/* Modernizr 2.8.3 (Custom Build) | MIT & BSD
 * Build: http://modernizr.com/download/#-fontface-backgroundsize-borderimage-borderradius-boxshadow-flexbox-hsla-multiplebgs-opacity-rgba-textshadow-cssanimations-csscolumns-generatedcontent-cssgradients-cssreflections-csstransforms-csstransforms3d-csstransitions-applicationcache-canvas-canvastext-draganddrop-hashchange-history-audio-video-indexeddb-input-inputtypes-localstorage-postmessage-sessionstorage-websockets-websqldatabase-webworkers-geolocation-inlinesvg-smil-svg-svgclippaths-touch-webgl-shiv-mq-cssclasses-addtest-prefixed-teststyles-testprop-testallprops-hasevent-prefixes-domprefixes-load
 */
;window.Modernizr=function(a,b,c){function D(a){j.cssText=a}function E(a,b){return D(n.join(a+";")+(b||""))}function F(a,b){return typeof a===b}function G(a,b){return!!~(""+a).indexOf(b)}function H(a,b){for(var d in a){var e=a[d];if(!G(e,"-")&&j[e]!==c)return b=="pfx"?e:!0}return!1}function I(a,b,d){for(var e in a){var f=b[a[e]];if(f!==c)return d===!1?a[e]:F(f,"function")?f.bind(d||b):f}return!1}function J(a,b,c){var d=a.charAt(0).toUpperCase()+a.slice(1),e=(a+" "+p.join(d+" ")+d).split(" ");return F(b,"string")||F(b,"undefined")?H(e,b):(e=(a+" "+q.join(d+" ")+d).split(" "),I(e,b,c))}function K(){e.input=function(c){for(var d=0,e=c.length;d<e;d++)u[c[d]]=c[d]in k;return u.list&&(u.list=!!b.createElement("datalist")&&!!a.HTMLDataListElement),u}("autocomplete autofocus list placeholder max min multiple pattern required step".split(" ")),e.inputtypes=function(a){for(var d=0,e,f,h,i=a.length;d<i;d++)k.setAttribute("type",f=a[d]),e=k.type!=="text",e&&(k.value=l,k.style.cssText="position:absolute;visibility:hidden;",/^range$/.test(f)&&k.style.WebkitAppearance!==c?(g.appendChild(k),h=b.defaultView,e=h.getComputedStyle&&h.getComputedStyle(k,null).WebkitAppearance!=="textfield"&&k.offsetHeight!==0,g.removeChild(k)):/^(search|tel)$/.test(f)||(/^(url|email)$/.test(f)?e=k.checkValidity&&k.checkValidity()===!1:e=k.value!=l)),t[a[d]]=!!e;return t}("search tel url email datetime date month week time datetime-local number range color".split(" "))}var d="2.8.3",e={},f=!0,g=b.documentElement,h="modernizr",i=b.createElement(h),j=i.style,k=b.createElement("input"),l=":)",m={}.toString,n=" -webkit- -moz- -o- -ms- ".split(" "),o="Webkit Moz O ms",p=o.split(" "),q=o.toLowerCase().split(" "),r={svg:"http://www.w3.org/2000/svg"},s={},t={},u={},v=[],w=v.slice,x,y=function(a,c,d,e){var f,i,j,k,l=b.createElement("div"),m=b.body,n=m||b.createElement("body");if(parseInt(d,10))while(d--)j=b.createElement("div"),j.id=e?e[d]:h+(d+1),l.appendChild(j);return f=["&#173;",'<style id="s',h,'">',a,"</style>"].join(""),l.id=h,(m?l:n).innerHTML+=f,n.appendChild(l),m||(n.style.background="",n.style.overflow="hidden",k=g.style.overflow,g.style.overflow="hidden",g.appendChild(n)),i=c(l,a),m?l.parentNode.removeChild(l):(n.parentNode.removeChild(n),g.style.overflow=k),!!i},z=function(b){var c=a.matchMedia||a.msMatchMedia;if(c)return c(b)&&c(b).matches||!1;var d;return y("@media "+b+" { #"+h+" { position: absolute; } }",function(b){d=(a.getComputedStyle?getComputedStyle(b,null):b.currentStyle)["position"]=="absolute"}),d},A=function(){function d(d,e){e=e||b.createElement(a[d]||"div"),d="on"+d;var f=d in e;return f||(e.setAttribute||(e=b.createElement("div")),e.setAttribute&&e.removeAttribute&&(e.setAttribute(d,""),f=F(e[d],"function"),F(e[d],"undefined")||(e[d]=c),e.removeAttribute(d))),e=null,f}var a={select:"input",change:"input",submit:"form",reset:"form",error:"img",load:"img",abort:"img"};return d}(),B={}.hasOwnProperty,C;!F(B,"undefined")&&!F(B.call,"undefined")?C=function(a,b){return B.call(a,b)}:C=function(a,b){return b in a&&F(a.constructor.prototype[b],"undefined")},Function.prototype.bind||(Function.prototype.bind=function(b){var c=this;if(typeof c!="function")throw new TypeError;var d=w.call(arguments,1),e=function(){if(this instanceof e){var a=function(){};a.prototype=c.prototype;var f=new a,g=c.apply(f,d.concat(w.call(arguments)));return Object(g)===g?g:f}return c.apply(b,d.concat(w.call(arguments)))};return e}),s.flexbox=function(){return J("flexWrap")},s.canvas=function(){var a=b.createElement("canvas");return!!a.getContext&&!!a.getContext("2d")},s.canvastext=function(){return!!e.canvas&&!!F(b.createElement("canvas").getContext("2d").fillText,"function")},s.webgl=function(){return!!a.WebGLRenderingContext},s.touch=function(){var c;return"ontouchstart"in a||a.DocumentTouch&&b instanceof DocumentTouch?c=!0:y(["@media (",n.join("touch-enabled),("),h,")","{#modernizr{top:9px;position:absolute}}"].join(""),function(a){c=a.offsetTop===9}),c},s.geolocation=function(){return"geolocation"in navigator},s.postmessage=function(){return!!a.postMessage},s.websqldatabase=function(){return!!a.openDatabase},s.indexedDB=function(){return!!J("indexedDB",a)},s.hashchange=function(){return A("hashchange",a)&&(b.documentMode===c||b.documentMode>7)},s.history=function(){return!!a.history&&!!history.pushState},s.draganddrop=function(){var a=b.createElement("div");return"draggable"in a||"ondragstart"in a&&"ondrop"in a},s.websockets=function(){return"WebSocket"in a||"MozWebSocket"in a},s.rgba=function(){return D("background-color:rgba(150,255,150,.5)"),G(j.backgroundColor,"rgba")},s.hsla=function(){return D("background-color:hsla(120,40%,100%,.5)"),G(j.backgroundColor,"rgba")||G(j.backgroundColor,"hsla")},s.multiplebgs=function(){return D("background:url(https://),url(https://),red url(https://)"),/(url\s*\(.*?){3}/.test(j.background)},s.backgroundsize=function(){return J("backgroundSize")},s.borderimage=function(){return J("borderImage")},s.borderradius=function(){return J("borderRadius")},s.boxshadow=function(){return J("boxShadow")},s.textshadow=function(){return b.createElement("div").style.textShadow===""},s.opacity=function(){return E("opacity:.55"),/^0.55$/.test(j.opacity)},s.cssanimations=function(){return J("animationName")},s.csscolumns=function(){return J("columnCount")},s.cssgradients=function(){var a="background-image:",b="gradient(linear,left top,right bottom,from(#9f9),to(white));",c="linear-gradient(left top,#9f9, white);";return D((a+"-webkit- ".split(" ").join(b+a)+n.join(c+a)).slice(0,-a.length)),G(j.backgroundImage,"gradient")},s.cssreflections=function(){return J("boxReflect")},s.csstransforms=function(){return!!J("transform")},s.csstransforms3d=function(){var a=!!J("perspective");return a&&"webkitPerspective"in g.style&&y("@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}",function(b,c){a=b.offsetLeft===9&&b.offsetHeight===3}),a},s.csstransitions=function(){return J("transition")},s.fontface=function(){var a;return y('@font-face {font-family:"font";src:url("https://")}',function(c,d){var e=b.getElementById("smodernizr"),f=e.sheet||e.styleSheet,g=f?f.cssRules&&f.cssRules[0]?f.cssRules[0].cssText:f.cssText||"":"";a=/src/i.test(g)&&g.indexOf(d.split(" ")[0])===0}),a},s.generatedcontent=function(){var a;return y(["#",h,"{font:0/0 a}#",h,':after{content:"',l,'";visibility:hidden;font:3px/1 a}'].join(""),function(b){a=b.offsetHeight>=3}),a},s.video=function(){var a=b.createElement("video"),c=!1;try{if(c=!!a.canPlayType)c=new Boolean(c),c.ogg=a.canPlayType('video/ogg; codecs="theora"').replace(/^no$/,""),c.h264=a.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/,""),c.webm=a.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/,"")}catch(d){}return c},s.audio=function(){var a=b.createElement("audio"),c=!1;try{if(c=!!a.canPlayType)c=new Boolean(c),c.ogg=a.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/,""),c.mp3=a.canPlayType("audio/mpeg;").replace(/^no$/,""),c.wav=a.canPlayType('audio/wav; codecs="1"').replace(/^no$/,""),c.m4a=(a.canPlayType("audio/x-m4a;")||a.canPlayType("audio/aac;")).replace(/^no$/,"")}catch(d){}return c},s.localstorage=function(){try{return localStorage.setItem(h,h),localStorage.removeItem(h),!0}catch(a){return!1}},s.sessionstorage=function(){try{return sessionStorage.setItem(h,h),sessionStorage.removeItem(h),!0}catch(a){return!1}},s.webworkers=function(){return!!a.Worker},s.applicationcache=function(){return!!a.applicationCache},s.svg=function(){return!!b.createElementNS&&!!b.createElementNS(r.svg,"svg").createSVGRect},s.inlinesvg=function(){var a=b.createElement("div");return a.innerHTML="<svg/>",(a.firstChild&&a.firstChild.namespaceURI)==r.svg},s.smil=function(){return!!b.createElementNS&&/SVGAnimate/.test(m.call(b.createElementNS(r.svg,"animate")))},s.svgclippaths=function(){return!!b.createElementNS&&/SVGClipPath/.test(m.call(b.createElementNS(r.svg,"clipPath")))};for(var L in s)C(s,L)&&(x=L.toLowerCase(),e[x]=s[L](),v.push((e[x]?"":"no-")+x));return e.input||K(),e.addTest=function(a,b){if(typeof a=="object")for(var d in a)C(a,d)&&e.addTest(d,a[d]);else{a=a.toLowerCase();if(e[a]!==c)return e;b=typeof b=="function"?b():b,typeof f!="undefined"&&f&&(g.className+=" "+(b?"":"no-")+a),e[a]=b}return e},D(""),i=k=null,function(a,b){function l(a,b){var c=a.createElement("p"),d=a.getElementsByTagName("head")[0]||a.documentElement;return c.innerHTML="x<style>"+b+"</style>",d.insertBefore(c.lastChild,d.firstChild)}function m(){var a=s.elements;return typeof a=="string"?a.split(" "):a}function n(a){var b=j[a[h]];return b||(b={},i++,a[h]=i,j[i]=b),b}function o(a,c,d){c||(c=b);if(k)return c.createElement(a);d||(d=n(c));var g;return d.cache[a]?g=d.cache[a].cloneNode():f.test(a)?g=(d.cache[a]=d.createElem(a)).cloneNode():g=d.createElem(a),g.canHaveChildren&&!e.test(a)&&!g.tagUrn?d.frag.appendChild(g):g}function p(a,c){a||(a=b);if(k)return a.createDocumentFragment();c=c||n(a);var d=c.frag.cloneNode(),e=0,f=m(),g=f.length;for(;e<g;e++)d.createElement(f[e]);return d}function q(a,b){b.cache||(b.cache={},b.createElem=a.createElement,b.createFrag=a.createDocumentFragment,b.frag=b.createFrag()),a.createElement=function(c){return s.shivMethods?o(c,a,b):b.createElem(c)},a.createDocumentFragment=Function("h,f","return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&("+m().join().replace(/[\w\-]+/g,function(a){return b.createElem(a),b.frag.createElement(a),'c("'+a+'")'})+");return n}")(s,b.frag)}function r(a){a||(a=b);var c=n(a);return s.shivCSS&&!g&&!c.hasCSS&&(c.hasCSS=!!l(a,"article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}mark{background:#FF0;color:#000}template{display:none}")),k||q(a,c),a}var c="3.7.0",d=a.html5||{},e=/^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i,f=/^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i,g,h="_html5shiv",i=0,j={},k;(function(){try{var a=b.createElement("a");a.innerHTML="<xyz></xyz>",g="hidden"in a,k=a.childNodes.length==1||function(){b.createElement("a");var a=b.createDocumentFragment();return typeof a.cloneNode=="undefined"||typeof a.createDocumentFragment=="undefined"||typeof a.createElement=="undefined"}()}catch(c){g=!0,k=!0}})();var s={elements:d.elements||"abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output progress section summary template time video",version:c,shivCSS:d.shivCSS!==!1,supportsUnknownElements:k,shivMethods:d.shivMethods!==!1,type:"default",shivDocument:r,createElement:o,createDocumentFragment:p};a.html5=s,r(b)}(this,b),e._version=d,e._prefixes=n,e._domPrefixes=q,e._cssomPrefixes=p,e.mq=z,e.hasEvent=A,e.testProp=function(a){return H([a])},e.testAllProps=J,e.testStyles=y,e.prefixed=function(a,b,c){return b?J(a,b,c):J(a,"pfx")},g.className=g.className.replace(/(^|\s)no-js(\s|$)/,"$1$2")+(f?" js "+v.join(" "):""),e}(this,this.document),function(a,b,c){function d(a){return"[object Function]"==o.call(a)}function e(a){return"string"==typeof a}function f(){}function g(a){return!a||"loaded"==a||"complete"==a||"uninitialized"==a}function h(){var a=p.shift();q=1,a?a.t?m(function(){("c"==a.t?B.injectCss:B.injectJs)(a.s,0,a.a,a.x,a.e,1)},0):(a(),h()):q=0}function i(a,c,d,e,f,i,j){function k(b){if(!o&&g(l.readyState)&&(u.r=o=1,!q&&h(),l.onload=l.onreadystatechange=null,b)){"img"!=a&&m(function(){t.removeChild(l)},50);for(var d in y[c])y[c].hasOwnProperty(d)&&y[c][d].onload()}}var j=j||B.errorTimeout,l=b.createElement(a),o=0,r=0,u={t:d,s:c,e:f,a:i,x:j};1===y[c]&&(r=1,y[c]=[]),"object"==a?l.data=c:(l.src=c,l.type=a),l.width=l.height="0",l.onerror=l.onload=l.onreadystatechange=function(){k.call(this,r)},p.splice(e,0,u),"img"!=a&&(r||2===y[c]?(t.insertBefore(l,s?null:n),m(k,j)):y[c].push(l))}function j(a,b,c,d,f){return q=0,b=b||"j",e(a)?i("c"==b?v:u,a,b,this.i++,c,d,f):(p.splice(this.i++,0,a),1==p.length&&h()),this}function k(){var a=B;return a.loader={load:j,i:0},a}var l=b.documentElement,m=a.setTimeout,n=b.getElementsByTagName("script")[0],o={}.toString,p=[],q=0,r="MozAppearance"in l.style,s=r&&!!b.createRange().compareNode,t=s?l:n.parentNode,l=a.opera&&"[object Opera]"==o.call(a.opera),l=!!b.attachEvent&&!l,u=r?"object":l?"script":"img",v=l?"script":u,w=Array.isArray||function(a){return"[object Array]"==o.call(a)},x=[],y={},z={timeout:function(a,b){return b.length&&(a.timeout=b[0]),a}},A,B;B=function(a){function b(a){var a=a.split("!"),b=x.length,c=a.pop(),d=a.length,c={url:c,origUrl:c,prefixes:a},e,f,g;for(f=0;f<d;f++)g=a[f].split("="),(e=z[g.shift()])&&(c=e(c,g));for(f=0;f<b;f++)c=x[f](c);return c}function g(a,e,f,g,h){var i=b(a),j=i.autoCallback;i.url.split(".").pop().split("?").shift(),i.bypass||(e&&(e=d(e)?e:e[a]||e[g]||e[a.split("/").pop().split("?")[0]]),i.instead?i.instead(a,e,f,g,h):(y[i.url]?i.noexec=!0:y[i.url]=1,f.load(i.url,i.forceCSS||!i.forceJS&&"css"==i.url.split(".").pop().split("?").shift()?"c":c,i.noexec,i.attrs,i.timeout),(d(e)||d(j))&&f.load(function(){k(),e&&e(i.origUrl,h,g),j&&j(i.origUrl,h,g),y[i.url]=2})))}function h(a,b){function c(a,c){if(a){if(e(a))c||(j=function(){var a=[].slice.call(arguments);k.apply(this,a),l()}),g(a,j,b,0,h);else if(Object(a)===a)for(n in m=function(){var b=0,c;for(c in a)a.hasOwnProperty(c)&&b++;return b}(),a)a.hasOwnProperty(n)&&(!c&&!--m&&(d(j)?j=function(){var a=[].slice.call(arguments);k.apply(this,a),l()}:j[n]=function(a){return function(){var b=[].slice.call(arguments);a&&a.apply(this,b),l()}}(k[n])),g(a[n],j,b,n,h))}else!c&&l()}var h=!!a.test,i=a.load||a.both,j=a.callback||f,k=j,l=a.complete||f,m,n;c(h?a.yep:a.nope,!!i),i&&c(i)}var i,j,l=this.yepnope.loader;if(e(a))g(a,0,l,0);else if(w(a))for(i=0;i<a.length;i++)j=a[i],e(j)?g(j,0,l,0):w(j)?B(j):Object(j)===j&&h(j,l);else Object(a)===a&&h(a,l)},B.addPrefix=function(a,b){z[a]=b},B.addFilter=function(a){x.push(a)},B.errorTimeout=1e4,null==b.readyState&&b.addEventListener&&(b.readyState="loading",b.addEventListener("DOMContentLoaded",A=function(){b.removeEventListener("DOMContentLoaded",A,0),b.readyState="complete"},0)),a.yepnope=k(),a.yepnope.executeStack=h,a.yepnope.injectJs=function(a,c,d,e,i,j){var k=b.createElement("script"),l,o,e=e||B.errorTimeout;k.src=a;for(o in d)k.setAttribute(o,d[o]);c=j?h:c||f,k.onreadystatechange=k.onload=function(){!l&&g(k.readyState)&&(l=1,c(),k.onload=k.onreadystatechange=null)},m(function(){l||(l=1,c(1))},e),i?k.onload():n.parentNode.insertBefore(k,n)},a.yepnope.injectCss=function(a,c,d,e,g,i){var e=b.createElement("link"),j,c=i?h:c||f;e.href=a,e.rel="stylesheet",e.type="text/css";for(j in d)e.setAttribute(j,d[j]);g||(n.parentNode.insertBefore(e,n),m(c,0))}}(this,document),Modernizr.load=function(){yepnope.apply(window,[].slice.call(arguments,0))};

'use strict';
angular
  .module('myApp.winVoters', ['ngRoute'])

  .config([
    '$routeProvider',
    function($routeProvider) {
      $routeProvider.when('/winVoters', {
        templateUrl: 'app/winVoters/winVoters.html',
        controller: 'winVotersCtrl',
      });
    },
  ])
  .controller('winVotersCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    'MyService',
    '$rootScope',
    'ngDialog',
    function($scope, $http, $location, apiCall, MyService, $rootScope, ngDialog) {
      //MyService.ConsoleLog("** questionHomeCtrl **");
      $rootScope.welcome = false;
      $scope.showLocalMatch = true;
      //use $rootScope.categories
      $scope.matchQuestion = function() {
        $location.path('/ballotMatch');
      };

      $scope.getLocalPoliticians = function() {
        $scope.statusGetLocalPoliticians = 1;
        $scope.page += 1;
        var extradata = '';
        if ($rootScope.FinalData && $rootScope.FinalData != '') {
          extradata = $rootScope.FinalData;
          //alert("extra");
          if ($scope.MyDialog != '') {
            $scope.MyDialog.close();
          } else {
            $scope.showLocalMatch = false;
          }
        }
        MyService.getLocalIncumbentPoliForVoter({
          max_records: 100,
          page: $scope.page,
          extradata: extradata,
        }).then(
          function(response) {
            if (response.data.success) {
              MyService.ConsoleLog('length : ' + response.data.data.length);
              if (response.data.data.length <= 0) {
                // $scope.showLocalMatch = false;
              } else {
                $scope.showLocalMatch = true;
              }
              $scope.statusGetLocalPoliticians = 2;
            } else {
              $scope.page -= 1;
              $scope.statusGetLocalPoliticians = 3;
              if (typeof response.data.error == 'string') growl.error(response.data.error);
              else growl.error('Something went wrong');
            }
          },
          function(err) {
            $scope.page -= 1;
            $scope.statusGetLocalPoliticians = 3;
            growl.error('Something went wrong');
          }
        );
      };

      $scope.allState = [];
      $scope.MyDialog = '';
      $scope.displayContent = '';

      $scope.oldaddress = {
        state: '',
        county: '',
        countySubdivision: '',
        place: '',
      };

      $scope.address = {
        state: '',
        county: '',
        countySubdivision: '',
        place: '',
      };
      // $scope.getLocalPoliticians();
    },
  ]);

'use strict';
angular.module('myApp.whatAmILookingAt4', ['ngRoute'])

  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/whatAmILookingAt4', {
      templateUrl: 'app/whatAmILookingAt4/whatAmILookingAt4.html',
      controller: 'whatAmILookingAt4Ctrl'
    });
  }])
  .controller('whatAmILookingAt4Ctrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService) {

  }]);

'use strict';
angular.module('myApp.whatAmILookingAt3', ['ngRoute'])

  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/whatAmILookingAt3', {
      templateUrl: 'app/whatAmILookingAt3/whatAmILookingAt3.html',
      controller: 'whatAmILookingAt3Ctrl'
    });
  }])
  .controller('whatAmILookingAt3Ctrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService) {

  }]);

'use strict';
angular.module('myApp.whatAmILookingAt2', ['ngRoute'])

  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/whatAmILookingAt2', {
      templateUrl: 'app/whatAmILookingAt2/whatAmILookingAt2.html',
      controller: 'whatAmILookingAt2Ctrl'
    });
  }])
  .controller('whatAmILookingAt2Ctrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService) {

  }]);

'use strict';
angular.module('myApp.whatAmILookingAt1', ['ngRoute'])

  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/whatAmILookingAt1', {
      templateUrl: 'app/whatAmILookingAt1/whatAmILookingAt1.html',
      controller: 'whatAmILookingAt1Ctrl'
    });
  }])
  .controller('whatAmILookingAt1Ctrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService) {

  }]);

'use strict';

angular.module('myApp.welcomeView', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/welcome', {
        templateUrl: 'app/welcomeView/welcomeView.html',
        controller: 'welcomeCtrl'
    });
}])

.controller('welcomeCtrl', ['$scope', 'apiCall', '$location', '$anchorScroll', '$timeout', '$rootScope', function($scope, apiCall, $location, $anchorScroll, $timeout, $rootScope) {
    // var returningUser = apiCall.getToken();
    //
    // if (returningUser) {
    //   $location.path('/debateHome');
    // }
    //$scope.showFacebookLoging = false;
    $rootScope.welcome = true;
    //console.log("outside :", $rootScope.showFacebookLoging);
    $scope.ogTitle = "VoteWise.net - In life, you can vote with wallet, with your voice, with your actions and at the ballot box. But it's important to always vote wisely.";
  $scope.ogDescription = "VoteWise.net is a non-partisan non-profit tool aimed at repairing democracy by connecting voters, politicians and organizations without advertising dollars getting in the way.  There are different tools available to different types of users, so click on a user type below, watch the 2 minute video and start saving the world.";
  $scope.ogImage = "https://votewise.net/assets/images/VoteWiseMeta.jpg";

    $scope.ShowFB = function() {
    	//if()
    	//console.log("inside :", $rootScope.showFacebookLoging);
        $rootScope.showFacebookLoging = !$rootScope.showFacebookLoging;
        $location.hash('bottom');
            $anchorScroll();
        //$location.hash('signupform');
        //$anchorScroll();
        //if($scope.showFacebookLoging) {
        // $timeout(function() {
            
        //console.log("inside after scroll :", $rootScope.showFacebookLoging);
        // }, 1500);

        //}
    }

}]);

'use strict';
angular.module('myApp.votingRecords', ['ngRoute'])

  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/votingRecords/:id/:userid/:type?', {
      templateUrl: 'app/votingRecords/votingRecords.html',
      controller: 'votingRecordsCtrl'
    });
  }])
  .controller('votingRecordsCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService) {
      
    $scope.memberId = $routeParams.id;
    MyService.ConsoleLog("memberId : " + $scope.memberId);
    $scope.selectedIndex;
      
      
      
    $scope.getVotingRecords = function() {
      var data = {};
      data.id = $scope.memberId;
      $scope.votingRecords = [];
      MyService.getVotingRecords(data).then(function(data) {
        MyService.ConsoleLog("getVotingRecords success : ", data);
        //$scope.memberName = data.data.data.results[0].name;
        $scope.votingRecords = data.data.data.results[0];
      }, function(err) {
        MyService.ConsoleLog("getVotingRecords error : ", err);
      });
    }


    if ($routeParams.id != "") {
      $scope.getVotingRecords();
    }
  }]);

"use strict";
angular
  .module("myApp.votesmart", ["ngRoute"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/votesmart", {
        templateUrl: "app/voteSmart/votesmart.html",
        controller: "votesmartCtrl"
      });
    }
  ])
  .controller("votesmartCtrl", ["$scope", "$http", "$location", "apiCall", "$rootScope", "baseApiUrl", "$q", "$filter", "growl", "ngDialog", "tokenService", "MyService", function ($scope, $http, $location, apiCall, $rootScope, baseApiUrl, $q, $filter, growl, ngDialog, tokenService, MyService) {

    $scope.candidates = false;
    $rootScope.local = false;
    $rootScope.cityData = false;
    $rootScope.courage = false;
    $rootScope.incumbent = false;
    $rootScope.CityCouncil = false;
    $rootScope.withoutState = false;
    $rootScope.catList = false;
    $rootScope.orgvList = false;
    $scope.showLoader = false;
    $scope.allState = [];
    $scope.address = {
      state: "",
      upstate: "",
      files: ""
    };

    $scope.getAllStates = function () {
      $scope.allState.length = 0;
      $scope.loader = true;
      // console.log("address.state", $scope.address.state);
      MyService.getAllStates().then(
        function (payload) {
          console.log("payload : ", payload);
          $scope.allState = payload;
          var addNwState = payload;
          var smpl = {
            state: "NA",
            statePostalCode: "NA"
          };
          addNwState.unshift(smpl);
          $scope.loader = false;
        },
        function (errorPayload) {
          growl.error("Something went wrong.");
          $scope.loader = false;
        }
      );

    };

    // console.log($scope.selectState);
    $scope.getElections = function () {
      $scope.loader = true;
      // console.log("address.state", $scope.address.state.statePostalCode);
      // var d = new Date();
      // $scope.today = d.toISOString();
      // console.log("dates", $scope.today);
      // $scope.today = '2018-06-05 00:00:00.000Z';
      // console.log("dates", $scope.today);

      MyService.getElectionData({
        stateCode: $scope.address.state.statePostalCode,
        state: $scope.address.state.state
      }).then(function (response) {
        $scope.ElectionData = response;
        $scope.loader = false;

        MyService.ConsoleLog("results:", $scope.ElectionData);
      }, function (err) {
        $scope.loader = false;
        growl.error(err.error);
      });
    };
    var d = new Date();
    $scope.today = d.toISOString().split('T')[0];
    $scope.getItems = function () {


      return function (u) {
        var len = u.stage.length;
        // MyService.ConsoleLog("params", today);
        // MyService.ConsoleLog("params length", len);

        for (var i = 0; i < len; i++) {
          MyService.ConsoleLog("params counter", u.stage[i].electionDate);


          if (u.stage[i].electionDate >= $scope.today) {
            var date = new Date(u.stage[i].electionDate);
            var fomr = date.toISOString().split('T')[0];
            u.stage[i].electionDate = fomr;
            return u;
          }


        }

      }
    };
    $scope.getAllStates();

    $scope.back = function () {
      $scope.candidates = false;


    };

    $scope.getCandidates = function (eid) {
      $scope.candidates = true;

      // console.log($scope.address.state.state);
      // console.log("welcome to get candidates :", eid);
      MyService.getVoteCandidates({
        e_id: eid
      }).then(function (result) {
        $scope.candidatesData = result;
        MyService.ConsoleLog("results :", $scope.candidatesData);
      });
    };

    /**
     * @description Function is use to insert records of presidential race.
     */
    $scope.getPrimaryElections = function () {
      MyService.ConsoleLog("this is president");
      $scope.showLoader = true;
      MyService.getPresidentData({
        stateCode: $scope.address.state.statePostalCode,
        state: $scope.address.state.state
      }).then(function (APIResponse) {

        MyService.ConsoleLog("APIReponse", APIResponse);
        $scope.ElectionData = APIResponse;
        $scope.showLoader = false;
      }, function (err) {
        $scope.showLoader = false;
        MyService.ConsoleLog("Error", err);
      });
    };
  }]).controller("votesmartLocalCtrl", ["$scope", "$http", "$location", "apiCall", "$rootScope", "baseApiUrl", "$q", "$filter", "growl", "ngDialog", "tokenService", "MyService", function ($scope, $http, $location, apiCall, $rootScope, baseApiUrl, $q, $filter, growl, ngDialog, tokenService, MyService) {
    $scope.candidates = false;
    $rootScope.election = false;
    $rootScope.cityData = false;
    $rootScope.courage = false;
    $rootScope.incumbent = false;
    $rootScope.CityCouncil = false;
    $rootScope.withoutState = false;
    $rootScope.catList = false;
    $rootScope.orgvList = false;


    $scope.allState = [];
    $scope.address = {
      state: "",
      upstate: "",
      files: ""
    };
    $scope.getAllStatesData = function () {
      $scope.allState.length = 0;
      $scope.loader = true;
      // console.log("address.state", $scope.address.state);
      MyService.getAllStates().then(
        function (payload) {
          // console.log("payload : ", payload);
          $scope.allState = payload;
          $scope.loader = false;
        },
        function (errorPayload) {
          growl.error("Something went wrong.");
          $scope.loader = false;
        }
      );
    };
    // console.log($scope.selectState);

    $scope.getLocalData = function () {
      $scope.loader = true;

      // MyService.getLocalOffices({"state":state})

      // console.log("call");
      // console.log("address.state", $scope.address.state.statePostalCode);

      MyService.getLocalOffices({
        "stateCode": $scope.address.state.statePostalCode,
        state: $scope.address.state.state
      }).then(function (success) {
        $scope.CountyData = success;
        console.log("success :", $scope.CountyData);

        $scope.loader = false;

      }, function (err) {
        console.log("called errr :", err);
        growl.error("No officials found in this locality.");
        $scope.loader = false;
      });

    };

    // $scope.getItems = function () {

    //   var d = new Date();
    //   var today = d.toISOString();
    //   return function (u) {
    //     var len = u.stage.length;
    //     // MyService.ConsoleLog("params", len);
    //     // MyService.ConsoleLog("params", u);

    //     for (var i = 0; i < len; i++) {
    //       // console.log("data", u.stage[i].electionDate);

    //       return u.stage[i].electionDate >= today;

    //     }

    //   }
    // };

    $scope.getAllStatesData();

    //   $scope.back = function () {
    //     $scope.candidates = false;


    //   };

    //   $scope.getCandidates = function (eid) {
    //     $scope.candidates = true;

    //     // console.log($scope.address.state.state);
    //     // console.log("welcome to get candidates :", eid);
    //     MyService.getVoteCandidates({
    //       e_id: eid
    //     }).then(function (result) {
    //       $scope.candidatesData = result;
    //       MyService.ConsoleLog("results :", $scope.candidatesData);
    //     });
    //   };
  }]).controller("LocalCityCtrl", ["$scope", "$http", "$location", "apiCall", "$rootScope", "baseApiUrl", "$q", "$filter", "growl", "ngDialog", "tokenService", "MyService", function ($scope, $http, $location, apiCall, $rootScope, baseApiUrl, $q, $filter, growl, ngDialog, tokenService, MyService) {

    // $scope.candidates = false;
    $rootScope.election = false;
    $rootScope.local = false;
    $rootScope.courage = false;
    $rootScope.incumbent = false;
    $rootScope.CityCouncil = false;
    $rootScope.withoutState = false;
    $rootScope.catList = false;
    $rootScope.orgvList = false;
    $scope.allState = [];
    $scope.address = {
      state: "",
      upstate: "",
      files: ""
    };
    $scope.getAllStatesData = function () {
      $scope.allState.length = 0;
      $scope.loader = true;
      // console.log("address.state", $scope.address.state);
      MyService.getAllStates().then(
        function (payload) {
          // console.log("payload : ", payload);
          $scope.allState = payload;
          $scope.loader = false;
        },
        function (errorPayload) {
          growl.error("Something went wrong.");
          $scope.loader = false;
        }
      );
    };
    // console.log($scope.selectState);

    $scope.getLocalCity = function () {
      $scope.loader = true;

      // MyService.getLocalOffices({"state":state})

      // console.log("call");
      // console.log("address.state", $scope.address.state.statePostalCode);

      MyService.getLocalOfficesForCity({
        "stateCode": $scope.address.state.statePostalCode,
        state: $scope.address.state.state
      }).then(function (success) {
        // MyService.ConsoleLog("success :", success);
        $scope.City = success;
        $scope.loader = false;

      }, function (err) {
        console.log("called errr :", err);
        growl.error("No officials found in this locality.");
        $scope.loader = false;
      });

    };

    // $scope.getItems = function () {

    //   var d = new Date();
    //   var today = d.toISOString();
    //   return function (u) {
    //     var len = u.stage.length;
    //     // MyService.ConsoleLog("params", len);
    //     // MyService.ConsoleLog("params", u);

    //     for (var i = 0; i < len; i++) {
    //       // console.log("data", u.stage[i].electionDate);

    //       return u.stage[i].electionDate >= today;

    //     }

    //   }
    // };

    $scope.getAllStatesData();

    //   $scope.back = function () {
    //     $scope.candidates = false;


    //   };

    //   $scope.getCandidates = function (eid) {
    //     $scope.candidates = true;

    //     // console.log($scope.address.state.state);
    //     // console.log("welcome to get candidates :", eid);
    //     MyService.getVoteCandidates({
    //       e_id: eid
    //     }).then(function (result) {
    //       $scope.candidatesData = result;
    //       MyService.ConsoleLog("results :", $scope.candidatesData);
    //     });
    //   };
  }]).controller("CourageTest", [
    "$scope",
    "$http",
    "$location",
    "apiCall",
    "$rootScope",
    "baseApiUrl",
    "$q",
    "$filter",
    "growl",
    "ngDialog",
    "tokenService",
    "MyService",
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $rootScope,
      baseApiUrl,
      $q,
      $filter,
      growl,
      ngDialog,
      tokenService,
      MyService
    ) {

      // $scope.candidates = false;
      $rootScope.election = false;
      $rootScope.local = false;
      $rootScope.cityData = false;
      $rootScope.CityCouncil = false;
      $rootScope.withoutState = false;
      $rootScope.catList = false;
      $rootScope.orgvList = false;
      $scope.Test = false;
      $scope.candy = false;
      $scope.Update = [];
      // $scope.allParentCats = [];
      $scope.catd = [];
      $scope.success_msg = false;
      $scope.success_msg1 = false;

      $scope.showtbl = [];
      $scope.present = false;



      // $scope.fiveMatch= {
      //   match:[]
      // };




      $scope.TstData = [];

      $scope.more = [];

      $scope.allState = [];
      $scope.address = {
        state: "",
        upstate: "",
        files: ""
      };

      $scope.fiveMatch = {
        "match": [],

      };

      $scope.cat = {
        "selected": []
      }

      // category listing

      $scope.getParentCategories = function () {
        $scope.statusGetCats = 1;
        var request = apiCall.apiCall('GET', '/categories/list', {
          root: 1,
          questions_counter: 0,
          catTypes: "Q"
        });
        $http(
          request
        ).then(function successCallback(response) {
          console.log("wwwwww :", response);
          $scope.parentCategories = response.data.data;

          if (response.data.success) {
            $scope.selCatForQues = [{
              "selected": null,
              viewOrders: 0,
              "items": $scope.parentCategories
            }];
            $scope.questions = [];
            $scope.statusGetCats = 2;
          } else {
            growl.error("Something went wrong");
            $scope.statusGetCats = 3;
          }
        }, function errorCallBack(response) {
          growl.error("Something went wrong");
          $scope.statusGetCats = 3;
        });
      }

      $scope.checkExistsInArr = function (rdata, val) {
        return rdata.filter(
          function (rdata) {
            //MyService.ConsoleLog(rdata.statePostalCode + "==" + val);
            if (rdata._id == val._id)
              return rdata
          }
        );
      }

      $scope.addToFiveMatch = function (pa, co, ftype, idx) {

        // $scope.$apply(function() {
        // $scope.TstData[idx].QueId.push(pa._id);
        // });



        // MyService.ConsoleLog("datatatatatatatata :",  $scope.fnArr);

        MyService.UpdateCourage({
          "qId": pa._id,
          "courageQId": co._id,
          "catId": $rootScope.catid,
          "ftype": ftype
        }).then(function (udata) {

          console.log(" updated :", udata);

          if (ftype !== "remove") {

            if (udata.data.data.QueId.length > 0) {
              // alert("Success");


              // $(document).ready(function() {
              // $scope.success_msg = true;
              setTimeout(function () {
                // $(".alert").alert('close');
                $scope.$apply(function () {
                  console.log("index > ", idx);
                  console.log("Qid > ", $scope.TstData[idx].QueId);
                  console.log("paid > ", pa._id);

                  $scope.TstData[idx].QueId.push(pa._id);
                  console.log("TST :::: ", $scope.TstData[idx]);
                  // $scope.exist($scope.TstData[idx].QueId, pa._id);
                })

              }, 300);

              // });

            } else {
              alert("Failed");
              // $scope.$apply();
              // $(document).ready(function() {
              // $scope.success_msg1 = true;
              // setTimeout(function() {
              // $(".alert").alert('close');


              // }, 3000);

              // });

            }
          } else {
            setTimeout(function () {
              // $(".alert").alert('close');
              $scope.$apply(function () {
                console.log("index > ", idx);
                console.log("Qid > ", $scope.TstData[idx].QueId);
                console.log("paid > ", pa._id);

                $scope.TstData[idx].QueId.pop(pa._id);
                console.log("TST :::: ", $scope.TstData[idx]);
                // $scope.exist($scope.TstData[idx].QueId, pa._id);
              })

            }, 300);
          }


          //
          // $scope.selCatForQues=[];

          // $scope.showtbl[co]=false;
          // $scope.getCourTest();
          // $scope.getParentCategories();


        });

      }

      var selQuesCategoryCanceler = $q.defer();
      var getQuestoinsCanceler = $q.defer();

      $scope.statusSubCat = 0;
      $scope.getParentCategories();

      $scope.selQuesCategory = function (pcat, index, uid) {

        // console.log("showtable : ", $scope.showtbl);

        var keysarray = Object.keys($scope.showtbl);
        console.log("keysarray > ", keysarray);

        for (var i = 0; i < keysarray.length; i++) {
          $scope.showtbl[keysarray[i]] = false;
          // pcat[keysarray[i]] = "";

        }



        // MyService.ConsoleLog("params :", uid._id);
        // MyService.ConsoleLog("params :", pcat);


        var catp = pcat[uid._id];
        var dat = JSON.parse(catp);

        // console.log("select cat :", dat);

        $rootScope.uid = uid._id;

        // console.log("select cat :", dat.title);


        MyService.getAllFiveMatch({
          "catId": dat._id
        }).then(function (fdata) {

          // console.log("fiveMatch que :", fdata);
          $scope.tbl = fdata.data.data;
          var ucid = uid._id;
          $scope.showtbl[ucid] = true;
        });


        $rootScope.catid = dat._id;
        // console.log("cat id :", $rootScope.catid);
        selQuesCategoryCanceler.resolve();
        var cat = JSON.parse(catp);
        //MyService.ConsoleLog("tempFun index: ", index);
        //remove all elements after given index


        getQuestoinsCanceler.resolve();
        selQuesCategoryCanceler = $q.defer();

        $scope.selCatForQues.length = index + 1;

        var params = {
          questions_counter: 0,
          parentId: cat._id,
          catTypes: "Q"
        };
        var request = apiCall.apiCall('GET', '/categories/list', params);
        request.timeout = selQuesCategoryCanceler.promise;
        $scope.statusSubCat = 1;
        $http(
            request
          )
          .then(function successCallback(response) {
            //MyService.ConsoleLog("************ in success callback ***************");
            if (response.data.success) {
              //MyService.ConsoleLog("Got subcategory data: ", response.data.data);
              if (response.data.data.length > 0)
                $scope.selCatForQues.push({
                  "selected": null,
                  viewOrders: 0,
                  "items": response.data.data
                });
              else if (response.data.data.length == 0) {
                // $scope.getQuestoins(cat._id);
              }
              $scope.statusSubCat = 2;
            } else {
              //MyService.ConsoleLog("Something went wrong: ", response.data);
              $scope.statusSubCat = 3;
            }
          }, function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
            $scope.statusSubCat = 3;
          });
      };

      $scope.exist = function (arr, start) {


        // MyService.ConsoleLog("exist :>>>> ",arr);
        // MyService.ConsoleLog("exist :>>>> ",arr.length);
        //   MyService.ConsoleLog("exist start :>>>> ",start);



        // $scope.fnArr=arr;
        // arr=$rootScope.fnArr;


        if (arr) {

          $scope.indx = arr.indexOf(start);
          // $scope.indx=uid.QueId.indexOf($scope.tbl._id);
          // console.log("index of ", $scope.indx);


          if ($scope.indx == '-1') {

            // console.log("######################### -1 ############################### ");


            return true;
          } else {
            return false;
          }

        } else {
          return true
        }

        // console.log("index of ", $scope.indx);

        // return $scope.indx

      }




      // $scope.getMatchData = function(par) {

      // $scope.getParentCategories();

      //     console.log("welcome to getMatchData  :", par.fiveMatchQue);

      //     // $scope.fiveMatch.match[par]=true;
      //     // MyService.ConsoleLog("select :", $scope.fiveMatch);

      //     // MyService.ConsoleLog("select :", $scope.fiveMatch.match[par._id]);

      //     $rootScope.upId = par._id;
      //     $rootScope.flag=$scope.fiveMatch.match[par._id];


      //     if ($scope.fiveMatch.match[par._id] == 'Yes') {

      //       $scope.Update[par._id] = true;
      //       $scope.catd[par._id] = true;

      //     } else {

      //       $scope.Update[par._id] = false;


      //     }

      //     if (par.fiveMatchQue == 'Yes') {
      //       console.log("welcome to first :", par._id);

      //       $scope.Update[par._id] = true;
      //       $scope.catd[par._id] = true;


      //     }




      //   };

      // $scope.updateFiveMatch = function(u) {

      //   MyService.ConsoleLog("welcome to save  ::",  $rootScope.catid );

      //   MyService.UpdateFiveMatchCou({ "id": u._id,"catId":$rootScope.catid,"flag":$rootScope.flag }).then(function(edata) {

      //     console.log("Updated successfully :", edata);
      //      $(document).ready(function () {
      //     $scope.success_msg = true;
      //     setTimeout(function () {
      //       $(".alert").alert('close');


      //     }, 3000);

      //   });


      //   });
      // }

      $scope.getStates = function () {
        $scope.allState.length = 0;
        $scope.loader = true;
        // console.log("address.state", $scope.address.state);
        MyService.getAllStates().then(
          function (payload) {
            // console.log("payload : ", payload);
            $scope.allState = payload;
            var smpl = {
              state: "NA",
              statePostalCode: "NA"
            };
            $scope.allState.unshift(smpl);
            $scope.loader = false;
          },
          function (errorPayload) {
            growl.error("Something went wrong.");
            $scope.loader = false;
          }
        );
      };
      // console.log($scope.selectState);

      $scope.getCourageData = function () {
        $scope.loader = true;
        $scope.success_msg = false;

        // MyService.getLocalOffices({"state":state})

        // console.log("call");
        // console.log("address.state", $scope.address.state.statePostalCode);
        $rootScope.statePostalCode = $scope.address.state.statePostalCode;

        MyService.getCourageTest({
          "stateCode": $scope.address.state.statePostalCode
        }).then(function (success) {
          $scope.courageResult = success;
          // console.log("  $scope.courageResult :",  $scope.courageResult);

          $scope.loader = false;

        });

      };



      $scope.getStates();

      // $scope.currPage = 1;
      //  // $scope.statusGetResPg = 0;


      // $scope.myPagingFunction = function() {
      //   // MyService.ConsoleLog("scoll called : ", $scope.statusGetResPg);
      //   if ($scope.statusGetResPg != 1) {
      //     $scope.currPage++;

      //   // MyService.ConsoleLog("scoll  : ",$scope.currPage);

      //      $scope.getCourTest($scope.currPage);
      //   }
      // };
      $scope.import = false;

      $scope.importCourage = function (data) {
        if (data.files != "") {
          ////MyService.ConsoleLog(data.files.type.indexOf("office"));
          // alert("This needs to be implemented");
          if (data.files.type.indexOf("office") > -1) {
            $scope.import = true;
            //MyService.ConsoleLog("data : ", data);
            var fd = new FormData();
            fd.append('file', data.files);
            fd.append('options', data.opt);
            var posturl = baseApiUrl + "/votequestions/importCourageData";
            $http.post(posturl, fd, {
              transformRequest: angular.identity,
              headers: {
                'Content-Type': undefined
              }
            }).then(function successCallback(response) {
              //console.log("Got countires: ", response);
              if (response.data.success) {
                $scope.import = false;
                alert("File successfully imported.");
              } else {
                //alert("Something went wrong: ", response.data);
                alert("Something went wrong.");
              }
            }, function errorCallBack(response) {
              console.log("Error: ", response);

            });
          } else {
            alert("Please select xlsx file");
          }

        } else {
          alert("Please select file");
        }

      }


      $scope.exportCourage = function () {

        MyService.ExportCourageData({
          "statePostalCode": $rootScope.statePostalCode
        }).then(function (payload) {
          MyService.ConsoleLog("Success Data", payload);

          window.open($scope.imgUrl + '/courageTest.xlsx', '_blank');
        }, function (errorPayload) {

          //MyService.ConsoleLog("errorPayload : ", errorPayload);
          alert("Something went wrong. Please try again after sometime");
        })

      };

      $scope.getCourTest = function () {
        MyService.getTestData({
          "statePostalCode": $rootScope.statePostalCode
        }).then(function (respo) {
          $scope.courage = false;
          $scope.Test = true;
          $scope.success_msg = false;

          // $scope.statusGetCats = 2;
          // console.log("respo :", respo);

          $scope.TstData = respo;
          // console.log("respo :", $scope.TstData);


        }, function (err) {
          //MyService.ConsoleLog(err);
          growl.error("Something went wrong.");

        });



      }

      $scope.getQuestion = function (category) {
        // console.log("Questions : ", category);
        $scope.more[category] = true;
      }

      $scope.showLess = function (category) {
        // console.log("id for less",id);
        $scope.more[category] = false;
        $scope.showtbl[category] = false;

      }

      $scope.backto = function () {
        $scope.Test = false;
        $scope.candy = false;
        $scope.Update[$rootScope.upId] = false;
        $scope.catd[$rootScope.upId] = false;
        $scope.showtbl[$rootScope.uid] = false;
        // $scope.statusGetCats = 1;
      };


      $scope.NotFound = false;


      $scope.getTst = function (u) {
        // console.log("params :",u.votesmartCandidateId);
        // MyService.ConsoleLog('params :', u);

        $scope.name = u.name;
        $scope.party = u.party;

        MyService.getCourageForCandidate({
          "c_id": u.votesmartCandidateId
        }).then(function (resultdata) {

          // console.log("data came :", resultdata);
          if (resultdata && resultdata.length > 0) {

            $scope.testy = resultdata;
            $scope.candy = true;
            // console.log("data came :", resultdata);
            $scope.NotFound = false;


          } else {
            $scope.testy = "";
            $scope.NotFound = true;
            $scope.candy = true;

            setTimeout(function () {

              $(".alert").alert('close');

            }, 3000);

          }




        });


      }



    }
  ]).controller("votesmartIncumbentCtrl", ["$scope", "$http", "$location", "apiCall", "$rootScope", "baseApiUrl", "$q", "$filter", "growl", "ngDialog", "tokenService", "MyService", function ($scope, $http, $location, apiCall, $rootScope, baseApiUrl, $q, $filter, growl, ngDialog, tokenService, MyService) {

    $scope.candidates = false;
    $rootScope.election = false;
    $rootScope.local = false;
    $rootScope.cityData = false;
    $rootScope.CityCouncil = false;
    $scope.Test = false;
    // $rootScope.incumbent = false;
    $rootScope.withoutState = false;
    $rootScope.catList = false;
    $rootScope.orgvList = false;
    $scope.allState = [];
    $scope.address = {
      state: "",
      upstate: "",
      files: ""
    };

    $scope.getAllStates = function () {
      $scope.allState.length = 0;
      $scope.loader = true;
      // console.log("address.state", $scope.address.state);
      MyService.getAllStates().then(
        function (payload) {
          // console.log("payload : ", payload);
          $scope.allState = payload;
          $scope.loader = false;
        },
        function (errorPayload) {
          growl.error("Something went wrong.");
          $scope.loader = false;
        }
      );
    };

    // console.log($scope.selectState);
    $scope.getIncumbent = function () {
      $scope.loader = true;
      // console.log("address.state", $scope.address.state.statePostalCode);
      // var d = new Date();
      // $scope.today = d.toISOString();
      // console.log("dates", $scope.today);
      // $scope.today = '2018-06-05 00:00:00.000Z';
      // console.log("dates", $scope.today);

      MyService.getIncumbentData({
        stateCode: $scope.address.state.statePostalCode,
        state: $scope.address.state.state
      }).then(function (response) {
        $scope.ElectionData = response;
        $scope.loader = false;
        // console.log("results:", $scope.ElectionData);
      });
    };
    var d = new Date();
    $scope.today = d.toISOString().split('T')[0];
    $scope.getItems = function () {


      return function (u) {
        var len = u.stage.length;
        // MyService.ConsoleLog("params", today);
        // MyService.ConsoleLog("params length", len);

        for (var i = 0; i < len; i++) {
          // MyService.ConsoleLog("params counter", i);


          if (u.stage[i].electionDate >= $scope.today) {

            return u.stage[i].electionDate >= $scope.today;
          }


        }

      }
    };
    $scope.getAllStates();


    $scope.back = function () {
      $scope.candidates = false;


    };

    $scope.getCandidates = function (eid) {
      $scope.candidates = true;

      // console.log($scope.address.state.state);
      // console.log("welcome to get candidates :", eid);
      MyService.getVoteCandidates({
        e_id: eid
      }).then(function (result) {
        $scope.candidatesData = result;
        MyService.ConsoleLog("results :", $scope.candidatesData);
      });
    };
  }]).controller("votesmartCityCouncil", ["$scope", "$http", "$location", "apiCall", "$rootScope", "baseApiUrl", "$q", "$filter", "growl", "ngDialog", "tokenService", "MyService", function ($scope, $http, $location, apiCall, $rootScope, baseApiUrl, $q, $filter, growl, ngDialog, tokenService, MyService) {

    $scope.candidates = false;
    $rootScope.election = false;
    $rootScope.local = false;
    $rootScope.cityData = false;
    // $rootScope.CityCouncil = false;
    $scope.Test = false;
    $rootScope.withoutState = false;
    $rootScope.incumbent = false;
    $rootScope.catList = false;
    $rootScope.orgvList = false;
    $scope.allState = [];
    $scope.address = {
      state: "",
      upstate: "",
      files: ""
    };

    $scope.getAllStates = function () {
      $scope.allState.length = 0;
      $scope.loader = true;
      // console.log("address.state", $scope.address.state);
      MyService.getAllStates().then(
        function (payload) {
          // console.log("payload : ", payload);
          $scope.allState = payload;
          $scope.loader = false;
        },
        function (errorPayload) {
          growl.error("Something went wrong.");
          $scope.loader = false;
        }
      );
    };

    // console.log($scope.selectState);
    $scope.getCityCouncil = function () {
      $scope.loader = true;
      // console.log("address.state", $scope.address.state.statePostalCode);
      // var d = new Date();
      // $scope.today = d.toISOString();
      // console.log("dates", $scope.today);
      // $scope.today = '2018-06-05 00:00:00.000Z';
      // console.log("dates", $scope.today);

      MyService.getCityCouncil({
        stateCode: $scope.address.state.statePostalCode,
        state: $scope.address.state.state
      }).then(function (response) {
        MyService.ConsoleLog("response", response);
        $scope.citysd = response;
        $scope.candidates = true;
        $scope.loader = false;
        // console.log("results:", $scope.ElectionData);
      });
    };
    var d = new Date();
    $scope.today = d.toISOString().split('T')[0];
    $scope.getItems = function () {


      return function (u) {
        var len = u.stage.length;
        // MyService.ConsoleLog("params", today);
        // MyService.ConsoleLog("params length", len);

        for (var i = 0; i < len; i++) {
          // MyService.ConsoleLog("params counter", i);


          if (u.stage[i].electionDate >= $scope.today) {

            return u.stage[i].electionDate >= $scope.today;
          }


        }

      }
    };
    $scope.getAllStates();


    $scope.back = function () {
      $scope.candidates = false;


    };

    $scope.getCandidates = function (eid) {
      $scope.candidates = true;

      // console.log($scope.address.state.state);
      // console.log("welcome to get candidates :", eid);
      MyService.getVoteCandidates({
        e_id: eid
      }).then(function (result) {
        $scope.candidatesData = result;
        MyService.ConsoleLog("results :", $scope.candidatesData);
      });
    };
  }]).controller("votesmartWithoutState", ["$scope", "$http", "$location", "apiCall", "$rootScope", "baseApiUrl", "$q", "$filter", "growl", "ngDialog", "tokenService", "MyService", function ($scope, $http, $location, apiCall, $rootScope, baseApiUrl, $q, $filter, growl, ngDialog, tokenService, MyService) {

    $scope.candidates = false;
    $rootScope.election = false;
    $rootScope.local = false;
    $rootScope.cityData = false;
    $rootScope.catList = false;
    $rootScope.orgvList = false;
    // $rootScope.CityCouncil = false;
    $scope.Test = false;
    // $rootScope.withoutState = false;
    $rootScope.incumbent = false;

    // console.log($scope.selectState);
    $scope.getWithoutState = function () {
      $scope.loader = true;
      // alert('called');
      // console.log("address.state", $scope.address.state.statePostalCode);
      // var d = new Date();
      // $scope.today = d.toISOString();
      // console.log("dates", $scope.today);
      // $scope.today = '2018-06-05 00:00:00.000Z';
      // console.log("dates", $scope.today);

      MyService.getWithoutState().then(function (response) {
        MyService.ConsoleLog("response", response);
        $scope.without = response.data.data;
        MyService.ConsoleLog("$scope.without ", $scope.without);
        $scope.candidates = true;
        $scope.loader = false;
        // console.log("results:", $scope.ElectionData);
      });
    };
    // $scope.getWithoutState();

    $scope.back = function () {
      $scope.candidates = false;
    };
  }]).controller("orgCatCtrl", ["$scope", "$http", "$location", "apiCall", "$rootScope", "baseApiUrl", "$q", "$filter", "growl", "ngDialog", "tokenService", "MyService", function ($scope, $http, $location, apiCall, $rootScope, baseApiUrl, $q, $filter, growl, ngDialog, tokenService, MyService) {

    $scope.candidates = false;
    $rootScope.local = false;
    $rootScope.cityData = false;
    $rootScope.courage = false;
    $rootScope.incumbent = false;
    $rootScope.CityCouncil = false;
    $rootScope.withoutState = false;
    $rootScope.election = false;
    $scope.showLoader = false;
    $rootScope.catList = true;
    $rootScope.orgvList = false;
    $scope.allState = [];
    $scope.address = {
      state: "",
      upstate: "",
      files: ""
    };

    $scope.getAllStates = function () {
      $scope.allState.length = 0;
      $scope.loader = true;
      // console.log("address.state", $scope.address.state);
      MyService.getAllStates().then(
        function (payload) {
          console.log("payload : ", payload);
          $scope.allState = payload;
          var addNwState = payload;
          var smpl = {
            state: "NA",
            statePostalCode: "NA"
          };
          addNwState.unshift(smpl);
          $scope.loader = false;
        },
        function (errorPayload) {
          growl.error("Something went wrong.");
          $scope.loader = false;
        }
      );

    };

    // console.log($scope.selectState);

    $scope.getAllStates();

    $scope.getReviewCategory = function () {
      var nwState;
      MyService.ConsoleLog(" address.state", $scope.address.state);


      $scope.loader = true;

      MyService.getReviewCategory({
        "s_id": $scope.address.state.statePostalCode
      }).then(function (result) {
        console.log("result :", result);
        growl.success(result);
        $scope.loader = false;
      }, function (err) {
        growl.error(err.error);
      });
    };
  }]).controller("orgListCtrl", ["$scope", "$http", "$location", "apiCall", "$rootScope", "baseApiUrl", "$q", "$filter", "growl", "ngDialog", "tokenService", "MyService", function ($scope, $http, $location, apiCall, $rootScope, baseApiUrl, $q, $filter, growl, ngDialog, tokenService, MyService) {

    $scope.candidates = false;
    $rootScope.local = false;
    $rootScope.cityData = false;
    $rootScope.courage = false;
    $rootScope.incumbent = false;
    $rootScope.CityCouncil = false;
    $rootScope.withoutState = false;
    $rootScope.election = false;
    $scope.showLoader = false;
    $rootScope.catList = false;
    $rootScope.orgvList = true;
    $scope.allState = [];
    $scope.address = {
      state: "",
      upstate: "",
      files: ""
    };

    $scope.getAllStates = function () {
      $scope.allState.length = 0;
      $scope.loader = true;
      // console.log("address.state", $scope.address.state);
      MyService.getAllStates().then(
        function (payload) {
          console.log("payload : ", payload);
          $scope.allState = payload;
          var addNwState = payload;
          var smpl = {
            state: "NA",
            statePostalCode: "NA"
          };
          addNwState.unshift(smpl);
          $scope.loader = false;
        },
        function (errorPayload) {
          growl.error("Something went wrong.");
          $scope.loader = false;
        }
      );

    };

    /**
     * @description  Add votesmart orgs into the office table
     */
    $scope.getOrgList = function () {
      $scope.loader = true;
      MyService.getOrgList({
        "s_id": $scope.address.state.statePostalCode
      }).then(function (result) {
        growl.success(result);
        console.log("result :", result);
        $scope.loader = false;
      }, function (err) {
        MyService.ConsoleLog("err", err);
        growl.error(err.error);
        $scope.loader = false;
      });
    };

    // console.log($scope.selectState);

    $scope.getAllStates();
  }]);

'use strict';
angular.module('myApp.voterSignup', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
  $routeProvider.when('/votersignup', {
    templateUrl: 'app/voterSignup/voterSignup.html',
    controller: 'voterSignupCtrl'
  });
}])

.controller('voterSignupCtrl', ['$scope','$rootScope','$http','$location','apiCall', 'MyService', function ($scope, $rootScope, $http, $location, apiCall, MyService) {
  $scope.user = {};
  $rootScope.welcome = false;
  $scope.usernameMessage = '';
  $scope.passwordMessage = '';
  $scope.emailMessage = '';
  $scope.taken = true;
  $scope.counties = '';
  $scope.cities = [];
  $scope.zipClicked = "zip-not-clicked";
  var validate = apiCall.constants();

  $scope.makeErrorList = function(response){
    //MyService.ConsoleLog(response.errors);
    var errors = [];
    for (var key in response.errors) {
      if (response.errors.hasOwnProperty(key)) {
        var value = response.errors[key];
        if (value.message !== undefined) {
          errors.push(value.message);
        }
    }
    return errors;
  }
}

function validateUsername (username) {
  $scope.usernameMessage = '';
  var validated = validate.regex.username.test(username);
  if (!validated && username.length > 25 ) {
    $scope.usernameMessage = 'cannot be longer than 25 charectors and can contain (. - _ $ @ * ! )';
    return false;
  }
  if (!validated && username.length < 3 ) {
    $scope.usernameMessage = 'cannot be shorter than 3 charectors and can contain (. - _ $ @ * !)';
    return false;
  }
  if (!validated) {
    $scope.usernameMessage = 'must be between 3 and 25 charectors and can contain (. - _ $ @ * !)';
    return false;
  }
  if (validated) {
    usernameTaken(username);
      if ($scope.taken) {
        return true;
      }
      return false;
  }
  return validated;
}

function validatePassword (password) {
  $scope.passwordMessage = '';
  var validated = validate.regex.password.test(password);
  if (!validated) {
    $scope.passwordMessage = ' must be at least 8 charectors long, contain one number, one uppercase letter and one lowercase letter';
    return false;
  }
  return validated;
}

function validateEmail (email) {
  $scope.emailMessage = '';
  var validated = validate.regex.email.test(email);
  if (!validated) {
    $scope.emailMessage = 'Not a valid email address';
    return false;
  }
  if (validated) {
    emailTaken(email);
      if($scope.taken) {
        return true;
      }
      return false;
  }
  return validated;
}

function validateInputs (username, email, password) {
  var validUsername = validateUsername(username);
  var validEmail = validateEmail(email, $scope);
  var validPassword = validatePassword(password);

  if (validUsername && validEmail && validPassword) {
    return true;
  }
  return false;
}

function usernameTaken(username) {
  MyService.checkUnm({"username": username}).then(function(response){
    if (response.data.taken) {
        $scope.usernameMessage = ' is taken';
        $scope.taken = false;
        return;
    }
    $scope.taken = true;
  }, function(err){
      growl.error("Something went wrong.");
  });
}

var emailTaken = function(email){
  MyService.checkEmail({"email": email}).then(function(response){
    if (response.data.taken) {
        $scope.emailMessage = ' is taken';
        $scope.taken = false;
        return;
    }
    $scope.taken = true;
  }, function(err){
    growl.error("Something went wrong.");
  });
}

$scope.findByZip = function( user ){
  var request = apiCall.apiCall('GET', '/ziplookup/zip/'+ user.zip, undefined);
  $http(
    request
  ).then(function success(response) {
    $scope.counties = response.data.zip.county;
    $scope.cities = response.data.zip.city;
    $scope.zipClicked = 'zip-clicked';
  }, function error(response) {
    //MyService.ConsoleLog(response.data);
  })
}

  $scope.signUp = function( user ){
    $scope.errorMessages = '';
    //MyService.ConsoleLog(user);
    user.county = $scope.county;
    var validated = validateInputs (user.username, user.email, user.password);
    usernameTaken(validated);
    if (user.username && user.password && user.zip && user.email && validated) {
      var data = {
           password: user.password,
           city: user.city,
           street: user.address,
           zip: user.zip,
           username: user.username,
           email: user.email
      };
      var request = apiCall.apiCall('POST', '/user/signup', data);
     $http(
       request
     ).then(function successCallback(response) {
      $location.path('/signin');
    }, function errorCallback(response) {
       var errorList = $scope.makeErrorList(response.data.error);
       if (errorList) {
         $scope.errorMessages = String(errorList);
       }
       else {
          $scope.errorMessages = '';
       }

    });
  }
  else {
    $scope.errorMessages = 'Please fill out all fields.';
  }
 }

}]);

'use strict';

angular
  .module('myApp.voterProfile', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/voterProfile/:pressId/:type?/:match?', {
        templateUrl: 'app/voterProfile/voterProfile.html',
        controller: 'voterProfileCtrl',
      });
    },
  ])

  .controller('voterProfileCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    '$routeParams',
    '$rootScope',
    'baseApiUrl',
    '$q',
    '$timeout',
    'growl',
    'tokenService',
    '$anchorScroll',
    '$sce',
    'MyService',
    'ngDialog',
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $rootScope,
      baseApiUrl,
      $q,
      $timeout,
      growl,
      tokenService,
      $anchorScroll,
      $sce,
      MyService,
      ngDialog
    ) {
      $rootScope.welcome = false;
      $rootScope.quizzesData = '';
      $rootScope.followersData = '';
      $scope.pressId = $routeParams.pressId;
      var tempArr = [];


      MyService.ConsoleLog("$rootScope.selectedCompareUsers", $rootScope.selectedCompareUsers);
      // $scope.match = $routeParams.match;
      $scope.showUnFollow = false;
      // $scope.loginUser = tokenService.getUserId();
      $scope.dataType = $routeParams.type;
      MyService.ConsoleLog('$scope.cat_title', $rootScope.cat_title);
      $scope.userType = tokenService.getUserRole();
      if (tokenService.getUserData()) {
        $scope.uData = JSON.parse(tokenService.getUserData());
      }
      window.localStorage.removeItem('isShowPreviousResult');

      window.localStorage.setItem('isShowPreviousResult', true);

      // window.localStorage.removeItem('followData');
      $scope.froumthreads = [];
      $scope.press = {};
      $scope.Sticky = {
        ShowOrder: [],
        txtOrder: [],
      };
      $scope.vote = {
        recommend: 0,
        factual: 0,
      };
      //$scope.GalleryFolder = baseApiUrl + "/resources/" + $scope.uData.uname;
      if (tokenService.getUserData()) {
        $scope.UserData = JSON.parse(tokenService.getUserData());
        MyService.ConsoleLog('$scope.UserData >', $scope.UserData);
      }
      $scope.displayComments = true;
      $scope.Reply = {};

      $scope.checkMemId = function (rdata, val) {
        return rdata.filter(function (rdata) {
          if (rdata.userData._id == $rootScope.UserId) return rdata;
        });
      };

      $scope.CheckUrl = function (url, option) {
        if (url) {
          if (url.indexOf('youtube.com') >= 0) {
            var url = url.replace('watch?v=', 'embed/');
            if (option == 'V')
              return $sce.trustAsHtml(
                '<br/><iframe width="560" height="315" src="' +
                url +
                '" frameborder="0" allowfullscreen></iframe><br/>'
              );
            else
              return $sce.trustAsHtml(
                '<br/><iframe src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>'
              );
          }
          if (url.indexOf('facebook.com') >= 0) {
            if (option == 'V')
              return $sce.trustAsHtml(
                '<br/><iframe src="' +
                url +
                '" width="560" height="315" frameborder="0"></iframe><br/>'
              );
            else
              return $sce.trustAsHtml(
                '<br/><iframe src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>'
              );
          }
          if (url.indexOf('vimeo.com') >= 0) {
            if (url.indexOf('https://vimeo.com/') >= 0) {
              var id = url.replace('https://vimeo.com/', '');
              var newurl = 'https://player.vimeo.com/video/' + id;
            } else {
              var newurl = url;
            }
            if (option == 'V')
              return $sce.trustAsHtml(
                '<br/><iframe src="' +
                newurl +
                '" width="500" height="281" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe><br/>'
              );
            else
              return $sce.trustAsHtml(
                '<br/><iframe src="' +
                newurl +
                '" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe><br/>'
              );
          }
          if (option == 'V')
            return $sce.trustAsHtml(
              '<br/><iframe width="560" height="315" src="' +
              url +
              '" frameborder="0" allowfullscreen></iframe><br/>'
            );
          else
            return $sce.trustAsHtml(
              '<br/><iframe src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>'
            );
        }
      };

      /**
       * get the average of rating for all type of users
       */

      $scope.calculateAvg = function (arr) {
        var reclen = arr.length;
        var recsum = 0;
        for (var r = 0; r < reclen; r++) {
          recsum += parseInt(arr[r].vote, 10);
          if (r == reclen - 1) {
            if (recsum > 0) {
              var recavg = Math.round(recsum / reclen);
            } else {
              var recavg = 0;
            }
            return recavg;
          }
        }
      };

      $scope.chkIfVoted = function (rdata, val) {
        return rdata.filter(function (rdata) {
          // if (!tokenService.getUserId()) {
          //   return rdata;
          // } else {
          //   if (rdata.user.id == val) return rdata;
          // }
          return rdata;
        });
      };
      $scope.loginUser = tokenService.getUserId();
      $scope.getPressDetails = function () {
        //MyService.ConsoleLog("Get One called");
        MyService.getPress($routeParams.pressId).then(
          function (payload) {
            MyService.ConsoleLog('payload', payload);

            if ($scope.UserData && $scope.UserData.followlist.length > 0) {
              var fLen = $scope.UserData.followlist.length;
              for (var f = 0; f < fLen; f++) {
                // MyService.ConsoleLog("$scope.UserData.followlist[f]", $scope.UserData.followlist[f]);
                if ($scope.UserData.followlist[f] == $routeParams.pressId) {
                  $scope.showUnFollow = true;
                  // growl.success("showUnfollow");
                  // alert("showunfollow");
                }
                /*else {
              // MyService.ConsoleLog("userProfile", $scope.userProfile);
              if ($scope.UserData.followlist[f] == $scope.userProfile.officeId) {
                $scope.showUnFollow = true;

              }
            }*/
              }
            }
            if (payload && payload.userData) {
              $scope.pressUserId = payload.userData._id;

              tempArr.push({
                _id: $scope.pressUserId
              });
              $rootScope.selectedCompareUsers = tempArr;
              MyService.getUserPublicProfile({
                id: $scope.pressUserId,
                type: false,
              }).then(function (response) {
                MyService.ConsoleLog('vote', response.data.data);
                $scope.votewiseActivity = response.data.data;
              });
            }

            if (payload && payload.orgdata) {
              $scope.pressUser = payload.userData;
              $scope.press = payload.orgdata;
              tempArr.push({
                _id: $scope.press._id
              });
              $rootScope.selectedCompareUsers = tempArr;
              if (payload.orgdata.recommended) {
                // alert('inside');
                var chkrecommend = $scope.chkIfVoted(payload.orgdata.recommended, $scope.loginUser);
                MyService.ConsoleLog('chkrecommend', chkrecommend);
                // if (chkrecommend && chkrecommend[0]) {
                $scope.vote.recommend = $scope.calculateAvg(chkrecommend);
                // }

              }
              if (payload.orgdata.factual) {
                var chkfactual = $scope.chkIfVoted(payload.orgdata.factual, $scope.loginUser);

                // if (chkfactual && chkfactual[0]) {
                $scope.vote.factual = $scope.calculateAvg(chkfactual);
                // }
              }
            } else {
              $scope.press = payload;
              $scope.pressUser = payload;
              MyService.ConsoleLog(' $scope.press ', $scope.press);
              if (payload.recommended) {
                var chkrecommend = $scope.chkIfVoted(payload.recommended, $scope.loginUser);

                if (chkrecommend && chkrecommend[0]) {
                  $scope.vote.recommend = chkrecommend[0].vote;
                }
              }
              if (payload.factual) {
                var chkfactual = $scope.chkIfVoted(payload.factual, $scope.loginUser);

                if (chkfactual && chkfactual[0]) {
                  $scope.vote.factual = chkfactual[0].vote;
                }
              }
            }
            MyService.getHighlighatedPost({
              pId: $scope.pressId,
            }).then(
              function (response) {
                $scope.getFollowersList();
                MyService.ConsoleLog('response', response);
                $scope.HighlightedPost = response.data;
              },
              function (err) {
                MyService.ConsoleLog('Error', err);
              }
            );
          },
          function (errorPayload) {
            //MyService.ConsoleLog(errorPayload);
            alert('Something went wrong ');
          }
        );
      };

      /**
       * Redirect to discussion page
       */
      $scope.redirectToReviews = function () {
        // growl.success("redirect to discussion");
        $location.path('/orgRating/' + $scope.pressId);
      };

      /**
       * get  followers count and get quizzes count
       */
      $scope.getFollowersList = function () {
        MyService.getFollowersList({
          orgId: $scope.pressId
        }).then(
          function (response) {
            MyService.ConsoleLog('response', response.data);
            $scope.followersCnt = response.data.followersCount;
            $rootScope.followersData = response.data.followersData;
            // window.localStorage.setItem('followData', JSON.stringify(response.data.followersData));
            $scope.questionsCnt = response.data.quizzesCount;
            $rootScope.quizzesData = response.data.quizzesData;
            $scope.quizQuesHasAns = response.data.quesHasAnsCount;
            $scope.getMatch();
          },
          function (err) {
            MyService.ConsoleLog('error', err);
          }
        );
      };


      /**
       * Get Match of questions
       */

      $scope.getMatch = function () {

        MyService.getMatchForPress({
          pressId: $scope.pressId
        }).then(function (result) {
          MyService.ConsoleLog("Result", result);
          if (result && result.length > 0) {
            $scope.match = result[0].match;

          }
        }, function (err) {
          MyService.ConsoleLog("Error", err);
        });
      };

      /**
       * Follow orgnization
       */
      $scope.addtoFollow = function () {
        var data = {};
        data.userId = $scope.loginUser;
        data.pushId = $routeParams.pressId;
        MyService.updateUserFollowList(data).then(
          function (payload) {
            // alert('User added to followup list successfully.');
            $scope.getPressDetails();
            if ($scope.UserData) {
              $scope.showUnFollow = true;
              $scope.UserData.followlist.push($routeParams.pressId);
              MyService.ConsoleLog('udata : ', $scope.UserData);
              tokenService.saveUserData(JSON.stringify($scope.UserData));
            }
          },
          function (errorPayload) {
            alert('Something went wrong ');
          }
        );
      };

      /**Unfollow organization*/

      $scope.removetoFollow = function () {
        var data = {};
        data.userId = $scope.loginUser;
        data.pushId = $routeParams.pressId;
        MyService.removeUserFollowList(data).then(
          function (result) {
            MyService.ConsoleLog('result', result);

            $scope.showUnFollow = false;
            $scope.getPressDetails();

            var ids = $scope.UserData.followlist.indexOf($routeParams.pressId);
            MyService.ConsoleLog('ids', ids);
            if (ids > -1) {
              $scope.UserData.followlist.splice(ids, 1);
            }

            // else {
            //   var idx = $scope.UserData.followlist.indexOf($scope.userProfile.officeId);
            //   if (idx > -1) {
            //     $scope.UserData.followlist.splice(idx, 1);
            //   }
            // }
            //MyService.ConsoleLog("udata : ", $scope.UserData);
            tokenService.saveUserData(JSON.stringify($scope.UserData));
          },
          function (err) {
            MyService.ConsoleLog('error', err);
          }
        );
      };

      function getCategory() {
        MyService.getCategoryList($routeParams.categoryId).then(
          function (payload) {
            $scope.category = payload;
          },
          function (errorPayload) {
            alert('Something went wrong ');
          }
        );
      }

      $scope.ShowLoader = false;
      $scope.LatestEssay = [];
      $scope.LatestPost = [];
      $scope.LatestThread = [];
      $scope.gotoPage = function (obj, data) {
        //MyService.ConsoleLog(data);
        switch (obj) {
          case "Essay":
            var userid = data._id;
            $scope.dialogClose = ngDialog.open({
              template: 'LatestEssayId',
              closeByNavigation: true,
              scope: $scope
            });
            $scope.ShowLoader = true;
            MyService.getLatestEssay({
              "userId": userid
            }).then(function (payload) {
              $scope.ShowLoader = false;
              MyService.ConsoleLog("essay", payload);
              $scope.LatestEssay = payload;
            }, function (errorPayload) {
              $scope.ShowLoader = false;
              MyService.ConsoleLog("err vosjs", errorPayload);
              alert("Something went wrong.");
            });
            //$location.path('essayDetails/' + catId + '/' + id);
            break;
          case "EssayComment":
            var userid = data._id;
            $scope.dialogClose = ngDialog.open({
              template: 'LatestEssayCommentId',
              closeByNavigation: true,
              scope: $scope
            });
            $scope.ShowLoader = true;
            MyService.getLatestEssay({
              "userId": userid,
              isEssayComment: true
            }).then(function (payload) {
              if (payload && payload.length > 0) {
                var essayIds = payload.map(function (itms) {
                  if (itms && itms.essayId) {
                    return itms.essayId;
                  }
                });

                MyService.getAllEssaysList({
                  eIds: JSON.stringify(essayIds)
                }).then(function (APIResponse) {
                  MyService.ConsoleLog("APIREs", APIResponse);
                  if (APIResponse.success) {
                    $scope.ShowLoader = false;
                    MyService.ConsoleLog("essay commnent", payload);
                    $scope.LatestEssayComments = APIResponse.data;
                  }
                }, function (err) {
                  MyService.ConsoleLog("Error", err);
                });
              }

            }, function (errorPayload) {
              $scope.ShowLoader = false;
              MyService.ConsoleLog("err vosjs", errorPayload);
              alert("Something went wrong.");
            });


            //$location.path('essayDetails/' + catId + '/' + id);
            break;
          case "Post":
            var userid = data._id;
            // var subcatid = ""
            // if(data.subcategories && data.subcategories.length > 0)
            //var subcatid = data.subcategories[0].pid;
            //var id = data.parent;
            //MyService.ConsoleLog('forumthread/' + catId + '/' + subcatid + '/' + id);
            //$location.path('forumthread/' + catId + '/' + subcatid + '/' + id);
            $scope.dialogClose = ngDialog.open({
              template: 'LatestPostId',
              closeByNavigation: true,
              scope: $scope
            });
            $scope.ShowLoader = true;
            MyService.getLatestPost({
              "userId": userid
            }).then(function (payload) {
              $scope.ShowLoader = false;
              //MyService.ConsoleLog(payload);
              $scope.LatestPost = payload;
            }, function (errorPayload) {
              $scope.ShowLoader = false;
              MyService.ConsoleLog("errorPayload errorPayload", errorPayload);
              alert("Something went wrong.");
            });
            break;
          case "Thread":
            //var catId = data.parentcat[0];
            //var subcatid = ""
            // if(data.subcategories && data.subcategories.length > 0)
            //     var subcatid = data.subcategories[0].pid;
            //var subcatid = data.subcategories[0].pid;
            var userid = data._id;
            $scope.dialogClose = ngDialog.open({
              template: 'LatestThreadId',
              closeByNavigation: true,
              scope: $scope
            });
            $scope.ShowLoader = true;
            MyService.getLatestThread({
              "userId": userid
            }).then(function (payload) {
              $scope.ShowLoader = false;
              //MyService.ConsoleLog(payload);
              $scope.LatestThread = payload;
            }, function (errorPayload) {
              $scope.ShowLoader = false;
              alert('error');
              alert("Something went wrong.");
            });
            //MyService.ConsoleLog('forumthread/' + catId + '/' + subcatid + '/' + id);
            //$location.path('forumthread/' + catId + '/' + subcatid + '/' + id);
            break;
          default:
            break;
        }

      };

      $scope.gotoThread = function (data, subcatid) {
        var id = '';
        if (data.parentId) {
          id = data.parentId;
        } else if (data.parent) {
          id = data.parent;
        } else {
          if (data.id) {
            id = data.id;
          } else {
            id = data._id;
          }
        }
        // MyService.ConsoleLog(data);
        var categoryId = "";
        if (data.parentCat[0] && data.parentCat[0] != "") {
          categoryId = data.parentCat[0];
        } else {
          if (data.parentCat[1] && data.parentCat[1] != "") {
            categoryId = data.parentCat[1];
          }
        }

        // $rootScope.subcategoryId = subcatid;
        //MyService.ConsoleLog('forumthread/' + categoryId + '/' + subcatid + '/' + id);


        if (categoryId != "") {
          $location.path('forumthread/' + categoryId + '/' + subcatid + '/' + id);
        } else {
          MyService.ConsoleLog("ELSE");
          alert("Something went wrong");
        }


      }

      $scope.gotoComments = function (eId, catId) {
        MyService.ConsoleLog("eid", eId);
        MyService.ConsoleLog("catId", catId);

        // MyService.getEssay(eId).then(function (APIResponse) {
        //   MyService.ConsoleLog("APIResponse", APIResponse);
        if (eId && catId) {
          $location.path('/essayDetails/' + catId + "/" + eId);
        }
      };

      $scope.gotoEssay = function (id, catId) {
        $location.path('essayDetails/' + catId + '/' + id);
      }

      $scope.updateCommentApi = function (data, options, idex) {
        MyService.updatePressComments(data).then(
          function (payload) {
            if (payload.nModified == 0) {
              alert('You already provided your inputs on this post');
            } else {
              switch (options) {
                case 'like':
                  $scope.essayComments[idex].totalLikes = $scope.essayComments[idex].totalLikes + 1;
                  break;
                case 'dislike':
                  $scope.essayComments[idex].totalDislike =
                    $scope.essayComments[idex].totalDislike + 1;
                  break;
                default:
                  $scope.essayComments[idex].totalSpam = $scope.essayComments[idex].totalSpam + 1;
                  break;
              }
            }
          },
          function (errorPayload) {
            alert('Something went wrong ');
          }
        );
      };

      $scope.updateComments = function (options, id, idex) {
        if ($rootScope.UserId) {
          if ($scope.essayComments[idex].createdBy.id != $rootScope.UserId) {
            var commentData = {};
            commentData.commentId = id;
            commentData.userId = $rootScope.UserId;

            switch (options) {
              case 'like':
                commentData.likes = 1;
                break;
              case 'dislike':
                commentData.dislikes = 1;
                break;
              default:
                commentData.spam = 1;
                break;
            }

            $scope.updateCommentApi(commentData, options, idex);
          } else {
            alert('You cannot ' + options + ' your own comments');
          }
        } else {
          alert('Please login to perform these actions');
        }
      };
      $scope.submitSticky = function (data, id, idx) {
        if (data > 0) {
          updateForum('sticky', id, idx);
        } else {
          alert('Please enter valid order');
        }
      };

      $scope.ShowComments = false;

      $scope.redirectToComment = function () {
        var token = apiCall.getToken();
        if (!token) {
          var message = 'Please login first.';

          var modal = ngDialog.openConfirm({
            template: '<p>' +
              message +
              '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
            plain: true,
          });

          modal.then(
            function fullfilled(data) {
              //MyService.ConsoleLog("fullfilled: ", data);
              $location.path('signin');
            },
            function rejected(data) {
              //MyService.ConsoleLog("rejected: ", data);
              $location.path('signin');
            }
          );
        }
        $scope.ShowComments = true;
        $scope.displayComments = false;

        //$location.path('forumReply/'+$routeParams.categoryId+'/'+$routeParams.subcatId+'/'+$routeParams.essayId);
      };

      $scope.goBack = function () {
        $scope.ShowComments = false;
        $scope.displayComments = true;
      };

      $scope.getComments = function () {
        MyService.getPressComments($routeParams.pressId).then(
          function (payload) {
            $scope.essayComments = payload;
          },
          function (errorPayload) {
            alert('Something went wrong ');
          }
        );
      };

      $scope.SubmitComment = function (rec) {
        //MyService.ConsoleLog(data);
        //MyService.ConsoleLog($scope.mainThread);
        var data = {};
        if (rec.content != '') {
          $scope.TopicButton = true;
          data.createdById = $rootScope.UserId;
          data.createdByName = $rootScope.User;
          data.createdByType = tokenService.getUserRole();
          data.comments = rec.content;
          data.pressId = $routeParams.pressId;
          //MyService.ConsoleLog(data);
          MyService.submitPressComments(data).then(
            function (payload) {
              $scope.comments = {
                content: '',
              };
              $scope.ShowComments = false;
              $scope.displayComments = true;
              $scope.mainThread = {};
              //$location.path('forumthread/'+$routeParams.categoryId+'/'+$routeParams.subcatId+'/'+$routeParams.essayId);
              $scope.getComments();
            },
            function (errorPayload) {
              alert('Something went wrong ');
            }
          );
        } else {
          alert('Please enter comments.');
        }
      };

      $scope.PressVote = function (option) {
        var token = apiCall.getToken();
        if (!token) {
          var message = 'Please login first.';

          var modal = ngDialog.openConfirm({
            template: '<p>' +
              message +
              '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
            plain: true,
          });

          modal.then(
            function fullfilled(data) {
              //MyService.ConsoleLog("fullfilled: ", data);
              $location.path('signin');
            },
            function rejected(data) {
              //MyService.ConsoleLog("rejected: ", data);
              $location.path('signin');
            }
          );
        } else {
          var data = {};
          data._id = $routeParams.pressId;
          data.mediaType = '';
          data.option = option;
          //MyService.ConsoleLog(option);
          if (option == 'Recommended') {
            data.vote = $scope.vote.recommend;
          } else {
            data.vote = $scope.vote.factual;
          }
          data.createdById = $scope.loginUser;
          data.createdByName = tokenService.getUserName();
          data.createdByType = tokenService.getUserRole();
          MyService.updatePress(data).then(
            function (payload) {
              alert('Thank you for rating the press.');
            },
            function (errorPayload) {
              alert('Something went wrong ');
            }
          );
        }
      };

      $scope.getVotesmartPressDetails = function () {
        console.log('getVotesmartPressDetails');
        MyService.getVotesmartPressDetails({
          sigid: $scope.pressId,
        }).then(
          function (payload) {
            console.log('payload1 > ', payload);
            if (payload.data.success) {
              $scope.press = payload.data.data;
            } else {
              alert('Something went wrong ');
            }
          },
          function (epayload) {
            alert('Something went wrong ');
          }
        );
      };

      console.log('new', $scope.dataType);
      if ($scope.dataType && $scope.dataType == 'false') {
        $scope.getVotesmartPressDetails();
      } else {
        if ($routeParams.pressId) {
          $scope.getPressDetails();
          $scope.getComments();
        }
      }
    },
  ]);

'use strict';
angular
  .module('myApp.viewBills', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/viewBills', {
        templateUrl: 'app/viewBills/viewBills.html',
        controller: 'viewBillsCtrl'
      });
    }
  ])
  .controller('viewBillsCtrl', [
    '$scope',
    'ngDialog',
    '$rootScope',
    'MyService',
    '$http',
    '$timeout',
    '$q',
    'tokenService',
    'growl',

    function ($scope, ngDialog, $rootScope, MyService, $http, $timeout, $q, tokenService, growl) {

      $scope.userData = tokenService.getUserData();
      if ($scope.userData && $scope.userData != "") {
        MyService.ConsoleLog("$scope.UserData >", JSON.parse($scope.userData));
        MyService.ConsoleLog("$scope.UserData >", JSON.parse($scope.userData));
        MyService.ConsoleLog("$scope.UserData >");
      }

      $scope.currPage = 1;
      $scope.showDetail = false;
      $scope.more = [];
      $scope.documents = [];
      $scope.activeDoc = true;
      $scope.activeAct = true;

      $scope.activeVot = true;
      $scope.activeSpo = true;

      $scope.date = {
        "value": ""
      }

      $scope.myPagingFunction = function () {
        MyService.ConsoleLog('scoll called', $scope.statusGetResPg);
        if ($scope.statusGetResPg != 1 && $scope.searchData > $scope.openBills.length) {
          $scope.currPage++;
          $scope.pageChanged($scope.currPage);
        }
      };

      $scope.pageChanged = function (newPage) {
        $scope.getBills(newPage);
      };
      $scope.openBills = [];
      $scope.searchCandy = {
        'search': "",
        'state': []
      };

      $scope.searchMe = function (user) {
        // MyService.ConsoleLog('in searchMe', user);
        var query = $scope.searchCandy.search.toLowerCase(),
          fullname = user.title.toLowerCase();

        if (fullname.indexOf(query) != -1) {
          return true;
        }
        return false;
      };

      $scope.searchData = 0;
      /*
      $scope.SearchByTitle = function() {
        // MyService.ConsoleLog('in searchMe', $scope.search.sdata);
        // var query = $scope.search.sdata.toUpperCase();
        if ($scope.userData && $scope.userData != "") {
          var state = JSON.parse($scope.userData);
          MyService.ConsoleLog("state >", state.address.state);
        }

        var pageNumber = 1;
        // MyService.ConsoleLog("apraaa >>",)
        // var states = [];
        var states = Object.keys($scope.searchCandy.state);
        // states.push(state.address.state);
        MyService.ConsoleLog("state > ", states);

        $scope.params = {
          page: pageNumber,
          max_records: 30,
          title: $scope.searchCandy.search,
          "state": states
        };

        //MyService.ConsoleLog("params: ", params);
        // $scope.users.data = [];

        $scope.statusGetResPg = 1;

        var getAllCanceller = $q.defer();


        MyService.ConsoleLog('in searchMe', $scope.currPage);

        MyService.SearchByTitle($scope.params, getAllCanceller).then(
          function(response) {
            MyService.ConsoleLog('response >>>>>>>>>', response);

            $scope.openBills.length = 0;
            $scope.openBills = response.data;
            $scope.searchData = response.count;

            MyService.ConsoleLog('response', $scope.openBills);

          },
          function(error) {
            MyService.ConsoleLog('Error>>', error);
            growl.error("Data not found for this search");
          }
        );
      };
*/
      // $scope.sortByDate=function(){
      //   if()

      // }


      $scope.getBills = function (pageNumber, obj, canceller) {
        MyService.ConsoleLog('pageNumber >', pageNumber);
        // $scope.states = "";
        // MyService.ConsoleLog("val >",val);
        $scope.openBills.length = 0;
        // $rootScope.para = "";
        if ($scope.userData) {
          var state = JSON.parse($scope.userData);

        }
        // MyService.ConsoleLog("state >", state.address.state);
        // $scope.state = "";

        $scope.states = Object.keys($scope.searchCandy.state);
        if ($scope.states.length == 0) {
          // alert("welcome");
          if ($scope.userData) {
            $scope.states.push(state.address.state);
          }
        }
        // if ($scope.userData) {
        //
        // }
        MyService.ConsoleLog("state > ", $scope.states);


        $scope.params = {
          page: pageNumber,
          max_records: 30,
          title: $scope.searchCandy.search,
          state: $scope.states
        };
        MyService.ConsoleLog("params: ", $scope.params);
        // $scope.users.data = [];
        $scope.totalUsers = 0;

        $scope.statusGetResPg = 1;

        $scope.getAllCanceller = $q.defer();
        var calc = (pageNumber - 1) * 30;
        MyService.ConsoleLog("Object >>", obj);
        if (pageNumber != "") {
          MyService.SearchByTitle($scope.params, $scope.getAllCanceller).then(
            function (result) {
              console.log("RESPONSE >  ", result);
              // $scope.states.length= 0;
              // $scope.TotalBills = result.data.data[0].totalCount;
              $scope.openBills = $scope.openBills.concat(result.data);
              $scope.searchData = result.count;
              MyService.ConsoleLog('$scope.open >', $scope.searchData);
              // console.log($scope.committee);
              // $scope.totalUsers = payload.Count;
              // MyService.ConsoleLog(payload.Items);
              $scope.statusGetResPg = 2;
            },
            function (err) {
              // MyService.ConsoleLog("ERORR", err);
              // MyService.ConsoleLog("ERORR", err);
              growl.error(err);
              $scope.statusGetResPg = 3;
              $scope.page--;
            }
          );
        } else {
          ////alert("else");
          MyService.SearchByTitle($rootScope.para, $scope.getAllCanceller).then(
            function (result) {
              console.log("RESPONSE >  ", result);
              // $scope.TotalBills = result.data.data[0].totalCount;
              $scope.openBills = $scope.openBills.concat(result.data);
              $scope.searchData = result.count;
              MyService.ConsoleLog('$scope.open >', $scope.searchData);
              // console.log($scope.committee);
              // $scope.totalUsers = payload.Count;
              // MyService.ConsoleLog(payload.Items);
              $scope.statusGetResPg = 2;
            },
            function (err) {
              growl.error('Something went wrong.');
              $scope.statusGetResPg = 3;
              $scope.page--;
            }
          );
        }

      };

      $scope.flag = window.localStorage.getItem('flag');

      MyService.ConsoleLog("Fla one ", $scope.flag);
      if ($scope.userData && $scope.flag == "false" || $scope.flag == "") {
        //////alert('if');
        $scope.getBills($scope.currPage);

      }

      $scope.getDetails = function (val) {
        MyService.ConsoleLog('params >', val);
        MyService.getBillDetail({
          id: val
        }).then(
          function (response) {
            MyService.ConsoleLog('got data >', response);
            $scope.details = response.data.data;
            $scope.showDetail = true;
          },
          function (err) {
            MyService.ConsoleLog('Error', err);
          }
        );
      };
      $scope.back = function () {
        $scope.showDetail = false;
      };

      $scope.getDetailsOfCandidates = function (val) {
        $scope.more[val] = true;
        $scope.documents[val] = true;


      };
      $scope.showLess = function (valOne) {
        $scope.more[valOne] = false;
        $scope.documents[valOne] = false;

      }

      /*
       *@ Function to get all states
       */


      $scope.getAllStates = function () {
        // $scope.allState.length = 0;
        // $scope.loader = true;
        // console.log("address.state", $scope.address.state);
        MyService.getAllStates().then(
          function (payload) {
            console.log("payload : ", payload);
            $scope.allState = payload;
            // $scope.loader = false;
          },
          function (errorPayload) {
            growl.error("Something went wrong.");
            $scope.loader = false;
          }
        );
      };

      $scope.getAllStates();


      $scope.flag = window.localStorage.getItem('flag');
      MyService.ConsoleLog("flag >>", $scope.flag);
      if ($scope.flag == "true") {
        // //////alert("wel");
        $scope.getBills("", $rootScope.para, $scope.getAllCanceller);
        window.localStorage.setItem('flag', false);

      } else {
        window.localStorage.setItem('flag', false);

      }
      MyService.ConsoleLog("$rootScope >>", $rootScope.para);

      $scope.getDetailPage = function (id) {
        MyService.ConsoleLog("$rootScope.para ", $rootScope.para);

        if ($rootScope.para != undefined) {
          $rootScope.para = $rootScope.para;

          //alert("if****");
        } else {
          $rootScope.para = $scope.params;


          //alert("else ****");
        }
        MyService.ConsoleLog("Root >", $rootScope.para);

        window.location.href = "#!/viewBillDetails/" + id;
      }
    }
  ]);

'use strict';
angular
  .module('myApp.viewBillDetails', ['ngRoute'])

  .config([
    '$routeProvider',
    function($routeProvider) {
      $routeProvider.when('/viewBillDetails/:id?', {
        templateUrl: 'app/viewBillDetails/viewBillDetails.html',
        controller: 'viewBillDetailsCtrl'
      });
    }
  ])
  .controller('viewBillDetailsCtrl', [
    '$scope',
    'ngDialog',
    '$rootScope',
    'MyService',
    '$http',
    '$timeout',
    '$routeParams',
    '$q',
    'tokenService',
    'growl',
    'apiCall',


    function($scope, ngDialog, $rootScope, MyService, $http, $timeout, $routeParams, $q, tokenService, growl, apiCall) {


      console.log("$routeParams >", $routeParams.id);
      $scope.uId = $routeParams.id;
      $scope.activeDoc = true;
      $scope.activeAct = true;
      $scope.activeAction = true;

      $scope.activeVot = true;
      $scope.activeSpo = true;
      $scope.displayComments = true;
      $scope.ShowComments = false;
      $scope.loader = false;

      /*
       ** get Bill Details 
       */

      $scope.getDetails = function(val) {
        MyService.ConsoleLog('params >', val);
        MyService.getBillDetail({ id: val }).then(
          function(response) {
            MyService.ConsoleLog('got data >', response);
            $scope.details = response.data.data;
            $scope.showDetail = true;
            $scope.getRatingData();

          },
          function(err) {
            MyService.ConsoleLog('Error', err);
          }
        );
      };

      $scope.getDetails($scope.uId);


      /*
       ** Redirect to comment form
       */



      $scope.redirectToComment = function() {
        var token = apiCall.getToken();
        if (!token) {
          var message = "Please login first.";

          var modal = ngDialog.openConfirm({
            template: '<p>' + message + '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
            plain: true
          });

          modal.then(function fullfilled(data) {
            //MyService.ConsoleLog("fullfilled: ", data);
            $location.path('signin');
          }, function rejected(data) {
            //MyService.ConsoleLog("rejected: ", data);
            $location.path('signin');
          });
        }
        $scope.ShowComments = true;
        $scope.displayComments = false;

        //$location.path('forumReply/'+$routeParams.categoryId+'/'+$routeParams.subcatId+'/'+$routeParams.essayId);
      }


      /*
       ** Hide comment text input
       */
      $scope.goBack = function() {
        $scope.ShowComments = false;
        $scope.displayComments = true;
      }


      /*
       ** get Ratings 
       */

      $scope.rating = {
        "rate": ''
      }
      $scope.rateLegislation = function(option) {
        var token = apiCall.getToken();
        if (!token) {
          var message = "Please login first.";

          var modal = ngDialog.openConfirm({
            template: '<p>' + message + '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
            plain: true
          });

          modal.then(function fullfilled(data) {
            //MyService.ConsoleLog("fullfilled: ", data);
            $location.path('signin');
          }, function rejected(data) {
            //MyService.ConsoleLog("rejected: ", data);
            $location.path('signin');
          });
        } else {
          var data = {};
          data.userId = tokenService.getUserId();
          data.uName = tokenService.getUserName();
          data.uType = tokenService.getUserRole();
          data.legisId = $scope.details._id;
          data.createOn = new Date();

          //MyService.ConsoleLog(option);

          data.rating = $scope.rating.rate;
          MyService.ConsoleLog("rating  >>>", data);

          MyService.saveLegisRating(data).then(function(payload) {
            // alert('Thank you for rating the Legislation.');

            growl.success('Thank you for vote Legislation.');


          }, function(errorPayload) {
            alert('Something went wrong ');
            growl.Error('Something went wrong');
          });
        }
      }


      /*
       ** Get comments and save it to tha database  
       */

      $scope.SubmitComment = function(rec) {
        //MyService.ConsoleLog(data);

        var data = {};
        if (rec.content != "") {

          data.commentedBy = tokenService.getUserId();
          data.commentedByName = tokenService.getUserName();
          data.commentedByType = tokenService.getUserRole();
          data.comments = rec.content;
          data.legisId = $scope.details._id;
          data.createOn = new Date();
          //MyService.ConsoleLog(data);
          MyService.saveLegisComment(data).then(function(payload) {
            $scope.comments = {
              content: ''
            };
            $scope.getRatingData();
            $scope.ShowComments = false;
            $scope.displayComments = true;
            $scope.getRatingData();
            // $scope.getComments();
          }, function(errorPayload) {
            alert('Something went wrong ');
          });
        } else {
          alert("Please enter comments.");
        }
      }

      /*
       ** Fetch rating data from database  
       */

      $scope.getRatingData = function() {



        MyService.getLegisRate({ 'legisId': $scope.details._id, "uType": tokenService.getUserRole() }).then(function(data) {
          MyService.ConsoleLog("Dayta>>>", data);
          $scope.rating.rate = data.data.rating;
          $scope.comment = data.data.comment;
          $scope.disImg = true;

        }, function(err) {
          console.log("error >>", err);
        })
      }


      $scope.backTo = function() {
      window.localStorage.setItem('flag', true);

        window.history.back();
      }
    }
  ]);

 'use strict';
 angular.module('myApp.verifyUsers', ['ngRoute'])

   .config(['$routeProvider', function ($routeProvider) {
     $routeProvider.when('/verifyUsers', {
       templateUrl: 'app/verifyUsers/verifyUsers.html',
       controller: 'AdminVerifyUsers'
     });
   }])
   .controller('AdminVerifyUsers', ['$scope', '$http', '$location', 'apiCall', '$rootScope', 'baseApiUrl', '$q', '$filter', 'growl', 'ngDialog', 'MyService', function ($scope, $http, $location, apiCall, $rootScope, baseApiUrl, $q, $filter, growl, ngDialog, MyService) {
     //MyService.ConsoleLog("* AdminVerifyUsers *");

     $scope.verifySelectedUser = null;
     $scope.showDetails = true;

     $scope.verifyFilter = null;
     $scope.statusVerifyUsers = 0; //1=loading, 2 = loaded, 3 = error while loading
     $scope.page = 1;
     $scope.usersPerPage = 25;
     $scope.isShowOrg = true;

     $scope.User = {
       name: ''
     };

     //$scope.totalUsers = 0;
     $scope.verifyUsers = {
       data: []
     };
     var getVerifyUsersCanceler = $q.defer();
     $scope.statusGetResPg = 0;
     $scope.listUsers = function (page) {
       //MyService.ConsoleLog("getVerifyUsers: ", $scope.verifySelectedUser, " filter: ", $scope.verifyFilter);
       $scope.statusGetResPg = 1;
       getVerifyUsersCanceler.resolve();
       var params = {
         usertype: $scope.verifySelectedUser.toLowerCase(),
         pageno: page,
         max_records: $scope.usersPerPage,
         verified: $scope.verifyFilter,
         timeout: getVerifyUsersCanceler.promise
       };


       $scope.statusVerifyUsers = 1;
       if ($scope.User && $scope.User.name && $scope.User.name != '') {
         params.name = $scope.User.name;
         MyService.getUnVerifiedUser(params).then(function (response) {
           //  MyService.ConsoleLog("Response", response);
           $scope.statusGetResPg = 2;
           if (response.data.success) {
             //  MyService.ConsoleLog("Got users data: ", response.data.data);
             //$scope.verifyUsers = response.data.data;
             $scope.verifyUsers.data = $scope.verifyUsers.data.concat(response.data.data.data);
             $scope.totalUsers = response.data.data.data.totalRecords;
             $scope.statusVerifyUsers = 2;
           } else if (response.data.error && typeof response.data.error == "string") {
             growl.error('Error: ' + response.data.error);
             $scope.statusVerifyUsers = 3;
           } else {
             growl.error('Something went wrong.');
             $scope.statusVerifyUsers = 3;
           }
         }, function (err) {
           MyService.ConsoleLog("err", err);
         });
       } else {
         var request = apiCall.apiCall('GET', '/user/list-paginated', params);
         $http(
           request
         ).then(function successCallback(response) {
           $scope.statusGetResPg = 2;
           if (response.data.success) {
             MyService.ConsoleLog("Got users data: ", response.data.data);
             //$scope.verifyUsers = response.data.data;
             $scope.verifyUsers.data = $scope.verifyUsers.data.concat(response.data.data);
             //$scope.totalUsers = response.data.data.Count;
             $scope.statusVerifyUsers = 2;
           } else if (response.data.error && typeof response.data.error == "string") {
             growl.error('Error: ' + response.data.error);
             $scope.statusVerifyUsers = 3;
           } else {
             growl.error('Something went wrong.');
             $scope.statusVerifyUsers = 3;
           }
         }, function errorCallBack(response) {
           //MyService.ConsoleLog("Error: ", response);
           $scope.statusGetResPg = 2;
           $scope.statusVerifyUsers = 3;
         });
       }
     }

     $scope.myPagingFunction = function () {
       //MyService.ConsoleLog("scoll called");
       if ($scope.statusGetResPg != 1) {

         if ($scope.User && $scope.User.name && $scope.User.name != '') {
           if ($scope.totalUsers >= $scope.verifyUsers.data.length) {
             $scope.page++;
             $scope.listUsers($scope.page);
           }
         } else {
           if ($scope.verifySelectedUser != "") {
             $scope.page++;
             $scope.listUsers($scope.page);
           }
         }


       }
     };
     $scope.pgselectedType = "";
     $scope.getVerifyUsers = function (selectedType) {
       $scope.page = 1;
       $scope.verifyUsers.data.length = 0;
       $scope.verifySelectedUser = selectedType;

       $scope.listUsers($scope.page);
     };

     $scope.getVerifyFilterUsers = function (selectedType, selectedFilter) {
       $scope.page = 1;
       $scope.verifyUsers.data.length = 0;
       $scope.verifySelectedUser = selectedType;
       $scope.verifyFilter = selectedFilter;
       $scope.listUsers($scope.page);
     }

     $scope.verifyThisUser = function (user, index, val) {

       var postobj = {
         userid: user._id,
         verify: val
       };

       //MyService.ConsoleLog("postobj : ", postobj);

       var request = apiCall.apiCall('POST', "/user/verify-by-admin", postobj);
       $http(
         request
       ).then(function successCallback(response) {
         //  MyService.ConsoleLog("Got categories: ", response);
         if (response.data.success) {
           $scope.verifyUsers.data[index].verifieduser = val;
           growl.success("Verified Successfully");
         } else if (response.data.error && typeof response.data.error == "string") {
           growl.error('Error: ' + response.data.error);
         } else {
           growl.error('Something went wrong.');
         }
       }, function errorCallBack(response) {
         growl.error('Something went wrong.');
       });
     }

     //  $scope.getOrganizationDetail = function (user, index) {
     //    //MyService.ConsoleLog("getOrganizationDetail: ", index);
     //    var param = {
     //      id: user.officeId
     //    };
     //    //MyService.ConsoleLog("user: ", param);
     //    $scope.verifyUsers.data[index].organization = {
     //      status: 1
     //    };


     //    if (user.press == true || user.advocate == true) {

     //      MyService.getOfficeList(param).then(function (response) {
     //        //MyService.ConsoleLog("response: ", response);
     //        if (response.data.success) {
     //          $scope.verifyUsers.data[index].organization = response.data.data;
     //          $scope.verifyUsers.data[index].organization.status = 2;
     //        } else if (response.data.error && typeof response.data.error == "string") {
     //          growl.error('Error: ' + response.data.error);
     //          $scope.verifyUsers.data[index].organization.status = 3;
     //        } else {
     //          growl.error('Something went wrong.');
     //          $scope.verifyUsers.data[index].organization.status = 3;
     //        }
     //      }, function (err) {
     //        growl.error('Something went wrong.');
     //        $scope.verifyUsers.data[index].organization.status = 3;
     //      });
     //    }


     //    if (user.politician == true) {
     //      //if(user.officeId) {
     //      MyService.getOnePolitician(param).then(function (response) {
     //        //MyService.ConsoleLog("response: ", response);
     //        if (response.data.success) {
     //          $scope.verifyUsers.data[index].organization = response.data.data;
     //          $scope.verifyUsers.data[index].organization.status = 2;
     //        } else if (response.data.error && typeof response.data.error == "string") {
     //          growl.error('Error: ' + response.data.error);
     //          $scope.verifyUsers.data[index].organization.status = 3;
     //        } else {
     //          growl.error('Something went wrong.');
     //          $scope.verifyUsers.data[index].organization.status = 3;
     //        }
     //      }, function (err) {
     //        growl.error('Something went wrong.');
     //        $scope.verifyUsers.data[index].organization.status = 3;
     //      });

     //    }
     //  };

     $scope.searchUsers = function () {
       if ($scope.User && $scope.User.name && $scope.User.name != '') {
         MyService.ConsoleLog("$scope.User", $scope.User.name);
         $scope.page = 0;
         $scope.verifyUsers.data = [];
         $scope.totalUsers = [];
         $scope.myPagingFunction();
       }
     };
   }])

"use strict";
angular
  .module("myApp.userProfile", ["ngRoute"])
  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/userProfile/", {
        templateUrl: "app/userProfile/userProfile.html",
        reloadOnSearch: false,
        controller: "userProfileCtrl", //we can name anythin
      });
    },
  ])
  .controller("userProfileCtrl", [
    "$scope",
    "$http",
    "$location",
    "apiCall",
    "$rootScope",
    "baseApiUrl",
    "$q",
    "$filter",
    "growl",
    "ngDialog",
    "tokenService",
    "MyService",
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $rootScope,
      baseApiUrl,
      $q,
      $filter,
      growl,
      ngDialog,
      tokenService,
      MyService
    ) {
      switch ($rootScope.userRole) {
        case "admin":
          $scope.showProfile = true;
          break;
        case "politician":
          $scope.showPoliticianProfile = true;
          break;
        case "advocate":
          $scope.showOrganizationProfile = true;
          break;
        case "voter":
          $scope.showProfile = true;
          // $scope.showVoterProfile = true;
          break;
        default:
          console.log("Sorry, data not found");
      }
      // console.log("route params", $routeParams.type);
      // console.log("type", $rootScope.userRole);

      $scope.isShowMailingAddress = false;

      $scope.getMailingAddress = function (id) {
        MyService.ConsoleLog("is first call");

        MyService.getMailingAddress({
          userId: id,
        }).then(
          function (result) {
            MyService.ConsoleLog("Result", result);
            $scope.mainData = result.data.data;
            if (
              $scope.mainData &&
              $scope.mainData.address &&
              $scope.mainData.address.statePostalCode != ""
            ) {
              window.localStorage.removeItem("isFiveMinPage");

              $scope.isShowMailingAddress = true;
            } else {
              $scope.isShowMailingAddress = false;
            }
          },
          function (err) {
            MyService.ConsoleLog("Error >", err);
          }
        );
      };
      if (tokenService.getUserId()) {
        MyService.ConsoleLog(
          "tokenService.getUserId()",
          tokenService.getUserId()
        );
        $scope.getMailingAddress(tokenService.getUserId());
      }
      /********************************** User Name ************************************** */

      // $scope.username = angular.copy($rootScope.User);
      /****************************** End User Name******************************************/
      if (tokenService.getUserData()) {
        $scope.userData = JSON.parse(tokenService.getUserData());
        // $scope.emailID = $scope.userData.email;
        MyService.ConsoleLog(" $scope.userData >", $scope.userData);
        $scope.userAdd = $scope.userData.address;
      }

      $scope.changeEmailID = function (email, confirmEmail) {
        MyService.ConsoleLog("emai", email);
        MyService.ConsoleLog("confirmEmail", confirmEmail);

        if (email != "" && confirmEmail && confirmEmail != "") {
          MyService.ConsoleLog("typeof", typeof email);
          var chkEmail;
          if (typeof email == "object") {
            chkEmail = email[0];
          } else {
            chkEmail = email;
          }
          if (chkEmail == confirmEmail) {
            if (email != "") {
              var message =
                "When you hit “YES”, we will send an email to your new email address. For security, you will have 30 minutes to respond and complete the change or your account will stay with the old email address. Would you like to continue?";
              MyService.ConsoleLog("$scope.userMainData", $rootScope.userRole);

              var modal = ngDialog.openConfirm({
                template:
                  "<p>" +
                  message +
                  '</p>\
                              <div class="ngdialog-buttons">\
                                  <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">YES</button>\
                  <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">NO</button>\
                              </div>',
                plain: true,
              });
              modal.then(
                function fullfilled(data) {
                  //MyService.ConsoleLog("fullfilled: ", data);
                  MyService.changeEmailID({
                    email: email,
                    verificationurl: $rootScope.getVerificationUrl(),
                    unsubscribeurl: $rootScope.getEmailUnsubscribeUrl(),
                  }).then(
                    function (response) {
                      if (response.data.success) {
                        growl.success("Please check your email to verify it");
                        //tokenService.saveUserName($scope.username);
                      } else if (
                        response.data.error &&
                        typeof response.data.error == "string"
                      ) {
                        growl.error("Error: " + response.data.error);
                      } else {
                        growl.error("Something went wrong.");
                      }
                    },
                    function (err) {
                      growl.error("Something went wrong");
                    }
                  );
                },
                function rejected(data) {
                  //MyService.ConsoleLog("rejected: ", data);
                }
              );
            }
          } else {
            var message = "Email addresses don't match";
            var modal = ngDialog.openConfirm({
              template:
                "<p>" +
                message +
                '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Okay</button>\
              </div>',
              plain: true,
            });
            modal.then(
              function fullfilled(data) {
                //MyService.ConsoleLog("fullfilled: ", data);
              },
              function rejected(data) {
                //MyService.ConsoleLog("rejected: ", data);
              }
            );
          }
        } else {
          var message = "Please enter confirm email";
          var modal = ngDialog.openConfirm({
            template:
              "<p>" +
              message +
              '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Okay</button>\
              </div>',
            plain: true,
          });
          modal.then(
            function fullfilled(data) {
              //MyService.ConsoleLog("fullfilled: ", data);
            },
            function rejected(data) {
              //MyService.ConsoleLog("rejected: ", data);
            }
          );
        }
      };

      $scope.updateAddress = function () {
        $scope.UpdateAddressLoader = true;
        MyService.getProfile($rootScope.UserId).then(
          function (data) {
            // body...
            var address_data = data.address;
            address_data.zipcode = data.zipcode;
            data.address.flag = "userProfile";
            MyService.ConsoleLog("********* Data: ", data.address);
            ngDialog.open({
              template: "app/popups/user_localupdate.html",
              data: data.address,
              // className: 'ngdialog-theme-default'
            });
            $scope.UpdateAddressLoader = false;
          },
          function (err) {
            //MyService.ConsoleLog("********* err: ", err);
            $scope.UpdateAddressLoader = false;
          }
        );
      };

      $scope.changePassword = function (
        old_password,
        password,
        confirm_password
      ) {
        MyService.resetPassword({
          old_password: old_password,
          password: password,
          confirm_password: confirm_password,
        }).then(
          function (response) {
            if (response.data.success) {
              growl.success("Updated successfully.");
              MyService.ConsoleLog(" updated password :", response);
              // tokenService.saveUserName($scope.username);
            } else if (
              response.data.error &&
              typeof response.data.error == "string"
            ) {
              growl.error("Error: " + response.data.error);
            } else {
              growl.error("Something went wrong.");
            }
          },
          function (err) {
            growl.error("Something went wrong");
          }
        );
      };
      $scope.allSource = [];

      $scope.getNewsSources = function () {
        $scope.allSource.length = 0;
        MyService.getNewsSource().then(
          function (payload) {
            MyService.ConsoleLog("payload", payload);
            // alert("call");
            $scope.allSource = payload;
            MyService.ConsoleLog("$scope.mainData", $scope.mainData);
            if ($scope.mainData) {
              $scope.newsChannel = $scope.mainData.myFavChannel;
            }
          },
          function (errorPayload) {
            //MyService.ConsoleLog(errorPayload);
            growl.error("News services down currently.");
          }
        );
      };

      $scope.changeNewsChannel = function (channel) {
        //alert(channel);
        MyService.saveFavChannel({
          channel: channel,
        }).then(
          function (payload) {
            //MyService.ConsoleLog(payload);
            $scope.userData.my_fav_channel = channel;
            tokenService.saveUserData(JSON.stringify($scope.userData));
            growl.success("Your favorite channel saved successfully.");
          },
          function (errorPayload) {
            growl.error("Something went wrong while saving the favorites.");
          }
        );
      };

      $scope.fivefb = {
        title: "",
        description: "",
        files: "",
      };

      $scope.getFiveFacebookPost = function (data) {
        MyService.getFiveFacebookPost().then(
          function (payload) {
            MyService.ConsoleLog(payload);
            if (payload.data.success) {
              $scope.fivefb.title = payload.data.data.fbTitle;
              $scope.fivefb.description = payload.data.data.fbDescription;
              if (payload.data.data.fbImage) {
                $scope.fbFiveImage =
                  baseApiUrl + "/resources/" + payload.data.data.fbImage;
              }
            } else {
              growl.error("Something went wrong.");
            }
          },
          function (errorPayload) {
            growl.error("Something went wrong.");
          }
        );
      };

      $scope.changeFacebookPost = function (data) {
        //alert(channel);
        var fd = new FormData();
        fd.append("title", $scope.fivefb.title);
        fd.append("description", $scope.fivefb.description);
        if ($scope.fivefb.files) {
          fd.append("file", $scope.fivefb.files);
        }

        var posturl = baseApiUrl + "/user/saveFiveFacebookPost";
        $http({
          method: "POST",
          url: posturl,
          // headers: { 'Content-Type': false },
          headers: {
            "Content-Type": undefined,
          },
          transformRequest: angular.identity,
          //Create an object that contains the model and files which will be transformed
          // in the above transformRequest method
          data: fd,
        }).then(
          function (data, status, headers, config) {
            //MyService.ConsoleLog("success data: ", data);
            if (data.data.success) {
              growl.success("Updated successfully.");
            } else if (data.data.error && typeof data.error == "string") {
              growl.error("Error: " + data.error);
            } else {
              growl.error("Something went wrong.");
            }
          },
          function (data, status, headers, config) {
            //MyService.ConsoleLog("error >> ", data);
            growl.error("Something went wrong.");
          }
        );
      };
      $scope.getNewsSources();

      /**
       * Filter new data
       */

      // $scope.search = function () {
      //   return function (u) {
      //     // MyService.ConsoleLog("u", u);
      //     if (u.name.toLowerCase() == $scope.mainData.myFavChannel) {
      //       return u;
      //     } else {
      //       return u;
      //     }
      //   };
      // };

      if ($rootScope.showProfile || $rootScope.showPoliProfile) {
        $scope.getFiveFacebookPost();
      }
    },
  ])
  .controller("MyProfileCtrl", [
    "$scope",
    "$http",
    "$location",
    "apiCall",
    "$routeParams",
    "$rootScope",
    "$q",
    "$timeout",
    "growl",
    "tokenService",
    "ngDialog",
    "baseApiUrl",
    "$anchorScroll",
    "MyService",
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $rootScope,
      $q,
      $timeout,
      growl,
      tokenService,
      ngDialog,
      baseApiUrl,
      $anchorScroll,
      MyService
    ) {
      //MyService.ConsoleLog("** MyProfileCtrl **");

      $scope.userId = tokenService.getUserId();
      $scope.UpdateAddressLoader = false;
      $scope.selectedCat = [];
      $scope.SelectedTree = [];
      $scope.disabled = [];
      $scope.Allcountries = [];
      $scope.SelectedCountry = "";
      $scope.newlocation = {
        country: "",
      };
      $scope.profile = {
        orgData: {
          description: "",
          typeOfOrg: "",
        },
      };
      $scope.subtopics = {
        subcategories: [],
      };

      $scope.Essay = {
        location: "",
        subcategories: [],
      };

      $scope.ShowAddLocation = function () {
        if (!$scope.AddLocation) {
          $scope.AddLocation = true;
        } else {
          $scope.AddLocation = false;
        }
      };

      $scope.getProfile = function () {
        MyService.ConsoleLog("getProfile : ", $scope.userId);
        // alert('called');
        MyService.getProfile($scope.userId).then(
          function (payload) {
            MyService.ConsoleLog("Got New Data: ", payload);
            $scope.userMainData = payload;
            var userdata = payload;
            $scope.profile = userdata;
            $scope.emailID = payload.email;
            $scope.username = payload.username;
            if (userdata && userdata.campaignInfo.length > 0) {
              $scope.profile.campwebUrl =
                userdata.campaignInfo[0].campaignWeburl;
              $scope.profile.campEmail = userdata.campaignInfo[0].campaignEmail;
              $scope.profile.campPhone = userdata.campaignInfo[0].campaignPhone;
              $scope.profile.campaignFburl =
                userdata.campaignInfo[0].campaignFburl;
            }
            if ($scope.userData.my_fav_channel) {
              $scope.newsChannel = $scope.userData.my_fav_channel;
            }
            MyService.ConsoleLog("typeOfOrg", userdata.typeOfOrg);
            if (userdata.typeOfOrg && userdata.typeOfOrg != "") {
              $scope.profile.typeOfOrg = userdata.typeOfOrg;
            }
            $scope.profileData = userdata.politicianInfo;
            MyService.ConsoleLog(
              "Got New ProfileData: ",
              $scope.profileData.length
            );

            $scope.getAllStates();
            //MyService.ConsoleLog("Essay : ", subcatdata);
            //MyService.ConsoleLog("address:", userdata.address);
            if (userdata.address && userdata.address.state) {
              $scope.profile.state = {
                state: userdata.address.state,
                statePostalCode: userdata.address.statePostalCode,
              };
              $scope.getCounties($scope.profile.state, "address");

              $scope.profile.county = {
                state: userdata.address.state,
                statePostalCode: userdata.address.statePostalCode,
                county: userdata.address.county,
              };
              $scope.getLocals(
                $scope.profile.state,
                $scope.profile.county,
                "address"
              );
            }

            var locations = userdata.locationOfInterest;
            MyService.ConsoleLog("locations", locations);
            var catArr = userdata.subjectOfInterest;
            //MyService.ConsoleLog(catArr[0].split(","));
            $scope.disabled = userdata.subjectOfDeepInterests;
            $scope.SelectedTree = userdata.subjectOfInterests;
            //MyService.ConsoleLog($scope.disabled);

            var nobj = {
              country: "National (USA)",
            };
            var idx = indexOfExt($scope.selectedArea, nobj);
            if (idx > -1) {
              $scope.selectedArea.splice(idx, 1);
            }
            var len = 0;
            if (locations) {
              len = locations.length;
            }

            $scope.selectedArea.length = 0;
            $scope.showSubCat = true;
            $scope.disabledLocation.length = 0;
            for (var l = 0; l < len; l++) {
              var nobj = {};
              if (locations[l].country) {
                if (locations[l].country == "National (USA)") {
                  $scope.Essay.National = "National";
                }
                if (locations[l].country == "International") {
                  $scope.Essay.Locations = "International";
                }
                nobj.country = locations[l].country;
              }
              if (locations[l].state) {
                nobj.state = locations[l].state;
                nobj.statePostalCode = locations[l].statePostalCode;
              }
              if (locations[l].county) {
                nobj.county = locations[l].county;
              }
              if (locations[l].countySubdivision) {
                nobj.countySubdivision = locations[l].countySubdivision;
              }
              if (locations[l].place) {
                nobj.place = locations[l].place;
              }
              $scope.selectedArea.push(nobj);
              $scope.disabledLocation.push(nobj);
            }

            $scope.getSubcatTree();
          },
          function (errorPayload) {
            growl.error("Something went wrong.");
          }
        );
      };
      $scope.changeUsername = function (username) {
        MyService.changeUsername({
          username: username,
        }).then(
          function (response) {
            if (response.data.success) {
              growl.success("Updated successfully.");
              // MyService.ConsoleLog("username", username);
              // MyService.ConsoleLog("$scope.username", $scope.username);

              tokenService.saveUserName(username);
              window.location.reload();
              // MyService.ConsoleLog("token", tokenService.getUserName());
            } else if (
              response.data.error &&
              typeof response.data.error == "string"
            ) {
              growl.error("Error: " + response.data.error);
            } else {
              growl.error("Something went wrong.");
            }
          },
          function (err) {
            growl.error("Something went wrong");
          }
        );
      };
      $scope.getFilter = function () {
        return function (u) {
          // MyService.ConsoleLog("Filter >>>>>>", u);
          if (
            u.incumbent != "incumbent" ||
            (u.incumbent == "Incumbent" && u.runningForOffice != "N")
          ) {
            return u;
          }
        };
      };

      // getData

      $scope.getData = function () {
        return function (u) {
          // MyService.ConsoleLog("Filter >>>>>>", u);
          if (
            u.incumbent == "incumbent" ||
            (u.incumbent == "Incumbent" && u.runningForOffice == "Y")
          ) {
            return u;
          } else if (u.incumbent == "incumbent" || u.incumbent == "Incumbent") {
            return u;
          }
        };
      };

      function suggest_country(term) {
        var q = term.toLowerCase().trim();
        var results = [];
        var len = $scope.Allcountries.length;
        // Find first 10 states that start with `term`.
        for (var i = 0; i < len && results.length < 10; i++) {
          var country = $scope.Allcountries[i];
          if (country.toLowerCase().indexOf(q) === 0)
            results.push({
              label: country,
              value: country,
            });
        }
        return results;
      }

      $scope.autocomplete_options = {
        suggest: suggest_country,
      };

      $scope.getAllStates = function () {
        MyService.getAllStates().then(
          function (payload) {
            $scope.allLocations.length = 0;
            var subcatdata = payload;
            //MyService.ConsoleLog("Sub states : ", subcatdata);
            $scope.allLocations = subcatdata;
            //MyService.ConsoleLog($scope.profile.address);
            //MyService.ConsoleLog($scope.profile.address.state);
            if ($scope.profile.address && $scope.profile.address.state) {
              var chkdata = $scope.checkExists(
                subcatdata,
                $scope.profile.address.state
              );
              //MyService.ConsoleLog("State check item :", chkdata[0]);
              if (chkdata != "") {
                chkdata[0].country = "United States of America";
                //MyService.ConsoleLog(JSON.stringify(chkdata[0]));
                $scope.profile.state = JSON.stringify(angular.copy(chkdata[0]));
              }
            }
          },
          function (errorPayload) {
            growl.error("Something went wrong.");
          }
        );
      };

      $scope.getVal = function (data) {
        MyService.ConsoleLog("gggg", data);
        var idx = $scope.selectedCat.indexOf(data);
        if (idx > -1) {
          $scope.selectedCat.splice(idx, 1);
          var id = $scope.disabled.indexOf(data._id);
          $scope.disabled.splice(id, 1);
          var jdx = $scope.SelectedTree.indexOf(data.parentIds);
          if (jdx > -1) $scope.SelectedTree.splice(jdx, 1);
        } else {
          $scope.selectedCat.push(data);
          var id = $scope.disabled.indexOf(data._id);
          if (id == -1) {
            $scope.disabled.push(data._id);
          }
          //MyService.ConsoleLog(data.parentIds);
          //MyService.ConsoleLog("SelectedTree: ", $scope.SelectedTree);
          if ($scope.SelectedTree && $scope.SelectedTree.length == 0) {
            if (data.parentIds.length > 0) {
              //var parents = Object.keys(data.parentIds).map(function (key) {return data.parentIds[key]});
              //angular.copy(data.parentIds, $scope.SelectedTree);
              var parents = data.parentIds;
              //MyService.ConsoleLog(parents);
              $scope.SelectedTree = parents;
            }
          } else {
            if (data.parentIds.length > 0) {
              //var parents = Object.keys(data.parentIds).map(function (key) {return data.parentIds[key]});
              //var parents = angular.copy(data.parentIds);
              var parents = data.parentIds;
              var plen = parents.length;
              for (var j = 0; j < plen; j++) {
                $scope.SelectedTree.push(parents[j]);
              }
            }
          }
        }
        //MyService.ConsoleLog($scope.SelectedTree);
      };

      $scope.selectedAll = {
        id: [],
      };
      $scope.removeVal = function (data) {
        var idx = $scope.selectedCat.indexOf(data);
        if (idx > -1) {
          $scope.selectedCat.splice(idx, 1);
          var id = $scope.disabled.indexOf(data._id);
          $scope.disabled.splice(id, 1);
          var parents = data.parentIds;
          var plen = parents.length;
          for (var j = 0; j < plen; j++) {
            var jdx = $scope.SelectedTree.indexOf(parents[j]);
            if (jdx > -1) $scope.SelectedTree.splice(jdx, 1);
          }
        }
        $scope.selectedAll.id.length = 0;
        //MyService.ConsoleLog($scope.SelectedTree);
        var allLen = $scope.SelectedTree.length;
        var chkboxe = document.getElementsByName("checkedidcat");
        for (var i = 0; i < allLen; i++) {
          chkboxe[i].checked = true;
        }
      };

      $scope.selectConfig = {
        requiredMin: 1,
        selectAll: true,
      };

      $scope.checksubCatExists = function (rdata, val) {
        return rdata.filter(function (rdata) {
          if (rdata._id == val) return rdata;
          else if (rdata.subCategories) {
            $scope.checksubCatExists(rdata.subcategories, val);
          }
        });
      };

      $scope.checkCatExists = function (rdata, val) {
        return rdata.filter(function (rdata) {
          if (rdata._id == val) {
            $scope.selectedCat.push(rdata);
            return rdata;
          } else if (rdata.subcategories) {
            $scope.checkCatExists(rdata.subcategories, val);
          }
        });
      };
      $scope.SaveButton = true;
      $scope.getSubcatTree = function () {
        // console.log("subcat");
        $scope.selectedCat.length = 0;
        $scope.SaveButton = true;

        MyService.getAllCatTree({
          type: "E",
        }).then(
          function (payload) {
            $scope.subtopics.subcategories.length = 0;
            var subcatdata = payload;
            // MyService.ConsoleLog("subcatdata : ", subcatdata);
            $scope.subtopics.subcategories = subcatdata;
            var selectedCat = $scope.disabled;
            MyService.ConsoleLog("$scope.disabled", selectedCat);
            if (selectedCat && selectedCat.length > 0) {
              for (var s = 0; s < selectedCat.length; s++) {
                var checkcatdata = $scope.checkCatExists(
                  subcatdata,
                  selectedCat[s]
                );
              }
              var filterCatData = $scope.selectedCat.filter(function (
                itm,
                index
              ) {
                return (
                  index ==
                  $scope.selectedCat.findIndex(function (ele) {
                    return JSON.stringify(ele) == JSON.stringify(itm);
                  })
                );
              });
              // MyService.ConsoleLog("filtered Data", filterCatData);
              $scope.selectedCat = "";
              $scope.selectedCat = filterCatData;
              MyService.ConsoleLog("now", $scope.selectedCat);
            }
            $scope.SaveButton = false;
            setTimeout(function () {
              var cols = document.getElementsByClassName("cmnUL");
              var clen = cols.length;
              for (var i = 0; i < clen; i++) {
                cols[i].style.display = "none";
              }
            }, 300);
          },
          function (errorPayload) {
            growl.error("Something went wrong.");
          }
        );
      };
      $scope.allLocations = [];
      $scope.allCounties = [];
      $scope.selectedArea = [];
      $scope.rmselectedArea = [];
      $scope.myselectionarea = [];
      $scope.disabledLocation = [];

      $scope.checkExists = function (rdata, val) {
        return rdata.filter(function (rdata) {
          if (rdata.state == val) return rdata;
        });
      };

      $scope.checkCountyExists = function (rdata, val) {
        return rdata.filter(function (rdata) {
          if (rdata._id.county == val) return rdata._id;
        });
      };

      $scope.checkCountryExists = function (rdata, val) {
        return rdata.filter(function (rdata) {
          if (rdata.country == val) return rdata;
        });
      };

      $scope.checkLocalExists = function (rdata, val, val1) {
        MyService.ConsoleLog("filter :", val);
        if (rdata && rdata.length > 0) {
          return rdata.filter(function (rdata) {
            if (rdata._id.place == val && rdata._id.countySubdivision == val1)
              return rdata._id;
          });
        }
      };

      function areEqual() {
        var len = arguments.length;
        for (var i = 1; i < len; i++) {
          if (arguments[i] == null || arguments[i] != arguments[i - 1])
            return false;
        }
        return true;
      }

      function indexOfExt(list, item) {
        var len = list.length;
        for (var i = 0; i < len; i++) {
          var keys = Object.keys(list[i]);
          var flg = true;
          var arr = [];
          for (var j = 0, s = 1; j < keys.length; j++, s++) {
            var value = list[i][keys[j]];
            if (item[keys[j]] !== value) {
              flg = false;
            }
            if (item[keys[j]] == value) {
              arr.push(flg);
            }
          }
          if (flg == true) {
            if (areEqual(arr.length, keys.length, Object.keys(item).length)) {
              return i;
            }
          }
        }
        return -1;
      }

      $scope.checkDisabled = function (data, stateId, type) {
        data.country = "United States of America";
        data.state = stateId;
        var idx = indexOfExt($scope.disabledLocation, data);
        if (idx > -1) return true;
        else return false;
      };

      $scope.getAreaVal = function (data, stateId, type) {
        if (!data.country) {
          data.country = "United States of America";
        }
        if (!data.state) {
          data.state = stateId;
        }

        switch (type) {
          case "county":
            MyService.ConsoleLog("county", data);
            var tempData = data;
            data.county = tempData.countyName;
            MyService.ConsoleLog("data", data);
            break;
          case "local":
            var onTemp = data;
            data.place = onTemp.placeName;
            break;
          default:
            MyService.ConsoleLog("default");
            break;
        }

        var idx = indexOfExt($scope.selectedArea, data);

        if (idx > -1) {
          growl.error("You have already selected the location");
        } else {
          // alert('new');
          $scope.selectedArea.push(data);
          $scope.disabledLocation.push(data);
          MyService.ConsoleLog("now link", $scope.selectedArea);
        }

        //MyService.ConsoleLog($scope.disabledLocation);
      };
      $scope.selectedLAll = {
        id: [],
      };

      $scope.removeAreaVal = function (data) {
        var idx = $scope.selectedArea.indexOf(data);

        //MyService.ConsoleLog($scope.Essay.Locations);
        if (idx > -1) {
          //MyService.ConsoleLog("Country:",$scope.selectedArea[idx].country);
          if ($scope.selectedArea[idx].country == "International") {
            $scope.Essay.Locations = "NO";
          }
          if ($scope.selectedArea[idx].country == "National (USA)") {
            $scope.Essay.National = "NO";
          }
          $scope.selectedArea.splice(idx, 1);
          var jdx = $scope.disabledLocation.indexOf(data);
          if (jdx > -1) {
            $scope.disabledLocation.splice(jdx, 1);
          }
        }
        $scope.selectedLAll.id.length = 0;
        //MyService.ConsoleLog($scope.selectedArea);
        var allLen = $scope.SelectedTree.length;
        var chkboxe = document.getElementsByName("checkedid");
        for (var i = 0; i < allLen; i++) {
          chkboxe[i].checked = true;
        }
      };
      $scope.allCounties = [];
      $scope.allLocals = [];
      $scope.setLocation = function (option) {
        $scope.Essay.location = option;
      };
      $scope.getLocations = function (val, type) {
        if (type == "National") {
          if (val == "National") {
            var nobj = {
              country: "National (USA)",
            };
            $scope.selectedArea.push(nobj);
            //MyService.ConsoleLog($scope.selectedArea);
          }
          if (val == "NO") {
            var nobj = {
              country: "National (USA)",
            };
            var idx = indexOfExt($scope.selectedArea, nobj);
            if (idx > -1) {
              $scope.selectedArea.splice(idx, 1);
            }
          }
        } else if (type == "International") {
          if (val == "International") {
            // $scope.selectedArea.length = 0;
            var nobj = {
              country: "International",
            };
            $scope.selectedArea.push(nobj);
          }

          if (val == "NO") {
            // $scope.selectedArea.length = 0;
            var nobj = {
              country: "International",
            };

            var idx = indexOfExt($scope.selectedArea, nobj);
            if (idx > -1) {
              $scope.selectedArea.splice(idx, 1);
            }
          }
        }
      };

      $scope.AddCountry = function () {
        if ($scope.newlocation.country && $scope.newlocation.country != "") {
          var idx = $scope.Allcountries.indexOf($scope.newlocation.country);
          if (idx > -1) {
            var nobj = {
              country: $scope.newlocation.country,
            };
            $scope.selectedArea.push(nobj);
          } else {
            alert(
              "Country does not exists in our database. Please check if you have entered correct name."
            );
          }
        } else {
          alert("Please enter country name");
        }
      };
      $scope.MyCounties = [];
      $scope.MyPlaces = [];
      $scope.getCounties = function (state, val) {
        if (val != "address") $scope.showLoading.push(state);

        if (val != "address") {
          if (
            !$scope.allCounties[state] ||
            $scope.allCounties[state].length == 0
          ) {
            MyService.getAllCounties(state).then(
              function (payload) {
                MyService.ConsoleLog("sublocations payload : ", payload);
                $scope.showLoading.length = 0;
                var sublocations = payload;
                MyService.ConsoleLog("sublocations counties : ", sublocations);
                if (!$scope.allCounties) {
                  $scope.allCounties = [];
                }
                $scope.allCounties[state] = sublocations;
              },
              function (errorPayload) {
                growl.error("Something went wrong.");
              }
            );
          } else {
            $scope.showLoading.length = 0;
            $scope.allCounties[state].length = 0;
          }
        } else if (val == "address") {
          if (typeof $scope.profile.state == "string") {
            var data = JSON.parse($scope.profile.state);
          } else {
            var data = $scope.profile.state;
          }
          var statePostalCode = data.statePostalCode;
          if (
            !data.statePostalCode ||
            data.statePostalCode == null ||
            data.statePostalCode == "null"
          ) {
            //MyService.ConsoleLog($scope.allLocations);
            //MyService.ConsoleLog(data.state);
            var chkData = $scope.checkExists($scope.allLocations, data.state);
            //MyService.ConsoleLog("chkData : ", chkData[0]);
            if (chkData[0]) {
              statePostalCode = chkData[0].statePostalCode;
            }
          }
          //MyService.ConsoleLog("statePostalCode:", statePostalCode);

          $scope.MyCounties.length = 0;
          MyService.getAllCounties(statePostalCode).then(
            function (payload) {
              //MyService.ConsoleLog("sublocations Locals : ", sublocations);
              $scope.showLoading.length = 0;
              $scope.MyCounties = payload;
              //MyService.ConsoleLog("getCounty checkdata: ", $scope.profile.address.county);
              if ($scope.profile.address.county) {
                var chkdata = $scope.checkCountyExists(
                  payload,
                  $scope.profile.address.county
                );
                //MyService.ConsoleLog("getCounty checkdata: ", chkdata);
                if (chkdata != "") {
                  $scope.profile.county = JSON.stringify(
                    angular.copy(chkdata[0]._id)
                  );
                }
              }
            },
            function (errorPayload) {
              growl.error("Something went wrong.");
            }
          );
        }
      };

      $scope.getLocals = function (state, county, val) {
        //MyService.ConsoleLog("state : " + state + ", county :" + county + ", val :" + val)
        if (val != "address") $scope.showLoadingCounty.push(county);
        if (val == "address") {
          $scope.MyPlaces.length = 0;
          if (typeof $scope.profile.state == "string") {
            var sdata = JSON.parse($scope.profile.state);
          } else {
            var sdata = $scope.profile.state;
          }
          if (typeof $scope.profile.county == "string") {
            var cdata = JSON.parse($scope.profile.county);
          } else {
            var cdata = $scope.profile.county;
          }
          MyService.getAllSubCountiesLocal(
            sdata.statePostalCode,
            cdata.county
          ).then(
            function (payload) {
              $scope.MyPlaces = payload;
              MyService.ConsoleLog("PlaCE :", $scope.MyPlaces);
              if ($scope.profile.address.place) {
                var chkdata = $scope.checkLocalExists(
                  payload,
                  $scope.profile.address.place,
                  $scope.profile.address.countySubdivision
                );
                // MyService.ConsoleLog('getLocal checkdata: ', chkdata[0]);
                if (chkdata && chkdata.length > 0) {
                  var idx = $scope.MyPlaces.indexOf(chkdata[0]);
                  //MyService.ConsoleLog(idx);
                  //MyService.ConsoleLog(angular.copy($scope.MyPlaces[idx]._id));
                  $scope.profile.places = JSON.stringify(
                    angular.copy($scope.MyPlaces[idx]._id)
                  );
                }
              }
            },
            function (errorPayload) {
              growl.error("Something went wrong.");
            }
          );
        } else {
          if (
            !$scope.allLocals[state] ||
            !$scope.allLocals[state][county] ||
            $scope.allLocals[state][county] == 0
          ) {
            MyService.getAllSubCountiesLocal(state, county).then(
              function (payload) {
                $scope.showLoadingCounty.length = 0;
                //MyService.ConsoleLog("sublocations Locals : ", sublocations);
                if (!$scope.allLocals[state]) {
                  $scope.allLocals[state] = [];
                }
                // alert('caalle');
                MyService.ConsoleLog("payload", payload.places.length);
                var plFil = payload.places.filter(function (item) {
                  // MyService.ConsoleLog('item', item);
                  var smTxt = item.placeName.substring(
                    item.placeName.length - 3
                  );
                  if (smTxt != "CDP") {
                    return item;
                  }
                });
                MyService.ConsoleLog("plFil >>", plFil.length);
                $scope.allLocals[state][county] = plFil;
              },
              function (errorPayload) {
                growl.error("Something went wrong.");
              }
            );
          } else {
            $scope.showLoadingCounty.length = 0;
            $scope.allLocals[state][county] = 0;
          }
        }
      };

      $scope.showSubCat = false;
      $scope.showLoading = [];
      $scope.showLoadingCounty = [];
      $scope.showDown = [];
      $scope.ChangeShow = function (id) {
        $scope.showSubCat = true;
        var cols = document.getElementsByClassName("cmnUL");
        var clen = cols.length;
        var nclass = "MainCatLi_" + id;
        if (
          document.getElementsByClassName(nclass)[0].style.display &&
          document.getElementsByClassName(nclass)[0].style.display == "none"
        ) {
          document.getElementsByClassName(nclass)[0].style.display = "block";
        } else {
          document.getElementsByClassName(nclass)[0].style.display = "none";
        }
      };

      $scope.checkTagsExists = function (rdata, val) {
        return rdata.filter(function (rdata) {
          if (rdata.pid == val) return rdata;
        });
      };

      $scope.updateProfile = function (data) {
        // MyService.ConsoleLog('Update profile:', data.orgData);
        // return
        // MyService.ConsoleLog('$scope', data.campaignInfo);
        data.userId = $scope.userId;
        data.phone = $scope.mainData.phone;
        data.publicEmail = $scope.profile.publicEmail;
        if (data.extensionNo && data.extensionNo != "undefined") {
          data.extensionNo = data.extensionNo;
        }

        MyService.ConsoleLog("Update profile:", data);
        if (data.orgData && data.orgData != "") {
          data.typeOfOrg = data.orgData.typeOfOrg;
          data.phone_no = data.orgData.phone_no;

          // alert(data.orgData.speciality);
          if (
            data.orgData.speciality == undefined &&
            data.orgData.speciality != null
          ) {
            growl.error("You can enter 100 characters only");
            // data.orgData.speciality = '';
            return;
          }
        }

        // data.type = 'advocate';
        data.type = $rootScope.userRole; //this is organizatino type
        if ($scope.SelectedTree) {
          data.tags = JSON.stringify($scope.SelectedTree);
        }
        if (data.donationLink && data.donationLink != "") {
          // MyService.ConsoleLog('data', data.donationLink.indexOf('https'));
          // MyService.ConsoleLog("data", data.donationLink.indexOf("http"));

          if (data.donationLink.indexOf("http") == -1) {
            // MyService.ConsoleLog('If');
            var smp = "http://" + data.donationLink;
            // MyService.ConsoleLog('smp', smp);
            data.donationLink = "";
            data.donationLink = smp;
            // MyService.ConsoleLog(' data.donationLink', data.donationLink);
          }
        }
        if (data.orgData && data.orgData.webUrl) {
          if (data.orgData.webUrl.indexOf("http") == -1) {
            // MyService.ConsoleLog("If");
            var smpw = "http://" + data.orgData.webUrl;
            MyService.ConsoleLog("smpw", smpw);
            data.webUrl = "";
            data.webUrl = smpw;
            MyService.ConsoleLog(" data.webUrl", data.webUrl);
          }
        }
        // MyService.ConsoleLog('Update profile:', data.orgData);

        // console.log('data.webUrl :>> ', data.webUrl);
        // console.log('data.orgData.webUrl:>> ', data.orgData.webUrl);
        // return;
        if (data.campwebUrl && data.campwebUrl) {
          if (data.campwebUrl.indexOf("http") == -1) {
            // MyService.ConsoleLog("If");
            var scamp = "http://" + data.campwebUrl;
            // MyService.ConsoleLog('smpw', smpw);
            data.campwebUrl = "";
            data.campwebUrl = scamp;
            MyService.ConsoleLog(" data.webUrl", data.campwebUrl);

            data.campaignWeburl = data.campwebUrl;
          } else {
            data.campaignWeburl = data.campwebUrl;
          }
        }

        // MyService.ConsoleLog("$scope.selectedArea", $scope.selectedArea);
        data.subject_of_deep_interest = JSON.stringify($scope.disabled);
        data.locations = JSON.stringify($scope.selectedArea);
        data.orgData = JSON.stringify(data.orgData);
        var places = null;
        var states = null;
        if (data.places) {
          places = JSON.parse(data.places);
        }
        if (data.state) {
          states = JSON.parse(data.state);
        }
        var address = null;
        if (places) {
          address = {
            countySubdivision: places.countySubdivision,
            county: places.county,
            statePostalCode: places.statePostalCode,
            place: places.place,
          };
          if (states) address.state = states.state;
        }
        // if (states && address == null) address = {
        //   state: states.state
        // };
        // data.compa
        // MyService.ConsoleLog('data : ', data);

        data.address = JSON.stringify(address);
        data.politicianInfo = JSON.stringify(data.politicianInfo);
        // MyService.ConsoleLog('data: ', data);
        data.campaignInfo = JSON.stringify(data.campaignInfo);
        // MyService.ConsoleLog("<<<<<<< new sir >>>>>>>>", JSON.parse(data.orgData));
        $scope.statusUpdateProfile = 1;
        MyService.updateProfile(data).then(
          function (payload) {
            MyService.ConsoleLog("payload: ", payload);
            var userdata = tokenService.getUserData();
            MyService.ConsoleLog("userData: ", userdata);
            data.politicianInfo = JSON.parse(data.politicianInfo);
            userdata = JSON.parse(userdata);
            // userdata.address = JSON.parse(data.address);
            (userdata.subject_of_deep_interest = $scope.disabled),
              (userdata.subject_of_interest = $scope.SelectedTree),
              (userdata.location_of_interest = $scope.selectedArea),
              tokenService.saveUserData(JSON.stringify(userdata));
            try {
              data.orgData = JSON.parse(data.orgData);
            } catch (e) {
              //MyService.ConsoleLog("Org data parse error: ", e);
            }
            $scope.statusUpdateProfile = 2;
            growl.success("Profile updated successfully.");
          },
          function (errorPayload) {
            $scope.statusUpdateProfile = 3;
            growl.error("Something went wrong.");
          }
        );
      };

      $scope.editPoliticianOffice = function (index) {
        var officeObj = $scope.profile.politician_info[index];
        //MyService.ConsoleLog("editPoliticianOffice: ", officeObj);
        ngDialog.open({
          template: "app/popups/update_politician_office.html",
          scope: $scope,
          data: officeObj,
        });
      };

      $scope.addPoliticianOffice = function () {
        //var officeObj = $scope.profile.politician_info[index];
        //MyService.ConsoleLog("editPoliticianOffice: ", officeObj);
        ngDialog.open({
          template: "app/popups/update_politician_office.html",
          scope: $scope,
        });
      };

      $scope.updateAddress = function () {
        $scope.UpdateAddressLoader = true;
        MyService.getProfile($rootScope.UserId).then(
          function (data) {
            // body...
            var address_data = data.address;
            MyService.ConsoleLog("data", data.zipcode);

            // address_data.zipcode = data.zipcode;

            // }
            // data.address = {
            //   "loca": {
            //     "coordinates": []
            //   },
            //   "place": "Allentown",
            //   "countyFips": "",
            //   "county": "Lehigh",
            //   "countySubdivisionFips": "",
            //   "countySubdivision": "Allentown",
            //   "statePostalCode": "PA",
            //   "state": "Pennsylvania",
            //   "country": "United States",
            //   "federalCongrassionalDist": "07",
            //   "stateSenateDistrict": "016",
            //   "schoolDistrictFips": "02280",
            //   "schoolDistrict": "Allentown City School District",
            //   "legislativeDistrict": "22"
            // }

            // data.address.zipcode = "18102";
            // if (data.zipcode && data.zipcode != "") {
            //   data.address.zipcode = data.zipcode;
            // }
            try {
              MyService.ConsoleLog("********* Data: ", data.address);

              data.address.flag = "userProfile";
              MyService.ConsoleLog("********* Data: ", data.address);
            } catch (err) {}

            ngDialog.open({
              template: "app/popups/user_localupdate.html",
              data: data.address,
              // className: 'ngdialog-theme-default'
            });
            $scope.UpdateAddressLoader = false;
          },
          function (err) {
            //MyService.ConsoleLog("********* err: ", err);
            $scope.UpdateAddressLoader = false;
          }
        );
      };

      $scope.getProfile();

      MyService.getAllCountries().then(
        function (payload) {
          $scope.Allcountries = payload;
        },
        function (errorPayload) {
          growl.error("Something went wrong.");
        }
      );
      // }
      $rootScope.$on("UserProfileUpdated", function (event, data) {
        //MyService.ConsoleLog(data);
        $scope.getProfile();
      });
    },
  ]);

'use strict';
angular.module('myApp.uploadPress', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/uploadPress', {
      templateUrl: 'app/uploadPress/uploadPress.html',
      controller: 'UploadPressCtrl'
    });
  }]) .controller('UploadPressCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'growl', 'tokenService', 'ngDialog', 'baseApiUrl', '$anchorScroll', 'MyService', '$window', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, growl, tokenService, ngDialog, baseApiUrl, $anchorScroll, MyService, $window) {
    $scope.upload = {
      files: '',
      opt: 'Update'
    };
    $scope.showPressList = true;
    $scope.press = {
      data: []
    };
    $scope.PressButton = false;
    $scope.getAllPress = function () {
      $scope.press.data.length = 0;
      MyService.getAllOrganizations({
        type: "Press"
      }).then(function (payload) {
        $scope.press.data = payload;

      }, function (err) {
        //MyService.ConsoleLog("got states error");
        // growl.error("Some");
      });
    }

    $scope.allLocations = [];
    $scope.getAllStates = function () {
      $scope.allLocations.length = 0;
      MyService.getAllStates().then(function (data) {
        //MyService.ConsoleLog("got states");
        $scope.allLocations = data;
      }, function (err) {
        //MyService.ConsoleLog("got states error");
        // growl.error("Some");
      });
    }

    $scope.updatePress = function (data) {
      if (data.files != "") {
        //MyService.ConsoleLog(data.files.type.indexOf("office"));
        //alert("This needs to be implemented");

        if (data.files.type.indexOf("office") > -1) {

          $scope.PressButton = true;
          //MyService.ConsoleLog("data : ", data);
          var fd = new FormData();
          fd.append('file', data.files);
          fd.append('options', data.opt);
          var posturl = baseApiUrl + "/user/uploadPress";
          $http.post(posturl, fd, {
              transformRequest: angular.identity,
              headers: {
                'Content-Type': undefined
              }
            })
            .success(function (response, status, headers, config) {
              //MyService.ConsoleLog("response : ", response);
              if (response.success) {
                //$location.path('/learnHome');
                $scope.PressButton = false;
                $scope.press.data.length = 0;
                $scope.getAllPress();
                alert("File successfully imported.");
              } else {
                alert("Something went wrong.");
              }
            })
            .error(function (data, status, headers, config) {
              //MyService.ConsoleLog("error");
            });
        } else {
          alert("Please select xlsx file");
        }

      } else {
        alert("Please select file");
      }

    }

    $scope.checkState = function (rdata, val) {
      return rdata.filter(
        function (rdata) {
          //MyService.ConsoleLog(rdata.statePostalCode + "==" + val);
          if (rdata.statePostalCode == val)
            return rdata
        }
      );
    }
    $scope.showExportLink = true;
    $scope.exportData = function () {
      $scope.showExportLink = false;
      MyService.exportOrganizationData({
        "type": "press"
      }).then(function (payload) {
        //MyService.ConsoleLog("Success Data", payload);
        $scope.showExportLink = true;
        $window.open($scope.imgUrl + '/press.xlsx', '_blank');
      }, function (errorPayload) {
        $scope.showExportLink = true;
        //MyService.ConsoleLog("errorPayload : ", errorPayload);
        alert("Something went wrong. Please try again after sometime");
      })
    }

    $scope.MyCounties = [];
    $scope.MyPlaces = [];
    $scope.allCounties = [];
    $scope.checkCountyExists = function (rdata, val) {
      return rdata.filter(
        function (rdata) {
          if (rdata._id.county == val)
            return rdata._id
        }
      );
    }

    $scope.checkLocalExists = function (rdata, val, val1) {
      return rdata.filter(
        function (rdata) {
          if ((rdata._id.place == val) && (rdata._id.countySubdivision == val1))
            return rdata._id
        }
      );
    }

    $scope.getCounties = function (state) {
      $scope.MyCounties.length = 0;
      if (typeof state == "string") {
        state = JSON.parse(state);
      }
      MyService.getAllCounties(state.statePostalCode).then(function (payload) {
          //MyService.ConsoleLog("sublocations Locals : ", payload);
          //$scope.showLoading.length = 0;
          $scope.MyCounties = payload;
          //MyService.ConsoleLog("getCounty checkdata: ", $scope.ShowData.address.county);
          if ($scope.ShowData.address.county) {
            var chkdata = $scope.checkCountyExists(payload, $scope.ShowData.address.county);
            //MyService.ConsoleLog("getCounty checkdata: ", chkdata);
            if (chkdata != "") {

              $scope.ShowData.county = JSON.stringify(angular.copy(chkdata[0]._id));
            }
          }
        },
        function (errorPayload) {
          growl.error('Something went wrong.');
        });
    }
    $scope.allLocals = [];
    $scope.getLocals = function (state, county) {
      if (typeof state == "string") {
        state = JSON.parse(state);
      }
      if (typeof county == "string") {
        county = JSON.parse(county);
      }
      MyService.getAllSubCountiesLocal(state.statePostalCode, county.county).then(function (payload) {
          $scope.MyPlaces = payload;
          //MyService.ConsoleLog("PlaCE :", $scope.ShowData.address.place);
          if ($scope.ShowData.address.place) {
            var chkdata = $scope.checkLocalExists(payload, $scope.ShowData.address.place, $scope.ShowData.address.countySubdivision);
            //MyService.ConsoleLog("getLocal checkdata: ", chkdata[0]);
            if (chkdata != "") {
              var idx = $scope.MyPlaces.indexOf(chkdata[0]);
              //MyService.ConsoleLog(idx);
              //MyService.ConsoleLog(angular.copy($scope.MyPlaces[idx]._id));
              $scope.ShowData.Locality = JSON.stringify(angular.copy($scope.MyPlaces[idx]._id));
            }
          }
        },
        function (errorPayload) {
          growl.error('Something went wrong.');
        });
    }

    $scope.dataIdx = "";
    $scope.showPress = function (data, idx) {
      //MyService.ConsoleLog(data);
      $scope.ShowData = data;
      //MyService.ConsoleLog("data : ", data);
      $scope.dataIdx = $scope.press.data.indexOf(data);
      var chkData = $scope.checkState($scope.allLocations, data.address.statePostalCode);
      //MyService.ConsoleLog("chkData : ", chkData[0]);
      $scope.ShowData.stateData = JSON.stringify(chkData[0]);
      /*
      if(data.location_of_press_interest) {
          var specialTowns = data.location_of_press_interest;
          var len = specialTowns.length;
          $scope.towns = [];
          for(var i=0; i< len; i++) {
              $scope.towns.push(specialTowns[i].place);
              if(i==len - 1) {
                  $scope.ShowData.towns = $scope.towns.join("; ");
              }
          }

      }
      */
      $scope.getCounties(data.address);
      $scope.getLocals(data.address, data.address);
      $scope.showPressList = false;
    }


    $scope.updatePressData = function (data) {

      if ($.fn.validateForceFully($("#pressform")) == true) {
        var state = JSON.parse(data.stateData);
        var county = "";
        var place = "";
        if (data.county) {
          county = JSON.parse(data.county);
        }
        if (data.Locality) {
          place = JSON.parse(data.Locality);
        }
        //data.address =
        data.state = state;
        if (data.contact_person) {
          data.contact_person = JSON.stringify(data.contact_person);
        }
        if (data.editor) {
          data.editor = JSON.stringify(data.editor);
        }
        data.county = county;
        data.place = place;
        //MyService.ConsoleLog(data);
        if (place != "") {
          var chkData = $scope.checkState($scope.allLocations, place.statePostalCode);
          //MyService.ConsoleLog("chkData : ", chkData[0]);
          if (chkData[0]) {
            data.statename = chkData[0].state;
          }
        }

        MyService.updateOfficeData(data).then(function (payload) {
          //MyService.ConsoleLog("payload : ", payload);
          data.contact_person = JSON.parse(data.contact_person);
          data.editor = JSON.parse(data.editor);
          $scope.press.data[$scope.dataIdx] = data;

          $scope.showPressList = true;

        }, function (err) {
          alert("Something went wrong");
        })
      }
    }

    $scope.registerAdvocateData = function (data) {
      if ($.fn.validateForceFully($("#pressform")) == true) {
        if ((data.contact_person.email != "") && (data.contact_person.email != null)) {
          var state = JSON.parse(data.stateData);
          var county = JSON.parse(data.county);
          var place = JSON.parse(data.Locality);
          //data.address =
          data.state = state;
          data.contact_person = JSON.stringify(data.contact_person);
          data.county = county;
          data.place = place;
          //MyService.ConsoleLog(data);
          var chkData = $scope.checkState($scope.allLocations, place.statePostalCode);
          //MyService.ConsoleLog("chkData : ", chkData[0]);
          if (chkData[0]) {
            data.statename = chkData[0].state;
          }


          MyService.registerAdvocateData(data).then(function (payload) {
            ////MyService.ConsoleLog("payload : ", payload);
            //data.contact_person = JSON.parse(data.contact_person);
            MyService.updateOfficeData(data).then(function (payload) {
              //MyService.ConsoleLog("payload : ", payload);
              data.contact_person = JSON.parse(data.contact_person);
              $scope.press.data[$scope.dataIdx] = data;
              $scope.showPressList = true;
            }, function (err) {
              alert("Something went wrong");
            })
          }, function (err) {
            alert("Something went wrong");
          })
        } else {
          alert("Please enter email ID to create user");
        }

      }
    }

    $scope.goBack = function () {
      $scope.showPressList = true;
    }

    if ($rootScope.showPress) {
      $scope.getAllPress();
      $scope.getAllStates();
      //alert("Still working on this page functionality.");
      $("#pressform").validationEngine();
    }

  }])
'use strict';
angular.module('myApp.uploadPopulationData', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/uploadPopulationData', {
      templateUrl: 'app/uploadPopulationData/uploadPopulationData.html',
      controller: 'uploadPopulationDataCtrl'
    });
  }]).controller('uploadPopulationDataCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'growl', 'tokenService', 'ngDialog', 'baseApiUrl', '$anchorScroll', 'MyService', '$window', '$sce', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, growl, tokenService, ngDialog, baseApiUrl, $anchorScroll, MyService, $window, $sce) {



    $scope.showLoader = false;
    $scope.errorFile = "";
    $scope.uploadBallotMeasures = function (data) {
      $scope.showLoader = true;
      if (data && data.files != "") {
        MyService.ConsoleLog(data.files.type.indexOf("office"));
        if (data.files.type.indexOf("office") > -1) {
          //MyService.ConsoleLog("data : ", data);
          var fd = new FormData();
          fd.append('file', data.files);
          var posturl = baseApiUrl + "/user/uploadPopulationData";
          $http.post(posturl, fd, {
              transformRequest: angular.identity,
              headers: {
                'Content-Type': undefined
              }
            })
            .then(function (response, status, headers, config) {
              //MyService.ConsoleLog("response : ", response);
              $scope.PoliticianButton = false;
              $scope.upload.files = "";
              $scope.upload.opt = "";
              if (response.data.success) {
                //$location.path('/learnHome');
                MyService.ConsoleLog("data", response);
                $scope.errorFile = response.data.errorfile;
                $scope.PoliticianButton = false;
                //$scope.getAllPolitician();
                $scope.showLoader = false;
                alert("File successfully imported.");
              } else {
                $scope.showLoader = false;
                alert("Something went wrong.");
              }
            }, function (data, status, headers, config) {
              $scope.PoliticianButton = false;
              //MyService.ConsoleLog("error");
            });
        } else {
          $scope.PoliticianButton = false;
          alert("Please select xlsx file");
        }
      } else {
        $scope.PoliticianButton = false;

        alert("Please select file");
      }
    };


  }]);

"use strict";
angular
  .module("myApp.uploadPolitician", ["ngRoute"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/uploadPolitician", {
        templateUrl: "app/uploadPoliticians/uploadPoliticians.html",
        controller: "UploadPoliticianCtrl",
      });
    },
  ])
  .controller("UploadPoliticianCtrl", [
    "$scope",
    "$http",
    "$location",
    "apiCall",
    "$routeParams",
    "$rootScope",
    "$q",
    "$timeout",
    "growl",
    "tokenService",
    "ngDialog",
    "baseApiUrl",
    "$anchorScroll",
    "MyService",
    "$window",
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $rootScope,
      $q,
      $timeout,
      growl,
      tokenService,
      ngDialog,
      baseApiUrl,
      $anchorScroll,
      MyService,
      $window
    ) {
      //MyService.ConsoleLog("** UploadPoliticianCtrl **");
      $scope.imgUrl = baseApiUrl + "/resources";
      $scope.upload = {
        files: "",
        opt: "Update",
        mtype: "BEF",
        etype: "PRS",
        isEmail: "",
      };
      $scope.showPoliticianList = true;
      $scope.politicians = {
        data: [],
      };
      $scope.rate = {
        year: "",
      };
      $scope.ShowPoliticianLoader = false;
      $scope.PoliticianButton = false;
      $scope.StatePostCode = "";

      $scope.allUSAPol = {
        statePostalCode: "All USA",
        state: "All USA",
      };

      $scope.getAllPolitician = function (state) {
        $scope.ShowPoliticianLoader = true;
        $scope.politicians.data.length = 0;
        var state = JSON.parse(state);
        $scope.StatePostCode = state.statePostalCode;
        //MyService.ConsoleLog(state);
        MyService.getAllPoliticians({
          state: state.statePostalCode,
        }).then(
          function (payload) {
            // MyService.ConsoleLog("",payload);
            $scope.ShowPoliticianLoader = false;
            $scope.politicians.data = payload;
            // MyService.ConsoleLog("got states :",  $scope.politicians.data[0].statePostalCode);
          },
          function (err) {
            MyService.ConsoleLog(err);
            MyService.ConsoleLog("got states error");
            //growl.error("Some");
          }
        );
      };

      $scope.read = function (workbook) {
        /* DO SOMETHING WITH workbook HERE */
        var first_sheet_name = workbook.SheetNames[0];
        var desired_cell = workbook.Sheets[first_sheet_name];
        var finaldata = XLSX.utils.sheet_to_json(desired_cell);
        var finaldata1 = XLSX.utils.sheet_to_row_object_array(desired_cell);
        //var finaldata = XLSX.utils.sheet_to_json(desired_cell);
      };

      $scope.error = function (e) {
        /* DO SOMETHING WHEN ERROR IS THROWN */
        //MyService.ConsoleLog("Xls error called");
        //MyService.ConsoleLog(e);
      };

      $scope.allLocations = [];

      $scope.getAllStates = function () {
        $scope.allLocations.length = 0;
        MyService.getAllStates().then(
          function (data) {
            //MyService.ConsoleLog("got states");
            $scope.allLocations = data;
          },
          function (err) {
            //MyService.ConsoleLog("got states error");
            //growl.error("Some");
          }
        );
      };

      $scope.errorFile = "";
      $scope.updatePolitician = function (data) {
        MyService.ConsoleLog("data >> ", data);
        $scope.PoliticianButton = true;
        if (data.files != "") {
          //MyService.ConsoleLog(data.files.type.indexOf("office"));
          if (data.files.type.indexOf("office") > -1) {
            //MyService.ConsoleLog("data : ", data);
            if (data && data.isEmail != "") {
              var fd = new FormData();
              fd.append("file", data.files);
              fd.append("options", data.opt);
              fd.append("type", data.mtype);
              fd.append("etype", data.etype);
              fd.append("isEmail", data.isEmail);

              if (data.mtype == "WIN") {
                fd.append("state", data.mstate);
              }
              var posturl = baseApiUrl + "/user/uploadPolitician";
              $http
                .post(posturl, fd, {
                  transformRequest: angular.identity,
                  headers: {
                    "Content-Type": undefined,
                  },
                })
                .then(
                  function (response, status, headers, config) {
                    //MyService.ConsoleLog("response : ", response);
                    $scope.PoliticianButton = false;
                    $scope.upload.files = "";
                    $scope.upload.opt = "";
                    if (response.data.success) {
                      //$location.path('/learnHome');
                      $scope.politicians.data.length = 0;
                      $scope.errorFile = response.data.errorfile;
                      $scope.PoliticianButton = false;
                      //$scope.getAllPolitician();
                      alert("File successfully imported.");
                    } else {
                      alert("Something went wrong.");
                    }
                  },
                  function (data, status, headers, config) {
                    $scope.PoliticianButton = false;
                    //MyService.ConsoleLog("error");
                  }
                );
            } else {
              growl.warning("Please select email option to procced");
            }
          } else {
            alert("Please select xlsx file");
          }
        } else {
          alert("Please select file");
        }
      };

      $scope.ShowData = "";
      $scope.showExportLink = true;
      $scope.exportData = function () {
        //alert($scope.StatePostCode);

        $scope.showExportLink = false;
        MyService.exportPoliticianData({
          state: $scope.StatePostCode,
        }).then(
          function (payload) {
            //MyService.ConsoleLog("Success Data", payload);
            $scope.showExportLink = true;
            $window.open($scope.imgUrl + "/politician.xlsx", "_blank");
          },
          function (errorPayload) {
            $scope.showExportLink = true;
            //MyService.ConsoleLog("errorPayload : ", errorPayload);
            alert("Something went wrong. Please try again after sometime");
          }
        );
      };

      $scope.checkState = function (rdata, val) {
        return rdata.filter(function (rdata) {
          //MyService.ConsoleLog(rdata.statePostalCode + "==" + val);
          if (rdata.statePostalCode == val) return rdata;
        });
      };

      $scope.dataIdx = "";
      $scope.showPolitician = function (data, idx) {
        //MyService.ConsoleLog(data);
        $scope.ShowPoliticianLoader = true;
        $scope.ShowData = data;
        MyService.ConsoleLog("$scope.ShowData", $scope.ShowData);
        if (
          $scope.ShowData &&
          $scope.ShowData.campaignInfo &&
          $scope.ShowData.campaignInfo.length > 0
        ) {
          $scope.ShowData.campaignWeburl =
            $scope.ShowData.campaignInfo[0].campaignWeburl;
        }
        $scope.dataIdx = $scope.politicians.data.indexOf(data);
        $scope.showPoliticianList = false;
      };

      /**
       * @description Get ratings of candidates
       */
      $scope.getRatings = function (state) {
        MyService.ConsoleLog("rate.year", $scope.rate.year);
        if ($scope.rate && $scope.rate.year) {
          var nwState;
          MyService.ConsoleLog(" $scope.getStateRate", $scope.getStateRate);
          if ($scope.getStateRate) {
            nwState = $scope.getStateRate;
          } else {
            nwState = state;
          }
          console.log("nwState :", nwState);
          $scope.loader = true;
          MyService.getRatingsOfCandidate({
            s_id: nwState,
            year: $scope.rate.year,
          }).then(function (result) {
            console.log("result :", result);
            if (result && result.data && result.data.success) {
              growl.success(result.data.data);
            }
            $scope.loader = false;
          });
        } else {
          growl.error("Please Select Year First");
        }
      };

      $scope.stateName = "";
      $scope.setState = function (data) {
        //MyService.ConsoleLog("setState : ", data);
        var chkdata = $scope.checkState($scope.allLocations, data);
        if (chkdata != "") {
          //MyService.ConsoleLog("ChkData : ", chkdata);
          $scope.stateName = chkdata[0].state;
        }
      };

      $scope.goBack = function () {
        $scope.ShowData = "";
        $scope.showPoliticianList = true;
        $scope.ShowPoliticianLoader = false;
      };

      $scope.isSelected = false;
      $scope.SelectChecks = function () {
        //alert($scope.isSelected);
        if ($scope.isSelected == false) {
          $scope.isSelected = true;
          angular.forEach($scope.politicians.data, function (val, key) {
            val.checked = true;
          });
        } else {
          $scope.isSelected = false;
          angular.forEach($scope.politicians.data, function (val, key) {
            val.checked = false;
          });
        }
        //$scope.isSelected = true;
      };

      $scope.updatePoliticianData = function (data) {
        // MyService.ConsoleLog("check data", data);
        // return;
        if ($("#uploadform").validationEngine("validate") == true) {
          data = JSON.parse(JSON.stringify(data));
          var chkdata = $scope.checkState(
            $scope.allLocations,
            data.StatePostalCode
          );
          if (chkdata != "") {
            //MyService.ConsoleLog("ChkData : ", chkdata);
            data.state = chkdata[0].state;
          }
          var camp = {};
          var campArr = [];
          try {
            camp.campaignWeburl = data.campaignWeburl;
            camp.campaignEmail = data.campaignInfo[0].campaignEmail
              ? data.campaignInfo[0].campaignEmail
              : null;
            camp.campaignPhone = data.campaignInfo[0].campaignPhone
              ? data.campaignInfo[0].campaignPhone
              : null;
            camp.campaignFburl = data.campaignInfo[0].campaignFburl
              ? data.campaignInfo[0].campaignFburl
              : null;
            camp.campaignTwitterurl = data.campaignInfo[0].campaignTwitterurl
              ? data.campaignInfo[0].campaignTwitterurl
              : null;
            camp.campaignInstagramUrl = data.campaignInfo[0]
              .campaignInstagramUrl
              ? data.campaignInfo[0].campaignInstagramUrl
              : null;
            camp.campaignLinkedInUrl = data.campaignInfo[0].campaignLinkedInUrl
              ? data.campaignInfo[0].campaignLinkedInUrl
              : null;
            camp.campaignYouTubeUrl = data.campaignInfo[0].campaignYouTubeUrl
              ? data.campaignInfo[0].campaignYouTubeUrl
              : null;
            console.log("check log", camp);
            campArr.push(camp);
            data.campaignInfo = [];
            data.campaignInfo = JSON.stringify(campArr);
          } catch (err) {
            console.log("err", err);
          }
          MyService.ConsoleLog("data<><><><>", data);
          MyService.updatePoliticianData(data).then(
            function (payload) {
              //MyService.ConsoleLog("payload : ", payload);
              $scope.politicians.data[$scope.dataIdx] = data;
              $scope.showPoliticianList = true;
            },
            function (err) {
              alert("Something went wrong");
            }
          );
        }
      };

      $scope.seleectedMState = "";
      $scope.getPolitciansStateWise = function (state) {
        MyService.ConsoleLog(state);
        var tempState = JSON.parse(state);
        // MyService.ConsoleLog("state", typeof tempState);

        // MyService.ConsoleLog("state", tempState.statePostalCode);

        if (tempState && tempState.statePostalCode == "All USA") {
          $scope.getStateRate = "NA";
        } else {
          $scope.getStateRate = tempState.statePostalCode;
        }

        $scope.seleectedMState = state;
        $scope.getAllPolitician(state);
      };

      $scope.removeBoth = function (para, flag) {
        MyService.ConsoleLog("postparam<>", para);
        para.chkflag = flag;
        MyService.ConsoleLog("para", para);
        MyService.removePoliticians(para).then(
          function (response) {
            //MyService.ConsoleLog(response);
            if (response.data.success) {
              growl.success("Removed selected politicians successfully.");
              $scope.getPolitciansStateWise($scope.seleectedMState);
            } else if (
              response.data.error &&
              typeof response.data.error == "string"
            ) {
              growl.error("Error: " + response.data.error);
            } else {
              growl.error("Something went wrong.");
            }
          },
          function (err) {
            growl.error("Something went wrong.");
          }
        );
      };

      $scope.rmBoth = false;
      $scope.deleteSelected = function () {
        var tempArr = [];
        var len = $scope.politicians.data.length;
        var j = 0;

        angular.forEach($scope.politicians.data, function (val, key) {
          j++;
          if (val.checked) {
            tempArr.push(val._id);
          }
          if (j == len) {
            //MyService.ConsoleLog(tempArr);
            if (tempArr.length > 0) {
              var postparam = {
                user_ids: tempArr.join(","),
              };
              MyService.checkUserExist(postparam).then(
                function (result) {
                  MyService.ConsoleLog("result >>", result);
                  if (result.data.success) {
                    var message =
                      "There is a User associated with the selected politician. Do you want to delete that user also?";
                    var modal = ngDialog.openConfirm({
                      template:
                        "<p>" +
                        message +
                        '</p>\
                    <div class="ngdialog-buttons">\
                    <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(2)">Cancel</button>\
                        <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">No</button>\
                        <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">YES</button>\
                    </div>',
                      plain: true,
                      closeByDocument: false,
                    });

                    modal.then(
                      function fullfilled(data) {
                        MyService.ConsoleLog("data", data);
                        if (data == 1) {
                          $scope.rmBoth = true;
                          $scope.removeBoth(postparam, $scope.rmBoth);
                        } else {
                          // alert('calle');
                          $scope.rmBoth = false;
                          $scope.removeBoth(postparam, $scope.rmBoth);
                        }
                      },
                      function rejected(data) {}
                    );
                  } else {
                    // alert("User Not Exists");

                    var message = "Do you want to delete selected politician";
                    var modal = ngDialog.openConfirm({
                      template:
                        "<p>" +
                        message +
                        '</p>\
                    <div class="ngdialog-buttons">\
                        <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                        <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">YES</button>\
                    </div>',
                      plain: true,
                      closeByDocument: false,
                    });

                    modal.then(
                      function fullfilled(data) {
                        MyService.ConsoleLog("data", data);

                        // alert('calle');
                        $scope.rmBoth = false;
                        $scope.removeBoth(postparam, $scope.rmBoth);
                      },
                      function rejected(data) {}
                    );
                    //MyService.ConsoleLog("postparam<>", postparam);
                    // MyService.removePoliticians(postparam).then(function (response) {
                    //   //MyService.ConsoleLog(response);
                    //   if (response.data.success) {
                    //     growl.success('Removed selected politicians successfully.');
                    //     $scope.getPolitciansStateWise($scope.seleectedMState);
                    //   } else if (response.data.error && typeof response.data.error == "string") {
                    //     growl.error('Error: ' + response.data.error);

                    //   } else {
                    //     growl.error('Something went wrong.');
                    //   }
                    // }, function (err) {
                    //   growl.error("Something went wrong.");
                    // });
                  }
                },
                function (err) {
                  growl.error(err);
                }
              );
            } else {
              growl.error("Please select atleast one record to delete.");
            }
          }
        });
        //MyService.ConsoleLog("tempArr: ", tempArr);
      };

      $scope.registerPoliticianData = function (data) {
        //MyService.ConsoleLog("data : ", data);
        if ($.fn.validateForceFully($("#uploadform")) == true) {
          if (
            (data.privateEmail == "" || !data.privateEmail) &&
            data.publicEmail != ""
          ) {
            data.privateEmail = data.publicEmail;
          }
          // MyService.ConsoleLog("data<><><>",data);

          if (data.privateEmail != "" && data.privateEmail != null) {
            if (data.zipname != "" && data.zipname != null) {
              data = JSON.parse(JSON.stringify(data));
              var chkdata = $scope.checkState(
                $scope.allLocations,
                data.StatePostalCode
              );
              if (chkdata != "") {
                //MyService.ConsoleLog("ChkData : ", chkdata);
                data.state = chkdata[0].state;
              }
              MyService.registerPoliticianData(data).then(
                function (payload) {
                  MyService.updatePoliticianData(data).then(
                    function (payload) {
                      //MyService.ConsoleLog("payload : ", payload);
                      $scope.politicians.data[$scope.dataIdx] = data;
                      $scope.showPoliticianList = true;
                    },
                    function (err) {
                      //MyService.ConsoleLog("err : ", err);
                      alert("Something went wrong");
                    }
                  );
                },
                function (err) {
                  //MyService.ConsoleLog("err : ", err);
                  alert(err);
                }
              );
            } else {
              alert("Zipcode is required for creating the user.");
            }
          } else {
            alert("Email is required for creating the user.");
          }
        }
      };

      if ($rootScope.showUpload) {
        $scope.getAllStates();
        $("#uploadform").validationEngine();
      }
    },
  ]);

'use strict';
angular.module('myApp.uploadNewPolitician', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/uploadNewPolitician', {
      templateUrl: 'app/uploadNewPolitician/uploadNewPolitician.html',
      controller: 'UploadNewPoliticianCtrl'
    });
  }])
  .controller('UploadNewPoliticianCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'growl', 'tokenService', 'ngDialog', 'baseApiUrl', '$anchorScroll', 'MyService', '$window', '$sce', 'uiGridConstants', '$filter', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, growl, tokenService, ngDialog, baseApiUrl, $anchorScroll, MyService, $window, $sce, uiGridConstants, $filter) {
    //MyService.ConsoleLog("** UploadPoliticianCtrl **");
    $scope.loginUser = tokenService.getUserId();
    //MyService.ConsoleLog(tokenService.getUserData());
    if (tokenService.getUserData()) {
      $scope.UserData = JSON.parse(tokenService.getUserData());
    }

    $scope.myFields = ["name", "email", "privateEmail", "office", "officePlace", "candidateStatus", "party", "postCard", "electionDate", "voterScope", "publicMailingAddress", "privateMailingAddress", "website", "rapidTransitDistrict", "statement", "numberOfOpenings", "incumbent", "publicZipCode", "privateZipCode", "publicPhoneNumber", "privatePhoneNumber", "stateBoardEducationDistrict", "judicialCircuitNumber", "stateFips", "statePostalCode", "countyFips", "countyName", "countySubdivisionFips", "countySubdivisionName", "placeFips", "placeName", "voterDistrict", "votingDistrictName", "federalCongressionalDistrict", "stateSenateDistrict", "stateHouseofRepresentativesDistrict", "unifiedSchoolDistrict", "unifiedSchoolDistrictName", "elementarySchoolDistrict", "elementarySchoolDistrictName", "secondarySchoolDistrict", "secondarySchoolDistrictName", "totalPop", "afact", "dataX", "dataY", "dataZ", "runningForOffice", "facebookPage", "twitterFeed", "website2", "typeOfElection", "dataOrigin"];
    $scope.gridOptions = {
      enableCellEdit: true,
      enablePaging: true,
      editableCellTemplate: '<div mass-autocomplete><input mass-autocomplete-item="grid.appScope.autocomplete_options" data-ng-model="MODEL_COL_FIELD" ng-input="COL_FIELD" ng-blur="grid.appScope.closeEditBlur(grid.getCellValue(row, col));" ng-class="itemAuto" ></div>',
      showFooter: true,
      enableColumnMenus: true,
      paginationPageSizes: [20],
      paginationPageSize: 20,
      minWidth: 150,
      data: [],
      columnDefs: []
    };

    $scope.reset = function () {
      $scope.gridOptions.data = [];
      $scope.gridOptions.columnDefs = [];
    }



    // editableCellTemplate: '<div class="mass-autocomplete"><input type="INPUT_TYPE"  data-ng-model="MODEL_COL_FIELD" name="label" mass-autocomplete-item="grid.appScope.autocomplete_options" maxlength="100" /></div>',

    $scope.myHeaderCellTemplate = '<div ng-style="{cursor: col.cursor}" ui-grid-auto-resize ng-class="{ ngSorted: !noSortVisible }">' +
      '<div class="ngHeaderText">{{col.displayName}}</div><div><select ng-model="dirty.value" ng-change="grid.appScope.changeDisplay(col,dirty.value)">';
    // for(var i=0; i<myfields.length;i++) {
    //     $scope.myHeaderCellTemplate += '<option value="'+myfields[i]+'">'+myfields[i]+'</option>';
    // }

    $scope.myHeaderCellTemplate += '<option ng-repeat="fld in grid.appScope.myFields" value="{{fld}}">{{fld}}</option>';
    $scope.myHeaderCellTemplate += '</select></div>' +
      '<div class="ngSortButtonDown" ng-show="col.showSortButtonDown()"></div>' +
      '<div class="ngSortButtonUp" ng-show="col.showSortButtonUp()"></div>' +
      '<div class="ngSortPriority">{{col.sortPriority}}</div>' +
      '</div>' +
      '<div ng-show="col.resizable" class="ngHeaderGrip"></div>';


    $scope.checkColumn = function (rdata, val) {
      return $scope.gridOptions.columnDefs.filter(
        function (rdata) {
          //MyService.ConsoleLog(rdata.field + "==" + val);
          if (rdata.field == val)
            return rdata;
        }
      );
    }

    $scope.add = function () {
      $scope.gridOptions.columnDefs.push({
        field: 'new',
        minWidth: 150,
        enableSorting: true,
        enableCellEdit: true,
        headerCellTemplate: $scope.myHeaderCellTemplate
      });
    }

    $scope.addColumn = function (t) {
      //MyService.ConsoleLog(t);
      //MyService.ConsoleLog($scope.gridOptions.columnDefs);
      var getfield = $scope.checkColumn($scope.gridOptions.columnDefs, t);
      //MyService.ConsoleLog("getfield >>>>>> ", getfield);
      if (getfield.length == 0) {
        $scope.gridOptions.columnDefs.push({
          field: t,
          minWidth: 150,
          enableSorting: true,
          enableCellEdit: true,
          headerCellTemplate: $scope.myHeaderCellTemplate
        });
      }

    }


    $scope.remove = function () {
      angular.forEach($scope.gridApi.selection.getSelectedRows(), function (data, index) {
        $scope.gridOptions.data.splice($scope.gridOptions.data.lastIndexOf(data), 1);
      });
    }

    $scope.editField = "";
    $scope.editFieldD = "";
    $scope.prevVal = "";
    $scope.address = {
      state: '',
      county: '',
      places: [],
      towns: [],
      city: [],
      CountySubdivisionName: [],
      FederalCongressionalDistrict: [],
      StateHouseofRepresentativesDistrict: [],
      UnifiedSchoolDistrictName: [],
      voterDistrictName: []
    }
    $scope.angularElement = "";
    $scope.selectedEditRow = "";
    $scope.selectedEditS = "";
    $scope.countyList = [];
    //MyService.ConsoleLog($scope.UserData.volunteers);
    if ($scope.UserData && $scope.UserData.volunteers && $scope.UserData.volunteers.length > 0) {
      $scope.countyList.length = 0;
      $scope.locations = $scope.UserData.volunteers[0].permited_location;
      //MyService.ConsoleLog($scope.locations);
      $scope.countyList = $scope.locations.map(function (pl) {
        return {
          "county": pl.county,
          "statePostalCode": pl.statePostalCode
        };
      });
      //MyService.ConsoleLog($scope.countyList);
    }

    $scope.checkColumn = function (val) {
      return $scope.countyList.filter(
        function (rdata) {
          if (rdata.county == val.county && rdata.statePostalCode == val.statePostalCode)
            return rdata;
        }
      );
    }

    $scope.checkCountyExists = function (item) {
      MyService.ConsoleLog("item:::", item);
      var idx = $scope.checkColumn(item._id);
      if (idx && idx.length > 0) {
        return item;
      } else {
        return "";
      }
    }



    $scope.gridOptions.onRegisterApi = function (gridApi) {
      //set gridApi on scope
      $scope.gridApi = gridApi;

      $scope.gridApi.colResizable.on.columnSizeChanged($scope, function (colDef, deltaChange) {
        //MyService.ConsoleLog('resized #############');
      });


      gridApi.selection.on.rowSelectionChanged($scope, function (row) {
        var msg = 'row selected ' + row.isSelected;
        //MyService.ConsoleLog(msg);
      });

      gridApi.selection.on.rowSelectionChangedBatch($scope, function (rows) {
        var msg = 'rows rowSelectionChangedBatch ' + rows.length;
        //MyService.ConsoleLog(msg);
      });

      //MyService.ConsoleLog(gridApi.edit);
      gridApi.edit.on.beginCellEdit($scope, function (row, s, t) {
        $scope.selectedEditRow = row;
        $scope.selectedEditS = s;
        // //t.srcElement.onkeypress = $scope.keypresscalled;
        //MyService.ConsoleLog(t.srcElement);
        //MyService.ConsoleLog(s);
        if (s.displayName) {
          $scope.editField = s.field;
          $scope.editFieldD = s.displayName;
        } else {
          $scope.editField = s.field;
          $scope.editFieldD = s.field;
        }
        $scope.prevVal = angular.copy(t.srcElement.innerHTML);
        $scope.angularElement = t.srcElement;
      });

      gridApi.edit.on.afterCellEdit($scope, function (row, s, t) {


        // $scope.gridApi.core.refresh();
        var fieldName = s.displayName ? s.displayName : s.field;

        // $scope.$apply();
        var message = "Do you want to replace all " + $scope.prevVal + " with " + t + " from " + $scope.editField + " column";
        var modal = ngDialog.openConfirm({
          template: '<p>' + message + '</p>\
            <div class="ngdialog-buttons">\
                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">YES</button>\
                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">NO</button>\
            </div>',
          plain: true
        });
        modal.then(function fullfilled(data) {
          //MyService.ConsoleLog("fullfilled: ", $scope.gridApi.grid);
          if (data == 1) {
            var len = $scope.gridApi.grid.rows.length;
            //MyService.ConsoleLog("len>", len);
            for (var j = 0; j < len; j++) {
              //MyService.ConsoleLog($scope.editField);
              //MyService.ConsoleLog($scope.gridApi.grid.rows[j].entity[$scope.editField]);
              //MyService.ConsoleLog($scope.prevVal);
              if ($scope.gridApi.grid.rows[j].entity[$scope.editField] == $scope.prevVal) {
                $scope.gridApi.grid.rows[j].entity[$scope.editField] = t;
                // MyService.ConsoleLog($scope.gridApi.grid.rows[j]);
                var columns = $scope.gridApi.grid.columns;
                var colLen = $scope.gridApi.grid.columns.length;
                for (var c = 0; c < colLen; c++) {

                  if (fieldName == $scope.gridApi.grid.columns[c].displayName) {
                    MyService.ConsoleLog($scope.gridApi.grid.columns[c]);
                    MyService.ConsoleLog(fieldName)
                    switch (fieldName) {
                      case "countyName":
                        MyService.ConsoleLog($scope.address.towns + "==" + t);
                        if ($scope.address.towns.indexOf(t) > 0) {
                          $scope.gridApi.grid.columns[c].cellClass = 'white';
                          // $scope.$apply();
                        }
                        break;
                      case "countySubdivisionName":
                        MyService.ConsoleLog($scope.address.CountySubdivisionName + "==" + t);
                        if ($scope.address.CountySubdivisionName.indexOf(t) > 0) {
                          $scope.gridApi.grid.columns[c].cellClass = 'white';
                          // $scope.$apply();
                        }
                        break;
                      case "placeName":
                        MyService.ConsoleLog($scope.address.city + "==" + t);
                        if ($scope.address.city.indexOf(t) > 0) {
                          $scope.gridApi.grid.columns[c].cellClass = 'white';
                          // $scope.$apply();
                        }
                        break;
                      case "default":

                        // $scope.$apply();
                        break;

                    }
                  }
                }
                MyService.ConsoleLog($scope.gridApi.grid.rows[j]);

              }
              if (j == len - 1) {
                angular.element($scope.angularElement).removeClass('ui-grid-cell-contents-hidden');
                angular.element($scope.angularElement).addClass('ui-grid-cell-contents');
                angular.element(document.querySelector('.ac-container')).remove();

                if ($scope.editFieldD.toLowerCase() == 'voterscope') {
                  $scope.addColumn(t);
                }

                $scope.gridApi.core.refresh();
                // $scope.$apply();
              }
            }
          }
        }, function rejected(data) {
          //MyService.ConsoleLog("rejected: ", data);
          angular.element($scope.angularElement).removeClass('ui-grid-cell-contents-hidden');



          angular.element($scope.angularElement).addClass('ui-grid-cell-contents');

          switch (fieldName) {
            case "countyName":
              MyService.ConsoleLog($scope.address.towns + "==" + t);
              if ($scope.address.towns.indexOf(t) > 0) {
                angular.element($scope.angularElement).removeClass('yellow');
                angular.element($scope.angularElement).addClass('white');
                // $scope.$apply();
              }
              break;
            case "countySubdivisionName":
              MyService.ConsoleLog($scope.address.CountySubdivisionName + "==" + t);
              if ($scope.address.CountySubdivisionName.indexOf(t) > 0) {
                angular.element($scope.angularElement).removeClass('yellow');
                angular.element($scope.angularElement).addClass('white');
                // $scope.$apply();
              }
              break;
            case "placeName":
              MyService.ConsoleLog($scope.address.city + "==" + t);
              if ($scope.address.city.indexOf(t) > 0) {
                angular.element($scope.angularElement).removeClass('yellow');
                angular.element($scope.angularElement).addClass('white');
                // $scope.$apply();
              }
              break;
            case "default":

              // $scope.$apply();
              break;

          }

          angular.element(document.querySelector('.ac-container')).remove();
          if ($scope.editFieldD.toLowerCase() == 'voterscope') {
            $scope.addColumn(t);
          }
          $scope.gridApi.core.refresh();
        });


        // gridApi.edit.on.afterCellEdit($scope, function(rowEntity, colDef, newValue, oldValue) {

        // colDef.cellClass = function(grid, row, col, rowRenderIndex, colRenderIndex) {
        //       if (rowEntity.id === row.entity.id && newValue !== oldValue) {
        //         return "test" ;
        //       }
        //       return "";
        //     };

        // $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);



      });
    };

    $scope.closeEdit = function (col) {
      // alert("here");
      //MyService.ConsoleLog(col);
      //var nval = col.value? col.value: col.displayName
      //MyService.ConsoleLog($scope.address.towns);
      $scope.gridApi.edit.raise.afterCellEdit($scope.selectedEditRow, $scope.selectedEditS, col.value);
      //$scope.gridApi.core.refresh();
    }

    $scope.closeEditBlur = function (col) {
      //MyService.ConsoleLog(col);
      var n = new Object;
      n.value = col;
      if (!$scope.suggestionsShown) {
        $scope.closeEdit(n);
      }

      //MyService.ConsoleLog(val);
    }

    $scope.finaldata = "";

    //Autofill fieldname
    $scope.dirty = {
      value: '',
      colval: ''
    };

    //angular.element($scope.angularElement).bind('blur', function() {
    //MyService.ConsoleLog("Blur triggered");
    //});



    $scope.party = ["Democratic", "Unknown", "Republican", "Democratic/Republican", "Independent", "Republican and Democrat", "Democratic and Republican", "Nonpartisan", "Green", "Republican/Democratic", "Independence", "Conservative", "Working Families", "Women's Equality"];

    $scope.voterScope = ["All USA", "CountyName", "PlaceName", "CountySubdivisionName", "FederalCongressionalDistrict", "StateHouseofRepresentativesDistrict", "StatePostalCode", "StateSenateDistrict", "UnifiedSchoolDistrictName"];

    function highlight(str, term) {
      var highlight_regex = new RegExp('(' + term + ')', 'gi');
      return str.replace(highlight_regex,
        '<span class="highlight">$1</span>');
    };
    $scope.suggestionsShown = false;

    function suggest_state(term) {
      var q = term.toLowerCase().trim();
      var results = [];
      var finaldata;
      $scope.suggestionsShown = false;
      var myEl = angular.element(document.querySelector('.ac-container'));
      myEl.css('top', 'inherit');
      myEl.css('left', 'inherit');
      // Find first 10 states that start with `term`.

      var editfield = $scope.editFieldD.replace(" ").toLowerCase();
      //MyService.ConsoleLog(editfield);
      switch (editfield) {
        case "voterscope":
          finaldata = $scope.voterScope;
          break;
        case "countysubdivisionname":
          finaldata = $scope.address.CountySubdivisionName;
          break;
        case "federalcongressionaldistrict":
          finaldata = $scope.address.FederalCongressionalDistrict;
          break;
        case "statehouseofrepresentativesdistrict":
          finaldata = $scope.address.StateHouseofRepresentativesDistrict;
          break;
        case "stateSenatedistrict":
          finaldata = $scope.address.StateSenateDistrict;
          break;
        case "unifiedschooldistrictname":
          finaldata = $scope.address.UnifiedSchoolDistrictName;
          break;
        case "party":
          finaldata = $scope.party;
          break;
        default:
          finaldata = $scope.address.towns;
          break;
      }
      //MyService.ConsoleLog("finaldata>>>",finaldata);
      for (var i = 0; i < finaldata.length; i++) {
        var state = finaldata[i];
        var matched = state.match(new RegExp(q, "i"));
        //MyService.ConsoleLog(state.match())
        //MyService.ConsoleLog(matched);
        //MyService.ConsoleLog(state.match(q, "i"));
        if (matched) {
          $scope.suggestionsShown = true;
          results.push({
            label: state,
            value: state
          });
        }
      }
      return results;
    }

    function suggest_state_with_highlight(term) {
      $scope.suggestionsShown = false;
      if (term.length < 1)
        return;
      var suggestions = suggest_state(term);
      suggestions.forEach(function (s) {
        // In real life you should reuse the regexp object.
        s.label = $sce.trustAsHtml(highlight(s.label, term));
      });
      return suggestions;
    };

    $scope.getAutoData = function (data, col) {
      //MyService.ConsoleLog(data);
      //MyService.ConsoleLog(col);

    };

    $scope.autocomplete_options = {
      suggest: suggest_state_with_highlight,
      on_select: $scope.closeEdit
    };


    function suggest_name(term) {
      var q = term.toLowerCase().trim();
      var results = [];
      var len = $scope.Allcountries.length;
      // Find first 10 states that start with `term`.
      for (var i = 0; i < len && results.length < 10; i++) {
        var country = $scope.Allcountries[i];
        if (country.toLowerCase().indexOf(q) === 0)
          results.push({
            label: country,
            value: country
          });
      }
      return results;
    }

    $scope.autocomplete_nameoptions = {
      suggest: suggest_name
    };


    $scope.changeDisplay = function (col, fld) {
      //MyService.ConsoleLog("<===============");
      //MyService.ConsoleLog(col);
      //MyService.ConsoleLog("===============>");
      //MyService.ConsoleLog(fld);
      col.colDef.displayName = fld;
      //MyService.ConsoleLog($scope.gridApi);
      //MyService.ConsoleLog($scope.opts);
      var idx = $scope.gridApi.grid.columns.indexOf(col);
      //MyService.ConsoleLog(fld.length);
      $scope.gridApi.grid.columns[idx].displayName = fld;

      if (fld.toLowerCase() != "voterscope") {
        var wdth = fld.length * 10;
        if (wdth < 150) {
          wdth = 150
        }
        $scope.gridApi.grid.columns[idx].width = wdth;
        $scope.gridApi.grid.columns[idx].colDef.width = wdth;
        //$scope.gridOptions.columnDefs[idx].width = fld.length * 10;
        //MyService.ConsoleLog($scope.gridOptions.columnDefs);
        $scope.gridApi.grid.columns[idx].drawnWidth = wdth;
      } else {
        $scope.gridApi.grid.columns[idx].width = 300;
        $scope.gridApi.grid.columns[idx].colDef.width = 300;
        //$scope.gridOptions.columnDefs[idx].width = fld.length * 10;
        //MyService.ConsoleLog($scope.gridOptions.columnDefs);
        $scope.gridApi.grid.columns[idx].drawnWidth = 300;
      }
      $timeout(function () {
        $scope.gridApi.core.refresh();
      });

    }

    //Autofill fieldname end
    // $scope.curstate = "";


    $scope.Show = {
      Loader: false
    };
    $scope.saveState = function () {
      //$scope.curstate = JSON.stringify($scope.gridApi.saveState.save());
      $scope.gridDirtyRows = $scope.gridOptions.data;
      $scope.promises = [];
      $scope.Show.Loader = true;
      angular.forEach($scope.gridDirtyRows, function (mvalue, key) {
        //MyService.ConsoleLog("Key>>>", key);
        $scope.subpromises = [];
        //var len = $scope.gridApi.grid.columns.length;
        var j = 0;
        angular.forEach($scope.gridApi.grid.columns, function (subval, subkey) {
          //MyService.ConsoleLog("mvalue<>",mvalue);
          var nfld = subval.field;
          //MyService.ConsoleLog("subval.field<>",mvalue[nfld]);
          //var nobj = new Object;
          if (subval.displayName != "" && subval.displayName != " ") {
            $scope.promises.push({
              fld: subval.displayName,
              fldval: mvalue[nfld],
              StatePostalCode: $scope.address.state.statePostalCode,
              CountyName: $scope.address.county._id.county,
              user: $scope.loginUser
            });
          }
        });
        //var displayColumn = $scope.checkColumn($scope.gridApi.grid.columns, value);

        // $q.all($scope.subpromises).then(function(value, key) {
        //     //MyService.ConsoleLog($scope.subpromises);

        // });

        //$scope.promises.push($scope.subpromises);
      })
      $q.all($scope.promises).then(function () {
        //MyService.ConsoleLog('there')
        //MyService.ConsoleLog($scope.promises);
        MyService.saveTempPolitician({
          data: JSON.stringify($scope.promises)
        }).then(function (payload) {
          //MyService.ConsoleLog(payload);
          $scope.Show.Loader = false;
          growl.error('Current state is successfully stored in database.');
        }, function (errorPayload) {
          $scope.Show.Loader = false;
          growl.error('Something went wrong.');
        });
      });
      //MyService.ConsoleLog($scope.gridDirtyRows);
      //window.localStorage.setItem('gridState', $scope.curstate);
    };
    $scope.finalData = [];

    function savedata(obj, columns, len) {
      //MyService.ConsoleLog(obj);
      var s = 0;
      var checkempty = false;
      var filData = {};
      filData = angular.copy(obj);
      $scope.finalData.push(filData);
    }

    $scope.restoreState = function () {
      //$timeout(function() {
      $scope.Show.Loader = true;
      //MyService.ConsoleLog($scope.ShowLoader);
      MyService.restoreTempPolitician({
        "user": $scope.loginUser
      }).then(function (payload) {
        //MyService.ConsoleLog(payload);
        var actualData = payload.data;
        var fldlenth = payload.fldlenth;
        var columnsArray = payload.flds;
        var j = 0;
        $scope.finalData1 = [];
        var nobj = {};
        angular.forEach(actualData, function (subval, subkey) {
          //MyService.ConsoleLog(subval);
          nobj[subval.fld] = subval.fldval;
          j++;
          if (j % fldlenth == 0) {
            savedata(nobj, columnsArray, fldlenth);
            //j = 0;
            //nobj.length = 0;
          }
        });
        //MyService.ConsoleLog($scope.finalData);
        //$scope.gridApi.grid.columns
        $scope.gridOptions.data = $scope.finalData;
        $scope.gridOptions.columnDefs = [];
        $scope.myHeaderCellTemplate = '<div  ng-style="{cursor: col.cursor}" ui-grid-auto-resize ng-class="{ ngSorted: !noSortVisible }">' +
          '<div class="ngHeaderText">{{col.displayName}}</div><div><select ng-model="dirty.value" ng-change="grid.appScope.changeDisplay(col,dirty.value)">';
        // for(var i=0; i<myfields.length;i++) {

        //     $scope.myHeaderCellTemplate += '<option value="'+myfields[i]+'">'+myfields[i]+'</option>';
        // }
        $scope.myHeaderCellTemplate += '<option ng-repeat="fld in grid.appScope.myFields" value="{{fld}}">{{fld}}</option>';
        $scope.myHeaderCellTemplate += '</select></div>' +
          '<div class="ngSortButtonDown" ng-show="col.showSortButtonDown()"></div>' +
          '<div class="ngSortButtonUp" ng-show="col.showSortButtonUp()"></div>' +
          '<div class="ngSortPriority">{{col.sortPriority}}</div>' +
          '</div>' +
          '<div ng-show="col.resizable" class="ngHeaderGrip"></div>';
        columnsArray.forEach(function (h) {

          if (checkcityArray.indexOf(h) > -1) {
            cityIdx = checkcityArray.indexOf(h);
            //MyService.ConsoleLog("cityIdx>>", cityIdx);
            /*cellClass: function(grid, row, col, rowRenderIndex, colRenderIndex) { var cidx = $scope.address.places.indexOf(grid.getCellValue(row,col)); if (cidx > -1) { if($scope.address.places[cidx]!=grid.getCellValue(row,col)) { return 'yellow'; } } return 'green'; } */
            //MyService.ConsoleLog($scope.opts);
            //MyService.ConsoleLog($scope);
            //MyService.ConsoleLog(grid.appScope.address);
            //MyService.ConsoleLog($scope.address.towns);
            $scope.gridOptions.columnDefs.push({
              field: h,
              displayName: h,
              width: 150,
              enableSorting: false,
              enableCellEdit: true,
              headerCellTemplate: $scope.myHeaderCellTemplate,
              cellClass: function (grid, row, col, rowRenderIndex, colRenderIndex) {
                var gVal = grid.getCellValue(row, col);
                if (gVal) {
                  //MyService.ConsoleLog(gVal);
                  var cval = gVal.split(",")[0].trim();
                  //MyService.ConsoleLog(cval);
                  var cidx = $scope.address.towns.filter(function (d) {
                    return d.indexOf(cval) !== -1;
                  });
                  if (cidx != "") {
                    return 'yellow'
                  }
                }
                return '';
              }
            });
          } else {
            $scope.gridOptions.columnDefs.push({
              field: h,
              displayName: h,
              width: 150,
              enableSorting: false,
              enableCellEdit: true,
              headerCellTemplate: $scope.myHeaderCellTemplate,
              cellClass: function (grid, row, col, rowRenderIndex, colRenderIndex) {
                var gVal = grid.getCellValue(row, col);
                if (gVal) {
                  //MyService.ConsoleLog(gVal);
                  var cidx = $scope.address.city.filter(function (d) {
                    return gVal.indexOf(d) !== -1;
                  });
                  if (cidx != "") {
                    return 'yellow'
                  }
                }
                return '';
              }
            });
          }

          //$scope.gridOptions.columnDefs.push({ field: h, displayName: h, width: 150, enableSorting: false, enableCellEdit: true, headerCellTemplate: $scope.myHeaderCellTemplate });
        });

        $scope.Show.Loader = false;

      }, function (errorPayload) {
        $scope.Show.Loader = false;
        growl.error('Something went wrong.');
      });
      //});
    };


    $scope.removeState = function () {
      var message = "This action cannot be undone. Are you sure you want to remove the previously stored grid data?";
      var modal = ngDialog.openConfirm({
        template: '<p>' + message + '</p>\
            <div class="ngdialog-buttons">\
                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">YES</button>\
                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">NO</button>\
            </div>',
        plain: true
      });
      modal.then(function fullfilled(data) {
        if (data == 1) {
          $scope.Show.Loader = true;
          MyService.removeStoredTempPolitician({
            "user": $scope.loginUser
          }).then(function (payload) {
            //MyService.ConsoleLog(payload);
            $scope.checkPrevState = false;
            $scope.Show.Loader = false;
            $scope.reset();
          }, function (errorPayload) {
            //MyService.ConsoleLog(errorPayload);
            $scope.Show.Loader = false;
          });
        }
      }, function rejected(data) {
        //MyService.ConsoleLog("rejected: ", data);
      });
    }



    $scope.getAllStates = function () {
      $scope.counties = "";
      $scope.address.state = "";
      $scope.address.county = "";
      $scope.address.places.length = 0;
      MyService.getAllStates().then(function (payload) {
          $scope.allState = payload;
        },
        function (errorPayload) {
          growl.error('Something went wrong.');
        });
    }

    $scope.getCounties = function () {
      MyService.ConsoleLog("state<><><>", $scope.address.state);
      $scope.address.places.length = 0;
      MyService.getAllCounties($scope.address.state.stateFips, $scope.address.state).then(function (payload) {
          $scope.counties = payload;
          $scope.county = payload;
          MyService.ConsoleLog("counties", $scope.counties);
        },
        function (errorPayload) {
          growl.error('Something went wrong.');
        });
    }

    $scope.switch = {
      "dStatus": []
    };

    $scope.checkboxModel = {
      "winner": ""
    };

    $scope.checkWinner = function (rdata, val) {
      return rdata.filter(
        function (rdata) {
          //MyService.ConsoleLog(rdata.statePostalCode + "==" + val);
          if (rdata.statePostalCode == val)
            return rdata;
        }
      );
    }

    $scope.showPreferences = function () {
      ngDialog.open({
        template: 'app/popups/setPreference.html',
        controller: "setPreference"
      });
    }

    $scope.orginialData = [];

    $scope.showHideWinners = function () {
      var val = $scope.checkboxModel.winner;
      //MyService.ConsoleLog(val);

      if (val == true) {
        $scope.orginialData = angular.copy($scope.gridOptions.data);
        var ldata = $filter('filter')($scope.gridOptions.data, "Winner");
        for (var i = 0, k = 1; i < ldata.length; i++, k++) {
          var idx = $scope.gridOptions.data.indexOf(ldata[i]);
          $scope.gridOptions.data.splice(idx, 1);
        }
        //var idx = $scope.gridOptions.data.indexOf(data);
        //$scope.gridApi.core.refresh();
      } else {
        //MyService.ConsoleLog($scope.orginialData);
        $scope.gridOptions.data = angular.copy($scope.orginialData);
        //$scope.gridApi.core.refresh();
      }
    }

    $scope.showRunningFor = function () {
      var val = $scope.checkboxModel.runningFor;
      //MyService.ConsoleLog(val);

      if (val == true) {
        $scope.orginialData = angular.copy($scope.gridOptions.data);
        var ldata = $scope.gridOptions.data.filter(function (ndata) {
          return (ndata.runningForOffice != "Y");
        });
        for (var i = 0, k = 1; i < ldata.length; i++, k++) {
          var idx = $scope.gridOptions.data.indexOf(ldata[i]);
          $scope.gridOptions.data.splice(idx, 1);
        }
        //var idx = $scope.gridOptions.data.indexOf(data);
        //$scope.gridApi.core.refresh();
      } else {
        //MyService.ConsoleLog($scope.orginialData);
        $scope.gridOptions.data = angular.copy($scope.orginialData);
        //$scope.gridApi.core.refresh();
      }
    }

    $scope.showMe = function (row, val) {
      //MyService.ConsoleLog(row);
      //MyService.ConsoleLog(val);
      var idx = $scope.gridOptions.data.indexOf(row);
      if (val != "") {
        //MyService.ConsoleLog("Row>>>", idx);
        if (val == "Loose") {
          $scope.gridOptions.data.splice(idx, 1);
        } else {
          if ($scope.checkboxModel.winner == true) {
            $scope.gridOptions.data.splice(idx, 1);
          }
          $scope.gridOptions.data[idx].incumbent = "Winner";
        }

        MyService.setWinRecords({
          "id": row._id,
          "val": val
        }).then(function (payload) {
          $timeout(function () {
            //$scope.gridApi.core.refresh();
            for (var j = 0; j < $scope.switch.dStatus.length; j++) {
              $scope.switch.dStatus[j] = "";
            }
            $scope.switch.dStatus[idx] = "";
            $scope.gridApi.core.refresh();
            //MyService.ConsoleLog("Inside TImeout");
          }, 2000);
        }, function (errorPayload) {

        });
      }
    }

    $scope.userSelectedCols = [];
    //MyService.ConsoleLog($scope.UserData);
    if ($scope.UserData && $scope.UserData.selectedColumns) {
      $scope.userSelectedCols = $scope.UserData.selectedColumns;
    } else {
      $scope.userSelectedCols = $scope.myFields;
    }
    $scope.list = {
      "selectedName": ''
    };
    $scope.selectedCols = function (temp) {
      //MyService.ConsoleLog(temp.cols);
      //MyService.ConsoleLog($scope.list);
      var allColumns = $scope.gridOptions.columnDefs.map(function (e) {
        return e.field;
      });
      //MyService.ConsoleLog(allColumns);
      for (var i = 1; i < allColumns.length; i++) {
        $scope.gridOptions.columnDefs[i].visible = false;
      }
      //MyService.ConsoleLog(temp);
      if (temp != "restore" && temp != null) {
        for (var j = 0; j < temp.cols.length; j++) {
          //MyService.ConsoleLog(temp.cols[j]);
          var pos = $scope.gridOptions.columnDefs.map(function (e) {
            return e.field;
          }).indexOf(temp.cols[j]);
          $scope.gridOptions.columnDefs[pos].visible = true;
        }
      } else {
        for (var i = 1; i < allColumns.length; i++) {
          $scope.gridOptions.columnDefs[i].visible = true;
        }
      }

      $scope.gridApi.core.refresh();
    }

    var checkcityArray = ['city', 'City', 'CITY', 'town', 'Town', 'TOWN'];

    $scope.getSubCounties = function () {
      MyService.ConsoleLog("state<><><>", $scope.address.county);
      $scope.address.towns.length = 0;
      $scope.address.city.length = 0;
      $scope.Show.Loader = true;
      MyService.getAllLocalDetails($scope.address.state.statePostalCode, $scope.address.county.county).then(function (npayload) {
        //$scope.counties = payload;
        //MyService.ConsoleLog(npayload);
        var payload = npayload.locations;
        $scope.address.places = npayload.locations;
        //$scope.address.places = npayload.locations;

        //MyService.ConsoleLog(payload);
        payload.forEach(function (d) {
          var idx = $scope.address.towns.indexOf(d._id.place);
          if (idx == -1) {
            $scope.address.towns.push(d._id.place);
            $scope.address.city.push(d._id.place.split(" ")[0]);
          }


          var idxc = $scope.address.CountySubdivisionName.indexOf(d._id.countySubdivision);
          if (idxc == -1) {
            $scope.address.CountySubdivisionName.push(d._id.countySubdivision);
          }

          var idxf = $scope.address.FederalCongressionalDistrict.indexOf(d._id.federalCongrassionalDist);
          if (idxf == -1) {
            $scope.address.FederalCongressionalDistrict.push(d._id.federalCongrassionalDist);
          }

          var idxH = $scope.address.StateHouseofRepresentativesDistrict.indexOf(d._id.stateHouseOFRepresentativeDistrict);
          if (idxH == -1) {
            $scope.address.StateHouseofRepresentativesDistrict.push(d._id.stateHouseOFRepresentativeDistrict);
          }

          var idxu = $scope.address.UnifiedSchoolDistrictName.indexOf(d._id.unifiedSchoolDistrictName);
          if (idxu == -1) {
            $scope.address.UnifiedSchoolDistrictName.push(d._id.unifiedSchoolDistrictName);

          }

          var idxd = $scope.address.voterDistrictName.indexOf(d._id.voterDistrictName);
          if (idxd == -1) {
            $scope.address.voterDistrictName.push(d._id.voterDistrictName);
          }
        });

        //MyService.ConsoleLog(npayload.politician);

        var wincellTemplate = '<select ng-model="switch.dStatus[$index]" ng-change="grid.appScope.showMe(row.entity, switch.dStatus[$index])"><option value="" selected ></option><option value="Win">Won</option><option value="Loose">Lost</option></select>';

        if (npayload.politician.length > 0) {
          var message = 'There are already records for this county. Do you want to load them?';
          var modal = ngDialog.openConfirm({
            template: '<p>' + message + '</p>\
            <div class="ngdialog-buttons">\
                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">YES</button>\
                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">NO</button>\
            </div>',
            plain: true
          });
          modal.then(function fullfilled(data) {
              //MyService.ConsoleLog("fullfilled: ", mydata);
              // alert(data);
              if (data == 1) {
                var promises = [];
                var columns = npayload.politician[0];
                var collen = columns.length;
                $scope.gridOptions.columnDefs.length = 0;
                //MyService.ConsoleLog("collen>>>", collen);
                var j = 0;
                //MyService.ConsoleLog($scope.userSelectedCols);
                angular.forEach(columns, function (value, key) {
                  //columns.forEach(function(key, value) {
                  j++;
                  //MyService.ConsoleLog("key>>>",key);
                  //var idx = $scope.userSelectedCols.indexOf(key);
                  //MyService.ConsoleLog("idx>>",idx);
                  //if (idx > -1) {

                  if (checkcityArray.indexOf(key) > -1) {
                    cityIdx = checkcityArray.indexOf(key);
                    //MyService.ConsoleLog("cityIdx>>", cityIdx);
                    /*cellClass: function(grid, row, col, rowRenderIndex, colRenderIndex) { var cidx = $scope.address.places.indexOf(grid.getCellValue(row,col)); if (cidx > -1) { if($scope.address.places[cidx]!=grid.getCellValue(row,col)) { return 'yellow'; } } return 'green'; } */
                    //MyService.ConsoleLog($scope.opts);
                    //MyService.ConsoleLog($scope);
                    //MyService.ConsoleLog(grid.appScope.address);
                    //MyService.ConsoleLog($scope.address.towns);


                    $scope.gridOptions.columnDefs.unshift({
                      field: key,
                      displayName: key,
                      width: 150,
                      enableSorting: false,
                      enableCellEdit: true,
                      cellClass: function (grid, row, col, rowRenderIndex, colRenderIndex) {
                        var gVal = grid.getCellValue(row, col);
                        if (gVal) {
                          //MyService.ConsoleLog(gVal);
                          var cval = gVal.split(",")[0].trim();
                          //MyService.ConsoleLog(cval);
                          var cidx = $scope.address.towns.filter(function (d) {
                            return d.indexOf(cval) !== -1;
                          });
                          if (cidx != "") {
                            return 'yellow'
                          }
                        }
                        return '';
                      }
                    });
                  } else {
                    $scope.gridOptions.columnDefs.unshift({
                      field: key,
                      displayName: key,
                      width: 150,
                      enableSorting: false,
                      enableCellEdit: true,
                      cellClass: function (grid, row, col, rowRenderIndex, colRenderIndex) {
                        var gVal = grid.getCellValue(row, col);
                        if (gVal) {
                          var cidx = $scope.address.city.filter(function (d) {
                            //MyService.ConsoleLog("d>", d);
                            if (d && d != "") {
                              MyService.ConsoleLog("gVal", gVal);
                              if (gVal) {
                                return gVal.indexOf(d) !== -1;
                              }
                            }

                          });
                          if (cidx != "") {
                            return 'yellow'
                          }
                        }
                        return '';
                      }
                    });
                  }

                  /*
                  $scope.gridOptions.columnDefs.unshift({
                    field: key,
                    displayName: key,
                    width: 150,
                    enableSorting: false,
                    enableCellEdit: true,
                    cellClass: function(grid, row, col, rowRenderIndex, colRenderIndex) {
                      var gVal = grid.getCellValue(row, col);
                      if (gVal) {
                        //MyService.ConsoleLog(gVal);
                        var cval = gVal.split(",")[0].trim();
                        //MyService.ConsoleLog(cval);
                        var cidx = $scope.address.towns.filter(function(d) {
                          return d.indexOf(cval) !== -1;
                        });
                        if (cidx != "") {
                          MyService.ConsoleLog("cval<><><>",cval);
                          MyService.ConsoleLog("cidx<><><>",cidx);
                          MyService.ConsoleLog("Twons<><><>",$scope.address.towns)
                          return 'yellow'
                        }
                      }
                      return '';
                    }
                  });
                  */
                  //}

                  promises.push(j);
                });

                $q.all(promises).then(function () {
                  //MyService.ConsoleLog("data");
                  $scope.gridOptions.columnDefs.unshift({
                    field: "WinLose",
                    displayName: "Won/Lost",
                    width: 110,
                    cellTemplate: wincellTemplate
                  });
                  $scope.gridOptions.data = npayload.politician;
                  $scope.gridOptions.enableFiltering = true;
                  //$scope.gridApi.core.refresh();
                  $scope.Show.Loader = false;
                  $scope.showSave = false;
                });
              }

              if (data == 2) {
                $scope.Show.Loader = false;
                $scope.showSave = true;
              }

              // $timeout(function() {
              // }, 2000);
              //window.localStorage.setItem()
              //MyService.ConsoleLog($scope.address.UnifiedSchoolDistrictName);
            },
            function (errorPayload) {
              $scope.Show.Loader = false;
              $scope.showSave = true;
              //growl.error('Something went wrong.');
            });
        } else {
          $scope.Show.Loader = false;
          $scope.showSave = true;
        }
      });
    }

    $scope.checkPrevState = false;




    $scope.saveRecords = function () {
      $scope.gridDirtyRows = $scope.gridOptions.data;
      MyService.ConsoleLog($scope.gridDirtyRows);
      $scope.promises = [];
      $scope.Show.Loader = true;

      angular.forEach($scope.gridDirtyRows, function (mvalue, key) {
        //MyService.ConsoleLog("Key>>>", key);
        $scope.subpromises = [];
        //var len = $scope.gridApi.grid.columns.length;
        var j = 0;
        var nobj = new Object;
        var len = $scope.gridApi.grid.columns.length;
        angular.forEach($scope.gridApi.grid.columns, function (subval, subkey) {
          //MyService.ConsoleLog("mvalue<>",mvalue);
          var nfld = subval.field;
          j++;
          //MyService.ConsoleLog("subval.field<>",mvalue[nfld]);
          //var nobj = new Object;
          if (subval.displayName != "" && subval.displayName != " ") {
            nobj[subval.displayName] = mvalue[nfld];
            //MyService.ConsoleLog(nobj);
          }
          if (j == len) {
            nobj.StatePostalCode = $scope.address.state.statePostalCode;
            nobj.CountyName = $scope.address.county.county;
            $scope.promises.push(nobj);
          }
        });
        //var displayColumn = $scope.checkColumn($scope.gridApi.grid.columns, value);

        // $q.all($scope.subpromises).then(function(value, key) {
        //     //MyService.ConsoleLog($scope.subpromises);

        // });

        //$scope.promises.push($scope.subpromises);
      })
      $q.all($scope.promises).then(function () {
        MyService.ConsoleLog($scope.promises);

        MyService.savePoliticianGrid({
          "records": JSON.stringify($scope.promises)
        }).then(function (payload) {
          MyService.ConsoleLog(payload);
          $scope.Show.Loader = false;
          $scope.reset();
          alert("Data saved successfully.");
        }, function (errorPayload) {
          //MyService.ConsoleLog(errorPayload);
          $scope.Show.Loader = false;
          alert("Error occurred. Please try again after sometime.");
        });

      });

    }


    $scope.saveSelectedRecords = function () {
      //MyService.ConsoleLog($scope.gridApi.selection.getSelectedRows());
      /*
      angular.forEach($scope.gridApi.selection.getSelectedRows(), function(data, index) {
          $scope.gridOptions.data.splice($scope.gridOptions.data.lastIndexOf(data), 1);
      });
      */
      $scope.gridDirtyRows = $scope.gridApi.selection.getSelectedRows();
      $scope.promises = [];
      $scope.Show.Loader = true;
      angular.forEach($scope.gridDirtyRows, function (mvalue, key) {
        //MyService.ConsoleLog("Key>>>", key);
        $scope.subpromises = [];
        //var len = $scope.gridApi.grid.columns.length;
        var j = 0;
        var nobj = new Object;
        var len = $scope.gridApi.grid.columns.length;


        angular.forEach($scope.gridApi.grid.columns, function (subval, subkey) {
          //MyService.ConsoleLog("mvalue<>",mvalue);h
          var nfld = subval.field;
          j++;
          //MyService.ConsoleLog("subval.field<>",mvalue[nfld]);
          //var nobj = new Object;
          if (subval.displayName != "" && subval.displayName != " ") {
            nobj[subval.displayName] = mvalue[nfld];
            //MyService.ConsoleLog(nobj);
          }
          if (j == len) {
            nobj.StatePostalCode = $scope.address.state.statePostalCode;
            nobj.CountyName = $scope.address.county.county;
            $scope.promises.push(nobj);
          }
        });
        //var displayColumn = $scope.checkColumn($scope.gridApi.grid.columns, value);
        // $q.all($scope.subpromises).then(function(value, key) {
        //     //MyService.ConsoleLog($scope.subpromises);
        // });
        //$scope.promises.push($scope.subpromises);
      })
      $q.all($scope.promises).then(function () {
        //MyService.ConsoleLog($scope.promises);
        MyService.savePoliticianGrid({
          "records": JSON.stringify($scope.promises)
        }).then(function (payload) {
          //MyService.ConsoleLog(payload);
          $scope.Show.Loader = false;
          alert("Data saved successfully");
        }, function (errorPayload) {
          $scope.Show.Loader = false;
          alert("Error occurred. Please try again after sometime.");
          //MyService.ConsoleLog(errorPayload);
        });
      });


    }


    $scope.updateRecords = function () {
      $scope.Show.Loader = true;
      $scope.gridDirtyRows = JSON.stringify($scope.gridOptions.data, function (key, value) {
        if (key === "$$hashKey" || key === "__v" || value === null) {
          return undefined;
        }
        return value;
      });
      //MyService.ConsoleLog("gridDirtyRows>>>",$scope.gridDirtyRows);

      MyService.updatePoliticianGrid({
        "records": $scope.gridDirtyRows
      }).then(function (payload) {
        //MyService.ConsoleLog(payload);
        $scope.Show.Loader = false;
        alert("Data updated successfully.");
      }, function (errorPayload) {
        //MyService.ConsoleLog(errorPayload);
        $scope.Show.Loader = false;
        alert("Error occurred. Please try again after sometime.");
      });
    }

    $scope.updateSelectedRecords = function () {
      $scope.Show.Loader = true;
      $scope.gridDirtyRows = JSON.stringify($scope.gridApi.selection.getSelectedRows(), function (key, value) {
        if (key === "$$hashKey" || key === "__v" || value === null) {
          return undefined;
        }
        return value;
      });
      //MyService.ConsoleLog("gridDirtyRows>>>", $scope.gridDirtyRows);
      MyService.updatePoliticianGrid({
        "records": $scope.gridDirtyRows
      }).then(function (payload) {
        //MyService.ConsoleLog(payload);
        $scope.Show.Loader = false;
        alert("Data updated successfully.");
      }, function (errorPayload) {
        //MyService.ConsoleLog(errorPayload);
        $scope.Show.Loader = false;
        alert("Error occurred. Please try again after sometime.");
      });

    }

    $scope.removeDB = function () {
      $scope.Show.Loader = true;
      var allrecords = JSON.stringify($scope.gridApi.selection.getSelectedRows(), function (key, value) {
        if (key === "$$hashKey" || key === "__v" || value === null) {
          return undefined;
        }
        return value;
      });

      var message = 'This action will remove the record from database as well as convert the user type to voter and this cannot be reversed. Do you want to continue?';
      var modal = ngDialog.openConfirm({
        template: '<p>' + message + '</p>\
            <div class="ngdialog-buttons">\
                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">YES</button>\
                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">NO</button>\
            </div>',
        plain: true
      });
      modal.then(function fullfilled(data) {
          MyService.removePoliticianGrid({
            "records": allrecords
          }).then(function (payload) {
            //MyService.ConsoleLog(payload);
            angular.forEach($scope.gridApi.selection.getSelectedRows(), function (data, index) {
              $scope.gridOptions.data.splice($scope.gridOptions.data.lastIndexOf(data), 1);
            });
            $scope.Show.Loader = false;
            alert("Data removed successfully.");
          }, function (errPayload) {
            //MyService.ConsoleLog(errorPayload);
            $scope.Show.Loader = false;
            alert("Error occurred. Please try again after sometime.");
          });
        },
        function (errorPayload) {
          //MyService.ConsoleLog("Error: ", errorPayload);
        });

    }

    $scope.checkifStateExists = function () {
      MyService.checkifStateExists({
        "user": $scope.loginUser
      }).then(function (payload) {
        if (payload > 0) {
          $scope.checkPrevState = true;
        }
      }, function (errorPayload) {
        $scope.checkPrevState = false;
      });
    };

    if ($rootScope.showVUpload) {
      $scope.getAllStates();
      $scope.checkifStateExists();
    }

  }])

'use strict';

angular.module('myApp.uploadFollowers', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/uploadFollowers/:qName?', {
      templateUrl: 'app/uploadFollowers/uploadFollowers.html',
      controller: 'uploadFollowersCtrl'
    });
  }]).controller('uploadFollowersCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', 'baseApiUrl', '$q', '$timeout', 'growl', 'tokenService', '$anchorScroll', '$sce', 'MyService', 'ngDialog', '$cookies', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, baseApiUrl, $q, $timeout, growl, tokenService, $anchorScroll, $sce, MyService, ngDialog, $cookies) {
    $scope.quizName = $routeParams.qName;
    MyService.ConsoleLog("$scope.quizName", $scope.quizName);

    $cookies.remove('isShows');

    /**
     * @Description upload csv file to the server
     * @params data
     * uploadFollowers
     */
    $scope.errorFile = "";
    $scope.uploadFollowers = function (data) {
      MyService.ConsoleLog("data", data);
      $scope.PoliticianButton = true;
      if (data && data.files != "") {
        if (data.files.type.indexOf("office") > -1) {
          MyService.ConsoleLog("data : ", data);
          var quizLink = window.location.origin + '/#!/followersQuiz/' + $scope.quizName + '/' + tokenService.getUserId();
          var fd = new FormData();
          fd.append('file', data.files);
          fd.append('orgId', tokenService.getUserId());
          fd.append('quizName', $scope.quizName);
          fd.append('quizLink', quizLink);

          var posturl = baseApiUrl + "/office/uploadFollowersList";
          $http.post(posturl, fd, {
              transformRequest: angular.identity,
              headers: {
                'Content-Type': undefined
              }
            })
            .then(function (response, status, headers, config) {
              MyService.ConsoleLog("response : ", response);
              $scope.PoliticianButton = false;
              $scope.upload.files = "";
              $scope.upload.opt = "";
              if (response.data.success) {

                MyService.ConsoleLog("data", response);
                $scope.errorFile = response.data.errorfile;
                $scope.PoliticianButton = false;

                growl.success('File uploaded successfully');
                $cookies.put('isShows', true);
                $location.path('/allQuizzes');
              } else {
                // alert("Something went wrong.");
                growl.error(response.data.error);
              }
            }, function (data, status, headers, config) {
              $scope.PoliticianButton = false;
              //MyService.ConsoleLog("error");
            });
        } else {
          $scope.PoliticianButton = false;
          // alert("Please select xlsx file");
          growl.error("Please select xlsx file");
        }
      } else {
        $scope.PoliticianButton = false;

        // alert("Please select file");
        growl.error("Please select file");
      }
    };
  }]);

'use strict';
angular.module('myApp.uploadElectionDate', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/uploadElectionDate', {
      templateUrl: 'app/uploadElectionDate/uploadElectionDate.html',
      controller: 'uploadElectionDateCtrl'
    });
  }]).controller('uploadElectionDateCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'growl', 'tokenService', 'ngDialog', 'baseApiUrl', '$anchorScroll', 'MyService', '$window', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, growl, tokenService, ngDialog, baseApiUrl, $anchorScroll, MyService, $window) {


    $scope.errorFile = "";
    $scope.uploadElectionDates = function (data) {
      $scope.PoliticianButton = true;
      if (data && data.files != "") {
        //MyService.ConsoleLog(data.files.type.indexOf("office"));
        if (data.files.type.indexOf("office") > -1) {
          //MyService.ConsoleLog("data : ", data);
          var fd = new FormData();
          fd.append('file', data.files);

          var posturl = baseApiUrl + "/user/uploadElectionDate";
          $http.post(posturl, fd, {
              transformRequest: angular.identity,
              headers: {
                'Content-Type': undefined
              }
            })
            .then(function (response, status, headers, config) {
              //MyService.ConsoleLog("response : ", response);
              $scope.PoliticianButton = false;
              $scope.upload.files = "";
              $scope.upload.opt = "";
              if (response.data.success) {
                //$location.path('/learnHome');
                MyService.ConsoleLog("data", response);
                $scope.errorFile = response.data.errorfile;
                $scope.PoliticianButton = false;
                //$scope.getAllPolitician();
                alert("File successfully imported.");
              } else {
                alert("Something went wrong.");
              }
            }, function (data, status, headers, config) {
              $scope.PoliticianButton = false;
              //MyService.ConsoleLog("error");
            });
        } else {
          $scope.PoliticianButton = false;
          alert("Please select xlsx file");
        }
      } else {
        $scope.PoliticianButton = false;

        alert("Please select file");
      }
    }

  }]);

"use strict";
angular
  .module("myApp.uploadBarAssociations", ["ngRoute"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/uploadBarAssociations", {
        templateUrl: "app/uploadBarAssociations/uploadBarAssociations.html",
        controller: "uploadBarAssociationsCtrl",
      });
    },
  ])
  .controller("uploadBarAssociationsCtrl", [
    "$scope",
    "$http",
    "$location",
    "apiCall",
    "$routeParams",
    "$rootScope",
    "$q",
    "$timeout",
    "tokenService",
    "MyService",
    "$anchorScroll",
    "$cookies",
    "ngDialog",
    "growl",
    "$window",
    "baseApiUrl",
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $rootScope,
      $q,
      $timeout,
      tokenService,
      MyService,
      $anchorScroll,
      $cookies,
      ngDialog,
      growl,
      $window,
      baseApiUrl
    ) {
      MyService.ConsoleLog("bar Associations");

      $scope.showLoader = false;
      $scope.errorFile = "";

      $scope.uploadBarAssociations = function (data) {
        MyService.ConsoleLog("data >> ", data);

        $scope.showLoader = true;
        if (data && data.files != "") {
          //MyService.ConsoleLog(data.files.type.indexOf("office"));
          if (data.files.type.indexOf("office") > -1) {
            //MyService.ConsoleLog("data : ", data);
            var fd = new FormData();
            fd.append("file", data.files);
            // fd.append('options', data.opt);
            // fd.append('type', data.mtype);
            // fd.append('etype', data.etype);
            // if (data.mtype == "WIN") {
            //   fd.append('state', data.mstate);
            // }
            var posturl = baseApiUrl + "/user/uploadBarAssociations";
            $http
              .post(posturl, fd, {
                transformRequest: angular.identity,
                headers: {
                  "Content-Type": undefined,
                },
              })
              .then(
                function (response, status, headers, config) {
                  //MyService.ConsoleLog("response : ", response);

                  $scope.upload.files = "";

                  if (response.data.success) {
                    //$location.path('/learnHome');
                    $scope.showLoader = false;

                    $scope.errorFile = response.data.errorfile;

                    //$scope.getAllPolitician();
                    alert("File successfully imported.");
                  } else {
                    $scope.showLoader = false;

                    alert("Something went wrong.");
                  }
                },
                function (data, status, headers, config) {
                  $scope.showLoader = false;

                  //MyService.ConsoleLog("error");
                }
              );
          } else {
            alert("Please select xlsx file");
          }
        } else {
          alert("Please select file");
        }
      };
    },
  ]);

'use strict';
angular.module('myApp.uploadBallotMeasures', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/uploadBallotMeasures', {
      templateUrl: 'app/uploadBallotMeasures/uploadBallotMeasures.html',
      controller: 'uploadBallotMeasuresCtrl'
    });
  }]).controller('uploadBallotMeasuresCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'growl', 'tokenService', 'ngDialog', 'baseApiUrl', '$anchorScroll', 'MyService', '$window', '$sce', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, growl, tokenService, ngDialog, baseApiUrl, $anchorScroll, MyService, $window, $sce) {

    $scope.ballot = {
      state: ''
    };
    $scope.showLoader = false;
    $scope.errorFile = "";
    $scope.uploadBallotMeasures = function (data) {
      $scope.PoliticianButton = true;
      if (data && data.files != "") {
        //MyService.ConsoleLog(data.files.type.indexOf("office"));
        if (data.files.type.indexOf("office") > -1) {
          //MyService.ConsoleLog("data : ", data);
          var fd = new FormData();
          fd.append('file', data.files);

          var posturl = baseApiUrl + "/user/uploadBallotMeasures";
          $http.post(posturl, fd, {
              transformRequest: angular.identity,
              headers: {
                'Content-Type': undefined
              }
            })
            .then(function (response, status, headers, config) {
              //MyService.ConsoleLog("response : ", response);
              $scope.PoliticianButton = false;
              $scope.upload.files = "";
              $scope.upload.opt = "";
              if (response.data.success) {
                //$location.path('/learnHome');
                MyService.ConsoleLog("data", response);
                $scope.errorFile = response.data.errorfile;
                $scope.PoliticianButton = false;
                //$scope.getAllPolitician();
                alert("File successfully imported.");
              } else {
                alert("Something went wrong.");
              }
            }, function (data, status, headers, config) {
              $scope.PoliticianButton = false;
              //MyService.ConsoleLog("error");
            });
        } else {
          $scope.PoliticianButton = false;
          alert("Please select xlsx file");
        }
      } else {
        $scope.PoliticianButton = false;

        alert("Please select file");
      }
    };

    /**
     * Get All state
     */
    $scope.allLocations = [];

    $scope.getAllStates = function () {
      $scope.allLocations.length = 0;
      MyService.getAllStates().then(function (data) {
        //MyService.ConsoleLog("got states");
        $scope.allLocations = data;
      }, function (err) {
        //MyService.ConsoleLog("got states error");
        //growl.error("Some");
      });
    };

    /**
     * Get ballot measures statewise
     */
    $scope.getBallotMeasuresStateWise = function (state) {
      MyService.ConsoleLog("state", state);
      $scope.showLoader = true;
      // MyService.ConsoleLog("state", state.statePostalCode);
      $scope.sdata = JSON.parse(state);
      MyService.getBallotMeausres({
        statePostalCode: $scope.sdata.statePostalCode
      }).then(function (response) {
        console.log("response", response);
        $scope.ballotData = response.data.data;
        $scope.showLoader = false;
      }, function (err) {
        console.log("Error", err);
      });
    };

    /**
     * Show pop up for the text
     */
    $scope.MyDialog1 = "";
    $scope.showHtmlViewer = function (content, ttl) {
      // console.log(content);
      $scope.displayContent = $sce.trustAsHtml(content.replace(/(\r\n|\n|\r)/g, "<br />"));
      $scope.MyDialog1 = ngDialog.open({
        template: 'ballotText',
        scope: $scope
        // className: 'ngdialog-theme-default'
      });
    };

    /**
     * Download Ballot measures
     */
    $scope.ShowData = "";
    $scope.showExportLink = true;
    $scope.exportData = function () {
      //alert($scope.StatePostCode);
      $scope.showExportLink = false;
      MyService.exportBallotMeasures({
        "state": $scope.sdata.statePostalCode
      }).then(function (payload) {
        //MyService.ConsoleLog("Success Data", payload);
        $scope.showExportLink = true;
        $window.open($scope.imgUrl + '/ballotSample.xlsx', '_blank');
      }, function (errorPayload) {
        $scope.showExportLink = true;
        //MyService.ConsoleLog("errorPayload : ", errorPayload);
        alert("Something went wrong. Please try again after sometime");
      })
    };

    /**
     * Redirect to the edit page
     */
    $scope.editBill = function (u) {
      $location.path('/editBallotMeasures/' + u._id);
    };

    /**
     * Select ballot measures
     */
    $scope.isSelected = false;
    $scope.SelectChecks = function () {
      //alert($scope.isSelected);
      if ($scope.isSelected == false) {
        $scope.isSelected = true;
        angular.forEach($scope.ballotData, function (val, key) {
          val.checked = true;
        });
      } else {
        $scope.isSelected = false;
        angular.forEach($scope.ballotData, function (val, key) {
          val.checked = false;
        });
      }
      //$scope.isSelected = true;
    };

    /**
     * Delete selected ballot measures
     */
    $scope.rmBoth = false;
    $scope.deleteSelected = function () {
      var tempArr = [];
      var len = $scope.ballotData.length;
      var j = 0;

      angular.forEach($scope.ballotData, function (val, key) {
        j++;
        if (val.checked) {
          tempArr.push(val._id);
        }
        if (j == len) {
          //MyService.ConsoleLog(tempArr);
          if (tempArr.length > 0) {
            var postparam = {
              "user_ids": tempArr.join(",")
            };
            MyService.ConsoleLog("postparam", postparam);
            MyService.removeBallotMeasures(postparam).then(function (result) {
              MyService.ConsoleLog("Results", result);
              growl.success(result.data.data);
              $scope.getBallotMeasuresStateWise(JSON.stringify($scope.sdata));
            }, function (err) {
              MyService.ConsoleLog("Error", err);
            });
          } else {
            growl.error('Please select atleast one record to delete.');
          }
        }

      });
    };
    $scope.getAllStates();
  }]);

'use strict';
angular.module('myApp.uploadAdvocate', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/uploadAdvocates', {
      templateUrl: 'app/uploadAdvocates/uploadAdvocates.html',
      controller: 'UploadAdvocateCtrl'
    });
  }])

  .controller('UploadAdvocateCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'growl', 'tokenService', 'ngDialog', 'baseApiUrl', '$anchorScroll', 'MyService', '$window', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, growl, tokenService, ngDialog, baseApiUrl, $anchorScroll, MyService, $window) {
    $scope.upload = {
      files: '',
      opt: 'Update'
    };
    $scope.showAdvcoatesList = true;
    $scope.showCreate = false;
    $scope.advocates = {
      data: []
    };
    $scope.AdvocateButton = false;
    $scope.getAllAdvocates = function () {
      $scope.advocates.data.length = 0;
      MyService.getAllOrganizations({
        type: "Advocate"
      }).then(function (payload) {
        MyService.ConsoleLog("advData", payload);
        $scope.advocates.data = payload;
      }, function (err) {
        //MyService.ConsoleLog("got states error");
        // growl.error("Some");
      });
    }

    $scope.makeInactive = function (val, id) {
      MyService.inactiveOrg({
        isInactive: val,
        advId: id
      }).then(function (APIResponse) {
        MyService.ConsoleLog('APIResponse', APIResponse);
        growl.success(APIResponse);
        $scope.getAllAdvocates();
      }, function (err) {
        MyService.ConsoleLog("err", err);
      });
    };

    $scope.allLocations = [];
    $scope.getAllStates = function () {
      $scope.allLocations.length = 0;
      MyService.getAllStates().then(function (data) {
        //MyService.ConsoleLog("got states");
        $scope.allLocations = data;
      }, function (err) {
        //MyService.ConsoleLog("got states error");
        // growl.error("Some");
      });
    }

    $scope.updateAdvocates = function (data) {
      MyService.ConsoleLog("data", data);
      if (data.files != "") {
        ////MyService.ConsoleLog(data.files.type.indexOf("office"));
        //alert("This needs to be implemented");
        if (data.files.type.indexOf("office") > -1) {
          $scope.AdvocateButton = true;
          //MyService.ConsoleLog("data : ", data);
          var fd = new FormData();
          fd.append('file', data.files);
          fd.append('options', data.opt);
          var posturl = baseApiUrl + "/user/uploadAdvocate";
          $http.post(posturl, fd, {
              transformRequest: angular.identity,
              headers: {
                'Content-Type': undefined
              }
            })
            .then(function (response, status, headers, config) {
              MyService.ConsoleLog("response : ", response);
              if (response.data.success == true) {
                //$location.path('/learnHome');
                $scope.AdvocateButton = false;
                $scope.advocates.data.length = 0;
                $scope.getAllAdvocates();
                alert("File successfully imported.");
              } else {
                alert("Something went wrong.");
              }
            }, function (err) {

              //MyService.ConsoleLog("error");

            });

        } else {
          alert("Please select xlsx file");
        }

      } else {
        alert("Please select file");
      }

    }


    /**
     * @description Function is use to create user's of org
     */
    $scope.createUserOfOrg = function () {
      $scope.showCreate = true;
      MyService.ConsoleLog("Lets create users");
      MyService.createUsersOfOrg().then(function (APIResponse) {
        MyService.ConsoleLog("APIResponse", APIResponse);
        if (APIResponse && APIResponse.data.success == true) {
          $scope.showCreate = false;
          growl.success(APIResponse.data.data);
        }
      }, function (err) {
        MyService.ConsoleLog("Error", err);
      });
    };

    $scope.checkState = function (rdata, val) {
      return rdata.filter(
        function (rdata) {
          //MyService.ConsoleLog(rdata.statePostalCode + "==" + val);
          if (rdata.statePostalCode == val)
            return rdata
        }
      );
    }
    $scope.showExportLink = true;
    $scope.exportData = function () {
      $scope.showExportLink = false;
      MyService.exportOrganizationData({
        "type": "advocate"
      }).then(function (payload) {
        //MyService.ConsoleLog("Success Data", payload);
        $scope.showExportLink = true;
        $window.open($scope.imgUrl + '/advocate.xlsx', '_blank')
      }, function (errorPayload) {
        $scope.showExportLink = true;
        //MyService.ConsoleLog("errorPayload : ", errorPayload);
        alert("Something went wrong. Please try again after sometime");
      })
    }

    $scope.MyCounties = [];
    $scope.MyPlaces = [];
    $scope.allCounties = [];
    $scope.checkCountyExists = function (rdata, val) {
      return rdata.filter(
        function (rdata) {
          if (rdata._id.county == val)
            return rdata._id
        }
      );
    }

    $scope.checkLocalExists = function (rdata, val, val1) {
      MyService.ConsoleLog("rdata", rdata);
      return rdata.filter(
        function (rdata) {
          if ((rdata._id.place == val) && (rdata._id.countySubdivision == val1))
            return rdata._id
        }
      );
    }

    $scope.getCounties = function (state) {
      $scope.MyCounties.length = 0;
      if (typeof state == "string") {
        state = JSON.parse(state);
      }
      MyService.getAllCounties(state.statePostalCode).then(function (payload) {
          //MyService.ConsoleLog("sublocations Locals : ", payload);
          //$scope.showLoading.length = 0;
          $scope.MyCounties = payload;
          //MyService.ConsoleLog("getCounty checkdata: ", $scope.ShowData.address.county);
          if ($scope.ShowData.address.county) {
            var chkdata = $scope.checkCountyExists(payload, $scope.ShowData.address.county);
            //MyService.ConsoleLog("getCounty checkdata: ", chkdata);
            if (chkdata != "") {

              $scope.ShowData.county = JSON.stringify(angular.copy(chkdata[0]._id));
            }
          }
        },
        function (errorPayload) {
          growl.error('Something went wrong.');
        });
    }
    $scope.allLocals = [];
    $scope.getLocals = function (state, county) {
      if (typeof state == "string") {
        state = JSON.parse(state);
      }
      if (typeof county == "string") {
        county = JSON.parse(county);
      }
      MyService.getAllSubCountiesLocal(state.statePostalCode, county.county).then(function (payload) {
          $scope.MyPlaces = payload;
          //MyService.ConsoleLog("PlaCE :", $scope.ShowData.address.place);
          if ($scope.ShowData.address.place) {
            var chkdata = $scope.checkLocalExists(payload, $scope.ShowData.address.place, $scope.ShowData.address.countySubdivision);
            //MyService.ConsoleLog("getLocal checkdata: ", chkdata[0]);
            if (chkdata != "") {
              var idx = $scope.MyPlaces.indexOf(chkdata[0]);
              //MyService.ConsoleLog(idx);
              //MyService.ConsoleLog(angular.copy($scope.MyPlaces[idx]._id));
              $scope.ShowData.Locality = JSON.stringify(angular.copy($scope.MyPlaces[idx]._id));
            }
          }
        },
        function (errorPayload) {
          growl.error('Something went wrong.');
        });
    }

    $scope.dataIdx = "";
    $scope.showAdvocate = function (data, idx) {
      //MyService.ConsoleLog(data);
      $scope.ShowData = data;
      MyService.ConsoleLog("data : ", data);
      $scope.dataIdx = $scope.advocates.data.indexOf(data);
      try {
        MyService.ConsoleLog("data.address", data.address);
        var chkData = $scope.checkState($scope.allLocations, data.address.statePostalCode);
        //MyService.ConsoleLog("chkData : ", chkData[0]);
        $scope.getCounties(data.address);
        $scope.getLocals(data.address, data.address);
        $scope.ShowData.stateData = JSON.stringify(chkData[0]);
      } catch (e) {
        MyService.ConsoleLog("Show Advocate Exception: ", e);
      }

      $scope.showAdvcoatesList = false;
    }



    $scope.updateAdvocatesData = function (data) {

      if ($.fn.validateForceFully($("#advcateform")) == true) {
        var state = JSON.parse(data.stateData);
        var county = JSON.parse(data.county);
        var place = JSON.parse(data.Locality);
        //data.address =
        data.state = state;
        data.contact_person = JSON.stringify(data.contact_person);
        data.county = county;
        data.place = place;
        //MyService.ConsoleLog(data);
        var chkData = $scope.checkState($scope.allLocations, place.statePostalCode);
        //MyService.ConsoleLog("chkData : ", chkData[0]);
        if (chkData[0]) {
          data.statename = chkData[0].state;
        }


        MyService.updateAdvocateData(data).then(function (payload) {
          //MyService.ConsoleLog("payload : ", payload);
          data.contact_person = JSON.parse(data.contact_person);
          $scope.advocates.data[$scope.dataIdx] = data;

          $scope.showAdvcoatesList = true;

        }, function (err) {
          alert("Something went wrong");
        })
      }
    }

    $scope.registerAdvocateData = function (data) {
      if ($.fn.validateForceFully($("#advcateform")) == true) {
        if ((data.contact_person.email != "") && (data.contact_person.email != null)) {
          var state = JSON.parse(data.stateData);
          var county = JSON.parse(data.county);
          var place = JSON.parse(data.Locality);
          //data.address =
          data.state = state;
          data.contact_person = JSON.stringify(data.contact_person);
          data.county = county;
          data.place = place;
          //MyService.ConsoleLog(data);
          var chkData = $scope.checkState($scope.allLocations, place.statePostalCode);
          //MyService.ConsoleLog("chkData : ", chkData[0]);
          if (chkData[0]) {
            data.statename = chkData[0].state;
          }


          MyService.registerAdvocateData(data).then(function (payload) {
            //MyService.ConsoleLog("payload : ", payload);
            //data.contact_person = JSON.parse(data.contact_person);
            MyService.updateAdvocateData(data).then(function (payload) {
              //MyService.ConsoleLog("payload : ", payload);
              data.contact_person = JSON.parse(data.contact_person);
              $scope.advocates.data[$scope.dataIdx] = data;
              $scope.showAdvcoatesList = true;
            }, function (err) {
              alert("Something went wrong");
            })
          }, function (err) {
            alert("Something went wrong");
          })
        } else {
          alert("Please enter email ID to create user");
        }

      }
    }

    $scope.goBack = function () {
      $scope.showAdvcoatesList = true;
    }

    if ($rootScope.showAdvocates) {
      $scope.getAllAdvocates();
      $scope.getAllStates();
      $("#advcateform").validationEngine();
    }

  }])

'use strict';
angular.module('myApp.updateTopic', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/updateTopic/:categoryId/:subcatId/:type/:topicId', {
      templateUrl: 'app/updateTopic/updateTopic.html',
      controller: 'updateTopicCtrl'
    });
  }])
  .controller('updateTopicCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'growl', 'tokenService', 'MyService', 'ngDialog', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, growl, tokenService, MyService, ngDialog) {
    $scope.TopicButton = false;
    $rootScope.welcome = false;
    $scope.uData = JSON.parse(tokenService.getUserData());
    $scope.location = ['National', 'State', 'County', 'Local'];
    $scope.categoryId = $routeParams.categoryId;
    $scope.subcatId = $routeParams.subcatId;
    $scope.topicId = $routeParams.topicId;
    $scope.ShowLocationOptions = false;
    $scope.Topic = {
      title: '',
      description: '',
      location: 'National',
      restrictedTo: 'No Restrictions',
    };

    $scope.subCatArr = [];

    $scope.restrictedOptions = ['Locals Only', 'My County', 'My State', 'National', 'No Restrictions'];
    if (!$rootScope.UserId) {
      $location.path('signin');
    }

    if ((!$routeParams.categoryId) && (!$routeParams.subcatId)) {
      $location.path('debateHome');
    }

    if (!$routeParams.topicId) {
      $location.path('forumList/' + $routeParams.categoryId + '/' + $routeParams.subcatId + '/' + $routeParams.type);
    }

    $scope.mainCatIds = [];
    $scope.mainCatIds.push($routeParams.categoryId);
    if ($routeParams.categoryId && $routeParams.subcatId) {
      $scope.subCatArr.push($routeParams.categoryId);
      $scope.subCatArr.push($routeParams.subcatId);

    } else if ($routeParams.categoryId) {
      $scope.subCatArr.push($routeParams.categoryId);
    } else {
      $scope.subCatArr.push($routeParams.subcatId);
    }
    console.log('$scope.subCatArr :>> ', $scope.subCatArr);

    if (window.localStorage.getItem("VoteWiseCategory")) {
      $rootScope.allcategories = JSON.parse(window.localStorage.getItem("VoteWiseCategory"));
      var idx = $rootScope.allcategories.indexOf($routeParams.subcatId);
      if (idx == -1) {
        $rootScope.allcategories.push($routeParams.subcatId);
        window.localStorage.setItem("VoteWiseCategory", JSON.stringify($rootScope.allcategories));
      }
    }
    //MyService.ConsoleLog("Final categories : ", window.localStorage.getItem("VoteWiseCategory"));
    $scope.subtopics = {
      subcategories: []
    };

    $scope.selectedCat = [];
    $scope.SelectedTree = [];
    $scope.disabled = [];

    $scope.checkPostalExists = function (rdata, val) {
      return rdata.filter(
        function (rdata) {
          if (rdata.statePostalCode == val)
            return rdata
        }
      );
    }
    $scope.getTopicDetails = function () {
      MyService.getOneTopic({
        topicId: $routeParams.topicId
      }).then(function (payload) {
        //MyService.ConsoleLog("payload : ", payload);
        //$scope.froumthreads = payload;
        $scope.Topic = payload.data[0];
        MyService.ConsoleLog($scope.Topic);
        var newDescription = $scope.Topic.description;
        $scope.Topic.description = newDescription.replace("...(updated)", "");
        //MyService.ConsoleLog("newDescripttion : ", newDescription);


        var locations = $scope.Topic.location;
        var nobj = {
          country: "National (USA)"
        }

        var idx = indexOfExt($scope.selectedArea, nobj);
        if (idx > -1) {
          $scope.selectedArea.splice(idx, 1);
        }
        $scope.Essay = {
          National: "",
          Locations: ""
        };
        var len = locations.length;
        $scope.selectedArea.length = 0;
        $scope.showSubCat = true;
        $scope.disabledLocation.length = 0;
        for (var l = 0; l < len; l++) {
          var nobj = {};

          if (locations[l].country) {

            if (locations[l].country == "National (USA)") {
              $scope.Essay.National = "National";

            }
            if (locations[l].country == "International") {
              $scope.Essay.Locations = "International";
            }
            nobj.country = locations[l].country;
            // MyService.ConsoleLog("$scope.Essay", $scope.Essay);
          }
          if (locations[l].state) {
            nobj.state = locations[l].state;
            nobj.statePostalCode = locations[l].statePostalCode;
          } else if (locations[l].statePostalCode) {
            var chkdata = $scope.checkPostalExists($scope.allLocations, locations[l].statePostalCode);
            //MyService.ConsoleLog("chkdata : ",chkdata);
            if (chkdata) {

              nobj.state = chkdata[0].state;
              nobj.statePostalCode = chkdata[0].statePostalCode;
            }
          }
          if (locations[l].county) {
            nobj.county = locations[l].county;
          }
          if (locations[l].countySubdivision) {
            nobj.countySubdivision = locations[l].countySubdivision;
          }
          if (locations[l].place) {
            nobj.place = locations[l].place;
          }
          // MyService.ConsoleLog("nobj", nobj);
          $scope.selectedArea.push(nobj);
          $scope.disabledLocation.push(nobj);
        }
        MyService.ConsoleLog("$scope.selectedArea:", $scope.selectedArea);
        MyService.ConsoleLog("Disable:", $scope.disabledLocation);
        $scope.getSubcatTree();
      }, function (errorPayload) {
        //MyService.ConsoleLog(errorPayload);
        if (errorPayload.data) {
          alert("Error : " + errorPayload.data);
        } else {
          //MyService.ConsoleLog("Something went wrong");
        }

      });
    }
    $scope.getParentId = function (childId) {
      MyService.getParentCat({
        id: childId
      }).then(function (APIResponse) {
        MyService.ConsoleLog("APIResponse", APIResponse);
        if (APIResponse && APIResponse.data.success) {
          var cobj = new Object();

          cobj.path = "," + APIResponse.data.data.parentIds[0].pid + "," + childId + ",";
          cobj.pid = childId;
          cobj.viewOrder = 1;
          $scope.SelectedTree.push(cobj);

          // APIResponse.data.data.parentIds[0].pid;
        } else {
          cobj.pid = childId;
          cobj.viewOrder = 1;

          cobj.path = "," + childId + ",";
          $scope.SelectedTree.push(cobj);
        }
        MyService.ConsoleLog("second", $scope.SelectedTree);
      }, function (err) {
        MyService.ConsoleLog("err", err);
      });
    };

    $scope.isGeneral = false;
    $scope.getVal = function (data) {
      MyService.ConsoleLog(" getVal :", data);

      var idx = $scope.selectedCat.indexOf(data);
      if (idx > -1) {
        $scope.selectedCat.splice(idx, 1);
        var id = $scope.disabled.indexOf(data._id);
        $scope.disabled.splice(id, 1);
        var jdx = $scope.SelectedTree.indexOf(data.parentIds);
        if (jdx > -1)
          $scope.SelectedTree.splice(jdx, 1);

      } else {
        // MyService.ConsoleLog("ss")
        $scope.selectedCat.push(data);
        if (data && data.subcategories && data.subcategories.length > 0) {
          data.subcategories.filter(function (itm) {

            var inx = itm.title.indexOf('General');
            if (inx > -1) {
              MyService.ConsoleLog("itm", itm);
              $scope.mainCatIds.push(data._id);
              $scope.isGeneral = true;
              $scope.subId = itm._id;
              if (itm && itm.subcategories && itm.subcategories.length > 0) {
                $scope.superSub = itm.subcategories[0];
              }
              $scope.selectedCat.push(itm);
            }
          });
        }
        MyService.ConsoleLog("mainCatIds", $scope.mainCatIds);
        var id = $scope.disabled.indexOf(data._id);
        if (id == -1) {
          $scope.disabled.push(data._id);
        }
        MyService.ConsoleLog("paren", data.parentIds);
        MyService.ConsoleLog("SelectedTree: ", $scope.SelectedTree);
        if ($scope.SelectedTree.length == 0) {
          if (data.parentIds.length > 0) {
            //var parents = Object.keys(data.parentIds).map(function (key) {return data.parentIds[key]});
            //angular.copy(data.parentIds, $scope.SelectedTree);
            var parents = data.parentIds;
            //MyService.ConsoleLog(parents);
            $scope.SelectedTree = parents;
          } else {
            MyService.ConsoleLog(" $scope.subId ", $scope.subId);
            var cobj = new Object;
            if ($scope.isGeneral == true && $scope.subId != '') {
              cobj.pid = data._id;
              cobj.viewOrder = 1;
              if ($scope.superSub) {
                cobj.path = "," + data._id + "," + $scope.subId + "," + $scope.superSub._id + ",";
              } else {
                cobj.path = "," + data._id + "," + $scope.subId + ",";
              }
              // cobj.path = "," + data._id + "," + $scope.subId + ",";
              $scope.SelectedTree.push(cobj);
            } else {
              // cobj.pid = data._id;
              // cobj.viewOrder = 1;

              // cobj.path = "," + data._id + ",";
              // $scope.SelectedTree.push(cobj);
              $scope.getParentId(data._id);
            }

            //"pid":"57987dfb31411a7f224cf01e","viewOrder":6,"path":",57987dfb31411a7f224cf01e,"
          }
        } else {
          if (data.parentIds.length > 0) {
            //var parents = Object.keys(data.parentIds).map(function (key) {return data.parentIds[key]});
            var parents = angular.copy(data.parentIds);
            //var parents = data.parentIds;
            var plen = parents.length;
            for (var j = 0; j < plen; j++) {
              var jdx = indexOfExt($scope.SelectedTree, parents[j]);
              //MyService.ConsoleLog(jdx);
              if (jdx == -1) {
                $scope.SelectedTree.push(parents[j]);
                // MyService.ConsoleLog("parents[j]",parents[j]);
                if ($scope.isGeneral == true && $scope.subId != '') {
                  var obj = {};
                  obj.pid = data._id;
                  obj.viewOrder = 1;
                  obj.path = "," + data._id + "," + $scope.subId + ",";
                  var sjdx = indexOfExt($scope.SelectedTree, obj);
                  if (sjdx == -1) {
                    MyService.ConsoleLog("Obj", obj);
                    $scope.SelectedTree.push(obj);
                  }
                }

              }
            }
          } else {

            var cobj = new Object;
            cobj.pid = data._id;
            cobj.viewOrder = 1;

            if ($scope.isGeneral == true && $scope.subId != '') {
              if ($scope.superSub) {
                cobj.path = "," + data._id + "," + $scope.subId + "," + $scope.superSub._id + ",";
              } else {
                cobj.path = "," + data._id + "," + $scope.subId + ",";
              }

              MyService.ConsoleLog("is", cobj.path);
              $scope.SelectedTree.push(cobj);
            } else {
              MyService.ConsoleLog("issssss");
              // cobj.path = "," + data._id + ",";
              $scope.getParentId(data._id);
            }

            //"pid":"57987dfb31411a7f224cf01e","viewOrder":6,"path":",57987dfb31411a7f224cf01e,"
          }
        }
      }
      MyService.ConsoleLog("$scope.SelectedTree", $scope.SelectedTree);
    }


    $scope.selectedAll = {
      id: []
    };
    $scope.removeVal = function (data) {
      var idx = $scope.selectedCat.indexOf(data);
      MyService.ConsoleLog("data", data);
      MyService.ConsoleLog("idx", idx);
      MyService.ConsoleLog("$scope.selectedCat", $scope.selectedCat);
      if (idx > -1) {
        if ($scope.selectedCat[idx].title.indexOf('General') > -1) {

          $scope.selectedCat.filter(function (itms, ind) {
            if (itms._id == $scope.selectedCat[idx]._id) {
              MyService.ConsoleLog(" $scope.selectedCat[idx]", itms._id + "==" + $scope.selectedCat[idx]._id);
              MyService.ConsoleLog("yes", ind);
              // $scope.selectedCat.splice(ind, 1);
            }
          });
          var indx = $scope.selectedCat.indexOf(data);
          $scope.selectedCat.splice(indx, 1);
        } else {
          $scope.selectedCat.splice(idx, 1);
        }

        var id = $scope.disabled.indexOf(data._id);
        $scope.disabled.splice(id, 1);
        if (data && data.parentIds && data.parentIds.length > 0) {
          var parents = data.parentIds;

          var plen = parents.length;

          for (var j = 0; j < plen; j++) {
            var jdx = $scope.SelectedTree.indexOf(parents[j]);
            if (jdx > -1) {
              $scope.SelectedTree.splice(jdx, 1);
            } else {
              $scope.SelectedTree.filter(function (itms) {
                MyService.ConsoleLog("chek ind", itms.pid.indexOf(parents[j].pid));
                var idx = itms.pid.indexOf(parents[j].pid);
                if (idx > -1) {
                  $scope.SelectedTree.splice(idx, 1);
                  var id = $scope.disabled.indexOf(parents[j].pid);
                  $scope.disabled.splice(id, 1);
                  if ($scope.SelectedTree.length == 0) {
                    MyService.ConsoleLog("$scope.selectedCat", $scope.selectedCat);
                    $scope.selectedCat.filter(function (itm) {
                      var obj = new Object();
                      obj.pid = itm._id;
                      obj.path = "," + itm._id + ",";
                      obj.viewOrder = 1;
                      $scope.SelectedTree.push(obj);
                    });
                  }
                }

              });
            }
          }
        } else {
          $scope.SelectedTree.filter(function (itms, ind) {
            var paths = "," + data._id + ",";

            var isContaines = itms.path.includes(paths);
            // MyService.ConsoleLog("isContaines", typeof isContaines);
            if (isContaines == true) {
              MyService.ConsoleLog("isContaines", isContaines);
              MyService.ConsoleLog("ind", ind);
              $scope.SelectedTree.splice(ind, 1);
            }
          });
        }
      }
      var idsX = $scope.allParentIds.indexOf(data._id);
      $scope.allParentIds.splice(idsX, 1);
      // MyService.ConsoleLog("path cat", $scope.allParentIds);
      // $scope.selectedAll.id.length = 0;
      MyService.ConsoleLog("$scope.SelectedTree", $scope.SelectedTree);
      var allLen = $scope.allParentIds.length;
      MyService.ConsoleLog("allLen", allLen);
      var chkboxe = document.getElementsByName("checkedidcat");
      // MyService.ConsoleLog("$scope.selectedAll", $scope.selectedAll);

      for (var i = 0; i < allLen; i++) {

        chkboxe[i].checked = true;

      }

    }

    $scope.selectConfig = {
      requiredMin: 1,
      selectAll: true
    };

    function areEqual() {
      var len = arguments.length;
      for (var i = 1; i < len; i++) {
        if (arguments[i] == null || arguments[i] != arguments[i - 1])
          return false;
      }
      return true;
    }

    function indexOfExt(list, item) {
      var len = list.length;
      for (var i = 0; i < len; i++) {
        var keys = Object.keys(list[i]);
        var flg = true;
        var arr = [];
        for (var j = 0, s = 1; j < keys.length; j++, s++) {
          var value = list[i][keys[j]];
          //MyService.ConsoleLog("value :" + value + "-----Item : " + item[keys[j]]);
          //MyService.ConsoleLog(typeof value + "===" + typeof item[keys[j]]);
          if ((typeof value != "object") && (typeof item[keys[j]] != "object")) {
            if (item[keys[j]] !== value) {
              flg = false;
              //MyService.ConsoleLog("flg : ", typeof item[keys[j]], typeof value);
            }
          }
          if (item[keys[j]] == value) {
            arr.push(flg);
          } else if ((typeof value == "object") && (typeof item[keys[j]] == "object")) {
            arr.push(flg);
          }
        }
        if (flg == true) {
          //MyService.ConsoleLog(arr.length + "-----" + keys.length + "-----" + Object.keys(item).length);
          if (areEqual(arr.length, keys.length, Object.keys(item).length)) {
            return i;
          }
        }
      }
      return -1;
    }

    $scope.checksubCatExists = function (rdata, val) {
      return rdata.filter(
        function (rdata) {
          if (rdata.pid) {
            var idx = indexOfExt($scope.selectedCat, val);
            if (idx == -1) {
              $scope.selectedCat.push(val);
            }
            return rdata
          }
        }
      );
    }

    $scope.checkCatExists = function (rdata, val) {

      return rdata.filter(function (rsdata) {

        if (rsdata._id == val) {
          MyService.ConsoleLog("rdata", rsdata._id + "====" + val);
          return rsdata;
          // MyService.ConsoleLog("parentIds : ", rsdata);
          // if (rdata.parentIds.length > 0) {
          //   var parents = rdata.parentIds.length;
          //   for (var j = 0; j < parents; j++) {
          //     var newd = angular.copy(rdata.parentIds[j]);
          //     //MyService.ConsoleLog("newd:", newd);
          //     //MyService.ConsoleLog("SelectedTree:", $scope.SelectedTree);
          //     var jdx = indexOfExt($scope.SelectedTree, newd);
          //     //MyService.ConsoleLog(jdx);
          //     if (jdx == -1) {
          //       $scope.SelectedTree.push(newd);
          //     }
          //   }
          // }
          // if (rdata.parentIds.length > 1) {
          //   var idx = indexOfExt($scope.selectedCat, angular.copy(rdata));
          //   if (idx == -1) {
          //     $scope.selectedCat.push(angular.copy(rdata));
          //   }
          // } else {
          //   $scope.selectedCat.push(angular.copy(rdata));
          // }

        } else if (rsdata.subcategories) {

          $scope.checkCatExists(rsdata.subcategories, val);
        }
      });
    };

    $scope.getSubcatTree = function () {
      $scope.selectedCat.length = 0;
      $scope.EssayButton = true;
      MyService.getAllCatTree({
        "type": "F"
      }).then(function (payload) {
          $scope.subtopics.subcategories.length = 0;
          var subcatdata = payload;
          MyService.ConsoleLog("subcatdata : ", subcatdata);
          $scope.disabled.length = 0;
          //$scope.disabled.push(window.localStorage.getItem("VoteWiseParentCategory"));
          $scope.disabled = $scope.Topic.parentCat;
          //MyService.ConsoleLog("subcat : ", $scope.disabled);
          $scope.subtopics.subcategories = subcatdata;

          MyService.ConsoleLog("$scope.Topic.", $scope.Topic.parentCat);
          // var pIds = [];
          // $scope.Topic.subCategories.filter(function (itms) {
          //   pIds.push(itms.pid);
          // });
          // MyService.ConsoleLog("pIds", pIds);
          var selectedCat = $scope.Topic.parentCat;
          // $scope.pCatId = $scope.Topic.parentCat[0];
          var catArr = [],
            selectCatsss = [];
          if (selectedCat && selectedCat.length > 0) {
            // for (var s = 0; s < selectedCat.length; s++) {
            // var checkcatdata = $scope.checkCatExists(subcatdata, selectedCat[s]);
            // MyService.ConsoleLog("checkcatdata", checkcatdata);
            // if (checkcatdata && checkcatdata.length > 0) {
            MyService.getSubCatUsingIds({
              ids: selectedCat
            }).then(function (APIResponse) {
                // MyService.ConsoleLog("APIResponse", APIResponse)
                if (APIResponse.data.success) {
                  $scope.multiCats = APIResponse.data.data;
                  MyService.ConsoleLog("$scope.", $scope.multiCats)
                  $scope.multiCats.filter(function (item) {
                    if (item && item.subcategories && item.subcategories.length > 0) {
                      // if (item._id != $scope.categoryId) {
                      var tmp = item.subcategories.filter(function (ele) {
                        if (ele.title.indexOf('General') > -1) {
                          $scope.mainCatIds.push(item._id);
                          catArr.push(ele);
                          var nwObjs = {};
                          nwObjs.pid = item._id;
                          nwObjs.viewOrder = 1;
                          nwObjs.path = "," + item._id + ',' + ele._id + ",";
                          selectCatsss.push(nwObjs);
                        }
                      });
                      // }

                    } else {
                      selectCatsss = selectCatsss.concat($scope.Topic.subCategories);
                      catArr.push(item);

                    }

                    // return item;
                  });
                  // catArr = catArr.concat(checkcatdata);
                  MyService.ConsoleLog("catArr", catArr);
                  var sml = catArr.filter(function (itms, ind) {
                    return ind == catArr.findIndex(function (ele) {
                      return JSON.stringify(ele) == JSON.stringify(itms);
                    });
                  });
                  $scope.allParentIds = sml.map(function (eles) {
                    return eles._id;
                  });
                  $scope.selectedCat = "";
                  $scope.selectedCat = sml;
                  MyService.ConsoleLog("this is ", $scope.selectedCat);
                  MyService.ConsoleLog("$scope.SelectedTree", $scope.SelectedTree);
                  $scope.SelectedTree = selectCatsss;
                }

              },
              function (err) {
                MyService.ConsoleLog("Err", err);

              });

            // }

            // }



          }
          $scope.EssayButton = false;
          setTimeout(function () {
            var cols = document.getElementsByClassName('cmnUL');
            var clen = cols.length;
            for (var i = 0; i < clen; i++) {
              cols[i].style.display = "none";
            }
          }, 300);
        },
        function (errorPayload) {
          alert('Something went wrong.');
        });
    }

    $scope.showSubCat = true;
    $scope.showLoading = [];
    $scope.showLoadingCounty = [];
    $scope.showDown = [];

    $scope.ChangeShow = function (id) {
      //$scope.showSubCat = true;
      //var cols = document.getElementsByClassName('cmnUL');
      //var clen = cols.length;

      var nclass = "MainCatLi_" + id;
      if ((document.getElementsByClassName(nclass)[0].style.display) && (document.getElementsByClassName(nclass)[0].style.display == "none")) {
        document.getElementsByClassName(nclass)[0].style.display = "block";
      } else {
        document.getElementsByClassName(nclass)[0].style.display = "none";
      }
    }

    $scope.AddLocation = false;
    $scope.newlocation = {
      country: ''
    };
    $scope.Allcountries = [];
    $scope.SelectedCountry = '';

    $scope.ShowAddLocation = function () {
      if (!$scope.AddLocation) {
        $scope.AddLocation = true;
      } else {
        $scope.AddLocation = false;
      }

    }

    function suggest_country(term) {
      var q = term.toLowerCase().trim();
      var results = [];
      var len = $scope.Allcountries.length;
      // Find first 10 states that start with `term`.
      for (var i = 0; i < len && results.length < 10; i++) {
        var country = $scope.Allcountries[i];
        if (country.toLowerCase().indexOf(q) === 0)
          results.push({
            label: country,
            value: country
          });
      }
      return results;
    }

    $scope.autocomplete_options = {
      suggest: suggest_country
    };

    $scope.getAllStates = function () {
      MyService.getAllStates().then(function (payload) {
          $scope.allLocations.length = 0;
          var subcatdata = payload;
          //MyService.ConsoleLog("countires : ", subcatdata);
          $scope.allLocations = subcatdata;


        },
        function (errorPayload) {
          alert('Something went wrong ');
        });

    }

    $scope.allLocations = [];
    $scope.allCounties = [];
    $scope.selectedArea = [];
    $scope.rmselectedArea = [];
    $scope.myselectionarea = [];
    $scope.disabledLocation = [];

    $scope.checkExists = function (rdata, val) {
      return rdata.filter(
        function (rdata) {
          if (rdata.state == val)
            return rdata
        }
      );
    }

    $scope.checkCountyExists = function (rdata, val) {
      return rdata.filter(
        function (rdata) {
          if (rdata.county == val)
            return rdata
        }
      );
    }

    $scope.checkCountryExists = function (rdata, val) {
      return rdata.filter(
        function (rdata) {
          if (rdata.country == val)
            return rdata
        }
      );
    }

    $scope.checkDisabled = function (data, stateId, type) {

      data.country = "United States of America";
      data.state = stateId;

      var idx = indexOfExt($scope.disabledLocation, data);
      if (idx > -1)
        return true;
      else
        return false;


    }

    $scope.getAreaVal = function (data, stateId, type) {

      if (!data.country) {
        data.country = "United States of America";
      }
      if (!data.state) {
        data.state = stateId;
      }



      var idx = indexOfExt($scope.selectedArea, data);


      if (idx > -1) {
        alert("You have already selected the location");
      } else {

        $scope.selectedArea.push(data);
        $scope.disabledLocation.push(data);

      }

      //MyService.ConsoleLog($scope.disabledLocation);
    }
    $scope.selectedLAll = {
      id: []
    };
    $scope.removeAreaVal = function (data) {
      var idx = $scope.selectedArea.indexOf(data);

      //MyService.ConsoleLog($scope.Topic.Locations);
      if (idx > -1) {
        //MyService.ConsoleLog("Country:",$scope.selectedArea[idx].country);
        if ($scope.selectedArea[idx].country == "International") {
          $scope.Topic.Locations = 'NO';
        }
        if ($scope.selectedArea[idx].country == "National (USA)") {
          $scope.Topic.National = 'NO';
        }
        $scope.selectedArea.splice(idx, 1);
        var jdx = $scope.disabledLocation.indexOf(data);
        if (jdx > -1) {
          $scope.disabledLocation.splice(jdx, 1);
        }
      }
      $scope.selectedLAll.id.length = 0;
      //MyService.ConsoleLog($scope.selectedArea);
      var allLen = $scope.selectedArea.length;
      var chkboxe = document.getElementsByName("checkedid");
      for (var i = 0; i < allLen; i++) {
        chkboxe[i].checked = true;

      }

    }
    $scope.allCounties = [];
    $scope.allLocals = [];
    $scope.setLocation = function (option) {
      $scope.Essay.location = option;
    }
    $scope.getLocations = function (val, type) {
      if (type == "National") {
        if (val == "National") {

          var nobj = {
            country: "National (USA)"
          }
          $scope.selectedArea.push(nobj);
          //MyService.ConsoleLog($scope.selectedArea);
        }
        if (val == "NO") {

          var nobj = {
            country: "National (USA)"
          }
          var idx = indexOfExt($scope.selectedArea, nobj);
          if (idx > -1) {
            $scope.selectedArea.splice(idx, 1);
          }
        }
      } else if (type == "International") {
        if (val == "International") {
          // $scope.selectedArea.length = 0;
          var nobj = {
            country: "International"
          }
          $scope.selectedArea.push(nobj);

        }
        if (val == "NO") {
          // $scope.selectedArea.length = 0;
          var nobj = {
            country: "International"
          }
          var idx = indexOfExt($scope.selectedArea, nobj);
          if (idx > -1) {
            $scope.selectedArea.splice(idx, 1);
          }
        }
      }
    }

    $scope.AddCountry = function () {
      if (($scope.newlocation.country) && ($scope.newlocation.country != '')) {
        var idx = $scope.Allcountries.indexOf($scope.newlocation.country);
        if (idx > -1) {
          var nobj = {
            country: $scope.newlocation.country
          };
          $scope.selectedArea.push(nobj);
        } else {
          alert("Country does not exists in our database. Please check if you have entered correct name.");
        }
      } else {
        alert("Please enter country name");
      }
    }

    $scope.getCounties = function (state) {
      $scope.showLoading.push(state);
      if (!$scope.allCounties[state] || $scope.allCounties[state].length == 0) {
        MyService.getAllCounties(state).then(function (payload) {
            $scope.showLoading.length = 0;
            var sublocations = payload;
            if (!$scope.allCounties) {
              $scope.allCounties = [];
            }
            $scope.allCounties[state] = sublocations;
          },
          function (errorPayload) {
            alert('Something went wrong.');
          });

      } else {
        $scope.showLoading.length = 0;
        $scope.allCounties[state].length = 0;
      }
    }

    $scope.getLocals = function (state, county) {
      $scope.showLoadingCounty.push(county);
      if (!$scope.allLocals[state] || !$scope.allLocals[state][county] || $scope.allLocals[state][county].length == 0) {
        MyService.getAllSubCountiesLocal(state, county).then(function (payload) {
            $scope.showLoadingCounty.length = 0;
            //MyService.ConsoleLog("sublocations Locals : ", sublocations);
            if (!$scope.allLocals[state]) {
              $scope.allLocals[state] = [];
            }
            $scope.allLocals[state][county] = payload;
          },
          function (errorPayload) {
            alert('Something went wrong ');
          });
      } else {
        $scope.showLoadingCounty.length = 0;
        $scope.allLocals[state][county].length = 0;
      }
    }

    $scope.ShowLocation = function () {
      $scope.ShowLocationOptions = true;
      MyService.getAllCountries().then(function (payload) {
          $scope.Allcountries = payload;
        },
        function (errorPayload) {
          alert('Something went wrong ');
        });
      $scope.getAllStates();
    }

    $scope.SubmitTopic = function (data) {
      if ($.fn.validateForceFully($("#topicform")) == true) {
        //$scope.TopicButton = true;
        data.parentcat = JSON.stringify($scope.disabled);
        var subcat = [];
        MyService.ConsoleLog("$scope.SelectedTree", $scope.SelectedTree);
        subcat = JSON.stringify($scope.SelectedTree);
        data.topicId = $routeParams.topicId;
        data.description = data.description + "...(updated)";
        data.subcategories = subcat;
        data.createdById = tokenService.getUserId();
        data.createdByName = tokenService.getUserName();
        data.createdByType = tokenService.getUserRole();
        if ($scope.selectedArea.length > 0) {
          data.location = JSON.stringify($scope.selectedArea);
        } else {
          var arr = [];
          var acountry = "";
          if ($scope.uData.address.country == null) {
            acountry = "United States of America";
          } else {
            acountry = $scope.uData.address.country;
          }
          var obj = {
            country: acountry,
            state: $scope.uData.address.state,
            statePostalCode: $scope.uData.address.statePostalCode,
            county: $scope.uData.address.county,
            countySubdivision: $scope.uData.address.countySubdivision,
            place: $scope.uData.address.place
          }
          arr.push(obj);
          data.location = JSON.stringify(arr);
        }


        MyService.ConsoleLog("updated Data", data);
        //MyService.ConsoleLog($scope.selectedArea);
        // return;
        MyService.updateTopic(data).then(function (response) {

          if (response.data.success) {
            if (response.data.data.nModified == 0) {
              alert("Something went wrong. Thread is not updated, please try after sometime.");
            } else {
              alert("Thread updated successfully.");
              $location.path('forumList/' + $routeParams.categoryId + '/' + $routeParams.subcatId + '/' + $routeParams.type);
            }
          } else {
            if (response.data.error) {
              alert(response.data.error);
              //MyService.ConsoleLog(response.data);
              if ((response.data.status) && (response.data.status == "405")) {
                var msg = "Do you want to send request to Admin to reactivate your account?.";
                MyService.GetDialogWithButtons(ngDialog, msg, "YES", "NO").then(function (payload) {
                  MyService.sendActivatationMailtoAdmin().then(function (payload) {
                    alert("Request sent successfully to admin");
                  }, function (errorPayload) {
                    alert("Something went wrong");
                  })
                }, function (errorPayload) {
                  //MyService.ConsoleLog(errorPayload);
                });
              }
            }
          }
        }, function (errorPayload) {
          //MyService.ConsoleLog("Error: ", response);
        });
      }
    }

    $scope.goBack = function () {
      $location.path('forumList/' + $routeParams.categoryId + '/' + $routeParams.subcatId + '/' + $routeParams.type);


    }

    if ($routeParams.topicId) {
      $scope.ShowLocation();
      $scope.getTopicDetails();

      $("#topicform").validationEngine();
    }




  }]);

'use strict';
angular.module('myApp.upcomingElection', ['ngRoute'])

  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/upcomingElection', {
      templateUrl: 'app/upcomingElection/upcomingElection.html',
      controller: 'upcomingElectionCtrl'
    });
  }])
  .controller('upcomingElectionCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService) {

  }]);
'use strict';
angular.module('myApp.trackUserActivities', ['ngRoute'])
  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/trackUserActivities', {
        templateUrl: 'app/trackUserActivities/trackUserActivities.html',
        controller: 'trackUserActivitiesCtrl'
      });
    }
  ])
  .controller('trackUserActivitiesCtrl', [
    '$scope',
    'ngDialog',
    '$rootScope',
    'MyService',
    '$routeParams',
    '$q',
    "growl",
    function ($scope, ngDialog, $rootScope, MyService, $routeParams, $q, growl) {

      $scope.User = {
        from: "",
        to: "",
        state: "",
        type: ""
      };
      $scope.activeLastLogin = true;
      $scope.activeLogged = true;
      $scope.currPage = 0;
      /**
       * Get count of register users from last 30 Days
       */
      // $scope.getRegisterUser = function () {
      //   MyService.getRegisterUsersFrom().then(function (results) {
      //     MyService.ConsoleLog("results", results.data.data);
      //     $scope.resgisterCount = results.data.data;
      //   }, function (err) {
      //     MyService.ConsoleLog("Error", err);
      //   });
      // };
      $scope.allUSAPol = {
        "statePostalCode": "All USA",
        "state": "All USA"
      };
      $scope.allState = [];


      $scope.pageFunction = function () {
        MyService.ConsoleLog("$scope.countData", $scope.countData + "   > " + $scope.mainData.length);
        if ($scope.statusGetResPg != 1 && $scope.countData > $scope.mainData.length) {
          // MyService.ConsoleLog("length");
          $scope.currPage++;
          $scope.changedPage($scope.currPage);
        }
      };

      $scope.changedPage = function (newPage) {
        $scope.searchRecords(newPage);
      };
      // $scope.getRegisterUser();
      $scope.mainData = [];
      $scope.tmpArr = [];
      /**
       * Get last activities of user
       * @params user type
       * @params Date and time
       */
      $scope.selectStatus = function (params, canceller) {
        $scope.activeUsers = true;
        $scope.activeLastLogin = true;
        $scope.showAns = true;
        $scope.resgisterCount = "";
        // MyService.ConsoleLog("Date", $scope.User.from.toISOString().split("T")[0]);
        // MyService.ConsoleLog("Type", $scope.User.type);
        // MyService.ConsoleLog("State", $scope.User.state);

        MyService.getRegisterUsersFrom(params, canceller).then(function (results) {
          MyService.ConsoleLog("results", results);
          if (results.data.data.register && results.data.data.register.length > 0 || results.data.data.notLoggedIn && results.data.data.notLoggedIn.length > 0) {
            // MyService.ConsoleLog('$scope.resgisterCount >', results.data.data.register);
            $scope.tmpArr = $scope.tmpArr.concat(results.data.data.register);
            $scope.mainData = $scope.mainData.concat(results.data.data.register);
            // MyService.ConsoleLog('$scope.resgisterCount >', $scope.tmpArr);
            $scope.countData = results.data.data.totalRecords;
            $scope.statusGetResPg = 2;
            // $scope.lastLogin = results.data.data.lastLogin;
            $scope.questionAnswered = results.data.data.questionsAnswered;
            $scope.notLoggedIn = results.data.data.notLoggedIn;


          } else {
            $scope.resgisterCount = "";
            $scope.notLoggedIn = "";
            $scope.statusGetResPg = 3;
            growl.error("Data Not Found");
          }

          // MyService.ConsoleLog(" $scope.lastLogin", $scope.lastLogin);
          // MyService.ConsoleLog(" $scope.resgisterCount", $scope.resgisterCount)
        }, function (err) {
          MyService.ConsoleLog("Error", err);
        });

      };


      $scope.searchRecords = function (pageNumber, val) {
        window.localStorage.removeItem('searchPara');
        if (val && val != '') {
          $scope.mainData = [];
          $scope.tmpArr = [];
        }
        if ($scope.User.from && $scope.User.from != "" || $scope.User.to && $scope.User.to != "" || $scope.User.type && $scope.User.type != "" || $scope.User.state && $scope.User.state != "" || $scope.User.checkUsers && $scope.User.checkUsers != "") {
          var fromDate;
          if ($scope.User.from && $scope.User.from != "") {
            var month = ("0" + ($scope.User.from.getMonth() + 1)).slice(-2);
            var dat = ("0" + $scope.User.from.getDate()).slice(-2);
            fromDate = $scope.User.from.getFullYear() + "-" + month + "-" + dat;
            MyService.ConsoleLog("fromDate >>", fromDate);
          }
          var toDate;
          if ($scope.User.to && $scope.User.to != "") {
            var smonth = ("0" + ($scope.User.to.getMonth() + 1)).slice(-2);
            var sdat = ("0" + $scope.User.to.getDate()).slice(-2);
            toDate = $scope.User.to.getFullYear() + "-" + smonth + "-" + sdat;
            MyService.ConsoleLog("toDate >>", toDate);
          }
          var checkLast;
          if ($scope.User.checkUsers && $scope.User.checkUsers != "") {
            var xsmonth = ("0" + ($scope.User.checkUsers.getMonth() + 1)).slice(-2);
            var xsdat = ("0" + $scope.User.checkUsers.getDate()).slice(-2);
            checkLast = $scope.User.checkUsers.getFullYear() + "-" + xsmonth + "-" + xsdat;
            MyService.ConsoleLog("checkLast >>", checkLast);
          }
          $scope.searchObj = {
            page: pageNumber,
            max_records: 30,
            type: $scope.User.type,
            from: fromDate,
            to: toDate,
            statePostalCode: $scope.User.state.statePostalCode,
            checkLog: checkLast
          };
          window.localStorage.setItem('searchPara', JSON.stringify($scope.searchObj));
          $scope.statusGetResPg = 1;

          $scope.getAllCanceller = $q.defer();
          $scope.selectStatus($scope.searchObj, $scope.getAllCanceller);
        } else {
          growl.error("Please Select at Least One Dropdown List");
        }
      };

      $scope.getComapreClass = function (match, i) {

        if (match >= 1) return 'ag-dg1';
        if (match >= 2) return 'ag-dg2';
        if (match >= 3) return 'ag-dg3';
        if (match >= 4) return 'ag-dg4';
        if (match >= 5) return 'ag-dg5';
        if (match >= 6) return 'ag-dg6';

        return 'ag-dg';
      };

      $scope.getItem = function () {
        return function (u) {
          if (typeof u.email == 'string') {

            u.email = u.email;
            return u;
          } else {
            var email = '';
            u.email.forEach(function (element, index) {
              if (element) {
                email += element + ', ';
                var n = email.lastIndexOf(",");
                var a = email.substring(0, n)
                // MyService.ConsoleLog("Element", a);
                u.email = a;
              }
            });
            return u;
          }
        };
      };

      $scope.getAllStates = function () {
        $scope.allState.length = 0;
        $scope.loader = true;
        // console.log("address.state", $scope.address.state);
        MyService.getAllStates().then(
          function (payload) {
            // console.log("payload : ", payload);
            $scope.allState = payload;
            $scope.allState.unshift($scope.allUSAPol);
            $scope.loader = false;
            // var
            // alert(window.localStorage.getItem('isShowPreviousResult'))
            if (window.localStorage.getItem('isShowPreviousResult') != 'false') {
              if (window.localStorage.getItem('searchPara')) {
                var params = JSON.parse(window.localStorage.getItem('searchPara'));
                MyService.ConsoleLog("params", params);
                $scope.statusGetResPg = 1;
                $scope.getAllCanceller = $q.defer();
                window.localStorage.setItem('isShowPreviousResult', false)
                $scope.selectStatus(params, $scope.getAllCanceller);
              }
            }
          },
          function (errorPayload) {
            growl.error("Something went wrong.");
            $scope.loader = false;
          }
        );
      };

      $scope.getAllStates();

    }
  ]);

'use strict';


angular.module('myApp.trackPoliticians', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/trackPoliticians', {
      templateUrl: 'app/trackPoliticians/trackPoliticians.html',
      controller: 'trackPoliticiansCtrl'
    });
  }]).controller('trackPoliticiansCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'growl', 'tokenService', 'ngDialog', 'baseApiUrl', '$anchorScroll', 'MyService', '$window', '$sce', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, growl, tokenService, ngDialog, baseApiUrl, $anchorScroll, MyService, $window, $sce) {

    $scope.User = {
      from: "",
      to: "",
      state: "",
      officeType: "",
      isContri: "",
      isAnsVotewise: false,
      isAnsVotesmart: false
    };
    $scope.showStatement = true;
    $scope.showResume = true;
    $scope.showVotesmartAns = true;
    $scope.showVotewiseAns = true;
    $scope.showCompetitor = true;
    $scope.allOfficeType = ["inOffice", "runningForOffice"];
    $scope.isUserContributed = ["Yes", "No"];
    $scope.loader = false;
    $scope.currPage = 1;

    $scope.allUSAPol = {
      "statePostalCode": "All USA",
      "state": "All USA"
    };
    $scope.allState = [];

    $scope.getAllStates = function () {
      $scope.allState.length = 0;
      $scope.loader = true;
      // console.log("address.state", $scope.address.state);
      MyService.getAllStates().then(
        function (payload) {
          // console.log("payload : ", payload);
          $scope.allState = payload;
          $scope.allState.unshift($scope.allUSAPol);
          $scope.loader = false;
          // var
          // alert(window.localStorage.getItem('isShowPreviousResult'))
          if (window.localStorage.getItem('isShowPreviousResult') != 'false') {
            if (window.localStorage.getItem('searchPara')) {
              // MyService.ConsoleLog(" <<<< search paramas >>> ", window.localStorage.getItem('searchPara'));
              var params = JSON.parse(window.localStorage.getItem('searchPara'));
              // MyService.ConsoleLog("params >>> ", params);
              $scope.User = {
                from: params.from ? new Date(params.from) : "",
                to: params.to ? new Date(params.to) : "",
                state: params.state ? params.state : "",
                statePostalCode: params.statePostalCode ? params.statePostalCode : "",
                officeType: params.officeType ? params.officeType : "",
                isContri: params.isContri ? params.isContri : ""
              };

              if (params.isAnsVotesmart) {
                $scope.User.isAnsVotesmart = params.isAnsVotesmart;
              }

              if (params.isAnsVotewise) {
                $scope.User.isAnsVotewise = params.isAnsVotewise;
              }

              if (params.isLoggedin) {
                $scope.User.isLoggedin = params.isLoggedin;
              }

              if (params.addedStatement) {
                $scope.User.addedStatement = params.addedStatement;
              }

              $scope.statusGetResPg = 1;
              $scope.getAllCanceller = $q.defer();
              window.localStorage.setItem('isShowPreviousResult', false)
              $scope.selectStatus(params, $scope.getAllCanceller);
            }
          }
        },
        function (errorPayload) {
          growl.error("Something went wrong.");
          $scope.loader = false;
        }
      );
    };



    $scope.pageFunction = function () {
      MyService.ConsoleLog("$scope.countData", $scope.countData + "   > " + $scope.mainData.length);
      if ($scope.statusGetResPg != 1 && $scope.countData > $scope.mainData.length) {
        // MyService.ConsoleLog("length");
        $scope.currPage++;
        $scope.changedPage($scope.currPage);
      }
    };

    $scope.changedPage = function (newPage) {
      $scope.searchRecords(newPage);
    };
    // $scope.getRegisterUser();
    $scope.mainData = [];
    $scope.tmpArr = [];
    /**
     * Get last activities of user
     * @params user type
     * @params Date and time
     */
    $scope.selectStatus = function (params, canceller) {
      MyService.ConsoleLog(" selectStatus params >>> ", params);
      $scope.activeUsers = true;
      $scope.activeLastLogin = true;
      $scope.showAns = true;
      $scope.resgisterCount = "";
      $scope.loader = true;
      // MyService.ConsoleLog("Date", $scope.User.from.toISOString().split("T")[0]);
      // MyService.ConsoleLog("Type", $scope.User.type);
      // MyService.ConsoleLog("State", $scope.User.state);

      MyService.trackPoliticians(params, canceller).then(function (results) {
        MyService.ConsoleLog("results", results);
        if (results.data.data.records && results.data.data.records.length > 0) {
          // MyService.ConsoleLog('$scope.resgisterCount >', results.data.data.register);
          $scope.loader = false;
          $scope.tmpArr = $scope.tmpArr.concat(results.data.data.records);
          $scope.mainData = $scope.mainData.concat(results.data.data.records);
          // MyService.ConsoleLog('$scope.resgisterCount >', $scope.tmpArr);
          $scope.countData = results.data.data.totalRecords;
          $scope.statusGetResPg = 2;
          // $scope.lastLogin = results.data.data.lastLogin;
          $scope.questionAnswered = results.data.data.questionsAnswered;
          $scope.notLoggedIn = results.data.data.notLoggedIn;
          $scope.loader = false;

        } else {
          $scope.resgisterCount = "";
          $scope.notLoggedIn = "";
          $scope.statusGetResPg = 3;
          $scope.loader = false;

          // if ($scope.User.isAnsVotewise && $scope.User.isAnsVotewise == true) {

          //   var smp = parseInt($scope.searchObj.page);
          //   smp += 1;

          //   $scope.searchObj.page = smp;
          //   $scope.selectStatus($scope.searchObj, $scope.getAllCanceller = $q.defer());
          // } else {
          growl.error("Data Not Found");
          // }

        }

        // MyService.ConsoleLog(" $scope.lastLogin", $scope.lastLogin);
        // MyService.ConsoleLog(" $scope.resgisterCount", $scope.resgisterCount)
      }, function (err) {
        $scope.loader = false;
        MyService.ConsoleLog("Error", err);
      });

    };

    /**
     * @description Search active politicians
     */
    $scope.searchRecords = function (pageNumber, val) {
      // MyService.ConsoleLog(" check >> ", $scope.User);
      window.localStorage.removeItem('searchPara');
      if (val && val != '') {
        $scope.mainData = [];
        $scope.tmpArr = [];
      }
      if ($scope.User.from && $scope.User.from != "" && $scope.User.to && $scope.User.to != "" && $scope.User.officeType && $scope.User.officeType != "" || $scope.User.state && $scope.User.state != "") {
        var fromDate;
        if ($scope.User.from && $scope.User.from != "") {
          var month = ("0" + ($scope.User.from.getMonth() + 1)).slice(-2);
          var dat = ("0" + $scope.User.from.getDate()).slice(-2);
          fromDate = $scope.User.from.getFullYear() + "-" + month + "-" + dat;
          // MyService.ConsoleLog("fromDate >>", fromDate);
        }
        var toDate;
        if ($scope.User.to && $scope.User.to != "") {
          var smonth = ("0" + ($scope.User.to.getMonth() + 1)).slice(-2);
          var sdat = ("0" + $scope.User.to.getDate()).slice(-2);
          toDate = $scope.User.to.getFullYear() + "-" + smonth + "-" + sdat;
          // MyService.ConsoleLog("toDate >>", toDate);
        }

        $scope.searchObj = {
          page: pageNumber,
          max_records: 30,
          officeType: $scope.User.officeType,
          from: fromDate,
          to: toDate,
          statePostalCode: $scope.User.state.statePostalCode ? $scope.User.state.statePostalCode : $scope.User.statePostalCode ? $scope.User.statePostalCode : '',
          state: $scope.User.state.state ? $scope.User.state.state : $scope.User.state ? $scope.User.state : '',
          isContri: $scope.User.isContri,

        };
        if ($scope.User.isContri || $scope.User.isAnsVotesmart) {
          $scope.searchObj.max_records = 100;
        }
        if ($scope.User.isAnsVotesmart) {
          $scope.searchObj.isAnsVotesmart = $scope.User.isAnsVotesmart;
        }

        if ($scope.User.isAnsVotewise) {
          $scope.searchObj.isAnsVotewise = $scope.User.isAnsVotewise;
          $scope.searchObj.max_records = 1500;
        }

        if ($scope.User.isLoggedin) {
          $scope.searchObj.isLoggedin = $scope.User.isLoggedin;
        }

        if ($scope.User.addedStatement) {
          $scope.searchObj.addedStatement = $scope.User.addedStatement;
        }


        if ($scope.User.addedResume) {
          $scope.searchObj.addedResume = $scope.User.addedResume;
        }
        // MyService.ConsoleLog(" $scope.search Obj ", $scope.searchObj);
        window.localStorage.setItem('searchPara', JSON.stringify($scope.searchObj));
        $scope.statusGetResPg = 1;

        $scope.getAllCanceller = $q.defer();
        $scope.selectStatus($scope.searchObj, $scope.getAllCanceller);
      } else {
        growl.error("Please Select at Least One Dropdown List");
      }
    };


    /**
     * 
     * @param {*} ans 
     * @param {*} i 
     * @description Function is use to apply dynamic css class
     */

    $scope.getComapreClass = function (ans, i) {

      if (ans == 1)
        return 'ag-dg1';
      if (ans == 2)
        return 'ag-dg2';
      if (ans == 3)
        return 'ag-dg3';
      if (ans == 4)
        return 'ag-dg4';
      if (ans == 5)
        return 'ag-dg5';
      if (ans == 6)
        return 'ag-dg6';

      return 'ag-dg';
    };

    $scope.getAllStates();



    $scope.showCompetitors = function (val) {
      MyService.ConsoleLog("show Competitors >> ", val);
      window.localStorage.removeItem('competitorsParams');
      // window.localStorage.removeItem('searchPara');
      MyService.ConsoleLog("$scope.searchObj >> ", $scope.searchObj);

      // window.localStorage.setItem('searchPara', JSON.stringify($scope.searchObj));
      val.officeType = $scope.User.officeType;
      var params = {
        office: val.office,
        runningForOffice: val.runningForOffice,
        statePostalCode: val.statePostalCode,
        voterScope: val.voterScope,
      }

      switch (val.voterScope) {
        case "federalCongressionalDistrict":
          params["federalCongressionalDistrict"] = val.federalCongressionalDistrict;
          var obj = {
            selectedPoli: val,
            params: params
          }
          window.localStorage.setItem('competitorsParams', JSON.stringify(obj));
          $location.path('/showCompetitors');
          break;
        case "stateHouseofRepresentativesDistrict":
          params["stateHouseofRepresentativesDistrict"] = val.stateHouseofRepresentativesDistrict;
          var obj = {
            selectedPoli: val,
            params: params
          }
          window.localStorage.setItem('competitorsParams', JSON.stringify(obj));
          $location.path('/showCompetitors');
          break;
        case "stateSenateDistrict":
          params["stateSenateDistrict"] = val.stateSenateDistrict;
          var obj = {
            selectedPoli: val,
            params: params
          }
          window.localStorage.setItem('competitorsParams', JSON.stringify(obj));
          $location.path('/showCompetitors');
          break;
        case "All USA":
          var obj = {
            selectedPoli: val,
            params: params
          }
          window.localStorage.setItem('competitorsParams', JSON.stringify(obj));
          $location.path('/showCompetitors');
          break;
        case "statePostalCode":
          var obj = {
            selectedPoli: val,
            params: params
          }
          window.localStorage.setItem('competitorsParams', JSON.stringify(obj));
          $location.path('/showCompetitors');
          break;

        default:
          console.log("default");
          break;
          // case ""
      }
    }

  }]);

'use strict';
angular.module('myApp.trackFiveMinQuizAns', ['ngRoute'])
  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/trackFiveMinQuizAns', {
        templateUrl: 'app/trackFiveMinQuizAns/trackFiveMinQuizAns.html',
        controller: 'trackFiveMinQuizAnsCtrl'
      });
    }
  ])
  .controller('trackFiveMinQuizAnsCtrl', [
    '$scope',
    'ngDialog',
    '$rootScope',
    'MyService',
    '$routeParams',
    '$q',
    "growl",
    function ($scope, ngDialog, $rootScope, MyService, $routeParams, $q, growl) {

      $scope.User = {
        from: "",
        to: "",
      };

      $scope.showAns = true;
      $scope.showQue = true;

      /**
       * 
       * @param {*} params 
       * @description Get list of other quizzes
       */

      $scope.getOtherQuizzes = function (params) {
        MyService.getListOfOtherQuizzes(params).then(function (APIResponse) {
          MyService.ConsoleLog("APIResponse >>> ", APIResponse);
          // if (APIResponse && APIResponse.data && APIResponse.data.success) {
          $scope.otherQuizzes = APIResponse.data.data;
          // } else {
          //   growl.error('Record not found for other quizzes');
          // }
        }, function (err) {
          MyService.ConsoleLog("err", err);
        });
      };

      /**
       * 
       * @param {*} params 
       * @description Get list of register user's answers of five minute quiz.
       */

      $scope.getListOfFiveMinQuiz = function (params) {

        MyService.getListOfFiveMinQuiz(params).then(function (APIResponse) {
          MyService.ConsoleLog('APIResponse', APIResponse);
          if (APIResponse && APIResponse.data && APIResponse.data.success) {
            $scope.userAnswers = APIResponse.data.data;
          } else {
            growl.error('Record not found for register users');
          }
          $scope.getOtherQuizzes(params);
        }, function (err) {
          MyService.ConsoleLog('err', err);
        });


      };

      /**
       * @description Function to get guest users answers of five minute quiz.
       *  
       */
      $scope.searchRecords = function () {
        MyService.ConsoleLog("$scope.User", $scope.User);

        if ($scope.User && $scope.User.from && $scope.User.from != '' && $scope.User.to && $scope.User.to != '') {

          var fromDate;
          if ($scope.User.from && $scope.User.from != "") {
            var month = ("0" + ($scope.User.from.getMonth() + 1)).slice(-2);
            var dat = ("0" + $scope.User.from.getDate()).slice(-2);
            fromDate = $scope.User.from.getFullYear() + "-" + month + "-" + dat;
            MyService.ConsoleLog("fromDate >>", fromDate);
          }
          var toDate;
          if ($scope.User.to && $scope.User.to != "") {
            var smonth = ("0" + ($scope.User.to.getMonth() + 1)).slice(-2);
            var sdat = ("0" + $scope.User.to.getDate()).slice(-2);
            toDate = $scope.User.to.getFullYear() + "-" + smonth + "-" + sdat;
            MyService.ConsoleLog("toDate >>", toDate);
          }

          MyService.getGuestFiveMinAns({
            from: fromDate,
            to: toDate
          }).then(function (APIResponse) {
            MyService.ConsoleLog("APIResponse >> ", APIResponse);
            if (APIResponse && APIResponse.length > 0) {
              $scope.guestAnswers = APIResponse;
              $scope.getListOfFiveMinQuiz({
                from: fromDate,
                to: toDate
              });
            } else {
              $scope.getListOfFiveMinQuiz({
                from: fromDate,
                to: toDate
              });
              growl.error('Records not found for this search');
            }

          }, function (err) {
            growl.error(err);
          });
        } else {
          MyService.ConsoleLog("Params missing");
          growl.error('Please select date range');
        }
      };



      /**
       * 
       * @param {*} ans 
       * @param {*} i 
       * @description Function is use to apply dynamic css class
       */

      $scope.getComapreClass = function (ans, i) {

        if (ans == 1)
          return 'ag-dg1';
        if (ans == 2)
          return 'ag-dg2';
        if (ans == 3)
          return 'ag-dg3';
        if (ans == 4)
          return 'ag-dg4';
        if (ans == 5)
          return 'ag-dg5';
        if (ans == 6)
          return 'ag-dg6';

        return 'ag-dg';
      };

    }
  ]);

'use strict';
angular.module('myApp.totalUsers', ['ngRoute'])

  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/totalUsers', {
      templateUrl: 'app/totalUsers/totalUsers.html',
      controller: 'totalUsersCtrl'
    });
  }]).controller('totalUsersCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'growl', 'tokenService', 'ngDialog', 'baseApiUrl', '$anchorScroll', 'MyService', '$window', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, growl, tokenService, ngDialog, baseApiUrl, $anchorScroll, MyService, $window) {

    $scope.showTotal = false;
    $scope.voter = false;
    $scope.politician = false;
    $scope.advocate = false;
    $scope.press = false;
    $scope.more = [];
    $scope.less = [];
    $scope.loaderOne = false;
    $scope.showLoader = false;
    $scope.newLoader = false;
    $scope.dis = [];
    $scope.disLo = [];
    $scope.disPoli = [];
    $scope.morePoli = [];
    $scope.loaderPolitician = false;

    $scope.cities = false;
    $scope.disCity = [];
    $scope.guestIds = [];
    $scope.getCount = function() {

      MyService.getUsersCount().then(function(result) {
        $scope.count = result.data.data;
        MyService.ConsoleLog("users count: ", $scope.count);
        $scope.showTotal = true;
        $scope.voter = false;
        $scope.politician = false;
        $scope.advocate = false;
        $scope.press = false;
        $scope.guestIds = $scope.count.guestIds;

        MyService.ConsoleLog("$scope.GuestIs >>", $scope.guestIds);

      });
    };


    $scope.getCount();

    $rootScope.UserType = "";
    $rootScope.state = "";


    /**
     ** This function fetch guest users details
     **
     **/

    $scope.getGuestUsersAnswers = function() {

      var userAdd = tokenService.getUserId();
      MyService.ConsoleLog("userAdd >>", userAdd);


      MyService.getGuestUsersAnswers({ "ids": $scope.guestIds, "userId": userAdd }).then(function(payload) {

        MyService.ConsoleLog("Payload >>", payload.data.data);
        var mData = JSON.stringify(payload.data.data);

        window.localStorage.setItem("cData", mData);
        $location.path('/compareGuestWith');
      }, function(error) {

        MyService.ConsoleLog("error >>", error);

      });

    };



    /**
     ** This function gets statewise data, called on page load.  
     **
     **
     ***/

    $scope.getVoterStateWise = function(val) {
      MyService.ConsoleLog(" para :>", val);
      $rootScope.UserType = val;


      MyService.getUsersCountStateWise({ "type": val }).then(function(response) {
        MyService.ConsoleLog("response :?&&&&&&& >", response);
        $scope.stateWise = response.data.data;
        $scope.voter = true;
        $scope.showTotal = false;




      });
    };



    /**
     ** Functions get data of cities
     **
     **
     ***/

    $scope.getUsersCityWise = function(county, state, stateFp, statePostalCode, obj) {
      // alert(county);
      $scope.disCity[$rootScope.county] = false;
      $scope.cities = false;
      $rootScope.state = state;
      $rootScope.county = county;
      MyService.ConsoleLog("obj >>", obj);
      $scope.showLoader = true;
      $scope.disLo[county] = true;

      MyService.ConsoleLog("$rootScope.UserType ", $rootScope.UserType);
      MyService.getUsersCountCityWise({
        "userType": $rootScope.UserType,
        "stateFips": stateFp,
        "state": state,
        "statePostalCode": statePostalCode,
        "county": obj
      }).then(function(payload) {
        // if (payload && payload != "") {
        if (payload && payload == "") growl.error("Local Data Not Found");
        $scope.disLo[county] = false;
        $scope.showLoader = false;
        $scope.cities = true;
        $scope.disCity[county] = true;
        MyService.ConsoleLog("Payload :", payload);
        $scope.cityWise = payload;
        // } else {
        //   $scope.disLo[county] = false;
        //   $scope.showLoader = false;
        //   growl.error(" Local Data Not Found");
        // }
      });
    };




    $scope.showLess = function(valOne) {
      // console.log("id for less",id);
      $scope.more[valOne] = false;

      $scope.morePoli[valOne] = false;

    }


    $scope.back = function() {
      $scope.showTotal = true;
      $scope.voter = false;
      $scope.more[$rootScope.state] = false;

    };



    /**
     ** This function called when county data not found 
     **
     **
     ***/

    $scope.getCityWise = function(state, stateFp, statePostalCode) {
      $scope.newLoader = true;

      MyService.getCity({
        "userType": $rootScope.UserType,
        "stateFips": stateFp,
        "state": state,
        "statePostalCode": statePostalCode,

      }).then(function(response) {
        if (response && response == "") growl.error("Local Data Not Found");
        $scope.newLoader = false;

        MyService.ConsoleLog("response >>>", response);
        $scope.city = response;


      }, function(error) {
        MyService.ConsoleLog("error >>", error);
      });

    }



    /**
     ** This function get records of county using statepostal code and statefips 
     **
     **
     ***/

    $scope.getUsersCountyWise = function(state, stateFp, statePostalCode, obj) {
      // alert(state + " " + stateFp);
      $scope.more[$rootScope.state] = false;
      $rootScope.state = state;
      MyService.ConsoleLog("obj >>", obj);
      $scope.loaderOne = true;
      $scope.dis[state] = true;
      $scope.cities = false;
      $scope.city = "";

      MyService.ConsoleLog("$rootScope.UserType ", $rootScope.UserType);
      MyService.getUsersCountyWise({
        "userType": $rootScope.UserType,
        "stateFips": stateFp,
        "state": state,
        "statePostalCode": statePostalCode
      }).then(function(payload) {

        // if (payload && payload != "") {
        if (payload && payload == "") growl.error("County Data Not Found");
        $scope.loaderOne = false;
        $scope.dis[state] = false;

        MyService.ConsoleLog("Payload :", payload);
        $scope.countywise = payload;
        $scope.more[state] = true;
        // } else {
        //   $scope.loaderOne = false;
        //   $scope.dis[state] = false;

        //   growl.error("County Data Not Found");

        // }

      });
    };

    /**
     ** This functions fetch state level politicians details
     **
     **
     **/

    $scope.getPolitician = function(obj) {

      MyService.ConsoleLog("obj >>>", obj);
      $scope.disPoli[obj.state] = true;
      $scope.loaderPolitician = true;
      MyService.getStateLevelPoli(obj).then(function(response) {
        MyService.ConsoleLog("Response >>", response);
        $scope.stateLevelPoli = response;
        $scope.morePoli[obj.state] = true;
        $scope.loaderPolitician = false;

      }, function(error) {
        growl.error(error);
      })

    }
  }])

'use strict';
angular.module('myApp.topicSpams', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/topicSpams', {
      templateUrl: 'app/topicSpams/topicSpams.html',
      controller: 'TopicSpamCtrl'
    });
  }]).controller('TopicSpamCtrl', ['$scope', '$location', '$rootScope', 'tokenService', 'MyService', 'ngDialog', function ($scope, $location, $rootScope, tokenService, MyService, ngDialog) {
    //MyService.ConsoleLog("* Following *");
    $scope.topic = {
      data: []
    };
    $scope.totalUsers = 0;
    $scope.usersPerPage = 25; // this should match however many results your API puts on one page

    $scope.pagination = {
      current: 1
    };
    $scope.showLoading = false;

    $scope.pageChanged = function (newPage) {
      $scope.getSpamTopics(newPage);
    };

    $scope.getSpamTopics = function (pageNumber) {
      // this is just an example, in reality this stuff should be in a service
      $scope.showLoading = true;
      MyService.getSpamTopics({
        "pageno": pageNumber,
        "max_records": $scope.usersPerPage
      }).then(function (payload) {
        $scope.topic.data = payload.Items;
        $scope.totalUsers = payload.Count;
        //MyService.ConsoleLog(payload.Items);
        $scope.showLoading = false;
      }, function (err) {
        //MyService.ConsoleLog(err);
      });
    }

    $scope.notSpam = function (mydata, idx) {
      var message = 'This action will mark this thread as not spam and it will be visible again. Do you want to proceed?';
      var modal = ngDialog.openConfirm({
        template: '<p>' + message + '</p>\
            <div class="ngdialog-buttons">\
                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">YES</button>\
                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">NO</button>\
            </div>',
        plain: true
      });
      modal.then(function fullfilled(data) {
        //MyService.ConsoleLog("fullfilled: ", mydata);
        MyService.notSpamTopic({
          "id": mydata._id
        }).then(function (payload) {
          //MyService.ConsoleLog(payload);
          //$scope.UserFormDiv = false;
          $scope.getSpamTopics(1);
          alert("Topic is updated and visible.");
        }, function (error) {
          alert(JSON.stringify(error));
        });
      }, function rejected(data) {
        //MyService.ConsoleLog("rejected: ", data);
      });
    }

    $scope.removeTopic = function (mydata, idx) {
      if (!mydata.parent) {
        var message = 'This is parent thread removing it will remove all the comments added to this thread. Do you want to proceed?';
      } else {
        var message = 'Are you sure you want to delete this Topic?';
      }

      var modal = ngDialog.openConfirm({
        template: '<p>' + message + '</p>\
            <div class="ngdialog-buttons">\
                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">YES</button>\
                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">NO</button>\
            </div>',
        plain: true
      });
      modal.then(function fullfilled(data) {
        //MyService.ConsoleLog("fullfilled: ", mydata);
        MyService.removeSpamTopic({
          "id": mydata._id
        }).then(function (payload) {
          //MyService.ConsoleLog(payload);
          //$scope.UserFormDiv = false;
          $scope.getSpamTopics(1);
          alert("Topic deleted successfully.");
        }, function (error) {
          alert(JSON.stringify(error));
        });
      }, function rejected(data) {
        //MyService.ConsoleLog("rejected: ", data);
      });
    }

    if ($rootScope.showTopicSpam) {
      $scope.getSpamTopics(1);
    }
  }])
'use strict';
angular.module('myApp.theConstitution', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
  $routeProvider.when('/theConstitution', {
    templateUrl: 'app/theConstitution/theConstitution.html',
    controller: 'theConstitutionCtrl'
  });
}])

.controller('theConstitutionCtrl', ['$scope','$rootScope', function($scope, $rootScope) {
	
    $rootScope.welcome = false;

}]);
"use strict";
angular
  .module("myApp.topic", ["ngRoute"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/topic/:categoryId/:subcatId", {
        templateUrl: "app/topic/topic.html",
        controller: "topicCtrl",
      });
    },
  ])
  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/topic-politician/:uId?", {
        templateUrl: "app/topic/topic.html",
        controller: "topicCtrl",
      });
    },
  ])
  .controller("topicCtrl", [
    "$scope",
    "$http",
    "$location",
    "apiCall",
    "$routeParams",
    "$rootScope",
    "$q",
    "$timeout",
    "growl",
    "tokenService",
    "MyService",
    "ngDialog",
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $rootScope,
      $q,
      $timeout,
      growl,
      tokenService,
      MyService,
      ngDialog
    ) {
      $scope.TopicButton = false;
      $rootScope.welcome = false;
      if (tokenService.getUserData()) {
        $scope.uData = JSON.parse(tokenService.getUserData());
      }
      $scope.uId = $routeParams.uId;
      if (window.localStorage.getItem("politicianThreadData") != "") {
        $rootScope.politicianThreadData = JSON.parse(
          window.localStorage.getItem("politicianThreadData")
        );
      }
      $scope.isDefaultSelected = false;
      $scope.subCatArr = [];
      $scope.location = ["National", "State", "County", "Local"];
      $scope.ShowLocationOptions = false;
      $scope.isNational = "National (USA)";
      $scope.Topic = {
        title: "",
        description: "",
        location: "National",
        restrictedTo: "No Restrictions",
      };
      $scope.restrictedOptions = [
        "Locals Only",
        "My County",
        "My State",
        "National",
        "No Restrictions",
      ];

      var current_url = $location.url();
      if (current_url.indexOf("topic-politician") > -1) {
        $scope.curState = "topic-politician";
      } else {
        $scope.curState = "topic";
      }
      $scope.mainCatIds = [];
      $scope.mainCatIds.push($routeParams.categoryId);
      if ($routeParams.categoryId && $routeParams.subcatId) {
        $scope.subCatArr.push($routeParams.categoryId);
        $scope.subCatArr.push($routeParams.subcatId);
      } else if ($routeParams.categoryId) {
        $scope.subCatArr.push($routeParams.categoryId);
      } else {
        $scope.subCatArr.push($routeParams.subcatId);
      }
      console.log("$scope.subCatArr :>> ", $scope.subCatArr);

      /*
    if ((!$routeParams.categoryId) && (!$routeParams.subcatId)) {
        $location.path('debateHome');
    }
    */
      //MyService.ConsoleLog("$routeParams.categoryId: ", $routeParams.categoryId, " $rootScope.politicianThreadData: ", $rootScope.politicianThreadData);
      if (!$routeParams.categoryId && $rootScope.politicianThreadData) {
        // alert('sjs');
        angular.forEach(
          $rootScope.politicianThreadData.users,
          function (val, key) {
            //MyService.ConsoleLog("key: ", key);
            if (($scope.curState = "topic-politician")) {
              val.selected = true;
            } else {
              if (
                val._id == $rootScope.politicianThreadData.selected_user._id
              ) {
                val.selected = true;
              }
            }
          }
        );
      }

      if (window.localStorage.getItem("VoteWiseCategory")) {
        $rootScope.allcategories = JSON.parse(
          window.localStorage.getItem("VoteWiseCategory")
        );
        MyService.ConsoleLog(
          "$rootScope.allcategories",
          $rootScope.allcategories
        );
        var chklen = 0;
        $scope.previouscatId = $rootScope.allcategories[chklen];
        if ($rootScope.allcategories.length >= 2) {
          $scope.mainCatIds.push($scope.previouscatId);
        }

        MyService.ConsoleLog("$scope.previouscatId", $scope.previouscatId);
        var idx = $rootScope.allcategories.indexOf($routeParams.subcatId);
        if (idx == -1) {
          $rootScope.allcategories.push($routeParams.subcatId);
          window.localStorage.setItem(
            "VoteWiseCategory",
            JSON.stringify($rootScope.allcategories)
          );
        }
      }
      //MyService.ConsoleLog("Final categories : ", window.localStorage.getItem("VoteWiseCategory"));
      $scope.subtopics = {
        subcategories: [],
      };

      $scope.getParentId = function (childId) {
        MyService.getParentCat({
          id: childId,
        }).then(
          function (APIResponse) {
            MyService.ConsoleLog("APIResponse", APIResponse);
            if (APIResponse && APIResponse.data.success) {
              var cobj = new Object();

              cobj.path =
                "," +
                APIResponse.data.data.parentIds[0].pid +
                "," +
                childId +
                ",";
              cobj.pid = childId;
              cobj.viewOrder = 1;
              $scope.SelectedTree.push(cobj);

              // APIResponse.data.data.parentIds[0].pid;
            } else {
              cobj.pid = childId;
              cobj.viewOrder = 1;

              cobj.path = "," + childId + ",";
              $scope.SelectedTree.push(cobj);
            }
            MyService.ConsoleLog("second", $scope.SelectedTree);
          },
          function (err) {
            MyService.ConsoleLog("err", err);
          }
        );
      };

      $scope.selectedCat = [];
      $scope.SelectedTree = [];
      $scope.disabled = [];
      $scope.isGeneral = false;
      $scope.getVal = function (data) {
        MyService.ConsoleLog(" getVal :", data);

        var idx = $scope.selectedCat.indexOf(data);
        if (idx > -1) {
          $scope.selectedCat.splice(idx, 1);
          var id = $scope.disabled.indexOf(data._id);
          $scope.disabled.splice(id, 1);
          var jdx = $scope.SelectedTree.indexOf(data.parentIds);
          if (jdx > -1) $scope.SelectedTree.splice(jdx, 1);
        } else {
          // MyService.ConsoleLog("ss")
          $scope.selectedCat.push(data);
          if (data && data.subcategories && data.subcategories.length > 0) {
            data.subcategories.filter(function (itm) {
              var inx = itm.title.indexOf("General");
              if (inx > -1) {
                MyService.ConsoleLog("itm", itm);
                $scope.mainCatIds.push(data._id);
                $scope.isGeneral = true;
                $scope.subId = itm._id;
                if (itm && itm.subcategories && itm.subcategories.length > 0) {
                  $scope.superSub = itm.subcategories[0];
                }
                $scope.selectedCat.push(itm);
              }
            });
          }
          MyService.ConsoleLog("mainCatIds", $scope.mainCatIds);
          var id = $scope.disabled.indexOf(data._id);
          if (id == -1) {
            $scope.disabled.push(data._id);
          }
          MyService.ConsoleLog("paren", data.parentIds);
          MyService.ConsoleLog("SelectedTree: ", $scope.SelectedTree);
          if ($scope.SelectedTree.length == 0) {
            if (data.parentIds.length > 0) {
              //var parents = Object.keys(data.parentIds).map(function (key) {return data.parentIds[key]});
              //angular.copy(data.parentIds, $scope.SelectedTree);
              var parents = data.parentIds;
              //MyService.ConsoleLog(parents);
              $scope.SelectedTree = parents;
            } else {
              MyService.ConsoleLog(" $scope.subId ", $scope.subId);
              var cobj = new Object();
              if ($scope.isGeneral == true && $scope.subId != "") {
                cobj.pid = data._id;
                cobj.viewOrder = 1;
                if ($scope.superSub) {
                  cobj.path =
                    "," +
                    data._id +
                    "," +
                    $scope.subId +
                    "," +
                    $scope.superSub._id +
                    ",";
                } else {
                  cobj.path = "," + data._id + "," + $scope.subId + ",";
                }
                // cobj.path = "," + data._id + "," + $scope.subId + ",";
                $scope.SelectedTree.push(cobj);
              } else {
                $scope.getParentId(data._id);
                // cobj.pid = data._id;
                // cobj.viewOrder = 1;

                // cobj.path = "," + data._id + ",";
                // $scope.SelectedTree.push(cobj);
              }

              //"pid":"57987dfb31411a7f224cf01e","viewOrder":6,"path":",57987dfb31411a7f224cf01e,"
            }
          } else {
            if (data.parentIds.length > 0) {
              //var parents = Object.keys(data.parentIds).map(function (key) {return data.parentIds[key]});
              var parents = angular.copy(data.parentIds);
              //var parents = data.parentIds;
              var plen = parents.length;
              for (var j = 0; j < plen; j++) {
                var jdx = indexOfExt($scope.SelectedTree, parents[j]);
                //MyService.ConsoleLog(jdx);
                if (jdx == -1) {
                  $scope.SelectedTree.push(parents[j]);
                  // MyService.ConsoleLog("parents[j]",parents[j]);
                  if ($scope.isGeneral == true && $scope.subId != "") {
                    var obj = {};
                    obj.pid = data._id;
                    obj.viewOrder = 1;
                    obj.path = "," + data._id + "," + $scope.subId + ",";
                    var sjdx = indexOfExt($scope.SelectedTree, obj);
                    if (sjdx == -1) {
                      MyService.ConsoleLog("Obj", obj);
                      $scope.SelectedTree.push(obj);
                    }
                  }
                }
              }
            } else {
              var cobj = new Object();
              cobj.pid = data._id;
              cobj.viewOrder = 1;

              if ($scope.isGeneral == true && $scope.subId != "") {
                // cobj.path = "," + data._id + "," + $scope.subId + ",";
                // MyService.ConsoleLog("is", cobj.path);
                if ($scope.superSub) {
                  cobj.path =
                    "," +
                    data._id +
                    "," +
                    $scope.subId +
                    "," +
                    $scope.superSub._id +
                    ",";
                } else {
                  cobj.path = "," + data._id + "," + $scope.subId + ",";
                }
                MyService.ConsoleLog("is", cobj.path);
                $scope.SelectedTree.push(cobj);
              } else {
                MyService.ConsoleLog("issssss");
                // cobj.path = "," + data._id + ",";
                $scope.getParentId(data._id);
              }

              //"pid":"57987dfb31411a7f224cf01e","viewOrder":6,"path":",57987dfb31411a7f224cf01e,"
            }
          }
        }
        MyService.ConsoleLog("$scope.SelectedTree", $scope.SelectedTree);
      };

      $scope.selectedAll = {
        id: [],
      };
      $scope.removeVal = function (data) {
        var idx = $scope.selectedCat.indexOf(data);
        MyService.ConsoleLog("data", data);
        MyService.ConsoleLog("idx", idx);
        if (idx > -1) {
          if ($scope.selectedCat[idx].title.indexOf("General") > -1) {
            $scope.selectedCat.filter(function (itms, ind) {
              if (itms._id == $scope.selectedCat[idx]._id) {
                MyService.ConsoleLog("yes", ind);
                // $scope.selectedCat.splice(ind, 1);
              }
            });
            var indx = $scope.selectedCat.indexOf(data);
            $scope.selectedCat.splice(indx, 1);
          } else {
            $scope.selectedCat.splice(idx, 1);
          }

          var id = $scope.disabled.indexOf(data._id);
          $scope.disabled.splice(id, 1);
          var parents = data.parentIds;

          var plen = parents.length;
          for (var j = 0; j < plen; j++) {
            var jdx = $scope.SelectedTree.indexOf(parents[j]);
            if (jdx > -1) $scope.SelectedTree.splice(jdx, 1);
          }
        }
        $scope.selectedAll.id.length = 0;
        //MyService.ConsoleLog($scope.SelectedTree);
        var allLen = $scope.SelectedTree.length;
        var chkboxe = document.getElementsByName("checkedidcat");
        for (var i = 0; i < allLen; i++) {
          chkboxe[i].checked = true;
        }
      };

      $scope.selectConfig = {
        requiredMin: 1,
        selectAll: true,
      };

      function areEqual() {
        var len = arguments.length;
        for (var i = 1; i < len; i++) {
          if (arguments[i] == null || arguments[i] != arguments[i - 1])
            return false;
        }
        return true;
      }

      function indexOfExt(list, item) {
        var len = list.length;

        for (var i = 0; i < len; i++) {
          var keys = Object.keys(list[i]);
          var flg = true;
          var arr = [];
          for (var j = 0, s = 1; j < keys.length; j++, s++) {
            var value = list[i][keys[j]];
            //MyService.ConsoleLog("value :" + value + "-----Item : " + item[keys[j]]);
            //MyService.ConsoleLog(typeof value + "===" + typeof item[keys[j]]);
            if (typeof value != "object" && typeof item[keys[j]] != "object") {
              if (item[keys[j]] !== value) {
                flg = false;
                //MyService.ConsoleLog("flg : ", typeof item[keys[j]], typeof value);
              }
            }
            if (item[keys[j]] == value) {
              arr.push(flg);
            } else if (
              typeof value == "object" &&
              typeof item[keys[j]] == "object"
            ) {
              arr.push(flg);
            }
          }
          if (flg == true) {
            //MyService.ConsoleLog(arr.length + "-----" + keys.length + "-----" + Object.keys(item).length);
            if (areEqual(arr.length, keys.length, Object.keys(item).length)) {
              return i;
            }
          }
        }
        return -1;
      }

      $scope.checksubCatExists = function (rdata, val) {
        return rdata.filter(function (rdata) {
          if (rdata.pid) {
            var idx = indexOfExt($scope.selectedCat, val);

            if (idx == -1) {
              $scope.selectedCat.push(val);
            }
            return rdata;
          }
        });
      };

      $scope.checkCatExists = function (rdata, val) {
        return rdata.filter(function (rdata) {
          if (rdata._id == val) {
            //MyService.ConsoleLog("parentIds : ", rdata.parentIds.length);
            if (rdata.parentIds.length > 0) {
              var parents = rdata.parentIds.length;
              for (var j = 0; j < parents; j++) {
                var newd = angular.copy(rdata.parentIds[j]);
                //MyService.ConsoleLog("newd:", newd);
                //MyService.ConsoleLog("SelectedTree:", $scope.SelectedTree);
                var jdx = indexOfExt($scope.SelectedTree, newd);
                //MyService.ConsoleLog(jdx);
                if (jdx == -1) {
                  $scope.SelectedTree.push(newd);
                }
              }
            }
            if (rdata.parentIds.length > 1) {
              var idx = indexOfExt($scope.selectedCat, angular.copy(rdata));
              if (idx == -1) {
                $scope.selectedCat.push(angular.copy(rdata));
              }
            } else {
              $scope.selectedCat.push(angular.copy(rdata));
            }
            return rdata;
          } else if (rdata.subcategories) {
            $scope.checkCatExists(rdata.subcategories, val);
          }
        });
      };

      $scope.getSubcatTree = function () {
        $scope.selectedCat.length = 0;
        $scope.EssayButton = true;
        var types;
        if ($scope.curState == "topic-politician") {
          types = "F,H";
        } else {
          types = "F";
        }
        MyService.getAllCatTree({
          type: types,
        }).then(
          function (payload) {
            $scope.subtopics.subcategories.length = 0;
            var subcatdata = payload;
            // MyService.ConsoleLog("subcatdata : ", subcatdata);
            $scope.disabled.length = 0;
            //$scope.disabled.push(window.localStorage.getItem("VoteWiseParentCategory"));
            $scope.subtopics.subcategories = subcatdata;
            if ($routeParams.categoryId) {
              $scope.disabled = JSON.parse(
                window.localStorage.getItem("VoteWiseCategory")
              );
              //MyService.ConsoleLog("subcat : ", $scope.disabled);
              var selectedCat = JSON.parse(
                window.localStorage.getItem("VoteWiseCategory")
              );
              if (selectedCat.length > 0) {
                for (var s = 0; s < selectedCat.length; s++) {
                  var checkcatdata = $scope.checkCatExists(
                    subcatdata,
                    selectedCat[s]
                  );
                }
                //MyService.ConsoleLog($scope.selectedCat);
                //$scope.SelectedTree = angular.copy($scope.selectedCat);
              }
              $scope.EssayButton = false;
              setTimeout(function () {
                var cols = document.getElementsByClassName("cmnUL");
                var clen = cols.length;
                for (var i = 0; i < clen; i++) {
                  cols[i].style.display = "none";
                }
              }, 300);
            } else {
              MyService.ConsoleLog("* Inside else *");
              angular.forEach(
                $scope.subtopics.subcategories,
                function (val, key) {
                  if (
                    val.title &&
                    val.title.toLowerCase() == "politician review"
                  ) {
                    $scope.disabled = [val._id];
                    // var checkcatdata = $scope.checkCatExists(subcatdata, val);
                    $scope.selectedCat.push(val);
                  }
                }
              );
            }
            MyService.ConsoleLog("$scope.selectedCat", $scope.selectedCat);
            var tmp = $scope.selectedCat.filter(function (itm, ind) {
              return (
                ind ==
                $scope.selectedCat.findIndex(function (ele) {
                  return JSON.stringify(ele) == JSON.stringify(itm);
                })
              );
            });
            MyService.ConsoleLog("tmp", tmp);
            $scope.selectedCat = "";
            $scope.selectedCat = tmp;
          },
          function (errorPayload) {
            alert("Something went wrong ");
          }
        );
      };

      $scope.showSubCat = true;
      $scope.showLoading = [];
      $scope.showLoadingCounty = [];
      $scope.showDown = [];
      $scope.ChangeShow = function (id) {
        //$scope.showSubCat = true;
        //var cols = document.getElementsByClassName('cmnUL');
        //var clen = cols.length;
        var nclass = "MainCatLi_" + id;
        if (
          document.getElementsByClassName(nclass)[0].style.display &&
          document.getElementsByClassName(nclass)[0].style.display == "none"
        ) {
          document.getElementsByClassName(nclass)[0].style.display = "block";
        } else {
          document.getElementsByClassName(nclass)[0].style.display = "none";
        }
      };

      $scope.AddLocation = false;
      $scope.newlocation = {
        country: "",
      };
      $scope.Allcountries = [];
      $scope.SelectedCountry = "";

      $scope.ShowAddLocation = function () {
        if (!$scope.AddLocation) {
          $scope.AddLocation = true;
        } else {
          $scope.AddLocation = false;
        }
      };

      function suggest_country(term) {
        var q = term.toLowerCase().trim();
        var results = [];
        var len = $scope.Allcountries.length;
        // Find first 10 states that start with `term`.
        for (var i = 0; i < len && results.length < 10; i++) {
          var country = $scope.Allcountries[i];
          if (country.toLowerCase().indexOf(q) === 0)
            results.push({
              label: country,
              value: country,
            });
        }
        return results;
      }

      $scope.autocomplete_options = {
        suggest: suggest_country,
      };

      $scope.setByDefaultState = function (data) {
        data.filter(function (itms) {
          if (itms.state.indexOf($scope.uData.address.state) > -1) {
            MyService.ConsoleLog("itms", itms);

            var nobj = {
              country: "National (USA)",
            };
            $scope.nwStateFips = itms.stateFips;
            $scope.selectedArea.push(nobj);
            $scope.selectedArea.push(itms);
            $scope.disabledLocation.push(itms);
            $scope.getCounties(itms.stateFips);
          }
        });
      };

      $scope.getAllStates = function () {
        MyService.getAllStates().then(
          function (payload) {
            $scope.allLocations.length = 0;
            var subcatdata = payload;
            MyService.ConsoleLog("countires : ", subcatdata);
            $scope.allLocations = subcatdata;
            if ($scope.isDefaultSelected) {
              $scope.setByDefaultState($scope.allLocations);
            }
          },
          function (errorPayload) {
            alert("Something went wrong ");
          }
        );
      };
      $scope.getAllStates();

      // var fetchPoliticiansByStateCanceler = $q.defer();
      $scope.statusfetchPoliticiansByState = 0;
      $scope.fetchPoliticiansByState = function (selState, idx) {
        //MyService.ConsoleLog("selState: ", selState);
        // fetchPoliticiansByStateCanceler.resolve();
        // fetchPoliticiansByStateCanceler = $q.defer();
        // $scope.statusfetchPoliticiansByState = 1;
        // $scope.politicians = [];
        //MyService.ConsoleLog("selState.loadPolitician: ", selState.loadPolitician);
        if (selState.loadPolitician == false) {
          //MyService.ConsoleLog("* this is false *");
          $scope.allLocations[idx].politicians = [];
          return;
        }
        $scope.allLocations[idx].getPolStatus = 1;
        MyService.getPoliticianLocWise(
          {
            statePostalCode: selState.statePostalCode,
          },
          null
        ).then(
          function (response) {
            if (response.data.success) {
              // $scope.politicians = response.data.data;
              // $scope.statusfetchPoliticiansByState = 2;
              $scope.allLocations[idx].politicians = response.data.data;
              $scope.allLocations[idx].getPolStatus = 2;
            } else if (
              response.data.error &&
              typeof response.data.error == "string"
            ) {
              growl.error("Error: " + response.data.error);
              // $scope.statusfetchPoliticiansByState = 3;
              $scope.allLocations[idx].getPolStatus = 3;
            } else {
              growl.error("Something went wrong.");
              // $scope.statusfetchPoliticiansByState = 3;
              $scope.allLocations[idx].getPolStatus = 3;
            }
          },
          function (err) {
            growl.error("Something went wrong.");
            // $scope.statusfetchPoliticiansByState = 3;
            $scope.allLocations[idx].getPolStatus = 3;
          }
        );
      };
      $scope.selectUsersFromGroup = function (usres, flag) {
        angular.forEach(usres, function (val, key) {
          val.selected = flag;
        });
      };

      $scope.allLocations = [];
      $scope.allCounties = [];
      $scope.selectedArea = [];
      $scope.rmselectedArea = [];
      $scope.myselectionarea = [];
      $scope.disabledLocation = [];

      $scope.checkExists = function (rdata, val) {
        return rdata.filter(function (rdata) {
          if (rdata.state == val) return rdata;
        });
      };

      $scope.checkCountyExists = function (rdata, val) {
        return rdata.filter(function (rdata) {
          if (rdata.county == val) return rdata;
        });
      };

      $scope.checkCountryExists = function (rdata, val) {
        return rdata.filter(function (rdata) {
          if (rdata.country == val) return rdata;
        });
      };

      $scope.checkDisabled = function (data, stateId, type) {
        data.country = "United States of America";
        data.state = stateId;

        var idx = indexOfExt($scope.disabledLocation, data);
        if (idx > -1) return true;
        else return false;
      };

      $scope.getAreaVal = function (data, stateId, type) {
        if (!data.country) {
          data.country = "United States of America";
        }
        if (!data.state) {
          data.state = stateId;
        }

        var idx = indexOfExt($scope.selectedArea, data);

        if (idx > -1) {
          alert("You have already selected the location");
        } else {
          $scope.selectedArea.push(data);
          $scope.disabledLocation.push(data);
        }

        MyService.ConsoleLog(
          "$scope.disabledLocation",
          $scope.disabledLocation
        );
        MyService.ConsoleLog("$scope.selectedArea", $scope.selectedArea);
      };
      $scope.selectedLAll = {
        id: [],
      };
      $scope.removeAreaVal = function (data) {
        var idx = $scope.selectedArea.indexOf(data);

        //MyService.ConsoleLog($scope.Topic.Locations);
        if (idx > -1) {
          //MyService.ConsoleLog("Country:",$scope.selectedArea[idx].country);
          if ($scope.selectedArea[idx].country == "International") {
            $scope.Topic.Locations = "NO";
          }
          if ($scope.selectedArea[idx].country == "National (USA)") {
            $scope.Topic.National = "NO";
          }
          $scope.selectedArea.splice(idx, 1);
          var jdx = $scope.disabledLocation.indexOf(data);
          if (jdx > -1) {
            $scope.disabledLocation.splice(jdx, 1);
          }
        }
        $scope.selectedLAll.id.length = 0;
        //MyService.ConsoleLog($scope.selectedArea);
        var allLen = $scope.selectedArea.length;
        var chkboxe = document.getElementsByName("checkedid");
        for (var i = 0; i < allLen; i++) {
          chkboxe[i].checked = true;
        }
      };
      $scope.allCounties = [];
      $scope.allLocals = [];
      $scope.setLocation = function (option) {
        $scope.Essay.location = option;
      };
      $scope.getLocations = function (val, type) {
        if (type == "National") {
          if (val == "National") {
            var nobj = {
              country: "National (USA)",
            };
            $scope.selectedArea.push(nobj);
            //MyService.ConsoleLog($scope.selectedArea);
          }
          if (val == "NO") {
            var nobj = {
              country: "National (USA)",
            };
            var idx = indexOfExt($scope.selectedArea, nobj);
            if (idx > -1) {
              $scope.selectedArea.splice(idx, 1);
            }
          }
        } else if (type == "International") {
          if (val == "International") {
            // $scope.selectedArea.length = 0;
            var nobj = {
              country: "International",
            };
            $scope.selectedArea.push(nobj);
            MyService.ConsoleLog("$scope.selectedArea", $scope.selectedArea);
          }
          if (val == "NO") {
            // $scope.selectedArea.length = 0;
            var nobj = {
              country: "International",
            };
            var idx = indexOfExt($scope.selectedArea, nobj);
            if (idx > -1) {
              $scope.selectedArea.splice(idx, 1);
            }
          }
        }
      };

      $scope.setByDefaultCounty = function (cdata) {
        // MyService
        cdata.filter(function (count) {
          if (count.countyName.indexOf($scope.uData.address.county) > -1) {
            $scope.selectedArea.push(count);
            $scope.disabledLocation.push(count);
            $scope.getLocals($scope.nwStateFips, count.countyFips);
          }
        });
      };

      $scope.AddCountry = function () {
        if ($scope.newlocation.country && $scope.newlocation.country != "") {
          var idx = $scope.Allcountries.indexOf($scope.newlocation.country);
          if (idx > -1) {
            var nobj = {
              country: $scope.newlocation.country,
            };
            $scope.selectedArea.push(nobj);
          } else {
            alert(
              "Country does not exists in our database. Please check if you have entered correct name."
            );
          }
        } else {
          alert("Please enter country name");
        }
      };

      $scope.getCounties = function (state) {
        console.log(state);
        $scope.showLoading.push(state);
        if (
          !$scope.allCounties[state] ||
          $scope.allCounties[state].length == 0
        ) {
          MyService.getAllCounties(state).then(
            function (payload) {
              $scope.showLoading.length = 0;
              var sublocations = payload;
              if (!$scope.allCounties) {
                $scope.allCounties = [];
              }
              var upCounty = sublocations.filter(function (coun) {
                coun.county = "";
                coun.county = coun.countyName;
                return coun;
              });
              $scope.allCounties[state] = upCounty;

              if ($scope.isDefaultSelected) {
                $scope.setByDefaultCounty(sublocations);
              }
            },
            function (errorPayload) {
              alert("Something went wrong.");
            }
          );
        } else {
          $scope.showLoading.length = 0;
          $scope.allCounties[state].length = 0;
        }
      };
      $scope.setByDefaultLocal = function (ldata) {
        // MyService
        ldata.filter(function (local) {
          if (local.placeName.indexOf($scope.uData.address.place) > -1) {
            $scope.selectedArea.push(local);
            $scope.disabledLocation.push(local);
          }
        });
      };

      $scope.getLocals = function (state, county) {
        $scope.showLoadingCounty.push(county);
        if (
          !$scope.allLocals[state] ||
          !$scope.allLocals[state][county] ||
          $scope.allLocals[state][county].length == 0
        ) {
          MyService.getAllSubCountiesLocal(state, "", county).then(
            function (payload) {
              $scope.showLoadingCounty.length = 0;
              MyService.ConsoleLog("payload Locals : ", payload);
              if (!$scope.allLocals[state]) {
                $scope.allLocals[state] = [];
              }
              var upPlaces = payload.places.filter(function (pla) {
                pla.place = "";
                pla.place = pla.placeName;
                return pla;
              });
              // MyService.ConsoleLog("upPlaces", upPlaces);
              $scope.allLocals[state][county] = upPlaces;
              if ($scope.isDefaultSelected) {
                $scope.setByDefaultLocal(payload.places);
              }
            },
            function (errorPayload) {
              alert("Something went wrong ");
            }
          );
        } else {
          $scope.showLoadingCounty.length = 0;
          $scope.allLocals[state][county].length = 0;
        }
      };

      $scope.ShowLocation = function () {
        $scope.ShowLocationOptions = true;
        $scope.isDefaultSelected = true;
        MyService.getAllCountries().then(
          function (payload) {
            $scope.Allcountries = payload;
            // MyService.ConsoleLog("$scope.Allcountries", $scope.Allcountries);
          },
          function (errorPayload) {
            alert("Something went wrong ");
          }
        );
        $scope.getAllStates();
      };

      $scope.SubmitTopic = function (data) {
        if ($.fn.validateForceFully($("#topicform")) == true) {
          //$scope.TopicButton = true;
          MyService.ConsoleLog("first", $scope.disabled);
          data.parentcat = JSON.stringify($scope.disabled);
          if ($scope.curState == "topic-politician" && $scope.disabled <= 0) {
            growl.error(
              "There must be a root category to with title 'Politician Review'."
            );
            return;
          }
          var subcat = [];
          if ($scope.curState == "topic-politician" && $scope.disabled <= 0) {
            subcat = JSON.stringify($scope.disabled);
          } else {
            subcat = JSON.stringify($scope.SelectedTree);
          }

          data.subcategories = subcat;
          data.createdById = tokenService.getUserId();
          data.createdByName = tokenService.getUserName();
          data.createdByType = tokenService.getUserRole();
          if ($scope.selectedArea.length > 0) {
            var obj = {};
            var smplData = $scope.selectedArea.filter(function (sel, idx) {
              if (sel.state) {
                obj.country = sel.country;
                obj.state = sel.state;
              }
              if (sel.county) {
                obj.county = sel.county;
              }
              if (sel.place) {
                obj.place = sel.place;
                obj.placeName = sel.place;

                // MyService.ConsoleLog("obj", obj);
                // MyService.ConsoleLog("idx", idx);
                $scope.selectedArea[idx] = "";
                $scope.selectedArea[idx] = obj;
                MyService.ConsoleLog("cheek plz", $scope.selectedArea[idx]);
              }

              //
            });
            data.location = JSON.stringify($scope.selectedArea);
          } else {
            var arr = [];
            var acountry = "";
            if ($scope.uData) {
              if ($scope.uData.address.country == null) {
                if ($scope.isNational) {
                  acountry = $scope.isNational;
                } else {
                  acountry = "United States of America";
                }
              } else {
                acountry = $scope.uData.address.country;
              }
              if (acountry.indexOf("National (USA)") > -1) {
                var objNw = {
                  country: acountry,
                  state: null,
                  statePostalCode: null,
                  county: null,
                  countySubdivision: null,
                  place: null,
                };

                arr.push(objNw);
                var objState = {
                  country: "United States of America",
                  state: $scope.uData.address.state,
                  statePostalCode: $scope.uData.address.statePostalCode,
                  county: null,
                  countySubdivision: null,
                  place: null,
                };
                arr.push(objState);
                var objCounty = {
                  country: "United States of America",
                  state: $scope.uData.address.state,
                  statePostalCode: $scope.uData.address.statePostalCode,
                  county: $scope.uData.address.county,
                  countySubdivision: null,
                  place: null,
                };
                arr.push(objCounty);
                var obj = {
                  country: acountry,
                  state: $scope.uData.address.state,
                  statePostalCode: $scope.uData.address.statePostalCode,
                  county: $scope.uData.address.county,
                  countySubdivision: $scope.uData.address.countySubdivision,
                  place: $scope.uData.address.place,
                };
                arr.push(obj);
              } else {
                var obj = {
                  country: acountry,
                  state: $scope.uData.address.state,
                  statePostalCode: $scope.uData.address.statePostalCode,
                  county: $scope.uData.address.county,
                  countySubdivision: $scope.uData.address.countySubdivision,
                  place: $scope.uData.address.place,
                };
                arr.push(obj);
              }

              data.location = JSON.stringify(arr);
            }
          }

          //MyService.ConsoleLog(data);
          //MyService.ConsoleLog($scope.selectedArea);

          var tempPoliticianUids = [];
          try {
            /*angular.forEach($scope.allLocations, function(state, key){
              if(state.politicians){
                  angular.forEach(state.politicians, function(pol, i){
                      if(pol.selected){
                          tempPoliticianUids.push(pol._id);
                      }
                  });
              }
          });*/
            //MyService.ConsoleLog("catch: ", $rootScope.politicianThreadData.users.length);
            angular.forEach(
              $rootScope.politicianThreadData.users,
              function (pol, key) {
                //MyService.ConsoleLog("key: ", key);
                if (pol.selected) {
                  tempPoliticianUids.push(pol._id);
                }
              }
            );
          } catch (e) {
            //MyService.ConsoleLog("politicians thread exception: ", e);
          }
          if (
            $scope.curState == "topic-politician" &&
            tempPoliticianUids.length <= 0
          ) {
            growl.error("Please select at least one politician.");
            return;
          }
          data.taggedUsers = tempPoliticianUids.join(",");
          MyService.ConsoleLog("data: ", data);
          // return;
          var request = apiCall.apiCall("POST", "/topics/create", data);
          $http(request).then(
            function successCallback(response) {
              MyService.ConsoleLog("Got categories: ", response);
              $scope.TopicButton = true;
              if (response.data.success) {
                if (!window.localStorage.getItem("VoteWiseParentCategory")) {
                  MyService.ConsoleLog(
                    "response.data.data",
                    response.data.data
                  );
                  MyService.ConsoleLog(response.data.data.parentCat[0]);
                  if ($routeParams.categoryId && $routeParams.subcatId) {
                    $location.path(
                      "/forum/" + response.data.data.parentCat[0] + "/home"
                    );
                  } else {
                    // alert('one');

                    $location.path("/politician-thread/" + $scope.uId);
                  }
                } else {
                  var cat =
                    window.localStorage.getItem("VoteWiseParentCategory") ||
                    null;
                  MyService.ConsoleLog(" window.localStorage.getIte", cat);
                  MyService.ConsoleLog(" window.localStorage.getIte", cat);

                  if (cat != "undefined") {
                    MyService.ConsoleLog("$$$$$$$$ IF $$$$$$$$$");
                    if ($routeParams.categoryId && $routeParams.subcatId) {
                      $location.path(
                        "/forum/" +
                          window.localStorage.getItem(
                            "VoteWiseParentCategory"
                          ) +
                          "/home"
                      );
                    } else {
                      // alert('two');

                      $location.path("/politician-thread/" + $scope.uId);
                    }
                  } else {
                    MyService.ConsoleLog("$$$$$$$$ ELSE $$$$$$$$$");
                    if ($routeParams.categoryId && $routeParams.subcatId) {
                      $location.path(
                        "/forum/" + response.data.data.parentCat[0] + "/home"
                      );
                    } else {
                      // alert('three');
                    }
                  }
                }
              } else {
                if (response.data.error) {
                  alert(response.data.error);
                  //MyService.ConsoleLog(response.data);
                  if (response.data.status && response.data.status == "405") {
                    var msg =
                      "Do you want to send request to Admin to reactivate your account?.";
                    MyService.GetDialogWithButtons(
                      ngDialog,
                      msg,
                      "YES",
                      "NO"
                    ).then(
                      function (payload) {
                        MyService.sendActivatationMailtoAdmin().then(
                          function (payload) {
                            alert("Request sent successfully to admin");
                          },
                          function (errorPayload) {
                            alert("Something went wrong");
                          }
                        );
                      },
                      function (errorPayload) {
                        //MyService.ConsoleLog(errorPayload);
                      }
                    );
                  }
                }
              }
            },
            function errorCallBack(response) {
              //MyService.ConsoleLog("Error: ", response);
            }
          );
        }
      };

      $scope.goBack = function () {
        //MyService.ConsoleLog("redirect back page");
        var len = $rootScope.allcategories.length;
        var type = "home";
        //MyService.ConsoleLog("Length:", len);
        if (len > 2) {
          type = "subcat";
        }
        //MyService.ConsoleLog(type);
        //MyService.ConsoleLog($rootScope.allcategories[len - 2] + "=====" + $rootScope.allcategories[len - 1]);

        //MyService.ConsoleLog('forumList/' + $rootScope.allcategories[len - 2] + '/' + $rootScope.allcategories[len - 1] + "/" + type);
        $location.path(
          "forumList/" +
            $rootScope.allcategories[len - 2] +
            "/" +
            $rootScope.allcategories[len - 1] +
            "/" +
            type
        );
      };

      if (!$rootScope.UserId) {
        var message = "Please login first.";

        var modal = ngDialog.openConfirm({
          template:
            "<p>" +
            message +
            '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
          plain: true,
        });

        modal.then(
          function fullfilled(data) {
            //MyService.ConsoleLog("fullfilled: ", data);
            $location.path("signin");
          },
          function rejected(data) {
            //MyService.ConsoleLog("rejected: ", data);
            $location.path("signin");
          }
        );
      } else {
        $scope.getSubcatTree();
      }

      $("#topicform").validationEngine();
    },
  ]);

'use strict';
angular.module('myApp.takeAction', ['ngRoute'])

  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/takeAction', {
      templateUrl: 'app/takeAction/takeAction.html',
      controller: 'takeActionCtrl'
    });
  }])
  .controller('takeActionCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService) {

  }]);

'use strict';
angular.module('myApp.stripe', ['ngRoute', 'angularPayments'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/verifyBy', {
      templateUrl: 'app/stripe/stripe.html',
      controller: 'stripeCtrl'
    });
  }])
  .controller('stripeCtrl', ['$scope', '$rootScope', 'growl', 'ngDialog', 'tokenService', 'MyService', '$location', '$window', '$filter', '$http', function ($scope, $rootScope, growl, ngDialog, tokenService, MyService, $location, $window, $filter, $http) {
    $scope.show = false;
    $window.Stripe.setPublishableKey('pk_live_CoIWdfmgwRrDjaFSSqDAASNh');


    $scope.getMailingAddress = function (id) {
      MyService.getMailingAddress({
        userId: id,
      }).then(
        function (result) {
          MyService.ConsoleLog('Result', result);
          $scope.mainData = result.data.data;
          $scope.checkAddress();

        },
        function (err) {
          MyService.ConsoleLog('Error >', err);
        }
      );
    };
    $scope.checkAddress = function () {
      MyService.ConsoleLog("$scope", $scope.mainData);
      if ($scope.mainData && $scope.mainData.politicianInfo.length > 0) {
        var pLen = $scope.mainData.politicianInfo.length;
        for (var i = 0; i < pLen; i++) {
          if ($scope.mainData.politicianInfo[i].levelOfGov != "federalCongressionalDistrict") {
            if ($scope.mainData.address && $scope.mainData.address.state != '') {
              MyService.ConsoleLog("$scope.mainData", $scope.mainData);
              var aurl = 'https://personator.melissadata.net/v3/WEB/ContactVerify/doContactVerify';
              aurl += '?id=kqB5hWsxojFjWLA14xFlfx**nSAcwXpxhQ0PC2lXxuDAZ-**';
              aurl += '&cols=GrpCensus,GrpCensus2,GrpGeocode';
              aurl += '&full=' + $scope.mainData.name;
              aurl += '&act=Check,Verify';
              aurl += '&a1=' + $scope.mainData.mailingAddress;
              aurl += '&city=' + $scope.mainData.address.place;
              aurl += '&state=' + $scope.mainData.address.state;
              aurl += '&postal=' + $scope.mainData.zipcode;
              aurl += '&ctry=US';
              aurl += '&format=JSON';
              // $scope.data = JSON.parse(window.localStorage.getItem("addInfo"));
              MyService.ConsoleLog("$scope.data", $scope.data);
              // var deferred = $q.defer();
              //var furl = "https://personator.melissadata.net/v3/WEB/ContactVerify/doContactVerify?id=RyMI8jlzD6dHUApvp_3XRP**&cols=GrpCensus,GrpCensus2,GrpGeocode&a1=" + records.address + "&city=" + records.city + "&state=" + records.state + "&postal=" + records.zipcode + "&ctry=US&format=JSON";
              //MyService.ConsoleLog("furl <><>>", furl);
              $http.get(aurl).then(
                function successCallback(response) {
                  $scope.data = "";
                  MyService.ConsoleLog("response", response.data.Records);
                  // window.localStorage.setItem("addInfo", JSON.stringify(response.data.Records));
                  var str = response.data.Records[0].Results;
                  $scope.AllData = response.data.Records[0];

                  // var res = str.match(/VR01/g);
                  const res = str.split(/[\s,\?\,\.!]+/).some(function (f) {
                    return f == 'VR01'
                  });
                  MyService.ConsoleLog("res", typeof res);
                  MyService.ConsoleLog("res", res);


                  if (res == true) {
                    MyService.ConsoleLog(" $scope.data", $scope.mainData);
                    $scope.addressLine1 = $scope.mainData.mailingAddress;

                    $scope.addressZip = $scope.mainData.zipcode;
                    $scope.show = true;
                  } else {
                    MyService.ConsoleLog("Else");
                    $location.path('/showMessage');
                  }

                  MyService.ConsoleLog("response", response);
                },
                function errorCallBack(error) {
                  $scope.finddetailsclicked = false;
                  //MyService.ConsoleLog(error);
                }
              );
            }
          } else {
            growl.error("Sorry, this tool is only for local and state politicians");
          }
        }
      }

    };
    // $scope.showPay = function (vals) {
    //   $scope.AllData = vals;
    //   // if()
    //   MyService.ConsoleLog(" $scope.data", $scope.mainData);
    //   $scope.addressLine1 = $scope.mainData.mailingAddress ? $scope.mainData.mailingAddress : vals.AddressLine1;
    //   var postalCode = vals.PostalCode.split('-');
    //   $scope.addressZip = postalCode[0];
    //   $scope.show = true;
    // };
    $scope.stripeCallback = function (code, result) {
      MyService.ConsoleLog("Code", code);
      console.log(result);
      if (result.error) {
        $scope.error_alert = true;
        $scope.st_error = result.error;
        // window.alert('it failed! error: ' + result.error);
      } else {
        var message =
          'Are you SURE that you are the person you picked.  Election fraud is not a joke.  Identity fraud is a federal crime.  Committing this crime in association with elections could have even further ramifications.  When we put the $1 charge on your card, we will literally know where you live.';
        var modal = ngDialog.openConfirm({
          template: '<p>' +
            message +
            '</p>\
                          <div class="ngdialog-buttons">\
                              <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Quit</button>\
                              <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(0)">Yes, it’s me </button>\
                          </div>',
          plain: true,
          width: '50%'
        });

        modal.then(
          function fullfilled(data) {
            MyService.ConsoleLog('fullfilled: ', data);
            if (data == 0) {
              $scope.stripeTokenHandler(result.id);
            }
          },
          function rejected(data) {
            MyService.ConsoleLog('rejected: ', data);
          }
        );
        //
      }
    };
    $scope.stripeTokenHandler = function (token) {
      console.log(token);
      var u_id = $scope.userProfile._id;
      //   console.log('U_id', u_id);
      MyService.getPayment({
        "stripe_token": token,
        "id": u_id
      }).then(function (response) {
        $scope.status = response.status;
        // console.log(response.status);
        if ($scope.status) {
          var params = {
            melisaData: JSON.stringify($scope.AllData),
            confirmedBy: 'melissa-stripe',
            typeOfConf: 'melissa-stripe'
          };
          MyService.saveMelisaStripe(params).then(function (result) {
            MyService.ConsoleLog("result", result);
            growl.success("Verified Successfully");

            setTimeout(function () {
                $location.path('/snapshot');
              },
              3000);
          }, function (err) {
            MyService.ConsoleLog("This is error", err);
          });
        }
      }, function (error) {
        console.log("eer", error);
        growl.error(error);
      });
    }


    $scope.getmyData = function () {
      $scope.ShowPorifleLoading = true;
      MyService.getUserPublicProfile({
        id: $rootScope.UserId,
        type: 'false'
      }).then(function (response) {
        $scope.ShowPorifleLoading = false;
        if (response.data.success) {
          $scope.userDetails = response.data.data;
          // MyService.ConsoleLog("welcome", $scope.userDetails);
          $scope.userProfile = $scope.userDetails.userData;
          // MyService.ConsoleLog("welcome to profile", $scope.userProfile);

          $scope.userType = $scope.userProfile.userType;
          $scope.verify = $scope.userProfile.verifiedUser;
          // MyService.ConsoleLog("welcome", $scope.verify);

        } else {
          MyService.ConsoleLog("ELSE vishal");
          alert("Something went wrong.");
        }
      }, function (errorPayload) {
        $scope.ShowPorifleLoading = false;
        MyService.ConsoleLog("ELSE vishal two");

        alert("Something went wrong.");
      });
    };
    $scope.getmyData();

    /**
     * Set Address
     */
    $scope.Location = {
      county: "",
      place: "",
      state: ""
    };


    $scope.User = {
      Address: ""
    };

    $scope.showCon = false;
    $scope.showBoth = false;
    $scope.showEm = false;

    var options = {
      componentRestrictions: {
        country: "us"
      },
      types: ["geocode"]
    };

    $scope.detectAddress = function (ent) {
      var val = document.getElementById("address");
      // //console.log($scope.User.Address);
      var autocomplete = new google.maps.places.Autocomplete(val, options);

      google.maps.event.addListener(
        autocomplete,
        "place_changed",
        function () {
          var place = autocomplete.getPlace();

          var lat = place.geometry.location.lat(),
            lng = place.geometry.location.lng();

          $scope.lati = lat.toFixed(6);
          $scope.lon = lng.toFixed(6);
          // //console.log($scope.lati);
          // //console.log($scope.lon);

          $scope.mailing_Address = place.formatted_address;
          console.log("  place.address_components :", place.address_components);
          for (var i = 0; i < place.address_components.length; i++) {
            for (
              var j = 0; j < place.address_components[i].types.length; j++
            ) {
              if (
                place.address_components[i].types[j] ==
                "administrative_area_level_1"
              ) {
                $scope.statePostalCode =
                  place.address_components[i].short_name;
                // //console.log($scope.statePostalCode);
              }
              if (place.address_components[i].types[j] == "country") {
                $scope.countryname = place.address_components[i].long_name;
                // //console.log($scope.countryname);
              }
              if (
                place.address_components[i].types[j] ==
                "administrative_area_level_2"
              ) {
                $scope.county_name = place.address_components[i].long_name;
                // //console.log($scope.county_name);
              }
              if (place.address_components[i].types[j] == "locality") {
                $scope.place_name = place.address_components[i].long_name;
                // //console.log($scope.place_name);
              }
              if (place.address_components[i].types[j] == "postal_code") {
                // document.getElementById('zip').value = place.address_components[i].long_name;
                $scope.ZipCode = place.address_components[i].long_name;
                // //console.log($scope.User.ZipCode);
              }
            }
          }

          //MyService.ConsoleLog(" $scope.User.ZipCode :", $scope.ZipCode);


          $scope.loc = JSON.stringify({
            longitude: $scope.lon,
            latitude: $scope.lati
          });
          // //console.log(" long and lat :",$scope.loc );
          // $rootScope.location = new Array;

          $scope.showAddressDropDowns("", $scope.loc);
        }
      );
    };


    $scope.checkLen = function (ldata, sval) {
      // //MyService.ConsoleLog("vdata : ", vdata);
      //MyService.ConsoleLog("vdata", ldata);
      if (ldata && ldata.length > 0) {
        var data = ldata.map(function (sub) {
          var returnval = "";
          switch (sval) {
            case "federalCongrassionalDist":
              returnval = sub.CD115FP;
              break;
            case "stateSenateDistrict":
              returnval = sub.SLDUST;
              break;
            case "stateHouseOFRepresentativeDistrict":
              returnval = sub.NAMELSAD;
              break;
            case "unifiedSchoolDistrictName":
              returnval = sub.NAME;
              break;
            case "place":
              returnval = sub.place;
              break;
            case "countySubdivision":
              returnval = sub.countySubdivision;
              break;
            case "county":
              returnval = sub.county;
              break;
            case "state":
              returnval = sub.state;
              break;
            case "default":
              returnval = sub.NAME;
              break;
          }
          return returnval;
        });

        var ndata = $filter("unique")(data);
        if (ndata.length > 1) {
          return "yellowBackground";
        } else {
          return "";
        }
      } else {
        return "";
      }
    };

    $scope.allcounties = [];

    $scope.getCounties = function (lbl) {
      MyService.ConsoleLog("county >", $scope.oldaddress);
      // $scope.allcounties.length = 0;
      var statePostalCode = "";
      var state = "";
      // if (lbl == "new") {
      //   state = JSON.stringify($scope.oldaddress.state);
      // } else {
      statePostalCode = $scope.oldaddress.state[0].STATEFP;
      // state = $scope.Location.state;
      // }
      // //MyService.ConsoleLog(statePostalCode + "<><><><>>" + state);
      MyService.getAllCounties(statePostalCode, state).then(
        function (payload) {
          // //MyService.ConsoleLog("sublocations Locals : ", payload);
          var allcounties = payload;
          if (lbl == "new") {
            var county = $scope.checkCounty(
              allcounties,
              $scope.oldaddress.county
            );
            $scope.allcounties = county;
            MyService.ConsoleLog("county<><", county[0]);
            MyService.ConsoleLog("$scope.Location", $scope.Location);
            $scope.Location.county = county[0];
          }
        },
        function (errorPayload) {
          growl.error("Something went wrong.");
        }
      );
    };
    $scope.MyPlaces = [];
    $scope.getSubCounties = function (lbl) {
      // //MyService.ConsoleLog(" $scope.Location.state :",$scope.Location.state);
      // //MyService.ConsoleLog("$scope.Location.county :",$scope.Location.county);
      // var county = $scope.Location.county;

      $scope.MyPlaces.length = 0;
      var county = "";
      var statePostalCode = "";
      $scope.MyPlaces.length = 0;
      var state = "";
      var county = "";
      if (lbl == "new") {
        state = JSON.stringify($scope.oldaddress.state);
        county = JSON.stringify($scope.oldaddress.county);
      } else {
        statePostalCode = $scope.Location.state.statePostalCode;
        state = $scope.Location.state;
        county = county.county;
      }
      // //MyService.ConsoleLog(statePostalCode + "===" + county);
      MyService.getAllSubCountiesLocal(statePostalCode, state, county).then(
        function (payload) {
          // payload = JSON.parse(payload);
          $scope.MyPlaces = payload;
          // //MyService.ConsoleLog("PlaCE :", payload);
          // //MyService.ConsoleLog(payload.countySubdivision);
          var subcounties = payload.countySubdivision;
          var places = payload.places;
          // //MyService.ConsoleLog("PlaCE :", payload);
          if (lbl == "new") {
            // //MyService.ConsoleLog("Places 1 > ",$scope.oldaddress.place);
            var subcounty = $scope.checksubCounty(
              subcounties,
              $scope.oldaddress.countySubdivision
            );
            var places = $scope.checkPlaces(places, $scope.oldaddress.place);
            // //MyService.ConsoleLog("subcounty<><><", subcounty);
            $scope.subcounties = subcounty;
            $scope.places = places;
            // //console.log('***********', places[0]);
            // $scope.Location.countySubdivision = subcounty[0];
            $scope.Location.place = places[0];
          }
        },
        function (errorPayload) {
          growl.error("Something went wrong.");
        }
      );
    };

    $scope.checkState = function (rdata, val) {
      //MyService.ConsoleLog("State :", rdata);
      //MyService.ConsoleLog("State val :", val);
      var sdata = [];
      var len = rdata.length;
      var j = 1;

      for (var i = 0; i < len; i++, j++) {
        var rsdata = rdata[i];
        var gdata = val.filter(function (obj) {
          if (
            rsdata.countyFips == obj.COUNTYFP &&
            rsdata.stateFips == obj.STATEFP
          ) {
            // //MyService.ConsoleLog(rdata[i]);
            return rdata[i];
          }
        });
        if (gdata.length > 0) {
          if (sdata.indexOf(rdata[i]) == -1) {
            sdata.push(rdata[i]);
          }
        }

        if (j == len) {
          // //MyService.ConsoleLog("gdata > ", sdata);
          return sdata;
        }
      }
    };

    $scope.checkCounty = function (rdata, val) {
      //MyService.ConsoleLog("County :", rdata);
      //MyService.ConsoleLog("County val :", val);
      var sdata = [];
      var len = rdata.length;
      var j = 1;

      for (var i = 0; i < len; i++, j++) {
        var rsdata = rdata[i];
        var gdata = val.filter(function (obj) {
          if (
            rsdata.countyFips == obj.COUNTYFP &&
            rsdata.stateFips == obj.STATEFP
          ) {
            // //MyService.ConsoleLog(rdata[i]);
            return rdata[i];
          }
        });
        if (gdata.length > 0) {
          if (sdata.indexOf(rdata[i]) == -1) {
            sdata.push(rdata[i]);
          }
        }

        if (j == len) {
          // //MyService.ConsoleLog("gdata > ", sdata);
          return sdata;
        }
      }
    };
    $scope.checksubCounty = function (rdata, val) {
      var sdata = [];
      var len = rdata.length;
      var j = 1;

      for (var i = 0; i < len; i++, j++) {
        var rsdata = rdata[i];
        var gdata = val.filter(function (obj) {
          if (rsdata.countySubdivision == obj.NAME) {
            // //MyService.ConsoleLog(rdata[i]);
            return rdata[i];
          }
        });
        if (gdata.length > 0) {
          if (sdata.indexOf(rdata[i]) == -1) {
            sdata.push(rdata[i]);
          }
        }

        if (j == len) {
          // //MyService.ConsoleLog("gdata > ", sdata);
          return sdata;
        }
      }
    };
    $scope.checkPlaces = function (prdata, val) {
      var sdata = [];
      var len = prdata.length;
      var j = 1;

      for (var i = 0; i < len; i++, j++) {
        var rsdata = prdata[i];
        var gdata = val.filter(function (obj) {
          // //MyService.ConsoleLog(rsdata.place +"=="+ obj.NAME);
          if (rsdata.place == obj.NAME && !rsdata.countyFips) {
            // //MyService.ConsoleLog(rdata[i]);
            return prdata[i];
          }
        });
        if (gdata.length > 0) {
          if (sdata.indexOf(prdata[i]) == -1) {
            sdata.push(prdata[i]);
          }
        }

        if (j == len) {
          // //MyService.ConsoleLog("gdata > ", sdata);
          return sdata;
        }
      }
    };

    $scope.oldaddress = {
      state: "",
      county: "",
      countySubdivision: "",
      place: ""
    };
    $scope.showAddressDrop = false;
    $scope.showAddressDropDowns = function (zipcode, loc) {
      $scope.showZipLoader = true;
      // //console.log(zipcode);

      if (loc && loc != "") {

        MyService.getAllStates().then(
          function (payload) {
            $scope.allStateRes = payload;
            $scope.states = payload;
            // //MyService.ConsoleLog(" $scope.allStateRes :", $scope.allStateRes);

          },
          function (errorPayload) {
            growl.error("Something went wrong.");
          }
        );

        MyService.getOrganizedZipData({
          "candidate": true,
          loc: loc
        }).then(
          function (respo) {
            //MyService.ConsoleLog("mylog", respo);
            if (respo && respo.state) {
              // var finalData = payload.data;
              // //MyService.ConsoleLog(payload[0]);
              // //MyService.ConsoleLog(payload[0].countySubdivision);
              // //MyService.ConsoleLog(payload[0].county);
              // //MyService.ConsoleLog(payload[0].place);
              var countySubdivisions = respo.places.filter(function (obj) {
                if (obj.COUSUBFP && obj.COUSUBFP != "") {
                  // //MyService.ConsoleLog("Inside cs");
                  return obj;
                }
              });
              var places = respo.places.filter(function (obj) {
                if (obj.PLACEFP && obj.PLACEFP != "") {
                  // //MyService.ConsoleLog("obj > ", obj);
                  return obj;
                }
              });

              // //MyService.ConsoleLog("here");
              $scope.showZipLoader = false;
              $scope.showAddressDrop = true;
              // //MyService.ConsoleLog("countySubdivisions >> ", respo.state[0].NAME);

              $scope.oldaddress.state = respo.state;
              $scope.oldaddress.county = respo.county;
              $scope.oldaddress.countySubdivision = countySubdivisions;
              // //MyService.ConsoleLog("places >>> ",places);
              $scope.oldaddress.place = places;
              $scope.getCounties("new");

              $scope.getSubCounties("new");

              // $scope.voterDistricts = payload;
              // //MyService.ConsoleLog(payload.congressionalDistrict);
              $scope.federalCongrassionalDist = respo.congressionalDistrict;
              //MyService.ConsoleLog("@@@@@@ drop :", $scope.federalCongrassionalDist);

              $scope.stateSenateDistrict = respo.stateSenateDistrict;
              $scope.stateHouseOFRepresentativeDistricts =
                respo.stateHouseofRepresentativesDistrict;
              $scope.unifiedSchoolDistrictNames = respo.unifiedSchoolDistrict;
              //$scope.$apply();
              //MyService.ConsoleLog("$scope.allStates :", $scope.allStates);
              // //MyService.ConsoleLog(payload[0].statePostalCode);
              var address = $scope.checkState($scope.allStateRes, respo.state);
              $scope.allstatesData = address;
              // //MyService.ConsoleLog("address<>", address);
              // $scope.Location.state = address[0];
              // $scope.Location.voterDistrict = $scope.voterDistricts[0];
              $scope.Location.federalCongrassionalDist =
                $scope.federalCongrassionalDist[0];
              $scope.Location.stateSenateDistrict =
                $scope.stateSenateDistrict[0];
              $scope.Location.stateHouseOFRepresentativeDistrict =
                $scope.stateHouseOFRepresentativeDistricts[0];
              $scope.Location.unifiedSchoolDistrictName =
                $scope.unifiedSchoolDistrictNames[0];
              // //MyService.ConsoleLog("address ; ", address);
            } else {
              $scope.showZipLoader = false;
              alert("Zipcode not found in our database. Please correct it");
            }
          },
          function (errorPayload) {
            $scope.showZipLoader = false;
            growl.error(errorPayload);
          }
        );

      } else {

        MyService.getAllStates().then(
          function (payload) {
            $scope.allStateRes = payload;
            $scope.states = payload;
            // //MyService.ConsoleLog(" $scope.allStateRes :", $scope.allStateRes);

          },
          function (errorPayload) {
            growl.error("Something went wrong.");
          }
        );

        MyService.getOrganizedZipData({
          "zipcode": zipcode,
          "candidate": true
        }).then(
          function (respo) {
            //MyService.ConsoleLog("mylog", respo);
            if (respo && respo.state) {
              // var finalData = payload.data;
              // //MyService.ConsoleLog(payload[0]);
              // //MyService.ConsoleLog(payload[0].countySubdivision);
              // //MyService.ConsoleLog(payload[0].county);
              // //MyService.ConsoleLog(payload[0].place);
              var countySubdivisions = respo.places.filter(function (obj) {
                if (obj.COUSUBFP && obj.COUSUBFP != "") {
                  // //MyService.ConsoleLog("Inside cs");
                  return obj;
                }
              });
              var places = respo.places.filter(function (obj) {
                if (obj.PLACEFP && obj.PLACEFP != "") {
                  // //MyService.ConsoleLog("obj > ", obj);
                  return obj;
                }
              });

              // //MyService.ConsoleLog("here");
              $scope.showZipLoader = false;
              $scope.showAddressDrop = true;
              // //MyService.ConsoleLog("countySubdivisions >> ", respo.state[0].NAME);

              $scope.oldaddress.state = respo.state;
              $scope.oldaddress.county = respo.county;
              $scope.oldaddress.countySubdivision = countySubdivisions;
              // //MyService.ConsoleLog("places >>> ",places);
              $scope.oldaddress.place = places;
              $scope.getCounties("new");

              $scope.getSubCounties("new");

              // $scope.voterDistricts = payload;
              // //MyService.ConsoleLog(payload.congressionalDistrict);
              $scope.federalCongrassionalDist = respo.congressionalDistrict;
              //MyService.ConsoleLog("@@@@@@ drop :", $scope.federalCongrassionalDist);

              $scope.stateSenateDistrict = respo.stateSenateDistrict;
              $scope.stateHouseOFRepresentativeDistricts =
                respo.stateHouseofRepresentativesDistrict;
              $scope.unifiedSchoolDistrictNames = respo.unifiedSchoolDistrict;
              //$scope.$apply();
              //MyService.ConsoleLog("$scope.allStates :", $scope.allStates);
              // //MyService.ConsoleLog(payload[0].statePostalCode);
              var address = $scope.checkState($scope.allStateRes, respo.state);
              $scope.allstatesData = address;
              // //MyService.ConsoleLog("address<>", address);
              // $scope.Location.state = address[0];
              // $scope.Location.voterDistrict = $scope.voterDistricts[0];
              //MyService.ConsoleLog("$scope.Location.federalCongrassionalDist :", $scope.federalCongrassionalDist[0]);
              $scope.Location.federalCongrassionalDist =
                $scope.federalCongrassionalDist[0];
              $scope.Location.stateSenateDistrict =
                $scope.stateSenateDistrict[0];
              $scope.Location.stateHouseOFRepresentativeDistrict =
                $scope.stateHouseOFRepresentativeDistricts[0];
              $scope.Location.unifiedSchoolDistrictName =
                $scope.unifiedSchoolDistrictNames[0];
              // //MyService.ConsoleLog("address ; ", address);
            } else {
              $scope.showZipLoader = false;
              alert("Zipcode not found in our database. Please correct it");
            }
          },
          function (errorPayload) {
            $scope.showZipLoader = false;
            growl.error(errorPayload);
          }
        );
      }

    };


    $scope.setAddressNew = function (address) {

      //MyService.ConsoleLog("setAddressNew > ", address);

      // if ($scope.statusGetStates == 2 && $scope.statusGetZipdata == 2) {

      var postobj = {
        userId: tokenService.getUserId(),
        zipcode: "",
        mailingAddress: $scope.mailing_Address
      };

      var add = {};

      if (address.state) {
        add.state = address.state.state;
        add.statePostalCode = address.state.statePostalCode;
        add.stateFips = address.state.stateFips;
        //MyService.ConsoleLog("address.statePostalCode :", address.state);
      }

      if (address.place) {
        add.placeFips = address.place.placeFips;
        add.place = address.place.placeName;
      }

      if (address.county) {
        add.countyFips = address.county.countyFips;
        add.county = address.county.countyName;
      }

      if (address.subcounty) {
        add.countySubdivisionFips = address.subcounty.COUSUBFP;
        add.countySubdivision = address.subcounty.NAME;
      }

      if (address.federalCongrassionalDist) {
        add.federalCongrassionalDist = address.federalCongrassionalDist.CD115FP;
      }

      if (address.stateSenateDistrict) {
        add.stateSenateDistrict = address.stateSenateDistrict.SLDUST;
      }

      if (address.unifiedSchoolDistrictName) {
        add.schoolDistrictFips = address.unifiedSchoolDistrictName.UNSDLEA;
        add.schoolDistrict = address.unifiedSchoolDistrictName.NAME;
      }

      // if ($scope.address.voterDistrict) {
      //   address.voterDistrictFips = $scope.address.voterDistrict.number;
      //   address.voterDistrict = $scope.address.voterDistrict.name;
      // }

      if (address.stateHouseOFRepresentativeDistrict) {
        var str = address.stateHouseOFRepresentativeDistrict.NAMELSAD;
        //MyService.ConsoleLog("address.stateLegislativeDistrict.NAMELSAD >>>>", str);

        var newString = str.substr(0, str.length - 3);
        //MyService.ConsoleLog("newString >>>>", newString);

        switch (newString) {

          case "General Assembly District":
            add.legislativeDistrict = address.stateHouseOFRepresentativeDistrict.NAMELSAD.replace("General Assembly District ", "");
            break;
          case "Assembly District":
            add.legislativeDistrict = address.stateHouseOFRepresentativeDistrict.NAMELSAD.replace("Assembly District ", "");
            break;
          case "State House District":
            add.legislativeDistrict = address.stateHouseOFRepresentativeDistrict.NAMELSAD.replace("State House District ", "");
            break;

          default:
            break;
        }




      }



      var finalLoc = JSON.parse($scope.loc);
      //MyService.ConsoleLog(" $scope.address: ", finalLoc);


      add.loca = {
        "type": "Point",
        "coordinates": [finalLoc.longitude, finalLoc.latitude]
      }

      // alert("got");

      //MyService.ConsoleLog(">>>>>>>>>> add >>>>>>>>>>>: ", address);
      postobj.mailingAddress = $scope.mailing_Address ? $scope.mailing_Address : "";

      postobj.address = JSON.stringify(add);
      //MyService.ConsoleLog("postobj.address: ", postobj);

      MyService.updateAddress(postobj).then(function (data) {
        growl.success("Updated successfully.");
        // $scope.setAddressNew();
        MyService.ConsoleLog("data", data);
        $scope.getMailingAddress(tokenService.getUserId());
        // $scope.closeThisDialog();
      }, function (err) {
        growl.error("Something went wrong.");
      });

      // }

    }

  }]);

'use strict';
angular.module('myApp.sponsored', ['ngRoute'])

  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/sponsored/:id/:userid/:type?', {
      templateUrl: 'app/sponsored/sponsored.html',
      controller: 'sponsoredCtrl'
    });
  }])
  .controller('sponsoredCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService) {
    $scope.memberId = $routeParams.id;
    $scope.sponsorData = [];
    MyService.ConsoleLog("memberId : " + $scope.memberId);
    $scope.selectedIndex;
    $scope.memberName;

    $scope.getBillCosponsored = function() {
      MyService.ConsoleLog("In getBillCosponsored :");
        var data = {};
        data.id = $scope.memberId;
        MyService.getBillCosponsoredData(data).then(function(data) {
          MyService.ConsoleLog("getBillCosponsored success : ", data);
          $scope.memberName = data.data.data.results[0].name;
          $scope.sponsorData = data.data.data.results[0].bills;
        }, function(err) {
          MyService.ConsoleLog("getBillCosponsored error : ", err);
        });
    }
    $scope.backToProfile = function() {
      $location.path("/publicProfile/" + $routeParams.userid + "/"+$routeParams.type);
    }
    if ($routeParams.id != "") {
      $scope.getBillCosponsored();
    }
  }]);

'use strict';
angular.module('myApp.speakOut', ['ngRoute'])

  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/speakOut', {
      templateUrl: 'app/speakOut/speakOut.html',
      controller: 'speakOutCtrl'
    });
  }])
  .controller('speakOutCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService) {

  }]);

"use strict";
angular
  .module("myApp.snapshot", ["ngRoute", "angularPayments"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/snapshot", {
        templateUrl: "app/snapshot/snapshot.html",
        controller: "snapshotCtrl",
      });
    },
  ])
  .controller("snapshotCtrl", [
    "$scope",
    "$rootScope",
    "growl",
    "ngDialog",
    "tokenService",
    "MyService",
    "$location",
    "$window",
    "$filter",
    function (
      $scope,
      $rootScope,
      growl,
      ngDialog,
      tokenService,
      MyService,
      $location,
      $window,
      $filter
    ) {
      //MyService.ConsoleLog("** dashboardCtrl **");
      $scope.loadingExtra = false;
      $rootScope.welcome = false;
      $scope.alert_success = false;
      $scope.error_alert = false;
      $scope.alert_token = false;

      window.localStorage.removeItem("fiveMatch");
      window.localStorage.removeItem("queIdsN");

      document.title = "Votewise";

      $scope.Location = {
        county: "",
        place: "",
        state: "",
      };

      $scope.User = {
        Address: "",
      };

      $scope.showCon = false;
      $scope.showBoth = false;
      $scope.showEm = false;

      /**
       * @description Show pop up If the showSavePopUp is true
       */
      if (window.localStorage.getItem("showSavePopUp")) {
        var message =
          "Your quiz has been saved to this page.  Anytime you want to come back to this page, just click your name in the top banner.";
        var modal = ngDialog.openConfirm({
          template:
            "<p>" +
            message +
            '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">OK</button>\
                            \
                        </div>',
          plain: true,
        });

        modal.then(
          function fullfilled(data) {
            MyService.ConsoleLog("fullfilled: ", data);
          },
          function rejected(data) {
            //MyService.ConsoleLog("rejected: ", data);
          }
        );
        window.localStorage.removeItem("showSavePopUp");
      }
      MyService.ConsoleLog(
        " check the flag value > ",
        window.localStorage.getItem("isPostCard")
      );
      MyService.ConsoleLog(
        " check the flag value > ",
        typeof window.localStorage.getItem("isPostCard")
      );

      var options = {
        componentRestrictions: {
          country: "us",
        },
        types: ["geocode"],
      };

      $scope.detectAddress = function (ent) {
        var val = document.getElementById("address");
        // //console.log($scope.User.Address);
        var autocomplete = new google.maps.places.Autocomplete(val, options);

        google.maps.event.addListener(
          autocomplete,
          "place_changed",
          function () {
            var place = autocomplete.getPlace();

            var lat = place.geometry.location.lat(),
              lng = place.geometry.location.lng();

            $scope.lati = lat.toFixed(6);
            $scope.lon = lng.toFixed(6);
            // //console.log($scope.lati);
            // //console.log($scope.lon);

            $scope.mailing_Address = place.formatted_address;
            console.log(
              "  place.address_components :",
              place.address_components
            );
            for (var i = 0; i < place.address_components.length; i++) {
              for (
                var j = 0;
                j < place.address_components[i].types.length;
                j++
              ) {
                if (
                  place.address_components[i].types[j] ==
                  "administrative_area_level_1"
                ) {
                  $scope.statePostalCode =
                    place.address_components[i].short_name;
                  // //console.log($scope.statePostalCode);
                }
                if (place.address_components[i].types[j] == "country") {
                  $scope.countryname = place.address_components[i].long_name;
                  // //console.log($scope.countryname);
                }
                if (
                  place.address_components[i].types[j] ==
                  "administrative_area_level_2"
                ) {
                  $scope.county_name = place.address_components[i].long_name;
                  // //console.log($scope.county_name);
                }
                if (place.address_components[i].types[j] == "locality") {
                  $scope.place_name = place.address_components[i].long_name;
                  // //console.log($scope.place_name);
                }
                if (place.address_components[i].types[j] == "postal_code") {
                  // document.getElementById('zip').value = place.address_components[i].long_name;
                  $scope.ZipCode = place.address_components[i].long_name;
                  // //console.log($scope.User.ZipCode);
                }
              }
            }

            //MyService.ConsoleLog(" $scope.User.ZipCode :", $scope.ZipCode);

            $scope.loc = JSON.stringify({
              longitude: $scope.lon,
              latitude: $scope.lati,
            });
            // //console.log(" long and lat :",$scope.loc );
            // $rootScope.location = new Array;

            $scope.showAddressDropDowns("", $scope.loc);
          }
        );
      };

      $scope.checkLen = function (ldata, sval) {
        // //MyService.ConsoleLog("vdata : ", vdata);
        //MyService.ConsoleLog("vdata", ldata);
        if (ldata && ldata.length > 0) {
          var data = ldata.map(function (sub) {
            var returnval = "";
            switch (sval) {
              case "federalCongrassionalDist":
                returnval = sub.CD115FP;
                break;
              case "stateSenateDistrict":
                returnval = sub.SLDUST;
                break;
              case "stateHouseOFRepresentativeDistrict":
                returnval = sub.NAMELSAD;
                break;
              case "unifiedSchoolDistrictName":
                returnval = sub.NAME;
                break;
              case "place":
                returnval = sub.place;
                break;
              case "countySubdivision":
                returnval = sub.countySubdivision;
                break;
              case "county":
                returnval = sub.county;
                break;
              case "state":
                returnval = sub.state;
                break;
              case "default":
                returnval = sub.NAME;
                break;
            }
            return returnval;
          });

          var ndata = $filter("unique")(data);
          if (ndata.length > 1) {
            return "yellowBackground";
          } else {
            return "";
          }
        } else {
          return "";
        }
      };

      $scope.allcounties = [];

      $scope.getCounties = function (lbl) {
        MyService.ConsoleLog("county >", $scope.oldaddress);
        // $scope.allcounties.length = 0;
        var statePostalCode = "";
        var state = "";
        // if (lbl == "new") {
        //   state = JSON.stringify($scope.oldaddress.state);
        // } else {
        statePostalCode = $scope.oldaddress.state[0].STATEFP;
        // state = $scope.Location.state;
        // }
        // //MyService.ConsoleLog(statePostalCode + "<><><><>>" + state);
        MyService.getAllCounties(statePostalCode, state).then(
          function (payload) {
            // //MyService.ConsoleLog("sublocations Locals : ", payload);
            var allcounties = payload;
            if (lbl == "new") {
              var county = $scope.checkCounty(
                allcounties,
                $scope.oldaddress.county
              );
              $scope.allcounties = county;
              MyService.ConsoleLog("county<><", county[0]);
              MyService.ConsoleLog("$scope.Location", $scope.Location);
              $scope.Location.county = county[0];
            }
          },
          function (errorPayload) {
            growl.error("Something went wrong.");
          }
        );
      };
      $scope.MyPlaces = [];
      $scope.getSubCounties = function (lbl) {
        // //MyService.ConsoleLog(" $scope.Location.state :",$scope.Location.state);
        // //MyService.ConsoleLog("$scope.Location.county :",$scope.Location.county);
        // var county = $scope.Location.county;

        $scope.MyPlaces.length = 0;
        var county = "";
        var statePostalCode = "";
        $scope.MyPlaces.length = 0;
        var state = "";
        var county = "";
        if (lbl == "new") {
          state = JSON.stringify($scope.oldaddress.state);
          county = JSON.stringify($scope.oldaddress.county);
        } else {
          statePostalCode = $scope.Location.state.statePostalCode;
          state = $scope.Location.state;
          county = county.county;
        }
        // //MyService.ConsoleLog(statePostalCode + "===" + county);
        MyService.getAllSubCountiesLocal(statePostalCode, state, county).then(
          function (payload) {
            // payload = JSON.parse(payload);
            $scope.MyPlaces = payload;
            // //MyService.ConsoleLog("PlaCE :", payload);
            // //MyService.ConsoleLog(payload.countySubdivision);
            var subcounties = payload.countySubdivision;
            var places = payload.places;
            // //MyService.ConsoleLog("PlaCE :", payload);
            if (lbl == "new") {
              // //MyService.ConsoleLog("Places 1 > ",$scope.oldaddress.place);
              var subcounty = $scope.checksubCounty(
                subcounties,
                $scope.oldaddress.countySubdivision
              );
              var places = $scope.checkPlaces(places, $scope.oldaddress.place);
              // //MyService.ConsoleLog("subcounty<><><", subcounty);
              $scope.subcounties = subcounty;
              $scope.places = places;
              // //console.log('***********', places[0]);
              // $scope.Location.countySubdivision = subcounty[0];
              $scope.Location.place = places[0];
            }
          },
          function (errorPayload) {
            growl.error("Something went wrong.");
          }
        );
      };

      $scope.checkState = function (rdata, val) {
        //MyService.ConsoleLog("State :", rdata);
        //MyService.ConsoleLog("State val :", val);
        var sdata = [];
        var len = rdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = rdata[i];
          var gdata = val.filter(function (obj) {
            if (
              rsdata.countyFips == obj.COUNTYFP &&
              rsdata.stateFips == obj.STATEFP
            ) {
              // //MyService.ConsoleLog(rdata[i]);
              return rdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(rdata[i]) == -1) {
              sdata.push(rdata[i]);
            }
          }

          if (j == len) {
            // //MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };

      $scope.checkCounty = function (rdata, val) {
        //MyService.ConsoleLog("County :", rdata);
        //MyService.ConsoleLog("County val :", val);
        var sdata = [];
        var len = rdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = rdata[i];
          var gdata = val.filter(function (obj) {
            if (
              rsdata.countyFips == obj.COUNTYFP &&
              rsdata.stateFips == obj.STATEFP
            ) {
              // //MyService.ConsoleLog(rdata[i]);
              return rdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(rdata[i]) == -1) {
              sdata.push(rdata[i]);
            }
          }

          if (j == len) {
            // //MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };
      $scope.checksubCounty = function (rdata, val) {
        var sdata = [];
        var len = rdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = rdata[i];
          var gdata = val.filter(function (obj) {
            if (rsdata.countySubdivision == obj.NAME) {
              // //MyService.ConsoleLog(rdata[i]);
              return rdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(rdata[i]) == -1) {
              sdata.push(rdata[i]);
            }
          }

          if (j == len) {
            // //MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };
      $scope.checkPlaces = function (prdata, val) {
        var sdata = [];
        var len = prdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = prdata[i];
          var gdata = val.filter(function (obj) {
            // //MyService.ConsoleLog(rsdata.place +"=="+ obj.NAME);
            if (rsdata.place == obj.NAME && !rsdata.countyFips) {
              // //MyService.ConsoleLog(rdata[i]);
              return prdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(prdata[i]) == -1) {
              sdata.push(prdata[i]);
            }
          }

          if (j == len) {
            // //MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };

      $scope.oldaddress = {
        state: "",
        county: "",
        countySubdivision: "",
        place: "",
      };
      $scope.address = {
        state: "",
        county: "",
        countySubdivision: "",
        place: "",
      };
      $scope.showAddressDrop = false;
      $scope.showAddressDropDowns = function (zipcode, loc) {
        $scope.showZipLoader = true;
        // //console.log(zipcode);

        if (loc && loc != "") {
          MyService.getAllStates().then(
            function (payload) {
              $scope.allStateRes = payload;
              $scope.states = payload;
              // //MyService.ConsoleLog(" $scope.allStateRes :", $scope.allStateRes);
            },
            function (errorPayload) {
              growl.error("Something went wrong.");
            }
          );

          MyService.getOrganizedZipData({
            candidate: true,
            loc: loc,
          }).then(
            function (respo) {
              //MyService.ConsoleLog("mylog", respo);
              if (respo && respo.state) {
                // var finalData = payload.data;
                // //MyService.ConsoleLog(payload[0]);
                // //MyService.ConsoleLog(payload[0].countySubdivision);
                // //MyService.ConsoleLog(payload[0].county);
                // //MyService.ConsoleLog(payload[0].place);
                var countySubdivisions = respo.places.filter(function (obj) {
                  if (obj.COUSUBFP && obj.COUSUBFP != "") {
                    // //MyService.ConsoleLog("Inside cs");
                    return obj;
                  }
                });
                var places = respo.places.filter(function (obj) {
                  if (obj.PLACEFP && obj.PLACEFP != "") {
                    // //MyService.ConsoleLog("obj > ", obj);
                    return obj;
                  }
                });
                // alert('dd');
                // MyService.ConsoleLog("here", respo);
                $scope.showZipLoader = false;
                $scope.showAddressDrop = true;
                // //MyService.ConsoleLog("countySubdivisions >> ", respo.state[0].NAME);
                $scope.address.county = respo.county;
                $scope.address.place = respo.places;
                // MyService.ConsoleLog(" $scope.address", $scope.address);
                $scope.oldaddress.state = respo.state;
                $scope.oldaddress.county = respo.county;
                $scope.oldaddress.countySubdivision = countySubdivisions;
                // //MyService.ConsoleLog("places >>> ",places);
                $scope.oldaddress.place = places;
                $scope.getCounties("new");

                $scope.getSubCounties("new");

                // $scope.voterDistricts = payload;
                // //MyService.ConsoleLog(payload.congressionalDistrict);
                $scope.federalCongrassionalDist = respo.congressionalDistrict;
                //MyService.ConsoleLog("@@@@@@ drop :", $scope.federalCongrassionalDist);

                $scope.stateSenateDistrict = respo.stateSenateDistrict;
                $scope.stateHouseOFRepresentativeDistricts =
                  respo.stateHouseofRepresentativesDistrict;
                $scope.unifiedSchoolDistrictNames = respo.unifiedSchoolDistrict;
                //$scope.$apply();
                //MyService.ConsoleLog("$scope.allStates :", $scope.allStates);
                // //MyService.ConsoleLog(payload[0].statePostalCode);
                var address = $scope.checkState(
                  $scope.allStateRes,
                  respo.state
                );
                $scope.allstatesData = address;
                // //MyService.ConsoleLog("address<>", address);
                // $scope.Location.state = address[0];
                // $scope.Location.voterDistrict = $scope.voterDistricts[0];
                $scope.address.state = address[0];
                // $scope.address.voterDistrict = $scope.voterDistricts[0];
                $scope.address.federalCongrassionalDist =
                  $scope.federalCongrassionalDist[0];
                $scope.address.stateSenateDistrict =
                  $scope.stateSenateDistrict[0];
                $scope.address.stateHouseOFRepresentativeDistrict =
                  $scope.stateHouseOFRepresentativeDistricts[0];
                $scope.address.unifiedSchoolDistrictName =
                  $scope.unifiedSchoolDistrictNames[0];
                $scope.Location.state = address[0];
                MyService.ConsoleLog("address<>", address);
                $scope.Location.federalCongrassionalDist =
                  $scope.federalCongrassionalDist[0];
                $scope.Location.stateSenateDistrict =
                  $scope.stateSenateDistrict[0];
                $scope.Location.stateHouseOFRepresentativeDistrict =
                  $scope.stateHouseOFRepresentativeDistricts[0];
                $scope.Location.unifiedSchoolDistrictName =
                  $scope.unifiedSchoolDistrictNames[0];
                // //MyService.ConsoleLog("address ; ", address);
              } else {
                $scope.showZipLoader = false;
                alert("Zipcode not found in our database. Please correct it");
              }
            },
            function (errorPayload) {
              $scope.showZipLoader = false;
              growl.error(errorPayload);
            }
          );
        } else {
          MyService.getAllStates().then(
            function (payload) {
              $scope.allStateRes = payload;
              $scope.states = payload;
              // //MyService.ConsoleLog(" $scope.allStateRes :", $scope.allStateRes);
            },
            function (errorPayload) {
              growl.error("Something went wrong.");
            }
          );

          MyService.getOrganizedZipData({
            zipcode: zipcode,
            candidate: true,
          }).then(
            function (respo) {
              //MyService.ConsoleLog("mylog", respo);
              if (respo && respo.state) {
                // var finalData = payload.data;
                // //MyService.ConsoleLog(payload[0]);
                // //MyService.ConsoleLog(payload[0].countySubdivision);
                // //MyService.ConsoleLog(payload[0].county);
                // //MyService.ConsoleLog(payload[0].place);
                var countySubdivisions = respo.places.filter(function (obj) {
                  if (obj.COUSUBFP && obj.COUSUBFP != "") {
                    // //MyService.ConsoleLog("Inside cs");
                    return obj;
                  }
                });
                var places = respo.places.filter(function (obj) {
                  if (obj.PLACEFP && obj.PLACEFP != "") {
                    // //MyService.ConsoleLog("obj > ", obj);
                    return obj;
                  }
                });

                // //MyService.ConsoleLog("here");
                $scope.showZipLoader = false;
                $scope.showAddressDrop = true;
                // //MyService.ConsoleLog("countySubdivisions >> ", respo.state[0].NAME);

                $scope.oldaddress.state = respo.state;
                $scope.oldaddress.county = respo.county;
                $scope.oldaddress.countySubdivision = countySubdivisions;
                // //MyService.ConsoleLog("places >>> ",places);
                $scope.oldaddress.place = places;
                $scope.getCounties("new");

                $scope.getSubCounties("new");

                // $scope.voterDistricts = payload;
                // //MyService.ConsoleLog(payload.congressionalDistrict);
                $scope.federalCongrassionalDist = respo.congressionalDistrict;
                //MyService.ConsoleLog("@@@@@@ drop :", $scope.federalCongrassionalDist);

                $scope.stateSenateDistrict = respo.stateSenateDistrict;
                $scope.stateHouseOFRepresentativeDistricts =
                  respo.stateHouseofRepresentativesDistrict;
                $scope.unifiedSchoolDistrictNames = respo.unifiedSchoolDistrict;
                //$scope.$apply();
                //MyService.ConsoleLog("$scope.allStates :", $scope.allStates);
                // //MyService.ConsoleLog(payload[0].statePostalCode);
                var address = $scope.checkState(
                  $scope.allStateRes,
                  respo.state
                );
                $scope.allstatesData = address;
                $scope.Location.state = address[0];
                MyService.ConsoleLog("address<>", address);
                // $scope.Location.state = address[0];
                // $scope.Location.voterDistrict = $scope.voterDistricts[0];
                //MyService.ConsoleLog("$scope.Location.federalCongrassionalDist :", $scope.federalCongrassionalDist[0]);
                $scope.Location.federalCongrassionalDist =
                  $scope.federalCongrassionalDist[0];
                $scope.Location.stateSenateDistrict =
                  $scope.stateSenateDistrict[0];
                $scope.Location.stateHouseOFRepresentativeDistrict =
                  $scope.stateHouseOFRepresentativeDistricts[0];
                $scope.Location.unifiedSchoolDistrictName =
                  $scope.unifiedSchoolDistrictNames[0];
                // //MyService.ConsoleLog("address ; ", address);
              } else {
                $scope.showZipLoader = false;
                alert("Zipcode not found in our database. Please correct it");
              }
            },
            function (errorPayload) {
              $scope.showZipLoader = false;
              growl.error(errorPayload);
            }
          );
        }
      };

      $scope.setAddressNew = function (address) {
        MyService.ConsoleLog("setAddressNew > ", address);

        // if ($scope.statusGetStates == 2 && $scope.statusGetZipdata == 2) {

        var postobj = {
          userId: tokenService.getUserId(),
          zipcode: "",
          mailingAddress: $scope.mailing_Address,
        };

        var add = {};

        if (address.state) {
          add.state = address.state.state;
          add.statePostalCode = address.state.statePostalCode;
          add.stateFips = address.state.stateFips;
          //MyService.ConsoleLog("address.statePostalCode :", address.state);
        }

        if (address.place) {
          add.placeFips = address.place.placeFips;
          add.place = address.place.placeName;
        }

        if (address.county) {
          add.countyFips = address.county.countyFips;
          add.county = address.county.countyName;
        }

        if (address.subcounty) {
          add.countySubdivisionFips = address.subcounty.COUSUBFP;
          add.countySubdivision = address.subcounty.NAME;
        }

        if (address.federalCongrassionalDist) {
          add.federalCongrassionalDist =
            address.federalCongrassionalDist.CD115FP;
        }

        if (address.stateSenateDistrict) {
          add.stateSenateDistrict = address.stateSenateDistrict.SLDUST;
        }

        if (address.unifiedSchoolDistrictName) {
          add.schoolDistrictFips = address.unifiedSchoolDistrictName.UNSDLEA;
          add.schoolDistrict = address.unifiedSchoolDistrictName.NAME;
        }

        // if ($scope.address.voterDistrict) {
        //   address.voterDistrictFips = $scope.address.voterDistrict.number;
        //   address.voterDistrict = $scope.address.voterDistrict.name;
        // }

        if (address.stateHouseOFRepresentativeDistrict) {
          var str = address.stateHouseOFRepresentativeDistrict.NAMELSAD;
          //MyService.ConsoleLog("address.stateLegislativeDistrict.NAMELSAD >>>>", str);

          var newString = str.substr(0, str.length - 3);
          //MyService.ConsoleLog("newString >>>>", newString);

          switch (newString) {
            case "General Assembly District":
              add.legislativeDistrict =
                address.stateHouseOFRepresentativeDistrict.NAMELSAD.replace(
                  "General Assembly District ",
                  ""
                );
              break;
            case "Assembly District":
              add.legislativeDistrict =
                address.stateHouseOFRepresentativeDistrict.NAMELSAD.replace(
                  "Assembly District ",
                  ""
                );
              break;
            case "State House District":
              add.legislativeDistrict =
                address.stateHouseOFRepresentativeDistrict.NAMELSAD.replace(
                  "State House District ",
                  ""
                );
              break;

            default:
              break;
          }
        }

        var finalLoc = JSON.parse($scope.loc);
        //MyService.ConsoleLog(" $scope.address: ", finalLoc);

        add.loca = {
          type: "Point",
          coordinates: [finalLoc.longitude, finalLoc.latitude],
        };

        // alert("got");

        //MyService.ConsoleLog(">>>>>>>>>> add >>>>>>>>>>>: ", address);
        postobj.mailingAddress = $scope.mailing_Address
          ? $scope.mailing_Address
          : "";

        postobj.address = JSON.stringify(add);
        //MyService.ConsoleLog("postobj.address: ", postobj);

        MyService.updateAddress(postobj).then(
          function (data) {
            growl.success("Updated successfully.");
            // $scope.setAddressNew();
            MyService.ConsoleLog("data", data);
            $scope.addressPopup.close();
            // $scope.closeThisDialog();
          },
          function (err) {
            growl.error("Something went wrong.");
          }
        );

        // }
      };

      /**
       * Redirect
       */
      $scope.goto = function () {
        $location.path("/verifyBy");
      };

      /**
       * Close it
       */
      $scope.closeIt = function () {
        $scope.PopDialog.close();
      };

      /**
       * Send Verification mail
       */

      $scope.sendMail = function () {
        MyService.SendVerificationMail({
          verificationUrl: $rootScope.getVerificationUrl(),
          unsubscribeurl: $rootScope.getEmailUnsubscribeUrl(),
        }).then(
          function (response) {
            MyService.ConsoleLog("response", response);
            if (response.data.success) {
              growl.success("Please check your email");
            }
          },
          function (err) {
            MyService.ConsoleLog("err", err);
          }
        );
      };

      $scope.favChannel = "associated-press";
      if (tokenService.getUserData()) {
        $scope.userData = JSON.parse(tokenService.getUserData());
        MyService.ConsoleLog(" $scope.userData", $scope.userData);

        if (
          window.localStorage.getItem("isPostCard") &&
          window.localStorage.getItem("isPostCard") != "false" &&
          !$scope.userData.email
        ) {
          var message =
            "Your Access is limited. Kindly add your email address to access exciting features";
          var modal = ngDialog.openConfirm({
            template:
              "<p>" +
              message +
              '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">Add Email</button>\
                            \
                        </div>',
            plain: true,
          });

          modal.then(
            function fullfilled(data) {
              $location.path("/userProfile");
            },
            function rejected(data) {
              //MyService.ConsoleLog("rejected: ", data);
            }
          );
          window.localStorage.removeItem("isPostCard");
        }

        if (
          $scope.userData.my_fav_channel &&
          $scope.userData.my_fav_channel != ""
        ) {
          $scope.favChannel = $scope.userData.my_fav_channel;
        }
      }

      /**
       * @description This function get the remainig quiz details
       */
      $scope.getRemainingQuizData = function () {
        MyService.getRemainingQuizData({
          userId: tokenService.getUserId(),
        }).then(
          function (APIResponse) {
            MyService.ConsoleLog("APIResponse", APIResponse.remainingQuizLinks);
            $scope.inCompleteQuiz = APIResponse.remainingQuizLinks;
            $scope.completedQuiz = APIResponse.completeQuizLinks;
          },
          function (err) {
            MyService.ConsoleLog("check for error", err);
          }
        );
      };

      $scope.feedtitle = $scope.favChannel
        .replace(new RegExp("-", "g"), " ")
        .toUpperCase();
      $scope.getExtraData = function () {
        $scope.loadingExtra = true;
        MyService.getExtraData($scope.userData).then(
          function (payload) {
            var responseLatest = payload;
            //MyService.ConsoleLog("subcatdata : ", subcatdata);
            $scope.loadingExtra = false;
            $rootScope.ExtraTopicData = responseLatest;
            if (responseLatest) {
              if (responseLatest.MyDiscussion) {
                $scope.DiscussionData = responseLatest.MyDiscussion;
              }
              if (responseLatest.ActiveData) {
                $scope.ActiveThreads = responseLatest.ActiveData;
              }
              if (responseLatest.HotTopics) {
                $scope.HotTopics = responseLatest.HotTopics;
              }
            }
          },
          function (errorPayload) {
            $scope.loadingExtra = false;
            MyService.ConsoleLog("errorPayload", errorPayload);
            alert("Something went wrong");
          }
        );
        $scope.getCurrentUserAns(tokenService.getUserId());
      };

      $scope.getCurrentUserAns = function (userId) {
        MyService.getFiveMinAnswers({
          authorId: userId,
        }).then(
          function (payload) {
            MyService.ConsoleLog("getAllAnsweredQuestions >> ", payload);
            if (payload.data.success) {
              $scope.AllAnsweredQuestions = payload.data.data;
              var queIdsN = $scope.AllAnsweredQuestions.filter(function (item) {
                if (item && item.categories && item.categories.length > 0) {
                  return item.questionId;
                }
              });

              var tempQuesNw = queIdsN.map(function (item) {
                return item.questionId;
              });
              MyService.ConsoleLog("tempQuesNw >> ", tempQuesNw);

              window.localStorage.setItem(
                "queIdsN",
                JSON.stringify(tempQuesNw)
              );
              window.localStorage.setItem(
                "fiveMatch",
                JSON.stringify($scope.AllAnsweredQuestions)
              );
              // $scope.getFiveMinQues();
            }
          },
          function (errpayload) {
            MyService.ConsoleLog(
              "getAllAnsweredQuestions errpayload >> ",
              errpayload
            );
          }
        );
        $scope.getRemainingQuizData();
      };

      $scope.gotoThread = function (data, subcatid) {
        var id = "";
        if (data.parentId) {
          id = data.parentId;
        } else if (data.parent) {
          id = data.parent;
        } else {
          if (data.id) {
            id = data.id;
          } else {
            id = data._id;
          }
        }
        // MyService.ConsoleLog(data);
        var categoryId = "";
        if (data.parentCat[0] && data.parentCat[0] != "") {
          categoryId = data.parentCat[0];
        } else {
          if (data.parentCat[1] && data.parentCat[1] != "") {
            categoryId = data.parentCat[1];
          }
        }

        // $rootScope.subcategoryId = subcatid;
        //MyService.ConsoleLog('forumthread/' + categoryId + '/' + subcatid + '/' + id);

        if (categoryId != "") {
          $location.path(
            "forumthread/" + categoryId + "/" + subcatid + "/" + id
          );
        } else {
          MyService.ConsoleLog("ELSE");
          alert("Something went wrong");
        }
      };

      $scope.gotoNewsThread = function (data, subcatid) {
        var id = data._id;
        //MyService.ConsoleLog(data);
        var categoryId = "";
        if (data.parentCat[0] && data.parentCat[0] != "") {
          categoryId = data.parentCat[0];
        } else {
          if (data.parentCat[1] && data.parentCat[1] != "") {
            categoryId = data.parentCat[1];
          }
        }

        //$rootScope.subcategoryId = subcatid;
        //MyService.ConsoleLog('pressEssayDetails/' + categoryId + '/' + id);
        if (categoryId != "") {
          $location.path("pressEssayDetails/" + categoryId + "/" + id);
        } else {
          MyService.ConsoleLog("vishal");
          alert("Something went wrong");
        }
      };

      $scope.loadingFollow = false;
      $scope.followlist = [];
      $scope.getFollowUsers = function () {
        $scope.loadingFollow = true;
        $scope.followlist.length = 0;
        MyService.ConsoleLog("followlist", $scope.userData.followlist);
        if (
          $scope.userData.followlist &&
          $scope.userData.followlist.length > 0
        ) {
          var userIds = JSON.stringify($scope.userData.followlist);
          MyService.getUsersFromIds({
            userIds: userIds,
          }).then(
            function (payload) {
              MyService.ConsoleLog("payload followers : ", payload.data.data);

              var responseLatest = payload;
              $scope.loadingFollow = false;
              // MyService.ConsoleLog("payload : ", payload.data.data);
              $scope.followlistData = payload.data.data;
            },
            function (errorPayload) {
              $scope.loadingFollow = false;
              MyService.ConsoleLog("errorPayload 3", errorPayload);
              /*   growl.error("There are no records for following users"); */
            }
          );
        } else {
          //alert("You ")
          $scope.loadingFollow = false;
        }
      };
      $scope.ShowPorifleLoading = false;
      $scope.getmyData = function () {
        $scope.ShowPorifleLoading = true;
        MyService.getUserPublicProfile({
          id: $rootScope.UserId,
          type: "false",
        }).then(
          function (response) {
            $scope.ShowPorifleLoading = false;
            if (response.data.success) {
              $scope.userDetails = response.data.data;
              MyService.ConsoleLog("welcome", $scope.userDetails);
              $scope.userProfile = $scope.userDetails.userData;
              // MyService.ConsoleLog("welcome to profile", $scope.userProfile);

              $scope.userType = $scope.userProfile.userType;
              $scope.verify = $scope.userProfile.verifiedUser;
              // MyService.ConsoleLog("welcome", $scope.verify);
              // console.log("$scope.userDetails", $scope.userDetails.userData.address);
              if (!$scope.userProfile.verifiedUser) {
                $scope.showCon = true;
              }
              // if ($scope.userProfile.userType == 'politician') {
              if (
                !$scope.userProfile.isEmailVerified ||
                !$scope.userProfile.verifiedUser
              ) {
                // $scope.getPopUp();
                if (
                  !$scope.userProfile.isEmailVerified &&
                  !$scope.userProfile.verifiedUser
                ) {
                  if ($scope.userProfile.userType == "politician") {
                    $scope.showCon = true;
                    $scope.showBoth = true;
                  } else if (!$scope.userProfile.isEmailVerified) {
                    $scope.showEm = true;
                  }
                } else if (!$scope.userProfile.isEmailVerified) {
                  // if ($scope.userProfile.userType != 'politician') {
                  $scope.showEm = true;
                  // }
                } else {
                  if ($scope.userProfile.userType != "politician") {
                    $scope.showEm = true;
                  }
                }
                if ($scope.userProfile.userType == "politician") {
                  $scope.PopDialog = ngDialog.open({
                    template: "popUp",
                    closeByNavigation: true,
                    scope: $scope,
                    width: "50%",
                    closeByDocument: false,
                  });
                } else if (
                  $scope.userProfile.userType == "advocate" &&
                  $scope.userProfile.isEmailVerified != true
                ) {
                  // alert('cal');
                  MyService.ConsoleLog(
                    "$scope.userProfile",
                    $scope.userProfile.isEmailVerified
                  );
                  $scope.PopDialog = ngDialog.open({
                    template: "popUp",
                    closeByNavigation: true,
                    scope: $scope,
                    width: "50%",
                    closeByDocument: false,
                  });
                }
              }
              // }
              /** Commented on the 28 May 2021 */
              // if (!$scope.userDetails.userData.address.statePostalCode) {
              //   $scope.addressPopup = ngDialog.open({
              //     template: "addressPopUp",
              //     closeByNavigation: true,
              //     scope: $scope,
              //   });
              // }
            } else {
              MyService.ConsoleLog("ELSE vishal");
              alert("Something went wrong.");
            }
          },
          function (errorPayload) {
            $scope.ShowPorifleLoading = false;
            MyService.ConsoleLog("ELSE vishal two");

            alert("Something went wrong.");
          }
        );
      };

      $scope.ShowLoader = false;
      $scope.LatestEssay = [];
      $scope.LatestPost = [];
      $scope.LatestThread = [];
      $scope.gotoPage = function (obj, data) {
        //MyService.ConsoleLog(data);
        switch (obj) {
          case "Essay":
            var userid = data._id;
            $scope.dialogClose = ngDialog.open({
              template: "LatestEssayId",
              closeByNavigation: true,
              scope: $scope,
            });
            $scope.ShowLoader = true;
            MyService.getLatestEssay({
              userId: userid,
            }).then(
              function (payload) {
                $scope.ShowLoader = false;
                MyService.ConsoleLog("essay", payload);
                $scope.LatestEssay = payload;
              },
              function (errorPayload) {
                $scope.ShowLoader = false;
                MyService.ConsoleLog("err vosjs", errorPayload);
                alert("Something went wrong.");
              }
            );
            //$location.path('essayDetails/' + catId + '/' + id);
            break;
          case "EssayComment":
            var userid = data._id;
            $scope.dialogClose = ngDialog.open({
              template: "LatestEssayCommentId",
              closeByNavigation: true,
              scope: $scope,
            });
            $scope.ShowLoader = true;
            MyService.getLatestEssay({
              userId: userid,
              isEssayComment: true,
            }).then(
              function (payload) {
                if (payload && payload.length > 0) {
                  var essayIds = payload.map(function (itms) {
                    if (itms && itms.essayId) {
                      return itms.essayId;
                    }
                  });

                  MyService.getAllEssaysList({
                    eIds: JSON.stringify(essayIds),
                  }).then(
                    function (APIResponse) {
                      MyService.ConsoleLog("APIREs", APIResponse);
                      if (APIResponse.success) {
                        $scope.ShowLoader = false;
                        MyService.ConsoleLog("essay commnent", payload);
                        $scope.LatestEssayComments = APIResponse.data;
                      }
                    },
                    function (err) {
                      MyService.ConsoleLog("Error", err);
                    }
                  );
                }
              },
              function (errorPayload) {
                $scope.ShowLoader = false;
                MyService.ConsoleLog("err vosjs", errorPayload);
                alert("Something went wrong.");
              }
            );

            //$location.path('essayDetails/' + catId + '/' + id);
            break;
          case "Post":
            var userid = data._id;
            // var subcatid = ""
            // if(data.subcategories && data.subcategories.length > 0)
            //var subcatid = data.subcategories[0].pid;
            //var id = data.parent;
            //MyService.ConsoleLog('forumthread/' + catId + '/' + subcatid + '/' + id);
            //$location.path('forumthread/' + catId + '/' + subcatid + '/' + id);
            $scope.dialogClose = ngDialog.open({
              template: "LatestPostId",
              closeByNavigation: true,
              scope: $scope,
            });
            $scope.ShowLoader = true;
            MyService.getLatestPost({
              userId: userid,
            }).then(
              function (payload) {
                $scope.ShowLoader = false;
                //MyService.ConsoleLog(payload);
                $scope.LatestPost = payload;
              },
              function (errorPayload) {
                $scope.ShowLoader = false;
                MyService.ConsoleLog("errorPayload errorPayload", errorPayload);
                alert("Something went wrong.");
              }
            );
            break;
          case "Thread":
            //var catId = data.parentcat[0];
            //var subcatid = ""
            // if(data.subcategories && data.subcategories.length > 0)
            //     var subcatid = data.subcategories[0].pid;
            //var subcatid = data.subcategories[0].pid;
            var userid = data._id;
            $scope.dialogClose = ngDialog.open({
              template: "LatestThreadId",
              closeByNavigation: true,
              scope: $scope,
            });
            $scope.ShowLoader = true;
            MyService.getLatestThread({
              userId: userid,
            }).then(
              function (payload) {
                $scope.ShowLoader = false;
                //MyService.ConsoleLog(payload);
                $scope.LatestThread = payload;
              },
              function (errorPayload) {
                $scope.ShowLoader = false;
                alert("error");
                alert("Something went wrong.");
              }
            );
            //MyService.ConsoleLog('forumthread/' + catId + '/' + subcatid + '/' + id);
            //$location.path('forumthread/' + catId + '/' + subcatid + '/' + id);
            break;
          default:
            break;
        }
      };

      $scope.gotoComments = function (eId, catId) {
        MyService.ConsoleLog("eid", eId);
        MyService.ConsoleLog("catId", catId);

        // MyService.getEssay(eId).then(function (APIResponse) {
        //   MyService.ConsoleLog("APIResponse", APIResponse);
        if (eId && catId) {
          $location.path("/essayDetails/" + catId + "/" + eId);
        }
      };

      $scope.gotoEssay = function (id, catId) {
        $location.path("essayDetails/" + catId + "/" + id);
      };

      $scope.gotoFThread = function (id, catId, subcatid) {
        $location.path("forumthread/" + catId + "/" + subcatid + "/" + id);
      };

      //Select Tags start
      $scope.subtopics = {
        subcategories: [],
      };
      $scope.selectedCat = [];
      $scope.SelectedTree = [];
      $scope.disabled = [];
      $scope.getVal = function (data) {
        //MyService.ConsoleLog(data);
        var idx = $scope.selectedCat.indexOf(data);
        if (idx > -1) {
          $scope.selectedCat.splice(idx, 1);
          var id = $scope.disabled.indexOf(data._id);
          $scope.disabled.splice(id, 1);
          var jdx = $scope.SelectedTree.indexOf(data.parentIds);
          if (jdx > -1) $scope.SelectedTree.splice(jdx, 1);
        } else {
          $scope.selectedCat.push(data);
          var id = $scope.disabled.indexOf(data._id);
          if (id == -1) {
            $scope.disabled.push(data._id);
          }
          //MyService.ConsoleLog(data.parentIds);
          //MyService.ConsoleLog("SelectedTree: ", $scope.SelectedTree);
          if ($scope.SelectedTree.length == 0) {
            if (data.parentIds.length > 0) {
              //var parents = Object.keys(data.parentIds).map(function (key) {return data.parentIds[key]});
              //angular.copy(data.parentIds, $scope.SelectedTree);
              var parents = data.parentIds;
              //MyService.ConsoleLog(parents);
              $scope.SelectedTree = parents;
            }
          } else {
            if (data.parentIds.length > 0) {
              //var parents = Object.keys(data.parentIds).map(function (key) {return data.parentIds[key]});
              //var parents = angular.copy(data.parentIds);
              var parents = data.parentIds;
              var plen = parents.length;
              for (var j = 0; j < plen; j++) {
                $scope.SelectedTree.push(parents[j]);
              }
            }
          }
        }
        //MyService.ConsoleLog($scope.SelectedTree);
      };

      $scope.selectedAll = {
        id: [],
      };

      $scope.removeVal = function (data) {
        var idx = $scope.selectedCat.indexOf(data);
        if (idx > -1) {
          $scope.selectedCat.splice(idx, 1);
          var id = $scope.disabled.indexOf(data._id);
          $scope.disabled.splice(id, 1);
          var parents = data.parentIds;
          var plen = parents.length;
          for (var j = 0; j < plen; j++) {
            var jdx = $scope.SelectedTree.indexOf(parents[j]);
            if (jdx > -1) $scope.SelectedTree.splice(jdx, 1);
          }
        }
        $scope.selectedAll.id.length = 0;
        var allLen = $scope.SelectedTree.length;
        var chkboxe = document.getElementsByName("checkedidcat");
        for (var i = 0; i < allLen; i++) {
          chkboxe[i].checked = true;
        }
      };

      $scope.selectConfig = {
        requiredMin: 1,
        selectAll: true,
      };

      $scope.checkCatExists = function (rdata, val) {
        return rdata.filter(function (rdata) {
          if (rdata._id == val) {
            $scope.selectedCat.push(rdata);
            return rdata;
          } else if (rdata.subcategories) {
            $scope.checkCatExists(rdata.subcategories, val);
          }
        });
      };

      $scope.loadDefaultTags = function () {
        $scope.selectedCat.length = 0;
        $scope.disabled.length = 0;
        var selectedCat = $scope.uData.subject_of_deep_interest;
        $scope.disabled = selectedCat;
        if (selectedCat.length > 0) {
          for (var s = 0; s < selectedCat.length; s++) {
            var checkcatdata = $scope.checkCatExists(
              $scope.subtopics.subcategories,
              selectedCat[s]
            );
          }
        }
      };

      $scope.loadDefaultLocations = function () {
        var locations = $scope.uData.location_of_interest;
        var len = locations.length;
        $scope.selectedArea.length = 0;
        $scope.showSubCat = true;
        $scope.disabledLocation.length = 0;

        for (var l = 0; l < len; l++) {
          var nobj = {};
          if (locations[l].country == "National (USA)") {
            $scope.Essay.National = "National";
          }
          if (locations[l].country) {
            nobj.country = locations[l].country;
          }
          if (locations[l].state) {
            nobj.state = locations[l].state;
            nobj.statePostalCode = locations[l].statePostalCode;
          }
          if (locations[l].county) {
            nobj.county = locations[l].county;
          }
          if (locations[l].countySubdivision) {
            nobj.countySubdivision = locations[l].countySubdivision;
          }
          if (locations[l].place) {
            nobj.place = locations[l].place;
          }
          $scope.selectedArea.push(nobj);
          $scope.disabledLocation.push(nobj);
        }
      };

      $scope.checkDisabled = function (data, stateId, type) {
        data.country = "United States of America";
        data.state = stateId;
        var idx = indexOfExt($scope.disabledLocation, data);
        if (idx > -1) return true;
        else return false;
      };

      $scope.getSubcatTree = function () {
        $scope.selectedCat.length = 0;
        MyService.getAllCatTree({
          type: "Q,F",
        }).then(
          function (payload) {
            //MyService.ConsoleLog("payload");
            //MyService.ConsoleLog(payload);
            $scope.subtopics.subcategories.length = 0;
            var subcatdata = payload;
            $scope.subtopics.subcategories = subcatdata;
            // MyService.ConsoleLog($scope.userData);
            var SelectedCats = $scope.userData.subjectOfDeepInterest;
            if (SelectedCats && SelectedCats.length > 0) {
              $scope.disabled.length = 0;
              $scope.disabled = SelectedCats;
              for (var i = 0; i < SelectedCats.length; i++) {
                var checkcatdata = $scope.checkCatExists(
                  subcatdata,
                  SelectedCats[i]
                );
              }
            }

            // if ($scope.categoryId != "") {
            //     $scope.disabled.length = 0;
            //     $scope.disabled.push($scope.categoryId);
            //     var checkcatdata = $scope.checkCatExists(subcatdata, $scope.categoryId);
            //     //MyService.ConsoleLog($scope.selectedCat);

            // }

            setTimeout(function () {
              var cols = document.getElementsByClassName("cmnUL");
              var clen = cols.length;
              for (var i = 0; i < clen; i++) {
                cols[i].style.display = "none";
              }
            }, 300);
          },
          function (errorPayload) {
            MyService.ConsoleLog("errorPayload wrong", errorPayload);
            alert("Something went wrong ");
          }
        );
      };

      $scope.showSubCat = true;
      $scope.showLoading = [];
      $scope.showLoadingCounty = [];
      $scope.showDown = [];
      $scope.ChangeShow = function (id) {
        //$scope.showSubCat = true;
        //var cols = document.getElementsByClassName('cmnUL');
        //var clen = cols.length;
        var nclass = "MainCatLi_" + id;
        if (
          document.getElementsByClassName(nclass)[0].style.display &&
          document.getElementsByClassName(nclass)[0].style.display == "none"
        ) {
          document.getElementsByClassName(nclass)[0].style.display = "block";
        } else {
          document.getElementsByClassName(nclass)[0].style.display = "none";
        }
      };

      $scope.getSubCat = function (val) {
        //MyService.ConsoleLog("Main Cat", $scope.subtopics.subcategories);
        return $scope.subtopics.subcategories.filter(function (rdata) {
          MyService.ConsoleLog("rdata", rdata._id + "  " + val);
          if (rdata._id == val) {
            //$scope.selectedCat.push(rdata);
            return rdata.subcategories[0]._id;
          }
        });
      };

      $scope.gotoForumT = function (obj) {
        MyService.ConsoleLog("obj", obj);
        var subcat = $scope.getSubCat(obj.parentCat[0]);
        MyService.ConsoleLog("subcat:::", subcat);
        if (obj.parent && obj.parent != "") {
          if (
            subcat &&
            subcat.length > 0 &&
            subcat[0].subCategories &&
            subcat[0].subCategories.length > 0
          ) {
            MyService.ConsoleLog("obj.parentCat[0]", obj.parentCat[0]);
            $scope.gotoFThread(
              obj.parent,
              obj.parentCat[0],
              subcat[0].subCategories[0]._id
            );
          } else if (
            subcat &&
            subcat.length > 0 &&
            subcat[0].subcategories &&
            subcat[0].subcategories.length > 0
          ) {
            $scope.gotoFThread(
              obj.parent,
              obj.parentCat[0],
              subcat[0].subcategories[0]._id
            );
          } else if (obj.parentCat && obj.parentCat.length > 0) {
            $scope.gotoFThread(obj.parent, obj.parentCat[0], null);
          } else {
            $scope.gotoFThread(obj.parent, obj.parentCat[0], null);
          }
        } else {
          if (
            subcat &&
            subcat.length > 0 &&
            obj.parentCat &&
            obj.parentCat.length > 0
          ) {
            $scope.gotoFThread(
              obj._id,
              obj.parentCat[0],
              subcat[0].subcategories[0]._id
            );
          } else if (
            subcat &&
            subcat.length > 0 &&
            subcat[0].subcategories &&
            subcat[0].subcategories.length > 0
          ) {
            $scope.gotoFThread(
              obj._id,
              obj.parentCat[0],
              subcat[0].subcategories[0]._id
            );
          } else if (obj.parentCat && obj.parentCat.length > 0) {
            $scope.gotoFThread(obj._id, obj.parentCat[0], null);
          } else {
            $scope.gotoFThread(obj._id, obj.parentCat[0], null);
          }
        }

        //"#!/forumthread/"+obj.parentcat[0]+"/"+subcat+"/"+obj._id;
      };

      $scope.gotoForumTopic = function (obj) {
        if (obj.parent && obj.parent != "") {
          $scope.gotoFThread(
            obj.parent,
            obj.parentCat[0],
            obj.subCategories[0]
          );
        } else {
          $scope.gotoFThread(obj._id, obj.parentCat[0], obj.subCategories[0]);
        }
      };

      $scope.saveTags = function () {
        var originalArray = [];
        var originalPArray = [];
        var CatIds = $scope.selectedCat.map(function (sub) {
          return sub._id;
        });
        var parentIds = $scope.selectedCat.map(function (sub) {
          sub.parentIds.map(function (parent) {
            if (parent.pid) {
              originalPArray.push(parent);
            }
          });
        });
        //MyService.ConsoleLog(CatIds);
        //MyService.ConsoleLog(originalPArray);
        MyService.setDeepInterest({
          catId: JSON.stringify(CatIds),
          parentId: JSON.stringify(originalPArray),
        }).then(
          function (payload) {
            if (payload.data.success) {
              $scope.userData.subject_of_deep_interest = CatIds;
              $scope.userData.subject_of_interest = originalPArray;
              tokenService.saveUserData(JSON.stringify($scope.userData));
              $scope.getNewsFeed();
            }
            //MyService.ConsoleLog(payload);
          },
          function (errorPayload) {
            //MyService.ConsoleLog(errorPayload);
          }
        );
      };
      $scope.feed = {
        data: [],
      };
      $scope.getAllFeeds = function () {
        $scope.feed.data.length = 0;
        $scope.loadingNewsExtra = true;
        MyService.getFavNews({
          favChannel: $scope.favChannel,
        }).then(
          function (payload) {
            $scope.loadingNewsExtra = false;
            //MyService.ConsoleLog(payload);
            $scope.feed.data = payload;
            $scope.getNewsFeed();
          },
          function (errorPayload) {
            $scope.loadingNewsExtra = false;
            $scope.getNewsFeed();
            //alert("Something went wrong");
          }
        );
      };

      //Select Tags End
      $scope.loadingNewsExtra = false;
      $scope.NewsPost = [];
      $scope.getNewsFeed = function () {
        if (tokenService.getUserData()) {
          $scope.userData = JSON.parse(tokenService.getUserData());
          MyService.ConsoleLog("$scope.userData", $scope.userData);
        }
        var interests = [];
        if (
          $scope.userData.subject_of_deep_interest &&
          $scope.userData.subject_of_deep_interest.length > 0
        ) {
          interests = $scope.userData.subject_of_deep_interest;
        }
        MyService.getNewsFeed({
          interest: JSON.stringify(interests),
        }).then(
          function (response) {
            $scope.loadingNewsExtra = false;
            //MyService.ConsoleLog(response);
            if (response.data.success) {
              $scope.NewsPost = response.data.data;
            } else {
              //alert("Something went wrong.");
            }
          },
          function (errorPayload) {
            $scope.loadingNewsExtra = false;
            //alert("Something went wrong.");
          }
        );
      };
      $scope.recommended = [];
      $scope.getRecommended = function () {
        $scope.recommended.length = 0;

        if (tokenService.getUserData()) {
          $scope.userData = JSON.parse(tokenService.getUserData());
          $scope.followlist = $scope.userData.followlist;
          //MyService.ConsoleLog($scope.followlist);
          if ($scope.followlist.length > 0) {
            $scope.loadingNewsExtra = true;
            MyService.getRecommended({
              followlist: JSON.stringify($scope.followlist),
            }).then(
              function (payload) {
                //MyService.ConsoleLog(payload);
                $scope.loadingNewsExtra = false;
                if (payload.data.success) {
                  $scope.recommended = payload.data.data;
                  //MyService.ConsoleLog($scope.recommended);
                }
              },
              function (errorPayload) {
                //MyService.ConsoleLog(errorPayload);
                $scope.loadingNewsExtra = false;
              }
            );
          }
        }
      };

      $scope.newData = {};

      $scope.latestDataDateWise = function () {
        MyService.latestDataDateWise({}).then(
          function (payload) {
            MyService.ConsoleLog("payload", payload);
            //alert("Here");
            $scope.newData = payload;
          },
          function (errorPayload) {
            MyService.ConsoleLog("errorPayload", errorPayload);
            alert("Something went wrong");
          }
        );
      };

      if ($scope.userData) {
        $scope.getExtraData();
        $scope.getFollowUsers();
        $scope.latestDataDateWise();
        $scope.getmyData();
        $scope.getSubcatTree();
        $scope.getAllFeeds();
        $scope.getRecommended();
      }
    },
  ]);

'use strict';
angular
  .module('myApp.showVotesmartAnsQues', ['ngRoute'])
  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/showVotesmartAnsQues/:qId/:voteCandidateId?', {
        templateUrl: 'app/showVotesmartAnsQues/showVotesmartAnsQues.html',
        controller: 'showVotesmartAnsQuesCtrl',
      });
    },
  ])
  .controller('showVotesmartAnsQuesCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    '$routeParams',
    '$q',
    'ngDialog',
    '$rootScope',
    'growl',
    'MyService',
    '$anchorScroll',
    '$timeout',
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $q,
      ngDialog,
      $rootScope,
      growl,
      MyService,
      $anchorScroll,
      $timeout
    ) {

      /**
       * Get params using route params
       */
      $scope.qId = $routeParams.qId;
      $scope.voteCandidateId = $routeParams.voteCandidateId;
      MyService.ConsoleLog("Qid", $scope.qId);
      MyService.ConsoleLog(" $scope.voteCandidateId", $scope.voteCandidateId);


      /**
       * Get Questions
       */
      $scope.getVotesmartData = function () {

        MyService.getVotesmartData({
          qId: $scope.qId,
          voteCandidateId: $scope.voteCandidateId
        }).then(function (response) {
          MyService.ConsoleLog("response", response);
          $scope.voteData = response.data.data;
        }, function (err) {
          MyService.ConsoleLog("Error", err);
        });
      };

      /**
       * Back to
       */
      $scope.backTo = function () {
        window.history.back();
      };

      $scope.getVotesmartData();
    }
  ]);

"use strict";
angular
  .module("myApp.signup", ["ngRoute"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider
        .when("/signup/:type", {
          templateUrl: "app/signup/signup.html",
          controller: "voter-signupCtrl",
        })
        .when("/verify/:id", {
          templateUrl: "app/signup/verify.html",
          controller: "verifyCtrl",
        });
    },
  ])
  .controller("voter-signupCtrl", [
    "$scope",
    "$http",
    "$location",
    "baseApiUrl",
    "growl",
    "$routeParams",
    "$anchorScroll",
    "tokenService",
    "MyService",
    "$rootScope",
    "$timeout",
    "$q",
    "apiCall",
    "$filter",
    function (
      $scope,
      $http,
      $location,
      baseApiUrl,
      growl,
      $routeParams,
      tokenService,
      MyService,
      $anchorScroll,
      $rootScope,
      $timeout,
      $q,
      apiCall,
      $filter
    ) {},
  ])
  .controller("SignupSectionCtrl", [
    "$scope",
    "$http",
    "$location",
    "baseApiUrl",
    "growl",
    "$routeParams",
    "tokenService",
    "MyService",
    "$rootScope",
    "$timeout",
    "$q",
    "apiCall",
    "$filter",
    "ngDialog",
    "$sce",
    "$cookies",
    function (
      $scope,
      $http,
      $location,
      baseApiUrl,
      growl,
      $routeParams,
      tokenService,
      MyService,
      $rootScope,
      $timeout,
      $q,
      apiCall,
      $filter,
      ngDialog,
      $sce,
      $cookies
    ) {
      $scope.MUserType = [
        /*{
          name: 'Politician',
          key: 'politician',
        },*/
        {
          name: "Voter",
          key: "voter",
        },
        {
          name: "Organization",
          key: "advocate",
        },
        /*     {
             name: "Press",
             key: "press"
           }
           */
      ];
      $scope.address = {
        state: "",
        county: "",
        countySubdivision: "",
        place: "",
      };
      $cookies.remove("showLongPopUp");
      //MyService.ConsoleLog("** SignupSectionCtrl ** : ", $scope.forFacebook);
      $scope.showMultiDrop = false;
      $scope.RegisterButton = false;
      $rootScope.welcome = false;
      $scope.records = [];
      $scope.States = [];
      $scope.Cities = [];
      $scope.UserType = $routeParams.type;
      MyService.ConsoleLog("$scope.UserType", $scope.UserType);
      $scope.Address = {
        ZipCode: "",
        Country: "",
        State: "",
        City: "",
      };
      $scope.HideOrgInfo = false;
      $scope.User = {
        name: "",
        lastname: "",
        UserName: "",
        Password: "",
        Email: "",
        ZipCode: "",
        ssn: "",
        confirmOpt: "Email",
        runElectionDate: "",
        runStatus: "",
        orgType: "",
        state: "",
      };

      $scope.Errors = [];

      //$scope.levelOfGovt = ['national', 'state', 'judicial district', 'county', 'sub county', 'city', 'state school board district', 'local school district', 'other'];

      $scope.levelOfGovt = ["Other", "Federal", "State", "County", "Local"];
      $scope.uName = "";
      $scope.countylevelOfGovt = ["County"];
      $scope.statelevelOfGovt = [
        "State",
        "State House of Representatives District",
        "State Senate District",
        "All USA",
        "Federal Congressional District",
      ];
      $scope.schoollevelOfGovt = [
        "Elementary school District Position",
        "Secondary School District Position",
        "Unified School District Position",
        "State Board of Education District",
      ];

      $scope.judiciallevelOfGovt = ["Judicial District"];
      $scope.locallevelOfGovt = ["Place Name", "County SubDivision Name"];
      $scope.offices = [];
      $scope.running_offices = [];
      $scope.carriers = [
        {
          name: "AT&T",
          domain: "txt.att.net",
        },
        {
          name: "T-Mobile",
          domain: "tmomail.net",
        },
        {
          name: "Verizon",
          domain: "vtext.com",
        },
        {
          name: "Sprint",
          domain: "messaging.sprintpcs.com",
        },
        {
          name: "Virgin Mobile",
          domain: "vmobl.com",
        },
        {
          name: "Tracfone",
          domain: "mmst5.tracfone.com",
        },
        {
          name: "Metro PCS",
          domain: "mymetropcs.com",
        },
        {
          name: "Boost Mobile",
          domain: "myboostmobile.com",
        },
        {
          name: "Cricket",
          domain: "sms.mycricket.com",
        },
        {
          name: "Ptel",
          domain: "ptel.com",
        },
        {
          name: "Republic Wireless",
          domain: "text.republicwireless.com",
        },
        {
          name: "Suncom",
          domain: "tms.suncom.com",
        },
        {
          name: "Ting",
          domain: "message.ting.com",
        },
        {
          name: "U.S. Cellular",
          domain: "email.uscc.net",
        },
        {
          name: "Consumer Cellular",
          domain: "cingularme.com",
        },
        {
          name: "C-Spire",
          domain: "cspire1.com",
        },
        {
          name: "Page Plus",
          domain: "vtext.com",
        },
      ];

      $scope.countyone = false;
      $scope.cityone = false;
      $scope.showLoaderOne = false;
      $scope.running_countyone = false;
      $scope.running_cityone = false;
      $scope.running_showLoaderOne = false;
      $scope.runAddress = {
        state: "",
        county: "",
        countySubdivision: "",
        place: "",
      };
      $scope.govLevelChanged = function (electionFor) {
        $scope.running_flagShowStateDropdown = false;
        $scope.running_flagShowOfficeDropdown = false;
        $scope.flagShowStateDropdown = false;
        $scope.flagShowOfficeDropdown = false;
        //MyService.ConsoleLog("* govLevelChanged *");
        if (electionFor == "running") {
          $scope.User.office_name = null;
          $scope.running_flagShowStateDropdown = true;
          //$scope.onStateChange('running');
          // $scope.running_stateSenate = false;
          // $scope.running_stateHouse = false;
          // $scope.running_federalCong = false;
          $scope.running_countyone = false;
          $scope.running_cityone = false;
          // $scope.running_school = false;
          $scope.running_showLoader = false;
          // $scope.runFederalCongrassionalDist = "";
          // $scope.runUnifiedSchoolDistrictNames = "";
          // $scope.runStateHouseOFRepresentativeDistricts = "";
          // $scope.runStateSenateDistrict = "";
          $scope.runPlaces = "";
          $scope.runCounties = "";
          $scope.User.state = "";
          // $scope.runAddress.stateSenateDistrict = "";
          // $scope.runAddress.federalCongrassionalDist = "";
          // $scope.runAddress.stateHouseOFRepresentativeDistrict = "";
          // $scope.runAddress.unifiedSchoolDistrictName = "";
        } else {
          $scope.User.cur_state = null;
          $scope.User.cur_office_name = null;
          $scope.flagShowStateDropdown = true;
          MyService.ConsoleLog("new sir", $scope.User.cur_level);
          // $scope.dis = false;
          // $scope.stateSenate = false;
          // $scope.stateHouse = false;
          // $scope.federalCong = false;
          $scope.countyone = false;
          $scope.cityone = false;
          // $scope.school = false;
          // $scope.federalCongrassionalDist = "";
          // $scope.unifiedSchoolDistrictNames = "";
          // $scope.stateHouseOFRepresentativeDistricts = "";
          // $scope.stateSenateDistrict = "";
          $scope.allsubcounty = "";
          $scope.places = "";
          $scope.counties = "";
          // $scope.User.cur_state = "";
          // $scope.address.stateSenateDistrict = "";
          // $scope.address.federalCongrassionalDist = "";
          // $scope.address.stateHouseOFRepresentativeDistrict = "";
          if (
            $scope.User.cur_level == "Federal" ||
            $scope.User.cur_level == "Other"
          ) {
            var nObj = new Object();
            nObj.level = $scope.User.cur_level;
            nObj.office = $scope.User.cur_off_name;
            nObj.state = JSON.stringify($scope.User.cur_state);
            MyService.getPoliticians(nObj).then(
              function (payload) {
                // MyService.ConsoleLog("payload<><><><><>", payload);
                // console.log(payload);
                $scope.candidates = payload;
                $scope.showLoader = false;
                //MyService.ConsoleLog($scope.running_flagShowCandidateDropdown);
                $scope.candidates.push({
                  name: "Other",
                });

                fuzzySearch = new Fuse($scope.candidates, {
                  shouldSort: true,
                  keys: ["name"],
                  caseSensitive: false,
                  threshold: 0.4,
                });
              },
              function (errPayload) {
                $scope.showLoader = false;
                //MyService.ConsoleLog("Error");
                //MyService.ConsoleLog(errPayload);
                alert(errPayload);
              }
            );
            $scope.flagShowCandidateDropdown = true;
          }
          //$scope.onStateChange('incumbent');
        }
      };

      $scope.localSchoolDistException = function (electionFor) {
        var exceptionState = ["AK", "DC", "VA"];
        if ((electionFor = "running")) {
          if (
            $scope.User.state &&
            exceptionState.indexOf($scope.User.state.statePostalCode) == -1
          ) {
            return true;
          } else return false;
        } else if (electionFor == "incumbent") {
          if (
            $scope.User.cur_state &&
            exceptionState.indexOf($scope.User.cur_state.statePostalCode) == -1
          ) {
            return true;
          } else return false;
        }
      };

      $scope.showOfficeAutoComplete = function (electionFor) {
        //MyService.ConsoleLog("showOfficeAutoComplete");
        // ['national', 'state', 'judicial district', 'county', 'sub county', 'city', 'state school board district', 'local', 'school district', 'other']
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "national":
              $scope.running_offices = [
                "president",
                "senate",
                "house of representatives",
                "other",
              ];
              return true;
              break;
            case "state":
              if ($scope.User.state) {
                //fetch office names for this
                //For the options, do a search through the table currently labelled “2016 Alabama” and Find all Item A’s where the Item D is State Postal Code, and item Q is the state selected.  Then add “other” to the end of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "judicial district":
              if ($scope.User.state && $scope.User.district) {
                //fetch office names for this
                //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item F is the district selected. Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "county":
              if ($scope.User.state && $scope.User.county) {
                //fetch office names for this
                //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected.  Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "sub county":
              if (
                $scope.User.state &&
                $scope.User.county &&
                $scope.User.subcounty
              ) {
                //fetch office names for this
                // For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item U is the subcounty selected. Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "city":
              if (
                $scope.User.state &&
                $scope.User.county &&
                $scope.User.locality
              ) {
                //fetch office names for this
                // For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected and U or W match the “city” selection.  Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "state school board district":
              if ($scope.User.state && $scope.User.state_school_dist) {
                //fetch office names for this
                // do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item E is the “District” selection.  Then add “other” to the bottom of the list.
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "local school district":
              if (
                $scope.User.state &&
                $scope.localSchoolDistException() &&
                $scope.User.county &&
                $scope.User.district
              ) {
                //for office names
                // search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the “County” selection and either AD’s, AF’s or  AH’s match the District Name selected.  Then add “other” to the bottom of the list.
                // $scope.offices=['other'];
                return true;
              } else if ($scope.User.state && $scope.User.district) {
                //for options
                //do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item AD’s match the District Name selected.  Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
          }
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "national":
              $scope.offices = [
                "president",
                "senate",
                "house of representatives",
                "other",
              ];
              return true;
              break;
            case "state":
              if ($scope.User.cur_state) {
                //fetch office names for this
                //For the options, do a search through the table currently labelled “2016 Alabama” and Find all Item A’s where the Item D is State Postal Code, and item Q is the state selected.  Then add “other” to the end of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "judicial district":
              if ($scope.User.cur_state && $scope.User.cur_district) {
                //fetch office names for this
                //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item F is the district selected. Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "county":
              if ($scope.User.cur_state && $scope.User.cur_county) {
                //fetch office names for this
                //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected.  Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "sub county":
              if (
                $scope.User.cur_state &&
                $scope.User.cur_county &&
                $scope.User.cur_subcounty
              ) {
                //fetch office names for this
                // For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item U is the subcounty selected. Then add “other” to the bottom of the list
                // $scope.offices=['other'];onOfficeChange
                return true;
              }
              break;
            case "city":
              if (
                $scope.User.cur_state &&
                $scope.User.cur_county &&
                $scope.User.cur_locality
              ) {
                //fetch office names for this
                // For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected and U or W match the “city” selection.  Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "state school board district":
              if ($scope.User.cur_state && $scope.User.cur_state_school_dist) {
                //fetch office names for this
                // do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item E is the “District” selection.  Then add “other” to the bottom of the list.
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "local school district":
              if (
                $scope.User.cur_state &&
                $scope.localSchoolDistException() &&
                $scope.User.cur_county &&
                $scope.User.cur_district
              ) {
                //for office names
                // search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the “County” selection and either AD’s, AF’s or  AH’s match the District Name selected.  Then add “other” to the bottom of the list.
                // $scope.offices=['other'];
                return true;
              } else if ($scope.User.cur_state && $scope.User.cur_district) {
                //for options
                //do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item AD’s match the District Name selected.  Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
          }
          return false;
        }
      };
      var running_flagShowStateDropdown = false;
      var flagShowStateDropdown = false;
      $scope.showSateDropdown = function (electionFor) {
        //MyService.ConsoleLog("showSateDropdown");
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "state":
            case "judicial district":
            case "county":
            case "sub county":
            case "city":
            case "state school board district":
            case "local school district":
              running_flagShowStateDropdown = true;
              return true;
              break;
          }

          switch ($scope.User.office_name) {
            case "senate":
            case "house of representatives":
              running_flagShowStateDropdown = true;
              return true;
              break;
          }

          running_flagShowStateDropdown = false;
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "state":
            case "judicial district":
            case "county":
            case "sub county":
            case "city":
            case "state school board district":
            case "local school district":
              flagShowStateDropdown = true;
              return true;
              break;
          }

          switch ($scope.User.cur_office_name) {
            case "senate":
            case "house of representatives":
              flagShowStateDropdown = true;
              return true;
              break;
          }

          flagShowStateDropdown = false;
          return false;
        }
      };

      $scope.flagShowCandidateDropdown = false;
      $scope.running_flagShowCandidateDropdown = false;

      var fuzzySearch = "";
      $scope.showLoader = false;

      $scope.onOfficeChange = function (electionFor) {
        $scope.showLoader = true;
        if (electionFor == "running") {
          //'Federal', 'State', 'Local'
          var nObj = new Object();
          nObj.level = $scope.User.level;
          nObj.office = $scope.User.off_name;
          nObj.state = JSON.stringify($scope.User.state);
          $scope.running_flagShowCandidateDropdown = true;
          switch ($scope.User.level) {
            // case "Other":
            //   $scope.getRunningCounties();
            //   break;
            case "County":
              $scope.getRunningCounties();
              break;
            // case 'State':
            //   $scope.getRunningStateHouse();
            //   break;
            // case 'Federal':
            //   $scope.getRunningFederal();
            //   break;
            case "Local":
              $scope.getRunningCounties();
              break;

            default:
              MyService.ConsoleLog("default");
              break;
          }
        } else if (electionFor == "incumbent") {
          var nObj = new Object();
          nObj.level = $scope.User.cur_level;
          nObj.office = $scope.User.cur_off_name;
          nObj.state = JSON.stringify($scope.User.cur_state);
          // $scope.flagShowCandidateDropdown = true;

          $scope.flagShowCandidateDropdown = true;

          switch ($scope.User.cur_level) {
            // case "Other":
            //   $scope.getCounties();
            //   break;
            case "County":
              $scope.getCounties();
              break;
            // case 'State':
            //   $scope.getStateHouse();
            //   break;
            // case 'Federal':
            //   $scope.getFederal();
            //   break;
            case "Local":
              $scope.getCounties();
              break;

            default:
              MyService.ConsoleLog("default");
              break;
          }
        }
        //MyService.ConsoleLog("nObj<><><><", nObj);
        MyService.getPoliticians(nObj).then(
          function (payload) {
            // MyService.ConsoleLog("payload<><><><><>", payload);
            // console.log(payload);
            $scope.candidates = payload;
            $scope.showLoader = false;
            //MyService.ConsoleLog($scope.running_flagShowCandidateDropdown);
            $scope.candidates.push({
              name: "Other",
            });

            fuzzySearch = new Fuse($scope.candidates, {
              shouldSort: true,
              keys: ["name"],
              caseSensitive: false,
              threshold: 0.4,
            });
          },
          function (errPayload) {
            $scope.showLoader = false;
            //MyService.ConsoleLog("Error");
            //MyService.ConsoleLog(errPayload);
            alert(errPayload);
          }
        );
      };

      // autocomplete

      var options = {
        componentRestrictions: {
          country: "us",
        },
        types: ["geocode"],
      };

      $scope.detectAddress = function (ent) {
        var val = document.getElementById("address");
        // console.log($scope.User.Address);
        var autocomplete = new google.maps.places.Autocomplete(val, options);

        google.maps.event.addListener(
          autocomplete,
          "place_changed",
          function () {
            var place = autocomplete.getPlace();
            // console.log('hello');
            // console.log("place", place);

            var lat = place.geometry.location.lat(),
              lng = place.geometry.location.lng();

            $scope.lati = lat.toFixed(6);
            $scope.lon = lng.toFixed(6);
            // console.log($scope.lati);
            // console.log($scope.lon);

            $scope.mailing_Address = place.formatted_address;
            console.log("formated address", $scope.mailing_Address);
            for (var i = 0; i < place.address_components.length; i++) {
              for (
                var j = 0;
                j < place.address_components[i].types.length;
                j++
              ) {
                if (
                  place.address_components[i].types[j] ==
                  "administrative_area_level_1"
                ) {
                  $scope.statePostalCode =
                    place.address_components[i].short_name;
                  // console.log($scope.statePostalCode);
                }
                if (place.address_components[i].types[j] == "country") {
                  $scope.countryname = place.address_components[i].long_name;
                  // console.log($scope.countryname);
                }
                if (
                  place.address_components[i].types[j] ==
                  "administrative_area_level_2"
                ) {
                  $scope.county_name = place.address_components[i].long_name;
                  // console.log($scope.county_name);
                }
                if (place.address_components[i].types[j] == "locality") {
                  $scope.place_name = place.address_components[i].long_name;
                  // console.log($scope.place_name);
                }
                if (place.address_components[i].types[j] == "postal_code") {
                  document.getElementById("zip").value =
                    place.address_components[i].long_name;
                  $scope.User.ZipCode = place.address_components[i].long_name;
                  // console.log($scope.User.ZipCode);

                  // console.log($scope.User.ZipCode);
                }
              }
            }

            $scope.locs = JSON.stringify({
              longitude: $scope.lon,
              latitude: $scope.lati,
            });
            // console.log(loc);
            // $rootScope.location = new Array;
            $rootScope.location = {
              longitude: $scope.lon,
              latitude: $scope.lati,
            };
            $scope.showAddressDropDowns("", $scope.locs);
          }
        );
      };

      $scope.checkReadOnly = false;
      $scope.HideRegisterButton = false;
      $scope.onCandidateChange = function (val) {
        //$scope.User.Candidates;
        $scope.checkReadOnly = false;
        $scope.shortEmail = "";
        // alert("onCandidateChange");
        //MyService.ConsoleLog($scope.User.Candidates);
        //MyService.ConsoleLog($scope.User.NCandidates);
        if (val == "incumbent" && $scope.User.Candidates) {
          if (
            $scope.User.Candidates.name &&
            $scope.User.Candidates.name != null
          ) {
            if ($scope.User.Candidates.name != "Other") {
              $scope.User.name = $scope.User.Candidates.name;
              if (
                $scope.User.Candidates.PublicPhoneNumber &&
                $scope.User.Candidates.PublicPhoneNumber != null
              ) {
                $scope.User.phone_no = $scope.User.Candidates.PublicPhoneNumber;
              } else {
                $scope.User.phone_no = "";
              }
              if (
                $scope.User.Candidates.website &&
                $scope.User.Candidates.website != null
              ) {
                $scope.User.web_url = $scope.User.Candidates.website;
              } else {
                $scope.User.web_url = "";
              }
              if (
                $scope.User.Candidates.public_zipcode &&
                $scope.User.Candidates.public_zipcode != null
              ) {
                $scope.User.ZipCode = $scope.User.Candidates.public_zipcode;
              } else {
                $scope.User.ZipCode = "";
              }
              if (
                $scope.User.Candidates.public_mailing_address &&
                $scope.User.Candidates.public_mailing_address != null
              ) {
                // $scope.User.mailing_address = $scope.User.Candidates.public_mailing_address;
              } else {
                // $scope.User.mailing_address = '';
              }

              if (
                $scope.User.Candidates.email &&
                $scope.User.Candidates.email != null &&
                $scope.User.Candidates.email != 0
              ) {
                $scope.HideRegisterButton = true;
                var email = $scope.User.Candidates.email
                  ? $scope.User.Candidates.email
                  : $scope.User.Candidates.privateEmail;
                // $scope.User.Email = email;
                var cemail = email;
                var firstSix = cemail.substr(0, 6);
                var lastSix = cemail.substr(cemail.length - 6);
                var xlen = cemail.length - 12;
                var xstring = "x".repeat(xlen);
                var finalstring = firstSix + xstring + lastSix;
                $scope.shortEmail = finalstring;
                /*
              var cemail = $scope.User.Candidates.email;
              var firstSix = cemail.substr(0, 6);
              var lastSix = cemail.substr(cemail.length - 6);
              var xlen = cemail.length - 12;
              var xstring = "x".repeat(xlen);
              var finalstring = firstSix + xstring + lastSix;
              $scope.HideRegisterButton = true;
              var msg = "You are already in our system with the email " + finalstring;
              MyService.GetDialogWithButtons(ngDialog, msg, "SignIn", "Please email me my password").then(function(payload) {
                //MyService.ConsoleLog("Ans<><><>", payload);
                $scope.User.Email = $scope.User.Candidates.email;
                $scope.checkReadOnly = true;
                if (payload == 1) {
                  $location.path("/signin");
                } else {
                  var postobj = {
                    email: $scope.User.Candidates.email,
                    reset_url: $rootScope.getPasswordResetUrl()
                  };
                  //MyService.ConsoleLog("postobj: ", postobj);

                  MyService.forgotPassword(postobj)
                  .then(function(response) {
                    if (response.data.success) {
                      growl.success("An email has been sent.");
                    } else {
                      if (typeof response.data.error == "string")
                      growl.error(response.data.error);
                      else
                      growl.error("Something went wrong");
                    }
                  }, function(err) {
                    growl.error("Something went wrong");
                  });
                }
              }, function(errorPayload) {
                $scope.User.Email = "";
                //MyService.ConsoleLog("errorPayload<><><>", errorPayload);
                $scope.checkReadOnly = false;
                if (errorPayload == 0) {
                  var postobj = {
                    email: $scope.User.Candidates.email,
                    reset_url: $rootScope.getPasswordResetUrl()
                  };
                  //MyService.ConsoleLog("postobj: ", postobj);

                  MyService.forgotPassword(postobj)
                  .then(function(response) {
                    if (response.data.success) {
                      growl.success("An email has been sent.");
                    } else {
                      if (typeof response.data.error == "string")
                      growl.error(response.data.error);
                      else
                      growl.error("Something went wrong");
                    }
                  }, function(err) {
                    growl.error("Something went wrong");
                  });
                }
              });
              */
              } else {
                $scope.User.Email = "";
                $scope.User.phone_no = "";
                $scope.User.web_url = "";
                $scope.User.ZipCode = "";
                // $scope.User.mailing_address = '';
              }
            } else {
              //If candidate is Other
              //MyService.ConsoleLog("Other selected");
            }
          } else {
            $scope.User.name = "";
            $scope.User.phone_no = "";
            $scope.User.web_url = "";
            $scope.User.ZipCode = "";
            // $scope.User.mailing_address = '';
          }
        } else {
          //MyService.ConsoleLog("Else 1", $scope.User.NCandidates);
          if ($scope.User.NCandidates) {
            if (
              $scope.User.NCandidates.name &&
              $scope.User.NCandidates.name != null
            ) {
              if ($scope.User.NCandidates.name != "Other") {
                $scope.User.name = $scope.User.NCandidates.name;
                //MyService.ConsoleLog("Other than <><><><<", $scope.User.NCandidates.name);
                if (
                  $scope.User.NCandidates.PublicPhoneNumber &&
                  $scope.User.NCandidates.PublicPhoneNumber != null
                ) {
                  $scope.User.phone_no =
                    $scope.User.NCandidates.PublicPhoneNumber;
                } else {
                  $scope.User.phone_no = "";
                }
                if (
                  $scope.User.NCandidates.website &&
                  $scope.User.NCandidates.website != null
                ) {
                  $scope.User.web_url = $scope.User.NCandidates.website;
                } else {
                  $scope.User.web_url = "";
                }
                if (
                  $scope.User.NCandidates.public_zipcode &&
                  $scope.User.NCandidates.public_zipcode != null
                ) {
                  $scope.User.ZipCode = $scope.User.NCandidates.public_zipcode;
                } else {
                  $scope.User.ZipCode = "";
                }
                if (
                  $scope.User.NCandidates.public_mailing_address &&
                  $scope.User.NCandidates.public_mailing_address != null
                ) {
                  // $scope.User.NCandidates = $scope.User.NCandidates.public_mailing_address;
                } else {
                  // $scope.User.mailing_address = '';
                }
                //MyService.ConsoleLog("NCandidates<><><>", $scope.User.NCandidates);

                if (
                  ($scope.User.NCandidates.email &&
                    $scope.User.NCandidates.email != null &&
                    $scope.User.NCandidates.email != 0) ||
                  ($scope.User.NCandidates.privateEmail &&
                    $scope.User.NCandidates.privateEmail != null &&
                    $scope.User.NCandidates.privateEmail != 0)
                ) {
                  $scope.HideNewRegisterButton = true;
                  var email = $scope.User.NCandidates.email
                    ? $scope.User.NCandidates.email
                    : $scope.User.NCandidates.privateEmail;
                  // $scope.User.Email = email;
                  var cemail = email;
                  var firstSix = cemail.substr(0, 6);
                  var lastSix = cemail.substr(cemail.length - 6);
                  var xlen = cemail.length - 12;
                  var xstring = "x".repeat(xlen);
                  var finalstring = firstSix + xstring + lastSix;
                  $scope.shortEmail = finalstring;
                  /*
                var cemail = $scope.User.NCandidates.email;
                var firstSix = cemail.substr(0, 6);
                var lastSix = cemail.substr(cemail.length - 6);
                var xlen = cemail.length - 12;
                var xstring = "x".repeat(xlen);
                var finalstring = firstSix + xstring + lastSix;
                var msg = "You are already in our system with the email " + finalstring;
                MyService.GetDialogWithButtons(ngDialog, msg, "SignIn", "Please email me my password").then(function(payload) {
                  //MyService.ConsoleLog("Ans<><><>", payload);
                  $scope.User.Email = $scope.User.NCandidates.email;
                  $scope.checkReadOnly = true;
                  if (payload == 1) {
                    $location.path("/signin");
                  } else {
                    var postobj = {
                      email: $scope.User.NCandidates.email,
                      reset_url: $rootScope.getPasswordResetUrl()
                    };
                    //MyService.ConsoleLog("postobj: ", postobj);

                    MyService.forgotPassword(postobj)
                    .then(function(response) {
                      if (response.data.success) {
                        growl.success("An email has been sent.");
                      } else {
                        if (typeof response.data.error == "string")
                        growl.error(response.data.error);
                        else
                        growl.error("Something went wrong");
                      }
                    }, function(err) {
                      growl.error("Something went wrong");
                    });
                  }
                }, function(errorPayload) {
                  $scope.User.Email = "";
                  //MyService.ConsoleLog("errorPayload<><><>", errorPayload);
                  $scope.checkReadOnly = false;
                  if (errorPayload == 0) {
                    var postobj = {
                      email: $scope.User.NCandidates.email,
                      reset_url: $rootScope.getPasswordResetUrl()
                    };
                    //MyService.ConsoleLog("postobj: ", postobj);

                    MyService.forgotPassword(postobj)
                    .then(function(response) {
                      if (response.data.success) {
                        growl.success("An email has been sent.");
                      } else {
                        if (typeof response.data.error == "string")
                        growl.error(response.data.error);
                        else
                        growl.error("Something went wrong");
                      }
                    }, function(err) {
                      growl.error("Something went wrong");
                    });
                  }
                });
                */
                } else {
                  $scope.User.Email = "";
                  $scope.User.phone_no = "";
                  $scope.User.web_url = "";
                  $scope.User.ZipCode = "";
                  $scope.User.mailing_address = "";
                }
              } else {
                //If candidate is Other
                //MyService.ConsoleLog("Other selected");
              }
            } else {
              $scope.User.name = "";
              $scope.User.phone_no = "";
              $scope.User.web_url = "";
              $scope.User.ZipCode = "";
              $scope.User.mailing_address = "";
            }
          }
        }
      };

      $scope.sendPostCard = false;
      $scope.PostcardSend = false;
      $scope.generatePostcard = function () {
        var postCard = Math.random().toString(36).substr(2, 10);

        MyService.checkPostCard({
          postcard: postCard,
        }).then(
          function (payload) {
            //MyService.ConsoleLog("Payload<><><<>",payload);
            var alldata = payload.data;
            //MyService.ConsoleLog("alldata<><><>", alldata);
            var taken = alldata.taken;
            //MyService.ConsoleLog("taken<><><>", taken);
            $scope.PostcardSend = true;
            if (!taken) {
              //MyService.ConsoleLog(taken);
              $scope.User.postCard = postCard.toUpperCase();
            } else {
              //MyService.ConsoleLog(taken);
              //$scope.generatePostcard();
            }
          },
          function (errorPayload) {
            $scope.User.postCard = postCard.toUpperCase();
            //MyService.ConsoleLog("errorPayload<><><<>",errorPayload);
          }
        );
      };

      $scope.submitPostcard = function (data) {
        //MyService.ConsoleLog("confirmPostalCode<><><>", $scope.User.confirmPostalCode);
        if ($scope.User.postCard == $scope.User.confirmPostalCode) {
          $scope.verifiedUser = "true";
          //MyService.ConsoleLog($scope.verifiedUser);
          var message = "Thank you for confirming your account.";
          var modal = ngDialog.openConfirm({
            template:
              "<p>" +
              message +
              '</p>\
              <div class="ngdialog-buttons">\
              <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
              </div>',
            plain: true,
          });
          modal.then(
            function fullfilled(data) {
              //MyService.ConsoleLog("fullfilled: ",data);
            },
            function rejected(data) {
              //MyService.ConsoleLog("rejected: ",data);
            }
          );
        } else {
          $scope.verifiedUser = "false";
          var message =
            "Your postcard code doesn't match with ours. Please try again.";
          var modal = ngDialog.openConfirm({
            template:
              "<p>" +
              message +
              '</p>\
              <div class="ngdialog-buttons">\
              <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
              </div>',
            plain: true,
          });
          modal.then(
            function fullfilled(data) {
              //MyService.ConsoleLog("fullfilled: ",data);
            },
            function rejected(data) {
              //MyService.ConsoleLog("rejected: ",data);
            }
          );
        }
      };

      $scope.showcur_office_name = false;
      $scope.showcur_office_location = false;
      $scope.checkExists = function () {
        MyService.ConsoleLog("welcome to checkExists");

        if ($scope.User.cur_Candidates != "" && !$scope.User.name_on_ballot) {
          MyService.ConsoleLog("inside");
          $scope.User.name_on_ballot = $scope.User.cur_Candidates;
          $scope.showcur_office_name = true;
          $scope.showcur_office_location = true;
        }
      };

      $scope.closeEdit = function (col) {
        // alert("here");
        // MyService.ConsoleLog("%$$$:",col);
        var nval = JSON.parse(col.value);
        // MyService.ConsoleLog("value for auto :",nval);
        $scope.User.Candidates = nval;
        $scope.User.cur_Candidates = nval.name;
        $scope.User.cur_office_name = nval.office;
        $scope.User.cur_office_email = nval.publicEmail;
        $scope.User.postCard = nval.postCard;
        $scope.User.cur_office_phone = nval.publicPhoneNumber;
        $scope.User.cur_office_website = nval.website;
        if ($scope.User.cur_office_name != "") {
          $scope.showcur_office_name = true;
        }
        $scope.User.cur_office_location = nval.officePlace;
        if ($scope.User.cur_office_location != "") {
          $scope.showcur_office_location = true;
        }
        $scope.User.from_date = nval.fromDate;
        $scope.User.end_date = nval.endDate;
        $scope.User.Email = nval.email ? nval.email : nval.privateEmail;
        $scope.User.name_on_ballot = nval.name;

        if (!$scope.User.Email) {
          //alert("here");
          $scope.sendPostCard = true;
        }

        //MyService.ConsoleLog("Email:::", $scope.User.Email);
        // var result = document.getElementsByClassName("ac-container");
        //MyService.ConsoleLog(result);
        // result[0].blur();
        document
          .getElementById("curCandidate")
          .getElementsByTagName("input")[0]
          .blur();
        $scope.onCandidateChange("incumbent");
        //var nval = col.value? col.value: col.displayName
      };

      function suggest_name(term) {
        var q = term.toLowerCase().trim();
        var results = [];
        var len = $scope.candidates.length;
        // Find first 10 states that start with `term`.
        for (var i = 0; i < len && results.length < 10; i++) {
          var name = $scope.candidates[i].name;
          var matched = name.match(new RegExp(q, "i"));
          //MyService.ConsoleLog(state.match())
          //MyService.ConsoleLog(matched);
          //MyService.ConsoleLog(state.match(q, "i"));
          if (matched) {
            results.push({
              label: $sce.trustAsHtml(name),
              value: JSON.stringify($scope.candidates[i]),
            });
          }
        }
        return results;
      }

      function highlight(str, term) {
        MyService.ConsoleLog("str<><><><", str);
        var highlight_regex = new RegExp("(" + term + ")", "gi");
        return str.replace(
          highlight_regex,
          '<span class="highlight">$1</span>'
        );
      }

      function fuzzy_suggest(term) {
        if (!term) return [];
        MyService.ConsoleLog(fuzzySearch);
        return fuzzySearch
          .search(term)
          .slice(0, 10)
          .map(function (i) {
            //MyService.ConsoleLog("I",i);
            //MyService.ConsoleLog($scope.candidates);
            //MyService.ConsoleLog(i);
            var val = i.name;
            MyService.ConsoleLog("val:::", val);
            return {
              value: JSON.stringify(i),
              label: $sce.trustAsHtml(highlight(val + "-" + i.office, term)),
            };
          });
      }

      $scope.autocomplete_options = {
        suggest: fuzzy_suggest,
        on_select: $scope.closeEdit,
      };

      $scope.running_flagShowCandidateDropdown = false;
      $scope.closeEditNew = function (col) {
        // alert("here");
        // MyService.ConsoleLog("got poly data :",col);
        var nval = JSON.parse(col.value);
        MyService.ConsoleLog("got poly data :", nval);
        $scope.User.NCandidates = nval;
        $scope.User.new_Candidates = nval.name;
        $scope.User.office_name = nval.office;
        $scope.User.office_email = nval.email;
        $scope.User.office_phone = nval.publicPhoneNumber;
        $scope.User.office_website = nval.website;
        if ($scope.User.cur_office_name != "") {
          $scope.showcur_office_name = true;
        }
        $scope.User.office_location = nval.officePlace;

        if ($scope.User.cur_office_location != "") {
          $scope.showcur_office_location = true;
        }

        $scope.User.from_date = nval.fromDate;
        $scope.User.end_date = nval.endDate;
        // alert('got');
        $scope.multiArr = $scope.candidates.filter(function (item) {
          // MyService.ConsoleLog("item", item.email);
          if (item.email == nval.email) {
            return item;
          }
        });

        $scope.User.Email = nval.email ? nval.email : nval.privateEmail;
        $scope.User.name_on_ballot = nval.name;
        MyService.ConsoleLog(" $scope.multiArr", $scope.multiArr);
        if ($scope.multiArr.length > 1) {
          $scope.showMultiDrop = true;
        } else {
          $scope.showMultiDrop = false;
        }
        // alert($scope.User.Email);
        if (!$scope.User.Email) {
          //alert("here=", $scope.User.Email);
          $scope.sendPostCardNew = true;
        }

        //MyService.ConsoleLog("Email:::", $scope.User.Email);
        // var result = document.getElementsByClassName("ac-container");
        //MyService.ConsoleLog(result);
        // result[0].blur();

        document
          .getElementById("curCandidate")
          .getElementsByTagName("input")[0]
          .blur();
        $scope.onCandidateChange("running");
        //var nval = col.value? col.value: col.displayName
      };

      $scope.HideNewRegisterButton = false;
      $scope.shownew_office_name = false;
      $scope.checkExistsNew = function () {
        //MyService.ConsoleLog($scope.User.new_Candidates);
        MyService.ConsoleLog(
          "name_on_ballot<><><><>",
          $scope.User.name_on_ballot
        );
        if (
          $scope.User.new_Candidates != "" &&
          $scope.User.new_Candidates != $scope.User.name_on_ballot
        ) {
          //MyService.ConsoleLog("inside");
          $scope.User.name_on_ballot = $scope.User.new_Candidates;
        }

        if (!$scope.User.NCandidates) {
          //alert("NCandidates");
          $scope.shownew_office_name = true;
        }
      };

      function fuzzy_suggest_new(term) {
        if (!term) return [];
        //MyService.ConsoleLog(fuzzySearch);
        return fuzzySearch
          .search(term)
          .slice(0, 10)
          .map(function (i) {
            //MyService.ConsoleLog("I",i);
            //MyService.ConsoleLog($scope.candidates);
            //MyService.ConsoleLog(i);
            var val = i.name;
            //MyService.ConsoleLog("val:::", val);
            return {
              value: JSON.stringify(i),
              label: $sce.trustAsHtml(highlight(val + "-" + i.office, term)),
            };
          });
      }

      $scope.autocomplete_new_options = {
        suggest: fuzzy_suggest_new,
        on_select: $scope.closeEditNew,
      };
      $scope.allPoliticians = [];

      function suggest_politician_name(term) {
        var results = [];
        for (var i = 0; i < $scope.allPoliticians.length; i++) {
          results.push({
            label: $sce.trustAsHtml(
              $scope.allPoliticians[i].name +
                "-" +
                $scope.allPoliticians[i].office
            ),
            value: JSON.stringify($scope.allPoliticians[i]),
          });
        }
        return results;
      }

      function suggest_politician_name_remote(term) {
        var deferred = $q.defer();
        var params = new Object();
        params.term = term;
        $scope.allPoliticians.length = 0;
        var request = apiCall.apiCall("GET", "/politician/fuzzySearch", params);
        // request.timeout = canceler;
        $http(request).then(
          function successCallback(response) {
            MyService.ConsoleLog("Got Politician: ", response);
            $scope.allPoliticians = response.data.data;
            /*
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
          */
            deferred.resolve(suggest_politician_name(term));
          },
          function errorCallBack(response) {
            deferred.reject(response);
          }
        );
        return deferred.promise;
      }

      $scope.onCandidateChangePolitician = function (val) {
        //$scope.User.Candidates;
        $scope.checkReadOnly = false;

        //MyService.ConsoleLog($scope.User.name_on_ballot);
        if ($scope.User.name_on_ballot) {
          if (
            $scope.User.name_on_ballot.name &&
            $scope.User.name_on_ballot.name != null
          ) {
            if ($scope.User.name_on_ballot.name != "Other") {
              $scope.User.name = $scope.User.name_on_ballot.name;
              if (
                $scope.User.name_on_ballot.PublicPhoneNumber &&
                $scope.User.name_on_ballot.PublicPhoneNumber != null
              ) {
                $scope.User.phone_no =
                  $scope.User.name_on_ballot.PublicPhoneNumber;
              } else {
                $scope.User.phone_no = "";
              }
              if (
                $scope.User.name_on_ballot.website &&
                $scope.User.name_on_ballot.website != null
              ) {
                $scope.User.web_url = $scope.User.name_on_ballot.website;
              } else {
                $scope.User.web_url = "";
              }
              if (
                $scope.User.name_on_ballot.public_zipcode &&
                $scope.User.name_on_ballot.public_zipcode != null
              ) {
                $scope.User.ZipCode = $scope.User.name_on_ballot.public_zipcode;
              } else {
                $scope.User.ZipCode = "";
              }
              if (
                $scope.User.name_on_ballot.public_mailing_address &&
                $scope.User.name_on_ballot.public_mailing_address != null
              ) {
                // $scope.User.mailing_address = $scope.User.name_on_ballot.public_mailing_address;
              } else {
                // $scope.User.mailing_address = '';
              }
              /*
            if ($scope.User.name_on_ballot.email && $scope.User.name_on_ballot.email != null && $scope.User.name_on_ballot.email != 0) {
              var msg = "We already have your email with us.<br> Your Email in our db is : <br> <center>" + $scope.User.name_on_ballot.email + "<center><br> Do you want to use it for registration?"
              MyService.GetDialogWithButtons(ngDialog, msg, "YES", "NO").then(function(payload) {
                $scope.User.Email = $scope.User.name_on_ballot.email;
                $scope.checkReadOnly = true;
              }, function(errorPayload) {
                $scope.User.Email = "";
                $scope.checkReadOnly = false;
              });
            } else {
              $scope.User.Email = "";
              $scope.User.phone_no = "";
              $scope.User.web_url = "";
              $scope.User.ZipCode = "";
              $scope.User.mailing_address = "";
            }
            */
            } else {
              //If candidate is Other
              //MyService.ConsoleLog("Other selected");
            }
          } else {
            $scope.User.name = "";
            $scope.User.phone_no = "";
            $scope.User.web_url = "";
            $scope.User.ZipCode = "";
            // $scope.User.mailing_address = '';
          }
        }
      };
      $scope.politicianSelected = false;
      $scope.selectedPolitician = function (col) {
        // alert("here");
        MyService.ConsoleLog("col", col);
        var nval = JSON.parse(col.value);
        //MyService.ConsoleLog(nval);
        $scope.User.name_on_ballot = nval.name;
        var result = document.getElementsByClassName("ac-container");
        //MyService.ConsoleLog(result);
        result[0].style.display = "none";
        // var wrappedResult = angular.element(result);
        //MyService.ConsoleLog(wrappedResult);
        $scope.politicianSelected = true;
        $scope.onCandidateChangePolitician();
        //var nval = col.value? col.value: col.displayName
      };

      $scope.autocomplete_politician_name = {
        suggest: suggest_politician_name_remote,
        on_select: $scope.selectedPolitician,
      };

      var running_flagCongressional = false;
      var flagCongressional = false;
      $scope.showCongressionalDropdown = function (electionFor) {
        //MyService.ConsoleLog("showCongressionalDropdown");
        if (electionFor == "running") {
          if (
            $scope.User.office_name == "house of representatives" &&
            $scope.User.state
          ) {
            running_flagCongressional = true;
            return true;
          }
          running_flagCongressional = false;
          return false;
        } else if (electionFor == "incumbent") {
          if (
            $scope.User.cur_office_name == "house of representatives" &&
            $scope.User.cur_state
          ) {
            flagCongressional = true;
            return true;
          }
          flagCongressional = false;
          return false;
        }
      };
      var running_flagDist = false;
      var flagDist = false;
      $scope.showDistrictDropdown = function (electionFor) {
        //MyService.ConsoleLog("showDistrictDropdown");
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "judicial district":
              if ($scope.User.state) {
                running_flagDist = true;
                return true;
              }
              // For the District options, do a search through the table currently labelled “2016 Alabama” and Find all Item F’s with item Q as the state selected.
              break;
          }
          running_flagDist = false;
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "judicial district":
              if ($scope.User.cur_state) {
                flagDist = true;
                return true;
              }
              // For the District options, do a search through the table currently labelled “2016 Alabama” and Find all Item F’s with item Q as the state selected.
              break;
          }
          flagDist = false;
          return false;
        }
      };
      var running_flagConty = false;
      var flagConty = false;
      $scope.showCountyDropdown = function (electionFor) {
        //MyService.ConsoleLog("showCountyDropdown");
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "county":
            case "sub county":
            case "city":
              if ($scope.User.state) {
                running_flagConty = true;
                return true;
              }
              break;
            case "local school district":
              var exceptionState = ["AK", "DC", "VA"];
              if (
                $scope.User.state &&
                exceptionState.indexOf($scope.User.state.statePostalCode) == -1
              ) {
                running_flagConty = true;
                return true;
              }
              break;
          }
          running_flagConty = false;
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "county":
            case "sub county":
            case "city":
              if ($scope.User.cur_state) {
                flagConty = true;
                return true;
              }
              break;
            case "local school district":
              var exceptionState = ["AK", "DC", "VA"];
              if (
                $scope.User.cur_state &&
                exceptionState.indexOf($scope.User.cur_state.statePostalCode) ==
                  -1
              ) {
                flagConty = true;
                return true;
              }
              break;
          }
          flagConty = false;
          return false;
        }
      };
      var running_flagSubConty = false;
      var flagSubConty = false;
      $scope.showSubCountyDropdown = function (electionFor) {
        //MyService.ConsoleLog("showSubCountyDropdown");
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "sub county":
              if ($scope.User.state && $scope.User.county) {
                running_flagSubConty = true;
                return true;
              }
              break;
          }
          running_flagSubConty = false;
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "sub county":
              if ($scope.User.cur_state && $scope.User.cur_county) {
                flagSubConty = false;
                return true;
              }
              break;
          }
          flagSubConty = false;
          return false;
        }
      };
      var running_flagLocality = false;
      var flagLocality = false;
      $scope.showLocalityDropdown = function (electionFor) {
        //MyService.ConsoleLog("showLocalityDropdown");
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "city":
              if ($scope.User.state && $scope.User.county) {
                running_flagLocality = true;
                return true;
              }
              // for options, list all unique county subdivision names and place names within the selected county within the selected state
              break;
          }
          running_flagLocality = false;
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "city":
              if ($scope.User.cur_state && $scope.User.cur_county) {
                flagLocality = true;
                return true;
              }
              // for options, list all unique county subdivision names and place names within the selected county within the selected state
              break;
          }
          flagLocality = false;
          return false;
        }
      };
      var running_flagStateSchoolDist = false;
      var flagStateSchoolDist = false;
      $scope.showStateSchoolDistDropdown = function (electionFor) {
        //MyService.ConsoleLog("showStateSchoolDistDropdown");
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "state school board district":
              if ($scope.User.state) {
                running_flagStateSchoolDist = true;
                return true;
              }
              // For the District options,
              //list all item E’s where item Q is the state selected
              break;
          }
          running_flagStateSchoolDist = false;
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "state school board district":
              if ($scope.User.cur_state) {
                flagStateSchoolDist = true;
                return true;
              }
              // For the District options,
              //list all item E’s where item Q is the state selected
              break;
          }
          flagStateSchoolDist = false;
          return false;
        }
      };
      var running_flagLocalSchoolDist = false;
      var flagLocalSchoolDist = false;
      $scope.showLocalSchoolDistDropdown = function (electionFor) {
        //MyService.ConsoleLog("showDistrictDropdown");
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "local school district":
              if ($scope.User.state) {
                if ($scope.User.state && $scope.localSchoolDistException()) {
                  if ($scope.User.state && $scope.User.county) {
                    running_flagLocalSchoolDist = true;
                    return true;
                  }
                  // For the District options,
                  // results of a search through the table currently labelled “2016 Alabama” and find all AD’s, AF’s  and AH’s  where item Q is the state selected and item S is the “County” selection
                } else if ($scope.User.state) {
                  // for District options
                  // do a search through the table currently labelled “2016 Alabama” and find all AD’s where the item Q is the state selected.
                  running_flagLocalSchoolDist = true;
                  return true;
                }
              }
              break;
          }
          running_flagLocalSchoolDist = false;
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "local school district":
              if ($scope.User.cur_state) {
                if (
                  $scope.User.cur_state &&
                  $scope.localSchoolDistException()
                ) {
                  if ($scope.User.cur_state && $scope.User.cur_county) {
                    flagLocalSchoolDist = true;
                    return true;
                  }
                  // For the District options,
                  // results of a search through the table currently labelled “2016 Alabama” and find all AD’s, AF’s  and AH’s  where item Q is the state selected and item S is the “County” selection
                } else if ($scope.User.cur_state) {
                  // for District options
                  // do a search through the table currently labelled “2016 Alabama” and find all AD’s where the item Q is the state selected.
                  flagLocalSchoolDist = true;
                  return true;
                }
              }
              break;
          }
          flagLocalSchoolDist = false;
          return false;
        }
      };

      $scope.congressionalDistricts = [];
      var getAddressOfRunningPoliCanceler = $q.defer();
      $scope.running_flagShowOfficeDropdown = false;
      $scope.flagShowOfficeDropdown = false;
      $scope.showlevelOfGovt = [];
      $scope.onStateChange = function (electionFor) {
        //MyService.ConsoleLog("** onStateChange **", electionFor);
        if (electionFor == "running") {
          //'State and Federal', 'County', 'School', 'Local', 'Judicial'
          switch ($scope.User.level) {
            case "County":
              $scope.showlevelOfGovt = angular.copy($scope.countylevelOfGovt);
              $scope.running_flagShowOfficeDropdown = true;
              break;
            case "State and Federal":
              $scope.showlevelOfGovt = angular.copy($scope.statelevelOfGovt);
              MyService.ConsoleLog(
                " $scope.showlevelof govt :",
                $scope.showlevelOfGovt
              );
              $scope.running_flagShowOfficeDropdown = true;
              break;
            case "School":
              $scope.showlevelOfGovt = angular.copy($scope.schoollevelOfGovt);
              $scope.running_flagShowOfficeDropdown = true;
              break;
            case "Judicial":
              $scope.showlevelOfGovt = angular.copy($scope.judiciallevelOfGovt);
              $scope.running_flagShowOfficeDropdown = true;
              break;
            case "Local":
              $scope.showlevelOfGovt = angular.copy($scope.locallevelOfGovt);
              $scope.running_flagShowOfficeDropdown = true;
              break;
            default:
              $scope.showlevelOfGovt = angular.copy($scope.statelevelOfGovt);
              $scope.running_flagShowOfficeDropdown = false;
              break;
          }
          //MyService.ConsoleLog($scope.User.level);
          /*setTimeout(function() {
          $scope.$apply(function() {
            $scope.showlevelOfGovt = $scope.showlevelOfGovt1;
            //MyService.ConsoleLog($scope.showlevelOfGovt);
            $scope.User.off_name = $scope.showlevelOfGovt[0];
          });
        }, 100);*/
          //$scope.User.off_name = $scope.showlevelOfGovt[0];

          /*
        if ($scope.User.state) {

          switch ($scope.User.level) {
            case 'state':
            if ($scope.User.state) {
              $scope.User.office_name = null;
              //fetch office names for this
              //For the options, do a search through the table currently labelled “2016 Alabama” and Find all Item A’s where the Item D is = "State Postal Code", and item Q is the state selected.  Then add “other” to the end of the list
              $scope.running_offices = [];
              MyService.getAddressOfRunningPoli({
                StatePostalCode: $scope.User.state.statePostalCode,
                voterScope: "State Postal Code",
                return_field: "office",
                timeout: getAddressOfRunningPoliCanceler.promise
              }).then(function(response) {
                if (response.data.success == true) {
                  $timeout(function() {
                    $scope.running_offices = response.data.data;
                    $scope.running_offices.push("other");
                    //MyService.ConsoleLog("--- Got offices data ---: ", $scope.running_offices);
                  });
                } else if (response.data.error && typeof response.data.error == "string") {
                  growl.error('Error: ' + response.data.error);
                } else {
                  growl.error('Something went wrong.');
                }
              });
            }
            break;

            case 'judicial district':
            if ($scope.User.state) {
              $scope.User.office_name = null;
              // For the District options, do a search through the table currently labelled “2016 Alabama” and Find all Item F’s with item Q as the state selected.
              MyService.getAddressOfRunningPoli({
                StatePostalCode: $scope.User.state.statePostalCode,
                return_field: "JudicialCircuitNumber",
                timeout: getAddressOfRunningPoliCanceler.promise
              }).then(function(response) {
                if (response.data.success == true) {
                  $timeout(function() {
                    $scope.running_districts = response.data.data;
                    //MyService.ConsoleLog("--- Got district data ---: ", $scope.running_districts);
                  });
                } else if (response.data.error && typeof response.data.error == "string") {
                  growl.error('Error: ' + response.data.error);
                } else {
                  growl.error('Something went wrong.');
                }
              });
            }
            break;

            case "county":
            case "sub county":
            case "city":
            if ($scope.User.state) {
              $scope.User.office_name = null;
              // For the District options, do a search through the table currently labelled “2016 Alabama” and Find all Item F’s with item Q as the state selected.
              MyService.getAddressOfRunningPoli({
                StatePostalCode: $scope.User.state.statePostalCode,
                return_field: "CountyName",
                timeout: getAddressOfRunningPoliCanceler.promise
              }).then(function(response) {
                if (response.data.success == true) {
                  $timeout(function() {
                    $scope.running_counties = response.data.data;
                    //MyService.ConsoleLog("--- Got counties data ---: ", $scope.running_counties);
                  });
                } else if (response.data.error && typeof response.data.error == "string") {
                  growl.error('Error: ' + response.data.error);
                } else {
                  growl.error('Something went wrong.');
                }
              });
            }
            break;

            case 'state school board district':
            if ($scope.User.state) {
              $scope.User.office_name = null;
              // do a search through the table currently labelled “2016 Alabama” and list all item E’s where item Q is the state selected.
              MyService.getAddressOfRunningPoli({
                StatePostalCode: $scope.User.state.statePostalCode,
                return_field: "StateBoardEducationDistrict",
                timeout: getAddressOfRunningPoliCanceler.promise
              }).then(function(response) {
                if (response.data.success == true) {
                  $timeout(function() {
                    $scope.running_stateSchoolDistricts = response.data.data;
                    //MyService.ConsoleLog("--- Got district data ---: ", running_stateSchoolDistricts);
                  });
                } else if (response.data.error && typeof response.data.error == "string") {
                  growl.error('Error: ' + response.data.error);
                } else {
                  growl.error('Something went wrong.');
                }
              });
            }
            break;

            case 'local school district':
            $scope.User.office_name = null;
            if (!$scope.localSchoolDistException()) {
              // /if($scope.User.cur_state && $scope.localSchoolDistException())
              MyService.getAddressOfRunningPoli({
                StatePostalCode: $scope.User.state.statePostalCode,
                return_field: "CountyName",
                timeout: getAddressOfRunningPoliCanceler.promise
              }).then(function(response) {
                if (response.data.success == true) {
                  $timeout(function() {
                    $scope.running_counties = response.data.data;
                    //MyService.ConsoleLog("--- Got counties data ---: ", $scope.running_counties);
                  });
                } else if (response.data.error && typeof response.data.error == "string") {
                  growl.error('Error: ' + response.data.error);
                } else {
                  growl.error('Something went wrong.');
                }
              });
            } else {
              //for options
              // do a search through the table currently labelled “2016 Alabama” and find all AD’s where the item Q is the state selected.
              MyService.getAddressOfRunningPoli({
                StatePostalCode: $scope.User.state.statePostalCode,
                return_field: "UnifiedSchoolDistrictName",
                timeout: getAddressOfRunningPoliCanceler.promise
              }).then(function(response) {
                if (response.data.success == true) {
                  $timeout(function() {
                    var tempArr = [];
                    angular.forEach(response.data.data, function(val, key) {
                      tempArr.push({
                        label: val,
                        type: "UnifiedSchoolDistrictName"
                      });
                    });
                    $scope.localSchoolDistricts = tempArr;
                    //MyService.ConsoleLog("--- Got localSchoolDistricts data ---: ", $scope.localSchoolDistricts);
                  });
                } else if (response.data.error && typeof response.data.error == "string") {
                  growl.error('Error: ' + response.data.error);
                } else {
                  growl.error('Something went wrong.');
                }
              });
            }
            break;
          }

          if ($scope.User.office_name) {
            if ($scope.User.state) {
              getAddressOfRunningPoliCanceler.resolve();
              MyService.getAddressOfRunningPoli({
                StatePostalCode: $scope.User.state.statePostalCode,
                return_field: "FederalCongressionalDistrict",
                timeout: getAddressOfRunningPoliCanceler.promise
              }).then(function(response) {
                if (response.data.success == true) {
                  $timeout(function() {
                    $scope.running_congressionalDistricts = response.data.data;
                    //MyService.ConsoleLog("--- Got congressionalDistricts data ---");
                  });
                } else if (response.data.error && typeof response.data.error == "string") {
                  growl.error('Error: ' + response.data.error);
                } else {
                  growl.error('Something went wrong.');
                }
              });
            }
          }
        } //state selected
        */
          //$scope.User.off_name = $scope.showlevelOfGovt[0];
        } else if (electionFor == "incumbent") {
          /*
        if ($scope.User.cur_state) {
          switch ($scope.User.cur_level) {
            case 'state':
            if ($scope.User.cur_state) {
              $scope.User.cur_office_name = null;
              //fetch office names for this
              //For the options, do a search through the table currently labelled “2016 Alabama” and Find all Item A’s where the Item D is = "State Postal Code", and item Q is the state selected.  Then add “other” to the end of the list
              $scope.offices = [];
              MyService.getAddressOfRunningPoli({
                StatePostalCode: $scope.User.cur_state.statePostalCode,
                voterScope: "State Postal Code",
                return_field: "office",
                timeout: getAddressOfRunningPoliCanceler.promise
              }).then(function(response) {
                if (response.data.success == true) {
                  $timeout(function() {
                    $scope.offices = response.data.data;
                    $scope.offices.push("other");
                    //MyService.ConsoleLog("--- Got offices data ---: ", $scope.offices);
                  });
                } else if (response.data.error && typeof response.data.error == "string") {
                  growl.error('Error: ' + response.data.error);
                } else {
                  growl.error('Something went wrong.');
                }
              });
            }
            break;

            case 'judicial district':
            if ($scope.User.cur_state) {
              $scope.User.cur_office_name = null;
              // For the District options, do a search through the table currently labelled “2016 Alabama” and Find all Item F’s with item Q as the state selected.
              MyService.getAddressOfRunningPoli({
                StatePostalCode: $scope.User.cur_state.statePostalCode,
                return_field: "JudicialCircuitNumber",
                timeout: getAddressOfRunningPoliCanceler.promise
              }).then(function(response) {
                if (response.data.success == true) {
                  $timeout(function() {
                    $scope.districts = response.data.data;
                    //MyService.ConsoleLog("--- Got district data ---: ", $scope.districts);
                  });
                } else if (response.data.error && typeof response.data.error == "string") {
                  growl.error('Error: ' + response.data.error);
                } else {
                  growl.error('Something went wrong.');
                }
              });
            }
            break;

            case "county":
            case "sub county":
            case "city":
            if ($scope.User.cur_state) {
              $scope.User.cur_office_name = null;
              // For the District options, do a search through the table currently labelled “2016 Alabama” and Find all Item F’s with item Q as the state selected.
              MyService.getAddressOfRunningPoli({
                StatePostalCode: $scope.User.cur_state.statePostalCode,
                return_field: "CountyName",
                timeout: getAddressOfRunningPoliCanceler.promise
              }).then(function(response) {
                if (response.data.success == true) {
                  $timeout(function() {
                    $scope.counties = response.data.data;
                    //MyService.ConsoleLog("--- Got counties data ---: ", $scope.counties);
                  });
                } else if (response.data.error && typeof response.data.error == "string") {
                  growl.error('Error: ' + response.data.error);
                } else {
                  growl.error('Something went wrong.');
                }
              });
            }
            break;

            case 'state school board district':
            if ($scope.User.cur_state) {
              $scope.User.cur_office_name = null;
              // do a search through the table currently labelled “2016 Alabama” and list all item E’s where item Q is the state selected.
              MyService.getAddressOfRunningPoli({
                StatePostalCode: $scope.User.cur_state.statePostalCode,
                return_field: "StateBoardEducationDistrict",
                timeout: getAddressOfRunningPoliCanceler.promise
              }).then(function(response) {
                if (response.data.success == true) {
                  $timeout(function() {
                    $scope.stateSchoolDistricts = response.data.data;
                    //MyService.ConsoleLog("--- Got district data ---: ", $scope.districts);
                  });
                } else if (response.data.error && typeof response.data.error == "string") {
                  growl.error('Error: ' + response.data.error);
                } else {
                  growl.error('Something went wrong.');
                }
              });
            }
            break;

            case 'local school district':
            if ($scope.User.cur_state) {
              $scope.User.cur_office_name = null;
              if (!$scope.localSchoolDistException()) {
                // /if($scope.User.cur_state && $scope.localSchoolDistException())
                MyService.getAddressOfRunningPoli({
                  StatePostalCode: $scope.User.cur_state.statePostalCode,
                  return_field: "CountyName",
                  timeout: getAddressOfRunningPoliCanceler.promise
                }).then(function(response) {
                  if (response.data.success == true) {
                    $timeout(function() {
                      $scope.counties = response.data.data;
                      //MyService.ConsoleLog("--- Got counties data ---: ", $scope.counties);
                    });
                  } else if (response.data.error && typeof response.data.error == "string") {
                    growl.error('Error: ' + response.data.error);
                  } else {
                    growl.error('Something went wrong.');
                  }
                });
              } else {
                //for options
                // do a search through the table currently labelled “2016 Alabama” and find all AD’s where the item Q is the state selected.
                MyService.getAddressOfRunningPoli({
                  StatePostalCode: $scope.User.cur_state.statePostalCode,
                  return_field: "UnifiedSchoolDistrictName",
                  timeout: getAddressOfRunningPoliCanceler.promise
                }).then(function(response) {
                  if (response.data.success == true) {
                    $timeout(function() {
                      var tempArr = [];
                      angular.forEach(response.data.data, function(val, key) {
                        tempArr.push({
                          label: val,
                          type: "UnifiedSchoolDistrictName"
                        });
                      });
                      $scope.localSchoolDistricts = tempArr;
                      //MyService.ConsoleLog("--- Got localSchoolDistricts data ---: ", $scope.localSchoolDistricts);
                    });
                  } else if (response.data.error && typeof response.data.error == "string") {
                    growl.error('Error: ' + response.data.error);
                  } else {
                    growl.error('Something went wrong.');
                  }
                });
              }
            }
            break;
          }

          if ($scope.User.cur_office_name) {
            if ($scope.User.cur_state) {
              getAddressOfRunningPoliCanceler.resolve();
              MyService.getAddressOfRunningPoli({
                StatePostalCode: $scope.User.cur_state.statePostalCode,
                return_field: "FederalCongressionalDistrict",
                timeout: getAddressOfRunningPoliCanceler.promise
              }).then(function(response) {
                if (response.data.success == true) {
                  $timeout(function() {
                    $scope.congressionalDistricts = response.data.data;
                    //MyService.ConsoleLog("--- Got congressionalDistricts data ---");
                  });
                } else if (response.data.error && typeof response.data.error == "string") {
                  growl.error('Error: ' + response.data.error);
                } else {
                  growl.error('Something went wrong.');
                }
              });
            }
          }
        } //state selected
        */
          switch ($scope.User.cur_level) {
            ////'State and Federal', 'County', 'School', 'Local', 'Judicial'
            case "County":
              $scope.showlevelOfGovt = angular.copy($scope.countylevelOfGovt);
              $scope.flagShowOfficeDropdown = true;
              break;
            case "State and Federal":
              $scope.showlevelOfGovt = angular.copy($scope.statelevelOfGovt);
              $scope.flagShowOfficeDropdown = true;
              break;
            case "School":
              $scope.showlevelOfGovt = angular.copy($scope.schoollevelOfGovt);
              $scope.flagShowOfficeDropdown = true;
              break;
            case "Judicial":
              $scope.showlevelOfGovt = angular.copy($scope.judiciallevelOfGovt);
              $scope.flagShowOfficeDropdown = true;
              break;
            case "Local":
              $scope.showlevelOfGovt = angular.copy($scope.locallevelOfGovt);
              $scope.flagShowOfficeDropdown = true;
              break;
            default:
              $scope.showlevelOfGovt = angular.copy($scope.statelevelOfGovt);
              $scope.flagShowOfficeDropdown = true;
              break;
          }
          //MyService.ConsoleLog($scope.showlevelOfGovt);
          //$scope.User.cur_off_name = $scope.showlevelOfGovt[0];
        }
      };
      $scope.onDistrictChange = function (electionFor) {
        //MyService.ConsoleLog("** onDistrictChange **");
        if (electionFor == "running") {
          if ($scope.User.state) {
            switch ($scope.User.level) {
              case "judicial district":
                if ($scope.User.state) {
                  $scope.User.office_name = null;
                  $scope.running_offices = [];
                  //fetch office names for this
                  //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item F is the district selected. Then add “other” to the bottom of the list
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.state.statePostalCode,
                    return_field: "office",
                    JudicialCircuitNumber: $scope.User.district,
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.running_offices = response.data.data;
                        $scope.running_offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.running_offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //state selected
        } else if (electionFor == "incumbent") {
          if ($scope.User.cur_state) {
            //MyService.ConsoleLog("** onDistrictChange **");
            switch ($scope.User.cur_level) {
              case "judicial district":
                if ($scope.User.cur_state) {
                  $scope.User.cur_office_name = null;
                  $scope.offices = [];
                  //fetch office names for this
                  //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item F is the district selected. Then add “other” to the bottom of the list
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.cur_state.statePostalCode,
                    return_field: "office",
                    JudicialCircuitNumber: $scope.User.cur_district,
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.offices = response.data.data;
                        $scope.offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //state selected
        }
      };
      $scope.onCountyChange = function (electionFor) {
        if (electionFor == "running") {
          if ($scope.User.state) {
            //MyService.ConsoleLog("** onCountyChange **");
            switch ($scope.User.level) {
              case "county":
                if ($scope.User.state) {
                  $scope.User.office_name = null;
                  $scope.running_offices = [];
                  //fetch office names for this
                  //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected.  Then add “other” to the bottom of the list
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.state.statePostalCode,
                    CountyName: $scope.User.county,
                    voterScope: "County Name",
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.running_offices = response.data.data;
                        $scope.running_offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.running_offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
              case "sub county":
                if ($scope.User.state && $scope.User.county) {
                  $scope.User.cur_office_name = null;
                  $scope.running_offices = [];
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.state.statePostalCode,
                    CountyName: $scope.User.county,
                    voterScope: "County Name",
                    return_field: "CountySubdivisionName",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.running_subcounties = response.data.data;
                        //MyService.ConsoleLog("--- Got sub counties data ---: ", $scope.running_subcounties);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
              case "city":
                if ($scope.User.state) {
                  $scope.User.office_name = null;
                  // For the options, list all unique county subdivision names and place names within the selected county within the selected state
                  var promiseArr = {
                    counties: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.state.statePostalCode,
                      CountyName: $scope.User.county,
                      return_field: "CountySubdivisionName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                    places: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.state.statePostalCode,
                      CountyName: $scope.User.county,
                      return_field: "PlaceName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                  };

                  $q.all(promiseArr).then(function (response) {
                    //MyService.ConsoleLog("response: ", response);
                    if (
                      response.counties.data.success &&
                      response.places.data.success
                    ) {
                      $timeout(function () {
                        var tempArr = [];
                        angular.forEach(
                          response.counties.data.data,
                          function (val, key) {
                            tempArr.push({
                              label: val,
                              type: "county",
                            });
                          }
                        );
                        angular.forEach(
                          response.places.data.data,
                          function (val, key) {
                            tempArr.push({
                              label: val,
                              type: "place",
                            });
                          }
                        );

                        // tempArr = [{label: "tetst", type: "county"}, {label: "tetst 2", type: "place"}];

                        $scope.running_localities = tempArr;
                        //MyService.ConsoleLog("--- Got localities data ---: ", $scope.running_localities);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;

              case "local school district":
                $scope.User.office_name = null;
                if (!$scope.localSchoolDistException() && $scope.User.county) {
                  // results of a search through the table currently labelled “2016 Alabama” and find all AD’s, AF’s  and AH’s  where item Q is the state selected and item S is the “County” selection
                  var promiseArr = {
                    UnifiedSchoolDistrict: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.state.statePostalCode,
                      CountyName: $scope.county,
                      return_field: "UnifiedSchoolDistrictName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                    ElementarySchoolDistrict: MyService.getAddressOfRunningPoli(
                      {
                        StatePostalCode: $scope.User.state.statePostalCode,
                        CountyName: $scope.county,
                        return_field: "ElementarySchoolDistrictName",
                        timeout: getAddressOfRunningPoliCanceler.promise,
                      }
                    ),
                    SecondarySchoolDistrict: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.state.statePostalCode,
                      CountyName: $scope.county,
                      return_field: "SecondarySchoolDistrictName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                  };

                  $q.all(promiseArr).then(
                    function (response) {
                      //MyService.ConsoleLog("response: ", response);
                      if (
                        response.UnifiedSchoolDistrict.data.success &&
                        response.ElementarySchoolDistrict.data.success &&
                        response.SecondarySchoolDistrict.data.success
                      ) {
                        $timeout(function () {
                          var tempArr = [];
                          angular.forEach(
                            response.UnifiedSchoolDistrict.data.data,
                            function (val, key) {
                              tempArr.push({
                                label: val,
                                type: "UnifiedSchoolDistrictName",
                              });
                            }
                          );
                          angular.forEach(
                            response.ElementarySchoolDistrict.data.data,
                            function (val, key) {
                              tempArr.push({
                                label: val,
                                type: "ElementarySchoolDistrictName",
                              });
                            }
                          );
                          angular.forEach(
                            response.SecondarySchoolDistrict.data.data,
                            function (val, key) {
                              tempArr.push({
                                label: val,
                                type: "SecondarySchoolDistrictName",
                              });
                            }
                          );
                          //MyService.ConsoleLog("$scope.localSchoolDistricts: ", tempArr);
                          $scope.running_localSchoolDistricts = tempArr;
                        });
                      } else {
                        //MyService.ConsoleLog("response: ", response);
                        growl.error("Something went wrong.");
                      }
                    },
                    function (err) {
                      //MyService.ConsoleLog("err: ", err);
                      growl.error("Something went wrong.");
                    }
                  );
                }
                break;
            }
          } //state selected
        } else if (electionFor == "incumbent") {
          if ($scope.User.cur_state) {
            //MyService.ConsoleLog("** onCountyChange **");
            switch ($scope.User.cur_level) {
              case "county":
                if ($scope.User.cur_state) {
                  $scope.User.cur_office_name = null;
                  $scope.offices = [];
                  //fetch office names for this
                  //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected.  Then add “other” to the bottom of the list
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.cur_state.statePostalCode,
                    CountyName: $scope.User.cur_county,
                    voterScope: "County Name",
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.offices = response.data.data;
                        $scope.offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
              case "sub county":
                if ($scope.User.cur_state && $scope.User.cur_county) {
                  $scope.User.cur_office_name = null;
                  $scope.offices = [];
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.cur_state.statePostalCode,
                    CountyName: $scope.User.cur_county,
                    voterScope: "County Name",
                    return_field: "CountySubdivisionName",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.subcounties = response.data.data;
                        //MyService.ConsoleLog("--- Got sub counties data ---: ", $scope.subcounties);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
              case "city":
                if ($scope.User.cur_state) {
                  $scope.User.cur_office_name = null;
                  // For the options, list all unique county subdivision names and place names within the selected county within the selected state
                  var promiseArr = {
                    counties: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.cur_state.statePostalCode,
                      CountyName: $scope.User.cur_county,
                      return_field: "CountySubdivisionName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                    places: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.cur_state.statePostalCode,
                      CountyName: $scope.User.cur_county,
                      return_field: "PlaceName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                  };

                  $q.all(promiseArr).then(function (response) {
                    //MyService.ConsoleLog("response: ", response);
                    if (
                      response.counties.data.success &&
                      response.places.data.success
                    ) {
                      $timeout(function () {
                        var tempArr = [];
                        angular.forEach(
                          response.counties.data.data,
                          function (val, key) {
                            tempArr.push({
                              label: val,
                              type: "county",
                            });
                          }
                        );
                        angular.forEach(
                          response.places.data.data,
                          function (val, key) {
                            tempArr.push({
                              label: val,
                              type: "place",
                            });
                          }
                        );

                        // tempArr = [{label: "tetst", type: "county"}, {label: "tetst 2", type: "place"}];

                        $scope.localities = tempArr;
                        //MyService.ConsoleLog("--- Got localities data ---: ", $scope.localities);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;

              case "local school district":
                //MyService.ConsoleLog("cur_county : ", $scope.User.cur_county);
                $scope.User.cur_office_name = null;
                if (
                  !$scope.localSchoolDistException() &&
                  $scope.User.cur_county
                ) {
                  // results of a search through the table currently labelled “2016 Alabama” and find all AD’s, AF’s  and AH’s  where item Q is the state selected and item S is the “County” selection
                  var promiseArr = {
                    UnifiedSchoolDistrict: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.cur_state.statePostalCode,
                      CountyName: $scope.cur_county,
                      return_field: "UnifiedSchoolDistrictName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                    ElementarySchoolDistrict: MyService.getAddressOfRunningPoli(
                      {
                        StatePostalCode: $scope.User.cur_state.statePostalCode,
                        CountyName: $scope.cur_county,
                        return_field: "ElementarySchoolDistrictName",
                        timeout: getAddressOfRunningPoliCanceler.promise,
                      }
                    ),
                    SecondarySchoolDistrict: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.cur_state.statePostalCode,
                      CountyName: $scope.cur_county,
                      return_field: "SecondarySchoolDistrictName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                  };

                  $q.all(promiseArr).then(
                    function (response) {
                      //MyService.ConsoleLog("response: ", response);
                      if (
                        response.UnifiedSchoolDistrict.data.success &&
                        response.ElementarySchoolDistrict.data.success &&
                        response.SecondarySchoolDistrict.data.success
                      ) {
                        $timeout(function () {
                          var tempArr = [];
                          angular.forEach(
                            response.UnifiedSchoolDistrict.data.data,
                            function (val, key) {
                              tempArr.push({
                                label: val,
                                type: "UnifiedSchoolDistrictName",
                              });
                            }
                          );
                          angular.forEach(
                            response.ElementarySchoolDistrict.data.data,
                            function (val, key) {
                              tempArr.push({
                                label: val,
                                type: "ElementarySchoolDistrictName",
                              });
                            }
                          );
                          angular.forEach(
                            response.SecondarySchoolDistrict.data.data,
                            function (val, key) {
                              tempArr.push({
                                label: val,
                                type: "SecondarySchoolDistrictName",
                              });
                            }
                          );
                          //MyService.ConsoleLog("$scope.localSchoolDistricts: ", tempArr);
                          $scope.localSchoolDistricts = tempArr;
                        });
                      } else {
                        //MyService.ConsoleLog("response: ", response);
                        growl.error("Something went wrong.");
                      }
                    },
                    function (err) {
                      //MyService.ConsoleLog("err: ", err);
                      growl.error("Something went wrong.");
                    }
                  );
                }
                break;
            }
          } //state selected
        }
      };
      $scope.onSubCountyChange = function (electionFor) {
        if (electionFor == "running") {
          if ($scope.User.state) {
            //MyService.ConsoleLog("** onCountyChange **");
            switch ($scope.User.level) {
              case "sub county":
                if (
                  $scope.User.state &&
                  $scope.User.county &&
                  $scope.User.subcounty
                ) {
                  $scope.User.office_name = null;
                  $scope.running_offices = [];
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.state.statePostalCode,
                    CountyName: $scope.User.county,
                    // voterScope: "County Name",
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.running_offices = response.data.data;
                        $scope.running_offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.running_offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //s
        } else {
          if ($scope.User.cur_state) {
            //MyService.ConsoleLog("** onCountyChange **");
            switch ($scope.User.cur_level) {
              case "sub county":
                if (
                  $scope.User.cur_state &&
                  $scope.User.cur_county &&
                  $scope.User.subcounty
                ) {
                  $scope.User.cur_office_name = null;
                  $scope.offices = [];
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.cur_state.statePostalCode,
                    CountyName: $scope.User.cur_county,
                    // voterScope: "County Name",
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.offices = response.data.data;
                        $scope.offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //s
        }
      };
      $scope.onLocalityChange = function (electionFor) {
        //MyService.ConsoleLog("** onLocalityChange **");
        if (electionFor == "running") {
          if ($scope.User.state) {
            switch ($scope.User.level) {
              case "city":
                if (
                  $scope.User.state &&
                  $scope.User.county &&
                  $scope.User.locality
                ) {
                  $scope.User.office_name = null;
                  $scope.running_offices = [];
                  //fetch office names for this
                  // For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected and U or W match the “city” selection.  Then add “other” to the bottom of the list
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.state.statePostalCode,
                    CountyName: $scope.User.county,
                    CountySubdivisionName: $scope.User.locality.label,
                    PlaceName: $scope.User.locality.label,
                    office_for: "place", //this is special case
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.running_offices = response.data.data;
                        $scope.running_offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.running_offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //s
        } else if (electionFor == "incumbent") {
          if ($scope.User.cur_state) {
            switch ($scope.User.cur_level) {
              case "city":
                if (
                  $scope.User.cur_state &&
                  $scope.User.cur_county &&
                  $scope.User.cur_locality
                ) {
                  $scope.User.cur_office_name = null;
                  $scope.offices = [];
                  //fetch office names for this
                  // For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected and U or W match the “city” selection.  Then add “other” to the bottom of the list
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.cur_state.statePostalCode,
                    CountyName: $scope.User.cur_county,
                    CountySubdivisionName: $scope.User.cur_locality.label,
                    PlaceName: $scope.User.cur_locality.label,
                    office_for: "place", //this is special case
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.offices = response.data.data;
                        $scope.offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //s
        }
      };
      $scope.onStateSchoolDistChange = function (electionFor) {
        //MyService.ConsoleLog("** onStateSchoolDistChange **");
        if (electionFor == "running") {
          if ($scope.User.state) {
            switch ($scope.User.level) {
              case "state school board district":
                if ($scope.User.state && $scope.User.state_school_dist) {
                  $scope.User.office_name = null;
                  $scope.running_offices = [];
                  //fetch office names for this
                  // do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item E is the “District” selection.  Then add “other” to the bottom of the list.
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.state.statePostalCode,
                    StateBoardEducationDistrict: $scope.User.state_school_dist,
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.running_offices = response.data.data;
                        $scope.running_offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.running_offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //s
        } else if (electionFor == "incumbent") {
          if ($scope.User.cur_state) {
            switch ($scope.User.cur_level) {
              case "state school board district":
                if (
                  $scope.User.cur_state &&
                  $scope.User.cur_state_school_dist
                ) {
                  $scope.User.cur_office_name = null;
                  $scope.offices = [];
                  //fetch office names for this
                  // do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item E is the “District” selection.  Then add “other” to the bottom of the list.
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.cur_state.statePostalCode,
                    StateBoardEducationDistrict:
                      $scope.User.cur_state_school_dist,
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.offices = response.data.data;
                        $scope.offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //s
        }
      };
      $scope.onLocalSchoolDistChange = function (electionFor) {
        if (electionFor == "running") {
          if ($scope.User.state) {
            //MyService.ConsoleLog("** onLocalSchoolDistChange **");
            switch ($scope.User.level) {
              case "local school district":
                break;
            }
          } //s
        } else if (electionFor == "incumbent") {
          if ($scope.User.cur_state) {
            //MyService.ConsoleLog("** onLocalSchoolDistChange **");
            switch ($scope.User.level) {
              case "local school district":
                break;
            }
          } //s
        }
      };

      $scope.CheckUserName = function () {
        $scope.Errors = [];
        MyService.checkUnm({
          username: $scope.User.UserName,
        }).then(
          function (response) {
            if (response.data.taken == true) {
              //$scope.Errors.push('Oops! Username ' + $scope.User.UserName + ' has already been taken.');
              growl.error(
                "Oops! Username " +
                  $scope.User.UserName +
                  " has already been taken."
              );
            }
          },
          function (err) {
            growl.error("Something went wrong.");
          }
        );
      };

      $scope.SignIn = function () {
        $http
          .post(baseApiUrl + "user/authenticate", {
            username: $scope.User.UserName,
            password: $scope.User.Password,
          })
          .then(
            function (response) {
              if (response.data.success == true) {
                tokenService.saveToken(response.data.token);
                tokenService.saveUserName(response.data.name);
                $http.defaults.headers.common["Authorization"] =
                  tokenService.getToken();
                $rootScope.Auth = true;
                $rootScope.User = tokenService.getUserName();
                $location.path("debate");
              } else {
                growl.error("Invalid Username or Password. Please try again.");
              }
            },
            function (response) {
              var validataionMsg = "";
              var errors = response.data.error.errors;
              for (var k in errors) {
                if (errors.hasOwnProperty(k)) {
                  var obj = errors[k];
                  if (obj.message !== undefined)
                    validataionMsg += obj.message.replace("Path", "") + "<br/>";
                }
              }
              growl.error(validataionMsg);
            }
          );
      };

      $scope.generatePostUserObj = function () {
        console.log("dates", $scope.User.from_date);
        if ($.fn.validateForceFully($("#signupform")) == true) {
          $scope.Errors = [];

          var mainLocation = JSON.stringify({
            longitude: $scope.lon ? $scope.lon : $scope.longg,
            latitude: $scope.lati ? $scope.lati : $scope.latt,
          });

          MyService.ConsoleLog("latitude and longitude :", mainLocation);

          /*  var mainAddress = JSON.stringify({
              state: $scope.state,
              statePostalCode: $scope.statePostalCode ?
                $scope.statePostalCode : $scope.astatePostalCode,
              place: $scope.place_name ? $scope.place_name : $scope.aplace,
              county: $scope.county_name ? $scope.county_name : $scope.acounty,
              country: $scope.countryname ? $scope.countryname : $scope.acountry,
              countySubdivision: $scope.address.countySubdivision ?
                $scope.address.countySubdivision._id.countySubdivision : $scope.acountySubdivision,
              federalCongrassionalDist: $scope.address.federalCongrassionalDist ?
                $scope.address.federalCongrassionalDist.federalCongrassionalDist : '',
              stateSenateDistrict: $scope.address.stateSenateDistrict ?
                $scope.address.stateSenateDistrict.stateSenateDistrict : '',
              schoolDistrictFips: $scope.address.unifiedSchoolDistrictName ?
                $scope.address.unifiedSchoolDistrictName.unifiedSchoolDistrict : '',
              schoolDistrict: $scope.address.unifiedSchoolDistrictName ?
                $scope.address.unifiedSchoolDistrictName.unifiedSchoolDistrictName : '',
              voterDistrictFips: $scope.address.voterDistrict ?
                $scope.address.voterDistrict.voterDistrict : '',
              voterDistrict: $scope.address.voterDistrict ?
                $scope.address.voterDistrict.voterDistrictName : '',
              legislativeDistrict: $scope.address.stateHouseOFRepresentativeDistrict ?
                $scope.stateHouseOFRepresentativeDistrict : '',
            });*/

          if ($scope.UserType == "advocate") {
            // alert("welcome");
            var mainAddress = JSON.stringify({
              state: $scope.state,
              statePostalCode: $scope.statePostalCode
                ? $scope.statePostalCode
                : $scope.astatePostalCode,
              place: $scope.place_name ? $scope.place_name : $scope.aplace,
              county: $scope.county_name ? $scope.county_name : $scope.acounty,
              country: $scope.countryname
                ? $scope.countryname
                : $scope.acountry,
              countySubdivision: $scope.address.countySubdivision
                ? $scope.address.countySubdivision._id.countySubdivision
                : $scope.acountySubdivision,
              federalCongrassionalDist: $scope.address.federalCongrassionalDist
                ? $scope.address.federalCongrassionalDist
                    .federalCongrassionalDist
                : "",
              stateSenateDistrict: $scope.address.stateSenateDistrict
                ? $scope.address.stateSenateDistrict.stateSenateDistrict
                : "",
              schoolDistrictFips: $scope.address.unifiedSchoolDistrictName
                ? $scope.address.unifiedSchoolDistrictName.unifiedSchoolDistrict
                : "",
              schoolDistrict: $scope.address.unifiedSchoolDistrictName
                ? $scope.address.unifiedSchoolDistrictName
                    .unifiedSchoolDistrictName
                : "",
              voterDistrictFips: $scope.address.voterDistrict
                ? $scope.address.voterDistrict.voterDistrict
                : "",
              voterDistrict: $scope.address.voterDistrict
                ? $scope.address.voterDistrict.voterDistrictName
                : "",
              legislativeDistrict: $scope.address
                .stateHouseOFRepresentativeDistrict
                ? $scope.stateHouseOFRepresentativeDistrict
                : "",
              cityCouncilDistrictName: $scope.address.cityCouncilDistrictName
                ? $scope.address.cityCouncilDistrictName.COUNTDIST
                : "",
            });
          }

          if ($scope.UserType == "voter") {
            if ($scope.User.cur_level != "County") {
              // alert("flag");
              $scope.checkFlag = true;
            }

            MyService.ConsoleLog("$scope.User", $scope.address);

            var mainAddress = JSON.stringify({
              state: $scope.User.cur_state
                ? $scope.User.cur_state.state
                : $scope.User
                ? $scope.User.state.state
                : "",
              statePostalCode: $scope.statePostalCode
                ? $scope.statePostalCode
                : $scope.User.cur_state
                ? $scope.User.cur_state.state.statePostalCode
                : "",
              stateFips: $scope.address.state
                ? $scope.address.state.stateFips
                : "",
              place: $scope.address.place ? $scope.address.place.placeName : "",
              placeFips: $scope.address.place
                ? $scope.address.place.placeFips
                : "",
              county: $scope.address.county
                ? $scope.address.county.countyName
                : "",
              countyFips: $scope.address.county
                ? $scope.address.county.countyFips
                : "",
              country: $scope.countryname ? $scope.countryname : "",
              countySubdivision: $scope.address.countySubdivision
                ? $scope.address.countySubdivision.countySubdivision
                : "",
              countySubdivisionFips: $scope.address.countySubdivision
                ? $scope.address.countySubdivision.countySubdivisionFips
                : "",
              federalCongrassionalDist: $scope.address.federalCongrassionalDist
                ? $scope.address.federalCongrassionalDist.CD115FP
                : "",
              stateSenateDistrict: $scope.address.stateSenateDistrict
                ? $scope.address.stateSenateDistrict.NAMELSAD
                : "",
              schoolDistrictFips: $scope.address.unifiedSchoolDistrictName
                ? $scope.address.unifiedSchoolDistrictName
                    .unifiedSchoolDistrictFips
                : "",
              schoolDistrict: $scope.address.unifiedSchoolDistrictName
                ? $scope.address.unifiedSchoolDistrictName.NAME
                : "",
              voterDistrictFips: $scope.address.voterDistrict
                ? $scope.address.voterDistrict.voterDistrict
                : "",
              voterDistrict: $scope.address.voterDistrict
                ? $scope.address.voterDistrict.voterDistrictName
                : "",
              legislativeDistrict: $scope.address
                .stateHouseOFRepresentativeDistrict
                ? $scope.address.stateHouseOFRepresentativeDistrict.NAMELSAD
                : "",
              cityCouncilDistrictName: $scope.address.cityCouncilDistrictName
                ? $scope.address.cityCouncilDistrictName.COUNTDIST
                : "",
            });
          }

          if ($scope.UserType == "politician") {
            var poliAddress = JSON.stringify({
              state: $scope.User.cur_state
                ? $scope.User.cur_state.state
                : $scope.User.state
                ? $scope.User.state.state
                : "",
              statePostalCode: $scope.statePostalCode
                ? $scope.statePostalCode
                : $scope.User.cur_state
                ? $scope.User.cur_state.state.statePostalCode
                : $scope.statePostalCode,
              stateFips: $scope.address.state
                ? $scope.address.state.stateFips
                : "",
              place: $scope.address.place
                ? $scope.address.place.city
                : $scope.place_name,
              placeFips: $scope.address.place
                ? $scope.address.place.placeFips
                : "",
              county: $scope.address.county
                ? $scope.address.county.countyName
                : $scope.county_name,
              countyFips: $scope.address.county
                ? $scope.address.county.countyFips
                : "",
              country: $scope.countryname
                ? $scope.countryname
                : $scope.acountry,
              countySubdivision: $scope.address.countySubdivision
                ? $scope.address.countySubdivision.countySubdivision
                : $scope.acountySubdivision,
              countySubdivisionFips: $scope.address.countySubdivision
                ? $scope.address.countySubdivision.countySubdivisionFips
                : "",
              federalCongrassionalDist: $scope.address.federalCongrassionalDist
                ? $scope.address.federalCongrassionalDist
                    .congressionalDistrictFips
                : "",
              stateSenateDistrict: $scope.address.stateSenateDistrict
                ? $scope.address.stateSenateDistrict.stateSenateDistrictFips
                : "",
              schoolDistrictFips: $scope.address.unifiedSchoolDistrictName
                ? $scope.address.unifiedSchoolDistrictName
                    .unifiedSchoolDistrictFips
                : "",
              schoolDistrict: $scope.address.unifiedSchoolDistrictName
                ? $scope.address.unifiedSchoolDistrictName.unifiedSchoolDistrict
                : "",
              voterDistrictFips: $scope.address.voterDistrict
                ? $scope.address.voterDistrict.voterDistrict
                : "",
              voterDistrict: $scope.address.voterDistrict
                ? $scope.address.voterDistrict.voterDistrictName
                : "",
              legislativeDistrict: $scope.address
                .stateHouseOFRepresentativeDistrict
                ? $scope.address.stateHouseOFRepresentativeDistrict
                    .stateHouseofRepresentativesDistrictName
                : "",
            });

            var runningPoliInfo = JSON.stringify({
              state: $scope.User.state
                ? $scope.User.state.state
                : $scope.User.cur_state
                ? $scope.User.cur_state.state
                : "",
              statePostalCode: $scope.User.state
                ? $scope.User.state.statePostalCode
                : $scope.statePostalCode
                ? $scope.statePostalCode
                : "",
              stateFips: $scope.User.state ? $scope.User.state.stateFips : "",
              place: $scope.runAddress.place
                ? $scope.runAddress.place.city
                : $scope.place_name
                ? $scope.place_name
                : "",
              placeFips: $scope.runAddress.place
                ? $scope.runAddress.place.placeFips
                : "",
              county: $scope.runAddress.county
                ? $scope.runAddress.county.countyName
                : $scope.county_name
                ? $scope.county_name
                : "",
              countyFips: $scope.runAddress.county
                ? $scope.runAddress.county.countyFips
                : "",
              country: $scope.countryname
                ? $scope.countryname
                : $scope.acountry,
              countySubdivision: $scope.runAddress.countySubdivision
                ? $scope.runAddress.countySubdivision.countySubdivision
                : $scope.acountySubdivision,
              countySubdivisionFips: $scope.runAddress.countySubdivision
                ? $scope.runAddress.countySubdivision.countySubdivisionFips
                : "",
              federalCongrassionalDist: $scope.runAddress
                .federalCongrassionalDist
                ? $scope.runAddress.federalCongrassionalDist
                    .congressionalDistrictFips
                : "",
              stateSenateDistrict: $scope.runAddress.stateSenateDistrict
                ? $scope.runAddress.stateSenateDistrict.stateSenateDistrictFips
                : "",
              schoolDistrictFips: $scope.runAddress.unifiedSchoolDistrictName
                ? $scope.runAddress.unifiedSchoolDistrictName
                    .unifiedSchoolDistrictFips
                : "",
              schoolDistrict: $scope.runAddress.unifiedSchoolDistrictName
                ? $scope.runAddress.unifiedSchoolDistrictName
                    .unifiedSchoolDistrict
                : "",
              voterDistrictFips: $scope.runAddress.voterDistrict
                ? $scope.runAddress.voterDistrict.voterDistrict
                : "",
              voterDistrict: $scope.runAddress.voterDistrict
                ? $scope.runAddress.voterDistrict.voterDistrictName
                : "",
              legislativeDistrict: $scope.runAddress
                .stateHouseOFRepresentativeDistrict
                ? $scope.runAddress.stateHouseOFRepresentativeDistrict
                    .stateHouseofRepresentativesDistrictName
                : "",
            });
          }

          // MyService.ConsoleLog(
          //   "<<<<<<<< runningPoliInfo >>>>>>>>",
          //   runningPoliInfo
          // );

          $scope.setLevel = function (lvl) {
            switch (lvl) {
              case "Federal":
                postobj.cur_level = "federalCongressionalDistrict";
                break;
              case "Other":
                postobj.cur_level = "All USA";
                break;
              case "State":
                postobj.cur_level = "statePostalCode";
                break;
              case "County":
                postobj.cur_level = "countyName";
                break;
              case "Local":
                postobj.cur_level = "placeName";
                break;
              default:
                break;
            }
          };

          if (
            $scope.User.runElectionDate &&
            $scope.User.runElectionDate != ""
          ) {
            // $scope.User.runElectionDate ? $scope.User.runElectionDate : "
            MyService.ConsoleLog(
              "$scope.User.runElectionDate ",
              $scope.User.runElectionDate
            );
            // var eleDate = $scope.User.runElectionDate.toJSON();
            var month = (
              "0" +
              ($scope.User.runElectionDate.getMonth() + 1)
            ).slice(-2);
            var dat = ("0" + $scope.User.runElectionDate.getDate()).slice(-2);
            MyService.ConsoleLog("dat >>", dat);
            var finDate =
              $scope.User.runElectionDate.getFullYear() +
              "-" +
              month +
              "-" +
              dat;
            MyService.ConsoleLog(
              "$scope.User.runElectionDate ",
              $scope.User.runElectionDate.getDate()
            );
            MyService.ConsoleLog(
              "$scope.User.runElectionDate ",
              $scope.User.runElectionDate.getMonth()
            );
            MyService.ConsoleLog(
              "$scope.User.runElectionDate ",
              finDate.toString()
            );
          }

          MyService.ConsoleLog("mainAddress >> ", mainAddress);
          var postobj = {
            username: $scope.User.UserName,
            password: $scope.User.Password,
            email: $scope.User.Email,
            zipcode: $scope.User.ZipCode,
            type: $scope.UserType,
            postCard: $scope.User.postCard,
            verifiedUser: $scope.verifiedUser,
            verificationCell: $scope.verificationCell,
            verificationCarrier: $scope.verificationCarrier,
            verificationMethod: $scope.verificationMethod,
            verificationurl: $rootScope.getVerificationUrl(),
            address: mainAddress,
            poliAddress: poliAddress,
            runningPoliInfo: runningPoliInfo,
            unsubscribeurl: $rootScope.getEmailUnsubscribeUrl(),
            loc: mainLocation,
            mailingAddress: $scope.mailing_Address
              ? $scope.mailing_Address
              : $scope.mailAdd,
            from_date: "",
            end_date: "",
            campaignEmail: $scope.User.campaignEmail,
            campaignWebSite: $scope.User.campaignWebSite,
            campaignFburl: $scope.User.campaignFburl,
            campPhone_no: $scope.User.campPhone_no,
            run_electionDate: finDate ? finDate : "",
          };
          console.log("test type", $scope.UserType);
          MyService.ConsoleLog(
            " my office first >>>>>>>>>> :",
            $scope.User.cur_office_name
          );

          switch ($scope.UserType.toLowerCase()) {
            case "voter":
              postobj.name = $scope.User.name + " " + $scope.User.lastname;
              break;
            case "advocate":
              postobj.name = $scope.User.name + " " + $scope.User.lastname;
              postobj.position = $scope.User.position;
              postobj.extention_no = $scope.User.extention_no;
              postobj.verification_note = $scope.User.verification_note;
              postobj.typeOfOrg = $scope.User.orgType;
              postobj.empIndNo = $scope.User.empIndNo;
              postobj.officeName = $scope.User.organization_name;
              postobj.officeWebUrl = $scope.User.organization.web_url;
              postobj.officePhoneNumber = $scope.User.organization.phone_no;
              break;

            case "press":
              postobj.name = $scope.User.name + " " + $scope.User.lastname;
              postobj.position = $scope.User.position;
              postobj.extention_no = $scope.User.press_extension_no;
              postobj.verification_note = $scope.User.verification_note;
              postobj.typeOfOrg = $scope.User.orgType;
              postobj.empIndNo = $scope.User.empIndNo;
              postobj.officeName = $scope.User.outlet_name;
              postobj.officeWebUrl = $scope.User.outlet_web;
              postobj.officePhoneNumber = $scope.User.outlet_phone_no;

              break;
            case "politician":
              postobj.name_on_ballot = $scope.User.new_Candidates
                ? $scope.User.new_Candidates
                : $scope.User.cur_Candidates;
              postobj.name = $scope.User.name;

              postobj.phone_no = $scope.User.phone_no
                ? $scope.User.phone_no
                : "";
              postobj.cur_office_phone = $scope.User.cur_office_phone
                ? $scope.User.cur_office_phone
                : "";
              postobj.publicEmail = $scope.User.cur_office_email
                ? $scope.User.cur_office_email
                : "";
              postobj.web_url = $scope.User.cur_office_website
                ? $scope.User.cur_office_website
                : "";
              postobj.mailing_address = $scope.mailing_address;

              if (
                $scope.User.govtOfficialWebsite &&
                $scope.User.govtOfficialWebsite != ""
              ) {
                postobj.govtOfficialWebsite = $scope.User.govtOfficialWebsite;
              }
              if ($scope.User.Candidates && $scope.User.Candidates._id) {
                postobj.cur_office_id = $scope.User.Candidates._id;
              }
              if ($scope.User.NCandidates && $scope.User.NCandidates._id) {
                postobj.office_id = $scope.User.NCandidates._id;
              }
              if ($scope.User.isInCurrentOffice == 1) {
                try {
                  MyService.ConsoleLog(
                    " my office >>>>>>>>>> :",
                    $scope.User.cur_office_name
                  );

                  if ($scope.User.cur_office_name) {
                    postobj.cur_office_name = $scope.User.cur_office_name;
                    // console.log('current office >>>>>>>>>>>>>>>', $scope.User.cur_office_name);
                  } else {
                    if ($filter("isBlankString")($scope.User.cur_office_name)) {
                      growl.error("Current Office name is not selected");
                      return null;
                    } else {
                      postobj.cur_office_name = $scope.User.cur_office_name;
                    }
                  }

                  if ($scope.User.cur_level) {
                    MyService.ConsoleLog(
                      " User.cur_level first >>>>>>> ",
                      $scope.User.cur_level
                    );
                    $scope.setLevel($scope.User.cur_level);
                  }

                  /*if($filter("isBlankString")($scope.User.cur_jurisdiction_name)){
                  growl.error("Current jurisdiction name is not selected");
                  return null;
                }*/

                  // postobj.cur_jurisdiction_name = $scope.User.cur_jurisdiction_name;
                  if ($scope.User.cur_state) {
                    var state = $scope.User.cur_state;
                    //MyService.ConsoleLog(state);
                    //MyService.ConsoleLog(state.state);
                    postobj.cur_state = state.state;
                    postobj.cur_state_postal_code = state.statePostalCode;
                  }

                  if ($scope.User.Candidates) {
                    if (
                      $scope.User.Candidates.FederalCongressionalDistrict &&
                      $scope.User.Candidates.FederalCongressionalDistrict !=
                        null
                    ) {
                      postobj.cur_federal_congrassional_dist =
                        $scope.User.Candidates.FederalCongressionalDistrict;
                    }

                    if (
                      $scope.User.Candidates.JudicialCircuitNumber &&
                      $scope.User.Candidates.JudicialCircuitNumber != null
                    ) {
                      postobj.cur_judicial_circuit_no =
                        $scope.User.Candidates.JudicialCircuitNumber;
                    }

                    if (
                      $scope.User.Candidates.CountyName &&
                      $scope.User.Candidates.CountyName != null
                    ) {
                      postobj.cur_county = $scope.User.Candidates.CountyName;
                    }

                    if (
                      $scope.User.Candidates.CountySubdivisionName &&
                      $scope.User.Candidates.CountySubdivisionName != null
                    ) {
                      postobj.cur_subcounty =
                        $scope.User.Candidates.CountySubdivisionName;
                    }

                    if (
                      $scope.User.Candidates.PlaceName &&
                      $scope.User.Candidates.PlaceName != null
                    ) {
                      postobj.cur_place = $scope.User.Candidates.PlaceName;
                    }

                    if (
                      $scope.User.Candidates.StateBoardEducationDistrict &&
                      $scope.User.Candidates.StateBoardEducationDistrict != null
                    ) {
                      postobj.cur_state_board_education_dist =
                        $scope.User.Candidates.StateBoardEducationDistrict;
                    }

                    if (
                      $scope.User.Candidates.UnifiedSchoolDistrictName &&
                      $scope.User.Candidates.UnifiedSchoolDistrictName != null
                    ) {
                      postobj.cur_unified_school_dist =
                        $scope.User.Candidates.UnifiedSchoolDistrictName;
                    }

                    if (
                      $scope.User.Candidates.ElementarySchoolDistrictName &&
                      $scope.User.Candidates.ElementarySchoolDistrictName !=
                        null
                    ) {
                      postobj.cur_elementary_school_dist =
                        $scope.User.Candidates.ElementarySchoolDistrictName;
                    }

                    if (
                      $scope.User.Candidates.SecondarySchoolDistrictName &&
                      $scope.User.Candidates.SecondarySchoolDistrictName != null
                    ) {
                      postobj.cur_secondary_school_dist =
                        $scope.User.Candidates.SecondarySchoolDistrictName;
                    }
                  }
                } catch (e) {
                  MyService.ConsoleLog("Exceptoin: ", e);
                  $scope.RegisterButton = false;
                  growl.error("Valid Office Name is required.");
                  return null;
                }
              }

              if ($scope.User.isRunningForEle == 1) {
                if ($scope.User.RunningForOtherOffice == 1) {
                  postobj.cur_office_name = $scope.User.cur_office_name;
                  if ($scope.User.cur_level) {
                    MyService.ConsoleLog(
                      " User.cur_level second >>>>>>> ",
                      $scope.User.cur_level
                    );

                    $scope.setLevel($scope.User.cur_level);
                    // postobj.cur_level = $scope.User.cur_level;
                  }
                  postobj.run_candidateStatus = $scope.User.runStatus
                    ? $scope.User.runStatus
                    : "";
                } else {
                  if (
                    $scope.User.NCandidates &&
                    $scope.User.NCandidates.office
                  ) {
                    postobj.office_name = $scope.User.NCandidates.office;
                  } else {
                    if ($filter("isBlankString")($scope.User.office_name)) {
                      growl.error("Office name is not selected");
                      return null;
                    } else {
                      postobj.office_name = $scope.User.office_name;
                    }
                  }
                  if ($scope.User.level) {
                    MyService.ConsoleLog(
                      " got lvl of govt :",
                      $scope.User.level
                    );

                    switch ($scope.User.level) {
                      case "Federal":
                        postobj.level = "federalCongressionalDistrict";
                        break;
                      case "Other":
                        postobj.level = "All USA";
                        break;
                      case "State":
                        postobj.level = "statePostalCode";
                        break;
                      case "County":
                        postobj.level = "countyName";
                        break;
                      case "Local":
                        postobj.level = "placeName";
                        break;
                      default:
                        break;
                    }
                  }
                }
                if ($scope.User.runStatus) {
                  postobj.run_candidateStatus = $scope.User.runStatus
                    ? $scope.User.runStatus
                    : "";
                }
                try {
                  if ($scope.User.state) {
                    var state = $scope.User.state;
                    postobj.state = state.state;
                    postobj.state_postal_code = state.statePostalCode;
                  }

                  if (
                    $scope.User.NCandidates &&
                    $scope.User.NCandidates.FederalCongressionalDistrict &&
                    $scope.User.NCandidates.FederalCongressionalDistrict != null
                  ) {
                    postobj.federal_congrassional_dist =
                      $scope.User.NCandidates.FederalCongressionalDistrict;
                  }

                  if (
                    $scope.User.NCandidates &&
                    $scope.User.NCandidates.JudicialCircuitNumber &&
                    $scope.User.NCandidates.JudicialCircuitNumber != null
                  ) {
                    postobj.judicial_circuit_no =
                      $scope.User.NCandidates.JudicialCircuitNumber;
                  }

                  if (
                    $scope.User.NCandidates &&
                    $scope.User.NCandidates.CountyName &&
                    $scope.User.NCandidates.CountyName != null
                  ) {
                    postobj.county = $scope.User.NCandidates.CountyName;
                  }

                  if (
                    $scope.User.NCandidates &&
                    $scope.User.NCandidates.CountySubdivisionName &&
                    $scope.User.NCandidates.CountySubdivisionName != null
                  ) {
                    postobj.subcounty =
                      $scope.User.NCandidates.CountySubdivisionName;
                  }

                  if (
                    $scope.User.NCandidates &&
                    $scope.User.NCandidates.PlaceName &&
                    $scope.User.NCandidates.PlaceName != null
                  ) {
                    postobj.place = $scope.User.NCandidates.PlaceName;
                  }

                  if (
                    $scope.User.NCandidates &&
                    $scope.User.NCandidates.StateBoardEducationDistrict &&
                    $scope.User.NCandidates.StateBoardEducationDistrict != null
                  ) {
                    postobj.state_board_education_dist =
                      $scope.User.NCandidates.StateBoardEducationDistrict;
                  }

                  if (
                    $scope.User.NCandidates &&
                    $scope.User.NCandidates.UnifiedSchoolDistrictName &&
                    $scope.User.NCandidates.UnifiedSchoolDistrictName != null
                  ) {
                    postobj.unified_school_dist =
                      $scope.User.NCandidates.UnifiedSchoolDistrictName;
                  }

                  if (
                    $scope.User.NCandidates &&
                    $scope.User.NCandidates.ElementarySchoolDistrictName &&
                    $scope.User.NCandidates.ElementarySchoolDistrictName != null
                  ) {
                    postobj.elementary_school_dist =
                      $scope.User.NCandidates.ElementarySchoolDistrictName;
                  }

                  if (
                    $scope.User.NCandidates &&
                    $scope.User.NCandidates.SecondarySchoolDistrictName &&
                    $scope.User.NCandidates.SecondarySchoolDistrictName != null
                  ) {
                    postobj.secondary_school_dist =
                      $scope.User.NCandidates.SecondarySchoolDistrictName;
                  }
                } catch (e) {
                  MyService.ConsoleLog("e", e);
                  $scope.RegisterButton = false;
                  growl.error("Valid office details are required.");
                  return null;
                }
              }
              if ($scope.User.web_url) postobj.web_url = $scope.User.web_url;
              if ($scope.User.facebook_url)
                postobj.fabebook_url = $scope.User.facebook_url;
              break;
          }
          // MyService.ConsoleLog("postobj:::::", postobj);
          return postobj;
        } //validation
        else {
          return null;
        }
      };

      $scope.disableRegister = function (opt) {
        if (opt == "P") {
          $scope.RegisterButton = true;
        } else {
          $scope.RegisterButton = false;
        }
      };
      $scope.verificationCode = "";
      $scope.getVerificationCode = function () {
        // $scope.number_exist = false;

        var cell = $scope.User.cellnumber;
        var carrier = $scope.User.carrier;
        // MyService.ConsoleLog(cell);
        // MyService.ConsoleLog(carrier);
        // MyService.ConsoleLog(carrier.domain);

        if (!cell || cell == "") {
          alert("Please enter phone number");
          return;
          //return false;
        }

        if (!carrier || carrier == "") {
          alert("Please select your phone carrier");
          return;
          //return false;
        }

        if (cell && cell != "" && carrier && carrier != "") {
          MyService.ConsoleLog("here");
          if (carrier.domain) {
            $scope.verificationCell = cell;
            $scope.verificationCarrier = carrier.domain;
            MyService.sendVerificationCode({
              cellnumber: cell,
              carrier: carrier.domain,
            }).then(
              function (payload) {
                MyService.ConsoleLog(payload);
                if (payload.data.success) {
                  $scope.verificationCode = payload.data.data;
                } else {
                  $scope.verificationCode = "";
                  // $scope.number_exist = true;

                  $(document).ready(function () {
                    $scope.number_exist = true;
                    setTimeout(function () {
                      $(".alert").alert("close");
                    }, 5000);
                  });
                  // alert("Something went wrong please try agian");
                }
              },
              function (errPayload) {
                $scope.verificationCode = "";
                alert("Something went wrong please try agian");
              }
            );
          }
        }
      };

      $scope.verifySSN = function () {
        //MyService.ConsoleLog("SSN<><><>", $scope.User.ssn);
        var returnval = "";
        if ($scope.User.ssn == "") {
          returnval = "Please enter valid SSN";
        }
        if ($scope.User.name == "") {
          returnval = "Please enter valid name to verify with the SSN";
        }
        if (returnval == "") {
          var aurl =
            "https://personator.melissadata.net/v3/WEB/ContactVerify/doContactVerify";
          aurl += "?id=RyMI8jlzD6dHUApvp_3XRP**";
          aurl += "&ss=" + $scope.User.ssn;
          aurl += "&full=" + $scope.User.name;
          aurl += "&format=JSON";
          // var deferred = $q.defer();
          //var furl = "https://personator.melissadata.net/v3/WEB/ContactVerify/doContactVerify?id=RyMI8jlzD6dHUApvp_3XRP**&cols=GrpCensus,GrpCensus2,GrpGeocode&a1=" + records.address + "&city=" + records.city + "&state=" + records.state + "&postal=" + records.zipcode + "&ctry=US&format=JSON";
          //MyService.ConsoleLog("furl <><>>", furl);
          $http.get(aurl).then(
            function successCallback(response) {
              //$scope.result = "";
              //MyService.ConsoleLog("response<><", response);
              $scope.finddetailsclicked = false;
              if (response.statusText == "OK") {
              }
            },
            function errorCallBack(error) {
              $scope.finddetailsclicked = false;
              //MyService.ConsoleLog(error);
            }
          );
        } else {
          alert(returnval);
        }
      };

      $scope.verifiedUser = "false";
      $scope.verificationMethod = "Email";
      $scope.verificationCell = "";
      $scope.verificationCarrier = "";
      $scope.matchVerficationCode = function (val) {
        //MyService.ConsoleLog("value : ", val);
        //MyService.ConsoleLog($scope.User.verificationCode);
        //MyService.ConsoleLog(val.length);
        $scope.RegisterButton = true;
        $scope.verifiedUser = "false";
        if (val.length == 6 && $scope.verificationCode != "") {
          if ($scope.verificationCode == val) {
            $scope.RegisterButton = false;
            $scope.verifiedUser = "true";
            $scope.verificationMethod = "Cell Phone Number";
          }
        }
      };

      $scope.resetPassword = function () {
        MyService.ConsoleLog($scope.User.Email);
        //MyService.ConsoleLog($scope.User.cur_office_email);
        var emails = [];
        if ($scope.User.Email && $scope.User.Email != "") {
          if (emails.indexOf($scope.User.Email) == -1) {
            emails.push($scope.User.Email);
          }
        }
        if ($scope.User.UserName && $scope.User.UserName != "") {
          if (emails.indexOf($scope.User.UserName) == -1) {
            emails.push($scope.User.UserName);
          }
        }

        if (
          $scope.User.cur_office_email &&
          $scope.User.cur_office_email != ""
        ) {
          if (emails.indexOf($scope.User.cur_office_email) == -1) {
            emails.push($scope.User.cur_office_email);
          }
        }

        if (emails.length > 0) {
          //MyService.ConsoleLog("emails<><><>", emails);
          MyService.ConsoleLog("uname<><><>", $scope.User.multiName);

          var multiUser;
          if ($scope.User.multiName && $scope.User.multiName.name != "") {
            multiUser = $scope.User.multiName.name;
          } else {
            multiUser = null;
          }

          // emails.push($scope.User.UserName);

          MyService.ConsoleLog("emails >>>>>>>", emails);
          MyService.ConsoleLog(
            "$scope.User.UserName",
            typeof $scope.User.UserName
          );

          // return;
          MyService.forgotPoliticianPassword({
            email: JSON.stringify(emails),
            reset_url: $rootScope.getPasswordResetUrl(),
            checkMultiUser: multiUser,
          }).then(
            function (payload) {
              //MyService.ConsoleLog("Payload<><><><>", payload);
              if (payload.data.success) {
                // alert(payload.data.data);
                growl.success(payload.data.data);
              } else {
                // alert("Something went wrong please try again later");
                growl.error("Something went wrong please try again later");
              }
            },
            function (errorPayload) {
              //MyService.ConsoleLog("Payload<><><><>", errorPayload);
            }
          );
        }
      };

      $scope.CreateUser = function () {
        //MyService.ConsoleLog(" CreateUser : ", $scope.User);
        //MyService.ConsoleLog(" address : ", $scope.address);
        // if ($scope.User && $scope.User.UserType == "voter") {
        // $scope.showAddressDropDowns("", $scope.locs);
        // } else {
        //   $scope.showAddressDropDowns($scope.User.ZipCode, "");
        // }
        // return;
        var postobj = $scope.generatePostUserObj();
        // console.log('welcome postobject', postobj);
        MyService.ConsoleLog("postobj: ", postobj);
        // return;
        if (postobj) {
          // $scope.RegisterButton = true;
          MyService.ConsoleLog("postData : ", postobj);
          MyService.signUp(postobj).then(
            function (response) {
              //MyService.ConsoleLog("response: ", response);
              $scope.RegisterButton = false;
              if (response.data.success == true) {
                var message = "";
                switch ($scope.UserType.toLowerCase()) {
                  case "politician":
                    message =
                      "It may take us some time to confirm your identity.  In the meantime, you can use the site, but everything you do will have the byline 'Unknown Politician.'  As soon as we confirm who you are, all your old posts will automatically switch to your real name.";
                    break;
                  case "voter":
                    message =
                      "Until you confirm your email, you can read and explore the site, but you won't be able to write responses.";
                    break;
                  case "press":
                    message =
                      "It may take us some time to confirm your identity.  In the meantime, you can use the site, but everything you do will have the byline 'Unknown Press.'  As soon as we confirm who you are, all your old posts will automatically switch to your real name.";
                    break;
                  case "advocate":
                    message =
                      "It may take us some time to confirm your identity.  In the meantime, you can use the site, but everything you do will have the byline 'Unknown Organization.'  As soon as we confirm who you are, all your old posts will automatically switch to your real name.";
                    break;
                }
                // growl.info(message);
                $cookies.put("showLongPopUp", message);
                var tempParam = {
                  username: $scope.User.UserName,
                  password: $scope.User.Password,
                };
                //MyService.ConsoleLog("tempParam>>",tempParam);
                // $rootScope.AuthenticateUser(tempParam);
                $timeout(function () {
                  $rootScope.AuthenticateUser(tempParam, "signup");
                }, 2000);
              } else if (
                response.data.error &&
                typeof response.data.error == "string"
              ) {
                growl.error("Error: " + response.data.error);
              } else {
                growl.error("Something went wrong.");
              }
            },
            function (response) {
              //MyService.ConsoleLog("Signup response: ", response);
              $scope.RegisterButton = false;
              var validataionMsg = "";
              if (
                response.data &&
                response.data.error &&
                response.data.error.errors
              ) {
                var errors = response.data.error.errors;
                for (var k in errors) {
                  if (errors.hasOwnProperty(k)) {
                    //MyService.ConsoleLog(k);
                    var obj = errors[k];
                    if (obj.message !== undefined)
                      validataionMsg +=
                        obj.message.replace("Path", "") + "<br/>";
                  }
                }
                growl.error(validataionMsg);
              }
            }
          );
        }
      };

      $scope.userTypeChanged = function (type) {
        //MyService.ConsoleLog("type : " + type);
        $scope.UserType = type;
        console.log("check type", $scope.UserType);

        $scope.User.organization_name = "";
        $scope.User.organization = null;
        //MyService.ConsoleLog("user type : ", $scope.UserType);
        $("form").validationEngine();
        //MyService.ConsoleLog("validationEngine applied");
      };

      /*
      $scope.suggest_organization = function(term) {
        var q = term.toLowerCase().trim();
        //MyService.ConsoleLog("term: ",term);
        var deferred = $q.defer();

        var postdata = {
          max_records: 5,
          keyword: term,
          type: $scope.UserType.toLowerCase()
        };

        var request = apiCall.apiCall('GET', '/office/list', postdata);
        $http(
          request
        ).then(function successCallback(response) {
          //MyService.ConsoleLog("succss: ",response);
          if(response.data.success){
            angular.forEach(response.data.data, function(val, key){
              response.data.data[key].value = val.title;
              response.data.data[key].label = val.title;
            });
            //MyService.ConsoleLog("got org dtaa: ", response.data.data);
            deferred.resolve(response.data.data);
            // growl.success("Tagged successfully");
          }
          else
          deferred.resolve([]);
          // else{
          //   if(typeof response.data.error == "string")
          //       growl.error(response.data.error);
          //   else
          //       growl.error("Something went wrong");
          // }
        }, function errorCallback(response) {
          // growl.error("Something went wrong");
          deferred.resolve([]);
        });

        return deferred.promise;
      }
      */

      function getOrganisationData(term) {
        var q = term.toLowerCase().trim();
        MyService.ConsoleLog("term: ", term);

        var deferred = $q.defer();

        var postdata = {
          max_records: 5,
          keyword: term,
          type: $scope.UserType.toLowerCase(),
        };

        var request = apiCall.apiCall("GET", "/office/list", postdata);

        $http(request).then(
          function successCallback(response) {
            //MyService.ConsoleLog("succss: ", response);
            if (response.data.success) {
              var returnArr = [];
              angular.forEach(response.data.data, function (val, key) {
                MyService.ConsoleLog("value :", val.title);
                returnArr.push({
                  label: $sce.trustAsHtml(val.title),
                  value: val,
                });
              });
              //MyService.ConsoleLog(returnArr);
              deferred.resolve(returnArr);
              // growl.success("Tagged successfully");
            } else deferred.resolve([]);
            /*else{
              if(typeof response.data.error == "string")
              growl.error(response.data.error);
              else
              growl.error("Something went wrong");
            }*/
          },
          function errorCallback(response) {
            // growl.error("Something went wrong");
            deferred.resolve([]);
          }
        );

        return deferred.promise;
      }

      $scope.goToSignIn = function () {
        $location.path("/signin");
      };

      $scope.org_autocomplete_options = {
        suggest: getOrganisationData,
        on_select: function (selected) {
          MyService.ConsoleLog("selected: ", selected);
          $scope.selectedData = selected;
          $scope.HideOrgInfo = true;
          $scope.HideRegisterButton = true;
          $scope.HideNewRegisterButton = true;
          // $scope.User.organization_name = selected.label;
          $scope.User.organization_name = selected.value.title;
          $scope.User.outlet_name = selected.value.title;

          MyService.getPress(selected.value._id).then(
            function (APIResponse) {
              MyService.ConsoleLog("APIData", APIResponse);
              if (Array.isArray(APIResponse.userData.email)) {
                $scope.User.UserName = APIResponse.userData.email[0];
              } else {
                $scope.User.UserName = APIResponse.userData.email;
              }
            },
            function (err) {
              console.log("err :>> ", err);
            }
          );

          $scope.User.organization = selected;
          $scope.User.organization.web_url = selected.value.webUrl;
          if (selected.value.contactPerson.phoneNo) {
            $scope.User.organization.phone_no =
              selected.value.contactPerson.phoneNo;
          } else {
            $scope.User.organization.phone_no = selected.value.phoneNo;
          }

          $scope.User.name = selected.value.contactPerson.name;
          if (selected.value.contactPerson.position) {
            $scope.User.lastname = selected.value.contactPerson.position;
          }
          if (selected.value.contactPerson.position) {
            $scope.User.Email = selected.value.contactPerson.email;
          }
          $scope.User.ZipCode = selected.value.zipcode;

          if (selected.value.mailingAddress) {
            $scope.mailAdd = selected.value.mailingAddress;

            var apiKey = "AIzaSyD1oCVshO67SnASsVVvOoJiAQgl7PvOmxo";
            var addApi =
              "https://maps.googleapis.com/maps/api/geocode/json?address=" +
              selected.value.mailingAddress +
              "&key=" +
              apiKey +
              "";
            $http.get(addApi).then(function (respo) {
              MyService.ConsoleLog(
                "api data :",
                respo.data.results[0].geometry.location
              );
              if (
                respo.data.results[0].geometry.location.lat &&
                respo.data.results[0].geometry.location.lng
              ) {
                $scope.User.Address = selected.value.mailingAddress;

                $scope.latt = respo.data.results[0].geometry.location.lat;
                $scope.longg = respo.data.results[0].geometry.location.lng;
              }
            });
          }

          if (selected.value.address) {
            $scope.acounty = selected.value.address.county;
            MyService.ConsoleLog("county :", $scope.acounty);
            $scope.acountry = selected.value.address.country;
            $scope.acountySubdivision =
              selected.value.address.countySubdivision;
            $scope.aplace = selected.value.address.place;
            $scope.astatePostalCode = selected.value.address.statePostalCode;
          }
        },
        on_detach: function (current_value) {
          MyService.ConsoleLog("on_detach: ", current_value);
          MyService.ConsoleLog("  $scope.selectedData ", $scope.selectedData);
          // $scope.HideOrgInfo = true;
          // $scope.HideRegisterButton = true;
          // $scope.HideNewRegisterButton = true;
          if ($scope.selectedData != "") {
            $scope.User.orgType = $scope.selectedData.value.typeOfOrg;
          }

          /*try{
            if($scope.User.organization.label != current_value)
            $scope.User.organization = null;
          }
          catch(e){
            $scope.User.organization = null;
          }*/
          $scope.User.organization_name = current_value;
        },
      };

      $scope.political_office_options = {
        suggest: function (term) {
          // return $rootScope.suggest_organization(term, $scope.UserType)
          return $rootScope.suggestPoliticianOffice(term, $scope.UserType);
        },
        on_select: function (selected) {
          //MyService.ConsoleLog("selected: ", selected);
          // $scope.User.organization_name = selected.label;
          $scope.User.office = selected;
        },
        on_detach: function (current_value) {
          //MyService.ConsoleLog("on_detach: ", current_value);
          /*try{
            if($scope.User.organization.label != current_value)
            $scope.User.organization = null;
          }
          catch(e){
            $scope.User.organization = null;
          }*/
          $scope.User.office_name = current_value;
        },
      };

      $scope.political_curroffice_options = {
        suggest: function (term) {
          return $rootScope.suggestPoliticianOffice(term, $scope.UserType);
        },
        on_select: function (selected) {
          MyService.ConsoleLog("selected: ", selected);
          $scope.User.curoffice = selected;
        },
        on_detach: function (current_value) {
          //MyService.ConsoleLog("on_detach: ", current_value);
          /*try{
            if($scope.User.organization.label != current_value)
            $scope.User.organization = null;
          }
          catch(e){
            $scope.User.organization = null;
          }*/
          $scope.User.cur_office_name = current_value;
        },
      };

      $scope.org_jurisdiction_options = {
        suggest: function (term) {
          // return $rootScope.suggest_organization(term, $scope.UserType)
          return $rootScope.suggestJurisdiction(term);
        },
        on_select: function (selected) {
          //MyService.ConsoleLog("selected: ", selected);
          $scope.User.jurisdiction = selected;
        },
        on_detach: function (current_value) {
          //MyService.ConsoleLog("on_detach: ", current_value);
          /*try{
            if($scope.User.organization.label != current_value)
            $scope.User.organization = null;
          }
          catch(e){
            $scope.User.organization = null;
          }*/
          $scope.User.jurisdiction_name = current_value;
        },
      };

      $scope.oldaddress = {
        state: "",
        county: "",
        countySubdivision: "",
        place: "",
      };

      $scope.getAllStates = function () {
        if ($scope.counties) $scope.counties.length = 0;
        if ($scope.places) $scope.places.length = 0;

        var request = apiCall.apiCall("GET", "/user/getAllStates", {
          country: "",
        });
        $http(request).then(
          function successCallback(response) {
            //MyService.ConsoleLog("Got States: ", response);
            if (response.data.success) {
              $scope.states = response.data.data;
            } else {
              growl.error("Something went wrong.");
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
            growl.error("Something went wrong.");
          }
        );
      };
      $scope.getAllStates();

      var getCountiesCanceler = $q.defer();
      $scope.getCounties = function (lbl) {
        // MyService.ConsoleLog("$scope.User.cur_state: ", $scope.User.cur_state);
        //MyService.ConsoleLog($scope.oldaddress);
        // var state = {};
        // if (lbl == 'cur') state = $scope.User.cur_state;
        // else if (lbl == 'new') state.statePostalCode = $scope.oldaddress.state;
        // else state = JSON.parse($scope.User.sel_state);
        $scope.counties = "";
        var statePostalCode = "";

        if ($scope.stateFipsNw != "") {
          statePostalCode = $scope.stateFipsNw;
        }
        //MyService.ConsoleLog("state: ", state);

        getCountiesCanceler.resolve();
        // if ($scope.places) $scope.counties = [];

        var request = apiCall.apiCall("POST", "/user/getAllCounties", {
          statePostalCode: statePostalCode,
          timeout: getCountiesCanceler.promise,
        });
        $http(request).then(
          function successCallback(response) {
            if (response.data.success) {
              MyService.ConsoleLog("county", response.data.data);
              $scope.counties = response.data.data;
              // if (lbl == 'new') {
              if ($scope.User.cur_level == "Local") {
                $scope.countyone = true;
                $scope.showLoader = false;
              }

              // if ($scope.User.cur_level == "Other") {
              //   $scope.countyone = true;
              //   $scope.showLoader = false;
              // }

              if ($scope.User.cur_level == "County") {
                $scope.countyone = true;
                $scope.showcur_office_nameDrop = true;
                $scope.showLoader = false;
              }

              // alert('counties');
              // $scope.address.county = address.county;
              var county = $scope.checkCounty(
                $scope.counties,
                $scope.oldaddress.county
              );
              MyService.ConsoleLog("county<><", county);
              $scope.address.county = county[0];
              // }
            } else {
              growl.error("Something went wrong.");
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
          }
        );
      };

      /*
       * this function Fetch all data of sub counties and cities
       **/

      $scope.getSubCounties = function () {
        $scope.arr = [];
        $scope.dis = false;
        $scope.stateSenate = false;
        $scope.stateHouse = false;
        $scope.federalCong = false;
        // $scope.countyone = false;
        $scope.cityone = false;
        $scope.school = false;
        $scope.federalCongrassionalDist = "";
        $scope.unifiedSchoolDistrictNames = "";
        $scope.stateHouseOFRepresentativeDistricts = "";
        $scope.stateSenateDistrict = "";
        $scope.allsubcounty = "";
        $scope.places = "";
        $scope.address.stateSenateDistrict = "";
        $scope.address.federalCongrassionalDist = "";
        $scope.address.stateHouseOFRepresentativeDistrict = "";
        $scope.address.unifiedSchoolDistrictName = "";

        MyService.ConsoleLog("$scope.state >>>", $scope.User.cur_state);
        MyService.ConsoleLog("$scope.County >>>", $scope.address.county);
        if (
          $scope.User.cur_level == "Local" ||
          $scope.User.cur_level == "Other"
        ) {
          $scope.showLoaderOne = true;
          // $scope.LoaderTwo = false;
        }
        if ($scope.User.cur_level != "County") {
          MyService.getPlacesAndSubCounty(
            $scope.User.cur_state.stateFips,
            $scope.address.county.countyFips,
            $scope.User.cur_state.state
          ).then(
            function (response) {
              MyService.ConsoleLog("response >>", response);

              var sub = response.countySubdivision.filter(function (val) {
                var cmat = val.city.substring(val.city.length - 3);
                if (cmat != "CDP") {
                  return val;
                }
              });

              $scope.allsubcounty = sub;

              var plFil = response.places.filter(function (item) {
                // MyService.ConsoleLog('item', item);
                var smTxt = item.city.substring(item.city.length - 3);
                if (smTxt != "CDP") {
                  return item;
                  MyService.ConsoleLog("smTxt >>", smTxt);
                }
              });
              MyService.ConsoleLog("plFil >>", plFil);
              $scope.finArr = $scope.allsubcounty.concat(plFil);
              MyService.ConsoleLog("$scope.arr", $scope.finArr);
              var smpl = $scope.finArr.filter(function (vals, ind) {
                return (
                  ind ==
                  $scope.finArr.findIndex(function (ele) {
                    return JSON.stringify(ele) == JSON.stringify(vals);
                  })
                );
              });
              MyService.ConsoleLog("new filtered >>", smpl);

              $scope.places = smpl;
              $scope.cityone = true;
              if ($scope.User.cur_level == "Local") {
                $scope.showLoaderOne = false;

                // $scope.getFederal();
              }

              if ($scope.User.cur_level == "Other") {
                // $scope.showLoaderOne = true;
                // $scope.getFederal();
              }
            },
            function (error) {
              MyService.ConsoleLog("Error >>", error);
            }
          );
        }
        // if($scope.User.cur_state && $scope.address.county == "" ){
        //   alert('if');
        // }else{
        //   alert('else');

        // }
      };

      /**
       * Get Counties for the running for office
       */
      $scope.getRunningCounties = function () {
        // alert("first");
        // MyService.ConsoleLog("$scope.User.cur_state: ", $scope.User.cur_state)
        // MyService.ConsoleLog("old",$scope.oldaddress);

        var statePostalCode = "";

        if ($scope.User.state != "") {
          statePostalCode = $scope.User.state.stateFips;
        }

        // MyService.ConsoleLog("selected state", $scope.address.state);

        // MyService.ConsoleLog("lbl", lbl);

        MyService.ConsoleLog("statePostalCode", statePostalCode);

        var request = apiCall.apiCall("POST", "/user/getAllCounties", {
          statePostalCode: statePostalCode,
          timeout: getCountiesCanceler.promise,
        });
        $http(request).then(
          function successCallback(response) {
            if (response.data.success) {
              MyService.ConsoleLog("response", response.data.data);
              $scope.runCounties = response.data.data;
              console.log("$scope.alllcounties>>", $scope.runCounties);
              // if (lbl == "new") {
              if ($scope.User.level == "Local") {
                $scope.running_countyone = true;
                $scope.running_showLoader = false;
              }

              if ($scope.User.level == "Other") {
                $scope.running_countyone = true;
                $scope.running_showLoader = false;
              }

              if ($scope.User.level == "County") {
                $scope.running_countyone = true;
                $scope.shownew_office_nameDrop = true;
                $scope.running_showLoader = false;
              }

              // alert('counties');

              // }
            } else {
              growl.error("Something went wrong.");
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
          }
        );
      };

      /**
       * Get all sub counties and cities of the running for office
       */

      $scope.getRunningSubCounties = function () {
        MyService.ConsoleLog("$scope.state >>>", $scope.User.state);
        MyService.ConsoleLog("$scope.County >>>", $scope.User.state);
        $scope.running_stateSenate = false;
        $scope.running_stateHouse = false;
        $scope.running_federalCong = false;
        // $scope.running_countyone = false;
        $scope.running_cityone = false;
        $scope.running_school = false;
        $scope.running_showLoader = false;
        $scope.runFederalCongrassionalDist = "";
        $scope.runUnifiedSchoolDistrictNames = "";
        $scope.runStateHouseOFRepresentativeDistricts = "";
        $scope.runStateSenateDistrict = "";
        $scope.runPlaces = "";
        // $scope.runAddress.stateSenateDistrict = "";
        // $scope.runAddress.federalCongrassionalDist = "";
        // $scope.runAddress.stateHouseOFRepresentativeDistrict = "";
        // $scope.runAddress.unifiedSchoolDistrictName = "";
        if ($scope.User.level == "Local" || $scope.User.level == "Other") {
          $scope.running_showLoaderOne = true;
        }
        if ($scope.User.level != "County") {
          MyService.getPlacesAndSubCounty(
            $scope.User.state.stateFips,
            $scope.runAddress.county.countyFips,
            $scope.User.state.state
          ).then(
            function (response) {
              MyService.ConsoleLog("response >>", response);
              var subRun = response.countySubdivision.filter(function (val) {
                var cmatRun = val.city.substring(val.city.length - 3);
                if (cmatRun != "CDP") {
                  return val;
                  MyService.ConsoleLog("cmat >>", cmat);
                }
              });

              $scope.allsubcounty = subRun;

              var plFilRun = response.places.filter(function (item) {
                // MyService.ConsoleLog('item', item);
                var smTxtRun = item.city.substring(item.city.length - 3);
                if (smTxtRun != "CDP") {
                  return item;
                  MyService.ConsoleLog("smTxt >>", smTxt);
                }
              });
              // $scope.allsubcounty = ;
              var temArr = $scope.allsubcounty.concat(plFilRun);
              var finls = temArr.filter(function (vals, ind) {
                return (
                  ind ==
                  temArr.findIndex(function (ele) {
                    return JSON.stringify(ele) == JSON.stringify(vals);
                  })
                );
              });
              $scope.runPlaces = finls;
              if ($scope.User.level == "Local") {
                $scope.running_showLoaderOne = false;
                $scope.running_cityone = true;

                // $scope.getRunningFederal();
              }
              if ($scope.User.level == "Other") {
                // $scope.showLoaderOne = true;
                // $scope.getRunningFederal();
              }
            },
            function (error) {
              MyService.ConsoleLog("Error >>", error);
            }
          );
        }
      };

      var getLocalsCanceler = $q.defer();
      $scope.getLocals = function (lbl) {
        //MyService.ConsoleLog($scope.oldaddress);
        var state = {},
          county = {};

        if (lbl == "cur") {
          state = $scope.User.cur_state;
          county = JSON.parse($scope.User.cur_county);
        } else if (lbl == "new") {
          state.statePostalCode = $scope.oldaddress.state;
          county = $scope.oldaddress.county;
        } else {
          state = JSON.parse($scope.User.sel_state);
          county = JSON.parse($scope.User.sel_county);
        }

        //MyService.ConsoleLog("county : ", county);
        getLocalsCanceler.resolve();

        var request = apiCall.apiCall("POST", "/user/getPlacesAndSubCounty", {
          statePostalCode: state.statePostalCode,
          county: JSON.stringify(county),
          state: JSON.stringify($scope.curState),
        });
        $http(request).then(
          function successCallback(response) {
            if (response.data.success) {
              if (response.data.data) {
                MyService.ConsoleLog("places ", response.data.data);
                $scope.places = response.data.data;

                if (lbl == "new") {
                  var subcounty = $scope.checksubCounty(
                    $scope.places,
                    $scope.oldaddress.countySubdivision
                  );

                  var places = $scope.checkPlaces(
                    $scope.places,
                    $scope.oldaddress.place
                  );
                  //MyService.ConsoleLog("subcounty<><><", subcounty[0])
                  $scope.address.countySubdivision = subcounty[0];
                  $scope.address.place = places[0];
                }
              }
            } else {
              growl("Something went wrong.");
            }
          },
          function errorCallBack(response) {
            growl("Something went wrong.");
          }
        );
      };

      $scope.emptyOrNull = function (item) {
        return !(
          item._id.place === null ||
          item._id.place === "" ||
          item._id.place === " "
        );
      };

      $scope.$watch("User.isRunningForEle", function (newVal, oldVal) {
        //MyService.ConsoleLog("newVal: ", newVal, "oldVal: ", oldVal);
        if (newVal == 1) {
          if ($scope.User.cur_state) {
            //MyService.ConsoleLog("cur_state set");
            $scope.User.sel_state = $scope.User.cur_state;
          } else {
            //MyService.ConsoleLog("cur_state not set");
          }

          if ($scope.User.cur_office_name) {
            $scope.User.office_name = $scope.User.cur_office_name;
          }
          if ($scope.User.cur_jurisdiction_name) {
            $scope.User.jurisdiction_name = $scope.User.cur_jurisdiction_name;
          }

          if ($scope.User.cur_county)
            $scope.User.sel_county = $scope.User.cur_county;
          if ($scope.User.cur_place)
            $scope.User.sel_place = $scope.User.cur_place;

          //MyService.ConsoleLog("sel_state: ", $scope.User.sel_state);
        }
      });

      $rootScope.LoginWithFacebook = function () {
        var msg = "";
        if ($.fn.validateForceFully($("#signupform")) == true) {
          //MyService.ConsoleLog("all good: ", $rootScope.NewUserData);
          //MyService.ConsoleLog("User<><><><",$scope.User);
          if (!$scope.User.UserType || $scope.User.UserType == "") {
            msg = "Please select: What type of user are you?";
          }
          if (msg == "") {
            FB.login(
              function (response) {
                statusChangeCallback(response);
              },
              {
                scope: "public_profile,email",
              }
            );
          } else {
            alert(msg);
          }
        }
      };

      function statusChangeCallback(response) {
        MyService.ConsoleLog("response", response);
        if (response.status === "connected") {
          getUserInfo();
        } else if (response.status === "not_authorized") {
          growl.info("Please log " + "into this app.");
        } else {
          growl.error("Please log " + "into Facebook.");
        }
      }

      function getUserInfo() {
        FB.api(
          "/me",
          {
            fields: "first_name,last_name,email",
          },
          function (response) {
            MyService.ConsoleLog("response: ", response);
            if (response != undefined && response != null && response != "") {
              $scope.CreateFBUser(response);
            }
          }
        );
      }

      $scope.showZipLoader = false;
      $scope.showAddressDropDown = false;

      $scope.checkState = function (rdata, val) {
        return rdata.filter(function (rdata) {
          //MyService.ConsoleLog(rdata.statePostalCode + "==" + val);
          if (rdata.statePostalCode == val) return rdata;
        });
      };

      // $scope.checkCounty = function (rdata, val) {
      //   // MyService.ConsoleLog("s", rdata);
      //   // MyService.ConsoleLog("v", val);
      //   // return rdata.filter(function (rdata) {
      //   //   if (rdata.county == val) return rdata;
      //   // });

      // };

      $scope.checkCounty = function (rdata, val) {
        // MyService.ConsoleLog("County :", rdata);
        // MyService.ConsoleLog("County val :", val);
        var sdata = [];
        var len = rdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = rdata[i];
          var gdata = val.filter(function (obj) {
            if (
              rsdata.countyFips == obj.COUNTYFP &&
              rsdata.stateFips == obj.STATEFP
            ) {
              // MyService.ConsoleLog(rdata[i]);
              return rdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(rdata[i]) == -1) {
              sdata.push(rdata[i]);
            }
          }

          if (j == len) {
            // MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };

      $scope.checksubCounty = function (rdata, val) {
        return rdata.filter(function (rdata) {
          //MyService.ConsoleLog(rdata._id.countySubdivision + "==" + val);
          if (rdata._id.countySubdivision == val) return rdata;
        });
      };
      $scope.checkPlaces = function (prdata, val) {
        MyService.ConsoleLog("val > ", val);
        // return rdata.filter(function (rdata) {

        //   MyService.ConsoleLog(rdata.place + "==" + val);
        //   if (rdata.place == val) return rdata;
        // });

        var sdata = [];
        var len = prdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = prdata[i];
          var gdata = val.filter(function (obj) {
            // MyService.ConsoleLog(rsdata.place +"=="+ obj.NAME);
            if (rsdata.place == obj.NAME && !rsdata.countyFips) {
              // MyService.ConsoleLog(rdata[i]);
              return prdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(prdata[i]) == -1) {
              sdata.push(prdata[i]);
            }
          }

          if (j == len) {
            // MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };
      $scope.detectCode = function (event, zip) {
        //MyService.ConsoleLog(event);
        //MyService.ConsoleLog("keycode : ",event.key);
        if (event.keyCode == 9 && event.key == "Tab") {
          $scope.showAddressDropDowns(zip, $scope.locs);
          $(this).blur();
        }
        if (event.keyCode == 13 && event.key == "Enter") {
          $scope.showAddressDropDowns(zip, $scope.locs);
          $(this).blur();
        }
      };
      $scope.mainAddress = "";
      $scope.showAddressDropDowns = function (zipcode, cooridinates) {
        MyService.ConsoleLog("cooridinates >> ", cooridinates);
        $scope.showZipLoader = true;
        var deferred = $q.defer();
        var addParams;
        if (cooridinates && cooridinates != "") {
          addParams = {
            loc: cooridinates,
            candidate: true,
          };
        } else {
          addParams = {
            zipcode: zipcode,
          };
        }
        MyService.ConsoleLog("addParams > ", addParams);

        MyService.getOrganizedZipData(addParams).then(
          function (payload) {
            MyService.ConsoleLog("payload", payload);
            // if (payload.length > 0) {
            // var finalData = payload.data;
            //MyService.ConsoleLog(payload[0].countySubdivision);
            //MyService.ConsoleLog(payload[0].county);
            //MyService.ConsoleLog(payload[0].place);
            $scope.mainAddress = payload;
            $scope.showZipLoader = false;
            $scope.showAddressDropDown = false;
            $scope.oldaddress.state = payload.state[0]
              ? payload.state[0].STUSPS
              : "";
            $scope.curState = payload.state;
            $scope.stateFipsNw = payload.state[0]
              ? payload.state[0].STATEFP
              : "";
            $scope.oldaddress.county = payload.county;
            $scope.oldaddress.countySubdivision = payload.countySubdivision
              ? payload.countySubdivision[0]
              : "";
            $scope.oldaddress.places = payload.places;
            $scope.getCounties("new");

            $scope.getSubCountiesData("new");

            $scope.voterDistricts = payload;
            // $scope.federalCongrassionalDist = payload;
            // $scope.stateSenateDistrict = payload;
            // $scope.stateHouseOFRepresentativeDistricts = payload;
            // $scope.unifiedSchoolDistrictNames = payload;
            $scope.federalCongrassionalDist = payload.congressionalDistrict;
            MyService.ConsoleLog(
              "@@@@@@ drop :",
              $scope.federalCongrassionalDist
            );

            $scope.stateSenateDistrict = payload.stateSenateDistrict;
            $scope.stateHouseOFRepresentativeDistricts =
              payload.stateHouseofRepresentativesDistrict;
            $scope.unifiedSchoolDistrictNames = payload.unifiedSchoolDistrict;
            $scope.cityCouncilDistrictName = payload.cityCouncilDistrict
              ? payload.cityCouncilDistrict
              : [];
            //$scope.$apply();
            var address = $scope.checkState(
              $scope.states,
              payload.state[0].STUSPS
            );
            $scope.address.state = address[0];
            $scope.address.voterDistrict = $scope.voterDistricts[0];
            $scope.address.federalCongrassionalDist =
              $scope.federalCongrassionalDist[0];
            $scope.address.stateSenateDistrict = $scope.stateSenateDistrict[0];
            $scope.address.stateHouseOFRepresentativeDistrict =
              $scope.stateHouseOFRepresentativeDistricts[0];
            $scope.address.unifiedSchoolDistrictName =
              $scope.unifiedSchoolDistrictNames[0];
            if (
              $scope.cityCouncilDistrictName &&
              $scope.cityCouncilDistrictName.length > 0
            ) {
              $scope.address.cityCouncilDistrictName =
                $scope.cityCouncilDistrictName[0];
            }
            // MyService.ConsoleLog("address>> ", $scope.address);
            deferred.resolve();
            //MyService.ConsoleLog("address ; ", address);
            // }
          },
          function (errorPayload) {
            $scope.showZipLoader = false;
            growl.error(errorPayload);
            deferred.resolve();
          }
        );
        return deferred.promise;
      };

      $scope.MyPlaces = [];
      $scope.getSubCountiesData = function (lbl) {
        //MyService.ConsoleLog($scope.Location.state);
        //MyService.ConsoleLog($scope.Location.county);
        // var county = $scope.Location.county;

        $scope.MyPlaces.length = 0;
        var county = "";
        var statePostalCode = "";
        $scope.MyPlaces.length = 0;
        var state = "";
        var county = "";
        if (lbl == "new") {
          state = JSON.stringify($scope.curState);
          county = JSON.stringify($scope.oldaddress.county);
        } else {
          statePostalCode = $scope.Location.state.statePostalCode;
          state = $scope.Location.state;
          county = county.county;
        }
        // MyService.ConsoleLog(statePostalCode + "===" + county);
        MyService.getAllSubCountiesLocal(statePostalCode, state, county).then(
          function (payload) {
            // payload = JSON.parse(payload);
            $scope.MyPlaces = payload;
            // MyService.ConsoleLog("PlaCE :", payload);
            // MyService.ConsoleLog(payload.countySubdivision);
            var subcounties = payload.countySubdivision;
            var places = payload.places;
            // MyService.ConsoleLog("PlaCE :", payload);
            if (lbl == "new") {
              // MyService.ConsoleLog("Places 1 > ",$scope.oldaddress.place);
              var subcounty = $scope.checksubCounty(
                subcounties,
                $scope.oldaddress.countySubdivision
              );
              var places = $scope.checkPlaces(places, $scope.oldaddress.places);
              // MyService.ConsoleLog("subcounty<><><", subcounty);
              // $scope.subcounties = subcounty;
              $scope.places = places;
              // console.log('***********', $scope.places);
              // $scope.Location.countySubdivision = subcounty[0];
              $scope.address.place = places[0];
            }
          },
          function (errorPayload) {
            growl.error("Something went wrong.");
          }
        );
      };
      // $rootScope.showFacebookLoging = false;
      $scope.showFbLogin = false;
      $scope.ShowFB = function () {
        // alert('test');
        $scope.forFacebook = false;
        $rootScope.showFacebookLoging = !$rootScope.showFacebookLoging;
        MyService.ConsoleLog("test new", $rootScope.showFacebookLoging);
        //if()
        //MyService.ConsoleLog("inside :", $rootScope.showFacebookLoging);
        // $scope.showFbLogin = true;
        // $scope.showFacebookLoging = true;

        // $scope.User.UserType = "Voter";

        // $location.hash('bottom');
        // $anchorScroll();
        //$location.hash('signupform');
        //$anchorScroll();
        //if($scope.showFacebookLoging) {
        // $timeout(function () {

        //   //MyService.ConsoleLog("inside after scroll :", $rootScope.showFacebookLoging);
        // }, 1500);

        // }
      };

      $scope.CreateFBUser = function (fbResponse) {
        MyService.ConsoleLog("CreateFBUser: ", fbResponse);
        MyService.ConsoleLog("  $scope.User.UserType: ", $scope.User.UserType);

        //MyService.ConsoleLog("organization_name: ", $rootScope.NewUserData.organization_name);
        $rootScope.Errors = [];

        $rootScope.FBSignIn(fbResponse, function () {
          if (fbResponse.email && fbResponse.email != "") {
            var postobj = $scope.generatePostUserObj();

            if (postobj) {
              //reset few fields for facebook login
              postobj.name = fbResponse.first_name + " " + fbResponse.last_name;
              postobj.username = fbResponse.email.split("@")[0];
              (postobj.password = ""), (postobj.email = fbResponse.email);
              postobj.isfacebooksigin = true;
              postobj.facebookid = fbResponse.id;
              postobj.verificationMethod = "Facebook";
              postobj.usertype = $scope.User.UserType;

              MyService.ConsoleLog("postobj: ", postobj);

              MyService.signUp(postobj).then(
                function (response) {
                  //MyService.ConsoleLog("response: ", response);
                  $scope.RegisterButton = false;
                  if (response.data.success == true) {
                    var message = "";
                    switch ($rootScope.NewUserData.usertype.toLowerCase()) {
                      case "politician":
                        message =
                          "It may take us some time to confirm your identity.  In the meantime, you can use the site, but everything you do will have the byline 'Unknown Politician.'  As soon as we confirm who you are, all your old posts will automatically switch to your real name.";
                        break;
                      case "voter":
                        message =
                          "Until you confirm your email, you can read and explore the site, but you won't be able to write responses.";
                        break;
                      case "press":
                        message =
                          "It may take us some time to confirm your identity.  In the meantime, you can use the site, but everything you do will have the byline 'Unknown Press.'  As soon as we confirm who you are, all your old posts will automatically switch to your real name.";
                        break;
                      case "advocate":
                        message =
                          "It may take us some time to confirm your identity.  In the meantime, you can use the site, but everything you do will have the byline 'Unknown Organization.'  As soon as we confirm who you are, all your old posts will automatically switch to your real name.";
                        break;
                    }
                    growl.success(message);
                    $rootScope.FBSignIn(fbResponse);
                    $location.path("debate");
                  } else if (
                    response.data.error &&
                    typeof response.data.error == "string"
                  ) {
                    growl.error("Error: " + response.data.error);
                  } else {
                    growl.error("Something went wrong.");
                  }
                },
                function (response) {
                  var validataionMsg = "";
                  //MyService.ConsoleLog("response: ", response)
                  var errors = response.data.error.errors;
                  for (var k in errors) {
                    if (errors.hasOwnProperty(k)) {
                      //MyService.ConsoleLog(k)
                      var obj = errors[k];
                      if (obj.message !== undefined)
                        validataionMsg +=
                          obj.message.replace("Path", "") + "<br/>";
                    }
                  }
                  growl.error(validataionMsg);
                }
              );
            } //if postobj
          } else {
            growl.error(
              "You haven't added email in your facebook account. Please add email in your facebook account then you can register using facebook."
            );
          }
        });
      };

      // Mellisa data start //
      $scope.findaddress = {
        address: "",
        city: "",
        state: "",
        zipcode: "",
      };
      $scope.result = {
        city: "",
      };

      $scope.checkLength = function (vdata, val) {
        var data = vdata.map(function (sub) {
          var returnval = "";
          switch (val) {
            case "federalCongrassionalDist":
              returnval = sub.federalCongrassionalDist;
              break;
            case "stateSenateDistrict":
              returnval = sub.stateSenateDistrict;
              break;
            case "stateHouseOFRepresentativeDistrict":
              returnval = sub.stateHouseOFRepresentativeDistrict;
              break;
            case "unifiedSchoolDistrictName":
              returnval = sub.unifiedSchoolDistrictName;
              break;
            case "default":
              returnval = sub.federalCongrassionalDist;
              break;
          }
          return returnval;
        });

        var ndata = $filter("unique")(data);
        if (ndata.length > 1) {
          return "yellowBackground";
        } else {
          return "";
        }
      };

      $scope.showFindAddress = function () {
        var q = {
          zipcode: $scope.User.ZipCode,
        };
        var addressModal = ngDialog.open({
          template: "app/popups/mellisa_data.html",
          scope: $scope,
          data: q,
        });
        $scope.findaddress.zipcode = $scope.User.ZipCode;
      };

      $scope.finddetailsclicked = false;
      $scope.getDetails = function (records) {
        var error = "";
        if ($scope.findaddress.address == "") {
          error = "Please enter address";
        }
        if (error == "" && $scope.findaddress.city == "") {
          error = "Please enter city";
        }
        if (error == "" && $scope.findaddress.state == "") {
          error = "Please enter state";
        }
        if (error == "" && $scope.findaddress.zipcode == "") {
          error = "Please enter zipcode";
        }

        if (error == "") {
          $scope.finddetailsclicked = true;
          //MyService.ConsoleLog("=============Address==============");
          //MyService.ConsoleLog($scope.findaddress);
          //MyService.ConsoleLog("findaddress<><><>", records);
          var aurl =
            "https://personator.melissadata.net/v3/WEB/ContactVerify/doContactVerify";
          aurl += "?id=RyMI8jlzD6dHUApvp_3XRP**";
          aurl += "&cols=GrpCensus,GrpCensus2,GrpGeocode";
          aurl += "&a1=" + records.address;
          aurl += "&city=" + records.city;
          aurl += "&state=" + records.state;
          aurl += "&postal=" + records.zipcode;
          aurl += "&ctry=US";
          aurl += "&format=JSON";
          // var deferred = $q.defer();
          //var furl = "https://personator.melissadata.net/v3/WEB/ContactVerify/doContactVerify?id=RyMI8jlzD6dHUApvp_3XRP**&cols=GrpCensus,GrpCensus2,GrpGeocode&a1=" + records.address + "&city=" + records.city + "&state=" + records.state + "&postal=" + records.zipcode + "&ctry=US&format=JSON";
          //MyService.ConsoleLog("furl <><>>", furl);
          $http.get(aurl).then(
            function successCallback(response) {
              //$scope.result = "";
              $scope.finddetailsclicked = false;
              if (response.statusText == "OK") {
                var rdata = response.data.Records[0];
                if (rdata) {
                  $scope.result = rdata;
                }
              }
              //MyService.ConsoleLog("response", response);
            },
            function errorCallBack(error) {
              $scope.finddetailsclicked = false;
              //MyService.ConsoleLog(error);
            }
          );
        } else {
          alert(error);
        }
      };
      // $scope.oldAddress = "";
      $scope.checkZipAddress = function (val) {
        // $scope.oldAddress = angular.copy($scope.mainAddress);
        return $scope.mainAddress.filter(function (rdata) {
          //MyService.ConsoleLog("Space:", parseInt(val.CongressionalDistrict));
          if (
            val.CongressionalDistrict == "" ||
            val.CongressionalDistrict == " "
          ) {
            //MyService.ConsoleLog("inside<><><><><>");

            if (
              parseInt(rdata.FIPScounty) == parseInt(val.CountyFIPS) &&
              parseInt(rdata.FIPScountySub) ==
                parseInt(val.CountySubdivisionCode) &&
              parseInt(rdata.stateHouseOFRepresentativeDistrict) ==
                parseInt(val.StateDistrictLower) &&
              parseInt(rdata.stateSenateDistrict) ==
                parseInt(val.StateDistrictUpper) &&
              parseInt(rdata.unifiedSchoolDistrict) ==
                parseInt(val.UnifiedSchoolDistrictCode)
            ) {
              //MyService.ConsoleLog("This is a match");
              return rdata;
            }
          } else {
            if (
              parseInt(rdata.FIPScounty) == parseInt(val.CountyFIPS) &&
              parseInt(rdata.FIPScountySub) ==
                parseInt(val.CountySubdivisionCode) &&
              parseInt(rdata.federalCongrassionalDist) ==
                parseInt(val.CongressionalDistrict) &&
              parseInt(rdata.stateHouseOFRepresentativeDistrict) ==
                parseInt(val.StateDistrictLower) &&
              parseInt(rdata.stateSenateDistrict) ==
                parseInt(val.StateDistrictUpper) &&
              parseInt(rdata.unifiedSchoolDistrict) ==
                parseInt(val.UnifiedSchoolDistrictCode)
            ) {
              //MyService.ConsoleLog("This is a match2");
              return rdata;
            }
          }
        });
      };

      $scope.setAddressNew = function () {
        //MyService.ConsoleLog($scope.result);
        var finalResult = $scope.checkZipAddress($scope.result);
        if (finalResult && finalResult.length > 0) {
          //MyService.ConsoleLog("finalResult::::", finalResult);
          // $scope.mainAddress = angular.copy(finalResult);
          $scope.voterDistricts = finalResult;
          $scope.federalCongrassionalDist = finalResult;
          $scope.stateSenateDistrict = finalResult;
          $scope.stateHouseOFRepresentativeDistricts = finalResult;
          $scope.unifiedSchoolDistrictNames = finalResult;
          ngDialog.closeAll();
          // $scope.$apply();
        } else {
          alert(
            "Address not matching with our database. Please enter detail address and try again."
          );
        }
      };

      var previousSelVal = {};
      $scope.setSelectedDropdown = function (
        listData,
        setfor,
        selectedUserAdrs
      ) {
        switch (setfor) {
          case "counties":
            previousSelVal.county = $scope.address.county;
            //MyService.ConsoleLog("selCountyNumber: ",previousSelVal.county);
            $scope.address.county = null;
            if (listData) {
              $scope.counties = listData;
              $scope.counties.unshift({
                number: null,
                name: "none",
              });

              // if(!selectedUserAdrs) selectedUserAdrs.countyFips = previousSelVal.county.number;
              var selCountyNumber = null;
              try {
                $scope.address.county = $scope.counties[0];
                if (selectedUserAdrs) {
                  selCountyNumber = selectedUserAdrs.countyFips;
                }
                if (previousSelVal.county) {
                  selCountyNumber = previousSelVal.county.number;
                }

                if (selCountyNumber) {
                  //MyService.ConsoleLog("selCountyNumber: ",selCountyNumber);
                  angular.forEach($scope.counties, function (val, key) {
                    if (selCountyNumber == val.number)
                      $scope.address.county = val;
                  });
                }
              } catch (e) {
                //MyService.ConsoleLog("Exception: ",e);
              }
            }
            break;
          case "subCounties":
            previousSelVal.subcounty = $scope.address.subcounty;
            $scope.address.subcounty = null;
            if (listData) {
              $scope.subCounties = listData;
              $scope.subCounties.unshift({
                number: null,
                name: "none",
              });
              var selSubCountyNo = null;
              try {
                $scope.address.subcounty = $scope.subCounties[0];
                if (selectedUserAdrs) {
                  selSubCountyNo = selectedUserAdrs.countySubdivisionFips;
                }
                if (previousSelVal.subcounty) {
                  selSubCountyNo = previousSelVal.subcounty.number;
                }
                if (selSubCountyNo) {
                  angular.forEach($scope.subCounties, function (val, key) {
                    //set selected state
                    // if(selectedUserAdrs.countySubdivisionFips == val.number)
                    if (selSubCountyNo == val.number)
                      $scope.address.subcounty = val;
                  });
                }
              } catch (e) {
                //MyService.ConsoleLog("Exception: ",e);
              }
            }
            break;
          case "places":
            previousSelVal.place = $scope.address.place;
            $scope.address.place = null;
            if (listData) {
              $scope.places = listData;
              $scope.places.unshift({
                number: null,
                name: "none",
              });

              try {
                $scope.address.place = $scope.places[0];
                var selPlaceNo = null;
                if (selectedUserAdrs) {
                  selPlaceNo = selectedUserAdrs.placeFips;
                }
                if (previousSelVal.place) {
                  selPlaceNo = previousSelVal.place.number;
                }
                if (selPlaceNo) {
                  angular.forEach($scope.places, function (val, key) {
                    if (selPlaceNo == val.number) $scope.address.place = val;
                  });
                }
              } catch (e) {
                //MyService.ConsoleLog("Exception: ",e);
              }
            }
            break;
          case "voterDistricts":
            if (listData) {
              previousSelVal.voterDistrict = $scope.address.voterDistrict;
              $scope.address.voterDistrict = null;
              $scope.voterDistricts = listData;
              $scope.voterDistricts.unshift({
                number: null,
                name: "none",
              });

              var voterDistrictNo = null;
              try {
                $scope.address.voterDistrict = $scope.voterDistricts[0];
                if (selectedUserAdrs) {
                  voterDistrictNo = selectedUserAdrs.voterDistrictFips;
                }
                if (previousSelVal.voterDistrict) {
                  voterDistrictNo = previousSelVal.voterDistrict.number;
                }

                if (voterDistrictNo) {
                  angular.forEach($scope.voterDistricts, function (val, key) {
                    //set selected
                    if (voterDistrictNo == val.number)
                      $scope.address.voterDistrict = val;
                  });
                }
              } catch (e) {
                //MyService.ConsoleLog("Exception: ",e);
              }
            }
            break;
          case "federalCongrassionalDist":
            $scope.address.federalCongrassionalDist = null;
            if (listData) {
              $scope.federalCongrassionalDist = listData;
              $scope.federalCongrassionalDist.unshift("none");

              if (selectedUserAdrs) {
                $scope.address.federalCongrassionalDist =
                  $scope.federalCongrassionalDist[0];
                angular.forEach(
                  $scope.federalCongrassionalDist,
                  function (val, key) {
                    //set selected state
                    if (selectedUserAdrs.federalCongrassionalDist == val)
                      $scope.address.federalCongrassionalDist = val;
                  }
                );
              }
            }
            break;
          case "stateSenateDistrict":
            $scope.address.stateSenateDistrict = null;
            if (listData) {
              $scope.stateSenateDistrict = listData;
              $scope.stateSenateDistrict.unshift("none");

              $scope.address.stateSenateDistrict =
                $scope.stateSenateDistrict[0];
              if (selectedUserAdrs) {
                angular.forEach(
                  $scope.stateSenateDistrict,
                  function (val, key) {
                    //set selected state
                    if (selectedUserAdrs.stateSenateDistrict == val)
                      $scope.address.stateSenateDistrict = val;
                  }
                );
              }
            }
            break;
          case "stateHouseOFRepresentativeDistrict":
            $scope.address.stateLegislativeDistrict = null;
            if (listData) {
              $scope.stateLegislativeDistrict = listData;
              $scope.stateLegislativeDistrict.unshift("none");
              $scope.address.stateLegislativeDistrict =
                $scope.stateLegislativeDistrict[0];
              if (selectedUserAdrs) {
                angular.forEach(
                  $scope.stateLegislativeDistrict,
                  function (val, key) {
                    //set selected state
                    if (selectedUserAdrs.legislativeDistrict == val)
                      $scope.address.stateLegislativeDistrict = val;
                  }
                );
              }
            }
            break;
          case "schoolDistricts":
            $scope.address.schoolDistrict = null;
            if (listData) {
              $scope.schoolDistricts = listData;
              $scope.schoolDistricts.unshift({
                number: null,
                name: "none",
              });
              $scope.address.schoolDistricts = $scope.schoolDistricts[0];
              if (selectedUserAdrs) {
                angular.forEach($scope.schoolDistricts, function (val, key) {
                  //set selected state
                  if (selectedUserAdrs.schoolDistrictFips == val.number)
                    $scope.address.schoolDistrict = val;
                });
              }
            }
            break;
        }
      };

      // $scope.onVoterDistChange = function() {
      //   //MyService.ConsoleLog("** onVoterDistChange **");
      //   try {
      //     var postobj = {};
      //     $scope.statusVoterDistSearch = 1;
      //     postobj.zipcode = $scope.User.ZipCode;
      //     //MyService.ConsoleLog("address<><><",$scope.address)
      //     if ($scope.address.voterDistrict && $scope.address.voterDistrict.voterDistrictName.toLowerCase() != "none") {
      //       postobj.voterDistrictName = $scope.address.voterDistrict.voterDistrictName;
      //       //MyService.ConsoleLog("postobj: ", postobj);
      //       MyService.getfilterAddressData(postobj).then(function(response) {
      //         //MyService.ConsoleLog("Got zip data: ", response);
      //         if (response.data.success) {
      //           var payload = response.data.data;

      //           $scope.mainAddress = payload;
      //           $scope.showZipLoader = false;
      //           $scope.showAddressDropDown = true;
      //           $scope.oldaddress.state = payload[0].statePostalCode;
      //           $scope.oldaddress.county = payload[0].county;
      //           $scope.oldaddress.countySubdivision = payload[0].countySubdivision;
      //           $scope.oldaddress.place = payload[0].place;
      //           $scope.getCounties("new");

      //           $scope.getLocals("new");

      //           $scope.voterDistricts = payload;
      //           $scope.federalCongrassionalDist = payload;
      //           $scope.stateSenateDistrict = payload;
      //           $scope.stateHouseOFRepresentativeDistricts = payload;
      //           $scope.unifiedSchoolDistrictNames = payload;
      //           //$scope.$apply();
      //           var address = $scope.checkState($scope.states, payload[0].statePostalCode);
      //           $scope.address.state = address[0];
      //           $scope.address.voterDistrict.length = 0;
      //           $scope.address.voterDistrict = $scope.voterDistricts[0];
      //           $scope.address.voterDistrict.unshift({
      //             number: null,
      //             voterDistrictName: "none"
      //           });
      //           $scope.address.federalCongrassionalDist = $scope.federalCongrassionalDist[0];
      //           $scope.address.stateSenateDistrict = $scope.stateSenateDistrict[0];
      //           $scope.address.stateHouseOFRepresentativeDistrict = $scope.stateHouseOFRepresentativeDistricts[0];
      //           $scope.address.unifiedSchoolDistrictName = $scope.unifiedSchoolDistrictNames[0];
      //           $scope.statusVoterDistSearch = 2;
      //         } else if (response.data.error && typeof response.data.error == "string") {
      //           growl.error('Error: ' + response.data.error);
      //           $scope.statusVoterDistSearch = 2;
      //         } else {
      //           growl.error('Something went wrong.');
      //           $scope.statusVoterDistSearch = 3;
      //         }
      //       }, function(err) {
      //         growl.error('Something went wrong.');
      //         $scope.statusVoterDistSearch = 3;
      //       });
      //     }
      //   } catch (e) {
      //     //MyService.ConsoleLog("Exception : ",e);
      //   }
      // };

      // Mellisa data end //

      $scope.UserLogin = function () {
        // alert($scope.User.isRunningForEle);
        $scope.flag = false;
        if ($filter("isBlankString")($scope.User.isInCurrentOffice)) {
          if ($scope.flag == false) {
            growl.error("Please answer: Are you currently in Office?");
            $scope.flag = true;
          }
        }
        if ($filter("isBlankString")($scope.User.isRunningForEle)) {
          if ($scope.flag == false) {
            growl.error(
              "Please answer: Are you running for office this coming election?"
            );
            $scope.flag = true;
          }
        }

        if ($.fn.validateForceFully($("#signupform")) == true) {
          if ($scope.flag == false) {
            // alert("Can submit data");
            //MyService.ConsoleLog($scope.User);
            var data = JSON.stringify($scope.User);
            MyService.registerLogin({
              data: data,
            }).then(
              function (payload) {
                //MyService.ConsoleLog(payload.data.data);
                if (payload.data.success == true) {
                  //MyService.ConsoleLog(payload.data.data);
                  $rootScope.initAuthorizedUser(payload.data.data, "signup");
                  $rootScope.statusAuthenticate = 2;
                } else {
                  $rootScope.statusAuthenticate = 3;
                  growl.error(
                    "Invalid Username or Password. Please try again."
                  );
                }
              },
              function (errorPayload) {}
            );
          }
        }
      };

      /**
       * Login with org
       */
      $scope.OrgLogin = function () {
        // alert($scope.User.isRunningForEle);
        $scope.flag = false;
        if ($filter("isBlankString")($scope.User.UserName)) {
          if ($scope.flag == false) {
            growl.error("Enter user name?");
            $scope.flag = true;
          }
        }

        if ($.fn.validateForceFully($("#signupform")) == true) {
          if ($scope.flag == false) {
            // alert("Can submit data");
            //MyService.ConsoleLog($scope.User);
            var data = JSON.stringify($scope.User);
            MyService.registerWithOrgs({
              data: data,
            }).then(
              function (payload) {
                MyService.ConsoleLog("payload.data.data", payload);
                if (payload.data.success == true) {
                  MyService.ConsoleLog("inside", payload.data);
                  $rootScope.initAuthorizedUser(payload.data, "signup");
                  $rootScope.statusAuthenticate = 2;
                } else {
                  $rootScope.statusAuthenticate = 3;
                  growl.error(
                    "Invalid Username or Password. Please try again."
                  );
                }
              },
              function (errorPayload) {}
            );
          }
        }
      };

      if ($scope.UserType == "voter" || $scope.UserType == "politician") {
        $(document).ready(function () {
          $("#signupform").validationEngine();
        });
      }
    },
  ]);

'use strict';
angular.module('myApp.signup')

//.config(['$routeProvider', function ($routeProvider) {
//    $routeProvider.when('/verify/:id', {
//        templateUrl: 'signup/verify.html',
//        controller: 'verifyCtrl'
//    });
//}])

.controller('verifyCtrl', ['$scope', '$http', '$location', 'baseApiUrl', 'growl', '$routeParams', 'tokenService', '$rootScope', function($scope, $http, $location, baseApiUrl, growl, $routeParams, tokenService, $rootScope) {

    $scope.encrypted = $routeParams.id;
    $scope.Show = false;
    $scope.Error = false;
    $scope.userData = "";
    if (tokenService.getUserData()) {
        $scope.userData = JSON.parse(tokenService.getUserData());
    }
//console.log($scope.userData);
    $scope.verify = function() {
        $http.post(baseApiUrl + '/user/verify', {
            salt: $scope.encrypted
        }).then(function(res) {
            if (res.data.success == true) {
                $scope.Show = true;
                if ($scope.userData) {
                    $scope.userData.isemailverified = true;
                    tokenService.saveUserData(JSON.stringify($scope.userData));
                }

                $scope.Error = false;
            } else {
                $scope.Error = true;
            }
        });
    };

    $scope.verify();
}]);

'use strict';
angular
  .module('myApp.signin', ['ngRoute'])
  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/signin', {
        templateUrl: 'app/signin/signin.html',
        controller: 'signinCtrl',
      });
    },
  ])

  .controller('signinCtrl', [
    '$scope',
    '$http',
    '$location',
    'growl',
    'tokenService',
    'baseApiUrl',
    '$rootScope',
    'MyService',
    function ($scope, $http, $location, growl, tokenService, baseApiUrl, $rootScope, MyService) {
      $scope.UserName = '';
      $scope.Password = '';
      $rootScope.welcome = false;
      $scope.showPasswordReset = false;
      $scope.showDrop = false;
      $scope.User = {
        uName: ""
      };

      $scope.AuthenticateUser = function () {
        console.log('AuthenticateUser');

        if ($.fn.validateForceFully($('#signInform')) == true) {
          /*$http.post(baseApiUrl + '/user/authenticate', {
              username: $scope.UserName,
              password: $scope.Password
          })
          .then(function (response) {
              if (response.data.success == true) {
                  //MyService.ConsoleLog("Login Data");
                  //MyService.ConsoleLog(response.data);
                  tokenService.saveToken(response.data.token);
                  tokenService.saveUserName(response.data.name);
                  tokenService.saveUserId(response.data.id);
                  tokenService.saveUserRole(response.data);
                   var userData = {
                      id: response.data.id,
                      lastLogin: response.data.lastLogin,
                      uname: $scope.UserName,
                      name: response.name
                   };
                  tokenService.saveUserData(JSON.stringify(userData));


                  $http.defaults.headers.common['x-access-token'] = tokenService.getToken();
                  $rootScope.Auth = true;
                  $rootScope.User = tokenService.getUserName();
                  $rootScope.UserId = tokenService.getUserId();
                  $location.path('debateHome');
                  $rootScope.getCategories();
              }
              else {
                  growl.error('Invalid Username or Password. Please try again.');
              }
          }, function (response) {
              var validataionMsg = "";
              var errors = response.data.error.errors;
              for (var k in errors) {
                  if (errors.hasOwnProperty(k)) {
                      //MyService.ConsoleLog(k)
                      var obj = errors[k];
                      if (obj.message !== undefined)
                          validataionMsg += obj.message.replace('Path', '') + "<br/>";
                  }
              }
              growl.error(validataionMsg);
          });*/

          var postobj = {
            username: $scope.UserName,
            password: $scope.Password,
          };
          $rootScope.AuthenticateUser(postobj, 'signin');
          // alert('login');
        }
      };

      /**
       * This function called when input box loses focus.
       * function search users with same email address
       */
      $scope.detectEmail = function () {
        MyService.ConsoleLog("forgotEmail", $scope.forgotEmail);
        var postobj = {};
        postobj.email = $scope.forgotEmail;
        MyService.checkEmailForMultiUsers(postobj).then(function (result) {
          if (result) {
            MyService.ConsoleLog("Result", result);
            if (result.data.data.length > 1) {
              MyService.ConsoleLog("IFFFFFFFFFFFFFFFF");
              $scope.showDrop = true;
              $scope.dropData = result.data.data;
              MyService.ConsoleLog("$scope.uName", $scope.uName);
              if ($scope.uName && $scope.uName != "") {

                alert($scope.uName);
              }
            }
          }

        }, function (err) {
          MyService.ConsoleLog("Error", err);
        });
      };

      $scope.requestPasswordReset = function () {
        if ($.fn.validateForceFully($('#forgotPassForm')) == true) {
          var postobj = {
            email: $scope.forgotEmail,
            reset_url: $rootScope.getPasswordResetUrl(),
            checkName: $scope.User.uName ? $scope.User.uName.name : ""
          };
          MyService.ConsoleLog("$scope.uName", $scope.User.uName.name);

          MyService.forgotPassword(postobj).then(
            function (response) {
              MyService.ConsoleLog(response);
              if (response.data.success) {
                growl.success('An email has been sent.');
              } else {
                if (typeof response.data.error == 'string') growl.error(response.data.error);
                else growl.error('Something went wrong');
              }
            },
            function (err) {
              growl.error('Something went wrong');
            }
          );
        }
      };

      $(document).ready(function () {
        console.log('onready');
        $('#signInform').validationEngine();
        $('#forgotPassForm').validationEngine();
      });
    },
  ]);

'use strict';
angular
  .module('myApp.showPopUp', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/showPopUp', {
        templateUrl: 'app/showPopUp/showPopUp.html',
        controller: 'showPopUpCtrl',
      });
    },
  ])
  .controller('showPopUpCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    '$routeParams',
    '$q',
    'ngDialog',
    '$rootScope',
    'growl',
    'MyService',
    '$anchorScroll',
    '$timeout',
    'tokenService',
    '$cookies',
    'baseApiUrl',
    '$document',
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $q,
      ngDialog,
      $rootScope,
      growl,
      MyService,
      $anchorScroll,
      $timeout,
      tokenService,
      $cookies,
      baseApiUrl,
      $document
    ) {

      /**
       * Show pop up on the page load
       */

      var message = "Are you already a member of VoteWise with this email address?";
      var modal = ngDialog.openConfirm({
        template: '<p>' + message + '</p>\
                <div class="ngdialog-buttons">\
                    <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(0)">No</button>\
                    <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Yes</button>\
                    \
                </div>',
        plain: true
      });

      modal.then(function fullfilled(data) {
        ////MyService.ConsoleLog("fullfilled: ", data);
        if (data == 1) {
          $location.path('/signin');
        } else {
          $location.path('/signup/voter');
        }
      }, function rejected(data) {
        ////MyService.ConsoleLog("rejected: ", data);
      });
    }

  ]);

'use strict';
angular
  .module('myApp.showPoliQuiz', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/showPoliQuiz/:quizName?/:orgId?', {
        templateUrl: 'app/showPoliQuiz/showPoliQuiz.html',
        controller: 'showPoliQuizCtrl',
      });
    },
  ])
  .controller('showPoliQuizCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    '$routeParams',
    '$q',
    'ngDialog',
    '$rootScope',
    'growl',
    'MyService',
    '$anchorScroll',
    '$timeout',
    'tokenService',
    '$cookies',
    'baseApiUrl',
    '$document',
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $q,
      ngDialog,
      $rootScope,
      growl,
      MyService,
      $anchorScroll,
      $timeout,
      tokenService,
      $cookies,
      baseApiUrl,
      $document
    ) {

      $scope.quizName = $routeParams.quizName;
      $scope.orgId = $routeParams.orgId;
      MyService.ConsoleLog("this is new page", $scope.orgId);

      /**
       * get Quiz questions count
       */
      $scope.getQueCount = function () {
        MyService.getQuesCount({
          quizName: $scope.quizName,
          orgId: $scope.orgId,
          curtUId: tokenService.getUserId()
        }).then(function (response) {
          MyService.ConsoleLog("Response", response);
          $scope.totalQues = response.data.data.totalQuestions;
          $scope.ansQues = response.data.data.answeredQuestions;
          $scope.orgName = response.data.data.orgName;
        }, function (err) {
          MyService.ConsoleLog("Error", err);
        });
      };

      $scope.getQueCount();

      /**
       * Redirect to the quiz
       */
      $scope.getQuiz = function () {

        $location.path('/organizationQuiz/' + $scope.quizName + "/" + $scope.orgId);
      };
    }
  ]);

'use strict';

angular.module('myApp.showListOfMatch', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/showListOfMatch/:type?', {
      templateUrl: 'app/showListOfMatch/showListOfMatch.html',
      controller: 'showListOfMatchCtrl'
    });
  }]).controller('showListOfMatchCtrl', ['$scope', 'apiCall', 'MyService', '$location', '$anchorScroll', '$timeout', '$rootScope', 'ngDialog', '$q', '$http', '$filter', 'growl', '$routeParams', 'baseApiUrl', 'tokenService', '$cookies', function ($scope, apiCall, MyService, $location, $anchorScroll, $timeout, $rootScope, ngDialog, $q, $http, $filter, growl, $routeParams, baseApiUrl, tokenService, $cookies) {

    /**
     * @description Get Paramters using $routeParams.
     */
    $scope.uType = $routeParams.type;
    $scope.loader = false;
    MyService.ConsoleLog("$routeParams", $scope.uType);

    if ($cookies.get('QuizName')) {
      console.log("$cookies.get('QuizName')", $cookies.get('QuizName'));
      $scope.quizTitle = $cookies.get('QuizName');
    }

    /**
     * @description Get List of Individual Match
     */
    $scope.getIndividualMatchList = function (para) {
      $scope.loader = true;
      MyService.ConsoleLog("params", para);
      para.usersIds = JSON.stringify(para.usersIds);

      para.type = $scope.uType;

      MyService.getIndividualMatchList(para).then(function (response) {
        MyService.ConsoleLog("response", response);
        $scope.loader = false;
        $scope.questions = response.data.data.qdata;
        $scope.FBCompareList = response.data.data.qdata;

        if ($scope.FBCompareList && $scope.FBCompareList.length > 0) {
          $scope.FBunWeighted = response.data.data.unweightedMatch;
          $scope.fbcombinedWeight = response.data.data.fbcombinedWeight;
          $scope.fbmultiplier = response.data.data.fbmultiplier;
          $scope.answeredQuestions = response.data.data.answeredQuestions;
          $scope.fbqlen = response.data.data.qlen;
          $scope.AllUsers = response.data.data.AllUsers;
          $scope.orgNames = response.data.data.orgNames;
          //$scope.qData = response.data.data.answeredQuestions;
        }

      }, function (err) {
        MyService.ConsoleLog("Error", err);
      });

    };

    /**
     * @description Get Data from local storage and pass to the function.
     */

    if (window.localStorage.getItem('comData')) {

      $scope.parData = JSON.parse(window.localStorage.getItem('comData'));
      MyService.ConsoleLog("<<<<<<<<<<<< parData >>>>>>>>>>>", JSON.parse($scope.parData.questions));
      $scope.getIndividualMatchList($scope.parData);
    }





  }]);

'use strict';
angular
  .module('myApp.showPoliAns', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/showPoliticianAns/:quizName?/:poliId?/:email?', {
        templateUrl: 'app/showPoliAns/showPoliAns.html',
        controller: 'showPoliticiansAnsCtrl',
      });
    },
  ])
  .controller('showPoliticiansAnsCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    '$routeParams',
    '$q',
    'ngDialog',
    '$rootScope',
    'growl',
    'MyService',
    '$anchorScroll',
    '$timeout',
    'tokenService',
    '$cookies',
    'baseApiUrl',
    '$document',
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $q,
      ngDialog,
      $rootScope,
      growl,
      MyService,
      $anchorScroll,
      $timeout,
      tokenService,
      $cookies,
      baseApiUrl,
      $document
    ) {
      /**
       * Clear $cookies on page load
       */
      $scope.qName = $routeParams.quizName;
      $scope.poliId = $routeParams.poliId;
      $scope.uEmail = $routeParams.email;
      $cookies.remove('showLogin');
      $cookies.remove('qName');
      $cookies.remove('poliId');

      if (!tokenService.getUserId()) {
        // alert('one');
        $cookies.put('qName', $scope.qName);
        $cookies.put('poliId', $scope.poliId);
        $cookies.put('showLogin', 'true');
        $location.path('/signin');
      }

      /**
       * Get details of the solved quiz
       */

      $scope.getDetails = function () {

        MyService.getDetailsofQuiz({
          quizName: $scope.qName,
          poliId: $scope.poliId
        }).then(function (response) {
          MyService.ConsoleLog("Response", response);
          $scope.poliName = response.data.poliName;
          $scope.totalQuestions = response.data.totalQues;
          $scope.answerQues = response.data.ansQuestions;
        }, function (err) {
          MyService.ConsoleLog("Error", err);
        });
      };

      $scope.getDetails();

      /**
       * Show Answers of the politicians
       */

      $scope.getAnswers = function () {
        $location.path('/poliAnswers/' + $scope.qName + '/' + $scope.poliId);
      };

      /**
       * Get invited politicians info
       */
      $scope.getInfo = function () {

        MyService.getInfoOfInvited({
          orgId: tokenService.getUserId(),
          quizName: $scope.qName
        }).then(
          function (result) {
            MyService.ConsoleLog("Results", result);
            $scope.polData = result.data.data;
          },
          function (err) {
            MyService.ConsoleLog("Error", err);
          })
      };

      $scope.getInfo();

      /**
       * Redirect to the listing page
       */
      $scope.gotoList = function () {
        $location.path('/listOfFollowers/' + $scope.qName + '/' + $scope.poliId);
      };
    }
  ]);

'use strict';
angular.module('myApp.showMessage', ['ngRoute', 'angularPayments'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/showMessage', {
      templateUrl: 'app/showMessage/showMessage.html',
      controller: 'showMessageCtrl'
    });
  }])
  .controller('showMessageCtrl', ['$scope', '$rootScope', 'growl', 'ngDialog', 'tokenService', 'MyService', '$location', '$window', '$filter', '$http', function ($scope, $rootScope, growl, ngDialog, tokenService, MyService, $location, $window, $filter, $http) {

  }]);

'use strict';
angular.module('myApp.showMelisaData', ['ngRoute', 'angularPayments'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/showMelisaData/:pId?', {
      templateUrl: 'app/showMelisaData/showMelisaData.html',
      controller: 'showMelisaDataCtrl'
    });
  }])
  .controller('showMelisaDataCtrl', ['$scope', '$rootScope', 'growl', 'ngDialog', 'tokenService', 'MyService', '$location', '$window', '$filter', '$http', '$routeParams', function ($scope, $rootScope, growl, ngDialog, tokenService, MyService, $location, $window, $filter, $http, $routeParams) {

    /**
     * Get Poli Id
     */
    $scope.pId = $routeParams.pId;

    $scope.getData = function () {
      MyService.getMeliSa({
        pId: $scope.pId
      }).then(function (result) {
        MyService.ConsoleLog("Resu;t", result);
        $scope.result = result;
      }, function (err) {
        MyService.ConsoleLog("Err", err);
        growl.error(err.error);
      });
    };
    $scope.getData();
  }]);

'use strict';

angular.module('myApp.showHideAns', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/showHideAns', {
      templateUrl: 'app/showHideAns/showHideAns.html',
      controller: 'showHideAnsCtrl'
    });
  }])

  .controller('showHideAnsCtrl', ['$scope', 'apiCall', 'MyService', '$location', '$anchorScroll', '$timeout', '$rootScope', 'ngDialog', '$q', '$http', '$filter', 'tokenService', 'baseApiUrl', '$document', "growl", '$cookies', function ($scope, apiCall, MyService, $location, $anchorScroll, $timeout, $rootScope, ngDialog, $q, $http, $filter, tokenService, baseApiUrl, $document, growl, $cookies) {

    $scope.oldQuestions = [];
    $scope.allQuestions = [];

    $scope.AnswerArray = [];
    $scope.AnswerArray[1] = "Very Strongly Agree";
    $scope.AnswerArray[2] = "Agree";
    $scope.AnswerArray[3] = "Somewhat Agree";
    $scope.AnswerArray[4] = "Somewhat Disagree";
    $scope.AnswerArray[5] = "Disagree";
    $scope.AnswerArray[6] = "Very Strongly Disgree";
    $scope.AnswerImpArray = [];
    $scope.AnswerImpArray[1] = "Somewhat Important";
    $scope.AnswerImpArray[2] = "Important";
    $scope.AnswerImpArray[3] = "Very Important";
    $scope.Math = window.Math;

    if (window.localStorage.getItem("fiveMatch")) {
      $scope.questions = JSON.parse(window.localStorage.getItem("fiveMatch"));
      $scope.queIds = $scope.questions.map(function (itm) {
        if (itm.questionId) {
          return itm.questionId;
        } else {
          // console.log("itm", itm);
          return itm._id;
        }
      });
      MyService.ConsoleLog("  $scope.queIds", $scope.queIds);

    }

    $scope.AllAnsweredQuestions = [];
    $scope.getAllAnsweredQuestions = function (userId) {
      MyService.getAllAnsQuesWithIds({
        "authorId": tokenService.getUserId(),
        "ques": JSON.stringify($scope.queIds)
      }).then(function (payload) {
        MyService.ConsoleLog("getAllAnsweredQuestions >> ", payload);
        if (payload.data.success) {
          $scope.AllAnsweredQuestions = payload.data.data;
          $scope.allQuestions = $scope.AllAnsweredQuestions;
          if ($scope.allQuestions.length == 0) {
            growl.error("There are no questions to display. Please go through all questions first.")
          }

        }
      }, function (errpayload) {
        MyService.ConsoleLog("getAllAnsweredQuestions errpayload >> ", errpayload);
      });
    };

    $scope.getAllAnsweredQuestions();

    /**
     * Get switch class
     */
    $scope.getSwitchClass = function (swtSts, inx) {
      MyService.ConsoleLog("swtSts", swtSts);
      MyService.ConsoleLog("inx", inx);
    };


    /**
     * Update the show status
     */
    $scope.showloader = false;
    $scope.isred = "red";
    $scope.isblue = "color:green";

    $scope.switchFilters = function (newValue, index, quest) {
      $scope.showloader = true;


      //MyService.ConsoleLog("oldValue::", $scope.switchStatus);
      var setVal = "N";
      if (newValue[index] == true) {
        setVal = "Y";
      }

      var idx = $scope.allQuestions.indexOf(quest);
      //MyService.ConsoleLog("setVal:", setVal);
      MyService.updateAnswers({
        "qid": quest._id,
        "show": setVal,
        "author": quest.author
      }).then(function (payload) {
        //MyService.ConsoleLog("payload : ", payload);
        $scope.showloader = false;
        if (payload.data.success) {
          quest.my_answer.show = setVal;
          $scope.allQuestions[idx] = quest;
          growl.success("Record updated successfully");
        } else {
          growl.error("Something went wrong. Contact administrator.");
        }
      }, function (errorpayload) {
        $scope.showloader = false;
        //MyService.ConsoleLog("errorpayload : ", errorpayload);
        growl.error("Something went wrong. Contact administrator.");
      });
    };

    /**
     * Next
     */

    $scope.next = function () {
      $location.path('/postOnFaceBook/'+window.localStorage.getItem('fbName'));
    };

    /**
     * Cancel
     */

    $scope.cancel = function () {
      $location.path('/showFbMessage');
    };

  }]);

'use strict';

angular.module('myApp.showGroupAnswer', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/showGroupAnswer/:data?/:quizName?/:isPopular?', {
      templateUrl: 'app/showGroupAnswer/showGroupAnswer.html',
      controller: 'showGroupAnswerCtrl'
    });
  }]).controller('showGroupAnswerCtrl', ['$scope', 'apiCall', 'MyService', '$location', '$anchorScroll', '$timeout', '$rootScope', 'ngDialog', '$q', '$http', '$filter', 'growl', '$routeParams', 'baseApiUrl', 'tokenService', '$cookies', function ($scope, apiCall, MyService, $location, $anchorScroll, $timeout, $rootScope, ngDialog, $q, $http, $filter, growl, $routeParams, baseApiUrl, tokenService, $cookies) {

    $scope.showPoliAnswerDetails = false;
    $scope.showUserAnswerDetails = false;
    $scope.showBack = $routeParams.data;
    $scope.quizName = $routeParams.quizName;
    $scope.isPopular = $routeParams.isPopular;


    if (window.localStorage.getItem('poliAr')) {
      var pdata = window.localStorage.getItem('poliAr');
      var opoli = JSON.parse(pdata);
      $scope.globalArray = opoli.poli;
      $scope.queId = opoli.qId;
      $scope.showPoliAnswerDetails = true;
    }

    /**
     * For Voter
     */
    if (window.localStorage.getItem('voter')) {
      // MyService.ConsoleLog("window.localStorage.getItem('comOfVoter')", window.localStorage.getItem('comOfVoter'));
      var data = window.localStorage.getItem('voter');
      var none = JSON.parse(data);
      $scope.globalArray = none.vot;
      $scope.queId = none.qId;
      $scope.showPoliAnswerDetails = true;

      // MyService.ConsoleLog(" $scope.unVeriComm", $scope.unVeriComm);
    }

    /**
     * For Advocates
     * */

    if (window.localStorage.getItem('adv')) {
      var adata = window.localStorage.getItem('adv');
      var aone = JSON.parse(adata);
      MyService.ConsoleLog("aone", aone);

      $scope.globalArray = aone.adv;
      $scope.queId = aone.qId;
      $scope.showPoliAnswerDetails = true;
      if ($cookies.get('orgName')) {
        $scope.orgName = $cookies.get('orgName');
      }
    }

    /**
     * For Guest Users
     */
    if (window.localStorage.getItem('unVerify')) {
      // alert('called');
      // MyService.ConsoleLog("window.localStorage.getItem('comOfVoter')", window.localStorage.getItem('comOfVoter'));
      var gdata = window.localStorage.getItem('unVerify');
      var gone = JSON.parse(gdata);
      $scope.unVeriCommNew = gone.unVeri;
      $scope.queId = gone.qId;
      $scope.showUserAnswerDetails = true;
    }

    /**
     * This function filter comment data
     */
    $scope.getItems = function () {
      return function (u) {
        // MyService.ConsoleLog("params >", u);

        if (u.comment && u.comment != "") {
          return u;
        }
      };
    };

    $scope.getComment = function () {
      return function (x) {
        if (x.comment && x.comment != "") {
          return x;
        }
      };
    };

    $scope.getComapreClass = function (match, i) {
      //MyService.ConsoleLog("match: ", match);
      /*if(match == 100)
        return 'ag-green';
    if(match == 0)
        return 'ag-red';
    if(match > 0 && match <100)
        return 'ag-dg'+i;*/
      if (match >= 100) return 'ag-dg1';
      if (match >= 80) return 'ag-dg2';
      if (match >= 60) return 'ag-dg3';
      if (match >= 40) return 'ag-dg4';
      if (match >= 20) return 'ag-dg5';
      if (match >= 0) return 'ag-dg6';

      return 'ag-dg';
    };

    $scope.back = function () {
      MyService.ConsoleLog("Called");
      if ($scope.showBack == 'true') {
        // alert('c')
        $location.path('/poliCompare/' + $scope.quizName);
      } else if ($scope.isPopular == 'true') {
        $location.path('/popularQuizMatch');

      } else {
        $location.path('/findMatch');

      }
    };


  }]);

'use strict';
angular
  .module('myApp.showFollowersQuiz', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/showFollowersQuiz/:quizName?/:orgId?', {
        templateUrl: 'app/showFollowersQuiz/showFollowersQuiz.html',
        controller: 'showFollowersQuizCtrl',
      });
    },
  ])
  .controller('showFollowersQuizCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    '$routeParams',
    '$q',
    'ngDialog',
    '$rootScope',
    'growl',
    'MyService',
    '$anchorScroll',
    '$timeout',
    'tokenService',
    '$cookies',
    'baseApiUrl',
    '$document',
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $q,
      ngDialog,
      $rootScope,
      growl,
      MyService,
      $anchorScroll,
      $timeout,
      tokenService,
      $cookies,
      baseApiUrl,
      $document
    ) {

      $scope.quizName = $routeParams.quizName;
      $scope.orgId = $routeParams.orgId;


      /**
       * get Quiz questions count
       */
      $scope.getQueCount = function () {
        MyService.getQuesCount({
          quizName: $scope.quizName,
          orgId: $scope.orgId,
          curtUId: tokenService.getUserId()
        }).then(function (response) {
          MyService.ConsoleLog("Response", response);
          $scope.totalQues = response.data.data.totalQuestions;
          $scope.ansQues = response.data.data.answeredQuestions;
          $scope.orgName = response.data.data.orgName;
        }, function (err) {
          MyService.ConsoleLog("Error", err);
        });
      };

      $scope.getQueCount();

      /**
       * Redirect to the quiz
       */
      $scope.getQuiz = function () {

        // $location.path('/organizationQuiz/' + $scope.quizName + "/" + $scope.orgId);
        $location.path('/followersQuiz/' + $scope.quizName + "/" + $scope.orgId);

      };
    }
  ]);

'use strict';
angular.module('myApp.showFbMessage', ['ngRoute', 'angularPayments'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/showFbMessage', {
      templateUrl: 'app/showFbMessage/showFbMessage.html',
      controller: 'showFbMessageCtrl'
    });
  }])
  .controller('showFbMessageCtrl', ['$scope', '$rootScope', 'growl', 'ngDialog', 'tokenService', 'MyService', '$location', '$window', '$filter', function ($scope, $rootScope, growl, ngDialog, tokenService, MyService, $location, $window, $filter) {


    /**
     * Next
     */

    $scope.next = function () {
      $location.path('/showHideAns');
    };

    /**
     * Cancel
     */

    $scope.cancel = function () {
      $location.path('/fiveCompare');
    };
  }]);

'use strict';


angular.module('myApp.showCompetitors', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/showCompetitors', {
      templateUrl: 'app/showCompetitors/showCompetitors.html',
      controller: 'showCompetitorsCtrl'
    });
  }]).controller('showCompetitorsCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'growl', 'tokenService', 'ngDialog', 'baseApiUrl', '$anchorScroll', 'MyService', '$window', '$sce', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, growl, tokenService, ngDialog, baseApiUrl, $anchorScroll, MyService, $window, $sce) {

    MyService.ConsoleLog("this is competitors ", JSON.parse(window.localStorage.getItem('competitorsParams')));
    $scope.showVotesmartAns = true;
    $scope.showVotewiseAns = true;
    window.localStorage.setItem('isShowPreviousResult', true)
    $scope.showCompetitors = function (params) {
      params.polId = $scope.selectedPoli._id;
      MyService.getListOfCompetitors(params).then(function (APIResponse) {
        MyService.ConsoleLog('APIResponse', APIResponse);
        if (APIResponse && APIResponse.data.success) {
          $scope.competitors = APIResponse.data.data.records;
          MyService.ConsoleLog('competitors', $scope.competitors);
        } else {
          growl.error('Competitors not found');
        }

      }, function (err) {
        MyService.ConsoleLog("err >> ", err);
      });
    }

    if (window.localStorage.getItem('competitorsParams')) {
      var smlData = JSON.parse(window.localStorage.getItem('competitorsParams'));
      $scope.selectedPoli = smlData.selectedPoli;
      $scope.showCompetitors(smlData.params);
    }



  }]);

'use strict';
angular.module('myApp.showBallotEndorsement', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/showBallotEndorsement/:id?', {
      templateUrl: 'app/showBallotEndorsement/showBallotEndorsement.html',
      controller: 'showBallotEndorsementCtrl'
    });
  }])
  .controller('showBallotEndorsementCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', '$sce', 'growl', 'ngDialog', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService, $sce, growl, ngDialog) {

    /**
     * Get params using routeparams
     */
    $scope.bId = $routeParams.id;
    MyService.ConsoleLog(" $scope.bId", $scope.bId);


    /**
     * Get Details of ballot measures
     */
    $scope.getDetailsOfBallot = function () {
      MyService.getDetailsOfBallotMeasures({
        bId: $scope.bId
      }).then(function (response) {
        MyService.ConsoleLog("Response", response);
        if (response) {
          $scope.title = response.title;
          $scope.getData();
        }
      }, function (err) {
        MyService.ConsoleLog("Error", err);
      });
    };

    /**
     * Get Reviews of the bill
     */
    $scope.getData = function () {

      MyService.getListOfEndorsers({
        bId: $scope.bId
      }).then(function (response) {
        MyService.ConsoleLog("Reposne", response);
        $scope.allEndorsements = response.data.data;
      }, function (err) {
        MyService.ConsoleLog("Error", err);
      });
    };

    /**
     * Sort name wise
     */
    $scope.sortSearch = function (val) {
      var sortOrder = "";
      MyService.ConsoleLog(val);
      if (val == 'name') {
        MyService.ConsoleLog("nameUp > ", $scope.nameUp);
        if ($scope.nameUp == "" || $scope.nameUp == "DESC") {
          sortOrder = "ASC";
          $scope.nameUp = true;
          $scope.nameDown = false;
          $scope.allEndorsements.sort(function (a, b) {
            var x = a.endorseBy[0].name.toLowerCase();
            var y = b.endorseBy[0].name.toLowerCase();
            if (x < y) {
              return -1;
            }
            if (x > y) {
              return 1;
            }
            return 0;
          });

        } else {
          sortOrder = "DESC";
          $scope.nameDown = true;
          $scope.nameUp = false;
          $scope.allEndorsements.sort(function (a, b) {
            var x = a.endorseBy[0].name.toLowerCase();
            var y = b.endorseBy[0].name.toLowerCase();
            if (x > y) {
              return -1;
            }
            if (x < y) {
              return 1;
            }
            return 0;
          });
        }
      } else {
        $scope.nameUp = false;
        $scope.nameDown = false;
      }
    };
    /**
     * Show notes
     */
    $scope.MyDialog1 = "";
    $scope.showHtmlViewer = function (content, ttl) {
      // console.log(content);
      $scope.displayContent = $sce.trustAsHtml(content.replace(/(\r\n|\n|\r)/g, "<br />"));
      $scope.MyDialog1 = ngDialog.open({
        template: 'statement',
        scope: $scope
        // className: 'ngdialog-theme-default'
      });
    };
    $scope.getDetailsOfBallot();
  }]);

'use strict';

angular.module('myApp.showAnswers', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/showAnswers/:type/:answers/:qId/:chAns', {
      templateUrl: 'app/showAnswers/showAnswers.html',
      controller: 'showAnswersCtrl'
    });
  }]).controller('showAnswersCtrl', ['$scope', 'apiCall', 'MyService', '$location', '$anchorScroll', '$timeout', '$rootScope', 'ngDialog', '$q', '$http', '$filter', 'growl', '$routeParams', 'baseApiUrl', 'tokenService', '$cookies', function ($scope, apiCall, MyService, $location, $anchorScroll, $timeout, $rootScope, ngDialog, $q, $http, $filter, growl, $routeParams, baseApiUrl, tokenService, $cookies) {
    MyService.ConsoleLog("Route Params >>", $routeParams.type);
    MyService.ConsoleLog("Route Params >>", $routeParams.answer);
    MyService.ConsoleLog("Route Params >>", $routeParams.chAns);
    $scope.showPoliAnswerDetails = false;
    $scope.showUserAnswerDetails = false;
    $scope.showLoader = false;

    $scope.getAnwers = function (par) {

      var pans = $routeParams.answers;
      var chAns = $routeParams.chAns;
      MyService.ConsoleLog("pans", pans);
      // if (chAns != "") {
      MyService.showUsersAnswers({
        "obj": par,
        "checkanswer": pans,
        "qId": $routeParams.qId
      }).then(function (payload) {
        $scope.quesId = $routeParams.qId;
        MyService.ConsoleLog("Payload>", payload.data.data);
        MyService.ConsoleLog("$routeParams.type>", $routeParams.type);
        $scope.showLoader = false;
        switch ($routeParams.type) {
          case 'politician':
            $scope.globalArray = payload.data.data.poliArr;
            $scope.showPoliAnswerDetails = true;
            break;
          case 'voter':
            $scope.globalArray = payload.data.data.voterArr;
            $scope.showPoliAnswerDetails = true;
            break;
          case 'advocate':
            $scope.globalArray = payload.data.data.advocateArr;
            $scope.showPoliAnswerDetails = true;
            $scope.orgName = $cookies.get('orgName');
            break;
          case 'guestUser':
            $scope.unVeriComm = payload.data.data.guestArr;
            $scope.showUserAnswerDetails = true;
            break;
          default:

            break;
        }

      }, function (error) {
        MyService.ConsoleLog("Error >", error);
      });
      // } else {

      // }
    };

    if (window.localStorage.getItem('comData')) {
      $scope.showLoader = true;
      // var ques = window.localStorage.getItem('quesData');
      $scope.compare = window.localStorage.getItem('comData');
      MyService.ConsoleLog("<<<<<<<<<<<< questions >>>>>>>>>>>", JSON.parse($scope.compare));
      var tempData;
      if (window.localStorage.getItem('compareData')) {
        tempData = JSON.parse($scope.compare);
        tempData.usersIds = [];
        tempData.usersIds = JSON.parse(window.localStorage.getItem('compareData'));
        MyService.ConsoleLog("tempData", tempData);
        $scope.getAnwers(JSON.stringify(tempData));
        window.localStorage.getItem('compareData');
      } else {
        $scope.getAnwers($scope.compare);
      }

    }

    $scope.getComapreClass = function (match, i) {
      //MyService.ConsoleLog("match: ", match);
      /*if(match == 100)
        return 'ag-green';
    if(match == 0)
        return 'ag-red';
    if(match > 0 && match <100)
        return 'ag-dg'+i;*/
      if (match >= 100) return 'ag-dg1';
      if (match >= 80) return 'ag-dg2';
      if (match >= 60) return 'ag-dg3';
      if (match >= 40) return 'ag-dg4';
      if (match >= 20) return 'ag-dg5';
      if (match >= 0) return 'ag-dg6';

      return 'ag-dg';
    };

    $scope.back = function () {
      $location.path('/findMatch');
    };

  }]);

'use strict';

angular.module('myApp.showComments', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/showComments/:data?', {
      templateUrl: 'app/showComments/showComments.html',
      controller: 'showCommentsCtrl'
    });
  }]).controller('showCommentsCtrl', ['$scope', 'apiCall', 'MyService', '$location', '$anchorScroll', '$timeout', '$rootScope', 'ngDialog', '$q', '$http', '$filter', 'growl', '$routeParams', 'baseApiUrl', 'tokenService', '$cookies', function ($scope, apiCall, MyService, $location, $anchorScroll, $timeout, $rootScope, ngDialog, $q, $http, $filter, growl, $routeParams, baseApiUrl, tokenService, $cookies) {
    $scope.showComment = false;
    $scope.unCommentNew = false;
    $scope.showCurUser = false;
    $scope.showHis = true;
    MyService.ConsoleLog("$root politician", $rootScope.comOfPolitician);
    MyService.ConsoleLog("$root voter", $rootScope.comOfVoter);
    if (window.localStorage.getItem('comOfPolitician')) {
      var pdata = window.localStorage.getItem('comOfPolitician');
      var opoli = JSON.parse(pdata);
      $scope.global = opoli.poliArr;
      $scope.queId = opoli.queId;
      $scope.showComment = true;

    }

    /**
     * For Voter
     */
    if (window.localStorage.getItem('comOfVoter')) {
      // MyService.ConsoleLog("window.localStorage.getItem('comOfVoter')", window.localStorage.getItem('comOfVoter'));
      var data = window.localStorage.getItem('comOfVoter');
      var none = JSON.parse(data);
      $scope.global = none.compArr;
      $scope.queId = none.queId;
      $scope.showComment = true;
      MyService.ConsoleLog(" none", none);

    }

    /**For Advocates */

    if (window.localStorage.getItem('comOfAdv')) {
      // MyService.ConsoleLog("window.localStorage.getItem('comOfVoter')", window.localStorage.getItem('comOfVoter'));
      var adata = window.localStorage.getItem('comOfAdv');
      var aone = JSON.parse(adata);
      $scope.global = aone.advArr;
      $scope.queId = aone.queId;
      $scope.showComment = true;
      $scope.orgName = $cookies.get('orgName');

    }

    /**
     * For Guest Users
     */
    if (window.localStorage.getItem('comOfGuest')) {
      // alert('called');
      // MyService.ConsoleLog("window.localStorage.getItem('comOfVoter')", window.localStorage.getItem('comOfVoter'));
      var gdata = window.localStorage.getItem('comOfGuest');
      var gone = JSON.parse(gdata);
      $scope.unVeriCommNew = gone.guestArr;
      $scope.queId = gone.queId;
      $scope.unCommentNew = true;

    }

    if (window.localStorage.getItem('cuUser')) {
      // alert('called');
      // MyService.ConsoleLog("window.localStorage.getItem('comOfVoter')", window.localStorage.getItem('comOfVoter'));
      var gdata = window.localStorage.getItem('cuUser');
      var gone = JSON.parse(gdata);
      $scope.currentUser = gone.curuser;
      MyService.ConsoleLog(" $scope.currentUser", $scope.currentUser);
      $scope.showCurUser = true;

      $scope.unCommentNew = false;
      $scope.showComment = false;

    }

    /**
     * This function filter comment data
     */
    $scope.getItems = function () {
      return function (u) {
        // MyService.ConsoleLog("params >", u);

        if (u.comment && u.comment != "") {
          return u;
        }
      };
    };

    $scope.getComment = function () {
      return function (x) {
        if (x.comment && x.comment != "") {
          return x;
        }
      };
    };

    $scope.getComapreClass = function (match, i) {
      //MyService.ConsoleLog("match: ", match);
      /*if(match == 100)
        return 'ag-green';
    if(match == 0)
        return 'ag-red';
    if(match > 0 && match <100)
        return 'ag-dg'+i;*/
      if (match >= 100) return 'ag-dg1';
      if (match >= 80) return 'ag-dg2';
      if (match >= 60) return 'ag-dg3';
      if (match >= 40) return 'ag-dg4';
      if (match >= 20) return 'ag-dg5';
      if (match >= 0) return 'ag-dg6';

      return 'ag-dg';
    };
    $scope.getComapreClassHis = function (match, i) {

      if (match >= 1) return 'ag-dg1';
      if (match >= 2) return 'ag-dg2';
      if (match >= 3) return 'ag-dg3';
      if (match >= 4) return 'ag-dg4';
      if (match >= 5) return 'ag-dg5';
      if (match >= 6) return 'ag-dg6';

      return 'ag-dg';
    };


    $scope.back = function () {
      // MyService.ConsoleLog("Called");
      $location.path('/findMatch');
    };


  }]);

"use strict";
angular
  .module("myApp.showAllUsersMatch", ["ngRoute"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/showAllUsersMatch/:flag?", {
        templateUrl: "app/showAllUsersMatch/showAllUsersMatch.html",
        controller: "showAllUsersMatchCtrl",
      });
    },
  ])
  .controller("showAllUsersMatchCtrl", [
    "$scope",
    "$http",
    "$location",
    "apiCall",
    "$routeParams",
    "$rootScope",
    "$q",
    "$timeout",
    "tokenService",
    "MyService",
    "$anchorScroll",
    "$cookies",
    "ngDialog",
    "growl",
    "$window",
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $rootScope,
      $q,
      $timeout,
      tokenService,
      MyService,
      $anchorScroll,
      $cookies,
      ngDialog,
      growl,
      $window
    ) {
      $scope.page = 1;
      $scope.maxRecordsPerPg = 10000;
      $scope.showPoliAnswerDetails = false;
      $scope.showUserAnswerDetails = false;
      $scope.noDataFound = false;
      $scope.showcomparison = false;
      $scope.showComment = false;
      $scope.unComment = false;
      $scope.showCurr = false;
      $scope.loaders = false;

      if (tokenService.getUserId()) {
        $scope.userId = tokenService.getUserId();
        console.log("$scope.userId: ", $scope.userId);
      }

      window.localStorage.removeItem("comData");

      var param = {};
      param.page = $scope.page;
      param.max_records = $scope.maxRecordsPerPg;

      if ($routeParams.flag) {
        $scope.flag = true;
        // alert('one');
      } else {
        $scope.flag = false;
        // alert('two');
      }

      if (window.localStorage.getItem("quesData")) {
        $rootScope.queData = window.localStorage.getItem("quesData");
        // MyService.ConsoleLog("main Data>>", JSON.parse($rootScope.queData));
      }
      $scope.showGrpFollow = false;
      /**
       * Remove values from localStorage on page load
       */
      window.localStorage.removeItem("comOfPolitician");
      window.localStorage.removeItem("comOfVoter");
      window.localStorage.removeItem("comOfAdv");
      window.localStorage.removeItem("comOfGuest");
      window.localStorage.removeItem("poliAr");
      window.localStorage.removeItem("voter");
      window.localStorage.removeItem("adv");
      window.localStorage.removeItem("unVerify");
      window.localStorage.removeItem("cuUser");

      if (tokenService.getUserId()) {
        // alert('sssss');
        $scope.userData = JSON.parse(tokenService.getUserData());
        MyService.ConsoleLog("$scope.userData >", $scope.userData);
        MyService.ConsoleLog("$scope.userData >", $scope.userData.address);

        // $rootScope.tempUserAddress = "";
        $rootScope.tempUserAddress = $scope.userData.address;
        console.log(
          "$rootScope.tempUserAddress >>> ",
          $rootScope.tempUserAddress
        );
        // }

        // var nAddobj = new Object;

        // nAddobj.state = $scope.mainAddress.state.state;
        // nAddobj.stateFips = $scope.mainAddress.state.stateFips;
        // nAddobj.statePostalCode = $scope.mainAddress.state.statePostalCode;

        // nAddobj.county = $scope.mainAddress.county ? $scope.mainAddress.county.county : "";
        // nAddobj.countyFips = $scope.mainAddress.county ? $scope.mainAddress.county.countyFips : "";
        // if ($scope.mainAddress.place && $scope.mainAddress.place != "") {
        //   nAddobj.place = $scope.mainAddress.place.place;
        //   nAddobj.placeFips = $scope.mainAddress.place.placeFips;
        // }

        // nAddobj.federalCongrassionalDist = $scope.mainAddress.federalCongrassionalDist ? $scope.mainAddress.federalCongrassionalDist.CD115FP : "";

        // nAddobj.stateSenateDistrict = $scope.mainAddress.stateSenateDistrict ? $scope.mainAddress.stateSenateDistrict.SLDUST : "";

        // nAddobj.legislativeDistrict = $scope.mainAddress.stateHouseOFRepresentativeDistrict ? $scope.mainAddress.stateHouseOFRepresentativeDistrict.NAMELSAD.replace("State House District ", "") : "";

        // nAddobj.schoolDistrict = $scope.mainAddress.unifiedSchoolDistrictName ? $scope.mainAddress.unifiedSchoolDistrictName.NAME : '';

        // nAddobj.schoolDistrictFips = $scope.mainAddress.unifiedSchoolDistrictName ? $scope.mainAddress.unifiedSchoolDistrictName.UNSDLEA : '';
        // console.log("nAddobj > ", nAddobj);
        // $rootScope.tempUserAddress = nAddobj;
      } else {
        if (window.localStorage.getItem("tempUserAddress")) {
          $rootScope.tempUserAddress = window.localStorage.getItem(
            "tempUserAddress"
          );

          // MyService.ConsoleLog("$rootScope.tempUserAddress >>", $rootScope.tempUserAddress);

          $scope.mainAddress = JSON.parse(
            angular.copy($rootScope.tempUserAddress)
          );
          // console.log("mainAddress >>> ", $scope.mainAddress);
          var nobj = new Object();

          nobj.state = $scope.mainAddress.state.state;
          nobj.stateFips = $scope.mainAddress.state.stateFips;
          nobj.statePostalCode = $scope.mainAddress.state.statePostalCode;

          nobj.county = $scope.mainAddress.county
            ? $scope.mainAddress.county.county
            : "";
          nobj.countyFips = $scope.mainAddress.county
            ? $scope.mainAddress.county.countyFips
            : "";
          if ($scope.mainAddress.place && $scope.mainAddress.place != "") {
            nobj.place = $scope.mainAddress.place.place;
            nobj.placeFips = $scope.mainAddress.place.placeFips;
          }

          nobj.federalCongrassionalDist = $scope.mainAddress
            .federalCongrassionalDist
            ? $scope.mainAddress.federalCongrassionalDist.CD115FP
            : "";

          nobj.stateSenateDistrict = $scope.mainAddress.stateSenateDistrict
            ? $scope.mainAddress.stateSenateDistrict.SLDUST
            : "";

          nobj.legislativeDistrict = $scope.mainAddress
            .stateHouseOFRepresentativeDistrict
            ? $scope.mainAddress.stateHouseOFRepresentativeDistrict.NAMELSAD.replace(
                "State House District ",
                ""
              )
            : "";

          nobj.schoolDistrict = $scope.mainAddress.unifiedSchoolDistrictName
            ? $scope.mainAddress.unifiedSchoolDistrictName.NAME
            : "";

          nobj.schoolDistrictFips = $scope.mainAddress.unifiedSchoolDistrictName
            ? $scope.mainAddress.unifiedSchoolDistrictName.UNSDLEA
            : "";
          // console.log("nobj > ", nobj);
          $rootScope.tempUserAddress = nobj;
          MyService.ConsoleLog(
            " $rootScope.tempUserAddress >",
            $rootScope.tempUserAddress
          );
        }
      }

      $scope.changeColor = function (nper, inx, cur_ans) {
        // MyService.ConsoleLog("inx", inx);
        // MyService.ConsoleLog("cur_ans", cur_ans);

        var arrOfCol = {
          5: "#990000",
          4: "#cc3300",
          3: "#ff9933",
          2: "#ffff00",
          1: "#99cc00",
          0: "#00d900",
        };
        var cdiff = Math.abs(inx - cur_ans);

        // console.log("arrOfCol > ", arrOfCol);
        $scope.gr = null;
        switch (true) {
          case nper >= 100:
            if (cur_ans == inx) {
              $scope.gr = {
                background:
                  "linear-gradient(to right, " +
                  arrOfCol[0] +
                  " " +
                  nper +
                  "%, #2b4f7f 10%)",
              };
            } else {
              $scope.gr = {
                background:
                  "linear-gradient(to right, " +
                  arrOfCol[cdiff] +
                  " " +
                  nper +
                  "%, #2b4f7f 10%)",
              };
            }

            // MyService.ConsoleLog("$scope.gr >>", arrOfCol.nper);
            break;
          case nper >= 80:
            if (cur_ans == inx) {
              $scope.gr = {
                background:
                  "linear-gradient(to right, " +
                  arrOfCol[0] +
                  " " +
                  nper +
                  "%, #2b4f7f 10%)",
              };
            } else {
              $scope.gr = {
                background:
                  "linear-gradient(to right, " +
                  arrOfCol[cdiff] +
                  " " +
                  nper +
                  "%, #2b4f7f 10%)",
              };
            }
            break;
          case nper >= 60:
            if (cur_ans == inx) {
              $scope.gr = {
                background:
                  "linear-gradient(to right, " +
                  arrOfCol[0] +
                  " " +
                  nper +
                  "%, #2b4f7f 10%)",
              };
            } else {
              $scope.gr = {
                background:
                  "linear-gradient(to right, " +
                  arrOfCol[cdiff] +
                  " " +
                  nper +
                  "%, #2b4f7f 10%)",
              };
            }
            break;
          case nper >= 40:
            if (cur_ans == inx) {
              $scope.gr = {
                background:
                  "linear-gradient(to right, " +
                  arrOfCol[0] +
                  " " +
                  nper +
                  "%, #2b4f7f 10%)",
              };
            } else {
              $scope.gr = {
                background:
                  "linear-gradient(to right, " +
                  arrOfCol[cdiff] +
                  " " +
                  nper +
                  "%, #2b4f7f 10%)",
              };
            }
            break;
          case nper >= 20:
            if (cur_ans == inx) {
              $scope.gr = {
                background:
                  "linear-gradient(to right, " +
                  arrOfCol[0] +
                  " " +
                  nper +
                  "%, #2b4f7f 10%)",
              };
            } else {
              $scope.gr = {
                background:
                  "linear-gradient(to right, " +
                  arrOfCol[cdiff] +
                  " " +
                  nper +
                  "%, #2b4f7f 10%)",
              };
            }
            break;
          case nper >= 0:
            if (cur_ans == inx) {
              $scope.gr = {
                background:
                  "linear-gradient(to right, " +
                  arrOfCol[0] +
                  " " +
                  nper +
                  "%, #2b4f7f 10%)",
              };
            } else {
              $scope.gr = {
                background:
                  "linear-gradient(to right, " +
                  arrOfCol[cdiff] +
                  " " +
                  nper +
                  "%, #2b4f7f 10%)",
              };
            }
            break;

          default:
            break;
        }
        // MyService.ConsoleLog(" $scope.gr", $scope.gr);
        return $scope.gr;
      };

      /** Return class of background color */

      $scope.getComapreClass = function (match, i) {
        //MyService.ConsoleLog("match: ", match);
        /*if(match == 100)
          return 'ag-green';
      if(match == 0)
          return 'ag-red';
      if(match > 0 && match <100)
          return 'ag-dg'+i;*/
        if (match >= 100) return "ag-dg1";
        if (match >= 80) return "ag-dg2";
        if (match >= 60) return "ag-dg3";
        if (match >= 40) return "ag-dg4";
        if (match >= 20) return "ag-dg5";
        if (match >= 0) return "ag-dg6";

        return "ag-dg";
      };

      /**
       * This function calls on page load
       * fetch data of user's area politician ,voters and advocates
       */

      $scope.getLocalPoliticians = function (id) {
        // MyService.ConsoleLog("window.localStorage.getItem('comData')", window.localStorage.getItem('comData'));
        // MyService.ConsoleLog("Id", id);
        if (!id) {
          $scope.loaders = true;
        } else {
          $scope.loadernew = true;
        }

        // MyService.ConsoleLog(" welcome to getLocalPoliticians ", $rootScope.queData);
        $scope.statusGetLocalPoliticians = 1;
        $scope.page += 1;
        $scope.loader = true;
        // MyService.ConsoleLog("$rootScope.tempUserA ******* ", $rootScope.tempUserAddress);
        // MyService.ConsoleLog("$rootScope.tempUserA ******* ", $rootScope.tempUserAddress.state)
        var extradata = new Object();
        if ($rootScope.tempUserAddress) {
          if (
            $rootScope.tempUserAddress.state &&
            $rootScope.tempUserAddress.state != ""
          ) {
            extradata.statePostalCode =
              $rootScope.tempUserAddress.statePostalCode;
          }
          if ($rootScope.tempUserAddress.county) {
            // $rootScope.tempUserAddress.FinalData = JSON.stringify(
            //   $rootScope.tempUserAddress.countyFips
            // );
            extradata.county = $rootScope.tempUserAddress.county;
          }
          if (
            $rootScope.tempUserAddress.countySubdivision &&
            $rootScope.tempUserAddress.countySubdivisionFips
          ) {
            $rootScope.tempUserAddress.FinalData = JSON.stringify(
              $rootScope.tempUserAddress.countySubdivisionFips
            );
            extradata.countySubdivision =
              $rootScope.tempUserAddress.countySubdivision;
          }
          if ($rootScope.tempUserAddress.place) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.place = $rootScope.tempUserAddress.place;
          }
          if (
            $rootScope.tempUserAddress.voterDistrict &&
            $rootScope.tempUserAddress.voterDistrictFips
          ) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.voterDistrict = $rootScope.tempUserAddress.voterDistrict;
          }
          if ($rootScope.tempUserAddress.federalCongrassionalDist) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            MyService.ConsoleLog(
              "federalCongrassionalDist  :",
              $rootScope.tempUserAddress.federalCongrassionalDist
            );
            extradata.federalCongrassionalDist =
              $rootScope.tempUserAddress.federalCongrassionalDist;
          }
          if ($rootScope.tempUserAddress.stateSenateDistrict) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.stateSenateDistrict =
              $rootScope.tempUserAddress.stateSenateDistrict;
          }
          if ($rootScope.tempUserAddress.legislativeDistrict) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.legislativeDistrict =
              $rootScope.tempUserAddress.legislativeDistrict;
          }
          if ($rootScope.tempUserAddress.schoolDistrict) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.schoolDistrict =
              $rootScope.tempUserAddress.schoolDistrict;
          }
        }
        MyService.ConsoleLog(
          "extradata : >>>>>>>>>> ",
          JSON.stringify(extradata)
        );
        MyService.getAllLocalPoli({
          max_records: 100,
          page: $scope.page,
          extradata: JSON.stringify(extradata),
        }).then(
          function (response) {
            if (response.data.success) {
              setTimeout(function () {
                $scope.$apply(function () {
                  if (response.data.data.length > 0) {
                    MyService.getAdvocates().then(
                      function (payload) {
                        MyService.ConsoleLog("Response >", payload);
                        var ndata = response.data.data;
                        var wdata = ndata.concat(payload.data.data);
                        $scope.userAreaPolitician = wdata.map(function (ques) {
                          return ques._id;
                        });
                        var param = JSON.stringify({
                          usersIds: $scope.userAreaPolitician,
                          cur_userId: $scope.userId,
                          questions: $rootScope.queData,
                        });
                        window.localStorage.setItem("comData", param);
                        var indx;
                        if (id && id != "") {
                          indx = id;
                          MyService.ConsoleLog("Inds >>>>>>>>", indx);
                        } else {
                          $scope.currentIndex = 0;
                          indx = $scope.currentIndex;
                          MyService.ConsoleLog(" $scope.currentIndex >", indx);
                        }
                        // alert('called');

                        var main = JSON.parse($rootScope.queData);
                        main.sort(function (x, y) {
                          if (x.matchOrder < y.matchOrder) {
                            return -1;
                          }
                          if (x.matchOrder > y.matchOrder) {
                            return 1;
                          }
                          return 0;
                        });
                        MyService.ConsoleLog(" $scope.quData :", main[indx]);
                        $scope.compareRegisterGuestUsers({
                          userIds: JSON.stringify($scope.userAreaPolitician),
                          guest: JSON.stringify(main[indx]),
                          userData: $scope.userId,
                        });
                      },
                      function (err) {
                        MyService.ConsoleLog("Error >>", err);
                      }
                    );
                  } else {
                    $scope.loader = false;
                    var message =
                      "None of your politicians have answered the questions yet. Contact them and ask them to fill it out.";
                    var modal = ngDialog.openConfirm({
                      template:
                        "<p>" +
                        message +
                        '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">OK</button>\
                            \
                        </div>',
                      plain: true,
                    });

                    modal.then(
                      function fullfilled(data) {
                        //MyService.ConsoleLog("fullfilled: ", data);
                        if (data == 1) {
                          $scope.postonFacebook();
                        } else {
                          if ($rootScope.userRole) {
                            $location.path("/snapshot");
                          } else {
                            $location.path("/signin");
                          }
                        }
                      },
                      function rejected(data) {
                        //MyService.ConsoleLog("rejected: ", data);
                      }
                    );
                  }
                });
              }, 100);
            } else {
              $scope.page -= 1;
              $scope.statusGetLocalPoliticians = 3;
              if (typeof response.data.error == "string")
                growl.error(response.data.error);
              else growl.error("Something went wrong");
            }
          },
          function (err) {
            $scope.page -= 1;
            $scope.statusGetLocalPoliticians = 3;
            $scope.loader = false;
            growl.error(err);
          }
        );
      };

      /**End of getLocalPoliticians */

      $scope.backTo = function () {
        $scope.showHidePop.close();
        // history.back();
        var catId = window.localStorage.getItem("cat_id");
        var subCatId = window.localStorage.getItem("selCat_id");
        $location.path("/question-background/" + catId + "/" + subCatId);
      };

      if (tokenService.getUserId()) {
        $scope.getLocalPoliticians();
      }

      /**
       * This function redirects to show answers page
       */

      $scope.showAnswers = function (ans, type, qId, chAns, ind) {
        MyService.ConsoleLog("Ind", ind);
        MyService.ConsoleLog("qId", qId);

        if (!ind) {
          ind = 0;
        }
        if (chAns) {
          if (!chAns[ind + 1]) {
            // alert("This");
            growl.error("No users to see here");
          } else {
            // if (chAns != "") {
            //   alert('dahdaj');
            // }
            MyService.ConsoleLog("Type >>", type);
            MyService.ConsoleLog("qId >>", qId);
            MyService.ConsoleLog("chAns >>", chAns);
            // return;
            $location.path(
              "/showAnswers/" + type + "/" + ans + "/" + qId + "/" + chAns
            );
          }
        } else {
          // alert('not Found');
          switch (type) {
            case "politician":
              growl.error(
                "None of politicians of your area answered for this question"
              );
              break;
            case "voter":
              growl.error(
                "None of voter of your area answered for this question"
              );
              break;
            case "advocate":
              growl.error(
                "None of organizations of your area answered for this question"
              );
              break;

            default:
              break;
          }
        }
      };

      /**
       * This function show the details of answered questions
       * showAnswersDetail
       */

      $scope.showAnswersDetail = function (para) {
        MyService.ConsoleLog("para >", para);

        switch (para) {
          case "politician":
            if ($scope.showGrpFollow) {
              // MyService.ConsoleLog("$scope.arrayOfCom", $scope.arrayOfCom[$scope.questions[$scope.currentIndex]._id].length);
              if (
                $scope.arrayOfCom &&
                $scope.arrayOfCom[$scope.questions[$scope.currentIndex]._id]
              ) {
                var newObjs = JSON.stringify({
                  poli: $scope.arrayOfCom,
                  qId: $scope.questions[$scope.currentIndex]._id,
                });
                MyService.ConsoleLog("newObj", newObjs);
                window.localStorage.setItem("poliAr", newObjs);
              } else if (
                $scope.voterComArr &&
                $scope.voterComArr[$scope.questions[$scope.currentIndex]._id]
              ) {
                var vObj = JSON.stringify({
                  vot: $scope.voterComArr,
                  qId: $scope.questions[$scope.currentIndex]._id,
                });
                window.localStorage.setItem("voter", vObj);
              } else if ($scope.advComArr) {
                var advo = JSON.stringify({
                  adv: $scope.advComArr,
                  qId: $scope.questions[$scope.currentIndex]._id,
                });
                window.localStorage.setItem("adv", advo);
              }
            } else {
              var newObj = JSON.stringify({
                poli: $scope.arrayOfCom,
                qId: $scope.questions[$scope.currentIndex]._id,
              });
              MyService.ConsoleLog("newObj", newObj);
              window.localStorage.setItem("poliAr", newObj);
            }
            $location.path("/showGroupAnswer");
            // $scope.showPoliAnswerDetails = true;
            break;
          case "unRegister":
            var unObj = JSON.stringify({
              unVeri: $scope.unVeriComm,
              qId: $scope.questions[$scope.currentIndex]._id,
            });
            window.localStorage.setItem("unVerify", unObj);
            $location.path("/showGroupAnswer");
            // $scope.showUserAnswerDetails = true;
            break;
          case "voter":
            var vObj = JSON.stringify({
              vot: $scope.voterComArr,
              qId: $scope.questions[$scope.currentIndex]._id,
            });
            window.localStorage.setItem("voter", vObj);
            $location.path("/showGroupAnswer");
            // $scope.showPoliAnswerDetails = true;
            break;
          case "advocate":
            var advo = JSON.stringify({
              adv: $scope.advComArr,
              qId: $scope.questions[$scope.currentIndex]._id,
            });
            window.localStorage.setItem("adv", advo);
            $location.path("/showGroupAnswer");
            // $scope.showPoliAnswerDetails = true;
            break;
          default:
            break;
        }

        // if (para == 'politician') {
        //   $scope.showPoliAnswerDetails = true;
        // } else {
        //   $scope.showUserAnswerDetails = true;
        // }
      };

      /**End Of showAnswersDetail */

      /** This function fetch comparison results using
       ** @ Params @
       ** guest user data and politician data
       **/

      $scope.compareRegisterGuestUsers = function (params) {
        MyService.ConsoleLog("Params >>", params);

        MyService.compareRegisterGuestUsers(params).then(
          function (payload) {
            MyService.ConsoleLog("Response >>>", payload);

            if (payload.data.success) {
              $scope.loadernew = false;

              $scope.questions = JSON.parse($rootScope.queData);
              MyService.ConsoleLog("check", $scope.questions);
              $scope.questions.sort(function (x, y) {
                if (x.matchOrder < y.matchOrder) {
                  return -1;
                }
                if (x.matchOrder > y.matchOrder) {
                  return 1;
                }
                return 0;
              });
              $scope.loaders = false;

              // MyService.ConsoleLog("CompareWithAllPolitcians >> ", payload.data.data.qdata);
              // if (Object.keys(payload.data.data.agrriOfEmail).length == 0 || Object.keys(payload.data.data.aggriOfVoter).length == 0 || Object.keys(payload.data.data.aggriOfAdvocate).length == 0 || Object.keys(payload.data.data.aggriOfUnVerified).length == 0) {

              if (
                JSON.stringify(payload.data.data.agrriOfEmail) !=
                JSON.stringify({})
              ) {
                $scope.emailRegistered = payload.data.data.agrriOfEmail;
              }

              $scope.emailImpo = payload.data.data.aggriOfEmailImportance;

              $scope.FBCompareList = payload.data.data.qdata;
              $scope.ansCount = payload.data.data.ansCount;
              $scope.impCount = payload.data.data.impCount;

              $scope.flagOfUnVerified = payload.data.data.flagOfUnVerified;
              // MyService.ConsoleLog('ansCount >', $scope.impCount);
              $scope.globalFlag = payload.data.data.checkFlag;
              $scope.arrayOfCom = payload.data.data.commArr;

              $scope.voter = "";

              $scope.voter = payload.data.data.aggriOfVoter;
              MyService.ConsoleLog(
                "else",
                JSON.stringify(payload.data.data.aggriOfVoter)
              );

              MyService.ConsoleLog(">>>>>>>>>>>>>>>>>>>>", $scope.voter);
              $scope.voterImp = payload.data.data.aggriOfVoterImportance;
              $scope.voterAnsCount = payload.data.data.voterAnsCount;
              $scope.voterImpCount = payload.data.data.voterImpCount;
              $scope.flagOfVoter = payload.data.data.voterFlag;
              $scope.voterComArr = payload.data.data.voterComArr;
              $scope.advocate = "";

              $scope.advocate = payload.data.data.aggriOfAdvocate;

              $scope.advocateAns = payload.data.data.advocateObj;
              $scope.advocateImpAggri =
                payload.data.data.aggriOfAdvocateImportance;
              $scope.advocateimpObj = payload.data.data.advocateimpObj;
              $scope.advocateFlag = payload.data.data.advFlag;
              $scope.advComArr = payload.data.data.advcommArr;
              // $scope.questions = payload.data.data.qdata;
              // MyService.ConsoleLog("$scope.questions >>>", $scope.questions);
              $scope.FBCompareList = payload.data.data.qdata;
              $scope.flag = true;
              if ($scope.FBCompareList && $scope.FBCompareList.length > 0) {
                $scope.FBunWeighted = payload.data.data.unweightedMatch;
                $scope.fbcombinedWeight = payload.data.data.fbcombinedWeight;
                $scope.fbmultiplier = payload.data.data.fbmultiplier;
                $scope.answeredQuestions = payload.data.data.answeredQuestions;
                $scope.fbqlen = payload.data.data.qlen;
                $scope.AllUsers = payload.data.data.AllUsers;
                var mainData = JSON.stringify(payload.data.data);
                // MyService.ConsoleLog("mainData >>", mainData);
                window.localStorage.setItem("Data", mainData);

                if (
                  JSON.stringify($scope.emailRegistered) ==
                    JSON.stringify({}) &&
                  JSON.stringify($scope.voter) == JSON.stringify({}) &&
                  JSON.stringify($scope.advocate) == JSON.stringify({}) &&
                  JSON.stringify($scope.unVerified) == JSON.stringify({})
                ) {
                  // alert('got')
                  var message =
                    "”Congratulations!!  You are the first person in your area to take this quiz!  You are at the forefront of democracy!”";
                  MyService.ConsoleLog(
                    "getUserRole >",
                    tokenService.getUserRole()
                  );
                  // var repath;

                  var modal = ngDialog.openConfirm({
                    template:
                      "<p>" +
                      message +
                      '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">OK</button>\
                            \
                        </div>',
                    plain: true,
                  });

                  modal.then(
                    function fullfilled(data) {
                      //MyService.ConsoleLog("fullfilled: ", data);
                      if (data == 0) {
                        if (tokenService.getUserRole() == "voter") {
                          $location.path("/learnHome");
                        } else if (tokenService.getUserRole() == "politician") {
                          $location.path("/winVoters");
                        }
                      }
                    },
                    function rejected(data) {
                      //MyService.ConsoleLog("rejected: ", data);
                    }
                  );
                }
              }
              //$scope.qData = payload.data.data.answeredQuestions;
              // } else {
              //   alert('got');
              // }
            } else {
              $scope.showAlert = true;
              var message =
                "”Congratulations!!  You are the first person in your area to take this quiz!  You are at the forefront of democracy!”";
              MyService.ConsoleLog("getUserRole >", tokenService.getUserRole());
              // var repath;

              var modal = ngDialog.openConfirm({
                template:
                  "<p>" +
                  message +
                  '</p>\
                    <div class="ngdialog-buttons">\
                        <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">OK</button>\
                        \
                    </div>',
                plain: true,
              });

              modal.then(
                function fullfilled(data) {
                  //MyService.ConsoleLog("fullfilled: ", data);
                  if (data == 0) {
                    if (tokenService.getUserRole() == "voter") {
                      $location.path("/learnHome");
                    } else if (tokenService.getUserRole() == "politician") {
                      $location.path("/winVoters");
                    }
                  }
                },
                function rejected(data) {
                  //MyService.ConsoleLog("rejected: ", data);
                }
              );
              // alert("Something went wrong.");
            }
          },
          function (error) {
            MyService.ConsoleLog("Error >>", error);
          }
        );
      };

      /**This function redirects to show comment page */
      $scope.viewAnsComment = function (val) {
        MyService.ConsoleLog("called", val);

        switch (val) {
          case "email":
            $scope.global = $scope.arrayOfCom;
            if ($scope.userId) {
              var poli = JSON.stringify({
                poliArr: $scope.arrayOfCom,
                queId: $scope.questions[$scope.currentIndex]._id,
              });
              window.localStorage.setItem("comOfPolitician", poli);
              $location.path("/showComments");
            }
            $scope.showComment = true;
            $scope.unComment = false;
            $scope.showCurr = false;

            break;
          case "unRegister":
            if ($scope.userId) {
              var guest = JSON.stringify({
                guestArr: $scope.unVeriComm,
                queId: $scope.questions[$scope.currentIndex]._id,
              });
              window.localStorage.setItem("comOfGuest", guest);
              $location.path("/showComments");
            }
            $scope.unComment = true;
            $scope.showComment = false;
            $scope.showCurr = false;

            break;
          case "voter":
            $scope.global = $scope.voterComArr;
            // MyService.ConsoleLog("$scope.voterComArr", $scope.voterComArr);
            if ($scope.userId) {
              var vo = JSON.stringify({
                compArr: $scope.voterComArr,
                queId: $scope.questions[$scope.currentIndex]._id,
              });
              // MyService.ConsoleLog("vo >>", vo);
              window.localStorage.setItem("comOfVoter", vo);
              $location.path("/showComments");
            }
            $scope.showComment = true;
            $scope.unComment = false;
            $scope.showCurr = false;

            break;
          case "advocate":
            $scope.global = $scope.advComArr;
            if ($scope.userId) {
              var adv = JSON.stringify({
                advArr: $scope.advComArr,
                queId: $scope.questions[$scope.currentIndex]._id,
              });
              window.localStorage.setItem("comOfAdv", adv);
              $location.path("/showComments");
            }
            $scope.showComment = true;
            $scope.unComment = false;
            $scope.showCurr = false;

            break;
          case "currentUser":
            if ($scope.userId) {
              var curUser = JSON.stringify({
                curuser: $scope.questions[$scope.currentIndex],
              });

              window.localStorage.setItem("cuUser", curUser);
              $location.path("/showComments");
            }
            $scope.showComment = false;
            $scope.showCurr = true;
            $scope.unComment = false;
            break;
          default:
            break;
        }
      };
      $scope.back = function () {
        $scope.showPoliAnswerDetails = false;
        $scope.showUserAnswerDetails = false;
        $scope.showComment = false;
        $scope.unComment = false;
        $scope.showCurr = false;
      };

      $scope.status = {
        questions: 0, //1=loading, 2=loaded, 3=error
        category: 0,
      };

      var getCompareAnswersCanceler = $q.defer();

      $scope.getCompareAnswers = function (params) {
        console.log("params: ", params);

        if (!params) return;
        getCompareAnswersCanceler.resolve();

        getCompareAnswersCanceler = $q.defer();
        $scope.questions = [];
        $scope.status.questions = 1;

        MyService.getCompareAns(params, getCompareAnswersCanceler.promise).then(
          function successCallback(response) {
            console.log("response: ", response);
            //MyService.ConsoleLog("Got categories: ",response);
            if (response.data.success) {
              if (response.data.data.length > 0) {
                $scope.status.questions = 2;
                angular.forEach(response.data.data, function (val, key) {
                  if (
                    val.answers &&
                    val.answers.length != $rootScope.selectedCompareUsers.length
                  ) {
                    var check_author_exist = function (u) {
                      var len = val.answers.length;
                      for (var i = 0; i < len; i++) {
                        if (val.answers[i].author._id == u) {
                          return true;
                        }
                      }
                      return false;
                    };

                    angular.forEach(
                      $rootScope.selectedCompareUsers,
                      function (u, i) {
                        if (!check_author_exist(u)) {
                          response.data.data[key].answers.push({
                            author: u,
                          });
                        }
                      }
                    );
                  } else if (!val.answers) {
                    response.data.data[key].answers = [];
                    angular.forEach(
                      $rootScope.selectedCompareUsers,
                      function (u, i) {
                        response.data.data[key].answers.push({
                          author: u,
                        });
                      }
                    );
                  }
                });

                $scope.questions = response.data.data;
                console.log("$scope.questions: ", $scope.questions);
              }
              // $location.path("question-compare/"+$routeParams.category_id+"/"+null);
            } else {
              $scope.status.questions = 3;
              //MyService.ConsoleLog("Something went wrong: ", response.data);
            }
          },
          function errorCallBack(response) {
            $scope.status.questions = 3;
            //MyService.ConsoleLog("Error: ", response);
          }
        );
      };

      $scope.finalSignIn = function () {
        $location.path("/fiveSaveUser");
      };

      /**
       * This function filter comment data
       */
      $scope.getItems = function () {
        return function (u) {
          MyService.ConsoleLog("params >", u);

          if (u.comment && u.comment != "") {
            return u;
          }
        };
      };

      $scope.getComment = function () {
        return function (x) {
          if (x.comment && x.comment != "") {
            return x;
          }
        };
      };

      $scope.prevQuestion = function () {
        //MyService.ConsoleLog("** prevQuestion **");

        $("html, body").animate(
          {
            scrollTop: $("#DisplayQ").offset().top - 280,
          },
          "slow"
        );
        if ($scope.currentIndex > 0) {
          var decr = $scope.currentIndex--;
          var one = decr - 1;
          MyService.ConsoleLog("decr", one);
          if ($scope.userId) {
            $scope.getLocalPoliticians(one);
          }
        } else if ($scope.currentIndex == 0) {
          if ($scope.currBackgroundIndex > 0) {
            $scope.currBackgroundIndex--;
            MyService.ConsoleLog(
              "$scope.traverseBackgrounds >",
              $scope.traverseBackgrounds
            );
            $scope.category =
              $scope.traverseBackgrounds[$scope.currBackgroundIndex];
          } else {
            //MyService.ConsoleLog("** end of background **");
            if ($scope.rootCatIndex > 0) {
              $scope.rootCatIndex--;
              $location.path(
                "/question-compare/all/" +
                  $rootScope.categories[$scope.rootCatIndex]._id
              );
            }
          }
        }
      };

      $scope.skipQuestion = function () {
        // $("html, body").animate({
        //   scrollTop: 0
        // }, "slow");
        var skip = function () {
          MyService.ConsoleLog("offset", $("#DisplayQ").offset().top);
          $("html, body").animate(
            {
              scrollTop: $("#DisplayQ").offset().top - 180,
            },
            "slow"
          );

          var tempIndex = $scope.currentIndex + 1;
          MyService.ConsoleLog(" $scope.currentIndex >>", tempIndex);
          if ($scope.userId) {
            $scope.getLocalPoliticians(tempIndex);
          }

          if (tempIndex < $scope.questions.length) {
            $scope.currentIndex++;
            if (
              $routeParams.categoryId &&
              $routeParams.categoryId.indexOf("popular:") == 0
            ) {
              //we are showing questions of most popular section
              $scope.getCategory({
                id: $scope.questions[$scope.currentIndex].categories.cid,
              });
            }
          }
          MyService.ConsoleLog(
            "tempIndex = ",
            tempIndex + "$scope.questions.length " + $scope.questions.length
          );
          if (
            tempIndex == $scope.questions.length ||
            $scope.questions.length == 0
          ) {
            //MyService.ConsoleLog("end of questions switch background");
            var tempBackIdx = $scope.currBackgroundIndex + 1;
            MyService.ConsoleLog(
              "$scope.traverseBackgrounds >>",
              $scope.traverseBackgrounds
            );
            if (
              $scope.traverseBackgrounds &&
              $scope.traverseBackgrounds != ""
            ) {
              if (tempBackIdx < $scope.traverseBackgrounds.length) {
                $scope.currBackgroundIndex++;
                $scope.category =
                  $scope.traverseBackgrounds[$scope.currBackgroundIndex];
              } else {
                $scope.rootCatIndex++;
                // alert("Else");
                window.localStorage.setItem(
                  "RootCatIndex",
                  $scope.rootCatIndex
                );
                window.localStorage.setItem(
                  "DisplayCategory",
                  JSON.stringify($scope.category)
                );
                //MyService.ConsoleLog("/politician_compare/" + $routeParams.categoryId + "/" + $routeParams.parentId);
                $location.path(
                  "/politician_compare/" +
                    $routeParams.categoryId +
                    "/" +
                    $routeParams.parentId
                );
              }
            } else {
              if ($scope.userId) {
                var tmps = JSON.parse(window.localStorage.getItem("quesData"));
                window.localStorage.setItem("fiveMatch", JSON.stringify(tmps));
                $location.path("/fiveCompare");
              }
            }
          }
        };

        skip();
      };
    },
  ]);


"use strict";
angular
  .module("myApp.sendInvitations", ["ngRoute"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/sendInvitations", {
        templateUrl: "app/sendInvitations/sendInvitations.html",
        controller: "sendInvitationsCtrl",
      });
    },
  ])
  .controller("sendInvitationsCtrl", [
    "$scope",
    "ngDialog",
    "MyService",
    "growl",
    function ($scope, ngDialog, MyService, growl) {
      $scope.loader = false;
      $scope.allState = [];
      $scope.address = {
        state: "",
        upstate: "",
        files: "",
        edate: "",
      };
      $scope.Showloader = false;
      $scope.getAllStates = function () {
        $scope.allState.length = 0;
        $scope.loader = true;
        // console.log("address.state", $scope.address.state);
        MyService.getAllStates().then(
          function (payload) {
            console.log("payload : ", payload);
            $scope.allState = payload;
            var addNwState = payload;
            var smpl = {
              state: "NA",
              statePostalCode: "NA",
            };
            addNwState.unshift(smpl);
            $scope.loader = false;
          },
          function (errorPayload) {
            growl.error("Something went wrong.");
            $scope.loader = false;
          }
        );
      };
      $scope.getAllStates();

      /**
       * @description Get the election dates record
       */

      $scope.getElectionDates = function () {
        MyService.getListOfDates().then(function (APIResponse) {
          MyService.ConsoleLog("APIResponse > ", APIResponse);
          $scope.electionDates = APIResponse.data.data.map(function (
            electionDate
          ) {
            return new Date(electionDate).toISOString().split("T")[0];
          });
        });
      };

      $scope.sendInvitations = function () {
        $scope.Showloader = true;

        MyService.ConsoleLog("$scope.address > ", $scope.address);
        const argument = {
          state: $scope.address.state.state,
          statePostalCode: $scope.address.state.statePostalCode,
          electionDate: $scope.address.eDate,
        };
        MyService.sendInvitations(argument).then(function (apiResponse) {
          MyService.ConsoleLog("apiResponse > ", apiResponse);
          if (apiResponse && apiResponse.data.success) {
            growl.success(apiResponse.data.data);
            $scope.Showloader = false;
          } else {
            growl.error("Something went wrong");
            $scope.Showloader = false;
          }
        });
      };
    },
  ]);

'use strict';
angular.module('myApp.sendEmail', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/sendEmail', {
      templateUrl: 'app/sendEmail/sendEmail.html',
      controller: 'AllEmailCtrl'
    });
  }]).controller('AllEmailCtrl', ['$scope', 'ngDialog', 'MyService', function ($scope, ngDialog, MyService) {
    $scope.tinymceOptions = {
      plugins: [
        'advlist autolink lists link image charmap print preview hr anchor pagebreak',
        'searchreplace wordcount visualblocks visualchars code fullscreen',
        'insertdatetime media nonbreaking save table contextmenu directionality',
        'emoticons template paste textcolor colorpicker textpattern imagetools'
      ],
      toolbar: ''
    };
    $scope.Email = {
      userType: "",
      toField: "",
      subject: "",
      message: "",
      officeType: ""
    };

    $scope.usersType = ["Politicians", "Advocate", "Press", "Voters", "Voteradmin", "Forumadmin", "Custom"];
    $scope.allOfficeType = ["inOffice", "runningForOffice"];

    $scope.SendMail = function ($event) {
      // MyService.ConsoleLog($scope.Email);
      $event.stopPropagation();
      var submitForm = true;
      if ($scope.Email.userType == "") {
        alert("Please select user type");
        submitForm = false;
      }
      if (submitForm && $scope.Email.userType == "Custom" && $scope.Email.toField == "") {
        alert("To field cannot be empty");
        submitForm = false;
      }

      if (submitForm && $scope.Email.subject == "") {
        alert("Please enter Subject");
        submitForm = false;
      }

      if (submitForm && $scope.Email.message == "") {
        alert("Please enter Message");
        submitForm = false;
      }
      $scope.DisableEmail = false;
      if (submitForm) {
        $scope.DisableEmail = true;
        MyService.sendBatchMail($scope.Email).then(function (payload) {
          //MyService.ConsoleLog(payload);
          if (payload.data.success) {
            var message = "Your Message(s) are queued, will be send depending on the recipient number."
            var modal = ngDialog.openConfirm({
              template: '<p>' + message + '</p>\
                            <div class="ngdialog-buttons">\
                                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                            </div>',
              plain: true
            });
            modal.then(function fullfilled(data) {
              //MyService.ConsoleLog("fullfilled: ", data);


            }, function rejected(data) {
              //MyService.ConsoleLog("rejected: ", data);
            });
            $scope.DisableEmail = false;
            $scope.Email = {
              userType: "",
              toField: "",
              subject: "",
              message: ""
            };
          } else {
            alert("Something went wrong");
            $scope.DisableEmail = false;
            $scope.Email = {
              userType: "",
              toField: "",
              subject: "",
              message: ""
            };
          }

        }, function (errorPayload) {
          //MyService.ConsoleLog(errorPayload);
          alert("Something went wrong");
          $scope.DisableEmail = false;
          $scope.Email = {
            userType: "",
            toField: "",
            subject: "",
            message: ""
          };
        })
      }

    };
  }])

'use strict';
angular.module('myApp.restorePolitician', ['ngRoute'])

  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/restorePolitician/:type?', {
      templateUrl: 'app/restorePoliticians/restorePoliticians.html',
      controller: 'RemovePoliticianCtrl'
    });
  }])
  .controller('RemovePoliticianCtrl', ['$scope', '$location', '$rootScope', 'tokenService', 'MyService', 'ngDialog', '$routeParams', function($scope, $location, $rootScope, tokenService, MyService, ngDialog, $routeParams) {
    //MyService.ConsoleLog("* Following *");
    $scope.politician = {
      data: []
    };
    $scope.showHUpload = false;
    $scope.totalUsers = 0;
    $scope.usersPerPage = 25; // this should match however many results your API puts on one page

    $scope.pagination = {
      current: 1
    };
    $scope.showLoading = false;


    $scope.pageChanged = function(newPage) {
      $scope.getHistoryPolitician(newPage);
    };

    $scope.getHistoryPolitician = function(pageNumber) {
      // this is just an example, in reality this stuff should be in a service
      $scope.showLoading = true;
      MyService.getHistoryPolitician({
        "pageno": pageNumber,
        "max_records": $scope.usersPerPage
      }).then(function(payload) {
        $scope.politician.data = payload.Items;
        $scope.totalUsers = payload.Count;
        //MyService.ConsoleLog(payload.Items);
        $scope.showLoading = false;
      }, function(err) {
        //MyService.ConsoleLog(err);
      });
    }

    $scope.restorePolitician = function(mydata, idx) {
      var message = 'This action will restore the politician as well as its user account and other details if it already exists. Do you want to proceed?';

      var modal = ngDialog.openConfirm({
        template: '<p>' + message + '</p>\
            <div class="ngdialog-buttons">\
                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">YES</button>\
                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">NO</button>\
            </div>',
        plain: true
      });
      modal.then(function fullfilled(data) {
        //MyService.ConsoleLog("fullfilled: ", mydata);
        MyService.restorePolitician({
          "id": mydata.delId
        }).then(function(payload) {
          //MyService.ConsoleLog(payload);
          //$scope.UserFormDiv = false;
          $scope.getHistoryPolitician(1);
          alert("Politician restored successfully.");
        }, function(error) {
          alert(JSON.stringify(error));
        });
      }, function rejected(data) {
        //MyService.ConsoleLog("rejected: ", data);
      });
    }

    if ($rootScope.showRUpload) {
      $scope.getHistoryPolitician(1);
    }
  }])
  
'use strict';
angular
  .module('myApp.resetPassword', ['ngRoute'])
  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/resetPassword', {
        templateUrl: 'app/resetPassword/resetPassword.html',
        controller: 'resetPasswordCtrl',
      });
    },
  ])

  .controller('resetPasswordCtrl', [
    '$scope',
    '$http',
    '$location',
    'growl',
    'tokenService',
    'baseApiUrl',
    '$rootScope',
    'MyService',
    function ($scope, $http, $location, growl, tokenService, baseApiUrl, $rootScope, MyService) {
      $scope.UserName = '';
      $scope.Password = '';
      $rootScope.welcome = false;

      $scope.showDrop = false;
      $scope.User = {
        uName: ""
      };


      /**
       * This function called when input box loses focus.
       * function search users with same email address
       */
      $scope.detectEmail = function () {
        MyService.ConsoleLog("forgotEmail", $scope.forgotEmail);
        var postobj = {};
        postobj.email = $scope.forgotEmail;
        MyService.checkEmailForMultiUsers(postobj).then(function (result) {
          if (result) {
            MyService.ConsoleLog("Result", result);
            if (result.data.data.length > 1) {
              MyService.ConsoleLog("IFFFFFFFFFFFFFFFF");
              $scope.showDrop = true;
              $scope.dropData = result.data.data;
              MyService.ConsoleLog("$scope.uName", $scope.uName);
              if ($scope.uName && $scope.uName != "") {

                alert($scope.uName);
              }
            }
          }

        }, function (err) {
          MyService.ConsoleLog("Error", err);
        });
      };

      $scope.requestPasswordReset = function () {
        if ($.fn.validateForceFully($('#forgotPassForm')) == true) {
          var postobj = {
            email: $scope.forgotEmail,
            reset_url: $rootScope.getPasswordResetUrl(),
            checkName: $scope.User.uName ? $scope.User.uName.name : ""
          };
          MyService.ConsoleLog("$scope.uName", $scope.User.uName.name);

          MyService.forgotPassword(postobj).then(
            function (response) {
              MyService.ConsoleLog(response);
              if (response.data.success) {
                growl.success('An email has been sent.');
              } else {
                if (typeof response.data.error == 'string') growl.error(response.data.error);
                else growl.error('Something went wrong');
              }
            },
            function (err) {
              growl.error('Something went wrong');
            }
          );
        }
      };

      $(document).ready(function () {
        console.log('onready');

        $('#forgotPassForm').validationEngine();
      });
    },
  ]);

'use strict';
angular.module('myApp.research', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
  $routeProvider.when('/research', {
    templateUrl: 'app/research/research.html',
    controller: 'researchCtrl'
  }),
 
  $routeProvider.when('/boardsofelections', {
    templateUrl: 'app/boardsofelections/boardsofelections.html'
  });
}])

.controller('researchCtrl', ['$scope','$rootScope', '$http','$location','apiCall', 'baseApiUrl', 'MyService', 'growl', function ($scope, $rootScope, $http, $location, apiCall, baseApiUrl, MyService, growl) {
//MyService.ConsoleLog("LearnHome called");
  $scope.imgUrl = baseApiUrl+"/resources";
$rootScope.welcome = false;
  $scope.statusGetEssayCat = 0;
  function getCategories(params) {
    /*var request = apiCall.apiCall('GET', '/categories/list', {root: 1});
    $http(
      request
    ).then(function successCallback(response) {
    //MyService.ConsoleLog("Got categories: ",response);
      if(response.data.success){
        $scope.categories = response.data.data;
      }
      else{
        //MyService.ConsoleLog("Something went wrong: ",response.data);
      }
    }, function errorCallBack(response) {
      //MyService.ConsoleLog("Error: ",response);
    });*/
    $scope.categories = [];
    $scope.statusGetEssayCat = 1;
    
    MyService.getCategories({root: 1, catTypes: "E"}, null).then(function(response){
      //MyService.ConsoleLog(response);
      if(response.data.success){
        $scope.categories = response.data.data;
        $scope.statusGetEssayCat = 2;
      }
      else{
        //MyService.ConsoleLog("Error: ",response.error);
        growl.error("Something went wrong: ");
        $scope.statusGetEssayCat = 3;
      }
    }, function(){
      growl.error("Something went wrong while fetching categories.");
      $scope.statusGetEssayCat = 3;
    });
  }
  getCategories();
}])
.controller('CatSelPressEssayCtrl', ['$scope','$rootScope', '$http','$location','apiCall', 'baseApiUrl', function ($scope, $rootScope, $http, $location, apiCall, baseApiUrl) {
  //MyService.ConsoleLog("CatSelPressEssayCtrl called");
  $scope.imgUrl = baseApiUrl+"/resources";
  $rootScope.welcome = false;
  function getCategories(params) {
    var request = apiCall.apiCall('GET', '/categories/list', {root: 1});
    $http(
      request
    ).then(function successCallback(response) {
    //MyService.ConsoleLog("Got categories: ",response);
    if(response.data.success){
      $scope.categories = response.data.data;
    }
    else{
      //MyService.ConsoleLog("Something went wrong: ",response.data);
    }
    }, function errorCallBack(response) {
      //MyService.ConsoleLog("Error: ",response);
    });
  }
  getCategories();
}]);


'use strict';
angular.module('myApp.representativeVideo', ['ngRoute'])
  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/representativeVideo', {
      templateUrl: 'app/representativeVideo/representativeVideo.html',
      reloadOnSearch: false,
      controller: 'representativeVideoCtrl' //we can name anythin
    });
  }])
  .controller('representativeVideoCtrl', ['$scope', '$rootScope', '$window', function($scope, $rootScope, $window) {
    //this is controller for sampepage.html, we link the conttoler to page in config defination, check above .config
    $rootScope.welcome = false;
    $window.scrollTo(0, 0);
  }]);

'use strict';
angular.module('myApp.reports', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
        $routeProvider.when('/reports', {
            templateUrl: 'app/reports/reports.html',
            controller: 'reportsCtrl'
        });
    }])
    .controller('reportsCtrl', ['$scope', '$rootScope', 'growl', 'ngDialog', 'tokenService', 'MyService', function($scope, $rootScope, growl, ngDialog, tokenService, MyService) {
        //MyService.ConsoleLog("** dashboardCtrl **");
        $rootScope.welcome = false;
        $scope.Report = {
            category: ''
        };
        $scope.TotalRecords = {
            data: []
        };
        $scope.items = {
            total: 0
        };
        $scope.page = 1;
        $scope.max_records = 250;
        $scope.statusGetResPg = 0;

        //AnsweredQuestion start

        $scope.categories = [];
        $scope.subcategories = [];
        $scope.getCategories = function() {
            $scope.showCatLoading = true;
            if ($rootScope.categories) {
                $scope.categories = $rootScope.categories;
                $scope.showCatLoading = false;
            } else {
                MyService.getRootCategoryList({ root: 1, questions_counter: 1, catTypes: "Q,B" }).then(function(payload) {
                    //MyService.ConsoleLog(payload);
                    $scope.categories = payload;
                    $rootScope.categories = payload;
                    $scope.showCatLoading = false;
                }, function(errpayload) {
                    MyService.ConsoleLog(errpayload);
                    $scope.showCatLoading = false;
                });
            }
            // MyService.ConsoleLog($scope.categories);
        }

        $scope.getSubcat = function() {
            if ($scope.Report.category && $scope.Report.category._id) {
                $scope.subcategories.length = 0;
                $scope.showCatLoading = true;
                MyService.getSubCategoryList($scope.Report.category._id).then(function(payload) {
                    $scope.subcategories = payload;
                    $scope.showCatLoading = false;
                }, function(errpayload) {
                    MyService.ConsoleLog(errpayload);
                    $scope.showCatLoading = false;
                });
            }
        }

        //AnsweredQuestion End

        //AreaQuestion Start
        $scope.states = [];
        $scope.counties = [];
        $scope.subcounties = [];
        $scope.getStates = function() {
            $scope.showStateLoading = true;
            MyService.getAllStates().then(function(payload) {
                $scope.showStateLoading = false;
                // MyService.ConsoleLog(payload);
                $scope.states = payload;
            }, function(errpayload) {
                $scope.showStateLoading = false;
                //MyService.ConsoleLog(errpayload);
            });
        }

        $scope.getCounty = function() {
            var statePostalCode = "";
            if ($scope.Report.state && $scope.Report.state.statePostalCode) {
                statePostalCode = $scope.Report.state.statePostalCode;
            }
            if (statePostalCode) {
                $scope.showStateLoading = true;
                $scope.counties.length = 0;
                $scope.subcounties.length = 0;
                MyService.getAllCounties(statePostalCode, $scope.Report.state.statePostalCode).then(function(payload) {
                    $scope.showStateLoading = false;
                    // MyService.ConsoleLog(payload);
                    $scope.counties = payload;
                }, function(errpayload) {
                    $scope.showStateLoading = false;
                    //MyService.ConsoleLog(errpayload);
                });
            } else {
                alert("State is not selected");
            }
        }

        $scope.getPlaces = function() {
                var county = "";
                // MyService.ConsoleLog($scope.Report.county);
                if ($scope.Report.county && $scope.Report.county._id) {
                    county = $scope.Report.county._id;
                }
                if (county) {
                    $scope.showCountyLoading = true;
                    MyService.getAllSubCountiesLocal(county.statePostalCode, county.county, county).then(function(payload) {
                        $scope.showCountyLoading = false;
                        // MyService.ConsoleLog(payload);
                        $scope.subcounties = payload;
                    }, function(errpayload) {
                        $scope.showCountyLoading = false;
                        //MyService.ConsoleLog(errpayload);
                    });
                } else {
                    alert("County is not selected");
                }
            }
            //AreaQuestion End

        $scope.showCatLoading = false;
        $scope.showAnswered = false;
        $scope.showComments = false;
        $scope.ShowCommentsSection = 1;
        $scope.showStateLoading = false;
        $scope.showCountyLoading = false;
        $scope.resetRecord = function() {
            $scope.ReportButton = false;
            $scope.showError = false;
            $scope.RunningFunction = "";
            $scope.totalPages = 0;
            $scope.page = 1;
            $scope.TotalRecords.data.length = 0;
            $scope.Report = {
                category: '',
                subcategory: '',
                state: '',
                county: '',
                place: ''
            };
        }
        $scope.showTab = function(obj) {
            // MyService.ConsoleLog(obj);
            $scope.resetRecord();
            $scope.showAnswered = false;
            $scope.showArea = false;
            $scope.showComments = false;
            $scope.showliveUsers = false;
            switch (obj) {
                case 'AnsweredQuestion':
                    $scope.showAnswered = true;
                    $scope.getCategories();
                    break;
                case 'AreaQuestion':
                    $scope.showArea = true;
                    $scope.getCategories();
                    $scope.getStates();
                    break;
                case 'CommentsQuestion':
                    $scope.showComments = true;
                    $scope.ShowCommentsSection = 1;
                    $scope.getCategories();
                    break;
                case 'liveUsers':
                    $scope.showliveUsers = true;
                    $scope.getLiveUsers();
                    break;
                default:
            }
        }

        $scope.ReportButton = false;
        $scope.showError = false;
        $scope.RunningFunction = "";
        $scope.totalPages = 0;

        $scope.getReport = function() {
             MyService.ConsoleLog($scope.Report.category);
             MyService.ConsoleLog($scope.Report.category._id);
            $scope.RunningFunction = "getReport";
            $scope.ReportButton = true;
            var catID = "";
            if ($scope.Report.category && $scope.Report.category._id) {
                catID = $scope.Report.category._id;
            }
            if ($scope.Report.subcategory && $scope.Report.subcategory._id) {
                catID = $scope.Report.subcategory._id;
            }
            MyService.GetAnsQuestionReport({ "catid": catID, "page": $scope.page, "max_records": $scope.max_records }).then(function(payload) {
                MyService.ConsoleLog("Success");
                MyService.ConsoleLog(payload);
                $scope.ReportButton = false;
                $scope.showError = true;
                if (payload.data.success) {
                    $scope.items.total = 0;
                    $scope.TotalRecords.data.length = 0;
                    $scope.TotalRecords.data = payload.data.data;

                    // }
                    // var finalCount = parseInt($scope.page) * parseInt($scope.max_records)
                    // if(parseInt(payload.data.data.totalCount) < finalCount ) {
                    //     $scope.myPagingFunction();
                    // }
                    // MyService.ConsoleLog($scope.TotalRecords.data);
                } else {
                    alert("Something went wrong");
                }
            }, function(errpayload) {
                $scope.showError = true;
                $scope.ReportButton = false;
                // MyService.ConsoleLog("errpayload");
                alert("Something went wrong");
            })
        }

        $scope.getAreaReport = function() {
            // MyService.ConsoleLog($scope.Report.category);
            // MyService.ConsoleLog($scope.Report.category._id);
            $scope.RunningFunction = "getAreaReport";
            $scope.ReportButton = true;
            var catID = "",
                obj = "";
            if ($scope.Report.state && $scope.Report.state.state) {
                obj = JSON.stringify($scope.Report.state);
            }
            if ($scope.Report.county && $scope.Report.county._id) {
                obj = JSON.stringify($scope.Report.county._id);
            }
            if ($scope.Report.place && $scope.Report.place._id) {
                obj = JSON.stringify($scope.Report.place._id);
            }
            if ($scope.Report.category && $scope.Report.category._id) {
                catID = $scope.Report.category._id;
            }
            if ($scope.Report.subcategory && $scope.Report.subcategory._id) {
                catID = $scope.Report.subcategory._id;
            }
            if ($scope.Report.state && $scope.Report.state.state) {
                MyService.GetAreaQuestionReport({ "catid": catID, "areaobj": obj, "page": $scope.page, "max_records": $scope.max_records }).then(function(payload) {
                    // MyService.ConsoleLog("Success");
                    // MyService.ConsoleLog(payload);
                    $scope.ReportButton = false;
                    $scope.showError = true;
                    if (payload.data.success) {
                        //$scope.items.total = 0;
                        if (payload.data.data.records && payload.data.data.records.length > 0) {
                            $scope.TotalRecords.data = $scope.TotalRecords.data.concat(payload.data.data.records);
                        }
                        var finalCount = parseInt($scope.page) * parseInt($scope.max_records);
                        $scope.totalPages = Math.ceil(parseInt(payload.data.data.totalCount) / parseInt($scope.max_records));
                        // MyService.ConsoleLog("finalCount::", finalCount);
                        if (finalCount < parseInt(payload.data.data.totalCount)) {
                            // MyService.ConsoleLog("Call paginate");
                            $scope.myPagingFunction();
                        }

                        // MyService.ConsoleLog($scope.TotalRecords.data);
                    } else {
                        alert("Something went wrong");
                    }
                }, function(errpayload) {
                    $scope.ReportButton = false;
                    $scope.showError = true;
                    // MyService.ConsoleLog("errpayload");
                    alert("Something went wrong");
                })
            } else {
                $scope.ReportButton = false;
                alert("Please select state");
            }
        }

        $scope.getCommentsReport = function() {
            // MyService.ConsoleLog($scope.Report.category);
            // MyService.ConsoleLog($scope.Report.category._id);
            $scope.RunningFunction = "getCommentsReport";
            $scope.ReportButton = true;
            var catID = "";
            if ($scope.Report.category && $scope.Report.category._id) {
                catID = $scope.Report.category._id;
            }
            if ($scope.Report.subcategory && $scope.Report.subcategory._id) {
                catID = $scope.Report.subcategory._id;
            }
            MyService.GetCommentsQuestionReport({ "catid": catID, "page": $scope.page, "max_records": $scope.max_records }).then(function(payload) {
                // MyService.ConsoleLog("Success");
                // MyService.ConsoleLog(payload);
                $scope.ReportButton = false;
                $scope.showError = true;
                if (payload.data.success) {
                    $scope.items.total = 0;
                    $scope.TotalRecords.data.length = 0;
                    $scope.TotalRecords.data = payload.data.data;

                    // }
                    // var finalCount = parseInt($scope.page) * parseInt($scope.max_records)
                    // if(parseInt(payload.data.data.totalCount) < finalCount ) {
                    //     $scope.myPagingFunction();
                    // }
                    // MyService.ConsoleLog($scope.TotalRecords.data);
                } else {
                    alert("Something went wrong");
                }
            }, function(errpayload) {
                $scope.showError = true;
                $scope.ReportButton = false;
                // MyService.ConsoleLog("errpayload");
                alert("Something went wrong");
            })
        }
        $scope.CommentQuestion = "";
        $scope.AllComments = [];
        $scope.getComments = function(id) {
            $scope.AllComments.length = 0;
            $scope.loading = true;
            MyService.getComments({ "id": id }).then(function(payload) {
                //MyService.ConsoleLog(payload);
                $scope.loading = false;
                if (payload.data.success) {

                    $scope.AllComments = payload.data.data;
                } else {
                    alert("Something went wrong");
                }
            }, function(errpayload) {
                $scope.loading = false;
                //MyService.ConsoleLog(errpayload);
                alert("Something went wrong");
            })
        }
        $scope.CommentQuestion = "";
        $scope.returnPage = '';
        $scope.gotoBack = function(id) {
            if ($scope.returnPage == 'Answer') {
                $scope.showArea = false;
                $scope.showComments = false;
                $scope.showAnswered = true;
            } else {
                $scope.ShowCommentsSection = id;
            }
        }
        $scope.DisplayAComments = function(data) {
            //alert("herre");
            //MyService.ConsoleLog(data);
            $scope.returnPage = 'Answer';
            $scope.CommentQuestion = data;
            // ngDialog.open({
            //     template: 'reports/comments.html',
            //     width: '80%',
            //     scope: $scope
            // });
            $scope.showAnswered = false;
            $scope.showArea = false;
            $scope.showComments = true;
            $scope.ShowCommentsSection = 2;
            $scope.getComments(data._id);
        }
        $scope.DisplayComments = function(data) {
                //alert("herre");
                //MyService.ConsoleLog(data);
                $scope.CommentQuestion = data;
                // ngDialog.open({
                //     template: 'reports/comments.html',
                //     width: '80%',
                //     scope: $scope
                // });
                $scope.ShowCommentsSection = 2;
                $scope.getComments(data._id);
            }
            // $scope.getUserReport = function() {
            //     $scope.RunningFunction = "getUserReport";
            //     MyService.GetAllUsersAnsReport({}).then(function(payload) {
            //         MyService.ConsoleLog("Success");
            //         MyService.ConsoleLog(payload);
            //         $scope.showError = true;
            //     }, function(errpayload) {
            //         $scope.ReportButton = false;
            //         MyService.ConsoleLog("errpayload");
            //         $scope.showError = true;
            //         alert("Something went wrong");
            //     })
            // }

        $scope.myPagingFunction = function() {
            if ($scope.RunningFunction != "") {
                if ($scope.page < $scope.totalPages) {
                    $scope.page++;
                    if ($scope.RunningFunction == "getAreaReport") {
                        $scope.getAreaReport();
                    }
                }
            }
        }
        $scope.userData = "";
        $scope.AllAnswers = [];
        $scope.loading = false;
        $scope.gotoUserAnswers = function(userdata) {
            MyService.ConsoleLog(userdata);
            $scope.userData = userdata.userData;
            $scope.ShowCommentsSection = 3;
            if ($scope.userData._id) {
                $scope.loading = true;
                MyService.getUserAnsQuestion({ "id": $scope.userData._id }).then(function(payload) {
                    MyService.ConsoleLog(payload);
                    if (payload.data.success) {
                        $scope.AllAnswers = payload.data.data;
                        $scope.loading = false;
                    } else {
                        $scope.loading = false;
                        alert("Something went wrong.");
                    }
                }, function(errpayload) {
                    $scope.loading = false;
                    alert("Something went wrong.");
                });
            } else {
                alert("Please select user first");
            }
        }

        $scope.ShowOrderList = false;
        $scope.showOrder = function() {
            if (!$scope.ShowOrderList) {
                $scope.ShowOrderList = true;
            } else {
                $scope.ShowOrderList = false;
            }
        }

        $scope.Importance = false;
        $scope.Agree = false;

        $scope.ShowImp = function(option) {
            switch (option) {
                case "Importance":
                    if (!$scope.Importance) {
                        $scope.Importance = true;
                    } else {
                        $scope.Importance = false;
                    }
                    break;
                case "Agree":
                    if (!$scope.Agree) {
                        $scope.Agree = true;
                    } else {
                        $scope.Agree = false;
                    }
                    break;
                case "Default":
                    $scope.Importance = false;
                    break;
            }
        }

        $scope.search = {
            importance: '',
            importancesmin: 0,
            importancesmax: 100,
            importanceimin: 0,
            importanceimax: 100,
            importancevmin: 0,
            importancevmax: 100,
            agree: '',
            strongagreemin: 0,
            strongagreemax: 100,
            agreemin: 0,
            agreemax: 100,
            sortagreemin: 0,
            sortagreemax: 100,
            sortdisagreemin: 0,
            sortdisagreemax: 100,
            disagreemin: 0,
            disagreemax: 100,
            strongdisagreemin: 0,
            strongdisagreemax: 100,
        };

        $scope.filterFn = function(item) {
            if ($scope.search.importance == '' || $scope.search.agree != '') {
                switch ($scope.search.agree) {
                    case 'Very strongly agree':
                        if (item.strongAgreeAvg && ((item.strongAgreeAvg > $scope.search.strongagreemin) && (item.strongAgreeAvg < $scope.search.strongagreemax))) {
                            return true; // this will be listed in the results
                        }
                        break;
                    case 'Agree':
                        if (item.AgreeAvg && ((item.AgreeAvg > $scope.search.agreemin) && (item.AgreeAvg < $scope.search.agreemax))) {
                            return true; // this will be listed in the results
                        }
                        break;
                    case 'Sort of agree':
                        if (item.sortAgreeAvg && ((item.sortAgreeAvg > $scope.search.sortagreemin) && (item.sortAgreeAvg < $scope.search.sortagreemax))) {
                            return true; // this will be listed in the results
                        }
                        break;
                    case 'Sort of disagree':
                        if (item.sortDisagreeAvg && ((item.sortDisagreeAvg > $scope.search.sortdisagreemin) && (item.sortDisagreeAvg < $scope.search.sortdisagreemax))) {
                            return true; // this will be listed in the results
                        }
                        break;
                    case 'Disagree':
                        if (item.DisagreeAvg && ((item.DisagreeAvg > $scope.search.disagreemin) && (item.DisagreeAvg < $scope.search.disagreemax))) {
                            return true; // this will be listed in the results
                        }
                        break;
                    case 'Very strongly disagree':
                        if (item.strongDisagreeAvg && ((item.strongDisagreeAvg > $scope.search.strongdisagreemin) && (item.strongDisagreeAvg < $scope.search.strongdisagreemax))) {
                            return true; // this will be listed in the results
                        }
                        break;
                    default:
                        return true;
                }
                return false; // otherwise it won't be within the results
            } else if ($scope.search.agree == '' || $scope.search.importance != '') {
                switch ($scope.search.importance) {
                    case 'Somewhat':
                        if (item.somewhatAvg && ((item.somewhatAvg > $scope.search.importancesmin) && (item.somewhatAvg < $scope.search.importancesmax))) {
                            return true; // this will be listed in the results
                        }
                        break;
                    case 'Important':
                        if (item.improtantAvg && ((item.improtantAvg > $scope.search.importanceimin) && (item.improtantAvg < $scope.search.importanceimax))) {
                            return true; // this will be listed in the results
                        }
                        break;
                    case 'Very Important':
                        if (item.veryImprotantAvg && ((item.veryImprotantAvg > $scope.search.importancevmin) && (item.veryImprotantAvg < $scope.search.importancevmax))) {
                            return true; // this will be listed in the results
                        }
                        break;
                    default:
                        return true;
                }
                return false; // otherwise it won't be within the results
            } else {
                return true; // otherwise it won't be within the results
            }
        };

        $scope.liveusersrecords = {};
        $scope.loadingExtra = false;
        $scope.getLiveUsers = function() {
            $scope.loadingExtra = true;
            MyService.getLiveUsers({}).then(function(payload) {
                $scope.loadingExtra = false;
                MyService.ConsoleLog(payload);
                $scope.liveusersrecords = payload;
            }, function(errpayload) {
                $scope.loadingExtra = false;
                alert("Something went wrong.");
                MyService.ConsoleLog(errpayload);
            });
        }


    }]);

'use strict';

angular.module('myApp.registerToVote', ['ngRoute'])

.config(['$routeProvider', function ($routeProvider) {
     $routeProvider.when('/registerToVote', {
         templateUrl: 'app/registerToVote/registerToVote.html',
         controller: 'registerToVoteCtrl' 
     });
}])
.controller('registerToVoteCtrl', ['$scope', '$rootScope', function($scope, $rootScope) {
$rootScope.welcome = false;
}]);

'use strict';
angular.module('myApp.ratingsDetails', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/ratingsDetails', {
      templateUrl: 'app/ratingsDetails/ratingsDetails.html',
      controller: 'ratingsDetailsCtrl'
    });
    $routeProvider.when('/ratingsDetails/:id/:uid?/:type?', {
      templateUrl: 'app/ratingsDetails/ratingsDetails.html',
      controller: 'ratingsDetailsCtrl'
    });
  }])
  .controller('ratingsDetailsCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService) {
    $scope.reviewId = $routeParams.id;
    $scope.usid = $routeParams.uid;
    $scope.type = $routeParams.type;
    $scope.key = "fdbde8c0a9f34ec9607eb83ecd246836";
    MyService.ConsoleLog("uid :", $scope.usid);

    // $scope.flguid=false;
    // if($scope.usid && $scope.usid !==''){
    //   MyService.ConsoleLog("welcome to flag");
    //   $scope.flguid=true;
    // }

    $scope.$on('$viewContentLoaded', function () {
      $scope.getData();
    });

    $scope.politicianId = "";


    $scope.pdata = "";
    $scope.getData = function () {
      MyService.getReviewsById({
        id: $routeParams.id,
      }).then(function (response) {
        MyService.ConsoleLog("response >>>>>>>>>> :::", JSON.parse(response.data.data));
        if (response.data.success) {
          // response.data.data[0].links = JSON.parse(response.data.data[0].votewise.links.split(','));
          // var Ars = [];
          $scope.reviewDetails = JSON.parse(response.data.data);
          // Ars.push($scope.reviewDetails.votesmart);
          // $scope.reviewDetails.votesmart = Ars;
          console.log("reviewDetails : ", $scope.reviewDetails);
          if ($scope.reviewDetails.votesmart[0].links && $scope.reviewDetails.votesmart[0].links != '') {
            $scope.arrLinks = $scope.reviewDetails.votesmart[0].links.split(',');
            MyService.ConsoleLog("$scope.arrLinks", $scope.arrLinks);
          }

          if ($scope.reviewDetails.votesmart[0]) {
            $scope.politicianId = $scope.reviewDetails.votesmart[0].to ? $scope.reviewDetails.votesmart[0].to[0].uid : '';
          }
          if ($scope.reviewDetails.votesmart.length > 0 && $scope.reviewDetails.votesmart[0].candidateRating[0].candidateId) {
            MyService.getVotesmartRatings({
              "key": $scope.key,
              "id": $scope.reviewDetails.votesmart[0].candidateRating[0].candidateId,
              "sigid": $scope.reviewDetails.votesmart[0].sig.sigId
            }).then(function (payload) {
              // console.log("payload >> ", payload);
              if (payload.status == 200) {
                // console.log(payload.data.candidateRating);
                MyService.ConsoleLog("payload.data.candidateRating", payload.data.candidateRating);
                $scope.pdata = payload.data.candidateRating.rating;
                $scope.candiName = payload.data.candidateRating.candidate.firstName + " " + payload.data.candidateRating.candidate.lastName;

              }
            }, function (epayload) {
              console.log("epayload >> ", epayload);
            })
          }

        }
      }, function (errorPayload) {});
    }

  }]);

'use strict';
angular.module('myApp.ratingReviews', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/ratingReviews', {
      templateUrl: 'app/ratingReviews/ratingReviews.html',
      controller: 'ratingReviewsCtrl'
    });
  }])
  .controller('ratingReviewsCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService) {

    $scope.organizations = [];

    MyService.getOrgCompareAnswers().then(function (payload) {
      MyService.ConsoleLog("payload : ", payload);
      if (payload.data.success) {
        $scope.organizations = payload.data.data;
        console.log('$scope.organizations: ', $scope.organizations);
      }
    }, function (errorpayload) {
      console.log("errorpayload : ", errorpayload);
    });

  }]);

'use strict';
angular.module('myApp.ratePolitician', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/ratePolitician', {
      templateUrl: 'app/ratePolitician/ratePolitician.html',
      controller: 'ratePoliticianCtrl'
    });
  }])
  .controller('ratePoliticianCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', 'growl', 'ngDialog', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService, growl, ngDialog) {

    $scope.User = {
      name: "",
      state: "",
      runningFor: ""
    };
    $scope.showEndorse = false;
    if (tokenService.getUserId()) {
      MyService.ConsoleLog("tokenService.getUserId()", tokenService.getUserId());
    };
    /**
     * Function called on page load and fetch state infromation from database
     */
    $scope.allState = [];
    $scope.getAllStates = function () {
      $scope.allState.length = 0;
      $scope.loader = true;
      // console.log("address.state", $scope.address.state);
      MyService.getAllStates().then(
        function (payload) {
          // console.log("payload : ", payload);
          $scope.allState = payload;
          $scope.loader = false;
        },
        function (errorPayload) {
          growl.error("Something went wrong.");
          $scope.loader = false;
        }
      );
    };

    $scope.getAllStates();

    /**
     * Search politician and users on the basis of search criteria
     */

    $scope.search = function () {
      MyService.ConsoleLog("User", $scope.User);

      MyService.searchForRate({
        name: $scope.User.name,
        state: $scope.User.state.statePostalCode,
        runningFor: $scope.User.runningFor,
        orgId: tokenService.getUserId()
      }).then(function (response) {
        MyService.ConsoleLog("Response", response);
        $scope.searchResult = response.data.data;
      }, function (err) {
        growl.error(err);
      });
    };

    /**
     * Endorse Politician and users
     * show text area for note
     */
    $scope.fEndorse = false;
    $scope.endorse = function (udata, type) {
      if (type == "endorse") {
        $scope.fEndorse = true;
        $scope.chkId = udata._id;
        $scope.MyDialog = ngDialog.open({
          template: "notePop",
          scope: $scope
          // className: 'ngdialog-theme-default'
        });
      } else {
        $scope.disNote = udata.note;
        $scope.MyDialogTwo = ngDialog.open({
          template: "disNotePop",
          scope: $scope
          // className: 'ngdialog-theme-default'
        });
      }

      $scope.userData = udata;
      MyService.ConsoleLog("Endorse", $scope.fEndorse);
    };

    $scope.addInfo = function () {
      // alert("all");
      MyService.ConsoleLog("note", $scope.User.note);
      MyService.ConsoleLog("userData", $scope.userData);
      MyService.endorsePoli({
        udata: $scope.userData,
        eflag: $scope.fEndorse,
        note: $scope.User.note,
        orgId: tokenService.getUserId()
      }).then(function (response) {
        MyService.ConsoleLog("response", response);
        $scope.showEndorse = true;
        $scope.User.note = "";
        $scope.search();
        $scope.MyDialog.close();
      }, function (err) {
        growl.error(err);
      });
    };

    $scope.close = function () {
      $scope.MyDialogTwo.close();
    };

  }]);

'use strict';
angular.module('myApp.rateBallotMeasures', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/rateBallotMeasures/:id', {
      templateUrl: 'app/rateBallotMeasures/rateBallotMeasures.html',
      controller: 'rateBallotMeasuresCtrl'
    });
  }])
  .controller('rateBallotMeasuresCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', '$sce', 'growl', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService, $sce, growl) {

    /**
     * Get params using Route params
     */
    $scope.bId = $routeParams.id;
    MyService.ConsoleLog(" $scope.bId", $scope.bId);
    $scope.userId = tokenService.getUserId();
    $scope.userData = JSON.parse(tokenService.getUserData());
    // MyService.ConsoleLog("$scope.userData", $scope.userData);
    $scope.review = {
      toId: '',
      toName: '',
      fromId: $scope.userData.id,
      fromName: $scope.userData.name,
      fromType: '',
      grade: {
        number: 0,
        letter: '',
        like: 'true'
      },
      text: '',
      links: []
    };
    $scope.showLoader = false;

    /**
     * Get Ballot measures Details
     */
    $scope.selectedUser = {};
    /**
     * Get Details of ballot measures
     */
    $scope.getDetailsOfBallot = function () {
      MyService.getDetailsOfBallotMeasures({
        bId: $scope.bId
      }).then(function (response) {
        MyService.ConsoleLog("Response", response);

        if (response) {
          $scope.selectedUser.value = response.title;
          $scope.review = {
            toId: response._id,
            toName: response.title,
            fromId: $scope.userData.id,
            fromName: $scope.userData.name,
            fromType: $scope.userType,
            grade: {
              number: 0,
              letter: '',
              like: 'true'
            },
            text: '',
            links: []
          };
        }
      }, function (err) {
        MyService.ConsoleLog("Error", err);
      });
    };

    /**
     * Save Raviews
     */
    $scope.submitReview = function () {

      var params = {
        toId: $scope.review.toId,
        toName: $scope.review.toName,
        fromId: $scope.review.fromId,
        fromName: $scope.review.fromName,
        fromType: $scope.userType,
        number: $scope.review.grade.number,
        letter: $scope.review.grade.letter,
        like: $scope.review.grade.like,
        review: $scope.review.text,
        links: $scope.review.links
      };

      MyService.ConsoleLog("params : ", params);
      if (params.number && params.number != '') {
        MyService.rateBallotMeasures(params).then(function (response) {

          if (response.data.success == true) {

            $scope.review = {
              to: '',
              from: $scope.userId,
              referal: '',
              grade: {
                number: 0,
                letter: '',
                like: 'true'
              },
              text: '',
              links: ''
            }
            MyService.ConsoleLog("success : ", response.data.data);
            $location.path('/ballotRatings/' + params.toId);
          }
        }, function (err) {
          // MyService.ConsoleLog('err: ', err);
        });
      } else {
        growl.error("Please fill the ratings");
      }
    };

    /**
     * Get current user details
     */
    $scope.getUserDetails = function () {
      MyService.getUserPublicProfile({
        id: $scope.userId,
        type: 'false'
      }).then(function (response) {
        $scope.ShowPorifleLoading = false;
        if (response.data.success) {
          $scope.userDetails = response.data.data;
          // MyService.ConsoleLog("welcome", $scope.userDetails);
          $scope.userProfile = $scope.userDetails.userData;
          MyService.ConsoleLog("welcome to profile", $scope.userProfile);

          $scope.userType = $scope.userProfile.userType;
          MyService.ConsoleLog("welcome to profile", $scope.userType);

          $scope.getDetailsOfBallot();
        } else {
          MyService.ConsoleLog("ELSE vishal");
          alert("Something went wrong.");
        }
      }, function (errorPayload) {
        $scope.ShowPorifleLoading = false;
        MyService.ConsoleLog("ELSE vishal two");

        alert("Something went wrong.");
      });
    };
    $scope.getUserDetails();

  }]);

'use strict';
angular.module('myApp.quizzesOrg', ['ngRoute'])

  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/quizzesOrg', {
      templateUrl: 'app/quizzesOrg/quizzesOrg.html',
      controller: 'quizzesOrgCtrl'
    });
  }])
  .controller('quizzesOrgCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService) {

  }]);

'use strict';
angular.module('myApp.quizzes', ['ngRoute'])

  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/quizzes', {
      templateUrl: 'app/quizzes/quizzes.html',
      controller: 'quizzesCtrl'
    });
  }])
  .controller('quizzesCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService) {

  }]);

'use strict';
angular
  .module('myApp.quizResult', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/quizResult', {
        templateUrl: 'app/quizResult/quizResult.html',
        controller: 'quizResultCtrl',
      });
    },
  ]).controller('quizResultCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    '$routeParams',
    '$q',
    'ngDialog',
    '$rootScope',
    'growl',
    'MyService',
    '$anchorScroll',
    '$timeout',
    'tokenService',
    '$cookies',
    'baseApiUrl',
    '$document',
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $q,
      ngDialog,
      $rootScope,
      growl,
      MyService,
      $anchorScroll,
      $timeout,
      tokenService,
      $cookies,
      baseApiUrl,
      $document
    ) {

      /**
       * Get user data
       */
      $scope.userId = tokenService.getUserId();
      MyService.ConsoleLog("tokenservice", $scope.userId);

      /**
       * Get quiz result
       */

      $scope.getResult = function () {

        MyService.getResultData({
          orgId: $scope.userId
        }).then(function (response) {
          MyService.ConsoleLog("response", response);
          $scope.list = response.data.data;
        }, function (err) {
          MyService.ConsoleLog("error", err);
        });
      };
      $scope.getResult();
    }
  ]);

'use strict';
angular.module('myApp.questionSubcategories', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/questionSubcategories/:categoryId', {
      templateUrl: 'app/questionSubcategories/questionSubcategories.html',
      controller: 'questionSubcategoriesCtrl'
    });
  }])
  .controller('questionSubcategoriesCtrl', ['$scope', '$rootScope', '$http', '$location', 'apiCall', '$routeParams', '$q', 'MyService', function ($scope, $rootScope, $http, $location, apiCall, $routeParams, $q, MyService) {
    //MyService.ConsoleLog("** questionSubcategoriesCtrl ** :",$routeParams);
    $rootScope.welcome = false;
    $scope.getAnsweredQuesCount = function (ids) {
      var request = apiCall.apiCall('POST', '/categories/count-answered-questions', {
        "ids": ids
      });
      request.headers['Cache-Control'] = 'No-Store';
      $http(
        request
      ).then(function successCallback(response) {
        //MyService.ConsoleLog("Got categories: ",response);
        if (response.data.success) {
          var total_answered_ques = response.data.data;
          //MyService.ConsoleLog("total_answered_ques: ",total_answered_ques);
          if (total_answered_ques > 0) {
            $scope.showMostPopularButton = true;
          }
        } else {
          //MyService.ConsoleLog("Something went wrong: ",response.data);
        }
      }, function errorCallBack(response) {
        //MyService.ConsoleLog("Error: ",response);
      });
    };

    function getSubCategories(params) {
      var request = apiCall.apiCall('GET', '/categories/list', {
        parentId: $routeParams.categoryId,
        catTypes: "Q,B"
      });
      request.headers['Cache-Control'] = 'No-Store';
      $http(
        request
      ).then(function successCallback(response) {
        MyService.ConsoleLog("Got sub categories: ", response);
        if (response.data.success) {
          $scope.subCategories = response.data.data;
          var catids = [];
          angular.forEach($scope.subCategories, function (val, key) {
            if (val._id) catids.push(val._id);
          });
          if (catids.length > 0) $scope.getAnsweredQuesCount(catids.join(","));
        } else {
          //MyService.ConsoleLog("Something went wrong: ",response.data);
        }
      }, function errorCallBack(response) {
        //MyService.ConsoleLog("Error: ",response);
      });
    }

    function getCategory(params) {
      var request = apiCall.apiCall('GET', '/categories/list', {
        id: $routeParams.categoryId
      });
      request.headers['Cache-Control'] = 'No-Store';
      $http(
        request
      ).then(function successCallback(response) {
        MyService.ConsoleLog("Got categories: ", response);
        if (response.data.success) {
          $scope.category = response.data.data;
        } else {
          //MyService.ConsoleLog("Something went wrong: ",response.data);
        }
      }, function errorCallBack(response) {
        //MyService.ConsoleLog("Error: ",response);
      });
    }

    function getPopularQuestions() {
      var categoryIds = [];
      if ($routeParams.categoryId) categoryIds.push($routeParams.categoryId);

      angular.forEach($scope.subCategories, function (val, key) {
        categoryIds.push(val._id);
      });

      /*
      var request = apiCall.apiCall('GET', '/answers/popular', {"categoryIds": categoryIds.join(",")});
      $http(
      	request
      ).then(function successCallback(response) {
      	//MyService.ConsoleLog("Got PopularQuestions: ",response);
      	if(response.data.success){
      		var questions = response.data.data;
      		if(questions.length <= 0 && $scope.subCategories.length > 0){
      			$location.path('/question/'+$scope.subCategories[0]._id);
      		}
      		else{
      			$location.path('/question/popular:'+categoryIds.join(","));
      		}
      	}
      	else{
      		//MyService.ConsoleLog("Something went wrong: ",response.data);
      	}
      }, function errorCallBack(response) {
      	//MyService.ConsoleLog("Error: ",response);
      });
      */
      $location.path('/question/popular:' + $routeParams.categoryId);
    }

    $scope.popularQuestions = function () {
      getPopularQuestions();
    };

    if ($routeParams.categoryId) {
      getCategory();
      getSubCategories();
    }



    $scope.goToNextPage = function (cat) {
      var params = {
        questions_counter: 0
      };
      // params.parentId = $routeParams.categoryId+","+cat._id;
      params.parentId = cat._id;
      params.catTypes = "Q,B";
      //MyService.ConsoleLog("params: ",params);
      var request = apiCall.apiCall('GET', '/categories/list', params);
      request.headers['Cache-Control'] = 'No-Store';
      $http(
        request
      ).then(function successCallback(response) {
        MyService.ConsoleLog("Response", response);
        if (response.data.success) {
          if (response.data.success && response.data.data.length > 0) {
            //there is subcategory present
            $location.path("questionSubcategories/" + params.parentId);
          } else {
            MyService.ConsoleLog("there is no subcategory", cat._id);
            // $location.path("question/"+cat._id);
            $location.path("question-background/" + $routeParams.categoryId + "/" + cat._id);
          }
        } else {
          alert("Something went wrong.");
        }
      }, function errorCallBack(response) {
        //MyService.ConsoleLog("Error: ",response);
      });
    };
  }]);

'use strict';
angular.module('myApp.questionSearch', ['ngRoute', 'ngDialog'])
  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/question-search', { //pass user_id = me to see questions tagged to self
      templateUrl: 'app/questionSearch/questionSearch.html',
      controller: 'QuestionSearchCtrl'
    });
  }]).controller('QuestionSearchCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$q', 'ngDialog', '$rootScope', 'growl', 'MyService', '$filter', 'tokenService', '$anchorScroll', '$timeout', function ($scope, $http, $location, apiCall, $routeParams, $q, ngDialog, $rootScope, growl, MyService, $filter, tokenService, $anchorScroll, $timeout) {
    //MyService.ConsoleLog("** QuestionSearchCtrl ** :", $routeParams);
    $rootScope.welcome = false;
    if (tokenService.getUserData()) {
      $scope.userData = JSON.parse(tokenService.getUserData());
    }
    $scope.traverseBackgrounds = [];
    $scope.currBackgroundIndex = 0;
    $scope.status = {
      questions: 0, //1= loading, 2 = loaded, 3 = error
      category: 0
    };
    $scope.flagSkipAnsweredQuestion = true;

    $scope.currentIndex = 0;
    $scope.initializeVariables = function () {
      $scope.importance = null;
      $scope.answer = null;
      $scope.comment = '';
      $scope.reason = '';
    };
    $scope.initializeVariables();


    $scope.initMyAnswer = function () {
      try {
        if ($scope.questions[$scope.currentIndex].my_answer) {
          var my_answer = $scope.importance = $scope.questions[$scope.currentIndex].my_answer;
          $scope.importance = my_answer.importance;
          $scope.answer = my_answer.answer;
          $scope.comment = my_answer.comment;
        } else {
          $scope.initializeVariables();
        }
      } catch (e) {
        $scope.initializeVariables();
        //MyService.ConsoleLog("Exceptoin: ", e)
      }
    };

    $scope.viewOldAnswers = function (old_ans) {
      ngDialog.open({
        template: 'app/popups/view_old_answers.html',
        controller: 'OldAnswerViewerCtrl',
        data: old_ans
      });
    };

    if ($rootScope.userRole == "advocate") {
      var request = apiCall.apiCall('GET', '/user/list', {
        "usertype": "politician"
      });
      $http(
        request
      ).then(function successCallback(response) {
        //MyService.ConsoleLog("Got categories: ",response);
        if (response.data.success) {
          $scope.tagableUsers = response.data.data;
        } else {
          //MyService.ConsoleLog("Something went wrong: ", response.data);
        }
      }, function errorCallBack(response) {
        //MyService.ConsoleLog("Error: ", response);
      });
    }
    $scope.addTags = function (tagUsers) {
      //MyService.ConsoleLog("tagUsers: ", tagUsers);
      //MyService.ConsoleLog("tagUsers: ", $scope.questions[$scope.currentIndex]._id);

      var postData = {
        id: $scope.questions[$scope.currentIndex]._id,
        user_ids: tagUsers.join(",")
      };

      var request = apiCall.apiCall('POST', '/questions/add_tag', postData);
      $http(
        request
      ).then(function successCallback(response) {
        //MyService.ConsoleLog("succss: ", response);
        if (response.data.success) {
          growl.success("Tagged successfully");
        } else {
          if (typeof response.data.error == "string")
            growl.error(response.data.error);
          else
            growl.error("Something went wrong");
        }
      }, function errorCallback(response) {
        growl.error("Something went wrong");
      });
    };

    var getQuestionsCanceler = $q.defer();
    $scope.AllAnsweredQuestions = [];

    function getQuestions(params) {
      getQuestionsCanceler.resolve();
      $scope.status.questions = 1;
      $scope.questions = [];
      getQuestionsCanceler.resolve();
      getQuestionsCanceler = $q.defer();
      MyService.ConsoleLog("QuestionSearchCtrl 2** /questions/list: ", params);
      var request = apiCall.apiCall('GET', '/questions/list', params);
      request.timeout = getQuestionsCanceler.promise;
      $http(
        request
      ).then(function successCallback(response) {
        MyService.ConsoleLog("QuestionSearchCtrl Got categories: ", response);
        if (response.data.success) {
          $scope.status.questions = 2;
          $scope.initMyAnswer();
          MyService.ConsoleLog("data len: ", response.data.data);
          $scope.questions = response.data.data;
          if ($scope.flagSkipAnsweredQuestion) {
            angular.forEach(response.data.data, function (val, key) {
              if (val.myAnswer == null) {
                // $scope.questions.push(val);
              } else {
                $scope.AllAnsweredQuestions.push(val);
              }

            });
            $scope.skipAnswerChagne();
          }

          //MyService.ConsoleLog("total questions: ", $scope.questions.length);
          if ($scope.questions.length > 0) {
            try {
              //MyService.ConsoleLog("Current question: ", $scope.questions[$scope.currentIndex]);
              var tempCate = $scope.questions[$scope.currentIndex].categories;
              if (angular.isArray(tempCate)) {
                $scope.getCategory({
                  id: tempCate[0].cid
                });
              } else {
                $scope.getCategory({
                  id: tempCate.cid
                });
              }
            } catch (e) {
              //MyService.ConsoleLog("category sel Ex: ", e)
            }
          }
        } else {
          $scope.status.questions = 3;
          if (typeof response.data.error == "string")
            growl.error(response.data.error);
          else
            growl.error("Something went wrong");
        }
      }, function errorCallBack(response) {
        $scope.status.questions = 3;
        //MyService.ConsoleLog("Error: ", response);
      });
    }

    var getCategoryCanceler = $q.defer();
    var prevFetchedCategoryId = null;

    $scope.getCategory = function (params) {
      //MyService.ConsoleLog("getCategory : ", params);
      try {
        prevFetchedCategoryId = $scope.category._id
      } catch (e) {}

      if (prevFetchedCategoryId != params.id) {
        //MyService.ConsoleLog("scrollTop");
        $("html, body").animate({
          scrollTop: 0
        }, "slow");
        getCategoryCanceler.resolve();
        getCategoryCanceler = $q.defer();
        $scope.status.category = 1;
        $scope.category = null;
        var request = apiCall.apiCall('GET', '/categories/list', params);
        request.timeout = getCategoryCanceler.promise;
        $http(
            request
          )
          .then(function successCallback(response) {
            //MyService.ConsoleLog("Got categories: ",response);
            if (response.data.success) {
              $scope.category = response.data.data;
              //MyService.ConsoleLog("category data: ", $scope.category);
              prevFetchedCategoryId = $scope.category._id;
              $scope.status.category = 2;
            } else {
              //MyService.ConsoleLog("Something went wrong: ", response.data);
              $scope.status.category = 3;
            }
          }, function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
            $scope.status.category = 3;
          });
      }
    };

    var getLevelCategoryCanceler = $q.defer();

    function getLevelCategory(params) {
      getLevelCategoryCanceler.resolve();
      getLevelCategoryCanceler = $q.defer();
      $scope.status.levlCat = 1;
      var request = apiCall.apiCall('GET', '/categories/list-layer', params);
      request.timeout = getLevelCategoryCanceler.promise;
      $http(
          request
        )
        .then(function successCallback(response) {
          //MyService.ConsoleLog("Got categories: ",response);
          if (response.data.success) {
            /*
            angular.forEach(response.data.data, function(val, key){
                if(val.total_questions > 0){
                    $scope.traverseBackgrounds.push(val);
                }
            });
            //MyService.ConsoleLog("traverseBackgrounds data: ", $scope.traverseBackgrounds);
            if($scope.traverseBackgrounds.length > 0){
                $scope.currBackgroundIndex = 0;
                $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
            }
            */
            $scope.traverseBackgrounds = response.data.data;
            if ($routeParams.selectedCatId) {
              //MyService.ConsoleLog("traverseBackgrounds: ", $scope.traverseBackgrounds);
              //MyService.ConsoleLog("$routeParams.selectedCatId: ", $routeParams.selectedCatId);
              angular.forEach($scope.traverseBackgrounds, function (val, key) {
                if (val._id == $routeParams.selectedCatId) {
                  //MyService.ConsoleLog("val._id: ", val._id, " key: ", key, " total_questions: ", val.total_questions);
                  $scope.currBackgroundIndex = key;
                  //MyService.ConsoleLog("$scope.currBackgroundIndex: ", key);
                  $scope.category = angular.copy(val);
                }
              });
            } else if ($scope.traverseBackgrounds.length > 0) {
              $scope.category = $scope.traverseBackgrounds[0];
            }
            $scope.status.levlCat = 2;
          } else {
            //MyService.ConsoleLog("Something went wrong: ", response.data);
            $scope.status.levlCat = 3;
          }
        }, function errorCallBack(response) {
          //MyService.ConsoleLog("Error: ", response);
          $scope.status.levlCat = 3;
        });
    }

    function getPopularQuestions() {
      //MyService.ConsoleLog("** getPopularQuestions **");
      var categoryIds = $routeParams.categoryId.split("popular:")[1];

      var request = apiCall.apiCall('GET', '/answers/popular', {
        "categoryIds": categoryIds
      });
      $http(
        request
      ).then(function successCallback(response) {
        //MyService.ConsoleLog("Got PopularQuestions: ", response);
        if (response.data.success) {
          // response.data.data[1].categories.cid = "579b6d83d0cfc69732251494"; //for testing purpose
          $scope.questions = response.data.data;
          if ($scope.questions.length > 0) {
            $scope.getCategory({
              id: $scope.questions[0].categories.cid
            });
          }
        } else {
          //MyService.ConsoleLog("Something went wrong: ", response.data);
        }
      }, function errorCallBack(response) {
        //MyService.ConsoleLog("Error: ", response);
      });
    }

    var getPopularCategoriesCanceler = $q.defer();
    $scope.getPopularCategories = function (params) {
      //MyService.ConsoleLog("** getPopularQuestions **");
      getPopularCategoriesCanceler.resolve();
      params.timeout = getPopularCategoriesCanceler.promise;
      var request = apiCall.apiCall('POST', '/categories/popular-subcategories', params);
      $http(
        request
      ).then(function successCallback(response) {
        //MyService.ConsoleLog("Got PopularQuestions: ", response);
        if (response.data.success) {
          // response.data.data[1].categories.cid = "579b6d83d0cfc69732251494"; //for testing purpose
          $scope.traverseBackgrounds = response.data.data;
          if ($scope.traverseBackgrounds.length > 0) {
            $scope.category = $scope.traverseBackgrounds[0];
            prevFetchedCategoryId = $scope.category._id;
            // getQuestions({categoryId: $scope.category._id});
          }
        } else {
          //MyService.ConsoleLog("Something went wrong: ", response.data);
        }
      }, function errorCallBack(response) {
        //MyService.ConsoleLog("Error: ", response);
      });
    };

    $scope.notAnswerableSelected = function () {
      /*
      if($scope.answer == 0){
          var message = 'Many of our Statements have an undeniable fact followed by an opinion.  Like “the sky is blue.  I hate the sky.”  If this is your problem with the question, then realize that this is just part of the question process and just respond to the second half.  If not, please explain the problem in the “add comments” section so we can fix it.  Thank you.';
          var modal = ngDialog.openConfirm({
              template:'<p>'+message+'</p>\
                      <div class="ngdialog-buttons">\
                          <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                      </div>',
              plain: true
          });

          modal.then(function fullfilled(data){
              //MyService.ConsoleLog("fullfilled: ",data);
          }, function rejected(data){
              //MyService.ConsoleLog("rejected: ",data);
          });
      }
      */
      //for report question
      var token = apiCall.getToken();

      if (!token || token == "") {
        var message = "Please login first.";

        var modal = ngDialog.openConfirm({
          template: '<p>' + message + '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
          plain: true
        });

        modal.then(function fullfilled(data) {
          //MyService.ConsoleLog("fullfilled: ", data);
        }, function rejected(data) {
          //MyService.ConsoleLog("rejected: ", data);
        });

        return;
      }
      var postData = {
        questionId: $scope.questions[$scope.currentIndex]._id,
        importance: 0, //$scope.importance,
        answer: $scope.answer,
        comment: $scope.comment
      };

      ngDialog.open({
        template: 'app/popups/report_question.html',
        controller: 'ReportQuesCtrl',
        data: postData
      });

    };

    $scope.postAnswer = function (postData) {
      //MyService.ConsoleLog("postData: ", postData);
      try {
        var my_answer = $scope.questions[$scope.currentIndex].my_answer;
        if (my_answer.importance != $scope.importance || my_answer.answer != $scope.answer || my_answer.comment != $scope.comment) {
          //MyService.ConsoleLog("Answer changed");
          postData.id = my_answer._id;
          postData.reason = $scope.reason;
        } else {
          //MyService.ConsoleLog("Answer not changed");
          return; //don't do anything
        }
      } catch (e) {
        //MyService.ConsoleLog("Exceptoin: ", e);
      }

      MyService.postAnswer(postData).then(function (response) {
        if (response.data.success) {
          try {
            if (postData.id) {
              $scope.questions[$scope.currentIndex]["my_answer"] = {
                _id: postData.id,
                created: new Date(),
                comment: postData.comment,
                answer: postData.answer,
                importance: postData.importance
              };
            } else {
              $scope.questions[$scope.currentIndex]["my_answer"] = {
                _id: response.data.data._id,
                created: response.data.data.created,
                comment: response.data.data.comment,
                answer: response.data.data.answer,
                importance: response.data.data.importance
              };
            }
          } catch (e) {
            //MyService.ConsoleLog("Exceptoin: ", e);
          }

          if (postData.id) {
            growl.success("Answer updated successfully", {
              ttl: 800
            });
          } else {
            growl.success("Answered successfully", {
              ttl: 800
            });
          }
          $scope.initializeVariables();
          $scope.skipQuestion();
        } else {
          growl.error("Error: " + response.data.error);
        }
      }, function (err) {
        growl.error("Something went wrong.");
      });


      /*
      var request = apiCall.apiCall('POST', '/answers/create', postData);
        $http(
          request
        ).then(function successCallback(response) {
          //MyService.ConsoleLog("succss: ",response);
          if(response.data.success){
            try{
                $scope.questions[$scope.currentIndex]["my_answer"] = {
                    _id: response.data.data._id,
                    created: response.data.data.created,
                    comment: response.data.data.comment,
                    answer: response.data.data.answer,
                    importance: response.data.data.importance
                };
            }
            catch(e){
                //MyService.ConsoleLog("Exceptoin: ",e);
            }
            growl.success("Answered successfully", {ttl: 800});
            $scope.initializeVariables();
            $scope.skipQuestion();
          }
          else{
            growl.success("Error: "+response.data.error);
          }
        }, function errorCallback(response) {
          $scope.error = 'Wrong Email or Password';
        });
        */

    };

    $rootScope.$on('question.answered', function (evt, data) {
      //MyService.ConsoleLog("on question.answered: ", data);
      if ($scope.questions[$scope.currentIndex]._id == data.questionId) {
        $scope.initializeVariables();
        $scope.skipQuestion();
      }
    });

    $scope.submitAnswer = function () {
      //MyService.ConsoleLog("submitAnswer: " + $scope.answer);
      //MyService.ConsoleLog("importance: " + $scope.importance);
      //MyService.ConsoleLog("comments: ", $scope.comment);

      var token = apiCall.getToken();

      if (!token || token == "") {
        var message = "Please login first.";

        var modal = ngDialog.openConfirm({
          template: '<p>' + message + '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
          plain: true
        });
        modal.then(function fullfilled(data) {
          //MyService.ConsoleLog("fullfilled: ", data);
        }, function rejected(data) {
          //MyService.ConsoleLog("rejected: ", data);
        });
        return;
      }

      if ($scope.answer == null) {
        var message = "Please select answer first.";
        var modal = ngDialog.openConfirm({
          template: '<p>' + message + '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
          plain: true
        });

        modal.then(function fullfilled(data) {
          //MyService.ConsoleLog("fullfilled: ", data);
        }, function rejected(data) {
          //MyService.ConsoleLog("rejected: ", data);
        });

        return;
      }

      if ($scope.importance == null) {
        var message = "You need to choose an importance level.  Should they fight hard for this can they use it to trade for other things you care about more?";

        var modal = ngDialog.openConfirm({
          template: '<p>' + message + '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
          plain: true
        });

        modal.then(function fullfilled(data) {
          //MyService.ConsoleLog("fullfilled: ", data);
        }, function rejected(data) {
          //MyService.ConsoleLog("rejected: ", data);
        });

        return;
      }

      /*
        var modal = ngDialog.openConfirm({
            template:'<p>Are you sure you want to close the parent dialog?</p>\
                      <div class="ngdialog-buttons">\
                        <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                        <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Yes</button>\
                       </div>',
            plain: true
        });
        //MyService.ConsoleLog("modal: ",modal);
        modal.then(function fullfilled(data){
            //MyService.ConsoleLog("fullfilled: ",data);
        }, function rejected(data){
            //MyService.ConsoleLog("rejected: ",data);
        });
        */
      var postData = {
        questionId: $scope.questions[$scope.currentIndex]._id,
        importance: $scope.importance,
        answer: $scope.answer,
        comment: $scope.comment,
        token: token
      };
      $scope.postAnswer(postData);
    };

    $scope.skipQuestion = function () {
      /*
      $timeout(function() {
        $location.hash('DisplayQ');
        $anchorScroll();
      }, 1500);
      */
      $("html, body").animate({
        scrollTop: $("#DisplayQ").offset().top - 280
      }, "slow");
      var skip = function () {
        var tempIndex = $scope.currentIndex + 1;
        MyService.ConsoleLog("questions > ", $scope.questions);
        if (tempIndex < $scope.questions.length) {
          $scope.initializeVariables();
          $scope.currentIndex++;
          if ($routeParams.categoryId && $routeParams.categoryId.indexOf("popular:") == 0) {
            //we are showing questions of most popular section
            $scope.getCategory({
              id: $scope.questions[$scope.currentIndex].categories.cid
            });
          }
        }
        MyService.ConsoleLog("tempIndex123 = ", tempIndex)
        MyService.ConsoleLog("questions.length ", $scope.questions.length);
        if (tempIndex == $scope.questions.length) {
          MyService.ConsoleLog("end of questions switch background");
          var tempBackIdx = $scope.currBackgroundIndex + 1;
          if (tempBackIdx < $scope.traverseBackgrounds.length) {
            $scope.currBackgroundIndex++;
            $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
          } else {
            MyService.ConsoleLog("* End of background *");
            var catId = $routeParams.categoryId;
            if (!$routeParams.categoryId) {
              catId = $scope.questions[$scope.currentIndex].categories[0].cid;
            }
            //$location.path('/questionSubcategories/' + catId);
            $location.path("/questionHome");
          }
        }
      };

      if ($scope.answer != null) {
        var show_answer_modal = true;
        try {
          var my_answer = $scope.questions[$scope.currentIndex]["my_answer"];
          /*
          for (var key in my_answer) {
            if(my_answer[])
          }
          */
          if (my_answer.importance == $scope.importance && my_answer.answer == $scope.answer && my_answer.comment == $scope.comment)
            show_answer_modal = false;

        } catch (e) {
          //MyService.ConsoleLog("Exceptoin : ", e);
        }
        //MyService.ConsoleLog("show_answer_modal: ", show_answer_modal);
        if (show_answer_modal) {
          var message = 'You just hit the SKIP button.  Are you sure you want to skip this one, or would you rather Submit your answer?';
          var modal = ngDialog.openConfirm({
            template: '<p>' + message + '</p>\
                            <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Skip</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Submit</button>\
                            </div>',
            plain: true,
            closeByDocument: false
          });

          modal.then(function fullfilled(data) {
            //submit answer
            $scope.submitAnswer();
          }, function rejected(data) {
            //skip the answer
            skip();
          });
        } else {
          skip();
        }
      } else {
        skip();
      }
    };
    $scope.prevQuestion = function () {
      //MyService.ConsoleLog("** prevQuestion **");
      // $timeout(function() {
      //   $location.hash('DisplayQ');
      //   $anchorScroll();
      // }, 1500);

      if ($scope.currentIndex > 0) {
        $scope.currentIndex--;
      } else if ($scope.currentIndex == 0) {
        if ($scope.currBackgroundIndex > 0) {
          $scope.currBackgroundIndex--;
          $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
        }
      }
    };

    $scope.compareChanged = function (compare_with) {
      //MyService.ConsoleLog("compare_with :", compare_with);
      var catid = $routeParams.categoryId;
      if ($routeParams.categoryId && $routeParams.categoryId.indexOf("popular:") == 0) {
        var catid = $routeParams.categoryId.split("popular:")[1];
      }

      $location.path('/compare-select/' + compare_with);
    };

    var getCompareAnswersCanceler = $q.defer();

    function getCompareAnswers(params) {
      if (!params) return;
      getCompareAnswersCanceler.resolve();
      params.timeout = getCompareAnswersCanceler.promise;

      $scope.questions = [];
      $scope.status.questions = 1;

      var request = apiCall.apiCall('GET', '/answers/compare', params);
      $http(
        request
      ).then(function successCallback(response) {
        //MyService.ConsoleLog("Got categories: ",response);
        if (response.data.success) {
          $scope.status.questions = 2;
          angular.forEach(response.data.data, function (val, key) {
            if (val.answers && val.answers.length != $rootScope.selectedCompareUsers.length) {
              var check_author_exist = function (u) {
                var len = val.answers.length;
                for (var i = 0; i < len; i++) {
                  if (val.answers[i].author._id == u._id) {
                    return true;
                  }
                }
                return false;
              };
              angular.forEach($rootScope.selectedCompareUsers, function (u, i) {
                if (!check_author_exist(u)) {
                  response.data.data[key].answers.push({
                    author: u
                  });
                }
              });
            } else if (!val.answers) {
              response.data.data[key].answers = [];
              angular.forEach($rootScope.selectedCompareUsers, function (u, i) {
                response.data.data[key].answers.push({
                  author: u
                });
              });
            }
          });
          $scope.questions = response.data.data;
          // $location.path("question-compare/"+$routeParams.category_id+"/"+null);
        } else {
          $scope.status.questions = 3;
          //MyService.ConsoleLog("Something went wrong: ", response.data);
        }
      }, function errorCallBack(response) {
        $scope.status.questions = 3;
        //MyService.ConsoleLog("Error: ", response);
      });
    };

    $scope.initPageData = function () {
      var current_url = $location.url();
      //MyService.ConsoleLog("$location.url: ", current_url);
      if (current_url.indexOf("question-search") > -1) {
        $scope.state = "question-search";

        if (!$filter('isBlankString')($rootScope.searchQuestionKeyword)) {
          var param = {
            keyword: $rootScope.searchQuestionKeyword,
          };
          getQuestions(param);
        }
      }
    };

    $scope.initPageData();


    $scope.checkQuestion = function (val) {
      if ($scope.AllAnsweredQuestions && $scope.AllAnsweredQuestions.length > 0) {
        return $scope.AllAnsweredQuestions.filter(
          function (rdata) {
            MyService.ConsoleLog(rdata._id + "==" + val);
            if (rdata._id == val)
              return rdata
          }
        );
      } else {
        if ($rootScope.fiveMatch) {
          return $rootScope.fiveMatch.filter(
            function (rdata) {
              MyService.ConsoleLog(rdata.statePostalCode + "==" + val);
              if (rdata.questionId == val)
                return rdata
            }
          );
        }

      }

    }

    $scope.checkIfExists = function (val) {
      if ($scope.questions) {
        var obj = $scope.questions[$scope.currentIndex];
        // MyService.ConsoleLog("checkIfExists >> ", obj);
        if (obj) {
          var data = $scope.checkQuestion(obj._id);

          if (data && data[0]) {
            // MyService.ConsoleLog("checkIfExists data>> ", data[0]);
            $scope.comment = data[0].comment;
            if (data[0].answer && data[0].answer != "") {
              if (data[0].answer == val) {
                // console.log("return True");
                // $scope.comment = data[0].comment;
                return true;
              }
            } else {
              if (data[0].myAnswer && data[0].myAnswer.answer == val) {
                // console.log("return myAnswer True");
                // $scope.comment = data[0].myAnswer.comment;
                return true;
              }
            }

          }
        }
        return false;
      } else {
        return false;
      }
    }

    $scope.checkQuestionAnswered = function () {
      // console.log("scope.questions > ", $scope.questions);
      if ($scope.questions) {
        return $scope.questions.filter(
          function (rdata) {
            // MyService.ConsoleLog(rdata._id);
            var data = $scope.checkQuestion(rdata._id);
            if (data && data.length > 0)
              return rdata;
          }
        );
      } else {
        return false;
      }
    }

    $scope.checkImpExists = function (val) {
      if ($scope.questions) {
        var obj = $scope.questions[$scope.currentIndex];

        if (obj) {
          var data = $scope.checkQuestion(obj._id);

          if (data && data[0]) {
            // MyService.ConsoleLog("checkIfExists data>> ", data[0].importance + "==" + val);
            if (data[0].importance && data[0].importance != "") {
              if (data[0].importance == val) {
                // console.log("return True");
                return true;
              }
            } else {
              if (data[0].myAnswer && data[0].myAnswer.importance == val) {
                // console.log("return myAnswer True");
                return true;
              }
            }

          }
        }
        return false;
      } else {
        return false;
      }
    }


    $scope.cachedQuestions = [];

    $scope.saveFiveMinAnswers = function (skip) {
      // MyService.ConsoleLog("saveFiveMinAnswers : ");
      // MyService.ConsoleLog($rootScope.fiveMatch);
      $scope.pstData = [];
      var len = $rootScope.fiveMatch.length;
      if (len > 0) {
        for (var i = 0, k = 1; i < len; i++) {
          if (skip != "" && skip == "skip") {
            $scope.answer = 0;
            $scope.importance = 0;
            $scope.comment = "";
            // MyService.ConsoleLog("saveFiveMinAnswers >> ", $rootScope.fiveMatch[i]);
            var data = $scope.checkQuestion($rootScope.fiveMatch[i]._id);
            if (data && data[0]) {
              // MyService.ConsoleLog("getMatchQUestions >>> ", data[0]);
              if (data[0].answer != "") {
                $scope.answer = data[0].answer;
              }
              if (data[0].importance != "") {
                $scope.importance = data[0].importance;
              }
              if (data[0].comment != "") {
                $scope.comment = data[0].comment;
              }

            }
            var postData = {
              questionId: $rootScope.fiveMatch[i]._id,
              importance: $scope.importance,
              answer: $scope.answer,
              comment: $scope.comment,
              categories: $rootScope.fiveMatch[i]["categories"],
              content: $rootScope.fiveMatch[i]["content"],
              _id: $rootScope.fiveMatch[i]["_id"]
            };
            $scope.pstData.push(postData);
          } else {
            var postData = $rootScope.fiveMatch[i];
          }

          // console.log("postData1 > ", $rootScope.fiveMatch[i]);
          // console.log("postData > ", postData);
          MyService.postAnswer(postData).then(function (response) {
            // MyService.ConsoleLog("saveFiveMinAnswers response >>>", response);
            if (response.data.success) {
              MyService.ConsoleLog("Answer updated successfully");

            } else {
              MyService.ConsoleLog("Error: " + response.data.error);
            }


            // console.log(k + "===" + len);
            if (k == len) {
              // console.log("redirect to five compare");
              if (skip != "" && skip == "skip") {
                $rootScope.fiveMatch = angular.copy($scope.pstData);
                window.localStorage.setItem("fiveMatch", JSON.stringify($rootScope.fiveMatch));
              }
              // console.log("$rootScope.fiveMatch > ", $rootScope.fiveMatch);
              $location.path('/fiveCompare');
            }
            k++;
          }, function (err) {
            MyService.ConsoleLog("Error: ");
          });
        }
      }
    }

    $scope.skipAnswerChagne = function () {
      MyService.ConsoleLog("scope.flagSkipAnsweredQuestion: ", $scope.flagSkipAnsweredQuestion);
      $scope.currentIndex = 0;
      $("html, body").animate({
        scrollTop: $("#DisplayQ").offset().top - 280
      }, "slow");
      var questions = $scope.checkQuestionAnswered();
      // $rootScope.fiveMatch.length = 0;
      // console.log('questions > ', questions);
      if (questions && questions.length > 0) {
        if ($scope.flagSkipAnsweredQuestion) {
          $scope.cachedQuestions.length = 0;
          $scope.cachedQuestions = angular.copy($scope.questions);
          for (var i = 0; i < questions.length; i++) {
            var idx = $scope.questions.indexOf(questions[i]);
            if (idx > -1) {
              $scope.questions.splice(idx, 1);
            }
          }
          // console.log("questionslength > ", $scope.cachedQuestions.length + "==" + questions.length)
          if ($scope.cachedQuestions.length == questions.length) {
            // console.log("questionslength Equal");
            if ($rootScope.fiveMatch.length == 0) {
              $rootScope.fiveMatch = angular.copy($scope.cachedQuestions);
              // MyService.ConsoleLog(" $rootScope.fiveMatch one :", $rootScope.fiveMatch);
              var lents = $rootScope.fiveMatch.length;
              if (lents >= 5) {
                // $scope.skipToRes = true;
                $('#skipMatch').attr('disabled', false);
              }
              $scope.questions = angular.copy($scope.cachedQuestions);
            }
            $scope.saveFiveMinAnswers("skip");
          } else {
            $rootScope.fiveMatch = angular.copy(questions);
            var lent = $rootScope.fiveMatch.length;
            if (lent >= 5) {
              // $scope.skipToRes = true;
              $('#skipMatch').attr('disabled', false);
            }
            // $scope.saveFiveMinAnswers("skip");
            // MyService.ConsoleLog(" $rootScope.fiveMatch two >>>>>>>>> :", $rootScope.fiveMatch);
            // MyService.ConsoleLog(" $rootScope.fiveMatch two >>>>>>>>> :", lent);
          }
        } else {
          $scope.questions = angular.copy($scope.cachedQuestions);
        }
      } else {
        // console.log("Else Else ");
        if (!$scope.flagSkipAnsweredQuestion) {
          if ($scope.cachedQuestions && $scope.cachedQuestions.length > 0) {
            $scope.questions = angular.copy($scope.cachedQuestions);
          }

        }
      }
    };

    /*$scope.$watch('category', function(newValue, oldValue) {
        var current_url = $location.url();

        if(current_url.indexOf("question-tagged") > -1)
            return; //for tagged questions don't again fetch questions

        if(newValue){
            //MyService.ConsoleLog("oldValue: ", oldValue);
            //MyService.ConsoleLog("newValue: ", newValue);
            if(oldValue && oldValue._id == newValue._id) return;
            //MyService.ConsoleLog("scrollTop");
            $("html, body").animate({ scrollTop: 0 }, "slow");
            $scope.currentIndex = 0;

            if(current_url.indexOf("question-compare") > -1){
                //MyService.ConsoleLog("** getCompareAnswers **");

                var temp_uids = [];
                angular.forEach($rootScope.selectedCompareUsers, function(val, key){
                    temp_uids.push(val._id);
                });

                getCompareAnswers({"categoryIds": newValue._id, "userIds": temp_uids.join(",")}); //"compare_with": $routeParams.user_type,
            }
            else{
                getQuestions({categoryId: newValue._id});
            }
        }
    });*/
    $scope.$watch('questions', function (newValue, oldValue) {
      try {
        MyService.ConsoleLog("Current question: ", $scope.questions[$scope.currentIndex]);
        var tempCate = $scope.questions[$scope.currentIndex].categories;
        if (angular.isArray(tempCate)) {
          $scope.getCategory({
            id: tempCate[0].cid
          });
        } else {
          $scope.getCategory({
            id: tempCate.cid
          });
        }

        $scope.initMyAnswer();
      } catch (e) {
        //MyService.ConsoleLog("questions Index Change Ex: ", e)
      }
    });
    $scope.$watch('currentIndex', function (newValue, oldValue) {
      try {
        //MyService.ConsoleLog("Current question: ", $scope.questions[$scope.currentIndex]);
        var tempCate = $scope.questions[$scope.currentIndex].categories;
        if (angular.isArray(tempCate)) {
          $scope.getCategory({
            id: tempCate[0].cid
          });
        } else {
          $scope.getCategory({
            id: tempCate.cid
          });
        }
        $scope.initMyAnswer();
      } catch (e) {
        //MyService.ConsoleLog("Current Index Change Ex: ", e)
      }
    });
    $scope.$on("$destroy", function (event) {
      $rootScope.searchQuestionKeyword = '';
    });
  }])

'use strict';
angular.module('myApp.questionHome', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/questionHome', {
      templateUrl: 'app/questionHome/questionHome.html',
      controller: 'questionHomeCtrl'
    });
  }])
  .controller('questionHomeCtrl', ['$scope', '$http', '$location', 'apiCall', 'MyService', '$rootScope', 'ngDialog', function ($scope, $http, $location, apiCall, MyService, $rootScope, ngDialog) {
    //MyService.ConsoleLog("** questionHomeCtrl **");
    $rootScope.welcome = false;
    $scope.showLocalMatch = true;
    //use $rootScope.categories
    window.localStorage.removeItem('isShowSpecialMatch');
    $scope.matchQuestion = function () {
      $location.path("/question-not-answered");
    }

    // $scope.getLocalPoliticians = function() {
    //   $scope.statusGetLocalPoliticians = 1;
    //   $scope.page += 1;
    //   var extradata = "";
    //   if ($rootScope.FinalData && $rootScope.FinalData != "") {
    //     extradata = $rootScope.FinalData;
    //     //alert("extra");
    //     if ($scope.MyDialog != "") {
    //       $scope.MyDialog.close();
    //     } else {
    //       $scope.showLocalMatch = false;
    //     }
    //   }
    //   MyService.getLocalIncumbentPoliForVoter({ max_records: 100, page: $scope.page, extradata: extradata }).then(function(response) {
    //     if (response.data.success) {
    //       MyService.ConsoleLog("length : " + response.data.data.length);
    //       if (response.data.data.length <= 0) {
    //         $scope.showLocalMatch = false;
    //       } else {
    //         $scope.showLocalMatch = true;
    //       }
    //       $scope.statusGetLocalPoliticians = 2;
    //     } else {
    //       $scope.page -= 1;
    //       $scope.statusGetLocalPoliticians = 3;
    //       if (typeof response.data.error == "string")
    //         growl.error(response.data.error);
    //       else
    //         growl.error("Something went wrong");
    //     }
    //   }, function(err) {
    //     $scope.page -= 1;
    //     $scope.statusGetLocalPoliticians = 3;
    //     growl.error("Something went wrong");
    //   });
    // };

    $scope.allState = [];
    $scope.MyDialog = "";
    $scope.displayContent = "";

    $scope.oldaddress = {
      state: "",
      county: "",
      countySubdivision: "",
      place: ""
    };

    $scope.address = {
      state: "",
      county: "",
      countySubdivision: "",
      place: ""
    };
    // $scope.getLocalPoliticians();
  }]);

 'use strict';
 angular.module('myApp.questionComparePolitician', ['ngRoute', 'ngDialog'])
   .config(['$routeProvider', function ($routeProvider) {
     $routeProvider.when('/question-compare-politician/:categoryId', {
       templateUrl: 'app/questionComparePolitician/questionComparePolitician.html',
       controller: 'questionPoliticianCompareCtrl'
     });
   }])
   .controller('questionPoliticianCompareCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$q', 'ngDialog', '$rootScope', 'growl', 'MyService', '$anchorScroll', '$timeout', function ($scope, $http, $location, apiCall, $routeParams, $q, ngDialog, $rootScope, growl, MyService, $anchorScroll, $timeout) {
     $rootScope.welcome = false;
     $scope.traverseBackgrounds = [];
     $scope.currBackgroundIndex = 0;
     $scope.status = {
       questions: 0, //1=loading, 2=loaded, 3=error
       category: 0
     };

     $scope.currentIndex = 0;


     var getCategoryCanceler = $q.defer();
     var prevFetchedCategoryId = null;
     $scope.categoryCalled = false;
     $scope.getCategory = function (params) {
       try {
         prevFetchedCategoryId = $scope.category._id
       } catch (e) {}
       MyService.ConsoleLog("params", params.id);
       MyService.ConsoleLog("prevFetchedCategoryId", prevFetchedCategoryId);

       if (prevFetchedCategoryId != params.id) {
         //MyService.ConsoleLog("scrollTop");
         $routeParams.categoryId = params.id;
         $("html, body").animate({
           scrollTop: 0
         }, "slow");
         $scope.categoryCalled = true;
         // $timeout(function() {
         //   $location.hash('DisplayC');
         //   $anchorScroll();
         // }, 1500);
         getCategoryCanceler.resolve();
         getCategoryCanceler = $q.defer()
         $scope.status.category = 1;

         MyService.getCategories(params, getCategoryCanceler.promise).then(function (response) {

           if (response) {
             if (response.data.success) {
               $scope.category = response.data.data;
               //MyService.ConsoleLog("category data: ", $scope.category);
               prevFetchedCategoryId = $scope.category._id;
               $scope.status.category = 2;
               //MyService.ConsoleLog("$scope.status: ", $scope.status.category);
             } else {
               //MyService.ConsoleLog("Something went wrong: ", response.data);
               $scope.status.category = 3;
               //MyService.ConsoleLog("$scope.status: ", $scope.status.category);
             }
           } else {
             $scope.status.category = 2;
             //MyService.ConsoleLog("$scope.status: ", $scope.status.category);
           }
         }, function (err) {
           //MyService.ConsoleLog("Error: ", err);
           $scope.status.category = 3;
           //MyService.ConsoleLog("$scope.status: ", $scope.status.category);
         });
       } else {
         $("html, body").animate({
           scrollTop: $("#DisplayQ1").offset().top - 80
         }, "slow");
       }
     };

     /**
      * show pop up with old answers
      */
     $scope.getOldAnswers = function (val) {
       MyService.ConsoleLog('dava', val);
       $scope.oldAns = val;
       $scope.showPopUp = ngDialog.open({
         template: 'showOldAnsPopUp',
         closeByNavigation: true,
         scope: $scope,
       });
     };

     $scope.rootCatIndex = 0;
     $scope.getRootCategoryIndex = function () {
       if ($routeParams.categoryId == 'all') {
         var len = $rootScope.categories.length;
         for (var i = 0; i < len; i++) {
           if ($routeParams.parentId == $rootScope.categories[i]._id) {
             $scope.rootCatIndex = i;
             //MyService.ConsoleLog("rootCatIndex : ", $scope.rootCatIndex);
             break;
           }
         }
       }
     };

     var getLevelCategoryCanceler = $q.defer();

     function getLevelCategory(params) {
       getLevelCategoryCanceler.resolve();
       $scope.status.levlCat = 1;
       params.timeout = getLevelCategoryCanceler.promise;
       var request = apiCall.apiCall('GET', '/categories/list-layer', params);
       $http(
           request
         )
         .then(function successCallback(response) {
           //MyService.ConsoleLog("Got categories: ",response);
           if (response.data.success) {
             $scope.traverseBackgrounds = response.data.data;
             if ($routeParams.selectedCatId) {
               angular.forEach(response.data.data, function (val, key) {
                 if (val._id == $routeParams.selectedCatId) {
                   $scope.currBackgroundIndex = key;
                   $scope.category = val;
                 }
               });
             } else if ($scope.traverseBackgrounds.length > 0) {
               $scope.category = $scope.traverseBackgrounds[0];
             }
             $scope.status.levlCat = 2;
           } else {
             //MyService.ConsoleLog("Something went wrong: ", response.data);
             $scope.status.levlCat = 3;
           }
         }, function errorCallBack(response) {
           //MyService.ConsoleLog("Error: ", response);
           $scope.status.levlCat = 3;
         });
     }

     $scope.skipQuestion = function () {
       // $timeout(function() {
       //   $location.hash('DisplayQ');
       //   $anchorScroll();
       // }, 1500);
       var skip = function () {
         var tempIndex = $scope.currentIndex + 1;
         if (tempIndex < $scope.questions.length) {
           $scope.currentIndex++;
           if ($routeParams.categoryId && $routeParams.categoryId.indexOf("popular:") == 0) {
             $scope.getCategory({
               id: $scope.questions[$scope.currentIndex].categories[0].cid
             });
           }
         }
         //MyService.ConsoleLog("tempIndex = ", tempIndex, "$scope.questions.length ",$scope.questions.length);
         if ((tempIndex == $scope.questions.length) || $scope.questions.length == 0) {
           //MyService.ConsoleLog("end of questions switch background");
           var tempBackIdx = $scope.currBackgroundIndex + 1;
           if (tempBackIdx < $scope.traverseBackgrounds.length) {
             $scope.currBackgroundIndex++;
             // alert("if");
             $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
           } else {
             //MyService.ConsoleLog("* End of background *", "/politician_compare/" + $routeParams.categoryId + "/" + $routeParams.parentId);
             $scope.rootCatIndex++;
             // alert("else");
             window.localStorage.setItem("RootCatIndex", $scope.rootCatIndex);
             window.localStorage.setItem("DisplayCategory", JSON.stringify($scope.category));
             $location.path("/compare-politician-questions");

           }
         }
         //$scope.currentIndex++;
       };

       skip();
     };

     $scope.prevQuestion = function () {
       //MyService.ConsoleLog("** prevQuestion **");
       // $timeout(function() {
       //   $location.hash('DisplayQ');
       //   $anchorScroll();
       // }, 1500);
       if ($scope.currentIndex > 0) {
         $scope.currentIndex--;
       } else if ($scope.currentIndex == 0) {
         if ($scope.currBackgroundIndex > 0) {
           $scope.currBackgroundIndex--;
           $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
         } else {
           //MyService.ConsoleLog("** end of background **");
           if ($scope.rootCatIndex > 0) {
             $scope.rootCatIndex--;
             $location.path("/question-compare-politician/all/" + $rootScope.categories[$scope.rootCatIndex]._id);
           }
         }
       }
     };

     $scope.compareChanged = function (compare_with) {
       //MyService.ConsoleLog("compare_with :", compare_with);
       var catid = $routeParams.categoryId;
       if ($routeParams.categoryId && $routeParams.categoryId.indexOf("popular:") == 0) {
         var catid = $routeParams.categoryId.split("popular:")[1];
       }

       $location.path('/compare-select/' + compare_with);
     };

     $scope.getInfo = function (val) {

       if (val && val.comment && val.comment != '') {
         $scope.showComment = val.comment;
         $scope.showPopUp = ngDialog.open({
           template: 'showInfoPopUp',
           closeByNavigation: true,
           scope: $scope,
         });
       }
     };

     $scope.getComapreClass = function (match, i) {

       if (match >= 100)
         return 'ag-dg1';
       if (match >= 80)
         return 'ag-dg2';
       if (match >= 60)
         return 'ag-dg3';
       if (match >= 40)
         return 'ag-dg4';
       if (match >= 20)
         return 'ag-dg5';
       if (match >= 0)
         return 'ag-dg6';

       return 'ag-dg';
     };

     var getCompareAnswersCanceler = $q.defer();
     $scope.getCompareAnswers = function (params) {
       MyService.ConsoleLog("getCompareAnswers params :>", params);
       /*
       if (!params) return;
       getCompareAnswersCanceler.resolve();

       getCompareAnswersCanceler = $q.defer();
       $scope.questions = [];
       $scope.status.questions = 1;

       MyService.getCompareAns(params, getCompareAnswersCanceler.promise)
         .then(function successCallback(response) {
           //MyService.ConsoleLog("Got categories: ",response);
           if (response.data.success) {
             $scope.status.questions = 2;
             angular.forEach(response.data.data, function(val, key) {
               if (val.answers && val.answers.length != $rootScope.selectedCompareUsers.length) {
                 var check_author_exist = function(u) {
                   var len = val.answers.length;
                   for (var i = 0; i < len; i++) {
                     if (val.answers[i].author._id == u._id) {
                       return true;
                     }
                   }
                   return false;
                 };

                 angular.forEach($rootScope.selectedCompareUsers, function(u, i) {
                   if (!check_author_exist(u)) {
                     response.data.data[key].answers.push({ author: u });
                   }
                 });
               } else if (!val.answers) {
                 response.data.data[key].answers = [];
                 angular.forEach($rootScope.selectedCompareUsers, function(u, i) {
                   response.data.data[key].answers.push({ author: u });
                 });
               }
             });

             $scope.questions = response.data.data;
             // $location.path("question-compare/"+$routeParams.category_id+"/"+null);
           } else {
             $scope.status.questions = 3;
             //MyService.ConsoleLog("Something went wrong: ", response.data);
           }
         }, function errorCallBack(response) {
           $scope.status.questions = 3;
           //MyService.ConsoleLog("Error: ", response);
         });
       */
     };
     $scope.showMatch = function () {
       if (window.localStorage.getItem('qData')) {
         var tmp = JSON.parse(window.localStorage.getItem('qData'));
         $scope.questions = tmp;
         MyService.ConsoleLog("here we go", $scope.questions);
         if (!Array.isArray($scope.questions[$scope.currentIndex].answers)) {
           $scope.questions.filter(function (itms) {
             itms.answers.match = itms.my_answer.match;
             var ans = itms.answers;
             itms.answers = [];
             itms.answers.push(ans);
             return itms;
           })
         }
         MyService.ConsoleLog($scope.questions);
         $scope.questions.sort(function (x, y) {
           if (x.categories[0].viewOrder < y.categories[0].viewOrder) {
             return -1;
           }
           if (x.categories[0].viewOrder > y.categories[0].viewOrder) {
             return 1;
           }
           return 0;
         });

         var catid = $scope.questions[$scope.currentIndex].categories[0].cid;

         //MyService.ConsoleLog(catid)
         $scope.getCategory({
           id: catid
         });
       }
     };
     var current_url = $location.url();
     //MyService.ConsoleLog("$location.url: ", current_url);

     $scope.state = "question-compare-politician";
     if (!$rootScope.selectedCompareUsers || $rootScope.selectedCompareUsers.length <= 0) {
       $scope.showMatch();
       //  alert('s');
       //$location.path("/questionHome");

     } else {
       //  alert('sssssss');

       if ($routeParams.categoryId == 'all') {
         //MyService.ConsoleLog("compare all answers");
         var param = {
           id: $routeParams.parentId,
           questions_counter: 1
         };
         getLevelCategory(param);
         $scope.getRootCategoryIndex();
         $scope.showMatch();
       } // traverse all questions
       else {

         $scope.questions = $rootScope.compareAnswerList;
         //MyService.ConsoleLog($scope.questions);
         var catid = $routeParams.categoryId;
         //MyService.ConsoleLog(catid)
         $scope.getCategory({
           id: catid
         });
         $scope.showMatch();
       }
     }

     $scope.viewAnsComment = function (ans) {
       if (ans.comment) {
         ngDialog.open({
           template: 'app/popups/show_comment_txt.html',
           controller: 'OldAnswerViewerCtrl',
           data: {
             title: "Comment",
             content: ans.comment
           }
         });
       }
     };

     $scope.$watch('category', function (newValue, oldValue) {
       //MyService.ConsoleLog("** category watch **");
       var current_url = $location.url();

       if (current_url.indexOf("question-tagged") > -1)
         return; //for tagged questions don't again fetch questions

       if (newValue) {
         if (oldValue && oldValue._id == newValue._id) return;
         //MyService.ConsoleLog("scrollTop");
         //$("html, body").animate({ scrollTop: 0 }, "slow");
         //   $timeout(function() {
         //   $location.hash('DisplayQ');
         //   $anchorScroll();
         // }, 1500);
         //$scope.currentIndex = 0;

         if (current_url.indexOf("question-compare-politician") > -1) {
           var temp_uids = [];
           angular.forEach($rootScope.selectedCompareUsers, function (val, key) {
             temp_uids.push(val._id);
           });
           //MyService.ConsoleLog("**** getCompareAnswers ****");
           //$scope.getCompareAnswers({ "categoryIds": newValue._id, "userIds": temp_uids.join(",") }); //"compare_with": $routeParams.user_type,
         }
       }
     });

     $scope.$watch('questions', function (newValue, oldValue) {
       //MyService.ConsoleLog("** questions watch **");
       try {
         //MyService.ConsoleLog("Current question: ", $scope.questions[$scope.currentIndex]);
         var tempCate = $scope.questions[$scope.currentIndex].categories;
         if (angular.isArray(tempCate)) {
           $scope.getCategory({
             id: tempCate[0].cid
           });
         } else {
           $scope.getCategory({
             id: tempCate.cid
           });
         }

         // $scope.initMyAnswer();
       } catch (e) {
         //MyService.ConsoleLog("questions Index Change Ex: ", e)
       }
     });

     $scope.$watch('currentIndex', function (newValue, oldValue) {
       //MyService.ConsoleLog("** currentIndex watch **");
       try {
         //MyService.ConsoleLog("Current question: ", $scope.questions[$scope.currentIndex]);
         var tempCate = $scope.questions[$scope.currentIndex].categories;
         if (angular.isArray(tempCate)) {
           $scope.getCategory({
             id: tempCate[0].cid
           });
         } else {
           $scope.getCategory({
             id: tempCate.cid
           });
         }

         // $scope.initMyAnswer();
       } catch (e) {
         //MyService.ConsoleLog("Current Index Change Ex: ", e)
       }
     });
   }])

'use strict';
angular.module('myApp.questionCompare', ['ngRoute', 'ngDialog'])
  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/question-compare/:categoryId/:parentId?', {
      templateUrl: 'app/questionCompare/questionCompare.html',
      controller: 'questionCompareCtrl'
    });
  }]).controller('questionCompareCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$q', 'ngDialog', '$rootScope', 'growl', 'MyService', '$anchorScroll', '$timeout', 'tokenService', function ($scope, $http, $location, apiCall, $routeParams, $q, ngDialog, $rootScope, growl, MyService, $anchorScroll, $timeout, tokenService) {
    //MyService.ConsoleLog("** questionCompareCtrl ** :", $routeParams);
    //MyService.ConsoleLog("$rootScope.selectedCompareUsers: ", $rootScope.selectedCompareUsers);
    $rootScope.welcome = false;
    $scope.traverseBackgrounds = [];
    $scope.currBackgroundIndex = 0;
    $scope.UserId = tokenService.getUserId();
    $scope.status = {
      questions: 0, //1=loading, 2=loaded, 3=error
      category: 0
    };

    $scope.currentIndex = 0;

    var getCategoryCanceler = $q.defer();
    var prevFetchedCategoryId = null;

    $scope.getCategory = function (params) {
      try {
        prevFetchedCategoryId = $scope.category._id
      } catch (e) {}

      //MyService.ConsoleLog("prevFetchedCategoryId: ", prevFetchedCategoryId);
      //MyService.ConsoleLog("params.id: ", params.id);
      if (prevFetchedCategoryId != params.id) {
        //MyService.ConsoleLog("scrollTop");
        $("html, body").animate({
          scrollTop: 0
        }, "slow");
        getCategoryCanceler.resolve();
        getCategoryCanceler = $q.defer()
        $scope.status.category = 1;
        // alert(" category called");
        MyService.getCategories(params, getCategoryCanceler.promise).then(function (response) {
          //MyService.ConsoleLog("-----------------------------");
          //MyService.ConsoleLog("response: ", response);
          //MyService.ConsoleLog("-----------------------------");
          if (response) {
            if (response.data.success) {
              $scope.category = response.data.data;
              //MyService.ConsoleLog("category data: ", $scope.category);
              prevFetchedCategoryId = $scope.category._id;
              $scope.status.category = 2;
              //MyService.ConsoleLog("$scope.status: ", $scope.status.category);
            } else {
              //MyService.ConsoleLog("Something went wrong: ", response.data);
              $scope.status.category = 3;
              //MyService.ConsoleLog("$scope.status: ", $scope.status.category);
            }
          } else {
            $scope.status.category = 2;
            //MyService.ConsoleLog("$scope.status: ", $scope.status.category);
          }
        }, function (err) {
          //MyService.ConsoleLog("Error: ", err);
          $scope.status.category = 3;
          //MyService.ConsoleLog("$scope.status: ", $scope.status.category);
        });
      }
    };

    $scope.rootCatIndex = 0;
    $scope.getRootCategoryIndex = function () {
      if ($routeParams.categoryId == 'all') {
        var len = $rootScope.categories.length;
        for (var i = 0; i < len; i++) {
          if ($routeParams.parentId == $rootScope.categories[i]._id) {
            $scope.rootCatIndex = i;
            MyService.ConsoleLog("rootCatIndex : ", $scope.rootCatIndex);
            break;
          }
        }
      }
    };

    var getLevelCategoryCanceler = $q.defer();

    function getLevelCategory(params) {
      getLevelCategoryCanceler.resolve();
      $scope.status.levlCat = 1;
      params.timeout = getLevelCategoryCanceler.promise;
      var request = apiCall.apiCall('GET', '/categories/list-layer', params);
      $http(
          request
        )
        .then(function successCallback(response) {
          MyService.ConsoleLog("Got categories: ", response);
          if (response.data.success) {
            $scope.traverseBackgrounds = response.data.data;
            if ($routeParams.selectedCatId) {
              angular.forEach(response.data.data, function (val, key) {
                if (val._id == $routeParams.selectedCatId) {
                  $scope.currBackgroundIndex = key;
                  $scope.category = val;
                }
              });
            } else if ($scope.traverseBackgrounds.length > 0) {
              $scope.category = $scope.traverseBackgrounds[0];
            }
            $scope.status.levlCat = 2;
          } else {
            //MyService.ConsoleLog("Something went wrong: ", response.data);
            $scope.status.levlCat = 3;
          }
        }, function errorCallBack(response) {
          //MyService.ConsoleLog("Error: ", response);
          $scope.status.levlCat = 3;
        });
    }

    $scope.skipQuestionOne = function () {

      var skip = function () {
        var tempIndex = $scope.currentIndex + 1;

        if (tempIndex < $scope.questions.length) {
          $scope.currentIndex++;

          if ($routeParams.categoryId && $routeParams.categoryId.indexOf("popular:") == 0) {
            // //we are showing questions of most popular section
            $scope.getCategory({
              id: $scope.questions[$scope.currentIndex].categories.cid
            });
          }
        }
        $("html, body").animate({
          scrollTop: $("#DisplayQ").offset().top - 280
        }, "slow");
        //MyService.ConsoleLog("tempIndex = ", tempIndex, "$scope.questions.length ",$scope.questions.length);
        if ((tempIndex == $scope.questions.length) || $scope.questions.length == 0) {
          //MyService.ConsoleLog("end of questions switch background");
          var tempBackIdx = $scope.currBackgroundIndex + 1;
          if (tempBackIdx < $scope.traverseBackgrounds.length) {
            $scope.currBackgroundIndex++;
            $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
          } else {
            $scope.rootCatIndex++;
            // alert("Else");
            window.localStorage.setItem("RootCatIndex", $scope.rootCatIndex);
            window.localStorage.setItem("DisplayCategory", JSON.stringify($scope.category));
            //MyService.ConsoleLog("/politician_compare/" + $routeParams.categoryId + "/" + $routeParams.parentId);
            if ($scope.UserId && $scope.UserId != "") {
              $location.path("/politician_compare/" + $routeParams.categoryId + "/" + $routeParams.parentId);
            } else {
              // alert("no more answered questions");
              $location.path("/compare-subject/politician");
            }
          }
        }
      };

      skip();
    };

    $scope.prevQuestion = function () {
      //MyService.ConsoleLog("** prevQuestion **");
      // $timeout(function () {
      //   $location.hash('DisplayQ');
      //   $anchorScroll();
      // }, 1500);
      $("html, body").animate({
        scrollTop: $("#DisplayQ").offset().top - 280
      }, "slow");
      if ($scope.currentIndex > 0) {
        $scope.currentIndex--;
      } else if ($scope.currentIndex == 0) {
        if ($scope.currBackgroundIndex > 0) {
          $scope.currBackgroundIndex--;
          $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
        } else {
          //MyService.ConsoleLog("** end of background **");
          if ($scope.rootCatIndex > 0) {
            $scope.rootCatIndex--;

            if ($scope.UserId && $scope.UserId != "") {
              $location.path("/question-compare/all/" + $rootScope.categories[$scope.rootCatIndex]._id);
            } else {
              // alert("no more answered questions");
              $location.path("/compare-subject/politician");
            }
          }
        }
      }
    };

    $scope.compareChanged = function (compare_with) {
      MyService.ConsoleLog("compare_with :", compare_with);
      var catid = $routeParams.categoryId;
      if ($routeParams.categoryId && $routeParams.categoryId.indexOf("popular:") == 0) {
        var catid = $routeParams.categoryId.split("popular:")[1];
      }

      $location.path('/compare-select/' + compare_with);
    };

    $scope.getComapreClass = function (match, i) {
      MyService.ConsoleLog("match: ", match);
      /*if(match == 100)
          return 'ag-green';
      if(match == 0)
          return 'ag-red';
      if(match > 0 && match <100)
          return 'ag-dg'+i;*/
      if (match >= 100)
        return 'ag-dg1';
      if (match >= 80)
        return 'ag-dg2';
      if (match >= 60)
        return 'ag-dg3';
      if (match >= 40)
        return 'ag-dg4';
      if (match >= 20)
        return 'ag-dg5';
      if (match >= 0)
        return 'ag-dg6';

      return 'ag-dg';
    };

    var getCompareAnswersCanceler = $q.defer();
    $scope.getCompareAnswers = function (params) {

      MyService.ConsoleLog(" params for getCompareAnswers :", params);
      if (!params) return;
      getCompareAnswersCanceler.resolve();

      getCompareAnswersCanceler = $q.defer();
      $scope.questions = [];
      $scope.status.questions = 1;

      MyService.getCompareAns(params, getCompareAnswersCanceler.promise)
        .then(function successCallback(response) {
          //MyService.ConsoleLog("Got categories: ",response);
          if (response.data.success) {
            if (response.data.data.length > 0) {
              $scope.status.questions = 2;
              angular.forEach(response.data.data, function (val, key) {
                if (val.answers && val.answers.length != $rootScope.selectedCompareUsers.length) {
                  var check_author_exist = function (u) {
                    var len = val.answers.length;
                    for (var i = 0; i < len; i++) {
                      if (val.answers[i].author._id == u._id) {
                        return true;
                      }
                    }
                    return false;
                  };

                  angular.forEach($rootScope.selectedCompareUsers, function (u, i) {
                    if (!check_author_exist(u)) {
                      response.data.data[key].answers.push({
                        author: u
                      });
                    }
                  });
                } else if (!val.answers) {
                  response.data.data[key].answers = [];
                  angular.forEach($rootScope.selectedCompareUsers, function (u, i) {
                    response.data.data[key].answers.push({
                      author: u
                    });
                  });
                }
              });

              $scope.questions = response.data.data.sort(function (x, y) {
                if (x.categories[0].viewOrder < y.categories[0].viewOrder) {
                  return -1;
                }
                if (x.categories[0].viewOrder > y.categories[0].viewOrder) {
                  return 1;
                }
                return 0;
              });
              MyService.ConsoleLog("$scope.questions: ", $scope.questions);
            }
            // $location.path("question-compare/"+$routeParams.category_id+"/"+null);
          } else {
            $scope.status.questions = 3;
            //MyService.ConsoleLog("Something went wrong: ", response.data);
          }
        }, function errorCallBack(response) {
          $scope.status.questions = 3;
          //MyService.ConsoleLog("Error: ", response);
        });
    };

    var current_url = $location.url();
    //MyService.ConsoleLog("$location.url: ", current_url);

    $scope.state = "question-compare";
    if (!$rootScope.selectedCompareUsers || $rootScope.selectedCompareUsers.length <= 0) {
      $location.path("/questionHome");
    } else {
      if ($routeParams.categoryId == 'all') {
        //MyService.ConsoleLog("compare all answers");
        var param = {
          id: $routeParams.parentId,
          questions_counter: 1
        };
        getLevelCategory(param);
        $scope.getRootCategoryIndex();
      } // traverse all questions
      else {
        //MyService.ConsoleLog("** question-compare **");
        //MyService.ConsoleLog("compareAnswerList: ", $rootScope.compareAnswerList);

        $scope.questions = $rootScope.compareAnswerList;
        $scope.getCategory({
          id: $routeParams.categoryId
        });
      }
    }


    $scope.getInfo = function (val) {
      MyService.ConsoleLog("val >>", val);
      if (val && val.comment && val.comment != '') {
        $scope.showComment = val.comment;
        $scope.showPopUp = ngDialog.open({
          template: 'showInfoPopUp',
          closeByNavigation: true,
          scope: $scope,
        });
      }
    };

    $scope.viewAnsComment = function (ans) {
      if (ans.comment) {
        ngDialog.open({
          template: 'app/popups/show_comment_txt.html',
          controller: 'OldAnswerViewerCtrl',
          data: {
            title: "Comment",
            content: ans.comment
          }
        });
      }
    };


    /**
     * show pop up with old answers
     */
    $scope.getOldAnswers = function (val) {
      MyService.ConsoleLog('dava', val);
      $scope.oldAns = val;
      $scope.showPopUp = ngDialog.open({
        template: 'showOldAnsPopUp',
        closeByNavigation: true,
        scope: $scope,
      });
    };

    $scope.$watch('category', function (newValue, oldValue) {
      //MyService.ConsoleLog("** category watch **");
      var current_url = $location.url();

      if (current_url.indexOf("question-tagged") > -1)
        return; //for tagged questions don't again fetch questions

      if (newValue) {
        //MyService.ConsoleLog("<<<<<<oldValue: ", oldValue);
        //MyService.ConsoleLog("<<<<<newValue: ", newValue);
        if (oldValue && oldValue._id == newValue._id) return;
        //MyService.ConsoleLog("scrollTop");
        $("html, body").animate({
          scrollTop: 0
        }, "slow");
        // MyService.ConsoleLog("window.localStorage.getItem('fiveQueIds')", window.localStorage.getItem('fiveQueIds'));
        if (!window.localStorage.getItem('fiveQueIds')) {
          $scope.currentIndex = 0;
        }

        if (current_url.indexOf("question-compare") > -1) {
          var temp_uids = [];
          angular.forEach($rootScope.selectedCompareUsers, function (val, key) {
            temp_uids.push(val._id);
          });

          if (!window.localStorage.getItem('fiveQueIds')) {
            MyService.ConsoleLog("**** getCompareAnswers ****");
            MyService.ConsoleLog("<<<<<<oldValue: ", oldValue);
            MyService.ConsoleLog("<<<<<newValue: ", newValue);
            $scope.getCompareAnswers({
              categoryIds: newValue._id,
              userIds: temp_uids.join(","),
              //"compare_with": $routeParams.user_type,
            });

          }



        }
      }
    });

    $scope.$watch('questions', function (newValue, oldValue) {
      //MyService.ConsoleLog("** questions watch **");
      try {
        //MyService.ConsoleLog("Current question: ", $scope.questions[$scope.currentIndex]);
        var tempCate = $scope.questions[$scope.currentIndex].categories;
        if (angular.isArray(tempCate)) {
          $scope.getCategory({
            id: tempCate[0].cid
          });
        } else {
          $scope.getCategory({
            id: tempCate.cid
          });
        }

        // $scope.initMyAnswer();
      } catch (e) {
        //MyService.ConsoleLog("questions Index Change Ex: ", e)
      }
    });

    $scope.$watch('currentIndex', function (newValue, oldValue) {
      //MyService.ConsoleLog("** currentIndex watch **");
      try {
        //MyService.ConsoleLog("Current question: ", $scope.questions[$scope.currentIndex]);
        var tempCate = $scope.questions[$scope.currentIndex].categories;
        if (angular.isArray(tempCate)) {
          $scope.getCategory({
            id: tempCate[0].cid
          });
        } else {
          $scope.getCategory({
            id: tempCate.cid
          });
        }
        // $scope.initMyAnswer();
      } catch (e) {
        //MyService.ConsoleLog("Current Index Change Ex: ", e)
      }
    });
  }])

'use strict';
angular.module('myApp.questionBackGround', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/question-background/:categoryId/:selectedCatId', {
      templateUrl: 'app/questionBackGround/questionBackGround.html',
      reloadOnSearch: false,
      controller: 'questionCtrl'
    });
  }]).controller('questionCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$q', 'ngDialog', '$rootScope', 'growl', 'MyService', 'tokenService', '$anchorScroll', '$timeout', '$window', '$cookies', function ($scope, $http, $location, apiCall, $routeParams, $q, ngDialog, $rootScope, growl, MyService, tokenService, $anchorScroll, $timeout, $window, $cookies) {
    //MyService.ConsoleLog("** questionCtrl ** :", $routeParams);

    // MyService.ConsoleLog("** questionCtrl ** :", $scope.politicianName);
    $scope.showLoaderNw = false;
    $rootScope.welcome = false;
    $scope.saveForLater = false;
    $scope.userId = tokenService.getUserId();
    $scope.userRole = tokenService.getUserRole();
    if (tokenService.getUserData()) {
      $scope.userData = JSON.parse(tokenService.getUserData());
      $rootScope.tempUserAddress = $scope.userData.address;
    }

    /**
     * @description Remove session Id
     */

    window.localStorage.removeItem('sessionId');

    window.localStorage.removeItem('showSavePopUp');
    window.localStorage.removeItem("cat_id");
    window.localStorage.removeItem("selCat_id");
    if ($routeParams.categoryId && $routeParams.selectedCatId) {
      window.localStorage.setItem("cat_id", $routeParams.categoryId);
      window.localStorage.setItem("selCat_id", $routeParams.selectedCatId);
    } else if ($routeParams.categoryId) {
      window.localStorage.setItem("cat_id", $routeParams.categoryId);
    } else {
      window.localStorage.setItem("selCat_id", $routeParams.selectedCatId);
    }
    window.localStorage.removeItem('fbImg');
    window.localStorage.removeItem('fbName');
    window.localStorage.removeItem('quizLinkData');
    if (window.localStorage.getItem('isFindFollowers')) {
      window.localStorage.removeItem("inviterInfo");
      $cookies.remove("quizTakerIdsArr");
      window.localStorage.removeItem('isFindFollowers');
    }

    if (window.localStorage.getItem('inviterId')) {
      if (window.localStorage.getItem('inviterInfo')) {
        $scope.inviterInfo = JSON.parse(window.localStorage.getItem('inviterInfo'));
        MyService.ConsoleLog("$scope.inviterInfo", $scope.inviterInfo);
        if ($scope.inviterInfo && $scope.inviterInfo.nameOnBallot && $scope.inviterInfo.userType == 'politician') {
          $scope.inviterName = $scope.inviterInfo.nameOnBallot;
        } else if ($scope.inviterInfo && $scope.inviterInfo.title) {
          $scope.inviterName = $scope.inviterInfo.title;
        } else if ($scope.inviterInfo && $scope.inviterInfo.userType == 'voter') {
          $scope.inviterName = $scope.inviterInfo.username;
        }
        $scope.isShare = true;
      }
      $scope.inviterId = window.localStorage.getItem('inviterId');
    }

    $scope.updateFlag = function () {
      $scope.isShare = !$scope.isShare;
      console.log('isShare :', $scope.isShare);
    };

    $cookies.remove('QuizName');
    $scope.traverseBackgrounds = [];
    $scope.currBackgroundIndex = 0;
    $scope.status = {
      questions: 0, //1= loading, 2 = loaded, 3 = error
      category: 0
    };
    $scope.flagSkipAnsweredQuestion = true;
    $scope.skipToMatch = false;
    $scope.skipToFinal = false;
    $scope.loadernew = false;
    $scope.currentIndex = 0;

    $cookies.remove('quizLinks');
    $scope.quizLink = "https://votewise.net/#!/question-background/" + $routeParams.categoryId + "/" + $routeParams.selectedCatId;
    // MyService.ConsoleLog("$scope.quizLink", $scope.quizLink);

    /**
     * This function calls on page load
     * fetch data of user's area politician ,voters and advocates
     */

    $scope.getLocalPoliticians = function (asdata) {
      // MyService.ConsoleLog(" welcome to getLocalPoliticians ", $rootScope.queData);
      $scope.statusGetLocalPoliticians = 1;
      $scope.page += 1;
      $scope.loader = true;
      // MyService.ConsoleLog("$rootScope.tempUserA ******* ", $rootScope.tempUserAddress);
      // MyService.ConsoleLog("$rootScope.tempUserA ******* ", $rootScope.tempUserAddress.state)
      var extradata = new Object();
      if ($rootScope.tempUserAddress) {
        if ($rootScope.tempUserAddress.state && $rootScope.tempUserAddress.state != '') {
          extradata.statePostalCode = $rootScope.tempUserAddress.statePostalCode;
        }
        if ($rootScope.tempUserAddress.county && $rootScope.tempUserAddress.countyFips) {
          $rootScope.tempUserAddress.FinalData = JSON.stringify(
            $rootScope.tempUserAddress.countyFips
          );
          extradata.county = $rootScope.tempUserAddress.county;
        }
        if (
          $rootScope.tempUserAddress.countySubdivision &&
          $rootScope.tempUserAddress.countySubdivisionFips
        ) {
          $rootScope.tempUserAddress.FinalData = JSON.stringify(
            $rootScope.tempUserAddress.countySubdivisionFips
          );
          extradata.countySubdivision = $rootScope.tempUserAddress.countySubdivision;
        }
        if ($rootScope.tempUserAddress.place && $rootScope.tempUserAddress.placeFips) {
          //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
          extradata.place = $rootScope.tempUserAddress.place;
        }
        if (
          $rootScope.tempUserAddress.voterDistrict &&
          $rootScope.tempUserAddress.voterDistrictFips
        ) {
          //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
          extradata.voterDistrict = $rootScope.tempUserAddress.voterDistrict;
        }
        if ($rootScope.tempUserAddress.federalCongrassionalDist) {
          //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);

          extradata.federalCongrassionalDist =
            $rootScope.tempUserAddress.federalCongrassionalDist;
        }
        if ($rootScope.tempUserAddress.stateSenateDistrict) {
          //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
          extradata.stateSenateDistrict = $rootScope.tempUserAddress.stateSenateDistrict;
        }
        if ($rootScope.tempUserAddress.legislativeDistrict) {
          //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
          extradata.legislativeDistrict = $rootScope.tempUserAddress.legislativeDistrict;
        }
        if ($rootScope.tempUserAddress.schoolDistrict) {
          //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
          extradata.schoolDistrict = $rootScope.tempUserAddress.schoolDistrict;
        }
      }
      // MyService.ConsoleLog('extradata : >>>>>>>>>> ', JSON.stringify(extradata));
      MyService.getAllLocalPoli({
        max_records: 100,
        page: $scope.page,
        extradata: JSON.stringify(extradata),
      }).then(
        function (response) {
          if (response.data.success) {
            setTimeout(function () {
              $scope.$apply(function () {
                if (response.data.data.length > 0) {
                  MyService.getAdvocates().then(function (payload) {
                    // MyService.ConsoleLog("Response >", payload);
                    var ndata = response.data.data;
                    if ($scope.inviterId) {
                      $scope.userAreaPolitician = [];
                      $scope.userAreaPolitician.push($scope.inviterId);
                    } else {
                      var wdata = ndata.concat(payload.data.data);
                      $scope.userAreaPolitician = wdata.map(function (ques) {
                        return ques._id;
                      });
                    }
                    // MyService.ConsoleLog(" $scope.userAreaPolitician >", $scope.userAreaPolitician);
                    var param = JSON.stringify({
                      usersIds: $scope.userAreaPolitician,
                      cur_userId: $scope.userId,
                      questions: JSON.stringify(asdata)
                    });

                    // MyService.ConsoleLog("apra >", param);
                    // window.localStorage.removeItem('comData');
                    window.localStorage.setItem('comData', param);
                    $scope.loadernew = false;
                    $scope.skipToFinal = true;
                    $scope.skipToMatch = true;
                  }, function (err) {
                    MyService.ConsoleLog("Error >>", err);
                  });
                } else {
                  $scope.loader = false;
                  var message =
                    'None of your politicians have answered the questions yet. Contact them and ask them to fill it out.';
                  var modal = ngDialog.openConfirm({
                    template: '<p>' +
                      message +
                      '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">OK</button>\
                            \
                        </div>',
                    plain: true,
                  });

                  modal.then(
                    function fullfilled(data) {
                      //MyService.ConsoleLog("fullfilled: ", data);
                      if (data == 1) {
                        $scope.postonFacebook();
                      } else {
                        if ($rootScope.userRole) {
                          $location.path('/snapshot');
                        } else {
                          $location.path('/signin');
                        }
                      }
                    },
                    function rejected(data) {
                      //MyService.ConsoleLog("rejected: ", data);
                    }
                  );
                }
              });
            }, 100);
          } else {
            $scope.page -= 1;
            $scope.statusGetLocalPoliticians = 3;
            if (typeof response.data.error == 'string') growl.error(response.data.error);
            else growl.error('Something went wrong');
          }
        },
        function (err) {
          $scope.page -= 1;
          $scope.statusGetLocalPoliticians = 3;
          $scope.loader = false;
          growl.error(err);
        }
      );
    };




    $scope.initializeVariables = function () {
      // alert("called");
      $scope.importance = null;
      $scope.answer = null;
      $scope.comment = '';
      $scope.reason = '';
    };
    $scope.initializeVariables();

    $scope.initMyAnswer = function () {

      try {
        if ($scope.questions[$scope.currentIndex].my_answer) {
          // MyService.ConsoleLog("called init my ans", $scope.questions[$scope.currentIndex].my_answer);
          var my_answer = $scope.importance = $scope.questions[$scope.currentIndex].my_answer;
          // MyService.ConsoleLog("Final Answers", my_answer);
          $scope.importance = my_answer.importance;
          $scope.answer = my_answer.answer;
          $scope.comment = my_answer.comment;
          // MyService.ConsoleLog("Importance", $scope.importance);
          // MyService.ConsoleLog(" $scope.answer", $scope.answer);
          // MyService.ConsoleLog("#agreedisagree-id" + my_answer.answer);
          // MyService.ConsoleLog("#importance-id" + my_answer.importance);
          $("#agreedisagree-id" + my_answer.answer).prop('checked', true);
          $("#importance-id" + my_answer.importance).prop('checked', true);
        } else {
          $scope.initializeVariables();
        }
      } catch (e) {
        $scope.initializeVariables();
        //MyService.ConsoleLog("Exceptoin: ", e)
      }
    };

    $scope.viewOldAnswers = function (old_ans) {
      ngDialog.open({
        template: 'app/popups/view_old_answers.html',
        controller: 'OldAnswerViewerCtrl',
        data: old_ans
      });
    };

    if ($rootScope.userRole == "advocate") {
      var request = apiCall.apiCall('GET', '/user/list', {
        "usertype": "politician"
      });
      request.headers['Cache-Control'] = 'No-Store';
      $http(
        request
      ).then(function successCallback(response) {
        //MyService.ConsoleLog("Got categories: ",response);
        if (response.data.success) {
          $scope.tagableUsers = response.data.data;
        } else {
          //MyService.ConsoleLog("Something went wrong: ", response.data);
        }
      }, function errorCallBack(response) {
        //MyService.ConsoleLog("Error: ", response);
      });
    }
    $scope.addTags = function (tagUsers) {
      //MyService.ConsoleLog("tagUsers: ", tagUsers);
      //MyService.ConsoleLog("tagUsers: ", $scope.questions[$scope.currentIndex]._id);

      var postData = {
        id: $scope.questions[$scope.currentIndex]._id,
        user_ids: tagUsers.join(",")
      };

      var request = apiCall.apiCall('POST', '/questions/add_tag', postData);
      $http(
        request
      ).then(function successCallback(response) {
        //MyService.ConsoleLog("succss: ", response);
        if (response.data.success) {
          growl.success("Tagged successfully");
        } else {
          if (typeof response.data.error == "string")
            growl.error(response.data.error);
          else
            growl.error("Something went wrong");
        }
      }, function errorCallback(response) {
        growl.error("Something went wrong");
      });
    };

    /**
     * Check how many questions has already answered
     */
    $scope.checkAnswerQuestions = function (quData) {
      return quData.filter(function (itm) {
        if (itm.my_answer && itm.my_answer.answer && itm.my_answer.answer != '') {
          return itm;
        }
      });
    };

    var getQuestionsCanceler = $q.defer();
    $scope.questions = [];
    $scope.fbwallDlg = "";
    $scope.oldQuestions = [];

    function getMoreQuestions(params) {
      $scope.loadernew = true;

      MyService.ConsoleLog("params >>", params);
      // alert('welcome');
      getQuestionsCanceler.resolve();
      $scope.status.questions = 1;
      $scope.questions.length = 0;
      if ($scope.fbwallDlg != "") {
        //MyService.ConsoleLog($scope.fbwallDlg);
        ngDialog.close($scope.fbwallDlg.id);
      }
      params.timeout = getQuestionsCanceler.promise;
      MyService.ConsoleLog("questionCtrl** /questions/list: ", params);
      var request = apiCall.apiCall('GET', '/questions/list', params);
      request.headers['Cache-Control'] = 'No-Store';
      $http(
        request
      ).then(function successCallback(response) {
        // MyService.ConsoleLog("questionCtrl Got categories: ", response);
        if (response.data.success) {
          MyService.ConsoleLog("IF =>>>", response.data.data.length);
          if (response.data.data == "") {
            // alert('call');
            $scope.skipQuestion();
          }
          $scope.status.questions = 2;

          $scope.initMyAnswer();
          if ($scope.userId) {

            // alert("call");
            window.localStorage.removeItem('quesData');
            window.localStorage.setItem('quesData', JSON.stringify(response.data.data));
            $scope.questionsData = response.data.data;
            $scope.queIds = $scope.questionsData.map(function (itm) {
              if (itm.questionId) {
                return itm.questionId;
              } else {
                // console.log("itm", itm);
                return itm._id;
              }
            });

          }
          // window.localStorage.setItem('quesData', JSON.stringify(response.data.data));
          // MyService.ConsoleLog("data len: ", response.data.data);
          if ($scope.flagSkipAnsweredQuestion) {
            angular.forEach(response.data.data, function (val, key) {
              if (val.my_answer == null)
                $scope.questions.push(val);
            });
          } else {
            $scope.questions = response.data.data;
          }
          $scope.chkAnsQues = $scope.checkAnswerQuestions(response.data.data);
          MyService.ConsoleLog("chkAnsQues", $scope.chkAnsQues);
          if ($scope.chkAnsQues && $scope.chkAnsQues.length > 0 && $scope.chkAnsQues.length != $scope.questionsData.length) {
            $scope.saveForLater = true;
          }
          if ($scope.chkAnsQues && $scope.chkAnsQues.length == response.data.data.length) {
            if (tokenService.getUserId()) {
              $scope.getLocalPoliticians(response.data.data);
            } else {
              $scope.loadernew = false;

            }
          } else {
            $scope.loadernew = false;
          }

          //$scope.oldQuestions = angular.copy($scope.questions);
          //MyService.ConsoleLog("total questions: ", $scope.questions.length);
        } else {
          MyService.ConsoleLog("Else by vishal");
          $scope.status.questions = 3;
          if (typeof response.data.error == "string")
            growl.error(response.data.error);
          else
            growl.error("Something went wrong");
        }
      }, function errorCallBack(response) {
        $scope.status.questions = 3;
        //MyService.ConsoleLog("Error: ", response);
      });
    }

    /**
     * Redirect to the match
     */
    $scope.skipToMatchs = function () {
      if ($scope.inviterId) {
        window.localStorage.removeItem('isUpdate');
        window.localStorage.setItem('isUpdate', true);
      }

      $location.path('/findMatch/#DisplayQ');
    };

    /**
     * Redirect to the final match
     */

    $scope.skipToCompare = function () {
      if ($scope.inviterId) {
        window.localStorage.removeItem('isUpdate');
        window.localStorage.setItem('isUpdate', true);
      }
      $location.path('/compareWithGroup');
    };

    /**
     * @description Show action pop up.
     */
    $scope.skipToActions = function () {
      MyService.ConsoleLog("old", $rootScope.OldCatforFB)
      $scope.getLocalMatch();
    };

    $scope.createLink = function () {
      MyService.ConsoleLog("create");
      $scope.fbwallDlg.close();
      if ($scope.userId && $scope.userId != '') {
        $scope.getAllAnsweredQuestions();
      }

    };

    $scope.retainOptions = "";
    if ($scope.userId) {
      $scope.fb = {
        // options: "C"
        options: "PS"
      };
    } else {
      $scope.fb = {
        options: "R"
      };
    }


    $scope.postOnWall = function (message) {
      var body = message;
      var link = 'https://votewise.net/#!/question-background/' + $routeParams.categoryId + '/' + $rootScope.OldCatforFB._id;
      var picture = 'https://api.votewise.net/resources/education-general-1484943663025.jpg';
      if ($rootScope.OldCatforFB && $rootScope.OldCatforFB.fbImage && $rootScope.OldCatforFB.fbImage != null) {
        picture = "https://api.votewise.net/resources/" + $rootScope.OldCatforFB.fbImage;
      }

      //MyService.ConsoleLog(picture);
      //var picture = '';
      //MyService.ConsoleLog($rootScope.OldCatforFB);
      var name = 'What makes a good education?';
      if ($rootScope.OldCatforFB && $rootScope.OldCatforFB.fbTitle) {
        name = $rootScope.OldCatforFB.fbTitle;
      }
      var description = 'How do we make our education system better?  Take the quiz to learn more, tell your politicians what they should do, and compare with your friends.';
      if ($rootScope.OldCatforFB && $rootScope.OldCatforFB.fbDescription) {
        description = $rootScope.OldCatforFB.fbDescription;
      }
      FB.api('/me/feed', 'post', {
        message: body,
        link: link,
        picture: picture,
        name: name,
        description: description
      }, function (response) {
        //MyService.ConsoleLog(response);
        $scope.DisplayFPostLoader = false;
        if (!response || response.error) {
          var errmsg = "Facebook is taking too long to respond. Should we try again?"
          var modal = ngDialog.openConfirm({
            template: '<p>' + errmsg + '</p>\
                            <div class="ngdialog-buttons">\
                    <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                    <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Yes</button>\
                </div>',
            plain: true
          });
          modal.then(function fullfilled(tdata) {
            //MyService.ConsoleLog("fullfilled: ", data);
            if (tdata == 1) {
              $scope.postOnWall(message);
            }

          }, function rejected(data) {
            //MyService.ConsoleLog("rejected: ", data);
          });
        } else {

          var msg = "Message is successfully posted on facebook wall. Do you want to continue with Answering questions?";
          var modal = ngDialog.openConfirm({
            template: '<p>' + msg + '</p>\
                            <div class="ngdialog-buttons">\
                                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(2)">NO</button>\
                                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">YES</button>\
                            </div>',
            plain: true
          });
          modal.then(function fullfilled(data) {
            //MyService.ConsoleLog("fullfilled: ", data);
            if (data == 1) {
              getMoreQuestions($scope.retainOptions);
            }
            ngDialog.close();
          }, function rejected(data) {
            //MyService.ConsoleLog("rejected: ", data);
            ngDialog.close();
          });
          // alert('Post ID: ' + response.id);
        }
      });
    }
    $scope.DisplayFPostLoader = false;
    $scope.postFB = function (message) {
      //alert("This needs to be implemented");
      $scope.DisplayFPostLoader = true;
      FB.getLoginStatus(function (response) {
        //MyService.ConsoleLog(response);

        if (response.status == 'unknown') {
          FB.login(function (response) {
            //statusChangeCallback(response, 'login');
            //MyService.ConsoleLog(response);
            MyService.updateFBID({
              "facebookid": response.authResponse.userID
            }).then(function (payload) {
              //MyService.ConsoleLog(payload);
              //MyService.ConsoleLog(payload.data.error);
              if (payload.data.error && payload.data.error == "FBDUPLICATE") {
                $scope.DisplayFPostLoader = false;
                alert("Facebook user doesn't match with your account.");
              } else {
                $scope.postOnWall(message);
              }

            }, function (errpayload) {
              $scope.DisplayFPostLoader = false;

              var errmsg = "Facebook is taking too long to respond. Should we try again?"
              var modal = ngDialog.openConfirm({
                template: '<p>' + errmsg + '</p>\
                            <div class="ngdialog-buttons">\
                    <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                    <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Yes</button>\
                </div>',
                plain: true
              });
              modal.then(function fullfilled(tdata) {
                //MyService.ConsoleLog("fullfilled: ", data);
                if (tdata == 1) {
                  $scope.postOnWall(message);
                }

              }, function rejected(data) {
                //MyService.ConsoleLog("rejected: ", data);
              });

              // alert("Facebook is taking too long to respond. Should we try again?");
            });
          }, {
            scope: 'public_profile,email,publish_actions',
            return_scopes: true
          });
        } else {
          if ($scope.userData && $scope.userData.facebookid) {
            if (response.authResponse.userID == $scope.userData.facebookid) {
              $scope.postOnWall(message);
            } else {
              $scope.DisplayFPostLoader = false;
              alert("Facebook user doesn't match with your account.");
            }
          } else {
            $scope.postOnWall(message);
          }
        }
      });
    }

    $scope.fbFrdDlg = "";
    $scope.FBfreinds = [];
    $scope.FBfreindsFinal = [];
    $scope.DisplayFLoader = false;
    $scope.checkFBFreinds = function () {
      $scope.DisplayFLoader = true;
      FB.login(function (loginData) {
        //MyService.ConsoleLog(loginData);
        FB.api('/me/friends', function (response) {
          //MyService.ConsoleLog(response);
          $scope.FBfreindsFinal.length = 0;
          if (response && response.data) {
            var frdata = response.data;
            $scope.FBfreindsFinal = response.data;
            if (frdata.length > 0) {
              var results = frdata.map(function (frdata) {
                return frdata.id;
              });
              //MyService.ConsoleLog(results);
              var sendfrd = JSON.stringify(results);
              //MyService.ConsoleLog(sendfrd);
              MyService.checkfreindsIfanswered({
                "friends": sendfrd,
                "categoryId": $rootScope.OldCatforFB._id
              }).then(function (payload) {
                //MyService.ConsoleLog("payload:", payload);
                $scope.selection.length = 0;
                var allfriends = payload.data.data;
                $scope.FBfreinds.length = 0;
                //MyService.ConsoleLog("allfriends:::", allfriends);
                $scope.DisplayFLoader = false;
                if (allfriends.length > 0) {
                  //$scope.FBfreinds.length = 0;
                  //MyService.ConsoleLog("inside frdata >> ", frdata);
                  var fresults = $scope.FBfreindsFinal.map(function (frdata) {
                    //MyService.ConsoleLog(frdata.id);
                    //MyService.ConsoleLog(allfriends.indexOf(frdata.id));
                    if (allfriends.indexOf(frdata.id) > -1) {
                      $scope.FBfreinds.push(frdata);
                      return frdata;
                    }
                  });
                  //MyService.ConsoleLog(fresults);
                  //$scope.FBfreinds = fresults;
                  //MyService.ConsoleLog($scope.FBfreindsFinal);
                  if ($scope.fbwallDlg != "") {
                    //MyService.ConsoleLog($scope.fbwallDlg);
                    ngDialog.close($scope.fbwallDlg.id);
                  }
                  $scope.fbFrdDlg = ngDialog.open({
                    template: 'FBFreindList',
                    scope: $scope
                  });
                } else {

                  alert("none of your friends have answered yet. You should write them and ask them to answer");
                }



              }, function (errpayload) {
                $scope.DisplayFLoader = false;
                //MyService.ConsoleLog("errpayload", errpayload);
              })



            } else {
              $scope.DisplayFLoader = false;
              alert("Your freinds not yet joined VoteWise.net. Ask them to join by posting a message on Facebook Wall?");
            }
          } else {
            $scope.DisplayFLoader = false;
            //MyService.ConsoleLog('Something goes wrong', response);
          }
        }, {
          scope: 'user_friends'
        });
      }, {
        scope: 'user_friends',
        auth_type: 'rerequest'
      });
    }

    $scope.selection = [];

    // helper method to get selected fruits
    $scope.selectedFrds = function () {
      return filterFilter($scope.FBfreinds, {
        selected: true
      });
    };

    // watch fruits for changes
    // $scope.$watch('FBfreinds|filter:{selected:true}', function(nv) {
    //     $scope.selection = nv.map(function(FBfreinds) {
    //         return FBfreinds.id;
    //     });
    // }, true);

    $scope.selectedFrd = function (frd) {
      //MyService.ConsoleLog(frd);
      var idx = $scope.selection.indexOf(frd.id);
      if (idx == -1) {
        $scope.selection.push(frd.id);
      } else {
        $scope.selection.splice(idx, 1);
      }
    }


    $scope.displayMatch = function () {
      //alert("This needs to be implemented");
      FB.getLoginStatus(function (response) {
        //MyService.ConsoleLog(response);
        if (response.status == 'unknown') {
          FB.login(function (response) {
            //statusChangeCallback(response, 'login');
            //MyService.ConsoleLog(response);
            MyService.updateFBID({
              "facebookid": response.authResponse.userID
            }).then(function (payload) {
              if (payload.data.error && payload.data.error == "FBDUPLICATE") {
                $scope.DisplayFLoader = false;
                alert("Facebook user doesn't match with your account.");
              } else {
                $scope.checkFBFreinds();
              }

            }, function (errpayload) {
              $scope.DisplayFLoader = false;
              alert("Something went wrong. Please try again later.");
            });
          }, {
            scope: 'public_profile,email,publish_actions',
            return_scopes: true
          });
        } else {
          // if($scope.userData && $scope.userData.facebookid) {
          //     if(response.authResponse.userID==$scope.userData.facebookid ) {
          //         var message = "Here is some message";
          //         $scope.postOnWall(message);
          //     } else {
          //         $scope.DisplayFLoader = false;
          //        alert("Facebook user doesn't match with your account.");
          //     }
          // } else {
          //     $scope.checkFBFreinds();
          // }
          $scope.checkFBFreinds();
        }
      });

    }
    $scope.FBCompareList = [];
    $scope.AnswerArray = [];
    $scope.AnswerArray[1] = "Very Strongly Agree";
    $scope.AnswerArray[2] = "Agree";
    $scope.AnswerArray[3] = "Somewhat Agree";
    $scope.AnswerArray[4] = "Somewhat Disagree";
    $scope.AnswerArray[5] = "Disagree";
    $scope.AnswerArray[6] = "Very Strongly Disgree";
    $scope.AnswerImpArray = [];
    $scope.AnswerImpArray[1] = "Somewhat Important";
    $scope.AnswerImpArray[2] = "Important";
    $scope.AnswerImpArray[3] = "Very Important";
    $scope.Math = window.Math;
    $scope.ComapreWithSelected = function () {
      //MyService.ConsoleLog($scope.selection);
      //MyService.ConsoleLog("ComapreWithSelected");
      //MyService.ConsoleLog($rootScope.OldCatforFB._id);
      //MyService.ConsoleLog($scope.retainOptions);
      if ($scope.selection.length > 0) {
        var frdlist = JSON.stringify($scope.selection);
        MyService.CompareWithFreinds({
          "frds": frdlist,
          "categoryIds": $rootScope.OldCatforFB._id
        }).then(function (payload) {
          //MyService.ConsoleLog(payload);
          $scope.FBCompareList.length = 0;
          if (payload.data.success) {
            //MyService.ConsoleLog(payload.data.data);
            $scope.FBCompareList = payload.data.data.qdata;
            if ($scope.FBCompareList.length > 0) {
              ngDialog.open({
                template: 'FBFreindCompare',
                scope: $scope
              });
              $scope.FBunWeighted = payload.data.data.unweightedMatch;
              $scope.fbcombinedWeight = payload.data.data.fbcombinedWeight;
              $scope.fbmultiplier = payload.data.data.fbmultiplier;
              $scope.fbqlen = payload.data.data.qlen;
            } else {
              alert("Looks like your freinds not yet answered the questions.");
              //MyService.ConsoleLog($scope.FBCompareList);
            }
          } else {
            alert("Something went wrong.");
          }
        }, function (errorpayload) {
          alert("Something went wrong.");
        })
      } else {
        alert("Please select at least one Friend to compare with");
      }
    }

    $scope.allQuestions = [];
    $scope.switchStatus = [];
    $scope.chooseQuestions = function () {
      MyService.ConsoleLog("$scope.oldQuestions", $scope.oldQuestions);
      // if ($scope.oldQuestions && $scope.oldQuestions.length > 0) {
      //   $scope.allQuestions = $scope.oldQuestions;
      // }
      if ($scope.allQuestions.length > 0) {
        $scope.showHidePop = ngDialog.open({
          template: 'ReviewMyAnswers',
          scope: $scope,
          width: "60%"
        });
      } else {
        MyService.ConsoleLog("here >>>>>>>>>>>>>>>>>>>");
        alert("There are no questions to display. Please go through all questions first.")
      }
    }
    //$scope.switchStatus = "Show";
    $scope.showloader = false;
    $scope.switchFilters = function (newValue, index, quest) {
      $scope.showloader = true;
      // MyService.ConsoleLog("newValue::", newValue);
      // MyService.ConsoleLog("oldValue::", $scope.switchStatus);
      var setVal = "N";
      if (newValue[index] == true) {
        setVal = "Y";
      }

      var idx = $scope.allQuestions.indexOf(quest);
      //MyService.ConsoleLog("setVal:", setVal);
      MyService.updateAnswers({
        "qid": quest._id,
        "show": setVal,
        "author": quest.author
      }).then(function (payload) {
        //MyService.ConsoleLog("payload : ", payload);
        $scope.showloader = false;
        if (payload.data.success) {
          quest.my_answer.show = setVal;
          $scope.allQuestions[idx] = quest;
          // alert("Record updated successfully");
        } else {
          alert("Something went wrong. Contact administrator.");
        }
      }, function (errorpayload) {
        $scope.showloader = false;
        //MyService.ConsoleLog("errorpayload : ", errorpayload);
        alert("Something went wrong. Contact administrator.");
      });
    }


    $scope.NextOptions = function (option) {
      //MyService.ConsoleLog(option);
      switch (option) {
        case "R":
          $scope.fbwallDlg.close();
          $location.path('/fiveSaveUser');
          break;
        case "C":
          // MyService.ConsoleLog("one more new : ", $scope.traverseBackgrounds);
          // $scope.traverseBackgrounds.filter(function (itm, index) {
          //   if ($routeParams.selectedCatId == itm._id) {
          //     MyService.ConsoleLog("index", index);
          //     var fnInd = index + 1;
          //     var chkId = $scope.traverseBackgrounds[fnInd];
          //     if (chkId && chkId.total_questions != 0) {
          //       $scope.catInd = fnInd;
          //     } else {
          //       $scope.catInd = fnInd + 1;
          //     }

          //   }
          // });
          // var catIds = $scope.traverseBackgrounds[$scope.catInd];
          // MyService.ConsoleLog("catIds", catIds);
          // MyService.ConsoleLog("check this new one", $scope.retainOptions);
          // $scope.retainOptions = "";
          // $scope.retainOptions = {
          //   categoryId: catIds._id
          // };
          // $scope.category = catIds;
          // getMoreQuestions($scope.retainOptions);
          ngDialog.close($scope.fbwallDlg.id);
          $location.path('/questionHome');
          break;
        case "P":
          //$scope.postFB();
          // $scope.fbFrdDlg = ngDialog.open({
          //   template: 'FBComposeMessage',
          //   scope: $scope
          // });
          MyService.ConsoleLog("$rootScope.OldCatforFB.", $rootScope.OldCatforFB)
          $scope.fbwallDlg.close();
          $cookies.put('quizLinks', $scope.quizLink);
          var qData = window.localStorage.getItem('quesData');
          window.localStorage.removeItem('fiveMatch');
          window.localStorage.setItem('fiveMatch', qData);
          $location.path('/showHideAns');
          break;
        case "Q":
          $scope.chooseQuestions();
          break;
        case "M":
          $scope.displayMatch();
          break;
        case "F":
          ngDialog.close($scope.fbwallDlg.id);

          if (!apiCall.getToken()) {
            MyService.ConsoleLog('IF');

            $scope.confirmPopup();
          } else {
            MyService.ConsoleLog('ELSE');

            $location.path('/findMatch/');

          }
          break;
        case 'L':
          $scope.fbwallDlg.close();
          $location.path('/essay/' + $routeParams.categoryId);
          break;
        case 'D':
          $scope.fbwallDlg.close();
          $location.path('/discussWithOthers/' + $routeParams.categoryId + '/' + $routeParams.selectedCatId);
          break;
        case 'PS':
          $scope.createLink();
          break;
        default:
          getMoreQuestions($scope.retainOptions);
          break;
      }

    }



    $scope.confirmPopup = function () {
      MyService.ConsoleLog("address : ", $scope.address);
      var message = "Without your voice, your politicians won’t know how to represent you. Before we show you your results, would you like to create a profile so we can tell your politicians what you want them to do?  It takes 45 seconds, is free and you won't get spammed.  Politicians just need to know that you are real and live in their district.";
      var modal = ngDialog.openConfirm({
        template: '<p>' + message + '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="compareBtn" ng-click="confirm(0)">Register</button>\
                            <button type="button" class="eraseBtn" ng-click="confirm(1)">Skip</button>\
                        </div>',
        plain: true
      });



      modal.then(function fullfilled(data) {
        MyService.ConsoleLog("fullfilled: ", data);
        if (data == 0) {
          $location.path('/fiveSaveUser');

          // $scope.saveUserAnswers();
        } else {
          // $scope.eraseUserAnswers();
          $location.path('/findMatch/');
          // ngDialog.close();

          // var message = "Thanks for answering those questions";
          // var modal = ngDialog.openConfirm({
          //   template: '<p>' + message + '</p>\
          //               <div class="ngdialog-buttons">\
          //                   <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
          //               </div>',
          //   plain: true
          // });

        }
      }, function rejected(data) {
        MyService.ConsoleLog("rejected: ", data);
      });

      return;
    };


    $scope.ord = {
      "Option": "BW"
    };

    $scope.checkMyOrder = function (frnd) {
      //MyService.ConsoleLog($scope.ord.Option);
      switch ($scope.ord.Option) {
        case "BW":
          return -($scope.fbcombinedWeight[frnd.id] / $scope.fbmultiplier[frnd.id]);
          break;
        case "W":
          return ($scope.fbcombinedWeight[frnd.id] / $scope.fbmultiplier[frnd.id]);
          break;
        case "BS":
          return -($scope.FBunWeighted[frnd.id] / $scope.fbqlen[frnd.id]);
          break;
        case "S":
          return ($scope.FBunWeighted[frnd.id] / $scope.fbqlen[frnd.id]);
          break;
        default:
          return -($scope.fbcombinedWeight[frnd.id] / $scope.fbmultiplier[frnd.id]);
          break;

      }

    }

    /**
     *
     * Get local best match of politician and organizations
     */

    $scope.getLocalMatch = function () {
      $scope.showLoaderNw = true;
      var testItm = window.localStorage.getItem('quesData');
      MyService.ConsoleLog("<<<<<< $scope.questions >>>>>>>", JSON.parse(testItm));

      MyService.getMatchOfLocalPoli({
        questions: testItm
      }).then(function (response) {
        MyService.ConsoleLog("response", response);
        if (response.data.success) {
          $scope.poliData = response.data.data.politician;
          $scope.orgData = response.data.data.advocate;
          $scope.showLoaderNw = false;
          $scope.fbwallDlg = ngDialog.open({
            template: 'nextQuestionOptions',
            scope: $scope
          });
        } else {
          $scope.showLoaderNw = false;
          $scope.skipToMatch = false;
          $scope.skipToFinal = false;
          getMoreQuestions($scope.retainOptions);
        }

      }, function (err) {
        $scope.showLoaderNw = false;
        growl.error(err);
      });
    };


    $scope.redirectTo = function (type, id) {
      $scope.fbwallDlg.close();
      if (type == 'politician') {
        $location.path('/publicProfile/' + id);

      } else {
        $location.path('/pressProfile/' + id);
      }
    };

    function getQuestions(params) {
      MyService.ConsoleLog("getQuestions params");
      MyService.ConsoleLog(params);
      //MyService.ConsoleLog($rootScope.OldCatforFB);
      $scope.oldQuestions = angular.copy($scope.questions);
      $scope.questions.length = 0;
      $scope.currentIndex = 0;
      $scope.retainOptions = params;
      MyService.ConsoleLog("$scope.questionsData", $scope.questionsData);
      //MyService.ConsoleLog($routeParams.selectedCatId);

      MyService.ConsoleLog(params.categoryId + "======" + $routeParams.selectedCatId);
      if (params.categoryId != $routeParams.selectedCatId) {
        // alert('in');
        if (tokenService.getUserId()) {
          $scope.chkAnsQues = $scope.checkAnswerQuestions($scope.questionsData);
          if ($scope.questionsData.length == $scope.chkAnsQues.length && $scope.saveForLater) {
            var catId, selCat_id;
            catId = window.localStorage.getItem('cat_id');
            selCat_id = window.localStorage.getItem('selCat_id');
            var tempLink = $location.absUrl().split("#!");
            var quizLinks = tempLink[0] + "#!/question-background/" + catId + "/" + selCat_id;
            MyService.updateRemainingQuiz({
              saveLink: quizLinks,
              userId: $scope.userId,
              quizName: window.localStorage.getItem('fbName')
            }).then(function (APIResponse) {
              MyService.ConsoleLog("APIResponse", APIResponse);
            }, function (err) {
              console.log("Error", err);
            });
          }

          $scope.getLocalMatch();

        } else {
          $scope.fbwallDlg = ngDialog.open({
            template: 'nextQuestionOptions',
            scope: $scope
          });
        }
        MyService.ConsoleLog("$scope.retainOptions nssssss", $scope.retainOptions);

        //MyService.ConsoleLog($scope.fbwallDlg);
        //getMoreQuestions(params);
      } else {
        // alert('sss');
        // ngDialog.open({
        //     template: 'nextQuestionOptions',
        //     scope: $scope
        // });
        // var obj = {};
        // obj.categoryId = $routeParams.selectedCatId;
        // MyService.ConsoleLog("params", params);
        getMoreQuestions(params);
      }
    }

    var getCategoryCanceler = $q.defer();
    var prevFetchedCategoryId = null;

    $scope.getCategory = function (params) {
      MyService.ConsoleLog("cat params", params);
      window.localStorage.removeItem("selCat_id");
      window.localStorage.setItem("selCat_id", params.id);
      try {
        prevFetchedCategoryId = $scope.category._id
      } catch (e) {}

      if (prevFetchedCategoryId != params.id) {
        //MyService.ConsoleLog("scrollTop");
        $("html, body").animate({
          scrollTop: 0
        }, "slow");
        getCategoryCanceler.resolve();
        getCategoryCanceler = $q.defer();
        $scope.status.category = 1;
        var request = apiCall.apiCall('GET', '/categories/list', params);
        request.headers['Cache-Control'] = 'No-Store';
        request.timeout = getCategoryCanceler.promise;
        $http(
            request
          )
          .then(function successCallback(response) {
            //MyService.ConsoleLog("Got categories: ",response);
            if (response.data.success) {
              // alert('one');
              MyService.ConsoleLog("one >>>>>>>>>>>");
              // if (params.id == $routeParams.selectedCatId) {
              $scope.category = response.data.data;
              // }


              //MyService.ConsoleLog("category data: ", $scope.category);
              prevFetchedCategoryId = $scope.category._id;
              $scope.status.category = 2;
            } else {
              //MyService.ConsoleLog("Something went wrong: ", response.data);
              $scope.status.category = 3;
            }
          }, function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
            $scope.status.category = 3;
          });
      }
    };

    var getLevelCategoryCanceler = $q.defer();

    function getLevelCategory(params) {
      getLevelCategoryCanceler.resolve();
      getLevelCategoryCanceler = $q.defer();
      $scope.status.levlCat = 1;
      var request = apiCall.apiCall('GET', '/categories/list-layer', params);
      request.headers['Cache-Control'] = 'No-Store';
      request.timeout = getLevelCategoryCanceler.promise;
      $http(
          request
        )
        .then(function successCallback(response) {

          //MyService.ConsoleLog("Got categories: ",response);
          if (response.data.success) {
            /*
            angular.forEach(response.data.data, function(val, key){
                if(val.total_questions > 0){
                    $scope.traverseBackgrounds.push(val);
                }
            });
            //MyService.ConsoleLog("traverseBackgrounds data: ", $scope.traverseBackgrounds);
            if($scope.traverseBackgrounds.length > 0){
                $scope.currBackgroundIndex = 0;
                $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
            }
            */
            $scope.traverseBackgrounds = response.data.data;
            if ($routeParams.selectedCatId) {
              //MyService.ConsoleLog("traverseBackgrounds: ", $scope.traverseBackgrounds);
              //MyService.ConsoleLog("$routeParams.selectedCatId: ", $routeParams.selectedCatId);
              angular.forEach($scope.traverseBackgrounds, function (val, key) {
                if (val._id == $routeParams.selectedCatId) {
                  //MyService.ConsoleLog("val._id: ", val._id, " key: ", key, " total_questions: ", val.total_questions);
                  $scope.currBackgroundIndex = key;
                  //MyService.ConsoleLog("$scope.currBackgroundIndex: ", key);
                  $scope.category = angular.copy(val);
                  $cookies.put('QuizName', $scope.category.title);
                  MyService.ConsoleLog("check two", $scope.category);
                  // $rootScope.fbImage =  $scope.category.fbImage;
                  window.localStorage.setItem('fbImg', $scope.category.fbImage);
                  window.localStorage.setItem('fbName', $scope.category.title);

                }
              });
            } else if ($scope.traverseBackgrounds.length > 0) {
              MyService.ConsoleLog("three >>>>>>>>>>>");
              $scope.category = $scope.traverseBackgrounds[0];
            }
            $scope.status.levlCat = 2;
          } else {
            //MyService.ConsoleLog("Something went wrong: ", response.data);
            $scope.status.levlCat = 3;
          }
        }, function errorCallBack(response) {
          //MyService.ConsoleLog("Error: ", response);
          $scope.status.levlCat = 3;
        });
    }

    function getPopularQuestions() {
      //MyService.ConsoleLog("** getPopularQuestions **");
      var categoryIds = $routeParams.categoryId.split("popular:")[1];
      var request = apiCall.apiCall('GET', '/answers/popular', {
        "categoryIds": categoryIds
      });
      $http(
        request
      ).then(function successCallback(response) {
        //MyService.ConsoleLog("Got PopularQuestions: ", response);
        if (response.data.success) {
          // response.data.data[1].categories.cid = "579b6d83d0cfc69732251494"; //for testing purpose
          $scope.questions = response.data.data;
          if ($scope.questions.length > 0) {
            $scope.getCategory({
              id: $scope.questions[0].categories.cid
            });
          }
        } else {
          //MyService.ConsoleLog("Something went wrong: ", response.data);
        }
      }, function errorCallBack(response) {
        //MyService.ConsoleLog("Error: ", response);
      });
    }

    var getPopularCategoriesCanceler = $q.defer();
    $scope.getPopularCategories = function (params) {
      //MyService.ConsoleLog("** getPopularQuestions **");
      getPopularCategoriesCanceler.resolve();
      params.timeout = getPopularCategoriesCanceler.promise;

      var request = apiCall.apiCall('POST', '/categories/popular-subcategories', params);
      $http(
        request
      ).then(function successCallback(response) {
        //MyService.ConsoleLog("Got PopularQuestions: ", response);
        if (response.data.success) {
          // response.data.data[1].categories.cid = "579b6d83d0cfc69732251494"; //for testing purpose
          $scope.traverseBackgrounds = response.data.data;
          if ($scope.traverseBackgrounds.length > 0) {
            MyService.ConsoleLog("four >>>>>>>>>>>");
            $scope.category = $scope.traverseBackgrounds[0];
            prevFetchedCategoryId = $scope.category._id;
            // getQuestions({categoryId: $scope.category._id});
          }
        } else {
          //MyService.ConsoleLog("Something went wrong: ", response.data);
        }
      }, function errorCallBack(response) {
        //MyService.ConsoleLog("Error: ", response);
      });
    };

    $scope.notAnswerableSelected = function () {
      /*
      if($scope.answer == 0){
          var message = 'Many of our Statements have an undeniable fact followed by an opinion.  Like “the sky is blue.  I hate the sky.”  If this is your problem with the question, then realize that this is just part of the question process and just respond to the second half.  If not, please explain the problem in the “add comments” section so we can fix it.  Thank you.';
          var modal = ngDialog.openConfirm({
              template:'<p>'+message+'</p>\
                      <div class="ngdialog-buttons">\
                          <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                      </div>',
              plain: true
          });

          modal.then(function fullfilled(data){
              //MyService.ConsoleLog("fullfilled: ",data);
          }, function rejected(data){
              //MyService.ConsoleLog("rejected: ",data);
          });
      }
      */
      //for report question

      // commented by vishal on 18 February 2019

      var token = apiCall.getToken();

      if (!token || token == "") {
        var message = "Please login first.";

        var modal = ngDialog.openConfirm({
          template: '<p>' + message + '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
          plain: true
        });

        modal.then(function fullfilled(data) {
          //MyService.ConsoleLog("fullfilled: ", data);
        }, function rejected(data) {
          //MyService.ConsoleLog("rejected: ", data);
        });

        return;
      }
      var postData = {
        questionId: $scope.questions[$scope.currentIndex]._id,
        importance: 0, //$scope.importance,
        answer: $scope.answer,
        comment: $scope.comment
      };

      ngDialog.open({
        template: 'app/popups/report_question.html',
        controller: 'ReportQuesCtrl',
        data: postData
      });

    };

    /**
     * @description Funtion is use to skip qustion using submit button click
     */
    $scope.skipToNext = function () {
      var tempIndex = $scope.currentIndex + 1;
      // MyService.ConsoleLog("MyLog >>", tempIndex);
      if (tempIndex < $scope.questions.length) {
        // alert('inside');
        $scope.initializeVariables();
        $scope.currentIndex++;
        MyService.ConsoleLog("cat", $routeParams.categoryId);

        if ($routeParams.categoryId && $routeParams.categoryId.indexOf("popular:") == 0) {
          //we are showing questions of most popular section
          MyService.ConsoleLog("$routeParams.categoryId", $routeParams.categoryId);

          $scope.getCategory({
            id: $scope.questions[$scope.currentIndex].categories.cid
          });
        }
      }
      MyService.ConsoleLog("tempIndex => ", tempIndex + "$scope.questions.length " + $scope.questions.length);


      if (tempIndex == $scope.questions.length) {

        MyService.ConsoleLog("end of questions switch background");
        var tempBackIdx = $scope.currBackgroundIndex + 1;
        if (tempBackIdx < $scope.traverseBackgrounds.length) {
          MyService.ConsoleLog("$scope.traverseBackgrounds >>", $scope.traverseBackgrounds);
          MyService.ConsoleLog("$scope.traverseBackgrounds >>", $scope.traverseBackgrounds[1].title);

          // if ($scope.traverseBackgrounds[1].title == 'General') {
          //   MyService.ConsoleLog("IF");
          //   var y = 1;
          //   $scope.currBackgroundIndex = ++y;
          //   MyService.ConsoleLog("IFFFFFFFFFFF >>", $scope.currBackgroundIndex);
          // } else {
          //   MyService.ConsoleLog("ELSE");
          $scope.currBackgroundIndex++;

          // }

          MyService.ConsoleLog("$scope.$scope.currBackgroundIndex>>", $scope.currBackgroundIndex);

          $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
          MyService.ConsoleLog("$scope.category yogesh", $scope.category);
        } else {
          MyService.ConsoleLog("* End of background Yogesh *");

          $scope.fbwallDlg = ngDialog.open({
            template: 'nextQuestionOptions',
            scope: $scope
          });
          // $location.path('/questionSubcategories/' + $routeParams.categoryId);
        }
      } else if ($scope.questions.length == 0) {

        var tempBackIdx = $scope.currBackgroundIndex + 1;
        if (tempBackIdx < $scope.traverseBackgrounds.length) {
          MyService.ConsoleLog("$scope.traverseBackgrounds >>", $scope.traverseBackgrounds);
          MyService.ConsoleLog("$scope.traverseBackgrounds >>", $scope.traverseBackgrounds[1].title);

          // if ($scope.traverseBackgrounds[1].title == 'General') {
          //   MyService.ConsoleLog("IF");
          //   var y = 1;
          //   $scope.currBackgroundIndex = ++y;
          //   MyService.ConsoleLog("IFFFFFFFFFFF >>", $scope.currBackgroundIndex);
          // } else {
          //   MyService.ConsoleLog("ELSE");
          $scope.currBackgroundIndex++;

          // }

          MyService.ConsoleLog("$scope.$scope.currBackgroundIndex>>", $scope.currBackgroundIndex);

          $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
          MyService.ConsoleLog("$scope.category second five", $scope.category);
        } else {
          MyService.ConsoleLog("* End of background *");
          $location.path('/questionSubcategories/' + $routeParams.categoryId);
        }

      }
    };
    var temp = [];
    var netm = [];
    $scope.postAnswer = function (postData) {
      //MyService.ConsoleLog("postData: ", postData);
      try {
        var my_answer = $scope.questions[$scope.currentIndex].my_answer;
        MyService.ConsoleLog(" my_answer", my_answer);
        // check if the inviter is exists or not if not then check for answers values if any value chnage then we are updating that answer.
        if (!window.localStorage.getItem('inviterId')) {
          if (my_answer.importance != $scope.importance || my_answer.answer != $scope.answer || my_answer.comment != $scope.comment) {
            //MyService.ConsoleLog("Answer changed");
            postData.id = my_answer._id;
            postData.reason = $scope.reason;
          } else {
            // If value not change then we are just skip that question.
            // MyService.ConsoleLog("Answer not changed");
            $scope.skipToNext();
            return; //don't do anything
          }
        } else {
          // If inviter Id exists then we are updating answer.
          postData.id = my_answer._id;
        }

      } catch (e) {
        //MyService.ConsoleLog("Exceptoin: ", e);
      }
      console.log("postData > ", postData);
      MyService.postAnswer(postData).then(function (response) {
        if (response.data.success) {
          try {
            if (postData.id) {
              MyService.ConsoleLog("Inside If");
              $scope.questions[$scope.currentIndex]["my_answer"] = {
                _id: postData.id,
                created: new Date(),
                comment: postData.comment,
                answer: postData.answer,
                importance: postData.importance
              };
              netm.push($scope.questions[$scope.currentIndex]);
              if ($scope.questions.length == netm.length) {
                window.localStorage.removeItem('quesData');
                MyService.ConsoleLog("set it now netm", netm);
                window.localStorage.setItem('quesData', JSON.stringify(netm));
              } else {
                MyService.ConsoleLog("Its ELSE Need to add updated record in array");
                var testItm = window.localStorage.getItem('quesData');
                // MyService.ConsoleLog("testItm", JSON.parse(testItm));
                var tempQ = JSON.parse(testItm);

                tempQ[$scope.currentIndex]["my_answer"] = {
                  _id: postData.id,
                  created: new Date(),
                  comment: postData.comment,
                  answer: postData.answer,
                  importance: postData.importance
                };
                // MyService.ConsoleLog("$scope.currentIndex", tempQ[$scope.currentIndex]);
                // MyService.ConsoleLog("tempQ", tempQ);
                window.localStorage.removeItem('quesData');
                window.localStorage.setItem('quesData', JSON.stringify(tempQ));
              }
            } else {
              MyService.ConsoleLog("Inside ELSEEEE");

              $scope.questions[$scope.currentIndex]["my_answer"] = {
                _id: response.data.data._id,
                created: response.data.data.created,
                comment: response.data.data.comment,
                answer: response.data.data.answer,
                importance: response.data.data.importance
              };
              MyService.ConsoleLog(" $scope.questions[$scope.currentIndex]", $scope.questions[$scope.currentIndex]);
              temp.push($scope.questions[$scope.currentIndex]);
              if ($scope.questions.length == temp.length) {
                window.localStorage.removeItem('quesData');
                MyService.ConsoleLog("set it now", temp);
                window.localStorage.setItem('quesData', JSON.stringify(temp));
              }
            }
          } catch (e) {
            //MyService.ConsoleLog("Exceptoin: ", e);
          }
          if (postData.id) {
            growl.success("Answer updated successfully", {
              ttl: 800
            });
          } else {
            growl.success("Answered successfully", {
              ttl: 800
            });
          }
          $scope.initializeVariables();
          $scope.skipQuestion();
        } else {
          growl.error("Error: " + response.data.error);
        }
      }, function (err) {
        growl.error("Something went wrong.");
      });

      /*
            var request = apiCall.apiCall('POST', '/answers/create', postData);
            $http(
              request
            ).then(function successCallback(response) {
              //MyService.ConsoleLog("succss: ",response);
              if(response.data.success){
                try{
                    $scope.questions[$scope.currentIndex]["my_answer"] = {
                        _id: response.data.data._id,
                        created: response.data.data.created,
                        comment: response.data.data.comment,
                        answer: response.data.data.answer,
                        importance: response.data.data.importance
                    };
                }
                catch(e){
                    //MyService.ConsoleLog("Exceptoin: ",e);
                }
                growl.success("Answered successfully", {ttl: 800});
                $scope.initializeVariables();
                $scope.skipQuestion();
              }
              else{
                growl.error("Error: "+response.data.error);
              }
            }, function errorCallback(response) {
              $scope.error = 'Wrong Email or Password';
            });
            */

    };

    /*
     *
     * This function called when guest user want to take quiz
     *
     **/
    var ques = [];
    $scope.guest = function (postData) {
      //MyService.ConsoleLog("postData: ", postData);
      try {
        var my_answer = $scope.questions[$scope.currentIndex].my_answer;
        if (my_answer.importance != $scope.importance || my_answer.answer != $scope.answer || my_answer.comment != $scope.comment) {
          //MyService.ConsoleLog("Answer changed");
          postData.id = my_answer._id;
          postData.reason = $scope.reason;
        } else {
          //MyService.ConsoleLog("Answer not changed");
          return; //don't do anything
        }
      } catch (e) {
        //MyService.ConsoleLog("Exceptoin: ", e);
      }
      console.log("postData > ", postData);

      MyService.guestAnswers(postData).then(function (response) {
        if (response.data.success) {
          try {
            if (postData.id) {
              $scope.questions[$scope.currentIndex]["my_answer"] = {
                _id: postData.id,
                created: new Date(),
                comment: postData.comment,
                answer: postData.answer,
                importance: postData.importance
              };
              MyService.ConsoleLog("Inside IF >>", $scope.questions);
            } else {
              $scope.questions[$scope.currentIndex]["my_answer"] = {
                _id: response.data.data._id,
                created: response.data.data.created,
                comment: response.data.data.comment,
                answer: response.data.data.answer,
                importance: response.data.data.importance
              };
              if ($scope.questions[$scope.currentIndex].my_answer) {
                MyService.ConsoleLog("Inside ELSE >>", $scope.questions[$scope.currentIndex]);
                ques.push($scope.questions[$scope.currentIndex]);
                if ($scope.questions.length == ques.length) {
                  window.localStorage.removeItem('quesData');
                  MyService.ConsoleLog("set it now", ques);
                  window.localStorage.setItem('quesData', JSON.stringify(ques));
                }
              }

            }
          } catch (e) {
            //MyService.ConsoleLog("Exceptoin: ", e);
          }
          if (postData.id) {
            growl.success("Answer updated successfully", {
              ttl: 800
            });
          } else {
            growl.success("Answered successfully", {
              ttl: 800
            });
          }
          $scope.initializeVariables();
          $scope.skipQuestion();
        } else {
          growl.error("Error: " + response.data.error);
        }
      }, function (err) {
        growl.error("Something went wrong.");
      });


      /*
        var request = apiCall.apiCall('POST', '/answers/create', postData);
        $http(
          request
        ).then(function successCallback(response) {
          //MyService.ConsoleLog("succss: ",response);
          if(response.data.success){
            try{
                $scope.questions[$scope.currentIndex]["my_answer"] = {
                    _id: response.data.data._id,
                    created: response.data.data.created,
                    comment: response.data.data.comment,
                    answer: response.data.data.answer,
                    importance: response.data.data.importance
                };
            }
            catch(e){
                //MyService.ConsoleLog("Exceptoin: ",e);
            }
            growl.success("Answered successfully", {ttl: 800});
            $scope.initializeVariables();
            $scope.skipQuestion();
          }
          else{
            growl.error("Error: "+response.data.error);
          }
        }, function errorCallback(response) {
          $scope.error = 'Wrong Email or Password';
        });
        */

    };


    $rootScope.$on('question.answered', function (evt, data) {
      MyService.ConsoleLog("on question.answered: ", data);
      if ($scope.questions[$scope.currentIndex]._id == data.questionId) {
        $scope.initializeVariables();
        $scope.skipQuestion();
      }
    });

    var guestArr = [];
    var guestCookies;
    // $cookies.remove('sessionId');

    // var guestOne = window.localStorage.getItem('guestMatch');
    // if (guestOne && guestOne != "") {
    //   MyService.ConsoleLog("$rootScope >>", guestOne);
    //   alert('got');
    // } else {
    $rootScope.guestMatch = [];
    $rootScope.guestMatch.length = 0;
    // }

    $scope.submitAnswer = function () {
      //MyService.ConsoleLog("submitAnswer: " + $scope.answer);
      //MyService.ConsoleLog("importance: " + $scope.importance);
      //MyService.ConsoleLog("comments: ", $scope.comment);

      // Commented by Vishal on 18 th February 2019

      var token = apiCall.getToken();

      // if (!token || token == "") {
      //   var message = "Please login first.";
      //   var modal = ngDialog.openConfirm({
      //     template: '<p>' + message + '</p>\
      //                   <div class="ngdialog-buttons">\
      //                       <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
      //                   </div>',
      //     plain: true
      //   });
      //   modal.then(function fullfilled(data) {
      //     //MyService.ConsoleLog("fullfilled: ", data);
      //   }, function rejected(data) {
      //     //MyService.ConsoleLog("rejected: ", data);
      //   });
      //   return;
      // }

      if ($scope.answer == null) {
        var message = "Please select answer first.";
        var modal = ngDialog.openConfirm({
          template: '<p>' + message + '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
          plain: true
        });
        modal.then(function fullfilled(data) {
          //MyService.ConsoleLog("fullfilled: ", data);
        }, function rejected(data) {
          //MyService.ConsoleLog("rejected: ", data);
        });
        return;
      }

      if ($scope.importance == null) {
        var message = "You gave your opinion, but you didn’t say how important this is to you.  Should they fight hard for this or can they use it as a bargaining chip to get other things you care about more?";
        var modal = ngDialog.openConfirm({
          template: '<p>' + message + '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
          plain: true
        });
        modal.then(function fullfilled(data) {
          //MyService.ConsoleLog("fullfilled: ", data);
        }, function rejected(data) {
          //MyService.ConsoleLog("rejected: ", data);
        });

        return;
      }


      MyService.ConsoleLog("token  >>", token);
      var postData;
      if (!window.localStorage.getItem('inviterId')) {
        postData = {
          questionId: $scope.questions[$scope.currentIndex]._id,
          importance: $scope.importance,
          answer: $scope.answer,
          comment: $scope.comment,
          token: token ? token : "",
        };
      } else {
        postData = {
          questionId: $scope.questions[$scope.currentIndex]._id,
          importance: $scope.importance,
          answer: $scope.answer,
          comment: $scope.comment,
          token: token ? token : "",
          isShare: $scope.isShare,
          inviterId: $scope.inviterId,
          catId: $routeParams.categoryId,
          selCatId: $routeParams.selectedCatId
        };
      }


      if (!token) {
        MyService.ConsoleLog("Inside IF");




        // $cookies.remove('guest');

        if (!guestCookies || guestCookies == "") {
          $rootScope.finalSessionId = "";
          MyService.ConsoleLog("Inside", guestCookies);
          var date = new Date();
          var sessionId = date.getTime();
          $rootScope.finalSessionId = sessionId;
          MyService.ConsoleLog("sessionId >>", $rootScope.finalSessionId);
          $cookies.put('sessionId', $rootScope.finalSessionId);


        }
        var guessObj;
        // window.sessionStorage;
        if ($scope.inviterId) {
          guessObj = {
            questionId: $scope.questions[$scope.currentIndex]._id,
            importance: $scope.importance,
            answer: $scope.answer,
            comment: $scope.comment,
            gSessionId: $rootScope.finalSessionId,
            isShare: $scope.isShare,
            inviterId: $scope.inviterId,
            catId: $routeParams.categoryId,
            selCatId: $routeParams.selectedCatId,
            quizType: 'Regular Quiz'
          };
        } else {
          guessObj = {
            questionId: $scope.questions[$scope.currentIndex]._id,
            importance: $scope.importance,
            answer: $scope.answer,
            comment: $scope.comment,
            gSessionId: $rootScope.finalSessionId,
            quizType: 'Regular Quiz'
          };
        }
        // guestArr.push(guessObj);

        var chkData = $scope.checkQuestions($rootScope.guestMatch, guessObj.questionId);


        if (chkData && chkData.length == 0) {
          $rootScope.guestMatch.push(guessObj);
          window.localStorage.setItem('guestMatch', JSON.stringify($rootScope.guestMatch));
          MyService.ConsoleLog("$rootScope.guestMatch >>>", $rootScope.guestMatch);
        }


        guestCookies = $cookies.get('sessionId');

        // window.sessionStorage.setItem("guest", JSON.stringify(guestArr));
        // // var test = sessionStorage.guest.length;

        MyService.ConsoleLog("guestCookies >>>", guestCookies.sessionId);
        // var one = sessionStorage.getItem('guest');
        // MyService.ConsoleLog("guessObj >>>", JSON.parse(one));
        $scope.guest(guessObj);
      } else {
        MyService.ConsoleLog("Else", postData);
        $scope.postAnswer(postData);
      }
      //
    };

    $scope.checkQuestions = function (rdata, val) {
      MyService.ConsoleLog("rdata :", rdata);
      if (rdata) {
        return rdata.filter(
          function (rdata) {
            // MyService.ConsoleLog(rdata.question + "==" + val);
            if (rdata.questionId == val)
              return rdata
          }
        );
      } else {
        return rdata = "";
      }
    }
    $scope.skipQuestion_for_skipansweredQues = function () {
      //MyService.ConsoleLog("skipQuestion: ", $scope.flagSkipAnsweredQuestion);
      var skip = function () {
        var tempIndex = $scope.currentIndex + 1;
        if ($scope.flagSkipAnsweredQuestion && tempIndex < $scope.questions.length && $scope.questions[tempIndex].my_answer) {
          $scope.currentIndex++;
          skip(); //call recursive function to move to next question
          return;
        }

        if (tempIndex < $scope.questions.length) {
          $scope.initializeVariables();
          $scope.currentIndex++;
          if ($routeParams.categoryId && $routeParams.categoryId.indexOf("popular:") == 0) {
            //we are showing questions of most popular section
            $scope.getCategory({
              id: $scope.questions[$scope.currentIndex].categories.cid
            });
          }
        }
        //MyService.ConsoleLog("tempIndex = ", tempIndex, "$scope.questions.length ",$scope.questions.length);
        if (tempIndex == $scope.questions.length) {
          //MyService.ConsoleLog("end of questions switch background");
          var tempBackIdx = $scope.currBackgroundIndex + 1;
          if (tempBackIdx < $scope.traverseBackgrounds.length) {
            $scope.currBackgroundIndex++;
            $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
            MyService.ConsoleLog("one >>>>>>>>>>> Six");
          } else {
            //MyService.ConsoleLog("* End of background *");
            $location.path('/questionSubcategories/' + $routeParams.categoryId);
          }
        }

        $timeout(function () {
          $location.hash('DisplayQ');
          $anchorScroll();
        }, 100);
      };

      if ($scope.answer != null) {
        var show_answer_modal = true;
        try {
          var my_answer = $scope.questions[$scope.currentIndex]["my_answer"];
          if (my_answer.importance == $scope.importance && my_answer.answer == $scope.answer && my_answer.comment == $scope.comment)
            show_answer_modal = false;

        } catch (e) {
          //MyService.ConsoleLog("Exceptoin : ", e);
        }
        //MyService.ConsoleLog("show_answer_modal: ", show_answer_modal);
        if (show_answer_modal) {
          var message = 'You just hit the SKIP button.  Are you sure you want to skip this one, or would you rather Submit your answer?';
          var modal = ngDialog.openConfirm({
            template: '<p>' + message + '</p>\
                            <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Skip</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Submit</button>\
                            </div>',
            plain: true,
            closeByDocument: false
          });

          modal.then(function fullfilled(data) {
            //submit answer
            $scope.submitAnswer();
          }, function rejected(data) {
            //skip the answer
            skip();
          });
        } else {
          skip();
        }
      } else {
        skip();
      }
    };
    $scope.prevQuestion_for_skipansweredQues = function () {
      //MyService.ConsoleLog("** prevQuestion **", $scope.currentIndex, "currBackgroundIndex: ", $scope.currBackgroundIndex);
      if ($scope.currentIndex > 0) {
        //MyService.ConsoleLog("$scope.currentIndex: ", $scope.currentIndex);
        // $scope.currentIndex--;
        var tempIndex = $scope.currentIndex - 1;
        //MyService.ConsoleLog("tempIndex: ", tempIndex);
        if ($scope.flagSkipAnsweredQuestion && tempIndex > 0 && $scope.questions[tempIndex].my_answer) {
          //MyService.ConsoleLog("Inside if");
          $scope.currentIndex--;
          $scope.prevQuestion(); //call recursive function to move to next question
          return;
        } else {
          //MyService.ConsoleLog("Inside else");
          $scope.currentIndex--;
          if ($scope.currentIndex == 0 && $scope.questions[tempIndex].my_answer && $scope.flagSkipAnsweredQuestion)
            $scope.prevQuestion();
        }

      } else if ($scope.currentIndex == 0) {
        if ($scope.currBackgroundIndex > 0) {
          $scope.currBackgroundIndex--;
          $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
          MyService.ConsoleLog("seven >>>>>>>>>>>");
        }
      }
    };

    $scope.skipQuestion = function () {
      var skip = function () {
        var tempIndex = $scope.currentIndex + 1;
        MyService.ConsoleLog("MyLog >>", tempIndex);
        if (tempIndex < $scope.questions.length) {
          // alert('inside');
          $scope.initializeVariables();
          $scope.currentIndex++;
          MyService.ConsoleLog("cat", $routeParams.categoryId);

          if ($routeParams.categoryId && $routeParams.categoryId.indexOf("popular:") == 0) {
            //we are showing questions of most popular section
            MyService.ConsoleLog("$routeParams.categoryId", $routeParams.categoryId);

            $scope.getCategory({
              id: $scope.questions[$scope.currentIndex].categories.cid
            });
          }
        }
        MyService.ConsoleLog("tempIndex => ", tempIndex + "$scope.questions.length " + $scope.questions.length);
        if (!$scope.userId) {
          $scope.chkAnsQues = $scope.checkAnswerQuestions($scope.questions);
          MyService.ConsoleLog("chkAnsQues", $scope.chkAnsQues);
          if ($scope.chkAnsQues && $scope.chkAnsQues.length > 0 && $scope.chkAnsQues.length != $scope.questions.length) {
            $scope.saveForLater = true;
          }
        }
        if (tempIndex == $scope.questions.length) {
          MyService.ConsoleLog("end of questions switch background");
          var tempBackIdx = $scope.currBackgroundIndex + 1;
          if (tempBackIdx < $scope.traverseBackgrounds.length) {
            MyService.ConsoleLog("$scope.traverseBackgrounds >>", $scope.traverseBackgrounds);
            MyService.ConsoleLog("$scope.traverseBackgrounds >>", $scope.traverseBackgrounds[1].title);

            // if ($scope.traverseBackgrounds[1].title == 'General') {
            //   MyService.ConsoleLog("IF");
            //   var y = 1;
            //   $scope.currBackgroundIndex = ++y;
            //   MyService.ConsoleLog("IFFFFFFFFFFF >>", $scope.currBackgroundIndex);
            // } else {
            //   MyService.ConsoleLog("ELSE");
            $scope.currBackgroundIndex++;

            // }

            MyService.ConsoleLog("$scope.$scope.currBackgroundIndex>>", $scope.currBackgroundIndex);

            $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
            MyService.ConsoleLog("$scope.category third", $scope.category);
          } else {
            MyService.ConsoleLog("Yogesh");
            $scope.chkAnsQues = $scope.checkAnswerQuestions($scope.questionsData);
            if ($scope.questionsData.length == $scope.chkAnsQues.length && $scope.saveForLater) {
              var catId, selCat_id;
              catId = window.localStorage.getItem('cat_id');
              selCat_id = window.localStorage.getItem('selCat_id');
              var tempLink = $location.absUrl().split("#!");
              var quizLinks = tempLink[0] + "#!/question-background/" + catId + "/" + selCat_id;
              MyService.updateRemainingQuiz({
                saveLink: quizLinks,
                userId: $scope.userId,
                quizName: window.localStorage.getItem('fbName')
              }).then(function (APIResponse) {
                MyService.ConsoleLog("APIResponse", APIResponse);
              }, function (err) {
                console.log("Error", err);
              });
            }
            $scope.fbwallDlg = ngDialog.open({
              template: 'nextQuestionOptions',
              scope: $scope
            });
            // $location.path('/questionSubcategories/' + $routeParams.categoryId);
          }
        } else if ($scope.questions.length == 0) {

          var tempBackIdx = $scope.currBackgroundIndex + 1;
          if (tempBackIdx < $scope.traverseBackgrounds.length) {
            MyService.ConsoleLog("$scope.traverseBackgrounds >>", $scope.traverseBackgrounds);
            MyService.ConsoleLog("$scope.traverseBackgrounds >>", $scope.traverseBackgrounds[1].title);

            // if ($scope.traverseBackgrounds[1].title == 'General') {
            //   MyService.ConsoleLog("IF");
            //   var y = 1;
            //   $scope.currBackgroundIndex = ++y;
            //   MyService.ConsoleLog("IFFFFFFFFFFF >>", $scope.currBackgroundIndex);
            // } else {
            //   MyService.ConsoleLog("ELSE");
            $scope.currBackgroundIndex++;

            // }

            MyService.ConsoleLog("$scope.$scope.currBackgroundIndex>>", $scope.currBackgroundIndex);

            $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
            MyService.ConsoleLog("$scope.category fourth", $scope.category);
          } else {
            MyService.ConsoleLog("* End of background *");
            $location.path('/questionSubcategories/' + $routeParams.categoryId);
          }

        }

        $timeout(function () {
          $location.hash('DisplayQ');
          $anchorScroll();
        }, 100);
      };
      MyService.ConsoleLog("$scope.answer", $scope.answer);
      if ($scope.answer != null) {
        var show_answer_modal = true;
        try {
          var my_answer = $scope.questions[$scope.currentIndex]["my_answer"];

          /*for (var key in my_answer) {
            if(my_answer[])
          }*/
          if (my_answer.importance == $scope.importance && my_answer.answer == $scope.answer && my_answer.comment == $scope.comment)
            show_answer_modal = false;

        } catch (e) {
          //MyService.ConsoleLog("Exceptoin : ", e);
        }
        //MyService.ConsoleLog("show_answer_modal: ", show_answer_modal);
        if (show_answer_modal) {
          var message = 'You just hit the SKIP button.  Are you sure you want to skip this one, or would you rather Submit your answer?';
          var modal = ngDialog.openConfirm({
            template: '<p>' + message + '</p>\
                            <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Skip</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Submit</button>\
                            </div>',
            plain: true,
            closeByDocument: false
          });

          modal.then(function fullfilled(data) {
            //submit answer
            $scope.submitAnswer();
          }, function rejected(data) {
            //skip the answer
            skip();
          });
        } else {
          skip();
        }
      } else {
        skip();
        // $scope.initializeVariables();
      }
    };
    $scope.prevQuestion = function () {
      //MyService.ConsoleLog("** prevQuestion **");

      if ($scope.currentIndex > 0) {
        $scope.currentIndex--;
        $timeout(function () {
          $location.hash('DisplayQ');
          $anchorScroll();
        }, 100);
      } else if ($scope.currentIndex == 0) {
        if ($scope.currBackgroundIndex > 0) {
          $scope.currBackgroundIndex--;
          MyService.ConsoleLog("eight >>>>>>>>>>>");
          $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
        }
      }
    };

    $scope.compareChanged = function (compare_with) {
      //MyService.ConsoleLog("compare_with :", compare_with);
      var catid = $routeParams.categoryId;
      if ($routeParams.categoryId && $routeParams.categoryId.indexOf("popular:") == 0) {
        var catid = $routeParams.categoryId.split("popular:")[1];
      }

      $location.path('/compare-select/' + compare_with);
    };

    var getCompareAnswersCanceler = $q.defer();

    function getCompareAnswers(params) {
      if (!params) return;
      getCompareAnswersCanceler.resolve();
      params.timeout = getCompareAnswersCanceler.promise;
      $scope.questions = [];
      $scope.status.questions = 1;
      var request = apiCall.apiCall('GET', '/answers/compare', params);
      $http(
        request
      ).then(function successCallback(response) {
        //MyService.ConsoleLog("Got categories: ",response);
        if (response.data.success) {
          $scope.status.questions = 2;
          angular.forEach(response.data.data, function (val, key) {
            if (val.answers && val.answers.length != $rootScope.selectedCompareUsers.length) {
              var check_author_exist = function (u) {
                var len = val.answers.length;
                for (var i = 0; i < len; i++) {
                  if (val.answers[i].author._id == u._id) {
                    return true;
                  }
                }
                return false;
              };

              angular.forEach($rootScope.selectedCompareUsers, function (u, i) {
                if (!check_author_exist(u)) {
                  response.data.data[key].answers.push({
                    author: u
                  });
                }
              });

            } else if (!val.answers) {
              response.data.data[key].answers = [];

              angular.forEach($rootScope.selectedCompareUsers, function (u, i) {
                response.data.data[key].answers.push({
                  author: u
                });
              });

            }
          });

          $scope.questions = response.data.data;
          // $location.path("question-compare/"+$routeParams.category_id+"/"+null);
        } else {
          $scope.status.questions = 3;
          //MyService.ConsoleLog("Something went wrong: ", response.data);
        }
      }, function errorCallBack(response) {
        $scope.status.questions = 3;
        //MyService.ConsoleLog("Error: ", response);
      });
    };

    $scope.initPageData = function () {
      var current_url = $location.url();
      //MyService.ConsoleLog("$location.url: ", current_url);

      if (current_url.indexOf("question-compare") > -1) {
        $scope.state = "question-compare";
        if ($routeParams.categoryId == 'all') {
          var param = {
            id: $routeParams.parentId,
            questions_counter: 1
          };
          getLevelCategory(param);
        } // traverse all questions
        else {
          //MyService.ConsoleLog("** question-compare **");
          //MyService.ConsoleLog("compareAnswerList: ", $rootScope.compareAnswerList);
          $scope.questions = $rootScope.compareAnswerList;
          $scope.getCategory({
            id: $routeParams.categoryId
          });
        }
      } else if (current_url.indexOf("question-tagged") > -1) {
        $scope.state = "question-tagged";
        getQuestions({
          "tagged_to": $routeParams.user_id
        });
      } else if (current_url.indexOf("question-background") > -1) {
        $scope.state = "question-background";
        var param = {
          id: $routeParams.categoryId,
          questions_counter: 1
        };
        getLevelCategory(param);
      } else if (current_url.indexOf("question-search") > -1) {
        $scope.state = "question-background";
        var param = {
          keyword: 'test',
        };
        getQuestions(param);
      } else {
        $scope.state = "question";
        if ($routeParams.categoryId && $routeParams.categoryId.indexOf("popular:") == 0) {
          // getPopularQuestions();
          var categoryId = $routeParams.categoryId.split("popular:")[1];
          $scope.getPopularCategories({
            parentId: categoryId
          })
        } else {
          // getQuestions({categoryId: $routeParams.categoryId});
          $scope.getCategory({
            id: $routeParams.categoryId
          });
        }
      }
    };
    $scope.initPageData();
    $scope.skipAnswerChagne = function () {
      MyService.ConsoleLog("$scope.category._id ", $scope.category._id);
      $scope.currentIndex = 0;
      // alert('nn');
      // $scope.initPageData();
      getQuestions({
        categoryId: $scope.category._id
      });
    };


    $scope.checkIfExists = function (val) {
      // console.log("questions <><><>", $scope.questions);
      // MyService.ConsoleLog("Val > ", val);
      var obj = $scope.questions[$scope.currentIndex];
      // MyService.ConsoleLog("checking For calling >> ");
      if (obj) {
        var data = obj.my_answer;
        // console.log("data <>", data);
        if (data) {
          // MyService.ConsoleLog("checkIfExists data>> ", data.answer + "==" + val);
          if (data.answer == val) {
            // MyService.ConsoleLog("checkIfExists data>> ", data.answer + "==" + val);
            return true;
          }

        }
      }
      return false;
    }

    $scope.subNew = function (valOne) {
      $scope.importance = valOne;
      $scope.submitAnswer();
    };

    $scope.checkImpExists = function (sval) {
      var obj = $scope.questions[$scope.currentIndex];
      // MyService.ConsoleLog(" qobject :", obj);
      if (obj) {
        var data = obj.my_answer;
        // MyService.ConsoleLog("Data", data);
        if (data && data) {
          if (data.importance == sval) {
            // MyService.ConsoleLog("main", $scope.importance);
            // $scope.importance = data.importance;
            // MyService.ConsoleLog("Importance data>> ", sval + " AND ++++++++ " + data.importance);
            return true;
          }
        }
      }
      // MyService.ConsoleLog("false return");
      return false;
    }

    // $scope.matchQuestion = function() {
    //   // ngDialog.open({
    //   //   template: 'app/popups/matchQuestion.html'
    //   //   // className: 'ngdialog-theme-default'
    //   // });

    // }

    $scope.saveQuizForLater = function () {

      window.localStorage.setItem('showSavePopUp', true);
      var catId, selCat_id;
      catId = window.localStorage.getItem('cat_id');
      selCat_id = window.localStorage.getItem('selCat_id');
      var tempLink = $location.absUrl().split("#!");
      var quizLinks = tempLink[0] + "#!/question-background/" + catId + "/" + selCat_id;
      MyService.ConsoleLog("this is new", quizLinks);
      if ($scope.userId) {
        MyService.saveForLaterQuiz({
          saveLink: quizLinks,
          userId: $scope.userId,
          quizName: window.localStorage.getItem('fbName')
        }).then(function (APIResponse) {
          // MyService.ConsoleLog("APIResponse", APIResponse);
          $location.path('/snapshot');
        }, function (err) {
          MyService.ConsoleLog("Error", err);
        });
      } else {
        MyService.ConsoleLog("inside me");
        var quizLinkData = {
          saveLink: quizLinks,
          userId: $scope.userId,
          quizName: window.localStorage.getItem('fbName')
        };
        window.localStorage.setItem('quizLinkData', JSON.stringify(quizLinkData));
        $location.path('/fiveSaveUser');
      }
    };


    $scope.$watch('category', function (newValue, oldValue) {
      var current_url = $location.url();
      MyService.ConsoleLog("oldValue: ", oldValue);
      MyService.ConsoleLog("newValue: ", newValue);
      if (oldValue) {
        window.localStorage.removeItem('fbImg');
        window.localStorage.setItem('fbImg', newValue.fbImage);
        window.localStorage.setItem('fbName', oldValue.title);

      }
      $rootScope.OldCatforFB = oldValue;
      if (current_url.indexOf("question-tagged") > -1)
        return; //for tagged questions don't again fetch questions

      if (newValue) {
        //MyService.ConsoleLog("oldValue: ", oldValue);
        //MyService.ConsoleLog("newValue: ", newValue);
        if (oldValue && oldValue._id == newValue._id) return;

        //MyService.ConsoleLog("scrollTop");
        $("html, body").animate({
          scrollTop: 0
        }, "slow");
        $scope.currentIndex = 0;

        if (current_url.indexOf("question-compare") > -1) {
          //MyService.ConsoleLog("** getCompareAnswers **");

          var temp_uids = [];
          angular.forEach($rootScope.selectedCompareUsers, function (val, key) {
            temp_uids.push(val._id);
          });

          getCompareAnswers({
            "categoryIds": newValue._id,
            "userIds": temp_uids.join(",")
          }); //"compare_with": $routeParams.user_type,
        } else {
          // alert('yo');
          // getQuestions({
          //   categoryId: $routeParams.selectedCatId
          // });
          getQuestions({
            categoryId: newValue._id
          });
        }
      }
    });

    $scope.$watch('questions', function (newValue, oldValue) {
      try {
        // MyService.ConsoleLog("Current question: ", $scope.questions[$scope.currentIndex]);
        var tempCate = $scope.questions[$scope.currentIndex].categories;
        if ($scope.questions[$scope.currentIndex] && $scope.questions[$scope.currentIndex].my_answer) {
          if ($scope.questions[$scope.currentIndex].my_answer.comment) {
            $scope.comment = $scope.questions[$scope.currentIndex].my_answer.comment;
          }

        }
        if (angular.isArray(tempCate)) {
          $scope.getCategory({
            id: tempCate[0].cid
          });
        } else {
          $scope.getCategory({
            id: tempCate.cid
          });
        }
        MyService.ConsoleLog("one");
        $scope.initMyAnswer();
      } catch (e) {
        //MyService.ConsoleLog("questions Index Change Ex: ", e)
      }
    });

    $scope.$watch('currentIndex', function (newValue, oldValue) {
      try {
        // MyService.ConsoleLog("test", tes);
        MyService.ConsoleLog("$scope.currentIndex", $scope.currentIndex);
        MyService.ConsoleLog("$scope.questions.length", $scope.questions.length);
        // MyService.ConsoleLog("Current currentIndex: ", $scope.questions[$scope.currentIndex]);
        $scope.chkAnsQues = $scope.checkAnswerQuestions($scope.questionsData);
        if (!$scope.saveForLater && $scope.chkAnsQues && $scope.chkAnsQues.length > 0 && $scope.chkAnsQues.length != $scope.questionsData.length) {
          $scope.saveForLater = true;
        }
        var tempCate = $scope.questions[$scope.currentIndex].categories;
        MyService.ConsoleLog("first", tempCate);
        if (angular.isArray(tempCate)) {
          $scope.getCategory({
            id: tempCate[0].cid
          });
        } else {
          $scope.getCategory({
            id: tempCate.cid
          });
        }
        // MyService.ConsoleLog("two");

        $scope.initMyAnswer();
      } catch (e) {
        //MyService.ConsoleLog("Current Index Change Ex: ", e)
      }
    });




    // if (window.localStorage.getItem("quesData")) {
    //   $scope.questionsData = JSON.parse(window.localStorage.getItem("quesData"));
    //   $scope.queIds = $scope.questionsData.map(function (itm) {
    //     if (itm.questionId) {
    //       return itm.questionId;
    //     } else {
    //       // console.log("itm", itm);
    //       return itm._id;
    //     }
    //   });
    //   // MyService.ConsoleLog("  $scope.queIds", $scope.queIds);

    // }

    $scope.AllAnsweredQuestions = [];
    $scope.getAllAnsweredQuestions = function (userId) {
      MyService.getAllAnsQuesWithIds({
        "authorId": tokenService.getUserId(),
        "ques": JSON.stringify($scope.queIds)
      }).then(function (payload) {
        MyService.ConsoleLog("getAllAnsweredQuestions >> ", payload);
        if (payload.data.success) {
          $scope.AllAnsweredQuestions = payload.data.data;
          $scope.allQuestions = $scope.AllAnsweredQuestions;
          MyService.ConsoleLog("$scope.allQuestions", $scope.allQuestions);
          var tmpS = $scope.allQuestions.filter(function (itms, ind) {
            if (itms && itms.my_answer) {
              if (itms.my_answer.show == 'Y') {
                $scope.switchStatus[ind] = true;
              } else {
                $scope.switchStatus[ind] = false;
              }
            }
          });
          $scope.chooseQuestions();
          MyService.ConsoleLog("$scope.switchStatus", $scope.switchStatus);
          if ($scope.allQuestions.length == 0) {
            growl.error("There are no questions to display. Please go through all questions first.")
          }

        }
      }, function (errpayload) {
        MyService.ConsoleLog("getAllAnsweredQuestions errpayload >> ", errpayload);
      });
    };




    /**
     * Next
     */

    $scope.next = function () {
      $scope.showHidePop.close();
      if ($scope.userId && $scope.userId != '') {
        MyService.ConsoleLog("yes");
        MyService.ConsoleLog("catId", window.localStorage.getItem('cat_id'));
        var catId, selCat_id;
        catId = window.localStorage.getItem('cat_id');
        selCat_id = window.localStorage.getItem('selCat_id');
        MyService.ConsoleLog("selCat_id", window.localStorage.getItem('selCat_id'));
        var tempLink = $location.absUrl().split("#!");
        $scope.shareLink = tempLink[0] + "#!/exploreQuiz/" + catId + "/" + selCat_id + "/" + $scope.userId;
        MyService.ConsoleLog("here we go with link", $scope.shareLink);
        var modalUrl = ngDialog.openConfirm({
          template: 'exporeQuizLink',
          scope: $scope,
          width: "60%"
        });

        modalUrl.then(
          function fullfilled(data) {
            //MyService.ConsoleLog("fullfilled: ", data);
            if (data == 1) {
              MyService.ConsoleLog("one");
            } else {
              // console.log('two :');
            }
          },
          function rejected(data) {
            $scope.fbwallDlg = ngDialog.open({
              template: 'nextQuestionOptions',
              scope: $scope
            });
          }
        );
      }
    };

    /**
     * Cancel
     */

    $scope.cancel = function () {
      $scope.showHidePop.close();
      $scope.fbwallDlg = ngDialog.open({
        template: 'nextQuestionOptions',
        scope: $scope
      });
    };




  }])

'use strict';
angular
  .module('myApp.questionAnsweredBy', ['ngRoute'])
  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/question-answered-by/:user_id/:voteCandidateId?/:type?/:name?', {
        //pass user_id = me to see questions tagged to self
        templateUrl: 'app/questionAnsweredBy/questionAnsweredBy.html',
        controller: 'questionAnsByCtrl',
      });
    },
  ])
  .controller('questionAnsByCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    '$routeParams',
    '$q',
    'ngDialog',
    '$rootScope',
    'growl',
    'MyService',
    '$anchorScroll',
    '$timeout',
    '$cookies',
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $q,
      ngDialog,
      $rootScope,
      growl,
      MyService,
      $anchorScroll,
      $timeout,
      $cookies
    ) {
      MyService.ConsoleLog('** questionCtrl ** :', $routeParams);
      $scope.routeId = $routeParams.user_id;
      MyService.ConsoleLog('** $scope.routeId ** :', $scope.routeId);
      // $rootScope.tempQuestions = '';
      $scope.isShowVotesmart = false;
      $scope.showLoader = false;
      // $cookies.remove('tmpElectionData');
      $scope.ques = {
        searchQuestionKeyword: '',
      };
      $rootScope.welcome = false;
      $scope.traverseBackgrounds = [];
      $scope.currBackgroundIndex = 0;
      $('input[type=radio]').attr('disabled', true);
      $scope.politicianName = $routeParams.name;
      MyService.ConsoleLog('  $scope.politicianName :>>>>>>>>>', $scope.politicianName);

      $scope.status = {
        questions: 0, //1= loading, 2 = loaded, 3 = error
        category: 0,
      };
      // window.localStorage.removeItem('tempQues');
      $scope.currentIndex = 0;
      $scope.initializeVariables = function () {
        $scope.importance = null;
        $scope.answer = null;
        $scope.comment = '';
        $scope.reason = '';
      };
      $scope.initializeVariables();
      $scope.checkIfExists = function (val) {
        // console.log("questions <><><>", $scope.questions);
        // MyService.ConsoleLog("Val > ", val);
        var obj = $scope.questions[$scope.currentIndex];
        // MyService.ConsoleLog("checkIfExists >> ", obj);
        if (obj) {
          var data = obj.userAnswer;
          if (data || data[0]) {
            // MyService.ConsoleLog("data", data);
            if (data[0]) {
              // MyService.ConsoleLog('checkIfExists data>> ', data[0].answer + '==' + val);
              // MyService.ConsoleLog('checkIfExists data>> ', data[0]);
              if (data && data[0].comment) {
                $scope.comment = data[0].comment;
              } else {
                $scope.comment = data[0].answer_descriptive;
              }
              if (data[0].answer == 'No') {
                if (val == 5) return true;
              }
              if (data[0].answer == 'Yes') {
                if (val == 2) return true;
              }
              if (data[0].answer == 'Pro-choice') {
                if (val == 2) return true;
              }
              if (data[0].answer == 'Pro-life') {
                if (val == 5) return true;
              }
            } else {
              // MyService.ConsoleLog("checkIfExists data>> ", data[0]);
              $scope.comment = data.comment;
              // $scope.answer = data.answer;
              // if (data.answer == "No") {
              //   if (val == 5)
              //     return true;
              // }
              // if (data.answer == "Yes") {
              //   if (val == 2)
              if (val == data.answer) {
                return true;
              }
              // }
            }
          }
        }
        return false;
      };

      $scope.checkQuestionAnswered = function () {
        // console.log("scope.questions > ", $scope.questions);
        return $scope.questions.filter(function (rdata) {
          //MyService.ConsoleLog(rdata.statePostalCode + "==" + val);
          var data = $scope.checkQuestion(rdata._id);
          if (data && data.length > 0) return rdata;
        });
      };

      /**
       * show pop up with old answers
       */
      $scope.getOldAnswers = function (val) {
        MyService.ConsoleLog('dava', val.oldAnswers);
        $scope.oldAns = val.oldAnswers;
        // $scope.showPopUp.close();
        $scope.showPopUp = ngDialog.open({
          template: 'showOldAnsPopUp',
          closeByNavigation: true,
          scope: $scope,
        });
      };

      $scope.getComapreClass = function (match, i) {
        // MyService.ConsoleLog('match: ', match);
        /*if(match == 100)
          return 'ag-green';
      if(match == 0)
          return 'ag-red';
      if(match > 0 && match <100)
          return 'ag-dg'+i;*/
        if (match == 1) return 'ag-dg1';
        if (match == 2) return 'ag-dg2';
        if (match == 3) return 'ag-dg3';
        if (match == 4) return 'ag-dg4';
        if (match == 5) return 'ag-dg5';
        if (match == 6) return 'ag-dg6';

        return 'ag-dg';
      };

      $scope.checkImpExists = function (val) {
        var obj = $scope.questions[$scope.currentIndex];
        // MyService.ConsoleLog(" qobject :", obj);
        if (obj) {
          var data = obj.userAnswer;

          if (data || data[0]) {
            // MyService.ConsoleLog("Importance data>> ", data[0].Importance);
            if (data[0]) {
              if (data[0].Importance == val) {
                return true;
              }
            } else {
              if (data.importance == val) {
                return true;
              }
            }
          }
        }
        return false;
      };
      $scope.initMyAnswer = function () {
        try {
          if ($scope.questions[$scope.currentIndex].userAnswer) {
            var user_answer = ($scope.importance =
              $scope.questions[$scope.currentIndex].userAnswer[0]);
            $scope.importance = user_answer.importance;
            $scope.answer = user_answer.answer;
            $scope.comment = user_answer.comment;
          } else {
            $scope.initializeVariables();
          }
        } catch (e) {
          $scope.initializeVariables();
          //MyService.ConsoleLog("Exceptoin: ", e)
        }
      };

      $scope.getPoliData = function () {
        MyService.getPoliDetails({
          voteCandidateId: $routeParams.voteCandidateId,
          uId: $scope.routeId
        }).then(function (response) {
          MyService.ConsoleLog("Response", response);
          $scope.eleDate = response.electionDate;
          MyService.ConsoleLog("$scope.eleDate", $scope.eleDate);
          var curDate = new Date();
          if ($scope.eleDate >= curDate.toISOString().split('T')[0]) {
            $cookies.put('electionDate', $scope.eleDate);
          }
        }, function (err) {
          MyService.ConsoleLog("Error", err);
        });
      };

      /**
       * Get Questions of questions of votesmart
       */
      $scope.getVotesmartData = function (qId, voteCanId) {
        $scope.showLoader = true;
        MyService.getVotesmartData({
          qId: qId,
          voteCandidateId: voteCanId
        }).then(function (response) {
          MyService.ConsoleLog("response", response);
          $scope.voteData = response.data.data;
          $scope.showLoader = false;
        }, function (err) {
          MyService.ConsoleLog("Error", err);
        });
      };

      /**
       * End of
       */
      var getQuestionsCanceler = $q.defer();

      function getQuestions(params) {
        // alert('cll');
        // MyService.ConsoleLog('params', params);
        getQuestionsCanceler.resolve();
        $scope.status.questions = 1;
        params.timeout = getQuestionsCanceler.promise;
        //MyService.ConsoleLog("questionAnsByCtrl** /questions/list: ", params);
        $scope.questions = [];
        var request = apiCall.apiCall('GET', '/questions/list', params);
        $http(request).then(
          function successCallback(response) {
            // MyService.ConsoleLog("questionAnsByCtrl Got categories: ", response);
            if (response.data.success) {
              $scope.status.questions = 2;
              $scope.questions = response.data.data;
              $scope.questions.sort(function (a, b) {
                var x, y;
                x = a.categories[0].viewOrder;
                y = b.categories[0].viewOrder;

                if (x < y) {
                  return -1;
                }
                if (x > y) {
                  return 1;
                }
                return 0;
              });
              MyService.ConsoleLog("check now", $scope.questions[0]);
              $scope.isShowVotesmart = $scope.questions[0].isVotesmart;
              if ($scope.isShowVotesmart) {
                var queId, voCanId;
                queId = $scope.questions[0].userAnswer[0].question_id;
                voCanId = $scope.questions[0].userAnswer[0].candidate_id;
                $scope.getVotesmartData(queId, voCanId);
              }

              MyService.ConsoleLog("one more", $scope.isShowVotesmart);
              // window.localStorage.setItem('tempQues', JSON.stringify(response.data.data));
              // $rootScope.tempQuestions = response.data.data;
              // MyService.ConsoleLog('one $rootScope.tempQuestions', $rootScope.tempQuestions);
              MyService.ConsoleLog('total questions: ', $scope.questions);
              // MyService.ConsoleLog("total questions: ", $scope.questions[0].userAnswer[0].answer);
              $scope.getPoliData();
            } else {
              $scope.status.questions = 3;
              if (typeof response.data.error == 'string') growl.error(response.data.error);
              else growl.error('Something went wrong');
            }
          },
          function errorCallBack(response) {
            $scope.status.questions = 3;
            //MyService.ConsoleLog("Error: ", response);
          }
        );
      }

      // $scope.searchQuestion = function(searchKey) {
      //   // alert('call');
      //   var temp = JSON.parse(window.localStorage.getItem('tempQues'));

      //   // MyService.ConsoleLog('temp', temp);
      //   if (temp.length > 0) {
      //     $scope.questions = temp;
      //   }
      //   // var searchKey = new RegExp(val, 'i');
      //   // MyService.ConsoleLog('searchKey', searchKey);
      //   const res = $scope.questions.filter(function(obj) {
      //     // MyService.ConsoleLog('obj', obj.content.indexOf(searchKey));
      //     if (obj.content.indexOf(searchKey) > -1) {
      //       return obj.content.indexOf(searchKey);
      //     }
      //   });
      //   if (res && res.length > 0) {
      //     $scope.questions.length = 0;
      //     $scope.questions = res;
      //   } else {
      //     growl.error('Records not found for this search');
      //   }
      //   // MyService.ConsoleLog('res', res);
      //   $scope.ques.searchQuestionKeyword = '';
      // };

      // $scope.getUserProfile = function(params) {
      //   MyService.getProfile($routeParams.user_id).then(function(userData) {
      //     $scope.userData = userData;
      //     //MyService.ConsoleLog("userData: ", $scope.userData);
      //   }, function(err) {
      //     growl.error("Something went wrong while fetching user info.");
      //   });
      // }

      var getCategoryCanceler = $q.defer();
      var prevFetchedCategoryId = null;

      $scope.getCategory = function (params) {
        if (prevFetchedCategoryId != params.id) {
          //MyService.ConsoleLog("scrollTop");

          $('html, body').animate({
              scrollTop: 0,
            },
            'slow'
          );

          getCategoryCanceler.resolve();
          $scope.status.category = 1;
          params.timeout = getCategoryCanceler.promise;
          var request = apiCall.apiCall('GET', '/categories/list', params);
          $http(request).then(
            function successCallback(response) {
              //MyService.ConsoleLog("Got categories: ",response);
              if (response.data.success) {
                $scope.category = response.data.data;
                //MyService.ConsoleLog("category data: ", $scope.category);
                prevFetchedCategoryId = $scope.category._id;
                $scope.status.category = 2;
              } else {
                //MyService.ConsoleLog("Something went wrong: ", response.data);
                $scope.status.category = 3;
              }
            },
            function errorCallBack(response) {
              //MyService.ConsoleLog("Error: ", response);
              $scope.status.category = 3;
            }
          );
        }
      };

      $scope.gotoPolitician = function () {
        $location.path('/compare-select/politician');
      };

      $scope.postAnswer = function (postData) {
        //MyService.ConsoleLog("postData: ", postData);
        try {
          var my_answer = $scope.questions[$scope.currentIndex].my_answer;
          if (
            my_answer.importance != $scope.importance ||
            my_answer.answer != $scope.answer ||
            my_answer.comment != $scope.comment
          ) {
            //MyService.ConsoleLog("Answer changed");
            postData.id = my_answer._id;
            postData.reason = $scope.reason;
          } else {
            //MyService.ConsoleLog("Answer not changed");
            return; //don't do anything
          }
        } catch (e) {
          //MyService.ConsoleLog("Exceptoin: ", e);
        }

        MyService.postAnswer(postData).then(
          function (response) {
            if (response.data.success) {
              try {
                if (postData.id) {
                  $scope.questions[$scope.currentIndex]['my_answer'] = {
                    _id: postData.id,
                    created: new Date(),
                    comment: postData.comment,
                    answer: postData.answer,
                    importance: postData.importance,
                  };
                } else {
                  $scope.questions[$scope.currentIndex]['my_answer'] = {
                    _id: response.data.data._id,
                    created: response.data.data.created,
                    comment: response.data.data.comment,
                    answer: response.data.data.answer,
                    importance: response.data.data.importance,
                  };
                }
              } catch (e) {
                //MyService.ConsoleLog("Exceptoin: ", e);
              }
              if (postData.id) {
                growl.success('Answer updated successfully', {
                  ttl: 800,
                });
              } else {
                growl.success('Answered successfully', {
                  ttl: 800,
                });
              }
              $scope.initializeVariables();
              $scope.skipQuestion();
            } else {
              growl.error('Error: ' + response.data.error);
            }
          },
          function (err) {
            growl.error('Something went wrong.');
          }
        );
      };

      $scope.skipQuestion = function () {
        /*
      $timeout(function() {
        $location.hash('DisplayQ');
        $anchorScroll();
      }, 1500);
      */
        var skip = function () {
          var tempIndex = $scope.currentIndex + 1;
          if (tempIndex < $scope.questions.length) {
            $scope.initializeVariables();
            $scope.currentIndex++;
            $scope.isShowVotesmart = $scope.questions[$scope.currentIndex].isVotesmart;
            var qId, vCanId;
            if ($scope.isShowVotesmart) {
              qId = $scope.questions[$scope.currentIndex].userAnswer[0].question_id;
              vCanId = $scope.questions[$scope.currentIndex].userAnswer[0].candidate_id;
              $scope.getVotesmartData(qId, vCanId);
            }
            MyService.ConsoleLog("<<<<<<<<  $scope.isShowVotesmart >>>>>>>>>>", $scope.isShowVotesmart);
            if ($routeParams.categoryId && $routeParams.categoryId.indexOf('popular:') == 0) {
              //we are showing questions of most popular section
              $scope.getCategory({
                id: $scope.questions[$scope.currentIndex].categories.cid,
              });
            }
          }
          //MyService.ConsoleLog("tempIndex = ", tempIndex, "$scope.questions.length ",$scope.questions.length);
          if (tempIndex == $scope.questions.length) {
            //MyService.ConsoleLog("end of questions switch background");
            var tempBackIdx = $scope.currBackgroundIndex + 1;
            if (tempBackIdx < $scope.traverseBackgrounds.length) {
              $scope.currBackgroundIndex++;
              $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
            } else {
              //MyService.ConsoleLog("* End of background *");
            }
          }
          // console.log("Display Q :", $("#DisplayQ").offset().top);
          $('html, body').animate({
              scrollTop: $('#DisplayQ').offset().top - 150,
            },
            'slow'
          );
        };

        skip();
      };

      $scope.prevQuestion = function () {
        //MyService.ConsoleLog("** prevQuestion **");
        /*
      $timeout(function() {
        $location.hash('DisplayQ');
        $anchorScroll();
      }, 1500);
      */
        if ($scope.currentIndex > 0) {
          $scope.currentIndex--;
          $scope.isShowVotesmart = $scope.questions[$scope.currentIndex].isVotesmart;
          if ($scope.isShowVotesmart) {
            var quId = $scope.questions[$scope.currentIndex].userAnswer[0].question_id;
            var CanId = $scope.questions[$scope.currentIndex].userAnswer[0].candidate_id;
            $scope.getVotesmartData(quId, CanId);
          }
        } else if ($scope.currentIndex == 0) {
          if ($scope.currBackgroundIndex > 0) {
            $scope.currBackgroundIndex--;
            $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
          }
        }
      };

      $scope.getInfo = function (val) {
        if (val && val.comment && val.comment != '') {
          $scope.showComment = val.comment;
          $scope.showPopUp = ngDialog.open({
            template: 'showInfoPopUp',
            closeByNavigation: true,
            scope: $scope,
          });
        }
      };

      /**
       * Show votesmart data
       */
      $scope.showVotesmartAns = function (data) {
        MyService.ConsoleLog("data", data);

        $location.path('/showVotesmartAnsQues/' + data.userAnswer[0].question_id + '/' + data.userAnswer[0].candidate_id);
      };


      var getCompareAnswersCanceler = $q.defer();

      function getCompareAnswers(params) {
        if (!params) return;
        getCompareAnswersCanceler.resolve();
        params.timeout = getCompareAnswersCanceler.promise;

        $scope.questions = [];
        $scope.status.questions = 1;

        var request = apiCall.apiCall('GET', '/answers/compare', params);
        $http(request).then(
          function successCallback(response) {
            //MyService.ConsoleLog("Got categories: ",response);
            if (response.data.success) {
              $scope.status.questions = 2;
              angular.forEach(response.data.data, function (val, key) {
                if (val.answers && val.answers.length != $rootScope.selectedCompareUsers.length) {
                  var check_author_exist = function (u) {
                    var len = val.answers.length;
                    for (var i = 0; i < len; i++) {
                      if (val.answers[i].author._id == u._id) {
                        return true;
                      }
                    }
                    return false;
                  };

                  angular.forEach($rootScope.selectedCompareUsers, function (u, i) {
                    if (!check_author_exist(u)) {
                      response.data.data[key].answers.push({
                        author: u,
                      });
                    }
                  });
                } else if (!val.answers) {
                  response.data.data[key].answers = [];
                  angular.forEach($rootScope.selectedCompareUsers, function (u, i) {
                    response.data.data[key].answers.push({
                      author: u,
                    });
                  });
                }
              });

              $scope.questions = response.data.data;
              // $location.path("question-compare/"+$routeParams.category_id+"/"+null);
            } else {
              $scope.status.questions = 3;
              //MyService.ConsoleLog("Something went wrong: ", response.data);
            }
          },
          function errorCallBack(response) {
            $scope.status.questions = 3;
            //MyService.ConsoleLog("Error: ", response);
          }
        );
      }

      var current_url = $location.url();
      //MyService.ConsoleLog("$location.url: ", current_url);

      $scope.state = 'question-answered-by';
      if ($routeParams.user_id) {
        // getPopularQuestions();
        MyService.ConsoleLog(' type :', $routeParams.type);
        if ($routeParams.type && $routeParams.type == 'politician') {
          MyService.ConsoleLog('welcome to if');

          getQuestions({
            answered_by: $routeParams.user_id,
            voteCandidateId: $routeParams.voteCandidateId,
          });
        } else {
          MyService.ConsoleLog('welcome to Else');

          // $scope.getUserProfile();
          getQuestions({
            answered_by: $routeParams.user_id,
            voteCandidateId: $routeParams.voteCandidateId,
          });
        }
      }

      $scope.$watch('questions', function (newValue, oldValue) {
        //MyService.ConsoleLog("*** questions changed ***");
        try {
          //MyService.ConsoleLog("Current question: ", $scope.questions[$scope.currentIndex]);
          var tempCate = $scope.questions[$scope.currentIndex].categories;
          if (angular.isArray(tempCate)) {
            $scope.getCategory({
              id: tempCate[0].cid,
            });
          } else {
            $scope.getCategory({
              id: tempCate.cid,
            });
          }

          $scope.initMyAnswer();
        } catch (e) {
          //MyService.ConsoleLog("questions Index Change Ex: ", e)
        }
      });
      $scope.$watch('currentIndex', function (newValue, oldValue) {
        //MyService.ConsoleLog("*** currentIndex changed ***");
        try {
          //MyService.ConsoleLog("Current question: ", $scope.questions[$scope.currentIndex]);
          var tempCate = $scope.questions[$scope.currentIndex].categories;
          if (angular.isArray(tempCate)) {
            $scope.getCategory({
              id: tempCate[0].cid,
            });
          } else {
            $scope.getCategory({
              id: tempCate.cid,
            });
          }

          $scope.initMyAnswer();
        } catch (e) {
          //MyService.ConsoleLog("Current Index Change Ex: ", e)
        }
      });
    },
  ]);

'use strict';
angular.module('myApp.question', ['ngRoute', 'ngDialog'])
  .run(['$anchorScroll', function($anchorScroll) {
    $anchorScroll.yOffset = 150; // always scroll by 50 extra pixels
  }])
  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/question/:categoryId', {
      templateUrl: 'app/question/question.html',
      controller: 'questionCtrl'
    });
  }])
  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/question-tagged/:user_id', { //pass user_id = me to see questions tagged to self
      templateUrl: 'app/question/question.html',
      controller: 'questionCtrl'
    });
  }]) 
  .controller('questionCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$q', 'ngDialog', '$rootScope', 'growl', 'MyService', 'tokenService', '$anchorScroll', '$timeout', function($scope, $http, $location, apiCall, $routeParams, $q, ngDialog, $rootScope, growl, MyService, tokenService, $anchorScroll, $timeout) {
    //MyService.ConsoleLog("** questionCtrl ** :", $routeParams);

    MyService.ConsoleLog("** questionCtrl ** :", $scope.politicianName);

    $rootScope.welcome = false;
    $scope.userId = tokenService.getUserId();
    $scope.userRole = tokenService.getUserRole();
    if (tokenService.getUserData()) {
      $scope.userData = JSON.parse(tokenService.getUserData());
    }

    $scope.traverseBackgrounds = [];
    $scope.currBackgroundIndex = 0;
    $scope.status = {
      questions: 0, //1= loading, 2 = loaded, 3 = error
      category: 0
    };
    $scope.flagSkipAnsweredQuestion = true;


    $scope.currentIndex = 0;
    $scope.initializeVariables = function() {
      $scope.importance = null;
      $scope.answer = null;
      $scope.comment = '';
      $scope.reason = '';
    };
    $scope.initializeVariables();

    $scope.initMyAnswer = function() {
      try {
        if ($scope.questions[$scope.currentIndex].my_answer) {
          var my_answer = $scope.importance = $scope.questions[$scope.currentIndex].my_answer;
          $scope.importance = my_answer.importance;
          $scope.answer = my_answer.answer;
          $scope.comment = my_answer.comment;
        } else {
          $scope.initializeVariables();
        }
      } catch (e) {
        $scope.initializeVariables();
        //MyService.ConsoleLog("Exceptoin: ", e)
      }
    };

    $scope.viewOldAnswers = function(old_ans) {
      ngDialog.open({
        template: 'app/popups/view_old_answers.html',
        controller: 'OldAnswerViewerCtrl',
        data: old_ans
      });
    };

    if ($rootScope.userRole == "advocate") {
      var request = apiCall.apiCall('GET', '/user/list', {
        "usertype": "politician"
      });
      $http(
        request
      ).then(function successCallback(response) {
        //MyService.ConsoleLog("Got categories: ",response);
        if (response.data.success) {
          $scope.tagableUsers = response.data.data;
        } else {
          //MyService.ConsoleLog("Something went wrong: ", response.data);
        }
      }, function errorCallBack(response) {
        //MyService.ConsoleLog("Error: ", response);
      });
    }
    $scope.addTags = function(tagUsers) {
      //MyService.ConsoleLog("tagUsers: ", tagUsers);
      //MyService.ConsoleLog("tagUsers: ", $scope.questions[$scope.currentIndex]._id);

      var postData = {
        id: $scope.questions[$scope.currentIndex]._id,
        user_ids: tagUsers.join(",")
      };

      var request = apiCall.apiCall('POST', '/questions/add_tag', postData);
      $http(
        request
      ).then(function successCallback(response) {
        //MyService.ConsoleLog("succss: ", response);
        if (response.data.success) {
          growl.success("Tagged successfully");
        } else {
          if (typeof response.data.error == "string")
            growl.error(response.data.error);
          else
            growl.error("Something went wrong");
        }
      }, function errorCallback(response) {
        growl.error("Something went wrong");
      });
    };

    var getQuestionsCanceler = $q.defer();
    $scope.questions = [];
    $scope.fbwallDlg = "";
    $scope.oldQuestions = [];

    function getMoreQuestions(params) {
      getQuestionsCanceler.resolve();
      $scope.status.questions = 1;
      $scope.questions.length = 0;
      if ($scope.fbwallDlg != "") {
        //MyService.ConsoleLog($scope.fbwallDlg);
        ngDialog.close($scope.fbwallDlg.id);
      }
      params.timeout = getQuestionsCanceler.promise;
      MyService.ConsoleLog("questionCtrl** /questions/list: ", params);
      var request = apiCall.apiCall('GET', '/questions/list', params);

      $http(
        request
      ).then(function successCallback(response) {
        //MyService.ConsoleLog("questionCtrl Got categories: ", response);
        if (response.data.success) {
          $scope.status.questions = 2;
          $scope.initMyAnswer();
          MyService.ConsoleLog("data len: ", response.data.data);
          if ($scope.flagSkipAnsweredQuestion) {
            angular.forEach(response.data.data, function(val, key) {
              if (val.my_answer == null)
                $scope.questions.push(val);
            });
          } else {
            $scope.questions = response.data.data;
          }
          //$scope.oldQuestions = angular.copy($scope.questions);
          //MyService.ConsoleLog("total questions: ", $scope.questions.length);
        } else {
          $scope.status.questions = 3;
          if (typeof response.data.error == "string")
            growl.error(response.data.error);
          else
            growl.error("Something went wrong");
        }
      }, function errorCallBack(response) {
        $scope.status.questions = 3;
        //MyService.ConsoleLog("Error: ", response);
      });
    }
    $scope.retainOptions = "";
    $scope.fb = {
      options: "C"
    };

    $scope.postOnWall = function(message) {
      var body = message;
      var link = 'https://votewise.net/#!/question-background/' + $routeParams.categoryId + '/' + $rootScope.OldCatforFB._id;
      var picture = 'https://votewise.net:8443/resources/education-general-1484943663025.jpg';
      if ($rootScope.OldCatforFB && $rootScope.OldCatforFB.fbImage && $rootScope.OldCatforFB.fbImage != null) {
        picture = "https://votewise.net:8443/resources/" + $rootScope.OldCatforFB.fbImage;
      }

      //MyService.ConsoleLog(picture);
      //var picture = '';
      //MyService.ConsoleLog($rootScope.OldCatforFB);
      var name = 'What makes a good education?';
      if ($rootScope.OldCatforFB && $rootScope.OldCatforFB.fbTitle) {
        name = $rootScope.OldCatforFB.fbTitle;
      }
      var description = 'How do we make our education system better?  Take the quiz to learn more, tell your politicians what they should do, and compare with your friends.';
      if ($rootScope.OldCatforFB && $rootScope.OldCatforFB.fbDescription) {
        description = $rootScope.OldCatforFB.fbDescription;
      }
      FB.api('/me/feed', 'post', {
        message: body,
        link: link,
        picture: picture,
        name: name,
        description: description
      }, function(response) {
        //MyService.ConsoleLog(response);
        $scope.DisplayFPostLoader = false;
        if (!response || response.error) {
          var errmsg = "Facebook is taking too long to respond. Should we try again?"
          var modal = ngDialog.openConfirm({
            template: '<p>' + errmsg + '</p>\
                            <div class="ngdialog-buttons">\
                    <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                    <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Yes</button>\
                </div>',
            plain: true
          });
          modal.then(function fullfilled(tdata) {
            //MyService.ConsoleLog("fullfilled: ", data);
            if (tdata == 1) {
              $scope.postOnWall(message);
            }

          }, function rejected(data) {
            //MyService.ConsoleLog("rejected: ", data);
          });
        } else {

          var msg = "Message is successfully posted on facebook wall. Do you want to continue with Answering questions?";
          var modal = ngDialog.openConfirm({
            template: '<p>' + msg + '</p>\
                            <div class="ngdialog-buttons">\
                                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(2)">NO</button>\
                                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">YES</button>\
                            </div>',
            plain: true
          });
          modal.then(function fullfilled(data) {
            //MyService.ConsoleLog("fullfilled: ", data);
            if (data == 1) {
              getMoreQuestions($scope.retainOptions);
            }
            ngDialog.close();
          }, function rejected(data) {
            //MyService.ConsoleLog("rejected: ", data);
            ngDialog.close();
          });
          // alert('Post ID: ' + response.id);
        }
      });
    }
    $scope.DisplayFPostLoader = false;
    $scope.postFB = function(message) {
      //alert("This needs to be implemented");
      $scope.DisplayFPostLoader = true;
      FB.getLoginStatus(function(response) {
        //MyService.ConsoleLog(response);

        if (response.status == 'unknown') {
          FB.login(function(response) {
            //statusChangeCallback(response, 'login');
            //MyService.ConsoleLog(response);
            MyService.updateFBID({
              "facebookid": response.authResponse.userID
            }).then(function(payload) {
              //MyService.ConsoleLog(payload);
              //MyService.ConsoleLog(payload.data.error);
              if (payload.data.error && payload.data.error == "FBDUPLICATE") {
                $scope.DisplayFPostLoader = false;
                alert("Facebook user doesn't match with your account.");
              } else {
                $scope.postOnWall(message);
              }

            }, function(errpayload) {
              $scope.DisplayFPostLoader = false;

              var errmsg = "Facebook is taking too long to respond. Should we try again?"
              var modal = ngDialog.openConfirm({
                template: '<p>' + errmsg + '</p>\
                            <div class="ngdialog-buttons">\
                    <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                    <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Yes</button>\
                </div>',
                plain: true
              });
              modal.then(function fullfilled(tdata) {
                //MyService.ConsoleLog("fullfilled: ", data);
                if (tdata == 1) {
                  $scope.postOnWall(message);
                }

              }, function rejected(data) {
                //MyService.ConsoleLog("rejected: ", data);
              });

              // alert("Facebook is taking too long to respond. Should we try again?");
            });
          }, {
            scope: 'public_profile,email,publish_actions',
            return_scopes: true
          });
        } else {
          if ($scope.userData && $scope.userData.facebookid) {
            if (response.authResponse.userID == $scope.userData.facebookid) {
              $scope.postOnWall(message);
            } else {
              $scope.DisplayFPostLoader = false;
              alert("Facebook user doesn't match with your account.");
            }
          } else {
            $scope.postOnWall(message);
          }
        }
      });
    }

    $scope.fbFrdDlg = "";
    $scope.FBfreinds = [];
    $scope.FBfreindsFinal = [];
    $scope.DisplayFLoader = false;
    $scope.checkFBFreinds = function() {
      $scope.DisplayFLoader = true;
      FB.login(function(loginData) {
        //MyService.ConsoleLog(loginData);
        FB.api('/me/friends', function(response) {
          //MyService.ConsoleLog(response);
          $scope.FBfreindsFinal.length = 0;
          if (response && response.data) {
            var frdata = response.data;
            $scope.FBfreindsFinal = response.data;
            if (frdata.length > 0) {
              var results = frdata.map(function(frdata) {
                return frdata.id;
              });
              //MyService.ConsoleLog(results);
              var sendfrd = JSON.stringify(results);
              //MyService.ConsoleLog(sendfrd);
              MyService.checkfreindsIfanswered({
                "friends": sendfrd,
                "categoryId": $rootScope.OldCatforFB._id
              }).then(function(payload) {
                //MyService.ConsoleLog("payload:", payload);
                $scope.selection.length = 0;
                var allfriends = payload.data.data;
                $scope.FBfreinds.length = 0;
                //MyService.ConsoleLog("allfriends:::", allfriends);
                $scope.DisplayFLoader = false;
                if (allfriends.length > 0) {
                  //$scope.FBfreinds.length = 0;
                  //MyService.ConsoleLog("inside frdata >> ", frdata);
                  var fresults = $scope.FBfreindsFinal.map(function(frdata) {
                    //MyService.ConsoleLog(frdata.id);
                    //MyService.ConsoleLog(allfriends.indexOf(frdata.id));
                    if (allfriends.indexOf(frdata.id) > -1) {
                      $scope.FBfreinds.push(frdata);
                      return frdata;
                    }
                  });
                  //MyService.ConsoleLog(fresults);
                  //$scope.FBfreinds = fresults;
                  //MyService.ConsoleLog($scope.FBfreindsFinal);
                  if ($scope.fbwallDlg != "") {
                    //MyService.ConsoleLog($scope.fbwallDlg);
                    ngDialog.close($scope.fbwallDlg.id);
                  }
                  $scope.fbFrdDlg = ngDialog.open({
                    template: 'FBFreindList',
                    scope: $scope
                  });
                } else {

                  alert("none of your friends have answered yet. You should write them and ask them to answer");
                }



              }, function(errpayload) {
                $scope.DisplayFLoader = false;
                //MyService.ConsoleLog("errpayload", errpayload);
              })



            } else {
              $scope.DisplayFLoader = false;
              alert("Your freinds not yet joined VoteWise.net. Ask them to join by posting a message on Facebook Wall?");
            }
          } else {
            $scope.DisplayFLoader = false;
            //MyService.ConsoleLog('Something goes wrong', response);
          }
        }, {
          scope: 'user_friends'
        });
      }, {
        scope: 'user_friends',
        auth_type: 'rerequest'
      });
    }

    $scope.selection = [];

    // helper method to get selected fruits
    $scope.selectedFrds = function() {
      return filterFilter($scope.FBfreinds, {
        selected: true
      });
    };

    // watch fruits for changes
    // $scope.$watch('FBfreinds|filter:{selected:true}', function(nv) {
    //     $scope.selection = nv.map(function(FBfreinds) {
    //         return FBfreinds.id;
    //     });
    // }, true);

    $scope.selectedFrd = function(frd) {
      //MyService.ConsoleLog(frd);
      var idx = $scope.selection.indexOf(frd.id);
      if (idx == -1) {
        $scope.selection.push(frd.id);
      } else {
        $scope.selection.splice(idx, 1);
      }
    }


    $scope.displayMatch = function() {
      //alert("This needs to be implemented");
      FB.getLoginStatus(function(response) {
        //MyService.ConsoleLog(response);
        if (response.status == 'unknown') {
          FB.login(function(response) {
            //statusChangeCallback(response, 'login');
            //MyService.ConsoleLog(response);
            MyService.updateFBID({
              "facebookid": response.authResponse.userID
            }).then(function(payload) {
              if (payload.data.error && payload.data.error == "FBDUPLICATE") {
                $scope.DisplayFLoader = false;
                alert("Facebook user doesn't match with your account.");
              } else {
                $scope.checkFBFreinds();
              }

            }, function(errpayload) {
              $scope.DisplayFLoader = false;
              alert("Something went wrong. Please try again later.");
            });
          }, {
            scope: 'public_profile,email,publish_actions',
            return_scopes: true
          });
        } else {
          // if($scope.userData && $scope.userData.facebookid) {
          //     if(response.authResponse.userID==$scope.userData.facebookid ) {
          //         var message = "Here is some message";
          //         $scope.postOnWall(message);
          //     } else {
          //         $scope.DisplayFLoader = false;
          //        alert("Facebook user doesn't match with your account.");
          //     }
          // } else {
          //     $scope.checkFBFreinds();
          // }
          $scope.checkFBFreinds();
        }
      });

    }
    $scope.FBCompareList = [];
    $scope.AnswerArray = [];
    $scope.AnswerArray[1] = "Very Strongly Agree";
    $scope.AnswerArray[2] = "Agree";
    $scope.AnswerArray[3] = "Somewhat Agree";
    $scope.AnswerArray[4] = "Somewhat Disagree";
    $scope.AnswerArray[5] = "Disagree";
    $scope.AnswerArray[6] = "Very Strongly Disgree";
    $scope.AnswerImpArray = [];
    $scope.AnswerImpArray[1] = "Somewhat Important";
    $scope.AnswerImpArray[2] = "Important";
    $scope.AnswerImpArray[3] = "Very Important";
    $scope.Math = window.Math;
    $scope.ComapreWithSelected = function() {
      //MyService.ConsoleLog($scope.selection);
      //MyService.ConsoleLog("ComapreWithSelected");
      //MyService.ConsoleLog($rootScope.OldCatforFB._id);
      //MyService.ConsoleLog($scope.retainOptions);
      if ($scope.selection.length > 0) {
        var frdlist = JSON.stringify($scope.selection);
        MyService.CompareWithFreinds({
          "frds": frdlist,
          "categoryIds": $rootScope.OldCatforFB._id
        }).then(function(payload) {
          //MyService.ConsoleLog(payload);
          $scope.FBCompareList.length = 0;
          if (payload.data.success) {
            //MyService.ConsoleLog(payload.data.data);
            $scope.FBCompareList = payload.data.data.qdata;
            if ($scope.FBCompareList.length > 0) {
              ngDialog.open({
                template: 'FBFreindCompare',
                scope: $scope
              });
              $scope.FBunWeighted = payload.data.data.unweightedMatch;
              $scope.fbcombinedWeight = payload.data.data.fbcombinedWeight;
              $scope.fbmultiplier = payload.data.data.fbmultiplier;
              $scope.fbqlen = payload.data.data.qlen;
            } else {
              alert("Looks like your freinds not yet answered the questions.");
              //MyService.ConsoleLog($scope.FBCompareList);
            }
          } else {
            alert("Something went wrong.");
          }
        }, function(errorpayload) {
          alert("Something went wrong.");
        })
      } else {
        alert("Please select at least one Friend to compare with");
      }
    }

    $scope.allQuestions = [];
    $scope.chooseQuestions = function() {
      //MyService.ConsoleLog($scope.oldQuestions);
      $scope.allQuestions = $scope.oldQuestions;
      if ($scope.allQuestions.length > 0) {
        ngDialog.open({
          template: 'ReviewMyAnswers',
          scope: $scope
        });
      } else {
        alert("There are no questions to display. Please go through all questions first.")
      }
    }
    //$scope.switchStatus = "Show";
    $scope.showloader = false;
    $scope.switchFilters = function(newValue, index, quest) {
      $scope.showloader = true;
      //MyService.ConsoleLog("newValue::", newValue);
      //MyService.ConsoleLog("oldValue::", $scope.switchStatus);
      var setVal = "N";
      if (newValue[index] == true) {
        setVal = "Y";
      }

      var idx = $scope.allQuestions.indexOf(quest);
      //MyService.ConsoleLog("setVal:", setVal);
      MyService.updateAnswers({
        "qid": quest._id,
        "show": setVal,
        "author": quest.author
      }).then(function(payload) {
        //MyService.ConsoleLog("payload : ", payload);
        $scope.showloader = false;
        if (payload.data.success) {
          quest.my_answer.show = setVal;
          $scope.allQuestions[idx] = quest;
          alert("Record updated successfully");
        } else {
          alert("Something went wrong. Contact administrator.");
        }
      }, function(errorpayload) {
        $scope.showloader = false;
        //MyService.ConsoleLog("errorpayload : ", errorpayload);
        alert("Something went wrong. Contact administrator.");
      });
    }


    $scope.NextOptions = function(option) {
      //MyService.ConsoleLog(option);
      switch (option) {
        case "C":
          getMoreQuestions($scope.retainOptions);
          break;
        case "P":
          //$scope.postFB();
          $scope.fbFrdDlg = ngDialog.open({
            template: 'FBComposeMessage',
            scope: $scope
          });
          break;
        case "Q":
          $scope.chooseQuestions();
          break;
        case "M":
          $scope.displayMatch();
          break;
        case "F":
          ngDialog.close($scope.fbwallDlg.id);
          $location.path('/findMatch/');
          break;
        default:
          getMoreQuestions($scope.retainOptions);
          break;
      }

    }

    $scope.ord = {
      "Option": "BW"
    };

    $scope.checkMyOrder = function(frnd) {
      //MyService.ConsoleLog($scope.ord.Option);
      switch ($scope.ord.Option) {
        case "BW":
          return -($scope.fbcombinedWeight[frnd.id] / $scope.fbmultiplier[frnd.id]);
          break;
        case "W":
          return ($scope.fbcombinedWeight[frnd.id] / $scope.fbmultiplier[frnd.id]);
          break;
        case "BS":
          return -($scope.FBunWeighted[frnd.id] / $scope.fbqlen[frnd.id]);
          break;
        case "S":
          return ($scope.FBunWeighted[frnd.id] / $scope.fbqlen[frnd.id]);
          break;
        default:
          return -($scope.fbcombinedWeight[frnd.id] / $scope.fbmultiplier[frnd.id]);
          break;

      }

    }



    function getQuestions(params) {
      MyService.ConsoleLog("getQuestions params");
      MyService.ConsoleLog(params);
      //MyService.ConsoleLog($rootScope.OldCatforFB);
      $scope.oldQuestions = angular.copy($scope.questions);
      $scope.questions.length = 0;
      $scope.currentIndex = 0;
      $scope.retainOptions = params;
      //MyService.ConsoleLog($scope.retainOptions);
      //MyService.ConsoleLog($routeParams.selectedCatId);

      //MyService.ConsoleLog(params.categoryId + "======" + $routeParams.selectedCatId);
      if (params.categoryId != $routeParams.selectedCatId) {
        //MyService.ConsoleLog($scope.retainOptions);
        $scope.fbwallDlg = ngDialog.open({
          template: 'nextQuestionOptions',
          scope: $scope
        });
        //MyService.ConsoleLog($scope.fbwallDlg);
        //getMoreQuestions(params);
      } else {
        // ngDialog.open({
        //     template: 'nextQuestionOptions',
        //     scope: $scope
        // });
        getMoreQuestions(params);
      }
    }

    var getCategoryCanceler = $q.defer();
    var prevFetchedCategoryId = null;

    $scope.getCategory = function(params) {
      try {
        prevFetchedCategoryId = $scope.category._id
      } catch (e) {}

      if (prevFetchedCategoryId != params.id) {
        //MyService.ConsoleLog("scrollTop");
        $("html, body").animate({
          scrollTop: 0
        }, "slow");
        getCategoryCanceler.resolve();
        getCategoryCanceler = $q.defer();
        $scope.status.category = 1;
        var request = apiCall.apiCall('GET', '/categories/list', params);
        request.timeout = getCategoryCanceler.promise;
        $http(
            request
          )
          .then(function successCallback(response) {
            //MyService.ConsoleLog("Got categories: ",response);
            if (response.data.success) {
              $scope.category = response.data.data;
              //MyService.ConsoleLog("category data: ", $scope.category);
              prevFetchedCategoryId = $scope.category._id;
              $scope.status.category = 2;
            } else {
              //MyService.ConsoleLog("Something went wrong: ", response.data);
              $scope.status.category = 3;
            }
          }, function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
            $scope.status.category = 3;
          });
      }
    };

    var getLevelCategoryCanceler = $q.defer();

    function getLevelCategory(params) {
      getLevelCategoryCanceler.resolve();
      getLevelCategoryCanceler = $q.defer();
      $scope.status.levlCat = 1;
      var request = apiCall.apiCall('GET', '/categories/list-layer', params);
      request.timeout = getLevelCategoryCanceler.promise;
      $http(
          request
        )
        .then(function successCallback(response) {
          //MyService.ConsoleLog("Got categories: ",response);
          if (response.data.success) {
            /*
            angular.forEach(response.data.data, function(val, key){
                if(val.total_questions > 0){
                    $scope.traverseBackgrounds.push(val);       
                }
            });
            //MyService.ConsoleLog("traverseBackgrounds data: ", $scope.traverseBackgrounds);
            if($scope.traverseBackgrounds.length > 0){
                $scope.currBackgroundIndex = 0;
                $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
            }
            */
            $scope.traverseBackgrounds = response.data.data;
            if ($routeParams.selectedCatId) {
              //MyService.ConsoleLog("traverseBackgrounds: ", $scope.traverseBackgrounds);
              //MyService.ConsoleLog("$routeParams.selectedCatId: ", $routeParams.selectedCatId);
              angular.forEach($scope.traverseBackgrounds, function(val, key) {
                if (val._id == $routeParams.selectedCatId) {
                  //MyService.ConsoleLog("val._id: ", val._id, " key: ", key, " total_questions: ", val.total_questions);
                  $scope.currBackgroundIndex = key;
                  //MyService.ConsoleLog("$scope.currBackgroundIndex: ", key);
                  $scope.category = angular.copy(val);
                  MyService.ConsoleLog($scope.category);
                }
              });
            } else if ($scope.traverseBackgrounds.length > 0) {
              $scope.category = $scope.traverseBackgrounds[0];
            }
            $scope.status.levlCat = 2;
          } else {
            //MyService.ConsoleLog("Something went wrong: ", response.data);
            $scope.status.levlCat = 3;
          }
        }, function errorCallBack(response) {
          //MyService.ConsoleLog("Error: ", response);
          $scope.status.levlCat = 3;
        });
    }

    function getPopularQuestions() {
      //MyService.ConsoleLog("** getPopularQuestions **");
      var categoryIds = $routeParams.categoryId.split("popular:")[1];
      var request = apiCall.apiCall('GET', '/answers/popular', {
        "categoryIds": categoryIds
      });
      $http(
        request
      ).then(function successCallback(response) {
        //MyService.ConsoleLog("Got PopularQuestions: ", response);
        if (response.data.success) {
          // response.data.data[1].categories.cid = "579b6d83d0cfc69732251494"; //for testing purpose
          $scope.questions = response.data.data;
          if ($scope.questions.length > 0) {
            $scope.getCategory({
              id: $scope.questions[0].categories.cid
            });
          }
        } else {
          //MyService.ConsoleLog("Something went wrong: ", response.data);
        }
      }, function errorCallBack(response) {
        //MyService.ConsoleLog("Error: ", response);
      });
    }

    var getPopularCategoriesCanceler = $q.defer();
    $scope.getPopularCategories = function(params) {
      //MyService.ConsoleLog("** getPopularQuestions **");
      getPopularCategoriesCanceler.resolve();
      params.timeout = getPopularCategoriesCanceler.promise;

      var request = apiCall.apiCall('POST', '/categories/popular-subcategories', params);
      $http(
        request
      ).then(function successCallback(response) {
        //MyService.ConsoleLog("Got PopularQuestions: ", response);
        if (response.data.success) {
          // response.data.data[1].categories.cid = "579b6d83d0cfc69732251494"; //for testing purpose
          $scope.traverseBackgrounds = response.data.data;
          if ($scope.traverseBackgrounds.length > 0) {
            $scope.category = $scope.traverseBackgrounds[0];
            prevFetchedCategoryId = $scope.category._id;
            // getQuestions({categoryId: $scope.category._id});
          }
        } else {
          //MyService.ConsoleLog("Something went wrong: ", response.data);
        }
      }, function errorCallBack(response) {
        //MyService.ConsoleLog("Error: ", response);
      });
    };

    $scope.notAnswerableSelected = function() {
      /*
      if($scope.answer == 0){
          var message = 'Many of our Statements have an undeniable fact followed by an opinion.  Like “the sky is blue.  I hate the sky.”  If this is your problem with the question, then realize that this is just part of the question process and just respond to the second half.  If not, please explain the problem in the “add comments” section so we can fix it.  Thank you.';
          var modal = ngDialog.openConfirm({
              template:'<p>'+message+'</p>\
                      <div class="ngdialog-buttons">\
                          <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                      </div>',
              plain: true
          });
          
          modal.then(function fullfilled(data){
              //MyService.ConsoleLog("fullfilled: ",data);
          }, function rejected(data){
              //MyService.ConsoleLog("rejected: ",data);
          });
      }
      */
      //for report question
      var token = apiCall.getToken();

      if (!token || token == "") {
        var message = "Please login first.";

        var modal = ngDialog.openConfirm({
          template: '<p>' + message + '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
          plain: true
        });

        modal.then(function fullfilled(data) {
          //MyService.ConsoleLog("fullfilled: ", data);
        }, function rejected(data) {
          //MyService.ConsoleLog("rejected: ", data);
        });

        return;
      }
      var postData = {
        questionId: $scope.questions[$scope.currentIndex]._id,
        importance: 0, //$scope.importance,
        answer: $scope.answer,
        comment: $scope.comment
      };

      ngDialog.open({
        template: 'app/popups/report_question.html',
        controller: 'ReportQuesCtrl',
        data: postData
      });

    };

    $scope.postAnswer = function(postData) {
      //MyService.ConsoleLog("postData: ", postData);
      try {
        var my_answer = $scope.questions[$scope.currentIndex].my_answer;
        if (my_answer.importance != $scope.importance || my_answer.answer != $scope.answer || my_answer.comment != $scope.comment) {
          //MyService.ConsoleLog("Answer changed");
          postData.id = my_answer._id;
          postData.reason = $scope.reason;
        } else {
          //MyService.ConsoleLog("Answer not changed");
          return; //don't do anything
        }
      } catch (e) {
        //MyService.ConsoleLog("Exceptoin: ", e);
      }
      console.log("postData > ", postData);
      MyService.postAnswer(postData).then(function(response) {
        if (response.data.success) {
          try {
            if (postData.id) {
              $scope.questions[$scope.currentIndex]["my_answer"] = {
                _id: postData.id,
                created: new Date(),
                comment: postData.comment,
                answer: postData.answer,
                importance: postData.importance
              };
            } else {
              $scope.questions[$scope.currentIndex]["my_answer"] = {
                _id: response.data.data._id,
                created: response.data.data.created,
                comment: response.data.data.comment,
                answer: response.data.data.answer,
                importance: response.data.data.importance
              };
            }
          } catch (e) {
            //MyService.ConsoleLog("Exceptoin: ", e);
          }
          if (postData.id) {
            growl.success("Answer updated successfully", {
              ttl: 800
            });
          } else {
            growl.success("Answered successfully", {
              ttl: 800
            });
          }
          $scope.initializeVariables();
          $scope.skipQuestion();
        } else {
          growl.error("Error: " + response.data.error);
        }
      }, function(err) {
        growl.error("Something went wrong.");
      });


      /*
        var request = apiCall.apiCall('POST', '/answers/create', postData);
        $http(
          request
        ).then(function successCallback(response) {
          //MyService.ConsoleLog("succss: ",response);
          if(response.data.success){
            try{
                $scope.questions[$scope.currentIndex]["my_answer"] = {
                    _id: response.data.data._id,
                    created: response.data.data.created,
                    comment: response.data.data.comment,
                    answer: response.data.data.answer,
                    importance: response.data.data.importance
                };
            }
            catch(e){
                //MyService.ConsoleLog("Exceptoin: ",e);
            }
            growl.success("Answered successfully", {ttl: 800});
            $scope.initializeVariables();
            $scope.skipQuestion();
          }
          else{
            growl.error("Error: "+response.data.error);
          }
        }, function errorCallback(response) {
          $scope.error = 'Wrong Email or Password';
        });
        */

    };

    $rootScope.$on('question.answered', function(evt, data) {
      MyService.ConsoleLog("on question.answered: ", data);
      if ($scope.questions[$scope.currentIndex]._id == data.questionId) {
        $scope.initializeVariables();
        $scope.skipQuestion();
      }
    });

    $scope.submitAnswer = function() {
      //MyService.ConsoleLog("submitAnswer: " + $scope.answer);
      //MyService.ConsoleLog("importance: " + $scope.importance);
      //MyService.ConsoleLog("comments: ", $scope.comment);
      var token = apiCall.getToken();
      if (!token || token == "") {
        var message = "Please login first.";
        var modal = ngDialog.openConfirm({
          template: '<p>' + message + '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
          plain: true
        });
        modal.then(function fullfilled(data) {
          //MyService.ConsoleLog("fullfilled: ", data);
        }, function rejected(data) {
          //MyService.ConsoleLog("rejected: ", data);
        });
        return;
      }

      if ($scope.answer == null) {
        var message = "Please select answer first.";
        var modal = ngDialog.openConfirm({
          template: '<p>' + message + '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
          plain: true
        });
        modal.then(function fullfilled(data) {
          //MyService.ConsoleLog("fullfilled: ", data);
        }, function rejected(data) {
          //MyService.ConsoleLog("rejected: ", data);
        });
        return;
      }

      if ($scope.importance == null) {
        var message = "You gave your opinion, but you didn’t say how important this is to you.  Should they fight hard for this or can they use it as a bargaining chip to get other things you care about more?";
        var modal = ngDialog.openConfirm({
          template: '<p>' + message + '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
          plain: true
        });
        modal.then(function fullfilled(data) {
          //MyService.ConsoleLog("fullfilled: ", data);
        }, function rejected(data) {
          //MyService.ConsoleLog("rejected: ", data);
        });

        return;
      }

      var postData = {
        questionId: $scope.questions[$scope.currentIndex]._id,
        importance: $scope.importance,
        answer: $scope.answer,
        comment: $scope.comment,
        token: token
      };
      $scope.postAnswer(postData);
    };

    $scope.skipQuestion_for_skipansweredQues = function() {
      //MyService.ConsoleLog("skipQuestion: ", $scope.flagSkipAnsweredQuestion);
      var skip = function() {
        var tempIndex = $scope.currentIndex + 1;
        if ($scope.flagSkipAnsweredQuestion && tempIndex < $scope.questions.length && $scope.questions[tempIndex].my_answer) {
          $scope.currentIndex++;
          skip(); //call recursive function to move to next question
          return;
        }

        if (tempIndex < $scope.questions.length) {
          $scope.initializeVariables();
          $scope.currentIndex++;
          if ($routeParams.categoryId && $routeParams.categoryId.indexOf("popular:") == 0) {
            //we are showing questions of most popular section
            $scope.getCategory({
              id: $scope.questions[$scope.currentIndex].categories.cid
            });
          }
        }
        //MyService.ConsoleLog("tempIndex = ", tempIndex, "$scope.questions.length ",$scope.questions.length);
        if (tempIndex == $scope.questions.length) {
          //MyService.ConsoleLog("end of questions switch background");
          var tempBackIdx = $scope.currBackgroundIndex + 1;
          if (tempBackIdx < $scope.traverseBackgrounds.length) {
            $scope.currBackgroundIndex++;
            $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
          } else {
            //MyService.ConsoleLog("* End of background *");
            $location.path('/questionSubcategories/' + $routeParams.categoryId);
          }
        }

        $timeout(function() {
          $location.hash('DisplayQ');
          $anchorScroll();
        }, 100);
      };

      if ($scope.answer != null) {
        var show_answer_modal = true;
        try {
          var my_answer = $scope.questions[$scope.currentIndex]["my_answer"];
          if (my_answer.importance == $scope.importance && my_answer.answer == $scope.answer && my_answer.comment == $scope.comment)
            show_answer_modal = false;

        } catch (e) {
          //MyService.ConsoleLog("Exceptoin : ", e);
        }
        //MyService.ConsoleLog("show_answer_modal: ", show_answer_modal);
        if (show_answer_modal) {
          var message = 'You just hit the SKIP button.  Are you sure you want to skip this one, or would you rather Submit your answer?';
          var modal = ngDialog.openConfirm({
            template: '<p>' + message + '</p>\
                            <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Skip</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Submit</button>\
                            </div>',
            plain: true,
            closeByDocument: false
          });

          modal.then(function fullfilled(data) {
            //submit answer
            $scope.submitAnswer();
          }, function rejected(data) {
            //skip the answer
            skip();
          });
        } else {
          skip();
        }
      } else {
        skip();
      }
    };
    $scope.prevQuestion_for_skipansweredQues = function() {
      //MyService.ConsoleLog("** prevQuestion **", $scope.currentIndex, "currBackgroundIndex: ", $scope.currBackgroundIndex);
      if ($scope.currentIndex > 0) {
        //MyService.ConsoleLog("$scope.currentIndex: ", $scope.currentIndex);
        // $scope.currentIndex--;
        var tempIndex = $scope.currentIndex - 1;
        //MyService.ConsoleLog("tempIndex: ", tempIndex);
        if ($scope.flagSkipAnsweredQuestion && tempIndex > 0 && $scope.questions[tempIndex].my_answer) {
          //MyService.ConsoleLog("Inside if");
          $scope.currentIndex--;
          $scope.prevQuestion(); //call recursive function to move to next question
          return;
        } else {
          //MyService.ConsoleLog("Inside else");
          $scope.currentIndex--;
          if ($scope.currentIndex == 0 && $scope.questions[tempIndex].my_answer && $scope.flagSkipAnsweredQuestion)
            $scope.prevQuestion();
        }

      } else if ($scope.currentIndex == 0) {
        if ($scope.currBackgroundIndex > 0) {
          $scope.currBackgroundIndex--;
          $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
        }
      }
    };

    $scope.skipQuestion = function() {


      var skip = function() {
        var tempIndex = $scope.currentIndex + 1;
        if (tempIndex < $scope.questions.length) {
          $scope.initializeVariables();
          $scope.currentIndex++;
          if ($routeParams.categoryId && $routeParams.categoryId.indexOf("popular:") == 0) {
            //we are showing questions of most popular section
            $scope.getCategory({
              id: $scope.questions[$scope.currentIndex].categories.cid
            });
          }
        }
        MyService.ConsoleLog("tempIndex = ", tempIndex, "$scope.questions.length ", $scope.questions.length);
        if (tempIndex == $scope.questions.length) {
          MyService.ConsoleLog("end of questions switch background");
          var tempBackIdx = $scope.currBackgroundIndex + 1;
          if (tempBackIdx < $scope.traverseBackgrounds.length) {
            $scope.currBackgroundIndex++;
            $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
          } else {
            MyService.ConsoleLog("* End of background *");
            $location.path('/questionSubcategories/' + $routeParams.categoryId);
          }
        }

        $timeout(function() {
          $location.hash('DisplayQ');
          $anchorScroll();
        }, 100);
      };

      if ($scope.answer != null) {
        var show_answer_modal = true;
        try {
          var my_answer = $scope.questions[$scope.currentIndex]["my_answer"];

          /*for (var key in my_answer) {
            if(my_answer[])
          }*/
          if (my_answer.importance == $scope.importance && my_answer.answer == $scope.answer && my_answer.comment == $scope.comment)
            show_answer_modal = false;

        } catch (e) {
          //MyService.ConsoleLog("Exceptoin : ", e);
        }
        //MyService.ConsoleLog("show_answer_modal: ", show_answer_modal);
        if (show_answer_modal) {
          var message = 'You just hit the SKIP button.  Are you sure you want to skip this one, or would you rather Submit your answer?';
          var modal = ngDialog.openConfirm({
            template: '<p>' + message + '</p>\
                            <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Skip</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Submit</button>\
                            </div>',
            plain: true,
            closeByDocument: false
          });

          modal.then(function fullfilled(data) {
            //submit answer
            $scope.submitAnswer();
          }, function rejected(data) {
            //skip the answer
            skip();
          });
        } else {
          skip();
        }
      } else {
        skip();
      }
    };
    $scope.prevQuestion = function() {
      //MyService.ConsoleLog("** prevQuestion **");

      if ($scope.currentIndex > 0) {
        $scope.currentIndex--;
        $timeout(function() {
          $location.hash('DisplayQ');
          $anchorScroll();
        }, 100);
      } else if ($scope.currentIndex == 0) {
        if ($scope.currBackgroundIndex > 0) {
          $scope.currBackgroundIndex--;
          $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
        }
      }
    };

    $scope.compareChanged = function(compare_with) {
      //MyService.ConsoleLog("compare_with :", compare_with);
      var catid = $routeParams.categoryId;
      if ($routeParams.categoryId && $routeParams.categoryId.indexOf("popular:") == 0) {
        var catid = $routeParams.categoryId.split("popular:")[1];
      }

      $location.path('/compare-select/' + compare_with);
    };

    var getCompareAnswersCanceler = $q.defer();

    function getCompareAnswers(params) {
      if (!params) return;
      getCompareAnswersCanceler.resolve();
      params.timeout = getCompareAnswersCanceler.promise;
      $scope.questions = [];
      $scope.status.questions = 1;
      var request = apiCall.apiCall('GET', '/answers/compare', params);
      $http(
        request
      ).then(function successCallback(response) {
        //MyService.ConsoleLog("Got categories: ",response);
        if (response.data.success) {
          $scope.status.questions = 2;
          angular.forEach(response.data.data, function(val, key) {
            if (val.answers && val.answers.length != $rootScope.selectedCompareUsers.length) {
              var check_author_exist = function(u) {
                var len = val.answers.length;
                for (var i = 0; i < len; i++) {
                  if (val.answers[i].author._id == u._id) {
                    return true;
                  }
                }
                return false;
              };

              angular.forEach($rootScope.selectedCompareUsers, function(u, i) {
                if (!check_author_exist(u)) {
                  response.data.data[key].answers.push({
                    author: u
                  });
                }
              });

            } else if (!val.answers) {
              response.data.data[key].answers = [];

              angular.forEach($rootScope.selectedCompareUsers, function(u, i) {
                response.data.data[key].answers.push({
                  author: u
                });
              });

            }
          });

          $scope.questions = response.data.data;
          // $location.path("question-compare/"+$routeParams.category_id+"/"+null);
        } else {
          $scope.status.questions = 3;
          //MyService.ConsoleLog("Something went wrong: ", response.data);
        }
      }, function errorCallBack(response) {
        $scope.status.questions = 3;
        //MyService.ConsoleLog("Error: ", response);
      });
    };

    $scope.initPageData = function() {
      var current_url = $location.url();
      //MyService.ConsoleLog("$location.url: ", current_url);

      if (current_url.indexOf("question-compare") > -1) {
        $scope.state = "question-compare";
        if ($routeParams.categoryId == 'all') {
          var param = {
            id: $routeParams.parentId,
            questions_counter: 1
          };
          getLevelCategory(param);
        } // traverse all questions
        else {
          //MyService.ConsoleLog("** question-compare **");
          //MyService.ConsoleLog("compareAnswerList: ", $rootScope.compareAnswerList);
          $scope.questions = $rootScope.compareAnswerList;
          $scope.getCategory({
            id: $routeParams.categoryId
          });
        }
      } else if (current_url.indexOf("question-tagged") > -1) {
        $scope.state = "question-tagged";
        getQuestions({
          "tagged_to": $routeParams.user_id
        });
      } else if (current_url.indexOf("question-background") > -1) {
        $scope.state = "question-background";
        var param = {
          id: $routeParams.categoryId,
          questions_counter: 1
        };
        getLevelCategory(param);
      } else if (current_url.indexOf("question-search") > -1) {
        $scope.state = "question-background";
        var param = {
          keyword: 'test',
        };
        getQuestions(param);
      } else {
        $scope.state = "question";
        if ($routeParams.categoryId && $routeParams.categoryId.indexOf("popular:") == 0) {
          // getPopularQuestions();
          var categoryId = $routeParams.categoryId.split("popular:")[1];
          $scope.getPopularCategories({
            parentId: categoryId
          })
        } else {
          // getQuestions({categoryId: $routeParams.categoryId});
          $scope.getCategory({
            id: $routeParams.categoryId
          });
        }
      }
    };
    $scope.initPageData();
    $scope.skipAnswerChagne = function() {
      //MyService.ConsoleLog("$scope.flagSkipAnsweredQuestion: ", $scope.flagSkipAnsweredQuestion);
      $scope.currentIndex = 0;
      // $scope.initPageData();
      getQuestions({
        categoryId: $scope.category._id
      });
    };


    // $scope.matchQuestion = function() {
    //   // ngDialog.open({
    //   //   template: 'app/popups/matchQuestion.html'
    //   //   // className: 'ngdialog-theme-default'
    //   // });

    // }

    $scope.$watch('category', function(newValue, oldValue) {
      var current_url = $location.url();
      //MyService.ConsoleLog("oldValue: ", oldValue);
      MyService.ConsoleLog("newValue: ", newValue);
      $rootScope.OldCatforFB = oldValue;
      if (current_url.indexOf("question-tagged") > -1)
        return; //for tagged questions don't again fetch questions

      if (newValue) {
        //MyService.ConsoleLog("oldValue: ", oldValue);
        //MyService.ConsoleLog("newValue: ", newValue);
        if (oldValue && oldValue._id == newValue._id) return;

        //MyService.ConsoleLog("scrollTop");
        $("html, body").animate({
          scrollTop: 0
        }, "slow");
        $scope.currentIndex = 0;

        if (current_url.indexOf("question-compare") > -1) {
          //MyService.ConsoleLog("** getCompareAnswers **");

          var temp_uids = [];
          angular.forEach($rootScope.selectedCompareUsers, function(val, key) {
            temp_uids.push(val._id);
          });

          getCompareAnswers({
            "categoryIds": newValue._id,
            "userIds": temp_uids.join(",")
          }); //"compare_with": $routeParams.user_type, 
        } else {
          getQuestions({
            categoryId: newValue._id
          });
        }
      }
    });

    $scope.$watch('questions', function(newValue, oldValue) {
      try {
        MyService.ConsoleLog("Current question: ", $scope.questions[$scope.currentIndex]);
        var tempCate = $scope.questions[$scope.currentIndex].categories;
        if ($scope.questions[$scope.currentIndex] && $scope.questions[$scope.currentIndex].my_answer) {
          if ($scope.questions[$scope.currentIndex].my_answer.comment) {
            $scope.comment = $scope.questions[$scope.currentIndex].my_answer.comment;
          }

        }
        if (angular.isArray(tempCate)) {
          $scope.getCategory({
            id: tempCate[0].cid
          });
        } else {
          $scope.getCategory({
            id: tempCate.cid
          });
        }
        $scope.initMyAnswer();
      } catch (e) {
        //MyService.ConsoleLog("questions Index Change Ex: ", e)
      }
    });

    $scope.$watch('currentIndex', function(newValue, oldValue) {
      try {
        //MyService.ConsoleLog($scope.currentIndex);
        //MyService.ConsoleLog($scope.questions.length);
        MyService.ConsoleLog("Current currentIndex: ", $scope.questions[$scope.currentIndex]);
        var tempCate = $scope.questions[$scope.currentIndex].categories;
        if (angular.isArray(tempCate)) {
          $scope.getCategory({
            id: tempCate[0].cid
          });
        } else {
          $scope.getCategory({
            id: tempCate.cid
          });
        }
        $scope.initMyAnswer();
      } catch (e) {
        //MyService.ConsoleLog("Current Index Change Ex: ", e)
      }
    });

    $scope.checkIfExists = function(val) {
      // console.log("questions <><><>", $scope.questions);
      // MyService.ConsoleLog("Val > ", val);
      var obj = $scope.questions[$scope.currentIndex];
      // MyService.ConsoleLog("checkIfExists >> ", obj);
      if (obj) {
        var data = obj.my_answer;
        // console.log("data <>", data);
        if (data) {
          // MyService.ConsoleLog("checkIfExists data>> ", data.answer + "==" + val);
          if (data.answer == val) {
            return true;
          }

        }
      }
      return false;
    }

    $scope.subNew = function(valOne) {
      $scope.importance = valOne;
      $scope.submitAnswer();
    };

    $scope.checkImpExists = function(val) {
      var obj = $scope.questions[$scope.currentIndex];
      // MyService.ConsoleLog(" qobject :", obj);
      if (obj) {
        var data = obj.my_answer;

        if (data && data) {
          // MyService.ConsoleLog("Importance data>> ", data.importance);
          if (data.importance == val) {
            return true;

          }
        }
      }
      return false;
    }


  }])
  .controller('ReportQuesCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$q', 'ngDialog', '$rootScope', 'growl', '$anchorScroll', '$timeout', function($scope, $http, $location, apiCall, $routeParams, $q, ngDialog, $rootScope, growl, $anchorScroll, $timeout) {
    //MyService.ConsoleLog("** ReportQuesCtrl **");
    //MyService.ConsoleLog("ngDialog data: ", $scope.ngDialogData);
    $rootScope.welcome = false;
    $scope.ngDialogData.comment = '';

    $scope.postAnswer = function() {
      var postData = {
        id: $scope.ngDialogData.questionId,
        // importance: 0,
        // answer: 0,
        comment: $scope.ngDialogData.comment
      };

      //MyService.ConsoleLog("postData: ", postData);

      var request = apiCall.apiCall('POST', '/questions/report', postData);
      $http(
        request
      ).then(function successCallback(response) {
        //MyService.ConsoleLog("succss: ", response);
        if (response.data.success) {
          $rootScope.$broadcast("question.answered", {
            "questionId": $scope.ngDialogData.questionId
          });
          $scope.closeThisDialog();
          growl.success("Reported successfully");
        } else {
          if (typeof response.data.error == "string")
            growl.error(response.data.error);
          else
            growl.error("Something went wrong");
        }
      }, function errorCallback(response) {
        growl.success("Something went wrong.");
      });
    };
  }])
  .controller('OldAnswerViewerCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$q', 'ngDialog', '$rootScope', 'growl', '$timeout', function($scope, $http, $location, apiCall, $routeParams, $q, ngDialog, $rootScope, growl, $timeout) {
    //MyService.ConsoleLog("** OldAnswerViewerCtrl **");
    //MyService.ConsoleLog("ngDialog data: ", $scope.ngDialogData);
    $rootScope.welcome = false;
    $scope.QuestionAnsArray = {};
    $scope.QuestionAnsArray[1] = 'Very strongly agree';
    $scope.QuestionAnsArray[2] = 'Agree';
    $scope.QuestionAnsArray[3] = 'Sort of agree';
    $scope.QuestionAnsArray[4] = 'Sort of disagree';
    $scope.QuestionAnsArray[5] = 'Disagree';
    $scope.QuestionAnsArray[6] = 'Very strongly disagree';

    $scope.QuestionImpArray = {};
    $scope.QuestionImpArray[1] = 'Somewhat';
    $scope.QuestionImpArray[2] = 'Important';
    $scope.QuestionImpArray[3] = 'Very Important';


  }])
  .controller('matchQuestion', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$q', 'ngDialog', '$rootScope', 'growl', 'MyService', function($scope, $http, $location, apiCall, $routeParams, $q, ngDialog, $rootScope, growl, MyService) {
    //MyService.ConsoleLog("** matchQuestion **");
    $rootScope.welcome = false;
    $scope.AllPolitician = [];
    MyService.matchQuestionwithPolitician().then(function(payload) {
      //MyService.ConsoleLog(payload);
      if (payload.data.success) {

        $scope.AllPolitician = payload.data.data.allUsers;
        $scope.FBunWeighted = payload.data.data.unweightedMatch;
        $scope.fbcombinedWeight = payload.data.data.fbcombinedWeight;
        $scope.fbmultiplier = payload.data.data.fbmultiplier;
        $scope.fbqlen = payload.data.data.qlen;
      } else {
        alert("Something went wrong. Please try again later");
      }
    }, function(errpayload) {
      //MyService.ConsoleLog(errpayload);
    });
    //MyService.ConsoleLog("CommentTxtViewerCtrl: ", $scope.ngDialogData);
  }])
  .controller('CommentTxtViewerCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$q', 'ngDialog', '$rootScope', 'growl', function($scope, $http, $location, apiCall, $routeParams, $q, ngDialog, $rootScope, growl) {
    //MyService.ConsoleLog("** CommentTxtViewerCtrl **");
    //MyService.ConsoleLog("CommentTxtViewerCtrl: ", $scope.ngDialogData);
    $rootScope.welcome = false;

  }]);;

"use strict";
angular
  .module("myApp.publicProfile", ["ngRoute"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/publicProfile/:id/:type?", {
        templateUrl: "app/publicProfile/publicProfile.html",
        controller: "publicProfileCtrl",
      });
    },
  ])
  .controller("publicProfileCtrl", [
    "$scope",
    "$http",
    "$location",
    "apiCall",
    "$routeParams",
    "$rootScope",
    "$q",
    "$timeout",
    "tokenService",
    "MyService",
    "growl",
    "$sce",
    "ngDialog",
    "$cookies",
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $rootScope,
      $q,
      $timeout,
      tokenService,
      MyService,
      growl,
      $sce,
      ngDialog,
      $cookies
    ) {
      $scope.userId = $routeParams.id;
      // MyService.ConsoleLog("user id :", $scope.userId);
      $rootScope.welcome = false;
      $scope.loginUser = tokenService.getUserId();
      $scope.politicianUser = "false";
      window.localStorage.removeItem("isShowPreviousResult");

      window.localStorage.setItem("isShowPreviousResult", true);

      window.localStorage.setItem("isShowOldResult", true);
      // MyService.ConsoleLog("route type", $routeParams);
      if ($routeParams.type) {
        $scope.politicianUser = $routeParams.type;
      }
      window.localStorage.removeItem("isShowSpecialMatch");
      if (tokenService.getUserData()) {
        $scope.UserData = JSON.parse(tokenService.getUserData());
        // MyService.ConsoleLog("$scope.UserData >", $scope.UserData);
      }
      $scope.shobackbtn = false;
      if ($cookies.get("params")) {
        $scope.shobackbtn = true;
      }
      MyService.ConsoleLog("params id", $routeParams.id);
      $scope.userDetails = {};
      $scope.userProfile = {};
      $scope.statusGetData = 0;
      $scope.propublicaData = [];
      $scope.memberRole = [];
      $scope.memberRoleCommittee = [];
      $scope.committeeData = [];
      $scope.currentRole = 0;
      $scope.allRoles = 1;
      $scope.showSponsoredContent = false;
      $scope.sponsorData = [];
      $scope.industrySupport = [];
      $scope.atLarge = "";
      $scope.memberCrpId = "";
      $scope.personalHoldingData = [];
      $scope.fundRaisingData = [];
      $scope.topContributorData = [];
      $scope.currentContent = "";
      $scope.allroles = [];
      $scope.committeesYears = [];
      $scope.contYear = new Date().getFullYear().toString();
      $scope.supportYear = new Date().getFullYear();
      $scope.contYearArray = [];
      $scope.selectedYear = "0";
      $scope.selectedYearCommittee = "0";
      for (var x = 0; x < 15; x++) {
        $scope.contYearArray.push($scope.contYear - x);
      }
      // MyService.ConsoleLog('@@@@ ', $scope.contYearArray);
      $scope.getData = function () {
        //MyService.ConsoleLog("politicianUser:",$scope.politicianUser);
        $scope.statusGetData = 1;
        MyService.getUserPublicProfile({
          id: $routeParams.id,
          type: $scope.politicianUser,
        }).then(
          function (response) {
            MyService.ConsoleLog("response", response);

            $scope.statusGetData = 2;
            if (response.data.success) {
              $scope.userDetails = response.data.data;
              // MyService.ConsoleLog('new user details : ', response.data.data);

              $scope.userProfile = $scope.userDetails.userData;

              MyService.ConsoleLog(
                "userDetails for user : ",
                $scope.userProfile
              );
              if ($scope.UserData && $scope.UserData.followlist.length > 0) {
                var fLen = $scope.UserData.followlist.length;
                for (var f = 0; f < fLen; f++) {
                  // MyService.ConsoleLog("$scope.UserData.followlist[f]", $scope.UserData.followlist[f]);
                  if ($scope.UserData.followlist[f] == $routeParams.id) {
                    $scope.showUnFollow = true;
                    // growl.success("showUnfollow");
                    // alert("showunfollow");
                  } else {
                    // MyService.ConsoleLog("userProfile", $scope.userProfile);
                    if (
                      $scope.UserData.followlist[f] ==
                      $scope.userProfile.officeId
                    ) {
                      $scope.showUnFollow = true;
                    }
                  }
                }
              }
              if ($scope.userProfile.politicianInfo) {
                var ulen = $scope.userProfile.politicianInfo.length;
                for (var i = 0; i < ulen; i++) {
                  if (
                    $scope.userProfile.politicianInfo[i].incumbent &&
                    $scope.userProfile.politicianInfo[i].incumbent != ""
                  ) {
                    $scope.isIncumbent = $scope.userProfile.politicianInfo[
                      i
                    ].incumbent.toLowerCase();
                  } else {
                    // $scope.isIncumbent = "";
                  }
                  MyService.ConsoleLog(
                    "$scope.isIncumbent",
                    $scope.isIncumbent
                  );
                }
              }
              $rootScope.userData = $scope.userProfile;
              var edat = $scope.userProfile.electionDate;
              // MyService.ConsoleLog("EleDate >", edat);
              if (edat && edat != "") {
                $scope.eleDate = new Date(edat).toISOString().split("T")[0];
                // MyService.ConsoleLog("EleDate >", $scope.eleDate);
              }

              var today = new Date();
              $scope.curDate = today.toISOString().split("T")[0];
              $scope.curYear = today.getFullYear();
              // MyService.ConsoleLog("$scope.curYear", $scope.curYear, $scope.userProfile.electionDate);

              // MyService.ConsoleLog("curDate >", $scope.curDate);

              if (
                $scope.userProfile.politicianIds &&
                $scope.userProfile.politicianIds[0]
              ) {
                // alert("inside");
                $scope.getRatingData($scope.userProfile.politicianIds[0]);
              } else if ($scope.userProfile.votesmartCandidateId) {
                $scope.getRatingData($scope.userProfile._id);
              } else {
                $scope.getRatingData($scope.userProfile._id);
              }
            } else {
              $scope.statusGetData = 3;
            }
          },
          function (errorPayload) {
            $scope.statusGetData = 3;
          }
        );
      };

      $scope.MyDialog1 = "";
      $scope.showHtmlViewer1 = function (content, ttl) {
        // console.log(content);
        $scope.displayContent = $sce.trustAsHtml(
          content.replace(/(\r\n|\n|\r)/g, "<br />")
        );
        $scope.MyDialog1 = ngDialog.open({
          template: "statement",
          scope: $scope,
          // className: 'ngdialog-theme-default'
        });
      };

      $scope.getMatch = function () {
        MyService.ConsoleLog("This is inside", $scope.userProfile);
        window.localStorage.setItem("isShowSpecialMatch", true);
        $location.path("/ballotMatch/" + $scope.userProfile._id);
      };

      $scope.addtoFollow = function () {
        var data = {};
        data.userId = $scope.loginUser;
        data.pushId = $routeParams.id;
        MyService.updateUserFollowList(data).then(
          function (payload) {
            if ($scope.UserData) {
              $scope.showUnFollow = true;
              $scope.UserData.followlist.push($routeParams.id);
              //MyService.ConsoleLog("udata : ", $scope.UserData);
              tokenService.saveUserData(JSON.stringify($scope.UserData));
            }
          },
          function (errorPayload) {
            alert("Something went wrong ");
          }
        );
      };

      $scope.removetoFollow = function () {
        var data = {};
        data.userId = $scope.loginUser;
        data.pushId = $routeParams.id;
        MyService.removeUserFollowList(data).then(
          function (result) {
            MyService.ConsoleLog("result", result);
            $scope.showUnFollow = false;
            var ids = $scope.UserData.followlist.indexOf($routeParams.id);
            MyService.ConsoleLog("ids", ids);
            if (ids > -1) {
              $scope.UserData.followlist.splice(ids, 1);
            } else {
              var idx = $scope.UserData.followlist.indexOf(
                $scope.userProfile.officeId
              );
              $scope.UserData.followlist.splice(idx, 1);
            }
            //MyService.ConsoleLog("udata : ", $scope.UserData);
            tokenService.saveUserData(JSON.stringify($scope.UserData));
          },
          function (err) {
            MyService.ConsoleLog("error", err);
          }
        );
      };

      $scope.goBack = function () {
        window.history.back();
      };

      $scope.arrangeComitteeData = function () {
        $scope.committeeData = [];
        var len1 = $scope.memberRoleCommittee.committees.length;
        var len2 = $scope.memberRoleCommittee.subcommittees.length;
        if ($scope.memberRoleCommittee) {
          for (var i = 0; i < len1; i++) {
            var itm = {
              committeeName: $scope.memberRoleCommittee.committees[i].name,
              committeeRank:
                $scope.memberRoleCommittee.committees[i].rank_in_party,
              committeeBeginDate:
                $scope.memberRoleCommittee.committees[i].begin_date,
              committeeEndDate:
                $scope.memberRoleCommittee.committees[i].end_date,
              committeeCode: $scope.memberRoleCommittee.committees[i].code,
              subcommittees: [],
            };
            $scope.committeeData.push(itm);
          }

          $timeout(function () {
            for (var j = 0; j < $scope.committeeData.length; j++) {
              for (var k = 0; k < len2; k++) {
                if (
                  $scope.committeeData[j].committeeCode ==
                  $scope.memberRoleCommittee.subcommittees[k]
                    .parent_committee_id
                ) {
                  var sub = {
                    scommitteeName:
                      $scope.memberRoleCommittee.subcommittees[k].name,
                    scommitteeRank:
                      $scope.memberRoleCommittee.subcommittees[k].rank_in_party,
                    scommitteeBeginDate:
                      $scope.memberRoleCommittee.subcommittees[k].begin_date,
                    scommitteeEndDate:
                      $scope.memberRoleCommittee.subcommittees[k].end_date,
                    scommitteeParentId:
                      $scope.memberRoleCommittee.subcommittees[k]
                        .parent_committee_id,
                    scommitteeCode:
                      $scope.memberRoleCommittee.subcommittees[k].code,
                  };

                  $scope.committeeData[j].subcommittees.push(sub);
                  //$scope.committeeData.push(itm);
                }
              }
            }
          }, 2000);
          MyService.ConsoleLog("committeeData : ", $scope.committeeData);
        }
      };
      $scope.getCommitteesYears = function () {
        MyService.ConsoleLog("getCommitteesYears");
        var len = $scope.propublicaData.roles.length;
        var yr = "";
        if (len > 0) {
          for (var i = 0; i < len; i++) {
            if (
              $scope.propublicaData.roles[i].committees.length > 0 ||
              $scope.propublicaData.roles[i].subcommittees.length > 0
            ) {
              switch ($scope.propublicaData.roles[i].congress) {
                case "116":
                  yr = "2019 - 2021";
                  break;
                case "115":
                  yr = "2017 - 2018";
                  break;
                case "114":
                  yr = "2015 - 2016";
                  break;
                case "113":
                  yr = "2013 - 2014";
                  break;
                case "112":
                  yr = "2011 - 2012";
                  break;
                case "111":
                  yr = "2009 - 2010";
                  break;
                case "110":
                  yr = "2007 - 2008";
                  break;
                case "109":
                  yr = "2005 - 2006";
                  break;
                case "108":
                  yr = "2003 - 2004";
                  break;
                case "107":
                  yr = "2001 - 2002";
                  break;
                case "106":
                  yr = "1999 - 2000";
                  break;
                case "105":
                  yr = "1997 - 1998";
                  break;
                case "104":
                  yr = "1995 - 1996";
                  break;
                case "103":
                  yr = "1993 - 1994";
                  break;
                case "102":
                  yr = "1991 - 1992";
                  break;
                case "101":
                  yr = "1989 - 1990";
                  break;
                case "default":
                  break;
              }
              var itm = {
                year: yr,
                id: i,
                committeesid: i,
                congress: $scope.propublicaData.roles[i].congress,
              };
              $scope.committeesYears.push(itm);
            }
          }
        }
      };
      $scope.getProbublicaData = function () {
        MyService.ConsoleLog("In getProbublicaData");
        var data = {};
        data.id = $routeParams.id;
        data.type = $scope.politicianUser;
        MyService.ConsoleLog("data params: ", data);
        MyService.getProbublicaData(data).then(
          function (payload) {
            // MyService.ConsoleLog('Success : ', payload);

            if (payload.data.success) {
              $scope.propublicaData = payload.data.data;
              $scope.memberCrpId = $scope.propublicaData.crp_id;
              $scope.getIndustrySupport($scope.contYear);
              // MyService.ConsoleLog(typeof $scope.propublicaData.roles);
              // if (typeof($scope.propublicaData.roles[0]) == 'string') {
              //   $scope.propublicaData.roles = JSON.parse($scope.propublicaData.roles);
              //   $scope.memberRole = $scope.propublicaData.roles[$scope.currentRole];
              // } else {
              var len = $scope.propublicaData.roles.length;
              var yr = "";
              for (var i = 0; i < len; i++) {
                switch ($scope.propublicaData.roles[i].congress) {
                  case "116":
                    yr = "2019 - 2021";
                    break;
                  case "115":
                    yr = "2017 - 2018";
                    break;
                  case "114":
                    yr = "2015 - 2016";
                    break;
                  case "113":
                    yr = "2013 - 2014";
                    break;
                  case "112":
                    yr = "2011 - 2012";
                    break;
                  case "111":
                    yr = "2009 - 2010";
                    break;
                  case "110":
                    yr = "2007 - 2008";
                    break;
                  case "109":
                    yr = "2005 - 2006";
                    break;
                  case "108":
                    yr = "2003 - 2004";
                    break;
                  case "107":
                    yr = "2001 - 2002";
                    break;
                  case "106":
                    yr = "1999 - 2000";
                    break;
                  case "105":
                    yr = "1997 - 1998";
                    break;
                  case "104":
                    yr = "1995 - 1996";
                    break;
                  case "103":
                    yr = "1993 - 1994";
                    break;
                  case "102":
                    yr = "1991 - 1992";
                    break;
                  case "101":
                    yr = "1989 - 1990";
                    break;
                  case "default":
                    break;
                }
                var itm = {
                  year: yr,
                  id: i,
                  committeesid: i,
                  congress: $scope.propublicaData.roles[i].congress,
                };
                $scope.allroles.push(itm);
              }
              //alert("allroles : ", $scope.allroles[0].id);
              $scope.getCommitteesYears();
              $scope.memberRole =
                $scope.propublicaData.roles[$scope.currentRole];
              $scope.memberRoleCommittee =
                $scope.propublicaData.roles[$scope.currentRole];
              //}
              $timeout(function () {
                $scope.arrangeComitteeData();
              }, 1000);

              if ($scope.memberRole.at_large) {
                if ($scope.memberRole.at_large == true) {
                  $scope.atLarge = "At large";
                } else {
                  $scope.atLarge = "";
                }
              }
              $scope.allRoles = $scope.propublicaData.roles.length;
              //MyService.ConsoleLog("allRoles : ", $scope.allRoles);
              MyService.ConsoleLog(
                "$scope.propublicaData : ",
                $scope.propublicaData
              );
            } else {
              // MyService.getOpenStateData(data).then(
              //   function (response) {
              //     $scope.openData = response;
              //     MyService.ConsoleLog('Response >', $scope.openData);
              //   },
              //   function (err) {
              //     MyService.ConsoleLog('Error >', err);
              //   }
              // );
            }
          },
          function (error) {
            MyService.ConsoleLog("Something went wrong : ", error);
          }
        );
      };

      $scope.getBillCosponsored = function (id) {
        MyService.ConsoleLog("In getBillCosponsored :" + id);
        $location.path(
          "/sponsored/" + id + "/" + $scope.userId + "/" + $routeParams.type
        );
        /*
        if ($scope.showSponsoredContent == false) {
        $scope.showSponsoredContent = true;
        var data = {};
        data.id = id;
        MyService.getBillCosponsoredData(data).then(function(data) {
          MyService.ConsoleLog("getBillCosponsored success : ", data);
          $scope.sponsorData = data.data.data.results[0].bills;
        }, function(err) {
          MyService.ConsoleLog("getBillCosponsored error : ", err);
        });
      } else {
        $scope.showSponsoredContent = false;
      }
      */
      };

      $scope.getVotingRecords = function (id) {
        $location.path(
          "/votingRecords/" + id + "/" + $scope.userId + "/" + $routeParams.type
        );
        /*if ($scope.showSponsoredContent == false) {
        $scope.showSponsoredContent = true;
        var data = {};
        data.id = id;
        MyService.getVotingRecords(data).then(function(data) {
          MyService.ConsoleLog("getVotingRecords success : ", data);
          //$scope.sponsorData = data.data.data.results[0].bills;
        }, function(err) {
          MyService.ConsoleLog("getVotingRecords error : ", err);
        });
      } else {
        $scope.showSponsoredContent = false;
      }*/
      };

      /**
       * @description Show Thread listing
       */
      $scope.ShowLoader = false;
      $scope.LatestEssay = [];
      $scope.LatestPost = [];
      $scope.LatestThread = [];
      $scope.gotoPage = function (obj, data) {
        //MyService.ConsoleLog(data);
        switch (obj) {
          case "Essay":
            var userid = data._id;
            $scope.dialogClose = ngDialog.open({
              template: "LatestEssayId",
              closeByNavigation: true,
              scope: $scope,
            });
            $scope.ShowLoader = true;
            MyService.getLatestEssay({
              userId: userid,
            }).then(
              function (payload) {
                $scope.ShowLoader = false;
                MyService.ConsoleLog("essay", payload);
                $scope.LatestEssay = payload;
              },
              function (errorPayload) {
                $scope.ShowLoader = false;
                MyService.ConsoleLog("err vosjs", errorPayload);
                alert("Something went wrong.");
              }
            );
            //$location.path('essayDetails/' + catId + '/' + id);
            break;
          case "EssayComment":
            var userid = data._id;
            $scope.dialogClose = ngDialog.open({
              template: "LatestEssayCommentId",
              closeByNavigation: true,
              scope: $scope,
            });
            $scope.ShowLoader = true;
            MyService.getLatestEssay({
              userId: userid,
              isEssayComment: true,
            }).then(
              function (payload) {
                if (payload && payload.length > 0) {
                  var essayIds = payload.map(function (itms) {
                    if (itms && itms.essayId) {
                      return itms.essayId;
                    }
                  });

                  MyService.getAllEssaysList({
                    eIds: JSON.stringify(essayIds),
                  }).then(
                    function (APIResponse) {
                      MyService.ConsoleLog("APIREs", APIResponse);
                      if (APIResponse.success) {
                        $scope.ShowLoader = false;
                        MyService.ConsoleLog("essay commnent", payload);
                        $scope.LatestEssayComments = APIResponse.data;
                      }
                    },
                    function (err) {
                      MyService.ConsoleLog("Error", err);
                    }
                  );
                }
              },
              function (errorPayload) {
                $scope.ShowLoader = false;
                MyService.ConsoleLog("err vosjs", errorPayload);
                alert("Something went wrong.");
              }
            );

            //$location.path('essayDetails/' + catId + '/' + id);
            break;
          case "Post":
            var userid = data._id;
            // var subcatid = ""
            // if(data.subcategories && data.subcategories.length > 0)
            //var subcatid = data.subcategories[0].pid;
            //var id = data.parent;
            //MyService.ConsoleLog('forumthread/' + catId + '/' + subcatid + '/' + id);
            //$location.path('forumthread/' + catId + '/' + subcatid + '/' + id);
            $scope.dialogClose = ngDialog.open({
              template: "LatestPostId",
              closeByNavigation: true,
              scope: $scope,
            });
            $scope.ShowLoader = true;
            MyService.getLatestPost({
              userId: userid,
            }).then(
              function (payload) {
                $scope.ShowLoader = false;
                //MyService.ConsoleLog(payload);
                $scope.LatestPost = payload;
              },
              function (errorPayload) {
                $scope.ShowLoader = false;
                MyService.ConsoleLog("errorPayload errorPayload", errorPayload);
                alert("Something went wrong.");
              }
            );
            break;
          case "Thread":
            //var catId = data.parentcat[0];
            //var subcatid = ""
            // if(data.subcategories && data.subcategories.length > 0)
            //     var subcatid = data.subcategories[0].pid;
            //var subcatid = data.subcategories[0].pid;
            var userid = data._id;
            $scope.dialogClose = ngDialog.open({
              template: "LatestThreadId",
              closeByNavigation: true,
              scope: $scope,
            });
            $scope.ShowLoader = true;
            MyService.getLatestThread({
              userId: userid,
            }).then(
              function (payload) {
                $scope.ShowLoader = false;
                //MyService.ConsoleLog(payload);
                $scope.LatestThread = payload;
              },
              function (errorPayload) {
                $scope.ShowLoader = false;
                alert("error");
                alert("Something went wrong.");
              }
            );
            //MyService.ConsoleLog('forumthread/' + catId + '/' + subcatid + '/' + id);
            //$location.path('forumthread/' + catId + '/' + subcatid + '/' + id);
            break;
          case "topic of interest":
            MyService.ConsoleLog("data", data);
            MyService.ConsoleLog("data", typeof data);

            MyService.getMultiCategoryByIds({
              ids: data,
            }).then(
              function (APIResponse) {
                MyService.ConsoleLog("APIResponse Its", APIResponse);
                if (APIResponse.data.success) {
                  $scope.TopicsOfInterests = APIResponse.data.data;
                  $scope.dialogClose = ngDialog.open({
                    template: "TopicsOfInterest",
                    closeByNavigation: true,
                    scope: $scope,
                  });
                }
              },
              function (err) {
                MyService.ConsoleLog("Errror", err);
              }
            );
            break;
          default:
            break;
        }
      };
      $scope.gotoThread = function (data, subcatid) {
        var id = "";
        if (data.parentId) {
          id = data.parentId;
        } else if (data.parent) {
          id = data.parent;
        } else {
          if (data.id) {
            id = data.id;
          } else {
            id = data._id;
          }
        }
        // MyService.ConsoleLog(data);
        var categoryId = "";
        if (data.parentCat[0] && data.parentCat[0] != "") {
          categoryId = data.parentCat[0];
        } else {
          if (data.parentCat[1] && data.parentCat[1] != "") {
            categoryId = data.parentCat[1];
          }
        }

        // $rootScope.subcategoryId = subcatid;
        //MyService.ConsoleLog('forumthread/' + categoryId + '/' + subcatid + '/' + id);

        if (categoryId != "") {
          $location.path(
            "forumthread/" + categoryId + "/" + subcatid + "/" + id
          );
        } else {
          MyService.ConsoleLog("ELSE");
          alert("Something went wrong");
        }
      };
      $scope.gotoComments = function (eId, catId) {
        MyService.ConsoleLog("eid", eId);
        MyService.ConsoleLog("catId", catId);

        // MyService.getEssay(eId).then(function (APIResponse) {
        //   MyService.ConsoleLog("APIResponse", APIResponse);
        if (eId && catId) {
          $location.path("/essayDetails/" + catId + "/" + eId);
        }
      };

      $scope.gotoEssay = function (id, catId) {
        $location.path("essayDetails/" + catId + "/" + id);
      };

      $scope.gotoFThread = function (id, catId, subcatid) {
        $location.path("forumthread/" + catId + "/" + subcatid + "/" + id);
      };

      $scope.getVoting = function () {
        $location.path(
          "/getBillVoteRecords/" + $scope.userId + "/" + $routeParams.type
        );
      };

      $scope.getIndustrySupport = function (yr) {
        MyService.ConsoleLog("In getIndustrySupport : ");
        if ($scope.memberCrpId) {
          var data = {};
          data.crpid = $scope.memberCrpId;
          data.year = yr;
          MyService.getIndustryData(data).then(
            function (res) {
              MyService.ConsoleLog("res : ", res);
              $scope.industrySupport = res.data.data.industries;
              $scope.currentContent = "industrysupport";
              var cy = new Date().getFullYear();
              if (
                $scope.industrySupport["@attributes"].cycle == cy &&
                yr != cy
              ) {
                $scope.msg = "There are no records for " + yr + "";
                $scope.industrySupport = [];
              } else {
                $scope.msg = "";
              }
              //$scope.supportYear = $scope.industrySupport['@attributes'].cycle - 2;
            },
            function (err) {
              MyService.ConsoleLog("err : ", err);
              $scope.supportYear = new Date().getFullYear();
            }
          );
        }
      };

      $scope.personalHoldings = function () {
        MyService.ConsoleLog("In personalHoldings : " + $scope.memberCrpId);
        if ($scope.memberCrpId) {
          var data = {};
          data.crpid = $scope.memberCrpId;
          MyService.getPersonalHoldings(data).then(
            function (res) {
              MyService.ConsoleLog("personalHoldings res : ", res);
              $scope.personalHoldingData = res.data.data;

              $scope.currentContent = "personalHoldings";
            },
            function (err) {
              MyService.ConsoleLog("err : ", err);
            }
          );
        }
      };
      $scope.fundRaising = function () {
        MyService.ConsoleLog("In fundRaising : " + $scope.memberCrpId);
        if ($scope.memberCrpId) {
          var data = {};
          data.crpid = $scope.memberCrpId;
          MyService.getFundRaising(data).then(
            function (res) {
              MyService.ConsoleLog("fundRaising res : ", res);
              $scope.fundRaisingData = res.data.data.summary["@attributes"];
              $scope.currentContent = "fundRaising";
            },
            function (err) {
              MyService.ConsoleLog("err : ", err);
            }
          );
        }
      };

      $scope.topContributor = function (yr) {
        MyService.ConsoleLog("In topContributor : " + yr);
        $scope.contYear = yr;
        if ($scope.memberCrpId) {
          var data = {};
          data.crpid = $scope.memberCrpId;
          data.year = yr;
          MyService.getTopContributor(data).then(
            function (res) {
              MyService.ConsoleLog("topContributor res : ", res);
              $scope.topContributorData = res.data.data.contributors;
              var cy = new Date().getFullYear();
              if (
                $scope.topContributorData["@attributes"].cycle == cy &&
                yr != cy
              ) {
                $scope.msg = "There are no records for " + yr + "";
                $scope.topContributorData = [];
              } else {
                $scope.msg = "";
              }
              //$scope.contYear = $scope.topContributorData['@attributes'].cycle - 2;
            },
            function (err) {
              MyService.ConsoleLog("err : ", err);
              $scope.contYear = new Date().getFullYear();
            }
          );
        }
      };

      /**
       * @description Get Followers count for public profile
       */
      $scope.getFollowers = function () {
        MyService.getFollowerForPublic({
          uId: $scope.userId,
        }).then(
          function (APIResponse) {
            MyService.ConsoleLog("APIResponse", APIResponse);
            if (APIResponse.data.success) {
              $scope.followersCnt = APIResponse.data.data.followersCount;
            }
          },
          function (err) {
            MyService.ConsoleLog("err", err);
          }
        );
      };

      $scope.getRatingData = function (politicianId) {
        MyService.ConsoleLog("In getRatingData");
        var data = {};
        data.id = politicianId;
        MyService.ConsoleLog("data params: ", data);
        MyService.getRatingData(data).then(
          function (res) {
            MyService.ConsoleLog("getRatingData result : ", res);
            if (res.data.success) {
              $scope.ratingsData = res.data.data;
              $scope.getFollowers();
            }
          },
          function (err) {
            MyService.ConsoleLog("getRatingData error > ", err);
          }
        );
      };

      if ($routeParams.id != "") {
        $scope.getData();
        $scope.getProbublicaData();

        $timeout(function () {
          $scope.topContributor($scope.contYear);
        }, 3000);
      }

      $scope.showPreviousYearRole = function (id, type) {
        MyService.ConsoleLog("current role : " + $scope.currentRole);
        MyService.ConsoleLog("allRoles : " + $scope.allRoles);
        //if ($scope.currentRole < $scope.allRoles) {
        $scope.currentRole = $scope.currentRole + 1;
        if (type == "legislation") {
          $scope.memberRole = $scope.propublicaData.roles[id];
        } else {
          $scope.memberRoleCommittee = $scope.propublicaData.roles[id];
          $scope.arrangeComitteeData();
        }
        /*if ($scope.memberRole.at_large) {
        if ($scope.memberRole.at_large == true) {
          $scope.atLarge = 'At large';
        } else {
          $scope.atLarge = "";
        }
      }*/
        //}
      };

      $scope.matchParty = function (letter) {
        if (letter == "D") {
          return "Democrat";
        } else if (letter == "I") {
          return "Independent";
        } else if (letter == "R") {
          return "Republican";
        } else {
          return "Other";
        }
      };

      /**
       * @description FUntion is use redirect to previous page
       */
      $scope.BackToPrev = function () {
        $location.path("/otherPoliticians");
      };

      // $scope.filterItems = function () {
      //   return function (u) {
      //     if (typeof u == 'string') {
      //       var tempArr = [];
      //       console.log("u", u);
      //       tempArr.push(u);
      //       return tempArr;
      //     }
      //   }
      // };
    },
  ]);

'use strict';
angular.module('myApp.privacyPolicy', ['ngRoute'])
  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/privacyPolicy', {
      templateUrl: 'app/privacyPolicy/privacyPolicy.html',
      reloadOnSearch: false,
      controller: 'privacyPolicyCtrl' //we can name anythin
    });
  }])
  .controller('privacyPolicyCtrl', ['$scope', '$rootScope', '$window', function($scope, $rootScope, $window) {
    //this is controller for sampepage.html, we link the conttoler to page in config defination, check above .config
    $rootScope.welcome = false;
    $window.scrollTo(0, 0);
  }]);

'use strict';
angular.module('myApp.printUsers', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
        $routeProvider.when('/print-users', {
            templateUrl: 'app/printUsers/printUsers.html',
            controller: 'PrintUserCtrl'
        });
}])
.controller('PrintUserCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'growl', 'tokenService', 'ngDialog', 'baseApiUrl', '$anchorScroll', 'MyService', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, growl, tokenService, ngDialog, baseApiUrl, $anchorScroll, MyService) {
    //MyService.ConsoleLog("* PrintUserCtrl *", $rootScope.printUsers); 
    $scope.printUsers = [];
    $rootScope.welcome = false;
    if($rootScope.printUsers && $rootScope.printUsers.length > 0){
        angular.forEach($rootScope.printUsers, function (val, key) {
            val.groupByKey = val.office+", "+val.running_for_location;
            $scope.printUsers.push(val);
        });
    }
    // obj.getUserList = function(params, canceler) {
}]);

'use strict';

angular
  .module('myApp.pressProfile', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/pressProfile/:pressId/:type?/:match?', {
        templateUrl: 'app/pressProfile/pressProfile.html',
        controller: 'pressProfileCtrl',
      });
    },
  ])

  .controller('pressProfileCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    '$routeParams',
    '$rootScope',
    'baseApiUrl',
    '$q',
    '$timeout',
    'growl',
    'tokenService',
    '$anchorScroll',
    '$sce',
    'MyService',
    'ngDialog',
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $rootScope,
      baseApiUrl,
      $q,
      $timeout,
      growl,
      tokenService,
      $anchorScroll,
      $sce,
      MyService,
      ngDialog
    ) {
      $rootScope.welcome = false;
      $rootScope.quizzesData = '';
      $rootScope.followersData = '';
      $scope.pressId = $routeParams.pressId;
      var tempArr = [];

      window.localStorage.removeItem('isShowSpecialMatch');
      MyService.ConsoleLog("$rootScope.selectedCompareUsers", $rootScope.selectedCompareUsers);
      // $scope.match = $routeParams.match;
      $scope.showUnFollow = false;
      // $scope.loginUser = tokenService.getUserId();
      $scope.dataType = $routeParams.type;
      MyService.ConsoleLog('$scope.cat_title', $rootScope.cat_title);
      $scope.userType = tokenService.getUserRole();
      if (tokenService.getUserData()) {
        $scope.uData = JSON.parse(tokenService.getUserData());
      }
      window.localStorage.removeItem('isShowPreviousResult');

      window.localStorage.setItem('isShowPreviousResult', true);

      // window.localStorage.removeItem('followData');
      $scope.froumthreads = [];
      $scope.press = {};
      $scope.Sticky = {
        ShowOrder: [],
        txtOrder: [],
      };
      $scope.vote = {
        recommend: 0,
        factual: 0,
      };
      //$scope.GalleryFolder = baseApiUrl + "/resources/" + $scope.uData.uname;
      if (tokenService.getUserData()) {
        $scope.UserData = JSON.parse(tokenService.getUserData());
        MyService.ConsoleLog('$scope.UserData >', $scope.UserData);
      }
      $scope.displayComments = true;
      $scope.Reply = {};

      $scope.checkMemId = function (rdata, val) {
        return rdata.filter(function (rdata) {
          if (rdata.userData._id == $rootScope.UserId) return rdata;
        });
      };

      $scope.CheckUrl = function (url, option) {
        if (url) {
          if (url.indexOf('youtube.com') >= 0) {
            var url = url.replace('watch?v=', 'embed/');
            if (option == 'V')
              return $sce.trustAsHtml(
                '<br/><iframe width="560" height="315" src="' +
                url +
                '" frameborder="0" allowfullscreen></iframe><br/>'
              );
            else
              return $sce.trustAsHtml(
                '<br/><iframe src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>'
              );
          }
          if (url.indexOf('facebook.com') >= 0) {
            if (option == 'V')
              return $sce.trustAsHtml(
                '<br/><iframe src="' +
                url +
                '" width="560" height="315" frameborder="0"></iframe><br/>'
              );
            else
              return $sce.trustAsHtml(
                '<br/><iframe src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>'
              );
          }
          if (url.indexOf('vimeo.com') >= 0) {
            if (url.indexOf('https://vimeo.com/') >= 0) {
              var id = url.replace('https://vimeo.com/', '');
              var newurl = 'https://player.vimeo.com/video/' + id;
            } else {
              var newurl = url;
            }
            if (option == 'V')
              return $sce.trustAsHtml(
                '<br/><iframe src="' +
                newurl +
                '" width="500" height="281" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe><br/>'
              );
            else
              return $sce.trustAsHtml(
                '<br/><iframe src="' +
                newurl +
                '" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe><br/>'
              );
          }
          if (option == 'V')
            return $sce.trustAsHtml(
              '<br/><iframe width="560" height="315" src="' +
              url +
              '" frameborder="0" allowfullscreen></iframe><br/>'
            );
          else
            return $sce.trustAsHtml(
              '<br/><iframe src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>'
            );
        }
      };

      /**
       * get the average of rating for all type of users
       */

      $scope.calculateAvg = function (arr) {
        var reclen = arr.length;
        var recsum = 0;
        for (var r = 0; r < reclen; r++) {
          recsum += parseInt(arr[r].vote, 10);
          if (r == reclen - 1) {
            if (recsum > 0) {
              var recavg = Math.round(recsum / reclen);
            } else {
              var recavg = 0;
            }
            return recavg;
          }
        }
      };

      $scope.chkIfVoted = function (rdata, val) {
        return rdata.filter(function (rdata) {
          // if (!tokenService.getUserId()) {
          //   return rdata;
          // } else {
          //   if (rdata.user.id == val) return rdata;
          // }
          return rdata;
        });
      };
      $scope.loginUser = tokenService.getUserId();
      $scope.getPressDetails = function () {
        //MyService.ConsoleLog("Get One called");
        MyService.getPress($routeParams.pressId).then(
          function (payload) {
            MyService.ConsoleLog('payload', payload);

            if ($scope.UserData && $scope.UserData.followlist.length > 0) {
              var fLen = $scope.UserData.followlist.length;
              for (var f = 0; f < fLen; f++) {
                // MyService.ConsoleLog("$scope.UserData.followlist[f]", $scope.UserData.followlist[f]);
                if ($scope.UserData.followlist[f] == $routeParams.pressId) {
                  $scope.showUnFollow = true;
                  // growl.success("showUnfollow");
                  // alert("showunfollow");
                }
                /*else {
              // MyService.ConsoleLog("userProfile", $scope.userProfile);
              if ($scope.UserData.followlist[f] == $scope.userProfile.officeId) {
                $scope.showUnFollow = true;

              }
            }*/
              }
            }
            if (payload && payload.userData) {
              $scope.pressUserId = payload.userData._id;

              tempArr.push({
                _id: $scope.pressUserId
              });
              $rootScope.selectedCompareUsers = tempArr;
              MyService.getUserPublicProfile({
                id: $scope.pressUserId,
                type: false,
              }).then(function (response) {
                MyService.ConsoleLog('vote', response.data.data);
                $scope.votewiseActivity = response.data.data;
              });
            }

            if (payload && payload.orgdata) {
              $scope.pressUser = payload.userData;
              $scope.press = payload.orgdata;
              tempArr.push({
                _id: $scope.press._id
              });
              $rootScope.selectedCompareUsers = tempArr;
              if (payload.orgdata.recommended) {
                // alert('inside');
                var chkrecommend = $scope.chkIfVoted(payload.orgdata.recommended, $scope.loginUser);
                MyService.ConsoleLog('chkrecommend', chkrecommend);
                // if (chkrecommend && chkrecommend[0]) {
                $scope.vote.recommend = $scope.calculateAvg(chkrecommend);
                // }

              }
              if (payload.orgdata.factual) {
                var chkfactual = $scope.chkIfVoted(payload.orgdata.factual, $scope.loginUser);

                // if (chkfactual && chkfactual[0]) {
                $scope.vote.factual = $scope.calculateAvg(chkfactual);
                // }
              }
            } else {
              $scope.press = payload;
              $scope.pressUser = payload;
              MyService.ConsoleLog(' $scope.press ', $scope.press);
              if (payload.recommended) {
                var chkrecommend = $scope.chkIfVoted(payload.recommended, $scope.loginUser);

                if (chkrecommend && chkrecommend[0]) {
                  $scope.vote.recommend = chkrecommend[0].vote;
                }
              }
              if (payload.factual) {
                var chkfactual = $scope.chkIfVoted(payload.factual, $scope.loginUser);

                if (chkfactual && chkfactual[0]) {
                  $scope.vote.factual = chkfactual[0].vote;
                }
              }
            }
            MyService.getHighlighatedPost({
              pId: $scope.pressId,
            }).then(
              function (response) {
                $scope.getFollowersList();
                MyService.ConsoleLog('response', response);
                $scope.HighlightedPost = response.data;
              },
              function (err) {
                MyService.ConsoleLog('Error', err);
              }
            );
          },
          function (errorPayload) {
            //MyService.ConsoleLog(errorPayload);
            alert('Something went wrong ');
          }
        );
      };

      /**
       * Redirect to discussion page
       */
      $scope.redirectToReviews = function () {
        // growl.success("redirect to discussion");
        $location.path('/orgRating/' + $scope.pressId);
      };

      /**
       * get  followers count and get quizzes count
       */
      $scope.getFollowersList = function () {
        MyService.getFollowersList({
          orgId: $scope.pressId
        }).then(
          function (response) {
            MyService.ConsoleLog('response', response.data);
            $scope.followersCnt = response.data.followersCount;
            $rootScope.followersData = response.data.followersData;
            // window.localStorage.setItem('followData', JSON.stringify(response.data.followersData));
            $scope.questionsCnt = response.data.quizzesCount;
            $rootScope.quizzesData = response.data.quizzesData;
            $scope.quizQuesHasAns = response.data.quesHasAnsCount;
            $scope.getMatch();
          },
          function (err) {
            MyService.ConsoleLog('error', err);
          }
        );
      };


      /**
       * Get Match of questions
       */

      $scope.getMatch = function () {

        MyService.getMatchForPress({
          pressId: $scope.pressId
        }).then(function (result) {
          MyService.ConsoleLog("Result", result);
          if (result && result.length > 0) {
            $scope.match = result[0].match;

          }
        }, function (err) {
          MyService.ConsoleLog("Error", err);
        });
      };

      /**
       * Follow orgnization
       */
      $scope.addtoFollow = function () {
        var data = {};
        data.userId = $scope.loginUser;
        data.pushId = $routeParams.pressId;
        MyService.updateUserFollowList(data).then(
          function (payload) {

            $scope.getPressDetails();
            if ($scope.UserData) {
              $scope.showUnFollow = true;
              $scope.UserData.followlist.push($routeParams.pressId);
              MyService.ConsoleLog('udata : ', $scope.UserData);
              tokenService.saveUserData(JSON.stringify($scope.UserData));
            }
          },
          function (errorPayload) {
            alert('Something went wrong ');
          }
        );
      };

      $scope.getMatchSpecific = function () {

        window.localStorage.setItem('isShowSpecialMatch', true);
        $location.path('/ballotMatch/' + $scope.pressUser._id);
      };

      /**Unfollow organization*/

      $scope.removetoFollow = function () {
        var data = {};
        data.userId = $scope.loginUser;
        data.pushId = $routeParams.pressId;
        MyService.removeUserFollowList(data).then(
          function (result) {
            MyService.ConsoleLog('result', result);

            $scope.showUnFollow = false;
            $scope.getPressDetails();

            var ids = $scope.UserData.followlist.indexOf($routeParams.pressId);
            MyService.ConsoleLog('ids', ids);
            if (ids > -1) {
              $scope.UserData.followlist.splice(ids, 1);
            }

            // else {
            //   var idx = $scope.UserData.followlist.indexOf($scope.userProfile.officeId);
            //   if (idx > -1) {
            //     $scope.UserData.followlist.splice(idx, 1);
            //   }
            // }
            //MyService.ConsoleLog("udata : ", $scope.UserData);
            tokenService.saveUserData(JSON.stringify($scope.UserData));
          },
          function (err) {
            MyService.ConsoleLog('error', err);
          }
        );
      };

      function getCategory() {
        MyService.getCategoryList($routeParams.categoryId).then(
          function (payload) {
            $scope.category = payload;
          },
          function (errorPayload) {
            alert('Something went wrong ');
          }
        );
      }

      // $scope.gotoThread = function (data) {
      //   //MyService.ConsoleLog(data);
      //   var id = '';
      //   if (data.parentId) {
      //     id = data.parentId;
      //   } else {
      //     id = data.id;
      //   }
      //   $location.path('/forumthread/' + id);
      // };
      $scope.gotoThread = function (data, subcatid) {
        var id = '';
        if (data.parentId) {
          id = data.parentId;
        } else if (data.parent) {
          id = data.parent;
        } else {
          if (data.id) {
            id = data.id;
          } else {
            id = data._id;
          }
        }
        // MyService.ConsoleLog(data);
        var categoryId = "";
        if (data.parentCat[0] && data.parentCat[0] != "") {
          categoryId = data.parentCat[0];
        } else {
          if (data.parentCat[1] && data.parentCat[1] != "") {
            categoryId = data.parentCat[1];
          }
        }

        // $rootScope.subcategoryId = subcatid;
        //MyService.ConsoleLog('forumthread/' + categoryId + '/' + subcatid + '/' + id);


        if (categoryId != "") {
          $location.path('forumthread/' + categoryId + '/' + subcatid + '/' + id);
        } else {
          MyService.ConsoleLog("ELSE");
          alert("Something went wrong");
        }


      }

      $scope.updateCommentApi = function (data, options, idex) {
        MyService.updatePressComments(data).then(
          function (payload) {
            if (payload.nModified == 0) {
              alert('You already provided your inputs on this post');
            } else {
              switch (options) {
                case 'like':
                  $scope.essayComments[idex].totalLikes = $scope.essayComments[idex].totalLikes + 1;
                  break;
                case 'dislike':
                  $scope.essayComments[idex].totalDislike =
                    $scope.essayComments[idex].totalDislike + 1;
                  break;
                default:
                  $scope.essayComments[idex].totalSpam = $scope.essayComments[idex].totalSpam + 1;
                  break;
              }
            }
          },
          function (errorPayload) {
            alert('Something went wrong ');
          }
        );
      };

      $scope.updateComments = function (options, id, idex) {
        if ($rootScope.UserId) {
          if ($scope.essayComments[idex].createdBy.id != $rootScope.UserId) {
            var commentData = {};
            commentData.commentId = id;
            commentData.userId = $rootScope.UserId;

            switch (options) {
              case 'like':
                commentData.likes = 1;
                break;
              case 'dislike':
                commentData.dislikes = 1;
                break;
              default:
                commentData.spam = 1;
                break;
            }

            $scope.updateCommentApi(commentData, options, idex);
          } else {
            alert('You cannot ' + options + ' your own comments');
          }
        } else {
          alert('Please login to perform these actions');
        }
      };
      $scope.submitSticky = function (data, id, idx) {
        if (data > 0) {
          updateForum('sticky', id, idx);
        } else {
          alert('Please enter valid order');
        }
      };

      $scope.ShowComments = false;

      $scope.redirectToComment = function () {
        var token = apiCall.getToken();
        if (!token) {
          var message = 'Please login first.';

          var modal = ngDialog.openConfirm({
            template: '<p>' +
              message +
              '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
            plain: true,
          });

          modal.then(
            function fullfilled(data) {
              //MyService.ConsoleLog("fullfilled: ", data);
              $location.path('signin');
            },
            function rejected(data) {
              //MyService.ConsoleLog("rejected: ", data);
              $location.path('signin');
            }
          );
        }
        $scope.ShowComments = true;
        $scope.displayComments = false;

        //$location.path('forumReply/'+$routeParams.categoryId+'/'+$routeParams.subcatId+'/'+$routeParams.essayId);
      };

      $scope.goBack = function () {
        $scope.ShowComments = false;
        $scope.displayComments = true;
      };

      $scope.getComments = function () {
        MyService.getPressComments($routeParams.pressId).then(
          function (payload) {
            $scope.essayComments = payload;
          },
          function (errorPayload) {
            alert('Something went wrong ');
          }
        );
      };

      $scope.SubmitComment = function (rec) {
        //MyService.ConsoleLog(data);
        //MyService.ConsoleLog($scope.mainThread);
        var data = {};
        if (rec.content != '') {
          $scope.TopicButton = true;
          data.createdById = $rootScope.UserId;
          data.createdByName = $rootScope.User;
          data.createdByType = tokenService.getUserRole();
          data.comments = rec.content;
          data.pressId = $routeParams.pressId;
          //MyService.ConsoleLog(data);
          MyService.submitPressComments(data).then(
            function (payload) {
              $scope.comments = {
                content: '',
              };
              $scope.ShowComments = false;
              $scope.displayComments = true;
              $scope.mainThread = {};
              //$location.path('forumthread/'+$routeParams.categoryId+'/'+$routeParams.subcatId+'/'+$routeParams.essayId);
              $scope.getComments();
            },
            function (errorPayload) {
              alert('Something went wrong ');
            }
          );
        } else {
          alert('Please enter comments.');
        }
      };

      $scope.PressVote = function (option) {
        var token = apiCall.getToken();
        if (!token) {
          var message = 'Please login first.';

          var modal = ngDialog.openConfirm({
            template: '<p>' +
              message +
              '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
            plain: true,
          });

          modal.then(
            function fullfilled(data) {
              //MyService.ConsoleLog("fullfilled: ", data);
              $location.path('signin');
            },
            function rejected(data) {
              //MyService.ConsoleLog("rejected: ", data);
              $location.path('signin');
            }
          );
        } else {
          var data = {};
          data._id = $routeParams.pressId;
          data.mediaType = '';
          data.option = option;
          //MyService.ConsoleLog(option);
          if (option == 'Recommended') {
            data.vote = $scope.vote.recommend;
          } else {
            data.vote = $scope.vote.factual;
          }
          data.createdById = $scope.loginUser;
          data.createdByName = tokenService.getUserName();
          data.createdByType = tokenService.getUserRole();
          MyService.updatePress(data).then(
            function (payload) {
              alert('Thank you for rating the press.');
            },
            function (errorPayload) {
              alert('Something went wrong ');
            }
          );
        }
      };

      $scope.getVotesmartPressDetails = function () {
        console.log('getVotesmartPressDetails');
        MyService.getVotesmartPressDetails({
          sigid: $scope.pressId,
        }).then(
          function (payload) {
            console.log('payload1 > ', payload);
            if (payload.data.success) {
              $scope.press = payload.data.data;
            } else {
              alert('Something went wrong ');
            }
          },
          function (epayload) {
            alert('Something went wrong ');
          }
        );
      };

      /**
       * @description Show pop up to select which thread to navigate
       */
      $scope.ShowLoader = false;
      $scope.LatestEssay = [];
      $scope.LatestPost = [];
      $scope.LatestThread = [];
      $scope.gotoPage = function (obj, data) {
        //MyService.ConsoleLog(data);
        switch (obj) {
          case "Essay":
            var userid = data._id;
            $scope.dialogClose = ngDialog.open({
              template: 'LatestEssayId',
              closeByNavigation: true,
              scope: $scope
            });
            $scope.ShowLoader = true;
            MyService.getLatestEssay({
              "userId": userid
            }).then(function (payload) {
              $scope.ShowLoader = false;
              MyService.ConsoleLog("essay", payload);
              $scope.LatestEssay = payload;
            }, function (errorPayload) {
              $scope.ShowLoader = false;
              MyService.ConsoleLog("err vosjs", errorPayload);
              alert("Something went wrong.");
            });
            //$location.path('essayDetails/' + catId + '/' + id);
            break;
          case "EssayComment":
            var userid = data._id;
            $scope.dialogClose = ngDialog.open({
              template: 'LatestEssayCommentId',
              closeByNavigation: true,
              scope: $scope
            });
            $scope.ShowLoader = true;
            MyService.getLatestEssay({
              "userId": userid,
              isEssayComment: true
            }).then(function (payload) {
              if (payload && payload.length > 0) {
                var essayIds = payload.map(function (itms) {
                  if (itms && itms.essayId) {
                    return itms.essayId;
                  }
                });

                MyService.getAllEssaysList({
                  eIds: JSON.stringify(essayIds)
                }).then(function (APIResponse) {
                  MyService.ConsoleLog("APIREs", APIResponse);
                  if (APIResponse.success) {
                    $scope.ShowLoader = false;
                    MyService.ConsoleLog("essay commnent", payload);
                    $scope.LatestEssayComments = APIResponse.data;
                  }
                }, function (err) {
                  MyService.ConsoleLog("Error", err);
                });
              }

            }, function (errorPayload) {
              $scope.ShowLoader = false;
              MyService.ConsoleLog("err vosjs", errorPayload);
              alert("Something went wrong.");
            });


            //$location.path('essayDetails/' + catId + '/' + id);
            break;
          case "Post":
            var userid = data._id;
            // var subcatid = ""
            // if(data.subcategories && data.subcategories.length > 0)
            //var subcatid = data.subcategories[0].pid;
            //var id = data.parent;
            //MyService.ConsoleLog('forumthread/' + catId + '/' + subcatid + '/' + id);
            //$location.path('forumthread/' + catId + '/' + subcatid + '/' + id);
            $scope.dialogClose = ngDialog.open({
              template: 'LatestPostId',
              closeByNavigation: true,
              scope: $scope
            });
            $scope.ShowLoader = true;
            MyService.getLatestPost({
              "userId": userid
            }).then(function (payload) {
              $scope.ShowLoader = false;
              //MyService.ConsoleLog(payload);
              $scope.LatestPost = payload;
            }, function (errorPayload) {
              $scope.ShowLoader = false;
              MyService.ConsoleLog("errorPayload errorPayload", errorPayload);
              alert("Something went wrong.");
            });
            break;
          case "Thread":
            //var catId = data.parentcat[0];
            //var subcatid = ""
            // if(data.subcategories && data.subcategories.length > 0)
            //     var subcatid = data.subcategories[0].pid;
            //var subcatid = data.subcategories[0].pid;
            var userid = data._id;
            $scope.dialogClose = ngDialog.open({
              template: 'LatestThreadId',
              closeByNavigation: true,
              scope: $scope
            });
            $scope.ShowLoader = true;
            MyService.getLatestThread({
              "userId": userid
            }).then(function (payload) {
              $scope.ShowLoader = false;
              //MyService.ConsoleLog(payload);
              $scope.LatestThread = payload;
            }, function (errorPayload) {
              $scope.ShowLoader = false;
              alert('error');
              alert("Something went wrong.");
            });
            //MyService.ConsoleLog('forumthread/' + catId + '/' + subcatid + '/' + id);
            //$location.path('forumthread/' + catId + '/' + subcatid + '/' + id);
            break;
          case "topic of interest":
            MyService.ConsoleLog("data", data);
            MyService.ConsoleLog("data", typeof data);

            MyService.getMultiCategoryByIds({
              ids: data
            }).then(function (APIResponse) {
              MyService.ConsoleLog("APIResponse Its", APIResponse);
              if (APIResponse.data.success) {
                $scope.TopicsOfInterests = APIResponse.data.data;
                $scope.dialogClose = ngDialog.open({
                  template: 'TopicsOfInterest',
                  closeByNavigation: true,
                  scope: $scope
                });
              }
            }, function (err) {
              MyService.ConsoleLog("Errror", err);
            });
            break;
          case 'location of interest':
            $scope.locationOfInterest = data;
            $scope.dialogClose = ngDialog.open({
              template: 'LocationOfInterest',
              closeByNavigation: true,
              scope: $scope
            });
            break;
          default:
            break;
        }

      };

      $scope.gotoComments = function (eId, catId) {
        MyService.ConsoleLog("eid", eId);
        MyService.ConsoleLog("catId", catId);

        // MyService.getEssay(eId).then(function (APIResponse) {
        //   MyService.ConsoleLog("APIResponse", APIResponse);
        if (eId && catId) {
          $location.path('/essayDetails/' + catId + "/" + eId);
        }
      };

      $scope.gotoEssay = function (id, catId) {
        MyService.ConsoleLog("catId", catId);
        $location.path('essayDetails/' + catId + '/' + id);
      }

      $scope.gotoFThread = function (id, catId, subcatid) {
        $location.path('forumthread/' + catId + '/' + subcatid + '/' + id);
      }

      console.log('new', $scope.dataType);
      if ($scope.dataType && $scope.dataType == 'false') {
        $scope.getVotesmartPressDetails();
      } else {
        if ($routeParams.pressId) {
          $scope.getPressDetails();
          $scope.getComments();
        }
      }
    },
  ]);

'use strict';
angular
  .module('myApp.pressHome', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/presshome/:orgtype', {
        templateUrl: 'app/pressHome/pressHome.html',
        controller: 'pressHomeCtrl',
      });
      $routeProvider.when('/presshome/:orgtype/:cat_title/:catId?', {
        templateUrl: 'app/pressHome/pressHome.html',
        controller: 'pressHomeCtrl',
      });
    },
  ])

  .controller('pressHomeCtrl', [
    '$scope',
    '$rootScope',
    '$http',
    '$location',
    'apiCall',
    'MyService',
    'tokenService',
    '$q',
    '$routeParams',
    'ngDialog',
    function (
      $scope,
      $rootScope,
      $http,
      $location,
      apiCall,
      MyService,
      tokenService,
      $q,
      $routeParams,
      ngDialog
    ) {
      $scope.loginUser = tokenService.getUserId();
      $scope.catId = $routeParams.catId;
      MyService.ConsoleLog('$scope.catId', $scope.catId);
      $rootScope.cat_title = $routeParams.cat_title;
      $rootScope.welcome = false;
      $scope.totalUsers = 0;
      $scope.usersPerPage = 25;
      $scope.pagination = {
        current: 1,
      };
      $scope.ratingUp = null;
      $scope.ratingDown = null;
      $scope.ratingUpNew = null;
      $scope.ratingDownNew = null;
      $scope.scrollToTop = function () {
        MyService.ConsoleLog('scroll');
        window.scrollTo(0, 0);
        //$('html, body').animate({scrollTop:100},'25');
      };
      if (tokenService.getUserData()) {
        $scope.allData = JSON.parse(tokenService.getUserData());
        $scope.fData = $scope.allData.followlist;
      }

      $scope.cat_title = $routeParams.cat_title;

      $scope.orgtype = $routeParams.orgtype;
      $scope.press = {
        data: [],
      };
      $scope.locationIntrest = 'usa';
      $scope.sort = {
        recommend: 'All',
        factual: 'All',
        Rfactual: 'All',
        Rrecommend: 'All',
        Trecommend: 'All',
        Tfactual: 'All',
      };

      $scope.calculateAvg = function (arr) {
        var reclen = arr.length;
        var recsum = 0;
        for (var r = 0; r < reclen; r++) {
          recsum += parseInt(arr[r].vote, 10);
          if (r == reclen - 1) {
            if (recsum > 0) {
              var recavg = Math.round(recsum / reclen);
            } else {
              var recavg = 0;
            }
            return recavg;
          }
        }
        //return card.values.opt1 + card.values.opt2;
      };

      function getCount(arr, type) {
        var reclen = arr.length;
        var recsum = 0;
        for (var r = 0; r < reclen; r++) {
          if (arr[r].user.utype == type) {
            recsum += 1;
          }
          if (r == reclen - 1) {
            return recsum;
          }
        }
      }

      $scope.calculateAvgType = function (arr, type) {
        var reclen = arr.length;
        var recsum = 0;
        var finallen = 0;
        for (var r = 0; r < reclen; r++) {
          if (arr[r].user.utype == type) {
            recsum += parseInt(arr[r].vote, 10);
            finallen += 1;
          }
          if (r == reclen - 1) {
            if (recsum > 0) {
              var recavg = Math.round(recsum / finallen);
            } else {
              var recavg = 0;
            }
            return recavg;
          }
        }
        //return card.values.opt1 + card.values.opt2;
      };

      $scope.showPaperRate = 'All';
      $scope.showPaperRRate = 'All';

      var getAllCanceler = $q.defer();
      $scope.page = 0;
      $scope.maxRecordsPerPg = 30;
      $scope.statusGetAll = 0;
      $scope.press.data = [];
      $scope.totalLen = 1;
      $scope.myPagingFunction = function () {
        MyService.ConsoleLog('scoll called', $scope.statusGetAll);
        MyService.ConsoleLog('scoll called', $scope.totalLen);
        MyService.ConsoleLog('scoll called', $scope.press.data.length);

        if ($scope.statusGetAll != 1 && $scope.totalLen > $scope.press.data.length) {
          $scope.page++;
          $scope.pageChanged($scope.page);
        }
      };

      $scope.pageChanged = function (newPage) {
        $scope.getAll(newPage);
      };

      $scope.getAll = function (pageNumber) {
        var param = {
          type: $routeParams.orgtype,
        };
        if ($routeParams.cat_title) {
          //for advocate page we need category
          param.topic = $routeParams.cat_title;
        }
        MyService.ConsoleLog("$scope.locationIntrest", $scope.locationIntrest);
        switch ($scope.locationIntrest) {
          case 'International':
            param.location_of_interest = 'International';
            break;
          case 'usa':
            param.location_of_interest = 'usa';
            break;
          case 'state':
            param.location_of_interest = 'state';
            try {
              var userdata = tokenService.getUserData();
              userdata = JSON.parse(userdata);
              // if(userdata.address.state) param.state = userdata.address.state;
              if (userdata.address.statePostalCode)
                param.statePostalCode = userdata.address.statePostalCode;
            } catch (e) {
              //MyService.ConsoleLog("Exception: ", e);
            }
            break;
          case 'county':
            param.location_of_interest = 'county';
            try {
              var userdata = tokenService.getUserData();
              userdata = JSON.parse(userdata);
              // if(userdata.address.state) param.state = userdata.address.state;
              if (userdata.address.statePostalCode)
                param.statePostalCode = userdata.address.statePostalCode;
              if (userdata.address.county) param.county = userdata.address.county;
            } catch (e) {
              //MyService.ConsoleLog("Exception: ", e);
            }
            break;
          case 'local':
            param.location_of_interest = 'local';
            try {
              var userdata = tokenService.getUserData();
              userdata = JSON.parse(userdata);
              // if(userdata.address.state) param.state = userdata.address.state;
              if (userdata.address.statePostalCode)
                param.statePostalCode = userdata.address.statePostalCode;
              if (userdata.address.county) param.county = userdata.address.county;
              if (userdata.address.place) param.place = userdata.address.place;
            } catch (e) {
              //MyService.ConsoleLog("Exception: ", e);
            }
            break;
        }
        MyService.ConsoleLog('$scope.allData', $scope.allData);
        param.page = pageNumber;
        param.max_records = $scope.maxRecordsPerPg;
        if ($scope.allData && $scope.allData != '') {
          param.curId = $scope.allData.id;
        }
        param.catId = $scope.catId;
        //MyService.ConsoleLog("param: ", param);

        getAllCanceler.resolve();
        getAllCanceler = $q.defer();
        $scope.statusGetAll = 1;
        MyService.getAllOrganizationsPaginated(param).then(
          function (payload) {
            //MyService.getAllOrganizations(param).then(function(payload) {
            // $scope.press.data.length = 0;

            var finalData = payload.data;
            // MyService.ConsoleLog("finalData: ", finalData);
            var flen = finalData.length;
            for (var s = 0; s < flen; s++) {
              if (finalData[s].recommended && finalData[s].recommended.length > 0) {
                finalData[s].recavg = $scope.calculateAvg(finalData[s].recommended);
                finalData[s].recavgtotal = finalData[s].recommended.length;
                finalData[s].recavgvoters = $scope.calculateAvgType(
                  finalData[s].recommended,
                  'voter'
                );
                finalData[s].recavgvoterstotal = getCount(finalData[s].recommended.length, 'voter');
                finalData[s].recavgpolitician = $scope.calculateAvgType(
                  finalData[s].recommended,
                  'politician'
                );
                finalData[s].recavgpoliticiantotal = getCount(
                  finalData[s].recommended.length,
                  'politician'
                );
                finalData[s].recavgadvocate = $scope.calculateAvgType(
                  finalData[s].recommended,
                  'advocate'
                );
                finalData[s].recavgadvocatetotal = getCount(
                  finalData[s].recommended.length,
                  'advocate'
                );
                finalData[s].recavgpress = $scope.calculateAvgType(
                  finalData[s].recommended,
                  'press'
                );
                finalData[s].recavgpresstotal = getCount(finalData[s].recommended, 'press');
                MyService.ConsoleLog(
                  ' finalData[s].recavgvoterstotal',
                  finalData[s].recavgvoterstotal
                );
              } else {
                finalData[s].recavg = 0;
                finalData[s].recavgvoters = 0;
                finalData[s].recavgpolitician = 0;
                finalData[s].recavgadvocate = 0;
                finalData[s].recavgpress = 0;
                finalData[s].recavgtotal = 0;
                finalData[s].recavgvoterstotal = 0;
                finalData[s].recavgpoliticiantotal = 0;
                finalData[s].recavgadvocatetotal = 0;
                finalData[s].recavgpresstotal = 0;
              }
              if (finalData[s].factual && finalData[s].factual.length > 0) {
                finalData[s].factfavg = $scope.calculateAvg(finalData[s].factual);
                finalData[s].factfavgtotal = finalData[s].factual.length;
                finalData[s].factfavgvoters = $scope.calculateAvgType(
                  finalData[s].factual,
                  'voter'
                );
                finalData[s].factfavgvoterstotal = getCount(finalData[s].factual, 'voter');
                finalData[s].factfavgpolitician = $scope.calculateAvgType(
                  finalData[s].factual,
                  'politician'
                );
                finalData[s].factfavgpoliticiantotal = getCount(finalData[s].factual, 'politician');
                finalData[s].factfavgadvocate = $scope.calculateAvgType(
                  finalData[s].factual,
                  'advocate'
                );
                finalData[s].factfavgadvocatetotal = getCount(finalData[s].factual, 'advocate');
                finalData[s].factfavgpress = $scope.calculateAvgType(finalData[s].factual, 'press');
                finalData[s].factfavgpresstotal = getCount(finalData[s].factual, 'press');
              } else {
                finalData[s].factfavg = 0;
                finalData[s].factfavgvoters = 0;
                finalData[s].factfavgpolitician = 0;
                finalData[s].factfavgadvocate = 0;
                finalData[s].factfavgpress = 0;
                finalData[s].factfavgtotal = 0;

                finalData[s].factfavgvoterstotal = 0;
                finalData[s].factfavgpoliticiantotal = 0;
                finalData[s].factfavgadvocatetotal = 0;
                finalData[s].factfavgpresstotal = 0;
              }
              //MyService.ConsoleLog("finalData[s] :", finalData[s]);
              // $scope.press.data.push(finalData[s]);
            }

            MyService.ConsoleLog('payload: ', payload);
            $scope.press.data = $scope.press.data.concat(finalData);
            $scope.totalLen = payload.total;

            $scope.press.data.sort(function (a, b) {
              return b.match - a.match;
            });
            //MyService.ConsoleLog("finalData: ", $scope.press.data.length);
            //MyService.ConsoleLog("$scope.press.data: ", $scope.press.data);
            $scope.statusGetAll = 2;
          },
          function (err) {
            //MyService.ConsoleLog("got states error");
            $scope.statusGetAll = 3;
            $scope.page--;
            alert('Something went wrong');
          }
        );
      };
      // $scope.getAll();

      $scope.loadMore = function () {
        $scope.page++;
        $scope.getAll();
      };

      $scope.sorArr = function (val) {
        var sortOrder = '';
        if (val == 'match') {
          MyService.ConsoleLog("called");
          if ($scope.ratingUp == '' || $scope.ratingUp == 'DESC') {
            sortOrder = 'ASC';
            // $scope.reverseSort = "";
            // $scope.reverseSort = "match";
            // if (para == 'factual') {
            $scope.ratingUp = true;
            $scope.ratingDown = false;

            // MyService.ConsoleLog("$scope.press.data", $scope.press.data.length);

            $scope.press.data.sort(function (a, b) {

              if (a && a.match && b && b.match) {
                return a.match - b.match;
              }
            });
          } else {
            sortOrder = 'DESC';
            // $scope.reverseSort = "";
            // $scope.reverseSort = "match";
            $scope.ratingUp = false;
            $scope.ratingDown = true;

            // MyService.ConsoleLog("$scope.press.data", $scope.press.data.length);
            $scope.press.data.sort(function (a, b) {
              if (a && a.match && b && b.match) {
                return b.match - a.match;
              }
            });
          }
        } else {
          MyService.ConsoleLog("called");
          if ($scope.nameUp == '' || $scope.nameUp == 'DESC') {
            sortOrder = 'ASC';
            // $scope.reverseSort = "";
            // $scope.reverseSort = "match";
            // if (para == 'factual') {
            $scope.nameUp = true;
            $scope.nameDown = false;

            // MyService.ConsoleLog("$scope.press.data", $scope.press.data.length);

            $scope.press.data.sort(function (a, b) {

              if (a && a.title && b && b.title) {
                var x, y;
                x = a.title.toLowerCase();
                y = b.title.toLowerCase();

                if (x < y) {
                  return -1;
                }
                if (x > y) {
                  return 1;
                }
                return 0;
              }
            });
          } else {
            sortOrder = 'DESC';
            // $scope.reverseSort = "";
            // $scope.reverseSort = "match";
            $scope.nameUp = false;
            $scope.nameDown = true;

            // MyService.ConsoleLog("$scope.press.data", $scope.press.data.length);
            $scope.press.data.sort(function (a, b) {
              if (a && a.title && b && b.title) {

                var xs = a.title.toLowerCase();
                var ys = b.title.toLowerCase();
                if (xs > ys) {
                  return -1;
                }
                if (xs < ys) {
                  return 1;
                }
                return 0;
              }
            });
          }
        }
      };

      $scope.intrestChange = function () {
        //MyService.ConsoleLog("intrestChange: ", $scope.locationIntrest);
        $scope.page = 0;
        $scope.press.data = [];
        $scope.totalLen = 1;
        // $scope.getAll();
        $scope.myPagingFunction();
      };

      $scope.paperFilter = function (item) {
        return item.orgtype.toLowerCase() === 'paper' || item.orgtype.toLowerCase() === 'magazine';
      };

      $scope.tvFilter = function (item) {
        return item.orgtype.toLowerCase() === 'tv';
      };

      $scope.radioFilter = function (item) {
        return item.orgtype.toLowerCase() === 'radio';
      };

      $scope.checkIfChecked = function (item) {
        if (item.followerUsers.indexOf($scope.loginUser) > -1) {
          var idx = $scope.followArr.indexOf(item._id);
          if (idx == -1) {
            $scope.followArr.push(item._id);
          }
          return true;
        } else {
          return false;
        }
      };

      $scope.followArr = [];
      $scope.addFollow = function (item) {
        var id = item._id;
        var idx = $scope.followArr.indexOf(id);
        if (idx == -1) {
          $scope.followArr.push(id);
        }
        //MyService.ConsoleLog($scope.followArr);
      };

      $scope.setLocation = function (state) {
        //MyService.ConsoleLog(" setLocation ");
        // $scope.getAll(state);
      };

      $scope.updateFollow = function () {
        //MyService.ConsoleLog($scope.followArr);
        var token = apiCall.getToken();
        if (!token) {
          var message = 'Please login first.';

          var modal = ngDialog.openConfirm({
            template: '<p>' +
              message +
              '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
            plain: true,
          });

          modal.then(
            function fullfilled(data) {
              //MyService.ConsoleLog("fullfilled: ", data);
              $location.path('signin');
            },
            function rejected(data) {
              //MyService.ConsoleLog("rejected: ", data);
              $location.path('signin');
            }
          );
        } else {
          if ($scope.followArr.length > 0) {
            var data = {};
            data.followlist = JSON.stringify($scope.followArr);
            data.userId = $scope.loginUser;
            //alert("This is not implemented yet");
            //MyService.ConsoleLog(data);
            MyService.addToMyFollow(data).then(
              function (payload) {
                // $scope.getAll();
                alert('Items added to your Follow List');
              },
              function (err) {
                alert('Something went wrong try again.');
              }
            );
          } else {
            alert('Please select atleast one record');
          }
        }
      };

      // $scope.getAll('International');
    },
  ]);

'use strict';
angular.module('myApp.pressEssayUpdate', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/pressEssayUpdate/:categoryId/:eid', {
        templateUrl: 'app/pressEssayUpdate/essayUpdate.html',
        controller: 'PressEssayUpdateCtrl'
    });
}])
.controller('PressEssayUpdateCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'growl', 'tokenService', 'ngDialog', 'baseApiUrl', '$anchorScroll', 'MyService', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, growl, tokenService, ngDialog, baseApiUrl, $anchorScroll, MyService) {
    //MyService.ConsoleLog("** PressEssayUpdateCtrl **");
    $scope.EssayButton = false;
    $rootScope.welcome = false;
    $scope.location = ['International', 'National', 'State', 'County', 'Local'];
    $scope.uData = JSON.parse(tokenService.getUserData());
    $scope.mediaType = ['Text', 'Video', 'Stills', 'Audio'];

    $scope.tinymceOptions = {
        plugins: [
            'advlist autolink lists link image charmap print preview hr anchor pagebreak',
            'searchreplace wordcount visualblocks visualchars code fullscreen',
            'insertdatetime media nonbreaking save table contextmenu directionality',
            'emoticons template paste textcolor colorpicker textpattern imagetools'
        ],
        toolbar: ''
    };

    $scope.subtopics = {
        subcategories: []
    };
    $scope.AddLocation = false;
    $scope.newlocation = {
        country: ''
    };
    $scope.Essay = {
        title: '',
        description: '',
        location: '',
        mediaType: 'Text',
        subcategories: []
    };

    $scope.restrictedOptions = ['Locals Only', 'No Restrictions'];

    $scope.selectedCat = [];
    $scope.SelectedTree = [];
    $scope.disabled = [];
    $scope.Allcountries = [];
    $scope.SelectedCountry = '';

    $scope.ShowAddLocation = function() {
        if (!$scope.AddLocation) {
            $scope.AddLocation = true;
        } else {
            $scope.AddLocation = false;
        }

    }

    $scope.getEssay = function() {
        MyService.getPressEssay($routeParams.eid).then(function(payload) {
            //MyService.ConsoleLog("Got Essay: ", response);
            $scope.getAllStates();
            var subcatdata = payload;
            //MyService.ConsoleLog("Essay : ", subcatdata);
            $scope.Essay = subcatdata;
            var locations = subcatdata.locationSpecific;
            var catArr = subcatdata.parentCat;
            //MyService.ConsoleLog(catArr[0].split(","));
            $scope.disabled = subcatdata.parentCat;
            $scope.SelectedTree = subcatdata.subCategories;
            //MyService.ConsoleLog($scope.disabled);
            var len = locations.length;
            $scope.selectedArea.length = 0;
            $scope.showSubCat = true;
            $scope.disabledLocation.length = 0;
            for (var l = 0; l < len; l++) {
                var nobj = {};
                if (locations[l].country) {
                    nobj.country = locations[l].country;
                }
                if (locations[l].state) {
                    nobj.state = locations[l].state;
                    nobj.statePostalCode = locations[l].statePostalCode;
                }
                if (locations[l].county) {
                    nobj.county = locations[l].county;
                }
                if (locations[l].countySubdivision) {
                    nobj.countySubdivision = locations[l].countySubdivision;
                }
                if (locations[l].place) {
                    nobj.place = locations[l].place;
                }
                $scope.selectedArea.push(nobj);
                $scope.disabledLocation.push(nobj);
            }

            $scope.getSubcatTree();

        }, function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
        });
    }

    function suggest_country(term) {
        var q = term.toLowerCase().trim();
        var results = [];
        var len = $scope.Allcountries.length;
        // Find first 10 states that start with `term`.
        for (var i = 0; i < len && results.length < 10; i++) {
            var country = $scope.Allcountries[i];
            if (country.toLowerCase().indexOf(q) === 0)
                results.push({ label: country, value: country });
        }
        return results;
    }

    $scope.autocomplete_options = {
        suggest: suggest_country
    };

    $scope.getAllStates = function() {
        MyService.getAllStates().then(function(payload) {
                $scope.allLocations.length = 0;
                var subcatdata = payload;
                //MyService.ConsoleLog("countires : ", subcatdata);
                $scope.allLocations = subcatdata;


            },
            function(errorPayload) {
                alert('Something went wrong ');
            });

    }

    $scope.getVal = function(data) {
        //MyService.ConsoleLog(data);
        var idx = $scope.selectedCat.indexOf(data);
        if (idx > -1) {
            $scope.selectedCat.splice(idx, 1);
            var id = $scope.disabled.indexOf(data._id);
            $scope.disabled.splice(id, 1);
            var jdx = $scope.SelectedTree.indexOf(data.parentIds);
            if (jdx > -1)
                $scope.SelectedTree.splice(jdx, 1);

        } else {
            $scope.selectedCat.push(data);
            var id = $scope.disabled.indexOf(data._id);
            if (id == -1) {
                $scope.disabled.push(data._id);

            }
            //MyService.ConsoleLog(data.parentIds);
            //MyService.ConsoleLog("SelectedTree: ", $scope.SelectedTree);
            if ($scope.SelectedTree.length == 0) {
                if (data.parentIds.length > 0) {
                    //var parents = Object.keys(data.parentIds).map(function (key) {return data.parentIds[key]});
                    //angular.copy(data.parentIds, $scope.SelectedTree);
                    var parents = data.parentIds;
                    //MyService.ConsoleLog(parents);
                    $scope.SelectedTree = parents;
                }
            } else {
                if (data.parentIds.length > 0) {
                    //var parents = Object.keys(data.parentIds).map(function (key) {return data.parentIds[key]});
                    //var parents = angular.copy(data.parentIds);
                    var parents = data.parentIds;
                    var plen = parents.length;
                    for (var j = 0; j < plen; j++) {
                        $scope.SelectedTree.push(parents[j]);
                    }
                }
            }
        }
        //MyService.ConsoleLog($scope.SelectedTree);
    }


    $scope.selectedAll = {
        id: []
    };

    $scope.removeVal = function(data) {
        var idx = $scope.selectedCat.indexOf(data);
        if (idx > -1) {
            $scope.selectedCat.splice(idx, 1);
            var id = $scope.disabled.indexOf(data._id);
            $scope.disabled.splice(id, 1);
            var parents = data.parentIds;
            var plen = parents.length;
            for (var j = 0; j < plen; j++) {
                var jdx = $scope.SelectedTree.indexOf(parents[j]);
                if (jdx > -1)
                    $scope.SelectedTree.splice(jdx, 1);
            }
        }
        $scope.selectedAll.id.length = 0;
        //MyService.ConsoleLog($scope.SelectedTree);
    }

    $scope.selectConfig = {
        requiredMin: 1,
        selectAll: true
    };

    $scope.checksubCatExists = function(rdata, val) {
        return rdata.filter(
            function(rdata) {
                if (rdata._id == val)
                    return rdata
                else if (rdata.subCategories) {
                    $scope.checksubCatExists(rdata.subcategories, val)
                }
            }
        );
    }

    $scope.checkCatExists = function(rdata, val) {
        return rdata.filter(
            function(rdata) {
                if (rdata._id == val) {
                    $scope.selectedCat.push(rdata);
                    return rdata
                } else if (rdata.subcategories) {
                    $scope.checkCatExists(rdata.subcategories, val)
                }
            }
        );
    }

    $scope.getSubcatTree = function() {
        $scope.selectedCat.length = 0;
        $scope.EssayButton = true;
        MyService.getAllCatTree({ "type": "E" }).then(function(payload) {
                $scope.subtopics.subcategories.length = 0;
                var subcatdata = payload;
                //MyService.ConsoleLog("subcatdata : ", subcatdata);
                $scope.subtopics.subcategories = subcatdata;
                var selectedCat = $scope.disabled;
                if (selectedCat.length > 0) {
                    for (var s = 0; s < selectedCat.length; s++) {
                        var checkcatdata = $scope.checkCatExists(subcatdata, selectedCat[s]);
                    }
                    //MyService.ConsoleLog($scope.selectedCat);
                }
                $scope.EssayButton = false;
                setTimeout(function() {
                    var cols = document.getElementsByClassName('cmnUL');
                    var clen = cols.length;
                    for (var i = 0; i < clen; i++) {
                        cols[i].style.display = "none";
                    }
                }, 300);
            },
            function(errorPayload) {
                alert('Something went wrong ');
            });

    }
    $scope.allLocations = [];
    $scope.allCounties = [];
    $scope.selectedArea = [];
    $scope.rmselectedArea = [];
    $scope.myselectionarea = [];
    $scope.disabledLocation = [];

    $scope.checkExists = function(rdata, val) {
        return rdata.filter(
            function(rdata) {
                if (rdata.state == val)
                    return rdata
            }
        );
    }

    $scope.checkCountyExists = function(rdata, val) {
        return rdata.filter(
            function(rdata) {
                if (rdata.county == val)
                    return rdata
            }
        );
    }

    $scope.checkCountryExists = function(rdata, val) {
        return rdata.filter(
            function(rdata) {
                if (rdata.country == val)
                    return rdata
            }
        );
    }

    function areEqual() {
        var len = arguments.length;
        for (var i = 1; i < len; i++) {
            if (arguments[i] == null || arguments[i] != arguments[i - 1])
                return false;
        }
        return true;
    }

    function indexOfExt(list, item) {
        var len = list.length;

        for (var i = 0; i < len; i++) {
            var keys = Object.keys(list[i]);
            var flg = true;
            var arr = [];


            for (var j = 0, s = 1; j < keys.length; j++, s++) {
                var value = list[i][keys[j]];
                if (item[keys[j]] !== value) {
                    flg = false;

                }

                if (item[keys[j]] == value) {
                    arr.push(flg);
                }


            }
            if (flg == true) {
                if (areEqual(arr.length, keys.length, Object.keys(item).length)) {
                    return i;
                }

            }


        }
        return -1;
    }

    $scope.checkDisabled = function(data, stateId, type) {

        data.country = "United States of America";
        data.state = stateId;

        var idx = indexOfExt($scope.disabledLocation, data);
        if (idx > -1)
            return true;
        else
            return false;


    }

    $scope.getAreaVal = function(data, stateId, type) {

        if (!data.country) {
            data.country = "United States of America";
        }
        if (!data.state) {
            data.state = stateId;
        }



        var idx = indexOfExt($scope.selectedArea, data);


        if (idx > -1) {
            alert("You have already selected the location");
        } else {

            $scope.selectedArea.push(data);
            $scope.disabledLocation.push(data);

        }

        //MyService.ConsoleLog($scope.disabledLocation);
    }
    $scope.selectedLAll = {
        id: []
    };
    $scope.removeAreaVal = function(data) {
        var idx = $scope.selectedArea.indexOf(data);

        //MyService.ConsoleLog($scope.Essay.Locations);
        if (idx > -1) {
            //MyService.ConsoleLog("Country:",$scope.selectedArea[idx].country);
            if ($scope.selectedArea[idx].country == "International") {
                $scope.Essay.Locations = 'NO';
            }
            if ($scope.selectedArea[idx].country == "National (USA)") {
                $scope.Essay.National = 'NO';
            }
            $scope.selectedArea.splice(idx, 1);
            var jdx = $scope.disabledLocation.indexOf(data);
            if (jdx > -1) {
                $scope.disabledLocation.splice(jdx, 1);
            }
        }
        $scope.selectedLAll.id.length = 0;
        //MyService.ConsoleLog($scope.selectedArea);

    }
    $scope.allCounties = [];
    $scope.allLocals = [];
    $scope.setLocation = function(option) {
        $scope.Essay.location = option;
    }
    $scope.getLocations = function(val, type) {
        if (type == "National") {
            if (val == "National") {

                var nobj = {
                    country: "National (USA)"
                }
                $scope.selectedArea.push(nobj);
                //MyService.ConsoleLog($scope.selectedArea);
            }
            if (val == "NO") {

                var nobj = {
                    country: "National (USA)"
                }
                var idx = indexOfExt($scope.selectedArea, nobj);
                if (idx > -1) {
                    $scope.selectedArea.splice(idx, 1);
                }
            }
        } else if (type == "International") {
            if (val == "International") {
                // $scope.selectedArea.length = 0;
                var nobj = {
                    country: "International"
                }
                $scope.selectedArea.push(nobj);

            }
            if (val == "NO") {
                // $scope.selectedArea.length = 0;
                var nobj = {
                    country: "International"
                }
                var idx = indexOfExt($scope.selectedArea, nobj);
                if (idx > -1) {
                    $scope.selectedArea.splice(idx, 1);
                }
            }
        }
    }

    $scope.AddCountry = function() {
        if (($scope.newlocation.country) && ($scope.newlocation.country != '')) {
            var idx = $scope.Allcountries.indexOf($scope.newlocation.country);
            if (idx > -1) {
                var nobj = {
                    country: $scope.newlocation.country
                };
                $scope.selectedArea.push(nobj);
            } else {
                alert("Country does not exists in our database. Please check if you have entered correct name.");
            }
        } else {
            alert("Please enter country name");
        }
    }

    $scope.getCounties = function(state) {
        $scope.showLoading.push(state);
        if (!$scope.allCounties[state] || $scope.allCounties[state].length == 0) {
            MyService.getAllCounties(state).then(function(payload) {
                    $scope.showLoading.length = 0;
                    var sublocations = payload;
                    if (!$scope.allCounties) {
                        $scope.allCounties = [];
                    }
                    $scope.allCounties[state] = sublocations;
                },
                function(errorPayload) {
                    alert('Something went wrong.');
                });

        } else {
            $scope.showLoading.length = 0;
            $scope.allCounties[state].length = 0;
        }
    }

    $scope.getLocals = function(state, county) {
        $scope.showLoadingCounty.push(county);
        if (!$scope.allLocals[state] || !$scope.allLocals[state][county] || $scope.allLocals[state][county].length == 0) {
            MyService.getAllSubCountiesLocal(state, county).then(function(payload) {
                    $scope.showLoadingCounty.length = 0;
                    //MyService.ConsoleLog("sublocations Locals : ", sublocations);
                    if (!$scope.allLocals[state]) {
                        $scope.allLocals[state] = [];
                    }
                    $scope.allLocals[state][county] = payload;
                },
                function(errorPayload) {
                    alert('Something went wrong ');
                });
        } else {
            $scope.showLoadingCounty.length = 0;
            $scope.allLocals[state][county].length = 0;
        }
    }

    if (!$rootScope.UserId) {
        $location.path('signin');
    }

    if (window.localStorage.getItem("VoteWiseEssayCategory")) {
        $rootScope.allEssaycategories = JSON.parse(window.localStorage.getItem("VoteWiseEssayCategory"));
        var idx = $rootScope.allEssaycategories.indexOf($routeParams.subcatId);
        if (idx == -1) {
            $rootScope.allEssaycategories.push($routeParams.subcatId);
            window.localStorage.setItem("VoteWiseEssayCategory", JSON.stringify($rootScope.allEssaycategories));
        }
    }

    $scope.showSubCat = true;
    $scope.showLoading = [];
    $scope.showLoadingCounty = [];
    $scope.showDown = [];
    $scope.ChangeShow = function(id) {
        //$scope.showSubCat = true;
        //var cols = document.getElementsByClassName('cmnUL');
        //var clen = cols.length;

        var nclass = "MainCatLi_" + id;
        if ((document.getElementsByClassName(nclass)[0].style.display) && (document.getElementsByClassName(nclass)[0].style.display == "none")) {
            document.getElementsByClassName(nclass)[0].style.display = "block";
        } else {
            document.getElementsByClassName(nclass)[0].style.display = "none";
        }

        /*
        for (var i = 0, j = 1; i < clen; i++, j++) {

            if (cols[i].style.display == "none") {


                if (j == clen) {
                    var nclass = "MainCatLi_" + id;
                    if ($scope.showDown.length > 0 && $scope.showDown[0] == id) {

                        document.getElementsByClassName(nclass)[0].style.display = "none";
                        $scope.showDown.splice(0, 1);
                        $scope.showDown.length = 0;

                    } else {
                        $scope.showDown.splice(0, 1);
                        $scope.showDown.length = 0;

                        $scope.showDown.push(id);
                        document.getElementsByClassName(nclass)[0].style.display = "block";
                    }

                    var idx = $location.hash();
                    $location.hash(id);
                    $anchorScroll();
                    $location.hash(idx);

                    
                }
                


            } else {
                cols[i].style.display = 'none';
            }

        }
        */

    }


    $scope.UpdateEssay = function(data) {


        if ($.fn.validateForceFully($("#topicform")) == true) {
            if (($scope.disabled.length == 0) || ($scope.SelectedTree == 0)) {
                alert("Please select atleast one Tag");
            } else {
                $scope.EssayButton = true;
                if (data.mediaType == 'Stills') {
                    //MyService.ConsoleLog(data.files);
                    if (data.files) {
                        var fd = new FormData();
                        fd.append('file', data.files);
                        fd.append('essayId', $routeParams.eid);
                        fd.append("parentcat", $scope.disabled);
                        fd.append("subcategories", JSON.stringify($scope.SelectedTree));
                        fd.append("createdById", tokenService.getUserId());
                        fd.append("createdByName", tokenService.getUserName());
                        fd.append("createdByType", tokenService.getUserRole());
                        fd.append("title", data.title);
                        fd.append("description", data.description);
                        fd.append("mediaType", data.mediaType);
                        fd.append("location", data.location);
                        if ($scope.selectedArea.length > 0) {
                            fd.append("locationSpecific", JSON.stringify($scope.selectedArea));
                        }


                        var udata = $scope.uData;
                        var posturl = baseApiUrl + "/essay-press/update?mediaType=" + data.mediaType;

                        $http.post(posturl, fd, {
                                transformRequest: angular.identity,
                                headers: { 'Content-Type': undefined },
                                params: {
                                    'folderName': udata.uname
                                }
                            })
                            .success(function(response, status, headers, config) {
                                $scope.EssayButton = true;
                                //MyService.ConsoleLog("response : ", response);
                                if (response.success) {
                                    $location.path('/essay_press/' + $routeParams.categoryId + '/home');
                                } else {
                                    alert(response.data.error);
                                    if ((response.data.status) && (response.data.status == "405")) {
                                        var msg = "Do you want to send request to Admin to reactivate your account?.";
                                        MyService.GetDialogWithButtons(ngDialog, msg, "YES", "NO").then(function(payload) {
                                            MyService.sendActivatationMailtoAdmin().then(function(payload) {
                                                alert("Request sent successfully to admin");
                                            }, function(errorPayload) {
                                                alert("Something went wrong");
                                            })
                                        }, function(errorPayload) {
                                            //MyService.ConsoleLog(errorPayload);
                                        });
                                    }
                                }
                            })
                            .error(function(data, status, headers, config) {
                                //MyService.ConsoleLog("error");
                            });
                    } else {
                        alert("File is required.");
                    }


                } else {
                    data.essayId = $routeParams.eid;
                    data.parentcat = $scope.disabled;
                    data.subcategories = JSON.stringify($scope.SelectedTree);
                    data.createdById = tokenService.getUserId();
                    data.createdByName = tokenService.getUserName();
                    data.createdByType = tokenService.getUserRole();
                    if ($scope.selectedArea.length > 0) {
                        data.locationSpecific = JSON.stringify($scope.selectedArea);
                    }
                    //MyService.ConsoleLog("data: ", data);

                    var request = apiCall.apiCall('POST', '/essay-press/update?mediaType=' + data.mediaType, data);
                    $http(
                        request
                    ).then(function successCallback(response) {
                        //MyService.ConsoleLog("Got Essay: ", response);
                        $scope.EssayButton = true;
                        if (response.data.success) {
                            $location.path('/essay_press/' + $routeParams.categoryId + '/home');
                        } else {
                           alert(response.data.error);
                            if ((response.data.status) && (response.data.status == "405")) {
                                var msg = "Do you want to send request to Admin to reactivate your account?.";
                                MyService.GetDialogWithButtons(ngDialog, msg, "YES", "NO").then(function(payload) {
                                    MyService.sendActivatationMailtoAdmin().then(function(payload) {
                                        alert("Request sent successfully to admin");
                                    }, function(errorPayload) {
                                        alert("Something went wrong");
                                    })
                                }, function(errorPayload) {
                                    //MyService.ConsoleLog(errorPayload);
                                });
                            }
                        }
                    }, function errorCallBack(response) {
                        //MyService.ConsoleLog("Error: ", response);
                    });
                }

            }


        }

        //alert("This is not implemented yet");
    }
    $scope.MainGallery = [];
    $scope.GalleryFolder = baseApiUrl + "/resources/" + $scope.uData.uname;
    $scope.loadGallery = function() {
        var nrequest = apiCall.apiCall('GET', '/gallery/get', { id: $scope.uData.id });
        $http(
            nrequest
        ).then(function successCallback(responseLatest) {
            if (responseLatest.data.success) {
                $scope.MainGallery = responseLatest.data.data;
            }


        }, function errorCallBack(responseLatest) {

            subCategories.returndata = sampledata;
            $scope.subCategories.push(subCategories);
        });
    }

    $scope.Showgallery = function() {
        ngDialog.open({
            template: 'newEssay/dialogGallery.html',
            width: '650px',
            scope: $scope
        });
        $scope.loadGallery();
    }
    $scope.uploadMedia = false;
    $scope.Gallery = false;
    $scope.uploads = {
        files: '',
        path: ''
    }
    $scope.ChangeMedia = function(option) {
        if (option == "G") {
            $scope.uploadMedia = false;
            $scope.Gallery = true;
        } else {
            $scope.Gallery = false;
            $scope.uploadMedia = true;
        }


    }




    $scope.uploadFile = function() {
        var fd = new FormData();
        //Take the first selected file
        var udata = $scope.uData;
        var urole = JSON.parse(tokenService.getUserData());

        $scope.userData = {
            id: udata.id,
            name: udata.name,
            uname: udata.uname,
            utype: tokenService.getUserRole()
        };
        $scope.uploads.files.fieldname = udata.uname;

        fd.append('file', $scope.uploads.files);
        fd.append("user", JSON.stringify($scope.userData));


        var posturl = baseApiUrl + "/gallery/upload";


        $http.post(posturl, fd, {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined },
            params: {
                'folderName': udata.uname
            }
        })

        .success(function(response, status, headers, config) {

            if (response.data) {
                $scope.loadGallery();
                $scope.ChangeMedia("G");
            }
        })

        .error(function(data, status, headers, config) {
            //MyService.ConsoleLog("error");
        });




    };

    $scope.ShowPath = false;

    $scope.ShowSelectedPath = function(filePath) {
        $scope.uploads.path = $scope.GalleryFolder + "/" + filePath;
        $scope.ShowPath = true;
    }

    $scope.goBack = function() {
        var len = $rootScope.allEssaycategories.length;
        var type = 'home';
        if (len > 2) {
            type = "subcat";
        }
        $location.path('/essay_press/' + $routeParams.categoryId + '/home');
        //$location.path('essay/' + $rootScope.allEssaycategories[len - 2] + '/' + $rootScope.allEssaycategories[len - 1] + "/" + type);



    }




    if (($routeParams.eid) && ($routeParams.categoryId)) {
        $scope.getEssay();
        MyService.getAllCountries().then(function(payload) {
                $scope.Allcountries = payload;
            },
            function(errorPayload) {
                alert('Something went wrong ');
            });




    } else {
        $location.path('/essay_press/' + $routeParams.categoryId);
    }


}]);

'use strict';
angular.module('myApp.pressEssayStaff', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/pressEssayStaff/:categoryId/:subcatId?/:type?', {
        templateUrl: 'app/pressEssayStaff/essayStaff.html',
        controller: 'PressEssayStaff'
    });
}])
.controller('PressEssayStaff', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'baseApiUrl', 'MyService', 'tokenService', 'growl', '$templateCache', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, baseApiUrl, MyService, tokenService, growl, $templateCache) {
    //MyService.ConsoleLog("** PressEssayStaff **");
    $rootScope.welcome = false;
    $scope.imgUrl = baseApiUrl + "/resources";
    $scope.categoryId = $routeParams.categoryId;
    $scope.subcategoryId = $routeParams.subcatId;
    $scope.userId = tokenService.getUserId();
    $scope.userRole = tokenService.getUserRole();
    $scope.userData = JSON.parse(tokenService.getUserData());


    $scope.ShowAdavace = false;
    if ($routeParams.query) {
        $scope.search = {
            text: $routeParams.query,
            subject: '',
            Locations: '',
            mediaoption: [],
            mediaType: '',
            dateBefore: '',
            dateAfter: '',
            matchFrom: '',
            matchTo: '',
            recommendFrom: '',
            recommendTo: '',
            factualFrom: '',
            factualTo: '',
            fromfollowlist: '',
            order: '',
            recommendorder: '',
            lrecommendorder: '',
            factualorder: '',
            lfactualorder: ''

        };
    } else {
        $scope.search = {
            text: '',
            subject: '',
            Locations: '',
            mediaoption: [],
            mediaType: '',
            dateBefore: '',
            dateAfter: '',
            matchFrom: '',
            matchTo: '',
            recommendFrom: '',
            recommendTo: '',
            factualFrom: '',
            factualTo: '',
            fromfollowlist: '',
            recommendorder: '',
            lrecommendorder: '',
            factualorder: '',
            lfactualorder: '',
            order: ''
        };
    }

    $scope.showRefineLocation = false;

    $scope.Location = ["International", "National", "My State", "My County", "My Local", "Other Specific"];
    $scope.mediaType = ['Text', 'Video', 'Stills', 'Audio'];
    $scope.dateRange = ['Today', 'In the last week', 'In the last month', 'In the last year'];
    $scope.users = ["Voters", "Advocates", "Press", "Politicians", "Authors on my follow list"];
    $scope.searchResults = {
        data: []
    };
    $scope.selectedCat = [];
    $scope.subtopics = {
        subcategories: []
    }
    $scope.disabled = [];
    $scope.allLocations = [];
    $scope.allCounties = [];
    $scope.selectedArea = [];
    $scope.rmselectedArea = [];
    $scope.myselectionarea = [];
    $scope.disabledLocation = [];
    $scope.ShowSubcatTree = false;

    $scope.selectConfig = {
        requiredMin: 1,
        selectAll: true
    };


    $scope.getStaffEssayList = function() {
        $scope.searchResults.data.length = 0;
        var nrequest = apiCall.apiCall('GET', '/essay-press/staffEssayList', { maincatId: $routeParams.categoryId, subcatId: $routeParams.subcatId });
        $http(
            nrequest
        ).then(function successCallback(responseLatest) {
            if (responseLatest.data.success) {
                var finalData = responseLatest.data.data;
                var flen = finalData.length;
                //$scope.staffResults.data = finalData;

                for (var s = 0; s < flen; s++) {
                    if (finalData[s].recommended.length > 0) {
                        finalData[s].recavg = $scope.calculateAvg(finalData[s].recommended);
                        finalData[s].recavgvoters = $scope.calculateAvgType(finalData[s].recommended, 'voter');
                        finalData[s].recavgpolitician = $scope.calculateAvgType(finalData[s].recommended, 'politician');
                        finalData[s].recavgadvocate = $scope.calculateAvgType(finalData[s].recommended, 'advocate');
                        finalData[s].recavgpress = $scope.calculateAvgType(finalData[s].recommended, 'press');
                    } else {
                        finalData[s].recavg = 0;
                        finalData[s].recavgvoters = 0;
                        finalData[s].recavgpolitician = 0;
                        finalData[s].recavgadvocate = 0;
                        finalData[s].recavgpress = 0;
                    }
                    if (finalData[s].factual.length > 0) {
                        finalData[s].factfavg = $scope.calculateAvg(finalData[s].factual);
                        finalData[s].factfavgvoters = $scope.calculateAvgType(finalData[s].factual, 'voter');
                        finalData[s].factfavgpolitician = $scope.calculateAvgType(finalData[s].factual, 'politician');
                        finalData[s].factfavgadvocate = $scope.calculateAvgType(finalData[s].factual, 'advocate');
                        finalData[s].factfavgpress = $scope.calculateAvgType(finalData[s].factual, 'press');
                    } else {
                        finalData[s].factfavg = 0;
                        finalData[s].factfavgvoters = 0;
                        finalData[s].factfavgpolitician = 0;
                        finalData[s].factfavgadvocate = 0;
                        finalData[s].factfavgpress = 0;
                    }
                    //MyService.ConsoleLog("finalData[s] :", finalData[s]);
                    $scope.searchResults.data.push(finalData[s]);
                }

            }
        }, function errorCallBack(responseLatest) {
            alert("Error : " + responseLatest);
        });
    }

    $scope.checkCatExists = function(rdata, val) {
        return rdata.filter(
            function(rdata) {
                if (rdata._id == val) {
                    $scope.selectedCat.push(rdata);
                    return rdata
                } else if (rdata.subcategories) {
                    $scope.checkCatExists(rdata.subcategories, val)
                }
            }
        );
    }

    $scope.mainCatTree = [];

    $scope.getSubcatTree = function() {
        //MyService.ConsoleLog($scope.mainCatTree);
        if ($scope.mainCatTree.length == 0) {
            $scope.ShowSubcatTree = true;

            MyService.getAllCatTree().then(function(payload) {
                    $scope.subtopics.subcategories.length = 0;
                    $scope.mainCatTree = angular.copy(payload);
                    var subcatdata = payload;
                    $scope.ShowSubcatTree = false;

                    $scope.subtopics.subcategories = subcatdata;
                    var selectedCat = $scope.disabled;
                    if (selectedCat.length > 0) {
                        for (var s = 0; s < selectedCat.length; s++) {
                            var checkcatdata = $scope.checkCatExists(subcatdata, selectedCat[s]);
                        }
                        //MyService.ConsoleLog($scope.selectedCat);
                    }
                    setTimeout(function() {
                        var cols = document.getElementsByClassName('cmnUL');
                        var clen = cols.length;
                        for (var i = 0; i < clen; i++) {
                            cols[i].style.display = "none";
                        }
                    }, 300);
                },
                function(errorPayload) {
                    alert('Something went wrong ');
                });
        } else {

            //MyService.ConsoleLog("After : " + $scope.subtopics.subcategories.length);
            if ($scope.subtopics.subcategories.length == 0) {
                $scope.subtopics.subcategories = angular.copy($scope.mainCatTree);

            } else {;
                $scope.subtopics.subcategories.length = 0;

            }


            $scope.ShowSubcatTree = false;
            //MyService.ConsoleLog("After : " + $scope.subtopics.subcategories);
            //MyService.ConsoleLog("After : " + $scope.ShowSubcatTree);
        }

    }



    $scope.AllStates = [];
    $scope.allCounties = [];
    $scope.allLocals = [];
    $scope.showSubCat = true;
    $scope.showLoading = [];
    $scope.showLoadingCounty = [];
    $scope.showDown = [];

    $scope.getAllStates = function() {
        $scope.ShowStateLoader = true;
        if ($scope.AllStates.length == 0) {
            MyService.getAllStates().then(function(payload) {
                    $scope.ShowStateLoader = false;
                    $scope.allLocations.length = 0;
                    var subcatdata = payload;
                    $scope.AllStates = angular.copy(subcatdata);
                    //MyService.ConsoleLog("countires : ", subcatdata);
                    $scope.allLocations = subcatdata;
                },
                function(errorPayload) {
                    alert('Something went wrong ');
                });
        } else {
            if (!$scope.showStates) {
                $scope.allLocations.length = 0;
                $scope.ShowStateLoader = false;
            } else {
                $scope.allLocations = angular.copy($scope.AllStates);
                $scope.ShowStateLoader = false;
            }
        }

    }


    $scope.getCounties = function(state) {
        $scope.showLoading.push(state);
        if (!$scope.allCounties[state] || $scope.allCounties[state].length == 0) {

            MyService.getAllCounties(state).then(function(payload) {
                    $scope.showLoading.length = 0;
                    var sublocations = payload;
                    if (!$scope.allCounties) {
                        $scope.allCounties = [];
                    }
                    $scope.allCounties[state] = sublocations;
                },
                function(errorPayload) {
                    alert('Something went wrong.');
                });


        } else {
            $scope.showLoading.length = 0;
            $scope.allCounties[state].length = 0;
        }
    }

    $scope.getLocals = function(state, county) {
        $scope.showLoadingCounty.push(county);
        if (!$scope.allLocals[state] || !$scope.allLocals[state][county] || $scope.allLocals[state][county].length == 0) {

            MyService.getAllSubCountiesLocal(state, county).then(function(payload) {
                    $scope.showLoadingCounty.length = 0;
                    //MyService.ConsoleLog("sublocations Locals : ", sublocations);
                    if (!$scope.allLocals[state]) {
                        $scope.allLocals[state] = [];
                    }
                    $scope.allLocals[state][county] = payload;
                },
                function(errorPayload) {
                    alert('Something went wrong ');
                });


        } else {
            $scope.showLoadingCounty.length = 0;
            $scope.allLocals[state][county].length = 0;
        }
    }





    $scope.showmediaType = false;
    $scope.showDateRange = false;
    $scope.showMatchAuthor = false;
    $scope.showEssayRating = false;
    $scope.showStates = false;
    $scope.showRefine = function(e, option) {
        e.preventDefault();
        switch (option) {
            case "Interest":
                $scope.getSubcatTree();
                break;
            case "Location":
                if (!$scope.showRefineLocation)
                    $scope.showRefineLocation = true;
                else
                    $scope.showRefineLocation = false;

                break;
            case "AllLocation":
                if (!$scope.showStates) {
                    $scope.showStates = true;

                } else {
                    $scope.showStates = false;
                }
                $scope.getAllStates();
                break;
            case "Media":
                if (!$scope.showmediaType)
                    $scope.showmediaType = true;
                else
                    $scope.showmediaType = false;
                break;
            case "Date":
                if (!$scope.showDateRange)
                    $scope.showDateRange = true;
                else
                    $scope.showDateRange = false;
                break;
            case "Author":
                if (!$scope.showMatchAuthor)
                    $scope.showMatchAuthor = true;
                else
                    $scope.showMatchAuthor = false;
                break;
            case "EssayRated":
                if (!$scope.showEssayRating)
                    $scope.showEssayRating = true;
                else
                    $scope.showEssayRating = false;
                break;
            case "Default":
                break;

        }
    }


    $scope.showSubCat = true;
    $scope.showLoading = [];
    $scope.showLoadingCounty = [];
    $scope.showDown = [];
    $scope.ChangeShow = function(id) {
        $scope.showSubCat = true;

        var nclass = "MainCatLi_" + id;
        if ((document.getElementsByClassName(nclass)[0].style.display) && (document.getElementsByClassName(nclass)[0].style.display == "none")) {
            document.getElementsByClassName(nclass)[0].style.display = "block";
        } else {
            document.getElementsByClassName(nclass)[0].style.display = "none";
        }
    }


    function areEqual() {
        var len = arguments.length;
        for (var i = 1; i < len; i++) {
            if (arguments[i] == null || arguments[i] != arguments[i - 1])
                return false;
        }
        return true;
    }

    function indexOfExt(list, item) {
        var len = list.length;

        for (var i = 0; i < len; i++) {
            var keys = Object.keys(list[i]);
            var flg = true;
            var arr = [];


            for (var j = 0, s = 1; j < keys.length; j++, s++) {
                var value = list[i][keys[j]];
                if (item[keys[j]] !== value) {
                    flg = false;

                }

                if (item[keys[j]] == value) {
                    arr.push(flg);
                }


            }
            if (flg == true) {
                if (areEqual(arr.length, keys.length, Object.keys(item).length)) {
                    return i;
                }

            }


        }
        return -1;
    }

    $scope.findLocations = [];
    $scope.Interests = [];
    $scope.MyLocation = [];
    $scope.SelectDefaultLocation = function(val) {
        //MyService.ConsoleLog("Data : ", val);
        var idx = $scope.MyLocation.indexOf(val);
        if (idx == -1) {
            $scope.MyLocation.push(val);
        } else {
            $scope.MyLocation.splice(idx, 1);
        }
        //MyService.ConsoleLog($scope.MyLocation);
    }

    $scope.selectLocation = function(val1, val2, val3, type) {
        //MyService.ConsoleLog(val1, val2, val3, type);
        var nobj = {};
        nobj.country = "United States of America";
        if (type == "state") {
            nobj.state = val1.state;
            nobj.statePostalCode = val1.statePostalCode;
        }
        if (type == "county") {
            nobj.state = val1.state;
            nobj.statePostalCode = val1.statePostalCode;
            nobj.county = val3;
        }
        if (type == "local") {
            nobj.state = val1.state;
            nobj.statePostalCode = val1.statePostalCode;
            nobj.county = val2;
            nobj.countySubdivision = val3.countySubdivision;
            nobj.place = val3.place;
        }
        //MyService.ConsoleLog("nboj:", nobj);
        var idx = indexOfExt($scope.findLocations, nobj);
        if (idx == -1) {
            $scope.findLocations.push(nobj);
        } else {
            $scope.findLocations.splice(idx, 1);
        }
    }



    $scope.getVal = function(data) {
        //MyService.ConsoleLog($scope.Interests);
        var idx = $scope.Interests.indexOf(data._id);
        if (idx == -1) {
            $scope.Interests.push(data._id);
        } else {
            $scope.Interests.splice(idx, 1);
        }
    }

    $scope.totalResults = 0;


    function addslashes(str) {
        return (str + '').replace(/[\\"']/g, '\\$&').replace(/\u0000/g, '\\0');
    }

    function cleanArray(actual) {
        var newArray = new Array();
        for (var i = 0; i < actual.length; i++) {
            if (actual[i]) {
                newArray.push(actual[i]);
            }
        }
        return newArray;
    }

    function allnumeric(inputtxt) {
        var numbers = /^[0-9]+$/;
        if (inputtxt == undefined) {
            return false;
        }
        if (inputtxt.match(numbers)) {
            return true;
        } else {
            return false;
        }
    }

    $scope.calculateAvg = function(arr) {
        var reclen = arr.length;
        var recsum = 0;
        for (var r = 0; r < reclen; r++) {
            recsum += parseInt(arr[r].vote, 10);
            if (r == reclen - 1) {
                var recavg = recsum / reclen;

                return recavg;
            }
        }

        //return card.values.opt1 + card.values.opt2;
    };

    $scope.calculateAvgType = function(arr, type) {
        var reclen = arr.length;
        var recsum = 0;
        for (var r = 0; r < reclen; r++) {
            if (arr[r].user.utype == type) {
                //MyService.ConsoleLog(arr[r].user.utype + "==" + type);
                recsum += parseInt(arr[r].vote, 10);

            }
            if (r == reclen - 1) {
                var recavg = recsum / reclen;

                return recavg;
            }
        }

        //return card.values.opt1 + card.values.opt2;
    };

    $scope.calculateAvgId = function(arr, followlist) {
        var reclen = arr.length;
        var recsum = 0;
        for (var r = 0; r < reclen; r++) {
            var idx = followlist.indexOf(arr[r].user.id)
            if (idx > -1) {
                //MyService.ConsoleLog(arr[r].user.utype + "==" + type);
                recsum += parseInt(arr[r].vote, 10);

            }
            if (r == reclen - 1) {
                var recavg = recsum / reclen;

                return recavg;
            }
        }
    }

    $scope.getEssayListAdvance = function(data) {

        $scope.searchResults.data.length = 0;
        if ($scope.findLocations.length > 0) {
            data.searchlocations = JSON.stringify($scope.findLocations);
        }

        if ($scope.MyLocation.length > 0) {
            data.MyLocation = JSON.stringify($scope.MyLocation);
        }
        if (data.mediaoption) {
            var moption = data.mediaoption;
            if (typeof moption == "object") {
                moption = Object.keys(moption).map(function(key) {
                    return moption[key]
                });
            }
            if (typeof moption != "string") {
                var media = cleanArray(moption);
                data.mediaoption = JSON.stringify(media);
            }
        }
        data.subjectOfInterest = JSON.stringify($scope.Interests);
        var validateMatch = true,
            validateMatchTo = true,
            validateRecommend = true,
            validateTo = true;
        var msg = "";
        if (data.matchFrom != "") {
            validateMatch = allnumeric(data.matchFrom);
            if (($scope.Interests.length == 0) && validateMatch) {
                msg = "Please select atleast one subject of interest";
                validateMatch = false;
            }
        }

        if (data.matchTo != "") {
            validateMatchTo = allnumeric(data.matchTo);
            if (validateMatchTo && ($scope.Interests.length == 0)) {
                msg = "Please select atleast one subject of interest";
                validateMatchTo = false;
            }
        }

        if (data.recommendFrom != "") {
            validateRecommend = allnumeric(data.recommendFrom);
        }
        if (data.recommendTo != "") {
            validateTo = allnumeric(data.recommendTo);
        }

        if (validateMatch && validateMatchTo && validateRecommend && validateTo) {
            $scope.searchResults.data.length = 0;
            $scope.totalResults = 0;
            var nrequest = apiCall.apiCall('POST', '/essay-press/AdvanceSearch', data);
            $http(
                nrequest
            ).then(function successCallback(responseLatest) {
                //MyService.ConsoleLog("Final Advance Data");
                //MyService.ConsoleLog(responseLatest.data.data);
                $scope.searchResults.data.length = 0;
                if (responseLatest.data.success) {
                    var finalData = responseLatest.data.data;
                    //MyService.ConsoleLog("finalData:", finalData.length);
                    var flen = finalData.length;
                    $scope.searchResults.data.length = 0;
                    //MyService.ConsoleLog("Results :", $scope.searchResults.data);
                    $templateCache.removeAll();
                    for (var s = 0; s < flen; s++) {
                        if (finalData[s].recommended.length > 0) {
                            finalData[s].recavg = $scope.calculateAvg(finalData[s].recommended);
                            finalData[s].recavgvoters = $scope.calculateAvgType(finalData[s].recommended, 'voter');
                            finalData[s].recavgpolitician = $scope.calculateAvgType(finalData[s].recommended, 'politician');
                            finalData[s].recavgadvocate = $scope.calculateAvgType(finalData[s].recommended, 'advocate');
                            finalData[s].recavgpress = $scope.calculateAvgType(finalData[s].recommended, 'press');
                            if (userData.followlist.length > 0) {
                                finalData[s].recavgfollow = $scope.calculateAvgId(finalData[s].recommended, userData.followlist);
                            } else {
                                finalData[s].recavgfollow = 0;
                            }

                        } else {
                            finalData[s].recavg = 0;
                            finalData[s].recavgvoters = 0;
                            finalData[s].recavgpolitician = 0;
                            finalData[s].recavgadvocate = 0;
                            finalData[s].recavgpress = 0;
                            finalData[s].recavgfollow = 0;
                        }
                        if (finalData[s].factual.length > 0) {
                            finalData[s].factfavg = $scope.calculateAvg(finalData[s].factual);
                            finalData[s].factfavgvoters = $scope.calculateAvgType(finalData[s].factual, 'voter');
                            finalData[s].factfavgpolitician = $scope.calculateAvgType(finalData[s].factual, 'politician');
                            finalData[s].factfavgadvocate = $scope.calculateAvgType(finalData[s].factual, 'advocate');
                            finalData[s].factfavgpress = $scope.calculateAvgType(finalData[s].factual, 'press');
                            if (userData.followlist.length > 0) {
                                finalData[s].factfavgfollow = $scope.calculateAvgId(finalData[s].recommended, userData.followlist);
                            } else {
                                finalData[s].factfavgfollow = 0;
                            }

                        } else {
                            finalData[s].factfavg = 0;
                            finalData[s].factfavgvoters = 0;
                            finalData[s].factfavgpolitician = 0;
                            finalData[s].factfavgadvocate = 0;
                            finalData[s].factfavgpress = 0;
                            finalData[s].factfavgfollow = 0;
                        }
                        //MyService.ConsoleLog("finalData[s] :", finalData[s]);
                        $scope.searchResults.data.push(finalData[s]);
                    }
                    $scope.totalResults = responseLatest.data.data.length;
                    data.mediaoption = "";
                    data.mediaoption = [];
                    data.mediaoption.length = 0;
                }
            }, function errorCallBack(responseLatest) {
                alert("Error : " + responseLatest);
            });
        } else {
            if (msg != "") {
                alert(msg);
            } else {
                alert("Please enter valid data");
            }

        }
    }
    $scope.ShowOrderList = false;
    $scope.showOrder = function() {
        if (!$scope.ShowOrderList) {
            $scope.ShowOrderList = true;
        } else {
            $scope.ShowOrderList = false;
        }
    }

    $scope.isreverse = false;
    $scope.showAvg = true;
    $scope.showVoters = false;
    $scope.showPolitician = false;
    $scope.showAdvocate = false;
    $scope.showPress = false;
    $scope.showFollow = false;
    $scope.showfAvg = true;
    $scope.showfVoters = false;
    $scope.showfPolitician = false;
    $scope.showfAdvocate = false;
    $scope.showfPress = false;
    $scope.showfFollow = false;
    $scope.resetAllOrder = function() {
        $scope.showAvg = false;
        $scope.showVoters = false;
        $scope.showPolitician = false;
        $scope.showAdvocate = false;
        $scope.showPress = false;
        $scope.showFollow = false;
    }
    $scope.resetAllfOrder = function() {
        $scope.showfAvg = false;
        $scope.showfVoters = false;
        $scope.showfPolitician = false;
        $scope.showfAdvocate = false;
        $scope.showfPress = false;
        $scope.showfFollow = false;
    }

    $scope.sortValues = function(data) {
        var result = "";
        $scope.resetAllOrder();
        $scope.resetAllfOrder();

        $scope.showfAvg = true;
        $scope.showAvg = true;


        switch ($scope.search.order) {
            case "Most Recent":
                $scope.isreverse = true;
                $scope.showAvg = true;
                $scope.showfAvg = true;
                result = data.createdOn;
                break;
            case "Oldest":
                $scope.isreverse = false;
                $scope.showAvg = true;
                $scope.showfAvg = true;
                result = data.createdOn;
                break;
            case "Highest Recommended":
                $scope.resetAllOrder();
                $scope.isreverse = true;
                $scope.showAvg = true;
                $scope.showfAvg = true;
                result = data.recavg;
                break;
            case "Least Recommended":
                $scope.resetAllOrder();
                $scope.isreverse = false;
                $scope.showAvg = true;
                $scope.showfAvg = true;
                result = data.recavg;
                break;
            case "Most Factual":
                $scope.resetAllfOrder();
                $scope.isreverse = true;
                $scope.showAvg = true;
                $scope.showfAvg = true;
                result = data.factfavg;
                break;
            case "Least Factual":
                $scope.resetAllfOrder();
                $scope.isreverse = false;
                $scope.showAvg = true;
                $scope.showfAvg = true;
                result = data.factfavg;
                break;
            case "Default":
                $scope.resetAllOrder();
                $scope.resetAllfOrder();
                $scope.isreverse = true;
                result = data.createdOn;
                $scope.showAvg = true;
                $scope.showfAvg = true;
                break;

        }

        switch ($scope.search.recommendorder) {
            case "Voters":
                $scope.resetAllOrder();
                $scope.showVoters = true;
                $scope.isreverse = true;
                result = data.recavgvoters;
                break;
            case "Politicians":
                $scope.resetAllOrder();
                $scope.showPolitician = true;
                $scope.isreverse = true;
                result = data.recavgpolitician;
                break;
            case "Advocates":
                $scope.resetAllOrder();
                $scope.showAdvocate = true;
                $scope.isreverse = true;
                result = data.recavgadvocate;
                break;
            case "Press":
                $scope.resetAllOrder();
                $scope.showPress = true;
                $scope.isreverse = true;
                result = data.recavgpress;
                break;
            case "Authors on my follow list":
                $scope.resetAllOrder();
                $scope.showFollow = true;
                $scope.isreverse = true;
                result = data.recavgfollow;
                break;
            case "Default":
                $scope.resetAllOrder();
                $scope.showAvg = true;

                break;

        }

        switch ($scope.search.lrecommendorder) {
            case "Voters":
                $scope.resetAllOrder();
                $scope.showVoters = true;
                $scope.isreverse = false;
                result = data.recavgvoters;
                break;
            case "Politicians":
                $scope.resetAllOrder();
                $scope.showPolitician = true;
                $scope.isreverse = false;
                result = data.recavgpolitician;
                break;
            case "Advocates":
                $scope.resetAllOrder();
                $scope.showAdvocate = true;
                $scope.isreverse = false;
                result = data.recavgadvocate;
                break;
            case "Press":
                $scope.resetAllOrder();
                $scope.showPress = true;
                $scope.isreverse = false;
                result = data.recavgpress;
                break;
            case "Authors on my follow list":
                $scope.resetAllOrder();
                $scope.showFollow = true;
                $scope.isreverse = false;
                result = data.recavgfollow;
                break;
            case "Default":
                $scope.resetAllOrder();
                $scope.showAvg = true;
                break;

        }

        switch ($scope.search.factualorder) {
            case "Voters":
                $scope.resetAllfOrder();
                $scope.showfVoters = true;
                $scope.isreverse = true;
                result = data.factfavgvoters;
                break;
            case "Politicians":
                $scope.resetAllfOrder();
                $scope.showfPolitician = true;
                $scope.isreverse = true;
                result = data.factfavgpolitician;
                break;
            case "Advocates":
                $scope.resetAllfOrder();
                $scope.showfAdvocate = true;
                $scope.isreverse = true;
                result = data.factfavgadvocate;
                break;
            case "Press":
                $scope.resetAllfOrder();
                $scope.showfPress = true;
                $scope.isreverse = true;
                result = data.factfavgpress;
                break;
            case "Authors on my follow list":
                $scope.resetAllOrder();
                $scope.showfFollow = true;
                $scope.isreverse = true;
                result = data.factfavgfollow;
                break;
            case "Default":
                $scope.resetAllfOrder();
                $scope.showfAvg = true;
                break;

        }

        switch ($scope.search.lfactualorder) {
            case "Voters":
                $scope.resetAllfOrder();
                $scope.showfVoters = true;
                $scope.isreverse = false;
                result = data.factfavgvoters;
                break;
            case "Politicians":
                $scope.resetAllfOrder();
                $scope.showfPolitician = true;
                $scope.isreverse = false;
                result = data.factfavgpolitician;
                break;
            case "Advocates":
                $scope.resetAllfOrder();
                $scope.showfAdvocate = true;
                $scope.isreverse = false;
                result = data.factfavgadvocate;
                break;
            case "Press":
                $scope.resetAllfOrder();
                $scope.showfPress = true;
                $scope.isreverse = false;
                result = data.factfavgpress;
                break;
            case "Authors on my follow list":
                $scope.resetAllOrder();
                $scope.showfFollow = true;
                $scope.isreverse = false;
                result = data.factfavgfollow;
                break;
            case "Default":
                $scope.resetAllfOrder();
                $scope.showfAvg = true;
                break;

        }
        //MyService.ConsoleLog($scope.search);
        //MyService.ConsoleLog(result);
        return result;

    }

    $scope.HighestRecommended = false;
    $scope.LeastRecommended = false;
    $scope.MostFactual = false;
    $scope.LeastFactual = false;
    $scope.ShowUsers = function(option) {
        switch (option) {
            case "HighestRecommended":
                if (!$scope.HighestRecommended) {
                    $scope.HighestRecommended = true;
                } else {
                    $scope.HighestRecommended = false;
                }
                break;
            case "LeastRecommended":
                if (!$scope.LeastRecommended) {
                    $scope.LeastRecommended = true;
                } else {
                    $scope.LeastRecommended = false;
                }
                break;
            case "MostFactual":
                if (!$scope.MostFactual) {
                    $scope.MostFactual = true;
                } else {
                    $scope.MostFactual = false;
                }
                break;
            case "LeastFactual":
                if (!$scope.LeastFactual) {
                    $scope.LeastFactual = true;
                } else {
                    $scope.LeastFactual = false;
                }
                break;
            case "Default":
                $scope.HighestRecommended = false;
                break;
        }
    }

    $scope.gotoThread = function(data) {
        var id = data;
        //MyService.ConsoleLog(data);
        $location.path('pressEssayDetails/' + $routeParams.categoryId + '/' + id);
    }

    $scope.GotoEdit = function(id) {
        $location.path('/pressEssayUpdate/' + $routeParams.categoryId + '/' + id);
    }


    $scope.showadvace = function() {
        $scope.ShowAdavace = true;
        var query = $scope.search.text;
        $scope.search = {
            text: query,
            subject: '',
            Locations: '',
            mediaoption: [],
            mediaType: '',
            dateBefore: '',
            dateAfter: '',
            matchFrom: '',
            matchTo: '',
            recommendFrom: '',
            recommendTo: '',
            factualFrom: '',
            factualTo: '',
            order: '',
            recommendorder: '',
            lrecommendorder: '',
            factualorder: '',
            lfactualorder: '',
            fromfollowlist: ''
        };
    }

    if ($routeParams.categoryId) {

        $scope.getStaffEssayList();
    }
}]);

'use strict';

angular.module('myApp.pressEssayDetails', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/pressEssayDetails/:categoryId/:essayId/:location?', {
        templateUrl: 'app/pressEssayDetails/essayDetails.html',
        controller: 'PressEssayDetailsCtrl'
    });
}])

.controller('PressEssayDetailsCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', 'baseApiUrl', '$q', '$timeout', 'growl', 'tokenService', '$anchorScroll', '$sce', 'MyService', 'ngDialog', function($scope, $http, $location, apiCall, $routeParams, $rootScope, baseApiUrl, $q, $timeout, growl, tokenService, $anchorScroll, $sce, MyService, ngDialog) {

    //MyService.ConsoleLog("* PressEssayDetailsCtrl *");
    $rootScope.welcome = false;
    $scope.categoryId = $routeParams.categoryId;
    $scope.essayId = $routeParams.essayId;
    $scope.userType = tokenService.getUserRole();
    $scope.uData = JSON.parse(tokenService.getUserData());
    $scope.froumthreads = [];
    $scope.essay = {};
    $scope.Sticky = {
        ShowOrder: [],
        txtOrder: []
    };
    $scope.vote = {
        recommend: 0,
        factual: 0
    };
    $scope.GalleryFolder = baseApiUrl + "/resources/" + $scope.uData.uname;

    $scope.displayComments = true;
    $scope.Reply = {};

    $scope.checkMemId = function(rdata, val) {
        return rdata.filter(
            function(rdata) {
                if (rdata.userData._id == $rootScope.UserId)
                    return rdata
            }
        );
    }


    $scope.CheckUrl = function(url, option) {
        if (url) {
            if (url.indexOf("youtube.com") >= 0) {
                var url = url.replace("watch?v=", "embed/");
                if (option == "V")
                    return $sce.trustAsHtml('<br/><iframe width="560" height="315" src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>');
                else
                    return $sce.trustAsHtml('<br/><iframe src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>');
            }
            if (url.indexOf("facebook.com") >= 0) {
                if (option == "V")
                    return $sce.trustAsHtml('<br/><iframe src="' + url + '" width="560" height="315" frameborder="0"></iframe><br/>');
                else
                    return $sce.trustAsHtml('<br/><iframe src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>');
            }
            if (url.indexOf("vimeo.com") >= 0) {
                if (url.indexOf("https://vimeo.com/") >= 0) {
                    var id = url.replace("https://vimeo.com/", "");
                    var newurl = "https://player.vimeo.com/video/" + id;
                } else {
                    var newurl = url;
                }
                if (option == "V")
                    return $sce.trustAsHtml('<br/><iframe src="' + newurl + '" width="500" height="281" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe><br/>');
                else
                    return $sce.trustAsHtml('<br/><iframe src="' + newurl + '" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe><br/>');
            }
            if (option == "V")
                return $sce.trustAsHtml('<br/><iframe width="560" height="315" src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>');
            else
                return $sce.trustAsHtml('<br/><iframe src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>');
        }

    }

    $scope.chkIfVoted = function(rdata, val) {
        return rdata.filter(
            function(rdata) {
                if (rdata.user.id == val)
                    return rdata

            }
        );
    }
    $scope.loginUser = tokenService.getUserId();
    $scope.getEssayDetails = function() {
        //MyService.ConsoleLog("Get One called");
        MyService.getPressEssay($routeParams.essayId).then(function(payload) {
            $scope.essay = payload;
            //MyService.ConsoleLog("payload:",payload);
            var chkrecommend = $scope.chkIfVoted(payload.recommended, $scope.loginUser);
            //MyService.ConsoleLog("chkrecommend : ", chkrecommend);
            if ((chkrecommend) && (chkrecommend.length > 0)) {
                $scope.vote.recommend = chkrecommend[0].vote;
            }
            var chkfactual = $scope.chkIfVoted(payload.factual, $scope.loginUser);
            if (chkfactual && chkfactual.length > 0) {
                $scope.vote.factual = chkfactual[0].vote;
            }

        }, function(errorPayload) {
            //MyService.ConsoleLog(errorPayload);
            alert('Something went wrong ');
        });

    }



    function getCategory() {
        MyService.getCategoryList($routeParams.categoryId).then(function(payload) {
            $scope.category = payload;

        }, function(errorPayload) {
            alert('Something went wrong ');
        });

    }

    $scope.gotoThread = function(data) {
        //MyService.ConsoleLog(data);
        var id = '';
        if (data.parentId) {
            id = data.parentId;
        } else {
            id = data.id;
        }
        $location('forumthread/' + id);
    }

    $scope.updateCommentApi = function(data, options, idex) {

        MyService.updatePressEssayComments(data).then(function(payload) {
            if (payload.nModified == 0) {
                alert("You already provided your inputs on this post");
            } else {
                switch (options) {
                    case 'like':
                        $scope.essayComments[idex].totalLikes = $scope.essayComments[idex].totalLikes + 1;
                        break;
                    case 'dislike':
                        $scope.essayComments[idex].totalDislike = $scope.essayComments[idex].totalDislike + 1;
                        break;
                    default:
                        $scope.essayComments[idex].totalSpam = $scope.essayComments[idex].totalSpam + 1;
                        break;
                }
            }
        }, function(response) {
            if (response.error) {
                alert(response.error);
                //MyService.ConsoleLog(response);
                if ((response.status) && (response.status == "405")) {
                    var msg = "Do you want to send request to Admin to reactivate your account?.";
                    MyService.GetDialogWithButtons(ngDialog, msg, "YES", "NO").then(function(payload) {
                        MyService.sendActivatationMailtoAdmin().then(function(payload) {
                            alert("Request sent successfully to admin");
                        }, function(errorPayload) {
                            alert("Something went wrong");
                        })
                    }, function(errorPayload) {
                        //MyService.ConsoleLog(errorPayload);
                    });
                }
            }

        });

    }



    $scope.updateComments = function(options, id, idex) {

        if ($rootScope.UserId) {
            if ($scope.essayComments[idex].createdBy.id != $rootScope.UserId) {
                var commentData = {};
                commentData.commentId = id;
                commentData.userId = $rootScope.UserId;

                switch (options) {
                    case 'like':
                        commentData.likes = 1;
                        break;
                    case 'dislike':
                        commentData.dislikes = 1;
                        break;
                    default:
                        commentData.spam = 1;
                        break;

                }
                $scope.updateCommentApi(commentData, options, idex);
            } else {
                alert("You cannot " + options + " your own comments");
            }

        } else {
            alert("Please login to perform these actions");
        }
    }
    $scope.submitSticky = function(data, id, idx) {
        if (data > 0) {
            updateForum('sticky', id, idx);
        } else {
            alert("Please enter valid order");
        }

    }
    $scope.ShowComments = false;
    $scope.redirectToComment = function() {
        if (!$rootScope.UserId) {
            $location.path('signin');
        }
        $scope.ShowComments = true;
        $scope.displayComments = false;
        //$location.path('forumReply/'+$routeParams.categoryId+'/'+$routeParams.subcatId+'/'+$routeParams.essayId);

    }



    $scope.goBack = function() {
        $scope.ShowComments = false;
        $scope.displayComments = true;
    }
    $scope.getComments = function() {

        MyService.getPressEssayComments($routeParams.essayId).then(function(payload) {
                $scope.essayComments = payload;
            },
            function(errorPayload) {
                alert('Something went wrong ');
            });


    }

    $scope.SubmitComment = function(rec) {
        //MyService.ConsoleLog(data);
        //MyService.ConsoleLog($scope.mainThread);
        var data = {};
        if (rec.content != "") {
            $scope.TopicButton = true;
            data.createdById = $rootScope.UserId;
            data.createdByName = $rootScope.User;
            data.createdByType = tokenService.getUserRole();
            data.comments = rec.content;
            data.essayId = $routeParams.essayId;
            //MyService.ConsoleLog(data);


            /*MyService.submitPressEssayComments(data).then(function(payload) {
                $scope.comments = {
                    content: ''
                };
                $scope.ShowComments = false;
                $scope.displayComments = true;
                $scope.mainThread = {};
                //$location.path('forumthread/'+$routeParams.categoryId+'/'+$routeParams.subcatId+'/'+$routeParams.essayId);
                $scope.getComments();
            }, function(response) {
                if (response.error) {
                    alert(response.error);
                    //MyService.ConsoleLog(response);
                    if ((response.status) && (response.status == "405")) {
                        var msg = "Do you want to send request to Admin to reactivate your account?.";
                        MyService.GetDialogWithButtons(ngDialog, msg, "YES", "NO").then(function(payload) {
                            MyService.sendActivatationMailtoAdmin().then(function(payload) {
                                alert("Request sent successfully to admin");
                            }, function(errorPayload) {
                                alert("Something went wrong");
                            })
                        }, function(errorPayload) {
                            //MyService.ConsoleLog(errorPayload);
                        });
                    }
                }
            });*/
        } else {
            alert("Please enter comments.");
        }
    }

    $scope.EssayVote = function(option) {
        if ($scope.essay.createdBy.id != tokenService.getUserId()) {
            var data = {};
            data.essayId = $routeParams.essayId;
            data.mediaType = '';
            data.option = option;
            //MyService.ConsoleLog(option);
            if (option == "Recommended") {
                data.vote = $scope.vote.recommend;
            } else {
                data.vote = $scope.vote.factual;
            }
            data.createdById = $scope.loginUser;
            data.createdByName = tokenService.getUserName();
            data.createdByType = tokenService.getUserRole();
            MyService.updatePressEssay(data).then(function(payload) {
                    alert('Thank you for rating the essay.');
                },
                function(response) {
                    if (response.error) {
                        alert(response.error);
                        //MyService.ConsoleLog(response);
                        if ((response.status) && (response.status == "405")) {
                            var msg = "Do you want to send request to Admin to reactivate your account?.";
                            MyService.GetDialogWithButtons(ngDialog, msg, "YES", "NO").then(function(payload) {
                                MyService.sendActivatationMailtoAdmin().then(function(payload) {
                                    alert("Request sent successfully to admin");
                                }, function(errorPayload) {
                                    alert("Something went wrong");
                                })
                            }, function(errorPayload) {
                                //MyService.ConsoleLog(errorPayload);
                            });
                        }
                    }
                });
        } else {
            alert("You cannot vote your own essay.");
        }

    }



    if ($routeParams.categoryId) {
        //getCategory();
        $scope.getEssayDetails();
        $scope.getComments();
    }
}]);

'use strict';

angular.module('myApp.pressComment', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/pressComment/:pressId/:pressName?', {
        templateUrl: 'app/pressComment/pressComment.html',
        controller: 'pressCommentCtrl'
    });
}])

.controller('pressCommentCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', 'baseApiUrl', '$q', '$timeout', 'growl', 'tokenService', '$anchorScroll', '$sce', 'MyService', function($scope, $http, $location, apiCall, $routeParams, $rootScope, baseApiUrl, $q, $timeout, growl, tokenService, $anchorScroll, $sce, MyService) {

    $rootScope.welcome = false;
    $scope.pressId = $routeParams.pressId;
    $scope.pressName = $routeParams.pressName;
    $scope.userType = tokenService.getUserRole();
    $scope.uData = JSON.parse(tokenService.getUserData());
    $scope.essayComments = [];
    $scope.press = {};
    $scope.Sticky = {
        ShowOrder: [],
        txtOrder: []
    };
    $scope.vote = {
        recommend: 0,
        factual: 0
    };
    //$scope.GalleryFolder = baseApiUrl + "/resources/" + $scope.uData.uname;

    $scope.displayComments = true;
    $scope.Reply = {};

    $scope.checkMemId = function(rdata, val) {
        return rdata.filter(
            function(rdata) {
                if (rdata.userData._id == $rootScope.UserId)
                    return rdata
            }
        );
    }


    $scope.CheckUrl = function(url, option) {
        if (url) {
            if (url.indexOf("youtube.com") >= 0) {
                var url = url.replace("watch?v=", "embed/");
                if (option == "V")
                    return $sce.trustAsHtml('<br/><iframe width="560" height="315" src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>');
                else
                    return $sce.trustAsHtml('<br/><iframe src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>');
            }
            if (url.indexOf("facebook.com") >= 0) {
                if (option == "V")
                    return $sce.trustAsHtml('<br/><iframe src="' + url + '" width="560" height="315" frameborder="0"></iframe><br/>');
                else
                    return $sce.trustAsHtml('<br/><iframe src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>');
            }
            if (url.indexOf("vimeo.com") >= 0) {
                if (url.indexOf("https://vimeo.com/") >= 0) {
                    var id = url.replace("https://vimeo.com/", "");
                    var newurl = "https://player.vimeo.com/video/" + id;
                } else {
                    var newurl = url;
                }
                if (option == "V")
                    return $sce.trustAsHtml('<br/><iframe src="' + newurl + '" width="500" height="281" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe><br/>');
                else
                    return $sce.trustAsHtml('<br/><iframe src="' + newurl + '" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe><br/>');
            }
            if (option == "V")
                return $sce.trustAsHtml('<br/><iframe width="560" height="315" src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>');
            else
                return $sce.trustAsHtml('<br/><iframe src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>');
        }

    }



    $scope.updateCommentApi = function(data, options, idex) {
        MyService.updatePressComments(data).then(function(payload) {
            if (payload.nModified == 0) {
                alert("You already provided your inputs on this post");
            } else {
                switch (options) {
                    case 'like':
                        $scope.essayComments[idex].totalLikes = $scope.essayComments[idex].totalLikes + 1;
                        break;
                    case 'dislike':
                        $scope.essayComments[idex].totalDislike = $scope.essayComments[idex].totalDislike + 1;
                        break;
                    default:
                        $scope.essayComments[idex].totalSpam = $scope.essayComments[idex].totalSpam + 1;
                        break;
                }
            }
        }, function(errorPayload) {
            alert('Something went wrong ');
        });
    }



    $scope.updateComments = function(options, id, idex) {
        if ($rootScope.UserId) {
            if ($scope.essayComments[idex].createdBy.id != $rootScope.UserId) {
                var commentData = {};
                commentData.commentId = id;
                commentData.userId = $rootScope.UserId;

                switch (options) {
                    case 'like':
                        commentData.likes = 1;
                        break;
                    case 'dislike':
                        commentData.dislikes = 1;
                        break;
                    default:
                        commentData.spam = 1;
                        break;
                }
                
                $scope.updateCommentApi(commentData, options, idex);

            } else {
                alert("You cannot " + options + " your own comments");
            }
        } else {
            alert("Please login to perform these actions");
        }
    }
    $scope.submitSticky = function(data, id, idx) {
        if (data > 0) {
            updateForum('sticky', id, idx);
        } else {
            alert("Please enter valid order");
        }
    }

    $scope.ShowComments = false;
    
    $scope.redirectToComment = function() {
        if (!$rootScope.UserId) {
            $location.path('signin');
        }
        $scope.ShowComments = true;
        $scope.displayComments = false;
        //$location.path('forumReply/'+$routeParams.categoryId+'/'+$routeParams.subcatId+'/'+$routeParams.essayId);
    }

    $scope.goBack = function() {
        $scope.ShowComments = false;
        $scope.displayComments = true;
    }

    $scope.getComments = function() {
        MyService.getPressComments($routeParams.pressId).then(function(payload) {
            //MyService.ConsoleLog(payload);
                if(payload) {
                    $scope.essayComments = payload;    
                }
                
            },
            function(errorPayload) {
                alert('Something went wrong ');
            });
    }

    $scope.SubmitComment = function(rec) {
        //MyService.ConsoleLog(data);
        //MyService.ConsoleLog($scope.mainThread);
        var data = {};
        if (rec.content != "") {
            $scope.TopicButton = true;
            data.createdById = $rootScope.UserId;
            data.createdByName = $rootScope.User;
            data.createdByType = tokenService.getUserRole();
            data.comments = rec.content;
            data.pressId = $routeParams.pressId;
            //MyService.ConsoleLog(data);
            MyService.submitPressComments(data).then(function(payload) {
                $scope.comments = {
                    content: ''
                };
                $scope.ShowComments = false;
                $scope.displayComments = true;
                $scope.mainThread = {};
                //$location.path('forumthread/'+$routeParams.categoryId+'/'+$routeParams.subcatId+'/'+$routeParams.essayId);
                $scope.getComments();
            }, function(errorPayload) {
                alert('Something went wrong ');
            });
        } else {
            alert("Please enter comments.");
        }
    }

    



    if ($routeParams.pressId) {
        $scope.getComments();
    }
}]);

'use strict';
angular.module('myApp.postOnFaceBook', ['ngRoute', 'angularPayments'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/postOnFaceBook/:fbImg', {
      templateUrl: 'app/postOnFaceBook/postOnFaceBook.html',
      controller: 'postOnFaceBookCtrl'
    });
  }])
  .controller('postOnFaceBookCtrl', ['$scope', '$rootScope', 'growl', 'ngDialog', 'tokenService', 'MyService', '$location', '$window', '$filter', '$cookies','baseApiUrl', function ($scope, $rootScope, growl, ngDialog, tokenService, MyService, $location, $window, $filter, $cookies,baseApiUrl) {

    MyService.ConsoleLog("baseApiUrl",baseApiUrl);
    // if (tokenService.getUserData())

    $scope.retainOptions = "";
    $scope.fb = {
      options: "C"
    };



    $scope.postOnWall = function (message) {
      var body = message;
      var catId = window.localStorage.getItem("cat_id");
      var subCat =window.localStorage.getItem("selCat_id");
      MyService.ConsoleLog("img",$rootScope.fbImage);
     
        var quizLink =
          window.location.origin + '#!/question-background/' + catId + '/' + subCat;
        // if ($cookies.get('quizLinks')) {
        //   // alert('if');
        //   links = $cookies.get('quizLinks');
        //   MyService.ConsoleLog("links  one", links);
        // } else {
        //   // alert('else');
        //   links = 'https://votewise.net/#!/fiveMatch#DisplayQ';
        // }
        var obj = {
          method: 'feed',
          link: quizLink
        };

        setTimeout(function(){
          FB.ui(obj, function (response) {
            MyService.ConsoleLog("response", response);
            // if (!response) {
            growl.success('Posted Successfully',{
              ttl: 800
            });
            if ($cookies.get('quizLinks')) {
              $cookies.remove('quizLinks');
            }
            // }
          });
        }, 4000);
     
    };
    $scope.DisplayFPostLoader = false;
    $scope.postFB = function (message) {

      $scope.DisplayFPostLoader = true;
      $scope.postOnWall(message);
      // FB.getLoginStatus(function (response) {
      //   if (response.status == 'unknown') {
      //     FB.login(function (response) {
      //       MyService.updateFBID({
      //         "facebookid": response.authResponse.userID
      //       }).then(function (payload) {
      //         if (payload.data.error && payload.data.error == "FBDUPLICATE") {
      //           $scope.DisplayFPostLoader = false;
      //           alert("Facebook user doesn't match with your account.");
      //         } else {
      //           $scope.postOnWall(message);
      //         }
      //       }, function (errpayload) {
      //         MyService.ConsoleLog("errpayload", errpayload);
      //         $scope.DisplayFPostLoader = false;
      //         var errmsg = "Facebook is taking too long to respond. Should we try again?"
      //         var modal = ngDialog.openConfirm({
      //           template: '<p>' + errmsg + '</p>\
      //                       <div class="ngdialog-buttons">\
      //               <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
      //               <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Yes</button>\
      //           </div>',
      //           plain: true
      //         });
      //         modal.then(function fullfilled(tdata) {
      //           if (tdata == 1) {
      //             $scope.postOnWall(message);
      //           }
      //         }, function rejected(data) {
      //           //MyService.ConsoleLog("rejected: ", data);
      //         });
      //         // alert("Facebook is taking too long to respond. Should we try again?");
      //       });
      //     }, {
      //       scope: 'public_profile,email,publish_actions',
      //       return_scopes: true
      //     });
      //   } else {
      //     if ($scope.userData && $scope.userData.facebookid) {
      //       if (response.authResponse.userID == $scope.userData.facebookid) {
      //         $scope.postOnWall(message);
      //       } else {
      //         $scope.DisplayFPostLoader = false;
      //         alert("Facebook user doesn't match with your account.");
      //       }
      //     } else {
      //       $scope.postOnWall(message);
      //     }
      //   }
      // });
    }

    $scope.checkSSR = function(){
      // MyService.ConsoleLog("check", $rootScope.OldCatforFB.fbImage);
      // var url = "https://api.votewise.net/resources/stop-and-frisk-2-(1-of-1)-1488802259580.jpg";
      var url = window.localStorage.getItem('fbImg');
      var catId = window.localStorage.getItem("cat_id");
      var subCat =window.localStorage.getItem("selCat_id");

      // $("head > meta[property='og:image']").attr('content', url);
      MyService.checkMetaWithSSR({imgUrl:url,
      catId:catId,
    subCatId:subCat}).then(function(APIResponse){
        MyService.ConsoleLog("Response",Response);
      },function(err){
        MyService.ConsoleLog("Error inside",err);
      });
    };
  }]);

'use strict';
angular.module('myApp.postingHints', ['ngRoute'])
  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/postingHints', {
      templateUrl: 'app/postingHints/postingHints.html',
      reloadOnSearch: false,
      controller: 'postingHintsCtrl' //we can name anythin
    });
  }])
  .controller('postingHintsCtrl', ['$scope', '$rootScope', '$window', function($scope, $rootScope, $window) {
    //this is controller for sampepage.html, we link the conttoler to page in config defination, check above .config
    $rootScope.welcome = false;
    $window.scrollTo(0, 0);
  }]);

angular
  .module("myApp.updateUserAddress", ["ngRoute", "ngDialog"])
  .controller("UpdateUserAddressCtrl", [
    "$scope",
    "$http",
    "$location",
    "apiCall",
    "$routeParams",
    "$q",
    "ngDialog",
    "$rootScope",
    "growl",
    "MyService",
    "$filter",
    "tokenService",
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $q,
      ngDialog,
      $rootScope,
      growl,
      MyService,
      $filter,
      tokenService
    ) {
      /*
    $scope.userAddress = {
      legislativeDistrict: "104",
      voterDistrict: "250132746",
      voterDistrictFips: "2746",
      schoolDistrict: "Agawam School District",
      schoolDistrictFips: "1800",
      stateSenateDistrict: "5",
      federalCongrassionalDist: "1",
      country: null,
      state: "MASSACHUSETTS",
      statePostalCode: "MA",
      countySubdivision: "Agawam Town city",
      countySubdivisionFips: "840",
      county: "Hampden MA",
      countyFips: "25013",
      place: "Agawam Town city, MA",
      placeFips: "840",
      zipcode: "01001"
    };
    */
      $scope.address = {
        zipcode: "",
        state: "",
      };
      $scope.statusGetZipdata = 0;
      $rootScope.welcome = false;
      $scope.showFAddress = false;
      $scope.Location = new Object();
      $scope.userAddress = $scope.ngDialogData;
      MyService.ConsoleLog("test", $scope.ngDialogData);
      MyService.ConsoleLog("$scope.userAddress", $scope.userAddress);
      if (
        $scope.ngDialogData &&
        $scope.ngDialogData.zipcode &&
        $scope.ngDialogData.zipcode != ""
      ) {
        $scope.address = {
          zipcode: $scope.ngDialogData.zipcode,
          state: "",
        };
        $scope.showNwTitle = false;
      } else {
        $scope.showNwTitle = true;
        $scope.statusGetZipdata = 2;
      }

      var previousSelVal = {};
      $scope.setSelectedDropdown = function (
        listData,
        setfor,
        selectedUserAdrs
      ) {
        // //MyService.ConsoleLog("listData: ",listData);
        // //MyService.ConsoleLog("setfor: ",setfor);
        switch (setfor) {
          case "counties":
            previousSelVal.county = $scope.address.county;
            // //MyService.ConsoleLog("selCountyNumber: ",previousSelVal.county);

            $scope.address.county = null;
            if (listData) {
              $scope.counties = listData;
              // $scope.counties.unshift({
              //   number: null,
              //   name: "none"
              // });
              // if(!selectedUserAdrs) selectedUserAdrs.countyFips = previousSelVal.county.number;
              var selCountyNumber = null;
              try {
                $scope.address.county = $scope.counties[0];

                if (selectedUserAdrs) {
                  selCountyNumber = selectedUserAdrs.countyFips;
                }

                if (previousSelVal.county) {
                  selCountyNumber = previousSelVal.county.number;
                }

                if (selCountyNumber) {
                  // //MyService.ConsoleLog("selCountyNumber: ",selCountyNumber);
                  angular.forEach($scope.counties, function (val, key) {
                    if (selCountyNumber == val.COUNTYFP)
                      $scope.address.county = val;
                  });
                }
              } catch (e) {
                ////MyService.ConsoleLog("Exception: ",e);
              }
            }
            break;
          case "subCounties":
            previousSelVal.subcounty = $scope.address.subcounty;
            $scope.address.subcounty = null;
            if (listData) {
              $scope.subCounties = listData;
              // $scope.subCounties.unshift({
              //   number: null,
              //   name: "none"
              // });
              var selSubCountyNo = null;
              try {
                $scope.address.subcounty = $scope.subCounties[0];
                if (selectedUserAdrs) {
                  selSubCountyNo = selectedUserAdrs.countySubdivisionFips;
                }
                if (previousSelVal.subcounty) {
                  selSubCountyNo = previousSelVal.subcounty.number;
                }
                if (selSubCountyNo) {
                  angular.forEach($scope.subCounties, function (val, key) {
                    //set selected state
                    // if(selectedUserAdrs.countySubdivisionFips == val.number)

                    if (selSubCountyNo == val.COUSUBFP)
                      $scope.address.subcounty = val;
                  });
                }
              } catch (e) {
                ////MyService.ConsoleLog("Exception: ",e);
              }
            }
            break;
          case "places":
            previousSelVal.place = $scope.address.place;
            $scope.address.place = null;
            if (listData) {
              $scope.places = listData;
              // MyService.ConsoleLog("one more log", $scope.places);

              // $scope.places.unshift({
              //   number: null,
              //   name: "none"
              // });

              try {
                $scope.address.place = $scope.places[0];
                var selPlaceNo = null;
                if (selectedUserAdrs) {
                  selPlaceNo = selectedUserAdrs.placeFips;
                }
                if (previousSelVal.place) {
                  selPlaceNo = previousSelVal.place.number;
                }
                if (selPlaceNo) {
                  angular.forEach($scope.places, function (val, key) {
                    if (selPlaceNo == val.PLACEFP) $scope.address.place = val;
                    MyService.ConsoleLog(
                      "$scope.address.place",
                      $scope.address.place
                    );
                  });
                }
              } catch (e) {
                ////MyService.ConsoleLog("Exception: ",e);
              }
            }
            break;
          case "voterDistricts":
            if (listData) {
              previousSelVal.voterDistrict = $scope.address.voterDistrict;
              $scope.address.voterDistrict = null;
              $scope.voterDistricts = listData;
              // $scope.voterDistricts.unshift({
              //   number: null,
              //   name: "none"
              // });

              var voterDistrictNo = null;
              try {
                $scope.address.voterDistrict = $scope.voterDistricts[0];
                if (selectedUserAdrs) {
                  voterDistrictNo = selectedUserAdrs.voterDistrictFips;
                }
                if (previousSelVal.voterDistrict) {
                  voterDistrictNo = previousSelVal.voterDistrict.number;
                }

                if (voterDistrictNo) {
                  angular.forEach($scope.voterDistricts, function (val, key) {
                    //set selected

                    if (voterDistrictNo == val.number)
                      $scope.address.voterDistrict = val;
                  });
                }
              } catch (e) {
                ////MyService.ConsoleLog("Exception: ",e);
              }
            }
            break;
          case "federalCongrassionalDist":
            $scope.address.federalCongrassionalDist = null;
            if (listData) {
              $scope.federalCongrassionalDist = listData;
              // $scope.federalCongrassionalDist.unshift("none");

              if (selectedUserAdrs) {
                $scope.address.federalCongrassionalDist =
                  $scope.federalCongrassionalDist[0];
                angular.forEach(
                  $scope.federalCongrassionalDist,
                  function (val, key) {
                    //set selected state

                    if (
                      selectedUserAdrs.federalCongrassionalDist == val.CD115FP
                    )
                      $scope.address.federalCongrassionalDist = val;
                  }
                );
              }
            }
            break;
          case "stateSenateDistrict":
            $scope.address.stateSenateDistrict = null;
            if (listData) {
              $scope.stateSenateDistrict = listData;
              // $scope.stateSenateDistrict.unshift("none");
              $scope.address.stateSenateDistrict =
                $scope.stateSenateDistrict[0];
              if (selectedUserAdrs) {
                angular.forEach(
                  $scope.stateSenateDistrict,
                  function (val, key) {
                    //set selected state

                    if (selectedUserAdrs.stateSenateDistrict == val.SLDUST)
                      $scope.address.stateSenateDistrict = val;
                    else if (selectedUserAdrs == val.SLDUST)
                      $scope.address.stateSenateDistrict = val;
                  }
                );
              }
            }
            break;
          case "stateHouseOFRepresentativeDistrict":
            $scope.address.stateLegislativeDistrict = null;
            // //MyService.ConsoleLog("listData>>>>", listData);
            if (listData) {
              $scope.stateLegislativeDistrict = listData;
              // $scope.stateLegislativeDistrict.unshift("none");
              // var matchval = "";
              $scope.address.stateLegislativeDistrict =
                $scope.stateLegislativeDistrict[0];
              // //MyService.ConsoleLog("selectedUserAdrs > ", selectedUserAdrs);
              if (selectedUserAdrs) {
                angular.forEach(
                  $scope.stateLegislativeDistrict,
                  function (val, key) {
                    //set selected state
                    // //console.log(val);

                    // //MyService.ConsoleLog("val >> ", val);
                    var val2 = val.NAMELSAD.replace(
                      "State House District ",
                      ""
                    );
                    if (selectedUserAdrs.legislativeDistrict == val2) {
                      $scope.address.stateLegislativeDistrict = val;
                    } else if (selectedUserAdrs == val2) {
                      $scope.address.stateLegislativeDistrict = val;
                    }
                  }
                );
              }
            }
            break;
          case "schoolDistricts":
            $scope.address.schoolDistrict = null;
            if (listData) {
              $scope.schoolDistricts = listData;
              // $scope.schoolDistricts.unshift({
              //   number: null,
              //   name: "none"
              // });
              $scope.address.schoolDistricts = $scope.schoolDistricts[0];
              if (selectedUserAdrs) {
                angular.forEach($scope.schoolDistricts, function (val, key) {
                  //set selected state

                  if (selectedUserAdrs.schoolDistrictFips == val.UNSDLEA)
                    $scope.address.schoolDistrict = val;
                  else if (selectedUserAdrs == val.UNSDLEA)
                    $scope.address.schoolDistrict = val;
                });
              }
            }
            break;
        }
      };

      $scope.prevZipCode = null;
      var getZipDataCanceler = $q.defer();
      $scope.getZipData = function () {
        // //MyService.ConsoleLog("** getZipData **", " prevZipCode: ", $scope.prevZipCode, " zipcode: ", $scope.address.zipcode)
        // MyService.ConsoleLog("zipcode: ", JSON.parse(tokenService.getUserData()));

        MyService.getMailingAddress({
          userId: tokenService.getUserId(),
        }).then(
          function (result) {
            MyService.ConsoleLog("Result", result);
            $scope.mainData = result.data.data;
            if ($scope.prevZipCode != $scope.mainData.zipcode) {
              $scope.states = [];
              $scope.statusGetZipdata = 1;
              getZipDataCanceler.resolve("cancel");
              getZipDataCanceler = $q.defer();
              var param = {
                zipcode: $scope.mainData.zipcode,
                candidate: true,
              };
              // alert("two");

              MyService.getAddressData(param, getZipDataCanceler.promise).then(
                function (response) {
                  MyService.ConsoleLog("*** GOT ZIP DATA : ", response);
                  $scope.prevZipCode = $scope.mainData.zipcode;
                  $scope.address.zipcode = $scope.mainData.zipcode;
                  // //MyService.ConsoleLog("success : ", response.data.success);
                  if (response.data.success) {
                    var zipData = response.data.data;
                    if (zipData.state || zipData.place) {
                      // //MyService.ConsoleLog("zipData :: ", zipData);

                      $scope.mainAddress = zipData;

                      if (zipData.state && zipData.state.length > 0) {
                        //MyService.ConsoleLog($scope.allStates);
                        // angular.forEach(zipData.statePostalCode, function(stCode, i) {
                        angular.forEach($scope.allStates, function (val, key) {
                          angular.forEach(zipData.state, function (val1, key1) {
                            if (val.statePostalCode == val1.STUSPS) {
                              $scope.states.push(val);
                              $scope.address.state = val;
                              // //MyService.ConsoleLog("-----------------pushed--------------", val);
                            }
                          });
                        });
                        // });
                        ////MyService.ConsoleLog("$scope.states: ",$scope.states);
                        angular.forEach($scope.states, function (val, key) {
                          //set selected state
                          if (
                            $scope.userAddress.statePostalCode ==
                            val.statePostalCode
                          )
                            $scope.address.state = val;
                        });
                      }
                      // //console.log($scope.userAddress);
                      //MyService.ConsoleLog("zipData > ", zipData);
                      var countySubdivisions = zipData.places.filter(function (
                        obj
                      ) {
                        if (obj.COUSUBFP && obj.COUSUBFP != "") {
                          // //MyService.ConsoleLog("Inside cs");
                          return obj;
                        }
                      });
                      var places = zipData.places.filter(function (obj) {
                        if (obj.PLACEFP && obj.PLACEFP != "") {
                          // //MyService.ConsoleLog("obj > ", obj);
                          return obj;
                        }
                      });
                      MyService.ConsoleLog("places", places);
                      if (zipData.county)
                        $scope.setSelectedDropdown(
                          zipData.county,
                          "counties",
                          $scope.userAddress
                        );

                      if (countySubdivisions)
                        $scope.setSelectedDropdown(
                          countySubdivisions,
                          "subCounties",
                          $scope.userAddress
                        );

                      if (places)
                        $scope.setSelectedDropdown(
                          places,
                          "places",
                          $scope.userAddress
                        );

                      // if (zipData.voterDistricts) $scope.setSelectedDropdown(zipData.voterDistricts, "voterDistricts", $scope.userAddress);

                      if (zipData.congressionalDistrict)
                        $scope.setSelectedDropdown(
                          zipData.congressionalDistrict,
                          "federalCongrassionalDist",
                          $scope.userAddress
                        );

                      if (zipData.stateSenateDistrict)
                        $scope.setSelectedDropdown(
                          zipData.stateSenateDistrict,
                          "stateSenateDistrict",
                          $scope.userAddress
                        );

                      if (zipData.stateHouseofRepresentativesDistrict)
                        $scope.setSelectedDropdown(
                          zipData.stateHouseofRepresentativesDistrict,
                          "stateHouseOFRepresentativeDistrict",
                          $scope.userAddress
                        );

                      if (zipData.unifiedSchoolDistrict)
                        $scope.setSelectedDropdown(
                          zipData.unifiedSchoolDistrict,
                          "schoolDistricts",
                          $scope.userAddress
                        );
                    } else {
                      // alert("Zipcode is not found in our database, please correct it.");
                    }

                    $scope.statusGetZipdata = 2;
                  } else if (
                    response.data.error &&
                    typeof response.data.error == "string"
                  ) {
                    growl.error("Error: " + response.data.error);
                    $scope.statusGetZipdata = 2;
                  } else {
                    growl.error("Something went wrong.");
                    $scope.statusGetZipdata = 3;
                  }
                },
                function (err) {
                  if (err.status != -1) {
                    growl.error("Something went wrong.");
                    $scope.statusGetZipdata = 3;
                  } else $scope.statusGetZipdata = 2;
                }
              );
              /*$http({
                    method: "GET",
                    url: "http://localhost:8080/ziplookup/list/filter",
                    params: param,
                    timeout: getZipDataCanceler.promise
                }).then(function(response){
                    ////MyService.ConsoleLog("GOT DATA: ",response);
                });*/
            }
          },
          function (err) {
            MyService.ConsoleLog("Error >", err);
          }
        );
      };

      $scope.zipCodeChanged = function () {
        ////MyService.ConsoleLog("zipCodeChanged");
        $scope.getZipData();
      };

      $scope.onCountyChange = function () {
        ////MyService.ConsoleLog("** onCountyChange **");
        try {
          var postobj = {};

          $scope.statusCountySearch = 1;
          postobj.zipcode = $scope.address.zipcode;
          postobj.county = $scope.address.county.name;

          if ($scope.address.county.name.toLowerCase() == "none") {
            return;
          }
          // alert("three");

          MyService.getAddressData(postobj).then(
            function (response) {
              ////MyService.ConsoleLog("Got zip data: ", response);
              $scope.prevZipCode = $scope.address.zipcode;

              if (response.data.success) {
                var zipData = response.data.data;

                if (zipData.subCounties)
                  $scope.setSelectedDropdown(
                    zipData.subCounties,
                    "subCounties",
                    null
                  );

                if (zipData.places)
                  $scope.setSelectedDropdown(zipData.places, "places", null);

                if (zipData.voterDistricts)
                  $scope.setSelectedDropdown(
                    zipData.voterDistricts,
                    "voterDistricts",
                    null
                  );

                if (zipData.federalCongrassionalDist)
                  $scope.setSelectedDropdown(
                    zipData.federalCongrassionalDist,
                    "federalCongrassionalDist",
                    null
                  );

                if (zipData.stateSenateDistrict)
                  $scope.setSelectedDropdown(
                    zipData.stateSenateDistrict,
                    "stateSenateDistrict",
                    null
                  );

                if (zipData.stateHouseOFRepresentativeDistrict)
                  $scope.setSelectedDropdown(
                    zipData.stateHouseOFRepresentativeDistrict,
                    "stateHouseOFRepresentativeDistrict",
                    null
                  );

                if (zipData.schoolDistricts)
                  $scope.setSelectedDropdown(
                    zipData.schoolDistricts,
                    "schoolDistricts",
                    null
                  );

                $scope.statusCountySearch = 2;
              } else if (
                response.data.error &&
                typeof response.data.error == "string"
              ) {
                growl.error("Error: " + response.data.error);
                $scope.statusCountySearch = 2;
              } else {
                growl.error("Something went wrong.");
                $scope.statusCountySearch = 3;
              }
            },
            function (err) {
              growl.error("Something went wrong.");
              $scope.statusCountySearch = 3;
            }
          );
        } catch (e) {
          ////MyService.ConsoleLog("Exception : ",e);
        }
      };
      $scope.onSubCountyChange = function () {
        ////MyService.ConsoleLog("** onSubCountyChange **");
        try {
          var postobj = {};

          $scope.statusSubCountySearch = 1;
          postobj.zipcode = $scope.address.zipcode;
          postobj.county = $scope.address.county.name;
          postobj.countySubdivision = $scope.address.subcounty.name;

          if ($scope.address.subcounty.name.toLowerCase() == "none") {
            return;
          }
          // alert("four");

          MyService.getAddressData(postobj).then(
            function (response) {
              ////MyService.ConsoleLog("Got zip data: ", response);
              $scope.prevZipCode = $scope.address.zipcode;

              if (response.data.success) {
                var zipData = response.data.data;

                if (zipData.places)
                  $scope.setSelectedDropdown(zipData.places, "places", null);

                if (zipData.voterDistricts)
                  $scope.setSelectedDropdown(
                    zipData.voterDistricts,
                    "voterDistricts",
                    null
                  );

                if (zipData.federalCongrassionalDist)
                  $scope.setSelectedDropdown(
                    zipData.federalCongrassionalDist,
                    "federalCongrassionalDist",
                    null
                  );

                if (zipData.stateSenateDistrict)
                  $scope.setSelectedDropdown(
                    zipData.stateSenateDistrict,
                    "stateSenateDistrict",
                    null
                  );

                if (zipData.stateHouseOFRepresentativeDistrict)
                  $scope.setSelectedDropdown(
                    zipData.stateHouseOFRepresentativeDistrict,
                    "stateHouseOFRepresentativeDistrict",
                    null
                  );

                if (zipData.schoolDistricts)
                  $scope.setSelectedDropdown(
                    zipData.schoolDistricts,
                    "schoolDistricts",
                    null
                  );

                $scope.statusSubCountySearch = 2;
              } else if (
                response.data.error &&
                typeof response.data.error == "string"
              ) {
                growl.error("Error: " + response.data.error);
                $scope.statusSubCountySearch = 2;
              } else {
                growl.error("Something went wrong.");
                $scope.statusSubCountySearch = 3;
              }
            },
            function (err) {
              growl.error("Something went wrong.");
              $scope.statusSubCountySearch = 3;
            }
          );
        } catch (e) {
          ////MyService.ConsoleLog("Exception : ",e);
        }
      };
      $scope.mainAddress = "";

      $scope.onVoterDistChange = function () {
        //MyService.ConsoleLog("** onVoterDistChange **");
        try {
          var postobj = {};

          $scope.statusVoterDistSearch = 1;
          postobj.zipcode = $scope.address.zipcode;
          //MyService.ConsoleLog("a:::", $scope.address);
          if (
            $scope.address.voterDistrict &&
            $scope.address.voterDistrict.name.toLowerCase() != "none"
          ) {
            postobj.voterDistrictName = $scope.address.voterDistrict.name;

            //MyService.ConsoleLog("postobj: ", postobj);
            // alert("one");
            MyService.getAddressData(postobj).then(
              function (response) {
                // //MyService.ConsoleLog("Got zip data: ", response);
                if (response.data.success) {
                  var zipData = response.data.data;
                  $scope.mainAddress = zipData;
                  if (zipData.counties)
                    $scope.setSelectedDropdown(
                      zipData.counties,
                      "counties",
                      null
                    );

                  if (zipData.subCounties)
                    $scope.setSelectedDropdown(
                      zipData.subCounties,
                      "subCounties",
                      null
                    );

                  if (zipData.places)
                    $scope.setSelectedDropdown(zipData.places, "places", null);

                  if (zipData.voterDistricts)
                    $scope.setSelectedDropdown(
                      zipData.voterDistricts,
                      "voterDistricts",
                      {
                        voterDistrictFips: $scope.address.voterDistrict.number,
                      }
                    );

                  if (zipData.federalCongrassionalDist)
                    $scope.setSelectedDropdown(
                      zipData.federalCongrassionalDist,
                      "federalCongrassionalDist",
                      null
                    );

                  if (zipData.stateSenateDistrict)
                    $scope.setSelectedDropdown(
                      zipData.stateSenateDistrict,
                      "stateSenateDistrict",
                      null
                    );

                  if (zipData.stateHouseOFRepresentativeDistrict)
                    $scope.setSelectedDropdown(
                      zipData.stateHouseOFRepresentativeDistrict,
                      "stateHouseOFRepresentativeDistrict",
                      null
                    );

                  if (zipData.schoolDistricts)
                    $scope.setSelectedDropdown(
                      zipData.schoolDistricts,
                      "schoolDistricts",
                      null
                    );

                  $scope.statusVoterDistSearch = 2;
                } else if (
                  response.data.error &&
                  typeof response.data.error == "string"
                ) {
                  growl.error("Error: " + response.data.error);
                  $scope.statusVoterDistSearch = 2;
                } else {
                  growl.error("Something went wrong.");
                  $scope.statusVoterDistSearch = 3;
                }
              },
              function (err) {
                growl.error("Something went wrong.");
                $scope.statusVoterDistSearch = 3;
              }
            );
          }
        } catch (e) {
          ////MyService.ConsoleLog("Exception : ",e);
        }
      };

      $scope.statusGetStates = 0; //1: loading, 2: loaded, 3: failed
      var getAllStatesCanceler = $q.defer();
      $scope.getAllStates = function () {
        // //MyService.ConsoleLog("** getAllStates **");

        $scope.statusGetStates = 1;
        MyService.getAllStates().then(
          function (data) {
            // //MyService.ConsoleLog("** getAllStates **", data);
            /*{
          state: "ALABAMA",
          statePostalCode: "AL"
        }*/
            $scope.statusGetStates = 2;
            $scope.allStates = data;
            $scope.getZipData();
          },
          function (err) {
            $scope.statusGetStates = 3;
            ////MyService.ConsoleLog("got states error");
            // growl.error("Some");
          }
        );
      };

      $scope.getAllStates();

      $scope.updateAddress = function (argument) {
        MyService.ConsoleLog("argument", argument);
        if ($scope.statusGetStates == 2 && $scope.statusGetZipdata == 2) {
          var postobj = {
            userId: $rootScope.UserId,
            zipcode: $scope.mainData.zipcode,
          };

          var address = {};

          if ($scope.address.state) {
            address.state = $scope.address.state.state;
            address.statePostalCode = $scope.address.state.statePostalCode;
          }

          if ($scope.address.place) {
            address.placeFips = $scope.address.place.PLACEFP;
            address.place = $scope.address.place.placeName
              ? $scope.address.place.placeName
              : $scope.address.place.NAMELSAD;
          }

          if ($scope.address.county) {
            address.countyFips = $scope.address.county.COUNTYFP;
            address.county = $scope.address.place.countyName
              ? $scope.address.place.countyName
              : $scope.address.county.NAMELSAD;
          }

          if ($scope.address.subcounty) {
            address.countySubdivisionFips = $scope.address.subcounty.COUSUBFP;
            address.countySubdivision = $scope.address.subcounty.NAMELSAD;
          }

          if ($scope.address.federalCongrassionalDist) {
            address.federalCongrassionalDist =
              $scope.address.federalCongrassionalDist.CD115FP;
          }

          if ($scope.address.stateSenateDistrict) {
            address.stateSenateDistrict =
              $scope.address.stateSenateDistrict.SLDUST;
          }

          if ($scope.address.schoolDistrict) {
            address.schoolDistrictFips = $scope.address.schoolDistrict.UNSDLEA;
            address.schoolDistrict = $scope.address.schoolDistrict.NAME;
          }

          // if ($scope.address.voterDistrict) {
          //   address.voterDistrictFips = $scope.address.voterDistrict.number;
          //   address.voterDistrict = $scope.address.voterDistrict.name;
          // }

          if ($scope.address.stateLegislativeDistrict) {
            address.legislativeDistrict =
              $scope.address.stateLegislativeDistrict.NAMELSAD.replace(
                "State House District ",
                ""
              );
          }

          //MyService.ConsoleLog(" $scope.address: ", address);

          postobj.address = JSON.stringify(address);
          ////MyService.ConsoleLog("postobj.address: ", postobj);

          MyService.updateProfile(postobj).then(
            function (data) {
              growl.success("Updated successfully.");
              // $scope.setAddressNew();
              $scope.closeThisDialog();
            },
            function (err) {
              growl.error("Something went wrong.");
            }
          );
        }
      };

      $scope.User = {
        Address: "",
      };

      var options = {
        componentRestrictions: {
          country: "us",
        },
        types: ["geocode"],
      };

      $scope.detectAddress = function (ent) {
        var val = document.getElementById("address");
        // //console.log($scope.User.Address);
        var autocomplete = new google.maps.places.Autocomplete(val, options);

        google.maps.event.addListener(
          autocomplete,
          "place_changed",
          function () {
            var place = autocomplete.getPlace();

            var lat = place.geometry.location.lat(),
              lng = place.geometry.location.lng();

            $scope.lati = lat.toFixed(6);
            $scope.lon = lng.toFixed(6);
            console.log($scope.lati);
            console.log($scope.lon);

            $scope.mailing_Address = place.formatted_address;
            console.log(
              "  place.address_components :",
              place.address_components
            );
            for (var i = 0; i < place.address_components.length; i++) {
              for (
                var j = 0;
                j < place.address_components[i].types.length;
                j++
              ) {
                if (
                  place.address_components[i].types[j] ==
                  "administrative_area_level_1"
                ) {
                  $scope.statePostalCode =
                    place.address_components[i].short_name;
                  // //console.log($scope.statePostalCode);
                }
                if (place.address_components[i].types[j] == "country") {
                  $scope.countryname = place.address_components[i].long_name;
                  // //console.log($scope.countryname);
                }
                if (
                  place.address_components[i].types[j] ==
                  "administrative_area_level_2"
                ) {
                  $scope.county_name = place.address_components[i].long_name;
                  // //console.log($scope.county_name);
                }
                if (place.address_components[i].types[j] == "locality") {
                  $scope.place_name = place.address_components[i].long_name;
                  // //console.log($scope.place_name);
                }
                if (place.address_components[i].types[j] == "postal_code") {
                  // document.getElementById('zip').value = place.address_components[i].long_name;
                  $scope.ZipCode = place.address_components[i].long_name;
                  // //console.log($scope.User.ZipCode);
                }
              }
            }

            //MyService.ConsoleLog(" $scope.User.ZipCode :", $scope.ZipCode);

            $scope.loc = JSON.stringify({
              longitude: $scope.lon,
              latitude: $scope.lati,
            });
            // //console.log(" long and lat :",$scope.loc );
            // $rootScope.location = new Array;

            $scope.showAddressDropDowns("", $scope.loc);
          }
        );
      };

      $scope.checkLen = function (ldata, sval) {
        // //MyService.ConsoleLog("vdata : ", vdata);
        //MyService.ConsoleLog("vdata", ldata);
        if (ldata && ldata.length > 0) {
          var data = ldata.map(function (sub) {
            var returnval = "";
            switch (sval) {
              case "federalCongrassionalDist":
                returnval = sub.CD115FP;
                break;
              case "stateSenateDistrict":
                returnval = sub.SLDUST;
                break;
              case "stateHouseOFRepresentativeDistrict":
                returnval = sub.NAMELSAD;
                break;
              case "unifiedSchoolDistrictName":
                returnval = sub.NAME;
                break;
              case "place":
                returnval = sub.place;
                break;
              case "countySubdivision":
                returnval = sub.countySubdivision;
                break;
              case "county":
                returnval = sub.county;
                break;
              case "state":
                returnval = sub.state;
                break;
              case "default":
                returnval = sub.NAME;
                break;
            }
            return returnval;
          });

          var ndata = $filter("unique")(data);
          if (ndata.length > 1) {
            return "yellowBackground";
          } else {
            return "";
          }
        } else {
          return "";
        }
      };

      $scope.allcounties = [];
      $scope.getCounties = function (lbl) {
        MyService.ConsoleLog("county >", $scope.oldaddress);
        // $scope.allcounties.length = 0;
        var statePostalCode = "";
        var state = "";
        // if (lbl == "new") {
        //   state = JSON.stringify($scope.oldaddress.state);
        // } else {
        statePostalCode = $scope.oldaddress.state[0].STATEFP;
        state = $scope.Location.state;
        // }
        // //MyService.ConsoleLog(statePostalCode + "<><><><>>" + state);
        MyService.getAllCounties(statePostalCode, state).then(
          function (payload) {
            // //MyService.ConsoleLog("sublocations Locals : ", payload);
            var allcounties = payload;
            if (lbl == "new") {
              var county = $scope.checkCounty(
                allcounties,
                $scope.oldaddress.county
              );
              $scope.allcounties = county;
              MyService.ConsoleLog("county<><", county[0]);
              $scope.Location.county = county[0];
            }
          },
          function (errorPayload) {
            growl.error("Something went wrong.");
          }
        );
      };
      $scope.MyPlaces = [];
      $scope.getSubCounties = function (lbl) {
        // //MyService.ConsoleLog(" $scope.Location.state :",$scope.Location.state);
        // //MyService.ConsoleLog("$scope.Location.county :",$scope.Location.county);
        // var county = $scope.Location.county;

        $scope.MyPlaces.length = 0;
        var county = "";
        var statePostalCode = "";
        $scope.MyPlaces.length = 0;
        var state = "";
        var county = "";
        if (lbl == "new") {
          state = JSON.stringify($scope.oldaddress.state);
          county = JSON.stringify($scope.oldaddress.county);
        } else {
          statePostalCode = $scope.Location.state.statePostalCode;
          state = $scope.Location.state;
          county = county.county;
        }
        // //MyService.ConsoleLog(statePostalCode + "===" + county);
        MyService.getAllSubCountiesLocal(statePostalCode, state, county).then(
          function (payload) {
            // payload = JSON.parse(payload);
            $scope.MyPlaces = payload;
            // //MyService.ConsoleLog("PlaCE :", payload);
            // //MyService.ConsoleLog(payload.countySubdivision);
            var subcounties = payload.countySubdivision;
            var places = payload.places;
            // //MyService.ConsoleLog("PlaCE :", payload);
            if (lbl == "new") {
              // //MyService.ConsoleLog("Places 1 > ",$scope.oldaddress.place);
              var subcounty = $scope.checksubCounty(
                subcounties,
                $scope.oldaddress.countySubdivision
              );
              var places = $scope.checkPlaces(places, $scope.oldaddress.place);
              // //MyService.ConsoleLog("subcounty<><><", subcounty);
              $scope.subcounties = subcounty;
              $scope.places = places;
              // //console.log('***********', places[0]);
              // $scope.Location.countySubdivision = subcounty[0];
              $scope.Location.place = places[0];
            }
          },
          function (errorPayload) {
            growl.error("Something went wrong.");
          }
        );
      };

      $scope.checkState = function (rdata, val) {
        //MyService.ConsoleLog("State :", rdata);
        //MyService.ConsoleLog("State val :", val);
        var sdata = [];
        var len = rdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = rdata[i];
          var gdata = val.filter(function (obj) {
            if (
              rsdata.countyFips == obj.COUNTYFP &&
              rsdata.stateFips == obj.STATEFP
            ) {
              // //MyService.ConsoleLog(rdata[i]);
              return rdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(rdata[i]) == -1) {
              sdata.push(rdata[i]);
            }
          }

          if (j == len) {
            // //MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };

      $scope.checkCounty = function (rdata, val) {
        MyService.ConsoleLog("County :", rdata);
        MyService.ConsoleLog("County val :", val);
        var sdata = [];
        var len = rdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = rdata[i];
          var gdata = val.filter(function (obj) {
            // MyService.ConsoleLog("obj", obj);
            if (
              rsdata.countyFips == obj.COUNTYFP &&
              rsdata.stateFips == obj.STATEFP
            ) {
              MyService.ConsoleLog("rdata", rdata[i]);
              return rdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(rdata[i]) == -1) {
              sdata.push(rdata[i]);
            }
          }

          if (j == len) {
            // //MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };
      $scope.checksubCounty = function (rdata, val) {
        var sdata = [];
        var len = rdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = rdata[i];
          var gdata = val.filter(function (obj) {
            if (rsdata.countySubdivision == obj.NAME) {
              // //MyService.ConsoleLog(rdata[i]);
              return rdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(rdata[i]) == -1) {
              sdata.push(rdata[i]);
            }
          }

          if (j == len) {
            // //MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };
      $scope.checkPlaces = function (prdata, val) {
        var sdata = [];
        var len = prdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = prdata[i];
          var gdata = val.filter(function (obj) {
            // //MyService.ConsoleLog(rsdata.place +"=="+ obj.NAME);
            if (rsdata.place == obj.NAME && !rsdata.countyFips) {
              // //MyService.ConsoleLog(rdata[i]);
              return prdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(prdata[i]) == -1) {
              sdata.push(prdata[i]);
            }
          }

          if (j == len) {
            // //MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };

      $scope.emptyOrNull = function (item) {
        return !(
          item._id.place === null ||
          item._id.place === "" ||
          item._id.place === " "
        );
      };
      $scope.oldaddress = {
        state: "",
        county: "",
        countySubdivision: "",
        place: "",
      };
      $scope.showAddressDrop = false;
      $scope.showAddressDropDowns = function (zipcode, loc) {
        $scope.showZipLoader = true;
        // //console.log(zipcode);

        if (loc && loc != "") {
          MyService.getAllStates().then(
            function (payload) {
              $scope.allStateRes = payload;
              $scope.states = payload;
              // //MyService.ConsoleLog(" $scope.allStateRes :", $scope.allStateRes);
            },
            function (errorPayload) {
              growl.error("Something went wrong.");
            }
          );

          MyService.getOrganizedZipData({
            candidate: true,
            loc: loc,
          }).then(
            function (respo) {
              //MyService.ConsoleLog("mylog", respo);
              if (respo && respo.state) {
                // var finalData = payload.data;
                // //MyService.ConsoleLog(payload[0]);
                // //MyService.ConsoleLog(payload[0].countySubdivision);
                // //MyService.ConsoleLog(payload[0].county);
                // //MyService.ConsoleLog(payload[0].place);
                var countySubdivisions = respo.places.filter(function (obj) {
                  if (obj.COUSUBFP && obj.COUSUBFP != "") {
                    // //MyService.ConsoleLog("Inside cs");
                    return obj;
                  }
                });
                var places = respo.places.filter(function (obj) {
                  if (obj.PLACEFP && obj.PLACEFP != "") {
                    // //MyService.ConsoleLog("obj > ", obj);
                    return obj;
                  }
                });

                // //MyService.ConsoleLog("here");
                $scope.showZipLoader = false;
                $scope.showAddressDrop = true;
                // //MyService.ConsoleLog("countySubdivisions >> ", respo.state[0].NAME);

                $scope.oldaddress.state = respo.state;
                $scope.oldaddress.county = respo.county;
                $scope.oldaddress.countySubdivision = countySubdivisions;
                // //MyService.ConsoleLog("places >>> ",places);
                $scope.oldaddress.place = places;
                $scope.getCounties("new");

                $scope.getSubCounties("new");

                // $scope.voterDistricts = payload;
                // //MyService.ConsoleLog(payload.congressionalDistrict);
                $scope.federalCongrassionalDist = respo.congressionalDistrict;
                //MyService.ConsoleLog("@@@@@@ drop :", $scope.federalCongrassionalDist);

                $scope.stateSenateDistrict = respo.stateSenateDistrict;
                $scope.stateHouseOFRepresentativeDistricts =
                  respo.stateHouseofRepresentativesDistrict;
                $scope.unifiedSchoolDistrictNames = respo.unifiedSchoolDistrict;
                if (respo.cityCouncilDistrict) {
                  $scope.cityCouncilDistrict = respo.cityCouncilDistrict;
                }

                //$scope.$apply();
                //MyService.ConsoleLog("$scope.allStates :", $scope.allStates);
                // //MyService.ConsoleLog(payload[0].statePostalCode);
                var address = $scope.checkState(
                  $scope.allStateRes,
                  respo.state
                );
                $scope.allstatesData = address;
                // //MyService.ConsoleLog("address<>", address);
                // $scope.Location.state = address[0];
                // $scope.Location.voterDistrict = $scope.voterDistricts[0];
                $scope.Location.federalCongrassionalDist =
                  $scope.federalCongrassionalDist[0];
                $scope.Location.stateSenateDistrict =
                  $scope.stateSenateDistrict[0];
                $scope.Location.stateHouseOFRepresentativeDistrict =
                  $scope.stateHouseOFRepresentativeDistricts[0];
                $scope.Location.unifiedSchoolDistrictName =
                  $scope.unifiedSchoolDistrictNames[0];
                $scope.Location.cityCouncilDistrict = $scope.cityCouncilDistrict
                  ? $scope.cityCouncilDistrict[0]
                  : [];
                // //MyService.ConsoleLog("address ; ", address);
              } else {
                $scope.showZipLoader = false;
                alert("Zipcode not found in our database. Please correct it");
              }
            },
            function (errorPayload) {
              $scope.showZipLoader = false;
              growl.error(errorPayload);
            }
          );
        } else {
          MyService.getAllStates().then(
            function (payload) {
              $scope.allStateRes = payload;
              $scope.states = payload;
              // //MyService.ConsoleLog(" $scope.allStateRes :", $scope.allStateRes);
            },
            function (errorPayload) {
              growl.error("Something went wrong.");
            }
          );

          MyService.getOrganizedZipData({
            zipcode: zipcode,
            candidate: true,
          }).then(
            function (respo) {
              //MyService.ConsoleLog("mylog", respo);
              if (respo && respo.state) {
                // var finalData = payload.data;
                // //MyService.ConsoleLog(payload[0]);
                // //MyService.ConsoleLog(payload[0].countySubdivision);
                // //MyService.ConsoleLog(payload[0].county);
                // //MyService.ConsoleLog(payload[0].place);
                var countySubdivisions = respo.places.filter(function (obj) {
                  if (obj.COUSUBFP && obj.COUSUBFP != "") {
                    // //MyService.ConsoleLog("Inside cs");
                    return obj;
                  }
                });
                var places = respo.places.filter(function (obj) {
                  if (obj.PLACEFP && obj.PLACEFP != "") {
                    // //MyService.ConsoleLog("obj > ", obj);
                    return obj;
                  }
                });

                // //MyService.ConsoleLog("here");
                $scope.showZipLoader = false;
                $scope.showAddressDrop = true;
                // //MyService.ConsoleLog("countySubdivisions >> ", respo.state[0].NAME);

                $scope.oldaddress.state = respo.state;
                $scope.oldaddress.county = respo.county;
                $scope.oldaddress.countySubdivision = countySubdivisions;
                // //MyService.ConsoleLog("places >>> ",places);
                $scope.oldaddress.place = places;
                $scope.getCounties("new");

                $scope.getSubCounties("new");

                // $scope.voterDistricts = payload;
                // //MyService.ConsoleLog(payload.congressionalDistrict);
                $scope.federalCongrassionalDist = respo.congressionalDistrict;
                //MyService.ConsoleLog("@@@@@@ drop :", $scope.federalCongrassionalDist);

                $scope.stateSenateDistrict = respo.stateSenateDistrict;
                $scope.stateHouseOFRepresentativeDistricts =
                  respo.stateHouseofRepresentativesDistrict;
                $scope.unifiedSchoolDistrictNames = respo.unifiedSchoolDistrict;
                //$scope.$apply();
                //MyService.ConsoleLog("$scope.allStates :", $scope.allStates);
                // //MyService.ConsoleLog(payload[0].statePostalCode);
                var address = $scope.checkState(
                  $scope.allStateRes,
                  respo.state
                );
                $scope.allstatesData = address;
                // //MyService.ConsoleLog("address<>", address);
                // $scope.Location.state = address[0];
                // $scope.Location.voterDistrict = $scope.voterDistricts[0];
                //MyService.ConsoleLog("$scope.Location.federalCongrassionalDist :", $scope.federalCongrassionalDist[0]);
                $scope.Location.federalCongrassionalDist =
                  $scope.federalCongrassionalDist[0];
                $scope.Location.stateSenateDistrict =
                  $scope.stateSenateDistrict[0];
                $scope.Location.stateHouseOFRepresentativeDistrict =
                  $scope.stateHouseOFRepresentativeDistricts[0];
                $scope.Location.unifiedSchoolDistrictName =
                  $scope.unifiedSchoolDistrictNames[0];
                // //MyService.ConsoleLog("address ; ", address);
              } else {
                $scope.showZipLoader = false;
                alert("Zipcode not found in our database. Please correct it");
              }
            },
            function (errorPayload) {
              $scope.showZipLoader = false;
              growl.error(errorPayload);
            }
          );
        }
      };

      /*
    $scope.updateAddressNew = function() {
//MyService.ConsoleLog("Here");
//MyService.ConsoleLog($scope.result);
//MyService.ConsoleLog($scope.result.City);
      if ($scope.result.City && $scope.result.City.trim() != "") {

        var postobj = {
          userId: $rootScope.UserId,
          zipcode: $scope.findaddress.zipcode
        };

        var address = {};

        if ($scope.result.State) {
          address.statePostalCode = $scope.result.State;
        }

        if ($scope.result.PlaceName) {
          address.place = $scope.result.PlaceName;
        }

        if ($scope.result.County) {
          address.countyFips = $scope.result.CountyFIPS;
          address.county = $scope.result.CountyName;
        }

        if ($scope.result.CountySubdivisionName) {
          address.countySubdivisionFips = $scope.result.CountySubdivisionCode;
          address.countySubdivision = $scope.result.CountySubdivisionName;
        }

        if ($scope.result.CongressionalDistrict) {
          address.federalCongrassionalDist = $scope.result.CongressionalDistrict;
        }

        if ($scope.result.UnifiedSchoolDistrictName) {
          address.schoolDistrictFips = $scope.result.UnifiedSchoolDistrictCode;
          address.schoolDistrict = $scope.result.UnifiedSchoolDistrictName;
        }
        ////MyService.ConsoleLog(" $scope.address: ", address);
        postobj.address = JSON.stringify(address);
        //MyService.ConsoleLog("postobj.address: ", postobj);
        MyService.updateProfile(postobj).then(function(data) {
          //MyService.ConsoleLog(data);
          growl.error("Updated successfully.");
          $scope.closeThisDialog();
        }, function(err) {
          //MyService.ConsoleLog(err);
          growl.error("Something went wrong.");
        });
      }
    };
    */

      $scope.showFindAddress = function () {
        if (!$scope.showFAddress) {
          $scope.getZipData();
          $scope.showFAddress = true;
        } else {
          $scope.showFAddress = false;
        }
      };

      $scope.findaddress = {
        address: "",
        city: "",
        state: "",
        zipcode: "",
      };
      $scope.result = {
        city: "",
      };
      $scope.finddetailsclicked = false;
      $scope.getDetails = function (records) {
        var error = "";
        if ($scope.findaddress.address == "") {
          error = "Please enter address";
        }
        if (error == "" && $scope.findaddress.city == "") {
          error = "Please enter city";
        }
        if (error == "" && $scope.findaddress.state == "") {
          error = "Please enter state";
        }
        if (error == "" && $scope.findaddress.zipcode == "") {
          error = "Please enter zipcode";
        }

        if (error == "") {
          $scope.finddetailsclicked = true;
          // //MyService.ConsoleLog("=============Address==============");
          // //MyService.ConsoleLog($scope.findaddress);
          // //MyService.ConsoleLog("findaddress<><><>", records);
          var aurl =
            "https://personator.melissadata.net/v3/WEB/ContactVerify/doContactVerify";
          aurl += "?id=RyMI8jlzD6dHUApvp_3XRP**";
          aurl += "&cols=GrpCensus,GrpCensus2,GrpGeocode";
          aurl += "&a1=" + records.address;
          aurl += "&city=" + records.city;
          aurl += "&state=" + records.state;
          aurl += "&postal=" + records.zipcode;
          aurl += "&ctry=US";
          aurl += "&format=JSON";
          // var deferred = $q.defer();
          //var furl = "https://personator.melissadata.net/v3/WEB/ContactVerify/doContactVerify?id=RyMI8jlzD6dHUApvp_3XRP**&cols=GrpCensus,GrpCensus2,GrpGeocode&a1=" + records.address + "&city=" + records.city + "&state=" + records.state + "&postal=" + records.zipcode + "&ctry=US&format=JSON";
          // //MyService.ConsoleLog("furl <><>>", furl);
          $http.get(aurl).then(
            function successCallback(response) {
              //$scope.result = "";
              $scope.finddetailsclicked = false;
              if (response.statusText == "OK") {
                var rdata = response.data.Records[0];
                if (rdata) {
                  $scope.result = rdata;
                }
              }
              //MyService.ConsoleLog("response", response);
            },
            function errorCallBack(error) {
              $scope.finddetailsclicked = false;
              // //MyService.ConsoleLog(error);
            }
          );
        } else {
          alert(error);
        }
      };

      $scope.checkLength = function (vdata, val) {
        var data = vdata.map(function (sub) {
          var returnval = "";
          switch (val) {
            case "federalCongrassionalDist":
              returnval = sub.federalCongrassionalDist;
              break;
            case "stateSenateDistrict":
              returnval = sub.stateSenateDistrict;
              break;
            case "stateHouseOFRepresentativeDistrict":
              returnval = sub.stateHouseOFRepresentativeDistrict;
              break;
            case "unifiedSchoolDistrictName":
              returnval = sub.unifiedSchoolDistrictName;
              break;
            case "cityCouncilDistrict":
              returnval = sub.COUNTDIST;
              break;
            case "default":
              returnval = sub.federalCongrassionalDist;
              break;
          }
          return returnval;
        });

        var ndata = $filter("unique")(data);
        if (ndata.length > 1) {
          return "yellowBackground";
        } else {
          return "";
        }
      };

      function remove(array, element) {
        const index = array.indexOf(element);

        if (index !== -1) {
          array.splice(index, 1);
        }
      }

      // $scope.oldAddress = "";
      $scope.checkZipAddress = function (val) {
        // //MyService.ConsoleLog("Main<><><>", $scope.mainAddress);
        // $scope.oldAddress = angular.copy($scope.mainAddress);
        // //MyService.ConsoleLog("main<><><", $scope.mainAddress);
        // //MyService.ConsoleLog("val+==", val);

        if ($scope.mainAddress.stateHouseOFRepresentativeDistrict) {
          var stateHouseOFRepresentativeDistrict =
            $scope.mainAddress.stateHouseOFRepresentativeDistrict.filter(
              function (rdata) {
                if (parseInt(rdata) == parseInt(val.StateDistrictLower)) {
                  return rdata;
                }
              }
            );
          //MyService.ConsoleLog("stateHouseOFRepresentativeDistrict<><><>", stateHouseOFRepresentativeDistrict);
          $scope.setSelectedDropdown(
            stateHouseOFRepresentativeDistrict,
            "stateHouseOFRepresentativeDistrict",
            stateHouseOFRepresentativeDistrict[0]
          );
          // $scope.address.stateSenateDistrict = stateHouseOFRepresentativeDistrict[0];
        }
        if ($scope.mainAddress.stateSenateDistrict) {
          var stateSenateDistrict =
            $scope.mainAddress.stateSenateDistrict.filter(function (rdata) {
              if (parseInt(rdata) == parseInt(val.StateDistrictUpper)) {
                return rdata;
              }
            });
          //MyService.ConsoleLog("stateSenateDistrict<><><>", stateSenateDistrict);
          $scope.setSelectedDropdown(
            stateSenateDistrict,
            "stateSenateDistrict",
            stateSenateDistrict[0]
          );
          // $scope.address.stateLegislativeDistrict = stateSenateDistrict[0];
        }
        //MyService.ConsoleLog("voterDistricts<><><", $scope.mainAddress.voterDistricts);
        $scope.setSelectedDropdown(
          $scope.mainAddress.voterDistricts,
          "voterDistricts",
          $scope.userAddress
        );
        if ($scope.mainAddress.federalCongrassionalDist) {
          var federalCongrassionalDist =
            $scope.mainAddress.federalCongrassionalDist.filter(function (
              rdata
            ) {
              if (parseInt(rdata) == parseInt(val.CongressionalDistrict)) {
                return rdata;
              }
            });
          //MyService.ConsoleLog("federalCongrassionalDist<><><>", federalCongrassionalDist);
          $scope.setSelectedDropdown(
            federalCongrassionalDist,
            "federalCongrassionalDist",
            federalCongrassionalDist[0]
          );
        }
        if ($scope.mainAddress.schoolDistricts) {
          var schoolDistricts = $scope.mainAddress.schoolDistricts.filter(
            function (rdata) {
              if (
                parseInt(rdata.number) ==
                parseInt(val.UnifiedSchoolDistrictCode)
              ) {
                return rdata;
              }
            }
          );
          //MyService.ConsoleLog("schoolDistricts<><><>", schoolDistricts);
          if (schoolDistricts[0] && schoolDistricts[0].number) {
            $scope.setSelectedDropdown(
              schoolDistricts,
              "schoolDistricts",
              schoolDistricts[0].number
            );
          } else {
            $scope.setSelectedDropdown(
              schoolDistricts,
              "schoolDistricts",
              null
            );
          }
        }
        if ($scope.mainAddress.subCounties) {
          var subCounties = $scope.mainAddress.subCounties.filter(function (
            rdata
          ) {
            if (parseInt(rdata.number) == parseInt(val.CountySubdivisionCode)) {
              return rdata;
            }
          });
          //MyService.ConsoleLog("subCounties<><><>", subCounties);
          if (schoolDistricts[0] && schoolDistricts[0].number) {
            $scope.setSelectedDropdown(
              subCounties,
              "subCounties",
              subCounties[0].number
            );
          } else {
            $scope.setSelectedDropdown(subCounties, "subCounties", null);
          }
        }

        /*\
      if (zipData.counties) $scope.setSelectedDropdown(zipData.counties, 'counties', $scope.userAddress);

                  if (zipData.subCounties) $scope.setSelectedDropdown(zipData.subCounties, "subCounties", $scope.userAddress);

                  if (zipData.places) $scope.setSelectedDropdown(zipData.places, "places", $scope.userAddress);

                  if (zipData.voterDistricts) $scope.setSelectedDropdown(zipData.voterDistricts, "voterDistricts", $scope.userAddress);

                  if (zipData.federalCongrassionalDist) $scope.setSelectedDropdown(zipData.federalCongrassionalDist, "federalCongrassionalDist", $scope.userAddress);

                  if (zipData.stateSenateDistrict) $scope.setSelectedDropdown(zipData.stateSenateDistrict, "stateSenateDistrict", $scope.userAddress);

                  if (zipData.stateHouseOFRepresentativeDistrict) $scope.setSelectedDropdown(zipData.stateHouseOFRepresentativeDistrict, "stateHouseOFRepresentativeDistrict", $scope.userAddress);

                  if (zipData.schoolDistricts) $scope.setSelectedDropdown(zipData.schoolDistricts, "schoolDistricts", $scope.userAddress);
            return $scope.mainAddress.filter(
              function(rdata) {
                // //MyService.ConsoleLog("Space:", parseInt(val.CongressionalDistrict));
                if (val.CongressionalDistrict == "" || val.CongressionalDistrict == " ") {
                  // //MyService.ConsoleLog("inside<><><><><>");
                  if (parseInt(rdata.FIPScounty) == parseInt(val.CountyFIPS) && parseInt(rdata.FIPScountySub) == parseInt(val.CountySubdivisionCode) && parseInt(rdata.stateHouseOFRepresentativeDistrict) ==
                    parseInt(val.StateDistrictLower) && parseInt(rdata.stateSenateDistrict) == parseInt(val.StateDistrictUpper) && parseInt(rdata.unifiedSchoolDistrict) == parseInt(val.UnifiedSchoolDistrictCode)) {
                    // //MyService.ConsoleLog("This is a match");
                    return rdata;
                  }
                } else {
                  if (parseInt(rdata.FIPScounty) == parseInt(val.CountyFIPS) && parseInt(rdata.FIPScountySub) == parseInt(val.CountySubdivisionCode) && parseInt(rdata.federalCongrassionalDist) == parseInt(val.CongressionalDistrict) && parseInt(rdata.stateHouseOFRepresentativeDistrict) ==
                    parseInt(val.StateDistrictLower) && parseInt(rdata.stateSenateDistrict) == parseInt(val.StateDistrictUpper) && parseInt(rdata.unifiedSchoolDistrict) == parseInt(val.UnifiedSchoolDistrictCode)) {
                    // //MyService.ConsoleLog("This is a match2");
                    return rdata;
                  }

                }
              }
            );
            */
      };

      $scope.setAddressNew = function (address) {
        MyService.ConsoleLog("setAddressNew > ", address);

        if ($scope.statusGetStates == 2 && $scope.statusGetZipdata == 2) {
          var postobj = {
            userId: $rootScope.UserId,
            zipcode: "",
          };

          var add = {};

          if (address.state) {
            add.state = address.state.state;
            add.statePostalCode = address.state.statePostalCode;
            add.stateFips = address.state.stateFips;
            //MyService.ConsoleLog("address.statePostalCode :", address.state);
          }

          if (address.place) {
            add.placeFips = address.place.placeFips;
            add.place = address.place.placeName;
          }

          if (address.county) {
            add.countyFips = address.county.countyFips;
            add.county = address.county.countyName;
          }

          if (address.subcounty) {
            add.countySubdivisionFips = address.subcounty.COUSUBFP;
            add.countySubdivision = address.subcounty.NAME;
          }

          if (address.federalCongrassionalDist) {
            add.federalCongrassionalDist =
              address.federalCongrassionalDist.CD115FP;
          }

          if (address.stateSenateDistrict) {
            add.stateSenateDistrict = address.stateSenateDistrict.SLDUST;
          }

          if (address.cityCouncilDistrict) {
            add.cityCouncilDistrictName = address.cityCouncilDistrict.COUNTDIST;
          }

          if (address.unifiedSchoolDistrictName) {
            add.schoolDistrictFips = address.unifiedSchoolDistrictName.UNSDLEA;
            add.schoolDistrict = address.unifiedSchoolDistrictName.NAME;
          }

          // if ($scope.address.voterDistrict) {
          //   address.voterDistrictFips = $scope.address.voterDistrict.number;
          //   address.voterDistrict = $scope.address.voterDistrict.name;
          // }

          if (address.stateHouseOFRepresentativeDistrict) {
            var str = address.stateHouseOFRepresentativeDistrict.NAMELSAD;
            // MyService.ConsoleLog("address.stateLegislativeDistrict.NAMELSAD >>>>", str);

            var newString = str.substr(0, str.length - 3);
            MyService.ConsoleLog("newString >>>>", str.indexOf("General"));
            if (str.indexOf("General Assembly District") > -1) {
              add.legislativeDistrict = str.replace(
                "General Assembly District ",
                ""
              );
            } else if (str.indexOf("Assembly District") > -1) {
              add.legislativeDistrict = str.replace("Assembly District ", "");
            } else {
              add.legislativeDistrict = str.replace(
                "State House District ",
                ""
              );
            }

            // alert(add.legislativeDistrict);
            /*  switch (newString) {

              case "General Assembly District":
                add.legislativeDistrict = address.stateHouseOFRepresentativeDistrict.NAMELSAD.replace("General Assembly District ", "");
                break;
              case "Assembly District":
                add.legislativeDistrict = address.stateHouseOFRepresentativeDistrict.NAMELSAD.replace("Assembly District ", "");
                break;
              case "State House District":
                add.legislativeDistrict = address.stateHouseOFRepresentativeDistrict.NAMELSAD.replace("State House District ", "");
                break;

              default:
                break;
            }*/
          }

          var finalLoc = JSON.parse($scope.loc);
          //MyService.ConsoleLog(" $scope.address: ", finalLoc);

          add.loca = {
            type: "Point",
            coordinates: [finalLoc.longitude, finalLoc.latitude],
          };

          // alert("got");

          //MyService.ConsoleLog(">>>>>>>>>> add >>>>>>>>>>>: ", address);
          postobj.mailingAddress = $scope.mailing_Address
            ? $scope.mailing_Address
            : "";

          postobj.address = JSON.stringify(add);
          //MyService.ConsoleLog("postobj.address: ", postobj);

          MyService.updateProfile(postobj).then(
            function (data) {
              setTimeout(function () {
                growl.success("Updated successfully.");
              }, 200);

              // $scope.setAddressNew();
              try {
                MyService.ConsoleLog(
                  "$scope.userAddress.flag",
                  $scope.userAddress.flag
                );
                if ($scope.userAddress.flag && $scope.userAddress.flag != "") {
                  $location.path("/userProfile");
                } else {
                  MyService.ConsoleLog("else >> ");
                }
              } catch (err) {
                console.log("err");

                if (window.localStorage.getItem("isFiveMinPage") != "") {
                  $location.path("/fiveCompare/skip_to_result#DisplayQ");
                }
              }
              $scope.closeThisDialog();
            },
            function (err) {
              console.log("err >> ", err);
              growl.error("Something went wrong.");
            }
          );
        }
      };

      $scope.onVoterDistChange();
    },
  ]);

'use strict';
angular
  .module('myApp.popularQuizMatch', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/popularQuizMatch/:flag?', {
        templateUrl: 'app/popularQuizMatch/popularQuizMatch.html',
        controller: 'popularQuizMatchCtrl',
      });
    },
  ])
  .controller('popularQuizMatchCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    '$routeParams',
    '$rootScope',
    '$q',
    '$timeout',
    'tokenService',
    'MyService',
    '$anchorScroll',
    '$cookies',
    'ngDialog',
    'growl',
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $rootScope,
      $q,
      $timeout,
      tokenService,
      MyService,
      $anchorScroll,
      $cookies,
      ngDialog,
      growl
    ) {
      $scope.page = 1;
      $scope.maxRecordsPerPg = 10000;
      $scope.showPoliAnswerDetails = false;
      $scope.showUserAnswerDetails = false;
      $scope.noDataFound = false;
      $scope.showcomparison = false;
      $scope.showComment = false;
      $scope.unComment = false;
      $scope.showCurr = false;
      $scope.showAdv = false;
      $scope.showVoter = false;
      $scope.showPolitician = false;
      $scope.showLoader = false;

      if (tokenService.getUserId()) {
        $scope.userId = tokenService.getUserId();
        console.log('$scope.userId: ', $scope.userId);
      }

      var param = {};
      param.page = $scope.page;
      param.max_records = $scope.maxRecordsPerPg;

      MyService.ConsoleLog("window.localStorage.getItem('fiveMatch');", window.localStorage.getItem('fiveMatch'));

      if (window.localStorage.getItem('fiveMatch')) {

        $rootScope.queData = window.localStorage.getItem('fiveMatch');
        MyService.ConsoleLog("main Data>>", JSON.parse($rootScope.queData));
        var tempData = JSON.parse($rootScope.queData);
        var queDatas = tempData.filter(function (itms) {
          if (itms && !itms.questionId) {
            return itms;
          }
        });
        $rootScope.queData = "";
        $rootScope.queData = JSON.stringify(queDatas);
        MyService.ConsoleLog("queDatas", queDatas);
      }

      /**
       * Remove values from localStorage on page load
       */
      window.localStorage.removeItem('comOfPolitician');
      window.localStorage.removeItem('comOfVoter');
      window.localStorage.removeItem('comOfAdv');
      window.localStorage.removeItem('comOfGuest');
      window.localStorage.removeItem('poliAr');
      window.localStorage.removeItem('voter');
      window.localStorage.removeItem('adv');
      window.localStorage.removeItem('unVerify');
      window.localStorage.removeItem('cuUser');
      $cookies.remove('orgName');

      if (tokenService.getUserId()) {
        // alert('sssss');
        $scope.userData = JSON.parse(tokenService.getUserData());
        MyService.ConsoleLog("$scope.userData >", $scope.userData);
        MyService.ConsoleLog("$scope.userData >", $scope.userData.address);


        // $rootScope.tempUserAddress = "";
        $rootScope.tempUserAddress = $scope.userData.address;
        console.log('$rootScope.tempUserAddress >>> ', $rootScope.tempUserAddress);
        // }

        // var nAddobj = new Object;

        // nAddobj.state = $scope.mainAddress.state.state;
        // nAddobj.stateFips = $scope.mainAddress.state.stateFips;
        // nAddobj.statePostalCode = $scope.mainAddress.state.statePostalCode;

        // nAddobj.county = $scope.mainAddress.county ? $scope.mainAddress.county.county : "";
        // nAddobj.countyFips = $scope.mainAddress.county ? $scope.mainAddress.county.countyFips : "";
        // if ($scope.mainAddress.place && $scope.mainAddress.place != "") {
        //   nAddobj.place = $scope.mainAddress.place.place;
        //   nAddobj.placeFips = $scope.mainAddress.place.placeFips;
        // }

        // nAddobj.federalCongrassionalDist = $scope.mainAddress.federalCongrassionalDist ? $scope.mainAddress.federalCongrassionalDist.CD115FP : "";

        // nAddobj.stateSenateDistrict = $scope.mainAddress.stateSenateDistrict ? $scope.mainAddress.stateSenateDistrict.SLDUST : "";

        // nAddobj.legislativeDistrict = $scope.mainAddress.stateHouseOFRepresentativeDistrict ? $scope.mainAddress.stateHouseOFRepresentativeDistrict.NAMELSAD.replace("State House District ", "") : "";

        // nAddobj.schoolDistrict = $scope.mainAddress.unifiedSchoolDistrictName ? $scope.mainAddress.unifiedSchoolDistrictName.NAME : '';

        // nAddobj.schoolDistrictFips = $scope.mainAddress.unifiedSchoolDistrictName ? $scope.mainAddress.unifiedSchoolDistrictName.UNSDLEA : '';
        // console.log("nAddobj > ", nAddobj);
        // $rootScope.tempUserAddress = nAddobj;
      }


      $scope.changeColor = function (nper, inx, cur_ans) {

        // MyService.ConsoleLog("inx", inx);
        // MyService.ConsoleLog("cur_ans", cur_ans);

        var arrOfCol = {
          "5": "#990000",
          "4": "#cc3300",
          "3": "#ff9933",
          "2": "#ffff00",
          "1": "#99cc00",
          "0": "#00d900"
        };
        var cdiff = Math.abs(inx - cur_ans);

        // console.log("arrOfCol > ", arrOfCol);
        $scope.gr = null;
        switch (true) {
          case (nper >= 100):
            if (cur_ans == inx) {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[0] + " " + nper + "%, #2b4f7f 10%)"
              };
            } else {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[cdiff] + " " + nper + "%, #2b4f7f 10%)"
              };
            }

            // MyService.ConsoleLog("$scope.gr >>", arrOfCol.nper);
            break;
          case (nper >= 80):
            if (cur_ans == inx) {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[0] + " " + nper + "%, #2b4f7f 10%)"
              };
            } else {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[cdiff] + " " + nper + "%, #2b4f7f 10%)"
              };
            }
            break;
          case (nper >= 60):
            if (cur_ans == inx) {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[0] + " " + nper + "%, #2b4f7f 10%)"
              };
            } else {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[cdiff] + " " + nper + "%, #2b4f7f 10%)"
              };
            }
            break;
          case (nper >= 40):
            if (cur_ans == inx) {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[0] + " " + nper + "%, #2b4f7f 10%)"
              };
            } else {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[cdiff] + " " + nper + "%, #2b4f7f 10%)"
              };
            }
            break;
          case (nper >= 20):
            if (cur_ans == inx) {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[0] + " " + nper + "%, #2b4f7f 10%)"
              };
            } else {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[cdiff] + " " + nper + "%, #2b4f7f 10%)"
              };
            }
            break;
          case (nper >= 0):
            if (cur_ans == inx) {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[0] + " " + nper + "%, #2b4f7f 10%)"
              };
            } else {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[cdiff] + " " + nper + "%, #2b4f7f 10%)"
              };
            }
            break;

          default:
            break;
        }
        // MyService.ConsoleLog(" $scope.gr", $scope.gr);
        return $scope.gr;

      };


      /** Return class of background color */

      $scope.getComapreClass = function (match, i) {

        if (match >= 100) return 'ag-dg1';
        if (match >= 80) return 'ag-dg2';
        if (match >= 60) return 'ag-dg3';
        if (match >= 40) return 'ag-dg4';
        if (match >= 20) return 'ag-dg5';
        if (match >= 0) return 'ag-dg6';

        return 'ag-dg';
      };



      /**
       * This function calls on page load
       * fetch data of user's area politician ,voters and advocates
       */

      $scope.getLocalPoliticians = function (id) {
        // alert('inside');
        $scope.showLoader = true;
        // MyService.ConsoleLog(" welcome to getLocalPoliticians ", $rootScope.queData);
        $scope.statusGetLocalPoliticians = 1;
        $scope.page += 1;
        $scope.loader = true;

        var extradata = new Object();
        if ($rootScope.tempUserAddress) {
          if ($rootScope.tempUserAddress.state && $rootScope.tempUserAddress.state != '') {
            extradata.statePostalCode = $rootScope.tempUserAddress.statePostalCode;
          }
          if ($rootScope.tempUserAddress.county && $rootScope.tempUserAddress.countyFips) {
            $rootScope.tempUserAddress.FinalData = JSON.stringify(
              $rootScope.tempUserAddress.countyFips
            );
            extradata.county = $rootScope.tempUserAddress.county;
          }
          if (
            $rootScope.tempUserAddress.countySubdivision &&
            $rootScope.tempUserAddress.countySubdivisionFips
          ) {
            $rootScope.tempUserAddress.FinalData = JSON.stringify(
              $rootScope.tempUserAddress.countySubdivisionFips
            );
            extradata.countySubdivision = $rootScope.tempUserAddress.countySubdivision;
          }
          if ($rootScope.tempUserAddress.place && $rootScope.tempUserAddress.placeFips) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.place = $rootScope.tempUserAddress.place;
          }
          if (
            $rootScope.tempUserAddress.voterDistrict &&
            $rootScope.tempUserAddress.voterDistrictFips
          ) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.voterDistrict = $rootScope.tempUserAddress.voterDistrict;
          }
          if ($rootScope.tempUserAddress.federalCongrassionalDist) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            MyService.ConsoleLog(
              'federalCongrassionalDist  :',
              $rootScope.tempUserAddress.federalCongrassionalDist
            );
            extradata.federalCongrassionalDist =
              $rootScope.tempUserAddress.federalCongrassionalDist;
          }
          if ($rootScope.tempUserAddress.stateSenateDistrict) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.stateSenateDistrict = $rootScope.tempUserAddress.stateSenateDistrict;
          }
          if ($rootScope.tempUserAddress.legislativeDistrict) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.legislativeDistrict = $rootScope.tempUserAddress.legislativeDistrict;
          }
          if ($rootScope.tempUserAddress.schoolDistrict) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.schoolDistrict = $rootScope.tempUserAddress.schoolDistrict;
          }
        }
        MyService.ConsoleLog('extradata : >>>>>>>>>> ', JSON.stringify(extradata));
        MyService.getAllLocalPoli({
          max_records: 100,
          page: $scope.page,
          extradata: JSON.stringify(extradata),
        }).then(
          function (response) {
            if (response.data.success) {
              setTimeout(function () {
                $scope.$apply(function () {
                  if (response.data.data.length > 0) {
                    MyService.getAdvocates().then(function (payload) {
                      MyService.ConsoleLog("Response >", payload);
                      var ndata = response.data.data;
                      var wdata = ndata.concat(payload.data.data);
                      $scope.userAreaPolitician = wdata.map(function (ques) {
                        return ques._id;
                      });
                      // MyService.ConsoleLog(" $scope.userAreaPolitician >", $scope.userAreaPolitician);
                      var param = JSON.stringify({
                        usersIds: $scope.userAreaPolitician,
                        cur_userId: $scope.userId,
                        questions: $rootScope.queData
                      });

                      // MyService.ConsoleLog("apra >", param);
                      // window.localStorage.removeItem('comData');
                      window.localStorage.setItem('comData', param);
                      var indx;
                      if (id && id != "") {
                        indx = id;
                        MyService.ConsoleLog("Inds >>>>>>>>", indx);
                      } else {
                        $scope.currentIndex = 0;
                        indx = $scope.currentIndex;
                        MyService.ConsoleLog(" $scope.currentIndex >", indx);
                      }
                      // alert('called');
                      MyService.ConsoleLog("$rootScope.queData", $rootScope.queData);
                      var main = JSON.parse($rootScope.queData);
                      MyService.ConsoleLog(' $scope.quData :', main[indx]);
                      // MyService.ConsoleLog("<<<<<<<<<<<<<<<<>>>>>>>>>>>>>>>>>>>>>", typeof $scope.userAreaPolitician)
                      // MyService.ConsoleLog("<<<<<<<<<<<<<<<<>>>>>>>>>>>>>>>>>>>>>", $scope.userAreaPolitician)
                      $scope.userAreaPolitician = [];
                      $scope.userAreaPolitician.push($cookies.get('advId'));
                      MyService.ConsoleLog("<<<<<<<<<<<<<<<<>>>>>>>>>>>>>>>>>>>>>", $scope.userAreaPolitician)
                      // return;
                      $scope.compareAll({
                        userIds: JSON.stringify($scope.userAreaPolitician),
                        quiz: JSON.stringify(main[indx]),
                        userData: $scope.userId
                      });
                    }, function (err) {
                      MyService.ConsoleLog("Error >>", err);
                    });
                  } else {
                    $scope.loader = false;
                    var message =
                      'None of your politicians have answered the questions yet. Contact them and ask them to fill it out.';
                    var modal = ngDialog.openConfirm({
                      template: '<p>' +
                        message +
                        '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">OK</button>\
                            \
                        </div>',
                      plain: true,
                    });

                    modal.then(
                      function fullfilled(data) {
                        //MyService.ConsoleLog("fullfilled: ", data);
                        if (data == 1) {
                          // $scope.postonFacebook();
                        } else {
                          if ($rootScope.userRole) {
                            $location.path('/snapshot');
                          } else {
                            $location.path('/signin');
                          }
                        }
                      },
                      function rejected(data) {
                        //MyService.ConsoleLog("rejected: ", data);
                      }
                    );
                  }
                });
              }, 100);
            } else {
              $scope.page -= 1;
              $scope.statusGetLocalPoliticians = 3;
              if (typeof response.data.error == 'string') growl.error(response.data.error);
              else growl.error('Something went wrong');
            }
          },
          function (err) {
            $scope.page -= 1;
            $scope.statusGetLocalPoliticians = 3;
            $scope.loader = false;
            growl.error(err);
          }
        );
      };

      /**End of getLocalPoliticians */

      if (tokenService.getUserId()) {
        $scope.getLocalPoliticians();
      }



      /**
       * This function redirects to show answers page
       */

      $scope.showAnswers = function (ans, type, qId, chAns, ind) {
        MyService.ConsoleLog("Ind", ind);
        MyService.ConsoleLog("qId", qId);

        if (!ind) {
          ind = 0;
        }
        if (chAns) {
          if (!chAns[ind + 1]) {
            // alert("This");
            growl.error("No users to see here");
          } else {
            // if (chAns != "") {
            //   alert('dahdaj');
            // }
            MyService.ConsoleLog("Type >>", type);
            MyService.ConsoleLog("qId >>", qId);
            MyService.ConsoleLog("chAns >>", chAns);
            $cookies.put('orgName', $scope.orgName);
            $location.path('/showAnswers/' + type + '/' + ans + '/' + qId + '/' + chAns);
          }
        } else {
          // alert('not Found');
          switch (type) {
            case 'politician':
              growl.error('None of politicians of your area answered for this question');
              break;
            case 'voter':
              growl.error('None of voter of your area answered for this question');
              break;
            case 'advocate':
              growl.error('None of organizations of your area answered for this question');
              break;

            default:

              break;
          }
        }
      };

      /**
       * This function show the details of answered questions
       * showAnswersDetail
       */

      $scope.showAnswersDetail = function (para) {
        MyService.ConsoleLog('para >', para);

        switch (para) {
          case 'politician':
            var newObj = JSON.stringify({
              poli: $scope.arrayOfCom,
              qId: $scope.questions[$scope.currentIndex]._id
            });
            window.localStorage.setItem('poliAr', newObj);
            $location.path('/showGroupAnswer/' + '' + '/' + '' + '/' + true);
            // $scope.showPoliAnswerDetails = true;
            break;

          case 'voter':
            var vObj = JSON.stringify({
              vot: $scope.voterComArr,
              qId: $scope.questions[$scope.currentIndex]._id
            });
            window.localStorage.setItem('voter', vObj);
            $location.path('/showGroupAnswer/' + '' + '/' + '' + '/' + true);
            // $location.path('/showGroupAnswer');
            // $scope.showPoliAnswerDetails = true;
            break;
          case 'advocate':
            var advo = JSON.stringify({
              adv: $scope.advComArr,
              qId: $scope.questions[$scope.currentIndex]._id
            });
            window.localStorage.setItem('adv', advo);
            $cookies.put('orgName', $scope.orgName);
            // $location.path('/showGroupAnswer');
            $location.path('/showGroupAnswer/' + '' + '/' + '' + '/' + true);

            // $scope.showPoliAnswerDetails = true;
            break;
          default:

            break;
        }

        // if (para == 'politician') {
        //   $scope.showPoliAnswerDetails = true;
        // } else {
        //   $scope.showUserAnswerDetails = true;
        // }
      };

      /**End Of showAnswersDetail */


      /** This function fetch comparison results using
       ** @ Params @
       ** guest user data and politician data
       **/

      $scope.compareAll = function (params) {

        MyService.getPopularMatch(params).then(
          function (payload) {
            MyService.ConsoleLog('Response >>>', payload);

            if (payload.data.success) {
              // if (Object.keys($scope.advocate).length > 0 || Object.keys($scope.voter).length > 0 || Object.keys($scope.emailRegistered).length > 0) {
              $scope.questions = JSON.parse($rootScope.queData);

              if ((JSON.stringify(payload.data.data.agrriOfEmail) != JSON.stringify({})) || (JSON.stringify(payload.data.data.aggriOfAdvocate) != JSON.stringify({}))) {
                MyService.ConsoleLog(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
                $scope.emailRegistered = payload.data.data.agrriOfEmail;
                MyService.ConsoleLog("$scope.emailRegistered >", $scope.emailRegistered);


                $scope.emailImpo = payload.data.data.aggriOfEmailImportance;


                // MyService.ConsoleLog("JSON.parse($rootScope.queData)", JSON.parse($rootScope.queData));
                // MyService.ConsoleLog('$scope.questions TWo >>>', $scope.questions);
                $scope.FBCompareList = payload.data.data.qdata;
                $scope.ansCount = payload.data.data.ansCount;

                $scope.impCount = payload.data.data.impCount;


                // MyService.ConsoleLog('ansCount >', $scope.impCount);
                $scope.globalFlag = payload.data.data.checkFlag;
                $scope.arrayOfCom = payload.data.data.commArr;

                $scope.voter = payload.data.data.aggriOfVoter;
                $scope.voterImp = payload.data.data.aggriOfVoterImportance;
                $scope.voterAnsCount = payload.data.data.voterAnsCount;
                $scope.voterImpCount = payload.data.data.voterImpCount;
                $scope.flagOfVoter = payload.data.data.voterFlag;
                $scope.voterComArr = payload.data.data.voterComArr;
                $scope.advocate = payload.data.data.aggriOfAdvocate;
                $scope.advocateAns = payload.data.data.advocateObj;
                $scope.advocateImpAggri = payload.data.data.aggriOfAdvocateImportance;
                $scope.advocateimpObj = payload.data.data.advocateimpObj;
                $scope.advocateFlag = payload.data.data.advFlag;
                $scope.advComArr = payload.data.data.advcommArr;
                $scope.orgName = payload.data.data.orgName;


                if (Object.keys($scope.advocate).length > 0) {
                  $scope.showAdv = true;
                }
                if (Object.keys($scope.voter).length > 0) {
                  $scope.showVoter = true;
                }
                if (Object.keys($scope.emailRegistered).length > 0) {
                  $scope.showPolitician = true;
                }

                if (JSON.stringify(payload.data.data.aggriOfAdvocate) == JSON.stringify({})) {
                  // alert('is');

                  growl.error("The organization has not answered the questions");
                }
                $scope.showLoader = false;
              } else {
                $scope.showLoader = false;
                // growl.error("The organization has not answered the questions");
                // alert('sho');?
                var message = 'The organization has not answered this question';
                var modal = ngDialog.openConfirm({
                  template: '<p>' +
                    message +
                    '</p>\
                  <div class="ngdialog-buttons">\
                      <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(0)">OK</button>\
                  </div>',
                  plain: true,
                  closeByDocument: false,
                });
                modal.then(
                  function fullfilled(data) {

                  },
                  function rejected(data) {
                    // MyService.ConsoleLog("rejected: ", data);
                    // $scope.getMatchQUestions();
                  }
                );
                MyService.ConsoleLog(">>>>>>>>>>>>>>>>>>>>>>>> elseeeeeeeeee >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
              }
            }
          },
          function (error) {
            $scope.showLoader = false;
            MyService.ConsoleLog('Error >>', error);
          }
        );
      };

      /**This function redirects to show comment page */
      $scope.viewAnsComment = function (val) {
        MyService.ConsoleLog('called', val);

        switch (val) {
          case 'email':
            $scope.global = $scope.arrayOfCom;
            if ($scope.userId) {
              var poli = JSON.stringify({
                poliArr: $scope.arrayOfCom,
                queId: $scope.questions[$scope.currentIndex]._id
              });
              window.localStorage.setItem('comOfPolitician', poli);
              $location.path('/showComments');
            }
            $scope.showComment = true;
            $scope.unComment = false;
            $scope.showCurr = false;

            break;
          case 'unRegister':
            if ($scope.userId) {
              var guest = JSON.stringify({
                guestArr: $scope.unVeriComm,
                queId: $scope.questions[$scope.currentIndex]._id
              });
              window.localStorage.setItem('comOfGuest', guest);
              $location.path('/showComments');
            }
            $scope.unComment = true;
            $scope.showComment = false;
            $scope.showCurr = false;

            break;
          case 'voter':
            $scope.global = $scope.voterComArr;
            // MyService.ConsoleLog("$scope.voterComArr", $scope.voterComArr);
            if ($scope.userId) {
              var vo = JSON.stringify({
                compArr: $scope.voterComArr,
                queId: $scope.questions[$scope.currentIndex]._id
              });
              // MyService.ConsoleLog("vo >>", vo);
              window.localStorage.setItem('comOfVoter', vo);
              $location.path('/showComments');
            }
            $scope.showComment = true;
            $scope.unComment = false;
            $scope.showCurr = false;

            break;
          case 'advocate':
            $scope.global = $scope.advComArr;
            if ($scope.userId) {
              var adv = JSON.stringify({
                advArr: $scope.advComArr,
                queId: $scope.questions[$scope.currentIndex]._id
              });
              $cookies.put('orgName', $scope.orgName);
              window.localStorage.setItem('comOfAdv', adv);
              $location.path('/showComments');
            }
            $scope.showComment = true;
            $scope.unComment = false;
            $scope.showCurr = false;

            break;
          case 'currentUser':
            if ($scope.userId) {
              var curUser = JSON.stringify({
                curuser: $scope.questions[$scope.currentIndex]
              });
              window.localStorage.setItem('cuUser', curUser);
              $location.path('/showComments');
            }
            $scope.showComment = false;
            $scope.showCurr = true;
            $scope.unComment = false;
            break;
          default:

            break;
        }
      };
      $scope.back = function () {
        $scope.showPoliAnswerDetails = false;
        $scope.showUserAnswerDetails = false;
        $scope.showComment = false;
        $scope.unComment = false;
        $scope.showCurr = false;

      };

      $scope.status = {
        questions: 0, //1=loading, 2=loaded, 3=error
        category: 0,
      };

      var getCompareAnswersCanceler = $q.defer();


      $scope.prevQuestion = function () {
        //MyService.ConsoleLog("** prevQuestion **");
        $timeout(function () {
          $location.hash('DisplayQ');
          $anchorScroll();
        }, 1500);
        if ($scope.currentIndex > 0) {
          var decr = $scope.currentIndex--;
          var one = decr - 1;
          MyService.ConsoleLog("decr", one);
          if ($scope.userId) {
            $scope.getLocalPoliticians(one);
          }
        } else if ($scope.currentIndex == 0) {
          if ($scope.currBackgroundIndex > 0) {
            $scope.currBackgroundIndex--;
            MyService.ConsoleLog('$scope.traverseBackgrounds >', $scope.traverseBackgrounds);
            $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
          } else {
            //MyService.ConsoleLog("** end of background **");
            if ($scope.rootCatIndex > 0) {
              $scope.rootCatIndex--;
              $location.path(
                '/question-compare/all/' + $rootScope.categories[$scope.rootCatIndex]._id
              );
            }
          }
        }
      };

      $scope.skipQuestion = function () {
        var skip = function () {
          var tempIndex = $scope.currentIndex + 1;
          MyService.ConsoleLog(' $scope.currentIndex >>', tempIndex);
          if ($scope.userId) {
            $scope.getLocalPoliticians(tempIndex);

          }

          if (tempIndex < $scope.questions.length) {
            $scope.currentIndex++;
            if ($routeParams.categoryId && $routeParams.categoryId.indexOf('popular:') == 0) {
              //we are showing questions of most popular section
              $scope.getCategory({
                id: $scope.questions[$scope.currentIndex].categories.cid,
              });
            }
          }
          MyService.ConsoleLog(
            'tempIndex = ',
            tempIndex + '$scope.questions.length ' + $scope.questions.length
          );
          if (tempIndex == $scope.questions.length || $scope.questions.length == 0) {
            //MyService.ConsoleLog("end of questions switch background");
            var tempBackIdx = $scope.currBackgroundIndex + 1;
            MyService.ConsoleLog('$scope.traverseBackgrounds >>', $scope.traverseBackgrounds);
            if ($scope.traverseBackgrounds && $scope.traverseBackgrounds != '') {
              if (tempBackIdx < $scope.traverseBackgrounds.length) {
                $scope.currBackgroundIndex++;
                $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
              } else {
                $scope.rootCatIndex++;
                // alert("Else");
                window.localStorage.setItem('RootCatIndex', $scope.rootCatIndex);
                window.localStorage.setItem('DisplayCategory', JSON.stringify($scope.category));
                //MyService.ConsoleLog("/politician_compare/" + $routeParams.categoryId + "/" + $routeParams.parentId);
                $location.path(
                  '/politician_compare/' + $routeParams.categoryId + '/' + $routeParams.parentId
                );
              }
            } else {
              if ($scope.userId) {
                $location.path('/getPopularComparison');

              }
            }
          }
        };

        skip();
      };
    },
  ]);

'use strict';
angular.module('myApp.polProfileSetUp', ['ngRoute'])

  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/polProfileSetUp', {
      templateUrl: 'app/polProfileSetUp/polProfileSetUp.html',
      controller: 'polProfileSetUpCtrl'
    });
  }])
  .controller('polProfileSetUpCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService) {

  }]);

'use strict';
angular.module('myApp.polProfile', ['ngRoute'])

  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/polProfile', {
      templateUrl: 'app/polProfile/polProfile.html',
      controller: 'polProfileCtrl'
    });
  }])
  .controller('polProfileCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService) {

  }]);

"use strict";
angular
  .module("myApp.politicianThread", ["ngRoute"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/politician-thread/:userid", {
        templateUrl: "app/politician_thread/politician_thread.html",
        controller: "PoliticianThreadCtrl",
      });
    },
  ])
  .filter("refineDataPol", [
    "tokenService",
    function (tokenService) {
      return function (data, filterBy) {
        //MyService.ConsoleLog("data: ",data," filterBy: ",filterBy);
        var userData = tokenService.getUserData();
        if (userData) {
          userData = JSON.parse(userData);
        }
        if (!filterBy || filterBy == "all") return data;
        var tempArr = [];
        angular.forEach(data, function (val, key) {
          //MyService.ConsoleLog("key: ",key);
          if (filterBy == "following") {
            if (userData && userData.followlist) {
              if (userData.followlist.indexOf(val.createdBy.id) > -1)
                tempArr.push(val);
            }
          } else {
            if (val.createdBy.utype == filterBy) {
              tempArr.push(val);
            }
          }
        });
        //MyService.ConsoleLog("tempArr: ", tempArr);
        return tempArr;
      };
    },
  ])
  .controller("PoliticianThreadCtrl", [
    "$scope",
    "$http",
    "$location",
    "apiCall",
    "$routeParams",
    "$rootScope",
    "$q",
    "$timeout",
    "tokenService",
    "MyService",
    "growl",
    "$anchorScroll",
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $rootScope,
      $q,
      $timeout,
      tokenService,
      MyService,
      growl,
      $anchorScroll
    ) {
      $rootScope.welcome = false;
      $scope.categoryId = $routeParams.categoryId;
      $scope.subcategoryId = $routeParams.subcatId;
      $scope.uId = $routeParams.userid;
      $scope.type = $routeParams.type;
      $scope.category = {};
      $scope.subcategory = {};
      $scope.DisplayData = [];
      $scope.userType = tokenService.getUserRole();
      $scope.userId = tokenService.getUserId();
      if (tokenService.getUserData()) {
        $scope.userData = JSON.parse(tokenService.getUserData());
      }
      $scope.getUserProfile = function () {
        MyService.getProfile($scope.userData.id).then(
          function (userData) {
            $scope.usersData = userData;
            MyService.ConsoleLog("userData: ", $scope.userData);
          },
          function (err) {
            growl.error("Something went wrong while fetching user info.");
          }
        );
      };
      window.localStorage.setItem("isShowOldResult", true);
      $scope.filterArray = [
        "all",
        "politician",
        "voter",
        "press",
        "advocate",
        "following",
      ];
      $scope.sortArray = ["Newest first", "Since last login"];
      $scope.sortBy = "Select sort";
      $scope.Sticky = {
        txtOrder: 0,
      };

      if ($rootScope.ExtraTopicData) {
        if ($rootScope.ExtraTopicData.MyDiscussion) {
          $scope.DiscussionData = $rootScope.ExtraTopicData.MyDiscussion;
        }

        if ($rootScope.ExtraTopicData.ActiveData) {
          $scope.ActiveThreads = $rootScope.ExtraTopicData.ActiveData;
        }

        if ($rootScope.ExtraTopicData.HotTopics) {
          $scope.HotTopics = $rootScope.ExtraTopicData.HotTopics;
        }
      }

      if (window.localStorage.getItem("VoteWiseCategory")) {
        $rootScope.allcategories = JSON.parse(
          window.localStorage.getItem("VoteWiseCategory")
        );
        var idx = $rootScope.allcategories.indexOf($routeParams.subcatId);

        if (idx == -1) {
          $rootScope.allcategories.push($routeParams.subcatId);
          window.localStorage.setItem(
            "VoteWiseCategory",
            JSON.stringify($rootScope.allcategories)
          );
        }
      }

      $scope.checkSticky = function (val) {
        if (val == "Y") {
          return {
            "background-color": "#fbeec0",
          };
        } else {
          return "";
        }
      };

      $scope.createNew = function () {
        $location.path("topic-politician/" + $scope.uId);
      };

      $scope.statusGetForumList = 0;
      $scope.getForumList = function () {
        if ($scope.userData) {
          var address = JSON.stringify($scope.userData.address);
        } else {
          var address = "";
        }
        var finalData = {
          taggedUserId: $routeParams.userid,
        };
        if ($scope.isRecent) {
          finalData.sort_by = $scope.isRecent;
        }
        //MyService.ConsoleLog("post Data : ", finalData);
        $scope.statusGetForumList = 1;
        var nrequest = apiCall.apiCall("POST", "/topics/getList", finalData);
        $http(nrequest).then(
          function successCallback(responseLatest) {
            //MyService.ConsoleLog("Final DataL : ",responseLatest);
            //MyService.ConsoleLog(responseLatest.data.data);
            if (responseLatest.data.success) {
              $scope.sortNw = "-createdOn";
              $scope.DisplayData = responseLatest.data.data;
              MyService.ConsoleLog("this is new", $scope.DisplayData);
              $scope.DisplayData.sort(function (a, b) {
                // MyService.ConsoleLog("am", a);
                // MyService.ConsoleLog("b", b);
                var asc = new Date(a.createdOn);
                var bss = new Date(b.createdOn);
                return bss - asc;
              });
              $scope.statusGetForumList = 2;
            } else {
              $scope.statusGetForumList = 3;
              if (
                responseLatest.data.error &&
                typeof responseLatest.data.error == "string"
              ) {
                growl.error(responseLatest.data.error);
              } else {
                growl.error("Something went wrong.");
              }
            }
          },
          function errorCallBack(responseLatest) {
            $scope.statusGetForumList = 3;
            growl.error("Error : " + responseLatest);
          }
        );
      };

      function getSubCategories() {
        MyService.getSubCategoryList($routeParams.subcatId).then(
          function (payload) {
            $scope.subcategory = payload;
          },
          function (errorPayload) {
            alert("Something went wrong. ");
          }
        );
      }

      function getCategory() {
        MyService.getCategoryList($routeParams.categoryId).then(
          function (payload) {
            $scope.category = payload;
            //MyService.ConsoleLog("subcatdata : ", subcatdata);
          },
          function (errorPayload) {
            alert("Something went wrong.");
          }
        );
      }

      $scope.gotoThread = function (id) {
        var categoryId = $routeParams.categoryId;
        var subcatid = $routeParams.subcatId;
        $location.path("forumthread/" + categoryId + "/" + subcatid + "/" + id);
      };
      if ($scope.userData && $scope.userData.id != "") {
        $scope.getUserProfile();
      }
      $scope.sortNw = "-createdOn";
      $scope.SortData = function () {
        MyService.ConsoleLog($scope.sortBy);
        if ($scope.sortBy == "Since last login") {
          if ($scope.usersData && $scope.usersData.lastLoginOld != "") {
            var lastOldLogIn = new Date($scope.usersData.lastLoginOld);

            var lens = $scope.DisplayData.length;
            for (var i = 0; i < lens; i++) {
              var lastLoginDate = new Date($scope.usersData.lastLogin);
              var createdOn = new Date($scope.DisplayData[i].createdOn);

              if (lastLoginDate <= createdOn) {
                $location.hash("anchorList" + $scope.DisplayData[i]._id);
                $anchorScroll();
                break;
              } else if (
                lastOldLogIn.toISOString().split("T")[0] <=
                createdOn.toISOString().split("T")[0]
              ) {
                // MyService.ConsoleLog("else", 'anchor' + $scope.DisplayData[i]._id);
                var old = $location.hash();
                MyService.ConsoleLog("old", old);
                // $location.hash('anchor' + $scope.DisplayData[i]._id);
                $anchorScroll("anchorList" + $scope.DisplayData[i]._id);
                break;
              }
            }
          }
        } else if ($scope.sortBy == "Chronological") {
          // $scope.getForumList();
          // $scope.sortNw = 'createdOn';
          $scope.DisplayData.sort(function (a, b) {
            // MyService.ConsoleLog("am", a);
            // MyService.ConsoleLog("b", b);
            var asc = new Date(a.createdOn);
            var bss = new Date(b.createdOn);
            return asc - bss;
          });
        } else {
          $scope.isRecent = "Newest first";
          $scope.DisplayData.sort(function (a, b) {
            // MyService.ConsoleLog("am", a);
            // MyService.ConsoleLog("b", b);
            var asc = new Date(a.createdOn);
            var bss = new Date(b.createdOn);
            return bss - asc;
          });
        }
        //alert("Sort Data called");
      };

      $scope.updatePostApi = function (data, options, idex) {
        var request = apiCall.apiCall("POST", "/topics/update", data);
        $http(request).then(
          function successCallback(response) {
            //MyService.ConsoleLog(response);
            if (response.data.data.nModified == 0) {
              alert("Something went wrong. Please try after sometime.");
            } else {
              $scope.getForumList();
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", JSON.stringify(response));
          }
        );
      };

      $scope.gotoUpdate = function (item) {
        $location.path(
          "/updateTopic/" +
            $routeParams.categoryId +
            "/" +
            $routeParams.subcatId +
            "/" +
            $routeParams.type +
            "/" +
            item._id
        );
      };

      $scope.objectKeys = function (obj) {
        return Object.keys(obj);
      };

      $scope.updatePost = function (option, id) {
        var data = {};
        if (option == "sticky") {
          data.poststicky = 1;
          data.poststickyOrder = $scope.Sticky.txtOrder[id];
          data.topicId = id;
        } else {
          data.removepostSticky = 1;
          data.topicId = id;
        }
        //MyService.ConsoleLog(data);
        $scope.updatePostApi(data);
      };

      /*if ($routeParams.categoryId) {
        getCategory();
        getSubCategories();

    }*/
      if ($routeParams.userid) {
        $scope.getForumList();
      }
    },
  ]);

'use strict';
angular.module('myApp.politician_compare', ['ngRoute', 'ngDialog'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/politician_compare/:categoryId?/:parentId?', {
      templateUrl: 'app/politician_compare/politician_compare.html',
      controller: 'politician_compareCtrl'
    });
  }])

  .controller('politician_compareCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$q', 'ngDialog', '$rootScope', 'growl', 'MyService', 'tokenService', '$anchorScroll', '$timeout', function ($scope, $http, $location, apiCall, $routeParams, $q, ngDialog, $rootScope, growl, MyService, tokenService, $anchorScroll, $timeout) {
    MyService.ConsoleLog("** politician-compare ** :", $routeParams);
    // alert("Here");
    $rootScope.welcome = false;
    $scope.FBCompareList = [];
    $scope.AnswerArray = [];
    $scope.AnswerArray[1] = "Very Strongly Agree";
    $scope.AnswerArray[2] = "Agree";
    $scope.AnswerArray[3] = "Somewhat Agree";
    $scope.AnswerArray[4] = "Somewhat Disagree";
    $scope.AnswerArray[5] = "Disagree";
    $scope.AnswerArray[6] = "Very Strongly Disgree";
    $scope.AnswerImpArray = [];
    $scope.AnswerImpArray[1] = "Somewhat Important";
    $scope.AnswerImpArray[2] = "Important";
    $scope.AnswerImpArray[3] = "Very Important";
    $scope.Math = window.Math;
    $scope.showAlert = false;

    $scope.checkMyOrder = function (frnd) {
      //MyService.ConsoleLog($scope.ord.Option);
      switch ($scope.ord.Option) {
        case "BW":
          return -($scope.fbcombinedWeight[frnd.id] / $scope.fbmultiplier[frnd.id]);
          break;
        case "W":
          return ($scope.fbcombinedWeight[frnd.id] / $scope.fbmultiplier[frnd.id]);
          break;
        case "BS":
          return -($scope.FBunWeighted[frnd.id] / $scope.fbqlen[frnd.id]);
          break;
        case "S":
          return ($scope.FBunWeighted[frnd.id] / $scope.fbqlen[frnd.id]);
          break;
        default:
          return -($scope.fbcombinedWeight[frnd.id] / $scope.fbmultiplier[frnd.id]);
          break;
      }
    }
    if (window.localStorage.getItem('fiveQueIds')) {
      $scope.FBfreinds = $rootScope.selectedCompareUsers ? $rootScope.selectedCompareUsers : JSON.parse(window.localStorage.getItem("selectedCompareUsers"));
      window.localStorage.removeItem('selectedCompareUsers');
      window.localStorage.setItem('selectedCompareUsers', JSON.stringify($scope.FBfreinds));
    } else {
      $scope.FBfreinds = JSON.parse(window.localStorage.getItem("selectedCompareUsers"));

    }


    $scope.category = JSON.parse(window.localStorage.getItem("DisplayCategory"));


    $scope.nextCat = function () {

      $location.path("compare-subject/politician");
      // $scope.rootCatIndex = window.localStorage.getItem("RootCatIndex");
      // MyService.ConsoleLog($scope.rootCatIndex);
      // if ($scope.rootCatIndex < ($rootScope.categories.length - 1)) {
      //     $location.path("/question-compare/all/" + $rootScope.categories[$scope.rootCatIndex]._id);
      // }

    }

    $scope.isObjectEmpty = function (card) {
      return Object.keys(card).length === 0;
    }

    $scope.ComapreWithSelected = function () {
      //MyService.ConsoleLog($scope.selection);
      MyService.ConsoleLog("ComapreWithSelected", $rootScope.selectedCompareUsers);
      //MyService.ConsoleLog($rootScope.OldCatforFB._id);
      //MyService.ConsoleLog(window.localStorage.getItem("selectedCompareUsers"));
      if (window.localStorage.getItem("selectedCompareUsers")) {

        var frdlistA = $scope.FBfreinds.map(function (sub) {
          return sub._id;
        });
        var frdlist = JSON.stringify(frdlistA);
        MyService.ConsoleLog(" frdlist :> ", frdlist);

        //MyService.ConsoleLog($routeParams.categoryId);
        var params;
        if (window.localStorage.getItem('fiveQueIds')) {
          params = {
            "frds": frdlist,
            "questionIds": window.localStorage.getItem('fiveQueIds')
          }
        } else {

          params = {
            "frds": frdlist,
            "categoryIds": $routeParams.categoryId
          }
        }
        // alert('compare');
        MyService.CompareWithPolitcians(params).then(function (payload) {
          //MyService.ConsoleLog(payload);

          $scope.FBCompareList.length = 0;
          if (payload.data.success) {
            MyService.ConsoleLog("compare data :", payload.data.data);
            MyService.ConsoleLog("answeredQuestions data :", payload.data.data.answeredQuestions);
            MyService.ConsoleLog("answeredQuestions len\ :", $scope.isObjectEmpty(payload.data.data.answeredQuestions));

            $scope.myObject = payload.data.data.answeredQuestions;

            if ($scope.isObjectEmpty(payload.data.data.answeredQuestions)) {

              MyService.ConsoleLog(" Welcome to if");

              $scope.showAlert = true;

              // setTimeout(function() {

              //   $scope.showAlert = true;


              // }, 3000);

            }
            $scope.FBCompareList = payload.data.data.qdata;
            if ($scope.FBCompareList.length > 0) {
              // ngDialog.open({
              //     template: 'FBFreindCompare',
              //     scope: $scope
              // });
              $scope.FBunWeighted = payload.data.data.unweightedMatch;
              $scope.fbcombinedWeight = payload.data.data.fbcombinedWeight;
              $scope.fbmultiplier = payload.data.data.fbmultiplier;
              $scope.answeredQuestions = payload.data.data.answeredQuestions;
              $scope.fbqlen = payload.data.data.qlen;
            } else {
              alert("Looks like your freinds not yet answered the questions.");
              //MyService.ConsoleLog($scope.FBCompareList);
            }
          } else {
            alert("Something went wrong.");
          }
        }, function (errorpayload) {
          alert("Something went wrong.");
        })
      } else {
        alert("Please select at least one Friend to compare with");
      }
    }
    $scope.ComapreWithSelected();
  }]);

'use strict';
angular.module('myApp.politicianVideo', ['ngRoute'])
  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/politicianVideo', {
      templateUrl: 'app/politicianVideo/politicianVideo.html',
      reloadOnSearch: false,
      controller: 'politicianVideoCtrl' //we can name anythin
    });
  }])
  .controller('politicianVideoCtrl', ['$scope', '$rootScope', '$window', function($scope, $rootScope, $window) {
    //this is controller for sampepage.html, we link the conttoler to page in config defination, check above .config
    $rootScope.welcome = false;
    $window.scrollTo(0, 0);
  }]);


'use strict';
angular.module('myApp.politicianSignup', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
  $routeProvider.when('/politiciansignup', {
    templateUrl: 'app/politicianSignup/politicianSignup.html',
    controller: 'politicianSignupCtrl'
  });
}])

.controller('politicianSignupCtrl', ['$scope', '$rootScope', '$http','$location','apiCall', function ($scope, $rootScope, $http, $location, apiCall) {
  $scope.user = {};
  $scope.usernameMessage = '';
  $scope.passwordMessage = '';
  $scope.emailMessage = '';
  $scope.taken = true;
  $scope.county = '';
  $scope.cities = [];
  $scope.zipClicked = "zip-not-clicked";
  $rootScope.welcome = false;
  var validate = apiCall.constants();

  $scope.makeErrorList = function(response){
    //console.log(response.errors);
    var errors = [];
    for (var key in response.errors) {
      if (response.errors.hasOwnProperty(key)) {
        var value = response.errors[key];
        if (value.message !== undefined) {
          errors.push(value.message);
        }
    }
    return errors;
  }
}

function validateUsername (username) {
  $scope.usernameMessage = '';
  var validated = validate.regex.username.test(username);
  if (!validated && username.length > 25 ) {
    $scope.usernameMessage = 'cannot be longer than 25 charectors and can contain (. - _ $ @ * ! )';
    return false;
  }
  if (!validated && username.length < 3 ) {
    $scope.usernameMessage = 'cannot be shorter than 3 charectors and can contain (. - _ $ @ * !)';
    return false;
  }
  if (!validated) {
    $scope.usernameMessage = 'must be between 3 and 25 charectors and can contain (. - _ $ @ * !)';
    return false;
  }
  if (validated) {
    usernameTaken(username);
      if ($scope.taken) {
        return true;
      }
      return false;
  }
  return validated;
}

function validatePassword (password) {
  $scope.passwordMessage = '';
  var validated = validate.regex.password.test(password);
  if (!validated) {
    $scope.passwordMessage = ' must be at least 8 charectors long, contain one number, one uppercase letter and one lowercase letter';
    return false;
  }
  return validated;
}

function validateEmail (email) {
  $scope.emailMessage = '';
  var validated = validate.regex.email.test(email);
  if (!validated) {
    $scope.emailMessage = 'Not a valid email address';
    return false;
  }
  if (validated) {
    emailTaken(email);
      if($scope.taken) {
        return true;
      }
      return false;
  }
  return validated;
}

function validateInputs (username, email, password) {
  var validUsername = validateUsername(username);
  var validEmail = apiCall.validateEmail(email, $scope);
  var validPassword = validatePassword(password);
  if (validUsername && validEmail && validPassword) {
    return true;
  }
  return false;
}

function usernameTaken(username) {
  MyService.checkUnm({"username": username}).then(function(response){
    if (response.data.taken) {
        $scope.usernameMessage = ' is taken';
        $scope.taken = false;
        return;
    }
    $scope.taken = true;
  }, function(err){
      growl.error("Something went wrong.");
  });
}

var emailTaken = function(email){
  MyService.checkEmail({"email": email}).then(function(response){
    if (response.data.taken) {
        $scope.emailMessage = ' is taken';
        $scope.taken = false;
        return;
    }
    $scope.taken = true;
  }, function(err){
    growl.error("Something went wrong.");
  });
}

$scope.findByZip = function( user ){
  var request = apiCall.apiCall('GET', '/ziplookup/zip/'+ user.zip, undefined);
  $http(
    request
  ).then(function success(response) {
    //console.log(response.data.zip);
    $scope.county = response.data.zip.county;
    $scope.cities = response.data.zip.city;
    $scope.zipClicked = 'zip-clicked';
  }, function error(response) {
    //console.log(response.data);
  })
}

  $scope.signUp = function( user ){
    $scope.errorMessages = '';
    //console.log(user);
    user.county = $scope.county;
    var validated = validateInputs (user.username, user.email, user.password);
    usernameTaken(user.username);
    if (user.username && user.password && user.zip && user.email && validated) {
      var data = {
           password: user.password,
           city: user.city,
           street: user.address,
           zip: user.zip,
           username: user.username,
           email: user.email
      };
      var request = apiCall.apiCall('POST', '/user/signup', data);
     $http(
       request
     ).then(function successCallback(response) {
      $location.path('/welcomeView');
    }, function errorCallback(response) {
       var errorList = $scope.makeErrorList(response.data.error);
       if (errorList) {
         $scope.errorMessages = String(errorList);
       }
       else {
          $scope.errorMessages = '';
       }

    });
  }
  else {
    $scope.errorMessages = 'Please fill out all fields.';
  }
 }

}]);

'use strict';
angular
  .module('myApp.politicianMatch', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/politicianMatch/:poliId?', {
        templateUrl: 'app/politicianMatch/politicianMatch.html',
        controller: 'politicianMatchCtrl',
      });
    },
  ]).controller('politicianMatchCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    '$routeParams',
    '$q',
    'ngDialog',
    '$rootScope',
    'growl',
    'MyService',
    '$anchorScroll',
    '$timeout',
    'tokenService',
    '$cookies',
    'baseApiUrl',
    '$document',
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $q,
      ngDialog,
      $rootScope,
      growl,
      MyService,
      $anchorScroll,
      $timeout,
      tokenService,
      $cookies,
      baseApiUrl,
      $document
    ) {

      /**
       * Get Route param value
       */
      $scope.poliId = $routeParams.poliId;
      // $scope.

      MyService.ConsoleLog("one more sir", $scope.poliId);
      // $cookies.remove('isAlreadyAnswer');
      // $cookies.put('isAlreadyAnswer', true);
      if (window.localStorage.getItem('poliQuiz')) {
        $rootScope.resultOfAns = JSON.parse(window.localStorage.getItem('poliQuiz'));
      }

      $scope.showcomparison = false;
      $scope.noDataFound = false;


      $scope.traverseBackgrounds = [];
      $scope.currBackgroundIndex = 0;
      $scope.status = {
        questions: 0, //1=loading, 2=loaded, 3=error
        category: 0
      };

      $scope.currentIndex = 0;


      var getCategoryCanceler = $q.defer();
      var prevFetchedCategoryId = null;

      /**
       * Show Pop up
       */

      $scope.Popup = function () {

        var message = "Final comparison to you is impossible since you did not take the quiz";
        var modal = ngDialog.openConfirm({
          template: '<p>' + message + '</p>\
                <div class="ngdialog-buttons">\
                    <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                </div>',
          plain: true,
          closeByDocument: false
        });
        modal.then(function fullfilled(data) {

        }, function rejected(data) {

        });
      };


      /**
       * Get Match
       */
      $scope.getCompMatch = function () {
        // MyService.ConsoleLog(" $scope.orgId", $scope.orgId);
        // MyService.ConsoleLog('$rootScope.resultOfAns >> ', $rootScope.resultOfAns);
        MyService.getPoliMatch({
          poliId: $scope.poliId,
          poliData: JSON.stringify($rootScope.resultOfAns)
        }).then(function (result) {
          MyService.ConsoleLog("Results", result);
          // if (result && result.data.data && result.data.data.qdata) {
          $scope.questions = result.data.qdata;
          $scope.FBCompareList = result.data.qdata;

          if ($scope.FBCompareList && $scope.FBCompareList.length > 0) {
            $scope.FBunWeighted = result.data.unweightedMatch;
            $scope.fbcombinedWeight = result.data.fbcombinedWeight;
            $scope.fbmultiplier = result.data.fbmultiplier;
            $scope.answeredQuestions = result.data.answeredQuestions;
            $scope.fbqlen = result.data.qlen;
            $scope.AllUsers = result.data.AllUsers;
            $scope.poliName = result.data.poliName;
            $scope.poliInfo = result.data.poliInfo;
            // $scope.showcomparison = true;
            MyService.ConsoleLog("$scope.AllUsers ", $scope.AllUsers);
            MyService.ConsoleLog(" $scope.FBunWeighted", $scope.FBunWeighted);
          }
          // } else {
          //   // growl.error(result.data.data.poliName + ' not answered the quiz yet');
          // }

        }, function (err) {
          if (err) {
            $scope.Popup();
          }
          MyService.ConsoleLog("Error", err);
        });
      };
      $scope.getCompMatch();

      /**
       * Show match details
       */
      $scope.showDetails = function () {
        $scope.currentIndex = 0;
        $scope.showcomparison = true;
      };



      /**
       * Get Category for background
       */


      $scope.getCategory = function (params) {
        try {
          prevFetchedCategoryId = $scope.category._id
        } catch (e) {}
        if (prevFetchedCategoryId != params.id) {
          $routeParams.categoryId = params.id;
          $("html, body").animate({
            scrollTop: 0
          }, "slow");
          getCategoryCanceler.resolve();
          getCategoryCanceler = $q.defer()
          $scope.status.category = 1;

          MyService.getCategories(params, getCategoryCanceler.promise).then(function (response) {
            if (response) {
              if (response.data.success) {
                $scope.category = response.data.data;
                MyService.ConsoleLog("$scope.category", $scope.category);
                prevFetchedCategoryId = $scope.category._id;
                $scope.status.category = 2;
              } else {
                $scope.status.category = 3;
              }
            } else {
              $scope.status.category = 2;
            }
          }, function (err) {
            ////MyService.ConsoleLog("Error: ", err);
            $scope.status.category = 3;
            ////MyService.ConsoleLog("$scope.status: ", $scope.status.category);
          });
        } else {
          $timeout(function () {
            $location.hash('DisplayQ');
            $anchorScroll();
          }, 500);
        }
      };



      $scope.viewAnsComment = function (ans) {
        if (ans.comment) {
          ngDialog.open({
            template: 'app/popups/show_comment_txt.html',
            controller: 'OldAnswerViewerCtrl',
            data: {
              title: "Comment",
              content: ans.comment
            }
          });
        }
      };


      $scope.rootCatIndex = 0;
      $scope.getRootCategoryIndex = function () {
        if ($routeParams.categoryId == 'all') {
          var len = $rootScope.categories.length;
          for (var i = 0; i < len; i++) {
            if ($routeParams.parentId == $rootScope.categories[i]._id) {
              $scope.rootCatIndex = i;
              ////MyService.ConsoleLog("rootCatIndex : ", $scope.rootCatIndex);
              break;
            }
          }
        }
      };

      var getLevelCategoryCanceler = $q.defer();

      function getLevelCategory(params) {
        getLevelCategoryCanceler.resolve();
        $scope.status.levlCat = 1;
        params.timeout = getLevelCategoryCanceler.promise;
        var request = apiCall.apiCall('GET', '/categories/list-layer', params);
        $http(
            request
          )
          .then(function successCallback(response) {
            ////MyService.ConsoleLog("Got categories: ",response);
            if (response.data.success) {
              $scope.traverseBackgrounds = response.data.data;
              if ($routeParams.selectedCatId) {
                angular.forEach(response.data.data, function (val, key) {
                  if (val._id == $routeParams.selectedCatId) {
                    $scope.currBackgroundIndex = key;
                    $scope.category = val;
                  }
                });
              } else if ($scope.traverseBackgrounds.length > 0) {
                $scope.category = $scope.traverseBackgrounds[0];
              }
              $scope.status.levlCat = 2;
            } else {
              ////MyService.ConsoleLog("Something went wrong: ", response.data);
              $scope.status.levlCat = 3;
            }
          }, function errorCallBack(response) {
            ////MyService.ConsoleLog("Error: ", response);
            $scope.status.levlCat = 3;
          });
      }

      $scope.skipQuestion = function () {
        var skip = function () {
          var tempIndex = $scope.currentIndex + 1;
          if (tempIndex < $scope.questions.length) {
            $scope.currentIndex++;
            if ($routeParams.categoryId && $routeParams.categoryId.indexOf("popular:") == 0) {
              $scope.getCategory({
                id: $scope.questions[$scope.currentIndex].categories[0].cid
              });
            }
          }
          if ((tempIndex == $scope.questions.length) || $scope.questions.length == 0) {
            var tempBackIdx = $scope.currBackgroundIndex + 1;
            if (tempBackIdx < $scope.traverseBackgrounds.length) {
              $scope.currBackgroundIndex++;
              // alert("if");
              $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
            } else {
              $scope.rootCatIndex++;
              $scope.showcomparison = false;
              $scope.noDataFound = false;
              // alert("else");
              window.localStorage.setItem("RootCatIndex", $scope.rootCatIndex);
              window.localStorage.setItem("DisplayCategory", JSON.stringify($scope.category));

              //$location.path("/compare-politician-questions");

            }
          }
          //$scope.currentIndex++;
        };

        skip();
      };

      $scope.prevQuestion = function () {
        ////MyService.ConsoleLog("** prevQuestion **");
        // $timeout(function() {
        //   $location.hash('DisplayQ');
        //   $anchorScroll();
        // }, 1500);
        if ($scope.currentIndex > 0) {
          $scope.currentIndex--;
        } else if ($scope.currentIndex == 0) {
          if ($scope.currBackgroundIndex > 0) {
            $scope.currBackgroundIndex--;
            $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
          } else {
            ////MyService.ConsoleLog("** end of background **");
            if ($scope.rootCatIndex > 0) {
              $scope.rootCatIndex--;
              $location.path("/question-compare-politician/all/" + $rootScope.categories[$scope.rootCatIndex]._id);
            }
          }
        }
      };

      $scope.compareChanged = function (compare_with) {
        // //MyService.ConsoleLog("compare_with :", compare_with);
        var catid = $routeParams.categoryId;
        if ($routeParams.categoryId && $routeParams.categoryId.indexOf("popular:") == 0) {
          var catid = $routeParams.categoryId.split("popular:")[1];
        }

        $location.path('/compare-select/' + compare_with);
      };

      $scope.getComapreClass = function (match, i) {

        if (match >= 1)
          return 'ag-dg1';
        if (match >= 2)
          return 'ag-dg2';
        if (match >= 3)
          return 'ag-dg3';
        if (match >= 4)
          return 'ag-dg4';
        if (match >= 5)
          return 'ag-dg5';
        if (match >= 6)
          return 'ag-dg6';

        return 'ag-dg';
      };




      var current_url = $location.url();
      ////MyService.ConsoleLog("$location.url: ", current_url);

      $scope.state = "question-compare-politician";
      if (!$rootScope.selectedCompareUsers || $rootScope.selectedCompareUsers.length <= 0) {
        //$location.path("/questionHome");

      } else {
        if ($routeParams.categoryId == 'all') {
          ////MyService.ConsoleLog("compare all answers");
          var param = {
            id: $routeParams.parentId,
            questions_counter: 1
          };
          getLevelCategory(param);
          $scope.getRootCategoryIndex();
        } // traverse all questions
        else {
          $scope.questions = $rootScope.compareAnswerList;
          // //MyService.ConsoleLog($scope.questions);
          var catid = $routeParams.categoryId;
          // //MyService.ConsoleLog(catid)
          $scope.getCategory({
            id: catid
          });
        }
      }



      $scope.retainOptions = "";
      $scope.fb = {
        options: "C"
      };

      // $scope.getFiveFacebookPost();

      $scope.$watch('category', function (newValue, oldValue) {
        //MyService.ConsoleLog("** category watch **");
        var current_url = $location.url();
        if (current_url.indexOf("question-tagged") > -1)
          return; //for tagged questions don't again fetch questions

        if (newValue) {
          if (oldValue && oldValue._id == newValue._id) return;

          if (current_url.indexOf("question-compare-politician") > -1) {
            var temp_uids = [];
            angular.forEach($rootScope.selectedCompareUsers, function (val, key) {
              temp_uids.push(val._id);
            });

          }
        }
      });

      $scope.$watch('questions', function (newValue, oldValue) {
        //MyService.ConsoleLog("** questions watch **");
        if (!$scope.questions) {
          $scope.questions = $rootScope.fiveminquestions;
        }
        try {
          if ($scope.questions) {
            var tempCate = $scope.questions[$scope.currentIndex].categories;
            if (angular.isArray(tempCate)) {
              $scope.getCategory({
                id: tempCate[0].cid
              });
            } else {
              $scope.getCategory({
                id: tempCate.cid
              });
            }
          }
          // $scope.initMyAnswer();
        } catch (e) {
          //MyService.ConsoleLog("questions Index Change Ex: ", e)
        }
      });

      $scope.$watch('currentIndex', function (newValue, oldValue) {
        //MyService.ConsoleLog("** currentIndex watch **");
        // console.log("fiveminquestions >> ", $rootScope.fiveminquestions);
        if (!$scope.questions) {
          $scope.questions = $rootScope.fiveminquestions;
        }
        try {
          // //MyService.ConsoleLog("Current question: ", $scope.questions[$scope.currentIndex]);
          if ($scope.questions) {
            var tempCate = $scope.questions[$scope.currentIndex].categories;
            if (angular.isArray(tempCate)) {
              $scope.getCategory({
                id: tempCate[0].cid
              });
            } else {
              $scope.getCategory({
                id: tempCate.cid
              });
            }
          }
          // $scope.initMyAnswer();
        } catch (e) {
          //MyService.ConsoleLog("Current Index Change Ex: ", e)
        }
      });
    }
  ]);

'use strict';
angular
  .module('myApp.poliCompare', ['ngRoute'])
  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/poliCompare/:quizName?/:poliId?', {
        templateUrl: 'app/poliCompare/poliCompare.html',
        controller: 'poliCompareCtrl',
      });
    },
  ])
  .controller('poliCompareCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    '$routeParams',
    '$q',
    'ngDialog',
    '$rootScope',
    'growl',
    'MyService',
    '$anchorScroll',
    '$timeout',
    'tokenService',
    '$cookies',
    'baseApiUrl',
    '$document',
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $q,
      ngDialog,
      $rootScope,
      growl,
      MyService,
      $anchorScroll,
      $timeout,
      tokenService,
      $cookies,
      baseApiUrl,
      $document
    ) {

      /**
       * Get params from the route params
       */
      $scope.quizName = $routeParams.quizName;
      $scope.poliId = $routeParams.poliId;

      MyService.ConsoleLog("best out of", JSON.parse(window.localStorage.getItem('compareData')));


      $scope.showPoliAnswerDetails = false;
      $scope.showUserAnswerDetails = false;
      $scope.noDataFound = false;
      $scope.showcomparison = false;
      $scope.showComment = false;
      $scope.unComment = false;
      $scope.showCurr = false;
      $scope.currentIndex = 0;
      $scope.userId = tokenService.getUserId();
      $scope.traverseBackgrounds = [];
      $scope.currBackgroundIndex = 0;

      $scope.status = {
        questions: 0, //1=loading, 2=loaded, 3=error
        category: 0
      };


      /**
       * Get quizzes details
       */

      $scope.getData = function () {
        // alert('s');
        MyService.getAnsQues({
          poliId: tokenService.getUserId(),
          quizName: $scope.quizName,
          isShowAll: true
        }).then(function (response) {
          MyService.ConsoleLog("Response", response);
          $scope.quiz = response.data;
          window.localStorage.setItem('ansDatas', JSON.stringify($scope.quiz));

          var obj = {};
          obj.poliId = window.localStorage.getItem('compareData');
          obj.poliData = JSON.stringify($scope.quiz);
          obj.quizName = $scope.quizName;
          // window.localStorage.removeItem('compareData');
          // return
          $scope.getCompMatch(obj);
        }, function (err) {
          MyService.ConsoleLog("Error", err);
        });
      };

      /**
       * Get Comparison of quiz
       */

      $scope.getCompMatch = function (params) {
        // MyService.ConsoleLog(" $scope.orgId", $scope.orgId);
        // MyService.ConsoleLog('$rootScope.resultOfAns >> ', $rootScope.resultOfAns);
        MyService.getSideBySide(params).then(function (result) {
          MyService.ConsoleLog("Results", result);
          $scope.questions = result.data.data;
          $scope.questions.sort(function (x, y) {
            if (x.qOrder < y.qOrder) {
              return -1;
            }
            if (x.qOrder > y.qOrder) {
              return 1;
            }
            return 0;
          });
        }, function (err) {
          if (err) {
            $scope.Popup();
          }
          MyService.ConsoleLog("Error", err);
        });
      };


      /**This function redirects to show comment page */
      $scope.viewAnsComment = function (val) {
        MyService.ConsoleLog('called', val);

        switch (val) {
          case 'email':
            $scope.global = $scope.arrayOfCom;
            if ($scope.userId) {
              var poli = JSON.stringify({
                poliArr: $scope.arrayOfCom,
                queId: $scope.questions[$scope.currentIndex]._id
              });
              window.localStorage.setItem('comOfPolitician', poli);
              $location.path('/showComments');
            }
            $scope.showComment = true;
            $scope.unComment = false;
            $scope.showCurr = false;

            break;
          case 'unRegister':
            if ($scope.userId) {
              var guest = JSON.stringify({
                guestArr: $scope.unVeriComm,
                queId: $scope.questions[$scope.currentIndex]._id
              });
              window.localStorage.setItem('comOfGuest', guest);
              $location.path('/showComments');
            }
            $scope.unComment = true;
            $scope.showComment = false;
            $scope.showCurr = false;

            break;
          case 'voter':
            $scope.global = $scope.voterComArr;
            // MyService.ConsoleLog("$scope.voterComArr", $scope.voterComArr);
            if ($scope.userId) {
              var vo = JSON.stringify({
                compArr: $scope.voterComArr,
                queId: $scope.questions[$scope.currentIndex]._id
              });
              // MyService.ConsoleLog("vo >>", vo);
              window.localStorage.setItem('comOfVoter', vo);
              $location.path('/showComments');
            }
            $scope.showComment = true;
            $scope.unComment = false;
            $scope.showCurr = false;

            break;
          case 'advocate':
            $scope.global = $scope.advComArr;
            if ($scope.userId) {
              var adv = JSON.stringify({
                advArr: $scope.advComArr,
                queId: $scope.questions[$scope.currentIndex]._id
              });
              $cookies.put('orgName', $scope.orgName);
              window.localStorage.setItem('comOfAdv', adv);
              $location.path('/showComments');
            }
            $scope.showComment = true;
            $scope.unComment = false;
            $scope.showCurr = false;

            break;
          case 'currentUser':
            if ($scope.userId) {
              var curUser = JSON.stringify({
                curuser: $scope.questions[$scope.currentIndex]
              });
              window.localStorage.setItem('cuUser', curUser);
              $location.path('/showComments');
            }
            $scope.showComment = false;
            $scope.showCurr = true;
            $scope.unComment = false;
            break;
          default:

            break;
        }
      };

      /**
       * Change color of match on the basis on answers
       */
      $scope.changeColor = function (nper, inx, cur_ans) {

        // MyService.ConsoleLog("inx", inx);
        // MyService.ConsoleLog("cur_ans", cur_ans);

        var arrOfCol = {
          "5": "#990000",
          "4": "#cc3300",
          "3": "#ff9933",
          "2": "#ffff00",
          "1": "#99cc00",
          "0": "#00d900"
        };
        var cdiff = Math.abs(inx - cur_ans);

        // console.log("arrOfCol > ", arrOfCol);
        $scope.gr = null;
        switch (true) {
          case (nper >= 100):
            if (cur_ans == inx) {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[0] + " " + nper + "%, #2b4f7f 10%)"
              };
            } else {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[cdiff] + " " + nper + "%, #2b4f7f 10%)"
              };
            }

            // MyService.ConsoleLog("$scope.gr >>", arrOfCol.nper);
            break;
          case (nper >= 80):
            if (cur_ans == inx) {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[0] + " " + nper + "%, #2b4f7f 10%)"
              };
            } else {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[cdiff] + " " + nper + "%, #2b4f7f 10%)"
              };
            }
            break;
          case (nper >= 60):
            if (cur_ans == inx) {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[0] + " " + nper + "%, #2b4f7f 10%)"
              };
            } else {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[cdiff] + " " + nper + "%, #2b4f7f 10%)"
              };
            }
            break;
          case (nper >= 40):
            if (cur_ans == inx) {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[0] + " " + nper + "%, #2b4f7f 10%)"
              };
            } else {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[cdiff] + " " + nper + "%, #2b4f7f 10%)"
              };
            }
            break;
          case (nper >= 20):
            if (cur_ans == inx) {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[0] + " " + nper + "%, #2b4f7f 10%)"
              };
            } else {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[cdiff] + " " + nper + "%, #2b4f7f 10%)"
              };
            }
            break;
          case (nper >= 0):
            if (cur_ans == inx) {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[0] + " " + nper + "%, #2b4f7f 10%)"
              };
            } else {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[cdiff] + " " + nper + "%, #2b4f7f 10%)"
              };
            }
            break;

          default:
            break;
        }
        // MyService.ConsoleLog(" $scope.gr", $scope.gr);
        return $scope.gr;

      };


      $scope.getOldAnswers = function (val) {
        MyService.ConsoleLog('dava', val);
        $scope.oldAns = val;
        $scope.showPopUp = ngDialog.open({
          template: 'showOldAnsPopUp',
          closeByNavigation: true,
          scope: $scope,
        });
      };

      /** Return class of background color */

      $scope.getComapreClass = function (match, i) {

        if (match >= 100) return 'ag-dg1';
        if (match >= 80) return 'ag-dg2';
        if (match >= 60) return 'ag-dg3';
        if (match >= 40) return 'ag-dg4';
        if (match >= 20) return 'ag-dg5';
        if (match >= 0) return 'ag-dg6';

        return 'ag-dg';
      };

      $scope.prevQuestion = function () {
        //MyService.ConsoleLog("** prevQuestion **");
        $("html, body").animate({
          scrollTop: $("#DisplayQ").offset().top - 280
        }, "slow");
        if ($scope.currentIndex > 0) {
          var decr = $scope.currentIndex--;
          var one = decr - 1;
          MyService.ConsoleLog("decr", one);

        } else if ($scope.currentIndex == 0) {
          if ($scope.currBackgroundIndex > 0) {
            $scope.currBackgroundIndex--;
            MyService.ConsoleLog('$scope.traverseBackgrounds >', $scope.traverseBackgrounds);
            $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
          } else {
            //MyService.ConsoleLog("** end of background **");
            if ($scope.rootCatIndex > 0) {
              $scope.rootCatIndex--;
              $location.path(
                '/question-compare/all/' + $rootScope.categories[$scope.rootCatIndex]._id
              );
            }
          }
        }
      };

      $scope.skipQuestion = function () {
        var skip = function () {
          var tempIndex = $scope.currentIndex + 1;
          MyService.ConsoleLog(' $scope.currentIndex >>', tempIndex);
          $("html, body").animate({
            scrollTop: $("#DisplayQ").offset().top - 280
          }, "slow");
          if (tempIndex < $scope.questions.length) {
            $scope.currentIndex++;
            if ($routeParams.categoryId && $routeParams.categoryId.indexOf('popular:') == 0) {
              //we are showing questions of most popular section
              $scope.getCategory({
                id: $scope.questions[$scope.currentIndex].categories.cid,
              });
            }
          }
          MyService.ConsoleLog(
            'tempIndex = ',
            tempIndex + '$scope.questions.length ' + $scope.questions.length
          );
          if (tempIndex == $scope.questions.length || $scope.questions.length == 0) {
            //MyService.ConsoleLog("end of questions switch background");
            var tempBackIdx = $scope.currBackgroundIndex + 1;
            MyService.ConsoleLog('$scope.traverseBackgrounds >>', $scope.traverseBackgrounds);
            if ($scope.traverseBackgrounds && $scope.traverseBackgrounds != '') {
              if (tempBackIdx < $scope.traverseBackgrounds.length) {
                $scope.currBackgroundIndex++;
                $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
              } else {
                $scope.rootCatIndex++;
                // alert("Else");
                window.localStorage.setItem('RootCatIndex', $scope.rootCatIndex);
                window.localStorage.setItem('DisplayCategory', JSON.stringify($scope.category));
                //MyService.ConsoleLog("/politician_compare/" + $routeParams.categoryId + "/" + $routeParams.parentId);
                $location.path(
                  '/politician_compare/' + $routeParams.categoryId + '/' + $routeParams.parentId
                );
              }
            } else {
              $location.path('/matchOfFollowers');
            }
          }
        };

        skip();
      };



      var getCategoryCanceler = $q.defer();
      var prevFetchedCategoryId = null;

      $scope.getCategory = function (params) {
        try {
          prevFetchedCategoryId = $scope.category._id
        } catch (e) {}

        //MyService.ConsoleLog("prevFetchedCategoryId: ", prevFetchedCategoryId);
        //MyService.ConsoleLog("params.id: ", params.id);
        if (prevFetchedCategoryId != params.id) {
          //MyService.ConsoleLog("scrollTop");
          $("html, body").animate({
            scrollTop: 0
          }, "slow");
          getCategoryCanceler.resolve();
          getCategoryCanceler = $q.defer()
          $scope.status.category = 1;
          // alert(" category called");
          MyService.getCategories(params, getCategoryCanceler.promise).then(function (response) {
            //MyService.ConsoleLog("-----------------------------");
            //MyService.ConsoleLog("response: ", response);
            //MyService.ConsoleLog("-----------------------------");
            if (response) {
              if (response.data.success) {
                $scope.category = response.data.data;
                //MyService.ConsoleLog("category data: ", $scope.category);
                prevFetchedCategoryId = $scope.category._id;
                $scope.status.category = 2;
                //MyService.ConsoleLog("$scope.status: ", $scope.status.category);
              } else {
                //MyService.ConsoleLog("Something went wrong: ", response.data);
                $scope.status.category = 3;
                //MyService.ConsoleLog("$scope.status: ", $scope.status.category);
              }
            } else {
              $scope.status.category = 2;
              //MyService.ConsoleLog("$scope.status: ", $scope.status.category);
            }
          }, function (err) {
            //MyService.ConsoleLog("Error: ", err);
            $scope.status.category = 3;
            //MyService.ConsoleLog("$scope.status: ", $scope.status.category);
          });
        }
      };

      $scope.rootCatIndex = 0;
      $scope.getRootCategoryIndex = function () {
        if ($routeParams.categoryId == 'all') {
          var len = $rootScope.categories.length;
          for (var i = 0; i < len; i++) {
            if ($routeParams.parentId == $rootScope.categories[i]._id) {
              $scope.rootCatIndex = i;
              MyService.ConsoleLog("rootCatIndex : ", $scope.rootCatIndex);
              break;
            }
          }
        }
      };

      var getLevelCategoryCanceler = $q.defer();

      function getLevelCategory(params) {
        getLevelCategoryCanceler.resolve();
        $scope.status.levlCat = 1;
        params.timeout = getLevelCategoryCanceler.promise;
        var request = apiCall.apiCall('GET', '/categories/list-layer', params);
        $http(
            request
          )
          .then(function successCallback(response) {
            MyService.ConsoleLog("Got categories: ", response);
            if (response.data.success) {
              $scope.traverseBackgrounds = response.data.data;
              if ($routeParams.selectedCatId) {
                angular.forEach(response.data.data, function (val, key) {
                  if (val._id == $routeParams.selectedCatId) {
                    $scope.currBackgroundIndex = key;
                    $scope.category = val;
                  }
                });
              } else if ($scope.traverseBackgrounds.length > 0) {
                $scope.category = $scope.traverseBackgrounds[0];
              }
              $scope.status.levlCat = 2;
            } else {
              //MyService.ConsoleLog("Something went wrong: ", response.data);
              $scope.status.levlCat = 3;
            }
          }, function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
            $scope.status.levlCat = 3;
          });
      }


      $scope.$watch('category', function (newValue, oldValue) {
        //MyService.ConsoleLog("** category watch **");
        var current_url = $location.url();

        if (current_url.indexOf("question-tagged") > -1)
          return; //for tagged questions don't again fetch questions

        if (newValue) {
          //MyService.ConsoleLog("<<<<<<oldValue: ", oldValue);
          //MyService.ConsoleLog("<<<<<newValue: ", newValue);
          if (oldValue && oldValue._id == newValue._id) return;
          //MyService.ConsoleLog("scrollTop");
          $("html, body").animate({
            scrollTop: 0
          }, "slow");
          // $scope.currentIndex = 0;

          if (current_url.indexOf("question-compare") > -1) {
            var temp_uids = [];
            angular.forEach($rootScope.selectedCompareUsers, function (val, key) {
              temp_uids.push(val._id);
            });
            MyService.ConsoleLog("**** getCompareAnswers ****");
            $scope.getCompareAnswers({
              "categoryIds": newValue._id,
              "userIds": temp_uids.join(",")
            }); //"compare_with": $routeParams.user_type,
          }
        }
      });

      $scope.$watch('questions', function (newValue, oldValue) {
        //MyService.ConsoleLog("** questions watch **");
        try {
          //MyService.ConsoleLog("Current question: ", $scope.questions[$scope.currentIndex]);
          var tempCate = $scope.questions[$scope.currentIndex].categories;
          if (angular.isArray(tempCate)) {
            $scope.getCategory({
              id: tempCate[0].cid
            });
          } else {
            $scope.getCategory({
              id: tempCate.cid
            });
          }

          // $scope.initMyAnswer();
        } catch (e) {
          //MyService.ConsoleLog("questions Index Change Ex: ", e)
        }
      });

      $scope.$watch('currentIndex', function (newValue, oldValue) {
        //MyService.ConsoleLog("** currentIndex watch **");
        try {
          //MyService.ConsoleLog("Current question: ", $scope.questions[$scope.currentIndex]);
          var tempCate = $scope.questions[$scope.currentIndex].categories;
          if (angular.isArray(tempCate)) {
            $scope.getCategory({
              id: tempCate[0].cid
            });
          } else {
            $scope.getCategory({
              id: tempCate.cid
            });
          }
          // $scope.initMyAnswer();
        } catch (e) {
          //MyService.ConsoleLog("Current Index Change Ex: ", e)
        }
      });
      $scope.getData();


      $scope.getInfo = function (val) {

        if (val && val.comment && val.comment != '') {
          $scope.showComment = val.comment;
          $scope.showPopUp = ngDialog.open({
            template: 'showInfoPopUp',
            closeByNavigation: true,
            scope: $scope,
          });
        }
      };

    }
  ]);

'use strict';
angular
  .module('myApp.poliAnswers', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/poliAnswers/:quizName?/:poliId?/:email?', {
        templateUrl: 'app/poliAnswers/poliAnswers.html',
        controller: 'poliAnswersCtrl',
      });
    },
  ])
  .controller('poliAnswersCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    '$routeParams',
    '$q',
    'ngDialog',
    '$rootScope',
    'growl',
    'MyService',
    '$anchorScroll',
    '$timeout',
    'tokenService',
    '$cookies',
    'baseApiUrl',
    '$document',
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $q,
      ngDialog,
      $rootScope,
      growl,
      MyService,
      $anchorScroll,
      $timeout,
      tokenService,
      $cookies,
      baseApiUrl,
      $document
    ) {
      /**
       * Clear $cookies on page load
       */
      $scope.qName = $routeParams.quizName;
      $scope.poliId = $routeParams.poliId;
      $scope.uEmail = $routeParams.email;
      $cookies.remove('showLogin');
      $cookies.remove('qName');
      $cookies.remove('poliId');
      window.localStorage.removeItem('poliQuiz');

      if (!tokenService.getUserId()) {
        // alert('one');
        $cookies.put('qName', $scope.qName);
        $cookies.put('poliId', $scope.poliId);
        $cookies.put('showLogin', 'true');
        $location.path('/signin');
      }
      $scope.traverseBackgrounds = [];
      $scope.currBackgroundIndex = 0;
      $('input[type=radio]').attr('disabled', true);
      $scope.status = {
        questions: 0, //1= loading, 2 = loaded, 3 = error
        category: 0,
      };

      /**
       * getAnswered questions of Politicians
       */
      $scope.getAnsQues = function () {

        if ($scope.uEmail && $scope.uEmail != '') {
          MyService.ConsoleLog("$scope.uEmail", $scope.uEmail);
          MyService.getFollowersAnsQues({
            email: $scope.uEmail
          }).then(function (response) {
            MyService.ConsoleLog("Response", response);
            if (response && response.data.error && response.data.error != '') {
              growl.error(response.data.error);

            }
            $scope.status.questions = 2;
            $scope.questions = response.data.data;
          }, function (err) {
            MyService.ConsoleLog("Error", err);
          });
        } else {
          MyService.getAnsQues({
            quizName: $scope.qName,
            poliId: $scope.poliId
          }).then(function (results) {
            MyService.ConsoleLog("Results", results);
            $scope.status.questions = 2;
            $scope.questions = results.data;
          }, function (err) {
            MyService.ConsoleLog("Error", err);
          });
        }

      };
      $scope.getAnsQues();

      /**
       * Go to the listing page
       */
      $scope.gotoList = function () {
        if ($scope.uEmail && $scope.uEmail != '') {
          $location.path('/quizResult');
        }
      };

      $scope.$watch('questions', function (newValue, oldValue) {
        MyService.ConsoleLog("*** questions changed ***");
        try {
          //MyService.ConsoleLog("Current question: ", $scope.questions[$scope.currentIndex]);
          var tempCate = $scope.questions[$scope.currentIndex].categories;
          if (angular.isArray(tempCate)) {
            $scope.getCategory({
              id: tempCate[0].cid,
            });
          } else {
            $scope.getCategory({
              id: tempCate.cid,
            });
          }

          $scope.initMyAnswer();
        } catch (e) {
          //MyService.ConsoleLog("questions Index Change Ex: ", e)
        }
      });
      $scope.$watch('currentIndex', function (newValue, oldValue) {
        MyService.ConsoleLog("*** currentIndex changed ***");
        try {
          //MyService.ConsoleLog("Current question: ", $scope.questions[$scope.currentIndex]);
          var tempCate = $scope.questions[$scope.currentIndex].categories;
          if (angular.isArray(tempCate)) {
            $scope.getCategory({
              id: tempCate[0].cid,
            });
          } else {
            $scope.getCategory({
              id: tempCate.cid,
            });
          }

          $scope.initMyAnswer();
        } catch (e) {
          //MyService.ConsoleLog("Current Index Change Ex: ", e)
        }
      });


      /**
       * Get Match
       */
      $scope.getMatch = function () {
        var qLen = $scope.questions.length;
        var tempArr = [];
        for (var i = 0; i < qLen; i++) {
          tempArr.push($scope.questions[i].userAnswer);
        }
        MyService.ConsoleLog("tempArr", tempArr);
        window.localStorage.setItem('poliQuiz', JSON.stringify($scope.questions));
        $location.path('/politicianMatch/' + $scope.poliId);
      };


      $scope.getComapreClass = function (match, i) {
        // MyService.ConsoleLog('match: ', match);
        /*if(match == 100)
          return 'ag-green';
      if(match == 0)
          return 'ag-red';
      if(match > 0 && match <100)
          return 'ag-dg'+i;*/
        if (match == 1) return 'ag-dg1';
        if (match == 2) return 'ag-dg2';
        if (match == 3) return 'ag-dg3';
        if (match == 4) return 'ag-dg4';
        if (match == 5) return 'ag-dg5';
        if (match == 6) return 'ag-dg6';

        return 'ag-dg';
      };

      $scope.checkImpExists = function (val) {
        if ($scope.questions && $scope.questions.length > 0) {
          var obj = $scope.questions[$scope.currentIndex];
        }
        // MyService.ConsoleLog(" qobject :", obj);
        if (obj) {
          var data = obj.userAnswer;

          if (data || data[0]) {
            // MyService.ConsoleLog("Importance data>> ", data[0].Importance);
            if (data[0]) {
              if (data[0].Importance == val) {
                return true;
              }
            } else {
              if (data.importance == val) {
                return true;
              }
            }
          }
        }
        return false;
      };
      $scope.initMyAnswer = function () {
        try {
          if ($scope.questions[$scope.currentIndex].userAnswer) {
            var user_answer = ($scope.importance =
              $scope.questions[$scope.currentIndex].userAnswer[0]);
            $scope.importance = user_answer.importance;
            $scope.answer = user_answer.answer;
            $scope.comment = user_answer.comment;
          } else {
            $scope.initializeVariables();
          }
        } catch (e) {
          $scope.initializeVariables();
          //MyService.ConsoleLog("Exceptoin: ", e)
        }
      };

      $scope.currentIndex = 0;
      $scope.initializeVariables = function () {
        $scope.importance = null;
        $scope.answer = null;
        $scope.comment = '';
        $scope.reason = '';
      };
      $scope.initializeVariables();
      $scope.checkIfExists = function (val) {
        // console.log("questions <><><>", $scope.questions);
        // MyService.ConsoleLog("Val > ", val);
        if ($scope.questions && $scope.questions.length > 0) {
          var obj = $scope.questions[$scope.currentIndex];
        }

        // MyService.ConsoleLog("checkIfExists >> ", obj);
        if (obj) {
          var data = obj.userAnswer;
          if (data || data[0]) {
            // MyService.ConsoleLog("data", data);
            if (data[0]) {
              MyService.ConsoleLog('checkIfExists data>> ', data[0].answer + '==' + val);
              $scope.comment = data[0].comment;
              if (data[0].answer == 'No') {
                if (val == 5) return true;
              }
              if (data[0].answer == 'Yes') {
                if (val == 2) return true;
              }
            } else {
              // MyService.ConsoleLog("checkIfExists data>> ", data[0].answer + "==" + val);
              $scope.comment = data.comment;
              // $scope.answer = data.answer;
              // if (data.answer == "No") {
              //   if (val == 5)
              //     return true;
              // }
              // if (data.answer == "Yes") {
              //   if (val == 2)
              if (val == data.answer) {
                return true;
              }
              // }
            }
          }
        }
        return false;
      };

      var getCategoryCanceler = $q.defer();
      var prevFetchedCategoryId = null;

      $scope.getCategory = function (params) {
        if (prevFetchedCategoryId != params.id) {
          //MyService.ConsoleLog("scrollTop");

          $('html, body').animate({
              scrollTop: 0,
            },
            'slow'
          );

          getCategoryCanceler.resolve();
          $scope.status.category = 1;
          params.timeout = getCategoryCanceler.promise;
          var request = apiCall.apiCall('GET', '/categories/list', params);
          $http(request).then(
            function successCallback(response) {
              //MyService.ConsoleLog("Got categories: ",response);
              if (response.data.success) {
                $scope.category = response.data.data;
                //MyService.ConsoleLog("category data: ", $scope.category);
                prevFetchedCategoryId = $scope.category._id;
                $scope.status.category = 2;
              } else {
                //MyService.ConsoleLog("Something went wrong: ", response.data);
                $scope.status.category = 3;
              }
            },
            function errorCallBack(response) {
              //MyService.ConsoleLog("Error: ", response);
              $scope.status.category = 3;
            }
          );
        }
      };

      $scope.skipQuestion = function () {
        /*
      $timeout(function() {
        $location.hash('DisplayQ');
        $anchorScroll();
      }, 1500);
      */
        var skip = function () {
          var tempIndex = $scope.currentIndex + 1;
          if (tempIndex < $scope.questions.length) {
            $scope.initializeVariables();
            $scope.currentIndex++;
            if ($routeParams.categoryId && $routeParams.categoryId.indexOf('popular:') == 0) {
              //we are showing questions of most popular section
              $scope.getCategory({
                id: $scope.questions[$scope.currentIndex].categories.cid,
              });
            }
          }
          //MyService.ConsoleLog("tempIndex = ", tempIndex, "$scope.questions.length ",$scope.questions.length);
          if (tempIndex == $scope.questions.length) {
            //MyService.ConsoleLog("end of questions switch background");
            var tempBackIdx = $scope.currBackgroundIndex + 1;
            if (tempBackIdx < $scope.traverseBackgrounds.length) {
              $scope.currBackgroundIndex++;
              $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
            } else {
              //MyService.ConsoleLog("* End of background *");
            }
          }
          // console.log("Display Q :", $("#DisplayQ").offset().top);
          $('html, body').animate({
              scrollTop: $('#DisplayQ').offset().top - 150,
            },
            'slow'
          );
        };

        skip();
      };

      $scope.prevQuestion = function () {
        //MyService.ConsoleLog("** prevQuestion **");
        /*
      $timeout(function() {
        $location.hash('DisplayQ');
        $anchorScroll();
      }, 1500);
      */
        if ($scope.currentIndex > 0) {
          $scope.currentIndex--;
        } else if ($scope.currentIndex == 0) {
          if ($scope.currBackgroundIndex > 0) {
            $scope.currBackgroundIndex--;
            $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
          }
        }
      };

      $scope.checkQuestionAnswered = function () {
        // console.log("scope.questions > ", $scope.questions);
        return $scope.questions.filter(function (rdata) {
          //MyService.ConsoleLog(rdata.statePostalCode + "==" + val);
          var data = $scope.checkQuestion(rdata._id);
          if (data && data.length > 0) return rdata;
        });
      };
    },
  ]);

'use strict';
angular.module('myApp.polFinance', ['ngRoute'])

  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/polFinance/:id/:type?', {
      templateUrl: 'app/polFinance/polFinance.html',
      controller: 'polFinanceCtrl'
    });
  }])
  .controller('polFinanceCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService) {

    $scope.userId = $routeParams.id;
    $rootScope.welcome = false;
    $scope.loginUser = tokenService.getUserId();
    $scope.politicianUser = 'false';
    //MyService.ConsoleLog($routeParams.type);
    if ($routeParams.type) {
      $scope.politicianUser = $routeParams.type;
    }

    if (tokenService.getUserData()) {
      $scope.UserData = JSON.parse(tokenService.getUserData());
    }
    //MyService.ConsoleLog($routeParams.id);
    $scope.userDetails = {};
    $scope.userProfile = {};
    $scope.statusGetData = 0;
    $scope.propublicaData = [];
    $scope.memberRole = [];
    //$scope.memberRoleCommittee = [];
    //$scope.committeeData = [];
    $scope.currentRole = 0;
    $scope.allRoles = 1;
    $scope.showSponsoredContent = false;
    $scope.sponsorData = [];
    $scope.industrySupport = [];
    $scope.atLarge = '';
    $scope.memberCrpId = '';
    $scope.personalHoldingData = [];
    $scope.fundRaisingData = [];
    $scope.topContributorData = [];
    $scope.currentContent = '';
    $scope.allroles = [];
    $scope.committeesYears = [];
    $scope.contYear = ((new Date()).getFullYear()).toString();
    $scope.supportYear = (new Date()).getFullYear();
    $scope.contYearArray = [];
    $scope.selectedYear = '0';
    $scope.selectedYearCommittee = '0';
    for (var x = 0; x < 15; x++) {
      $scope.contYearArray.push($scope.contYear - x);
    }
    MyService.ConsoleLog("@@@@ ", $scope.contYearArray);
    $scope.getData = function() {
      //MyService.ConsoleLog("politicianUser:",$scope.politicianUser);
      $scope.statusGetData = 1;
      MyService.getUserPublicProfile({ id: $routeParams.id, type: $scope.politicianUser }).then(function(response) {
        if (response.data.success) {
          $scope.userDetails = response.data.data;
          MyService.ConsoleLog("userDetails : ", $scope.userDetails);
          $scope.userProfile = $scope.userDetails.userData;
          $scope.statusGetData = 2;
        } else {
          $scope.statusGetData = 3;
        }
      }, function(errorPayload) {
        $scope.statusGetData = 3;
      });
    }

    $scope.addtoFollow = function() {
      var data = {};
      data.userId = $scope.loginUser;
      data.pushId = $routeParams.id;
      MyService.updateUserFollowList(data).then(function(payload) {
          alert("User added to followup list successfully.");
          if ($scope.UserData) {
            $scope.UserData.followlist.push($routeParams.id);
            //MyService.ConsoleLog("udata : ", $scope.UserData);
            tokenService.saveUserData(JSON.stringify($scope.UserData));
          }
        },
        function(errorPayload) {
          alert('Something went wrong ');
        });

    }

    $scope.goBack = function() {
      window.history.back();
    }
/*
    $scope.arrangeComitteeData = function() {
      $scope.committeeData = [];
      var len1 = $scope.memberRoleCommittee.committees.length;
      var len2 = $scope.memberRoleCommittee.subcommittees.length;
      if ($scope.memberRoleCommittee) {
        for (var i = 0; i < len1; i++) {
          var itm = {
            'committeeName': $scope.memberRoleCommittee.committees[i].name,
            'committeeRank': $scope.memberRoleCommittee.committees[i].rank_in_party,
            'committeeBeginDate': $scope.memberRoleCommittee.committees[i].begin_date,
            'committeeEndDate': $scope.memberRoleCommittee.committees[i].end_date,
            'committeeCode': $scope.memberRoleCommittee.committees[i].code,
            'subcommittees': []
          }
          $scope.committeeData.push(itm);
        }

        $timeout(function() {
          for (var j = 0; j < $scope.committeeData.length; j++) {
            for (var k = 0; k < len2; k++) {
              if ($scope.committeeData[j].committeeCode == $scope.memberRoleCommittee.subcommittees[k].parent_committee_id) {

                var sub = {
                  'scommitteeName': $scope.memberRoleCommittee.subcommittees[k].name,
                  'scommitteeRank': $scope.memberRoleCommittee.subcommittees[k].rank_in_party,
                  'scommitteeBeginDate': $scope.memberRoleCommittee.subcommittees[k].begin_date,
                  'scommitteeEndDate': $scope.memberRoleCommittee.subcommittees[k].end_date,
                  'scommitteeParentId': $scope.memberRoleCommittee.subcommittees[k].parent_committee_id,
                  'scommitteeCode': $scope.memberRoleCommittee.subcommittees[k].code
                }

                $scope.committeeData[j].subcommittees.push(sub);
                //$scope.committeeData.push(itm);
              }
            }
          }
        }, 2000);
        MyService.ConsoleLog("committeeData : ", $scope.committeeData);



      }
    }
    $scope.getCommitteesYears = function() {
      MyService.ConsoleLog('getCommitteesYears');
      var len = $scope.propublicaData.roles.length;
      var yr = '';
      if (len > 0) {
        for (var i = 0; i < len; i++) {
          if ($scope.propublicaData.roles[i].committees.length > 0 || $scope.propublicaData.roles[i].subcommittees.length > 0) {
            switch ($scope.propublicaData.roles[i].congress) {
              case '116':
                yr = '2019 - 2021';
                break;
              case '115':
                yr = '2017 - 2018';
                break;
              case '114':
                yr = '2015 - 2016';
                break;
              case '113':
                yr = '2013 - 2014';
                break;
              case '112':
                yr = '2011 - 2012';
                break;
              case '111':
                yr = '2009 - 2010';
                break;
              case '110':
                yr = '2007 - 2008';
                break;
              case '109':
                yr = '2005 - 2006';
                break;
              case '108':
                yr = '2003 - 2004';
                break;
              case '107':
                yr = '2001 - 2002';
                break;
              case '106':
                yr = '1999 - 2000';
                break;
              case '105':
                yr = '1997 - 1998';
                break;
              case '104':
                yr = '1995 - 1996';
                break;
              case '103':
                yr = '1993 - 1994';
                break;
              case '102':
                yr = '1991 - 1992';
                break;
              case '101':
                yr = '1989 - 1990';
                break;
              case "default":
                break;
            }
            var itm = {
              'year': yr,
              'id': i,
              'committeesid': i,
              'congress': $scope.propublicaData.roles[i].congress
            }
            $scope.committeesYears.push(itm);
          }
        }
      }
    }
    
    */
    $scope.getProbublicaData = function() {
      MyService.ConsoleLog("In getProbublicaData");
      var data = {};
      data.id = $routeParams.id;
      data.type = $scope.politicianUser;
      MyService.ConsoleLog("data : ");
      MyService.getProbublicaData(data).then(function(payload) {
          MyService.ConsoleLog("Success : ", payload);
          if (payload) {
            $scope.propublicaData = payload.data.data;
            $scope.memberCrpId = $scope.propublicaData.crp_id;
            $scope.getIndustrySupport($scope.contYear);
            MyService.ConsoleLog(typeof($scope.propublicaData.roles));
            // if (typeof($scope.propublicaData.roles[0]) == 'string') {
            //   $scope.propublicaData.roles = JSON.parse($scope.propublicaData.roles);
            //   $scope.memberRole = $scope.propublicaData.roles[$scope.currentRole];
            // } else {
            var len = $scope.propublicaData.roles.length;
            var yr = ''
            for (var i = 0; i < len; i++) {
              switch ($scope.propublicaData.roles[i].congress) {
                case '116':
                  yr = '2019 - 2021';
                  break;
                case '115':
                  yr = '2017 - 2018';
                  break;
                case '114':
                  yr = '2015 - 2016';
                  break;
                case '113':
                  yr = '2013 - 2014';
                  break;
                case '112':
                  yr = '2011 - 2012';
                  break;
                case '111':
                  yr = '2009 - 2010';
                  break;
                case '110':
                  yr = '2007 - 2008';
                  break;
                case '109':
                  yr = '2005 - 2006';
                  break;
                case '108':
                  yr = '2003 - 2004';
                  break;
                case '107':
                  yr = '2001 - 2002';
                  break;
                case '106':
                  yr = '1999 - 2000';
                  break;
                case '105':
                  yr = '1997 - 1998';
                  break;
                case '104':
                  yr = '1995 - 1996';
                  break;
                case '103':
                  yr = '1993 - 1994';
                  break;
                case '102':
                  yr = '1991 - 1992';
                  break;
                case '101':
                  yr = '1989 - 1990';
                  break;
                case "default":
                  break;
              }
              var itm = {
                'year': yr,
                'id': i,
                'committeesid': i,
                'congress': $scope.propublicaData.roles[i].congress
              }
              $scope.allroles.push(itm);
            }
            //alert("allroles : ", $scope.allroles[0].id);
            $scope.getCommitteesYears();
            $scope.memberRole = $scope.propublicaData.roles[$scope.currentRole];
            $scope.memberRoleCommittee = $scope.propublicaData.roles[$scope.currentRole];
            //}
            $timeout(function() {
              $scope.arrangeComitteeData();
            }, 1000);

            if ($scope.memberRole.at_large) {
              if ($scope.memberRole.at_large == true) {
                $scope.atLarge = 'At large';
              } else {
                $scope.atLarge = "";
              }
            }
            $scope.allRoles = $scope.propublicaData.roles.length;
            //MyService.ConsoleLog("allRoles : ", $scope.allRoles);
            MyService.ConsoleLog("$scope.propublicaData : ", $scope.propublicaData);
          }
        },
        function(errorPayload) {
          MyService.ConsoleLog('Something went wrong : ', errorPayload);
        });
    }
/*
    $scope.getBillCosponsored = function(id) {
      MyService.ConsoleLog("In getBillCosponsored :" + id);
      $location.path("/sponsored/" + id + "/" + $scope.userId + "/" + $routeParams.type);
      /*if ($scope.showSponsoredContent == false) {
        $scope.showSponsoredContent = true;
        var data = {};
        data.id = id;
        MyService.getBillCosponsoredData(data).then(function(data) {
          MyService.ConsoleLog("getBillCosponsored success : ", data);
          $scope.sponsorData = data.data.data.results[0].bills;
        }, function(err) {
          MyService.ConsoleLog("getBillCosponsored error : ", err);
        });
      } else {
        $scope.showSponsoredContent = false;
      }*/
/*    }

    $scope.getVotingRecords = function(id) {
      $location.path("/votingRecords/" + id + "/" + $scope.userId + "/" + $routeParams.type);
      /*if ($scope.showSponsoredContent == false) {
        $scope.showSponsoredContent = true;
        var data = {};
        data.id = id;
        MyService.getVotingRecords(data).then(function(data) {
          MyService.ConsoleLog("getVotingRecords success : ", data);
          //$scope.sponsorData = data.data.data.results[0].bills;
        }, function(err) {
          MyService.ConsoleLog("getVotingRecords error : ", err);
        });
      } else {
        $scope.showSponsoredContent = false;
      }*/
 //   }

    $scope.getIndustrySupport = function(yr) {
      MyService.ConsoleLog("In getIndustrySupport : ");
      if ($scope.memberCrpId) {
        var data = {}; 
        data.crpid = $scope.memberCrpId;
        data.year = yr;
        MyService.getIndustryData(data).then(function(res) {
          MyService.ConsoleLog("res : ", res);
          $scope.industrySupport = res.data.data.industries;
          $scope.currentContent = 'industrysupport';
          var cy = (new Date()).getFullYear();
          if ($scope.industrySupport['@attributes'].cycle == cy && yr != cy) {
            $scope.msg = "There are no records for " + yr + "";
            $scope.industrySupport = [];
          } else {
            $scope.msg = "";

          }
          //$scope.supportYear = $scope.industrySupport['@attributes'].cycle - 2;
        }, function(err) {
          MyService.ConsoleLog("err : ", err);
          $scope.supportYear = (new Date()).getFullYear();
        });
      }
    }

    $scope.personalHoldings = function() {
      MyService.ConsoleLog("In personalHoldings : " + $scope.memberCrpId);
      if ($scope.memberCrpId) {
        var data = {};
        data.crpid = $scope.memberCrpId;
        MyService.getPersonalHoldings(data).then(function(res) {
          MyService.ConsoleLog("personalHoldings res : ", res);
          $scope.personalHoldingData = res.data.data;

          $scope.currentContent = 'personalHoldings';
        }, function(err) {
          MyService.ConsoleLog("err : ", err);
        });
      }
    }
    $scope.fundRaising = function() {
      MyService.ConsoleLog("In fundRaising : " + $scope.memberCrpId);
      if ($scope.memberCrpId) {
        var data = {};
        data.crpid = $scope.memberCrpId;
        MyService.getFundRaising(data).then(function(res) {
          MyService.ConsoleLog("fundRaising res : ", res);
          $scope.fundRaisingData = res.data.data.summary['@attributes'];
          $scope.currentContent = 'fundRaising';
        }, function(err) {
          MyService.ConsoleLog("err : ", err);
        });
      }
    }

    $scope.topContributor = function(yr) {
      MyService.ConsoleLog("In topContributor : " + yr);
      $scope.contYear = yr;
      if ($scope.memberCrpId) {
        var data = {};
        data.crpid = $scope.memberCrpId;
        data.year = yr;
        MyService.getTopContributor(data).then(function(res) {
          MyService.ConsoleLog("topContributor res : ", res);
          $scope.topContributorData = res.data.data.contributors;
          var cy = (new Date()).getFullYear();
          if ($scope.topContributorData['@attributes'].cycle == cy && yr != cy) {
            $scope.msg = "There are no records for " + yr + "";
            $scope.topContributorData = [];
          } else {
            $scope.msg = "";

          }
          //$scope.contYear = $scope.topContributorData['@attributes'].cycle - 2;
        }, function(err) {
          MyService.ConsoleLog("err : ", err);
          $scope.contYear = (new Date()).getFullYear();
        });
      }
    }

    if ($routeParams.id != "") {
      $scope.getData();
      $scope.getProbublicaData();
      $timeout(function() {
        $scope.topContributor($scope.contYear);
      }, 3000);
    }

    $scope.showPreviousYearRole = function(id, type) {
      MyService.ConsoleLog("current role : " + $scope.currentRole);
      MyService.ConsoleLog("allRoles : " + $scope.allRoles);
      //if ($scope.currentRole < $scope.allRoles) {
      $scope.currentRole = $scope.currentRole + 1;
      if (type == 'legislation') {
        $scope.memberRole = $scope.propublicaData.roles[id];
      } else {
        $scope.memberRoleCommittee = $scope.propublicaData.roles[id];
        $scope.arrangeComitteeData();
      }
      /*if ($scope.memberRole.at_large) {
        if ($scope.memberRole.at_large == true) {
          $scope.atLarge = 'At large';
        } else {
          $scope.atLarge = "";
        }
      }*/
      //}
    }

    $scope.matchParty = function(letter) {
      if (letter == 'D') {
        return 'Democrat';
      } else if (letter == 'I') {
        return 'Independent'
      } else if (letter == 'R') {
        return 'Republican'
      } else {
        return 'Other';
      }

    }
  }]);

'use strict';
angular.module('myApp.placesShape', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/placesShapes', {
      templateUrl: 'app/placesShape/placesShape.html',
      controller: 'PlacesShapeCtrl'
    });
  }]) .controller('PlacesShapeCtrl', ['$scope', 'ngDialog', '$rootScope', 'MyService', '$http', '$timeout', function ($scope, ngDialog, $rootScope, MyService, $http, $timeout) {

    $scope.gridOptions = {
      enableFiltering: true,
      showGridFooter: true,
      showColumnFooter: false,
    };

    $scope.getPlacesData = function () {
      MyService.getPlaceShape({}).then(function (records) {
        // MyService.ConsoleLog(records);
        // console.log('records for place shape', records);
        var columns = [];
        if (records.data.success) {
          var fdata = records.data.data;
          angular.forEach(fdata[0], function (pd, i) {
            // MyService.ConsoleLog("Field :", i);
            if (i != "__v" && i != "_id") {
              var nc = Object;
              nc.field = i;
              nc.displayName = i;
              nc.width = 100;
              var str = {
                field: i,
                width: '140'
              };
              columns.push(str);
            }

          });
          MyService.ConsoleLog(columns);
          $scope.gridOptions.columnDefs = columns;
          $scope.gridOptions.data = fdata;
        }
      }, function (err) {
        $scope.showLoader = false;
        MyService.ConsoleLog("error : ", err);
      });
    }

    if ($rootScope.showPlacesShape) {
      $scope.getPlacesData();
    }
  }])
'use strict';

angular.module('myApp.otherPoliticians', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/otherPoliticians', {
      templateUrl: 'app/otherPoliticians/otherPoliticians.html',
      controller: 'otherPoliticiansCtrl'
    });
  }])
  .controller('otherPoliticiansCtrl', ['$scope', '$rootScope', 'MyService',
    '$http', '$filter', 'growl', '$q', '$cookies', 'apiCall', '$anchorScroll', '$location',
    function ($scope, $rootScope, MyService, $http, $filter, growl, $q, $cookies, apiCall, $anchorScroll, $location) {
      $rootScope.welcome = false;
      $scope.search = {
        pName: '',
        level: '',
        curState: '',
        county: '',
        city: '',
        chamber: '',
        party: '',
        isOffice: ''
      };
      $scope.showLoader = false;
      $scope.loader = false;
      $scope.allState = [];
      $scope.address = {
        state: "",
        upstate: "",
        files: ""
      };
      $scope.countyone = false;
      $scope.cityone = false;
      $scope.showChamber = false;

      /**
       * @description Function is use to show all state data.
       */
      $scope.getAllStates = function () {
        $scope.showLoader = true;
        $scope.allState.length = 0;

        if ($scope.search.level == 'federalCongressionalDistrict') {
          $scope.showChamber = true;

        } else if ($scope.search.level == 'statePostalCode') {
          $scope.showChamber = true;
        }
        // console.log("address.state", $scope.address.state);
        MyService.getAllStates().then(
          function (payload) {
            MyService.ConsoleLog("payload : ", payload);
            $scope.allState = payload;
            $scope.showLoader = false;
          },
          function (errorPayload) {
            growl.error("Something went wrong.");
            $scope.showLoader = false;
          }
        );
      };

      /**
       * End of getAllState
       */


      /**
       * @description Function is use to search politicians
       */

      $scope.searchPoliticians = function () {
        var newHash = 'compareContent';

        $scope.poliData = '';
        if (!$filter("isBlankString")($scope.search.pName) || !$filter("isBlankString")($scope.search.level) || !$filter("isBlankString")($scope.search.chamber) || !$filter("isBlankString")($scope.search.curState) || !$filter("isBlankString")($scope.search.party)) {
          $scope.loader = true;

          MyService.searchPoliticiansWith($scope.search).then(function (response) {
            MyService.ConsoleLog("response: ", response);
            if (response && response.length > 0) {

              $scope.poliData = response;
              if (!$cookies.get('params')) {
                $cookies.put('params', JSON.stringify($scope.search));
              } else {
                $cookies.remove('params');
              }
              if ($location.hash() !== newHash) {
                $location.hash('compareContent');
              } else {
                $anchorScroll();
              }
              $scope.loader = false;

              if ($scope.search.level == 'federalCongressionalDistrict') {
                $scope.showChamber = true;

              } else if ($scope.search.level == 'statePostalCode') {
                $scope.showChamber = true;
              }
            } else {
              $scope.loader = false;
              growl.error(response);

            }

          }, function (err) {
            console.log("Error", err);
            growl.error(err);
            $scope.loader = false;

          });
        } else {
          growl.error("Please enter politician name");
          $scope.loader = false;
        }
      };

      /**
       * End of searchPoliticians
       */

      $scope.getAllStates();
      MyService.ConsoleLog("$cookies.get()", $cookies.get('params'));
      if ($cookies.get('params')) {
        console.log("data", JSON.parse($cookies.get('params')));
        $scope.search = '';
        $scope.search = JSON.parse($cookies.get('params'));
        $scope.searchPoliticians();
        // $cookies.remove('params');
      }


      /**
       * @description Get  County within selected state
       */
      var getCountiesCanceler = $q.defer();
      $scope.getCounties = function () {
        // alert("first");
        // MyService.ConsoleLog("$scope.User.cur_state: ", $scope.User.cur_state)
        // MyService.ConsoleLog("old",$scope.oldaddress);
        $scope.counties = "";
        var statePostalCode = "";

        if ($scope.search.curState && $scope.search.curState.stateFips) {
          statePostalCode = $scope.search.curState.stateFips;
        }

        MyService.ConsoleLog("statePostalCode", statePostalCode);

        var request = apiCall.apiCall("POST", "/user/getAllCounties", {
          statePostalCode: statePostalCode,
          timeout: getCountiesCanceler.promise
        });
        $http(request).then(
          function successCallback(response) {
            if (response.data.success) {
              MyService.ConsoleLog("response", response.data.data);
              $scope.counties = response.data.data;
              console.log("$scope.alllcounties>>", $scope.counties);
              // if (lbl == "new") {
              if ($scope.search.level == "placeName") {
                $scope.countyone = true;
                $scope.showLoader = false;
              }

              if ($scope.search.level == "Other") {
                $scope.countyone = true;
                $scope.showLoader = false;
              }

              if ($scope.search.level == "countyName") {
                $scope.countyone = true;
                $scope.showcur_office_nameDrop = true;
                $scope.showLoader = false;
              }
              $scope.address.county = $scope.counties;
              MyService.ConsoleLog("$scope.address.county >", $scope.address.county);
              // }
            } else {
              growl.error("Something went wrong.");
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
          }
        );
      };

      /**
       * @description Get Cities within county
       */
      $scope.getSubCounties = function () {
        $scope.arr = [];
        $scope.dis = false;

        // $scope.countyone = false;

        $scope.allsubcounty = "";
        $scope.places = "";

        MyService.ConsoleLog("$scope.state >>>", $scope.search.curState);
        MyService.ConsoleLog("$scope.County >>>", $scope.address.county);
        if ($scope.search.level == "placeName" || $scope.search.level == "Other") {
          $scope.showLoaderOne = true;
          // $scope.LoaderTwo = false;
        }


        MyService.getPlacesAndSubCounty($scope.search.curState.stateFips, $scope.address.county.countyFips, $scope.search.curState.state)
          .then(function (response) {
            MyService.ConsoleLog("response >>", response);

            var sub = response.countySubdivision.filter(function (val) {
              var cmat = val.city.substring(val.city.length - 3);
              if (cmat != 'CDP') {
                return val;

              }
            });

            $scope.allsubcounty = sub;

            var plFil = response.places.filter(function (item) {
              MyService.ConsoleLog('item', item);
              var smTxt = item.city.substring(item.city.length - 3);
              if (smTxt != 'CDP') {
                return item;
                MyService.ConsoleLog("smTxt >>", smTxt);

              }

            });
            MyService.ConsoleLog("plFil >>", plFil);
            $scope.finArr = $scope.allsubcounty.concat(plFil);
            MyService.ConsoleLog("$scope.arr", $scope.finArr);

            $scope.places = $scope.finArr;
            if ($scope.search.level == "placeName") {
              $scope.cityone = true;

            }
            $scope.showLoaderOne = false;

          }, function (error) {
            MyService.ConsoleLog("Error >>", error);
          });

      }

      /**
       * @description Reset all drop downs
       */
      $scope.resetDropDown = function () {
        $scope.cityone = false;
        $scope.countyone = false;
        $scope.poliData = '';
        // $scope.showChamber = false;
        $scope.places = '';
        $scope.address.county = '';
        $scope.getAllStates();
        if ($scope.search.level == 'federalCongressionalDistrict') {
          $scope.showChamber = true;

        } else if ($scope.search.level == 'statePostalCode') {
          $scope.showChamber = true;
        }
      };

      /**
       * @description Filters politicians data
       */
      $scope.filterItems = function () {
        return function (u) {
          // if (!u.name.includes('test') && !u.name.includes('Test') && !u.name.includes('jack')) {

          if ($scope.search.level == 'federalCongressionalDistrict' && !$scope.search.chamber) {
            if (u.office && u.office != '') {
              if (u.office == 'u.s. senate' || u.office == 'u.s. house') {
                u.voterScope = 'federalCongressionalDistrict';
                return u;
              }
            }
          } else if ($scope.search.level == 'federalCongressionalDistrict' && $scope.search.chamber == 'senate') {

            if (u.office && u.office != '') {
              if (u.winDetails && u.winDetails.length > 0) {
                if (u.winDetails[0].office == 'u.s. senate' || u.winDetails[0].office == 'U.S. Senate') {
                  u.voterScope = 'federalCongressionalDistrict';
                  return u;
                }
              } else if (u.office == 'u.s. senate') {
                u.voterScope = 'federalCongressionalDistrict';
                return u;
              }
            }
          } else if ($scope.search.level == 'federalCongressionalDistrict' && $scope.search.chamber == 'house') {

            if (u.office && u.office != '') {
              if (u.office == 'u.s. house') {
                u.voterScope = 'federalCongressionalDistrict';
                return u;
              } else if (u.winDetails && u.winDetails[0].office.toLowerCase() == 'u.s. house') {
                u.voterScope = 'federalCongressionalDistrict';
                return u;
              }
            }
          } else if ($scope.search.level == 'statePostalCode' && $scope.search.chamber == 'senate') {
            if (u.office && u.office != '') {
              if (u.office == 'state senate') {

                return u;
              }
            }
          } else if ($scope.search.level == 'statePostalCode' && $scope.search.chamber == 'house') {
            if (u.office && u.office != '') {
              if (u.office == 'state house') {

                return u;
              }
            }
          } else {
            return u;
          }
          // }
          // }
        };
      };

      /**
       * @description Reset All the fields of search.
       *
       */
      $scope.resetSearch = function () {
        $scope.search = {
          pName: '',
          level: '',
          curState: '',
          county: '',
          city: '',
          chamber: '',
          party: '',
          isOffice: ''
        };
        $scope.cityone = false;
        $scope.countyone = false;
        $scope.showChamber = false;

      };
    }
  ]);

'use strict';
angular.module('myApp.orgVideo', ['ngRoute'])
  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/orgVideo', {
      templateUrl: 'app/orgVideo/orgVideo.html',
      reloadOnSearch: false,
      controller: 'orgVideoCtrl' //we can name anythin
    });
  }])
  .controller('orgVideoCtrl', ['$scope', '$rootScope', '$window', function($scope, $rootScope, $window) {
    //this is controller for sampepage.html, we link the conttoler to page in config defination, check above .config
    $rootScope.welcome = false;
    $window.scrollTo(0, 0);
  }]);

'use strict';

angular
  .module('myApp.orgRating', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/orgRating/:pressId/:type?', {
        templateUrl: 'app/orgRating/orgRating.html',
        controller: 'orgRatingCtrl',
      });
    },
  ])

  .controller('orgRatingCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    '$routeParams',
    '$rootScope',
    'baseApiUrl',
    '$q',
    '$timeout',
    'growl',
    'tokenService',
    '$anchorScroll',
    '$sce',
    'MyService',
    'ngDialog',
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $rootScope,
      baseApiUrl,
      $q,
      $timeout,
      growl,
      tokenService,
      $anchorScroll,
      $sce,
      MyService,
      ngDialog
    ) {
      $rootScope.welcome = false;
      $scope.pressId = $routeParams.pressId;
      $scope.showUnFollow = false;
      // $scope.loginUser = tokenService.getUserId();
      $scope.dataType = $routeParams.type;
      $scope.userType = tokenService.getUserRole();

      $scope.showCon = false;
      $scope.showBoth = false;
      $scope.showEm = false;


      /**
       * Redirect
       */
      $scope.goto = function () {
        $location.path('/verifyBy');
      };

      /**
       * Close it
       */
      $scope.closeIt = function () {
        $scope.PopDialog.close();
      };
      $scope.getmyData = function () {
        $scope.ShowPorifleLoading = true;
        MyService.getUserPublicProfile({
          id: tokenService.getUserId(),
          type: 'false'
        }).then(function (response) {
          $scope.ShowPorifleLoading = false;
          if (response.data.success) {
            $scope.userDetails = response.data.data;
            // MyService.ConsoleLog("welcome", $scope.userDetails);
            $scope.userProfile = $scope.userDetails.userData;
            MyService.ConsoleLog("welcome to profile", $scope.userProfile);

            $scope.userType = $scope.userProfile.userType;
            $scope.verify = $scope.userProfile.verifiedUser;
            // MyService.ConsoleLog("welcome", $scope.verify);
            // console.log("$scope.userDetails", $scope.userDetails.userData.address);
            if (!$scope.userProfile.verifiedUser) {
              $scope.showCon = true;
            }
            if (!$scope.userProfile.isEmailVerified || !$scope.userProfile.verifiedUser) {
              // $scope.getPopUp();
              if (!$scope.userProfile.isEmailVerified && !$scope.userProfile.verifiedUser) {
                if ($scope.userProfile.userType == 'politician') {
                  $scope.showCon = true;
                  $scope.showBoth = true;
                } else if (!$scope.userProfile.isEmailVerified) {
                  $scope.showEm = true;
                }
              } else if (!$scope.userProfile.isEmailVerified) {
                // if ($scope.userProfile.userType != 'politician') {
                $scope.showEm = true;
                // }
              } else {
                if ($scope.userProfile.userType != 'politician') {
                  $scope.showEm = true;
                }
              }
              if ($scope.userProfile.userType == 'politician') {
                $scope.PopDialog = ngDialog.open({
                  template: 'popUp',
                  closeByNavigation: true,
                  scope: $scope,
                  width: '50%',
                  closeByDocument: false
                });
              } else if ($scope.userProfile.userType == 'advocate' && $scope.userProfile.isEmailVerified != true) {
                // alert('cal');
                MyService.ConsoleLog("$scope.userProfile", $scope.userProfile.isEmailVerified);
                $scope.PopDialog = ngDialog.open({
                  template: 'popUp',
                  closeByNavigation: true,
                  scope: $scope,
                  width: '50%',
                  closeByDocument: false
                });
              }
            }
            // if (!$scope.userDetails.userData.address.statePostalCode) {
            //   $scope.addressPopup = ngDialog.open({
            //     template: 'addressPopUp',
            //     closeByNavigation: true,
            //     scope: $scope
            //   });
            // };

          } else {
            MyService.ConsoleLog("ELSE vishal");
            alert("Something went wrong.");
          }
        }, function (errorPayload) {
          $scope.ShowPorifleLoading = false;
          MyService.ConsoleLog("ELSE vishal two");

          alert("Something went wrong.");
        });
      }

      if (tokenService.getUserId()) {
        $scope.getmyData();
      }

      if (tokenService.getUserData()) {
        $scope.uData = JSON.parse(tokenService.getUserData());

      }

      $scope.froumthreads = [];
      $scope.press = {};
      $scope.Sticky = {
        ShowOrder: [],
        txtOrder: [],
      };
      $scope.vote = {
        recommend: 0,
        factual: 0,
      };
      //$scope.GalleryFolder = baseApiUrl + "/resources/" + $scope.uData.uname;
      if (tokenService.getUserData()) {
        $scope.UserData = JSON.parse(tokenService.getUserData());
        MyService.ConsoleLog('$scope.UserData >', $scope.UserData);
      }
      $scope.displayComments = true;
      $scope.Reply = {};

      $scope.checkMemId = function (rdata, val) {
        return rdata.filter(function (rdata) {
          if (rdata.userData._id == $rootScope.UserId) return rdata;
        });
      };

      $scope.CheckUrl = function (url, option) {
        if (url) {
          if (url.indexOf('youtube.com') >= 0) {
            var url = url.replace('watch?v=', 'embed/');
            if (option == 'V')
              return $sce.trustAsHtml(
                '<br/><iframe width="560" height="315" src="' +
                url +
                '" frameborder="0" allowfullscreen></iframe><br/>'
              );
            else
              return $sce.trustAsHtml(
                '<br/><iframe src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>'
              );
          }
          if (url.indexOf('facebook.com') >= 0) {
            if (option == 'V')
              return $sce.trustAsHtml(
                '<br/><iframe src="' +
                url +
                '" width="560" height="315" frameborder="0"></iframe><br/>'
              );
            else
              return $sce.trustAsHtml(
                '<br/><iframe src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>'
              );
          }
          if (url.indexOf('vimeo.com') >= 0) {
            if (url.indexOf('https://vimeo.com/') >= 0) {
              var id = url.replace('https://vimeo.com/', '');
              var newurl = 'https://player.vimeo.com/video/' + id;
            } else {
              var newurl = url;
            }
            if (option == 'V')
              return $sce.trustAsHtml(
                '<br/><iframe src="' +
                newurl +
                '" width="500" height="281" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe><br/>'
              );
            else
              return $sce.trustAsHtml(
                '<br/><iframe src="' +
                newurl +
                '" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe><br/>'
              );
          }
          if (option == 'V')
            return $sce.trustAsHtml(
              '<br/><iframe width="560" height="315" src="' +
              url +
              '" frameborder="0" allowfullscreen></iframe><br/>'
            );
          else
            return $sce.trustAsHtml(
              '<br/><iframe src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>'
            );
        }
      };

      $scope.chkIfVoted = function (rdata, val) {
        return rdata.filter(function (rdata) {
          if (rdata.user.id == val) return rdata;
        });
      };
      $scope.loginUser = tokenService.getUserId();
      $scope.getPressDetails = function () {
        //MyService.ConsoleLog("Get One called");
        MyService.getPress($routeParams.pressId).then(
          function (payload) {
            MyService.ConsoleLog('payLoad', payload);
            if ($scope.UserData && $scope.UserData.followlist.length > 0) {
              var fLen = $scope.UserData.followlist.length;
              for (var f = 0; f < fLen; f++) {
                // MyService.ConsoleLog("$scope.UserData.followlist[f]", $scope.UserData.followlist[f]);
                if ($scope.UserData.followlist[f] == $routeParams.pressId) {
                  $scope.showUnFollow = true;
                  // growl.success("showUnfollow");
                  // alert("showunfollow");
                }
                /*else {
              // MyService.ConsoleLog("userProfile", $scope.userProfile);
              if ($scope.UserData.followlist[f] == $scope.userProfile.officeId) {
                $scope.showUnFollow = true;

              }
            }*/
              }
            }
            if (payload && payload.orgdata) {
              $scope.pressUser = payload.userData;
              $scope.press = payload.orgdata;
              if (payload.orgdata.recommended) {
                var chkrecommend = $scope.chkIfVoted(payload.orgdata.recommended, $scope.loginUser);

                if (chkrecommend && chkrecommend[0]) {
                  $scope.vote.recommend = chkrecommend[0].vote;
                }
              }
              if (payload.orgdata.factual) {
                var chkfactual = $scope.chkIfVoted(payload.orgdata.factual, $scope.loginUser);

                if (chkfactual && chkfactual[0]) {
                  $scope.vote.factual = chkfactual[0].vote;
                }
              }
            } else {
              $scope.press = payload;
              $scope.pressUser = payload;
              MyService.ConsoleLog(' $scope.press ', $scope.press);
              if (payload.recommended) {
                var chkrecommend = $scope.chkIfVoted(payload.recommended, $scope.loginUser);

                if (chkrecommend && chkrecommend[0]) {
                  $scope.vote.recommend = chkrecommend[0].vote;
                }
              }
              if (payload.factual) {
                var chkfactual = $scope.chkIfVoted(payload.factual, $scope.loginUser);

                if (chkfactual && chkfactual[0]) {
                  $scope.vote.factual = chkfactual[0].vote;
                }
              }
            }
            MyService.getHighlighatedPost({
              pId: $scope.pressId,
            }).then(
              function (response) {
                MyService.ConsoleLog('response', response);
                $scope.HighlightedPost = response.data;
              },
              function (err) {
                MyService.ConsoleLog('Error', err);
              }
            );
          },
          function (errorPayload) {
            MyService.ConsoleLog("one", errorPayload);
            alert('Something went wrong ');
          }
        );
      };

      /**
       * Redirect to discussion page
       */
      $scope.redirectToDiscuss = function () {
        // growl.success("redirect to discussion");
        $location.path('/debateHome');
      };

      /**
       * Follow orgnization
       */
      $scope.addtoFollow = function () {
        var data = {};
        data.userId = $scope.loginUser;
        data.pushId = $routeParams.pressId;
        MyService.updateUserFollowList(data).then(
          function (payload) {
            alert('User added to followup list successfully.');
            if ($scope.UserData) {
              $scope.showUnFollow = true;
              $scope.UserData.followlist.push($routeParams.pressId);
              MyService.ConsoleLog('udata : ', $scope.UserData);
              tokenService.saveUserData(JSON.stringify($scope.UserData));
            }
          },
          function (errorPayload) {
            MyService.ConsoleLog("two", errorPayload);

            alert('Something went wrong ');
          }
        );
      };

      /**Unfollow organization*/

      $scope.removetoFollow = function () {
        var data = {};
        data.userId = $scope.loginUser;
        data.pushId = $routeParams.pressId;
        MyService.removeUserFollowList(data).then(
          function (result) {
            MyService.ConsoleLog('result', result);
            $scope.showUnFollow = false;
            var ids = $scope.UserData.followlist.indexOf($routeParams.pressId);
            MyService.ConsoleLog('ids', ids);
            if (ids > -1) {
              $scope.UserData.followlist.splice(ids, 1);
            }

            // else {
            //   var idx = $scope.UserData.followlist.indexOf($scope.userProfile.officeId);
            //   if (idx > -1) {
            //     $scope.UserData.followlist.splice(idx, 1);
            //   }
            // }
            //MyService.ConsoleLog("udata : ", $scope.UserData);
            tokenService.saveUserData(JSON.stringify($scope.UserData));
          },
          function (err) {
            MyService.ConsoleLog('error', err);
          }
        );
      };

      function getCategory() {
        MyService.getCategoryList($routeParams.categoryId).then(
          function (payload) {
            $scope.category = payload;
          },
          function (errorPayload) {
            MyService.ConsoleLog("three", errorPayload);

            alert('Something went wrong ');
          }
        );
      }

      $scope.gotoThread = function (data) {
        //MyService.ConsoleLog(data);
        var id = '';
        if (data.parentId) {
          id = data.parentId;
        } else {
          id = data.id;
        }
        $location('forumthread/' + id);
      };

      $scope.updateCommentApi = function (data, options, idex) {
        MyService.updatePressComments(data).then(
          function (payload) {
            if (payload.nModified == 0) {
              alert('You already provided your inputs on this post');
            } else {
              switch (options) {
                case 'like':
                  $scope.essayComments[idex].totalLikes = $scope.essayComments[idex].totalLikes + 1;
                  break;
                case 'dislike':
                  $scope.essayComments[idex].totalDislike =
                    $scope.essayComments[idex].totalDislike + 1;
                  break;
                default:
                  $scope.essayComments[idex].totalSpam = $scope.essayComments[idex].totalSpam + 1;
                  break;
              }
            }
          },
          function (errorPayload) {
            // alert('Something went wrong ');
            MyService.ConsoleLog("vishal", errorPayload);
            growl.error(errorPayload.error);
          }
        );
      };

      $scope.updateComments = function (options, id, idex) {
        if ($rootScope.UserId) {
          if ($scope.essayComments[idex].createdBy.id != $rootScope.UserId) {
            var commentData = {};
            commentData.commentId = id;
            commentData.userId = $rootScope.UserId;

            switch (options) {
              case 'like':
                commentData.likes = 1;
                break;
              case 'dislike':
                commentData.dislikes = 1;
                break;
              default:
                commentData.spam = 1;
                break;
            }

            $scope.updateCommentApi(commentData, options, idex);
          } else {
            alert('You cannot ' + options + ' your own comments');
          }
        } else {
          alert('Please login to perform these actions');
        }
      };
      $scope.submitSticky = function (data, id, idx) {
        if (data > 0) {
          updateForum('sticky', id, idx);
        } else {
          alert('Please enter valid order');
        }
      };

      $scope.ShowComments = false;

      $scope.redirectToComment = function () {
        var token = apiCall.getToken();
        if (!token) {
          var message = 'Please login first.';

          var modal = ngDialog.openConfirm({
            template: '<p>' +
              message +
              '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
            plain: true,
          });

          modal.then(
            function fullfilled(data) {
              //MyService.ConsoleLog("fullfilled: ", data);
              $location.path('signin');
            },
            function rejected(data) {
              //MyService.ConsoleLog("rejected: ", data);
              $location.path('signin');
            }
          );
        }
        $scope.ShowComments = true;
        $scope.displayComments = false;

        //$location.path('forumReply/'+$routeParams.categoryId+'/'+$routeParams.subcatId+'/'+$routeParams.essayId);
      };

      $scope.goBack = function () {
        $scope.ShowComments = false;
        $scope.displayComments = true;
      };

      $scope.getComments = function () {
        MyService.getPressComments($routeParams.pressId).then(
          function (payload) {
            $scope.essayComments = payload;
            MyService.ConsoleLog("$scope.essayComments", $scope.essayComments);
          },
          function (errorPayload) {
            // alert('Something went wrong ');
            MyService.ConsoleLog("vishal two", errorPayload);

            growl.error(errorPayload.error);
          }
        );
      };

      $scope.SubmitComment = function (rec) {
        //MyService.ConsoleLog(data);
        //MyService.ConsoleLog($scope.mainThread);
        var data = {};
        if (rec.content != '') {
          $scope.TopicButton = true;
          data.createdById = $rootScope.UserId;
          data.createdByName = $rootScope.User;
          data.createdByType = tokenService.getUserRole();
          data.comments = rec.content;
          data.pressId = $routeParams.pressId;
          //MyService.ConsoleLog(data);
          MyService.submitPressComments(data).then(
            function (payload) {
              $scope.comments = {
                content: '',
              };
              $scope.ShowComments = false;
              $scope.displayComments = true;
              $scope.mainThread = {};
              //$location.path('forumthread/'+$routeParams.categoryId+'/'+$routeParams.subcatId+'/'+$routeParams.essayId);
              $scope.getComments();
            },
            function (errorPayload) {
              // alert('Something went wrong ');
              MyService.ConsoleLog("ommmmmm");
              $scope.ShowComments = false;
              $scope.displayComments = true;
              growl.error(errorPayload.error);

            }
          );
        } else {
          alert('Please enter comments.');
        }
      };

      $scope.PressVote = function (option) {
        var token = apiCall.getToken();
        if (!token) {
          var message = 'Please login first.';

          var modal = ngDialog.openConfirm({
            template: '<p>' +
              message +
              '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
            plain: true,
          });

          modal.then(
            function fullfilled(data) {
              //MyService.ConsoleLog("fullfilled: ", data);
              $location.path('signin');
            },
            function rejected(data) {
              //MyService.ConsoleLog("rejected: ", data);
              $location.path('signin');
            }
          );
        } else {
          var data = {};
          data._id = $routeParams.pressId;
          data.mediaType = '';
          data.option = option;
          //MyService.ConsoleLog(option);
          if (option == 'Recommended') {
            data.vote = $scope.vote.recommend;
          } else {
            data.vote = $scope.vote.factual;
          }
          data.createdById = $scope.loginUser;
          data.createdByName = tokenService.getUserName();
          data.createdByType = tokenService.getUserRole();
          MyService.updatePress(data).then(
            function (payload) {
              alert('Thank you for rating the press.');
            },
            function (errorPayload) {
              // alert('Something went wrong ');
              MyService.ConsoleLog("ommmmdsssmm");
              console.log("error", errorPayload);
              $scope.vote.recommend = "";
              $scope.vote.factual = "";
              growl.error(errorPayload.error);
            }
          );
        }
      };

      $scope.getVotesmartPressDetails = function () {
        console.log('getVotesmartPressDetails');
        MyService.getVotesmartPressDetails({
          sigid: $scope.pressId,
        }).then(
          function (payload) {
            console.log('payload1 > ', payload);
            if (payload.data.success) {
              $scope.press = payload.data.data;
            } else {
              MyService.ConsoleLog("five", payload);
              alert('Something went wrong ');
            }
          },
          function (epayload) {
            MyService.ConsoleLog("six", epayload);
            alert('Something went wrong ');
          }
        );
      };

      console.log('new', $scope.dataType);
      if ($scope.dataType && $scope.dataType == 'false') {
        $scope.getVotesmartPressDetails();
      } else {
        if ($routeParams.pressId) {
          $scope.getPressDetails();
          $scope.getComments();
        }
      }
    },
  ]);

'use strict';
angular.module('myApp.orgQuizIntro', ['ngRoute'])

  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/orgQuizIntro', {
      templateUrl: 'app/orgQuizIntro/orgQuizIntro.html',
      controller: 'orgQuizIntroCtrl'
    });
  }])
  .controller('orgQuizIntroCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService) {

  }]);

'use strict';

angular.module('myApp.orgQuizComparison', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/orgQuizComparison/:type?/:quizName?', {
      templateUrl: 'app/orgQuizComparison/orgQuizComparison.html',
      controller: 'orgQuizComparisonCtrl'
    });
  }])

  .controller('orgQuizComparisonCtrl', ['$scope', 'apiCall', 'MyService', '$location', '$anchorScroll', '$timeout', '$rootScope', 'ngDialog', '$q', '$http', '$filter', 'growl', '$routeParams', 'baseApiUrl', 'tokenService', '$cookies', function ($scope, apiCall, MyService, $location, $anchorScroll, $timeout, $rootScope, ngDialog, $q, $http, $filter, growl, $routeParams, baseApiUrl, tokenService, $cookies) {

    $scope.showAlert = false;

    $scope.quizName = $routeParams.quizName;
    $scope.showcomparison = false;

    if (tokenService.getUserData()) {
      var userData = JSON.parse(tokenService.getUserData());
      // console.log("userData > ", userData);
    }
    var orgs;
    if ($cookies.get('sendEmail')) {
      var isData = JSON.parse($cookies.get('sendEmail'));
      //MyService.ConsoleLog("isData", isData);
      if ($cookies.get('orgTitle')) {
        orgs = JSON.parse($cookies.get('orgTitle'));

      }
      if (isData && isData != '') {
        $cookies.remove('sendEmail');
        var ansLink = window.location.origin + '/#!/showPoliticianAns/' + $scope.quizName;
        var filData = $rootScope.fiveMatch.filter(function (itm) {
          if (itm && itm.questionId && itm.questionId != '') {
            return itm;
          }
        });
        // alert('inside');
        MyService.sendEmailToOrg({
          quizName: $scope.quizName,
          orgEmail: isData,
          orgData: orgs,
          ansLink: ansLink,
          ansQues: filData.length
        }).then(function (result) {
          //MyService.ConsoleLog("result", result);
        }, function (err) {
          //MyService.ConsoleLog("Error", err);
        });
      }
    }

    // if (!$cookies.get('isShowPopUp')) {
    if ($cookies.get('showNotice')) {

      if ($cookies.get('orgTitle')) {
        $scope.orgData = JSON.parse($cookies.get('orgTitle'));
        $scope.orgName = $scope.orgData.title;
        MyService.ConsoleLog(" $scope.orgData", $scope.orgData);
        // alert('callled');
      } else {
        $scope.orgName = "Organization";
      }
    }
    // }

    /**
     * Get more quizzes
     */
    $scope.moreQuizzes = function () {
      $location.path('/quizzes');
    };

    /**
     * See contact info of the org
     */
    $scope.seeContact = function () {
      $location.path('/pressProfile/' + $scope.orgData._id);
    };

    /**
     * @description
     */

    $scope.seeComparison = function () {
      $location.path('/popularQuizMatch');
    };
  }]);

'use strict';
angular.module('myApp.orgQuestions', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/orgQuestions/:quizName?', {
      templateUrl: 'app/orgQuestions/orgQuestions.html',
      controller: 'orgQuestionsCtrl'
    });
  }])
  .controller('orgQuestionsCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', 'growl', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService, growl) {

    $scope.qName = $routeParams.quizName;
    // MyService.ConsoleLog("$scope", $scope.qName);




    /**
     * Get Selected Questions by organization
     */

    $scope.getQuestions = function () {
      MyService.getSelectedQues({
        orgId: tokenService.getUserId(),
        quizName: $scope.qName
      }).then(function (result) {
        MyService.ConsoleLog("result", result);
        $scope.questions = result.data.data;
        $scope.questions.sort(function (a, b) {
          var x, y;
          x = a.qOrder;
          y = b.qOrder;
          if (x < y) {
            return -1;
          }
          if (x > y) {
            return 1;
          }
          return 0;
        });
      }, function (err) {
        growl.error(err);
      });
    };

    /**
     * Call this function on page load because we have to show questions list to the organization on page load
     */

    $scope.getQuestions();

    /**
     * start call when row started dragging.
     */

    $scope.start = function (event, ui, order, id, ind) {
      MyService.ConsoleLog("current order", order);
      MyService.ConsoleLog("current index", id);
      MyService.ConsoleLog("$index", ind);
      $scope.oldOrder = order;
      $scope.curId = id;
    };

    /**
     * End of start
     */

    /**
     * Drop function called when rows drop from on position to another
     */

    $scope.drop = function (event, ui, order, id, ind) {

      MyService.ConsoleLog("order", order);
      MyService.ConsoleLog("ind", id);
      MyService.ConsoleLog("$index", ind);

      MyService.updateOrder({
        curId: $scope.curId,
        newOrder: order,
        oldOrder: $scope.oldOrder,
        orgId: tokenService.getUserId()
      }).then(function (response) {
        MyService.ConsoleLog("response", response);
        $scope.getQuestions();
      }, function (error) {
        MyService.ConsoleLog("error", error);
      });
    };

    /**
     * End of drop
     */

    /**
     * removeQue
     * Remove questions from quiz
     */
    $scope.removeQue = function (ele) {
      MyService.ConsoleLog("Ele", ele);
      MyService.removeOrgQues({
        orgId: ele.orgId,
        qId: ele._id
      }).then(function (result) {
        MyService.ConsoleLog("Result", result);
        growl.success("Removed Successfully");
        $scope.getQuestions();
      }, function (err) {
        MyService.ConsoleLog("Error", err);
      });
    };

  }]);

'use strict';
angular
  .module('myApp.orgMatch', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/orgMatch/:orgId?', {
        templateUrl: 'app/orgMatch/orgMatch.html',
        controller: 'orgMatchCtrl',
      });
    },
  ]).controller('orgMatchCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    '$routeParams',
    '$q',
    'ngDialog',
    '$rootScope',
    'growl',
    'MyService',
    '$anchorScroll',
    '$timeout',
    'tokenService',
    '$cookies',
    'baseApiUrl',
    '$document',
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $q,
      ngDialog,
      $rootScope,
      growl,
      MyService,
      $anchorScroll,
      $timeout,
      tokenService,
      $cookies,
      baseApiUrl,
      $document
    ) {

      /**
       * Get Route param value
       */
      $scope.orgId = $routeParams.orgId;

      MyService.ConsoleLog("one more sir", $scope.orgId);
      // $cookies.remove('isAlreadyAnswer');
      // $cookies.put('isAlreadyAnswer', true);
      if (window.localStorage.getItem('fiveMatch')) {
        $rootScope.resultOfAns = JSON.parse(window.localStorage.getItem('fiveMatch'));
      }

      $scope.showcomparison = false;
      $scope.noDataFound = false;


      $scope.traverseBackgrounds = [];
      $scope.currBackgroundIndex = 0;
      $scope.status = {
        questions: 0, //1=loading, 2=loaded, 3=error
        category: 0
      };

      $scope.currentIndex = 0;


      var getCategoryCanceler = $q.defer();
      var prevFetchedCategoryId = null;

      /**
       * Get Followers Ids
       */
      $scope.getFollowers = function () {
        MyService.getIdsOfFollowers({
          orgId: $scope.orgId
        }).then(function (response) {
          $scope.fIds = response.data.data;
          MyService.ConsoleLog("response", $scope.fIds);

          $scope.getCompMatch();
        }, function (err) {
          MyService.ConsoleLog("Error", err);
        });
      };

      $scope.getFollowers();

      /**
       * Get Match
       */
      $scope.getCompMatch = function () {
        // MyService.ConsoleLog(" $scope.orgId", $scope.orgId);
        // MyService.ConsoleLog('$rootScope.resultOfAns >> ', $rootScope.resultOfAns);
        MyService.getFollowerMatch({
          orgId: $scope.orgId,
          fIds: JSON.stringify($scope.fIds),
          followerData: JSON.stringify($rootScope.resultOfAns),
          curUId: tokenService.getUserId()
        }).then(function (result) {
          MyService.ConsoleLog("Results", result);
          if (result && result.data.data && result.data.data.qdata) {
            $scope.questions = result.data.data.qdata;
            $scope.FBCompareList = result.data.data.qdata;

            if ($scope.FBCompareList && $scope.FBCompareList.length > 0) {
              $scope.FBunWeighted = result.data.data.unweightedMatch;
              $scope.fbcombinedWeight = result.data.data.fbcombinedWeight;
              $scope.fbmultiplier = result.data.data.fbmultiplier;
              $scope.answeredQuestions = result.data.data.answeredQuestions;
              $scope.fbqlen = result.data.data.qlen;
              $scope.AllUsers = result.data.data.AllUsers;
              $scope.orgName = result.data.data.orgName;
              // $scope.showcomparison = true;
              // MyService.ConsoleLog("$scope.AllUsers ", $scope.AllUsers);
              // MyService.ConsoleLog(" $scope.FBunWeighted", $scope.FBunWeighted);
            }
          } else {
            growl.error(result.data.data.orgName + ' not answered the quiz yet');
          }

        }, function (err) {
          MyService.ConsoleLog("Error", err);
        });
      };


      /**
       * Show match details
       */
      $scope.showDetails = function () {
        $scope.showcomparison = true;
        $scope.currentIndex = 0;
      };



      /**
       * Get Category for background
       */


      $scope.getCategory = function (params) {
        try {
          prevFetchedCategoryId = $scope.category._id
        } catch (e) {}
        if (prevFetchedCategoryId != params.id) {
          $routeParams.categoryId = params.id;
          $("html, body").animate({
            scrollTop: 0
          }, "slow");
          getCategoryCanceler.resolve();
          getCategoryCanceler = $q.defer()
          $scope.status.category = 1;

          MyService.getCategories(params, getCategoryCanceler.promise).then(function (response) {
            if (response) {
              if (response.data.success) {
                $scope.category = response.data.data;
                // MyService.ConsoleLog("$scope.category", $scope.category);
                prevFetchedCategoryId = $scope.category._id;
                $scope.status.category = 2;
              } else {
                $scope.status.category = 3;
              }
            } else {
              $scope.status.category = 2;
            }
          }, function (err) {
            ////MyService.ConsoleLog("Error: ", err);
            $scope.status.category = 3;
            ////MyService.ConsoleLog("$scope.status: ", $scope.status.category);
          });
        } else {
          $timeout(function () {
            $location.hash('DisplayQ');
            $anchorScroll();
          }, 500);
        }
      };



      $scope.viewAnsComment = function (ans) {
        if (ans.comment) {
          ngDialog.open({
            template: 'app/popups/show_comment_txt.html',
            controller: 'OldAnswerViewerCtrl',
            data: {
              title: "Comment",
              content: ans.comment
            }
          });
        }
      };


      $scope.rootCatIndex = 0;
      $scope.getRootCategoryIndex = function () {
        if ($routeParams.categoryId == 'all') {
          var len = $rootScope.categories.length;
          for (var i = 0; i < len; i++) {
            if ($routeParams.parentId == $rootScope.categories[i]._id) {
              $scope.rootCatIndex = i;
              ////MyService.ConsoleLog("rootCatIndex : ", $scope.rootCatIndex);
              break;
            }
          }
        }
      };

      var getLevelCategoryCanceler = $q.defer();

      function getLevelCategory(params) {
        getLevelCategoryCanceler.resolve();
        $scope.status.levlCat = 1;
        params.timeout = getLevelCategoryCanceler.promise;
        var request = apiCall.apiCall('GET', '/categories/list-layer', params);
        $http(
            request
          )
          .then(function successCallback(response) {
            ////MyService.ConsoleLog("Got categories: ",response);
            if (response.data.success) {
              $scope.traverseBackgrounds = response.data.data;
              if ($routeParams.selectedCatId) {
                angular.forEach(response.data.data, function (val, key) {
                  if (val._id == $routeParams.selectedCatId) {
                    $scope.currBackgroundIndex = key;
                    $scope.category = val;
                  }
                });
              } else if ($scope.traverseBackgrounds.length > 0) {
                $scope.category = $scope.traverseBackgrounds[0];
              }
              $scope.status.levlCat = 2;
            } else {
              ////MyService.ConsoleLog("Something went wrong: ", response.data);
              $scope.status.levlCat = 3;
            }
          }, function errorCallBack(response) {
            ////MyService.ConsoleLog("Error: ", response);
            $scope.status.levlCat = 3;
          });
      }

      $scope.skipQuestion = function () {
        var skip = function () {
          var tempIndex = $scope.currentIndex + 1;
          if (tempIndex < $scope.questions.length) {
            $scope.currentIndex++;
            if ($routeParams.categoryId && $routeParams.categoryId.indexOf("popular:") == 0) {
              $scope.getCategory({
                id: $scope.questions[$scope.currentIndex].categories[0].cid
              });
            }
          }
          if ((tempIndex == $scope.questions.length) || $scope.questions.length == 0) {
            var tempBackIdx = $scope.currBackgroundIndex + 1;
            if (tempBackIdx < $scope.traverseBackgrounds.length) {
              $scope.currBackgroundIndex++;
              // alert("if");
              $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
            } else {
              $scope.rootCatIndex++;
              $scope.showcomparison = false;
              $scope.noDataFound = false;
              // alert("else");
              window.localStorage.setItem("RootCatIndex", $scope.rootCatIndex);
              window.localStorage.setItem("DisplayCategory", JSON.stringify($scope.category));

              //$location.path("/compare-politician-questions");

            }
          }
          //$scope.currentIndex++;
        };

        skip();
      };

      $scope.prevQuestion = function () {
        ////MyService.ConsoleLog("** prevQuestion **");
        // $timeout(function() {
        //   $location.hash('DisplayQ');
        //   $anchorScroll();
        // }, 1500);
        if ($scope.currentIndex > 0) {
          $scope.currentIndex--;
        } else if ($scope.currentIndex == 0) {
          if ($scope.currBackgroundIndex > 0) {
            $scope.currBackgroundIndex--;
            $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
          } else {
            ////MyService.ConsoleLog("** end of background **");
            if ($scope.rootCatIndex > 0) {
              $scope.rootCatIndex--;
              $location.path("/question-compare-politician/all/" + $rootScope.categories[$scope.rootCatIndex]._id);
            }
          }
        }
      };

      $scope.compareChanged = function (compare_with) {
        // //MyService.ConsoleLog("compare_with :", compare_with);
        var catid = $routeParams.categoryId;
        if ($routeParams.categoryId && $routeParams.categoryId.indexOf("popular:") == 0) {
          var catid = $routeParams.categoryId.split("popular:")[1];
        }

        $location.path('/compare-select/' + compare_with);
      };

      $scope.getComapreClass = function (match, i) {

        if (match >= 100)
          return 'ag-dg1';
        if (match >= 80)
          return 'ag-dg2';
        if (match >= 60)
          return 'ag-dg3';
        if (match >= 40)
          return 'ag-dg4';
        if (match >= 20)
          return 'ag-dg5';
        if (match >= 0)
          return 'ag-dg6';

        return 'ag-dg';
      };




      var current_url = $location.url();
      ////MyService.ConsoleLog("$location.url: ", current_url);

      $scope.state = "question-compare-politician";
      if (!$rootScope.selectedCompareUsers || $rootScope.selectedCompareUsers.length <= 0) {
        //$location.path("/questionHome");

      } else {
        if ($routeParams.categoryId == 'all') {
          ////MyService.ConsoleLog("compare all answers");
          var param = {
            id: $routeParams.parentId,
            questions_counter: 1
          };
          getLevelCategory(param);
          $scope.getRootCategoryIndex();
        } // traverse all questions
        else {
          $scope.questions = $rootScope.compareAnswerList;
          // //MyService.ConsoleLog($scope.questions);
          var catid = $routeParams.categoryId;
          // //MyService.ConsoleLog(catid)
          $scope.getCategory({
            id: catid
          });
        }
      }



      $scope.retainOptions = "";
      $scope.fb = {
        options: "C"
      };

      // $scope.getFiveFacebookPost();

      $scope.$watch('category', function (newValue, oldValue) {
        //MyService.ConsoleLog("** category watch **");
        var current_url = $location.url();
        if (current_url.indexOf("question-tagged") > -1)
          return; //for tagged questions don't again fetch questions

        if (newValue) {
          if (oldValue && oldValue._id == newValue._id) return;

          if (current_url.indexOf("question-compare-politician") > -1) {
            var temp_uids = [];
            angular.forEach($rootScope.selectedCompareUsers, function (val, key) {
              temp_uids.push(val._id);
            });

          }
        }
      });

      $scope.$watch('questions', function (newValue, oldValue) {
        //MyService.ConsoleLog("** questions watch **");
        if (!$scope.questions) {
          $scope.questions = $rootScope.fiveminquestions;
        }
        try {
          if ($scope.questions) {
            var tempCate = $scope.questions[$scope.currentIndex].categories;
            if (angular.isArray(tempCate)) {
              $scope.getCategory({
                id: tempCate[0].cid
              });
            } else {
              $scope.getCategory({
                id: tempCate.cid
              });
            }
          }
          // $scope.initMyAnswer();
        } catch (e) {
          //MyService.ConsoleLog("questions Index Change Ex: ", e)
        }
      });

      $scope.$watch('currentIndex', function (newValue, oldValue) {
        //MyService.ConsoleLog("** currentIndex watch **");
        // console.log("fiveminquestions >> ", $rootScope.fiveminquestions);
        if (!$scope.questions) {
          $scope.questions = $rootScope.fiveminquestions;
        }
        try {
          // //MyService.ConsoleLog("Current question: ", $scope.questions[$scope.currentIndex]);
          if ($scope.questions) {
            var tempCate = $scope.questions[$scope.currentIndex].categories;
            if (angular.isArray(tempCate)) {
              $scope.getCategory({
                id: tempCate[0].cid
              });
            } else {
              $scope.getCategory({
                id: tempCate.cid
              });
            }
          }
          // $scope.initMyAnswer();
        } catch (e) {
          //MyService.ConsoleLog("Current Index Change Ex: ", e)
        }
      });
    }
  ]);

'use strict';
angular.module('myApp.organizedTable', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/organizedTable', {
      templateUrl: 'app/organizedTable/organizedTable.html',
      controller: 'OrganizedTblCtrl'
    });
  }]).controller('OrganizedTblCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'growl', 'tokenService', 'ngDialog', 'baseApiUrl', '$anchorScroll', 'MyService', '$window', '$sce', 'uiGridConstants', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, growl, tokenService, ngDialog, baseApiUrl, $anchorScroll, MyService, $window, $sce, uiGridConstants) {
    //MyService.ConsoleLog("** UploadPoliticianCtrl **");
    $scope.allState = [];
    $scope.address = {
      "state": "",
      "upstate": "",
      "files": ""
    };
    $scope.getAllStates = function () {
      $scope.allState.length = 0;
      $scope.loader = true;
      MyService.getAllStates().then(function (payload) {
          $scope.allState = payload;
          $scope.loader = false;
        },
        function (errorPayload) {
          growl.error('Something went wrong.');
          $scope.loader = false;
        });
    }
    $scope.loader = false;
    $scope.displayLong = false;
    $scope.ziprecords = [];
    $scope.recordLength = 0;
    $scope.getOrganizedData = function () {
      var state = $scope.address.state;
      //MyService.ConsoleLog(state.statePostalCode);
      $scope.loader = true;
      $scope.displayLong = true;
      $scope.ziprecords.length = 0;
      $scope.recordLength = 0;
      MyService.getOrganizedData({
        "state": state.statePostalCode
      }).then(function (payload) {
        //MyService.ConsoleLog(payload.length);
        $scope.recordLength = payload.length;
        $scope.ziprecords = payload;
        $scope.loader = false;
        $scope.displayLong = false;
      }, function (errorPayload) {
        //MyService.ConsoleLog("error");
        //MyService.ConsoleLog(errorPayload);
        $scope.loader = false;
        $scope.displayLong = false;
      });

    }

    $scope.updateZips = function (data) {
      //MyService.ConsoleLog(data);
      if (data.files != "") {
        //MyService.ConsoleLog(data.files.type.indexOf("office"));
        //alert("This needs to be implemented");

        if (data.files.type.indexOf("office") > -1) {
          alert("This is still to be implemented.");
          $scope.PressButton = true;
          //MyService.ConsoleLog("data : ", data);
          var fd = new FormData();
          fd.append('file', data.files);
          fd.append('state', data.upsate);
          var posturl = baseApiUrl + "/user/uploadZips";
          //MyService.ConsoleLog(data.upstate.statePostalCode);
          //MyService.ConsoleLog(data.files);
          //MyService.ConsoleLog(JSON.stringify(fd));


          $http.post(posturl, fd, {
              transformRequest: angular.identity,
              headers: {
                'Content-Type': undefined
              }
            })
            .success(function (response, status, headers, config) {
              //MyService.ConsoleLog("response : ", response);
              if (response.success) {
                //$location.path('/learnHome');
                alert("File successfully imported.");
              } else {
                alert("Something went wrong.");
              }
            })
            .error(function (data, status, headers, config) {
              //MyService.ConsoleLog("error");
              alert("Something went wrong.");
            });


        } else {
          alert("Please select xlsx file");
        }

      } else {
        alert("Please select file");
      }

    }

    if ($rootScope.showOrganized) {
      //alert("Here");
      $scope.getAllStates();
    }

  }])
'use strict';
angular
  .module('myApp.organizationQuiz', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/organizationQuiz/:quizName?/:orgId?/:poliId?', {
        templateUrl: 'app/organizationQuiz/organizationQuiz.html',
        controller: 'organizationQuizCtrl',
      });
    },
  ])
  .controller('organizationQuizCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    '$routeParams',
    '$q',
    'ngDialog',
    '$rootScope',
    'growl',
    'MyService',
    '$anchorScroll',
    '$timeout',
    'tokenService',
    '$cookies',
    'baseApiUrl',
    '$document',
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $q,
      ngDialog,
      $rootScope,
      growl,
      MyService,
      $anchorScroll,
      $timeout,
      tokenService,
      $cookies,
      baseApiUrl,
      $document
    ) {
      $scope.qName = $routeParams.quizName;
      $scope.orgId = $routeParams.orgId;
      $scope.poliId = $routeParams.poliId;
      $cookies.remove('showLogin');
      $cookies.remove('qName');
      $cookies.remove('orgId');
      $cookies.remove('showNotice');
      $cookies.remove('orgTitle');
      $cookies.remove('sendEmail');

      if (!tokenService.getUserId()) {
        // alert('one');
        $cookies.put('qName', $scope.qName);
        $cookies.put('orgId', $scope.orgId);
        $cookies.put('showLogin', 'true');
        $location.path('/signin');
      }
      // return;
      $rootScope.welcome = true;
      $scope.currentIndex = 0;
      $scope.questions = [];
      $scope.oldQuestions = [];
      $scope.tempans = [];
      $scope.oldIndex = 0;
      $scope.showZipCode = false;
      $scope.showloader = false;
      $scope.UserId = tokenService.getUserId();
      $scope.skipToMatchNew = false;
      $scope.skipToFinal = false;
      // $scope.flag = $routeParams.flag;
      window.localStorage.removeItem('followData');
      window.localStorage.removeItem('comData');
      window.localStorage.removeItem('fiveMatch')
      $scope.updata = {
        comment: '',
        reason: '',
      };
      // $scope.skipToRes = false;
      $('#skipMatch').attr('disabled', true);

      MyService.ConsoleLog(' user id :', $scope.UserId);
      if ($cookies.get('sessionId')) {
        $cookies.remove('sessionId');
      }
      $scope.fivefb = {
        title: 'Take a fun five minute quiz to find out who to vote for in your local elections',
        description: '',
        fbFiveImage: '',
      };

      $scope.getFiveFacebookPost = function (data) {
        MyService.getFiveFacebookPost().then(
          function (payload) {
            // MyService.ConsoleLog(payload)
            if (payload.data.success) {
              $scope.fivefb.title = payload.data.data.fbTitle;
              $scope.fivefb.description = payload.data.data.fbDescription;
              if (payload.data.data.fbImage) {
                $scope.fivefb.fbFiveImage = baseApiUrl + '/resources/' + payload.data.data.fbImage;
              }
            }
          },
          function (errorPayload) {}
        );
      };

      $scope.skipToMatchs = function () {
        $location.path('/popularQuizMatch');
      };

      $scope.skipToCompare = function () {
        $location.path('/getPopularComparison');
      };

      // $scope.getFiveFacebookPost();

      if ($scope.currentIndex == 0) {
        if (window.localStorage.getItem('fiveMatch')) {
          // $scope.questions = JSON.parse(window.localStorage.getItem("fiveMinMatch"));
          $rootScope.fiveMatch = JSON.parse(window.localStorage.getItem('fiveMatch'));
          $timeout(function () {
            $scope.$apply();
          });
        } else {
          $rootScope.fiveMatch = [];
          $rootScope.fiveMatch.length = 0;
        }
      }
      $scope.initializeVariables = function () {
        $scope.importance = null;
        $scope.answer = null;
        $scope.updata.comment = '';
        $scope.updata.reason = '';
      };

      $scope.saveFiveMinAnswers = function (skip) {
        // MyService.ConsoleLog("saveFiveMinAnswers : ");
        MyService.ConsoleLog('saveFiveMinAnswers fiveMatch >>>: ', $rootScope.fiveMatch);
        // alert(skip);
        $scope.pstData = [];
        var len = $rootScope.fiveMatch.length;
        MyService.ConsoleLog('Len :: ', len);
        if (len > 0) {
          for (var i = 0, k = 1; i < len; i++) {
            if (skip != '') {
              $scope.answer = '';
              $scope.importance = '';
              $scope.updata.comment = '';
              if ($rootScope.fiveMatch[i]) {
                // console.log("Inside i ", i);
                // console.log("answer :", $rootScope.fiveMatch[i].answer);
                if ($rootScope.fiveMatch[i].answer && $rootScope.fiveMatch[i].answer != '') {
                  $scope.answer = $rootScope.fiveMatch[i].answer;
                  $scope.importance = $rootScope.fiveMatch[i].importance;
                  $scope.updata.comment = $rootScope.fiveMatch[i].comment;
                  var postData = {
                    questionId: $rootScope.fiveMatch[i]._id,
                    importance: $scope.importance,
                    answer: $scope.answer,
                    comment: $scope.updata.comment,
                    categories: $rootScope.fiveMatch[i]['categories'],
                    content: $rootScope.fiveMatch[i]['content'],
                    _id: $rootScope.fiveMatch[i]['_id'],
                  };
                  $rootScope.fiveMatch[i] = angular.copy(postData);
                  // console.log("fiveMatch[i] > ", $rootScope.fiveMatch[i]);
                  $scope.pstData.push(postData);
                } else {
                  var data = $scope.checkQuestion($rootScope.fiveMatch[i]._id);
                  if (data && data[0]) {
                    // MyService.ConsoleLog("getdata >>> ", data[0]);
                    if (data[0].answer != '') {
                      $scope.answer = data[0].answer;
                    }
                    if (data[0].importance != '') {
                      $scope.importance = data[0].importance;
                    }
                    if (data[0].comment != '') {
                      $scope.updata.comment = data[0].comment;
                    }
                  }
                  var postData1 = {
                    questionId: $rootScope.fiveMatch[i]._id,
                    importance: $scope.importance,
                    answer: $scope.answer,
                    comment: $scope.updata.comment,
                    categories: $rootScope.fiveMatch[i]['categories'],
                    content: $rootScope.fiveMatch[i]['content'],
                    _id: $rootScope.fiveMatch[i]['_id'],
                  };
                  $rootScope.fiveMatch[i] = angular.copy(postData1);
                  $scope.pstData.push(postData1);
                }
              }
            } else {
              var postData = $rootScope.fiveMatch[i];
              $scope.pstData.push(postData);
            }
            if (skip != '' && postData) {
              console.log('saveFiveMinAnswers postData >>>>>>> ', postData);

              MyService.postAnswer(postData).then(
                function (response) {
                  // MyService.ConsoleLog("saveFiveMinAnswers response >>>", response);
                  if (response.data.success) {
                    MyService.ConsoleLog('Answer updated successfully');
                    growl.success('Answer updated successfully');
                  } else {
                    MyService.ConsoleLog('Error: ' + response.data.error);
                    growl.error(response.data.error);
                  }
                  if (k == len) {
                    $rootScope.fiveMatch = angular.copy($scope.pstData);
                    window.localStorage.setItem('fiveMatch', JSON.stringify($rootScope.fiveMatch));
                    MyService.ConsoleLog(
                      '$rootScope.fiveMatch > ******** >>>',
                      $rootScope.fiveMatch
                    );
                    if (skip == 'RediectNew') {
                      // alert('three');

                      $location.path('/orgQuizComparison/skip_to_result');
                    } else if (skip != 'skipNew') {
                      MyService.ConsoleLog('IFFFFFFFFFFFFFF');
                      // alert('four');
                      $cookies.put('showNotice', true);
                      $cookies.put('orgTitle', JSON.stringify($scope.orgInfo));
                      if ($scope.orgUser && $scope.orgUser.email && $scope.orgUser.email != '') {
                        $cookies.put('sendEmail', JSON.stringify($scope.orgUser.email));
                      }
                      if ($cookies.get('showBanner') == 'true') {
                        var qName = $cookies.get('quizName') ? $cookies.get('quizName') : $routeParams.quizName;
                        $location.path('/orgQuizComparison/' + '' + '/' + qName);
                        $cookies.remove('showBanner');
                      } else {
                        $location.path('/popularQuizMatch');
                      }

                    }
                  }
                  k++;
                },
                function (err) {
                  MyService.ConsoleLog('Error: err');
                }
              );
            } else {
              $scope.updata.comment = '';

              if (k == len) {
                $rootScope.fiveMatch = angular.copy($scope.pstData);
                MyService.ConsoleLog('$rootScope.fiveMatch  one > ******** >>>', $rootScope.fiveMatch);

                if ($scope.qName && $scope.qName != '') {
                  window.localStorage.setItem('fiveMatch', JSON.stringify($rootScope.fiveMatch));
                  MyService.ConsoleLog('$rootScope.fiveMatch > ******** >>>', $rootScope.fiveMatch);
                } else {
                  // MyService.ConsoleLog('$rootScope.fiveMatch > ******** >>>', $rootScope.fiveMatch);
                  var tempFil = $rootScope.fiveMatch.filter(function (ele) {
                    if (ele.my_answer) {
                      return ele;
                    }
                  });
                  MyService.ConsoleLog('$rootScope.fiveMatch new > ******** >>>', tempFil);
                  if (tempFil && tempFil.length > 0) {
                    window.localStorage.setItem('fiveMatch', JSON.stringify(tempFil));

                  } else {
                    var tLen = $rootScope.fiveMatch.length;
                    var tempArr = [];
                    for (var s = 0; s < tLen; s++) {
                      var obj = {};
                      obj.my_answer = $rootScope.fiveMatch[i];
                      obj._id = $rootScope.fiveMatch[i].questionId;
                      obj.content = $rootScope.fiveMatch[i].content;
                      tempArr.push(obj);
                    }
                    MyService.ConsoleLog('$rootScope.fiveMatch else  tempArr> ******** >>>', tempArr);

                    window.localStorage.setItem('fiveMatch', JSON.stringify(tempArr));
                  }

                }

                if (skip == 'RediectNew') {
                  // alert('5');
                  $location.path('/orgQuizComparison/skip_to_result');
                } else if (skip != 'skipNew') {
                  MyService.ConsoleLog('IFFFFFFFFFFFFFF');
                  $cookies.put('orgTitle', JSON.stringify($scope.orgInfo));
                  $cookies.put('showNotice', true);
                  if ($scope.orgUser && $scope.orgUser.email && $scope.orgUser.email != '') {
                    $cookies.put('sendEmail', JSON.stringify($scope.orgUser.email));
                  }
                  // alert('6');

                  if ($cookies.get('showBanner') == 'true') {
                    var qName = $cookies.get('quizName') ? $cookies.get('quizName') : $routeParams.quizName;

                    $location.path('/orgQuizComparison/' + '' + '/' + qName);
                    $cookies.remove('showBanner');
                  } else {
                    $location.path('/popularQuizMatch');
                  }
                }
              }
              k++;
            }
          }
        }
      };

      $scope.fiveMinuteMatchDone = function () {
        $scope.showpopUp = false;
        if (!$scope.UserId || $scope.UserId == '') {
          MyService.ConsoleLog('$scope.Questions', $scope.questions);
          var qLen = $scope.questions.length;
          for (var t = 0; t < qLen; t++) {
            if (
              $scope.questions[t].my_answer &&
              $scope.questions[t].my_answer != '' &&
              $scope.questions[t].my_answer.answer != ''
            ) {
              if ($scope.poliId && $scope.poliId != '') {
                $location.path('/fiveminsignin');
              } else {
                $scope.showpopUp = true;
                $scope.showZipCode = true;
              }
            } else {
              if (!$scope.showpopUp && t == qLen - 1) {
                var message = 'You need to answer at least one question to see a match comparison';
                var modal = ngDialog.openConfirm({
                  template: '<p>' +
                    message +
                    '</p>\
                  <div class="ngdialog-buttons">\
                      <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Back to Questions</button>\
                  </div>',
                  plain: true,
                  closeByDocument: false,
                });
                modal.then(
                  function fullfilled(data) {
                    // MyService.ConsoleLog("fullfilled: ", data);
                    $scope.getOrgQuiz();
                  },
                  function rejected(data) {
                    // MyService.ConsoleLog("rejected: ", data);
                    // $scope.getMatchQUestions();
                  }
                );
                t = qLen + 1;
              }
            }
          }
        } else {
          // alert('one');
          $scope.saveFiveMinAnswers('');
        }
      };
      $scope.initializeVariables();
      $scope.newQuestion = function () {
        MyService.ConsoleLog('newQuestion' + $scope.currentIndex);
        var tempIndex = $scope.currentIndex;
        $scope.initializeVariables();

        $scope.answer = '';
        $scope.importance = '';
        $scope.updata.comment = '';
        if (tempIndex < $scope.questions.length) {
          $scope.initializeVariables();

          if (window.localStorage.getItem('fiveMatch')) {
            $scope.getFiveMinData = [];
            $scope.getFiveMinData = JSON.parse(window.localStorage.getItem('fiveMatch'));
            MyService.ConsoleLog('Data : ', $scope.getFiveMinData);
            for (var i = 0; i < $scope.getFiveMinData.length; i++) {
              // MyService.ConsoleLog("for i : " + i + " currentIndex : " + $scope.currentIndex);
              if (i == $scope.currentIndex) {
                // MyService.ConsoleLog("index matched", $scope.getFiveMinData[i]);
                $scope.answer = $scope.getFiveMinData[i].answer;
                $scope.importance = $scope.getFiveMinData[i].importance;
                $scope.updata.comment = $scope.getFiveMinData[i].comment;
                $timeout(function () {
                  $scope.$apply();
                });
              }
            }
          } else {
            console.log('Else is called');
            $scope.answer = '';
            $scope.importance = '';
            $scope.updata.comment = '';
            console.log('importance > ', $scope.importance);
          }
          //$scope.currentIndex++;
        } else {
          // MyService.ConsoleLog("final question : " + $scope.questions.length);
          $scope.fiveMinuteMatchDone();
        }
      };

      $scope.checkQuestion = function (val) {
        if ($scope.AllAnsweredQuestions && $scope.AllAnsweredQuestions.length > 0) {
          // alert('if');
          // MyService.ConsoleLog("IDDDDDDDDDDDDDDDDDDDDDFFFFFFFFFFFF");
          return $scope.AllAnsweredQuestions.filter(function (rdata) {
            // MyService.ConsoleLog(rdata.question + "==" + val);
            if (rdata.question == val) return rdata;
          });
        } else {
          // alert('else');
          MyService.ConsoleLog('elseeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee');
          return $rootScope.fiveMatch.filter(function (rdata) {
            // MyService.ConsoleLog(rdata.questionId + "<==>" + val);
            if (rdata.questionId == val) return rdata;
          });
        }
      };

      $scope.checkIfExists = function (val) {
        var obj = $scope.questions[$scope.currentIndex];
        if (obj) {
          var data;
          if (obj && obj.queId && obj.queId != '') {
            // MyService.ConsoleLog("checkIfExists >> ", obj);
            // MyService.ConsoleLog("iddddssssssssssss");
            data = $scope.checkQuestion(obj.queId);
          } else {
            data = $scope.checkQuestion(obj._id);
            // MyService.ConsoleLog("else", data);
          }

          if (data && data[0]) {
            // MyService.ConsoleLog("checkIfExists data>> ", data[0]);
            // $scope.comment = data[0].comment;
            if (data[0].answer == val) {
              // console.log("return True");
              $scope.dis = true;
              return true;
            }
          }
        }
        return false;
      };

      $scope.checkQuestionAnswered = function () {
        // console.log("scope.questions > ", $scope.questions);
        return $scope.questions.filter(function (rdata) {
          // MyService.ConsoleLog("== rdata >>>", rdata);
          var data = $scope.checkQuestion(rdata._id);
          // MyService.ConsoleLog("rdata.questionId  ", data);

          if (data && data.length > 0) return rdata;
        });
      };

      $scope.oneMore = function (valOne) {
        console.log('One more clicked');
        $scope.importance = valOne;

        // console.log("$scope.importance >> ",$scope.importance);
        $scope.submitAnswer();
      };

      $scope.checkImpExists = function (val) {
        // MyService.ConsoleLog('checkImpExists called :', $scope.importance);
        var obj = $scope.questions[$scope.currentIndex];
        if (obj) {
          // MyService.ConsoleLog('data', obj);
          var data;
          if (obj && obj.queId && obj.queId != '') {
            data = $scope.checkQuestion(obj.queId);
          } else {
            data = $scope.checkQuestion(obj._id);
          }
          if (data && data[0]) {
            if (data[0].importance == val) {
              return true;
            }
          } else {
            // alert('one');
            // MyService.ConsoleLog('compare them', $scope.importance + '   ' + val);
            if ($scope.importance == val) {
              $scope.importance = '';
            }
          }
        }
        return false;
      };

      $scope.$watch('currentIndex', function (newValue, oldValue) {
        try {
          MyService.ConsoleLog('Current currentIndex: ', $scope.currentIndex);
          var data = $scope.checkQuestion($scope.questions[$scope.currentIndex]._id);
          console.log("data >> check", data[0]);
          if (data && data[0]) {
            $scope.updata.comment = data[0].comment;
            $scope.answer = data[0].answer;
            $scope.importance = data[0].importance;
            $("#agreedisagree-id" + $scope.answer).prop('checked', true);
            $("#importance-id" + $scope.importance).prop('checked', true);
          }
        } catch (e) {
          //MyService.ConsoleLog("Current Index Change Ex: ", e)
        }
      });

      $scope.cachedQuestions = [];
      $scope.flagSkipAnsweredQuestion = false;
      $scope.skipAnswerChagne = function () {
        MyService.ConsoleLog('scope.flagSkipAnsweredQuestion: ', $scope.flagSkipAnsweredQuestion);
        MyService.ConsoleLog('$scope.questi', $scope.questions);
        // if (window.localStorage.getItem('orgQuizData')) {
        //   $scope.temp = JSON.parse(window.localStorage.getItem('orgQuizData'));
        // } else {
        $scope.temp = $scope.questions;
        // }


        $scope.currentIndex = 0;
        var questions = $scope.checkQuestionAnswered();
        $scope.dis = false;
        MyService.ConsoleLog('questions > ', questions);
        if (questions && questions.length > 0) {
          // alert('insise');
          if ($scope.flagSkipAnsweredQuestion) {
            $scope.cachedQuestions.length = 0;
            $scope.cachedQuestions = angular.copy($scope.questions);
            for (var i = 0; i < questions.length; i++) {
              var idx = $scope.questions.indexOf(questions[i]);
              if (idx > -1) {
                $scope.questions.splice(idx, 1);
              }
            }
            // console.log("questionslength > ", $scope.questions);
            if ($scope.questions[$scope.currentIndex] && $scope.questions[$scope.currentIndex].categories.length > 0) {
              var paObj = {};

              paObj.id = $scope.questions[$scope.currentIndex].categories[0].cid;
              MyService.ConsoleLog("categoryId", paObj.id);
              setTimeout(function () {
                $scope.getCategory(paObj);
              }, 100);
            }
            MyService.ConsoleLog('$scope.cachedQuestions :', $scope.cachedQuestions);
            if ($scope.cachedQuestions.length == questions.length) {
              console.log("questionslength Equal", $rootScope.fiveMatch.length);
              if ($rootScope.fiveMatch.length == 0) {
                $rootScope.fiveMatch = angular.copy($scope.cachedQuestions);
                // MyService.ConsoleLog(' $rootScope.fiveMatch one :', $rootScope.fiveMatch);
                var lents = $rootScope.fiveMatch.length;
                // MyService.ConsoleLog(
                //   'Len >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>',
                //   lents
                // );

                $scope.questions = angular.copy($scope.cachedQuestions);
              }
              // else {
              //   $scope.questions = $rootScope.fiveMatch;
              // }
              // alert('two');

              // $scope.saveFiveMinAnswers('skip');
            } else {
              // alert("esle");
              $scope.updata.comment = '';
              $rootScope.fiveMatch = angular.copy(questions);
              var lent = $rootScope.fiveMatch.length;
              MyService.ConsoleLog('lent @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@', lent);
              // MyService.ConsoleLog("questions", questions);

              if (lent >= 5) {
                // $scope.skipToRes = true;
                $('#skipMatch').attr('disabled', false);
              }
              // alert('three');
              // $scope.saveFiveMinAnswers('skipNew');
            }
          } else {
            $scope.questions = angular.copy($scope.cachedQuestions);
          }
        } else {
          if (!$scope.flagSkipAnsweredQuestion) {
            MyService.ConsoleLog('INside');
            $scope.questions = angular.copy($scope.cachedQuestions);
            if ($scope.questions[$scope.currentIndex]) {
              MyService.ConsoleLog('ONe MORE');
              console.log($scope.questions[$scope.currentIndex]._id);
              var paObj = {};

              paObj.id = $scope.questions[$scope.currentIndex].categories[0].cid;
              // MyService.ConsoleLog("categoryId", paObj.id);
              $scope.getCategory(paObj);
              var data = $scope.checkQuestion($scope.questions[$scope.currentIndex]._id);
              console.log("data >> ", data);
              if (data && data[0]) {
                $scope.updata.comment = data[0].comment;
                $scope.answer = data[0].answer; // Added
                $scope.importance = data[0].importance; // Added

              }
            } else {
              // $scope.flagSkipAnsweredQuestion = false;
              // alert("inside");
              MyService.ConsoleLog('$scope.temp', $scope.temp);
              $scope.questions = $scope.temp;
            }
          }
        }
      };

      // $scope.commenta=function()
      $scope.checkQuestions = function (rdata, val) {
        MyService.ConsoleLog('rdata :', rdata);
        return rdata.filter(function (rdata) {
          // MyService.ConsoleLog(rdata.question + "==" + val);
          if (rdata.questionId == val) return rdata;
        });
      };

      $scope.saveAnswersOneByOne = function (params) {
        MyService.ConsoleLog('post params >>>>>:', params);

        if (params && params != '') {
          MyService.postAnswer(params).then(
            function (response) {
              document.getElementById('txtReason').value = '';

              if (response.data.success) {
                try {
                  if (params.id) {
                    $scope.questions[$scope.currentIndex]['my_answer'] = {
                      _id: postData.id,
                      created: new Date(),
                      comment: params.comment,
                      questionId: params.questionId,
                      answer: params.answer,
                      importance: params.importance,
                    };
                  } else {
                    $scope.questions[$scope.currentIndex]['my_answer'] = {
                      _id: response.data.data._id,
                      created: response.data.data.created,
                      questionId: response.data.data.question,
                      comment: response.data.data.comment,
                      answer: response.data.data.answer,
                      importance: response.data.data.importance,
                    };
                  }
                } catch (e) {
                  //MyService.ConsoleLog("Exceptoin: ", e);
                }
                if (response.data.data.question) {
                  $scope.AllAnsweredQuestions.push(response.data.data);
                }

                if (params.id) {
                  growl.success('Answer updated successfully', {
                    ttl: 5000,
                  });
                } else {
                  growl.success('Answered successfully', {
                    ttl: 5000,
                  });
                }
                $scope.currentIndex = $scope.currentIndex + 1;
                var paObj = {};
                if ($scope.questions[$scope.currentIndex] && $scope.questions[$scope.currentIndex].categories.length > 0) {
                  paObj.id = $scope.questions[$scope.currentIndex].categories[0].cid;
                  MyService.ConsoleLog("categoryId", paObj.id);
                  $scope.getCategory(paObj);
                }

                // MyService.ConsoleLog(window.localStorage.getItem("fiveMatch"));
                $scope.newQuestion();
              } else {
                growl.error('Error: ' + response.data.error);
              }
            },
            function (err) {
              // growl.error("Something went wrong.");
            }
          );
        }
      };

      $scope.postAnswer = function (postData, val) {
        MyService.ConsoleLog('postData: ', postData);
        // MyService.ConsoleLog("Index <><><", $rootScope.fiveMatch.indexOf(postData));
        var ndata = $scope.checkQuestion(postData.questionId);
        MyService.ConsoleLog('ndata >', ndata);
        // MyService.ConsoleLog($rootScope.fiveMatch);

        if (ndata.length > 0) {
          var vdx = $scope.AllAnsweredQuestions.indexOf(ndata[0]);
          if (vdx > -1) {
            // console.log("VDX > ", vdx);
            $scope.AllAnsweredQuestions[vdx]['answer'] = postData.answer;
            $scope.AllAnsweredQuestions[vdx]['importance'] = postData.importance;
            $scope.AllAnsweredQuestions[vdx]['comment'] = postData.comment;
            // console.log("AS : ", $scope.AllAnsweredQuestions[vdx]);
          }
        }

        $scope.questions[$scope.currentIndex]['my_answer'] = {
          _id: postData._id,
          created: new Date(),
          id: postData.id,
          reason: postData.reason,
          comment: postData.comment,
          answer: postData.answer,
          importance: postData.importance,
        };

        var chkData = $scope.checkQuestions($rootScope.fiveMatch, postData.questionId);
        MyService.ConsoleLog('chkData<><><>', chkData);
        $scope.dis = false;

        postData.categories = $scope.questions[$scope.currentIndex]['categories'];
        postData.content = $scope.questions[$scope.currentIndex]['content'];
        postData._id = $scope.questions[$scope.currentIndex]['_id'];

        if (chkData && chkData.length == 0) {
          // alert("one");
          // MyService.ConsoleLog("postData1if<><><",postData);
          $rootScope.fiveMatch.push(postData);
          // MyService.ConsoleLog("Final Five match <><><><><> ", $rootScope.fiveMatch);
          window.localStorage.setItem('fiveMatch', JSON.stringify($rootScope.fiveMatch));
          if (val == 'submit' && val != 'skip') {
            if ($scope.UserId && $scope.UserId != '') {
              if (postData.questionId && postData.questionId != '') {

                $scope.saveAnswersOneByOne(postData);
                postData = '';
              }
            } else {
              $scope.currentIndex = $scope.currentIndex + 1;
              MyService.ConsoleLog('Else >> ', window.localStorage.getItem('fiveMatch'));
              $scope.importance = angular.copy('');
              growl.success('Answered successfully', {
                ttl: 1000,
              });
              $scope.newQuestion();
            }
          }

          var fiveLen = $rootScope.fiveMatch.length;

          MyService.ConsoleLog('FiveMatch:  $scope.currentIndex ::: ', $scope.currentIndex);
          $scope.importance = angular.copy('');
          if (fiveLen >= 5) {
            // $scope.skipToRes = true;
            $('#skipMatch').attr('disabled', false);
          }
        } else {
          // alert("two");
          var idx = $rootScope.fiveMatch.indexOf(chkData[0]);

          $rootScope.fiveMatch[idx] = postData;
          $scope.importance = angular.copy('');
          window.localStorage.setItem('fiveMatch', JSON.stringify($rootScope.fiveMatch));
          if (val == 'submit' && val != 'skip') {
            if ($scope.UserId && $scope.UserId != '') {
              if (
                (postData.reason && postData.reason != '') ||
                (postData.id && postData.id != '')
              ) {
                $scope.saveAnswersOneByOne(postData);
                postData = '';
              }
            } else {
              $scope.currentIndex = $scope.currentIndex + 1;
              $scope.importance = angular.copy('');
              MyService.ConsoleLog(
                'currentIndex <><><> ',
                window.localStorage.getItem('fiveMatch')
              );
              $scope.newQuestion();
            }
          }
        }
      };

      $scope.submitAnswer = function () {
        MyService.ConsoleLog('$scope.comment <>>>>', $scope.updata);
        MyService.ConsoleLog('$scope.answer', $scope.answer);

        var answerId = '';
        var answerReason = '';
        var data = $scope.checkQuestion($scope.questions[$scope.currentIndex]._id);
        if (data && data[0]) {
          if (data[0] && data[0]._id) {
            answerId = data[0]._id;
          }
          if (data[0] && data[0]._id) {
            if ($scope.updata && $scope.updata.reason) {
              answerReason = $scope.updata.reason;
            }
            if ($scope.answer == null || $scope.answer == '') {
              $scope.answer = data[0].answer;
            }
            if ($scope.importance == null || $scope.importance == '') {
              $scope.importance = data[0].importance;
            }
          }
        }
        if ($scope.answer == null || $scope.answer == '') {
          var message = 'Please select answer first.';
          var modal = ngDialog.openConfirm({
            template: '<p>' +
              message +
              '</p>\
                         <div class="ngdialog-buttons">\
                             <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                         </div>',
            plain: true,
          });
          modal.then(
            function fullfilled(data) {
              MyService.ConsoleLog('fullfilled: ', data);
            },
            function rejected(data) {
              MyService.ConsoleLog('rejected: ', data);
            }
          );
          $('html, body').animate({
              scrollTop: 0,
            },
            'slow'
          );
          return;
        }
        //MyService.ConsoleLog("**** ", $scope.importance);
        if ($scope.importance == null || $scope.importance == '') {
          var message =
            'You need to choose an importance level.  Should they fight hard for this can they use it to trade for other things you care about more?';
          var modal = ngDialog.openConfirm({
            template: '<p>' +
              message +
              '</p>\
                         <div class="ngdialog-buttons">\
                             <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                         </div>',
            plain: true,
          });
          modal.then(
            function fullfilled(data) {
              //MyService.ConsoleLog("fullfilled: ", data);
            },
            function rejected(data) {
              //MyService.ConsoleLog("rejected: ", data);
            }
          );
          $('html, body').animate({
              scrollTop: 0,
            },
            'slow'
          );
          return;
        }
        var qid;
        MyService.ConsoleLog('$scope', $scope.UserId);
        if ($scope.UserId && $scope.UserId) {
          qid = $scope.questions[$scope.currentIndex]._id;
        } else {
          qid = $scope.questions[$scope.currentIndex].queId;
        }
        var postData = {
          questionId: qid,
          importance: $scope.importance,
          answer: $scope.answer,
          comment: $scope.updata.comment,
        };

        if (answerId != '') {
          postData.id = answerId;
          MyService.ConsoleLog('answerId :', answerId);
          postData.reason = answerReason;
        }
        $('html, body').animate({
            scrollTop: $('#DisplayQ1').offset().top - 80,
          },
          'slow'
        );
        // console.log("postData > ", postData);
        $scope.postAnswer(postData, 'submit');
      };

      $rootScope.$on('question.answered', function (evt, data) {
        MyService.ConsoleLog('on question.answered: ', data);
        if ($scope.questions[$scope.currentIndex]._id == data.questionId) {
          $scope.initializeVariables();
          $scope.skipQuestion();
        }
      });

      /**
       * get Org Information
       */

      $scope.getOrgInfo = function () {
        MyService.getPress($scope.orgId).then(
          function (response) {
            MyService.ConsoleLog('Response', response);
            $scope.orgInfo = response.orgdata;
            $scope.orgUser = response.userData;
            $scope.getFollowersList();
          },
          function (err) {
            MyService.ConsoleLog('Error', err);
          }
        );
      };

      /**
       * get  followers count and get quizzes count
       */
      $scope.getFollowersList = function () {
        MyService.getFollowersList({
          orgId: $scope.orgId
        }).then(
          function (response) {
            MyService.ConsoleLog('response', response.data);
            $scope.followersCnt = response.data.followersCount;
            $rootScope.followersData = response.data.followersData;
            window.localStorage.setItem('followData', JSON.stringify(response.data.followersData));
            $scope.questionsCnt = response.data.quizzesCount;
            $rootScope.quizzesData = response.data.quizzesData;
            $scope.quizQuesHasAns = response.data.quesHasAnsCount;
          },
          function (err) {
            MyService.ConsoleLog('error', err);
          }
        );
      };

      // Quick link for show match

      $scope.skipToMatch = function () {
        if ($scope.UserId && $scope.UserId != '') {
          // alert("if");
          MyService.ConsoleLog('welcome to quick link :', $rootScope.fiveMatch);
          $location.path('/orgQuizComparison/skip_to_result');
          // window.localStorage.setItem("fiveMatch", JSON.stringify($rootScope.fiveMatch));
          // $scope.saveFiveMinAnswers("RedirectNew");
        } else {
          // alert("else");
          $scope.showZipCode = true;
        }
        // $rootScope.fiveMatch.length=0;
      };

      $scope.getOrgQuiz = function () {
        // MyService.ConsoleLog("  $rootScope.fiveMatch :>", $rootScope.fiveMatch);
        $scope.showloader = true;
        var sobj = {};

        if ($scope.orgId && $scope.orgId != '') {
          MyService.ConsoleLog('<<<<< If >>', $scope.qName);
          sobj.quizName = $scope.qName;
          sobj.orgId = $scope.orgId;
          $cookies.put('advId', $scope.orgId);
        } else {
          MyService.ConsoleLog('<<<<<<<<< Else >>>>>>>>>');
          $scope.orgId = $cookies.get('advId');
          $scope.qName = $cookies.get('quizName') ? $cookies.get('quizName') : $routeParams.quizName;
          // $scope.qName = ;
          MyService.ConsoleLog(" $scope.orgId", $scope.orgId);
          MyService.ConsoleLog("test", JSON.parse(window.localStorage.getItem('queIds')));
          if (window.localStorage.getItem('queIds')) {

            sobj.queIds = JSON.parse(window.localStorage.getItem('queIds'));
            sobj.orgId = $scope.orgId;
          } else {
            sobj.queIds = JSON.parse(window.localStorage.getItem('pQueIds'));
          }

        }
        MyService.ConsoleLog("sobj", sobj);
        MyService.getOrgQuizQuestions(sobj).then(
          function (payload) {
            MyService.ConsoleLog('getMatchQUestions', payload);
            if (payload.data.success && payload.data.success != '') {
              $scope.questions = payload.data.data;

              $scope.questions.sort(function (a, b) {
                var x, y;
                x = a.qOrder;
                y = b.qOrder;
                if (x < y) {
                  return -1;
                }
                if (x > y) {
                  return 1;
                }
                return 0;
              });
              $scope.queLen = $scope.questions.length;
              window.localStorage.setItem('orgQuizData', JSON.stringify($scope.questions));
              MyService.ConsoleLog('This is length ::', $scope.queLen);

              $scope.flagSkipAnsweredQuestion = true;
              $scope.showloader = false;
              if ($scope.orgId && $scope.orgId != '') {
                $scope.getOrgInfo();
              }

              if (!$scope.questions[$scope.currentIndex].my_answer) {
                // alert('one');
                $cookies.put('showBanner', true);
              } else {
                $cookies.remove('showBanner');
              }

              if ($scope.questions[$scope.currentIndex] && $scope.questions[$scope.currentIndex].categories.length > 0) {
                // alert('iss');
                MyService.ConsoleLog("$scope.questions[$scope.currentIndex]", $scope.currentIndex);
                var paObj = {};

                paObj.id = $scope.questions[$scope.currentIndex].categories[0].cid;
                $scope.getCategory(paObj);
              }

              var ansCheck = $scope.checkQuestionAnswered();
              MyService.ConsoleLog("ceck le", ansCheck.length + "==========" + $scope.questions.length)
              if (ansCheck.length == $scope.questions.length) {
                $rootScope.fiveMatch = angular.copy($scope.questions);
                window.localStorage.setItem('fiveMatch', JSON.stringify($scope.questions));
                var param = JSON.stringify({
                  cur_userId: $scope.UserId,
                  questions: JSON.stringify($scope.questions)
                });
                MyService.ConsoleLog("params", param);

                window.localStorage.setItem('comData', param);
                $scope.skipToMatchNew = true;
                $scope.skipToFinal = true;
              }
              // $scope.digDeeper();
              $scope.skipAnswerChagne();

            } else {

              alert('Something went wrong. Please try after some time');
              $location.path('/welcome');
            }
          },
          function (errpayload) {
            alert('Something went wrong. Please try after some time');
            $location.path('/welcome');
          }
        );
      };

      $scope.skipQuestion = function () {
        MyService.ConsoleLog('* skipQuestion *');
        var skip = function () {
          // MyService.ConsoleLog("skip");
          var paObj = {};


          var data = $scope.checkQuestion($scope.questions[$scope.currentIndex]._id);
          if (data && data[0]) {
            MyService.ConsoleLog('getMatchQUestions >>> ', data[0]);
            if (data[0].answer != '') {
              $scope.answer = data[0].answer;
            }
            if (data[0].importance != '') {
              $scope.importance = data[0].importance;
            }
            if (data[0].comment != '') {
              $scope.updata.comment = data[0].comment;
            }
          }
          // $scope.dis=false;
          // console.log("answer : ", $scope.answer);
          if ($scope.answer && $scope.answer != '') {
            var postData = {
              questionId: $scope.questions[$scope.currentIndex]._id,
              importance: $scope.importance,
              answer: $scope.answer,
              comment: $scope.updata.comment,
            };
            // console.log("postData >> ", postData);
            $scope.postAnswer(postData, 'skip');
          }

          if (prevFetchedCategoryId == paObj.id) {

            $("html, body").animate({
              scrollTop: $("#DisplayQ1").offset().top - 100
            }, "slow");
          }

          // console.log($("#DisplayQ1").offset());
          // $('html, body').animate({
          //     scrollTop: $('#DisplayQ1').offset().top - 120,
          //   },
          //   'slow'
          // );
          // $timeout(function () {
          //   $location.hash('DisplayQ');
          //   $anchorScroll();
          // }, 1500);

          var tempIndex = $scope.currentIndex + 1;
          if (tempIndex < $scope.questions.length) {
            $scope.initializeVariables();
            $scope.currentIndex++;
            paObj.id = $scope.questions[$scope.currentIndex].categories[0].cid;
            MyService.ConsoleLog("categoryId", paObj.id);
            $scope.getCategory(paObj);
          } else {
            MyService.ConsoleLog('final question : ' + $scope.questions.length);
            $scope.fiveMinuteMatchDone();
          }
          /*
          $timeout(function() {
            $location.hash('DisplayQ');
            $anchorScroll();
          }, 100);
          */
        };

        MyService.ConsoleLog('skip answer<><><><<>', $scope.answer);
        if ($scope.answer != null) {
          var show_answer_modal = true;
          try {
            var my_answer = $scope.questions[$scope.currentIndex]['my_answer'];

            /*for (var key in my_answer) {
              if(my_answer[])
            }*/
            if (
              my_answer.importance == $scope.importance &&
              my_answer.answer == $scope.answer &&
              my_answer.comment == $scope.updata.comment
            )
              show_answer_modal = false;
          } catch (e) {
            //MyService.ConsoleLog("Exceptoin : ", e);
          }
          // MyService.ConsoleLog("show_answer_modal: ", show_answer_modal);
          if (show_answer_modal) {
            var message =
              'You just hit the SKIP button.  Are you sure you want to skip this one, or would you rather Submit your answer?';
            var modal = ngDialog.openConfirm({
              template: '<p>' +
                message +
                '</p>\
                <div class="ngdialog-buttons">\
                    <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Skip</button>\
                    <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Submit</button>\
                </div>',
              plain: true,
              closeByDocument: false,
            });

            modal.then(
              function fullfilled(data) {
                //submit answer
                $scope.submitAnswer();
              },
              function rejected(data) {
                //skip the answer
                skip();
              }
            );
          } else {
            skip();
          }
        } else {
          skip();
        }
      };

      //  prevQuestions
      $scope.prevQuestion = function () {
        MyService.ConsoleLog('** prevQuestion **');

        if ($scope.currentIndex > 0) {
          // alert($scope.currentIndex);
          $('html, body').animate({
              scrollTop: $('#DisplayQ1').offset().top - 100,
            },
            'slow'
          );
          $scope.currentIndex--;
          var paObj = {};

          paObj.id = $scope.questions[$scope.currentIndex].categories[0].cid;
          MyService.ConsoleLog("categoryId", paObj.id);
          $scope.getCategory(paObj);
          // console.log("Current <><>,", $scope.currentIndex);
          $scope.updata.comment = '';
          // console.log("C digDeeper : ",$scope.digDeeperMatch);
          if ($scope.digDeeperMatch != true) {
            // console.log("digDeeper");
            // console.log(window.localStorage.getItem("fiveMatch"));
            if (window.localStorage.getItem('fiveMatch')) {
              MyService.ConsoleLog('here', JSON.parse(window.localStorage.getItem('fiveMatch')));
              MyService.ConsoleLog(' $scope.cachedQuestions', $scope.cachedQuestions);
              $scope.getFiveMinData = [];
              $scope.getFiveMinData.length = 0;
              if ($scope.flagSkipAnsweredQuestion) {
                console.log('IF <> ', $scope.flagSkipAnsweredQuestion);
                // if ($scope.cachedQuestions && $scope.cachedQuestions.length > 0) {
                $scope.getFiveMinData = $scope.cachedQuestions;
                // } else {
                //   $scope.getFiveMinData = JSON.parse(window.localStorage.getItem('fiveMatch'));
                // }
              } else {
                console.log('Else ');
                $scope.getFiveMinData = JSON.parse(window.localStorage.getItem('fiveMatch'));
              }

              // MyService.ConsoleLog('Data : ', $scope.getFiveMinData);
              for (var i = 0; i < $scope.getFiveMinData.length; i++) {
                MyService.ConsoleLog('for i : ' + i + ' currentIndex : ' + $scope.currentIndex);

                if (i == $scope.currentIndex) {
                  MyService.ConsoleLog('index matched', $scope.getFiveMinData[i]);
                  MyService.ConsoleLog('index matched', $scope.getFiveMinData[i].importance);

                  $scope.answer = $scope.getFiveMinData[i].answer;
                  $scope.importance = $scope.getFiveMinData[i].importance;

                  $scope.updata.comment = $scope.getFiveMinData[i].comment;
                  // $timeout(function() {
                  //   $scope.$apply();
                  // });
                }
              }
              MyService.ConsoleLog(' $scope.importance', $scope.importance);
            }
          }
        } else if ($scope.currentIndex == 0) {
          if ($scope.currBackgroundIndex > 0) {
            $scope.currBackgroundIndex--;
            $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
          }
        }
      };

      // Zip code
      $scope.oldaddress = {
        state: '',
        county: '',
        countySubdivision: '',
        place: '',
      };

      $scope.address = {
        state: '',
        county: '',
        countySubdivision: '',
        place: '',
      };
      $scope.showZipLoader = false;
      $scope.showAddressDropDown = false;

      $scope.AllAnsweredQuestions = [];
      $scope.getAllAnsweredQuestions = function (userId) {
        MyService.getAllAnsweredQuestions({
          authorId: userId,
          quizName: $scope.qName
        }).then(
          function (payload) {
            // MyService.ConsoleLog("getAllAnsweredQuestions >> ", payload)
            if (payload.data.success) {
              $scope.AllAnsweredQuestions = payload.data.data;
              $scope.getOrgQuiz();
            }
          },
          function (errpayload) {
            MyService.ConsoleLog('getAllAnsweredQuestions errpayload >> ', errpayload);
          }
        );
      };

      $scope.getAllStates = function () {
        if ($scope.counties) {
          $scope.counties.length = 0;
        }
        if ($scope.places) {
          $scope.places.length = 0;
        }

        var request = apiCall.apiCall('GET', '/user/getAllStates', {
          country: '',
        });
        $http(request).then(
          function successCallback(response) {
            MyService.ConsoleLog('Got States: ', response);
            if (response.data.success) {
              $scope.states = response.data.data;
            } else {
              growl.error('Something went wrong.');
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
            growl.error('Something went wrong.');
          }
        );
      };

      if ($scope.UserId && $scope.UserId != '') {
        $scope.getAllAnsweredQuestions($scope.UserId);
      } else {
        $scope.getAllStates();
        $scope.getOrgQuiz();
      }

      $scope.checkState = function (rdata, val) {
        // MyService.ConsoleLog(rdata);
        return rdata.filter(function (rdata) {
          //MyService.ConsoleLog(rdata.statePostalCode + "==" + val);
          if (rdata.statePostalCode == val) return rdata;
        });
      };

      $scope.checkState = function (rdata, val) {
        // MyService.ConsoleLog("State :", rdata);
        // MyService.ConsoleLog("State val :", val);
        var sdata = [];
        var len = rdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = rdata[i];
          var gdata = val.filter(function (obj) {
            if (rsdata.countyFips == obj.COUNTYFP && rsdata.stateFips == obj.STATEFP) {
              // MyService.ConsoleLog(rdata[i]);
              return rdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(rdata[i]) == -1) {
              sdata.push(rdata[i]);
            }
          }

          if (j == len) {
            // MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };

      $scope.checkCounty = function (rdata, val) {
        MyService.ConsoleLog('County :', rdata);
        MyService.ConsoleLog('County val :', val);
        var sdata = [];
        var len = rdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = rdata[i];
          var gdata = val.filter(function (obj) {
            if (rsdata.countyFips == obj.COUNTYFP && rsdata.stateFips == obj.STATEFP) {
              // MyService.ConsoleLog(rdata[i]);
              return rdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(rdata[i]) == -1) {
              sdata.push(rdata[i]);
            }
          }

          if (j == len) {
            // MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };
      $scope.checksubCounty = function (rdata, val) {
        var sdata = [];
        var len = rdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = rdata[i];
          var gdata = val.filter(function (obj) {
            if (rsdata.countySubdivision == obj.NAME) {
              // MyService.ConsoleLog(rdata[i]);
              return rdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(rdata[i]) == -1) {
              sdata.push(rdata[i]);
            }
          }

          if (j == len) {
            // MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };
      $scope.checkPlaces = function (prdata, val) {
        var sdata = [];
        var len = prdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = prdata[i];
          var gdata = val.filter(function (obj) {
            // MyService.ConsoleLog(rsdata.place +"=="+ obj.NAME);
            if (rsdata.place == obj.NAME && !rsdata.countyFips) {
              // MyService.ConsoleLog(rdata[i]);
              return prdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(prdata[i]) == -1) {
              sdata.push(prdata[i]);
            }
          }

          if (j == len) {
            // MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };
      var getCountiesCanceler = $q.defer();

      $scope.allcounties = [];
      $scope.getCounties = function (lbl) {
        // MyService.ConsoleLog("county >", $scope.Location.state);
        // $scope.allcounties.length = 0;
        var statePostalCode = '';
        var state = '';
        if (lbl == 'new') {
          state = JSON.stringify($scope.oldaddress.state);
        } else {
          statePostalCode = $scope.Location.state.statePostalCode;
          state = $scope.Location.state;
        }
        if (!statePostalCode) {
          statePostalCode = $scope.stateFips;
          MyService.ConsoleLog('StatePostal Code in IF', statePostalCode);
        }
        // MyService.ConsoleLog(statePostalCode + "<><><><>>" + state);
        MyService.getAllCounties(statePostalCode, state).then(
          function (payload) {
            // MyService.ConsoleLog("sublocations Locals : ", payload);
            var allcounties = payload;
            if (lbl == 'new') {
              var county = $scope.checkCounty(allcounties, $scope.oldaddress.county);
              $scope.allcounties = county;
              // MyService.ConsoleLog("county<><", county);
              $scope.address.county = county[0];
            }
          },
          function (errorPayload) {
            growl.error('Something went wrong.');
          }
        );
      };
      $scope.MyPlaces = [];
      $scope.getSubCounties = function (lbl) {
        //MyService.ConsoleLog($scope.Location.state);
        //MyService.ConsoleLog($scope.Location.county);
        // var county = $scope.Location.county;

        $scope.MyPlaces.length = 0;
        var county = '';
        var statePostalCode = '';
        $scope.MyPlaces.length = 0;
        var state = '';
        var county = '';
        if (lbl == 'new') {
          state = JSON.stringify($scope.oldaddress.state);
          county = JSON.stringify($scope.oldaddress.county);
        } else {
          statePostalCode = $scope.Location.state.statePostalCode;
          state = $scope.Location.state;
          county = county.county;
        }
        // MyService.ConsoleLog(statePostalCode + "===" + county);
        MyService.getAllSubCountiesLocal(statePostalCode, state, county).then(
          function (payload) {
            // payload = JSON.parse(payload);
            $scope.MyPlaces = payload;
            // MyService.ConsoleLog("PlaCE :", payload);
            // MyService.ConsoleLog(payload.countySubdivision);
            var subcounties = payload.countySubdivision;
            var places = payload.places;
            // MyService.ConsoleLog("PlaCE :", payload);
            if (lbl == 'new') {
              // MyService.ConsoleLog("Places 1 > ",$scope.oldaddress.place);
              var subcounty = $scope.checksubCounty(
                subcounties,
                $scope.oldaddress.countySubdivision
              );
              var places = $scope.checkPlaces(places, $scope.oldaddress.place);
              // MyService.ConsoleLog("subcounty<><><", subcounty);
              // $scope.subcounties = subcounty;
              $scope.places = places;
              // console.log('***********', $scope.places);
              // $scope.Location.countySubdivision = subcounty[0];
              $scope.address.place = places[0];
            }
          },
          function (errorPayload) {
            growl.error('Something went wrong.');
          }
        );
      };

      var getLocalsCanceler = $q.defer();
      $scope.getLocals = function (lbl) {
        // MyService.ConsoleLog($scope.oldaddress);
        var state = {},
          county = {};

        if (lbl == 'cur') {
          state = $scope.User.cur_state;
          county = JSON.parse($scope.User.cur_county);
        } else if (lbl == 'new') {
          state.statePostalCode = $scope.oldaddress.state;
          county.county = $scope.oldaddress.county;
        } else {
          state = JSON.parse($scope.User.sel_state);
          county = JSON.parse($scope.User.sel_county);
        }

        //MyService.ConsoleLog("county : ", county);
        getLocalsCanceler.resolve();

        var request = apiCall.apiCall('GET', '/user/getAllSubCountiesLocal', {
          statePostalCode: state.statePostalCode,
          county: county.county,
          timeout: getLocalsCanceler.promise,
        });
        $http(request).then(
          function successCallback(response) {
            if (response.data.success) {
              if (response.data.data) {
                // MyService.ConsoleLog(response.data.data);
                $scope.places = response.data.data;

                if (lbl == 'new') {
                  var subcounty = $scope.checksubCounty(
                    $scope.places,
                    $scope.oldaddress.countySubdivision
                  );

                  var places = $scope.checkPlaces($scope.places, $scope.oldaddress.place);
                  // MyService.ConsoleLog("subcounty<><><", subcounty[0])
                  $scope.address.countySubdivision = subcounty[0];
                  $scope.address.place = places[0];
                }
              }
            } else {
              growl('Something went wrong.');
            }
          },
          function errorCallBack(response) {
            growl('Something went wrong.');
          }
        );
      };
      $scope.User = {
        ZipCode: '',
      };
      $scope.detectCode = function (event) {
        if (event.keyCode == 9 && event.key == 'Tab') {
          $scope.showAddressDropDowns($scope.User.ZipCode);
        }
        if (event.keyCode == 13 && event.key == 'Enter') {
          $scope.showAddressDropDowns($scope.User.ZipCode);
        }
      };

      $scope.checkLength = function (vdata, val) {
        MyService.ConsoleLog(' vdata :', vdata);
        // MyService.ConsoleLog(" val :",val);

        var data = vdata.map(function (sub) {
          var returnval = '';
          switch (val) {
            case 'federalCongrassionalDist':
              returnval = sub.CD115FP;
              break;
            case 'stateSenateDistrict':
              returnval = sub.SLDUST;
              break;
            case 'stateHouseOFRepresentativeDistrict':
              returnval = sub.NAMELSAD;
              break;
            case 'unifiedSchoolDistrictName':
              returnval = sub.NAME;
              break;
            case 'default':
              returnval = sub.NAME;
              break;
          }
          return returnval;
        });

        var ndata = $filter('unique')(data);
        if (ndata.length > 1) {
          return 'yellowBackground';
        } else {
          return '';
        }
      };

      // for autocomplete address

      var options = {
        componentRestrictions: {
          country: 'us',
        },
        types: ['geocode'],
      };

      $scope.detectAddress = function (ent) {
        var val = document.getElementById('address');
        // console.log($scope.User.Address);
        var autocomplete = new google.maps.places.Autocomplete(val, options);

        google.maps.event.addListener(autocomplete, 'place_changed', function () {
          var place = autocomplete.getPlace();

          var lat = place.geometry.location.lat(),
            lng = place.geometry.location.lng();

          $scope.lati = lat.toFixed(6);
          $scope.lon = lng.toFixed(6);
          // console.log($scope.lati);
          // console.log($scope.lon);

          $scope.mailing_Address = place.formatted_address;
          // MyService.ConsoleLog("Main addd :", place.address_components);
          for (var i = 0; i < place.address_components.length; i++) {
            for (var j = 0; j < place.address_components[i].types.length; j++) {
              if (place.address_components[i].types[j] == 'administrative_area_level_1') {
                $scope.statePostalCode = place.address_components[i].short_name;
                // console.log($scope.statePostalCode);
              }
              if (place.address_components[i].types[j] == 'country') {
                $scope.countryname = place.address_components[i].long_name;
                // console.log($scope.countryname);
              }
              if (place.address_components[i].types[j] == 'administrative_area_level_2') {
                $scope.county_name = place.address_components[i].long_name;
                // console.log($scope.county_name);
              }
              if (place.address_components[i].types[j] == 'locality') {
                $scope.place_name = place.address_components[i].long_name;
                // console.log($scope.place_name);
              }
              if (place.address_components[i].types[j] == 'postal_code') {
                // document.getElementById('zip').value = place.address_components[i].long_name;
                if (
                  place.address_components[i].long_name &&
                  place.address_components[i].long_name != ''
                ) {
                  $scope.User.ZipCode = place.address_components[i].long_name;
                  // console.log($scope.User.ZipCode);
                }
                // console.log($scope.User.ZipCode);
              }
            }
          }

          console.log('$scope.User.ZipCode :', $scope.User.ZipCode);

          var loc = JSON.stringify({
            longitude: $scope.lon,
            latitude: $scope.lati,
          });
          // console.log(loc);
          // $rootScope.location = new Array;
          $rootScope.location = {
            longitude: $scope.lon,
            latitude: $scope.lati,
          };
          $scope.showAddressDropDowns('', loc);
        });
      };

      // End for autocomplete address

      $scope.mainAddress = '';

      $scope.showAddressDropDowns = function (zipcode, loc) {
        if (loc && loc != '') {
          MyService.ConsoleLog('showAddressDropDowns' + zipcode);
          MyService.ConsoleLog('MyLocation : >>>.' + loc);

          $scope.showZipLoader = true;
          MyService.getOrganizedZipData({
            candidate: true,
            loc: loc,
          }).then(
            function (payload) {
              MyService.ConsoleLog(' showAddressDropDowns ', payload);
              if (payload && payload != '') {
                // var finalData = payload.data;
                // MyService.ConsoleLog(payload[0].countySubdivision);
                // MyService.ConsoleLog(payload[0].county);
                // MyService.ConsoleLog(payload[0].place);
                var countySubdivisions = payload.places.filter(function (obj) {
                  if (obj.COUSUBFP && obj.COUSUBFP != '') {
                    // MyService.ConsoleLog("Inside cs");
                    return obj;
                  }
                });
                var places = payload.places.filter(function (obj) {
                  if (obj.PLACEFP && obj.PLACEFP != '') {
                    // MyService.ConsoleLog("obj > ", obj);
                    return obj;
                  }
                });
                MyService.ConsoleLog(' showAddressDropDowns <><><><><><><><><><><><><> ');

                $scope.mainAddress = payload;
                $scope.showZipLoader = false;
                $scope.showAddressDropDown = true;
                $scope.oldaddress.state = payload.state;
                $scope.oldaddress.county = payload.county;
                $scope.stateFips = payload.state[0].STATEFP;
                MyService.ConsoleLog('ALLLLLLLLLLL', $scope.stateFips);
                // MyService.ConsoleLog("countySubdivisions >> ", countySubdivisions);
                $scope.oldaddress.countySubdivision = countySubdivisions;
                // MyService.ConsoleLog("places >>> ",places);
                $scope.countyName = payload.county;
                $scope.placeName = payload.places;
                MyService.ConsoleLog('$scope.placename', $scope.placeName);
                MyService.ConsoleLog('$scope.countyName', $scope.countyName);
                $scope.oldaddress.place = places;
                $scope.getCounties('new');

                $scope.getSubCounties('new');

                // $scope.voterDistricts = payload;
                // MyService.ConsoleLog(payload.congressionalDistrict);
                $scope.federalCongrassionalDist = payload.congressionalDistrict;
                MyService.ConsoleLog('@@@@@@ drop :', $scope.federalCongrassionalDist);

                $scope.stateSenateDistrict = payload.stateSenateDistrict;
                $scope.stateHouseOFRepresentativeDistricts =
                  payload.stateHouseofRepresentativesDistrict;
                $scope.unifiedSchoolDistrictNames = payload.unifiedSchoolDistrict;
                //$scope.$apply();
                // MyService.ConsoleLog($scope.states);
                // MyService.ConsoleLog(payload[0].statePostalCode);
                var address = $scope.checkState($scope.states, payload.state);
                MyService.ConsoleLog('address : ', address[0]);

                $scope.address.state = address[0];
                // $scope.address.voterDistrict = $scope.voterDistricts[0];
                $scope.address.federalCongrassionalDist = $scope.federalCongrassionalDist[0];
                $scope.address.stateSenateDistrict = $scope.stateSenateDistrict[0];
                $scope.address.stateHouseOFRepresentativeDistrict =
                  $scope.stateHouseOFRepresentativeDistricts[0];
                $scope.address.unifiedSchoolDistrictName = $scope.unifiedSchoolDistrictNames[0];
                // MyService.ConsoleLog("address ; ", address);
                MyService.ConsoleLog(
                  '<><><><><<><><>>>>>>. zip code >>>>>>>>>>>>>>>>>',
                  $scope.User.ZipCode
                );
                $timeout(function () {
                  $rootScope.tempUserZip = $scope.User.ZipCode;
                  $rootScope.tempUserAddress = $scope.address;
                  MyService.ConsoleLog(
                    ' temp : >>>>>>>>>>>>>>>>>>>>>>>>>>>',
                    $rootScope.tempUserAddress
                  );
                  window.localStorage.setItem('tempUserZip', $rootScope.tempUserZip);
                  window.localStorage.setItem(
                    'tempUserAddress',
                    JSON.stringify($rootScope.tempUserAddress)
                  );
                  // MyService.ConsoleLog("address : ", address);
                  // MyService.ConsoleLog("rootscope address : ", $rootScope.tempUserAddress);
                }, 100);
              }
            },
            function (errorPayload) {
              $scope.showZipLoader = false;
              growl.error(errorPayload);
            }
          );
        }
      };

      $scope.saveUserAnswers = function () {
        console.log('address>>>', $scope.address);
        $rootScope.tempUserAddress = $scope.address;
        MyService.ConsoleLog(' temp : >>>>>>>>>>>>>>>>>>>>>>>>>>>', $rootScope.tempUserAddress);
        window.localStorage.setItem('tempUserZip', $rootScope.tempUserZip);
        window.localStorage.setItem('tempUserAddress', JSON.stringify($rootScope.tempUserAddress));
        $location.path('/fiveSaveUser');
      };

      $scope.eraseUserAnswers = function () {
        MyService.ConsoleLog('eraseUserAnswers');
        MyService.ConsoleLog(window.localStorage.getItem('fiveMatch'));
        $location.path('/orgQuizComparison');
      };

      $scope.showDigDeeperLoader = false;

      $scope.goBack = function () {
        $scope.initializeVariables();
        $scope.questions = angular.copy($scope.oldQuestions);
        $scope.currentIndex = angular.copy($scope.oldIndex);
        $scope.oldQuestions.length = 0;
        $scope.oldIndex = 0;
      };

      var getCategoryCanceler = $q.defer();
      $scope.digDeeper = function () {
        MyService.ConsoleLog("$scope.questions[$scope.currentIndex]", $scope.questions[$scope.currentIndex]);

        if ($scope.questions[$scope.currentIndex] && $scope.questions[$scope.currentIndex].categories.length > 0) {
          var catID = $scope.questions[$scope.currentIndex].categories[0].cid;

        } else {
          MyService.ConsoleLog("$scope.questions[$scope.currentIndex]", $scope.questions);
          // var catID = $scope.questions[$scope.currentIndex].categories[0].cid;

        }
        //  MyService.ConsoleLog("catID<><>",catID);
        // MyService.ConsoleLog($scope.questions);
        // MyService.ConsoleLog("catNewID<><><>",$scope.questions[$scope.currentIndex].categories[0].cid);
        $scope.showDigDeeperLoader = true;

        //MyService.ConsoleLog("scrollTop");
        $('html, body').animate({
            scrollTop: 0,
          },
          'slow'
        );
        getCategoryCanceler.resolve();
        getCategoryCanceler = $q.defer();

        var request = apiCall.apiCall('GET', '/categories/list', {
          id: catID,
        });
        request.timeout = getCategoryCanceler.promise;
        $http(request).then(
          function successCallback(response) {
            //MyService.ConsoleLog("Got categories: ",response);
            if (response.data.success) {
              $scope.category = response.data.data;
              MyService.ConsoleLog('category data: ', $scope.category);
              MyService.digDeepperQuestions({
                catId: catID,
              }).then(
                function (payload) {
                  $scope.showDigDeeperLoader = false;
                  if (payload.data.success) {
                    $scope.oldQuestions = angular.copy($scope.questions);
                    $scope.oldIndex = angular.copy($scope.currentIndex);
                    $scope.questions = payload.data.data;
                    $scope.currentIndex = 0;
                    $scope.digDeeperMatch = true;
                    MyService.ConsoleLog($scope.questions);
                  } else {
                    MyService.ConsoleLog("payload one", payload);
                    alert('Something went wrong. Please try after some time');
                    // $location.path("/welcome");
                  }
                  // MyService.ConsoleLog(payload);
                },
                function (errorPayload) {
                  $scope.showDigDeeperLoader = false;
                  // MyService.ConsoleLog(errorPayload);
                }
              );
            } else {
              //MyService.ConsoleLog("Something went wrong: ", response.data);
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
            $scope.status.category = 3;
          }
        );
      };
      var prevFetchedCategoryId = null;
      $scope.categoryCalled = false;
      $scope.status = {
        questions: 0, //1= loading, 2 = loaded, 3 = error
        category: 0
      };
      $scope.getCategory = function (params) {
        MyService.ConsoleLog("scrollTop pre :", prevFetchedCategoryId);
        MyService.ConsoleLog("scrollTop Two :", params.id);


        if (prevFetchedCategoryId != params.id) {
          MyService.ConsoleLog("scrollTop in");
          $scope.categoryCalled = true;
          $("html, body").animate({
            scrollTop: 0
          }, "slow");
          getCategoryCanceler.resolve();
          $scope.status.category = 1;
          params.timeout = getCategoryCanceler.promise;
          var request = apiCall.apiCall('GET', '/categories/list', params);
          $http(
              request
            )
            .then(function successCallback(response) {
              //MyService.ConsoleLog("Got categories: ",response);
              if (response.data.success) {
                $scope.category = response.data.data;
                MyService.ConsoleLog("category data: ", $scope.category);
                prevFetchedCategoryId = $scope.category._id;
                $scope.status.category = 2;
              } else {
                //MyService.ConsoleLog("Something went wrong: ", response.data);
                $scope.status.category = 3;
              }
            }, function errorCallBack(response) {
              //MyService.ConsoleLog("Error: ", response);
              $scope.status.category = 3;
            });
        } else {

          $("html, body").animate({
            scrollTop: $("#DisplayQ1").offset().top - 80
          }, "slow");
          // $timeout(function() {
          //   MyService.ConsoleLog("called")
          //   $location.hash('DisplayQue');
          //   $anchorScroll();

          // }, 100);

        }
      };

      // Mellisa data start //
      $scope.findaddress = {
        address: '',
        city: '',
        state: '',
        zipcode: '',
      };
      $scope.result = {
        city: '',
      };
      $scope.showFindAddress = function () {
        var q = {
          zipcode: $scope.User.ZipCode,
        };
        var addressModal = ngDialog.open({
          template: 'app/popups/mellisa_data.html',
          scope: $scope,
          data: q,
        });
        $scope.findaddress.zipcode = $scope.User.ZipCode;
      };

      $scope.finddetailsclicked = false;
      $scope.getDetails = function (records) {
        var error = '';
        if ($scope.findaddress.address == '') {
          error = 'Please enter address';
        }
        if (error == '' && $scope.findaddress.city == '') {
          error = 'Please enter city';
        }
        if (error == '' && $scope.findaddress.state == '') {
          error = 'Please enter state';
        }
        if (error == '' && $scope.findaddress.zipcode == '') {
          error = 'Please enter zipcode';
        }

        if (error == '') {
          $scope.finddetailsclicked = true;
          // MyService.ConsoleLog("=============Address==============");
          // MyService.ConsoleLog($scope.findaddress);
          // MyService.ConsoleLog("findaddress<><><>", records);
          var aurl = 'https://personator.melissadata.net/v3/WEB/ContactVerify/doContactVerify';
          aurl += '?id=RyMI8jlzD6dHUApvp_3XRP**';
          aurl += '&cols=GrpCensus,GrpCensus2,GrpGeocode';
          aurl += '&a1=' + records.address;
          aurl += '&city=' + records.city;
          aurl += '&state=' + records.state;
          aurl += '&postal=' + records.zipcode;
          aurl += '&ctry=US';
          aurl += '&format=JSON';
          // var deferred = $q.defer();
          //var furl = "https://personator.melissadata.net/v3/WEB/ContactVerify/doContactVerify?id=RyMI8jlzD6dHUApvp_3XRP**&cols=GrpCensus,GrpCensus2,GrpGeocode&a1=" + records.address + "&city=" + records.city + "&state=" + records.state + "&postal=" + records.zipcode + "&ctry=US&format=JSON";
          // MyService.ConsoleLog("furl <><>>", furl);
          $http.get(aurl).then(
            function successCallback(response) {
              //$scope.result = "";
              $scope.finddetailsclicked = false;
              if (response.statusText == 'OK') {
                var rdata = response.data.Records[0];
                if (rdata) {
                  $scope.result = rdata;
                }
              }
              // MyService.ConsoleLog("response", response);
            },
            function errorCallBack(error) {
              $scope.finddetailsclicked = false;
              // MyService.ConsoleLog(error);
            }
          );
        } else {
          alert(error);
        }
      };
      // $scope.oldAddress = "";
      $scope.checkZipAddress = function (val) {
        // $scope.oldAddress = angular.copy($scope.mainAddress);
        return $scope.mainAddress.filter(function (rdata) {
          // MyService.ConsoleLog("Space:", parseInt(val.CongressionalDistrict));
          if (val.CongressionalDistrict == '' || val.CongressionalDistrict == ' ') {
            // MyService.ConsoleLog("inside<><><><><>");

            if (
              parseInt(rdata.FIPScounty) == parseInt(val.CountyFIPS) &&
              parseInt(rdata.FIPScountySub) == parseInt(val.CountySubdivisionCode) &&
              parseInt(rdata.stateHouseOFRepresentativeDistrict) ==
              parseInt(val.StateDistrictLower) &&
              parseInt(rdata.stateSenateDistrict) == parseInt(val.StateDistrictUpper) &&
              parseInt(rdata.unifiedSchoolDistrict) == parseInt(val.UnifiedSchoolDistrictCode)
            ) {
              // MyService.ConsoleLog("This is a match");
              return rdata;
            }
          } else {
            if (
              parseInt(rdata.FIPScounty) == parseInt(val.CountyFIPS) &&
              parseInt(rdata.FIPScountySub) == parseInt(val.CountySubdivisionCode) &&
              parseInt(rdata.federalCongrassionalDist) == parseInt(val.CongressionalDistrict) &&
              parseInt(rdata.stateHouseOFRepresentativeDistrict) ==
              parseInt(val.StateDistrictLower) &&
              parseInt(rdata.stateSenateDistrict) == parseInt(val.StateDistrictUpper) &&
              parseInt(rdata.unifiedSchoolDistrict) == parseInt(val.UnifiedSchoolDistrictCode)
            ) {
              // MyService.ConsoleLog("This is a match2");
              return rdata;
            }
          }
        });
      };

      $scope.setAddressNew = function () {
        // MyService.ConsoleLog($scope.result);
        var finalResult = $scope.checkZipAddress($scope.result);
        if (finalResult && finalResult.length > 0) {
          MyService.ConsoleLog('finalResult::::', finalResult);
          // $scope.mainAddress = angular.copy(finalResult);
          $scope.voterDistricts = finalResult;
          $scope.federalCongrassionalDist = finalResult;
          $scope.stateSenateDistrict = finalResult;
          $scope.stateHouseOFRepresentativeDistricts = finalResult;
          $scope.unifiedSchoolDistrictNames = finalResult;
          ngDialog.closeAll();
          // $scope.$apply();
        } else {
          alert(
            'Address not matching with our database. Please enter detail address and try again.'
          );
        }
      };

      var previousSelVal = {};
      $scope.setSelectedDropdown = function (listData, setfor, selectedUserAdrs) {
        switch (setfor) {
          case 'counties':
            previousSelVal.county = $scope.address.county;
            //MyService.ConsoleLog("selCountyNumber: ",previousSelVal.county);
            $scope.address.county = null;
            if (listData) {
              $scope.counties = listData;
              $scope.counties.unshift({
                number: null,
                name: 'none',
              });

              // if(!selectedUserAdrs) selectedUserAdrs.countyFips = previousSelVal.county.number;
              var selCountyNumber = null;
              try {
                $scope.address.county = $scope.counties[0];
                if (selectedUserAdrs) {
                  selCountyNumber = selectedUserAdrs.countyFips;
                }
                if (previousSelVal.county) {
                  selCountyNumber = previousSelVal.county.number;
                }

                if (selCountyNumber) {
                  //MyService.ConsoleLog("selCountyNumber: ",selCountyNumber);
                  angular.forEach($scope.counties, function (val, key) {
                    if (selCountyNumber == val.number) $scope.address.county = val;
                  });
                }
              } catch (e) {
                //MyService.ConsoleLog("Exception: ",e);
              }
            }
            break;
          case 'subCounties':
            previousSelVal.subcounty = $scope.address.subcounty;
            $scope.address.subcounty = null;
            if (listData) {
              $scope.subCounties = listData;
              $scope.subCounties.unshift({
                number: null,
                name: 'none',
              });
              var selSubCountyNo = null;
              try {
                $scope.address.subcounty = $scope.subCounties[0];
                if (selectedUserAdrs) {
                  selSubCountyNo = selectedUserAdrs.countySubdivisionFips;
                }
                if (previousSelVal.subcounty) {
                  selSubCountyNo = previousSelVal.subcounty.number;
                }
                if (selSubCountyNo) {
                  angular.forEach($scope.subCounties, function (val, key) {
                    //set selected state
                    // if(selectedUserAdrs.countySubdivisionFips == val.number)
                    if (selSubCountyNo == val.number) $scope.address.subcounty = val;
                  });
                }
              } catch (e) {
                //MyService.ConsoleLog("Exception: ",e);
              }
            }
            break;
          case 'places':
            previousSelVal.place = $scope.address.place;
            $scope.address.place = null;
            if (listData) {
              $scope.places = listData;
              $scope.places.unshift({
                number: null,
                name: 'none',
              });

              try {
                $scope.address.place = $scope.places[0];
                var selPlaceNo = null;
                if (selectedUserAdrs) {
                  selPlaceNo = selectedUserAdrs.placeFips;
                }
                if (previousSelVal.place) {
                  selPlaceNo = previousSelVal.place.number;
                }
                if (selPlaceNo) {
                  angular.forEach($scope.places, function (val, key) {
                    if (selPlaceNo == val.number) $scope.address.place = val;
                  });
                }
              } catch (e) {
                //MyService.ConsoleLog("Exception: ",e);
              }
            }
            break;
          case 'voterDistricts':
            if (listData) {
              previousSelVal.voterDistrict = $scope.address.voterDistrict;
              $scope.address.voterDistrict = null;
              $scope.voterDistricts = listData;
              $scope.voterDistricts.unshift({
                number: null,
                name: 'none',
              });

              var voterDistrictNo = null;
              try {
                $scope.address.voterDistrict = $scope.voterDistricts[0];
                if (selectedUserAdrs) {
                  voterDistrictNo = selectedUserAdrs.voterDistrictFips;
                }
                if (previousSelVal.voterDistrict) {
                  voterDistrictNo = previousSelVal.voterDistrict.number;
                }

                if (voterDistrictNo) {
                  angular.forEach($scope.voterDistricts, function (val, key) {
                    //set selected
                    if (voterDistrictNo == val.number) $scope.address.voterDistrict = val;
                  });
                }
              } catch (e) {
                //MyService.ConsoleLog("Exception: ",e);
              }
            }
            break;
          case 'federalCongrassionalDist':
            $scope.address.federalCongrassionalDist = null;
            if (listData) {
              $scope.federalCongrassionalDist = listData;
              $scope.federalCongrassionalDist.unshift('none');

              if (selectedUserAdrs) {
                $scope.address.federalCongrassionalDist = $scope.federalCongrassionalDist[0];
                angular.forEach($scope.federalCongrassionalDist, function (val, key) {
                  //set selected state
                  if (selectedUserAdrs.federalCongrassionalDist == val)
                    $scope.address.federalCongrassionalDist = val;
                });
              }
            }
            break;
          case 'stateSenateDistrict':
            $scope.address.stateSenateDistrict = null;
            if (listData) {
              $scope.stateSenateDistrict = listData;
              $scope.stateSenateDistrict.unshift('none');

              $scope.address.stateSenateDistrict = $scope.stateSenateDistrict[0];
              if (selectedUserAdrs) {
                angular.forEach($scope.stateSenateDistrict, function (val, key) {
                  //set selected state
                  if (selectedUserAdrs.stateSenateDistrict == val)
                    $scope.address.stateSenateDistrict = val;
                });
              }
            }
            break;
          case 'stateHouseOFRepresentativeDistrict':
            $scope.address.stateLegislativeDistrict = null;
            if (listData) {
              $scope.stateLegislativeDistrict = listData;
              $scope.stateLegislativeDistrict.unshift('none');
              $scope.address.stateLegislativeDistrict = $scope.stateLegislativeDistrict[0];
              if (selectedUserAdrs) {
                angular.forEach($scope.stateLegislativeDistrict, function (val, key) {
                  //set selected state
                  if (selectedUserAdrs.legislativeDistrict == val)
                    $scope.address.stateLegislativeDistrict = val;
                });
              }
            }
            break;
          case 'schoolDistricts':
            $scope.address.schoolDistrict = null;
            if (listData) {
              $scope.schoolDistricts = listData;
              $scope.schoolDistricts.unshift({
                number: null,
                name: 'none',
              });
              $scope.address.schoolDistricts = $scope.schoolDistricts[0];
              if (selectedUserAdrs) {
                angular.forEach($scope.schoolDistricts, function (val, key) {
                  //set selected state
                  if (selectedUserAdrs.schoolDistrictFips == val.number)
                    $scope.address.schoolDistrict = val;
                });
              }
            }
            break;
        }
      };

      $scope.confirmPopup = function () {
        MyService.ConsoleLog('address : ', $scope.address);
        var message =
          'Without your voice, your politician won’t know how to represent you. Before we show you your results, would you like to create a profile so we can save your answers and send them to your politicians anonymously?';
        var modal = ngDialog.openConfirm({
          template: '<p>' +
            message +
            '</p>\
                          <div class="ngdialog-buttons">\
                              <button type="button" class="compareBtn" ng-click="confirm(0)">Create and Save</button>\
                              <button type="button" class="eraseBtn" ng-click="confirm(1)">No. Erase when done</button>\
                          </div>',
          plain: true,
        });

        modal.then(
          function fullfilled(data) {
            MyService.ConsoleLog('fullfilled: ', data);
            if (data == 0) {
              $scope.saveUserAnswers();
            } else {
              $scope.eraseUserAnswers();
            }
          },
          function rejected(data) {
            MyService.ConsoleLog('rejected: ', data);
          }
        );

        return;
      };

      function keyupHandler(keyEvent) {
        MyService.ConsoleLog('key up');
        if (!$scope.showZipCode) {
          event.preventDefault();
          if (event.keyCode === 13) {
            //MyService.ConsoleLog('Current route name: ', $location.path());
            if ($location.path() == '/fiveMatch') {
              $scope.submitAnswer();
            }
          }
        }
      }
      document.addEventListener('keyup', keyupHandler);
      $scope.$on('$destroy', function () {
        MyService.ConsoleLog('event destroyed :');
        $document.unbind('keyup');
      });
    },
  ]);

'use strict';

angular
  .module('myApp.orgActivityDetails', ['ngRoute'])

  .config([
    '$routeProvider',
    function($routeProvider) {
      $routeProvider.when('/orgActivityDetails/:type?/:orgId?', {
        templateUrl: 'app/orgActivityDetails/orgActivityDetails.html',
        controller: 'orgActivityDetailsCtrl',
      });
    },
  ])

  .controller('orgActivityDetailsCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    '$routeParams',
    '$rootScope',
    'baseApiUrl',
    '$q',
    '$timeout',
    'growl',
    'tokenService',
    '$anchorScroll',
    '$sce',
    'MyService',
    'ngDialog',
    function(
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $rootScope,
      baseApiUrl,
      $q,
      $timeout,
      growl,
      tokenService,
      $anchorScroll,
      $sce,
      MyService,
      ngDialog
    ) {
      $scope.isfollowList = $routeParams.type;
      $scope.isfollow = false;
      $scope.isQus = false;
      $scope.orgId = $routeParams.orgId;

      /**
       * get  followers count and get quizzes count
       */
      $scope.getFollowersList = function() {
        MyService.getFollowersList({ orgId: $scope.orgId }).then(
          function(response) {
            MyService.ConsoleLog('response', response.data);
            $scope.isfollow = true;
            $scope.isQus = false;
            $scope.foData = response.data.followersData;
            $scope.questionsCnt = response.data.quizzesCount;
            $scope.quizzesData = response.data.quizzesData;
            $scope.quizQuesHasAns = response.data.quesHasAnsCount;
          },
          function(err) {
            MyService.ConsoleLog('error', err);
          }
        );
      };

      if ($scope.orgId && $scope.orgId != '') {
        $scope.getFollowersList();
      } else {
        if (window.localStorage.getItem('followData')) {
          $scope.isfollow = true;
          $scope.isQus = false;
          $scope.foData = JSON.parse(window.localStorage.getItem('followData'));
          MyService.ConsoleLog('<<<<< data >>>>>>>>', $scope.foData);
        } else if ($scope.isfollowList == 'followers') {
          $scope.isfollow = true;
          $scope.isQus = false;
          $scope.foData = $rootScope.followersData;
          MyService.ConsoleLog('$scope.foData', $scope.foData);
        } else {
          $scope.isQus = true;
          $scope.isfollow = false;
          $scope.quesData = $rootScope.quizzesData;
        }
      }
    },
  ]);

'use strict';
angular
  .module('myApp.openStateBills', ['ngRoute'])

  .config([
    '$routeProvider',
    function($routeProvider) {
      $routeProvider.when('/openStateBills', {
        templateUrl: 'app/openStateBills/openStateBills.html',
        controller: 'openStateBillsCtrl'
      });
    }
  ])
  .controller('openStateBillsCtrl', [
    '$scope',
    'ngDialog',
    '$rootScope',
    'MyService',
    '$http',
    '$timeout',
    '$q',

    function($scope, ngDialog, $rootScope, MyService, $http, $timeout, $q) {
      $scope.loader = false;
      $scope.showDetail = false;
      $scope.more = [];
      $scope.documents = [];
      $scope.activeDoc = true;
      $scope.activeAct = true;

      $scope.activeVot = true;
      $scope.activeSpo = true;

      $scope.getOpenStateBills = function() {
        $scope.loader = true;

        MyService.ConsoleLog('<<<<<<<< Welcome >>>>>>');
        MyService.getBills().then(
          function(data) {
            MyService.ConsoleLog('Data >>>>>>', data);
            $scope.loader = false;
          },
          function(err) {
            console.log('Error >>', err);
          }
        );
      };

      $scope.myPagingFunction = function() {
        MyService.ConsoleLog('scoll called', $scope.statusGetResPg);
        if ($scope.statusGetResPg != 1 && $scope.serachData > $scope.openBills.length) {
          $scope.currPage++;
          $scope.pageChanged($scope.currPage);
        }
      };

      $scope.pageChanged = function(newPage) {
        $scope.getBillsData(newPage);
      };
      $scope.openBills = [];
      $scope.searchCandy = {
        'search': ""
      };

      // $scope.searchMe = function(user) {
      //   // MyService.ConsoleLog('in searchMe', user);
      //   var query = $scope.searchCandy.search.toLowerCase(),
      //     fullname = user.title.toLowerCase();

      //   if (fullname.indexOf(query) != -1) {
      //     return true;
      //   }
      //   return false;
      // };

      $scope.SearchByTitle = function() {
        // MyService.ConsoleLog('in searchMe', $scope.search.sdata);
        // var query = $scope.search.sdata.toUpperCase();
        // $scope.currPage++;

        var pageNumber = 1;
        var params = {
          page: pageNumber,
          max_records: 30,
          title: $scope.searchCandy.search,

        };
        //MyService.ConsoleLog("params: ", params);
        // $scope.users.data = [];

        $scope.statusGetResPg = 1;

        var getAllCanceller = $q.defer();


        MyService.ConsoleLog('in searchMe', $scope.currPage);

        MyService.SearchByTitleOne(params, getAllCanceller).then(
          function(response) {
            MyService.ConsoleLog('response', response);

            $scope.openBills.length = 0;
            $scope.openBills = response.data;
            $scope.serachData = response.count;

            MyService.ConsoleLog('response', $scope.openBills);

          },
          function(error) {
            MyService.ConsoleLog('Error>>', error);
          }
        );
      };

      $scope.getBillsData = function(pageNumber) {
        MyService.ConsoleLog('pageNumber >', pageNumber);
        var params = {
          page: pageNumber,
          max_records: 30
        };
        //MyService.ConsoleLog("params: ", params);
        // $scope.users.data = [];


        $scope.statusGetResPg = 1;

        var getAllCanceller = $q.defer();


        MyService.getOpenBills(params, getAllCanceller).then(
          function(result) {
            console.log("RESPONSE >  ", result);
            $scope.openBills = $scope.openBills.concat(result.data.data.data);
            MyService.ConsoleLog('$scope.open >', $scope.openBills);
            $scope.serachData = result.data.data.count;
            // console.log($scope.committee);
            // $scope.totalUsers = payload.Count;
            // MyService.ConsoleLog(payload.Items);
            $scope.statusGetResPg = 2;
          },
          function(err) {
            growl.error('Something went wrong.');
            $scope.statusGetResPg = 3;
            $scope.page--;
          }
        );
      };

      $scope.getDetails = function(val) {
        MyService.ConsoleLog('params >', val);
        MyService.getBillDetail({ id: val }).then(
          function(response) {
            MyService.ConsoleLog('got data >', response);
            $scope.details = response.data.data;
            $scope.showDetail = true;
          },
          function(err) {
            MyService.ConsoleLog('Error', err);
          }
        );
      };
      $scope.back = function() {
        $scope.showDetail = false;
      };

      $scope.getDetailsOfCandidates = function(val) {
        $scope.more[val] = true;
        $scope.documents[val] = true;


      };
      $scope.showLess = function(valOne) {
        $scope.more[valOne] = false;
        $scope.documents[valOne] = false;

      }

      $scope.getBillsData($scope.currPage);
    }
  ]);

'use strict';
angular
  .module('myApp.openState', ['ngRoute'])

  .config([
    '$routeProvider',
    function($routeProvider) {
      $routeProvider.when('/openState', {
        templateUrl: 'app/openState/openState.html',
        controller: 'openStateCtrl'
      });
    }
  ])
  .controller('openStateCtrl', ['$scope','ngDialog','$rootScope', 'MyService', '$http','$timeout','$q', function($scope, ngDialog, $rootScope, MyService, $http, $timeout, $q) {
      $scope.loader = false;
      $scope.currPage = 1;

      $scope.people = true;
      $scope.selectCandidate = {
        selectCandy: 'user'
      };

      $scope.selDbPresent = {
        present: ''
      };
      $scope.success_msg = false;
      $scope.more = [];
      $scope.search = {
        sdata: ''
      };

      $scope.getOpenState = function() {
        $scope.loader = true;

        console.log('welcome');
        MyService.getOpenStatePeopleData().then(
          function(data) {
            MyService.ConsoleLog('Data >>>>>>', data);
            $scope.loader = false;
          },
          function(err) {
            console.log('Error >>', err);
          }
        );
      };

      $scope.myPagingFunction = function() {
        MyService.ConsoleLog('scoll called', $scope.statusGetResPg);
        if ($scope.statusGetResPg != 1 && $scope.searchCount > $scope.open.length) {
          $scope.currPage++;
          $scope.pageChanged($scope.currPage);
        }
      };

      $scope.pageChanged = function(newPage) {
        $scope.getOpenData(newPage);
      };
      $scope.open = [];

      $scope.SearchByName = function() {
        // MyService.ConsoleLog('in searchMe', $scope.search.sdata);
        // var query = $scope.search.sdata.toUpperCase();

        MyService.ConsoleLog('in searchMe', $scope.search.sdata);

        MyService.SearchByName({ name: $scope.search.sdata }).then(
          function(response) {
            MyService.ConsoleLog('response', response);
            $scope.open=response.data;
            $scope.searchCount=response.count;
          },
          function(error) {
            MyService.ConsoleLog('Error>>', error);
          }
        );
      };

      $scope.getOpenData = function(pageNumber) {
        MyService.ConsoleLog('pageNumber >', pageNumber);
        var params = {
          page: pageNumber,
          max_records: 30
        };
        //MyService.ConsoleLog("params: ", params);
        // $scope.users.data = [];
       

        $scope.statusGetResPg = 1;

        var getAllCanceller = $q.defer();
       

        MyService.getOpenData(params, getAllCanceller).then(
          function(result) {
            console.log("RESPONSE >	",result.data.data);
            $scope.open = $scope.open.concat(result.data.data.data);
            $scope.searchCount=result.data.data.count;
            MyService.ConsoleLog('$scope.open >', $scope.open);
            // console.log($scope.committee);
            // $scope.totalUsers = payload.Count;
            // MyService.ConsoleLog(payload.Items);
            $scope.statusGetResPg = 2;
          },
          function(err) {
            growl.error('Something went wrong.');
            $scope.statusGetResPg = 3;
            $scope.page--;
          }
        );
      };

      $scope.getOpenData($scope.currPage);

      $scope.matchMembers = function(para) {
        MyService.ConsoleLog('parameters >', para);
        $scope.pdata = para;
        $scope.pId = para._id;
        MyService.matchPeople({ name: para.name }).then(
          function(result) {
            MyService.ConsoleLog('Result >', result);
            $scope.matchData = result;
            $scope.people = false;
          },
          function(err) {
            MyService.ConsoleLog('Error >', err);
          }
        );
      };

      $scope.back = function() {
        // console.log("back");
        // $scope.show = false;

        $scope.people = true;
      };

      $scope.showLess = function(id) {
        // console.log("id for less",id);
        $scope.more[id] = false;
      };

      //get Candidates
      $scope.getDetailsOfCandidates = function(id) {
        $scope.more[id] = true;
      };
      $scope.addMatchCandidates = function(uid, type) {
        MyService.ConsoleLog('params >', uid + 'type' + type);
        MyService.ConsoleLog('people Id >', $scope.pId);
        MyService.addMatchedPeople({
          id: uid,
          type: type,
          pId: $scope.pId
        }).then(
          function(response) {
            MyService.ConsoleLog('Response >', response);
            $(document).ready(function() {
              $scope.success_msg = true;
              setTimeout(function() {
                $('.alert').alert('close');
                $scope.getOpenData(1);
              }, 2000);
            });
          },
          function(err) {
            console.log('Error >', err);
          }
        );
      };
    }
  ]);

'use strict';
angular.module('myApp.openFecCommittee', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/openFecCommittees', {
      templateUrl: 'app/openFecCommittees/openFecCommittee.html',
      controller: 'openFECCommittee'
    });
  }])
.controller('openFECCommittee', ['$scope', 'ngDialog', '$rootScope', 'MyService', '$http', '$timeout', '$q', function ($scope, ngDialog, $rootScope, MyService, $http, $timeout, $q) {
    $scope.openFecCandidates = [];
    $scope.showLoader = false;
    $scope.currPage = 1;
    $scope.openCandidateDtls = false;
    $scope.candidiateDtls = [];
    $scope.candidiateCommittees = [];

    /*OpenFec Calls*/
    $scope.myPagingFunction = function () {
      MyService.ConsoleLog("scoll called",$scope.statusGetResPg);
      if ($scope.statusGetResPg != 1) {
        $scope.currPage++;
        $scope.pageChanged($scope.currPage);
      }
    };


    $scope.pageChanged = function (newPage) {

      $scope.getopenFECCommittees(newPage);
    };
    $scope.committee = [];
    $scope.getopenFECCommittees = function (pageNumber) {
      console.log("page number", pageNumber);



      var params = {
        "page": pageNumber,
        max_records: 30
      };
      //MyService.ConsoleLog("params: ", params);
      // $scope.users.data = [];
      $scope.totalUsers = 0;


      $scope.statusGetResPg = 1;

      var getAllCanceller = $q.defer();
      var calc = (pageNumber - 1) * 30;

      MyService.getAllFECCommitteesData(params, getAllCanceller).then(function (payload) {
        // $scope.users.data = payload.Items;
        // console.log(payload);
        $scope.committee = $scope.committee.concat(payload.data.data);
        // console.log($scope.committee);
        // $scope.totalUsers = payload.Count;
        // MyService.ConsoleLog(payload.Items);
        $scope.statusGetResPg = 2;
      }, function (err) {
        //MyService.ConsoleLog(err);
        growl.error("Something went wrong.");
        $scope.statusGetResPg = 3;
        $scope.page--;
      });
      // } else {
      //   //MyService.ConsoleLog("break loop");
      //   $scope.page = 0;
      //   // break;
      //   return false;

      // }


      // if (!$filter("isBlankString")($scope.orgDetailKeyword) || !$filter("isBlankString")($scope.userDetailKeyword) || !$filter("isBlankString")($scope.userDetailFilter)) {
      //   if (!$filter("isBlankString")($scope.orgDetailKeyword)) {
      //     //MyService.ConsoleLog("searching by organization");
      //     $scope.statusGetResPg = 1;

      //     searchOrgByDetailCanceller = $q.defer();
      //     params.keyword = $scope.orgDetailKeyword;
      //     var calc = (pageNumber - 1) * 30;
      //     if ($scope.users.data.length >= calc) {
      //       MyService.searchUserByOrgDetail(params, searchOrgByDetailCanceller).then(function (payload) {
      //         //MyService.ConsoleLog("payload: ", payload);
      //         // $scope.users.data = payload.Items;
      //         $scope.users.data = $scope.users.data.concat(payload);
      //         //MyService.ConsoleLog("length: ", $scope.users.data.length);
      //         $scope.totalUsers = payload.Count;
      //         //MyService.ConsoleLog(payload.Items);
      //         $scope.statusGetResPg = 2;
      //       }, function (err) {
      //         //MyService.ConsoleLog(err);
      //         growl.error("Something went wrong.");
      //         $scope.statusGetResPg = 3;
      //         $scope.page--;
      //       });
      //     } else {
      //       //MyService.ConsoleLog("break loop");
      //       $scope.page = 0;
      //       // break;
      //       return false;

      //     }
      //   } else if (!$filter("isBlankString")($scope.userDetailKeyword) || !$filter("isBlankString")($scope.userDetailFilter)) {
      //     //MyService.ConsoleLog("searching by user detail");
      //     $scope.statusGetResPg = 1;

      //     searchUserByDetailCanceller = $q.defer();
      //     params.keyword = $scope.userDetailKeyword;
      //     if (!params.keyword) {
      //       params.keyword = "postcard";
      //     }
      //     params.listOption = $scope.userDetailFilter;
      //     var calc = (pageNumber - 1) * 30;
      //     if ($scope.users.data.length >= calc) {
      //       MyService.searchUserByDetail(params, searchUserByDetailCanceller).then(function (payload) {
      //         //MyService.ConsoleLog("payload: ", payload);
      //         // $scope.users.data = payload.Items;
      //         $scope.users.data = $scope.users.data.concat(payload);
      //         //MyService.ConsoleLog("length: ", $scope.users.data.length);
      //         $scope.totalUsers = payload.Count;
      //         //MyService.ConsoleLog(payload.Items);
      //         $scope.statusGetResPg = 2;
      //       }, function (err) {
      //         //MyService.ConsoleLog(err);
      //         growl.error("Something went wrong.");
      //         $scope.statusGetResPg = 3;
      //         $scope.page--;
      //       });
      //     } else {
      //       //MyService.ConsoleLog("break loop");
      //       $scope.page = 0;
      //       // break;
      //       return false;

      //     }
      //   }
      // } else {
      //   if ($scope.filterUser) {
      //     params.usertype = $scope.filterUser;
      //   }



      // MyService.getAllFECCommitteesData({
      //   "pageno": pageNumber
      // }).then(function (response) {
      //   console.log("response", response);
      //   $scope.candidiateCommittees = response.data.data;
      //   $scope.openFecTotal = $scope.candidiateCommittees.length;

      //   MyService.ConsoleLog("getopenFECCandidateCommittees ** : ", $scope.candidiateCommittees);
      // }, function (err) {
      //   MyService.ConsoleLog("error : ", err);
      // });

      // MyService.getAllFECCommittees().then(function (response) {
      //   console.log("yogesh");
      //   console.log(response);
      // }, function (err) {
      //   MyService.ConsoleLog("error : ", err);
      // });

    }
    $scope.AddCommittees = function () {

      MyService.getAllFECCommittees().then(function (response) {
        // console.log("yogesh");
        // console.log(response);
      }, function (err) {
        MyService.ConsoleLog("error : ", err);
      });
    }

    if ($rootScope.showOpenFecCommittee) {
      $scope.getopenFECCommittees($scope.currPage);
    }

  }])
'use strict';
angular.module('myApp.openFecCandidates', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/openFecCandidates', {
      templateUrl: 'app/openFecCandidates/openFecCandidates.html',
      controller: 'openFECCtrl'
    });
  }]) .controller('openFECCtrl', ['$scope', 'ngDialog', '$rootScope', 'MyService', '$http', '$timeout', '$q', function ($scope, ngDialog, $rootScope, MyService, $http, $timeout, $q) {
    $scope.openFecCandidates = [];
    $scope.showLoader = false;
    $scope.currPage = 1;
    $scope.openCandidateDtls = false;
    $scope.candidiateDtls = [];
    $scope.candidiateCommittees = [];

    /*OpenFec Calls*/
    $scope.myPagingFunction = function () {
      //MyService.ConsoleLog("scoll called");
      if ($scope.statusGetResPg != 1) {
        $scope.currPage++;
        $scope.pageChanged($scope.currPage);
      }
    };
    $scope.pageChanged = function (newPage) {
      $scope.getopenFECCandidatesData(newPage);
    };

    $scope.selDbPresent = {
      "present": ""
    };
    // Get FEC Candidates Data

    $scope.openFecCandidates = [];

    $scope.getopenFECCandidatesData = function (pageNumber) {
      console.log(pageNumber);
      var params = {
        "page": pageNumber,
        max_records: 30
      };
      //MyService.ConsoleLog("params: ", params);
      // $scope.users.data = [];



      $scope.statusGetResPg = 1;

      var getAllCanceller = $q.defer();
      var calc = (pageNumber - 1) * 30;

      MyService.getopenFECCandidates(params, getAllCanceller).then(function (success) {
        // $scope.users.data = payload.Items;
        // console.log(success);
        $scope.openFecCandidates = $scope.openFecCandidates.concat(success.data.data);
        // console.log($scope.openFecCandidates);
        // $scope.totalUsers = payload.Count;
        // MyService.ConsoleLog(payload.Items);
        $scope.statusGetResPg = 2;
      }, function (err) {
        //MyService.ConsoleLog(err);
        growl.error("Something went wrong.");
        $scope.statusGetResPg = 3;
        $scope.page--;
      });


      // //MyService.ConsoleLog("In getopenFECCandidates");
      // MyService.getopenFECCandidates({
      //   "pageno": pageNumber
      // }).then(function (success) {
      //   MyService.ConsoleLog("getopenFECCandidates : ", success);
      //   $scope.openFecCandidates = success.data.data;
      //   MyService.ConsoleLog($scope.openFecCandidates);
      //   $scope.openFecTotal = $scope.openFecCandidates.length;
      //   //$scope.currPage = success.data.data.pagination.page;
      // }, function (err) {
      //   MyService.ConsoleLog("error : ", err);
      // });
    };
    $scope.showLoader = false;
    $scope.getCurrentFECCandidates = function (pageNumber) {
      //MyService.ConsoleLog("In getopenFECCandidates");
      $scope.showLoader = true;
      MyService.getCurrentFECCandidates({
        "pageno": pageNumber
      }).then(function (returndata) {
        MyService.ConsoleLog(returndata);
        if (returndata.data.success) {
          MyService.ConsoleLog(returndata.data.data);
          var totalpages = returndata.data.data.totalPages;
          var currentPage = returndata.data.data.currentPage;
          if (currentPage < totalpages) {
            alert("Records of " + currentPage + " page out of " + totalpages + " successfully added in database");
            var nextpage = parseInt(currentPage) + 1;
            alert("Lets get " + nextpage + " page records");
            $scope.getCurrentFECCandidates(nextpage);
          }
        }

      }, function (err) {
        $scope.showLoader = false;
        MyService.ConsoleLog("error : ", err);
      });
    };
    $scope.goBack = function () {
      $scope.openCandidateDtls = false;
      $scope.candidiateDtls = [];
      $scope.candidiateCommittees = [];
    }
    $scope.getCandidateDetails = function (id) {
      $scope.openCandidateDtls = true;
      MyService.getopenFECCandidateDetails({
        "cid": id
      }).then(function (success) {
        // MyService.ConsoleLog("getCandidateDetails : ", success);
        $scope.candidiateDtls = success.data.data;
        $scope.candidiateCommittees = $scope.candidiateDtls.committees;
        // console.log('********committee candy*************');
        // console.log('committee candy', $scope.candidiateCommittees);

        //MyService.ConsoleLog("candidiateDtls @@ :",$scope.candidiateDtls);



      }, function (err) {
        MyService.ConsoleLog("error : ", err);
      });

      MyService.getopenFECCandidateCommittees({
        "cid": id
      }).then(function (success1) {
        // MyService.ConsoleLog("getopenFECCandidateCommittees ");
        $scope.candidiateCommittees = success1.data.data;
        // MyService.ConsoleLog("getopenFECCandidateCommittees ** : ", $scope.candidiateCommittees);
      }, function (err1) {
        MyService.ConsoleLog("error : ", err1);
      });
    }

    $scope.getElectionData = function () {
      MyService.ConsoleLog("In getopenFECCandidates");
      $scope.showLoader = true;
      MyService.getElectionsDate({}).then(function (success) {
        $scope.showLoader = false;
        alert("data added successfully");

      }, function (err) {
        $scope.showLoader = false;
        MyService.ConsoleLog("error : ", err);
      });
    };
    if ($rootScope.showOpenFec) {
      $scope.getopenFECCandidatesData($scope.currPage);
    }


  }])
'use strict';
angular.module('myApp.newsFeed', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/newsFeed', {
      templateUrl: 'app/newsFeed/newsFeed.html',
      controller: 'newsFeedCtrl'
    });
  }])

  .controller('newsFeedCtrl', ['$scope', '$rootScope', '$http', '$location', 'apiCall', 'baseApiUrl', 'tokenService', 'ngDialog', 'growl', 'MyService', function ($scope, $rootScope, $http, $location, apiCall, baseApiUrl, tokenService, ngDialog, growl, MyService) {
    $scope.imgUrl = baseApiUrl + "/resources";
    $scope.userId = tokenService.getUserId();
    $scope.userRole = tokenService.getUserRole();
    $scope.userData = JSON.parse(tokenService.getUserData());

    $rootScope.welcome = false;
    $scope.showCon = false;
    $scope.showBoth = false;
    $scope.showEm = false;


    /**
     * Redirect
     */
    $scope.goto = function () {
      $location.path('/verifyBy');
    };

    /**
     * Close it
     */
    $scope.closeIt = function () {
      $scope.PopDialog.close();
    };
    $scope.getmyData = function () {
      $scope.ShowPorifleLoading = true;
      MyService.getUserPublicProfile({
        id: tokenService.getUserId(),
        type: 'false'
      }).then(function (response) {
        $scope.ShowPorifleLoading = false;
        if (response.data.success) {
          $scope.userDetails = response.data.data;
          // MyService.ConsoleLog("welcome", $scope.userDetails);
          $scope.userProfile = $scope.userDetails.userData;
          MyService.ConsoleLog("welcome to profile", $scope.userProfile);

          $scope.userType = $scope.userProfile.userType;
          $scope.verify = $scope.userProfile.verifiedUser;
          // MyService.ConsoleLog("welcome", $scope.verify);
          // console.log("$scope.userDetails", $scope.userDetails.userData.address);
          if (!$scope.userProfile.verifiedUser) {
            $scope.showCon = true;
          }
          if (!$scope.userProfile.isEmailVerified || !$scope.userProfile.verifiedUser) {
            // $scope.getPopUp();
            if (!$scope.userProfile.isEmailVerified && !$scope.userProfile.verifiedUser) {
              $scope.showCon = true;
              $scope.showBoth = true;
            } else if (!$scope.userProfile.isEmailVerified) {
              $scope.showEm = true;
            }
            $scope.PopDialog = ngDialog.open({
              template: 'popUp',
              closeByNavigation: true,
              scope: $scope,
              width: '50%'
            });
          }


        } else {
          MyService.ConsoleLog("ELSE vishal");
          alert("Something went wrong.");
        }
      }, function (errorPayload) {
        $scope.ShowPorifleLoading = false;
        MyService.ConsoleLog("ELSE vishal two");

        alert("Something went wrong.");
      });
    }

    if (tokenService.getUserId()) {
      $scope.getmyData();
    }


  }]);

'use strict';
angular.module('myApp.newPressEssay', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
        $routeProvider.when('/newPressEssay/:categoryId?', {
            templateUrl: 'app/newPressEssay/newEssay.html',
            controller: 'NewPressEssayCtrl'
        });
    }])
    .controller('NewPressEssayCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'growl', 'tokenService', 'ngDialog', 'baseApiUrl', '$anchorScroll', 'MyService', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, growl, tokenService, ngDialog, baseApiUrl, $anchorScroll, MyService) {
        //MyService.ConsoleLog("NewPressEssayCtrl")
        $scope.EssayButton = false;
        $rootScope.welcome = false;
        $scope.categoryId = $routeParams.categoryId;
        $scope.userType = tokenService.getUserRole();
        MyService.ConsoleLog("User Type:", $scope.userType);
        //MyService.ConsoleLog($scope.categoryId);
        $scope.location = ['International', 'National', 'State', 'County', 'Local'];
        if (tokenService.getUserData()) {
            $scope.uData = JSON.parse(tokenService.getUserData());
            //MyService.ConsoleLog("Default Data : ", $scope.uData);
        }

        $scope.mediaType = ['Text', 'Video', 'Stills', 'Audio'];

        $scope.tinymceOptions = {
            plugins: [
                'advlist autolink lists link image charmap print preview hr anchor pagebreak',
                'searchreplace wordcount visualblocks visualchars code fullscreen',
                'insertdatetime media nonbreaking save table contextmenu directionality',
                'emoticons template paste textcolor colorpicker textpattern imagetools'
            ],
            toolbar: ''
        };

        $scope.subtopics = {
            subcategories: []
        };
        $scope.AddLocation = false;
        $scope.newlocation = {
            country: ''
        };
        $scope.Essay = {
            title: '',
            description: '',
            location: '',
            mediaType: 'Text',
            subcategories: []
        };

        $scope.restrictedOptions = ['Locals Only', 'No Restrictions'];

        $scope.selectedCat = [];
        $scope.SelectedTree = [];
        $scope.disabled = [];
        $scope.Allcountries = [];
        $scope.Allpress = [];
        $scope.SelectedCountry = '';



        $scope.ShowAddLocation = function() {
            if (!$scope.AddLocation) {
                $scope.AddLocation = true;
            } else {
                $scope.AddLocation = false;
            }

        }



        $scope.getAllCountries = function() {
            var request = apiCall.apiCall('GET', '/user/getAllCountries', {});
            $http(
                request
            ).then(function successCallback(response) {
                //MyService.ConsoleLog("Got countires: ", response);
                if (response.data.success) {
                    $scope.Allcountries.length = 0;
                    var subcatdata = response.data.data;
                    //MyService.ConsoleLog("countires : ", subcatdata);
                    $scope.Allcountries = subcatdata;
                } else {
                    alert("Something went wrong: ", response.data);
                }
            }, function errorCallBack(response) {
                //MyService.ConsoleLog("Error: ", response);
            });
        }


        function suggest_country(term) {
            var q = term.toLowerCase().trim();
            var results = [];
            var len = $scope.Allcountries.length;
            // Find first 10 states that start with `term`.
            for (var i = 0; i < len && results.length < 10; i++) {
                var country = $scope.Allcountries[i];
                if (country.toLowerCase().indexOf(q) === 0)
                    results.push({ label: country, value: country });
            }

            return results;
        }

        $scope.autocomplete_options = {
            suggest: suggest_country
        };
        $scope.displayPressRefresh = false;
        $scope.getAllPress = function() {
            $scope.displayPressRefresh = true;
            $scope.Allpress.length = 0;
            MyService.getAllOrganizations({ type: "Press" }).then(function(payload) {
                $scope.Allpress = payload;
                $scope.displayPressRefresh = false;
                MyService.ConsoleLog($scope.Allpress);
            }, function(err) {
                $scope.displayPressRefresh = false;
                alert("Something went wrong.");
                // growl.error("Some");
            });


        }

        function suggest_press(term) {
            var q = term.toLowerCase().trim();

            var results = [];
            var len = $scope.Allpress.length;
            // Find first 10 states that start with `term`.
            for (var i = 0; i < len && results.length < 10; i++) {
                var country = $scope.Allpress[i].title;
                if (country.toLowerCase().indexOf(q) === 0)
                    results.push({ label: country, value: country, obj: $scope.Allpress[i] });
            }

            return results;
        }
        $scope.selected_press = '';

        $scope.autocomplete_press_options = {
            suggest: suggest_press,
            on_select: function(selected) {
                $scope.selected_press = selected.obj;
            }
        };


        $scope.getAllStates = function() {

            MyService.getAllStates().then(function(payload) {
                    $scope.allLocations.length = 0;
                    var subcatdata = payload;
                    //MyService.ConsoleLog("countires : ", subcatdata);
                    $scope.allLocations = subcatdata;


                },
                function(errorPayload) {
                    alert('Something went wrong ');
                });


        }




        $scope.getVal = function(data) {
            //MyService.ConsoleLog(data);
            var idx = $scope.selectedCat.indexOf(data);
            if (idx > -1) {
                $scope.selectedCat.splice(idx, 1);
                var id = $scope.disabled.indexOf(data._id);
                $scope.disabled.splice(id, 1);
                var jdx = $scope.SelectedTree.indexOf(data.parentIds);
                if (jdx > -1)
                    $scope.SelectedTree.splice(jdx, 1);

            } else {
                $scope.selectedCat.push(data);
                var id = $scope.disabled.indexOf(data._id);
                if (id == -1) {
                    $scope.disabled.push(data._id);

                }
                //MyService.ConsoleLog(data.parentIds);
                //MyService.ConsoleLog("SelectedTree: ", $scope.SelectedTree);
                if ($scope.SelectedTree.length == 0) {
                    if (data.parentIds.length > 0) {
                        //var parents = Object.keys(data.parentIds).map(function (key) {return data.parentIds[key]});
                        //angular.copy(data.parentIds, $scope.SelectedTree);
                        var parents = data.parentIds;
                        //MyService.ConsoleLog(parents);
                        $scope.SelectedTree = parents;
                    }
                } else {
                    if (data.parentIds.length > 0) {
                        //var parents = Object.keys(data.parentIds).map(function (key) {return data.parentIds[key]});
                        //var parents = angular.copy(data.parentIds);
                        var parents = data.parentIds;
                        var plen = parents.length;
                        for (var j = 0; j < plen; j++) {
                            $scope.SelectedTree.push(parents[j]);
                        }
                    }
                }
            }
            //MyService.ConsoleLog($scope.SelectedTree);
        }


        $scope.selectedAll = {
            id: []
        };
        $scope.removeVal = function(data) {

            var idx = $scope.selectedCat.indexOf(data);
            if (idx > -1) {
                $scope.selectedCat.splice(idx, 1);
                var id = $scope.disabled.indexOf(data._id);
                $scope.disabled.splice(id, 1);
                var parents = data.parentIds;
                var plen = parents.length;
                for (var j = 0; j < plen; j++) {
                    var jdx = $scope.SelectedTree.indexOf(parents[j]);

                    if (jdx > -1)
                        $scope.SelectedTree.splice(jdx, 1);
                }

            }
            $scope.selectedAll.id.length = 0;
            var allLen = $scope.SelectedTree.length;
            var chkboxe = document.getElementsByName("checkedidcat");
            for (var i = 0; i < allLen; i++) {
                chkboxe[i].checked = true;

            }
        }

        $scope.selectConfig = {
            requiredMin: 1,
            selectAll: true
        };

        $scope.checkCatExists = function(rdata, val) {
            return rdata.filter(
                function(rdata) {
                    if (rdata._id == val) {
                        $scope.selectedCat.push(rdata);
                        return rdata
                    } else if (rdata.subcategories) {
                        $scope.checkCatExists(rdata.subcategories, val)
                    }
                }
            );
        }

        $scope.loadDefaultTags = function() {
            $scope.selectedCat.length = 0;
            $scope.disabled.length = 0;
            if ($scope.uData) {
                var selectedCat = $scope.uData.subject_of_deep_interest;
            } else {
                var selectedCat = "";
            }
            $scope.disabled = selectedCat;
            if (selectedCat.length > 0) {
                for (var s = 0; s < selectedCat.length; s++) {
                    var checkcatdata = $scope.checkCatExists($scope.subtopics.subcategories, selectedCat[s]);
                }
            }
        }

        $scope.loadDefaultLocations = function() {
            var locations = $scope.uData.location_of_interest;
            var len = locations.length;
            $scope.selectedArea.length = 0;
            $scope.showSubCat = true;
            $scope.disabledLocation.length = 0;
            for (var l = 0; l < len; l++) {
                var nobj = {};
                if (locations[l].country == "National (USA)") {
                    $scope.Essay.National = 'National';
                }
                if (locations[l].country) {
                    nobj.country = locations[l].country;
                }
                if (locations[l].state) {
                    nobj.state = locations[l].state;
                    nobj.statePostalCode = locations[l].statePostalCode;
                }
                if (locations[l].county) {
                    nobj.county = locations[l].county;
                }
                if (locations[l].countySubdivision) {
                    nobj.countySubdivision = locations[l].countySubdivision;
                }
                if (locations[l].place) {
                    nobj.place = locations[l].place;
                }
                $scope.selectedArea.push(nobj);
                $scope.disabledLocation.push(nobj);


            }
        }

        $scope.checkDisabled = function(data, stateId, type) {

            data.country = "United States of America";
            data.state = stateId;

            var idx = indexOfExt($scope.disabledLocation, data);
            if (idx > -1)
                return true;
            else
                return false;


        }

        $scope.getSubcatTree = function() {
            $scope.selectedCat.length = 0;

            MyService.getAllCatTree({ "type": "E" }).then(function(payload) {
                    $scope.subtopics.subcategories.length = 0;
                    var subcatdata = payload;

                    $scope.subtopics.subcategories = subcatdata;
                    if ($scope.categoryId != "") {
                        $scope.disabled.length = 0;
                        $scope.disabled.push($scope.categoryId);
                        var checkcatdata = $scope.checkCatExists(subcatdata, $scope.categoryId);
                        //MyService.ConsoleLog($scope.selectedCat);

                    }
                    setTimeout(function() {
                        var cols = document.getElementsByClassName('cmnUL');
                        var clen = cols.length;
                        for (var i = 0; i < clen; i++) {
                            cols[i].style.display = "none";
                        }
                    }, 300);
                },
                function(errorPayload) {
                    alert('Something went wrong ');
                });


        }
        $scope.allLocations = [];
        $scope.allCounties = [];
        $scope.selectedArea = [];
        $scope.rmselectedArea = [];
        $scope.myselectionarea = [];
        $scope.disabledLocation = [];

        $scope.checkExists = function(rdata, val) {
            return rdata.filter(
                function(rdata) {
                    if (rdata.state == val)
                        return rdata
                }
            );
        }

        $scope.checkCountyExists = function(rdata, val) {
            return rdata.filter(
                function(rdata) {
                    if (rdata.county == val)
                        return rdata
                }
            );
        }

        $scope.checkCountryExists = function(rdata, val) {
            return rdata.filter(
                function(rdata) {
                    if (rdata.country == val)
                        return rdata
                }
            );
        }

        $scope.getAreaVal = function(data, stateId, type) {
            if (!data.country) {
                data.country = "United States of America";
            }
            if (!data.state) {
                data.state = stateId;
            }
            var idx = $scope.selectedArea.indexOf(data);


            if (idx > -1) {
                $scope.selectedArea.splice(idx, 1);
                var jdx = $scope.disabledLocation.indexOf(data);
                if (jdx > -1) {
                    $scope.disabledLocation.splice(jdx, 1);
                }
            } else {

                $scope.selectedArea.push(data);
                $scope.disabledLocation.push(data);

            }

            //MyService.ConsoleLog($scope.disabledLocation);
        }
        $scope.selectedLAll = {
            id: []
        };
        $scope.removeAreaVal = function(data) {
            var idx = $scope.selectedArea.indexOf(data);
            if (idx > -1) {
                if ($scope.selectedArea[idx].country == "International") {
                    $scope.Essay.Locations = 'NO';
                }
                if ($scope.selectedArea[idx].country == "National (USA)") {
                    $scope.Essay.National = 'NO';
                }
                $scope.selectedArea.splice(idx, 1);
                var jdx = $scope.disabledLocation.indexOf(data);
                if (jdx > -1) {
                    $scope.disabledLocation.splice(jdx, 1);
                }
            }
            $scope.selectedLAll.id.length = 0;
            var allLen = $scope.selectedArea.length;
            var chkboxe = document.getElementsByName("checkedid");
            for (var i = 0; i < allLen; i++) {
                chkboxe[i].checked = true;

            }



        }
        $scope.allCounties = [];
        $scope.allLocals = [];
        $scope.setLocation = function(option) {
            $scope.Essay.location = option;
        }

        function areEqual() {
            var len = arguments.length;
            for (var i = 1; i < len; i++) {
                if (arguments[i] == null || arguments[i] != arguments[i - 1])
                    return false;
            }
            return true;
        }

        function indexOfExt(list, item) {
            var len = list.length;

            for (var i = 0; i < len; i++) {
                var keys = Object.keys(list[i]);
                var flg = true;
                var arr = [];


                for (var j = 0, s = 1; j < keys.length; j++, s++) {
                    var value = list[i][keys[j]];
                    if (item[keys[j]] !== value) {
                        flg = false;

                    }

                    if (item[keys[j]] == value) {
                        arr.push(flg);
                    }


                }
                if (flg == true) {
                    if (areEqual(arr.length, keys.length, Object.keys(item).length)) {
                        return i;
                    }

                }


            }
            return -1;
        }
        $scope.getLocations = function(val, type) {
            //MyService.ConsoleLog(val+"<====>"+type);
            if (type == "National") {
                if (val == "National") {

                    var nobj = {
                        country: "National (USA)"
                    }
                    $scope.selectedArea.push(nobj);
                    //MyService.ConsoleLog($scope.selectedArea);
                }
                if (val == "NO") {

                    var nobj = {
                        country: "National (USA)"
                    }
                    var idx = indexOfExt($scope.selectedArea, nobj);
                    //var idx = $scope.selectedArea.indexOf(nobj);
                    if (idx > -1) {
                        $scope.selectedArea.splice(idx, 1);
                    }


                }
            } else if (type == "International") {

                if (val == "International") {
                    // $scope.selectedArea.length = 0;
                    var nobj = {
                        country: "International"
                    }
                    $scope.selectedArea.push(nobj);

                }

                if (val == "NO") {
                    // $scope.selectedArea.length = 0;
                    var nobj = {
                        country: "International"
                    }

                    var idx = indexOfExt($scope.selectedArea, nobj);
                    //var idx = $scope.selectedArea.indexOf(nobj);
                    if (idx > -1) {
                        $scope.selectedArea.splice(idx, 1);
                    }
                }


            }

        }

        $scope.AddCountry = function() {
            if (($scope.newlocation.country) && ($scope.newlocation.country != '')) {
                var idx = $scope.Allcountries.indexOf($scope.newlocation.country);
                if (idx > -1) {
                    var nobj = {
                        country: $scope.newlocation.country
                    };
                    $scope.selectedArea.push(nobj);

                } else {
                    alert("Country does not exists in our database. Please check if you have entered correct name.");
                }

            } else {
                alert("Please enter country name");
            }
        }

        $scope.getCounties = function(state) {
            $scope.showLoading.push(state);
            if (!$scope.allCounties[state] || $scope.allCounties[state].length == 0) {

                MyService.getAllCounties(state).then(function(payload) {
                        $scope.showLoading.length = 0;
                        var sublocations = payload;
                        if (!$scope.allCounties) {
                            $scope.allCounties = [];
                        }
                        $scope.allCounties[state] = sublocations;
                    },
                    function(errorPayload) {
                        alert('Something went wrong.');
                    });


            } else {
                $scope.showLoading.length = 0;
                $scope.allCounties[state].length = 0;
            }
        }

        $scope.getLocals = function(state, county) {
            $scope.showLoadingCounty.push(county);
            if (!$scope.allLocals[state] || !$scope.allLocals[state][county] || $scope.allLocals[state][county].length == 0) {

                MyService.getAllSubCountiesLocal(state, county).then(function(payload) {
                        $scope.showLoadingCounty.length = 0;
                        //MyService.ConsoleLog("sublocations Locals : ", sublocations);
                        if (!$scope.allLocals[state]) {
                            $scope.allLocals[state] = [];
                        }
                        $scope.allLocals[state][county] = payload;
                    },
                    function(errorPayload) {
                        alert('Something went wrong ');
                    });


            } else {
                $scope.showLoadingCounty.length = 0;
                $scope.allLocals[state][county].length = 0;
            }
        }

        if (!$rootScope.UserId) {
            $location.path('signin');
        }



        if (window.localStorage.getItem("VoteWiseEssayCategory")) {
            $rootScope.allEssaycategories = JSON.parse(window.localStorage.getItem("VoteWiseEssayCategory"));
            var idx = $rootScope.allEssaycategories.indexOf($routeParams.subcatId);
            if (idx == -1) {
                $rootScope.allEssaycategories.push($routeParams.subcatId);
                window.localStorage.setItem("VoteWiseEssayCategory", JSON.stringify($rootScope.allEssaycategories));
            }
        }

        $scope.showSubCat = true;
        $scope.showLoading = [];
        $scope.showLoadingCounty = [];
        $scope.showDown = [];
        $scope.ChangeShow = function(id) {
            //$scope.showSubCat = true;
            //var cols = document.getElementsByClassName('cmnUL');
            //var clen = cols.length;
            var nclass = "MainCatLi_" + id;
            if ((document.getElementsByClassName(nclass)[0].style.display) && (document.getElementsByClassName(nclass)[0].style.display == "none")) {
                document.getElementsByClassName(nclass)[0].style.display = "block";
            } else {
                document.getElementsByClassName(nclass)[0].style.display = "none";
            }


        }


        $scope.SubmitEssay = function(data) {
            //MyService.ConsoleLog(data);
            //MyService.ConsoleLog($scope.selected_press);
            var cId = tokenService.getUserId();
            var cName = tokenService.getUserName();
            var cRole = tokenService.getUserRole();

            if($scope.selected_press && $scope.selected_press._id && $scope.selected_press._id!="") {
                cId = $scope.selected_press._id;
                cName = $scope.selected_press.title;
                cRole = "PressM";
            }

            
            if ($.fn.validateForceFully($("#topicform")) == true) {
                if ($scope.disabled.length == 0) {
                    alert("Please select atleast one Tag");
                } else {
                    $scope.EssayButton = true;
                    if (data.mediaType == 'Stills') {
                        //MyService.ConsoleLog(data.files);
                        if (data.files) {
                            var fd = new FormData();
                            fd.append('file', data.files);
                            fd.append("parentcat", $scope.disabled);
                            fd.append("subcategories", JSON.stringify($scope.SelectedTree));

                            fd.append("createdById", cId);
                            fd.append("createdByName", cName);
                            fd.append("createdByType", cRole);
                            fd.append("title", data.title);
                            fd.append("description", data.description);
                            fd.append("mediaType", data.mediaType);
                            fd.append("location", data.location);
                            if ($scope.selectedArea.length > 0) {
                                fd.append("locationSpecific", JSON.stringify($scope.selectedArea));
                            }


                            var udata = $scope.uData;
                            var posturl = baseApiUrl + "/essay-press/create?mediaType=" + data.mediaType;

                            $http.post(posturl, fd, {
                                    transformRequest: angular.identity,
                                    headers: { 'Content-Type': undefined },
                                    params: {
                                        'folderName': udata.uname
                                    }
                                })
                                .success(function(response, status, headers, config) {
                                    $scope.EssayButton = false;
                                    //MyService.ConsoleLog("response : ", response);

                                    if (response.success) {
                                        $location.path('/catsel-press-essay');
                                    } else {

                                        //MyService.ConsoleLog(errorPayload);

                                        alert(response.error);
                                        if ((response.status) && (response.status == "405")) {
                                            var msg = "Do you want to send request to Admin to reactivate your account?.";
                                            MyService.GetDialogWithButtons(ngDialog, msg, "YES", "NO").then(function(payload) {
                                                MyService.sendActivatationMailtoAdmin().then(function(payload) {
                                                    alert("Request sent successfully to admin");
                                                }, function(errorPayload) {
                                                    alert("Something went wrong");
                                                })
                                            }, function(errorPayload) {
                                                //MyService.ConsoleLog(errorPayload);
                                            });
                                        }

                                    }
                                })
                                .error(function(response, status, headers, config) {
                                    if (response.error) {
                                        alert("Error: ", response.error);
                                    } else {
                                        alert("Something went wrong");
                                    }
                                });
                        } else {
                            alert("File is required.");
                        }


                    } else {
                        data.parentcat = $scope.disabled;
                        data.subcategories = JSON.stringify($scope.SelectedTree);
                        data.createdById = cId;
                        data.createdByName = cName;
                        data.createdByType = cRole;
                        if ($scope.selectedArea.length > 0) {
                            data.locationSpecific = JSON.stringify($scope.selectedArea);
                        }
                        //MyService.ConsoleLog("data: ", data);

                        var request = apiCall.apiCall('POST', '/essay-press/create?mediaType=' + data.mediaType, data);
                        $http(
                            request
                        ).then(function successCallback(response) {
                            //MyService.ConsoleLog("Got Essay: ", response);
                            $scope.EssayButton = false;
                            if (response.data.success) {
                                $location.path('/catsel-press-essay');
                            } else {
                                alert(response.data.error);
                                if ((response.data.status) && (response.data.status == "405")) {
                                    var msg = "Do you want to send request to Admin to reactivate your account?.";
                                    MyService.GetDialogWithButtons(ngDialog, msg, "YES", "NO").then(function(payload) {
                                        MyService.sendActivatationMailtoAdmin().then(function(payload) {
                                            alert("Request sent successfully to admin");
                                        }, function(errorPayload) {
                                            alert("Something went wrong");
                                        })
                                    }, function(errorPayload) {
                                        //MyService.ConsoleLog(errorPayload);
                                    });
                                }
                            }
                        }, function errorCallBack(response) {
                            if (response.error) {
                                alert("Error: ", response.error);
                            } else {
                                alert("Something went wrong");
                            }

                        });
                    }

                }


            }

            
        }
        $scope.MainGallery = [];
        if ($scope.uData) {
            $scope.GalleryFolder = baseApiUrl + "/resources/" + $scope.uData.uname;
        }

        $scope.loadGallery = function() {
            var nrequest = apiCall.apiCall('GET', '/gallery/get', { id: $scope.uData.id });
            $http(
                nrequest
            ).then(function successCallback(responseLatest) {
                if (responseLatest.data.success) {
                    $scope.MainGallery = responseLatest.data.data;
                }


            }, function errorCallBack(responseLatest) {

                subCategories.returndata = sampledata;
                $scope.subCategories.push(subCategories);
            });
        }

        $scope.Showgallery = function() {
            ngDialog.open({
                template: 'newEssay/dialogGallery.html',
                width: '650px',
                scope: $scope
            });
            $scope.loadGallery();
        }
        $scope.uploadMedia = false;
        $scope.Gallery = false;
        $scope.uploads = {
            files: '',
            path: ''
        }
        $scope.ChangeMedia = function(option) {
            if (option == "G") {
                $scope.uploadMedia = false;
                $scope.Gallery = true;
            } else {
                $scope.Gallery = false;
                $scope.uploadMedia = true;
            }


        }




        $scope.uploadFile = function() {
            var fd = new FormData();
            //Take the first selected file
            var udata = $scope.uData;
            var urole = JSON.parse(tokenService.getUserData());

            $scope.userData = {
                id: udata.id,
                name: udata.name,
                uname: udata.uname,
                utype: tokenService.getUserRole()
            };
            $scope.uploads.files.fieldname = udata.uname;

            fd.append('file', $scope.uploads.files);
            fd.append("user", JSON.stringify($scope.userData));


            var posturl = baseApiUrl + "/gallery/upload";


            $http.post(posturl, fd, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined },
                params: {
                    'folderName': udata.uname
                }
            })

            .success(function(response, status, headers, config) {

                if (response.data) {
                    $scope.loadGallery();
                    $scope.ChangeMedia("G");
                }
            })

            .error(function(data, status, headers, config) {
                //MyService.ConsoleLog("error");
            });




        };

        $scope.ShowPath = false;

        $scope.ShowSelectedPath = function(filePath) {
            $scope.uploads.path = $scope.GalleryFolder + "/" + filePath;
            $scope.ShowPath = true;
        }

        $scope.checkSelected = function() {


            return true;

        }

        $scope.goBack = function() {
            var len = $rootScope.allEssaycategories.length;
            var type = 'home';
            if (len > 2) {
                type = "subcat";
            }

            $location.path('essay/' + $rootScope.allEssaycategories[len - 2] + '/' + $rootScope.allEssaycategories[len - 1] + "/" + type);



        }

        var token = apiCall.getToken();
        if (!token) {
            var message = "Please login first.";

            var modal = ngDialog.openConfirm({
                template: '<p>' + message + '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
                plain: true
            });

            modal.then(function fullfilled(data) {
                //MyService.ConsoleLog("fullfilled: ", data);
                $location.path('signin');
            }, function rejected(data) {
                //MyService.ConsoleLog("rejected: ", data);
                $location.path('signin');
            });
        } else {
            $scope.getAllPress();
            $scope.getAllCountries();
            $scope.getSubcatTree();
            $scope.getAllStates();
            $("form").validationEngine();
        }


    }]);

'use strict';
angular.module('myApp.newEssay', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/newEssay/:categoryId?', {
      templateUrl: 'app/newEssay/newEssay.html',
      controller: 'newEssayCtrl'
    });
  }])
  .controller('newEssayCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'growl', 'tokenService', 'ngDialog', 'baseApiUrl', '$anchorScroll', 'MyService', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, growl, tokenService, ngDialog, baseApiUrl, $anchorScroll, MyService) {
    $scope.EssayButton = false;
    $rootScope.welcome = false;
    $scope.categoryId = $routeParams.categoryId;
    //MyService.ConsoleLog($scope.categoryId);
    $scope.location = ['International', 'National', 'State', 'County', 'Local'];
    if (tokenService.getUserData()) {
      $scope.uData = JSON.parse(tokenService.getUserData());
    }
    //MyService.ConsoleLog("Default Data : ", $scope.uData);
    $scope.mediaType = ['Text', 'Video', 'Stills', 'Audio'];
    $scope.tinymceOptions = {
      plugins: [
        'advlist autolink lists link image charmap print preview hr anchor pagebreak',
        'searchreplace wordcount visualblocks visualchars code fullscreen',
        'insertdatetime media nonbreaking save table contextmenu directionality',
        'emoticons template paste textcolor colorpicker textpattern imagetools'
      ],
      toolbar: ''
    };
    $scope.subtopics = {
      subcategories: []
    };
    $scope.AddLocation = false;
    $scope.newlocation = {
      country: ''
    };
    $scope.Essay = {
      title: '',
      description: '',
      location: '',
      mediaType: 'Text',
      subcategories: []
    };

    $scope.restrictedOptions = ['Locals Only', 'No Restrictions'];

    $scope.selectedCat = [];
    $scope.SelectedTree = [];
    $scope.disabled = [];
    $scope.Allcountries = [];

    $scope.SelectedCountry = '';



    $scope.ShowAddLocation = function () {
      if (!$scope.AddLocation) {
        $scope.AddLocation = true;
      } else {
        $scope.AddLocation = false;
      }

    }



    $scope.getAllCountries = function () {
      var request = apiCall.apiCall('GET', '/user/getAllCountries', {});
      $http(
        request
      ).then(function successCallback(response) {
        //MyService.ConsoleLog("Got countires: ", response);
        if (response.data.success) {
          $scope.Allcountries.length = 0;
          var subcatdata = response.data.data;
          //MyService.ConsoleLog("countires : ", subcatdata);
          $scope.Allcountries = subcatdata;
        } else {
          alert("Something went wrong: ", response.data);
        }
      }, function errorCallBack(response) {
        //MyService.ConsoleLog("Error: ", response);
      });
    }


    function suggest_country(term) {
      var q = term.toLowerCase().trim();
      var results = [];
      var len = $scope.Allcountries.length;
      // Find first 10 states that start with `term`.
      for (var i = 0; i < len && results.length < 10; i++) {
        var country = $scope.Allcountries[i];
        if (country.toLowerCase().indexOf(q) === 0)
          results.push({
            label: country,
            value: country
          });
      }

      return results;
    }

    $scope.autocomplete_options = {
      suggest: suggest_country
    };

    $scope.Allpress = [];

    $scope.getAllPress = function () {
      $scope.Allpress.length = 0;
      MyService.getAllOrganizations({
        type: "Press"
      }).then(function (payload) {
        $scope.Allpress = payload;
      }, function (err) {
        alert("Something went wrong.");
        // growl.error("Some");
      });
    }

    function suggest_press(term) {
      var q = term.toLowerCase().trim();
      var results = [];
      var len = $scope.Allpress.length;
      // Find first 10 states that start with `term`.
      for (var i = 0; i < len && results.length < 10; i++) {
        var country = $scope.Allpress[i];
        if (country.toLowerCase().indexOf(q) === 0)
          results.push({
            label: country,
            value: country
          });
      }
      return results;
    }


    $scope.autocomplete_press_options = {
      suggest: suggest_press
    };

    $scope.getAllStates = function () {
      MyService.getAllStates().then(function (payload) {
          $scope.allLocations.length = 0;
          var subcatdata = payload;
          //MyService.ConsoleLog("countires : ", subcatdata);
          $scope.allLocations = subcatdata;
        },
        function (errorPayload) {
          alert('Something went wrong ');
        });
    }

    $scope.getVal = function (data) {
      //MyService.ConsoleLog(data);
      var idx = $scope.selectedCat.indexOf(data);
      if (idx > -1) {
        $scope.selectedCat.splice(idx, 1);
        var id = $scope.disabled.indexOf(data._id);
        $scope.disabled.splice(id, 1);
        var jdx = $scope.SelectedTree.indexOf(data.parentIds);
        if (jdx > -1)
          $scope.SelectedTree.splice(jdx, 1);

      } else {
        $scope.selectedCat.push(data);
        var id = $scope.disabled.indexOf(data._id);
        if (id == -1) {
          $scope.disabled.push(data._id);
        }
        //MyService.ConsoleLog(data.parentIds);
        //MyService.ConsoleLog("SelectedTree: ", $scope.SelectedTree);
        if ($scope.SelectedTree.length == 0) {
          if (data.parentIds.length > 0) {
            //var parents = Object.keys(data.parentIds).map(function (key) {return data.parentIds[key]});
            //angular.copy(data.parentIds, $scope.SelectedTree);
            var parents = data.parentIds;
            //MyService.ConsoleLog(parents);
            $scope.SelectedTree = parents;
          }
        } else {
          if (data.parentIds.length > 0) {
            //var parents = Object.keys(data.parentIds).map(function (key) {return data.parentIds[key]});
            //var parents = angular.copy(data.parentIds);
            var parents = data.parentIds;
            var plen = parents.length;
            for (var j = 0; j < plen; j++) {
              $scope.SelectedTree.push(parents[j]);
            }
          }
        }
      }
      //MyService.ConsoleLog($scope.SelectedTree);
    }

    $scope.selectedAll = {
      id: []
    };
    $scope.removeVal = function (data) {
      var idx = $scope.selectedCat.indexOf(data);
      if (idx > -1) {
        $scope.selectedCat.splice(idx, 1);
        var id = $scope.disabled.indexOf(data._id);
        $scope.disabled.splice(id, 1);
        var parents = data.parentIds;
        var plen = parents.length;
        for (var j = 0; j < plen; j++) {
          var jdx = $scope.SelectedTree.indexOf(parents[j]);
          if (jdx > -1)
            $scope.SelectedTree.splice(jdx, 1);
        }
      }
      $scope.selectedAll.id.length = 0;
      var allLen = $scope.SelectedTree.length;
      var chkboxe = document.getElementsByName("checkedidcat");
      for (var i = 0; i < allLen; i++) {
        chkboxe[i].checked = true;

      }
    }

    $scope.selectConfig = {
      requiredMin: 1,
      selectAll: true
    };

    $scope.checkCatExists = function (rdata, val) {
      return rdata.filter(
        function (rdata) {
          if (rdata._id == val) {
            $scope.selectedCat.push(rdata);
            return rdata
          } else if (rdata.subcategories) {
            $scope.checkCatExists(rdata.subcategories, val)
          }
        }
      );
    }

    if ($scope.uData && $scope.uData.subject_of_deep_interest) {
      $scope.DeepInterests = angular.copy($scope.uData.subject_of_deep_interest);
    }

    $scope.loadDefaultTags = function () {
      $scope.selectedCat.length = 0;
      $scope.disabled.length = 0;
      if ($scope.DeepInterests.length == 0) {
        $scope.DeepInterests = angular.copy($scope.uData.subject_of_deep_interest);
      }
      // MyService.ConsoleLog("Deep interest>>>",$scope.DeepInterests);
      // MyService.ConsoleLog("uData interest>>>",$scope.uData);
      $scope.disabled = $scope.DeepInterests;
      if ($scope.DeepInterests.length > 0) {
        for (var s = 0; s < $scope.DeepInterests.length; s++) {
          var checkcatdata = $scope.checkCatExists($scope.subtopics.subcategories, $scope.DeepInterests[s]);
        }
      }
    }

    $scope.loadDefaultLocations = function () {
      var locations = $scope.uData.location_of_interest;
      var len = locations.length;
      $scope.selectedArea.length = 0;
      $scope.showSubCat = true;
      $scope.disabledLocation.length = 0;
      for (var l = 0; l < len; l++) {
        var nobj = {};
        if (locations[l].country == "National (USA)") {
          $scope.Essay.National = 'National';
        }
        if (locations[l].country) {
          nobj.country = locations[l].country;
        }
        if (locations[l].state) {
          nobj.state = locations[l].state;
          nobj.statePostalCode = locations[l].statePostalCode;
        }
        if (locations[l].county) {
          nobj.county = locations[l].county;
        }
        if (locations[l].countySubdivision) {
          nobj.countySubdivision = locations[l].countySubdivision;
        }
        if (locations[l].place) {
          nobj.place = locations[l].place;
        }
        $scope.selectedArea.push(nobj);
        $scope.disabledLocation.push(nobj);


      }
    }

    $scope.checkDisabled = function (data, stateId, type) {

      data.country = "United States of America";
      data.state = stateId;

      var idx = indexOfExt($scope.disabledLocation, data);
      if (idx > -1)
        return true;
      else
        return false;


    }

    $scope.getSubcatTree = function () {
      $scope.selectedCat.length = 0;

      MyService.getAllCatTree({
        "type": "E"
      }).then(function (payload) {
          $scope.subtopics.subcategories.length = 0;
          var subcatdata = payload;

          $scope.subtopics.subcategories = subcatdata;
          if ($scope.categoryId != "") {
            $scope.disabled.length = 0;
            $scope.disabled.push($scope.categoryId);
            var checkcatdata = $scope.checkCatExists(subcatdata, $scope.categoryId);
            //MyService.ConsoleLog($scope.selectedCat);

          }
          setTimeout(function () {
            var cols = document.getElementsByClassName('cmnUL');
            var clen = cols.length;
            for (var i = 0; i < clen; i++) {
              cols[i].style.display = "none";
            }
          }, 300);
        },
        function (errorPayload) {
          alert('Something went wrong ');
        });


    }
    $scope.allLocations = [];
    $scope.allCounties = [];
    $scope.selectedArea = [];
    $scope.rmselectedArea = [];
    $scope.myselectionarea = [];
    $scope.disabledLocation = [];

    $scope.checkExists = function (rdata, val) {
      return rdata.filter(
        function (rdata) {
          if (rdata.state == val)
            return rdata
        }
      );
    }

    $scope.checkCountyExists = function (rdata, val) {
      return rdata.filter(
        function (rdata) {
          if (rdata.county == val)
            return rdata
        }
      );
    }

    $scope.checkCountryExists = function (rdata, val) {
      return rdata.filter(
        function (rdata) {
          if (rdata.country == val)
            return rdata
        }
      );
    }

    $scope.getAreaVal = function (data, stateId, type) {
      if (!data.country) {
        data.country = "United States of America";
      }
      if (!data.state) {
        data.state = stateId;
      }
      var idx = $scope.selectedArea.indexOf(data);


      if (idx > -1) {
        $scope.selectedArea.splice(idx, 1);
        var jdx = $scope.disabledLocation.indexOf(data);
        if (jdx > -1) {
          $scope.disabledLocation.splice(jdx, 1);
        }
      } else {

        $scope.selectedArea.push(data);
        $scope.disabledLocation.push(data);

      }

      //MyService.ConsoleLog($scope.disabledLocation);
    }
    $scope.selectedLAll = {
      id: []
    };
    $scope.removeAreaVal = function (data) {
      var idx = $scope.selectedArea.indexOf(data);
      if (idx > -1) {
        if ($scope.selectedArea[idx].country == "International") {
          $scope.Essay.Locations = 'NO';
        }
        if ($scope.selectedArea[idx].country == "National (USA)") {
          $scope.Essay.National = 'NO';
        }
        $scope.selectedArea.splice(idx, 1);
        var jdx = $scope.disabledLocation.indexOf(data);
        if (jdx > -1) {
          $scope.disabledLocation.splice(jdx, 1);
        }
      }
      $scope.selectedLAll.id.length = 0;
      var allLen = $scope.selectedArea.length;
      var chkboxe = document.getElementsByName("checkedid");
      for (var i = 0; i < allLen; i++) {
        chkboxe[i].checked = true;

      }



    }
    $scope.allCounties = [];
    $scope.allLocals = [];
    $scope.setLocation = function (option) {
      $scope.Essay.location = option;
    }

    function areEqual() {
      var len = arguments.length;
      for (var i = 1; i < len; i++) {
        if (arguments[i] == null || arguments[i] != arguments[i - 1])
          return false;
      }
      return true;
    }

    function indexOfExt(list, item) {
      var len = list.length;

      for (var i = 0; i < len; i++) {
        var keys = Object.keys(list[i]);
        var flg = true;
        var arr = [];


        for (var j = 0, s = 1; j < keys.length; j++, s++) {
          var value = list[i][keys[j]];
          if (item[keys[j]] !== value) {
            flg = false;

          }

          if (item[keys[j]] == value) {
            arr.push(flg);
          }


        }
        if (flg == true) {
          if (areEqual(arr.length, keys.length, Object.keys(item).length)) {
            return i;
          }

        }


      }
      return -1;
    }
    $scope.getLocations = function (val, type) {
      //MyService.ConsoleLog(val+"<====>"+type);
      if (type == "National") {
        if (val == "National") {

          var nobj = {
            country: "National (USA)"
          }
          $scope.selectedArea.push(nobj);
          //MyService.ConsoleLog($scope.selectedArea);
        }
        if (val == "NO") {

          var nobj = {
            country: "National (USA)"
          }
          var idx = indexOfExt($scope.selectedArea, nobj);
          //var idx = $scope.selectedArea.indexOf(nobj);
          if (idx > -1) {
            $scope.selectedArea.splice(idx, 1);
          }


        }
      } else if (type == "International") {
        MyService.ConsoleLog("val", val);
        if (val == "International") {
          // $scope.selectedArea.length = 0;
          var nobj = {
            country: "International"
          }
          $scope.selectedArea.push(nobj);
          MyService.ConsoleLog("$scope.selectedArea", $scope.selectedArea);

        }

        if (val == "NO") {
          // $scope.selectedArea.length = 0;
          var nobj = {
            country: "International"
          }

          var idx = indexOfExt($scope.selectedArea, nobj);
          //var idx = $scope.selectedArea.indexOf(nobj);
          if (idx > -1) {
            $scope.selectedArea.splice(idx, 1);
          }
        }


      }

    }

    $scope.AddCountry = function () {
      if (($scope.newlocation.country) && ($scope.newlocation.country != '')) {
        var idx = $scope.Allcountries.indexOf($scope.newlocation.country);
        if (idx > -1) {
          var nobj = {
            country: $scope.newlocation.country
          };
          $scope.selectedArea.push(nobj);

        } else {
          alert("Country does not exists in our database. Please check if you have entered correct name.");
        }

      } else {
        alert("Please enter country name");
      }
    }

    $scope.getCounties = function (state) {
      $scope.showLoading.push(state);
      if (!$scope.allCounties[state] || $scope.allCounties[state].length == 0) {

        MyService.getAllCounties(state).then(function (payload) {
            $scope.showLoading.length = 0;
            var sublocations = payload;
            if (!$scope.allCounties) {
              $scope.allCounties = [];
            }
            $scope.allCounties[state] = sublocations;
          },
          function (errorPayload) {
            alert('Something went wrong.');
          });


      } else {
        $scope.showLoading.length = 0;
        $scope.allCounties[state].length = 0;
      }
    }

    $scope.getLocals = function (state, county) {
      $scope.showLoadingCounty.push(county);
      if (!$scope.allLocals[state] || !$scope.allLocals[state][county] || $scope.allLocals[state][county].length == 0) {

        MyService.getAllSubCountiesLocal(state, '', county).then(function (payload) {
            $scope.showLoadingCounty.length = 0;
            MyService.ConsoleLog("payload Locals : ", payload);
            if (!$scope.allLocals[state]) {
              $scope.allLocals[state] = [];
            }
            $scope.allLocals[state][county] = payload.places;
          },
          function (errorPayload) {
            alert('Something went wrong ');
          });


      } else {
        $scope.showLoadingCounty.length = 0;
        $scope.allLocals[state][county].length = 0;
      }
    }

    if (!$rootScope.UserId) {
      $location.path('signin');
    }



    if (window.localStorage.getItem("VoteWiseEssayCategory")) {
      $rootScope.allEssaycategories = JSON.parse(window.localStorage.getItem("VoteWiseEssayCategory"));
      var idx = $rootScope.allEssaycategories.indexOf($routeParams.subcatId);
      if (idx == -1) {
        $rootScope.allEssaycategories.push($routeParams.subcatId);
        window.localStorage.setItem("VoteWiseEssayCategory", JSON.stringify($rootScope.allEssaycategories));
      }
    }

    $scope.showSubCat = true;
    $scope.showLoading = [];
    $scope.showLoadingCounty = [];
    $scope.showDown = [];
    $scope.ChangeShow = function (id) {
      //$scope.showSubCat = true;
      //var cols = document.getElementsByClassName('cmnUL');
      //var clen = cols.length;
      var nclass = "MainCatLi_" + id;
      if ((document.getElementsByClassName(nclass)[0].style.display) && (document.getElementsByClassName(nclass)[0].style.display == "none")) {
        document.getElementsByClassName(nclass)[0].style.display = "block";
      } else {
        document.getElementsByClassName(nclass)[0].style.display = "none";
      }


    }


    $scope.SubmitEssay = function (data) {
      // console.log('Essay data comes', data);


      console.log(' welcome :', $.fn.validateForceFully($("#topicform")));
      console.log(' welcome :', typeof $.fn.validateForceFully($("#topicform")));

      if ($.fn.validateForceFully($("#topicform")) == true) {
        console.log(" if ");
        if ($scope.disabled.length == 0) {
          alert("Please select atleast one Tag");
        } else {
          $scope.EssayButton = true;
          if (data.mediaType == 'Stills') {
            //MyService.ConsoleLog(data.files);
            if (data.files) {
              var fd = new FormData();
              fd.append('file', data.files);
              fd.append("parentcat", $scope.disabled);
              fd.append("subcategories", JSON.stringify($scope.SelectedTree));
              fd.append("createdById", tokenService.getUserId());
              fd.append("createdByName", tokenService.getUserName());
              fd.append("createdByType", tokenService.getUserRole());
              fd.append("title", data.title);
              fd.append("description", data.description);
              fd.append("mediaType", data.mediaType);
              fd.append("location", data.location);
              if ($scope.selectedArea.length > 0) {
                fd.append("locationSpecific", JSON.stringify($scope.selectedArea));
              }
              MyService.ConsoleLog("data", data)


              var udata = $scope.uData;
              var posturl = baseApiUrl + "/essay/create?mediaType=" + data.mediaType;

              $http.post(posturl, fd, {
                  transformRequest: angular.identity,
                  headers: {
                    'Content-Type': undefined
                  },
                  params: {
                    'folderName': udata.uname
                  }
                })
                .success(function (response, status, headers, config) {
                  $scope.EssayButton = true;
                  MyService.ConsoleLog("response : ", response);
                  console.log('response get', response);

                  if (response.success) {
                    $location.path('/essay/home');
                    console.log('redirect $$######');

                  } else {
                    //alert(response.error);
                    if ((response.status) && (response.status == "405")) {
                      var msg = "Do you want to send request to Admin to reactivate your account?.";
                      MyService.GetDialogWithButtons(ngDialog, msg, "YES", "NO").then(function (payload) {
                        MyService.sendActivatationMailtoAdmin().then(function (payload) {
                          alert("Request sent successfully to admin");
                        }, function (errorPayload) {
                          // alert("Something went wrong");
                          growl.error(errorPayload.error);

                        })
                      }, function (errorPayload) {
                        //MyService.ConsoleLog(errorPayload);
                      });
                    }
                  }
                })
                .error(function (response, status, headers, config) {
                  if (response.error) {
                    alert("Error: ", response.error);
                  } else {
                    alert("Something went wrong");
                  }
                });
            } else {
              alert("File is required.");
            }


          } else {
            data.parentcat = $scope.disabled;
            data.subcategories = JSON.stringify($scope.SelectedTree);
            data.createdById = tokenService.getUserId();
            data.createdByName = tokenService.getUserName();
            data.createdByType = tokenService.getUserRole();
            if ($scope.selectedArea.length > 0) {
              data.locationSpecific = JSON.stringify($scope.selectedArea);
            }
            MyService.ConsoleLog("data: ", data);
            // return;
            var request = apiCall.apiCall('POST', '/essay/create?mediaType=' + data.mediaType, data);
            $http(
              request
            ).then(function successCallback(response) {
              MyService.ConsoleLog("Got Essay: ", response);
              if (response.data.success) {
                $scope.pid = response.data['data'].parentCat[0];
                console.log($scope.pid);
                $scope.EssayButton = true;
                if (response.data.success) {
                  $location.path('/essay/' + $scope.pid + '/home');
                  console.log('redirect to essay home');

                } else {
                  alert(response.data.error);
                  if ((response.data.status) && (response.data.status == "405")) {
                    var msg = "Do you want to send request to Admin to reactivate your account?.";
                    MyService.GetDialogWithButtons(ngDialog, msg, "YES", "NO").then(function (payload) {
                      MyService.sendActivatationMailtoAdmin().then(function (payload) {
                        alert("Request sent successfully to admin");
                      }, function (errorPayload) {
                        // alert("Something went wrong");
                        growl.error(errorPayload.error);
                      })
                    }, function (errorPayload) {
                      //MyService.ConsoleLog(errorPayload);
                    });
                  }
                }
              } else {
                growl.error(response.data.error);
              }
            }, function errorCallBack(response) {
              if (response.error) {
                alert("Error: ", response.error);
              } else {
                alert("Something went wrong");
              }

            });
          }

        }


      }
      //       else{
      //         $('html, body').animate({
      //     scrollTop: $("#titleOne").offset().top
      // }, 2000);
      //       }
    }
    $scope.MainGallery = [];
    if ($scope.uData) {
      $scope.GalleryFolder = baseApiUrl + "/resources/" + $scope.uData.uname;
    }
    $scope.loadGallery = function () {
      var nrequest = apiCall.apiCall('GET', '/gallery/get', {
        id: $scope.uData.id
      });
      $http(
        nrequest
      ).then(function successCallback(responseLatest) {
        if (responseLatest.data.success) {
          $scope.MainGallery = responseLatest.data.data;
        }


      }, function errorCallBack(responseLatest) {

        subCategories.returndata = sampledata;
        $scope.subCategories.push(subCategories);
      });
    }

    $scope.Showgallery = function () {
      ngDialog.open({
        template: 'newEssay/dialogGallery.html',
        width: '650px',
        scope: $scope
      });
      $scope.loadGallery();
    }
    $scope.uploadMedia = false;
    $scope.Gallery = false;
    $scope.uploads = {
      files: '',
      path: ''
    }
    $scope.ChangeMedia = function (option) {
      if (option == "G") {
        $scope.uploadMedia = false;
        $scope.Gallery = true;
      } else {
        $scope.Gallery = false;
        $scope.uploadMedia = true;
      }


    }




    $scope.uploadFile = function () {
      var fd = new FormData();
      //Take the first selected file
      var udata = $scope.uData;
      var urole = JSON.parse(tokenService.getUserData());

      $scope.userData = {
        id: udata.id,
        name: udata.name,
        uname: udata.uname,
        utype: tokenService.getUserRole()
      };
      $scope.uploads.files.fieldname = udata.uname;

      fd.append('file', $scope.uploads.files);
      fd.append("user", JSON.stringify($scope.userData));


      var posturl = baseApiUrl + "/gallery/upload";


      $http.post(posturl, fd, {
          transformRequest: angular.identity,
          headers: {
            'Content-Type': undefined
          },
          params: {
            'folderName': udata.uname
          }
        })

        .success(function (response, status, headers, config) {

          if (response.data) {
            $scope.loadGallery();
            $scope.ChangeMedia("G");
          }
        })

        .error(function (data, status, headers, config) {
          //MyService.ConsoleLog("error");
        });




    };

    $scope.ShowPath = false;

    $scope.ShowSelectedPath = function (filePath) {
      $scope.uploads.path = $scope.GalleryFolder + "/" + filePath;
      $scope.ShowPath = true;
    }

    $scope.checkSelected = function () {


      return true;

    }

    $scope.goBack = function () {
      if ($rootScope.allEssaycategories) {
        var len = $rootScope.allEssaycategories.length;
        var type = 'home';
        if (len > 2) {
          type = "subcat";
        }

        $location.path('essay/' + $rootScope.allEssaycategories[len - 2] + '/' + $rootScope.allEssaycategories[len - 1] + "/" + type);

      } else {
        $location.path('essay/' + $routeParams.categoryId + '/home');
      }

    }


    $scope.getVdoScreen = function (text) {
      //MyService.ConsoleLog("------------------------------");
      //MyService.ConsoleLog("text:", text);
      //MyService.ConsoleLog("width: ", tempW);
      //MyService.ConsoleLog("height: ", tempH);
      //MyService.ConsoleLog("------------------------------");
      MyService.ConsoleLog(text);
      var urlRegex = /(http(s?):\/\/[^\s]+)/g;
      var data = text.replace(urlRegex, function (url) {
        var rdata = url;

        var xurl = 'https://api.linkpreview.net/?key=58888df95dcf460b67d461f25c5ce2a26bd15b4c83e8f&q=' + url;
        var hurl = xurl + "&callback=JSON_CALLBACK";
        MyService.ConsoleLog(hurl);
        //var deferred = $q.defer();
        $http.jsonp(hurl)
          .success(function (response) {
            MyService.ConsoleLog(response);
            var data = $sce.trustAsHtml('<br/><a href="' + response.url + '" target="_blank"><h3>' + response.title + '</h3><div style="width:100%; clear:both;"><img src="' + response.image + '" style="width:80%; height:auto; max-width: ' + tempWDefault + '" /></div><div style="width:100%; clear:both;">' + response.description + '</div></a><br/>');
            MyService.ConsoleLog(data);
            return data;
            //deferred.resolve(data);
          });
      });

      //return text;
      //return deferred.promise;
      //MyService.ConsoleLog(data);
      //return $sce.trustAsHtml(data);
    }

    var token = apiCall.getToken();
    if (!token) {
      var message = "Please login first.";

      var modal = ngDialog.openConfirm({
        template: '<p>' + message + '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
        plain: true
      });

      modal.then(function fullfilled(data) {
        //MyService.ConsoleLog("fullfilled: ", data);
        $location.path('signin');
      }, function rejected(data) {
        //MyService.ConsoleLog("rejected: ", data);
        $location.path('signin');
      });
    } else {
      $scope.getAllPress();
      $scope.getAllCountries();
      $scope.getSubcatTree();
      $scope.getAllStates();
      $("form").validationEngine('attach', {
        // focusInvalid: false,
        // invalidHandler: function(form, validator) {
        //   console.log("invalidHandler");
        //   if (!validator.numberOfInvalids())
        //     return;
        //   console.log($(validator.errorList[0].element).offset().top);
        //   $('html, body').animate({ scrollTop: $(validator.errorList[0].element).offset().top + 50 }, 2000);
        // }
        // MyService.ConsoleLog("welcome to validationEngine");
      });
      // $("form").validationEngine('attach',{autoHidePrompt:true,autoHideDelay: 1000,fadeDuration: 200,scrollOffset:200});
    }


  }]);

'use strict';
angular
  .module('myApp.matchOfFollowers', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/matchOfFollowers/:orgId?', {
        templateUrl: 'app/matchOfFollowers/matchOfFollowers.html',
        controller: 'matchOfFollowersCtrl',
      });
    },
  ]).controller('matchOfFollowersCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    '$routeParams',
    '$q',
    'ngDialog',
    '$rootScope',
    'growl',
    'MyService',
    '$anchorScroll',
    '$timeout',
    'tokenService',
    '$cookies',
    'baseApiUrl',
    '$document',
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $q,
      ngDialog,
      $rootScope,
      growl,
      MyService,
      $anchorScroll,
      $timeout,
      tokenService,
      $cookies,
      baseApiUrl,
      $document
    ) {

      /**
       * Get Route param value
       */
      $scope.orgId = $routeParams.orgId;

      $scope.userId = tokenService.getUserId();
      // $cookies.remove('isAlreadyAnswer');
      // $cookies.put('isAlreadyAnswer', true);
      if (window.localStorage.getItem('ansDatas')) {
        $rootScope.resultOfAns = JSON.parse(window.localStorage.getItem('ansDatas'));
      }

      $scope.showcomparison = false;
      $scope.noDataFound = false;


      $scope.traverseBackgrounds = [];
      $scope.currBackgroundIndex = 0;
      $scope.status = {
        questions: 0, //1=loading, 2=loaded, 3=error
        category: 0
      };

      $scope.currentIndex = 0;


      var getCategoryCanceler = $q.defer();
      var prevFetchedCategoryId = null;

      /** 
       * 
       * @description Get front runners records from locaStorage. 
       */


      $scope.frontRunners = JSON.parse(window.localStorage.getItem('frontRunners'));

      /**
       * Get Match
       */
      $scope.getCompMatch = function () {
        // MyService.ConsoleLog(" $scope.orgId", $scope.orgId);
        // MyService.ConsoleLog('$rootScope.resultOfAns >> ', $rootScope.resultOfAns);
        MyService.getFinalGroup({
          poliIds: window.localStorage.getItem('compareData'),
          poliData: JSON.stringify($rootScope.resultOfAns),
        }).then(function (result) {
          MyService.ConsoleLog("Results", result);
          if (result && result.data.data && result.data.data.qdata) {
            $scope.questions = result.data.data.qdata;
            $scope.FBCompareList = result.data.data.qdata;

            if ($scope.FBCompareList && $scope.FBCompareList.length > 0) {
              $scope.FBunWeighted = result.data.data.unweightedMatch;
              $scope.fbcombinedWeight = result.data.data.fbcombinedWeight;
              $scope.fbmultiplier = result.data.data.fbmultiplier;
              $scope.answeredQuestions = result.data.data.answeredQuestions;
              $scope.fbqlen = result.data.data.qlen;
              $scope.AllUsers = result.data.data.AllUsers;
              $scope.orgName = result.data.data.orgName;

              var allkeys = Object.keys($scope.answeredQuestions);
              // MyService.ConsoleLog("check now ", allkeys);
              $scope.isShowAsterix = {};
              $scope.frontRunners.filter(function (itms) {
                if (allkeys.indexOf(itms._id) > -1) {
                  $scope.isShowAsterix[itms._id] = true;
                }
              });
              // $scope.showcomparison = true;
              // MyService.ConsoleLog("$scope.AllUsers ", $scope.AllUsers);
              // MyService.ConsoleLog(" $scope.FBunWeighted", $scope.FBunWeighted);
            }
          } else {
            growl.error(result.data.data.orgName + ' not answered the quiz yet');
          }

          if (JSON.stringify(result.data.data.qlen) == JSON.stringify({})) {
            var message =
              '“Sorry, we couldn’t provide an overall match because you haven’t answered any of the questions in your quiz”';
            var modal = ngDialog.openConfirm({
              template: '<p>' +
                message +
                '</p>\
              <div class="ngdialog-buttons">\
              <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Take Quiz</button>\
                  <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(0)">OK</button>\
                  \
              </div>',
              plain: true,
            });

            modal.then(
              function fullfilled(data) {
                //MyService.ConsoleLog("fullfilled: ", data);
                if (data == 1) {
                  window.localStorage.setItem('isOrg', true);
                  var quzName = window.localStorage.getItem('quizNameNw');
                  $location.path('/followersQuiz/' + quzName + '/' + $scope.userId);
                }
              },
              function rejected(data) {
                //MyService.ConsoleLog("rejected: ", data);
              }
            );
          }

        }, function (err) {
          MyService.ConsoleLog("Error", err);
        });
      };

      $scope.getCompMatch();
      /**
       * Show match details
       */
      $scope.showDetails = function () {
        $scope.showcomparison = true;
      };



      /**
       * Get Category for background
       */


      $scope.getCategory = function (params) {
        try {
          prevFetchedCategoryId = $scope.category._id
        } catch (e) {}
        if (prevFetchedCategoryId != params.id) {
          $routeParams.categoryId = params.id;
          $("html, body").animate({
            scrollTop: 0
          }, "slow");
          getCategoryCanceler.resolve();
          getCategoryCanceler = $q.defer()
          $scope.status.category = 1;

          MyService.getCategories(params, getCategoryCanceler.promise).then(function (response) {
            if (response) {
              if (response.data.success) {
                $scope.category = response.data.data;
                // MyService.ConsoleLog("$scope.category", $scope.category);
                prevFetchedCategoryId = $scope.category._id;
                $scope.status.category = 2;
              } else {
                $scope.status.category = 3;
              }
            } else {
              $scope.status.category = 2;
            }
          }, function (err) {
            ////MyService.ConsoleLog("Error: ", err);
            $scope.status.category = 3;
            ////MyService.ConsoleLog("$scope.status: ", $scope.status.category);
          });
        } else {
          $timeout(function () {
            $location.hash('DisplayQ');
            $anchorScroll();
          }, 500);
        }
      };



      $scope.viewAnsComment = function (ans) {
        if (ans.comment) {
          ngDialog.open({
            template: 'app/popups/show_comment_txt.html',
            controller: 'OldAnswerViewerCtrl',
            data: {
              title: "Comment",
              content: ans.comment
            }
          });
        }
      };


      $scope.rootCatIndex = 0;
      $scope.getRootCategoryIndex = function () {
        if ($routeParams.categoryId == 'all') {
          var len = $rootScope.categories.length;
          for (var i = 0; i < len; i++) {
            if ($routeParams.parentId == $rootScope.categories[i]._id) {
              $scope.rootCatIndex = i;
              ////MyService.ConsoleLog("rootCatIndex : ", $scope.rootCatIndex);
              break;
            }
          }
        }
      };

      var getLevelCategoryCanceler = $q.defer();

      function getLevelCategory(params) {
        getLevelCategoryCanceler.resolve();
        $scope.status.levlCat = 1;
        params.timeout = getLevelCategoryCanceler.promise;
        var request = apiCall.apiCall('GET', '/categories/list-layer', params);
        $http(
            request
          )
          .then(function successCallback(response) {
            ////MyService.ConsoleLog("Got categories: ",response);
            if (response.data.success) {
              $scope.traverseBackgrounds = response.data.data;
              if ($routeParams.selectedCatId) {
                angular.forEach(response.data.data, function (val, key) {
                  if (val._id == $routeParams.selectedCatId) {
                    $scope.currBackgroundIndex = key;
                    $scope.category = val;
                  }
                });
              } else if ($scope.traverseBackgrounds.length > 0) {
                $scope.category = $scope.traverseBackgrounds[0];
              }
              $scope.status.levlCat = 2;
            } else {
              ////MyService.ConsoleLog("Something went wrong: ", response.data);
              $scope.status.levlCat = 3;
            }
          }, function errorCallBack(response) {
            ////MyService.ConsoleLog("Error: ", response);
            $scope.status.levlCat = 3;
          });
      }

      $scope.skipQuestion = function () {
        var skip = function () {
          var tempIndex = $scope.currentIndex + 1;
          if (tempIndex < $scope.questions.length) {
            $scope.currentIndex++;
            if ($routeParams.categoryId && $routeParams.categoryId.indexOf("popular:") == 0) {
              $scope.getCategory({
                id: $scope.questions[$scope.currentIndex].categories[0].cid
              });
            }
          }
          if ((tempIndex == $scope.questions.length) || $scope.questions.length == 0) {
            var tempBackIdx = $scope.currBackgroundIndex + 1;
            if (tempBackIdx < $scope.traverseBackgrounds.length) {
              $scope.currBackgroundIndex++;
              // alert("if");
              $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
            } else {
              $scope.rootCatIndex++;
              $scope.showcomparison = false;
              $scope.noDataFound = false;
              // alert("else");
              window.localStorage.setItem("RootCatIndex", $scope.rootCatIndex);
              window.localStorage.setItem("DisplayCategory", JSON.stringify($scope.category));

              //$location.path("/compare-politician-questions");

            }
          }
          //$scope.currentIndex++;
        };

        skip();
      };

      $scope.prevQuestion = function () {
        ////MyService.ConsoleLog("** prevQuestion **");
        // $timeout(function() {
        //   $location.hash('DisplayQ');
        //   $anchorScroll();
        // }, 1500);
        if ($scope.currentIndex > 0) {
          $scope.currentIndex--;
        } else if ($scope.currentIndex == 0) {
          if ($scope.currBackgroundIndex > 0) {
            $scope.currBackgroundIndex--;
            $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
          } else {
            ////MyService.ConsoleLog("** end of background **");
            if ($scope.rootCatIndex > 0) {
              $scope.rootCatIndex--;
              $location.path("/question-compare-politician/all/" + $rootScope.categories[$scope.rootCatIndex]._id);
            }
          }
        }
      };

      $scope.compareChanged = function (compare_with) {
        // //MyService.ConsoleLog("compare_with :", compare_with);
        var catid = $routeParams.categoryId;
        if ($routeParams.categoryId && $routeParams.categoryId.indexOf("popular:") == 0) {
          var catid = $routeParams.categoryId.split("popular:")[1];
        }

        $location.path('/compare-select/' + compare_with);
      };

      $scope.getComapreClass = function (match, i) {

        if (match >= 100)
          return 'ag-dg1';
        if (match >= 80)
          return 'ag-dg2';
        if (match >= 60)
          return 'ag-dg3';
        if (match >= 40)
          return 'ag-dg4';
        if (match >= 20)
          return 'ag-dg5';
        if (match >= 0)
          return 'ag-dg6';

        return 'ag-dg';
      };




      var current_url = $location.url();
      ////MyService.ConsoleLog("$location.url: ", current_url);

      $scope.state = "question-compare-politician";
      if (!$rootScope.selectedCompareUsers || $rootScope.selectedCompareUsers.length <= 0) {
        //$location.path("/questionHome");

      } else {
        if ($routeParams.categoryId == 'all') {
          ////MyService.ConsoleLog("compare all answers");
          var param = {
            id: $routeParams.parentId,
            questions_counter: 1
          };
          getLevelCategory(param);
          $scope.getRootCategoryIndex();
        } // traverse all questions
        else {
          $scope.questions = $rootScope.compareAnswerList;
          // //MyService.ConsoleLog($scope.questions);
          var catid = $routeParams.categoryId;
          // //MyService.ConsoleLog(catid)
          $scope.getCategory({
            id: catid
          });
        }
      }



      $scope.retainOptions = "";
      $scope.fb = {
        options: "C"
      };

      // $scope.getFiveFacebookPost();

      $scope.$watch('category', function (newValue, oldValue) {
        //MyService.ConsoleLog("** category watch **");
        var current_url = $location.url();
        if (current_url.indexOf("question-tagged") > -1)
          return; //for tagged questions don't again fetch questions

        if (newValue) {
          if (oldValue && oldValue._id == newValue._id) return;

          if (current_url.indexOf("question-compare-politician") > -1) {
            var temp_uids = [];
            angular.forEach($rootScope.selectedCompareUsers, function (val, key) {
              temp_uids.push(val._id);
            });

          }
        }
      });

      $scope.$watch('questions', function (newValue, oldValue) {
        //MyService.ConsoleLog("** questions watch **");
        if (!$scope.questions) {
          $scope.questions = $rootScope.fiveminquestions;
        }
        try {
          if ($scope.questions) {
            var tempCate = $scope.questions[$scope.currentIndex].categories;
            if (angular.isArray(tempCate)) {
              $scope.getCategory({
                id: tempCate[0].cid
              });
            } else {
              $scope.getCategory({
                id: tempCate.cid
              });
            }
          }
          // $scope.initMyAnswer();
        } catch (e) {
          //MyService.ConsoleLog("questions Index Change Ex: ", e)
        }
      });

      $scope.$watch('currentIndex', function (newValue, oldValue) {
        //MyService.ConsoleLog("** currentIndex watch **");
        // console.log("fiveminquestions >> ", $rootScope.fiveminquestions);
        if (!$scope.questions) {
          $scope.questions = $rootScope.fiveminquestions;
        }
        try {
          // //MyService.ConsoleLog("Current question: ", $scope.questions[$scope.currentIndex]);
          if ($scope.questions) {
            var tempCate = $scope.questions[$scope.currentIndex].categories;
            if (angular.isArray(tempCate)) {
              $scope.getCategory({
                id: tempCate[0].cid
              });
            } else {
              $scope.getCategory({
                id: tempCate.cid
              });
            }
          }
          // $scope.initMyAnswer();
        } catch (e) {
          //MyService.ConsoleLog("Current Index Change Ex: ", e)
        }
      });
    }
  ]);

'use strict';
angular.module('myApp.match', ['ngRoute', 'ngDialog'])

.config(['$routeProvider', function($routeProvider) {
  $routeProvider.when('/match/:categoryId', {
    templateUrl: 'app/match/match.html',
    controller: 'matchCtrl'
  });
}])
.controller('matchCtrl', ['$scope','$http','$location','apiCall', '$routeParams', '$q', 'ngDialog', '$rootScope', function ($scope, $http, $location, apiCall, $routeParams, $q, ngDialog, $rootScope) {
	//MyService.ConsoleLog("** matchCtrl ** :",$routeParams);
	
	$scope.currentIndex = 0;
	$rootScope.welcome = false;
	$scope.initializeVariables = function(){
		$scope.importance = null;
		$scope.answer = null;
		$scope.comment = '';
	};
	$scope.initializeVariables();

	
	function getQuestions(params) {
	  var request = apiCall.apiCall('GET', '/questions/list', params);
	  $http(
	    request
	  ).then(function successCallback(response) {
		//MyService.ConsoleLog("Got categories: ",response);
		if(response.data.success){
			$scope.questions = response.data.data;
			//MyService.ConsoleLog("total questions: ", $scope.questions.length);
		}
		else{
			//MyService.ConsoleLog("Something went wrong: ",response.data);
		}
	  }, function errorCallBack(response) {
	    //MyService.ConsoleLog("Error: ",response);
	  });
	}

	function getCategory(params) {
	  var request = apiCall.apiCall('GET', '/categories/list', params);
	  $http(
	    request
	  ).then(function successCallback(response) {
		//MyService.ConsoleLog("Got categories: ",response);
		if(response.data.success){
			$scope.category = response.data.data;
		}
		else{
			//MyService.ConsoleLog("Something went wrong: ",response.data);
		}
	  }, function errorCallBack(response) {
	    //MyService.ConsoleLog("Error: ",response);
	  });
	}

	function getPopularQuestions(){
		var categoryIds = $routeParams.categoryId.split("popular:")[1];

		var request = apiCall.apiCall('GET', '/answers/popular', {"categoryIds": categoryIds});
		$http(
			request
		).then(function successCallback(response) {
			//MyService.ConsoleLog("Got PopularQuestions: ",response);
			if(response.data.success){
				$scope.questions = response.data.data;
			}
			else{
				//MyService.ConsoleLog("Something went wrong: ",response.data);
			}
		}, function errorCallBack(response) {
			//MyService.ConsoleLog("Error: ",response);
		});
	}

	$scope.notAnswerableSelected = function(){
		if($scope.answer == 0){
			var message = 'Many of our Statements have a fact followed by an opinion.  Like “the sky is blue.  I hate the sky.”  If this is your problem with the question, then realize that this is just part of the question process and just respond to the second half.  If not, please explain the problem in the “add comments” section so we can fix it.  Thank you.';
			var modal = ngDialog.openConfirm({
		    	template:'<p>'+message+'</p>\
			            <div class="ngdialog-buttons">\
		                	<button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
			            </div>',
			    plain: true
			});
			
			modal.then(function fullfilled(data){
				//MyService.ConsoleLog("fullfilled: ",data);
			}, function rejected(data){
				//MyService.ConsoleLog("rejected: ",data);
			});
		}
	};

	$scope.postAnswer = function(postData){
		//MyService.ConsoleLog("postData: ",postData);

	    var request = apiCall.apiCall('POST', '/answers/create', postData);
	    $http(
	      request
	    ).then(function successCallback(response) {
	      //MyService.ConsoleLog("succss: ",response);
	      if(response.data.success){
	        alert("Answered successfully");
	        $scope.initializeVariables();
	      }
	      else{
	        alert("Error: "+response.data.error);
	      }
	    }, function errorCallback(response) {
	      $scope.error = 'Wrong Email or Password';
	    });
	    
	};

	$scope.submitAnswer = function(){
		//MyService.ConsoleLog("submitAnswer: "+$scope.answer);
		//MyService.ConsoleLog("importance: "+$scope.importance);
		//MyService.ConsoleLog("comments: ", $scope.comment);

		var token = apiCall.getToken();

		if(!token || token == ""){
			var message = "Please login first.";

			var modal = ngDialog.openConfirm({
		    	template:'<p>'+message+'</p>\
			            <div class="ngdialog-buttons">\
		                	<button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
			            </div>',
			    plain: true
			});
			
			modal.then(function fullfilled(data){
				//MyService.ConsoleLog("fullfilled: ",data);
			}, function rejected(data){
				//MyService.ConsoleLog("rejected: ",data);
			});
			
			return;
		}

		if($scope.answer == null){
			
			var message = "Please select answer first.";

			var modal = ngDialog.openConfirm({
		    	template:'<p>'+message+'</p>\
			            <div class="ngdialog-buttons">\
		                	<button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
			            </div>',
			    plain: true
			});
			
			modal.then(function fullfilled(data){
				//MyService.ConsoleLog("fullfilled: ",data);
			}, function rejected(data){
				//MyService.ConsoleLog("rejected: ",data);
			});
			
			return;
		}

		if($scope.importance == null){
			var message = "You need to choose an importance level.  Should they fight hard for this can they use it to trade for other things you care about more?";

			var modal = ngDialog.openConfirm({
		    	template:'<p>'+message+'</p>\
			            <div class="ngdialog-buttons">\
		                	<button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
			            </div>',
			    plain: true
			});
			
			modal.then(function fullfilled(data){
				//MyService.ConsoleLog("fullfilled: ",data);
			}, function rejected(data){
				//MyService.ConsoleLog("rejected: ",data);
			});

			return;
		}

		/*
		var modal = ngDialog.openConfirm({
		    template:'<p>Are you sure you want to close the parent dialog?</p>\
		              <div class="ngdialog-buttons">\
	                    <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
	                    <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Yes</button>\
		               </div>',
		    plain: true
		});
		//MyService.ConsoleLog("modal: ",modal);
		modal.then(function fullfilled(data){
			//MyService.ConsoleLog("fullfilled: ",data);
		}, function rejected(data){
			//MyService.ConsoleLog("rejected: ",data);
		});
		*/
		var postData = {
			questionId: $scope.questions[$scope.currentIndex]._id,
			importance: $scope.importance,
			answer: $scope.answer,
			comment: $scope.comment,
			token: token
		};
		$scope.postAnswer(postData);
	};

	$scope.skipQuestion = function(){
		var skip = function(){
			var tempIndex = $scope.currentIndex+1;
			if(tempIndex < $scope.questions.length){
				$scope.initializeVariables();
				$scope.currentIndex++;
			}
		};

		if($scope.answer != null){
			var message = 'You just hit the SKIP button.  Are you sure you want to skip this one, or would you rather Submit your answer?';
			var modal = ngDialog.openConfirm({
		    	template:'<p>'+message+'</p>\
			            <div class="ngdialog-buttons">\
		                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Skip</button>\
	                    <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Submit</button>\
			            </div>',
			    plain: true
			});
			
			modal.then(function fullfilled(data){
				//submit answer
				$scope.submitAnswer();
			}, function rejected(data){
				//skip the answer
				skip();
			});
		}
		else{
			skip();
		}
	};

	$scope.prevQuestion = function(){
		if($scope.currentIndex > 0){
			$scope.currentIndex--;
		}
	};

	$scope.reportQuestion = function(){
		//MyService.ConsoleLog("Report questions");
	};

	$scope.compareChanged = function(compare_with){
		//MyService.ConsoleLog("compare_with :",compare_with);
		$location.path('/compare-select/'+compare_with+"/"+$routeParams.categoryId);
	};

	var current_url = $location.url();
	//MyService.ConsoleLog("$location.url: ", current_url);

	if(current_url.indexOf("question-compare") > -1){
		$scope.state = "question-compare";
		if($routeParams.categoryId == 'all'){
			//MyService.ConsoleLog("compare all answers");	
			try{
				var user_ids = []
				angular.forEach($rootScope.selectedCompareUsers, function(val, key){
					user_ids.push(val._id);
				});
				//MyService.ConsoleLog("user_ids: ", user_ids);

				var req = apiCall.apiCall('GET', '/answers/compare', {"userIds": user_ids.join(",")});
				$http(
					req
				).then(function successCallback(response) {
					//MyService.ConsoleLog("Got categories: ",response);
					if(response.data.success){
						$scope.questions = response.data.data;
						//MyService.ConsoleLog("total questions: ", $scope.questions.length);
					}
					else{
						//MyService.ConsoleLog("Something went wrong: ",response.data);
					}
				}, function errorCallBack(response) {
					//MyService.ConsoleLog("Error: ",response);
				});
			}
			catch(e){
				//MyService.ConsoleLog("Exceptoin: ",e);
			}
		} // traverse all questions
		else{
			
			//MyService.ConsoleLog("** question-compare **");
			//MyService.ConsoleLog("compareAnswerList: ", $rootScope.compareAnswerList);
			$scope.questions = $rootScope.compareAnswerList;
			getCategory({id: $routeParams.categoryId});	
		}
	}
	else{
		$scope.state = "question";
		if($routeParams.categoryId && $routeParams.categoryId.indexOf("popular:") == 0){
			getPopularQuestions();
		}
		else{
			getQuestions({categoryId: $routeParams.categoryId});
			getCategory({id: $routeParams.categoryId});
		}
	}
}]);

"use strict";
angular
  .module("myApp.manageQue", ["ngRoute"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/manageQue", {
        templateUrl: "app/manageQuestions/manageQuestions.html",
        controller: "QuestionsCtrl",
      });
    },
  ])
  .controller("QuestionsCtrl", [
    "$scope",
    "$http",
    "$location",
    "apiCall",
    "$rootScope",
    "baseApiUrl",
    "$q",
    "$filter",
    "growl",
    "ngDialog",
    "MyService",
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $rootScope,
      baseApiUrl,
      $q,
      $filter,
      growl,
      ngDialog,
      MyService
    ) {
      //MyService.ConsoleLog(" ** QuestionsCtrl ** ");
      //------------- question --------------
      $scope.getParentCategoriesOne = function () {
        $scope.statusGetCats = 1;
        var request = apiCall.apiCall("GET", "/categories/list", {
          root: 1,
          questions_counter: 0,
          catTypes: "Q",
        });
        $http(request).then(
          function successCallback(response) {
            MyService.ConsoleLog("data :", response);
            $scope.parentCategories = response.data.data;
            if (response.data.success) {
              $scope.selCatForQues = [
                {
                  selected: null,
                  viewOrders: 0,
                  items: $scope.parentCategories,
                },
              ];
              $scope.questions = [];
              $scope.statusGetCats = 2;
            } else {
              growl.error("Something went wrong");
              $scope.statusGetCats = 3;
            }
          },
          function errorCallBack(response) {
            growl.error("Something went wrong");
            $scope.statusGetCats = 3;
          }
        );
      };

      $scope.getParentCategoriesOne();

      $scope.initQuesVar = function () {
        // MyService.ConsoleLog(" $scope.parentCategories :", $scope.parentCategories);
        $scope.question = {
          id: null, //to edit question set this
          content: "",
          categoryIds: [],
          viewOrders: [],
        };
        $scope.selCatForQues = [
          {
            selected: null,
            viewOrders: 0,
            items: $scope.parentCategories,
          },
        ];
        MyService.ConsoleLog("selCatForQues :", $scope.selCatForQues);
        $scope.questions = [];
      };
      $scope.initQuesVar();

      $scope.queFirstLevelCat = [];
      $scope.queSecondLevelCat = [];

      var getQuestoinsCanceler = $q.defer();
      $scope.statusGetQuestoins = 0;
      $scope.getQuestoins = function (cat_id) {
        //MyService.ConsoleLog("cat_id: ", cat_id);
        $scope.questions = [];
        getQuestoinsCanceler.resolve();
        getQuestoinsCanceler = $q.defer();
        removeQeustionCanceler.resolve();
        var params = {};

        if (cat_id) {
          params.categoryId = cat_id;
        }

        if ($rootScope.userRole != "admin") {
          params.authorId = $rootScope.UserId;
        }
        //MyService.ConsoleLog("questionVeriFilter: ", $scope.questionVeriFilter);
        if (
          $scope.questionVeriFilter != null ||
          $scope.questionVeriFilter != undefined
        ) {
          params.approved = $scope.questionVeriFilter;
        }

        if (
          $scope.question.content &&
          !$filter("isBlankString")($scope.question.content)
        ) {
          params.keyword = $scope.question.content;
        }

        //MyService.ConsoleLog("params: ", params);
        $scope.statusGetQuestoins = 1;
        MyService.getQuestions(params, getQuestoinsCanceler.promise).then(
          function (qdata) {
            //MyService.ConsoleLog("*************** questions ***************");
            //MyService.ConsoleLog("qdata: ", qdata);
            if (qdata.data.success) {
              $scope.questions = qdata.data.data;
              $scope.statusGetQuestoins = 2;
            } else {
              $scope.statusGetQuestoins = 3;
            }
          },
          function (err) {
            //MyService.ConsoleLog("Get question error: ", err);
            $scope.statusGetQuestoins = 3;
          }
        );
      };

      $scope.addQuestion = function () {
        var tempCatIds = [],
          tempViewOrders = [];
        angular.forEach($scope.selCatForQues, function (val, key) {
          //MyService.ConsoleLog("key: ",key," val: ",val);
          if (val) {
            // val = JSON.parse(val);
            var selectedVal = JSON.parse(val.selected);
            if (selectedVal && selectedVal._id) {
              tempCatIds[0] = selectedVal._id; //last level cat id
              tempViewOrders[0] = val.viewOrders;
            }
          }
        });
        //MyService.ConsoleLog("tempCatIds: ",tempCatIds);
        //MyService.ConsoleLog("tempViewOrders: ",tempViewOrders);

        var postobj = {
          content: $scope.question.content,
          categoryIds: tempCatIds.join(","),
          viewOrders: tempViewOrders.join(","),
        };
        //MyService.ConsoleLog("postobj: ", postobj);

        var request = apiCall.apiCall("POST", "/questions/create", postobj);
        $http(request).then(
          function successCallback(response) {
            //MyService.ConsoleLog("Got categories: ",response);
            /*if (response.data.success) {
              alert("Added successfully");
              $scope.initQuesVar();
          } else {
              //MyService.ConsoleLog("Something went wrong: ", response.data);
              growl.error('Error: ' + response.data.error);
          }*/
            if (response.data.success) {
              $scope.initVarCat();
              $rootScope.getCategories();
              // $scope.getParentCategories();
              growl.success("Added successfully!");
            } else if (
              response.data.error &&
              typeof response.data.error == "string"
            ) {
              growl.error("Error: " + response.data.error);
            } else {
              growl.error("Something went wrong.");
            }
          },
          function errorCallBack(response) {
            growl.error("Something went wrong.");
          }
        );
      };
      $scope.initVarCat = function () {
        $scope.category = {
          title: "",
          parentIds: [],
          viewOrders: [],
          description: "",
          viewOrder: 0,
          files: null,
          catType: [],
        };
      };
      var removeQeustionCanceler = $q.defer();
      $scope.removeQeustion = function (q, index) {
        //MyService.ConsoleLog("index: ", index, " Q: ", q);

        var message =
          $rootScope.userRole.toLowerCase() == "admin"
            ? "Removing question will remove all it's answers too. Do you want to continue?"
            : "This will remove question if it's not answered. Do you want to continue?";
        var modal = ngDialog.openConfirm({
          template:
            "<p>" +
            message +
            '</p>\
            <div class="ngdialog-buttons">\
                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(1)">OK</button>\
                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Cancel</button>\
            </div>',
          plain: true,
        });
        modal.then(
          function fullfilled(data) {
            //MyService.ConsoleLog("fullfilled: ", data);

            var postobj = {
              id: q._id,
              timeout: removeQeustionCanceler.promise,
            };
            var request = apiCall.apiCall("POST", "/questions/remove", postobj);
            $http(request).then(
              function successCallback(response) {
                if (response.data.success) {
                  growl.success("Removed successfully.");
                  // $rootScope.getCategories();
                  // $scope.getParentCategories();
                  // $scope.initUpdateCat();
                  // $scope.questions.splice(index, 1);
                  var len = $scope.questions.length;
                  for (var i = 0; i < len; i++) {
                    if ($scope.questions[i]._id == postobj.id) {
                      $scope.questions.splice(i, 1);
                      break;
                    }
                  }
                } else if (
                  response.data.error &&
                  typeof response.data.error == "string"
                ) {
                  growl.error("Error: " + response.data.error);
                } else {
                  growl.error("Something went wrong.");
                }
              },
              function errorCallBack(response) {
                growl.error("Something went wrong.");
              }
            );
          },
          function rejected(data) {
            //MyService.ConsoleLog("rejected: ", data);
          }
        );
      };

      $scope.editQeustion = function (q, index) {
        //MyService.ConsoleLog("edit question: ", q);
        // growl.error("Edit not implemented yet.");
        var editModal = ngDialog.open({
          template: "app/popups/edit_question.html",
          controller: "EditQuestionCtrl",
          data: q,
        });
      };

      $scope.verifyThisQues = function (user, index, val) {
        var postobj = {
          id: user._id,
          approve: val,
        };

        //MyService.ConsoleLog("postobj : ", postobj);
        $scope.questions[index].apiApproveStatus = 1;
        MyService.approveQuestion(postobj).then(
          function (response) {
            //MyService.ConsoleLog("Got categories: ", response);
            if (response.data.success) {
              $scope.questions[index].approved = val;
              $scope.questions[index].apiApproveStatus = 2;
            } else if (
              response.data.error &&
              typeof response.data.error == "string"
            ) {
              growl.error("Error: " + response.data.error);
              $scope.questions[index].apiApproveStatus = 3;
            } else {
              growl.error("Something went wrong.");
              $scope.questions[index].apiApproveStatus = 3;
            }
          },
          function (err) {
            growl.error("Something went wrong.");
            $scope.questions[index].apiApproveStatus = 3;
          }
        );
        /*
      var request = apiCall.apiCall('POST', "/questions/approve", postobj);
      $http(
          request
      ).then(function successCallback(response) {

      }, function errorCallBack(response) {
          growl.error('Something went wrong.');
      });
      */
      };

      var selQuesCategoryCanceler = $q.defer();
      $scope.statusSubCat = 0;
      $scope.selQuesCategory = function (cat, index) {
        selQuesCategoryCanceler.resolve();
        cat = JSON.parse(cat);
        //MyService.ConsoleLog("tempFun index: ", index);
        //remove all elements after given index

        $scope.questions = [];
        getQuestoinsCanceler.resolve();
        selQuesCategoryCanceler = $q.defer();

        $scope.selCatForQues.length = index + 1;
        $scope.catId = cat._id;
        var params = {
          questions_counter: 0,
          parentId: cat._id,
          catTypes: "Q",
        };
        var request = apiCall.apiCall("GET", "/categories/list", params);
        request.timeout = selQuesCategoryCanceler.promise;
        $scope.statusSubCat = 1;
        $http(request).then(
          function successCallback(response) {
            //MyService.ConsoleLog("************ in success callback ***************");
            if (response.data.success) {
              //MyService.ConsoleLog("Got subcategory data: ", response.data.data);
              if (response.data.data.length > 0)
                $scope.selCatForQues.push({
                  selected: null,
                  viewOrders: 0,
                  items: response.data.data,
                });
              else if (response.data.data.length == 0) {
                $scope.getQuestoins(cat._id);
              }
              $scope.statusSubCat = 2;
            } else {
              //MyService.ConsoleLog("Something went wrong: ", response.data);
              $scope.statusSubCat = 3;
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
            $scope.statusSubCat = 3;
          }
        );
      };

      $scope.filterQuestions = function (selFilter) {
        if (selFilter == "all") $scope.questionVeriFilter = null;
        else $scope.questionVeriFilter = selFilter;

        var selCatId = null;
        angular.forEach($scope.selCatForQues, function (val, key) {
          if (val.selected) {
            //MyService.ConsoleLog("val: ", val);
            var tCat = JSON.parse(val.selected);
            selCatId = tCat._id;
          }
        });
        $scope.getQuestoins(selCatId);
      };

      /**
       * start call when row started dragging.
       */

      $scope.start = function (event, ui, order, id, ind) {
        MyService.ConsoleLog("current order", order);
        MyService.ConsoleLog("current index", id);
        MyService.ConsoleLog("$index", ind);
        $scope.oldOrder = order;
        $scope.curId = id;
      };

      /**
       * End of start
       */

      /**
       * Drop function called when rows drop from on position to another
       */

      $scope.drop = function (event, ui, order, id, ind) {
        MyService.ConsoleLog("order", order);
        MyService.ConsoleLog("ind", id);
        MyService.ConsoleLog("$index", ind);
        MyService.ConsoleLog("<<<<<<<< catId >>>>>>>>", $scope.catId);

        MyService.updateViewOrder({
          curId: $scope.curId,
          newOrder: order,
          oldOrder: $scope.oldOrder,
          catId: $scope.catId,
        }).then(
          function (response) {
            MyService.ConsoleLog("response", response);
            growl.success(response);
            setTimeout(function () {
              $scope.getQuestoins($scope.catId);
            }, 300);
          },
          function (error) {
            MyService.ConsoleLog("error", error);
          }
        );
      };

      /**
       * End of drop
       */
    },
  ]);

'use strict';

angular
  .module('myApp.manageOrganizationQuestions', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/manageOrganizationQuestions', {
        templateUrl: 'app/manageOrganizationQuestion/manageOrganizationQuestions.html',
        controller: 'manageOrganizationQuestionsCtrl',
      });
    },
  ])
  .controller('manageOrganizationQuestionsCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    '$routeParams',
    '$rootScope',
    'baseApiUrl',
    '$q',
    '$timeout',
    'growl',
    'tokenService',
    '$anchorScroll',
    '$sce',
    'MyService',
    'ngDialog',
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $rootScope,
      baseApiUrl,
      $q,
      $timeout,
      growl,
      tokenService,
      $anchorScroll,
      $sce,
      MyService,
      ngDialog
    ) {
      $scope.disTxt = false;
      //------------- question --------------
      $scope.getParentCategoriesOne = function () {
        $rootScope.subCategory = '';
        $scope.statusGetCats = 1;
        var request = apiCall.apiCall('GET', '/categories/list', {
          root: 1,
          questions_counter: 0,
          catTypes: 'Q',
        });
        $http(request).then(
          function successCallback(response) {
            MyService.ConsoleLog('data :', response);
            $scope.parentCategories = response.data.data;
            if (response.data.success) {
              $scope.selCatForQues = [{
                selected: null,
                viewOrders: 0,
                items: $scope.parentCategories,
              }, ];
              $scope.questions = [];
              $scope.statusGetCats = 2;
            } else {
              growl.error('Something went wrong');
              $scope.statusGetCats = 3;
            }
          },
          function errorCallBack(response) {
            growl.error('Something went wrong');
            $scope.statusGetCats = 3;
          }
        );
      };

      $scope.getParentCategoriesOne();
      var autoFillForQuizName = '';
      $scope.getQuizNames = function () {
        // alert('calle');
        autoFillForQuizName = '';
        MyService.getQuizNames({
          orgId: tokenService.getUserId()
        }).then(
          function (results) {
            MyService.ConsoleLog('Result>>>>>>>>', results);
            $scope.qNames = results;
            autoFillForQuizName = new Fuse(results, {
              shouldSort: true,
              caseSensitive: false,
              threshold: 0.4,
            });
            // MyService.ConsoleLog(" autoFillForQuizName", autoFillForQuizName);
          },
          function (err) {
            MyService.ConsoleLog('Error', err);
          }
        );
      };

      /**
       * Select quizNames
       */
      window.localStorage.removeItem('selectedQuizName');
      $scope.uArr = [];
      $scope.select = function (quiz) {
        MyService.ConsoleLog('quiz', quiz);
        // MyService.ConsoleLog("$scope.uArr one", $scope.uArr);
        if ($scope.uArr.length > 0) {
          // MyService.ConsoleLog('<<<<<<<$scope.uArr>>>>>>>', $scope.uArr.indexOf(quiz));


          if ($scope.uArr.indexOf(quiz) == -1) {
            $scope.uArr.push(quiz);
          } else {
            var idx = $scope.uArr.indexOf(quiz);
            MyService.ConsoleLog('idx', idx);
            $scope.uArr.splice(idx, 1);
          }
          window.localStorage.setItem('selectedQuizName', JSON.stringify($scope.uArr));
          MyService.ConsoleLog(' $scope.uArr', $scope.uArr);
        } else {
          $scope.uArr.push(quiz);
          // MyService.ConsoleLog(' $scope.uArr', $scope.uArr);
          window.localStorage.setItem('selectedQuizName', JSON.stringify($scope.uArr));
        }

        if ($scope.uArr.length > 0) {
          $scope.disTxt = true;
        } else {
          $scope.disTxt = false;
        }
      };

      function highlightCurOff(str, term) {
        MyService.ConsoleLog('str<><><><', str);
        var highlight_regex = new RegExp('(' + term + ')', 'gi');
        return str.replace(highlight_regex, '<span class="highlight">$1</span>');
      }

      /**
       * Filter quiz names
       */
      function autoFillName(term) {
        // alert('preFuzzy_suggest');
        // MyService.ConsoleLog("<<<<<<< term >>>>>>>>>", term);
        if (!term) return [];

        MyService.ConsoleLog('term >>', term);
        MyService.ConsoleLog('autoFillForQuizName', autoFillForQuizName);

        return autoFillForQuizName
          .search(term)
          .slice(0, 10)
          .map(function (i) {
            var val = $scope.qNames[i];
            return {
              value: JSON.stringify(val),
              label: $sce.trustAsHtml(highlightCurOff(val, term)),
            };
          });
      }
      /**
       * End of
       */

      $scope.closeAutoFill = function (col) {
        // alert('call');
        MyService.ConsoleLog('col', col);
        var nval = JSON.parse(col.value);
        $scope.question.quiz = nval;
        MyService.ConsoleLog('nval >>', nval);
        $scope.tempQuiz = nval;
        document.getElementById('quiz').value = $scope.tempQuiz;

        // MyService.ConsoleLog("$scope.question.quiz", $scope.question.quiz);
        document
          .getElementById('autoFillText')
          .getElementsByTagName('input')[0]
          .blur();
      };

      $scope.autoFillOptions = {
        suggest: autoFillName,
        on_select: $scope.closeAutoFill,
      };

      $scope.initQuesVar = function () {
        // MyService.ConsoleLog(" $scope.parentCategories :", $scope.parentCategories);
        $scope.question = {
          id: null, //to edit question set this
          content: '',
          categoryIds: [],
          viewOrders: [],
          quizName: '',
        };
        $scope.selCatForQues = [{
          selected: null,
          viewOrders: 0,
          items: $scope.parentCategories,
        }, ];
        $scope.getQuizNames();
        MyService.ConsoleLog('selCatForQues :', $scope.selCatForQues);
        $scope.questions = [];
      };
      $scope.initQuesVar();

      $scope.queFirstLevelCat = [];
      $scope.queSecondLevelCat = [];

      var getQuestoinsCanceler = $q.defer();
      $scope.statusGetQuestoins = 0;
      $scope.getQuestoins = function (cat_id) {
        //MyService.ConsoleLog("cat_id: ", cat_id);
        $rootScope.parCat = '';
        $scope.questions = [];
        getQuestoinsCanceler.resolve();
        getQuestoinsCanceler = $q.defer();
        removeQeustionCanceler.resolve();
        var params = {};

        if (cat_id) {
          params.categoryId = cat_id;
        }

        $rootScope.parCat = cat_id;
        // alert($rootScope.parCat);
        // if ($rootScope.userRole != "admin") {
        //   params.authorId = $rootScope.UserId;
        // }
        //MyService.ConsoleLog("questionVeriFilter: ", $scope.questionVeriFilter);
        if ($scope.questionVeriFilter != null || $scope.questionVeriFilter != undefined) {
          params.approved = $scope.questionVeriFilter;
        }

        if ($scope.question.content && !$filter('isBlankString')($scope.question.content)) {
          params.keyword = $scope.question.content;
        }

        //MyService.ConsoleLog("params: ", params);
        $scope.statusGetQuestoins = 1;
        MyService.getQuestions(params, getQuestoinsCanceler.promise).then(
          function (qdata) {
            //MyService.ConsoleLog("*************** questions ***************");
            MyService.ConsoleLog('qdata: ', qdata);
            if (qdata.data.success) {
              $scope.questions = qdata.data.data;
              $scope.statusGetQuestoins = 2;
            } else {
              $scope.statusGetQuestoins = 3;
            }
          },
          function (err) {
            //MyService.ConsoleLog("Get question error: ", err);
            $scope.statusGetQuestoins = 3;
          }
        );
      };

      $scope.addQuestion = function () {
        var tempCatIds = [],
          tempViewOrders = [];
        angular.forEach($scope.selCatForQues, function (val, key) {
          //MyService.ConsoleLog("key: ",key," val: ",val);
          if (val) {
            // val = JSON.parse(val);
            var selectedVal = JSON.parse(val.selected);
            if (selectedVal && selectedVal._id) {
              tempCatIds[0] = selectedVal._id; //last level cat id
              tempViewOrders[0] = val.viewOrders;
            }
          }
        });
        //MyService.ConsoleLog("tempCatIds: ",tempCatIds);
        //MyService.ConsoleLog("tempViewOrders: ",tempViewOrders);

        var postobj = {
          content: $scope.question.content,
          categoryIds: tempCatIds.join(','),
          viewOrders: tempViewOrders.join(','),
        };
        //MyService.ConsoleLog("postobj: ", postobj);

        var request = apiCall.apiCall('POST', '/questions/create', postobj);
        $http(request).then(
          function successCallback(response) {
            //MyService.ConsoleLog("Got categories: ",response);
            /*if (response.data.success) {
              alert("Added successfully");
              $scope.initQuesVar();
          } else {
              //MyService.ConsoleLog("Something went wrong: ", response.data);
              growl.error('Error: ' + response.data.error);
          }*/
            if (response.data.success) {
              $scope.initVarCat();
              $rootScope.getCategories();
              $scope.getParentCategories();
              growl.success('Added successfully!');
            } else if (response.data.error && typeof response.data.error == 'string') {
              growl.error('Error: ' + response.data.error);
            } else {
              growl.error('Something went wrong.');
            }
          },
          function errorCallBack(response) {
            growl.error('Something went wrong.');
          }
        );
      };
      $scope.initVarCat = function () {
        $scope.category = {
          title: '',
          parentIds: [],
          viewOrders: [],
          description: '',
          viewOrder: 0,
          files: null,
          catType: [],
        };
      };
      var removeQeustionCanceler = $q.defer();
      $scope.removeQeustion = function (q, index) {
        //MyService.ConsoleLog("index: ", index, " Q: ", q);

        var message =
          $rootScope.userRole.toLowerCase() == 'admin' ?
          "Removing question will remove all it's answers too. Do you want to continue?" :
          "This will remove question if it's not answered. Do you want to continue?";
        var modal = ngDialog.openConfirm({
          template: '<p>' +
            message +
            '</p>\
          <div class="ngdialog-buttons">\
              <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(1)">OK</button>\
              <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Cancel</button>\
          </div>',
          plain: true,
        });
        modal.then(
          function fullfilled(data) {
            //MyService.ConsoleLog("fullfilled: ", data);

            var postobj = {
              id: q._id,
              timeout: removeQeustionCanceler.promise,
            };
            var request = apiCall.apiCall('POST', '/questions/remove', postobj);
            $http(request).then(
              function successCallback(response) {
                if (response.data.success) {
                  growl.success('Removed successfully.');
                  // $rootScope.getCategories();
                  // $scope.getParentCategories();
                  // $scope.initUpdateCat();
                  // $scope.questions.splice(index, 1);
                  var len = $scope.questions.length;
                  for (var i = 0; i < len; i++) {
                    if ($scope.questions[i]._id == postobj.id) {
                      $scope.questions.splice(i, 1);
                      break;
                    }
                  }
                } else if (response.data.error && typeof response.data.error == 'string') {
                  growl.error('Error: ' + response.data.error);
                } else {
                  growl.error('Something went wrong.');
                }
              },
              function errorCallBack(response) {
                growl.error('Something went wrong.');
              }
            );
          },
          function rejected(data) {
            //MyService.ConsoleLog("rejected: ", data);
          }
        );
      };

      $scope.editQeustion = function (q, index) {
        //MyService.ConsoleLog("edit question: ", q);
        // growl.error("Edit not implemented yet.");
        $rootScope.editModal = ngDialog.open({
          template: 'app/popups/editOrgQuestions.html',
          controller: 'AddQuestionCtrl',
          scope: $scope,
          preserveScope: true,
          data: q,
        });
      };

      $scope.verifyThisQues = function (user, index, val) {
        var postobj = {
          id: user._id,
          approve: val,
        };

        //MyService.ConsoleLog("postobj : ", postobj);
        $scope.questions[index].apiApproveStatus = 1;
        MyService.approveQuestion(postobj).then(
          function (response) {
            //MyService.ConsoleLog("Got categories: ", response);
            if (response.data.success) {
              $scope.questions[index].approved = val;
              $scope.questions[index].apiApproveStatus = 2;
            } else if (response.data.error && typeof response.data.error == 'string') {
              growl.error('Error: ' + response.data.error);
              $scope.questions[index].apiApproveStatus = 3;
            } else {
              growl.error('Something went wrong.');
              $scope.questions[index].apiApproveStatus = 3;
            }
          },
          function (err) {
            growl.error('Something went wrong.');
            $scope.questions[index].apiApproveStatus = 3;
          }
        );
        /*
      var request = apiCall.apiCall('POST', "/questions/approve", postobj);
      $http(
          request
      ).then(function successCallback(response) {

      }, function errorCallBack(response) {
          growl.error('Something went wrong.');
      });
      */
      };

      var selQuesCategoryCanceler = $q.defer();
      $scope.statusSubCat = 0;
      $scope.selQuesCategory = function (cat, index) {
        selQuesCategoryCanceler.resolve();
        cat = JSON.parse(cat);
        //MyService.ConsoleLog("tempFun index: ", index);
        //remove all elements after given index
        // $scope.parCat = cat;
        $scope.questions = [];
        getQuestoinsCanceler.resolve();
        selQuesCategoryCanceler = $q.defer();

        $scope.selCatForQues.length = index + 1;

        var params = {
          questions_counter: 0,
          parentId: cat._id,
          catTypes: 'Q',
        };
        var request = apiCall.apiCall('GET', '/categories/list', params);
        request.timeout = selQuesCategoryCanceler.promise;
        $scope.statusSubCat = 1;
        $http(request).then(
          function successCallback(response) {
            //MyService.ConsoleLog("************ in success callback ***************");
            if (response.data.success) {
              MyService.ConsoleLog('Got subcategory data: ', response.data.data);
              MyService.ConsoleLog('cat ', cat);

              if (response.data.data.length == 0) {
                $scope.subCategory = cat;
              }
              MyService.ConsoleLog('$rootScope.subCategory', $scope.subCategory);
              if (response.data.data.length > 0)
                $scope.selCatForQues.push({
                  selected: null,
                  viewOrders: 0,
                  items: response.data.data,
                });
              else if (response.data.data.length == 0) {
                $scope.getQuestoins(cat._id);
              }
              $scope.statusSubCat = 2;
            } else {
              //MyService.ConsoleLog("Something went wrong: ", response.data);
              $scope.statusSubCat = 3;
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
            $scope.statusSubCat = 3;
          }
        );
      };

      $scope.filterQuestions = function (selFilter) {
        if (selFilter == 'all') $scope.questionVeriFilter = null;
        else $scope.questionVeriFilter = selFilter;

        var selCatId = null;
        angular.forEach($scope.selCatForQues, function (val, key) {
          if (val.selected) {
            //MyService.ConsoleLog("val: ", val);
            var tCat = JSON.parse(val.selected);
            selCatId = tCat._id;
          }
        });
        $scope.getQuestoins(selCatId);
      };
    },
  ])
  .controller('AddQuestionCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    '$rootScope',
    'baseApiUrl',
    '$q',
    '$filter',
    'growl',
    'ngDialog',
    'MyService',
    'tokenService',
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $rootScope,
      baseApiUrl,
      $q,
      $filter,
      growl,
      ngDialog,
      MyService,
      tokenService
    ) {
      //MyService.ConsoleLog("* EditQuestionCtrl *", $scope.ngDialogData);
      $scope.userId = tokenService.getUserId();
      MyService.ConsoleLog('$scope.userId', $scope.userId);
      $scope.initQuesVar = function () {
        $scope.question = {
          id: null, //to edit question set this
          content: '',
          categoryIds: [],
          viewOrders: [],
          quizName: '',
        };
        if ($scope.ngDialogData) {
          try {
            MyService.ConsoleLog('$scope.ngDialogData<><><><>', $scope.ngDialogData);
            $scope.question.content = $scope.ngDialogData.content;
            $scope.question.showInMatch = $scope.ngDialogData.showInMatch;
            $scope.question.matchOrder = $scope.ngDialogData.matchOrder;
            MyService.ConsoleLog('question<><><><>', $scope.question);
          } catch (e) {
            //MyService.ConsoleLog("EditQuestion Exception: ", e);
          }
          //MyService.ConsoleLog("$scope.question: ", $scope.question);
        }

        $scope.selCatForQues = [{
          selected: null,
          viewOrders: 0,
          items: $scope.parentCategories,
        }, ];
        $scope.questions = [];
      };
      $scope.initQuesVar();

      $scope.matchType = ['YES', 'NO'];

      $scope.statusGetCats = 0;
      $rootScope.getParentCategories = function () {
        //MyService.ConsoleLog("getParentCategories");
        $scope.statusGetCats = 1;
        var request = apiCall.apiCall('GET', '/categories/list', {
          root: 1,
          questions_counter: 0,
        });
        $http(request).then(
          function successCallback(response) {
            if (response.data.success) {
              $scope.parentCategories = response.data.data;

              $scope.selCatForQues = [{
                selected: null,
                viewOrders: 0,
                items: $scope.parentCategories,
              }, ];
              $scope.statusGetCats = 2;
            } else {
              growl.error('Something went wrong');
              $scope.statusGetCats = 3;
            }
          },
          function errorCallBack(response) {
            growl.error('Something went wrong');
            $scope.statusGetCats = 3;
          }
        );
      };
      $scope.getParentCategories();

      $scope.questionCatChanged = function (selcat) {
        selcat = JSON.parse(selcat);
        $scope.questionSubcategories = [];
        if (selcat._id) {
          var request = apiCall.apiCall('GET', '/categories/list', {
            parentId: selcat._id,
          });
          $http(request).then(
            function successCallback(response) {
              //MyService.ConsoleLog("Got categories: ",response);
              if (response.data.success) {
                $scope.questionSubcategories = response.data.data;
              } else {
                //MyService.ConsoleLog("Something went wrong: ", response.data);
              }
            },
            function errorCallBack(response) {
              //MyService.ConsoleLog("Error: ", response);
            }
          );
        }
      };

      $scope.queFirstLevelCat = [];
      $scope.queSecondLevelCat = [];

      $scope.addQuestion = function () {
        var tempCatIds = [],
          tempViewOrders = [];
        angular.forEach($scope.selCatForQues, function (val, key) {
          //MyService.ConsoleLog("key: ",key," val: ",val);
          if (val) {
            // val = JSON.parse(val);
            var selectedVal = JSON.parse(val.selected);
            if (selectedVal && selectedVal._id) {
              tempCatIds[0] = selectedVal._id; //last level cat id
              tempViewOrders[0] = val.viewOrders;
            }
          }
        });
        // var teome = document.getElementById('quiz');
        // MyService.ConsoleLog("$scope.tempQuiz", $scope.tempQuiz);
        // MyService.ConsoleLog("$scope.question", $scope.question.quiz);

        var tempQName;
        var tempArr = [];
        var isSelect = JSON.parse(window.localStorage.getItem('selectedQuizName'));
        MyService.ConsoleLog("isSelect >>>>>>>", isSelect);

        if (isSelect && isSelect.length > 0) {
          tempQName = isSelect;
        } else {
          tempArr.push($scope.question.quiz);
          tempQName = tempArr;
        }
        MyService.ConsoleLog('tempQName', tempQName);
        MyService.ConsoleLog('tempQName', typeof tempQName);

        var postobj = {
          content: $scope.question.content,
          showInMatch: $scope.question.showInMatch,
          matchOrder: $scope.question.matchOrder,
          advId: $scope.userId,
          quizName: tempQName,
        };
        postobj.categoryIds = $rootScope.parCat;
        if (tempCatIds.length > 0) {
          postobj.categoryIds = $rootScope.parCat.join(',');
          postobj.viewOrders = tempViewOrders.join(',');
        }
        if ($scope.ngDialogData) postobj.id = $scope.ngDialogData._id;
        MyService.ConsoleLog(' $rootScope.parCat', $rootScope.parCat);
        MyService.ConsoleLog('postobj: ', postobj);
        // return;
        if (postobj && postobj.quizName && postobj.quizName != '') {
          MyService.addorgQuestions(postobj).then(
            function (response) {
              MyService.ConsoleLog('response', response);
              window.localStorage.removeItem('selectedQuizName');
              $rootScope.editModal.close();
              growl.success(response.data.data);
              $scope.getQuizNames();
            },
            function (error) {
              MyService.ConsoleLog('error', error);
            }
          );
        } else {
          growl.error("Please enter the quiz name");
        }
      };

      var selQuesCategoryCanceler = $q.defer();
      $scope.selQuesCategory = function (cat, index) {
        selQuesCategoryCanceler.resolve();
        cat = JSON.parse(cat);
        //remove all elements after given index
        selQuesCategoryCanceler.resolve();
        selQuesCategoryCanceler = $q.defer();
        MyService.ConsoleLog('<><><><><><><> cat <><><><><><<><><>', cat);
        $scope.selCatForQues.length = index + 1;
        var params = {
          questions_counter: 0,
          parentId: cat._id,
        };
        var request = apiCall.apiCall('GET', '/categories/list', params);
        request.timeout = selQuesCategoryCanceler.promise;
        $http(request).then(
          function successCallback(response) {
            //MyService.ConsoleLog("************ in success callback ***************");
            if (response.data.success) {
              // MyService.ConsoleLog("Got subcategory data: ", response.data.data);
              if (response.data.data.length > 0)
                $scope.selCatForQues.push({
                  selected: null,
                  viewOrders: 0,
                  items: response.data.data,
                });
            } else {
              //MyService.ConsoleLog("Something went wrong: ", response.data);
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
          }
        );
      };
    },
  ]);

'use strict';
angular.module('myApp.localPress', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
  $routeProvider.when('/localpress', {
    templateUrl: 'app/localPress/localPress.html',
    controller: 'localPressCtrl'
  });
}])

.controller('localPressCtrl', ['$scope','$rootScope','$http','$location','apiCall', function ($scope, $rootScope, $http, $location, apiCall) {
$rootScope.welcome = false;
}]);

'use strict';
angular.module('myApp.localDebate', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
  $routeProvider.when('/localDebate', {
    templateUrl: 'app/localDebate/localDebate.html',
    controller: 'localDebateCtrl'
  });
}])

.controller('localDebateCtrl', ['$scope','$rootScope', '$http','$location','apiCall', function ($scope, $rootScope, $http, $location, apiCall) {
$rootScope.welcome = false;
}]);

"use strict";
angular
  .module("myApp.liveFeed", ["ngRoute"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/liveFeed", {
        templateUrl: "app/liveFeed/liveFeed.html",
        controller: "liveFeedCtrl",
      });
    },
  ])

  .controller("liveFeedCtrl", [
    "$scope",
    "$rootScope",
    "MyService",
    "$http",
    "tokenService",
    "baseApiUrl",
    "$sce",
    "growl",
    function (
      $scope,
      $rootScope,
      MyService,
      $http,
      tokenService,
      baseApiUrl,
      $sce,
      growl
    ) {
      $scope.feed = {
        data: [],
      };
      $scope.showLoading = false;
      $rootScope.welcome = false;
      $scope.favChannel = "associated-press";
      if (tokenService.getUserData()) {
        $scope.userData = JSON.parse(tokenService.getUserData());
        if (
          $scope.userData.my_fav_channel &&
          $scope.userData.my_fav_channel != ""
        ) {
          $scope.favChannel = $scope.userData.my_fav_channel;
        }
      }
      MyService.ConsoleLog("baseApiUrl >> ", baseApiUrl);
      $scope.baseApiUrl = $sce.trustAsResourceUrl(
        baseApiUrl + "/user/getRSSFeeds"
      );
      $scope.title = $scope.favChannel
        .replace(new RegExp("-", "g"), " ")
        .toUpperCase();
      $scope.getAllFeeds = function () {
        $scope.feed.data.length = 0;
        $scope.showLoading = true;

        MyService.getFavNews({ favChannel: $scope.favChannel }).then(
          function (payload) {
            $scope.showLoading = false;
            MyService.ConsoleLog(payload);
            $scope.feed.data = payload;
          },
          function (errorPayload) {
            $scope.showLoading = false;
            alert("Something went wrong");
          }
        );
      };

      $scope.allSource = [];
      $scope.getNewsSources = function () {
        $scope.allSource.length = 0;
        MyService.getNewsSource().then(
          function (payload) {
            $scope.allSource = payload;
            $scope.newsChannel = $scope.favChannel;
          },
          function (errorPayload) {
            growl.error("News services down currently.");
          }
        );
      };

      $scope.changeNewsChannel = function (channel) {
        //alert(channel);
        MyService.saveFavChannel({ channel: channel }).then(
          function (payload) {
            MyService.ConsoleLog(payload);
            $scope.favChannel = channel;
            $scope.userData.my_fav_channel = channel;
            $scope.title = $scope.favChannel
              .replace(new RegExp("-", "g"), " ")
              .toUpperCase();
            tokenService.saveUserData(JSON.stringify($scope.userData));
            $scope.getAllFeeds();
            //growl.success("Your favorite channel saved successfully.");
          },
          function (errorPayload) {
            growl.error("Something went wrong while saving the favorites.");
          }
        );
      };

      $scope.getAllFeeds();
      $scope.getNewsSources();
    },
  ]);

'use strict';
angular
  .module('myApp.listOfFollowers', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/listOfFollowers/:quizName?/:poliId?', {
        templateUrl: 'app/listOfInvitedFollowers/listOfFollowers.html',
        controller: 'listOfFollowersCtrl',
      });
    },
  ])
  .controller('listOfFollowersCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    '$routeParams',
    '$q',
    'ngDialog',
    '$rootScope',
    'growl',
    'MyService',
    '$anchorScroll',
    '$timeout',
    'tokenService',
    '$cookies',
    'baseApiUrl',
    '$document',
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $q,
      ngDialog,
      $rootScope,
      growl,
      MyService,
      $anchorScroll,
      $timeout,
      tokenService,
      $cookies,
      baseApiUrl,
      $document
    ) {

      /**
       * Get params from the route params
       */
      $scope.quizName = $routeParams.quizName;
      $scope.poliId = $routeParams.poliId;

      /**
       *  Declartion
       */
      $scope.fArr = [];

      /**
       * Remove localstorage values on page load
       */
      window.localStorage.removeItem('compareData');
      window.localStorage.removeItem('quizNameNw');
      window.localStorage.setItem('quizNameNw', $scope.quizName);


      /**
       * Get invited politicians info
       */
      $scope.getInfo = function () {

        MyService.getInfoOfInvited({
          orgId: tokenService.getUserId(),
          quizName: $scope.quizName
        }).then(
          function (result) {
            MyService.ConsoleLog("Results", result);
            $scope.polData = result.data.data;
            $scope.polData.filter(function (itms) {
              if (itms.id == $scope.poliId) {
                itms.isSelected = true;
                if ($scope.fArr.indexOf(itms.id) == -1) {
                  $scope.fArr.push(itms.id);
                }
                return itms;
              } else {
                return itms;
              }
            });
          },
          function (err) {
            MyService.ConsoleLog("Error", err);
          })
      };

      $scope.getInfo();

      /**
       * Filter Data
       */

      // $scope.getItems = function () {
      //   return function (u) {
      //     if (u.id == $scope.poliId) {

      //       u.isSelected = true;
      //       if ($scope.fArr.length == 0) {
      //         MyService.ConsoleLog("$scope.fArr fill", $scope.fArr);
      //       } else {
      //         MyService.ConsoleLog("$scope.fArr fill else", $scope.fArr);
      //       }

      //       // if ($scope.fArr.indexOf(u.id) == -1) {
      //       //   $scope.fArr.push(u.id);
      //       // }
      //       return u;
      //     } else {
      //       return u;
      //     }
      //   };
      // };

      /**
       * Select Individuals
       */
      $scope.select = function (uid, qName, name, val) {
        var obj = {};
        MyService.ConsoleLog(" $scope.fArr", $scope.fArr);
        if ($scope.fArr.length > 0) {

          if ($scope.fArr.indexOf(uid) == -1) {
            $scope.fArr.push(uid);
          } else {
            var idx = $scope.fArr.indexOf(uid);
            MyService.ConsoleLog("idx", idx);
            $scope.fArr.splice(idx, 1);
            val.isSelected = false;
          }
        } else {
          $scope.fArr.push(uid);
        }
        MyService.ConsoleLog(' $scope.farr', $scope.fArr);
        if ($scope.fArr.length == $scope.polData.length) {
          $scope.isSelected = true;
        } else {
          $scope.isSelected = false;
        }
      };

      /**
       * Select all the followers
       */

      $scope.isSelected = false;

      $scope.SelectChecks = function () {

        if ($scope.isSelected == false) {
          $scope.isSelected = true;
          angular.forEach($scope.polData, function (val, key) {
            val.isSelected = true;
            if ($scope.fArr.indexOf(val.id) == -1) {
              $scope.fArr.push(val.id);
            }
          });
          MyService.ConsoleLog('  $scope.fArr', $scope.fArr);
        } else {
          $scope.isSelected = false;
          angular.forEach($scope.polData, function (val, key) {
            val.isSelected = false;
            $scope.fArr = [];
            $scope.selectedQuestions = 0;
          });
        }
      };

      /**
       * Compare all records
       */
      $scope.compare = function () {

        if ($scope.fArr && $scope.fArr.length > 0) {
          MyService.ConsoleLog("$scope.fArr", $scope.fArr);
          window.localStorage.setItem('compareData', JSON.stringify($scope.fArr));
          $location.path('/poliCompare/' + $scope.quizName + '/' + $scope.poliId);
        } else {
          growl.error("Please select at least one politician");
        }
      };

      /**
       * Select type
       */
      $scope.selectType = function () {
        MyService.ConsoleLog("types", $scope.types);
        if ($scope.types == 'All') {
          $scope.getInfo();
        } else {
          MyService.getSeletedTypes({
            type: $scope.types,
            orgId: tokenService.getUserId(),
            quizName: $scope.quizName
          }).then(function (response) {
            MyService.ConsoleLog("Response", response);
            $scope.polData = null;
            $scope.polData = response.data.data;
          }, function (err) {
            MyService.ConsoleLog("Error", err);
          });
        }
      };
    }
  ]);

'use strict';
angular.module('myApp.legislation', ['ngRoute'])

  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/legislation', {
      templateUrl: 'app/legislation/legislation.html',
      controller: 'legislationCtrl'
    });
  }])
  .controller('legislationCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService) {

  }]);

'use strict';
angular.module('myApp.learnHome', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
  $routeProvider.when('/learnHome', {
    templateUrl: 'app/learnHome/learnHome.html',
    controller: 'learnHomeCtrl'
  }),
  $routeProvider.when('/catsel-press-essay', {
    templateUrl: 'app/learnHome/cat_sel_press_essay.html',
    controller: 'CatSelPressEssayCtrl'
  }),
  $routeProvider.when('/wheretovote', {
    templateUrl: 'app/learnHome/WhereToVote.html'
  }),
  $routeProvider.when('/wheretogetnews', {
    templateUrl: 'app/learnHome/WhereToGetNews.html'
  }),
  $routeProvider.when('/fakenews', {
    templateUrl: 'app/learnHome/FakeNews.html'
  }),
  $routeProvider.when('/factchecking', {
    templateUrl: 'app/learnHome/FactChecking.html'
  }),
  $routeProvider.when('/politicalDictionary', {
    templateUrl: 'app/learnHome/PoliticalDictionary.html'
  }),
  $routeProvider.when('/basicsofpolitics', {
    templateUrl: 'app/learnHome/basicsofpolitics.html'
  }),
  $routeProvider.when('/aboutus', {
    templateUrl: 'app/learnHome/AboutUs.html'
  });
  $routeProvider.when('/boardsofelections', {
    templateUrl: 'app/boardsofelections/boardsofelections.html'
  });
}])

.controller('learnHomeCtrl', ['$scope','$rootScope', '$http','$location','apiCall', 'baseApiUrl', 'MyService', 'growl', function ($scope, $rootScope, $http, $location, apiCall, baseApiUrl, MyService, growl) {
//MyService.ConsoleLog("LearnHome called");
  $scope.imgUrl = baseApiUrl+"/resources";
$rootScope.welcome = false;
  $scope.statusGetEssayCat = 0;
  function getCategories(params) {
    /*var request = apiCall.apiCall('GET', '/categories/list', {root: 1});
    $http(
      request
    ).then(function successCallback(response) {
    //MyService.ConsoleLog("Got categories: ",response);
      if(response.data.success){
        $scope.categories = response.data.data;
      }
      else{
        //MyService.ConsoleLog("Something went wrong: ",response.data);
      }
    }, function errorCallBack(response) {
      //MyService.ConsoleLog("Error: ",response);
    });*/
    $scope.categories = [];
    $scope.statusGetEssayCat = 1;
    
    MyService.getCategories({root: 1, catTypes: "E"}, null).then(function(response){
      //MyService.ConsoleLog(response);
      if(response.data.success){
        $scope.categories = response.data.data;
        $scope.statusGetEssayCat = 2;
      }
      else{
        //MyService.ConsoleLog("Error: ",response.error);
        growl.error("Something went wrong: ");
        $scope.statusGetEssayCat = 3;
      }
    }, function(){
      growl.error("Something went wrong while fetching categories.");
      $scope.statusGetEssayCat = 3;
    });
  }
  getCategories();
}])
.controller('CatSelPressEssayCtrl', ['$scope','$rootScope', '$http','$location','apiCall', 'baseApiUrl', function ($scope, $rootScope, $http, $location, apiCall, baseApiUrl) {
  //MyService.ConsoleLog("CatSelPressEssayCtrl called");
  $scope.imgUrl = baseApiUrl+"/resources";
  $rootScope.welcome = false;
  function getCategories(params) {
    var request = apiCall.apiCall('GET', '/categories/list', {root: 1});
    $http(
      request
    ).then(function successCallback(response) {
    //MyService.ConsoleLog("Got categories: ",response);
    if(response.data.success){
      $scope.categories = response.data.data;
    }
    else{
      //MyService.ConsoleLog("Something went wrong: ",response.data);
    }
    }, function errorCallBack(response) {
      //MyService.ConsoleLog("Error: ",response);
    });
  }
  getCategories();
}]);


'use strict';
angular
  .module('myApp.invitePoliticians', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/invitePoliticians/:quizName?', {
        templateUrl: 'app/invitePoliticians/invitePoliticians.html',
        controller: 'invitePoliCtrl',
      });
    },
  ])
  .controller('invitePoliCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    '$routeParams',
    '$rootScope',
    '$q',
    '$timeout',
    'tokenService',
    'MyService',
    'growl',
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $rootScope,
      $q,
      $timeout,
      tokenService,
      MyService,
      growl
    ) {
      $scope.quizName = $routeParams.quizName;
      /**
       * User Object
       */
      $scope.User = {
        name: '',
      };
      /**
       * search politician for invite them
       */
      $scope.searchPoli = function () {
        MyService.ConsoleLog('$scope.user', $scope.User.name);
        MyService.searchPoli({
          name: $scope.User.name,
        }).then(
          function (response) {
            MyService.ConsoleLog('response', response);
            $scope.poliData = response.data.data;
          },
          function (err) {
            MyService.ConsoleLog('err', err);
          }
        );
      };

      /**
       * Select Politician
       */
      $scope.uArr = [];
      $scope.select = function (uid) {
        if ($scope.uArr.length > 0) {
          if ($scope.uArr.indexOf(uid) == -1) {
            $scope.uArr.push(uid);
          } else {
            var idx = $scope.uArr.indexOf(uid);
            MyService.ConsoleLog('idx', idx);
            $scope.uArr.splice(idx, 1);
          }
        } else {
          $scope.uArr.push(uid);
        }
        // MyService.ConsoleLog(' $scope.uArr', $scope.uArr);
      };

      /**
       * Select and deselect All Politicians
       */
      $scope.isSelected = false;

      $scope.SelectChecks = function () {
        //alert($scope.isSelected);
        if ($scope.isSelected == false) {
          $scope.isSelected = true;
          angular.forEach($scope.poliData, function (val, key) {
            val.isSelected = true;
            $scope.uArr.push(val._id);
            // MyService.ConsoleLog(' $scope.uArr inall', $scope.uArr);
          });
        } else {
          $scope.isSelected = false;
          angular.forEach($scope.poliData, function (val, key) {
            val.isSelected = false;
            $scope.uArr = [];
            // MyService.ConsoleLog(' else', $scope.uArr);
          });
        }
        //$scope.isSelected = true;
      };

      /**
       * Send Invitation to select politicians
       */
      $scope.sendInvitation = function (ele) {
        var pObj = {};
        if (ele && ele != '') {
          pObj.uId = ele;
          pObj.quizName = $scope.quizName;
          pObj.advId = tokenService.getUserId();
        } else {
          pObj.uId = $scope.uArr;
          pObj.quizName = $scope.quizName;
          pObj.advId = tokenService.getUserId();
        }
        var quizLink =
          window.location.origin + '#!/organizationQuiz/' + $scope.quizName + '/' + pObj.advId;
        pObj.quizLink = quizLink;
        MyService.ConsoleLog('pObj', quizLink);
        MyService.ConsoleLog('pObj', window.location.origin);
        // $location.path('/organizationQuiz/' + $scope.quizName + '/' + pObj.advId);
        MyService.sendQuizInvitation(pObj).then(
          function (result) {
            if (result.data.success) {
              MyService.ConsoleLog('Result', result);
              growl.success(result.data.data);
            } else {
              growl.error(result.data.error);
            }

          },
          function (err) {
            MyService.ConsoleLog('Error', err);
          }
        );
      };
    },
  ]);

"use strict";
angular
  .module("myApp.incumbentPolitician", ["ngRoute"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/incumbent_politician/:user_type", {
        templateUrl: "app/incumbent_politician/incumbent_politician.html",
        controller: "incumbentPoliticianCtrl",
      });
    },
  ])
  .controller("incumbentPoliticianCtrl", [
    "$scope",
    "$http",
    "$location",
    "apiCall",
    "$routeParams",
    "$rootScope",
    "$filter",
    "MyService",
    "ngDialog",
    "growl",
    "tokenService",
    "$sce",
    "$cookies",
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $rootScope,
      $filter,
      MyService,
      ngDialog,
      growl,
      tokenService,
      $sce,
      $cookies
    ) {
      // MyService.ConsoleLog("** compareSelectCtrl **", $routeParams);
      $rootScope.welcome = false;
      $scope.Address = false;
      $scope.Zip = true;
      $scope.Link = true;
      $scope.showAlert = false;
      $cookies.remove("elecDateForRate");
      if (tokenService.getUserId() && tokenService.getUserId() != "") {
        $rootScope.tempUserAddress = "";
        $rootScope.incuAdd = "";
      }

      $scope.usertype = $routeParams.user_type;
      $scope.search = {
        searchFilter: "",
      };
      $scope.searchUsers = [];
      $scope.searchUsersByType = [];
      $scope.sortype = "local";
      $scope.oldaddress = {
        state: "",
        county: "",
        countySubdivision: "",
        place: "",
      };

      $scope.address = {
        state: "",
        county: "",
        countySubdivision: "",
        place: "",
      };
      $scope.User = {
        Address: "",
      };

      // if (!tokenService.getUserId()) {
      //   alert('called');
      //   if ($rootScope.FinalData) {
      //     var samp = JSON.parse($rootScope.FinalData);
      //   }
      // }

      $scope.pop = true;

      function getCategories(params) {
        var request = apiCall.apiCall("GET", "/categories/list", {
          root: 1,
        });
        $http(request).then(
          function successCallback(response) {
            //MyService.ConsoleLog("Got categories: ",response);
            if (response.data.success) {
              $scope.categories = response.data.data;
            } else {
              //MyService.ConsoleLog("Something went wrong: ", response.data);
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
          }
        );
      }
      //getCategories();

      $scope.setAllSelected = function (users) {
        angular.forEach(users, function (val, key) {
          if (val.registeredUser) $scope.selectedUser.push(val);
        });
      };
      $scope.searchUsersByType = [];
      $scope.searchUsers = angular.copy($scope.users);
      $scope.displayTab = [];
      $scope.getByType = function (type) {
        // MyService.ConsoleLog("type : " + type);

        $scope.sortype = type;
        $scope.searchUsersByType.length = 0;
        var len = $scope.searchUsers.length;
        if (len > 0) {
          for (var i = 0; i < len; i++) {
            if ($scope.searchUsers[i].voterScope) {
              // MyService.ConsoleLog("i : " + i + " ----- voterscope : ", $scope.searchUsers[i]);

              if (
                type == "local" &&
                ($scope.searchUsers[i].voterScope == "placeName" ||
                  $scope.searchUsers[i].voterScope == "countySubdivisionName" ||
                  $scope.searchUsers[i].voterScope ==
                    "unifiedSchoolDistrictName" ||
                  $scope.searchUsers[i].voterScope ==
                    "elementarySchoolDistrictName" ||
                  $scope.searchUsers[i].voterScope ==
                    "secondarySchoolDistrictName")
              ) {
                if ($scope.displayTab.indexOf("Local") == -1) {
                  $scope.displayTab.push("Local");
                }
                MyService.ConsoleLog("office >>", $scope.searchUsers[i].office);
                $scope.searchUsers[i].office =
                  $scope.searchUsers[i].office.toLowerCase();
                if (typeof $scope.searchUsers[i].party == "string") {
                  // alert('one');
                  $scope.searchUsers[i].party = $scope.searchUsers[i].party;
                } else {
                  var partyl = "";
                  $scope.searchUsers[i].party.forEach(function (
                    element,
                    index
                  ) {
                    if (element && element != "") {
                      partyl += element + ", ";
                      var n = partyl.lastIndexOf(",");
                      var a = partyl.substring(0, n);
                      // MyService.ConsoleLog("Element", party);
                      $scope.searchUsers[i].party = a;
                    }
                  });
                }
                $scope.searchUsersByType.push($scope.searchUsers[i]);
              } else if (
                type == "county" &&
                ($scope.searchUsers[i].voterScope == "countyName" ||
                  $scope.searchUsers[i].voterScope == "county")
              ) {
                if ($scope.displayTab.indexOf("County") == -1) {
                  $scope.displayTab.push("County");
                }
                $scope.searchUsers[i].office =
                  $scope.searchUsers[i].office.toLowerCase();
                if (typeof $scope.searchUsers[i].party == "string") {
                  // alert('one');
                  $scope.searchUsers[i].party = $scope.searchUsers[i].party;
                } else {
                  var partyc = "";
                  $scope.searchUsers[i].party.forEach(function (
                    element,
                    index
                  ) {
                    if (element) {
                      partyc += element + ", ";
                      var n = partyc.lastIndexOf(",");
                      var a = partyc.substring(0, n);
                      // MyService.ConsoleLog("Element", party);
                      $scope.searchUsers[i].party = a;
                    }
                  });
                }
                $scope.searchUsersByType.push($scope.searchUsers[i]);
              } else if (
                type == "state" &&
                ($scope.searchUsers[i].OfficeTypeId == "G" ||
                  $scope.searchUsers[i].OfficeTypeId == "S" ||
                  $scope.searchUsers[i].OfficeTypeId == "K" ||
                  $scope.searchUsers[i].OfficeTypeId == "L")
              ) {
                if ($scope.displayTab.indexOf("State") == -1) {
                  $scope.displayTab.push("State");
                }
                $scope.searchUsers[i].office =
                  $scope.searchUsers[i].office.toLowerCase();
                if (typeof $scope.searchUsers[i].party == "string") {
                  // alert('one');
                  $scope.searchUsers[i].party = $scope.searchUsers[i].party;
                } else {
                  var partys = "";
                  $scope.searchUsers[i].party.forEach(function (
                    element,
                    index
                  ) {
                    if (element) {
                      partys += element + ", ";
                      // MyService.ConsoleLog("Element", party);
                      var n = partys.lastIndexOf(",");
                      var a = partys.substring(0, n);
                      $scope.searchUsers[i].party = a;
                    }
                  });
                }
                $scope.searchUsersByType.push($scope.searchUsers[i]);
                /*
              if (
                $scope.searchUsers[i].office &&
                $scope.searchUsers[i].voterScope == "statePostalCode"
              ) {
                if (
                  $scope.searchUsers[i].office != "unitedStatesSenate" &&
                  $scope.searchUsers[i].office != "United States Senate"
                ) {
                  $scope.searchUsersByType.push($scope.searchUsers[i]);
                } //else {
                //$scope.searchUsersByType.push($scope.searchUsers[i]);
                //}
              } else {
                $scope.searchUsersByType.push($scope.searchUsers[i]);
              }
              */
                // MyService.ConsoleLog("$scope.searchUsers[i] >>", $scope.searchUsers[i]);
              } else if (
                type == "federal" &&
                ($scope.searchUsers[i].OfficeTypeId == "P" ||
                  $scope.searchUsers[i].OfficeTypeId == "C" ||
                  $scope.searchUsers[i].OfficeTypeId == "J" ||
                  $scope.searchUsers[i].voterScope ==
                    "federalCongressionalDistrict" ||
                  ($scope.searchUsers[i].office != "" &&
                    $scope.searchUsers[i].office.toLowerCase() ==
                      "u.s. senate") ||
                  $scope.searchUsers[i].office == "president" ||
                  ($scope.searchUsers[i].office == "President" &&
                    $scope.searchUsers[i].politicianInfo[0].levelOfGov ==
                      "All USA"))
              ) {
                if ($scope.displayTab.indexOf("Federal") == -1) {
                  $scope.displayTab.push("Federal");
                }
                $scope.searchUsers[i].office =
                  $scope.searchUsers[i].office.toLowerCase();
                // MyService.ConsoleLog("typeof $scope.searchUsers[i].party", typeof $scope.searchUsers[i].party);
                // MyService.ConsoleLog("party", $scope.searchUsers[i].party);
                if (typeof $scope.searchUsers[i].party == "string") {
                  // alert('one');
                  $scope.searchUsers[i].party = $scope.searchUsers[i].party;
                } else {
                  var party = "";
                  $scope.searchUsers[i].party.forEach(function (
                    element,
                    index
                  ) {
                    if (element) {
                      party += element + ", ";
                      // MyService.ConsoleLog("Element", party);
                      var n = party.lastIndexOf(",");
                      var a = party.substring(0, n);
                      $scope.searchUsers[i].party = a;
                    }
                  });
                }
                $scope.searchUsersByType.push($scope.searchUsers[i]);
                /*
              if (
                $scope.searchUsers[i].office &&
                $scope.searchUsers[i].voterScope == "statePostalCode"
              ) {
                if (
                  $scope.federalCongrassionalDist.searchUsers[i].office == "unitedStatesSenate" ||
                  $scope.searchUsers[i].office == "United States Senate"
                ) {
                  $scope.searchUsersByType.push($scope.searchUsers[i]);
                } //else {
                //$scope.searchUsersByType.push($scope.searchUsers[i]);
                //}
              } else {
                $scope.searchUsersByType.push($scope.searchUsers[i]);
              }
              */
              } else if (
                type == "other" &&
                $scope.searchUsers[i].voterScope == "All USA" &&
                $scope.searchUsers[i].OfficeTypeId != "P" &&
                $scope.searchUsers[i].OfficeTypeId != "C" &&
                $scope.searchUsers[i].OfficeTypeId != "M" &&
                $scope.searchUsers[i].OfficeTypeId != "G"
              ) {
                MyService.ConsoleLog(
                  " $scope.searchUsers[i].office new",
                  $scope.searchUsers[i]
                );

                if ($scope.searchUsers[i].winDetails.length > 0) {
                  // MyService.ConsoleLog(" $scope.searchUsers[i].office", $scope.searchUsers[i]);
                  if (
                    $scope.searchUsers[i].winDetails[0].office != "president"
                  ) {
                    $scope.searchUsers[i].office =
                      $scope.searchUsers[i].winDetails[0].office.toLowerCase();
                  }
                } else {
                  // MyService.ConsoleLog(" $scope.searchUsers[i].office", $scope.searchUsers[i]);
                  if ($scope.searchUsers[i].office != "president") {
                    $scope.searchUsers[i].office =
                      $scope.searchUsers[i].office.toLowerCase();
                  }
                }

                $scope.searchUsersByType.push($scope.searchUsers[i]);
              }
            } else {
              // MyService.ConsoleLog("no voterScope", $scope.searchUsers[i]);

              var polInfoLen = $scope.searchUsers[i].politicianInfo.length;

              for (var j = 0; j < polInfoLen; j++) {
                // MyService.ConsoleLog("$scope.searchUsers[i].politicianInfo[j].runningForOffice", $scope.searchUsers[i].politicianInfo[j].runningForOffice);
                if (
                  $scope.searchUsers[i].politicianInfo[j].runningForOffice ==
                    "N" &&
                  $scope.searchUsers[i].politicianInfo[j].candidateStatus ==
                    "active"
                ) {
                  if (
                    $scope.searchUsers[i].running_for &&
                    $scope.searchUsers[i].running_for.levelOfGov &&
                    $scope.searchUsers[i].running_for.levelOfGov != ""
                  ) {
                    if (
                      type == "local" &&
                      ($scope.searchUsers[i].running_for.levelOfGov ==
                        "placeName" ||
                        $scope.searchUsers[i].running_for.levelOfGov ==
                          "countySubDivisionName" ||
                        $scope.searchUsers[i].running_for.levelOfGov ==
                          "unifiedSchoolDistrictName" ||
                        $scope.searchUsers[i].running_for.levelOfGov ==
                          "elementarySchoolDistrictName" ||
                        $scope.searchUsers[i].running_for.levelOfGov ==
                          "secondarySchoolDistrictName")
                    ) {
                      if ($scope.displayTab.indexOf("Local") == -1) {
                        $scope.displayTab.push("Local");
                      }
                      if ($scope.displayTab.indexOf("Federal") == -1) {
                        $scope.displayTab.push("Federal");
                      }
                      $scope.searchUsers[i].office =
                        $scope.searchUsers[i].office.toLowerCase();
                      if (typeof $scope.searchUsers[i].party == "string") {
                        // alert('one');
                        $scope.searchUsers[i].party =
                          $scope.searchUsers[i].party;
                      } else {
                        var party = "";
                        $scope.searchUsers[i].party.forEach(function (
                          element,
                          index
                        ) {
                          if (element) {
                            party += element + ", ";
                            var n = party.lastIndexOf(",");
                            var a = party.substring(0, n);
                            MyService.ConsoleLog("a", a);

                            $scope.searchUsers[i].party = a;
                          }
                        });
                      }
                      $scope.searchUsersByType.push($scope.searchUsers[i]);
                    } else if (
                      type == "county" &&
                      ($scope.searchUsers[i].running_for.levelOfGov ==
                        "countyName" ||
                        $scope.searchUsers[i].running_for.levelOfGov ==
                          "county")
                    ) {
                      if ($scope.displayTab.indexOf("County") == -1) {
                        $scope.displayTab.push("County");
                      }
                      $scope.searchUsers[i].office =
                        $scope.searchUsers[i].office.toLowerCase();
                      if (typeof $scope.searchUsers[i].party == "string") {
                        // alert('one');
                        $scope.searchUsers[i].party =
                          $scope.searchUsers[i].party;
                      } else {
                        var party = "";
                        $scope.searchUsers[i].party.forEach(function (
                          element,
                          index
                        ) {
                          if (element) {
                            party += element + ", ";
                            MyService.ConsoleLog("Element", party);
                            $scope.searchUsers[i].party = party;
                          }
                        });
                      }
                      $scope.searchUsersByType.push($scope.searchUsers[i]);
                    } else if (
                      type == "state" &&
                      ($scope.searchUsers[i].electionOfficeTypeId == "G" ||
                        $scope.searchUsers[i].electionOfficeTypeId == "S" ||
                        $scope.searchUsers[i].electionOfficeTypeId == "K" ||
                        ($scope.searchUsers[i].electionOfficeTypeId == "L" &&
                          $scope.searchUsers[i].politicianInfo[0].levelOfGov !=
                            "countyName") ||
                        $scope.searchUsers[i].politicianInfo[0].levelOfGov ==
                          "stateSenateDistrict" ||
                        ($scope.searchUsers[i].politicianInfo[0].levelOfGov ==
                          "statePostalCode" &&
                          $scope.searchUsers[i].electionOfficeTypeId != "C")) &&
                      $scope.searchUsers[i].politicianInfo[0].officeName !=
                        "" &&
                      $scope.searchUsers[
                        i
                      ].politicianInfo[0].officeName.toLowerCase() !=
                        "u.s. senate"
                    ) {
                      MyService.ConsoleLog(
                        "VoterScope : ",
                        $scope.searchUsers[i]
                      );
                      if ($scope.displayTab.indexOf("State") == -1) {
                        $scope.displayTab.push("State");
                      }
                      $scope.searchUsers[i].office =
                        $scope.searchUsers[i].office.toLowerCase();
                      if (typeof $scope.searchUsers[i].party == "string") {
                        // alert('one');
                        $scope.searchUsers[i].party =
                          $scope.searchUsers[i].party;
                      } else {
                        var party = "";
                        $scope.searchUsers[i].party.forEach(function (
                          element,
                          index
                        ) {
                          if (element) {
                            party += element + ", ";
                            MyService.ConsoleLog("Element", party);
                            $scope.searchUsers[i].party = party;
                          }
                        });
                      }
                      $scope.searchUsersByType.push($scope.searchUsers[i]);
                      /*
                    if ($scope.searchUsers[i].office) {

                      if (($scope.searchUsers[i].running_for.levelOfGov == 'state' || $scope.searchUsers[i].running_for.levelOfGov == 'statePostalCode' || $scope.searchUsers[i].running_for.levelOfGov == 'stateSenateDistrict' || $scope.searchUsers[i].running_for.levelOfGov == 'stateHouseofRepresentativesDistrict') && $scope.searchUsers[i].office != 'unitedStatesSenate') {
                        $scope.searchUsersByType.push($scope.searchUsers[i]);
                      } else {
                        $scope.searchUsersByType.push($scope.searchUsers[i]);
                      }
                    } else {
                      $scope.searchUsersByType.push($scope.searchUsers[i]);
                    }*/
                    } else if (
                      type == "federal" &&
                      ($scope.searchUsers[i].electionOfficeTypeId == "C" ||
                        $scope.searchUsers[i].electionOfficeTypeId == "P" ||
                        $scope.searchUsers[i].electionOfficeTypeId == "J" ||
                        $scope.searchUsers[i].politicianInfo[0].levelOfGov ==
                          "federalCongressionalDistrict" ||
                        $scope.searchUsers[i].office == "president" ||
                        ($scope.searchUsers[i].office == "President" &&
                          $scope.searchUsers[i].politicianInfo[0].levelOfGov ==
                            "All USA") ||
                        ($scope.searchUsers[i].office != "" &&
                          $scope.searchUsers[i].office.toLowerCase() ==
                            "u.s. senate" &&
                          $scope.searchUsers[i].office.toLowerCase() !=
                            "state senate"))
                    ) {
                      // MyService.ConsoleLog("samp.federalCongrassionalDist", $scope.checkFedDist.federalCongrassionalDist);
                      // var fed = $scope.checkFedDist.federalCongrassionalDist;
                      // var nDef = fed.charAt(1);
                      MyService.ConsoleLog("nDef", $scope.searchUsers[i]);

                      if ($scope.displayTab.indexOf("Federal") == -1) {
                        $scope.displayTab.push("Federal");
                      }
                      if (
                        $scope.searchUsers[i].politicianInfo[j]
                          .runningForOffice == "N"
                      ) {
                        // MyService.ConsoleLog("agai nananananananananananananananan", $scope.searchUsers[i]);
                        $scope.searchUsers[i].office =
                          $scope.searchUsers[i].politicianInfo[
                            j
                          ].officeName.toLowerCase();
                        if (
                          typeof $scope.searchUsers[i].politicianInfo[j]
                            .party == "string"
                        ) {
                          // alert('one');
                          $scope.searchUsers[i].party =
                            $scope.searchUsers[i].politicianInfo[j].party;
                        } else {
                          var party = "";
                          $scope.searchUsers[i].politicianInfo[j].party.forEach(
                            function (element, index) {
                              if (element) {
                                party += element + ", ";
                                MyService.ConsoleLog("Element", party);
                                $scope.searchUsers[i].party = party;
                              }
                            }
                          );
                        }
                        if (
                          $scope.searchUsers[i].running_for.levelOfGov ==
                            "state" &&
                          $scope.searchUsers[i].office == "unitedStatesSenate"
                        ) {
                          // if ($scope.searchUsers[i].running_for.federalCongressionalDistrict == fed || $scope.searchUsers[i].running_for.federalCongressionalDistrict == nDef) {
                          $scope.searchUsersByType.push($scope.searchUsers[i]);

                          // }
                        } else {
                          // $scope.searchUsersByType.push($scope.searchUsers[i]);
                          // if ($scope.searchUsers[i].running_for.federalCongressionalDistrict == fed || $scope.searchUsers[i].running_for.federalCongressionalDistrict == nDef) {
                          if (
                            $scope.searchUsers[i].running_for.officeName !=
                            "state senate"
                          ) {
                            $scope.searchUsersByType.push(
                              $scope.searchUsers[i]
                            );
                          }

                          // }
                        }
                      } else {
                        if ($scope.searchUsers[i].office) {
                          $scope.searchUsers[i].office =
                            $scope.searchUsers[i].office.toLowerCase();
                          if (typeof $scope.searchUsers[i].party == "string") {
                            // alert('one');
                            $scope.searchUsers[i].party =
                              $scope.searchUsers[i].party;
                          } else {
                            var party = "";
                            $scope.searchUsers[i].party.forEach(function (
                              element,
                              index
                            ) {
                              if (element) {
                                party += element + ", ";
                                MyService.ConsoleLog("Element", party);
                                $scope.searchUsers[i].party = party;
                              }
                            });
                          }
                          if (
                            $scope.searchUsers[i].running_for.levelOfGov ==
                              "state" &&
                            $scope.searchUsers[i].office == "unitedStatesSenate"
                          ) {
                            // if ($scope.searchUsers[i].running_for.federalCongressionalDistrict == fed || $scope.searchUsers[i].running_for.federalCongressionalDistrict == nDef) {
                            $scope.searchUsersByType.push(
                              $scope.searchUsers[i]
                            );

                            // }
                          } else {
                            // $scope.searchUsersByType.push($scope.searchUsers[i]);
                            // if ($scope.searchUsers[i].running_for.federalCongressionalDistrict == fed || $scope.searchUsers[i].running_for.federalCongressionalDistrict == nDef) {
                            $scope.searchUsersByType.push(
                              $scope.searchUsers[i]
                            );

                            // }
                          }
                        }
                      }

                      //else {
                      //   $scope.searchUsersByType.push($scope.searchUsers[i]);
                      // }
                    } else if (
                      type == "other" &&
                      ($scope.searchUsers[i].running_for.levelOfGov ==
                        "All USA" ||
                        $scope.searchUsers[i].running_for.levelOfGov ==
                          "all usa") &&
                      $scope.searchUsers[i].running_for.officeName !=
                        "President" &&
                      $scope.searchUsers[i].running_for.officeName !=
                        "president" &&
                      $scope.searchUsers[i].electionOfficeTypeId != "P"
                    ) {
                      // alert("if");
                      // MyService.ConsoleLog("$scope.searchUsers[i].running_for.officeName", $scope.searchUsers[i].running_for.officeName);

                      if ($scope.displayTab.indexOf("Other") == -1) {
                        $scope.displayTab.push("Other");
                      }
                      $scope.searchUsers[i].office =
                        $scope.searchUsers[i].office.toLowerCase();
                      MyService.ConsoleLog(
                        " $scope.searchUsers[i].office else",
                        $scope.searchUsers[i]
                      );
                      $scope.searchUsersByType.push($scope.searchUsers[i]);
                    }
                  } else if (
                    type == "other" &&
                    (($scope.searchUsers[i].politicianInfo[0].levelOfGov ==
                      "All USA" &&
                      $scope.searchUsers[i].politicianInfo[0].officeName !=
                        "President") ||
                      $scope.searchUsers[i].politicianInfo[0].officeName !=
                        "president")
                  ) {
                    // alert("else");
                    if ($scope.displayTab.indexOf("Other") == -1) {
                      $scope.displayTab.push("Other");
                    }
                    $scope.searchUsers[i].office =
                      $scope.searchUsers[i].office.toLowerCase();
                    $scope.searchUsersByType.push($scope.searchUsers[i]);
                  }
                }
              }
            }
            if (i == len - 1) {
              // MyService.ConsoleLog("FINAL : ", $scope.searchUsersByType);
              /*setTimeout(function() {
              MyService.ConsoleLog("apply");
              $(".main-table").clone(true).appendTo('.table-scroll').addClass('clone');
            }, 2000);*/
            }
          }
        }
      };

      $scope.getAddress = function () {
        $scope.Address = true;
        $scope.showAddressDropDown = false;
        $scope.Zip = false;
        $scope.Link = false;
      };

      // get Address from google api
      var options = {
        componentRestrictions: {
          country: "us",
        },
        types: ["geocode"],
      };

      $scope.detectAddress = function (ent) {
        var val = document.getElementById("address");
        // console.log($scope.User.Address);
        var autocomplete = new google.maps.places.Autocomplete(val, options);

        google.maps.event.addListener(
          autocomplete,
          "place_changed",
          function () {
            var place = autocomplete.getPlace();

            var lat = place.geometry.location.lat(),
              lng = place.geometry.location.lng();

            $scope.lati = lat.toFixed(6);
            $scope.lon = lng.toFixed(6);
            // console.log($scope.lati);
            // console.log($scope.lon);

            $scope.mailing_Address = place.formatted_address;
            // console.log($scope.mailing_Address);
            for (var i = 0; i < place.address_components.length; i++) {
              for (
                var j = 0;
                j < place.address_components[i].types.length;
                j++
              ) {
                if (
                  place.address_components[i].types[j] ==
                  "administrative_area_level_1"
                ) {
                  $scope.statePostalCode =
                    place.address_components[i].short_name;
                  // console.log($scope.statePostalCode);
                }
                if (place.address_components[i].types[j] == "country") {
                  $scope.countryname = place.address_components[i].long_name;
                  // console.log($scope.countryname);
                }
                if (
                  place.address_components[i].types[j] ==
                  "administrative_area_level_2"
                ) {
                  $scope.county_name = place.address_components[i].long_name;
                  // console.log($scope.county_name);
                }
                if (place.address_components[i].types[j] == "locality") {
                  $scope.place_name = place.address_components[i].long_name;
                  // console.log($scope.place_name);
                }
                if (place.address_components[i].types[j] == "postal_code") {
                  // document.getElementById('zip').value = place.address_components[i].long_name;
                  // $scope.User.ZipCode = place.address_components[i].long_name;
                  // console.log($scope.User.ZipCode);
                  // console.log($scope.User.ZipCode);
                }
              }
            }

            var loc = JSON.stringify({
              longitude: $scope.lon,
              latitude: $scope.lati,
            });
            // console.log(loc);
            // $rootScope.location = new Array;
            $rootScope.location = {
              longitude: $scope.lon,
              latitude: $scope.lati,
            };
            $scope.showAddressDropDowns("", loc);
          }
        );
      };

      function getUsers(params) {
        // MyService.ConsoleLog("get users");
        var request = apiCall.apiCall("GET", "/user/list", params);
        $http(request).then(
          function successCallback(response) {
            MyService.ConsoleLog("Got categories: ", response);
            if (response.data.success) {
              angular.forEach(response.data.data, function (val, key) {
                response.data.data[key].registeredUser = true;
              });
              $scope.setAllSelected(response.data.data);
              $scope.users = response.data.data;
              MyService.ConsoleLog("all user data", $scope.users);
              $scope.searchUsers = angular.copy($scope.users);
            } else {
              growl.error("Something went wrong.");
            }
          },
          function errorCallBack(response) {
            growl.error("Something went wrong.");
          }
        );
      }

      function getCompareAnswers(params) {
        var request = apiCall.apiCall("GET", "/answers/compare", params);
        $http(request).then(
          function successCallback(response) {
            //MyService.ConsoleLog("Got categories: ",response);
            if (response.data.success) {
              angular.forEach(response.data.data, function (val, key) {
                if (
                  val.answers &&
                  val.answers.length != $scope.selectedUser.length
                ) {
                  var check_author_exist = function (u) {
                    var len = val.answers.length;
                    for (var i = 0; i < len; i++) {
                      if (val.answers[i].author._id == u._id) {
                        return true;
                      }
                    }
                    return false;
                  };

                  angular.forEach($scope.selectedUser, function (u, i) {
                    if (!check_author_exist(u)) {
                      response.data.data[key].answers.push({
                        author: u,
                      });
                    }
                  });
                } else if (!val.answers) {
                  response.data.data[key].answers = [];
                  angular.forEach($scope.selectedUser, function (u, i) {
                    response.data.data[key].answers.push({
                      author: u,
                    });
                  });
                }
              });

              $rootScope.compareAnswerList = response.data.data;
              //MyService.ConsoleLog("compareAnswerList: ", $rootScope.compareAnswerList);
              $location.path(
                "question-compare/" + $routeParams.category_id + "/" + null
              );
            } else {
              //MyService.ConsoleLog("Something went wrong: ", response.data);
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
          }
        );
      }

      $scope.statusGetLocalPoliticians = 0;
      $scope.page = 0;
      $scope.users = [];
      $scope.Location = {
        state: "",
        FinalData: "",
      };
      $scope.showIncumbentLoader = false;

      $scope.getLocalPoliticians = function () {
        $scope.statusGetLocalPoliticians = 1;
        $scope.showIncumbentLoader = true;
        $scope.page += 1;
        var extradata = "";
        if ($rootScope.FinalData && $rootScope.FinalData != "") {
          extradata = $rootScope.FinalData;
          // alert("extra");
          if ($scope.MyDialog != "") {
            $scope.MyDialog.close();
          }
        }
        if ($rootScope.FinalData && $rootScope.FinalData !== "") {
          var fnlData = JSON.parse($rootScope.FinalData);
          $scope.checkFedDist = JSON.parse($rootScope.FinalData);
          MyService.ConsoleLog("extradata : ", fnlData);

          MyService.ConsoleLog("extradata : ", fnlData.statePostalCode);

          if (fnlData.statePostalCode !== "NC") {
            MyService.ConsoleLog("######## if ###########");

            MyService.getLocalIncumbentPoliForVoter({
              max_records: 100,
              page: $scope.page,
              extradata: extradata,
            }).then(
              function (response) {
                if (response.data.success) {
                  $scope.setAllSelected(response.data.data);
                  MyService.ConsoleLog("Dataaaa:::", response.data.data);

                  //var newData = [];
                  setTimeout(function () {
                    $scope.$apply(function () {
                      $scope.users = $scope.users.concat(response.data.data);
                      $scope.searchUsers = angular.copy($scope.users);
                      $scope.showIncumbentLoader = false;
                      $scope.getByType("local");

                      // MyService.ConsoleLog('final data : ', $rootScope.FinalData);
                      // for (var i = 0; i < $scope.searchUsers.length; i++) {
                      //   if ($rootScope.FinalData) {
                      //     if ($scope.searchUsers[i].address) {
                      //       if ($scope.searchUsers[i].address.place) {
                      //         if ($scope.searchUsers[i].address.place == $rootScope.FinalData.place) {
                      //           newData.push($scope.searchUsers[i]);
                      //         }
                      //       }
                      //     }
                      //   }
                      // }
                      //MyService.ConsoleLog(newData);
                    });
                  }, 100);

                  //$scope.users = response.data.data;
                  //MyService.ConsoleLog("users:::", JSON.stringify($scope.users));
                  $scope.statusGetLocalPoliticians = 2;
                } else {
                  $scope.page -= 1;
                  $scope.showIncumbentLoader = false;
                  $scope.statusGetLocalPoliticians = 3;
                  if (typeof response.data.error == "string")
                    growl.error(response.data.error);
                  else growl.error("Something went wrong");
                }
              },
              function (err) {
                // MyService.ConsoleLog("err : ", err);
                $scope.page -= 1;
                $scope.showIncumbentLoader = false;
                $scope.statusGetLocalPoliticians = 3;
                growl.error("Something went wrong");
              }
            );
          } else {
            $scope.showAlert = true;

            MyService.ConsoleLog("######## else ###########");
          }
        } else {
          MyService.getLocalIncumbentPoliForVoter({
            max_records: 100,
            page: $scope.page,
            extradata: extradata,
          }).then(
            function (response) {
              if (response.data.success) {
                $scope.setAllSelected(response.data.data);
                MyService.ConsoleLog("Dataaaa:::", response.data.data);
                //var newData = [];
                setTimeout(function () {
                  $scope.$apply(function () {
                    $scope.users = $scope.users.concat(response.data.data);
                    $scope.searchUsers = angular.copy($scope.users);
                    $scope.showIncumbentLoader = false;
                    $scope.getByType("local");

                    // MyService.ConsoleLog('final data : ', $rootScope.FinalData);
                    // for (var i = 0; i < $scope.searchUsers.length; i++) {
                    //   if ($rootScope.FinalData) {
                    //     if ($scope.searchUsers[i].address) {
                    //       if ($scope.searchUsers[i].address.place) {
                    //         if ($scope.searchUsers[i].address.place == $rootScope.FinalData.place) {
                    //           newData.push($scope.searchUsers[i]);
                    //         }
                    //       }
                    //     }
                    //   }
                    // }
                    //MyService.ConsoleLog(newData);
                  });
                }, 100);
                //$scope.users = response.data.data;
                //MyService.ConsoleLog("users:::", JSON.stringify($scope.users));
                $scope.statusGetLocalPoliticians = 2;
              } else {
                $scope.page -= 1;
                $scope.showIncumbentLoader = false;
                $scope.statusGetLocalPoliticians = 3;
                if (typeof response.data.error == "string")
                  growl.error(response.data.error);
                else growl.error("Something went wrong");
              }
            },
            function (err) {
              // MyService.ConsoleLog("err : ", err);
              $scope.page -= 1;
              $scope.showIncumbentLoader = false;
              $scope.statusGetLocalPoliticians = 3;
              growl.error("Something went wrong");
            }
          );
        }
      };

      $scope.allState = [];
      $scope.MyDialog = "";
      $rootScope.$on("ngDialog.opened", function (e, $dialog) {
        // MyService.ConsoleLog('ngDialog opened: ' + $dialog.attr('id'));
        if ($(window).width() <= 768) {
          $(".ngdialog").css("padding-top", "65px");
        }
      });
      $rootScope.$on("ngDialog.closed", function (e, $dialog) {
        // MyService.ConsoleLog('ngDialog closed: ' + $dialog.attr('id'));
        if ($(window).width() <= 768) {
          $(".ngdialog").css("padding-top", "160px");
        }
      });
      $scope.showHtmlViewer = function (content, ttl) {
        MyService.getAllStates().then(
          function (payload) {
            $scope.allState = payload;
            $scope.states = payload;
            $scope.MyDialog = ngDialog.open({
              template: "guest_location",
              scope: $scope,
              // className: 'ngdialog-theme-default'
            });
          },
          function (errorPayload) {
            growl.error("Something went wrong.");
          }
        );
      };

      $scope.showPopups = function () {
        MyService.getAllStates().then(
          function (payload) {
            $scope.allState = payload;
            $scope.states = payload;
            $scope.MyDialog = ngDialog.open({
              template: "guest_location",
              scope: $scope,
              // className: 'ngdialog-theme-default'
            });
          },
          function (errorPayload) {
            growl.error("Something went wrong.");
          }
        );
      };
      $scope.MyDialog1 = "";
      $scope.displayContent = "";
      // $scope.showHtmlViewer1 = function(content, ttl) {
      //             MyService.ConsoleLog(content);
      //             $scope.MyDialog1 = ngDialog.open({
      //                 template: content,
      //                 plain: true,
      //                 scope: $scope
      //                     // className: 'ngdialog-theme-default'
      //             });

      // };

      $scope.showHtmlViewer1 = function (content, ttl) {
        // MyService.ConsoleLog(content);
        $scope.displayContent = $sce.trustAsHtml(
          content.replace(/(\r\n|\n|\r)/g, "<br />")
        );
        $scope.MyDialog1 = ngDialog.open({
          template: "statement",
          scope: $scope,
          // className: 'ngdialog-theme-default'
        });
      };

      $scope.allcounties = [];
      $scope.getCounties = function (lbl) {
        MyService.ConsoleLog(
          " <<<<<<<<<<<< county >>>>>>>>>>>",
          $scope.Location.state,
          $scope.oldaddress.state
        );
        // $scope.allcounties.length = 0;
        var statePostalCode = "";
        var state = "";
        MyService.ConsoleLog("lbl >", lbl);
        if (lbl == "new") {
          // state = JSON.stringify($scope.oldaddress.state);
          statePostalCode = $scope.Location.state.stateFips;
        } else {
          statePostalCode = $scope.Location.state.stateFips;
          state = $scope.Location.state;
        }
        // if ($scope.Location.state && $scope.Location.state != "") {
        //   statePostalCode = $scope.Location.state.stateFips;
        // } else {
        //   // var nestate = JSON.parse($scope.Location);
        //   // MyService.ConsoleLog("nestate >>", nestate);
        // }

        MyService.ConsoleLog("$scope.stateFips", $scope.stateFips);

        MyService.getAllCounties($scope.stateFips, state).then(
          function (payload) {
            // MyService.ConsoleLog("sublocations Locals : ", payload);
            var allcounties = payload;
            if (lbl == "new") {
              var county = $scope.checkCounty(
                allcounties,
                $scope.oldaddress.county
              );
              $scope.allcounties = county;
              // MyService.ConsoleLog("county<><", county);
              $scope.Location.county = county[0];
            }
          },
          function (errorPayload) {
            growl.error("Something went wrong.");
          }
        );
      };
      $scope.MyPlaces = [];
      $scope.getSubCounties = function (lbl) {
        //MyService.ConsoleLog($scope.Location.state);
        //MyService.ConsoleLog($scope.Location.county);
        // var county = $scope.Location.county;

        $scope.MyPlaces.length = 0;
        var county = "";
        var statePostalCode = "";
        $scope.MyPlaces.length = 0;
        var state = "";
        var county = "";
        if (lbl == "new") {
          state = JSON.stringify($scope.oldaddress.state);
          county = JSON.stringify($scope.oldaddress.county);
        } else {
          statePostalCode = $scope.Location.state.statePostalCode;
          state = $scope.Location.state;
          county = county.county;
        }
        // MyService.ConsoleLog(statePostalCode + "===" + county);
        MyService.getAllSubCountiesLocal(statePostalCode, state, county).then(
          function (payload) {
            // payload = JSON.parse(payload);
            $scope.MyPlaces = payload;
            // MyService.ConsoleLog("PlaCE :", payload);
            // MyService.ConsoleLog(payload.countySubdivision);
            var subcounties = payload.countySubdivision;
            var places = payload.places;
            // MyService.ConsoleLog("PlaCE :", payload);
            if (lbl == "new") {
              // MyService.ConsoleLog("Places 1 > ",$scope.oldaddress.place);
              var subcounty = $scope.checksubCounty(
                subcounties,
                $scope.oldaddress.countySubdivision
              );
              var places = $scope.checkPlaces(places, $scope.oldaddress.place);
              // MyService.ConsoleLog("subcounty<><><", subcounty);
              $scope.subcounties = subcounty;
              $scope.places = places;
              // console.log('***********', $scope.places);
              // $scope.Location.countySubdivision = subcounty[0];
              $scope.Location.place = places[0];
            }
          },
          function (errorPayload) {
            growl.error("Something went wrong.");
          }
        );
      };

      $scope.submitLocation = function () {
        // MyService.ConsoleLog("@@@@ :", $scope.Location);
        //MyService.ConsoleLog($scope.Location.county);
        MyService.ConsoleLog($scope.Location.place);
        var finalData = new Object();
        if ($scope.Location.state && $scope.Location.state != "") {
          var nobj = new Object();
          nobj.statePostalCode = $scope.Location.state.statePostalCode;
          finalData.statePostalCode = $scope.Location.state.statePostalCode;
          finalData.state = $scope.Location.state.state;
        }
        if (
          $scope.Location.county &&
          $scope.Location.county.county &&
          $scope.Location.county.county != ""
        ) {
          $scope.Location.FinalData = JSON.stringify($scope.Location.county);
          finalData.county = $scope.Location.county.countyName;
        }
        if (
          $scope.Location.countySubdivision &&
          $scope.Location.countySubdivision.countySubdivision != ""
        ) {
          $scope.Location.FinalData = JSON.stringify(
            $scope.Location.countySubdivision
          );
          finalData.countySubdivision =
            $scope.Location.countySubdivision.countySubdivision;
        }
        if ($scope.Location.place && $scope.Location.place.place != "") {
          //$scope.Location.FinalData = JSON.stringify($scope.Location.place._id);
          finalData.place = $scope.Location.place.placeName;
        }

        if (
          $scope.Location.cityCouncilDistrict &&
          $scope.Location.cityCouncilDistrict != ""
        ) {
          finalData.cityCouncilDistrictName =
            $scope.Location.cityCouncilDistrict.COUNTDIST;
        }
        /*
      if ($scope.Location.voterDistrict && $scope.Location.voterDistrict.voterDistrictName != "") {
        //$scope.Location.FinalData = JSON.stringify($scope.Location.place._id);
        finalData.voterDistrict = $scope.Location.voterDistrict.voterDistrictName;
      }
      */
        if (
          $scope.Location.stateHouseOFRepresentativeDistrict &&
          $scope.Location.stateHouseOFRepresentativeDistrict.NAMELSAD != ""
        ) {
          //$scope.Location.FinalData = JSON.stringify($scope.Location.place._id);
          if (
            $scope.Location.stateHouseOFRepresentativeDistrict.SLDLST &&
            $scope.Location.stateHouseOFRepresentativeDistrict.SLDLST != ""
          ) {
            finalData.legislativeDistrict =
              $scope.Location.stateHouseOFRepresentativeDistrict.SLDLST;
          } else {
            var SLDLSTarr =
              $scope.Location.stateHouseOFRepresentativeDistrict.NAMELSAD.split(
                " "
              );
            var SLDLST = SLDLSTarr[SLDLSTarr.length - 1];
            finalData.legislativeDistrict = SLDLST;
          }
        }

        if (
          $scope.Location.federalCongrassionalDist &&
          $scope.Location.federalCongrassionalDist.CD115FP
        ) {
          //$scope.Location.FinalData = JSON.stringify($scope.Location.place._id);
          if (
            $scope.Location.federalCongrassionalDist.CD115FP ==
            "Congressional District (at Large)"
          ) {
            finalData.federalCongrassionalDist = "At-Large";
          } else {
            finalData.federalCongrassionalDist =
              $scope.Location.federalCongrassionalDist.CD115FP;
          }
        }
        if (
          $scope.Location.stateSenateDistrict &&
          $scope.Location.stateSenateDistrict.SLDUST != ""
        ) {
          //$scope.Location.FinalData = JSON.stringify($scope.Location.place._id);
          finalData.stateSenateDistrict =
            $scope.Location.stateSenateDistrict.SLDUST;
        }
        /*
      if ($scope.Location.stateLegislativeDistrict && $scope.Location.stateLegislativeDistrict.stateHouseOFRepresentativeDistrict != "") {
        //$scope.Location.FinalData = JSON.stringify($scope.Location.place._id);
        finalData.legislativeDistrict = $scope.Location.stateLegislativeDistrict.stateHouseOFRepresentativeDistrict;
      }
      */
        if (
          $scope.Location.unifiedSchoolDistrictName &&
          $scope.Location.unifiedSchoolDistrictName.NAME != ""
        ) {
          //$scope.Location.FinalData = JSON.stringify($scope.Location.place._id);
          finalData.schoolDistrict =
            $scope.Location.unifiedSchoolDistrictName.NAME;
        }
        // MyService.ConsoleLog(finalData);

        //MyService.ConsoleLog($scope.Location.FinalData);
        $rootScope.FinalData = JSON.stringify(finalData);
        MyService.ConsoleLog("final data : ", $rootScope.FinalData);

        $scope.users.length = 0;
        $scope.page = 0;
        $scope.getLocalPoliticians();
      };
      // $rootScope.compareFinalData = "";
      //alert($routeParams.user_type);
      if ($routeParams.user_type) {
        if ($routeParams.user_type == "politician") {
          MyService.ConsoleLog(
            "inside politician",
            $rootScope.compareFinalData
          );

          MyService.ConsoleLog(" $rootScope.incuAdd", $rootScope.incuAdd);
          if (
            $rootScope.compareFinalData &&
            $rootScope.compareFinalData != ""
          ) {
            $rootScope.FinalData = $rootScope.compareFinalData;
            MyService.ConsoleLog("$rootScope.FinalData ", $rootScope.FinalData);
          } else if ($rootScope.incuAdd && $rootScope.incuAdd != "") {
            $rootScope.FinalData = JSON.stringify($rootScope.incuAdd);
          }
          if (
            !tokenService.getUserId() &&
            (!$rootScope.FinalData || $rootScope.FinalData == "")
          ) {
            $scope.showHtmlViewer();
          }

          if (tokenService.getUserId()) {
            var tempData = JSON.parse(tokenService.getUserData());
            MyService.ConsoleLog("tempData", tempData);
            if (
              (tempData.address &&
                tempData.address.statePostalCode &&
                tempData.address.statePostalCode != "") ||
              (tempData.address.state && tempData.address.state != "")
            ) {
              $rootScope.FinalData = "";
              $scope.pop = false;
              $scope.getLocalPoliticians();
            } else {
              $scope.pop = true;
              $scope.showPopups();
            }
          }

          if ($rootScope.FinalData && $rootScope.FinalData != "") {
            $scope.pop = false;
            $scope.getLocalPoliticians();
          }
        } else {
          /*
        getUsers({
          usertype: $routeParams.user_type
        });
        */
        }
      }

      $scope.selectedUser = [];
      $scope.toggleSelection = function (uid) {
        //MyService.ConsoleLog("toggleSelection: ", uid);
        var idx = $scope.selectedUser.indexOf(uid);
        // console.log("idxxxx  :",idx);
        // is currently selected
        if (idx > -1) {
          $scope.selectedUser.splice(idx, 1);
        } else {
          $scope.selectedUser.push(uid);
        }
      };

      $scope.selectedUserPrint = [];
      $scope.togglePrintSelection = function (uid) {
        //MyService.ConsoleLog("togglePrintSelection: ", uid);
        var idx = $scope.selectedUserPrint.indexOf(uid);
        // is currently selected
        if (idx > -1) {
          $scope.selectedUserPrint.splice(idx, 1);
        }
        // is newly selected
        else {
          $scope.selectedUserPrint.push(uid);
        }
      };

      $scope.compare = function () {
        //MyService.ConsoleLog("compare :", $scope.selectedUser);
        if ($scope.selectedUser.length <= 0) {
          alert("Please select user first.");
        } else {
          $rootScope.selectedCompareUsers = $scope.selectedUser;
          // $location.path("/question-compare/all/"+$routeParams.category_id);
          $location.path(
            "/question-compare/all/" + $rootScope.categories[0]._id
          );
        }
      };

      $scope.compareOfficeWise = function (users) {
        $rootScope.selectedCompareUsers = [];
        angular.forEach(users, function (val, key) {
          //MyService.ConsoleLog("key: ", key, " val: ", val);
          if (val.registeredUser) {
            $rootScope.selectedCompareUsers.push(val);
          }
        });
        //MyService.ConsoleLog("$rootScope.selectedCompareUsers: ", $rootScope.selectedCompareUsers);
        if ($rootScope.selectedCompareUsers.length <= 0) {
          growl.error("None of the users are registered user.");
        } else {
          $location.path(
            "/question-compare/all/" + $rootScope.categories[0]._id
          );
        }
      };

      $scope.compareRatings = function (users) {
        MyService.ConsoleLog("users > ", users);
        $rootScope.selectedRatingUsers = [];
        angular.forEach(users, function (val, key) {
          MyService.ConsoleLog("key: ", key);
          MyService.ConsoleLog(" val: ", val);
          //if (val.registeredUser && val.isSelected && val.total_reviews > 0) {
          if (val.total_reviews > 0) {
            console.log("valpoliticianIds >> ", val.politicianIds);
            if (!val.politicianIds) {
              var pids = [];
              pids.push(val._id);
              val["politicianIds"] = pids;
              console.log("val >>> ", val);
            }
            $rootScope.selectedRatingUsers.push(val);
          }
        });
        //MyService.ConsoleLog("$rootScope.selectedCompareUsers: ", $rootScope.selectedCompareUsers);
        if ($rootScope.selectedRatingUsers.length <= 0) {
          growl.error("None of the users you selected have ratings.");
        } else {
          $location.path("/compareRatings");
        }
      };

      $scope.compareOfficeWiseSubject = function (users) {
        $rootScope.selectedCompareUsers = [];
        angular.forEach(users, function (val, key) {
          //MyService.ConsoleLog("key: ", key, " val: ", val);
          if (val.total_answers && val.total_answers > 0) {
            $rootScope.selectedCompareUsers.push(val);
          }
        });
        //MyService.ConsoleLog("$rootScope.selectedCompareUsers: ", $rootScope.selectedCompareUsers);
        if ($rootScope.selectedCompareUsers.length <= 0) {
          growl.error("None of the users you selected answered questions.");
        } else {
          $location.path("/compare-subject/" + $routeParams.user_type);
        }
      };

      $scope.compareSubjectWise = function () {
        //MyService.ConsoleLog("compare :", $scope.selectedUser);
        if ($scope.selectedUser.length <= 0) {
          alert("Please select user first.");
        } else {
          $rootScope.selectedCompareUsers = $scope.selectedUser;
          $location.path("/compare-subject/" + $routeParams.user_type);
        }
      };

      $scope.printSelectedUsers = function () {
        //MyService.ConsoleLog("* printSelectedUsers *", $scope.selectedUserPrint);
        if ($scope.selectedUserPrint.length > 0) {
          $rootScope.printUsers = angular.copy($scope.selectedUserPrint);
          $location.path("/print-users");
        } else {
          growl.error("Please select user first.");
        }
      };

      $scope.searchOffice = function (office) {
        $scope.searchUsers = $scope.users.filter(function (rdata) {
          var idx = rdata.office
            .toLowerCase()
            .indexOf($scope.search.searchFilter.toLowerCase());
          if (idx > -1) return rdata;
        });
      };

      $scope.showZipLoader = false;
      $scope.showAddressDropDown = false;

      $scope.checkState = function (rdata, val) {
        MyService.ConsoleLog("State :", rdata);
        MyService.ConsoleLog("State val :", val);
        var sdata = [];
        var len = rdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = rdata[i];
          var gdata = val.filter(function (obj) {
            if (
              rsdata.countyFips == obj.COUNTYFP &&
              rsdata.stateFips == obj.STATEFP
            ) {
              // MyService.ConsoleLog(rdata[i]);
              return rdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(rdata[i]) == -1) {
              sdata.push(rdata[i]);
            }
          }

          if (j == len) {
            // MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };

      $scope.checkCounty = function (rdata, val) {
        MyService.ConsoleLog("County :", rdata);
        MyService.ConsoleLog("County val :", val);
        var sdata = [];
        var len = rdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = rdata[i];
          var gdata = val.filter(function (obj) {
            if (
              rsdata.countyFips == obj.COUNTYFP &&
              rsdata.stateFips == obj.STATEFP
            ) {
              // MyService.ConsoleLog(rdata[i]);
              return rdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(rdata[i]) == -1) {
              sdata.push(rdata[i]);
            }
          }

          if (j == len) {
            // MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };
      $scope.checksubCounty = function (rdata, val) {
        var sdata = [];
        var len = rdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = rdata[i];
          var gdata = val.filter(function (obj) {
            if (rsdata.countySubdivision == obj.NAME) {
              // MyService.ConsoleLog(rdata[i]);
              return rdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(rdata[i]) == -1) {
              sdata.push(rdata[i]);
            }
          }

          if (j == len) {
            // MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };
      $scope.checkPlaces = function (prdata, val) {
        var sdata = [];
        var len = prdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = prdata[i];
          var gdata = val.filter(function (obj) {
            // MyService.ConsoleLog(rsdata.place +"=="+ obj.NAME);
            if (rsdata.place == obj.NAME && !rsdata.countyFips) {
              // MyService.ConsoleLog(rdata[i]);
              return prdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(prdata[i]) == -1) {
              sdata.push(prdata[i]);
            }
          }

          if (j == len) {
            // MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };

      $scope.emptyOrNull = function (item) {
        return !(
          item._id.place === null ||
          item._id.place === "" ||
          item._id.place === " "
        );
      };

      $scope.detectCode = function (event) {
        // console.log("Zipcode", $scope.Location.ZipCode);
        // MyService.ConsoleLog(event);
        // MyService.ConsoleLog("keycode : ", event.keyCode);
        if (event.keyCode == 9 && event.key == "Tab") {
          $("#zipcodeinput").blur();
          $scope.showAddressDropDowns($scope.Location.ZipCode);
        }
        if (event.keyCode == 13 && event.key == "Enter") {
          $("#zipcodeinput").blur();
          $scope.showAddressDropDowns($scope.Location.ZipCode);
        }
      };

      $scope.showAddressDropDowns = function (zipcode, loc) {
        $scope.showZipLoader = true;
        // console.log(zipcode);
        MyService.getOrganizedZipData({
          zipcode: zipcode,
          candidate: true,
          loc: loc,
        }).then(
          function (payload) {
            MyService.ConsoleLog(" <<<<<< mylog >>>>>>>>>", payload);
            if (payload && payload.state) {
              // var finalData = payload.data;
              // MyService.ConsoleLog(payload[0]);
              // MyService.ConsoleLog(payload[0].countySubdivision);
              // MyService.ConsoleLog(payload[0].county);
              // MyService.ConsoleLog(payload[0].place);
              $scope.stateFips = payload.state[0].STATEFP;
              MyService.ConsoleLog("STATEFP", $scope.stateFips);
              var countySubdivisions = payload.places.filter(function (obj) {
                if (obj.COUSUBFP && obj.COUSUBFP != "") {
                  // MyService.ConsoleLog("Inside cs");
                  return obj;
                }
              });
              var places = payload.places.filter(function (obj) {
                if (obj.PLACEFP && obj.PLACEFP != "") {
                  // MyService.ConsoleLog("obj > ", obj);
                  return obj;
                }
              });

              // MyService.ConsoleLog("here");
              $scope.showZipLoader = false;
              $scope.showAddressDropDown = true;
              $scope.oldaddress.state = payload.state;
              $scope.oldaddress.county = payload.county;
              // MyService.ConsoleLog("countySubdivisions >> ", countySubdivisions);
              $scope.oldaddress.countySubdivision = countySubdivisions;
              // MyService.ConsoleLog("places >>> ",places);
              $scope.oldaddress.place = places;
              $scope.getCounties("new");

              $scope.getSubCounties("new");

              // $scope.voterDistricts = payload;
              // MyService.ConsoleLog(payload.congressionalDistrict);
              $scope.federalCongrassionalDist = payload.congressionalDistrict;
              MyService.ConsoleLog(
                "@@@@@@ drop :",
                $scope.federalCongrassionalDist
              );

              $scope.stateSenateDistrict = payload.stateSenateDistrict;
              $scope.stateHouseOFRepresentativeDistricts =
                payload.stateHouseofRepresentativesDistrict;
              $scope.unifiedSchoolDistrictNames = payload.unifiedSchoolDistrict;
              $scope.cityCouncilDistrict = payload.cityCouncilDistrict;
              //$scope.$apply();
              // MyService.ConsoleLog($scope.states);
              // MyService.ConsoleLog(payload[0].statePostalCode);
              var address = $scope.checkState($scope.states, payload.state);
              $scope.allstates = address;
              // MyService.ConsoleLog("address<>", address);
              $scope.Location.state = address[0];
              // $scope.Location.voterDistrict = $scope.voterDistricts[0];
              $scope.Location.federalCongrassionalDist =
                $scope.federalCongrassionalDist[0];
              $scope.Location.stateSenateDistrict =
                $scope.stateSenateDistrict[0];
              $scope.Location.stateHouseOFRepresentativeDistrict =
                $scope.stateHouseOFRepresentativeDistricts[0];
              $scope.Location.unifiedSchoolDistrictName =
                $scope.unifiedSchoolDistrictNames[0];
              $scope.Location.cityCouncilDistrict = $scope.cityCouncilDistrict
                ? $scope.cityCouncilDistrict[0]
                : [];
              // MyService.ConsoleLog("address ; ", address);
            } else {
              $scope.showZipLoader = false;
              alert("Zipcode not found in our database. Please correct it");
            }
          },
          function (errorPayload) {
            $scope.showZipLoader = false;
            growl.error(errorPayload);
          }
        );
      };

      $scope.checkLength = function (vdata, val) {
        // MyService.ConsoleLog("vdata : ", vdata);
        MyService.ConsoleLog("vdata", vdata);
        if (vdata && vdata.length > 0) {
          var data = vdata.map(function (sub) {
            var returnval = "";
            switch (val) {
              case "federalCongrassionalDist":
                returnval = sub.CD115FP;
                break;
              case "stateSenateDistrict":
                returnval = sub.SLDUST;
                break;
              case "stateHouseOFRepresentativeDistrict":
                returnval = sub.NAMELSAD;
                break;
              case "unifiedSchoolDistrictName":
                returnval = sub.NAME;
                break;
              case "place":
                returnval = sub.place;
                break;
              case "countySubdivision":
                returnval = sub.countySubdivision;
                break;
              case "county":
                returnval = sub.county;
                break;
              case "state":
                returnval = sub.state;
                break;
              case "cityCouncilDistrict":
                returnval = sub.COUNTDIST;
                break;
              case "default":
                returnval = sub.NAME;
                break;
            }
            return returnval;
          });

          var ndata = $filter("unique")(data);
          if (ndata.length > 1) {
            return "yellowBackground";
          } else {
            return "";
          }
        } else {
          return "";
        }
      };
      $scope.goToPoliticianThread = function (officename, users, userData) {
        //MyService.ConsoleLog("goToPoliticianThread: ", users, " officename: ", officename, " userData: ", userData);
        $rootScope.politicianThreadData = {
          // office: officename,
          users: users,
          selected_user: userData,
        };
        window.localStorage.setItem(
          "politicianThreadData",
          JSON.stringify($rootScope.politicianThreadData)
        );
        $location.path("/politician-thread/" + userData._id);
      };

      if ($rootScope.userRole && $rootScope.userRole.toLowerCase() == "voter") {
        MyService.getProfile($rootScope.UserId).then(
          function (data) {
            // body...
            try {
              var address_data = data.address;
              if ($filter("isBlankString")(address_data.voterDistrict)) {
                address_data.zipcode = data.zipcode;
                //MyService.ConsoleLog("Data: ",data);
                // ngDialog.open({
                //   template: "popups/user_localupdate.html",
                //   data: data.address
                //   // className: 'ngdialog-theme-default'
                // });
              } //isBlankString voterDistrict
            } catch (e) {
              //MyService.ConsoleLog("Exception: ", e);
            }
          },
          function (err) {
            //MyService.ConsoleLog("********* err: ", err);
          }
        );
      }
    },
  ]);

'use strict';
angular.module('myApp.howToVideo', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/howToVideo', {
      templateUrl: 'app/howToVideo/howToVideo.html',
      controller: 'howToVideoCtrl'
    });
  }])

  .controller('howToVideoCtrl', ['$scope', '$rootScope', '$http', '$location', 'apiCall', 'baseApiUrl', 'tokenService', 'ngDialog', 'growl', 'MyService', function ($scope, $rootScope, $http, $location, apiCall, baseApiUrl, tokenService, ngDialog, growl, MyService) {
    $scope.imgUrl = baseApiUrl + "/resources";
    $scope.userId = tokenService.getUserId();
    $scope.userRole = tokenService.getUserRole();
    $scope.userData = JSON.parse(tokenService.getUserData());

    $rootScope.welcome = false;
    $scope.showCon = false;
    $scope.showBoth = false;
    $scope.showEm = false;


    /**
     * Redirect
     */
    $scope.goto = function () {
      $location.path('/verifyBy');
    };

    /**
     * Close it
     */
    $scope.closeIt = function () {
      $scope.PopDialog.close();
    };
    $scope.getmyData = function () {
      $scope.ShowPorifleLoading = true;
      MyService.getUserPublicProfile({
        id: tokenService.getUserId(),
        type: 'false'
      }).then(function (response) {
        $scope.ShowPorifleLoading = false;
        if (response.data.success) {
          $scope.userDetails = response.data.data;
          // MyService.ConsoleLog("welcome", $scope.userDetails);
          $scope.userProfile = $scope.userDetails.userData;
          MyService.ConsoleLog("welcome to profile", $scope.userProfile);

          $scope.userType = $scope.userProfile.userType;
          $scope.verify = $scope.userProfile.verifiedUser;
          // MyService.ConsoleLog("welcome", $scope.verify);
          // console.log("$scope.userDetails", $scope.userDetails.userData.address);
          if (!$scope.userProfile.verifiedUser) {
            $scope.showCon = true;
          }
          if (!$scope.userProfile.isEmailVerified || !$scope.userProfile.verifiedUser) {
            // $scope.getPopUp();
            if (!$scope.userProfile.isEmailVerified && !$scope.userProfile.verifiedUser) {
              $scope.showCon = true;
              $scope.showBoth = true;
            } else if (!$scope.userProfile.isEmailVerified) {
              $scope.showEm = true;
            }
            $scope.PopDialog = ngDialog.open({
              template: 'popUp',
              closeByNavigation: true,
              scope: $scope,
              width: '50%'
            });
          }


        } else {
          MyService.ConsoleLog("ELSE vishal");
          alert("Something went wrong.");
        }
      }, function (errorPayload) {
        $scope.ShowPorifleLoading = false;
        MyService.ConsoleLog("ELSE vishal two");

        alert("Something went wrong.");
      });
    }

    if (tokenService.getUserId()) {
      $scope.getmyData();
    }


  }]);

'use strict';

angular.module('myApp.howABillBecomesALaw', ['ngRoute'])

.config(['$routeProvider', function ($routeProvider) {
     $routeProvider.when('/howABillBecomesALaw', {
         templateUrl: 'app/howABillBecomesALaw/howABillBecomesALaw.html',
         controller: 'howABillBecomesALawCtrl' 
     });
}])
.controller('howABillBecomesALawCtrl', ['$scope', '$rootScope', function($scope, $rootScope) {
$rootScope.welcome = false;
}]);

"use strict";
angular
  .module("myApp.getVotesDetails", ["ngRoute"])

  .config([
    "$routeProvider",
    function($routeProvider) {
      $routeProvider.when("/getVotesDetails/:id?", {
        templateUrl: "app/getVotesDetails/getVotesDetails.html",
        controller: "getVotesDetailsCtrl"
      });
    }
  ])
  .controller("getVotesDetailsCtrl", ["$scope", "$http", "$location", "apiCall", "$rootScope", "growl", "ngDialog", "tokenService", "MyService", "$routeParams", function($scope, $http, $location, apiCall, $rootScope, growl, ngDialog, tokenService, MyService, $routeParams) {

    $scope.uId = $routeParams.id;
    MyService.ConsoleLog("$scopeId >>", $scope.uId);
    $scope.activeDoc = true;


    $scope.getDetails = function() {

      MyService.getVotesDetail({ "id": $scope.uId }).then(function(response) {
        MyService.ConsoleLog("response >>", response);
        $scope.details = response.data.data;
      }, function(err) {
        MyService.ConsoleLog("Erorr >>", err);
      })

    }
    $scope.getDetails();

  }]);

'use strict';
angular.module('myApp.highlightedPost', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/highlightedPost/:pressId', {
      templateUrl: 'app/highlightedPost/highlightedPost.html',
      controller: 'highlightedPostCtrl'
    });
  }])
  .controller('highlightedPostCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'baseApiUrl', 'MyService', 'tokenService', 'growl', '$templateCache', 'ngDialog', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, baseApiUrl, MyService, tokenService, growl, $templateCache, ngDialog) {
    $scope.pressId = $routeParams.pressId;
    MyService.ConsoleLog(" $scope.pressId", $scope.pressId);
    $scope.showAdvocate = true;
    $scope.showfAdvocate = true;
    /**
     * Fetch Highlighted post by advocate
     */

    $scope.getHighlightedPost = function () {
      MyService.getHighlighatedPost({
        pId: $scope.pressId
      }).then(function (response) {
        MyService.ConsoleLog("response", response);
        $scope.HighlightedPost = response.data;
      }, function (err) {
        MyService.ConsoleLog("Error", err);
      });
    };
    $scope.getHighlightedPost();
  }]);

'use strict';
angular.module('myApp.gridState', ['ngRoute'])

  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/gridState', {
      templateUrl: 'app/gridState/gridState.html',
      controller: 'GridStateCtrl'
    });
  }])
  .controller('GridStateCtrl', ['$scope', '$location', '$rootScope', 'tokenService', 'MyService', 'ngDialog', '$routeParams', function($scope, $location, $rootScope, tokenService, MyService, ngDialog, $routeParams) {
    //MyService.ConsoleLog("* Following *");
    $scope.users = {
      data: []
    };
    $scope.showRUpload = false;
    $scope.showLoading = false;

    if ($routeParams.type && $routeParams.type != "") {
      $scope.showRUpload = true;
    } else {
      $scope.showHUpload = true;
    }

    $scope.getGridHistory = function() {
      // this is just an example, in reality this stuff should be in a service
      $scope.showLoading = true;
      MyService.getGridHistory().then(function(payload) {
        //MyService.ConsoleLog(payload)
        $scope.users.data = payload;
        //MyService.ConsoleLog(payload.Items);
        $scope.showLoading = false;
      }, function(err) {
        //MyService.ConsoleLog(err);
      });
    }

    $scope.removeGrid = function(mydata, idx) {
      //MyService.ConsoleLog(mydata);
      //MyService.ConsoleLog(mydata.user);
      var message = 'This action will remove the saved history of the user. Do you want to proceed?';

      var modal = ngDialog.openConfirm({
        template: '<p>' + message + '</p>\
            <div class="ngdialog-buttons">\
                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">YES</button>\
                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">NO</button>\
            </div>',
        plain: true
      });
      modal.then(function fullfilled(data) {
        //MyService.ConsoleLog("fullfilled: ", mydata);
        MyService.removeStoredTempPolitician({
          "user": mydata.user
        }).then(function(payload) {
          //MyService.ConsoleLog(payload);
          //$scope.UserFormDiv = false;
          $scope.getGridHistory();
          alert("Grid state removed successfully.");
        }, function(error) {
          alert(JSON.stringify(error));
        });
      }, function rejected(data) {
        //MyService.ConsoleLog("rejected: ", data);
      });
    }

    if ($rootScope.showHUpload) {
      $scope.getGridHistory();
    }
  }])

'use strict';
angular.module('myApp.gettingStartedPol', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/gettingStartedPol', {
      templateUrl: 'app/gettingStartedPol/gettingStartedPol.html',
      controller: 'gettingStartedPolCtrl'
    });
  }])
  .controller('gettingStartedPolCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', 'growl', '$cookies', 'ngDialog', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService, growl, $cookies, ngDialog) {

    $scope.showCon = false;
    $scope.showBoth = false;
    $scope.showEm = false;

    $scope.ShowPorifleLoading = false;
    $scope.getmyData = function (uid) {
      $scope.ShowPorifleLoading = true;
      MyService.getUserPublicProfile({
        id: uid,
        type: 'false'
      }).then(function (response) {
        $scope.ShowPorifleLoading = false;
        if (response.data.success) {
          $scope.userDetails = response.data.data;
          // MyService.ConsoleLog("welcome", $scope.userDetails);
          $scope.userProfile = $scope.userDetails.userData;
          MyService.ConsoleLog("welcome to profile", $scope.userProfile);

          $scope.userType = $scope.userProfile.userType;
          $scope.verify = $scope.userProfile.verifiedUser;
          // MyService.ConsoleLog("welcome", $scope.verify);
          // console.log("$scope.userDetails", $scope.userDetails.userData.address);
          if (!$scope.userProfile.verifiedUser) {
            $scope.showCon = true;
          }
          // if ($scope.userProfile.userType == 'politician') {
          if (!$scope.userProfile.isEmailVerified || !$scope.userProfile.verifiedUser) {
            // $scope.getPopUp();
            if (!$scope.userProfile.isEmailVerified && !$scope.userProfile.verifiedUser) {
              if ($scope.userProfile.userType == 'politician') {
                $scope.showCon = true;
                $scope.showBoth = true;
              } else if (!$scope.userProfile.isEmailVerified) {
                $scope.showEm = true;
              }
            } else if (!$scope.userProfile.isEmailVerified) {
              // if ($scope.userProfile.userType != 'politician') {
              $scope.showEm = true;
              // }
            } else {
              if ($scope.userProfile.userType != 'politician') {
                $scope.showEm = true;
              }
            }
            if ($scope.userProfile.userType == 'politician') {
              $scope.PopDialog = ngDialog.open({
                template: 'popUp',
                closeByNavigation: true,
                scope: $scope,
                width: '50%',
                closeByDocument: false
              });
            } else if ($scope.userProfile.userType == 'advocate' && $scope.userProfile.isEmailVerified != true) {
              // alert('cal');
              MyService.ConsoleLog("$scope.userProfile", $scope.userProfile.isEmailVerified);
              $scope.PopDialog = ngDialog.open({
                template: 'popUp',
                closeByNavigation: true,
                scope: $scope,
                width: '50%',
                closeByDocument: false
              });
            }
          }
          // }


        } else {
          MyService.ConsoleLog("ELSE vishal");
          alert("Something went wrong.");
        }
      }, function (errorPayload) {
        $scope.ShowPorifleLoading = false;
        MyService.ConsoleLog("ELSE vishal two");

        alert("Something went wrong.");
      });
    };
    if ($cookies.get('showLongPopUp')) {
      var msg = $cookies.get('showLongPopUp');
      // MyService.ConsoleLog("cookies >>>>>", msg);


      var modal = ngDialog.openConfirm({
        template: '<p>' +
          msg +
          '</p>\
                  <div class="ngdialog-buttons">\
                      <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">CLOSE</button>\
                  </div>',
        plain: true,
        closeByDocument: false,
        width: "70%"
      });
      modal.then(
        function fullfilled(data) {
          if (data == 1) {
            // MyService.ConsoleLog("yes")
            $cookies.remove('showLongPopUp');
            $scope.getmyData(tokenService.getUserId());
          } else {
            $cookies.remove('showLongPopUp');

          }
        },
        function rejected(data) {
          $scope.getmyData(tokenService.getUserId());
        }
      );
    } else {
      $scope.getmyData(tokenService.getUserId());

    }

    /**
     * Redirect
     */
    $scope.goto = function () {
      $location.path('/verifyBy');
    };

    /**
     * Close it
     */
    $scope.closeIt = function () {
      $scope.PopDialog.close();
    };

    /**
     * Send Verification mail
     */

    $scope.sendMail = function () {
      MyService.SendVerificationMail({
        verificationUrl: $rootScope.getVerificationUrl(),
        unsubscribeurl: $rootScope.getEmailUnsubscribeUrl()
      }).then(function (response) {
        MyService.ConsoleLog("response", response);
        if (response.data.success) {
          growl.success("Please check your email");
        }
      }, function (err) {
        MyService.ConsoleLog("err", err);
      });
    };
  }]);

'use strict';
angular.module('myApp.gettingStartedOrg', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/gettingStartedOrg', {
      templateUrl: 'app/gettingStartedOrg/gettingStartedOrg.html',
      controller: 'gettingStartedOrgCtrl'
    });
  }])
  .controller('gettingStartedOrgCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', 'growl', '$cookies', 'ngDialog', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService, growl, $cookies, ngDialog) {

    $scope.showCon = false;
    $scope.showBoth = false;
    $scope.showEm = false;

    $scope.ShowPorifleLoading = false;
    $scope.getmyData = function (uid) {
      $scope.ShowPorifleLoading = true;
      MyService.getUserPublicProfile({
        id: uid,
        type: 'false'
      }).then(function (response) {
        $scope.ShowPorifleLoading = false;
        if (response.data.success) {
          $scope.userDetails = response.data.data;
          // MyService.ConsoleLog("welcome", $scope.userDetails);
          $scope.userProfile = $scope.userDetails.userData;
          MyService.ConsoleLog("welcome to profile", $scope.userProfile);

          $scope.userType = $scope.userProfile.userType;
          $scope.verify = $scope.userProfile.verifiedUser;
          // MyService.ConsoleLog("welcome", $scope.verify);
          // console.log("$scope.userDetails", $scope.userDetails.userData.address);
          if (!$scope.userProfile.verifiedUser) {
            $scope.showCon = true;
          }
          // if ($scope.userProfile.userType == 'politician') {
          if (!$scope.userProfile.isEmailVerified || !$scope.userProfile.verifiedUser) {
            // $scope.getPopUp();
            if (!$scope.userProfile.isEmailVerified && !$scope.userProfile.verifiedUser) {
              if ($scope.userProfile.userType == 'politician') {
                $scope.showCon = true;
                $scope.showBoth = true;
              } else if (!$scope.userProfile.isEmailVerified) {
                $scope.showEm = true;
              }
            } else if (!$scope.userProfile.isEmailVerified) {
              // if ($scope.userProfile.userType != 'politician') {
              $scope.showEm = true;
              // }
            } else {
              if ($scope.userProfile.userType != 'politician') {
                $scope.showEm = true;
              }
            }
            if ($scope.userProfile.userType == 'politician') {
              $scope.PopDialog = ngDialog.open({
                template: 'popUp',
                closeByNavigation: true,
                scope: $scope,
                width: '50%',
                closeByDocument: false
              });
            } else if ($scope.userProfile.userType == 'advocate' && $scope.userProfile.isEmailVerified != true) {
              // alert('cal');
              MyService.ConsoleLog("$scope.userProfile", $scope.userProfile.isEmailVerified);
              $scope.PopDialog = ngDialog.open({
                template: 'popUp',
                closeByNavigation: true,
                scope: $scope,
                width: '50%',
                closeByDocument: false
              });
            }
          }
          // }


        } else {
          MyService.ConsoleLog("ELSE vishal");
          alert("Something went wrong.");
        }
      }, function (errorPayload) {
        $scope.ShowPorifleLoading = false;
        MyService.ConsoleLog("ELSE vishal two");

        alert("Something went wrong.");
      });
    };
    if ($cookies.get('showLongPopUp')) {
      var msg = $cookies.get('showLongPopUp');
      MyService.ConsoleLog("cookies >>>>>", msg);


      var modal = ngDialog.openConfirm({
        template: '<p>' +
          msg +
          '</p>\
                  <div class="ngdialog-buttons">\
                      <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">CLOSE</button>\
                  </div>',
        plain: true,
        closeByDocument: false,
        width: "70%"
      });
      modal.then(
        function fullfilled(data) {
          if (data == 1) {
            // MyService.ConsoleLog("yes")
            $cookies.remove('showLongPopUp');
            $scope.getmyData(tokenService.getUserId());
          } else {
            $cookies.remove('showLongPopUp');
          }
        },
        function rejected(data) {
          $scope.getmyData(tokenService.getUserId());

        }
      );
    } else {
      $scope.getmyData(tokenService.getUserId());

    }

    /**
     * Redirect
     */
    $scope.goto = function () {
      $location.path('/verifyBy');
    };

    /**
     * Close it
     */
    $scope.closeIt = function () {
      $scope.PopDialog.close();
    };

    /**
     * Send Verification mail
     */

    $scope.sendMail = function () {
      MyService.SendVerificationMail({
        verificationUrl: $rootScope.getVerificationUrl(),
        unsubscribeurl: $rootScope.getEmailUnsubscribeUrl()
      }).then(function (response) {
        MyService.ConsoleLog("response", response);
        if (response.data.success) {
          growl.success("Please check your email");
        }
      }, function (err) {
        MyService.ConsoleLog("err", err);
      });
    };
  }]);

'use strict';
angular.module('myApp.gettingStarted', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/gettingstarted', {
      templateUrl: 'app/gettingStarted/gettingstarted.html',
      controller: 'gettingStartedCtrl'
    });
  }])
  .controller('gettingStartedCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', 'growl', '$cookies', 'ngDialog', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService, growl, $cookies, ngDialog) {
    if ($cookies.get('showLongPopUp')) {
      var msg = $cookies.get('showLongPopUp');
      MyService.ConsoleLog("cookies >>>>>", msg);


      var modal = ngDialog.openConfirm({
        template: '<p>' +
          msg +
          '</p>\
                  <div class="ngdialog-buttons">\
                      <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">CLOSE</button>\
                  </div>',
        plain: true,
        closeByDocument: false,
        width: "70%"
      });
      modal.then(
        function fullfilled(data) {
          if (data == 1) {
            // MyService.ConsoleLog("yes")
            $cookies.remove('showLongPopUp');
          } else {
            $cookies.remove('showLongPopUp');

          }
        },
        function rejected(data) {

        }
      );
    }


  }]);

"use strict";
angular
  .module("myApp.getRollVotes", ["ngRoute"])

  .config([
    "$routeProvider",
    function($routeProvider) {
      $routeProvider.when("/getRollVotes", {
        templateUrl: "app/getRollVotes/getRollVotes.html",
        controller: "getRollVotesCtrl"
      });
    }
  ])
  .controller("getRollVotesCtrl", ["$scope", "$http", "$location", "apiCall", "$rootScope", "baseApiUrl", "$q", "$filter", "growl", "ngDialog", "tokenService", "MyService", function($scope, $http, $location, apiCall, $rootScope, baseApiUrl, $q, $filter, growl, ngDialog, tokenService, MyService) {
    $scope.loaderOne = false;
    $scope.currPage = 1;
    $scope.addVotes = function() {
      $scope.loaderOne = true;

      MyService.addRollVotes().then(function(response) {
        console.log("response >>>", response);
        $scope.loaderOne = false;

      })
    }


    $scope.myPagingFunction = function() {
      MyService.ConsoleLog('scoll called', $scope.statusGetResPg);
      if ($scope.statusGetResPg != 1 && $scope.serachData > $scope.votesData.length) {
        $scope.currPage++;
        $scope.pageChanged($scope.currPage);
      }
    };

    $scope.pageChanged = function(newPage) {
      $scope.getVotes(newPage);
    };

    $scope.votesData = [];

    $scope.getVotes = function(pageNumber) {
      MyService.ConsoleLog('pageNumber >', pageNumber);
      var params = {
        page: pageNumber,
        max_records: 30
      };
      //MyService.ConsoleLog("params: ", params);
      // $scope.users.data = [];


      $scope.statusGetResPg = 1;

      var getAllCanceller = $q.defer();


      MyService.getVotesData(params, getAllCanceller).then(
        function(result) {
          console.log("RESPONSE >  ", result);
          // $scope.votes = $scope.votes.concat(result.data.data.data);
          $scope.votesData = $scope.votesData.concat(result.data.data.data);

          MyService.ConsoleLog('$scope.open >', $scope.votesData);
          $scope.serachData = result.data.data.count;
          MyService.ConsoleLog("serachData >>", $scope.serachData);
          // console.log($scope.committee);
          // $scope.totalUsers = payload.Count;
          // MyService.ConsoleLog(payload.Items);
          $scope.statusGetResPg = 2;
        },
        function(err) {
          // growl.error('Something went wrong.');
          $scope.statusGetResPg = 3;
          $scope.page--;
        }
      );
    };
    $scope.getVotes();



  }]);

'use strict';
angular
  .module('myApp.getPopularQues', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/getPopularQues/:type?/:orgId?', {
        templateUrl: 'app/getPopularQuestions/getPopularQues.html',
        controller: 'getPopularQuesCtrl',
      });
    },
  ])
  .controller('getPopularQuesCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    '$routeParams',
    '$q',
    'ngDialog',
    '$rootScope',
    'growl',
    'MyService',
    '$anchorScroll',
    '$timeout',
    'tokenService',
    '$cookies',
    'baseApiUrl',
    '$document',
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $q,
      ngDialog,
      $rootScope,
      growl,
      MyService,
      $anchorScroll,
      $timeout,
      tokenService,
      $cookies,
      baseApiUrl,
      $document
    ) {
      $scope.isSelect = {
        voter: false,
        politician: false,
        organization: false,
        catId: '',
        numOfQues: '',
      };
      window.localStorage.removeItem('pQueIds');
      $cookies.remove('isShowPopUp');
      $scope.isShowPopUp = $routeParams.type;
      $cookies.put('isShowPopUp', $scope.isShowPopUp);


      /**
       * @description Find most popular questions by using user types and topics
       * @params user type,  topic, number of questions
       */
      $scope.find = function () {
        MyService.ConsoleLog('$scope.isSelected', $scope.isSelect);
        if ($scope.isSelect.voter || $scope.isSelect.politician || $scope.isSelect.organization) {
          MyService.getPopularQuestion($scope.isSelect).then(
            function (sdata) {
              MyService.ConsoleLog('sdata', sdata.data);
              if (sdata && sdata.data.length > 0) {
                window.localStorage.removeItem('queIds');
                window.localStorage.setItem('pQueIds', JSON.stringify(sdata.data));
                $location.path('/organizationQuiz');
              }

            },
            function (err) {
              growl.error(err);
            }
          );
        } else {
          growl.error('Please select at least one user type');
        }
      };

      /**Get Parent Categories */

      $scope.getParentCategoriesOne = function () {
        $rootScope.subCategory = '';
        $scope.statusGetCats = 1;
        var request = apiCall.apiCall('GET', '/categories/list', {
          root: 1,
          questions_counter: 0,
          catTypes: 'Q',
        });
        $http(request).then(
          function successCallback(response) {
            MyService.ConsoleLog('data :', response);
            $scope.parentCategories = response.data.data;
            if (response.data.success) {
              $scope.selCatForQues = [{
                selected: null,
                viewOrders: 0,
                items: $scope.parentCategories,
              }, ];
              $scope.questions = [];
              $scope.statusGetCats = 2;
            } else {
              growl.error('Something went wrong');
              $scope.statusGetCats = 3;
            }
          },
          function errorCallBack(response) {
            growl.error('Something went wrong');
            $scope.statusGetCats = 3;
          }
        );
      };

      $scope.getParentCategoriesOne();
      var getQuestoinsCanceler = $q.defer();

      var selQuesCategoryCanceler = $q.defer();
      $scope.statusSubCat = 0;
      $scope.selQuesCategory = function (cat, index) {
        selQuesCategoryCanceler.resolve();
        cat = JSON.parse(cat);
        //MyService.ConsoleLog("tempFun index: ", index);
        //remove all elements after given index
        // $scope.parCat = cat;
        $scope.questions = [];
        getQuestoinsCanceler.resolve();
        selQuesCategoryCanceler = $q.defer();

        $scope.selCatForQues.length = index + 1;

        var params = {
          questions_counter: 0,
          parentId: cat._id,
          catTypes: 'Q',
        };
        var request = apiCall.apiCall('GET', '/categories/list', params);
        request.timeout = selQuesCategoryCanceler.promise;
        $scope.statusSubCat = 1;
        $http(request).then(
          function successCallback(response) {
            //MyService.ConsoleLog("************ in success callback ***************");
            if (response.data.success) {
              MyService.ConsoleLog('Got subcategory data: ', response.data.data);
              MyService.ConsoleLog('cat ', cat);

              if (response.data.data.length == 0) {
                $scope.subCategory = cat;
              }
              MyService.ConsoleLog('$rootScope.subCategory', $scope.subCategory);
              $scope.isSelect.catId = $scope.subCategory._id;

              if (response.data.data.length > 0)
                $scope.selCatForQues.push({
                  selected: null,
                  viewOrders: 0,
                  items: response.data.data,
                });
              else if (response.data.data.length == 0) {}
              $scope.statusSubCat = 2;
            } else {
              //MyService.ConsoleLog("Something went wrong: ", response.data);
              $scope.statusSubCat = 3;
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
            $scope.statusSubCat = 3;
          }
        );
      };
    },
  ]);

'use strict';

angular.module('myApp.getPopularComparison', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/getPopularComparison/:type?', {
      templateUrl: 'app/getPopularComparison/getPopularComparison.html',
      controller: 'getPopularComparisonCtrl'
    });
  }]).controller('getPopularComparisonCtrl', ['$scope', 'apiCall', 'MyService', '$location', '$anchorScroll', '$timeout', '$rootScope', 'ngDialog', '$q', '$http', '$filter', 'growl', '$routeParams', 'baseApiUrl', 'tokenService', '$cookies', function ($scope, apiCall, MyService, $location, $anchorScroll, $timeout, $rootScope, ngDialog, $q, $http, $filter, growl, $routeParams, baseApiUrl, tokenService, $cookies) {

    $scope.loader = false;
    $scope.noDataFound = false;
    $scope.FBCompareList = [];
    $scope.politician = false;
    $scope.showvoter = false;
    $scope.showadv = false;
    $scope.shownonUser = false;

    if (tokenService.getUserId()) {
      $scope.userId = tokenService.getUserId();
      console.log('$scope.userId: ', $scope.userId);
      MyService.ConsoleLog("$cookies", $cookies.get('advId'));
    }



    $scope.compareWithAll = function (params) {
      $scope.loader = true;

      MyService.ConsoleLog("params >", params);
      // params.usersIds = JSON.stringify(params.usersIds);
      params.usersIds = [];
      params.usersIds.push($cookies.get('advId'));
      params.usersIds = JSON.stringify(params.usersIds);
      // params.questions = JSON.parse(params.questions);
      MyService.getPopularComparison(params).then(function (payload) {
          MyService.ConsoleLog("payload >", payload);
          $scope.loader = false;

          if (payload.data.data.unweightedMatch && payload.data.data.unweightedMatch != "") {
            $scope.FBunWeighted = payload.data.data.unweightedMatch;
            $scope.politician = true;

          }
          if (payload.data.data.advunWeighated && payload.data.data.advunWeighated != "") {
            $scope.advUnWeighated = payload.data.data.advunWeighated;
            $scope.showadv = true;

          }
          if (payload.data.data.finalunFbcombinedWeight && payload.data.data.finalunFbcombinedWeight != "") {
            $scope.unVerifiedWeighated = payload.data.data.finalunFbcombinedWeight;
            $scope.shownonUser = true;

          }
          if (payload.data.data.voterunWeight && payload.data.data.voterunWeight != "") {
            $scope.voterUnWeighated = payload.data.data.voterunWeight;
            $scope.showvoter = true;

          }
          $scope.fbcombinedWeight = payload.data.data.fbcombinedWeight;
          $scope.fbmultiplier = payload.data.data.fbmultiplier;
          $scope.fbqlen = payload.data.data.qdata.length;
          $scope.unVerifiedFBunWeighted = payload.data.data.finalUnFacbook;
          $scope.unFbmultiplier = payload.data.data.unFbmultiplier;
          $scope.voterCombined = payload.data.data.voterCombWeight;
          $scope.voterMulti = payload.data.data.voterMulti;
          $scope.advCombined = payload.data.data.advCombWeight;
          $scope.advMulti = payload.data.data.advMulti;
          $scope.orgName = payload.data.data.orgName;
          if (payload.data.data && payload.data.data.qdata && payload.data.data.qdata.length > 0) {
            if ((JSON.stringify(payload.data.data.qdata[0].answers) != JSON.stringify({}))) {
              $scope.ansCnt = payload.data.data.qdata[0].answers ? payload.data.data.qdata[0].answers.advocate.length : '';
            }

          }

          if ((JSON.stringify($scope.advCombined) == JSON.stringify({}))) {
            var message = 'Sorry, there is no final comparison because the organization hasn’t answered any of the questions in their quiz.';
            var modal = ngDialog.openConfirm({
              template: '<p>' +
                message +
                '</p>\
            <div class="ngdialog-buttons">\
                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(0)">OK</button>\
            </div>',
              plain: true,
              closeByDocument: false,
            });
            modal.then(
              function fullfilled(data) {

              },
              function rejected(data) {
                // MyService.ConsoleLog("rejected: ", data);
                // $scope.getMatchQUestions();
              }
            );
          }
        },
        function (error) {
          MyService.ConsoleLog("error", error);
        });
    };

    if (window.localStorage.getItem('comData')) {
      // var ques = window.localStorage.getItem('quesData');
      $scope.compare = JSON.parse(window.localStorage.getItem('comData'));
      MyService.ConsoleLog("<<<<<<<<<<<< questions >>>>>>>>>>>", $scope.compare);
      $scope.compareWithAll($scope.compare);
    }

    $scope.finalSignIn = function () {

      $location.path('/fiveSaveUser');
    };

  }]);

'use strict';
angular
  .module('myApp.getBillVoteRecords', ['ngRoute'])

  .config([
    '$routeProvider',
    function($routeProvider) {
      $routeProvider.when('/getBillVoteRecords/:id/:type?', {
        templateUrl: 'app/getBillVoteRecords/getBillVoteRecords.html',
        controller: 'getBillVoteRecordsCtrl'
      });
    }
  ])
  .controller('getBillVoteRecordsCtrl', [
    '$scope',
    'ngDialog',
    '$rootScope',
    'MyService',
    '$http',
    '$timeout',
    '$q',
    '$routeParams',
    function($scope, ngDialog, $rootScope, MyService, $http, $timeout, $q, $routeParams) {
      $scope.userId = $routeParams.id;
      $scope.type = $routeParams.type;
      $scope.show = false;
      $scope.more = [];
      $scope.documents = [];
      $scope.currPage = 1;
      $scope.alert = false;
      $scope.userProfile = [];
      if ($rootScope.userData) {
        $scope.userProfile = $rootScope.userData;
      }
      $scope.activeSpo = true;
      $scope.activeAct = true;
      $scope.activeDoc = true;
      $scope.activeVot = true;
      $scope.showLoader = false;
      $scope.bill = [];
      $scope.voter = [];


      console.log("typw  >>", $scope.type);
      console.log("id >", $scope.userId);

      $scope.myPagingFunction = function() {
        MyService.ConsoleLog('scoll called', $scope.statusGetResPg);
        if ($scope.statusGetResPg != 1 && $scope.searchData > $scope.bill.length) {
          $scope.currPage++;
          $scope.pageChanged($scope.currPage);
        }
      };

      $scope.pageChanged = function(newPage) {
        $scope.getBillVotes(newPage);
      };
      $scope.openBills = [];
      $scope.searchCandy = {
        'search': ""
      };
      $scope.searchData = 0;
      $scope.SearchByTitle = function() {
        // MyService.ConsoleLog('in searchMe', $scope.search.sdata);
        // var query = $scope.search.sdata.toUpperCase();
        var pageNumber = 1;
        var params = {
          page: pageNumber,
          max_records: 30,
          title: $scope.searchCandy.search,
          "id": $scope.userId,
          "type": $scope.type
        };
        //MyService.ConsoleLog("params: ", params);
        // $scope.users.data = [];

        // $scope.statusGetResPg = 1;

        var getAllCanceller = $q.defer();
     

        MyService.ConsoleLog('in searchMe', $scope.currPage);

        MyService.SearchByTitle(params, getAllCanceller).then(
          function(response) {
            MyService.ConsoleLog('response >> ',response);
            $scope.bill.length = 0;
            $scope.bill = response.data;
            $scope.searchData = response.count;
            

          },
          function(error) {
            MyService.ConsoleLog('Error>>', error);
          }
        );
      };

      // $scope.searchMe = function(user) {
      //   // MyService.ConsoleLog('in searchMe', user);
      //   var query = $scope.searchCandy.search.toLowerCase(),
      //     fullname = user.title.toLowerCase();

      //   if (fullname.indexOf(query) != -1) {
      //     return true;
      //   }
      //   return false;
      // };

      $scope.getBillVotes = function(pageNumber) {
        $scope.showLoader = true;

        // $scope.votes.length = 0;
        MyService.ConsoleLog('pageNumber >', pageNumber);
        var params = {
          page: pageNumber,
          max_records: 30,
          "id": $scope.userId,
          "type": $scope.type
        };
        //MyService.ConsoleLog("params: ", params);
        // $scope.users.data = [];

        $scope.statusGetResPg = 1;

        var getAllCanceller = $q.defer();
        var calc = (pageNumber - 1) * 30;

        MyService.getBillVotes(params, getAllCanceller).then(
          function(result) {
            console.log("RESPONSE >  ", result[0]);

            $scope.bill = $scope.bill.concat(result[0].billSpoData);
            $scope.searchData = result[0].count;
            console.log("Bills >>", $scope.bill);
            $scope.show = false;
            $scope.showLoader = false;



            $scope.statusGetResPg = 2;
          },
          function(err) {
            growl.error('Something went wrong.');
            $scope.statusGetResPg = 3;
            $scope.page--;
          }
        );
      };

      $scope.getBillVotes(1);
      $scope.myPagingFunctionOne = function() {
        MyService.ConsoleLog('scoll called', $scope.statusGetResPg);
        if ($scope.statusGetResPg != 1 ) {
          $scope.currPage++;
          $scope.pageChangedOne($scope.currPage);
        }
      };


      $scope.pageChangedOne = function(newPage) {
        $scope.getVotes(newPage);
      };

      $scope.searchCandy = {
        'search': ""
      };


      $scope.getVotes = function(pageNumber) {
        $scope.showLoader = true;
        // $scope.bill.length = 0;
        MyService.ConsoleLog('pageNumber >', pageNumber);
        var params = {
          page: pageNumber,
          max_records: 30,
          "id": $scope.userId,
          "type": $scope.type
        };
        //MyService.ConsoleLog("params: ", params);
        // $scope.users.data = [];
        $scope.totalUsers = 0;

        $scope.statusGetResPg = 1;

        var getAllCanceller = $q.defer();
        var calc = (pageNumber - 1) * 30;

        MyService.getBillVotes(params, getAllCanceller).then(
          function(result) {
            console.log("RESPONSE >  ", result[0]);

            if (result[0].voterData.length > 0) {
              $scope.votes = $scope.votes.concat(result[0].voterData);
              console.log("Bills >>", $scope.bill);
              $scope.show = true;



              $scope.statusGetResPg = 2;
            } else {
              $scope.show = true;
                  $scope.showLoader = false;

              // alert('else');
              $(document).ready(function() {
                $scope.alert = true;
                setTimeout(function() {
                  $('.alert').alert('close');

                }, 2000);
              });
              $scope.statusGetResPg = 2;

            }
          },
          function(err) {
            growl.error('Something went wrong.');
            $scope.statusGetResPg = 3;
            $scope.page--;
          }
        );
      };

      $scope.getDetailsOfCandidates = function(val) {

        $scope.more[val] = true;
        $scope.documents[val] = true;


      };
      $scope.showLess = function(valOne) {
        $scope.more[valOne] = false;
        $scope.documents[valOne] = false;

      }
    }
  ]);

'use strict';

angular.module('myApp.getAReminder', ['ngRoute'])

.config(['$routeProvider', function ($routeProvider) {
     $routeProvider.when('/getAReminder', {
         templateUrl: 'app/getAReminder/getAReminder.html',
         controller: 'getAReminderCtrl' 
     });
}])
.controller('getAReminderCtrl', ['$scope', '$rootScope', function($scope, $rootScope) {
$rootScope.welcome = false;
}]);

'use strict';
angular.module('myApp.geoCode', ['ngRoute'])

  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/geoCode', {
      templateUrl: 'app/geoCode/geoCode.html',
      controller: 'geoCodeCtrl'
    });
  }])
  .controller('geoCodeCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService) {

  }]);

"use strict";
angular
  .module("myApp.generatePostCards", ["ngRoute"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/generatePostCards", {
        templateUrl: "app/generatePostCards/generatePostCard.html",
        controller: "generatePostCardsCtrl",
      });
    },
  ])
  .controller("generatePostCardsCtrl", [
    "$scope",
    "$location",
    "$rootScope",
    "tokenService",
    "MyService",
    "ngDialog",
    "growl",
    "$filter",
    "$q",
    "$window",
    "baseApiUrl",
    function (
      $scope,
      $location,
      $rootScope,
      tokenService,
      MyService,
      ngDialog,
      growl,
      $filter,
      $q,
      $window,
      baseApiUrl
    ) {
      $scope.allState = [];
      $scope.params = {
        state: "",
        electionDate: "",
      };
      $scope.imgUrl = baseApiUrl + "/resources";
      /**
       * @description Get the list of the States
       */

      $scope.getAllStates = function () {
        $scope.allState.length = 0;
        $scope.loader = true;
        // console.log("address.state", $scope.address.state);
        MyService.getAllStates().then(
          function (payload) {
            $scope.allState = payload;
            $scope.loader = false;
            $scope.getElectionDates();
          },
          function (errorPayload) {
            growl.error("Something went wrong.");
            $scope.loader = false;
          }
        );
      };

      /**
       * @description Get the list of the elections dates
       */
      $scope.getElectionDates = function () {
        MyService.getListOfDates().then(
          function (APIResponse) {
            MyService.ConsoleLog("APIResponse >> ", APIResponse);
            if (APIResponse.data.success) {
              var datesArr = [];
              var mainArr = APIResponse.data.data.map(function (item, index) {
                if (item && item != null) {
                  var date = new Date(item).toGMTString();

                  var par = {
                    _id: index,
                    eDate: date.substr(5, 12),
                    date: item,
                  };
                  datesArr.push(par);
                }
              });
              MyService.ConsoleLog("datesArr >> ", datesArr[0].eDate);
              $scope.electionDates = datesArr;

              $scope.electionDates.sort(function (a, b) {
                if (a != null && b != null) {
                  return new Date(b.date) - new Date(a.date);
                }
              });
              // $scope.quiz.eDate = $scope.electionDates[0];

              MyService.ConsoleLog("$scope.quiz >> ", $scope.quiz);
              MyService.ConsoleLog(
                "$scope.electionDates >> ",
                $scope.electionDates
              );
            }
          },
          function (err) {
            MyService.ConsoleLog("error", err);
          }
        );
      };

      $scope.generatePostCard = function () {
        console.log("$scope.params ", $scope.params);

        if (
          $scope.params &&
          $scope.params.state &&
          $scope.params.electionDate
        ) {
          MyService.generatePostCard({
            state: $scope.params.state.state,
            electionDate: $scope.params.electionDate.date,
            statePostalCode: $scope.params.state.statePostalCode,
          }).then(function (APIReponse) {
            MyService.ConsoleLog("APIResponse >> ", APIReponse);
            $scope.showExportLink = true;
            $window.open($scope.imgUrl + "/postCards.xlsx", "_blank");
          });
        } else {
          growl.error(
            "Please select state and election date to generate the postcards"
          );
        }
      };

      $scope.getAllStates();
    },
  ]);

'use strict';
angular.module('myApp.forumthread', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/forumthread/:categoryId/:subcatId/:forumId/:location?', {
      templateUrl: 'app/forumthread/forumthread.html',
      controller: 'forumthreadCtrl'
    });
  }])
  .filter('refineData', ['tokenService', function (tokenService) {
    return function (data, filterBy) {
      //MyService.ConsoleLog("data: ",data," filterBy: ",filterBy);
      var userData = tokenService.getUserData();
      if (userData) {
        userData = JSON.parse(userData);
      }
      if (!filterBy || filterBy == 'all')
        return data;
      var tempArr = [];
      angular.forEach(data, function (val, key) {
        //MyService.ConsoleLog("key: ",key);
        if (filterBy == 'following') {
          if (userData && userData.followlist) {
            if (userData.followlist.indexOf(val.createdBy.id) > -1)
              tempArr.push(val);
          }
        } else {
          if (val.createdBy.utype == filterBy) {
            tempArr.push(val)
          }
        }
      });
      //MyService.ConsoleLog("tempArr: ", tempArr);
      return tempArr;
    };
  }])
  .controller('forumthreadCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'growl', 'tokenService', '$anchorScroll', 'ngDialog', 'MyService', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, growl, tokenService, $anchorScroll, ngDialog, MyService) {
    //MyService.ConsoleLog("** forumCtrl ** :", $routeParams);
    $rootScope.welcome = false;
    $scope.categoryId = $routeParams.categoryId;
    $scope.subcategoryId = $routeParams.subcatId;
    $scope.forumId = $routeParams.forumId;
    $scope.userType = tokenService.getUserRole();
    if (tokenService.getUserData()) {
      $scope.userData = JSON.parse(tokenService.getUserData());
      MyService.ConsoleLog("$scope.userData", $scope.userData);

    }
    $scope.getUserProfile = function () {
      MyService.getProfile($scope.userData.id).then(
        function (userData) {
          $scope.usersData = userData;
          MyService.ConsoleLog('userData: ', $scope.userData);
        },
        function (err) {
          growl.error('Something went wrong while fetching user info.');
        }
      );
    };



    $scope.filterArray = ['all', 'politician', 'voter', 'press', 'advocate', 'following'];
    $scope.sortArray = ['Newest first', 'Since last login'];
    $scope.sortBy = 'Select sort';
    $scope.statusLoading = false;
    $scope.froumthreads = [];
    $scope.mainThread = {};
    $scope.Sticky = {
      ShowOrder: [],
      txtOrder: []
    };
    $rootScope.showSpam = false;
    $scope.page = 1;
    $scope.totalRecords = 0;
    $scope.max_records = 25; // this should match however many results your API puts on one page

    $scope.pagination = {
      current: 1
    };

    $scope.displayReply = true;
    $scope.Reply = {};

    $scope.checkMemId = function (rdata, val) {
      return rdata.filter(
        function (rdata) {

          if (rdata.userData._id == $rootScope.UserId)
            return rdata
        }
      );
    }
    $scope.statusLoading = 0;

    $scope.getForumDetails = function (page) {
      $scope.statusLoading = true;
      if ($scope.userData) {
        var LastLogin = $scope.userData.lastLogin
      } else {
        var LastLogin = "";
      }
      //$scope.totalRecords = 1;
      MyService.getOneTopic({
        topicId: $routeParams.forumId,
        "page": page,
        max_records: $scope.max_records,
        sort_by: $scope.sortBy,
        last_login: LastLogin
      }).then(function (payload) {
        MyService.ConsoleLog(payload);
        $scope.froumthreads = $scope.froumthreads.concat(payload.data);
        //MyService.ConsoleLog($scope.froumthreads);
        $scope.totalRecords = payload.Count;
        if (page == 1) {
          $scope.mainThread = $scope.froumthreads[0];
        }

        $scope.statusLoading = 2;
        $timeout(function () {
          if ($routeParams.location) {
            var id = $location.hash();
            $location.hash($routeParams.location);
            $anchorScroll();
            $location.hash(id);
          }
        }, 500);
      }, function (errorPayload) {
        $scope.statusLoading = 3;
        MyService.ConsoleLog(errorPayload);
        if (errorPayload.data && errorPayload.data.error) {
          alert("Error : " + errorPayload.data.error);
        }

      });
    }

    if ($scope.userData && $scope.userData.id != '') {
      $scope.getUserProfile();
    }

    $scope.SortData = function () {
      MyService.ConsoleLog($scope.sortBy);
      if ($scope.sortBy == 'Since last login') {
        if ($scope.usersData && $scope.usersData.lastLoginOld != '') {
          var lastOldLogIn = new Date($scope.usersData.lastLoginOld);
          // MyService.ConsoleLog("lastOldLogIn", lastOldLogIn);
          var lens = $scope.froumthreads.length;
          for (var i = 0; i < lens; i++) {
            var lastLoginDate = new Date($scope.usersData.lastLogin);
            var createdOn = new Date($scope.froumthreads[i].createdOn);
            // MyService.ConsoleLog("lastOldLogIn.toISOString().split('T')[0] < createdOn.toISOString().split('T')[0]", lastOldLogIn.toISOString().split('T')[0] + "<=" + createdOn.toISOString().split('T')[0])
            if (lastLoginDate <= createdOn) {
              MyService.ConsoleLog("lastLoginDate", lastLoginDate);
              MyService.ConsoleLog("createdOn", createdOn);
              MyService.ConsoleLog("'thread-' + itms._id", 'thread-' + $scope.froumthreads[i]._id);
              $location.hash('thread-' + $scope.froumthreads[i]._id);
              $anchorScroll();
              break;
              // return itms;
            } else if (lastOldLogIn.toISOString().split('T')[0] <= createdOn.toISOString().split('T')[0]) {
              MyService.ConsoleLog("else");
              $location.hash('thread-' + $scope.froumthreads[i]._id);
              $anchorScroll();
              break;
            }
          }
        }
      } else {

        $scope.page = 0;
        $scope.froumthreads.length = 0;
        $scope.getForumDetails($scope.page);
      }
      //alert("Sort Data called");
    }

    $scope.showSpam = [];
    $scope.DisplaySpam = function (id) {
      //alert(id);
      var idx = $scope.showSpam.indexOf(id);
      if (idx == -1) {
        $scope.showSpam.push(id);
      } else {
        $scope.showSpam.splice(idx, 1);
      }
      //MyService.ConsoleLog($scope.showSpam);
    }

    function getSubCategories() {
      var request = apiCall.apiCall('GET', '/categories/list', {
        id: $routeParams.subcatId
      });
      $http(
        request
      ).then(function successCallback(response) {
        if (response.data.success) {
          $scope.subcategory = response.data.data;
        }
      }, function errorCallBack(response) {
        alert("Error: " + response);
      });
    }

    function getCategory() {
      var request = apiCall.apiCall('GET', '/categories/list', {
        id: $routeParams.categoryId
      });
      $http(
        request
      ).then(function successCallback(response) {
        //MyService.ConsoleLog("Got categories: ", response);
        if (response.data.success) {
          $scope.category = response.data.data;
        }
      }, function errorCallBack(response) {
        alert("Error: " + response);
      });
    }

    $scope.updateForumApi = function (data, options, idex) {
      MyService.updateTopic(data).then(function (response) {
        if (response.data.success) {
          if (response.data.data.nModified == 0) {
            alert("You already provided your inputs on this post");
          } else {
            switch (options) {
              case 'like':
                $scope.froumthreads[idex].likes = $scope.froumthreads[idex].likes + 1;
                break;
              case 'dislike':
                $scope.froumthreads[idex].dislikes = $scope.froumthreads[idex].dislikes + 1;
                break;
              case 'sticky':
                $routeParams.location = data.topicId;
                $scope.page = 1;
                $scope.getForumDetails($scope.page);
                break;
              case 'removeSticky':
                $routeParams.location = data.topicId;
                $scope.page = 1;
                $scope.getForumDetails($scope.page);
                break;
              default:
                $scope.froumthreads[idex].spam = $scope.froumthreads[idex].spam + 1;
                break;
            }
          }
        } else {
          if (response.data.error) {
            alert(response.data.error);
            //MyService.ConsoleLog(response.data);
            if ((response.data.status) && (response.data.status == "405")) {
              var msg = "Do you want to send request to Admin to reactivate your account?.";
              MyService.GetDialogWithButtons(ngDialog, msg, "YES", "NO").then(function (payload) {
                MyService.sendActivatationMailtoAdmin().then(function (payload) {
                  alert("Request sent successfully to admin");
                }, function (errorPayload) {
                  alert("Something went wrong");
                })
              }, function (errorPayload) {
                //MyService.ConsoleLog(errorPayload);
              });
            }
          }
        }
      }, function (errorPayload) {
        //MyService.ConsoleLog("Error: ", response);
      });
    }



    $scope.updateForum = function (options, id, forumd) {
      var idex = $scope.froumthreads.indexOf(forumd);
      //alert(idex);
      if (options == "spam") {
        var message = "Are you sure you want to report this comment as spam or abusive?";
        var modal = ngDialog.openConfirm({
          template: '<p>' + message + '</p>\
            <div class="ngdialog-buttons">\
                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">YES</button>\
                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">NO</button>\
            </div>',
          plain: true
        });
        modal.then(function fullfilled(data) {
          //MyService.ConsoleLog("fullfilled: ", mydata);
          if ($rootScope.UserId) {
            var forumData = {};
            forumData.topicId = id;
            forumData.userId = $rootScope.UserId;
            if ((options == "sticky" || options == "removeSticky") && ($scope.userType == 'admin')) {
              if (options == "sticky") {
                forumData.sticky = 1;
                forumData.stickyOrder = $scope.Sticky.txtOrder[id];
              } else if (options == "removeSticky") {
                forumData.removeSticky = 1;
              }
              $scope.updateForumApi(forumData, options, idex);
            } else if ($scope.froumthreads[idex].createdBy.id != $rootScope.UserId) {
              switch (options) {
                case 'like':
                  forumData.likes = 1;
                  break;
                case 'dislike':
                  forumData.dislikes = 1;
                  break;
                case 'sticky':
                  forumData.sticky = 1;
                  forumData.stickyOrder = $scope.Sticky.txtOrder[id];
                  break;
                case 'removeSticky':
                  forumData.removeSticky = 1;
                  break;
                default:
                  forumData.spam = 1;
                  break;
              }
              $scope.updateForumApi(forumData, options, idex);
            } else {
              alert("You cannot " + options + " your own post");
            }
          } else {
            alert("Please login to perform these actions");
          }
        }, function rejected(data) {
          //MyService.ConsoleLog("rejected: ", data);
        });

      } else {
        if ($rootScope.UserId) {
          var forumData = {};
          forumData.topicId = id;
          forumData.userId = $rootScope.UserId;
          if ((options == "sticky" || options == "removeSticky") && ($scope.userType == 'admin')) {
            if (options == "sticky") {
              forumData.sticky = 1;
              forumData.stickyOrder = $scope.Sticky.txtOrder[id];
            } else if (options == "removeSticky") {
              forumData.removeSticky = 1;
            }
            $scope.updateForumApi(forumData, options, idex);
          } else if ($scope.froumthreads[idex].createdBy.id != $rootScope.UserId) {
            switch (options) {
              case 'like':
                forumData.likes = 1;
                break;
              case 'dislike':
                forumData.dislikes = 1;
                break;
              case 'sticky':
                forumData.sticky = 1;
                forumData.stickyOrder = $scope.Sticky.txtOrder[id];
                break;
              case 'removeSticky':
                forumData.removeSticky = 1;
                break;
              default:
                forumData.spam = 1;
                break;
            }
            $scope.updateForumApi(forumData, options, idex);
          } else {
            alert("You cannot " + options + " your own post");
          }
        } else {
          alert("Please login to perform these actions");
        }

      }
    }

    $scope.submitSticky = function (data, id, idx) {
      if (data > 0) {
        updateForum('sticky', id, idx);
      } else {
        alert("Please enter valid order");
      }
    }

    $scope.ShowReply = false;
    $scope.redirectToReply = function () {
      if (!$rootScope.UserId) {
        $location.path('signin');
      }
      $scope.ShowReply = true;
      $scope.displayReply = false;
      //$location.path('forumReply/'+$routeParams.categoryId+'/'+$routeParams.subcatId+'/'+$routeParams.forumId);
    }

    $scope.editDescription = "";

    $scope.editThread = function (item) {
      $scope.editDescription = item;
      $scope.editDescription.description = item.description.replace(" ...(updated)", "");;
      var editModal = ngDialog.open({
        template: 'templateId',
        scope: $scope
      });
    }

    $scope.removeThread = function (mydata) {
      if (!mydata.parent) {
        var message = 'This is a parent thread. Removing it will remove all the comments added to this thread. Do you want to proceed?';
      } else {
        var message = 'Are you sure you want to delete this comment?';
      }

      var modal = ngDialog.openConfirm({
        template: '<p>' + message + '</p>\
            <div class="ngdialog-buttons">\
                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">YES</button>\
                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">NO</button>\
            </div>',
        plain: true
      });
      modal.then(function fullfilled(data) {
        //MyService.ConsoleLog("fullfilled: ", mydata);
        MyService.removeSpamTopic({
          "id": mydata._id
        }).then(function (payload) {
          //MyService.ConsoleLog(payload);
          //$scope.UserFormDiv = false;
          //$scope.getSpamTopics(1);
          alert("Topic deleted successfully.");
          if (!mydata.parent) {
            $location.path("/forum/" + $routeParams.categoryId + "/home")
          } else {
            $scope.sortBy = 'Select sort';
            $scope.froumthreads.length = 0;
            $scope.page = 1;
            $scope.getForumDetails($scope.page);
          }
        }, function (error) {
          alert(JSON.stringify(error));
        });
      }, function rejected(data) {
        //MyService.ConsoleLog("rejected: ", data);
      });
    }


    $scope.notSpam = function (mydata) {
      var message = 'This action will mark this thread as not spam and it will be visible again. Do you want to proceed?';
      var modal = ngDialog.openConfirm({
        template: '<p>' + message + '</p>\
            <div class="ngdialog-buttons">\
                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">YES</button>\
                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">NO</button>\
            </div>',
        plain: true
      });
      modal.then(function fullfilled(data) {
        //MyService.ConsoleLog("fullfilled: ", mydata);
        MyService.notSpamTopic({
          "id": mydata._id
        }).then(function (payload) {
          //MyService.ConsoleLog(payload);
          //$scope.UserFormDiv = false;
          $scope.sortBy = 'Select sort';
          $scope.froumthreads.length = 0;
          $scope.page = 1;
          $scope.getForumDetails($scope.page);
          alert("Topic is updated and visible.");
        }, function (error) {
          alert(JSON.stringify(error));
        });
      }, function rejected(data) {
        MyService.ConsoleLog("rejected: ", data);
      });
    }

    $scope.spamMessage = '';
    $scope.spamData = '';
    $scope.dialogClose = "";
    $scope.sendMessage = function (data) {
      $scope.spamData = data;
      $scope.dialogClose = ngDialog.open({
        template: 'sendMessage',
        scope: $scope
      });
    };

    $scope.sendMail = function (msg) {

      if ($scope.spamData.createdBy.id) {
        var msgurl = 'https://votewise.co/#!/forumthread/' + $routeParams.categoryId + '/' + $routeParams.subcatId + '/' + $routeParams.forumId;
        MyService.spamMail({
          "id": $scope.spamData.createdBy.id,
          "msg": msg,
          "msgurl": msgurl
        }).then(function (payload) {
          MyService.ConsoleLog(payload);
          if (payload.data.success) {
            ngDialog.close('sendMessage');
            $scope.dialogClose.close();
            alert("Message send successfully.");
          } else {
            alert(payload.data.data);
          }
        }, function (errorPayload) {
          alert("Something went wrong");
        });
      } else {
        alert("Something went wrong");
      }
      //alert("This is not implemented yet");
    }

    /**
     * Send verification mail
     */

    $scope.sendVeriMail = function () {
      MyService.SendVerificationMail({
        verificationUrl: $rootScope.getVerificationUrl(),
        unsubscribeurl: $rootScope.getEmailUnsubscribeUrl()
      }).then(function (response) {
        MyService.ConsoleLog("response", response);
        if (response.data.success) {
          growl.success("Please check your email");
        }
      }, function (err) {
        MyService.ConsoleLog("err", err);
      });
    };

    $scope.UpdateReply = function (data) {
      //MyService.ConsoleLog(data);
      if (data.description != "") {
        data.topicId = data._id;
        data.parentcat = JSON.stringify(data.parentCat);
        data.location = JSON.stringify(data.location);
        data.subcategories = JSON.stringify(data.subCategories);
        data.description = data.description + " ...(updated)"
        MyService.updateTopic(data).then(function (payload) {
          //MyService.ConsoleLog("payload : ", payload);
          ngDialog.closeAll();
          alert("Comments updated");

        }, function (errorPayload) {
          //MyService.ConsoleLog("errorPayload : ", errorPayload);
        });
      } else {
        alert("Comment should not be empty");
      }
    }

    $scope.showStickyOrder = function (id) {
      $scope.Sticky.ShowOrder[id] = true;
    }

    $scope.goBack = function () {
      $scope.ShowReply = false;
      $scope.displayReply = true;
    }

    $scope.SubmitReply = function (rec) {
      //MyService.ConsoleLog(data);
      //MyService.ConsoleLog($scope.mainThread);
      var data = {};
      if (rec.description != "") {
        $scope.TopicButton = true;
        data.title = "RE: " + $scope.mainThread.title;
        data.parentcat = JSON.stringify($scope.mainThread.parentCat);
        data.subcategories = JSON.stringify($scope.mainThread.subCategories);
        data.createdById = $rootScope.UserId;
        data.createdByName = rec.screenname || $scope.userData.name || $rootScope.User;
        data.createdByType = tokenService.getUserRole();
        data.location = JSON.stringify($scope.mainThread.location);
        data.restrictedTo = $scope.mainThread.restrictedTo;
        data.parent = $routeParams.forumId;
        data.description = rec.description;
        //MyService.ConsoleLog(data);
        var request = apiCall.apiCall('POST', '/topics/create', data);

        $http(
          request
        ).then(function successCallback(response) {
          // MyService.ConsoleLog("reply success");
          $scope.TopicButton = false;
          // MyService.ConsoleLog(response);
          if (response.data.success) {
            //MyService.ConsoleLog("Check the response");
            //MyService.ConsoleLog(response.data);
            $scope.Reply = {
              description: ''
            };
            $scope.ShowReply = false;
            $scope.displayReply = true;
            $scope.mainThread = {};
            $scope.sortBy = 'Select sort';
            $scope.froumthreads.length = 0;
            //$location.path('forumthread/'+$routeParams.categoryId+'/'+$routeParams.subcatId+'/'+$routeParams.forumId);
            $scope.page = 1;
            $scope.getForumDetails($scope.page);
            //$scope.froumthreads.push(response.data.data)
          } else {
            if (response.data.error) {
              alert(response.data.error);
              //MyService.ConsoleLog(response.data);
              if ((response.data.status) && (response.data.status == "405")) {
                var msg = "Do you want to send request to Admin to reactivate your account?.";
                MyService.GetDialogWithButtons(ngDialog, msg, "YES", "NO").then(function (payload) {
                  MyService.sendActivatationMailtoAdmin().then(function (payload) {
                    alert("Request sent successfully to admin");
                  }, function (errorPayload) {
                    alert("Something went wrong");
                  })
                }, function (errorPayload) {
                  //MyService.ConsoleLog(errorPayload);
                });
              }
            }
          }
        }, function errorCallBack(response) {
          //MyService.ConsoleLog("Error: ",response);
        });
      }
    }

    $scope.pageChanged = function (newPage) {
      $scope.getForumDetails(newPage);
    };

    $scope.myPagingFunction = function () {
      //MyService.ConsoleLog("scoll called");
      if ($scope.statusLoading != 1) {
        //MyService.ConsoleLog($scope.froumthreads.length);
        //MyService.ConsoleLog($scope.totalRecords);
        if ($scope.froumthreads.length < $scope.totalRecords) {

          $scope.page++;
          $scope.pageChanged($scope.page);
        }

      }
    }

    if ($routeParams.categoryId) {
      getCategory();
      getSubCategories();
      $scope.getForumDetails($scope.page);
    }
  }]);

'use strict';
angular.module('myApp.forumSearch', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/forumSearch/:query?', {
      templateUrl: 'app/forumSearch/forumSearch.html',
      controller: 'forumSearchCtrl'
    });
  }])
  .controller('forumSearchCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'baseApiUrl', 'tokenService', 'MyService', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, baseApiUrl, tokenService, MyService) {
    $scope.imgUrl = baseApiUrl + "/resources";
    $rootScope.welcome = false;
    $scope.userId = tokenService.getUserId();
    $scope.userRole = tokenService.getUserRole();
    $scope.userData = JSON.parse(tokenService.getUserData());
    $scope.ShowAdavace = false;
    if ($routeParams.query) {
      $scope.search = {
        text: $routeParams.query,
        subject: '',
        Locations: '',
        mediaoption: [],
        mediaType: '',
        dateBefore: '',
        dateAfter: '',
        matchFrom: '',
        matchTo: '',
        recommendFrom: '',
        recommendTo: '',
        factualFrom: '',
        factualTo: '',
        fromfollowlist: '',
        order: '',
        recommendorder: '',
        lrecommendorder: '',
        factualorder: '',
        lfactualorder: ''
      };
    } else {
      $scope.search = {
        text: '',
        subject: '',
        Locations: '',
        mediaoption: [],
        mediaType: '',
        dateBefore: '',
        dateAfter: '',
        matchFrom: '',
        matchTo: '',
        recommendFrom: '',
        recommendTo: '',
        factualFrom: '',
        factualTo: '',
        fromfollowlist: '',
        order: '',
        recommendorder: '',
        lrecommendorder: '',
        factualorder: '',
        lfactualorder: ''
      };
    }

    $scope.showRefineLocation = false;

    $scope.Location = ["International", "National", "My State", "My County", "My Local", "Other Specific"];
    $scope.mediaType = ['Text', 'Video', 'Stills', 'Audio'];
    $scope.dateRange = ['Today', 'In the last week', 'In the last month', 'In the last year'];
    $scope.users = ["Voters", "Advocates", "Press", "Politicians", "Authors on my follow list"];
    $scope.searchResults = {
      data: []
    };
    $scope.selectedCat = [];
    $scope.subtopics = {
      subcategories: []
    }
    $scope.disabled = [];
    $scope.allLocations = [];
    $scope.allCounties = [];
    $scope.selectedArea = [];
    $scope.rmselectedArea = [];
    $scope.myselectionarea = [];
    $scope.disabledLocation = [];
    $scope.ShowSubcatTree = false;

    $scope.selectConfig = {
      requiredMin: 1,
      selectAll: true
    };

    function addslashes(str) {
      return (str + '').replace(/[\\"']/g, '\\$&').replace(/\u0000/g, '\\0');
    }

    $scope.checkCatExists = function (rdata, val) {
      return rdata.filter(
        function (rdata) {
          if (rdata._id == val) {
            $scope.selectedCat.push(rdata);
            return rdata
          } else if (rdata.subcategories) {
            $scope.checkCatExists(rdata.subcategories, val)
          }
        }
      );
    }

    $scope.mainCatTree = [];

    $scope.getSubcatTree = function () {
      //MyService.ConsoleLog($scope.mainCatTree);
      if ($scope.mainCatTree.length == 0) {
        $scope.ShowSubcatTree = true;

        MyService.getAllCatTree().then(function (payload) {
            $scope.subtopics.subcategories.length = 0;
            $scope.mainCatTree = angular.copy(payload);
            var subcatdata = payload;
            $scope.ShowSubcatTree = false;

            $scope.subtopics.subcategories = subcatdata;
            var selectedCat = $scope.disabled;
            if (selectedCat.length > 0) {
              for (var s = 0; s < selectedCat.length; s++) {
                var checkcatdata = $scope.checkCatExists(subcatdata, selectedCat[s]);
              }
              //MyService.ConsoleLog($scope.selectedCat);
            }
            setTimeout(function () {
              var cols = document.getElementsByClassName('cmnUL');
              var clen = cols.length;
              for (var i = 0; i < clen; i++) {
                cols[i].style.display = "none";
              }
            }, 300);
          },
          function (errorPayload) {
            alert('Something went wrong ');
          });
      } else {

        //MyService.ConsoleLog("After : " + $scope.subtopics.subcategories.length);
        if ($scope.subtopics.subcategories.length == 0) {
          $scope.subtopics.subcategories = angular.copy($scope.mainCatTree);

        } else {
          ;
          $scope.subtopics.subcategories.length = 0;

        }


        $scope.ShowSubcatTree = false;
        //MyService.ConsoleLog("After : " + $scope.subtopics.subcategories);
        //MyService.ConsoleLog("After : " + $scope.ShowSubcatTree);
      }

    }



    $scope.AllStates = [];
    $scope.allCounties = [];
    $scope.allLocals = [];
    $scope.showSubCat = true;
    $scope.showLoading = [];
    $scope.showLoadingCounty = [];
    $scope.showDown = [];

    $scope.getAllStates = function () {
      $scope.ShowStateLoader = true;
      if ($scope.AllStates.length == 0) {
        MyService.getAllStates().then(function (payload) {
            $scope.ShowStateLoader = false;
            $scope.allLocations.length = 0;
            var subcatdata = payload;
            $scope.AllStates = angular.copy(subcatdata);
            //MyService.ConsoleLog("countires : ", subcatdata);
            $scope.allLocations = subcatdata;
          },
          function (errorPayload) {
            alert('Something went wrong ');
          });
      } else {
        if (!$scope.showStates) {
          $scope.allLocations.length = 0;
          $scope.ShowStateLoader = false;
        } else {
          $scope.allLocations = angular.copy($scope.AllStates);
          $scope.ShowStateLoader = false;
        }
      }

    }


    $scope.getCounties = function (state) {
      MyService.ConsoleLog("getCounties", state);
      $scope.showLoading.push(state);
      if (!$scope.allCounties[state] || $scope.allCounties[state].length == 0) {

        MyService.getAllCounties(state).then(function (payload) {
            $scope.showLoading.length = 0;
            var sublocations = payload;
            if (!$scope.allCounties) {
              $scope.allCounties = [];
            }
            $scope.allCounties[state] = sublocations;
          },
          function (errorPayload) {
            alert('Something went wrong.');
          });


      } else {
        $scope.showLoading.length = 0;
        $scope.allCounties[state].length = 0;
      }
    }

    $scope.getLocals = function (state, county) {
      $scope.showLoadingCounty.push(county);
      if (!$scope.allLocals[state] || !$scope.allLocals[state][county] || $scope.allLocals[state][county].length == 0) {

        MyService.getAllSubCountiesLocal(state, county).then(function (payload) {
            // MyService.ConsoleLog("sublocations Locals : ", payload);

            $scope.showLoadingCounty.length = 0;
            if (!$scope.allLocals[state]) {
              $scope.allLocals[state] = [];
            }
            $scope.allLocals[state][county] = payload.places;

          },
          function (errorPayload) {
            alert('Something went wrong ');
          });


      } else {
        $scope.showLoadingCounty.length = 0;
        $scope.allLocals[state][county].length = 0;
      }
    }





    $scope.showmediaType = false;
    $scope.showDateRange = false;
    $scope.showMatchAuthor = false;
    $scope.showEssayRating = false;
    $scope.showStates = false;
    $scope.showRefine = function (e, option) {
      // MyService.ConsoleLog("opts", option);
      e.preventDefault();
      switch (option) {
        case "Interest":
          $scope.getSubcatTree();
          break;
        case "Location":
          if (!$scope.showRefineLocation)
            $scope.showRefineLocation = true;
          else
            $scope.showRefineLocation = false;

          break;
        case "AllLocation":
          if (!$scope.showStates) {
            $scope.showStates = true;

          } else {
            $scope.showStates = false;
          }
          $scope.getAllStates();
          break;
        case "Media":
          if (!$scope.showmediaType)
            $scope.showmediaType = true;
          else
            $scope.showmediaType = false;
          break;
        case "Date":
          if (!$scope.showDateRange)
            $scope.showDateRange = true;
          else
            $scope.showDateRange = false;
          break;
        case "Author":
          if (!$scope.showMatchAuthor)
            $scope.showMatchAuthor = true;
          else
            $scope.showMatchAuthor = false;
          break;
        case "EssayRated":
          if (!$scope.showEssayRating)
            $scope.showEssayRating = true;
          else
            $scope.showEssayRating = false;
          break;
        case "Default":
          break;

      }
    }


    $scope.showSubCat = true;
    $scope.showLoading = [];
    $scope.showLoadingCounty = [];
    $scope.showDown = [];
    $scope.ChangeShow = function (id) {
      $scope.showSubCat = true;

      var nclass = "MainCatLi_" + id;
      if ((document.getElementsByClassName(nclass)[0].style.display) && (document.getElementsByClassName(nclass)[0].style.display == "none")) {
        document.getElementsByClassName(nclass)[0].style.display = "block";
      } else {
        document.getElementsByClassName(nclass)[0].style.display = "none";
      }
    }


    function areEqual() {
      var len = arguments.length;
      for (var i = 1; i < len; i++) {
        if (arguments[i] == null || arguments[i] != arguments[i - 1])
          return false;
      }
      return true;
    }

    function indexOfExt(list, item) {
      var len = list.length;

      for (var i = 0; i < len; i++) {
        var keys = Object.keys(list[i]);
        var flg = true;
        var arr = [];


        for (var j = 0, s = 1; j < keys.length; j++, s++) {
          var value = list[i][keys[j]];
          if (item[keys[j]] !== value) {
            flg = false;

          }

          if (item[keys[j]] == value) {
            arr.push(flg);
          }


        }
        if (flg == true) {
          if (areEqual(arr.length, keys.length, Object.keys(item).length)) {
            return i;
          }

        }


      }
      return -1;
    }

    $scope.findLocations = [];
    $scope.Interests = [];
    $scope.MyLocation = [];
    $scope.SelectDefaultLocation = function (val) {
      //MyService.ConsoleLog("Data : ", val);
      var idx = $scope.MyLocation.indexOf(val);
      if (idx == -1) {
        $scope.MyLocation.push(val);
      } else {
        $scope.MyLocation.splice(idx, 1);
      }
      //MyService.ConsoleLog($scope.MyLocation);
    }

    $scope.selectLocation = function (val1, val2, val3, type) {
      //MyService.ConsoleLog(val1, val2, val3, type);
      var nobj = {};
      nobj.country = "United States of America";
      if (type == "state") {
        nobj.state = val1.state;
        nobj.statePostalCode = val1.statePostalCode;
      }
      if (type == "county") {
        nobj.state = val1.state;
        nobj.statePostalCode = val1.statePostalCode;
        nobj.county = val3;
      }
      if (type == "local") {
        nobj.state = val1.state;
        nobj.statePostalCode = val1.statePostalCode;
        nobj.county = val2;
        nobj.countySubdivision = val3.countySubdivision;
        nobj.place = val3.place;
      }
      //MyService.ConsoleLog("nboj:", nobj);
      var idx = indexOfExt($scope.findLocations, nobj);
      if (idx == -1) {
        $scope.findLocations.push(nobj);
      } else {
        $scope.findLocations.splice(idx, 1);
      }
    }



    $scope.getVal = function (data) {
      //MyService.ConsoleLog($scope.Interests);
      var idx = $scope.Interests.indexOf(data._id);
      if (idx == -1) {
        $scope.Interests.push(data._id);
      } else {
        $scope.Interests.splice(idx, 1);
      }
    }

    $scope.totalResults = 0;

    function cleanArray(actual) {
      var newArray = new Array();
      for (var i = 0; i < actual.length; i++) {
        if (actual[i]) {
          newArray.push(actual[i]);
        }
      }
      return newArray;
    }

    function allnumeric(inputtxt) {
      var numbers = /^[0-9]+$/;
      if (inputtxt == undefined) {
        return false;
      }
      if (inputtxt.match(numbers)) {
        return true;
      } else {
        return false;
      }
    }

    $scope.getForumList = function (query) {
      //var q = addslashes(query);
      var q = query;
      //MyService.ConsoleLog("Q:",q);
      var nrequest = apiCall.apiCall('GET', '/topics/search', {
        query: q
      });
      $http(
        nrequest
      ).then(function successCallback(responseLatest) {
        //MyService.ConsoleLog("Final Data");
        //MyService.ConsoleLog(responseLatest.data.data);
        $scope.searchResults.data.length = 0;
        if (responseLatest.data.success) {
          $scope.searchResults.data = responseLatest.data.data;
          MyService.ConsoleLog("$scope.searchResults.data", $scope.searchResults.data);
        }
      }, function errorCallBack(responseLatest) {
        alert("Error : " + responseLatest);
      });
    }

    $scope.getForumListAdvance = function (data) {
      $scope.searchResults.data.length = 0;
      if ($scope.findLocations.length > 0) {
        data.searchlocations = JSON.stringify($scope.findLocations);
      }

      if ($scope.MyLocation.length > 0) {
        data.MyLocation = JSON.stringify($scope.MyLocation);
      }
      if (data.mediaoption) {
        var moption = data.mediaoption;
        if (typeof moption == "object") {
          moption = Object.keys(moption).map(function (key) {
            return moption[key]
          });
        }
        if (typeof moption != "string") {
          var media = cleanArray(moption);
          data.mediaoption = JSON.stringify(media);
        }
      }
      data.subjectOfInterest = JSON.stringify($scope.Interests);
      var validateMatch = true,
        validateMatchTo = true,
        validateRecommend = true,
        validateTo = true;
      var msg = "";
      if (data.matchFrom != "") {
        validateMatch = allnumeric(data.matchFrom);
        if (($scope.Interests.length == 0) && validateMatch) {
          msg = "Please select atleast one subject of interest";
          validateMatch = false;
        }
      }

      if (data.matchTo != "") {
        validateMatchTo = allnumeric(data.matchTo);
        if (validateMatchTo && ($scope.Interests.length == 0)) {
          msg = "Please select atleast one subject of interest";
          validateMatchTo = false;
        }
      }
      //MyService.ConsoleLog("data : ", data);

      if (validateMatch && validateMatchTo) {
        var nrequest = apiCall.apiCall('POST', '/topics/AdvanceSearch', data);
        $http(
          nrequest
        ).then(function successCallback(responseLatest) {
          //MyService.ConsoleLog("Final Advance Data");
          //MyService.ConsoleLog(responseLatest.data.data);
          $scope.searchResults.data.length = 0;
          if (responseLatest.data.success) {
            $scope.searchResults.data = responseLatest.data.data;
          }
        }, function errorCallBack(responseLatest) {
          alert("Error : " + responseLatest);
        });
      } else {
        if (msg != "") {
          alert(msg);
        } else {
          alert("Please enter valid data");
        }

      }
    }

    $scope.ShowOrderList = false;
    $scope.showOrder = function () {
      if (!$scope.ShowOrderList) {
        $scope.ShowOrderList = true;
      } else {
        $scope.ShowOrderList = false;
      }
    }
    $scope.isreverse = false;


    $scope.sortValues = function (data) {
      var result = "";


      switch ($scope.search.order) {
        case "Most Recent":
          $scope.isreverse = true;
          result = data.createdOn;
          break;
        case "Oldest":
          $scope.isreverse = false;
          result = data.createdOn;
          break;

        case "Default":
          $scope.isreverse = true;
          result = data.createdOn;
          break;

      }


      //MyService.ConsoleLog($scope.search);
      //MyService.ConsoleLog(result);
      return result;

    }


    $scope.gotoThread = function (data, subcatid) {
      var id = '';
      if (data.parentId) {
        id = data.parentId;
      } else if (data.parent) {
        id = data.parent;
      } else {
        if (data.id) {
          id = data.id;
        } else {
          id = data._id;
        }
      }
      // MyService.ConsoleLog(data);
      var categoryId = "";
      if (data.parentCat[0] && data.parentCat[0] != "") {
        categoryId = data.parentCat[0];
      } else {
        if (data.parentCat[1] && data.parentCat[1] != "") {
          categoryId = data.parentCat[1];
        }
      }

      // $rootScope.subcategoryId = subcatid;
      //MyService.ConsoleLog('forumthread/' + categoryId + '/' + subcatid + '/' + id);


      if (categoryId != "") {
        $location.path('forumthread/' + categoryId + '/' + subcatid + '/' + id);
      } else {
        MyService.ConsoleLog("ELSE");
        alert("Something went wrong");
      }


    }

    // $scope.gotoThread = function (data) {
    //   var id = '';
    //   if (data.parentId) {
    //     id = data.parentId;
    //   } else if (data.parent) {
    //     id = data.parent;
    //   } else {
    //     if (data.id) {
    //       id = data.id;
    //     } else {
    //       id = data._id;
    //     }
    //   }
    //   var subcats = data.subcategories;
    //   var len = subcats.length;
    //   var categoryId = subcats[len - 2];
    //   var subcatid = subcats[len - 1];
    //   //MyService.ConsoleLog('forumthread/' + categoryId + '/' + subcatid + '/' + id + '/' + data._id);
    //   $location.path('forumthread/' + categoryId + '/' + subcatid + '/' + id + '/' + data._id);
    // }



    $scope.showadvace = function () {
      $scope.ShowAdavace = true;
      var query = $scope.search.text;
      $scope.search = {
        text: query,
        subject: '',
        Locations: '',
        mediaoption: [],
        mediaType: '',
        dateBefore: '',
        dateAfter: '',
        matchFrom: '',
        matchTo: '',
        recommendFrom: '',
        recommendTo: '',
        factualFrom: '',
        factualTo: '',
        fromfollowlist: '',
        order: '',
        recommendorder: '',
        lrecommendorder: '',
        factualorder: '',
        lfactualorder: ''
      };
    }

    if ($routeParams.query) {

      $scope.getForumList($routeParams.query);
    }
  }]);

'use strict';
angular.module('myApp.forumReply', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
  $routeProvider.when('/forumReply/:categoryId/:subcatId/:forumId', {
    templateUrl: 'app/forumReply/forumReply.html',
    controller: 'forumReplyCtrl'
  });
}])
.controller('forumReplyCtrl', ['$scope','$http','$location','apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'growl', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout,growl) {
	$rootScope.welcome = false;
	$scope.TopicButton = false;
	$scope.location = ['National', 'State', 'County', 'Local'];
	$scope.mainTopic = {};
	$scope.Topic = {
		title: '',
		description: '',
		location: 'National',
		restrictedTo: 'Locals Only',
	};
	$scope.restrictedOptions = ['Locals Only', 'No Restrictions'];
	
	if(!$rootScope.UserId) {
		$location.path('signin');
	}



	$scope.forumDetails = function() {
		var nrequest = apiCall.apiCall('GET', '/topics/getTopic', {topicId: $routeParams.forumId});
		$http(
		    nrequest
		  ).then(function successCallback(responseLatest) {
			$scope.Topic.title = "RE: "+responseLatest.data.data.title;
			$scope.mainTopic = responseLatest.data.data;
			
		  }, function errorCallBack(responseLatest) {
		  	
		    //console.log("Error : "+responseLatest);
		  });
	}

	$scope.SubmitTopic = function(data) {
		 if ($.fn.validateForceFully($("#topicform")) == true) {
		 	$scope.TopicButton = true;
		 	data.parentcat = $routeParams.categoryId;
		 	data.subcategories = $routeParams.subcatId;
		 	data.createdById = $rootScope.UserId;
		 	data.createdByName = $rootScope.User;
		 	data.location = $scope.mainTopic.location;
		 	data.restrictedTo = $scope.mainTopic.restrictedTo;
		 	data.parent = $routeParams.forumId;
		 	var request = apiCall.apiCall('POST', '/topics/create', data);
		 	$http(
				request
				).then(function successCallback(response) {
				
				$scope.TopicButton = true;
					if(response.data.success){
						$location.path('forumthread/'+$routeParams.categoryId+'/'+$routeParams.subcatId+'/'+$routeParams.forumId);
					}
					else{
						alert("Something went wrong. Please try after sometime.");
					}
				}, function errorCallBack(response) {
				//console.log("Error: ",response);
			});

		 }
	}

	$scope.goBack = function() {
		//console.log("redirect back page");
		$location.path('forumthread/'+$routeParams.categoryId+'/'+$routeParams.subcatId+'/'+$routeParams.forumId);
	}
	
if((!$routeParams.categoryId) && (!$routeParams.subcatId) && (!$routeParams.forumId)) {
		$location.path('debate');	
	} else {
		$scope.forumDetails();
	}
	


	
}]);

'use strict';
angular.module('myApp.forumList', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/forumList/:categoryId/:subcatId/:type', {
      templateUrl: 'app/forumList/forumList.html',
      controller: 'forumListCtrl'
    });
  }]).filter('refineDataNw', ['tokenService', function (tokenService) {
    return function (data, filterBy) {
      //MyService.ConsoleLog("data: ",data," filterBy: ",filterBy);
      var userData = tokenService.getUserData();
      if (userData) {
        userData = JSON.parse(userData);
      }
      if (!filterBy || filterBy == 'all')
        return data;
      var tempArr = [];
      angular.forEach(data, function (val, key) {
        //MyService.ConsoleLog("key: ",key);
        if (filterBy == 'following') {
          if (userData && userData.followlist) {
            if (userData.followlist.indexOf(val.createdBy.id) > -1)
              tempArr.push(val);
          }
        } else {
          if (val.createdBy.utype == filterBy) {
            tempArr.push(val)
          }
        }
      });
      //MyService.ConsoleLog("tempArr: ", tempArr);
      return tempArr;
    };
  }])
  .controller('forumListCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', 'ngDialog', 'growl', '$anchorScroll', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService, ngDialog, growl, $anchorScroll) {
    $rootScope.welcome = false;
    $scope.categoryId = $routeParams.categoryId;
    $scope.subcategoryId = $routeParams.subcatId;
    $scope.type = $routeParams.type;
    $scope.category = {};
    $scope.subcategory = {};
    $scope.DisplayData = [];
    $scope.userType = tokenService.getUserRole();
    $scope.userId = tokenService.getUserId();

    if (tokenService.getUserData()) {
      $scope.userData = JSON.parse(tokenService.getUserData());
      MyService.ConsoleLog("$scope.userData", $scope.userData);

    }
    $scope.getUserProfile = function () {
      MyService.getProfile($scope.userData.id).then(
        function (userData) {
          $scope.usersData = userData;
          MyService.ConsoleLog('userData: ', $scope.userData);
        },
        function (err) {
          growl.error('Something went wrong while fetching user info.');
        }
      );
    };

    $scope.filterArray = ['all', 'politician', 'voter', 'press', 'advocate', 'following'];
    $scope.sortArray = ['Newest first', 'Since last login'];
    $scope.sortBy = 'Select sort';

    $scope.showCon = false;
    $scope.showBoth = false;
    $scope.showEm = false;

    // alert('cc');
    /**
     * Redirect
     */
    $scope.goto = function () {
      $location.path('/verifyBy');
    };
    if ($scope.userData && $scope.userData._id != '') {
      $scope.getUserProfile();
    }

    /**
     * Close it
     */
    $scope.closeIt = function () {
      $scope.PopDialog.close();
    };
    $scope.getmyData = function () {
      $scope.ShowPorifleLoading = true;
      MyService.getUserPublicProfile({
        id: tokenService.getUserId(),
        type: 'false'
      }).then(function (response) {
        $scope.ShowPorifleLoading = false;
        if (response.data.success) {
          $scope.userDetails = response.data.data;
          // MyService.ConsoleLog("welcome", $scope.userDetails);
          $scope.userProfile = $scope.userDetails.userData;
          MyService.ConsoleLog("welcome to profile", $scope.userProfile);

          $scope.userType = $scope.userProfile.userType;
          $scope.verify = $scope.userProfile.verifiedUser;
          // MyService.ConsoleLog("welcome", $scope.verify);
          // console.log("$scope.userDetails", $scope.userDetails.userData.address);
          if (!$scope.userProfile.verifiedUser) {
            $scope.showCon = true;
          }
          // if ($scope.userProfile.userType == 'politician') {

          if (!$scope.userProfile.isEmailVerified || !$scope.userProfile.verifiedUser) {
            // $scope.getPopUp();
            if (!$scope.userProfile.isEmailVerified && !$scope.userProfile.verifiedUser) {
              if ($scope.userProfile.userType == 'politician') {
                $scope.showCon = true;
                $scope.showBoth = true;
              } else if (!$scope.userProfile.isEmailVerified) {
                $scope.showEm = true;
              }
            } else if (!$scope.userProfile.isEmailVerified) {
              // if ($scope.userProfile.userType != 'politician') {
              $scope.showEm = true;
              // }
            } else {
              if ($scope.userProfile.userType != 'politician') {
                $scope.showEm = true;
              }
            }
            if ($scope.userProfile.userType == 'politician') {
              $scope.PopDialog = ngDialog.open({
                template: 'popUp',
                closeByNavigation: true,
                scope: $scope,
                width: '50%',
                closeByDocument: false
              });
            } else if ($scope.userProfile.userType == 'advocate' && $scope.userProfile.isEmailVerified != true) {
              // alert('cal');
              MyService.ConsoleLog("$scope.userProfile", $scope.userProfile.isEmailVerified);
              $scope.PopDialog = ngDialog.open({
                template: 'popUp',
                closeByNavigation: true,
                scope: $scope,
                width: '50%',
                closeByDocument: false
              });
            }
          }
          // }


        } else {
          MyService.ConsoleLog("ELSE vishal");
          alert("Something went wrong.");
        }
      }, function (errorPayload) {
        $scope.ShowPorifleLoading = false;
        MyService.ConsoleLog("ELSE vishal two");

        alert("Something went wrong.");
      });
    }

    if (tokenService.getUserId()) {
      $scope.getmyData();
    }

    if (tokenService.getUserData()) {
      $scope.userData = JSON.parse(tokenService.getUserData());
    }
    // $scope.Sticky = {
    //   txtOrder: 0
    // };
    $scope.Sticky = {
      ShowOrder: [],
      txtOrder: []
    };
    // $scope.sortNw = '-createdOn';
    $scope.SortData = function () {
      MyService.ConsoleLog($scope.sortBy);
      if ($scope.sortBy == 'Since last login') {
        if ($scope.usersData && $scope.usersData.lastLoginOld != '') {

          var lastOldLogIn = new Date($scope.usersData.lastLoginOld);

          var lens = $scope.DisplayData.length;
          for (var i = 0; i < lens; i++) {
            var lastLoginDate = new Date($scope.usersData.lastLogin);
            var createdOn = new Date($scope.DisplayData[i].createdOn);

            if (lastLoginDate <= createdOn) {

              $location.hash('anchor' + $scope.DisplayData[i]._id);
              $anchorScroll();
              break;

            } else if (lastOldLogIn.toISOString().split('T')[0] <= createdOn.toISOString().split('T')[0]) {
              // MyService.ConsoleLog("else", 'anchor' + $scope.DisplayData[i]._id);
              var old = $location.hash();
              MyService.ConsoleLog("old", old);
              // $location.hash('anchor' + $scope.DisplayData[i]._id);
              $anchorScroll('anchor' + $scope.DisplayData[i]._id);
              break;
            }
          }
        }
      } else if ($scope.sortBy == "Chronological") {
        // $scope.getForumList();
        // $scope.sortNw = 'createdOn';
        $scope.DisplayData.sort(function (a, b) {
          // MyService.ConsoleLog("am", a);
          // MyService.ConsoleLog("b", b);
          var asc = new Date(a.createdOn);
          var bss = new Date(b.createdOn);
          return asc - bss;
        });
      } else {
        $scope.isRecent = "Newest first";
        $scope.DisplayData.sort(function (a, b) {
          // MyService.ConsoleLog("am", a);
          // MyService.ConsoleLog("b", b);
          var asc = new Date(a.createdOn);
          var bss = new Date(b.createdOn);
          return bss - asc;
        });
      }
      //alert("Sort Data called");
    };

    /**
     * Send Verification mail
     */

    $scope.sendMail = function () {
      MyService.SendVerificationMail({
        verificationUrl: $rootScope.getVerificationUrl(),
        unsubscribeurl: $rootScope.getEmailUnsubscribeUrl()
      }).then(function (response) {
        MyService.ConsoleLog("response", response);
        if (response.data.success) {
          growl.success("Please check your email");
        }
      }, function (err) {
        MyService.ConsoleLog("err", err);
      });
    };

    $scope.getExtraData = function () {
      $rootScope.ExtraTopicData = [];

      var token = apiCall.getToken();
      //alert(token);
      if (token) {

        MyService.extraDataUpdated($scope.userData).then(function (payload) {
            var responseLatest = payload;
            MyService.ConsoleLog("responseLatest : ", responseLatest);
            $rootScope.ExtraTopicData = responseLatest;
            if (responseLatest) {
              $scope.latestDataDateWise();
              if (responseLatest.MyDiscussion) {
                $scope.DiscussionData = responseLatest.MyDiscussion;
              }
              if (responseLatest.ActiveData) {
                $scope.ActiveThreads = responseLatest.ActiveData;
              }
              if (responseLatest.HotTopics) {
                $scope.HotTopics = responseLatest.HotTopics;
              }
            }
          },
          function (errorPayload) {
            alert('Something went wrong ');
          });
      }
    }

    $scope.newData = {};

    $scope.latestDataDateWise = function () {

      MyService.latestDataDateWise({}).then(function (payload) {
        MyService.ConsoleLog("payload", payload);
        //alert("Here");
        $scope.newData = payload;

      }, function (errorPayload) {
        MyService.ConsoleLog("errorPayload", errorPayload);
        alert("Something went wrong");
      });
    }
    if (($rootScope.ExtraTopicData) && ($rootScope.ExtraTopicData.length > 0)) {
      if ($rootScope.ExtraTopicData.MyDiscussion) {
        $scope.DiscussionData = $rootScope.ExtraTopicData.MyDiscussion;
      }

      if ($rootScope.ExtraTopicData.ActiveData) {
        $scope.ActiveThreads = $rootScope.ExtraTopicData.ActiveData;
      }

      if ($rootScope.ExtraTopicData.HotTopics) {
        $scope.HotTopics = $rootScope.ExtraTopicData.HotTopics;
      }
    } else {
      $scope.getExtraData();
    }

    if (window.localStorage.getItem("VoteWiseCategory")) {
      $rootScope.allcategories = JSON.parse(window.localStorage.getItem("VoteWiseCategory"));
      var idx = $rootScope.allcategories.indexOf($routeParams.subcatId);

      if (idx == -1) {
        $rootScope.allcategories.push($routeParams.subcatId);
        window.localStorage.setItem("VoteWiseCategory", JSON.stringify($rootScope.allcategories));
      }
    }

    $scope.checkSticky = function (val) {
      if (val == 'Y') {
        return {
          'background-color': "#fbeec0"
        };
      } else {
        return '';
      }
    }
    var ops, isDisWith = false;
    switch ($scope.type) {
      case 'state':
        ops = JSON.stringify({
          "options": "",
          "isInternational": false,
          "isNational": false,
          "isState": true,
          "isCounty": false,
          "isLocal": false
        });
        isDisWith = true;
        break;
      case 'country':
        ops = JSON.stringify({
          "options": "",
          "isInternational": false,
          "isNational": true,
          "isState": false,
          "isCounty": false,
          "isLocal": false
        });
        isDisWith = true;
        break;
      case 'county':
        ops = JSON.stringify({
          "options": "",
          "isInternational": false,
          "isNational": false,
          "isState": false,
          "isCounty": true,
          "isLocal": false
        });
        isDisWith = true;
        break;
      case 'place':
        ops = JSON.stringify({
          "options": "",
          "isInternational": false,
          "isNational": false,
          "isState": false,
          "isCounty": false,
          "isLocal": true
        });
        isDisWith = true;
        break;
      default:
        break;
    }

    $rootScope.subcategory = "";

    $scope.getForumList = function () {
      if ($scope.userData) {
        var address = JSON.stringify($scope.userData.address);
      } else {
        var address = "";
      }


      var finalData = {
        "prevCat": window.localStorage.getItem('previouscatId'),
        "maincatId": $routeParams.categoryId,
        "subcatId": $routeParams.subcatId,
        "option": ops ? ops : window.localStorage.getItem("locationOption"),
        "address": address,
        "rootData": "N",
        "checkIsDis": isDisWith
      };
      //MyService.ConsoleLog("category:::::::::::",$rootScope.category);
      if ($rootScope.subcategory.title == "General") {
        finalData.rootData = "Y";
      }
      if ($scope.isRecent) {
        finalData.sort_by = $scope.isRecent;
      }

      //MyService.ConsoleLog("post Data : ", finalData);
      var nrequest = apiCall.apiCall('POST', '/topics/getList', finalData);
      nrequest.headers['Cache-Control'] = 'No-Store';
      $http(
        nrequest
      ).then(function successCallback(responseLatest) {
        //MyService.ConsoleLog("Final Data");
        //MyService.ConsoleLog(responseLatest.data.data);
        if (responseLatest.data.success) {
          // $scope.sortNw = '-createdOn';
          $scope.DisplayData = responseLatest.data.data;
          MyService.ConsoleLog(" $scope.DisplayData", $scope.DisplayData);


          $scope.DisplayData.sort(function (a, b) {
            // MyService.ConsoleLog("am", a);
            // MyService.ConsoleLog("b", b);
            var asc = new Date(a.createdOn);
            var bss = new Date(b.createdOn);
            return bss - asc;
          });
        }
      }, function errorCallBack(responseLatest) {
        alert("Error : " + responseLatest);
      });
    }



    function getSubCategories() {
      MyService.getCategoryList($routeParams.subcatId).then(function (payload) {
          $scope.subcategory = payload;
          $rootScope.subcategory = payload;
          $scope.getForumList();
        },
        function (errorPayload) {
          alert('Something went wrong. ');
        });

    }

    function getCategory() {
      MyService.getCategoryList($routeParams.categoryId).then(function (payload) {
          $scope.category = payload;

        },
        function (errorPayload) {
          alert('Something went wrong.');
        });

    }

    $scope.gotoThread = function (data) {
      var categoryId = $routeParams.categoryId;
      var subcatid = $routeParams.subcatId;
      $location.path('forumthread/' + categoryId + '/' + subcatid + '/' + data);
    };

    $scope.updatePostApi = function (data, options, idex) {

      var request = apiCall.apiCall('POST', '/topics/update', data);
      $http(
        request
      ).then(function successCallback(response) {
        //MyService.ConsoleLog(response);
        if (response.data.data.nModified == 0) {
          alert("Something went wrong. Please try after sometime.");
        } else {
          $scope.getForumList();

        }

      }, function errorCallBack(response) {
        //MyService.ConsoleLog("Error: ", JSON.stringify(response));
      });
    }

    $scope.gotoUpdate = function (item) {
      $location.path('/updateTopic/' + $routeParams.categoryId + '/' + $routeParams.subcatId + '/' + $routeParams.type + '/' + item._id);

    }


    $scope.objectKeys = function (obj) {
      return Object.keys(obj);
    }

    $scope.updatePost = function (option, id) {
      var data = {};
      if (option == "sticky") {
        data.poststicky = 1;
        data.poststickyOrder = $scope.Sticky.txtOrder[id];
        data.topicId = id;

      } else {
        data.removepostSticky = 1;
        data.topicId = id;

      }
      //MyService.ConsoleLog(data);
      $scope.updatePostApi(data);
    }

    $scope.gotoFThread = function (id, catId, subcatid) {
      $location.path('forumthread/' + catId + '/' + subcatid + '/' + id);
    }
    $scope.gotoForumTopic = function (obj) {
      if (obj.parent && obj.parent != "") {
        $scope.gotoFThread(obj.parent, obj.parentCat[0], obj.subCategories[0]);
      } else {
        $scope.gotoFThread(obj._id, obj.parentCat[0], obj.subCategories[0]);
      }
    }

    $scope.gotoForumT = function (obj) {
      MyService.ConsoleLog("obj", obj);
      var subcat = $scope.getSubCat(obj.parentCat[0]);
      MyService.ConsoleLog("subcat:::", subcat);
      if (obj.parent && obj.parent != "") {
        $scope.gotoFThread(obj.parent, obj.parentCat[0], subcat[0].subCategories[0]._id);
      } else {
        $scope.gotoFThread(obj._id, obj.parentCat[0], subcat[0].subcategories[0]._id);
      }

      //"#!/forumthread/"+obj.parentcat[0]+"/"+subcat+"/"+obj._id;
    }


    if ($routeParams.categoryId) {
      getCategory();
      getSubCategories();
    }

  }]);

'use strict';
angular.module('myApp.forum', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/forum/:categoryId/:type', {
      templateUrl: 'app/forum/forum.html',
      controller: 'forumCtrl'
    });
  }])
  .controller('forumCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', 'ngDialog', 'growl', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService, ngDialog, growl) {
    MyService.ConsoleLog("** forumCtrl ** :", $routeParams);
    $rootScope.welcome = false;
    $scope.categoryId = $routeParams.categoryId;
    $scope.type = $routeParams.type;
    $scope.subCategories = [];

    $scope.showCon = false;
    $scope.showBoth = false;
    $scope.showEm = false;


    /**
     * Redirect
     */
    $scope.goto = function () {
      $location.path('/verifyBy');
    };

    /**
     * Close it
     */
    $scope.closeIt = function () {
      $scope.PopDialog.close();
    };
    $scope.getmyData = function () {
      $scope.ShowPorifleLoading = true;
      MyService.getUserPublicProfile({
        id: tokenService.getUserId(),
        type: 'false'
      }).then(function (response) {
        $scope.ShowPorifleLoading = false;
        if (response.data.success) {
          $scope.userDetails = response.data.data;
          // MyService.ConsoleLog("welcome", $scope.userDetails);
          $scope.userProfile = $scope.userDetails.userData;
          // MyService.ConsoleLog("welcome to profile", $scope.userProfile);

          $scope.userType = $scope.userProfile.userType;
          $scope.verify = $scope.userProfile.verifiedUser;
          // MyService.ConsoleLog("welcome", $scope.verify);
          // console.log("$scope.userDetails", $scope.userDetails.userData.address);
          if (!$scope.userProfile.verifiedUser) {
            $scope.showCon = true;
          }
          if (!$scope.userProfile.isEmailVerified || !$scope.userProfile.verifiedUser) {
            // $scope.getPopUp();
            if (!$scope.userProfile.isEmailVerified && !$scope.userProfile.verifiedUser) {
              if ($scope.userProfile.userType == 'politician') {
                $scope.showCon = true;
                $scope.showBoth = true;
              } else if (!$scope.userProfile.isEmailVerified) {
                $scope.showEm = true;
              }
            } else if (!$scope.userProfile.isEmailVerified) {
              // if ($scope.userProfile.userType != 'politician') {
              $scope.showEm = true;
              // }
            } else {
              if ($scope.userProfile.userType != 'politician') {
                $scope.showEm = true;
              }
            }
            if ($scope.userProfile.userType == 'politician') {
              $scope.PopDialog = ngDialog.open({
                template: 'popUp',
                closeByNavigation: true,
                scope: $scope,
                width: '50%',
                closeByDocument: false
              });
            } else if ($scope.userProfile.userType == 'advocate' && $scope.userProfile.isEmailVerified != true) {
              // alert('cal');
              MyService.ConsoleLog("$scope.userProfile", $scope.userProfile.isEmailVerified);
              $scope.PopDialog = ngDialog.open({
                template: 'popUp',
                closeByNavigation: true,
                scope: $scope,
                width: '50%',
                closeByDocument: false
              });
            }
          }
          // }


        } else {
          MyService.ConsoleLog("ELSE vishal");
          alert("Something went wrong.");
        }
      }, function (errorPayload) {
        $scope.ShowPorifleLoading = false;
        MyService.ConsoleLog("ELSE vishal two");

        alert("Something went wrong.");
      });
    }

    if (tokenService.getUserId()) {
      $scope.getmyData();
    }





    if (tokenService.getUserData()) {
      $scope.userData = JSON.parse(tokenService.getUserData());
      if (!$scope.userData.isemailverified) {
        // $scope.getPopUp();
      }
    }
    $scope.DiscussionData = [];
    $scope.ActiveThreads = [];
    $scope.HotTopics = [];
    var token = apiCall.getToken();

    $scope.search = {
      text: ''
    };

    $scope.previouscategory = [];

    //MyService.ConsoleLog("forum page ", window.location.getItem("locationOption"));


    function getCategory(params, type) {
      // MyService.ConsoleLog("$scope.previouscatId : one ", $scope.previouscatId);
      MyService.getCategoryList(params).then(function (payload) {
          var subcatdata = payload;
          //MyService.ConsoleLog("subcatdata : ", subcatdata);
          if (type == "Prev") {
            $scope.previouscategory = payload;
          } else {
            $scope.category = payload;
          }
        },
        function (errorPayload) {
          alert('Something went wrong ');
        });

    }

    if ($scope.type == "home") {
      $rootScope.allcategories = [];
      $rootScope.allcategories.length = 0;
      window.localStorage.removeItem("VoteWiseCategory");
      window.localStorage.setItem("VoteWiseParentCategory", $routeParams.categoryId);
      $rootScope.allcategories.push($routeParams.categoryId);
      window.localStorage.setItem("VoteWiseCategory", JSON.stringify($rootScope.allcategories));
    } else {
      if (window.localStorage.getItem("VoteWiseCategory")) {
        $rootScope.allcategories = JSON.parse(window.localStorage.getItem("VoteWiseCategory"));

        //MyService.ConsoleLog($rootScope.allcategories);
        //MyService.ConsoleLog(finallen);


        var idx = $rootScope.allcategories.indexOf($routeParams.categoryId);
        if (idx == -1) {
          var finallen = $rootScope.allcategories.length;
          if (finallen >= 1) {
            if (finallen > 1) {
              $scope.finaltype = "subcat";
            } else {
              $scope.finaltype = "home";

            }
            var chklen = finallen - 1;

            $scope.previouscatId = $rootScope.allcategories[chklen];
            //MyService.ConsoleLog("prev ID : ", $scope.previouscatId);
            getCategory($scope.previouscatId, "Prev");
          }
          $rootScope.allcategories.push($routeParams.categoryId);
          window.localStorage.setItem("VoteWiseCategory", JSON.stringify($rootScope.allcategories));
        } else {

          var len = $rootScope.allcategories.length;
          var fidx = idx;
          var no = len - fidx;

          //MyService.ConsoleLog("len:" + len + "====idx:" + fidx + "====NO:" + no);
          $rootScope.allcategories.splice(fidx, no);
          //MyService.ConsoleLog($rootScope.allcategories);
          var finallen = $rootScope.allcategories.length;
          window.localStorage.setItem("VoteWiseCategory", JSON.stringify($rootScope.allcategories));
          if (finallen >= 1) {
            if (finallen > 1) {
              $scope.finaltype = "subcat";
            } else {
              $scope.finaltype = "home";

            }
            var chklen = finallen - 1;
            $scope.previouscatId = $rootScope.allcategories[chklen];
            //MyService.ConsoleLog("prev ID : ", $scope.previouscatId);
            getCategory($scope.previouscatId, "Prev");
          }
        }
        //MyService.ConsoleLog("Got categories: ",$scope.previouscategory);
      }
    }



    $scope.getExtraData = function () {

      if ($scope.type != "subcat") {
        $rootScope.ExtraTopicData = [];
        MyService.extraDataUpdated($scope.userData).then(function (payload) {
            var responseLatest = payload;
            MyService.ConsoleLog("payload : ", payload);
            $rootScope.ExtraTopicData = responseLatest;
            if (responseLatest) {
              $scope.latestDataDateWise();
              if (responseLatest.MyDiscussion) {
                $scope.DiscussionData = responseLatest.MyDiscussion;
              }
              if (responseLatest.ActiveData) {
                $scope.ActiveThreads = responseLatest.ActiveData;
              }
              if (responseLatest.HotTopics) {
                $scope.HotTopics = responseLatest.HotTopics;
              }
            }
          },
          function (errorPayload) {
            alert('Something went wrong ');
          });

      } else {
        var responseLatest = $rootScope.ExtraTopicData;
        if (responseLatest) {
          if (responseLatest.MyDiscussion) {
            $scope.DiscussionData = responseLatest.MyDiscussion;
          }
          if (responseLatest.ActiveData) {
            $scope.ActiveThreads = responseLatest.ActiveData;
          }
          if (responseLatest.HotTopics) {
            $scope.HotTopics = responseLatest.HotTopics;
          }
        }
      }
    }

    $scope.newData = {};

    $scope.latestDataDateWise = function () {

      MyService.latestDataDateWise({}).then(function (payload) {
        MyService.ConsoleLog("payload", payload);
        //alert("Here");
        $scope.newData = payload;

      }, function (errorPayload) {
        MyService.ConsoleLog("errorPayload", errorPayload);
        alert("Something went wrong");
      });
    }

    $scope.getData = function (subCategories, subcatid, sampledata) {

      if ($scope.userData) {
        var address = JSON.stringify($scope.userData.address);
      } else {
        var address = "";
      }
      // MyService.ConsoleLog("window.localStorage.getItem >>>>>>>>", JSON.parse(window.localStorage.getItem("locationOption")));
      var finalData = {
        "subcatId": subcatid,
        "option": window.localStorage.getItem("locationOption"),
        "address": address,
        "rootData": "N",
        "cateId": $scope.categoryId,
        "prevCatId": $scope.previouscatId
      };
      // MyService.ConsoleLog("post Data : ", finalData);
      MyService.getLatestTopics(finalData).then(function (payload) {
          subCategories.returndata = payload;
          $scope.subCategories.push(subCategories);
          MyService.ConsoleLog("$scope.subCategories", $scope.subCategories);
          // MyService.ConsoleLog(subCategories);
        },
        function (errorPayload) {
          //MyService.ConsoleLog(subCategories);
          subCategories.returndata = sampledata;
          $scope.subCategories.push(subCategories);
        });
    }


    /**
     * Send Verification mail
     */

    $scope.sendMail = function () {
      MyService.SendVerificationMail({
        verificationUrl: $rootScope.getVerificationUrl(),
        unsubscribeurl: $rootScope.getEmailUnsubscribeUrl()
      }).then(function (response) {
        MyService.ConsoleLog("response", response);
        if (response.data.success) {
          growl.success("Please check your email");
        }
      }, function (err) {
        MyService.ConsoleLog("err", err);
      });
    };

    $scope.getRootData = function (subCategories, subcatid, sampledata) {
      //MyService.ConsoleLog("SubcatID : ", subcatid);
      window.localStorage.removeItem('previouscatId');
      window.localStorage.setItem('previouscatId', $scope.previouscatId);
      if ($scope.userData) {
        var address = JSON.stringify($scope.userData.address);
      } else {
        var address = "";
      }
      var finalData = {
        "subcatId": subcatid,
        "option": window.localStorage.getItem("locationOption"),
        "address": address,
        "rootData": "Y",
        "catId": $routeParams.categoryId,
        "prevCatId": $scope.previouscatId,
        "cateId": $scope.categoryId
      };
      //MyService.ConsoleLog("post Data getRootData : ", finalData);
      MyService.getLatestTopics(finalData).then(function (payload) {
          subCategories.returndata = payload;
          $scope.subCategories.push(subCategories);
        },
        function (errorPayload) {
          //MyService.ConsoleLog(subCategories);
          subCategories.returndata = sampledata;
          $scope.subCategories.push(subCategories);
        });
    }


    function getSubCategories(params) {

      var sampledata = {
        topic: '',
        createdby: '',
        createdOn: '',
        brainstorming: 0,
        solution: 0,
        totalThread: 0,
        totalPost: 0
      };


      MyService.getSubCategoryList($routeParams.categoryId).then(function (payload) {
          var subcatdata = payload;
          //MyService.ConsoleLog("subcatdata: ", subcatdata);
          if (subcatdata.length <= 0) {
            //send the category itself
            MyService.getCategoryList($routeParams.categoryId).then(function (payload) {
              //MyService.ConsoleLog("payload: ",payload);
              subcatdata = [payload];
              angular.forEach(subcatdata, function (value, key) {
                var subCategories = value;
                var subcatId = value._id;
                MyService.ConsoleLog("<<<<<<<value >>>>>>", value.title);
                if (value.title == "General") {
                  $scope.getRootData(subCategories, value._id, sampledata);
                } else {
                  $scope.getData(subCategories, value._id, sampledata);
                }

              });
            }, function (err) {
              //MyService.ConsoleLog("Something went wrong.");
            });
          } else {
            angular.forEach(subcatdata, function (value, key) {
              var subCategories = value;
              //$scope.getData(subCategories, value._id, sampledata);
              MyService.ConsoleLog("<<<<<<<value >>>>>>", value.title);
              if (value.title == "General") {
                $scope.getRootData(subCategories, value._id, sampledata);
              } else {
                $scope.getData(subCategories, value._id, sampledata);
              }
            });
          }

        },
        function (errorPayload) {
          alert('Something went wrong ');
        });


    }



    $scope.gotoThread = function (data, subcatid) {

      var id = '';
      if (data.parentId) {
        id = data.parentId;
      } else if (data.parent) {
        id = data.parent;
      } else {
        if (data.id) {
          id = data.id;
        } else {
          id = data._id;
        }

      }
      var categoryId = $routeParams.categoryId;
      $rootScope.subcategoryId = subcatid;
      $location.path('forumthread/' + categoryId + '/' + subcatid + '/' + id);
    }

    $scope.searchForum = function (data) {
      $location.path('forumSearch/' + data.text);
    }

    if ($routeParams.categoryId) {

      getCategory($routeParams.categoryId, "Main");
      getSubCategories();
      //alert(token);
      if (token) {
        $scope.getExtraData();
      }
    }

    $scope.gotoFThread = function (id, catId, subcatid) {
      $location.path('forumthread/' + catId + '/' + subcatid + '/' + id);
    }
    $scope.gotoForumTopic = function (obj) {
      if (obj.parent && obj.parent != "") {
        $scope.gotoFThread(obj.parent, obj.parentCat[0], obj.subCategories[0]);
      } else {
        $scope.gotoFThread(obj._id, obj.parentCat[0], obj.subCategories[0]);
      }
    }

    $scope.gotoForumT = function (obj) {
      MyService.ConsoleLog("obj", obj);
      var subcat = $scope.getSubCat(obj.parentCat[0]);
      MyService.ConsoleLog("subcat:::", subcat);
      if (obj.parent && obj.parent != "") {
        $scope.gotoFThread(obj.parent, obj.parentCat[0], subcat[0].subCategories[0]._id);
      } else {
        $scope.gotoFThread(obj._id, obj.parentCat[0], subcat[0].subcategories[0]._id);
      }

      //"#!/forumthread/"+obj.parentcat[0]+"/"+subcat+"/"+obj._id;
    }
  }]);

'use strict';
angular.module('myApp.forgotpassword', ['ngRoute'])

.config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/forgot-password/:token', {
        templateUrl: 'app/forgot-password/forgot-password.html',
        controller: 'forgotpasswordCtrl'
    });
}])

.controller('forgotpasswordCtrl', ['$scope', '$http', '$location', 'baseApiUrl', 'growl', '$routeParams', 'tokenService', '$rootScope', 'MyService', '$timeout', function ($scope, $http, $location, baseApiUrl, growl, $routeParams, tokenService, $rootScope, MyService, $timeout) {
	//MyService.ConsoleLog("* ForgotpasswordCtrl *");
$rootScope.welcome = false;
	$scope.resetPassword = function () {
        if ($.fn.validateForceFully($("#forgotPassForm")) == true) {
            var postobj = {
                password: $scope.forgotPassword,
                confirm_password: $scope.confirmPassword,
                reset_token: $routeParams.token
            };

            //MyService.ConsoleLog("postobj: ",postobj);
            
            MyService.resetPassword(postobj)
            .then(function(response){
                if(response.data.success){
                    growl.success("Password reset successfully");
                    $timeout(function(){
                		$location.path('/signin');
                	}, 1500);
                }
                else{
                    if(typeof response.data.error == "string")
                        growl.error(response.data.error);
                    else
                        growl.error("Something went wrong");
                }
            }, function(err){
                growl.error("Something went wrong");
            });
        }
    };

    $("form").validationEngine();
}]);
"use strict";
angular
  .module("myApp.followingUsers", ["ngRoute"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/followingUsers", {
        templateUrl: "app/followingUsers/followingUsers.html",
        controller: "FollowingCtrl"
      });
    }
  ]).controller('FollowingCtrl', ['$scope', '$location', '$rootScope', 'tokenService', 'MyService', 'growl', '$cookies', 'apiCall', '$http', 'ngDialog', function ($scope, $location, $rootScope, tokenService, MyService, growl, $cookies, apiCall, $http, ngDialog) {
    //MyService.ConsoleLog("* Following *");
    $scope.loginUser = tokenService.getUserId();
    $scope.allData = JSON.parse(tokenService.getUserData());
    $scope.fData = $scope.allData.followlist;
    $scope.userId = tokenService.getUserId();
    $rootScope.tempUserAddress = $scope.allData.address;
    $scope.users = {
      data: []
    };
    $scope.showList = true;
    $scope.isExist = false;
    $cookies.remove('quizTakerId');
    window.localStorage.removeItem('quesData');
    window.localStorage.removeItem('comData');
    window.localStorage.removeItem('inviterId');
    window.localStorage.removeItem('inviterInfo');

    /**
     * @description Function is use to check if the quiz taker is exist or not
     */
    $scope.checkIfQuizTakerExist = function () {
      MyService.checkIfQuizTakerExist({
        inviterId: $scope.loginUser
      }).then(function (APIResponse) {
        MyService.ConsoleLog("APIResponse", APIResponse);
        if (APIResponse.data.success) {
          $scope.result = APIResponse.data.data;
          MyService.ConsoleLog("$scope", $scope.result);
          $scope.categoryId = $scope.result[0].selCatId;
          $scope.followersIds = $scope.result.map(function (itms) {
            if (itms && itms.quizTakerArr) {
              return itms.quizTakerArr;
            }
          });

          MyService.ConsoleLog("$scope.followersIds", $scope.followersIds);
          $scope.getFollowersList();
        } else {
          // growl.error(APIResponse.data.error);
        }

      }, function (err) {
        // growl.error(err);
        MyService.ConsoleLog("Error", err);
      });
    };


    $scope.getFollowersList = function () {
      MyService.getFollowersList({
        orgId: $scope.loginUser
      }).then(
        function (response) {
          MyService.ConsoleLog('response', response.data);
          $scope.followersCnt = response.data.followersCount;
          $scope.followersData = response.data.followersData;
        },
        function (err) {
          MyService.ConsoleLog('error', err);
        }
      );
    };




    /**
     * @description Show pop up with the url quiz
     */
    $scope.shareQuiz = function (val) {
      MyService.ConsoleLog("val", val);

      if ($scope.userId && $scope.userId != '') {

        var tempLink = $location.absUrl().split("#!");
        if (val && val.mainCatId != null && val.selCatId != '') {
          $scope.shareLink = tempLink[0] + "#!/exploreQuiz/" + val.mainCatId + "/" + val.selCatId + "/" + $scope.userId;
          var modalUrl = ngDialog.openConfirm({
            template: 'exporeQuizLink',
            scope: $scope,
            width: "60%"
          });
          modalUrl.then(
            function fullfilled(data) {
              //MyService.ConsoleLog("fullfilled: ", data);

            },
            function rejected(data) {

            }
          );
        } else {
          var request = apiCall.apiCall('GET', '/categories/list', {
            id: val.selCatId
          });
          request.headers['Cache-Control'] = 'No-Store';
          $http(
            request
          ).then(function successCallback(response) {
            MyService.ConsoleLog("Got categories: ", response);
            if (response.data.success) {
              var cat = response.data.data;
              if (cat && cat != '') {
                $scope.shareLink = tempLink[0] + "#!/exploreQuiz/" + cat.parentIds[0].pid + "/" + val.selCatId + "/" + $scope.userId;

                var modalUrl = ngDialog.openConfirm({
                  template: 'exporeQuizLink',
                  scope: $scope,
                  width: "60%"
                });
                modalUrl.then(
                  function fullfilled(data) {
                    //MyService.ConsoleLog("fullfilled: ", data);

                  },
                  function rejected(data) {

                  }
                );
              }
            } else {
              //MyService.ConsoleLog("Something went wrong: ",response.data);
            }
          }, function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ",response);
          });
        }

      }
    };

    // $scope.getFollowers = function () {
    //   $scope.tmpArr = [];
    //   $scope.showList = !$scope.showList;
    //   var tmo = $scope.followersIds.filter(function (eles) {
    //     var len = eles.length;
    //     for (var i = 0; i < len; i++) {
    //       $scope.tmpArr.push(eles[i]);
    //     }
    //   });
    //   MyService.ConsoleLog("$scope.tmpArr", $scope.tmpArr);
    //   var remvDuplicates = $scope.tmpArr.filter(function (vals, ind) {
    //     return ind == $scope.tmpArr.findIndex(function (eles) {
    //       return JSON.stringify(eles) == JSON.stringify(vals);
    //     });
    //   });
    //   MyService.ConsoleLog("remvDuplicates", remvDuplicates);
    //   MyService.getAllUsersData({
    //     "followlist": JSON.stringify(remvDuplicates)
    //   }).then(function (APIResponse) {
    //     MyService.ConsoleLog("APIResponse : ", APIResponse);
    //     $scope.followers = APIResponse;

    //   }, function (error) {
    //     //MyService.ConsoleLog(error);
    //   })
    // };

    $scope.getUserDetails = function () {
      MyService.getUserPublicProfile({
        id: $scope.loginUser,
        type: 'false'
      }).then(function (response) {
        MyService.ConsoleLog("reposnse", response);
        var data;
        if (response.data.success) {
          data = JSON.stringify(response.data.data.userData.followingUsers);
        } else {
          data = JSON.stringify($scope.fData);
        }
        MyService.getAllUsersData({
          "followlist": data
        }).then(function (payload) {
          MyService.ConsoleLog("payload : ", payload);
          $scope.users.data = payload;
          $scope.checkIfQuizTakerExist();
        }, function (error) {
          //MyService.ConsoleLog(error);
        })
      }, function (err) {
        console.log('err :', err);
      });

      //MyService.ConsoleLog(data);
    }

    $scope.unfollow = function (odata, idx) {
      var data = {};
      data.userId = $scope.loginUser;
      data.pushId = odata._id;
      data.isExist = $scope.isExist;
      MyService.removeUserFollowList(data).then(function (payload) {
          var newidx = $scope.users.data.indexOf(odata);
          if (newidx > -1) {
            $scope.users.data.splice(newidx, 1);
          }

          $scope.allData.followlist.splice(odata._id, 1);
          //MyService.ConsoleLog("udata : ", $scope.allData);
          tokenService.saveUserData(JSON.stringify($scope.allData));
          alert("User removed from followup list successfully.");
        },
        function (errorPayload) {
          alert('Something went wrong ');
        });
    }

    /**
     * This function calls on page load
     * fetch data of user's area politician ,voters and advocates
     */

    $scope.getLocalPoliticians = function (asdata) {
      // MyService.ConsoleLog(" welcome to getLocalPoliticians ", $rootScope.queData);
      $scope.statusGetLocalPoliticians = 1;
      $scope.page += 1;
      $scope.loader = true;
      // MyService.ConsoleLog("$rootScope.tempUserA ******* ", $rootScope.tempUserAddress);
      // MyService.ConsoleLog("$rootScope.tempUserA ******* ", $rootScope.tempUserAddress.state)
      var extradata = new Object();
      if ($rootScope.tempUserAddress) {
        if ($rootScope.tempUserAddress.state && $rootScope.tempUserAddress.state != '') {
          extradata.statePostalCode = $rootScope.tempUserAddress.statePostalCode;
        }
        if ($rootScope.tempUserAddress.county && $rootScope.tempUserAddress.countyFips) {
          $rootScope.tempUserAddress.FinalData = JSON.stringify(
            $rootScope.tempUserAddress.countyFips
          );
          extradata.county = $rootScope.tempUserAddress.county;
        }
        if (
          $rootScope.tempUserAddress.countySubdivision &&
          $rootScope.tempUserAddress.countySubdivisionFips
        ) {
          $rootScope.tempUserAddress.FinalData = JSON.stringify(
            $rootScope.tempUserAddress.countySubdivisionFips
          );
          extradata.countySubdivision = $rootScope.tempUserAddress.countySubdivision;
        }
        if ($rootScope.tempUserAddress.place && $rootScope.tempUserAddress.placeFips) {
          //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
          extradata.place = $rootScope.tempUserAddress.place;
        }
        if (
          $rootScope.tempUserAddress.voterDistrict &&
          $rootScope.tempUserAddress.voterDistrictFips
        ) {
          //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
          extradata.voterDistrict = $rootScope.tempUserAddress.voterDistrict;
        }
        if ($rootScope.tempUserAddress.federalCongrassionalDist) {
          //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
          MyService.ConsoleLog(
            'federalCongrassionalDist  :',
            $rootScope.tempUserAddress.federalCongrassionalDist
          );
          extradata.federalCongrassionalDist =
            $rootScope.tempUserAddress.federalCongrassionalDist;
        }
        if ($rootScope.tempUserAddress.stateSenateDistrict) {
          //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
          extradata.stateSenateDistrict = $rootScope.tempUserAddress.stateSenateDistrict;
        }
        if ($rootScope.tempUserAddress.legislativeDistrict) {
          //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
          extradata.legislativeDistrict = $rootScope.tempUserAddress.legislativeDistrict;
        }
        if ($rootScope.tempUserAddress.schoolDistrict) {
          //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
          extradata.schoolDistrict = $rootScope.tempUserAddress.schoolDistrict;
        }
      }
      MyService.ConsoleLog('extradata : >>>>>>>>>> ', JSON.stringify(extradata));
      MyService.getAllLocalPoli({
        max_records: 100,
        page: $scope.page,
        extradata: JSON.stringify(extradata),
      }).then(
        function (response) {
          if (response.data.success) {
            setTimeout(function () {
              $scope.$apply(function () {
                if (response.data.data.length > 0) {
                  MyService.getAdvocates().then(function (payload) {
                    MyService.ConsoleLog("Response >", payload);
                    var ndata = response.data.data;
                    if ($scope.inviterId) {
                      $scope.userAreaPolitician = [];
                      $scope.userAreaPolitician.push($scope.inviterId);
                    } else {
                      var wdata = ndata.concat(payload.data.data);
                      $scope.userAreaPolitician = wdata.map(function (ques) {
                        return ques._id;
                      });
                    }
                    MyService.ConsoleLog(" $scope.userAreaPolitician >", $scope.userAreaPolitician);

                    var param = JSON.stringify({
                      usersIds: $scope.userAreaPolitician,
                      cur_userId: $scope.loginUser,
                      questions: JSON.stringify(asdata)
                    });

                    // MyService.ConsoleLog("apra >", param);
                    // window.localStorage.removeItem('comData');
                    window.localStorage.setItem('comData', param);
                    $scope.loadernew = false;
                    $scope.skipToFinal = true;
                    $scope.skipToMatch = true;
                  }, function (err) {
                    MyService.ConsoleLog("Error >>", err);
                  });
                } else {
                  $scope.loader = false;
                  var message =
                    'None of your politicians have answered the questions yet. Contact them and ask them to fill it out.';
                  var modal = ngDialog.openConfirm({
                    template: '<p>' +
                      message +
                      '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">OK</button>\
                            \
                        </div>',
                    plain: true,
                  });

                  modal.then(
                    function fullfilled(data) {
                      //MyService.ConsoleLog("fullfilled: ", data);
                      if (data == 1) {
                        $scope.postonFacebook();
                      } else {
                        if ($rootScope.userRole) {
                          $location.path('/snapshot');
                        } else {
                          $location.path('/signin');
                        }
                      }
                    },
                    function rejected(data) {
                      //MyService.ConsoleLog("rejected: ", data);
                    }
                  );
                }
              });
            }, 100);
          } else {
            $scope.page -= 1;
            $scope.statusGetLocalPoliticians = 3;
            if (typeof response.data.error == 'string') growl.error(response.data.error);
            else growl.error('Something went wrong');
          }
        },
        function (err) {
          $scope.page -= 1;
          $scope.statusGetLocalPoliticians = 3;
          $scope.loader = false;
          growl.error(err);
        }
      );
    };


    /**
     * @description Get Inviter details
     */

    $scope.getmyData = function (val, quesData) {
      MyService.ConsoleLog("quizTakerId", val.quizTakerId);
      $scope.showLoader = true;
      $scope.ShowPorifleLoading = true;
      MyService.getUserPublicProfile({
        id: val.quizTakerId,
        type: 'false'
      }).then(function (response) {
        $scope.ShowPorifleLoading = false;
        if (response.data.success) {
          $scope.userDetails = response.data.data;
          // MyService.ConsoleLog("welcome", $scope.userDetails);
          $scope.userProfile = $scope.userDetails.userData;
          MyService.ConsoleLog("welcome to profile", $scope.userProfile);
          $scope.poliName = $scope.userProfile.nameOnBallot;
          window.localStorage.getItem('inviterInfo', JSON.stringify($scope.userProfile));
          if (val.quizTakerArr && val.quizTakerArr.length > 1) {
            $cookies.put('quizTakerIdsArr', JSON.stringify(val.quizTakerArr));
          } else {
            $cookies.put('quizTakerId', val.quizTakerId);
          }

          $scope.userAreaPolitician = [];
          $scope.userAreaPolitician = val.quizTakerArr;
          console.log('$scope.userAreaPolitician :', $scope.userAreaPolitician);
          // return;
          var param = JSON.stringify({
            usersIds: $scope.userAreaPolitician,
            cur_userId: $scope.loginUser,
            questions: JSON.stringify(quesData)
          });

          MyService.ConsoleLog("apra >", param);
          window.localStorage.setItem('quesData', JSON.stringify(quesData));
          $location.path('/findFollowerMatch/true');

        } else {
          MyService.ConsoleLog("ELSE vishal");
          $scope.showLoader = false;
          alert("Something went wrong.");
        }
      }, function (errorPayload) {
        $scope.ShowPorifleLoading = false;
        MyService.ConsoleLog("ELSE vishal two");

        alert("Something went wrong.");
      });
    };

    /**
     * @description Function is use to get match of quiz taker
     */
    $scope.getMatch = function (val) {
      MyService.ConsoleLog("selId", val.selCatId);
      MyService.getQuestions({
        categoryId: val.selCatId
      }).then(function (APIResponse) {
        MyService.ConsoleLog("APIResponse", APIResponse);
        // $scope.getLocalPoliticians(APIResponse.data.data);
        if (APIResponse.data.success) {
          $scope.getmyData(val, APIResponse.data.data);
        }

      }, function (err) {
        MyService.ConsoleLog("Err", err);
      });
    };


    $scope.checkInviter = function () {
      MyService.ConsoleLog("$scope.fData", $scope.fData);
      MyService.checkInviter({
        "Ids": $scope.fData
      }).then(function (APIResponse) {
        MyService.ConsoleLog("APIResponse check", APIResponse);
        if (APIResponse.data.success) {
          $scope.isExist = true;
        } else {
          $scope.isExist = false;
        }
        $scope.getUserDetails();
      }, function (err) {
        console.log('err :', err);
      });
    };

    // if ($rootScope.showFollowing) {
    if ($scope.fData.length > 0) {
      $scope.checkInviter();
    } else {
      $scope.checkInviter();
      $scope.checkIfQuizTakerExist();
    }
    // }
  }])

'use strict';
angular
  .module('myApp.followersQuiz', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/followersQuiz/:quizName?/:orgId?/:isExist?', {
        templateUrl: 'app/followersQuiz/followersQuiz.html',
        controller: 'followersQuizCtrl',
      });
    },
  ]).controller('followersQuizCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    '$routeParams',
    '$q',
    'ngDialog',
    '$rootScope',
    'growl',
    'MyService',
    '$anchorScroll',
    '$timeout',
    'tokenService',
    '$cookies',
    'baseApiUrl',
    '$document',
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $q,
      ngDialog,
      $rootScope,
      growl,
      MyService,
      $anchorScroll,
      $timeout,
      tokenService,
      $cookies,
      baseApiUrl,
      $document
    ) {
      $scope.qName = $routeParams.quizName;
      $scope.orgId = $routeParams.orgId;
      // $scope.isExist = true;
      MyService.ConsoleLog("new");

      $cookies.remove('isExist');
      $cookies.remove('orgId');
      $cookies.remove('qName');
      $scope.showCheck = true;
      if (window.localStorage.getItem('isOrg') == 'true') {
        $scope.showCheck = false;
      }

      /**
       * redirect to the login form
       */
      if (!tokenService.getUserId()) {
        $cookies.put('orgId', $scope.orgId);
        $cookies.put('qName', $scope.qName);
        $cookies.put('isExist', true);

        $location.path('/showPopUp');
      }


      $rootScope.welcome = true;
      $scope.currentIndex = 0;
      $scope.questions = [];
      $scope.oldQuestions = [];
      $scope.tempans = [];
      $scope.oldIndex = 0;
      $scope.showZipCode = false;
      $scope.isShare = true;
      $scope.showloader = false;
      $scope.UserId = tokenService.getUserId();
      window.localStorage.removeItem('followData');
      $scope.updata = {
        comment: '',
        reason: '',
      };
      // $scope.skipToRes = false;
      $('#skipMatch').attr('disabled', true);

      MyService.ConsoleLog(' user id :', $scope.UserId);
      if ($cookies.get('sessionId')) {
        $cookies.remove('sessionId');
      }
      $scope.fivefb = {
        title: 'Take a fun five minute quiz to find out who to vote for in your local elections',
        description: '',
        fbFiveImage: '',
      };

      $scope.getFiveFacebookPost = function (data) {
        MyService.getFiveFacebookPost().then(
          function (payload) {
            // MyService.ConsoleLog(payload)
            if (payload.data.success) {
              $scope.fivefb.title = payload.data.data.fbTitle;
              $scope.fivefb.description = payload.data.data.fbDescription;
              if (payload.data.data.fbImage) {
                $scope.fivefb.fbFiveImage = baseApiUrl + '/resources/' + payload.data.data.fbImage;
              }
            }
          },
          function (errorPayload) {}
        );
      };

      $scope.getFiveFacebookPost();

      if ($scope.currentIndex == 0) {
        if (window.localStorage.getItem('fiveMinMatch')) {
          // $scope.questions = JSON.parse(window.localStorage.getItem("fiveMinMatch"));
          $rootScope.fiveMatch = JSON.parse(window.localStorage.getItem('fiveMinMatch'));
          $timeout(function () {
            $scope.$apply();
          });
        } else {
          $rootScope.fiveMatch = [];
          $rootScope.fiveMatch.length = 0;
        }
      }
      $scope.initializeVariables = function () {
        $scope.importance = null;
        $scope.answer = null;
        $scope.updata.comment = '';
        $scope.updata.reason = '';
      };

      $scope.saveFiveMinAnswers = function (skip) {
        // MyService.ConsoleLog("saveFiveMinAnswers : ");
        MyService.ConsoleLog('saveFiveMinAnswers fiveMatch >>>: ', $rootScope.fiveMatch);
        // alert(skip);
        $scope.pstData = [];
        var len = $rootScope.fiveMatch.length;
        MyService.ConsoleLog('Len :: ', len);
        if (len > 0) {
          for (var i = 0, k = 1; i < len; i++) {
            if (skip != '') {
              $scope.answer = '';
              $scope.importance = '';
              $scope.updata.comment = '';
              if ($rootScope.fiveMatch[i]) {
                // console.log("Inside i ", i);
                // console.log("answer :", $rootScope.fiveMatch[i].answer);
                if ($rootScope.fiveMatch[i].answer && $rootScope.fiveMatch[i].answer != '') {
                  $scope.answer = $rootScope.fiveMatch[i].answer;
                  $scope.importance = $rootScope.fiveMatch[i].importance;
                  $scope.updata.comment = $rootScope.fiveMatch[i].comment;
                  var postData = {
                    questionId: $rootScope.fiveMatch[i]._id,
                    importance: $scope.importance,
                    answer: $scope.answer,
                    comment: $scope.updata.comment,
                    categories: $rootScope.fiveMatch[i]['categories'],
                    content: $rootScope.fiveMatch[i]['content'],
                    _id: $rootScope.fiveMatch[i]['_id'],
                  };
                  $rootScope.fiveMatch[i] = angular.copy(postData);
                  // console.log("fiveMatch[i] > ", $rootScope.fiveMatch[i]);
                  $scope.pstData.push(postData);
                } else {
                  var data = $scope.checkQuestion($rootScope.fiveMatch[i]._id);
                  if (data && data[0]) {
                    // MyService.ConsoleLog("getdata >>> ", data[0]);
                    if (data[0].answer != '') {
                      $scope.answer = data[0].answer;
                    }
                    if (data[0].importance != '') {
                      $scope.importance = data[0].importance;
                    }
                    if (data[0].comment != '') {
                      $scope.updata.comment = data[0].comment;
                    }
                  }
                  var postData1 = {
                    questionId: $rootScope.fiveMatch[i]._id,
                    importance: $scope.importance,
                    answer: $scope.answer,
                    comment: $scope.updata.comment,
                    categories: $rootScope.fiveMatch[i]['categories'],
                    content: $rootScope.fiveMatch[i]['content'],
                    _id: $rootScope.fiveMatch[i]['_id'],
                  };
                  $rootScope.fiveMatch[i] = angular.copy(postData1);
                  $scope.pstData.push(postData1);
                }
              }
            } else {
              var postData = $rootScope.fiveMatch[i];
              $scope.pstData.push(postData);
            }
            if (skip != '' && postData) {
              console.log('saveFiveMinAnswers postData >>>>>>> ', postData);

              MyService.postAnswer(postData).then(
                function (response) {
                  // MyService.ConsoleLog("saveFiveMinAnswers response >>>", response);
                  if (response.data.success) {
                    MyService.ConsoleLog('Answer updated successfully');
                    growl.success('Answer updated successfully');
                  } else {
                    MyService.ConsoleLog('Error: ' + response.data.error);
                    growl.error(response.data.error);
                  }
                  if (k == len) {
                    $rootScope.fiveMatch = angular.copy($scope.pstData);
                    window.localStorage.setItem('fiveMatch', JSON.stringify($rootScope.fiveMatch));
                    MyService.ConsoleLog(
                      '$rootScope.fiveMatch > ******** >>>',
                      $rootScope.fiveMatch
                    );
                    if (skip == 'RediectNew') {
                      $location.path('/fiveCompare/skip_to_result');
                    } else if (skip != 'skipNew') {
                      MyService.ConsoleLog('IFFFFFFFFFFFFFF');
                      $location.path('/fiveCompare');
                    }
                  }
                  k++;
                },
                function (err) {
                  MyService.ConsoleLog('Error: err');
                }
              );
            } else {
              $scope.updata.comment = '';

              if (k == len) {
                $rootScope.fiveMatch = angular.copy($scope.pstData);
                window.localStorage.setItem('fiveMatch', JSON.stringify($rootScope.fiveMatch));
                MyService.ConsoleLog('$rootScope.fiveMatch > ******** >>>', $rootScope.fiveMatch);
                if (skip == 'RediectNew') {
                  $location.path('/fiveCompare/skip_to_result');
                } else if (skip != 'skipNew') {
                  MyService.ConsoleLog('IFFFFFFFFFFFFFF');
                  $location.path('/fiveCompare');
                }
              }
              k++;
            }
          }
        }
      };

      /**
       * insert followers answer with flag
       */
      $scope.addFollowersAnswers = function () {
        var len = $rootScope.fiveMatch.length;
        if (len > 0) {
          for (var i = 0; i < len; i++) {
            // $rootScope.fiveMatch[i].show = isShow;
            MyService.ConsoleLog($rootScope.fiveMatch[i]);
            MyService.postAnswer($rootScope.fiveMatch[i]).then(
              function (response) {
                MyService.ConsoleLog(response);
                if (response.data.success) {
                  MyService.ConsoleLog('Answer updated successfully');
                } else {
                  MyService.ConsoleLog('Error: ' + response.data.error);
                }
              },
              function (err) {
                MyService.ConsoleLog('Error: ');
              }
            );
          }
        }
      };

      $scope.fiveMinuteMatchDone = function () {
        $scope.showpopUp = false;
        if (!$scope.UserId || $scope.UserId == '') {
          MyService.ConsoleLog('$scope.Questions', $scope.questions);
          var qLen = $scope.questions.length;
          for (var t = 0; t < qLen; t++) {
            if (
              $scope.questions[t].my_answer &&
              $scope.questions[t].my_answer != '' &&
              $scope.questions[t].my_answer.answer != ''
            ) {
              // alert('got');
              MyService.ConsoleLog("is exist", $scope.isExist);
              if ($scope.isExist && $scope.isExist == 'true') {
                $location.path('/fiveminsignin');
              } else {
                $scope.showpopUp = true;
                $scope.showZipCode = true;
              }
            } else {
              if (!$scope.showpopUp && t == qLen - 1) {
                var message = 'You need to answer at least one question to see a match comparison';
                var modal = ngDialog.openConfirm({
                  template: '<p>' +
                    message +
                    '</p>\
                  <div class="ngdialog-buttons">\
                      <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Back to Questions</button>\
                  </div>',
                  plain: true,
                  closeByDocument: false,
                });
                modal.then(
                  function fullfilled(data) {
                    // MyService.ConsoleLog("fullfilled: ", data);
                    $scope.getFollowersQuiz();
                  },
                  function rejected(data) {
                    // MyService.ConsoleLog("rejected: ", data);
                    // $scope.getMatchQUestions();
                  }
                );
                t = qLen + 1;
              }
            }
          }
        } else {
          MyService.ConsoleLog('saveFiveMinAnswers fiveMatch >>>: ', $rootScope.fiveMatch);
          // alert('inside');
          /*  MyService.ConsoleLog("orgInf", $scope.orgInfo);
            var message = 'Do you want to share your quiz answers to the ' + '<b>' + $scope.orgInfo.title + '</b>';
            var modal = ngDialog.openConfirm({
              template: '<p>' +
                message +
                '</p>\
              <div class="ngdialog-buttons">\
                  <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Yes</button>\
                  <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(2)">No</button>\
              </div>',
              plain: true,
              closeByDocument: false,
            });
            modal.then(
              function fullfilled(data) {
                if (data == 1) {
                  MyService.ConsoleLog("Yes ");
                  $scope.AddFollowersAnswers('Y');
                  $location.path('/orgMatch/' + $scope.orgId);
                } else {
                  $scope.AddFollowersAnswers('N');
                  MyService.ConsoleLog("No");
                  $location.path('/orgMatch/' + $scope.orgId);

                }
              },
              function rejected(data) {
                MyService.ConsoleLog("rejected: ", data);
                // $scope.getMatchQUestions();
              }
            );*/
          $scope.addFollowersAnswers();
          if (window.localStorage.getItem('isOrg') == 'true') {
            var message = 'Congratulations, ' + $scope.orgInfo.title + '. You finished the quiz.  Now you can invite politicians and compare answers.';
            var modals = ngDialog.openConfirm({
              template: '<p>' +
                message +
                '</p>\
              <div class="ngdialog-buttons">\
                  <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Back to Quizzes</button>\
              </div>',
              plain: true,
              closeByDocument: false,
            });
            modals.then(
              function fullfilled(data) {
                MyService.ConsoleLog("fullfilled: ", data);
                $location.path('/allQuizzes');
              },
              function rejected(data) {
                // MyService.ConsoleLog("rejected: ", data);
                // $scope.getMatchQUestions();
              }
            );
          } else {
            $location.path('/orgMatch/' + $scope.orgId);
          }


          // $scope.saveFiveMinAnswers('');
        }
      };
      $scope.initializeVariables();
      $scope.newQuestion = function () {
        MyService.ConsoleLog('newQuestion' + $scope.currentIndex);
        // alert('three');
        var tempIndex = $scope.currentIndex;
        $scope.initializeVariables();

        $scope.answer = '';
        $scope.importance = '';
        $scope.updata.comment = '';
        MyService.ConsoleLog("tempIndex", tempIndex + "   quesLen" + $scope.questions.length);
        if (tempIndex < $scope.questions.length) {
          $scope.initializeVariables();

          if (window.localStorage.getItem('fiveMinMatch')) {
            $scope.getFiveMinData = [];
            $scope.getFiveMinData = JSON.parse(window.localStorage.getItem('fiveMinMatch'));
            MyService.ConsoleLog('Data : ', $scope.getFiveMinData);
            for (var i = 0; i < $scope.getFiveMinData.length; i++) {
              // MyService.ConsoleLog("for i : " + i + " currentIndex : " + $scope.currentIndex);
              if (i == $scope.currentIndex) {
                // MyService.ConsoleLog("index matched", $scope.getFiveMinData[i]);
                $scope.answer = $scope.getFiveMinData[i].answer;
                $scope.importance = $scope.getFiveMinData[i].importance;
                $scope.updata.comment = $scope.getFiveMinData[i].comment;
                $timeout(function () {
                  $scope.$apply();
                });
              }
            }
          } else {
            console.log('Else is called');
            $scope.answer = '';
            $scope.importance = '';
            $scope.updata.comment = '';
            console.log('importance > ', $scope.importance);
            MyService.ConsoleLog('got >> ', window.localStorage.getItem('fiveMatch'));

          }
          //$scope.currentIndex++;
        } else {
          // MyService.ConsoleLog("final question : " + $scope.questions.length);
          MyService.ConsoleLog('got >> ', window.localStorage.getItem('fiveMatch'));

          // alert('newques');
          $scope.fiveMinuteMatchDone();
        }
      };

      $scope.checkQuestion = function (val) {
        if ($scope.AllAnsweredQuestions && $scope.AllAnsweredQuestions.length > 0) {
          return $scope.AllAnsweredQuestions.filter(function (rdata) {
            // MyService.ConsoleLog("if", rdata.question + "==" + val);
            if (rdata.question == val) return rdata;
          });
        } else {
          return $rootScope.fiveMatch.filter(function (rdata) {
            // MyService.ConsoleLog("else", rdata.questionId + "<==>" + val);
            if (rdata.questionId == val) return rdata;
          });
        }
      };

      $scope.checkIfExists = function (val) {
        var obj = $scope.questions[$scope.currentIndex];
        if (obj) {
          var data;
          // MyService.ConsoleLog("checkIfExists >> ", obj);

          if (obj && obj.queId && obj.queId != '') {
            data = $scope.checkQuestion(obj.queId);
          } else {
            // alert('else');
            data = $scope.checkQuestion(obj._id);
            // MyService.ConsoleLog("inside else", data);

          }

          if (data && data[0]) {
            // MyService.ConsoleLog("checkIfExists data>> ", data[0]);
            // MyService.CongressionalDistrict("val", val);
            // $scope.comment = data[0].comment;
            if (data[0].answer == val) {
              // console.log("return True");
              $scope.dis = true;
              return true;
            }
          }
        }
        return false;
      };

      $scope.checkQuestionAnswered = function () {
        // console.log("scope.questions > ", $scope.questions);
        return $scope.questions.filter(function (rdata) {
          // MyService.ConsoleLog("== rdata >>>", rdata);
          var data = $scope.checkQuestion(rdata._id);
          // MyService.ConsoleLog("rdata.questionId  ", data);

          if (data && data.length > 0) return rdata;
        });
      };

      $scope.oneMore = function (valOne) {
        console.log('One more clicked', $scope.isShare);
        $scope.importance = valOne;
        // console.log("$scope.importance >> ",$scope.importance);
        $scope.submitAnswer();
      };

      $scope.checkImpExists = function (val) {
        // MyService.ConsoleLog('checkImpExists called :', $scope.importance);
        var obj = $scope.questions[$scope.currentIndex];
        if (obj) {
          // MyService.ConsoleLog('data', obj);
          var data;
          if (obj && obj.queId && obj.queId != '') {
            data = $scope.checkQuestion(obj.queId);
          } else {
            data = $scope.checkQuestion(obj._id);
          }
          if (data && data[0]) {
            if (data[0].importance == val) {
              return true;
            }
          } else {
            // alert('one');
            // MyService.ConsoleLog('compare them', $scope.importance + '   ' + val);
            if ($scope.importance == val) {
              $scope.importance = '';
            }
          }
        }
        return false;
      };

      $scope.$watch('currentIndex', function (newValue, oldValue) {
        try {
          MyService.ConsoleLog('Current currentIndex: ', $scope.currentIndex);
          var data = $scope.checkQuestion($scope.questions[$scope.currentIndex]._id);
          // console.log("data >> ", data);
          if (data && data[0]) {
            $scope.updata.comment = data[0].comment;
          }
        } catch (e) {
          //MyService.ConsoleLog("Current Index Change Ex: ", e)
        }
      });

      $scope.cachedQuestions = [];
      $scope.flagSkipAnsweredQuestion = false;
      $scope.skipAnswerChagne = function () {
        MyService.ConsoleLog('scope.flagSkipAnsweredQuestion: ', $scope.flagSkipAnsweredQuestion);
        MyService.ConsoleLog('$scope.questi', $scope.questions);
        $scope.temp = $scope.questions;

        $scope.currentIndex = 0;
        var questions = $scope.checkQuestionAnswered();
        $scope.dis = false;
        MyService.ConsoleLog('questions > ', questions);
        if (questions && questions.length > 0) {
          // alert('insise');
          if ($scope.flagSkipAnsweredQuestion) {
            $scope.cachedQuestions.length = 0;
            $scope.cachedQuestions = angular.copy($scope.questions);
            for (var i = 0; i < questions.length; i++) {
              var idx = $scope.questions.indexOf(questions[i]);
              if (idx > -1) {
                $scope.questions.splice(idx, 1);
              }
            }
            // console.log("questionslength > ", $scope.cachedQuestions.length + "==" + questions.length);
            MyService.ConsoleLog('$scope.cachedQuestions :', $scope.cachedQuestions);
            if ($scope.cachedQuestions.length == questions.length) {
              // console.log("questionslength Equal");
              if ($rootScope.fiveMatch.length == 0) {
                $rootScope.fiveMatch = angular.copy($scope.cachedQuestions);
                MyService.ConsoleLog(' $rootScope.fiveMatch one :', $rootScope.fiveMatch);
                var lents = $rootScope.fiveMatch.length;
                MyService.ConsoleLog(
                  'Len >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>',
                  lents
                );
                if (lents >= 5) {
                  // $scope.skipToRes = true;
                  $('#skipMatch').attr('disabled', false);
                }
                $scope.questions = angular.copy($scope.cachedQuestions);
                // $scope.answer = '';

              }
              // $scope.saveFiveMinAnswers('skip');
            } else {
              // alert("esle");
              $scope.updata.comment = '';
              $rootScope.fiveMatch = angular.copy(questions);
              var lent = $rootScope.fiveMatch.length;
              MyService.ConsoleLog('lent @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@', lent);

              if (lent >= 5) {
                // $scope.skipToRes = true;
                $('#skipMatch').attr('disabled', false);
              }
              // $scope.saveFiveMinAnswers('skipNew');
            }
          } else {
            $scope.questions = angular.copy($scope.cachedQuestions);
          }
        } else {
          if (!$scope.flagSkipAnsweredQuestion) {
            MyService.ConsoleLog('INside');
            $scope.questions = angular.copy($scope.cachedQuestions);
            if ($scope.questions[$scope.currentIndex]) {
              MyService.ConsoleLog('ONe MORE');
              // console.log($scope.questions[$scope.currentIndex]._id);
              var data = $scope.checkQuestion($scope.questions[$scope.currentIndex]._id);
              // console.log("data >> ", data);
              if (data && data[0]) {
                $scope.updata.comment = data[0].comment;
              }
            } else {
              // $scope.flagSkipAnsweredQuestion = false;
              // alert("inside");
              MyService.ConsoleLog('$scope.temp', $scope.temp);
              $scope.questions = $scope.temp;
            }
          }
        }
      };

      // $scope.commenta=function()
      $scope.checkQuestions = function (rdata, val) {
        MyService.ConsoleLog('rdata :', rdata);
        return rdata.filter(function (rdata) {
          // MyService.ConsoleLog(rdata.question + "==" + val);
          if (rdata.questionId == val) return rdata;
        });
      };

      $scope.saveAnswersOneByOne = function (params) {
        MyService.ConsoleLog('post params >>>>>:', params);
        /**
         * Commented for pop up
         */
        /*if (params && params != '') {
          MyService.postAnswer(params).then(
            function (response) {
              document.getElementById('txtReason').value = '';

              if (response.data.success) {
                try {
                  if (params.id) {
                    $scope.questions[$scope.currentIndex]['my_answer'] = {
                      _id: postData.id,
                      created: new Date(),
                      comment: params.comment,
                      questionId: params.questionId,
                      answer: params.answer,
                      importance: params.importance,
                    };
                  } else {
                    $scope.questions[$scope.currentIndex]['my_answer'] = {
                      _id: response.data.data._id,
                      created: response.data.data.created,
                      questionId: response.data.data.question,
                      comment: response.data.data.comment,
                      answer: response.data.data.answer,
                      importance: response.data.data.importance,
                    };
                  }
                } catch (e) {
                  //MyService.ConsoleLog("Exceptoin: ", e);
                }
                if (response.data.data.question) {
                  $scope.AllAnsweredQuestions.push(response.data.data);
                }

                if (params.id) {
                  growl.success('Answer updated successfully', {
                    ttl: 5000,
                  });
                } else {
                  growl.success('Answered successfully', {
                    ttl: 5000,
                  });
                }
                $scope.currentIndex = $scope.currentIndex + 1;

                // MyService.ConsoleLog(window.localStorage.getItem("fiveMatch"));
                $scope.newQuestion();
              } else {
                growl.error('Error: ' + response.data.error);
              }
            },
            function (err) {
              // growl.error("Something went wrong.");
            }
          );
        } */
      };

      $scope.postAnswer = function (postData, val) {
        MyService.ConsoleLog('postData: ', postData);
        // MyService.ConsoleLog("Index <><><", $rootScope.fiveMatch.indexOf(postData));
        var ndata = $scope.checkQuestion(postData.questionId);
        MyService.ConsoleLog('ndata >', ndata);
        // MyService.ConsoleLog($rootScope.fiveMatch);

        if (ndata.length > 0) {
          var vdx = $scope.AllAnsweredQuestions.indexOf(ndata[0]);
          if (vdx > -1) {
            // console.log("VDX > ", vdx);
            $scope.AllAnsweredQuestions[vdx]['answer'] = postData.answer;
            $scope.AllAnsweredQuestions[vdx]['importance'] = postData.importance;
            $scope.AllAnsweredQuestions[vdx]['comment'] = postData.comment;
            // console.log("AS : ", $scope.AllAnsweredQuestions[vdx]);
          }
        }

        $scope.questions[$scope.currentIndex]['my_answer'] = {
          _id: postData._id,
          created: new Date(),
          id: postData.id,
          reason: postData.reason,
          comment: postData.comment,
          answer: postData.answer,
          importance: postData.importance,
        };

        var chkData = $scope.checkQuestions($rootScope.fiveMatch, postData.questionId);
        MyService.ConsoleLog('chkData<><><>', chkData);
        $scope.dis = false;

        postData.categories = $scope.questions[$scope.currentIndex]['categories'];
        postData.content = $scope.questions[$scope.currentIndex]['content'];
        postData._id = $scope.questions[$scope.currentIndex]['_id'];

        if (chkData && chkData.length == 0) {
          // alert("one");
          // MyService.ConsoleLog("postData1if<><><",postData);
          $rootScope.fiveMatch.push(postData);
          // MyService.ConsoleLog("Final Five match <><><><><> ", $rootScope.fiveMatch);
          window.localStorage.setItem('fiveMatch', JSON.stringify($rootScope.fiveMatch));
          if (val == 'submit' && val != 'skip') {
            // if ($scope.UserId && $scope.UserId != '') {
            //   if (postData.questionId && postData.questionId != '') {
            // alert('one');
            //     $scope.saveAnswersOneByOne(postData);
            //     postData = '';
            //   }
            // } else {
            $scope.currentIndex = $scope.currentIndex + 1;
            MyService.ConsoleLog('Else >> ', window.localStorage.getItem('fiveMatch'));
            $scope.importance = angular.copy('');
            growl.success('Answered successfully', {
              ttl: 1000,
            });
            $scope.newQuestion();
            // }
          }

          var fiveLen = $rootScope.fiveMatch.length;

          MyService.ConsoleLog('FiveMatch:  $scope.currentIndex ::: ', $scope.currentIndex);
          $scope.importance = angular.copy('');
          if (fiveLen >= 5) {
            // $scope.skipToRes = true;
            $('#skipMatch').attr('disabled', false);
          }
        } else {
          // alert("two");
          var idx = $rootScope.fiveMatch.indexOf(chkData[0]);

          $rootScope.fiveMatch[idx] = postData;
          $scope.importance = angular.copy('');
          window.localStorage.setItem('fiveMatch', JSON.stringify($rootScope.fiveMatch));
          if (val == 'submit' && val != 'skip') {
            // if ($scope.UserId && $scope.UserId != '') {
            //   if (
            //     (postData.reason && postData.reason != '') ||
            //     (postData.id && postData.id != '')
            //   ) {
            //     // alert('two');
            //     // $scope.saveAnswersOneByOne(postData);
            //     postData = '';
            //   }
            // } else {
            $scope.currentIndex = $scope.currentIndex + 1;
            $scope.importance = angular.copy('');
            MyService.ConsoleLog(
              'currentIndex <><><> ',
              window.localStorage.getItem('fiveMatch')
            );
            $scope.newQuestion();
            // }
          }
        }
      };

      $scope.submitAnswer = function () {
        MyService.ConsoleLog('$scope.comment <>>>>', $scope.updata);
        var answerId = '';
        var answerReason = '';
        var data = $scope.checkQuestion($scope.questions[$scope.currentIndex]._id);
        if (data && data[0]) {
          if (data[0] && data[0]._id) {
            answerId = data[0]._id;
          }
          if (data[0] && data[0]._id) {
            if ($scope.updata && $scope.updata.reason) {
              answerReason = $scope.updata.reason;
            }
          }
        }
        if ($scope.answer == null || $scope.answer == '') {
          var message = 'Please select answer first.';
          var modal = ngDialog.openConfirm({
            template: '<p>' +
              message +
              '</p>\
                         <div class="ngdialog-buttons">\
                             <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                         </div>',
            plain: true,
          });
          modal.then(
            function fullfilled(data) {
              MyService.ConsoleLog('fullfilled: ', data);
            },
            function rejected(data) {
              MyService.ConsoleLog('rejected: ', data);
            }
          );
          $('html, body').animate({
              scrollTop: 0,
            },
            'slow'
          );
          return;
        }
        //MyService.ConsoleLog("**** ", $scope.importance);
        if ($scope.importance == null || $scope.importance == '') {
          var message =
            'You need to choose an importance level.  Should they fight hard for this can they use it to trade for other things you care about more?';
          var modal = ngDialog.openConfirm({
            template: '<p>' +
              message +
              '</p>\
                         <div class="ngdialog-buttons">\
                             <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                         </div>',
            plain: true,
          });
          modal.then(
            function fullfilled(data) {
              //MyService.ConsoleLog("fullfilled: ", data);
            },
            function rejected(data) {
              //MyService.ConsoleLog("rejected: ", data);
            }
          );
          $('html, body').animate({
              scrollTop: 0,
            },
            'slow'
          );
          return;
        }
        var qid;
        MyService.ConsoleLog('$scope', $scope.UserId);
        if ($scope.UserId && $scope.UserId) {
          qid = $scope.questions[$scope.currentIndex]._id;
        } else {
          qid = $scope.questions[$scope.currentIndex].queId;
        }
        var showMatch;
        if ($scope.isShare && $scope.isShare == true) {
          showMatch = 'Y';
        } else {
          // alert('else');
          showMatch = 'N';
        }
        var postData = {
          questionId: qid,
          importance: $scope.importance,
          answer: $scope.answer,
          comment: $scope.updata.comment,
          show: showMatch
        };

        if (answerId != '') {
          postData.id = answerId;
          MyService.ConsoleLog('answerId :', answerId);
          postData.reason = answerReason;
        }
        $('html, body').animate({
            scrollTop: $('#DisplayQ1').offset().top - 80,
          },
          'slow'
        );
        // console.log("postData > ", postData);
        $scope.postAnswer(postData, 'submit');
      };

      $rootScope.$on('question.answered', function (evt, data) {
        MyService.ConsoleLog('on question.answered: ', data);
        if ($scope.questions[$scope.currentIndex]._id == data.questionId) {
          $scope.initializeVariables();
          $scope.skipQuestion();
        }
      });

      /**
       * get Org Information
       */

      $scope.getOrgInfo = function () {
        MyService.getPress($scope.orgId).then(
          function (response) {
            MyService.ConsoleLog('Response', response);
            $scope.orgInfo = response.orgdata;
            $scope.orgUser = response.userData;
            $scope.getFollowersList();
          },
          function (err) {
            MyService.ConsoleLog('Error', err);
          }
        );
      };

      /**
       * get  followers count and get quizzes count
       */
      $scope.getFollowersList = function () {
        MyService.getFollowersList({
          orgId: $scope.orgId
        }).then(
          function (response) {
            MyService.ConsoleLog('response', response.data);
            $scope.followersCnt = response.data.followersCount;
            $rootScope.followersData = response.data.followersData;
            window.localStorage.setItem('followData', JSON.stringify(response.data.followersData));
            $scope.questionsCnt = response.data.quizzesCount;
            $rootScope.quizzesData = response.data.quizzesData;
            $scope.quizQuesHasAns = response.data.quesHasAnsCount;
          },
          function (err) {
            MyService.ConsoleLog('error', err);
          }
        );
      };

      // Quick link for show match

      $scope.skipToMatch = function () {
        if ($scope.UserId && $scope.UserId != '') {
          // alert("if");
          MyService.ConsoleLog('welcome to quick link :', $rootScope.fiveMatch);
          $location.path('/fiveCompare/skip_to_result');
          // window.localStorage.setItem("fiveMatch", JSON.stringify($rootScope.fiveMatch));
          // $scope.saveFiveMinAnswers("RedirectNew");
        } else {
          // alert("else");
          $scope.showZipCode = true;
        }
        // $rootScope.fiveMatch.length=0;
      };

      $scope.getFollowersQuiz = function () {
        // MyService.ConsoleLog("  $rootScope.fiveMatch :>", $rootScope.fiveMatch);
        $scope.showloader = true;
        var sobj = {};

        if ($scope.orgId && $scope.orgId != '') {
          MyService.ConsoleLog('<<<<< If >>');
          sobj.quizName = $scope.qName;
          sobj.orgId = $scope.orgId;
        } else {
          MyService.ConsoleLog('<<<<<<<<< Else >>>>>>>>>');
          sobj.queIds = JSON.parse(window.localStorage.getItem('queIds'));
        }
        MyService.getOrgQuizQuestions(sobj).then(
          function (payload) {
            MyService.ConsoleLog('getMatchQUestions', payload);
            if (payload.data.success && payload.data.success != '') {
              $scope.questions = payload.data.data;
              $scope.queLen = $scope.questions.length;

              MyService.ConsoleLog('This is length ::', $scope.queLen);

              $scope.flagSkipAnsweredQuestion = true;
              $scope.showloader = false;
              if ($scope.orgId && $scope.orgId != '') {
                $scope.getOrgInfo();
              }
              if ($scope.questions[$scope.currentIndex] && $scope.questions[$scope.currentIndex].categories.length > 0) {
                var paObj = {};

                paObj.id = $scope.questions[$scope.currentIndex].categories[0].cid;
                $scope.getCategory(paObj);
              }
              $scope.skipAnswerChagne();
            } else {
              alert('Something went wrong. Please try after some time');
              $location.path('/welcome');
            }
          },
          function (errpayload) {
            alert('Something went wrong. Please try after some time');
            $location.path('/welcome');
          }
        );
      };

      $scope.skipQuestion = function () {
        MyService.ConsoleLog('* skipQuestion *');
        var skip = function () {
          // MyService.ConsoleLog("skip");
          var paObj = {};
          paObj.id = $scope.questions[$scope.currentIndex].categories[0].cid;
          $scope.getCategory(paObj);
          var data = $scope.checkQuestion($scope.questions[$scope.currentIndex]._id);
          if (data && data[0]) {
            MyService.ConsoleLog('getMatchQUestions >>> ', data[0]);
            if (data[0].answer != '') {
              $scope.answer = data[0].answer;
            }
            if (data[0].importance != '') {
              $scope.importance = data[0].importance;
            }
            if (data[0].comment != '') {
              $scope.updata.comment = data[0].comment;
            }
          }
          // $scope.dis=false;
          // console.log("answer : ", $scope.answer);
          if ($scope.answer && $scope.answer != '') {
            var postData = {
              questionId: $scope.questions[$scope.currentIndex]._id,
              importance: $scope.importance,
              answer: $scope.answer,
              comment: $scope.updata.comment,
            };
            // console.log("postData >> ", postData);
            $scope.postAnswer(postData, 'skip');
          }

          // console.log($("#DisplayQ1").offset());
          $('html, body').animate({
              scrollTop: $('#DisplayQ1').offset().top - 80,
            },
            'slow'
          );

          var tempIndex = $scope.currentIndex + 1;
          if (tempIndex < $scope.questions.length) {
            $scope.initializeVariables();
            $scope.currentIndex++;
          } else {
            MyService.ConsoleLog('final question : ' + $scope.questions.length);
            $scope.fiveMinuteMatchDone();
          }
          /*
          $timeout(function() {
            $location.hash('DisplayQ');
            $anchorScroll();
          }, 100);
          */
        };

        MyService.ConsoleLog('skip answer<><><><<>', $scope.answer);
        if ($scope.answer != null) {
          var show_answer_modal = true;
          try {
            var my_answer = $scope.questions[$scope.currentIndex]['my_answer'];

            /*for (var key in my_answer) {
              if(my_answer[])
            }*/
            if (
              my_answer.importance == $scope.importance &&
              my_answer.answer == $scope.answer &&
              my_answer.comment == $scope.updata.comment
            )
              show_answer_modal = false;
          } catch (e) {
            //MyService.ConsoleLog("Exceptoin : ", e);
          }
          // MyService.ConsoleLog("show_answer_modal: ", show_answer_modal);
          if (show_answer_modal) {
            var message =
              'You just hit the SKIP button.  Are you sure you want to skip this one, or would you rather Submit your answer?';
            var modal = ngDialog.openConfirm({
              template: '<p>' +
                message +
                '</p>\
                <div class="ngdialog-buttons">\
                    <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Skip</button>\
                    <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Submit</button>\
                </div>',
              plain: true,
              closeByDocument: false,
            });

            modal.then(
              function fullfilled(data) {
                //submit answer
                $scope.submitAnswer();
              },
              function rejected(data) {
                //skip the answer
                skip();
              }
            );
          } else {
            skip();
          }
        } else {
          skip();
        }
      };

      //  prevQuestions
      $scope.prevQuestion = function () {
        MyService.ConsoleLog('** prevQuestion **');

        if ($scope.currentIndex > 0) {
          // alert($scope.currentIndex);
          $('html, body').animate({
              scrollTop: $('#DisplayQ1').offset().top - 80,
            },
            'slow'
          );
          $scope.currentIndex--;
          // console.log("Current <><>,", $scope.currentIndex);
          $scope.updata.comment = '';
          // console.log("C digDeeper : ",$scope.digDeeperMatch);
          if ($scope.digDeeperMatch != true) {
            // console.log("digDeeper");
            // console.log(window.localStorage.getItem("fiveMatch"));
            if (window.localStorage.getItem('fiveMatch')) {
              MyService.ConsoleLog('here', JSON.parse(window.localStorage.getItem('fiveMatch')));
              MyService.ConsoleLog(' $scope.cachedQuestions', $scope.cachedQuestions);
              $scope.getFiveMinData = [];
              $scope.getFiveMinData.length = 0;
              if ($scope.flagSkipAnsweredQuestion) {
                console.log('IF <> ', $scope.flagSkipAnsweredQuestion);
                // if ($scope.cachedQuestions && $scope.cachedQuestions.length > 0) {
                $scope.getFiveMinData = $scope.cachedQuestions;
                // } else {
                //   $scope.getFiveMinData = JSON.parse(window.localStorage.getItem('fiveMatch'));
                // }
              } else {
                console.log('Else ');
                $scope.getFiveMinData = JSON.parse(window.localStorage.getItem('fiveMatch'));
              }

              // MyService.ConsoleLog('Data : ', $scope.getFiveMinData);
              for (var i = 0; i < $scope.getFiveMinData.length; i++) {
                MyService.ConsoleLog('for i : ' + i + ' currentIndex : ' + $scope.currentIndex);

                if (i == $scope.currentIndex) {
                  MyService.ConsoleLog('index matched', $scope.getFiveMinData[i]);
                  MyService.ConsoleLog('index matched', $scope.getFiveMinData[i].importance);

                  $scope.answer = $scope.getFiveMinData[i].answer;
                  $scope.importance = $scope.getFiveMinData[i].importance;

                  $scope.updata.comment = $scope.getFiveMinData[i].comment;
                  // $timeout(function() {
                  //   $scope.$apply();
                  // });
                }
              }
              MyService.ConsoleLog(' $scope.importance', $scope.importance);
            }
          }
        } else if ($scope.currentIndex == 0) {
          if ($scope.currBackgroundIndex > 0) {
            $scope.currBackgroundIndex--;
            $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
          }
        }
      };

      // Zip code
      $scope.oldaddress = {
        state: '',
        county: '',
        countySubdivision: '',
        place: '',
      };

      $scope.address = {
        state: '',
        county: '',
        countySubdivision: '',
        place: '',
      };
      $scope.showZipLoader = false;
      $scope.showAddressDropDown = false;

      $scope.AllAnsweredQuestions = [];
      $scope.getAllAnsweredQuestions = function (userId) {
        MyService.getAllAnsweredQuestions({
          authorId: userId,
          quizName: $scope.qName
        }).then(
          function (payload) {
            // MyService.ConsoleLog("getAllAnsweredQuestions >> ", payload)
            if (payload.data.success) {
              $scope.AllAnsweredQuestions = payload.data.data;
              $scope.getFollowersQuiz();
            }
          },
          function (errpayload) {
            MyService.ConsoleLog('getAllAnsweredQuestions errpayload >> ', errpayload);
          }
        );
      };

      $scope.getAllStates = function () {
        if ($scope.counties) {
          $scope.counties.length = 0;
        }
        if ($scope.places) {
          $scope.places.length = 0;
        }

        var request = apiCall.apiCall('GET', '/user/getAllStates', {
          country: '',
        });
        $http(request).then(
          function successCallback(response) {
            MyService.ConsoleLog('Got States: ', response);
            if (response.data.success) {
              $scope.states = response.data.data;
            } else {
              growl.error('Something went wrong.');
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
            growl.error('Something went wrong.');
          }
        );
      };

      // if ($cookies.get('isAlreadyAnswer') == 'true') {
      //   // alert('dd');
      $scope.getAllAnsweredQuestions($scope.UserId);
      // } else {
      $scope.getAllStates();
      // $scope.getFollowersQuiz();
      // }

      $scope.checkState = function (rdata, val) {
        // MyService.ConsoleLog(rdata);
        return rdata.filter(function (rdata) {
          //MyService.ConsoleLog(rdata.statePostalCode + "==" + val);
          if (rdata.statePostalCode == val) return rdata;
        });
      };

      $scope.checkState = function (rdata, val) {
        // MyService.ConsoleLog("State :", rdata);
        // MyService.ConsoleLog("State val :", val);
        var sdata = [];
        var len = rdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = rdata[i];
          var gdata = val.filter(function (obj) {
            if (rsdata.countyFips == obj.COUNTYFP && rsdata.stateFips == obj.STATEFP) {
              // MyService.ConsoleLog(rdata[i]);
              return rdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(rdata[i]) == -1) {
              sdata.push(rdata[i]);
            }
          }

          if (j == len) {
            // MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };

      $scope.checkCounty = function (rdata, val) {
        MyService.ConsoleLog('County :', rdata);
        MyService.ConsoleLog('County val :', val);
        var sdata = [];
        var len = rdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = rdata[i];
          var gdata = val.filter(function (obj) {
            if (rsdata.countyFips == obj.COUNTYFP && rsdata.stateFips == obj.STATEFP) {
              // MyService.ConsoleLog(rdata[i]);
              return rdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(rdata[i]) == -1) {
              sdata.push(rdata[i]);
            }
          }

          if (j == len) {
            // MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };
      $scope.checksubCounty = function (rdata, val) {
        var sdata = [];
        var len = rdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = rdata[i];
          var gdata = val.filter(function (obj) {
            if (rsdata.countySubdivision == obj.NAME) {
              // MyService.ConsoleLog(rdata[i]);
              return rdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(rdata[i]) == -1) {
              sdata.push(rdata[i]);
            }
          }

          if (j == len) {
            // MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };
      $scope.checkPlaces = function (prdata, val) {
        var sdata = [];
        var len = prdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = prdata[i];
          var gdata = val.filter(function (obj) {
            // MyService.ConsoleLog(rsdata.place +"=="+ obj.NAME);
            if (rsdata.place == obj.NAME && !rsdata.countyFips) {
              // MyService.ConsoleLog(rdata[i]);
              return prdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(prdata[i]) == -1) {
              sdata.push(prdata[i]);
            }
          }

          if (j == len) {
            // MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };
      var getCountiesCanceler = $q.defer();

      $scope.allcounties = [];
      $scope.getCounties = function (lbl) {
        // MyService.ConsoleLog("county >", $scope.Location.state);
        // $scope.allcounties.length = 0;
        var statePostalCode = '';
        var state = '';
        if (lbl == 'new') {
          state = JSON.stringify($scope.oldaddress.state);
        } else {
          statePostalCode = $scope.Location.state.statePostalCode;
          state = $scope.Location.state;
        }
        if (!statePostalCode) {
          statePostalCode = $scope.stateFips;
          MyService.ConsoleLog('StatePostal Code in IF', statePostalCode);
        }
        // MyService.ConsoleLog(statePostalCode + "<><><><>>" + state);
        MyService.getAllCounties(statePostalCode, state).then(
          function (payload) {
            // MyService.ConsoleLog("sublocations Locals : ", payload);
            var allcounties = payload;
            if (lbl == 'new') {
              var county = $scope.checkCounty(allcounties, $scope.oldaddress.county);
              $scope.allcounties = county;
              // MyService.ConsoleLog("county<><", county);
              $scope.address.county = county[0];
            }
          },
          function (errorPayload) {
            growl.error('Something went wrong.');
          }
        );
      };
      $scope.MyPlaces = [];
      $scope.getSubCounties = function (lbl) {
        //MyService.ConsoleLog($scope.Location.state);
        //MyService.ConsoleLog($scope.Location.county);
        // var county = $scope.Location.county;

        $scope.MyPlaces.length = 0;
        var county = '';
        var statePostalCode = '';
        $scope.MyPlaces.length = 0;
        var state = '';
        var county = '';
        if (lbl == 'new') {
          state = JSON.stringify($scope.oldaddress.state);
          county = JSON.stringify($scope.oldaddress.county);
        } else {
          statePostalCode = $scope.Location.state.statePostalCode;
          state = $scope.Location.state;
          county = county.county;
        }
        // MyService.ConsoleLog(statePostalCode + "===" + county);
        MyService.getAllSubCountiesLocal(statePostalCode, state, county).then(
          function (payload) {
            // payload = JSON.parse(payload);
            $scope.MyPlaces = payload;
            // MyService.ConsoleLog("PlaCE :", payload);
            // MyService.ConsoleLog(payload.countySubdivision);
            var subcounties = payload.countySubdivision;
            var places = payload.places;
            // MyService.ConsoleLog("PlaCE :", payload);
            if (lbl == 'new') {
              // MyService.ConsoleLog("Places 1 > ",$scope.oldaddress.place);
              var subcounty = $scope.checksubCounty(
                subcounties,
                $scope.oldaddress.countySubdivision
              );
              var places = $scope.checkPlaces(places, $scope.oldaddress.place);
              // MyService.ConsoleLog("subcounty<><><", subcounty);
              // $scope.subcounties = subcounty;
              $scope.places = places;
              // console.log('***********', $scope.places);
              // $scope.Location.countySubdivision = subcounty[0];
              $scope.address.place = places[0];
            }
          },
          function (errorPayload) {
            growl.error('Something went wrong.');
          }
        );
      };

      var getLocalsCanceler = $q.defer();
      $scope.getLocals = function (lbl) {
        // MyService.ConsoleLog($scope.oldaddress);
        var state = {},
          county = {};

        if (lbl == 'cur') {
          state = $scope.User.cur_state;
          county = JSON.parse($scope.User.cur_county);
        } else if (lbl == 'new') {
          state.statePostalCode = $scope.oldaddress.state;
          county.county = $scope.oldaddress.county;
        } else {
          state = JSON.parse($scope.User.sel_state);
          county = JSON.parse($scope.User.sel_county);
        }

        //MyService.ConsoleLog("county : ", county);
        getLocalsCanceler.resolve();

        var request = apiCall.apiCall('GET', '/user/getAllSubCountiesLocal', {
          statePostalCode: state.statePostalCode,
          county: county.county,
          timeout: getLocalsCanceler.promise,
        });
        $http(request).then(
          function successCallback(response) {
            if (response.data.success) {
              if (response.data.data) {
                // MyService.ConsoleLog(response.data.data);
                $scope.places = response.data.data;

                if (lbl == 'new') {
                  var subcounty = $scope.checksubCounty(
                    $scope.places,
                    $scope.oldaddress.countySubdivision
                  );

                  var places = $scope.checkPlaces($scope.places, $scope.oldaddress.place);
                  // MyService.ConsoleLog("subcounty<><><", subcounty[0])
                  $scope.address.countySubdivision = subcounty[0];
                  $scope.address.place = places[0];
                }
              }
            } else {
              growl('Something went wrong.');
            }
          },
          function errorCallBack(response) {
            growl('Something went wrong.');
          }
        );
      };
      $scope.User = {
        ZipCode: '',
      };
      $scope.detectCode = function (event) {
        if (event.keyCode == 9 && event.key == 'Tab') {
          $scope.showAddressDropDowns($scope.User.ZipCode);
        }
        if (event.keyCode == 13 && event.key == 'Enter') {
          $scope.showAddressDropDowns($scope.User.ZipCode);
        }
      };

      $scope.checkLength = function (vdata, val) {
        MyService.ConsoleLog(' vdata :', vdata);
        // MyService.ConsoleLog(" val :",val);

        var data = vdata.map(function (sub) {
          var returnval = '';
          switch (val) {
            case 'federalCongrassionalDist':
              returnval = sub.CD115FP;
              break;
            case 'stateSenateDistrict':
              returnval = sub.SLDUST;
              break;
            case 'stateHouseOFRepresentativeDistrict':
              returnval = sub.NAMELSAD;
              break;
            case 'unifiedSchoolDistrictName':
              returnval = sub.NAME;
              break;
            case 'default':
              returnval = sub.NAME;
              break;
          }
          return returnval;
        });

        var ndata = $filter('unique')(data);
        if (ndata.length > 1) {
          return 'yellowBackground';
        } else {
          return '';
        }
      };

      // for autocomplete address

      var options = {
        componentRestrictions: {
          country: 'us',
        },
        types: ['geocode'],
      };

      $scope.detectAddress = function (ent) {
        var val = document.getElementById('address');
        // console.log($scope.User.Address);
        var autocomplete = new google.maps.places.Autocomplete(val, options);

        google.maps.event.addListener(autocomplete, 'place_changed', function () {
          var place = autocomplete.getPlace();

          var lat = place.geometry.location.lat(),
            lng = place.geometry.location.lng();

          $scope.lati = lat.toFixed(6);
          $scope.lon = lng.toFixed(6);
          // console.log($scope.lati);
          // console.log($scope.lon);

          $scope.mailing_Address = place.formatted_address;
          // MyService.ConsoleLog("Main addd :", place.address_components);
          for (var i = 0; i < place.address_components.length; i++) {
            for (var j = 0; j < place.address_components[i].types.length; j++) {
              if (place.address_components[i].types[j] == 'administrative_area_level_1') {
                $scope.statePostalCode = place.address_components[i].short_name;
                // console.log($scope.statePostalCode);
              }
              if (place.address_components[i].types[j] == 'country') {
                $scope.countryname = place.address_components[i].long_name;
                // console.log($scope.countryname);
              }
              if (place.address_components[i].types[j] == 'administrative_area_level_2') {
                $scope.county_name = place.address_components[i].long_name;
                // console.log($scope.county_name);
              }
              if (place.address_components[i].types[j] == 'locality') {
                $scope.place_name = place.address_components[i].long_name;
                // console.log($scope.place_name);
              }
              if (place.address_components[i].types[j] == 'postal_code') {
                // document.getElementById('zip').value = place.address_components[i].long_name;
                if (
                  place.address_components[i].long_name &&
                  place.address_components[i].long_name != ''
                ) {
                  $scope.User.ZipCode = place.address_components[i].long_name;
                  // console.log($scope.User.ZipCode);
                }
                // console.log($scope.User.ZipCode);
              }
            }
          }

          console.log('$scope.User.ZipCode :', $scope.User.ZipCode);

          var loc = JSON.stringify({
            longitude: $scope.lon,
            latitude: $scope.lati,
          });
          // console.log(loc);
          // $rootScope.location = new Array;
          $rootScope.location = {
            longitude: $scope.lon,
            latitude: $scope.lati,
          };
          $scope.showAddressDropDowns('', loc);
        });
      };

      // End for autocomplete address

      $scope.mainAddress = '';

      $scope.showAddressDropDowns = function (zipcode, loc) {
        if (loc && loc != '') {
          MyService.ConsoleLog('showAddressDropDowns' + zipcode);
          MyService.ConsoleLog('MyLocation : >>>.' + loc);

          $scope.showZipLoader = true;
          MyService.getOrganizedZipData({
            candidate: true,
            loc: loc,
          }).then(
            function (payload) {
              MyService.ConsoleLog(' showAddressDropDowns ', payload);
              if (payload && payload != '') {
                // var finalData = payload.data;
                // MyService.ConsoleLog(payload[0].countySubdivision);
                // MyService.ConsoleLog(payload[0].county);
                // MyService.ConsoleLog(payload[0].place);
                var countySubdivisions = payload.places.filter(function (obj) {
                  if (obj.COUSUBFP && obj.COUSUBFP != '') {
                    // MyService.ConsoleLog("Inside cs");
                    return obj;
                  }
                });
                var places = payload.places.filter(function (obj) {
                  if (obj.PLACEFP && obj.PLACEFP != '') {
                    // MyService.ConsoleLog("obj > ", obj);
                    return obj;
                  }
                });
                MyService.ConsoleLog(' showAddressDropDowns <><><><><><><><><><><><><> ');

                $scope.mainAddress = payload;
                $scope.showZipLoader = false;
                $scope.showAddressDropDown = true;
                $scope.oldaddress.state = payload.state;
                $scope.oldaddress.county = payload.county;
                $scope.stateFips = payload.state[0].STATEFP;
                MyService.ConsoleLog('ALLLLLLLLLLL', $scope.stateFips);
                // MyService.ConsoleLog("countySubdivisions >> ", countySubdivisions);
                $scope.oldaddress.countySubdivision = countySubdivisions;
                // MyService.ConsoleLog("places >>> ",places);
                $scope.countyName = payload.county;
                $scope.placeName = payload.places;
                MyService.ConsoleLog('$scope.placename', $scope.placeName);
                MyService.ConsoleLog('$scope.countyName', $scope.countyName);
                $scope.oldaddress.place = places;
                $scope.getCounties('new');

                $scope.getSubCounties('new');

                // $scope.voterDistricts = payload;
                // MyService.ConsoleLog(payload.congressionalDistrict);
                $scope.federalCongrassionalDist = payload.congressionalDistrict;
                MyService.ConsoleLog('@@@@@@ drop :', $scope.federalCongrassionalDist);

                $scope.stateSenateDistrict = payload.stateSenateDistrict;
                $scope.stateHouseOFRepresentativeDistricts =
                  payload.stateHouseofRepresentativesDistrict;
                $scope.unifiedSchoolDistrictNames = payload.unifiedSchoolDistrict;
                //$scope.$apply();
                // MyService.ConsoleLog($scope.states);
                // MyService.ConsoleLog(payload[0].statePostalCode);
                var address = $scope.checkState($scope.states, payload.state);
                MyService.ConsoleLog('address : ', address[0]);

                $scope.address.state = address[0];
                // $scope.address.voterDistrict = $scope.voterDistricts[0];
                $scope.address.federalCongrassionalDist = $scope.federalCongrassionalDist[0];
                $scope.address.stateSenateDistrict = $scope.stateSenateDistrict[0];
                $scope.address.stateHouseOFRepresentativeDistrict =
                  $scope.stateHouseOFRepresentativeDistricts[0];
                $scope.address.unifiedSchoolDistrictName = $scope.unifiedSchoolDistrictNames[0];
                // MyService.ConsoleLog("address ; ", address);
                MyService.ConsoleLog(
                  '<><><><><<><><>>>>>>. zip code >>>>>>>>>>>>>>>>>',
                  $scope.User.ZipCode
                );
                $timeout(function () {
                  $rootScope.tempUserZip = $scope.User.ZipCode;
                  $rootScope.tempUserAddress = $scope.address;
                  MyService.ConsoleLog(
                    ' temp : >>>>>>>>>>>>>>>>>>>>>>>>>>>',
                    $rootScope.tempUserAddress
                  );
                  window.localStorage.setItem('tempUserZip', $rootScope.tempUserZip);
                  window.localStorage.setItem(
                    'tempUserAddress',
                    JSON.stringify($rootScope.tempUserAddress)
                  );
                  // MyService.ConsoleLog("address : ", address);
                  // MyService.ConsoleLog("rootscope address : ", $rootScope.tempUserAddress);
                }, 100);
              }
            },
            function (errorPayload) {
              $scope.showZipLoader = false;
              growl.error(errorPayload);
            }
          );
        }
      };

      $scope.saveUserAnswers = function () {
        console.log('address>>>', $scope.address);
        $rootScope.tempUserAddress = $scope.address;
        MyService.ConsoleLog(' temp : >>>>>>>>>>>>>>>>>>>>>>>>>>>', $rootScope.tempUserAddress);
        window.localStorage.setItem('tempUserZip', $rootScope.tempUserZip);
        window.localStorage.setItem('tempUserAddress', JSON.stringify($rootScope.tempUserAddress));
        $location.path('/fiveSaveUser');
      };

      $scope.eraseUserAnswers = function () {
        MyService.ConsoleLog('eraseUserAnswers');
        MyService.ConsoleLog(window.localStorage.getItem('fiveMatch'));
        $location.path('/fiveCompare');
      };

      $scope.showDigDeeperLoader = false;

      $scope.goBack = function () {
        $scope.initializeVariables();
        $scope.questions = angular.copy($scope.oldQuestions);
        $scope.currentIndex = angular.copy($scope.oldIndex);
        $scope.oldQuestions.length = 0;
        $scope.oldIndex = 0;
      };

      var getCategoryCanceler = $q.defer();


      /**
       * Get category
       */

      var prevFetchedCategoryId = null;
      $scope.categoryCalled = false;
      $scope.status = {
        questions: 0, //1= loading, 2 = loaded, 3 = error
        category: 0
      };
      $scope.getCategory = function (params) {
        MyService.ConsoleLog("scrollTop pre :", prevFetchedCategoryId);
        MyService.ConsoleLog("scrollTop Two :", params.id);
        if (prevFetchedCategoryId != params.id) {
          MyService.ConsoleLog("scrollTop");
          $scope.categoryCalled = true;
          $("html, body").animate({
            scrollTop: 0
          }, "slow");
          getCategoryCanceler.resolve();
          $scope.status.category = 1;
          params.timeout = getCategoryCanceler.promise;
          var request = apiCall.apiCall('GET', '/categories/list', params);
          $http(
              request
            )
            .then(function successCallback(response) {
              //MyService.ConsoleLog("Got categories: ",response);
              if (response.data.success) {
                $scope.category = response.data.data;
                //MyService.ConsoleLog("category data: ", $scope.category);
                prevFetchedCategoryId = $scope.category._id;
                $scope.status.category = 2;
              } else {
                //MyService.ConsoleLog("Something went wrong: ", response.data);
                $scope.status.category = 3;
              }
            }, function errorCallBack(response) {
              //MyService.ConsoleLog("Error: ", response);
              $scope.status.category = 3;
            });
        } else {

          $("html, body").animate({
            scrollTop: $("#DisplayQ1").offset().top - 80
          }, "slow");
          // $timeout(function() {
          //   MyService.ConsoleLog("called")
          //   $location.hash('DisplayQue');
          //   $anchorScroll();

          // }, 100);

        }
      };

      // $scope.oldAddress = "";
      $scope.checkZipAddress = function (val) {
        // $scope.oldAddress = angular.copy($scope.mainAddress);
        return $scope.mainAddress.filter(function (rdata) {
          // MyService.ConsoleLog("Space:", parseInt(val.CongressionalDistrict));
          if (val.CongressionalDistrict == '' || val.CongressionalDistrict == ' ') {
            // MyService.ConsoleLog("inside<><><><><>");

            if (
              parseInt(rdata.FIPScounty) == parseInt(val.CountyFIPS) &&
              parseInt(rdata.FIPScountySub) == parseInt(val.CountySubdivisionCode) &&
              parseInt(rdata.stateHouseOFRepresentativeDistrict) ==
              parseInt(val.StateDistrictLower) &&
              parseInt(rdata.stateSenateDistrict) == parseInt(val.StateDistrictUpper) &&
              parseInt(rdata.unifiedSchoolDistrict) == parseInt(val.UnifiedSchoolDistrictCode)
            ) {
              // MyService.ConsoleLog("This is a match");
              return rdata;
            }
          } else {
            if (
              parseInt(rdata.FIPScounty) == parseInt(val.CountyFIPS) &&
              parseInt(rdata.FIPScountySub) == parseInt(val.CountySubdivisionCode) &&
              parseInt(rdata.federalCongrassionalDist) == parseInt(val.CongressionalDistrict) &&
              parseInt(rdata.stateHouseOFRepresentativeDistrict) ==
              parseInt(val.StateDistrictLower) &&
              parseInt(rdata.stateSenateDistrict) == parseInt(val.StateDistrictUpper) &&
              parseInt(rdata.unifiedSchoolDistrict) == parseInt(val.UnifiedSchoolDistrictCode)
            ) {
              // MyService.ConsoleLog("This is a match2");
              return rdata;
            }
          }
        });
      };

      $scope.setAddressNew = function () {
        // MyService.ConsoleLog($scope.result);
        var finalResult = $scope.checkZipAddress($scope.result);
        if (finalResult && finalResult.length > 0) {
          MyService.ConsoleLog('finalResult::::', finalResult);
          // $scope.mainAddress = angular.copy(finalResult);
          $scope.voterDistricts = finalResult;
          $scope.federalCongrassionalDist = finalResult;
          $scope.stateSenateDistrict = finalResult;
          $scope.stateHouseOFRepresentativeDistricts = finalResult;
          $scope.unifiedSchoolDistrictNames = finalResult;
          ngDialog.closeAll();
          // $scope.$apply();
        } else {
          alert(
            'Address not matching with our database. Please enter detail address and try again.'
          );
        }
      };

      var previousSelVal = {};
      $scope.setSelectedDropdown = function (listData, setfor, selectedUserAdrs) {
        switch (setfor) {
          case 'counties':
            previousSelVal.county = $scope.address.county;
            //MyService.ConsoleLog("selCountyNumber: ",previousSelVal.county);
            $scope.address.county = null;
            if (listData) {
              $scope.counties = listData;
              $scope.counties.unshift({
                number: null,
                name: 'none',
              });

              // if(!selectedUserAdrs) selectedUserAdrs.countyFips = previousSelVal.county.number;
              var selCountyNumber = null;
              try {
                $scope.address.county = $scope.counties[0];
                if (selectedUserAdrs) {
                  selCountyNumber = selectedUserAdrs.countyFips;
                }
                if (previousSelVal.county) {
                  selCountyNumber = previousSelVal.county.number;
                }

                if (selCountyNumber) {
                  //MyService.ConsoleLog("selCountyNumber: ",selCountyNumber);
                  angular.forEach($scope.counties, function (val, key) {
                    if (selCountyNumber == val.number) $scope.address.county = val;
                  });
                }
              } catch (e) {
                //MyService.ConsoleLog("Exception: ",e);
              }
            }
            break;
          case 'subCounties':
            previousSelVal.subcounty = $scope.address.subcounty;
            $scope.address.subcounty = null;
            if (listData) {
              $scope.subCounties = listData;
              $scope.subCounties.unshift({
                number: null,
                name: 'none',
              });
              var selSubCountyNo = null;
              try {
                $scope.address.subcounty = $scope.subCounties[0];
                if (selectedUserAdrs) {
                  selSubCountyNo = selectedUserAdrs.countySubdivisionFips;
                }
                if (previousSelVal.subcounty) {
                  selSubCountyNo = previousSelVal.subcounty.number;
                }
                if (selSubCountyNo) {
                  angular.forEach($scope.subCounties, function (val, key) {
                    //set selected state
                    // if(selectedUserAdrs.countySubdivisionFips == val.number)
                    if (selSubCountyNo == val.number) $scope.address.subcounty = val;
                  });
                }
              } catch (e) {
                //MyService.ConsoleLog("Exception: ",e);
              }
            }
            break;
          case 'places':
            previousSelVal.place = $scope.address.place;
            $scope.address.place = null;
            if (listData) {
              $scope.places = listData;
              $scope.places.unshift({
                number: null,
                name: 'none',
              });

              try {
                $scope.address.place = $scope.places[0];
                var selPlaceNo = null;
                if (selectedUserAdrs) {
                  selPlaceNo = selectedUserAdrs.placeFips;
                }
                if (previousSelVal.place) {
                  selPlaceNo = previousSelVal.place.number;
                }
                if (selPlaceNo) {
                  angular.forEach($scope.places, function (val, key) {
                    if (selPlaceNo == val.number) $scope.address.place = val;
                  });
                }
              } catch (e) {
                //MyService.ConsoleLog("Exception: ",e);
              }
            }
            break;
          case 'voterDistricts':
            if (listData) {
              previousSelVal.voterDistrict = $scope.address.voterDistrict;
              $scope.address.voterDistrict = null;
              $scope.voterDistricts = listData;
              $scope.voterDistricts.unshift({
                number: null,
                name: 'none',
              });

              var voterDistrictNo = null;
              try {
                $scope.address.voterDistrict = $scope.voterDistricts[0];
                if (selectedUserAdrs) {
                  voterDistrictNo = selectedUserAdrs.voterDistrictFips;
                }
                if (previousSelVal.voterDistrict) {
                  voterDistrictNo = previousSelVal.voterDistrict.number;
                }

                if (voterDistrictNo) {
                  angular.forEach($scope.voterDistricts, function (val, key) {
                    //set selected
                    if (voterDistrictNo == val.number) $scope.address.voterDistrict = val;
                  });
                }
              } catch (e) {
                //MyService.ConsoleLog("Exception: ",e);
              }
            }
            break;
          case 'federalCongrassionalDist':
            $scope.address.federalCongrassionalDist = null;
            if (listData) {
              $scope.federalCongrassionalDist = listData;
              $scope.federalCongrassionalDist.unshift('none');

              if (selectedUserAdrs) {
                $scope.address.federalCongrassionalDist = $scope.federalCongrassionalDist[0];
                angular.forEach($scope.federalCongrassionalDist, function (val, key) {
                  //set selected state
                  if (selectedUserAdrs.federalCongrassionalDist == val)
                    $scope.address.federalCongrassionalDist = val;
                });
              }
            }
            break;
          case 'stateSenateDistrict':
            $scope.address.stateSenateDistrict = null;
            if (listData) {
              $scope.stateSenateDistrict = listData;
              $scope.stateSenateDistrict.unshift('none');

              $scope.address.stateSenateDistrict = $scope.stateSenateDistrict[0];
              if (selectedUserAdrs) {
                angular.forEach($scope.stateSenateDistrict, function (val, key) {
                  //set selected state
                  if (selectedUserAdrs.stateSenateDistrict == val)
                    $scope.address.stateSenateDistrict = val;
                });
              }
            }
            break;
          case 'stateHouseOFRepresentativeDistrict':
            $scope.address.stateLegislativeDistrict = null;
            if (listData) {
              $scope.stateLegislativeDistrict = listData;
              $scope.stateLegislativeDistrict.unshift('none');
              $scope.address.stateLegislativeDistrict = $scope.stateLegislativeDistrict[0];
              if (selectedUserAdrs) {
                angular.forEach($scope.stateLegislativeDistrict, function (val, key) {
                  //set selected state
                  if (selectedUserAdrs.legislativeDistrict == val)
                    $scope.address.stateLegislativeDistrict = val;
                });
              }
            }
            break;
          case 'schoolDistricts':
            $scope.address.schoolDistrict = null;
            if (listData) {
              $scope.schoolDistricts = listData;
              $scope.schoolDistricts.unshift({
                number: null,
                name: 'none',
              });
              $scope.address.schoolDistricts = $scope.schoolDistricts[0];
              if (selectedUserAdrs) {
                angular.forEach($scope.schoolDistricts, function (val, key) {
                  //set selected state
                  if (selectedUserAdrs.schoolDistrictFips == val.number)
                    $scope.address.schoolDistrict = val;
                });
              }
            }
            break;
        }
      };

      $scope.confirmPopup = function () {
        MyService.ConsoleLog('address : ', $scope.address);
        var message =
          'Without your voice, your politician won’t know how to represent you. Before we show you your results, would you like to create a profile so we can save your answers and send them to your politicians anonymously?';
        var modal = ngDialog.openConfirm({
          template: '<p>' +
            message +
            '</p>\
                          <div class="ngdialog-buttons">\
                              <button type="button" class="compareBtn" ng-click="confirm(0)">Create and Save</button>\
                              <button type="button" class="eraseBtn" ng-click="confirm(1)">No. Erase when done</button>\
                          </div>',
          plain: true,
        });

        modal.then(
          function fullfilled(data) {
            MyService.ConsoleLog('fullfilled: ', data);
            if (data == 0) {
              $scope.saveUserAnswers();
            } else {
              $scope.eraseUserAnswers();
            }
          },
          function rejected(data) {
            MyService.ConsoleLog('rejected: ', data);
          }
        );

        return;
      };

      function keyupHandler(keyEvent) {
        MyService.ConsoleLog('key up');
        if (!$scope.showZipCode) {
          event.preventDefault();
          if (event.keyCode === 13) {
            //MyService.ConsoleLog('Current route name: ', $location.path());
            if ($location.path() == '/fiveMatch') {
              $scope.submitAnswer();
            }
          }
        }
      }
      document.addEventListener('keyup', keyupHandler);
      $scope.$on('$destroy', function () {
        MyService.ConsoleLog('event destroyed :');
        $document.unbind('keyup');
      });
    }
  ]);

'use strict';

angular.module('myApp.followersGroupAnswer', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/followersGroupAnswer/:data?/:quizName?/:isPopular?', {
      templateUrl: 'app/followersGroupAnswer/followersGroupAnswer.html',
      controller: 'followersGroupAnswerCtrl'
    });
  }]).controller('followersGroupAnswerCtrl', ['$scope', 'apiCall', 'MyService', '$location', '$anchorScroll', '$timeout', '$rootScope', 'ngDialog', '$q', '$http', '$filter', 'growl', '$routeParams', 'baseApiUrl', 'tokenService', '$cookies', function ($scope, apiCall, MyService, $location, $anchorScroll, $timeout, $rootScope, ngDialog, $q, $http, $filter, growl, $routeParams, baseApiUrl, tokenService, $cookies) {

    $scope.showPoliAnswerDetails = false;
    $scope.showUserAnswerDetails = false;
    $scope.showBack = $routeParams.data;
    $scope.quizName = $routeParams.quizName;
    $scope.isPopular = $routeParams.isPopular;


    if (window.localStorage.getItem('poliAr')) {
      var pdata = window.localStorage.getItem('poliAr');
      var opoli = JSON.parse(pdata);
      $scope.globalArray = opoli.poli;
      $scope.queId = opoli.qId;
      $scope.showPoliAnswerDetails = true;
    }

    /**
     * For Voter
     */
    if (window.localStorage.getItem('voter')) {
      // MyService.ConsoleLog("window.localStorage.getItem('comOfVoter')", window.localStorage.getItem('comOfVoter'));
      var data = window.localStorage.getItem('voter');
      var none = JSON.parse(data);
      $scope.globalArray = none.vot;
      $scope.queId = none.qId;
      $scope.showPoliAnswerDetails = true;

      // MyService.ConsoleLog(" $scope.unVeriComm", $scope.unVeriComm);
    }

    /**
     * For Advocates
     * */

    if (window.localStorage.getItem('adv')) {
      // MyService.ConsoleLog("window.localStorage.getItem('comOfVoter')", window.localStorage.getItem('comOfVoter'));
      var adata = window.localStorage.getItem('adv');
      var aone = JSON.parse(adata);
      $scope.globalArray = aone.adv;
      $scope.queId = aone.qId;
      $scope.showPoliAnswerDetails = true;
      if ($cookies.get('orgName')) {
        $scope.orgName = $cookies.get('orgName');
      }
    }

    /**
     * For Guest Users
     */
    if (window.localStorage.getItem('unVerify')) {
      // alert('called');
      // MyService.ConsoleLog("window.localStorage.getItem('comOfVoter')", window.localStorage.getItem('comOfVoter'));
      var gdata = window.localStorage.getItem('unVerify');
      var gone = JSON.parse(gdata);
      $scope.unVeriCommNew = gone.unVeri;
      $scope.queId = gone.qId;
      $scope.showUserAnswerDetails = true;
    }

    /**
     * This function filter comment data
     */
    $scope.getItems = function () {
      return function (u) {
        // MyService.ConsoleLog("params >", u);

        if (u.comment && u.comment != "") {
          return u;
        }
      };
    };

    $scope.getComment = function () {
      return function (x) {
        if (x.comment && x.comment != "") {
          return x;
        }
      };
    };

    $scope.getComapreClass = function (match, i) {
      //MyService.ConsoleLog("match: ", match);
      /*if(match == 100)
        return 'ag-green';
    if(match == 0)
        return 'ag-red';
    if(match > 0 && match <100)
        return 'ag-dg'+i;*/
      if (match >= 100) return 'ag-dg1';
      if (match >= 80) return 'ag-dg2';
      if (match >= 60) return 'ag-dg3';
      if (match >= 40) return 'ag-dg4';
      if (match >= 20) return 'ag-dg5';
      if (match >= 0) return 'ag-dg6';

      return 'ag-dg';
    };

    $scope.back = function () {
      MyService.ConsoleLog("Called");
      if ($scope.showBack == 'true') {
        // alert('c')
        $location.path('/poliCompare/' + $scope.quizName);
      } else if ($scope.isPopular == 'true') {
        $location.path('/popularQuizMatch');

      } else {
        $location.path('/findMatch');

      }
    };


  }]);

"use strict";

angular
  .module("myApp.fiveMatchView", ["ngRoute"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/fiveMatch/:tmpType?", {
        templateUrl: "app/fivemin_match/fivemin_match.html",
        controller: "fiveMatchCtrl",
      });
    },
  ])

  .controller("fiveMatchCtrl", [
    "$scope",
    "apiCall",
    "MyService",
    "$location",
    "$anchorScroll",
    "$timeout",
    "$rootScope",
    "ngDialog",
    "$q",
    "$http",
    "$filter",
    "tokenService",
    "baseApiUrl",
    "$document",
    "growl",
    "$cookies",
    function (
      $scope,
      apiCall,
      MyService,
      $location,
      $anchorScroll,
      $timeout,
      $rootScope,
      ngDialog,
      $q,
      $http,
      $filter,
      tokenService,
      baseApiUrl,
      $document,
      growl,
      $cookies
    ) {
      // alert('inside');
      $rootScope.welcome = true;
      $scope.currentIndex = 0;
      $scope.questions = [];
      $scope.oldQuestions = [];
      $scope.tempans = [];
      $scope.oldIndex = 0;
      $scope.showZipCode = false;
      $scope.showNw = false;
      $scope.isShowCheckBx = false;
      $scope.UserId = tokenService.getUserId();

      $scope.quizAns = {
        shortAns: "",
        mediAns: "",
        longAns: "",
      };
      $scope.answer;
      $scope.updata = {
        comment: "",
        reason: "",
      };
      $scope.nwAns;
      // $scope.skipToRes = false;
      $("#skipMatch").attr("disabled", true);

      /**
       * @description Remove session Id
       */

      window.localStorage.removeItem("sessionId");
      window.localStorage.removeItem("queIdsN");
      window.localStorage.removeItem("extraData");
      window.localStorage.removeItem("tempUserAddress");
      window.localStorage.removeItem("poliList");
      window.localStorage.removeItem("isFiveMinPage");
      window.localStorage.removeItem("fiveMatch");
      window.localStorage.removeItem("compareResult");

      $rootScope.guestUserData = [];
      MyService.ConsoleLog(" user id :", $scope.UserId);
      if ($cookies.get("sessionId")) {
        $cookies.remove("sessionId");
      }
      $scope.fivefb = {
        title:
          "Take a fun five minute quiz to find out who to vote for in your local elections",
        description: "",
        fbFiveImage: "",
      };
      window.localStorage.removeItem("mailingAddress");

      $scope.isUser = {
        selected: "",
      };

      /**
       *
       * @description Get front runners records from locaStorage if the user role is admin.
       */
      if (tokenService.getUserRole() == "admin") {
        $scope.frontRunners = JSON.parse(
          window.localStorage.getItem("frontRunners")
        );

        MyService.ConsoleLog("here is the frontRunners", $scope.frontRunners);
      }

      /**
       * @description Function calls when admin select front runner to answer for.
       * @param {*} userId
       */
      $scope.setUserId = function () {
        MyService.ConsoleLog("$scope.isUser", $scope.isUser.selected);
      };

      $scope.getFiveFacebookPost = function (data) {
        MyService.getFiveFacebookPost().then(
          function (payload) {
            // MyService.ConsoleLog(payload)
            if (payload.data.success) {
              $scope.fivefb.title = payload.data.data.fbTitle;
              $scope.fivefb.description = payload.data.data.fbDescription;
              if (payload.data.data.fbImage) {
                $scope.fivefb.fbFiveImage =
                  baseApiUrl + "/resources/" + payload.data.data.fbImage;
              }
            }
          },
          function (errorPayload) {}
        );
      };

      $scope.getFiveFacebookPost();

      if ($scope.currentIndex == 0) {
        if (window.localStorage.getItem("fiveMinMatch")) {
          // $scope.questions = JSON.parse(window.localStorage.getItem("fiveMinMatch"));
          $rootScope.fiveMatch = JSON.parse(
            window.localStorage.getItem("fiveMinMatch")
          );

          $timeout(function () {
            $scope.$apply();
          });
        } else {
          $rootScope.fiveMatch = [];
          $rootScope.fiveMatch.length = 0;
        }
      }
      // MyService.ConsoleLog("**** questions : " ,$scope.questions);
      /*if ($scope.questions.length <= 0) {
      if (window.localStorage.getItem("fiveMinMatch")) {
        $scope.questions = JSON.parse(window.localStorage.getItem("fiveMinMatch"));
      }
    }else{
      MyService.ConsoleLog("questions present");
    }*/
      $scope.initializeVariables = function () {
        $scope.importance = null;
        $scope.answer = null;
        $scope.updata.comment = "";
        $scope.updata.reason = "";

        // $scope.comment=document.getElementById('exampleFormControlTextarea1').value;
      };
      // $scope.comment;

      $scope.saveFiveMinAnswers = function (skip) {
        // MyService.ConsoleLog("saveFiveMinAnswers : ");
        MyService.ConsoleLog(
          "saveFiveMinAnswers fiveMatch >>>: ",
          $rootScope.fiveMatch
        );
        // alert(skip);
        $scope.pstData = [];
        var len = $rootScope.fiveMatch.length;
        MyService.ConsoleLog("Len :: ", len);
        if (len > 0) {
          for (var i = 0, k = 1; i < len; i++) {
            if (skip != "") {
              $scope.answer = "";
              $scope.importance = "";
              $scope.updata.comment = "";
              // MyService.ConsoleLog("saveFiveMinAnswers i >> ", i);
              // MyService.ConsoleLog("saveFiveMinAnswers >> ", $rootScope.fiveMatch[i]);
              if ($rootScope.fiveMatch[i]) {
                // console.log("Inside i ", i);
                // console.log("answer :", $rootScope.fiveMatch[i]);
                if (
                  $rootScope.fiveMatch[i].answer &&
                  $rootScope.fiveMatch[i].answer != ""
                ) {
                  $scope.answer = $rootScope.fiveMatch[i].answer;
                  $scope.importance = $rootScope.fiveMatch[i].importance;
                  $scope.updata.comment = $rootScope.fiveMatch[i].comment;
                  var postData = {
                    questionId: $rootScope.fiveMatch[i]._id,
                    importance: $scope.importance,
                    answer: $scope.answer,
                    comment: $scope.updata.comment,
                    categories: $rootScope.fiveMatch[i]["categories"],
                    content: $rootScope.fiveMatch[i]["content"],
                    _id: $rootScope.fiveMatch[i]["_id"],
                    matchOrder: $rootScope.fiveMatch[i]["matchOrder"],
                  };
                  $rootScope.fiveMatch[i] = angular.copy(postData);
                  // console.log("fiveMatch[i] > ", $rootScope.fiveMatch[i]);
                  $scope.pstData.push(postData);
                } else {
                  var data = $scope.checkQuestion($rootScope.fiveMatch[i]._id);
                  if (data && data[0]) {
                    // MyService.ConsoleLog("getdata >>> ", data[0]);
                    if (data[0].answer != "") {
                      $scope.answer = data[0].answer;
                    }
                    if (data[0].importance != "") {
                      $scope.importance = data[0].importance;
                    }
                    if (data[0].comment != "") {
                      $scope.updata.comment = data[0].comment;
                    }
                  }
                  var postData1 = {
                    questionId: $rootScope.fiveMatch[i]._id,
                    importance: $scope.importance,
                    answer: $scope.answer,
                    comment: $scope.updata.comment,
                    categories: $rootScope.fiveMatch[i]["categories"],
                    content: $rootScope.fiveMatch[i]["content"],
                    _id: $rootScope.fiveMatch[i]["_id"],
                    matchOrder: $rootScope.fiveMatch[i]["matchOrder"],
                  };
                  $rootScope.fiveMatch[i] = angular.copy(postData1);
                  $scope.pstData.push(postData1);
                }

                // MyService.ConsoleLog("$scope.postdata :",$scope.pstData);
              }
            } else {
              var postData = $rootScope.fiveMatch[i];
              $scope.pstData.push(postData);
              // MyService.ConsoleLog("$scope.postdata :>>>>>>>>>>>>", $rootScope.fiveMatch);
            }

            // console.log("postData1 > ", $rootScope.fiveMatch[i]);
            // console.log("postData > ", postData);
            if (skip != "" && postData) {
              console.log("saveFiveMinAnswers postData >>>>>>> ", postData);

              MyService.postAnswer(postData).then(
                function (response) {
                  // MyService.ConsoleLog("saveFiveMinAnswers response >>>", response);
                  if (response.data.success) {
                    MyService.ConsoleLog("Answer updated successfully");
                    growl.success("Answer updated successfully");
                  } else {
                    MyService.ConsoleLog("Error: " + response.data.error);
                    growl.error(response.data.error);
                  }

                  // console.log(k + "===" + len);
                  if (k == len) {
                    // console.log("redirect to five compare");
                    // if (skip == "skip") {
                    $rootScope.fiveMatch = angular.copy($scope.pstData);
                    window.localStorage.setItem(
                      "fiveMatch",
                      JSON.stringify($rootScope.fiveMatch)
                    );
                    // }

                    MyService.ConsoleLog(
                      "$rootScope.fiveMatch > ******** >>>",
                      $rootScope.fiveMatch
                    );
                    // MyService.ConsoleLog("This is length>>>>>>> ::", $scope.queLen);

                    if (skip == "RediectNew") {
                      $location.path("/fiveCompare/skip_to_result");
                    } else if (skip != "skipNew") {
                      MyService.ConsoleLog("IFFFFFFFFFFFFFF");
                      $location.path("/fiveCompare");
                    }

                    // else{
                    //   MyService.ConsoleLog("ELSESSSSSSSSSSSS");

                    //   $location.path('/fiveCompare/skip_to_result');

                    // }
                  }
                  k++;
                },
                function (err) {
                  MyService.ConsoleLog("Error: err");
                }
              );
            } else {
              // console.log("POstData ");

              $scope.updata.comment = "";

              if (k == len) {
                // console.log("redirect to five compare");
                // if (skip == "skip") {
                $rootScope.fiveMatch = angular.copy($scope.pstData);
                MyService.ConsoleLog(
                  "<<<<<<< tfdd",
                  window.localStorage.getItem("isShowFiveMin")
                );
                MyService.ConsoleLog(
                  "<<<<<<< tfdd",
                  typeof window.localStorage.getItem("isShowFiveMin")
                );

                // alert("got it");
                if (window.localStorage.getItem("isShowFiveMin") != "true") {
                  window.localStorage.setItem(
                    "fiveMatch",
                    JSON.stringify($rootScope.fiveMatch)
                  );
                } else {
                  window.localStorage.removeItem("isShowFiveMin");
                }

                // }

                MyService.ConsoleLog(
                  "$rootScope.fiveMatch > ******** 88888888 >>>",
                  $rootScope.fiveMatch
                );
                // MyService.ConsoleLog("This is length>>>>>>> ::", $scope.queLen);

                if (skip == "RediectNew") {
                  $location.path("/fiveCompare/skip_to_result");
                } else if (skip != "skipNew") {
                  MyService.ConsoleLog("IFFFFFFFFFFFFFF");
                  $location.path("/fiveCompare");
                }

                // else{
                //   MyService.ConsoleLog("ELSESSSSSSSSSSSS");

                //   $location.path('/fiveCompare/skip_to_result');

                // }
              }
              k++;
            }
          }
        }
      };

      $scope.fiveMinuteMatchDone = function () {
        // MyService.ConsoleLog($rootScope.fiveMatch);
        // MyService.ConsoleLog("**** fiveMinuteMatchDone");
        // MyService.ConsoleLog("UserId : >>>>>>", $rootScope.UserId);
        $scope.showpopUp = false;
        if (!$scope.UserId || $scope.UserId == "") {
          MyService.ConsoleLog("$scope.Questions", $scope.questions);
          var qLen = $scope.questions.length;
          for (var t = 0; t < qLen; t++) {
            if (
              $scope.questions[t].my_answer &&
              $scope.questions[t].my_answer != "" &&
              $scope.questions[t].my_answer.answer != ""
            ) {
              $scope.showpopUp = true;
              $scope.showZipCode = true;
            } else {
              if (!$scope.showpopUp && t == qLen - 1) {
                var message =
                  "You need to answer at least one question to see a match comparison";
                var modal = ngDialog.openConfirm({
                  template:
                    "<p>" +
                    message +
                    '</p>\
                <div class="ngdialog-buttons">\
                    <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Skip match and see candidates</button>\
                    <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Back to Questions</button>\
                </div>',
                  plain: true,
                  closeByDocument: false,
                });
                modal.then(
                  function fullfilled(data) {
                    // MyService.ConsoleLog("fullfilled: ", data);
                    $scope.getMatchQUestions();
                  },
                  function rejected(data) {
                    // MyService.ConsoleLog("rejected: ", data);
                    // $scope.getMatchQUestions();
                    // $location.path("/compare-select/politician");
                    //  $location.path("/fiveSaveUser");
                    const ansQue = $scope.checkQuestionAnswered();
                    if (ansQue == 0) {
                      window.localStorage.setItem(
                        "fiveMatch",
                        JSON.stringify($rootScope.fiveMatch)
                      );
                    }

                    $scope.showZipCode = true;
                  }
                );
                t = qLen + 1;
              }
            }
          }
        } else {
          // MyService.ConsoleLog("else called");
          // alert("else");
          $scope.saveFiveMinAnswers("");
        }
        //MyService.ConsoleLog($scope.questions);
      };
      $scope.initializeVariables();
      $scope.newQuestion = function () {
        MyService.ConsoleLog("newQuestion" + $scope.currentIndex);
        var tempIndex = $scope.currentIndex;
        $scope.initializeVariables();

        $scope.answer = "";
        $scope.importance = "";
        $scope.updata.comment = "";
        MyService.ConsoleLog("tempIndex<><><", tempIndex);
        // MyService.ConsoleLog("questions<><><", $scope.questions);
        MyService.ConsoleLog("length yog : ", $scope.questions.length);
        if (tempIndex < $scope.questions.length) {
          $scope.initializeVariables();

          if (window.localStorage.getItem("fiveMinMatch")) {
            $scope.getFiveMinData = [];
            $scope.getFiveMinData = JSON.parse(
              window.localStorage.getItem("fiveMinMatch")
            );
            MyService.ConsoleLog("Data : ", $scope.getFiveMinData);
            for (var i = 0; i < $scope.getFiveMinData.length; i++) {
              // MyService.ConsoleLog("for i : " + i + " currentIndex : " + $scope.currentIndex);
              if (i == $scope.currentIndex) {
                // MyService.ConsoleLog("index matched", $scope.getFiveMinData[i]);
                $scope.answer = $scope.getFiveMinData[i].answer;
                $scope.importance = $scope.getFiveMinData[i].importance;
                $scope.updata.comment = $scope.getFiveMinData[i].comment;
                // MyService.ConsoleLog("answer : " + $scope.answer);
                // MyService.ConsoleLog("importance : " + $scope.importance);
                // MyService.ConsoleLog("comment : " + $scope.comment);
                $timeout(function () {
                  $scope.$apply();
                });
              }
            }
          } else {
            console.log("Else is called");
            $scope.answer = "";
            $scope.importance = "";
            $scope.updata.comment = "";
            $scope.quizAns = {
              shortAns: "",
              mediAns: "",
              longAns: "",
            };
            MyService.ConsoleLog("Myans", $scope.getFiveMinData);

            // $scope.currentIndex++;
          }
          //$scope.currentIndex++;
        } else {
          // MyService.ConsoleLog("final question : " + $scope.questions.length);
          $scope.fiveMinuteMatchDone();
        }

        /*
      $timeout(function() {
        $location.hash('DisplayQ');
        $anchorScroll();
        $scope.$apply();
      }, 100);
      */
      };

      $scope.checkQuestion = function (val) {
        if (
          $scope.AllAnsweredQuestions &&
          $scope.AllAnsweredQuestions.length > 0
        ) {
          return $scope.AllAnsweredQuestions.filter(function (rdata) {
            // MyService.ConsoleLog(rdata.question + "==" + val);
            if (rdata.question == val) return rdata;
          });
        } else {
          if (!apiCall.getToken()) {
            return $rootScope.guestUserData.filter(function (rdata) {
              // MyService.ConsoleLog(rdata.questionId + "<==>" + val);
              if (rdata.questionId == val) return rdata;
            });
          } else {
            return $rootScope.fiveMatch.filter(function (rdata) {
              // MyService.ConsoleLog(rdata.questionId + "<==>" + val);
              if (rdata.questionId == val) return rdata;
            });
          }
        }
      };

      $scope.checkIfExists = function (val) {
        // MyService.ConsoleLog("checkIfExists >> ", $scope.currentIndex);

        var obj = $scope.questions[$scope.currentIndex];
        // MyService.ConsoleLog("checkIfExists >> ", obj);
        if (obj) {
          var data = $scope.checkQuestion(obj._id);

          if (data && data[0]) {
            // MyService.ConsoleLog("checkIfExists data>> ", data[0]);
            // $scope.comment = data[0].comment;
            if (data[0].answer == val) {
              // console.log("return True");
              $scope.dis = true;
              return true;
            }
          }
        }
        return false;
      };

      $scope.checkQuestionAnswered = function () {
        // console.log("scope.questions > ", $scope.questions);
        return $scope.questions.filter(function (rdata) {
          // MyService.ConsoleLog("== rdata >>>", rdata);
          var data = $scope.checkQuestion(rdata._id);
          // MyService.ConsoleLog("rdata.questionId  ", data);

          if (data && data.length > 0) return rdata;
        });
      };

      $scope.oneMore = function (valOne) {
        console.log("One more clicked");
        $scope.importance = valOne;
        // console.log("$scope.importance >> ",$scope.importance);
        $scope.submitAnswer();
      };

      $scope.checkImpExists = function (val) {
        // MyService.ConsoleLog("checkImpExists called :");
        var obj = $scope.questions[$scope.currentIndex];

        // $scope.importance = "";
        // console.log("scope.importance >>> ", $scope.importance);
        if (obj) {
          var data = $scope.checkQuestion(obj._id);

          if (data && data[0]) {
            // MyService.ConsoleLog("checkIfExists data>> ", data[0].importance + "==" + val);
            if (data[0].importance == val) {
              // $scope.importance = val;
              // console.log("importance <><><> ", $scope.importance);
              return true;
            }
          } else {
            if ($scope.importance == val) {
              $scope.importance = "";
            }
          }
        }
        return false;
      };

      $scope.initMyAnswer = function () {
        try {
          MyService.ConsoleLog(
            "yogesh here",
            $scope.questions[$scope.currentIndex]._id
          );
          var data = $scope.checkQuestion(
            $scope.questions[$scope.currentIndex]._id
          );
          MyService.ConsoleLog("yogesh here", data);
          if (data && data.length > 0) {
            // MyService.ConsoleLog("called init my ans", $scope.questions[$scope.currentIndex].my_answer);
            // alert('ooo')
            var my_answer = data[0];
            // MyService.ConsoleLog("Final Answers", my_answer);

            $scope.importance = my_answer.importance;
            $scope.answer = my_answer.answer;
            $scope.comment = my_answer.comment;
            MyService.ConsoleLog("Importance", $scope.importance);
            MyService.ConsoleLog(" $scope.answer", $scope.answer);
            MyService.ConsoleLog("#agreedisagree-id" + my_answer.answer);
            MyService.ConsoleLog("#importance-id" + my_answer.importance);
            $scope.quizAns.shortAns = my_answer.shortAns
              ? my_answer.shortAns
              : "";
            $scope.quizAns.mediAns = my_answer.mediumAns
              ? my_answer.mediumAns
              : "";
            $scope.quizAns.longAns = my_answer.longAns ? my_answer.longAns : "";
            $("#agreedisagree-id" + my_answer.answer).prop("checked", true);
            $("#importance-id" + my_answer.importance).prop("checked", true);
          } else {
            $scope.initializeVariables();
          }
        } catch (e) {
          $scope.initializeVariables();
          //MyService.ConsoleLog("Exceptoin: ", e)
        }
      };

      $scope.cachedQuestions = [];
      $scope.flagSkipAnsweredQuestion = false;
      $scope.skipAnswerChagne = function () {
        $scope.showNw = true;
        MyService.ConsoleLog(
          "scope.flagSkipAnsweredQuestion: ",
          $scope.flagSkipAnsweredQuestion
        );
        // MyService.ConsoleLog("$scope.questi", $scope.questions);

        var queIdsN = $scope.tempQue.filter(function (item) {
          if (!item.isEssayQue) {
            return item._id;
          }
        });

        var tempQuesNw = queIdsN.map(function (item) {
          return item._id;
        });
        // MyService.ConsoleLog("tempQuesNw >> ", tempQuesNw);

        window.localStorage.setItem("queIdsN", JSON.stringify(tempQuesNw));

        $scope.temp = $scope.questions;
        // if (!$scope.flagSkipAnsweredQuestion) {
        //   // alert("calld");
        //   // $scope.getMatchQUestions();
        //   // $scope.flagSkipAnsweredQuestion = true;

        // }
        $scope.currentIndex = 0;
        var questions = $scope.checkQuestionAnswered();
        // $rootScope.fiveMatch.length = 0;
        // if (!questions) {
        //   alert("call");
        // }

        $scope.dis = false;
        MyService.ConsoleLog("questions > ", questions.length);
        if (questions && questions.length > 0) {
          if ($scope.flagSkipAnsweredQuestion) {
            $scope.cachedQuestions.length = 0;
            $scope.cachedQuestions = angular.copy($scope.questions);
            for (var i = 0; i < questions.length; i++) {
              var idx = $scope.questions.indexOf(questions[i]);
              if (idx > -1) {
                $scope.questions.splice(idx, 1);
              }
            }
            console.log(
              "questionslength > ",
              $scope.cachedQuestions.length + "==" + questions.length
            );
            MyService.ConsoleLog(
              "$scope.cachedQuestions:",
              $scope.cachedQuestions
            );
            if ($scope.cachedQuestions.length == questions.length) {
              // console.log("questionslength Equal");
              if ($rootScope.fiveMatch.length == 0) {
                $rootScope.fiveMatch = angular.copy($scope.cachedQuestions);
                MyService.ConsoleLog(
                  " $rootScope.fiveMatch one :",
                  $rootScope.fiveMatch
                );
                var lents = $rootScope.fiveMatch.length;
                MyService.ConsoleLog(
                  "Len >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>",
                  lents
                );
                if (lents >= 5) {
                  // $scope.skipToRes = true;
                  $("#skipMatch").attr("disabled", false);
                }
                $scope.questions = angular.copy($scope.cachedQuestions);
                // $scope.questions = $scope.tempQue;

                $scope.questions.sort(function (x, y) {
                  if (x.matchOrder < y.matchOrder) {
                    return -1;
                  }
                  if (x.matchOrder > y.matchOrder) {
                    return 1;
                  }
                  return 0;
                });
              }
              // Newly Added
              if ($scope.cachedQuestions.length != questions.length) {
                $scope.saveFiveMinAnswers("skip");
              } else {
                // MyService.ConsoleLog("check type of > ", $scope.questions);
                var checkQueAns = $scope.checkQuestionAnswered();
                // MyService.ConsoleLog("checkQueAns > ", checkQueAns);
                if ($scope.tempQue.length == checkQueAns.length) {
                  $scope.isShowCheckBx = true;
                  var message =
                    "Congratulations, you have answered all the questions that your politicians have answered.";

                  var modal = ngDialog.openConfirm({
                    template:
                      "<p>" +
                      message +
                      '</p>\
                       <div class="ngdialog-buttons">\
                           <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(0)">See Match-Ups</button>\
                           <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Edit Answers</button>\
                       </div>',
                    plain: true,
                  });

                  modal.then(
                    function fullfilled(data) {
                      if (data == 0) {
                        $scope.skipToMatch();
                      } else {
                        $scope.flagSkipAnsweredQuestion = false;
                        $scope.showNw = false;
                        $scope.skipAnswerChagne();
                      }
                    },
                    function rejected(data) {
                      //MyService.ConsoleLog("rejected: ", data);
                    }
                  );
                } else {
                  var finalQues = [];
                  finalQues = finalQues.concat($scope.tempQue);

                  // MyService.ConsoleLog("check type of > ", questions);

                  const cLen = questions.length;
                  for (var c = 0; c < cLen; c++) {
                    var idxc = finalQues.indexOf(questions[c]);
                    // MyService.ConsoleLog("idxc > ", idxc);
                    if (idxc > -1) {
                      finalQues.splice(idxc, 1);
                    }
                  }
                  // MyService.ConsoleLog("finalQues > ", finalQues);
                  $scope.questions = finalQues;
                }

                // $scope.questions = angular.copy($scope.cachedQuestions);
                // $scope.questions.sort(function (x, y) {
                //   if (x.matchOrder < y.matchOrder) {
                //     return -1;
                //   }
                //   if (x.matchOrder > y.matchOrder) {
                //     return 1;
                //   }
                //   return 0;
                // });
              } // Newly Added
            } else {
              // alert("esle");
              $scope.updata.comment = "";
              $rootScope.fiveMatch = angular.copy(questions);
              // $rootScope.fiveMatch.filter(function (itm) {
              //   MyService.ConsoleLog("itm nw", itm)
              //   let queLen = $scope.questions.length;
              //   for (var i = 0; i > queLen; i++) {
              //     if (itm.questionId == $scope.questions[i]._id) {
              //       MyService.ConsoleLog("itm", itm);
              //     }
              //   }
              // });
              var lent = $rootScope.fiveMatch.length;
              MyService.ConsoleLog(
                "lent @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@",
                lent
              );

              if (lent >= 5) {
                // $scope.skipToRes = true;
                $("#skipMatch").attr("disabled", false);
              }
              $scope.saveFiveMinAnswers("skipNew");
            }
          } else {
            // alert("esle2222");
            MyService.ConsoleLog(
              "$scope.cachedQuestions super else",
              $scope.cachedQuestions
            );

            MyService.ConsoleLog("questions super else", questions);
            MyService.ConsoleLog(
              "$scope.questions super else",
              $scope.questions
            );

            // /**
            //  * Check If
            //  */
            if ($scope.cachedQuestions && $scope.cachedQuestions.length > 0) {
              $scope.questions = angular.copy($scope.cachedQuestions);
            } else {
              if (tokenService.getUserRole() == "politician") {
                const ansCheck = $scope.checkQuestionAnswered();
                if (ansCheck.length >= 5) {
                  // $scope.skipToRes = true;
                  $("#skipMatch").attr("disabled", false);
                }
                $scope.questions.sort(function (x, y) {
                  if (x.matchOrder < y.matchOrder) {
                    return -1;
                  }
                  if (x.matchOrder > y.matchOrder) {
                    return 1;
                  }
                  return 0;
                });
              } else {
                $scope.questions = questions;
              }
            }

            // console.log("currentIndex : ", $scope.currentIndex);
          }
        } else {
          // alert("esle333");

          if (!$scope.flagSkipAnsweredQuestion) {
            MyService.ConsoleLog("INside");
            $scope.questions = angular.copy($scope.cachedQuestions);

            var queIdsN = $scope.questions.filter(function (item) {
              if (!item.isEssayQue) {
                return item._id;
              }
            });

            var tempQuesNw = queIdsN.map(function (item) {
              return item._id;
            });
            MyService.ConsoleLog("tempQuesNw >> ", tempQuesNw);

            window.localStorage.setItem("queIdsN", JSON.stringify(tempQuesNw));

            if ($scope.questions[$scope.currentIndex]) {
              MyService.ConsoleLog("ONe MORE");
              // console.log($scope.questions[$scope.currentIndex]._id);
              var data = $scope.checkQuestion(
                $scope.questions[$scope.currentIndex]._id
              );
              console.log("data >> ", data);
              if (data && data[0]) {
                $scope.updata.comment = data[0].comment;
                $scope.importance = data[0].importance; //Added
              }
            } else {
              // $scope.flagSkipAnsweredQuestion = false;
              // alert("inside");
              MyService.ConsoleLog("$scope.temp", $scope.temp);
              $scope.questions = $scope.temp;
            }
          }
        }
      };

      // $scope.commenta=function()
      $scope.checkQuestions = function (rdata, val) {
        MyService.ConsoleLog("rdata :", rdata);
        return rdata.filter(function (rdata) {
          // MyService.ConsoleLog(rdata.question + "==" + val);
          if (rdata.questionId == val) return rdata;
        });
      };
      //  Commented by vishal on 1 st November
      // $scope.postAnswer = function(postData, val) {
      //   MyService.ConsoleLog("postData: ", postData);
      //   // MyService.ConsoleLog("Index <><><", $rootScope.fiveMatch.indexOf(postData));
      //   var ndata = $scope.checkQuestion(postData.questionId);
      //   // MyService.ConsoleLog("ndata >", ndata);
      //   // MyService.ConsoleLog($rootScope.fiveMatch);
      //   /*
      //   if (ndata.length == 0) {
      //     $rootScope.fiveMatch.push(postData);
      //     MyService.ConsoleLog("Data Pushed");
      //   }
      //   */
      //   $scope.questions[$scope.currentIndex]["my_answer"] = {
      //     _id: postData.id,
      //     created: new Date(),
      //     comment: postData.comment,
      //     answer: postData.answer,
      //     importance: postData.importance
      //   };

      //   var chkData = $scope.checkQuestions($rootScope.fiveMatch, postData.questionId);
      //   MyService.ConsoleLog("chkData<><><>", chkData);
      //   if (ndata.length == 0) {
      //     postData.categories = $scope.questions[$scope.currentIndex]["categories"];
      //     postData.content = $scope.questions[$scope.currentIndex]["content"];
      //     postData._id = $scope.questions[$scope.currentIndex]["_id"];
      //     if (chkData && chkData.length == 0) {
      //       // MyService.ConsoleLog("postData1if<><><",postData);
      //       $rootScope.fiveMatch.push(postData);
      //       MyService.ConsoleLog("FiveMatch::::", $rootScope.fiveMatch);

      //       var fiveLen = $rootScope.fiveMatch.length;

      //       MyService.ConsoleLog("fiveLen:::", fiveLen);

      //       if (fiveLen >= 5) {
      //         // $scope.skipToRes = true;
      //         $('#skipMatch').attr('disabled', false);

      //       }

      //     }
      //     // MyService.ConsoleLog("Data Pushed");
      //   } else {
      //     // console.log("chkData >> ", chkData);
      //     // console.log("chkData.length >> ", chkData.length);
      //     if (chkData && chkData.length == 0) {
      //       postData.categories = $scope.questions[$scope.currentIndex]["categories"];
      //       postData.content = $scope.questions[$scope.currentIndex]["content"];
      //       postData._id = $scope.questions[$scope.currentIndex]["_id"];
      //       MyService.ConsoleLog("postData<><><", postData);
      //       $rootScope.fiveMatch.push(postData);

      //       var fiveLen = $rootScope.fiveMatch.length;

      //       if (fiveLen >= 5) {
      //         $('#skipMatch').attr('disabled', false);
      //         // $scope.skipToRes = true;

      //       }

      //     }
      //   }
      //   // MyService.ConsoleLog($rootScope.fiveMatch);
      //   window.localStorage.setItem("fiveMatch", JSON.stringify($rootScope.fiveMatch));
      //   if (val == "submit") {
      //     $scope.currentIndex = $scope.currentIndex + 1;
      //     // MyService.ConsoleLog(window.localStorage.getItem("fiveMatch"));
      //     $scope.newQuestion();
      //   }

      // };

      $scope.saveAnswersOneByOne = function (params) {
        MyService.ConsoleLog("post params >>>>>:", params);

        if (params && params != "") {
          MyService.postAnswer(params).then(
            function (response) {
              try {
                document.getElementById("txtReason").value = "";
              } catch (err) {
                console.log("err", err);
              }

              if (response.data.success) {
                try {
                  if (params.id) {
                    $scope.questions[$scope.currentIndex]["my_answer"] = {
                      _id: postData.id,
                      created: new Date(),
                      comment: params.comment,
                      questionId: params.questionId,
                      answer: params.answer,
                      importance: params.importance,
                    };
                  } else {
                    $scope.questions[$scope.currentIndex]["my_answer"] = {
                      _id: response.data.data._id,
                      created: response.data.data.created,
                      questionId: response.data.data.question,
                      comment: response.data.data.comment,
                      answer: response.data.data.answer,
                      importance: response.data.data.importance,
                    };
                  }
                } catch (e) {
                  //MyService.ConsoleLog("Exceptoin: ", e);
                }
                if (response.data.data.question) {
                  $scope.AllAnsweredQuestions.push(response.data.data);
                }

                if (params.id) {
                  growl.success("Answer updated successfully", {
                    ttl: 5000,
                  });
                } else {
                  growl.success("Answered successfully", {
                    ttl: 5000,
                  });
                }
                $scope.currentIndex = $scope.currentIndex + 1;

                // MyService.ConsoleLog(window.localStorage.getItem("fiveMatch"));
                $scope.newQuestion();
              } else {
                growl.error("Error: " + response.data.error);
              }
            },
            function (err) {
              // growl.error("Something went wrong.");
            }
          );
        }
      };

      //  Commented by vishal on 1st November
      // $scope.submitAnswer = function() {
      //   MyService.ConsoleLog("$scope.comment >>>>", $scope.updata.comment);

      //   var data = $scope.checkQuestion($scope.questions[$scope.currentIndex]._id);
      //   if (data && data[0]) {
      //     MyService.ConsoleLog("getMatchQUestions >>> ", data[0]);
      //     if (data[0].answer != "") {
      //       $scope.answer = data[0].answer;
      //     }
      //     if (data[0].importance != "") {
      //       $scope.importance = data[0].importance;
      //     }
      //     if (data[0].comment != "") {
      //       $scope.comment = data[0].comment;
      //     }

      //   }
      //   document.getElementById("txtReason").value = '';
      //   document.getElementById("exampleFormControlTextarea1").value = '';
      //   MyService.ConsoleLog("answer :" + $scope.answer);
      //   MyService.ConsoleLog("importance :" + $scope.importance);
      //   if ($scope.answer == null || $scope.answer == '') {
      //     var message = "Please select answer first.";
      //     var modal = ngDialog.openConfirm({
      //       template: '<p>' + message + '</p>\
      //                     <div class="ngdialog-buttons">\
      //                         <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
      //                     </div>',
      //       plain: true
      //     });
      //     modal.then(function fullfilled(data) {
      //       MyService.ConsoleLog("fullfilled: ", data);
      //     }, function rejected(data) {
      //       MyService.ConsoleLog("rejected: ", data);
      //     });
      //     $("html, body").animate({
      //       scrollTop: 0
      //     }, "slow");
      //     return;
      //   }
      //   //MyService.ConsoleLog("**** ", $scope.importance);
      //   if ($scope.importance == null || $scope.importance == '') {
      //     var message = "You need to choose an importance level.  Should they fight hard for this can they use it to trade for other things you care about more?";
      //     var modal = ngDialog.openConfirm({
      //       template: '<p>' + message + '</p>\
      //                     <div class="ngdialog-buttons">\
      //                         <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
      //                     </div>',
      //       plain: true
      //     });
      //     modal.then(function fullfilled(data) {
      //       //MyService.ConsoleLog("fullfilled: ", data);
      //     }, function rejected(data) {
      //       //MyService.ConsoleLog("rejected: ", data);
      //     });
      //     $("html, body").animate({
      //       scrollTop: 0
      //     }, "slow");
      //     return;
      //   }
      //   $("html, body").animate({
      //     scrollTop: 0
      //   }, "slow");
      //   var postData = {
      //     questionId: $scope.questions[$scope.currentIndex]._id,
      //     importance: $scope.importance,
      //     answer: $scope.answer,
      //     comment: $scope.updata.comment,
      //     reason: $scope.updata.reason
      //   };
      //   $scope.postAnswer(postData, 'submit');
      // };

      //

      $scope.postAnswer = function (postData, val) {
        MyService.ConsoleLog("postData: ", postData);
        // MyService.ConsoleLog("Index <><><", $rootScope.fiveMatch.indexOf(postData));

        var ndata = $scope.checkQuestion(postData.questionId);
        MyService.ConsoleLog("ndata >", ndata);
        // MyService.ConsoleLog($rootScope.fiveMatch);

        if (ndata.length > 0) {
          var vdx = $scope.AllAnsweredQuestions.indexOf(ndata[0]);
          if (vdx > -1) {
            // console.log("VDX > ", vdx);
            $scope.AllAnsweredQuestions[vdx]["answer"] = postData.answer;
            $scope.AllAnsweredQuestions[vdx]["importance"] =
              postData.importance;
            $scope.AllAnsweredQuestions[vdx]["comment"] = postData.comment;
            // console.log("AS : ", $scope.AllAnsweredQuestions[vdx]);
          }
        }

        $scope.questions[$scope.currentIndex]["my_answer"] = {
          _id: postData._id,
          created: new Date(),
          id: postData.id,
          reason: postData.reason,
          comment: postData.comment,
          answer: postData.answer,
          importance: postData.importance,
        };

        var chkData = $scope.checkQuestions(
          $rootScope.fiveMatch,
          postData.questionId
        );
        MyService.ConsoleLog("chkData<><><>", chkData);
        $scope.dis = false;

        postData.categories =
          $scope.questions[$scope.currentIndex]["categories"];
        postData.content = $scope.questions[$scope.currentIndex]["content"];
        postData._id = $scope.questions[$scope.currentIndex]["_id"];

        if (chkData && chkData.length == 0) {
          // alert("one");
          // MyService.ConsoleLog("postData1if<><><",postData);
          $rootScope.fiveMatch.push(postData);
          // MyService.ConsoleLog("Final Five match <><><><><> ", $rootScope.fiveMatch);
          window.localStorage.setItem(
            "fiveMatch",
            JSON.stringify($rootScope.fiveMatch)
          );
          if (val == "submit" && val != "skip") {
            if ($scope.UserId && $scope.UserId != "") {
              if (postData.questionId && postData.questionId != "") {
                $scope.saveAnswersOneByOne(postData);
                postData = "";
              }
            } else {
              $scope.currentIndex = $scope.currentIndex + 1;
              MyService.ConsoleLog(
                "Else >> ",
                window.localStorage.getItem("fiveMatch")
              );
              $scope.importance = angular.copy("");
              growl.success("Answered successfully", {
                ttl: 1000,
              });
              $scope.newQuestion();
            }
          }

          var fiveLen = $rootScope.fiveMatch.length;

          MyService.ConsoleLog(
            "FiveMatch:  $scope.currentIndex ::: ",
            $scope.currentIndex
          );
          $scope.importance = angular.copy("");
          if (fiveLen >= 5) {
            // $scope.skipToRes = true;
            $("#skipMatch").attr("disabled", false);
          }
        } else {
          // alert("two");
          var idx = $rootScope.fiveMatch.indexOf(chkData[0]);
          // MyService.ConsoleLog(
          //   "currentIndex <><><> ",
          //   JSON.parse(window.localStorage.getItem("fiveMatch"))
          // );
          $rootScope.fiveMatch[idx] = postData;
          $scope.importance = angular.copy("");
          window.localStorage.setItem(
            "fiveMatch",
            JSON.stringify($rootScope.fiveMatch)
          );
          // MyService.ConsoleLog("val >>>> ", val);
          if (val == "submit" && val != "skip") {
            if ($scope.UserId && $scope.UserId != "") {
              if (
                (postData.reason && postData.reason != "") ||
                (postData.id && postData.id != "")
              ) {
                $scope.saveAnswersOneByOne(postData);
                postData = "";
              }
            } else {
              $scope.currentIndex = $scope.currentIndex + 1;
              $scope.importance = angular.copy("");
              MyService.ConsoleLog(
                "currentIndex <><><> 4",
                window.localStorage.getItem("fiveMatch")
              );
              $scope.newQuestion();
            }
          }
        }

        // MyService.ConsoleLog("Final Five match <><><><><> ", $rootScope.fiveMatch);
        // window.localStorage.setItem("fiveMatch", JSON.stringify($rootScope.fiveMatch));
        // if (val == "submit") {
        //   $scope.currentIndex = $scope.currentIndex + 1;
        //   // MyService.ConsoleLog(window.localStorage.getItem("fiveMatch"));
        //   $scope.newQuestion();
        // }
      };

      /**
       * @description Funtions is use to save guest user's answers with unique id.
       */
      var ques = [];
      $scope.guest = function (guestData) {
        //MyService.ConsoleLog("guestData: ", guestData);
        try {
          var my_answer = $scope.questions[$scope.currentIndex].my_answer;
          if (
            my_answer.importance != $scope.importance ||
            my_answer.answer != $scope.answer ||
            my_answer.comment != $scope.comment
          ) {
            //MyService.ConsoleLog("Answer changed");
            guestData.id = my_answer._id;
            guestData.reason = $scope.reason;
          } else {
            //MyService.ConsoleLog("Answer not changed");
            return; //don't do anything
          }
        } catch (e) {
          //MyService.ConsoleLog("Exceptoin: ", e);
        }

        var ndatas = $scope.checkQuestion(guestData.questionId);
        MyService.ConsoleLog("ndata >", ndatas);
        // MyService.ConsoleLog($rootScope.fiveMatch);

        if (ndatas.length > 0) {
          var vdx = $scope.AllAnsweredQuestions.indexOf(ndatas[0]);
          if (vdx > -1) {
            // console.log("VDX > ", vdx);
            $scope.AllAnsweredQuestions[vdx]["answer"] = guestData.answer;
            $scope.AllAnsweredQuestions[vdx]["importance"] =
              guestData.importance;
            $scope.AllAnsweredQuestions[vdx]["comment"] = guestData.comment;
            // console.log("AS : ", $scope.AllAnsweredQuestions[vdx]);
          }
        }

        $scope.questions[$scope.currentIndex]["my_answer"] = {
          _id: guestData.questionId,
          created: new Date(),
          id: guestData.id,
          reason: guestData.reason,
          comment: guestData.comment,
          answer: guestData.answer,
          importance: guestData.importance,
          categories: $scope.questions[$scope.currentIndex]["categories"],
          content: $scope.questions[$scope.currentIndex]["content"],
        };

        guestData.content = $scope.questions[$scope.currentIndex]["content"];
        guestData.categories =
          $scope.questions[$scope.currentIndex]["categories"];

        var chkGuestAns = $scope.checkQuestions(
          $rootScope.guestUserData,
          guestData.questionId
        );

        // guestData.categories = $scope.questions[$scope.currentIndex]["categories"];
        // guestData.content = $scope.questions[$scope.currentIndex]["content"];
        guestData._id = $scope.questions[$scope.currentIndex]["_id"];

        if (chkGuestAns && chkGuestAns.length == 0) {
          $rootScope.guestUserData.push(guestData);
          window.localStorage.setItem(
            "fiveMatch",
            JSON.stringify($rootScope.guestUserData)
          );
          MyService.ConsoleLog("guestUserData >>>", $rootScope.guestUserData);
        }
        console.log("guestData > ", guestData);

        MyService.guestAnswers(guestData).then(
          function (response) {
            if (response.data.success) {
              try {
                if (guestData.id) {
                  $scope.questions[$scope.currentIndex]["my_answer"] = {
                    _id: guestData.id,
                    created: new Date(),
                    comment: guestData.comment,
                    answer: guestData.answer,
                    importance: guestData.importance,
                  };
                  MyService.ConsoleLog("Inside IF >>", $scope.questions);
                } else {
                  $scope.questions[$scope.currentIndex]["my_answer"] = {
                    _id: guestData.questionId,
                    created: response.data.data.created,
                    comment: response.data.data.comment,
                    answer: response.data.data.answer,
                    importance: response.data.data.importance,
                  };

                  if ($scope.questions[$scope.currentIndex].my_answer) {
                    MyService.ConsoleLog(
                      "Inside ELSE >>",
                      $scope.questions[$scope.currentIndex]
                    );
                    ques.push($scope.questions[$scope.currentIndex]);
                    if ($scope.questions.length == ques.length) {
                      // window.localStorage.removeItem('quesData');
                      MyService.ConsoleLog("set it now", ques);
                      // window.localStorage.setItem('quesData', JSON.stringify(ques));
                    }
                  }
                }
              } catch (e) {
                //MyService.ConsoleLog("Exceptoin: ", e);
              }
              if (guestData.id) {
                growl.success("Answer updated successfully", {
                  ttl: 800,
                });
              } else {
                growl.success("Answered successfully", {
                  ttl: 800,
                });
              }
              $scope.dis = false;
              $scope.currentIndex = $scope.currentIndex + 1;
              var fiveLen = $rootScope.guestUserData.length;

              $scope.importance = angular.copy("");
              if (fiveLen >= 5) {
                // $scope.skipToRes = true;
                $("#skipMatch").attr("disabled", false);
              }
              $scope.newQuestion();
            } else {
              growl.error("Error: " + response.data.error);
            }
          },
          function (err) {
            growl.error("Something went wrong.");
          }
        );
      };

      /**
       * @description Function is to set answer object.
       */

      var guestSessionId;
      $rootScope.guestUserData = [];

      $scope.submitAnswer = function () {
        MyService.ConsoleLog("$scope.answer", $scope.answer);
        MyService.ConsoleLog("$scope.comment <>>>>", $scope.updata);
        MyService.ConsoleLog("$scope.answer <>>>>", $scope.answer);
        // return;
        var isEssayQue = $scope.questions[$scope.currentIndex].isEssayQue;
        var data = $scope.checkQuestion(
          $scope.questions[$scope.currentIndex]._id
        );
        if (!isEssayQue) {
          var token = apiCall.getToken();
          var answerId = "";
          var answerReason = "";

          if (data && data[0]) {
            if (data[0] && data[0]._id) {
              answerId = data[0]._id;
            }
            if (data[0] && data[0]._id) {
              if ($scope.updata && $scope.updata.reason) {
                answerReason = $scope.updata.reason;
              }
              if ($scope.importance == null || $scope.importance == "") {
                $scope.importance = data[0].importance; // Added
              }
              if ($scope.answer == null || $scope.answer == "") {
                $scope.answer = data[0].answer; // Added
              }
            }
          }

          MyService.ConsoleLog("answer :" + $scope.answer);
          MyService.ConsoleLog("importance :" + $scope.importance);
          if ($scope.answer == null || $scope.answer == "") {
            var message = "Please select answer first.";
            var modal = ngDialog.openConfirm({
              template:
                "<p>" +
                message +
                '</p>\
                       <div class="ngdialog-buttons">\
                           <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                       </div>',
              plain: true,
            });
            modal.then(
              function fullfilled(data) {
                MyService.ConsoleLog("fullfilled: ", data);
              },
              function rejected(data) {
                MyService.ConsoleLog("rejected: ", data);
              }
            );
            $("html, body").animate(
              {
                scrollTop: 0,
              },
              "slow"
            );
            return;
          }
          //MyService.ConsoleLog("**** ", $scope.importance);
          if ($scope.importance == null || $scope.importance == "") {
            var message =
              "You need to choose an importance level.  Should they fight hard for this can they use it to trade for other things you care about more?";
            var modal = ngDialog.openConfirm({
              template:
                "<p>" +
                message +
                '</p>\
                       <div class="ngdialog-buttons">\
                           <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                       </div>',
              plain: true,
            });
            modal.then(
              function fullfilled(data) {
                //MyService.ConsoleLog("fullfilled: ", data);
              },
              function rejected(data) {
                //MyService.ConsoleLog("rejected: ", data);
              }
            );
            $("html, body").animate(
              {
                scrollTop: 0,
              },
              "slow"
            );
            return;
          }

          // document.getElementById("txtReason").value = '';
          // document.getElementById("exampleFormControlTextarea1").value = '';

          if (
            tokenService &&
            tokenService.getUserRole() == "admin" &&
            $scope.isUser &&
            $scope.isUser.selected &&
            $scope.isUser.selected != ""
          ) {
            var postData = {
              questionId: $scope.questions[$scope.currentIndex]._id,
              importance: $scope.importance,
              answer: $scope.answer,
              comment: $scope.updata.comment,
              frontRunnerId: $scope.isUser.selected._id,
            };
          } else {
            var postData = {
              questionId: $scope.questions[$scope.currentIndex]._id,
              importance: $scope.importance,
              answer: $scope.answer,
              comment: $scope.updata.comment,
            };
          }

          if (answerId != "") {
            postData.id = answerId;
            MyService.ConsoleLog("answerId :", answerId);
            postData.reason = answerReason;
            // console.log($rootScope.fiveMatch[$scope.currentIndex]);
            if ($rootScope.fiveMatch[$scope.currentIndex]) {
              if (
                $rootScope.fiveMatch[$scope.currentIndex].answer !=
                  $scope.answer ||
                $rootScope.fiveMatch[$scope.currentIndex].importance !=
                  $scope.importance ||
                $rootScope.fiveMatch[$scope.currentIndex].comment ==
                  $scope.updata.comment
              ) {
                // if ($scope.updata.reason == null || $scope.updata.reason == '') {
                //   var message = "You need to add the reason for changing the answer.";
                //   var modal = ngDialog.openConfirm({
                //     template: '<p>' + message + '</p>\
                //            <div class="ngdialog-buttons">\
                //                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                //            </div>',
                //     plain: true
                //   });
                //   modal.then(function fullfilled(data) {
                //     //MyService.ConsoleLog("fullfilled: ", data);
                //   }, function rejected(data) {
                //     //MyService.ConsoleLog("rejected: ", data);
                //   });
                //   $("html, body").animate({
                //     scrollTop: 0
                //   }, "slow");
                //   return;
                // }
              }
            }
          }
          $("html, body").animate(
            {
              scrollTop: $("#DisplayQ1").offset().top - 80,
            },
            "slow"
          );
          // console.log("postData > ", postData);

          if (!token) {
            var guestObj;
            if (!guestSessionId) {
              $scope.finalSessionId = "";
              MyService.ConsoleLog("Inside", guestSessionId);

              /**
               * @description Create unique Id for each guest user.
               */
              var date = new Date();
              var sessionId = date.getTime();
              $scope.finalSessionId = sessionId;
              MyService.ConsoleLog("sessionId >>", $scope.finalSessionId);
              window.localStorage.setItem("sessionId", $scope.finalSessionId);
            }

            guestSessionId = $scope.finalSessionId;

            /**
             * @description Guest user answer object with the unique id.
             */

            if (
              $scope.questions[$scope.currentIndex].showInMatch &&
              $scope.questions[$scope.currentIndex].showInMatch == "YES"
            ) {
              guestObj = {
                questionId: $scope.questions[$scope.currentIndex]._id,
                importance: $scope.importance,
                answer: $scope.answer,
                comment: $scope.updata.comment,
                gSessionId: guestSessionId,
                quizType: "FiveMin Quiz",
                matchOrder: $scope.questions[$scope.currentIndex].matchOrder,
              };
            } else if (
              $scope.questions[$scope.currentIndex].showInMatch &&
              $scope.questions[$scope.currentIndex].showInMatch == "NO"
            ) {
              guestObj = {
                questionId: $scope.questions[$scope.currentIndex]._id,
                importance: $scope.importance,
                answer: $scope.answer,
                comment: $scope.updata.comment,
                gSessionId: guestSessionId,
                quizType: "Regular Quiz",
              };
            }
            $scope.guest(guestObj);
          } else {
            $scope.postAnswer(postData, "submit");
          }
        } else {
          var ansId = "";
          if (data[0] && data[0]._id) {
            ansId = data[0]._id;
          }

          if (
            $scope.quizAns.shortAns == "" &&
            $scope.quizAns.mediAns == "" &&
            $scope.quizAns.longAns == ""
          ) {
            var message = "You need to write at least one answer";
            var modal = ngDialog.openConfirm({
              template:
                "<p>" +
                message +
                '</p>\
                       <div class="ngdialog-buttons">\
                           <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="closeThisDialog(0)">OK</button>\
                       </div>',
              plain: true,
            });
            modal.then(
              function fullfilled(data) {
                //MyService.ConsoleLog("fullfilled: ", data);
              },
              function rejected(data) {
                //MyService.ConsoleLog("rejected: ", data);
              }
            );
            $("html, body").animate(
              {
                scrollTop: 0,
              },
              "slow"
            );
            return;
          } // End of question checking
          var quizParams = {
            shortAns: $scope.quizAns.shortAns,
            mediAns: $scope.quizAns.mediAns,
            longAns: $scope.quizAns.longAns,
          };
          if (
            tokenService &&
            tokenService.getUserRole() == "admin" &&
            $scope.isUser &&
            $scope.isUser.selected &&
            $scope.isUser.selected != ""
          ) {
            quizParams.frontRunnerId = $scope.isUser.selected._id;
          }

          if (ansId && ansId != "") {
            quizParams.id = ansId;
          } else {
            quizParams.questionId = $scope.questions[$scope.currentIndex]._id;
            // quizParams
          }

          MyService.ConsoleLog(" check quizParams >> ", quizParams);
          // return;
          $rootScope.fiveMatch.push(quizParams);
          // MyService.ConsoleLog("Final Five match <><><><><> ", $rootScope.fiveMatch);
          window.localStorage.setItem(
            "fiveMatch",
            JSON.stringify($rootScope.fiveMatch)
          );
          MyService.storeEssayAnswer(quizParams).then(
            function (APIResponse) {
              MyService.ConsoleLog("APIResponse >> ", APIResponse);
              if (APIResponse.data.success) {
                $scope.questions[$scope.currentIndex]["my_answer"] = {
                  _id: ansId ? ansId : APIResponse.data.data._id,
                  created: new Date(),
                  shortAns: APIResponse.data.data.shortAns,
                  mediAns: APIResponse.data.data.mediumAns,
                  longAns: APIResponse.data.data.longAns,
                  questionId: APIResponse.data.data.question,
                };
              }
              $scope.currentIndex = $scope.currentIndex + 1;
              $scope.newQuestion();
            },
            function (err) {
              MyService.ConsoleLog("Error >> ", err);
            }
          );
        } // End of isEssayQue
      };

      $rootScope.$on("question.answered", function (evt, data) {
        MyService.ConsoleLog("on question.answered: ", data);
        if ($scope.questions[$scope.currentIndex]._id == data.questionId) {
          $scope.initializeVariables();
          $scope.skipQuestion();
        }
      });

      // Quick link for show match

      $scope.skipToMatch = function () {
        if ($scope.UserId && $scope.UserId != "") {
          // alert("if");
          MyService.ConsoleLog("$scope.temoQue", $scope.isQuestions);
          MyService.ConsoleLog("welcome to quick link :", $rootScope.fiveMatch);
          MyService.ConsoleLog(
            "welcome to quick link :",
            $rootScope.fiveMatch + "     " + $scope.questions.length
          );

          const ansQ = $scope.checkQuestionAnswered();
          MyService.ConsoleLog("ansQ >> ", ansQ.length);
          MyService.ConsoleLog(
            "$scope.isQuestions.length >> ",
            $scope.isQuestions.length
          );

          if (ansQ.length != $scope.isQuestions.length) {
            if ($scope.isQuestions && $scope.isQuestions.length > 0) {
              $scope.questions.filter(function (que) {
                var newQue = {};
                if (que && que.categories && que.categories.length > 0) {
                  newQue.content = que.content;
                  newQue.matchOrder = que.matchOrder;
                  newQue.categories = que.categories;
                  newQue.answer = 0;
                  newQue.importance = 0;
                  newQue.comment = "";
                  newQue.questionId = que._id;
                  newQue.question = que._id;
                  $rootScope.fiveMatch.push(newQue);
                }
              });
              MyService.ConsoleLog(
                "$rootScope.fiveMatch ",
                $rootScope.fiveMatch.length
              );
              // return;
              window.localStorage.setItem(
                "fiveMatch",
                JSON.stringify($rootScope.fiveMatch)
              );
              // setTimeout(function () {
              $location.path("/fiveCompare/skip_to_result");
              // }, 200);
            }
          } else {
            $location.path("/fiveCompare/skip_to_result");
          }

          // if ($rootScope.fiveMatch.length != $scope.cachedQuestions) {
          //   MyService.ConsoleLog("$cope catch que", $scope.cachedQuestions);
          //   const fivLen = $rootScope.fiveMatch.length;
          //   for (var f = 0; f < fivLen; f++){
          //     $scope.cachedQuestions.filter(function (ans) {
          //       if($rootScope.fiveMatch[f].questionId !=)
          //     });
          //   }
          // }

          // return;

          // window.localStorage.setItem("fiveMatch", JSON.stringify($rootScope.fiveMatch));
          // $scope.saveFiveMinAnswers("RedirectNew");
        } else {
          // alert("else");
          $scope.showZipCode = true;
        }
        // $rootScope.fiveMatch.length=0;
      };

      $scope.getMatchQUestions = function () {
        // MyService.ConsoleLog("  $rootScope.fiveMatch :>", $rootScope.fiveMatch);
        MyService.getfivematch().then(
          function (payload) {
            MyService.ConsoleLog("getMatchQUestions", payload);
            if (payload.data.success) {
              $scope.questions = payload.data.data;
              $scope.tempQue = payload.data.data;

              $scope.isQuestions = angular.copy(payload.data.data);

              $scope.questions.sort(function (x, y) {
                if (x.matchOrder < y.matchOrder) {
                  return -1;
                }
                if (x.matchOrder > y.matchOrder) {
                  return 1;
                }
                return 0;
              });
              $scope.queLen = $scope.questions.length;

              MyService.ConsoleLog("This is length ::", $scope.queLen);

              if (
                $scope.UserId &&
                $scope.UserId != "" &&
                tokenService.getUserRole() == "politician"
              ) {
                MyService.ConsoleLog(
                  "tokenService.getUserRole()",
                  tokenService.getUserRole()
                );
              } else {
                $scope.flagSkipAnsweredQuestion = true;
              }

              var ansQuestion = $scope.checkQuestionAnswered();
              MyService.ConsoleLog(
                "ansQuestion >> ",
                ansQuestion.length + "   " + $scope.queLen
              );
              if (ansQuestion.length != $scope.queLen) {
                $scope.skipAnswerChagne();
              } else if (ansQuestion.length >= 5) {
                var ansArr = [];
                $scope.questions.filter(function (itm) {
                  var isAns = $scope.checkQuestion(itm._id);
                  // MyService.ConsoleLog("itm", itm);
                  MyService.ConsoleLog("isAns >> ", isAns);
                  if (isAns && isAns.length > 0) {
                    var smlObj = {};
                    smlObj = isAns[0];
                    smlObj.questionId = itm._id;
                    smlObj.categories = itm.categories;
                    smlObj.content = itm.content;
                    smlObj.matchOrder = itm.matchOrder;
                    ansArr.push(smlObj);
                  }
                });
                $rootScope.fiveMatch = angular.copy(ansArr);
                window.localStorage.setItem(
                  "fiveMatch",
                  JSON.stringify($rootScope.fiveMatch)
                );
                $("#skipMatch").attr("disabled", false);
                if (ansQuestion.length == $scope.queLen) {
                  $scope.skipAnswerChagne();
                }
              }
            } else {
              alert("Something went wrong. Please try after some time");
              $location.path("/welcome");
            }
          },
          function (errpayload) {
            alert("Something went wrong. Please try after some time");
            $location.path("/welcome");
          }
        );
      };

      $scope.skipQuestion = function () {
        MyService.ConsoleLog("* skipQuestion *");
        var skip = function () {
          // MyService.ConsoleLog("skip");
          var data = $scope.checkQuestion(
            $scope.questions[$scope.currentIndex]._id
          );

          if (data && data[0]) {
            MyService.ConsoleLog("getMatchQUestions >>> ", data[0]);
            if (data[0].answer && data[0].answer != "") {
              $scope.answer = data[0].answer;
            }
            if (data[0].importance && data[0].importance != "") {
              $scope.importance = data[0].importance;
            }
            if (data[0].comment && data[0].comment != "") {
              $scope.updata.comment = data[0].comment;
            }
          }
          // $scope.dis=false;
          // MyService.ConsoleLog("answer : ", $scope.answer);
          if ($scope.answer && $scope.answer != "") {
            var postData = {
              questionId: $scope.questions[$scope.currentIndex]._id,
              importance: $scope.importance,
              answer: $scope.answer,
              comment: $scope.updata.comment,
              categories: $scope.questions[$scope.currentIndex]["categories"],
              content: $scope.questions[$scope.currentIndex]["content"],
            };
            // console.log("postData >> ", postData);
            // return;
            if (
              $scope.answer &&
              $scope.answer != "" &&
              $scope.importance &&
              $scope.importance != ""
            ) {
              $scope.postAnswer(postData, "skip");
            } else {
              postData.answer = 0;
              postData.importance = 0;
              $rootScope.fiveMatch.push(postData);
            }

            //
          } else {
            var pData = {
              questionId: $scope.questions[$scope.currentIndex]._id,
              importance: 0,
              answer: 0,
              comment: $scope.updata.comment,
              categories: $scope.questions[$scope.currentIndex]["categories"],
              content: $scope.questions[$scope.currentIndex]["content"],
              matchOrder: $scope.questions[$scope.currentIndex].matchOrder,
              // postData._id = $scope.questions[$scope.currentIndex]["_id"];
            };
            $rootScope.fiveMatch.push(pData);
            if (!$scope.UserId) {
              $rootScope.guestUserData.push(pData);
              window.localStorage.setItem(
                "fiveMatch",
                JSON.stringify($rootScope.guestUserData)
              );
            } else {
              window.localStorage.setItem(
                "fiveMatch",
                JSON.stringify($rootScope.fiveMatch)
              );
            }
          }

          MyService.ConsoleLog(
            "<< $rootScope.fiveMatch >> ",
            $rootScope.fiveMatch
          );
          // console.log($("#DisplayQ1").offset());
          $("html, body").animate(
            {
              scrollTop: $("#DisplayQ1").offset().top - 80,
            },
            "slow"
          );

          var tempIndex = $scope.currentIndex + 1;
          if (tempIndex < $scope.questions.length) {
            $scope.initializeVariables();
            $scope.currentIndex++;
          } else {
            MyService.ConsoleLog("final question : " + $scope.questions.length);
            $scope.fiveMinuteMatchDone();
          }
          /*
        $timeout(function() {
          $location.hash('DisplayQ');
          $anchorScroll();
        }, 100);
        */
        };

        MyService.ConsoleLog("skip answer<><><><<>", $scope.answer);
        if ($scope.answer != null) {
          var show_answer_modal = true;
          try {
            var my_answer = $scope.questions[$scope.currentIndex]["my_answer"];

            /*for (var key in my_answer) {
            if(my_answer[])
          }*/
            if (
              my_answer.importance == $scope.importance &&
              my_answer.answer == $scope.answer &&
              my_answer.comment == $scope.updata.comment
            )
              show_answer_modal = false;
          } catch (e) {
            //MyService.ConsoleLog("Exceptoin : ", e);
          }
          // MyService.ConsoleLog("show_answer_modal: ", show_answer_modal);
          if (show_answer_modal) {
            var message =
              "You just hit the SKIP button.  Are you sure you want to skip this one, or would you rather Submit your answer?";
            var modal = ngDialog.openConfirm({
              template:
                "<p>" +
                message +
                '</p>\
              <div class="ngdialog-buttons">\
                  <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">Skip</button>\
                  <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Submit</button>\
              </div>',
              plain: true,
              closeByDocument: false,
            });

            modal.then(
              function fullfilled(data) {
                //submit answer
                if (data == 0) {
                  skip();
                } else {
                  $scope.submitAnswer();
                }
              },
              function rejected(data) {
                //skip the answer
                skip();
              }
            );
          } else {
            skip();
          }
        } else {
          skip();
        }
      };

      // Commented by vishal on 1st November

      // $scope.prevQuestion = function() {
      //   MyService.ConsoleLog("** prevQuestion **");

      //   if ($scope.currentIndex > 0) {
      //     $("html, body").animate({
      //       scrollTop: 0
      //     }, "slow");
      //     $scope.currentIndex--;
      //     if ($scope.digDeeperMatch != true) {
      //       if (window.localStorage.getItem("fiveMinMatch")) {
      //         //MyService.ConsoleLog("here");
      //         $scope.getFiveMinData = [];
      //         $scope.getFiveMinData.length = 0;
      //         if ($scope.flagSkipAnsweredQuestion) {
      //           $scope.getFiveMinData = $scope.cachedQuestions;
      //         } else {
      //           $scope.getFiveMinData = JSON.parse(window.localStorage.getItem("fiveMinMatch"));
      //         }

      //         //MyService.ConsoleLog("Data : ", $scope.getFiveMinData);
      //         for (var i = 0; i < $scope.getFiveMinData.length; i++) {
      //           MyService.ConsoleLog("for i : " + i + " currentIndex : " + $scope.currentIndex);
      //           if (i == $scope.currentIndex) {
      //             MyService.ConsoleLog("index matched", $scope.getFiveMinData[i]);
      //             // $scope.answer = $scope.getFiveMinData[i].answer;
      //             // $scope.importance = $scope.getFiveMinData[i].importance;
      //             // $scope.comment = $scope.getFiveMinData[i].comment;
      //             // $timeout(function() {
      //             //   $scope.$apply();
      //             // });

      //           }
      //         }
      //       }
      //     }
      //     /*
      //     $timeout(function() {
      //       $location.hash('DisplayQ');
      //       $anchorScroll();
      //       $scope.$apply();
      //     }, 100);
      //     */
      //   } else if ($scope.currentIndex == 0) {
      //     if ($scope.currBackgroundIndex > 0) {
      //       $scope.currBackgroundIndex--;
      //       $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
      //     }
      //   }
      // };

      //  prevQuestions
      $scope.prevQuestion = function () {
        MyService.ConsoleLog("** prevQuestion **");

        if ($scope.currentIndex > 0) {
          $("html, body").animate(
            {
              scrollTop: $("#DisplayQ1").offset().top - 80,
            },
            "slow"
          );
          $scope.currentIndex--;
          // console.log("Current <><>,", $scope.currentIndex);
          $scope.updata.comment = "";
          // console.log("C digDeeper : ",$scope.digDeeperMatch);
          if ($scope.digDeeperMatch != true) {
            // console.log("digDeeper");
            // console.log(window.localStorage.getItem("fiveMatch"));
            if (window.localStorage.getItem("fiveMatch")) {
              // MyService.ConsoleLog("here");
              $scope.getFiveMinData = [];
              $scope.getFiveMinData.length = 0;
              if ($scope.flagSkipAnsweredQuestion) {
                // console.log("IF <> ", $scope.flagSkipAnsweredQuestion, $scope.cachedQuestions);

                $scope.getFiveMinData = $scope.cachedQuestions;
              } else {
                console.log("Else ");
                $scope.getFiveMinData = JSON.parse(
                  window.localStorage.getItem("fiveMatch")
                );
              }

              // MyService.ConsoleLog("Data : ", $scope.getFiveMinData);
              var ansLen = $scope.getFiveMinData.length;
              for (var i = 0; i < ansLen; i++) {
                MyService.ConsoleLog(
                  "for i : " + i + " currentIndex : " + $scope.currentIndex
                );

                if (i == $scope.currentIndex) {
                  MyService.ConsoleLog(
                    "index matched",
                    $scope.getFiveMinData[i]
                  );
                  $scope.answer = $scope.getFiveMinData[i].answer;
                  $scope.importance = $scope.getFiveMinData[i].importance;
                  $scope.comment = $scope.getFiveMinData[i].comment;
                  $scope.updata.comment = $scope.getFiveMinData[i].comment;
                  // $timeout(function() {
                  //   $scope.$apply();
                  // });
                }
              }
            }
          }
          /*
        $timeout(function() {
          $location.hash('DisplayQ');
          $anchorScroll();
          $scope.$apply();
        }, 100);
        */
        } else if ($scope.currentIndex == 0) {
          if ($scope.currBackgroundIndex > 0) {
            $scope.currBackgroundIndex--;
            $scope.category =
              $scope.traverseBackgrounds[$scope.currBackgroundIndex];
          }
        }
      };

      // Zip code
      $scope.oldaddress = {
        state: "",
        county: "",
        countySubdivision: "",
        place: "",
      };

      $scope.address = {
        state: "",
        county: "",
        countySubdivision: "",
        place: "",
      };
      $scope.showZipLoader = false;
      $scope.showAddressDropDown = false;

      $scope.AllAnsweredQuestions = [];
      $scope.getAllAnsweredQuestions = function (userId) {
        MyService.getAllAnsweredQuestions({
          authorId: userId,
        }).then(
          function (payload) {
            // MyService.ConsoleLog("getAllAnsweredQuestions >> ", payload)
            if (payload.data.success) {
              $scope.AllAnsweredQuestions = payload.data.data;
              $scope.getMatchQUestions();
            }
          },
          function (errpayload) {
            MyService.ConsoleLog(
              "getAllAnsweredQuestions errpayload >> ",
              errpayload
            );
          }
        );
      };

      $scope.getAllStates = function () {
        if ($scope.counties) {
          $scope.counties.length = 0;
        }
        if ($scope.places) {
          $scope.places.length = 0;
        }

        var request = apiCall.apiCall("GET", "/user/getAllStates", {
          country: "",
        });
        $http(request).then(
          function successCallback(response) {
            MyService.ConsoleLog("Got States: ", response);
            if (response.data.success) {
              $scope.states = response.data.data;
            } else {
              growl.error("Something went wrong.");
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
            growl.error("Something went wrong.");
          }
        );
      };

      if ($scope.UserId && $scope.UserId != "") {
        $scope.getAllAnsweredQuestions($scope.UserId);
      } else {
        $scope.getAllStates();
        $scope.getMatchQUestions();
      }

      $scope.checkState = function (rdata, val) {
        // MyService.ConsoleLog(rdata);
        return rdata.filter(function (rdata) {
          //MyService.ConsoleLog(rdata.statePostalCode + "==" + val);
          if (rdata.statePostalCode == val) return rdata;
        });
      };

      $scope.checkState = function (rdata, val) {
        // MyService.ConsoleLog("State :", rdata);
        // MyService.ConsoleLog("State val :", val);
        var sdata = [];
        var len = rdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = rdata[i];
          var gdata = val.filter(function (obj) {
            if (
              rsdata.countyFips == obj.COUNTYFP &&
              rsdata.stateFips == obj.STATEFP
            ) {
              // MyService.ConsoleLog(rdata[i]);
              return rdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(rdata[i]) == -1) {
              sdata.push(rdata[i]);
            }
          }

          if (j == len) {
            // MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };

      $scope.checkCounty = function (rdata, val) {
        MyService.ConsoleLog("County :", rdata);
        MyService.ConsoleLog("County val :", val);
        var sdata = [];
        var len = rdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = rdata[i];
          var gdata = val.filter(function (obj) {
            if (
              rsdata.countyFips == obj.COUNTYFP &&
              rsdata.stateFips == obj.STATEFP
            ) {
              // MyService.ConsoleLog(rdata[i]);
              return rdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(rdata[i]) == -1) {
              sdata.push(rdata[i]);
            }
          }

          if (j == len) {
            // MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };
      $scope.checksubCounty = function (rdata, val) {
        var sdata = [];
        var len = rdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = rdata[i];
          var gdata = val.filter(function (obj) {
            if (rsdata.countySubdivision == obj.NAME) {
              // MyService.ConsoleLog(rdata[i]);
              return rdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(rdata[i]) == -1) {
              sdata.push(rdata[i]);
            }
          }

          if (j == len) {
            // MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };
      $scope.checkPlaces = function (prdata, val) {
        var sdata = [];
        var len = prdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = prdata[i];
          var gdata = val.filter(function (obj) {
            // MyService.ConsoleLog(rsdata.place +"=="+ obj.NAME);
            if (rsdata.place == obj.NAME && !rsdata.countyFips) {
              // MyService.ConsoleLog(rdata[i]);
              return prdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(prdata[i]) == -1) {
              sdata.push(prdata[i]);
            }
          }

          if (j == len) {
            // MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };
      var getCountiesCanceler = $q.defer();

      $scope.allcounties = [];
      $scope.getCounties = function (lbl) {
        // MyService.ConsoleLog("county >", $scope.Location.state);
        // $scope.allcounties.length = 0;
        var statePostalCode = "";
        var state = "";
        if (lbl == "new") {
          state = JSON.stringify($scope.oldaddress.state);
        } else {
          statePostalCode = $scope.Location.state.statePostalCode;
          state = $scope.Location.state;
        }
        if (!statePostalCode) {
          statePostalCode = $scope.stateFips;
          MyService.ConsoleLog("StatePostal Code in IF", statePostalCode);
        }
        // MyService.ConsoleLog(statePostalCode + "<><><><>>" + state);
        MyService.getAllCounties(statePostalCode, state).then(
          function (payload) {
            // MyService.ConsoleLog("sublocations Locals : ", payload);
            var allcounties = payload;
            if (lbl == "new") {
              var county = $scope.checkCounty(
                allcounties,
                $scope.oldaddress.county
              );
              $scope.allcounties = county;
              // MyService.ConsoleLog("county<><", county);
              $scope.address.county = county[0];
            }
          },
          function (errorPayload) {
            growl.error("Something went wrong.");
          }
        );
      };
      $scope.MyPlaces = [];
      $scope.getSubCounties = function (lbl) {
        //MyService.ConsoleLog($scope.Location.state);
        //MyService.ConsoleLog($scope.Location.county);
        // var county = $scope.Location.county;

        $scope.MyPlaces.length = 0;
        var county = "";
        var statePostalCode = "";
        $scope.MyPlaces.length = 0;
        var state = "";
        var county = "";
        if (lbl == "new") {
          state = JSON.stringify($scope.oldaddress.state);
          county = JSON.stringify($scope.oldaddress.county);
        } else {
          statePostalCode = $scope.Location.state.statePostalCode;
          state = $scope.Location.state;
          county = county.county;
        }
        // MyService.ConsoleLog(statePostalCode + "===" + county);
        MyService.getAllSubCountiesLocal(statePostalCode, state, county).then(
          function (payload) {
            // payload = JSON.parse(payload);
            $scope.MyPlaces = payload;
            // MyService.ConsoleLog("PlaCE :", payload);
            // MyService.ConsoleLog(payload.countySubdivision);
            var subcounties = payload.countySubdivision;
            var places = payload.places;
            // MyService.ConsoleLog("PlaCE :", payload);
            if (lbl == "new") {
              // MyService.ConsoleLog("Places 1 > ",$scope.oldaddress.place);
              var subcounty = $scope.checksubCounty(
                subcounties,
                $scope.oldaddress.countySubdivision
              );
              var places = $scope.checkPlaces(places, $scope.oldaddress.place);
              // MyService.ConsoleLog("subcounty<><><", subcounty);
              // $scope.subcounties = subcounty;
              $scope.places = places;
              // console.log('***********', $scope.places);
              // $scope.Location.countySubdivision = subcounty[0];
              $scope.address.place = places[0];
            }
          },
          function (errorPayload) {
            growl.error("Something went wrong.");
          }
        );
      };

      var getLocalsCanceler = $q.defer();
      $scope.getLocals = function (lbl) {
        // MyService.ConsoleLog($scope.oldaddress);
        var state = {},
          county = {};

        if (lbl == "cur") {
          state = $scope.User.cur_state;
          county = JSON.parse($scope.User.cur_county);
        } else if (lbl == "new") {
          state.statePostalCode = $scope.oldaddress.state;
          county.county = $scope.oldaddress.county;
        } else {
          state = JSON.parse($scope.User.sel_state);
          county = JSON.parse($scope.User.sel_county);
        }

        //MyService.ConsoleLog("county : ", county);
        getLocalsCanceler.resolve();

        var request = apiCall.apiCall("GET", "/user/getAllSubCountiesLocal", {
          statePostalCode: state.statePostalCode,
          county: county.county,
          timeout: getLocalsCanceler.promise,
        });
        $http(request).then(
          function successCallback(response) {
            if (response.data.success) {
              if (response.data.data) {
                // MyService.ConsoleLog(response.data.data);
                $scope.places = response.data.data;

                if (lbl == "new") {
                  var subcounty = $scope.checksubCounty(
                    $scope.places,
                    $scope.oldaddress.countySubdivision
                  );

                  var places = $scope.checkPlaces(
                    $scope.places,
                    $scope.oldaddress.place
                  );
                  // MyService.ConsoleLog("subcounty<><><", subcounty[0])
                  $scope.address.countySubdivision = subcounty[0];
                  $scope.address.place = places[0];
                }
              }
            } else {
              growl("Something went wrong.");
            }
          },
          function errorCallBack(response) {
            growl("Something went wrong.");
          }
        );
      };
      $scope.User = {
        ZipCode: "",
      };
      $scope.detectCode = function (event) {
        if (event.keyCode == 9 && event.key == "Tab") {
          $scope.showAddressDropDowns($scope.User.ZipCode);
        }
        if (event.keyCode == 13 && event.key == "Enter") {
          $scope.showAddressDropDowns($scope.User.ZipCode);
        }
      };

      $scope.checkLength = function (vdata, val) {
        MyService.ConsoleLog(" vdata :", vdata);
        // MyService.ConsoleLog(" val :",val);

        var data = vdata.map(function (sub) {
          var returnval = "";
          switch (val) {
            case "federalCongrassionalDist":
              returnval = sub.CD115FP;
              break;
            case "stateSenateDistrict":
              returnval = sub.SLDUST;
              break;
            case "stateHouseOFRepresentativeDistrict":
              returnval = sub.NAMELSAD;
              break;
            case "unifiedSchoolDistrictName":
              returnval = sub.NAME;
              break;
            case "default":
              returnval = sub.NAME;
              break;
          }
          return returnval;
        });

        var ndata = $filter("unique")(data);
        if (ndata.length > 1) {
          return "yellowBackground";
        } else {
          return "";
        }
      };

      // for autocomplete address

      var options = {
        componentRestrictions: {
          country: "us",
        },
        types: ["geocode"],
      };

      $scope.detectAddress = function (ent) {
        var val = document.getElementById("address");
        // console.log($scope.User.Address);
        var autocomplete = new google.maps.places.Autocomplete(val, options);

        google.maps.event.addListener(
          autocomplete,
          "place_changed",
          function () {
            var place = autocomplete.getPlace();

            var lat = place.geometry.location.lat(),
              lng = place.geometry.location.lng();

            $scope.lati = lat.toFixed(6);
            $scope.lon = lng.toFixed(6);
            // console.log($scope.lati);
            // console.log($scope.lon);

            $scope.mailing_Address = place.formatted_address;
            window.localStorage.setItem(
              "mailingAddress",
              $scope.mailing_Address
            );
            // MyService.ConsoleLog("Main addd :", place.address_components);
            for (var i = 0; i < place.address_components.length; i++) {
              for (
                var j = 0;
                j < place.address_components[i].types.length;
                j++
              ) {
                if (
                  place.address_components[i].types[j] ==
                  "administrative_area_level_1"
                ) {
                  $scope.statePostalCode =
                    place.address_components[i].short_name;
                  // console.log($scope.statePostalCode);
                }
                if (place.address_components[i].types[j] == "country") {
                  $scope.countryname = place.address_components[i].long_name;
                  // console.log($scope.countryname);
                }
                if (
                  place.address_components[i].types[j] ==
                  "administrative_area_level_2"
                ) {
                  $scope.county_name = place.address_components[i].long_name;
                  // console.log($scope.county_name);
                }
                if (place.address_components[i].types[j] == "locality") {
                  $scope.place_name = place.address_components[i].long_name;
                  // console.log($scope.place_name);
                }
                if (place.address_components[i].types[j] == "postal_code") {
                  // document.getElementById('zip').value = place.address_components[i].long_name;
                  if (
                    place.address_components[i].long_name &&
                    place.address_components[i].long_name != ""
                  ) {
                    $scope.User.ZipCode = place.address_components[i].long_name;
                    // console.log($scope.User.ZipCode);
                  }
                  // console.log($scope.User.ZipCode);
                }
              }
            }

            console.log("$scope.User.ZipCode :", $scope.User.ZipCode);

            var loc = JSON.stringify({
              longitude: $scope.lon,
              latitude: $scope.lati,
            });
            // console.log(loc);
            // $rootScope.location = new Array;
            $rootScope.location = {
              longitude: $scope.lon,
              latitude: $scope.lati,
            };
            $scope.showAddressDropDowns("", loc);
          }
        );
      };

      // End for autocomplete address

      $scope.mainAddress = "";

      $scope.showAddressDropDowns = function (zipcode, loc) {
        if (loc && loc != "") {
          MyService.ConsoleLog("showAddressDropDowns" + zipcode);
          MyService.ConsoleLog("MyLocation : >>>." + loc);

          $scope.showZipLoader = true;
          MyService.getOrganizedZipData({
            candidate: true,
            loc: loc,
          }).then(
            function (payload) {
              MyService.ConsoleLog(" showAddressDropDowns ", payload);
              if (payload && payload != "") {
                // var finalData = payload.data;
                // MyService.ConsoleLog(payload[0].countySubdivision);
                // MyService.ConsoleLog(payload[0].county);
                // MyService.ConsoleLog(payload[0].place);
                var countySubdivisions = payload.places.filter(function (obj) {
                  if (obj.COUSUBFP && obj.COUSUBFP != "") {
                    // MyService.ConsoleLog("Inside cs");
                    return obj;
                  }
                });
                var places = payload.places.filter(function (obj) {
                  if (obj.PLACEFP && obj.PLACEFP != "") {
                    // MyService.ConsoleLog("obj > ", obj);
                    return obj;
                  }
                });
                MyService.ConsoleLog(
                  " showAddressDropDowns <><><><><><><><><><><><><> "
                );

                $scope.mainAddress = payload;
                $scope.showZipLoader = false;
                $scope.showAddressDropDown = true;
                $scope.oldaddress.state = payload.state;
                $scope.oldaddress.county = payload.county;
                $scope.stateFips = payload.state[0].STATEFP;
                MyService.ConsoleLog("ALLLLLLLLLLL", $scope.stateFips);
                // MyService.ConsoleLog("countySubdivisions >> ", countySubdivisions);
                $scope.oldaddress.countySubdivision = countySubdivisions;
                // MyService.ConsoleLog("places >>> ",places);
                $scope.countyName = payload.county;
                $scope.placeName = payload.places;
                MyService.ConsoleLog("$scope.placename", $scope.placeName);
                MyService.ConsoleLog("$scope.countyName", $scope.countyName);
                $scope.oldaddress.place = places;
                $scope.getCounties("new");

                $scope.getSubCounties("new");

                // $scope.voterDistricts = payload;
                // MyService.ConsoleLog(payload.congressionalDistrict);
                $scope.federalCongrassionalDist = payload.congressionalDistrict;
                MyService.ConsoleLog(
                  "@@@@@@ drop :",
                  $scope.federalCongrassionalDist
                );

                $scope.stateSenateDistrict = payload.stateSenateDistrict;
                $scope.stateHouseOFRepresentativeDistricts =
                  payload.stateHouseofRepresentativesDistrict;
                $scope.unifiedSchoolDistrictNames =
                  payload.unifiedSchoolDistrict;
                $scope.cityCouncilDistrict = payload.cityCouncilDistrict;
                //$scope.$apply();
                // MyService.ConsoleLog($scope.states);
                // MyService.ConsoleLog(payload[0].statePostalCode);
                var address = $scope.checkState($scope.states, payload.state);
                MyService.ConsoleLog("address : ", address[0]);

                $scope.address.state = address[0];
                // $scope.address.voterDistrict = $scope.voterDistricts[0];
                $scope.address.federalCongrassionalDist =
                  $scope.federalCongrassionalDist[0];
                $scope.address.stateSenateDistrict =
                  $scope.stateSenateDistrict[0];
                $scope.address.stateHouseOFRepresentativeDistrict =
                  $scope.stateHouseOFRepresentativeDistricts[0];
                $scope.address.unifiedSchoolDistrictName =
                  $scope.unifiedSchoolDistrictNames[0];
                $scope.address.cityCouncilDistrict = $scope.cityCouncilDistrict
                  ? $scope.cityCouncilDistrict[0]
                  : [];
                // MyService.ConsoleLog("address ; ", address);
                MyService.ConsoleLog(
                  "<><><><><<><><>>>>>>. zip code >>>>>>>>>>>>>>>>>",
                  $scope.User.ZipCode
                );
                $timeout(function () {
                  $rootScope.tempUserZip = $scope.User.ZipCode;
                  $rootScope.tempUserAddress = $scope.address;
                  MyService.ConsoleLog(
                    " temp : >>>>>>>>>>>>>>>>>>>>>>>>>>>",
                    $rootScope.tempUserAddress
                  );
                  window.localStorage.setItem(
                    "tempUserZip",
                    $rootScope.tempUserZip
                  );
                  window.localStorage.setItem(
                    "tempUserAddress",
                    JSON.stringify($rootScope.tempUserAddress)
                  );
                  // MyService.ConsoleLog("address : ", address);
                  // MyService.ConsoleLog("rootscope address : ", $rootScope.tempUserAddress);
                }, 100);
              }
            },
            function (errorPayload) {
              $scope.showZipLoader = false;
              growl.error(errorPayload);
            }
          );
        }

        // else {

        //   MyService.ConsoleLog("showAddressDropDowns" + zipcode);
        //   $scope.showZipLoader = true;
        //   MyService.getOrganizedZipData({
        //     "zipcode": zipcode,
        //     "candidate": true,
        //     "loc": loc
        //   }).then(function(payload) {
        //     MyService.ConsoleLog(" showAddressDropDowns ", payload);
        //     if (payload && payload != "") {
        //       // var finalData = payload.data;
        //       // MyService.ConsoleLog(payload[0].countySubdivision);
        //       // MyService.ConsoleLog(payload[0].county);
        //       // MyService.ConsoleLog(payload[0].place);
        //       var countySubdivisions = payload.places.filter(function(obj) {
        //         if (obj.COUSUBFP && obj.COUSUBFP != "") {
        //           // MyService.ConsoleLog("Inside cs");
        //           return obj;
        //         }
        //       });
        //       var places = payload.places.filter(function(obj) {
        //         if (obj.PLACEFP && obj.PLACEFP != "") {
        //           // MyService.ConsoleLog("obj > ", obj);
        //           return obj;
        //         }
        //       });
        //       MyService.ConsoleLog(" showAddressDropDowns <><><><><><><><><><><><><> ");

        //       $scope.mainAddress = payload;
        //       $scope.showZipLoader = false;
        //       $scope.showAddressDropDown = true;
        //       $scope.oldaddress.state = payload.state;
        //       $scope.oldaddress.county = payload.county;
        //       // MyService.ConsoleLog("countySubdivisions >> ", countySubdivisions);
        //       $scope.oldaddress.countySubdivision = countySubdivisions;
        //       // MyService.ConsoleLog("places >>> ",places);
        //       $scope.oldaddress.place = places;
        //       $scope.getCounties("new");

        //       $scope.getSubCounties("new");

        //       // $scope.voterDistricts = payload;
        //       // MyService.ConsoleLog(payload.congressionalDistrict);
        //       $scope.federalCongrassionalDist = payload.congressionalDistrict;
        //       MyService.ConsoleLog("@@@@@@ drop :", $scope.federalCongrassionalDist);

        //       $scope.stateSenateDistrict = payload.stateSenateDistrict;
        //       $scope.stateHouseOFRepresentativeDistricts =
        //         payload.stateHouseofRepresentativesDistrict;
        //       $scope.unifiedSchoolDistrictNames = payload.unifiedSchoolDistrict;
        //       //$scope.$apply();
        //       // MyService.ConsoleLog($scope.states);
        //       // MyService.ConsoleLog(payload[0].statePostalCode);
        //       var address = $scope.checkState($scope.states, payload.state);
        //       MyService.ConsoleLog("address : ", address);
        //       $scope.address.state = address[0];
        //       // $scope.address.voterDistrict = $scope.voterDistricts[0];
        //       $scope.address.federalCongrassionalDist = $scope.federalCongrassionalDist[0];
        //       $scope.address.stateSenateDistrict = $scope.stateSenateDistrict[0];
        //       $scope.address.stateHouseOFRepresentativeDistrict = $scope.stateHouseOFRepresentativeDistricts[0];
        //       $scope.address.unifiedSchoolDistrictName = $scope.unifiedSchoolDistrictNames[0];
        //       // MyService.ConsoleLog("address ; ", address);
        //       MyService.ConsoleLog("<><><><><<><><>>>>>>. zip code >>>>>>>>>>>>>>>>>", $scope.User.ZipCode);
        //       $timeout(function() {
        //         $rootScope.tempUserZip = $scope.User.ZipCode;
        //         $rootScope.tempUserAddress = $scope.address;
        //         MyService.ConsoleLog(" temp : >>>>>>>>>>>>>>>>>>>>>>>>>>>", $rootScope.tempUserAddress);
        //         window.localStorage.setItem("tempUserZip", $rootScope.tempUserZip);
        //         window.localStorage.setItem("tempUserAddress", JSON.stringify($rootScope.tempUserAddress));
        //         // MyService.ConsoleLog("address : ", address);
        //         // MyService.ConsoleLog("rootscope address : ", $rootScope.tempUserAddress);
        //       }, 100);
        //     }

        //   }, function(errorPayload) {
        //     $scope.showZipLoader = false;
        //     growl.error(errorPayload);
        //   });
        // }
      };

      $scope.saveUserAnswers = function () {
        console.log("address>>>", $scope.address);
        $rootScope.tempUserAddress = $scope.address;
        MyService.ConsoleLog(
          " temp : >>>>>>>>>>>>>>>>>>>>>>>>>>>",
          $rootScope.tempUserAddress
        );
        window.localStorage.setItem("tempUserZip", $rootScope.tempUserZip);
        window.localStorage.setItem(
          "tempUserAddress",
          JSON.stringify($rootScope.tempUserAddress)
        );
        $location.path("/fiveSaveUser");
      };

      $scope.eraseUserAnswers = function () {
        MyService.ConsoleLog("eraseUserAnswers");
        MyService.ConsoleLog(window.localStorage.getItem("fiveMatch"));
        $location.path("/fiveCompare");
      };

      $scope.showDigDeeperLoader = false;

      $scope.goBack = function () {
        $scope.initializeVariables();
        $scope.questions = angular.copy($scope.oldQuestions);
        $scope.currentIndex = angular.copy($scope.oldIndex);
        $scope.oldQuestions.length = 0;
        $scope.oldIndex = 0;
      };

      var getCategoryCanceler = $q.defer();
      $scope.digDeeper = function () {
        var catID = $scope.questions[$scope.currentIndex].categories[0].cid;
        //  MyService.ConsoleLog("catID<><>",catID);
        // MyService.ConsoleLog($scope.questions);
        // MyService.ConsoleLog("catNewID<><><>",$scope.questions[$scope.currentIndex].categories[0].cid);
        $scope.showDigDeeperLoader = true;

        //MyService.ConsoleLog("scrollTop");
        $("html, body").animate(
          {
            scrollTop: 0,
          },
          "slow"
        );
        getCategoryCanceler.resolve();
        getCategoryCanceler = $q.defer();

        var request = apiCall.apiCall("GET", "/categories/list", {
          id: catID,
        });
        request.timeout = getCategoryCanceler.promise;
        $http(request).then(
          function successCallback(response) {
            //MyService.ConsoleLog("Got categories: ",response);
            if (response.data.success) {
              $scope.category = response.data.data;
              MyService.ConsoleLog("category data: ", $scope.category);
              MyService.digDeepperQuestions({
                catId: catID,
              }).then(
                function (payload) {
                  $scope.showDigDeeperLoader = false;
                  if (payload.data.success) {
                    $scope.oldQuestions = angular.copy($scope.questions);
                    $scope.oldIndex = angular.copy($scope.currentIndex);
                    $scope.questions = payload.data.data;
                    $scope.currentIndex = 0;
                    $scope.digDeeperMatch = true;
                    MyService.ConsoleLog($scope.questions);
                  } else {
                    alert("Something went wrong. Please try after some time");
                    // $location.path("/welcome");
                  }
                  // MyService.ConsoleLog(payload);
                },
                function (errorPayload) {
                  $scope.showDigDeeperLoader = false;
                  // MyService.ConsoleLog(errorPayload);
                }
              );
            } else {
              //MyService.ConsoleLog("Something went wrong: ", response.data);
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
            $scope.status.category = 3;
          }
        );
      };

      // Mellisa data start //
      $scope.findaddress = {
        address: "",
        city: "",
        state: "",
        zipcode: "",
      };
      $scope.result = {
        city: "",
      };
      $scope.showFindAddress = function () {
        var q = {
          zipcode: $scope.User.ZipCode,
        };
        var addressModal = ngDialog.open({
          template: "app/popups/mellisa_data.html",
          scope: $scope,
          data: q,
        });
        $scope.findaddress.zipcode = $scope.User.ZipCode;
      };

      $scope.finddetailsclicked = false;
      $scope.getDetails = function (records) {
        var error = "";
        if ($scope.findaddress.address == "") {
          error = "Please enter address";
        }
        if (error == "" && $scope.findaddress.city == "") {
          error = "Please enter city";
        }
        if (error == "" && $scope.findaddress.state == "") {
          error = "Please enter state";
        }
        if (error == "" && $scope.findaddress.zipcode == "") {
          error = "Please enter zipcode";
        }

        if (error == "") {
          $scope.finddetailsclicked = true;
          // MyService.ConsoleLog("=============Address==============");
          // MyService.ConsoleLog($scope.findaddress);
          // MyService.ConsoleLog("findaddress<><><>", records);
          var aurl =
            "https://personator.melissadata.net/v3/WEB/ContactVerify/doContactVerify";
          aurl += "?id=RyMI8jlzD6dHUApvp_3XRP**";
          aurl += "&cols=GrpCensus,GrpCensus2,GrpGeocode";
          aurl += "&a1=" + records.address;
          aurl += "&city=" + records.city;
          aurl += "&state=" + records.state;
          aurl += "&postal=" + records.zipcode;
          aurl += "&ctry=US";
          aurl += "&format=JSON";
          // var deferred = $q.defer();
          //var furl = "https://personator.melissadata.net/v3/WEB/ContactVerify/doContactVerify?id=RyMI8jlzD6dHUApvp_3XRP**&cols=GrpCensus,GrpCensus2,GrpGeocode&a1=" + records.address + "&city=" + records.city + "&state=" + records.state + "&postal=" + records.zipcode + "&ctry=US&format=JSON";
          // MyService.ConsoleLog("furl <><>>", furl);
          $http.get(aurl).then(
            function successCallback(response) {
              //$scope.result = "";
              $scope.finddetailsclicked = false;
              if (response.statusText == "OK") {
                var rdata = response.data.Records[0];
                if (rdata) {
                  $scope.result = rdata;
                }
              }
              // MyService.ConsoleLog("response", response);
            },
            function errorCallBack(error) {
              $scope.finddetailsclicked = false;
              // MyService.ConsoleLog(error);
            }
          );
        } else {
          alert(error);
        }
      };
      // $scope.oldAddress = "";
      $scope.checkZipAddress = function (val) {
        // $scope.oldAddress = angular.copy($scope.mainAddress);
        return $scope.mainAddress.filter(function (rdata) {
          // MyService.ConsoleLog("Space:", parseInt(val.CongressionalDistrict));
          if (
            val.CongressionalDistrict == "" ||
            val.CongressionalDistrict == " "
          ) {
            // MyService.ConsoleLog("inside<><><><><>");

            if (
              parseInt(rdata.FIPScounty) == parseInt(val.CountyFIPS) &&
              parseInt(rdata.FIPScountySub) ==
                parseInt(val.CountySubdivisionCode) &&
              parseInt(rdata.stateHouseOFRepresentativeDistrict) ==
                parseInt(val.StateDistrictLower) &&
              parseInt(rdata.stateSenateDistrict) ==
                parseInt(val.StateDistrictUpper) &&
              parseInt(rdata.unifiedSchoolDistrict) ==
                parseInt(val.UnifiedSchoolDistrictCode)
            ) {
              // MyService.ConsoleLog("This is a match");
              return rdata;
            }
          } else {
            if (
              parseInt(rdata.FIPScounty) == parseInt(val.CountyFIPS) &&
              parseInt(rdata.FIPScountySub) ==
                parseInt(val.CountySubdivisionCode) &&
              parseInt(rdata.federalCongrassionalDist) ==
                parseInt(val.CongressionalDistrict) &&
              parseInt(rdata.stateHouseOFRepresentativeDistrict) ==
                parseInt(val.StateDistrictLower) &&
              parseInt(rdata.stateSenateDistrict) ==
                parseInt(val.StateDistrictUpper) &&
              parseInt(rdata.unifiedSchoolDistrict) ==
                parseInt(val.UnifiedSchoolDistrictCode)
            ) {
              // MyService.ConsoleLog("This is a match2");
              return rdata;
            }
          }
        });
      };

      $scope.setAddressNew = function () {
        // MyService.ConsoleLog($scope.result);
        var finalResult = $scope.checkZipAddress($scope.result);
        if (finalResult && finalResult.length > 0) {
          MyService.ConsoleLog("finalResult::::", finalResult);
          // $scope.mainAddress = angular.copy(finalResult);
          $scope.voterDistricts = finalResult;
          $scope.federalCongrassionalDist = finalResult;
          $scope.stateSenateDistrict = finalResult;
          $scope.stateHouseOFRepresentativeDistricts = finalResult;
          $scope.unifiedSchoolDistrictNames = finalResult;
          ngDialog.closeAll();
          // $scope.$apply();
        } else {
          alert(
            "Address not matching with our database. Please enter detail address and try again."
          );
        }
      };

      var previousSelVal = {};
      $scope.setSelectedDropdown = function (
        listData,
        setfor,
        selectedUserAdrs
      ) {
        switch (setfor) {
          case "counties":
            previousSelVal.county = $scope.address.county;
            //MyService.ConsoleLog("selCountyNumber: ",previousSelVal.county);
            $scope.address.county = null;
            if (listData) {
              $scope.counties = listData;
              $scope.counties.unshift({
                number: null,
                name: "none",
              });

              // if(!selectedUserAdrs) selectedUserAdrs.countyFips = previousSelVal.county.number;
              var selCountyNumber = null;
              try {
                $scope.address.county = $scope.counties[0];
                if (selectedUserAdrs) {
                  selCountyNumber = selectedUserAdrs.countyFips;
                }
                if (previousSelVal.county) {
                  selCountyNumber = previousSelVal.county.number;
                }

                if (selCountyNumber) {
                  //MyService.ConsoleLog("selCountyNumber: ",selCountyNumber);
                  angular.forEach($scope.counties, function (val, key) {
                    if (selCountyNumber == val.number)
                      $scope.address.county = val;
                  });
                }
              } catch (e) {
                //MyService.ConsoleLog("Exception: ",e);
              }
            }
            break;
          case "subCounties":
            previousSelVal.subcounty = $scope.address.subcounty;
            $scope.address.subcounty = null;
            if (listData) {
              $scope.subCounties = listData;
              $scope.subCounties.unshift({
                number: null,
                name: "none",
              });
              var selSubCountyNo = null;
              try {
                $scope.address.subcounty = $scope.subCounties[0];
                if (selectedUserAdrs) {
                  selSubCountyNo = selectedUserAdrs.countySubdivisionFips;
                }
                if (previousSelVal.subcounty) {
                  selSubCountyNo = previousSelVal.subcounty.number;
                }
                if (selSubCountyNo) {
                  angular.forEach($scope.subCounties, function (val, key) {
                    //set selected state
                    // if(selectedUserAdrs.countySubdivisionFips == val.number)
                    if (selSubCountyNo == val.number)
                      $scope.address.subcounty = val;
                  });
                }
              } catch (e) {
                //MyService.ConsoleLog("Exception: ",e);
              }
            }
            break;
          case "places":
            previousSelVal.place = $scope.address.place;
            $scope.address.place = null;
            if (listData) {
              $scope.places = listData;
              $scope.places.unshift({
                number: null,
                name: "none",
              });

              try {
                $scope.address.place = $scope.places[0];
                var selPlaceNo = null;
                if (selectedUserAdrs) {
                  selPlaceNo = selectedUserAdrs.placeFips;
                }
                if (previousSelVal.place) {
                  selPlaceNo = previousSelVal.place.number;
                }
                if (selPlaceNo) {
                  angular.forEach($scope.places, function (val, key) {
                    if (selPlaceNo == val.number) $scope.address.place = val;
                  });
                }
              } catch (e) {
                //MyService.ConsoleLog("Exception: ",e);
              }
            }
            break;
          case "voterDistricts":
            if (listData) {
              previousSelVal.voterDistrict = $scope.address.voterDistrict;
              $scope.address.voterDistrict = null;
              $scope.voterDistricts = listData;
              $scope.voterDistricts.unshift({
                number: null,
                name: "none",
              });

              var voterDistrictNo = null;
              try {
                $scope.address.voterDistrict = $scope.voterDistricts[0];
                if (selectedUserAdrs) {
                  voterDistrictNo = selectedUserAdrs.voterDistrictFips;
                }
                if (previousSelVal.voterDistrict) {
                  voterDistrictNo = previousSelVal.voterDistrict.number;
                }

                if (voterDistrictNo) {
                  angular.forEach($scope.voterDistricts, function (val, key) {
                    //set selected
                    if (voterDistrictNo == val.number)
                      $scope.address.voterDistrict = val;
                  });
                }
              } catch (e) {
                //MyService.ConsoleLog("Exception: ",e);
              }
            }
            break;
          case "federalCongrassionalDist":
            $scope.address.federalCongrassionalDist = null;
            if (listData) {
              $scope.federalCongrassionalDist = listData;
              $scope.federalCongrassionalDist.unshift("none");

              if (selectedUserAdrs) {
                $scope.address.federalCongrassionalDist =
                  $scope.federalCongrassionalDist[0];
                angular.forEach(
                  $scope.federalCongrassionalDist,
                  function (val, key) {
                    //set selected state
                    if (selectedUserAdrs.federalCongrassionalDist == val)
                      $scope.address.federalCongrassionalDist = val;
                  }
                );
              }
            }
            break;
          case "stateSenateDistrict":
            $scope.address.stateSenateDistrict = null;
            if (listData) {
              $scope.stateSenateDistrict = listData;
              $scope.stateSenateDistrict.unshift("none");

              $scope.address.stateSenateDistrict =
                $scope.stateSenateDistrict[0];
              if (selectedUserAdrs) {
                angular.forEach(
                  $scope.stateSenateDistrict,
                  function (val, key) {
                    //set selected state
                    if (selectedUserAdrs.stateSenateDistrict == val)
                      $scope.address.stateSenateDistrict = val;
                  }
                );
              }
            }
            break;
          case "stateHouseOFRepresentativeDistrict":
            $scope.address.stateLegislativeDistrict = null;
            if (listData) {
              $scope.stateLegislativeDistrict = listData;
              $scope.stateLegislativeDistrict.unshift("none");
              $scope.address.stateLegislativeDistrict =
                $scope.stateLegislativeDistrict[0];
              if (selectedUserAdrs) {
                angular.forEach(
                  $scope.stateLegislativeDistrict,
                  function (val, key) {
                    //set selected state
                    if (selectedUserAdrs.legislativeDistrict == val)
                      $scope.address.stateLegislativeDistrict = val;
                  }
                );
              }
            }
            break;
          case "schoolDistricts":
            $scope.address.schoolDistrict = null;
            if (listData) {
              $scope.schoolDistricts = listData;
              $scope.schoolDistricts.unshift({
                number: null,
                name: "none",
              });
              $scope.address.schoolDistricts = $scope.schoolDistricts[0];
              if (selectedUserAdrs) {
                angular.forEach($scope.schoolDistricts, function (val, key) {
                  //set selected state
                  if (selectedUserAdrs.schoolDistrictFips == val.number)
                    $scope.address.schoolDistrict = val;
                });
              }
            }
            break;
        }
      };

      /*$scope.onVoterDistChange = function() {
       MyService.ConsoleLog("** onVoterDistChange **");
      try {
        var postobj = {};

        $scope.statusVoterDistSearch = 1;
        postobj.zipcode = $scope.User.ZipCode;
         MyService.ConsoleLog("address<><><",$scope.address)
        if ($scope.address.voterDistrict && $scope.address.voterDistrict.voterDistrictName.toLowerCase() != "none") {
          postobj.voterDistrictName = $scope.address.voterDistrict.voterDistrictName;

           MyService.ConsoleLog("postobj: ", postobj);
          MyService.getfilterAddressData(postobj).then(function(response) {
             MyService.ConsoleLog("Got zip data: ", response);
            if (response.data.success) {
              var payload = response.data.data;

              $scope.mainAddress = payload;
              $scope.showZipLoader = false;
              $scope.showAddressDropDown = true;
              $scope.oldaddress.state = payload[0].statePostalCode;
              $scope.oldaddress.county = payload[0].county;
              $scope.oldaddress.countySubdivision = payload[0].countySubdivision;
              $scope.oldaddress.place = payload[0].place;
              $scope.getCounties("new");

              $scope.getLocals("new");

              $scope.voterDistricts = payload;
              $scope.federalCongrassionalDist = payload;
              $scope.stateSenateDistrict = payload;
              $scope.stateHouseOFRepresentativeDistricts = payload;
              $scope.unifiedSchoolDistrictNames = payload;
              //$scope.$apply();
              var address = $scope.checkState($scope.states, payload[0].statePostalCode);
              $scope.address.state = address[0];
              $scope.address.voterDistrict.length = 0;
              $scope.address.voterDistrict = $scope.voterDistricts[0];
              $scope.address.voterDistrict.unshift({
                number: null,
                voterDistrictName: "none"
              });
              $scope.address.federalCongrassionalDist = $scope.federalCongrassionalDist[0];
              $scope.address.stateSenateDistrict = $scope.stateSenateDistrict[0];
              $scope.address.stateHouseOFRepresentativeDistrict = $scope.stateHouseOFRepresentativeDistricts[0];
              $scope.address.unifiedSchoolDistrictName = $scope.unifiedSchoolDistrictNames[0];
              $scope.statusVoterDistSearch = 2;
            } else if (response.data.error && typeof response.data.error == "string") {
              growl.error('Error: ' + response.data.error);
              $scope.statusVoterDistSearch = 2;
            } else {
              growl.error('Something went wrong.');
              $scope.statusVoterDistSearch = 3;
            }
          }, function(err) {
            growl.error('Something went wrong.');
            $scope.statusVoterDistSearch = 3;
          });
        }
      } catch (e) {
        //MyService.ConsoleLog("Exception : ",e);
      }
    };*/

      // Mellisa data end //

      $scope.confirmPopup = function () {
        MyService.ConsoleLog("address : ", $scope.address);
        const ansQuestion = $scope.checkQuestionAnswered();

        if (ansQuestion == 0) {
          $scope.eraseUserAnswers();
        } else {
          var message =
            "Without your voice, your politician won’t know how to represent you. Before we show you your results, would you like to create a profile so we can save your answers and send them to your politicians anonymously?";
          var modal = ngDialog.openConfirm({
            template:
              "<p>" +
              message +
              '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="compareBtn" ng-click="confirm(0)">Create and Save</button>\
                            <button type="button" class="eraseBtn" ng-click="confirm(1)">No. Erase when done</button>\
                        </div>',
            plain: true,
          });

          modal.then(
            function fullfilled(data) {
              MyService.ConsoleLog("fullfilled: ", data);
              if (data == 0) {
                $scope.saveUserAnswers();
              } else {
                $scope.eraseUserAnswers();
              }
            },
            function rejected(data) {
              MyService.ConsoleLog("rejected: ", data);
            }
          );

          return;
        }
      };

      function keyupHandler(keyEvent) {
        MyService.ConsoleLog("key up");
        if (
          !$scope.showZipCode &&
          !$scope.questions[$scope.currentIndex].isEssayQue
        ) {
          event.preventDefault();
          if (event.keyCode === 13) {
            //MyService.ConsoleLog('Current route name: ', $location.path());
            if ($location.path() == "/fiveMatch") {
              $scope.submitAnswer();
            }
          }
        }
      }
      $scope.$watch("currentIndex", function (newValue, oldValue) {
        try {
          // MyService.ConsoleLog($scope.currentIndex);
          // MyService.ConsoleLog($scope.questions.length);

          MyService.ConsoleLog("Current currentIndex: ", $scope.currentIndex);
          // console.log("scope.importance >>> ",$scope.importance)
          // console.log($scope.questions[$scope.currentIndex]._id);
          // if ($scope.currentIndex == 0) {

          var data = $scope.checkQuestion(
            $scope.questions[$scope.currentIndex]._id
          );
          console.log("data >> ", data.length);
          if (data.length == 0) {
            $scope.dis = false;
          }

          if (data && data[0] && data[0].answer && data[0].answer != "") {
            $scope.updata.comment = data[0].comment;
            $scope.answer = data[0].answer;
            $scope.importance = data[0].importance;
          }

          $scope.initMyAnswer(); // Added
          // }

          // var obj = $scope.questions[$scope.currentIndex];

          /*
        var data = $scope.checkQuestion(obj._id);


        if (data && data[0]) {
          MyService.ConsoleLog(data[0]);
          if (data[0].answer != "") {
            $scope.answer = data[0].answer;
          }
          if (data[0].importance != "") {
            $scope.importance = data[0].importance;
          }
          if (data[0].comment != "") {
            $scope.comment = data[0].comment;
          }

        }
        */
        } catch (e) {
          //MyService.ConsoleLog("Current Index Change Ex: ", e)
        }
      });

      document.addEventListener("keyup", keyupHandler);
      $scope.$on("$destroy", function () {
        MyService.ConsoleLog("event destroyed :");
        $document.unbind("keyup");
      });
    },
  ]);

'use strict';
angular.module('myApp.fiveminsignin', ['ngRoute'])
  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/fiveminsignin', {
      templateUrl: 'app/fiveminsignin/signin.html',
      controller: 'fiveminSigninCtrl'
    });
  }])

  .controller('fiveminSigninCtrl', ['$scope', '$http', '$location', 'growl', 'tokenService', 'baseApiUrl', '$rootScope', 'MyService',
    function($scope, $http, $location, growl, tokenService, baseApiUrl, $rootScope, MyService) {
      $scope.UserName = "";
      $scope.Password = "";
      $rootScope.welcome = false;
      $scope.saveFiveMinAnswers = function() {
        MyService.ConsoleLog("saveFiveMinAnswers : ");
        MyService.ConsoleLog($rootScope.fiveMatch);
        var len = $rootScope.fiveMatch.length;
        if(len > 0){
        for (var i = 0; i < len; i++) {
          MyService.ConsoleLog($rootScope.fiveMatch[i]);
          MyService.postAnswer($rootScope.fiveMatch[i]).then(function(response) {
            MyService.ConsoleLog(response);
            if (response.data.success) {
                MyService.ConsoleLog("Answer updated successfully");
              
            } else {
              MyService.ConsoleLog("Error: " + response.data.error);
            }
          }, function(err) {
            MyService.ConsoleLog("Error: ");
          });
        }
      }
      }
      $scope.initAuthorizedUser1 = function(userdata) {
        // body...
        MyService.ConsoleLog("userdata>>", userdata);
        tokenService.saveToken(userdata.token);
        tokenService.saveUserName(userdata.name);
        tokenService.saveUserId(userdata.id);
        tokenService.saveUserRole(userdata);
        var udata = {
          id: userdata.id,
          lastLogin: userdata.lastLogin,
          uname: userdata.username,
          email: userdata.email,
          followlist: userdata.followlist,
          isemailverified: userdata.isemailverified,
          subject_of_deep_interest: userdata.subject_of_deep_interest,
          subject_of_interest: userdata.subject_of_interest,
          location_of_interest: userdata.location_of_interest,
          address: userdata.address,
          selectedColumns: userdata.selectedColumns,
          facebookid: userdata.facebookid,
          volunteers: userdata.volunteers,
          name: userdata.name
        };
        $rootScope.tempUserAddress = userdata.address;
        //MyService.ConsoleLog("udata : ", udata);
        tokenService.saveUserData(JSON.stringify(udata));

        $http.defaults.headers.common['x-access-token'] = tokenService.getToken();
        // $http.defaults.headers.common['Authorization'] = tokenService.getToken();
        $rootScope.Auth = true;
        $rootScope.User = tokenService.getUserName();
        $rootScope.UserId = tokenService.getUserId();
        //$location.path('howToVideo');
        if ($rootScope.endFiveMin == true) {
          $location.path('/snapshot');
        } else {
          $location.path('/fiveCompare');
        }
        $scope.saveFiveMinAnswers();
        $rootScope.getCategories();
      };
      $rootScope.statusAuthenticate = 0;
      $scope.AuthenticateUser1 = function(postObj) {
        $rootScope.statusAuthenticate = 1;
        $http.post(baseApiUrl + '/user/authenticate', postObj)
          .then(function(response) {
            if (response.data.success == true) {
              //MyService.ConsoleLog("Login Data");
              //MyService.ConsoleLog(response.data);
              $scope.initAuthorizedUser1(response.data);
              /*
              tokenService.saveToken(response.data.token);
              tokenService.saveUserName(response.data.name);
              tokenService.saveUserId(response.data.id);
              tokenService.saveUserRole(response.data);
              var userData = {
                  id: response.data.id,
                  lastLogin: response.data.lastLogin,
                  uname: response.data.username,
                  name: response.data.name
              };
              //MyService.ConsoleLog("username: ", userData);
              tokenService.saveUserData(JSON.stringify(userData));
              $http.defaults.headers.common['x-access-token'] = tokenService.getToken();
              $rootScope.Auth = true;
              $rootScope.User = tokenService.getUserName();
              $rootScope.UserId = tokenService.getUserId();
              $location.path('debateHome');
              $rootScope.getCategories();
              */
              $rootScope.statusAuthenticate = 2;
            } else {
              $rootScope.statusAuthenticate = 3;
              growl.error('Invalid Username or Password. Please try again.');
            }
          }, function(response) {
            $rootScope.statusAuthenticate = 3;
            var validataionMsg = "";
            //MyService.ConsoleLog("response: ", response);
            if ((response.data) && (response.data.error)) {
              var errors = response.data.error.errors;
              for (var k in errors) {
                if (errors.hasOwnProperty(k)) {
                  //MyService.ConsoleLog(k)
                  var obj = errors[k];
                  if (obj.message !== undefined)
                    validataionMsg += obj.message.replace('Path', '') + "<br/>";
                }
              }
              growl.error(validataionMsg);
            }

          });
      };
      $scope.AuthenticateUser = function() {
        if ($.fn.validateForceFully($("#signInform")) == true) {
          /*$http.post(baseApiUrl + '/user/authenticate', {
              username: $scope.UserName,
              password: $scope.Password
          })
          .then(function (response) {
              if (response.data.success == true) {
                  //MyService.ConsoleLog("Login Data");
                  //MyService.ConsoleLog(response.data);
                  tokenService.saveToken(response.data.token);
                  tokenService.saveUserName(response.data.name);
                  tokenService.saveUserId(response.data.id);
                  tokenService.saveUserRole(response.data);
                   var userData = {
                      id: response.data.id,
                      lastLogin: response.data.lastLogin,
                      uname: $scope.UserName,
                      name: response.name
                   };
                  tokenService.saveUserData(JSON.stringify(userData));
                 
                  
                  $http.defaults.headers.common['x-access-token'] = tokenService.getToken();
                  $rootScope.Auth = true;
                  $rootScope.User = tokenService.getUserName();
                  $rootScope.UserId = tokenService.getUserId();
                  $location.path('debateHome');
                  $rootScope.getCategories();
              }
              else {
                  growl.error('Invalid Username or Password. Please try again.');
              }
          }, function (response) {
              var validataionMsg = "";
              var errors = response.data.error.errors;
              for (var k in errors) {
                  if (errors.hasOwnProperty(k)) {
                      //MyService.ConsoleLog(k)
                      var obj = errors[k];
                      if (obj.message !== undefined)
                          validataionMsg += obj.message.replace('Path', '') + "<br/>";
                  }
              }
              growl.error(validataionMsg);
          });*/

          var postobj = {
            username: $scope.UserName,
            password: $scope.Password
          };
          $scope.AuthenticateUser1(postobj);
        }
      };

      $scope.requestPasswordReset = function() {
        if ($.fn.validateForceFully($("#forgotPassForm")) == true) {
          var postobj = {
            email: $scope.forgotEmail,
            reset_url: $rootScope.getPasswordResetUrl()
          };
          //MyService.ConsoleLog("postobj: ",postobj);

          MyService.forgotPassword(postobj)
            .then(function(response) {
              if (response.data.success) {
                growl.success("An email has been sent.");
              } else {
                if (typeof response.data.error == "string")
                  growl.error(response.data.error);
                else
                  growl.error("Something went wrong");
              }
            }, function(err) {
              growl.error("Something went wrong");
            });
        }
      };

      $("form").validationEngine();
    }
  ]);

"use strict";

angular
  .module("myApp.fiveMinSaveUser", ["ngRoute"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/fiveSaveUser", {
        templateUrl: "app/fiveminsaveuser/fiveminsaveuser.html",
        controller: "fiveSaveUserCtrl",
      });
    },
  ])

  .controller("fiveSaveUserCtrl", [
    "$scope",
    "apiCall",
    "MyService",
    "tokenService",
    "$location",
    "$anchorScroll",
    "$timeout",
    "$rootScope",
    "ngDialog",
    "$q",
    "$http",
    "$filter",
    "growl",
    "baseApiUrl",
    "$sce",
    "$cookies",
    function (
      $scope,
      apiCall,
      MyService,
      tokenService,
      $location,
      $anchorScroll,
      $timeout,
      $rootScope,
      ngDialog,
      $q,
      $http,
      $filter,
      growl,
      baseApiUrl,
      $sce,
      $cookies
    ) {
      $rootScope.welcome = false;
      $scope.UserType = "voter";
      $scope.MUserType = [
        /*{
          name: 'Politician',
          key: 'politician',
        },*/
        {
          name: "Voter",
          key: "voter",
        },
        {
          name: "Organization",
          key: "advocate",
        },
      ];

      // BRING BACK   removed from above line { "name": 'Organization', "key": 'advocate' }, { "name": 'Press', "key": 'press' }
      $cookies.remove("showLongPopUp");
      $scope.showGuest = false;
      $scope.showzip = false;
      MyService.ConsoleLog("$scope.showGuest >>", $cookies.get("sessionId"));

      if ($cookies.get("sessionId")) {
        $scope.showGuest = true;
      }
      MyService.ConsoleLog("before set >> ", $rootScope.fiveMatch);
      if ($rootScope.fiveMatch && $rootScope.fiveMatch.length > 0) {
        window.localStorage.setItem(
          "fiveMatch",
          JSON.stringify($rootScope.fiveMatch)
        );
      } else {
        $rootScope.fiveMatch = JSON.parse(
          window.localStorage.getItem("fiveMatch")
        );
      }

      MyService.ConsoleLog("after set >> ", $rootScope.fiveMatch);

      if ($rootScope.tempUserAddress) {
        window.localStorage.setItem(
          "tempUserAddress",
          JSON.stringify($rootScope.tempUserAddress)
        );
      } else {
        $rootScope.tempUserAddress = JSON.parse(
          window.localStorage.getItem("tempUserAddress")
        );
      }

      MyService.ConsoleLog(
        " $rootScope.tempUserAddress :",
        $rootScope.tempUserAddress
      );

      if ($rootScope.tempUserZip) {
        MyService.ConsoleLog(
          " inside zip>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>",
          $rootScope.tempUserZip
        );
        window.localStorage.setItem("tempUserZip", $rootScope.tempUserZip);
      } else {
        $rootScope.tempUserZip = window.localStorage.getItem("tempUserZip");
        MyService.ConsoleLog(
          "$rootScope.tempUserZip >>",
          $rootScope.tempUserZip
        );
      }
      if ($rootScope.tempUserZip == "") {
        // alert('show');
        $scope.showzip = true;
      }

      $scope.records = [];
      $scope.States = [];
      $scope.Cities = [];

      $scope.Address = {
        ZipCode: "",
        Country: "",
        State: "",
        City: "",
      };
      $scope.User = {
        name: "",
        UserType: "voter",
        lastname: "",
        UserName: "",
        Password: "",
        ConfirmPassword: "",
        Email: "",
        ZipCode: "",
        ZipCodeOne: "",
        confirmOpt: "Email",
        runElectionDate: "",
        runStatus: "",
      };
      $scope.countyone = false;
      $scope.cityone = false;
      $scope.showLoaderOne = false;
      $scope.running_countyone = false;
      $scope.running_cityone = false;
      $scope.running_showLoaderOne = false;
      $scope.runAddress = {
        state: "",
        county: "",
        countySubdivision: "",
        place: "",
      };
      $scope.Errors = [];

      $scope.levelOfGovt = ["Other", "Federal", "State", "County", "Local"];

      $scope.countylevelOfGovt = ["County"];
      $scope.statelevelOfGovt = [
        "State",
        "State House of Representatives District",
        "State Senate District",
        "All USA",
        "Federal Congressional District",
      ];
      $scope.schoollevelOfGovt = [
        "Elementary school District Position",
        "Secondary School District Position",
        "Unified School District Position",
        "State Board of Education District",
      ];

      $scope.judiciallevelOfGovt = ["Judicial District"];
      $scope.locallevelOfGovt = ["Place Name", "County SubDivision Name"];
      $scope.offices = [];
      $scope.running_offices = [];

      $scope.carriers = [
        {
          name: "AT&T",
          domain: "txt.att.net",
        },
        {
          name: "T-Mobile",
          domain: "tmomail.net",
        },
        {
          name: "Verizon",
          domain: "vtext.com",
        },
        {
          name: "Sprint",
          domain: "messaging.sprintpcs.com",
        },
        {
          name: "Virgin Mobile",
          domain: "vmobl.com",
        },
        {
          name: "Tracfone",
          domain: "mmst5.tracfone.com",
        },
        {
          name: "Metro PCS",
          domain: "mymetropcs.com",
        },
        {
          name: "Boost Mobile",
          domain: "myboostmobile.com",
        },
        {
          name: "Cricket",
          domain: "sms.mycricket.com",
        },
        {
          name: "Ptel",
          domain: "ptel.com",
        },
        {
          name: "Republic Wireless",
          domain: "text.republicwireless.com",
        },
        {
          name: "Suncom",
          domain: "tms.suncom.com",
        },
        {
          name: "Ting",
          domain: "message.ting.com",
        },
        {
          name: "U.S. Cellular",
          domain: "email.uscc.net",
        },
        {
          name: "Consumer Cellular",
          domain: "cingularme.com",
        },
        {
          name: "C-Spire",
          domain: "cspire1.com",
        },
        {
          name: "Page Plus",
          domain: "vtext.com",
        },
      ];

      $scope.govLevelChanged = function (electionFor) {
        $scope.running_flagShowStateDropdown = false;
        $scope.running_flagShowOfficeDropdown = false;
        $scope.flagShowStateDropdown = false;
        $scope.flagShowOfficeDropdown = false;
        MyService.ConsoleLog("* govLevelChanged *");
        if (electionFor == "running") {
          $scope.User.office_name = null;
          $scope.running_flagShowStateDropdown = true;
          //$scope.onStateChange('running');
        } else {
          $scope.User.cur_state = null;
          $scope.User.cur_office_name = null;
          $scope.flagShowStateDropdown = true;
          //$scope.onStateChange('incumbent');
        }
      };

      $scope.localSchoolDistException = function (electionFor) {
        var exceptionState = ["AK", "DC", "VA"];
        if ((electionFor = "running")) {
          if (
            $scope.User.state &&
            exceptionState.indexOf($scope.User.state.statePostalCode) == -1
          ) {
            return true;
          } else return false;
        } else if (electionFor == "incumbent") {
          if (
            $scope.User.cur_state &&
            exceptionState.indexOf($scope.User.cur_state.statePostalCode) == -1
          ) {
            return true;
          } else return false;
        }
      };

      $scope.userTypeChanged = function (type) {
        MyService.ConsoleLog("type : " + type);
        $scope.UserType = type;
        console.log("check type", $scope.UserType);

        $scope.User.organization_name = "";
        $scope.User.organization = null;
        //MyService.ConsoleLog("user type : ", $scope.UserType);
        $("form").validationEngine();
        //MyService.ConsoleLog("validationEngine applied");
      };
      // for autocomplete address

      var options = {
        componentRestrictions: {
          country: "us",
        },
        types: ["geocode"],
      };

      $scope.detectAddress = function (ent) {
        var val = document.getElementById("address");
        // console.log($scope.User.Address);
        var autocomplete = new google.maps.places.Autocomplete(val, options);

        google.maps.event.addListener(
          autocomplete,
          "place_changed",
          function () {
            var place = autocomplete.getPlace();

            var lat = place.geometry.location.lat(),
              lng = place.geometry.location.lng();

            $scope.lati = lat.toFixed(6);
            $scope.lon = lng.toFixed(6);
            // console.log($scope.lati);
            // console.log($scope.lon);

            $scope.mailing_Address = place.formatted_address;
            MyService.ConsoleLog("Main addd :", place.address_components);
            for (var i = 0; i < place.address_components.length; i++) {
              for (
                var j = 0;
                j < place.address_components[i].types.length;
                j++
              ) {
                if (
                  place.address_components[i].types[j] ==
                  "administrative_area_level_1"
                ) {
                  $scope.statePostalCode =
                    place.address_components[i].short_name;
                  // console.log($scope.statePostalCode);
                }
                if (place.address_components[i].types[j] == "country") {
                  $scope.countryname = place.address_components[i].long_name;
                  // console.log($scope.countryname);
                }
                if (
                  place.address_components[i].types[j] ==
                  "administrative_area_level_2"
                ) {
                  $scope.county_name = place.address_components[i].long_name;
                  // console.log($scope.county_name);
                }
                if (place.address_components[i].types[j] == "locality") {
                  $scope.place_name = place.address_components[i].long_name;
                  // console.log($scope.place_name);
                }
                if (place.address_components[i].types[j] == "postal_code") {
                  document.getElementById("zip").value =
                    place.address_components[i].long_name;
                  if (
                    place.address_components[i].long_name &&
                    place.address_components[i].long_name != ""
                  ) {
                    $scope.User.ZipCode = place.address_components[i].long_name;
                    $scope.User.ZipCodeOne =
                      place.address_components[i].long_name;
                    // console.log($scope.User.ZipCode);
                  }
                  // console.log($scope.User.ZipCode);
                }
              }
            }

            console.log("$scope.User.ZipCode :", $scope.User.ZipCode);

            var loc = JSON.stringify({
              longitude: $scope.lon,
              latitude: $scope.lati,
            });
            // console.log(loc);
            // $rootScope.location = new Array;
            $rootScope.location = {
              longitude: $scope.lon,
              latitude: $scope.lati,
            };
            $scope.showAddressDropDowns("", loc);
          }
        );
      };
      $scope.oldaddress = {
        state: "",
        county: "",
        countySubdivision: "",
        place: "",
      };

      $scope.address = {
        state: "",
        county: "",
        countySubdivision: "",
        place: "",
      };
      // End for autocomplete address

      $scope.mainAddress = "";

      $scope.showAddressDropDowns = function (zipcode, loc) {
        if (loc && loc != "") {
          MyService.ConsoleLog("showAddressDropDowns" + zipcode);
          MyService.ConsoleLog("MyLocation : >>>." + loc);

          $scope.showZipLoader = true;
          MyService.getOrganizedZipData({
            candidate: true,
            loc: loc,
          }).then(
            function (payload) {
              MyService.ConsoleLog(" showAddressDropDowns ", payload);
              if (payload && payload != "") {
                // var finalData = payload.data;
                // MyService.ConsoleLog(payload[0].countySubdivision);
                // MyService.ConsoleLog(payload[0].county);
                // MyService.ConsoleLog(payload[0].place);
                var countySubdivisions = payload.places.filter(function (obj) {
                  if (obj.COUSUBFP && obj.COUSUBFP != "") {
                    // MyService.ConsoleLog("Inside cs");
                    return obj;
                  }
                });
                var places = payload.places.filter(function (obj) {
                  if (obj.PLACEFP && obj.PLACEFP != "") {
                    // MyService.ConsoleLog("obj > ", obj);
                    return obj;
                  }
                });
                MyService.ConsoleLog(
                  " showAddressDropDowns <><><><><><><><><><><><><> "
                );

                $scope.mainAddress = payload;
                $scope.showZipLoader = false;
                $scope.showAddressDropDown = true;
                $scope.oldaddress.state = payload.state;
                $scope.oldaddress.county = payload.county;
                // MyService.ConsoleLog("countySubdivisions >> ", countySubdivisions);
                $scope.oldaddress.countySubdivision = countySubdivisions;
                // MyService.ConsoleLog("places >>> ",places);
                $scope.oldaddress.place = places;
                // $scope.getCounties("new");

                $scope.getSubCounties("new");

                // $scope.voterDistricts = payload;
                // MyService.ConsoleLog(payload.congressionalDistrict);
                $scope.federalCongrassionalDist = payload.congressionalDistrict;
                MyService.ConsoleLog(
                  "@@@@@@ drop :",
                  $scope.federalCongrassionalDist
                );

                $scope.stateSenateDistrict = payload.stateSenateDistrict;
                $scope.stateHouseOFRepresentativeDistricts =
                  payload.stateHouseofRepresentativesDistrict;
                $scope.unifiedSchoolDistrictNames =
                  payload.unifiedSchoolDistrict;
                //$scope.$apply();
                // MyService.ConsoleLog($scope.states);
                // MyService.ConsoleLog(payload[0].statePostalCode);
                var address = $scope.checkState($scope.states, payload.state);
                MyService.ConsoleLog("address : ", address);
                $scope.address.state = address[0];
                // $scope.address.voterDistrict = $scope.voterDistricts[0];
                $scope.address.federalCongrassionalDist =
                  $scope.federalCongrassionalDist[0];
                $scope.address.stateSenateDistrict =
                  $scope.stateSenateDistrict[0];
                $scope.address.stateHouseOFRepresentativeDistrict =
                  $scope.stateHouseOFRepresentativeDistricts[0];
                $scope.address.unifiedSchoolDistrictName =
                  $scope.unifiedSchoolDistrictNames[0];
                // MyService.ConsoleLog("address ; ", address);
                MyService.ConsoleLog(
                  "<><><><><<><><>>>>>>. zip code >>>>>>>>>>>>>>>>>",
                  $scope.User.ZipCode
                );
                $timeout(function () {
                  $rootScope.tempUserZip = $scope.User.ZipCode;
                  $rootScope.tempUserAddress = $scope.address;
                  MyService.ConsoleLog(
                    " temp : >>>>>>>>>>>>>>>>>>>>>>>>>>>",
                    $rootScope.tempUserAddress
                  );
                  window.localStorage.setItem(
                    "tempUserZip",
                    $rootScope.tempUserZip
                  );
                  window.localStorage.setItem(
                    "tempUserAddress",
                    JSON.stringify($rootScope.tempUserAddress)
                  );
                  // MyService.ConsoleLog("address : ", address);
                  // MyService.ConsoleLog("rootscope address : ", $rootScope.tempUserAddress);
                }, 100);
              }
            },
            function (errorPayload) {
              $scope.showZipLoader = false;
              growl.error(errorPayload);
            }
          );
        }
      };

      $scope.checkState = function (rdata, val) {
        // MyService.ConsoleLog("State :", rdata);
        // MyService.ConsoleLog("State val :", val);
        var sdata = [];
        var len = rdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = rdata[i];
          var gdata = val.filter(function (obj) {
            if (
              rsdata.countyFips == obj.COUNTYFP &&
              rsdata.stateFips == obj.STATEFP
            ) {
              // MyService.ConsoleLog(rdata[i]);
              return rdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(rdata[i]) == -1) {
              sdata.push(rdata[i]);
            }
          }

          if (j == len) {
            // MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };

      $scope.checkCounty = function (rdata, val) {
        MyService.ConsoleLog("County :", rdata);
        MyService.ConsoleLog("County val :", val);
        var sdata = [];
        var len = rdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = rdata[i];
          var gdata = val.filter(function (obj) {
            if (
              rsdata.countyFips == obj.COUNTYFP &&
              rsdata.stateFips == obj.STATEFP
            ) {
              // MyService.ConsoleLog(rdata[i]);
              return rdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(rdata[i]) == -1) {
              sdata.push(rdata[i]);
            }
          }

          if (j == len) {
            // MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };
      $scope.checksubCounty = function (rdata, val) {
        var sdata = [];
        var len = rdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = rdata[i];
          var gdata = val.filter(function (obj) {
            if (rsdata.countySubdivision == obj.NAME) {
              // MyService.ConsoleLog(rdata[i]);
              return rdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(rdata[i]) == -1) {
              sdata.push(rdata[i]);
            }
          }

          if (j == len) {
            // MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };
      $scope.checkPlaces = function (prdata, val) {
        var sdata = [];
        var len = prdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = prdata[i];
          var gdata = val.filter(function (obj) {
            // MyService.ConsoleLog(rsdata.place +"=="+ obj.NAME);
            if (rsdata.place == obj.NAME && !rsdata.countyFips) {
              // MyService.ConsoleLog(rdata[i]);
              return prdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(prdata[i]) == -1) {
              sdata.push(prdata[i]);
            }
          }

          if (j == len) {
            // MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };
      var getCountiesCanceler = $q.defer();
      var getCountiesCanceler = $q.defer();
      $scope.getCounties = function (lbl) {
        //MyService.ConsoleLog("$scope.User.cur_state: ", $scope.User.cur_state)
        //MyService.ConsoleLog($scope.oldaddress);
        // var state = {};
        // if (lbl == 'cur') state = $scope.User.cur_state;
        // else if (lbl == 'new') state.statePostalCode = $scope.oldaddress.state;
        // else state = JSON.parse($scope.User.sel_state);
        $scope.counties = "";
        var statePostalCode = "";

        if ($scope.User.cur_state != "") {
          statePostalCode = $scope.User.cur_state.stateFips;
        }
        //MyService.ConsoleLog("state: ", state);

        getCountiesCanceler.resolve();
        if ($scope.places) $scope.counties.length = 0;

        var request = apiCall.apiCall("POST", "/user/getAllCounties", {
          statePostalCode: statePostalCode,
          timeout: getCountiesCanceler.promise,
        });
        $http(request).then(
          function successCallback(response) {
            if (response.data.success) {
              //MyService.ConsoleLog(response.data.data);
              $scope.counties = response.data.data;
              // if (lbl == 'new') {
              if ($scope.User.cur_level == "Local") {
                $scope.countyone = true;
                $scope.showLoader = false;
              }

              // if ($scope.User.cur_level == "Other") {
              //   $scope.countyone = true;
              //   $scope.showLoader = false;
              // }

              if ($scope.User.cur_level == "County") {
                $scope.countyone = true;
                $scope.showcur_office_nameDrop = true;
                $scope.showLoader = false;
              }

              // alert('counties');
              // $scope.address.county = address.county;
              var county = $scope.checkCounty(
                $scope.counties,
                $scope.oldaddress.county
              );
              //MyService.ConsoleLog("county<><", county);
              $scope.address.county = county[0];
              // }
            } else {
              growl.error("Something went wrong.");
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
          }
        );
      };

      /*
       * this function Fetch all data of sub counties and cities
       **/

      $scope.getSubCounties = function () {
        $scope.arr = [];
        $scope.dis = false;
        $scope.stateSenate = false;
        $scope.stateHouse = false;
        $scope.federalCong = false;
        // $scope.countyone = false;
        $scope.cityone = false;
        $scope.school = false;
        $scope.federalCongrassionalDist = "";
        $scope.unifiedSchoolDistrictNames = "";
        $scope.stateHouseOFRepresentativeDistricts = "";
        $scope.stateSenateDistrict = "";
        $scope.allsubcounty = "";
        $scope.places = "";
        $scope.address.stateSenateDistrict = "";
        $scope.address.federalCongrassionalDist = "";
        $scope.address.stateHouseOFRepresentativeDistrict = "";
        $scope.address.unifiedSchoolDistrictName = "";

        MyService.ConsoleLog("$scope.state >>>", $scope.User.cur_state);
        MyService.ConsoleLog("$scope.County >>>", $scope.address.county);
        if (
          $scope.User.cur_level == "Local" ||
          $scope.User.cur_level == "Other"
        ) {
          $scope.showLoaderOne = true;
          // $scope.LoaderTwo = false;
        }
        if ($scope.User.cur_level != "County") {
          MyService.getPlacesAndSubCounty(
            $scope.User.cur_state.stateFips,
            $scope.address.county.countyFips,
            $scope.User.cur_state.state
          ).then(
            function (response) {
              MyService.ConsoleLog("response >>", response);

              var sub = response.countySubdivision.filter(function (val) {
                var cmat = val.city.substring(val.city.length - 3);
                if (cmat != "CDP") {
                  return val;
                }
              });

              $scope.allsubcounty = sub;

              var plFil = response.places.filter(function (item) {
                // MyService.ConsoleLog('item', item);
                var smTxt = item.city.substring(item.city.length - 3);
                if (smTxt != "CDP") {
                  return item;
                  MyService.ConsoleLog("smTxt >>", smTxt);
                }
              });
              MyService.ConsoleLog("plFil >>", plFil);
              $scope.finArr = $scope.allsubcounty.concat(plFil);
              MyService.ConsoleLog("$scope.arr", $scope.finArr);
              var smpl = $scope.finArr.filter(function (vals, ind) {
                return (
                  ind ==
                  $scope.finArr.findIndex(function (ele) {
                    return JSON.stringify(ele) == JSON.stringify(vals);
                  })
                );
              });
              MyService.ConsoleLog("new filtered >>", smpl);

              $scope.places = smpl;
              $scope.cityone = true;
              if ($scope.User.cur_level == "Local") {
                $scope.showLoaderOne = false;

                // $scope.getFederal();
              }

              if ($scope.User.cur_level == "Other") {
                // $scope.showLoaderOne = true;
                // $scope.getFederal();
              }
            },
            function (error) {
              MyService.ConsoleLog("Error >>", error);
            }
          );
        }
        // if($scope.User.cur_state && $scope.address.county == "" ){
        //   alert('if');
        // }else{
        //   alert('else');

        // }
      };

      /**
       * Get Counties for the running for office
       */
      $scope.getRunningCounties = function () {
        // alert("first");
        // MyService.ConsoleLog("$scope.User.cur_state: ", $scope.User.cur_state)
        // MyService.ConsoleLog("old",$scope.oldaddress);

        var statePostalCode = "";

        if ($scope.User.state != "") {
          statePostalCode = $scope.User.state.stateFips;
        }

        // MyService.ConsoleLog("selected state", $scope.address.state);

        // MyService.ConsoleLog("lbl", lbl);

        MyService.ConsoleLog("statePostalCode", statePostalCode);

        var request = apiCall.apiCall("POST", "/user/getAllCounties", {
          statePostalCode: statePostalCode,
          timeout: getCountiesCanceler.promise,
        });
        $http(request).then(
          function successCallback(response) {
            if (response.data.success) {
              MyService.ConsoleLog("response", response.data.data);
              $scope.runCounties = response.data.data;
              console.log("$scope.alllcounties>>", $scope.runCounties);
              // if (lbl == "new") {
              if ($scope.User.level == "Local") {
                $scope.running_countyone = true;
                $scope.running_showLoader = false;
              }

              if ($scope.User.level == "Other") {
                $scope.running_countyone = true;
                $scope.running_showLoader = false;
              }

              if ($scope.User.level == "County") {
                $scope.running_countyone = true;
                $scope.shownew_office_nameDrop = true;
                $scope.running_showLoader = false;
              }

              // alert('counties');

              // }
            } else {
              growl.error("Something went wrong.");
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
          }
        );
      };

      /**
       * Get all sub counties and cities of the running for office
       */

      $scope.getRunningSubCounties = function () {
        MyService.ConsoleLog("$scope.state >>>", $scope.User.state);
        MyService.ConsoleLog("$scope.County >>>", $scope.User.state);
        $scope.running_stateSenate = false;
        $scope.running_stateHouse = false;
        $scope.running_federalCong = false;
        // $scope.running_countyone = false;
        $scope.running_cityone = false;
        $scope.running_school = false;
        $scope.running_showLoader = false;
        $scope.runFederalCongrassionalDist = "";
        $scope.runUnifiedSchoolDistrictNames = "";
        $scope.runStateHouseOFRepresentativeDistricts = "";
        $scope.runStateSenateDistrict = "";
        $scope.runPlaces = "";
        // $scope.runAddress.stateSenateDistrict = "";
        // $scope.runAddress.federalCongrassionalDist = "";
        // $scope.runAddress.stateHouseOFRepresentativeDistrict = "";
        // $scope.runAddress.unifiedSchoolDistrictName = "";
        if ($scope.User.level == "Local" || $scope.User.level == "Other") {
          $scope.running_showLoaderOne = true;
        }
        MyService.ConsoleLog("$scope.User.cur_level", $scope.User.cur_level);
        if ($scope.User.level != "County") {
          MyService.getPlacesAndSubCounty(
            $scope.User.state.stateFips,
            $scope.runAddress.county.countyFips,
            $scope.User.state.state
          ).then(
            function (response) {
              MyService.ConsoleLog("response >>", response);
              var subRun = response.countySubdivision.filter(function (val) {
                var cmatRun = val.city.substring(val.city.length - 3);
                if (cmatRun != "CDP") {
                  return val;
                  MyService.ConsoleLog("cmat >>", cmat);
                }
              });

              $scope.allsubcounty = subRun;

              var plFilRun = response.places.filter(function (item) {
                // MyService.ConsoleLog('item', item);
                var smTxtRun = item.city.substring(item.city.length - 3);
                if (smTxtRun != "CDP") {
                  return item;
                  MyService.ConsoleLog("smTxt >>", smTxt);
                }
              });
              // $scope.allsubcounty = ;
              var temArr = $scope.allsubcounty.concat(plFilRun);
              var finls = temArr.filter(function (vals, ind) {
                return (
                  ind ==
                  temArr.findIndex(function (ele) {
                    return JSON.stringify(ele) == JSON.stringify(vals);
                  })
                );
              });
              $scope.runPlaces = finls;
              if ($scope.User.level == "Local") {
                $scope.running_showLoaderOne = false;
                $scope.running_cityone = true;

                // $scope.getRunningFederal();
              }
              if ($scope.User.level == "Other") {
                // $scope.showLoaderOne = true;
                // $scope.getRunningFederal();
              }
            },
            function (error) {
              MyService.ConsoleLog("Error >>", error);
            }
          );
        }
      };
      /*  $scope.allcounties = [];
        $scope.getCounties = function (lbl) {
          // MyService.ConsoleLog("county >", $scope.Location.state);
          $scope.allcounties.length = 0;
          var statePostalCode = '';
          var state = '';
          if (lbl == 'new') {
            state = JSON.stringify($scope.oldaddress.state);
          } else {
            statePostalCode = $scope.Location.state.statePostalCode;
            state = $scope.Location.state;
          }
          // MyService.ConsoleLog(statePostalCode + "<><><><>>" + state);
          MyService.getAllCounties(statePostalCode, state).then(
            function (payload) {
              // MyService.ConsoleLog("sublocations Locals : ", payload);
              var allcounties = payload;
              if (lbl == 'new') {
                var county = $scope.checkCounty(allcounties, $scope.oldaddress.county);
                $scope.allcounties = county;
                // MyService.ConsoleLog("county<><", county);
                $scope.address.county = county[0];
              }
            },
            function (errorPayload) {
              growl.error('Something went wrong.');
            }
          );
        };
        $scope.MyPlaces = [];
        $scope.getSubCounties = function (lbl) {
          //MyService.ConsoleLog($scope.Location.state);
          //MyService.ConsoleLog($scope.Location.county);
          // var county = $scope.Location.county;

          $scope.MyPlaces.length = 0;
          var county = '';
          var statePostalCode = '';
          $scope.MyPlaces.length = 0;
          var state = '';
          var county = '';
          if (lbl == 'new') {
            state = JSON.stringify($scope.oldaddress.state);
            county = JSON.stringify($scope.oldaddress.county);
          } else {
            statePostalCode = $scope.Location.state.statePostalCode;
            state = $scope.Location.state;
            county = county.county;
          }
          // MyService.ConsoleLog(statePostalCode + "===" + county);
          MyService.getAllSubCountiesLocal(statePostalCode, state, county).then(
            function (payload) {
              // payload = JSON.parse(payload);
              $scope.MyPlaces = payload;
              // MyService.ConsoleLog("PlaCE :", payload);
              // MyService.ConsoleLog(payload.countySubdivision);
              var subcounties = payload.countySubdivision;
              var places = payload.places;
              // MyService.ConsoleLog("PlaCE :", payload);
              if (lbl == 'new') {
                // MyService.ConsoleLog("Places 1 > ",$scope.oldaddress.place);
                var subcounty = $scope.checksubCounty(
                  subcounties,
                  $scope.oldaddress.countySubdivision
                );
                var places = $scope.checkPlaces(places, $scope.oldaddress.place);
                // MyService.ConsoleLog("subcounty<><><", subcounty);
                // $scope.subcounties = subcounty;
                $scope.places = places;
                // console.log('***********', $scope.places);
                // $scope.Location.countySubdivision = subcounty[0];
                $scope.address.place = places[0];
              }
            },
            function (errorPayload) {
              growl.error('Something went wrong.');
            }
          );
        }; */

      var getLocalsCanceler = $q.defer();
      $scope.getLocals = function (lbl) {
        // MyService.ConsoleLog($scope.oldaddress);
        var state = {},
          county = {};

        if (lbl == "cur") {
          state = $scope.User.cur_state;
          county = JSON.parse($scope.User.cur_county);
        } else if (lbl == "new") {
          state.statePostalCode = $scope.oldaddress.state;
          county.county = $scope.oldaddress.county;
        } else {
          state = JSON.parse($scope.User.sel_state);
          county = JSON.parse($scope.User.sel_county);
        }

        //MyService.ConsoleLog("county : ", county);
        getLocalsCanceler.resolve();

        var request = apiCall.apiCall("GET", "/user/getAllSubCountiesLocal", {
          statePostalCode: state.statePostalCode,
          county: county.county,
          timeout: getLocalsCanceler.promise,
        });
        $http(request).then(
          function successCallback(response) {
            if (response.data.success) {
              if (response.data.data) {
                // MyService.ConsoleLog(response.data.data);
                $scope.places = response.data.data;

                if (lbl == "new") {
                  var subcounty = $scope.checksubCounty(
                    $scope.places,
                    $scope.oldaddress.countySubdivision
                  );

                  var places = $scope.checkPlaces(
                    $scope.places,
                    $scope.oldaddress.place
                  );
                  // MyService.ConsoleLog("subcounty<><><", subcounty[0])
                  $scope.address.countySubdivision = subcounty[0];
                  $scope.address.place = places[0];
                }
              }
            } else {
              growl("Something went wrong.");
            }
          },
          function errorCallBack(response) {
            growl("Something went wrong.");
          }
        );
      };

      $scope.showOfficeAutoComplete = function (electionFor) {
        //MyService.ConsoleLog("showOfficeAutoComplete");
        // ['national', 'state', 'judicial district', 'county', 'sub county', 'city', 'state school board district', 'local', 'school district', 'other']
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "national":
              $scope.running_offices = [
                "president",
                "senate",
                "house of representatives",
                "other",
              ];
              return true;
              break;
            case "state":
              if ($scope.User.state) {
                //fetch office names for this
                //For the options, do a search through the table currently labelled “2016 Alabama” and Find all Item A’s where the Item D is State Postal Code, and item Q is the state selected.  Then add “other” to the end of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "judicial district":
              if ($scope.User.state && $scope.User.district) {
                //fetch office names for this
                //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item F is the district selected. Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "county":
              if ($scope.User.state && $scope.User.county) {
                //fetch office names for this
                //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected.  Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "sub county":
              if (
                $scope.User.state &&
                $scope.User.county &&
                $scope.User.subcounty
              ) {
                //fetch office names for this
                // For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item U is the subcounty selected. Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "city":
              if (
                $scope.User.state &&
                $scope.User.county &&
                $scope.User.locality
              ) {
                //fetch office names for this
                // For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected and U or W match the “city” selection.  Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "state school board district":
              if ($scope.User.state && $scope.User.state_school_dist) {
                //fetch office names for this
                // do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item E is the “District” selection.  Then add “other” to the bottom of the list.
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "local school district":
              if (
                $scope.User.state &&
                $scope.localSchoolDistException() &&
                $scope.User.county &&
                $scope.User.district
              ) {
                //for office names
                // search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the “County” selection and either AD’s, AF’s or  AH’s match the District Name selected.  Then add “other” to the bottom of the list.
                // $scope.offices=['other'];
                return true;
              } else if ($scope.User.state && $scope.User.district) {
                //for options
                //do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item AD’s match the District Name selected.  Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
          }
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "national":
              $scope.offices = [
                "president",
                "senate",
                "house of representatives",
                "other",
              ];
              return true;
              break;
            case "state":
              if ($scope.User.cur_state) {
                //fetch office names for this
                //For the options, do a search through the table currently labelled “2016 Alabama” and Find all Item A’s where the Item D is State Postal Code, and item Q is the state selected.  Then add “other” to the end of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "judicial district":
              if ($scope.User.cur_state && $scope.User.cur_district) {
                //fetch office names for this
                //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item F is the district selected. Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "county":
              if ($scope.User.cur_state && $scope.User.cur_county) {
                //fetch office names for this
                //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected.  Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "sub county":
              if (
                $scope.User.cur_state &&
                $scope.User.cur_county &&
                $scope.User.cur_subcounty
              ) {
                //fetch office names for this
                // For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item U is the subcounty selected. Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "city":
              if (
                $scope.User.cur_state &&
                $scope.User.cur_county &&
                $scope.User.cur_locality
              ) {
                //fetch office names for this
                // For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected and U or W match the “city” selection.  Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "state school board district":
              if ($scope.User.cur_state && $scope.User.cur_state_school_dist) {
                //fetch office names for this
                // do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item E is the “District” selection.  Then add “other” to the bottom of the list.
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "local school district":
              if (
                $scope.User.cur_state &&
                $scope.localSchoolDistException() &&
                $scope.User.cur_county &&
                $scope.User.cur_district
              ) {
                //for office names
                // search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the “County” selection and either AD’s, AF’s or  AH’s match the District Name selected.  Then add “other” to the bottom of the list.
                // $scope.offices=['other'];
                return true;
              } else if ($scope.User.cur_state && $scope.User.cur_district) {
                //for options
                //do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item AD’s match the District Name selected.  Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
          }
          return false;
        }
      };
      var running_flagShowStateDropdown = false;
      var flagShowStateDropdown = false;
      $scope.showSateDropdown = function (electionFor) {
        //MyService.ConsoleLog("showSateDropdown");
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "state":
            case "judicial district":
            case "county":
            case "sub county":
            case "city":
            case "state school board district":
            case "local school district":
              running_flagShowStateDropdown = true;
              return true;
              break;
          }

          switch ($scope.User.office_name) {
            case "senate":
            case "house of representatives":
              running_flagShowStateDropdown = true;
              return true;
              break;
          }

          running_flagShowStateDropdown = false;
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "state":
            case "judicial district":
            case "county":
            case "sub county":
            case "city":
            case "state school board district":
            case "local school district":
              flagShowStateDropdown = true;
              return true;
              break;
          }

          switch ($scope.User.cur_office_name) {
            case "senate":
            case "house of representatives":
              flagShowStateDropdown = true;
              return true;
              break;
          }

          flagShowStateDropdown = false;
          return false;
        }
      };

      $scope.flagShowCandidateDropdown = false;
      $scope.running_flagShowCandidateDropdown = false;

      var fuzzySearch = "";
      $scope.showLoader = false;

      $scope.onOfficeChange = function (electionFor) {
        $scope.showLoader = true;
        if (electionFor == "running") {
          //'Federal', 'State', 'Local'
          var nObj = new Object();
          nObj.level = $scope.User.level;
          nObj.office = $scope.User.off_name;
          nObj.state = JSON.stringify($scope.User.state);
          $scope.running_flagShowCandidateDropdown = true;
          switch ($scope.User.level) {
            // case "Other":
            //   $scope.getRunningCounties();
            //   break;
            case "County":
              $scope.getRunningCounties();
              break;
            // case 'State':
            //   $scope.getRunningStateHouse();
            //   break;
            // case 'Federal':
            //   $scope.getRunningFederal();
            //   break;
            case "Local":
              $scope.getRunningCounties();
              break;

            default:
              MyService.ConsoleLog("default");
              break;
          }
        } else if (electionFor == "incumbent") {
          var nObj = new Object();
          nObj.level = $scope.User.cur_level;
          nObj.office = $scope.User.cur_off_name;
          nObj.state = JSON.stringify($scope.User.cur_state);
          $scope.flagShowCandidateDropdown = true;
          switch ($scope.User.cur_level) {
            // case "Other":
            //   $scope.getCounties();
            //   break;
            case "County":
              $scope.getCounties();
              break;
            // case 'State':
            //   $scope.getStateHouse();
            //   break;
            // case 'Federal':
            //   $scope.getFederal();
            //   break;
            case "Local":
              $scope.getCounties();
              break;

            default:
              MyService.ConsoleLog("default");
              break;
          }
        }
        // MyService.ConsoleLog("nObj<><><><", nObj);
        MyService.getPoliticians(nObj).then(
          function (payload) {
            MyService.ConsoleLog("payload<><><><><>", payload);

            $scope.candidates = payload;
            $scope.showLoader = false;
            MyService.ConsoleLog($scope.running_flagShowCandidateDropdown);
            $scope.candidates.push({
              name: "Other",
            });
            fuzzySearch = new Fuse($scope.candidates, {
              shouldSort: true,
              keys: ["name"],
              caseSensitive: false,
              threshold: 0.4,
            });
          },
          function (errPayload) {
            $scope.showLoader = false;
            //MyService.ConsoleLog("Error");
            //MyService.ConsoleLog(errPayload);
            alert(errPayload);
          }
        );
      };

      $scope.checkReadOnly = false;
      $scope.HideRegisterButton = false;
      $scope.onCandidateChange = function (val) {
        //$scope.User.Candidates;
        $scope.checkReadOnly = false;
        $scope.shortEmail = "";
        // alert("onCandidateChange");
        // MyService.ConsoleLog($scope.User.Candidates);
        // MyService.ConsoleLog($scope.User.NCandidates);
        if (val == "incumbent" && $scope.User.Candidates) {
          if (
            $scope.User.Candidates.name &&
            $scope.User.Candidates.name != null
          ) {
            if ($scope.User.Candidates.name != "Other") {
              $scope.User.name = $scope.User.Candidates.name;
              if (
                $scope.User.Candidates.PublicPhoneNumber &&
                $scope.User.Candidates.PublicPhoneNumber != null
              ) {
                $scope.User.phone_no = $scope.User.Candidates.PublicPhoneNumber;
              } else {
                $scope.User.phone_no = "";
              }
              if (
                $scope.User.Candidates.website &&
                $scope.User.Candidates.website != null
              ) {
                $scope.User.web_url = $scope.User.Candidates.website;
              } else {
                $scope.User.web_url = "";
              }
              if (
                $scope.User.Candidates.public_zipcode &&
                $scope.User.Candidates.public_zipcode != null
              ) {
                $scope.User.ZipCode = $scope.User.Candidates.public_zipcode;
              } else {
                $scope.User.ZipCode = "";
              }
              if (
                $scope.User.Candidates.public_mailing_address &&
                $scope.User.Candidates.public_mailing_address != null
              ) {
                $scope.User.mailing_address =
                  $scope.User.Candidates.public_mailing_address;
              } else {
                $scope.User.mailing_address = "";
              }

              if (
                ($scope.User.Candidates.email &&
                  $scope.User.Candidates.email != null &&
                  $scope.User.Candidates.email != 0) ||
                ($scope.User.Candidates.privateEmail &&
                  $scope.User.Candidates.privateEmail != null &&
                  $scope.User.Candidates.privateEmail != 0)
              ) {
                $scope.HideRegisterButton = true;
                var email = $scope.User.Candidates.email
                  ? $scope.User.Candidates.email
                  : $scope.User.Candidates.privateEmail;
                var cemail = email;
                var firstSix = cemail.substr(0, 6);
                var lastSix = cemail.substr(cemail.length - 6);
                var xlen = cemail.length - 12;
                var xstring = "x".repeat(xlen);
                var finalstring = firstSix + xstring + lastSix;
                $scope.shortEmail = finalstring;
                /*
              var cemail = $scope.User.Candidates.email;
              var firstSix = cemail.substr(0, 6);
              var lastSix = cemail.substr(cemail.length - 6);
              var xlen = cemail.length - 12;
              var xstring = "x".repeat(xlen);
              var finalstring = firstSix + xstring + lastSix;
              $scope.HideRegisterButton = true;
              var msg = "You are already in our system with the email " + finalstring;
              MyService.GetDialogWithButtons(ngDialog, msg, "SignIn", "Please email me my password").then(function(payload) {
                MyService.ConsoleLog("Ans<><><>", payload);
                $scope.User.Email = $scope.User.Candidates.email;
                $scope.checkReadOnly = true;
                if (payload == 1) {
                  $location.path("/signin");
                } else {
                  var postobj = {
                    email: $scope.User.Candidates.email,
                    reset_url: $rootScope.getPasswordResetUrl()
                  };
                  MyService.ConsoleLog("postobj: ", postobj);

                  MyService.forgotPassword(postobj)
                    .then(function(response) {
                      if (response.data.success) {
                        growl.success("An email has been sent.");
                      } else {
                        if (typeof response.data.error == "string")
                          growl.error(response.data.error);
                        else
                          growl.error("Something went wrong");
                      }
                    }, function(err) {
                      growl.error("Something went wrong");
                    });
                }
              }, function(errorPayload) {
                $scope.User.Email = "";
                MyService.ConsoleLog("errorPayload<><><>", errorPayload);
                $scope.checkReadOnly = false;
                if (errorPayload == 0) {
                  var postobj = {
                    email: $scope.User.Candidates.email,
                    reset_url: $rootScope.getPasswordResetUrl()
                  };
                  MyService.ConsoleLog("postobj: ", postobj);

                  MyService.forgotPassword(postobj)
                    .then(function(response) {
                      if (response.data.success) {
                        growl.success("An email has been sent.");
                      } else {
                        if (typeof response.data.error == "string")
                          growl.error(response.data.error);
                        else
                          growl.error("Something went wrong");
                      }
                    }, function(err) {
                      growl.error("Something went wrong");
                    });
                }
              });
              */
              } else {
                $scope.User.Email = "";
                $scope.User.phone_no = "";
                $scope.User.web_url = "";
                $scope.User.ZipCode = "";
                $scope.User.mailing_address = "";
              }
            } else {
              //If candidate is Other
              //MyService.ConsoleLog("Other selected");
            }
          } else {
            $scope.User.name = "";
            $scope.User.phone_no = "";
            $scope.User.web_url = "";
            $scope.User.ZipCode = "";
            $scope.User.mailing_address = "";
          }
        } else {
          MyService.ConsoleLog("Else 1", $scope.User.NCandidates);
          if ($scope.User.NCandidates) {
            if (
              $scope.User.NCandidates.name &&
              $scope.User.NCandidates.name != null
            ) {
              if ($scope.User.NCandidates.name != "Other") {
                $scope.User.name = $scope.User.NCandidates.name;
                MyService.ConsoleLog(
                  "Other than <><><><<",
                  $scope.User.NCandidates.name
                );
                if (
                  $scope.User.NCandidates.PublicPhoneNumber &&
                  $scope.User.NCandidates.PublicPhoneNumber != null
                ) {
                  $scope.User.phone_no =
                    $scope.User.NCandidates.PublicPhoneNumber;
                } else {
                  $scope.User.phone_no = "";
                }
                if (
                  $scope.User.NCandidates.website &&
                  $scope.User.NCandidates.website != null
                ) {
                  $scope.User.web_url = $scope.User.NCandidates.website;
                } else {
                  $scope.User.web_url = "";
                }
                if (
                  $scope.User.NCandidates.public_zipcode &&
                  $scope.User.NCandidates.public_zipcode != null
                ) {
                  $scope.User.ZipCode = $scope.User.NCandidates.public_zipcode;
                } else {
                  $scope.User.ZipCode = "";
                }
                if (
                  $scope.User.NCandidates.public_mailing_address &&
                  $scope.User.NCandidates.public_mailing_address != null
                ) {
                  $scope.User.NCandidates =
                    $scope.User.NCandidates.public_mailing_address;
                } else {
                  $scope.User.mailing_address = "";
                }
                MyService.ConsoleLog(
                  "NCandidates<><><>",
                  $scope.User.NCandidates
                );

                if (
                  ($scope.User.NCandidates.email &&
                    $scope.User.NCandidates.email != null &&
                    $scope.User.NCandidates.email != 0) ||
                  ($scope.User.NCandidates.privateEmail &&
                    $scope.User.NCandidates.privateEmail != null &&
                    $scope.User.NCandidates.privateEmail != 0)
                ) {
                  $scope.HideNewRegisterButton = true;
                  var email = $scope.User.NCandidates.email
                    ? $scope.User.NCandidates.email
                    : $scope.User.NCandidates.privateEmail;
                  var cemail = email;
                  var firstSix = cemail.substr(0, 6);
                  var lastSix = cemail.substr(cemail.length - 6);
                  var xlen = cemail.length - 12;
                  var xstring = "x".repeat(xlen);
                  var finalstring = firstSix + xstring + lastSix;
                  $scope.shortEmail = finalstring;
                  /*
                var cemail = $scope.User.NCandidates.email;
                var firstSix = cemail.substr(0, 6);
                var lastSix = cemail.substr(cemail.length - 6);
                var xlen = cemail.length - 12;
                var xstring = "x".repeat(xlen);
                var finalstring = firstSix + xstring + lastSix;
                var msg = "You are already in our system with the email " + finalstring;
                MyService.GetDialogWithButtons(ngDialog, msg, "SignIn", "Please email me my password").then(function(payload) {
                  MyService.ConsoleLog("Ans<><><>", payload);
                  $scope.User.Email = $scope.User.NCandidates.email;
                  $scope.checkReadOnly = true;
                  if (payload == 1) {
                    $location.path("/signin");
                  } else {
                    var postobj = {
                      email: $scope.User.NCandidates.email,
                      reset_url: $rootScope.getPasswordResetUrl()
                    };
                    MyService.ConsoleLog("postobj: ", postobj);

                    MyService.forgotPassword(postobj)
                      .then(function(response) {
                        if (response.data.success) {
                          growl.success("An email has been sent.");
                        } else {
                          if (typeof response.data.error == "string")
                            growl.error(response.data.error);
                          else
                            growl.error("Something went wrong");
                        }
                      }, function(err) {
                        growl.error("Something went wrong");
                      });
                  }
                }, function(errorPayload) {
                  $scope.User.Email = "";
                  MyService.ConsoleLog("errorPayload<><><>", errorPayload);
                  $scope.checkReadOnly = false;
                  if (errorPayload == 0) {
                    var postobj = {
                      email: $scope.User.NCandidates.email,
                      reset_url: $rootScope.getPasswordResetUrl()
                    };
                    MyService.ConsoleLog("postobj: ", postobj);

                    MyService.forgotPassword(postobj)
                      .then(function(response) {
                        if (response.data.success) {
                          growl.success("An email has been sent.");
                        } else {
                          if (typeof response.data.error == "string")
                            growl.error(response.data.error);
                          else
                            growl.error("Something went wrong");
                        }
                      }, function(err) {
                        growl.error("Something went wrong");
                      });
                  }
                });
                */
                } else {
                  $scope.User.Email = "";
                  $scope.User.phone_no = "";
                  $scope.User.web_url = "";
                  $scope.User.ZipCode = "";
                  $scope.User.mailing_address = "";
                }
              } else {
                //If candidate is Other
                //MyService.ConsoleLog("Other selected");
              }
            } else {
              $scope.User.name = "";
              $scope.User.phone_no = "";
              $scope.User.web_url = "";
              $scope.User.ZipCode = "";
              $scope.User.mailing_address = "";
            }
          }
        }
      };

      $scope.sendPostCard = false;
      $scope.PostcardSend = false;
      $scope.generatePostcard = function () {
        var postCard = Math.random().toString(36).substr(2, 10);

        MyService.checkPostCard({
          postcard: postCard,
        }).then(
          function (payload) {
            // MyService.ConsoleLog("Payload<><><<>",payload);
            var alldata = payload.data;
            // MyService.ConsoleLog("alldata<><><>", alldata);
            var taken = alldata.taken;
            // MyService.ConsoleLog("taken<><><>", taken);
            $scope.PostcardSend = true;
            if (!taken) {
              // MyService.ConsoleLog(taken);
              $scope.User.postCard = postCard.toUpperCase();
            } else {
              // MyService.ConsoleLog(taken);
              //$scope.generatePostcard();
            }
          },
          function (errorPayload) {
            $scope.User.postCard = postCard.toUpperCase();
            // MyService.ConsoleLog("errorPayload<><><<>",errorPayload);
          }
        );
      };

      $scope.submitPostcard = function (data) {
        MyService.ConsoleLog(
          "confirmPostalCode<><><>",
          $scope.User.confirmPostalCode
        );
        if ($scope.User.postCard == $scope.User.confirmPostalCode) {
          $scope.verifiedUser = "true";
          MyService.ConsoleLog($scope.verifiedUser);
          var message = "Thank you for confirming your account.";
          var modal = ngDialog.openConfirm({
            template:
              "<p>" +
              message +
              '</p>\
                    <div class="ngdialog-buttons">\
                        <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                    </div>',
            plain: true,
          });
          modal.then(
            function fullfilled(data) {
              //MyService.ConsoleLog("fullfilled: ",data);
            },
            function rejected(data) {
              //MyService.ConsoleLog("rejected: ",data);
            }
          );
        } else {
          $scope.verifiedUser = "false";
          var message =
            "Your postcard code doesn't match with ours. Please try again.";
          var modal = ngDialog.openConfirm({
            template:
              "<p>" +
              message +
              '</p>\
                    <div class="ngdialog-buttons">\
                        <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                    </div>',
            plain: true,
          });
          modal.then(
            function fullfilled(data) {
              //MyService.ConsoleLog("fullfilled: ",data);
            },
            function rejected(data) {
              //MyService.ConsoleLog("rejected: ",data);
            }
          );
        }
      };

      $scope.showcur_office_name = false;
      $scope.showcur_office_location = false;
      $scope.checkExists = function () {
        if ($scope.User.cur_Candidates != "" && !$scope.User.name_on_ballot) {
          MyService.ConsoleLog("inside");
          $scope.User.name_on_ballot = $scope.User.cur_Candidates;
          $scope.showcur_office_name = true;
          $scope.showcur_office_location = true;
        }
      };

      $scope.closeEdit = function (col) {
        // alert("here");
        // MyService.ConsoleLog(col);
        var nval = JSON.parse(col.value);
        // MyService.ConsoleLog(nval);
        $scope.User.Candidates = nval;
        $scope.User.cur_Candidates = nval.name;
        $scope.User.cur_office_name = nval.office;
        $scope.User.cur_office_email = nval.publicEmail;
        $scope.User.postCard = nval.postCard;
        $scope.User.cur_office_phone = nval.publicPhoneNumber;
        $scope.User.cur_office_website = nval.website;
        if ($scope.User.cur_office_name != "") {
          $scope.showcur_office_name = true;
        }
        $scope.User.cur_office_location = nval.officePlace;
        if ($scope.User.cur_office_location != "") {
          $scope.showcur_office_location = true;
        }
        $scope.User.from_date = nval.fromDate;
        $scope.User.end_date = nval.endDate;
        $scope.User.Email = nval.email ? nval.email : nval.privateEmail;
        $scope.User.name_on_ballot = nval.name;

        if (!$scope.User.Email) {
          //alert("here");
          $scope.sendPostCard = true;
        }

        MyService.ConsoleLog("Email:::", $scope.User.Email);
        // var result = document.getElementsByClassName("ac-container");
        // MyService.ConsoleLog(result);
        // result[0].blur();
        document
          .getElementById("curCandidate")
          .getElementsByTagName("input")[0]
          .blur();
        $scope.onCandidateChange("incumbent");
        //var nval = col.value? col.value: col.displayName
      };

      function suggest_name(term) {
        var q = term.toLowerCase().trim();
        var results = [];
        var len = $scope.candidates.length;
        // Find first 10 states that start with `term`.
        for (var i = 0; i < len && results.length < 10; i++) {
          var name = $scope.candidates[i].name;
          var matched = name.match(new RegExp(q, "i"));
          //MyService.ConsoleLog(state.match())
          //MyService.ConsoleLog(matched);
          //MyService.ConsoleLog(state.match(q, "i"));
          if (matched) {
            results.push({
              label: $sce.trustAsHtml(name),
              value: JSON.stringify($scope.candidates[i]),
            });
          }
        }
        return results;
      }

      function highlight(str, term) {
        // MyService.ConsoleLog("str<><><><",str);
        var highlight_regex = new RegExp("(" + term + ")", "gi");
        return str.replace(
          highlight_regex,
          '<span class="highlight">$1</span>'
        );
      }

      function fuzzy_suggest(term) {
        if (!term) return [];
        // MyService.ConsoleLog(fuzzySearch);
        return fuzzySearch
          .search(term)
          .slice(0, 10)
          .map(function (i) {
            // MyService.ConsoleLog("I",i);
            // MyService.ConsoleLog($scope.candidates);
            // MyService.ConsoleLog(i);
            var val = i.name;
            // MyService.ConsoleLog("val:::", val);
            return {
              value: JSON.stringify(i),
              label: $sce.trustAsHtml(highlight(val + "-" + i.office, term)),
            };
          });
      }

      $scope.autocomplete_options = {
        suggest: fuzzy_suggest,
        on_select: $scope.closeEdit,
      };

      $scope.running_flagShowCandidateDropdown = false;
      $scope.closeEditNew = function (col) {
        // alert("here");
        // MyService.ConsoleLog(col);
        var nval = JSON.parse(col.value);
        MyService.ConsoleLog(nval);
        $scope.User.NCandidates = nval;
        $scope.User.new_Candidates = nval.name;
        $scope.User.office_name = nval.office;
        $scope.User.office_email = nval.email;
        $scope.User.office_phone = nval.publicPhoneNumber;
        $scope.User.office_website = nval.website;
        if ($scope.User.cur_office_name != "") {
          $scope.showcur_office_name = true;
        }
        $scope.User.office_location = nval.officePlace;

        if ($scope.User.cur_office_location != "") {
          $scope.showcur_office_location = true;
        }

        $scope.User.from_date = nval.fromDate;
        $scope.User.end_date = nval.endDate;
        $scope.User.Email = nval.email ? nval.email : nval.privateEmail;
        $scope.User.name_on_ballot = nval.name;
        // alert($scope.User.Email);
        if (!$scope.User.Email) {
          //alert("here=", $scope.User.Email);
          $scope.sendPostCardNew = true;
        }

        // MyService.ConsoleLog("Email:::", $scope.User.Email);
        // var result = document.getElementsByClassName("ac-container");
        // MyService.ConsoleLog(result);
        // result[0].blur();

        document
          .getElementById("curCandidate")
          .getElementsByTagName("input")[0]
          .blur();
        $scope.onCandidateChange("running");
        //var nval = col.value? col.value: col.displayName
      };

      $scope.HideNewRegisterButton = false;
      $scope.shownew_office_name = false;
      $scope.checkExistsNew = function () {
        // MyService.ConsoleLog($scope.User.new_Candidates);
        // MyService.ConsoleLog("name_on_ballot<><><><>",$scope.User.name_on_ballot);
        if (
          $scope.User.new_Candidates != "" &&
          $scope.User.new_Candidates != $scope.User.name_on_ballot
        ) {
          // MyService.ConsoleLog("inside");
          $scope.User.name_on_ballot = $scope.User.new_Candidates;
        }

        if (!$scope.User.NCandidates) {
          //alert("NCandidates");
          $scope.shownew_office_name = true;
        }
      };

      function fuzzy_suggest_new(term) {
        if (!term) return [];
        // MyService.ConsoleLog(fuzzySearch);
        return fuzzySearch
          .search(term)
          .slice(0, 10)
          .map(function (i) {
            // MyService.ConsoleLog("I",i);
            // MyService.ConsoleLog($scope.candidates);
            // MyService.ConsoleLog(i);
            var val = i.name;
            // MyService.ConsoleLog("val:::", val);
            return {
              value: JSON.stringify(i),
              label: $sce.trustAsHtml(highlight(val + "-" + i.office, term)),
            };
          });
      }

      $scope.autocomplete_new_options = {
        suggest: fuzzy_suggest_new,
        on_select: $scope.closeEditNew,
      };
      $scope.allPoliticians = [];

      function suggest_politician_name(term) {
        var results = [];
        for (var i = 0; i < $scope.allPoliticians.length; i++) {
          results.push({
            label: $sce.trustAsHtml(
              $scope.allPoliticians[i].name +
                "-" +
                $scope.allPoliticians[i].office
            ),
            value: JSON.stringify($scope.allPoliticians[i]),
          });
        }
        return results;
      }

      function suggest_politician_name_remote(term) {
        var deferred = $q.defer();
        var params = new Object();
        params.term = term;
        $scope.allPoliticians.length = 0;
        var request = apiCall.apiCall("GET", "/politician/fuzzySearch", params);
        // request.timeout = canceler;
        $http(request).then(
          function successCallback(response) {
            // MyService.ConsoleLog("Got Politician: ", response);
            $scope.allPoliticians = response.data.data;
            /*
        if (response.data.success) {
            deferred.resolve(response.data.data);
        } else {
            deferred.reject(response.data);
        }
        */
            deferred.resolve(suggest_politician_name(term));
          },
          function errorCallBack(response) {
            deferred.reject(response);
          }
        );
        return deferred.promise;
      }

      $scope.onCandidateChangePolitician = function (val) {
        //$scope.User.Candidates;
        $scope.checkReadOnly = false;

        MyService.ConsoleLog($scope.User.name_on_ballot);
        if ($scope.User.name_on_ballot) {
          if (
            $scope.User.name_on_ballot.name &&
            $scope.User.name_on_ballot.name != null
          ) {
            if ($scope.User.name_on_ballot.name != "Other") {
              $scope.User.name = $scope.User.name_on_ballot.name;
              if (
                $scope.User.name_on_ballot.PublicPhoneNumber &&
                $scope.User.name_on_ballot.PublicPhoneNumber != null
              ) {
                $scope.User.phone_no =
                  $scope.User.name_on_ballot.PublicPhoneNumber;
              } else {
                $scope.User.phone_no = "";
              }
              if (
                $scope.User.name_on_ballot.website &&
                $scope.User.name_on_ballot.website != null
              ) {
                $scope.User.web_url = $scope.User.name_on_ballot.website;
              } else {
                $scope.User.web_url = "";
              }
              if (
                $scope.User.name_on_ballot.public_zipcode &&
                $scope.User.name_on_ballot.public_zipcode != null
              ) {
                $scope.User.ZipCode = $scope.User.name_on_ballot.public_zipcode;
              } else {
                $scope.User.ZipCode = "";
              }
              if (
                $scope.User.name_on_ballot.public_mailing_address &&
                $scope.User.name_on_ballot.public_mailing_address != null
              ) {
                $scope.User.mailing_address =
                  $scope.User.name_on_ballot.public_mailing_address;
              } else {
                $scope.User.mailing_address = "";
              }
              /*
            if ($scope.User.name_on_ballot.email && $scope.User.name_on_ballot.email != null && $scope.User.name_on_ballot.email != 0) {
              var msg = "We already have your email with us.<br> Your Email in our db is : <br> <center>" + $scope.User.name_on_ballot.email + "<center><br> Do you want to use it for registration?"
              MyService.GetDialogWithButtons(ngDialog, msg, "YES", "NO").then(function(payload) {
                $scope.User.Email = $scope.User.name_on_ballot.email;
                $scope.checkReadOnly = true;
              }, function(errorPayload) {
                $scope.User.Email = "";
                $scope.checkReadOnly = false;
              });
            } else {
              $scope.User.Email = "";
              $scope.User.phone_no = "";
              $scope.User.web_url = "";
              $scope.User.ZipCode = "";
              $scope.User.mailing_address = "";
            }
            */
            } else {
              //If candidate is Other
              //MyService.ConsoleLog("Other selected");
            }
          } else {
            $scope.User.name = "";
            $scope.User.phone_no = "";
            $scope.User.web_url = "";
            $scope.User.ZipCode = "";
            $scope.User.mailing_address = "";
          }
        }
      };
      $scope.politicianSelected = false;
      $scope.selectedPolitician = function (col) {
        // alert("here");
        MyService.ConsoleLog(col);
        var nval = JSON.parse(col.value);
        MyService.ConsoleLog(nval);
        $scope.User.name_on_ballot = nval.name;
        var result = document.getElementsByClassName("ac-container");
        // MyService.ConsoleLog(result);
        result[0].style.display = "none";
        // var wrappedResult = angular.element(result);
        // MyService.ConsoleLog(wrappedResult);
        $scope.politicianSelected = true;
        $scope.onCandidateChangePolitician();
        //var nval = col.value? col.value: col.displayName
      };

      $scope.autocomplete_politician_name = {
        suggest: suggest_politician_name_remote,
        on_select: $scope.selectedPolitician,
      };

      var running_flagCongressional = false;
      var flagCongressional = false;
      $scope.showCongressionalDropdown = function (electionFor) {
        //MyService.ConsoleLog("showCongressionalDropdown");
        if (electionFor == "running") {
          if (
            $scope.User.office_name == "house of representatives" &&
            $scope.User.state
          ) {
            running_flagCongressional = true;
            return true;
          }
          running_flagCongressional = false;
          return false;
        } else if (electionFor == "incumbent") {
          if (
            $scope.User.cur_office_name == "house of representatives" &&
            $scope.User.cur_state
          ) {
            flagCongressional = true;
            return true;
          }
          flagCongressional = false;
          return false;
        }
      };
      var running_flagDist = false;
      var flagDist = false;
      $scope.showDistrictDropdown = function (electionFor) {
        //MyService.ConsoleLog("showDistrictDropdown");
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "judicial district":
              if ($scope.User.state) {
                running_flagDist = true;
                return true;
              }
              // For the District options, do a search through the table currently labelled “2016 Alabama” and Find all Item F’s with item Q as the state selected.
              break;
          }
          running_flagDist = false;
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "judicial district":
              if ($scope.User.cur_state) {
                flagDist = true;
                return true;
              }
              // For the District options, do a search through the table currently labelled “2016 Alabama” and Find all Item F’s with item Q as the state selected.
              break;
          }
          flagDist = false;
          return false;
        }
      };
      var running_flagConty = false;
      var flagConty = false;
      $scope.showCountyDropdown = function (electionFor) {
        //MyService.ConsoleLog("showCountyDropdown");
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "county":
            case "sub county":
            case "city":
              if ($scope.User.state) {
                running_flagConty = true;
                return true;
              }
              break;
            case "local school district":
              var exceptionState = ["AK", "DC", "VA"];
              if (
                $scope.User.state &&
                exceptionState.indexOf($scope.User.state.statePostalCode) == -1
              ) {
                running_flagConty = true;
                return true;
              }
              break;
          }
          running_flagConty = false;
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "county":
            case "sub county":
            case "city":
              if ($scope.User.cur_state) {
                flagConty = true;
                return true;
              }
              break;
            case "local school district":
              var exceptionState = ["AK", "DC", "VA"];
              if (
                $scope.User.cur_state &&
                exceptionState.indexOf($scope.User.cur_state.statePostalCode) ==
                  -1
              ) {
                flagConty = true;
                return true;
              }
              break;
          }
          flagConty = false;
          return false;
        }
      };
      var running_flagSubConty = false;
      var flagSubConty = false;
      $scope.showSubCountyDropdown = function (electionFor) {
        //MyService.ConsoleLog("showSubCountyDropdown");
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "sub county":
              if ($scope.User.state && $scope.User.county) {
                running_flagSubConty = true;
                return true;
              }
              break;
          }
          running_flagSubConty = false;
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "sub county":
              if ($scope.User.cur_state && $scope.User.cur_county) {
                flagSubConty = false;
                return true;
              }
              break;
          }
          flagSubConty = false;
          return false;
        }
      };
      var running_flagLocality = false;
      var flagLocality = false;
      $scope.showLocalityDropdown = function (electionFor) {
        //MyService.ConsoleLog("showLocalityDropdown");
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "city":
              if ($scope.User.state && $scope.User.county) {
                running_flagLocality = true;
                return true;
              }
              // for options, list all unique county subdivision names and place names within the selected county within the selected state
              break;
          }
          running_flagLocality = false;
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "city":
              if ($scope.User.cur_state && $scope.User.cur_county) {
                flagLocality = true;
                return true;
              }
              // for options, list all unique county subdivision names and place names within the selected county within the selected state
              break;
          }
          flagLocality = false;
          return false;
        }
      };
      var running_flagStateSchoolDist = false;
      var flagStateSchoolDist = false;
      $scope.showStateSchoolDistDropdown = function (electionFor) {
        //MyService.ConsoleLog("showStateSchoolDistDropdown");
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "state school board district":
              if ($scope.User.state) {
                running_flagStateSchoolDist = true;
                return true;
              }
              // For the District options,
              //list all item E’s where item Q is the state selected
              break;
          }
          running_flagStateSchoolDist = false;
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "state school board district":
              if ($scope.User.cur_state) {
                flagStateSchoolDist = true;
                return true;
              }
              // For the District options,
              //list all item E’s where item Q is the state selected
              break;
          }
          flagStateSchoolDist = false;
          return false;
        }
      };
      var running_flagLocalSchoolDist = false;
      var flagLocalSchoolDist = false;
      $scope.showLocalSchoolDistDropdown = function (electionFor) {
        //MyService.ConsoleLog("showDistrictDropdown");
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "local school district":
              if ($scope.User.state) {
                if ($scope.User.state && $scope.localSchoolDistException()) {
                  if ($scope.User.state && $scope.User.county) {
                    running_flagLocalSchoolDist = true;
                    return true;
                  }
                  // For the District options,
                  // results of a search through the table currently labelled “2016 Alabama” and find all AD’s, AF’s  and AH’s  where item Q is the state selected and item S is the “County” selection
                } else if ($scope.User.state) {
                  // for District options
                  // do a search through the table currently labelled “2016 Alabama” and find all AD’s where the item Q is the state selected.
                  running_flagLocalSchoolDist = true;
                  return true;
                }
              }
              break;
          }
          running_flagLocalSchoolDist = false;
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "local school district":
              if ($scope.User.cur_state) {
                if (
                  $scope.User.cur_state &&
                  $scope.localSchoolDistException()
                ) {
                  if ($scope.User.cur_state && $scope.User.cur_county) {
                    flagLocalSchoolDist = true;
                    return true;
                  }
                  // For the District options,
                  // results of a search through the table currently labelled “2016 Alabama” and find all AD’s, AF’s  and AH’s  where item Q is the state selected and item S is the “County” selection
                } else if ($scope.User.cur_state) {
                  // for District options
                  // do a search through the table currently labelled “2016 Alabama” and find all AD’s where the item Q is the state selected.
                  flagLocalSchoolDist = true;
                  return true;
                }
              }
              break;
          }
          flagLocalSchoolDist = false;
          return false;
        }
      };

      $scope.congressionalDistricts = [];
      var getAddressOfRunningPoliCanceler = $q.defer();
      $scope.running_flagShowOfficeDropdown = false;
      $scope.flagShowOfficeDropdown = false;
      $scope.showlevelOfGovt = [];
      $scope.onStateChange = function (electionFor) {
        //MyService.ConsoleLog("** onStateChange **", electionFor);
        if (electionFor == "running") {
          //'State and Federal', 'County', 'School', 'Local', 'Judicial'
          switch ($scope.User.level) {
            case "County":
              $scope.showlevelOfGovt = angular.copy($scope.countylevelOfGovt);
              $scope.running_flagShowOfficeDropdown = true;
              break;
            case "State and Federal":
              $scope.showlevelOfGovt = angular.copy($scope.statelevelOfGovt);
              $scope.running_flagShowOfficeDropdown = true;
              break;
            case "School":
              $scope.showlevelOfGovt = angular.copy($scope.schoollevelOfGovt);
              $scope.running_flagShowOfficeDropdown = true;
              break;
            case "Judicial":
              $scope.showlevelOfGovt = angular.copy($scope.judiciallevelOfGovt);
              $scope.running_flagShowOfficeDropdown = true;
              break;
            case "Local":
              $scope.showlevelOfGovt = angular.copy($scope.locallevelOfGovt);
              $scope.running_flagShowOfficeDropdown = true;
              break;
            default:
              $scope.showlevelOfGovt = angular.copy($scope.statelevelOfGovt);
              $scope.running_flagShowOfficeDropdown = false;
              break;
          }
          //MyService.ConsoleLog($scope.User.level);
          /*setTimeout(function() {
            $scope.$apply(function() {
                $scope.showlevelOfGovt = $scope.showlevelOfGovt1;
                //MyService.ConsoleLog($scope.showlevelOfGovt);
                $scope.User.off_name = $scope.showlevelOfGovt[0];
            });
        }, 100);*/
          //$scope.User.off_name = $scope.showlevelOfGovt[0];

          /*
        if ($scope.User.state) {

            switch ($scope.User.level) {
                case 'state':
                    if ($scope.User.state) {
                        $scope.User.office_name = null;
                        //fetch office names for this
                        //For the options, do a search through the table currently labelled “2016 Alabama” and Find all Item A’s where the Item D is = "State Postal Code", and item Q is the state selected.  Then add “other” to the end of the list
                        $scope.running_offices = [];
                        MyService.getAddressOfRunningPoli({
                            StatePostalCode: $scope.User.state.statePostalCode,
                            voterScope: "State Postal Code",
                            return_field: "office",
                            timeout: getAddressOfRunningPoliCanceler.promise
                        }).then(function(response) {
                            if (response.data.success == true) {
                                $timeout(function() {
                                    $scope.running_offices = response.data.data;
                                    $scope.running_offices.push("other");
                                    //MyService.ConsoleLog("--- Got offices data ---: ", $scope.running_offices);
                                });
                            } else if (response.data.error && typeof response.data.error == "string") {
                                growl.error('Error: ' + response.data.error);
                            } else {
                                growl.error('Something went wrong.');
                            }
                        });
                    }
                    break;

                case 'judicial district':
                    if ($scope.User.state) {
                        $scope.User.office_name = null;
                        // For the District options, do a search through the table currently labelled “2016 Alabama” and Find all Item F’s with item Q as the state selected.
                        MyService.getAddressOfRunningPoli({
                            StatePostalCode: $scope.User.state.statePostalCode,
                            return_field: "JudicialCircuitNumber",
                            timeout: getAddressOfRunningPoliCanceler.promise
                        }).then(function(response) {
                            if (response.data.success == true) {
                                $timeout(function() {
                                    $scope.running_districts = response.data.data;
                                    //MyService.ConsoleLog("--- Got district data ---: ", $scope.running_districts);
                                });
                            } else if (response.data.error && typeof response.data.error == "string") {
                                growl.error('Error: ' + response.data.error);
                            } else {
                                growl.error('Something went wrong.');
                            }
                        });
                    }
                    break;

                case "county":
                case "sub county":
                case "city":
                    if ($scope.User.state) {
                        $scope.User.office_name = null;
                        // For the District options, do a search through the table currently labelled “2016 Alabama” and Find all Item F’s with item Q as the state selected.
                        MyService.getAddressOfRunningPoli({
                            StatePostalCode: $scope.User.state.statePostalCode,
                            return_field: "CountyName",
                            timeout: getAddressOfRunningPoliCanceler.promise
                        }).then(function(response) {
                            if (response.data.success == true) {
                                $timeout(function() {
                                    $scope.running_counties = response.data.data;
                                    //MyService.ConsoleLog("--- Got counties data ---: ", $scope.running_counties);
                                });
                            } else if (response.data.error && typeof response.data.error == "string") {
                                growl.error('Error: ' + response.data.error);
                            } else {
                                growl.error('Something went wrong.');
                            }
                        });
                    }
                    break;

                case 'state school board district':
                    if ($scope.User.state) {
                        $scope.User.office_name = null;
                        // do a search through the table currently labelled “2016 Alabama” and list all item E’s where item Q is the state selected.
                        MyService.getAddressOfRunningPoli({
                            StatePostalCode: $scope.User.state.statePostalCode,
                            return_field: "StateBoardEducationDistrict",
                            timeout: getAddressOfRunningPoliCanceler.promise
                        }).then(function(response) {
                            if (response.data.success == true) {
                                $timeout(function() {
                                    $scope.running_stateSchoolDistricts = response.data.data;
                                    //MyService.ConsoleLog("--- Got district data ---: ", running_stateSchoolDistricts);
                                });
                            } else if (response.data.error && typeof response.data.error == "string") {
                                growl.error('Error: ' + response.data.error);
                            } else {
                                growl.error('Something went wrong.');
                            }
                        });
                    }
                    break;

                case 'local school district':
                    $scope.User.office_name = null;
                    if (!$scope.localSchoolDistException()) {
                        // /if($scope.User.cur_state && $scope.localSchoolDistException())
                        MyService.getAddressOfRunningPoli({
                            StatePostalCode: $scope.User.state.statePostalCode,
                            return_field: "CountyName",
                            timeout: getAddressOfRunningPoliCanceler.promise
                        }).then(function(response) {
                            if (response.data.success == true) {
                                $timeout(function() {
                                    $scope.running_counties = response.data.data;
                                    //MyService.ConsoleLog("--- Got counties data ---: ", $scope.running_counties);
                                });
                            } else if (response.data.error && typeof response.data.error == "string") {
                                growl.error('Error: ' + response.data.error);
                            } else {
                                growl.error('Something went wrong.');
                            }
                        });
                    } else {
                        //for options
                        // do a search through the table currently labelled “2016 Alabama” and find all AD’s where the item Q is the state selected.
                        MyService.getAddressOfRunningPoli({
                            StatePostalCode: $scope.User.state.statePostalCode,
                            return_field: "UnifiedSchoolDistrictName",
                            timeout: getAddressOfRunningPoliCanceler.promise
                        }).then(function(response) {
                            if (response.data.success == true) {
                                $timeout(function() {
                                    var tempArr = [];
                                    angular.forEach(response.data.data, function(val, key) {
                                        tempArr.push({
                                            label: val,
                                            type: "UnifiedSchoolDistrictName"
                                        });
                                    });
                                    $scope.localSchoolDistricts = tempArr;
                                    //MyService.ConsoleLog("--- Got localSchoolDistricts data ---: ", $scope.localSchoolDistricts);
                                });
                            } else if (response.data.error && typeof response.data.error == "string") {
                                growl.error('Error: ' + response.data.error);
                            } else {
                                growl.error('Something went wrong.');
                            }
                        });
                    }
                    break;
            }

            if ($scope.User.office_name) {
                if ($scope.User.state) {
                    getAddressOfRunningPoliCanceler.resolve();
                    MyService.getAddressOfRunningPoli({
                        StatePostalCode: $scope.User.state.statePostalCode,
                        return_field: "FederalCongressionalDistrict",
                        timeout: getAddressOfRunningPoliCanceler.promise
                    }).then(function(response) {
                        if (response.data.success == true) {
                            $timeout(function() {
                                $scope.running_congressionalDistricts = response.data.data;
                                //MyService.ConsoleLog("--- Got congressionalDistricts data ---");
                            });
                        } else if (response.data.error && typeof response.data.error == "string") {
                            growl.error('Error: ' + response.data.error);
                        } else {
                            growl.error('Something went wrong.');
                        }
                    });
                }
            }
        } //state selected
        */
          //$scope.User.off_name = $scope.showlevelOfGovt[0];
        } else if (electionFor == "incumbent") {
          /*
        if ($scope.User.cur_state) {
            switch ($scope.User.cur_level) {
                case 'state':
                    if ($scope.User.cur_state) {
                        $scope.User.cur_office_name = null;
                        //fetch office names for this
                        //For the options, do a search through the table currently labelled “2016 Alabama” and Find all Item A’s where the Item D is = "State Postal Code", and item Q is the state selected.  Then add “other” to the end of the list
                        $scope.offices = [];
                        MyService.getAddressOfRunningPoli({
                            StatePostalCode: $scope.User.cur_state.statePostalCode,
                            voterScope: "State Postal Code",
                            return_field: "office",
                            timeout: getAddressOfRunningPoliCanceler.promise
                        }).then(function(response) {
                            if (response.data.success == true) {
                                $timeout(function() {
                                    $scope.offices = response.data.data;
                                    $scope.offices.push("other");
                                    //MyService.ConsoleLog("--- Got offices data ---: ", $scope.offices);
                                });
                            } else if (response.data.error && typeof response.data.error == "string") {
                                growl.error('Error: ' + response.data.error);
                            } else {
                                growl.error('Something went wrong.');
                            }
                        });
                    }
                    break;

                case 'judicial district':
                    if ($scope.User.cur_state) {
                        $scope.User.cur_office_name = null;
                        // For the District options, do a search through the table currently labelled “2016 Alabama” and Find all Item F’s with item Q as the state selected.
                        MyService.getAddressOfRunningPoli({
                            StatePostalCode: $scope.User.cur_state.statePostalCode,
                            return_field: "JudicialCircuitNumber",
                            timeout: getAddressOfRunningPoliCanceler.promise
                        }).then(function(response) {
                            if (response.data.success == true) {
                                $timeout(function() {
                                    $scope.districts = response.data.data;
                                    //MyService.ConsoleLog("--- Got district data ---: ", $scope.districts);
                                });
                            } else if (response.data.error && typeof response.data.error == "string") {
                                growl.error('Error: ' + response.data.error);
                            } else {
                                growl.error('Something went wrong.');
                            }
                        });
                    }
                    break;

                case "county":
                case "sub county":
                case "city":
                    if ($scope.User.cur_state) {
                        $scope.User.cur_office_name = null;
                        // For the District options, do a search through the table currently labelled “2016 Alabama” and Find all Item F’s with item Q as the state selected.
                        MyService.getAddressOfRunningPoli({
                            StatePostalCode: $scope.User.cur_state.statePostalCode,
                            return_field: "CountyName",
                            timeout: getAddressOfRunningPoliCanceler.promise
                        }).then(function(response) {
                            if (response.data.success == true) {
                                $timeout(function() {
                                    $scope.counties = response.data.data;
                                    //MyService.ConsoleLog("--- Got counties data ---: ", $scope.counties);
                                });
                            } else if (response.data.error && typeof response.data.error == "string") {
                                growl.error('Error: ' + response.data.error);
                            } else {
                                growl.error('Something went wrong.');
                            }
                        });
                    }
                    break;

                case 'state school board district':
                    if ($scope.User.cur_state) {
                        $scope.User.cur_office_name = null;
                        // do a search through the table currently labelled “2016 Alabama” and list all item E’s where item Q is the state selected.
                        MyService.getAddressOfRunningPoli({
                            StatePostalCode: $scope.User.cur_state.statePostalCode,
                            return_field: "StateBoardEducationDistrict",
                            timeout: getAddressOfRunningPoliCanceler.promise
                        }).then(function(response) {
                            if (response.data.success == true) {
                                $timeout(function() {
                                    $scope.stateSchoolDistricts = response.data.data;
                                    //MyService.ConsoleLog("--- Got district data ---: ", $scope.districts);
                                });
                            } else if (response.data.error && typeof response.data.error == "string") {
                                growl.error('Error: ' + response.data.error);
                            } else {
                                growl.error('Something went wrong.');
                            }
                        });
                    }
                    break;

                case 'local school district':
                    if ($scope.User.cur_state) {
                        $scope.User.cur_office_name = null;
                        if (!$scope.localSchoolDistException()) {
                            // /if($scope.User.cur_state && $scope.localSchoolDistException())
                            MyService.getAddressOfRunningPoli({
                                StatePostalCode: $scope.User.cur_state.statePostalCode,
                                return_field: "CountyName",
                                timeout: getAddressOfRunningPoliCanceler.promise
                            }).then(function(response) {
                                if (response.data.success == true) {
                                    $timeout(function() {
                                        $scope.counties = response.data.data;
                                        //MyService.ConsoleLog("--- Got counties data ---: ", $scope.counties);
                                    });
                                } else if (response.data.error && typeof response.data.error == "string") {
                                    growl.error('Error: ' + response.data.error);
                                } else {
                                    growl.error('Something went wrong.');
                                }
                            });
                        } else {
                            //for options
                            // do a search through the table currently labelled “2016 Alabama” and find all AD’s where the item Q is the state selected.
                            MyService.getAddressOfRunningPoli({
                                StatePostalCode: $scope.User.cur_state.statePostalCode,
                                return_field: "UnifiedSchoolDistrictName",
                                timeout: getAddressOfRunningPoliCanceler.promise
                            }).then(function(response) {
                                if (response.data.success == true) {
                                    $timeout(function() {
                                        var tempArr = [];
                                        angular.forEach(response.data.data, function(val, key) {
                                            tempArr.push({
                                                label: val,
                                                type: "UnifiedSchoolDistrictName"
                                            });
                                        });
                                        $scope.localSchoolDistricts = tempArr;
                                        //MyService.ConsoleLog("--- Got localSchoolDistricts data ---: ", $scope.localSchoolDistricts);
                                    });
                                } else if (response.data.error && typeof response.data.error == "string") {
                                    growl.error('Error: ' + response.data.error);
                                } else {
                                    growl.error('Something went wrong.');
                                }
                            });
                        }
                    }
                    break;
            }

            if ($scope.User.cur_office_name) {
                if ($scope.User.cur_state) {
                    getAddressOfRunningPoliCanceler.resolve();
                    MyService.getAddressOfRunningPoli({
                        StatePostalCode: $scope.User.cur_state.statePostalCode,
                        return_field: "FederalCongressionalDistrict",
                        timeout: getAddressOfRunningPoliCanceler.promise
                    }).then(function(response) {
                        if (response.data.success == true) {
                            $timeout(function() {
                                $scope.congressionalDistricts = response.data.data;
                                //MyService.ConsoleLog("--- Got congressionalDistricts data ---");
                            });
                        } else if (response.data.error && typeof response.data.error == "string") {
                            growl.error('Error: ' + response.data.error);
                        } else {
                            growl.error('Something went wrong.');
                        }
                    });
                }
            }
        } //state selected
        */
          switch ($scope.User.cur_level) {
            ////'State and Federal', 'County', 'School', 'Local', 'Judicial'
            case "County":
              $scope.showlevelOfGovt = angular.copy($scope.countylevelOfGovt);
              $scope.flagShowOfficeDropdown = true;
              break;
            case "State and Federal":
              $scope.showlevelOfGovt = angular.copy($scope.statelevelOfGovt);
              $scope.flagShowOfficeDropdown = true;
              break;
            case "School":
              $scope.showlevelOfGovt = angular.copy($scope.schoollevelOfGovt);
              $scope.flagShowOfficeDropdown = true;
              break;
            case "Judicial":
              $scope.showlevelOfGovt = angular.copy($scope.judiciallevelOfGovt);
              $scope.flagShowOfficeDropdown = true;
              break;
            case "Local":
              $scope.showlevelOfGovt = angular.copy($scope.locallevelOfGovt);
              $scope.flagShowOfficeDropdown = true;
              break;
            default:
              $scope.showlevelOfGovt = angular.copy($scope.statelevelOfGovt);
              $scope.flagShowOfficeDropdown = true;
              break;
          }
          //MyService.ConsoleLog($scope.showlevelOfGovt);
          //$scope.User.cur_off_name = $scope.showlevelOfGovt[0];
        }
      };
      $scope.onDistrictChange = function (electionFor) {
        //MyService.ConsoleLog("** onDistrictChange **");
        if (electionFor == "running") {
          if ($scope.User.state) {
            switch ($scope.User.level) {
              case "judicial district":
                if ($scope.User.state) {
                  $scope.User.office_name = null;
                  $scope.running_offices = [];
                  //fetch office names for this
                  //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item F is the district selected. Then add “other” to the bottom of the list
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.state.statePostalCode,
                    return_field: "office",
                    JudicialCircuitNumber: $scope.User.district,
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.running_offices = response.data.data;
                        $scope.running_offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.running_offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //state selected
        } else if (electionFor == "incumbent") {
          if ($scope.User.cur_state) {
            //MyService.ConsoleLog("** onDistrictChange **");
            switch ($scope.User.cur_level) {
              case "judicial district":
                if ($scope.User.cur_state) {
                  $scope.User.cur_office_name = null;
                  $scope.offices = [];
                  //fetch office names for this
                  //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item F is the district selected. Then add “other” to the bottom of the list
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.cur_state.statePostalCode,
                    return_field: "office",
                    JudicialCircuitNumber: $scope.User.cur_district,
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.offices = response.data.data;
                        $scope.offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //state selected
        }
      };
      $scope.onCountyChange = function (electionFor) {
        if (electionFor == "running") {
          if ($scope.User.state) {
            //MyService.ConsoleLog("** onCountyChange **");
            switch ($scope.User.level) {
              case "county":
                if ($scope.User.state) {
                  $scope.User.office_name = null;
                  $scope.running_offices = [];
                  //fetch office names for this
                  //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected.  Then add “other” to the bottom of the list
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.state.statePostalCode,
                    CountyName: $scope.User.county,
                    voterScope: "County Name",
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.running_offices = response.data.data;
                        $scope.running_offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.running_offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
              case "sub county":
                if ($scope.User.state && $scope.User.county) {
                  $scope.User.cur_office_name = null;
                  $scope.running_offices = [];
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.state.statePostalCode,
                    CountyName: $scope.User.county,
                    voterScope: "County Name",
                    return_field: "CountySubdivisionName",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.running_subcounties = response.data.data;
                        //MyService.ConsoleLog("--- Got sub counties data ---: ", $scope.running_subcounties);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
              case "city":
                if ($scope.User.state) {
                  $scope.User.office_name = null;
                  // For the options, list all unique county subdivision names and place names within the selected county within the selected state
                  var promiseArr = {
                    counties: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.state.statePostalCode,
                      CountyName: $scope.User.county,
                      return_field: "CountySubdivisionName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                    places: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.state.statePostalCode,
                      CountyName: $scope.User.county,
                      return_field: "PlaceName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                  };

                  $q.all(promiseArr).then(function (response) {
                    //MyService.ConsoleLog("response: ", response);
                    if (
                      response.counties.data.success &&
                      response.places.data.success
                    ) {
                      $timeout(function () {
                        var tempArr = [];
                        angular.forEach(
                          response.counties.data.data,
                          function (val, key) {
                            tempArr.push({
                              label: val,
                              type: "county",
                            });
                          }
                        );
                        angular.forEach(
                          response.places.data.data,
                          function (val, key) {
                            tempArr.push({
                              label: val,
                              type: "place",
                            });
                          }
                        );

                        // tempArr = [{label: "tetst", type: "county"}, {label: "tetst 2", type: "place"}];

                        $scope.running_localities = tempArr;
                        //MyService.ConsoleLog("--- Got localities data ---: ", $scope.running_localities);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;

              case "local school district":
                $scope.User.office_name = null;
                if (!$scope.localSchoolDistException() && $scope.User.county) {
                  // results of a search through the table currently labelled “2016 Alabama” and find all AD’s, AF’s  and AH’s  where item Q is the state selected and item S is the “County” selection
                  var promiseArr = {
                    UnifiedSchoolDistrict: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.state.statePostalCode,
                      CountyName: $scope.county,
                      return_field: "UnifiedSchoolDistrictName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                    ElementarySchoolDistrict: MyService.getAddressOfRunningPoli(
                      {
                        StatePostalCode: $scope.User.state.statePostalCode,
                        CountyName: $scope.county,
                        return_field: "ElementarySchoolDistrictName",
                        timeout: getAddressOfRunningPoliCanceler.promise,
                      }
                    ),
                    SecondarySchoolDistrict: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.state.statePostalCode,
                      CountyName: $scope.county,
                      return_field: "SecondarySchoolDistrictName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                  };

                  $q.all(promiseArr).then(
                    function (response) {
                      //MyService.ConsoleLog("response: ", response);
                      if (
                        response.UnifiedSchoolDistrict.data.success &&
                        response.ElementarySchoolDistrict.data.success &&
                        response.SecondarySchoolDistrict.data.success
                      ) {
                        $timeout(function () {
                          var tempArr = [];
                          angular.forEach(
                            response.UnifiedSchoolDistrict.data.data,
                            function (val, key) {
                              tempArr.push({
                                label: val,
                                type: "UnifiedSchoolDistrictName",
                              });
                            }
                          );
                          angular.forEach(
                            response.ElementarySchoolDistrict.data.data,
                            function (val, key) {
                              tempArr.push({
                                label: val,
                                type: "ElementarySchoolDistrictName",
                              });
                            }
                          );
                          angular.forEach(
                            response.SecondarySchoolDistrict.data.data,
                            function (val, key) {
                              tempArr.push({
                                label: val,
                                type: "SecondarySchoolDistrictName",
                              });
                            }
                          );
                          //MyService.ConsoleLog("$scope.localSchoolDistricts: ", tempArr);
                          $scope.running_localSchoolDistricts = tempArr;
                        });
                      } else {
                        //MyService.ConsoleLog("response: ", response);
                        growl.error("Something went wrong.");
                      }
                    },
                    function (err) {
                      //MyService.ConsoleLog("err: ", err);
                      growl.error("Something went wrong.");
                    }
                  );
                }
                break;
            }
          } //state selected
        } else if (electionFor == "incumbent") {
          if ($scope.User.cur_state) {
            //MyService.ConsoleLog("** onCountyChange **");
            switch ($scope.User.cur_level) {
              case "county":
                if ($scope.User.cur_state) {
                  $scope.User.cur_office_name = null;
                  $scope.offices = [];
                  //fetch office names for this
                  //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected.  Then add “other” to the bottom of the list
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.cur_state.statePostalCode,
                    CountyName: $scope.User.cur_county,
                    voterScope: "County Name",
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.offices = response.data.data;
                        $scope.offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
              case "sub county":
                if ($scope.User.cur_state && $scope.User.cur_county) {
                  $scope.User.cur_office_name = null;
                  $scope.offices = [];
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.cur_state.statePostalCode,
                    CountyName: $scope.User.cur_county,
                    voterScope: "County Name",
                    return_field: "CountySubdivisionName",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.subcounties = response.data.data;
                        //MyService.ConsoleLog("--- Got sub counties data ---: ", $scope.subcounties);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
              case "city":
                if ($scope.User.cur_state) {
                  $scope.User.cur_office_name = null;
                  // For the options, list all unique county subdivision names and place names within the selected county within the selected state
                  var promiseArr = {
                    counties: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.cur_state.statePostalCode,
                      CountyName: $scope.User.cur_county,
                      return_field: "CountySubdivisionName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                    places: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.cur_state.statePostalCode,
                      CountyName: $scope.User.cur_county,
                      return_field: "PlaceName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                  };

                  $q.all(promiseArr).then(function (response) {
                    //MyService.ConsoleLog("response: ", response);
                    if (
                      response.counties.data.success &&
                      response.places.data.success
                    ) {
                      $timeout(function () {
                        var tempArr = [];
                        angular.forEach(
                          response.counties.data.data,
                          function (val, key) {
                            tempArr.push({
                              label: val,
                              type: "county",
                            });
                          }
                        );
                        angular.forEach(
                          response.places.data.data,
                          function (val, key) {
                            tempArr.push({
                              label: val,
                              type: "place",
                            });
                          }
                        );

                        // tempArr = [{label: "tetst", type: "county"}, {label: "tetst 2", type: "place"}];

                        $scope.localities = tempArr;
                        //MyService.ConsoleLog("--- Got localities data ---: ", $scope.localities);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;

              case "local school district":
                //MyService.ConsoleLog("cur_county : ", $scope.User.cur_county);
                $scope.User.cur_office_name = null;
                if (
                  !$scope.localSchoolDistException() &&
                  $scope.User.cur_county
                ) {
                  // results of a search through the table currently labelled “2016 Alabama” and find all AD’s, AF’s  and AH’s  where item Q is the state selected and item S is the “County” selection
                  var promiseArr = {
                    UnifiedSchoolDistrict: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.cur_state.statePostalCode,
                      CountyName: $scope.cur_county,
                      return_field: "UnifiedSchoolDistrictName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                    ElementarySchoolDistrict: MyService.getAddressOfRunningPoli(
                      {
                        StatePostalCode: $scope.User.cur_state.statePostalCode,
                        CountyName: $scope.cur_county,
                        return_field: "ElementarySchoolDistrictName",
                        timeout: getAddressOfRunningPoliCanceler.promise,
                      }
                    ),
                    SecondarySchoolDistrict: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.cur_state.statePostalCode,
                      CountyName: $scope.cur_county,
                      return_field: "SecondarySchoolDistrictName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                  };

                  $q.all(promiseArr).then(
                    function (response) {
                      //MyService.ConsoleLog("response: ", response);
                      if (
                        response.UnifiedSchoolDistrict.data.success &&
                        response.ElementarySchoolDistrict.data.success &&
                        response.SecondarySchoolDistrict.data.success
                      ) {
                        $timeout(function () {
                          var tempArr = [];
                          angular.forEach(
                            response.UnifiedSchoolDistrict.data.data,
                            function (val, key) {
                              tempArr.push({
                                label: val,
                                type: "UnifiedSchoolDistrictName",
                              });
                            }
                          );
                          angular.forEach(
                            response.ElementarySchoolDistrict.data.data,
                            function (val, key) {
                              tempArr.push({
                                label: val,
                                type: "ElementarySchoolDistrictName",
                              });
                            }
                          );
                          angular.forEach(
                            response.SecondarySchoolDistrict.data.data,
                            function (val, key) {
                              tempArr.push({
                                label: val,
                                type: "SecondarySchoolDistrictName",
                              });
                            }
                          );
                          //MyService.ConsoleLog("$scope.localSchoolDistricts: ", tempArr);
                          $scope.localSchoolDistricts = tempArr;
                        });
                      } else {
                        //MyService.ConsoleLog("response: ", response);
                        growl.error("Something went wrong.");
                      }
                    },
                    function (err) {
                      //MyService.ConsoleLog("err: ", err);
                      growl.error("Something went wrong.");
                    }
                  );
                }
                break;
            }
          } //state selected
        }
      };
      $scope.onSubCountyChange = function (electionFor) {
        if (electionFor == "running") {
          if ($scope.User.state) {
            //MyService.ConsoleLog("** onCountyChange **");
            switch ($scope.User.level) {
              case "sub county":
                if (
                  $scope.User.state &&
                  $scope.User.county &&
                  $scope.User.subcounty
                ) {
                  $scope.User.office_name = null;
                  $scope.running_offices = [];
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.state.statePostalCode,
                    CountyName: $scope.User.county,
                    // voterScope: "County Name",
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.running_offices = response.data.data;
                        $scope.running_offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.running_offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //s
        } else {
          if ($scope.User.cur_state) {
            //MyService.ConsoleLog("** onCountyChange **");
            switch ($scope.User.cur_level) {
              case "sub county":
                if (
                  $scope.User.cur_state &&
                  $scope.User.cur_county &&
                  $scope.User.subcounty
                ) {
                  $scope.User.cur_office_name = null;
                  $scope.offices = [];
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.cur_state.statePostalCode,
                    CountyName: $scope.User.cur_county,
                    // voterScope: "County Name",
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.offices = response.data.data;
                        $scope.offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //s
        }
      };
      $scope.onLocalityChange = function (electionFor) {
        //MyService.ConsoleLog("** onLocalityChange **");
        if (electionFor == "running") {
          if ($scope.User.state) {
            switch ($scope.User.level) {
              case "city":
                if (
                  $scope.User.state &&
                  $scope.User.county &&
                  $scope.User.locality
                ) {
                  $scope.User.office_name = null;
                  $scope.running_offices = [];
                  //fetch office names for this
                  // For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected and U or W match the “city” selection.  Then add “other” to the bottom of the list
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.state.statePostalCode,
                    CountyName: $scope.User.county,
                    CountySubdivisionName: $scope.User.locality.label,
                    PlaceName: $scope.User.locality.label,
                    office_for: "place", //this is special case
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.running_offices = response.data.data;
                        $scope.running_offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.running_offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //s
        } else if (electionFor == "incumbent") {
          if ($scope.User.cur_state) {
            switch ($scope.User.cur_level) {
              case "city":
                if (
                  $scope.User.cur_state &&
                  $scope.User.cur_county &&
                  $scope.User.cur_locality
                ) {
                  $scope.User.cur_office_name = null;
                  $scope.offices = [];
                  //fetch office names for this
                  // For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected and U or W match the “city” selection.  Then add “other” to the bottom of the list
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.cur_state.statePostalCode,
                    CountyName: $scope.User.cur_county,
                    CountySubdivisionName: $scope.User.cur_locality.label,
                    PlaceName: $scope.User.cur_locality.label,
                    office_for: "place", //this is special case
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.offices = response.data.data;
                        $scope.offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //s
        }
      };
      $scope.onStateSchoolDistChange = function (electionFor) {
        //MyService.ConsoleLog("** onStateSchoolDistChange **");
        if (electionFor == "running") {
          if ($scope.User.state) {
            switch ($scope.User.level) {
              case "state school board district":
                if ($scope.User.state && $scope.User.state_school_dist) {
                  $scope.User.office_name = null;
                  $scope.running_offices = [];
                  //fetch office names for this
                  // do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item E is the “District” selection.  Then add “other” to the bottom of the list.
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.state.statePostalCode,
                    StateBoardEducationDistrict: $scope.User.state_school_dist,
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.running_offices = response.data.data;
                        $scope.running_offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.running_offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //s
        } else if (electionFor == "incumbent") {
          if ($scope.User.cur_state) {
            switch ($scope.User.cur_level) {
              case "state school board district":
                if (
                  $scope.User.cur_state &&
                  $scope.User.cur_state_school_dist
                ) {
                  $scope.User.cur_office_name = null;
                  $scope.offices = [];
                  //fetch office names for this
                  // do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item E is the “District” selection.  Then add “other” to the bottom of the list.
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.cur_state.statePostalCode,
                    StateBoardEducationDistrict:
                      $scope.User.cur_state_school_dist,
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.offices = response.data.data;
                        $scope.offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //s
        }
      };
      $scope.onLocalSchoolDistChange = function (electionFor) {
        if (electionFor == "running") {
          if ($scope.User.state) {
            //MyService.ConsoleLog("** onLocalSchoolDistChange **");
            switch ($scope.User.level) {
              case "local school district":
                break;
            }
          } //s
        } else if (electionFor == "incumbent") {
          if ($scope.User.cur_state) {
            //MyService.ConsoleLog("** onLocalSchoolDistChange **");
            switch ($scope.User.level) {
              case "local school district":
                break;
            }
          } //s
        }
      };

      $scope.CheckUserName = function () {
        $scope.Errors = [];
        MyService.checkUnm({
          username: $scope.User.UserName,
        }).then(
          function (response) {
            if (response.data.taken == true) {
              //$scope.Errors.push('Oops! Username ' + $scope.User.UserName + ' has already been taken.');
              growl.error(
                "Oops! Username " +
                  $scope.User.UserName +
                  " has already been taken."
              );
            }
          },
          function (err) {
            growl.error("Something went wrong.");
          }
        );
      };

      $scope.SignIn = function () {
        $http
          .post(baseApiUrl + "user/authenticate", {
            username: $scope.User.UserName,
            password: $scope.User.Password,
          })
          .then(
            function (response) {
              if (response.data.success == true) {
                tokenService.saveToken(response.data.token);
                tokenService.saveUserName(response.data.name);
                $http.defaults.headers.common["Authorization"] =
                  tokenService.getToken();
                $rootScope.Auth = true;
                $rootScope.User = tokenService.getUserName();
                $location.path("debate");
              } else {
                growl.error("Invalid Username or Password. Please try again.");
              }
            },
            function (response) {
              var validataionMsg = "";
              var errors = response.data.error.errors;
              for (var k in errors) {
                if (errors.hasOwnProperty(k)) {
                  var obj = errors[k];
                  if (obj.message !== undefined)
                    validataionMsg += obj.message.replace("Path", "") + "<br/>";
                }
              }
              growl.error(validataionMsg);
            }
          );
      };

      $scope.generatePostUserObj = function () {
        //if ($.fn.validateForceFully($("#fiveminform")) == true) {

        var mainLocation = JSON.stringify($rootScope.location);

        MyService.ConsoleLog(
          " $$$$$$$$$$$$$$ My Address $$$$$$$$$$$$$$ :",
          $scope.address
        );

        $scope.Errors = [];
        /* var mainAddress = JSON.stringify({
           state: $scope.address.state ? $scope.address.state.state : '',
           statePostalCode: $scope.address.state.statePostalCode ?
             $scope.address.state.statePostalCode : $scope.statePostalCode,
           place: $scope.address.place ? $scope.address.place.place : $scope.place_name,
           // placeFips:$scope.address.place.placeFips?$scope.address.place.placeFips:"",
           country: $scope.countryname ? $scope.countryname : $scope.county_name,
           countyFips: $scope.address.county ? $scope.address.county.countyFips : '',
           county: $scope.address.county ? $scope.address.county.county : '',
           countySubdivision: $scope.address.countySubdivision ?
             $scope.address.countySubdivision.countySubdivision : '',
           federalCongrassionalDist: $scope.address.federalCongrassionalDist.CD115FP ?
             $scope.address.federalCongrassionalDist.CD115FP : '',
           stateSenateDistrict: $scope.address.stateSenateDistrict.SLDUST ?
             $scope.address.stateSenateDistrict.SLDUST : '',
           schoolDistrict: $scope.address.unifiedSchoolDistrictName ?
             $scope.address.unifiedSchoolDistrictName.unifiedSchoolDistrictName : '',
           schoolDistrictFips: $scope.address.unifiedSchoolDistrictName ?
             $scope.address.unifiedSchoolDistrictName.UNSDLEA ?
             $scope.address.unifiedSchoolDistrictName.UNSDLEA :
             '' : '',

           // voterDistrictFips: $scope.address.voterDistrict ? $scope.address.voterDistrict.voterDistrict : '',
           // voterDistrict: $scope.address.voterDistrict ? $scope.address.voterDistrict.voterDistrictName : '',
           legislativeDistrict: $scope.address.stateHouseOFRepresentativeDistrict ?
             $scope.address.stateHouseOFRepresentativeDistrict.stateHouseOFRepresentativeDistrict : '',
         });*/
        if ($scope.UserType == "advocate") {
          // alert("welcome");
          var mainAddress = JSON.stringify({
            state: $scope.state,
            statePostalCode: $scope.statePostalCode
              ? $scope.statePostalCode
              : $scope.astatePostalCode,
            place: $scope.place_name ? $scope.place_name : $scope.aplace,
            county: $scope.county_name ? $scope.county_name : $scope.acounty,
            country: $scope.countryname ? $scope.countryname : $scope.acountry,
            countySubdivision: $scope.address.countySubdivision
              ? $scope.address.countySubdivision._id.countySubdivision
              : $scope.acountySubdivision,
            federalCongrassionalDist: $scope.address.federalCongrassionalDist
              ? $scope.address.federalCongrassionalDist.CD115FP
              : "",
            stateSenateDistrict: $scope.address.stateSenateDistrict
              ? $scope.address.stateSenateDistrict.NAMELSAD
              : "",
            schoolDistrictFips: $scope.address.unifiedSchoolDistrictName
              ? $scope.address.unifiedSchoolDistrictName.unifiedSchoolDistrict
              : "",
            schoolDistrict: $scope.address.unifiedSchoolDistrictName
              ? $scope.address.unifiedSchoolDistrictName.NAME
              : "",
            voterDistrictFips: $scope.address.voterDistrict
              ? $scope.address.voterDistrict.voterDistrict
              : "",
            voterDistrict: $scope.address.voterDistrict
              ? $scope.address.voterDistrict.voterDistrictName
              : "",
            legislativeDistrict: $scope.address
              .stateHouseOFRepresentativeDistrict
              ? $scope.address.stateHouseOFRepresentativeDistrict.NAMELSAD
              : "",
            cityCouncilDistrictName: $scope.address.cityCouncilDistrict
              ? $scope.address.cityCouncilDistrict.COUNTDIST
              : "",
          });
        } else {
          if ($scope.User.cur_level != "County") {
            // alert("flag");
            $scope.checkFlag = true;
          }
          MyService.ConsoleLog("$scope.User.cur_state", $scope.User.cur_state);
          MyService.ConsoleLog("$scope.User", $scope.User);

          var mainAddress = JSON.stringify({
            state: $scope.User.cur_state
              ? $scope.User.cur_state.state
              : $scope.address
              ? $scope.address.state.state
              : "",
            statePostalCode: $scope.address.state.statePostalCode
              ? $scope.address.state.statePostalCode
              : $scope.statePostalCode,
            stateFips: $scope.address.state
              ? $scope.address.state.stateFips
              : "",
            place: $scope.address.place ? $scope.address.place.placeName : "",
            placeFips: $scope.address.place
              ? $scope.address.place.placeFips
              : "",
            county: $scope.address.county
              ? $scope.address.county.countyName
              : "",
            countyFips: $scope.address.county
              ? $scope.address.county.countyFips
              : "",
            country: $scope.countryname ? $scope.countryname : "",
            countySubdivision: $scope.address.countySubdivision
              ? $scope.address.countySubdivision.countySubdivision
              : "",
            countySubdivisionFips: $scope.address.countySubdivision
              ? $scope.address.countySubdivision.countySubdivisionFips
              : "",
            federalCongrassionalDist: $scope.address.federalCongrassionalDist
              ? $scope.address.federalCongrassionalDist.CD115FP
              : "",
            stateSenateDistrict: $scope.address.stateSenateDistrict
              ? $scope.address.stateSenateDistrict.NAMELSAD
              : "",
            schoolDistrictFips: $scope.address.unifiedSchoolDistrictName
              ? $scope.address.unifiedSchoolDistrictName
                  .unifiedSchoolDistrictFips
              : "",
            schoolDistrict: $scope.address.unifiedSchoolDistrictName
              ? $scope.address.unifiedSchoolDistrictName
                  .unifiedSchoolDistrictName
              : "",
            voterDistrictFips: $scope.address.voterDistrict
              ? $scope.address.voterDistrict.voterDistrict
              : "",
            voterDistrict: $scope.address.voterDistrict
              ? $scope.address.voterDistrict.voterDistrictName
              : "",
            legislativeDistrict: $scope.address
              .stateHouseOFRepresentativeDistrict
              ? $scope.address.stateHouseOFRepresentativeDistrict.NAMELSAD
              : "",
            cityCouncilDistrictName: $scope.address.cityCouncilDistrict
              ? $scope.address.cityCouncilDistrict.COUNTDIST
              : "",
          });
        }
        MyService.ConsoleLog("$scope.User.cur_state", $scope.User.cur_state);
        MyService.ConsoleLog("$scope.address.place ", $scope.address.place);
        var poliAddress = JSON.stringify({
          state: $scope.User.cur_state
            ? $scope.User.cur_state.state
            : $scope.User.state
            ? $scope.User.state.state
            : "",
          statePostalCode: $scope.User.cur_state
            ? $scope.User.cur_state.statePostalCode
            : $scope.statePostalCode,
          stateFips: $scope.address.state ? $scope.address.state.stateFips : "",
          place: $scope.address.place
            ? $scope.address.place.placeName
            : $scope.place_name,
          placeFips: $scope.address.place ? $scope.address.place.placeFips : "",
          county: $scope.address.county
            ? $scope.address.county.countyName
            : $scope.county_name,
          countyFips: $scope.address.county
            ? $scope.address.county.countyFips
            : "",
          country: $scope.countryname ? $scope.countryname : $scope.acountry,
          countySubdivision: $scope.address.countySubdivision
            ? $scope.address.countySubdivision.countySubdivision
            : $scope.acountySubdivision,
          countySubdivisionFips: $scope.address.countySubdivision
            ? $scope.address.countySubdivision.countySubdivisionFips
            : "",
          federalCongrassionalDist: $scope.address.federalCongrassionalDist
            ? $scope.address.federalCongrassionalDist.congressionalDistrictFips
            : "",
          stateSenateDistrict: $scope.address.stateSenateDistrict
            ? $scope.address.stateSenateDistrict.stateSenateDistrictFips
            : "",
          schoolDistrictFips: $scope.address.unifiedSchoolDistrictName
            ? $scope.address.unifiedSchoolDistrictName.unifiedSchoolDistrictFips
            : "",
          schoolDistrict: $scope.address.unifiedSchoolDistrictName
            ? $scope.address.unifiedSchoolDistrictName.unifiedSchoolDistrict
            : "",
          voterDistrictFips: $scope.address.voterDistrict
            ? $scope.address.voterDistrict.voterDistrict
            : "",
          voterDistrict: $scope.address.voterDistrict
            ? $scope.address.voterDistrict.voterDistrictName
            : "",
          legislativeDistrict: $scope.address.stateHouseOFRepresentativeDistrict
            ? $scope.address.stateHouseOFRepresentativeDistrict
                .stateHouseofRepresentativesDistrictName
            : "",
        });
        MyService.ConsoleLog("poliAddress", poliAddress);
        var runningPoliInfo = JSON.stringify({
          state: $scope.User.state
            ? $scope.User.state.state
            : $scope.User.cur_state
            ? $scope.User.cur_state.state
            : "",
          statePostalCode: $scope.User.state
            ? $scope.User.state.statePostalCode
            : $scope.statePostalCode
            ? $scope.statePostalCode
            : "",
          stateFips: $scope.User.state ? $scope.User.state.stateFips : "",
          place: $scope.runAddress.place
            ? $scope.runAddress.place.city
            : $scope.place_name
            ? $scope.place_name
            : "",
          placeFips: $scope.runAddress.place
            ? $scope.runAddress.place.placeFips
            : "",
          county: $scope.runAddress.county
            ? $scope.runAddress.county.countyName
            : $scope.county_name
            ? $scope.county_name
            : "",
          countyFips: $scope.runAddress.county
            ? $scope.runAddress.county.countyFips
            : "",
          country: $scope.countryname ? $scope.countryname : $scope.acountry,
          countySubdivision: $scope.runAddress.countySubdivision
            ? $scope.runAddress.countySubdivision.countySubdivision
            : $scope.acountySubdivision,
          countySubdivisionFips: $scope.runAddress.countySubdivision
            ? $scope.runAddress.countySubdivision.countySubdivisionFips
            : "",
          federalCongrassionalDist: $scope.runAddress.federalCongrassionalDist
            ? $scope.runAddress.federalCongrassionalDist
                .congressionalDistrictFips
            : "",
          stateSenateDistrict: $scope.runAddress.stateSenateDistrict
            ? $scope.runAddress.stateSenateDistrict.stateSenateDistrictFips
            : "",
          schoolDistrictFips: $scope.runAddress.unifiedSchoolDistrictName
            ? $scope.runAddress.unifiedSchoolDistrictName
                .unifiedSchoolDistrictFips
            : "",
          schoolDistrict: $scope.runAddress.unifiedSchoolDistrictName
            ? $scope.runAddress.unifiedSchoolDistrictName.unifiedSchoolDistrict
            : "",
          voterDistrictFips: $scope.runAddress.voterDistrict
            ? $scope.runAddress.voterDistrict.voterDistrict
            : "",
          voterDistrict: $scope.runAddress.voterDistrict
            ? $scope.runAddress.voterDistrict.voterDistrictName
            : "",
          legislativeDistrict: $scope.runAddress
            .stateHouseOFRepresentativeDistrict
            ? $scope.runAddress.stateHouseOFRepresentativeDistrict
                .stateHouseofRepresentativesDistrictName
            : "",
        });
        MyService.ConsoleLog(
          "<<<<<<<< runningPoliInfo >>>>>>>>",
          runningPoliInfo
        );
        if ($scope.User.runElectionDate && $scope.User.runElectionDate != "") {
          // $scope.User.runElectionDate ? $scope.User.runElectionDate : "
          MyService.ConsoleLog(
            "$scope.User.runElectionDate ",
            $scope.User.runElectionDate
          );
          // var eleDate = $scope.User.runElectionDate.toJSON();
          var month = (
            "0" +
            ($scope.User.runElectionDate.getMonth() + 1)
          ).slice(-2);
          var dat = ("0" + $scope.User.runElectionDate.getDate()).slice(-2);
          MyService.ConsoleLog("dat >>", dat);
          var finDate =
            $scope.User.runElectionDate.getFullYear() + "-" + month + "-" + dat;
          MyService.ConsoleLog(
            "$scope.User.runElectionDate ",
            $scope.User.runElectionDate.getDate()
          );
          MyService.ConsoleLog(
            "$scope.User.runElectionDate ",
            $scope.User.runElectionDate.getMonth()
          );
          MyService.ConsoleLog(
            "$scope.User.runElectionDate ",
            finDate.toString()
          );
        }
        var postobj = {
          username: $scope.User.UserName,
          password: $scope.User.Password,
          email: $scope.User.Email,
          zipcode: $scope.User.ZipCode
            ? $scope.User.ZipCode
            : $scope.User.ZipCodeOne,
          type: $scope.User.UserType,
          postCard: $scope.User.postCard,
          verifiedUser: $scope.verifiedUser,
          verificationCell: $scope.verificationCell,
          verificationCarrier: $scope.verificationCarrier,
          verificationMethod: $scope.verificationMethod,
          verificationurl: $rootScope.getVerificationUrl(),
          address: mainAddress,
          poliAddress: poliAddress,
          runningPoliInfo: runningPoliInfo,
          loc: mainLocation ? mainLocation : "",
          unsubscribeurl: $rootScope.getEmailUnsubscribeUrl(),
          campaignEmail: $scope.User.campaignEmail,
          campaignWebSite: $scope.User.campaignWebSite,
          campaignFburl: $scope.User.campaignFburl,
          campPhone_no: $scope.User.campPhone_no,
          run_electionDate: finDate ? finDate : "",
          mailingAddress: window.localStorage.getItem("mailingAddress"),
        };

        switch ($scope.User.UserType.toLowerCase()) {
          case "voter":
            postobj.name = $scope.User.name + " " + $scope.User.lastname;
            break;
          case "advocate":
            postobj.name = $scope.User.name + " " + $scope.User.lastname;
            postobj.position = $scope.User.position;
            postobj.extention_no = $scope.User.extention_no;
            postobj.verification_note = $scope.User.verification_note;
            postobj.typeOfOrg = $scope.User.orgType;
            postobj.empIndNo = $scope.User.empIndNo;
            postobj.officeName = $scope.User.organization_name;
            postobj.officeWebUrl = $scope.User.organization.web_url;
            postobj.officePhoneNumber = $scope.User.organization.phone_no;
            break;
          case "press":
            postobj.name = $scope.User.name + " " + $scope.User.lastname;

            postobj.extention_no = $scope.User.press_extension_no;
            postobj.verification_note = $scope.User.verification_note;
            if ($scope.User.organization) {
              MyService.ConsoleLog("one fnfnf", $scope.User.organization);
              postobj.office_id = $scope.User.organization._id
                ? $scope.User.organization._id
                : "";
            }
            postobj.typeOfOrg = $scope.User.orgType;
            postobj.empIndNo = $scope.User.empIndNo;
            postobj.officeName = $scope.User.outlet_name;
            postobj.officeWebUrl = $scope.User.outlet_web;
            postobj.officePhoneNumber = $scope.User.outlet_phone_no;

            break;
          case "politician":
            postobj.name_on_ballot = $scope.User.name_on_ballot;
            postobj.name = $scope.User.name;

            postobj.phone_no = $scope.User.phone_no ? $scope.User.phone_no : "";
            postobj.cur_office_phone = $scope.User.cur_office_phone
              ? $scope.User.cur_office_phone
              : "";
            postobj.publicEmail = $scope.User.cur_office_email
              ? $scope.User.cur_office_email
              : "";
            postobj.web_url = $scope.User.cur_office_website
              ? $scope.User.cur_office_website
              : "";
            postobj.mailing_address = $scope.User.mailing_address;

            if ($scope.User.Candidates && $scope.User.Candidates._id) {
              postobj.cur_office_id = $scope.User.Candidates._id;
            }
            if ($scope.User.NCandidates && $scope.User.NCandidates._id) {
              postobj.office_id = $scope.User.NCandidates._id
                ? $scope.User.NCandidates._id
                : "";
            }
            if ($scope.User.isInCurrentOffice == 1) {
              try {
                MyService.ConsoleLog(
                  " my office >>>>>>>>>> :",
                  $scope.User.cur_office_name
                );

                if ($scope.User.cur_office_name) {
                  postobj.cur_office_name = $scope.User.cur_office_name;
                  // console.log('current office >>>>>>>>>>>>>>>', $scope.User.cur_office_name);
                } else {
                  if ($filter("isBlankString")($scope.User.cur_office_name)) {
                    growl.error("Current Office name is not selected");
                    return null;
                  } else {
                    postobj.cur_office_name = $scope.User.cur_office_name;
                  }
                }

                if ($scope.User.cur_level) {
                  MyService.ConsoleLog(
                    " User.cur_level first >>>>>>> ",
                    $scope.User.cur_level
                  );

                  switch ($scope.User.cur_level) {
                    case "Federal":
                      postobj.cur_level = "federalCongressionalDistrict";
                      break;
                    case "Other":
                      postobj.cur_level = "All USA";
                      break;
                    case "State":
                      postobj.cur_level = "statePostalCode";
                      break;
                    case "County":
                      postobj.cur_level = "countyName";
                      break;
                    case "Local":
                      postobj.cur_level = "placeName";
                      break;
                    default:
                      break;
                  }
                }

                /*if($filter("isBlankString")($scope.User.cur_jurisdiction_name)){
                growl.error("Current jurisdiction name is not selected");
                return null;
              }*/

                // postobj.cur_jurisdiction_name = $scope.User.cur_jurisdiction_name;
                if ($scope.User.cur_state) {
                  var state = $scope.User.cur_state;
                  //MyService.ConsoleLog(state);
                  //MyService.ConsoleLog(state.state);
                  postobj.cur_state = state.state;
                  postobj.cur_state_postal_code = state.statePostalCode;
                }

                if ($scope.User.Candidates) {
                  if (
                    $scope.User.Candidates.FederalCongressionalDistrict &&
                    $scope.User.Candidates.FederalCongressionalDistrict != null
                  ) {
                    postobj.cur_federal_congrassional_dist =
                      $scope.User.Candidates.FederalCongressionalDistrict;
                  }

                  if (
                    $scope.User.Candidates.JudicialCircuitNumber &&
                    $scope.User.Candidates.JudicialCircuitNumber != null
                  ) {
                    postobj.cur_judicial_circuit_no =
                      $scope.User.Candidates.JudicialCircuitNumber;
                  }

                  if (
                    $scope.User.Candidates.CountyName &&
                    $scope.User.Candidates.CountyName != null
                  ) {
                    postobj.cur_county = $scope.User.Candidates.CountyName;
                  }

                  if (
                    $scope.User.Candidates.CountySubdivisionName &&
                    $scope.User.Candidates.CountySubdivisionName != null
                  ) {
                    postobj.cur_subcounty =
                      $scope.User.Candidates.CountySubdivisionName;
                  }

                  if (
                    $scope.User.Candidates.PlaceName &&
                    $scope.User.Candidates.PlaceName != null
                  ) {
                    postobj.cur_place = $scope.User.Candidates.PlaceName;
                  }

                  if (
                    $scope.User.Candidates.StateBoardEducationDistrict &&
                    $scope.User.Candidates.StateBoardEducationDistrict != null
                  ) {
                    postobj.cur_state_board_education_dist =
                      $scope.User.Candidates.StateBoardEducationDistrict;
                  }

                  if (
                    $scope.User.Candidates.UnifiedSchoolDistrictName &&
                    $scope.User.Candidates.UnifiedSchoolDistrictName != null
                  ) {
                    postobj.cur_unified_school_dist =
                      $scope.User.Candidates.UnifiedSchoolDistrictName;
                  }

                  if (
                    $scope.User.Candidates.ElementarySchoolDistrictName &&
                    $scope.User.Candidates.ElementarySchoolDistrictName != null
                  ) {
                    postobj.cur_elementary_school_dist =
                      $scope.User.Candidates.ElementarySchoolDistrictName;
                  }

                  if (
                    $scope.User.Candidates.SecondarySchoolDistrictName &&
                    $scope.User.Candidates.SecondarySchoolDistrictName != null
                  ) {
                    postobj.cur_secondary_school_dist =
                      $scope.User.Candidates.SecondarySchoolDistrictName;
                  }
                }
              } catch (e) {
                //MyService.ConsoleLog("Exceptoin: ", e);
                $scope.RegisterButton = false;
                growl.error("Valid Office Name is required.");
                return null;
              }
            }

            if ($scope.User.isRunningForEle == 1) {
              if ($scope.User.RunningForOtherOffice == 1) {
                postobj.cur_office_name = $scope.User.cur_office_name;
                if ($scope.User.cur_level) {
                  postobj.cur_level = $scope.User.cur_level;
                }
                postobj.run_candidateStatus = $scope.User.runStatus
                  ? $scope.User.runStatus
                  : "";
              } else {
                if ($scope.User.NCandidates && $scope.User.NCandidates.office) {
                  postobj.office_name = $scope.User.NCandidates.office;
                } else {
                  if ($filter("isBlankString")($scope.User.office_name)) {
                    growl.error("Office name is not selected");
                    return null;
                  } else {
                    postobj.office_name = $scope.User.office_name;
                  }
                }
                if ($scope.User.level) {
                  MyService.ConsoleLog(" got lvl of govt :", $scope.User.level);

                  switch ($scope.User.level) {
                    case "Federal":
                      postobj.level = "federalCongressionalDistrict";
                      break;
                    case "Other":
                      postobj.level = "All USA";
                      break;
                    case "State":
                      postobj.level = "statePostalCode";
                      break;
                    case "County":
                      postobj.level = "countyName";
                      break;
                    case "Local":
                      postobj.level = "placeName";
                      break;
                    default:
                      break;
                  }
                }
              }
              if ($scope.User.runStatus) {
                postobj.run_candidateStatus = $scope.User.runStatus
                  ? $scope.User.runStatus
                  : "";
              }
              try {
                if ($scope.User.state) {
                  var state = $scope.User.state;
                  postobj.state = state.state;
                  postobj.state_postal_code = state.statePostalCode;
                }

                if (
                  $scope.User.NCandidates &&
                  $scope.User.NCandidates.FederalCongressionalDistrict &&
                  $scope.User.NCandidates.FederalCongressionalDistrict != null
                ) {
                  postobj.federal_congrassional_dist =
                    $scope.User.NCandidates.FederalCongressionalDistrict;
                }

                if (
                  $scope.User.NCandidates &&
                  $scope.User.NCandidates.JudicialCircuitNumber &&
                  $scope.User.NCandidates.JudicialCircuitNumber != null
                ) {
                  postobj.judicial_circuit_no =
                    $scope.User.NCandidates.JudicialCircuitNumber;
                }

                if (
                  $scope.User.NCandidates &&
                  $scope.User.NCandidates.CountyName &&
                  $scope.User.NCandidates.CountyName != null
                ) {
                  postobj.county = $scope.User.NCandidates.CountyName;
                }

                if (
                  $scope.User.NCandidates &&
                  $scope.User.NCandidates.CountySubdivisionName &&
                  $scope.User.NCandidates.CountySubdivisionName != null
                ) {
                  postobj.subcounty =
                    $scope.User.NCandidates.CountySubdivisionName;
                }

                if (
                  $scope.User.NCandidates &&
                  $scope.User.NCandidates.PlaceName &&
                  $scope.User.NCandidates.PlaceName != null
                ) {
                  postobj.place = $scope.User.NCandidates.PlaceName;
                }

                if (
                  $scope.User.NCandidates &&
                  $scope.User.NCandidates.StateBoardEducationDistrict &&
                  $scope.User.NCandidates.StateBoardEducationDistrict != null
                ) {
                  postobj.state_board_education_dist =
                    $scope.User.NCandidates.StateBoardEducationDistrict;
                }

                if (
                  $scope.User.NCandidates &&
                  $scope.User.NCandidates.UnifiedSchoolDistrictName &&
                  $scope.User.NCandidates.UnifiedSchoolDistrictName != null
                ) {
                  postobj.unified_school_dist =
                    $scope.User.NCandidates.UnifiedSchoolDistrictName;
                }

                if (
                  $scope.User.NCandidates &&
                  $scope.User.NCandidates.ElementarySchoolDistrictName &&
                  $scope.User.NCandidates.ElementarySchoolDistrictName != null
                ) {
                  postobj.elementary_school_dist =
                    $scope.User.NCandidates.ElementarySchoolDistrictName;
                }

                if (
                  $scope.User.NCandidates &&
                  $scope.User.NCandidates.SecondarySchoolDistrictName &&
                  $scope.User.NCandidates.SecondarySchoolDistrictName != null
                ) {
                  postobj.secondary_school_dist =
                    $scope.User.NCandidates.SecondarySchoolDistrictName;
                }
              } catch (e) {
                $scope.RegisterButton = false;
                growl.error("Valid office details are required.");
                return null;
              }
            }
            if ($scope.User.web_url) postobj.web_url = $scope.User.web_url;
            if ($scope.User.facebook_url)
              postobj.fabebook_url = $scope.User.facebook_url;
            break;
        }

        MyService.ConsoleLog("postobj:::::", postobj);
        return postobj;
        // } //validation
        // else {
        //   return null;
        // }
      };
      $scope.disableRegister = function (opt) {
        if (opt == "P") {
          $scope.RegisterButton = true;
        } else {
          $scope.RegisterButton = false;
        }
      };
      $scope.verificationCode = "";
      $scope.getVerificationCode = function () {
        var cell = $scope.User.cellnumber;
        var carrier = $scope.User.carrier;
        // //MyService.ConsoleLog(cell);
        // //MyService.ConsoleLog(carrier);
        // //MyService.ConsoleLog(carrier.domain);

        if (!cell || cell == "") {
          alert("Please enter phone number");
          return;
          //return false;
        }

        if (!carrier || carrier == "") {
          alert("Please select your phone carrier");
          return;
          //return false;
        }

        if (cell && cell != "" && carrier && carrier != "") {
          // //MyService.ConsoleLog("here");
          if (carrier.domain) {
            $scope.verificationCell = cell;
            $scope.verificationCarrier = carrier.domain;
            MyService.sendVerificationCode({
              cellnumber: cell,
              carrier: carrier.domain,
            }).then(
              function (payload) {
                // //MyService.ConsoleLog(payload);
                if (payload.data.success) {
                  $scope.verificationCode = payload.data.data;
                  alert("Verification code sent on " + cell);
                  // //MyService.ConsoleLog("verification code : ");
                  // //MyService.ConsoleLog($scope.verificationCode);
                } else {
                  $scope.verificationCode = "";
                  if (payload.data.error) {
                    alert(payload.data.error);
                  } else {
                    alert("Something went wrong please try agian");
                  }
                }
              },
              function (errPayload) {
                $scope.verificationCode = "";
                alert("Something went wrong please try agian");
              }
            );
          }
        }
      };
      $scope.verifiedUser = "false";
      $scope.verificationMethod = "Email";
      $scope.verificationCell = "";
      $scope.verificationCarrier = "";
      $scope.matchVerficationCode = function (val) {
        MyService.ConsoleLog("value : ", val);
        ////MyService.ConsoleLog($scope.User.verificationCode);
        ////MyService.ConsoleLog(val.length);
        $scope.RegisterButton = true;
        $scope.verifiedUser = "false";
        if (val.length == 6 && $scope.verificationCode != "") {
          if ($scope.verificationCode == val) {
            $scope.RegisterButton = false;
            $scope.verifiedUser = "true";
            $scope.verificationMethod = "Cell Phone Number";
            if ($scope.User.confirmOpt == "Phone") {
              $scope.saveUser();
            }
          } else {
            alert(
              "You have entered the wrong code.  Please try again or have us send you another code."
            );
          }
        } else {
          alert(
            "You have entered the wrong code.  Please try again or have us send you another code."
          );
        }
      };
      $scope.saveUser = function () {
        var postobj = $scope.generatePostUserObj();
        MyService.ConsoleLog("postobj<><><><><>", postobj);
        if (postobj) {
          MyService.signUp(postobj).then(
            function (response) {
              //MyService.ConsoleLog("response: ", response);
              $scope.RegisterButton = false;
              if (response.data.success == true) {
                var message = "";
                switch ($scope.User.UserType.toLowerCase()) {
                  case "politician":
                    message =
                      "It may take us some time to confirm your identity.  In the meantime, you can use the site, but everything you do will have the byline 'Unknown Politician.'  As soon as we confirm who you are, all your old posts will automatically switch to your real name.";
                    break;
                  case "voter":
                    message =
                      "Until you confirm your email, you can read and explore the site, but you won't be able to write responses.";
                    break;
                  case "press":
                    message =
                      "It may take us some time to confirm your identity.  In the meantime, you can use the site, but everything you do will have the byline 'Unknown Press.'  As soon as we confirm who you are, all your old posts will automatically switch to your real name.";
                    break;
                  case "advocate":
                    message =
                      "It may take us some time to confirm your identity.  In the meantime, you can use the site, but everything you do will have the byline 'Unknown Organization.'  As soon as we confirm who you are, all your old posts will automatically switch to your real name.";
                    break;
                }
                // growl.info(message);
                $cookies.put("showLongPopUp", message);
                var tempParam = {
                  username: $scope.User.UserName,
                  password: $scope.User.Password,
                };
                ////MyService.ConsoleLog("tempParam>>",tempParam);
                // $scope.AuthenticateUser1(tempParam);
                $timeout(function () {
                  $scope.AuthenticateUser1(tempParam);
                }, 2000);
              } else if (
                response.data.error &&
                typeof response.data.error == "string"
              ) {
                growl.error("Error: " + response.data.error);
              } else {
                growl.error("Something went wrong.");
              }
            },
            function (response) {
              //MyService.ConsoleLog("Signup response: ", response);
              $scope.RegisterButton = false;
              var validataionMsg = "";
              if (
                response.data &&
                response.data.error &&
                response.data.error.errors
              ) {
                var errors = response.data.error.errors;
                for (var k in errors) {
                  if (errors.hasOwnProperty(k)) {
                    ////MyService.ConsoleLog(k);
                    var obj = errors[k];
                    if (obj.message !== undefined)
                      validataionMsg +=
                        obj.message.replace("Path", "") + "<br/>";
                  }
                }
                growl.error(validataionMsg);
              }
            }
          );
        }
      };
      $scope.showUserConfirm = function () {
        var message =
          "Some parts of the site will not work until you check your email and confirm – or you can instantly confirm with your cell phone number.";
        var modal = ngDialog.openConfirm({
          template:
            "<p>" +
            message +
            '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">Confirm</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(1)">Skip</button>\
                        </div>',
          plain: true,
        });
        modal.then(
          function fullfilled(data) {
            //MyService.ConsoleLog("fullfilled: ", data);
            if (data == 0) {
              $scope.verifiedUser = true;
              $scope.User.confirmOpt = "Phone";
              //$scope.saveUser();
            } else {
              $scope.verifiedUser = false;
              $scope.saveUser();
            }
          },
          function rejected(data) {
            //MyService.ConsoleLog("rejected: ", data);
          }
        );

        return;
      };

      $scope.CreateUser = function () {
        //MyService.ConsoleLog("CreateUser");
        //MyService.ConsoleLog($rootScope.tempUserAddress);
        if (!$cookies.get("sessionId")) {
          $scope.address = $rootScope.tempUserAddress;
        }
        $scope.User.ZipCode = $rootScope.tempUserZip;
        $scope.newZipCode = $rootScope.tempUserZip;
        MyService.ConsoleLog(" CreateUser : ", $scope.newZipCode);
        //MyService.ConsoleLog(" address : ", $scope.address);

        // MyService.ConsoleLog("postobj: ", postobj);

        if ($filter("isBlankString")($scope.User.UserName)) {
          growl.error("Please enter username");
          return null;
        }
        if ($filter("isBlankString")($scope.User.Password)) {
          growl.error("Please enter password");
          return null;
        }

        if ($scope.User.Password != $scope.User.ConfirmPassword) {
          MyService.ConsoleLog(
            "check pass",
            $scope.User.Password + "    " + $scope.User.ConfirmPassword
          );
          growl.error("Password and confirm password does not match");
          return null;
        }

        if ($filter("isBlankString")($scope.User.Email)) {
          growl.error("Please enter email");
          return null;
        }
        var postobj = $scope.generatePostUserObj();
        console.log("CreateUser >>> ", postobj);
        // return;
        if (postobj) {
          // MyService.ConsoleLog("inside if post obj");
          $scope.saveUser();
        }
      };

      $scope.saveAns = function () {
        MyService.ConsoleLog("saveFiveMinAnswers : ", $rootScope.guestMatch);
        window.localStorage.removeItem("isHide");
        window.localStorage.setItem("isHide", true);

        if (!$rootScope.guestMatch) {
          $rootScope.guestMatch = $rootScope.guestUserData;
        }

        var len = $rootScope.guestMatch.length;
        if (len > 0) {
          for (var i = 0; i < len; i++) {
            MyService.ConsoleLog($rootScope.guestMatch[i]);
            MyService.postAnswer($rootScope.guestMatch[i]).then(
              function (response) {
                MyService.ConsoleLog(response);
                if (response.data.success) {
                  MyService.ConsoleLog("Answer updated successfully");
                } else {
                  MyService.ConsoleLog("Error: " + response.data.error);
                }
              },
              function (err) {
                MyService.ConsoleLog("Error: ");
              }
            );

            MyService.deleteGuest($rootScope.guestMatch[i]).then(
              function (success) {
                MyService.ConsoleLog("SUccess >>>", success);
              },
              function (err) {
                MyService.ConsoleLog("Error >>", err);
              }
            );
          }
        }
      };
      $scope.saveFiveMinAnswers = function () {
        if ($cookies.get("sessionId")) {
          $scope.saveAns();
        } else if (window.localStorage.getItem("sessionId")) {
          $scope.saveAns();
        } else {
          MyService.ConsoleLog("saveFiveMinAnswers : ");
          MyService.ConsoleLog($rootScope.fiveMatch);
          var len = $rootScope.fiveMatch.length;
          if (len > 0) {
            for (var i = 0; i < len; i++) {
              MyService.ConsoleLog($rootScope.fiveMatch[i]);
              MyService.postAnswer($rootScope.fiveMatch[i]).then(
                function (response) {
                  MyService.ConsoleLog(response);
                  if (response.data.success) {
                    MyService.ConsoleLog("Answer updated successfully");
                  } else {
                    MyService.ConsoleLog("Error: " + response.data.error);
                  }
                },
                function (err) {
                  MyService.ConsoleLog("Error: ");
                }
              );
            }
          }
        }
      };
      $scope.initAuthorizedUser1 = function (userdata) {
        // body...
        //MyService.ConsoleLog("userdata>>", userdata);
        tokenService.saveToken(userdata.token);
        tokenService.saveUserName(userdata.name);
        tokenService.saveUserId(userdata.id);
        tokenService.saveUserRole(userdata);
        var udata = {
          id: userdata.id,
          lastLogin: userdata.lastLogin,
          uname: userdata.username,
          email: userdata.email,
          followlist: userdata.followlist,
          isemailverified: userdata.isemailverified,
          subject_of_deep_interest: userdata.subject_of_deep_interest,
          subject_of_interest: userdata.subject_of_interest,
          location_of_interest: userdata.location_of_interest,
          address: userdata.address,
          selectedColumns: userdata.selectedColumns,
          facebookid: userdata.facebookid,
          volunteers: userdata.volunteers,
          name: userdata.name,
        };

        ////MyService.ConsoleLog("udata : ", udata);
        tokenService.saveUserData(JSON.stringify(udata));
        // $rootScope.tempUserAddress = userdata.address;

        $http.defaults.headers.common["x-access-token"] =
          tokenService.getToken();
        // $http.defaults.headers.common['Authorization'] = tokenService.getToken();
        $rootScope.Auth = true;
        $rootScope.User = tokenService.getUserName();
        $rootScope.UserId = tokenService.getUserId();

        //$location.path('howToVideo');
        if (!$cookies.get("isShowPopUp")) {
          // alert('if');
          // MyService.ConsoleLog("$cookies.get('sessionId')", $cookies.get('sessionId'));
          if (!$cookies.get("sessionId")) {
            MyService.ConsoleLog("IFFF");
            $scope.saveFiveMinAnswers();
            $location.path("/fiveCompare");
            $rootScope.getCategories();
          } else {
            MyService.ConsoleLog("ELSE");
            $scope.saveFiveMinAnswers();
            MyService.ConsoleLog(
              "Quiz Data",
              window.localStorage.getItem("quizLinkData")
            );
            if (window.localStorage.getItem("quizLinkData")) {
              var quData = JSON.parse(
                window.localStorage.getItem("quizLinkData")
              );
              MyService.saveForLaterQuiz({
                saveLink: quData.saveLink,
                userId: tokenService.getUserId(),
                quizName: quData.quizName,
              }).then(
                function (APIResponse) {
                  // MyService.ConsoleLog("APIResponse", APIResponse);
                  $location.path("/snapshot");
                },
                function (err) {
                  MyService.ConsoleLog("Error", err);
                }
              );
            } else {
              $location.path("/findMatch/true");
            }
          }
        } else {
          // alert('else');
          // var message = 'You need to answer at least one question to see a match comparison';
          // var modal = ngDialog.openConfirm({
          //   template: '<p>' +
          //     message +
          //     '</p>\
          //   <div class="ngdialog-buttons">\
          //       <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Back to Questions</button>\
          //   </div>',
          //   plain: true,
          //   closeByDocument: false,
          // });
          // modal.then(
          //   function fullfilled(data) {
          //     // MyService.ConsoleLog("fullfilled: ", data);
          //     $scope.getOrgQuiz();
          //   },
          //   function rejected(data) {
          //     // MyService.ConsoleLog("rejected: ", data);
          //     // $scope.getMatchQUestions();
          //   }
          // );
        }
      };

      $rootScope.statusAuthenticate = 0;
      $scope.AuthenticateUser1 = function (postObj) {
        $rootScope.statusAuthenticate = 1;
        $http.post(baseApiUrl + "/user/authenticate", postObj).then(
          function (response) {
            if (response.data.success == true) {
              //MyService.ConsoleLog("Login Data");
              //MyService.ConsoleLog(response.data);
              $scope.initAuthorizedUser1(response.data);
              /*
            tokenService.saveToken(response.data.token);
            tokenService.saveUserName(response.data.name);
            tokenService.saveUserId(response.data.id);
            tokenService.saveUserRole(response.data);
            var userData = {
                id: response.data.id,
                lastLogin: response.data.lastLogin,
                uname: response.data.username,
                name: response.data.name
            };
            ////MyService.ConsoleLog("username: ", userData);
            tokenService.saveUserData(JSON.stringify(userData));
            $http.defaults.headers.common['x-access-token'] = tokenService.getToken();
            $rootScope.Auth = true;
            $rootScope.User = tokenService.getUserName();
            $rootScope.UserId = tokenService.getUserId();
            $location.path('debateHome');
            $rootScope.getCategories();
            */
              $rootScope.statusAuthenticate = 2;
            } else {
              $rootScope.statusAuthenticate = 3;
              growl.error("Invalid Username or Password. Please try again.");
            }
          },
          function (response) {
            $rootScope.statusAuthenticate = 3;
            var validataionMsg = "";
            //MyService.ConsoleLog("response: ", response);
            if (response.data && response.data.error) {
              var errors = response.data.error.errors;
              for (var k in errors) {
                if (errors.hasOwnProperty(k)) {
                  ////MyService.ConsoleLog(k)
                  var obj = errors[k];
                  if (obj.message !== undefined)
                    validataionMsg += obj.message.replace("Path", "") + "<br/>";
                }
              }
              growl.error(validataionMsg);
            }
          }
        );
      };

      $scope.ShowFB = function () {
        //if()
        //MyService.ConsoleLog("inside :", $rootScope.showFacebookLoging);
        $rootScope.showFacebookLoging = !$rootScope.showFacebookLoging;

        $location.hash("bottom");
        $anchorScroll();
        //$location.hash('signupform');
        //$anchorScroll();
        //if($scope.showFacebookLoging) {
        // $timeout(function() {

        //     //MyService.ConsoleLog("inside after scroll :", $rootScope.showFacebookLoging);
        // }, 1500);

        //}
      };

      $rootScope.LoginWithFacebook = function () {
        // if ($.fn.validateForceFully($("#signupform")) == true) {
        ////MyService.ConsoleLog("all good: ", $rootScope.NewUserData);
        $scope.address = $rootScope.tempUserAddress;
        $scope.User.ZipCode = $rootScope.tempUserZip;
        //MyService.ConsoleLog($scope.address);
        //MyService.ConsoleLog($scope.User.ZipCode);
        FB.login(
          function (response) {
            statusChangeCallback(response);
          },
          {
            scope: "public_profile,email,publish_actions",
          }
        );
        // }
      };

      function statusChangeCallback(response) {
        ////MyService.ConsoleLog(response);
        if (response.status === "connected") {
          getUserInfo();
        } else if (response.status === "not_authorized") {
          growl.info("Please log " + "into this app.");
        } else {
          growl.error("Please log " + "into Facebook.");
        }
      }

      function getUserInfo() {
        FB.api(
          "/me",
          {
            fields: "first_name,last_name,email",
          },
          function (response) {
            ////MyService.ConsoleLog("response: ", response);
            if (response != undefined && response != null && response != "") {
              $scope.CreateFBUser(response);
            }
          }
        );
      }

      $scope.CreateFBUser = function (fbResponse) {
        ////MyService.ConsoleLog("CreateFBUser: ", fbResponse);
        ////MyService.ConsoleLog("organization_name: ", $rootScope.NewUserData.organization_name);
        $rootScope.Errors = [];

        $scope.FBSignIn(fbResponse, function () {
          if (fbResponse.email && fbResponse.email != "") {
            var postobj = $scope.generatePostUserObj();

            if (postobj) {
              //reset few fields for facebook login
              postobj.name = fbResponse.first_name + " " + fbResponse.last_name;
              postobj.username = fbResponse.email.split("@")[0];
              (postobj.password = ""), (postobj.email = fbResponse.email);
              postobj.isfacebooksigin = true;
              postobj.facebookid = fbResponse.id;
              postobj.verificationMethod = "Facebook";

              //MyService.ConsoleLog("postobj: ", postobj);
              MyService.signUp(postobj).then(
                function (response) {
                  ////MyService.ConsoleLog("response: ", response);
                  $scope.RegisterButton = false;
                  if (response.data.success == true) {
                    var message = "";
                    switch ($rootScope.NewUserData.usertype.toLowerCase()) {
                      case "politician":
                        message =
                          "It may take us some time to confirm your identity.  In the meantime, you can use the site, but everything you do will have the byline 'Unknown Politician.'  As soon as we confirm who you are, all your old posts will automatically switch to your real name.";
                        break;
                      case "voter":
                        message =
                          "Until you confirm your email, you can read and explore the site, but you won't be able to write responses.";
                        break;
                      case "press":
                        message =
                          "It may take us some time to confirm your identity.  In the meantime, you can use the site, but everything you do will have the byline 'Unknown Press.'  As soon as we confirm who you are, all your old posts will automatically switch to your real name.";
                        break;
                      case "advocate":
                        message =
                          "It may take us some time to confirm your identity.  In the meantime, you can use the site, but everything you do will have the byline 'Unknown Organization.'  As soon as we confirm who you are, all your old posts will automatically switch to your real name.";
                        break;
                    }
                    growl.success(message);
                    $scope.FBSignIn(fbResponse);
                    // $location.path('debate');
                  } else if (
                    response.data.error &&
                    typeof response.data.error == "string"
                  ) {
                    growl.error("Error: " + response.data.error);
                  } else {
                    growl.error("Something went wrong.");
                  }
                },
                function (response) {
                  var validataionMsg = "";
                  ////MyService.ConsoleLog("response: ", response)
                  var errors = response.data.error.errors;
                  for (var k in errors) {
                    if (errors.hasOwnProperty(k)) {
                      ////MyService.ConsoleLog(k)
                      var obj = errors[k];
                      if (obj.message !== undefined)
                        validataionMsg +=
                          obj.message.replace("Path", "") + "<br/>";
                    }
                  }
                  growl.error(validataionMsg);
                }
              );
            } //if postobj
          } else {
            growl.error(
              "You haven't added email in your facebook account. Please add email in your facebook account then you can register using facebook."
            );
          }
        });
      };

      $scope.FBSignIn = function (fbresponse, callback) {
        //MyService.ConsoleLog(fbresponse);
        $http
          .post(baseApiUrl + "/user/authenticateEmail", {
            email: fbresponse.email,
          })
          .then(
            function (response) {
              //MyService.ConsoleLog("response<><><>",response);
              if (response.data.success == true) {
                if (!response.data.facebookid) {
                  $http
                    .post(baseApiUrl + "/user/updateFacebookId", {
                      facebookid: fbresponse.id,
                      userId: response.data.id,
                    })
                    .then(function (userresponse) {
                      $scope.initAuthorizedUser1(response.data);
                    });
                } else {
                  $scope.initAuthorizedUser1(response.data);
                }
              } else {
                //growl.error('Invalid Username or Password. Please try again.');
                if (callback !== undefined) callback();
              }
            },
            function (response) {
              var validataionMsg = "";
              var errors = response.data.error.errors;
              for (var k in errors) {
                if (errors.hasOwnProperty(k)) {
                  ////MyService.ConsoleLog(k)
                  var obj = errors[k];
                  if (obj.message !== undefined)
                    validataionMsg += obj.message.replace("Path", "") + "<br/>";
                }
              }
              growl.error(validataionMsg);
            }
          );
      };

      function getOrganisationData(term) {
        var q = term.toLowerCase().trim();
        MyService.ConsoleLog("term: ", $scope.User.UserType.toLowerCase());

        var deferred = $q.defer();

        var postdata = {
          max_records: 5,
          keyword: term,
          type: $scope.User.UserType.toLowerCase(),
        };

        var request = apiCall.apiCall("GET", "/office/list", postdata);

        $http(request).then(
          function successCallback(response) {
            MyService.ConsoleLog("succss: ", response);
            if (response.data.success) {
              var returnArr = [];
              angular.forEach(response.data.data, function (val, key) {
                MyService.ConsoleLog(val.title);

                returnArr.push({
                  label: $sce.trustAsHtml(val.title),
                  value: JSON.stringify(val),
                });
              });
              MyService.ConsoleLog(returnArr);
              deferred.resolve(returnArr);
              // growl.success("Tagged successfully");
            } else deferred.resolve([]);
            /*else{
          if(typeof response.data.error == "string")
              growl.error(response.data.error);
          else
              growl.error("Something went wrong");
        }*/
          },
          function errorCallback(response) {
            // growl.error("Something went wrong");
            deferred.resolve([]);
          }
        );

        return deferred.promise;
      }

      // $scope.checkExists = function() {
      //   if ($scope.User.organization) {
      //     $scope.User.outlet_name = $scope.User.organization.title;
      //     $scope.User.organization_name = $scope.User.organization.title;
      //   }

      // }

      $scope.org_autocomplete_options = {
        suggest: getOrganisationData,
        on_select: function (selected) {
          // MyService.ConsoleLog("selected: ", selected);
          // $scope.User.organization_name = selected.label;
          var data = JSON.parse(selected.value);
          $scope.User.organization = data;
          $scope.User.outlet_name = data.title;
          $scope.User.organization_name = data.title;
          // MyService.ConsoleLog($scope.User.organization);
        },
        on_detach: function (current_value) {
          //MyService.ConsoleLog("on_detach: ", current_value);
          /*try{
            if($scope.User.organization.label != current_value)
            $scope.User.organization = null;
        }
        catch(e){
            $scope.User.organization = null;
        }*/
          $scope.User.organization_name = current_value;
        },
      };

      $scope.getAllStates = function () {
        if ($scope.counties) $scope.counties.length = 0;
        if ($scope.places) $scope.places.length = 0;

        var request = apiCall.apiCall("GET", "/user/getAllStates", {
          country: "",
        });
        $http(request).then(
          function successCallback(response) {
            //MyService.ConsoleLog("Got States: ", response);
            if (response.data.success) {
              $scope.states = response.data.data;
            } else {
              growl.error("Something went wrong.");
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
            growl.error("Something went wrong.");
          }
        );
      };
      $scope.getAllStates();

      var getCountiesCanceler = $q.defer();
      // $scope.getCounties = function(lbl) {
      //   //MyService.ConsoleLog("$scope.User.cur_state: ", $scope.User.cur_state)
      //   MyService.ConsoleLog($scope.oldaddress);
      //   var state = {};
      //   if (lbl == "cur")
      //     state = $scope.User.cur_state;
      //   else if (lbl == "new")
      //     state.statePostalCode = $scope.oldaddress.state;
      //   else
      //     state = JSON.parse($scope.User.sel_state);
      //   //MyService.ConsoleLog("state: ", state);

      //   getCountiesCanceler.resolve();
      //   if ($scope.places) $scope.counties.length = 0;

      //   var request = apiCall.apiCall('GET', '/user/getAllCounties', {
      //     "statePostalCode": state.statePostalCode,
      //     "timeout": getCountiesCanceler.promise
      //   });
      //   $http(
      //     request
      //   ).then(function successCallback(response) {
      //     if (response.data.success) {
      //       // MyService.ConsoleLog(response.data.data);
      //       $scope.counties = response.data.data;
      //       if (lbl == "new") {

      //         var county = $scope.checkCounty($scope.counties, $scope.oldaddress.county);
      //         MyService.ConsoleLog("county<><", county);
      //         $scope.address.county = county[0];
      //       }
      //     } else {
      //       growl.error("Something went wrong.");
      //     }
      //   }, function errorCallBack(response) {
      //     MyService.ConsoleLog("Error: ", response);
      //   });

      // }

      var getLocalsCanceler = $q.defer();
      $scope.getLocals = function (lbl) {
        MyService.ConsoleLog($scope.oldaddress);
        var state = {},
          county = {};

        if (lbl == "cur") {
          state = $scope.User.cur_state;
          county = JSON.parse($scope.User.cur_county);
        } else if (lbl == "new") {
          state.statePostalCode = $scope.oldaddress.state;
          county.county = $scope.oldaddress.county;
        } else {
          state = JSON.parse($scope.User.sel_state);
          county = JSON.parse($scope.User.sel_county);
        }

        //MyService.ConsoleLog("county : ", county);
        getLocalsCanceler.resolve();

        var request = apiCall.apiCall("GET", "/user/getAllSubCountiesLocal", {
          statePostalCode: state.statePostalCode,
          county: county.county,
          timeout: getLocalsCanceler.promise,
        });
        $http(request).then(
          function successCallback(response) {
            if (response.data.success) {
              if (response.data.data) {
                MyService.ConsoleLog(response.data.data);
                $scope.places = response.data.data;

                if (lbl == "new") {
                  var subcounty = $scope.checksubCounty(
                    $scope.places,
                    $scope.oldaddress.countySubdivision
                  );

                  var places = $scope.checkPlaces(
                    $scope.places,
                    $scope.oldaddress.place
                  );
                  MyService.ConsoleLog("subcounty<><><", subcounty[0]);
                  $scope.address.countySubdivision = subcounty[0];
                  $scope.address.place = places[0];
                }
              }
            } else {
              growl("Something went wrong.");
            }
          },
          function errorCallBack(response) {
            growl("Something went wrong.");
          }
        );
      };

      $scope.UserLogin = function () {
        // alert($scope.User.isRunningForEle);
        $scope.flag = false;
        if ($filter("isBlankString")($scope.User.isInCurrentOffice)) {
          if ($scope.flag == false) {
            growl.error("Please answer: Are you currently in Office?");
            $scope.flag = true;
          }
        }
        if ($filter("isBlankString")($scope.User.isRunningForEle)) {
          if ($scope.flag == false) {
            growl.error(
              "Please answer: Are you running for office this coming election?"
            );
            $scope.flag = true;
          }
        }

        // if ($.fn.validateForceFully($("#signupform")) == true) {
        if ($scope.flag == false) {
          // alert("Can submit data");
          MyService.ConsoleLog($scope.User);
          var data = JSON.stringify($scope.User);
          MyService.registerLogin({
            data: data,
          }).then(
            function (payload) {
              MyService.ConsoleLog(payload.data.data);
              if (payload.data.success == true) {
                MyService.ConsoleLog(payload.data.data);
                $scope.initAuthorizedUser1(payload.data.data);
                $rootScope.statusAuthenticate = 2;
              } else {
                $rootScope.statusAuthenticate = 3;
                growl.error("Invalid Username or Password. Please try again.");
              }
            },
            function (errorPayload) {}
          );
        }
        // }
      };

      $scope.resetPassword = function () {
        // MyService.ConsoleLog($scope.User.Email);
        // MyService.ConsoleLog($scope.User.cur_office_email);
        var emails = [];
        if ($scope.User.Email && $scope.User.Email != "") {
          if (emails.indexOf($scope.User.Email) == -1) {
            emails.push($scope.User.Email);
          }
        }

        if (
          $scope.User.cur_office_email &&
          $scope.User.cur_office_email != ""
        ) {
          if (emails.indexOf($scope.User.cur_office_email) == -1) {
            emails.push($scope.User.cur_office_email);
          }
        }

        if (emails.length > 0) {
          // MyService.ConsoleLog("emails<><><>", emails);
          MyService.forgotPoliticianPassword({
            email: JSON.stringify(emails),
            reset_url: $rootScope.getPasswordResetUrl(),
          }).then(
            function (payload) {
              // MyService.ConsoleLog("Payload<><><><>", payload);
              if (payload.data.success) {
                alert(payload.data.data);
              } else {
                alert("Something went wrong please try again later");
              }
            },
            function (errorPayload) {
              MyService.ConsoleLog("Payload<><><><>", errorPayload);
            }
          );
        }
      };

      $scope.emptyOrNull = function (item) {
        return !(
          item._id.place === null ||
          item._id.place === "" ||
          item._id.place === " "
        );
      };

      $scope.$watch("User.isRunningForEle", function (newVal, oldVal) {
        //MyService.ConsoleLog("newVal: ", newVal, "oldVal: ", oldVal);
        if (newVal == 1) {
          if ($scope.User.cur_state) {
            //MyService.ConsoleLog("cur_state set");
            $scope.User.sel_state = $scope.User.cur_state;
          } else {
            //MyService.ConsoleLog("cur_state not set");
          }

          if ($scope.User.cur_office_name) {
            $scope.User.office_name = $scope.User.cur_office_name;
          }
          if ($scope.User.cur_jurisdiction_name) {
            $scope.User.jurisdiction_name = $scope.User.cur_jurisdiction_name;
          }

          if ($scope.User.cur_county)
            $scope.User.sel_county = $scope.User.cur_county;
          if ($scope.User.cur_place)
            $scope.User.sel_place = $scope.User.cur_place;

          //MyService.ConsoleLog("sel_state: ", $scope.User.sel_state);
        }
      });

      // if ($scope.UserType == "voter" || $scope.UserType == "politician") {
      //   $("#fiveminform1").validationEngine();
      // }
    },
  ]);

'use strict';

angular.module('myApp.fiveMinLanding', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/fiveMinLanding/:pageType?', {
      templateUrl: 'app/fiveMinLanding/fiveMinLanding.html',
      controller: 'fiveMinLandingCtrl'
    });
  }])

  .controller('fiveMinLandingCtrl', ['$scope', 'apiCall', '$location', '$anchorScroll', '$timeout', '$rootScope', function ($scope, apiCall, $location, $anchorScroll, $timeout, $rootScope) {
    // var returningUser = apiCall.getToken();
    //
    // if (returningUser) {
    //   $location.path('/debateHome');
    // }
    //$scope.showFacebookLoging = false;
    $rootScope.fiveMinLanding = true;
    //console.log("outside :", $rootScope.showFacebookLoging);
    $scope.ogTitle = "VoteWise.net - In life, you can vote with wallet, with your voice, with your actions and at the ballot box. But it's important to always vote wisely.";
    $scope.ogDescription = "VoteWise.net is a non-partisan non-profit tool aimed at repairing democracy by connecting voters, politicians and organizations without advertising dollars getting in the way.  There are different tools available to different types of users, so click on a user type below, watch the 2 minute video and start saving the world.";
    $scope.ogImage = "https://votewise.net/assets/images/VoteWiseMeta.jpg";

    $scope.ShowFB = function () {
      //if()
      //console.log("inside :", $rootScope.showFacebookLoging);
      $rootScope.showFacebookLoging = !$rootScope.showFacebookLoging;
      $location.hash('bottom');
      $anchorScroll();
      //$location.hash('signupform');
      //$anchorScroll();
      //if($scope.showFacebookLoging) {
      // $timeout(function() {

      //console.log("inside after scroll :", $rootScope.showFacebookLoging);
      // }, 1500);

      //}
    }

  }]);

"use strict";

angular
  .module("myApp.fiveMinEssayAnswers", ["ngRoute"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/fiveMinEssayAnswers", {
        templateUrl: "app/fiveMinEssayAnswers/fiveMinEssayAnswers.html",
        controller: "fiveMinEssayAnswersCtrl",
      });
    },
  ])

  .controller("fiveMinEssayAnswersCtrl", [
    "$scope",
    "apiCall",
    "MyService",
    "$location",
    "$anchorScroll",
    "$timeout",
    "$rootScope",
    "ngDialog",
    "$q",
    "$http",
    "$filter",
    "growl",
    "$routeParams",
    "baseApiUrl",
    "tokenService",
    "$cookies",
    function (
      $scope,
      apiCall,
      MyService,
      $location,
      $anchorScroll,
      $timeout,
      $rootScope,
      ngDialog,
      $q,
      $http,
      $filter,
      growl,
      $routeParams,
      baseApiUrl,
      tokenService,
      $cookies
    ) {
      MyService.ConsoleLog("show essay listing");
      window.localStorage.setItem("isShowOldResult", true);

      if (window.localStorage.getItem("essayAnswers")) {
        $scope.essayAns = JSON.parse(
          window.localStorage.getItem("essayAnswers")
        );
      }
    },
  ]);

"use strict";

angular
  .module("myApp.fiveMatchCompare", ["ngRoute"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/fiveCompare/:type?/:quizName?", {
        templateUrl: "app/fivemincompare/fivemincompare.html",
        controller: "fiveCompareCtrl",
      });
    },
  ])

  .controller("fiveCompareCtrl", [
    "$scope",
    "apiCall",
    "MyService",
    "$location",
    "$anchorScroll",
    "$timeout",
    "$rootScope",
    "ngDialog",
    "$q",
    "$http",
    "$filter",
    "growl",
    "$routeParams",
    "baseApiUrl",
    "tokenService",
    "$cookies",
    "$sce",
    function (
      $scope,
      apiCall,
      MyService,
      $location,
      $anchorScroll,
      $timeout,
      $rootScope,
      ngDialog,
      $q,
      $http,
      $filter,
      growl,
      $routeParams,
      baseApiUrl,
      tokenService,
      $cookies,
      $sce
    ) {
      $scope.showAlert = false;
      $scope.showBanner = false;
      $scope.isSkip = $routeParams.type;
      $scope.quizName = $routeParams.quizName;
      if (tokenService.getUserId()) {
        $scope.userId = tokenService.getUserId();
        // console.log('$scope.userId: ', $scope.userId);
      }
      $scope.selectedDate;
      window.localStorage.removeItem("showOtherDetails");
      window.localStorage.removeItem("quesData");
      window.localStorage.removeItem("comData");
      window.localStorage.removeItem("essayAnswer");
      window.localStorage.removeItem("compareAnsData");
      window.localStorage.removeItem("eleDate");
      window.localStorage.removeItem("isShowFiveMin");
      $scope.showcomparison = false;
      MyService.ConsoleLog("  $scope.isSkip :", $scope.isSkip);

      // $scope.electionDates = [
      //   {
      //     _id: 1,
      //     eDate: "May 23, 2020",
      //   },
      //   {
      //     _id: 2,
      //     eDate: "June 23, 2020",
      //   },
      // ];
      $scope.getMailingAddress = function (id) {
        MyService.ConsoleLog("is first call");

        MyService.getMailingAddress({
          userId: id,
        }).then(
          function (result) {
            MyService.ConsoleLog("Result", result);
            $scope.mainData = result.data.data;
            if ($scope.mainData && !$scope.mainData.address) {
              window.localStorage.setItem("isFiveMinPage", true);
              ngDialog.open({
                template: "app/popups/user_localupdate.html",
                data: null,
                className: "ngdialog-theme-default",
              });
            }
          },
          function (err) {
            MyService.ConsoleLog("Error >", err);
          }
        );
      };

      if (tokenService.getUserData()) {
        const usr = tokenService.getUserId();
        MyService.ConsoleLog("user > ", usr);
        $scope.getMailingAddress(usr);
      }

      if (window.localStorage.getItem("queIdsN")) {
        $scope.queIdsN = JSON.parse(window.localStorage.getItem("queIdsN"));

        MyService.ConsoleLog("$scope.queIdsN >> ", $scope.queIdsN);
      }

      $scope.getBannerInfo = function () {
        MyService.getBannerInfo({ event: "All" }).then(function (APIResponse) {
          if (APIResponse.data.success) {
            $scope.bannerInfo = APIResponse.data.data;
            MyService.ConsoleLog("$scope.bannerInfo > ", $scope.bannerInfo);
          }
        });
      };

      $scope.getBannerInfo();
      $scope.parties = ["All Parties"];
      $scope.quiz = {
        eDate: "",
        party: "",
      };

      if ($cookies.get("showLongPopUp")) {
        var msg = $cookies.get("showLongPopUp");
        MyService.ConsoleLog("cookies >>>>>", msg);
        window.localStorage.removeItem("showOtherDetails");

        var modal = ngDialog.openConfirm({
          template:
            "<p>" +
            msg +
            '</p>\
                  <div class="ngdialog-buttons">\
                      <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Close</button>\
                  </div>',
          plain: true,
          closeByDocument: false,
          width: "70%",
        });
        modal.then(
          function fullfilled(data) {
            if (data == 1) {
              // MyService.ConsoleLog("yes")
              $cookies.remove("showLongPopUp");
            } else {
              $cookies.remove("showLongPopUp");
            }
          },
          function rejected(data) {}
        );
      }

      // if (!$rootScope.fiveMatch) {

      $rootScope.fiveMatch = JSON.parse(
        window.localStorage.getItem("fiveMatch")
      );
      MyService.ConsoleLog("fiveMatch : >>>>>>>", $rootScope.fiveMatch);

      MyService.ConsoleLog("temp address : >>", $rootScope.tempUserAddress);

      // }
      if (tokenService.getUserData()) {
        var userData = JSON.parse(tokenService.getUserData());
        // console.log("userData > ", userData);
      }

      /**
       *
       * @description Get front runners records from locaStorage.
       */

      $scope.frontRunners = JSON.parse(
        window.localStorage.getItem("frontRunners")
      );

      if (
        !tokenService.getUserData() &&
        window.localStorage.getItem("poliList")
      ) {
        $scope.poliList = JSON.parse(window.localStorage.getItem("poliList"));
      }

      /*  var orgs;
      if ($cookies.get('sendEmail')) {
        var isData = JSON.parse($cookies.get('sendEmail'));
        MyService.ConsoleLog("isData", isData);
        if ($cookies.get('orgTitle')) {
          orgs = JSON.parse($cookies.get('orgTitle'));

        }
        if (isData && isData != '') {
          $cookies.remove('sendEmail');
          var ansLink = window.location.origin + '/#!/showPoliticianAns/' + $scope.quizName;

          MyService.sendEmailToOrg({
            quizName: $scope.quizName,
            orgEmail: isData,
            orgData: orgs,
            ansLink: ansLink
          }).then(function (result) {
            MyService.ConsoleLog("result", result);
          }, function (err) {
            MyService.ConsoleLog("Error", err);
          });
        }
      }
      // MyService.ConsoleLog("")
      if (!$cookies.get('isShowPopUp')) {
        if ($cookies.get('showNotice')) {
          MyService.ConsoleLog("$cookies.get('showNotice')", $cookies.get('showNotice'));
          // alert('inside');
          var title;
          if ($cookies.get('orgTitle')) {
            var orgData = JSON.parse($cookies.get('orgTitle'));
            title = orgData.title;
          } else {
            title = "Organization";
          }
          var message = "Congratulations!  You have completed the quiz. A notice has been sent to ('<b>'" + title + "'</b>') to let them know, but it wouldn’t hurt to contact them directly just in case.";
          var modal = ngDialog.openConfirm({
            template: '<p>' + message + '</p>\
                  <div class="ngdialog-buttons">\
                      <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(0)">See contact info</button>\
                      <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(1)">More quizzes</button>\
                      \
                  </div>',
            plain: true
          });

          modal.then(function fullfilled(data) {
            //MyService.ConsoleLog("fullfilled: ", data);
            if (data == 1) {
              $location.path('/quizzes');
            } else {
              if (orgData && orgData._id != '') {
                $location.path('/pressProfile/' + orgData._id);

              }
              // alert('else');
            }
          }, function rejected(data) {
            //MyService.ConsoleLog("rejected: ", data);
          });

        }
      } else {
        // alert("alalal");
        $scope.showcomparison = true;
        $scope.loader = false;
        $scope.state = "question-compare-politician";

      }*/

      if (!$rootScope.tempUserAddress) {
        if (tokenService.getUserData()) {
          $rootScope.tempUserAddress = userData.address;
          MyService.ConsoleLog(
            "tempUserAddress :  >>>>>>>",
            $rootScope.tempUserAddress
          );
        }
      } else {
        if (tokenService.getUserData()) {
          var userData = JSON.parse(tokenService.getUserData());
          MyService.ConsoleLog("userData > ", userData);
          // alert("iff");
          MyService.ConsoleLog(
            " ############################# IF ############################### "
          );
          if (
            $rootScope.tempUserAddress.county &&
            $rootScope.tempUserAddress.county != ""
          ) {
            if (
              $rootScope.tempUserAddress.county.county &&
              $rootScope.tempUserAddress.county.county != ""
            ) {
              // alert("Inside If");
              $scope.mainAddress = angular.copy($rootScope.tempUserAddress);
              MyService.ConsoleLog("mainAddress >>> ", $scope.mainAddress);
              var nobj = new Object();

              nobj.state = $scope.mainAddress.state.state;
              nobj.stateFips = $scope.mainAddress.state.stateFips;
              nobj.statePostalCode = $scope.mainAddress.state.statePostalCode;

              nobj.county = $scope.mainAddress.county.countyName;
              nobj.countyFips = $scope.mainAddress.county.countyFips;
              if ($scope.mainAddress.place && $scope.mainAddress.place != "") {
                nobj.place = $scope.mainAddress.place.placeName;
                nobj.placeFips = $scope.mainAddress.place.placeFips;
              }

              nobj.federalCongrassionalDist = $scope.mainAddress
                .federalCongrassionalDist
                ? $scope.mainAddress.federalCongrassionalDist.CD115FP
                : "";

              nobj.stateSenateDistrict = $scope.mainAddress.stateSenateDistrict
                ? $scope.mainAddress.stateSenateDistrict.SLDUST
                : "";

              nobj.legislativeDistrict =
                $scope.mainAddress.stateHouseOFRepresentativeDistrict.NAMELSAD.replace(
                  "State House District ",
                  ""
                );

              nobj.schoolDistrict = $scope.mainAddress.unifiedSchoolDistrictName
                ? $scope.mainAddress.unifiedSchoolDistrictName.NAME
                : "";

              nobj.schoolDistrictFips = $scope.mainAddress
                .unifiedSchoolDistrictName
                ? $scope.mainAddress.unifiedSchoolDistrictName.UNSDLEA
                : "";

              // console.log("nobj > ", nobj);
              $rootScope.tempUserAddress = nobj;
            } else {
              // alert(" Inside else");
              $rootScope.tempUserAddress = userData.address;
              MyService.ConsoleLog(
                "tempUserAddress : @@@",
                $rootScope.tempUserAddress
              );
            }
          }
        } else {
          // alert("else");
          MyService.ConsoleLog(
            " ############################# Else ############################### "
          );

          $scope.mainAddress = $rootScope.tempUserAddress
            ? angular.copy($rootScope.tempUserAddress)
            : JSON.parse(window.localStorage.getItem("extraData"));
          // console.log("mainAddress >>> ", $scope.mainAddress);
          var nobj = new Object();

          nobj.state = $scope.mainAddress.state.state;
          nobj.stateFips = $scope.mainAddress.state.stateFips;
          nobj.statePostalCode = $scope.mainAddress.state.statePostalCode;

          nobj.county = $scope.mainAddress.county
            ? $scope.mainAddress.county.countyName
            : "";
          nobj.countyFips = $scope.mainAddress.county
            ? $scope.mainAddress.county.countyFips
            : "";
          if ($scope.mainAddress.place && $scope.mainAddress.place != "") {
            nobj.place = $scope.mainAddress.place.placeName;
            nobj.placeFips = $scope.mainAddress.place.placeFips;
          }

          nobj.federalCongrassionalDist = $scope.mainAddress
            .federalCongrassionalDist
            ? $scope.mainAddress.federalCongrassionalDist.CD115FP
            : "";

          nobj.stateSenateDistrict = $scope.mainAddress.stateSenateDistrict
            ? $scope.mainAddress.stateSenateDistrict.SLDUST
            : "";
          nobj.cityCouncilDistrictName = $scope.mainAddress.cityCouncilDistrict
            ? $scope.mainAddress.cityCouncilDistrict.COUNTDIST
            : "";
          nobj.legislativeDistrict = $scope.mainAddress
            .stateHouseOFRepresentativeDistrict
            ? $scope.mainAddress.stateHouseOFRepresentativeDistrict.NAMELSAD.replace(
                "State House District ",
                ""
              )
            : "";

          nobj.schoolDistrict = $scope.mainAddress.unifiedSchoolDistrictName
            ? $scope.mainAddress.unifiedSchoolDistrictName.NAME
            : "";

          nobj.schoolDistrictFips = $scope.mainAddress.unifiedSchoolDistrictName
            ? $scope.mainAddress.unifiedSchoolDistrictName.UNSDLEA
            : "";
          // console.log("nobj > ", nobj);
          if (nobj && nobj != "") {
            $rootScope.tempUserAddress = nobj;
          }

          // console.log("$rootScope.tempUserAddress >>> ", $rootScope.tempUserAddress);
        }
      }

      if (
        !tokenService.getUserData() &&
        window.localStorage.getItem("extraData")
      ) {
        $rootScope.tempUserAddress = JSON.parse(
          window.localStorage.getItem("extraData")
        );
      }

      $rootScope.welcome = false;

      $scope.FBCompareList = [];
      $scope.AnswerArray = [];
      $scope.AnswerArray[1] = "Very Strongly Agree";
      $scope.AnswerArray[2] = "Agree";
      $scope.AnswerArray[3] = "Somewhat Agree";
      $scope.AnswerArray[4] = "Somewhat Disagree";
      $scope.AnswerArray[5] = "Disagree";
      $scope.AnswerArray[6] = "Very Strongly Disgree";
      $scope.AnswerImpArray = [];
      $scope.AnswerImpArray[1] = "Somewhat Important";
      $scope.AnswerImpArray[2] = "Important";
      $scope.AnswerImpArray[3] = "Very Important";
      $scope.Math = window.Math;
      $scope.userAreaPolitician = [];
      $scope.userAreaVoters = [];
      $scope.noDataFound = false;
      $scope.hideName = false;
      $scope.checkMyOrder = function (frnd) {
        //MyService.ConsoleLog($scope.ord.Option);
        switch ($scope.ord.Option) {
          case "BW":
            return -(
              $scope.fbcombinedWeight[frnd.id] / $scope.fbmultiplier[frnd.id]
            );
            break;
          case "W":
            return (
              $scope.fbcombinedWeight[frnd.id] / $scope.fbmultiplier[frnd.id]
            );
            break;
          case "BS":
            return -($scope.FBunWeighted[frnd.id] / $scope.fbqlen[frnd.id]);
            break;
          case "S":
            return $scope.FBunWeighted[frnd.id] / $scope.fbqlen[frnd.id];
            break;
          default:
            return -(
              $scope.fbcombinedWeight[frnd.id] / $scope.fbmultiplier[frnd.id]
            );
            break;
        }
      };
      $scope.nextCat = function () {
        $scope.rootCatIndex = window.localStorage.getItem("RootCatIndex");
        if ($scope.rootCatIndex < $rootScope.categories.length - 1) {
          $location.path(
            "/question-compare/all/" +
              $rootScope.categories[$scope.rootCatIndex]._id
          );
        }
      };

      $scope.getOthersMatch = function (params) {
        $scope.loader = true;

        MyService.ConsoleLog("params >", params);
        params.usersIds = JSON.stringify(params.usersIds);
        // params.questions = JSON.parse(params.questions);
        MyService.getOthersMatch(params).then(
          function (payload) {
            MyService.ConsoleLog("payload >", payload);
            $scope.loader = false;

            if (
              payload.data.data.unweightedMatch &&
              payload.data.data.unweightedMatch != ""
            ) {
              $scope.FBunWeighted = payload.data.data.unweightedMatch;
              $scope.politician = true;
            }
            if (
              payload.data.data.advunWeighated &&
              payload.data.data.advunWeighated != ""
            ) {
              $scope.advUnWeighated = payload.data.data.advunWeighated;
              $scope.showadv = true;
            }
            if (
              payload.data.data.voterunWeight &&
              payload.data.data.voterunWeight != ""
            ) {
              $scope.voterUnWeighated = payload.data.data.voterunWeight;
              $scope.showvoter = true;
            }
            $scope.fbcombinedWeight = payload.data.data.fbcombinedWeight;
            $scope.fbmultiplier = payload.data.data.fbmultiplier;
            $scope.fbqlen = payload.data.data.qdata.length;
            $scope.voterCombined = payload.data.data.voterCombWeight;
            $scope.voterMulti = payload.data.data.voterMulti;
            $scope.advCombined = payload.data.data.advCombWeight;
            $scope.advMulti = payload.data.data.advMulti;
            $scope.allUser = payload.data.data.AllUsers;
            // var tmpData = JSON.parse(window.localStorage.getItem('fiveMatch'));
            // MyService.ConsoleLog("tmpData >>>>>>>", tmpData);
            var tmpArr = $rootScope.fiveMatch.filter(function (itms) {
              itms.my_answer = {};
              itms["my_answer"].answer = itms.answer;
              itms.my_answer.comment = itms.comment;
              itms.my_answer.importance = itms.importance;
              return itms;
            });
            MyService.ConsoleLog("Check this if you can", tmpArr);
            var objParams = {
              usersIds: $scope.userAreaPolitician,
              questions: JSON.stringify(tmpArr),
              cur_userId: $scope.userId,
            };
            window.localStorage.setItem("comData", JSON.stringify(objParams));
            window.localStorage.setItem("quesData", JSON.stringify(tmpArr));
          },
          function (error) {
            MyService.ConsoleLog("error", error);
          }
        );
      };

      $scope.getGroupMatch = function () {
        $scope.statusGetLocalPoliticians = 1;
        $scope.page += 1;
        $scope.loader = true;
        // MyService.ConsoleLog("$rootScope.tempUserA ******* ", $rootScope.tempUserAddress);
        // MyService.ConsoleLog("$rootScope.tempUserA ******* ", $rootScope.tempUserAddress.state)
        var extradata = new Object();
        if ($rootScope.tempUserAddress) {
          if (
            $rootScope.tempUserAddress.state &&
            $rootScope.tempUserAddress.state != ""
          ) {
            extradata.statePostalCode =
              $rootScope.tempUserAddress.statePostalCode;
          }
          if ($rootScope.tempUserAddress.county) {
            // $rootScope.tempUserAddress.FinalData = JSON.stringify(
            //   $rootScope.tempUserAddress.countyFips
            // );
            extradata.county = $rootScope.tempUserAddress.county;
          }
          if (
            $rootScope.tempUserAddress.countySubdivision &&
            $rootScope.tempUserAddress.countySubdivisionFips
          ) {
            $rootScope.tempUserAddress.FinalData = JSON.stringify(
              $rootScope.tempUserAddress.countySubdivisionFips
            );
            extradata.countySubdivision =
              $rootScope.tempUserAddress.countySubdivision;
          }
          if ($rootScope.tempUserAddress.place) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.place = $rootScope.tempUserAddress.place;
          }
          if (
            $rootScope.tempUserAddress.voterDistrict &&
            $rootScope.tempUserAddress.voterDistrictFips
          ) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.voterDistrict = $rootScope.tempUserAddress.voterDistrict;
          }
          if ($rootScope.tempUserAddress.federalCongrassionalDist) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            MyService.ConsoleLog(
              "federalCongrassionalDist  :",
              $rootScope.tempUserAddress.federalCongrassionalDist
            );
            extradata.federalCongrassionalDist =
              $rootScope.tempUserAddress.federalCongrassionalDist;
          }
          if ($rootScope.tempUserAddress.stateSenateDistrict) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.stateSenateDistrict =
              $rootScope.tempUserAddress.stateSenateDistrict;
          }
          if ($rootScope.tempUserAddress.legislativeDistrict) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.legislativeDistrict =
              $rootScope.tempUserAddress.legislativeDistrict;
          }
          if ($rootScope.tempUserAddress.schoolDistrict) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.schoolDistrict =
              $rootScope.tempUserAddress.schoolDistrict;
          }
          if ($rootScope.tempUserAddress.cityCouncilDistrict) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.cityCouncilDistrictName =
              $rootScope.tempUserAddress.cityCouncilDistrict;
          }
        }
        MyService.ConsoleLog(
          "extradata : >>>>>>>>>> ",
          JSON.stringify(extradata)
        );
        MyService.getAllLocalPoli({
          max_records: 100,
          page: $scope.page,
          extradata: JSON.stringify(extradata),
        }).then(
          function (response) {
            if (response.data.success) {
              setTimeout(function () {
                $scope.$apply(function () {
                  if (response.data.data.length > 0) {
                    MyService.getAdvocates().then(
                      function (payload) {
                        MyService.ConsoleLog("Response >", payload);
                        var ndata = response.data.data;
                        var wdata = ndata.concat(payload.data.data);

                        $scope.userAreaPolitician = wdata.map(function (ques) {
                          return ques._id;
                        });
                        // $rootScope.fiveMatch.filter(function (itms) {
                        //   MyService.ConsoleLog("itms", itms);
                        //   var myAns = {
                        //     answer: '',
                        //     importance: '',
                        //     comment: ''
                        //   };
                        //   myAns = itms;
                        //   myAns['answer'] = itms.answer;
                        //   myAns['importance'] = itms.importance;
                        //   myAns['comment'] = itms.comment;
                        //   itms.my_answer = myAns;
                        //   return itms;
                        // });

                        MyService.ConsoleLog(
                          " $scope.userAreaPolitician >",
                          $scope.userAreaPolitician
                        );
                        // MyService.ConsoleLog("  $rootScope.fiveMatch >", $rootScope.fiveMatch);

                        $scope.getOthersMatch({
                          userIds: JSON.stringify($scope.userAreaPolitician),
                          quizData: JSON.stringify($rootScope.fiveMatch),
                          userData: $scope.userId,
                        });
                      },
                      function (err) {
                        MyService.ConsoleLog("Error >>", err);
                      }
                    );
                  } else {
                    $scope.loader = false;
                    // var message =
                    //   "No active candidates in your area have answered this set of questions yet. Contact them and ask them to fill it out.";
                    // var modal = ngDialog.openConfirm({
                    //   template:
                    //     "<p>" +
                    //     message +
                    //     '</p>\
                    //     <div class="ngdialog-buttons">\
                    //         <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">OK</button>\
                    //         \
                    //     </div>',
                    //   plain: true,
                    // });

                    // modal.then(
                    //   function fullfilled(data) {
                    //     //MyService.ConsoleLog("fullfilled: ", data);
                    //     if (data == 1) {
                    //       $scope.postonFacebook();
                    //     } else {
                    //       if ($rootScope.userRole) {
                    //         $location.path("/snapshot");
                    //       } else {
                    //         $location.path("/signin");
                    //       }
                    //     }
                    //   },
                    //   function rejected(data) {
                    //     //MyService.ConsoleLog("rejected: ", data);
                    //   }
                    // );
                  }
                });
              }, 100);
            } else {
              $scope.page -= 1;
              $scope.statusGetLocalPoliticians = 3;
              if (typeof response.data.error == "string")
                growl.error(response.data.error);
              else growl.error("Something went wrong");
            }
          },
          function (err) {
            $scope.page -= 1;
            $scope.statusGetLocalPoliticians = 3;
            $scope.loader = false;
            growl.error(err);
          }
        );
      };
      $scope.page = 0;
      $scope.loader = false;

      $scope.getLocalPoliticians = function (val, pVal) {
        MyService.ConsoleLog(" welcome to getLocalPoliticians ", val);
        $scope.statusGetLocalPoliticians = 1;
        $scope.page += 1;
        $scope.loader = true;
        MyService.ConsoleLog(
          "$rootScope.tempUserA ******* ",
          $rootScope.tempUserAddress
        );
        if (
          !tokenService.getUserData() &&
          $rootScope.tempUserAddress &&
          $rootScope.tempUserAddress.schoolDistrict &&
          $rootScope.tempUserAddress.schoolDistrict != ""
        ) {
          window.localStorage.setItem(
            "extraData",
            JSON.stringify($rootScope.tempUserAddress)
          );
        }
        if (!$rootScope.tempUserAddress) {
          if (
            !tokenService.getUserData() &&
            window.localStorage.getItem("extraData")
          ) {
            $rootScope.tempUserAddress = JSON.parse(
              window.localStorage.getItem("extraData")
            );
            MyService.ConsoleLog(
              "$rootScope.tempUserAddress >> ",
              $rootScope.tempUserAddress
            );
          }
        }
        var extradata = new Object();
        if ($rootScope.tempUserAddress) {
          if (
            $rootScope.tempUserAddress.state &&
            $rootScope.tempUserAddress.state != ""
          ) {
            extradata.statePostalCode =
              $rootScope.tempUserAddress.statePostalCode;
          }
          if ($rootScope.tempUserAddress.county) {
            $rootScope.tempUserAddress.FinalData = $rootScope.tempUserAddress
              .countyFips
              ? JSON.stringify($rootScope.tempUserAddress.countyFips)
              : "";
            extradata.county = $rootScope.tempUserAddress.county;
          }
          if ($rootScope.tempUserAddress.countySubdivision) {
            $rootScope.tempUserAddress.FinalData = $rootScope.tempUserAddress
              .countySubdivisionFips
              ? JSON.stringify($rootScope.tempUserAddress.countySubdivisionFips)
              : "";
            extradata.countySubdivision =
              $rootScope.tempUserAddress.countySubdivision;
          }
          if ($rootScope.tempUserAddress.place) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.place = $rootScope.tempUserAddress.place;
          }
          if (
            $rootScope.tempUserAddress.voterDistrict &&
            $rootScope.tempUserAddress.voterDistrictFips
          ) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.voterDistrict = $rootScope.tempUserAddress.voterDistrict;
          }

          if (
            $rootScope.tempUserAddress.cityCouncilDistrictName &&
            $rootScope.tempUserAddress.cityCouncilDistrictName != ""
          ) {
            extradata.cityCouncilDistrictName =
              $rootScope.tempUserAddress.cityCouncilDistrictName;
          }
          if ($rootScope.tempUserAddress.federalCongrassionalDist) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            MyService.ConsoleLog(
              "federalCongrassionalDist  :",
              $rootScope.tempUserAddress.federalCongrassionalDist
            );
            extradata.federalCongrassionalDist =
              $rootScope.tempUserAddress.federalCongrassionalDist;
          }
          if ($rootScope.tempUserAddress.stateSenateDistrict) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.stateSenateDistrict =
              $rootScope.tempUserAddress.stateSenateDistrict;
          }
          if ($rootScope.tempUserAddress.legislativeDistrict) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.legislativeDistrict =
              $rootScope.tempUserAddress.legislativeDistrict;
          }
          if ($rootScope.tempUserAddress.schoolDistrict) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.schoolDistrict =
              $rootScope.tempUserAddress.schoolDistrict;
          }
        }
        MyService.ConsoleLog("extradata : >>>>>>>>>> ", extradata);

        MyService.ConsoleLog("check add data >> ", $rootScope.tempUserAddress);

        MyService.getLocalPoliForVoterFivemin({
          max_records: 100,
          page: $scope.page,
          extradata: JSON.stringify(extradata),
          eDate: val ? val : new Date(),
          party: pVal,
        }).then(
          function (response) {
            if (response.data.success) {
              setTimeout(function () {
                $scope.$apply(function () {
                  if (response.data.data.poliRecords.length > 0) {
                    var ndata = response.data.data.poliRecords;
                    $scope.poliList = ndata;
                    window.localStorage.setItem(
                      "poliList",
                      JSON.stringify($scope.poliList)
                    );
                    if (
                      response.data.data.parties &&
                      response.data.data.parties.length > 0
                    ) {
                      var partyArr = [];

                      $scope.parties = response.data.data.parties;
                      console.log(
                        '$scope.parties.indexOf("All Parties") > ',
                        $scope.parties.indexOf("All Parties")
                      );
                      if ($scope.parties.indexOf("All Parties") == -1) {
                        $scope.parties.unshift("All Parties");
                      }
                      window.localStorage.setItem(
                        "parties",
                        JSON.stringify($scope.parties)
                      );
                      // response.data.data.parties.filter(function (party, ind) {
                      //   partyArr.push({
                      //     // _id: ind + 1,
                      //     party: party,
                      //   });
                      // });
                      // // partyArr.unshift({
                      // //   _id: 0,
                      // //   party: "All Parties",
                      // // });
                      // window.localStorage.setItem(
                      //   "parties",
                      //   JSON.stringify(partyArr)
                      // );
                      // $scope.parties = $scope.parties.concat(partyArr);
                      // $scope.parties.filter(function (item, pos) {
                      //   return $scope.parties.indexOf(item) == pos;
                      // });
                    }

                    $scope.userAreaPolitician = ndata.map(function (ques) {
                      return ques._id;
                    });
                    MyService.ConsoleLog(
                      " userAreaPolitician :",
                      $scope.userAreaPolitician
                    );
                    $scope.CompareWithAllPolitcians(val);
                  } else {
                    // alert("esdlse");
                    $scope.allCandidates = [];
                    window.localStorage.setItem("showOtherDetails", true);
                    $scope.loader = false;
                    $scope.showBanner = true;
                    // var message =
                    //   "No active candidates in your area have answered this set of questions yet. Contact them and ask them to fill it out.";
                    // var modal = ngDialog.openConfirm({
                    //   template:
                    //     "<p>" +
                    //     message +
                    //     '</p>\
                    //     <div class="ngdialog-buttons">\
                    //         <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(1)">See How You Match Your Community</button>\
                    //         <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">Learn More About Your Candidates</button>\
                    //         \
                    //     </div>',
                    //   plain: true,
                    //   width: "70%",
                    // });

                    // modal.then(
                    //   function fullfilled(data) {
                    //     //MyService.ConsoleLog("fullfilled: ", data);
                    //     if (data == 1) {
                    //       $scope.getGroupMatch();
                    //     } else {
                    //       $location.path("/compare-select/politician");
                    //     }
                    //   },
                    //   function rejected(data) {
                    //     //MyService.ConsoleLog("rejected: ", data);
                    //   }
                    // );
                  }
                });
              }, 100);
            } else {
              $scope.page -= 1;
              $scope.statusGetLocalPoliticians = 3;
              if (typeof response.data.error == "string")
                growl.error(response.data.error);
              else growl.error("Something went wrong");
            }
          },
          function (err) {
            $scope.page -= 1;
            $scope.statusGetLocalPoliticians = 3;
            $scope.loader = false;
            growl.error("Something went wrong");
          }
        );
      };

      $scope.changeColor = function (val) {
        $scope.gr = {
          background:
            "linear-gradient(to right,#FEFF10 ," + val + "%, #2b4f7f 10%)",
        };
        // MyService.ConsoleLog("$scope.gr", $scope.gr);
        return $scope.gr;
      };

      /**
       * @description Saved candidates to the locatstorage
       */
      $scope.savedCandi = [];
      $scope.saveCandidates = function (candi) {
        if (candi.isChecked) {
          $scope.savedCandi.push(candi);
          window.localStorage.setItem(
            "savedCandidates",
            JSON.stringify($scope.savedCandi)
          );
        } else {
          MyService.ConsoleLog(" $scope.savedCandi > ", $scope.savedCandi);
          MyService.ConsoleLog(" candi > ", candi);
          var toDel = $scope.savedCandi.indexOf(candi);
          MyService.ConsoleLog("toDel >> ", toDel);

          $scope.savedCandi.splice(toDel, 1);
          MyService.ConsoleLog(
            " $scope.savedCandi after rm > ",
            $scope.savedCandi
          );
          window.localStorage.removeItem("savedCandidates");
          window.localStorage.setItem(
            "savedCandidates",
            JSON.stringify($scope.savedCandi)
          );
        }
      };

      $scope.showSavedCandidates = function () {
        if (window.localStorage.getItem("savedCandidates")) {
          $scope.showCandidates = JSON.parse(
            window.localStorage.getItem("savedCandidates")
          );
        } else {
          growl.error("Seems no candidates are saved");
        }

        if ($scope.showCandidates && $scope.showCandidates.length > 0) {
          $scope.showPopUp = ngDialog.open({
            template: "showSavedCandi",
            scope: $scope,
            width: "60%",
          });
        } else {
          growl.error("Seems no candidates are saved");
        }
      };

      /**
       * Cancel
       */

      $scope.hidePopup = function () {
        if ($scope.showPopUp) {
          $scope.showPopUp.close();
        }

        if ($scope.isShowMatch) {
          $scope.isShowMatch.close();
        }
        if ($scope.isShowPopUp) {
          $scope.isShowPopUp.close();
        }
      };

      $scope.finish = function () {
        window.localStorage.setItem("isShowFiveMin", true);
        $location.path("/fiveMatch");
      };

      /**
       * @description Show the description of essay question answers
       */
      $scope.readStatement = function (val) {
        MyService.ConsoleLog("val >> ", val);
        window.localStorage.setItem("essayAnswers", JSON.stringify(val));
        if (val && val.length > 0) {
          $location.path("/fiveMinEssayAnswers");
        } else {
          growl.error("Candidate Haven't answered essay questions");
        }
      };

      /**
       * @description Redirect to get match list
       */
      $scope.redirectTo = function (type) {
        $location.path("/showListOfMatch/" + type);
      };

      $scope.showSelectedOffice = function (ans) {
        // MyService.ConsoleLog(
        //   "check questions >> ",
        //   $scope.questions[$scope.currentIndex]
        // );
        var isData = ans.author.politicianInfo.filter(function (polInfo) {
          if (
            polInfo.officeName &&
            polInfo.officeName != "" &&
            $scope.office == polInfo.officeName.toLowerCase()
          ) {
            // MyService.ConsoleLog(
            //   "check office name >> ",
            //   $scope.office,
            //   "polInfo.officeName",
            //   polInfo.officeName
            // );
            return polInfo;
          }
        });
        // MyService.ConsoleLog("isData >> ", isData);
        if (isData && isData.length > 0) {
          return true;
        } else {
          return false;
        }
      };

      $scope.showDetails = function (key) {
        $scope.office = key.toLowerCase();
        $scope.currentIndex = 0;
        MyService.ConsoleLog(
          "check flag",
          window.localStorage.getItem("showOtherDetails")
        );
        if (window.localStorage.getItem("showOtherDetails") == "true") {
          $location.path("/showAllUsersMatch");
        } else {
          $scope.hidePopup();
          $scope.showcomparison = true;
        }
      };

      $scope.allCandidates = [];
      $scope.filterCandidatesOfficeWise = function () {
        var cLen = $scope.AllUsers.length;
        MyService.ConsoleLog("cLen >> ", cLen);
        for (var i = 0; i < cLen; i++) {
          var udata = $scope.AllUsers[i];
          udata = JSON.parse(JSON.stringify(udata));
          if (udata.politicianInfo && udata.politicianInfo.length > 0) {
            var poliInfoLen = udata.politicianInfo.length;

            for (var j = 0; j < poliInfoLen; j++) {
              var polivar = udata.politicianInfo[j];
              if (
                polivar &&
                polivar.officeName != "" &&
                polivar.runningForOffice == "Y"
              ) {
                MyService.ConsoleLog("polivar >> ", polivar.levelOfGov);
                if (
                  (polivar.levelOfGov == "placeName" ||
                    polivar.levelOfGov == "countySubDivisionName" ||
                    polivar.levelOfGov == "unifiedSchoolDistrictName" ||
                    polivar.levelOfGov == "elementarySchoolDistrictName" ||
                    polivar.levelOfGov == "secondarySchoolDistrictName" ||
                    polivar.levelOfGov == "cityCouncilDistrictName" ||
                    polivar.levelOfGov == "countySubdivision") &&
                  polivar.candidateStatus != "inactive"
                ) {
                  if (polivar.officeName) {
                    polivar.officeName = polivar.officeName.toLowerCase();
                    udata.party = "";
                    var newOff = polivar.officeName.toLowerCase();
                    udata.office = newOff;
                    udata.candidateStatus = polivar.candidateStatus;
                  }
                  if (typeof polivar.party == "string") {
                    polivar.party = polivar.party;
                  } else {
                    var party = "";
                    polivar.party.forEach(function (element, index) {
                      if (element) {
                        party += element + ", ";
                        var n = party.lastIndexOf(",");
                        var a = party.substring(0, n);
                        udata.party = a;
                      }
                    });
                  }

                  $scope.allCandidates.push(udata);

                  // MyService.ConsoleLog(
                  //   "$scope.allCandidates >",
                  //   $scope.allCandidates
                  // );
                } else if (
                  (polivar.levelOfGov == "countyName" ||
                    polivar.levelOfGov == "county") &&
                  polivar.candidateStatus != "inactive"
                ) {
                  if (polivar.officeName) {
                    polivar.officeName = polivar.officeName.toLowerCase();
                    udata.office = polivar.officeName;
                    udata.candidateStatus = polivar.candidateStatus;
                    udata.party = polivar.party;
                  }
                  if (typeof polivar.party == "string") {
                    polivar.party = polivar.party;
                  } else {
                    var party = "";
                    polivar.party.forEach(function (element, index) {
                      if (element) {
                        party += element + ", ";
                        var n = party.lastIndexOf(",");
                        var a = party.substring(0, n);
                        udata.party = a;
                      }
                    });
                  }

                  if (typeof polivar.party == "string") {
                    // if ($scope.comp.party && $scope.comp.party != "") {
                    //   if ($scope.comp.party == udata.politicianInfo[s].party) {
                    //     $scope.allCandidates.push(udata);
                    //   }
                    // } else {
                    $scope.allCandidates.push(udata);
                    // }
                  } else {
                    $scope.allCandidates.push(udata);
                  }
                } else if (
                  (polivar.levelOfGov == "statePostalCode" ||
                    (polivar.levelOfGov == "stateSenateDistrict" &&
                      polivar.officeName != "" &&
                      polivar.officeName.toLowerCase() != "u.s. senate") ||
                    polivar.officeName != "president") &&
                  polivar.candidateStatus != "inactive"
                ) {
                  if (polivar.officeName) {
                    polivar.officeName = polivar.officeName.toLowerCase();
                    udata.office = polivar.officeName;
                    udata.candidateStatus = polivar.candidateStatus;
                    udata.party = polivar.party;
                  }
                  if (typeof polivar.party == "string") {
                    polivar.party = polivar.party;
                  } else {
                    var party = "";
                    polivar.party.forEach(function (element, index) {
                      if (element) {
                        party += element + ", ";
                        var n = party.lastIndexOf(",");
                        var a = party.substring(0, n);

                        udata.party = a;
                      }
                    });
                  }

                  $scope.allCandidates.push(udata);
                } else if (
                  polivar.levelOfGov == "federalCongressionalDistrict" ||
                  polivar.officeName == "president" ||
                  (polivar.officeName == "President" &&
                    polivar.levelOfGov == "All USA") ||
                  polivar.levelOfGov == "all USA" ||
                  (polivar.levelOfGov == "statePostalCode" &&
                    polivar.officeName != "" &&
                    polivar.officeName != "State House") ||
                  polivar.officeName != "auditor" ||
                  (polivar.officeName != "" &&
                    polivar.officeName.toLowerCase() == "u.s. senate" &&
                    polivar.candidateStatus != "inactive")
                ) {
                  if (polivar.levelOfGov != "unifiedSchoolDistrictName") {
                    if (polivar.officeName) {
                      polivar.officeName = polivar.officeName.toLowerCase();
                      if (typeof polivar.party == "string") {
                        polivar.party = polivar.party;
                      } else {
                        var party = "";
                        polivar.party.forEach(function (element, index) {
                          if (element) {
                            party += element + ", ";
                            var n = party.lastIndexOf(",");
                            var a = party.substring(0, n);
                            udata.party = a;
                          }
                        });
                      }
                      udata.office = polivar.officeName;
                      udata.candidateStatus = polivar.candidateStatus;
                    }

                    $scope.allCandidates.push(udata);
                  } else if (
                    (polivar.levelOfGov == "All USA" ||
                      polivar.levelOfGov == "all USA") &&
                    polivar.officeName != "president" &&
                    polivar.candidateStatus != "inactive"
                  ) {
                    if (polivar.officeName) {
                      polivar.officeName = polivar.officeName.toLowerCase();
                      udata.office = polivar.officeName;
                      udata.candidateStatus = polivar.candidateStatus;
                      udata.party = polivar.party;
                    }

                    $scope.allCandidates.push(udata);
                  }
                }
              }
            }
          } else {
            if (udata.voterScope) {
              if (
                udata.voterScope == "placeName" ||
                udata.voterScope == "countySubDivisionName" ||
                udata.voterScope == "unifiedSchoolDistrictName" ||
                udata.voterScope == "elementarySchoolDistrictName" ||
                udata.voterScope == "cityCouncilDistrictName" ||
                udata.voterScope == "secondarySchoolDistrictName" ||
                (udata.voterScope == "countySubdivision" &&
                  udata.voterScope != "federalCongressionalDistrict")
              ) {
                udata.office = udata.office.toLowerCase();
                if (typeof udata.party == "string") {
                  // alert('one');
                  udata.party = udata.party;
                } else {
                  var party = "";
                  udata.party.forEach(function (element, index) {
                    if (element) {
                      party += element + ", ";
                      var n = party.lastIndexOf(",");
                      var a = party.substring(0, n);

                      if (a != '""') {
                        udata.party = a;
                      } else {
                        udata.party = "";
                      }
                    }
                  });
                }
                if (
                  udata &&
                  udata.office &&
                  udata.office.toLowerCase() != "president"
                ) {
                  if (udata.verifiedUser != false) {
                    $scope.allCandidates.push(udata);
                  }
                }
              } else if (
                udata.voterScope == "countyName" ||
                udata.voterScope == "county"
              ) {
                udata.office = udata.office.toLowerCase();
                if (typeof udata.party == "string") {
                  udata.party = udata.party;
                } else {
                  var party = "";
                  udata.party.forEach(function (element, index) {
                    if (element) {
                      party += element + ", ";
                      var n = party.lastIndexOf(",");
                      var a = party.substring(0, n);
                      udata.party = a;
                    }
                  });
                }
                if (udata.verifiedUser != false) {
                  $scope.allCandidates.push(udata);
                }
              } else if (
                udata.electionOfficeTypeId == "S" ||
                udata.electionOfficeTypeId == "K" ||
                udata.electionOfficeTypeId == "L" ||
                udata.voterScope == "statePostalCode"
              ) {
                // MyService.ConsoleLog("plz check ========", udata);
                udata.office = udata.office.toLowerCase();
                if (typeof udata.party == "string") {
                  udata.party = udata.party;
                } else {
                  var party = "";
                  udata.party.forEach(function (element, index) {
                    if (element) {
                      party += element + ", ";
                      var n = party.lastIndexOf(",");
                      var a = party.substring(0, n);

                      udata.party = a;
                    }
                  });
                }

                if (udata.verifiedUser != false) {
                  $scope.allCandidates.push(udata);
                }
              } else if (
                type == "federal" &&
                (udata.electionOfficeTypeId == "C" ||
                  udata.electionOfficeTypeId == "J" ||
                  udata.electionOfficeTypeId == "R" ||
                  udata.voterScope == "federalCongressionalDistrict" ||
                  udata.office == "president" ||
                  (udata.office == "President" &&
                    udata.voterScope == "All USA") ||
                  udata.voterScope == "all USA" ||
                  udata.voterScope == "statePostalCode")
              ) {
                if (udata.voterScope != "unifiedSchoolDistrictName") {
                  udata.office = udata.office.toLowerCase();

                  if (typeof udata.party == "string") {
                    udata.party = udata.party;
                  } else {
                    var party = "";
                    udata.party.forEach(function (element, index) {
                      if (element) {
                        party += element + ", ";
                        var n = party.lastIndexOf(",");
                        var a = party.substring(0, n);

                        udata.party = a;
                      }
                    });
                  }

                  if (
                    (udata.office &&
                      udata.office.toLowerCase() == "u.s. house") ||
                    udata.office.toLowerCase() == "u.s. senate" ||
                    udata.office.toLowerCase() == "president"
                  ) {
                    if (udata.verifiedUser != false) {
                      if (
                        udata.isOnBallot != false &&
                        $scope.comp.election.electionDate == udata.electionDate
                      ) {
                        $scope.topCandidates.push(udata);
                      } else {
                        $scope.allCandidates.push(udata);
                      }
                    }
                  }
                }
              } else if (
                type == "other" &&
                (udata.voterScope == "All USA" || udata.voterScope == "all USA")
              ) {
                if (udata.verifiedUser != false) {
                  $scope.allCandidates.push(udata);
                }
                // }
              } else if (
                udata.office == "president" ||
                (udata.office == "President" &&
                  udata.voterScope == "All USA") ||
                udata.voterScope == "all USA"
              ) {
                if (udata.voterScope != "unifiedSchoolDistrictName") {
                  udata.office = udata.office.toLowerCase();

                  if (typeof udata.party == "string") {
                    udata.party = udata.party;
                  } else {
                    var party = "";
                    udata.party.forEach(function (element, index) {
                      if (element) {
                        party += element + ", ";
                        var n = party.lastIndexOf(",");
                        var a = party.substring(0, n);

                        udata.party = a;
                      }
                    });
                  }

                  if (
                    udata.verifiedUser != false &&
                    type != "state" &&
                    type != "local"
                  ) {
                    $scope.allCandidates.push(udata);
                  }
                }
              }
            }
          }
        }
        MyService.ConsoleLog(
          " $scope.allCandidates before filter >> ",
          $scope.allCandidates
        );
        var data = $scope.allCandidates.filter(function (item, ind) {
          return (
            ind ==
            $scope.allCandidates.findIndex(function (val) {
              return JSON.stringify(val) == JSON.stringify(item);
            })
          );
        });
        $scope.allCandidates == [];
        $scope.allCandidates = data;
        MyService.ConsoleLog(" $scope.allCandidates >> ", $scope.allCandidates);
      };

      $scope.getUrl = function (val) {
        // MyService.ConsoleLog("val >> ", val);
        if (val && val.review) {
          switch (val.review.toLowerCase()) {
            case "qualified":
            case "recommended":
              return "../assets/images/yellowCheck.svg";
            case "highly qualified":
            case "highly recommended":
              return "../assets/images/greenCheck.svg";
            case "unqualified":
            case "not recommended":
              return "../assets/images/redX.svg";

            case "declined to review":
              return "../assets/images/redExclamation.svg";
            default:
              break;
          }
        }
      };

      $scope.CompareWithAllPolitcians = function (val) {
        $timeout(function () {
          //MyService.ConsoleLog("here : ", $scope.userAreaPolitician);
          var ndata = {
            userdata: $rootScope.fiveMatch,
            comparewith: $scope.userAreaPolitician,
            type: "politician",
          };
          MyService.ConsoleLog("Compare this data <><<><>", ndata);
          if ($rootScope.fiveMatch && $rootScope.fiveMatch.length > 0) {
            MyService.compareFiveMinAnswers({
              userdata: JSON.stringify($rootScope.fiveMatch),
              comparewith: JSON.stringify($scope.userAreaPolitician),
              type: "politician",
              eDate: val ? val : new Date(),
              party: $scope.quiz.party,
              queIdsArr: window.localStorage.getItem("queIdsN")
                ? window.localStorage.getItem("queIdsN")
                : [],
            }).then(
              function (payload) {
                MyService.ConsoleLog("compareFiveMinAnswers1 success ****");
                MyService.ConsoleLog("payload check >> ", payload);
                $scope.FBCompareList = [];
                $scope.loader = false;
                if (payload.data.success) {
                  MyService.ConsoleLog(
                    "CompareWithAllPolitcians >> ",
                    payload.data.data.qdata
                  );

                  if (
                    !payload.data.data.qdata &&
                    payload.data.data.AllUsers &&
                    payload.data.data.AllUsers.length > 0
                  ) {
                    if (window.localStorage.getItem("savedCandidates")) {
                      savedCan = JSON.parse(
                        window.localStorage.getItem("savedCandidates")
                      );
                    }
                    $scope.AllUsers = payload.data.data.AllUsers.filter(
                      function (val) {
                        if (val && val._id != "") {
                          $scope.poliList.filter(function (itm) {
                            if (val._id == itm._id) {
                              val.numberOfOpenings = itm.numberOfOpenings;
                              val.dataX = itm.dataX;
                              val.dataY = itm.dataY;
                              val.total_tagged = itm.total_tagged;
                              val.total_answers = itm.total_answers;
                            }
                          });
                          return val;
                        }
                      }
                    );

                    if (savedCan && savedCan.length > 0) {
                      $scope.AllUsers.map(function (item) {
                        savedCan.filter(function (val) {
                          if (item.name == val.name) {
                            item.isChecked = true;
                          }
                        });
                        return item;
                      });
                    }

                    if (
                      payload.data.data.barRatings &&
                      payload.data.data.barRatings != ""
                    )
                      $scope.barRatingData = payload.data.data.barRatings;
                    window.localStorage.setItem(
                      "compareResult",
                      JSON.stringify(payload.data.data)
                    );

                    $scope.allCandidates = [];
                    $scope.filterCandidatesOfficeWise();
                  }

                  if (
                    payload.data.data &&
                    payload.data.data.qdata &&
                    payload.data.data.qdata.length > 0
                  ) {
                    $scope.questions = payload.data.data.qdata.sort(function (
                      x,
                      y
                    ) {
                      if (x.matchOrder < y.matchOrder) {
                        return -1;
                      }
                      if (x.matchOrder > y.matchOrder) {
                        return 1;
                      }
                      return 0;
                    });
                  }

                  window.localStorage.setItem(
                    "compareResult",
                    JSON.stringify(payload.data.data)
                  );
                  if (
                    payload.data.data.qdata &&
                    payload.data.data.qdata.length > 0
                  ) {
                    $scope.curUserAns = payload.data.data.qdata.filter(
                      function (ans) {
                        if (
                          ans &&
                          ans.my_answer &&
                          ans.my_answer.answer &&
                          ans.my_answer.answer != "" &&
                          ans.my_answer.importance &&
                          ans.my_answer.importance != ""
                        ) {
                          return ans;
                        }
                      }
                    );
                  }

                  $scope.FBCompareList = payload.data.data.qdata;

                  if ($scope.FBCompareList && $scope.FBCompareList.length > 0) {
                    $scope.FBunWeighted = payload.data.data.unweightedMatch;
                    $scope.fbcombinedWeight =
                      payload.data.data.fbcombinedWeight;
                    $scope.fbmultiplier = payload.data.data.fbmultiplier;
                    $scope.answeredQuestions =
                      payload.data.data.answeredQuestions;
                    $scope.fbqlen = payload.data.data.qlen;
                    $scope.barRatingData = payload.data.data.barRatings;
                    $scope.confidenceLevel = payload.data.data.confidenceLevel;
                    $scope.essayAnswers = payload.data.data.fiveMinEssayAns;
                    $scope.sumOfImp = payload.data.data.sumOfImp;
                    $scope.percentageOfQuizUnanswered =
                      payload.data.data.percentageOfQuizUnanswered;
                    $scope.matchPercentage = payload.data.data.matchPercentage;
                    $scope.lowestPossibleMatch =
                      payload.data.data.lowestPossibleMatch;
                    $scope.highestPossibleMatch =
                      payload.data.data.highestPossibleMatch;
                    $scope.greatestPossibleNegative =
                      payload.data.data.greatestPossibleNegative;
                    $scope.greatestPossiblePositive =
                      payload.data.data.greatestPossiblePositive;
                    $scope.noOfQuesMutuallyAns =
                      payload.data.data.noOfQuesMutuallyAns;
                    $scope.ShowAsterix = payload.data.data.isShowAsterix;

                    var allUser = payload.data.data.AllUsers;
                    var savedCan;
                    if (window.localStorage.getItem("savedCandidates")) {
                      savedCan = JSON.parse(
                        window.localStorage.getItem("savedCandidates")
                      );
                    }
                    if (savedCan && savedCan.length > 0) {
                      allUser.map(function (item) {
                        savedCan.filter(function (val) {
                          if (item.name == val.name) {
                            item.isChecked = true;
                          }
                        });
                        return item;
                      });
                    }

                    var allkeys = Object.keys($scope.answeredQuestions);

                    var usersData = [];

                    // MyService.ConsoleLog("check now ", allkeys);
                    $scope.isShowAsterix = {};
                    if ($scope.frontRunners && $scope.frontRunners.length > 0) {
                      $scope.frontRunners.filter(function (itms) {
                        if (allkeys.indexOf(itms._id) > -1) {
                          $scope.isShowAsterix[itms._id] = true;
                        }
                      });
                    }

                    allUser.filter(function (itm) {
                      if (allkeys.indexOf(itm._id) > -1) {
                        if ($scope.isShowAsterix[itm._id]) {
                          // MyService.ConsoleLog("$scope.isShowAsterix", $scope.isShowAsterix[itm._id]);
                          itm.isOnBallot = true;
                        }
                        usersData.push(itm);
                      } else {
                        MyService.ConsoleLog("else >>> ");
                        itm.isOnBallot = false;
                        usersData.push(itm);
                      }
                    });

                    $scope.AllUsers = usersData.filter(function (val) {
                      $scope.poliList.filter(function (itm) {
                        if (val._id == itm._id) {
                          val.numberOfOpenings = itm.numberOfOpenings;
                          val.dataX = itm.dataX;
                          val.dataY = itm.dataY;
                          val.total_tagged = itm.total_tagged;
                          val.total_answers = itm.total_answers;
                        }
                      });
                      return val;
                    });
                    // setTimeout(function () {
                    MyService.ConsoleLog("$usersData", $scope.AllUsers);
                    $scope.allCandidates = [];
                    $scope.filterCandidatesOfficeWise();
                    // }, 4000);

                    // //$scope.qData = payload.data.data.answeredQuestions;
                  } else {
                    //alert("Looks like your friends have not yet answered the questions.");
                    MyService.ConsoleLog(
                      "No politicians found, check incumbent"
                    );
                    MyService.compareFiveMinAnswers({
                      userdata: JSON.stringify($rootScope.fiveMatch),
                      comparewith: JSON.stringify($scope.userAreaPolitician),
                      type: "incumbent",
                    }).then(
                      function (payload) {
                        if (payload.data.success) {
                          MyService.ConsoleLog(
                            "incumbent data :> ",
                            payload.data.data
                          );
                          $scope.questions = payload.data.data.qdata;
                          $scope.FBCompareList = payload.data.data.qdata;
                          if (
                            $scope.FBCompareList &&
                            $scope.FBCompareList.length > 0
                          ) {
                            $scope.FBunWeighted =
                              payload.data.data.unweightedMatch;
                            $scope.fbcombinedWeight =
                              payload.data.data.fbcombinedWeight;
                            $scope.fbmultiplier =
                              payload.data.data.fbmultiplier;
                            $scope.answeredQuestions =
                              payload.data.data.answeredQuestions;
                            $scope.fbqlen = payload.data.data.qlen;
                            $scope.AllUsers = payload.data.data.AllUsers;
                          } else {
                            MyService.ConsoleLog(
                              "No politicians and incumbent found, check voters"
                            );
                            window.localStorage.setItem(
                              "showOtherDetails",
                              true
                            );
                            $scope.hideName = true;
                            // Show only popup if no politicians and incubents
                            //     var message =
                            //       "No active candidates in your area have answered this set of questions yet. Contact them and ask them to fill it out.";
                            //     var modal = ngDialog.openConfirm({
                            //       template:
                            //         "<p>" +
                            //         message +
                            //         '</p>\
                            // <div class="ngdialog-buttons">\
                            // <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">See How You Match Your Community</button>\
                            // <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(0)">Learn More About Your Candidates</button>\
                            //     \
                            // </div>',
                            //       plain: true,
                            //       width: "70%",
                            //       closeByDocument: false,
                            //     });

                            // modal.then(function fullfilled(data) {
                            //   //MyService.ConsoleLog("fullfilled: ", data);
                            //   if (data == 1) {
                            //     $scope.postonFacebook();
                            //   } else {
                            //     // if ($rootScope.userRole) {
                            //     //   $location.path('/snapshot');
                            //     // } else {
                            //     //   $location.path('/signin');
                            //     // }
                            //   }
                            // }, function rejected(data) {
                            //   //MyService.ConsoleLog("rejected: ", data);
                            // });
                            // modal.then(
                            //   function fullfilled(data) {
                            //     //MyService.ConsoleLog("fullfilled: ", data);
                            //     if (data == 1) {
                            //       $scope.getGroupMatch();
                            //     } else {
                            //       $location.path("/compare-select/politician");
                            //     }
                            //   },
                            //   function rejected(data) {
                            //     //MyService.ConsoleLog("rejected: ", data);
                            //   }
                            // );
                            return;
                          }
                        }
                      },
                      function (errorpayload) {
                        MyService.ConsoleLog(errorpayload);
                      }
                    );
                  }
                } else {
                  $scope.showAlert = true;
                  // alert("Something went wrong.");
                }
              },
              function (errorpayload) {
                $scope.loader = false;
                MyService.ConsoleLog(errorpayload);
              }
            );
          } else {
            $scope.loader = false;
            // alert("Please select at least one Friend to compare with");
            growl.error("Please answer at least one question to get the match");
          }
        }, 3000);
      };

      $scope.isShowBarAsso = function (key, isShowBarLink) {
        // MyService.ConsoleLog("check key >>", key);

        // MyService.ConsoleLog("isShowBarLink >> ", isShowBarLink);
        if (isShowBarLink == "false") {
          var isBar = key.match(/judge/g);
          if (isBar && isBar != "") {
            return true;
          } else {
            return false;
          }
        } else {
          var barLink;
          $scope.allCandidates.filter(function (item) {
            if (item.office == key) {
              if (
                $scope.barRatingData &&
                $scope.barRatingData[item._id] &&
                $scope.barRatingData[item._id].length > 0
              ) {
                barLink = $scope.barRatingData[item._id][0].generalLink;
                return item;
              }
            }
          });
          // MyService.ConsoleLog("barLink >> ", barLink);
          return barLink;
        }

        // MyService.ConsoleLog("isBar >> ", isBar);
      };

      $scope.goToPoliticianThread = function (officename, users, userData) {
        //console.log("goToPoliticianThread: ", users, " officename: ", officename, " userData: ", userData);
        $rootScope.politicianThreadData = {
          // office: officename,
          users: users,
          selected_user: userData,
        };
        window.localStorage.setItem(
          "politicianThreadData",
          JSON.stringify($rootScope.politicianThreadData)
        );
        $location.path("/politician-thread/" + userData._id);
      };

      $scope.getResultDateWise = function (val) {
        $scope.showBanner = false;
        MyService.ConsoleLog("quiz", $scope.quiz);
        window.localStorage.removeItem("showOtherDetails");
        window.localStorage.removeItem("compareResult");
        window.localStorage.removeItem("isShowOldResult");
        window.localStorage.setItem("eleDate", $scope.quiz.eDate.date);
        // if (val == "date") {
        if (
          !tokenService.getUserData() &&
          window.localStorage.getItem("extraData")
        ) {
          $rootScope.tempUserAddress = JSON.parse(
            window.localStorage.getItem("extraData")
          );
        }
        $scope.getLocalPoliticians($scope.quiz.eDate.date, $scope.quiz.party);

        // } else {

        //   $scope.allCandidates.filter(function (candi) {
        //     if (candi && candi.politicianInfo && candi.politicianInfo.length > 0) {
        //         if(candi.politicianInfo.party.indexOf($scope.quiz.party))
        //       }
        //   });
        //   // return;
        //   $scope.getLocalPoliticians(
        //     $scope.quiz.eDate.date,
        //     $scope.quiz.party.party
        //   );
        // }
      };
      $scope.finalSignIn = function () {
        $rootScope.endFiveMin = true;
        $location.path("/fiveminsignin");
      };

      // ***** Match ***** //
      $scope.traverseBackgrounds = [];
      $scope.currBackgroundIndex = 0;
      $scope.status = {
        questions: 0, //1=loading, 2=loaded, 3=error
        category: 0,
      };

      $scope.currentIndex = 0;

      var getCategoryCanceler = $q.defer();
      var prevFetchedCategoryId = null;

      $scope.getCategory = function (params) {
        try {
          prevFetchedCategoryId = $scope.category._id;
        } catch (e) {}
        MyService.ConsoleLog(
          "prevFetchedCategoryId != params.id ",
          prevFetchedCategoryId + "       " + params.id
        );
        if (prevFetchedCategoryId != params.id) {
          MyService.ConsoleLog("inside check it one");
          $routeParams.categoryId = params.id;
          $("html, body").animate(
            {
              scrollTop: 0,
            },
            "slow"
          );
          // $timeout(function() {
          //   $location.hash('DisplayQ');
          //   $anchorScroll();
          // }, 1500);
          getCategoryCanceler.resolve();
          getCategoryCanceler = $q.defer();
          $scope.status.category = 1;

          MyService.ConsoleLog("inside check it >>>>. two");

          MyService.getCategories(params, getCategoryCanceler.promise).then(
            function (response) {
              if (response) {
                if (response.data.success) {
                  $scope.category = response.data.data;
                  prevFetchedCategoryId = $scope.category._id;
                  $scope.status.category = 2;
                } else {
                  $scope.status.category = 3;
                }
              } else {
                $scope.status.category = 2;
              }
            },
            function (err) {
              //MyService.ConsoleLog("Error: ", err);
              $scope.status.category = 3;
              //MyService.ConsoleLog("$scope.status: ", $scope.status.category);
            }
          );
        } else {
          $timeout(function () {
            // $location.hash("DisplayQ");
            $anchorScroll();
          }, 500);
        }
      };

      $scope.rootCatIndex = 0;
      $scope.getRootCategoryIndex = function () {
        if ($routeParams.categoryId == "all") {
          var len = $rootScope.categories.length;
          for (var i = 0; i < len; i++) {
            if ($routeParams.parentId == $rootScope.categories[i]._id) {
              $scope.rootCatIndex = i;
              //MyService.ConsoleLog("rootCatIndex : ", $scope.rootCatIndex);
              break;
            }
          }
        }
      };

      var getLevelCategoryCanceler = $q.defer();

      function getLevelCategory(params) {
        getLevelCategoryCanceler.resolve();
        $scope.status.levlCat = 1;
        params.timeout = getLevelCategoryCanceler.promise;
        var request = apiCall.apiCall("GET", "/categories/list-layer", params);
        $http(request).then(
          function successCallback(response) {
            //MyService.ConsoleLog("Got categories: ",response);
            if (response.data.success) {
              $scope.traverseBackgrounds = response.data.data;
              if ($routeParams.selectedCatId) {
                angular.forEach(response.data.data, function (val, key) {
                  if (val._id == $routeParams.selectedCatId) {
                    $scope.currBackgroundIndex = key;
                    $scope.category = val;
                  }
                });
              } else if ($scope.traverseBackgrounds.length > 0) {
                $scope.category = $scope.traverseBackgrounds[0];
              }
              $scope.status.levlCat = 2;
            } else {
              //MyService.ConsoleLog("Something went wrong: ", response.data);
              $scope.status.levlCat = 3;
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
            $scope.status.levlCat = 3;
          }
        );
      }

      $scope.skipQuestion = function () {
        var skip = function () {
          var tempIndex = $scope.currentIndex + 1;
          if (tempIndex < $scope.questions.length) {
            $scope.currentIndex++;
            if (
              $routeParams.categoryId &&
              $routeParams.categoryId.indexOf("popular:") == 0
            ) {
              $scope.getCategory({
                id: $scope.questions[$scope.currentIndex].categories[0].cid,
              });
            }
          }
          if (
            tempIndex == $scope.questions.length ||
            $scope.questions.length == 0
          ) {
            var tempBackIdx = $scope.currBackgroundIndex + 1;
            if (tempBackIdx < $scope.traverseBackgrounds.length) {
              $scope.currBackgroundIndex++;
              // alert("if");
              $scope.category =
                $scope.traverseBackgrounds[$scope.currBackgroundIndex];
            } else {
              $scope.rootCatIndex++;
              // alert("else");
              window.localStorage.setItem("RootCatIndex", $scope.rootCatIndex);
              window.localStorage.setItem(
                "DisplayCategory",
                JSON.stringify($scope.category)
              );

              //$location.path("/compare-politician-questions");
            }
          }
          MyService.ConsoleLog(
            "yoffff",
            tempIndex + "           " + $scope.questions.length
          );
          if (tempIndex == $scope.questions.length) {
            $scope.showcomparison = false;
          }
          //$scope.currentIndex++;
        };

        skip();
      };

      /**
       * show pop up with old answers
       */
      $scope.getOldAnswers = function (val) {
        MyService.ConsoleLog("dava", val);
        $scope.oldAns = val;
        $scope.showPopUp = ngDialog.open({
          template: "showOldAnsPopUp",
          closeByNavigation: true,
          scope: $scope,
        });
      };

      $scope.showMacthOnPop = function (val, isType) {
        MyService.ConsoleLog("val > ", val);
        $scope.ofcName = val.office;
        MyService.ConsoleLog("val >> ", $scope.answeredQuestions[val._id]);
        $scope.uId = val._id;
        $scope.poliName = val.name;
        if (isType == "true") {
          $scope.isShowMatch = ngDialog.open({
            template: "showMatchDetails",
            closeByNavigation: true,
            scope: $scope,
            width: "50%",
          });
        } else {
          $scope.isShowPopUp = ngDialog.open({
            template: "showMatch",
            closeByNavigation: true,
            scope: $scope,
            width: "50%",
          });
        }
      };

      $scope.getInfo = function (val) {
        if (val && val.comment && val.comment != "") {
          $scope.showComment = $sce.trustAsHtml(val.comment);
          $scope.showPopUp = ngDialog.open({
            template: "showInfoPopUp",
            closeByNavigation: true,
            scope: $scope,
          });
        }
      };

      $scope.showNotice = function () {
        $scope.showNoticePopUp = ngDialog.open({
          template: "showNoticePop",
          closeByNavigation: true,
          scope: $scope,
        });
      };

      $scope.closeNotice = function () {
        $scope.showNoticePopUp.close();
      };

      $scope.prevQuestion = function () {
        //MyService.ConsoleLog("** prevQuestion **");
        // $timeout(function() {
        //   $location.hash('DisplayQ');
        //   $anchorScroll();
        // }, 1500);
        if ($scope.currentIndex > 0) {
          $scope.currentIndex--;
        } else if ($scope.currentIndex == 0) {
          if ($scope.currBackgroundIndex > 0) {
            $scope.currBackgroundIndex--;
            $scope.category =
              $scope.traverseBackgrounds[$scope.currBackgroundIndex];
          } else {
            //MyService.ConsoleLog("** end of background **");
            if ($scope.rootCatIndex > 0) {
              $scope.rootCatIndex--;
              $location.path(
                "/question-compare-politician/all/" +
                  $rootScope.categories[$scope.rootCatIndex]._id
              );
            }
          }
        }
      };

      $scope.compareChanged = function (compare_with) {
        // MyService.ConsoleLog("compare_with :", compare_with);
        var catid = $routeParams.categoryId;
        if (
          $routeParams.categoryId &&
          $routeParams.categoryId.indexOf("popular:") == 0
        ) {
          var catid = $routeParams.categoryId.split("popular:")[1];
        }

        $location.path("/compare-select/" + compare_with);
      };

      $scope.getComapreClass = function (match, i) {
        if (match >= 100) return "ag-dg1";
        if (match >= 80) return "ag-dg2";
        if (match >= 60) return "ag-dg3";
        if (match >= 40) return "ag-dg4";
        if (match >= 20) return "ag-dg5";
        if (match >= 0) return "ag-dg6";

        return "ag-dg";
      };

      var getCompareAnswersCanceler = $q.defer();
      $scope.getCompareAnswers = function (params) {
        MyService.ConsoleLog("getCompareAnswers");
        MyService.ConsoleLog(params);
        /*
      if (!params) return;
      getCompareAnswersCanceler.resolve();

      getCompareAnswersCanceler = $q.defer();
      $scope.questions = [];
      $scope.status.questions = 1;

      MyService.getCompareAns(params, getCompareAnswersCanceler.promise)
        .then(function successCallback(response) {
          //MyService.ConsoleLog("Got categories: ",response);
          if (response.data.success) {
            $scope.status.questions = 2;
            angular.forEach(response.data.data, function(val, key) {
              if (val.answers && val.answers.length != $rootScope.selectedCompareUsers.length) {
                var check_author_exist = function(u) {
                  var len = val.answers.length;
                  for (var i = 0; i < len; i++) {
                    if (val.answers[i].author._id == u._id) {
                      return true;
                    }
                  }
                  return false;
                };

                angular.forEach($rootScope.selectedCompareUsers, function(u, i) {
                  if (!check_author_exist(u)) {
                    response.data.data[key].answers.push({ author: u });
                  }
                });
              } else if (!val.answers) {
                response.data.data[key].answers = [];
                angular.forEach($rootScope.selectedCompareUsers, function(u, i) {
                  response.data.data[key].answers.push({ author: u });
                });
              }
            });

            $scope.questions = response.data.data;
            // $location.path("question-compare/"+$routeParams.category_id+"/"+null);
          } else {
            $scope.status.questions = 3;
            //MyService.ConsoleLog("Something went wrong: ", response.data);
          }
        }, function errorCallBack(response) {
          $scope.status.questions = 3;
          //MyService.ConsoleLog("Error: ", response);
        });
      */
      };

      var current_url = $location.url();
      //MyService.ConsoleLog("$location.url: ", current_url);

      $scope.state = "question-compare-politician";
      if (
        !$rootScope.selectedCompareUsers ||
        $rootScope.selectedCompareUsers.length <= 0
      ) {
        //$location.path("/questionHome");
      } else {
        if ($routeParams.categoryId == "all") {
          //MyService.ConsoleLog("compare all answers");
          var param = {
            id: $routeParams.parentId,
            questions_counter: 1,
          };
          getLevelCategory(param);
          $scope.getRootCategoryIndex();
        } // traverse all questions
        else {
          $scope.questions = $rootScope.compareAnswerList;
          // MyService.ConsoleLog($scope.questions);
          var catid = $routeParams.categoryId;
          // MyService.ConsoleLog(catid)
          $scope.getCategory({
            id: catid,
          });
        }
      }

      $scope.viewAnsComment = function (ans) {
        if (ans.comment) {
          ngDialog.open({
            template: "app/popups/show_comment_txt.html",
            controller: "OldAnswerViewerCtrl",
            data: {
              title: "Comment",
              content: ans.comment,
            },
          });
        }
      };

      $scope.retainOptions = "";
      $scope.fb = {
        options: "C",
      };

      $scope.postOnWall = function (message) {
        var body = message;
        // MyService.ConsoleLog($scope.fivefb);
        var link = "https://votewise.net/#!/fiveMatch#DisplayQ";
        FB.api(
          "/me/feed",
          "post",
          {
            message: body,
            link: link,
          },
          function (response) {
            // MyService.ConsoleLog(response);
            $scope.DisplayFPostLoader = false;
            if (!response || response.error) {
              var errmsg =
                "Facebook is taking too long to respond. Should we try again?";
              var modal = ngDialog.openConfirm({
                template:
                  "<p>" +
                  errmsg +
                  '</p>\
                            <div class="ngdialog-buttons">\
                    <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                    <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Yes</button>\
                </div>',
                plain: true,
              });
              modal.then(
                function fullfilled(tdata) {
                  //MyService.ConsoleLog("fullfilled: ", data);
                  if (tdata == 1) {
                    $scope.postOnWall(message);
                  }
                },
                function rejected(data) {
                  //MyService.ConsoleLog("rejected: ", data);
                }
              );
            } else {
              var msg = "Message is successfully posted on facebook wall.";
              var modal = ngDialog.openConfirm({
                template:
                  "<p>" +
                  msg +
                  '</p>\
                            <div class="ngdialog-buttons">\
                                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">OK</button>\
                            </div>',
                plain: true,
              });
              modal.then(
                function fullfilled(data) {
                  //MyService.ConsoleLog("fullfilled: ", data);
                  // if (data == 1) {
                  // getMoreQuestions($scope.retainOptions);
                  // }
                  ngDialog.close();
                },
                function rejected(data) {
                  //MyService.ConsoleLog("rejected: ", data);
                  ngDialog.close();
                }
              );
              // alert('Post ID: ' + response.id);
            }
          }
        );
      };
      $scope.DisplayFPostLoader = false;
      $scope.postFB = function (message) {
        $scope.DisplayFPostLoader = true;
        FB.getLoginStatus(function (response) {
          if (response.status == "unknown") {
            FB.login(
              function (response) {
                MyService.updateFBID({
                  facebookid: response.authResponse.userID,
                }).then(
                  function (payload) {
                    if (
                      payload.data.error &&
                      payload.data.error == "FBDUPLICATE"
                    ) {
                      $scope.DisplayFPostLoader = false;
                      alert("Facebook user doesn't match with your account.");
                    } else {
                      $scope.postOnWall(message);
                    }
                  },
                  function (errpayload) {
                    $scope.DisplayFPostLoader = false;
                    var errmsg =
                      "Facebook is taking too long to respond. Should we try again?";
                    var modal = ngDialog.openConfirm({
                      template:
                        "<p>" +
                        errmsg +
                        '</p>\
                            <div class="ngdialog-buttons">\
                    <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                    <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Yes</button>\
                </div>',
                      plain: true,
                      width: "70%",
                    });
                    modal.then(
                      function fullfilled(tdata) {
                        if (tdata == 1) {
                          $scope.postOnWall(message);
                        }
                      },
                      function rejected(data) {
                        //MyService.ConsoleLog("rejected: ", data);
                      }
                    );
                    // alert("Facebook is taking too long to respond. Should we try again?");
                  }
                );
              },
              {
                scope: "public_profile,email,publish_actions",
                return_scopes: true,
              }
            );
          } else {
            if ($scope.userData && $scope.userData.facebookid) {
              if (response.authResponse.userID == $scope.userData.facebookid) {
                $scope.postOnWall(message);
              } else {
                $scope.DisplayFPostLoader = false;
                alert("Facebook user doesn't match with your account.");
              }
            } else {
              $scope.postOnWall(message);
            }
          }
        });
      };

      $scope.postonFacebook = function () {
        // $scope.fbFrdDlg = ngDialog.open({
        //   template: 'FBComposeMessage',
        //   scope: $scope
        // });
        $location.path("/showFbMessage");
      };

      // $scope.getFiveFacebookPost();

      $scope.$watch("category", function (newValue, oldValue) {
        MyService.ConsoleLog("** category watch **");
        var current_url = $location.url();
        if (current_url.indexOf("question-tagged") > -1) return; //for tagged questions don't again fetch questions

        if (newValue) {
          if (oldValue && oldValue._id == newValue._id) return;

          if (current_url.indexOf("question-compare-politician") > -1) {
            var temp_uids = [];
            angular.forEach(
              $rootScope.selectedCompareUsers,
              function (val, key) {
                temp_uids.push(val._id);
              }
            );
          }
        }
      });

      $scope.$watch("questions", function (newValue, oldValue) {
        MyService.ConsoleLog("** questions watch **");
        if (!$scope.questions) {
          $scope.questions = $rootScope.fiveminquestions;
        }
        // MyService.ConsoleLog("$scope.questions", $scope.questions);
        try {
          if ($scope.questions) {
            var tempCate = $scope.questions[$scope.currentIndex].categories;
            if (angular.isArray(tempCate)) {
              $scope.getCategory({
                id: tempCate[0].cid,
              });
            } else {
              $scope.getCategory({
                id: tempCate.cid,
              });
            }
          }
          // $scope.initMyAnswer();
        } catch (e) {
          MyService.ConsoleLog("questions Index Change Ex: ", e);
        }
      });

      $scope.$watch("currentIndex", function (newValue, oldValue) {
        MyService.ConsoleLog("** currentIndex watch **");
        // console.log("fiveminquestions >> ", $rootScope.fiveminquestions);
        if (!$scope.questions) {
          $scope.questions = $rootScope.fiveminquestions;
        }
        try {
          // MyService.ConsoleLog("Current question: ", $scope.questions[$scope.currentIndex]);
          if ($scope.questions) {
            var tempCate = $scope.questions[$scope.currentIndex].categories;
            if (angular.isArray(tempCate)) {
              $scope.getCategory({
                id: tempCate[0].cid,
              });
            } else {
              $scope.getCategory({
                id: tempCate.cid,
              });
            }
          }
          // $scope.initMyAnswer();
        } catch (e) {
          MyService.ConsoleLog("Current Index Change Ex: ", e);
        }
      });

      $scope.setOldRecord = function () {
        if (window.localStorage.getItem("compareResult")) {
          var data = JSON.parse(window.localStorage.getItem("compareResult"));

          if (data && data.qdata && data.qdata.length > 0) {
            $scope.questions = data.qdata.sort(function (x, y) {
              if (x.matchOrder < y.matchOrder) {
                return -1;
              }
              if (x.matchOrder > y.matchOrder) {
                return 1;
              }
              return 0;
            });
          }

          $scope.FBCompareList = data.qdata;

          if ($scope.FBCompareList && $scope.FBCompareList.length > 0) {
            $scope.FBunWeighted = data.unweightedMatch;
            $scope.fbcombinedWeight = data.fbcombinedWeight;
            $scope.fbmultiplier = data.fbmultiplier;
            $scope.answeredQuestions = data.answeredQuestions;
            $scope.fbqlen = data.qlen;
            $scope.confidenceLevel = data.confidenceLevel;
            $scope.essayAnswers = data.fiveMinEssayAns;
            $scope.sumOfImp = data.sumOfImp;
            $scope.percentageOfQuizUnanswered = data.percentageOfQuizUnanswered;
            $scope.barRatingData = data.barRatings;
            $scope.matchPercentage = data.matchPercentage;
            $scope.lowestPossibleMatch = data.lowestPossibleMatch;
            $scope.highestPossibleMatch = data.highestPossibleMatch;
            $scope.greatestPossibleNegative = data.greatestPossibleNegative;
            $scope.greatestPossiblePositive = data.greatestPossiblePositive;
            $scope.noOfQuesMutuallyAns = data.noOfQuesMutuallyAns;
            $scope.ShowAsterix = data.isShowAsterix;
            var allUser = data.AllUsers;
            var savedCan;
            if (window.localStorage.getItem("savedCandidates")) {
              savedCan = JSON.parse(
                window.localStorage.getItem("savedCandidates")
              );
            }
            if (savedCan && savedCan.length > 0) {
              allUser.map(function (item) {
                savedCan.filter(function (val) {
                  if (item.name == val.name) {
                    item.isChecked = true;
                  }
                });
                return item;
              });
            }

            var allkeys = Object.keys($scope.answeredQuestions);

            var usersData = [];

            // MyService.ConsoleLog("check now ", allkeys);
            $scope.isShowAsterix = {};
            if ($scope.frontRunners && $scope.frontRunners.length > 0) {
              $scope.frontRunners.filter(function (itms) {
                if (allkeys.indexOf(itms._id) > -1) {
                  $scope.isShowAsterix[itms._id] = true;
                }
              });
            }

            allUser.filter(function (itm) {
              if (allkeys.indexOf(itm._id) > -1) {
                if ($scope.isShowAsterix[itm._id]) {
                  // MyService.ConsoleLog("$scope.isShowAsterix", $scope.isShowAsterix[itm._id]);
                  itm.isOnBallot = true;
                }
                usersData.push(itm);
              } else {
                MyService.ConsoleLog("else >>> ");
                itm.isOnBallot = false;
                usersData.push(itm);
              }
            });

            $scope.AllUsers = usersData;
            $scope.poliList = JSON.parse(
              window.localStorage.getItem("poliList")
            );
            $scope.AllUsers = data.AllUsers.filter(function (val) {
              if ($scope.poliList && $scope.poliList.length > 0) {
                $scope.poliList.filter(function (itm) {
                  if (val._id == itm._id) {
                    val.numberOfOpenings = itm.numberOfOpenings;
                    val.dataX = itm.dataX;
                    val.dataY = itm.dataY;
                    val.total_tagged = itm.total_tagged;
                    val.total_answers = itm.total_answers;
                  }
                });
              }

              return val;
            });
            // setTimeout(function () {
            $scope.parties = JSON.parse(window.localStorage.getItem("parties"));
            MyService.ConsoleLog("$usersData", usersData);

            $scope.allCandidates = [];
            $scope.filterCandidatesOfficeWise();
          } else {
            var savedCan;
            if (window.localStorage.getItem("savedCandidates")) {
              savedCan = JSON.parse(
                window.localStorage.getItem("savedCandidates")
              );
            }
            console.log("data >> ", data.AllUsers);
            if (data.barRatings) {
              $scope.barRatingData = data.barRatings;
            }
            $scope.poliList = JSON.parse(
              window.localStorage.getItem("poliList")
            );

            $scope.AllUsers = data.AllUsers.filter(function (val) {
              if (val && val._id != "") {
                $scope.poliList.filter(function (itm) {
                  if (val._id == itm._id) {
                    val.numberOfOpenings = itm.numberOfOpenings;
                    val.dataX = itm.dataX;
                    val.dataY = itm.dataY;
                    val.total_tagged = itm.total_tagged;
                    val.total_answers = itm.total_answers;
                  }
                });
                if (savedCan && savedCan.length > 0) {
                  savedCan.filter(function (scan) {
                    if (scan.name == val.name) {
                      val.isChecked = true;
                    }
                  });
                  return val;
                } else {
                  return val;
                }
              }
            });
            $scope.parties = JSON.parse(window.localStorage.getItem("parties"));
            $scope.allCandidates = [];
            $scope.filterCandidatesOfficeWise();
          }
        }
        // window.localStorage.removeItem("poliList");
        window.localStorage.removeItem("isShowOldResult");
      };

      $scope.checkIfDatax = function (key, val) {
        // MyService.ConsoleLog("key >> ", key);
        // MyService.ConsoleLog("val >> ", val);
        // var terms = val.filter(function (item) {
        var vlen = val.length;
        var arr;
        for (var j = 0; j < vlen; j++) {
          var item = val[j];
          if (item.politicianInfo && item.politicianInfo.length > 0) {
            var len = item.politicianInfo.length;

            for (var i = 0; i < len; i++) {
              // MyService.ConsoleLog(
              //   " item.politicianInfo[i]  >>",
              //   item.politicianInfo[i]
              // );
              if (
                item.politicianInfo[i] &&
                item.dataX &&
                item.dataX != "" &&
                item.dataX != null
              ) {
                if (item.dataX && key == item.politicianInfo[i].officeName) {
                  arr = item.dataX;
                  return arr;
                  // break;
                }
              }
            }
          }
        }

        // break;
        // });

        // MyService.ConsoleLog("terms >> ", arr);
      };

      $scope.showNumberOfOpening = function (key, val) {
        var valLen = val.length;
        var noOfOp;
        for (var i = 0; i < valLen; i++) {
          if (key == val[i].office) {
            noOfOp = val[i].numberOfOpenings;
            return noOfOp;
          }
        }
      };

      // $scope.electionDates = [];
      $scope.getElectionDates = function () {
        MyService.getListOfDates().then(
          function (APIResponse) {
            MyService.ConsoleLog("APIResponse >> ", APIResponse);
            if (APIResponse.data.success) {
              var datesArr = [];
              var mainArr = APIResponse.data.data.map(function (item, index) {
                var date = new Date(item).toGMTString();

                var par = {
                  _id: index,
                  eDate: date.substr(5, 12),
                  date: item,
                };
                datesArr.push(par);
              });
              MyService.ConsoleLog("datesArr >> ", datesArr);
              $scope.electionDates = datesArr;

              // const today = new Date();
              // const closestDate = datesArr.reduce(function (a, b) {
              //   if (a != null && b != null) {
              //     const adiff = a.date - today;
              //     return adiff > 0 && adiff < b.date - today ? a : b;
              //   }
              // });

              // $scope.electionDates.sort(function (a, b) {
              //   if (a != null && b != null) {
              //     return new Date(b.date) - new Date(a.date);
              //   }
              // });
              // function sortFunction(a, b) {
              //   var dateA = new Date(a.date).getTime();
              //   var dateB = new Date(b.date).getTime();
              //   return dateA < dateB ? 1 : -1;
              // }

              // var sortedDate = datesArr.sort(sortFunction);
              MyService.ConsoleLog(
                " $scope.electionDates >> ",
                $scope.electionDates[0]
              );
              // return;
              $scope.quiz.eDate = $scope.electionDates[0];
              window.localStorage.setItem("eleDate", $scope.quiz.eDate.date);
              MyService.ConsoleLog("$scope.quiz >> ", $scope.quiz);
              MyService.ConsoleLog(
                "$scope.electionDates >> ",
                $scope.electionDates
              );
              if (window.localStorage.getItem("isShowOldResult") == "true") {
                $scope.setOldRecord();
              } else {
                $scope.getLocalPoliticians($scope.quiz.eDate.date);
              }
            } else {
              if (window.localStorage.getItem("isShowOldResult") == "true") {
                $scope.setOldRecord();
              } else {
                $scope.getLocalPoliticians($scope.quiz.eDate.date);
              }
            }
          },
          function (err) {
            MyService.ConsoleLog("error", err);
          }
        );
      };
      $scope.getElectionDates();

      $scope.showAnswerDetails = function (off) {
        MyService.ConsoleLog("check office >> ", off);
        $scope.loader = true;
        var filData = $scope.allCandidates.filter(function (val) {
          if (val.office === off) {
            return val;
          }
        });
        MyService.ConsoleLog("filData >> ", filData);
        var params = {
          candidates: filData,
          essayAnswers: $scope.essayAnswers,
        };

        window.localStorage.setItem("compareAnsData", JSON.stringify(params));
        $scope.loader = false;
        $location.path("/compareEssayAns");

        // MyService.ConsoleLog("params >> ", params);
      };

      $scope.isAnsExist = function (office, val) {
        var aData = val.filter(function (item) {
          if (item.office == office) {
            if (
              $scope.answeredQuestions &&
              $scope.answeredQuestions[item._id] &&
              $scope.answeredQuestions[item._id] != ""
            ) {
              return item;
            }
          }
        });
        if (aData && aData.length > 0) {
          return true;
        } else {
          return false;
        }
      };

      $scope.isEssayAnsExist = function (office, val) {
        var isTrue;
        var data = val.filter(function (item) {
          if (item.office == office) {
            if (
              $scope.essayAnswers &&
              $scope.essayAnswers[item._id] &&
              $scope.essayAnswers[item._id].length > 0
            ) {
              return item;
            }
          }
        });
        if (data && data.length > 0) {
          return true;
        } else {
          return false;
        }
      };
    },
  ]);

'use strict';
angular.module('myApp.fiveMatchQuestions', ['ngRoute'])

  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/fiveMatchQuestions/:type?', {
      templateUrl: 'app/fiveMatchQuestions/fiveMatchQuestions.html',
      controller: 'MatchQuestionsCtrl'
    });
  }])
  .controller('MatchQuestionsCtrl', ['$scope', '$location', '$rootScope', 'tokenService', 'MyService', 'ngDialog', '$routeParams', function($scope, $location, $rootScope, tokenService, MyService, ngDialog, $routeParams) {
    $scope.questions = [];
    $scope.getAllMatchQuestions = function() {
      $scope.questions.length = 0;
      MyService.getfivematch().then(function(payload) {
        MyService.ConsoleLog(payload);
        if (payload.data.success) {
          $scope.questions = payload.data.data;
        } else {
          alert("Something went wrong. Please try after some time");
        }
      }, function(errpayload) {
        alert("Something went wrong. Please try after some time");
      });
    }

    if ($routeParams.type && $routeParams.type != "") {
      $scope.showReportQuestion = true;
    } else {
      $scope.showFiveMatchQuestion = true;
    }

    $scope.editQeustion = function(q, index) {
      //MyService.ConsoleLog("edit question: ", q);
      // growl.error("Edit not implemented yet.");
      var editModal = ngDialog.open({
        template: 'app/popups/edit_question.html',
        controller: "EditQuestionCtrl",
        data: q
      });
    };

    $scope.removeReportedQeustion = function(q, index) {
      var message = 'Are you sure you want to remove this question from Five Minute Match Questions?';

      var modal = ngDialog.openConfirm({
        template: '<p>' + message + '</p>\
            <div class="ngdialog-buttons">\
                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">YES</button>\
                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">NO</button>\
            </div>',
        plain: true
      });
      modal.then(function fullfilled(data) {
        MyService.removeMatchedQuestion({
          "id": q._id
        }).then(function(payload) {
          //MyService.ConsoleLog(payload);
          $scope.getAllMatchQuestions();
        }, function(errPayload) {
          //MyService.ConsoleLog(errPayload);
        });
      }, function rejected(data) {
        //MyService.ConsoleLog("rejected: ", data);
      });
    }

    // if ($scope.showFiveMatchQuestion) {
    $scope.getAllMatchQuestions();
    // }
  }]).controller('ReportQuestionsCtrl', ['$scope', '$location', '$rootScope', 'tokenService', 'MyService', 'ngDialog','$routeParams', function($scope, $location, $rootScope, tokenService, MyService, ngDialog,$routeParams) {
    $scope.questions = [];
    $scope.getAllReportQuestions = function() {
      $scope.questions.length - 0;
      MyService.getReportedQuestions().then(function(payload) {
        //MyService.ConsoleLog(payload);
        $scope.questions = payload;
      }, function(errPayload) {
        //MyService.ConsoleLog(errPayload);
      });
    }

    if ($routeParams.type && $routeParams.type != "") {
      $scope.showReportQuestion = true;
    } else {
      $scope.showFiveMatchQuestion = true;
    }

    $scope.editQeustion = function(q, index) {
      //MyService.ConsoleLog("edit question: ", q);
      // growl.error("Edit not implemented yet.");
      var editModal = ngDialog.open({
        template: 'app/popups/edit_question.html',
        controller: "EditQuestionCtrl",
        data: q
      });
    };

    $scope.removeReportedQeustion = function(q, index) {
      var message = 'Are you sure you want to remove this question from Reported Questions?';

      var modal = ngDialog.openConfirm({
        template: '<p>' + message + '</p>\
            <div class="ngdialog-buttons">\
                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">YES</button>\
                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">NO</button>\
            </div>',
        plain: true
      });
      modal.then(function fullfilled(data) {
        MyService.removeReportedQuestion({
          "id": q._id
        }).then(function(payload) {
          //MyService.ConsoleLog(payload);
          $scope.getAllReportQuestions();
        }, function(errPayload) {
          //MyService.ConsoleLog(errPayload);
        });
      }, function rejected(data) {
        //MyService.ConsoleLog("rejected: ", data);
      });
    }

    if ($rootScope.showReportQuestion) {
      $scope.getAllReportQuestions();
    }
  }])

"use strict";
angular
  .module("myApp.findMatch", ["ngRoute"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/findMatch/:flag?", {
        templateUrl: "app/findMatch/findMatch.html",
        controller: "findMatchCtrl",
      });
      $routeProvider.when("/findMatch/:catid", {
        templateUrl: "app/findMatch/findMatch.html",
        controller: "findMatchCtrl",
      });
    },
  ])
  .controller("findMatchCtrl", [
    "$scope",
    "$http",
    "$location",
    "apiCall",
    "$routeParams",
    "$rootScope",
    "$q",
    "$timeout",
    "tokenService",
    "MyService",
    "$anchorScroll",
    "$cookies",
    "ngDialog",
    "growl",
    "$window",
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $rootScope,
      $q,
      $timeout,
      tokenService,
      MyService,
      $anchorScroll,
      $cookies,
      ngDialog,
      growl,
      $window
    ) {
      $scope.page = 1;
      $scope.maxRecordsPerPg = 10000;
      $scope.showPoliAnswerDetails = false;
      $scope.showUserAnswerDetails = false;
      $scope.noDataFound = false;
      $scope.showcomparison = false;
      $scope.showComment = false;
      $scope.unComment = false;
      $scope.showCurr = false;
      $scope.loaders = false;

      if (tokenService.getUserId()) {
        $scope.userId = tokenService.getUserId();
        console.log("$scope.userId: ", $scope.userId);
      }
      console.log(
        "window.localStorage.getItem :",
        window.localStorage.getItem("inviterId")
      );
      if (window.localStorage.getItem("inviterId")) {
        if (window.localStorage.getItem("inviterInfo")) {
          $scope.inviterInfo = JSON.parse(
            window.localStorage.getItem("inviterInfo")
          );
          MyService.ConsoleLog("$scope.inviterInfo", $scope.inviterInfo);
          if ($scope.inviterInfo && $scope.inviterInfo.nameOnBallot) {
            $scope.inviterName = $scope.inviterInfo.nameOnBallot;
          } else if ($scope.inviterInfo && $scope.inviterInfo.title) {
            $scope.inviterName = $scope.inviterInfo.title;
          } else if ($scope.inviterInfo) {
            $scope.inviterName = $scope.inviterInfo.username;
          }
          $scope.isShare = true;
        }
        $scope.inviterId = window.localStorage.getItem("inviterId");
      }

      if ($cookies.get("showLongPopUp")) {
        var msg = $cookies.get("showLongPopUp");

        var modal = ngDialog.openConfirm({
          template:
            "<p>" +
            msg +
            '</p>\
                    <div class="ngdialog-buttons">\
                        <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">OK</button>\
                        <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(0)">Cancel</button>\
                    </div>',
          plain: true,
          closeByDocument: false,
          width: "70%",
        });
        modal.then(
          function fullfilled(data) {
            if (data == 1) {
              // MyService.ConsoleLog("yes")
              $cookies.remove("showLongPopUp");
            } else {
              $cookies.remove("showLongPopUp");
            }
          },
          function rejected(data) {}
        );
      }

      var param = {};
      param.page = $scope.page;
      param.max_records = $scope.maxRecordsPerPg;

      if ($routeParams.flag) {
        $scope.flag = true;
        // alert('one');
      } else {
        $scope.flag = false;
        // alert('two');
      }

      if (window.localStorage.getItem("quesData")) {
        $rootScope.queData = window.localStorage.getItem("quesData");
        // MyService.ConsoleLog("main Data>>", JSON.parse($rootScope.queData));
      }
      $scope.showGrpFollow = false;

      /**
       * Remove values from localStorage on page load
       */
      window.localStorage.removeItem("comOfPolitician");
      window.localStorage.removeItem("comOfVoter");
      window.localStorage.removeItem("comOfAdv");
      window.localStorage.removeItem("comOfGuest");
      window.localStorage.removeItem("poliAr");
      window.localStorage.removeItem("voter");
      window.localStorage.removeItem("adv");
      window.localStorage.removeItem("unVerify");
      window.localStorage.removeItem("cuUser");

      if (tokenService.getUserId()) {
        // alert('sssss');
        $scope.userData = JSON.parse(tokenService.getUserData());
        MyService.ConsoleLog("$scope.userData >", $scope.userData);
        MyService.ConsoleLog("$scope.userData >", $scope.userData.address);

        // $rootScope.tempUserAddress = "";
        $rootScope.tempUserAddress = $scope.userData.address;
        console.log(
          "$rootScope.tempUserAddress >>> ",
          $rootScope.tempUserAddress
        );
        // }

        // var nAddobj = new Object;

        // nAddobj.state = $scope.mainAddress.state.state;
        // nAddobj.stateFips = $scope.mainAddress.state.stateFips;
        // nAddobj.statePostalCode = $scope.mainAddress.state.statePostalCode;

        // nAddobj.county = $scope.mainAddress.county ? $scope.mainAddress.county.county : "";
        // nAddobj.countyFips = $scope.mainAddress.county ? $scope.mainAddress.county.countyFips : "";
        // if ($scope.mainAddress.place && $scope.mainAddress.place != "") {
        //   nAddobj.place = $scope.mainAddress.place.place;
        //   nAddobj.placeFips = $scope.mainAddress.place.placeFips;
        // }

        // nAddobj.federalCongrassionalDist = $scope.mainAddress.federalCongrassionalDist ? $scope.mainAddress.federalCongrassionalDist.CD115FP : "";

        // nAddobj.stateSenateDistrict = $scope.mainAddress.stateSenateDistrict ? $scope.mainAddress.stateSenateDistrict.SLDUST : "";

        // nAddobj.legislativeDistrict = $scope.mainAddress.stateHouseOFRepresentativeDistrict ? $scope.mainAddress.stateHouseOFRepresentativeDistrict.NAMELSAD.replace("State House District ", "") : "";

        // nAddobj.schoolDistrict = $scope.mainAddress.unifiedSchoolDistrictName ? $scope.mainAddress.unifiedSchoolDistrictName.NAME : '';

        // nAddobj.schoolDistrictFips = $scope.mainAddress.unifiedSchoolDistrictName ? $scope.mainAddress.unifiedSchoolDistrictName.UNSDLEA : '';
        // console.log("nAddobj > ", nAddobj);
        // $rootScope.tempUserAddress = nAddobj;
      } else {
        if (window.localStorage.getItem("tempUserAddress")) {
          $rootScope.tempUserAddress = window.localStorage.getItem(
            "tempUserAddress"
          );

          // MyService.ConsoleLog("$rootScope.tempUserAddress >>", $rootScope.tempUserAddress);

          $scope.mainAddress = JSON.parse(
            angular.copy($rootScope.tempUserAddress)
          );
          // console.log("mainAddress >>> ", $scope.mainAddress);
          var nobj = new Object();

          nobj.state = $scope.mainAddress.state.state;
          nobj.stateFips = $scope.mainAddress.state.stateFips;
          nobj.statePostalCode = $scope.mainAddress.state.statePostalCode;

          nobj.county = $scope.mainAddress.county
            ? $scope.mainAddress.county.county
            : "";
          nobj.countyFips = $scope.mainAddress.county
            ? $scope.mainAddress.county.countyFips
            : "";
          if ($scope.mainAddress.place && $scope.mainAddress.place != "") {
            nobj.place = $scope.mainAddress.place.place;
            nobj.placeFips = $scope.mainAddress.place.placeFips;
          }

          nobj.federalCongrassionalDist = $scope.mainAddress
            .federalCongrassionalDist
            ? $scope.mainAddress.federalCongrassionalDist.CD115FP
            : "";

          nobj.stateSenateDistrict = $scope.mainAddress.stateSenateDistrict
            ? $scope.mainAddress.stateSenateDistrict.SLDUST
            : "";

          nobj.legislativeDistrict = $scope.mainAddress
            .stateHouseOFRepresentativeDistrict
            ? $scope.mainAddress.stateHouseOFRepresentativeDistrict.NAMELSAD.replace(
                "State House District ",
                ""
              )
            : "";

          nobj.schoolDistrict = $scope.mainAddress.unifiedSchoolDistrictName
            ? $scope.mainAddress.unifiedSchoolDistrictName.NAME
            : "";

          nobj.schoolDistrictFips = $scope.mainAddress.unifiedSchoolDistrictName
            ? $scope.mainAddress.unifiedSchoolDistrictName.UNSDLEA
            : "";
          // console.log("nobj > ", nobj);
          $rootScope.tempUserAddress = nobj;
          MyService.ConsoleLog(
            " $rootScope.tempUserAddress >",
            $rootScope.tempUserAddress
          );
        }
      }

      $scope.changeColor = function (nper, inx, cur_ans) {
        // MyService.ConsoleLog("inx", inx);
        // MyService.ConsoleLog("cur_ans", cur_ans);

        var arrOfCol = {
          5: "#990000",
          4: "#cc3300",
          3: "#ff9933",
          2: "#ffff00",
          1: "#99cc00",
          0: "#00d900",
        };
        var cdiff = Math.abs(inx - cur_ans);

        // console.log("arrOfCol > ", arrOfCol);
        $scope.gr = null;
        switch (true) {
          case nper >= 100:
            if (cur_ans == inx) {
              $scope.gr = {
                background:
                  "linear-gradient(to right, " +
                  arrOfCol[0] +
                  " " +
                  nper +
                  "%, #2b4f7f 10%)",
              };
            } else {
              $scope.gr = {
                background:
                  "linear-gradient(to right, " +
                  arrOfCol[cdiff] +
                  " " +
                  nper +
                  "%, #2b4f7f 10%)",
              };
            }

            // MyService.ConsoleLog("$scope.gr >>", arrOfCol.nper);
            break;
          case nper >= 80:
            if (cur_ans == inx) {
              $scope.gr = {
                background:
                  "linear-gradient(to right, " +
                  arrOfCol[0] +
                  " " +
                  nper +
                  "%, #2b4f7f 10%)",
              };
            } else {
              $scope.gr = {
                background:
                  "linear-gradient(to right, " +
                  arrOfCol[cdiff] +
                  " " +
                  nper +
                  "%, #2b4f7f 10%)",
              };
            }
            break;
          case nper >= 60:
            if (cur_ans == inx) {
              $scope.gr = {
                background:
                  "linear-gradient(to right, " +
                  arrOfCol[0] +
                  " " +
                  nper +
                  "%, #2b4f7f 10%)",
              };
            } else {
              $scope.gr = {
                background:
                  "linear-gradient(to right, " +
                  arrOfCol[cdiff] +
                  " " +
                  nper +
                  "%, #2b4f7f 10%)",
              };
            }
            break;
          case nper >= 40:
            if (cur_ans == inx) {
              $scope.gr = {
                background:
                  "linear-gradient(to right, " +
                  arrOfCol[0] +
                  " " +
                  nper +
                  "%, #2b4f7f 10%)",
              };
            } else {
              $scope.gr = {
                background:
                  "linear-gradient(to right, " +
                  arrOfCol[cdiff] +
                  " " +
                  nper +
                  "%, #2b4f7f 10%)",
              };
            }
            break;
          case nper >= 20:
            if (cur_ans == inx) {
              $scope.gr = {
                background:
                  "linear-gradient(to right, " +
                  arrOfCol[0] +
                  " " +
                  nper +
                  "%, #2b4f7f 10%)",
              };
            } else {
              $scope.gr = {
                background:
                  "linear-gradient(to right, " +
                  arrOfCol[cdiff] +
                  " " +
                  nper +
                  "%, #2b4f7f 10%)",
              };
            }
            break;
          case nper >= 0:
            if (cur_ans == inx) {
              $scope.gr = {
                background:
                  "linear-gradient(to right, " +
                  arrOfCol[0] +
                  " " +
                  nper +
                  "%, #2b4f7f 10%)",
              };
            } else {
              $scope.gr = {
                background:
                  "linear-gradient(to right, " +
                  arrOfCol[cdiff] +
                  " " +
                  nper +
                  "%, #2b4f7f 10%)",
              };
            }
            break;

          default:
            break;
        }
        MyService.ConsoleLog(" $scope.gr", $scope.gr);
        return $scope.gr;
      };

      /** Return class of background color */

      $scope.getComapreClass = function (match, i) {
        //MyService.ConsoleLog("match: ", match);
        /*if(match == 100)
          return 'ag-green';
      if(match == 0)
          return 'ag-red';
      if(match > 0 && match <100)
          return 'ag-dg'+i;*/
        if (match >= 100) return "ag-dg1";
        if (match >= 80) return "ag-dg2";
        if (match >= 60) return "ag-dg3";
        if (match >= 40) return "ag-dg4";
        if (match >= 20) return "ag-dg5";
        if (match >= 0) return "ag-dg6";

        return "ag-dg";
      };

      // $scope.getRegisterCompare = function() {
      //   MyService.ConsoleLog("$rootScope.guestMatch >", $rootScope.guestMatch);
      //   MyService.getRegisterUsersOfNation({ "quesArray": $rootScope.guestMatch }).then(function(response) {
      //     MyService.ConsoleLog("Response >>", response);
      //     $scope.currentIndex = 0;
      //     var quedata = response.data.data;

      //     var temp_uids = quedata[0].voterAnswer.map(function(item) {
      //       // console.log("item >>", item);
      //       // console.log("item >>", JSON.parse(item));

      //       if (item) {
      //         console.log("item >>", item);
      //         return item.toString();
      //       }

      //     });

      //     // temp_uids = temp_uids.filter(function(item, pos) {
      //     //   return temp_uids.indexOf(item) == pos;
      //     // });

      //     MyService.ConsoleLog("temp_uids >>", temp_uids);

      //     $scope.compareRegisterGuestUsers({
      //       "userIds": temp_uids,
      //       "guest": $rootScope.guestMatch,
      //       "userData": $scope.userId
      //     })

      //   }, function(err) {
      //     MyService.ConsoleLog("Error >>", err);
      //   });
      // }

      /**
       * @description Update quiz answers with existing flag
       */
      $scope.updateQuizAnswers = function () {
        if (window.localStorage.getItem("comData")) {
          $scope.quizData = JSON.parse(window.localStorage.getItem("comData"));
          $scope.answers = JSON.parse($scope.quizData.questions);
        }
        MyService.ConsoleLog("$scope.quizData", $scope.quizData);
        MyService.ConsoleLog("$scope.answers", $scope.answers);
        var token = apiCall.getToken();
        var ansLen = $scope.answers.length;

        for (var i = 0; i < ansLen; i++) {
          var isShare;
          if ($scope.answers[i].my_answer.show == "Y") {
            isShare = true;
          } else {
            isShare = false;
          }
          var postData = {
            questionId: $scope.answers[i]._id,
            importance: $scope.answers[i].my_answer.importance,
            answer: $scope.answers[i].my_answer.answer,
            id: $scope.answers[i].my_answer._id,
            comment: $scope.answers[i].my_answer.comment,
            token: token ? token : "",
            isShare: isShare,
            inviterId: $scope.inviterId,
            selCatId: $scope.answers[i].categories.cid,
          };
          MyService.ConsoleLog("<<<<<<<<<< postData", postData);
          MyService.postAnswer(postData).then(
            function (APIResponse) {
              MyService.ConsoleLog("APIResponse", APIResponse);
            },
            function (err) {
              MyService.ConsoleLog("err", err);
            }
          );
        }
        window.localStorage.removeItem("isUpdate");
        $scope.getAllAnsweredQuestions();
      };

      /**
       * This function calls on page load
       * fetch data of user's area politician ,voters and advocates
       */

      $scope.getLocalPoliticians = function (id) {
        MyService.ConsoleLog(
          "window.localStorage.getItem('comData')",
          window.localStorage.getItem("comData")
        );
        MyService.ConsoleLog("Id", id);
        if (!id) {
          $scope.loaders = true;
        } else {
          $scope.loadernew = true;
        }

        // MyService.ConsoleLog(" welcome to getLocalPoliticians ", $rootScope.queData);
        $scope.statusGetLocalPoliticians = 1;
        $scope.page += 1;
        $scope.loader = true;
        // MyService.ConsoleLog("$rootScope.tempUserA ******* ", $rootScope.tempUserAddress);
        // MyService.ConsoleLog("$rootScope.tempUserA ******* ", $rootScope.tempUserAddress.state)
        var extradata = new Object();
        if ($rootScope.tempUserAddress) {
          if (
            $rootScope.tempUserAddress.state &&
            $rootScope.tempUserAddress.state != ""
          ) {
            extradata.statePostalCode =
              $rootScope.tempUserAddress.statePostalCode;
          }
          if ($rootScope.tempUserAddress.county) {
            // $rootScope.tempUserAddress.FinalData = JSON.stringify(
            //   $rootScope.tempUserAddress.countyFips
            // );
            extradata.county = $rootScope.tempUserAddress.county;
          }
          if (
            $rootScope.tempUserAddress.countySubdivision &&
            $rootScope.tempUserAddress.countySubdivisionFips
          ) {
            $rootScope.tempUserAddress.FinalData = JSON.stringify(
              $rootScope.tempUserAddress.countySubdivisionFips
            );
            extradata.countySubdivision =
              $rootScope.tempUserAddress.countySubdivision;
          }
          if ($rootScope.tempUserAddress.place) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.place = $rootScope.tempUserAddress.place;
          }
          if (
            $rootScope.tempUserAddress.voterDistrict &&
            $rootScope.tempUserAddress.voterDistrictFips
          ) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.voterDistrict = $rootScope.tempUserAddress.voterDistrict;
          }
          if ($rootScope.tempUserAddress.federalCongrassionalDist) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            MyService.ConsoleLog(
              "federalCongrassionalDist  :",
              $rootScope.tempUserAddress.federalCongrassionalDist
            );
            extradata.federalCongrassionalDist =
              $rootScope.tempUserAddress.federalCongrassionalDist;
          }
          if ($rootScope.tempUserAddress.stateSenateDistrict) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.stateSenateDistrict =
              $rootScope.tempUserAddress.stateSenateDistrict;
          }
          if ($rootScope.tempUserAddress.legislativeDistrict) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.legislativeDistrict =
              $rootScope.tempUserAddress.legislativeDistrict;
          }
          if ($rootScope.tempUserAddress.schoolDistrict) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.schoolDistrict =
              $rootScope.tempUserAddress.schoolDistrict;
          }
        }
        MyService.ConsoleLog(
          "extradata : >>>>>>>>>> ",
          JSON.stringify(extradata)
        );
        MyService.getAllLocalPoli({
          max_records: 100,
          page: $scope.page,
          extradata: JSON.stringify(extradata),
        }).then(
          function (response) {
            if (response.data.success) {
              setTimeout(function () {
                $scope.$apply(function () {
                  if (response.data.data.length > 0) {
                    MyService.getAdvocates().then(
                      function (payload) {
                        MyService.ConsoleLog("Response >", payload);
                        var ndata = response.data.data;
                        var wdata = ndata.concat(payload.data.data);

                        if (window.localStorage.getItem("inviterId")) {
                          if (window.localStorage.getItem("isUpdate")) {
                            $scope.updateQuizAnswers();
                          }

                          if (window.localStorage.getItem("isHide")) {
                            window.localStorage.removeItem("isHide");
                            $scope.getAllAnsweredQuestions();
                          }
                          $scope.userAreaPolitician = [];
                          $scope.userAreaPolitician.push(
                            window.localStorage.getItem("inviterId")
                          );
                          var param = JSON.stringify({
                            usersIds: $scope.userAreaPolitician,
                            cur_userId: $scope.userId,
                            questions: $rootScope.queData,
                          });
                          // MyService.ConsoleLog("apra >", param);
                          // window.localStorage.removeItem('comData');
                          window.localStorage.setItem("comData", param);
                        } else {
                          $scope.userAreaPolitician = wdata.map(function (
                            ques
                          ) {
                            return ques._id;
                          });
                          var param = JSON.stringify({
                            usersIds: $scope.userAreaPolitician,
                            cur_userId: $scope.userId,
                            questions: $rootScope.queData,
                          });

                          // MyService.ConsoleLog("apra >", param);
                          // window.localStorage.removeItem('comData');
                          window.localStorage.setItem("comData", param);
                        }
                        MyService.ConsoleLog(
                          " $scope.userAreaPolitician >",
                          $scope.userAreaPolitician
                        );

                        var indx;
                        if (id && id != "") {
                          indx = id;
                          MyService.ConsoleLog("Inds >>>>>>>>", indx);
                        } else {
                          $scope.currentIndex = 0;
                          indx = $scope.currentIndex;
                          MyService.ConsoleLog(" $scope.currentIndex >", indx);
                        }
                        // alert('called');

                        var main = JSON.parse($rootScope.queData);
                        MyService.ConsoleLog(" $scope.quData :", main[indx]);
                        // if ($cookies.get('quizTakerId')) {
                        //   $scope.compareRegisterGuestUsers({
                        //     userIds: JSON.stringify($scope.userAreaPolitician),
                        //     guest: JSON.stringify(main[indx]),
                        //     userData: $scope.userId,
                        //     quizTakerId: $cookies.get('quizTakerId')
                        //   });
                        // } else if ($cookies.get('quizTakerIdsArr')) {
                        //   $scope.compareRegisterGuestUsers({
                        //     userIds: JSON.stringify($scope.userAreaPolitician),
                        //     guest: JSON.stringify(main[indx]),
                        //     userData: $scope.userId,
                        //     quizTakerIdsArr: $cookies.get('quizTakerId')
                        //   });
                        // } else {
                        $scope.compareRegisterGuestUsers({
                          userIds: JSON.stringify($scope.userAreaPolitician),
                          guest: JSON.stringify(main[indx]),
                          userData: $scope.userId,
                        });
                        // }
                      },
                      function (err) {
                        MyService.ConsoleLog("Error >>", err);
                      }
                    );
                  } else {
                    $scope.loader = false;
                    var message =
                      "None of your politicians have answered the questions yet. Contact them and ask them to fill it out.";
                    var modal = ngDialog.openConfirm({
                      template:
                        "<p>" +
                        message +
                        '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">OK</button>\
                            \
                        </div>',
                      plain: true,
                    });

                    modal.then(
                      function fullfilled(data) {
                        //MyService.ConsoleLog("fullfilled: ", data);
                        if (data == 1) {
                          $scope.postonFacebook();
                        } else {
                          if ($rootScope.userRole) {
                            $location.path("/snapshot");
                          } else {
                            $location.path("/signin");
                          }
                        }
                      },
                      function rejected(data) {
                        //MyService.ConsoleLog("rejected: ", data);
                      }
                    );
                  }
                });
              }, 100);
            } else {
              $scope.page -= 1;
              $scope.statusGetLocalPoliticians = 3;
              if (typeof response.data.error == "string")
                growl.error(response.data.error);
              else growl.error("Something went wrong");
            }
          },
          function (err) {
            $scope.page -= 1;
            $scope.statusGetLocalPoliticians = 3;
            $scope.loader = false;
            growl.error(err);
          }
        );
      };

      /**End of getLocalPoliticians */

      $scope.backTo = function () {
        $scope.showHidePop.close();
        // history.back();
        var catId = window.localStorage.getItem("cat_id");
        var subCatId = window.localStorage.getItem("selCat_id");
        $location.path("/question-background/" + catId + "/" + subCatId);
      };

      if (tokenService.getUserId()) {
        $scope.getLocalPoliticians();
      } else {
        MyService.getAllUsersOfNation({
          quesArray: $rootScope.guestMatch,
        }).then(
          function (response) {
            // MyService.ConsoleLog("Response >>", response);

            $scope.currentIndex = 0;
            var quedata = response.data.data;
            MyService.ConsoleLog("quedata >>", quedata);
            var temp_uids = quedata[0].voterAnswer.map(function (item) {
              // console.log("item >>", item);
              // console.log("item >>", JSON.parse(item));

              if (item) {
                // console.log("item >>", item);
                return item.toString();
              }
            });
            // MyService.ConsoleLog("temp_uids >",temp_uids);
            $scope.getCompareGuest(temp_uids);
          },
          function (err) {
            MyService.ConsoleLog("Error >>", err);
          }
        );
      }

      /**
       * This function redirects to show answers page
       */

      $scope.showAnswers = function (ans, type, qId, chAns, ind) {
        MyService.ConsoleLog("Ind", ind);
        MyService.ConsoleLog("qId", qId);

        if (!ind) {
          ind = 0;
        }
        if (chAns) {
          if (!chAns[ind + 1]) {
            // alert("This");
            growl.error("No users to see here");
          } else {
            // if (chAns != "") {
            //   alert('dahdaj');
            // }
            MyService.ConsoleLog("Type >>", type);
            MyService.ConsoleLog("qId >>", qId);
            MyService.ConsoleLog("chAns >>", chAns);

            $location.path(
              "/showAnswers/" + type + "/" + ans + "/" + qId + "/" + chAns
            );
          }
        } else {
          // alert('not Found');
          switch (type) {
            case "politician":
              growl.error(
                "None of politicians of your area answered for this question"
              );
              break;
            case "voter":
              growl.error(
                "None of voter of your area answered for this question"
              );
              break;
            case "advocate":
              growl.error(
                "None of organizations of your area answered for this question"
              );
              break;

            default:
              break;
          }
        }
      };

      /**
       * This function show the details of answered questions
       * showAnswersDetail
       */

      $scope.showAnswersDetail = function (para) {
        MyService.ConsoleLog("para >", para);

        switch (para) {
          case "politician":
            if ($scope.showGrpFollow) {
              // MyService.ConsoleLog("$scope.arrayOfCom", $scope.arrayOfCom[$scope.questions[$scope.currentIndex]._id].length);
              if (
                $scope.arrayOfCom &&
                $scope.arrayOfCom[$scope.questions[$scope.currentIndex]._id]
              ) {
                var newObjs = JSON.stringify({
                  poli: $scope.arrayOfCom,
                  qId: $scope.questions[$scope.currentIndex]._id,
                });
                MyService.ConsoleLog("newObj", newObjs);
                window.localStorage.setItem("poliAr", newObjs);
              } else if (
                $scope.voterComArr &&
                $scope.voterComArr[$scope.questions[$scope.currentIndex]._id]
              ) {
                var vObj = JSON.stringify({
                  vot: $scope.voterComArr,
                  qId: $scope.questions[$scope.currentIndex]._id,
                });
                window.localStorage.setItem("voter", vObj);
              } else if ($scope.advComArr) {
                var advo = JSON.stringify({
                  adv: $scope.advComArr,
                  qId: $scope.questions[$scope.currentIndex]._id,
                });
                window.localStorage.setItem("adv", advo);
              }
            } else {
              var newObj = JSON.stringify({
                poli: $scope.arrayOfCom,
                qId: $scope.questions[$scope.currentIndex]._id,
              });
              MyService.ConsoleLog("newObj", newObj);
              window.localStorage.setItem("poliAr", newObj);
            }
            $location.path("/showGroupAnswer");
            // $scope.showPoliAnswerDetails = true;
            break;
          case "unRegister":
            var unObj = JSON.stringify({
              unVeri: $scope.unVeriComm,
              qId: $scope.questions[$scope.currentIndex]._id,
            });
            window.localStorage.setItem("unVerify", unObj);
            $location.path("/showGroupAnswer");
            // $scope.showUserAnswerDetails = true;
            break;
          case "voter":
            var vObj = JSON.stringify({
              vot: $scope.voterComArr,
              qId: $scope.questions[$scope.currentIndex]._id,
            });
            window.localStorage.setItem("voter", vObj);
            $location.path("/showGroupAnswer");
            // $scope.showPoliAnswerDetails = true;
            break;
          case "advocate":
            var advo = JSON.stringify({
              adv: $scope.advComArr,
              qId: $scope.questions[$scope.currentIndex]._id,
            });
            window.localStorage.setItem("adv", advo);
            $location.path("/showGroupAnswer");
            // $scope.showPoliAnswerDetails = true;
            break;
          default:
            break;
        }

        // if (para == 'politician') {
        //   $scope.showPoliAnswerDetails = true;
        // } else {
        //   $scope.showUserAnswerDetails = true;
        // }
      };

      /**End Of showAnswersDetail */

      $scope.getCompareGuest = function (params) {
        // MyService.ConsoleLog("params >", params);
        console.log("$rootScope.guestMatch", $rootScope.guestMatch);
        MyService.compareGuest({
          comparewith: params,
          guest: $rootScope.guestMatch,
        }).then(
          function (payload) {
            if (payload.data.success) {
              MyService.ConsoleLog(
                "CompareWithAllPolitcians >> ",
                payload.data.data
              );
              $scope.emailRegistered = payload.data.data.agrriOfEmail;
              $scope.unVerified = payload.data.data.aggriOfUnVerified;
              $scope.emailImpo = payload.data.data.aggriOfEmailImportance;
              $scope.unVeriImpo = payload.data.data.aggriUnVerifiedImportance;
              // $scope.questions = payload.data.data.qdata;
              $scope.questions = JSON.parse($rootScope.queData);
              MyService.ConsoleLog("$scope.questions ONE>>>", $scope.questions);
              $scope.FBCompareList = payload.data.data.qdata;
              $scope.ansCount = payload.data.data.ansCount;
              $scope.unCount = payload.data.data.unCount;
              $scope.impCount = payload.data.data.impCount;
              $scope.unImpCount = payload.data.data.unImpCount;
              $scope.flagOfUnVerified = payload.data.data.flagOfUnVerified;
              // MyService.ConsoleLog('ansCount >', $scope.impCount);
              $scope.globalFlag = payload.data.data.checkFlag;
              $scope.arrayOfCom = payload.data.data.commArr;
              $scope.unVeriComm = payload.data.data.unVeriComm;
              MyService.ConsoleLog(
                "Object.keys(payload.data.data.agrriOfEmail).length",
                Object.keys(payload.data.data.agrriOfEmail).length
              );
              MyService.ConsoleLog(
                "aggriOfUnVerified",
                Object.keys(payload.data.data.aggriOfUnVerified).length
              );
              if (
                Object.keys(payload.data.data.agrriOfEmail).length == 0 &&
                Object.keys(payload.data.data.aggriOfUnVerified).length == 0 &&
                payload.data.data.agrriOfEmail.constructor == Object &&
                payload.data.data.aggriOfUnVerified.constructor == Object
              ) {
                // alert("called");
                var message =
                  "'”Congratulations!!  You are the first person to take this quiz! ";
                var modal = ngDialog.openConfirm({
                  template:
                    "<p>" +
                    message +
                    '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">OK</button>\
                            \
                        </div>',
                  plain: true,
                });
                modal.then(
                  function fullfilled(data) {
                    //MyService.ConsoleLog("fullfilled: ", data);
                    if (data == 0) {
                      // if (tokenService.getUserRole() == 'voter') {
                      $location.path("/learnHome");
                      // } else if (tokenService.getUserRole() == 'politician') {
                      //   $location.path('/winVoters');
                      // }
                    }
                  },
                  function rejected(data) {
                    //MyService.ConsoleLog("rejected: ", data);
                  }
                );
              }
              // if () {
              //   alert("second");
              // }
              // MyService.ConsoleLog(' $scope.unVeriComm >', $scope.unVeriComm);
              // MyService.ConsoleLog('$scope.flagOfUnVerified >', $scope.flagOfUnVerified);
              // MyService.ConsoleLog(' $scope.globalFlag >', $scope.globalFlag);

              $scope.flag = true;
              if ($scope.FBCompareList && $scope.FBCompareList.length > 0) {
                $scope.FBunWeighted = payload.data.data.unweightedMatch;
                $scope.fbcombinedWeight = payload.data.data.fbcombinedWeight;
                $scope.fbmultiplier = payload.data.data.fbmultiplier;
                $scope.answeredQuestions = payload.data.data.answeredQuestions;
                $scope.fbqlen = payload.data.data.qlen;
                $scope.AllUsers = payload.data.data.AllUsers;

                var mainData = JSON.stringify(payload.data.data);
                // MyService.ConsoleLog("mainData >>", mainData);
                window.localStorage.setItem("Data", mainData);
                //$scope.qData = payload.data.data.answeredQuestions;
              } else {
                var message =
                  "'”Congratulations!!  You are the first person in your area to take this quiz! ";
                var modal = ngDialog.openConfirm({
                  template:
                    "<p>" +
                    message +
                    '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">OK</button>\
                            \
                        </div>',
                  plain: true,
                });
                //alert("Looks like your friends have not yet answered the questions.");
                // MyService.ConsoleLog("No politicians found, check incumbent");
                /*MyService.compareFiveMinAnswers({
              "userdata": JSON.stringify($rootScope.fiveMatch),
              "comparewith": JSON.stringify($scope.userAreaPolitician),
              type: "incumbent"
            }).then(function(payload) {
                if (payload.data.success) {
                  MyService.ConsoleLog("incumbent data :> ", payload.data.data);
                  $scope.questions = payload.data.data.qdata;
                  $scope.FBCompareList = payload.data.data.qdata;
                  if ($scope.FBCompareList && $scope.FBCompareList.length > 0) {
                    $scope.FBunWeighted = payload.data.data.unweightedMatch;
                    $scope.fbcombinedWeight = payload.data.data.fbcombinedWeight;
                    $scope.fbmultiplier = payload.data.data.fbmultiplier;
                    $scope.answeredQuestions = payload.data.data.answeredQuestions;
                    $scope.fbqlen = payload.data.data.qlen;
                    $scope.AllUsers = payload.data.data.AllUsers;
                  } else {
                    // MyService.ConsoleLog("No politicians and incumbent found, check voters");
                    $scope.hideName = true;
                    // Show only popup if no politicians and incubents
                    var message = "None of your politicians have answered the questions yet. Contact them and ask them to fill it out.";
                    var modal = ngDialog.openConfirm({
                      template: '<p>' + message + '</p>\
                  <div class="ngdialog-buttons">\
                      <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">OK</button>\
                      \
                  </div>',
                      plain: true
                    });

                    modal.then(function fullfilled(data) {
                      //MyService.ConsoleLog("fullfilled: ", data);
                      if (data == 1) {
                        $scope.postonFacebook();
                      } else {
                        if ($rootScope.userRole) {
                          $location.path('/snapshot');
                        } else {
                          $location.path('/signin');
                        }
                      }
                    }, function rejected(data) {
                      //MyService.ConsoleLog("rejected: ", data);
                    });
                    return;
                  }
                }
              },
              function(errorpayload) {
                MyService.ConsoleLog(errorpayload);
              });*/
              }
            } else {
              $scope.showAlert = true;
              // alert("Something went wrong.");
              $scope.loaders = false;
            }
          },
          function (err) {
            MyService.ConsoleLog("Error >", err);
          }
        );
      };
      $scope.loadernew = false;

      /** This function fetch comparison results using
       ** @ Params @
       ** guest user data and politician data
       **/

      $scope.compareRegisterGuestUsers = function (params) {
        MyService.ConsoleLog("Params >>", params);

        MyService.compareRegisterGuestUsers(params).then(
          function (payload) {
            MyService.ConsoleLog("Response >>>", payload);

            if (payload.data.success) {
              $scope.loadernew = false;
              $scope.loaders = false;
              if (window.localStorage.getItem("inviterInfo")) {
                $scope.inviterData = JSON.parse(
                  window.localStorage.getItem("inviterInfo")
                );
              }

              // MyService.ConsoleLog("CompareWithAllPolitcians >> ", payload.data.data.qdata);
              // if (Object.keys(payload.data.data.agrriOfEmail).length == 0 || Object.keys(payload.data.data.aggriOfVoter).length == 0 || Object.keys(payload.data.data.aggriOfAdvocate).length == 0 || Object.keys(payload.data.data.aggriOfUnVerified).length == 0) {
              $scope.emailRegistered = "";
              if (
                $scope.inviterData &&
                $scope.inviterData.userType == "politician" &&
                JSON.stringify(payload.data.data.agrriOfEmail) !=
                  JSON.stringify({})
              ) {
                $scope.emailRegistered = payload.data.data.agrriOfEmail;
              } else if (
                !$scope.inviterData &&
                JSON.stringify(payload.data.data.agrriOfEmail) !=
                  JSON.stringify({})
              ) {
                $scope.emailRegistered = payload.data.data.agrriOfEmail;
              }

              MyService.ConsoleLog(
                "$scope.emailRegistered >",
                $scope.emailRegistered
              );
              MyService.ConsoleLog(
                "<<<<< $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$>>>>>",
                window.localStorage.getItem("inviterId")
              );
              if (!window.localStorage.getItem("inviterId")) {
                $scope.unVerified = payload.data.data.aggriOfUnVerified;
              }
              // $scope.unVerified = payload.data.data.aggriOfUnVerified;
              $scope.emailImpo = payload.data.data.aggriOfEmailImportance;
              $scope.unVeriImpo = payload.data.data.aggriUnVerifiedImportance;
              $scope.questions = JSON.parse($rootScope.queData);
              MyService.ConsoleLog(
                "JSON.parse($rootScope.queData)",
                JSON.parse($rootScope.queData)
              );
              MyService.ConsoleLog(
                "$scope.questions TWo >>>",
                $scope.questions
              );
              $scope.FBCompareList = payload.data.data.qdata;
              $scope.ansCount = payload.data.data.ansCount;
              $scope.unCount = payload.data.data.unCount;
              $scope.impCount = payload.data.data.impCount;
              $scope.unImpCount = payload.data.data.unImpCount;
              $scope.flagOfUnVerified = payload.data.data.flagOfUnVerified;
              // MyService.ConsoleLog('ansCount >', $scope.impCount);
              $scope.globalFlag = payload.data.data.checkFlag;
              $scope.arrayOfCom = payload.data.data.commArr;
              $scope.unVeriComm = payload.data.data.unVeriComm;
              $scope.voter = "";
              if (
                $scope.inviterData &&
                $scope.inviterData.userType == "voter" &&
                JSON.stringify(payload.data.data.aggriOfVoter) !=
                  JSON.stringify({})
              ) {
                MyService.ConsoleLog(
                  "<<<<<<<<<<<<<<<<<<<>>>>>>>>>>>>>>>>>>>>",
                  JSON.stringify(payload.data.data.aggriOfVoter)
                );
                $scope.voter = payload.data.data.aggriOfVoter;
              } else if (
                !$scope.inviterData &&
                JSON.stringify(payload.data.data.aggriOfVoter) !=
                  JSON.stringify({})
              ) {
                $scope.voter = payload.data.data.aggriOfVoter;
                MyService.ConsoleLog(
                  "else",
                  JSON.stringify(payload.data.data.aggriOfVoter)
                );
              }
              MyService.ConsoleLog(">>>>>>>>>>>>>>>>>>>>", $scope.voter);
              $scope.voterImp = payload.data.data.aggriOfVoterImportance;
              $scope.voterAnsCount = payload.data.data.voterAnsCount;
              $scope.voterImpCount = payload.data.data.voterImpCount;
              $scope.flagOfVoter = payload.data.data.voterFlag;
              $scope.voterComArr = payload.data.data.voterComArr;
              $scope.advocate = "";
              if (
                $scope.inviterData &&
                $scope.inviterData.title &&
                JSON.stringify(payload.data.data.aggriOfAdvocate) !=
                  JSON.stringify({})
              ) {
                $scope.advocate = payload.data.data.aggriOfAdvocate;
              } else if (
                !$scope.inviterData &&
                JSON.stringify(payload.data.data.aggriOfAdvocate) !=
                  JSON.stringify({})
              ) {
                $scope.advocate = payload.data.data.aggriOfAdvocate;
              }

              $scope.advocateAns = payload.data.data.advocateObj;
              $scope.advocateImpAggri =
                payload.data.data.aggriOfAdvocateImportance;
              $scope.advocateimpObj = payload.data.data.advocateimpObj;
              $scope.advocateFlag = payload.data.data.advFlag;
              $scope.advComArr = payload.data.data.advcommArr;
              // $scope.questions = payload.data.data.qdata;
              // MyService.ConsoleLog("$scope.questions >>>", $scope.questions);
              $scope.FBCompareList = payload.data.data.qdata;
              $scope.flag = true;
              if ($scope.FBCompareList && $scope.FBCompareList.length > 0) {
                $scope.FBunWeighted = payload.data.data.unweightedMatch;
                $scope.fbcombinedWeight = payload.data.data.fbcombinedWeight;
                $scope.fbmultiplier = payload.data.data.fbmultiplier;
                $scope.answeredQuestions = payload.data.data.answeredQuestions;
                $scope.fbqlen = payload.data.data.qlen;
                $scope.AllUsers = payload.data.data.AllUsers;
                var mainData = JSON.stringify(payload.data.data);
                // MyService.ConsoleLog("mainData >>", mainData);
                window.localStorage.setItem("Data", mainData);

                if (
                  JSON.stringify($scope.emailRegistered) ==
                    JSON.stringify({}) &&
                  JSON.stringify($scope.voter) == JSON.stringify({}) &&
                  JSON.stringify($scope.advocate) == JSON.stringify({}) &&
                  JSON.stringify($scope.unVerified) == JSON.stringify({})
                ) {
                  // alert('got')
                  var message =
                    "”Congratulations!!  You are the first person in your area to take this quiz!  You are at the forefront of democracy!”";
                  MyService.ConsoleLog(
                    "getUserRole >",
                    tokenService.getUserRole()
                  );
                  // var repath;

                  var modal = ngDialog.openConfirm({
                    template:
                      "<p>" +
                      message +
                      '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">OK</button>\
                            \
                        </div>',
                    plain: true,
                  });

                  modal.then(
                    function fullfilled(data) {
                      //MyService.ConsoleLog("fullfilled: ", data);
                      if (data == 0) {
                        if (tokenService.getUserRole() == "voter") {
                          $location.path("/learnHome");
                        } else if (tokenService.getUserRole() == "politician") {
                          $location.path("/winVoters");
                        }
                      }
                    },
                    function rejected(data) {
                      //MyService.ConsoleLog("rejected: ", data);
                    }
                  );
                }
              }
              //$scope.qData = payload.data.data.answeredQuestions;
              // } else {
              //   alert('got');
              // }
            } else {
              $scope.showAlert = true;
              var message =
                "”In order for us to show how your answers compare to others, you must first answer questions”";
              MyService.ConsoleLog("getUserRole >", tokenService.getUserRole());
              // var repath;

              var modal = ngDialog.openConfirm({
                template:
                  "<p>" +
                  message +
                  '</p>\
                    <div class="ngdialog-buttons">\
                        <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">OK</button>\
                        \
                    </div>',
                plain: true,
              });

              modal.then(
                function fullfilled(data) {
                  //MyService.ConsoleLog("fullfilled: ", data);
                  if (data == 0) {
                    history.back();
                  }
                },
                function rejected(data) {
                  //MyService.ConsoleLog("rejected: ", data);
                }
              );
              // alert("Something went wrong.");
            }
          },
          function (error) {
            MyService.ConsoleLog("Error >>", error);
          }
        );
      };

      /**This function redirects to show comment page */
      $scope.viewAnsComment = function (val) {
        MyService.ConsoleLog("called", val);

        switch (val) {
          case "email":
            $scope.global = $scope.arrayOfCom;
            if ($scope.userId) {
              var poli = JSON.stringify({
                poliArr: $scope.arrayOfCom,
                queId: $scope.questions[$scope.currentIndex]._id,
              });
              window.localStorage.setItem("comOfPolitician", poli);
              $location.path("/showComments");
            }
            $scope.showComment = true;
            $scope.unComment = false;
            $scope.showCurr = false;

            break;
          case "unRegister":
            if ($scope.userId) {
              var guest = JSON.stringify({
                guestArr: $scope.unVeriComm,
                queId: $scope.questions[$scope.currentIndex]._id,
              });
              window.localStorage.setItem("comOfGuest", guest);
              $location.path("/showComments");
            }
            $scope.unComment = true;
            $scope.showComment = false;
            $scope.showCurr = false;

            break;
          case "voter":
            $scope.global = $scope.voterComArr;
            // MyService.ConsoleLog("$scope.voterComArr", $scope.voterComArr);
            if ($scope.userId) {
              var vo = JSON.stringify({
                compArr: $scope.voterComArr,
                queId: $scope.questions[$scope.currentIndex]._id,
              });
              // MyService.ConsoleLog("vo >>", vo);
              window.localStorage.setItem("comOfVoter", vo);
              $location.path("/showComments");
            }
            $scope.showComment = true;
            $scope.unComment = false;
            $scope.showCurr = false;

            break;
          case "advocate":
            $scope.global = $scope.advComArr;
            if ($scope.userId) {
              var adv = JSON.stringify({
                advArr: $scope.advComArr,
                queId: $scope.questions[$scope.currentIndex]._id,
              });
              window.localStorage.setItem("comOfAdv", adv);
              $location.path("/showComments");
            }
            $scope.showComment = true;
            $scope.unComment = false;
            $scope.showCurr = false;

            break;
          case "currentUser":
            if ($scope.userId) {
              var curUser = JSON.stringify({
                curuser: $scope.questions[$scope.currentIndex],
              });

              window.localStorage.setItem("cuUser", curUser);
              $location.path("/showComments");
            }
            $scope.showComment = false;
            $scope.showCurr = true;
            $scope.unComment = false;
            break;
          default:
            break;
        }
      };
      $scope.back = function () {
        $scope.showPoliAnswerDetails = false;
        $scope.showUserAnswerDetails = false;
        $scope.showComment = false;
        $scope.unComment = false;
        $scope.showCurr = false;
      };

      $scope.status = {
        questions: 0, //1=loading, 2=loaded, 3=error
        category: 0,
      };

      var getCompareAnswersCanceler = $q.defer();

      $scope.getCompareAnswers = function (params) {
        console.log("params: ", params);

        if (!params) return;
        getCompareAnswersCanceler.resolve();

        getCompareAnswersCanceler = $q.defer();
        $scope.questions = [];
        $scope.status.questions = 1;

        MyService.getCompareAns(params, getCompareAnswersCanceler.promise).then(
          function successCallback(response) {
            console.log("response: ", response);
            //MyService.ConsoleLog("Got categories: ",response);
            if (response.data.success) {
              if (response.data.data.length > 0) {
                $scope.status.questions = 2;
                angular.forEach(response.data.data, function (val, key) {
                  if (
                    val.answers &&
                    val.answers.length != $rootScope.selectedCompareUsers.length
                  ) {
                    var check_author_exist = function (u) {
                      var len = val.answers.length;
                      for (var i = 0; i < len; i++) {
                        if (val.answers[i].author._id == u) {
                          return true;
                        }
                      }
                      return false;
                    };

                    angular.forEach(
                      $rootScope.selectedCompareUsers,
                      function (u, i) {
                        if (!check_author_exist(u)) {
                          response.data.data[key].answers.push({
                            author: u,
                          });
                        }
                      }
                    );
                  } else if (!val.answers) {
                    response.data.data[key].answers = [];
                    angular.forEach(
                      $rootScope.selectedCompareUsers,
                      function (u, i) {
                        response.data.data[key].answers.push({
                          author: u,
                        });
                      }
                    );
                  }
                });

                $scope.questions = response.data.data;
                console.log("$scope.questions: ", $scope.questions);
              }
              // $location.path("question-compare/"+$routeParams.category_id+"/"+null);
            } else {
              $scope.status.questions = 3;
              //MyService.ConsoleLog("Something went wrong: ", response.data);
            }
          },
          function errorCallBack(response) {
            $scope.status.questions = 3;
            //MyService.ConsoleLog("Error: ", response);
          }
        );
      };

      $scope.finalSignIn = function () {
        $location.path("/fiveSaveUser");
      };

      /**
       * This function filter comment data
       */
      $scope.getItems = function () {
        return function (u) {
          MyService.ConsoleLog("params >", u);

          if (u.comment && u.comment != "") {
            return u;
          }
        };
      };

      $scope.getComment = function () {
        return function (x) {
          if (x.comment && x.comment != "") {
            return x;
          }
        };
      };

      /**
       **
       ** This function fetched matched answers for guest
       **/

      /* var getGuestCompareCanceler = $q.defer();

    $scope.getGuestCompare = function(params) {

      console.log("params: ", params);

      if (!params) return;
      getGuestCompareCanceler.resolve();

      getGuestCompareCanceler = $q.defer();
      $scope.questions = [];
      $scope.status.questions = 1;

      MyService.getGuestCompareAns(params, getGuestCompareCanceler.promise)
        .then(function successCallback(response) {
          console.log('response: ', response);
          //MyService.ConsoleLog("Got categories: ",response);
          if (response.data.success) {
            if (response.data.data.length > 0) {
              $scope.status.questions = 2;
              angular.forEach(response.data.data, function(val, key) {
                if (val.answers && val.answers.length != $rootScope.selectedCompareUsers.length) {
                  var check_author_exist = function(u) {
                    var len = val.answers.length;
                    for (var i = 0; i < len; i++) {
                      if (val.answers[i].author._id == u) {
                        return true;
                      }
                    }
                    return false;
                  };

                  angular.forEach($rootScope.selectedCompareUsers, function(u, i) {
                    if (!check_author_exist(u)) {
                      response.data.data[key].answers.push({
                        author: u
                      });
                    }
                  });
                } else if (!val.answers) {
                  response.data.data[key].answers = [];
                  angular.forEach($rootScope.selectedCompareUsers, function(u, i) {
                    response.data.data[key].answers.push({
                      author: u
                    });
                  });
                }
              });

              $scope.questions = response.data.data;
              console.log('$scope.questions: ', $scope.questions);
            }
            // $location.path("question-compare/"+$routeParams.category_id+"/"+null);
          } else {
            $scope.status.questions = 3;
            //MyService.ConsoleLog("Something went wrong: ", response.data);
          }
        }, function errorCallBack(response) {
          $scope.status.questions = 3;
          //MyService.ConsoleLog("Error: ", response);
        });
    };
*/

      $scope.prevQuestion = function () {
        //MyService.ConsoleLog("** prevQuestion **");

        $("html, body").animate(
          {
            scrollTop: $("#DisplayQ").offset().top - 280,
          },
          "slow"
        );
        if ($scope.currentIndex > 0) {
          var decr = $scope.currentIndex--;
          var one = decr - 1;
          MyService.ConsoleLog("decr", one);
          if ($scope.userId) {
            $scope.getLocalPoliticians(one);
          }
        } else if ($scope.currentIndex == 0) {
          if ($scope.currBackgroundIndex > 0) {
            $scope.currBackgroundIndex--;
            MyService.ConsoleLog(
              "$scope.traverseBackgrounds >",
              $scope.traverseBackgrounds
            );
            $scope.category =
              $scope.traverseBackgrounds[$scope.currBackgroundIndex];
          } else {
            //MyService.ConsoleLog("** end of background **");
            if ($scope.rootCatIndex > 0) {
              $scope.rootCatIndex--;
              $location.path(
                "/question-compare/all/" +
                  $rootScope.categories[$scope.rootCatIndex]._id
              );
            }
          }
        }
      };

      $scope.skipQuestion = function () {
        // $("html, body").animate({
        //   scrollTop: 0
        // }, "slow");
        var skip = function () {
          MyService.ConsoleLog("offset", $("#DisplayQ").offset().top);
          $("html, body").animate(
            {
              scrollTop: $("#DisplayQ").offset().top - 180,
            },
            "slow"
          );

          var tempIndex = $scope.currentIndex + 1;
          MyService.ConsoleLog(" $scope.currentIndex >>", tempIndex);
          if ($scope.userId) {
            $scope.getLocalPoliticians(tempIndex);
          }

          if (tempIndex < $scope.questions.length) {
            $scope.currentIndex++;
            if (
              $routeParams.categoryId &&
              $routeParams.categoryId.indexOf("popular:") == 0
            ) {
              //we are showing questions of most popular section
              $scope.getCategory({
                id: $scope.questions[$scope.currentIndex].categories.cid,
              });
            }
          }
          MyService.ConsoleLog(
            "tempIndex = ",
            tempIndex + "$scope.questions.length " + $scope.questions.length
          );
          if (
            tempIndex == $scope.questions.length ||
            $scope.questions.length == 0
          ) {
            //MyService.ConsoleLog("end of questions switch background");
            var tempBackIdx = $scope.currBackgroundIndex + 1;
            MyService.ConsoleLog(
              "$scope.traverseBackgrounds >>",
              $scope.traverseBackgrounds
            );
            if (
              $scope.traverseBackgrounds &&
              $scope.traverseBackgrounds != ""
            ) {
              if (tempBackIdx < $scope.traverseBackgrounds.length) {
                $scope.currBackgroundIndex++;
                $scope.category =
                  $scope.traverseBackgrounds[$scope.currBackgroundIndex];
              } else {
                $scope.rootCatIndex++;
                // alert("Else");
                window.localStorage.setItem(
                  "RootCatIndex",
                  $scope.rootCatIndex
                );
                window.localStorage.setItem(
                  "DisplayCategory",
                  JSON.stringify($scope.category)
                );
                //MyService.ConsoleLog("/politician_compare/" + $routeParams.categoryId + "/" + $routeParams.parentId);
                $location.path(
                  "/politician_compare/" +
                    $routeParams.categoryId +
                    "/" +
                    $routeParams.parentId
                );
              }
            } else {
              if ($scope.userId) {
                $location.path("/compareWithGroup");
              } else {
                $location.path("/compareGuestUsers");
              }
            }
          }
        };

        skip();
      };

      /**
       * Hide show Pop Up
       */
      $scope.FBCompareList = [];
      $scope.AnswerArray = [];
      $scope.AnswerArray[1] = "Very Strongly Agree";
      $scope.AnswerArray[2] = "Agree";
      $scope.AnswerArray[3] = "Somewhat Agree";
      $scope.AnswerArray[4] = "Somewhat Disagree";
      $scope.AnswerArray[5] = "Disagree";
      $scope.AnswerArray[6] = "Very Strongly Disgree";
      $scope.AnswerImpArray = [];
      $scope.AnswerImpArray[1] = "Somewhat Important";
      $scope.AnswerImpArray[2] = "Important";
      $scope.AnswerImpArray[3] = "Very Important";
      $scope.Math = window.Math;
      $scope.allQuestions = [];
      $scope.switchStatus = [];
      $scope.chooseQuestions = function () {
        //MyService.ConsoleLog($scope.oldQuestions);
        if ($scope.allQuestions.length > 0) {
          $scope.showHidePop = ngDialog.open({
            template: "ReviewMyAnswers",
            scope: $scope,
            width: "60%",
          });
        } else {
          alert(
            "There are no questions to display. Please go through all questions first."
          );
        }
      };
      //$scope.switchStatus = "Show";
      $scope.showloader = false;
      $scope.switchFilters = function (newValue, index, quest) {
        $scope.showloader = true;
        MyService.ConsoleLog("newValue::", newValue);
        MyService.ConsoleLog("oldValue::", $scope.switchStatus);
        var setVal = "N";
        if (newValue[index] == true) {
          setVal = "Y";
        }

        var idx = $scope.allQuestions.indexOf(quest);
        MyService.ConsoleLog("setVal:", setVal);
        MyService.ConsoleLog("quest:", quest);

        MyService.updateAnswers({
          qid: quest._id,
          show: setVal,
          author: quest.author,
          inviterId: $scope.inviterId ? $scope.inviterId : "",
          quest: JSON.stringify(quest.categories),
        }).then(
          function (payload) {
            //MyService.ConsoleLog("payload : ", payload);
            $scope.showloader = false;
            if (payload.data.success) {
              quest.my_answer.show = setVal;
              $scope.allQuestions[idx] = quest;
            } else {
              alert("Something went wrong. Contact administrator.");
            }
          },
          function (errorpayload) {
            $scope.showloader = false;
            //MyService.ConsoleLog("errorpayload : ", errorpayload);
            alert("Something went wrong. Contact administrator.");
          }
        );
      };

      if (window.localStorage.getItem("quesData")) {
        $scope.questions = JSON.parse(window.localStorage.getItem("quesData"));
        $scope.queIds = $scope.questions.map(function (itm) {
          if (itm.questionId) {
            return itm.questionId;
          } else {
            // console.log("itm", itm);
            return itm._id;
          }
        });
        MyService.ConsoleLog("  $scope.queIds", $scope.queIds);
      }

      $scope.AllAnsweredQuestions = [];
      $scope.getAllAnsweredQuestions = function (userId) {
        MyService.getAllAnsQuesWithIds({
          authorId: tokenService.getUserId(),
          ques: JSON.stringify($scope.queIds),
        }).then(
          function (payload) {
            MyService.ConsoleLog("getAllAnsweredQuestions >> ", payload);
            if (payload.data.success) {
              $scope.AllAnsweredQuestions = payload.data.data;
              $scope.allQuestions = $scope.AllAnsweredQuestions;
              MyService.ConsoleLog("$scope.allQuestions", $scope.allQuestions);
              var tmpS = $scope.allQuestions.filter(function (itms, ind) {
                if (itms && itms.my_answer) {
                  if (itms.my_answer.show == "Y") {
                    $scope.switchStatus[ind] = true;
                  } else {
                    $scope.switchStatus[ind] = false;
                  }
                }
              });

              MyService.ConsoleLog("$scope.switchStatus", $scope.switchStatus);
              if ($scope.allQuestions.length == 0) {
                growl.error(
                  "There are no questions to display. Please go through all questions first."
                );
              }
              $scope.chooseQuestions();
            }
          },
          function (errpayload) {
            MyService.ConsoleLog(
              "getAllAnsweredQuestions errpayload >> ",
              errpayload
            );
          }
        );
      };

      // /**
      //  * Next
      //  */

      // $scope.next = function () {
      //   $scope.showHidePop.close();
      //   // if ($scope.userId && $scope.userId != '') {
      //   //   MyService.ConsoleLog("yes");
      //   //   MyService.ConsoleLog("catId", window.localStorage.getItem('cat_id'));
      //   //   var catId, selCat_id;
      //   //   catId = window.localStorage.getItem('cat_id');
      //   //   selCat_id = window.localStorage.getItem('selCat_id');
      //   //   MyService.ConsoleLog("selCat_id", window.localStorage.getItem('selCat_id'));
      //   //   var tempLink = $location.absUrl().split("#!");
      //   //   $scope.shareLink = tempLink[0] + "#!/exploreQuiz/" + catId + "/" + selCat_id + "/" + $scope.userId;
      //   //   MyService.ConsoleLog("here we go with link", $scope.shareLink);
      //   //   ngDialog.open({
      //   //     template: 'exporeQuizLink',
      //   //     scope: $scope,
      //   //     width: "60%"
      //   //   });
      //   // }
      // };

      /**
       * Cancel
       */

      $scope.cancel = function () {
        $scope.showHidePop.close();
      };
    },
  ]);

'use strict';
angular
  .module('myApp.findFollowerMatch', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/findFollowerMatch/:flag?', {
        templateUrl: 'app/findFollowerMatch/findFollowerMatch.html',
        controller: 'findFollowerMatchCtrl',
      });
      $routeProvider.when('/findFollowerMatch/:catid', {
        templateUrl: 'app/findFollowerMatch/findFollowerMatch.html',
        controller: 'findFollowerMatchCtrl',
      });
    },
  ])
  .controller('findFollowerMatchCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    '$routeParams',
    '$rootScope',
    '$q',
    '$timeout',
    'tokenService',
    'MyService',
    '$anchorScroll',
    '$cookies',
    'ngDialog',
    'growl',
    '$window',
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $rootScope,
      $q,
      $timeout,
      tokenService,
      MyService,
      $anchorScroll,
      $cookies,
      ngDialog,
      growl,
      $window
    ) {
      $scope.page = 1;
      $scope.maxRecordsPerPg = 10000;
      $scope.showPoliAnswerDetails = false;
      $scope.showUserAnswerDetails = false;
      $scope.noDataFound = false;
      $scope.showcomparison = false;
      $scope.showComment = false;
      $scope.unComment = false;
      $scope.showCurr = false;
      $scope.loaders = false;


      if (tokenService.getUserId()) {
        $scope.userId = tokenService.getUserId();
        console.log('$scope.userId: ', $scope.userId);
      }
      window.localStorage.removeItem('isFindFollowers');
      window.localStorage.setItem('isFindFollowers', true);
      console.log('window.localStorage.getItem :', window.localStorage.getItem('inviterId'));
      if (window.localStorage.getItem('inviterId')) {
        if (window.localStorage.getItem('inviterInfo')) {
          $scope.inviterInfo = JSON.parse(window.localStorage.getItem('inviterInfo'));
          MyService.ConsoleLog("$scope.inviterInfo", $scope.inviterInfo);
          if ($scope.inviterInfo && $scope.inviterInfo.nameOnBallot) {
            $scope.inviterName = $scope.inviterInfo.nameOnBallot;
          } else if ($scope.inviterInfo && $scope.inviterInfo.title) {
            $scope.inviterName = $scope.inviterInfo.title;
          } else if ($scope.inviterInfo) {
            $scope.inviterName = $scope.inviterInfo.username;
          }
          $scope.isShare = true;
        }
        $scope.inviterId = window.localStorage.getItem('inviterId');

      }

      if ($cookies.get('showLongPopUp')) {
        var msg = $cookies.get('showLongPopUp');

        var modal = ngDialog.openConfirm({
          template: '<p>' +
            msg +
            '</p>\
                    <div class="ngdialog-buttons">\
                        <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">OK</button>\
                        <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(0)">Cancel</button>\
                    </div>',
          plain: true,
          closeByDocument: false,
          width: "70%"
        });
        modal.then(
          function fullfilled(data) {
            if (data == 1) {
              // MyService.ConsoleLog("yes")
              $cookies.remove('showLongPopUp');
            } else {
              $cookies.remove('showLongPopUp');

            }
          },
          function rejected(data) {

          }
        );
      }

      var param = {};
      param.page = $scope.page;
      param.max_records = $scope.maxRecordsPerPg;

      if ($routeParams.flag) {
        $scope.flag = true;
        // alert('one');
      } else {
        $scope.flag = false;
        // alert('two');
      }

      if (window.localStorage.getItem('quesData')) {

        $rootScope.queData = window.localStorage.getItem('quesData');
        // MyService.ConsoleLog("main Data>>", JSON.parse($rootScope.queData));
      }
      $scope.showGrpFollow = false;
      /**
       * Remove values from localStorage on page load
       */
      window.localStorage.removeItem('comOfPolitician');
      window.localStorage.removeItem('comOfVoter');
      window.localStorage.removeItem('comOfAdv');
      window.localStorage.removeItem('comOfGuest');
      window.localStorage.removeItem('poliAr');
      window.localStorage.removeItem('voter');
      window.localStorage.removeItem('adv');
      window.localStorage.removeItem('unVerify');
      window.localStorage.removeItem('cuUser');


      if (tokenService.getUserId()) {
        // alert('sssss');
        $scope.userData = JSON.parse(tokenService.getUserData());
        MyService.ConsoleLog("$scope.userData >", $scope.userData);
        MyService.ConsoleLog("$scope.userData >", $scope.userData.address);


        // $rootScope.tempUserAddress = "";
        $rootScope.tempUserAddress = $scope.userData.address;
        console.log('$rootScope.tempUserAddress >>> ', $rootScope.tempUserAddress);
        // }

        // var nAddobj = new Object;

        // nAddobj.state = $scope.mainAddress.state.state;
        // nAddobj.stateFips = $scope.mainAddress.state.stateFips;
        // nAddobj.statePostalCode = $scope.mainAddress.state.statePostalCode;

        // nAddobj.county = $scope.mainAddress.county ? $scope.mainAddress.county.county : "";
        // nAddobj.countyFips = $scope.mainAddress.county ? $scope.mainAddress.county.countyFips : "";
        // if ($scope.mainAddress.place && $scope.mainAddress.place != "") {
        //   nAddobj.place = $scope.mainAddress.place.place;
        //   nAddobj.placeFips = $scope.mainAddress.place.placeFips;
        // }

        // nAddobj.federalCongrassionalDist = $scope.mainAddress.federalCongrassionalDist ? $scope.mainAddress.federalCongrassionalDist.CD115FP : "";

        // nAddobj.stateSenateDistrict = $scope.mainAddress.stateSenateDistrict ? $scope.mainAddress.stateSenateDistrict.SLDUST : "";

        // nAddobj.legislativeDistrict = $scope.mainAddress.stateHouseOFRepresentativeDistrict ? $scope.mainAddress.stateHouseOFRepresentativeDistrict.NAMELSAD.replace("State House District ", "") : "";

        // nAddobj.schoolDistrict = $scope.mainAddress.unifiedSchoolDistrictName ? $scope.mainAddress.unifiedSchoolDistrictName.NAME : '';

        // nAddobj.schoolDistrictFips = $scope.mainAddress.unifiedSchoolDistrictName ? $scope.mainAddress.unifiedSchoolDistrictName.UNSDLEA : '';
        // console.log("nAddobj > ", nAddobj);
        // $rootScope.tempUserAddress = nAddobj;
      } else {
        if (window.localStorage.getItem('tempUserAddress')) {
          $rootScope.tempUserAddress = window.localStorage.getItem('tempUserAddress');

          // MyService.ConsoleLog("$rootScope.tempUserAddress >>", $rootScope.tempUserAddress);

          $scope.mainAddress = JSON.parse(angular.copy($rootScope.tempUserAddress));
          // console.log("mainAddress >>> ", $scope.mainAddress);
          var nobj = new Object();

          nobj.state = $scope.mainAddress.state.state;
          nobj.stateFips = $scope.mainAddress.state.stateFips;
          nobj.statePostalCode = $scope.mainAddress.state.statePostalCode;

          nobj.county = $scope.mainAddress.county ? $scope.mainAddress.county.county : '';
          nobj.countyFips = $scope.mainAddress.county ? $scope.mainAddress.county.countyFips : '';
          if ($scope.mainAddress.place && $scope.mainAddress.place != '') {
            nobj.place = $scope.mainAddress.place.place;
            nobj.placeFips = $scope.mainAddress.place.placeFips;
          }

          nobj.federalCongrassionalDist = $scope.mainAddress.federalCongrassionalDist ?
            $scope.mainAddress.federalCongrassionalDist.CD115FP :
            '';

          nobj.stateSenateDistrict = $scope.mainAddress.stateSenateDistrict ?
            $scope.mainAddress.stateSenateDistrict.SLDUST :
            '';

          nobj.legislativeDistrict = $scope.mainAddress.stateHouseOFRepresentativeDistrict ?
            $scope.mainAddress.stateHouseOFRepresentativeDistrict.NAMELSAD.replace(
              'State House District ',
              ''
            ) :
            '';

          nobj.schoolDistrict = $scope.mainAddress.unifiedSchoolDistrictName ?
            $scope.mainAddress.unifiedSchoolDistrictName.NAME :
            '';

          nobj.schoolDistrictFips = $scope.mainAddress.unifiedSchoolDistrictName ?
            $scope.mainAddress.unifiedSchoolDistrictName.UNSDLEA :
            '';
          // console.log("nobj > ", nobj);
          $rootScope.tempUserAddress = nobj;
          MyService.ConsoleLog(' $rootScope.tempUserAddress >', $rootScope.tempUserAddress);
        }
      }


      $scope.changeColor = function (nper, inx, cur_ans) {

        // MyService.ConsoleLog("inx", inx);
        // MyService.ConsoleLog("cur_ans", cur_ans);

        var arrOfCol = {
          "5": "#990000",
          "4": "#cc3300",
          "3": "#ff9933",
          "2": "#ffff00",
          "1": "#99cc00",
          "0": "#00d900"
        };
        var cdiff = Math.abs(inx - cur_ans);

        // console.log("arrOfCol > ", arrOfCol);
        $scope.gr = null;
        switch (true) {
          case (nper >= 100):
            if (cur_ans == inx) {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[0] + " " + nper + "%, #2b4f7f 10%)"
              };
            } else {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[cdiff] + " " + nper + "%, #2b4f7f 10%)"
              };
            }

            // MyService.ConsoleLog("$scope.gr >>", arrOfCol.nper);
            break;
          case (nper >= 80):
            if (cur_ans == inx) {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[0] + " " + nper + "%, #2b4f7f 10%)"
              };
            } else {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[cdiff] + " " + nper + "%, #2b4f7f 10%)"
              };
            }
            break;
          case (nper >= 60):
            if (cur_ans == inx) {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[0] + " " + nper + "%, #2b4f7f 10%)"
              };
            } else {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[cdiff] + " " + nper + "%, #2b4f7f 10%)"
              };
            }
            break;
          case (nper >= 40):
            if (cur_ans == inx) {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[0] + " " + nper + "%, #2b4f7f 10%)"
              };
            } else {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[cdiff] + " " + nper + "%, #2b4f7f 10%)"
              };
            }
            break;
          case (nper >= 20):
            if (cur_ans == inx) {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[0] + " " + nper + "%, #2b4f7f 10%)"
              };
            } else {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[cdiff] + " " + nper + "%, #2b4f7f 10%)"
              };
            }
            break;
          case (nper >= 0):
            if (cur_ans == inx) {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[0] + " " + nper + "%, #2b4f7f 10%)"
              };
            } else {
              $scope.gr = {
                "background": "linear-gradient(to right, " + arrOfCol[cdiff] + " " + nper + "%, #2b4f7f 10%)"
              };
            }
            break;

          default:
            break;
        }
        // MyService.ConsoleLog(" $scope.gr", $scope.gr);
        return $scope.gr;

      };


      /** Return class of background color */

      $scope.getComapreClass = function (match, i) {
        //MyService.ConsoleLog("match: ", match);
        /*if(match == 100)
          return 'ag-green';
      if(match == 0)
          return 'ag-red';
      if(match > 0 && match <100)
          return 'ag-dg'+i;*/
        if (match >= 100) return 'ag-dg1';
        if (match >= 80) return 'ag-dg2';
        if (match >= 60) return 'ag-dg3';
        if (match >= 40) return 'ag-dg4';
        if (match >= 20) return 'ag-dg5';
        if (match >= 0) return 'ag-dg6';

        return 'ag-dg';
      };

      // $scope.getRegisterCompare = function() {
      //   MyService.ConsoleLog("$rootScope.guestMatch >", $rootScope.guestMatch);
      //   MyService.getRegisterUsersOfNation({ "quesArray": $rootScope.guestMatch }).then(function(response) {
      //     MyService.ConsoleLog("Response >>", response);
      //     $scope.currentIndex = 0;
      //     var quedata = response.data.data;

      //     var temp_uids = quedata[0].voterAnswer.map(function(item) {
      //       // console.log("item >>", item);
      //       // console.log("item >>", JSON.parse(item));

      //       if (item) {
      //         console.log("item >>", item);
      //         return item.toString();
      //       }

      //     });

      //     // temp_uids = temp_uids.filter(function(item, pos) {
      //     //   return temp_uids.indexOf(item) == pos;
      //     // });

      //     MyService.ConsoleLog("temp_uids >>", temp_uids);

      //     $scope.compareRegisterGuestUsers({
      //       "userIds": temp_uids,
      //       "guest": $rootScope.guestMatch,
      //       "userData": $scope.userId
      //     })

      //   }, function(err) {
      //     MyService.ConsoleLog("Error >>", err);
      //   });
      // }


      /**
       * This function calls on page load
       * fetch data of user's area politician ,voters and advocates
       */

      $scope.getLocalPoliticians = function (id) {
        MyService.ConsoleLog("window.localStorage.getItem('comData')", window.localStorage.getItem('comData'));
        MyService.ConsoleLog("Id", id);
        if (!id) {
          $scope.loaders = true;

        } else {
          $scope.loadernew = true;

        }

        // MyService.ConsoleLog(" welcome to getLocalPoliticians ", $rootScope.queData);
        $scope.statusGetLocalPoliticians = 1;
        $scope.page += 1;
        $scope.loader = true;
        // MyService.ConsoleLog("$rootScope.tempUserA ******* ", $rootScope.tempUserAddress);
        // MyService.ConsoleLog("$rootScope.tempUserA ******* ", $rootScope.tempUserAddress.state)
        var extradata = new Object();
        if ($rootScope.tempUserAddress) {
          if ($rootScope.tempUserAddress.state && $rootScope.tempUserAddress.state != '') {
            extradata.statePostalCode = $rootScope.tempUserAddress.statePostalCode;
          }
          if ($rootScope.tempUserAddress.county && $rootScope.tempUserAddress.countyFips) {
            $rootScope.tempUserAddress.FinalData = JSON.stringify(
              $rootScope.tempUserAddress.countyFips
            );
            extradata.county = $rootScope.tempUserAddress.county;
          }
          if (
            $rootScope.tempUserAddress.countySubdivision &&
            $rootScope.tempUserAddress.countySubdivisionFips
          ) {
            $rootScope.tempUserAddress.FinalData = JSON.stringify(
              $rootScope.tempUserAddress.countySubdivisionFips
            );
            extradata.countySubdivision = $rootScope.tempUserAddress.countySubdivision;
          }
          if ($rootScope.tempUserAddress.place && $rootScope.tempUserAddress.placeFips) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.place = $rootScope.tempUserAddress.place;
          }
          if (
            $rootScope.tempUserAddress.voterDistrict &&
            $rootScope.tempUserAddress.voterDistrictFips
          ) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.voterDistrict = $rootScope.tempUserAddress.voterDistrict;
          }
          if ($rootScope.tempUserAddress.federalCongrassionalDist) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            MyService.ConsoleLog(
              'federalCongrassionalDist  :',
              $rootScope.tempUserAddress.federalCongrassionalDist
            );
            extradata.federalCongrassionalDist =
              $rootScope.tempUserAddress.federalCongrassionalDist;
          }
          if ($rootScope.tempUserAddress.stateSenateDistrict) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.stateSenateDistrict = $rootScope.tempUserAddress.stateSenateDistrict;
          }
          if ($rootScope.tempUserAddress.legislativeDistrict) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.legislativeDistrict = $rootScope.tempUserAddress.legislativeDistrict;
          }
          if ($rootScope.tempUserAddress.schoolDistrict) {
            //$rootScope.tempUserAddress.FinalData = JSON.stringify($rootScope.tempUserAddress.place._id);
            extradata.schoolDistrict = $rootScope.tempUserAddress.schoolDistrict;
          }
        }
        MyService.ConsoleLog('extradata : >>>>>>>>>> ', JSON.stringify(extradata));
        MyService.getAllLocalPoli({
          max_records: 100,
          page: $scope.page,
          extradata: JSON.stringify(extradata),
        }).then(
          function (response) {
            if (response.data.success) {
              setTimeout(function () {
                $scope.$apply(function () {
                  if (response.data.data.length > 0) {
                    MyService.getAdvocates().then(function (payload) {
                      MyService.ConsoleLog("Response >", payload);
                      var ndata = response.data.data;
                      var wdata = ndata.concat(payload.data.data);

                      if (window.localStorage.getItem('inviterId') || $cookies.get('quizTakerId') || $cookies.get('quizTakerIdsArr')) {
                        $scope.userAreaPolitician = [];
                        if (window.localStorage.getItem('inviterId') && !$cookies.get('quizTakerIdsArr')) {
                          $scope.userAreaPolitician.push(window.localStorage.getItem('inviterId'));
                          var param = JSON.stringify({
                            usersIds: $scope.userAreaPolitician,
                            cur_userId: $scope.userId,
                            questions: $rootScope.queData
                          });

                          // MyService.ConsoleLog("apra >", param);
                          // window.localStorage.removeItem('comData');
                          window.localStorage.setItem('comData', param);
                        } else if ($cookies.get('quizTakerIdsArr') || $cookies.get('quizTakerId')) {
                          // MyService.ConsoleLog("check now yogesh >>>>>>>>>>", JSON.parse($cookies.get('quizTakerIdsArr')));
                          if ($cookies.get('quizTakerId')) {
                            $scope.userAreaPolitician.push($cookies.get('quizTakerId'));
                          } else {
                            $scope.userAreaPolitician = JSON.parse($cookies.get('quizTakerIdsArr'));
                          }

                          if ($scope.userAreaPolitician && $scope.userAreaPolitician.length > 1) {
                            $scope.showGrpFollow = true;
                          } else {
                            $scope.showGrpFollow = false;
                          }
                          var param = JSON.stringify({
                            usersIds: $scope.userAreaPolitician,
                            cur_userId: $scope.userId,
                            questions: $rootScope.queData
                          });
                          window.localStorage.setItem('comData', param);
                        }

                      }
                      // else {
                      //   $scope.userAreaPolitician = wdata.map(function (ques) {
                      //     return ques._id;
                      //   });
                      //   var param = JSON.stringify({
                      //     usersIds: $scope.userAreaPolitician,
                      //     cur_userId: $scope.userId,
                      //     questions: $rootScope.queData
                      //   });

                      //   // MyService.ConsoleLog("apra >", param);
                      //   // window.localStorage.removeItem('comData');
                      //   window.localStorage.setItem('comData', param);
                      // }
                      MyService.ConsoleLog(" $scope.userAreaPolitician >", $scope.userAreaPolitician);

                      var indx;
                      if (id && id != "") {
                        indx = id;
                        MyService.ConsoleLog("Inds >>>>>>>>", indx);
                      } else {
                        $scope.currentIndex = 0;
                        indx = $scope.currentIndex;
                        MyService.ConsoleLog(" $scope.currentIndex >", indx);
                      }
                      // alert('called');

                      var main = JSON.parse($rootScope.queData);
                      MyService.ConsoleLog(' $scope.quData :', main[indx]);
                      if ($cookies.get('quizTakerId')) {
                        $scope.compareRegisterGuestUsers({
                          userIds: JSON.stringify($scope.userAreaPolitician),
                          guest: JSON.stringify(main[indx]),
                          userData: $scope.userId,
                          quizTakerId: $cookies.get('quizTakerId')
                        });
                      } else if ($cookies.get('quizTakerIdsArr')) {
                        $scope.compareRegisterGuestUsers({
                          userIds: JSON.stringify($scope.userAreaPolitician),
                          guest: JSON.stringify(main[indx]),
                          userData: $scope.userId,
                          quizTakerIdsArr: $cookies.get('quizTakerId')
                        });
                      }

                    }, function (err) {
                      MyService.ConsoleLog("Error >>", err);
                    });
                  } else {
                    $scope.loader = false;
                    var message =
                      'None of your politicians have answered the questions yet. Contact them and ask them to fill it out.';
                    var modal = ngDialog.openConfirm({
                      template: '<p>' +
                        message +
                        '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">OK</button>\
                            \
                        </div>',
                      plain: true,
                    });

                    modal.then(
                      function fullfilled(data) {
                        //MyService.ConsoleLog("fullfilled: ", data);
                        if (data == 1) {
                          $scope.postonFacebook();
                        } else {
                          if ($rootScope.userRole) {
                            $location.path('/snapshot');
                          } else {
                            $location.path('/signin');
                          }
                        }
                      },
                      function rejected(data) {
                        //MyService.ConsoleLog("rejected: ", data);
                      }
                    );
                  }
                });
              }, 100);
            } else {
              $scope.page -= 1;
              $scope.statusGetLocalPoliticians = 3;
              if (typeof response.data.error == 'string') growl.error(response.data.error);
              else growl.error('Something went wrong');
            }
          },
          function (err) {
            $scope.page -= 1;
            $scope.statusGetLocalPoliticians = 3;
            $scope.loader = false;
            growl.error(err);
          }
        );
      };

      /**End of getLocalPoliticians */

      if (tokenService.getUserId()) {
        $scope.getLocalPoliticians();
      } else {
        MyService.getAllUsersOfNation({
          quesArray: $rootScope.guestMatch,
        }).then(
          function (response) {
            // MyService.ConsoleLog("Response >>", response);

            $scope.currentIndex = 0;
            var quedata = response.data.data;
            MyService.ConsoleLog('quedata >>', quedata);
            var temp_uids = quedata[0].voterAnswer.map(function (item) {
              // console.log("item >>", item);
              // console.log("item >>", JSON.parse(item));

              if (item) {
                // console.log("item >>", item);
                return item.toString();
              }
            });
            // MyService.ConsoleLog("temp_uids >",temp_uids);
            $scope.getCompareGuest(temp_uids);
          },
          function (err) {
            MyService.ConsoleLog('Error >>', err);
          }
        );
      }

      /**
       * This function redirects to show answers page
       */

      $scope.showAnswers = function (ans, type, qId, chAns, ind) {
        MyService.ConsoleLog("Ind", ind);
        MyService.ConsoleLog("qId", qId);

        if (!ind) {
          ind = 0;
        }
        if (chAns) {
          if (!chAns[ind + 1]) {
            // alert("This");
            growl.error("No users to see here");
          } else {
            // if (chAns != "") {
            //   alert('dahdaj');
            // }
            MyService.ConsoleLog("Type >>", type);
            MyService.ConsoleLog("qId >>", qId);
            MyService.ConsoleLog("chAns >>", chAns);

            $location.path('/showAnswers/' + type + '/' + ans + '/' + qId + '/' + chAns);
          }
        } else {
          // alert('not Found');
          switch (type) {
            case 'politician':
              growl.error('None of politicians of your area answered for this question');
              break;
            case 'voter':
              growl.error('None of voter of your area answered for this question');
              break;
            case 'advocate':
              growl.error('None of organizations of your area answered for this question');
              break;

            default:

              break;
          }
        }
      };

      /**
       * This function show the details of answered questions
       * showAnswersDetail
       */

      $scope.showAnswersDetail = function (para) {
        MyService.ConsoleLog('para >', para);

        switch (para) {
          case 'politician':

            // if ($scope.showGrpFollow) {
            //   // MyService.ConsoleLog("$scope.arrayOfCom", $scope.arrayOfCom[$scope.questions[$scope.currentIndex]._id].length);
            //   if ($scope.arrayOfCom && $scope.arrayOfCom[$scope.questions[$scope.currentIndex]._id]) {
            //     if ($scope.advComArr && $scope.advComArr[$scope.questions[$scope.currentIndex]._id]) {
            //       $scope.arrayOfCom[$scope.questions[$scope.currentIndex]._id] = $scope.arrayOfCom[$scope.questions[$scope.currentIndex]._id].concat($scope.advComArr[$scope.questions[$scope.currentIndex]._id]);
            //     }
            //     if ($scope.voterComArr && $scope.voterComArr[$scope.questions[$scope.currentIndex]._id]) {
            //       $scope.arrayOfCom[$scope.questions[$scope.currentIndex]._id] = $scope.arrayOfCom[$scope.questions[$scope.currentIndex]._id].concat($scope.voterComArr[$scope.questions[$scope.currentIndex]._id]);
            //     }
            //     // console.log('$scope.arrayOfCom  :', $scope.arrayOfCom);
            //     var newObjs = JSON.stringify({
            //       poli: $scope.arrayOfCom,
            //       qId: $scope.questions[$scope.currentIndex]._id
            //     });
            //     MyService.ConsoleLog("newObj", JSON.parse(newObjs));
            //     window.localStorage.setItem('poliAr', newObjs);
            //   } else if ($scope.voterComArr && $scope.voterComArr[$scope.questions[$scope.currentIndex]._id]) {
            //     if ($scope.advComArr && $scope.advComArr[$scope.questions[$scope.currentIndex]._id]) {
            //       $scope.voterComArr[$scope.questions[$scope.currentIndex]._id] = $scope.voterComArr[$scope.questions[$scope.currentIndex]._id].concat($scope.advComArr[$scope.questions[$scope.currentIndex]._id]);
            //     }

            //     if ($scope.arrayOfCom && $scope.arrayOfCom[$scope.questions[$scope.currentIndex]._id]) {
            //       $scope.voterComArr[$scope.questions[$scope.currentIndex]._id] = $scope.voterComArr[$scope.questions[$scope.currentIndex]._id].concat($scope.arrayOfCom[$scope.questions[$scope.currentIndex]._id]);
            //     }
            //     var vObj = JSON.stringify({
            //       vot: $scope.voterComArr,
            //       qId: $scope.questions[$scope.currentIndex]._id
            //     });
            //     window.localStorage.setItem('voter', vObj);
            //   } else if ($scope.advComArr) {

            //     if ($scope.voterComArr && $scope.voterComArr[$scope.questions[$scope.currentIndex]._id]) {
            //       $scope.advComArr[$scope.questions[$scope.currentIndex]._id] = $scope.advComArr[$scope.questions[$scope.currentIndex]._id].concat($scope.voterComArr[$scope.questions[$scope.currentIndex]._id]);
            //     }

            //     if ($scope.arrayOfCom && $scope.arrayOfCom[$scope.questions[$scope.currentIndex]._id]) {
            //       $scope.advComArr[$scope.questions[$scope.currentIndex]._id] = $scope.advComArr[$scope.questions[$scope.currentIndex]._id].concat($scope.arrayOfCom[$scope.questions[$scope.currentIndex]._id]);
            //     }

            //     var advo = JSON.stringify({
            //       adv: $scope.advComArr,
            //       qId: $scope.questions[$scope.currentIndex]._id
            //     });
            //     window.localStorage.setItem('adv', advo);
            //   }
            // } else {
            var newObj = JSON.stringify({
              poli: $scope.arrayOfCom,
              qId: $scope.questions[$scope.currentIndex]._id
            });
            MyService.ConsoleLog("newObj", newObj);
            window.localStorage.setItem('poliAr', newObj);
            // }
            $location.path('/followersGroupAnswer');
            // $scope.showPoliAnswerDetails = true;
            break;
          case 'unRegister':
            var unObj = JSON.stringify({
              unVeri: $scope.unVeriComm,
              qId: $scope.questions[$scope.currentIndex]._id
            });
            window.localStorage.setItem('unVerify', unObj);
            $location.path('/followersGroupAnswer');
            // $scope.showUserAnswerDetails = true;
            break;
          case 'voter':
            var vObj = JSON.stringify({
              vot: $scope.voterComArr,
              qId: $scope.questions[$scope.currentIndex]._id
            });
            window.localStorage.setItem('voter', vObj);
            $location.path('/followersGroupAnswer');
            // $scope.showPoliAnswerDetails = true;
            break;
          case 'advocate':
            var advo = JSON.stringify({
              adv: $scope.advComArr,
              qId: $scope.questions[$scope.currentIndex]._id
            });
            window.localStorage.setItem('adv', advo);
            $location.path('/followersGroupAnswer');
            // $scope.showPoliAnswerDetails = true;
            break;
          default:

            break;
        }

        // if (para == 'politician') {
        //   $scope.showPoliAnswerDetails = true;
        // } else {
        //   $scope.showUserAnswerDetails = true;
        // }
      };

      /**End Of showAnswersDetail */

      $scope.getCompareGuest = function (params) {
        // MyService.ConsoleLog("params >", params);
        console.log("$rootScope.guestMatch", $rootScope.guestMatch);
        MyService.compareGuest({
          comparewith: params,
          guest: $rootScope.guestMatch
        }).then(
          function (payload) {
            if (payload.data.success) {
              MyService.ConsoleLog('CompareWithAllPolitcians >> ', payload.data.data);
              $scope.emailRegistered = payload.data.data.agrriOfEmail;
              $scope.unVerified = payload.data.data.aggriOfUnVerified;
              $scope.emailImpo = payload.data.data.aggriOfEmailImportance;
              $scope.unVeriImpo = payload.data.data.aggriUnVerifiedImportance;
              // $scope.questions = payload.data.data.qdata;
              $scope.questions = JSON.parse($rootScope.queData);
              MyService.ConsoleLog('$scope.questions ONE>>>', $scope.questions);
              $scope.FBCompareList = payload.data.data.qdata;
              $scope.ansCount = payload.data.data.ansCount;
              $scope.unCount = payload.data.data.unCount;
              $scope.impCount = payload.data.data.impCount;
              $scope.unImpCount = payload.data.data.unImpCount;
              $scope.flagOfUnVerified = payload.data.data.flagOfUnVerified;
              // MyService.ConsoleLog('ansCount >', $scope.impCount);
              $scope.globalFlag = payload.data.data.checkFlag;
              $scope.arrayOfCom = payload.data.data.commArr;
              $scope.unVeriComm = payload.data.data.unVeriComm;
              MyService.ConsoleLog("Object.keys(payload.data.data.agrriOfEmail).length", Object.keys(payload.data.data.agrriOfEmail).length);
              MyService.ConsoleLog("aggriOfUnVerified", Object.keys(payload.data.data.aggriOfUnVerified).length);
              if (Object.keys(payload.data.data.agrriOfEmail).length == 0 && Object.keys(payload.data.data.aggriOfUnVerified).length == 0 && payload.data.data.agrriOfEmail.constructor == Object && payload.data.data.aggriOfUnVerified.constructor == Object) {
                // alert("called");
                var message = "'”Congratulations!!  You are the first person to take this quiz! ";
                var modal = ngDialog.openConfirm({
                  template: '<p>' +
                    message +
                    '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">OK</button>\
                            \
                        </div>',
                  plain: true,
                });
                modal.then(
                  function fullfilled(data) {
                    //MyService.ConsoleLog("fullfilled: ", data);
                    if (data == 0) {
                      // if (tokenService.getUserRole() == 'voter') {
                      $location.path('/learnHome');
                      // } else if (tokenService.getUserRole() == 'politician') {
                      //   $location.path('/winVoters');
                      // }

                    }
                  },
                  function rejected(data) {
                    //MyService.ConsoleLog("rejected: ", data);
                  }
                );
              }
              // if () {
              //   alert("second");
              // }
              // MyService.ConsoleLog(' $scope.unVeriComm >', $scope.unVeriComm);
              // MyService.ConsoleLog('$scope.flagOfUnVerified >', $scope.flagOfUnVerified);
              // MyService.ConsoleLog(' $scope.globalFlag >', $scope.globalFlag);

              $scope.flag = true;
              if ($scope.FBCompareList && $scope.FBCompareList.length > 0) {
                $scope.FBunWeighted = payload.data.data.unweightedMatch;
                $scope.fbcombinedWeight = payload.data.data.fbcombinedWeight;
                $scope.fbmultiplier = payload.data.data.fbmultiplier;
                $scope.answeredQuestions = payload.data.data.answeredQuestions;
                $scope.fbqlen = payload.data.data.qlen;
                $scope.AllUsers = payload.data.data.AllUsers;

                var mainData = JSON.stringify(payload.data.data);
                // MyService.ConsoleLog("mainData >>", mainData);
                window.localStorage.setItem('Data', mainData);
                //$scope.qData = payload.data.data.answeredQuestions;
              } else {
                var message = "'”Congratulations!!  You are the first person in your area to take this quiz! ";
                var modal = ngDialog.openConfirm({
                  template: '<p>' +
                    message +
                    '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">OK</button>\
                            \
                        </div>',
                  plain: true,
                });
                //alert("Looks like your friends have not yet answered the questions.");
                // MyService.ConsoleLog("No politicians found, check incumbent");
                /*MyService.compareFiveMinAnswers({
              "userdata": JSON.stringify($rootScope.fiveMatch),
              "comparewith": JSON.stringify($scope.userAreaPolitician),
              type: "incumbent"
            }).then(function(payload) {
                if (payload.data.success) {
                  MyService.ConsoleLog("incumbent data :> ", payload.data.data);
                  $scope.questions = payload.data.data.qdata;
                  $scope.FBCompareList = payload.data.data.qdata;
                  if ($scope.FBCompareList && $scope.FBCompareList.length > 0) {
                    $scope.FBunWeighted = payload.data.data.unweightedMatch;
                    $scope.fbcombinedWeight = payload.data.data.fbcombinedWeight;
                    $scope.fbmultiplier = payload.data.data.fbmultiplier;
                    $scope.answeredQuestions = payload.data.data.answeredQuestions;
                    $scope.fbqlen = payload.data.data.qlen;
                    $scope.AllUsers = payload.data.data.AllUsers;
                  } else {
                    // MyService.ConsoleLog("No politicians and incumbent found, check voters");
                    $scope.hideName = true;
                    // Show only popup if no politicians and incubents
                    var message = "None of your politicians have answered the questions yet. Contact them and ask them to fill it out.";
                    var modal = ngDialog.openConfirm({
                      template: '<p>' + message + '</p>\
                  <div class="ngdialog-buttons">\
                      <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">OK</button>\
                      \
                  </div>',
                      plain: true
                    });

                    modal.then(function fullfilled(data) {
                      //MyService.ConsoleLog("fullfilled: ", data);
                      if (data == 1) {
                        $scope.postonFacebook();
                      } else {
                        if ($rootScope.userRole) {
                          $location.path('/snapshot');
                        } else {
                          $location.path('/signin');
                        }
                      }
                    }, function rejected(data) {
                      //MyService.ConsoleLog("rejected: ", data);
                    });
                    return;
                  }
                }
              },
              function(errorpayload) {
                MyService.ConsoleLog(errorpayload);
              });*/
              }
            } else {
              $scope.showAlert = true;
              // alert("Something went wrong.");
              $scope.loaders = false;
            }
          },
          function (err) {
            MyService.ConsoleLog('Error >', err);
          }
        );
      };
      $scope.loadernew = false;

      /** This function fetch comparison results using
       ** @ Params @
       ** guest user data and politician data
       **/

      $scope.compareRegisterGuestUsers = function (params) {

        MyService.ConsoleLog('Params >>', params);

        MyService.compareRegisterGuestUsers(params).then(
          function (payload) {
            MyService.ConsoleLog('Response >>>', payload);

            if (payload.data.success) {
              $scope.loadernew = false;
              $scope.loaders = false;
              if (window.localStorage.getItem('inviterInfo')) {
                $scope.inviterData = JSON.parse(window.localStorage.getItem('inviterInfo'));
              }

              // MyService.ConsoleLog("CompareWithAllPolitcians >> ", payload.data.data.qdata);
              // if (Object.keys(payload.data.data.agrriOfEmail).length == 0 || Object.keys(payload.data.data.aggriOfVoter).length == 0 || Object.keys(payload.data.data.aggriOfAdvocate).length == 0 || Object.keys(payload.data.data.aggriOfUnVerified).length == 0) {
              $scope.emailRegistered = "";
              if ($scope.inviterData && $scope.inviterData.userType == 'politician' && (JSON.stringify(payload.data.data.agrriOfEmail) !=
                  JSON.stringify({}))) {
                $scope.emailRegistered = payload.data.data.agrriOfEmail;
              } else if ($cookies.get('quizTakerIdsArr') && (JSON.stringify(payload.data.data.agrriOfEmail) !=
                  JSON.stringify({}))) {
                $scope.emailRegistered = payload.data.data.agrriOfEmail;
              } else if (!$scope.inviterData && (JSON.stringify(payload.data.data.agrriOfEmail) !=
                  JSON.stringify({}))) {
                $scope.emailRegistered = payload.data.data.agrriOfEmail;
              }


              // $scope.unVerified = payload.data.data.aggriOfUnVerified;
              $scope.emailImpo = payload.data.data.aggriOfEmailImportance;

              $scope.questions = JSON.parse($rootScope.queData);
              MyService.ConsoleLog("JSON.parse($rootScope.queData)", JSON.parse($rootScope.queData));
              MyService.ConsoleLog('$scope.questions TWo >>>', $scope.questions);
              $scope.FBCompareList = payload.data.data.qdata;
              $scope.ansCount = payload.data.data.ansCount;

              $scope.impCount = payload.data.data.impCount;

              $scope.flagOfUnVerified = payload.data.data.flagOfUnVerified;
              // MyService.ConsoleLog('ansCount >', $scope.impCount);
              $scope.globalFlag = payload.data.data.checkFlag;
              $scope.arrayOfCom = payload.data.data.commArr;

              $scope.voter = "";
              if ($scope.inviterData && $scope.inviterData.userType == 'voter' && (JSON.stringify(payload.data.data.aggriOfVoter) !=
                  JSON.stringify({}))) {
                MyService.ConsoleLog("<<<<<<<<<<<<<<<<<<<>>>>>>>>>>>>>>>>>>>>", JSON.stringify(payload.data.data.aggriOfVoter));
                $scope.voter = payload.data.data.aggriOfVoter;
              } else if ($cookies.get('quizTakerIdsArr') && (JSON.stringify(payload.data.data.aggriOfVoter) !=
                  JSON.stringify({}))) {
                $scope.voter = payload.data.data.aggriOfVoter;
              } else if (!$scope.inviterData && JSON.stringify(payload.data.data.aggriOfVoter) != JSON.stringify({})) {
                $scope.voter = payload.data.data.aggriOfVoter;
                MyService.ConsoleLog("else", JSON.stringify(payload.data.data.aggriOfVoter));
              }
              MyService.ConsoleLog(">>>>>>>>>>>>>>>>>>>>", $scope.voter);
              $scope.voterImp = payload.data.data.aggriOfVoterImportance;
              $scope.voterAnsCount = payload.data.data.voterAnsCount;
              $scope.voterImpCount = payload.data.data.voterImpCount;
              $scope.flagOfVoter = payload.data.data.voterFlag;
              $scope.voterComArr = payload.data.data.voterComArr;
              $scope.advocate = "";
              if ($scope.inviterData && $scope.inviterData.title && (JSON.stringify(payload.data.data.aggriOfAdvocate) !=
                  JSON.stringify({}))) {
                $scope.advocate = payload.data.data.aggriOfAdvocate;
              } else if ($cookies.get('quizTakerIdsArr') && (JSON.stringify(payload.data.data.aggriOfAdvocate) !=
                  JSON.stringify({}))) {
                $scope.advocate = payload.data.data.aggriOfAdvocate;
              } else if (!$scope.inviterData && (JSON.stringify(payload.data.data.aggriOfAdvocate) !=
                  JSON.stringify({}))) {
                $scope.advocate = payload.data.data.aggriOfAdvocate;
              }

              $scope.advocateAns = payload.data.data.advocateObj;
              $scope.advocateImpAggri = payload.data.data.aggriOfAdvocateImportance;
              $scope.advocateimpObj = payload.data.data.advocateimpObj;
              $scope.advocateFlag = payload.data.data.advFlag;
              $scope.advComArr = payload.data.data.advcommArr;
              // $scope.questions = payload.data.data.qdata;
              // MyService.ConsoleLog("$scope.questions >>>", $scope.questions);
              $scope.FBCompareList = payload.data.data.qdata;
              $scope.flag = true;
              if ($scope.FBCompareList && $scope.FBCompareList.length > 0) {
                $scope.FBunWeighted = payload.data.data.unweightedMatch;
                $scope.fbcombinedWeight = payload.data.data.fbcombinedWeight;
                $scope.fbmultiplier = payload.data.data.fbmultiplier;
                $scope.answeredQuestions = payload.data.data.answeredQuestions;
                $scope.fbqlen = payload.data.data.qlen;
                $scope.AllUsers = payload.data.data.AllUsers;
                var mainData = JSON.stringify(payload.data.data);
                // MyService.ConsoleLog("mainData >>", mainData);
                window.localStorage.setItem('Data', mainData);

                if (JSON.stringify($scope.emailRegistered) == JSON.stringify({}) && JSON.stringify($scope.voter) == JSON.stringify({}) && JSON.stringify($scope.advocate) == JSON.stringify({}) && JSON.stringify($scope.unVerified) == JSON.stringify({})) {
                  // alert('got')
                  var message = '”Congratulations!!  You are the first person in your area to take this quiz!  You are at the forefront of democracy!”';
                  MyService.ConsoleLog("getUserRole >", tokenService.getUserRole());
                  // var repath;

                  var modal = ngDialog.openConfirm({
                    template: '<p>' +
                      message +
                      '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">OK</button>\
                            \
                        </div>',
                    plain: true,
                  });

                  modal.then(
                    function fullfilled(data) {
                      //MyService.ConsoleLog("fullfilled: ", data);
                      if (data == 0) {
                        if (tokenService.getUserRole() == 'voter') {
                          $location.path('/learnHome');
                        } else if (tokenService.getUserRole() == 'politician') {
                          $location.path('/winVoters');
                        }

                      }
                    },
                    function rejected(data) {
                      //MyService.ConsoleLog("rejected: ", data);
                    }
                  );
                }

              }
              //$scope.qData = payload.data.data.answeredQuestions;
              // } else {
              //   alert('got');
              // }
            } else {
              $scope.showAlert = true;
              var message = '”Congratulations!!  You are the first person in your area to take this quiz!  You are at the forefront of democracy!”';
              MyService.ConsoleLog("getUserRole >", tokenService.getUserRole());
              // var repath;

              var modal = ngDialog.openConfirm({
                template: '<p>' +
                  message +
                  '</p>\
                    <div class="ngdialog-buttons">\
                        <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">OK</button>\
                        \
                    </div>',
                plain: true,
              });

              modal.then(
                function fullfilled(data) {
                  //MyService.ConsoleLog("fullfilled: ", data);
                  if (data == 0) {
                    if (tokenService.getUserRole() == 'voter') {
                      $location.path('/learnHome');
                    } else if (tokenService.getUserRole() == 'politician') {
                      $location.path('/winVoters');
                    }

                  }
                },
                function rejected(data) {
                  //MyService.ConsoleLog("rejected: ", data);
                }
              );
              // alert("Something went wrong.");
            }
          },
          function (error) {
            MyService.ConsoleLog('Error >>', error);
          }
        );
      };

      /**This function redirects to show comment page */
      $scope.viewAnsComment = function (val) {
        MyService.ConsoleLog('called', val);

        switch (val) {
          case 'email':
            $scope.global = $scope.arrayOfCom;
            if ($scope.userId) {
              var poli = JSON.stringify({
                poliArr: $scope.arrayOfCom,
                queId: $scope.questions[$scope.currentIndex]._id
              });
              window.localStorage.setItem('comOfPolitician', poli);
              $location.path('/showComments');
            }
            $scope.showComment = true;
            $scope.unComment = false;
            $scope.showCurr = false;

            break;
          case 'unRegister':
            if ($scope.userId) {
              var guest = JSON.stringify({
                guestArr: $scope.unVeriComm,
                queId: $scope.questions[$scope.currentIndex]._id
              });
              window.localStorage.setItem('comOfGuest', guest);
              $location.path('/showComments');
            }
            $scope.unComment = true;
            $scope.showComment = false;
            $scope.showCurr = false;

            break;
          case 'voter':
            $scope.global = $scope.voterComArr;
            // MyService.ConsoleLog("$scope.voterComArr", $scope.voterComArr);
            if ($scope.userId) {
              var vo = JSON.stringify({
                compArr: $scope.voterComArr,
                queId: $scope.questions[$scope.currentIndex]._id
              });
              // MyService.ConsoleLog("vo >>", vo);
              window.localStorage.setItem('comOfVoter', vo);
              $location.path('/showComments');
            }
            $scope.showComment = true;
            $scope.unComment = false;
            $scope.showCurr = false;

            break;
          case 'advocate':
            $scope.global = $scope.advComArr;
            if ($scope.userId) {
              var adv = JSON.stringify({
                advArr: $scope.advComArr,
                queId: $scope.questions[$scope.currentIndex]._id
              });
              window.localStorage.setItem('comOfAdv', adv);
              $location.path('/showComments');
            }
            $scope.showComment = true;
            $scope.unComment = false;
            $scope.showCurr = false;

            break;
          case 'currentUser':
            if ($scope.userId) {
              var curUser = JSON.stringify({
                curuser: $scope.questions[$scope.currentIndex]
              });
              window.localStorage.setItem('cuUser', curUser);
              $location.path('/showComments');
            }
            $scope.showComment = false;
            $scope.showCurr = true;
            $scope.unComment = false;
            break;
          default:

            break;
        }
      };
      $scope.back = function () {
        $scope.showPoliAnswerDetails = false;
        $scope.showUserAnswerDetails = false;
        $scope.showComment = false;
        $scope.unComment = false;
        $scope.showCurr = false;

      };

      $scope.status = {
        questions: 0, //1=loading, 2=loaded, 3=error
        category: 0,
      };

      var getCompareAnswersCanceler = $q.defer();

      $scope.getCompareAnswers = function (params) {
        console.log('params: ', params);

        if (!params) return;
        getCompareAnswersCanceler.resolve();

        getCompareAnswersCanceler = $q.defer();
        $scope.questions = [];
        $scope.status.questions = 1;

        MyService.getCompareAns(params, getCompareAnswersCanceler.promise).then(
          function successCallback(response) {
            console.log('response: ', response);
            //MyService.ConsoleLog("Got categories: ",response);
            if (response.data.success) {
              if (response.data.data.length > 0) {
                $scope.status.questions = 2;
                angular.forEach(response.data.data, function (val, key) {
                  if (val.answers && val.answers.length != $rootScope.selectedCompareUsers.length) {
                    var check_author_exist = function (u) {
                      var len = val.answers.length;
                      for (var i = 0; i < len; i++) {
                        if (val.answers[i].author._id == u) {
                          return true;
                        }
                      }
                      return false;
                    };

                    angular.forEach($rootScope.selectedCompareUsers, function (u, i) {
                      if (!check_author_exist(u)) {
                        response.data.data[key].answers.push({
                          author: u,
                        });
                      }
                    });
                  } else if (!val.answers) {
                    response.data.data[key].answers = [];
                    angular.forEach($rootScope.selectedCompareUsers, function (u, i) {
                      response.data.data[key].answers.push({
                        author: u,
                      });
                    });
                  }
                });

                $scope.questions = response.data.data;
                console.log('$scope.questions: ', $scope.questions);
              }
              // $location.path("question-compare/"+$routeParams.category_id+"/"+null);
            } else {
              $scope.status.questions = 3;
              //MyService.ConsoleLog("Something went wrong: ", response.data);
            }
          },
          function errorCallBack(response) {
            $scope.status.questions = 3;
            //MyService.ConsoleLog("Error: ", response);
          }
        );
      };

      $scope.finalSignIn = function () {

        $location.path('/fiveSaveUser');
      };

      /**
       * This function filter comment data
       */
      $scope.getItems = function () {
        return function (u) {
          MyService.ConsoleLog("params >", u);

          if (u.comment && u.comment != "") {
            return u;
          }
        };
      };

      $scope.getComment = function () {
        return function (x) {
          if (x.comment && x.comment != "") {
            return x;
          }
        };
      };

      /**
       **
       ** This function fetched matched answers for guest
       **/

      /* var getGuestCompareCanceler = $q.defer();

    $scope.getGuestCompare = function(params) {

      console.log("params: ", params);

      if (!params) return;
      getGuestCompareCanceler.resolve();

      getGuestCompareCanceler = $q.defer();
      $scope.questions = [];
      $scope.status.questions = 1;

      MyService.getGuestCompareAns(params, getGuestCompareCanceler.promise)
        .then(function successCallback(response) {
          console.log('response: ', response);
          //MyService.ConsoleLog("Got categories: ",response);
          if (response.data.success) {
            if (response.data.data.length > 0) {
              $scope.status.questions = 2;
              angular.forEach(response.data.data, function(val, key) {
                if (val.answers && val.answers.length != $rootScope.selectedCompareUsers.length) {
                  var check_author_exist = function(u) {
                    var len = val.answers.length;
                    for (var i = 0; i < len; i++) {
                      if (val.answers[i].author._id == u) {
                        return true;
                      }
                    }
                    return false;
                  };

                  angular.forEach($rootScope.selectedCompareUsers, function(u, i) {
                    if (!check_author_exist(u)) {
                      response.data.data[key].answers.push({
                        author: u
                      });
                    }
                  });
                } else if (!val.answers) {
                  response.data.data[key].answers = [];
                  angular.forEach($rootScope.selectedCompareUsers, function(u, i) {
                    response.data.data[key].answers.push({
                      author: u
                    });
                  });
                }
              });

              $scope.questions = response.data.data;
              console.log('$scope.questions: ', $scope.questions);
            }
            // $location.path("question-compare/"+$routeParams.category_id+"/"+null);
          } else {
            $scope.status.questions = 3;
            //MyService.ConsoleLog("Something went wrong: ", response.data);
          }
        }, function errorCallBack(response) {
          $scope.status.questions = 3;
          //MyService.ConsoleLog("Error: ", response);
        });
    };
*/

      $scope.prevQuestion = function () {
        //MyService.ConsoleLog("** prevQuestion **");

        $("html, body").animate({
          scrollTop: $("#DisplayQ").offset().top - 280
        }, "slow");
        if ($scope.currentIndex > 0) {
          var decr = $scope.currentIndex--;
          var one = decr - 1;
          MyService.ConsoleLog("decr", one);
          if ($scope.userId) {
            $scope.getLocalPoliticians(one);
          }
        } else if ($scope.currentIndex == 0) {
          if ($scope.currBackgroundIndex > 0) {
            $scope.currBackgroundIndex--;
            MyService.ConsoleLog('$scope.traverseBackgrounds >', $scope.traverseBackgrounds);
            $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
          } else {
            //MyService.ConsoleLog("** end of background **");
            if ($scope.rootCatIndex > 0) {
              $scope.rootCatIndex--;
              $location.path(
                '/question-compare/all/' + $rootScope.categories[$scope.rootCatIndex]._id
              );
            }
          }
        }
      };

      $scope.skipQuestion = function () {
        // $("html, body").animate({
        //   scrollTop: 0
        // }, "slow");
        var skip = function () {
          MyService.ConsoleLog("offset", $("#DisplayQ").offset().top);
          $("html, body").animate({
            scrollTop: $("#DisplayQ").offset().top - 180
          }, "slow");

          var tempIndex = $scope.currentIndex + 1;
          MyService.ConsoleLog(' $scope.currentIndex >>', tempIndex);
          if ($scope.userId) {
            $scope.getLocalPoliticians(tempIndex);

          }

          if (tempIndex < $scope.questions.length) {
            $scope.currentIndex++;
            if ($routeParams.categoryId && $routeParams.categoryId.indexOf('popular:') == 0) {
              //we are showing questions of most popular section
              $scope.getCategory({
                id: $scope.questions[$scope.currentIndex].categories.cid,
              });
            }
          }
          MyService.ConsoleLog(
            'tempIndex = ',
            tempIndex + '$scope.questions.length ' + $scope.questions.length
          );
          if (tempIndex == $scope.questions.length || $scope.questions.length == 0) {
            //MyService.ConsoleLog("end of questions switch background");
            var tempBackIdx = $scope.currBackgroundIndex + 1;
            MyService.ConsoleLog('$scope.traverseBackgrounds >>', $scope.traverseBackgrounds);
            if ($scope.traverseBackgrounds && $scope.traverseBackgrounds != '') {
              if (tempBackIdx < $scope.traverseBackgrounds.length) {
                $scope.currBackgroundIndex++;
                $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
              } else {
                $scope.rootCatIndex++;
                // alert("Else");
                window.localStorage.setItem('RootCatIndex', $scope.rootCatIndex);
                window.localStorage.setItem('DisplayCategory', JSON.stringify($scope.category));
                //MyService.ConsoleLog("/politician_compare/" + $routeParams.categoryId + "/" + $routeParams.parentId);
                $location.path(
                  '/politician_compare/' + $routeParams.categoryId + '/' + $routeParams.parentId
                );
              }
            } else {
              if ($scope.userId) {
                $location.path('/compareWithGroup');

              } else {
                $location.path('/compareGuestUsers');

              }
            }
          }
        };

        skip();
      };
    },
  ]);

'use strict';
angular
  .module('myApp.federalLegislation', ['ngRoute'])

  .config([
    '$routeProvider',
    function($routeProvider) {
      $routeProvider.when('/federalLegislation', {
        templateUrl: 'app/federalTrack/federalTrack.html',
        controller: 'federalTrackCtrl'
      });
    }
  ])
  .controller('federalTrackCtrl', [
    '$scope',
    'ngDialog',
    '$rootScope',
    'MyService',
    '$http',
    '$timeout',
    '$q',
    '$routeParams',
    '$window',
    "growl",

    function($scope, ngDialog, $rootScope, MyService, $http, $timeout, $q, $routeParams, $window, growl) {

      $scope.loader = false;
      $scope.loaderOne = false;
      $scope.currPage = 1;


      // if (!$routeParams.flag) {

      //   $window.location.href = "/federalBills";

      // }
      $scope.selType = {
        "type": "",
        "congress": "116",
        
      }

      $scope.myPagingFunction = function() {
        MyService.ConsoleLog('scoll called', $scope.statusGetResPg);
        if ($scope.statusGetResPg != 1 && $scope.serachData > $scope.federal.length) {
          $scope.currPage++;
          $scope.pageChanged($scope.currPage);
        }
      };

      $scope.pageChanged = function(newPage) {
        $scope.getFederal(newPage);
      };
      $scope.federal = [];

      $scope.getFederal = function(pageNumber) {
        MyService.ConsoleLog('pageNumber >', pageNumber);
        var params = {
          page: pageNumber,
          max_records: 30
        };
        //MyService.ConsoleLog("params: ", params);
        // $scope.users.data = [];


        $scope.statusGetResPg = 1;

        var getAllCanceller = $q.defer();


        MyService.getFederalData(params, getAllCanceller).then(
          function(result) {
            console.log("RESPONSE >  ", result);
            $scope.federal = $scope.federal.concat(result.data.data.data);
            MyService.ConsoleLog('$scope.open >', $scope.federal);
            $scope.serachData = result.data.data.count;
            // console.log($scope.committee);
            // $scope.totalUsers = payload.Count;
            // MyService.ConsoleLog(payload.Items);
            $scope.statusGetResPg = 2;
          },
          function(err) {
            // growl.error('Something went wrong.');
            $scope.statusGetResPg = 3;
            $scope.page--;
          }
        );
      };
      $scope.getFederal();


      $scope.getfederalLegislation = function() {
        MyService.ConsoleLog("seleted >>", $scope.selType.type);
        MyService.ConsoleLog("seleted >>", $scope.selType.congress);

        if ($scope.selType.type && $scope.selType.type != "" && $scope.selType.congress != "" ) {
          $scope.loader = true;

          MyService.addFederal({ "type": $scope.selType.type, "congress": $scope.selType.congress }).then(function(result) {
            console.log("result", result);
            $scope.loader = false;

          }, function(error) {
            console.log("error >", error);
          })
        } else {
          growl.error("Please select value from select box");
        }
      };

      $scope.getfederalBills = function() {
        $scope.loaderOne = true;

        MyService.addFederalBills().then(function(response) {
          console.log("response >>>", response);
          $scope.loaderOne = false;

        })

      }




    }
  ]);

'use strict';
angular
  .module('myApp.federalTextBills', ['ngRoute'])

  .config([
    '$routeProvider',
    function($routeProvider) {
      $routeProvider.when('/federalTextBills', {
        templateUrl: 'app/federalTextBills/federalTextBills.html',
        controller: 'federalTextBillsCtrl'
      });
    }
  ])
  .controller('federalTextBillsCtrl', [
    '$scope',
    'ngDialog',
    '$rootScope',
    'MyService',
    '$http',
    '$timeout',
    '$q',
    '$routeParams',
    '$window',
    "growl",

    function($scope, ngDialog, $rootScope, MyService, $http, $timeout, $q, $routeParams, $window, growl) {

      $scope.loader = false;
      $scope.loaderOne = false;
      $scope.currPage = 1;


      // if (!$routeParams.flag) {

      //   $window.location.href = "/federalBills";

      // }
      $scope.selType = {
        "type": "",
        "congress": "116",
        "session":""
        
      }

      $scope.myPagingFunction = function() {
        MyService.ConsoleLog('scoll called', $scope.statusGetResPg);
        if ($scope.statusGetResPg != 1 && $scope.serachData > $scope.federal.length) {
          $scope.currPage++;
          $scope.pageChanged($scope.currPage);
        }
      };

      $scope.pageChanged = function(newPage) {
        $scope.getFederalText(newPage);
      };
      $scope.federal = [];

      $scope.getFederalText = function(pageNumber) {
        MyService.ConsoleLog('pageNumber >', pageNumber);
        var params = {
          page: pageNumber,
          max_records: 30
        };
        //MyService.ConsoleLog("params: ", params);
        // $scope.users.data = [];


        $scope.statusGetResPg = 1;

        var getAllCanceller = $q.defer();


        MyService.getTextBills(params, getAllCanceller).then(
          function(result) {
            console.log("RESPONSE >  ", result);
            $scope.federal = $scope.federal.concat(result.data.data.data);
            MyService.ConsoleLog('$scope.open >', $scope.federal);
            $scope.serachData = result.data.data.count;
            // console.log($scope.committee);
            // $scope.totalUsers = payload.Count;
            // MyService.ConsoleLog(payload.Items);
            $scope.statusGetResPg = 2;
          },
          function(err) {
            // growl.error('Something went wrong.');
            $scope.statusGetResPg = 3;
            $scope.page--;
          }
        );
      };
      $scope.getFederalText();


      $scope.getfederalBills = function() {
        MyService.ConsoleLog("seleted >>", $scope.selType.type);
        MyService.ConsoleLog("seleted >>", $scope.selType.congress);
        MyService.ConsoleLog("seleted >>", $scope.selType.session);


        if ($scope.selType.type && $scope.selType.type != "" && $scope.selType.congress != "" && $scope.selType.session != "" ) {
          $scope.loader = true;

          MyService.addFederalBills({ "type": $scope.selType.type, "congress": $scope.selType.congress,"session":$scope.selType.session  }).then(function(result) {
            console.log("result", result);
            $scope.loader = false;

          }, function(error) {
            console.log("error >", error);
          })
        } else {
          growl.error("Please select value from select box");
        }
      };

      // $scope.getfederalBills = function() {
      //   $scope.loaderOne = true;

      //   MyService.addFederalBills().then(function(response) {
      //     console.log("response >>>", response);
      //     $scope.loaderOne = false;

      //   })

      // }




    }
  ]);

'use strict';
angular
  .module('myApp.federalDetail', ['ngRoute'])

  .config([
    '$routeProvider',
    function($routeProvider) {
      $routeProvider.when('/federalDetail/:ids', {
        templateUrl: 'app/federalDetails/federalDetails.html',
        controller: 'federalCtrl'
      });
    }
  ])
  .controller('federalCtrl', [
    '$scope',
    'ngDialog',
    '$rootScope',
    'MyService',
    '$routeParams',
    'apiCall',
    'tokenService',
    'growl',
    '$window',
    '$sce',

    function($scope, ngDialog, $rootScope, MyService, $routeParams, apiCall, tokenService, growl, $window, $sce) {

      // console.log("$routeParams >", $routeParams);
      $scope.uId = $routeParams.ids;
      // console.log("idddddddddddd >", $scope.uId);
      $scope.activeDoc = true;
      $scope.activeAct = true;
      $scope.activeText = true;
      $scope.activeVot = true;
      $scope.activeVots = true;
      $scope.activeCom = true;
      $scope.activeTitles = true;

      // $rootScope.flag = true;
      $scope.activeSpo = true;
      $scope.displayComments = true;
      $scope.ShowComments = false;
      $scope.loader = false;



      $scope.getDetails = function() {
        // MyService.ConsoleLog('params >', val);
        MyService.getDetails({ id: $scope.uId }).then(
          function(response) {
            MyService.ConsoleLog("Response >", response);

            if (response.data.data && response.data.data.bill && response.data.data.votes) {
              $scope.details = response.data.data.bill;
              $scope.votesData = response.data.data.votes;

            } else {

              $scope.details = response.data.data;
            }

            // MyService.ConsoleLog('got data >', $scope.details);
            $scope.getRatingData();


            // $scope.showDetail = true;
          },
          function(err) {
            MyService.ConsoleLog('Error', err);
          }
        );
      };
      $scope.getDetails();

      /*
       ** Redirect to comment form
       */



      $scope.redirectToComment = function() {
        var token = apiCall.getToken();
        if (!token) {
          var message = "Please login first.";

          var modal = ngDialog.openConfirm({
            template: '<p>' + message + '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
            plain: true
          });

          modal.then(function fullfilled(data) {
            //MyService.ConsoleLog("fullfilled: ", data);
            $location.path('signin');
          }, function rejected(data) {
            //MyService.ConsoleLog("rejected: ", data);
            $location.path('signin');
          });
        }
        $scope.ShowComments = true;
        $scope.displayComments = false;

        //$location.path('forumReply/'+$routeParams.categoryId+'/'+$routeParams.subcatId+'/'+$routeParams.essayId);
      }


      /*
       ** Hide comment text input
       */
      $scope.goBack = function() {
        $scope.ShowComments = false;
        $scope.displayComments = true;
      }
      $rootScope.flagOne = false;
      $scope.backTo = function() {
        $rootScope.flagOne = true;
        window.localStorage.setItem('flagOne', true);
        $window.history.back();
      }

      /*
       ** get Ratings 
       */

      $scope.rating = {
        "rate": ''
      }

      // $scope.path = "../assets/images/thumbsupone.png";
      $scope.disImg = false;

      $scope.rateLegislation = function(option) {
        var token = apiCall.getToken();
        if (!token) {
          var message = "Please login first.";

          var modal = ngDialog.openConfirm({
            template: '<p>' + message + '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
            plain: true
          });

          modal.then(function fullfilled(data) {
            //MyService.ConsoleLog("fullfilled: ", data);
            $location.path('signin');
          }, function rejected(data) {
            //MyService.ConsoleLog("rejected: ", data);
            $location.path('signin');
          });
        } else {
          var data = {};
          data.userId = tokenService.getUserId();
          data.uName = tokenService.getUserName();
          data.uType = tokenService.getUserRole();
          data.legisId = $scope.details._id;
          data.billNumber = $scope.details.billNumber;
          data.billType = $scope.details.billType;
          data.congress = $scope.details.congress;
          data.createOn = new Date();
          // if (option && option != "") {
          //   console.log("option >>", option);

          //   $scope.disImg = true;

          //   data.vote = 1;

          // }
          //MyService.ConsoleLog(option);

          data.rating = $scope.rating.rate;
          MyService.ConsoleLog("rating  >>>", data);

          MyService.saveLegisRating(data).then(function(payload) {
            // alert('Thank you for rating the Legislation.');
            // if (option && option != "") {
            // growl.success('Thank you for vote Legislation.');

            // } else {
              growl.success('Thank you for rating the Legislation.');
            // }
          }, function(errorPayload) {
            alert('Something went wrong ');
            growl.Error('Something went wrong');
          });
        }
      }



      /*
       ** Get comments and save it to tha database  
       */

      $scope.SubmitComment = function(rec) {
        //MyService.ConsoleLog(data);

        var data = {};
        if (rec.content != "") {

          data.commentedBy = tokenService.getUserId();
          data.commentedByName = tokenService.getUserName();
          data.commentedByType = tokenService.getUserRole();
          data.comments = rec.content;
          data.legisId = $scope.details._id;
          data.billNumber = $scope.details.billNumber;
          data.createOn = new Date();
          //MyService.ConsoleLog(data);
          MyService.saveLegisComment(data).then(function(payload) {
            $scope.comments = {
              content: ''
            };
            $scope.ShowComments = false;
            $scope.displayComments = true;
            $scope.getRatingData();
            growl.success("Thank you for comment")

            // $scope.getComments();
          }, function(errorPayload) {
            growl.Error("Something went wrong ");

          });
        } else {
          growl.Error("Please enter comments.");
        }
      }

      /*
       ** Fetch rating data from database  
       */

      $scope.getRatingData = function() {



        MyService.getLegisRate({ 'legisId': $scope.details._id, "uType": tokenService.getUserRole(), "billNumber": $scope.details.billNumber }).then(function(data) {
          MyService.ConsoleLog("Dayta>>>", data);

          $scope.disImg = true;

          $scope.rating.rate = data.data.rating;
          $scope.comment = data.data.comment;
        }, function(err) {
          console.log("error >>", err);
        })
      }


      $scope.checkData = function(data) {

        return $sce.trustAsHtml(data);

      }



    }
  ]);

'use strict';
angular
  .module('myApp.federalBills', ['ngRoute'])

  .config([
    '$routeProvider',
    function($routeProvider) {
      $routeProvider.when('/federalBills', {
        templateUrl: 'app/federalBills/federalBills.html',
        controller: 'federalBillsCtrlOne'
      });
    }
  ])
  .controller('federalBillsCtrlOne', [
    '$scope',
    'ngDialog',
    '$rootScope',
    'MyService',
    '$routeParams',
    '$q',
    "growl",
    function($scope, ngDialog, $rootScope, MyService, $routeParams, $q, growl) {
      $scope.fData = [];

      $scope.userRole = $rootScope;
      $scope.currPage = 1;
      // MyService.ConsoleLog("$rootScope.userRole >>", $scope.userRole);

      $scope.loader = false;
      $scope.showOne = false;
      $scope.searchTool = false;
      $scope.moreTool = false;
      $scope.search = false;




      $scope.selType = {
        "congress": "116",
        "title": "",
        "law": true,
        "vote": true,
        "selHouse": [],
        "selSenate": [],
        "sponsor": false,
        "cosponsor": false,
        "house": "",
        "senate": "",
        "action": "",
        "com": ""
      }

      /*
       **@ function for lazzy load
       */

      // $scope.myPagingFunction = function() {
      //   // MyService.ConsoleLog('scoll called', $scope.statusGetResPg);
      //   if ($scope.statusGetResPg != 1 && $scope.serachData > $scope.fData.length) {
      //     $scope.currPage++;
      //     $scope.pageChanged($scope.currPage);
      //   }
      // };

      // $scope.pageChanged = function(newPage) {
      //   $scope.getFederalData(newPage);
      // };








      /*
            $scope.getFederalData = function(pageNumber) {
              MyService.ConsoleLog('pageNumber >', pageNumber);
              var params = {
                page: pageNumber,
                max_records: 30
              };



              $scope.statusGetResPg = 1;

              var getAllCanceller = $q.defer();


              MyService.getFederalData(params, getAllCanceller).then(
                function(result) {
                  console.log("RESPONSE >  ", result);
                  $scope.fData = $scope.fData.concat(result.data.data.data);
                  MyService.ConsoleLog('$scope.open >', $scope.fData);
                  $scope.serachData = result.data.data.count;
                  MyService.ConsoleLog("count >", $scope.serachData);

                  // $scope.totalUsers = payload.Count;
                  // MyService.ConsoleLog(payload.Items);
                  $scope.statusGetResPg = 2;
                },
                function(err) {
                  // growl.error('Something went wrong.');
                  $scope.statusGetResPg = 3;
                  $scope.page--;
                }
              );
            };
      */



      MyService.ConsoleLog("$rootScope", $rootScope.flag);

      /*
            $scope.getFederalData();
      */

      $scope.pageFunction = function() {
        // MyService.ConsoleLog('scoll called', $scope.statusGetResPg);
        // MyService.ConsoleLog("called");
        if ($scope.statusGetResPg != 1 && $scope.countData > $scope.fedData.length) {
          // MyService.ConsoleLog("length");
          $scope.currPage++;
          $scope.changedPage($scope.currPage);
        }
      };

      $scope.changedPage = function(newPage) {
        $scope.SearchBy(newPage);
      };

      $scope.fedData = [];


      $scope.searchFun = function(params, canceller) {

        MyService.SearchBills(params, canceller).then(function(response) {
          $scope.showOne = true;
          $scope.loader = false;

          if (response.data.error) {
            growl.error(response.data.error)
          } else {
            console.log("result >>", response);
            $scope.searchTool = false;
            // $rootScope.para = "";
            // MyService.ConsoleLog("$rootScope >", $rootScope.para);

            $scope.search = true;

            $scope.fedData = $scope.fedData.concat(response.data.data.result);
            // MyService.ConsoleLog('$scope.fede >', $scope.fedData);
            $scope.countData = response.data.data.bcount;
            $scope.sim = "";
            $scope.statusGetResPg = 2;

          }

        }, function(err) {
          MyService.ConsoleLog("error >", err);
          $scope.statusGetResPg = 3;
          $scope.page--;
        })

      }

      /*
       **@ function get records of federal bills
       */

      $scope.SearchBy = function(pageNumber, val) {
        $scope.loader = true;
        $rootScope.para = "";

        // MyService.ConsoleLog("para >", val);
        if (val && val != "") {
        $scope.fedData.length = 0;

        }
        MyService.ConsoleLog("pageNumber >", pageNumber);

        // MyService.ConsoleLog("params >>", $scope.selType);
        // MyService.ConsoleLog("params >>", Object.keys($scope.selType.selHouse));
        if ($scope.selType.senate == "Any Senator" || $scope.selType.house == "Any Representative") {

          if ($scope.selType.senate == "Any Senator" && $scope.selType.house == "Any Representative") {
            $scope.selType.senate = "";
            $scope.selType.house = "";

          } else if ($scope.selType.house == "Any Representative") {
            $scope.selType.house = "";

          } else {
            $scope.selType.senate = "";

          }
        }

        if ($scope.selType.action == "Any Legislative Action") {
          $scope.selType.action = "";
        }
        $scope.sim = {};

        $scope.sim.selHouse = Object.keys($scope.selType.selHouse);
        $scope.sim.selSenate = Object.keys($scope.selType.selSenate)

        // MyService.ConsoleLog("Sim >>", $scope.sim);
        $scope.selType.com = $scope.sim;
        MyService.ConsoleLog("params >.", $scope.selType);
        $scope.searchObj = {
          page: pageNumber,
          max_records: 30,
          para: $scope.selType,
          flag: $scope.searchTool

        }


        // var obj = {
        //   page: pageNumber,
        //   max_records: 30,
        //   para: $scope.selType,
        //   flag: $scope.searchTool
        // };

        // MyService.ConsoleLog("obj>", obj);



        $scope.statusGetResPg = 1;

        $scope.getAllCanceller = $q.defer();

        // MyService.ConsoleLog("selType ", $scope.selType.title);

        if ($scope.selType.title != "") {
          //alert("if");
          // if ($scope.selType.title && $scope.selType.title.length >= 4) {
          $scope.searchFun($scope.searchObj, $scope.getAllCanceller);

          // } else {
          //   growl.error("Please enter at least 4 characters");
          // }


        } else {

          if (!$scope.searchTool) {
            //alert($scope.searchTool);
            $scope.searchFun($scope.searchObj, $scope.getAllCanceller);


          } else {
            //alert($scope.searchTool);

            if ($scope.selType.house != "" || $scope.selType.senate != "") {
              if ($scope.selType.house != "") {
                if ($scope.selType.sponsor == true || $scope.selType.cosponsor == true) {

                  if ($scope.selType.sponsor == true) {
                    $scope.searchFun($scope.searchObj, $scope.getAllCanceller);
                  } else {
                    $scope.searchFun($scope.searchObj, $scope.getAllCanceller);
                  }

                } else {
                  //alert('one');
                  growl.error("Please select atleast one checkbox  sponsor or cosponsor");
                }

              } else {
                if ($scope.selType.sponsor == true || $scope.selType.cosponsor == true) {

                  if ($scope.selType.sponsor == true) {
                    $scope.searchFun($scope.searchObj, $scope.getAllCanceller);
                  } else {
                    $scope.searchFun($scope.searchObj, $scope.getAllCanceller);
                  }

                } else {
                  //alert('two');

                  growl.error("Please select atleast one checkbox  sponsor or cosponsor");
                }

              }
            } else {
              $scope.searchFun($scope.searchObj, $scope.getAllCanceller);
            }
          }




          // $scope.searchFun(obj, getAllCanceller);


          // //alert("else");
        }




        // MyService.ConsoleLog("params >>", $scope.selType.selHouse[0] + "&&&&&&&&&&&&&&&&&&&&&&&&" + $scope.selType.selSenate[0]);


        // if ($scope.selType.title && $scope.selType.title != "" || $scope.selType.subTopics && $scope.selType.title != "" || $scope.selType.policyArea && $scope.selType.policyArea != "") {


        // } else {
        //   growl.error("Please fill the search box");
        // }
      }


      $scope.getDetailPage = function(id) {

        if ($rootScope.para != "") {
          $rootScope.para = $rootScope.para;
          // alert("else");
        } else {

          $rootScope.para = $scope.searchObj;
        }
        window.location.href = '#!/federalDetail/' + id;
      }

      /*
       **@ function calls on page load
       */

      // var fla = window.localStorage.getItem('flagOne');
      // alert(fla);

      var fone = window.localStorage.getItem('flagOne');
      MyService.ConsoleLog("f;actionType >>", fone);
      if (fone == 'true') {

        // alert("if");
        // var data = JSON.stringify($rootScope.para);
        $scope.searchFun($rootScope.para, $scope.getAllCanceller);
        console.log("Here >>> ", $rootScope.para);
        window.localStorage.setItem('flagOne', false);


      } else {
        // alert("else");

        console.log("FedData >> ", $scope.fedData);
        window.localStorage.setItem('flagOne', false);
        $scope.SearchBy();
      }



      // $scope.$on('$viewContentLoaded', function(event) {
      //   MyService.ConsoleLog("$rootScope >", $rootScope.flag);

      //   MyService.ConsoleLog("$scope.fedData >", $scope.fedData);
      //   MyService.ConsoleLog("$scope.event >", event);
      //   // alert("welcome");

      // });



      $scope.more = function() {
        $scope.searchTool = true;
        // $scope.moreTool = true;


      }

      $scope.getCommittees = function() {

        MyService.fedCommittees().then(function(response) {

          MyService.ConsoleLog("Got response >>", response);
          $scope.senate = response.Senate;
          $scope.house = response.House;
          $scope.actionType = response.actionTypes;

        }, function(err) {
          MyService.ConsoleLog("Error >", err);
        })

      }
      $scope.getCommittees();

      $scope.getCandidate = function() {
        MyService.getCandi().then(function(response) {

          MyService.ConsoleLog("response >", response);
          $scope.senateRepresent = response.senateRepresent;
          $scope.houseRepresent = response.houseRepresent;

        }, function(err) {
          MyService.ConsoleLog("Error >>", err);
        });
      }

      $scope.getCandidate();

      // $scope.getCheck = function() {
      //   MyService.ConsoleLog("Check >", $scope.selType.selHouse);
      // }

      $scope.reset = function() {
        $scope.searchTool = false;

      }

    }
  ]);

'use strict';

angular.module('myApp.faq', ['ngRoute'])

.config(['$routeProvider', function ($routeProvider) {
     $routeProvider.when('/faq', {
         templateUrl: 'app/faq/faq.html',
         controller: 'faqCtrl' 
     });
}])
.controller('faqCtrl', ['$scope', '$rootScope', function($scope, $rootScope) {
$rootScope.welcome = false;
}]);

'use strict';
angular.module('myApp.exportOrgRatings', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/exportOrgRatings', {
      templateUrl: 'app/exportOrgRatings/exportOrgRatings.html',
      controller: 'ExportOrgRatingsCtrl'
    });
  }]).controller('ExportOrgRatingsCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'growl', 'tokenService', 'ngDialog', 'baseApiUrl', '$anchorScroll', 'MyService', '$window', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, growl, tokenService, ngDialog, baseApiUrl, $anchorScroll, MyService, $window) {

    $scope.loader = false;

    /**
     * @description Function is use to export records of rating organizations.
     */
    $scope.exportData = function () {
      $scope.loader = true;
      MyService.exportOrgRatingData().then(function (payload) {
        //MyService.ConsoleLog("Success Data", payload);
        $scope.loader = false;
        $window.open($scope.imgUrl + '/ratingOrganizations.xlsx', '_blank');
      }, function (errorPayload) {

        //MyService.ConsoleLog("errorPayload : ", errorPayload);
        alert("Something went wrong. Please try again after sometime");
      })
    }
  }]);

'use strict';

angular.module('myApp.exploreQuiz', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/exploreQuiz/:catId?/:selCatId?/:inviterId?', {
      templateUrl: 'app/exploreQuiz/exploreQuiz.html',
      controller: 'exploreQuizCtrl'
    });
  }]).controller('exploreQuizCtrl', ['$scope', 'apiCall', 'MyService', '$location', '$anchorScroll', '$timeout', '$rootScope', 'ngDialog', '$q', '$http', '$filter', 'growl', '$routeParams', 'baseApiUrl', 'tokenService', '$cookies', function ($scope, apiCall, MyService, $location, $anchorScroll, $timeout, $rootScope, ngDialog, $q, $http, $filter, growl, $routeParams, baseApiUrl, tokenService, $cookies) {

    /**
     *@description Get params using $routeParams
     */
    $scope.catId = $routeParams.catId;
    $scope.selCatId = $routeParams.selCatId;
    $scope.inviterId = $routeParams.inviterId;
    MyService.ConsoleLog("catId", $scope.catId);
    MyService.ConsoleLog("selCatId", $scope.selCatId);

    $scope.showLoader = false;
    $scope.showInfo = false;
    window.localStorage.removeItem('inviterInfo');
    window.localStorage.removeItem('inviterId');
    window.localStorage.setItem('inviterId', $scope.inviterId);

    /**
     * @description Get Inviter details
     */

    $scope.getmyData = function () {
      $scope.showLoader = true;
      $scope.ShowPorifleLoading = true;
      MyService.getUserPublicProfile({
        id: $scope.inviterId,
        type: 'false'
      }).then(function (response) {
        $scope.ShowPorifleLoading = false;
        if (response.data.success) {
          $scope.userDetails = response.data.data;
          MyService.ConsoleLog("welcome", $scope.userDetails);
          $scope.userProfile = $scope.userDetails.userData;
          MyService.ConsoleLog("welcome to profile", $scope.userProfile);
          switch ($scope.userProfile.userType) {
            case "voter":
              $scope.inviterName = $scope.userProfile.username;
              window.localStorage.setItem('inviterInfo', JSON.stringify($scope.userProfile));
              break;
            case "politician":
              $scope.inviterName = $scope.userProfile.nameOnBallot;
              window.localStorage.setItem('inviterInfo', JSON.stringify($scope.userProfile));
              break;
            case "advocate":
              $scope.inviterName = $scope.userDetails.orgData.title;
              window.localStorage.setItem('inviterInfo', JSON.stringify($scope.userDetails.orgData));
              break;
            default:

              break;
          }


          $scope.showInfo = true;
          $scope.showLoader = false;
        } else {
          MyService.ConsoleLog("ELSE vishal");
          $scope.showLoader = false;
          alert("Something went wrong.");
        }
      }, function (errorPayload) {
        $scope.ShowPorifleLoading = false;
        MyService.ConsoleLog("ELSE vishal two");

        alert("Something went wrong.");
      });
    };

    /**
     * @description Redirect to the regular quiz
     */
    $scope.getQuiz = function () {
      $location.path("/question-background/" + $scope.catId + "/" + $scope.selCatId);
    };

    $scope.getmyData();
  }]);

'use strict';
angular.module('myApp.essayPress', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
        $routeProvider.when('/essay_press/:categoryId/:subcatId?/:type?', {
            templateUrl: 'app/essay_press/essay.html',
            controller: 'EssayPressCtrl'
        });
        $routeProvider.when('/essay_press', {
            templateUrl: 'app/essay_press/essay.html',
            controller: 'EssayPressCtrl'
        });
    }])
    .controller('EssayPressCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'baseApiUrl', 'MyService', 'tokenService', 'growl', '$templateCache', 'ngDialog', '$sce', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, baseApiUrl, MyService, tokenService, growl, $templateCache, ngDialog, $sce) {
        //MyService.ConsoleLog("** EssayPressCtrl **");
        $scope.imgUrl = baseApiUrl + "/resources";
        $rootScope.welcome = false;
        $scope.categoryId = $routeParams.categoryId;
        $scope.subcategoryId = $routeParams.subcatId;
        $scope.userId = tokenService.getUserId();
        $scope.userRole = tokenService.getUserRole();
        $scope.favChannel = "associated-press";
        if(tokenService.getUserData()) {
            $scope.userData = JSON.parse(tokenService.getUserData());
            MyService.ConsoleLog($scope.userData);
            $scope.GalleryFolder = baseApiUrl + "/resources/" + $scope.userData.uname;
            if($scope.userData.my_fav_channel && $scope.userData.my_fav_channel!="") {
                $scope.favChannel = $scope.userData.my_fav_channel;    
            }
        }

        $scope.feedtitle = $scope.favChannel.replace(new RegExp("-",'g'), " ").toUpperCase();
        $scope.ShowAdavace = false;
        if ($routeParams.query) {
            $scope.search = {
                text: $routeParams.query,
                subject: '',
                Locations: '',
                mediaoption: [],
                mediaType: '',
                dateBefore: '',
                dateAfter: '',
                matchFrom: '',
                matchTo: '',
                recommendFrom: '',
                recommendTo: '',
                recommendFilter: '',
                factualFilter: '',
                factualFrom: '',
                factualTo: '',
                fromfollowlist: '',
                order: '',
                recommendorder: '',
                lrecommendorder: '',
                factualorder: '',
                lfactualorder: ''

            };
        } else {
            $scope.search = {
                text: '',
                subject: '',
                Locations: '',
                mediaoption: [],
                mediaType: '',
                dateBefore: '',
                dateAfter: '',
                matchFrom: '',
                matchTo: '',
                recommendFrom: '',
                recommendTo: '',
                recommendFilter: '',
                factualFilter: '',
                factualFrom: '',
                factualTo: '',
                fromfollowlist: '',
                recommendorder: '',
                lrecommendorder: '',
                factualorder: '',
                lfactualorder: '',
                order: ''
            };
        }

        $scope.showRefineLocation = false;

        $scope.Location = ["International", "National", "My State", "My County", "My Local", "Other Specific"];
        $scope.mediaType = ['Text', 'Video', 'Stills', 'Audio'];
        $scope.dateRange = ['Today', 'In the last week', 'In the last month', 'In the last year'];
        $scope.users = ["Voters", "Advocates", "Press", "Politicians", "Authors on my follow list"];
        $scope.staffResults = {
            data: []
        };
        $scope.searchResults = {
            data: []
        };
        $scope.selectedCat = [];
        $scope.subtopics = {
            subcategories: []
        }
        $scope.disabled = [];
        $scope.allLocations = [];
        $scope.allCounties = [];
        $scope.selectedArea = [];
        $scope.rmselectedArea = [];
        $scope.myselectionarea = [];
        $scope.disabledLocation = [];
        $scope.ShowSubcatTree = false;

        $scope.selectConfig = {
            requiredMin: 1,
            selectAll: true
        };

        /*$scope.getStaffEssayList = function() {
            $scope.searchResults.data.length = 0;
            var nrequest = apiCall.apiCall('GET', '/essay-press/staffEssayList', { maincatId: $routeParams.categoryId, subcatId: $routeParams.subcatId, limit: 3 });
            $http(
                nrequest
            ).then(function successCallback(responseLatest) {
                if (responseLatest.data.success) {
                    var finalData = responseLatest.data.data;
                    var flen = finalData.length;
                    $scope.staffResults.data = finalData;
                }
            }, function errorCallBack(responseLatest) {
                alert("Error : " + responseLatest);
            });
        }*/
        
        $scope.getEssayList = function() {
            $scope.searchResults.data.length = 0;
            var param = {};
            if ($routeParams.categoryId)
                param.maincatId = $routeParams.categoryId;
            if ($routeParams.subcatId)
                param.subcatId = routeParams.subcatId;

            var nrequest = apiCall.apiCall('GET', '/essay-press/getList', param); //{ maincatId: $routeParams.categoryId, subcatId: $routeParams.subcatId }
            $http(
                nrequest
            ).then(function successCallback(responseLatest) {
                if (responseLatest.data.success) {
                    var finalData = responseLatest.data.data;
                    //MyService.ConsoleLog("finalData : ", finalData);
                    var flen = finalData.length;
                    for (var s = 0; s < flen; s++) {
                        if (finalData[s].recommended.length > 0) {
                            finalData[s].recavg = $scope.calculateAvg(finalData[s].recommended);
                            finalData[s].recavgvoters = $scope.calculateAvgType(finalData[s].recommended, 'voter');
                            finalData[s].recavgpolitician = $scope.calculateAvgType(finalData[s].recommended, 'politician');
                            finalData[s].recavgadvocate = $scope.calculateAvgType(finalData[s].recommended, 'advocate');
                            finalData[s].recavgpress = $scope.calculateAvgType(finalData[s].recommended, 'press');
                        } else {
                            finalData[s].recavg = 0;
                            finalData[s].recavgvoters = 0;
                            finalData[s].recavgpolitician = 0;
                            finalData[s].recavgadvocate = 0;
                            finalData[s].recavgpress = 0;
                        }
                        if (finalData[s].factual.length > 0) {
                            finalData[s].factfavg = $scope.calculateAvg(finalData[s].factual);
                            finalData[s].factfavgvoters = $scope.calculateAvgType(finalData[s].factual, 'voter');
                            finalData[s].factfavgpolitician = $scope.calculateAvgType(finalData[s].factual, 'politician');
                            finalData[s].factfavgadvocate = $scope.calculateAvgType(finalData[s].factual, 'advocate');
                            finalData[s].factfavgpress = $scope.calculateAvgType(finalData[s].factual, 'press');
                        } else {
                            finalData[s].factfavg = 0;
                            finalData[s].factfavgvoters = 0;
                            finalData[s].factfavgpolitician = 0;
                            finalData[s].factfavgadvocate = 0;
                            finalData[s].factfavgpress = 0;
                        }
                        //MyService.ConsoleLog("finalData[s] :", finalData[s]);
                        $scope.searchResults.data.push(finalData[s]);
                    }
                    //$scope.getFavNewsChannel();
                }
            }, function errorCallBack(responseLatest) {
                alert("Error : " + responseLatest);
            });
        }

        $scope.checkCatExists = function(rdata, val) {
            return rdata.filter(
                function(rdata) {
                    if (rdata._id == val) {
                        $scope.selectedCat.push(rdata);
                        return rdata
                    } else if (rdata.subcategories) {
                        $scope.checkCatExists(rdata.subcategories, val)
                    }
                }
            );
        }

        $scope.mainCatTree = [];

        $scope.getSubcatTree = function() {
            //MyService.ConsoleLog($scope.mainCatTree);
            if ($scope.mainCatTree.length == 0) {
                $scope.ShowSubcatTree = true;
                MyService.getAllCatTree().then(function(payload) {
                        $scope.subtopics.subcategories.length = 0;
                        $scope.mainCatTree = angular.copy(payload);
                        var subcatdata = payload;
                        $scope.ShowSubcatTree = false;
                        $scope.subtopics.subcategories = subcatdata;
                        var selectedCat = $scope.disabled;
                        if (selectedCat.length > 0) {
                            for (var s = 0; s < selectedCat.length; s++) {
                                var checkcatdata = $scope.checkCatExists(subcatdata, selectedCat[s]);
                            }
                            //MyService.ConsoleLog($scope.selectedCat);
                        }
                        setTimeout(function() {
                            var cols = document.getElementsByClassName('cmnUL');
                            var clen = cols.length;
                            for (var i = 0; i < clen; i++) {
                                cols[i].style.display = "none";
                            }
                        }, 300);
                    },
                    function(errorPayload) {
                        alert('Something went wrong ');
                    });
            } else {
                //MyService.ConsoleLog("After : " + $scope.subtopics.subcategories.length);
                if ($scope.subtopics.subcategories.length == 0) {
                    $scope.subtopics.subcategories = angular.copy($scope.mainCatTree);
                } else {;
                    $scope.subtopics.subcategories.length = 0;
                }


                $scope.ShowSubcatTree = false;
                //MyService.ConsoleLog("After : " + $scope.subtopics.subcategories);
                //MyService.ConsoleLog("After : " + $scope.ShowSubcatTree);
            }

        }



        $scope.AllStates = [];
        $scope.allCounties = [];
        $scope.allLocals = [];
        $scope.showSubCat = true;
        $scope.showLoading = [];
        $scope.showLoadingCounty = [];
        $scope.showDown = [];

        $scope.GotoEdit = function(id) {
            //MyService.ConsoleLog("GotoEdit: ", id);
            $location.path('/pressEssayUpdate/' + $routeParams.categoryId + '/' + id);
        }

        $scope.GotoRemove = function(id) {


            var message = 'This will also remove all the comments added to this post. Do you want to proceed?';

            var modal = ngDialog.openConfirm({
                template: '<p>' + message + '</p>\
            <div class="ngdialog-buttons">\
                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">YES</button>\
                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">NO</button>\
            </div>',
                plain: true
            });
            modal.then(function fullfilled(data) {
                //MyService.ConsoleLog("fullfilled: ", mydata);
                MyService.removePressEssay(id).then(function(payload) {
                    //MyService.ConsoleLog(payload);
                    //$scope.UserFormDiv = false;
                    //$scope.getSpamTopics(1);
                    $scope.getEssayList();
                    alert("Topic deleted successfully.");



                }, function(error) {
                    if(error.error) {
                        alert(error.error);    
                    } else {
                        alert(JSON.stringify(error));    
                    }
                    
                });
            }, function rejected(data) {
                //MyService.ConsoleLog("rejected: ", data);
            });



        }

        $scope.getAllStates = function() {
            $scope.ShowStateLoader = true;
            if ($scope.AllStates.length == 0) {
                MyService.getAllStates().then(function(payload) {
                        $scope.ShowStateLoader = false;
                        $scope.allLocations.length = 0;
                        var subcatdata = payload;
                        $scope.AllStates = angular.copy(subcatdata);
                        //MyService.ConsoleLog("countires : ", subcatdata);
                        $scope.allLocations = subcatdata;
                    },
                    function(errorPayload) {
                        alert('Something went wrong ');
                    });
            } else {
                if (!$scope.showStates) {
                    $scope.allLocations.length = 0;
                    $scope.ShowStateLoader = false;
                } else {
                    $scope.allLocations = angular.copy($scope.AllStates);
                    $scope.ShowStateLoader = false;
                }
            }

        }


        $scope.getCounties = function(state) {
            $scope.showLoading.push(state);
            if (!$scope.allCounties[state] || $scope.allCounties[state].length == 0) {

                MyService.getAllCounties(state).then(function(payload) {
                        $scope.showLoading.length = 0;
                        var sublocations = payload;
                        if (!$scope.allCounties) {
                            $scope.allCounties = [];
                        }
                        $scope.allCounties[state] = sublocations;
                    },
                    function(errorPayload) {
                        alert('Something went wrong.');
                    });


            } else {
                $scope.showLoading.length = 0;
                $scope.allCounties[state].length = 0;
            }
        }

        $scope.getLocals = function(state, county) {
            $scope.showLoadingCounty.push(county);
            if (!$scope.allLocals[state] || !$scope.allLocals[state][county] || $scope.allLocals[state][county].length == 0) {

                MyService.getAllSubCountiesLocal(state, county).then(function(payload) {
                        $scope.showLoadingCounty.length = 0;
                        //MyService.ConsoleLog("sublocations Locals : ", sublocations);
                        if (!$scope.allLocals[state]) {
                            $scope.allLocals[state] = [];
                        }
                        $scope.allLocals[state][county] = payload;
                    },
                    function(errorPayload) {
                        alert('Something went wrong ');
                    });


            } else {
                $scope.showLoadingCounty.length = 0;
                $scope.allLocals[state][county].length = 0;
            }
        }





        $scope.showmediaType = false;
        $scope.showDateRange = false;
        $scope.showMatchAuthor = false;
        $scope.showEssayRating = false;
        $scope.showStates = false;
        $scope.showRefine = function(e, option) {
            e.preventDefault();
            switch (option) {
                case "Interest":
                    $scope.getSubcatTree();
                    break;
                case "Location":
                    if (!$scope.showRefineLocation)
                        $scope.showRefineLocation = true;
                    else
                        $scope.showRefineLocation = false;

                    break;
                case "AllLocation":
                    if (!$scope.showStates) {
                        $scope.showStates = true;

                    } else {
                        $scope.showStates = false;
                    }
                    $scope.getAllStates();
                    break;
                case "Media":
                    if (!$scope.showmediaType)
                        $scope.showmediaType = true;
                    else
                        $scope.showmediaType = false;
                    break;
                case "Date":
                    if (!$scope.showDateRange)
                        $scope.showDateRange = true;
                    else
                        $scope.showDateRange = false;
                    break;
                case "Author":
                    if (!$scope.showMatchAuthor)
                        $scope.showMatchAuthor = true;
                    else
                        $scope.showMatchAuthor = false;
                    break;
                case "EssayRated":
                    if (!$scope.showEssayRating)
                        $scope.showEssayRating = true;
                    else
                        $scope.showEssayRating = false;
                    break;
                case "Default":
                    break;

            }
        }


        $scope.showSubCat = true;
        $scope.showLoading = [];
        $scope.showLoadingCounty = [];
        $scope.showDown = [];
        $scope.ChangeShow = function(id) {
            $scope.showSubCat = true;

            var nclass = "MainCatLi_" + id;
            if ((document.getElementsByClassName(nclass)[0].style.display) && (document.getElementsByClassName(nclass)[0].style.display == "none")) {
                document.getElementsByClassName(nclass)[0].style.display = "block";
            } else {
                document.getElementsByClassName(nclass)[0].style.display = "none";
            }
        }


        function areEqual() {
            var len = arguments.length;
            for (var i = 1; i < len; i++) {
                if (arguments[i] == null || arguments[i] != arguments[i - 1])
                    return false;
            }
            return true;
        }

        function indexOfExt(list, item) {
            var len = list.length;

            for (var i = 0; i < len; i++) {
                var keys = Object.keys(list[i]);
                var flg = true;
                var arr = [];


                for (var j = 0, s = 1; j < keys.length; j++, s++) {
                    var value = list[i][keys[j]];
                    if (item[keys[j]] !== value) {
                        flg = false;

                    }

                    if (item[keys[j]] == value) {
                        arr.push(flg);
                    }


                }
                if (flg == true) {
                    if (areEqual(arr.length, keys.length, Object.keys(item).length)) {
                        return i;
                    }

                }


            }
            return -1;
        }

        $scope.findLocations = [];
        $scope.Interests = [];
        $scope.MyLocation = [];
        $scope.SelectDefaultLocation = function(val) {
            //MyService.ConsoleLog("Data : ", val);
            var idx = $scope.MyLocation.indexOf(val);
            if (idx == -1) {
                $scope.MyLocation.push(val);
            } else {
                $scope.MyLocation.splice(idx, 1);
            }
            //MyService.ConsoleLog($scope.MyLocation);
        }

        $scope.selectLocation = function(val1, val2, val3, type) {
            //MyService.ConsoleLog(val1, val2, val3, type);
            var nobj = {};
            nobj.country = "United States of America";
            if (type == "state") {
                nobj.state = val1.state;
                nobj.statePostalCode = val1.statePostalCode;
            }
            if (type == "county") {
                nobj.state = val1.state;
                nobj.statePostalCode = val1.statePostalCode;
                nobj.county = val3;
            }
            if (type == "local") {
                nobj.state = val1.state;
                nobj.statePostalCode = val1.statePostalCode;
                nobj.county = val2;
                nobj.countySubdivision = val3.countySubdivision;
                nobj.place = val3.place;
            }
            //MyService.ConsoleLog("nboj:", nobj);
            var idx = indexOfExt($scope.findLocations, nobj);
            if (idx == -1) {
                $scope.findLocations.push(nobj);
            } else {
                $scope.findLocations.splice(idx, 1);
            }
        }



        $scope.getVal = function(data) {
            //MyService.ConsoleLog($scope.Interests);
            var idx = $scope.Interests.indexOf(data._id);
            if (idx == -1) {
                $scope.Interests.push(data._id);
            } else {
                $scope.Interests.splice(idx, 1);
            }
        }

        $scope.totalResults = 0;


        function addslashes(str) {
            return (str + '').replace(/[\\"']/g, '\\$&').replace(/\u0000/g, '\\0');
        }




        function cleanArray(actual) {
            var newArray = new Array();
            for (var i = 0; i < actual.length; i++) {
                if (actual[i]) {
                    newArray.push(actual[i]);
                }
            }
            return newArray;
        }

        function allnumeric(inputtxt) {
            var numbers = /^[0-9]+$/;
            if (inputtxt == undefined) {
                return false;
            }
            if (inputtxt.match(numbers)) {
                return true;
            } else {
                return false;
            }
        }


        $scope.calculateAvg = function(arr) {
            var reclen = arr.length;
            //MyService.ConsoleLog("Arr Len : ", reclen);
            var recsum = 0;
            for (var r = 0; r < reclen; r++) {
                if (arr[r].vote) {
                    //MyService.ConsoleLog("===", arr[r].vote);
                    recsum += parseInt(arr[r].vote, 10);
                    if (r == reclen - 1) {
                        var recavg = recsum / reclen;

                        return recavg;
                    }
                }

            }

            //return card.values.opt1 + card.values.opt2;
        };

        $scope.calculateAvgType = function(arr, type) {
            var reclen = arr.length;
            //MyService.ConsoleLog("Array Lenght : ", arr);
            var recsum = 0;
            for (var r = 0; r < reclen; r++) {
                var mainarr = arr[r];
                //MyService.ConsoleLog("mainarr:", mainarr);
                if (mainarr.user) {
                    var userData = arr[r].user || arr[r][0].user;
                    var userVote = arr[r].vote || arr[r][0].vote;
                    if (userData.utype == type) {
                        //MyService.ConsoleLog(userData.utype + "==" + type);
                        recsum += parseInt(userVote, 10);

                    }
                    if (r == reclen - 1) {
                        var recavg = recsum / reclen;

                        return recavg;
                    }
                }

            }

            //return card.values.opt1 + card.values.opt2;
        };

        $scope.calculateAvgId = function(arr, followlist) {
            var reclen = arr.length;
            var recsum = 0;
            for (var r = 0; r < reclen; r++) {
                var mainarr = arr[r];
                //MyService.ConsoleLog("mainarr:", mainarr);
                if (mainarr.user) {
                    var userData = mainarr.user;
                    var userVote = mainarr.vote;
                    if (userData.id) {
                        var idx = followlist.indexOf(userData.id)
                        if (idx > -1) {
                            //MyService.ConsoleLog(arr[r].user.utype + "==" + type);
                            recsum += parseInt(userVote, 10);

                        }
                    }
                }
                if (r == reclen - 1) {
                    var recavg = recsum / reclen;

                    return recavg;
                }
            }
        }

        $scope.getEssayListAdvance = function(data) {

            $scope.searchResults.data.length = 0;
            if ($scope.findLocations.length > 0) {
                data.searchlocations = JSON.stringify($scope.findLocations);
            }

            if ($scope.MyLocation.length > 0) {
                data.MyLocation = JSON.stringify($scope.MyLocation);
            }
            if (data.mediaoption) {
                var moption = data.mediaoption;
                if (typeof moption == "object") {
                    moption = Object.keys(moption).map(function(key) {
                        return moption[key]
                    });
                }
                if (typeof moption != "string") {
                    var media = cleanArray(moption);
                    data.mediaoption = JSON.stringify(media);
                }
            }
            data.subjectOfInterest = JSON.stringify($scope.Interests);
            var validateMatch = true,
                validateMatchTo = true,
                validateRecommend = true,
                validateTo = true;
            var msg = "";
            if (data.matchFrom != "") {
                validateMatch = allnumeric(data.matchFrom);
                if (($scope.Interests.length == 0) && validateMatch) {
                    msg = "Please select atleast one subject of interest";
                    validateMatch = false;
                }
            }

            if (data.matchTo != "") {
                validateMatchTo = allnumeric(data.matchTo);
                if (validateMatchTo && ($scope.Interests.length == 0)) {
                    msg = "Please select atleast one subject of interest";
                    validateMatchTo = false;
                }
            }

            if (data.recommendFrom != "") {
                validateRecommend = allnumeric(data.recommendFrom);
            }
            if (data.recommendTo != "") {
                validateTo = allnumeric(data.recommendTo);
            }

            if (validateMatch && validateMatchTo && validateRecommend && validateTo) {
                $scope.searchResults.data.length = 0;
                $scope.totalResults = 0;
                var nrequest = apiCall.apiCall('POST', '/essay-press/AdvanceSearch', data);
                $http(
                    nrequest
                ).then(function successCallback(responseLatest) {
                    //MyService.ConsoleLog("Final Advance Data: ", responseLatest);
                    //MyService.ConsoleLog(responseLatest.data.data);
                    $scope.searchResults.data.length = 0;
                    if (responseLatest.data.success) {
                        var finalData = responseLatest.data.data;
                        //MyService.ConsoleLog("finalData:", finalData.length);
                        var flen = finalData.length;
                        $scope.searchResults.data.length = 0;
                        //MyService.ConsoleLog("Results :", $scope.searchResults.data);

                        $templateCache.removeAll();
                        for (var s = 0; s < flen; s++) {
                            //MyService.ConsoleLog("actual length : ", finalData[s].recommended.length);
                            //MyService.ConsoleLog("actual : ", finalData[s].recommended);
                            // if (typeof finalData[s].recommended == "object") {
                            //     var narr = [];
                            //     narr.push(finalData[s].recommended);
                            //     finalData[s].recommended = narr;
                            // }
                            // if (typeof finalData[s].factual == "object") {
                            //     var farr = [];
                            //     farr.push(finalData[s].factual);
                            //     finalData[s].factual = farr;
                            // }
                            //MyService.ConsoleLog("actual length : ", finalData[s].recommended.length);
                            //MyService.ConsoleLog("actual : ", finalData[s].recommended);
                            if (finalData[s].recommended.length > 0) {
                                finalData[s].recavg = $scope.calculateAvg(finalData[s].recommended);
                                finalData[s].recavgvoters = $scope.calculateAvgType(finalData[s].recommended, 'voter');
                                finalData[s].recavgpolitician = $scope.calculateAvgType(finalData[s].recommended, 'politician');
                                finalData[s].recavgadvocate = $scope.calculateAvgType(finalData[s].recommended, 'advocate');
                                finalData[s].recavgpress = $scope.calculateAvgType(finalData[s].recommended, 'press');
                                if ($scope.userData && $scope.userData.followlist.length > 0) {
                                    finalData[s].recavgfollow = $scope.calculateAvgId(finalData[s].recommended, $scope.userData.followlist);
                                } else {
                                    finalData[s].recavgfollow = 0;
                                }

                            } else {
                                finalData[s].recavg = 0;
                                finalData[s].recavgvoters = 0;
                                finalData[s].recavgpolitician = 0;
                                finalData[s].recavgadvocate = 0;
                                finalData[s].recavgpress = 0;
                                finalData[s].recavgfollow = 0;
                            }
                            if (finalData[s].factual.length > 0) {
                                finalData[s].factfavg = $scope.calculateAvg(finalData[s].factual);
                                finalData[s].factfavgvoters = $scope.calculateAvgType(finalData[s].factual, 'voter');
                                finalData[s].factfavgpolitician = $scope.calculateAvgType(finalData[s].factual, 'politician');
                                finalData[s].factfavgadvocate = $scope.calculateAvgType(finalData[s].factual, 'advocate');
                                finalData[s].factfavgpress = $scope.calculateAvgType(finalData[s].factual, 'press');
                                if ($scope.userData && $scope.userData.followlist.length > 0) {
                                    finalData[s].factfavgfollow = $scope.calculateAvgId(finalData[s].recommended, $scope.userData.followlist);
                                } else {
                                    finalData[s].factfavgfollow = 0;
                                }

                            } else {
                                finalData[s].factfavg = 0;
                                finalData[s].factfavgvoters = 0;
                                finalData[s].factfavgpolitician = 0;
                                finalData[s].factfavgadvocate = 0;
                                finalData[s].factfavgpress = 0;
                                finalData[s].factfavgfollow = 0;
                            }
                            //MyService.ConsoleLog("finalData[s] :", finalData[s]);
                            $scope.searchResults.data.push(finalData[s]);
                        }
                        $scope.totalResults = responseLatest.data.data.length;

                        data.mediaoption = "";
                        data.mediaoption = [];
                        data.mediaoption.length = 0;
                    }
                }, function errorCallBack(responseLatest) {
                    alert("Error : " + responseLatest);
                });
            } else {
                if (msg != "") {
                    alert(msg);
                } else {
                    alert("Please enter valid data");
                }

            }
        }
        $scope.ShowOrderList = false;
        $scope.showOrder = function() {
            if (!$scope.ShowOrderList) {
                $scope.ShowOrderList = true;
            } else {
                $scope.ShowOrderList = false;
            }
        }

        $scope.isreverse = false;
        $scope.showAvg = true;
        $scope.showVoters = false;
        $scope.showPolitician = false;
        $scope.showAdvocate = false;
        $scope.showPress = false;
        $scope.showFollow = false;
        $scope.showfAvg = true;
        $scope.showfVoters = false;
        $scope.showfPolitician = false;
        $scope.showfAdvocate = false;
        $scope.showfPress = false;
        $scope.showfFollow = false;
        $scope.resetAllOrder = function() {
            $scope.showAvg = false;
            $scope.showVoters = false;
            $scope.showPolitician = false;
            $scope.showAdvocate = false;
            $scope.showPress = false;
            $scope.showFollow = false;
        }
        $scope.resetAllfOrder = function() {
            $scope.showfAvg = false;
            $scope.showfVoters = false;
            $scope.showfPolitician = false;
            $scope.showfAdvocate = false;
            $scope.showfPress = false;
            $scope.showfFollow = false;
        }

        $scope.sortValues = function(data) {
            var result = "";
            $scope.resetAllOrder();
            $scope.resetAllfOrder();

            $scope.showfAvg = true;
            $scope.showAvg = true;


            switch ($scope.search.order) {
                case "Most Recent":
                    $scope.isreverse = true;
                    $scope.showAvg = true;
                    $scope.showfAvg = true;
                    result = data.createdOn;
                    break;
                case "Oldest":
                    $scope.isreverse = false;
                    $scope.showAvg = true;
                    $scope.showfAvg = true;
                    result = data.createdOn;
                    break;
                case "Highest Recommended":
                    $scope.resetAllOrder();
                    $scope.isreverse = true;
                    $scope.showAvg = true;
                    $scope.showfAvg = true;
                    result = data.recavg;
                    break;
                case "Least Recommended":
                    $scope.resetAllOrder();
                    $scope.isreverse = false;
                    $scope.showAvg = true;
                    $scope.showfAvg = true;
                    result = data.recavg;
                    break;
                case "Most Factual":
                    $scope.resetAllfOrder();
                    $scope.isreverse = true;
                    $scope.showAvg = true;
                    $scope.showfAvg = true;
                    result = data.factfavg;
                    break;
                case "Least Factual":
                    $scope.resetAllfOrder();
                    $scope.isreverse = false;
                    $scope.showAvg = true;
                    $scope.showfAvg = true;
                    result = data.factfavg;
                    break;
                case "Default":
                    $scope.resetAllOrder();
                    $scope.resetAllfOrder();
                    $scope.isreverse = true;
                    result = data.createdOn;
                    $scope.showAvg = true;
                    $scope.showfAvg = true;
                    break;

            }

            switch ($scope.search.recommendorder) {
                case "Voters":
                    $scope.resetAllOrder();
                    $scope.showVoters = true;
                    $scope.isreverse = true;
                    result = data.recavgvoters;
                    break;
                case "Politicians":
                    $scope.resetAllOrder();
                    $scope.showPolitician = true;
                    $scope.isreverse = true;
                    result = data.recavgpolitician;
                    break;
                case "Advocates":
                    $scope.resetAllOrder();
                    $scope.showAdvocate = true;
                    $scope.isreverse = true;
                    result = data.recavgadvocate;
                    break;
                case "Press":
                    $scope.resetAllOrder();
                    $scope.showPress = true;
                    $scope.isreverse = true;
                    result = data.recavgpress;
                    break;
                case "Authors on my follow list":
                    $scope.resetAllOrder();
                    $scope.showFollow = true;
                    $scope.isreverse = true;
                    result = data.recavgfollow;
                    break;
                case "Default":
                    $scope.resetAllOrder();
                    $scope.showAvg = true;

                    break;

            }

            switch ($scope.search.lrecommendorder) {
                case "Voters":
                    $scope.resetAllOrder();
                    $scope.showVoters = true;
                    $scope.isreverse = false;
                    result = data.recavgvoters;
                    break;
                case "Politicians":
                    $scope.resetAllOrder();
                    $scope.showPolitician = true;
                    $scope.isreverse = false;
                    result = data.recavgpolitician;
                    break;
                case "Advocates":
                    $scope.resetAllOrder();
                    $scope.showAdvocate = true;
                    $scope.isreverse = false;
                    result = data.recavgadvocate;
                    break;
                case "Press":
                    $scope.resetAllOrder();
                    $scope.showPress = true;
                    $scope.isreverse = false;
                    result = data.recavgpress;
                    break;
                case "Authors on my follow list":
                    $scope.resetAllOrder();
                    $scope.showFollow = true;
                    $scope.isreverse = false;
                    result = data.recavgfollow;
                    break;
                case "Default":
                    $scope.resetAllOrder();
                    $scope.showAvg = true;
                    break;

            }

            switch ($scope.search.factualorder) {
                case "Voters":
                    $scope.resetAllfOrder();
                    $scope.showfVoters = true;
                    $scope.isreverse = true;
                    result = data.factfavgvoters;
                    break;
                case "Politicians":
                    $scope.resetAllfOrder();
                    $scope.showfPolitician = true;
                    $scope.isreverse = true;
                    result = data.factfavgpolitician;
                    break;
                case "Advocates":
                    $scope.resetAllfOrder();
                    $scope.showfAdvocate = true;
                    $scope.isreverse = true;
                    result = data.factfavgadvocate;
                    break;
                case "Press":
                    $scope.resetAllfOrder();
                    $scope.showfPress = true;
                    $scope.isreverse = true;
                    result = data.factfavgpress;
                    break;
                case "Authors on my follow list":
                    $scope.resetAllOrder();
                    $scope.showfFollow = true;
                    $scope.isreverse = true;
                    result = data.factfavgfollow;
                    break;
                case "Default":
                    $scope.resetAllfOrder();
                    $scope.showfAvg = true;
                    break;

            }

            switch ($scope.search.lfactualorder) {
                case "Voters":
                    $scope.resetAllfOrder();
                    $scope.showfVoters = true;
                    $scope.isreverse = false;
                    result = data.factfavgvoters;
                    break;
                case "Politicians":
                    $scope.resetAllfOrder();
                    $scope.showfPolitician = true;
                    $scope.isreverse = false;
                    result = data.factfavgpolitician;
                    break;
                case "Advocates":
                    $scope.resetAllfOrder();
                    $scope.showfAdvocate = true;
                    $scope.isreverse = false;
                    result = data.factfavgadvocate;
                    break;
                case "Press":
                    $scope.resetAllfOrder();
                    $scope.showfPress = true;
                    $scope.isreverse = false;
                    result = data.factfavgpress;
                    break;
                case "Authors on my follow list":
                    $scope.resetAllOrder();
                    $scope.showfFollow = true;
                    $scope.isreverse = false;
                    result = data.factfavgfollow;
                    break;
                case "Default":
                    $scope.resetAllfOrder();
                    $scope.showfAvg = true;
                    break;

            }
            //MyService.ConsoleLog($scope.search);
            //MyService.ConsoleLog(result);
            return result;

        }

        $scope.HighestRecommended = false;
        $scope.LeastRecommended = false;
        $scope.MostFactual = false;
        $scope.LeastFactual = false;
        $scope.ShowUsers = function(option) {
            switch (option) {
                case "HighestRecommended":
                    if (!$scope.HighestRecommended) {
                        $scope.HighestRecommended = true;
                    } else {
                        $scope.HighestRecommended = false;
                    }
                    break;
                case "LeastRecommended":
                    if (!$scope.LeastRecommended) {
                        $scope.LeastRecommended = true;
                    } else {
                        $scope.LeastRecommended = false;
                    }
                    break;
                case "MostFactual":
                    if (!$scope.MostFactual) {
                        $scope.MostFactual = true;
                    } else {
                        $scope.MostFactual = false;
                    }
                    break;
                case "LeastFactual":
                    if (!$scope.LeastFactual) {
                        $scope.LeastFactual = true;
                    } else {
                        $scope.LeastFactual = false;
                    }
                    break;
                case "Default":
                    $scope.HighestRecommended = false;
                    break;
            }
        }

        $scope.gotoThread = function(data) {
            var id = data;
            //MyService.ConsoleLog(data);
            $location.path('pressEssayDetails/' + $routeParams.categoryId + '/' + id);
        }

        $scope.showadvace = function() {
            $scope.ShowAdavace = true;
            var query = $scope.search.text;
            $scope.search = {
                text: query,
                subject: '',
                Locations: '',
                mediaoption: [],
                mediaType: '',
                dateBefore: '',
                dateAfter: '',
                matchFrom: '',
                matchTo: '',
                recommendFrom: '',
                recommendTo: '',
                recommendFilter: '',
                factualFilter: '',
                factualFrom: '',
                factualTo: '',
                order: '',
                recommendorder: '',
                lrecommendorder: '',
                factualorder: '',
                lfactualorder: '',
                fromfollowlist: ''
            };
        }



        $scope.getVdoScreen = function(text) {
            //MyService.ConsoleLog("------------------------------");
            //MyService.ConsoleLog("text:", text);
            //MyService.ConsoleLog("width: ", tempW);
            //MyService.ConsoleLog("height: ", tempH);
            //MyService.ConsoleLog("------------------------------");
            var tempWDefault = 560;
            var tempHDefault = 315;
            var tempW = 560;
            var tempH = 315;
            MyService.ConsoleLog(text);
            var urlRegex = /(http(s?):\/\/[^\s]+)/g;
            var data = text.replace(urlRegex, function(url) {
                var rdata = url;
                MyService.getLinkPreview({"weburl": url}).then(function(response){
                    MyService.ConsoleLog(response);
                    var data = $sce.trustAsHtml('<br/><a href="' + url + '" target="_blank"><h3>' + response.title + '</h3><div style="width:100%; clear:both;"><img src="' + response.image + '" style="width:80%; height:auto; max-width: '+tempWDefault+'" /></div><div style="width:100%; clear:both;">' + response.description + '</div></a><br/>');
                    MyService.ConsoleLog(data);
                    return data;

                }, function(err){
                    return text;
                });
                
            });
            //MyService.ConsoleLog(data);
            //return $sce.trustAsHtml(data);
        }

        /*if ($routeParams.categoryId) {
            // $scope.getStaffEssayList();
            $scope.getEssayList();
        }*/
        $scope.getEssayList();
    }]);

'use strict';
angular.module('myApp.essayUpdate', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
        $routeProvider.when('/essayUpdate/:categoryId/:eid', {
            templateUrl: 'app/essayUpdate/essayUpdate.html',
            controller: 'essayUpdateCtrl'
        });
    }])
    .controller('essayUpdateCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'growl', 'tokenService', 'ngDialog', 'baseApiUrl', '$anchorScroll', 'MyService', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, growl, tokenService, ngDialog, baseApiUrl, $anchorScroll, MyService) {
        $scope.EssayButton = false;
        $rootScope.welcome = false;
        $scope.location = ['International', 'National', 'State', 'County', 'Local'];
        $scope.uData = JSON.parse(tokenService.getUserData());
        $scope.mediaType = ['Text', 'Video', 'Stills', 'Audio'];

        $scope.tinymceOptions = {
            plugins: [
                'advlist autolink lists link image charmap print preview hr anchor pagebreak',
                'searchreplace wordcount visualblocks visualchars code fullscreen',
                'insertdatetime media nonbreaking save table contextmenu directionality',
                'emoticons template paste textcolor colorpicker textpattern imagetools'
            ],
            toolbar: ''
        };

        $scope.subtopics = {
            subcategories: []
        };
        $scope.AddLocation = false;
        $scope.newlocation = {
            country: ''
        };
        $scope.Essay = {
            title: '',
            description: '',
            location: '',
            mediaType: 'Text',
            subcategories: []
        };

        $scope.restrictedOptions = ['Locals Only', 'No Restrictions'];

        $scope.selectedCat = [];
        $scope.SelectedTree = [];
        $scope.disabled = [];
        $scope.Allcountries = [];
        $scope.SelectedCountry = '';

        $scope.ShowAddLocation = function() {
            if (!$scope.AddLocation) {
                $scope.AddLocation = true;
            } else {
                $scope.AddLocation = false;
            }

        }

        $scope.getEssay = function() {
            MyService.getEssay($routeParams.eid).then(function(payload) {
                //MyService.ConsoleLog("Got Essay: ", response);
                $scope.getAllStates();
                var subcatdata = payload;
                //MyService.ConsoleLog("Essay : ", subcatdata);
                $scope.Essay = subcatdata;
                var locations = subcatdata.locationSpecific;
                var catArr = subcatdata.parentcat;
                //MyService.ConsoleLog(catArr[0].split(","));
                $scope.disabled = subcatdata.parentCat;
                $scope.SelectedTree = subcatdata.subCategories;
                //MyService.ConsoleLog($scope.disabled);
                var len = locations.length;
                $scope.selectedArea.length = 0;
                $scope.showSubCat = true;
                $scope.disabledLocation.length = 0;
                for (var l = 0; l < len; l++) {
                    var nobj = {};
                    if (locations[l].country) {
                        nobj.country = locations[l].country;
                    }
                    if (locations[l].state) {
                        nobj.state = locations[l].state;
                        nobj.statePostalCode = locations[l].statePostalCode;
                    }
                    if (locations[l].county) {
                        nobj.county = locations[l].county;
                    }
                    if (locations[l].countySubdivision) {
                        nobj.countySubdivision = locations[l].countySubdivision;
                    }
                    if (locations[l].place) {
                        nobj.place = locations[l].place;
                    }
                    $scope.selectedArea.push(nobj);
                    $scope.disabledLocation.push(nobj);
                }

                $scope.getSubcatTree();

            }, function errorCallBack(response) {
                //MyService.ConsoleLog("Error: ", response);
            });
        }




        function suggest_country(term) {
            var q = term.toLowerCase().trim();
            var results = [];
            var len = $scope.Allcountries.length;
            // Find first 10 states that start with `term`.
            for (var i = 0; i < len && results.length < 10; i++) {
                var country = $scope.Allcountries[i];
                if (country.toLowerCase().indexOf(q) === 0)
                    results.push({ label: country, value: country });
            }
            return results;
        }

        $scope.autocomplete_options = {
            suggest: suggest_country
        };

        $scope.getAllStates = function() {
            MyService.getAllStates().then(function(payload) {
                    $scope.allLocations.length = 0;
                    var subcatdata = payload;
                    //MyService.ConsoleLog("countires : ", subcatdata);
                    $scope.allLocations = subcatdata;


                },
                function(errorPayload) {
                    alert('Something went wrong ');
                });

        }

        $scope.getVal = function(data) {
            //MyService.ConsoleLog(data);
            var idx = $scope.selectedCat.indexOf(data);
            if (idx > -1) {
                $scope.selectedCat.splice(idx, 1);
                var id = $scope.disabled.indexOf(data._id);
                $scope.disabled.splice(id, 1);
                var jdx = $scope.SelectedTree.indexOf(data.parentIds);
                if (jdx > -1)
                    $scope.SelectedTree.splice(jdx, 1);

            } else {
                $scope.selectedCat.push(data);
                var id = $scope.disabled.indexOf(data._id);
                if (id == -1) {
                    $scope.disabled.push(data._id);

                }
                //MyService.ConsoleLog(data.parentIds);
                //MyService.ConsoleLog("SelectedTree: ", $scope.SelectedTree);
                if ($scope.SelectedTree.length == 0) {
                    if (data.parentIds.length > 0) {
                        //var parents = Object.keys(data.parentIds).map(function (key) {return data.parentIds[key]});
                        //angular.copy(data.parentIds, $scope.SelectedTree);
                        var parents = data.parentIds;
                        //MyService.ConsoleLog(parents);
                        $scope.SelectedTree = parents;
                    }
                } else {
                    if (data.parentIds.length > 0) {
                        //var parents = Object.keys(data.parentIds).map(function (key) {return data.parentIds[key]});
                        //var parents = angular.copy(data.parentIds);
                        var parents = data.parentIds;
                        var plen = parents.length;
                        for (var j = 0; j < plen; j++) {
                            $scope.SelectedTree.push(parents[j]);
                        }
                    }
                }
            }
            //MyService.ConsoleLog($scope.SelectedTree);
        }


        $scope.selectedAll = {
            id: []
        };
        $scope.removeVal = function(data) {
            var idx = $scope.selectedCat.indexOf(data);
            if (idx > -1) {
                $scope.selectedCat.splice(idx, 1);
                var id = $scope.disabled.indexOf(data._id);
                $scope.disabled.splice(id, 1);
                var parents = data.parentIds;
                var plen = parents.length;
                for (var j = 0; j < plen; j++) {
                    var jdx = $scope.SelectedTree.indexOf(parents[j]);
                    if (jdx > -1)
                        $scope.SelectedTree.splice(jdx, 1);
                }
            }
            $scope.selectedAll.id.length = 0;
            //MyService.ConsoleLog($scope.SelectedTree);
        }

        $scope.selectConfig = {
            requiredMin: 1,
            selectAll: true
        };

        $scope.checksubCatExists = function(rdata, val) {
            return rdata.filter(
                function(rdata) {
                    if (rdata._id == val)
                        return rdata
                    else if (rdata.subCategories) {
                        $scope.checksubCatExists(rdata.subcategories, val)
                    }
                }
            );
        }

        $scope.checkCatExists = function(rdata, val) {
            return rdata.filter(
                function(rdata) {
                    if (rdata._id == val) {
                        $scope.selectedCat.push(rdata);
                        return rdata
                    } else if (rdata.subcategories) {
                        $scope.checkCatExists(rdata.subcategories, val)
                    }
                }
            );
        }

        $scope.getSubcatTree = function() {
            $scope.selectedCat.length = 0;
            $scope.EssayButton = true;
            MyService.getAllCatTree({ "type": "E" }).then(function(payload) {
                    $scope.subtopics.subcategories.length = 0;
                    var subcatdata = payload;
                    // MyService.ConsoleLog("subcatdata : ", subcatdata);
                    $scope.subtopics.subcategories = subcatdata;
                    var selectedCat = $scope.disabled;
                    if (selectedCat.length > 0) {
                        for (var s = 0; s < selectedCat.length; s++) {
                            var checkcatdata = $scope.checkCatExists(subcatdata, selectedCat[s]);
                        }
                        //MyService.ConsoleLog($scope.selectedCat);
                    }
                    $scope.EssayButton = false;
                    setTimeout(function() {
                        var cols = document.getElementsByClassName('cmnUL');
                        var clen = cols.length;
                        for (var i = 0; i < clen; i++) {
                            cols[i].style.display = "none";
                        }
                    }, 300);
                },
                function(errorPayload) {
                    alert('Something went wrong ');
                });

        }
        $scope.allLocations = [];
        $scope.allCounties = [];
        $scope.selectedArea = [];
        $scope.rmselectedArea = [];
        $scope.myselectionarea = [];
        $scope.disabledLocation = [];

        $scope.checkExists = function(rdata, val) {
            return rdata.filter(
                function(rdata) {
                    if (rdata.state == val)
                        return rdata
                }
            );
        }

        $scope.checkCountyExists = function(rdata, val) {
            return rdata.filter(
                function(rdata) {
                    if (rdata.county == val)
                        return rdata
                }
            );
        }

        $scope.checkCountryExists = function(rdata, val) {
            return rdata.filter(
                function(rdata) {
                    if (rdata.country == val)
                        return rdata
                }
            );
        }

        function areEqual() {
            var len = arguments.length;
            for (var i = 1; i < len; i++) {
                if (arguments[i] == null || arguments[i] != arguments[i - 1])
                    return false;
            }
            return true;
        }

        function indexOfExt(list, item) {
            var len = list.length;

            for (var i = 0; i < len; i++) {
                var keys = Object.keys(list[i]);
                var flg = true;
                var arr = [];


                for (var j = 0, s = 1; j < keys.length; j++, s++) {
                    var value = list[i][keys[j]];
                    if (item[keys[j]] !== value) {
                        flg = false;

                    }

                    if (item[keys[j]] == value) {
                        arr.push(flg);
                    }


                }
                if (flg == true) {
                    if (areEqual(arr.length, keys.length, Object.keys(item).length)) {
                        return i;
                    }

                }


            }
            return -1;
        }

        $scope.checkDisabled = function(data, stateId, type) {

            data.country = "United States of America";
            data.state = stateId;

            var idx = indexOfExt($scope.disabledLocation, data);
            if (idx > -1)
                return true;
            else
                return false;


        }

        $scope.getAreaVal = function(data, stateId, type) {

            if (!data.country) {
                data.country = "United States of America";
            }
            if (!data.state) {
                data.state = stateId;
            }



            var idx = indexOfExt($scope.selectedArea, data);


            if (idx > -1) {
                alert("You have already selected the location");
            } else {

                $scope.selectedArea.push(data);
                $scope.disabledLocation.push(data);

            }

            //MyService.ConsoleLog($scope.disabledLocation);
        }
        $scope.selectedLAll = {
            id: []
        };
        $scope.removeAreaVal = function(data) {
            var idx = $scope.selectedArea.indexOf(data);

            //MyService.ConsoleLog($scope.Essay.Locations);
            if (idx > -1) {
                //MyService.ConsoleLog("Country:",$scope.selectedArea[idx].country);
                if ($scope.selectedArea[idx].country == "International") {
                    $scope.Essay.Locations = 'NO';
                }
                if ($scope.selectedArea[idx].country == "National (USA)") {
                    $scope.Essay.National = 'NO';
                }
                $scope.selectedArea.splice(idx, 1);
                var jdx = $scope.disabledLocation.indexOf(data);
                if (jdx > -1) {
                    $scope.disabledLocation.splice(jdx, 1);
                }
            }
            $scope.selectedLAll.id.length = 0;
            //MyService.ConsoleLog($scope.selectedArea);

        }
        $scope.allCounties = [];
        $scope.allLocals = [];
        $scope.setLocation = function(option) {
            $scope.Essay.location = option;
        }
        $scope.getLocations = function(val, type) {
            if (type == "National") {
                if (val == "National") {

                    var nobj = {
                        country: "National (USA)"
                    }
                    $scope.selectedArea.push(nobj);
                    //MyService.ConsoleLog($scope.selectedArea);
                }
                if (val == "NO") {

                    var nobj = {
                        country: "National (USA)"
                    }
                    var idx = indexOfExt($scope.selectedArea, nobj);
                    if (idx > -1) {
                        $scope.selectedArea.splice(idx, 1);
                    }
                }
            } else if (type == "International") {
                if (val == "International") {
                    // $scope.selectedArea.length = 0;
                    var nobj = {
                        country: "International"
                    }
                    $scope.selectedArea.push(nobj);

                }
                if (val == "NO") {
                    // $scope.selectedArea.length = 0;
                    var nobj = {
                        country: "International"
                    }
                    var idx = indexOfExt($scope.selectedArea, nobj);
                    if (idx > -1) {
                        $scope.selectedArea.splice(idx, 1);
                    }
                }
            }
        }

        $scope.AddCountry = function() {
            if (($scope.newlocation.country) && ($scope.newlocation.country != '')) {
                var idx = $scope.Allcountries.indexOf($scope.newlocation.country);
                if (idx > -1) {
                    var nobj = {
                        country: $scope.newlocation.country
                    };
                    $scope.selectedArea.push(nobj);
                } else {
                    alert("Country does not exists in our database. Please check if you have entered correct name.");
                }
            } else {
                alert("Please enter country name");
            }
        }

        $scope.getCounties = function(state) {
            $scope.showLoading.push(state);
            if (!$scope.allCounties[state] || $scope.allCounties[state].length == 0) {
                MyService.getAllCounties(state).then(function(payload) {
                        $scope.showLoading.length = 0;
                        var sublocations = payload;
                        if (!$scope.allCounties) {
                            $scope.allCounties = [];
                        }
                        $scope.allCounties[state] = sublocations;
                    },
                    function(errorPayload) {
                        alert('Something went wrong.');
                    });

            } else {
                $scope.showLoading.length = 0;
                $scope.allCounties[state].length = 0;
            }
        }

        $scope.getLocals = function(state, county) {
            $scope.showLoadingCounty.push(county);
            if (!$scope.allLocals[state] || !$scope.allLocals[state][county] || $scope.allLocals[state][county].length == 0) {
                MyService.getAllSubCountiesLocal(state, county).then(function(payload) {
                        $scope.showLoadingCounty.length = 0;
                        //MyService.ConsoleLog("sublocations Locals : ", sublocations);
                        if (!$scope.allLocals[state]) {
                            $scope.allLocals[state] = [];
                        }
                        $scope.allLocals[state][county] = payload;
                    },
                    function(errorPayload) {
                        alert('Something went wrong ');
                    });
            } else {
                $scope.showLoadingCounty.length = 0;
                $scope.allLocals[state][county].length = 0;
            }
        }

        if (!$rootScope.UserId) {
            $location.path('signin');
        }

        if (window.localStorage.getItem("VoteWiseEssayCategory")) {
            $rootScope.allEssaycategories = JSON.parse(window.localStorage.getItem("VoteWiseEssayCategory"));
            var idx = $rootScope.allEssaycategories.indexOf($routeParams.subcatId);
            if (idx == -1) {
                $rootScope.allEssaycategories.push($routeParams.subcatId);
                window.localStorage.setItem("VoteWiseEssayCategory", JSON.stringify($rootScope.allEssaycategories));
            }
        }

        $scope.showSubCat = true;
        $scope.showLoading = [];
        $scope.showLoadingCounty = [];
        $scope.showDown = [];
        $scope.ChangeShow = function(id) {
            //$scope.showSubCat = true;
            //var cols = document.getElementsByClassName('cmnUL');
            //var clen = cols.length;
            var nclass = "MainCatLi_" + id;
            if ((document.getElementsByClassName(nclass)[0].style.display) && (document.getElementsByClassName(nclass)[0].style.display == "none")) {
                document.getElementsByClassName(nclass)[0].style.display = "block";
            } else {
                document.getElementsByClassName(nclass)[0].style.display = "none";
            }
            /*
            for (var i = 0, j = 1; i < clen; i++, j++) {
                if (cols[i].style.display == "none") {
                    if (j == clen) {
                        var nclass = "MainCatLi_" + id;
                        if ($scope.showDown.length > 0 && $scope.showDown[0] == id) {

                            document.getElementsByClassName(nclass)[0].style.display = "none";
                            $scope.showDown.splice(0, 1);
                            $scope.showDown.length = 0;

                        } else {
                            $scope.showDown.splice(0, 1);
                            $scope.showDown.length = 0;

                            $scope.showDown.push(id);
                            document.getElementsByClassName(nclass)[0].style.display = "block";
                        }

                        var idx = $location.hash();
                        $location.hash(id);
                        $anchorScroll();
                        $location.hash(idx);                        
                    }
                } else {
                    cols[i].style.display = 'none';
                }

            }

            */
        }


        $scope.UpdateEssay = function(data) {
            //MyService.ConsoleLog($scope.disabled);
            //MyService.ConsoleLog($scope.SelectedTree);
            if ($.fn.validateForceFully($("#topicform")) == true) {
                if (($scope.disabled.length == 0) && ($scope.SelectedTree == 0)) {
                    alert("Please select atleast one Tag");
                } else {
                    $scope.EssayButton = true;
                    if (data.mediaType == 'Stills') {
                        //MyService.ConsoleLog(data.files);
                        if (data.files) {
                            var fd = new FormData();
                            fd.append('file', data.files);
                            fd.append('essayId', $routeParams.eid);
                            fd.append("parentcat", $scope.disabled);
                            fd.append("subcategories", JSON.stringify($scope.SelectedTree));
                            fd.append("createdById", tokenService.getUserId());
                            fd.append("createdByName", tokenService.getUserName());
                            fd.append("createdByType", tokenService.getUserRole());
                            fd.append("title", data.title);
                            fd.append("description", data.description);
                            fd.append("mediaType", data.mediaType);
                            fd.append("location", data.location);
                            if ($scope.selectedArea.length > 0) {
                                fd.append("locationSpecific", JSON.stringify($scope.selectedArea));
                            }
                            var udata = $scope.uData;
                            var posturl = baseApiUrl + "/essay/update?mediaType=" + data.mediaType;

                            $http.post(posturl, fd, {
                                    transformRequest: angular.identity,
                                    headers: { 'Content-Type': undefined },
                                    params: {
                                        'folderName': udata.uname
                                    }
                                })
                                .success(function(response, status, headers, config) {
                                    $scope.EssayButton = true;
                                    //MyService.ConsoleLog("response : ", response);
                                    if (response.success) {
                                        $location.path('/essay/' + $routeParams.categoryId + '/home');
                                    } else {
                                        alert(response.data.error);
                                        if ((response.data.status) && (response.data.status == "405")) {
                                            var msg = "Do you want to send request to Admin to reactivate your account?.";
                                            MyService.GetDialogWithButtons(ngDialog, msg, "YES", "NO").then(function(payload) {
                                                MyService.sendActivatationMailtoAdmin().then(function(payload) {
                                                    alert("Request sent successfully to admin");
                                                }, function(errorPayload) {
                                                    alert("Something went wrong");
                                                })
                                            }, function(errorPayload) {
                                                //MyService.ConsoleLog(errorPayload);
                                            });
                                        }
                                    }
                                })
                                .error(function(data, status, headers, config) {
                                    //MyService.ConsoleLog("error");
                                });
                        } else {
                            alert("File is required.");
                        }


                    } else {
                        data.essayId = $routeParams.eid;
                        data.parentcat = $scope.disabled;
                        data.subcategories = JSON.stringify($scope.SelectedTree);
                        data.createdById = tokenService.getUserId();
                        data.createdByName = tokenService.getUserName();
                        data.createdByType = tokenService.getUserRole();
                        if ($scope.selectedArea.length > 0) {
                            data.locationSpecific = JSON.stringify($scope.selectedArea);
                        }
                        //MyService.ConsoleLog("data: ", data);

                        var request = apiCall.apiCall('POST', '/essay/update?mediaType=' + data.mediaType, data);
                        $http(
                            request
                        ).then(function successCallback(response) {
                            //MyService.ConsoleLog("Got Essay: ", response);
                            $scope.EssayButton = true;
                            if (response.data.success) {
                                $location.path('/essay/' + $routeParams.categoryId + '/home');
                            } else {
                               alert(response.data.error);
                                if ((response.data.status) && (response.data.status == "405")) {
                                    var msg = "Do you want to send request to Admin to reactivate your account?.";
                                    MyService.GetDialogWithButtons(ngDialog, msg, "YES", "NO").then(function(payload) {
                                        MyService.sendActivatationMailtoAdmin().then(function(payload) {
                                            alert("Request sent successfully to admin");
                                        }, function(errorPayload) {
                                            alert("Something went wrong");
                                        })
                                    }, function(errorPayload) {
                                        //MyService.ConsoleLog(errorPayload);
                                    });
                                }
                            }
                        }, function errorCallBack(response) {
                            //MyService.ConsoleLog("Error: ", response);
                        });
                    }

                }


            }

            //alert("This is not implemented yet");
        }
        $scope.MainGallery = [];
        $scope.GalleryFolder = baseApiUrl + "/resources/" + $scope.uData.uname;
        $scope.loadGallery = function() {
            var nrequest = apiCall.apiCall('GET', '/gallery/get', { id: $scope.uData.id });
            $http(
                nrequest
            ).then(function successCallback(responseLatest) {
                if (responseLatest.data.success) {
                    $scope.MainGallery = responseLatest.data.data;
                }


            }, function errorCallBack(responseLatest) {

                subCategories.returndata = sampledata;
                $scope.subCategories.push(subCategories);
            });
        }

        $scope.Showgallery = function() {
            ngDialog.open({
                template: 'newEssay/dialogGallery.html',
                width: '650px',
                scope: $scope
            });
            $scope.loadGallery();
        }
        $scope.uploadMedia = false;
        $scope.Gallery = false;
        $scope.uploads = {
            files: '',
            path: ''
        }
        $scope.ChangeMedia = function(option) {
            if (option == "G") {
                $scope.uploadMedia = false;
                $scope.Gallery = true;
            } else {
                $scope.Gallery = false;
                $scope.uploadMedia = true;
            }


        }




        $scope.uploadFile = function() {
            var fd = new FormData();
            //Take the first selected file
            var udata = $scope.uData;
            var urole = JSON.parse(tokenService.getUserData());

            $scope.userData = {
                id: udata.id,
                name: udata.name,
                uname: udata.uname,
                utype: tokenService.getUserRole()
            };
            $scope.uploads.files.fieldname = udata.uname;

            fd.append('file', $scope.uploads.files);
            fd.append("user", JSON.stringify($scope.userData));


            var posturl = baseApiUrl + "/gallery/upload";


            $http.post(posturl, fd, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined },
                params: {
                    'folderName': udata.uname
                }
            })

            .success(function(response, status, headers, config) {
                if (response.data) {
                    $scope.loadGallery();
                    $scope.ChangeMedia("G");
                }
            })

            .error(function(data, status, headers, config) {
                //MyService.ConsoleLog("error");
            });
        };

        $scope.ShowPath = false;

        $scope.ShowSelectedPath = function(filePath) {
            $scope.uploads.path = $scope.GalleryFolder + "/" + filePath;
            $scope.ShowPath = true;
        }

        $scope.goBack = function() {
            var len = $rootScope.allEssaycategories.length;
            var type = 'home';
            if (len > 2) {
                type = "subcat";
            }
            $location.path('/essay/' + $routeParams.categoryId + '/home');
            //$location.path('essay/' + $rootScope.allEssaycategories[len - 2] + '/' + $rootScope.allEssaycategories[len - 1] + "/" + type);
        }

        if (($routeParams.eid) && ($routeParams.categoryId)) {
            $scope.getEssay();
            MyService.getAllCountries().then(function(payload) {
                    $scope.Allcountries = payload;
                },
                function(errorPayload) {
                    alert('Something went wrong ');
                });
            $("form").validationEngine();
        } else {
            $location.path('essay/' + $routeParams.categoryId);
        }
    }]);

'use strict';
angular.module('myApp.essayStaff', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
        $routeProvider.when('/essayStaff/:categoryId/:subcatId?/:type?', {
            templateUrl: 'app/essayStaff/essayStaff.html',
            controller: 'essayStaffCtrl'
        });
    }])
    .controller('essayStaffCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'baseApiUrl', 'MyService', 'tokenService', 'growl', '$templateCache', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, baseApiUrl, MyService, tokenService, growl, $templateCache) {
        $scope.imgUrl = baseApiUrl + "/resources";
        $scope.categoryId = $routeParams.categoryId;
        $scope.subcategoryId = $routeParams.subcatId;
        $scope.userId = tokenService.getUserId();
        $scope.userRole = tokenService.getUserRole();
        $rootScope.welcome = false;
        if(tokenService.getUserData()) {
            $scope.userData = JSON.parse(tokenService.getUserData());
        }


        $scope.ShowAdavace = false;
        if ($routeParams.query) {
            $scope.search = {
                text: $routeParams.query,
                subject: '',
                Locations: '',
                mediaoption: [],
                mediaType: '',
                dateBefore: '',
                dateAfter: '',
                matchFrom: '',
                matchTo: '',
                recommendFrom: '',
                recommendTo: '',
                factualFrom: '',
                factualTo: '',
                fromfollowlist: '',
                order: '',
                recommendorder: '',
                lrecommendorder: '',
                factualorder: '',
                lfactualorder: ''

            };
        } else {
            $scope.search = {
                text: '',
                subject: '',
                Locations: '',
                mediaoption: [],
                mediaType: '',
                dateBefore: '',
                dateAfter: '',
                matchFrom: '',
                matchTo: '',
                recommendFrom: '',
                recommendTo: '',
                factualFrom: '',
                factualTo: '',
                fromfollowlist: '',
                recommendorder: '',
                lrecommendorder: '',
                factualorder: '',
                lfactualorder: '',
                order: ''
            };
        }

        $scope.showRefineLocation = false;

        $scope.Location = ["International", "National", "My State", "My County", "My Local", "Other Specific"];
        $scope.mediaType = ['Text', 'Video', 'Stills', 'Audio'];
        $scope.dateRange = ['Today', 'In the last week', 'In the last month', 'In the last year'];
        $scope.users = ["Voters", "Advocates", "Press", "Politicians", "Authors on my follow list"];
        $scope.searchResults = {
            data: []
        };
        $scope.selectedCat = [];
        $scope.subtopics = {
            subcategories: []
        }
        $scope.disabled = [];
        $scope.allLocations = [];
        $scope.allCounties = [];
        $scope.selectedArea = [];
        $scope.rmselectedArea = [];
        $scope.myselectionarea = [];
        $scope.disabledLocation = [];
        $scope.ShowSubcatTree = false;

        $scope.selectConfig = {
            requiredMin: 1,
            selectAll: true
        };


        $scope.getStaffEssayList = function() {
            $scope.searchResults.data.length = 0;
            var nrequest = apiCall.apiCall('GET', '/essay/staffEssayList', { maincatId: $routeParams.categoryId, subcatId: $routeParams.subcatId });
            $http(
                nrequest
            ).then(function successCallback(responseLatest) {
                if (responseLatest.data.success) {
                    var finalData = responseLatest.data.data;
                    var flen = finalData.length;
                    //$scope.staffResults.data = finalData;

                    for (var s = 0; s < flen; s++) {
                        if (finalData[s].recommended.length > 0) {
                            finalData[s].recavg = $scope.calculateAvg(finalData[s].recommended);
                            finalData[s].recavgvoters = $scope.calculateAvgType(finalData[s].recommended, 'voter');
                            finalData[s].recavgpolitician = $scope.calculateAvgType(finalData[s].recommended, 'politician');
                            finalData[s].recavgadvocate = $scope.calculateAvgType(finalData[s].recommended, 'advocate');
                            finalData[s].recavgpress = $scope.calculateAvgType(finalData[s].recommended, 'press');
                        } else {
                            finalData[s].recavg = 0;
                            finalData[s].recavgvoters = 0;
                            finalData[s].recavgpolitician = 0;
                            finalData[s].recavgadvocate = 0;
                            finalData[s].recavgpress = 0;
                        }
                        if (finalData[s].factual.length > 0) {
                            finalData[s].factfavg = $scope.calculateAvg(finalData[s].factual);
                            finalData[s].factfavgvoters = $scope.calculateAvgType(finalData[s].factual, 'voter');
                            finalData[s].factfavgpolitician = $scope.calculateAvgType(finalData[s].factual, 'politician');
                            finalData[s].factfavgadvocate = $scope.calculateAvgType(finalData[s].factual, 'advocate');
                            finalData[s].factfavgpress = $scope.calculateAvgType(finalData[s].factual, 'press');
                        } else {
                            finalData[s].factfavg = 0;
                            finalData[s].factfavgvoters = 0;
                            finalData[s].factfavgpolitician = 0;
                            finalData[s].factfavgadvocate = 0;
                            finalData[s].factfavgpress = 0;
                        }
                        //MyService.ConsoleLog("finalData[s] :", finalData[s]);
                        $scope.searchResults.data.push(finalData[s]);
                    }

                }
            }, function errorCallBack(responseLatest) {
                alert("Error : " + responseLatest);
            });
        }

        $scope.checkCatExists = function(rdata, val) {
            return rdata.filter(
                function(rdata) {
                    if (rdata._id == val) {
                        $scope.selectedCat.push(rdata);
                        return rdata
                    } else if (rdata.subcategories) {
                        $scope.checkCatExists(rdata.subcategories, val)
                    }
                }
            );
        }

        $scope.mainCatTree = [];

        $scope.getSubcatTree = function() {
            //MyService.ConsoleLog($scope.mainCatTree);
            if ($scope.mainCatTree.length == 0) {
                $scope.ShowSubcatTree = true;

                MyService.getAllCatTree().then(function(payload) {
                        $scope.subtopics.subcategories.length = 0;
                        $scope.mainCatTree = angular.copy(payload);
                        var subcatdata = payload;
                        $scope.ShowSubcatTree = false;

                        $scope.subtopics.subcategories = subcatdata;
                        var selectedCat = $scope.disabled;
                        if (selectedCat.length > 0) {
                            for (var s = 0; s < selectedCat.length; s++) {
                                var checkcatdata = $scope.checkCatExists(subcatdata, selectedCat[s]);
                            }
                            //MyService.ConsoleLog($scope.selectedCat);
                        }
                        setTimeout(function() {
                            var cols = document.getElementsByClassName('cmnUL');
                            var clen = cols.length;
                            for (var i = 0; i < clen; i++) {
                                cols[i].style.display = "none";
                            }
                        }, 300);
                    },
                    function(errorPayload) {
                        alert('Something went wrong ');
                    });
            } else {

                //MyService.ConsoleLog("After : " + $scope.subtopics.subcategories.length);
                if ($scope.subtopics.subcategories.length == 0) {
                    $scope.subtopics.subcategories = angular.copy($scope.mainCatTree);

                } else {;
                    $scope.subtopics.subcategories.length = 0;

                }


                $scope.ShowSubcatTree = false;
                //MyService.ConsoleLog("After : " + $scope.subtopics.subcategories);
                //MyService.ConsoleLog("After : " + $scope.ShowSubcatTree);
            }

        }



        $scope.AllStates = [];
        $scope.allCounties = [];
        $scope.allLocals = [];
        $scope.showSubCat = true;
        $scope.showLoading = [];
        $scope.showLoadingCounty = [];
        $scope.showDown = [];

        $scope.getAllStates = function() {
            $scope.ShowStateLoader = true;
            if ($scope.AllStates.length == 0) {
                MyService.getAllStates().then(function(payload) {
                        $scope.ShowStateLoader = false;
                        $scope.allLocations.length = 0;
                        var subcatdata = payload;
                        $scope.AllStates = angular.copy(subcatdata);
                        //MyService.ConsoleLog("countires : ", subcatdata);
                        $scope.allLocations = subcatdata;
                    },
                    function(errorPayload) {
                        alert('Something went wrong ');
                    });
            } else {
                if (!$scope.showStates) {
                    $scope.allLocations.length = 0;
                    $scope.ShowStateLoader = false;
                } else {
                    $scope.allLocations = angular.copy($scope.AllStates);
                    $scope.ShowStateLoader = false;
                }
            }

        }


        $scope.getCounties = function(state) {
            $scope.showLoading.push(state);
            if (!$scope.allCounties[state] || $scope.allCounties[state].length == 0) {

                MyService.getAllCounties(state).then(function(payload) {
                        $scope.showLoading.length = 0;
                        var sublocations = payload;
                        if (!$scope.allCounties) {
                            $scope.allCounties = [];
                        }
                        $scope.allCounties[state] = sublocations;
                    },
                    function(errorPayload) {
                        alert('Something went wrong.');
                    });


            } else {
                $scope.showLoading.length = 0;
                $scope.allCounties[state].length = 0;
            }
        }

        $scope.getLocals = function(state, county) {
            $scope.showLoadingCounty.push(county);
            if (!$scope.allLocals[state] || !$scope.allLocals[state][county] || $scope.allLocals[state][county].length == 0) {

                MyService.getAllSubCountiesLocal(state, county).then(function(payload) {
                        $scope.showLoadingCounty.length = 0;
                        //MyService.ConsoleLog("sublocations Locals : ", sublocations);
                        if (!$scope.allLocals[state]) {
                            $scope.allLocals[state] = [];
                        }
                        $scope.allLocals[state][county] = payload;
                    },
                    function(errorPayload) {
                        alert('Something went wrong ');
                    });


            } else {
                $scope.showLoadingCounty.length = 0;
                $scope.allLocals[state][county].length = 0;
            }
        }





        $scope.showmediaType = false;
        $scope.showDateRange = false;
        $scope.showMatchAuthor = false;
        $scope.showEssayRating = false;
        $scope.showStates = false;
        $scope.showRefine = function(e, option) {
            e.preventDefault();
            switch (option) {
                case "Interest":
                    $scope.getSubcatTree();
                    break;
                case "Location":
                    if (!$scope.showRefineLocation)
                        $scope.showRefineLocation = true;
                    else
                        $scope.showRefineLocation = false;

                    break;
                case "AllLocation":
                    if (!$scope.showStates) {
                        $scope.showStates = true;

                    } else {
                        $scope.showStates = false;
                    }
                    $scope.getAllStates();
                    break;
                case "Media":
                    if (!$scope.showmediaType)
                        $scope.showmediaType = true;
                    else
                        $scope.showmediaType = false;
                    break;
                case "Date":
                    if (!$scope.showDateRange)
                        $scope.showDateRange = true;
                    else
                        $scope.showDateRange = false;
                    break;
                case "Author":
                    if (!$scope.showMatchAuthor)
                        $scope.showMatchAuthor = true;
                    else
                        $scope.showMatchAuthor = false;
                    break;
                case "EssayRated":
                    if (!$scope.showEssayRating)
                        $scope.showEssayRating = true;
                    else
                        $scope.showEssayRating = false;
                    break;
                case "Default":
                    break;

            }
        }


        $scope.showSubCat = true;
        $scope.showLoading = [];
        $scope.showLoadingCounty = [];
        $scope.showDown = [];
        $scope.ChangeShow = function(id) {
            $scope.showSubCat = true;

            var nclass = "MainCatLi_" + id;
            if ((document.getElementsByClassName(nclass)[0].style.display) && (document.getElementsByClassName(nclass)[0].style.display == "none")) {
                document.getElementsByClassName(nclass)[0].style.display = "block";
            } else {
                document.getElementsByClassName(nclass)[0].style.display = "none";
            }
        }


        function areEqual() {
            var len = arguments.length;
            for (var i = 1; i < len; i++) {
                if (arguments[i] == null || arguments[i] != arguments[i - 1])
                    return false;
            }
            return true;
        }

        function indexOfExt(list, item) {
            var len = list.length;

            for (var i = 0; i < len; i++) {
                var keys = Object.keys(list[i]);
                var flg = true;
                var arr = [];


                for (var j = 0, s = 1; j < keys.length; j++, s++) {
                    var value = list[i][keys[j]];
                    if (item[keys[j]] !== value) {
                        flg = false;

                    }

                    if (item[keys[j]] == value) {
                        arr.push(flg);
                    }


                }
                if (flg == true) {
                    if (areEqual(arr.length, keys.length, Object.keys(item).length)) {
                        return i;
                    }

                }


            }
            return -1;
        }

        $scope.findLocations = [];
        $scope.Interests = [];
        $scope.MyLocation = [];
        $scope.SelectDefaultLocation = function(val) {
            //MyService.ConsoleLog("Data : ", val);
            var idx = $scope.MyLocation.indexOf(val);
            if (idx == -1) {
                $scope.MyLocation.push(val);
            } else {
                $scope.MyLocation.splice(idx, 1);
            }
            //MyService.ConsoleLog($scope.MyLocation);
        }

        $scope.selectLocation = function(val1, val2, val3, type) {
            //MyService.ConsoleLog(val1, val2, val3, type);
            var nobj = {};
            nobj.country = "United States of America";
            if (type == "state") {
                nobj.state = val1.state;
                nobj.statePostalCode = val1.statePostalCode;
            }
            if (type == "county") {
                nobj.state = val1.state;
                nobj.statePostalCode = val1.statePostalCode;
                nobj.county = val3;
            }
            if (type == "local") {
                nobj.state = val1.state;
                nobj.statePostalCode = val1.statePostalCode;
                nobj.county = val2;
                nobj.countySubdivision = val3.countySubdivision;
                nobj.place = val3.place;
            }
            //MyService.ConsoleLog("nboj:", nobj);
            var idx = indexOfExt($scope.findLocations, nobj);
            if (idx == -1) {
                $scope.findLocations.push(nobj);
            } else {
                $scope.findLocations.splice(idx, 1);
            }
        }



        $scope.getVal = function(data) {
            //MyService.ConsoleLog($scope.Interests);
            var idx = $scope.Interests.indexOf(data._id);
            if (idx == -1) {
                $scope.Interests.push(data._id);
            } else {
                $scope.Interests.splice(idx, 1);
            }
        }

        $scope.totalResults = 0;


        function addslashes(str) {
            return (str + '').replace(/[\\"']/g, '\\$&').replace(/\u0000/g, '\\0');
        }




        function cleanArray(actual) {
            var newArray = new Array();
            for (var i = 0; i < actual.length; i++) {
                if (actual[i]) {
                    newArray.push(actual[i]);
                }
            }
            return newArray;
        }

        function allnumeric(inputtxt) {
            var numbers = /^[0-9]+$/;
            if (inputtxt == undefined) {
                return false;
            }
            if (inputtxt.match(numbers)) {
                return true;
            } else {
                return false;
            }
        }


        $scope.calculateAvg = function(arr) {
            var reclen = arr.length;
            var recsum = 0;
            for (var r = 0; r < reclen; r++) {
                recsum += parseInt(arr[r].vote, 10);
                if (r == reclen - 1) {
                    var recavg = recsum / reclen;

                    return recavg;
                }
            }

            //return card.values.opt1 + card.values.opt2;
        };

        $scope.calculateAvgType = function(arr, type) {
            var reclen = arr.length;
            var recsum = 0;
            for (var r = 0; r < reclen; r++) {
                if (arr[r].user.utype == type) {
                    //MyService.ConsoleLog(arr[r].user.utype + "==" + type);
                    recsum += parseInt(arr[r].vote, 10);

                }
                if (r == reclen - 1) {
                    var recavg = recsum / reclen;

                    return recavg;
                }
            }

            //return card.values.opt1 + card.values.opt2;
        };

        $scope.calculateAvgId = function(arr, followlist) {
            var reclen = arr.length;
            var recsum = 0;
            for (var r = 0; r < reclen; r++) {
                var idx = followlist.indexOf(arr[r].user.id)
                if (idx > -1) {
                    //MyService.ConsoleLog(arr[r].user.utype + "==" + type);
                    recsum += parseInt(arr[r].vote, 10);

                }
                if (r == reclen - 1) {
                    var recavg = recsum / reclen;

                    return recavg;
                }
            }
        }

        $scope.getEssayListAdvance = function(data) {

            $scope.searchResults.data.length = 0;
            if ($scope.findLocations.length > 0) {
                data.searchlocations = JSON.stringify($scope.findLocations);
            }

            if ($scope.MyLocation.length > 0) {
                data.MyLocation = JSON.stringify($scope.MyLocation);
            }
            if (data.mediaoption) {
                var moption = data.mediaoption;
                if (typeof moption == "object") {
                    moption = Object.keys(moption).map(function(key) {
                        return moption[key]
                    });
                }
                if (typeof moption != "string") {
                    var media = cleanArray(moption);
                    data.mediaoption = JSON.stringify(media);
                }
            }
            data.subjectOfInterest = JSON.stringify($scope.Interests);
            var validateMatch = true,
                validateMatchTo = true,
                validateRecommend = true,
                validateTo = true;
            var msg = "";
            if (data.matchFrom != "") {
                validateMatch = allnumeric(data.matchFrom);
                if (($scope.Interests.length == 0) && validateMatch) {
                    msg = "Please select atleast one subject of interest";
                    validateMatch = false;
                }
            }

            if (data.matchTo != "") {
                validateMatchTo = allnumeric(data.matchTo);
                if (validateMatchTo && ($scope.Interests.length == 0)) {
                    msg = "Please select atleast one subject of interest";
                    validateMatchTo = false;
                }
            }

            if (data.recommendFrom != "") {
                validateRecommend = allnumeric(data.recommendFrom);
            }
            if (data.recommendTo != "") {
                validateTo = allnumeric(data.recommendTo);
            }

            if (validateMatch && validateMatchTo && validateRecommend && validateTo) {
                $scope.searchResults.data.length = 0;
                $scope.totalResults = 0;
                var nrequest = apiCall.apiCall('POST', '/essay/AdvanceSearch', data);
                $http(
                    nrequest
                ).then(function successCallback(responseLatest) {
                    //MyService.ConsoleLog("Final Advance Data");
                    //MyService.ConsoleLog(responseLatest.data.data);
                    $scope.searchResults.data.length = 0;
                    if (responseLatest.data.success) {
                        var finalData = responseLatest.data.data;
                        //MyService.ConsoleLog("finalData:", finalData.length);
                        var flen = finalData.length;
                        $scope.searchResults.data.length = 0;
                        //MyService.ConsoleLog("Results :", $scope.searchResults.data);
                        $templateCache.removeAll();
                        for (var s = 0; s < flen; s++) {
                            if (finalData[s].recommended.length > 0) {
                                finalData[s].recavg = $scope.calculateAvg(finalData[s].recommended);
                                finalData[s].recavgvoters = $scope.calculateAvgType(finalData[s].recommended, 'voter');
                                finalData[s].recavgpolitician = $scope.calculateAvgType(finalData[s].recommended, 'politician');
                                finalData[s].recavgadvocate = $scope.calculateAvgType(finalData[s].recommended, 'advocate');
                                finalData[s].recavgpress = $scope.calculateAvgType(finalData[s].recommended, 'press');
                                if (userData.followlist.length > 0) {
                                    finalData[s].recavgfollow = $scope.calculateAvgId(finalData[s].recommended, userData.followlist);
                                } else {
                                    finalData[s].recavgfollow = 0;
                                }

                            } else {
                                finalData[s].recavg = 0;
                                finalData[s].recavgvoters = 0;
                                finalData[s].recavgpolitician = 0;
                                finalData[s].recavgadvocate = 0;
                                finalData[s].recavgpress = 0;
                                finalData[s].recavgfollow = 0;
                            }
                            if (finalData[s].factual.length > 0) {
                                finalData[s].factfavg = $scope.calculateAvg(finalData[s].factual);
                                finalData[s].factfavgvoters = $scope.calculateAvgType(finalData[s].factual, 'voter');
                                finalData[s].factfavgpolitician = $scope.calculateAvgType(finalData[s].factual, 'politician');
                                finalData[s].factfavgadvocate = $scope.calculateAvgType(finalData[s].factual, 'advocate');
                                finalData[s].factfavgpress = $scope.calculateAvgType(finalData[s].factual, 'press');
                                if (userData.followlist.length > 0) {
                                    finalData[s].factfavgfollow = $scope.calculateAvgId(finalData[s].recommended, userData.followlist);
                                } else {
                                    finalData[s].factfavgfollow = 0;
                                }

                            } else {
                                finalData[s].factfavg = 0;
                                finalData[s].factfavgvoters = 0;
                                finalData[s].factfavgpolitician = 0;
                                finalData[s].factfavgadvocate = 0;
                                finalData[s].factfavgpress = 0;
                                finalData[s].factfavgfollow = 0;
                            }
                            //MyService.ConsoleLog("finalData[s] :", finalData[s]);
                            $scope.searchResults.data.push(finalData[s]);
                        }
                        $scope.totalResults = responseLatest.data.data.length;
                        data.mediaoption = "";
                        data.mediaoption = [];
                        data.mediaoption.length = 0;
                    }
                }, function errorCallBack(responseLatest) {
                    alert("Error : " + responseLatest);
                });
            } else {
                if (msg != "") {
                    alert(msg);
                } else {
                    alert("Please enter valid data");
                }

            }
        }
        $scope.ShowOrderList = false;
        $scope.showOrder = function() {
            if (!$scope.ShowOrderList) {
                $scope.ShowOrderList = true;
            } else {
                $scope.ShowOrderList = false;
            }
        }

        $scope.isreverse = false;
        $scope.showAvg = true;
        $scope.showVoters = false;
        $scope.showPolitician = false;
        $scope.showAdvocate = false;
        $scope.showPress = false;
        $scope.showFollow = false;
        $scope.showfAvg = true;
        $scope.showfVoters = false;
        $scope.showfPolitician = false;
        $scope.showfAdvocate = false;
        $scope.showfPress = false;
        $scope.showfFollow = false;
        $scope.resetAllOrder = function() {
            $scope.showAvg = false;
            $scope.showVoters = false;
            $scope.showPolitician = false;
            $scope.showAdvocate = false;
            $scope.showPress = false;
            $scope.showFollow = false;
        }

        $scope.resetAllfOrder = function() {
            $scope.showfAvg = false;
            $scope.showfVoters = false;
            $scope.showfPolitician = false;
            $scope.showfAdvocate = false;
            $scope.showfPress = false;
            $scope.showfFollow = false;
        }

        $scope.sortValues = function(data) {
            var result = "";
            $scope.resetAllOrder();
            $scope.resetAllfOrder();
            $scope.showfAvg = true;
            $scope.showAvg = true;


            switch ($scope.search.order) {
                case "Most Recent":
                    $scope.isreverse = true;
                    $scope.showAvg = true;
                    $scope.showfAvg = true;
                    result = data.createdOn;
                    break;
                case "Oldest":
                    $scope.isreverse = false;
                    $scope.showAvg = true;
                    $scope.showfAvg = true;
                    result = data.createdOn;
                    break;
                case "Highest Recommended":
                    $scope.resetAllOrder();
                    $scope.isreverse = true;
                    $scope.showAvg = true;
                    $scope.showfAvg = true;
                    result = data.recavg;
                    break;
                case "Least Recommended":
                    $scope.resetAllOrder();
                    $scope.isreverse = false;
                    $scope.showAvg = true;
                    $scope.showfAvg = true;
                    result = data.recavg;
                    break;
                case "Most Factual":
                    $scope.resetAllfOrder();
                    $scope.isreverse = true;
                    $scope.showAvg = true;
                    $scope.showfAvg = true;
                    result = data.factfavg;
                    break;
                case "Least Factual":
                    $scope.resetAllfOrder();
                    $scope.isreverse = false;
                    $scope.showAvg = true;
                    $scope.showfAvg = true;
                    result = data.factfavg;
                    break;
                case "Default":
                    $scope.resetAllOrder();
                    $scope.resetAllfOrder();
                    $scope.isreverse = true;
                    result = data.createdOn;
                    $scope.showAvg = true;
                    $scope.showfAvg = true;
                    break;

            }

            switch ($scope.search.recommendorder) {
                case "Voters":
                    $scope.resetAllOrder();
                    $scope.showVoters = true;
                    $scope.isreverse = true;
                    result = data.recavgvoters;
                    break;
                case "Politicians":
                    $scope.resetAllOrder();
                    $scope.showPolitician = true;
                    $scope.isreverse = true;
                    result = data.recavgpolitician;
                    break;
                case "Advocates":
                    $scope.resetAllOrder();
                    $scope.showAdvocate = true;
                    $scope.isreverse = true;
                    result = data.recavgadvocate;
                    break;
                case "Press":
                    $scope.resetAllOrder();
                    $scope.showPress = true;
                    $scope.isreverse = true;
                    result = data.recavgpress;
                    break;
                case "Authors on my follow list":
                    $scope.resetAllOrder();
                    $scope.showFollow = true;
                    $scope.isreverse = true;
                    result = data.recavgfollow;
                    break;
                case "Default":
                    $scope.resetAllOrder();
                    $scope.showAvg = true;

                    break;

            }

            switch ($scope.search.lrecommendorder) {
                case "Voters":
                    $scope.resetAllOrder();
                    $scope.showVoters = true;
                    $scope.isreverse = false;
                    result = data.recavgvoters;
                    break;
                case "Politicians":
                    $scope.resetAllOrder();
                    $scope.showPolitician = true;
                    $scope.isreverse = false;
                    result = data.recavgpolitician;
                    break;
                case "Advocates":
                    $scope.resetAllOrder();
                    $scope.showAdvocate = true;
                    $scope.isreverse = false;
                    result = data.recavgadvocate;
                    break;
                case "Press":
                    $scope.resetAllOrder();
                    $scope.showPress = true;
                    $scope.isreverse = false;
                    result = data.recavgpress;
                    break;
                case "Authors on my follow list":
                    $scope.resetAllOrder();
                    $scope.showFollow = true;
                    $scope.isreverse = false;
                    result = data.recavgfollow;
                    break;
                case "Default":
                    $scope.resetAllOrder();
                    $scope.showAvg = true;
                    break;

            }

            switch ($scope.search.factualorder) {
                case "Voters":
                    $scope.resetAllfOrder();
                    $scope.showfVoters = true;
                    $scope.isreverse = true;
                    result = data.factfavgvoters;
                    break;
                case "Politicians":
                    $scope.resetAllfOrder();
                    $scope.showfPolitician = true;
                    $scope.isreverse = true;
                    result = data.factfavgpolitician;
                    break;
                case "Advocates":
                    $scope.resetAllfOrder();
                    $scope.showfAdvocate = true;
                    $scope.isreverse = true;
                    result = data.factfavgadvocate;
                    break;
                case "Press":
                    $scope.resetAllfOrder();
                    $scope.showfPress = true;
                    $scope.isreverse = true;
                    result = data.factfavgpress;
                    break;
                case "Authors on my follow list":
                    $scope.resetAllOrder();
                    $scope.showfFollow = true;
                    $scope.isreverse = true;
                    result = data.factfavgfollow;
                    break;
                case "Default":
                    $scope.resetAllfOrder();
                    $scope.showfAvg = true;
                    break;

            }

            switch ($scope.search.lfactualorder) {
                case "Voters":
                    $scope.resetAllfOrder();
                    $scope.showfVoters = true;
                    $scope.isreverse = false;
                    result = data.factfavgvoters;
                    break;
                case "Politicians":
                    $scope.resetAllfOrder();
                    $scope.showfPolitician = true;
                    $scope.isreverse = false;
                    result = data.factfavgpolitician;
                    break;
                case "Advocates":
                    $scope.resetAllfOrder();
                    $scope.showfAdvocate = true;
                    $scope.isreverse = false;
                    result = data.factfavgadvocate;
                    break;
                case "Press":
                    $scope.resetAllfOrder();
                    $scope.showfPress = true;
                    $scope.isreverse = false;
                    result = data.factfavgpress;
                    break;
                case "Authors on my follow list":
                    $scope.resetAllOrder();
                    $scope.showfFollow = true;
                    $scope.isreverse = false;
                    result = data.factfavgfollow;
                    break;
                case "Default":
                    $scope.resetAllfOrder();
                    $scope.showfAvg = true;
                    break;

            }
            //MyService.ConsoleLog($scope.search);
            //MyService.ConsoleLog(result);
            return result;

        }

        $scope.HighestRecommended = false;
        $scope.LeastRecommended = false;
        $scope.MostFactual = false;
        $scope.LeastFactual = false;
        $scope.ShowUsers = function(option) {
            switch (option) {
                case "HighestRecommended":
                    if (!$scope.HighestRecommended) {
                        $scope.HighestRecommended = true;
                    } else {
                        $scope.HighestRecommended = false;
                    }
                    break;
                case "LeastRecommended":
                    if (!$scope.LeastRecommended) {
                        $scope.LeastRecommended = true;
                    } else {
                        $scope.LeastRecommended = false;
                    }
                    break;
                case "MostFactual":
                    if (!$scope.MostFactual) {
                        $scope.MostFactual = true;
                    } else {
                        $scope.MostFactual = false;
                    }
                    break;
                case "LeastFactual":
                    if (!$scope.LeastFactual) {
                        $scope.LeastFactual = true;
                    } else {
                        $scope.LeastFactual = false;
                    }
                    break;
                case "Default":
                    $scope.HighestRecommended = false;
                    break;
            }
        }

        $scope.gotoThread = function(data) {
            var id = data;
            //MyService.ConsoleLog(data);
            $location.path('essayDetails/' + $routeParams.categoryId + '/' + id);
        }

        $scope.GotoEdit = function(id) {
            $location.path('/essayUpdate/' + $routeParams.categoryId + '/' + id);
        }

        $scope.removeEssay = function(mydata, idx) {

            var message = 'Are you sure you want to delete this Essay?';

            var modal = ngDialog.openConfirm({
                template: '<p>' + message + '</p>\
            <div class="ngdialog-buttons">\
                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">YES</button>\
                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">NO</button>\
            </div>',
                plain: true
            });
            modal.then(function fullfilled(data) {
                //MyService.ConsoleLog("fullfilled: ", mydata);
                MyService.removeEssay({ "id": mydata._id }).then(function(payload) {
                    //MyService.ConsoleLog(payload);
                    //$scope.UserFormDiv = false;
                    $scope.getStaffEssayList();
                    
                    alert("Essay deleted successfully.");
                }, function(error) {
                    alert(JSON.stringify(error));
                });
            }, function rejected(data) {
                MyService.ConsoleLog("rejected: ", data);
            });
        }


        $scope.showadvace = function() {
            $scope.ShowAdavace = true;
            var query = $scope.search.text;
            $scope.search = {
                text: query,
                subject: '',
                Locations: '',
                mediaoption: [],
                mediaType: '',
                dateBefore: '',
                dateAfter: '',
                matchFrom: '',
                matchTo: '',
                recommendFrom: '',
                recommendTo: '',
                factualFrom: '',
                factualTo: '',
                order: '',
                recommendorder: '',
                lrecommendorder: '',
                factualorder: '',
                lfactualorder: '',
                fromfollowlist: ''
            };
        }

        if ($routeParams.categoryId) {

            $scope.getStaffEssayList();
        }
    }]);

'use strict';
angular.module('myApp.essaySearch', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
        $routeProvider.when('/essaySearch/:categoryId/:subcatId?/:type?', {
            templateUrl: 'app/essaySearch/essaySearch.html',
            controller: 'essaySearchCtrl'
        });
    }])
    .controller('essaySearchCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'baseApiUrl', 'MyService', 'tokenService', 'growl', '$templateCache', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, baseApiUrl, MyService, tokenService, growl, $templateCache) {
        $scope.imgUrl = baseApiUrl + "/resources";
        $scope.categoryId = $routeParams.categoryId;
        $scope.subcategoryId = $routeParams.subcatId;
        $scope.userId = tokenService.getUserId();
        $scope.userRole = tokenService.getUserRole();
        $scope.userData = JSON.parse(tokenService.getUserData());
        $rootScope.welcome = false;

        $scope.ShowAdavace = false;
        if ($routeParams.query) {
            $scope.search = {
                text: $routeParams.query,
                subject: '',
                Locations: '',
                mediaoption: [],
                mediaType: '',
                dateBefore: '',
                dateAfter: '',
                matchFrom: '',
                matchTo: '',
                recommendFrom: '',
                recommendTo: '',
                factualFrom: '',
                factualTo: '',
                fromfollowlist: '',
                order: '',
                recommendorder: '',
                lrecommendorder: '',
                factualorder: '',
                lfactualorder: ''

            };
        } else {
            $scope.search = {
                text: '',
                subject: '',
                Locations: '',
                mediaoption: [],
                mediaType: '',
                dateBefore: '',
                dateAfter: '',
                matchFrom: '',
                matchTo: '',
                recommendFrom: '',
                recommendTo: '',
                factualFrom: '',
                factualTo: '',
                fromfollowlist: '',
                recommendorder: '',
                lrecommendorder: '',
                factualorder: '',
                lfactualorder: '',
                order: ''
            };
        }

        $scope.showRefineLocation = false;

        $scope.Location = ["International", "National", "My State", "My County", "My Local", "Other Specific"];
        $scope.mediaType = ['Text', 'Video', 'Stills', 'Audio'];
        $scope.dateRange = ['Today', 'In the last week', 'In the last month', 'In the last year'];
        $scope.users = ["Voters", "Advocates", "Press", "Politicians", "Authors on my follow list"];
        $scope.searchResults = {
            data: []
        };
        $scope.selectedCat = [];
        $scope.subtopics = {
            subcategories: []
        }
        $scope.disabled = [];
        $scope.allLocations = [];
        $scope.allCounties = [];
        $scope.selectedArea = [];
        $scope.rmselectedArea = [];
        $scope.myselectionarea = [];
        $scope.disabledLocation = [];
        $scope.ShowSubcatTree = false;

        $scope.selectConfig = {
            requiredMin: 1,
            selectAll: true
        };


        $scope.getEssayList = function() {
            $scope.searchResults.data.length = 0;
            var nrequest = apiCall.apiCall('GET', '/essay/getList', { maincatId: $routeParams.categoryId, subcatId: $routeParams.subcatId });
            $http(
                nrequest
            ).then(function successCallback(responseLatest) {
                if (responseLatest.data.success) {
                    var finalData = responseLatest.data.data;
                    var flen = finalData.length;
                    for (var s = 0; s < flen; s++) {
                        if (finalData[s].recommended.length > 0) {
                            finalData[s].recavg = $scope.calculateAvg(finalData[s].recommended);
                            finalData[s].recavgvoters = $scope.calculateAvgType(finalData[s].recommended, 'voter');
                            finalData[s].recavgpolitician = $scope.calculateAvgType(finalData[s].recommended, 'politician');
                            finalData[s].recavgadvocate = $scope.calculateAvgType(finalData[s].recommended, 'advocate');
                            finalData[s].recavgpress = $scope.calculateAvgType(finalData[s].recommended, 'press');
                        } else {
                            finalData[s].recavg = 0;
                            finalData[s].recavgvoters = 0;
                            finalData[s].recavgpolitician = 0;
                            finalData[s].recavgadvocate = 0;
                            finalData[s].recavgpress = 0;
                        }
                        if (finalData[s].factual.length > 0) {
                            finalData[s].factfavg = $scope.calculateAvg(finalData[s].factual);
                            finalData[s].factfavgvoters = $scope.calculateAvgType(finalData[s].factual, 'voter');
                            finalData[s].factfavgpolitician = $scope.calculateAvgType(finalData[s].factual, 'politician');
                            finalData[s].factfavgadvocate = $scope.calculateAvgType(finalData[s].factual, 'advocate');
                            finalData[s].factfavgpress = $scope.calculateAvgType(finalData[s].factual, 'press');
                        } else {
                            finalData[s].factfavg = 0;
                            finalData[s].factfavgvoters = 0;
                            finalData[s].factfavgpolitician = 0;
                            finalData[s].factfavgadvocate = 0;
                            finalData[s].factfavgpress = 0;
                        }
                        //MyService.ConsoleLog("finalData[s] :", finalData[s]);
                        $scope.searchResults.data.push(finalData[s]);
                    }
                }
            }, function errorCallBack(responseLatest) {
                alert("Error : " + responseLatest);
            });
        }

        $scope.checkCatExists = function(rdata, val) {
            return rdata.filter(
                function(rdata) {
                    if (rdata._id == val) {
                        $scope.selectedCat.push(rdata);
                        return rdata
                    } else if (rdata.subcategories) {
                        $scope.checkCatExists(rdata.subcategories, val)
                    }
                }
            );
        }

        $scope.mainCatTree = [];

        $scope.getSubcatTree = function() {
            //MyService.ConsoleLog($scope.mainCatTree);
            if ($scope.mainCatTree.length == 0) {
                $scope.ShowSubcatTree = true;

                MyService.getAllCatTree().then(function(payload) {
                        $scope.subtopics.subcategories.length = 0;
                        $scope.mainCatTree = angular.copy(payload);
                        var subcatdata = payload;
                        $scope.ShowSubcatTree = false;

                        $scope.subtopics.subcategories = subcatdata;
                        var selectedCat = $scope.disabled;
                        if (selectedCat.length > 0) {
                            for (var s = 0; s < selectedCat.length; s++) {
                                var checkcatdata = $scope.checkCatExists(subcatdata, selectedCat[s]);
                            }
                            //MyService.ConsoleLog($scope.selectedCat);
                        }
                        setTimeout(function() {
                            var cols = document.getElementsByClassName('cmnUL');
                            var clen = cols.length;
                            for (var i = 0; i < clen; i++) {
                                cols[i].style.display = "none";
                            }
                        }, 300);
                    },
                    function(errorPayload) {
                        alert('Something went wrong ');
                    });
            } else {

                //MyService.ConsoleLog("After : " + $scope.subtopics.subcategories.length);
                if ($scope.subtopics.subcategories.length == 0) {
                    $scope.subtopics.subcategories = angular.copy($scope.mainCatTree);

                } else {;
                    $scope.subtopics.subcategories.length = 0;

                }


                $scope.ShowSubcatTree = false;
                //MyService.ConsoleLog("After : " + $scope.subtopics.subcategories);
                //MyService.ConsoleLog("After : " + $scope.ShowSubcatTree);
            }

        }



        $scope.AllStates = [];
        $scope.allCounties = [];
        $scope.allLocals = [];
        $scope.showSubCat = true;
        $scope.showLoading = [];
        $scope.showLoadingCounty = [];
        $scope.showDown = [];

        $scope.getAllStates = function() {
            $scope.ShowStateLoader = true;
            if ($scope.AllStates.length == 0) {
                MyService.getAllStates().then(function(payload) {
                        $scope.ShowStateLoader = false;
                        $scope.allLocations.length = 0;
                        var subcatdata = payload;
                        $scope.AllStates = angular.copy(subcatdata);
                        //MyService.ConsoleLog("countires : ", subcatdata);
                        $scope.allLocations = subcatdata;
                    },
                    function(errorPayload) {
                        alert('Something went wrong ');
                    });
            } else {
                if (!$scope.showStates) {
                    $scope.allLocations.length = 0;
                    $scope.ShowStateLoader = false;
                } else {
                    $scope.allLocations = angular.copy($scope.AllStates);
                    $scope.ShowStateLoader = false;
                }
            }

        }


        $scope.getCounties = function(state) {
            $scope.showLoading.push(state);
            if (!$scope.allCounties[state] || $scope.allCounties[state].length == 0) {

                MyService.getAllCounties(state).then(function(payload) {
                        $scope.showLoading.length = 0;
                        var sublocations = payload;
                        if (!$scope.allCounties) {
                            $scope.allCounties = [];
                        }
                        $scope.allCounties[state] = sublocations;
                    },
                    function(errorPayload) {
                        alert('Something went wrong.');
                    });


            } else {
                $scope.showLoading.length = 0;
                $scope.allCounties[state].length = 0;
            }
        }

        $scope.getLocals = function(state, county) {
            $scope.showLoadingCounty.push(county);
            if (!$scope.allLocals[state] || !$scope.allLocals[state][county] || $scope.allLocals[state][county].length == 0) {

                MyService.getAllSubCountiesLocal(state, county).then(function(payload) {
                        $scope.showLoadingCounty.length = 0;
                        //MyService.ConsoleLog("sublocations Locals : ", sublocations);
                        if (!$scope.allLocals[state]) {
                            $scope.allLocals[state] = [];
                        }
                        $scope.allLocals[state][county] = payload;
                    },
                    function(errorPayload) {
                        alert('Something went wrong ');
                    });


            } else {
                $scope.showLoadingCounty.length = 0;
                $scope.allLocals[state][county].length = 0;
            }
        }





        $scope.showmediaType = false;
        $scope.showDateRange = false;
        $scope.showMatchAuthor = false;
        $scope.showEssayRating = false;
        $scope.showStates = false;
        $scope.showRefine = function(e, option) {
            e.preventDefault();
            switch (option) {
                case "Interest":
                    $scope.getSubcatTree();
                    break;
                case "Location":
                    if (!$scope.showRefineLocation)
                        $scope.showRefineLocation = true;
                    else
                        $scope.showRefineLocation = false;

                    break;
                case "AllLocation":
                    if (!$scope.showStates) {
                        $scope.showStates = true;

                    } else {
                        $scope.showStates = false;
                    }
                    $scope.getAllStates();
                    break;
                case "Media":
                    if (!$scope.showmediaType)
                        $scope.showmediaType = true;
                    else
                        $scope.showmediaType = false;
                    break;
                case "Date":
                    if (!$scope.showDateRange)
                        $scope.showDateRange = true;
                    else
                        $scope.showDateRange = false;
                    break;
                case "Author":
                    if (!$scope.showMatchAuthor)
                        $scope.showMatchAuthor = true;
                    else
                        $scope.showMatchAuthor = false;
                    break;
                case "EssayRated":
                    if (!$scope.showEssayRating)
                        $scope.showEssayRating = true;
                    else
                        $scope.showEssayRating = false;
                    break;
                case "Default":
                    break;

            }
        }


        $scope.showSubCat = true;
        $scope.showLoading = [];
        $scope.showLoadingCounty = [];
        $scope.showDown = [];
        $scope.ChangeShow = function(id) {
            $scope.showSubCat = true;

            var nclass = "MainCatLi_" + id;
            if ((document.getElementsByClassName(nclass)[0].style.display) && (document.getElementsByClassName(nclass)[0].style.display == "none")) {
                document.getElementsByClassName(nclass)[0].style.display = "block";
            } else {
                document.getElementsByClassName(nclass)[0].style.display = "none";
            }
        }


        function areEqual() {
            var len = arguments.length;
            for (var i = 1; i < len; i++) {
                if (arguments[i] == null || arguments[i] != arguments[i - 1])
                    return false;
            }
            return true;
        }

        function indexOfExt(list, item) {
            var len = list.length;

            for (var i = 0; i < len; i++) {
                var keys = Object.keys(list[i]);
                var flg = true;
                var arr = [];


                for (var j = 0, s = 1; j < keys.length; j++, s++) {
                    var value = list[i][keys[j]];
                    if (item[keys[j]] !== value) {
                        flg = false;

                    }

                    if (item[keys[j]] == value) {
                        arr.push(flg);
                    }


                }
                if (flg == true) {
                    if (areEqual(arr.length, keys.length, Object.keys(item).length)) {
                        return i;
                    }

                }


            }
            return -1;
        }

        $scope.findLocations = [];
        $scope.Interests = [];
        $scope.MyLocation = [];
        $scope.SelectDefaultLocation = function(val) {
            //MyService.ConsoleLog("Data : ", val);
            var idx = $scope.MyLocation.indexOf(val);
            if (idx == -1) {
                $scope.MyLocation.push(val);
            } else {
                $scope.MyLocation.splice(idx, 1);
            }
            //MyService.ConsoleLog($scope.MyLocation);
        }

        $scope.selectLocation = function(val1, val2, val3, type) {
            //MyService.ConsoleLog(val1, val2, val3, type);
            var nobj = {};
            nobj.country = "United States of America";
            if (type == "state") {
                nobj.state = val1.state;
                nobj.statePostalCode = val1.statePostalCode;
            }
            if (type == "county") {
                nobj.state = val1.state;
                nobj.statePostalCode = val1.statePostalCode;
                nobj.county = val3;
            }
            if (type == "local") {
                nobj.state = val1.state;
                nobj.statePostalCode = val1.statePostalCode;
                nobj.county = val2;
                nobj.countySubdivision = val3.countySubdivision;
                nobj.place = val3.place;
            }
            //MyService.ConsoleLog("nboj:", nobj);
            var idx = indexOfExt($scope.findLocations, nobj);
            if (idx == -1) {
                $scope.findLocations.push(nobj);
            } else {
                $scope.findLocations.splice(idx, 1);
            }
        }



        $scope.getVal = function(data) {
            //MyService.ConsoleLog($scope.Interests);
            var idx = $scope.Interests.indexOf(data._id);
            if (idx == -1) {
                $scope.Interests.push(data._id);
            } else {
                $scope.Interests.splice(idx, 1);
            }
        }

        $scope.totalResults = 0;


        function addslashes(str) {
            return (str + '').replace(/[\\"']/g, '\\$&').replace(/\u0000/g, '\\0');
        }




        function cleanArray(actual) {
            var newArray = new Array();
            for (var i = 0; i < actual.length; i++) {
                if (actual[i]) {
                    newArray.push(actual[i]);
                }
            }
            return newArray;
        }

        function allnumeric(inputtxt) {
            var numbers = /^[0-9]+$/;
            if (inputtxt == undefined) {
                return false;
            }
            if (inputtxt.match(numbers)) {
                return true;
            } else {
                return false;
            }
        }


        $scope.calculateAvg = function(arr) {
            var reclen = arr.length;
            var recsum = 0;
            for (var r = 0; r < reclen; r++) {
                recsum += parseInt(arr[r].vote, 10);
                if (r == reclen - 1) {
                    var recavg = recsum / reclen;

                    return recavg;
                }
            }

            //return card.values.opt1 + card.values.opt2;
        };

        $scope.calculateAvgType = function(arr, type) {
            var reclen = arr.length;
            var recsum = 0;
            for (var r = 0; r < reclen; r++) {
                if (arr[r].user.utype == type) {
                    //MyService.ConsoleLog(arr[r].user.utype + "==" + type);
                    recsum += parseInt(arr[r].vote, 10);

                }
                if (r == reclen - 1) {
                    var recavg = recsum / reclen;

                    return recavg;
                }
            }

            //return card.values.opt1 + card.values.opt2;
        };

        $scope.calculateAvgId = function(arr, followlist) {
            var reclen = arr.length;
            var recsum = 0;
            for (var r = 0; r < reclen; r++) {
                var idx = followlist.indexOf(arr[r].user.id)
                if (idx > -1) {
                    //MyService.ConsoleLog(arr[r].user.utype + "==" + type);
                    recsum += parseInt(arr[r].vote, 10);

                }
                if (r == reclen - 1) {
                    var recavg = recsum / reclen;

                    return recavg;
                }
            }
        }

        $scope.getEssayListAdvance = function(data) {

            $scope.searchResults.data.length = 0;
            if ($scope.findLocations.length > 0) {
                data.searchlocations = JSON.stringify($scope.findLocations);
            }

            if ($scope.MyLocation.length > 0) {
                data.MyLocation = JSON.stringify($scope.MyLocation);
            }
            if (data.mediaoption) {
                var moption = data.mediaoption;
                if (typeof moption == "object") {
                    moption = Object.keys(moption).map(function(key) {
                        return moption[key]
                    });
                }
                if (typeof moption != "string") {
                    var media = cleanArray(moption);
                    data.mediaoption = JSON.stringify(media);
                }
            }
            data.subjectOfInterest = JSON.stringify($scope.Interests);
            var validateMatch = true,
                validateMatchTo = true,
                validateRecommend = true,
                validateTo = true;
            var msg = "";
            if (data.matchFrom != "") {
                validateMatch = allnumeric(data.matchFrom);
                if (($scope.Interests.length == 0) && validateMatch) {
                    msg = "Please select atleast one subject of interest";
                    validateMatch = false;
                }
            }

            if (data.matchTo != "") {
                validateMatchTo = allnumeric(data.matchTo);
                if (validateMatchTo && ($scope.Interests.length == 0)) {
                    msg = "Please select atleast one subject of interest";
                    validateMatchTo = false;
                }
            }

            if (data.recommendFrom != "") {
                validateRecommend = allnumeric(data.recommendFrom);
            }
            if (data.recommendTo != "") {
                validateTo = allnumeric(data.recommendTo);
            }

            if (validateMatch && validateMatchTo && validateRecommend && validateTo) {
                $scope.searchResults.data.length = 0;
                $scope.totalResults = 0;
                var nrequest = apiCall.apiCall('POST', '/essay/AdvanceSearch', data);
                $http(
                    nrequest
                ).then(function successCallback(responseLatest) {
                    //MyService.ConsoleLog("Final Advance Data");
                    //MyService.ConsoleLog(responseLatest.data.data);
                    $scope.searchResults.data.length = 0;
                    if (responseLatest.data.success) {
                        var finalData = responseLatest.data.data;
                        //MyService.ConsoleLog("finalData:", finalData.length);
                        var flen = finalData.length;
                        $scope.searchResults.data.length = 0;
                        //MyService.ConsoleLog("Results :", $scope.searchResults.data);
                        $templateCache.removeAll();
                        for (var s = 0; s < flen; s++) {
                            if (finalData[s].recommended.length > 0) {
                                finalData[s].recavg = $scope.calculateAvg(finalData[s].recommended);
                                finalData[s].recavgvoters = $scope.calculateAvgType(finalData[s].recommended, 'voter');
                                finalData[s].recavgpolitician = $scope.calculateAvgType(finalData[s].recommended, 'politician');
                                finalData[s].recavgadvocate = $scope.calculateAvgType(finalData[s].recommended, 'advocate');
                                finalData[s].recavgpress = $scope.calculateAvgType(finalData[s].recommended, 'press');
                                if (userData.followlist.length > 0) {
                                    finalData[s].recavgfollow = $scope.calculateAvgId(finalData[s].recommended, userData.followlist);
                                } else {
                                    finalData[s].recavgfollow = 0;
                                }

                            } else {
                                finalData[s].recavg = 0;
                                finalData[s].recavgvoters = 0;
                                finalData[s].recavgpolitician = 0;
                                finalData[s].recavgadvocate = 0;
                                finalData[s].recavgpress = 0;
                                finalData[s].recavgfollow = 0;
                            }
                            if (finalData[s].factual.length > 0) {
                                finalData[s].factfavg = $scope.calculateAvg(finalData[s].factual);
                                finalData[s].factfavgvoters = $scope.calculateAvgType(finalData[s].factual, 'voter');
                                finalData[s].factfavgpolitician = $scope.calculateAvgType(finalData[s].factual, 'politician');
                                finalData[s].factfavgadvocate = $scope.calculateAvgType(finalData[s].factual, 'advocate');
                                finalData[s].factfavgpress = $scope.calculateAvgType(finalData[s].factual, 'press');
                                if (userData.followlist.length > 0) {
                                    finalData[s].factfavgfollow = $scope.calculateAvgId(finalData[s].recommended, userData.followlist);
                                } else {
                                    finalData[s].factfavgfollow = 0;
                                }

                            } else {
                                finalData[s].factfavg = 0;
                                finalData[s].factfavgvoters = 0;
                                finalData[s].factfavgpolitician = 0;
                                finalData[s].factfavgadvocate = 0;
                                finalData[s].factfavgpress = 0;
                                finalData[s].factfavgfollow = 0;
                            }
                            //MyService.ConsoleLog("finalData[s] :", finalData[s]);
                            $scope.searchResults.data.push(finalData[s]);
                        }
                        $scope.totalResults = responseLatest.data.data.length;
                        data.mediaoption = "";
                        data.mediaoption = [];
                        data.mediaoption.length = 0;
                    }
                }, function errorCallBack(responseLatest) {
                    alert("Error : " + responseLatest);
                });
            } else {
                if (msg != "") {
                    alert(msg);
                } else {
                    alert("Please enter valid data");
                }

            }
        }
        $scope.ShowOrderList = false;
        $scope.showOrder = function() {
            if (!$scope.ShowOrderList) {
                $scope.ShowOrderList = true;
            } else {
                $scope.ShowOrderList = false;
            }
        }

        $scope.isreverse = false;
        $scope.showAvg = true;
        $scope.showVoters = false;
        $scope.showPolitician = false;
        $scope.showAdvocate = false;
        $scope.showPress = false;
        $scope.showFollow = false;
        $scope.showfAvg = true;
        $scope.showfVoters = false;
        $scope.showfPolitician = false;
        $scope.showfAdvocate = false;
        $scope.showfPress = false;
        $scope.showfFollow = false;
        $scope.resetAllOrder = function() {
            $scope.showAvg = false;
            $scope.showVoters = false;
            $scope.showPolitician = false;
            $scope.showAdvocate = false;
            $scope.showPress = false;
            $scope.showFollow = false;
        }
        $scope.resetAllfOrder = function() {
            $scope.showfAvg = false;
            $scope.showfVoters = false;
            $scope.showfPolitician = false;
            $scope.showfAdvocate = false;
            $scope.showfPress = false;
            $scope.showfFollow = false;
        }

        $scope.sortValues = function(data) {
            var result = "";
            $scope.resetAllOrder();
            $scope.resetAllfOrder();

            $scope.showfAvg = true;
            $scope.showAvg = true;


            switch ($scope.search.order) {
                case "Most Recent":
                    $scope.isreverse = true;
                    $scope.showAvg = true;
                    $scope.showfAvg = true;
                    result = data.createdOn;
                    break;
                case "Oldest":
                    $scope.isreverse = false;
                    $scope.showAvg = true;
                    $scope.showfAvg = true;
                    result = data.createdOn;
                    break;
                case "Highest Recommended":
                    $scope.resetAllOrder();
                    $scope.isreverse = true;
                    $scope.showAvg = true;
                    $scope.showfAvg = true;
                    result = data.recavg;
                    break;
                case "Least Recommended":
                    $scope.resetAllOrder();
                    $scope.isreverse = false;
                    $scope.showAvg = true;
                    $scope.showfAvg = true;
                    result = data.recavg;
                    break;
                case "Most Factual":
                    $scope.resetAllfOrder();
                    $scope.isreverse = true;
                    $scope.showAvg = true;
                    $scope.showfAvg = true;
                    result = data.factfavg;
                    break;
                case "Least Factual":
                    $scope.resetAllfOrder();
                    $scope.isreverse = false;
                    $scope.showAvg = true;
                    $scope.showfAvg = true;
                    result = data.factfavg;
                    break;
                case "Default":
                    $scope.resetAllOrder();
                    $scope.resetAllfOrder();
                    $scope.isreverse = true;
                    result = data.createdOn;
                    $scope.showAvg = true;
                    $scope.showfAvg = true;
                    break;

            }

            switch ($scope.search.recommendorder) {
                case "Voters":
                    $scope.resetAllOrder();
                    $scope.showVoters = true;
                    $scope.isreverse = true;
                    result = data.recavgvoters;
                    break;
                case "Politicians":
                    $scope.resetAllOrder();
                    $scope.showPolitician = true;
                    $scope.isreverse = true;
                    result = data.recavgpolitician;
                    break;
                case "Advocates":
                    $scope.resetAllOrder();
                    $scope.showAdvocate = true;
                    $scope.isreverse = true;
                    result = data.recavgadvocate;
                    break;
                case "Press":
                    $scope.resetAllOrder();
                    $scope.showPress = true;
                    $scope.isreverse = true;
                    result = data.recavgpress;
                    break;
                case "Authors on my follow list":
                    $scope.resetAllOrder();
                    $scope.showFollow = true;
                    $scope.isreverse = true;
                    result = data.recavgfollow;
                    break;
                case "Default":
                    $scope.resetAllOrder();
                    $scope.showAvg = true;

                    break;

            }

            switch ($scope.search.lrecommendorder) {
                case "Voters":
                    $scope.resetAllOrder();
                    $scope.showVoters = true;
                    $scope.isreverse = false;
                    result = data.recavgvoters;
                    break;
                case "Politicians":
                    $scope.resetAllOrder();
                    $scope.showPolitician = true;
                    $scope.isreverse = false;
                    result = data.recavgpolitician;
                    break;
                case "Advocates":
                    $scope.resetAllOrder();
                    $scope.showAdvocate = true;
                    $scope.isreverse = false;
                    result = data.recavgadvocate;
                    break;
                case "Press":
                    $scope.resetAllOrder();
                    $scope.showPress = true;
                    $scope.isreverse = false;
                    result = data.recavgpress;
                    break;
                case "Authors on my follow list":
                    $scope.resetAllOrder();
                    $scope.showFollow = true;
                    $scope.isreverse = false;
                    result = data.recavgfollow;
                    break;
                case "Default":
                    $scope.resetAllOrder();
                    $scope.showAvg = true;
                    break;

            }

            switch ($scope.search.factualorder) {
                case "Voters":
                    $scope.resetAllfOrder();
                    $scope.showfVoters = true;
                    $scope.isreverse = true;
                    result = data.factfavgvoters;
                    break;
                case "Politicians":
                    $scope.resetAllfOrder();
                    $scope.showfPolitician = true;
                    $scope.isreverse = true;
                    result = data.factfavgpolitician;
                    break;
                case "Advocates":
                    $scope.resetAllfOrder();
                    $scope.showfAdvocate = true;
                    $scope.isreverse = true;
                    result = data.factfavgadvocate;
                    break;
                case "Press":
                    $scope.resetAllfOrder();
                    $scope.showfPress = true;
                    $scope.isreverse = true;
                    result = data.factfavgpress;
                    break;
                case "Authors on my follow list":
                    $scope.resetAllOrder();
                    $scope.showfFollow = true;
                    $scope.isreverse = true;
                    result = data.factfavgfollow;
                    break;
                case "Default":
                    $scope.resetAllfOrder();
                    $scope.showfAvg = true;
                    break;

            }

            switch ($scope.search.lfactualorder) {
                case "Voters":
                    $scope.resetAllfOrder();
                    $scope.showfVoters = true;
                    $scope.isreverse = false;
                    result = data.factfavgvoters;
                    break;
                case "Politicians":
                    $scope.resetAllfOrder();
                    $scope.showfPolitician = true;
                    $scope.isreverse = false;
                    result = data.factfavgpolitician;
                    break;
                case "Advocates":
                    $scope.resetAllfOrder();
                    $scope.showfAdvocate = true;
                    $scope.isreverse = false;
                    result = data.factfavgadvocate;
                    break;
                case "Press":
                    $scope.resetAllfOrder();
                    $scope.showfPress = true;
                    $scope.isreverse = false;
                    result = data.factfavgpress;
                    break;
                case "Authors on my follow list":
                    $scope.resetAllOrder();
                    $scope.showfFollow = true;
                    $scope.isreverse = false;
                    result = data.factfavgfollow;
                    break;
                case "Default":
                    $scope.resetAllfOrder();
                    $scope.showfAvg = true;
                    break;

            }
            //MyService.ConsoleLog($scope.search);
            //MyService.ConsoleLog(result);
            return result;

        }

        $scope.HighestRecommended = false;
        $scope.LeastRecommended = false;
        $scope.MostFactual = false;
        $scope.LeastFactual = false;
        $scope.ShowUsers = function(option) {
            switch (option) {
                case "HighestRecommended":
                    if (!$scope.HighestRecommended) {
                        $scope.HighestRecommended = true;
                    } else {
                        $scope.HighestRecommended = false;
                    }
                    break;
                case "LeastRecommended":
                    if (!$scope.LeastRecommended) {
                        $scope.LeastRecommended = true;
                    } else {
                        $scope.LeastRecommended = false;
                    }
                    break;
                case "MostFactual":
                    if (!$scope.MostFactual) {
                        $scope.MostFactual = true;
                    } else {
                        $scope.MostFactual = false;
                    }
                    break;
                case "LeastFactual":
                    if (!$scope.LeastFactual) {
                        $scope.LeastFactual = true;
                    } else {
                        $scope.LeastFactual = false;
                    }
                    break;
                case "Default":
                    $scope.HighestRecommended = false;
                    break;
            }
        }

        $scope.gotoThread = function(data) {

            var id = data;
            //MyService.ConsoleLog(data);

            $location.path('essayDetails/' + $routeParams.categoryId + '/' + id);
        }

        $scope.GotoEdit = function(id) {

            $location.path('/essayUpdate/' + $routeParams.categoryId + '/' + id);
        }

        $scope.showadvace = function() {
            $scope.ShowAdavace = true;
            var query = $scope.search.text;
            $scope.search = {
                text: query,
                subject: '',
                Locations: '',
                mediaoption: [],
                mediaType: '',
                dateBefore: '',
                dateAfter: '',
                matchFrom: '',
                matchTo: '',
                recommendFrom: '',
                recommendTo: '',
                factualFrom: '',
                factualTo: '',
                order: '',
                recommendorder: '',
                lrecommendorder: '',
                factualorder: '',
                lfactualorder: '',
                fromfollowlist: ''
            };
        }

        if ($routeParams.categoryId) {

            $scope.getEssayList();
        }
    }]);

'use strict';
angular.module('myApp.essayList', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
  $routeProvider.when('/essayList/:categoryId/:subcatId/:type', {
    templateUrl: 'app/essayList/essayList.html',
    controller: 'essayListCtrl'
  });
}])
.controller('essayListCtrl', ['$scope','$http','$location','apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService) {
	$rootScope.welcome = false;
	$scope.categoryId = $routeParams.categoryId;
	$scope.subcategoryId = $routeParams.subcatId;
	$scope.type = $routeParams.type;
	$scope.category = {};
	$scope.subcategory = {};
	$scope.DisplayData = [];
	$scope.userType = tokenService.getUserRole();
	$scope.Sticky = {
		txtOrder: 0
	};
	
	

	if(window.localStorage.getItem("VoteWiseEssayCategory")) {
		$rootScope.allEssaycategories = JSON.parse(window.localStorage.getItem("VoteWiseEssayCategory"));
		var idx = $rootScope.allEssaycategories.indexOf($routeParams.subcatId);
		
		if(idx==-1) {
			$rootScope.allEssaycategories.push($routeParams.subcatId);
			window.localStorage.setItem("VoteWiseEssayCategory", JSON.stringify($rootScope.allEssaycategories));		
		}	
	}
	
	
	$scope.getForumList = function() {
		var nrequest = apiCall.apiCall('GET', '/essay/getList', {maincatId: $routeParams.categoryId, subcatId: $routeParams.subcatId});
		$http(
		    nrequest
		  ).then(function successCallback(responseLatest) {
		  	//MyService.ConsoleLog("Final Data");
		  	//MyService.ConsoleLog(responseLatest.data.data);
			if(responseLatest.data.success){
				$scope.DisplayData = responseLatest.data.data;
			}
		  }, function errorCallBack(responseLatest) {
		    alert("Error : "+responseLatest);
		  });
	}



	function getSubCategories() {
		var request = apiCall.apiCall('GET', '/categories/list', {id: $routeParams.subcatId});
		  $http(
		    request
		  ).then(function successCallback(response) {
			if(response.data.success){
				$scope.subcategory = response.data.data;
			}
			else{
				alert("Something went wrong: ");
			}
		  }, function errorCallBack(response) {
		    alert("Error: "+response);
		  });		
	}

	function getCategory() {
	  var request = apiCall.apiCall('GET', '/categories/list', {id: $routeParams.categoryId});
	  $http(
	    request
	  ).then(function successCallback(response) {
		//MyService.ConsoleLog("Got categories: ",response);
		if(response.data.success){
			$scope.category = response.data.data;
		}
		else{
			alert("Something went wrong: ");
		}
	  }, function errorCallBack(response) {
	    alert("Error: "+response);
	  });
	}

	$scope.gotoThread = function(id) {
		
		var categoryId = $routeParams.categoryId;
		var subcatid = $routeParams.subcatId;
		$location.path('essayDetails/'+categoryId+'/'+subcatid+'/'+id);
	}

	$scope.updatePostApi = function(data, options, idex) {
		
		var request = apiCall.apiCall('POST', '/topics/update', data);
		 	$http(
				request
				).then(function successCallback(response) {
					//MyService.ConsoleLog(response);
				 	if(response.data.data.nModified==0) {
				 		alert("Something went wrong. Please try after sometime.");
				 	} else {
				 		$scope.getForumList();
				 		
				 	}
				
				}, function errorCallBack(response) {
				//MyService.ConsoleLog("Error: ",response);
			});
	}


	$scope.objectKeys = function(obj){
	  return Object.keys(obj);
	}
	
	$scope.updatePost = function(option, id) {
		var data = {};
		if(option=="sticky") {
			data.poststicky = 1;
			data.poststickyOrder = $scope.Sticky.txtOrder[id];
			data.topicId = id;
			
		} else {
			data.removepostSticky = 1;
			data.topicId = id;

		}
		//MyService.ConsoleLog(data);
		$scope.updatePostApi(data);
	}
	

	if($routeParams.categoryId){
		getCategory();
		getSubCategories();
		$scope.getForumList();
	}

}]);

'use strict';
angular.module('myApp.essayDetails', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/essayDetails/:categoryId/:essayId/:location?', {
      templateUrl: 'app/essayDetails/essayDetails.html',
      controller: 'essayDetailsCtrl'
    });
  }])
  .controller('essayDetailsCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', 'baseApiUrl', '$q', '$timeout', 'growl', 'tokenService', '$anchorScroll', '$sce', 'MyService', 'ngDialog', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, baseApiUrl, $q, $timeout, growl, tokenService, $anchorScroll, $sce, MyService, ngDialog) {
    //MyService.ConsoleLog("essayDetailsCtrl");
    $rootScope.welcome = false;
    $scope.categoryId = $routeParams.categoryId;
    $scope.essayId = $routeParams.essayId;
    $scope.userType = tokenService.getUserRole();


    $scope.showCon = false;
    $scope.showBoth = false;
    $scope.showEm = false;


    /**
     * Redirect
     */
    $scope.goto = function () {
      $location.path('/verifyBy');
    };

    /**
     * Close it
     */
    $scope.closeIt = function () {
      $scope.PopDialog.close();
    };
    $scope.getmyData = function () {
      $scope.ShowPorifleLoading = true;
      MyService.getUserPublicProfile({
        id: tokenService.getUserId(),
        type: 'false'
      }).then(function (response) {
        $scope.ShowPorifleLoading = false;
        if (response.data.success) {
          $scope.userDetails = response.data.data;
          // MyService.ConsoleLog("welcome", $scope.userDetails);
          $scope.userProfile = $scope.userDetails.userData;
          MyService.ConsoleLog("welcome to profile", $scope.userProfile);

          $scope.userType = $scope.userProfile.userType;
          $scope.verify = $scope.userProfile.verifiedUser;
          // MyService.ConsoleLog("welcome", $scope.verify);
          // console.log("$scope.userDetails", $scope.userDetails.userData.address);
          if (!$scope.userProfile.verifiedUser) {
            $scope.showCon = true;
          }

          if (!$scope.userProfile.isEmailVerified || !$scope.userProfile.verifiedUser) {
            // $scope.getPopUp();
            if (!$scope.userProfile.isEmailVerified && !$scope.userProfile.verifiedUser) {
              $scope.showCon = true;
              $scope.showBoth = true;
            } else if (!$scope.userProfile.isEmailVerified) {
              $scope.showEm = true;
            }

            if ($scope.userProfile.userType == 'politician') {
              $scope.PopDialog = ngDialog.open({
                template: 'popUp',
                closeByNavigation: true,
                scope: $scope,
                width: '50%',
                closeByDocument: false
              });
            } else if ($scope.userProfile.userType == 'advocate' && $scope.userProfile.isEmailVerified != true) {
              // alert('cal');
              MyService.ConsoleLog("$scope.userProfile", $scope.userProfile.isEmailVerified);

              $scope.PopDialog = ngDialog.open({
                template: 'popUp',
                closeByNavigation: true,
                scope: $scope,
                width: '50%',
                closeByDocument: false
              });
            }
          }


        } else {
          MyService.ConsoleLog("ELSE vishal");
          alert("Something went wrong.");
        }
      }, function (errorPayload) {
        $scope.ShowPorifleLoading = false;
        MyService.ConsoleLog("ELSE vishal two");

        alert("Something went wrong.");
      });
    }

    if (tokenService.getUserId()) {
      $scope.getmyData();
    }


    if (tokenService.getUserData()) {
      $scope.uData = JSON.parse(tokenService.getUserData());

    }



    $scope.froumthreads = [];
    $scope.essay = {};
    $scope.Sticky = {
      ShowOrder: [],
      txtOrder: []
    };
    $scope.vote = {
      recommend: 0,
      factual: 0
    };
    if ($scope.uData) {
      $scope.GalleryFolder = baseApiUrl + "/resources/" + $scope.uData.uname;
    }

    $scope.displayComments = true;
    $scope.Reply = {};

    $scope.checkMemId = function (rdata, val) {
      return rdata.filter(
        function (rdata) {
          if (rdata.userData._id == $rootScope.UserId)
            return rdata
        }
      );
    }


    $scope.CheckUrl = function (url, option) {
      if (url) {
        if (url.indexOf("youtube.com") >= 0) {
          var url = url.replace("watch?v=", "embed/");
          var nurl = url.split("&");
          var durl = nurl[0];
          if (option == "V")
            return $sce.trustAsHtml('<br/><iframe width="560" height="315" src="' + durl + '" frameborder="0" allowfullscreen></iframe><br/>');
          else
            return $sce.trustAsHtml('<br/><iframe src="' + durl + '" frameborder="0" allowfullscreen></iframe><br/>');
        }

        if (url.indexOf("facebook.com") >= 0) {
          if (option == "V")
            return $sce.trustAsHtml('<br/><iframe src="' + url + '" width="560" height="315" frameborder="0"></iframe><br/>');
          else
            return $sce.trustAsHtml('<br/><iframe src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>');
        }

        if (url.indexOf("vimeo.com") >= 0) {
          if (url.indexOf("https://vimeo.com/") >= 0) {
            var id = url.replace("https://vimeo.com/", "");
            var newurl = "https://player.vimeo.com/video/" + id;
          } else {
            var newurl = url;
          }
          if (option == "V")
            return $sce.trustAsHtml('<br/><iframe src="' + newurl + '" width="500" height="281" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe><br/>');
          else
            return $sce.trustAsHtml('<br/><iframe src="' + newurl + '" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe><br/>');
        }
        if (option == "V")
          return $sce.trustAsHtml('<br/><iframe width="560" height="315" src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>');
        else
          return $sce.trustAsHtml('<br/><iframe src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>');
      }

    }

    $scope.chkIfVoted = function (rdata, val) {
      return rdata.filter(
        function (rdata) {
          if (rdata.user.id == val)
            return rdata

        }
      );
    }
    $scope.loginUser = tokenService.getUserId();
    $scope.getEssayDetails = function () {
      //MyService.ConsoleLog("Get One called");
      MyService.getEssay($routeParams.essayId).then(function (payload) {
        $scope.essay = payload;
        //MyService.ConsoleLog("payload : ", payload);
        var chkrecommend = $scope.chkIfVoted(payload.recommended, $scope.loginUser);
        if (chkrecommend && chkrecommend.length > 0) {
          $scope.vote.recommend = chkrecommend[0].vote;
        }
        var chkfactual = $scope.chkIfVoted(payload.factual, $scope.loginUser);
        if (chkfactual && chkfactual.length > 0) {
          $scope.vote.factual = chkfactual[0].vote;
        }

      }, function (errorPayload) {
        //MyService.ConsoleLog(errorPayload);
        alert('Something went wrong ');
      });

    }



    function getCategory() {
      MyService.getCategoryList($routeParams.categoryId).then(function (payload) {
        $scope.category = payload;

      }, function (errorPayload) {
        alert('Something went wrong ');
      });

    }

    $scope.gotoThread = function (data) {
      //MyService.ConsoleLog(data);
      var id = '';
      if (data.parentId) {
        id = data.parentId;
      } else {
        id = data.id;
      }
      $location('forumthread/' + id);
    }

    $scope.updateCommentApi = function (data, options, idex) {

      MyService.updateEssayComments(data).then(function (payload) {
        if (payload.nModified == 0) {
          alert("You already provided your inputs on this post");
        } else {
          switch (options) {
            case 'like':
              $scope.essayComments[idex].totalLikes = $scope.essayComments[idex].totalLikes + 1;
              break;
            case 'dislike':
              $scope.essayComments[idex].totalDislike = $scope.essayComments[idex].totalDislike + 1;
              break;
            default:
              $scope.essayComments[idex].totalSpam = $scope.essayComments[idex].totalSpam + 1;
              break;
          }
          $scope.getComments();
        }
      }, function (response) {
        if (response.error) {
          alert(response.error);
          //MyService.ConsoleLog(response);
          if ((response.status) && (response.status == "405")) {
            var msg = "Do you want to send request to Admin to reactivate your account?.";
            MyService.GetDialogWithButtons(ngDialog, msg, "YES", "NO").then(function (payload) {
              MyService.sendActivatationMailtoAdmin().then(function (payload) {
                alert("Request sent successfully to admin");
              }, function (errorPayload) {
                alert("Something went wrong");
              })
            }, function (errorPayload) {
              //MyService.ConsoleLog(errorPayload);
            });
          }
        }

      });

    }

    // $scope.getItems = function () {
    //   return function (u) {
    //     MyService.ConsoleLog("u", u);
    //     if (u && u.spam && u.spam.length != 3) {
    //       return u;
    //     }
    //   };
    // };

    $scope.showSpam = [];
    $scope.DisplaySpam = function (id) {
      //alert(id);
      var idx = $scope.showSpam.indexOf(id);
      if (idx == -1) {
        $scope.showSpam.push(id);
      } else {
        $scope.showSpam.splice(idx, 1);
      }
      //MyService.ConsoleLog($scope.showSpam);
    }

    $scope.spamMessage = '';
    $scope.spamData = '';
    $scope.dialogClose = "";
    $scope.sendMessage = function (data) {
      $scope.spamData = data;
      $scope.dialogClose = ngDialog.open({
        template: 'sendMessage',
        scope: $scope
      });
    };


    $scope.updateComments = function (options, id, idex) {
      var message = 'Are you sure you want make this comment as spam';
      var modal = ngDialog.openConfirm({
        template: '<p>' + message + '</p>\
            <div class="ngdialog-buttons">\
                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">YES</button>\
                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">NO</button>\
            </div>',
        plain: true
      });
      modal.then(function fullfilled(data) {
        //MyService.ConsoleLog("fullfilled: ", mydata);
        if ($rootScope.UserId) {
          if ($scope.essayComments[idex].createdBy.id != $rootScope.UserId) {
            var commentData = {};
            commentData.commentId = id;
            commentData.userId = $rootScope.UserId;

            switch (options) {
              case 'like':
                commentData.likes = 1;
                break;
              case 'dislike':
                commentData.dislikes = 1;
                break;
              default:
                commentData.spam = 1;
                break;

            }
            MyService.ConsoleLog("commentData", commentData);
            $scope.updateCommentApi(commentData, options, idex);
          } else {
            alert("You cannot " + options + " your own comments");
          }

        } else {
          alert("Please login to perform these actions");
        }
      }, function rejected(data) {
        MyService.ConsoleLog("rejected: ", data);
      });
    }
    $scope.submitSticky = function (data, id, idx) {
      if (data > 0) {
        updateForum('sticky', id, idx);
      } else {
        alert("Please enter valid order");
      }

    }
    $scope.ShowComments = false;
    $scope.redirectToComment = function () {
      if (!$rootScope.UserId) {
        var message = "Please login first.";

        var modal = ngDialog.openConfirm({
          template: '<p>' + message + '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
          plain: true
        });

        modal.then(function fullfilled(data) {
          //MyService.ConsoleLog("fullfilled: ", data);
          $location.path('signin');
        }, function rejected(data) {
          //MyService.ConsoleLog("rejected: ", data);
          $location.path('signin');
        });
      }
      $scope.ShowComments = true;
      $scope.displayComments = false;
      //$location.path('forumReply/'+$routeParams.categoryId+'/'+$routeParams.subcatId+'/'+$routeParams.essayId);

    }


    $scope.sendMail = function (msg) {

      if ($scope.spamData.createdBy.id) {
        var msgurl = 'https://votewise.co/#!/essayDetails/' + $scope.categoryId + '/' + $scope.essayId;
        MyService.spamMail({
          "id": $scope.spamData.createdBy.id,
          "msg": msg,
          "msgurl": msgurl
        }).then(function (payload) {
          MyService.ConsoleLog(payload);
          if (payload.data.success) {
            ngDialog.close('sendMessage');
            $scope.dialogClose.close();
            alert("Message send successfully.");
          } else {
            alert(payload.data.data);
          }
        }, function (errorPayload) {
          alert("Something went wrong");
        });
      } else {
        alert("Something went wrong");
      }
      //alert("This is not implemented yet");
    }




    $scope.notSpam = function (mydata) {
      var message = 'This action will mark this comment as not spam and it will be visible again. Do you want to proceed?';
      var modal = ngDialog.openConfirm({
        template: '<p>' + message + '</p>\
            <div class="ngdialog-buttons">\
                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">YES</button>\
                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">NO</button>\
            </div>',
        plain: true
      });
      modal.then(function fullfilled(data) {
        //MyService.ConsoleLog("fullfilled: ", mydata);
        MyService.notSpamTopic({
          "id": mydata._id,
          isEssay: true
        }).then(function (payload) {
          $scope.getComments();
        }, function (error) {
          alert(JSON.stringify(error));
        });
      }, function rejected(data) {
        MyService.ConsoleLog("rejected: ", data);
      });
    }



    $scope.goBack = function () {
      $scope.ShowComments = false;
      $scope.displayComments = true;
    }
    $scope.getComments = function () {

      MyService.getEssayComments($routeParams.essayId).then(function (payload) {
          MyService.ConsoleLog("payload", payload);
          $scope.essayComments = payload;
        },
        function (errorPayload) {
          alert('Something went wrong ');
        });


    }

    $scope.SubmitComment = function (rec) {
      //MyService.ConsoleLog(data);
      //MyService.ConsoleLog($scope.mainThread);
      var data = {};
      if (rec.content != "") {
        $scope.TopicButton = true;
        data.createdById = $rootScope.UserId;
        data.createdByName = $rootScope.User;
        data.createdByType = tokenService.getUserRole();
        data.comments = rec.content;
        data.essayId = $routeParams.essayId;
        //MyService.ConsoleLog(data);


        MyService.submitEssayComments(data).then(function (payload) {
          $scope.comments = {
            content: ''
          };
          $scope.ShowComments = false;
          $scope.displayComments = true;
          $scope.mainThread = {};
          //$location.path('forumthread/'+$routeParams.categoryId+'/'+$routeParams.subcatId+'/'+$routeParams.essayId);
          $scope.getComments();
        }, function (response) {
          if (response.error) {
            alert(response.error);
            //MyService.ConsoleLog(response);
            if ((response.status) && (response.status == "405")) {
              var msg = "Do you want to send request to Admin to reactivate your account?.";
              MyService.GetDialogWithButtons(ngDialog, msg, "YES", "NO").then(function (payload) {
                MyService.sendActivatationMailtoAdmin().then(function (payload) {
                  alert("Request sent successfully to admin");
                }, function (errorPayload) {
                  alert("Something went wrong");
                })
              }, function (errorPayload) {
                //MyService.ConsoleLog(errorPayload);
              });
            }
          }
        });



      } else {
        alert("Please enter comments.");
      }
    }

    $scope.EssayVote = function (option) {
      if (!$rootScope.UserId) {
        var message = "Please login first.";

        var modal = ngDialog.openConfirm({
          template: '<p>' + message + '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
          plain: true
        });

        modal.then(function fullfilled(data) {
          //MyService.ConsoleLog("fullfilled: ", data);
          $location.path('signin');
        }, function rejected(data) {
          //MyService.ConsoleLog("rejected: ", data);
          $location.path('signin');
        });
      } else {
        if ($scope.essay.createdBy.id != tokenService.getUserId()) {
          var data = {};
          data.essayId = $routeParams.essayId;
          data.mediaType = '';
          data.option = option;
          //MyService.ConsoleLog(option);
          if (option == "Recommended") {
            data.vote = $scope.vote.recommend;
          } else {
            data.vote = $scope.vote.factual;
          }
          data.createdById = $scope.loginUser;
          data.createdByName = tokenService.getUserName();
          data.createdByType = tokenService.getUserRole();
          MyService.updateEssay(data).then(function (payload) {
              alert('Thank you for rating the essay.');
            },
            function (response) {
              if (response.error) {
                alert(response.error);
                //MyService.ConsoleLog(response);
                if ((response.status) && (response.status == "405")) {
                  var msg = "Do you want to send request to Admin to reactivate your account?.";
                  MyService.GetDialogWithButtons(ngDialog, msg, "YES", "NO").then(function (payload) {
                    MyService.sendActivatationMailtoAdmin().then(function (payload) {
                      alert("Request sent successfully to admin");
                    }, function (errorPayload) {
                      alert("Something went wrong");
                    })
                  }, function (errorPayload) {
                    //MyService.ConsoleLog(errorPayload);
                  });
                }
              }
            });
        } else {
          alert("You cannot vote your own essay.");
        }
      }
    }


    $scope.editDescription = "";

    $scope.editComments = function (item) {
      MyService.ConsoleLog(item);
      $scope.editDescription = item;
      $scope.editDescription.description = item.comments.replace(" ...(updated)", "");;
      var editModal = ngDialog.open({
        template: 'templateId',
        scope: $scope
      });
    }

    $scope.removeComments = function (mydata) {
      var message = 'Are you sure you want to delete this comment?';

      var modal = ngDialog.openConfirm({
        template: '<p>' + message + '</p>\
            <div class="ngdialog-buttons">\
                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">YES</button>\
                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">NO</button>\
            </div>',
        plain: true
      });

      modal.then(function fullfilled(data) {

        //MyService.ConsoleLog("fullfilled: ", mydata);

        MyService.removeEssayComment({
          "id": mydata._id
        }).then(function (payload) {
          //MyService.ConsoleLog(payload);
          //$scope.UserFormDiv = false;
          //$scope.getSpamTopics(1);
          $scope.getComments();

        }, function (error) {
          alert(JSON.stringify(error));
        });
      }, function rejected(data) {
        //MyService.ConsoleLog("rejected: ", data);
      });
    }

    $scope.UpdateReply = function (data) {
      MyService.ConsoleLog(data);
      if (data.description != "") {
        data.commentId = data._id;

        data.comments = data.description + " ...(updated)";
        MyService.updateEssayComts(data).then(function (payload) {
          MyService.ConsoleLog("payload : ", payload);
          alert("Comments updated");
          ngDialog.closeAll();
          $scope.getComments();

        }, function (errorPayload) {
          //MyService.ConsoleLog("errorPayload : ", errorPayload);
        });
      } else {
        alert("Comment should not be empty");
      }
    }



    if ($routeParams.categoryId) {
      getCategory();
      $scope.getEssayDetails();
      $scope.getComments();
      $anchorScroll();
    }

  }]);

'use strict';
angular.module('myApp.essay', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/essay/:categoryId/:subcatId?/:type?', {
      templateUrl: 'app/essay/essay.html',
      controller: 'essayCtrl'
    });
  }])
  .controller('essayCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'baseApiUrl', 'MyService', 'tokenService', 'growl', '$templateCache', 'ngDialog', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, baseApiUrl, MyService, tokenService, growl, $templateCache, ngDialog) {
    $scope.imgUrl = baseApiUrl + "/resources";
    $scope.categoryId = $routeParams.categoryId;
    $scope.subcategoryId = $routeParams.subcatId;
    $scope.userId = tokenService.getUserId();
    $scope.userRole = tokenService.getUserRole();
    $rootScope.welcome = false;
    if (tokenService.getUserData()) {
      $scope.userData = JSON.parse(tokenService.getUserData());
    } else {
      $scope.userData = "";
    }

    MyService.ConsoleLog("$scope.userData", $scope.userData);

    $scope.ShowAdavace = false;
    if ($routeParams.query) {
      $scope.search = {
        text: $routeParams.query,
        subject: '',
        Locations: '',
        mediaoption: [],
        mediaType: '',
        dateBefore: '',
        dateAfter: '',
        matchFrom: '',
        matchTo: '',
        recommendFrom: '',
        recommendTo: '',
        recommendFilter: '',
        factualFilter: '',
        factualFrom: '',
        factualTo: '',
        fromfollowlist: '',
        order: '',
        recommendorder: '',
        lrecommendorder: '',
        factualorder: '',
        lfactualorder: '',
        chk: false

      };
    } else {
      $scope.search = {
        text: '',
        subject: '',
        Locations: '',
        mediaoption: [],
        mediaType: '',
        dateBefore: '',
        dateAfter: '',
        matchFrom: '',
        matchTo: '',
        recommendFrom: '',
        recommendTo: '',
        recommendFilter: '',
        factualFilter: '',
        factualFrom: '',
        factualTo: '',
        fromfollowlist: '',
        recommendorder: '',
        lrecommendorder: '',
        factualorder: '',
        lfactualorder: '',
        order: '',
        chk: false

      };
    }

    $scope.showRefineLocation = false;

    $scope.Location = ["International", "National", "My State", "My County", "My Local", "Other Specific"];
    $scope.mediaType = ['Text', 'Video', 'Stills', 'Audio'];
    $scope.dateRange = ['Today', 'In the last week', 'In the last month', 'In the last year'];
    $scope.users = ["Voters", "Organizations", "Press", "Politicians", "Authors on my follow list"];
    $scope.staffResults = {
      data: []
    };
    $scope.searchResults = {
      data: []
    };
    $scope.selectedCat = [];
    $scope.subtopics = {
      subcategories: []
    }
    $scope.disabled = [];
    $scope.allLocations = [];
    $scope.allCounties = [];
    $scope.selectedArea = [];
    $scope.rmselectedArea = [];
    $scope.myselectionarea = [];
    $scope.disabledLocation = [];
    $scope.ShowSubcatTree = false;

    $scope.selectConfig = {
      requiredMin: 1,
      selectAll: true
    };

    $scope.getMailingAddress = function (id) {
      MyService.getMailingAddress({
        userId: id,
      }).then(
        function (result) {
          MyService.ConsoleLog('Result', result);
          $scope.mainData = result.data.data;
        },
        function (err) {
          MyService.ConsoleLog('Error >', err);
        }
      );
    };

    function getCategory(params, type) {
      MyService.getCategoryList(params).then(function (payload) {
          var subcatdata = payload;
          //MyService.ConsoleLog("subcatdata : ", subcatdata);
          if (type == "Prev") {
            $scope.previouscategory = payload;
          } else {
            $scope.category = payload;
          }
        },
        function (errorPayload) {
          alert('Something went wrong ');
        });
    }

    $scope.getStaffEssayList = function () {
      $scope.staffResults.data.length = 0;
      var nrequest = apiCall.apiCall('GET', '/essay/staffEssayList', {
        maincatId: $routeParams.categoryId,
        subcatId: $routeParams.subcatId,
        limit: 3
      });
      $http(
        nrequest
      ).then(function successCallback(responseLatest) {
        if (responseLatest.data.success) {
          var finalData = responseLatest.data.data;
          var flen = finalData.length;
          $scope.staffResults.data = finalData;
          /*
          for (var s = 0; s < flen; s++) {
              if (finalData[s].recommended.length > 0) {
                  finalData[s].recavg = $scope.calculateAvg(finalData[s].recommended);
                  finalData[s].recavgvoters = $scope.calculateAvgType(finalData[s].recommended, 'voter');
                  finalData[s].recavgpolitician = $scope.calculateAvgType(finalData[s].recommended, 'politician');
                  finalData[s].recavgadvocate = $scope.calculateAvgType(finalData[s].recommended, 'advocate');
                  finalData[s].recavgpress = $scope.calculateAvgType(finalData[s].recommended, 'press');
              } else {
                  finalData[s].recavg = 0;
                  finalData[s].recavgvoters = 0;
                  finalData[s].recavgpolitician = 0;
                  finalData[s].recavgadvocate = 0;
                  finalData[s].recavgpress = 0;
              }
              if (finalData[s].factual.length > 0) {
                  finalData[s].factfavg = $scope.calculateAvg(finalData[s].factual);
                  finalData[s].factfavgvoters = $scope.calculateAvgType(finalData[s].factual, 'voter');
                  finalData[s].factfavgpolitician = $scope.calculateAvgType(finalData[s].factual, 'politician');
                  finalData[s].factfavgadvocate = $scope.calculateAvgType(finalData[s].factual, 'advocate');
                  finalData[s].factfavgpress = $scope.calculateAvgType(finalData[s].factual, 'press');
              } else {
                  finalData[s].factfavg = 0;
                  finalData[s].factfavgvoters = 0;
                  finalData[s].factfavgpolitician = 0;
                  finalData[s].factfavgadvocate = 0;
                  finalData[s].factfavgpress = 0;
              }
              //MyService.ConsoleLog("finalData[s] :", finalData[s]);
              $scope.staffResults.data.push(finalData[s]);
          }
          */
        }
      }, function errorCallBack(responseLatest) {
        alert("Error : " + responseLatest);
      });
    };

    /**
     * Highlight post
     */
    $scope.highlight = function (pId) {
      MyService.ConsoleLog("highlight", pId);
      MyService.ConsoleLog(" $scope.userData", $scope.userData);
      // hdjdDA
      MyService.highlightPost({
        pId: pId,
        advId: $scope.userData.id
      }).then(function (result) {
        MyService.ConsoleLog("result", result);
        growl.success(result.data);
      }, function (error) {
        growl.error(error);
      });
    };


    $scope.showArr = false;
    $scope.currentPage = 1;
    $scope.pageChangeHandler = function (num) {
      MyService.ConsoleLog('meals page changed to ' + num);
    };
    $scope.getEssayList = function () {
      $scope.searchResults.data.length = 0;
      var nrequest = apiCall.apiCall('GET', '/essay/getList', {
        maincatId: $routeParams.categoryId,
        subcatId: $routeParams.subcatId
      });
      $http(
        nrequest
      ).then(function successCallback(responseLatest) {
        if (responseLatest.data.success) {
          var finalData = responseLatest.data.data;
          var flen = finalData.length;

          for (var s = 0; s < flen; s++) {
            if (finalData[s].recommended.length > 0) {
              finalData[s].recavg = $scope.calculateAvg(finalData[s].recommended);
              finalData[s].recavgvoters = $scope.calculateAvgType(finalData[s].recommended, 'voter');
              finalData[s].recavgpolitician = $scope.calculateAvgType(finalData[s].recommended, 'politician');
              finalData[s].recavgadvocate = $scope.calculateAvgType(finalData[s].recommended, 'advocate');
              finalData[s].recavgpress = $scope.calculateAvgType(finalData[s].recommended, 'press');
            } else {
              finalData[s].recavg = 0;
              finalData[s].recavgvoters = 0;
              finalData[s].recavgpolitician = 0;
              finalData[s].recavgadvocate = 0;
              finalData[s].recavgpress = 0;
            }
            if (finalData[s].factual.length > 0) {
              finalData[s].factfavg = $scope.calculateAvg(finalData[s].factual);
              finalData[s].factfavgvoters = $scope.calculateAvgType(finalData[s].factual, 'voter');
              finalData[s].factfavgpolitician = $scope.calculateAvgType(finalData[s].factual, 'politician');
              finalData[s].factfavgadvocate = $scope.calculateAvgType(finalData[s].factual, 'advocate');
              finalData[s].factfavgpress = $scope.calculateAvgType(finalData[s].factual, 'press');
            } else {
              finalData[s].factfavg = 0;
              finalData[s].factfavgvoters = 0;
              finalData[s].factfavgpolitician = 0;
              finalData[s].factfavgadvocate = 0;
              finalData[s].factfavgpress = 0;
            }
            //MyService.ConsoleLog("finalData[s] :", finalData[s]);
            $scope.searchResults.data.push(finalData[s]);
          }
          MyService.ConsoleLog("dd", $scope.searchResults.data);
          $scope.totalResults = flen;
        }
      }, function errorCallBack(responseLatest) {
        alert("Error : " + responseLatest);
      });
    }

    $scope.checkCatExists = function (rdata, val) {
      return rdata.filter(
        function (rdata) {
          if (rdata._id == val) {
            $scope.selectedCat.push(rdata);
            return rdata
          } else if (rdata.subcategories) {
            $scope.checkCatExists(rdata.subcategories, val)
          }
        }
      );
    }

    $scope.mainCatTree = [];

    $scope.getSubcatTree = function () {
      MyService.ConsoleLog("main  cat", $scope.mainCatTree);
      if ($scope.mainCatTree.length == 0) {
        $scope.ShowSubcatTree = true;
        $scope.showArr = true;
        MyService.getAllCatTree().then(function (payload) {
            $scope.subtopics.subcategories.length = 0;
            $scope.mainCatTree = angular.copy(payload);
            var subcatdata = payload;
            $scope.ShowSubcatTree = false;
            $scope.subtopics.subcategories = subcatdata;
            MyService.ConsoleLog("$scope.subtopics", $scope.subtopics);
            var selectedCat = $scope.disabled;
            if (selectedCat.length > 0) {
              for (var s = 0; s < selectedCat.length; s++) {
                var checkcatdata = $scope.checkCatExists(subcatdata, selectedCat[s]);
              }
              //MyService.ConsoleLog($scope.selectedCat);
            }
            setTimeout(function () {
              var cols = document.getElementsByClassName('cmnUL');
              var clen = cols.length;
              for (var i = 0; i < clen; i++) {
                cols[i].style.display = "none";
              }
            }, 300);
          },
          function (errorPayload) {
            alert('Something went wrong ');
          });
      } else {
        //MyService.ConsoleLog("After : " + $scope.subtopics.subcategories.length);
        if ($scope.subtopics.subcategories.length == 0) {
          $scope.subtopics.subcategories = angular.copy($scope.mainCatTree);
        } else {

          $scope.subtopics.subcategories.length = 0;
        }


        $scope.ShowSubcatTree = false;
        MyService.ConsoleLog("After : " + $scope.subtopics.subcategories);
        MyService.ConsoleLog("After : " + $scope.ShowSubcatTree);
      }

    }



    $scope.AllStates = [];
    $scope.allCounties = [];
    $scope.allLocals = [];
    $scope.showSubCat = true;
    $scope.showLoading = [];
    $scope.showLoadingCounty = [];
    $scope.showDown = [];

    $scope.GotoEdit = function (id) {

      $location.path('/essayUpdate/' + $routeParams.categoryId + '/' + id);
    }

    $scope.removeEssay = function (mydata, idx, flag) {
      MyService.ConsoleLog(mydata);
      var message = 'Are you sure you want to delete this Essay?';

      var modal = ngDialog.openConfirm({
        template: '<p>' + message + '</p>\
            <div class="ngdialog-buttons">\
                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">YES</button>\
                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">NO</button>\
            </div>',
        plain: true
      });
      modal.then(function fullfilled(data) {
        // MyService.ConsoleLog("fullfilled: ", mydata);
        MyService.removeEssay({
          "id": mydata._id
        }).then(function (payload) {
          //MyService.ConsoleLog(payload);
          //$scope.UserFormDiv = false;
          if (flag == "S") {
            $scope.getStaffEssayList();
          }

          if (flag == "A") {
            $scope.getEssayList();
          }

          alert("Essay deleted successfully.");
        }, function (error) {
          alert(JSON.stringify(error));
        });
      }, function rejected(data) {
        MyService.ConsoleLog("rejected: ", data);
      });
    }

    $scope.getAllStates = function () {
      $scope.ShowStateLoader = true;
      if ($scope.AllStates.length == 0) {
        MyService.getAllStates().then(function (payload) {
            $scope.ShowStateLoader = false;
            $scope.allLocations.length = 0;
            var subcatdata = payload;
            $scope.AllStates = angular.copy(subcatdata);
            //MyService.ConsoleLog("countires : ", subcatdata);
            $scope.allLocations = subcatdata;
          },
          function (errorPayload) {
            alert('Something went wrong ');
          });
      } else {
        if (!$scope.showStates) {
          $scope.allLocations.length = 0;
          $scope.ShowStateLoader = false;
        } else {
          $scope.allLocations = angular.copy($scope.AllStates);
          $scope.ShowStateLoader = false;
        }
      }

    }

    $scope.showSts = [];
    $scope.getCounties = function (state) {
      // MyService.ConsoleLog("state", state);
      $scope.showLoading.push(state);
      $scope.showSts[state] = true;
      if (!$scope.allCounties[state] || $scope.allCounties[state].length == 0) {

        MyService.getAllCounties(state).then(function (payload) {
            $scope.showLoading.length = 0;
            var sublocations = payload;
            // MyService.ConsoleLog("paload", payload);
            if (!$scope.allCounties) {
              $scope.allCounties = [];
            }
            $scope.allCounties[state] = payload;
            // MyService.ConsoleLog(" $scope.allCounties", $scope.allCounties);
          },
          function (errorPayload) {
            alert('Something went wrong.');
          });


      } else {
        $scope.showSts[state] = false;
        $scope.showLoading.length = 0;
        $scope.allCounties[state].length = 0;
      }
    }
    $scope.showCount = [];
    $scope.getLocals = function (state, county) {
      $scope.showCount[county] = true;
      MyService.ConsoleLog("state", state);
      MyService.ConsoleLog("county", county);

      $scope.showLoadingCounty.push(county);
      if (!$scope.allLocals[state] || !$scope.allLocals[state][county] || $scope.allLocals[state][county].length == 0) {

        MyService.getAllSubCountiesLocal(state, county).then(function (payload) {
            $scope.showLoadingCounty.length = 0;
            MyService.ConsoleLog("sublocations Locals : ", payload);
            if (!$scope.allLocals[state]) {
              $scope.allLocals[state] = [];
            }
            MyService.ConsoleLog("state.statePostalCode", state.statePostalCode);
            $scope.allLocals[state][county] = payload.places;
            MyService.ConsoleLog("sublocations Locals : ", $scope.allLocals[state][county]);

          },
          function (errorPayload) {
            alert('Something went wrong ');
          });


      } else {
        $scope.showCount[county] = false;
        $scope.showLoadingCounty.length = 0;
        $scope.allLocals[state][county].length = 0;
      }
    }





    $scope.showmediaType = false;
    $scope.showDateRange = false;
    $scope.showMatchAuthor = false;
    $scope.showEssayRating = false;
    $scope.showStates = false;
    $scope.showRefine = function (e, option) {
      e.preventDefault();
      switch (option) {
        case "Interest":
          $scope.getSubcatTree();
          break;
        case "Location":
          if (!$scope.showRefineLocation)
            $scope.showRefineLocation = true;
          else
            $scope.showRefineLocation = false;

          break;
        case "AllLocation":
          if (!$scope.showStates) {
            $scope.showStates = true;

          } else {
            $scope.showStates = false;
          }
          $scope.getAllStates();
          break;
        case "Media":
          if (!$scope.showmediaType)
            $scope.showmediaType = true;
          else
            $scope.showmediaType = false;
          break;
        case "Date":
          if (!$scope.showDateRange)
            $scope.showDateRange = true;
          else
            $scope.showDateRange = false;
          break;
        case "Author":
          if (!$scope.showMatchAuthor)
            $scope.showMatchAuthor = true;
          else
            $scope.showMatchAuthor = false;
          break;
        case "EssayRated":
          if (!$scope.showEssayRating)
            $scope.showEssayRating = true;
          else
            $scope.showEssayRating = false;
          break;
        case "Default":
          break;

      }
    }


    $scope.showSubCat = true;
    $scope.showLoading = [];
    $scope.showLoadingCounty = [];
    $scope.showDown = [];
    $scope.showSubs = [];
    $scope.ChangeShow = function (id) {
      $scope.showSubCat = true;
      $scope.showSubs[id] = true;

      var nclass = "MainCatLi_" + id;
      if ((document.getElementsByClassName(nclass)[0].style.display) && (document.getElementsByClassName(nclass)[0].style.display == "none")) {
        document.getElementsByClassName(nclass)[0].style.display = "block";
      } else {
        document.getElementsByClassName(nclass)[0].style.display = "none";
      }
    }


    function areEqual() {
      var len = arguments.length;
      for (var i = 1; i < len; i++) {
        if (arguments[i] == null || arguments[i] != arguments[i - 1])
          return false;
      }
      return true;
    }

    function indexOfExt(list, item) {
      var len = list.length;
      for (var i = 0; i < len; i++) {
        var keys = Object.keys(list[i]);
        var flg = true;
        var arr = [];
        for (var j = 0, s = 1; j < keys.length; j++, s++) {
          var value = list[i][keys[j]];
          if (item[keys[j]] !== value) {
            flg = false;
          }

          if (item[keys[j]] == value) {
            arr.push(flg);
          }
        }
        if (flg == true) {
          if (areEqual(arr.length, keys.length, Object.keys(item).length)) {
            return i;
          }
        }
      }
      return -1;
    }

    $scope.findLocations = [];
    $scope.Interests = [];
    $scope.MyLocation = [];
    $scope.SelectDefaultLocation = function (val) {
      //MyService.ConsoleLog("Data : ", val);
      var idx = $scope.MyLocation.indexOf(val);
      if (idx == -1) {
        $scope.MyLocation.push(val);
      } else {
        $scope.MyLocation.splice(idx, 1);
      }
      //MyService.ConsoleLog($scope.MyLocation);
    }

    $scope.selectLocation = function (val1, val2, val3, type) {
      //MyService.ConsoleLog(val1, val2, val3, type);
      var nobj = {};
      nobj.country = "United States of America";
      if (type == "state") {
        nobj.state = val1.state;
        nobj.statePostalCode = val1.statePostalCode;
      }
      if (type == "county") {
        nobj.state = val1.state;
        nobj.statePostalCode = val1.statePostalCode;
        nobj.county = val3;
      }
      if (type == "local") {
        nobj.state = val1.state;
        nobj.statePostalCode = val1.statePostalCode;
        nobj.county = val2;
        nobj.countySubdivision = val3.countySubdivision;
        nobj.place = val3.place;
      }
      //MyService.ConsoleLog("nboj:", nobj);
      var idx = indexOfExt($scope.findLocations, nobj);
      if (idx == -1) {
        $scope.findLocations.push(nobj);
      } else {
        $scope.findLocations.splice(idx, 1);
      }
    }



    $scope.getVal = function (data) {
      MyService.ConsoleLog("data", data);
      var idx = $scope.Interests.indexOf(data._id);
      if (idx == -1) {
        $scope.Interests.push(data._id);
      } else {
        $scope.Interests.splice(idx, 1);
      }
    }

    $scope.totalResults = 0;


    function addslashes(str) {
      return (str + '').replace(/[\\"']/g, '\\$&').replace(/\u0000/g, '\\0');
    }




    function cleanArray(actual) {
      var newArray = new Array();
      for (var i = 0; i < actual.length; i++) {
        if (actual[i]) {
          newArray.push(actual[i]);
        }
      }
      return newArray;
    }

    function allnumeric(inputtxt) {
      var numbers = /^[0-9]+$/;
      if (inputtxt == undefined) {
        return false;
      }
      if (inputtxt.match(numbers)) {
        return true;
      } else {
        return false;
      }
    }


    $scope.calculateAvg = function (arr) {
      var reclen = arr.length;
      //MyService.ConsoleLog("Arr Len : ", reclen);
      var recsum = 0;
      for (var r = 0; r < reclen; r++) {
        if (arr[r].vote) {
          //MyService.ConsoleLog("===",arr[r].vote);
          recsum += parseInt(arr[r].vote, 10);
          if (r == reclen - 1) {
            var recavg = recsum / reclen;

            return recavg;
          }
        }

      }

      //return card.values.opt1 + card.values.opt2;
    };

    $scope.calculateAvgType = function (arr, type) {
      //MyService.ConsoleLog("calculateAvgType : ",arr);
      var reclen = arr.length;
      var recsum = 0;
      for (var r = 0; r < reclen; r++) {
        var userData = arr[r].user || arr[r][0].user;
        var userVote = arr[r].vote || arr[r][0].vote;
        if (userData.utype == type) {
          //MyService.ConsoleLog(userData.utype + "==" + type);
          recsum += parseInt(userVote, 10);

        }
        if (r == reclen - 1) {
          var recavg = recsum / reclen;

          return recavg;
        }
      }

      //return card.values.opt1 + card.values.opt2;
    };

    $scope.calculateAvgId = function (arr, followlist) {
      var reclen = arr.length;
      var recsum = 0;
      for (var r = 0; r < reclen; r++) {
        var userData = arr[r].user || arr[r][0].user;
        var userVote = arr[r].vote || arr[r][0].vote;
        var idx = followlist.indexOf(userData.id)
        if (idx > -1) {
          //MyService.ConsoleLog(arr[r].user.utype + "==" + type);
          recsum += parseInt(userVote.vote, 10);
        }

        if (r == reclen - 1) {
          var recavg = recsum / reclen;
          return recavg;
        }
      }
    }
    $scope.displayMsg = false;
    $scope.getEssayListAdvance = function (data) {
      MyService.ConsoleLog("$scope.search", $scope.search);
      $scope.displayMsg = true;
      $scope.searchResults.data.length = 0;
      if ($scope.findLocations.length > 0) {
        data.searchlocations = JSON.stringify($scope.findLocations);
      }

      if ($scope.MyLocation.length > 0) {
        data.MyLocation = JSON.stringify($scope.MyLocation);
      }
      if (data.mediaoption) {
        var moption = data.mediaoption;
        if (typeof moption == "object") {
          moption = Object.keys(moption).map(function (key) {
            return moption[key]
          });
        }
        if (typeof moption != "string") {
          var media = cleanArray(moption);
          data.mediaoption = JSON.stringify(media);
        }
      }
      if ($scope.Interests && $scope.Interests.length > 0) {
        data.subjectOfInterest = JSON.stringify($scope.Interests);
      } else {
        $scope.Interests.push($scope.categoryId);
        data.subjectOfInterest = JSON.stringify($scope.Interests);
      }

      var validateMatch = true,
        validateMatchTo = true,
        validateRecommend = true,
        validateTo = true;
      var msg = "";
      if (data.matchFrom != "") {

        validateMatch = allnumeric(data.matchFrom);
        if (($scope.Interests.length == 0) && validateMatch) {
          msg = "Please select atleast one subject of interest";
          validateMatch = false;
        }
      }

      if (data.matchTo != "") {
        validateMatchTo = allnumeric(data.matchTo);
        if (validateMatchTo && ($scope.Interests.length == 0)) {
          msg = "Please select atleast one subject of interest";
          validateMatchTo = false;
        }
      }

      if (data.recommendFrom != "") {
        validateRecommend = allnumeric(data.recommendFrom);
      }
      if (data.recommendTo != "") {
        validateTo = allnumeric(data.recommendTo);
      }
      data.cat = $scope.categoryId;
      if (validateMatch && validateMatchTo && validateRecommend && validateTo) {
        $scope.searchResults.data.length = 0;
        $scope.totalResults = 0;
        // MyService.ConsoleLog(data);
        var nrequest = apiCall.apiCall('POST', '/essay/AdvanceSearch', data);
        $http(
          nrequest
        ).then(function successCallback(responseLatest) {
          // MyService.ConsoleLog("Final Advance Data");
          // MyService.ConsoleLog(JSON.stringify(responseLatest.data));
          $scope.searchResults.data.length = 0;
          if (responseLatest.data.success) {
            var main = responseLatest.data.data.filter(function (itm, inx) {
              return inx == responseLatest.data.data.findIndex(function (eles) {
                return JSON.stringify(eles) == JSON.stringify(itm);
              });
            });
            var finalData = main;
            MyService.ConsoleLog("finalData:", finalData);
            var flen = finalData.length;
            $scope.searchResults.data.length = 0;
            //MyService.ConsoleLog("Results :", $scope.searchResults.data);

            //$templateCache.removeAll();
            for (var s = 0; s < flen; s++) {
              //MyService.ConsoleLog("actual length : ", finalData[s].recommended.length);
              // MyService.ConsoleLog("actual >>> ", finalData[s]);
              /*
              if(typeof finalData[s].recommended == "object") {
                  var narr = [];
                  narr.push(finalData[s].recommended);
                  finalData[s].recommended = narr;
              }
              if(typeof finalData[s].factual == "object") {
                  var farr = [];
                  farr.push(finalData[s].factual);
                  finalData[s].factual = farr;
              }
              */
              //  //MyService.ConsoleLog("actual length : ", finalData[s].recommended.length);
              //MyService.ConsoleLog("actual : ", finalData[s].recommended);
              if (finalData[s].recommended.length > 0) {
                finalData[s].recavg = $scope.calculateAvg(finalData[s].recommended);
                finalData[s].recavgvoters = $scope.calculateAvgType(finalData[s].recommended, 'voter');
                finalData[s].recavgpolitician = $scope.calculateAvgType(finalData[s].recommended, 'politician');
                finalData[s].recavgadvocate = $scope.calculateAvgType(finalData[s].recommended, 'advocate');
                finalData[s].recavgpress = $scope.calculateAvgType(finalData[s].recommended, 'press');
                if ($scope.userData && $scope.userData.followlist.length > 0) {
                  finalData[s].recavgfollow = $scope.calculateAvgId(finalData[s].recommended, $scope.userData.followlist);
                } else {
                  finalData[s].recavgfollow = 0;
                }

              } else {
                finalData[s].recavg = 0;
                finalData[s].recavgvoters = 0;
                finalData[s].recavgpolitician = 0;
                finalData[s].recavgadvocate = 0;
                finalData[s].recavgpress = 0;
                finalData[s].recavgfollow = 0;
              }

              if (finalData[s].factual.length > 0) {
                finalData[s].factfavg = $scope.calculateAvg(finalData[s].factual);
                finalData[s].factfavgvoters = $scope.calculateAvgType(finalData[s].factual, 'voter');
                finalData[s].factfavgpolitician = $scope.calculateAvgType(finalData[s].factual, 'politician');
                finalData[s].factfavgadvocate = $scope.calculateAvgType(finalData[s].factual, 'advocate');
                finalData[s].factfavgpress = $scope.calculateAvgType(finalData[s].factual, 'press');
                if ($scope.userData && $scope.userData.followlist.length > 0) {
                  finalData[s].factfavgfollow = $scope.calculateAvgId(finalData[s].recommended, $scope.userData.followlist);
                } else {
                  finalData[s].factfavgfollow = 0;
                }

              } else {
                finalData[s].factfavg = 0;
                finalData[s].factfavgvoters = 0;
                finalData[s].factfavgpolitician = 0;
                finalData[s].factfavgadvocate = 0;
                finalData[s].factfavgpress = 0;
                finalData[s].factfavgfollow = 0;
              }
              //MyService.ConsoleLog("finalData[s] :", finalData[s]);
              $scope.searchResults.data.push(finalData[s]);
            }
            $scope.totalResults = responseLatest.data.data.length;

            data.mediaoption = "";
            data.mediaoption = [];
            data.mediaoption.length = 0;
          } else {
            data.mediaoption = "";
            data.mediaoption = [];
            data.mediaoption.length = 0;
            $scope.searchResults.data.length = 0;
            MyService.ConsoleLog("There are no records");
          }
        }, function errorCallBack(responseLatest) {
          MyService.ConsoleLog(responseLatest);
          alert("Error : " + responseLatest);
        });
      } else {
        if (msg != "") {
          alert(msg);
        } else {
          alert("Please enter valid data");
        }

      }
    }
    $scope.ShowOrderList = false;
    $scope.showOrder = function () {
      if (!$scope.ShowOrderList) {
        $scope.ShowOrderList = true;
      } else {
        $scope.ShowOrderList = false;
      }
    }

    $scope.isreverse = false;
    $scope.showAvg = true;
    $scope.showVoters = false;
    $scope.showPolitician = false;
    $scope.showAdvocate = false;
    $scope.showPress = false;
    $scope.showFollow = false;
    $scope.showfAvg = true;
    $scope.showfVoters = false;
    $scope.showfPolitician = false;
    $scope.showfAdvocate = false;
    $scope.showfPress = false;
    $scope.showfFollow = false;
    $scope.resetAllOrder = function () {
      $scope.showAvg = false;
      $scope.showVoters = false;
      $scope.showPolitician = false;
      $scope.showAdvocate = false;
      $scope.showPress = false;
      $scope.showFollow = false;
    }
    $scope.resetAllfOrder = function () {
      $scope.showfAvg = false;
      $scope.showfVoters = false;
      $scope.showfPolitician = false;
      $scope.showfAdvocate = false;
      $scope.showfPress = false;
      $scope.showfFollow = false;
    }

    $scope.sortValues = function (data) {
      var result = "";
      $scope.resetAllOrder();
      $scope.resetAllfOrder();

      $scope.showfAvg = true;
      $scope.showAvg = true;


      switch ($scope.search.order) {
        case "Most Recent":
          $scope.isreverse = true;
          $scope.showAvg = true;
          $scope.showfAvg = true;
          result = data.createdOn;
          break;
        case "Oldest":
          $scope.isreverse = false;
          $scope.showAvg = true;
          $scope.showfAvg = true;
          result = data.createdOn;
          break;
        case "Highest Recommended":
          $scope.resetAllOrder();
          $scope.isreverse = true;
          $scope.showAvg = true;
          $scope.showfAvg = true;
          result = data.recavg;
          break;
        case "Least Recommended":
          $scope.resetAllOrder();
          $scope.isreverse = false;
          $scope.showAvg = true;
          $scope.showfAvg = true;
          result = data.recavg;
          break;
        case "Most Factual":
          $scope.resetAllfOrder();
          $scope.isreverse = true;
          $scope.showAvg = true;
          $scope.showfAvg = true;
          result = data.factfavg;
          break;
        case "Least Factual":
          $scope.resetAllfOrder();
          $scope.isreverse = false;
          $scope.showAvg = true;
          $scope.showfAvg = true;
          result = data.factfavg;
          break;
        case "Default":
          $scope.resetAllOrder();
          $scope.resetAllfOrder();
          $scope.isreverse = true;
          result = data.createdOn;
          $scope.showAvg = true;
          $scope.showfAvg = true;
          break;

      }

      switch ($scope.search.recommendorder) {
        case "Voters":
          $scope.resetAllOrder();
          $scope.showVoters = true;
          $scope.isreverse = true;
          result = data.recavgvoters;
          break;
        case "Politicians":
          $scope.resetAllOrder();
          $scope.showPolitician = true;
          $scope.isreverse = true;
          result = data.recavgpolitician;
          break;
        case "Organizations":
          $scope.resetAllOrder();
          $scope.showAdvocate = true;
          $scope.isreverse = true;
          result = data.recavgadvocate;
          break;
        case "Press":
          $scope.resetAllOrder();
          $scope.showPress = true;
          $scope.isreverse = true;
          result = data.recavgpress;
          break;
        case "Authors on my follow list":
          $scope.resetAllOrder();
          $scope.showFollow = true;
          $scope.isreverse = true;
          result = data.recavgfollow;
          break;
        case "Default":
          $scope.resetAllOrder();
          $scope.showAvg = true;

          break;

      }

      switch ($scope.search.lrecommendorder) {
        case "Voters":
          $scope.resetAllOrder();
          $scope.showVoters = true;
          $scope.isreverse = false;
          result = data.recavgvoters;
          break;
        case "Politicians":
          $scope.resetAllOrder();
          $scope.showPolitician = true;
          $scope.isreverse = false;
          result = data.recavgpolitician;
          break;
        case "Organizations":
          $scope.resetAllOrder();
          $scope.showAdvocate = true;
          $scope.isreverse = false;
          result = data.recavgadvocate;
          break;
        case "Press":
          $scope.resetAllOrder();
          $scope.showPress = true;
          $scope.isreverse = false;
          result = data.recavgpress;
          break;
        case "Authors on my follow list":
          $scope.resetAllOrder();
          $scope.showFollow = true;
          $scope.isreverse = false;
          result = data.recavgfollow;
          break;
        case "Default":
          $scope.resetAllOrder();
          $scope.showAvg = true;
          break;

      }

      switch ($scope.search.factualorder) {
        case "Voters":
          $scope.resetAllfOrder();
          $scope.showfVoters = true;
          $scope.isreverse = true;
          result = data.factfavgvoters;
          break;
        case "Politicians":
          $scope.resetAllfOrder();
          $scope.showfPolitician = true;
          $scope.isreverse = true;
          result = data.factfavgpolitician;
          break;
        case "Organizations":
          $scope.resetAllfOrder();
          $scope.showfAdvocate = true;
          $scope.isreverse = true;
          result = data.factfavgadvocate;
          break;
        case "Press":
          $scope.resetAllfOrder();
          $scope.showfPress = true;
          $scope.isreverse = true;
          result = data.factfavgpress;
          break;
        case "Authors on my follow list":
          $scope.resetAllOrder();
          $scope.showfFollow = true;
          $scope.isreverse = true;
          result = data.factfavgfollow;
          break;
        case "Default":
          $scope.resetAllfOrder();
          $scope.showfAvg = true;
          break;

      }

      switch ($scope.search.lfactualorder) {
        case "Voters":
          $scope.resetAllfOrder();
          $scope.showfVoters = true;
          $scope.isreverse = false;
          result = data.factfavgvoters;
          break;
        case "Politicians":
          $scope.resetAllfOrder();
          $scope.showfPolitician = true;
          $scope.isreverse = false;
          result = data.factfavgpolitician;
          break;
        case "Organizations":
          $scope.resetAllfOrder();
          $scope.showfAdvocate = true;
          $scope.isreverse = false;
          result = data.factfavgadvocate;
          break;
        case "Press":
          $scope.resetAllfOrder();
          $scope.showfPress = true;
          $scope.isreverse = false;
          result = data.factfavgpress;
          break;
        case "Authors on my follow list":
          $scope.resetAllOrder();
          $scope.showfFollow = true;
          $scope.isreverse = false;
          result = data.factfavgfollow;
          break;
        case "Default":
          $scope.resetAllfOrder();
          $scope.showfAvg = true;
          break;

      }
      //MyService.ConsoleLog($scope.search);
      //MyService.ConsoleLog(result);
      return result;

    }

    $scope.HighestRecommended = false;
    $scope.LeastRecommended = false;
    $scope.MostFactual = false;
    $scope.LeastFactual = false;
    $scope.ShowUsers = function (option) {
      switch (option) {
        case "HighestRecommended":
          if (!$scope.HighestRecommended) {
            $scope.HighestRecommended = true;
          } else {
            $scope.HighestRecommended = false;
          }
          break;
        case "LeastRecommended":
          if (!$scope.LeastRecommended) {
            $scope.LeastRecommended = true;
          } else {
            $scope.LeastRecommended = false;
          }
          break;
        case "MostFactual":
          if (!$scope.MostFactual) {
            $scope.MostFactual = true;
          } else {
            $scope.MostFactual = false;
          }
          break;
        case "LeastFactual":
          if (!$scope.LeastFactual) {
            $scope.LeastFactual = true;
          } else {
            $scope.LeastFactual = false;
          }
          break;
        case "Default":
          $scope.HighestRecommended = false;
          break;
      }
    }

    $scope.gotoThread = function (data) {
      var id = data;
      //MyService.ConsoleLog(data);
      MyService.ConsoleLog('essayDetails/' + $routeParams.categoryId + '/' + id);
      $location.path('essayDetails/' + $routeParams.categoryId + '/' + id);
    }

    $scope.GotoEdit = function (id) {
      $location.path('/essayUpdate/' + $routeParams.categoryId + '/' + id);
    }



    $scope.showadvace = function () {
      if (!$scope.ShowAdavace) {
        $scope.ShowAdavace = true;

      } else {
        $scope.ShowAdavace = false;

      }
      var query = $scope.search.text;
      $scope.search = {
        text: query,
        subject: '',
        Locations: '',
        mediaoption: [],
        mediaType: '',
        dateBefore: '',
        dateAfter: '',
        matchFrom: '',
        matchTo: '',
        recommendFrom: '',
        recommendTo: '',
        recommendFilter: '',
        factualFilter: '',
        factualFrom: '',
        factualTo: '',
        order: '',
        recommendorder: '',
        lrecommendorder: '',
        factualorder: '',
        lfactualorder: '',
        fromfollowlist: '',
        chk: false
      };
    }
    if (tokenService.getUserId()) {
      $scope.getMailingAddress(tokenService.getUserId());

    }
    if ($routeParams.categoryId) {
      getCategory($routeParams.categoryId, "Main");
      $scope.getStaffEssayList();
      $scope.getEssayList();
    }
  }]);

'use strict';
angular.module('myApp.endorsePolitician', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/endorsePolitician', {
      templateUrl: 'app/endorsePolitician/endorsePolitician.html',
      controller: 'endorsePoliticianCtrl'
    });

  }]).controller('endorsePoliticianCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', '$sce', 'growl', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService, $sce, growl) {


    /**
     * Get list of Endorse Politicians
     */
    $scope.getEndorseList = function () {
      MyService.getEndorsePoliList({
        orgId: tokenService.getUserId()
      }).then(function (response) {
        MyService.ConsoleLog("Response", response);
        $scope.endorseList = response.data.data;
      }, function (error) {
        // MyService.ConsoleLog("")
        growl.error(error);
      });
    };

    $scope.getEndorseList();

    /**
     * Remove Politician from endorse table
     */

    $scope.removeEndorse = function (val) {
      // alert(val);
      MyService.removePoliFromEndorse({
        pId: val,
        orgId: tokenService.getUserId()
      }).then(function (result) {
        MyService.ConsoleLog('result', result);
        growl.success(result.data.data);
        $scope.getEndorseList();
      }, function (err) {
        growl.error(err);
      });
    };
  }]);

'use strict';
angular.module('myApp.endorseBallot', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/endorseBallot/:id?', {
      templateUrl: 'app/endorseBallot/endorseBallot.html',
      controller: 'endorseBallotCtrl'
    });
  }])
  .controller('endorseBallotCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', '$sce', 'growl', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService, $sce, growl) {

    /**
     * Get params using $route params
     */
    $scope.bId = $routeParams.id;
    MyService.ConsoleLog("$scope.bId", $scope.bId);

    $scope.userId = tokenService.getUserId();
    $scope.userData = JSON.parse(tokenService.getUserData());
    // MyService.ConsoleLog("$scope.userData", $scope.userData);
    $scope.endorse = {
      toId: '',
      toName: '',
      fromId: $scope.userData.id,
      fromName: $scope.userData.name,
      fromType: '',
      isEndorse: false,
      note: ''
    };
    $scope.showLoader = false;

    /**
     * Get Ballot measures Details
     */
    $scope.selectedUser = {};
    /**
     * Get Details of ballot measures
     */
    $scope.getDetailsOfBallot = function () {
      MyService.getDetailsOfBallotMeasures({
        bId: $scope.bId
      }).then(function (response) {
        MyService.ConsoleLog("Response", response);

        if (response) {
          $scope.selectedUser.value = response.title;
          $scope.endorse = {
            toId: response._id,
            toName: response.title,
            fromId: $scope.userData.id,
            fromName: $scope.userData.name,
            fromType: $scope.userType,
            isEndorse: false,
            note: ''
          };
        }
      }, function (err) {
        MyService.ConsoleLog("Error", err);
      });
    };

    $scope.submitEndorse = function () {
      var params = {
        toId: $scope.endorse.toId,
        toName: $scope.endorse.toName,
        fromId: $scope.endorse.fromId,
        fromName: $scope.endorse.fromName,
        fromType: $scope.endorse.fromType,
        isEndorse: true,
        note: $scope.endorse.note
      };
      MyService.ConsoleLog("params", params);

      MyService.endorseBallotMeasures(params).then(function (response) {
        MyService.ConsoleLog("Response", response);
        $location.path('/showBallotEndorsement/' + $scope.bId);
      }, function (err) {
        MyService.ConsoleLog("Error", err);
      });
    };

    /**
     * Get current user details
     */
    $scope.getUserDetails = function () {
      MyService.getUserPublicProfile({
        id: $scope.userId,
        type: 'false'
      }).then(function (response) {
        $scope.ShowPorifleLoading = false;
        if (response.data.success) {
          $scope.userDetails = response.data.data;
          // MyService.ConsoleLog("welcome", $scope.userDetails);
          $scope.userProfile = $scope.userDetails.userData;
          MyService.ConsoleLog("welcome to profile", $scope.userProfile);

          $scope.userType = $scope.userProfile.userType;
          MyService.ConsoleLog("welcome to profile", $scope.userType);

          $scope.getDetailsOfBallot();
        } else {
          MyService.ConsoleLog("ELSE vishal");
          alert("Something went wrong.");
        }
      }, function (errorPayload) {
        $scope.ShowPorifleLoading = false;
        MyService.ConsoleLog("ELSE vishal two");

        alert("Something went wrong.");
      });
    };
    $scope.getUserDetails();
  }]);

'use strict';
angular.module('myApp.emailunsubscribe', ['ngRoute'])

.config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/email-unsubscribe/:id', {
       templateUrl: 'app/email_unsubscribe/email_unsubscribe.html',
       controller: 'emailunsubscribeCtrl'
    });
}])

.controller('emailunsubscribeCtrl', ['$scope', '$http', '$location', 'baseApiUrl', 'growl', '$routeParams', 'tokenService', '$rootScope',
function ($scope, $http, $location, baseApiUrl, growl, $routeParams, tokenService, $rootScope) {        
    $scope.status = 0; // 1: loading, 2: loaded , 3: error, 
    $rootScope.welcome = false;
    $scope.unsubscribe_email = function () {
    	$scope.status = 1;
        $http.post(baseApiUrl + '/user/unsubscribe-email', {
            salt: $routeParams.id
        }).then(function (res) {
            if (res.data.success == true) {
                $scope.status = 2;
            }
            else {
                $scope.status = 3;
            }
        }, function(err){
        	$scope.status = 3;
        });
    };

	if($routeParams.id){
		$scope.unsubscribe_email();
	}

}]);
'use strict';
angular.module('myApp.electionProblems', ['ngRoute'])

  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/electionProblems', {
      templateUrl: 'app/electionProblems/electionProblems.html',
      controller: 'electionProblemsCtrl'
    });
  }])
  .controller('electionProblemsCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService) {

  }]);

'use strict';
angular.module('myApp.editBallotMeasures', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/editBallotMeasures/:bId?', {
      templateUrl: 'app/editBallotMeasures/editBallotMeasures.html',
      controller: 'editBallotMeasuresCtrl'
    });
  }]).controller('editBallotMeasuresCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'growl', 'tokenService', 'ngDialog', 'baseApiUrl', '$anchorScroll', 'MyService', '$window', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, growl, tokenService, ngDialog, baseApiUrl, $anchorScroll, MyService, $window) {

    MyService.ConsoleLog("routeParams", $routeParams.bId);
    $scope.showBallot = "";
    /**
     * Get Details of ballot measures
     */
    $scope.getDetailsOfBallot = function () {
      MyService.getDetailsOfBallotMeasures({
        bId: $routeParams.bId
      }).then(function (response) {
        MyService.ConsoleLog("Response", response);
        $scope.showBallot = response;
      }, function (err) {
        MyService.ConsoleLog("Error", err);
      });
    };

    /**
     * Update ballot measures details
     */
    $scope.updateBallot = function (udata) {
      MyService.ConsoleLog("update", udata);

      MyService.updateBallotMeasures({
        bId: $routeParams.bId,
        upData: JSON.stringify(udata)
      }).then(function (response) {
        MyService.ConsoleLog("Response", response);
        if (response) {
          growl.success("Updated Successfully");
        }
      }, function (err) {
        MyService.ConsoleLog("Error", err);
      });
    };

    /**
     * Navigate back to the listing page
     */
    $scope.goBack = function () {
      $location.path('/uploadBallotMeasures');
    };


    $scope.getDetailsOfBallot();
  }]);

'use strict';

angular.module('myApp.donate', ['ngRoute'])

.config(['$routeProvider', function ($routeProvider) {
     $routeProvider.when('/donate', {
         templateUrl: 'app/donate/donate.html',
         controller: 'donateCtrl' 
     });
}])
.controller('donateCtrl', ['$scope', '$rootScope', '$window', function($scope, $rootScope, $window) {
$rootScope.welcome = false;
$window.scrollTo(0, 0);
}]);

'use strict';
angular
  .module('myApp.displayGuestForPolitician', ['ngRoute'])

  .config([
    '$routeProvider',
    function($routeProvider) {
      $routeProvider.when('/displayGuestForPolitician', {
        templateUrl: 'app/displayGuestForPolitician/displayGuestForPolitician.html',
        controller: 'displayGuestForPoliticianCtrl',
      });
    },
  ])
  .controller('displayGuestForPoliticianCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    '$routeParams',
    '$rootScope',
    '$q',
    '$timeout',
    'growl',
    'tokenService',
    'ngDialog',
    'baseApiUrl',
    '$anchorScroll',
    'MyService',
    '$window',
    function(
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $rootScope,
      $q,
      $timeout,
      growl,
      tokenService,
      ngDialog,
      baseApiUrl,
      $anchorScroll,
      MyService,
      $window
    ) {
      $scope.showTotal = false;

      $scope.getCount = function() {
        MyService.getUsersCount().then(function(result) {
          $scope.count = result.data.data;
          MyService.ConsoleLog('users count: ', $scope.count);
          $scope.showTotal = true;

          $scope.guestIds = $scope.count.guestIds;

          MyService.ConsoleLog('$scope.GuestIs >>', $scope.guestIds);
        });
      };

      $scope.getCount();

      $rootScope.UserType = '';
      $rootScope.state = '';

      /**
       ** This function fetch guest users details
       **
       **/

      $scope.getGuestUsersAnswers = function() {
        var userAdd = tokenService.getUserId();
        MyService.ConsoleLog('userAdd >>', userAdd);

        // MyService.getGuestUsersAnswers({ "ids": $scope.guestIds, "userId": userAdd }).then(function(payload) {

        //   MyService.ConsoleLog("Payload >>", payload.data.data);
        //   var mData = JSON.stringify(payload.data.data);

        //   window.localStorage.setItem("cData", mData);
        //   $location.path('/compareGuestWith');
        // }, function(error) {

        //   MyService.ConsoleLog("error >>", error);

        // });
      };
    },
  ]);

'use strict';
angular.module('myApp.discussWithOthers', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/discussWithOthers/:catId?/:subCat?', {
      templateUrl: 'app/discussWithOthers/discussWithOthers.html',
      controller: 'discussWithOthersCtrl'
    });
  }])
  .controller('discussWithOthersCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'baseApiUrl', 'tokenService', 'MyService', 'ngDialog', '$filter', 'growl', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, baseApiUrl, tokenService, MyService, ngDialog, $filter, growl) {

    /**
     * Get params from the route
     */
    $scope.catId = $routeParams.catId;
    $scope.subCat = $routeParams.subCat;
    $scope.showtxt = false;
    if (tokenService.getUserData()) {
      MyService.ConsoleLog("tokenservice", JSON.parse(tokenService.getUserData()));
      $scope.uAddress = JSON.parse(tokenService.getUserData());
      MyService.ConsoleLog("$aaaaa", $scope.uAddress);
      if (!$scope.uAddress.address.statePostalCode) {
        $scope.addressPopup = ngDialog.open({
          template: 'addressPopUp',
          closeByNavigation: true,
          scope: $scope
        });
      }
    }

    $scope.Location = {
      county: "",
      place: "",
      state: ""
    };

    MyService.ConsoleLog(" $scope.catId", $scope.catId);
    MyService.ConsoleLog("$scope.subCat", $scope.subCat);
    var getLevelCategoryCanceler = $q.defer();

    /**
     * Get Cat
     */
    $scope.getCat = function (params) {

      getLevelCategoryCanceler.resolve();
      getLevelCategoryCanceler = $q.defer();

      var request = apiCall.apiCall('GET', '/categories/list-layer', params);
      request.timeout = getLevelCategoryCanceler.promise;
      $http(request).then(function successCallback(response) {
        MyService.ConsoleLog("response", response);
        $scope.catData = response.data.data;
        angular.forEach($scope.catData, function (val, key) {
          if (val._id == $routeParams.subCat) {

            $scope.currBackgroundIndex = key;
            //MyService.ConsoleLog("$scope.currBackgroundIndex: ", key);
            $scope.subcat = angular.copy(val);
            MyService.ConsoleLog($scope.subcat);
          }
        });
        $scope.getTopics();
      }, function errorCallBack(err) {
        MyService.ConsoleLog("Error: ", err);
        $scope.status.levlCat = 3;
      });

    };

    /**
     * Get records of the topics
     */
    $scope.getTopics = function () {

      MyService.getRecordsOf({
        catId: $scope.catId,
        subCat: $scope.subCat,
        address: JSON.stringify($scope.uAddress.address)
      }).then(function (response) {
        MyService.ConsoleLog("Response", response);

        $scope.tempArr = [];
        $scope.tempArr.push(response[0]);
        $scope.records = response;
      }, function (err) {
        $scope.showtxt = true;
        growl.error(err.error);
        MyService.ConsoleLog("Error", err);
      });
    };
    if (tokenService.getUserId()) {
      var param = {
        id: $routeParams.catId,
      };
      $scope.getCat(param);
    }

    $scope.setAddressNew = function (address) {

      //MyService.ConsoleLog("setAddressNew > ", address);

      // if ($scope.statusGetStates == 2 && $scope.statusGetZipdata == 2) {

      var postobj = {
        userId: tokenService.getUserId(),
        zipcode: "",
        mailingAddress: $scope.mailing_Address
      };

      var add = {};

      if (address.state) {
        add.state = address.state.state;
        add.statePostalCode = address.state.statePostalCode;
        add.stateFips = address.state.stateFips;
        //MyService.ConsoleLog("address.statePostalCode :", address.state);
      }

      if (address.place) {
        add.placeFips = address.place.placeFips;
        add.place = address.place.placeName;
      }

      if (address.county) {
        add.countyFips = address.county.countyFips;
        add.county = address.county.countyName;
      }

      if (address.subcounty) {
        add.countySubdivisionFips = address.subcounty.COUSUBFP;
        add.countySubdivision = address.subcounty.NAME;
      }

      if (address.federalCongrassionalDist) {
        add.federalCongrassionalDist = address.federalCongrassionalDist.CD115FP;
      }

      if (address.stateSenateDistrict) {
        add.stateSenateDistrict = address.stateSenateDistrict.SLDUST;
      }

      if (address.unifiedSchoolDistrictName) {
        add.schoolDistrictFips = address.unifiedSchoolDistrictName.UNSDLEA;
        add.schoolDistrict = address.unifiedSchoolDistrictName.NAME;
      }

      // if ($scope.address.voterDistrict) {
      //   address.voterDistrictFips = $scope.address.voterDistrict.number;
      //   address.voterDistrict = $scope.address.voterDistrict.name;
      // }

      if (address.stateHouseOFRepresentativeDistrict) {
        var str = address.stateHouseOFRepresentativeDistrict.NAMELSAD;
        //MyService.ConsoleLog("address.stateLegislativeDistrict.NAMELSAD >>>>", str);

        var newString = str.substr(0, str.length - 3);
        //MyService.ConsoleLog("newString >>>>", newString);

        switch (newString) {

          case "General Assembly District":
            add.legislativeDistrict = address.stateHouseOFRepresentativeDistrict.NAMELSAD.replace("General Assembly District ", "");
            break;
          case "Assembly District":
            add.legislativeDistrict = address.stateHouseOFRepresentativeDistrict.NAMELSAD.replace("Assembly District ", "");
            break;
          case "State House District":
            add.legislativeDistrict = address.stateHouseOFRepresentativeDistrict.NAMELSAD.replace("State House District ", "");
            break;

          default:
            break;
        }




      }



      var finalLoc = JSON.parse($scope.loc);
      //MyService.ConsoleLog(" $scope.address: ", finalLoc);


      add.loca = {
        "type": "Point",
        "coordinates": [finalLoc.longitude, finalLoc.latitude]
      }

      // alert("got");

      //MyService.ConsoleLog(">>>>>>>>>> add >>>>>>>>>>>: ", address);
      postobj.mailingAddress = $scope.mailing_Address ? $scope.mailing_Address : "";

      postobj.address = JSON.stringify(add);
      //MyService.ConsoleLog("postobj.address: ", postobj);

      MyService.updateAddress(postobj).then(function (data) {
        growl.success("Updated successfully.");
        // $scope.setAddressNew();
        MyService.ConsoleLog("data", data);
        $scope.addressPopup.close();
        // $scope.closeThisDialog();
      }, function (err) {
        growl.error("Something went wrong.");
      });

      // }

    }

    $scope.checkLen = function (ldata, sval) {
      // //MyService.ConsoleLog("vdata : ", vdata);
      //MyService.ConsoleLog("vdata", ldata);
      if (ldata && ldata.length > 0) {
        var data = ldata.map(function (sub) {
          var returnval = "";
          switch (sval) {
            case "federalCongrassionalDist":
              returnval = sub.CD115FP;
              break;
            case "stateSenateDistrict":
              returnval = sub.SLDUST;
              break;
            case "stateHouseOFRepresentativeDistrict":
              returnval = sub.NAMELSAD;
              break;
            case "unifiedSchoolDistrictName":
              returnval = sub.NAME;
              break;
            case "place":
              returnval = sub.place;
              break;
            case "countySubdivision":
              returnval = sub.countySubdivision;
              break;
            case "county":
              returnval = sub.county;
              break;
            case "state":
              returnval = sub.state;
              break;
            case "default":
              returnval = sub.NAME;
              break;
          }
          return returnval;
        });

        var ndata = $filter("unique")(data);
        if (ndata.length > 1) {
          return "yellowBackground";
        } else {
          return "";
        }
      } else {
        return "";
      }
    };

    $scope.allcounties = [];

    $scope.getCounties = function (lbl) {
      MyService.ConsoleLog("county >", $scope.oldaddress);
      // $scope.allcounties.length = 0;
      var statePostalCode = "";
      var state = "";
      // if (lbl == "new") {
      //   state = JSON.stringify($scope.oldaddress.state);
      // } else {
      statePostalCode = $scope.oldaddress.state[0].STATEFP;
      // state = $scope.Location.state;
      // }
      // //MyService.ConsoleLog(statePostalCode + "<><><><>>" + state);
      MyService.getAllCounties(statePostalCode, state).then(
        function (payload) {
          // //MyService.ConsoleLog("sublocations Locals : ", payload);
          var allcounties = payload;
          if (lbl == "new") {
            var county = $scope.checkCounty(
              allcounties,
              $scope.oldaddress.county
            );
            $scope.allcounties = county;
            MyService.ConsoleLog("county<><", county[0]);
            MyService.ConsoleLog("$scope.Location", $scope.Location);
            $scope.Location.county = county[0];
          }
        },
        function (errorPayload) {
          growl.error("Something went wrong.");
        }
      );
    };
    $scope.MyPlaces = [];
    $scope.getSubCounties = function (lbl) {
      // //MyService.ConsoleLog(" $scope.Location.state :",$scope.Location.state);
      // //MyService.ConsoleLog("$scope.Location.county :",$scope.Location.county);
      // var county = $scope.Location.county;

      $scope.MyPlaces.length = 0;
      var county = "";
      var statePostalCode = "";
      $scope.MyPlaces.length = 0;
      var state = "";
      var county = "";
      if (lbl == "new") {
        state = JSON.stringify($scope.oldaddress.state);
        county = JSON.stringify($scope.oldaddress.county);
      } else {
        statePostalCode = $scope.Location.state.statePostalCode;
        state = $scope.Location.state;
        county = county.county;
      }
      // //MyService.ConsoleLog(statePostalCode + "===" + county);
      MyService.getAllSubCountiesLocal(statePostalCode, state, county).then(
        function (payload) {
          // payload = JSON.parse(payload);
          $scope.MyPlaces = payload;
          // //MyService.ConsoleLog("PlaCE :", payload);
          // //MyService.ConsoleLog(payload.countySubdivision);
          var subcounties = payload.countySubdivision;
          var places = payload.places;
          // //MyService.ConsoleLog("PlaCE :", payload);
          if (lbl == "new") {
            // //MyService.ConsoleLog("Places 1 > ",$scope.oldaddress.place);
            var subcounty = $scope.checksubCounty(
              subcounties,
              $scope.oldaddress.countySubdivision
            );
            var places = $scope.checkPlaces(places, $scope.oldaddress.place);
            // //MyService.ConsoleLog("subcounty<><><", subcounty);
            $scope.subcounties = subcounty;
            $scope.places = places;
            // //console.log('***********', places[0]);
            // $scope.Location.countySubdivision = subcounty[0];
            $scope.Location.place = places[0];
          }
        },
        function (errorPayload) {
          growl.error("Something went wrong.");
        }
      );
    };

    $scope.checkState = function (rdata, val) {
      //MyService.ConsoleLog("State :", rdata);
      //MyService.ConsoleLog("State val :", val);
      var sdata = [];
      var len = rdata.length;
      var j = 1;

      for (var i = 0; i < len; i++, j++) {
        var rsdata = rdata[i];
        var gdata = val.filter(function (obj) {
          if (
            rsdata.countyFips == obj.COUNTYFP &&
            rsdata.stateFips == obj.STATEFP
          ) {
            // //MyService.ConsoleLog(rdata[i]);
            return rdata[i];
          }
        });
        if (gdata.length > 0) {
          if (sdata.indexOf(rdata[i]) == -1) {
            sdata.push(rdata[i]);
          }
        }

        if (j == len) {
          // //MyService.ConsoleLog("gdata > ", sdata);
          return sdata;
        }
      }
    };

    $scope.checkCounty = function (rdata, val) {
      //MyService.ConsoleLog("County :", rdata);
      //MyService.ConsoleLog("County val :", val);
      var sdata = [];
      var len = rdata.length;
      var j = 1;

      for (var i = 0; i < len; i++, j++) {
        var rsdata = rdata[i];
        var gdata = val.filter(function (obj) {
          if (
            rsdata.countyFips == obj.COUNTYFP &&
            rsdata.stateFips == obj.STATEFP
          ) {
            // //MyService.ConsoleLog(rdata[i]);
            return rdata[i];
          }
        });
        if (gdata.length > 0) {
          if (sdata.indexOf(rdata[i]) == -1) {
            sdata.push(rdata[i]);
          }
        }

        if (j == len) {
          // //MyService.ConsoleLog("gdata > ", sdata);
          return sdata;
        }
      }
    };
    $scope.checksubCounty = function (rdata, val) {
      var sdata = [];
      var len = rdata.length;
      var j = 1;

      for (var i = 0; i < len; i++, j++) {
        var rsdata = rdata[i];
        var gdata = val.filter(function (obj) {
          if (rsdata.countySubdivision == obj.NAME) {
            // //MyService.ConsoleLog(rdata[i]);
            return rdata[i];
          }
        });
        if (gdata.length > 0) {
          if (sdata.indexOf(rdata[i]) == -1) {
            sdata.push(rdata[i]);
          }
        }

        if (j == len) {
          // //MyService.ConsoleLog("gdata > ", sdata);
          return sdata;
        }
      }
    };
    $scope.checkPlaces = function (prdata, val) {
      var sdata = [];
      var len = prdata.length;
      var j = 1;

      for (var i = 0; i < len; i++, j++) {
        var rsdata = prdata[i];
        var gdata = val.filter(function (obj) {
          // //MyService.ConsoleLog(rsdata.place +"=="+ obj.NAME);
          if (rsdata.place == obj.NAME && !rsdata.countyFips) {
            // //MyService.ConsoleLog(rdata[i]);
            return prdata[i];
          }
        });
        if (gdata.length > 0) {
          if (sdata.indexOf(prdata[i]) == -1) {
            sdata.push(prdata[i]);
          }
        }

        if (j == len) {
          // //MyService.ConsoleLog("gdata > ", sdata);
          return sdata;
        }
      }
    };

    $scope.User = {
      Address: ""
    };

    $scope.showCon = false;
    $scope.showBoth = false;
    $scope.showEm = false;

    var options = {
      componentRestrictions: {
        country: "us"
      },
      types: ["geocode"]
    };


    $scope.oldaddress = {
      state: "",
      county: "",
      countySubdivision: "",
      place: ""
    };
    $scope.showAddressDrop = false;
    $scope.showAddressDropDowns = function (zipcode, loc) {
      $scope.showZipLoader = true;
      // //console.log(zipcode);

      if (loc && loc != "") {

        MyService.getAllStates().then(
          function (payload) {
            $scope.allStateRes = payload;
            $scope.states = payload;
            // //MyService.ConsoleLog(" $scope.allStateRes :", $scope.allStateRes);

          },
          function (errorPayload) {
            growl.error("Something went wrong.");
          }
        );

        MyService.getOrganizedZipData({
          "candidate": true,
          loc: loc
        }).then(
          function (respo) {
            //MyService.ConsoleLog("mylog", respo);
            if (respo && respo.state) {
              // var finalData = payload.data;
              // //MyService.ConsoleLog(payload[0]);
              // //MyService.ConsoleLog(payload[0].countySubdivision);
              // //MyService.ConsoleLog(payload[0].county);
              // //MyService.ConsoleLog(payload[0].place);
              var countySubdivisions = respo.places.filter(function (obj) {
                if (obj.COUSUBFP && obj.COUSUBFP != "") {
                  // //MyService.ConsoleLog("Inside cs");
                  return obj;
                }
              });
              var places = respo.places.filter(function (obj) {
                if (obj.PLACEFP && obj.PLACEFP != "") {
                  // //MyService.ConsoleLog("obj > ", obj);
                  return obj;
                }
              });

              // //MyService.ConsoleLog("here");
              $scope.showZipLoader = false;
              $scope.showAddressDrop = true;
              // //MyService.ConsoleLog("countySubdivisions >> ", respo.state[0].NAME);

              $scope.oldaddress.state = respo.state;
              $scope.oldaddress.county = respo.county;
              $scope.oldaddress.countySubdivision = countySubdivisions;
              // //MyService.ConsoleLog("places >>> ",places);
              $scope.oldaddress.place = places;
              $scope.getCounties("new");

              $scope.getSubCounties("new");

              // $scope.voterDistricts = payload;
              // //MyService.ConsoleLog(payload.congressionalDistrict);
              $scope.federalCongrassionalDist = respo.congressionalDistrict;
              //MyService.ConsoleLog("@@@@@@ drop :", $scope.federalCongrassionalDist);

              $scope.stateSenateDistrict = respo.stateSenateDistrict;
              $scope.stateHouseOFRepresentativeDistricts =
                respo.stateHouseofRepresentativesDistrict;
              $scope.unifiedSchoolDistrictNames = respo.unifiedSchoolDistrict;
              //$scope.$apply();
              //MyService.ConsoleLog("$scope.allStates :", $scope.allStates);
              // //MyService.ConsoleLog(payload[0].statePostalCode);
              var address = $scope.checkState($scope.allStateRes, respo.state);
              $scope.allstatesData = address;
              // //MyService.ConsoleLog("address<>", address);
              // $scope.Location.state = address[0];
              // $scope.Location.voterDistrict = $scope.voterDistricts[0];
              $scope.Location.federalCongrassionalDist =
                $scope.federalCongrassionalDist[0];
              $scope.Location.stateSenateDistrict =
                $scope.stateSenateDistrict[0];
              $scope.Location.stateHouseOFRepresentativeDistrict =
                $scope.stateHouseOFRepresentativeDistricts[0];
              $scope.Location.unifiedSchoolDistrictName =
                $scope.unifiedSchoolDistrictNames[0];
              // //MyService.ConsoleLog("address ; ", address);
            } else {
              $scope.showZipLoader = false;
              alert("Zipcode not found in our database. Please correct it");
            }
          },
          function (errorPayload) {
            $scope.showZipLoader = false;
            growl.error(errorPayload);
          }
        );

      } else {

        MyService.getAllStates().then(
          function (payload) {
            $scope.allStateRes = payload;
            $scope.states = payload;
            // //MyService.ConsoleLog(" $scope.allStateRes :", $scope.allStateRes);

          },
          function (errorPayload) {
            growl.error("Something went wrong.");
          }
        );

        MyService.getOrganizedZipData({
          "zipcode": zipcode,
          "candidate": true
        }).then(
          function (respo) {
            //MyService.ConsoleLog("mylog", respo);
            if (respo && respo.state) {
              // var finalData = payload.data;
              // //MyService.ConsoleLog(payload[0]);
              // //MyService.ConsoleLog(payload[0].countySubdivision);
              // //MyService.ConsoleLog(payload[0].county);
              // //MyService.ConsoleLog(payload[0].place);
              var countySubdivisions = respo.places.filter(function (obj) {
                if (obj.COUSUBFP && obj.COUSUBFP != "") {
                  // //MyService.ConsoleLog("Inside cs");
                  return obj;
                }
              });
              var places = respo.places.filter(function (obj) {
                if (obj.PLACEFP && obj.PLACEFP != "") {
                  // //MyService.ConsoleLog("obj > ", obj);
                  return obj;
                }
              });

              // //MyService.ConsoleLog("here");
              $scope.showZipLoader = false;
              $scope.showAddressDrop = true;
              // //MyService.ConsoleLog("countySubdivisions >> ", respo.state[0].NAME);

              $scope.oldaddress.state = respo.state;
              $scope.oldaddress.county = respo.county;
              $scope.oldaddress.countySubdivision = countySubdivisions;
              // //MyService.ConsoleLog("places >>> ",places);
              $scope.oldaddress.place = places;
              $scope.getCounties("new");

              $scope.getSubCounties("new");

              // $scope.voterDistricts = payload;
              // //MyService.ConsoleLog(payload.congressionalDistrict);
              $scope.federalCongrassionalDist = respo.congressionalDistrict;
              //MyService.ConsoleLog("@@@@@@ drop :", $scope.federalCongrassionalDist);

              $scope.stateSenateDistrict = respo.stateSenateDistrict;
              $scope.stateHouseOFRepresentativeDistricts =
                respo.stateHouseofRepresentativesDistrict;
              $scope.unifiedSchoolDistrictNames = respo.unifiedSchoolDistrict;
              //$scope.$apply();
              //MyService.ConsoleLog("$scope.allStates :", $scope.allStates);
              // //MyService.ConsoleLog(payload[0].statePostalCode);
              var address = $scope.checkState($scope.allStateRes, respo.state);
              $scope.allstatesData = address;
              // //MyService.ConsoleLog("address<>", address);
              // $scope.Location.state = address[0];
              // $scope.Location.voterDistrict = $scope.voterDistricts[0];
              //MyService.ConsoleLog("$scope.Location.federalCongrassionalDist :", $scope.federalCongrassionalDist[0]);
              $scope.Location.federalCongrassionalDist =
                $scope.federalCongrassionalDist[0];
              $scope.Location.stateSenateDistrict =
                $scope.stateSenateDistrict[0];
              $scope.Location.stateHouseOFRepresentativeDistrict =
                $scope.stateHouseOFRepresentativeDistricts[0];
              $scope.Location.unifiedSchoolDistrictName =
                $scope.unifiedSchoolDistrictNames[0];
              // //MyService.ConsoleLog("address ; ", address);
            } else {
              $scope.showZipLoader = false;
              alert("Zipcode not found in our database. Please correct it");
            }
          },
          function (errorPayload) {
            $scope.showZipLoader = false;
            growl.error(errorPayload);
          }
        );
      }

    };

    $scope.detectAddress = function (ent) {
      var val = document.getElementById("address");
      // //console.log($scope.User.Address);
      var autocomplete = new google.maps.places.Autocomplete(val, options);

      google.maps.event.addListener(
        autocomplete,
        "place_changed",
        function () {
          var place = autocomplete.getPlace();

          var lat = place.geometry.location.lat(),
            lng = place.geometry.location.lng();

          $scope.lati = lat.toFixed(6);
          $scope.lon = lng.toFixed(6);
          // //console.log($scope.lati);
          // //console.log($scope.lon);

          $scope.mailing_Address = place.formatted_address;
          console.log("  place.address_components :", place.address_components);
          for (var i = 0; i < place.address_components.length; i++) {
            for (
              var j = 0; j < place.address_components[i].types.length; j++
            ) {
              if (
                place.address_components[i].types[j] ==
                "administrative_area_level_1"
              ) {
                $scope.statePostalCode =
                  place.address_components[i].short_name;
                // //console.log($scope.statePostalCode);
              }
              if (place.address_components[i].types[j] == "country") {
                $scope.countryname = place.address_components[i].long_name;
                // //console.log($scope.countryname);
              }
              if (
                place.address_components[i].types[j] ==
                "administrative_area_level_2"
              ) {
                $scope.county_name = place.address_components[i].long_name;
                // //console.log($scope.county_name);
              }
              if (place.address_components[i].types[j] == "locality") {
                $scope.place_name = place.address_components[i].long_name;
                // //console.log($scope.place_name);
              }
              if (place.address_components[i].types[j] == "postal_code") {
                // document.getElementById('zip').value = place.address_components[i].long_name;
                $scope.ZipCode = place.address_components[i].long_name;
                // //console.log($scope.User.ZipCode);
              }
            }
          }

          //MyService.ConsoleLog(" $scope.User.ZipCode :", $scope.ZipCode);


          $scope.loc = JSON.stringify({
            longitude: $scope.lon,
            latitude: $scope.lati
          });
          // //console.log(" long and lat :",$scope.loc );
          // $rootScope.location = new Array;

          $scope.showAddressDropDowns("", $scope.loc);
        }
      );
    };




  }]);

'use strict';

angular.module('myApp.digDeeperView', ['ngRoute'])

  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/digDeeper', {
      templateUrl: 'app/dig_deeper/dig_deeper.html',
      controller: 'digDeeperCtrl'
    });
  }])

  .controller('digDeeperCtrl', ['$scope', '$location', '$timeout', function($scope, $location, $timeout) {
    // var returningUser = apiCall.getToken();
    //
    // if (returningUser) {
    //   $location.path('/debateHome');
    // }
    //$scope.showFacebookLoging = false;

   // $scope.videoURL = "https://www.youtube.com/watch?v=HrZqeFsbQZk";
    $scope.videoID = "HrZqeFsbQZk";

    $scope.playerReady = function(event) {
        MyService.ConsoleLog(event); // Event data logged
    };
    
    $scope.playerStateChanged = function(event) {
        MyService.ConsoleLog(event); // Event data logged
        MyService.ConsoleLog(event.data);
        if(event.data == 0) {
          MyService.ConsoleLog("inside data 0");
          $location.path("/signup/voter");
          $scope.$apply();
        }
    };

     $scope.$on('youtube.player.ended', function ($event, player) {
        MyService.ConsoleLog("inside player end");
           $location.path("/signup/voter");
          // $scope.$apply();
     });

    
  }]);

'use strict';
angular.module('myApp.debateHome', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/debateHome', {
      templateUrl: 'app/debateHome/debateHome.html',
      controller: 'debateHomeCtrl'
    });
  }])

  .controller('debateHomeCtrl', ['$scope', '$http', '$location', 'apiCall', 'baseApiUrl', 'MyService', 'tokenService', '$rootScope', 'ngDialog', function ($scope, $http, $location, apiCall, baseApiUrl, MyService, tokenService, $rootScope, ngDialog) {
    //MyService.ConsoleLog("DebateHome called");
    $scope.imgUrl = baseApiUrl + "/resources";
    $rootScope.welcome = false;
    if (tokenService.getUserData()) {
      $scope.allData = JSON.parse(tokenService.getUserData());
    }

    $scope.location = {
      options: '',
      isInternational: true,
      isNational: true,
      isState: true,
      isCounty: true,
      isLocal: true
    };
    $scope.categories = [];
    $scope.Location = {
      state: "",
      FinalData: ""
    };
    var obj = {};
    $scope.getCategories = function (params) {
      MyService.ConsoleLog("params : ", typeof params);
      MyService.ConsoleLog("$scope.location : ", $scope.location);

      if ($scope.location.options == "other") {
        var address = JSON.stringify($scope.Location.FinalData);
      } else if ($scope.allData) {
        var address = JSON.stringify($scope.allData.address);
      } else {
        var address = "";

      }


      MyService.getCategoryListWithTopics({
        "option": JSON.stringify(params),
        "address": address,
        // "checkOps": $scope.location
      }).then(function (payload) {
        //MyService.ConsoleLog("response recieved");
        $scope.categories = payload;
        //MyService.ConsoleLog(payload);
      }, function (err) {
        //MyService.ConsoleLog("Error: ",err);
      })
    }

    $scope.gotoForum = function (item) {
      MyService.ConsoleLog("item :", item);
      var id = item._id;
      window.localStorage.setItem("locationOption", JSON.stringify($scope.location));
      //MyService.ConsoleLog("Location : ",window.localStorage.getItem("locationOption"));
      $location.path('/forum/' + id + '/home');

    }

    $scope.getResult = function (val) {
      MyService.ConsoleLog("$loca", $scope.location.isState);
      // var tmp = ;
      $scope.getCategories($scope.location);

    }

    $scope.getCategories($scope.location);



    //Other option clicked

    $scope.allState = [];
    $scope.MyDialog = "";
    $scope.showHtmlViewer = function () {

      MyService.getAllStates().then(function (payload) {
          $scope.allState = payload;
          $scope.MyDialog = ngDialog.open({
            template: 'guest_location',
            scope: $scope
            // className: 'ngdialog-theme-default'
          });
        },
        function (errorPayload) {
          growl.error('Something went wrong.');
        });



    };

    $scope.allcounties = [];
    $scope.getCounties = function () {
      //MyService.ConsoleLog($scope.Location.state);
      $scope.allcounties.length = 0;
      MyService.getAllCounties($scope.Location.state.statePostalCode, $scope.Location.state).then(function (payload) {
          //MyService.ConsoleLog("sublocations Locals : ", payload);
          $scope.allcounties = payload;
        },
        function (errorPayload) {
          growl.error('Something went wrong.');
        });
    }
    $scope.MyPlaces = [];
    $scope.getSubCounties = function () {
      //MyService.ConsoleLog($scope.Location.state);
      //MyService.ConsoleLog($scope.Location.county);
      var county = $scope.Location.county;
      $scope.MyPlaces.length = 0;
      MyService.getAllSubCountiesLocal($scope.Location.state.statePostalCode, county._id.county).then(function (payload) {
          $scope.MyPlaces = payload;
          //MyService.ConsoleLog("PlaCE :", payload);

        },
        function (errorPayload) {
          growl.error('Something went wrong.');
        });
    }

    $scope.checkTagsExists = function (rdata, val) {
      return rdata.filter(
        function (rdata) {

          if (rdata.statePostalCode == val)
            return rdata;
        }
      );
    }

    $scope.submitLocation = function () {
      //MyService.ConsoleLog($scope.Location.state);
      //MyService.ConsoleLog($scope.Location.county);
      //MyService.ConsoleLog($scope.Location.place);

      if ($scope.Location.state && $scope.Location.state != "") {
        var nobj = new Object;
        nobj.state = $scope.Location.state.state;
        $scope.Location.FinalData = nobj;
      }

      if ($scope.Location.county && $scope.Location.county._id && $scope.Location.county._id.county != "") {
        var finalObj = $scope.Location.county._id;
        var fobj = $scope.checkTagsExists($scope.allState, $scope.Location.county._id.statePostalCode)
        finalObj.state = fobj[0].state;
        $scope.Location.FinalData = finalObj;
      }

      if ($scope.Location.place && $scope.Location.place._id && $scope.Location.place._id.place != "") {
        var finalObj = $scope.Location.place._id;
        var fobj = $scope.checkTagsExists($scope.allState, $scope.Location.place._id.statePostalCode);
        finalObj.state = fobj[0].state;
        $scope.Location.FinalData = finalObj;


      }

      //MyService.ConsoleLog($scope.Location.FinalData);
      //$rootScope.FinalData = $scope.Location.FinalData;
      $scope.MyDialog.close();
      $scope.getCategories('Local');
      //$scope.getLocalPoliticians();
    }

    //Other option clicked End




  }]);

"use strict";
angular
  .module("myApp.dashboard", ["ngRoute"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/dashboard", {
        templateUrl: "app/dashboard/dashboard.html",
        controller: "dashboardCtrl",
      });
    },
  ])
  .controller("dashboardCtrl", [
    "$scope",
    "$http",
    "$location",
    "apiCall",
    "$rootScope",
    "baseApiUrl",
    "$q",
    "$filter",
    "growl",
    "ngDialog",
    "tokenService",
    "MyService",
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $rootScope,
      baseApiUrl,
      $q,
      $filter,
      growl,
      ngDialog,
      tokenService,
      MyService
    ) {
      //MyService.ConsoleLog("** dashboardCtrl **");
      $rootScope.welcome = false;
      $scope.allParentCats = [];
      $scope.statusGetCats = 0;
      $scope.alert_msg = false;
      $scope.success_msg = false;
      // $scope.search = false;

      $rootScope.getParentCategories = function (idx) {
        //MyService.ConsoleLog("getParentCategories: ", idx);
        if (idx == 0) {
          $scope.allParentCats = [];
        }
        $scope.statusGetCats = 1;
        var request = apiCall.apiCall("GET", "/categories/list", {
          root: 1,
          questions_counter: 0,
        });
        $http(request).then(
          function successCallback(response) {
            if (response.data.success) {
              $scope.parentCategories = response.data.data;
              /*
          $scope.selectedCategories = [{ "selected": null, viewOrders: 0, "items": $scope.parentCategories }];
          $scope.selCatForQues = [{ "selected": null, viewOrders: 0, "items": $scope.parentCategories }];
          $scope.selCatForCatUpdate = [{ "selected": null, viewOrders: 0, "items": $scope.parentCategories }];
          $scope.selCatForNewCatUpdate = [{ "selected": null, viewOrders: 0, "items": $scope.parentCategories }];*/
              $scope.allParentCats[idx] = [
                {
                  selected: null,
                  viewOrders: 0,
                  items: $scope.parentCategories,
                },
              ];
              $scope.selCatForCatUpdate = [
                {
                  selected: null,
                  viewOrders: 0,
                  items: $scope.parentCategories,
                },
              ];
              $scope.selCatForNewCatUpdate = [
                {
                  selected: null,
                  viewOrders: 0,
                  items: $scope.parentCategories,
                },
              ];
              $scope.statusGetCats = 2;
            } else {
              //MyService.ConsoleLog(response.data.error);
              growl.error("Something went wrong");
              $scope.statusGetCats = 3;
            }
          },
          function errorCallBack(response) {
            growl.error("Something went wrong");
            $scope.statusGetCats = 3;
          }
        );
      };
      $rootScope.getParentCategories(0);

      $scope.addOneMoreParent = function () {
        var idx = $scope.allParentCats.length;
        $scope.getParentCategories(idx);
      };
      $scope.removeParent = function (pindex) {
        // body...
        //MyService.ConsoleLog("removeParent pindex: ", pindex);
        // $scope.allParentCats.length = pindex;
        $scope.allParentCats.splice(pindex, 1);
      };
      $scope.hideAll = function () {
        //alert("1");
        $rootScope.showProfile = false;
        $rootScope.showPoliProfile = false;
        $rootScope.showFollowing = false;
        $scope.showAddCategories = false;
        $scope.showUpdateCategories = false;
        $scope.showAddQuestion = false;
        $rootScope.showReportQuestion = false;
        $scope.showFiveMatchQuestion = false;
        $scope.showUserVerification = false;
        $rootScope.showAllCongressman = false;
        $rootScope.showCongressbills = false;
        $rootScope.showUpload = false;
        $rootScope.showVUpload = false;
        $rootScope.showRUpload = false;
        $rootScope.showHUpload = false;
        $rootScope.showOrganized = false;
        $rootScope.showAdvocates = false;
        $rootScope.showPress = false;
        $rootScope.showTopicSpam = false;
        $rootScope.showAllUsers = false;
        $rootScope.showAllTopic = false;
        $rootScope.showAllEssay = false;
        $rootScope.showAllEmail = false;
        $rootScope.showOpenFec = false;
        $rootScope.showOpenFecCommittee = false;
        $rootScope.postCard = false;

        $rootScope.showPlacesShape = false;
        $rootScope.showAllRecommendation = false;
        $scope.showBackup = false;
      };

      // $scope.parentCategories = angular.copy($rootScope.categories);

      /*
    $rootScope.$on("EventParentCategoriesFetched", function() {
        $scope.parentCategories = angular.copy($rootScope.categories);
        $scope.selectedCategories = [{ "selected": null, viewOrders: 0, "items": $scope.parentCategories }];
        $scope.selCatForQues = [{ "selected": null, viewOrders: 0, "items": $scope.parentCategories }];

        $scope.selCatForCatUpdate = [{ "selected": null, viewOrders: 0, "items": $scope.parentCategories }];
        $scope.selCatForNewCatUpdate = [{ "selected": null, viewOrders: 0, "items": $scope.parentCategories }];
    });
    */

      $scope.showAddCategories = false;

      $scope.cattypes = [
        {
          lbl: "Essay",
          val: "E",
        },
        {
          lbl: "For forum",
          val: "F",
        },
        {
          lbl: "For questions",
          val: "Q",
        },
      ];
      $scope.updateCatTypes = angular.copy($scope.cattypes);

      /*
    $scope.catTypeSelected = function (val, selected) {
        //MyService.ConsoleLog("* catTypeSelected *", val);
            if(!$scope.category.catType) $scope.category.catType = [];

            var idx = $scope.category.cat_type.indexOf(val);
            if(selected)
                $scope.category.catType.push(val);
            else
                $scope.category.catType.splice(idx, 1);

            //MyService.ConsoleLog("category.catType: ",$scope.category.catType);
    };
    $scope.updateCatTypeSelected = function (val, selected) {
        //MyService.ConsoleLog("* updateCatTypeSelected *", val);

            var idx = $scope.updateCat.cat_type.indexOf(val);
            if(selected)
                $scope.updateCat.cat_type.push(val);
            else
                $scope.updateCat.cat_type.splice(idx, 1);

        //MyService.ConsoleLog("updateCatTypeSelected: ",$scope.updateCat.cat_type);
    };
    */

      $scope.initVarCat = function () {
        $scope.category = {
          title: "",
          parentIds: [],
          viewOrders: [],
          description: "",
          viewOrder: 0,
          files: null,
          catType: [],
        };
        $scope.selectedCategories = [
          {
            selected: null,
            viewOrders: 0,
            items: $scope.parentCategories,
          },
        ];
        angular.forEach($scope.cattypes, function (c, i) {
          c.selected = false;
        });
      };
      $scope.initVarCat();

      $scope.addCategory = function () {
        /*
      var tempParentIds = [],
          tempViewOrders = [];
      angular.forEach($scope.selectedCategories, function(val, key) {
          //MyService.ConsoleLog("key: ", key, " val: ", val);
          if (val) {
              // val = JSON.parse(val);
              var selectedVal = JSON.parse(val.selected);
              if (selectedVal && selectedVal._id) {
                  tempParentIds.push(selectedVal._id);
                  tempViewOrders[0] = val.viewOrders;
              }
          }
      });*/
        //MyService.ConsoleLog("allParentCats: ", $scope.allParentCats);
        var tempParentIdsAll = [],
          tempViewOrders = [];
        angular.forEach($scope.allParentCats, function (pcat, i) {
          // body...
          var tempParentIds = [];
          var len = pcat.length;
          var tViewOrder = null;
          angular.forEach(pcat, function (val, key) {
            //MyService.ConsoleLog("key: ", key, " val: ", val);
            if (val) {
              // val = JSON.parse(val);
              var selectedVal = JSON.parse(val.selected);
              if (selectedVal && selectedVal._id) {
                tempParentIds.push(selectedVal._id);
                tViewOrder = val.viewOrders;
              }
            }
          });
          //MyService.ConsoleLog("tViewOrder: ", tViewOrder);
          if (tViewOrder != null) tempViewOrders.push(tViewOrder);
          tempParentIdsAll.push(tempParentIds.join(","));
        });

        //MyService.ConsoleLog("--------------------------------");
        //MyService.ConsoleLog("tempParentIdsAll: ", tempParentIdsAll);
        //MyService.ConsoleLog("tempViewOrders: ", tempViewOrders);
        //MyService.ConsoleLog("cat_type: ", $scope.category.cat_type);
        var fd = new FormData();
        fd.append("title", $scope.category.title);
        fd.append("description", $scope.category.description);
        //MyService.ConsoleLog("category files: ", $scope.category.files);

        angular.forEach($scope.category.files, function (file) {
          //MyService.ConsoleLog("append file", file);
          fd.append("file", file);
        });

        fd.append("file", $scope.category.files);

        if (tempParentIdsAll.length > 0) {
          fd.append("parentIds", tempParentIdsAll.join(";"));
          fd.append("viewOrders", tempViewOrders.join(","));
        } else {
          fd.append("viewOrder", $scope.category.viewOrder);
        }

        var tempCatTypes = [];
        angular.forEach($scope.cattypes, function (c, i) {
          if (c.selected) {
            tempCatTypes.push(c.val);
          }
        });
        if (tempCatTypes <= 0) {
          growl.error("At least select one category type.");
          return;
        } else {
          fd.append("catType", tempCatTypes.join(","));
        }
        //MyService.ConsoleLog("formData: ",fd);
        var posturl = baseApiUrl + "/categories/create";
        $http({
          method: "POST",
          url: posturl,
          // headers: { 'Content-Type': false },
          headers: {
            "Content-Type": undefined,
            "x-access-token": tokenService.getToken(),
          },
          transformRequest: angular.identity,
          //Create an object that contains the model and files which will be transformed
          // in the above transformRequest method
          data: fd,
        }).then(
          function (response, status, headers, config) {
            //MyService.ConsoleLog("success data: ", response.data);
            if (response.data.success) {
              $scope.initVarCat();
              $rootScope.getCategories();
              $rootScope.getParentCategories(0);
              growl.success("Added successfully!");
            } else if (
              response.data.error &&
              typeof response.data.error == "string"
            ) {
              growl.error("Error: " + response.data.error);
            } else {
              growl.error("Something went wrong.");
            }
          },
          function (data, status, headers, config) {
            //MyService.ConsoleLog("error: ", data);
            growl.error("Something went wrong");
          }
        );

        $scope.showProfile = false;
        $rootScope.showProfile = false;
        $rootScope.showUpload = false;
        $rootScope.showAllCongressman = false;
        $rootScope.showCongressbills = false;
        $rootScope.showVUpload = false;
        $rootScope.showRUpload = false;
        $rootScope.showHUpload = false;
        $rootScope.showOrganized = false;
        $rootScope.showAdvocates = false;
        $rootScope.showFollowing = false;
        $rootScope.showTopicSpam = false;
        $rootScope.showAllTopic = false;
        $rootScope.showReportQuestion = false;
        $scope.showFiveMatchQuestion = false;
        $rootScope.showAllEssay = false;
        $rootScope.showPress = false;
        $rootScope.showAllEvents = false;

        //$root.showAdvocates = !$root.showAdvocates
        //MyService.ConsoleLog("addCategory", $scope.category);

        /*
      var fd = new FormData();
      fd.append("title", $scope.category.title);
      fd.append("description", $scope.category.title);
      //MyService.ConsoleLog("category files: ", $scope.category.files);
      angular.forEach($scope.category.files, function(file){
          //MyService.ConsoleLog("append file", file);
          fd.append('file', file);
      });
      fd.append('file', $scope.category.files);
      var tempParentIds = [], tempViewOrders = [];
      angular.forEach($scope.category.parentIds, function(val, key){
          tempParentIds.push(val._id);
          tempViewOrders.push(val.viewOrders);
      });
      if(tempParentIds.length > 0){
          fd.append("parentIds", tempParentIds.join(","));
          fd.append("viewOrders", tempViewOrders.join(","));
      }
      //MyService.ConsoleLog("formData: ",fd);
      var posturl = baseApiUrl+"/categories/create";
      $http({
          method: 'POST',
          url: posturl,
          // headers: { 'Content-Type': false },
          headers: {'Content-Type': undefined},
          transformRequest: angular.identity,
          //Create an object that contains the model and files which will be transformed
          // in the above transformRequest method
          data: fd
      }).
      success(function (data, status, headers, config) {
          //MyService.ConsoleLog("success data: ",data);
          if(data.success){
              $scope.initVarCat();
              $rootScope.getCategories();
              alert("Added successfully!");
          }
          else{
              alert("Error: ", data.error);
          }
      }).
      error(function (data, status, headers, config) {
          //MyService.ConsoleLog("error: ",data);
          alert("failed!");
      });
       */
      };

      $scope.toggleCategorySelection = function (cat) {
        //MyService.ConsoleLog(" toggleCategorySelection ");
        var idx = $scope.category.parentIds.indexOf(cat);

        // is currently selected
        if (idx > -1) {
          $scope.category.parentIds.splice(idx, 1);
        }
        // is newly selected
        else {
          $scope.category.parentIds.push(cat);
          $scope.statusGetCats = 1;
          var request = apiCall.apiCall("GET", "/categories/list", {
            root: 1,
            questions_counter: 0,
            parentId: cat._id,
          });
          $http(request).then(
            function successCallback(response) {
              if (response.data.success) {
                //MyService.ConsoleLog("Got subcategory data: ", response.data.data);
                // $scope.secondLevelCat = response.data.data;
                cat.subcategory = response.data.data;
                $scope.statusGetCats = 2;
              } else {
                $scope.statusGetCats = 3;
                growl.error("Something went wrong.");
              }
            },
            function errorCallBack(response) {
              $scope.statusGetCats = 3;
              growl.error("Something went wrong.");
            }
          );
        }
      };

      var toogleAddCatSelCanceler = $q.defer();
      $scope.toogleAddCatSel = function (cat, index, pindex) {
        cat = JSON.parse(cat);
        //MyService.ConsoleLog("$scope.selectedCategories: ",$scope.selectedCategories);
        //MyService.ConsoleLog("tempFun index: ", index, "pindex: ", pindex);
        /*
      //remove all elements after given index
      $scope.selectedCategories.length = index + 1;

      toogleAddCatSelCanceler.resolve();
      var params = {
          questions_counter: 0,
          parentId: cat._id,
          timeout: toogleAddCatSelCanceler.promise
      };
      var request = apiCall.apiCall('GET', '/categories/list', params);
      $http(
          request
      ).then(function successCallback(response) {
          if (response.data.success) {
              //MyService.ConsoleLog("Got subcategory data: ", response.data.data);
              if (response.data.data.length > 0)
                  $scope.selectedCategories.push({ "selected": null, viewOrders: 0, "items": response.data.data });
          } else {
              //MyService.ConsoleLog("Something went wrong: ", response.data);
          }
      }, function errorCallBack(response) {
          //MyService.ConsoleLog("Error: ", response);
      });
      */
        //MyService.ConsoleLog("allParentCats: ", $scope.allParentCats);
        $scope.allParentCats[pindex].length = index + 1;

        toogleAddCatSelCanceler.resolve();
        var params = {
          questions_counter: 0,
          parentId: cat._id,
          timeout: toogleAddCatSelCanceler.promise,
        };
        var request = apiCall.apiCall("GET", "/categories/list", params);
        $http(request).then(
          function successCallback(response) {
            if (response.data.success) {
              //MyService.ConsoleLog("Got subcategory data: ", response.data.data);
              if (response.data.data.length > 0) {
                //MyService.ConsoleLog("allParentCats 2: ", $scope.allParentCats);
                //MyService.ConsoleLog("index: ", index, " pindex: ", pindex);
                $scope.allParentCats[pindex].push({
                  selected: null,
                  viewOrders: 0,
                  items: response.data.data,
                });
                //MyService.ConsoleLog("allParentCats 3: ", $scope.allParentCats);
              }
            } else {
              //MyService.ConsoleLog("Something went wrong: ", response.data);
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
          }
        );
      };

      //--------- update category ----------------

      $scope.initUpdateCat = function () {
        $scope.updateCat = {
          id: null,
          title: "",
          parentIds: [],
          viewOrders: [],
          description: "",
          viewOrder: 0,
          files: null,
          iconImage: null,
          old_path: null,
          catType: null,
        };
        $scope.selCatForCatUpdate = [
          {
            selected: null,
            viewOrders: 0,
            items: $scope.parentCategories,
          },
        ];
        $scope.selCatForNewCatUpdate = [
          {
            selected: null,
            viewOrders: 0,
            items: $scope.parentCategories,
          },
        ];
        angular.forEach($scope.updateCatTypes, function (c, i) {
          c.selected = false;
        });
      };
      $scope.initUpdateCat();

      var toggleUpdateCatSelCanceler = $q.defer();
      $scope.toggleUpdateCatSel = function (cat, index) {
        cat = JSON.parse(cat);
        //MyService.ConsoleLog("toggleUpdateCatSel : ", cat);
        $scope.updateCat.id = cat._id;
        $scope.updateCat.title = cat.title;
        $scope.updateCat.description = cat.description;
        if (cat.fbTitle) {
          $scope.updateCat.fbtitle = cat.fbTitle;
        }
        if (cat.fbDescription) {
          $scope.updateCat.fbdescription = cat.fbDescription;
        }
        $scope.updateCat.viewOrder = cat.order;
        $scope.selCatForCatUpdate[index].viewOrders = cat.order;
        //MyService.ConsoleLog(" viewOrders index: ", $scope.selCatForCatUpdate[index].viewOrders);

        angular.forEach($scope.updateCatTypes, function (c, i) {
          c.selected = false; //reset all selected categories
        });
        if (cat.catType) {
          angular.forEach(cat.catType, function (val, key) {
            angular.forEach($scope.updateCatTypes, function (c, i) {
              if (c.val == val) {
                c.selected = true;
              }
            });
          });
          // $scope.updateCat.cat_type = cat.cat_type;
          // angular.forEach($scope.cattypes, function(val, key){
          //  if(val.val == cat.cat_type)
          //      $scope.updateCat.cat_type = val;
          // });
        }
        $scope.updateCat.iconImage = cat.iconImage;
        if (cat.fbImage) {
          $scope.updateCat.fbimage = cat.fbImage;
        }
        //MyService.ConsoleLog("response.data: ", cat);
        try {
          $scope.updateCat.old_path = cat.parentIds._id;
        } catch (e) {
          //MyService.ConsoleLog("Exception :", old_path);
        }

        //remove all elements after given index
        $scope.selCatForCatUpdate.length = index + 1;

        toggleUpdateCatSelCanceler.resolve();
        var params = {
          questions_counter: 0,
          parentId: cat._id,
          timeout: toggleUpdateCatSelCanceler.promise,
        };
        var request = apiCall.apiCall("GET", "/categories/list", params);
        $http(request).then(
          function successCallback(response) {
            if (response.data.success) {
              //MyService.ConsoleLog("Got subcategory data: ", requestsponse.data.data);
              if (response.data.data.length > 0) {
                $scope.selCatForCatUpdate.push({
                  selected: null,
                  viewOrders: 0,
                  items: response.data.data,
                });
              }
            } else {
              //MyService.ConsoleLog("Something went wrong: ", response.data);
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
          }
        );
      };

      var toggleUpdateNewCatSelCanceler = $q.defer();
      $scope.statusUpdateGetCats = 0;
      $scope.toggleUpdateNewCatSel = function (cat, index) {
        cat = JSON.parse(cat);
        //MyService.ConsoleLog("$scope.selectedCategories: ",$scope.selectedCategories);
        //MyService.ConsoleLog("tempFun index: ", index);
        //remove all elements after given index
        $scope.selCatForNewCatUpdate.length = index + 1;
        toggleUpdateNewCatSelCanceler.resolve();
        toggleUpdateNewCatSelCanceler = $q.defer();
        var params = {
          questions_counter: 0,
          parentId: cat._id,
        };
        $scope.statusUpdateGetCats = 1;
        var request = apiCall.apiCall("GET", "/categories/list", params);
        request.timeout = toggleUpdateNewCatSelCanceler.promise;
        $http(request).then(
          function successCallback(response) {
            if (response.data.success) {
              //MyService.ConsoleLog("Got subcategory data: ", response.data.data);
              if (response.data.data.length > 0)
                $scope.selCatForNewCatUpdate.push({
                  selected: null,
                  viewOrders: 0,
                  items: response.data.data,
                });
              $scope.statusUpdateGetCats = 2;
            } else {
              $scope.statusUpdateGetCats = 3;
              growl.error("Something went wrong.");
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
            $scope.statusUpdateGetCats = 3;
            growl.error("Something went wrong.");
          }
        );
      };

      $scope.updateCategory = function () {
        //MyService.ConsoleLog("** updateCategory **");

        var tempParentIds = [],
          tempViewOrders = [];
        var parent_path_id = 0;
        var parent_path_order = 0;
        angular.forEach($scope.selCatForCatUpdate, function (val, key) {
          //MyService.ConsoleLog("key: ", key, " val: ", val);
          if (val) {
            // val = JSON.parse(val);
            var selectedVal = JSON.parse(val.selected);
            if (selectedVal && selectedVal._id) {
              // tempParentIds.push(selectedVal._id);
              // tempViewOrders[0] = val.viewOrders;
              //MyService.ConsoleLog("** parentIds: ", selectedVal.parentIds);
              parent_path_id = selectedVal.parentIds._id;
              parent_path_order = val.viewOrders;
            }
          }
        });
        //MyService.ConsoleLog("parent_pathid :", parent_path_id);
        //MyService.ConsoleLog("parent_path_order :", parent_path_order);
        //MyService.ConsoleLog("tempParentIds: ",tempParentIds);
        //MyService.ConsoleLog("tempViewOrders: ",tempViewOrders);

        var fd = new FormData();
        fd.append("id", $scope.updateCat.id);
        fd.append("title", $scope.updateCat.title);
        fd.append("description", $scope.updateCat.description);
        fd.append("fbtitle", $scope.updateCat.fbtitle);
        fd.append("fbdescription", $scope.updateCat.fbdescription);

        if (parent_path_id) {
          fd.append("parent_path_id", parent_path_id);
          fd.append("parent_path_order", parent_path_order);
        }

        //MyService.ConsoleLog("category files: ", $scope.updateCat.files);

        angular.forEach($scope.updateCat.files, function (file) {
          //MyService.ConsoleLog("append file", file);
          fd.append("file", file);
        });

        fd.append("file", $scope.updateCat.files);

        fd.append("fbfile", $scope.updateCat.fbimage);

        if (tempParentIds.length > 0) {
          fd.append("parentIds", tempParentIds.join(","));
          fd.append("viewOrders", tempViewOrders.join(","));
        } else {
          fd.append("viewOrder", $scope.updateCat.viewOrder);
        }

        var tempCatTypes = [];

        angular.forEach($scope.updateCatTypes, function (c, i) {
          if (c.selected) {
            tempCatTypes.push(c.val);
          }
        });

        if (tempCatTypes <= 0) {
          growl.error("At least select one category type.");
          return;
        } else {
          fd.append("catType", tempCatTypes.join(","));
        }
        //MyService.ConsoleLog(fd);
        var posturl = baseApiUrl + "/categories/create";
        $http({
          method: "POST",
          url: posturl,
          // headers: { 'Content-Type': false },
          headers: {
            "Content-Type": undefined,
          },
          transformRequest: angular.identity,
          //Create an object that contains the model and files which will be transformed
          // in the above transformRequest method
          data: fd,
        }).then(
          function (data, status, headers, config) {
            //MyService.ConsoleLog("success data: ", data);
            if (data.data.success) {
              growl.success("Updated successfully.");
              $rootScope.getCategories();
              $scope.getParentCategories();
              $scope.initUpdateCat();
            } else if (data.data.error && typeof data.error == "string") {
              growl.error("Error: " + data.error);
            } else {
              growl.error("Something went wrong.");
            }
          },
          function (data, status, headers, config) {
            //MyService.ConsoleLog("error >> ", data);
            growl.error("Something went wrong.");
          }
        );
      };

      $scope.removeCategory = function () {
        //MyService.ConsoleLog("-- removeCategory --");
        if (!$scope.updateCat || !$scope.updateCat.id) {
          growl.error("Select category first.");
          return;
        }

        var old_path_ids = null;
        var category_id = null;

        angular.forEach($scope.selCatForCatUpdate, function (val, key) {
          try {
            var selObj = JSON.parse(val.selected);
            if (selObj._id) {
              category_id = selObj._id;
              // selObj.parentIds = JSON.parse(selObj.parentIds);
              old_path_ids = selObj.parentIds._id;
            }
          } catch (e) {
            //MyService.ConsoleLog("Exception: ", e)
          }
        });

        var postobj = {
          id: category_id,
          old_path_ids: old_path_ids,
        };

        //MyService.ConsoleLog("postobj : ", postobj);
        var request = apiCall.apiCall("POST", "/categories/remove", postobj);
        $http(request).then(
          function successCallback(response) {
            //MyService.ConsoleLog("Got categories: ",response);
            if (response.data.success) {
              growl.success("Removed successfully.");
              $rootScope.getCategories();
              $scope.getParentCategories();
              $scope.initUpdateCat();
            } else if (
              response.data.error &&
              typeof response.data.error == "string"
            ) {
              growl.error("Error: " + response.data.error);
            } else {
              growl.error("Something went wrong.");
            }
          },
          function errorCallBack(response) {
            growl.error("Something went wrong.");
          }
        );
      };

      $scope.updateParentCategory = function () {
        //MyService.ConsoleLog("-- updateParentCategory --");
        //MyService.ConsoleLog("selCatForNewCatUpdate: ", $scope.selCatForNewCatUpdate);
        var tempParentIds = [],
          tempViewOrders = [];
        angular.forEach($scope.selCatForNewCatUpdate, function (val, key) {
          try {
            var selObj = JSON.parse(val.selected);
            if (selObj._id) {
              tempParentIds.push(selObj._id);
              tempViewOrders[0] = val.viewOrders;
            }
          } catch (e) {
            //MyService.ConsoleLog("Exception: ", e)
          }
        });

        var old_path_ids = null;
        angular.forEach($scope.selCatForCatUpdate, function (val, key) {
          try {
            var selObj = JSON.parse(val.selected);
            if (selObj._id) {
              // selObj.parentIds = JSON.parse(selObj.parentIds);
              old_path_ids = selObj.parentIds._id;
            }
          } catch (e) {
            //MyService.ConsoleLog("Exception: ", e)
          }
        });

        //MyService.ConsoleLog("tempParentIds: ",tempParentIds);
        //MyService.ConsoleLog("tempViewOrders: ",tempViewOrders);
        if (!$scope.updateCat || !$scope.updateCat.id) {
          growl.error("Select category first.");
        } else {
          var postobj = {
            parentIds: tempParentIds.join(","),
            viewOrders: tempViewOrders.join(","),
            id: $scope.updateCat.id,
            old_path_ids: old_path_ids,
            viewOrder: $scope.updateCat.viewOrder,
          };
          //MyService.ConsoleLog("postobj: ", postobj);

          /*
        var message = 'Continue?';
        var modal = ngDialog.openConfirm({
            template:'<p>'+message+'</p>\
                    <div class="ngdialog-buttons">\
                        <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                    </div>',
            plain: true
        });
        modal.then(function fullfilled(data){
            //MyService.ConsoleLog("fullfilled: ",data);
        }, function rejected(data){
            //MyService.ConsoleLog("rejected: ",data);
        });
        */

          var request = apiCall.apiCall(
            "POST",
            "/categories/update-parent",
            postobj
          );
          $http(request).then(
            function successCallback(response) {
              if (response.data.success) {
                growl.success("Updated successfully.");
                $rootScope.getCategories();
                $scope.getParentCategories();
                $scope.initUpdateCat();
              } else if (
                response.data.error &&
                typeof response.data.error == "string"
              ) {
                growl.error("Error: " + response.data.error);
              } else {
                growl.error("Something went wrong.");
              }
            },
            function errorCallBack(response) {
              growl.error("Something went wrong.");
            }
          );
        }
      };
      $scope.addCongressBills = function () {
        MyService.ConsoleLog("In addCongressBills");
        $scope.loader = true;
        MyService.addCongressBills().then(
          function (data) {
            MyService.ConsoleLog("Congress bill data : ", data);
            if (data.status == 200) {
              $scope.loader = false;
              alert("Congress Bills added");
            }
          },
          function (err) {
            MyService.ConsoleLog("Congress bill error: ", err);
            $scope.loader = false;
          }
        );
      };
    },
  ])
  .controller("AddNewParentsCtrl", [
    "$scope",
    "$http",
    "$location",
    "apiCall",
    "$rootScope",
    "baseApiUrl",
    "$q",
    "$filter",
    "growl",
    "ngDialog",
    "MyService",
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $rootScope,
      baseApiUrl,
      $q,
      $filter,
      growl,
      ngDialog,
      MyService
    ) {
      //MyService.ConsoleLog("* AddNewParentsCtrl *");

      $scope.allRootCats = [];
      $rootScope.getParentCategories2 = function (idx) {
        //MyService.ConsoleLog("getParentCategories: ", idx);
        var request = apiCall.apiCall("GET", "/categories/list", {
          root: 1,
          questions_counter: 0,
        });
        $http(request).then(
          function successCallback(response) {
            if (response.data.success) {
              $scope.parentCategories = response.data.data;
              $scope.allRootCats[idx] = [
                {
                  selected: null,
                  viewOrders: 0,
                  items: $scope.parentCategories,
                },
              ];
              $scope.selCatForQues = [
                {
                  selected: null,
                  viewOrders: 0,
                  items: $scope.parentCategories,
                },
              ];
              $scope.selCatForCatUpdate = [
                {
                  selected: null,
                  viewOrders: 0,
                  items: $scope.parentCategories,
                },
              ];
              $scope.selCatForNewCatUpdate = [
                {
                  selected: null,
                  viewOrders: 0,
                  items: $scope.parentCategories,
                },
              ];
            } else {
              //MyService.ConsoleLog("Something went wrong: ", response.data);
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
          }
        );
      };
      $rootScope.getParentCategories2(0);

      $scope.addOneMoreParent2 = function () {
        var idx = $scope.allRootCats.length;
        $scope.getParentCategories2(idx);
      };
      $scope.removeParent = function (pindex) {
        // body...
        //MyService.ConsoleLog("removeParent pindex: ", pindex);
        // $scope.allRootCats.length = pindex;
        $scope.allRootCats.splice(pindex, 1);
      };

      var toogleAddCatSelCanceler = $q.defer();
      $scope.toogleAddCatSel = function (cat, index, pindex) {
        cat = JSON.parse(cat);

        //MyService.ConsoleLog("$scope.selectedCategories: ",$scope.selectedCategories);
        //MyService.ConsoleLog("tempFun index: ", index, "pindex: ", pindex);

        //MyService.ConsoleLog("allRootCats: ", $scope.allRootCats);
        $scope.allRootCats[pindex].length = index + 1;

        toogleAddCatSelCanceler.resolve();
        var params = {
          questions_counter: 0,
          parentId: cat._id,
          timeout: toogleAddCatSelCanceler.promise,
        };
        var request = apiCall.apiCall("GET", "/categories/list", params);
        $http(request).then(
          function successCallback(response) {
            if (response.data.success) {
              //MyService.ConsoleLog("Got subcategory data: ", response.data.data);
              if (response.data.data.length > 0) {
                //MyService.ConsoleLog("allRootCats 2: ", $scope.allRootCats);
                //MyService.ConsoleLog("index: ", index, " pindex: ", pindex);
                $scope.allRootCats[pindex].push({
                  selected: null,
                  viewOrders: 0,
                  items: response.data.data,
                });

                //MyService.ConsoleLog("allRootCats 3: ", $scope.allRootCats);
              }
            } else {
              //MyService.ConsoleLog("Something went wrong: ", response.data);
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
          }
        );
      };

      $scope.statusaddParents = 0;
      $scope.addParentCategory = function () {
        if (!$scope.$parent.updateCat.id) {
          growl.error("Select category first.");
          return;
        }

        var tempParentIdsAll = [],
          tempViewOrders = [];
        //MyService.ConsoleLog("allRootCats: ", $scope.allRootCats);
        angular.forEach($scope.allRootCats, function (pcat, i) {
          // body...
          var tempParentIds = [];
          var len = pcat.length;
          var tViewOrder = 0;
          angular.forEach(pcat, function (val, key) {
            //MyService.ConsoleLog("key: ", key, " val: ", val);
            if (val) {
              // val = JSON.parse(val);
              var selectedVal = JSON.parse(val.selected);
              if (selectedVal && selectedVal._id) {
                tempParentIds.push(selectedVal._id);
                tViewOrder = val.viewOrders;
              }
            }
          });
          tempParentIdsAll.push(tempParentIds.join(","));
          tempViewOrders.push(tViewOrder);
        });
        //MyService.ConsoleLog("tempParentIdsAll: ", tempParentIdsAll);
        //MyService.ConsoleLog("tempViewOrders: ", tempViewOrders);
        var postobj = {};

        if ($scope.$parent.updateCat.id) {
          postobj["id"] = $scope.$parent.updateCat.id;
        }
        if (tempParentIdsAll.length > 0) {
          postobj["parentIds"] = tempParentIdsAll.join(";");
          postobj["viewOrders"] = tempViewOrders.join(",");
        }

        //MyService.ConsoleLog("postobj: ", postobj);
        $scope.statusaddParents = 1;
        MyService.addParents(postobj).then(
          function (response) {
            if (response.data.success) {
              $scope.statusaddParents = 2;
              growl.success("Added successfully.");
            } else if (
              response.data.error &&
              typeof response.data.error == "string"
            ) {
              growl.error("Error: " + response.data.error);
              $scope.statusaddParents = 3;
            } else {
              growl.error("Something went wrong.");
              $scope.statusaddParents = 3;
            }
          },
          function (err) {
            growl.error("Something went wrong.");
          }
        );

        // $scope.showProfile = false;
        // $rootScope.showProfile = false;
        // $rootScope.showUpload = false;
        // $rootScope.showAdvocates = false;
        // $rootScope.showFollowing = false;
        // $rootScope.showTopicSpam = false;
        // $rootScope.showAllTopic = false;
        // $rootScope.showAllEssay = false;
        // $rootScope.showPress = false;
      };
    },
  ])
  .controller("EditQuestionCtrl", [
    "$scope",
    "$http",
    "$location",
    "apiCall",
    "$rootScope",
    "baseApiUrl",
    "$q",
    "$filter",
    "growl",
    "ngDialog",
    "MyService",
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $rootScope,
      baseApiUrl,
      $q,
      $filter,
      growl,
      ngDialog,
      MyService
    ) {
      //MyService.ConsoleLog("* EditQuestionCtrl *", $scope.ngDialogData);

      $scope.initQuesVar = function () {
        $scope.question = {
          id: null, //to edit question set this
          content: "",
          categoryIds: [],
          viewOrders: [],
        };
        if ($scope.ngDialogData) {
          try {
            MyService.ConsoleLog(
              "$scope.ngDialogData<><><><>",
              $scope.ngDialogData
            );
            $scope.question.content = $scope.ngDialogData.content;
            $scope.question.showInMatch = $scope.ngDialogData.showInMatch;
            $scope.question.matchOrder = $scope.ngDialogData.matchOrder;
            MyService.ConsoleLog("question<><><><>", $scope.question);
          } catch (e) {
            //MyService.ConsoleLog("EditQuestion Exception: ", e);
          }
          //MyService.ConsoleLog("$scope.question: ", $scope.question);
        }

        $scope.selCatForQues = [
          {
            selected: null,
            viewOrders: 0,
            items: $scope.parentCategories,
          },
        ];
        $scope.questions = [];
      };
      $scope.initQuesVar();

      $scope.matchType = ["YES", "NO"];

      $scope.statusGetCats = 0;
      $rootScope.getParentCategories = function () {
        //MyService.ConsoleLog("getParentCategories");
        $scope.statusGetCats = 1;
        var request = apiCall.apiCall("GET", "/categories/list", {
          root: 1,
          questions_counter: 0,
        });
        $http(request).then(
          function successCallback(response) {
            if (response.data.success) {
              $scope.parentCategories = response.data.data;

              $scope.selCatForQues = [
                {
                  selected: null,
                  viewOrders: 0,
                  items: $scope.parentCategories,
                },
              ];
              $scope.statusGetCats = 2;
            } else {
              growl.error("Something went wrong");
              $scope.statusGetCats = 3;
            }
          },
          function errorCallBack(response) {
            growl.error("Something went wrong");
            $scope.statusGetCats = 3;
          }
        );
      };
      $scope.getParentCategories();

      $scope.questionCatChanged = function (selcat) {
        selcat = JSON.parse(selcat);
        $scope.questionSubcategories = [];
        if (selcat._id) {
          var request = apiCall.apiCall("GET", "/categories/list", {
            parentId: selcat._id,
          });
          $http(request).then(
            function successCallback(response) {
              //MyService.ConsoleLog("Got categories: ",response);
              if (response.data.success) {
                $scope.questionSubcategories = response.data.data;
              } else {
                //MyService.ConsoleLog("Something went wrong: ", response.data);
              }
            },
            function errorCallBack(response) {
              //MyService.ConsoleLog("Error: ", response);
            }
          );
        }
      };

      $scope.queFirstLevelCat = [];
      $scope.queSecondLevelCat = [];

      $scope.addQuestion = function () {
        var tempCatIds = [],
          tempViewOrders = [];
        angular.forEach($scope.selCatForQues, function (val, key) {
          //MyService.ConsoleLog("key: ",key," val: ",val);
          if (val) {
            // val = JSON.parse(val);
            var selectedVal = JSON.parse(val.selected);
            if (selectedVal && selectedVal._id) {
              tempCatIds[0] = selectedVal._id; //last level cat id
              tempViewOrders[0] = val.viewOrders;
            }
          }
        });

        var postobj = {
          content: $scope.question.content,
          showInMatch: $scope.question.showInMatch,
          matchOrder: $scope.question.matchOrder,
        };

        if (tempCatIds.length > 0) {
          postobj.categoryIds = tempCatIds.join(",");
          postobj.viewOrders = tempViewOrders.join(",");
        }
        if ($scope.ngDialogData) postobj.id = $scope.ngDialogData._id;

        MyService.ConsoleLog("postobj: ", postobj);

        MyService.editQuestion(postobj).then(
          function (response) {
            if (response.data.success) {
              growl.success("Added successfully!");
              $scope.closeThisDialog({
                data: $scope.ngDialogData,
              });
            } else if (
              response.data.error &&
              typeof response.data.error == "string"
            ) {
              growl.error("Error: " + response.data.error);
            } else {
              growl.error("Something went wrong.");
            }
          },
          function (err) {
            growl.error("Something went wrong.");
          }
        );

        /*
      var request = apiCall.apiCall('POST', '/questions/create', postobj);
      $http(request)
      .then(function successCallback(response) {
          if (response.data.success) {
              $scope.initVarCat();
              $rootScope.getCategories();
              $scope.getParentCategories();
              growl.success("Added successfully!");
          } else if (response.data.error && typeof response.data.error == "string") {
              growl.error('Error: ' + response.data.error);
          } else {
              growl.error('Something went wrong.');
          }
      }, function errorCallBack(response) {
          growl.error('Something went wrong.');
      });
      */
      };

      var selQuesCategoryCanceler = $q.defer();
      $scope.selQuesCategory = function (cat, index) {
        selQuesCategoryCanceler.resolve();
        cat = JSON.parse(cat);
        //remove all elements after given index
        selQuesCategoryCanceler.resolve();
        selQuesCategoryCanceler = $q.defer();

        $scope.selCatForQues.length = index + 1;
        var params = {
          questions_counter: 0,
          parentId: cat._id,
        };
        var request = apiCall.apiCall("GET", "/categories/list", params);
        request.timeout = selQuesCategoryCanceler.promise;
        $http(request).then(
          function successCallback(response) {
            //MyService.ConsoleLog("************ in success callback ***************");
            if (response.data.success) {
              //MyService.ConsoleLog("Got subcategory data: ", response.data.data);
              if (response.data.data.length > 0)
                $scope.selCatForQues.push({
                  selected: null,
                  viewOrders: 0,
                  items: response.data.data,
                });
            } else {
              //MyService.ConsoleLog("Something went wrong: ", response.data);
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
          }
        );
      };
    },
  ])

  /*.controller('AdminVerifyQuestions', ['$scope', '$http', '$location', 'apiCall', '$rootScope', 'baseApiUrl', '$q', '$filter', 'growl', 'ngDialog', 'MyService', function($scope, $http, $location, apiCall, $rootScope, baseApiUrl, $q, $filter, growl, ngDialog, MyService) {
      //MyService.ConsoleLog("* AdminVerifyQuestions *");

      $scope.verifySelectedUser = null;
      $scope.verifyFilter = null;
      $scope.statusVerifyQues = 0; //1=loading, 2 = loaded, 3 = error while loading
      $scope.max_records = 30;

      var getVerifyUsersCanceler = $q.defer();
      var prevSelFilter = null;
      $scope.page = 0;
      $scope.verifyQuestions = [];

      $scope.getVerifyQues = function() {
          //MyService.ConsoleLog("prevSelFilter = ", prevSelFilter);
          //MyService.ConsoleLog("verifyFilter = ", $scope.verifyFilter);
          if (prevSelFilter != $scope.verifyFilter) {
              prevSelFilter = $scope.verifyFilter;
              $scope.page = 0;
              $scope.verifyQuestions = [];
          }
          $scope.page += 1;
          prevSelFilter = $scope.verifyFilter;

          //MyService.ConsoleLog("getVerifyUsers: ", $scope.verifySelectedUser, " filter: ", $scope.verifyFilter);

          getVerifyUsersCanceler.resolve();
          var params = {
              approved: $scope.verifyFilter,
              page: $scope.page,
              max_records: $scope.max_records,
          };
          //MyService.ConsoleLog("params: ", params);
          $scope.statusVerifyQues = 1;

          MyService.getQuestions(params, getVerifyUsersCanceler.promise).then(function (response) {
              if (response.data.success) {
                  //MyService.ConsoleLog("Got subcategory data: ", response.data.data);
                  $scope.verifyQuestions = $scope.verifyQuestions.concat(response.data.data);
                  $scope.statusVerifyQues = 2;
              } else if (response.data.error && typeof response.data.error == "string") {
                  growl.error('Error: ' + response.data.error);
                  $scope.statusVerifyQues = 3;
              } else {
                  growl.error('Something went wrong.');
                  $scope.statusVerifyQues = 3;
              }
          }, function (err) {
              //MyService.ConsoleLog("Get question error: ", err);
              $scope.statusVerifyQues = 3;
          });
          var request = apiCall.apiCall('GET', '/questions/list', params);
          $http(
              request
          ).then(function successCallback(response) {
              if (response.data.success) {
                  //MyService.ConsoleLog("Got subcategory data: ", response.data.data);
                  $scope.verifyQuestions = $scope.verifyQuestions.concat(response.data.data);
                  $scope.statusVerifyQues = 2;
              } else if (response.data.error && typeof response.data.error == "string") {
                  growl.error('Error: ' + response.data.error);
                  $scope.statusVerifyQues = 3;
              } else {
                  growl.error('Something went wrong.');
                  $scope.statusVerifyQues = 3;
              }
          }, function errorCallBack(response) {
              //MyService.ConsoleLog("Error: ", response);
              $scope.statusVerifyQues = 3;
          });
      };

      $scope.verifyThisQues = function(user, index, val) {

          var postobj = {
              id: user._id,
              approve: val
          };

          //MyService.ConsoleLog("postobj : ", postobj);

          var request = apiCall.apiCall('POST', "/questions/approve", postobj);
          $http(
              request
          ).then(function successCallback(response) {
              //MyService.ConsoleLog("Got categories: ", response);
              if (response.data.success) {
                  $scope.verifyQuestions[index].approved = val;
              } else if (response.data.error && typeof response.data.error == "string") {
                  growl.error('Error: ' + response.data.error);
              } else {
                  growl.error('Something went wrong.');
              }
          }, function errorCallBack(response) {
              growl.error('Something went wrong.');
          });

      }

      $scope.getCategoriesOfQues = function(q, index) {
          //MyService.ConsoleLog("getCategoriesOfQues: ",q, index);
          var tempCatIds = [];
          angular.forEach(q.categories, function(val, key) {
              tempCatIds.push(val.cid);
          });
          //MyService.ConsoleLog("tempCatIds: ", tempCatIds);
          var param = {
              ids: tempCatIds.join(",")
          }

          $scope.verifyQuestions[index].fullCategoriesData = {
              status: 1
          };
          MyService.getMultiCategoryByIds(param).then(function(response) {
              if (response.data.success) {
                  $scope.verifyQuestions[index].fullCategoriesData.list = response.data.data;
                  $scope.verifyQuestions[index].fullCategoriesData.status = 2;
              } else if (response.data.error && typeof response.data.error == "string") {
                  growl.error('Error: ' + response.data.error);
                  $scope.verifyQuestions[index].fullCategoriesData.status = 3;
              } else {
                  growl.error('Something went wrong.');
                  $scope.verifyQuestions[index].fullCategoriesData.status = 3;
              }
          }, function(err) {
              $scope.verifyQuestions[index].fullCategoriesData.status = 3;
          });
      };
  }])*/

  .controller("setPreference", [
    "$scope",
    "$http",
    "$location",
    "apiCall",
    "$routeParams",
    "$rootScope",
    "$q",
    "$timeout",
    "growl",
    "tokenService",
    "ngDialog",
    "baseApiUrl",
    "$anchorScroll",
    "MyService",
    "$window",
    "$sce",
    "uiGridConstants",
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $rootScope,
      $q,
      $timeout,
      growl,
      tokenService,
      ngDialog,
      baseApiUrl,
      $anchorScroll,
      MyService,
      $window,
      $sce,
      uiGridConstants
    ) {
      $scope.userSelectedCols = [];
      $scope.userSelectedColsNew = [];
      $scope.chkcol = [];
      $scope.list = {
        name: "",
        rename: "",
        selectedName: "",
      };

      $scope.tabs = [
        {
          title: "All Templates",
          url: "one.tpl.html",
        },
        {
          title: "New Template",
          url: "two.tpl.html",
        },
        {
          title: "Update Template",
          url: "three.tpl.html",
        },
      ];

      $scope.currentTab = "one.tpl.html";

      $scope.onClickTab = function (tab) {
        $scope.currentTab = tab.url;
        if (tab.url == "three.tpl.html") {
          $scope.list.selectedName = null;
        }
      };

      $scope.isActiveTab = function (tabUrl) {
        return tabUrl == $scope.currentTab;
      };

      if (tokenService.getUserData()) {
        $scope.userData = JSON.parse(tokenService.getUserData());
        if ($scope.userData.selectedColumns) {
          $scope.userSelectedCols = $scope.userData.selectedColumns;
        }
      }

      $scope.columns = [
        "name",
        "email",
        "privateEmail",
        "office",
        "officePlace",
        "party",
        "electionDate",
        "voterScope",
        "publicMailingAddress",
        "privateMailingAddress",
        "website",
        "rapidTransitDistrict",
        "statement",
        "numberOfOpenings",
        "incumbent",
        "publicZipCode",
        "privateZipCode",
        "publicPhoneNumber",
        "privatePhoneNumber",
        "stateBoardEducationDistrict",
        "judicialCircuitNumber",
        "stateFips",
        "statePostalCode",
        "countyFips",
        "countyName",
        "countySubdivisionFips",
        "countySubdivisionName",
        "placeFips",
        "placeName",
        "voterDistrict",
        "votingDistrictName",
        "federalCongressionalDistrict",
        "stateSenateDistrict",
        "stateHouseofRepresentativesDistrict",
        "unifiedSchoolDistrict",
        "unifiedSchoolDistrictName",
        "elementarySchoolDistrict",
        "elementarySchoolDistrictName",
        "secondarySchoolDistrict",
        "secondarySchoolDistrictName",
        "totalPop",
        "afact",
        "dataX",
        "dataY",
        "dataZ",
        "runningForOffice",
        "facebookPage",
        "twitterFeed",
        "website2",
        "typeOfElection",
        "dataOrigin",
      ];

      $scope.setColumns = function (col) {
        var idx = $scope.userSelectedColsNew.indexOf(col);
        //MyService.ConsoleLog(idx);
        if (idx === -1) {
          $scope.userSelectedColsNew.push(col);
        } else {
          $scope.userSelectedColsNew.splice(idx, 1);
        }
      };

      $scope.removeSelected = function (col) {
        var idx = $scope.userSelectedColsNew.indexOf(col);
        $scope.userSelectedColsNew.splice(idx, 1);
        var vdx = $scope.columns.indexOf(col);
        $scope.chkcol[vdx] = false;
      };

      $scope.savePreferences = function () {
        //MyService.ConsoleLog($scope.userSelectedColsNew);
        var error = false;
        var errmsg = "";
        var sfoc = "";
        if ($scope.userSelectedColsNew.length == 0) {
          errmsg = "Please select atleast one column";
          error = true;
        }

        if ($scope.list.name == "") {
          errmsg = "Please enter list name";
          sfoc = "name";
          error = true;
        }

        if (error == false) {
          MyService.savePreferences({
            selectedColumns: JSON.stringify($scope.userSelectedColsNew),
            name: $scope.list.name,
          }).then(
            function (payload) {
              //MyService.ConsoleLog(payload);
              if ($scope.userData) {
                // $scope.userSelectedColsNew = payload.selectedColumns;
                $scope.userData.selectedColumns = payload.selectedColumns;
                tokenService.saveUserData(JSON.stringify($scope.userData));
              }
              alert("Preferences saved successfully.");
            },
            function (errorPayload) {
              //MyService.ConsoleLog(errorPayload);
              alert(
                "Error occured while saving Preferences, please try after sometime."
              );
            }
          );
        } else {
          if (sfoc == "name") {
            var element = $window.document.getElementById("name");
            if (element) element.focus();
          }
          alert(errmsg);
        }
      };

      $scope.removeTemplate = function (list, idx) {
        var message =
          "This action will remove the selected template. Do you want to continue?";
        var modal = ngDialog.openConfirm({
          template:
            "<p>" +
            message +
            '</p>\
            <div class="ngdialog-buttons">\
                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">YES</button>\
                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">NO</button>\
            </div>',
          plain: true,
        });
        modal.then(
          function fullfilled(data) {
            //MyService.ConsoleLog("fullfilled: ", mydata);
            $scope.userSelectedCols.splice(idx, 1);
            // alert(JSON.stringify(list));
            // alert(idx);
            MyService.removePreferences({
              selectedColumns: JSON.stringify($scope.userSelectedCols),
            }).then(
              function (payload) {
                if ($scope.userData) {
                  $scope.userData.selectedColumns = $scope.userSelectedCols;
                  tokenService.saveUserData(JSON.stringify($scope.userData));
                }
                alert("Preferences removed successfully.");
                //tokenService.saveUserData(JSON.stringify($scope.userData));
              },
              function (errorPayload) {
                alert(
                  "Error occured while removing Preferences, please try after sometime."
                );
              }
            );
          },
          function rejected(data) {
            //MyService.ConsoleLog("rejected: ", data);
          }
        );
      };
      $scope.updateSelectedCols = [];
      $scope.chkucol = [];
      $scope.oldList = "";
      $scope.selectedCols = function () {
        var list = JSON.parse(angular.toJson($scope.list.selectedName));
        $scope.oldList = angular.copy(list);
        //MyService.ConsoleLog(list);
        if (list && list.cols) {
          $scope.updateSelectedCols = angular.copy(list.cols);
          $scope.list.rename = angular.copy(list.name);
        }
      };

      $scope.setupdatedColumns = function (col) {
        var idx = $scope.updateSelectedCols.indexOf(col);
        //MyService.ConsoleLog(idx);
        if (idx === -1) {
          $scope.updateSelectedCols.push(col);
        } else {
          $scope.updateSelectedCols.splice(idx, 1);
        }
      };
      $scope.FinalIdx = "";
      $scope.checkifItemExists = function (rdata, val) {
        return rdata.filter(function (rdata, idx) {
          //MyService.ConsoleLog(rdata.statePostalCode + "==" + val);
          if (rdata.name == val) {
            $scope.FinalIdx = idx;
            return idx;
          }
        });
      };

      $scope.removeupdatedSelected = function (col) {
        var idx = $scope.updateSelectedCols.indexOf(col);
        $scope.updateSelectedCols.splice(idx, 1);
        var vdx = $scope.columns.indexOf(col);
        $scope.chkucol[vdx] = false;
      };

      $scope.updateRecords = function () {
        var error = false;
        var errmsg = "";
        var sfoc = "";

        if ($scope.updateSelectedCols.length == 0) {
          errmsg = "Please select atleast one column";
          error = true;
        }

        if ($scope.list.rename == "") {
          errmsg = "Please enter list name";
          sfoc = "rename";
          error = true;
        }

        if (
          $scope.list.selectedName == "" ||
          $scope.list.selectedName == null
        ) {
          //MyService.ConsoleLog($scope.list.selectedName);
          sfoc = "list";
          errmsg = "Please select the list first";
          error = true;
        }

        if (error == false) {
          var list = $scope.checkifItemExists(
            $scope.userSelectedCols,
            $scope.list.selectedName.name
          );
          $scope.userSelectedCols.splice($scope.FinalIdx, 1, {
            name: $scope.list.rename,
            cols: $scope.updateSelectedCols,
          });
          var newlist = JSON.parse(angular.toJson($scope.userSelectedCols));
          //MyService.ConsoleLog(newlist);
          // alert(JSON.stringify(list));
          // alert(idx);

          MyService.removePreferences({
            selectedColumns: JSON.stringify(newlist),
          }).then(
            function (payload) {
              if ($scope.userData) {
                $scope.userData.selectedColumns = $scope.userSelectedCols;
                tokenService.saveUserData(JSON.stringify($scope.userData));
              }
              alert("Preferences updated successfully.");
              //tokenService.saveUserData(JSON.stringify($scope.userData));
            },
            function (errorPayload) {
              alert(
                "Error occured while updating Preferences, please try after sometime."
              );
            }
          );
        } else {
          //MyService.ConsoleLog($scope.list.selectedName);
          if (sfoc == "rename") {
            var element = $window.document.getElementById("rename");
            if (element) element.focus();
          }
          alert(errmsg);
        }
      };
    },
  ])

  .controller("UpdatePoliticianOfficeCtrl_Old", [
    "$scope",
    "$http",
    "$location",
    "apiCall",
    "$rootScope",
    "baseApiUrl",
    "$q",
    "$filter",
    "growl",
    "ngDialog",
    "tokenService",
    "MyService",
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $rootScope,
      baseApiUrl,
      $q,
      $filter,
      growl,
      ngDialog,
      tokenService,
      MyService
    ) {
      $scope.User = {};

      //MyService.ConsoleLog("UpdatePoliticianOfficeCtrl: ", $scope.ngDialogData);

      $scope.political_office_options = {
        suggest: function (term) {
          // return $rootScope.suggest_organization(term, $scope.UserType)
          return $rootScope.suggestPoliticianOffice(term, $rootScope.userRole);
        },
        on_select: function (selected) {
          //MyService.ConsoleLog("selected: ", selected);
          // $scope.User.organization_name = selected.label;
          $scope.User.office = selected;
        },
        on_detach: function (current_value) {
          //MyService.ConsoleLog("on_detach: ", current_value);
          /*try{
            if($scope.User.organization.label != current_value)
            $scope.User.organization = null;
        }
        catch(e){
            $scope.User.organization = null;
        }*/
          $scope.User.office_name = current_value;
        },
      };

      $scope.org_jurisdiction_options = {
        suggest: function (term) {
          // return $rootScope.suggest_organization(term, $scope.UserType)
          return $rootScope.suggestJurisdiction(term);
        },
        on_select: function (selected) {
          //MyService.ConsoleLog("selected: ", selected);
          $scope.User.jurisdiction = selected;
        },
        on_detach: function (current_value) {
          //MyService.ConsoleLog("on_detach: ", current_value);
          /*try{
            if($scope.User.organization.label != current_value)
            $scope.User.organization = null;
        }
        catch(e){
            $scope.User.organization = null;
        }*/
          $scope.User.jurisdiction_name = current_value;
        },
      };

      $scope.statusGetStates = 0; //1: loading, 2: loaded, 3: failed
      var getAllStatesCanceler = $q.defer();
      $scope.getAllStates = function () {
        //MyService.ConsoleLog("** getAllStates **");
        if ($scope.counties) $scope.counties.length = 0;
        if ($scope.places) $scope.places.length = 0;
        var params = {
          country: "",
          timeout: getAllStatesCanceler.promise,
        };
        $scope.statusGetStates = 1;
        MyService.getAllStates(params).then(
          function (data) {
            //MyService.ConsoleLog("got states");
            $scope.statusGetStates = 2;
            $scope.states = data;
            if (!$scope.User.state && $scope.ngDialogData.state) {
              var len = $scope.states.length;
              for (var i = 0; i < len; i++) {
                if (
                  $scope.ngDialogData.state.toLowerCase() ==
                  $scope.states[i].state.toLowerCase()
                ) {
                  $scope.User.state = JSON.stringify($scope.states[i]);
                  //MyService.ConsoleLog("Set current state: ", $scope.User.state);
                  $scope.getCounties();
                  break;
                }
              }
            }
          },
          function (err) {
            $scope.statusGetStates = 3;
            //MyService.ConsoleLog("got states error");
            // growl.error("Some");
          }
        );
      };
      $scope.getAllStates();

      $scope.statusGetCounties = 0; //1: loading, 2: loaded, 3: failed
      var getCountiesCanceler = $q.defer();
      $scope.getCounties = function () {
        //MyService.ConsoleLog("** getCounties **");
        var state = JSON.parse($scope.User.state);

        getCountiesCanceler.resolve();
        if ($scope.places) $scope.places.length = 0;
        $scope.User.place = null;
        $scope.User.county = null;

        var param = {
          statePostalCode: state.statePostalCode,
          timeout: getCountiesCanceler.promise,
        };
        //MyService.ConsoleLog("param : ", param);
        $scope.statusGetCounties = 1;
        MyService.getAllCounties(null, param).then(
          function (data) {
            //MyService.ConsoleLog("got counties data");
            $scope.statusGetCounties = 2;
            $scope.counties = data;
            if (!$scope.User.county && $scope.ngDialogData.county) {
              var len = $scope.counties.length;
              //MyService.ConsoleLog("county data: ", $scope.counties);
              //MyService.ConsoleLog("length: ", len);
              for (var i = 0; i < len; i++) {
                //MyService.ConsoleLog("i ", i);
                //MyService.ConsoleLog("i data: ", $scope.counties[i]);
                if (
                  $scope.ngDialogData.county.toLowerCase() ==
                  $scope.counties[i]._id.county.toLowerCase()
                ) {
                  $scope.User.county = JSON.stringify($scope.counties[i]._id);
                  //MyService.ConsoleLog("Set current county: ", $scope.User.county);
                  $scope.getLocals();
                  break;
                }
              }
            }
          },
          function (err) {
            //MyService.ConsoleLog("got counties error");
            // growl.error("Some");
            $scope.statusGetCounties = 3;
          }
        );
      };

      $scope.statusGetLocals = 0; //1: loading, 2: loaded, 3: failed
      var getLocalsCanceler = $q.defer();
      $scope.getLocals = function () {
        //MyService.ConsoleLog("** getLocals **");
        var state = null,
          county = null;

        state = JSON.parse($scope.User.state);
        county = JSON.parse($scope.User.county);

        $scope.User.place = null;

        //MyService.ConsoleLog("county : ", county);
        getLocalsCanceler.resolve();
        var param = {
          statePostalCode: state.statePostalCode,
          county: county.county,
          timeout: getLocalsCanceler.promise,
        };
        $scope.statusGetLocals = 1;
        MyService.getAllSubCountiesLocal(null, null, param).then(
          function (data) {
            $scope.statusGetLocals = 2;
            $scope.places = data;
            if (!$scope.User.place && $scope.ngDialogData.place) {
              var len = $scope.places.length;
              for (var i = 0; i < len; i++) {
                if (
                  $scope.ngDialogData.place.toLowerCase() ==
                  $scope.places[i]._id.place.toLowerCase()
                ) {
                  $scope.User.place = JSON.stringify($scope.places[i]._id);
                  //MyService.ConsoleLog("Set current place: ", $scope.User.place);
                  break;
                }
              }
            }
          },
          function (err) {
            $scope.statusGetLocals = 3;
            //MyService.ConsoleLog("Get places error: ", err);
          }
        );
      };

      $scope.UpdateOffice = function () {
        try {
          var userData = JSON.parse(tokenService.getUserData());
          //MyService.ConsoleLog("userData: ", userData);
          var postobj = {
            userid: userData.id,
            info_id: $scope.ngDialogData._id,
            office_name: $scope.User.office_name,
            jurisdiction_name: $scope.User.jurisdiction_name,
          };

          if ($scope.User.state) {
            var state = JSON.parse($scope.User.state);
            postobj.state = state.state;
          }
          if ($scope.User.county) {
            var obj = JSON.parse($scope.User.county);
            postobj.county = obj.county;
          }
          if ($scope.User.place) {
            var obj = JSON.parse($scope.User.place);
            postobj.place = obj.place;
            postobj.county_subdivision = obj.countySubdivision;
          }

          if ($scope.User.isCurrentOffice == 1) {
            postobj.from_date = new Date($scope.User.from_date).toISOString();
            postobj.end_date = new Date($scope.User.end_date).toISOString();
          }

          //MyService.ConsoleLog("postobj: ", postobj);

          MyService.managePoliticianOffice(postobj).then(
            function (response) {
              //MyService.ConsoleLog("response: ", response);
              if (response.data.success) {
                growl.success("Updated successfully.");
                $rootScope.$broadcast("UserProfileUpdated", response.data.data);
                $scope.closeThisDialog();
              } else if (
                response.data.error &&
                typeof response.data.error == "string"
              ) {
                growl.error("Error: " + response.data.error);
              } else {
                growl.error("Something went wrong.");
              }
            },
            function (err) {
              growl.error("Something went wrong.");
            }
          );
        } catch (e) {
          //MyService.ConsoleLog("Exception: ", e);
        }
      };

      $scope.removeOffice = function () {
        try {
          var userData = JSON.parse(tokenService.getUserData());
          //MyService.ConsoleLog("userData: ", userData);
          var postobj = {
            userid: userData._id,
            info_id: $scope.ngDialogData._id,
          };

          /*MyService.managePoliticianOffice().then(function(response){
            if (response.success) {
                growl.success('Updated successfully.');
            } else if (response.error && typeof response.error == "string") {
                growl.error('Error: ' + data.error);
            } else {
                growl.error('Something went wrong.');
            }
        }, function(err){
            growl.error("Something went wrong.");
        });*/
        } catch (e) {
          //MyService.ConsoleLog("Exception: ", e);
        }
      };

      if ($scope.ngDialogData) {
        var obj = $scope.ngDialogData;
        $scope.User.office_name = obj.office_name;
        $scope.User.jurisdiction_name = obj.jurisdiction_name;
        if (obj.from_date) $scope.User.from_date = new Date(obj.from_date);
        if (obj.end_date) {
          $scope.User.end_date = new Date(obj.end_date);
          $scope.User.isCurrentOffice = 1;
        }
      }
    },
  ])
  .controller("UpdatePoliticianOfficeCtrl", [
    "$scope",
    "$http",
    "$location",
    "apiCall",
    "$rootScope",
    "baseApiUrl",
    "$q",
    "$filter",
    "growl",
    "ngDialog",
    "tokenService",
    "MyService",
    "$timeout",
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $rootScope,
      baseApiUrl,
      $q,
      $filter,
      growl,
      ngDialog,
      tokenService,
      MyService,
      $timeout
    ) {
      $scope.User = {};

      //MyService.ConsoleLog("UpdatePoliticianOfficeCtrl: ", $scope.ngDialogData);
      $scope.ShowAdd = true;

      $scope.statusGetStates = 0; //1: loading, 2: loaded, 3: failed
      var getAllStatesCanceler = $q.defer();
      $scope.getAllStates = function () {
        //MyService.ConsoleLog("** getAllStates **");
        if ($scope.counties) $scope.counties.length = 0;
        if ($scope.places) $scope.places.length = 0;
        var params = {
          country: "",
          // timeout: getAllStatesCanceler.promise
        };
        $scope.statusGetStates = 1;
        MyService.getAllStates(params).then(
          function (data) {
            //MyService.ConsoleLog("got states");
            $scope.statusGetStates = 2;
            $scope.states = angular.copy(data);
            if (
              !$scope.User.state &&
              $scope.ngDialogData &&
              $scope.ngDialogData.state
            ) {
              var len = $scope.states.length;
              for (var i = 0; i < len; i++) {
                if (
                  $scope.ngDialogData.state.toLowerCase() ==
                  $scope.states[i].state.toLowerCase()
                ) {
                  $scope.User.state = $scope.states[i];
                  //MyService.ConsoleLog("Set current state: ", $scope.User.state);
                  // $scope.getCounties();
                  break;
                }
              }
            }
          },
          function (err) {
            $scope.statusGetStates = 3;
            //MyService.ConsoleLog("got states error");
            // growl.error("Some");
          }
        );
      };
      $scope.getAllStates();

      $scope.RegisterButton = false;
      $scope.records = [];
      $scope.States = [];
      $scope.Cities = [];
      // $scope.UserType = $routeParams.type;

      $scope.Address = {
        ZipCode: "",
        Country: "",
        State: "",
        City: "",
      };

      $scope.User = {
        name: "",
        lastname: "",
        UserName: "",
        Password: "",
        Email: "",
        ZipCode: "",
      };

      $scope.Errors = [];

      $scope.levelOfGovt = ["Federal", "State", "Local"];
      $scope.fedlevelOfGovt = [
        "President",
        "Senate",
        "House of representatives",
      ];
      $scope.statelevelOfGovt = [
        "State House of Representatives",
        "State Senate",
        "State School Board",
        "State Other",
      ];
      $scope.locallevelOfGovt = [
        "County level job",
        "Judicial position",
        "Elementary school District Position",
        "Secondary School District Positio",
        "Unified School District Position",
        "City or Township position",
      ];

      //$scope.levelOfGovt = ['national', 'state', 'judicial district', 'county', 'sub county', 'city', 'state school board district', 'local school district', 'other'];

      $scope.offices = [];
      $scope.running_offices = [];

      $scope.govLevelChanged = function (electionFor) {
        $scope.running_flagShowStateDropdown = false;
        $scope.running_flagShowOfficeDropdown = false;
        $scope.flagShowStateDropdown = false;
        $scope.flagShowOfficeDropdown = false;
        //MyService.ConsoleLog("* govLevelChanged *");
        if (electionFor == "running") {
          $scope.User.office_name = null;
          $scope.running_flagShowStateDropdown = true;
          if ($scope.ngDialogData) {
            $scope.editflagShowOfficeDropdown = true;
          }

          //$scope.onStateChange('running');
        } else {
          $scope.User.cur_office_name = null;
          $scope.flagShowStateDropdown = true;
          //$scope.onStateChange('incumbent');
        }
      };

      $scope.localSchoolDistException = function (electionFor) {
        var exceptionState = ["AK", "DC", "VA"];
        if ((electionFor = "running")) {
          if (
            $scope.User.state &&
            exceptionState.indexOf($scope.User.state.statePostalCode) == -1
          ) {
            return true;
          } else return false;
        } else if (electionFor == "incumbent") {
          if (
            $scope.User.cur_state &&
            exceptionState.indexOf($scope.User.cur_state.statePostalCode) == -1
          ) {
            return true;
          } else return false;
        }
      };
      //$scope.SearchByZipcode = function () {
      //    $http.get(baseApiUrl + 'votewise/search/' + $scope.Address.ZipCode)
      //        .then(function (response) {
      //            $scope.States = [];
      //            $scope.Cities = [];
      //            //MyService.ConsoleLog(response.data)
      //            angular.forEach(response.data, function (item) {
      //                $scope.States.push({ Name: item.stab });
      //                $scope.Cities.push({ Name: item.placenm });
      //            });
      //            $scope.Address.Country = "USA";
      //            $scope.Address.City = $scope.Cities[0].Name;
      //            $scope.Address.State = $scope.States[0].Name;
      //        });
      //};

      $scope.showOfficeAutoComplete = function (electionFor) {
        //MyService.ConsoleLog("showOfficeAutoComplete");
        // ['national', 'state', 'judicial district', 'county', 'sub county', 'city', 'state school board district', 'local', 'school district', 'other']
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "national":
              $scope.running_offices = [
                "president",
                "senate",
                "house of representatives",
                "other",
              ];
              return true;
              break;
            case "state":
              if ($scope.User.state) {
                //fetch office names for this
                //For the options, do a search through the table currently labelled “2016 Alabama” and Find all Item A’s where the Item D is State Postal Code, and item Q is the state selected.  Then add “other” to the end of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "judicial district":
              if ($scope.User.state && $scope.User.district) {
                //fetch office names for this
                //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item F is the district selected. Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "county":
              if ($scope.User.state && $scope.User.county) {
                //fetch office names for this
                //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected.  Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "sub county":
              if (
                $scope.User.state &&
                $scope.User.county &&
                $scope.User.subcounty
              ) {
                //fetch office names for this
                // For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item U is the subcounty selected. Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "city":
              if (
                $scope.User.state &&
                $scope.User.county &&
                $scope.User.locality
              ) {
                //fetch office names for this
                // For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected and U or W match the “city” selection.  Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "state school board district":
              if ($scope.User.state && $scope.User.state_school_dist) {
                //fetch office names for this
                // do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item E is the “District” selection.  Then add “other” to the bottom of the list.
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "local school district":
              if (
                $scope.User.state &&
                $scope.localSchoolDistException() &&
                $scope.User.county &&
                $scope.User.district
              ) {
                //for office names
                // search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the “County” selection and either AD’s, AF’s or  AH’s match the District Name selected.  Then add “other” to the bottom of the list.
                // $scope.offices=['other'];
                return true;
              } else if ($scope.User.state && $scope.User.district) {
                //for options
                //do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item AD’s match the District Name selected.  Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
          }
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "national":
              $scope.offices = [
                "president",
                "senate",
                "house of representatives",
                "other",
              ];
              return true;
              break;
            case "state":
              if ($scope.User.cur_state) {
                //fetch office names for this
                //For the options, do a search through the table currently labelled “2016 Alabama” and Find all Item A’s where the Item D is State Postal Code, and item Q is the state selected.  Then add “other” to the end of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "judicial district":
              if ($scope.User.cur_state && $scope.User.cur_district) {
                //fetch office names for this
                //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item F is the district selected. Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "county":
              if ($scope.User.cur_state && $scope.User.cur_county) {
                //fetch office names for this
                //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected.  Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "sub county":
              if (
                $scope.User.cur_state &&
                $scope.User.cur_county &&
                $scope.User.cur_subcounty
              ) {
                //fetch office names for this
                // For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item U is the subcounty selected. Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "city":
              if (
                $scope.User.cur_state &&
                $scope.User.cur_county &&
                $scope.User.cur_locality
              ) {
                //fetch office names for this
                // For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected and U or W match the “city” selection.  Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "state school board district":
              if ($scope.User.cur_state && $scope.User.cur_state_school_dist) {
                //fetch office names for this
                // do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item E is the “District” selection.  Then add “other” to the bottom of the list.
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "local school district":
              if (
                $scope.User.cur_state &&
                $scope.localSchoolDistException() &&
                $scope.User.cur_county &&
                $scope.User.cur_district
              ) {
                //for office names
                // search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the “County” selection and either AD’s, AF’s or  AH’s match the District Name selected.  Then add “other” to the bottom of the list.
                // $scope.offices=['other'];
                return true;
              } else if ($scope.User.cur_state && $scope.User.cur_district) {
                //for options
                //do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item AD’s match the District Name selected.  Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
          }
          return false;
        }
      };
      var running_flagShowStateDropdown = false;
      var flagShowStateDropdown = false;
      $scope.showSateDropdown = function (electionFor) {
        //MyService.ConsoleLog("showSateDropdown");
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "state":
            case "judicial district":
            case "county":
            case "sub county":
            case "city":
            case "state school board district":
            case "local school district":
              running_flagShowStateDropdown = true;
              return true;
              break;
          }

          switch ($scope.User.office_name) {
            case "senate":
            case "house of representatives":
              running_flagShowStateDropdown = true;
              return true;
              break;
          }

          running_flagShowStateDropdown = false;
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "state":
            case "judicial district":
            case "county":
            case "sub county":
            case "city":
            case "state school board district":
            case "local school district":
              flagShowStateDropdown = true;
              return true;
              break;
          }

          switch ($scope.User.cur_office_name) {
            case "senate":
            case "house of representatives":
              flagShowStateDropdown = true;
              return true;
              break;
          }

          flagShowStateDropdown = false;
          return false;
        }
      };

      $scope.flagShowCandidateDropdown = false;
      $scope.running_flagShowCandidateDropdown = false;

      $scope.onOfficeChange = function (electionFor) {
        if (electionFor == "running") {
          //'Federal', 'State', 'Local'
          var nObj = new Object();
          nObj.level = $scope.User.level;
          nObj.office = $scope.User.off_name;
          nObj.state = JSON.stringify($scope.User.state);
        } else if (electionFor == "incumbent") {
          var nObj = new Object();
          nObj.level = $scope.User.cur_level;
          nObj.office = $scope.User.cur_off_name;
          nObj.state = JSON.stringify($scope.User.cur_state);
        }
        //MyService.ConsoleLog(nObj);
      };
      var running_flagCongressional = false;
      var flagCongressional = false;
      $scope.showCongressionalDropdown = function (electionFor) {
        //MyService.ConsoleLog("showCongressionalDropdown");
        if (electionFor == "running") {
          if (
            $scope.User.office_name == "house of representatives" &&
            $scope.User.state
          ) {
            running_flagCongressional = true;
            return true;
          }
          running_flagCongressional = false;
          return false;
        } else if (electionFor == "incumbent") {
          if (
            $scope.User.cur_office_name == "house of representatives" &&
            $scope.User.cur_state
          ) {
            flagCongressional = true;
            return true;
          }
          flagCongressional = false;
          return false;
        }
      };
      var running_flagDist = false;
      var flagDist = false;
      $scope.showDistrictDropdown = function (electionFor) {
        //MyService.ConsoleLog("showDistrictDropdown");
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "judicial district":
              if ($scope.User.state) {
                running_flagDist = true;
                return true;
              }
              // For the District options, do a search through the table currently labelled “2016 Alabama” and Find all Item F’s with item Q as the state selected.
              break;
          }
          running_flagDist = false;
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "judicial district":
              if ($scope.User.cur_state) {
                flagDist = true;
                return true;
              }
              // For the District options, do a search through the table currently labelled “2016 Alabama” and Find all Item F’s with item Q as the state selected.
              break;
          }
          flagDist = false;
          return false;
        }
      };
      var running_flagConty = false;
      var flagConty = false;
      $scope.showCountyDropdown = function (electionFor) {
        //MyService.ConsoleLog("showCountyDropdown");
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "county":
            case "sub county":
            case "city":
              if ($scope.User.state) {
                running_flagConty = true;
                return true;
              }
              break;
            case "local school district":
              var exceptionState = ["AK", "DC", "VA"];
              if (
                $scope.User.state &&
                exceptionState.indexOf($scope.User.state.statePostalCode) == -1
              ) {
                running_flagConty = true;
                return true;
              }
              break;
          }
          running_flagConty = false;
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "county":
            case "sub county":
            case "city":
              if ($scope.User.cur_state) {
                flagConty = true;
                return true;
              }
              break;
            case "local school district":
              var exceptionState = ["AK", "DC", "VA"];
              if (
                $scope.User.cur_state &&
                exceptionState.indexOf($scope.User.cur_state.statePostalCode) ==
                  -1
              ) {
                flagConty = true;
                return true;
              }
              break;
          }
          flagConty = false;
          return false;
        }
      };
      var running_flagSubConty = false;
      var flagSubConty = false;
      $scope.showSubCountyDropdown = function (electionFor) {
        //MyService.ConsoleLog("showSubCountyDropdown");
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "sub county":
              if ($scope.User.state && $scope.User.county) {
                running_flagSubConty = true;
                return true;
              }
              break;
          }
          running_flagSubConty = false;
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "sub county":
              if ($scope.User.cur_state && $scope.User.cur_county) {
                flagSubConty = false;
                return true;
              }
              break;
          }
          flagSubConty = false;
          return false;
        }
      };
      var running_flagLocality = false;
      var flagLocality = false;
      $scope.showLocalityDropdown = function (electionFor) {
        //MyService.ConsoleLog("showLocalityDropdown");
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "city":
              if ($scope.User.state && $scope.User.county) {
                running_flagLocality = true;
                return true;
              }
              // for options, list all unique county subdivision names and place names within the selected county within the selected state
              break;
          }
          running_flagLocality = false;
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "city":
              if ($scope.User.cur_state && $scope.User.cur_county) {
                flagLocality = true;
                return true;
              }
              // for options, list all unique county subdivision names and place names within the selected county within the selected state
              break;
          }
          flagLocality = false;
          return false;
        }
      };
      var running_flagStateSchoolDist = false;
      var flagStateSchoolDist = false;
      $scope.showStateSchoolDistDropdown = function (electionFor) {
        //MyService.ConsoleLog("showStateSchoolDistDropdown");
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "state school board district":
              if ($scope.User.state) {
                running_flagStateSchoolDist = true;
                return true;
              }
              // For the District options,
              //list all item E’s where item Q is the state selected
              break;
          }
          running_flagStateSchoolDist = false;
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "state school board district":
              if ($scope.User.cur_state) {
                flagStateSchoolDist = true;
                return true;
              }
              // For the District options,
              //list all item E’s where item Q is the state selected
              break;
          }
          flagStateSchoolDist = false;
          return false;
        }
      };
      var running_flagLocalSchoolDist = false;
      var flagLocalSchoolDist = false;
      $scope.showLocalSchoolDistDropdown = function (electionFor) {
        //MyService.ConsoleLog("showDistrictDropdown");
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "local school district":
              if ($scope.User.state) {
                if ($scope.User.state && $scope.localSchoolDistException()) {
                  if ($scope.User.state && $scope.User.county) {
                    running_flagLocalSchoolDist = true;
                    return true;
                  }
                  // For the District options,
                  // results of a search through the table currently labelled “2016 Alabama” and find all AD’s, AF’s  and AH’s  where item Q is the state selected and item S is the “County” selection
                } else if ($scope.User.state) {
                  // for District options
                  // do a search through the table currently labelled “2016 Alabama” and find all AD’s where the item Q is the state selected.
                  running_flagLocalSchoolDist = true;
                  return true;
                }
              }
              break;
          }

          running_flagLocalSchoolDist = false;
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "local school district":
              if ($scope.User.cur_state) {
                if (
                  $scope.User.cur_state &&
                  $scope.localSchoolDistException()
                ) {
                  if ($scope.User.cur_state && $scope.User.cur_county) {
                    flagLocalSchoolDist = true;
                    return true;
                  }
                  // For the District options,
                  // results of a search through the table currently labelled “2016 Alabama” and find all AD’s, AF’s  and AH’s  where item Q is the state selected and item S is the “County” selection
                } else if ($scope.User.cur_state) {
                  // for District options
                  // do a search through the table currently labelled “2016 Alabama” and find all AD’s where the item Q is the state selected.
                  flagLocalSchoolDist = true;
                  return true;
                }
              }
              break;
          }
          flagLocalSchoolDist = false;
          return false;
        }
      };
      //var getAddressOfRunningPoliCanceler = $q.defer();
      $scope.congressionalDistricts = [];
      var getAddressOfRunningPoliCanceler = $q.defer();
      $scope.running_flagShowOfficeDropdown = false;
      $scope.flagShowOfficeDropdown = false;
      $scope.showlevelOfGovt = [];
      $scope.onStateChange = function (electionFor) {
        //MyService.ConsoleLog("** onStateChange **", electionFor);
        //MyService.ConsoleLog("** onStateChange **", $scope.User.level);
        if (electionFor == "running") {
          //'Federal', 'State', 'Local'
          switch ($scope.User.level) {
            case "federal":
            case "Federal":
              $scope.showlevelOfGovt = angular.copy($scope.fedlevelOfGovt);
              $scope.running_flagShowOfficeDropdown = true;
              break;
            case "state":
            case "State":
              $scope.showlevelOfGovt = angular.copy($scope.statelevelOfGovt);
              $scope.running_flagShowOfficeDropdown = true;
              break;
            case "local":
            case "Local":
              $scope.showlevelOfGovt = angular.copy($scope.locallevelOfGovt);
              $scope.running_flagShowOfficeDropdown = true;
              break;
            default:
              $scope.showlevelOfGovt = angular.copy($scope.fedlevelOfGovt);
              $scope.running_flagShowOfficeDropdown = false;
              break;
          }
          //$scope.User.off_name = $scope.showlevelOfGovt[0];
        } else if (electionFor == "incumbent") {
          $scope.showlevelOfGovt.length = 0;
          //MyService.ConsoleLog($scope.User.cur_level);
          switch ($scope.User.cur_level) {
            case "Federal":
              $scope.showlevelOfGovt = angular.copy($scope.fedlevelOfGovt);
              $scope.flagShowOfficeDropdown = true;
              break;
            case "State":
              $scope.showlevelOfGovt = angular.copy($scope.statelevelOfGovt);
              $scope.flagShowOfficeDropdown = true;
              break;
            case "Local":
              $scope.showlevelOfGovt = angular.copy($scope.locallevelOfGovt);
              $scope.flagShowOfficeDropdown = true;
              break;
            default:
              $scope.showlevelOfGovt = angular.copy($scope.fedlevelOfGovt);
              $scope.flagShowOfficeDropdown = true;
              break;
          }
          //MyService.ConsoleLog($scope.showlevelOfGovt);
          //$scope.User.cur_off_name = $scope.showlevelOfGovt[0];
        }
      };
      $scope.onDistrictChange = function (electionFor) {
        //MyService.ConsoleLog("** onDistrictChange **");
        if (electionFor == "running") {
          if ($scope.User.state) {
            switch ($scope.User.level) {
              case "judicial district":
                if ($scope.User.state) {
                  $scope.User.office_name = null;
                  $scope.running_offices = [];
                  //fetch office names for this
                  //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item F is the district selected. Then add “other” to the bottom of the list
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.state.statePostalCode,
                    return_field: "office",
                    JudicialCircuitNumber: $scope.User.district,
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.running_offices = response.data.data;
                        $scope.running_offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.running_offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //state selected
        } else if (electionFor == "incumbent") {
          if ($scope.User.cur_state) {
            //MyService.ConsoleLog("** onDistrictChange **");
            switch ($scope.User.cur_level) {
              case "judicial district":
                if ($scope.User.cur_state) {
                  $scope.User.cur_office_name = null;
                  $scope.offices = [];
                  //fetch office names for this
                  //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item F is the district selected. Then add “other” to the bottom of the list
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.cur_state.statePostalCode,
                    return_field: "office",
                    JudicialCircuitNumber: $scope.User.cur_district,
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.offices = response.data.data;
                        $scope.offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //state selected
        }
      };
      $scope.onCountyChange = function (electionFor) {
        if (electionFor == "running") {
          if ($scope.User.state) {
            //MyService.ConsoleLog("** onCountyChange **");
            switch ($scope.User.level) {
              case "county":
                if ($scope.User.state) {
                  $scope.User.office_name = null;
                  $scope.running_offices = [];
                  //fetch office names for this
                  //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected.  Then add “other” to the bottom of the list
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.state.statePostalCode,
                    CountyName: $scope.User.county,
                    voterScope: "County Name",
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.running_offices = response.data.data;
                        $scope.running_offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.running_offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
              case "sub county":
                if ($scope.User.state && $scope.User.county) {
                  $scope.User.cur_office_name = null;
                  $scope.running_offices = [];
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.state.statePostalCode,
                    CountyName: $scope.User.county,
                    voterScope: "County Name",
                    return_field: "CountySubdivisionName",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.running_subcounties = response.data.data;
                        //MyService.ConsoleLog("--- Got sub counties data ---: ", $scope.running_subcounties);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
              case "city":
                if ($scope.User.state) {
                  $scope.User.office_name = null;
                  // For the options, list all unique county subdivision names and place names within the selected county within the selected state
                  var promiseArr = {
                    counties: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.state.statePostalCode,
                      CountyName: $scope.User.county,
                      return_field: "CountySubdivisionName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                    places: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.state.statePostalCode,
                      CountyName: $scope.User.county,
                      return_field: "PlaceName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                  };

                  $q.all(promiseArr).then(function (response) {
                    //MyService.ConsoleLog("response: ", response);
                    if (
                      response.counties.data.success &&
                      response.places.data.success
                    ) {
                      $timeout(function () {
                        var tempArr = [];
                        angular.forEach(
                          response.counties.data.data,
                          function (val, key) {
                            tempArr.push({
                              label: val,
                              type: "county",
                            });
                          }
                        );
                        angular.forEach(
                          response.places.data.data,
                          function (val, key) {
                            tempArr.push({
                              label: val,
                              type: "place",
                            });
                          }
                        );

                        // tempArr = [{label: "tetst", type: "county"}, {label: "tetst 2", type: "place"}];

                        $scope.running_localities = tempArr;
                        //MyService.ConsoleLog("--- Got localities data ---: ", $scope.running_localities);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;

              case "local school district":
                $scope.User.office_name = null;
                if (!$scope.localSchoolDistException() && $scope.User.county) {
                  // results of a search through the table currently labelled “2016 Alabama” and find all AD’s, AF’s  and AH’s  where item Q is the state selected and item S is the “County” selection
                  var promiseArr = {
                    UnifiedSchoolDistrict: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.state.statePostalCode,
                      CountyName: $scope.county,
                      return_field: "UnifiedSchoolDistrictName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                    ElementarySchoolDistrict: MyService.getAddressOfRunningPoli(
                      {
                        StatePostalCode: $scope.User.state.statePostalCode,
                        CountyName: $scope.county,
                        return_field: "ElementarySchoolDistrictName",
                        timeout: getAddressOfRunningPoliCanceler.promise,
                      }
                    ),
                    SecondarySchoolDistrict: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.state.statePostalCode,
                      CountyName: $scope.county,
                      return_field: "SecondarySchoolDistrictName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                  };

                  $q.all(promiseArr).then(
                    function (response) {
                      //MyService.ConsoleLog("response: ", response);
                      if (
                        response.UnifiedSchoolDistrict.data.success &&
                        response.ElementarySchoolDistrict.data.success &&
                        response.SecondarySchoolDistrict.data.success
                      ) {
                        $timeout(function () {
                          var tempArr = [];
                          angular.forEach(
                            response.UnifiedSchoolDistrict.data.data,
                            function (val, key) {
                              tempArr.push({
                                label: val,
                                type: "UnifiedSchoolDistrictName",
                              });
                            }
                          );
                          angular.forEach(
                            response.ElementarySchoolDistrict.data.data,
                            function (val, key) {
                              tempArr.push({
                                label: val,
                                type: "ElementarySchoolDistrictName",
                              });
                            }
                          );
                          angular.forEach(
                            response.SecondarySchoolDistrict.data.data,
                            function (val, key) {
                              tempArr.push({
                                label: val,
                                type: "SecondarySchoolDistrictName",
                              });
                            }
                          );
                          //MyService.ConsoleLog("$scope.localSchoolDistricts: ", tempArr);
                          $scope.running_localSchoolDistricts = tempArr;
                        });
                      } else {
                        //MyService.ConsoleLog("response: ", response);
                        growl.error("Something went wrong.");
                      }
                    },
                    function (err) {
                      //MyService.ConsoleLog("err: ", err);
                      growl.error("Something went wrong.");
                    }
                  );
                }
                break;
            }
          } //state selected
        } else if (electionFor == "incumbent") {
          if ($scope.User.cur_state) {
            //MyService.ConsoleLog("** onCountyChange **");
            switch ($scope.User.cur_level) {
              case "county":
                if ($scope.User.cur_state) {
                  $scope.User.cur_office_name = null;
                  $scope.offices = [];
                  //fetch office names for this
                  //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected.  Then add “other” to the bottom of the list
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.cur_state.statePostalCode,
                    CountyName: $scope.User.cur_county,
                    voterScope: "County Name",
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.offices = response.data.data;
                        $scope.offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
              case "sub county":
                if ($scope.User.cur_state && $scope.User.cur_county) {
                  $scope.User.cur_office_name = null;
                  $scope.offices = [];
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.cur_state.statePostalCode,
                    CountyName: $scope.User.cur_county,
                    voterScope: "County Name",
                    return_field: "CountySubdivisionName",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.subcounties = response.data.data;
                        //MyService.ConsoleLog("--- Got sub counties data ---: ", $scope.subcounties);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
              case "city":
                if ($scope.User.cur_state) {
                  $scope.User.cur_office_name = null;
                  // For the options, list all unique county subdivision names and place names within the selected county within the selected state
                  var promiseArr = {
                    counties: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.cur_state.statePostalCode,
                      CountyName: $scope.User.cur_county,
                      return_field: "CountySubdivisionName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                    places: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.cur_state.statePostalCode,
                      CountyName: $scope.User.cur_county,
                      return_field: "PlaceName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                  };

                  $q.all(promiseArr).then(function (response) {
                    //MyService.ConsoleLog("response: ", response);
                    if (
                      response.counties.data.success &&
                      response.places.data.success
                    ) {
                      $timeout(function () {
                        var tempArr = [];
                        angular.forEach(
                          response.counties.data.data,
                          function (val, key) {
                            tempArr.push({
                              label: val,
                              type: "county",
                            });
                          }
                        );
                        angular.forEach(
                          response.places.data.data,
                          function (val, key) {
                            tempArr.push({
                              label: val,
                              type: "place",
                            });
                          }
                        );

                        // tempArr = [{label: "tetst", type: "county"}, {label: "tetst 2", type: "place"}];

                        $scope.localities = tempArr;
                        //MyService.ConsoleLog("--- Got localities data ---: ", $scope.localities);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;

              case "local school district":
                //MyService.ConsoleLog("cur_county : ", $scope.User.cur_county);
                $scope.User.cur_office_name = null;
                if (
                  !$scope.localSchoolDistException() &&
                  $scope.User.cur_county
                ) {
                  // results of a search through the table currently labelled “2016 Alabama” and find all AD’s, AF’s  and AH’s  where item Q is the state selected and item S is the “County” selection
                  var promiseArr = {
                    UnifiedSchoolDistrict: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.cur_state.statePostalCode,
                      CountyName: $scope.cur_county,
                      return_field: "UnifiedSchoolDistrictName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                    ElementarySchoolDistrict: MyService.getAddressOfRunningPoli(
                      {
                        StatePostalCode: $scope.User.cur_state.statePostalCode,
                        CountyName: $scope.cur_county,
                        return_field: "ElementarySchoolDistrictName",
                        timeout: getAddressOfRunningPoliCanceler.promise,
                      }
                    ),
                    SecondarySchoolDistrict: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.cur_state.statePostalCode,
                      CountyName: $scope.cur_county,
                      return_field: "SecondarySchoolDistrictName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                  };

                  $q.all(promiseArr).then(
                    function (response) {
                      //MyService.ConsoleLog("response: ", response);
                      if (
                        response.UnifiedSchoolDistrict.data.success &&
                        response.ElementarySchoolDistrict.data.success &&
                        response.SecondarySchoolDistrict.data.success
                      ) {
                        $timeout(function () {
                          var tempArr = [];
                          angular.forEach(
                            response.UnifiedSchoolDistrict.data.data,
                            function (val, key) {
                              tempArr.push({
                                label: val,
                                type: "UnifiedSchoolDistrictName",
                              });
                            }
                          );
                          angular.forEach(
                            response.ElementarySchoolDistrict.data.data,
                            function (val, key) {
                              tempArr.push({
                                label: val,
                                type: "ElementarySchoolDistrictName",
                              });
                            }
                          );
                          angular.forEach(
                            response.SecondarySchoolDistrict.data.data,
                            function (val, key) {
                              tempArr.push({
                                label: val,
                                type: "SecondarySchoolDistrictName",
                              });
                            }
                          );
                          //MyService.ConsoleLog("$scope.localSchoolDistricts: ", tempArr);
                          $scope.localSchoolDistricts = tempArr;
                        });
                      } else {
                        //MyService.ConsoleLog("response: ", response);
                        growl.error("Something went wrong.");
                      }
                    },
                    function (err) {
                      //MyService.ConsoleLog("err: ", err);
                      growl.error("Something went wrong.");
                    }
                  );
                }
                break;
            }
          } //state selected
        }
      };
      $scope.onSubCountyChange = function (electionFor) {
        if (electionFor == "running") {
          if ($scope.User.state) {
            //MyService.ConsoleLog("** onCountyChange **");
            switch ($scope.User.level) {
              case "sub county":
                if (
                  $scope.User.state &&
                  $scope.User.county &&
                  $scope.User.subcounty
                ) {
                  $scope.User.office_name = null;
                  $scope.running_offices = [];
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.state.statePostalCode,
                    CountyName: $scope.User.county,
                    // voterScope: "County Name",
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.running_offices = response.data.data;
                        $scope.running_offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.running_offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //s
        } else {
          if ($scope.User.cur_state) {
            //MyService.ConsoleLog("** onCountyChange **");
            switch ($scope.User.cur_level) {
              case "sub county":
                if (
                  $scope.User.cur_state &&
                  $scope.User.cur_county &&
                  $scope.User.subcounty
                ) {
                  $scope.User.cur_office_name = null;
                  $scope.offices = [];
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.cur_state.statePostalCode,
                    CountyName: $scope.User.cur_county,
                    // voterScope: "County Name",
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.offices = response.data.data;
                        $scope.offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //s
        }
      };
      $scope.onLocalityChange = function (electionFor) {
        //MyService.ConsoleLog("** onLocalityChange **");
        if (electionFor == "running") {
          if ($scope.User.state) {
            switch ($scope.User.level) {
              case "city":
                if (
                  $scope.User.state &&
                  $scope.User.county &&
                  $scope.User.locality
                ) {
                  $scope.User.office_name = null;
                  $scope.running_offices = [];
                  //fetch office names for this
                  // For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected and U or W match the “city” selection.  Then add “other” to the bottom of the list
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.state.statePostalCode,
                    CountyName: $scope.User.county,
                    CountySubdivisionName: $scope.User.locality.label,
                    PlaceName: $scope.User.locality.label,
                    office_for: "place", //this is special case
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.running_offices = response.data.data;
                        $scope.running_offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.running_offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //s
        } else if (electionFor == "incumbent") {
          if ($scope.User.cur_state) {
            switch ($scope.User.cur_level) {
              case "city":
                if (
                  $scope.User.cur_state &&
                  $scope.User.cur_county &&
                  $scope.User.cur_locality
                ) {
                  $scope.User.cur_office_name = null;
                  $scope.offices = [];
                  //fetch office names for this
                  // For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected and U or W match the “city” selection.  Then add “other” to the bottom of the list
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.cur_state.statePostalCode,
                    CountyName: $scope.User.cur_county,
                    CountySubdivisionName: $scope.User.cur_locality.label,
                    PlaceName: $scope.User.cur_locality.label,
                    office_for: "place", //this is special case
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.offices = response.data.data;
                        $scope.offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //s
        }
      };
      $scope.onStateSchoolDistChange = function (electionFor) {
        //MyService.ConsoleLog("** onStateSchoolDistChange **");
        if (electionFor == "running") {
          if ($scope.User.state) {
            switch ($scope.User.level) {
              case "state school board district":
                if ($scope.User.state && $scope.User.state_school_dist) {
                  $scope.User.office_name = null;
                  $scope.running_offices = [];
                  //fetch office names for this
                  // do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item E is the “District” selection.  Then add “other” to the bottom of the list.
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.state.statePostalCode,
                    StateBoardEducationDistrict: $scope.User.state_school_dist,
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.running_offices = response.data.data;
                        $scope.running_offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.running_offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //s
        } else if (electionFor == "incumbent") {
          if ($scope.User.cur_state) {
            switch ($scope.User.cur_level) {
              case "state school board district":
                if (
                  $scope.User.cur_state &&
                  $scope.User.cur_state_school_dist
                ) {
                  $scope.User.cur_office_name = null;
                  $scope.offices = [];
                  //fetch office names for this
                  // do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item E is the “District” selection.  Then add “other” to the bottom of the list.
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.cur_state.statePostalCode,
                    StateBoardEducationDistrict:
                      $scope.User.cur_state_school_dist,
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.offices = response.data.data;
                        $scope.offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //s
        }
      };
      $scope.onLocalSchoolDistChange = function (electionFor) {
        if (electionFor == "running") {
          if ($scope.User.state) {
            //MyService.ConsoleLog("** onLocalSchoolDistChange **");
            switch ($scope.User.level) {
              case "local school district":
                break;
            }
          } //s
        } else if (electionFor == "incumbent") {
          if ($scope.User.cur_state) {
            //MyService.ConsoleLog("** onLocalSchoolDistChange **");
            switch ($scope.User.level) {
              case "local school district":
                break;
            }
          } //s
        }
      };

      try {
        if ($scope.ngDialogData.from_date && $scope.ngDialogData.end_date) {
          $scope.User.isInCurrentOffice = "1";
          //MyService.ConsoleLog("$sope.User.isInCurrentOffice: ", $scope.User.isInCurrentOffice);
        }

        if (
          $scope.ngDialogData.levelOfGov.toLowerCase() == "national" ||
          $scope.ngDialogData.levelOfGov.toLowerCase() == "all usa"
        )
          $scope.User.cur_level = $scope.ngDialogData.levelOfGov.toLowerCase();
        if ($scope.ngDialogData.from_date) {
          $scope.User.from_date = new Date($scope.ngDialogData.from_date);
        }
        if ($scope.ngDialogData.end_date) {
          $scope.User.end_date = new Date($scope.ngDialogData.end_date);
        }
        if ($scope.ngDialogData.office_name) {
          $scope.User.cur_office_name = $scope.ngDialogData.office_name;
        }
      } catch (e) {
        //MyService.ConsoleLog("$scope.User: ", e);
      }

      $scope.AddNewOffice = function (opt) {
        if (tokenService.getUserData()) {
          var userData = JSON.parse(tokenService.getUserData());
          var newData = new Object();
          //MyService.ConsoleLog($scope.User);
          if (opt == "incumbent") {
            newData.govLevel = $scope.User.cur_level;
            if ($scope.User.cur_state) {
              newData.state = $scope.User.cur_state.state;
              newData.statePostalCode = $scope.User.cur_state.statePostalCode;
            }
            if ($scope.User.cur_off_name != "Other") {
              newData.office_name = $scope.User.cur_off_name;
            } else {
              newData.office_name = $scope.User.cur_office_name;
              newData.office_location = $scope.User.cur_office_location;
            }
          } else {
            newData.govLevel = $scope.User.level;
            if ($scope.User.state) {
              newData.state = $scope.User.state.state;
              newData.statePostalCode = $scope.User.state.statePostalCode;
            }
            if ($scope.User.off_name != "Other") {
              newData.office_name = $scope.User.off_name;
            } else {
              newData.office_name = $scope.User.office_name;
              newData.office_location = $scope.User.office_location;
            }

            newData.from_date = $scope.User.from_date;
            newData.end_date = $scope.User.end_date;
          }
          //MyService.ConsoleLog(newData);

          var validate = true;

          if (newData.govLevel == "") {
            alert("Please select level of government.");
            validate = false;
          }

          if (newData.state == "") {
            alert("Please select State.");
            validate = false;
          }

          if (newData.office_name == "") {
            alert("Please select/enter office details.");
            validate = false;
          }

          if (
            opt == "running" &&
            (!newData.from_date || newData.from_date == "")
          ) {
            alert("Please enter from date.");
            validate = false;
          }

          if (
            opt == "running" &&
            (!newData.end_date || newData.end_date == "")
          ) {
            alert("Please enter to date.");
            validate = false;
          }
          if (validate) {
            MyService.AddNewOfficeData(newData).then(
              function (payload) {
                //MyService.ConsoleLog(payload);
                if (payload.data.success) {
                  $scope.$parent.profile.politician_info =
                    payload.data.user.politician_info;
                  ngDialog.closeAll();
                } else {
                  //MyService.ConsoleLog(payload);
                  alert("Something went wrong");
                  ngDialog.closeAll();
                }
              },
              function (errPayload) {
                //MyService.ConsoleLog(errPayload);
                alert("Something went wrong");
                ngDialog.closeAll();
              }
            );
          }
        } else {
          alert("Please login first");
          ngDialog.closeAll();
        }
      };

      $scope.UpdateOffice = function () {
        var newData = new Object();

        newData.levelOfGov = $scope.User.level;
        if ($scope.User.state) {
          newData.state = $scope.User.state.state;
          newData.statePostalCode = $scope.User.state.statePostalCode;
        }
        newData.office_name = $scope.User.off_name;
        if ($scope.User.from_date) {
          newData.from_date = $scope.User.from_date;
        }
        if ($scope.User.end_date) {
          newData.end_date = $scope.User.end_date;
        }

        //MyService.ConsoleLog(newData);

        var validate = true;

        if (newData.govLevel == "") {
          alert("Please select level of government.");
          validate = false;
        }

        if (newData.state == "") {
          alert("Please select State.");
          validate = false;
        }

        if (newData.office_name == "") {
          alert("Please select/enter office details.");
          validate = false;
        }

        if (newData.from_date && newData.from_date == "") {
          alert("Please enter from date.");
          validate = false;
        }

        if (newData.end_date && newData.end_date == "") {
          alert("Please enter to date.");
          validate = false;
        }
        if (validate) {
          var idx = $scope.$parent.profile.politician_info.indexOf(
            $scope.ngDialogData
          );
          //MyService.ConsoleLog(idx);
          $scope.$parent.profile.politician_info[idx] = newData;
          //MyService.ConsoleLog($scope.$parent.profile.politician_info);

          MyService.UpdateOfficeData({
            politician_info: JSON.stringify(
              $scope.$parent.profile.politician_info
            ),
          }).then(
            function (payload) {
              //MyService.ConsoleLog(payload);
              if (payload.data.success) {
                $scope.$parent.profile.politician_info =
                  payload.data.user.politician_info;
                ngDialog.closeAll();
              } else {
                //MyService.ConsoleLog(payload);
                ngDialog.closeAll();
              }
            },
            function (errPayload) {
              //MyService.ConsoleLog(errPayload);
              ngDialog.closeAll();
            }
          );
        }
      };

      $scope.removeOffice = function () {
        try {
          var userData = JSON.parse(tokenService.getUserData());
          //MyService.ConsoleLog("userData: ", userData);
          var postobj = {
            userid: userData._id,
            info_id: $scope.ngDialogData._id,
          };

          /*MyService.managePoliticianOffice().then(function(response){
            if (response.success) {
                growl.success('Updated successfully.');
            } else if (response.error && typeof response.error == "string") {
                growl.error('Error: ' + data.error);
            } else {
                growl.error('Something went wrong.');
            }
        }, function(err){
            growl.error("Something went wrong.");
        });*/
        } catch (e) {
          //MyService.ConsoleLog("Exception: ", e);
        }
      };

      function toTitleCase(str) {
        return str.replace(/\w\S*/g, function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
      }

      if ($scope.ngDialogData) {
        //MyService.ConsoleLog("Edit called");
        $scope.ShowAdd = false;
        $scope.running_flagShowStateDropdown = true;
        // $scope.running_flagShowOfficeDropdown = true;
        $scope.editflagShowOfficeDropdown = true;

        $scope.User.level = toTitleCase($scope.ngDialogData.levelOfGov);
        $scope.User.off_name = toTitleCase($scope.ngDialogData.office_name);
        $scope.onStateChange("running");
        if ($scope.ngDialogData.from_date) {
          $scope.User.from_date = $scope.ngDialogData.from_date;
        }
        if ($scope.ngDialogData.end_date) {
          $scope.User.to_date = $scope.ngDialogData.end_date;
        }
        //MyService.ConsoleLog($scope.User.level + "====" + $scope.User.off_name);
        //MyService.ConsoleLog($scope.ngDialogData.levelOfGov + "====" + $scope.ngDialogData.office_name);
        /*
       = {
          level: $scope.ngDialogData.levelOfGov,
          off_name: $scope.ngDialogData.office_name
      }
      */
      } else {
        //MyService.ConsoleLog("Add Called");
        $scope.ShowAdd = true;
      }
    },
  ])
  .controller("PlacesShapeCtrl", [
    "$scope",
    "ngDialog",
    "$rootScope",
    "MyService",
    "$http",
    "$timeout",
    function ($scope, ngDialog, $rootScope, MyService, $http, $timeout) {
      $scope.gridOptions = {
        enableFiltering: true,
        showGridFooter: true,
        showColumnFooter: false,
        enableColumnMenu: true,
      };

      $scope.getPlacesData = function () {
        MyService.getPlaceShape({}).then(
          function (records) {
            // MyService.ConsoleLog(records);
            // console.log('records for place shape', records);
            var columns = [];
            if (records.data.success) {
              var fdata = records.data.data;
              angular.forEach(fdata[0], function (pd, i) {
                // MyService.ConsoleLog("Field :", i);
                if (i != "__v" && i != "_id") {
                  var nc = Object;
                  nc.field = i;
                  nc.displayName = i;
                  nc.width = 100;
                  var str = {
                    field: i,
                    width: "140",
                  };
                  columns.push(str);
                }
              });
              MyService.ConsoleLog(columns);
              $scope.gridOptions.columnDefs = columns;
              $scope.gridOptions.data = fdata;
            }
          },
          function (err) {
            $scope.showLoader = false;
            MyService.ConsoleLog("error : ", err);
          }
        );
      };

      if ($rootScope.showPlacesShape) {
        $scope.getPlacesData();
      }
    },
  ])
  .controller("recommendCtrl", [
    "$scope",
    "$location",
    "$rootScope",
    "growl",
    "ngDialog",
    "tokenService",
    "MyService",
    function (
      $scope,
      $location,
      $rootScope,
      growl,
      ngDialog,
      tokenService,
      MyService
    ) {
      $scope.userData = tokenService.getUserRole();
      $scope.favorite = {
        type: "",
        name: "",
        description: "",
        artist: "",
        releaseDate: "",
        imdburl: "",
        website: "",
        utype: $scope.userData,
      };
      $scope.fav = {
        data: [],
      };
      $scope.showFaouriteList = 0;
      //MyService.ConsoleLog($scope.userData);
      $scope.allType = ["Movie", "Music", "Book", "Podcasts"];

      $scope.ListMyFavorite = function () {
        $scope.showFaouriteList = 3;
        $scope.fav.data.length = 0;
        MyService.ListMyFavorite().then(
          function (payload) {
            //MyService.ConsoleLog(payload);
            $scope.showFaouriteList = 1;
            if (payload.data.success) {
              $scope.fav.data = payload.data.data;
            }
          },
          function (errorPayload) {
            $scope.showFaouriteList = 1;
            //MyService.ConsoleLog(errorPayload);
          }
        );
      };

      $scope.DisplayFavorite = function () {
        $scope.showFaouriteList = 2;
        $scope.favorite = {
          type: "",
          name: "",
          description: "",
          artist: "",
          releaseDate: "",
          imdburl: "",
          website: "",
          utype: $scope.userData,
        };
      };
      $scope.AddFavorite = function () {
        var Validation = true;
        if ($scope.favorite.type == "") {
          alert("Please select favorite type.");
          Validation = false;
        }

        if (Validation && $scope.favorite.name == "") {
          alert("Please enter name.");
          Validation = false;
        }

        if (Validation) {
          //MyService.ConsoleLog($scope.favorite);

          MyService.AddFavorite($scope.favorite).then(
            function (payload) {
              //MyService.ConsoleLog(payload);
              if (payload.data.success) {
                alert("Record added successfully");
                $scope.ListMyFavorite();
              } else {
                alert("Something went wrong.");
              }
            },
            function (errorPayload) {
              //MyService.ConsoleLog(errorPayload);
              alert("Something went wrong.");
            }
          );
        }
      };

      $scope.removeFav = function (rdata, index) {
        var message = "Are you sure you want to delete this record?";
        //MyService.ConsoleLog(rdata);
        if (rdata._id) {
          var modal = ngDialog.openConfirm({
            template:
              "<p>" +
              message +
              '</p>\
            <div class="ngdialog-buttons">\
                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">YES</button>\
                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">NO</button>\
            </div>',
            plain: true,
          });
          modal.then(
            function fullfilled(data) {
              //MyService.ConsoleLog("fullfilled: ", mydata);
              MyService.RemoveFavorite({
                id: rdata._id,
              }).then(
                function (payload) {
                  if (payload.data.success) {
                    alert("Record deleted successfully");
                    $scope.ListMyFavorite();
                  } else {
                    alert("Something went wrong.");
                  }
                },
                function (errorPayload) {
                  //MyService.ConsoleLog(errorPayload);
                  alert("Something went wrong.");
                }
              );
            },
            function rejected(data) {
              //MyService.ConsoleLog("rejected: ", data);
            }
          );
        }
      };

      $scope.recommendFav = function (data, recommend) {
        var nobj = new Object();
        nobj.favId = data._id;
        nobj.recommend = recommend;
        MyService.recommendFav({
          favId: data._id,
          recommend: recommend,
        }).then(
          function (payload) {
            if (payload.data.success) {
              alert("Record updated successfully");
              $scope.ListMyFavorite();
            } else {
              alert("Something went wrong.");
            }
          },
          function (errorPayload) {
            alert("Something went wrong.");
          }
        );
      };

      $scope.goBack = function () {
        $scope.showFaouriteList = 1;
      };
      $scope.ListMyFavorite();
    },
  ])

  .directive("fileread", [
    function () {
      return {
        scope: {
          opts: "=",
          address: "=",
        },
        link: function ($scope, $elm, $attrs) {
          // MyService.ConsoleLog("$scope >>", $scope, $elm)
          $elm.on("change", function (changeEvent) {
            var reader = new FileReader();
            // console.log("reader >", reader);
            reader.onload = function (evt) {
              $scope.$apply(function () {
                var data = evt.target.result;

                var workbook = XLSX.read(data, {
                  type: "binary",
                });

                var headerNames = XLSX.utils.sheet_to_json(
                  workbook.Sheets[workbook.SheetNames[0]],
                  {
                    header: 1,
                  }
                )[0];

                var vdata = XLSX.utils.sheet_to_json(
                  workbook.Sheets[workbook.SheetNames[0]]
                );
                // console.log("vdata>>", vdata);
                $scope.opts.columnDefs = [];

                //$scope.states = ['Alabama', 'Alaska', 'California'];
                /*
               $scope.myHeaderCellTemplate = '<div class="ngHeaderSortColumn {{col.headerClass}}" ng-style="{cursor: col.cursor}" ui-grid-auto-resize ng-class="{ ngSorted: !noSortVisible }">' +
                   '<div ng-click="col.sort($event)" ng-class="\'colt\' + col.index" class="ngHeaderText">{{col.displayName}}</div><div mass-autocomplete><input ng-model="dirty.value" mass-autocomplete-item="grid.appScope.autocomplete_options"></div>' +
                   '<div class="ngSortButtonDown" ng-show="col.showSortButtonDown()"></div>' +
                   '<div class="ngSortButtonUp" ng-show="col.showSortButtonUp()"></div>' +
                   '<div class="ngSortPriority">{{col.sortPriority}}</div>' +
                   '</div>' +
                   '<div ng-show="col.resizable" class="ngHeaderGrip"></div>';

               */
                // var myfields = ["name", "email", "PrivateEmail", "office", "officePlace", "party", "electionDate", "voterScope", "public_mailing_address", "private_mailing_address", "website", "RapidTransitDistrict", "statement", "numberOfOpenings", "incumbent", "publicZipCode", "privateZipCode", "PublicPhoneNumber", "PrivatePhoneNumber", "StateBoardEducationDistrict", "JudicialCircuitNumber", "StateFIPS", "StatePostalCode", "CountyFIPS", "CountyName", "CountySubdivisionFIPS", "CountySubdivisionName", "PlaceFIPS", "PlaceName", "VoterDistrict", "VotingDistrictName", "FederalCongressionalDistrict", "StateSenateDistrict", "StateHouseofRepresentativesDistrict", "UnifiedSchoolDistrict", "UnifiedSchoolDistrictName", "ElementarySchoolDistrict", "ElementarySchoolDistrictName", "SecondarySchoolDistrict", "SecondarySchoolDistrictName", "TotalPop", "afact", "dataX", "dataY", "dataZ", "RunningForOffice", "facebookpage", "twitterfeed", "website2", "type_of_election", "data_origin"];

                function camelize(str) {
                  return str.replace(
                    /(?:^\w|[A-Z]|\b\w|\s+)/g,
                    function (match, index) {
                      if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
                      return index == 0
                        ? match.toLowerCase()
                        : match.toUpperCase();
                    }
                  );
                }

                $scope.myHeaderCellTemplate =
                  '<div  ng-style="{cursor: col.cursor}" ui-grid-auto-resize ng-class="{ ngSorted: !noSortVisible }">' +
                  '<div class="ngHeaderText">{{col.displayName}}</div><div><select ng-model="dirty.value" ng-change="grid.appScope.changeDisplay(col,dirty.value)">';
                // for(var i=0; i<myfields.length;i++) {

                //     $scope.myHeaderCellTemplate += '<option value="'+myfields[i]+'">'+myfields[i]+'</option>';
                // }

                var checkcityArray = [
                  "city",
                  "City",
                  "CITY",
                  "town",
                  "Town",
                  "TOWN",
                ];
                var cityIdx = "";
                $scope.myHeaderCellTemplate +=
                  '<option ng-repeat="fld in grid.appScope.myFields" value="{{fld}}">{{fld}}</option>';
                $scope.myHeaderCellTemplate +=
                  "</select></div>" +
                  '<div class="ngSortButtonDown" ng-show="col.showSortButtonDown()"></div>' +
                  '<div class="ngSortButtonUp" ng-show="col.showSortButtonUp()"></div>' +
                  '<div class="ngSortPriority">{{col.sortPriority}}</div>' +
                  "</div>" +
                  '<div ng-show="col.resizable" class="ngHeaderGrip"></div>';

                var myFields = [
                  "name",
                  "email",
                  "privateEmail",
                  "office",
                  "officePlace",
                  "candidateStatus",
                  "party",
                  "postCard",
                  "electionDate",
                  "voterScope",
                  "publicMailingAddress",
                  "privateMailingAddress",
                  "website",
                  "rapidTransitDistrict",
                  "statement",
                  "numberOfOpenings",
                  "incumbent",
                  "publicZipCode",
                  "privateZipCode",
                  "publicPhoneNumber",
                  "privatePhoneNumber",
                  "stateBoardEducationDistrict",
                  "judicialCircuitNumber",
                  "stateFips",
                  "statePostalCode",
                  "state",
                  "countyFips",
                  "countyName",
                  "countySubdivisionFips",
                  "countySubdivisionName",
                  "placeFips",
                  "placeName",
                  "voterDistrict",
                  "votingDistrictName",
                  "federalCongressionalDistrict",
                  "stateSenateDistrict",
                  "stateHouseofRepresentativesDistrict",
                  "unifiedSchoolDistrict",
                  "unifiedSchoolDistrictName",
                  "elementarySchoolDistrict",
                  "elementarySchoolDistrictName",
                  "secondarySchoolDistrict",
                  "secondarySchoolDistrictName",
                  "officeDistrictName",
                  "officeStatus",
                  "totalPop",
                  "afact",
                  "dataX",
                  "dataY",
                  "dataZ",
                  "runningForOffice",
                  "facebookPage",
                  "twitterFeed",
                  "website2",
                  "typeOfElection",
                  "dataOrigin",
                ];

                function getSelectedRecord(h) {
                  // MyService.ConsoleLog("data", h);
                  // console.log('h >', h);
                  // console.log("touched",addr);

                  var arr = myFields.map(function (elem) {
                    return elem.toLowerCase();
                  });
                  var dname = h.toLowerCase();
                  var idx = arr.indexOf(dname);
                  if (idx > -1) {
                    return myFields[idx];
                  } else {
                    return camelize(h.toLowerCase());
                  }
                }
                // console.log('headerNames', headerNames);
                headerNames.forEach(function (h) {
                  var disName = getSelectedRecord(h);
                  //MyService.ConsoleLog("disName>>>", disName);
                  var wdth = disName.length * 10;
                  if (wdth < 150) {
                    wdth = 150;
                  }
                  var checkarray = [];
                  checkarray.length = 0;
                  switch (h) {
                    case "state":
                      // console.log("state >>", $scope.address.state);
                      checkarray = angular.copy($scope.address.state.state);
                      break;
                    case "federalCongressionalDistrict":
                    case "FederalCongressionalDistrict":
                      checkarray = angular.copy(
                        $scope.address.FederalCongressionalDistrict
                      );
                      break;
                    case "stateHouseofRepresentativesDistrict":
                    case "StateHouseofRepresentativesDistrict":
                      checkarray = angular.copy(
                        $scope.address.StateHouseofRepresentativesDistrict
                      );
                      break;
                    case "default":
                      checkarray = angular.copy($scope.address.city);
                      break;
                  }
                  // console.log("checkarray<><><><>", checkarray);
                  /* $scope.opts.columnDefs.push({
                   field: h,
                   displayName: disName,
                   minWidth: wdth,
                   enableSorting: false,
                   enableCellEdit: true,
                   headerCellTemplate: $scope.myHeaderCellTemplate,
                   cellClass: function (grid, row, col, rowRenderIndex, colRenderIndex) {
                     var gVal = grid.getCellValue(row, col);
                     if (gVal) {
                       //MyService.ConsoleLog(gVal);
                       console.log("checkarray >>", checkarray)
                       // if (checkarray && checkarray != "") {
                       var cidx = checkarray.filter(function (d) {
                         // MyService.ConsoleLog("d>", d);
                         if (d && d != "") {
                           // MyService.ConsoleLog("gVal<><><>", gVal);
                           // console.log("address>>", $scope.address.towns)
                           if ($scope.address.towns.indexOf(gVal) == -1) {
                             return gVal.indexOf(d) !== -1;
                           }
                         }

                       });
                       // }

                       // console.log("$scope.address.state >>", $scope.address.state);
                       // if (checkarray && checkarray != "") {
                       var staids = checkarray.filter(function (st) {
                         console.log("st >>", st);
                         if (st && st != "") {
                           if ($scope.address.state.state.indexOf(gVal) == -1) {
                             return gVal.indexOf(st) !== -1;
                           }
                         }
                       });
                       // }
                       console.log("stais", staids);
                       if (staids != "") {
                         return 'yellow'
                       }

                       if (cidx != "") {
                         return 'yellow'
                       }
                     }
                     return '';
                   }
                 });*/

                  if (checkcityArray.indexOf(h) > -1) {
                    cityIdx = checkcityArray.indexOf(h);
                    //MyService.ConsoleLog("cityIdx>>", cityIdx);
                    //MyService.ConsoleLog($scope.opts);
                    //MyService.ConsoleLog($scope);
                    //MyService.ConsoleLog(grid.appScope.address);
                    //MyService.ConsoleLog($scope.address.towns);

                    $scope.opts.columnDefs.push({
                      field: h,
                      displayName: disName,
                      width: wdth,
                      enableSorting: false,
                      enableCellEdit: true,
                      headerCellTemplate: $scope.myHeaderCellTemplate,
                      cellClass: function (
                        grid,
                        row,
                        col,
                        rowRenderIndex,
                        colRenderIndex
                      ) {
                        var gVal = grid.getCellValue(row, col);
                        if (gVal) {
                          //MyService.ConsoleLog(gVal);
                          var cval = gVal.split(",")[0].trim();
                          // MyService.ConsoleLog(cval);
                          // alert('vishal');
                          var cidx = $scope.address.towns.filter(function (d) {
                            return d.indexOf(cval) !== -1;
                          });
                          if (cidx != "") {
                            return "yellow";
                          }
                        }
                        return "";
                      },
                    });
                  } else {
                    var arr = [];
                    arr.push($scope.address.county);
                    // console.log("$scope.address", $scope.address);

                    $scope.opts.columnDefs.push({
                      field: h,
                      displayName: disName,
                      minWidth: wdth,
                      enableSorting: false,
                      enableCellEdit: true,
                      enableColumnMenus: true,
                      headerCellTemplate: $scope.myHeaderCellTemplate,
                      cellClass: function (
                        grid,
                        row,
                        col,
                        rowRenderIndex,
                        colRenderIndex
                      ) {
                        var gVal = grid.getCellValue(row, col);
                        if (gVal) {
                          //MyService.ConsoleLog(gVal);
                          // console.log("grid", grid);

                          // console.log("$scope.address.city >>", $scope.address.city);
                          // console.log("$scope.address >>", $scope.address);
                          // console.log('col >>', col);

                          // console.log('row >', Object.keys(row.entity));
                          // console.log('row.entity.placeName >>', row.entity.placeName);
                          var sFields = ["state", "placeName", "countyName"];
                          // var chr;
                          var cidx = $scope.address.towns.filter(function (d) {
                            // MyService.ConsoleLog("d>", d);
                            if (d && d != "") {
                              // console.log("d >>", d);
                              // if (gVal == d) {
                              // console.log('$scope.address.towns', $scope.address.towns);
                              //   var reg = new RegExp(gVal, 'gi');
                              // }

                              // 'placeName' == col.field
                              if ("placeName" == col.field) {
                                // console.log('col.field >>>', col.field);
                                // console.log($scope.address.city.indexOf(gVal));
                                if ($scope.address.towns.indexOf(gVal) == -1) {
                                  // console.log('gval', gVal);
                                  // console.log('new search', gVal.search());

                                  return gVal.indexOf(d) == -1;
                                }
                              }
                            }
                          });

                          var sidx = arr.filter(function (item) {
                            if (item && item != "") {
                              // console.log('item >', item.countyName);
                              // console.log('col >', col.field);
                              if ("countyName" == col.field) {
                                console.log(
                                  "item.countyName",
                                  item.countyName,
                                  +" - " + gVal
                                );
                                console.log(
                                  "samp separate",
                                  item.countyName.indexOf(gVal)
                                );

                                if (gVal.indexOf(item.countyName) == -1) {
                                  return gVal.indexOf(item.countyName) == -1;
                                }
                              }
                            }
                          });
                          // console.log("sids >>", sidx);

                          var stAr = [];
                          stAr.push($scope.address.state);

                          var stat = stAr.filter(function (ds) {
                            // MyService.ConsoleLog("d>", d);
                            // console.log("d", d);
                            if (ds && ds != "") {
                              if ("state" == col.field) {
                                // console.log('col.field >', col.field);
                                // console.log('ds.state.indexOf >>', ds.state.indexOf);
                                if (ds.state.indexOf(gVal) == -1) {
                                  // console.log('Inside', gVal.indexOf(ds.state), ds.state);
                                  // console.log('Inside second', gVal.indexOf(ds));
                                  // alert('got');
                                  return ds.state.indexOf(gVal) == -1;
                                }
                              }
                            }
                          });
                          // console.log("stat >>", stat);
                          // publicMailingAddress

                          // school.push(address.)
                          //

                          var pub =
                            $scope.address.UnifiedSchoolDistrictName.filter(
                              function (e) {
                                // MyService.ConsoleLog("d>", d);
                                if (e && e != "") {
                                  if (
                                    "unifiedSchoolDistrictName" == col.field
                                  ) {
                                    // console.log('col.field >>>', col.field);
                                    // console.log($scope.address.city.indexOf(gVal));
                                    if (
                                      $scope.address.UnifiedSchoolDistrictName.indexOf(
                                        gVal
                                      ) == -1
                                    ) {
                                      // console.log('gval', gVal);
                                      // console.log('new search', gVal.search());
                                      // console.log('gVal.includes(d)', gVal.includes(d), d);
                                      // console.log('search', gVal.search(e), gVal);
                                      return gVal.search(e) == -1;
                                    }
                                  }
                                }
                              }
                            );

                          if (cidx != "") {
                            return "yellow";
                          }
                          if (sidx != "") {
                            return "yellow";
                          }
                          if (stat != "") {
                            return "yellow";
                          }
                          // console.log('pub >', pub);
                          if (pub != "") {
                            return "yellow";
                          }

                          // var ind = arr.map(function (e) {
                          //   return e.state;
                          // }).indexOf(gVal);
                          // console.log("Indx >>", ind);

                          // var sidx = $scope.address.state.state.indexOf(gVal);
                        }
                        return "";
                      },
                    });
                  }

                  // $scope.opts.columnDefs.push({ field: h, displayName: h, width: 150, enableSorting: false, enableCellEdit: true, headerCellTemplate: $scope.myHeaderCellTemplate });
                });
                //MyService.ConsoleLog($scope.opts);
                //$scope.address.places

                $scope.opts.data = vdata;

                $elm.val(null);
              });
            };

            reader.readAsBinaryString(changeEvent.target.files[0]);
          });
        },
      };
    },
  ]);

"use strict";
angular
  .module("myApp.createBanner", ["ngRoute"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/createBanner", {
        templateUrl: "app/createBanner/createBanner.html",
        controller: "createBannerCtrl",
      });
    },
  ])
  .controller("createBannerCtrl", [
    "$scope",
    "$http",
    "$location",
    "apiCall",
    "$routeParams",
    "$rootScope",
    "$q",
    "$timeout",
    "tokenService",
    "MyService",
    "growl",
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $rootScope,
      $q,
      $timeout,
      tokenService,
      MyService,
      growl
    ) {
      $scope.banner = {
        event: "",
        link: "",
        description: "",
        isActive: "",
      };

      $scope.addBanner = function () {
        if (
          $scope.banner.link &&
          $scope.banner.link != "" &&
          $scope.banner.event &&
          $scope.banner.event != ""
        ) {
          MyService.ConsoleLog("$scope.Banner", $scope.banner);
          MyService.addBannerInfo($scope.banner).then(function (APIResponse) {
            MyService.ConsoleLog(
              "TCL ->  ~ file: createBanner.js ~ line 54 ~ APIResponse",
              APIResponse
            );
            if (APIResponse.data.success) {
              $scope.banner = {
                event: "",
                link: "",
                description: "",
                isActive: "",
              };
              growl.success(APIResponse.data.data);
            }
          });
        } else {
          growl.error("Please select event type or Add the link");
        }
      };

      $scope.getBannerInfo = function () {
        MyService.getBannerInfo({ event: $scope.banner.event }).then(function (
          APIResponse
        ) {
          MyService.ConsoleLog(
            "TCL ->  ~ file: createBanner.js ~ line 75 ~ APIResponse",
            APIResponse
          );
          if (APIResponse.data.success) {
            $scope.banner.link = APIResponse.data.data.webLink;
            $scope.banner.description = APIResponse.data.data.description;
            if (APIResponse.data.data.isActive) {
              $scope.banner.isActive = "true";
            } else {
              $scope.banner.isActive = "false";
            }
          }
        });
      };
    },
  ]);

'use strict';
angular.module('myApp.createBallotThread', ['ngRoute'])
  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/createBallotThread/:bId?', {
      templateUrl: 'app/createBallotThread/createBallotThread.html',
      controller: 'createBallotThreadCtrl'
    });
  }])
  .controller('createBallotThreadCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'growl', 'tokenService', 'MyService', 'ngDialog', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, growl, tokenService, MyService, ngDialog) {

    /**
     * Params
     */
    $scope.bId = $routeParams.bId;
    MyService.ConsoleLog(" $scope.bId", $scope.bId);

    $scope.TopicButton = false;
    $rootScope.welcome = false;
    if (tokenService.getUserData()) {
      $scope.uData = JSON.parse(tokenService.getUserData());
    }
    $scope.uId = $routeParams.bId;
    if (window.localStorage.getItem("ballotThreadData") != "") {
      $rootScope.ballotThreadData = JSON.parse(window.localStorage.getItem("ballotThreadData"));
    }

    $scope.location = ['National', 'State', 'County', 'Local'];
    $scope.ShowLocationOptions = false;
    $scope.Topic = {
      title: '',
      description: '',
      location: 'National',
      restrictedTo: 'No Restrictions',
    };
    $scope.restrictedOptions = ['Locals Only', 'My County', 'My State', 'National', 'No Restrictions'];


    var current_url = $location.url();
    MyService.ConsoleLog("asndkadakd", $rootScope.ballotThreadData);
    if (!$routeParams.categoryId && $rootScope.ballotThreadData) {
      angular.forEach($rootScope.ballotThreadData.users, function (val, key) {
        MyService.ConsoleLog("key: ", val);
        if (val._id == $rootScope.ballotThreadData.selected_user._id) {
          val.selected = true;
        }
      });
    }

    if (window.localStorage.getItem("VoteWiseCategory")) {
      $rootScope.allcategories = JSON.parse(window.localStorage.getItem("VoteWiseCategory"));
      var idx = $rootScope.allcategories.indexOf($routeParams.subcatId);
      if (idx == -1) {
        $rootScope.allcategories.push($routeParams.subcatId);
        window.localStorage.setItem("VoteWiseCategory", JSON.stringify($rootScope.allcategories));
      }
    }
    //MyService.ConsoleLog("Final categories : ", window.localStorage.getItem("VoteWiseCategory"));
    $scope.subtopics = {
      subcategories: []
    };

    $scope.selectedCat = [];
    $scope.SelectedTree = [];
    $scope.disabled = [];
    $scope.getVal = function (data) {
      MyService.ConsoleLog(" getVal :", data);
      var idx = $scope.selectedCat.indexOf(data);
      if (idx > -1) {
        $scope.selectedCat.splice(idx, 1);
        var id = $scope.disabled.indexOf(data._id);
        $scope.disabled.splice(id, 1);
        var jdx = $scope.SelectedTree.indexOf(data.parentIds);
        if (jdx > -1)
          $scope.SelectedTree.splice(jdx, 1);

      } else {
        $scope.selectedCat.push(data);
        var id = $scope.disabled.indexOf(data._id);
        if (id == -1) {
          $scope.disabled.push(data._id);
        }
        //MyService.ConsoleLog(data.parentIds);
        //MyService.ConsoleLog("SelectedTree: ", $scope.SelectedTree);
        if ($scope.SelectedTree.length == 0) {
          if (data.parentIds.length > 0) {
            //var parents = Object.keys(data.parentIds).map(function (key) {return data.parentIds[key]});
            //angular.copy(data.parentIds, $scope.SelectedTree);
            var parents = data.parentIds;
            //MyService.ConsoleLog(parents);
            $scope.SelectedTree = parents;
          } else {
            var cobj = new Object;
            cobj.pid = data._id;
            cobj.viewOrder = 1;
            cobj.path = "," + data._id + ",";
            $scope.SelectedTree.push(cobj);
            //"pid":"57987dfb31411a7f224cf01e","viewOrder":6,"path":",57987dfb31411a7f224cf01e,"
          }
        } else {
          if (data.parentIds.length > 0) {
            //var parents = Object.keys(data.parentIds).map(function (key) {return data.parentIds[key]});
            var parents = angular.copy(data.parentIds);
            //var parents = data.parentIds;
            var plen = parents.length;
            for (var j = 0; j < plen; j++) {
              var jdx = indexOfExt($scope.SelectedTree, parents[j]);
              //MyService.ConsoleLog(jdx);
              if (jdx == -1) {
                $scope.SelectedTree.push(parents[j]);
              }
            }
          } else {
            var cobj = new Object;
            cobj.pid = data._id;
            cobj.viewOrder = 1;
            cobj.path = "," + data._id + ",";
            $scope.SelectedTree.push(cobj);
            //"pid":"57987dfb31411a7f224cf01e","viewOrder":6,"path":",57987dfb31411a7f224cf01e,"
          }
        }
      }
      //MyService.ConsoleLog($scope.SelectedTree);
    }


    $scope.selectedAll = {
      id: []
    };
    $scope.removeVal = function (data) {
      var idx = $scope.selectedCat.indexOf(data);
      if (idx > -1) {
        $scope.selectedCat.splice(idx, 1);
        var id = $scope.disabled.indexOf(data._id);
        $scope.disabled.splice(id, 1);
        var parents = data.parentIds;
        var plen = parents.length;
        for (var j = 0; j < plen; j++) {
          var jdx = $scope.SelectedTree.indexOf(parents[j]);
          if (jdx > -1)
            $scope.SelectedTree.splice(jdx, 1);
        }
      }
      $scope.selectedAll.id.length = 0;
      //MyService.ConsoleLog($scope.SelectedTree);
      var allLen = $scope.SelectedTree.length;
      var chkboxe = document.getElementsByName("checkedidcat");
      for (var i = 0; i < allLen; i++) {
        chkboxe[i].checked = true;

      }
    }

    $scope.selectConfig = {
      requiredMin: 1,
      selectAll: true
    };

    function areEqual() {
      var len = arguments.length;
      for (var i = 1; i < len; i++) {
        if (arguments[i] == null || arguments[i] != arguments[i - 1])
          return false;
      }
      return true;
    }

    function indexOfExt(list, item) {
      var len = list.length;

      for (var i = 0; i < len; i++) {
        var keys = Object.keys(list[i]);
        var flg = true;
        var arr = [];
        for (var j = 0, s = 1; j < keys.length; j++, s++) {
          var value = list[i][keys[j]];
          //MyService.ConsoleLog("value :" + value + "-----Item : " + item[keys[j]]);
          //MyService.ConsoleLog(typeof value + "===" + typeof item[keys[j]]);
          if ((typeof value != "object") && (typeof item[keys[j]] != "object")) {
            if (item[keys[j]] !== value) {
              flg = false;
              //MyService.ConsoleLog("flg : ", typeof item[keys[j]], typeof value);
            }
          }
          if (item[keys[j]] == value) {
            arr.push(flg);
          } else if ((typeof value == "object") && (typeof item[keys[j]] == "object")) {
            arr.push(flg);
          }


        }
        if (flg == true) {
          //MyService.ConsoleLog(arr.length + "-----" + keys.length + "-----" + Object.keys(item).length);
          if (areEqual(arr.length, keys.length, Object.keys(item).length)) {
            return i;
          }

        }


      }
      return -1;
    }

    $scope.checksubCatExists = function (rdata, val) {
      return rdata.filter(
        function (rdata) {
          if (rdata.pid) {
            var idx = indexOfExt($scope.selectedCat, val);

            if (idx == -1) {
              $scope.selectedCat.push(val);
            }
            return rdata
          }

        }
      );
    }

    $scope.checkCatExists = function (rdata, val) {
      return rdata.filter(
        function (rdata) {
          if (rdata._id == val) {
            //MyService.ConsoleLog("parentIds : ", rdata.parentIds.length);
            if (rdata.parentIds.length > 0) {
              var parents = rdata.parentIds.length;
              for (var j = 0; j < parents; j++) {
                var newd = angular.copy(rdata.parentIds[j]);
                //MyService.ConsoleLog("newd:", newd);
                //MyService.ConsoleLog("SelectedTree:", $scope.SelectedTree);
                var jdx = indexOfExt($scope.SelectedTree, newd);
                //MyService.ConsoleLog(jdx);
                if (jdx == -1) {
                  $scope.SelectedTree.push(newd);
                }
              }
            }
            if (rdata.parentIds.length > 1) {
              var idx = indexOfExt($scope.selectedCat, angular.copy(rdata));
              if (idx == -1) {
                $scope.selectedCat.push(angular.copy(rdata));
              }
            } else {
              $scope.selectedCat.push(angular.copy(rdata));
            }
            return rdata;
          } else if (rdata.subcategories) {
            $scope.checkCatExists(rdata.subcategories, val)
          }
        }
      );
    }

    $scope.getSubcatTree = function () {
      $scope.selectedCat.length = 0;
      $scope.EssayButton = true;
      MyService.getAllCatTree({
        "type": "F"
      }).then(function (payload) {
          $scope.subtopics.subcategories.length = 0;
          var subcatdata = payload;
          //MyService.ConsoleLog("subcatdata : ", subcatdata);
          $scope.disabled.length = 0;
          //$scope.disabled.push(window.localStorage.getItem("VoteWiseParentCategory"));
          $scope.subtopics.subcategories = subcatdata;
          if ($routeParams.categoryId) {
            $scope.disabled = JSON.parse(window.localStorage.getItem("VoteWiseCategory"));
            //MyService.ConsoleLog("subcat : ", $scope.disabled);
            var selectedCat = JSON.parse(window.localStorage.getItem("VoteWiseCategory"));
            if (selectedCat.length > 0) {
              for (var s = 0; s < selectedCat.length; s++) {
                var checkcatdata = $scope.checkCatExists(subcatdata, selectedCat[s]);
              }
              //MyService.ConsoleLog($scope.selectedCat);
              //$scope.SelectedTree = angular.copy($scope.selectedCat);
            }
            $scope.EssayButton = false;
            setTimeout(function () {
              var cols = document.getElementsByClassName('cmnUL');
              var clen = cols.length;
              for (var i = 0; i < clen; i++) {
                cols[i].style.display = "none";
              }
            }, 300);
          } else {
            MyService.ConsoleLog("* Inside else *");
            angular.forEach($scope.subtopics.subcategories, function (val, key) {
              if (val.title && val.title.toLowerCase() == "ballot measure") {
                $scope.disabled = [val._id];
                // var checkcatdata = $scope.checkCatExists(subcatdata, val);
                $scope.selectedCat.push(val);
              }
            });
          }
        },
        function (errorPayload) {
          alert('Something went wrong ');
        });
    }

    $scope.showSubCat = true;
    $scope.showLoading = [];
    $scope.showLoadingCounty = [];
    $scope.showDown = [];
    $scope.ChangeShow = function (id) {
      //$scope.showSubCat = true;
      //var cols = document.getElementsByClassName('cmnUL');
      //var clen = cols.length;
      var nclass = "MainCatLi_" + id;
      if ((document.getElementsByClassName(nclass)[0].style.display) && (document.getElementsByClassName(nclass)[0].style.display == "none")) {
        document.getElementsByClassName(nclass)[0].style.display = "block";
      } else {
        document.getElementsByClassName(nclass)[0].style.display = "none";
      }
    }

    $scope.AddLocation = false;
    $scope.newlocation = {
      country: ''
    };
    $scope.Allcountries = [];
    $scope.SelectedCountry = '';

    $scope.ShowAddLocation = function () {
      if (!$scope.AddLocation) {
        $scope.AddLocation = true;
      } else {
        $scope.AddLocation = false;
      }

    }

    function suggest_country(term) {
      var q = term.toLowerCase().trim();
      var results = [];
      var len = $scope.Allcountries.length;
      // Find first 10 states that start with `term`.
      for (var i = 0; i < len && results.length < 10; i++) {
        var country = $scope.Allcountries[i];
        if (country.toLowerCase().indexOf(q) === 0)
          results.push({
            label: country,
            value: country
          });
      }
      return results;
    }

    $scope.autocomplete_options = {
      suggest: suggest_country
    };

    $scope.getAllStates = function () {
      MyService.getAllStates().then(function (payload) {
          $scope.allLocations.length = 0;
          var subcatdata = payload;
          //MyService.ConsoleLog("countires : ", subcatdata);
          $scope.allLocations = subcatdata;
        },
        function (errorPayload) {
          alert('Something went wrong ');
        });

    }
    $scope.getAllStates();

    // var fetchPoliticiansByStateCanceler = $q.defer();
    $scope.statusfetchPoliticiansByState = 0;
    $scope.fetchPoliticiansByState = function (selState, idx) {
      //MyService.ConsoleLog("selState: ", selState);
      // fetchPoliticiansByStateCanceler.resolve();
      // fetchPoliticiansByStateCanceler = $q.defer();
      // $scope.statusfetchPoliticiansByState = 1;
      // $scope.politicians = [];
      //MyService.ConsoleLog("selState.loadPolitician: ", selState.loadPolitician);
      if (selState.loadPolitician == false) {
        //MyService.ConsoleLog("* this is false *");
        $scope.allLocations[idx].politicians = [];
        return;
      }
      $scope.allLocations[idx].getPolStatus = 1;
      MyService.getPoliticianLocWise({
        statePostalCode: selState.statePostalCode
      }, null).then(function (response) {
        if (response.data.success) {
          // $scope.politicians = response.data.data;
          // $scope.statusfetchPoliticiansByState = 2;
          $scope.allLocations[idx].politicians = response.data.data;
          $scope.allLocations[idx].getPolStatus = 2;
        } else if (response.data.error && typeof response.data.error == "string") {
          growl.error('Error: ' + response.data.error);
          // $scope.statusfetchPoliticiansByState = 3;
          $scope.allLocations[idx].getPolStatus = 3;
        } else {
          growl.error('Something went wrong.');
          // $scope.statusfetchPoliticiansByState = 3;
          $scope.allLocations[idx].getPolStatus = 3;
        }
      }, function (err) {
        growl.error('Something went wrong.');
        // $scope.statusfetchPoliticiansByState = 3;
        $scope.allLocations[idx].getPolStatus = 3;
      });
    };
    $scope.selectUsersFromGroup = function (usres, flag) {
      angular.forEach(usres, function (val, key) {
        val.selected = flag;
      });
    };

    $scope.allLocations = [];
    $scope.allCounties = [];
    $scope.selectedArea = [];
    $scope.rmselectedArea = [];
    $scope.myselectionarea = [];
    $scope.disabledLocation = [];

    $scope.checkExists = function (rdata, val) {
      return rdata.filter(
        function (rdata) {
          if (rdata.state == val)
            return rdata
        }
      );
    }

    $scope.checkCountyExists = function (rdata, val) {
      return rdata.filter(
        function (rdata) {
          if (rdata.county == val)
            return rdata
        }
      );
    }

    $scope.checkCountryExists = function (rdata, val) {
      return rdata.filter(
        function (rdata) {
          if (rdata.country == val)
            return rdata
        }
      );
    }

    $scope.checkDisabled = function (data, stateId, type) {

      data.country = "United States of America";
      data.state = stateId;

      var idx = indexOfExt($scope.disabledLocation, data);
      if (idx > -1)
        return true;
      else
        return false;


    }

    $scope.getAreaVal = function (data, stateId, type) {

      if (!data.country) {
        data.country = "United States of America";
      }
      if (!data.state) {
        data.state = stateId;
      }



      var idx = indexOfExt($scope.selectedArea, data);


      if (idx > -1) {
        alert("You have already selected the location");
      } else {

        $scope.selectedArea.push(data);
        $scope.disabledLocation.push(data);

      }

      //MyService.ConsoleLog($scope.disabledLocation);
    }
    $scope.selectedLAll = {
      id: []
    };
    $scope.removeAreaVal = function (data) {
      var idx = $scope.selectedArea.indexOf(data);

      //MyService.ConsoleLog($scope.Topic.Locations);
      if (idx > -1) {
        //MyService.ConsoleLog("Country:",$scope.selectedArea[idx].country);
        if ($scope.selectedArea[idx].country == "International") {
          $scope.Topic.Locations = 'NO';
        }
        if ($scope.selectedArea[idx].country == "National (USA)") {
          $scope.Topic.National = 'NO';
        }
        $scope.selectedArea.splice(idx, 1);
        var jdx = $scope.disabledLocation.indexOf(data);
        if (jdx > -1) {
          $scope.disabledLocation.splice(jdx, 1);
        }
      }
      $scope.selectedLAll.id.length = 0;
      //MyService.ConsoleLog($scope.selectedArea);
      var allLen = $scope.selectedArea.length;
      var chkboxe = document.getElementsByName("checkedid");
      for (var i = 0; i < allLen; i++) {
        chkboxe[i].checked = true;

      }

    }
    $scope.allCounties = [];
    $scope.allLocals = [];
    $scope.setLocation = function (option) {
      $scope.Essay.location = option;
    }
    $scope.getLocations = function (val, type) {
      if (type == "National") {
        if (val == "National") {

          var nobj = {
            country: "National (USA)"
          }
          $scope.selectedArea.push(nobj);
          //MyService.ConsoleLog($scope.selectedArea);
        }
        if (val == "NO") {

          var nobj = {
            country: "National (USA)"
          }
          var idx = indexOfExt($scope.selectedArea, nobj);
          if (idx > -1) {
            $scope.selectedArea.splice(idx, 1);
          }
        }
      } else if (type == "International") {
        if (val == "International") {
          // $scope.selectedArea.length = 0;
          var nobj = {
            country: "International"
          }
          $scope.selectedArea.push(nobj);

        }
        if (val == "NO") {
          // $scope.selectedArea.length = 0;
          var nobj = {
            country: "International"
          }
          var idx = indexOfExt($scope.selectedArea, nobj);
          if (idx > -1) {
            $scope.selectedArea.splice(idx, 1);
          }
        }
      }
    }

    $scope.AddCountry = function () {
      if (($scope.newlocation.country) && ($scope.newlocation.country != '')) {
        var idx = $scope.Allcountries.indexOf($scope.newlocation.country);
        if (idx > -1) {
          var nobj = {
            country: $scope.newlocation.country
          };
          $scope.selectedArea.push(nobj);
        } else {
          alert("Country does not exists in our database. Please check if you have entered correct name.");
        }
      } else {
        alert("Please enter country name");
      }
    }

    $scope.getCounties = function (state) {
      console.log(state);
      $scope.showLoading.push(state);
      if (!$scope.allCounties[state] || $scope.allCounties[state].length == 0) {
        MyService.getAllCounties(state).then(function (payload) {
            $scope.showLoading.length = 0;
            var sublocations = payload;
            if (!$scope.allCounties) {
              $scope.allCounties = [];
            }
            $scope.allCounties[state] = sublocations;
          },
          function (errorPayload) {
            alert('Something went wrong.');
          });

      } else {
        $scope.showLoading.length = 0;
        $scope.allCounties[state].length = 0;
      }
    }

    $scope.getLocals = function (state, county) {
      $scope.showLoadingCounty.push(county);
      if (!$scope.allLocals[state] || !$scope.allLocals[state][county] || $scope.allLocals[state][county].length == 0) {
        MyService.getAllSubCountiesLocal(state, '', county).then(function (payload) {
            $scope.showLoadingCounty.length = 0;
            MyService.ConsoleLog("payload Locals : ", payload);
            if (!$scope.allLocals[state]) {
              $scope.allLocals[state] = [];
            }
            $scope.allLocals[state][county] = payload.places;
          },
          function (errorPayload) {
            alert('Something went wrong ');
          });
      } else {
        $scope.showLoadingCounty.length = 0;
        $scope.allLocals[state][county].length = 0;
      }
    }

    $scope.ShowLocation = function () {
      $scope.ShowLocationOptions = true;
      MyService.getAllCountries().then(function (payload) {
          $scope.Allcountries = payload;
        },
        function (errorPayload) {
          alert('Something went wrong ');
        });
      $scope.getAllStates();
    }

    $scope.SubmitTopic = function (data) {
      if ($.fn.validateForceFully($("#topicform")) == true) {
        //$scope.TopicButton = true;
        MyService.ConsoleLog("first", $scope.disabled);
        data.parentcat = JSON.stringify($scope.disabled);
        if ($scope.curState == "createBallotThread" && $scope.disabled <= 0) {
          growl.error("There must be a root category to with title 'Ballot Measure'.");
          return;
        }
        var subcat = [];
        if ($scope.curState == "createBallotThread" && $scope.disabled <= 0) {
          subcat = JSON.stringify($scope.disabled);
        } else {
          subcat = JSON.stringify($scope.SelectedTree);
        }

        data.subcategories = subcat;
        data.createdById = tokenService.getUserId();
        data.createdByName = tokenService.getUserName();
        data.createdByType = tokenService.getUserRole();
        if ($scope.selectedArea.length > 0) {
          data.location = JSON.stringify($scope.selectedArea);
        } else {
          var arr = [];
          var acountry = "";
          if ($scope.uData) {
            if ($scope.uData.address.country == null) {
              acountry = "United States of America";
            } else {
              acountry = $scope.uData.address.country;
            }
            var obj = {
              country: acountry,
              state: $scope.uData.address.state,
              statePostalCode: $scope.uData.address.statePostalCode,
              county: $scope.uData.address.county,
              countySubdivision: $scope.uData.address.countySubdivision,
              place: $scope.uData.address.place
            };
            arr.push(obj);
            data.location = JSON.stringify(arr);
          }
        }


        //MyService.ConsoleLog(data);
        //MyService.ConsoleLog($scope.selectedArea);

        var tempballotids = [];
        try {
          //MyService.ConsoleLog("catch: ", $rootScope.politicianThreadData.users.length);
          angular.forEach($rootScope.ballotThreadData.users, function (pol, key) {
            //MyService.ConsoleLog("key: ", key);
            if (pol.selected) {
              tempballotids.push(pol._id);
            }
          });
        } catch (e) {
          //MyService.ConsoleLog("politicians thread exception: ", e);
        }
        if ($scope.curState == "createBallotThread" && tempballotids.length <= 0) {
          growl.error("Please select at least one politician.");
          return;
        }
        data.taggedUsers = tempballotids.join(",");
        MyService.ConsoleLog("data: ", data);


        var request = apiCall.apiCall('POST', '/topics/create', data);
        $http(
          request
        ).then(function successCallback(response) {
            MyService.ConsoleLog("Got categories: ", response);
            $scope.TopicButton = true;
            if (response.data.success) {
              if (!window.localStorage.getItem("VoteWiseParentCategory")) {
                MyService.ConsoleLog("response.data.data", response.data.data);
                MyService.ConsoleLog(response.data.data.parentCat[0]);
                if ($routeParams.categoryId && $routeParams.subcatId) {
                  $location.path("/forum/" + response.data.data.parentCat[0] + "/home");
                } else {
                  // alert('one');
                  $location.path('/ballotThread/' + $scope.uId);
                }

              } else {

                var cat = window.localStorage.getItem("VoteWiseParentCategory") || null;
                MyService.ConsoleLog(" window.localStorage.getIte", cat);
                MyService.ConsoleLog(" window.localStorage.getIte", cat);

                if (cat != 'undefined') {
                  MyService.ConsoleLog("$$$$$$$$ IF $$$$$$$$$");
                  if ($routeParams.categoryId && $routeParams.subcatId) {
                    $location.path("/forum/" + window.localStorage.getItem("VoteWiseParentCategory") + "/home");
                  } else {
                    // alert('two');
                    $location.path('/ballotThread/' + $scope.uId);
                  }
                } else {
                  MyService.ConsoleLog("$$$$$$$$ ELSE $$$$$$$$$");
                  if ($routeParams.categoryId && $routeParams.subcatId) {

                    $location.path("/forum/" + response.data.data.parentCat[0] + "/home");
                  } else {
                    // alert('three');
                  }
                }

              }

            } else {
              if (response.data.error) {
                alert(response.data.error);
                //MyService.ConsoleLog(response.data);
                if ((response.data.status) && (response.data.status == "405")) {
                  var msg = "Do you want to send request to Admin to reactivate your account?.";
                  MyService.GetDialogWithButtons(ngDialog, msg, "YES", "NO").then(function (payload) {
                    MyService.sendActivatationMailtoAdmin().then(function (payload) {
                      alert("Request sent successfully to admin");
                    }, function (errorPayload) {
                      alert("Something went wrong");
                    })
                  }, function (errorPayload) {
                    //MyService.ConsoleLog(errorPayload);
                  });
                }
              }
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
          });
      }
    };

    $scope.goBack = function () {
      $location.path('/ballotThread/' + $scope.uId);
    }

    if (!$rootScope.UserId) {
      var message = "Please login first.";

      var modal = ngDialog.openConfirm({
        template: '<p>' + message + '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
        plain: true
      });

      modal.then(function fullfilled(data) {
        //MyService.ConsoleLog("fullfilled: ", data);
        $location.path('signin');
      }, function rejected(data) {
        //MyService.ConsoleLog("rejected: ", data);
        $location.path('signin');
      });
    } else {
      $scope.getSubcatTree();
    }
    $("#topicform").validationEngine();

  }]);

'use strict';

angular.module('myApp.contactUs', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
     $routeProvider.when('/contactUs', {
         templateUrl: 'app/contactUs/contactUs.html',
         reloadOnSearch: false,
         controller: 'contactUsCtrl' 
     });
}])
.controller('contactUsCtrl', ['$scope', '$rootScope', function($scope, $rootScope) {
$rootScope.welcome = false;
}]);

'use strict';
angular
  .module('myApp.compositeQuiz', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/compositeQuiz/:orgId?/:quizName?', {
        templateUrl: 'app/compositeQuiz/compositeQuiz.html',
        controller: 'compositeQuizCtrl',
      });
    },
  ])
  .controller('compositeQuizCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    '$routeParams',
    '$q',
    'ngDialog',
    '$rootScope',
    'growl',
    'MyService',
    '$anchorScroll',
    '$timeout',
    'tokenService',
    '$cookies',
    'baseApiUrl',
    '$document',
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $q,
      ngDialog,
      $rootScope,
      growl,
      MyService,
      $anchorScroll,
      $timeout,
      tokenService,
      $cookies,
      baseApiUrl,
      $document
    ) {
      $scope.view = [];
      $scope.viewTwo = [];
      $scope.selectedCat = [];
      $scope.subtopics = {
        subcategories: [],
      };
      $scope.disabled = [];
      $scope.allLocations = [];
      $scope.allCounties = [];
      $scope.selectedArea = [];
      $scope.rmselectedArea = [];
      $scope.myselectionarea = [];
      $scope.disabledLocation = [];
      $scope.mainCatTree = [];
      $scope.AllStates = [];
      $scope.allCounties = [];
      $scope.allLocals = [];
      $scope.showLoading = [];
      $scope.showLoadingCounty = [];
      $scope.showDown = [];
      $scope.showLoading = [];
      $scope.showLoadingCounty = [];
      $scope.showDown = [];
      $scope.Interests = [];
      $scope.compositeQuiz = [];
      $scope.findLocations = [];
      $scope.Interests = [];
      $scope.MyLocation = [];
      $scope.Location = ["International", "National", "My State", "My County", "My Local", "Other Specific"];


      $scope.selectConfig = {
        requiredMin: 1,
        selectAll: true,
      };

      $scope.queUp = false;
      $scope.queDown = false;
      $scope.unAnsUp = false;
      $scope.unAnsDown = false;
      $scope.isInvited = false;
      $scope.checkCount = false;
      $scope.descrised = false;
      $scope.isShowFilter = false;
      $scope.ShowSubcatTree = false;
      $scope.showRefineLocation = false;

      $scope.showSubCat = true;

      $scope.currPage = 1;
      $scope.selectedQuestions = 0;
      $scope.statusGetResPg = 0;
      $scope.loadernew = false;

      /**
       * Get orgId using route params
       */

      $scope.orgId = $routeParams.orgId;
      $scope.quizName = $routeParams.quizName;
      $scope.userId = tokenService.getUserId();

      MyService.ConsoleLog('$scope.orgId', $scope.orgId);
      // $scope.selectedQuestions = '';

      if ($scope.quizName && $scope.quizName != '') {
        $scope.isInvited = true;
      }

      window.localStorage.removeItem('queIds');
      $cookies.remove('advId');
      $cookies.remove('showBanner');
      $cookies.remove('quizName');


      /**
       * Show all the quizzes created by orgs
       */
      $scope.getShowAll = function () {

        MyService.showAllQuizzes().then(function (response) {
          MyService.ConsoleLog("response", response);
          MyService.getCatForQuiz({
            quizData: JSON.stringify(response.data.data.quizData)
          }).then(function (APIResponse) {
            MyService.ConsoleLog("API", APIResponse);
            $scope.compositeQuiz = $scope.compositeQuiz.concat(APIResponse.data.data);
            $scope.totleRecords = response.data.data.totalRecords;

            if ($scope.orgData && $scope.orgData.length > 0) {
              var lens = $scope.orgData.length;
              $scope.compositeQuiz.filter(function (itms) {
                for (var i = 0; i < lens; i++) {
                  // MyService.ConsoleLog("vvvv", itms.orgId + " == " + $scope.orgData[i].orgId + "    " + itms.quizName + "     " + $scope.orgData[i].quizName);
                  if (itms.orgId == $scope.orgData[i].orgId && itms.quizName == $scope.orgData[i].quizName) {
                    itms.isInvited = true;
                  }
                }
                return itms;
              });
            }
            $scope.loadernew = false;
            // $scope.statusGetResPg = 2;
          }, function (err) {
            MyService.ConsoleLog("Error", err);
          });
        }, function (err) {
          MyService.ConsoleLog("Error", err);
        });
      };


      $scope.checkIfInvited = function () {
        MyService.checkIfInvited().then(function (APIResponse) {
          MyService.ConsoleLog("APIResponse", APIResponse);
          if (APIResponse.data.success) {
            $scope.orgData = APIResponse.data.data;
            MyService.ConsoleLog("$scope.orgData", $scope.orgData);
            $scope.getShowAll();
          } else {
            var message = 'No organizations have yet invited you to take a quiz.Would you like to see their quizzes anyway ?';
            var modal = ngDialog.openConfirm({
              template: '<p>' +
                message +
                '</p>\
              <div class="ngdialog-buttons">\
                  <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Yes</button>\
                  <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(0)">No</button>\
              </div>',
              plain: true,
              closeByDocument: false,
            });
            modal.then(
              function fullfilled(data) {
                // MyService.ConsoleLog("fullfilled: ", data);
                $scope.getShowAll();
              },
              function rejected(data) {

              }
            );
          }
        }, function (err) {
          MyService.ConsoleLog("err", err);
        });
      };

      /**
       * Get Quiz details for composite quiz
       */
      $scope.filterCanceler = $q.defer();
      $scope.getAllCanceller = $q.defer();

      $scope.getQuizDetails = function (pageNumber) {
        // $scope.compositeQuiz = [];
        $scope.loadernew = true;
        MyService.ConsoleLog("$scope.Interest", $scope.Interests);
        // alert('call');
        var obj = {};
        obj.orgId = $scope.orgId;
        obj.quizName = $scope.quizName;
        obj.page = pageNumber;
        obj.max_records = 30;
        $scope.statusGetResPg = 1;
        if ($scope.Interests && $scope.Interests.length > 0 || $scope.findLocations && $scope.findLocations.length > 0 || $scope.MyLocation && $scope.MyLocation.length > 0) {
          obj.interest = JSON.stringify($scope.Interests);
          obj.areaOfInterest = JSON.stringify($scope.findLocations);
          obj.MyLocation = JSON.stringify($scope.MyLocation);
          // MyService.ConsoleLog("obj", obj);
          MyService.getFilterQuizzes(obj, $scope.filterCanceler).then(function (response) {
            MyService.ConsoleLog("response", response);
            if (response && response.data.quizData && response.data.quizData.length > 0) {
              $scope.compositeQuiz = $scope.compositeQuiz.concat(response.data.quizData);
              $scope.totleRecords = response.data.totalRecords;
              $scope.statusGetResPg = 2;
            } else {
              growl.error("Quizzes not found for this topic");
            }
          }, function (err) {
            MyService.ConsoleLog("Error", err);
            $scope.statusGetResPg = 3;
            // $scope.statusGetResPg = 1;
            $scope.currPage--;
            growl.error("Quizzes not found for this search", {
              ttl: 2000
            });
            // $scope.getQuizDetails($scope.currPage);
          });

        } else {
          MyService.ConsoleLog("<<<<<<<<<<<<<<<< inside >>>>>>>>>>>>>>>>>");
          MyService.getQuizDetailsFor(obj, $scope.getAllCanceller).then(
            function (result) {
              MyService.ConsoleLog('result', result);
              // MyService.ConsoleLog("<<<<<<<<<<<< ONe more Inside");
              if (result && result.data.quizData && result.data.quizData.length > 0) {

                $scope.compositeQuiz = $scope.compositeQuiz.concat(result.data.quizData);
                $scope.totleRecords = result.data.totalRecords;
                $scope.statusGetResPg = 2;
              } else {
                // growl.error("Quizzes not found");
                $scope.checkIfInvited();

              }
            },
            function (err) {
              MyService.ConsoleLog('Error', err);
              growl.error(err);
              $scope.statusGetResPg = 3;
              $scope.currPage--;
            }
          );
        }
      };

      $scope.pageFunction = function () {
        // MyService.ConsoleLog("$scope.statusGetResPg >>>>>>", $scope.statusGetResPg);
        if ($scope.statusGetResPg != 1 && $scope.totleRecords > $scope.compositeQuiz.length) {
          $scope.currPage++;
          $scope.changedPage($scope.currPage);
        }
      };

      $scope.changedPage = function (newPage) {
        if ($scope.statusGetResPg != 3) {
          $scope.getQuizDetails(newPage);

        }
      };



      $scope.toggleList = function () {
        $scope.isInvited = !$scope.isInvited;
        if ($scope.isInvited == true) {
          var tmp = $scope.compositeQuiz.filter(function (itms) {

            // MyService.ConsoleLog(typeof itms.isInvited);
            if (itms.isInvited == true) {
              return itms;
            }
            // MyService.ConsoleLog("itms", itms);

          });
          $scope.compositeQuiz = [];
          $scope.compositeQuiz = tmp;
          MyService.ConsoleLog("tmp", tmp.length)
        } else {
          $scope.compositeQuiz = [];
          $scope.getQuizDetails(1);
        }

      };

      /**
       * Filter Quiz
       */

      // $scope.getItems = function () {
      //   return function (u) {
      //     if ($scope.isInvited == true) {
      //       // alert("inside");
      //       if (u.quizName == $scope.quizName) {
      //         u.isInvited = true;
      //         return u;
      //       }
      //     } else {
      //       // u.isInvited = false;
      //       MyService.ConsoleLog("one")
      //       return u;
      //     }
      //   };
      // };

      /**
       * Select quiz
       */
      $scope.uArr = [];
      $scope.unAnsArr = [];
      $scope.select = function (oid, qName, val) {
        var obj = {};

        if ($scope.uArr.length > 0) {
          obj.orgId = oid;
          obj.quizName = qName;
          var id = $scope.uArr.findIndex(function (x) {
            MyService.ConsoleLog('x', x);
            return x.orgId == oid && x.quizName == qName;
          });
          MyService.ConsoleLog('id', id);
          if (id == -1) {
            $scope.uArr.push(obj);
            $scope.checkCount = true;
            $scope.descrised = false;
            $scope.showQuestions(obj);

            // $scope.selectedQuestions += $scope.quesCount;
          } else {
            $scope.descrised = true;
            $scope.checkCount = true;
            $scope.showQuestions(obj);
            $scope.uArr.splice(id, 1);
          }
        } else {
          obj.orgId = oid;
          obj.quizName = qName;
          $scope.checkCount = true;
          $scope.descrised = false;
          $scope.uArr.push(obj);
          $scope.showQuestions(obj);
        }

        if ($scope.unAnsArr.length > 0) {
          val.unAnsweredQuesData.filter(function (itms) {
            var ids = $scope.unAnsArr.indexOf(itms);
            MyService.ConsoleLog('val.unAnsweredQuesData', ids);
            if (ids == -1) {
              $scope.unAnsArr = $scope.unAnsArr.concat(val.unAnsweredQuesData);
            } else {
              $scope.unAnsArr.splice(ids, 1);
            }
          });
        } else {
          $scope.unAnsArr = $scope.unAnsArr.concat(val.unAnsweredQuesData);
        }
        var unAnsQIds = $scope.unAnsArr.map(function (itms) {
          if (itms && itms.queId) {
            return itms.queId;
          }
        });
        MyService.ConsoleLog("unAnsQIds", unAnsQIds.length);
        $scope.unAnsCount = unAnsQIds.filter(function (itm, ind) {
          return ind == unAnsQIds.findIndex(function (ele) {
            return JSON.stringify(ele) == JSON.stringify(itm);
          });
        });

      };

      /**
       * Select and deselect All quizzes
       */
      $scope.isSelected = false;
      var tempObj = {};
      $scope.SelectChecks = function () {
        //alert($scope.isSelected);
        $scope.unAnsArr = [];
        if ($scope.isSelected == false) {
          $scope.isSelected = true;
          // angular.forEach($scope.compositeQuiz, function(val, key) {
          $scope.uArr = $scope.compositeQuiz.filter(function (val) {
            // MyService.ConsoleLog("val", val);
            $scope.unAnsArr = $scope.unAnsArr.concat(val.unAnsweredQuesData);
            val.isSelected = true;
            tempObj.orgId = val.orgId;
            tempObj.quizName = val.quizName;
            tempObj.unAnsweredQues = val.unAnsweredQues;
            $scope.checkCount = true;
            $scope.descrised = false;
            $scope.showQuestions(tempObj);
            return tempObj;
            // $scope.uArr.push(tempObj);
          });
          MyService.ConsoleLog(' $scope.unAnsArr', $scope.unAnsArr);
          var unAnsQIds = $scope.unAnsArr.map(function (itms) {
            if (itms && itms.queId) {
              return itms.queId;
            }
          });
          MyService.ConsoleLog("unAnsQIds", unAnsQIds.length);
          $scope.unAnsCount = unAnsQIds.filter(function (itm, ind) {
            return ind == unAnsQIds.findIndex(function (ele) {
              return JSON.stringify(ele) == JSON.stringify(itm);
            });
          });
          MyService.ConsoleLog("$scope.unAnsCount", $scope.unAnsCount.length);
        } else {
          $scope.isSelected = false;
          angular.forEach($scope.compositeQuiz, function (val, key) {
            val.isSelected = false;
            $scope.uArr = [];
            $scope.selectedQuestions = 0;
            // MyService.ConsoleLog(' else', $scope.uArr);
          });
        }
      };

      /**
       * Show questions
       */
      $scope.showQuestions = function (val, show) {
        $scope.idsArr = [];
        // MyService.ConsoleLog("showQuestions val", val);
        if (show && show != '') {
          $scope.checkCount = false;
        }
        MyService.ConsoleLog('val', val);
        $scope.view = [];
        $scope.viewTwo = [];
        MyService.getSelectedQues({
          orgId: val.orgId,
          quizName: val.quizName,
        }).then(
          function (result) {
            MyService.ConsoleLog('result', result.data.data);
            // var len = result.data.data.length;
            // for (var i = 0; i < len; i++) {
            //   if ($scope.idsArr && $scope.idsArr.length > 0) {
            //     if ($scope.idsArr.indexOf(result.data.data[i].queId) == -1) {
            //       $scope.idsArr.push(result.data.data[i].queId);
            //     }
            //   } else {
            //     $scope.idsArr.push(result.data.data[i].queId);
            //   }
            // }
            // MyService.ConsoleLog('$scope.idsArr', $scope.idsArr.length);
            if (!$scope.checkCount) {
              $scope.questions = result.data.data;
              $scope.view[val.orgId] = true;
              $scope.viewTwo[val.quizName] = true;
            }
            // if ($scope.checkCount) {
            //   $scope.quesCount = result.data.data.length;
            //   if ($scope.descrised) {
            //     MyService.ConsoleLog('<<<<<<<<<<>>>>>>>>>>>>>');
            //     $scope.selectedQuestions -= $scope.quesCount;
            //   } else if ($scope.isSelected && $scope.descrised) {
            //     // alert('here');
            //     $scope.selectedQuestions -= $scope.quesCount;
            //   } else {
            //     MyService.ConsoleLog('three');
            //     $scope.selectedQuestions += $scope.quesCount;
            //   }
            // }
            MyService.getCompositeQuiz({
              obj: JSON.stringify($scope.uArr),
            }).then(
              function (response) {
                MyService.ConsoleLog('Response', response);
                if (response.success) {
                  $scope.selectedQuestions = response.data.length;
                  window.localStorage.setItem('queIds', JSON.stringify(response.data));
                }
              },
              function (err) {
                MyService.ConsoleLog('Error', err);
              }
            );
            MyService.ConsoleLog(' $scope.quesCount', $scope.quesCount);
          },
          function (err) {
            growl.error(err);
          }
        );
      };

      /**
       * Hide list of questions
       */
      $scope.showLess = function (id) {
        // console.log("id for less",id);
        $scope.view[id.orgId] = false;
        $scope.viewTwo[id.quizName] = false;
      };

      /**
       * Get Quiz of composite questions
       */

      $scope.getQuiz = function () {
        MyService.ConsoleLog("$scope.uArr", $scope.uArr);
        MyService.ConsoleLog("$scope.uArr", $scope.uArr.length);
        // return;
        if ($scope.uArr && $scope.uArr.length > 0) {
          $cookies.put('advId', $scope.uArr[0].orgId);
          $cookies.put('quizName', $scope.uArr[0].quizName);
          $cookies.put('showBanner', true);
          MyService.ConsoleLog("showBanner >>>>>>>>>", $cookies.get('showBanner'));
          // alert("isnsnsn");
          $location.path('/organizationQuiz');
        } else {
          growl.error('Please select quizzes first');
        }
      };

      /**
       * Get Quiz of unAnswered questions
       * redirectToQuestions
       */

      $scope.redirectToQuestions = function (val) {
        MyService.ConsoleLog('val', val);
        MyService.getSelectedQues({
          orgId: val.orgId,
          quizName: val.quizName,
        }).then(
          function (APIResponse) {
            MyService.ConsoleLog("res APIResponse", APIResponse)
            if (APIResponse.data.success) {
              var data = APIResponse.data.data.map(function (itms) {
                return itms.queId;
              });
              MyService.ConsoleLog('data', data);
              if (data && data.length > 0) {
                MyService.ConsoleLog("val.orgId", val.orgId);

                $cookies.put('advId', val.orgId);
                window.localStorage.setItem('queIds', JSON.stringify(data));
                $location.path('/organizationQuiz/' + val.quizName);
              }
            }

          },
          function (err) {
            MyService.ConsoleLog("erroe", err);
          });
        // return;
        // var data = val.unAnsweredQuesData.map(function (itms) {
        //   return itms.queId;
        // });
        // MyService.ConsoleLog('data', data);
        // if (data && data.length > 0) {
        //   MyService.ConsoleLog("val.orgId", val.orgId);

        //   $cookies.put('advId', val.orgId);
        //   window.localStorage.setItem('queIds', JSON.stringify(data));
        //   $location.path('/organizationQuiz/' + val.quizName);
        // }
      };

      /**
       * Sort questions number
       */

      $scope.sortQues = function () {
        var sortOrder = '';

        // MyService.ConsoleLog("called");
        if ($scope.queUp == '' || $scope.queUp == 'DESC') {
          sortOrder = 'ASC';
          // if (para == 'factual') {
          $scope.queUp = true;
          $scope.queDown = false;

          // MyService.ConsoleLog("$scope.press.data", $scope.press.data.length);

          $scope.compositeQuiz.sort(function (a, b) {
            return a.noOfQues - b.noOfQues;
          });
        } else {
          sortOrder = 'DESC';

          $scope.queUp = false;
          $scope.queDown = true;

          // MyService.ConsoleLog("$scope.press.data", $scope.press.data.length);
          $scope.compositeQuiz.sort(function (a, b) {
            return b.noOfQues - a.noOfQues;
          });
        }
      };

      $scope.unAns = function () {
        var sortOrder = '';

        // MyService.ConsoleLog("called");
        if ($scope.unAnsUp == '' || $scope.unAnsUp == 'DESC') {
          sortOrder = 'ASC';
          // if (para == 'factual') {
          $scope.unAnsUp = true;
          $scope.unAnsDown = false;

          // MyService.ConsoleLog("$scope.press.data", $scope.press.data.length);

          $scope.compositeQuiz.sort(function (a, b) {
            return a.unAnsweredQues - b.unAnsweredQues;
          });
        } else {
          sortOrder = 'DESC';

          $scope.unAnsUp = false;
          $scope.unAnsDown = true;

          // MyService.ConsoleLog("$scope.press.data", $scope.press.data.length);
          $scope.compositeQuiz.sort(function (a, b) {
            return b.unAnsweredQues - a.unAnsweredQues;
          });
        }
      };

      /** Show filter */
      $scope.showFilter = function () {
        if (!$scope.isShowFilter) {
          $scope.isShowFilter = true;
        } else {
          $scope.isShowFilter = false;
        }
        // var query = $scope.search.text;
        $scope.search = {
          subject: '',
          Locations: '',
          mediaoption: [],
          mediaType: '',
          dateBefore: '',
          dateAfter: '',
          matchFrom: '',
          matchTo: '',
          recommendFrom: '',
          recommendTo: '',
          recommendFilter: '',
          factualFilter: '',
          factualFrom: '',
          factualTo: '',
          order: '',
          recommendorder: '',
          lrecommendorder: '',
          factualorder: '',
          lfactualorder: '',
          fromfollowlist: '',
          chk: false,
        };
      };

      $scope.showStates = false;
      $scope.showAllFilter = function (e, option) {
        e.preventDefault();
        switch (option) {
          case 'Interest':
            $scope.getSubcatTree();
            break;
          case 'Location':
            if (!$scope.showRefineLocation) $scope.showRefineLocation = true;
            else $scope.showRefineLocation = false;
            break;

          case 'AllLocation':
            if (!$scope.showStates) {
              $scope.showStates = true;
            } else {
              $scope.showStates = false;
            }
            $scope.getAllStates();
            break;

          case 'Default':
            break;
        }
      };

      /** Check cat exists or not */

      $scope.checkCatExists = function (rdata, val) {
        return rdata.filter(function (rdata) {
          if (rdata._id == val) {
            $scope.selectedCat.push(rdata);
            return rdata;
          } else if (rdata.subcategories) {
            $scope.checkCatExists(rdata.subcategories, val);
          }
        });
      };

      /**
       * Get  Categories */

      $scope.getSubcatTree = function () {
        MyService.ConsoleLog("calll sdnsnssn");
        if ($scope.mainCatTree.length == 0) {
          $scope.ShowSubcatTree = true;
          MyService.getQuizzesCategories().then(function (payload) {
            MyService.ConsoleLog("payload", payload);
            $scope.subtopics.subcategories.length = 0;
            $scope.mainCatTree = angular.copy(payload);
            var subcatdata = payload;
            $scope.ShowSubcatTree = false;
            $scope.subtopics.subcategories = subcatdata;
            var selectedCat = $scope.disabled;
            if (selectedCat.length > 0) {
              for (var s = 0; s < selectedCat.length; s++) {
                var checkcatdata = $scope.checkCatExists(subcatdata, selectedCat[s]);
              }
              //MyService.ConsoleLog($scope.selectedCat);
            }
            setTimeout(function () {
              var cols = document.getElementsByClassName('cmnUL');
              var clen = cols.length;
              for (var i = 0; i < clen; i++) {
                cols[i].style.display = 'none';
              }
            }, 300);
          }, function (err) {
            MyService.ConsoleLog("Error", err);
          });
        } else {
          //MyService.ConsoleLog("After : " + $scope.subtopics.subcategories.length);
          if ($scope.subtopics.subcategories.length == 0) {
            $scope.subtopics.subcategories = angular.copy($scope.mainCatTree);
          } else {
            $scope.subtopics.subcategories.length = 0;
          }

          $scope.ShowSubcatTree = false;
          //MyService.ConsoleLog("After : " + $scope.subtopics.subcategories);
          //MyService.ConsoleLog("After : " + $scope.ShowSubcatTree);
        }
        /*if ($scope.mainCatTree.length == 0) {
          $scope.ShowSubcatTree = true;
          MyService.getAllCatTree().then(
            function (payload) {
              $scope.subtopics.subcategories.length = 0;
              $scope.mainCatTree = angular.copy(payload);
              var subcatdata = payload;
              $scope.ShowSubcatTree = false;
              $scope.subtopics.subcategories = subcatdata;
              var selectedCat = $scope.disabled;
              if (selectedCat.length > 0) {
                for (var s = 0; s < selectedCat.length; s++) {
                  var checkcatdata = $scope.checkCatExists(subcatdata, selectedCat[s]);
                }
                //MyService.ConsoleLog($scope.selectedCat);
              }
              setTimeout(function () {
                var cols = document.getElementsByClassName('cmnUL');
                var clen = cols.length;
                for (var i = 0; i < clen; i++) {
                  cols[i].style.display = 'none';
                }
              }, 300);
            },
            function (errorPayload) {
              alert('Something went wrong ');
            }
          );
        } else {
          //MyService.ConsoleLog("After : " + $scope.subtopics.subcategories.length);
          if ($scope.subtopics.subcategories.length == 0) {
            $scope.subtopics.subcategories = angular.copy($scope.mainCatTree);
          } else {
            $scope.subtopics.subcategories.length = 0;
          }

          $scope.ShowSubcatTree = false;
          //MyService.ConsoleLog("After : " + $scope.subtopics.subcategories);
          //MyService.ConsoleLog("After : " + $scope.ShowSubcatTree);
        }*/
      };

      /**
       * Get All State */
      $scope.getAllStates = function () {
        $scope.ShowStateLoader = true;
        if ($scope.AllStates.length == 0) {
          MyService.getAllStates().then(
            function (payload) {
              $scope.ShowStateLoader = false;
              $scope.allLocations.length = 0;
              var subcatdata = payload;
              $scope.AllStates = angular.copy(subcatdata);
              //MyService.ConsoleLog("countires : ", subcatdata);
              $scope.allLocations = subcatdata;
            },
            function (errorPayload) {
              alert('Something went wrong ');
            }
          );
        } else {
          if (!$scope.showStates) {
            $scope.allLocations.length = 0;
            $scope.ShowStateLoader = false;
          } else {
            $scope.allLocations = angular.copy($scope.AllStates);
            $scope.ShowStateLoader = false;
          }
        }
      };

      $scope.getCounties = function (state) {
        // MyService.ConsoleLog("state", state);
        $scope.showLoading.push(state);

        if (!$scope.allCounties[state.statePostalCode] || $scope.allCounties[state.statePostalCode].length == 0) {
          MyService.getAllCounties(state.stateFips).then(
            function (payload) {
              $scope.showLoading.length = 0;
              var sublocations = payload;
              // MyService.ConsoleLog("paload", payload);
              if (!$scope.allCounties) {
                $scope.allCounties = [];
              }
              $scope.allCounties[state.statePostalCode] = payload;
              // MyService.ConsoleLog(" $scope.allCounties", $scope.allCounties);
            },
            function (errorPayload) {
              alert('Something went wrong.');
            }
          );
        } else {
          // alert('inside');
          $scope.showLoading.length = 0;
          $scope.allCounties[state.statePostalCode].length = 0;
        }
      };

      $scope.getLocals = function (state, county) {
        MyService.ConsoleLog('state', state);
        MyService.ConsoleLog('county', county);

        $scope.showLoadingCounty.push(county);
        if (
          !$scope.allLocals[state] ||
          !$scope.allLocals[state][county] ||
          $scope.allLocals[state][county].length == 0
        ) {
          MyService.getAllSubCountiesLocal(state, county).then(
            function (payload) {
              $scope.showLoadingCounty.length = 0;
              MyService.ConsoleLog('sublocations Locals : ', payload);
              if (!$scope.allLocals[state]) {
                $scope.allLocals[state] = [];
              }
              MyService.ConsoleLog('state.statePostalCode', state.statePostalCode);
              $scope.allLocals[state][county] = payload.places;
              MyService.ConsoleLog('sublocations Locals : ', $scope.allLocals[state][county]);
            },
            function (errorPayload) {
              alert('Something went wrong ');
            }
          );
        } else {
          // alert('inside');
          $scope.showLoadingCounty.length = 0;
          $scope.allLocals[state][county].length = 0;
        }
      };

      $scope.ChangeShow = function (id) {
        $scope.showSubCat = true;

        var nclass = 'MainCatLi_' + id;
        if (
          document.getElementsByClassName(nclass)[0].style.display &&
          document.getElementsByClassName(nclass)[0].style.display == 'none'
        ) {
          document.getElementsByClassName(nclass)[0].style.display = 'block';
        } else {
          document.getElementsByClassName(nclass)[0].style.display = 'none';
        }
      };

      /**
       * Get Selected val */

      $scope.getVal = function (data) {
        // MyService.ConsoleLog("data", data);
        var idx = $scope.Interests.indexOf(data._id);
        if (idx == -1) {
          $scope.Interests.push(data._id);
        } else {
          $scope.Interests.splice(idx, 1);
        }
        MyService.ConsoleLog('$scope.Interest', $scope.Interests);
      };

      /**
       * Filter Quizzes */

      $scope.filterQuizzes = function () {
        MyService.ConsoleLog("$scope.findLocations", $scope.findLocations);
        MyService.ConsoleLog("$scope.MyLocation", $scope.MyLocation);

        if ($scope.Interests && $scope.Interests.length > 0 || $scope.findLocations && $scope.findLocations.length > 0 || $scope.MyLocation && $scope.MyLocation.length > 0) {
          $scope.currPage = 0;
          $scope.compositeQuiz = [];
          $scope.statusGetResPg = 2;
          $scope.pageFunction();
          // alert('djf');
        } else {
          // alert('call');
          if ($scope.quizName && $scope.quizName != '') {
            $scope.compositeQuiz = [];
            $scope.getQuizDetails(1);
          } else {
            $scope.compositeQuiz = [];
            $scope.getShowAll();
          }
        }
      };

      /**
       * Select Default locations
       */
      $scope.SelectDefaultLocation = function (val) {
        //MyService.ConsoleLog("Data : ", val);
        var idx = $scope.MyLocation.indexOf(val);
        if (idx == -1) {
          $scope.MyLocation.push(val);
        } else {
          $scope.MyLocation.splice(idx, 1);
        }
        //MyService.ConsoleLog($scope.MyLocation);
      }

      /**
       * check vales are equals or not
       */
      function areEqual() {
        var len = arguments.length;
        for (var i = 1; i < len; i++) {
          if (arguments[i] == null || arguments[i] != arguments[i - 1])
            return false;
        }
        return true;
      }


      /**
       * @description check index is exist or not
       * @param {array of states} list
       * @param {* object of state} item
       */
      function indexOfExt(list, item) {
        var len = list.length;
        for (var i = 0; i < len; i++) {
          var keys = Object.keys(list[i]);
          var flg = true;
          var arr = [];
          for (var j = 0, s = 1; j < keys.length; j++, s++) {
            var value = list[i][keys[j]];
            if (item[keys[j]] !== value) {
              flg = false;
            }

            if (item[keys[j]] == value) {
              arr.push(flg);
            }
          }
          if (flg == true) {
            if (areEqual(arr.length, keys.length, Object.keys(item).length)) {
              return i;
            }
          }
        }
        return -1;
      }

      /**
       * Select locations
       */

      $scope.selectLocation = function (val1, val2, val3, type) {
        // MyService.ConsoleLog(val1, val2, val3, type);
        var nobj = {};
        nobj.country = "United States of America";
        if (type == "state") {
          nobj.state = val1.state;
          nobj.statePostalCode = val1.statePostalCode;
        }
        if (type == "county") {
          nobj.state = val1.state;
          nobj.statePostalCode = val1.statePostalCode;
          nobj.county = val3;
        }
        if (type == "local") {
          nobj.state = val1.state;
          nobj.statePostalCode = val1.statePostalCode;
          nobj.county = val2;
          nobj.countySubdivision = val3.countySubdivision;
          nobj.place = val3.placeName;
        }
        MyService.ConsoleLog("nboj:", nobj);
        var idx = indexOfExt($scope.findLocations, nobj);
        if (idx == -1) {
          $scope.findLocations.push(nobj);
        } else {
          $scope.findLocations.splice(idx, 1);
        }
      }

      if ($scope.orgId && $scope.orgId != '') {
        $scope.getQuizDetails(1);

      } else {
        $scope.getQuizDetails(1);
      }
    },
  ]);

'use strict';
angular.module('myApp.compareSubjectWise', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/compare-subject/:user_type', {
      templateUrl: 'app/compare_subject/compare_subject.html',
      controller: 'compareSubjectWiseCtrl'
    });
  }])
  .controller('compareSubjectWiseCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$filter', 'MyService', 'growl', '$q', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $filter, MyService, growl, $q) {
    //MyService.ConsoleLog("** compareSubjectWiseCtrl **", $routeParams, "$rootScope.selectedCompareUsers: ",$rootScope.selectedCompareUsers);

    $scope.usertype = $routeParams.user_type;
    $scope.categories = [];
    $rootScope.welcome = false;
    var getCategoriesCanceler = $q.defer();
    $scope.statusCat = 0;
    window.localStorage.removeItem('fiveQueIds');
    $scope.fiveMinData = [];
    $scope.showLoader = false;
    $scope.checkTotalAns = function () {
      var checkTotalAnswers = $scope.categories.filter(function (itms) {
        if (itms.total_answers != 0) {
          MyService.ConsoleLog("itms", typeof itms.total_answers);
          return itms.total_answers;
        }
      });
      MyService.ConsoleLog("checkTotalAnswers>>>>>>>>", checkTotalAnswers);
      if (checkTotalAnswers.length == 1) {
        $location.path("/compare-subcategories/" + checkTotalAnswers[0]._id);
      }
    };

    $scope.getFiveMin = function () {
      $scope.showLoader = true;
      var temp_userids = [];
      if ($rootScope.selectedCompareUsers && $rootScope.selectedCompareUsers.length > 0) {
        angular.forEach($rootScope.selectedCompareUsers, function (val, key) {
          // body...
          temp_userids.push(val._id);
        });
      }
      var params = {};
      params.answer_count_userids = temp_userids.join(",");
      MyService.getFiveMinCount(params).then(function (APIResponse) {
        MyService.ConsoleLog("APIResponse", APIResponse);
        if (APIResponse && APIResponse.data.status) {
          $scope.queIds = APIResponse.data.data.queIds;
          $scope.allQueIds = APIResponse.data.data.allQueIds;
          $scope.showLoader = false;
          $scope.fiveMinData.push({
            title: 'Five Minute Quiz',
            imgUrl: './assets/images/5minQuizIcon.jpg',
            ansCount: APIResponse.data.data.ansCount,
            queIds: $scope.queIds
          })

          if (APIResponse.data.data.allTopicCount != '') {
            $scope.fiveMinData.push({
              title: 'All Topics',
              imgUrl: './assets/images/allTopics7.svg',
              ansCount: APIResponse.data.data.allTopicCount,
              queIds: $scope.allQueIds
            })
          }


        } else {
          $scope.showLoader = false;
        }
      }, function (err) {

        MyService.ConsoleLog("err", err);
      });

    };

    function getCategories() {
      MyService.ConsoleLog("getCategories: ***");
      getCategoriesCanceler.resolve();
      getCategoriesCanceler = $q.defer();
      var params = {
        root: 1,
        questions_counter: 1,
        catTypes: "Q,B"
      };
      var temp_userids = [];
      if ($rootScope.selectedCompareUsers && $rootScope.selectedCompareUsers.length > 0) {
        angular.forEach($rootScope.selectedCompareUsers, function (val, key) {
          // body...
          temp_userids.push(val._id);
        });
      }
      params.answer_count_userids = temp_userids.join(",");
      MyService.ConsoleLog("params: ", params);
      $scope.statusCat = 1;
      MyService.getCatListWithQueAnsCountUserwise(params, null).then(function (response) {
        if (response.data.success) {
          $scope.categories = response.data.data;
          $scope.checkTotalAns();
          $scope.getFiveMin();
          MyService.ConsoleLog("Got categories here: ", $scope.categories);
          $scope.statusCat = 2;
        } else {
          $scope.statusCat = 3;
          if (typeof response.data.error == "string")
            growl.error(response.data.error);
          else
            growl.error("Something went wrong");
        }
      }, function (err) {
        $scope.statusCat = 3;
        growl.error("Something went wrong.");
      });
    }
    getCategories();


    function getUsers(params) {
      var request = apiCall.apiCall('GET', '/user/list', params);
      $http(
        request
      ).then(function successCallback(response) {
        // MyService.ConsoleLog("Got categories: ",response);
        if (response.data.success) {
          $scope.users = response.data.data;
        } else {
          //MyService.ConsoleLog("Something went wrong: ",response.data);
        }
      }, function errorCallBack(response) {
        //MyService.ConsoleLog("Error: ",response);
      });
    }

    function getCompareAnswers(params) {
      console.log("params", params);
      var request = apiCall.apiCall('GET', '/answers/compare', params);
      $http(
        request
      ).then(function successCallback(response) {
        MyService.ConsoleLog("Got categories: ", response);
        // MyService.ConsoleLog(" $routeParams.category_id", $routeParams.category_id);
        if (response.data.success) {

          angular.forEach(response.data.data, function (val, key) {
            if (val.answers && val.answers.length != $scope.selectedUser.length) {
              var check_author_exist = function (u) {
                var len = val.answers.length;
                for (var i = 0; i < len; i++) {
                  if (val.answers[i].author._id == u._id) {
                    return true;
                  }
                }
                return false;
              };

              angular.forEach($scope.selectedUser, function (u, i) {
                if (!check_author_exist(u)) {
                  response.data.data[key].answers.push({
                    author: u
                  });
                }
              });

            } else if (!val.answers) {
              response.data.data[key].answers = [];
              angular.forEach($scope.selectedUser, function (u, i) {
                response.data.data[key].answers.push({
                  author: u
                });
              });
            }
          });

          $rootScope.compareAnswerList = response.data.data;
          if ($routeParams.category_id && $routeParams.category_id != '') {

            $location.path("question-compare/" + $routeParams.category_id);
          } else {
            console.log("check cat", response.data.data[0].categories[0].cid);
            $location.path("question-compare/" + response.data.data[0].categories[0].cid + "/");
          }

        } else {
          //MyService.ConsoleLog("Something went wrong: ",response.data);
        }
      }, function errorCallBack(response) {
        //MyService.ConsoleLog("Error: ",response);
      });
    }

    if ($routeParams.user_type) {
      getUsers({
        usertype: $routeParams.user_type
      });
    }

    $scope.selectedUser = [];
    $scope.toggleSelection = function toggleSelection(uid) {
      //MyService.ConsoleLog("toggleSelection: ", uid);
      var idx = $scope.selectedUser.indexOf(uid);

      // is currently selected
      if (idx > -1) {
        $scope.selectedUser.splice(idx, 1);
      }

      // is newly selected
      else {
        $scope.selectedUser.push(uid);
      }
    };

    $scope.compare = function () {
      //MyService.ConsoleLog("compare :",$scope.selectedUser);
      if ($scope.selectedUser.length <= 0) {
        alert("Please select user first.");
      } else {
        var temp_uids = [];
        angular.forEach($scope.selectedUser, function (val, key) {
          temp_uids.push(val._id);
        });
        getCompareAnswers({
          "compare_with": $routeParams.user_type,
          "categoryId": $routeParams.category_id,
          "userIds": temp_uids.join(",")
        });
      }
    };

    $scope.goToCompareSubcategories = function (cat) {
      $location.path("/compare-subcategories/" + cat._id);
    };

    $scope.goToFiveCompare = function (item) {
      MyService.ConsoleLog("item >>", item);
      if (item.title == 'Five Minute Quiz') {
        window.localStorage.setItem('fiveQueIds', JSON.stringify($scope.queIds));
        var temp_userids = [];
        if ($rootScope.selectedCompareUsers && $rootScope.selectedCompareUsers.length > 0) {
          angular.forEach($rootScope.selectedCompareUsers, function (val, key) {
            // body...
            temp_userids.push(val._id);
          });
        }
        getCompareAnswers({
          "compare_with": $routeParams.user_type,
          "questionIds": JSON.stringify($scope.queIds),
          "userIds": temp_userids.join(",")
        });
      } else if (item.title == 'All Topics') {
        window.localStorage.setItem('fiveQueIds', JSON.stringify(item.queIds));
        var temp_userids = [];
        if ($rootScope.selectedCompareUsers && $rootScope.selectedCompareUsers.length > 0) {
          angular.forEach($rootScope.selectedCompareUsers, function (val, key) {
            // body...
            temp_userids.push(val._id);
          });
        }
        getCompareAnswers({
          "compare_with": $routeParams.user_type,
          "questionIds": JSON.stringify(item.queIds),
          "userIds": temp_userids.join(",")
        });
      }

    };
  }]);

'use strict';
angular.module('myApp.compareSubcategories', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/compare-subcategories/:categoryId', {
      templateUrl: 'app/compare_subcategories/compare_subcategories.html',
      controller: 'compareSubcategoriesCtrl'
    });
  }])
  .controller('compareSubcategoriesCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$filter', 'growl', 'MyService', '$q', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $filter, growl, MyService, $q) {
    //MyService.ConsoleLog("** compareSubcategoriesCtrl **",$routeParams);
    $rootScope.welcome = false;
    $scope.statusGetSubCategories = 0;
    /*
    function getSubCategories(params) {
    	$scope.statusGetSubCategories = 1;
      	var request = apiCall.apiCall('GET', '/categories/list', {"parentId": $routeParams.categoryId, "questions_counter": 1});
      	$http(
        	request
      	).then(function successCallback(response) {
    		//MyService.ConsoleLog("Got categories: ",response);
    		if(response.data.success){
    			$scope.subCategories = response.data.data;
    			$scope.statusGetSubCategories = 2;
    		}
    		else{
    			growl.error("Unable to load categories");
    			//MyService.ConsoleLog("Something went wrong: ",response.data);
    			$scope.statusGetSubCategories = 3;
    		}
      	}, function errorCallBack(response) {
        	//MyService.ConsoleLog("Error: ",response);
        	growl.error("Unable to load categories");
        	$scope.statusGetSubCategories = 3;
      	});
    }*/

    $scope.checkTotalAns = function () {
      var checkTotalAnswers = $scope.subCategories.filter(function (itms) {
        if (itms.total_answers != 0) {
          MyService.ConsoleLog("itms", typeof itms.total_answers);
          return itms.total_answers;
        }
      });
      MyService.ConsoleLog("checkTotalAnswers>>>>>>>>", checkTotalAnswers);
      if (checkTotalAnswers.length == 1) {
        $scope.compare(checkTotalAnswers[0]);
      }
    };

    var getCategoriesCanceler = $q.defer();

    function getSubCategories() {
      //MyService.ConsoleLog("getCategories: ***");
      getCategoriesCanceler.resolve();
      getCategoriesCanceler = $q.defer();
      var params = {
        root: 1,
        questions_counter: 1,
        catTypes: "Q,B",
        parentId: $routeParams.categoryId,
      };
      var temp_userids = [];
      if ($rootScope.selectedCompareUsers && $rootScope.selectedCompareUsers.length > 0) {
        angular.forEach($rootScope.selectedCompareUsers, function (val, key) {
          // body...
          temp_userids.push(val._id);
        });
      }
      params.answer_count_userids = temp_userids.join(",");
      //MyService.ConsoleLog("params: ", params);
      $scope.statusGetSubCategories = 1;
      MyService.getCatListWithQueAnsCountUserwise(params, null).then(function (response) {
        if (response.data.success) {
          $scope.subCategories = response.data.data;
          MyService.ConsoleLog("Got subCategories: ", $scope.subCategories);
          $scope.checkTotalAns();
          $scope.statusGetSubCategories = 2;
        } else {
          $scope.statusGetSubCategories = 3;
          if (typeof response.data.error == "string")
            growl.error(response.data.error);
          else
            growl.error("Something went wrong");
        }
      }, function (err) {
        $scope.statusGetSubCategories = 3;
        growl.error("Something went wrong.");
      });
    }


    function getCategory(params) {
      var request = apiCall.apiCall('GET', '/categories/list', {
        id: $routeParams.categoryId
      });
      $http(
        request
      ).then(function successCallback(response) {
        //MyService.ConsoleLog("Got categories: ",response);
        if (response.data.success) {
          $scope.category = response.data.data;
        } else {
          //MyService.ConsoleLog("Something went wrong: ",response.data);
        }
      }, function errorCallBack(response) {
        //MyService.ConsoleLog("Error: ",response);
      });
    }

    function getPopularQuestions() {
      var categoryIds = [];
      if ($routeParams.categoryId) categoryIds.push($routeParams.categoryId);

      angular.forEach($scope.subCategories, function (val, key) {
        categoryIds.push(val._id);
      });

      var request = apiCall.apiCall('GET', '/answers/popular', {
        "categoryIds": categoryIds.join(",")
      });
      $http(
        request
      ).then(function successCallback(response) {
        //MyService.ConsoleLog("Got PopularQuestions: ",response);
        if (response.data.success) {
          var questions = response.data.data;
          if (questions.length <= 0 && $scope.subCategories.length > 0) {
            $location.path('/question/' + $scope.subCategories[0]._id);
          } else {
            $location.path('/question/popular:' + categoryIds.join(","));
          }
        } else {
          //MyService.ConsoleLog("Something went wrong: ",response.data);
        }
      }, function errorCallBack(response) {
        //MyService.ConsoleLog("Error: ",response);
      });
    }

    if ($routeParams.categoryId) {
      getCategory();
      getSubCategories();
    }

    $scope.statusGetCompareAnswers = 0;

    function getCompareAnswers(params) {
      $scope.statusGetCompareAnswers = 1;
      var request = apiCall.apiCall('GET', '/answers/compare', params);
      $http(
        request
      ).then(function successCallback(response) {
        //MyService.ConsoleLog("Got categories: ",response);
        if (response.data.success) {
          $scope.statusGetCompareAnswers = 2;
          angular.forEach(response.data.data, function (val, key) {
            if (val.answers && val.answers.length != $rootScope.selectedCompareUsers.length) {

              var check_author_exist = function (u) {
                var len = val.answers.length;
                for (var i = 0; i < len; i++) {
                  if (val.answers[i].author._id == u._id) {
                    return true;
                  }
                }
                return false;
              };

              angular.forEach($rootScope.selectedCompareUsers, function (u, i) {
                if (!check_author_exist(u)) {
                  response.data.data[key].answers.push({
                    author: u
                  });
                }
              });

            } else if (!val.answers) {
              response.data.data[key].answers = [];
              angular.forEach($rootScope.selectedCompareUsers, function (u, i) {
                response.data.data[key].answers.push({
                  author: u
                });
              });
            }
          });

          $rootScope.compareAnswerList = response.data.data;
          //MyService.ConsoleLog("compareAnswerList: ", $rootScope.compareAnswerList);
          $location.path("question-compare/" + params.categoryIds + "/" + $routeParams.categoryId);
        } else if (response.data.error && typeof response.data.error == "string") {
          $scope.statusGetCompareAnswers = 3;
          growl.error('Error: ' + data.error);
        } else {
          $scope.statusGetCompareAnswers = 3;
          growl.error('Something went wrong.');
        }
      }, function errorCallBack(response) {
        $scope.statusGetCompareAnswers = 3;
        growl.error('Something went wrong.');
      });
    }
    $scope.compare = function (subcat) {
      MyService.ConsoleLog("compare :", $rootScope.selectedCompareUsers);

      window.localStorage.setItem("selectedCompareUsers", JSON.stringify($rootScope.selectedCompareUsers));
      if ($rootScope.selectedCompareUsers.length <= 0) {
        growl.error('Please select user first.');
      } else if (subcat.has_subcategory) {
        $location.path("/compare-subcategories/" + subcat._id);
      } else {
        var temp_uids = [];
        angular.forEach($rootScope.selectedCompareUsers, function (val, key) {
          temp_uids.push(val._id);
        });
        // if(subcat.total_answers && subcat.total_answers > 0){}
        $location.path("question-compare/" + subcat._id + "/" + $routeParams.categoryId);
        // getCompareAnswers({"compare_with": $routeParams.user_type, "categoryIds": subcat._id, "userIds": temp_uids.join(",")});

      }
    };
  }]);

"use strict";
angular
  .module("myApp.compareSelect", ["ngRoute"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/compare-select/:user_type", {
        templateUrl: "app/compare_select/compare_select.html",
        controller: "compareSelectCtrl",
      });
    },
  ])
  .controller("compareSelectCtrl", [
    "$scope",
    "$http",
    "$location",
    "apiCall",
    "$routeParams",
    "$rootScope",
    "$filter",
    "MyService",
    "ngDialog",
    "growl",
    "tokenService",
    "$sce",
    "$cookies",
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $rootScope,
      $filter,
      MyService,
      ngDialog,
      growl,
      tokenService,
      $sce,
      $cookies
    ) {
      //console.log("** compareSelectCtrl **",$routeParams);
      $scope.userId = tokenService.getUserId();
      $scope.usertype = $routeParams.user_type;
      $rootScope.welcome = false;

      $scope.Address = false;
      $scope.topCandidates = [];
      $scope.Zip = true;
      $scope.Link = true;
      $scope.showAlert = false;
      // $scope.showWar = false;
      $scope.showLoader = false;
      $scope.User = {
        Address: "",
      };
      if (tokenService.getUserData()) {
        $scope.addressNw = JSON.parse(tokenService.getUserData());
        // MyService.ConsoleLog("this is add", $scope.addressNw.address);
      }

      if ($scope.userId && $scope.userId != "") {
        $rootScope.tempUserAddress = "";
        $rootScope.incuAdd = "";
      }
      $scope.comp = {
        election: {
          electionDate: "",
        },
        // "party": "Select Party"
      };
      if ($cookies.get("elecDateForRate")) {
        MyService.ConsoleLog(
          "chck for ele date",
          $cookies.get("elecDateForRate")
        );
        // $scope.comp.election.electionDate = $cookies.get('elecDateForRate');
      }

      if ($cookies.get("electionDate")) {
        MyService.ConsoleLog(
          "electionDate in co",
          $cookies.get("electionDate")
        );
        $scope.comp.election.electionDate = $cookies.get("electionDate");
        MyService.ConsoleLog("models", $scope.comp);
      }
      $scope.matchQuestion = function () {
        $location.path("/question-not-answered");
      };
      var loc = $rootScope.location;
      // console.log("location", loc);

      // console.log("longitude", loc.longitude);

      function getCategories(params) {
        var request = apiCall.apiCall("GET", "/categories/list", {
          root: 1,
        });
        $http(request).then(
          function successCallback(response) {
            //console.log("Got categories: ",response);
            if (response.data.success) {
              $scope.categories = response.data.data;
            } else {
              //console.log("Something went wrong: ", response.data);
            }
          },
          function errorCallBack(response) {
            //console.log("Error: ", response);
          }
        );
      }

      //getCategories();

      $scope.setAllSelected = function (users) {
        angular.forEach(users, function (val, key) {
          if (val.registeredUser)
            // MyService.ConsoleLog(" val.isSelected", val.isSelected);
            val.isSelected = true;
          $scope.selectedUser.push(val);
        });
      };
      var loc = [];
      var eLoc = [];

      $scope.checkParty = function (tflag, udata, type) {
        // $scope.searchUsersByType.length = 0;
        // console.log("searchUsersByType >>> ", type);

        //// MyService.ConsoleLog("Call checkParty", udata);

        if (udata.politicianInfo) {
          if (udata.politicianInfo.length > 0) {
            // MyService.ConsoleLog("IF", udata);
            var pInLen = udata.politicianInfo.length;
            //// MyService.ConsoleLog("pInLEn >", pInLen);
            // $scope.searchUsersByType.length = 0;
            for (var s = 0; s < pInLen; s++) {
              udata = JSON.parse(JSON.stringify(udata));
              var polivar = udata.politicianInfo[s];

              if (polivar.runningForOffice == "Y") {
                if ($scope.comp.election.electionDate == polivar.electionYear) {
                  // MyService.ConsoleLog("nsnsnsn", type + "   " + polivar.levelOfGov);
                  // MyService.ConsoleLog("election date", polivar.electionYear);
                  if (!tflag) {
                    // MyService.ConsoleLog("nsnsnsn", polivar.levelOfGov);
                    switch (polivar.levelOfGov) {
                      case "placeName":
                        $scope.showlocal = true;
                        $scope.sortype = "local";
                        type = "local";
                        if (!type) type = "local";
                        break;
                      case "countySubdivision":
                        $scope.sortype = "local";
                        if (!type) type = "local";
                        $scope.showlocal = true;
                        break;
                      case "unifiedSchoolDistrictName":
                        $scope.showlocal = true;
                        // $scope.sortype = "local";
                        if (!type) type = "local";
                        break;
                      case "All USA":
                      case "all USA":
                        //MyService.ConsoleLog("$scope.searchUsers[i].office >", $scope.searchUsers[i].office);
                        var ncoff = polivar.officeName;
                        if (ncoff.toLowerCase() != "president") {
                          // $scope.sortype = "other";
                          if (!type) type = "other";
                          $scope.showother = true;
                        } else {
                          // $scope.sortype = "federal";
                          if (!type) type = "federal";
                          $scope.showfederal = true;
                          $scope.showother = false;
                        }
                        break;
                      case "countyName":
                        $scope.showcounty = true;
                        $scope.sortype = "county";
                        if (!type) {
                          type = "county";
                        } else if (type == "local") {
                          type = "local";
                        }
                        break;
                      case "statePostalCode":
                        var ncoff = udata.office;
                        if (ncoff && ncoff != "") {
                          // MyService.ConsoleLog("ncoff.toLowerCase()", ncoff.toLowerCase());
                          if (ncoff.toLowerCase() != "u.s. senate") {
                            // $scope.sortype = "other";
                            $scope.showstate = true;
                            $scope.sortype = "state";
                            if (!type) type = "state";
                          } else if (ncoff.toLowerCase() != "president") {
                            // MyService.ConsoleLog("ncoff.toLowerCase() nanan", ncoff.toLowerCase());
                            $scope.sortype = "federal";
                            if (!type) type = "federal";
                            $scope.showfederal = true;
                            $scope.showother = false;
                          } else {
                            // MyService.ConsoleLog("ncoff.toLowerCase() nanan", ncoff.toLowerCase());
                            $scope.sortype = "federal";
                            if (!type) type = "federal";
                            $scope.showfederal = true;
                            $scope.showother = false;
                          }
                        } else {
                          MyService.ConsoleLog("ncoff", ncoff);
                          MyService.ConsoleLog("udata", udata);
                        }
                        break;
                      case "stateSenateDistrict":
                        var ncoff = udata.office;
                        if (ncoff && ncoff != "") {
                          if (ncoff.toLowerCase() != "president") {
                            // $scope.sortype = "other";
                            $scope.showstate = true;
                            $scope.sortype = "state";
                            if (!type) type = "state";
                          } else {
                            $scope.sortype = "federal";
                            if (!type) type = "federal";
                            $scope.showfederal = true;
                            $scope.showother = false;
                          }
                        }
                        break;
                      case "stateHouseofRepresentativesDistrict":
                        var ncoff = udata.office;
                        if (ncoff.toLowerCase() != "president") {
                          // $scope.sortype = "other";
                          $scope.showstate = true;
                          $scope.sortype = "state";
                          if (!type) type = "state";
                        } else {
                          $scope.sortype = "federal";
                          if (!type) type = "federal";
                          $scope.showfederal = true;
                          $scope.showother = false;
                        }
                        break;
                      case "federalCongressionalDistrict":
                        // $scope.sortype = "federal";
                        // console.log("type", type);
                        if (!type) type = "federal";
                        $scope.showfederal = true;
                        break;
                      default:
                        break;
                    }
                  } else {
                    // MyService.ConsoleLog("$scope.searchUsers[i].voterScope >>", $scope.searchUsers[i]);
                    // $scope.changeTab($scope.searchUsers[i].voterScope);
                    switch (polivar.levelOfGov) {
                      case "placeName":
                        // $scope.sortype = "local";
                        if (!type) type = "local";
                        $scope.showlocal = true;
                        break;
                      case "countySubdivision":
                        // $scope.sortype = "local";
                        if (!type) type = "local";
                        $scope.showlocal = true;
                        break;
                      case "unifiedSchoolDistrictName":
                        $scope.showlocal = true;
                        break;
                      case "All USA":
                      case "all USA":
                        //MyService.ConsoleLog("$scope.searchUsers[i].office >", $scope.searchUsers[i].office);
                        var ncoff = polivar.officeName;

                        if (ncoff.toLowerCase() != "president") {
                          // $scope.sortype = "other";
                          if (!type) type = "other";
                          $scope.showother = true;
                        } else {
                          // $scope.sortype = "federal";
                          if (!type) type = "federal";
                          $scope.showfederal = true;
                          $scope.showother = false;
                        }
                        break;
                      case "countyName":
                        $scope.sortype = "county";
                        if (!type) type = "county";
                        $scope.showcounty = true;
                        break;
                      case "statePostalCode":
                        // $scope.sortype = "state";
                        var ncoff = udata.office;
                        if (ncoff.toLowerCase() != "u.s. senate") {
                          // $scope.sortype = "other";
                          $scope.showstate = true;
                          $scope.sortype = "state";
                          if (!type) type = "state";
                        } else if (ncoff.toLowerCase() != "president") {
                          $scope.sortype = "federal";
                          if (!type) type = "federal";
                          $scope.showfederal = true;
                          $scope.showother = false;
                        } else {
                          $scope.sortype = "federal";
                          if (!type) type = "federal";
                          $scope.showfederal = true;
                          $scope.showother = false;
                        }
                        break;
                      case "stateSenateDistrict":
                        var ncoff = udata.office;
                        if (ncoff && ncoff != "") {
                          if (ncoff.toLowerCase() != "president") {
                            // $scope.sortype = "other";
                            $scope.showstate = true;
                            $scope.sortype = "state";
                            if (!type) type = "state";
                          } else {
                            $scope.sortype = "federal";
                            if (!type) type = "federal";
                            $scope.showfederal = true;
                            $scope.showother = false;
                          }
                        }
                        break;
                      case "stateHouseofRepresentativesDistrict":
                        var ncoff = udata.office;
                        if (ncoff.toLowerCase() != "president") {
                          // $scope.sortype = "other";
                          $scope.showstate = true;
                          $scope.sortype = "state";
                          if (!type) type = "state";
                        } else {
                          $scope.sortype = "federal";
                          if (!type) type = "federal";
                          $scope.showfederal = true;
                          $scope.showother = false;
                        }
                        break;
                      case "federalCongressionalDistrict":
                        $scope.showfederal = true;
                        if (!type) type = "federal";
                        break;
                      default:
                        break;
                    }
                  }
                  // MyService.ConsoleLog(" if type for voterscope", type);
                  // MyService.ConsoleLog(" if sort type for voterscope", $scope.sortype);
                }

                if (polivar.levelOfGov) {
                  // $scope.searchUsersByType.length = 0;

                  if (
                    type == "local" &&
                    (polivar.levelOfGov == "placeName" ||
                      polivar.levelOfGov == "countySubDivisionName" ||
                      polivar.levelOfGov == "unifiedSchoolDistrictName" ||
                      polivar.levelOfGov == "elementarySchoolDistrictName" ||
                      polivar.levelOfGov == "secondarySchoolDistrictName" ||
                      polivar.levelOfGov == "cityCouncilDistrictName" ||
                      polivar.levelOfGov == "countySubdivision") &&
                    polivar.candidateStatus != "inactive"
                  ) {
                    // if (type == 'local') {
                    //   $scope.searchUsersByType.length = 0;
                    //   $scope.sortype = "local";
                    // }
                    // MyService.ConsoleLog("local", polivar.levelOfGov);
                    if (polivar.officeName) {
                      polivar.officeName = polivar.officeName.toLowerCase();
                      udata.party = "";
                      var newOff = polivar.officeName.toLowerCase();
                      udata.office = newOff;
                      udata.candidateStatus = polivar.candidateStatus;
                      // udata.party = polivar.party;
                    }
                    if (typeof polivar.party == "string") {
                      // alert('one');
                      polivar.party = polivar.party;
                    } else {
                      var party = "";
                      polivar.party.forEach(function (element, index) {
                        if (element) {
                          party += element + ", ";
                          var n = party.lastIndexOf(",");
                          var a = party.substring(0, n);
                          // MyService.ConsoleLog("Element", a);
                          udata.party = a;
                        }
                      });
                    }

                    // loc.push(udata)
                    // $scope.searchUsersByType['local'] = loc;
                    // $scope.searchUsersByType.push(udata);
                    // if ($scope.comp.party && $scope.comp.party != "") {
                    //   if ($scope.comp.party == udata.politicianInfo[s].party) {
                    //     $scope.searchUsersByType.push(udata);

                    //   }
                    // } else {
                    //   $scope.searchUsersByType.push(udata);
                    // }
                    if (
                      polivar &&
                      polivar.officeName &&
                      polivar.officeName.toLowerCase() != "president"
                    ) {
                      if (typeof polivar.party == "string") {
                        if ($scope.comp.party && $scope.comp.party != "") {
                          if (
                            $scope.comp.party == udata.politicianInfo[s].party
                          ) {
                            $scope.searchUsersByType.push(udata);
                          }
                        } else {
                          $scope.searchUsersByType.push(udata);
                        }
                      } else {
                        if ($scope.comp.party && $scope.comp.party != "") {
                          if (
                            udata.politicianInfo[s].party.indexOf(
                              $scope.comp.party
                            ) != -1
                          ) {
                            $scope.searchUsersByType.push(udata);
                          }
                        } else {
                          $scope.searchUsersByType.push(udata);
                        }
                      }
                    }
                    // MyService.ConsoleLog("searchUsersByType local>>> ", $scope.searchUsersByType);
                  } else if (
                    type == "county" &&
                    (polivar.levelOfGov == "countyName" ||
                      polivar.levelOfGov == "county") &&
                    polivar.candidateStatus != "inactive"
                  ) {
                    // if (type == 'county') {
                    //   $scope.searchUsersByType.length = 0;
                    //   $scope.sortype = "county";
                    // }
                    if (polivar.officeName) {
                      polivar.officeName = polivar.officeName.toLowerCase();
                      udata.office = polivar.officeName;
                      udata.candidateStatus = polivar.candidateStatus;
                      udata.party = polivar.party;
                    }
                    if (typeof polivar.party == "string") {
                      // alert('one');
                      polivar.party = polivar.party;
                    } else {
                      var party = "";
                      polivar.party.forEach(function (element, index) {
                        if (element) {
                          party += element + ", ";
                          var n = party.lastIndexOf(",");
                          var a = party.substring(0, n);
                          // MyService.ConsoleLog("Element", a);
                          udata.party = a;
                        }
                      });
                    }

                    // MyService.ConsoleLog("County >>", polivar);
                    if (typeof polivar.party == "string") {
                      if ($scope.comp.party && $scope.comp.party != "") {
                        if (
                          $scope.comp.party == udata.politicianInfo[s].party
                        ) {
                          $scope.searchUsersByType.push(udata);
                        }
                      } else {
                        $scope.searchUsersByType.push(udata);
                      }
                    } else {
                      if ($scope.comp.party && $scope.comp.party != "") {
                        if (
                          udata.politicianInfo[s].party.indexOf(
                            $scope.comp.party
                          ) != -1
                        ) {
                          $scope.searchUsersByType.push(udata);
                        }
                      } else {
                        $scope.searchUsersByType.push(udata);
                      }
                    }
                  } else if (
                    type == "state" &&
                    (polivar.levelOfGov == "statePostalCode" ||
                      (polivar.levelOfGov == "stateSenateDistrict" &&
                        polivar.officeName != "" &&
                        polivar.officeName.toLowerCase() != "u.s. senate") ||
                      polivar.officeName != "president") &&
                    polivar.candidateStatus != "inactive"
                  ) {
                    // alert('in')
                    // MyService.ConsoleLog("state", polivar);
                    // if (type == 'state') {
                    //   $scope.searchUsersByType.length = 0;
                    //   $scope.sortype = "state";
                    // }
                    // MyService.ConsoleLog("VoterScope it me : ", polivar.levelOfGov);
                    if (polivar.officeName) {
                      polivar.officeName = polivar.officeName.toLowerCase();
                      udata.office = polivar.officeName;
                      udata.candidateStatus = polivar.candidateStatus;
                      udata.party = polivar.party;
                    }
                    if (typeof polivar.party == "string") {
                      // alert('one');
                      polivar.party = polivar.party;
                    } else {
                      var party = "";
                      polivar.party.forEach(function (element, index) {
                        if (element) {
                          party += element + ", ";
                          var n = party.lastIndexOf(",");
                          var a = party.substring(0, n);
                          // MyService.ConsoleLog("Element", a);
                          udata.party = a;
                        }
                      });
                    }
                    // $scope.sortype = "";

                    // $scope.sortype = "state";

                    // var ssle = $scope.searchUsersByType.length;
                    // //// MyService.ConsoleLog("cle.n ", cle);
                    // for (var t = 0; t < ssle; t++) {
                    //   //// MyService.ConsoleLog("sinsisi >", $scope.searchUsersByType[s].voterScope)
                    //   if ($scope.searchUsersByType[t].voterScope != "statePostalCode") {
                    //     $scope.searchUsersByType.splice(t, 1);
                    //   }
                    // }
                    if (
                      polivar.officeName &&
                      polivar.officeName.toLowerCase() != "u.s. house" &&
                      polivar.levelOfGov != "placeName" &&
                      polivar.levelOfGov != "All USA"
                    ) {
                      if (polivar.runningForOffice == "Y") {
                        if (typeof polivar.party == "string") {
                          if ($scope.comp.party && $scope.comp.party != "") {
                            if (
                              $scope.comp.party == udata.politicianInfo[s].party
                            ) {
                              $scope.searchUsersByType.push(udata);
                            }
                          } else {
                            $scope.searchUsersByType.push(udata);
                          }
                        } else {
                          if ($scope.comp.party && $scope.comp.party != "") {
                            if (
                              udata.politicianInfo[s].party.indexOf(
                                $scope.comp.party
                              ) != -1
                            ) {
                              $scope.searchUsersByType.push(udata);
                            }
                          } else {
                            $scope.searchUsersByType.push(udata);
                          }
                        }
                      }
                    }
                    // $scope.searchUsersByType.push(udata);
                    //// MyService.ConsoleLog("searchUsersByType state>>> ", $scope.searchUsersByType);

                    /*****************************************************************
                     * commented by vishal $scope.searchUsers.electionOfficeTypeId == 'G' ||
                     *
                     *****************************************************************/

                    /*
                  if ($scope.searchUsers[i].office) {

                    if (($scope.searchUsers[i].voterScope == 'state' || $scope.searchUsers[i].voterScope == 'statePostalCode' || $scope.searchUsers[i].voterScope == 'stateSenateDistrict' || $scope.searchUsers[i].voterScope == 'stateHouseofRepresentativesDistrict') && $scope.searchUsers[i].office != 'unitedStatesSenate') {
                      $scope.searchUsersByType.push($scope.searchUsers[i]);
                    } else {
                      $scope.searchUsersByType.push($scope.searchUsers[i]);
                    }
                  } else {
                    $scope.searchUsersByType.push($scope.searchUsers[i]);
                  }
                  */
                  } else if (
                    type == "federal" &&
                    (polivar.levelOfGov == "federalCongressionalDistrict" ||
                      polivar.officeName == "president" ||
                      (polivar.officeName == "President" &&
                        polivar.levelOfGov == "All USA") ||
                      polivar.levelOfGov == "all USA" ||
                      (polivar.levelOfGov == "statePostalCode" &&
                        polivar.officeName != "" &&
                        polivar.officeName != "State House") ||
                      polivar.officeName != "auditor" ||
                      (polivar.officeName != "" &&
                        polivar.officeName.toLowerCase() == "u.s. senate" &&
                        polivar.candidateStatus != "inactive"))
                  ) {
                    // alert('come');
                    // $scope.showfederal = true;
                    // if (type == 'federal') {
                    //   $scope.searchUsersByType.length = 0;
                    //   $scope.sortype = "federal";
                    // }
                    // //MyService.ConsoleLog("unifiedSchoolDistrictName >>>", $scope.searchUsers[i].voterScope);
                    // MyService.ConsoleLog("!!!!!!!! 4 !!!!!!!!!!!!!", udata);
                    // MyService.ConsoleLog("Federal", polivar.levelOfGov);

                    // $scope.changeTab($scope.searchUsers[i]);
                    if (polivar.levelOfGov != "unifiedSchoolDistrictName") {
                      // MyService.ConsoleLog("check federal",typeof udata.isOnBallot);
                      if (polivar.officeName) {
                        polivar.officeName = polivar.officeName.toLowerCase();
                        if (typeof polivar.party == "string") {
                          // alert('one');
                          polivar.party = polivar.party;
                        } else {
                          var party = "";
                          polivar.party.forEach(function (element, index) {
                            if (element) {
                              party += element + ", ";
                              var n = party.lastIndexOf(",");
                              var a = party.substring(0, n);
                              //// MyService.ConsoleLog("Element", party);
                              udata.party = a;
                            }
                          });
                        }
                        udata.office = polivar.officeName;
                        udata.candidateStatus = polivar.candidateStatus;
                        // udata.party = polivar.party;
                      }
                      // $scope.sortype = "";
                      if (
                        (polivar.officeName &&
                          polivar.officeName.toLowerCase() == "u.s. house") ||
                        polivar.officeName.toLowerCase() == "u.s. senate" ||
                        polivar.officeName.toLowerCase() == "president"
                      ) {
                        if (typeof polivar.party == "string") {
                          if ($scope.comp.party && $scope.comp.party != "") {
                            if (
                              $scope.comp.party == udata.politicianInfo[s].party
                            ) {
                              if (
                                udata.isOnBallot != false &&
                                $scope.comp.election.electionDate ==
                                  udata.electionDate
                              ) {
                                $scope.topCandidates.push(udata);
                              } else {
                                $scope.searchUsersByType.push(udata);
                              }
                            }
                          } else {
                            if (
                              udata.isOnBallot != false &&
                              $scope.comp.election.electionDate ==
                                udata.electionDate
                            ) {
                              $scope.topCandidates.push(udata);
                            } else {
                              $scope.searchUsersByType.push(udata);
                            }
                          }
                        } else {
                          if ($scope.comp.party && $scope.comp.party != "") {
                            if (
                              udata.politicianInfo[s].party.indexOf(
                                $scope.comp.party
                              ) != -1
                            ) {
                              if (
                                udata.isOnBallot != false &&
                                $scope.comp.election.electionDate ==
                                  udata.electionDate
                              ) {
                                $scope.topCandidates.push(udata);
                              } else {
                                $scope.searchUsersByType.push(udata);
                              }
                            }
                          } else {
                            if (
                              udata.isOnBallot != false &&
                              $scope.comp.election.electionDate ==
                                udata.electionDate
                            ) {
                              $scope.topCandidates.push(udata);
                            } else {
                              $scope.searchUsersByType.push(udata);
                            }
                          }
                        }

                        // $scope.searchUsersByType.push(udata);
                        //// MyService.ConsoleLog("searchUsersByType federal>>> ", $scope.searchUsersByType);
                      }
                      //// MyService.ConsoleLog(" $scope.searchUsersByType !!!", $scope.searchUsersByType);
                    }
                    // MyService.ConsoleLog("$scope.topCandidates", $scope.topCandidates.length);
                    // else if ($scope.searchUsers[i].voterScope != 'placeName') {
                    //   $scope.searchUsers[i].office = $scope.searchUsers[i].office.toLowerCase();
                    //   $scope.searchUsersByType.push($scope.searchUsers[i]);
                    // }

                    /*
                  if ($scope.searchUsers[i].office) {
                    if ($scope.searchUsers[i].voterScope == 'state' && $scope.searchUsers[i].office == 'unitedStatesSenate') {
                      $scope.searchUsersByType.push($scope.searchUsers[i]);
                    } else {
                      $scope.searchUsersByType.push($scope.searchUsers[i]);
                    }
                  } else {
                    $scope.searchUsersByType.push($scope.searchUsers[i]);
                  }
                  */
                  } else if (
                    type == "other" &&
                    (polivar.levelOfGov == "All USA" ||
                      polivar.levelOfGov == "all USA") &&
                    polivar.officeName != "president" &&
                    polivar.candidateStatus != "inactive"
                  ) {
                    // MyService.ConsoleLog("!!!!!!!! 5 !!!!!!!!!!!!!", polivar);
                    // $scope.changeTab($scope.searchUsers[i]);
                    // $scope.showother = true;
                    // $scope.showlocal = true;
                    // if (type == 'other') {
                    //   $scope.searchUsersByType.length = 0;
                    //   $scope.sortype = "other";
                    // }
                    // $scope.sortype = "other";

                    // var sle = $scope.searchUsersByType.length;
                    // for (var s = 0; s < sle; s++) {
                    //   //// MyService.ConsoleLog("sinsisi >", $scope.searchUsersByType[s].voterScope)
                    //   if ($scope.searchUsersByType[s].voterScope != "All USA") {
                    //     $scope.searchUsersByType.splice(s, 1);
                    //   }
                    // }
                    //// MyService.ConsoleLog("slen >", sle, $scope.searchUsersByType);
                    // if ($scope.searchUsers[i].voterScope == "All USA") {
                    // $scope.searchUsersByType.length = 0;
                    if (polivar.officeName) {
                      polivar.officeName = polivar.officeName.toLowerCase();
                      udata.office = polivar.officeName;
                      udata.candidateStatus = polivar.candidateStatus;
                      udata.party = polivar.party;
                    }
                    // if (udata.politicianInfo[s].runningForOffice = "Y" && udata.politicianInfo[s].incumbent != "") {
                    //   $scope.searchUsersByType.push(udata);
                    //  // MyService.ConsoleLog(" udata.office IF", udata.office);

                    // } else {
                    //// MyService.ConsoleLog(" udata.office ELSE", udata.office);
                    $scope.searchUsersByType.push(udata);
                    // }

                    // }
                  }
                } else {
                  // console.log("no voterScope");
                  if (
                    udata.running_for &&
                    udata.running_for.levelOfGov &&
                    udata.running_for.levelOfGov != ""
                  ) {
                    if (
                      type == "local" &&
                      (udata.running_for.levelOfGov == "placeName" ||
                        udata.running_for.levelOfGov ==
                          "countySubDivisionName" ||
                        udata.running_for.levelOfGov ==
                          "unifiedSchoolDistrictName" ||
                        udata.running_for.levelOfGov ==
                          "cityCouncilDistrictName" ||
                        udata.running_for.levelOfGov ==
                          "elementarySchoolDistrictName" ||
                        udata.running_for.levelOfGov ==
                          "secondarySchoolDistrictName")
                    ) {
                      udata.office = udata.office.toLowerCase();
                      $scope.searchUsersByType.push(udata);
                    } else if (
                      type == "county" &&
                      (udata.running_for.levelOfGov == "countyName" ||
                        udata.running_for.levelOfGov == "county")
                    ) {
                      udata.office = udata.office.toLowerCase();
                      $scope.searchUsersByType.push(udata);
                    } else if (
                      type == "state" &&
                      (udata.electionOfficeTypeId == "G" ||
                        udata.electionOfficeTypeId == "S" ||
                        udata.electionOfficeTypeId == "K" ||
                        udata.electionOfficeTypeId == "L" ||
                        udata.electionOfficeTypeId == "P")
                    ) {
                      // alert('new');

                      udata.office = udata.office.toLowerCase();
                      if (typeof udata.party == "string") {
                        // alert('one');
                        udata.party = udata.party;
                      } else {
                        var party = "";
                        udata.party.forEach(function (element, index) {
                          if (element) {
                            party += element + ", ";
                            var n = party.lastIndexOf(",");
                            var a = party.substring(0, n);
                            //// MyService.ConsoleLog("Element", party);
                            udata.party = a;
                          }
                        });
                      }
                      if (
                        udata.verifiedUser != false &&
                        udata.office &&
                        udata.office.toLowerCase() != "u.s. house" &&
                        udata.office.toLowerCase() != "president"
                      ) {
                        $scope.searchUsersByType.push(udata);
                      }
                      /*
                    if ($scope.searchUsers[i].office) {

                      if (($scope.searchUsers[i].running_for.levelOfGov == 'state' || $scope.searchUsers[i].running_for.levelOfGov == 'statePostalCode' || $scope.searchUsers[i].running_for.levelOfGov == 'stateSenateDistrict' || $scope.searchUsers[i].running_for.levelOfGov == 'stateHouseofRepresentativesDistrict') && $scope.searchUsers[i].office != 'unitedStatesSenate') {
                        $scope.searchUsersByType.push($scope.searchUsers[i]);
                      } else {
                        $scope.searchUsersByType.push($scope.searchUsers[i]);
                      }
                    } else {
                      $scope.searchUsersByType.push($scope.searchUsers[i]);
                    }
                    */
                    } else if (
                      type == "federal" &&
                      (udata.electionOfficeTypeId == "P" ||
                        udata.electionOfficeTypeId == "C" ||
                        udata.electionOfficeTypeId == "J")
                    ) {
                      udata.office = udata.office.toLowerCase();
                      if (typeof udata.party == "string") {
                        // alert('one');
                        udata.party = udata.party;
                      } else {
                        var party = "";
                        udata.party.forEach(function (element, index) {
                          if (element) {
                            party += element + ", ";
                            var n = party.lastIndexOf(",");
                            var a = party.substring(0, n);
                            //// MyService.ConsoleLog("Element", party);
                            udata.party = a;
                          }
                        });
                      }

                      // $scope.searchUsersByType.push(udata);
                      if (udata && udata.isOnBallot != true) {
                        $scope.searchUsersByType.push(udata);
                      } else {
                        $scope.topCandidates.push(udata);
                      }
                      /*
                    if ($scope.searchUsers[i].office) {
                      if ($scope.searchUsers[i].running_for.levelOfGov == 'state' && $scope.searchUsers[i].office == 'unitedStatesSenate') {
                        $scope.searchUsersByType.push($scope.searchUsers[i]);
                      } else {
                        $scope.searchUsersByType.push($scope.searchUsers[i]);
                      }
                    } else {
                      $scope.searchUsersByType.push($scope.searchUsers[i]);
                    }
                    */
                    } // else if(type == 'other') {
                    //   $scope.searchUsersByType.push($scope.searchUsers[i]);
                    // }
                  } else if (type == "other") {
                    udata.office = udata.office.toLowerCase();
                    $scope.searchUsersByType.push(udata);
                  }
                }
              }
            }
          }
        } else {
          // MyService.ConsoleLog("in sir", udata.voterScope);
          // MyService.ConsoleLog("udata >", udata);
          if (!tflag) {
            // alert("blink");
            switch (udata.voterScope) {
              case "placeName":
                $scope.showlocal = true;

                // $scope.sortype = "local";
                if (!type) type = "local";
                break;
              case "countySubdivision":
                // $scope.sortype = "local";
                $scope.showlocal = true;

                if (!type) type = "local";
                break;
              case "unifiedSchoolDistrictName":
                $scope.showlocal = true;

                // $scope.sortype = "local";
                if (!type) type = "local";
                break;
              case "All USA":
              case "all USA":
                var ncoff = udata.office;
                if (ncoff.toLowerCase() != "president") {
                  // $scope.sortype = "other";
                  if (!type) type = "other";
                  $scope.showother = true;
                } else {
                  $scope.sortype = "federal";
                  if (!type) type = "federal";
                  $scope.showfederal = true;
                  $scope.showother = false;
                }
                break;
              case "countyName":
                $scope.showcounty = true;
                // $scope.sortype = "county";
                if (!type) type = "county";
                break;
              case "statePostalCode":
                var ncoff = udata.office;
                if (ncoff.toLowerCase() != "u.s. senate") {
                  // $scope.sortype = "other";
                  $scope.showstate = true;
                  $scope.showfederal = true;
                  $scope.sortype = "state";
                  if (!type) type = "state";
                } else if (ncoff.toLowerCase() != "president") {
                  $scope.sortype = "federal";
                  if (!type) type = "federal";
                  $scope.showfederal = true;
                  $scope.showother = false;
                } else {
                  $scope.sortype = "federal";
                  if (!type) type = "federal";
                  $scope.showfederal = true;
                  $scope.showother = false;
                }
                break;
              case "stateHouseofRepresentativesDistrict":
                var ncoff = udata.office;
                if (ncoff.toLowerCase() != "president") {
                  // $scope.sortype = "other";
                  $scope.showstate = true;
                  $scope.sortype = "state";
                  if (!type) type = "state";
                } else {
                  $scope.sortype = "federal";
                  if (!type) type = "federal";
                  $scope.showfederal = true;
                  $scope.showother = false;
                }
                break;
              case "federalCongressionalDistrict":
                $scope.sortype = "federal";
                if (!type) type = "federal";
                $scope.showfederal = true;
                break;
              default:
                break;
            }
            //// MyService.ConsoleLog("type in", type);
          } else {
            //// MyService.ConsoleLog("$scope.searchUsers[i].voterScope >>", $scope.searchUsers[i]);
            // $scope.changeTab($scope.searchUsers[i].voterScope);
            switch (udata.voterScope) {
              case "placeName":
                // $scope.sortype = "local";
                if (!type) type = "local";
                $scope.showlocal = true;
                break;
              case "countySubdivision":
                // $scope.sortype = "local";
                if (!type) type = "local";
                $scope.showlocal = true;
                break;
              case "unifiedSchoolDistrictName":
                $scope.showlocal = true;
                if (!type) type = "local";
                break;
              case "All USA":
              case "all USA":
                //MyService.ConsoleLog("$scope.searchUsers[i].office >", $scope.searchUsers[i].office);
                var ncoff = udata.office;
                if (ncoff.toLowerCase() != "president") {
                  // $scope.sortype = "other";
                  if (!type) type = "other";
                  $scope.showother = true;
                } else {
                  // $scope.sortype = "federal";
                  if (!type) type = "federal";
                  $scope.showfederal = true;
                  $scope.showother = false;
                }
                break;
              case "countyName":
                // $scope.sortype = "county";
                if (!type) type = "county";
                $scope.showcounty = true;
                break;
              case "statePostalCode":
                var ncoff = udata.office;
                if (ncoff.toLowerCase() != "u.s. senate") {
                  // $scope.sortype = "other";
                  $scope.showstate = true;
                  $scope.showfederal = true;
                  $scope.sortype = "state";
                  if (!type) type = "state";
                } else if (ncoff.toLowerCase() != "president") {
                  $scope.sortype = "federal";
                  if (!type) type = "federal";
                  $scope.showfederal = true;
                  $scope.showother = false;
                } else {
                  $scope.sortype = "federal";
                  if (!type) type = "federal";
                  $scope.showfederal = true;
                  $scope.showother = false;
                }
                break;
              case "stateHouseofRepresentativesDistrict":
                var ncoff = udata.office;
                if (ncoff.toLowerCase() != "president") {
                  // $scope.sortype = "other";
                  $scope.showstate = true;
                  $scope.sortype = "state";
                  if (!type) type = "state";
                } else {
                  $scope.sortype = "federal";
                  if (!type) type = "federal";
                  $scope.showfederal = true;
                  $scope.showother = false;
                }
                break;
              case "federalCongressionalDistrict":
                $scope.showfederal = true;
                if (!type) type = "federal";
                break;
              default:
                break;
            }
          }
          // $scope.searchUsersByType.length = 0;

          if (udata.voterScope) {
            // MyService.ConsoleLog(" Yogesh  >>>>>>> type for voterscope", type);
            // MyService.ConsoleLog("Yogesh =>>>>>>>>>> sort type for voterscope", $scope.sortype);

            // alert('in');
            if (
              type == "local" &&
              (udata.voterScope == "placeName" ||
                udata.voterScope == "countySubDivisionName" ||
                udata.voterScope == "unifiedSchoolDistrictName" ||
                udata.voterScope == "elementarySchoolDistrictName" ||
                udata.voterScope == "cityCouncilDistrictName" ||
                udata.voterScope == "secondarySchoolDistrictName" ||
                (udata.voterScope == "countySubdivision" &&
                  udata.voterScope != "federalCongressionalDistrict"))
            ) {
              udata.office = udata.office.toLowerCase();
              if (typeof udata.party == "string") {
                // alert('one');
                udata.party = udata.party;
              } else {
                var party = "";
                udata.party.forEach(function (element, index) {
                  if (element) {
                    party += element + ", ";
                    var n = party.lastIndexOf(",");
                    var a = party.substring(0, n);
                    // MyService.ConsoleLog("a", a);
                    if (a != '""') {
                      MyService.ConsoleLog("Element  inside", a);
                      udata.party = a;
                    } else {
                      udata.party = "";
                    }
                  }
                });
              }

              // MyService.ConsoleLog("welcome");
              if (
                udata &&
                udata.office &&
                udata.office.toLowerCase() != "president"
              ) {
                if (udata.verifiedUser != false) {
                  $scope.searchUsersByType.push(udata);
                }
              }

              // }
            } else if (
              type == "county" &&
              (udata.voterScope == "countyName" || udata.voterScope == "county")
            ) {
              udata.office = udata.office.toLowerCase();
              if (typeof udata.party == "string") {
                // alert('one');
                udata.party = udata.party;
              } else {
                var party = "";
                udata.party.forEach(function (element, index) {
                  if (element) {
                    party += element + ", ";
                    var n = party.lastIndexOf(",");
                    var a = party.substring(0, n);
                    //// MyService.ConsoleLog("Element", party);
                    udata.party = a;
                  }
                });
              }
              if (udata.verifiedUser != false) {
                $scope.searchUsersByType.push(udata);
              }

              // }
            } else if (
              type == "state" &&
              (udata.electionOfficeTypeId == "S" ||
                udata.electionOfficeTypeId == "K" ||
                udata.electionOfficeTypeId == "L" ||
                udata.voterScope == "statePostalCode")
            ) {
              // alert('mm')
              // $scope.showfederal = true;
              MyService.ConsoleLog("plz check ========", udata.voterScope);
              udata.office = udata.office.toLowerCase();
              if (typeof udata.party == "string") {
                // alert('one');
                udata.party = udata.party;
              } else {
                var party = "";
                udata.party.forEach(function (element, index) {
                  if (element) {
                    party += element + ", ";
                    var n = party.lastIndexOf(",");
                    var a = party.substring(0, n);
                    //// MyService.ConsoleLog("Element", party);
                    udata.party = a;
                  }
                });
              }
              // MyService.ConsoleLog("yogesh got it >>>>>>>>>", udata.office)
              if (
                udata.verifiedUser != false &&
                udata.office &&
                udata.office.toLowerCase() != "u.s. house" &&
                udata.office.toLowerCase() != "president"
              ) {
                $scope.searchUsersByType.push(udata);
              }
              /*****************************************************************
               * commented by vishal $scope.searchUsers.electionOfficeTypeId == 'G' ||
               *
               *****************************************************************/

              /*
            udata.voterScope == "statePostalCode" && udata.officeName != 'president'
            if ($scope.searchUsers[i].office) {

              if (($scope.searchUsers[i].voterScope == 'state' || $scope.searchUsers[i].voterScope == 'statePostalCode' || $scope.searchUsers[i].voterScope == 'stateSenateDistrict' || $scope.searchUsers[i].voterScope == 'stateHouseofRepresentativesDistrict') && $scope.searchUsers[i].office != 'unitedStatesSenate') {
                $scope.searchUsersByType.push($scope.searchUsers[i]);
              } else {
                $scope.searchUsersByType.push($scope.searchUsers[i]);
              }
            } else {
              $scope.searchUsersByType.push($scope.searchUsers[i]);
            }
            */
            } else if (
              type == "federal" &&
              (udata.electionOfficeTypeId == "C" ||
                udata.electionOfficeTypeId == "J" ||
                udata.electionOfficeTypeId == "R" ||
                udata.voterScope == "federalCongressionalDistrict" ||
                udata.office == "president" ||
                (udata.office == "President" &&
                  udata.voterScope == "All USA") ||
                udata.voterScope == "all USA" ||
                udata.voterScope == "statePostalCode")
            ) {
              // alert('4');
              // && udata.politicianInfo[0].levelOfGov == "All USA" || udata.politicianInfo[0].levelOfGov == "all USA"
              // $scope.showfederal = true;
              // //MyService.ConsoleLog("unifiedSchoolDistrictName >>>", $scope.searchUsers[i].voterScope);
              // MyService.ConsoleLog("!!!!!!!! 4 !!!!!!!!!!!!!", udata);
              // $scope.changeTab($scope.searchUsers[i]);
              if (udata.voterScope != "unifiedSchoolDistrictName") {
                udata.office = udata.office.toLowerCase();
                // $scope.sortype = "";
                if (typeof udata.party == "string") {
                  // alert('one');
                  udata.party = udata.party;
                } else {
                  var party = "";
                  udata.party.forEach(function (element, index) {
                    if (element) {
                      party += element + ", ";
                      var n = party.lastIndexOf(",");
                      var a = party.substring(0, n);
                      //// MyService.ConsoleLog("Element", party);
                      udata.party = a;
                    }
                  });
                }
                // $scope.sortype = "fedesampleral";
                // var fle = $scope.searchUsersByType.length;
                // for (var f = 0; f < fle; f++) {
                //   // MySgetLocalPoliticianservice.ConsoleLog("sinsisi >", $scope.searchUsersByType[s].voterScope)
                //   if ($scope.searchUsersByType[f].voterScope != "federal" || $scope.searchUsersByType[f].voterScope != "All USA") {
                //     $scope.searchUsersByType.splice(f, 1);
                //   }
                // }
                if (
                  (udata.office &&
                    udata.office.toLowerCase() == "u.s. house") ||
                  udata.office.toLowerCase() == "u.s. senate" ||
                  udata.office.toLowerCase() == "president"
                ) {
                  if (udata.verifiedUser != false) {
                    if (
                      udata.isOnBallot != false &&
                      $scope.comp.election.electionDate == udata.electionDate
                    ) {
                      // MyService.ConsoleLog('$scope.searchUsersByType', $scope.searchUsersByType.length);
                      $scope.topCandidates.push(udata);
                    } else {
                      $scope.searchUsersByType.push(udata);
                    }
                  }
                }
              }

              // else if ($scope.searchUsers[i].voterScope != 'placeName') {
              //   $scope.searchUsers[i].office = $scope.searchUsers[i].office.toLowerCase();
              //   $scope.searchUsersByType.push($scope.searchUsers[i]);
              // }

              /*
            if ($scope.searchUsers[i].office) {
              if ($scope.searchUsers[i].voterScope == 'state' && $scope.searchUsers[i].office == 'unitedStatesSenate') {
                $scope.searchUsersByType.push($scope.searchUsers[i]);
              } else {
                $scope.searchUsersByType.push($scope.searchUsers[i]);
              }
            } else {
              $scope.searchUsersByType.push($scope.searchUsers[i]);
            }
            */
            } else if (
              type == "other" &&
              (udata.voterScope == "All USA" || udata.voterScope == "all USA")
            ) {
              // alert('5');
              // MyService.ConsoleLog("!!!!!!!! 5 !!!!!!!!!!!!!", $scope.searchUsersByType);
              // && (udata.office != "president")
              // $scope.changeTab($scope.searchUsers[i]);
              // $scope.showother = true;
              // $scope.showlocal = true;

              // $scope.sortype = "other";
              // $scope.searchUsersByType.length = 0;
              // var sle = $scope.searchUsersByType.length;
              // for (var s = 0; s < sle; s++) {
              //   //// MyService.ConsoleLog("sinsisi >", $scope.searchUsersByType[s].voterScope)
              //   if ($scope.searchUsersByType[s].voterScope != "All USA") {
              //     $scope.searchUsersByType.splice(s, 1);
              //   }
              // }
              //// MyService.ConsoleLog("slen >", sle, $scope.searchUsersByType);
              // if ($scope.searchUsers[i].voterScope == "All USA") {
              // $scope.searchUsersByType.length = 0;
              // MyService.ConsoleLog("udata", udata);
              if (udata.verifiedUser != false) {
                $scope.searchUsersByType.push(udata);
              }
              // }
            } else if (
              udata.office == "president" ||
              (udata.office == "President" && udata.voterScope == "All USA") ||
              udata.voterScope == "all USA"
            ) {
              // MyService.ConsoleLog("check", udata.voterScope);
              // MyService.ConsoleLog(" Yogesh  >>>>>>> type for voterscope", type);
              // type = 'federal';
              if (udata.voterScope != "unifiedSchoolDistrictName") {
                udata.office = udata.office.toLowerCase();
                // $scope.sortype = "";
                if (typeof udata.party == "string") {
                  // alert('one');
                  udata.party = udata.party;
                } else {
                  var party = "";
                  udata.party.forEach(function (element, index) {
                    if (element) {
                      party += element + ", ";
                      var n = party.lastIndexOf(",");
                      var a = party.substring(0, n);
                      //// MyService.ConsoleLog("Element", party);
                      udata.party = a;
                    }
                  });
                }
                // $scope.sortype = "fedesampleral";
                // var fle = $scope.searchUsersByType.length;
                // for (var f = 0; f < fle; f++) {
                //   // MySgetLocalPoliticianservice.ConsoleLog("sinsisi >", $scope.searchUsersByType[s].voterScope)
                //   if ($scope.searchUsersByType[f].voterScope != "federal" || $scope.searchUsersByType[f].voterScope != "All USA") {
                //     $scope.searchUsersByType.splice(f, 1);
                //   }
                // }

                if (
                  udata.verifiedUser != false &&
                  type != "state" &&
                  type != "local"
                ) {
                  $scope.searchUsersByType.push(udata);
                }
              }
            }
          } else {
            // alert('no')
            if (
              udata.running_for &&
              udata.running_for.levelOfGov &&
              udata.running_for.levelOfGov != ""
            ) {
              if (
                type == "local" &&
                (udata.running_for.levelOfGov == "placeName" ||
                  udata.running_for.levelOfGov == "countySubDivisionName" ||
                  udata.running_for.levelOfGov == "unifiedSchoolDistrictName" ||
                  udata.running_for.levelOfGov == "cityCouncilDistrictName" ||
                  udata.running_for.levelOfGov ==
                    "elementarySchoolDistrictName" ||
                  udata.running_for.levelOfGov == "secondarySchoolDistrictName")
              ) {
                udata.office = udata.office.toLowerCase();
                $scope.searchUsersByType.push(udata);
              } else if (
                type == "county" &&
                (udata.running_for.levelOfGov == "countyName" ||
                  udata.running_for.levelOfGov == "county")
              ) {
                udata.office = udata.office.toLowerCase();
                $scope.searchUsersByType.push(udata);
              } else if (
                type == "state" &&
                (udata.electionOfficeTypeId == "G" ||
                  udata.electionOfficeTypeId == "S" ||
                  udata.electionOfficeTypeId == "K" ||
                  udata.electionOfficeTypeId == "L" ||
                  udata.electionOfficeTypeId == "P")
              ) {
                udata.office = udata.office.toLowerCase();

                $scope.searchUsersByType.push(udata);

                /*
              if ($scope.searchUsers[i].office) {

                if (($scope.searchUsers[i].running_for.levelOfGov == 'state' || $scope.searchUsers[i].running_for.levelOfGov == 'statePostalCode' || $scope.searchUsers[i].running_for.levelOfGov == 'stateSenateDistrict' || $scope.searchUsers[i].running_for.levelOfGov == 'stateHouseofRepresentativesDistrict') && $scope.searchUsers[i].office != 'unitedStatesSenate') {
                  $scope.searchUsersByType.push($scope.searchUsers[i]);
                } else {
                  $scope.searchUsersByType.push($scope.searchUsers[i]);
                }
              } else {
                $scope.searchUsersByType.push($scope.searchUsers[i]);
              }
              */
              } else if (
                type == "federal" &&
                (udata.electionOfficeTypeId == "P" ||
                  udata.electionOfficeTypeId == "C" ||
                  udata.electionOfficeTypeId == "J")
              ) {
                udata.office = udata.office.toLowerCase();
                if (typeof udata.party == "string") {
                  // alert('one');
                  udata.party = udata.party;
                } else {
                  var party = "";
                  udata.party.forEach(function (element, index) {
                    if (element) {
                      party += element + ", ";
                      //// MyService.ConsoleLog("Element", party);
                      udata.party = party;
                    }
                  });
                }

                $scope.searchUsersByType.push(udata);
                /*
              if ($scope.searchUsers[i].office) {
                if ($scope.searchUsers[i].running_for.levelOfGov == 'state' && $scope.searchUsers[i].office == 'unitedStatesSenate') {
                  $scope.searchUsersByType.push($scope.searchUsers[i]);
                } else {
                  $scope.searchUsersByType.push($scope.searchUsers[i]);
                }
              } else {
                $scope.searchUsersByType.push($scope.searchUsers[i]);
              }
              */
              } // else if(type == 'other') {
              //   $scope.searchUsersByType.push($scope.searchUsers[i]);
              // }
            } else if (type == "other") {
              udata.office = udata.office.toLowerCase();
              $scope.searchUsersByType.push(udata);
            }
          }
        }
        // MyService.ConsoleLog("Typ End", type);
        // MyService.ConsoleLog("searchUsersByType >>> ", $scope.searchUsersByType);
        $scope.showLoader = false;

        if (type != "") {
          // $scope.sortype = "";
          $scope.searchUsersByType.filter(function (itms) {
            // MyService.ConsoleLog("itms", itms);
            if (
              $scope.comp.election.electionDate == itms.electionDate ||
              $scope.comp.election.electionDate == itms.electionYear
            ) {
              //     $scope.sortype =
              $scope.sortype = type;
              return itms;
            }
          });
          // MyService.ConsoleLog("type more", $scope.showlocal);

          // MyService.ConsoleLog("type more", type);

          // MyService.ConsoleLog("check", $scope.topCandidates.length);
        }
      };

      $scope.checkElectionDate = function () {
        var curDate = new Date();
        var smpArr = $scope.searchUsers.filter(function (itms) {
          if (itms.electionDate >= curDate.toISOString().split("T")[0]) {
            if (itms && itms.politicianInfo && itms.politicianInfo.length > 0) {
              var pLens = itms.politicianInfo.length;
              for (var j = 0; j < pLens; j++) {
                if (itms.politicianInfo[j].runningForOffice == "Y") {
                  // MyService.ConsoleLog(
                  //   "itms.politicianInfo[j].levelOfGov",
                  //   itms.politicianInfo[j].levelOfGov
                  // );
                  switch (itms.politicianInfo[j].levelOfGov) {
                    case "placeName":
                      $scope.getByType("local", "");
                      break;
                    case "countyName":
                      $scope.getByType("county", "");
                      break;
                    case "statePostalCode":
                      $scope.getByType("state", "");
                      break;
                    case "stateSenateDistrict":
                      $scope.getByType("state", "");
                      break;
                    case "federalCongressionalDistrict":
                      $scope.getByType("federal", "");
                      break;
                    case "All USA":
                    case "all USA":
                      $scope.getByType("federal", "");
                      break;
                    default:
                      break;
                  }
                } else {
                  return;
                }
              }
            } else {
              switch (itms.voterScope) {
                case "placeName":
                  $scope.getByType("local", "");
                  break;
                case "countyName":
                  $scope.getByType("county", "");
                  break;
                case "statePostalCode":
                  $scope.getByType("state", "");
                  break;
                case "stateSenateDistrict":
                  $scope.getByType("state", "");
                  break;
                case "federalCongressionalDistrict":
                  $scope.getByType("federal", "");
                  break;
                case "All USA":
                case "all USA":
                  $scope.getByType("federal", "");
                  break;
                default:
                  break;
              }
            }
          }
        });
      };

      $scope.searchUsers = [];
      $scope.searchUsersByType = [];
      $scope.sortype = "local";
      $scope.showParty = false;

      $scope.getByType = function (type, tflag) {
        $scope.showlocal = false;
        $scope.showcounty = false;
        $scope.showstate = false;
        $scope.showfederal = false;
        $scope.showother = false;
        // $cookies.remove('electionDate');
        $cookies.put("elecDateForRate", $scope.comp.election.electionDate);
        // console.log("type : " + type);
        // if (type) {
        //   $scope.sortype = type;
        //  // MyService.ConsoleLog("sortType", $scope.sortype);
        // } else {
        //   type = $scope.sortype;
        //  // MyService.ConsoleLog("type >>", type);
        // }
        $scope.searchUsersByType = [];
        $scope.topCandidates = [];
        var len = $scope.searchUsers.length;
        // MyService.ConsoleLog(" $scope.searchUsers", $scope.searchUsers);
        // if (type && type != "") {
        // alert('call');
        if (len > 0) {
          $scope.getBallotByType("local");
          for (var x = 0; x < len; x++) {
            if ($scope.searchUsers[x].typeOfElection != "Primary") {
              $scope.showParty = false;
              break;
            }
          }
          for (var i = 0; i < len; i++) {
            var today = new Date();
            // return u
            // MyService.ConsoleLog("nssssssssss", $scope.comp);
            // if ($scope.searchUsers[i].generalElection && $scope.searchUsers[i].generalElection != '') {
            //   if ($scope.searchUsers[i].generalElection >= today.toISOString().split('T')[0]) {
            //     $scope.searchUsers[i].electionDate = $scope.searchUsers[i].generalElection;
            //   }
            // }

            if (
              $scope.searchUsers[i].electionDate >=
              today.toISOString().split("T")[0]
            ) {
              if (
                $scope.comp.election.electionDate &&
                $scope.comp.election.electionDate != ""
              ) {
                if (
                  $scope.searchUsers[i].electionDate ==
                  $scope.comp.election.electionDate
                ) {
                  //MyService.ConsoleLog("tflag >>", tflag);

                  if (
                    $scope.searchUsers[i].typeOfElection == "Primary" &&
                    $scope.searchUsers[i].party
                  ) {
                    //// MyService.ConsoleLog("$scope.searchUsers", $scope.searchUsers[i].name);
                    // alert("inside");
                    $scope.showParty = true;
                    // MyService.ConsoleLog("if");
                  } else {
                    // MyService.ConsoleLog("else");
                    // $scope.showParty = false;
                  }

                  if (
                    $scope.searchUsers[i].party &&
                    $scope.searchUsers[i].party.length > 0 &&
                    $scope.comp.party &&
                    $scope.comp.party != ""
                  ) {
                    if ($scope.searchUsers[i].party == $scope.comp.party) {
                      $scope.checkParty(tflag, $scope.searchUsers[i], type);
                    }
                  } else {
                    // console.log("sample");
                    // if ($scope.comp.election.electionDate == "2020-11-03") {
                    //   type = "";
                    //   type = "federal";
                    // }

                    var setFlag;
                    // var filter_Data =
                    // console.log("start type", $scope.searchUsers[i]);

                    $scope.checkParty(tflag, $scope.searchUsers[i], type);
                  }
                }
              }
            }
            if (i == len - 1) {
              // console.log("FINAL : ", $scope.searchUsersByType);
            }
          }
        }
        // }
      };

      $scope.getAddress = function () {
        $scope.Address = true;
        $scope.showAddressDropDown = false;
        $scope.Zip = false;
        $scope.Link = false;
      };

      // get Address from google api
      var options = {
        componentRestrictions: {
          country: "us",
        },
        types: ["geocode"],
      };

      $scope.detectAddress = function (ent) {
        var val = document.getElementById("address");
        // console.log($scope.User.Address);
        var autocomplete = new google.maps.places.Autocomplete(val, options);

        google.maps.event.addListener(
          autocomplete,
          "place_changed",
          function () {
            var place = autocomplete.getPlace();

            var lat = place.geometry.location.lat(),
              lng = place.geometry.location.lng();

            $scope.lati = lat.toFixed(6);
            $scope.lon = lng.toFixed(6);
            // console.log($scope.lati);
            // console.log($scope.lon);

            $scope.mailing_Address = place.formatted_address;
            // console.log($scope.mailing_Address);
            for (var i = 0; i < place.address_components.length; i++) {
              for (
                var j = 0;
                j < place.address_components[i].types.length;
                j++
              ) {
                if (
                  place.address_components[i].types[j] ==
                  "administrative_area_level_1"
                ) {
                  $scope.statePostalCode =
                    place.address_components[i].short_name;
                  // console.log($scope.statePostalCode);
                }
                if (place.address_components[i].types[j] == "country") {
                  $scope.countryname = place.address_components[i].long_name;
                  // console.log($scope.countryname);
                }
                if (
                  place.address_components[i].types[j] ==
                  "administrative_area_level_2"
                ) {
                  $scope.county_name = place.address_components[i].long_name;
                  // console.log($scope.county_name);
                }
                if (place.address_components[i].types[j] == "locality") {
                  $scope.place_name = place.address_components[i].long_name;
                  // console.log($scope.place_name);
                }
                if (place.address_components[i].types[j] == "postal_code") {
                  // document.getElementById('zip').value = place.address_components[i].long_name;
                  // $scope.User.ZipCode = place.address_components[i].long_name;
                  // console.log($scope.User.ZipCode);
                  // console.log($scope.User.ZipCode);
                }
              }
            }

            var loc = JSON.stringify({
              longitude: $scope.lon,
              latitude: $scope.lati,
            });
            // console.log(loc);
            // $rootScope.location = new Array;
            $rootScope.location = {
              longitude: $scope.lon,
              latitude: $scope.lati,
            };
            $scope.showAddressDropDowns("", loc);
          }
        );
      };

      function getUsers(params) {
        var request = apiCall.apiCall("GET", "/user/list", params);
        $http(request).then(
          function successCallback(response) {
            // console.log("Got categories: ", response.data);
            if (response.data.success) {
              angular.forEach(response.data.data, function (val, key) {
                response.data.data[key].registeredUser = true;
                response.data.data[key].office =
                  response.data.data[key].office.toLowerCase();
              });

              $scope.setAllSelected(response.data.data);
              $scope.users = response.data.data;
              $scope.searchUsers = angular.copy($scope.users);
            } else {
              growl.error("Something went wrong.");
            }
          },
          function errorCallBack(response) {
            growl.error("Something went wrong.");
          }
        );
      }

      function getCompareAnswers(params) {
        var request = apiCall.apiCall("GET", "/answers/compare", params);
        $http(request).then(
          function successCallback(response) {
            //console.log("Got categories: ",response);
            if (response.data.success) {
              angular.forEach(response.data.data, function (val, key) {
                if (
                  val.answers &&
                  val.answers.length != $scope.selectedUser.length
                ) {
                  var check_author_exist = function (u) {
                    var len = val.answers.length;
                    for (var i = 0; i < len; i++) {
                      if (val.answers[i].author._id == u._id) {
                        return true;
                      }
                    }
                    return false;
                  };
                  angular.forEach($scope.selectedUser, function (u, i) {
                    if (!check_author_exist(u)) {
                      response.data.data[key].answers.push({
                        author: u,
                      });
                    }
                  });
                } else if (!val.answers) {
                  response.data.data[key].answers = [];
                  angular.forEach($scope.selectedUser, function (u, i) {
                    response.data.data[key].answers.push({
                      author: u,
                    });
                  });
                }
              });

              $rootScope.compareAnswerList = response.data.data;
              //console.log("compareAnswerList: ", $rootScope.compareAnswerList);
              $location.path(
                "question-compare/" + $routeParams.category_id + "/" + null
              );
            } else {
              //console.log("Something went wrong: ", response.data);
            }
          },
          function errorCallBack(response) {
            //console.log("Error: ", response);
          }
        );
      }

      $scope.statusGetLocalPoliticians = 0;
      $scope.page = 0;
      $scope.users = [];
      $scope.Location = {
        state: "",
        FinalData: "",
      };

      $scope.getLocalPoliticians = function () {
        // //MyService.ConsoleLog(" finalData >>>>>>>>>>>",$rootScope.compareFinalData);
        $scope.showLoader = true;
        $scope.statusGetLocalPoliticians = 1;
        $scope.page += 1;
        var extradata = "";
        if ($rootScope.compareFinalData && $rootScope.compareFinalData != "") {
          extradata = $rootScope.compareFinalData;
          //alert("extra");
          if ($scope.MyDialog != "") {
            $scope.MyDialog.close();
          }
        } else {
          // MyService.ConsoleLog("else", $rootScope.tempUserAddress);
          extradata = $rootScope.tempUserAddress;
        }
        console.log("extradata<><><><> : ", extradata);
        MyService.getLocalPoliForVoter({
          max_records: 100,
          page: $scope.page,
          extradata: extradata,
        }).then(
          function (response) {
            if (response.data.success) {
              $scope.setAllSelected(response.data.data);
              $rootScope.tempUserAddress = "";
              // $rootScope.compareFinalData = "";
              $scope.getBannerInfo();
              $scope.getBallotMeasures(extradata);
              // console.log("Dataaaa:::", response.data.data);

              MyService.ConsoleLog(
                "getLocalPoliticians > : ",
                response.data.data.poliData
              );

              var filPoli = response.data.data.poliData.filter(function (
                itx,
                ind
              ) {
                return (
                  ind ==
                  response.data.data.poliData.findIndex(function (obj) {
                    return JSON.stringify(obj) == JSON.stringify(itx);
                  })
                );
              });
              MyService.ConsoleLog("filPoli >>", filPoli);
              if (filPoli && filPoli.length > 0) {
                // var tmp = filPoli.filter(function (itms) {
                //   // if (itms.isOnBallot != 'true') {
                //   //   return itms;
                //   // }
                //   MyService.ConsoleLog("itms.is",itms.isOnBallot)
                // });
                // MyService.ConsoleLog("tmp new fil;ter>>", tmp);
                setTimeout(function () {
                  $scope.$apply(function () {
                    var samp = response.data.data.dates.filter(function (
                      item,
                      index,
                      self
                    ) {
                      return (
                        index ==
                        self.findIndex(function (t) {
                          // //MyService.ConsoleLog("t", t);
                          return t.electionDate == item.electionDate;
                        })
                      );

                      // return samp;
                    });
                    //MyService.ConsoleLog("Filter >>", samp);
                    if (samp && samp.length == 0) {
                      $scope.showLoader = false;
                    }
                    // //MyService.ConsoleLog("dublicates >>", [...new Set(response.data.data.dates)]);
                    var sor = samp.sort(function (a, b) {
                      return (
                        new Date(a.electionDate) - new Date(b.electionDate)
                      );
                    });
                    // MyService.ConsoleLog("Sor >", sor);
                    $scope.eleDates = sor;
                    $scope.party = response.data.data.parties.filter(function (
                      party,
                      index
                    ) {
                      return (
                        response.data.data.parties.indexOf(party) === index
                      );
                    });
                    // MyService.ConsoleLog("$scope.party", $scope.party);

                    // var parties = [];
                    // if ($scope.party && $scope.party.length > 0) {
                    //   var parties = $scope.party.filter(function (vals) {
                    //     if (vals == 'Democratic') {
                    //       return vals;
                    //     } else if (vals == 'Republican') {
                    //       return vals;
                    //     }
                    //   });
                    //   $scope.party = '';
                    //   $scope.party = parties;
                    //   $scope.party.unshift('Select Party');
                    // } else {
                    //   parties.push('Democratic');
                    //   parties.push('Republican');
                    //   $scope.party = parties;
                    //   $scope.party.unshift('Select Party');
                    // }
                    // parties.unshift('Select Party');
                    // MyService.ConsoleLog(" parties", parties);
                    MyService.ConsoleLog(" $scope.parties >>", $scope.party);
                    MyService.ConsoleLog("electionDates >>", $scope.eleDates);

                    // MyService.ConsoleLog("$scope.comp.election", $scope.comp.election);
                    if (
                      $cookies.get("electionDate") ||
                      $cookies.get("elecDateForRate")
                    ) {
                      var sml;

                      if ($cookies.get("electionDate")) {
                        sml = {
                          electionDate: $cookies.get("electionDate"),
                        };
                      } else if ($cookies.get("elecDateForRate")) {
                        sml = {
                          electionDate: $cookies.get("elecDateForRate"),
                        };
                      }

                      $scope.eleDates.unshift(sml);
                      var eleDates = $scope.eleDates.filter(function (
                        itm,
                        ind
                      ) {
                        return (
                          ind ==
                          $scope.eleDates.findIndex(function (ele) {
                            return JSON.stringify(ele) == JSON.stringify(itm);
                          })
                        );
                      });
                      $scope.eleDates = "";
                      $scope.eleDates = eleDates;
                      MyService.ConsoleLog(" $scope.eleDates", $scope.eleDates);
                      $scope.comp.election = $scope.eleDates[0];
                      $cookies.remove("electionDate");
                      $cookies.remove("elecDateForRate");
                    } else {
                      $scope.comp.election = $scope.eleDates[0];
                    }
                    // $scope.comp.party = "Democratic";
                    $scope.users = $scope.users.concat(filPoli);
                    $scope.searchUsers = angular.copy($scope.users);
                    $scope.checkElectionDate(); //set state as default
                    // $scope.getByType('local');
                  });
                }, 100);
              } else {
                growl.error("Candidates not found");
                $scope.showLoader = false;
              }

              //$scope.users = response.data.data;
              //console.log("users:::", JSON.stringify($scope.users));
              $scope.statusGetLocalPoliticians = 2;
            } else {
              $scope.page -= 1;
              $scope.statusGetLocalPoliticians = 3;
              if (typeof response.data.error == "string")
                growl.error(response.data.error);
              else growl.error("Something went wrong");
            }
          },
          function (err) {
            $scope.page -= 1;
            $scope.statusGetLocalPoliticians = 3;
            growl.error("Something went wrong");
          }
        );
      };

      $scope.getBannerInfo = function () {
        MyService.getBannerInfo({ event: "All" }).then(function (APIResponse) {
          if (APIResponse.data.success) {
            $scope.bannerInfo = APIResponse.data.data;
            MyService.ConsoleLog("$scope.bannerInfo > ", $scope.bannerInfo);
          }
        });
      };

      $scope.getBallotMeasures = function (data) {
        var dat;
        if (data) {
          dat = data;
        } else {
          dat = $scope.addressNw.address;
        }
        MyService.ConsoleLog("data", dat);
        MyService.getBallotMeasuresData({
          address: dat,
        }).then(
          function (response) {
            MyService.ConsoleLog("Response", response);
            $scope.ballot = response.data.data;
            $scope.getBallotByType("local");
          },
          function (err) {
            // MyService.ConsoleLog("Err", err);
          }
        );
      };

      /**
       * Filter ballot measures data date wise
       */
      $scope.balloType = [];
      $scope.bType = "local";
      $scope.getBallotByType = function (type) {
        $scope.shwLocal = false;
        $scope.shwCounty = false;
        $scope.shwSbCounty = false;
        $scope.shwState = false;

        if (!type) {
          $scope.type = "local";
        } else {
          $scope.type = type;
        }
        $scope.balloType = [];
        $scope.bType = type;
        if ($scope.ballot && $scope.ballot.length > 0) {
          var bLen = $scope.ballot.length;
        }
        // alert(bLen);

        if (bLen > 0) {
          for (var i = 0; i < bLen; i++) {
            // MyService.ConsoleLog("got ttnhthth type", $scope.ballot[i].electionDate + "     " + $scope.comp.election.electionDate);
            // if()
            if (
              $scope.comp.election.electionDate == $scope.ballot[i].electionDate
            ) {
              MyService.ConsoleLog(
                "$scope.ballot[i].voterScope",
                $scope.ballot[i].voterScope
              );
              switch ($scope.ballot[i].voterScope) {
                case "placeName":
                  $scope.shwLocal = true;
                  break;
                case "countyName":
                  $scope.shwCounty = true;
                  break;
                case "countySubdivision":
                  $scope.shwSbCounty = true;
                  break;
                case "statePostalCode":
                  $scope.shwState = true;
                  break;
              }
              if (
                $scope.type == "local" &&
                $scope.ballot[i].voterScope == "placeName"
              ) {
                $scope.balloType.push($scope.ballot[i]);
              } else if (
                $scope.type == "county" &&
                $scope.ballot[i].voterScope == "countyName"
              ) {
                $scope.balloType.push($scope.ballot[i]);
              } else if (
                $scope.type == "subCounty" &&
                $scope.ballot[i].voterScope == "countySubdivision"
              ) {
                $scope.balloType.push($scope.ballot[i]);
              } else if (
                $scope.type == "state" &&
                $scope.ballot[i].voterScope == "statePostalCode"
              ) {
                // $scope.shwState = true;
                $scope.balloType.push($scope.ballot[i]);
              }
            }
          }
          // MyService.ConsoleLog(" $scope.sortType", $scope.sortType);
        }
      };

      $scope.allState = [];
      $scope.MyDialog = "";
      $scope.displayContent = "";

      $scope.oldaddress = {
        state: "",
        county: "",
        countySubdivision: "",
        place: "",
      };

      $scope.address = {
        state: "",
        county: "",
        countySubdivision: "",
        place: "",
      };

      $scope.showHtmlViewer = function (content, ttl) {
        MyService.getAllStates().then(
          function (payload) {
            $scope.allState = payload;
            $scope.states = payload;
            $scope.MyDialog = ngDialog.open({
              template: "guest_location",
              scope: $scope,
              // className: 'ngdialog-theme-default'
            });
          },
          function (errorPayload) {
            growl.error("Something went wrong.");
          }
        );
      };

      // if ($rootScope.tempUserAddress && $rootScope.tempUserAddress != "") {
      //     //MyService.ConsoleLog("Inside If ");
      //     // ngDialog.close();

      //   $scope.getLocalPoliticians();
      // };

      $scope.MyDialog1 = "";
      $scope.showHtmlViewer1 = function (content, ttl) {
        // console.log(content);
        $scope.displayContent = $sce.trustAsHtml(
          content.replace(/(\r\n|\n|\r)/g, "<br />")
        );
        $scope.MyDialog1 = ngDialog.open({
          template: "statement",
          scope: $scope,
          // className: 'ngdialog-theme-default'
        });
      };

      $scope.allcounties = [];
      $scope.getCounties = function (lbl) {
        //console.log($scope.Location.state);
        // $scope.allcounties.length = 0;
        var statePostalCode = "";
        var state = "";
        if (lbl == "new") {
          // state = JSON.stringify($scope.oldaddress.state);
          statePostalCode = $scope.Location.state.stateFips;
        } else {
          statePostalCode = $scope.Location.state.stateFips;
          state = $scope.Location.state;
        }
        //// MyService.ConsoleLog(" $scope.allstates >", $scope.allstates);
        //// MyService.ConsoleLog("$scope.Location.state >", $scope.Location);
        //// MyService.ConsoleLog("statePostalCode >>", statePostalCode);
        // if (statePostalCode == "") {
        //  // MyService.ConsoleLog(" <<<<<<<<<<<< $scope.Location.state  new >", $scope.Location.state);
        //   statePostalCode = $scope.Location.state.stateFips;

        // }
        // MyService.ConsoleLog(" $scope.stateFips second", $scope.stateFips);

        MyService.getAllCounties($scope.stateFips, state).then(
          function (payload) {
            //console.log("sublocations Locals : ", payload);
            var allcounties = payload;
            if (lbl == "new") {
              var county = $scope.checkCounty(
                allcounties,
                $scope.oldaddress.county
              );
              $scope.allcounties = county;
              // console.log("county<><", county);
              $scope.Location.county = county[0];
            }
          },
          function (errorPayload) {
            growl.error("Something went wrong.");
          }
        );
      };
      $scope.MyPlaces = [];
      $scope.getSubCounties = function (lbl) {
        //console.log($scope.Location.state);
        //console.log($scope.Location.county);
        var county = "";
        var statePostalCode = "";
        $scope.MyPlaces.length = 0;

        var state = "";
        var county = "";
        if (lbl == "new") {
          state = JSON.stringify($scope.oldaddress.state);
          county = JSON.stringify($scope.oldaddress.county);
        } else {
          statePostalCode = $scope.Location.state.statePostalCode;
          state = $scope.Location.state;
          county = county.county;
        }

        // MyService.getAllSubCountiesLocal($scope.Location.state.statePostalCode, county._id.county).then(function(payload) {
        //     $scope.MyPlaces = payload;
        //     //console.log("PlaCE :", payload);

        //   },
        //   function(errorPayload) {
        //     growl.error('Something went wrong.');
        //   });
        console.log("Here inside ", county);
        MyService.getAllSubCountiesLocal(statePostalCode, state, county).then(
          function (payload) {
            $scope.MyPlaces = payload;
            // console.log(payload);
            // var subcounties = payload.allsubcounty
            // var places = payload.allPlaces;
            var subcounties = payload.countySubdivision;
            var places = payload.places;
            // console.log("PlaCE :", payload);
            if (lbl == "new") {
              var subcounty = $scope.checksubCounty(
                subcounties,
                $scope.oldaddress.countySubdivision
              );
              var places = $scope.checkPlaces(places, $scope.oldaddress.place);
              // console.log("subcounty<><><", subcounty)
              $scope.subcounties = subcounty;
              $scope.places = places;
              // $scope.Location.countySubdivision = subcounty[0];
              $scope.Location.place = places[0];
            }
          },
          function (errorPayload) {
            growl.error("Something went wrong.");
          }
        );
      };

      $scope.displayPlaces = [];
      $scope.displayVoterDistrict = [];
      $scope.displayFederalDistrict = [];
      $scope.displayStateSenate = [];
      $scope.displayStateLegislative = [];
      $scope.displaySchoolDistrict = [];
      $scope.getPlacesData = function (val) {
        var rdata1 = angular.copy($scope.MyPlaces.allPlaces);
        $scope.displayPlaces.length = 0;
        var newDat = rdata1.filter(function (rdata, idx) {
          if (rdata._id.countySubdivision == val._id.countySubdivision) {
            return rdata;
          }
        });
        $scope.displayPlaces = newDat;
      };

      $scope.getVoterDistrcitData = function (val) {
        var rdata1 = angular.copy($scope.MyPlaces.allVoterDistricts);
        var compareplace = val._id.place;
        $scope.displayVoterDistrict.length = 0;
        var newDat = rdata1.filter(function (rdata, idx) {
          if (rdata._id.place == compareplace) {
            return rdata;
          }
        });
        $scope.displayVoterDistrict = newDat;
        if ($scope.displayVoterDistrict.length == 1) {
          $scope.Location.voterDistrict = $scope.displayVoterDistrict[0];
        }

        var rdata2 = angular.copy($scope.MyPlaces.allfederalCongrassionalDist);
        $scope.displayFederalDistrict.length = 0;
        var newDat1 = rdata2.filter(function (rdata21) {
          if (rdata21._id.place == compareplace) {
            return rdata21;
          }
        });
        $scope.displayFederalDistrict = newDat1;
        if ($scope.displayFederalDistrict.length == 1) {
          $scope.Location.federalCongrassionalDist =
            $scope.displayFederalDistrict[0];
        }

        var rdata3 = angular.copy($scope.MyPlaces.allstateSenateDistrict);
        $scope.displayStateSenate.length = 0;
        var newDat2 = rdata3.filter(function (rdata31) {
          if (rdata31._id.place == compareplace) {
            return rdata31;
          }
        });
        $scope.displayStateSenate = newDat2;
        if ($scope.displayStateSenate.length == 1) {
          $scope.Location.stateSenateDistrict = $scope.displayStateSenate[0];
        }

        var rdata4 = angular.copy($scope.MyPlaces.allstateLegislativeDistrict);
        $scope.displayStateLegislative.length = 0;
        var newDat3 = rdata4.filter(function (rdata41) {
          if (rdata41._id.place == compareplace) {
            return rdata41;
          }
        });
        $scope.displayStateLegislative = newDat3;
        if ($scope.displayStateLegislative.length == 1) {
          $scope.Location.stateLegislativeDistrict =
            $scope.displayStateLegislative[0];
        }
        //console.log(newDat);

        var rdata5 = angular.copy($scope.MyPlaces.allschoolDistrict);
        $scope.displaySchoolDistrict.length = 0;
        var newDat4 = rdata5.filter(function (rdata51) {
          if (rdata51._id.place == compareplace) {
            return rdata51;
          }
        });
        $scope.displaySchoolDistrict = newDat4;
        if ($scope.displaySchoolDistrict.length == 1) {
          $scope.Location.schoolDistrict = $scope.displaySchoolDistrict[0];
        }
      };

      $scope.Location = {
        state: "",
        county: "",
        countySubdivision: "",
        place: "",
        voterDistrict: "",
        federalCongrassionalDist: "",
        stateSenateDistrict: "",
        stateHouseOFRepresentativeDistrict: "",
        unifiedSchoolDistrictName: "",
      };

      if ($rootScope.tempUserAddress && $rootScope.tempUserAddress != "") {
        //   $rootScope.compareFinalData = JSON.stringify($rootScope.tempUserAddress);
        // $rootScope.tempUserAddress="";
        // $scope.users.length = 0;
        // $scope.page = 0;
        $rootScope.incuAdd = $rootScope.tempUserAddress;

        $scope.getLocalPoliticians();
      }
      $scope.showPopups = function () {
        MyService.getAllStates().then(
          function (payload) {
            $scope.allState = payload;
            $scope.states = payload;
            $scope.MyDialog = ngDialog.open({
              template: "guest_location",
              scope: $scope,
              // className: 'ngdialog-theme-default'
            });
          },
          function (errorPayload) {
            growl.error("Something went wrong.");
          }
        );
      };

      $scope.submitLocation = function (loc) {
        //console.log($scope.Location.state);
        //console.log($scope.Location.county);
        //console.log($scope.Location.place);
        // console.log("location<><><>",$scope.Location);
        // console.log("location2<><><>",loc);
        var finalData = new Object();
        if ($scope.Location.state && $scope.Location.state != "") {
          var nobj = new Object();
          nobj.statePostalCode = $scope.Location.state.statePostalCode;
          finalData.statePostalCode = $scope.Location.state.statePostalCode;
          finalData.state = $scope.Location.state.state;
        }
        if (
          $scope.Location.county &&
          $scope.Location.county.county &&
          $scope.Location.county.county != ""
        ) {
          $scope.Location.FinalData = JSON.stringify($scope.Location.county);
          finalData.county = $scope.Location.county.countyName;
        }
        if (
          $scope.Location.countySubdivision &&
          $scope.Location.countySubdivision.countySubdivision != ""
        ) {
          $scope.Location.FinalData = JSON.stringify(
            $scope.Location.countySubdivision
          );
          finalData.countySubdivision =
            $scope.Location.countySubdivision.countySubdivision;
        }
        if ($scope.Location.place && $scope.Location.place.place != "") {
          //$scope.Location.FinalData = JSON.stringify($scope.Location.place._id);
          finalData.place = $scope.Location.place.placeName;
        }
        /*
      if ($scope.Location.voterDistrict && $scope.Location.voterDistrict.voterDistrictName != "") {
        //$scope.Location.FinalData = JSON.stringify($scope.Location.place._id);
        finalData.voterDistrict = $scope.Location.voterDistrict.voterDistrictName;
      }
      */
        if (
          $scope.Location.cityCouncilDistrict &&
          $scope.Location.cityCouncilDistrict != ""
        ) {
          finalData.cityCouncilDistrictName =
            $scope.Location.cityCouncilDistrict.COUNTDIST;
        }
        if (
          $scope.Location.stateHouseOFRepresentativeDistrict &&
          $scope.Location.stateHouseOFRepresentativeDistrict.NAMELSAD != ""
        ) {
          //$scope.Location.FinalData = JSON.stringify($scope.Location.place._id);
          if (
            $scope.Location.stateHouseOFRepresentativeDistrict.SLDLST &&
            $scope.Location.stateHouseOFRepresentativeDistrict.SLDLST != ""
          ) {
            finalData.legislativeDistrict =
              $scope.Location.stateHouseOFRepresentativeDistrict.SLDLST;
          } else {
            var SLDLSTarr =
              $scope.Location.stateHouseOFRepresentativeDistrict.NAMELSAD.split(
                " "
              );
            var SLDLST = SLDLSTarr[SLDLSTarr.length - 1];
            finalData.legislativeDistrict = SLDLST;
          }
        }

        if (
          $scope.Location.federalCongrassionalDist &&
          $scope.Location.federalCongrassionalDist.CD115FP
        ) {
          //$scope.Location.FinalData = JSON.stringify($scope.Location.place._id);
          if ($scope.Location.federalCongrassionalDist.CD115FP == "00") {
            finalData.federalCongrassionalDist = "At-Large";
          } else {
            finalData.federalCongrassionalDist =
              $scope.Location.federalCongrassionalDist.CD115FP;
          }
        }
        if (
          $scope.Location.stateSenateDistrict &&
          $scope.Location.stateSenateDistrict.SLDUST != ""
        ) {
          //$scope.Location.FinalData = JSON.stringify($scope.Location.place._id);
          finalData.stateSenateDistrict =
            $scope.Location.stateSenateDistrict.SLDUST;
        }
        /*
      if ($scope.Location.stateLegislativeDistrict && $scope.Location.stateLegislativeDistrict.stateHouseOFRepresentativeDistrict != "") {
        //$scope.Location.FinalData = JSON.stringify($scope.Location.place._id);
        finalData.legislativeDistrict = $scope.Location.stateLegislativeDistrict.stateHouseOFRepresentativeDistrict;
      }
      */
        if (
          $scope.Location.unifiedSchoolDistrictName &&
          $scope.Location.unifiedSchoolDistrictName.NAME != ""
        ) {
          //$scope.Location.FinalData = JSON.stringify($scope.Location.place._id);
          finalData.schoolDistrict =
            $scope.Location.unifiedSchoolDistrictName.NAME;
        }
        // console.log(finalData);

        // console.log($scope.Location.FinalData);
        // if (finalData && finalData != "") {
        //// MyService.ConsoleLog("IF in finalData");
        $rootScope.compareFinalData = JSON.stringify(finalData);

        $rootScope.tempUserAddress = "";
        $scope.users.length = 0;
        $scope.page = 0;
        $scope.getLocalPoliticians();
      };
      // //MyService.ConsoleLog("$rootScope.compareFinalData :",$rootScope.compareFinalData);
      $scope.pop = true;

      // $rootScope.FinalData == "";
      // alert($routeParams.user_type);
      if ($routeParams.user_type) {
        if ($routeParams.user_type == "politician") {
          // console.log("inside politician");
          // MyService.ConsoleLog("inside one");

          // if($rootScope.compareFinalData)
          console.log("temp ", $rootScope.compareFinalData);
          if (
            !tokenService.getUserId() &&
            (!$rootScope.compareFinalData || $rootScope.compareFinalData == "")
          ) {
            // if (!tokenService.getUserId()) {
            $rootScope.compareFinalData = $rootScope.FinalData;
            if (loc) {
              MyService.getAllStates().then(
                function (payload) {
                  $scope.allState = payload;
                  $scope.states = payload;
                },
                function (errorPayload) {
                  growl.error("Something went wrong.");
                }
              );
            } else {
              //MyService.ConsoleLog(" data >>", $rootScope.tempUserAddress);
              // alert("else");
              if (!$rootScope.tempUserAddress) {
                $scope.showHtmlViewer();
              }
            }
          }

          if (tokenService.getUserId()) {
            var tempData = JSON.parse(tokenService.getUserData());
            // MyService.ConsoleLog("tempData", tempData);
            if (
              (tempData.address &&
                tempData.address.statePostalCode &&
                tempData.address.statePostalCode != "") ||
              (tempData.address.state && tempData.address.state != "")
            ) {
              $rootScope.compareFinalData = "";
              $scope.pop = false;
              $scope.getLocalPoliticians();
            } else {
              $scope.pop = true;
              $scope.showPopups();
            }
          }

          if (
            $rootScope.compareFinalData &&
            $rootScope.compareFinalData != ""
          ) {
            // alert("got");
            $scope.pop = false;
            $scope.getLocalPoliticians();
          }
        } else {
          console.log("Else >> ", $rootScope.compareFinalData);
          /*
         getUsers({
           usertype: $routeParams.user_type
         });
         */
        }
      }

      $scope.selectedUser = [];
      $scope.toggleSelection = function (uid) {
        //console.log("toggleSelection: ", uid);
        var idx = $scope.selectedUser.indexOf(uid);
        // is currently selected
        if (idx > -1) {
          $scope.selectedUser.splice(idx, 1);
        } else {
          $scope.selectedUser.push(uid);
        }
      };

      $scope.selectedUserPrint = [];
      $scope.togglePrintSelection = function (uid) {
        //console.log("togglePrintSelection: ", uid);
        var idx = $scope.selectedUserPrint.indexOf(uid);
        // is currently selected
        if (idx > -1) {
          $scope.selectedUserPrint.splice(idx, 1);
        }
        // is newly selected
        else {
          $scope.selectedUserPrint.push(uid);
        }
      };

      $scope.compare = function () {
        //console.log("compare :", $scope.selectedUser);
        if ($scope.selectedUser.length <= 0) {
          alert("Please select user first.");
        } else {
          $rootScope.selectedCompareUsers = $scope.selectedUser;
          // $location.path("/question-compare/all/"+$routeParams.category_id);
          $location.path(
            "/question-compare/all/" + $rootScope.categories[0]._id
          );
        }
      };

      $scope.compareOfficeWise = function (users) {
        $rootScope.selectedCompareUsers = [];
        angular.forEach(users, function (val, key) {
          //console.log("key: ", key, " val: ", val);
          if (val.registeredUser) {
            $rootScope.selectedCompareUsers.push(val);
          }
        });
        //console.log("$rootScope.selectedCompareUsers: ", $rootScope.selectedCompareUsers);
        if ($rootScope.selectedCompareUsers.length <= 0) {
          growl.error("None of the users are registered user.");
        } else {
          $location.path(
            "/question-compare/all/" + $rootScope.categories[0]._id
          );
        }
      };

      $scope.compareRatings = function (users) {
        //MyService.ConsoleLog("users > ", users);
        $rootScope.selectedRatingUsers = [];
        angular.forEach(users, function (val, key) {
          //MyService.ConsoleLog("key123: ", key);
          //MyService.ConsoleLog(" val321: ", val);
          if (val.total_reviews > 0) {
            // alert("Here");
            console.log("valpoliticianIds >> ", val.politicianIds);
            if (!val.politicianIds) {
              var pids = [];
              pids.push(val._id);
              val["politicianIds"] = pids;
              console.log("val >>> ", val);
            }
            $rootScope.selectedRatingUsers.push(val);
          }
        });
        //MyService.ConsoleLog("$rootScope.selectedCompareUsers: ", $rootScope.selectedCompareUsers);
        if ($rootScope.selectedRatingUsers.length <= 0) {
          growl.error("None of the users you selected have ratings.");
        } else {
          $location.path("/compareRatings");
        }
      };

      $scope.compareOfficeWiseSubject = function (users) {
        //MyService.ConsoleLog("compare-subject : >>", users);
        $rootScope.selectedCompareUsers = [];
        angular.forEach(users, function (val, key) {
          console.log("key: ", key, " val: ", val);
          if (val.total_answers > 0 && val.isSelected) {
            $rootScope.selectedCompareUsers.push(val);
            // //MyService.ConsoleLog("$rootScope.selectedCompareUsers :",$rootScope.selectedCompareUsers);
          }
        });
        //MyService.ConsoleLog("$rootScope.selectedCompareUsers: ", $rootScope.selectedCompareUsers);
        if ($rootScope.selectedCompareUsers.length <= 0) {
          growl.error(
            "None of the selected users have answered any questions."
          );
        } else {
          $location.path("/compare-subject/" + $routeParams.user_type);
        }
      };
      $scope.compareSubjectWise = function () {
        //console.log("compare :", $scope.selectedUser);
        if ($scope.selectedUser.length <= 0) {
          alert("Please select user first.");
        } else {
          $rootScope.selectedCompareUsers = $scope.selectedUser;
          $location.path("/compare-subject/" + $routeParams.user_type);
        }
      };

      $scope.printSelectedUsers = function () {
        //console.log("* printSelectedUsers *", $scope.selectedUserPrint);
        if ($scope.selectedUserPrint.length > 0) {
          $rootScope.printUsers = angular.copy($scope.selectedUserPrint);
          $location.path("/print-users");
        } else {
          growl.error("Please select user first.");
        }
      };

      $scope.goToPoliticianThread = function (officename, users, userData) {
        //console.log("goToPoliticianThread: ", users, " officename: ", officename, " userData: ", userData);
        $rootScope.politicianThreadData = {
          // office: officename,
          users: users,
          selected_user: userData,
        };
        window.localStorage.setItem(
          "politicianThreadData",
          JSON.stringify($rootScope.politicianThreadData)
        );
        $location.path("/politician-thread/" + userData._id);
      };

      $scope.search = {
        searchFilter: "",
      };
      $scope.filteredSearch = "";
      $scope.searchOffice = function (office) {
        // if($scope.search.searchFilter.length > 1 ) {
        //     //if($scope.searchUsers.length!=$scope.users.length) {
        //         $scope.searchUsers = angular.copy($scope.users);
        //     //}
        // }
        $scope.searchUsers = $scope.users.filter(function (rdata) {
          // console.log(rdata.office + "==" + office);
          var idx = rdata.office
            .toLowerCase()
            .indexOf($scope.search.searchFilter.toLowerCase());
          // console.log(idx);
          if (idx > -1) return rdata;
        });
        //$scope.$apply();
        // if (teamIsNew) {
        //   indexedTeams.push(player.team);
        // }
        // return teamIsNew;
      };
      $scope.userAddress = "";
      $scope.zipcode = "";
      $scope.updateAddress = function () {
        var address_data = $scope.userAddress;
        address_data.zipcode = $scope.zipcode;
        // console.log("********* Data: ", address_data);
        ngDialog.open({
          template: "app/popups/user_localupdate.html",
          data: address_data,
          // className: 'ngdialog-theme-default'
        });
      };
      $scope.string = {
        showLink: "hide",
      };

      $scope.showZipLoader = false;
      $scope.showAddressDropDown = false;

      $scope.checkState = function (rdata, val) {
        //MyService.ConsoleLog("State :", rdata);
        //MyService.ConsoleLog("State val :", val);
        var sdata = [];
        var len = rdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = rdata[i];
          var gdata = val.filter(function (obj) {
            if (
              rsdata.countyFips == obj.COUNTYFP &&
              rsdata.stateFips == obj.STATEFP
            ) {
              // //MyService.ConsoleLog(rdata[i]);
              return rdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(rdata[i]) == -1) {
              sdata.push(rdata[i]);
            }
          }

          if (j == len) {
            // //MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };

      $scope.checkCounty = function (rdata, val) {
        //MyService.ConsoleLog("County :", rdata);
        //MyService.ConsoleLog("County val :", val);
        var sdata = [];
        var len = rdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = rdata[i];
          var gdata = val.filter(function (obj) {
            if (
              rsdata.countyFips == obj.COUNTYFP &&
              rsdata.stateFips == obj.STATEFP
            ) {
              // //MyService.ConsoleLog(rdata[i]);
              return rdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(rdata[i]) == -1) {
              sdata.push(rdata[i]);
            }
          }

          if (j == len) {
            // //MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };
      $scope.checksubCounty = function (rdata, val) {
        var sdata = [];
        var len = rdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = rdata[i];
          var gdata = val.filter(function (obj) {
            if (rsdata.countySubdivision == obj.NAME) {
              // console.log(rdata[i]);
              return rdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(rdata[i]) == -1) {
              sdata.push(rdata[i]);
            }
          }

          if (j == len) {
            // console.log("gdata > ", sdata);
            return sdata;
          }
        }
      };
      $scope.checkPlaces = function (prdata, val) {
        var sdata = [];
        var len = prdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = prdata[i];
          var gdata = val.filter(function (obj) {
            // console.log(rsdata.place +"=="+ obj.NAME);
            if (rsdata.place == obj.NAME && !rsdata.countyFips) {
              // console.log(rdata[i]);
              return prdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(prdata[i]) == -1) {
              sdata.push(prdata[i]);
            }
          }

          if (j == len) {
            // console.log("gdata > ", sdata);
            return sdata;
          }
        }
      };

      $scope.emptyOrNull = function (item) {
        return !(
          item._id.place === null ||
          item._id.place === "" ||
          item._id.place === " "
        );
      };

      /**
       * Get ballot thread
       */
      $scope.goToBallotThread = function (userData) {
        console.log("goToPoliticianThread: ", userData);
        var tempArr = [];
        tempArr.push(userData);
        $rootScope.ballotThread = {
          users: tempArr,
          selected_user: userData,
        };
        window.localStorage.setItem(
          "ballotThreadData",
          JSON.stringify($rootScope.ballotThread)
        );
        $location.path("/ballotThread/" + userData._id);
      };

      $scope.showAddressDropDowns = function (zipcode, loc) {
        // console.log("yogy", loc);
        if (loc) {
          // console.log("welcome to if");
          $scope.showZipLoader = true;
          MyService.getOrganizedZipData({
            zipcode: zipcode,
            candidate: true,
            loc: loc,
          }).then(
            function (payload) {
              // console.log(payload);
              // MyService.ConsoleLog(" << payload >>", payload);
              if (payload && payload.state) {
                // var finalData = payload.data;
                // console.log(payload[0]);
                // console.log(payload[0].countySubdivision);
                // console.log(payload[0].county);
                // console.log(payload[0].place);

                $scope.stateFips = payload.state[0].STATEFP;

                // MyService.ConsoleLog("$scope.stateFips >>", $scope.stateFips);

                var countySubdivisions = payload.places.filter(function (obj) {
                  if (obj.COUSUBFP && obj.COUSUBFP != "") {
                    // console.log("Inside cs");
                    return obj;
                  }
                });

                var places = payload.places.filter(function (obj) {
                  if (obj.PLACEFP && obj.PLACEFP != "") {
                    // console.log("obj > ", obj);
                    return obj;
                  }
                });

                // console.log("here");
                $scope.showZipLoader = false;
                $scope.showAddressDropDown = true;
                $scope.oldaddress.state = payload.state;
                $scope.oldaddress.county = payload.county;

                // console.log("countySubdivisions >> ", countySubdivisions);
                $scope.oldaddress.countySubdivision = countySubdivisions;
                $scope.oldaddress.place = places;
                $scope.getCounties("new");

                $scope.getSubCounties("new");
                // $scope.voterDistricts = payload;
                $scope.federalCongrassionalDist = payload.congressionalDistrict;
                console.log("@@@@@@drop :", $scope.federalCongrassionalDist);

                $scope.stateSenateDistrict = payload.stateSenateDistrict;
                $scope.stateHouseOFRepresentativeDistricts =
                  payload.stateHouseofRepresentativesDistrict;
                $scope.unifiedSchoolDistrictNames =
                  payload.unifiedSchoolDistrict;
                $scope.cityCouncilDistrict = payload.cityCouncilDistrict;
                //$scope.$apply();
                // console.log($scope.states);
                // console.log(payload[0].statePostalCode);
                var address = $scope.checkState($scope.states, payload.state);
                $scope.allstates = address;
                // console.log("address<>", address);
                $scope.Location.state = address[0];
                // $scope.Location.voterDistrict = $scope.voterDistricts[0];
                $scope.Location.federalCongrassionalDist =
                  $scope.federalCongrassionalDist[0];
                $scope.Location.stateSenateDistrict =
                  $scope.stateSenateDistrict[0];
                $scope.Location.stateHouseOFRepresentativeDistrict =
                  $scope.stateHouseOFRepresentativeDistricts[0];
                $scope.Location.unifiedSchoolDistrictName =
                  $scope.unifiedSchoolDistrictNames[0];
                $scope.Location.cityCouncilDistrict =
                  $scope.cityCouncilDistrict[0];
                // $scope.submitLocation('');
                // console.log("address ; ", address);
              } else {
                $scope.showZipLoader = false;
                alert("Zipcode not found in our database. Please correct it");
              }
            },
            function (errorPayload) {
              $scope.showZipLoader = false;
              growl.error(errorPayload);
            }
          );
        } else {
          // console.log("welcome to esle");
          $scope.showZipLoader = true;
          MyService.getOrganizedZipData({
            zipcode: zipcode,
            candidate: true,
          }).then(
            function (payload) {
              console.log(payload);
              if (payload && payload.state) {
                // var finalData = payload.data;
                // console.log(payload[0]);
                // console.log(payload[0].countySubdivision);
                // console.log(payload[0].county);
                // console.log(payload[0].place);

                var countySubdivisions = payload.places.filter(function (obj) {
                  if (obj.COUSUBFP && obj.COUSUBFP != "") {
                    // console.log("Inside cs");
                    return obj;
                  }
                });

                var places = payload.places.filter(function (obj) {
                  if (obj.PLACEFP && obj.PLACEFP != "") {
                    // console.log("obj > ", obj);
                    return obj;
                  }
                });

                // console.log("here");
                $scope.showZipLoader = false;
                $scope.showAddressDropDown = true;
                $scope.oldaddress.state = payload.state;
                $scope.oldaddress.county = payload.county;

                // console.log("countySubdivisions >> ", countySubdivisions);
                $scope.oldaddress.countySubdivision = countySubdivisions;
                $scope.oldaddress.place = places;
                $scope.getCounties("new");

                $scope.getSubCounties("new");
                // $scope.voterDistricts = payload;
                // console.log(payload.congressionalDistrict);
                $scope.federalCongrassionalDist = payload.congressionalDistrict;
                // console.log("hello :", $scope.federalCongrassionalDist);

                $scope.stateSenateDistrict = payload.stateSenateDistrict;
                $scope.stateHouseOFRepresentativeDistricts =
                  payload.stateHouseofRepresentativesDistrict;
                $scope.unifiedSchoolDistrictNames =
                  payload.unifiedSchoolDistrict;
                //$scope.$apply();
                // console.log($scope.states);
                // console.log(payload[0].statePostalCode);
                var address = $scope.checkState($scope.states, payload.state);
                $scope.allstates = address;
                // console.log("address<>", address);
                $scope.Location.state = address[0];
                // $scope.Location.voterDistrict = $scope.voterDistricts[0];
                $scope.Location.federalCongrassionalDist =
                  $scope.federalCongrassionalDist[0];
                $scope.Location.stateSenateDistrict =
                  $scope.stateSenateDistrict[0];
                $scope.Location.stateHouseOFRepresentativeDistrict =
                  $scope.stateHouseOFRepresentativeDistricts[0];
                $scope.Location.unifiedSchoolDistrictName =
                  $scope.unifiedSchoolDistrictNames[0];
                // console.log("address ; ", address);
              } else {
                $scope.showZipLoader = false;
                alert("Zipcode not found in our database. Please correct it");
              }
            },
            function (errorPayload) {
              $scope.showZipLoader = false;
              growl.error(errorPayload);
            }
          );
        }
      };

      if (loc && loc != "") {
        console.log("location");
        $scope.showAddressDropDowns("", loc);
      } else {
        // console.log("else");

        $scope.detectCode = function (event) {
          // console.log(event);
          // console.log(event.keyCode);
          //MyService.ConsoleLog("callded");
          if (event.keyCode == 9 && event.key == "Tab") {
            $("#zipcodecompareinput").blur();
            $scope.showAddressDropDowns($scope.Location.ZipCode);
          }
          if (event.keyCode == 13 && event.key == "Enter") {
            $("#zipcodecompareinput").blur();
            $scope.showAddressDropDowns($scope.Location.ZipCode);
          }
        };
      }

      $scope.checkLength = function (vdata, val) {
        //MyService.ConsoleLog("vdata", vdata);
        if (vdata && vdata.length > 0) {
          var data = vdata.map(function (sub) {
            var returnval = "";
            switch (val) {
              case "federalCongrassionalDist":
                returnval = sub.CD115FP;
                break;
              case "stateSenateDistrict":
                returnval = sub.SLDUST;
                break;
              case "stateHouseOFRepresentativeDistrict":
                returnval = sub.NAMELSAD;
                break;
              case "unifiedSchoolDistrictName":
                returnval = sub.NAME;
                break;
              case "place":
                returnval = sub.place;
                break;
              case "countySubdivision":
                returnval = sub.countySubdivision;
                break;
              case "county":
                returnval = sub.county;
                break;
              case "state":
                returnval = sub.state;
                break;
              case "cityCouncilDistrict":
                returnval = sub.COUNTDIST;
                break;
              case "default":
                returnval = sub.NAME;
                break;
            }
            return returnval;
          });

          var ndata = $filter("unique")(data);
          if (ndata.length > 1) {
            return "yellowBackground";
          } else {
            return "";
          }
        } else {
          return "";
        }
      };
      $scope.user = {
        flagSkipAnsweredQuestion: "YES",
      };
      if ($rootScope.UserId) {
        MyService.getProfile($rootScope.UserId).then(
          function (data) {
            // body...

            var address_data = data.address;
            //MyService.ConsoleLog(" address_data :", address_data);
            $scope.zipcode = data.zipcode;
            // console.log(address_data.legislativeDistrict);
            if (!address_data.legislativeDistrict) {
              $scope.string.showLink = "show";
              // console.log("legislativeDistrict");
            }
            // console.log(address_data.voterDistrict);
            if (!address_data.voterDistrict) {
              $scope.string.showLink = "show";
              // console.log("voterDistrict");
            }
            // console.log(address_data.voterDistrictFips);

            // console.log(address_data.schoolDistrict);
            if (!address_data.schoolDistrict) {
              $scope.string.showLink = "show";
              // console.log("schoolDistrict");
            }

            // console.log(address_data.stateSenateDistrict);
            if (!address_data.stateSenateDistrict) {
              $scope.string.showLink = "show";
              // console.log("stateSenateDistrict");
            }
            // console.log(address_data.federalCongrassionalDist);
            if (!address_data.federalCongrassionalDist) {
              $scope.string.showLink = "show";
              // console.log("federalCongrassionalDist");
            }
            // console.log(address_data.state);
            if (!address_data.state) {
              $scope.string.showLink = "show";
              // console.log("state");
            }
            // console.log(address_data.statePostalCode);
            if (!address_data.statePostalCode) {
              $scope.string.showLink = "show";
              // console.log("statePostalCode");
            }
            // console.log(address_data.countySubdivision);
            if (!address_data.countySubdivision) {
              $scope.string.showLink = "show";
              // console.log("countySubdivision");
            }
            // console.log(address_data.county);
            if (!address_data.county) {
              $scope.string.showLink = "show";
              // console.log("county");
            }
            // console.log(address_data.place);
            if (!address_data.place) {
              $scope.string.showLink = "show";
              // console.log("place");
            }
            // console.log($scope.string.showLink);
            $scope.userAddress = address_data;
            //$scope.userAddress.zipcode = data.address.zipcode;
            // if ($filter("isBlankString")(address_data.voterDistrict)) {
            //   address_data.zipcode = data.zipcode;
            //   //console.log("Data: ",data);
            //   ngDialog.open({
            //     template: 'popups/user_localupdate.html',
            //     data: data.address
            //     // className: 'ngdialog-theme-default'
            //   });
            // } //isBlankString voterDistrict
          },
          function (err) {
            //console.log("********* err: ", err);
          }
        );
      }
    },
  ]);

'use strict';

angular.module('myApp.compareWithGroup', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/compareWithGroup/:type?', {
      templateUrl: 'app/compareWithGroup/compareWithGroup.html',
      controller: 'compareWithGroupCtrl'
    });
  }]).controller('compareWithGroupCtrl', ['$scope', 'apiCall', 'MyService', '$location', '$anchorScroll', '$timeout', '$rootScope', 'ngDialog', '$q', '$http', '$filter', 'growl', '$routeParams', 'baseApiUrl', 'tokenService', '$cookies', function ($scope, apiCall, MyService, $location, $anchorScroll, $timeout, $rootScope, ngDialog, $q, $http, $filter, growl, $routeParams, baseApiUrl, tokenService, $cookies) {

    $scope.loader = false;
    $scope.noDataFound = false;
    $scope.FBCompareList = [];
    $scope.politician = false;
    $scope.showvoter = false;
    $scope.showadv = false;
    $scope.shownonUser = false;
    $scope.isShowFollow = false;
    if (tokenService.getUserId()) {
      $scope.userId = tokenService.getUserId();
      console.log('$scope.userId: ', $scope.userId);
    }

    if (window.localStorage.getItem('isFindFollowers')) {
      $scope.isShowFollow = true;
    }

    if (window.localStorage.getItem('inviterInfo')) {
      $scope.inviterInfo = JSON.parse(window.localStorage.getItem('inviterInfo'));
      if ($scope.inviterInfo && $scope.inviterInfo.nameOnBallot) {
        $scope.inviterName = $scope.inviterInfo.nameOnBallot;
      } else if ($scope.inviterInfo && $scope.inviterInfo.title) {
        $scope.inviterName = $scope.inviterInfo.title;
      } else if ($scope.inviterInfo) {
        $scope.inviterName = $scope.inviterInfo.username;
      }
      $scope.inviterId = window.localStorage.getItem('inviterId');
    }

    if ($cookies.get('QuizName')) {
      console.log("$cookies.get('QuizName')", $cookies.get('QuizName'));
      $scope.quizTitle = $cookies.get('QuizName');
    }

    $scope.compareWithGroup = function (params) {
      $scope.loader = true;

      MyService.ConsoleLog("params >", params);
      params.usersIds = JSON.stringify(params.usersIds);
      // params.questions = JSON.parse(params.questions);
      MyService.getComparisonOfGroup(params).then(function (payload) {
          MyService.ConsoleLog("payload >", payload);
          $scope.loader = false;

          if (payload.data.data.unweightedMatch && payload.data.data.unweightedMatch != "") {
            $scope.FBunWeighted = payload.data.data.unweightedMatch;
            $scope.politician = true;

          }
          if (payload.data.data.advunWeighated && payload.data.data.advunWeighated != "") {
            $scope.advUnWeighated = payload.data.data.advunWeighated;
            $scope.showadv = true;

          }


          if ((!window.localStorage.getItem('inviterId')) && (!$cookies.get('quizTakerIdsArr')) && payload.data.data.finalunFbcombinedWeight && payload.data.data.finalunFbcombinedWeight != "") {
            if (!window.localStorage.getItem('inviterId')) {
              $scope.unVerifiedWeighated = payload.data.data.finalunFbcombinedWeight;
              $scope.shownonUser = true;
            } else if (!$cookies.get('quizTakerIdsArr')) {
              $scope.unVerifiedWeighated = payload.data.data.finalunFbcombinedWeight;
              $scope.shownonUser = true;
            }
          }
          if (payload.data.data.voterunWeight && payload.data.data.voterunWeight != "") {
            $scope.voterUnWeighated = payload.data.data.voterunWeight;
            $scope.showvoter = true;

          }
          $scope.fbcombinedWeight = payload.data.data.fbcombinedWeight;
          $scope.fbmultiplier = payload.data.data.fbmultiplier;
          $scope.fbqlen = payload.data.data.qdata.length;
          $scope.unVerifiedFBunWeighted = payload.data.data.finalUnFacbook;
          $scope.unFbmultiplier = payload.data.data.unFbmultiplier;
          $scope.voterCombined = payload.data.data.voterCombWeight;
          $scope.voterMulti = payload.data.data.voterMulti;
          $scope.advCombined = payload.data.data.advCombWeight;
          $scope.advMulti = payload.data.data.advMulti;
          $scope.allUser = payload.data.data.AllUsers;
          MyService.ConsoleLog("check one more time what it is", window.localStorage.getItem('isFindFollowers'));
          if (!window.localStorage.getItem('isFindFollowers')) {
            window.localStorage.removeItem('inviterId');
            window.localStorage.removeItem('inviterInfo');
            $cookies.remove('quizTakerIdsArr');
          } else {
            // window.localStorage.removeItem('isFindFollowers');
          }

          if ($scope.userId && $scope.userId != '') {
            setTimeout(function () {
              var msg = "Do you want to share this quiz with others?  They will be able to take the quiz and see how you match.";

              var modal = ngDialog.openConfirm({
                template: '<p>' +
                  msg +
                  '</p>\
                      <div class="ngdialog-buttons">\
                          <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Yes</button>\
                          <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(0)">No</button>\
                      </div>',
                plain: true,
                closeByDocument: false,
                width: "70%"
              });
              modal.then(
                function fullfilled(data) {
                  if (data == 1) {
                    $scope.getAllAnsweredQuestions();

                  } else {

                  }
                },
                function rejected(data) {

                }
              );
            }, 3000);
          }


        },
        function (error) {
          MyService.ConsoleLog("error", error);
        });
    };



    $scope.finalSignIn = function () {

      $location.path('/fiveSaveUser');
    };

    /**
     * @description Redirect to get match list
     */
    $scope.redirectTo = function (type) {
      $location.path('/showListOfMatch/' + type);
    };


    /**
     * Hide show Pop Up
     */
    $scope.FBCompareList = [];
    $scope.AnswerArray = [];
    $scope.AnswerArray[1] = "Very Strongly Agree";
    $scope.AnswerArray[2] = "Agree";
    $scope.AnswerArray[3] = "Somewhat Agree";
    $scope.AnswerArray[4] = "Somewhat Disagree";
    $scope.AnswerArray[5] = "Disagree";
    $scope.AnswerArray[6] = "Very Strongly Disgree";
    $scope.AnswerImpArray = [];
    $scope.AnswerImpArray[1] = "Somewhat Important";
    $scope.AnswerImpArray[2] = "Important";
    $scope.AnswerImpArray[3] = "Very Important";
    $scope.Math = window.Math;
    $scope.allQuestions = [];
    $scope.switchStatus = [];
    $scope.chooseQuestions = function () {
      //MyService.ConsoleLog($scope.oldQuestions);
      if ($scope.allQuestions.length > 0) {

        $scope.showHidePop = ngDialog.open({
          template: 'ReviewMyAnswers',
          scope: $scope,
          width: "60%"
        });
      } else {
        alert("There are no questions to display. Please go through all questions first.")
      }
    }
    //$scope.switchStatus = "Show";
    $scope.showloader = false;
    $scope.switchFilters = function (newValue, index, quest) {
      $scope.showloader = true;
      MyService.ConsoleLog("newValue::", newValue);
      MyService.ConsoleLog("oldValue::", $scope.switchStatus);
      var setVal = "N";
      if (newValue[index] == true) {
        setVal = "Y";
      }

      var idx = $scope.allQuestions.indexOf(quest);
      //MyService.ConsoleLog("setVal:", setVal);
      MyService.updateAnswers({
        "qid": quest._id,
        "show": setVal,
        "author": quest.author,
        'inviterId': $scope.inviterId ? $scope.inviterId : '',
        "quest": JSON.stringify(quest.categories)
      }).then(function (payload) {
        //MyService.ConsoleLog("payload : ", payload);
        $scope.showloader = false;
        if (payload.data.success) {
          quest.my_answer.show = setVal;
          $scope.allQuestions[idx] = quest;

        } else {
          alert("Something went wrong. Contact administrator.");
        }
      }, function (errorpayload) {
        $scope.showloader = false;
        //MyService.ConsoleLog("errorpayload : ", errorpayload);
        alert("Something went wrong. Contact administrator.");
      });
    }

    if (window.localStorage.getItem("quesData")) {
      $scope.questions = JSON.parse(window.localStorage.getItem("quesData"));
      $scope.queIds = $scope.questions.map(function (itm) {
        if (itm.questionId) {
          return itm.questionId;
        } else {
          // console.log("itm", itm);
          return itm._id;
        }
      });
      MyService.ConsoleLog("  $scope.queIds", $scope.queIds);

    }

    $scope.AllAnsweredQuestions = [];
    $scope.getAllAnsweredQuestions = function (userId) {
      MyService.getAllAnsQuesWithIds({
        "authorId": tokenService.getUserId(),
        "ques": JSON.stringify($scope.queIds)
      }).then(function (payload) {
        MyService.ConsoleLog("getAllAnsweredQuestions >> ", payload);
        if (payload.data.success) {
          $scope.AllAnsweredQuestions = payload.data.data;
          $scope.allQuestions = $scope.AllAnsweredQuestions;
          MyService.ConsoleLog("$scope.allQuestions", $scope.allQuestions);
          var tmpS = $scope.allQuestions.filter(function (itms, ind) {
            if (itms && itms.my_answer) {
              if (itms.my_answer.show == 'Y') {
                $scope.switchStatus[ind] = true;
              } else {
                $scope.switchStatus[ind] = false;
              }
            }
          });

          MyService.ConsoleLog("$scope.switchStatus", $scope.switchStatus);
          if ($scope.allQuestions.length == 0) {
            growl.error("There are no questions to display. Please go through all questions first.")
          }
          $scope.chooseQuestions();
        }
      }, function (errpayload) {
        MyService.ConsoleLog("getAllAnsweredQuestions errpayload >> ", errpayload);
      });
    };




    /**
     * Next
     */

    $scope.next = function () {
      $scope.showHidePop.close();
      if ($scope.userId && $scope.userId != '') {
        MyService.ConsoleLog("yes");
        MyService.ConsoleLog("catId", window.localStorage.getItem('cat_id'));
        var catId, selCat_id;
        catId = window.localStorage.getItem('cat_id');
        selCat_id = window.localStorage.getItem('selCat_id');
        MyService.ConsoleLog("selCat_id", window.localStorage.getItem('selCat_id'));
        var tempLink = $location.absUrl().split("#!");
        $scope.shareLink = tempLink[0] + "#!/exploreQuiz/" + catId + "/" + selCat_id + "/" + $scope.userId;
        MyService.ConsoleLog("here we go with link", $scope.shareLink);
        ngDialog.open({
          template: 'exporeQuizLink',
          scope: $scope,
          width: "60%"
        });
      }
    };

    /**
     * Cancel
     */

    $scope.cancel = function () {
      $scope.showHidePop.close();
    };
    /**
     * @description Update quiz answers with existing flag
     */
    $scope.updateQuizAnswers = function () {
      if (window.localStorage.getItem('comData')) {
        $scope.quizData = JSON.parse(window.localStorage.getItem('comData'));
        $scope.answers = JSON.parse($scope.quizData.questions);
      }
      MyService.ConsoleLog("$scope.quizData", $scope.quizData);
      MyService.ConsoleLog("$scope.answers", $scope.answers);
      var token = apiCall.getToken();
      var ansLen = $scope.answers.length;

      for (var i = 0; i < ansLen; i++) {
        var isShare;
        if ($scope.answers[i].my_answer.show == 'Y') {
          isShare = true;
        } else {
          isShare = false;
        }
        var postData = {
          questionId: $scope.answers[i]._id,
          importance: $scope.answers[i].my_answer.importance,
          answer: $scope.answers[i].my_answer.answer,
          id: $scope.answers[i].my_answer._id,
          comment: $scope.answers[i].my_answer.comment,
          token: token ? token : "",
          isShare: isShare,
          inviterId: $scope.inviterId,
          selCatId: $scope.answers[i].categories.cid
        };
        MyService.ConsoleLog("<<<<<<<<<< postData", postData);
        MyService.postAnswer(postData).then(function (APIResponse) {
          MyService.ConsoleLog("APIResponse", APIResponse);
        }, function (err) {
          MyService.ConsoleLog("err", err);
        });
      }
      window.localStorage.removeItem('isUpdate');
      $scope.getAllAnsweredQuestions();
      $scope.compareWithGroup($scope.quizData);
    };

    if (window.localStorage.getItem('comData')) {
      // var ques = window.localStorage.getItem('quesData');
      $scope.compare = JSON.parse(window.localStorage.getItem('comData'));
      MyService.ConsoleLog("<<<<<<<<<<<< questions >>>>>>>>>>>", $scope.compare);
      if (window.localStorage.getItem('isUpdate')) {
        $scope.updateQuizAnswers();
      } else {
        $scope.compareWithGroup($scope.compare);
      }

    }


  }]);

'use strict';
angular.module('myApp.compareRatings', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/compareRatings', {
      templateUrl: 'app/compareRatings/compareRatings.html',
      controller: 'compareRatingsCtrl'
    });
  }])
  .controller('compareRatingsCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService) {

    $scope.politicians = [];
    $scope.rating1 = [];
    $scope.rating2 = [];
    $scope.rating3 = [];

    $scope.reviewId1 = [];
    $scope.reviewId2 = [];
    $scope.reviewId3 = [];
    /*
    $scope.review = {
      "data1": "",
      "data2": "",
      "data3": ""
    };
    */


    if ($rootScope.selectedRatingUsers && $rootScope.selectedRatingUsers.length > 0) {
      $scope.politicians = $rootScope.selectedRatingUsers;
      var plen = $scope.politicians.length;
      for (var h = 0; h < plen; h++) {
        $scope.rating1[$scope.politicians[h].politicianIds[0]] = 0;
        $scope.reviewId1[$scope.politicians[h].politicianIds[0]] = '';
        $scope.rating2[$scope.politicians[h].politicianIds[0]] = 0;
        $scope.reviewId2[$scope.politicians[h].politicianIds[0]] = '';
        $scope.rating3[$scope.politicians[h].politicianIds[0]] = 0;
        $scope.reviewId3[$scope.politicians[h].politicianIds[0]] = '';
      }
    } else {
      $location.path("/incumbent_politician/politician");
    }

    MyService.ConsoleLog("selectedRatingUsers >", $rootScope.selectedRatingUsers);

    var userIds = $rootScope.selectedRatingUsers.map(function (key, val) {
      return key._id;
    });

    MyService.ConsoleLog("userIds > ", userIds);
    $scope.reviewData = [];
    $scope.review = [];
    MyService.getCompareReviewList({
      "userIds": JSON.stringify(userIds)
    }).then(function (response) {
        MyService.ConsoleLog("getCompareReviewList Response : ", response);
        if (response.data.success) {
          MyService.ConsoleLog("OrgData1 : ", response.data.orgdata);
          MyService.ConsoleLog("Data : ", response.data.data);
          $scope.reviewData = response.data.data;

          $scope.orgData = response.data.orgdata;

          $scope.review.data1 = $scope.orgData[0];
          $scope.setReviewer1($scope.review.data1);
          if ($scope.orgData[1]) {
            $scope.review.data2 = $scope.orgData[1];
            $scope.setReviewer2($scope.review.data2);
          }
          if ($scope.orgData[2]) {
            $scope.review.data3 = $scope.orgData[2];
            $scope.setReviewer3($scope.review.data3);
          }


          /*
          MyService.getOrgCompareAnswers().then(function (payload) {
            MyService.ConsoleLog("payload : ", payload);
            if (payload.data.success) {

              response.data.data.forEach(function (element) {
                var resultObject = payload.data.data.find(function (o) {
                  return o.author.username === element.name[0];
                });

                var t = 0;
                if (resultObject) {
                  t = (resultObject.fbcombinedWeight / resultObject.fbmultiplier);
                }
                element.matchCount = t.toFixed(2);
                $scope.reviewData.push(element);
              });

              $scope.reviewData = response.data.data;

              if ($scope.reviewData.length > 0) {
                if ($scope.reviewData[0].referal[0].name && $scope.reviewData[0].referal[0].name) {
                  $scope.review.data1 = JSON.stringify($scope.reviewData[0]);
                } else {
                  $scope.review.data1 = JSON.stringify($scope.reviewData[0]);
                }
                $scope.setReviewer1($scope.review.data1);
                if ($scope.reviewData.length > 1) {
                  if ($scope.reviewData[1].referal[0].name && $scope.reviewData[1].referal[0].name) {
                    $scope.review.data2 = JSON.stringify($scope.reviewData[1]);
                  } else {
                    $scope.review.data2 = JSON.stringify($scope.reviewData[1]);
                  }
                  $scope.setReviewer2($scope.review.data2);
                  if ($scope.reviewData.length > 2) {
                    if ($scope.reviewData[2].referal[0].name && $scope.reviewData[2].referal[0].name) {
                      $scope.review.data3 = JSON.stringify($scope.reviewData[2]);
                    } else {
                      $scope.review.data3 = JSON.stringify($scope.reviewData[2]);
                    }
                    $scope.setReviewer3($scope.review.data3);
                  }
                }
              }

            }
          }, function (errorpayload) {
            console.log("errorpayload : ", errorpayload);
          });
          */
        }
      },
      function (errcallback) {
        MyService.ConsoleLog("Error : ", errcallback);
      });

    $scope.getToArray = function (rdata, val) {
      // MyService.ConsoleLog("rdata", rdata);
      // MyService.ConsoleLog("val", val);
      return rdata.filter(
        function (rdata) {
          // MyService.ConsoleLog(rdata.referal[0].name + "==" + rdata.from[0].name + "==" + val);
          if (rdata.sig && rdata.sig.name != "") {
            if (rdata.sig.name == val || rdata.sig.name == val) {
              var len = $rootScope.selectedRatingUsers.length;
              for (var i = 0; i < len; i++) {
                // MyService.ConsoleLog("rdata", rdata);
                if ($rootScope.selectedRatingUsers[i].name == rdata.to[0].name) {
                  // MyService.ConsoleLog("$rootScope.selectedRatingUsers", $rootScope.selectedRatingUsers[i].politicianIds[0] + " " + rdata.to[0].name);
                  rdata.politicianId = $rootScope.selectedRatingUsers[i].politicianIds[0];
                }
              }
              rdata.rating = rdata.candidateRating[0].rating;
              return rdata.sig.sigId;
            }
          } else {
            if (rdata.organisation == val || rdata.organisation == val)
              return rdata.politicianId;
          }
        }
      );
    }

    $scope.setReviewer1 = function (data) {

      var l = $scope.rating1.length;
      for (var k in $scope.rating1) {
        $scope.rating1[k] = 'N/A';
      }

      var selected = $scope.review.data1;
      // MyService.ConsoleLog("setReviewer1 > selected : ", selected);
      var referal_name = selected;
      // MyService.ConsoleLog("setReviewer1 > referal_name : ", referal_name);
      var finalData = $scope.getToArray($scope.reviewData, referal_name);
      MyService.ConsoleLog("setReviewer1 > finalData : ", finalData);
      var len = finalData.length;
      for (var s = 0; s < len; s++) {
        $scope.rating1[finalData[s].politicianId] = finalData[s].rating;
        $scope.reviewId1[finalData[s].politicianId] = finalData[s].politicianId;
      }



    }

    $scope.setReviewer2 = function (data) {
      var l = $scope.rating2.length;
      for (var k in $scope.rating2) {
        $scope.rating2[k] = 'N/A';
      }
      var selected = $scope.review.data2;
      var referal_name = selected;

      var finalData = $scope.getToArray($scope.reviewData, referal_name);

      var len = finalData.length;
      for (var s = 0; s < len; s++) {
        $scope.rating2[finalData[s].politicianId] = finalData[s].rating;
        $scope.reviewId2[finalData[s].politicianId] = finalData[s].politicianId;
      }
    }

    $scope.setReviewer3 = function (data) {
      var l = $scope.rating3.length;
      for (var k in $scope.rating3) {
        $scope.rating3[k] = 'N/A';
      }
      var selected = $scope.review.data3;
      var referal_name = selected;

      var finalData = $scope.getToArray($scope.reviewData, referal_name);

      var len = finalData.length;
      for (var s = 0; s < len; s++) {
        $scope.rating3[finalData[s].politicianId] = finalData[s].rating;
        $scope.reviewId3[finalData[s].politicianId] = finalData[s].politicianId;
      }


    }

    $scope.getToCount = function (rdata, val) {
      // MyService.ConsoleLog("rdata", rdata);
      MyService.ConsoleLog("val", val);

      return rdata.filter(
        function (rdata) {
          // MyService.ConsoleLog(rdata.to[0].uid + "==" + val);
          if (rdata.politicianId && rdata.politicianId != "") {
            if (rdata.politicianId == val)
              return rdata;
          } else {
            // MyService.ConsoleLog("ELSE");
            // MyService.ConsoleLog(rdata.to[0].uid + "==" + val);
            if (rdata.to[0].uid == val) {
              return rdata;
            } else {
              return $scope.politicians.filter(function (itm) {
                // MyService.ConsoleLog(rdata.to[0].uid + "==" + itm._id);

                if (rdata.to[0].uid == itm._id) {
                  return rdata;
                }
              });
            }
          }
        }
      );
    }
    $scope.getRatingsTotal = function (data) {
      // MyService.ConsoleLog("data :", data);
      var fdata = $scope.getToCount($scope.reviewData, data);
      // MyService.ConsoleLog("fdata",fdata);
      return fdata.length;
    }

  }]);

'use strict';

angular.module('myApp.compareGuestWith', ['ngRoute'])

  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/compareGuestWith/:type?', {
      templateUrl: 'app/compareGuestWith/compareGuestWith.html',
      controller: 'compareGuestWithCtrl'
    });
  }]).controller('compareGuestWithCtrl', ['$scope', 'apiCall', 'MyService', '$location', '$anchorScroll', '$timeout', '$rootScope', 'ngDialog', '$q', '$http', '$filter', 'growl', '$routeParams', 'baseApiUrl', 'tokenService', function($scope, apiCall, MyService, $location, $anchorScroll, $timeout, $rootScope, ngDialog, $q, $http, $filter, growl, $routeParams, baseApiUrl, tokenService) {


    $scope.noDataFound = false;
    $scope.FBCompareList = [];


    var data = window.localStorage.getItem('cData');
    // MyService.ConsoleLog("Data >>", data);
    try {
      $scope.AllData = JSON.parse(data);
    } catch (error) {
      MyService.ConsoleLog("Error >>", error);

    }

    // MyService.ConsoleLog("$scope.AllData  >>", $scope.AllData);
    // MyService.ConsoleLog("$scope.AllData  >>", $scope.AllData.AllUsers);
    // MyService.ConsoleLog("$scope.AllData  >>", $scope.AllData.AllUsers.length);
    // var Arr = [];
    var len = $scope.AllData.AllUsers.length;

    // if (Array.isArray($scope.AllData.AllUsers)) {
    //   for (var i = 0; i < len; i++) {
    //     var val = $scope.AllData.AllUsers[i];
    //     Arr.push(JSON.parse(val));
    //   }
    // } else {

    //   // var udata = JSON.parse($scope.AllData.AllUsers);
    //   // MyService.ConsoleLog("Udata >>>", udata);
    // }



    // MyService.ConsoleLog("Arr. >>", Arr);

    $scope.FBunWeighted = $scope.AllData.unweightedMatch;
    $scope.fbcombinedWeight = $scope.AllData.fbcombinedWeight;
    $scope.fbmultiplier = $scope.AllData.fbmultiplier;
    $scope.answeredQuestions = $scope.AllData.answeredQuestions;
    $scope.fbqlen = $scope.AllData.qlen;
    // if (Arr.length == 0) {
    //   $scope.noDataFound = false;

    //   $scope.AllUsers = $scope.AllData.AllUsers;
    //   MyService.ConsoleLog("$scope.AllUsers >>", $scope.AllUsers);
    // } else {

    var dups = [];
    var finalArr = $scope.AllData.AllUsers.filter(function(el) {
      // If it is not a duplicate, return true
      if (dups.indexOf(el.guestId) == -1) {
        dups.push(el.guestId);
        return true;
      }

      return false;

    });

    MyService.ConsoleLog("finalArr >", finalArr);

    $scope.AllUsers = finalArr;
    // }

    $scope.finalSignIn = function() {

      $location.path('/fiveSaveUser');
    }

  }]);

'use strict';

angular.module('myApp.compareGuest', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/compareGuestUsers/:type?', {
      templateUrl: 'app/compareGuestUsers/compareGuestUsers.html',
      controller: 'compareGuestUsersCtrl'
    });
  }]).controller('compareGuestUsersCtrl', ['$scope', 'apiCall', 'MyService', '$location', '$anchorScroll', '$timeout', '$rootScope', 'ngDialog', '$q', '$http', '$filter', 'growl', '$routeParams', 'baseApiUrl', 'tokenService', function ($scope, apiCall, MyService, $location, $anchorScroll, $timeout, $rootScope, ngDialog, $q, $http, $filter, growl, $routeParams, baseApiUrl, tokenService) {


    $scope.noDataFound = false;
    $scope.FBCompareList = [];


    if (tokenService.getUserId()) {
      $scope.userId = tokenService.getUserId();
      console.log('$scope.userId: ', $scope.userId);
    }

    var data = window.localStorage.getItem('Data');
    // MyService.ConsoleLog("Data >>", data);
    try {
      $scope.AllData = JSON.parse(data);
    } catch (error) {
      MyService.ConsoleLog("Error >>", error);

    }

    // MyService.ConsoleLog("$scope.AllData  >>", $scope.AllData);
    // MyService.ConsoleLog("$scope.AllData  >>", $scope.AllData.AllUsers);
    // MyService.ConsoleLog("$scope.AllData  >>", $scope.AllData.AllUsers.length);
    var Arr = [];
    var len = $scope.AllData.AllUsers.length;



    MyService.ConsoleLog("Arr. >>", Arr);

    $scope.FBunWeighted = $scope.AllData.unweightedMatch;
    $scope.fbcombinedWeight = $scope.AllData.fbcombinedWeight;
    // var ids = $scope.AllData.AllUsers.map(function(item) {
    //   return item._id;
    // })


    // var val = [];
    // for (var i = 0; i < len; i++) {
    //   if ($scope.AllData.fbmultiplier[ids[i]] && $scope.AllData.fbmultiplier[ids[i]] != "undefined") {
    //     val.push($scope.AllData.fbmultiplier[ids[i]]);

    //   }


    // }
    // MyService.ConsoleLog("val >", val);

    // var add = Math.max.apply(Math, val);
    // MyService.ConsoleLog("add >", add);


    $scope.fbmultiplier = $scope.AllData.fbmultiplier;
    $scope.answeredQuestions = $scope.AllData.answeredQuestions;
    $scope.fbqlen = $scope.AllData.qdata.length;
    $scope.unVerifiedFBunWeighted = $scope.AllData.finalUnFacbook;
    $scope.unVerifiedWeighated = $scope.AllData.finalunFbcombinedWeight;
    // var propValue = [];
    // for (var propName in $scope.AllData.unFbmultiplier) {
    //   if ($scope.AllData.unFbmultiplier.hasOwnProperty(propName)) {
    //     propValue.push($scope.AllData.unFbmultiplier[propName]);

    //   }
    // }

    // // MyService.ConsoleLog("$scope.unFbmultiplier >", $scope.AllData.unFbmultiplier);
    // // MyService.ConsoleLog("$scope.unFbmultiplier >", Object.keys($scope.AllData.unFbmultiplier).length);
    // // MyService.ConsoleLog("$scope.unFbmultiplier >", propValue.length);

    // var unFbMul = Math.max.apply(Math, propValue);

    // MyService.ConsoleLog("unFbMul >", unFbMul);

    $scope.unFbmultiplier = $scope.AllData.unFbmultiplier;

    // if (Arr.length == 0) {
    //   $scope.noDataFound = false;

    //   $scope.AllUsers = $scope.AllData.AllUsers;
    //   MyService.ConsoleLog("$scope.AllUsers >>", $scope.AllUsers);
    // } else {
    $scope.AllUsers = $scope.AllData.AllUsers;
    // }

    $scope.finalSignIn = function () {

      $location.path('/fiveSaveUser');
    }

  }]);

"use strict";
angular
  .module("myApp.compareEssayAns", ["ngRoute"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/compareEssayAns", {
        templateUrl: "app/compareEssayAns/compareEssayAns.html",
        controller: "compareEssayAnsCtrl",
      });
    },
  ])
  .controller("compareEssayAnsCtrl", [
    "$scope",
    "$http",
    "$location",
    "apiCall",
    "$routeParams",
    "$rootScope",
    "$q",
    "$timeout",
    "tokenService",
    "MyService",
    "$anchorScroll",
    "$cookies",
    "ngDialog",
    "growl",
    "$window",
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $rootScope,
      $q,
      $timeout,
      tokenService,
      MyService,
      $anchorScroll,
      $cookies,
      ngDialog,
      growl,
      $window
    ) {
      $scope.ansTypes = [];
      $scope.aType = "short";

      window.localStorage.setItem("isShowOldResult", true);
      $scope.loader = false;
      $scope.getEssayQuestions = function () {
        MyService.getFiveMinEssayQues().then(
          function (APIReponse) {
            var data = $scope.data.candidates.filter(function (val) {
              $scope.candidates.filter(function (item) {
                if (val._id == item._id) {
                  val = val;
                  val.total_answers = item.total_answers;
                  val.total_endorsements = item.total_endorsements;
                  val.total_reviews = item.total_reviews;
                  val.total_tagged = item.total_tagged;
                }
              });

              return val;
            });
            MyService.ConsoleLog("data check >> ", data);

            $scope.showCandidates = data;
            $scope.fiveMinQuestion = APIReponse;

            MyService.ConsoleLog(
              "$scope.fiveMinQuestion > ",
              $scope.fiveMinQuestion
            );
            $scope.loader = false;
          },
          function (err) {
            growl.error(err);
          }
        );
        $scope.getEssayAns("short");
      };

      $scope.getEssayAns = function (type) {
        $scope.showShort = true;
        $scope.showMedium = true;
        $scope.showLong = true;

        if (!type) {
          $scope.type = "short";
        } else {
          $scope.type = type;
        }
        $scope.ansTypes = [];
        $scope.aType = type;
      };

      $scope.isShowEssayAns = function (user, que) {
        var isData = $scope.essayAns[user._id].filter(function (ans) {
          if (ans.question == que._id) {
            if ($scope.type == "short" && ans.shortAns != "") {
              return ans;
            } else if ($scope.type == "medium" && ans.mediumAns != "") {
              return ans;
            } else if ($scope.type == "long" && ans.longAns != "") {
              return ans;
            }
          }
        });
        if (isData && isData.length > 0) {
          return true;
        } else {
          return false;
        }
      };

      $scope.getCandidate = function (val) {
        var params = {
          eDate: val,
          extradata: JSON.parse(window.localStorage.getItem("extraData")),
        };
        MyService.getCandidateListing(params).then(
          function (APIResponse) {
            MyService.ConsoleLog("APIResponse >> ", APIResponse);
            $scope.candidates = APIResponse.data.data;
            $scope.getEssayQuestions();
          },
          function (err) {
            MyService.ConsoleLog("get candi >> ", err);
          }
        );
      };

      $scope.goToPoliticianThread = function (officename, users, userData) {
        //console.log("goToPoliticianThread: ", users, " officename: ", officename, " userData: ", userData);
        $rootScope.politicianThreadData = {
          // office: officename,
          users: users,
          selected_user: userData,
        };
        window.localStorage.setItem(
          "politicianThreadData",
          JSON.stringify($rootScope.politicianThreadData)
        );
        $location.path("/politician-thread/" + userData._id);
      };

      $scope.compareRatings = function (users) {
        //MyService.ConsoleLog("users > ", users);
        $rootScope.selectedRatingUsers = [];
        angular.forEach(users, function (val, key) {
          //MyService.ConsoleLog("key123: ", key);
          //MyService.ConsoleLog(" val321: ", val);
          if (val.total_reviews > 0) {
            // alert("Here");
            console.log("valpoliticianIds >> ", val.politicianIds);
            if (!val.politicianIds) {
              var pids = [];
              pids.push(val._id);
              val["politicianIds"] = pids;
              console.log("val >>> ", val);
            }
            $rootScope.selectedRatingUsers.push(val);
          }
        });
        //MyService.ConsoleLog("$rootScope.selectedCompareUsers: ", $rootScope.selectedCompareUsers);
        if ($rootScope.selectedRatingUsers.length <= 0) {
          growl.error("None of the users you selected have ratings.");
        } else {
          $location.path("/compareRatings");
        }
      };

      // $scope.compareEndorsement = function (users) {

      // };

      if (window.localStorage.getItem("compareAnsData")) {
        $scope.loader = true;
        $scope.data = JSON.parse(window.localStorage.getItem("compareAnsData"));
        MyService.ConsoleLog(" values >> ", $scope.data);
        $scope.essayAns = $scope.data.essayAnswers;
        if (window.localStorage.getItem("eleDate")) {
          MyService.ConsoleLog(
            "eleDate >> ",
            window.localStorage.getItem("eleDate")
          );
          $scope.getCandidate(window.localStorage.getItem("eleDate"));
        }
      }
    },
  ]);

'use strict';
angular.module('myApp.compare_politician_questions', ['ngRoute', 'ngDialog'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/compare-politician-questions', {
      templateUrl: 'app/compare-politician-questions/compare-politician-questions.html',
      controller: 'comparePoliticianQuestionsCtrl'
    });
  }])

  .controller('comparePoliticianQuestionsCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$q', 'ngDialog', '$rootScope', 'growl', 'MyService', 'tokenService', '$anchorScroll', '$timeout', function ($scope, $http, $location, apiCall, $routeParams, $q, ngDialog, $rootScope, growl, MyService, tokenService, $anchorScroll, $timeout) {
    //MyService.ConsoleLog("** politician-compare ** :", $routeParams);
    $scope.FBCompareList = [];
    $scope.AnswerArray = [];
    $scope.AnswerArray[1] = "Very Strongly Agree";
    $scope.AnswerArray[2] = "Agree";
    $scope.AnswerArray[3] = "Somewhat Agree";
    $scope.AnswerArray[4] = "Somewhat Disagree";
    $scope.AnswerArray[5] = "Disagree";
    $scope.AnswerArray[6] = "Very Strongly Disgree";
    $scope.AnswerImpArray = [];
    $scope.AnswerImpArray[1] = "Somewhat Important";
    $scope.AnswerImpArray[2] = "Important";
    $scope.AnswerImpArray[3] = "Very Important";
    $scope.Math = window.Math;
    $rootScope.welcome = false;
    $scope.showAlert = false;
    window.localStorage.removeItem('qData');
    $scope.checkMyOrder = function (frnd) {
      //MyService.ConsoleLog($scope.ord.Option);
      switch ($scope.ord.Option) {
        case "BW":
          return -($scope.fbcombinedWeight[frnd.id] / $scope.fbmultiplier[frnd.id]);
          break;
        case "W":
          return ($scope.fbcombinedWeight[frnd.id] / $scope.fbmultiplier[frnd.id]);
          break;
        case "BS":
          return -($scope.FBunWeighted[frnd.id] / $scope.fbqlen[frnd.id]);
          break;
        case "S":
          return ($scope.FBunWeighted[frnd.id] / $scope.fbqlen[frnd.id]);
          break;
        default:
          return -($scope.fbcombinedWeight[frnd.id] / $scope.fbmultiplier[frnd.id]);
          break;
      }
    }
    $scope.status = 0;
    $scope.showSpecial = false;

    /** 
     * 
     * @description Get front runners records from locaStorage. 
     */


    $scope.frontRunners = JSON.parse(window.localStorage.getItem('frontRunners'));


    $scope.nextCat = function () {

      $scope.rootCatIndex = window.localStorage.getItem("RootCatIndex");
      MyService.ConsoleLog($scope.rootCatIndex);
      if ($scope.rootCatIndex < ($rootScope.categories.length - 1)) {
        $location.path("/question-compare/all/" + $rootScope.categories[$scope.rootCatIndex]._id);
      }

    }

    $scope.isObjectEmpty = function (card) {
      return Object.keys(card).length === 0;
    }

    $scope.CompareWithAllPolitcians = function () {
      $scope.status = 1;
      //MyService.ConsoleLog($scope.selection);
      //MyService.ConsoleLog("ComapreWithSelected");
      //MyService.ConsoleLog($rootScope.OldCatforFB._id);
      //MyService.ConsoleLog(window.localStorage.getItem("selectedCompareUsers"));
      var obj = JSON.parse(window.localStorage.getItem("caompareAll"));

      MyService.ConsoleLog("Object", obj);
      if (obj.compareUsersAll.length > 0 && obj.compareQuestionsAll.length > 0) {
        $scope.FBfreinds = JSON.parse(obj.compareUsersAll);
        var frdlist = JSON.stringify(obj.compareUsersAll);
        // MyService.ConsoleLog(frdlist);
        //MyService.ConsoleLog($routeParams.categoryId);
        MyService.CompareWithAllPolitcians({
          "frds": frdlist,
          "categoryIds": obj.compareQuestionsAll
        }).then(function (payload) {
          MyService.ConsoleLog("payload :", payload);
          $scope.myObject = payload.data.data.answeredQuestions;

          if ($scope.isObjectEmpty(payload.data.data.answeredQuestions)) {

            MyService.ConsoleLog(" Welcome to if");

            $scope.showAlert = true;

            // setTimeout(function() {

            //   $scope.showAlert = true;


            // }, 3000);

          }
          $scope.FBCompareList.length = 0;
          if (payload.data.success) {
            $scope.status = 0;
            // MyService.ConsoleLog(payload.data.data);
            $scope.FBCompareList = payload.data.data.qdata;
            if ($scope.FBCompareList.length > 0) {
              $scope.FBunWeighted = payload.data.data.unweightedMatch;
              $scope.fbcombinedWeight = payload.data.data.fbcombinedWeight;
              $scope.fbmultiplier = payload.data.data.fbmultiplier;
              $scope.answeredQuestions = payload.data.data.answeredQuestions;
              $scope.fbqlen = payload.data.data.qlen;
              $scope.AllUsers = payload.data.data.AllUsers;
              $scope.qData = payload.data.data.qdata;

              var allkeys = Object.keys($scope.answeredQuestions);
              // MyService.ConsoleLog("check now ", allkeys);
              $scope.isShowAsterix = {};
              $scope.frontRunners.filter(function (itms) {
                if (allkeys.indexOf(itms._id) > -1) {
                  $scope.isShowAsterix[itms._id] = true;
                }
              });


              window.localStorage.setItem('qData', JSON.stringify($scope.qData));
            } else {
              alert("Looks like your freinds not yet answered the questions.");
              //MyService.ConsoleLog($scope.FBCompareList);
            }
          } else {
            $scope.status = 0;
            alert("Something went wrong.");
          }
        }, function (errorpayload) {
          alert("Something went wrong.");
        })
      } else {
        alert("Please select at least one Friend to compare with");
      }
    }

    $scope.getOnePoliMatch = function (params) {
      MyService.ConsoleLog(" params", params);
      params.uId = tokenService.getUserId();
      // MyService.ConsoleLog('$rootScope.resultOfAns >> ', $rootScope.resultOfAns);
      MyService.getPoliMatch(params).then(function (result) {
        MyService.ConsoleLog("Results", result);
        // if (result && result.data.data && result.data.data.qdata) {
        $scope.questions = result.data.qdata;
        $scope.FBCompareList = result.data.qdata;

        if ($scope.FBCompareList && $scope.FBCompareList.length > 0) {
          $scope.showSpecial = true;

          $scope.FBunWeighted = result.data.unweightedMatch;
          $scope.fbcombinedWeight = result.data.fbcombinedWeight;
          $scope.fbmultiplier = result.data.fbmultiplier;
          $scope.answeredQuestions = result.data.answeredQuestions;
          $scope.fbqlen = result.data.qlen;
          $scope.AllUsers = result.data.AllUsers;
          $scope.poliName = result.data.poliName;
          $scope.poliInfo = result.data.poliInfo;
          // $scope.showcomparison = true;
          var allkeys = Object.keys($scope.answeredQuestions);
          // MyService.ConsoleLog("check now ", allkeys);
          $scope.isShowAsterix = {};
          $scope.frontRunners.filter(function (itms) {
            if (allkeys.indexOf(itms._id) > -1) {
              $scope.isShowAsterix[itms._id] = true;
            }
          });

          $scope.status = 0;
          MyService.ConsoleLog("$scope.AllUsers ", $scope.AllUsers);
          MyService.ConsoleLog(" $scope.FBunWeighted", $scope.FBunWeighted);
          window.localStorage.setItem('qData', JSON.stringify($scope.questions));
        }
        // } else {
        //   // growl.error(result.data.data.poliName + ' not answered the quiz yet');
        // }

      }, function (err) {
        if (err) {
          // $scope.Popup();
        }
        MyService.ConsoleLog("Error", err);
      });
    };
    if (!window.localStorage.getItem('isShowSpecialMatch')) {
      $scope.CompareWithAllPolitcians();
    } else {
      var para;
      if (window.localStorage.getItem('specialQueAns')) {
        para = JSON.parse(window.localStorage.getItem('specialQueAns'));
      }
      $scope.status = 1;
      $scope.getOnePoliMatch(para);
    }


    MyService.ConsoleLog("  $rootScope.catsId :", $rootScope.catsId);
    $scope.showDetails = function () {

      $location.path("question-compare-politician/" + $rootScope.catsId);
      // $rootScope.catsId = "";

    };
  }]);

'use strict';
angular.module('myApp.commonPhrases', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/commonPhrases', {
        templateUrl: 'app/commonPhrases/commonPhrases.html',
        controller: 'commonPhrasesCtrl' //we can name anythin
    });
}])
.controller('commonPhrasesCtrl', ['$scope','$rootScope', function($scope, $rootScope) {
    //this is controller for sampepage.html, we link the conttoler to page in config defination, check above .config
    $scope.search = {
        text: ''
    }
    $scope.oldhtml = $('.match').html();
    $rootScope.welcome = false;
    $scope.searchTerm = function() {
        //MyService.ConsoleLog($scope.search.text)
        var oldhtml = $scope.oldhtml;
        if ($scope.search.text != "") {
            

            if ((oldhtml != "") && (oldhtml != undefined)) {
                var fOld = '<span class="match">' + oldhtml + '</span>'
                    //MyService.ConsoleLog("oldhtml:",fOld);
                    /*
    	$("#content").html($("#content").html()
        .replace(fOld, oldhtml));	
        */
                $("span.match").replaceWith(oldhtml);
            }
            $("#content").css({ "height": "550px", "overflow": "auto" })

            var searchTermRegEx = new RegExp($scope.search.text, "i");
            $("#content").html($("#content").html()
                .replace(searchTermRegEx, "<span class='match'>" + $scope.search.text + "</span>"));

            //to highlighted specific index 
            setTimeout(function() {
                //MyService.ConsoleLog("Timeout called");
                $("#content").scrollTo(".match:first");
            }, 100);
        } else {
            $("#content").removeAttr("style");
             //var oldhtml = $('.match').html();

            if ((oldhtml != "") && (oldhtml != undefined)) {
                var fOld = '<span class="match">' + oldhtml + '</span>'
                    //MyService.ConsoleLog("oldhtml:",fOld);
                    /*
    	$("#content").html($("#content").html()
        .replace(fOld, oldhtml));	
        */
                $("span.match").replaceWith(oldhtml);
            }
        }
        //$("#content").scrollTo('.match:first');
        //         $('#content').animate({
        //     scrollTop: $(".match:first").offset().top
        // }, 1000);



        //$("#elementtoScrollToID").offset().top
        //to work with index you need you var matches to know what indexes exist
        //$('.match').eq(3).addClass('highlighted');
    }


}]);

'use strict';

angular.module('myApp.checkRegistration', ['ngRoute'])

.config(['$routeProvider', function ($routeProvider) {
     $routeProvider.when('/checkRegistration', {
         templateUrl: 'app/checkRegistration/checkRegistration.html',
         controller: 'checkRegistrationCtrl' 
     });
}])
.controller('checkRegistrationCtrl', ['$scope', '$rootScope', function($scope, $rootScope) {
$rootScope.welcome = false;
}]);

'use strict';
angular.module('myApp.calendar', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
        $routeProvider.when('/calendar', {
            templateUrl: 'app/calendar/calendar.html',
            controller: 'calendarCtrl' //we can name anythin
        });
    }])
.config(['$routeProvider', function($routeProvider) {
        $routeProvider.when('/calendar-event', { //pass user_id = me to see questions tagged to self
            templateUrl: 'app/calendar/calendar-event.html',
            controller: 'calendarEventCtrl'
        });
    }])
    .controller('calendarCtrl', ['$scope', '$rootScope','MyService', '$location', function($scope, $rootScope, MyService, $location) {
        //this is controller for sampepage.html, we link the controller to page in config definition, check above .config
        $scope.CalendarList = [];
        $rootScope.welcome = false;
        $scope.getCalendarList = function() {
        	//MyService.ConsoleLog("getCalendarList called");
        	MyService.getCalendarList().then(function(payload) {
        		//MyService.ConsoleLog(payload);
        		$scope.CalendarList = payload;
        	}, function(errorpayload) {
        		//MyService.ConsoleLog("error");
        		//MyService.ConsoleLog(errorpayload);
        	});
        }

        $scope.getCalendarList();


        $scope.calendarEvent = function(id) {
        	window.localStorage.setItem("calendarId", id);
        	$location.path('/calendar-event');
        }

    }])
    .controller('calendarEventCtrl', ['$scope', '$rootScope', 'MyService', '$routeParams', function($scope, $rootScope, MyService, $routeParams) {
        //this is controller for sampepage.html, we link the controller to page in config definition, check above .config
        var calendarId = window.localStorage.getItem("calendarId");
        $rootScope.welcome = false;
        $scope.CalendarEventList = [];
        $scope.getCalendarEventList = function() {
        	//MyService.ConsoleLog("getCalendarList called");
        	MyService.getCalendarEventList({"calendarId": calendarId}).then(function(payload) {
        		//MyService.ConsoleLog(payload);
        		$scope.CalendarEventList = payload;
        	}, function(errorpayload) {
        		//MyService.ConsoleLog("error");
        		//MyService.ConsoleLog(errorpayload);
        	});
        }

        $scope.getCalendarEventList();
    }]);

'use strict';

angular.module('myApp.boardsofelections', ['ngRoute'])

.config(['$routeProvider', function ($routeProvider) {
     $routeProvider.when('/boardsofelections', {
         templateUrl: 'app/boardsofelections/boardsofelections.html',
         controller: 'boardsofelectionsCtrl' 
     });
}])
.controller('boardsofelectionsCtrl', ['$scope','$rootScope', function($scope,$rootScope) {
$rootScope.welcome = false;
}]);

'use strict';
angular.module('myApp.ballotThread', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/ballotThread/:id', {
      templateUrl: 'app/ballotThread/ballotThread.html',
      controller: 'ballotThreadCtrl'
    });
  }])
  .controller('ballotThreadCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$filter', 'MyService', 'ngDialog', 'growl', 'tokenService', '$sce', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $filter, MyService, ngDialog, growl, tokenService, $sce) {

    /**
     * Params
     */
    $scope.bId = $routeParams.id;
    MyService.ConsoleLog("$scope.bId", $scope.bId);

    $rootScope.welcome = false;
    $scope.category = {};
    $scope.subcategory = {};
    $scope.DisplayData = [];
    $scope.userType = tokenService.getUserRole();
    $scope.userId = tokenService.getUserId();
    if (tokenService.getUserData()) {
      $scope.userData = JSON.parse(tokenService.getUserData());
    }
    $scope.Sticky = {
      txtOrder: 0
    };

    if ($rootScope.ExtraTopicData) {
      if ($rootScope.ExtraTopicData.MyDiscussion) {
        $scope.DiscussionData = $rootScope.ExtraTopicData.MyDiscussion;
      }

      if ($rootScope.ExtraTopicData.ActiveData) {
        $scope.ActiveThreads = $rootScope.ExtraTopicData.ActiveData;
      }

      if ($rootScope.ExtraTopicData.HotTopics) {
        $scope.HotTopics = $rootScope.ExtraTopicData.HotTopics;
      }
    }

    if (window.localStorage.getItem("VoteWiseCategory")) {
      $rootScope.allcategories = JSON.parse(window.localStorage.getItem("VoteWiseCategory"));
      var idx = $rootScope.allcategories.indexOf($routeParams.subcatId);

      if (idx == -1) {
        $rootScope.allcategories.push($routeParams.subcatId);
        window.localStorage.setItem("VoteWiseCategory", JSON.stringify($rootScope.allcategories));
      }
    }

    $scope.checkSticky = function (val) {
      if (val == 'Y') {
        return {
          'background-color': "#fbeec0"
        };
      } else {
        return '';
      }
    };

    $scope.createNew = function () {
      $location.path('/createBallotThread/' + $scope.bId);
    };

    $scope.statusGetForumList = 0;
    $scope.getForumList = function () {
      if ($scope.userData) {
        var address = JSON.stringify($scope.userData.address);
      } else {
        var address = "";
      }
      var finalData = {
        "taggedUserId": $routeParams.id
      };
      //MyService.ConsoleLog("post Data : ", finalData);
      $scope.statusGetForumList = 1;
      var nrequest = apiCall.apiCall('POST', '/topics/getList', finalData);
      $http(
        nrequest
      ).then(function successCallback(responseLatest) {
        //MyService.ConsoleLog("Final DataL : ",responseLatest);
        //MyService.ConsoleLog(responseLatest.data.data);
        if (responseLatest.data.success) {
          $scope.DisplayData = responseLatest.data.data;
          MyService.ConsoleLog("this is new", $scope.DisplayData);
          $scope.statusGetForumList = 2;
        } else {
          $scope.statusGetForumList = 3;
          if (responseLatest.data.error && typeof responseLatest.data.error == "string") {
            growl.error(responseLatest.data.error);
          } else {
            growl.error('Something went wrong.');
          }
        }
      }, function errorCallBack(responseLatest) {
        $scope.statusGetForumList = 3;
        growl.error("Error : " + responseLatest);
      });
    }

    function getSubCategories() {
      MyService.getSubCategoryList($routeParams.subcatId).then(function (payload) {
          $scope.subcategory = payload;
        },
        function (errorPayload) {
          alert('Something went wrong. ');
        });

    }

    function getCategory() {
      MyService.getCategoryList($routeParams.categoryId).then(function (payload) {
          $scope.category = payload;
          //MyService.ConsoleLog("subcatdata : ", subcatdata);

        },
        function (errorPayload) {
          alert('Something went wrong.');
        });

    }

    $scope.gotoThread = function (id) {

      var categoryId = $routeParams.categoryId;
      var subcatid = $routeParams.subcatId;
      $location.path('forumthread/' + categoryId + '/' + subcatid + '/' + id);
    }

    $scope.updatePostApi = function (data, options, idex) {

      var request = apiCall.apiCall('POST', '/topics/update', data);
      $http(
        request
      ).then(function successCallback(response) {
        //MyService.ConsoleLog(response);
        if (response.data.data.nModified == 0) {
          alert("Something went wrong. Please try after sometime.");
        } else {
          $scope.getForumList();

        }

      }, function errorCallBack(response) {
        //MyService.ConsoleLog("Error: ", JSON.stringify(response));
      });
    }

    $scope.gotoUpdate = function (item) {
      $location.path('/updateTopic/' + $routeParams.categoryId + '/' + $routeParams.subcatId + '/' + $routeParams.type + '/' + item._id);

    }


    $scope.objectKeys = function (obj) {
      return Object.keys(obj);
    }

    $scope.updatePost = function (option, id) {
      var data = {};
      if (option == "sticky") {
        data.poststicky = 1;
        data.poststickyOrder = $scope.Sticky.txtOrder[id];
        data.topicId = id;

      } else {
        data.removepostSticky = 1;
        data.topicId = id;

      }
      //MyService.ConsoleLog(data);
      $scope.updatePostApi(data);
    }


    /*if ($routeParams.categoryId) {
        getCategory();
        getSubCategories();

    }*/
    if ($routeParams.id) {
      $scope.getForumList();
    }
  }]);

'use strict';
angular.module('myApp.ballotReviewDetails', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/ballotReviewDetails/:id/:uid?/:type?', {
      templateUrl: 'app/ballotReviewDetails/ballotReviewDetails.html',
      controller: 'ballotReviewDetailsCtrl'
    });
  }])
  .controller('ballotReviewDetailsCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService) {

    /**
     * Get id using route params
     */
    $scope.bId = $routeParams.id;
    $scope.uId = $routeParams.uid;

    MyService.ConsoleLog("$scope.bId", $scope.bId);

    $scope.getReviewDetails = function () {
      MyService.getReviewsDetailsOf({
        bId: $scope.bId,
        uId: $scope.uId
      }).then(function (response) {
        MyService.ConsoleLog("Response", response);
        $scope.reviewDetails = response.data.data;
        $scope.arrLinks = $scope.reviewDetails.links.split(',');
      }, function (err) {
        MyService.ConsoleLog("Error", err);
      });
    };
    $scope.getReviewDetails();
  }]);

'use strict';
angular.module('myApp.ballotRating', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/ballotRatings/:id', {
      templateUrl: 'app/ballotRating/ballotRating.html',
      controller: 'ballotRatingCtrl'
    });
  }])
  .controller('ballotRatingCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', '$sce', 'growl', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService, $sce, growl) {

    /**
     * Get params using Route params
     */
    $scope.bId = $routeParams.id;
    MyService.ConsoleLog(" $scope.bId", $scope.bId);

    /**
     * Get Details of ballot measures
     */
    $scope.getDetailsOfBallot = function () {
      MyService.getDetailsOfBallotMeasures({
        bId: $scope.bId
      }).then(function (response) {
        MyService.ConsoleLog("Response", response);
        if (response) {
          $scope.title = response.title;
          $scope.getData();
        }
      }, function (err) {
        MyService.ConsoleLog("Error", err);
      });
    };

    /**
     * Get Reviews of the bill
     */
    $scope.getData = function () {

      MyService.getReviewsByBallotId({
        bId: $scope.bId
      }).then(function (response) {
        MyService.ConsoleLog("reposne", response);
        $scope.allReviews = response.data.data;
      }, function (err) {
        MyService.ConsoleLog("error", err);
      });
    };

    /**
     * Sort name wise
     */
    $scope.sortSearch = function (val) {
      var sortOrder = "";
      MyService.ConsoleLog(val);
      if (val == 'name') {
        MyService.ConsoleLog("nameUp > ", $scope.nameUp);
        if ($scope.nameUp == "" || $scope.nameUp == "DESC") {
          sortOrder = "ASC";
          $scope.nameUp = true;
          $scope.nameDown = false;
          $scope.allReviews.sort(function (a, b) {
            var x = a.from[0].name.toLowerCase();
            var y = b.from[0].name.toLowerCase();
            if (x < y) {
              return -1;
            }
            if (x > y) {
              return 1;
            }
            return 0;
          });

        } else {
          sortOrder = "DESC";
          $scope.nameDown = true;
          $scope.nameUp = false;
          $scope.allReviews.sort(function (a, b) {
            var x = a.from[0].name.toLowerCase();
            var y = b.from[0].name.toLowerCase();
            if (x > y) {
              return -1;
            }
            if (x < y) {
              return 1;
            }
            return 0;
          });

        }
      } else {
        $scope.nameUp = false;
        $scope.nameDown = false;
      }
      if (val == 'rating') {
        if ($scope.ratingUp == "" || $scope.ratingUp == "DESC") {
          sortOrder = "ASC";
          $scope.ratingUp = true;
          $scope.ratingDown = false;
          $scope.allReviews.sort(function (a, b) {
            return a.number - b.number;
          });

        } else {
          sortOrder = "DESC";
          $scope.ratingDown = true;
          $scope.ratingUp = false;
          $scope.allReviews.sort(function (a, b) {
            return b.number - a.number;
          });
        }
      } else {
        $scope.ratingUp = false;
        $scope.ratingDown = false;
      }
    };

    /**
     * Sort Date
     */
    $scope.sortDate = function () {
      var sortOrder = "";

      if ($scope.ratingDateUp == "" || $scope.ratingDateUp == "DESC") {
        sortOrder = "ASC";
        $scope.ratingDateUp = true;
        $scope.ratingDateDown = false;
        $scope.allReviews.sort(function (a, b) {
          var asc;
          var bss;
          // return a.timespan - b.timespan;
          MyService.ConsoleLog("createdBy", a.createdBy);
          if (a.createdBy.length > 4 || b.createdBy.length > 4) {
            // console.log("if");
            asc = a.createdBy.slice(0, 4);
            bss = b.createdBy.slice(0, 4);
            MyService.ConsoleLog("ass", asc + "   " + bss);
            return asc - bss;
          }
        });
      } else {
        sortOrder = "DESC";
        $scope.ratingDateDown = true;
        $scope.ratingDateUp = false;
        var oneA, bTwo;

        $scope.allReviews.sort(function (a, b) {
          if (a.createdBy.length > 4 || b.createdBy.length > 4) {
            // console.log("if");
            oneA = a.createdBy.slice(0, 4);
            bTwo = b.createdBy.slice(0, 4);
            // MyService.ConsoleLog("ass", asc + "   " + bss);
            return bTwo - oneA;
          }
        });
      }
    };

    $scope.getDetailsOfBallot();


  }]);

"use strict";
angular
  .module("myApp.ballotMeasures", ["ngRoute"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/ballotMeasures", {
        templateUrl: "app/ballotMeasures/ballotMeasures.html",
        controller: "ballotMeasuresCtrl"
      });
    }
  ])
  .controller("ballotMeasuresCtrl", ["$scope", "$http", "$location", "apiCall", "$rootScope", "baseApiUrl", "$q", "$filter", "growl", "ngDialog", "tokenService", "MyService", function ($scope, $http, $location, apiCall, $rootScope, baseApiUrl, $q, $filter, growl, ngDialog, tokenService, MyService) {


    $scope.allState = [];
    $scope.address = {
      state: "",
      upstate: "",
      files: ""
    };
    /**
     * Load list of states
     */
    $scope.getAllStates = function () {
      $scope.allState.length = 0;
      $scope.loader = true;
      // console.log("address.state", $scope.address.state);
      MyService.getAllStates().then(
        function (payload) {
          // console.log("payload : ", payload);
          $scope.allState = payload;
          $scope.loader = false;
        },
        function (errorPayload) {
          growl.error("Something went wrong.");
          $scope.loader = false;
        }
      );
    };

    /**
     * End Of  getAllStates
     */

    /**
     * Call function on page Load
     */
    $scope.getAllStates();

    /**
     * addBallotMeasures
     * Add ballot measures by statewise
     */

    $scope.addBallotMeasures = function () {
      var stateps = $scope.address.state.statePostalCode;
      MyService.addBallotMeasuresData({
        state: stateps
      }).then(function (response) {
        MyService.ConsoleLog("response", response);
        $scope.ballotData = response.data.data;
      });
    };
    /**
     * End of addBallotMeasures
     */
  }]);

 "use strict";
 angular
   .module("myApp.ballotMatch", ["ngRoute"])

   .config([
     "$routeProvider",
     function ($routeProvider) {
       $routeProvider.when("/ballotMatch/:uId?", {
         templateUrl: "app/ballotMatch/ballotMatch.html",
         controller: "ballotMatchCtrl"
       });
     }
   ]).controller('ballotMatchCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$q', 'ngDialog', '$rootScope', 'growl', 'MyService', '$anchorScroll', '$timeout', 'tokenService', function ($scope, $http, $location, apiCall, $routeParams, $q, ngDialog, $rootScope, growl, MyService, $anchorScroll, $timeout, tokenService) {
     //MyService.ConsoleLog("** questionCtrl ** :", $routeParams);
     $rootScope.welcome = false;
     $scope.traverseBackgrounds = [];
     $scope.currBackgroundIndex = 0;

     if ($routeParams.uId) {
       $scope.selUserId = $routeParams.uId;
     }
     // $scope.flagSkipAnsweredQuestion = true;
     // alert("welcome");
     // $('#skipMatchOne').attr('disabled', false);
     // $scope.reason;
     // $scope.comment;
     $scope.skipMatchOne = 1;
     MyService.ConsoleLog(" $scope.skipMatchOne :", $scope.skipMatchOne);

     $scope.status = {
       questions: 0, //1= loading, 2 = loaded, 3 = error
       category: 0
     };

     window.localStorage.removeItem('specialQueAns');
     $scope.updata = {
       comment: "",
       reason: ""
     };
     if (tokenService.getUserData()) {
       $scope.userData = JSON.parse(tokenService.getUserData());
       // MyService.ConsoleLog(" $scope.userData :", $scope.userData)
     }


     $scope.currentIndex = 0;
     $scope.initializeVariables = function () {
       $scope.importance = null;
       $scope.answer = null;
       $scope.updata.comment = '';
       $scope.reason = '';
     };
     $scope.initializeVariables();

     $scope.initMyAnswer = function () {
       try {
         MyService.ConsoleLog("$scope.questions[$scope.currentIndex] :", $scope.questions[$scope.currentIndex]);
         if ($scope.questions[$scope.currentIndex].my_answer) {
           var user_answer = $scope.importance = $scope.questions[$scope.currentIndex].my_answer;
           $scope.importance = user_answer.importance;
           $scope.answer = user_answer.answer;
           $scope.updata.comment = user_answer.comment;
           $("#agreedisagree-id" + user_answer.answer).prop('checked', true);
           $("#importance-id" + user_answer.importance).prop('checked', true);


         } else {
           $scope.initializeVariables();
         }
       } catch (e) {
         $scope.initializeVariables();
         //MyService.ConsoleLog("Exceptoin: ", e)
       }
     };

     var getQuestionsCanceler = $q.defer();

     /*
     function getQuestions(params) {
       getQuestionsCanceler.resolve();
       $scope.status.questions = 1;
       params.timeout = getQuestionsCanceler.promise;
       MyService.ConsoleLog("questionAnsByCtrl** /questions/list: ", params);
       $scope.questions.length = 0;
       var request = apiCall.apiCall('GET', '/questions/list', params);
       $http(
         request
       ).then(function successCallback(response) {
         MyService.ConsoleLog("questionAnsByCtrl Got categories: ", response);
         if (response.data.success) {
           $scope.status.questions = 2;
           $scope.questions = response.data.data;
           MyService.ConsoleLog("total questions: ", $scope.questions);
           // $scope.skipAnswerChagne();
         } else {
           $scope.status.questions = 3;
           if (typeof response.data.error == "string")
             growl.error(response.data.error);
           else {
             // growl.error("Something went wrong");
           }
         }
       }, function errorCallBack(response) {
         $scope.status.questions = 3;
         //MyService.ConsoleLog("Error: ", response);
       });
     }
    */

     $scope.getUserProfile = function () {
       MyService.getProfile($routeParams.user_id).then(function (userData) {
         $scope.userData = userData;
         MyService.ConsoleLog("userData: ", $scope.userData);
       }, function (err) {
         growl.error("Something went wrong while fetching user info.");
       });
     }

     var getCategoryCanceler = $q.defer();
     var prevFetchedCategoryId = null;
     $scope.categoryCalled = false;
     $scope.getCategory = function (params) {
       MyService.ConsoleLog("scrollTop pre :", prevFetchedCategoryId);
       MyService.ConsoleLog("scrollTop Two :", params.id);


       if (prevFetchedCategoryId != params.id) {
         MyService.ConsoleLog("scrollTop");
         $scope.categoryCalled = true;
         $("html, body").animate({
           scrollTop: 0
         }, "slow");
         getCategoryCanceler.resolve();
         $scope.status.category = 1;
         params.timeout = getCategoryCanceler.promise;
         var request = apiCall.apiCall('GET', '/categories/list', params);
         $http(
             request
           )
           .then(function successCallback(response) {
             //MyService.ConsoleLog("Got categories: ",response);
             if (response.data.success) {
               $scope.category = response.data.data;
               //MyService.ConsoleLog("category data: ", $scope.category);
               prevFetchedCategoryId = $scope.category._id;
               $scope.status.category = 2;
             } else {
               //MyService.ConsoleLog("Something went wrong: ", response.data);
               $scope.status.category = 3;
             }
           }, function errorCallBack(response) {
             //MyService.ConsoleLog("Error: ", response);
             $scope.status.category = 3;
           });
       } else {

         $("html, body").animate({
           scrollTop: $("#DisplayQ1").offset().top - 80
         }, "slow");
         // $timeout(function() {
         //   MyService.ConsoleLog("called")
         //   $location.hash('DisplayQue');
         //   $anchorScroll();

         // }, 100);

       }
     };


     $scope.postAnswer = function (postData) {
       // MyService.ConsoleLog("postData: ", postData);
       try {
         var my_answer = $scope.questions[$scope.currentIndex].my_answer;
         if (my_answer.importance != $scope.importance || my_answer.answer != $scope.answer || my_answer.comment != $scope.updata.comment) {
           MyService.ConsoleLog("Answer changed :", my_answer);
           postData.id = my_answer._id;
           postData.reason = $scope.updata.reason;
         } else {
           //MyService.ConsoleLog("Answer not changed");
           return; //don't do anything
         }
       } catch (e) {
         //MyService.ConsoleLog("Exceptoin: ", e);
       }
       //MyService.ConsoleLog(postData);
       MyService.ConsoleLog("postData Second: ", postData);


       MyService.postAnswer(postData).then(function (response) {
         document.getElementById("txtReason").value = '';

         if (response.data.success) {
           // console.log("response.data > ", response.data.data);
           try {
             if (postData.id) {
               var idx = angular.copy($scope.currentIndex);
               console.log("IDX <><><><", idx);
               $scope.questions[$scope.currentIndex]["my_answer"] = {
                 _id: postData.id,
                 question: postData.questionId,
                 created: new Date(),
                 comment: postData.comment,
                 answer: postData.answer,
                 importance: postData.importance
               };
             } else {
               var idx = angular.copy($scope.currentIndex);
               console.log("eLSE IDX <><><><", idx);
               $scope.questions[$scope.currentIndex]["my_answer"] = {
                 _id: response.data.data._id,
                 question: response.data.data.question,
                 created: response.data.data.created,
                 comment: response.data.data.comment,
                 answer: response.data.data.answer,
                 importance: response.data.data.importance
               };
             }
             // $scope.questions = angular.copy($scope.questions);
             console.log("questions <><><><>", $scope.questions);
           } catch (e) {
             //MyService.ConsoleLog("Exceptoin: ", e);
           }
           if (postData.id) {
             growl.success("Answer updated successfully", {
               ttl: 800
             });
           } else {
             growl.success("Answered successfully", {
               ttl: 800
             });
           }
           $scope.initializeVariables();
           $scope.skipQuestions();
         } else {
           growl.error("Error: " + response.data.error);
         }
       }, function (err) {
         // growl.error("Something went wrong.");
       });

     };






     $scope.submitAnswer = function () {

       MyService.ConsoleLog("submitAnswer: " + $scope.answer);
       MyService.ConsoleLog("importance: " + $scope.importance);
       MyService.ConsoleLog("comments: ", $scope.updata.comment);
       // MyService.ConsoleLog("$scope.comments: ", $scope.comment);
       MyService.ConsoleLog("$scope.comments: ", $scope.updata.reason);

       //  MyService.ConsoleLog("$scope.questions[$scope.currentIndex]._id ", $scope.questions[$scope.currentIndex]);
       if ($scope.questions[$scope.currentIndex] && $scope.questions[$scope.currentIndex].my_answer && $scope.questions[$scope.currentIndex].my_answer._id != '') {
         var myAns = $scope.questions[$scope.currentIndex].my_answer;
         if ($scope.answer == null || $scope.answer == '') {
           $scope.answer = myAns.answer;
         }
         if ($scope.importance == null || $scope.importance == '') {
           $scope.importance = myAns.importance;
         }
       }

       var token = apiCall.getToken();

       if (!token || token == "") {
         var message = "Please login first.";

         var modal = ngDialog.openConfirm({
           template: '<p>' + message + '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
           plain: true
         });
         modal.then(function fullfilled(data) {
           //MyService.ConsoleLog("fullfilled: ", data);
         }, function rejected(data) {
           //MyService.ConsoleLog("rejected: ", data);
         });
         return;
       }

       if ($scope.answer == null) {
         var message = "Please select answer first.";
         var modal = ngDialog.openConfirm({
           template: '<p>' + message + '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
           plain: true
         });

         modal.then(function fullfilled(data) {
           //MyService.ConsoleLog("fullfilled: ", data);
         }, function rejected(data) {
           //MyService.ConsoleLog("rejected: ", data);
         });

         return;
       }

       if ($scope.importance == null) {
         var message = "You gave your opinion, but you didn’t say how important this is to you.  Should they fight hard for this or can they use it as a bargaining chip to get other things you care about more?";

         var modal = ngDialog.openConfirm({
           template: '<p>' + message + '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
           plain: true
         });

         modal.then(function fullfilled(data) {
           //MyService.ConsoleLog("fullfilled: ", data);
         }, function rejected(data) {
           //MyService.ConsoleLog("rejected: ", data);
         });
         return;
       }
       // $("html, body").animate({
       //   scrollTop: $("#DisplayQ1").offset().top - 80
       // }, "slow");

       var postData = {
         questionId: $scope.questions[$scope.currentIndex]._id,
         importance: $scope.importance,
         answer: $scope.answer,
         comment: $scope.updata.comment ? $scope.updata.comment : "",
         reason: $scope.updata.reason,
         token: token
       };
       //MyService.ConsoleLog(postData);
       $scope.postAnswer(postData);
     };

     // $scope.comment;
     //   MyService.ConsoleLog("  $scope.comment :", $scope.comment);



     $scope.skipQuestions = function () {
       MyService.ConsoleLog(" questionssssssssssssssssssss called");
       // $scope.categoryCalled = false;
       // MyService.ConsoleLog(' $rootScope.queOneLen ', $rootScope.queOneLen);




       var skip = function () {
         var tempIndex = $scope.currentIndex + 1;
         MyService.ConsoleLog(" length of questions :", tempIndex);
         if (tempIndex < $scope.questions.length) {
           $scope.initializeVariables();
           $scope.currentIndex++;
           if ($routeParams.categoryId && $routeParams.categoryId.indexOf("popular:") == 0) {
             //we are showing questions of most popular section
             MyService.ConsoleLog("welcome to if");

             $scope.getCategory({
               id: $scope.questions[$scope.currentIndex].categories.cid
             });
           }
         }
         if (tempIndex >= 5) {
           // $scope.skipToRes = true;
           // $('#skipMatchOne').attr('disabled', false);
           $scope.skipMatchOne = 2;
         }
         MyService.ConsoleLog("tempIndex = ", tempIndex, "$scope.questions.length ", $scope.questions.length);
         if (tempIndex == $scope.questions.length) {
           //MyService.ConsoleLog("end of questions switch background");
           var tempBackIdx = $scope.currBackgroundIndex + 1;
           if (tempBackIdx < $scope.traverseBackgrounds.length) {
             $scope.currBackgroundIndex++;
             $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
             MyService.ConsoleLog(" category  id   : ", $scope.category);
           } else {
             //MyService.ConsoleLog("* End of background *");
             var message = "Congratulations, you have answered all the questions that your politicians have answered.";
             var modal = ngDialog.openConfirm({
               template: '<p>' + message + '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">See Match-ups</button>\
                        </div>',
               plain: true
             });

             modal.then(function fullfilled(data) {
               //MyService.ConsoleLog("fullfilled: ", data);
               getCompareAnswers({
                 "compareQuestionsAll": JSON.stringify($scope.queIds),
                 "compareUsersAll": JSON.stringify($scope.compareUsersAll)
               });
             }, function rejected(data) {
               //MyService.ConsoleLog("rejected: ", data);
             });
             return;

           }
         }



       };

       skip();


     };

     $scope.prevQuestion = function () {
       //MyService.ConsoleLog("** prevQuestion **");

       if ($scope.currentIndex > 0) {
         // $("html, body").animate({
         //   scrollTop: 0
         // }, "slow");
         $scope.currentIndex--;
         if ($scope.digDeeperMatch != true) {
           if (window.localStorage.getItem("fiveMinMatch")) {
             //MyService.ConsoleLog("here");
             $scope.getFiveMinData = [];
             $scope.getFiveMinData.length = 0;
             if ($scope.flagSkipAnsweredQuestion) {
               $scope.getFiveMinData = $scope.cachedQuestions;
             } else {
               $scope.getFiveMinData = JSON.parse(window.localStorage.getItem("fiveMinMatch"));
             }

             //MyService.ConsoleLog("Data : ", $scope.getFiveMinData);
             for (var i = 0; i < $scope.getFiveMinData.length; i++) {
               MyService.ConsoleLog("for i : " + i + " currentIndex : " + $scope.currentIndex);
               if (i == $scope.currentIndex) {
                 MyService.ConsoleLog("index matched", $scope.getFiveMinData[i]);
                 // $scope.answer = $scope.getFiveMinData[i].answer;
                 // $scope.importance = $scope.getFiveMinData[i].importance;
                 // $scope.comment = $scope.getFiveMinData[i].comment;
                 // $("#agreedisagree-id" + user_answer.answer).prop('checked', true);
                 // $("#importance-id" + user_answer.importance).prop('checked', true);

                 // $timeout(function() {
                 //   $scope.$apply();
                 // });

               }
             }
           }
         }


       } else if ($scope.currentIndex == 0) {
         if ($scope.currBackgroundIndex > 0) {
           $scope.currBackgroundIndex--;
           $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
         }
       }
     };

     var getCompareAnswersCanceler = $q.defer();

     function getCompareAnswers(params) {
       MyService.ConsoleLog("params >>>", params);

       if (!params) return;
       getCompareAnswersCanceler.resolve();
       params.timeout = getCompareAnswersCanceler.promise;
       $scope.questions = [];
       $scope.status.questions = 1;
       // $rootScope.selectedCompareUsers = params.compareUsersAll;
       //  var comObj = {
       //    "compareUsersAll": params.compareUsersAll,
       //    "compareQuestionsAll": params.compareQuestionsAll
       //  }
       //  MyService.ConsoleLog(" compare object :", comObj);
       //  window.localStorage.setItem("caompareAll", JSON.stringify(comObj));
       //  $location.path("/compare-politician-questions");
       //  return;
       var request = apiCall.apiCall('POST', '/answers/getCompareAnswersForPoliticians', params);
       request.headers['Cache-Control'] = 'No-Store';
       $http(
         request
       ).then(function successCallback(response) {
         MyService.ConsoleLog("Got categories:>> ", response);
         if (response.data.data.length > 0) {
           $scope.status.questions = 2;
           $scope.userIds = response.data.data.map(function (obj) {
             if (obj != "" && obj != " ") {
               return obj.answers[0].author._id;
             }
           })
           MyService.ConsoleLog("User ides", $scope.userIds.length);
           $rootScope.selectedCompareUsers = $scope.userIds;
           var comObj = {
             "compareUsersAll": JSON.stringify($scope.userIds),
             "compareQuestionsAll": JSON.stringify($scope.queIds)
           }
           MyService.ConsoleLog(" compare object :", comObj);
           window.localStorage.setItem("caompareAll", JSON.stringify(comObj));

           MyService.ConsoleLog("$rootScope.selectedCompareUsers :", $rootScope.selectedCompareUsers);
           angular.forEach(response.data.data, function (val, key) {
             if (val.answers && val.answers.length != $rootScope.selectedCompareUsers.length) {
               var check_author_exist = function (u) {
                 var len = val.answers.length;
                 for (var i = 0; i < len; i++) {
                   if (val.answers[i].author._id == u._id) {
                     return true;
                   }
                 }
                 return false;
               };
               angular.forEach($rootScope.selectedCompareUsers, function (u, i) {
                 if (!check_author_exist(u)) {
                   response.data.data[key].answers.push({
                     author: u
                   });
                 }
               });
             } else if (!val.answers) {
               response.data.data[key].answers = [];
               angular.forEach($rootScope.selectedCompareUsers, function (u, i) {
                 response.data.data[key].answers.push({
                   author: u
                 });
               });
             }
           });

           $scope.questions = response.data.data;
           $rootScope.compareAnswerList = response.data.data;
           MyService.ConsoleLog("Questions><><><>", $scope.questions);
           MyService.ConsoleLog("Questions><><><>", params);

           // alert("params :",params);
           $rootScope.catsId = $scope.questions[0].categories[0].cid;
           MyService.ConsoleLog(" $scope.questions[0].categories[0].cid :", $scope.questions[0].categories[0].cid);
           /*
           if (params.type && params.type == "skipToResult") {

             $location.path("/compare-politician-questions");
           } else {
             // alert("else");

             $location.path("question-compare-politician/" + $scope.questions[0].categories[0].cid);
           }*/
           $location.path("/compare-politician-questions");

         } else {
           $scope.status.questions = 3;
           MyService.ConsoleLog("Something went wrong: ", response.data);
           var message = "None of your politicians have answered the questions yet. Contact them and ask them to fill it out.";

           var modal = ngDialog.openConfirm({
             template: '<p>' + message + '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">OK</button>\
                        </div>',
             plain: true
           });

           modal.then(function fullfilled(data) {
             //MyService.ConsoleLog("fullfilled: ", data);
             if (tokenService.getUserRole() == "politician") {
               $location.path("/winVoters");
             } else if (tokenService.getUserRole() == "voter") {
               $location.path("/questionHome");

             }
           }, function rejected(data) {
             //MyService.ConsoleLog("rejected: ", data);

           });
         }
       }, function errorCallBack(response) {
         $scope.status.questions = 3;
         //MyService.ConsoleLog("Error: ", response);
       });
     };

     var current_url = $location.url();
     //MyService.ConsoleLog("$location.url: ", current_url);


     $scope.state = "question-not-answered";
     $scope.status.questions = 1;
     $scope.compareQuestionsAll = [];
     //MyService.matchQuestionwithPolitician().then(function(payload) {


     // function to get questions commented by vishal

     // MyService.matchQuestionwithPolitician().then(function(payload) {

     //     MyService.ConsoleLog("matchQuestionwithPolitician :", payload);
     //     //MyService.ConsoleLog(payload.data.success);
     //     //MyService.ConsoleLog(payload.data.data.error);
     //     if (payload.data.success) {
     //       $scope.status.questions = 2;
     //       $scope.questions = payload.data.data.unanswered;
     //       $scope.compareQuestionsAll = payload.data.data.allanswered;
     //       $scope.compareUsersAll = payload.data.data.allusers;
     //       $scope.initializeVariables();
     //       // setTimeout(function() {
     //       //   getCompareAnswers({ "compareQuestionsAll": JSON.stringify($scope.compareQuestionsAll), "compareUsersAll": JSON.stringify($scope.compareUsersAll) });
     //       // }, 6000);

     //     } else {
     //       $scope.status.questions = 3;
     //       if (typeof payload.data.data.error == "string" && payload.data.data.error == "NoQuestions") {
     //         $scope.compareQuestionsAll = payload.data.data.allanswered;
     //         $scope.compareUsersAll = payload.data.data.allusers;
     //         growl.error("You already answered all the questions answered by your politicians.");
     //         // alert("welcome to compare");
     //         setTimeout(function() {
     //           getCompareAnswers({
     //             "compareQuestionsAll": JSON.stringify($scope.compareQuestionsAll),
     //             "compareUsersAll": JSON.stringify($scope.compareUsersAll)
     //           });
     //         }, 700);

     //       } else {
     //         growl.error("Something went wrong");
     //       }
     //     }
     //   },
     //   function(errpayload) {
     //     growl.error("Something went wrong");
     //   });


     // Function to get questions for local politicians.

     $scope.getBallotMatch = function () {
       // alert("called ballotMatch");
       $scope.status.questions = 1;
       MyService.getBallotQue().then(function (result) {
         MyService.ConsoleLog("matchQuestionwithPolitician :", result.data.data);
         // MyService.ConsoleLog("dhADGDAD :",result.data.success);
         //MyService.ConsoleLog(payload.data.data.error);
         if (result.data.success) {

           $scope.status.questions = 2;
           $scope.questions = result.data.data.quizData;
           $rootScope.ques = result.data.data.quizData;
           $scope.compareUsersAll = result.data.data.userIds;
           $scope.queIds = $scope.questions.map(function (obj) {
             if (obj != "" && obj != " ") {
               return obj._id;
             }
           });


           //  MyService.ConsoleLog("question ids :", $scope.queIds);
           $scope.flagSkipAnsweredQuestion = true;
           $scope.skipAnswerChagne();

         } else {
           $scope.status.questions = 3;
           MyService.ConsoleLog("result", result.data.error);
           growl.error(result.data.error);
         }



       }, function (err) {
         growl.error("Something went wrong");
       });

     };

     $scope.getUserSpecificQues = function () {
       MyService.getUserSpecificQues({
         "uId": $scope.selUserId,
         "curUId": tokenService.getUserId()
       }).then(function (APIResponse) {
         MyService.ConsoleLog("APIResponse Its me", JSON.parse(APIResponse.data.data));
         if (APIResponse.data.success) {

           $scope.status.questions = 2;
           $scope.questions = JSON.parse(APIResponse.data.data);
           //  MyService.ConsoleLog("check Data >>", $scope.questions);
           $rootScope.ques = JSON.parse(APIResponse.data.data);
           $scope.compareUsersAll = APIResponse.data.data.userIds;
           $scope.queIds = $scope.questions.map(function (obj) {
             if (obj != "" && obj != " ") {
               return obj._id;
             }
           });


           //  MyService.ConsoleLog("question ids :", $scope.queIds);
           $scope.flagSkipAnsweredQuestion = true;
           $scope.skipAnswerChagne();

         } else {
           $scope.status.questions = 3;
           MyService.ConsoleLog("result", APIResponse.data.error);
           growl.error(APIResponse.data.error);
         }
         $scope.status.questions = 2;
       }, function (err) {
         MyService.ConsoleLog("Error", err);
       });
     };

     if (!window.localStorage.getItem('isShowSpecialMatch')) {
       $scope.getBallotMatch();
     } else {
       $scope.getUserSpecificQues();
     }




     $scope.skipToMatchOne = function () {
       // alert("welcome");

       if (!window.localStorage.getItem('isShowSpecialMatch')) {
         getCompareAnswers({
           "compareQuestionsAll": JSON.stringify($scope.queIds),
           "compareUsersAll": JSON.stringify($scope.compareUsersAll),
           "type": "skipToResult"
         });
       } else {

         var para = JSON.stringify({
           poliId: $scope.selUserId,
           poliData: JSON.stringify($rootScope.ques)
         });
         window.localStorage.setItem('specialQueAns', para);
         $location.path("/compare-politician-questions");
       }

     };

     $scope.newOne = function (valOne) {
       $scope.importance = valOne;
       $scope.submitAnswer();

     };
     $scope.checkImpExists = function (val) {

       // MyService.ConsoleLog("value :", $scope.importance + "==" + val);

       if ($scope.questions) {
         var obj = $scope.questions[$scope.currentIndex];
         // MyService.ConsoleLog("object :", obj);

         if (obj) {
           var data = $scope.checkQuestion(obj._id);

           if (data && data[0]) {
             // MyService.ConsoleLog("checkIfExists data>> ", data[0].importance + "==" + val);
             if (data[0].my_answer.importance == val) {
               return true;
             }
           }
         }
       }
       return false;
     }

     $scope.checkIfExists = function (val) {
       // MyService.ConsoleLog("answe :>>> :",$scope.answer);

       if ($scope.questions) {
         var obj = $scope.questions[$scope.currentIndex];
         // MyService.ConsoleLog("checkIfExists >> ", obj);
         if (obj) {
           var data = $scope.checkQuestion(obj._id);

           if (data && data[0]) {
             // MyService.ConsoleLog("checkIfExists data>> ", data[0]);
             // $scope.updata.comment = data[0].my_answer.comment;
             if (data[0].my_answer.answer == val) {
               // console.log("return True");
               return true;
             }
           }
         }
       }
       return false;
     }

     $scope.checkQuestionAnswered = function () {
       // alert("called");
       // console.log("scope.questions > ", $scope.questions);
       return $scope.questions.filter(
         function (rdata) {
           // MyService.ConsoleLog(" questions Ids", rdata._id);
           var data = $scope.checkQuestion(rdata._id);
           if (data && data.length > 0) {
             return rdata;
           }
         }
       );
     }

     $scope.checkQuestion = function (val) {
       // MyService.ConsoleLog("value ", val);
       var queLen = $scope.questions.length;
       // alert(queLen);
       // MyService.ConsoleLog("quelen :",queLen);
       for (var i = 0; i < queLen; i++) {
         if ($scope.questions[i].my_answer && $scope.questions[i].my_answer != "") {
           return $scope.questions.filter(
             function (rdata) {
               // MyService.ConsoleLog(" ANs data :", rdata);


               if (rdata.my_answer) {
                 // MyService.ConsoleLog(" ANs data :", rdata.myAnswers.question);
                 if (rdata.my_answer.question == val) {
                   return rdata
                 }
               }
             });

         }
       }
     }


     $scope.cachedQuestions = [];
     // $rootScope.queOneLen = [];
     // $rootScope.queOneLen.length=0;
     $scope.flagSkipAnsweredQuestion = "";
     $scope.skipAnswerChagne = function () {
       // alert("called");
       MyService.ConsoleLog("scope.flagSkipAnsweredQuestion: ", $scope.flagSkipAnsweredQuestion);
       $scope.currentIndex = 0;
       console.log("$scope.questions<><><>", $scope.questions);
       var questions = $scope.checkQuestionAnswered();
       // $rootScope.fiveMatch.length = 0;
       MyService.ConsoleLog('questions >$$$ ', questions);
       // MyService.ConsoleLog('questions  length ', questions.length);
       // $rootScope.queOneLen = questions;
       // MyService.ConsoleLog(' $rootScope.queOneLen ', $rootScope.queOneLen);

       if (questions.length >= 5) {
         // $scope.skipToRes = true;
         // $('#skipMatchOne').attr('disabled', false);
         $scope.skipMatchOne = 2;
       }

       if (questions && questions.length > 0) {
         if ($scope.flagSkipAnsweredQuestion) {
           // $scope.cachedQuestions.length = 0;
           $scope.cachedQuestions = angular.copy($scope.questions);
           for (var i = 0; i < questions.length; i++) {

             var idx = $scope.questions.indexOf(questions[i]);
             // console.log("idx : ", idx);
             if (idx > -1) {
               // console.log("idx > ", idx);
               $scope.questions.splice(idx, 1);
             }
           }
           // console.log("questionslength > ", $scope.cachedQuestions.length + "==" + $scope.questions.length)
           MyService.ConsoleLog("cachedQuestions :", $scope.cachedQuestions);
           // $scope.flagSkipAnsweredQuestion = false;
           if ($scope.cachedQuestions.length == questions.length) {
             // console.log("questionslength Equal");
             if ($scope.questions.length == 0) {
               // alert("if");
               // $scope.questions = angular.copy($scope.cachedQuestions);
               // MyService.ConsoleLog(" $rootScope.fiveMatch one :", $scope.questions);
               // var lents = $rootScope.fiveMatch.length;
               // if (lents >= 5) {
               //   // $scope.skipToRes = true;
               //   $('#skipMatch').attr('disabled', false);
               // }

               //MyService.ConsoleLog("* End of background *");
               var message = "Congratulations, you have answered all the questions that your politicians have answered.";

               var modal = ngDialog.openConfirm({
                 template: '<p>' + message + '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(0)">See Match-Ups</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Edit Answers</button>\
                        </div>',
                 plain: true
               });

               modal.then(function fullfilled(data) {
                 //MyService.ConsoleLog("fullfilled: ", data);
                 //  getCompareAnswers({
                 //    "compareQuestionsAll": JSON.stringify($scope.queIds),
                 //    "compareUsersAll": JSON.stringify($scope.compareUsersAll)
                 //  });
                 if (data == 0) {
                   $scope.skipToMatchOne();
                 } else {
                   $scope.flagSkipAnsweredQuestion = false;
                   $scope.skipAnswerChagne();
                 }
               }, function rejected(data) {
                 //MyService.ConsoleLog("rejected: ", data);

               });
               return;


               $scope.status.questions = 2;
             }
             // $scope.saveFiveMinAnswers("skip");
           } else {
             // alert("esle");
             $rootScope.ques = angular.copy(questions);
             // $scope.questions = angular.copy(questions);
             // MyService.ConsoleLog(" questions", $rootScope.ques)
             // var lent = $rootScope.fiveMatch.length;
             // if (lent >= 5) {
             //   // $scope.skipToRes = true;
             //   $('#skipMatch').attr('disabled', false);
             // }
             // $scope.saveFiveMinAnswers("skipNew");

           }
         } else {
           // alert("if else");
           // $scope.flagSkipAnsweredQuestion = true;
           $scope.questions = angular.copy($scope.cachedQuestions);
         }
       } else {
         // alert("last else");

         // if ($scope.flagSkipAnsweredQuestion) {
         // $scope.flagSkipAnsweredQuestion = false;
         if ($scope.cachedQuestions && $scope.cachedQuestions != "") {
           // alert("welcome");
           $scope.questions = angular.copy($scope.cachedQuestions);
           MyService.ConsoleLog(" $scope.questions :", $scope.questions);

         }

       }
     };

     // $scope.skipAnswerChagne = function() {
     //   MyService.ConsoleLog("$scope.flagSkipAnsweredQuestion: ", $scope.flagSkipAnsweredQuestion);
     //   MyService.ConsoleLog(" $scope.category._id ", $scope.category._id);

     //   $scope.currentIndex = 0;
     //   // $scope.initPageData();
     //   getQuestions({
     //     categoryId: $scope.category._id
     //   });
     // };
     $scope.$watch('questions', function (newValue, oldValue) {
       //MyService.ConsoleLog("*** questions changed ***");
       try {
         MyService.ConsoleLog("Current question: >>>", $scope.questions[$scope.currentIndex]);
         var tempCate = $scope.questions[$scope.currentIndex].categories;

         if ($scope.questions[$scope.currentIndex] && $scope.questions[$scope.currentIndex].my_answer) {
           if ($scope.questions[$scope.currentIndex].my_answer.comment) {
             MyService.ConsoleLog("$scope.updata.comment :>>", $scope.questions[$scope.currentIndex].my_answer.comment);
             $scope.updata.comment = $scope.questions[$scope.currentIndex].my_answer.comment;
           }

         }
         if (angular.isArray(tempCate)) {
           // console.log("IF");
           $scope.getCategory({
             id: tempCate[0].cid
           });
         } else {
           // console.log("ELSE IF");
           $scope.getCategory({
             id: tempCate.cid
           });
         }
         //MyService.ConsoleLog($scope.questions.length + "====" + $scope.currentIndex);
         $scope.initMyAnswer();
       } catch (e) {
         //MyService.ConsoleLog("questions Index Change Ex: ", e)
       }
     });
     $scope.$watch('currentIndex', function (newValue, oldValue) {
       //MyService.ConsoleLog("*** currentIndex changed ***");
       try {
         MyService.ConsoleLog("Current question: ", $scope.questions[$scope.currentIndex]);
         var tempCate = $scope.questions[$scope.currentIndex].categories;
         if (angular.isArray(tempCate)) {
           console.log("currentIndex IF");
           $scope.getCategory({
             id: tempCate[0].cid
           });
         } else {
           console.log("currentIndex ELSE IF");
           $scope.getCategory({
             id: tempCate.cid
           });
         }
         //MyService.ConsoleLog($scope.questions.length + "====" + $scope.currentIndex);
         $scope.initMyAnswer();
       } catch (e) {
         //MyService.ConsoleLog("Current Index Change Ex: ", e)
       }
     });
   }])

'use strict';
angular.module('myApp.backup', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/backup', {
      templateUrl: 'app/backup/backup.html',
      controller: 'AdminBackup'
    });
  }]).controller('AdminBackup', ['$scope', '$http', '$location', 'apiCall', '$rootScope', 'baseApiUrl', '$q', '$filter', 'growl', 'ngDialog', 'tokenService', function ($scope, $http, $location, apiCall, $rootScope, baseApiUrl, $q, $filter, growl, ngDialog, tokenService) {
    //MyService.ConsoleLog("* AdminBackup *");
    $scope.statusTakeBackup = 0;
    $scope.statusGetBackup = 0;

    var takeBackupOfDbCanceler = $q.defer();
    $scope.takeBackupOfDb = function () {
      //MyService.ConsoleLog(" takeBackupOfDb ");

      takeBackupOfDbCanceler.resolve();
      $scope.statusTakeBackup = 1;


      var request = apiCall.apiCall('GET', '/admin/database-backup', {
        timeout: takeBackupOfDbCanceler.promise
      });
      $http(
        request
      ).then(function successCallback(response) {
        if (response.data.success) {
          $scope.statusTakeBackup = 2;
        } else if (response.data.error && typeof response.data.error == "string") {
          growl.error('Error: ' + response.data.error);
          $scope.statusTakeBackup = 3;
        } else {
          growl.error('Something went wrong.');
          $scope.statusTakeBackup = 3;
        }
      }, function errorCallBack(response) {
        //MyService.ConsoleLog("Error: ", response);
        $scope.statusTakeBackup = 3;
      });
    };

    var getBackupFilesCanceler = $q.defer();
    $scope.getBackupFiles = function () {
      //MyService.ConsoleLog(" takeBackupOfDb ");

      takeBackupOfDbCanceler.resolve();
      $scope.statusGetBackup = 1;


      var request = apiCall.apiCall('GET', '/admin/backupfile-list', {
        timeout: takeBackupOfDbCanceler.promise
      });
      $http(
        request
      ).then(function successCallback(response) {
        if (response.data.success) {
          $scope.statusGetBackup = 2;
          $scope.backupFiles = response.data.data;
        } else if (response.data.error && typeof response.data.error == "string") {
          growl.error('Error: ' + response.data.error);
          $scope.statusGetBackup = 3;
        } else {
          growl.error('Something went wrong.');
          $scope.statusGetBackup = 3;
        }
      }, function errorCallBack(response) {
        //MyService.ConsoleLog("Error: ", response);
        $scope.statusGetBackup = 3;
      });
    };
    // $scope.getBackupFiles();

    $scope.downloadFile = function (file) {
      //MyService.ConsoleLog(" downloadFile ");
      /*
      var request = apiCall.apiCall('GET', '/admin/download-backup', {file_name: file});
      $http(
          request
      ).then(function successCallback(response) {
          if(response.data.success){
              //download started
          }
          else if(response.data.error && typeof response.data.error == "string"){
              growl.error('Error: '+response.data.error);
          }
          else{
              growl.error('Something went wrong.');
              $scope.statusGetBackup = 3;
          }
      }, function errorCallBack(response) {
          //MyService.ConsoleLog("Error: ",response);
          $scope.statusGetBackup = 3;
      });
      */
      var url = baseApiUrl + "/admin/download-backup?token=" + tokenService.getToken() + "&file_name=" + file;
      window.open(url, '_blank');
    };
  }])
'use strict';
angular
  .module('myApp.answeredQuestions', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/answeredQuestions', {
        templateUrl: 'app/answeredQuestions/answeredQuestions.html',
        controller: 'answeredQuestionsCtrl',
      });
    },
  ])
  .controller('answeredQuestionsCtrl', [
    '$scope',
    '$http',
    '$location',
    'apiCall',
    '$routeParams',
    '$q',
    'ngDialog',
    '$rootScope',
    'growl',
    'MyService',
    '$anchorScroll',
    '$timeout',
    'tokenService',
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $q,
      ngDialog,
      $rootScope,
      growl,
      MyService,
      $anchorScroll,
      $timeout,
      tokenService
    ) {
      //MyService.ConsoleLog("** questionCtrl ** :", $routeParams);
      $rootScope.welcome = false;
      $scope.traverseBackgrounds = [];
      window.localStorage.removeItem('tempQues');

      $scope.currBackgroundIndex = 0;
      // $scope.flagSkipAnsweredQuestion = true;
      // alert("welcome");
      // $('#skipMatchOne').attr('disabled', false);
      // $scope.reason;
      // $scope.comment;
      $scope.skipMatchOne = 1;
      MyService.ConsoleLog(' $scope.skipMatchOne :', $scope.skipMatchOne);

      $scope.status = {
        questions: 0, //1= loading, 2 = loaded, 3 = error
        category: 0,
      };

      $scope.updata = {
        comment: '',
        reason: '',
      };
      if (tokenService.getUserData()) {
        $scope.userData = JSON.parse(tokenService.getUserData());
      }

      /** 
       * 
       * @description Get front runners records from locaStorage if the user role is admin. 
       */
      if (tokenService.getUserRole() == 'admin') {

        $scope.frontRunners = JSON.parse(window.localStorage.getItem('frontRunners'));

        MyService.ConsoleLog("here is the frontRunners", $scope.frontRunners);
      }
      $scope.isUser = {
        selected: ''
      }

      /**
       * @description Function calls when admin select front runner to answer for.
       * @param {*} userId 
       */
      $scope.setUserId = function () {
        MyService.ConsoleLog("$scope.isUser", $scope.isUser.selected);
        $scope.questions = "";
        $scope.getAnsweredQuestions({
          frontRunnerId: $scope.isUser.selected._id
        });
      }


      var flagNw = 0;
      $scope.ansCheck = function (val) {
        // MyService.ConsoleLog("val >>>>>>>>>>>>", val);
        if (flagNw != 0) {
          $scope.chgAns(val);
        }
        flagNw++;
      };

      $scope.currentIndex = 0;
      $scope.initializeVariables = function () {
        // MyService.ConsoleLog("one");
        $scope.importance = null;
        $scope.answer = null;
        $scope.updata.comment = '';
        $scope.reason = '';
      };
      $scope.initializeVariables();

      $scope.initMyAnswer = function () {
        try {

          if ($scope.questions[$scope.currentIndex].my_answer) {
            MyService.ConsoleLog(
              '$scope.questions[$scope.currentIndex].my_answer :',
              $scope.questions[$scope.currentIndex].my_answer.answer
            );
            var user_answer = $scope.questions[$scope.currentIndex].my_answer;
            $scope.importance = user_answer.importance;
            $scope.answer = user_answer.answer;
            MyService.ConsoleLog("$scope.answer", $scope.answer);
            $scope.updata.comment = user_answer.comment;
            $('#agreedisagree-id' + user_answer.answer).prop('checked', true);
            $('#importance-id' + user_answer.importance).prop('checked', true);
            // console.log("$scope.answer > ",$scope.answer);
            // console.log("$scope.importance > ",$scope.importance);
          } else {
            $scope.initializeVariables();
          }
        } catch (e) {
          $scope.initializeVariables();
          //MyService.ConsoleLog("Exceptoin: ", e)
        }
      };

      var getQuestionsCanceler = $q.defer();
      /*
     function getQuestions(params) {
       getQuestionsCanceler.resolve();
       $scope.status.questions = 1;
       params.timeout = getQuestionsCanceler.promise;
       MyService.ConsoleLog("questionAnsByCtrl** /questions/list: ", params);
       $scope.questions = [];
       var request = apiCall.apiCall('GET', '/questions/list', params);
       $http(
         request
       ).then(function successCallback(response) {
         //MyService.ConsoleLog("questionAnsByCtrl Got categories: ", response);
         if (response.data.success) {
           $scope.status.questions = 2;
           $scope.questions = response.data.data;
           //MyService.ConsoleLog("total questions: ", $scope.questions);
         } else {
           $scope.status.questions = 3;
           if (typeof response.data.error == "string")
             growl.error(response.data.error);
           else {
             // growl.error("Something went wrong");
           }
         }
       }, function errorCallBack(response) {
         $scope.status.questions = 3;
         //MyService.ConsoleLog("Error: ", response);
       });
     }

     */
      $scope.getUserProfile = function () {
        MyService.getProfile($routeParams.user_id).then(
          function (userData) {
            $scope.userData = userData;
            MyService.ConsoleLog('userData: ', $scope.userData);
          },
          function (err) {
            growl.error('Something went wrong while fetching user info.');
          }
        );
      };

      var getCategoryCanceler = $q.defer();
      var prevFetchedCategoryId = null;
      $scope.categoryCalled = false;
      $scope.getCategory = function (params) {
        if (prevFetchedCategoryId != params.id) {
          //MyService.ConsoleLog("scrollTop");
          $scope.categoryCalled = true;
          $('html, body').animate({
              scrollTop: 0,
            },
            'slow'
          );

          getCategoryCanceler.resolve();
          $scope.status.category = 1;
          params.timeout = getCategoryCanceler.promise;
          var request = apiCall.apiCall('GET', '/categories/list', params);
          $http(request).then(
            function successCallback(response) {
              //MyService.ConsoleLog("Got categories: ",response);
              if (response.data.success) {
                $scope.category = response.data.data;
                //MyService.ConsoleLog("category data: ", $scope.category);
                prevFetchedCategoryId = $scope.category._id;
                $scope.status.category = 2;
              } else {
                //MyService.ConsoleLog("Something went wrong: ", response.data);
                $scope.status.category = 3;
              }
            },
            function errorCallBack(response) {
              //MyService.ConsoleLog("Error: ", response);
              $scope.status.category = 3;
            }
          );
        } else {
          $('html, body').animate({
              scrollTop: $('#DisplayQue').offset().top - 100,
            },
            'slow'
          );

          /*
          $timeout(function() {
            MyService.ConsoleLog("called")
            $location.hash('DisplayQue');
            $anchorScroll();
          }, 100);
         */
        }
      };

      $scope.postAnswer = function (postData) {
        MyService.ConsoleLog('postData: ', postData);
        try {
          var my_answer = $scope.questions[$scope.currentIndex].my_answer;
          if (
            my_answer.importance != $scope.importance ||
            my_answer.answer != $scope.answer ||
            my_answer.comment != $scope.updata.comment
          ) {
            //MyService.ConsoleLog("Answer changed");
            // alert($scope.answer);
            postData.id = my_answer._id;
            postData.reason = $scope.updata.reason;
          } else {
            //MyService.ConsoleLog("Answer not changed");
            return; //don't do anything
          }
        } catch (e) {
          //MyService.ConsoleLog("Exceptoin: ", e);
        }
        //MyService.ConsoleLog(postData);
        MyService.ConsoleLog('postData Second: ', postData);

        MyService.postAnswer(postData).then(
          function (response) {
            document.getElementById('txtReason').value = '';
            // console.log("Result >", response.data);
            if (response.data.success) {
              try {
                if (postData.id) {
                  console.log('postData.id > ', postData);
                  $scope.questions[$scope.currentIndex]['my_answer'] = {
                    _id: postData.id,
                    created: new Date(),
                    comment: postData.comment,
                    answer: postData.answer,
                    importance: postData.importance,
                    question: postData.questionId,
                  };
                } else {
                  console.log('postData.id Else  > ', postData);
                  console.log('postData.id Else Data  > ', response.data.data);
                  $scope.questions[$scope.currentIndex]['my_answer'] = {
                    _id: response.data.data._id,
                    created: response.data.data.created,
                    comment: response.data.data.comment,
                    answer: response.data.data.answer,
                    importance: response.data.data.importance,
                  };
                }
              } catch (e) {
                //MyService.ConsoleLog("Exceptoin: ", e);
              }
              if (postData.id) {
                growl.success('Answer updated successfully', {
                  ttl: 800,
                });
              } else {
                growl.success('Answered successfully', {
                  ttl: 800,
                });
              }
              console.log('My ANs : ', $scope.questions[$scope.currentIndex].my_answer);
              $scope.initializeVariables();
              $scope.skipQuestions();
            } else {
              growl.error('Error: ' + response.data.error);
            }
          },
          function (err) {
            // growl.error("Something went wrong.");
          }
        );
      };

      $scope.chgAns = function (val) {
        console.log("$scope.answer val", val);
        $scope.answer = val;

        // $scope.checkIfExists(val);
      };
      $scope.chgImp = function (val) {
        $scope.importance = val;
        // $scope.checkImpExists(val);
      };

      $scope.submitAnswer = function () {
        // console.log($scope);
        MyService.ConsoleLog('submitAnswer: ' + $scope.answer);
        MyService.ConsoleLog('importance: ' + $scope.importance);
        MyService.ConsoleLog('comments: ', $scope.updata.comment);
        MyService.ConsoleLog('$scope.comments: ', $scope.comment);
        MyService.ConsoleLog('reason: ', $scope.updata.reason);

        var token = apiCall.getToken();

        if (!token || token == '') {
          var message = 'Please login first.';

          var modal = ngDialog.openConfirm({
            template: '<p>' +
              message +
              '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
            plain: true,
          });
          modal.then(
            function fullfilled(data) {
              //MyService.ConsoleLog("fullfilled: ", data);
            },
            function rejected(data) {
              //MyService.ConsoleLog("rejected: ", data);
            }
          );
          return;
        }

        if ($scope.answer == null) {
          var message = 'Please select answer first.';
          var modal = ngDialog.openConfirm({
            template: '<p>' +
              message +
              '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
            plain: true,
          });

          modal.then(
            function fullfilled(data) {
              //MyService.ConsoleLog("fullfilled: ", data);
            },
            function rejected(data) {
              //MyService.ConsoleLog("rejected: ", data);
            }
          );

          return;
        }

        if ($scope.importance == null) {
          var message =
            'You gave your opinion, but you didn’t say how important this is to you.  Should they fight hard for this or can they use it as a bargaining chip to get other things you care about more?';

          var modal = ngDialog.openConfirm({
            template: '<p>' +
              message +
              '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                        </div>',
            plain: true,
          });

          modal.then(
            function fullfilled(data) {
              //MyService.ConsoleLog("fullfilled: ", data);
            },
            function rejected(data) {
              //MyService.ConsoleLog("rejected: ", data);
            }
          );
          return;
        }
        var postData;
        if (tokenService && tokenService.getUserRole() == 'admin' && $scope.isUser && $scope.isUser.selected && $scope.isUser.selected != '') {
          postData = {
            questionId: $scope.questions[$scope.currentIndex]._id,
            importance: $scope.importance,
            answer: $scope.answer,
            comment: $scope.updata.comment,
            reason: $scope.updata.reason,
            token: token,
            frontRunnerId: $scope.isUser.selected._id
          };
        } else {
          postData = {
            questionId: $scope.questions[$scope.currentIndex]._id,
            importance: $scope.importance,
            answer: $scope.answer,
            comment: $scope.updata.comment,
            reason: $scope.updata.reason,
            token: token,
          };
        }


        // MyService.ConsoleLog(postData);
        $scope.postAnswer(postData);
      };

      // $scope.comment;
      //   MyService.ConsoleLog("  $scope.comment :", $scope.comment);

      $scope.skipQuestions = function () {
        MyService.ConsoleLog(' questionssssssssssssssssssss called');
        $scope.answer = null;
        // $scope.categoryCalled = false;
        MyService.ConsoleLog(' $rootScope.queOneLen ', $rootScope.queOneLen);
        var skip = function () {
          var tempIndex = $scope.currentIndex + 1;
          MyService.ConsoleLog(' length of questions :', tempIndex);
          if (tempIndex < $scope.questions.length) {
            $scope.initializeVariables();
            $scope.currentIndex++;
            if ($routeParams.categoryId && $routeParams.categoryId.indexOf('popular:') == 0) {
              //we are showing questions of most popular section
              MyService.ConsoleLog('welcome to if');
              $scope.getCategory({
                id: $scope.questions[$scope.currentIndex].categories.cid,
              });
            }
          }
          if (tempIndex >= 5) {
            // $scope.skipToRes = true;
            // $('#skipMatchOne').attr('disabled', false);
            $scope.skipMatchOne = 2;
          }
          MyService.ConsoleLog(
            'tempIndex = ',
            tempIndex,
            '$scope.questions.length ',
            $scope.questions.length
          );
          if (tempIndex == $scope.questions.length) {
            //MyService.ConsoleLog("end of questions switch background");
            var tempBackIdx = $scope.currBackgroundIndex + 1;
            if (tempBackIdx < $scope.traverseBackgrounds.length) {
              $scope.currBackgroundIndex++;
              $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
              MyService.ConsoleLog(' category  id   : ', $scope.category);
            } else {
              //MyService.ConsoleLog("* End of background *");
              var message =
                'End of Questions';
              var modal = ngDialog.openConfirm({
                template: '<p>' +
                  message +
                  '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">OK</button>\
                        </div>',
                plain: true,
              });
              modal.then(
                function fullfilled(data) {
                  MyService.ConsoleLog('fullfilled: ', data);
                  // getCompareAnswers({
                  //   "compareQuestionsAll": JSON.stringify($scope.queIds),
                  //   "compareUsersAll": JSON.stringify($scope.compareUsersAll)
                  // });
                },
                function rejected(data) {
                  //MyService.ConsoleLog("rejected: ", data);
                }
              );
              return;
            }
          }
        };
        skip();
      };

      $scope.prevQuestion = function () {
        //MyService.ConsoleLog("** prevQuestion **");
        // $timeout(function() {
        //   $location.hash('DisplayQ');
        //   $anchorScroll();
        // }, 1500);
        if ($scope.currentIndex > 0) {
          $scope.currentIndex--;
          // $scope.skipQuestions();
        } else if ($scope.currentIndex == 0) {
          if ($scope.currBackgroundIndex > 0) {
            $scope.currBackgroundIndex--;
            $scope.category = $scope.traverseBackgrounds[$scope.currBackgroundIndex];
          }
        }
      };

      var getCompareAnswersCanceler = $q.defer();
      var current_url = $location.url();
      //MyService.ConsoleLog("$location.url: ", current_url);
      $scope.state = 'question-not-answered';
      $scope.status.questions = 1;
      $scope.compareQuestionsAll = [];

      $scope.getAnsweredQuestions = function (params) {
        // alert("called");
        MyService.getAnsweredQuestions(params).then(
          function (result) {
            MyService.ConsoleLog('result', result);
            MyService.ConsoleLog('matchQuestionwithPolitician :', result.data.data);
            if (result && result.data.data) {
              window.localStorage.setItem('tempQues', JSON.stringify(result.data.data));
              $scope.questions = result.data.data;

              $rootScope.ques = result.data.data;
            }
            if (result.data.error) {
              $scope.questions = JSON.parse(window.localStorage.getItem('tempQues'));
              $scope.ques.searchQuestionKeyword = '';
              growl.error(result.data.error);
            }
            $scope.questions.sort(function (a, b) {
              var x, y;
              x = a.categories[0].viewOrder;
              y = b.categories[0].viewOrder;
              if (x < y) {
                return -1;
              }
              if (x > y) {
                return 1;
              }
              return 0;
            });
            // MyService.ConsoleLog("dhADGDAD :",result.data.success);
            //MyService.ConsoleLog(payload.data.data.error);
            // $scope.flagSkipAnsweredQuestion = true;

            if ($scope.questions && $scope.questions.length > 0) {
              $scope.queIds = $scope.questions.map(function (obj) {
                if (obj != '' && obj != ' ') {
                  return obj._id;
                }
              });
            }

            // $rootScope.selectedCompareUsers=$scope.queIds;
            MyService.ConsoleLog('question ids :', $scope.queIds);
            // $scope.flagSkipAnsweredQuestion = true;
            // $scope.skipAnswerChagne();
          },
          function (err) {
            growl.error('Something went wrong');
          }
        );
      };

      $scope.getAnsweredQuestions();

      $scope.searchQuestion = function (searchKey) {
        $scope.getAnsweredQuestions({
          keyword: searchKey
        });
      };

      $scope.newSub = function (valOne) {
        $scope.importance = valOne;
        $scope.submitAnswer();
      };

      $scope.checkImpExists = function (val) {
        if ($scope.questions) {
          var obj = $scope.questions[$scope.currentIndex];
          // MyService.ConsoleLog("object :", obj);

          if (obj) {
            var data = $scope.checkQuestion(obj._id);

            if (data && data[0]) {
              // MyService.ConsoleLog("checkIfExists data>> ", data[0].importance + "==" + val);
              if (data[0].my_answer.importance == val) {
                return true;
              }
            }
          }
        }
        return false;
      };

      $scope.checkIfExists = function (val) {
        // MyService.ConsoleLog("click");
        if ($scope.questions) {
          var obj = $scope.questions[$scope.currentIndex];
          // MyService.ConsoleLog("checking For calling >> ");
          if (obj) {
            var data = obj.my_answer;
            // console.log("data <>", data);
            if (data) {
              if (data.answer == val) {
                // MyService.ConsoleLog("checkIfExists data>> ", data.answer + "==" + val);
                return true;
              }
            }
          }
        }
        return false;
      };

      $scope.checkQuestionAnswered = function () {
        // alert("called");
        // console.log("scope.questions > ", $scope.questions);
        return $scope.questions.filter(function (rdata) {
          // MyService.ConsoleLog(" questions Ids", rdata._id);
          var data = $scope.checkQuestion(rdata._id);
          if (data && data.length > 0) {
            return rdata;
          }
        });
      };

      $scope.checkQuestion = function (val) {
        // MyService.ConsoleLog("value ", val);
        var queLen = $scope.questions.length;
        // alert(queLen);
        // MyService.ConsoleLog("quelen :",queLen);
        for (var i = 0; i < queLen; i++) {
          if ($scope.questions[i].my_answer && $scope.questions[i].my_answer != '') {
            return $scope.questions.filter(function (rdata) {
              // MyService.ConsoleLog(" ANs data :", rdata);

              if (rdata.my_answer) {
                // MyService.ConsoleLog(" ANs data :", rdata.myAnswers.question);
                if (rdata.my_answer.question == val) {
                  return rdata;
                }
              }
            });
          }
        }
      };

      $scope.flagSkipAnsweredQuestion = false;
      $scope.cachedQuestions = [];
      $rootScope.queOneLen = [];
      // $rootScope.queOneLen.length=0;

      $scope.skipAnswerChagne = function () {
        MyService.ConsoleLog('scope.flagSkipAnsweredQuestion: ', $scope.flagSkipAnsweredQuestion);
        $scope.currentIndex = 0;
        var questions = $scope.checkQuestionAnswered();
        // $rootScope.fiveMatch.length = 0;
        MyService.ConsoleLog('questions >$$$ ', questions);
        MyService.ConsoleLog('questions  length ', questions.length);
        $rootScope.queOneLen = questions;
        MyService.ConsoleLog(' $rootScope.queOneLen ', $rootScope.queOneLen);

        if (questions.length >= 5) {
          // $scope.skipToRes = true;
          // $('#skipMatchOne').attr('disabled', false);
          $scope.skipMatchOne = 2;
        }

        if (questions && questions.length > 0) {
          if ($scope.flagSkipAnsweredQuestion) {
            // $scope.cachedQuestions.length = 0;
            $scope.cachedQuestions = angular.copy($scope.questions);
            for (var i = 0; i < questions.length; i++) {
              var idx = $scope.questions.indexOf(questions[i]);
              // console.log("idx : ", idx);
              if (idx > -1) {
                // console.log("idx > ", idx);
                $scope.questions.splice(idx, 1);
              }
            }
            // console.log("questionslength > ", $scope.cachedQuestions.length + "==" + $scope.questions.length)
            MyService.ConsoleLog('cachedQuestions :', $scope.cachedQuestions);
            if ($scope.cachedQuestions.length == questions.length) {
              // console.log("questionslength Equal");
              if ($scope.questions.length == 0) {
                // alert("if");
                // $scope.questions = angular.copy($scope.cachedQuestions);
                // MyService.ConsoleLog(" $rootScope.fiveMatch one :", $scope.questions);
                // var lents = $rootScope.fiveMatch.length;
                // if (lents >= 5) {
                //   // $scope.skipToRes = true;
                //   $('#skipMatch').attr('disabled', false);
                // }

                //MyService.ConsoleLog("* End of background *");
                var message =
                  'End of Questions';

                var modal = ngDialog.openConfirm({
                  template: '<p>' +
                    message +
                    '</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="confirm(0)">OK</button>\
                        </div>',
                  plain: true,
                });

                modal.then(
                  function fullfilled(data) {
                    MyService.ConsoleLog('fullfilled: ', data);
                    // getCompareAnswers({
                    //   "compareQuestionsAll": JSON.stringify($scope.queIds),
                    //   "compareUsersAll": JSON.stringify($scope.compareUsersAll)
                    // });
                  },
                  function rejected(data) {
                    //MyService.ConsoleLog("rejected: ", data);
                  }
                );
                return;

                $scope.status.questions = 2;
              }
              // $scope.saveFiveMinAnswers("skip");
            } else {
              // alert("esle");
              $rootScope.ques = angular.copy(questions);
              // $scope.questions = angular.copy(questions);
              // MyService.ConsoleLog(" questions", $rootScope.ques)
              // var lent = $rootScope.fiveMatch.length;
              // if (lent >= 5) {
              //   // $scope.skipToRes = true;
              //   $('#skipMatch').attr('disabled', false);
              // }
              // $scope.saveFiveMinAnswers("skipNew");
            }
          } else {
            // alert("if else");

            $scope.questions = angular.copy($scope.cachedQuestions);
          }
        } else {
          // alert("last else");

          if ($scope.flagSkipAnsweredQuestion) {
            if ($scope.cachedQuestions && $scope.cachedQuestions != '') {
              // alert("welcome");
              $scope.questions = angular.copy($scope.cachedQuestions);
              MyService.ConsoleLog(' $scope.questions :', $scope.questions);
            }
          }
        }
      };

      // $scope.skipAnswerChagne = function() {
      //   MyService.ConsoleLog("$scope.flagSkipAnsweredQuestion: ", $scope.flagSkipAnsweredQuestion);
      //   MyService.ConsoleLog(" $scope.category._id ", $scope.category._id);

      //   $scope.currentIndex = 0;
      //   // $scope.initPageData();
      //   getQuestions({
      //     categoryId: $scope.category._id
      //   });
      // };
      $scope.$watch('questions', function (newValue, oldValue) {
        MyService.ConsoleLog('*** questions changed ***');
        try {
          MyService.ConsoleLog('Current question: ', $scope.questions[$scope.currentIndex]);
          var tempCate = $scope.questions[$scope.currentIndex].categories;

          if (angular.isArray(tempCate)) {
            // console.log("IF");
            $scope.getCategory({
              id: tempCate[0].cid,
            });
          } else {
            // console.log("ELSE IF");
            $scope.getCategory({
              id: tempCate.cid,
            });
          }
          //MyService.ConsoleLog($scope.questions.length + "====" + $scope.currentIndex);
          $scope.initMyAnswer();
        } catch (e) {
          //MyService.ConsoleLog("questions Index Change Ex: ", e)
        }
      });
      $scope.$watch('currentIndex', function (newValue, oldValue) {
        MyService.ConsoleLog('*** currentIndex changed ***');
        try {
          //MyService.ConsoleLog("Current question: ", $scope.questions[$scope.currentIndex]);
          var tempCate = $scope.questions[$scope.currentIndex].categories;
          if (angular.isArray(tempCate)) {
            console.log('currentIndex IF');
            $scope.getCategory({
              id: tempCate[0].cid,
            });
          } else {
            console.log('currentIndex ELSE IF');
            $scope.getCategory({
              id: tempCate.cid,
            });
          }
          MyService.ConsoleLog($scope.questions.length + '====' + $scope.currentIndex);
          $scope.initMyAnswer();
        } catch (e) {
          //MyService.ConsoleLog("Current Index Change Ex: ", e)
        }
      });
    },
  ]);

'use strict';
angular.module('myApp.allUsers', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/allUsers', {
      templateUrl: 'app/allUsers/allUsers.html',
      controller: 'AllUsersCtrl'
    });
  }])
  .controller('AllUsersCtrl', ['$scope', '$location', '$rootScope', 'tokenService', 'MyService', 'ngDialog', 'growl', '$filter', '$q', '$window', function ($scope, $location, $rootScope, tokenService, MyService, ngDialog, growl, $filter, $q, $window) {
    //MyService.ConsoleLog("* Following *");
    $scope.loginUser = tokenService.getUserId();
    $scope.allData = JSON.parse(tokenService.getUserData());
    $scope.fData = $scope.allData.followlist;
    $scope.UserFormDiv = false;
    $scope.newuser = {
      type: "forumadmin",
      name: '',
      email: '',
      username: '',
      password: '',
    };
    $scope.page = 1;

    $scope.sel = {
      state: ''
    };

    $scope.initVar = function () {
      $scope.userTypes = ["forumadmin", "voteradmin", "dataentryadmin"];
      $scope.users = {
        data: []
      };

      $scope.totalUsers = 0;
      $scope.usersPerPage = 25; // this should match however many results your API puts on one page

      $scope.pagination = {
        current: 1
      };
    };
    $scope.initVar();

    $scope.pageChanged = function (newPage) {
      $scope.getResultsPage(newPage);
    };

    $scope.notifyUser = 0;
    $scope.notifyUsersTheirPasswords = function () {
      var tempArr = [];
      angular.forEach($scope.users.data, function (val, key) {
        if (val.isSelected) {
          tempArr.push(val._id);
        }
      });

      var postparam = {
        "user_ids": tempArr.join(",")
      };
      MyService.notifyUsersPasswords(postparam, null).then(function (response) {
        if (response.data.success) {
          $scope.notifyUser = 2;
          growl.success('Send successfully.');
        } else if (response.data.error && typeof response.data.error == "string") {
          growl.error('Error: ' + response.data.error);
          $scope.notifyUser = 3;
        } else {
          growl.error('Something went wrong.');
          $scope.notifyUser = 3;
        }
      }, function (err) {
        growl.error("Something went wrong.");
      });
      //MyService.ConsoleLog("tempArr: ", tempArr);
    };

    $scope.selectAll = function () {
      angular.forEach($scope.users.data, function (val, key) {
        val.isSelected = true;
      });
    };

    // generate Password
    $scope.pass = "";

    // $scope.pass[] = false;
    $scope.generatePassword = function (sdata) {
      $rootScope.Id = sdata._id;
      MyService.ConsoleLog("id", sdata._id);
      MyService.ConsoleLog("data", sdata.userStatus);

      $scope.password = Math.random().toString(36).slice(-6);
      $scope.User.password = $scope.password;
      MyService.ConsoleLog("password :", $scope.password);
      if (sdata.userStatus == "Blocked") {
        var message = "Do you want to also change your email address and username";
        var modal = ngDialog.openConfirm({
          template: '<p>' + message + '</p>\
                <div class="ngdialog-buttons">\
                    <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Cancel</button>\
                    <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Yes</button>\
                </div>',
          plain: true,
          closeByDocument: false
        });
        modal.then(function fullfilled(data) {
          MyService.ConsoleLog("fullfilled: ", data);
          $scope.addressPopup = ngDialog.open({
            template: 'addressPopUp',
            closeByNavigation: true,
            scope: $scope
          });
        }, function rejected(data) {
          MyService.ConsoleLog("rejected: ", data);
          MyService.UpdatePassword({
            id: sdata._id,
            password: $scope.password,
            flag: false
          }).then(function (response) {
            // console.log(response);
            $scope.pass = sdata._id;
          });
        });
      } else {
        MyService.UpdatePassword({
          id: sdata._id,
          password: $scope.password,
          flag: false
        }).then(function (response) {
          // console.log(response);
          $scope.pass = sdata._id;
        });
      }
    };

    $scope.User = {
      email: "",
      username: "",
      password: ""
    };

    $scope.updateCredentials = function (udata) {
      MyService.ConsoleLog("udata", udata);
      MyService.ConsoleLog(" $rootScope.Id", $rootScope.Id);
      MyService.ConsoleLog("$scope.password", $scope.password);

      MyService.UpdatePassword({
        id: $rootScope.Id,
        password: $scope.User.password,
        email: $scope.User.email,
        username: $scope.User.username,
        flag: true
      }).then(function (response) {
        // console.log(response);
        if (response.data.success) {
          $scope.addressPopup.close();
          $rootScope.Id = "";
          MyService.ConsoleLog("resonse new", response.data.data);
          growl.success("Updated Successfully");
        } else {
          growl.error(response.data.error);
        }
        MyService.ConsoleLog("response", response);
        $scope.pass = udata._id;
      }, function (err) {
        growl.error(err);
      });
    };



    // Select location startsAllUsersCtrl

    $scope.selectedCat = [];
    $scope.SelectedTree = [];
    $scope.disabled = [];
    $scope.Allcountries = [];
    $scope.SelectedCountry = '';
    $scope.newlocation = {
      country: ''
    };
    $scope.profile = {
      orgData: {}
    }
    $scope.subtopics = {
      subcategories: []
    };

    $scope.Essay = {
      location: '',
      subcategories: []
    };


    $scope.selectedCat = [];
    $scope.SelectedTree = [];
    $scope.disabled = [];
    $scope.Allcountries = [];
    $scope.SelectedCountry = '';
    $scope.newlocation = {
      country: ''
    };
    $scope.profile = {
      orgData: {}
    }
    $scope.subtopics = {
      subcategories: []
    };

    $scope.Essay = {
      location: '',
      subcategories: []
    };

    $scope.ShowAddLocation = function () {
      if (!$scope.AddLocation) {
        $scope.AddLocation = true;
      } else {
        $scope.AddLocation = false;
      }

    }


    function suggest_country(term) {
      var q = term.toLowerCase().trim();
      var results = [];
      var len = $scope.Allcountries.length;
      // Find first 10 states that start with `term`.
      for (var i = 0; i < len && results.length < 10; i++) {
        var country = $scope.Allcountries[i];
        if (country.toLowerCase().indexOf(q) === 0)
          results.push({
            label: country,
            value: country
          });
      }
      return results;
    }

    $scope.autocomplete_options = {
      suggest: suggest_country
    };


    $scope.getAllStates = function () {
      MyService.getAllStates().then(function (payload) {
          $scope.allLocations.length = 0;
          var subcatdata = payload;
          //MyService.ConsoleLog("Sub states : ", subcatdata);
          $scope.allLocations = subcatdata;
          //MyService.ConsoleLog($scope.profile.address);
          //MyService.ConsoleLog($scope.profile.address.state);
          if (($scope.profile.address) && ($scope.profile.address.state)) {
            var chkdata = $scope.checkExists(subcatdata, $scope.profile.address.state);
            //MyService.ConsoleLog("State check item :", chkdata[0]);
            if (chkdata != "") {
              chkdata[0].country = "United States of America";
              //MyService.ConsoleLog(JSON.stringify(chkdata[0]));
              $scope.profile.state = JSON.stringify(angular.copy(chkdata[0]));
            }
          }
        },
        function (errorPayload) {
          growl.error('Something went wrong.');
        });
    }



    $scope.getVal = function (data) {
      //MyService.ConsoleLog(data);
      var idx = $scope.selectedCat.indexOf(data);
      if (idx > -1) {
        $scope.selectedCat.splice(idx, 1);
        var id = $scope.disabled.indexOf(data._id);
        $scope.disabled.splice(id, 1);
        var jdx = $scope.SelectedTree.indexOf(data.parentIds);
        if (jdx > -1)
          $scope.SelectedTree.splice(jdx, 1);

      } else {
        $scope.selectedCat.push(data);
        var id = $scope.disabled.indexOf(data._id);
        if (id == -1) {
          $scope.disabled.push(data._id);

        }
        //MyService.ConsoleLog(data.parentIds);
        //MyService.ConsoleLog("SelectedTree: ", $scope.SelectedTree);
        if ($scope.SelectedTree.length == 0) {
          if (data.parentIds.length > 0) {
            //var parents = Object.keys(data.parentIds).map(function (key) {return data.parentIds[key]});
            //angular.copy(data.parentIds, $scope.SelectedTree);
            var parents = data.parentIds;
            //MyService.ConsoleLog(parents);
            $scope.SelectedTree = parents;
          }
        } else {
          if (data.parentIds.length > 0) {
            //var parents = Object.keys(data.parentIds).map(function (key) {return data.parentIds[key]});
            //var parents = angular.copy(data.parentIds);
            var parents = data.parentIds;
            var plen = parents.length;
            for (var j = 0; j < plen; j++) {
              $scope.SelectedTree.push(parents[j]);
            }
          }
        }
      }
      //MyService.ConsoleLog($scope.SelectedTree);
    }


    $scope.selectedAll = {
      id: []
    };
    $scope.removeVal = function (data) {
      //MyService.ConsoleLog("EntrieData<><", data);
      var idx = $scope.selectedCat.indexOf(data);
      if (idx > -1) {
        $scope.selectedCat.splice(idx, 1);
        //MyService.ConsoleLog("removeDataId:", data._id);
        //MyService.ConsoleLog("Before:::", $scope.disabled);
        var vid = $scope.disabled.indexOf(data._id);
        //MyService.ConsoleLog("removeId:", vid);


        $scope.disabled.splice(vid, 1);
        //MyService.ConsoleLog("After:::", $scope.disabled);

        var parents = data.parentIds;
        var plen = parents.length;
        for (var j = 0; j < plen; j++) {
          var jdx = $scope.SelectedTree.indexOf(parents[j]);
          if (jdx > -1)
            $scope.SelectedTree.splice(jdx, 1);
        }
      }
      $scope.selectedAll.id.length = 0;
      //MyService.ConsoleLog($scope.SelectedTree);
      var allLen = $scope.SelectedTree.length;
      var chkboxe = document.getElementsByName("checkedidcat");
      for (var i = 0; i < allLen; i++) {
        chkboxe[i].checked = true;

      }
    }

    $scope.selectConfig = {
      requiredMin: 1,
      selectAll: true
    };

    $scope.checksubCatExists = function (rdata, val) {
      return rdata.filter(
        function (rdata) {
          if (rdata._id == val)
            return rdata
          else if (rdata.subCategories) {
            $scope.checksubCatExists(rdata.subcategories, val)
          }
        }
      );
    }

    $scope.checkCatExists = function (rdata, val) {
      return rdata.filter(
        function (rdata) {
          if (rdata._id == val) {
            $scope.selectedCat.push(rdata);
            return rdata
          } else if (rdata.subcategories) {
            $scope.checkCatExists(rdata.subcategories, val)
          }
        }
      );
    }
    $scope.SaveButton = true;
    $scope.getSubcatTree = function () {
      $scope.selectedCat.length = 0;
      $scope.SaveButton = true;

      MyService.getAllCatTree({
        "type": ""
      }).then(function (payload) {
          $scope.subtopics.subcategories.length = 0;
          var subcatdata = payload;
          //MyService.ConsoleLog("subcatdata : ", subcatdata);
          $scope.subtopics.subcategories = subcatdata;
          var selectedCat = $scope.disabled;
          if (selectedCat && selectedCat.length > 0) {
            for (var s = 0; s < selectedCat.length; s++) {
              var checkcatdata = $scope.checkCatExists(subcatdata, selectedCat[s]);
            }
            //MyService.ConsoleLog($scope.selectedCat);
          }
          $scope.SaveButton = false;
          setTimeout(function () {
            var cols = document.getElementsByClassName('cmnUL');
            var clen = cols.length;
            for (var i = 0; i < clen; i++) {
              cols[i].style.display = "none";
            }
          }, 300);
        },
        function (errorPayload) {
          console.log('errorPayload :>> ', errorPayload);
          // growl.error('Something went wrong.');
        });
    }


    $scope.selectedAll = {
      id: []
    };

    $scope.selectConfig = {
      requiredMin: 1,
      selectAll: true
    };

    $scope.allLocations = [];
    $scope.allCounties = [];
    $scope.selectedArea = [];
    $scope.rmselectedArea = [];
    $scope.myselectionarea = [];
    $scope.disabledLocation = [];

    $scope.checkExists = function (rdata, val) {
      return rdata.filter(
        function (rdata) {
          if (rdata.state == val)
            return rdata
        }
      );
    }

    $scope.checkCountyExists = function (rdata, val) {
      return rdata.filter(
        function (rdata) {
          if (rdata._id.county == val)
            return rdata._id
        }
      );
    }

    $scope.checkCountryExists = function (rdata, val) {
      return rdata.filter(
        function (rdata) {
          if (rdata.country == val)
            return rdata
        }
      );
    }

    $scope.checkLocalExists = function (rdata, val, val1) {
      return rdata.filter(
        function (rdata) {
          if ((rdata._id.place == val) && (rdata._id.countySubdivision == val1))
            return rdata._id
        }
      );
    }

    function areEqual() {
      var len = arguments.length;
      for (var i = 1; i < len; i++) {
        if (arguments[i] == null || arguments[i] != arguments[i - 1])
          return false;
      }
      return true;
    }

    function indexOfExt(list, item) {
      var len = list.length;

      for (var i = 0; i < len; i++) {
        var keys = Object.keys(list[i]);
        var flg = true;
        var arr = [];


        for (var j = 0, s = 1; j < keys.length; j++, s++) {
          var value = list[i][keys[j]];
          if (item[keys[j]] !== value) {
            flg = false;

          }

          if (item[keys[j]] == value) {
            arr.push(flg);
          }


        }
        if (flg == true) {
          if (areEqual(arr.length, keys.length, Object.keys(item).length)) {
            return i;
          }
        }


      }
      return -1;
    }

    $scope.checkDisabled = function (data, stateId, type) {
      data.country = "United States of America";
      data.state = stateId;
      var idx = indexOfExt($scope.disabledLocation, data);
      if (idx > -1)
        return true;
      else
        return false;
    }

    $scope.getAreaVal = function (data, stateId, type) {

      if (!data.country) {
        data.country = "United States of America";
      }
      if (!data.state) {
        data.state = stateId;
      }



      var idx = indexOfExt($scope.selectedArea, data);


      if (idx > -1) {
        growl.error("You have already selected the location");
      } else {

        $scope.selectedArea.push(data);
        $scope.disabledLocation.push(data);

      }
      //MyService.ConsoleLog($scope.selectedArea);
      //MyService.ConsoleLog($scope.disabledLocation);
    }
    $scope.selectedLAll = {
      id: []
    };
    $scope.removeAreaVal = function (data) {
      var idx = $scope.selectedArea.indexOf(data);
      //MyService.ConsoleLog(data);
      //MyService.ConsoleLog($scope.selectedArea);
      //MyService.ConsoleLog(idx);
      //MyService.ConsoleLog($scope.Essay.Locations);
      if (idx > -1) {
        //MyService.ConsoleLog("Country:",$scope.selectedArea[idx].country);
        if ($scope.selectedArea[idx].country == "International") {
          $scope.Essay.Locations = 'NO';
        }
        if ($scope.selectedArea[idx].country == "National (USA)") {
          $scope.Essay.National = 'NO';
        }
        $scope.selectedArea.splice(idx, 1);
        $scope.disabledLocation.splice(idx, 1);

      }
      //MyService.ConsoleLog($scope.disabledLocation);
      // var jdx = $scope.disabledLocation.indexOf(data);
      //MyService.ConsoleLog(jdx);
      //   if (jdx > -1) {
      //     $scope.disabledLocation.splice(jdx, 1);
      //   }
      $scope.selectedLAll.id.length = 0;
      //MyService.ConsoleLog($scope.selectedArea);
      var allLen = $scope.SelectedTree.length;
      var chkboxe = document.getElementsByName("checkedid");
      for (var i = 0; i < allLen; i++) {
        chkboxe[i].checked = true;

      }

    }
    $scope.allCounties = [];
    $scope.allLocals = [];
    $scope.setLocation = function (option) {
      $scope.Essay.location = option;
    }
    $scope.getLocations = function (val, type) {
      if (type == "National") {
        if (val == "National") {
          var nobj = {
            country: "National (USA)"
          }
          $scope.selectedArea.push(nobj);
          //MyService.ConsoleLog($scope.selectedArea);
        }
        if (val == "NO") {
          var nobj = {
            country: "National (USA)"
          }
          var idx = indexOfExt($scope.selectedArea, nobj);
          if (idx > -1) {
            $scope.selectedArea.splice(idx, 1);
          }
        }
      } else if (type == "International") {

        if (val == "International") {
          // $scope.selectedArea.length = 0;
          var nobj = {
            country: "International"
          }
          $scope.selectedArea.push(nobj);
        }

        if (val == "NO") {
          // $scope.selectedArea.length = 0;
          var nobj = {
            country: "International"
          }

          var idx = indexOfExt($scope.selectedArea, nobj);
          if (idx > -1) {
            $scope.selectedArea.splice(idx, 1);
          }
        }
      }
    }


    $scope.MyCounties = [];
    $scope.MyPlaces = [];
    $scope.getCounties = function (state, val) {
      if (val != "address")
        $scope.showLoading.push(state);
      if (val != "address") {
        if ((!$scope.allCounties[state]) || ($scope.allCounties[state].length == 0)) {
          MyService.getAllCounties(state).then(function (payload) {
              //MyService.ConsoleLog("sublocations Locals : ", sublocations);
              $scope.showLoading.length = 0;
              var sublocations = payload;
              //MyService.ConsoleLog("sublocations counties : ", sublocations);
              if (!$scope.allCounties) {
                $scope.allCounties = [];
              }
              $scope.allCounties[state] = sublocations;
            },
            function (errorPayload) {
              growl.error('Something went wrong.');
            });
        } else {
          $scope.showLoading.length = 0;
          $scope.allCounties[state].length = 0;
        }
      } else if (val == "address") {

        if (typeof $scope.profile.state == "string") {
          var data = JSON.parse($scope.profile.state);
        } else {
          var data = $scope.profile.state;
        }
        var statePostalCode = data.statePostalCode;
        if (!data.statePostalCode || data.statePostalCode == null || data.statePostalCode == "null") {
          //MyService.ConsoleLog($scope.allLocations);
          //MyService.ConsoleLog(data.state);
          var chkData = $scope.checkExists($scope.allLocations, data.state);
          //MyService.ConsoleLog("chkData : ", chkData[0]);
          if (chkData[0]) {
            statePostalCode = chkData[0].statePostalCode;
          }
        }
        //MyService.ConsoleLog("statePostalCode:", statePostalCode);

        $scope.MyCounties.length = 0;
        MyService.getAllCounties(statePostalCode).then(function (payload) {
            //MyService.ConsoleLog("sublocations Locals : ", sublocations);
            $scope.showLoading.length = 0;
            $scope.MyCounties = payload;
            //MyService.ConsoleLog("getCounty checkdata: ", $scope.profile.address.county);
            if ($scope.profile.address.county) {
              var chkdata = $scope.checkCountyExists(payload, $scope.profile.address.county);
              //MyService.ConsoleLog("getCounty checkdata: ", chkdata);
              if (chkdata != "") {

                $scope.profile.county = JSON.stringify(angular.copy(chkdata[0]._id));
              }
            }
          },
          function (errorPayload) {
            growl.error('Something went wrong.');
          });

      }
    }

    $scope.getLocals = function (state, county, val) {
      //MyService.ConsoleLog("state : " + state + ", county :" + county + ", val :" + val)
      if (val != 'address')
        $scope.showLoadingCounty.push(county);
      if (val == "address") {
        $scope.MyPlaces.length = 0;
        if (typeof $scope.profile.state == "string") {
          var sdata = JSON.parse($scope.profile.state);
        } else {
          var sdata = $scope.profile.state;
        }
        if (typeof $scope.profile.county == "string") {
          var cdata = JSON.parse($scope.profile.county);
        } else {
          var cdata = $scope.profile.county;
        }
        MyService.getAllSubCountiesLocal(sdata.statePostalCode, cdata.county).then(function (payload) {
            $scope.MyPlaces = payload;
            //MyService.ConsoleLog("PlaCE :", $scope.profile.address.place);
            if ($scope.profile.address.place) {

              var chkdata = $scope.checkLocalExists(payload, $scope.profile.address.place, $scope.profile.address.countySubdivision);
              //MyService.ConsoleLog("getLocal checkdata: ", chkdata[0]);
              if (chkdata != "") {
                var idx = $scope.MyPlaces.indexOf(chkdata[0]);
                //MyService.ConsoleLog(idx);
                //MyService.ConsoleLog(angular.copy($scope.MyPlaces[idx]._id));
                $scope.profile.places = JSON.stringify(angular.copy($scope.MyPlaces[idx]._id));
              }
            }
          },
          function (errorPayload) {
            growl.error('Something went wrong.');
          });

      } else {
        if ((!$scope.allLocals[state] || !$scope.allLocals[state][county]) || ($scope.allLocals[state][county] == 0)) {

          MyService.getAllSubCountiesLocal(state, county).then(function (payload) {
              $scope.showLoadingCounty.length = 0;
              //MyService.ConsoleLog("sublocations Locals : ", sublocations);
              if (!$scope.allLocals[state]) {
                $scope.allLocals[state] = [];
              }
              $scope.allLocals[state][county] = payload;
            },
            function (errorPayload) {
              growl.error('Something went wrong.');
            });

        } else {
          $scope.showLoadingCounty.length = 0;
          $scope.allLocals[state][county] = 0;

        }
      }
    }

    $scope.showSubCat = false;
    $scope.showLoading = [];
    $scope.showLoadingCounty = [];
    $scope.showDown = [];
    $scope.ChangeShow = function (id) {
      $scope.showSubCat = true;
      var cols = document.getElementsByClassName('cmnUL');
      var clen = cols.length;
      var nclass = "MainCatLi_" + id;
      if ((document.getElementsByClassName(nclass)[0].style.display) && (document.getElementsByClassName(nclass)[0].style.display == "none")) {
        document.getElementsByClassName(nclass)[0].style.display = "block";
      } else {
        document.getElementsByClassName(nclass)[0].style.display = "none";
      }
    }

    $scope.checkTagsExists = function (rdata, val) {
      return rdata.filter(
        function (rdata) {

          if (rdata.pid == val)
            return rdata
        }
      );
    }

    //Select location ends
    $scope.users.data = [];
    $scope.statusGetResPg = 0;
    var searchUserByDetailCanceller = $q.defer();
    var searchOrgByDetailCanceller = $q.defer();
    var getAllCanceller = $q.defer();
    $scope.postOptions = ['Postcard', 'OfficialWebsite'];
    $scope.getResultsPage = function (pageNumber) {
      // this is just an example, in reality this stuff should be in a service
      //MyService.ConsoleLog("pageNumber");
      var params = {
        "page": pageNumber,
        max_records: 30
      };
      //MyService.ConsoleLog("params: ", params);
      // $scope.users.data = [];
      $scope.totalUsers = 0;
      //MyService.ConsoleLog($scope.userDetailFilter);
      searchOrgByDetailCanceller.resolve();
      searchUserByDetailCanceller.resolve();
      getAllCanceller.resolve();
      if (!$filter("isBlankString")($scope.orgDetailKeyword) || !$filter("isBlankString")($scope.userDetailKeyword) || !$filter("isBlankString")($scope.userDetailFilter)) {
        if (!$filter("isBlankString")($scope.orgDetailKeyword)) {
          //MyService.ConsoleLog("searching by organization");
          $scope.statusGetResPg = 1;

          searchOrgByDetailCanceller = $q.defer();
          params.keyword = $scope.orgDetailKeyword;
          var calc = (pageNumber - 1) * 30;
          if ($scope.users.data.length >= calc) {
            MyService.searchUserByOrgDetail(params, searchOrgByDetailCanceller).then(function (payload) {
              MyService.ConsoleLog("payload: ", payload);
              // $scope.users.data = payload.Items;
              $scope.users.data = $scope.users.data.concat(payload);
              //MyService.ConsoleLog("length: ", $scope.users.data.length);
              $scope.totalUsers = payload.Count;
              //MyService.ConsoleLog(payload.Items);
              $scope.statusGetResPg = 2;
            }, function (err) {
              //MyService.ConsoleLog(err);
              growl.error("Something went wrong.");
              $scope.statusGetResPg = 3;
              $scope.page--;
            });
          } else {
            //MyService.ConsoleLog("break loop");
            $scope.page = 0;
            // break;
            return false;

          }
        } else if (!$filter("isBlankString")($scope.userDetailKeyword) || !$filter("isBlankString")($scope.userDetailFilter)) {
          MyService.ConsoleLog("searching by user detail");
          $scope.statusGetResPg = 1;

          searchUserByDetailCanceller = $q.defer();
          params.keyword = $scope.userDetailKeyword;
          if (!params.keyword) {
            params.keyword = "postcard";
          }
          params.listOption = $scope.userDetailFilter;
          var calc = (pageNumber - 1) * 30;
          if ($scope.users.data.length >= calc) {
            MyService.searchUserByDetail(params, searchUserByDetailCanceller).then(function (payload) {
              MyService.ConsoleLog("payload: ", payload);
              // $scope.users.data = payload.Items;
              $scope.users.data = $scope.users.data.concat(payload);
              //MyService.ConsoleLog("length: ", $scope.users.data.length);
              $scope.totalUsers = payload.Count;
              //MyService.ConsoleLog(payload.Items);
              $scope.statusGetResPg = 2;
            }, function (err) {
              //MyService.ConsoleLog(err);
              growl.error("Something went wrong.");
              $scope.statusGetResPg = 3;
              $scope.page--;
            });
          } else {
            //MyService.ConsoleLog("break loop");
            $scope.page = 0;
            // break;
            return false;

          }
        }
      } else {
        if ($scope.filterUser) {
          params.usertype = $scope.filterUser;
        }
        $scope.statusGetResPg = 1;

        getAllCanceller = $q.defer();
        var calc = (pageNumber - 1) * 30;
        if ($scope.users.data.length >= calc) {
          MyService.getAllUsers(params, getAllCanceller).then(function (payload) {
            // $scope.users.data = payload.Items;
            $scope.users.data = $scope.users.data.concat(payload.Items);
            MyService.ConsoleLog("length: ", $scope.users.data);
            $scope.totalUsers = payload.Count;
            //MyService.ConsoleLog(payload.Items);
            $scope.statusGetResPg = 2;
          }, function (err) {
            //MyService.ConsoleLog(err);
            growl.error("Something went wrong.");
            $scope.statusGetResPg = 3;
            $scope.page--;
          });
        } else {
          //MyService.ConsoleLog("break loop");
          $scope.page = 0;
          // break;
          return false;

        }
      }
    }

    $scope.ShowUserForm = function () {
      $scope.UserFormDiv = 'New';
    }

    $scope.addNewUser = function (data) {
      if ($.fn.validateForceFully($("#AllUsersform")) == true) {

        //MyService.ConsoleLog("data: ", data);
        //MyService.ConsoleLog($scope.selectedArea);

        //MyService.ConsoleLog($scope.disabledLocation);


        if (data.subtype == "dataentryadmin") {
          data.type = "volunteer";
          data.volunteers = JSON.stringify({
            vtype: data.subtype,
            permited_location: $scope.selectedArea
          });
        }

        MyService.signUp(data).then(function (payload) {
          //MyService.ConsoleLog(payload);
          if (data.subtype == "dataentryadmin") {
            $scope.newuser = {
              type: "forumadmin",
              name: '',
              email: '',
              username: '',
              password: '',
            };
          } else {
            $scope.newuser = {
              type: "forumadmin",
              name: '',
              email: '',
              username: '',
              password: '',
            };
          }


          $scope.UserFormDiv = false;

          $scope.getResultsPage(1);

          alert("User added successfully.");

        }, function (error) {
          alert(JSON.stringify(error));
        });
      }
    }
    $scope.upuser = [];

    $scope.EditUser = function (mydata, idx) {
      // MyService.ConsoleLog("welcome yo edit");
      // MyService.ConsoleLog("edit");
      $scope.UserFormDiv = 'Edit';
      $scope.upuser.length = 0;
      $scope.upuser = mydata;
      MyService.ConsoleLog("para id :", idx);
      MyService.ConsoleLog("para", $scope.upuser);
      $scope.getSubcatTree();

      //$scope.disabledLocation = mydata.location_of_interest;
      //MyService.ConsoleLog(mydata.volunteers);
      //MyService.ConsoleLog(mydata.volunteers[0].permited_location);
      //MyService.ConsoleLog(mydata.volunteers[0].permited_location.length);
      //MyService.ConsoleLog($scope.selectedArea);
      //MyService.ConsoleLog($scope.disabledLocation);

      var locations = mydata.locationOfInterest;

      var catArr = mydata.subjectOfInterest;

      $scope.disabled = mydata.subjectOfDeepInterests;
      $scope.SelectedTree = mydata.subjectOfInterest;

      if (mydata.locationOfInterest && mydata.locationOfInterest.length > 0) {
        //MyService.ConsoleLog(mydata);
        var locData = mydata.locationOfInterest;
        //MyService.ConsoleLog("locData ", locData);
        var finalArray = [];
        var len = locations.length;
        for (var l = 0; l < len; l++) {
          var nobj = {};
          if (locations[l].country) {
            if (locations[l].country == "National (USA)") {
              $scope.Essay.National = "National";
            }
            if (locations[l].country == "International") {
              $scope.Essay.Locations = "International";
            }
            nobj.country = locations[l].country;
          }
          if (locations[l].state) {
            nobj.state = locations[l].state;
            nobj.statePostalCode = locations[l].statePostalCode;
          }
          if (locations[l].county) {
            nobj.county = locations[l].county;
          }
          if (locations[l].countySubdivision) {
            nobj.countySubdivision = locations[l].countySubdivision;
          }
          if (locations[l].place) {
            nobj.place = locations[l].place;
          }
          $scope.selectedArea.push(nobj);
          $scope.disabledLocation.push(nobj);
        }
        //MyService.ConsoleLog($scope.disabledLocation);
      }
      //MyService.ConsoleLog(idx);
    }

    $scope.closeUserEdit = function () {
      $scope.UserFormDiv = false;
    }

    $scope.UpdateUser = function (data) {
      var userId = angular.copy(data._id);
      MyService.ConsoleLog("data: ", data);
      delete data._id;
      delete data.__v;
      delete data.lastLogin;
      delete data.admin;
      delete data.politician;
      delete data.press;
      delete data.voteradmin;
      delete data.advocate;
      delete data.voter;
      delete data.$$hashKey;

      if ($scope.SelectedTree) {
        data.subjectOfInterest = $scope.SelectedTree;
      }
      //MyService.ConsoleLog("Final:", $scope.disabled);
      if ($scope.disabled) {
        data.subjectOfDeepInterests = $scope.disabled;
      }

      if ($scope.selectedArea) {
        data.locationOfInterest = $scope.selectedArea;
      }
      //MyService.ConsoleLog(data);
      var ndata = angular.toJson(data);


      //MyService.ConsoleLog($scope.selectedArea);
      //MyService.ConsoleLog($scope.disabledLocation);
      // var nobj = new Object;
      // nobj.id = data._id;
      // nobj.name = data.name;
      // nobj.email = data.email;
      // nobj.username = data.username;
      // nobj.permited_location = JSON.stringify($scope.selectedArea);
      // if (data.volunteers && data.volunteers[0].permited_location) {

      //   nobj.volunteers = JSON.stringify({
      //     vtype: data.volunteers[0].vtype,
      //     permited_location: JSON.stringify($scope.selectedArea)
      //   });
      // }
      // MyService.ConsoleLog("ndata<><><><>",ndata);

      MyService.UpdateUser({
        "id": userId,
        "alldata": ndata
      }).then(function (payload) {
        MyService.ConsoleLog(payload);
        $scope.UserFormDiv = false;
        $scope.users.data.length = 0;
        $scope.userDetailKeyword = "";
        $scope.orgDetailKeyword = "";
        $scope.getResultsPage(1);
        alert("User updated successfully.");
      }, function (error) {
        alert(JSON.stringify(error));
      });

    }

    $scope.removeUser = function (mydata, idx) {
      var message = 'Remove this user? This action cannot be undone.';
      var modal = ngDialog.openConfirm({
        template: '<p>' + message + '</p>\
            <div class="ngdialog-buttons">\
                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">OK</button>\
                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Cancel</button>\
            </div>',
        plain: true
      });
      modal.then(function fullfilled(data) {
        //MyService.ConsoleLog("fullfilled: ", mydata);
        MyService.removeUser({
          "id": mydata._id
        }).then(function (payload) {
          //MyService.ConsoleLog(payload);
          //$scope.UserFormDiv = false;
          $scope.getResultsPage(1);
          alert("User deleted successfully.");
        }, function (error) {
          alert(JSON.stringify(error));
        });
      }, function rejected(data) {
        //MyService.ConsoleLog("rejected: ", data);
      });
    }

    $scope.changeStatus = function (mydata, status) {
      //alert(status);
      MyService.updateUserStatus({
        "userid": mydata._id,
        "status": status
      }).then(function (payload) {
        //MyService.ConsoleLog(payload);
        //$scope.UserFormDiv = false;
        $scope.getResultsPage(1);
        alert("User status updated successfully.");
      }, function (error) {
        alert(JSON.stringify(error));
      });
    }

    $scope.filterUsers = function (selVal) {
      $scope.filterUser = selVal;
      //MyService.ConsoleLog("filterUsers: ", selVal);
      $scope.initVar();
      $scope.getResultsPage(1);
    };


    $scope.myPagingFunction = function () {
      MyService.ConsoleLog("scoll called");
      if ($scope.statusGetResPg != 1) {
        $scope.page++;
        $scope.pageChanged($scope.page);
      }
    };

    $scope.orgDetailKeyword = '';
    $scope.userDetailKeyword = '';
    $scope.userDetailTextChange = function () {
      //MyService.ConsoleLog("1", $scope.userDetailKeyword);
      $scope.orgDetailKeyword = '';
    };
    $scope.orgDetailTextChange = function () {
      //MyService.ConsoleLog("2", $scope.orgDetailKeyword);
      $scope.userDetailKeyword = '';
    };

    $scope.searchPeople = function () {
      if (!$filter("isBlankString")($scope.orgDetailKeyword) || !$filter("isBlankString")($scope.userDetailKeyword) || !$filter("isBlankString")($scope.userDetailFilter)) {
        $scope.page = 0;
        $scope.users.data = [];
        $scope.myPagingFunction();
      }
    };

    /**
     * Show melisa Data
     */
    $scope.showMelisa = function (u) {
      MyService.ConsoleLog("u", u);
      $location.path('/showMelisaData/' + u);

    };

    /**
     * Make account invisible from the site
     */
    $scope.makeInvisible = function (u, type) {
      MyService.ConsoleLog("u", u);
      MyService.makeInvisible({
        uData: JSON.stringify(u),
        type: type
      }).then(function (results) {
        MyService.ConsoleLog("Results", results);
        growl.success(results);
        $scope.searchPeople();
      }, function (err) {
        MyService.ConsoleLog("Error", err);
      });
    };

    $scope.updateAddress = function (id) {
      $scope.UpdateAddressLoader = true;
      MyService.getProfile(id).then(function (data) {
        // body...
        var address_data = data.address;
        address_data.zipcode = data.zipcode;
        //MyService.ConsoleLog("********* Data: ", data);
        ngDialog.open({
          template: 'app/popups/user_localupdate.html',
          data: data.address
          // className: 'ngdialog-theme-default'
        });
        $scope.UpdateAddressLoader = false;
      }, function (err) {
        //MyService.ConsoleLog("********* err: ", err);
        $scope.UpdateAddressLoader = false;
      });
    };

    if ($rootScope.showAllUsers) {
      MyService.ConsoleLog("inside");
      $scope.newuser = {
        type: "forumadmin",
        name: '',
        email: '',
        username: '',
        password: '',
      };
      $('#AllUsersform').validationEngine();
      $scope.getResultsPage(1);
      $scope.getAllStates();
    }

    /**
     * @description Function is use to export users and politicians records
     */
    $scope.exportBoth = function () {
      if (!$filter("isBlankString")($scope.sel.state)) {
        MyService.ConsoleLog(" $scope.sel ", $scope.sel.state);
        var obj = {};
        obj.statePostalCode = $scope.sel.state.statePostalCode;
        MyService.exportBoth(obj).then(function (APIResponse) {
          MyService.ConsoleLog("APIResponse", APIResponse);
          $window.open($scope.imgUrl + '/politician.xlsx', '_blank');
        }, function (err) {
          MyService.ConsoleLog("err", err);
          growl.error(err);
        });
      } else {
        growl.error('Please select state first');
      }
    };

  }])

'use strict';
angular.module('myApp.allTopics', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/allTopics', {
      templateUrl: 'app/allTopics/allTopics.html',
      controller: 'AllTopicsCtrl'
    });
  }]) .controller('AllTopicsCtrl', ['$scope', '$location', '$rootScope', 'tokenService', 'MyService', 'ngDialog', function ($scope, $location, $rootScope, tokenService, MyService, ngDialog) {
    $scope.topic = {
      data: []
    };
    $scope.totalUsers = 0;
    $scope.usersPerPage = 10; // this should match however many results your API puts on one page

    $scope.pagination = {
      current: 1
    };
    $scope.showLoading = false;

    $scope.page = 1;

    $scope.pageChanged = function (newPage) {
      $scope.getAllTopics(newPage);
    };

    $scope.getAllTopics = function (pageNumber) {
      // this is just an example, in reality this stuff should be in a service
      $scope.showLoading = true;
      var params = {
        "page": pageNumber,
        "max_records": $scope.usersPerPage
      };
      //MyService.ConsoleLog("params: ", params);
      MyService.getAllTopics(params).then(function (payload) {
        $scope.topic.data = $scope.topic.data.concat(payload.Items);
        $scope.totalUsers = payload.Count;
        //MyService.ConsoleLog(payload.Items);
        $scope.showLoading = false;
      }, function (err) {
        $scope.page--;
        //MyService.ConsoleLog(err);
        $scope.showLoading = false;
      });
    }

    $scope.loadMoreTopics = function () {
      if (!$scope.showLoading) {
        $scope.page++;
        $scope.getAllTopics($scope.page)
      }
    };

    $scope.removeTopic = function (mydata, idx) {
      if (!mydata.parent) {
        var message = 'This is a parent thread. Removing it will remove all the comments added to this thread. Do you want to proceed?';
      } else {
        var message = 'Are you sure you want to delete this Topic?';
      }

      var modal = ngDialog.openConfirm({
        template: '<p>' + message + '</p>\
            <div class="ngdialog-buttons">\
                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">YES</button>\
                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">NO</button>\
            </div>',
        plain: true
      });
      modal.then(function fullfilled(data) {
        //MyService.ConsoleLog("fullfilled: ", mydata);
        MyService.removeSpamTopic({
          "id": mydata._id
        }).then(function (payload) {
          //MyService.ConsoleLog(payload);
          //$scope.UserFormDiv = false;
          $scope.getAllTopics(1);
          alert("Topic deleted successfully.");
        }, function (error) {
          alert(JSON.stringify(error));
        });
      }, function rejected(data) {
        //MyService.ConsoleLog("rejected: ", data);
      });
    }

    if ($rootScope.showAllTopic) {
      $scope.getAllTopics(1);
    }
  }])
"use strict";
angular
  .module("myApp.allRatings", ["ngRoute"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/allRatings", {
        templateUrl: "app/allRatings/allRatings.html",
        controller: "allRatingsCtrl",
      });
      $routeProvider.when("/allRatings/:id/:msg?/:type?", {
        templateUrl: "app/allRatings/allRatings.html",
        controller: "allRatingsCtrl",
      });
    },
  ])
  .controller("allRatingsCtrl", [
    "$scope",
    "$http",
    "$location",
    "apiCall",
    "$routeParams",
    "$rootScope",
    "$q",
    "$timeout",
    "tokenService",
    "MyService",
    "$cookies",
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $rootScope,
      $q,
      $timeout,
      tokenService,
      MyService,
      $cookies
    ) {
      $scope.selectedPolitician = $routeParams.id;
      $scope.allReviews = [];
      $scope.ratingUp = null;
      $scope.ratingDown = null;
      $scope.nameUp = null;
      $scope.nameDown = null;
      $scope.dateUp = null;
      $scope.dateDown = null;
      $scope.matchUp = null;
      $scope.matchDown = null;
      $scope.type = false;
      $scope.ratingDateUp = null;
      $scope.ratingDateDown = null;
      $scope.showLoader = false;
      $scope.statusGetResPg = 0;
      $scope.page = 1;
      console.log("eleDate", $cookies.get("elecDateForRate"));

      /**
       * @description Get current user Id
       */
      $scope.userId = tokenService.getUserId();

      if ($scope.userId && $scope.userId != "") {
        MyService.getPress($scope.userId).then(
          function (APIResponse) {
            MyService.ConsoleLog("API", APIResponse);
            if (APIResponse && APIResponse.orgdata) {
              $scope.sigId = APIResponse.orgdata.sigId;
            }
          },
          function (err) {
            MyService.ConsoleLog("Error", err);
          }
        );
      }

      $scope.$on("$viewContentLoaded", function () {
        $scope.getData();
      });

      $scope.search = {
        name: "",
        rangeMin: 0,
        rangeMax: "",
      };
      $scope.success_msg = false;
      if ($routeParams.msg && $routeParams.msg == "true") {
        $scope.success_msg = true;
        setTimeout(function () {
          $(".alert").alert("close");
          // $scope.getAllCongressman();
        }, 2000);
      }

      if ($routeParams.type && $routeParams.type != "") {
        $scope.type = $routeParams.type;
      }

      $scope.sortDate = function () {
        var sortOrder = "";

        if ($scope.ratingDateUp == "" || $scope.ratingDateUp == "DESC") {
          sortOrder = "ASC";
          $scope.ratingDateUp = true;
          $scope.ratingDateDown = false;

          $scope.allReviews.sort(function (a, b) {
            // MyService.ConsoleLog("am", a);
            // MyService.ConsoleLog("b", b);
            var asc;
            var bss;
            // return a.timespan - b.timespan;
            if (
              a.timespan &&
              a.timespan != "" &&
              b.timespan &&
              b.timespan != ""
            ) {
              if (a.timespan.length > 4 || b.timespan.length > 4) {
                // console.log("if");
                asc = a.timespan.slice(0, 4);
                bss = b.timespan.slice(0, 4);
                MyService.ConsoleLog("ass", asc + "   " + bss);
                return asc - bss;
              } else {
                // console.log("else");
                return a.timespan - b.timespan;
              }
            }
          });
        } else {
          sortOrder = "DESC";
          $scope.ratingDateDown = true;
          $scope.ratingDateUp = false;
          var oneA, bTwo;

          $scope.allReviews.sort(function (a, b) {
            if (
              a.timespan &&
              a.timespan != "" &&
              b.timespan &&
              b.timespan != ""
            ) {
              // MyService.ConsoleLog("a", a.timespan);
              if (a.timespan.length > 4 || b.timespan.length > 4) {
                // console.log("if");
                oneA = a.timespan.slice(0, 4);
                bTwo = b.timespan.slice(0, 4);
                // MyService.ConsoleLog("ass", asc + "   " + bss);
                return bTwo - oneA;
              } else {
                // console.log("else");
                return b.timespan - a.timespan;
              }
            }
            // return b.timespan - a.timespan;
          });
        }
      };
      $scope.sortSearch = function (val) {
        var sortOrder = "";
        MyService.ConsoleLog(val);
        if (val == "name") {
          MyService.ConsoleLog("nameUp > ", $scope.nameUp);
          if ($scope.nameUp == "" || $scope.nameUp == "DESC") {
            sortOrder = "ASC";
            $scope.nameUp = true;
            $scope.nameDown = false;
            $scope.allReviews.sort(function (a, b) {
              var x, y;
              if (a && a.uType && b && b.uType) {
                if (a.uType == "advocate" && b.uType == "advocate") {
                  x = a.orgName.toLowerCase();
                  y = b.orgName.toLowerCase();
                } else {
                  x = a.pName.toLowerCase();
                  y = b.pName.toLowerCase();
                }
              } else {
                x = a.sig.name.toLowerCase();
                y = b.sig.name.toLowerCase();
              }

              if (x < y) {
                return -1;
              }
              if (x > y) {
                return 1;
              }
              return 0;
            });
          } else {
            sortOrder = "DESC";
            $scope.nameDown = true;
            $scope.nameUp = false;

            $scope.allReviews.sort(function (a, b) {
              // var x = a.sig.name.toLowerCase();
              // var y = b.sig.name.toLowerCase();
              var x, y;
              if (a && a.uType && b && b.uType) {
                if (a.uType == "advocate" && b.uType == "advocate") {
                  x = a.orgName.toLowerCase();
                  y = b.orgName.toLowerCase();
                } else {
                  x = a.pName.toLowerCase();
                  y = b.pName.toLowerCase();
                }
              } else {
                x = a.sig.name.toLowerCase();
                y = b.sig.name.toLowerCase();
              }
              if (x > y) {
                return -1;
              }
              if (x < y) {
                return 1;
              }
              return 0;
            });
          }
        } else {
          $scope.nameUp = false;
          $scope.nameDown = false;
        }
        /**
         * Sort Match
         */
        if (val == "match") {
          if ($scope.matchUp == "" || $scope.matchUp == "DESC") {
            sortOrder = "ASC";
            $scope.matchUp = true;
            $scope.matchDown = false;
            $scope.allReviews.sort(function (a, b) {
              return a.match - b.match;
            });
          } else {
            sortOrder = "DESC";
            $scope.matchDown = true;
            $scope.matchUp = false;
            $scope.allReviews.sort(function (a, b) {
              return b.match - a.match;
            });
          }
        } else {
          $scope.matchUp = false;
          $scope.matchDown = false;
        }

        if (val == "rating") {
          if ($scope.ratingUp == "" || $scope.ratingUp == "DESC") {
            sortOrder = "ASC";
            $scope.ratingUp = true;
            $scope.ratingDown = false;
            $scope.allReviews.sort(function (a, b) {
              return a.candidateRating[0].rating - b.candidateRating[0].rating;
            });
          } else {
            sortOrder = "DESC";
            $scope.ratingDown = true;
            $scope.ratingUp = false;
            $scope.allReviews.sort(function (a, b) {
              return b.candidateRating[0].rating - a.candidateRating[0].rating;
            });
          }
        } else {
          $scope.ratingUp = false;
          $scope.ratingDown = false;
        }
        if (val == "date") {
          if ($scope.dateUp == "" || $scope.dateUp == "DESC") {
            sortOrder = "ASC";
            $scope.dateUp = true;
            $scope.dateDown = false;
          } else {
            sortOrder = "DESC";
            $scope.dateDown = true;
            $scope.dateUp = false;
          }
        } else {
          $scope.dateUp = false;
          $scope.dateDown = false;
        }

        MyService.ConsoleLog("sortField : ", val);
        MyService.ConsoleLog("sortOrder : ", sortOrder);
        /*
      MyService.getReviewSearchResult({"id": $routeParams.id, "type": $scope.type, "sortField":val, "sortOrder": sortOrder}).then(function(response){
          MyService.ConsoleLog("response : ",response);
          if (response.data.success) {
          $scope.allReviews = response.data.data;
        }
      });
      */
      };

      var getAllCanceller = $q.defer();
      $scope.allReviews = [];
      $scope.tempArr = [];
      $scope.getData = function (pageNumber) {
        $scope.showLoader = true;
        $scope.statusGetData = 1;

        //getting name of politician
        MyService.getUserPublicProfile({
          id: $routeParams.id,
          type: false,
        }).then(
          function (response) {
            if (response.data.success) {
              MyService.ConsoleLog("response.data.success", response);

              $scope.username = response.data.data.userData.name;
              if (
                response.data.data.userData &&
                response.data.data.userData.politicianIds &&
                response.data.data.userData.politicianIds.length > 0
              ) {
                $scope.politicianIds =
                  response.data.data.userData.politicianIds[0];
              }

              MyService.ConsoleLog(" username : ", $scope.username);
            }
          },
          function (errorPayload) {
            $scope.statusGetData = 3;
          }
        );

        // getting user reviews
        MyService.ConsoleLog($routeParams.id + "====" + $scope.type);
        var params = {
          page: pageNumber,
          max_records: 30,
        };
        getAllCanceller.resolve();
        $scope.statusGetResPg = 1;
        getAllCanceller = $q.defer();
        params.id = $routeParams.id;
        params.type = $scope.type;
        params.curUId = $scope.userId;
        var calc = (pageNumber - 1) * 30;
        MyService.ConsoleLog("calc", calc);
        // if ($scope.allReviews.length >= calc) {
        MyService.getReviewsByUserId(params, getAllCanceller).then(
          function (response) {
            // MyService.ConsoleLog("response > ", JSON.parse(response.data.data));
            if (response.data.success) {
              try {
                $scope.showLoader = false;
                var tmpRate = JSON.parse(response.data.data);
                $scope.allReviews = $scope.allReviews.concat(tmpRate.votesmart);
                $scope.totalReviews = tmpRate.totalRecords;
                // $scope.allReviews = $scope.allReviews.concat(tmpRate);
              } catch (error) {
                $scope.showLoader = false;
                $scope.allReviews = $scope.allReviews.concat(
                  response.data.data.votesmart
                );
                $scope.totalReviews = response.data.data.totalRecords;
              }
              MyService.ConsoleLog(" $scope.allReviews : ", $scope.allReviews);
              MyService.ConsoleLog(
                "  $scope.totalReviews : ",
                $scope.totalReviews
              );

              var tempData = $scope.allReviews.filter(function (els, ind) {
                return (
                  ind ==
                  $scope.allReviews.findIndex(function (val) {
                    return JSON.stringify(val) == JSON.stringify(els);
                  })
                );
              });
              $scope.allReviews = [];
              $scope.allReviews = tempData;

              /*$scope.allReviews.sort(function (a, b) {
            var x = a.sig.name.toLowerCase();
            var y = b.sig.name.toLowerCase();
            if (x < y) {
              return -1;
            }
            if (x > y) {
              return 1;
            }
            return 0;
          });*/
              /**
               * @description Sort records and show best match first.
               */
              $scope.allReviews.sort(function (a, b) {
                return b.match - a.match;
              });
              $scope.statusGetResPg = 2;
            }
          },
          function (errorPayload) {
            $scope.statusGetData = 3;
            $scope.statusGetResPg = 3;
          }
        );
        // } else {
        //   $scope.page = 0;
        //   // break;
        //   return false;
        // }
      };

      $scope.pageChanged = function (newPage) {
        if (newPage) {
          $scope.getData(newPage);
        }
      };

      $scope.myPagingFunction = function () {
        MyService.ConsoleLog("scoll called", $scope.statusGetResPg);
        if (
          $scope.statusGetResPg != 1 &&
          $scope.totalReviews > $scope.allReviews.length
        ) {
          $scope.page++;
          $scope.pageChanged($scope.page);
        }
      };

      /**
       * @description Function use to redirect previous page.
       */

      $scope.BackToPrev = function () {
        if ($cookies.get("elecDateForRate")) {
          $location.path("/compare-select/politician");
        } else {
          $location.path("/incumbent_politician/politician");
        }
      };

      /**
       * End of BackToPrev
       */
      $scope.myPagingFunction();
    },
  ]);

'use strict';

angular.module('myApp.allQuizzes', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/allQuizzes', {
      templateUrl: 'app/allQuizzes/allQuizzes.html',
      controller: 'allQuizzesCtrl'
    });
  }]).controller('allQuizzesCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', 'baseApiUrl', '$q', '$timeout', 'growl', 'tokenService', '$anchorScroll', '$sce', 'MyService', 'ngDialog', '$cookies', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, baseApiUrl, $q, $timeout, growl, tokenService, $anchorScroll, $sce, MyService, ngDialog, $cookies) {

    /**
     * Get Current user id
     */
    if (tokenService.getUserId()) {
      $scope.advId = tokenService.getUserId();
      MyService.ConsoleLog("$scope.advId", $scope.advId);
    }
    window.localStorage.removeItem('isOrg');
    // $scope.isShow = $routeParams.isShowPop;

    /**
     * Get quizzes records which is created by advocate.
     */

    $scope.getQuizzesList = function () {
      MyService.getQuizList({
        advId: $scope.advId
      }).then(function (response) {
        MyService.ConsoleLog("Response", response);
        if (response && response.length > 0) {
          $scope.quizzes = response;

        } else {
          growl.error("You haven't created any quiz yet");
        }
      }, function (err) {
        MyService.ConsoleLog("Error", err);
      });
    };

    /**End of getQuizzesList */

    $scope.getQuizzesList();

    if ($cookies.get('isShows') == 'true') {
      var message = 'Congratulations you have invited your followers';
      var modal = ngDialog.openConfirm({
        template: '<p>' +
          message +
          '</p>\
        <div class="ngdialog-buttons">\
            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">OK</button>\
        </div>',
        plain: true,
        closeByDocument: false,
      });
      modal.then(
        function fullfilled(data) {
          if (data == 1) {
            MyService.ConsoleLog("Yes ");
          }
        },
        function rejected(data) {
          MyService.ConsoleLog("rejected: ", data);
          // $scope.getMatchQUestions();
        }
      );
      $cookies.remove('isShows');
    }

    /**
     * Shows the confirmation pop up
     */
    $scope.showPopUp = function (quiz) {
      var message = 'Are you sure you want to delete this quiz';
      var modal = ngDialog.openConfirm({
        template: '<p>' +
          message +
          '</p>\
        <div class="ngdialog-buttons">\
            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Yes</button>\
            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(0)">No</button>\
        </div>',
        plain: true,
        closeByDocument: false,
      });
      modal.then(
        function fullfilled(data) {
          if (data == 1) {
            MyService.ConsoleLog("Yes ");
            $scope.deleteQuiz(quiz);
          }
        },
        function rejected(data) {
          MyService.ConsoleLog("rejected: ", data);
          // $scope.getMatchQUestions();
        }
      );
    };
    $scope.questions = {
      quiz: ''
    }
    /**
     * @description Show Pop with text box to edit quiz name
     */

    $scope.editName = function (item) {
      $scope.questions.quiz = item.quizName;
      $scope.quizData = item;
      $rootScope.editModal = ngDialog.open({
        template: 'viewQuiz',
        scope: $scope,
      });
    };

    /**
     * @description Update quiz name
     */
    $scope.updateName = function () {
      $rootScope.editModal.close();
      MyService.ConsoleLog("Ssss", $scope.questions.quiz);
      MyService.ConsoleLog("$scope.quizData", $scope.quizData);

      MyService.updateQuizName({
        quizName: $scope.questions.quiz,
        orgId: $scope.advId,
        oldQuizName: $scope.quizData.quizName
      }).then(function (APIResponse) {
        MyService.ConsoleLog("this is", APIResponse);
        $scope.getQuizzesList();
      }, function (err) {
        MyService.ConsoleLog("Error", err);
      });
    };


    /**
     * Delete selected quiz
     */
    $scope.deleteQuiz = function (val) {
      MyService.ConsoleLog("val", val);
      MyService.deleteQuiz(val).then(function (result) {
        MyService.ConsoleLog("Result", result);
        growl.success(result.data.data);
        $scope.getQuizzesList();
      }, function (err) {
        MyService.ConsoleLog("Error", err);
      });
    };

    $scope.takeQuiz = function (val) {
      window.localStorage.setItem('isOrg', true);
      $location.path('/followersQuiz/' + val.quizName + '/' + val.orgId);
    };
  }]);

'use strict';
angular.module('myApp.alliesP', ['ngRoute'])

  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/alliesP', {
      templateUrl: 'app/alliesP/alliesP.html',
      controller: 'alliesPCtrl'
    });
  }])
  .controller('alliesPCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService) {

  }]);

'use strict';
angular.module('myApp.allies', ['ngRoute'])

  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/allies', {
      templateUrl: 'app/allies/allies.html',
      controller: 'alliesCtrl'
    });
  }])
  .controller('alliesCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', function($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService) {

  }]);

'use strict';
angular.module('myApp.allEssay', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/allEssay', {
      templateUrl: 'app/allEssay/allEssay.html',
      controller: 'AllEssayCtrl'
    });
  }]).controller('AllEssayCtrl', ['$scope', '$location', '$rootScope', 'tokenService', 'MyService', 'ngDialog', function ($scope, $location, $rootScope, tokenService, MyService, ngDialog) {
    $scope.essay = {
      data: []
    };
    $scope.totalUsers = 0;
    $scope.usersPerPage = 25; // this should match however many results your API puts on one page

    $scope.pagination = {
      current: 1
    };
    $scope.showLoading = false;

    $scope.pageChanged = function (newPage) {
      $scope.getAllEssay(newPage);
    };

    $scope.getAllEssay = function (pageNumber) {
      // this is just an example, in reality this stuff should be in a service
      $scope.showLoading = true;
      MyService.getAllEssay({
        "pageno": pageNumber,
        "max_records": $scope.usersPerPage
      }).then(function (payload) {
        $scope.essay.data = payload.Items;
        $scope.totalUsers = payload.Count;
        //MyService.ConsoleLog(payload.Items);
        $scope.showLoading = false;
      }, function (err) {
        //MyService.ConsoleLog(err);
      });
    }

    $scope.removeEssay = function (mydata, idx) {

      var message = 'Are you sure you want to delete this Essay?';

      var modal = ngDialog.openConfirm({
        template: '<p>' + message + '</p>\
            <div class="ngdialog-buttons">\
                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">YES</button>\
                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">NO</button>\
            </div>',
        plain: true
      });
      modal.then(function fullfilled(data) {
        //MyService.ConsoleLog("fullfilled: ", mydata);
        MyService.removeEssay({
          "id": mydata._id
        }).then(function (payload) {
          //MyService.ConsoleLog(payload);
          //$scope.UserFormDiv = false;
          $scope.getAllEssay(1);
          alert("Essay deleted successfully.");
        }, function (error) {
          alert(JSON.stringify(error));
        });
      }, function rejected(data) {
        //MyService.ConsoleLog("rejected: ", data);
      });
    }

    if ($rootScope.showAllEssay) {
      $scope.getAllEssay(1);
    }
  }])
'use strict';
angular.module('myApp.allEndorsements', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/allEndorsements', {
      templateUrl: 'app/allEndorsements/allEndorsements.html',
      controller: 'allEndorsementsCtrl'
    });
    $routeProvider.when('/allEndorsements/:id/:msg?/:type?', {
      templateUrl: 'app/allEndorsements/allEndorsements.html',
      controller: 'allEndorsementsCtrl'
    });
  }])
  .controller('allEndorsementsCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', 'ngDialog', '$cookies', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService, ngDialog, $cookies) {

    $scope.selectedPolitician = $routeParams.id;
    $scope.allEndorsements = [];
    $scope.endorsementUp = null;
    $scope.endorsementDown = null;
    $scope.nameUp = null;
    $scope.nameDown = null;
    $scope.dateUp = null;
    $scope.dateDown = null;
    $scope.type = false;
    $scope.loader = false;
    $scope.$on('$viewContentLoaded', function () {
      $scope.getData();
    });
    $scope.userId = tokenService.getUserId();
    $scope.search = {
      name: '',
      rangeMin: 0,
      rangeMax: ''
    };
    $scope.success_msg = false;
    if ($routeParams.msg && $routeParams.msg == "true") {
      $scope.success_msg = true;
      setTimeout(function () {
        $(".alert").alert('close');
        // $scope.getAllCongressman();
      }, 2000);
    }

    if ($routeParams.type && $routeParams.type != "") {
      $scope.type = $routeParams.type;
    }
    $scope.getNotes = function (val) {
      $scope.showNote = val;
      $scope.MyDialog = ngDialog.open({
        template: 'viewNotes',
        scope: $scope
      });
    };

    MyService.ConsoleLog("tokenService.getUserId()", tokenService.getUserId());
    $scope.sortSearch = function (val) {
      var sortOrder = "";
      MyService.ConsoleLog(val);
      if (val == 'name') {
        MyService.ConsoleLog("nameUp > ", $scope.nameUp);
        if ($scope.nameUp == "" || $scope.nameUp == "DESC") {
          sortOrder = "ASC";
          $scope.nameUp = true;
          $scope.nameDown = false;
          $scope.allEndorsements.sort(function (a, b) {
            var x = a.name.toLowerCase();
            var y = b.name.toLowerCase();
            if (x < y) {
              return -1;
            }
            if (x > y) {
              return 1;
            }
            return 0;
          });
        } else {
          sortOrder = "DESC";
          $scope.nameDown = true;
          $scope.nameUp = false;
          $scope.allEndorsements.sort(function (a, b) {
            var x = a.name.toLowerCase();
            var y = b.name.toLowerCase();
            if (x > y) {
              return -1;
            }
            if (x < y) {
              return 1;
            }
            return 0;
          });
        }


      } else {
        $scope.nameUp = false;
        $scope.nameDown = false;
      }
      if (val == 'endorsement') {
        if ($scope.ratingUp == "" || $scope.ratingUp == "DESC") {
          sortOrder = "ASC";
          $scope.ratingUp = true;
          $scope.ratingDown = false;

          $scope.allEndorsements.sort(function (a, b) {
            return a.match - b.match;

          });
        } else {
          sortOrder = "DESC";
          $scope.ratingDown = true;
          $scope.ratingUp = false;

          $scope.allEndorsements.sort(function (a, b) {
            return b.match - a.match;
          });
        }
      } else {
        $scope.ratingUp = false;
        $scope.ratingDown = false;
      }
      if (val == 'date') {
        if ($scope.dateUp == "" || $scope.dateUp == "DESC") {
          sortOrder = "ASC";
          $scope.dateUp = true;
          $scope.dateDown = false;
        } else {
          sortOrder = "DESC";
          $scope.dateDown = true;
          $scope.dateUp = false;
        }
      } else {
        $scope.dateUp = false;
        $scope.dateDown = false;
      }

      MyService.ConsoleLog("sortField : ", val);
      MyService.ConsoleLog("sortOrder : ", sortOrder);
      /*
      MyService.getReviewSearchResult({"id": $routeParams.id, "type": $scope.type, "sortField":val, "sortOrder": sortOrder}).then(function(response){
          MyService.ConsoleLog("response : ",response);
          if (response.data.success) {
          $scope.allEndorsements = response.data.data;
        }
      });
      */

    }

    $scope.getData = function () {
      $scope.statusGetData = 1;
      $scope.loader = true;

      //getting name of politician
      MyService.getUserPublicProfile({
        id: $routeParams.id,
        type: $scope.type
      }).then(function (response) {
        if (response.data.success) {

          $scope.username = response.data.data.userData.name;
          MyService.ConsoleLog(" username : ", $scope.username);
        }
      }, function (errorPayload) {
        $scope.statusGetData = 3;
      });

      // getting user reviews
      MyService.ConsoleLog($routeParams.id + "====" + $scope.type);
      MyService.getEndorsementsByUserId({
        id: $routeParams.id,
        type: $scope.type,
        curId: tokenService.getUserId()
      }).then(function (response) {
        MyService.ConsoleLog("response > ", response);
        if (response.data.success) {
          $scope.allEndorsements = response.data.data;
          MyService.ConsoleLog(" $scope.allEndorsements : ", $scope.allEndorsements);
          /**
           * @description Sort records and show best match first.
           */
          $scope.allEndorsements.sort(function (a, b) {
            return b.match - a.match;
          });

          $scope.loader = false;


        }
      }, function (errorPayload) {
        $scope.statusGetData = 3;
      });
    };

    /**
     * @description Function use to redirect previous page.
     */

    $scope.BackToPrev = function () {
      if ($cookies.get('elecDateForRate')) {
        $location.path('/compare-select/politician');
      } else {
        $location.path('/incumbent_politician/politician');
      }
    };

    /**
     * End of BackToPrev
     */

  }]);

'use strict';
angular
  .module('myApp.allCongressman', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/allCongressman', {
        templateUrl: 'app/allCongressman/allCongressman.html',
        controller: 'AllCongressmanCtrl'
      });
    }
  ])
  .controller('AllCongressmanCtrl', [
    '$scope',
    'ngDialog',
    '$rootScope',
    'MyService',
    '$http',
    function ($scope, ngDialog, $rootScope, MyService, $http) {
      $scope.allCongressmanData = [];
      // $scope.more = false;
      $scope.selChamber = {
        chamber: ''
      };
      $scope.selDbPresent = {
        present: ''
      };
      $scope.selectCandidate = {
        selectCandy: 'user'
      };
      $scope.more = [];
      $scope.searchCongressmen = '';

      $scope.searchMe = function (user) {
        //MyService.ConsoleLog("in searchMe" ,user);
        var query = $scope.searchCongressmen.toLowerCase(),
          fullname = user.firstName.toLowerCase() + ' ' + user.lastName.toLowerCase();
        MyService.ConsoleLog('fullname >', fullname);
        // MyService.ConsoleLog('fullname >', users.name.toLowerCase());

        MyService.ConsoleLog('query >', query);
        if (fullname.indexOf(query) != -1) {
          return true;
        }
        return false;
      };
      $scope.propublicaData = [];
      $scope.matchMembers = function (u) {
        MyService.ConsoleLog("U >", u);
        // $scope.more = false;
        $scope.propublicaData = u;
        // console.log($scope.propublicaData);
        var fname = $scope.propublicaData.firstName;
        // MyService.ConsoleLog("matchMembers",fname);
        var lname = $scope.propublicaData.lastName;
        // MyService.ConsoleLog("matchMembers",lname);
        $scope.proPublicaId = $scope.propublicaData.proPublicaId;
        // MyService.ConsoleLog("matchMembers", $scope.proPublicaId );

        $scope.success_msg = false;

        // MyService.ConsoleLog("matchMembers");

        // MyService.ConsoleLog("proPublicaId :", $scope.proPublicaId);
        $scope.allCongressman = false;
        // $scope.allmatch = true;
        MyService.matchMembers({
          fname: fname,
          lname: lname,
          proId: $scope.proPublicaId,
          votesmartId: u.votesmartId
        }).then(
          function (payload) {
            MyService.ConsoleLog('Match Members data : ', payload);
            if (payload.data.data.conData && payload.data.data.conData != "") {
              $scope.allmatchData = "";
              $(document).ready(function () {
                $scope.success_msg = true;
                setTimeout(function () {
                  $('.alert').alert('close');
                  $scope.getAllCongressman();
                }, 2000);
                // $scope.allCongressman = true;
              });
            } else {
              if (payload.data.data.user[0] || payload.data.data.politicians[0]) {
                // MyService.ConsoleLog('Match Members data : ', payload);
                $scope.allmatchData = payload.data.data;
                // console.log("all data", $scope.allmatchData);
                if (!$scope.allmatchData['user'] || $scope.allmatchData['user'].length == 0) {
                  $scope.selectCandidate.selectCandy = 'politician';
                }
                $scope.alert_msg = false;
                // console.log("name", $scope.allmatchData.user[0].name);
              } else {
                $scope.alert_msg = true;
              }
            }
          },
          function (err) {
            MyService.ConsoleLog('Match Members error: ', err);
          }
        );
      };

      $scope.addMatchCandidates = function (id, type) {
        // alert(id);
        // MyService.ConsoleLog("proPublicaId :", $scope.proPublicaId);
        var pro_id = $scope.proPublicaId;
        MyService.addMatchedMembers({
          u_id: id,
          type: type,
          proPublicaId: pro_id
        }).then(
          function (payload) {
            $(document).ready(function () {
              $scope.success_msg = true;
              setTimeout(function () {
                $('.alert').alert('close');
                $scope.getAllCongressman();
              }, 2000);
              // $scope.allCongressman = true;
            });

            // $scope.allCongressman = true;
            // console.log(payload);
          },
          function (errorPayload) {
            console.log(errorPayload);
          }
        );
      };

      $scope.back = function () {
        // console.log("back");
        // $scope.show = false;

        $scope.allCongressman = true;
      };

      $scope.showLess = function (id) {
        // console.log("id for less",id);
        $scope.more[id] = false;
      };

      //get Candidates
      $scope.getDetailsOfCandidates = function (id) {
        $scope.more[id] = true;
      };

      $scope.showLoader = false;
      $scope.getAllCongressman = function () {
        $scope.allCongressmanData.length = 0;
        $scope.showLoader = true;
        $scope.allCongressman = true;
        // $scope.success_msg = false;

        MyService.getAllCongressman({}).then(
          function (payload) {
            MyService.ConsoleLog('payload<><><>', payload);
            $scope.showLoader = false;
            $scope.allCongressmanData = payload;
          },
          function (errorPayload) {
            $scope.showLoader = false;
          }
        );
      };

      $scope.findCongressmenMismatch = function () {
        MyService.findCongressmenMismatch({}).then(
          function (payload) {
            // MyService.ConsoleLog("addCongressman:::", payload);
          },
          function (errorPayload) {
            MyService.ConsoleLog(errorPayload);
            //$scope.showLoader = false;
          }
        );
      };

      $scope.currentCongressman = function () {
        // $scope.allCongressman.length = 0;
        $scope.showLoader = true;
        MyService.addCongressman({}).then(
          function (payload) {
            MyService.ConsoleLog('addCongressman:::', payload);
            $scope.getAllCongressman();
          },
          function (errorPayload) {
            alert('Something went wrong');
            $scope.showLoader = false;
          }
        );
      };

      if ($rootScope.showAllCongressman) {
        $scope.getAllCongressman();
      }
    }
  ]);

'use strict';
angular.module('myApp.advocateSignup', ['ngRoute'])
.config(['$routeProvider', function($routeProvider) {
  $routeProvider.when('/advocatesignup', {
    templateUrl: 'app/advocateSignup/advocateSignup.html',
    controller: 'advocateSignupCtrl'
  });
}])
.controller('advocateSignupCtrl', ['$scope','$rootScope','$http','$location','apiCall', 'MyService', function ($scope, $rootScope, $http, $location, apiCall, MyService) {
  $scope.user = {};
  $scope.usernameMessage = '';
  $scope.passwordMessage = '';
  $scope.emailMessage = '';
  $scope.taken = true;
  $scope.county = '';
  $scope.cities = [];
  $scope.zipClicked = "zip-not-clicked";
  $rootScope.welcome = false;
  var validate = apiCall.constants();

  $scope.makeErrorList = function(response){
    //MyService.ConsoleLog(response.errors);
    var errors = [];
    for (var key in response.errors) {
        if (response.errors.hasOwnProperty(key)) {
          var value = response.errors[key];
          if (value.message !== undefined) {
            errors.push(value.message);
          }
        }
      return errors;
    }
  }

  function validateUsername (username) {
    $scope.usernameMessage = '';
    var validated = validate.regex.username.test(username);
    if (!validated && username.length > 25 ) {
      $scope.usernameMessage = 'cannot be longer than 25 charectors and can contain (. - _ $ @ * ! )';
      return false;
    }
    if (!validated && username.length < 3 ) {
      $scope.usernameMessage = 'cannot be shorter than 3 charectors and can contain (. - _ $ @ * !)';
      return false;
    }
    if (!validated) {
      $scope.usernameMessage = 'must be between 3 and 25 charectors and can contain (. - _ $ @ * !)';
      return false;
    }
    if (validated) {
      usernameTaken(username);
        if ($scope.taken) {
          return true;
        }
        return false;
    }
    return validated;
  }

  function validatePassword (password) {
    $scope.passwordMessage = '';
    var validated = validate.regex.password.test(password);
    if (!validated) {
      $scope.passwordMessage = ' must be at least 8 charectors long, contain one number, one uppercase letter and one lowercase letter';
      return false;
    }
    return validated;
  }

  function validateEmail (email) {
    $scope.emailMessage = '';
    var validated = validate.regex.email.test(email);
    if (!validated) {
      $scope.emailMessage = 'Not a valid email address';
      return false;
    }
    if (validated) {
      emailTaken(email);
        if($scope.taken) {
          return true;
        }
        return false;
    }
    return validated;
  }

  function validateInputs (username, email, password) {
    var validUsername = validateUsername(username);
    var validEmail = apiCall.validateEmail(email, $scope);
    var validPassword = validatePassword(password);
    if (validUsername && validEmail && validPassword) {
      return true;
    }
    return false;
  }

  function usernameTaken(username) {
    MyService.checkUnm({"username": username}).then(function(response){
      if (response.data.taken) {
          $scope.usernameMessage = ' is taken';
          $scope.taken = false;
          return;
      }
      $scope.taken = true;
    }, function(err){
        growl.error("Something went wrong.");
    });
  }

  var emailTaken = function(email){
    MyService.checkEmail({"email": email}).then(function(response){
      if (response.data.taken) {
          $scope.emailMessage = ' is taken';
          $scope.taken = false;
          return;
      }
      $scope.taken = true;
    }, function(err){
      growl.error("Something went wrong.");
    });
  }

  $scope.findByZip = function( user ){
    var request = apiCall.apiCall('GET', '/ziplookup/zip/'+ user.zip, undefined);
    $http(
      request
    ).then(function success(response) {
      //MyService.ConsoleLog(response.data.zip);
      $scope.county = response.data.zip.county;
      $scope.cities = response.data.zip.city;
      $scope.zipClicked = 'zip-clicked';
    }, function error(response) {
      //MyService.ConsoleLog(response.data);
    })
  }

    $scope.signUp = function( user ){
      $scope.errorMessages = '';
      //MyService.ConsoleLog(user);
      user.county = $scope.county;
      var validated = validateInputs (user.username, user.email, user.password);
      usernameTaken(user.username);
      if (user.username && user.password && user.zip && user.email && validated) {
        var data = {
             password: user.password,
             city: user.city,
             street: user.address,
             zip: user.zip,
             username: user.username,
             email: user.email
        };
        var request = apiCall.apiCall('POST', '/user/signup', data);
       $http(
         request
       ).then(function successCallback(response) {
        $location.path('/welcomeView');
      }, function errorCallback(response) {
         var errorList = $scope.makeErrorList(response.data.error);
         if (errorList) {
           $scope.errorMessages = String(errorList);
         }
         else {
            $scope.errorMessages = '';
         }

      });
    }
    else {
      $scope.errorMessages = 'Please fill out all fields.';
    }
   }

}]);

'use strict';
angular.module('myApp.advocateHome', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/advocateHome', {
        templateUrl: 'app/advocateHome/advocateHome.html',
        controller: 'advocateHomeCtrl'
    });
}])

.controller('advocateHomeCtrl', ['$scope','$rootScope','baseApiUrl', 'MyService', 'growl', function($scope, $rootScope, baseApiUrl, MyService, growl) {
    //MyService.ConsoleLog("DebateHome called");
    $scope.imgUrl = baseApiUrl + "/resources";
    $rootScope.welcome = false;
    $scope.statusGetEssayCat = 0;
    $scope.getCategories = function() {
        /*var request = apiCall.apiCall('GET', '/categories/list', {root: 1});
	  $http(
	    request
	  ).then(function successCallback(response) {
		//MyService.ConsoleLog("Got categories: ",response);
		if(response.data.success){
			$scope.categories = response.data.data;
		}
		else{
			//MyService.ConsoleLog("Something went wrong: ",response.data);
		}
	  }, function errorCallBack(response) {
	    //MyService.ConsoleLog("Error: ",response);
	  });*/
		$scope.categories = [];
		$scope.statusGetEssayCat = 1;
        //MyService.ConsoleLog("params----");
        
        MyService.getCategories({ root: 1, catTypes: "E" }, null).then(function(response) {
            if (response.data.success) {
                $scope.categories = response.data.data;
                //MyService.ConsoleLog($scope.categories);
                $scope.statusGetEssayCat = 2;
            } else {
                //MyService.ConsoleLog("Error: ", response.error);
                growl.error("Something went wrong: ");
                $scope.statusGetEssayCat = 3;
            }
        }, function() {
            growl.error("Something went wrong while fetching categories.");
            $scope.statusGetEssayCat = 3;
        });
    }
    $scope.getCategories();
}]);

'use strict';
angular.module('myApp.addRating', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/addRating', {
      templateUrl: 'app/addRating/addRating.html',
      controller: 'addRatingCtrl'
    });
    $routeProvider.when('/addRating/:id/:isEdit?/:voteSmartId?', {
      templateUrl: 'app/addRating/addRating.html',
      controller: 'addRatingCtrl'
    });
  }])
  .controller('addRatingCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', '$sce', 'growl', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService, $sce, growl) {
    $scope.locationIntrest = 'politician';
    $scope.selectionType = '';
    $scope.selectedUser = {};
    $scope.selectedReferal = {};
    $scope.userId = tokenService.getUserId();
    $scope.userData = JSON.parse(tokenService.getUserData());
    $scope.politiicanId = $routeParams.id;
    $scope.isEdit = $routeParams.isEdit;
    $scope.voteSmartId = $routeParams.voteSmartId;
    MyService.ConsoleLog(" $scope.voteSmartId", $scope.voteSmartId);
    $scope.review = {
      toId: '',
      toName: '',
      fromId: $scope.userData.id,
      fromName: $scope.userData.name,
      referalId: '',
      referalName: '',
      grade: {
        number: 0,
        letter: '',
        like: 'true'
      },
      text: '',
      links: []
    };
    $scope.showLoader = false;

    $scope.$on('$viewContentLoaded', function () {
      //commented by Pankaj Patil to stop the autoload for politicians when called from incumbent page
      //$scope.getUsers('politician');
      if ($routeParams.id && $routeParams.id != "") {
        $scope.getUsersFromIds();
      }
      if (tokenService.getUserRole()) {
        MyService.ConsoleLog("tokenService.getUserRole()", tokenService.getUserRole());
      }
    });

    $scope.getUsers = function (type) {
      $scope.allUsers = [];
      $scope.selectedUser.value = '';
      $scope.selectedReferal.value = '';
      $scope.review.referalId = '';
      $scope.review.referalName = '';
      $scope.showLoader = true;
      $scope.review = {
        toId: '',
        toName: '',
        fromId: $scope.userData.id,
        fromName: $scope.userData.name,
        referalId: '',
        referalName: '',
        grade: {
          number: 0,
          letter: '',
          like: 'true'
        },
        text: '',
        links: []
      }
      $scope.selectionType = type;
      var request = apiCall.apiCall('GET', '/user/list', {
        usertype: type
      });
      $http(
        request
      ).then(function successCallback(response) {
        if (response.data.success) {
          // MyService.ConsoleLog(response);
          angular.forEach(response.data.data, function (val, key) {
            var fkey;
            var _id = response.data.data[key]._id;
            if ($routeParams.id && response.data.data[key]._id == $routeParams.id) {
              var fkey = '';
              if (response.data.data[key].userType == 'politician') {
                var name, officeName, state;
                name = response.data.data[key].name;
                if (response.data.data[key].politicianInfo && response.data.data[key].politicianInfo.length > 0) {
                  officeName = response.data.data[key].politicianInfo[0].officeName;
                  state = response.data.data[key].politicianInfo[0].state;
                }

                if (state && state != '') {
                  fkey = name + ' ' + state + ' ' + officeName;
                } else {
                  fkey = name + ' ' + officeName;
                }
              } else {
                var name, url;
                name = response.data.data[key].name;
                url = window.location.origin + '/#!/publicProfile/' + response.data.data[key]._id;
                fkey = name + ' ' + url;
              }
              $scope.selectedUser.value = fkey;
              $scope.review.toId = response.data.data[key]._id;
              $scope.review.toName = response.data.data[key].name;
              $scope.showLoader = false;
              document
                .getElementById("auto-referal-suggest-box")
                .getElementsByTagName("input")[0]
                .blur();
            } else {
              if ($scope.selectionType == 'politician') {
                MyService.ConsoleLog("politician Info", response.data.data[key].politicianInfo);
                var name, officeName, state;
                name = response.data.data[key].name;
                if (response.data.data[key].politicianInfo && response.data.data[key].politicianInfo.length > 0) {
                  officeName = response.data.data[key].politicianInfo[0].officeName;
                  state = response.data.data[key].politicianInfo[0].state;
                }



                if (state && state != '') {
                  fkey = name + ' ' + state + ' ' + officeName;
                } else {
                  fkey = name + ' ' + officeName;
                }
              } else {
                var name, url;
                name = response.data.data[key].name;
                url = window.location.origin + '/#!/publicProfile/' + response.data.data[key]._id;
                fkey = name + ' ' + url;
              }
              response.data.data[key].fkey = fkey
              $scope.allUsers.push(response.data.data[key]);
              $scope.showLoader = false;
            }

          });
        } else {
          growl.error("Something went wrong.");
          $scope.showLoader = false;
        }
      }, function errorCallBack(response) {
        growl.error("Something went wrong.");
        $scope.showLoader = false;
      });
    }

    $scope.getUsersFromIds = function () {
      var userIds = [];
      userIds.push($routeParams.id);
      if (!$scope.isEdit) {
        MyService.getUsersFromIds({
          "userIds": JSON.stringify(userIds)
        }).then(function (response) {
          console.log("response : ", response);
          if (response.data.success) {
            console.log("Data : ", response.data.data);
            var rdata = response.data.data;
            $scope.selectedUser.value = rdata[0].name;
            $scope.review = {
              toId: $routeParams.id,
              toName: rdata[0].name,
              fromId: $scope.userData.id,
              fromName: $scope.userData.name,
              referalId: '',
              referalName: '',
              grade: {
                number: 0,
                letter: '',
                like: 'true'
              },
              text: '',
              links: []
            };
            console.log("review >>> ", $scope.review);
          }
        });
      } else {
        MyService.getRatingsFor({
          "rateId": $routeParams.id,
          "curUId": $scope.userId,
          "voteSmartId": $scope.voteSmartId
        }).then(function (APIResponse) {
            MyService.ConsoleLog("APIResponse", APIResponse);
            if (APIResponse.data.success) {
              console.log("Data : ", APIResponse.data.data);
              var rdata = APIResponse.data.data;

              if (!$scope.voteSmartId) {
                $scope.selectedUser.value = rdata.to[0].name;
                $scope.review = {
                  toId: rdata.to[0].uid,
                  toName: rdata.to[0].name,
                  fromId: rdata.from[0].uid,
                  fromName: rdata.from[0].name,
                  referalId: '',
                  referalName: '',
                  grade: {
                    number: rdata.number,
                    letter: '',
                    like: 'true'
                  },
                  text: rdata.review,
                  links: []
                };
              } else {
                $scope.selectedUser.value = rdata.poliName;
                $scope.selectedUserId = rdata.userId;
                $scope.review = {
                  grade: {
                    number: parseInt(rdata.candidateRating.rating),
                    letter: '',
                    like: 'true'
                  },
                  text: '',
                }
              }

            }
          },
          function (err) {
            MyService.ConsoleLog("Error", err);
          });
      }
    };

    function fuzzy_suggest(term) {
      if (!term) return [];
      var fuzzySearch = "";
      fuzzySearch = new Fuse($scope.allUsers, {
        shouldSort: true,
        keys: ["fkey"],
        caseSensitive: false,
        threshold: 0.4
      });
      // MyService.ConsoleLog(fuzzySearch);
      return fuzzySearch
        .search(term)
        .slice(0, 10)
        .map(function (i) {
          var val = i.fkey;
          // MyService.ConsoleLog("val:::", val);
          return {
            value: JSON.stringify(i),
            label: $sce.trustAsHtml(val)
          };
        });
    }

    function highlight(str, term) {
      var highlight_regex = new RegExp("(" + term + ")", "gi");
      return str.replace(
        highlight_regex,
        '<span class="highlight">$1</span>'
      );
    }

    $scope.closeEdit = function (col) {
      var nval = JSON.parse(col.value);
      // MyService.ConsoleLog(nval);
      // MyService.ConsoleLog('_id: ', nval._id);
      $scope.selectedUser.value = nval.fkey;
      $scope.review.toId = nval._id;
      $scope.review.toName = nval.name;
      document
        .getElementById("auto-user-suggest-box")
        .getElementsByTagName("input")[0]
        .blur();
    }

    $scope.user_options = {
      suggest: fuzzy_suggest,
      on_select: $scope.closeEdit
    };

    $scope.reviewYourself = function () {
      $scope.selectionType = 'yourself';
      // $scope.selectedUser.value = '';
      MyService.ConsoleLog("review : ", $scope.review);
      $scope.selectedReferal.value = '';
      /*
      $scope.review = {
        fromId: $scope.userData.id,
        fromName: $scope.userData.name,
        referalId: '',
        referalName: '',
        grade: {
          number: 0,
          letter: 'a',
          like: 'true'
        },
        text: '',
        links: []
      }
      */
    }

    function referal_suggest(term) {
      if (!term) return [];
      var fuzzySearch = "";
      fuzzySearch = new Fuse($scope.allUsers, {
        shouldSort: true,
        keys: ["fkey"],
        caseSensitive: false,
        threshold: 0.4
      });
      // MyService.ConsoleLog(fuzzySearch);
      return fuzzySearch
        .search(term)
        .slice(0, 10)
        .map(function (i) {
          var val = i.fkey;
          // MyService.ConsoleLog("val:::", val);
          return {
            value: JSON.stringify(i),
            label: $sce.trustAsHtml(val)
          };
        });
    }

    $scope.closeReferal = function (col) {
      var nval = JSON.parse(col.value);
      $scope.selectedReferal.value = nval.fkey;
      $scope.review.referalId = nval._id;
      $scope.review.referalName = nval.name;
      document
        .getElementById("auto-referal-suggest-box")
        .getElementsByTagName("input")[0]
        .blur();
    }

    $scope.referal_options = {
      suggest: referal_suggest,
      on_select: $scope.closeReferal
    };

    $scope.setLike = function (grade) {
      $scope.review.grade.like = grade;
    }

    $scope.submitReview = function () {
      var referalId = null;
      var referalName = "";

      if ($scope.review.referalName == "") {
        referalName = $scope.selectedReferal.value;
        referalId = referalId;
      } else {
        referalName = $scope.review.referalId;
        referalId = $scope.review.referalName;
      }

      var params = {
        toId: $scope.review.toId,
        toName: $scope.review.toName,
        fromId: $scope.review.fromId,
        fromName: $scope.review.fromName,
        referalId: referalId,
        referalName: referalName,
        number: $scope.review.grade.number,
        letter: $scope.review.grade.letter,
        like: $scope.review.grade.like,
        review: $scope.review.text,
        links: $scope.review.links

      };

      MyService.ConsoleLog("params : ", params);
      if (params.number && params.number != '') {
        if (!$scope.isEdit) {
          MyService.addReview(params).then(function (response) {

            if (response.data.success == true) {
              $scope.selectedUser.value = '';
              $scope.selectedReferal.value = '';
              $scope.review = {
                to: '',
                from: $scope.userId,
                referal: '',
                grade: {
                  number: 0,
                  letter: '',
                  like: 'true'
                },
                text: '',
                links: ''
              }
              MyService.ConsoleLog("success : ", response.data.data);
              $location.path('/allRatings/' + params.toId + '/showmsg');
            }
          }, function (err) {
            // MyService.ConsoleLog('err: ', err);
          });
        } else {
          MyService.updateRating({
            "rateId": $routeParams.id,
            "curUId": $scope.userId,
            "voteSmartId": $scope.voteSmartId,
            "data": params
          }).then(function (APIResponse) {
            MyService.ConsoleLog("APIResponse", APIResponse);
            if (!$scope.voteSmartId)
              $location.path('/allRatings/' + params.toId + '/showmsg');
            else
              $location.path('/allRatings/' + $scope.selectedUserId + '/showmsg');

          }, function (err) {
            MyService.ConsoleLog("Error", err);
          });
        }
      } else {
        growl.error("Please fill the ratings");
      }




    };
    $(document).ready(function () {
      console.log('onready');
      $('#myform').validationEngine();

    });
  }]);

"use strict";
angular
  .module("myApp.addPolitician", ["ngRoute"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/addPolitician", {
        templateUrl: "app/addPolitician/addPolitician.html",
        controller: "addPoliticianCtrl",
      });
    },
  ])
  .controller("addPoliticianCtrl", [
    "$scope",
    "ngDialog",
    "$rootScope",
    "MyService",
    "$routeParams",
    "apiCall",
    "tokenService",
    "growl",
    "$window",
    "$sce",
    "$filter",
    "$q",
    "$http",
    "$timeout",

    function (
      $scope,
      ngDialog,
      $rootScope,
      MyService,
      $routeParams,
      apiCall,
      tokenService,
      growl,
      $window,
      $sce,
      $filter,
      $q,
      $http,
      $timeout
    ) {
      $scope.MUserType = [
        {
          name: "Politician",
          key: "politician",
        },
        {
          name: "Organization",
          key: "advocate",
        },
      ];

      $scope.RegisterButton = false;
      $rootScope.welcome = false;
      $scope.HideOrgInfo = false;
      $scope.records = [];
      $scope.States = [];
      $scope.Cities = [];
      $scope.UserType = $routeParams.type;
      $scope.Address = {
        ZipCode: "",
        Country: "",
        State: "",
        City: "",
      };

      $scope.User = {
        name: "",
        lastname: "",
        UserName: "",
        Password: "",
        Email: "",
        ZipCode: "",
        ssn: "",
        confirmOpt: "Email",
        runElectionDate: "",
        runStatus: "",
        runElecType: "",
        cur_ElectionDate: "",
        cur_status: "",
        cur_eleType: "",
        otherLevel: "",
        runOtherLevel: "",
      };

      $scope.Errors = [];

      $scope.displayDrop = false;
      $scope.displayCounty = false;
      $scope.stateSenate = false;
      $scope.stateHouse = false;
      $scope.federalCong = false;
      $scope.countyone = false;
      $scope.cityone = false;
      $scope.school = false;
      $scope.showLoaderOne = false;
      $scope.dis = false;
      $scope.showtxtRun = false;
      $scope.showtxt = false;
      // $scope.showcur_office_details = false
      $scope.showcur_office_name = false;
      $scope.showcur_office_location = false;
      $scope.showOther = false;
      $scope.show_run_Other = false;
      $scope.running_stateSenate = false;
      $scope.running_stateHouse = false;
      $scope.running_federalCong = false;
      $scope.running_countyone = false;
      $scope.running_cityone = false;
      $scope.running_school = false;
      $scope.running_showLoaderOne = false;
      $scope.running_dis = false;
      $scope.running_showLoader = false;
      $scope.LoaderTwo = false;
      $scope.shownew_office_nameDrop = false;
      $scope.showcur_office_nameDrop = false;
      $scope.flagShowStateDropdownPres = false;
      $scope.running_flagShowStateDropdownPre = false;
      $scope.shownew_office_nameOther = false;
      $scope.showcur_office_nameOther = false;
      //$scope.levelOfGovt = ['national', 'state', 'judicial district', 'county', 'sub county', 'city', 'state school board district', 'local school district', 'other'];

      $scope.levelOfGovt = [
        "Other",
        "Federal",
        "State",
        "County",
        "Local",
        "President",
      ];

      $scope.countylevelOfGovt = ["County"];
      $scope.statelevelOfGovt = [
        "State",
        "State House of Representatives District",
        "State Senate District",
        "All USA",
        "Federal Congressional District",
      ];
      $scope.schoollevelOfGovt = [
        "Elementary school District Position",
        "Secondary School District Position",
        "Unified School District Position",
        "State Board of Education District",
      ];

      $scope.judiciallevelOfGovt = ["Judicial District"];
      $scope.locallevelOfGovt = ["Place Name", "County SubDivision Name"];
      $scope.offices = [];
      $scope.running_offices = [];
      $scope.carriers = [
        {
          name: "AT&T",
          domain: "txt.att.net",
        },
        {
          name: "T-Mobile",
          domain: "tmomail.net",
        },
        {
          name: "Verizon",
          domain: "vtext.com",
        },
        {
          name: "Sprint",
          domain: "messaging.sprintpcs.com",
        },
        {
          name: "Virgin Mobile",
          domain: "vmobl.com",
        },
        {
          name: "Tracfone",
          domain: "mmst5.tracfone.com",
        },
        {
          name: "Metro PCS",
          domain: "mymetropcs.com",
        },
        {
          name: "Boost Mobile",
          domain: "myboostmobile.com",
        },
        {
          name: "Cricket",
          domain: "sms.mycricket.com",
        },
        {
          name: "Ptel",
          domain: "ptel.com",
        },
        {
          name: "Republic Wireless",
          domain: "text.republicwireless.com",
        },
        {
          name: "Suncom",
          domain: "tms.suncom.com",
        },
        {
          name: "Ting",
          domain: "message.ting.com",
        },
        {
          name: "U.S. Cellular",
          domain: "email.uscc.net",
        },
        {
          name: "Consumer Cellular",
          domain: "cingularme.com",
        },
        {
          name: "C-Spire",
          domain: "cspire1.com",
        },
        {
          name: "Page Plus",
          domain: "vtext.com",
        },
      ];

      $scope.govLevelChanged = function (electionFor) {
        $scope.running_flagShowStateDropdown = false;
        $scope.running_flagShowOfficeDropdown = false;
        // $scope.flagShowStateDropdown = false;
        $scope.flagShowOfficeDropdown = false;
        //MyService.ConsoleLog("* govLevelChanged *");
        if (electionFor == "running") {
          $scope.User.office_name = null;
          $scope.running_flagShowStateDropdown = true;
          //$scope.onStateChange('running');
          if ($scope.User.level == "Other") {
            $scope.shownew_office_nameOther = true;
            $scope.shownew_office_nameDrop = false;
            $scope.show_run_Other = true;
            $scope.running_flagShowStateDropdownPre = false;
          } else {
            $scope.shownew_office_nameOther = false;
            $scope.show_run_Other = false;
          }
          if ($scope.User.level == "President") {
            // $scope.onOfficeChange('running');
            $scope.running_flagShowStateDropdown = false;
            $scope.running_flagShowCandidateDropdown = true;
            $scope.shownew_office_nameDrop = true;
            $scope.running_flagShowStateDropdownPre = true;
          } else {
            $scope.running_flagShowStateDropdown = true;
            $scope.running_flagShowCandidateDropdown = false;
            $scope.shownew_office_nameDrop = false;
            $scope.running_flagShowStateDropdownPre = false;
          }
          $scope.running_stateSenate = false;
          $scope.running_stateHouse = false;
          $scope.running_federalCong = false;
          $scope.running_countyone = false;
          $scope.running_cityone = false;
          $scope.running_school = false;
          $scope.running_showLoader = false;
          $scope.runFederalCongrassionalDist = "";
          $scope.runUnifiedSchoolDistrictNames = "";
          $scope.runStateHouseOFRepresentativeDistricts = "";
          $scope.runStateSenateDistrict = "";
          $scope.runPlaces = "";
          $scope.runCounties = "";
          $scope.User.state = "";
          $scope.runAddress.stateSenateDistrict = "";
          $scope.runAddress.federalCongrassionalDist = "";
          $scope.runAddress.stateHouseOFRepresentativeDistrict = "";
          $scope.runAddress.unifiedSchoolDistrictName = "";

          switch ($scope.User.level) {
            case "State":
              $scope.offiArr = [
                {
                  officeName: "Governor",
                },
                {
                  officeName: "Lieutenant Governor",
                },
                {
                  officeName: "State Senator",
                },
                {
                  officeName: "State House of Representatives",
                },
                {
                  officeName: "Other",
                },
              ];
              break;
            case "Federal":
              $scope.offiArr = [
                {
                  officeName: "U.S. House of Representatives",
                },
                {
                  officeName: "U.S. Senate",
                },
              ];
              break;
            case "Local":
              $scope.offiArr = [
                {
                  officeName: "Mayor",
                },
                {
                  officeName: "City Council",
                },
                {
                  officeName: "Other",
                },
              ];
              break;

            case "County":
              $scope.offiArr = [
                {
                  officeName: "Commissioner",
                },
                {
                  officeName: "Sheriff",
                },
                {
                  officeName: "Other",
                },
              ];

              break;
            case "Other":
              $scope.offiArr = [
                {
                  officeName: "",
                },
              ];

              break;
            case "President":
              $scope.offiArr = [
                {
                  officeName: "President",
                },
              ];
              break;
          }
        } else {
          // $scope.User.cur_state = null;
          $scope.User.cur_office_name = null;

          if ($scope.User.cur_level == "Other") {
            $scope.showcur_office_nameOther = true;
            $scope.flagShowStateDropdownPre = false;
            $scope.showcur_office_nameDrop = false;
            $scope.showOther = true;
          } else {
            $scope.showcur_office_nameOther = false;
            $scope.showOther = false;
          }

          if ($scope.User.cur_level == "President") {
            // $scope.onOfficeChange('incumbent');
            $scope.flagShowStateDropdown = false;
            $scope.flagShowCandidateDropdown = true;
            $scope.showcur_office_nameDrop = true;
            $scope.flagShowStateDropdownPres = true;
          } else {
            $scope.flagShowStateDropdown = true;
            $scope.flagShowCandidateDropdown = false;
            $scope.showcur_office_nameDrop = false;
            $scope.flagShowStateDropdownPres = false;
          }
          $scope.dis = false;
          $scope.stateSenate = false;
          $scope.stateHouse = false;
          $scope.federalCong = false;
          $scope.countyone = false;
          $scope.cityone = false;
          $scope.school = false;
          $scope.federalCongrassionalDist = "";
          $scope.unifiedSchoolDistrictNames = "";
          $scope.stateHouseOFRepresentativeDistricts = "";
          $scope.stateSenateDistrict = "";
          $scope.allsubcounty = "";
          $scope.places = "";
          $scope.counties = "";
          $scope.User.cur_state = "";
          $scope.address.stateSenateDistrict = "";
          $scope.address.federalCongrassionalDist = "";
          $scope.address.stateHouseOFRepresentativeDistrict = "";

          switch ($scope.User.cur_level) {
            case "State":
              $scope.cur_offiArr = [
                {
                  officeName: "U.S. Senate",
                },
                {
                  officeName: "Lieutenant Governor",
                },
                {
                  officeName: "Governor",
                },
                {
                  officeName: "State Board of Education",
                },
                {
                  officeName: "Secretary of State",
                },
                {
                  officeName: "unifiedSchoolDistrictName",
                },
                {
                  officeName: "State House",
                },
                {
                  officeName: "State Senate",
                },
              ];
              break;
            case "Federal":
              $scope.cur_offiArr = [
                {
                  officeName: "U.S. House",
                },
                {
                  officeName: "U.S. Senate",
                },
              ];
              break;
            case "Local":
              $scope.cur_offiArr = [
                {
                  officeName: "Mayor",
                },
                {
                  officeName: "City Council",
                },
                {
                  officeName: "Other",
                },
              ];
              break;

            case "County":
              $scope.cur_offiArr = [
                {
                  officeName: "Commissioner",
                },
                {
                  officeName: "Sheriff",
                },
                {
                  officeName: "Other",
                },
              ];

              break;
            case "Other":
              $scope.cur_offiArr = [
                {
                  officeName: "",
                },
              ];

              break;
            case "President":
              $scope.cur_offiArr = [
                {
                  officeName: "President",
                },
              ];
              break;
          }
          // switch ($scope.User.cur_level) {
          //   case "Local":
          //     $scope.displayDrop = true;
          //     break;
          //   case "Other":
          //     $scope.displayDrop = true;
          //     break;
          //   case 'County':
          //     $scope.displayCounty = true;
          //     break;
          //   case 'State':
          //    $scope.displayDrop = true;
          //    break;

          //   default:
          //     MyService.ConsoleLog("default");
          //     break
          // }

          // if ($scope.User.cur_level == 'Federal') {
          //   // alert("fed");
          //   $scope.displayDrop = false;
          //   $scope.displayCounty = false;
          //   $scope.federalCongrassionalDist = "";
          //   $scope.unifiedSchoolDistrictNames = "";
          //   $scope.stateHouseOFRepresentativeDistricts = "";
          //   $scope.stateSenateDistrict = "";
          //   $scope.allsubcounty = "";
          //   $scope.places = "";
          //   $scope.counties = "";
          //   // $scope.states = "";
          //   $scope.address.state = "";
          // } else if ($scope.User.cur_level == 'County') {
          //   $scope.displayDrop = false;
          // }

          // if( $scope.User.cur_level == 'State'){

          // }

          // alert('else');
          //$scope.onStateChange('incumbent');
        }
      };

      $scope.localSchoolDistException = function (electionFor) {
        var exceptionState = ["AK", "DC", "VA"];
        if ((electionFor = "running")) {
          if (
            $scope.User.state &&
            exceptionState.indexOf($scope.User.state.statePostalCode) == -1
          ) {
            return true;
          } else return false;
        } else if (electionFor == "incumbent") {
          if (
            $scope.User.cur_state &&
            exceptionState.indexOf($scope.User.cur_state.statePostalCode) == -1
          ) {
            return true;
          } else return false;
        }
      };

      $scope.selectStatus = function () {
        // MyService.ConsoleLog("selected >", $scope.User.runStatus);
        // MyService.ConsoleLog('User.cur_eleType >', $scope.User.runElecType);
        MyService.ConsoleLog(
          "Usercur_ElectionDate>",
          $scope.User.runElectionDate
        );
        // MyService.ConsoleLog('Usercur_ElectionDate>', $scope.User.runElectionDate);
        // var month = $scope.User.runElectionDate.getMonth() + 1;

        // var finDate = $scope.User.runElectionDate.getFullYear() + "-" + month + "-" + ;
        // MyService.ConsoleLog("$scope.User.runElectionDate ", $scope.User.runElectionDate.getDate());
        // MyService.ConsoleLog("$scope.User.runElectionDate ", $scope.User.runElectionDate.getMonth());
        // MyService.ConsoleLog("$scope.User.runElectionDate ", finDate.toString());
        // var tm = $scope.User.runElectionDate.getTime();
        // var testDate = new Date(tm);
        // MyService.ConsoleLog("testDate", testDate);
        // MyService.ConsoleLog("testDate String", testDate.toString());
      };

      $scope.showOfficeAutoComplete = function (electionFor) {
        //MyService.ConsoleLog("showOfficeAutoComplete");
        // ['national', 'state', 'judicial district', 'county', 'sub county', 'city', 'state school board district', 'local', 'school district', 'other']
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "national":
              $scope.running_offices = [
                "president",
                "senate",
                "house of representatives",
                "other",
              ];
              return true;
              break;
            case "state":
              if ($scope.User.state) {
                //fetch office names for this
                //For the options, do a search through the table currently labelled “2016 Alabama” and Find all Item A’s where the Item D is State Postal Code, and item Q is the state selected.  Then add “other” to the end of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "judicial district":
              if ($scope.User.state && $scope.User.district) {
                //fetch office names for this
                //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item F is the district selected. Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "county":
              if ($scope.User.state && $scope.User.county) {
                //fetch office names for this
                //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected.  Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "sub county":
              if (
                $scope.User.state &&
                $scope.User.county &&
                $scope.User.subcounty
              ) {
                //fetch office names for this
                // For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item U is the subcounty selected. Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "city":
              if (
                $scope.User.state &&
                $scope.User.county &&
                $scope.User.locality
              ) {
                //fetch office names for this
                // For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected and U or W match the “city” selection.  Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "state school board district":
              if ($scope.User.state && $scope.User.state_school_dist) {
                //fetch office names for this
                // do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item E is the “District” selection.  Then add “other” to the bottom of the list.
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "local school district":
              if (
                $scope.User.state &&
                $scope.localSchoolDistException() &&
                $scope.User.county &&
                $scope.User.district
              ) {
                //for office names
                // search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the “County” selection and either AD’s, AF’s or  AH’s match the District Name selected.  Then add “other” to the bottom of the list.
                // $scope.offices=['other'];
                return true;
              } else if ($scope.User.state && $scope.User.district) {
                //for options
                //do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item AD’s match the District Name selected.  Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
          }
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "national":
              $scope.offices = [
                "president",
                "senate",
                "house of representatives",
                "other",
              ];
              return true;
              break;
            case "state":
              if ($scope.User.cur_state) {
                //fetch office names for this
                //For the options, do a search through the table currently labelled “2016 Alabama” and Find all Item A’s where the Item D is State Postal Code, and item Q is the state selected.  Then add “other” to the end of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "judicial district":
              if ($scope.User.cur_state && $scope.User.cur_district) {
                //fetch office names for this
                //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item F is the district selected. Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "county":
              if ($scope.User.cur_state && $scope.User.cur_county) {
                //fetch office names for this
                //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected.  Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "sub county":
              if (
                $scope.User.cur_state &&
                $scope.User.cur_county &&
                $scope.User.cur_subcounty
              ) {
                //fetch office names for this
                // For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item U is the subcounty selected. Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "city":
              if (
                $scope.User.cur_state &&
                $scope.User.cur_county &&
                $scope.User.cur_locality
              ) {
                //fetch office names for this
                // For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected and U or W match the “city” selection.  Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "state school board district":
              if ($scope.User.cur_state && $scope.User.cur_state_school_dist) {
                //fetch office names for this
                // do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item E is the “District” selection.  Then add “other” to the bottom of the list.
                // $scope.offices=['other'];
                return true;
              }
              break;
            case "local school district":
              if (
                $scope.User.cur_state &&
                $scope.localSchoolDistException() &&
                $scope.User.cur_county &&
                $scope.User.cur_district
              ) {
                //for office names
                // search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the “County” selection and either AD’s, AF’s or  AH’s match the District Name selected.  Then add “other” to the bottom of the list.
                // $scope.offices=['other'];
                return true;
              } else if ($scope.User.cur_state && $scope.User.cur_district) {
                //for options
                //do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item AD’s match the District Name selected.  Then add “other” to the bottom of the list
                // $scope.offices=['other'];
                return true;
              }
              break;
          }
          return false;
        }
      };
      var running_flagShowStateDropdown = false;
      var flagShowStateDropdown = false;
      $scope.showSateDropdown = function (electionFor) {
        //MyService.ConsoleLog("showSateDropdown");
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "state":
            case "judicial district":
            case "county":
            case "sub county":
            case "city":
            case "state school board district":
            case "local school district":
              running_flagShowStateDropdown = true;
              return true;
              break;
          }

          switch ($scope.User.office_name) {
            case "senate":
            case "house of representatives":
              running_flagShowStateDropdown = true;
              return true;
              break;
          }

          running_flagShowStateDropdown = false;
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "state":
            case "judicial district":
            case "county":
            case "sub county":
            case "city":
            case "state school board district":
            case "local school district":
              flagShowStateDropdown = true;
              return true;
              break;
          }

          switch ($scope.User.cur_office_name) {
            case "senate":
            case "house of representatives":
              flagShowStateDropdown = true;
              return true;
              break;
          }

          flagShowStateDropdown = false;
          return false;
        }
      };

      $scope.flagShowCandidateDropdown = false;
      $scope.running_flagShowCandidateDropdown = false;

      var fuzzySearch = "";
      var autoFillCurOffice = "";
      var autoFillOffice = "";
      $scope.showLoader = false;

      $scope.onOfficeChange = function (electionFor) {
        if (electionFor == "running") {
          //'Federal', 'State', 'Local'
          // if ($scope.User.level != 'President') {
          $scope.running_showLoader = true;
          // }

          var nObj = new Object();
          nObj.level = $scope.User.level ? $scope.User.level : "";
          nObj.office = $scope.User.off_name ? $scope.User.off_name : "";
          if ($scope.User.state && $scope.User.state != "") {
            nObj.state = JSON.stringify($scope.User.state);
          }
          $scope.running_flagShowCandidateDropdown = true;
          $scope.shownew_office_name = true;

          switch ($scope.User.level) {
            case "Other":
              $scope.getRunningCounties();
              break;
            case "County":
              $scope.getRunningCounties();
              break;
            case "State":
              $scope.getRunningStateHouse();
              break;
            case "Federal":
              $scope.getRunningFederal();
              break;
            case "Local":
              $scope.getRunningCounties();
              break;

            default:
              MyService.ConsoleLog("default");
              break;
          }

          if ($scope.User.level == "Other") {
            $scope.autoOffice = [
              {
                officeName: "U.S. Senate",
              },
              {
                officeName: "Lieutenant Governor",
              },
              {
                officeName: "Governor",
              },
              {
                officeName: "State Board of Education",
              },
              {
                officeName: "Secretary of State",
              },
              {
                officeName: "unifiedSchoolDistrictName",
              },
              {
                officeName: "State House",
              },
              {
                officeName: "State Senate",
              },
              {
                officeName: "U.S. House",
              },
              {
                officeName: "U.S. Senate",
              },
              {
                officeName: "Mayor",
              },
              {
                officeName: "City Council",
              },
              {
                officeName: "Commissioner",
              },
              {
                officeName: "Sheriff",
              },
            ];

            autoFillOffice = new Fuse($scope.autoOffice, {
              shouldSort: true,
              keys: ["officeName"],
              caseSensitive: false,
              threshold: 0.4,
            });
          }
        } else if (electionFor == "incumbent") {
          // if ($scope.User.cur_level != 'President') {
          $scope.showLoader = true;
          $scope.showcur_office_name = true;

          // }

          var nObj = new Object();
          nObj.level = $scope.User.cur_level;
          nObj.office = $scope.User.cur_off_name;
          if ($scope.User.cur_state && $scope.User.cur_state != "") {
            nObj.state = JSON.stringify($scope.User.cur_state);
          }
          $scope.flagShowCandidateDropdown = true;
          // if ($scope.User.cur_level == "County") {
          //   $scope.getCounties(nObj.state);
          //   alert('office changed');
          // }

          switch ($scope.User.cur_level) {
            case "Other":
              $scope.getCounties();
              break;
            case "County":
              $scope.getCounties();
              break;
            case "State":
              $scope.getStateHouse();
              break;
            case "Federal":
              $scope.getFederal();
              break;
            case "Local":
              $scope.getCounties();
              break;

            default:
              MyService.ConsoleLog("default");
              break;
          }

          if ($scope.User.cur_level == "Other") {
            $scope.autoOfficeCur = [
              {
                officeName: "U.S. Senate",
              },
              {
                officeName: "Lieutenant Governor",
              },
              {
                officeName: "Governor",
              },
              {
                officeName: "State Board of Education",
              },
              {
                officeName: "Secretary of State",
              },
              {
                officeName: "unifiedSchoolDistrictName",
              },
              {
                officeName: "State House",
              },
              {
                officeName: "State Senate",
              },
              {
                officeName: "U.S. House",
              },
              {
                officeName: "U.S. Senate",
              },
              {
                officeName: "Mayor",
              },
              {
                officeName: "City Council",
              },
              {
                officeName: "Commissioner",
              },
              {
                officeName: "Sheriff",
              },
            ];
            $scope.showcur_office_name = true;
            $scope.showcur_office_location = true;

            autoFillCurOffice = new Fuse($scope.autoOfficeCur, {
              shouldSort: true,
              keys: ["officeName"],
              caseSensitive: false,
              threshold: 0.4,
            });
          }
        }
        MyService.ConsoleLog("nObj<><><><", nObj);
        MyService.getPoliticians(nObj).then(
          function (payload) {
            // MyService.ConsoleLog("payload<><><><><>", payload);
            // console.log(payload);
            $scope.candidates = payload;
            // $scope.showLoader = false;
            //MyService.ConsoleLog($scope.running_flagShowCandidateDropdown);

            $scope.candidates.push({
              name: "Other",
            });

            fuzzySearch = new Fuse($scope.candidates, {
              shouldSort: true,
              keys: ["name"],
              caseSensitive: false,
              threshold: 0.4,
            });
          },
          function (errPayload) {
            $scope.showLoader = false;
            //MyService.ConsoleLog("Error");
            //MyService.ConsoleLog(errPayload);
            alert(errPayload);
          }
        );
      };

      $scope.getofficeDrop = function () {
        MyService.ConsoleLog("$drop cur >>", $scope.User.cur_office_name);
        // MyService.ConsoleLog("$drop >>", $scope.User.office_name);
        if ($scope.User.cur_office_name != "") {
          if ($scope.User.cur_office_name.officeName == "Other") {
            MyService.ConsoleLog("Insde >>");

            $scope.showtxt = true;
            // MyService.ConsoleLog()
          }
        }
      };

      $scope.getofficeDropRun = function () {
        MyService.ConsoleLog(
          "$drop cur >>",
          $scope.User.office_name.officeName
        );
        // MyService.ConsoleLog("$drop >>", $scope.User.office_name);

        if ($scope.User.office_name.officeName == "Other") {
          MyService.ConsoleLog("Insde >>");
          $scope.showtxtRun = true;
          // MyService.ConsoleLog()
        }

        if (
          $scope.User.office_name.officeName == "State House of Representatives"
        ) {
          $scope.User.office_name.officeName = "";
          $scope.User.office_name.officeName = "State House";
        }

        if (
          $scope.User.office_name.officeName == "U.S. House of Representatives"
        ) {
          $scope.User.office_name.officeName = "";
          $scope.User.office_name.officeName = "U.S. House";
        }
      };

      // autocomplete

      var options = {
        componentRestrictions: {
          country: "us",
        },
        types: ["geocode"],
      };

      $scope.detectAddress = function (ent) {
        var val = document.getElementById("address");
        // console.log($scope.User.Address);
        var autocomplete = new google.maps.places.Autocomplete(val, options);

        google.maps.event.addListener(
          autocomplete,
          "place_changed",
          function () {
            var place = autocomplete.getPlace();
            // console.log('hello');
            // console.log("place", place);

            var lat = place.geometry.location.lat(),
              lng = place.geometry.location.lng();

            $scope.lati = lat.toFixed(6);
            $scope.lon = lng.toFixed(6);
            // console.log($scope.lati);
            // console.log($scope.lon);

            $scope.mailing_Address = place.formatted_address;
            console.log($scope.mailing_Address);
            for (var i = 0; i < place.address_components.length; i++) {
              for (
                var j = 0;
                j < place.address_components[i].types.length;
                j++
              ) {
                if (
                  place.address_components[i].types[j] ==
                  "administrative_area_level_1"
                ) {
                  $scope.statePostalCode =
                    place.address_components[i].short_name;
                  $scope.stateName = place.address_components[i].long_name;
                  // console.log($scope.statePostalCode);
                }
                if (place.address_components[i].types[j] == "country") {
                  $scope.countryname = place.address_components[i].long_name;
                  // console.log($scope.countryname);
                }
                if (
                  place.address_components[i].types[j] ==
                  "administrative_area_level_2"
                ) {
                  $scope.county_name = place.address_components[i].long_name;
                  // console.log($scope.county_name);
                }
                if (place.address_components[i].types[j] == "locality") {
                  $scope.place_name = place.address_components[i].long_name;
                  // console.log($scope.place_name);
                }
                if (place.address_components[i].types[j] == "postal_code") {
                  document.getElementById("zip").value =
                    place.address_components[i].long_name;
                  $scope.User.ZipCode = place.address_components[i].long_name;
                  // console.log($scope.User.ZipCode);

                  // console.log($scope.User.ZipCode);
                }
              }
            }
          }
        );
      };

      /*
       * this function create 6 digit of password
       **/

      $scope.generatePassword = function () {
        $scope.password = Math.random().toString(36).slice(-8);
        MyService.ConsoleLog("password :", $scope.password);
        $scope.User.Password = $scope.password;
      };

      /*
       * this function Fetch all data of sub counties and cities
       **/

      $scope.getSubCounties = function () {
        $scope.arr = [];
        $scope.dis = false;
        $scope.stateSenate = false;
        $scope.stateHouse = false;
        $scope.federalCong = false;
        // $scope.countyone = false;
        $scope.cityone = false;
        $scope.school = false;
        $scope.federalCongrassionalDist = "";
        $scope.unifiedSchoolDistrictNames = "";
        $scope.stateHouseOFRepresentativeDistricts = "";
        $scope.stateSenateDistrict = "";
        $scope.allsubcounty = "";
        $scope.places = "";
        $scope.address.stateSenateDistrict = "";
        $scope.address.federalCongrassionalDist = "";
        $scope.address.stateHouseOFRepresentativeDistrict = "";
        $scope.address.unifiedSchoolDistrictName = "";

        MyService.ConsoleLog("$scope.state >>>", $scope.User.cur_state);
        MyService.ConsoleLog("$scope.County >>>", $scope.address.county);
        if (
          $scope.User.cur_level == "Local" ||
          $scope.User.cur_level == "Other"
        ) {
          $scope.showLoaderOne = true;
          // $scope.LoaderTwo = false;
        }

        // if($scope.User.cur_state && $scope.address.county == "" ){
        //   alert('if');
        // }else{
        //   alert('else');

        // }

        MyService.getPlacesAndSubCounty(
          $scope.User.cur_state.stateFips,
          $scope.address.county.countyFips,
          $scope.User.cur_state.state
        ).then(
          function (response) {
            MyService.ConsoleLog("response >>", response);

            var sub = response.countySubdivision.filter(function (val) {
              var cmat = val.city.substring(val.city.length - 3);
              if (cmat != "CDP") {
                return val;
              }
            });

            $scope.allsubcounty = sub;

            var plFil = response.places.filter(function (item) {
              MyService.ConsoleLog("item", item);
              var smTxt = item.city.substring(item.city.length - 3);
              if (smTxt != "CDP") {
                return item;
                MyService.ConsoleLog("smTxt >>", smTxt);
              }
            });
            MyService.ConsoleLog("plFil >>", plFil);
            $scope.finArr = $scope.allsubcounty.concat(plFil);
            MyService.ConsoleLog("$scope.arr", $scope.finArr);

            $scope.places = $scope.finArr;
            if ($scope.User.cur_level == "Local") {
              $scope.showLoaderOne = true;

              $scope.getFederal();
            }

            if ($scope.User.cur_level == "Other") {
              // $scope.showLoaderOne = true;

              $scope.getFederal();
            }
          },
          function (error) {
            MyService.ConsoleLog("Error >>", error);
          }
        );
      };

      $scope.getRunningSubCounties = function () {
        MyService.ConsoleLog("$scope.state >>>", $scope.User.state);
        MyService.ConsoleLog("$scope.County >>>", $scope.User.state);
        $scope.running_stateSenate = false;
        $scope.running_stateHouse = false;
        $scope.running_federalCong = false;
        // $scope.running_countyone = false;
        $scope.running_cityone = false;
        $scope.running_school = false;
        $scope.running_showLoader = false;
        $scope.runFederalCongrassionalDist = "";
        $scope.runUnifiedSchoolDistrictNames = "";
        $scope.runStateHouseOFRepresentativeDistricts = "";
        $scope.runStateSenateDistrict = "";
        $scope.runPlaces = "";
        $scope.runAddress.stateSenateDistrict = "";
        $scope.runAddress.federalCongrassionalDist = "";
        $scope.runAddress.stateHouseOFRepresentativeDistrict = "";
        $scope.runAddress.unifiedSchoolDistrictName = "";
        if ($scope.User.level == "Local" || $scope.User.level == "Other") {
          $scope.running_showLoaderOne = true;
        }

        MyService.getPlacesAndSubCounty(
          $scope.User.state.stateFips,
          $scope.runAddress.county.countyFips,
          $scope.User.state.state
        ).then(
          function (response) {
            MyService.ConsoleLog("response >>", response);
            var subRun = response.countySubdivision.filter(function (val) {
              var cmatRun = val.city.substring(val.city.length - 3);
              if (cmatRun != "CDP") {
                return val;
                MyService.ConsoleLog("cmat >>", cmat);
              }
            });

            $scope.allsubcounty = subRun;

            var plFilRun = response.places.filter(function (item) {
              MyService.ConsoleLog("item", item);
              var smTxtRun = item.city.substring(item.city.length - 3);
              if (smTxtRun != "CDP") {
                return item;
                MyService.ConsoleLog("smTxt >>", smTxt);
              }
            });
            // $scope.allsubcounty = ;

            $scope.runPlaces = $scope.allsubcounty.concat(plFilRun);
            if ($scope.User.level == "Local") {
              // $scope.showLoaderOne = true;

              $scope.getRunningFederal();
            }
            if ($scope.User.level == "Other") {
              // $scope.showLoaderOne = true;

              $scope.getRunningFederal();
            }
          },
          function (error) {
            MyService.ConsoleLog("Error >>", error);
          }
        );
      };

      /*
       * this function Fetch all data of statehouse and state senate
       **/
      $scope.getStateHouse = function () {
        MyService.ConsoleLog("State >>", $scope.User.cur_state);
        if ($scope.User.cur_level == "State") {
          $scope.stateSenateDistrict = "";
          $scope.stateHouseOFRepresentativeDistricts = "";
          $scope.stateHouse = false;
          $scope.stateSenate = false;
          $scope.address.stateSenateDistrict = "";
          $scope.address.stateHouseOFRepresentativeDistrict = "";
        }
        MyService.getStateHouseData($scope.User.cur_state).then(
          function (response) {
            MyService.ConsoleLog("Result >", response);
            $scope.stateSenateDistrict = response.allstateSenateDistrict;
            $scope.stateHouseOFRepresentativeDistricts =
              response.allstateLegislativeDistrict;
            if ($scope.User.cur_level == "State") {
              $scope.stateHouse = true;
              $scope.stateSenate = true;
              $scope.showLoader = false;
              $scope.showcur_office_nameDrop = true;
            }
          },
          function (error) {
            MyService.ConsoleLog("Error >>", error);
          }
        );
      };

      $scope.getRunningStateHouse = function () {
        MyService.ConsoleLog("State >>", $scope.User.state);
        if ($scope.User.level == "State") {
          $scope.runStateSenateDistrict = "";
          $scope.runStateHouseOFRepresentativeDistricts = "";
          $scope.running_stateHouse = false;
          $scope.running_stateSenate = false;
          $scope.runAddress.stateSenateDistrict = "";
          $scope.runAddress.stateHouseOFRepresentativeDistrict = "";
        }

        MyService.getStateHouseData($scope.User.state).then(
          function (response) {
            MyService.ConsoleLog("Result >", response);
            $scope.runStateSenateDistrict = response.allstateSenateDistrict;
            $scope.runStateHouseOFRepresentativeDistricts =
              response.allstateLegislativeDistrict;
            if ($scope.User.level == "State") {
              $scope.running_stateHouse = true;
              $scope.running_stateSenate = true;
              $scope.running_showLoader = false;
              $scope.shownew_office_nameDrop = true;
            }
          },
          function (error) {
            MyService.ConsoleLog("Error >>", error);
          }
        );
      };

      /*  $scope.getSubCounties = function() {
        alert("called");
        MyService.ConsoleLog("$scope.state >>>", $scope.address.state);
        MyService.ConsoleLog("$scope.County >>>", $scope.address.county);
        $scope.federalCongrassionalDist = "";
        $scope.unifiedSchoolDistrictNames = "";
        $scope.stateHouseOFRepresentativeDistricts = "";
        $scope.stateSenateDistrict = "";
        $scope.allsubcounty = "";
        $scope.places = "";

        if ($scope.address.state.stateFips != "" && $scope.address.county != "") {
          alert('not');
          MyService.getAllData({ "state": $scope.address.state.stateFips, "county": $scope.address.county.countyFips }).then(function(response) {
            MyService.ConsoleLog("response &&&&& ", response);
            // $scope.places = response;
            $scope.federalCongrassionalDist = response.allfederalCongrassionalDist;
            $scope.unifiedSchoolDistrictNames = response.allschoolDistrict;
            $scope.stateHouseOFRepresentativeDistricts = response.allstateLegislativeDistrict;
            $scope.stateSenateDistrict = response.allstateSenateDistrict;
            $scope.allsubcounty = response.allsubcounty;
            $scope.places = response.allPlaces;
            $scope.showcur_office_name = true;

          }, function(error) {
            MyService.ConsoleLog("Error >>", error);
          });
        }

      };
*/

      /***
       ** function get federal records using places and county geometry
       ***/

      $scope.getFederal = function () {
        // alert("welcome");
        MyService.ConsoleLog("$scope.address >>", $scope.User.cur_state);
        if ($scope.User.cur_level == "Federal") {
          $scope.federalCongrassionalDist = "";
          $scope.stateSenateDistrictOne = "";
          $scope.address.stateSenateDistrict = "";
          $scope.address.federalCongrassionalDist = "";
          $scope.federalCong = false;
          $scope.stateSenate = false;
          $scope.dis = false;
        }

        MyService.getAllcogressionalData($scope.User.cur_state).then(
          function (response) {
            MyService.ConsoleLog("Result >", response);
            if ($scope.User.cur_level == "Federal") {
              $scope.federalCongrassionalDist =
                response.allfederalCongrassionalDist;
              // $scope.stateSenateDistrictOne = response.allstateSenateDistrict;
              $scope.federalCong = true;
              // $scope.stateSenate = true;
              // $scope.dis = true;
              $scope.showcur_office_nameDrop = true;

              $scope.showLoader = false;
            }
            if ($scope.User.cur_level == "Local") {
              $scope.unifiedSchoolDistrictNames = response.allschoolDistrict;

              $scope.cityone = true;
              $scope.school = true;
              $scope.showLoaderOne = false;
              $scope.showcur_office_nameDrop = true;
            }

            if ($scope.User.cur_level == "Other") {
              $scope.federalCongrassionalDist =
                response.allfederalCongrassionalDist;
              $scope.stateSenateDistrict = response.allstateSenateDistrict;
              $scope.stateHouseOFRepresentativeDistricts =
                response.allstateLegislativeDistrict;
              $scope.unifiedSchoolDistrictNames = response.allschoolDistrict;
              $scope.cityone = true;
              $scope.federalCong = true;
              $scope.stateSenate = true;
              $scope.stateHouse = true;
              $scope.school = true;
              $scope.showLoaderOne = false;
              // $scope.showcur_office_nameDrop = true;
            }
          },
          function (error) {
            MyService.ConsoleLog("Error >", error);
          }
        );
      };

      $scope.getRunningFederal = function () {
        // alert("welcome");
        MyService.ConsoleLog("$scope.address >>", $scope.User.state);
        if ($scope.User.level == "Federal") {
          $scope.runFederalCongrassionalDist = "";
          $scope.runStateSenateDistrictOne = "";
          $scope.runAddress.stateSenateDistrict = "";
          $scope.runAddress.federalCongrassionalDist = "";
          $scope.running_federalCong = false;
          $scope.running_stateSenate = false;
          $scope.running_dis = false;
        }

        MyService.getAllcogressionalData($scope.User.state).then(
          function (response) {
            MyService.ConsoleLog("Result >", response);
            if ($scope.User.level == "Federal") {
              $scope.runFederalCongrassionalDist =
                response.allfederalCongrassionalDist;
              // $scope.runStateSenateDistrictOne = response.allstateSenateDistrict;
              $scope.running_federalCong = true;
              // $scope.running_stateSenate = true;
              // $scope.running_dis = true;
              $scope.shownew_office_nameDrop = true;

              $scope.running_showLoader = false;
            }
            if ($scope.User.level == "Local") {
              $scope.runUnifiedSchoolDistrictNames = response.allschoolDistrict;

              $scope.running_cityone = true;
              $scope.running_school = true;
              $scope.running_showLoaderOne = false;
              $scope.shownew_office_nameDrop = true;
            }
            if ($scope.User.level == "Other") {
              $scope.runFederalCongrassionalDist =
                response.allfederalCongrassionalDist;
              $scope.runStateSenateDistrict = response.allstateSenateDistrict;
              $scope.runStateHouseOFRepresentativeDistricts =
                response.allstateLegislativeDistrict;
              $scope.runUnifiedSchoolDistrictNames = response.allschoolDistrict;
              $scope.running_cityone = true;
              $scope.running_federalCong = true;
              $scope.running_stateSenate = true;
              $scope.running_stateHouse = true;
              $scope.running_school = true;
              $scope.running_showLoaderOne = false;
              // $scope.shownew_office_nameDrop = true;
            }
          },
          function (error) {
            MyService.ConsoleLog("Error >", error);
          }
        );
      };
      // end of getFederal

      /***
       ** function get School district based on selected city
       ***/

      /* $scope.getSchool = function() {
         MyService.ConsoleLog("State >>", $scope.User.cur_state);
         MyService.ConsoleLog("City >>", $scope.address.place);

         if ($scope.User.cur_level == "Local" && $scope.address.place !="" ) {
           $scope.LoaderTwo = false;
           // alert('come');
         }


         MyService.getSchool($scope.address.place).then(function(response) {
           MyService.ConsoleLog("Result >", response);
           if ($scope.User.cur_level == "Local") {
             $scope.unifiedSchoolDistrictNames = response;

             // $scope.cityone = true;
             $scope.school = true;
             // $scope.showLoaderOne = false;
             $scope.LoaderTwo = false;


           }

         }, function(error) {
           MyService.ConsoleLog("Error >>", error);
         });

       }
       */
      // End of getSchool

      $scope.checkReadOnly = false;
      $scope.HideRegisterButton = false;
      $scope.onCandidateChange = function (val) {
        //$scope.User.Candidates;
        $scope.checkReadOnly = false;
        $scope.shortEmail = "";
        // alert("onCandidateChange");
        //MyService.ConsoleLog($scope.User.Candidates);
        //MyService.ConsoleLog($scope.User.NCandidates);
        if (val == "incumbent" && $scope.User.Candidates) {
          if (
            $scope.User.Candidates.name &&
            $scope.User.Candidates.name != null
          ) {
            if ($scope.User.Candidates.name != "Other") {
              $scope.User.name = $scope.User.Candidates.name;
              if (
                $scope.User.Candidates.PublicPhoneNumber &&
                $scope.User.Candidates.PublicPhoneNumber != null
              ) {
                $scope.User.phone_no = $scope.User.Candidates.PublicPhoneNumber;
              } else {
                $scope.User.phone_no = "";
              }
              if (
                $scope.User.Candidates.website &&
                $scope.User.Candidates.website != null
              ) {
                $scope.User.web_url = $scope.User.Candidates.website;
              } else {
                $scope.User.web_url = "";
              }
              if (
                $scope.User.Candidates.public_zipcode &&
                $scope.User.Candidates.public_zipcode != null
              ) {
                $scope.User.ZipCode = $scope.User.Candidates.public_zipcode;
              } else {
                $scope.User.ZipCode = "";
              }
              if (
                $scope.User.Candidates.public_mailing_address &&
                $scope.User.Candidates.public_mailing_address != null
              ) {
                $scope.User.mailing_address =
                  $scope.User.Candidates.public_mailing_address;
              } else {
                $scope.User.mailing_address = "";
              }

              if (
                $scope.User.Candidates.email &&
                $scope.User.Candidates.email != null &&
                $scope.User.Candidates.email != 0
              ) {
                $scope.HideRegisterButton = true;
                var email = $scope.User.Candidates.email
                  ? $scope.User.Candidates.email
                  : $scope.User.Candidates.privateEmail;
                // $scope.User.Email = email;
                var cemail = email;
                var firstSix = cemail.substr(0, 6);
                var lastSix = cemail.substr(cemail.length - 6);
                var xlen = cemail.length - 12;
                var xstring = "x".repeat(xlen);
                var finalstring = firstSix + xstring + lastSix;
                $scope.shortEmail = finalstring;
                /*
                var cemail = $scope.User.Candidates.email;
                var firstSix = cemail.substr(0, 6);
                var lastSix = cemail.substr(cemail.length - 6);
                var xlen = cemail.length - 12;
                var xstring = "x".repeat(xlen);
                var finalstring = firstSix + xstring + lastSix;
                $scope.HideRegisterButton = true;
                var msg = "You are already in our system with the email " + finalstring;
                MyService.GetDialogWithButtons(ngDialog, msg, "SignIn", "Please email me my password").then(function(payload) {
                  //MyService.ConsoleLog("Ans<><><>", payload);
                  $scope.User.Email = $scope.User.Candidates.email;
                  $scope.checkReadOnly = true;
                  if (payload == 1) {
                    $location.path("/signin");
                  } else {
                    var postobj = {
                      email: $scope.User.Candidates.email,
                      reset_url: $rootScope.getPasswordResetUrl()
                    };
                    //MyService.ConsoleLog("postobj: ", postobj);

                    MyService.forgotPassword(postobj)
                    .then(function(response) {
                      if (response.data.success) {
                        growl.success("An email has been sent.");
                      } else {
                        if (typeof response.data.error == "string")
                        growl.error(response.data.error);
                        else
                        growl.error("Something went wrong");
                      }
                    }, function(err) {
                      growl.error("Something went wrong");
                    });
                  }
                }, function(errorPayload) {
                  $scope.User.Email = "";
                  //MyService.ConsoleLog("errorPayload<><><>", errorPayload);
                  $scope.checkReadOnly = false;
                  if (errorPayload == 0) {
                    var postobj = {
                      email: $scope.User.Candidates.email,
                      reset_url: $rootScope.getPasswordResetUrl()
                    };
                    //MyService.ConsoleLog("postobj: ", postobj);

                    MyService.forgotPassword(postobj)
                    .then(function(response) {
                      if (response.data.success) {
                        growl.success("An email has been sent.");
                      } else {
                        if (typeof response.data.error == "string")
                        growl.error(response.data.error);
                        else
                        growl.error("Something went wrong");
                      }
                    }, function(err) {
                      growl.error("Something went wrong");
                    });
                  }
                });
                */
              } else {
                $scope.User.Email = "";
                $scope.User.phone_no = "";
                $scope.User.web_url = "";
                $scope.User.ZipCode = "";
                $scope.User.mailing_address = "";
              }
            } else {
              //If candidate is Other
              //MyService.ConsoleLog("Other selected");
            }
          } else {
            $scope.User.name = "";
            $scope.User.phone_no = "";
            $scope.User.web_url = "";
            $scope.User.ZipCode = "";
            $scope.User.mailing_address = "";
          }
        } else {
          //MyService.ConsoleLog("Else 1", $scope.User.NCandidates);
          if ($scope.User.NCandidates) {
            if (
              $scope.User.NCandidates.name &&
              $scope.User.NCandidates.name != null
            ) {
              if ($scope.User.NCandidates.name != "Other") {
                $scope.User.name = $scope.User.NCandidates.name;
                //MyService.ConsoleLog("Other than <><><><<", $scope.User.NCandidates.name);
                if (
                  $scope.User.NCandidates.PublicPhoneNumber &&
                  $scope.User.NCandidates.PublicPhoneNumber != null
                ) {
                  $scope.User.phone_no =
                    $scope.User.NCandidates.PublicPhoneNumber;
                } else {
                  $scope.User.phone_no = "";
                }
                if (
                  $scope.User.NCandidates.website &&
                  $scope.User.NCandidates.website != null
                ) {
                  $scope.User.web_url = $scope.User.NCandidates.website;
                } else {
                  $scope.User.web_url = "";
                }
                if (
                  $scope.User.NCandidates.public_zipcode &&
                  $scope.User.NCandidates.public_zipcode != null
                ) {
                  $scope.User.ZipCode = $scope.User.NCandidates.public_zipcode;
                } else {
                  $scope.User.ZipCode = "";
                }
                if (
                  $scope.User.NCandidates.public_mailing_address &&
                  $scope.User.NCandidates.public_mailing_address != null
                ) {
                  $scope.User.NCandidates =
                    $scope.User.NCandidates.public_mailing_address;
                } else {
                  $scope.User.mailing_address = "";
                }
                //MyService.ConsoleLog("NCandidates<><><>", $scope.User.NCandidates);

                if (
                  ($scope.User.NCandidates.email &&
                    $scope.User.NCandidates.email != null &&
                    $scope.User.NCandidates.email != 0) ||
                  ($scope.User.NCandidates.privateEmail &&
                    $scope.User.NCandidates.privateEmail != null &&
                    $scope.User.NCandidates.privateEmail != 0)
                ) {
                  $scope.HideNewRegisterButton = true;
                  var email = $scope.User.NCandidates.email
                    ? $scope.User.NCandidates.email
                    : $scope.User.NCandidates.privateEmail;
                  // $scope.User.Email = email;
                  var cemail = email;
                  var firstSix = cemail.substr(0, 6);
                  var lastSix = cemail.substr(cemail.length - 6);
                  var xlen = cemail.length - 12;
                  var xstring = "x".repeat(xlen);
                  var finalstring = firstSix + xstring + lastSix;
                  $scope.shortEmail = finalstring;
                  /*
                  var cemail = $scope.User.NCandidates.email;
                  var firstSix = cemail.substr(0, 6);
                  var lastSix = cemail.substr(cemail.length - 6);
                  var xlen = cemail.length - 12;
                  var xstring = "x".repeat(xlen);
                  var finalstring = firstSix + xstring + lastSix;
                  var msg = "You are already in our system with the email " + finalstring;
                  MyService.GetDialogWithButtons(ngDialog, msg, "SignIn", "Please email me my password").then(function(payload) {
                    //MyService.ConsoleLog("Ans<><><>", payload);
                    $scope.User.Email = $scope.User.NCandidates.email;
                    $scope.checkReadOnly = true;
                    if (payload == 1) {
                      $location.path("/signin");
                    } else {
                      var postobj = {
                        email: $scope.User.NCandidates.email,
                        reset_url: $rootScope.getPasswordResetUrl()
                      };
                      //MyService.ConsoleLog("postobj: ", postobj);

                      MyService.forgotPassword(postobj)
                      .then(function(response) {
                        if (response.data.success) {
                          growl.success("An email has been sent.");
                        } else {
                          if (typeof response.data.error == "string")
                          growl.error(response.data.error);
                          else
                          growl.error("Something went wrong");
                        }
                      }, function(err) {
                        growl.error("Something went wrong");
                      });
                    }
                  }, function(errorPayload) {
                    $scope.User.Email = "";
                    //MyService.ConsoleLog("errorPayload<><><>", errorPayload);
                    $scope.checkReadOnly = false;
                    if (errorPayload == 0) {
                      var postobj = {
                        email: $scope.User.NCandidates.email,
                        reset_url: $rootScope.getPasswordResetUrl()
                      };
                      //MyService.ConsoleLog("postobj: ", postobj);

                      MyService.forgotPassword(postobj)
                      .then(function(response) {
                        if (response.data.success) {
                          growl.success("An email has been sent.");
                        } else {
                          if (typeof response.data.error == "string")
                          growl.error(response.data.error);
                          else
                          growl.error("Something went wrong");
                        }
                      }, function(err) {
                        growl.error("Something went wrong");
                      });
                    }
                  });
                  */
                } else {
                  $scope.User.Email = "";
                  $scope.User.phone_no = "";
                  $scope.User.web_url = "";
                  $scope.User.ZipCode = "";
                  $scope.User.mailing_address = "";
                }
              } else {
                //If candidate is Other
                //MyService.ConsoleLog("Other selected");
              }
            } else {
              $scope.User.name = "";
              $scope.User.phone_no = "";
              $scope.User.web_url = "";
              $scope.User.ZipCode = "";
              $scope.User.mailing_address = "";
            }
          }
        }
      };

      $scope.sendPostCard = false;
      $scope.PostcardSend = false;
      $scope.generatePostcard = function () {
        var postCard = Math.random().toString(36).substr(2, 10);

        MyService.checkPostCard({
          postcard: postCard,
        }).then(
          function (payload) {
            //MyService.ConsoleLog("Payload<><><<>",payload);
            var alldata = payload.data;
            //MyService.ConsoleLog("alldata<><><>", alldata);
            var taken = alldata.taken;
            //MyService.ConsoleLog("taken<><><>", taken);
            $scope.PostcardSend = true;
            if (!taken) {
              //MyService.ConsoleLog(taken);
              $scope.User.postCard = postCard.toUpperCase();
            } else {
              //MyService.ConsoleLog(taken);
              //$scope.generatePostcard();
            }
          },
          function (errorPayload) {
            $scope.User.postCard = postCard.toUpperCase();
            //MyService.ConsoleLog("errorPayload<><><<>",errorPayload);
          }
        );
      };

      $scope.submitPostcard = function (data) {
        //MyService.ConsoleLog("confirmPostalCode<><><>", $scope.User.confirmPostalCode);
        if ($scope.User.postCard == $scope.User.confirmPostalCode) {
          $scope.verifiedUser = "true";
          //MyService.ConsoleLog($scope.verifiedUser);
          var message = "Thank you for confirming your account.";
          var modal = ngDialog.openConfirm({
            template:
              "<p>" +
              message +
              '</p>\
              <div class="ngdialog-buttons">\
              <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
              </div>',
            plain: true,
          });
          modal.then(
            function fullfilled(data) {
              //MyService.ConsoleLog("fullfilled: ",data);
            },
            function rejected(data) {
              //MyService.ConsoleLog("rejected: ",data);
            }
          );
        } else {
          $scope.verifiedUser = "true";
          var message =
            "Your postcard code doesn't match with ours. Please try again.";
          var modal = ngDialog.openConfirm({
            template:
              "<p>" +
              message +
              '</p>\
              <div class="ngdialog-buttons">\
              <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
              </div>',
            plain: true,
          });
          modal.then(
            function fullfilled(data) {
              //MyService.ConsoleLog("fullfilled: ",data);
            },
            function rejected(data) {
              //MyService.ConsoleLog("rejected: ",data);
            }
          );
        }
      };

      $scope.checkExists = function () {
        MyService.ConsoleLog("welcome to checkExists");
        // alert('called');
        if ($scope.User.cur_Candidates != "" && !$scope.User.name_on_ballot) {
          MyService.ConsoleLog("inside");
          $scope.User.name_on_ballot = $scope.User.cur_Candidates
            ? $scope.User.cur_Candidates
            : "";
        }
      };

      $scope.closeEdit = function (col) {
        // alert("here");
        // MyService.ConsoleLog("%$$$:",col);
        // MyService.ConsoleLog(" $scope.autocomplete_options => ", $scope.autocomplete_options);

        var nval = JSON.parse(col.value);
        // MyService.ConsoleLog("value for auto :",nval);
        $scope.User.Candidates = nval;
        $scope.User.cur_Candidates = nval.name;
        $scope.User.cur_office_name = nval.office;
        $scope.User.cur_office_email = nval.publicEmail;
        $scope.User.postCard = nval.postCard;
        $scope.User.cur_office_phone = nval.publicPhoneNumber;
        $scope.User.cur_office_website = nval.website;
        if ($scope.User.cur_office_name != "") {
          $scope.showcur_office_name = true;
        }
        $scope.User.cur_office_location = nval.officePlace;
        if ($scope.User.cur_office_location != "") {
          $scope.showcur_office_location = true;
        }
        $scope.User.from_date = nval.fromDate;
        $scope.User.end_date = nval.endDate;
        $scope.User.Email = nval.email ? nval.email : nval.privateEmail;
        $scope.User.name_on_ballot = nval.name;

        if (!$scope.User.Email) {
          //alert("here");
          $scope.sendPostCard = true;
        }

        //MyService.ConsoleLog("Email:::", $scope.User.Email);
        // var result = document.getElementsByClassName("ac-container");
        //MyService.ConsoleLog(result);
        // result[0].blur();
        document
          .getElementById("curCandidate")
          .getElementsByTagName("input")[0]
          .blur();
        $scope.onCandidateChange("incumbent");
        //var nval = col.value? col.value: col.displayName
      };

      function suggest_name(term) {
        var q = term.toLowerCase().trim();
        var results = [];
        var len = $scope.candidates.length;
        // Find first 10 states that start with `term`.
        for (var i = 0; i < len && results.length < 10; i++) {
          var name = $scope.candidates[i].name;
          var matched = name.match(new RegExp(q, "i"));
          //MyService.ConsoleLog(state.match())
          //MyService.ConsoleLog(matched);
          //MyService.ConsoleLog(state.match(q, "i"));
          if (matched) {
            results.push({
              label: $sce.trustAsHtml(name),
              value: JSON.stringify($scope.candidates[i]),
            });
          }
        }
        return results;
      }

      function highlight(str, term) {
        MyService.ConsoleLog("str<><><><", str);
        var highlight_regex = new RegExp("(" + term + ")", "gi");
        return str.replace(
          highlight_regex,
          '<span class="highlight">$1</span>'
        );
      }

      var prefuzzySearch = "";

      function fuzzy_suggest(term) {
        // alert('preFuzzy_suggest');
        if (!term) return [];
        if ($scope.User.cur_level == "President") {
          MyService.getPresident({
            search: term,
          }).then(
            function (results) {
              MyService.ConsoleLog("Result >", results);

              // if (results && results != "") {
              $scope.president = results;
              $scope.president.push({
                name: "Other",
              });
              prefuzzySearch = new Fuse($scope.president, {
                shouldSort: true,
                keys: ["name"],
                caseSensitive: false,
                threshold: 0.4,
              });
              MyService.ConsoleLog("prefuzzySearch >", prefuzzySearch);
              return prefuzzySearch
                .search(term)
                .slice(0, 10)
                .map(function (i) {
                  //MyService.ConsoleLog("I",i);
                  //MyService.ConsoleLog($scope.candidates);
                  //MyService.ConsoleLog(i);
                  var val = i.name;
                  // MyService.ConsoleLog("val:::", val);
                  return {
                    value: JSON.stringify(i),
                    label: $sce.trustAsHtml(
                      highlight(val + "-" + i.office, term)
                    ),
                  };
                });

              // }
            },
            function (error) {
              MyService.ConsoleLog("Error >>", error);
            }
          );
        } else {
          MyService.ConsoleLog("term >>", term);

          MyService.ConsoleLog("got", fuzzySearch);
          return fuzzySearch
            .search(term)
            .slice(0, 10)
            .map(function (i) {
              //MyService.ConsoleLog("I",i);
              //MyService.ConsoleLog($scope.candidates);
              //MyService.ConsoleLog(i);
              var val = i.name;
              MyService.ConsoleLog("val:::", val);
              return {
                value: JSON.stringify(i),
                label: $sce.trustAsHtml(highlight(val + "-" + i.office, term)),
              };
            });
        }
      }

      $scope.autocomplete_options = {
        suggest: fuzzy_suggest,
        on_select: $scope.closeEdit,
      };

      function highlightOff(str, term) {
        MyService.ConsoleLog("str<><><><", str);
        var highlight_regex = new RegExp("(" + term + ")", "gi");
        return str.replace(
          highlight_regex,
          '<span class="highlight">$1</span>'
        );
      }

      function autoFill(term) {
        // alert('preFuzzy_suggest');
        if (!term) return [];

        MyService.ConsoleLog("term >>", term);

        return autoFillOffice
          .search(term)
          .slice(0, 10)
          .map(function (i) {
            //MyService.ConsoleLog("I",i);
            //MyService.ConsoleLog($scope.candidates);
            //MyService.ConsoleLog(i);
            var val = i.officeName;
            // MyService.ConsoleLog("val:::", val);
            return {
              value: JSON.stringify(i),
              label: $sce.trustAsHtml(highlightOff(val, term)),
            };
          });
      }

      $scope.autoFill_options = {
        suggest: autoFill,
        on_select: $scope.closeAutoFill,
      };

      $scope.closeAutoFill = function (col) {
        // alert("here");

        // MyService.ConsoleLog("%$$$:",col);
        // MyService.ConsoleLog(" $scope.autocomplete_options => ", $scope.autocomplete_options);

        var nval = JSON.parse(col.value);
        MyService.ConsoleLog("nval >>", nval);
        $scope.User.office_name = nval.officeName;
        $scope.tempOffice = nval.officeName;
        MyService.ConsoleLog("Office>>", $scope.tempOffice);

        document
          .getElementById("autoOff")
          .getElementsByTagName("input")[0]
          .blur();

        // $scope.onCandidateChange("incumbent");
        //var nval = col.value? col.value: col.displayName
      };

      $scope.setOfficeCur = function () {
        MyService.ConsoleLog("insideone cur >>", $scope.tempOfficeCur);
        MyService.ConsoleLog(
          "$scope.User.cur_office_name >>",
          $scope.User.cur_office_name
        );
        if ($scope.User.cur_office_name && !$scope.tempOfficeCur) {
          $scope.User.cur_office_name = $scope.User.cur_office_name;
        } else {
          $scope.User.cur_office_name = $scope.tempOfficeCur;
        }
      };
      $scope.setOfficeRun = function () {
        MyService.ConsoleLog("insideone >>", $scope.tempOffice);
        if ($scope.User.office_name && !$scope.tempOffice) {
          $scope.User.office_name = $scope.User.office_name;
        } else {
          $scope.User.office_name = $scope.tempOffice;
        }
        // $scope.User.office_name = $scope.tempOffice;

        // MyService.ConsoleLog("$scope.User.cur_office_name >>", $scope.User.cur_office_name);
      };

      function highlightCurOff(str, term) {
        MyService.ConsoleLog("str<><><><", str);
        var highlight_regex = new RegExp("(" + term + ")", "gi");
        return str.replace(
          highlight_regex,
          '<span class="highlight">$1</span>'
        );
      }

      function autoFillCur(term) {
        // alert('preFuzzy_suggest');
        if (!term) return [];

        MyService.ConsoleLog("term >>", term);

        return autoFillCurOffice
          .search(term)
          .slice(0, 10)
          .map(function (i) {
            //MyService.ConsoleLog("I",i);
            //MyService.ConsoleLog($scope.candidates);
            //MyService.ConsoleLog(i);
            var val = i.officeName;
            // MyService.ConsoleLog("val:::", val);
            return {
              value: JSON.stringify(i),
              label: $sce.trustAsHtml(highlightCurOff(val, term)),
            };
          });
      }

      $scope.autoFillCur_options = {
        suggest: autoFillCur,
        on_select: $scope.closeAutoFillCur,
      };

      $scope.closeAutoFillCur = function (col) {
        // alert("here");

        // MyService.ConsoleLog("%$$$:",col);
        // MyService.ConsoleLog(" $scope.autocomplete_options => ", $scope.autocomplete_options);

        var nval = JSON.parse(col.value);
        MyService.ConsoleLog("nval >>", nval);
        // $scope.User.office_name = nval.officeName;
        $scope.tempOfficeCur = nval.officeName;
        // MyService.ConsoleLog("Office>>", $scope.User.office_name);
        // $scope.
        document
          .getElementById("autoFillText")
          .getElementsByTagName("input")[0]
          .blur();
        // $scope.onCandidateChange("incumbent");
        //var nval = col.value? col.value: col.displayName
      };

      // MyService.ConsoleLog(" $scope.autocomplete_options => ", $scope.autocomplete_options);

      $scope.running_flagShowCandidateDropdown = false;
      $scope.closeEditNew = function (col) {
        // alert("here");
        // MyService.ConsoleLog("got poly data :",col);
        var nval = JSON.parse(col.value);
        MyService.ConsoleLog("got poly data :", nval);
        $scope.User.NCandidates = nval;
        $scope.User.new_Candidates = nval.name;
        $scope.User.office_name = nval.office;
        $scope.User.office_email = nval.email;
        $scope.User.office_phone = nval.publicPhoneNumber;
        $scope.User.office_website = nval.website;
        if ($scope.User.cur_office_name != "") {
          $scope.showcur_office_name = true;
        }
        $scope.User.office_location = nval.officePlace;

        if ($scope.User.cur_office_location != "") {
          $scope.showcur_office_location = true;
        }

        $scope.User.from_date = nval.fromDate;
        $scope.User.end_date = nval.endDate;
        $scope.User.Email = nval.email ? nval.email : nval.privateEmail;
        $scope.User.name_on_ballot = nval.name;
        // alert($scope.User.Email);
        if (!$scope.User.Email) {
          //alert("here=", $scope.User.Email);
          $scope.sendPostCardNew = true;
        }

        //MyService.ConsoleLog("Email:::", $scope.User.Email);
        // var result = document.getElementsByClassName("ac-container");
        //MyService.ConsoleLog(result);
        // result[0].blur();

        document
          .getElementById("curCandidate")
          .getElementsByTagName("input")[0]
          .blur();
        $scope.onCandidateChange("running");
        //var nval = col.value? col.value: col.displayName
      };

      $scope.HideNewRegisterButton = false;
      $scope.shownew_office_name = false;
      $scope.checkExistsNew = function () {
        //MyService.ConsoleLog($scope.User.new_Candidates);
        MyService.ConsoleLog(
          "name_on_ballot<><><><>",
          $scope.User.name_on_ballot
        );
        if (
          $scope.User.new_Candidates != "" &&
          $scope.User.new_Candidates != $scope.User.name_on_ballot
        ) {
          //MyService.ConsoleLog("inside");
          $scope.User.name_on_ballot = $scope.User.new_Candidates;
        }

        if (!$scope.User.NCandidates) {
          //alert("NCandidates");
          $scope.shownew_office_name = true;
        }
      };

      function fuzzy_suggest_new(term) {
        if ($scope.User.level == "President") {
          MyService.getPresident({
            search: term,
          }).then(
            function (results) {
              MyService.ConsoleLog("Result >", results);

              if (results && results != "") {
                prefuzzySearch = new Fuse(results, {
                  shouldSort: true,
                  keys: ["name"],
                  caseSensitive: false,
                  threshold: 0.4,
                });
                MyService.ConsoleLog("prefuzzySearch >", prefuzzySearch);
                return prefuzzySearch
                  .search(term)
                  .slice(0, 10)
                  .map(function (i) {
                    //MyService.ConsoleLog("I",i);
                    //MyService.ConsoleLog($scope.candidates);
                    //MyService.ConsoleLog(i);
                    var val = i.name;
                    // MyService.ConsoleLog("val:::", val);
                    return {
                      value: JSON.stringify(i),
                      label: $sce.trustAsHtml(
                        highlight(val + "-" + i.office, term)
                      ),
                    };
                  });
              }
            },
            function (error) {
              MyService.ConsoleLog("Error >>", error);
            }
          );
        } else {
          if (!term) return [];
          //MyService.ConsoleLog(fuzzySearch);
          return fuzzySearch
            .search(term)
            .slice(0, 10)
            .map(function (i) {
              //MyService.ConsoleLog("I",i);
              //MyService.ConsoleLog($scope.candidates);
              //MyService.ConsoleLog(i);
              var val = i.name;
              //MyService.ConsoleLog("val:::", val);
              return {
                value: JSON.stringify(i),
                label: $sce.trustAsHtml(highlight(val + "-" + i.office, term)),
              };
            });
        }
      }

      $scope.autocomplete_new_options = {
        suggest: fuzzy_suggest_new,
        on_select: $scope.closeEditNew,
      };
      $scope.allPoliticians = [];

      function suggest_politician_name(term) {
        var results = [];
        for (var i = 0; i < $scope.allPoliticians.length; i++) {
          results.push({
            label: $sce.trustAsHtml(
              $scope.allPoliticians[i].name +
                "-" +
                $scope.allPoliticians[i].office
            ),
            value: JSON.stringify($scope.allPoliticians[i]),
          });
        }
        return results;
      }

      function suggest_politician_name_remote(term) {
        var deferred = $q.defer();
        var params = new Object();
        params.term = term;
        $scope.allPoliticians.length = 0;
        var request = apiCall.apiCall("GET", "/politician/fuzzySearch", params);
        // request.timeout = canceler;
        $http(request).then(
          function successCallback(response) {
            MyService.ConsoleLog("Got Politician: ", response);
            $scope.allPoliticians = response.data.data;
            /*
            if (response.data.success) {
              deferred.resolve(response.data.data);
            } else {
              deferred.reject(response.data);
            }
            */
            deferred.resolve(suggest_politician_name(term));
          },
          function errorCallBack(response) {
            deferred.reject(response);
          }
        );
        return deferred.promise;
      }

      $scope.onCandidateChangePolitician = function (val) {
        //$scope.User.Candidates;
        $scope.checkReadOnly = false;

        //MyService.ConsoleLog($scope.User.name_on_ballot);
        if ($scope.User.name_on_ballot) {
          if (
            $scope.User.name_on_ballot.name &&
            $scope.User.name_on_ballot.name != null
          ) {
            if ($scope.User.name_on_ballot.name != "Other") {
              $scope.User.name = $scope.User.name_on_ballot.name;
              if (
                $scope.User.name_on_ballot.PublicPhoneNumber &&
                $scope.User.name_on_ballot.PublicPhoneNumber != null
              ) {
                $scope.User.phone_no =
                  $scope.User.name_on_ballot.PublicPhoneNumber;
              } else {
                $scope.User.phone_no = "";
              }
              if (
                $scope.User.name_on_ballot.website &&
                $scope.User.name_on_ballot.website != null
              ) {
                $scope.User.web_url = $scope.User.name_on_ballot.website;
              } else {
                $scope.User.web_url = "";
              }
              if (
                $scope.User.name_on_ballot.public_zipcode &&
                $scope.User.name_on_ballot.public_zipcode != null
              ) {
                $scope.User.ZipCode = $scope.User.name_on_ballot.public_zipcode;
              } else {
                $scope.User.ZipCode = "";
              }
              if (
                $scope.User.name_on_ballot.public_mailing_address &&
                $scope.User.name_on_ballot.public_mailing_address != null
              ) {
                $scope.User.mailing_address =
                  $scope.User.name_on_ballot.public_mailing_address;
              } else {
                $scope.User.mailing_address = "";
              }
              /*
              if ($scope.User.name_on_ballot.email && $scope.User.name_on_ballot.email != null && $scope.User.name_on_ballot.email != 0) {
                var msg = "We already have your email with us.<br> Your Email in our db is : <br> <center>" + $scope.User.name_on_ballot.email + "<center><br> Do you want to use it for registration?"
                MyService.GetDialogWithButtons(ngDialog, msg, "YES", "NO").then(function(payload) {
                  $scope.User.Email = $scope.User.name_on_ballot.email;
                  $scope.checkReadOnly = true;
                }, function(errorPayload) {
                  $scope.User.Email = "";
                  $scope.checkReadOnly = false;
                });
              } else {
                $scope.User.Email = "";
                $scope.User.phone_no = "";
                $scope.User.web_url = "";
                $scope.User.ZipCode = "";
                $scope.User.mailing_address = "";
              }
              */
            } else {
              //If candidate is Other
              //MyService.ConsoleLog("Other selected");
            }
          } else {
            $scope.User.name = "";
            $scope.User.phone_no = "";
            $scope.User.web_url = "";
            $scope.User.ZipCode = "";
            $scope.User.mailing_address = "";
          }
        }
      };
      $scope.politicianSelected = false;
      $scope.selectedPolitician = function (col) {
        // alert("here");
        MyService.ConsoleLog("col", col);
        var nval = JSON.parse(col.value);
        //MyService.ConsoleLog(nval);
        $scope.User.name_on_ballot = nval.name;
        var result = document.getElementsByClassName("ac-container");
        //MyService.ConsoleLog(result);
        result[0].style.display = "none";
        // var wrappedResult = angular.element(result);
        //MyService.ConsoleLog(wrappedResult);
        $scope.politicianSelected = true;
        $scope.onCandidateChangePolitician();
        //var nval = col.value? col.value: col.displayName
      };

      $scope.autocomplete_politician_name = {
        suggest: suggest_politician_name_remote,
        on_select: $scope.selectedPolitician,
      };

      var running_flagCongressional = false;
      var flagCongressional = false;
      $scope.showCongressionalDropdown = function (electionFor) {
        //MyService.ConsoleLog("showCongressionalDropdown");
        if (electionFor == "running") {
          if (
            $scope.User.office_name == "house of representatives" &&
            $scope.User.state
          ) {
            running_flagCongressional = true;
            return true;
          }
          running_flagCongressional = false;
          return false;
        } else if (electionFor == "incumbent") {
          if (
            $scope.User.cur_office_name == "house of representatives" &&
            $scope.User.cur_state
          ) {
            flagCongressional = true;
            return true;
          }
          flagCongressional = false;
          return false;
        }
      };
      var running_flagDist = false;
      var flagDist = false;
      $scope.showDistrictDropdown = function (electionFor) {
        //MyService.ConsoleLog("showDistrictDropdown");
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "judicial district":
              if ($scope.User.state) {
                running_flagDist = true;
                return true;
              }
              // For the District options, do a search through the table currently labelled “2016 Alabama” and Find all Item F’s with item Q as the state selected.
              break;
          }
          running_flagDist = false;
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "judicial district":
              if ($scope.User.cur_state) {
                flagDist = true;
                return true;
              }
              // For the District options, do a search through the table currently labelled “2016 Alabama” and Find all Item F’s with item Q as the state selected.
              break;
          }
          flagDist = false;
          return false;
        }
      };
      var running_flagConty = false;
      var flagConty = false;
      $scope.showCountyDropdown = function (electionFor) {
        //MyService.ConsoleLog("showCountyDropdown");
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "county":
            case "sub county":
            case "city":
              if ($scope.User.state) {
                running_flagConty = true;
                return true;
              }
              break;
            case "local school district":
              var exceptionState = ["AK", "DC", "VA"];
              if (
                $scope.User.state &&
                exceptionState.indexOf($scope.User.state.statePostalCode) == -1
              ) {
                running_flagConty = true;
                return true;
              }
              break;
          }
          running_flagConty = false;
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "county":
            case "sub county":
            case "city":
              if ($scope.User.cur_state) {
                flagConty = true;
                return true;
              }
              break;
            case "local school district":
              var exceptionState = ["AK", "DC", "VA"];
              if (
                $scope.User.cur_state &&
                exceptionState.indexOf($scope.User.cur_state.statePostalCode) ==
                  -1
              ) {
                flagConty = true;
                return true;
              }
              break;
          }
          flagConty = false;
          return false;
        }
      };
      var running_flagSubConty = false;
      var flagSubConty = false;
      $scope.showSubCountyDropdown = function (electionFor) {
        //MyService.ConsoleLog("showSubCountyDropdown");
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "sub county":
              if ($scope.User.state && $scope.User.county) {
                running_flagSubConty = true;
                return true;
              }
              break;
          }
          running_flagSubConty = false;
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "sub county":
              if ($scope.User.cur_state && $scope.User.cur_county) {
                flagSubConty = false;
                return true;
              }
              break;
          }
          flagSubConty = false;
          return false;
        }
      };
      var running_flagLocality = false;
      var flagLocality = false;
      $scope.showLocalityDropdown = function (electionFor) {
        //MyService.ConsoleLog("showLocalityDropdown");
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "city":
              if ($scope.User.state && $scope.User.county) {
                running_flagLocality = true;
                return true;
              }
              // for options, list all unique county subdivision names and place names within the selected county within the selected state
              break;
          }
          running_flagLocality = false;
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "city":
              if ($scope.User.cur_state && $scope.User.cur_county) {
                flagLocality = true;
                return true;
              }
              // for options, list all unique county subdivision names and place names within the selected county within the selected state
              break;
          }
          flagLocality = false;
          return false;
        }
      };
      var running_flagStateSchoolDist = false;
      var flagStateSchoolDist = false;
      $scope.showStateSchoolDistDropdown = function (electionFor) {
        //MyService.ConsoleLog("showStateSchoolDistDropdown");
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "state school board district":
              if ($scope.User.state) {
                running_flagStateSchoolDist = true;
                return true;
              }
              // For the District options,
              //list all item E’s where item Q is the state selected
              break;
          }
          running_flagStateSchoolDist = false;
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "state school board district":
              if ($scope.User.cur_state) {
                flagStateSchoolDist = true;
                return true;
              }
              // For the District options,
              //list all item E’s where item Q is the state selected
              break;
          }
          flagStateSchoolDist = false;
          return false;
        }
      };
      var running_flagLocalSchoolDist = false;
      var flagLocalSchoolDist = false;
      $scope.showLocalSchoolDistDropdown = function (electionFor) {
        //MyService.ConsoleLog("showDistrictDropdown");
        if (electionFor == "running") {
          switch ($scope.User.level) {
            case "local school district":
              if ($scope.User.state) {
                if ($scope.User.state && $scope.localSchoolDistException()) {
                  if ($scope.User.state && $scope.User.county) {
                    running_flagLocalSchoolDist = true;
                    return true;
                  }
                  // For the District options,
                  // results of a search through the table currently labelled “2016 Alabama” and find all AD’s, AF’s  and AH’s  where item Q is the state selected and item S is the “County” selection
                } else if ($scope.User.state) {
                  // for District options
                  // do a search through the table currently labelled “2016 Alabama” and find all AD’s where the item Q is the state selected.
                  running_flagLocalSchoolDist = true;
                  return true;
                }
              }
              break;
          }
          running_flagLocalSchoolDist = false;
          return false;
        } else if (electionFor == "incumbent") {
          switch ($scope.User.cur_level) {
            case "local school district":
              if ($scope.User.cur_state) {
                if (
                  $scope.User.cur_state &&
                  $scope.localSchoolDistException()
                ) {
                  if ($scope.User.cur_state && $scope.User.cur_county) {
                    flagLocalSchoolDist = true;
                    return true;
                  }
                  // For the District options,
                  // results of a search through the table currently labelled “2016 Alabama” and find all AD’s, AF’s  and AH’s  where item Q is the state selected and item S is the “County” selection
                } else if ($scope.User.cur_state) {
                  // for District options
                  // do a search through the table currently labelled “2016 Alabama” and find all AD’s where the item Q is the state selected.
                  flagLocalSchoolDist = true;
                  return true;
                }
              }
              break;
          }
          flagLocalSchoolDist = false;
          return false;
        }
      };

      $scope.congressionalDistricts = [];
      var getAddressOfRunningPoliCanceler = $q.defer();
      $scope.running_flagShowOfficeDropdown = false;
      $scope.flagShowOfficeDropdown = false;
      $scope.showlevelOfGovt = [];
      $scope.onStateChange = function (electionFor) {
        //MyService.ConsoleLog("** onStateChange **", electionFor);
        if (electionFor == "running") {
          //'State and Federal', 'County', 'School', 'Local', 'Judicial'
          switch ($scope.User.level) {
            case "County":
              $scope.showlevelOfGovt = angular.copy($scope.countylevelOfGovt);
              $scope.running_flagShowOfficeDropdown = true;
              break;
            case "State and Federal":
              $scope.showlevelOfGovt = angular.copy($scope.statelevelOfGovt);
              MyService.ConsoleLog(
                " $scope.showlevelof govt :",
                $scope.showlevelOfGovt
              );
              $scope.running_flagShowOfficeDropdown = true;
              break;
            case "School":
              $scope.showlevelOfGovt = angular.copy($scope.schoollevelOfGovt);
              $scope.running_flagShowOfficeDropdown = true;
              break;
            case "Judicial":
              $scope.showlevelOfGovt = angular.copy($scope.judiciallevelOfGovt);
              $scope.running_flagShowOfficeDropdown = true;
              break;
            case "Local":
              $scope.showlevelOfGovt = angular.copy($scope.locallevelOfGovt);
              $scope.running_flagShowOfficeDropdown = true;
              break;
            default:
              $scope.showlevelOfGovt = angular.copy($scope.statelevelOfGovt);
              $scope.running_flagShowOfficeDropdown = false;
              break;
          }
          //MyService.ConsoleLog($scope.User.level);
          /*setTimeout(function() {
            $scope.$apply(function() {
              $scope.showlevelOfGovt = $scope.showlevelOfGovt1;
              //MyService.ConsoleLog($scope.showlevelOfGovt);
              $scope.User.off_name = $scope.showlevelOfGovt[0];
            });
          }, 100);*/
          //$scope.User.off_name = $scope.showlevelOfGovt[0];

          /*
          if ($scope.User.state) {

            switch ($scope.User.level) {
              case 'state':
              if ($scope.User.state) {
                $scope.User.office_name = null;
                //fetch office names for this
                //For the options, do a search through the table currently labelled “2016 Alabama” and Find all Item A’s where the Item D is = "State Postal Code", and item Q is the state selected.  Then add “other” to the end of the list
                $scope.running_offices = [];
                MyService.getAddressOfRunningPoli({
                  StatePostalCode: $scope.User.state.statePostalCode,
                  voterScope: "State Postal Code",
                  return_field: "office",
                  timeout: getAddressOfRunningPoliCanceler.promise
                }).then(function(response) {
                  if (response.data.success == true) {
                    $timeout(function() {
                      $scope.running_offices = response.data.data;
                      $scope.running_offices.push("other");
                      //MyService.ConsoleLog("--- Got offices data ---: ", $scope.running_offices);
                    });
                  } else if (response.data.error && typeof response.data.error == "string") {
                    growl.error('Error: ' + response.data.error);
                  } else {
                    growl.error('Something went wrong.');
                  }
                });
              }
              break;

              case 'judicial district':
              if ($scope.User.state) {
                $scope.User.office_name = null;
                // For the District options, do a search through the table currently labelled “2016 Alabama” and Find all Item F’s with item Q as the state selected.
                MyService.getAddressOfRunningPoli({
                  StatePostalCode: $scope.User.state.statePostalCode,
                  return_field: "JudicialCircuitNumber",
                  timeout: getAddressOfRunningPoliCanceler.promise
                }).then(function(response) {
                  if (response.data.success == true) {
                    $timeout(function() {
                      $scope.running_districts = response.data.data;
                      //MyService.ConsoleLog("--- Got district data ---: ", $scope.running_districts);
                    });
                  } else if (response.data.error && typeof response.data.error == "string") {
                    growl.error('Error: ' + response.data.error);
                  } else {
                    growl.error('Something went wrong.');
                  }
                });
              }
              break;

              case "county":
              case "sub county":
              case "city":
              if ($scope.User.state) {
                $scope.User.office_name = null;
                // For the District options, do a search through the table currently labelled “2016 Alabama” and Find all Item F’s with item Q as the state selected.
                MyService.getAddressOfRunningPoli({
                  StatePostalCode: $scope.User.state.statePostalCode,
                  return_field: "CountyName",
                  timeout: getAddressOfRunningPoliCanceler.promise
                }).then(function(response) {
                  if (response.data.success == true) {
                    $timeout(function() {
                      $scope.running_counties = response.data.data;
                      //MyService.ConsoleLog("--- Got counties data ---: ", $scope.running_counties);
                    });
                  } else if (response.data.error && typeof response.data.error == "string") {
                    growl.error('Error: ' + response.data.error);
                  } else {
                    growl.error('Something went wrong.');
                  }
                });
              }
              break;

              case 'state school board district':
              if ($scope.User.state) {
                $scope.User.office_name = null;
                // do a search through the table currently labelled “2016 Alabama” and list all item E’s where item Q is the state selected.
                MyService.getAddressOfRunningPoli({
                  StatePostalCode: $scope.User.state.statePostalCode,
                  return_field: "StateBoardEducationDistrict",
                  timeout: getAddressOfRunningPoliCanceler.promise
                }).then(function(response) {
                  if (response.data.success == true) {
                    $timeout(function() {
                      $scope.running_stateSchoolDistricts = response.data.data;
                      //MyService.ConsoleLog("--- Got district data ---: ", running_stateSchoolDistricts);
                    });
                  } else if (response.data.error && typeof response.data.error == "string") {
                    growl.error('Error: ' + response.data.error);
                  } else {
                    growl.error('Something went wrong.');
                  }
                });
              }
              break;

              case 'local school district':
              $scope.User.office_name = null;
              if (!$scope.localSchoolDistException()) {
                // /if($scope.User.cur_state && $scope.localSchoolDistException())
                MyService.getAddressOfRunningPoli({
                  StatePostalCode: $scope.User.state.statePostalCode,
                  return_field: "CountyName",
                  timeout: getAddressOfRunningPoliCanceler.promise
                }).then(function(response) {
                  if (response.data.success == true) {
                    $timeout(function() {
                      $scope.running_counties = response.data.data;
                      //MyService.ConsoleLog("--- Got counties data ---: ", $scope.running_counties);
                    });
                  } else if (response.data.error && typeof response.data.error == "string") {
                    growl.error('Error: ' + response.data.error);
                  } else {
                    growl.error('Something went wrong.');
                  }
                });
              } else {
                //for options
                // do a search through the table currently labelled “2016 Alabama” and find all AD’s where the item Q is the state selected.
                MyService.getAddressOfRunningPoli({
                  StatePostalCode: $scope.User.state.statePostalCode,
                  return_field: "UnifiedSchoolDistrictName",
                  timeout: getAddressOfRunningPoliCanceler.promise
                }).then(function(response) {
                  if (response.data.success == true) {
                    $timeout(function() {
                      var tempArr = [];
                      angular.forEach(response.data.data, function(val, key) {
                        tempArr.push({
                          label: val,
                          type: "UnifiedSchoolDistrictName"
                        });
                      });
                      $scope.localSchoolDistricts = tempArr;
                      //MyService.ConsoleLog("--- Got localSchoolDistricts data ---: ", $scope.localSchoolDistricts);
                    });
                  } else if (response.data.error && typeof response.data.error == "string") {
                    growl.error('Error: ' + response.data.error);
                  } else {
                    growl.error('Something went wrong.');
                  }
                });
              }
              break;
            }

            if ($scope.User.office_name) {
              if ($scope.User.state) {
                getAddressOfRunningPoliCanceler.resolve();
                MyService.getAddressOfRunningPoli({
                  StatePostalCode: $scope.User.state.statePostalCode,
                  return_field: "FederalCongressionalDistrict",
                  timeout: getAddressOfRunningPoliCanceler.promise
                }).then(function(response) {
                  if (response.data.success == true) {
                    $timeout(function() {
                      $scope.running_congressionalDistricts = response.data.data;
                      //MyService.ConsoleLog("--- Got congressionalDistricts data ---");
                    });
                  } else if (response.data.error && typeof response.data.error == "string") {
                    growl.error('Error: ' + response.data.error);
                  } else {
                    growl.error('Something went wrong.');
                  }
                });
              }
            }
          } //state selected
          */
          //$scope.User.off_name = $scope.showlevelOfGovt[0];
        } else if (electionFor == "incumbent") {
          /*
          if ($scope.User.cur_state) {
            switch ($scope.User.cur_level) {
              case 'state':
              if ($scope.User.cur_state) {
                $scope.User.cur_office_name = null;
                //fetch office names for this
                //For the options, do a search through the table currently labelled “2016 Alabama” and Find all Item A’s where the Item D is = "State Postal Code", and item Q is the state selected.  Then add “other” to the end of the list
                $scope.offices = [];
                MyService.getAddressOfRunningPoli({
                  StatePostalCode: $scope.User.cur_state.statePostalCode,
                  voterScope: "State Postal Code",
                  return_field: "office",
                  timeout: getAddressOfRunningPoliCanceler.promise
                }).then(function(response) {
                  if (response.data.success == true) {
                    $timeout(function() {
                      $scope.offices = response.data.data;
                      $scope.offices.push("other");
                      //MyService.ConsoleLog("--- Got offices data ---: ", $scope.offices);
                    });
                  } else if (response.data.error && typeof response.data.error == "string") {
                    growl.error('Error: ' + response.data.error);
                  } else {
                    growl.error('Something went wrong.');
                  }
                });
              }
              break;

              case 'judicial district':
              if ($scope.User.cur_state) {
                $scope.User.cur_office_name = null;
                // For the District options, do a search through the table currently labelled “2016 Alabama” and Find all Item F’s with item Q as the state selected.
                MyService.getAddressOfRunningPoli({
                  StatePostalCode: $scope.User.cur_state.statePostalCode,
                  return_field: "JudicialCircuitNumber",
                  timeout: getAddressOfRunningPoliCanceler.promise
                }).then(function(response) {
                  if (response.data.success == true) {
                    $timeout(function() {
                      $scope.districts = response.data.data;
                      //MyService.ConsoleLog("--- Got district data ---: ", $scope.districts);
                    });
                  } else if (response.data.error && typeof response.data.error == "string") {
                    growl.error('Error: ' + response.data.error);
                  } else {
                    growl.error('Something went wrong.');
                  }
                });
              }
              break;

              case "county":
              case "sub county":
              case "city":
              if ($scope.User.cur_state) {
                $scope.User.cur_office_name = null;
                // For the District options, do a search through the table currently labelled “2016 Alabama” and Find all Item F’s with item Q as the state selected.
                MyService.getAddressOfRunningPoli({
                  StatePostalCode: $scope.User.cur_state.statePostalCode,
                  return_field: "CountyName",
                  timeout: getAddressOfRunningPoliCanceler.promise
                }).then(function(response) {
                  if (response.data.success == true) {
                    $timeout(function() {
                      $scope.counties = response.data.data;
                      //MyService.ConsoleLog("--- Got counties data ---: ", $scope.counties);
                    });
                  } else if (response.data.error && typeof response.data.error == "string") {
                    growl.error('Error: ' + response.data.error);
                  } else {
                    growl.error('Something went wrong.');
                  }
                });
              }
              break;

              case 'state school board district':
              if ($scope.User.cur_state) {
                $scope.User.cur_office_name = null;
                // do a search through the table currently labelled “2016 Alabama” and list all item E’s where item Q is the state selected.
                MyService.getAddressOfRunningPoli({
                  StatePostalCode: $scope.User.cur_state.statePostalCode,
                  return_field: "StateBoardEducationDistrict",
                  timeout: getAddressOfRunningPoliCanceler.promise
                }).then(function(response) {
                  if (response.data.success == true) {
                    $timeout(function() {
                      $scope.stateSchoolDistricts = response.data.data;
                      //MyService.ConsoleLog("--- Got district data ---: ", $scope.districts);
                    });
                  } else if (response.data.error && typeof response.data.error == "string") {
                    growl.error('Error: ' + response.data.error);
                  } else {
                    growl.error('Something went wrong.');
                  }
                });
              }
              break;

              case 'local school district':
              if ($scope.User.cur_state) {
                $scope.User.cur_office_name = null;
                if (!$scope.localSchoolDistException()) {
                  // /if($scope.User.cur_state && $scope.localSchoolDistException())
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.cur_state.statePostalCode,
                    return_field: "CountyName",
                    timeout: getAddressOfRunningPoliCanceler.promise
                  }).then(function(response) {
                    if (response.data.success == true) {
                      $timeout(function() {
                        $scope.counties = response.data.data;
                        //MyService.ConsoleLog("--- Got counties data ---: ", $scope.counties);
                      });
                    } else if (response.data.error && typeof response.data.error == "string") {
                      growl.error('Error: ' + response.data.error);
                    } else {
                      growl.error('Something went wrong.');
                    }
                  });
                } else {
                  //for options
                  // do a search through the table currently labelled “2016 Alabama” and find all AD’s where the item Q is the state selected.
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.cur_state.statePostalCode,
                    return_field: "UnifiedSchoolDistrictName",
                    timeout: getAddressOfRunningPoliCanceler.promise
                  }).then(function(response) {
                    if (response.data.success == true) {
                      $timeout(function() {
                        var tempArr = [];
                        angular.forEach(response.data.data, function(val, key) {
                          tempArr.push({
                            label: val,
                            type: "UnifiedSchoolDistrictName"
                          });
                        });
                        $scope.localSchoolDistricts = tempArr;
                        //MyService.ConsoleLog("--- Got localSchoolDistricts data ---: ", $scope.localSchoolDistricts);
                      });
                    } else if (response.data.error && typeof response.data.error == "string") {
                      growl.error('Error: ' + response.data.error);
                    } else {
                      growl.error('Something went wrong.');
                    }
                  });
                }
              }
              break;
            }

            if ($scope.User.cur_office_name) {
              if ($scope.User.cur_state) {
                getAddressOfRunningPoliCanceler.resolve();
                MyService.getAddressOfRunningPoli({
                  StatePostalCode: $scope.User.cur_state.statePostalCode,
                  return_field: "FederalCongressionalDistrict",
                  timeout: getAddressOfRunningPoliCanceler.promise
                }).then(function(response) {
                  if (response.data.success == true) {
                    $timeout(function() {
                      $scope.congressionalDistricts = response.data.data;
                      //MyService.ConsoleLog("--- Got congressionalDistricts data ---");
                    });
                  } else if (response.data.error && typeof response.data.error == "string") {
                    growl.error('Error: ' + response.data.error);
                  } else {
                    growl.error('Something went wrong.');
                  }
                });
              }
            }
          } //state selected
          */
          switch ($scope.User.cur_level) {
            ////'State and Federal', 'County', 'School', 'Local', 'Judicial'
            case "County":
              $scope.showlevelOfGovt = angular.copy($scope.countylevelOfGovt);
              $scope.flagShowOfficeDropdown = true;
              break;
            case "State and Federal":
              $scope.showlevelOfGovt = angular.copy($scope.statelevelOfGovt);
              $scope.flagShowOfficeDropdown = true;
              break;
            case "School":
              $scope.showlevelOfGovt = angular.copy($scope.schoollevelOfGovt);
              $scope.flagShowOfficeDropdown = true;
              break;
            case "Judicial":
              $scope.showlevelOfGovt = angular.copy($scope.judiciallevelOfGovt);
              $scope.flagShowOfficeDropdown = true;
              break;
            case "Local":
              $scope.showlevelOfGovt = angular.copy($scope.locallevelOfGovt);
              $scope.flagShowOfficeDropdown = true;
              break;
            default:
              $scope.showlevelOfGovt = angular.copy($scope.statelevelOfGovt);
              $scope.flagShowOfficeDropdown = true;
              break;
          }
          //MyService.ConsoleLog($scope.showlevelOfGovt);
          //$scope.User.cur_off_name = $scope.showlevelOfGovt[0];
        }
      };
      $scope.onDistrictChange = function (electionFor) {
        //MyService.ConsoleLog("** onDistrictChange **");
        if (electionFor == "running") {
          if ($scope.User.state) {
            switch ($scope.User.level) {
              case "judicial district":
                if ($scope.User.state) {
                  $scope.User.office_name = null;
                  $scope.running_offices = [];
                  //fetch office names for this
                  //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item F is the district selected. Then add “other” to the bottom of the list
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.state.statePostalCode,
                    return_field: "office",
                    JudicialCircuitNumber: $scope.User.district,
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.running_offices = response.data.data;
                        $scope.running_offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.running_offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //state selected
        } else if (electionFor == "incumbent") {
          if ($scope.User.cur_state) {
            //MyService.ConsoleLog("** onDistrictChange **");
            switch ($scope.User.cur_level) {
              case "judicial district":
                if ($scope.User.cur_state) {
                  $scope.User.cur_office_name = null;
                  $scope.offices = [];
                  //fetch office names for this
                  //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item F is the district selected. Then add “other” to the bottom of the list
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.cur_state.statePostalCode,
                    return_field: "office",
                    JudicialCircuitNumber: $scope.User.cur_district,
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.offices = response.data.data;
                        $scope.offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //state selected
        }
      };

      $scope.onCountyChange = function (electionFor) {
        if (electionFor == "running") {
          if ($scope.User.state) {
            //MyService.ConsoleLog("** onCountyChange **");
            switch ($scope.User.level) {
              case "county":
                if ($scope.User.state) {
                  $scope.User.office_name = null;
                  $scope.running_offices = [];
                  //fetch office names for this
                  //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected.  Then add “other” to the bottom of the list
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.state.statePostalCode,
                    CountyName: $scope.User.county,
                    voterScope: "County Name",
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.running_offices = response.data.data;
                        $scope.running_offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.running_offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
              case "sub county":
                if ($scope.User.state && $scope.User.county) {
                  $scope.User.cur_office_name = null;
                  $scope.running_offices = [];
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.state.statePostalCode,
                    CountyName: $scope.User.county,
                    voterScope: "County Name",
                    return_field: "CountySubdivisionName",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.running_subcounties = response.data.data;
                        //MyService.ConsoleLog("--- Got sub counties data ---: ", $scope.running_subcounties);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
              case "city":
                if ($scope.User.state) {
                  $scope.User.office_name = null;
                  // For the options, list all unique county subdivision names and place names within the selected county within the selected state
                  var promiseArr = {
                    counties: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.state.statePostalCode,
                      CountyName: $scope.User.county,
                      return_field: "CountySubdivisionName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                    places: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.state.statePostalCode,
                      CountyName: $scope.User.county,
                      return_field: "PlaceName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                  };

                  $q.all(promiseArr).then(function (response) {
                    //MyService.ConsoleLog("response: ", response);
                    if (
                      response.counties.data.success &&
                      response.places.data.success
                    ) {
                      $timeout(function () {
                        var tempArr = [];
                        angular.forEach(
                          response.counties.data.data,
                          function (val, key) {
                            tempArr.push({
                              label: val,
                              type: "county",
                            });
                          }
                        );
                        angular.forEach(
                          response.places.data.data,
                          function (val, key) {
                            tempArr.push({
                              label: val,
                              type: "place",
                            });
                          }
                        );

                        // tempArr = [{label: "tetst", type: "county"}, {label: "tetst 2", type: "place"}];

                        $scope.running_localities = tempArr;
                        //MyService.ConsoleLog("--- Got localities data ---: ", $scope.running_localities);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;

              case "local school district":
                $scope.User.office_name = null;
                if (!$scope.localSchoolDistException() && $scope.User.county) {
                  // results of a search through the table currently labelled “2016 Alabama” and find all AD’s, AF’s  and AH’s  where item Q is the state selected and item S is the “County” selection
                  var promiseArr = {
                    UnifiedSchoolDistrict: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.state.statePostalCode,
                      CountyName: $scope.county,
                      return_field: "UnifiedSchoolDistrictName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                    ElementarySchoolDistrict: MyService.getAddressOfRunningPoli(
                      {
                        StatePostalCode: $scope.User.state.statePostalCode,
                        CountyName: $scope.county,
                        return_field: "ElementarySchoolDistrictName",
                        timeout: getAddressOfRunningPoliCanceler.promise,
                      }
                    ),
                    SecondarySchoolDistrict: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.state.statePostalCode,
                      CountyName: $scope.county,
                      return_field: "SecondarySchoolDistrictName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                  };

                  $q.all(promiseArr).then(
                    function (response) {
                      //MyService.ConsoleLog("response: ", response);
                      if (
                        response.UnifiedSchoolDistrict.data.success &&
                        response.ElementarySchoolDistrict.data.success &&
                        response.SecondarySchoolDistrict.data.success
                      ) {
                        $timeout(function () {
                          var tempArr = [];
                          angular.forEach(
                            response.UnifiedSchoolDistrict.data.data,
                            function (val, key) {
                              tempArr.push({
                                label: val,
                                type: "UnifiedSchoolDistrictName",
                              });
                            }
                          );
                          angular.forEach(
                            response.ElementarySchoolDistrict.data.data,
                            function (val, key) {
                              tempArr.push({
                                label: val,
                                type: "ElementarySchoolDistrictName",
                              });
                            }
                          );
                          angular.forEach(
                            response.SecondarySchoolDistrict.data.data,
                            function (val, key) {
                              tempArr.push({
                                label: val,
                                type: "SecondarySchoolDistrictName",
                              });
                            }
                          );
                          //MyService.ConsoleLog("$scope.localSchoolDistricts: ", tempArr);
                          $scope.running_localSchoolDistricts = tempArr;
                        });
                      } else {
                        //MyService.ConsoleLog("response: ", response);
                        growl.error("Something went wrong.");
                      }
                    },
                    function (err) {
                      //MyService.ConsoleLog("err: ", err);
                      growl.error("Something went wrong.");
                    }
                  );
                }
                break;
            }
          } //state selected
        } else if (electionFor == "incumbent") {
          if ($scope.User.cur_state) {
            //MyService.ConsoleLog("** onCountyChange **");
            switch ($scope.User.cur_level) {
              case "county":
                if ($scope.User.cur_state) {
                  $scope.User.cur_office_name = null;
                  $scope.offices = [];
                  //fetch office names for this
                  //For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected.  Then add “other” to the bottom of the list
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.cur_state.statePostalCode,
                    CountyName: $scope.User.cur_county,
                    voterScope: "County Name",
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.offices = response.data.data;
                        $scope.offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
              case "sub county":
                if ($scope.User.cur_state && $scope.User.cur_county) {
                  $scope.User.cur_office_name = null;
                  $scope.offices = [];
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.cur_state.statePostalCode,
                    CountyName: $scope.User.cur_county,
                    voterScope: "County Name",
                    return_field: "CountySubdivisionName",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.subcounties = response.data.data;
                        //MyService.ConsoleLog("--- Got sub counties data ---: ", $scope.subcounties);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
              case "city":
                if ($scope.User.cur_state) {
                  $scope.User.cur_office_name = null;
                  // For the options, list all unique county subdivision names and place names within the selected county within the selected state
                  var promiseArr = {
                    counties: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.cur_state.statePostalCode,
                      CountyName: $scope.User.cur_county,
                      return_field: "CountySubdivisionName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                    places: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.cur_state.statePostalCode,
                      CountyName: $scope.User.cur_county,
                      return_field: "PlaceName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                  };

                  $q.all(promiseArr).then(function (response) {
                    //MyService.ConsoleLog("response: ", response);
                    if (
                      response.counties.data.success &&
                      response.places.data.success
                    ) {
                      $timeout(function () {
                        var tempArr = [];
                        angular.forEach(
                          response.counties.data.data,
                          function (val, key) {
                            tempArr.push({
                              label: val,
                              type: "county",
                            });
                          }
                        );
                        angular.forEach(
                          response.places.data.data,
                          function (val, key) {
                            tempArr.push({
                              label: val,
                              type: "place",
                            });
                          }
                        );

                        // tempArr = [{label: "tetst", type: "county"}, {label: "tetst 2", type: "place"}];

                        $scope.localities = tempArr;
                        //MyService.ConsoleLog("--- Got localities data ---: ", $scope.localities);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;

              case "local school district":
                //MyService.ConsoleLog("cur_county : ", $scope.User.cur_county);
                $scope.User.cur_office_name = null;
                if (
                  !$scope.localSchoolDistException() &&
                  $scope.User.cur_county
                ) {
                  // results of a search through the table currently labelled “2016 Alabama” and find all AD’s, AF’s  and AH’s  where item Q is the state selected and item S is the “County” selection
                  var promiseArr = {
                    UnifiedSchoolDistrict: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.cur_state.statePostalCode,
                      CountyName: $scope.cur_county,
                      return_field: "UnifiedSchoolDistrictName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                    ElementarySchoolDistrict: MyService.getAddressOfRunningPoli(
                      {
                        StatePostalCode: $scope.User.cur_state.statePostalCode,
                        CountyName: $scope.cur_county,
                        return_field: "ElementarySchoolDistrictName",
                        timeout: getAddressOfRunningPoliCanceler.promise,
                      }
                    ),
                    SecondarySchoolDistrict: MyService.getAddressOfRunningPoli({
                      StatePostalCode: $scope.User.cur_state.statePostalCode,
                      CountyName: $scope.cur_county,
                      return_field: "SecondarySchoolDistrictName",
                      timeout: getAddressOfRunningPoliCanceler.promise,
                    }),
                  };

                  $q.all(promiseArr).then(
                    function (response) {
                      //MyService.ConsoleLog("response: ", response);
                      if (
                        response.UnifiedSchoolDistrict.data.success &&
                        response.ElementarySchoolDistrict.data.success &&
                        response.SecondarySchoolDistrict.data.success
                      ) {
                        $timeout(function () {
                          var tempArr = [];
                          angular.forEach(
                            response.UnifiedSchoolDistrict.data.data,
                            function (val, key) {
                              tempArr.push({
                                label: val,
                                type: "UnifiedSchoolDistrictName",
                              });
                            }
                          );
                          angular.forEach(
                            response.ElementarySchoolDistrict.data.data,
                            function (val, key) {
                              tempArr.push({
                                label: val,
                                type: "ElementarySchoolDistrictName",
                              });
                            }
                          );
                          angular.forEach(
                            response.SecondarySchoolDistrict.data.data,
                            function (val, key) {
                              tempArr.push({
                                label: val,
                                type: "SecondarySchoolDistrictName",
                              });
                            }
                          );
                          //MyService.ConsoleLog("$scope.localSchoolDistricts: ", tempArr);
                          $scope.localSchoolDistricts = tempArr;
                        });
                      } else {
                        //MyService.ConsoleLog("response: ", response);
                        growl.error("Something went wrong.");
                      }
                    },
                    function (err) {
                      //MyService.ConsoleLog("err: ", err);
                      growl.error("Something went wrong.");
                    }
                  );
                }
                break;
            }
          } //state selected
        }
      };
      $scope.onSubCountyChange = function (electionFor) {
        if (electionFor == "running") {
          if ($scope.User.state) {
            //MyService.ConsoleLog("** onCountyChange **");
            switch ($scope.User.level) {
              case "sub county":
                if (
                  $scope.User.state &&
                  $scope.User.county &&
                  $scope.User.subcounty
                ) {
                  $scope.User.office_name = null;
                  $scope.running_offices = [];
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.state.statePostalCode,
                    CountyName: $scope.User.county,
                    // voterScope: "County Name",
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.running_offices = response.data.data;
                        $scope.running_offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.running_offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //s
        } else {
          if ($scope.User.cur_state) {
            //MyService.ConsoleLog("** onCountyChange **");
            switch ($scope.User.cur_level) {
              case "sub county":
                if (
                  $scope.User.cur_state &&
                  $scope.User.cur_county &&
                  $scope.User.subcounty
                ) {
                  $scope.User.cur_office_name = null;
                  $scope.offices = [];
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.cur_state.statePostalCode,
                    CountyName: $scope.User.cur_county,
                    // voterScope: "County Name",
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.offices = response.data.data;
                        $scope.offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //s
        }
      };
      $scope.onLocalityChange = function (electionFor) {
        //MyService.ConsoleLog("** onLocalityChange **");
        if (electionFor == "running") {
          if ($scope.User.state) {
            switch ($scope.User.level) {
              case "city":
                if (
                  $scope.User.state &&
                  $scope.User.county &&
                  $scope.User.locality
                ) {
                  $scope.User.office_name = null;
                  $scope.running_offices = [];
                  //fetch office names for this
                  // For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected and U or W match the “city” selection.  Then add “other” to the bottom of the list
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.state.statePostalCode,
                    CountyName: $scope.User.county,
                    CountySubdivisionName: $scope.User.locality.label,
                    PlaceName: $scope.User.locality.label,
                    office_for: "place", //this is special case
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.running_offices = response.data.data;
                        $scope.running_offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.running_offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //s
        } else if (electionFor == "incumbent") {
          if ($scope.User.cur_state) {
            switch ($scope.User.cur_level) {
              case "city":
                if (
                  $scope.User.cur_state &&
                  $scope.User.cur_county &&
                  $scope.User.cur_locality
                ) {
                  $scope.User.cur_office_name = null;
                  $scope.offices = [];
                  //fetch office names for this
                  // For the options, do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item S is the county selected and U or W match the “city” selection.  Then add “other” to the bottom of the list
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.cur_state.statePostalCode,
                    CountyName: $scope.User.cur_county,
                    CountySubdivisionName: $scope.User.cur_locality.label,
                    PlaceName: $scope.User.cur_locality.label,
                    office_for: "place", //this is special case
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.offices = response.data.data;
                        $scope.offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //s
        }
      };
      $scope.onStateSchoolDistChange = function (electionFor) {
        //MyService.ConsoleLog("** onStateSchoolDistChange **");
        if (electionFor == "running") {
          if ($scope.User.state) {
            switch ($scope.User.level) {
              case "state school board district":
                if ($scope.User.state && $scope.User.state_school_dist) {
                  $scope.User.office_name = null;
                  $scope.running_offices = [];
                  //fetch office names for this
                  // do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item E is the “District” selection.  Then add “other” to the bottom of the list.
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.state.statePostalCode,
                    StateBoardEducationDistrict: $scope.User.state_school_dist,
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.running_offices = response.data.data;
                        $scope.running_offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.running_offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //s
        } else if (electionFor == "incumbent") {
          if ($scope.User.cur_state) {
            switch ($scope.User.cur_level) {
              case "state school board district":
                if (
                  $scope.User.cur_state &&
                  $scope.User.cur_state_school_dist
                ) {
                  $scope.User.cur_office_name = null;
                  $scope.offices = [];
                  //fetch office names for this
                  // do a search through the table currently labelled “2016 Alabama” and find all A’s where item Q is the state selected and item E is the “District” selection.  Then add “other” to the bottom of the list.
                  MyService.getAddressOfRunningPoli({
                    StatePostalCode: $scope.User.cur_state.statePostalCode,
                    StateBoardEducationDistrict:
                      $scope.User.cur_state_school_dist,
                    return_field: "office",
                    timeout: getAddressOfRunningPoliCanceler.promise,
                  }).then(function (response) {
                    if (response.data.success == true) {
                      $timeout(function () {
                        $scope.offices = response.data.data;
                        $scope.offices.push("other");
                        //MyService.ConsoleLog("--- Got offices data ---: ", $scope.offices);
                      });
                    } else if (
                      response.data.error &&
                      typeof response.data.error == "string"
                    ) {
                      growl.error("Error: " + response.data.error);
                    } else {
                      growl.error("Something went wrong.");
                    }
                  });
                }
                break;
            }
          } //s
        }
      };
      $scope.onLocalSchoolDistChange = function (electionFor) {
        if (electionFor == "running") {
          if ($scope.User.state) {
            //MyService.ConsoleLog("** onLocalSchoolDistChange **");
            switch ($scope.User.level) {
              case "local school district":
                break;
            }
          } //s
        } else if (electionFor == "incumbent") {
          if ($scope.User.cur_state) {
            //MyService.ConsoleLog("** onLocalSchoolDistChange **");
            switch ($scope.User.level) {
              case "local school district":
                break;
            }
          } //s
        }
      };

      $scope.CheckUserName = function () {
        $scope.Errors = [];
        MyService.checkUnm({
          username: $scope.User.UserName,
        }).then(
          function (response) {
            if (response.data.taken == true) {
              //$scope.Errors.push('Oops! Username ' + $scope.User.UserName + ' has already been taken.');
              growl.error(
                "Oops! Username " +
                  $scope.User.UserName +
                  " has already been taken."
              );
            }
          },
          function (err) {
            growl.error("Something went wrong.");
          }
        );
      };

      $scope.SignIn = function () {
        $http
          .post(baseApiUrl + "user/authenticate", {
            username: $scope.User.UserName,
            password: $scope.User.Password,
          })
          .then(
            function (response) {
              if (response.data.success == true) {
                tokenService.saveToken(response.data.token);
                tokenService.saveUserName(response.data.name);
                $http.defaults.headers.common["Authorization"] =
                  tokenService.getToken();
                $rootScope.Auth = true;
                $rootScope.User = tokenService.getUserName();
                $location.path("debate");
              } else {
                growl.error("Invalid Username or Password. Please try again.");
              }
            },
            function (response) {
              var validataionMsg = "";
              var errors = response.data.error.errors;
              for (var k in errors) {
                if (errors.hasOwnProperty(k)) {
                  var obj = errors[k];
                  if (obj.message !== undefined)
                    validataionMsg += obj.message.replace("Path", "") + "<br/>";
                }
              }
              growl.error(validataionMsg);
            }
          );
      };

      $scope.generatePostUserObj = function () {
        console.log("dates", $scope.User.from_date);
        if ($.fn.validateForceFully($("#addPoli")) == true) {
          $scope.Errors = [];

          var mainLocation = JSON.stringify({
            longitude: $scope.lon ? $scope.lon : $scope.longg,
            latitude: $scope.lati ? $scope.lati : $scope.latt,
          });

          MyService.ConsoleLog("latitude and longitude :", mainLocation);
          MyService.ConsoleLog("luser :", $scope.User.cur_level);
          MyService.ConsoleLog("$scope.UserType :", $scope.UserType);

          if ($scope.UserType == "advocate") {
            // alert("welcome");
            var mainAddress = JSON.stringify({
              state: $scope.state,
              statePostalCode: $scope.statePostalCode
                ? $scope.statePostalCode
                : $scope.astatePostalCode,
              place: $scope.place_name ? $scope.place_name : $scope.aplace,
              county: $scope.county_name ? $scope.county_name : $scope.acounty,
              country: $scope.countryname
                ? $scope.countryname
                : $scope.acountry,
              countySubdivision: $scope.address.countySubdivision
                ? $scope.address.countySubdivision._id.countySubdivision
                : $scope.acountySubdivision,
              federalCongrassionalDist: $scope.address.federalCongrassionalDist
                ? $scope.address.federalCongrassionalDist
                    .federalCongrassionalDist
                : "",
              stateSenateDistrict: $scope.address.stateSenateDistrict
                ? $scope.address.stateSenateDistrict.stateSenateDistrict
                : "",
              schoolDistrictFips: $scope.address.unifiedSchoolDistrictName
                ? $scope.address.unifiedSchoolDistrictName.unifiedSchoolDistrict
                : "",
              schoolDistrict: $scope.address.unifiedSchoolDistrictName
                ? $scope.address.unifiedSchoolDistrictName
                    .unifiedSchoolDistrictName
                : "",
              voterDistrictFips: $scope.address.voterDistrict
                ? $scope.address.voterDistrict.voterDistrict
                : "",
              voterDistrict: $scope.address.voterDistrict
                ? $scope.address.voterDistrict.voterDistrictName
                : "",
              legislativeDistrict: $scope.address
                .stateHouseOFRepresentativeDistrict
                ? $scope.stateHouseOFRepresentativeDistrict
                : "",
            });
          } else {
            if ($scope.User.cur_level != "County") {
              // alert("flag");
              $scope.checkFlag = true;
            }

            var mainAddress = JSON.stringify({
              state: $scope.stateName
                ? $scope.stateName
                : $scope.User.cur_state
                ? $scope.User.cur_state.state
                : $scope.User.state.state,
              statePostalCode: $scope.address.state
                ? $scope.address.state.statePostalCode
                : $scope.statePostalCode,
              stateFips: $scope.address.state
                ? $scope.address.state.stateFips
                : "",
              place: $scope.address.place ? $scope.address.place.city : "",
              placeFips: $scope.address.place
                ? $scope.address.place.placeFips
                : "",
              county: $scope.address.county
                ? $scope.address.county.countyName
                : "",
              countyFips: $scope.address.county
                ? $scope.address.county.countyFips
                : "",
              country: $scope.countryname ? $scope.countryname : "",
              countySubdivision: $scope.address.countySubdivision
                ? $scope.address.countySubdivision.countySubdivision
                : "",
              countySubdivisionFips: $scope.address.countySubdivision
                ? $scope.address.countySubdivision.countySubdivisionFips
                : "",
              federalCongrassionalDist: $scope.address.federalCongrassionalDist
                ? $scope.address.federalCongrassionalDist
                    .congressionalDistrictFips
                : "",
              stateSenateDistrict: $scope.address.stateSenateDistrict
                ? $scope.address.stateSenateDistrict.stateSenateDistrictFips
                : "",
              schoolDistrictFips: $scope.address.unifiedSchoolDistrictName
                ? $scope.address.unifiedSchoolDistrictName
                    .unifiedSchoolDistrictFips
                : "",
              schoolDistrict: $scope.address.unifiedSchoolDistrictName
                ? $scope.address.unifiedSchoolDistrictName.unifiedSchoolDistrict
                : "",
              voterDistrictFips: $scope.address.voterDistrict
                ? $scope.address.voterDistrict.voterDistrict
                : "",
              voterDistrict: $scope.address.voterDistrict
                ? $scope.address.voterDistrict.voterDistrictName
                : "",
              legislativeDistrict: $scope.address
                .stateHouseOFRepresentativeDistrict
                ? $scope.address.stateHouseOFRepresentativeDistrict
                    .stateSenateDistrict
                : "",
            });

            var poliAddress = JSON.stringify({
              state: $scope.User.cur_state
                ? $scope.User.cur_state.state
                : $scope.User.state.state,
              statePostalCode: $scope.User.cur_state
                ? $scope.User.cur_state.statePostalCode
                : "",
              stateFips: $scope.User.cur_state
                ? $scope.User.cur_state.stateFips
                : "",
              place: $scope.address.place ? $scope.address.place.city : "",
              placeFips: $scope.address.place
                ? $scope.address.place.placeFips
                : "",
              county: $scope.address.county
                ? $scope.address.county.countyName
                : "",
              countyFips: $scope.address.county
                ? $scope.address.county.countyFips
                : "",
              country: $scope.countryname
                ? $scope.countryname
                : $scope.acountry,
              countySubdivision: $scope.address.countySubdivision
                ? $scope.address.countySubdivision.countySubdivision
                : $scope.acountySubdivision,
              countySubdivisionFips: $scope.address.countySubdivision
                ? $scope.address.countySubdivision.countySubdivisionFips
                : "",
              federalCongrassionalDist: $scope.address.federalCongrassionalDist
                ? $scope.address.federalCongrassionalDist
                    .congressionalDistrictFips
                : "",
              stateSenateDistrict: $scope.address.stateSenateDistrict
                ? $scope.address.stateSenateDistrict.stateSenateDistrictFips
                : "",
              schoolDistrictFips: $scope.address.unifiedSchoolDistrictName
                ? $scope.address.unifiedSchoolDistrictName
                    .unifiedSchoolDistrictFips
                : "",
              schoolDistrict: $scope.address.unifiedSchoolDistrictName
                ? $scope.address.unifiedSchoolDistrictName.unifiedSchoolDistrict
                : "",
              voterDistrictFips: $scope.address.voterDistrict
                ? $scope.address.voterDistrict.voterDistrict
                : "",
              voterDistrict: $scope.address.voterDistrict
                ? $scope.address.voterDistrict.voterDistrictName
                : "",
              legislativeDistrict: $scope.address
                .stateHouseOFRepresentativeDistrict
                ? $scope.address.stateHouseOFRepresentativeDistrict
                    .stateHouseofRepresentativesDistrictName
                : "",
            });
            // }
            // if ($scope.User.state && $scope.User.state != "" || $scope.User.cur_state && $scope.User.cur_state != "") {
            var runningPoliInfo = JSON.stringify({
              state: $scope.User.state
                ? $scope.User.state.state
                : $scope.User.cur_state
                ? $scope.User.cur_state.state
                : "",
              statePostalCode: $scope.User.state
                ? $scope.User.state.statePostalCode
                : $scope.User.cur_state
                ? $scope.User.cur_state.statePostalCode
                : "",
              stateFips: $scope.User.state ? $scope.User.state.stateFips : "",
              place: $scope.runAddress.place
                ? $scope.runAddress.place.city
                : $scope.address.place
                ? $scope.address.place.city
                : "",
              placeFips: $scope.runAddress.place
                ? $scope.runAddress.place.placeFips
                : "",
              county: $scope.runAddress.county
                ? $scope.runAddress.county.countyName
                : $scope.address.county
                ? $scope.address.county.countyName
                : "",
              countyFips: $scope.runAddress.county
                ? $scope.runAddress.county.countyFips
                : "",
              country: $scope.countryname
                ? $scope.countryname
                : $scope.acountry,
              countySubdivision: $scope.runAddress.countySubdivision
                ? $scope.runAddress.countySubdivision.countySubdivision
                : $scope.acountySubdivision,
              countySubdivisionFips: $scope.runAddress.countySubdivision
                ? $scope.runAddress.countySubdivision.countySubdivisionFips
                : "",
              federalCongrassionalDist: $scope.runAddress
                .federalCongrassionalDist
                ? $scope.runAddress.federalCongrassionalDist
                    .congressionalDistrictFips
                : $scope.address.federalCongrassionalDist
                ? $scope.address.federalCongrassionalDist
                    .congressionalDistrictFips
                : "",
              stateSenateDistrict: $scope.runAddress.stateSenateDistrict
                ? $scope.runAddress.stateSenateDistrict.stateSenateDistrictFips
                : $scope.address.stateSenateDistrict
                ? $scope.address.stateSenateDistrict.stateSenateDistrictFips
                : "",
              schoolDistrictFips: $scope.runAddress.unifiedSchoolDistrictName
                ? $scope.runAddress.unifiedSchoolDistrictName
                    .unifiedSchoolDistrictFips
                : $scope.address.unifiedSchoolDistrictName
                ? $scope.address.unifiedSchoolDistrictName
                    .unifiedSchoolDistrictFips
                : "",
              schoolDistrict: $scope.runAddress.unifiedSchoolDistrictName
                ? $scope.runAddress.unifiedSchoolDistrictName
                    .unifiedSchoolDistrict
                : $scope.address.unifiedSchoolDistrictName
                ? $scope.address.unifiedSchoolDistrictName.unifiedSchoolDistrict
                : "",
              voterDistrictFips: $scope.runAddress.voterDistrict
                ? $scope.runAddress.voterDistrict.voterDistrict
                : "",
              voterDistrict: $scope.runAddress.voterDistrict
                ? $scope.runAddress.voterDistrict.voterDistrictName
                : "",
              legislativeDistrict: $scope.runAddress
                .stateHouseOFRepresentativeDistrict
                ? $scope.runAddress.stateHouseOFRepresentativeDistrict
                    .stateHouseofRepresentativesDistrictName
                : $scope.address.stateHouseOFRepresentativeDistrict
                ? $scope.address.stateHouseOFRepresentativeDistrict
                    .stateHouseofRepresentativesDistrictName
                : "",
            });
          }

          // }

          // MyService.ConsoleLog("runningPoliInfo >>", runningPoliInfo);
          $scope.chndate = function () {
            MyService.ConsoleLog(
              "$scope.User.runElectionDate >",
              $scope.User.runElectionDate
            );
          };

          if (
            $scope.User.runElectionDate &&
            $scope.User.runElectionDate != ""
          ) {
            // $scope.User.runElectionDate ? $scope.User.runElectionDate : "
            // MyService.ConsoleLog("$scope.User.runElectionDate ", $scope.User.runElectionDate)
            // var eleDate = $scope.User.runElectionDate.toJSON();
            var month = (
              "0" +
              ($scope.User.runElectionDate.getMonth() + 1)
            ).slice(-2);
            var dat = ("0" + $scope.User.runElectionDate.getDate()).slice(-2);
            MyService.ConsoleLog("dat >>", dat);
            var finDate =
              $scope.User.runElectionDate.getFullYear() +
              "-" +
              month +
              "-" +
              dat;
            MyService.ConsoleLog(
              "$scope.User.runElectionDate ",
              $scope.User.runElectionDate.getDate()
            );
            MyService.ConsoleLog(
              "$scope.User.runElectionDate ",
              $scope.User.runElectionDate.getMonth()
            );
            MyService.ConsoleLog(
              "$scope.User.runElectionDate ",
              finDate.toString()
            );
          }

          var postobj = {
            username: $scope.User.UserName,
            password: $scope.User.Password,
            email: $scope.User.Email,
            zipcode: $scope.User.ZipCode,
            type: $scope.UserType,
            postCard: $scope.User.postCard,
            verifiedUser: $scope.verifiedUser,
            verificationCell: $scope.verificationCell,
            verificationCarrier: $scope.verificationCarrier,
            verificationMethod: $scope.verificationMethod,
            verificationurl: $rootScope.getVerificationUrl(),
            address: mainAddress,
            unsubscribeurl: $rootScope.getEmailUnsubscribeUrl(),
            loc: mainLocation,
            mailingAddress: $scope.mailing_Address
              ? $scope.mailing_Address
              : $scope.mailAdd,
            from_date: "",
            end_date: "",
            flagAddPoli: true,
            checkFlag: $scope.checkFlag ? $scope.checkFlag : "",
            publicEmail: $scope.User.cur_office_email
              ? $scope.User.cur_office_email
              : "",
            campaignWebSite: $scope.User.campWeb_url
              ? $scope.User.campWeb_url
              : "",
            run_electionDate: finDate ? finDate : "",
            campaignEmail: $scope.User.campEmail ? $scope.User.campEmail : "",
            cur_office_website: $scope.User.cur_office_website
              ? $scope.User.cur_office_website
              : "",
            cur_office_phone: $scope.User.cur_office_phone
              ? $scope.User.cur_office_phone
              : "",
            campPhone_no: $scope.User.campPhone_no
              ? $scope.User.campPhone_no
              : "",
            office_id: $scope.office_id ? $scope.office_id : "",
          };
          console.log("test type", $scope.UserType);
          MyService.ConsoleLog(
            " my office first >>>>>>>>>> :",
            $scope.User.cur_office_name
          );

          switch ($scope.UserType.toLowerCase()) {
            case "advocate":
              postobj.name = $scope.User.name;
              postobj.position = $scope.User.position;
              postobj.extention_no = $scope.User.extention_no;
              postobj.verification_note = $scope.User.verification_note;
              postobj.typeOfOrg = $scope.User.organization.orgType;
              postobj.empIndNo = $scope.User.organization.empIndNo;
              postobj.officeName = $scope.User.organization_name;
              postobj.officeWebUrl = $scope.User.organization.web_url;
              postobj.officePhoneNumber = $scope.User.organization.phone_no;
              break;

            case "press":
              postobj.name = $scope.User.name + " " + $scope.User.lastname;

              postobj.extention_no = $scope.User.press_extension_no;
              postobj.verification_note = $scope.User.verification_note;
              postobj.typeOfOrg = $scope.User.orgType;
              postobj.empIndNo = $scope.User.empIndNo;
              postobj.officeName = $scope.User.outlet_name;
              postobj.officeWebUrl = $scope.User.outlet_web;
              postobj.officePhoneNumber = $scope.User.outlet_phone_no;

              break;
            case "politician":
              postobj.name_on_ballot = $scope.User.name_on_ballot
                ? $scope.User.name_on_ballot
                : "";
              postobj.name = $scope.User.name;

              postobj.phone_no = $scope.User.phone_no;

              postobj.mailing_address = $scope.User.mailing_address;

              if (
                $scope.User.govtOfficialWebsite &&
                $scope.User.govtOfficialWebsite != ""
              ) {
                postobj.govtOfficialWebsite = $scope.User.govtOfficialWebsite;
              }
              if ($scope.User.Candidates && $scope.User.Candidates._id) {
                postobj.cur_office_id = $scope.User.Candidates._id;
              }
              if ($scope.User.NCandidates && $scope.User.NCandidates._id) {
                postobj.office_id = $scope.User.NCandidates._id;
              }
              if ($scope.User.isInCurrentOffice == 1) {
                try {
                  MyService.ConsoleLog(
                    " my office >>>>>>>>>> :",
                    $scope.User.cur_office_name
                  );

                  if ($scope.User.cur_office_name) {
                    if ($scope.User.cur_office_name.officeName) {
                      if ($scope.User.cur_office_name.officeName == "Other") {
                        MyService.ConsoleLog(
                          "newcur_office_name >",
                          $scope.User.newcur_office_name
                        );
                        postobj.cur_office_name =
                          $scope.User.newcur_office_name;
                      } else {
                        postobj.cur_office_name =
                          $scope.User.cur_office_name.officeName;
                        MyService.ConsoleLog("yes go it");
                      }
                    } else {
                      postobj.cur_office_name = $scope.User.cur_office_name;
                    }
                    // console.log('current office >>>>>>>>>>>>>>>', $scope.User.cur_office_name);
                  } else {
                    if ($filter("isBlankString")($scope.User.cur_office_name)) {
                      growl.error("Current Office name is not selected");
                      return null;
                    } else {
                      if ($scope.User.cur_office_name.officeName) {
                        if ($scope.User.cur_office_name.officeName == "Other") {
                          MyService.ConsoleLog(
                            "newcur_office_name two >",
                            $scope.User.newcur_office_name
                          );
                          postobj.cur_office_name =
                            $scope.User.newcur_office_name;
                        } else {
                          postobj.cur_office_name =
                            $scope.User.cur_office_name.officeName;
                          MyService.ConsoleLog("yes go it");
                        }
                      } else {
                        postobj.cur_office_name = $scope.User.cur_office_name;
                      }
                    }
                  }

                  if ($scope.User.cur_level) {
                    MyService.ConsoleLog(
                      " User.cur_level first >>>>>>> ",
                      $scope.User.cur_level
                    );

                    switch ($scope.User.cur_level) {
                      case "Federal":
                        if (
                          $scope.User.cur_office_name.officeName ==
                          "U.S. Senate"
                        ) {
                          postobj.cur_level = "statePostalCode";
                        } else if (
                          $scope.User.cur_office_name.officeName ==
                          "U.S. Senate"
                        ) {
                          postobj.cur_level = "statePostalCode";
                        } else {
                          postobj.cur_level = "federalCongressionalDistrict";
                        }
                        break;
                      case "Other":
                        if (
                          $scope.User.otherLevel &&
                          $scope.User.otherLevel != ""
                        ) {
                          MyService.ConsoleLog(
                            "User.otherLevel >",
                            $scope.User.otherLevel
                          );
                          postobj.cur_level = "All USA";
                        } else {
                          postobj.cur_level = "All USA";
                        }
                        break;
                      case "State":
                        MyService.ConsoleLog(
                          " $scope.User.cur_office_name first >>>>>>> ",
                          $scope.User.cur_office_name
                        );
                        if (
                          $scope.User.cur_office_name.officeName ==
                          "State Senate"
                        ) {
                          postobj.cur_level = "stateSenateDistrict";
                        } else {
                          postobj.cur_level = "statePostalCode";
                        }
                        MyService.ConsoleLog("check level", postobj.cur_level);
                        break;
                      case "County":
                        postobj.cur_level = "countyName";
                        break;
                      case "Local":
                        if (
                          $scope.address.unifiedSchoolDistrictName &&
                          $scope.address.unifiedSchoolDistrictName
                            .unifiedSchoolDistrict != ""
                        ) {
                          postobj.cur_level = "unifiedSchoolDistrictName";
                        } else {
                          postobj.cur_level = "placeName";
                        }
                        break;
                      case "President":
                        postobj.cur_level = "All USA";
                        break;
                      default:
                        break;
                    }
                  }

                  // if ($scope.User.cur_ElectionDate) {
                  //   postobj.cur_electionDate = $scope.User.cur_ElectionDate ? $scope.User.cur_ElectionDate : "";
                  // }

                  // if ($scope.User.cur_status) {
                  postobj.cur_candidateStatus = "active";
                  // }

                  // if ($scope.User.cur_eleType) {
                  //   postobj.cur_electionType = $scope.User.cur_eleType ? $scope.User.cur_eleType : "";
                  // }

                  /*if($filter("isBlankString")($scope.User.cur_jurisdiction_name)){
                    growl.error("Current jurisdiction name is not selected");
                    return null;
                  }*/

                  // postobj.cur_jurisdiction_name = $scope.User.cur_jurisdiction_name;
                  if ($scope.User.cur_state) {
                    var state = $scope.User.cur_state;
                    //MyService.ConsoleLog(state);
                    //MyService.ConsoleLog(state.state);
                    postobj.cur_state = state.state;
                    postobj.cur_state_postal_code = state.statePostalCode;
                  }

                  if ($scope.User.Candidates) {
                    if (
                      $scope.User.Candidates.FederalCongressionalDistrict &&
                      $scope.User.Candidates.FederalCongressionalDistrict !=
                        null
                    ) {
                      postobj.cur_federal_congrassional_dist =
                        $scope.User.Candidates.FederalCongressionalDistrict;
                    }

                    if (
                      $scope.User.Candidates.JudicialCircuitNumber &&
                      $scope.User.Candidates.JudicialCircuitNumber != null
                    ) {
                      postobj.cur_judicial_circuit_no =
                        $scope.User.Candidates.JudicialCircuitNumber;
                    }

                    if (
                      $scope.User.Candidates.CountyName &&
                      $scope.User.Candidates.CountyName != null
                    ) {
                      postobj.cur_county = $scope.User.Candidates.CountyName;
                    }

                    if (
                      $scope.User.Candidates.CountySubdivisionName &&
                      $scope.User.Candidates.CountySubdivisionName != null
                    ) {
                      postobj.cur_subcounty =
                        $scope.User.Candidates.CountySubdivisionName;
                    }

                    if (
                      $scope.User.Candidates.PlaceName &&
                      $scope.User.Candidates.PlaceName != null
                    ) {
                      postobj.cur_place = $scope.User.Candidates.PlaceName;
                    }

                    if (
                      $scope.User.Candidates.StateBoardEducationDistrict &&
                      $scope.User.Candidates.StateBoardEducationDistrict != null
                    ) {
                      postobj.cur_state_board_education_dist =
                        $scope.User.Candidates.StateBoardEducationDistrict;
                    }

                    if (
                      $scope.User.Candidates.UnifiedSchoolDistrictName &&
                      $scope.User.Candidates.UnifiedSchoolDistrictName != null
                    ) {
                      postobj.cur_unified_school_dist =
                        $scope.User.Candidates.UnifiedSchoolDistrictName;
                    }

                    if (
                      $scope.User.Candidates.ElementarySchoolDistrictName &&
                      $scope.User.Candidates.ElementarySchoolDistrictName !=
                        null
                    ) {
                      postobj.cur_elementary_school_dist =
                        $scope.User.Candidates.ElementarySchoolDistrictName;
                    }

                    if (
                      $scope.User.Candidates.SecondarySchoolDistrictName &&
                      $scope.User.Candidates.SecondarySchoolDistrictName != null
                    ) {
                      postobj.cur_secondary_school_dist =
                        $scope.User.Candidates.SecondarySchoolDistrictName;
                    }
                  }
                } catch (e) {
                  //MyService.ConsoleLog("Exceptoin: ", e);
                  $scope.RegisterButton = false;
                  growl.error("Valid Office Name is required.");
                  return null;
                }
              }

              if ($scope.User.isRunningForEle == 1) {
                if ($scope.User.RunningForOtherOffice == 1) {
                  postobj.cur_office_name = $scope.User.cur_office_name
                    .officeName
                    ? $scope.User.cur_office_name.officeName
                    : $scope.User.cur_office_name;
                  postobj.office_name = $scope.User.cur_office_name.officeName
                    ? $scope.User.cur_office_name.officeName
                    : $scope.User.cur_office_name;
                  postobj.run_candidateStatus = $scope.User.runStatus
                    ? $scope.User.runStatus
                    : "";
                  if ($scope.User.cur_level) {
                    MyService.ConsoleLog(
                      " User.cur_level second >>>>>>> ",
                      $scope.User.cur_level
                    );
                    switch ($scope.User.cur_level) {
                      case "Federal":
                        if ($scope.User.office_name == "U.S. Senate") {
                          postobj.level = "statePostalCode";
                        } else if (
                          $scope.User.office_name.officeName == "U.S. Senate"
                        ) {
                          postobj.level = "statePostalCode";
                        } else {
                          postobj.level = "federalCongressionalDistrict";
                        }
                        break;
                      case "Other":
                        if (
                          $scope.User.otherLevel &&
                          $scope.User.otherLevel != ""
                        ) {
                          MyService.ConsoleLog(
                            "User.otherLevel >",
                            $scope.User.otherLevel
                          );
                          postobj.level = "All USA";
                        } else {
                          postobj.level = "All USA";
                        }
                        break;
                      case "State":
                        MyService.ConsoleLog(
                          "$scope.User.office_name",
                          $scope.User.office_name
                        );
                        if ($scope.User.office_name == "State Senator") {
                          postobj.level = "stateSenateDistrict";
                        } else if (
                          $scope.User.office_name.officeName == "State Senate"
                        ) {
                          postobj.level = "stateSenateDistrict";
                        } else {
                          postobj.level = "statePostalCode";
                        }
                        MyService.ConsoleLog(
                          "check level second",
                          postobj.level
                        );
                        break;
                      case "County":
                        postobj.level = "countyName";
                        break;
                      case "Local":
                        if (
                          $scope.address.unifiedSchoolDistrictName &&
                          $scope.address.unifiedSchoolDistrictName
                            .unifiedSchoolDistrict != ""
                        ) {
                          postobj.level = "unifiedSchoolDistrictName";
                        } else {
                          postobj.level = "placeName";
                        }
                        break;
                      case "President":
                        postobj.level = "All USA";
                        break;
                      default:
                        break;
                    }
                    // postobj.cur_level = $scope.User.cur_level;
                  }
                } else {
                  if (
                    $scope.User.NCandidates &&
                    $scope.User.NCandidates.office
                  ) {
                    if ($scope.User.NCandidates.office) {
                      // if(!$scope.User.NCandidates.office.officeName)
                      if (
                        $scope.User.NCandidates.office.officeName == "Other"
                      ) {
                        postobj.office_name = $scope.User.newoffice_name
                          ? $scope.User.newoffice_name
                          : "";
                      } else {
                        postobj.office_name = $scope.User.NCandidates.office
                          .officeName
                          ? $scope.User.NCandidates.office.officeName
                          : $scope.User.NCandidates.office;
                      }
                    }
                  } else {
                    if ($filter("isBlankString")($scope.User.office_name)) {
                      growl.error("Office name is not selected");
                      return null;
                    } else {
                      if ($scope.User.office_name.officeName == "Other") {
                        postobj.office_name = $scope.User.newoffice_name;
                      } else {
                        postobj.office_name = $scope.User.office_name.officeName
                          ? $scope.User.office_name.officeName
                          : $scope.User.office_name;
                      }
                    }
                  }
                  if ($scope.User.level) {
                    MyService.ConsoleLog(
                      " got lvl of govt :",
                      $scope.User.level
                    );

                    switch ($scope.User.level) {
                      case "Federal":
                        if ($scope.User.office_name == "U.S. Senate") {
                          postobj.level = "statePostalCode";
                        } else if (
                          $scope.User.office_name.officeName == "U.S. Senate"
                        ) {
                          postobj.level = "statePostalCode";
                        } else {
                          postobj.level = "federalCongressionalDistrict";
                        }
                        break;
                      case "Other":
                        if ($scope.User.runOtherLevel) {
                          MyService.ConsoleLog(
                            "$scope.User.runOtherLevel >",
                            $scope.User.runOtherLevel
                          );
                          postobj.level = "All USA";
                        } else {
                          postobj.level = "All USA";
                        }
                        break;
                      case "State":
                        if (
                          $scope.User.office_name.officeName == "State Senator"
                        ) {
                          postobj.level = "stateSenateDistrict";
                        } else if (
                          $scope.User.office_name.officeName == "State Senate"
                        ) {
                          postobj.level = "stateSenateDistrict";
                        } else {
                          postobj.level = "statePostalCode";
                        }
                        break;
                      case "County":
                        postobj.level = "countyName";
                        break;
                      case "Local":
                        if (
                          $scope.runAddress.unifiedSchoolDistrictName &&
                          $scope.runAddress.unifiedSchoolDistrictName
                            .unifiedSchoolDistrict != ""
                        ) {
                          postobj.level = "unifiedSchoolDistrictName";
                        } else {
                          postobj.level = "placeName";
                        }
                        break;
                      case "President":
                        postobj.level = "All USA";
                        break;

                      default:
                        break;
                    }
                  }

                  // if ($scope.User.runElectionDate) {
                  //   postobj.run_electionDate = $scope.User.runElectionDate ? $scope.User.runElectionDate : "";
                  // }

                  if ($scope.User.runStatus) {
                    postobj.run_candidateStatus = $scope.User.runStatus
                      ? $scope.User.runStatus
                      : "";
                  }

                  if ($scope.User.runElecType) {
                    postobj.run_electionType = $scope.User.runElecType
                      ? $scope.User.runElecType
                      : "";
                  }
                }

                try {
                  if ($scope.User.state) {
                    var state = $scope.User.state;
                    postobj.state = state.state;
                    postobj.state_postal_code = state.statePostalCode;
                  }

                  if (
                    $scope.User.NCandidates &&
                    $scope.User.NCandidates.FederalCongressionalDistrict &&
                    $scope.User.NCandidates.FederalCongressionalDistrict != null
                  ) {
                    postobj.federal_congrassional_dist =
                      $scope.User.NCandidates.FederalCongressionalDistrict;
                  }

                  if (
                    $scope.User.NCandidates &&
                    $scope.User.NCandidates.JudicialCircuitNumber &&
                    $scope.User.NCandidates.JudicialCircuitNumber != null
                  ) {
                    postobj.judicial_circuit_no =
                      $scope.User.NCandidates.JudicialCircuitNumber;
                  }

                  if (
                    $scope.User.NCandidates &&
                    $scope.User.NCandidates.CountyName &&
                    $scope.User.NCandidates.CountyName != null
                  ) {
                    postobj.county = $scope.User.NCandidates.CountyName;
                  }

                  if (
                    $scope.User.NCandidates &&
                    $scope.User.NCandidates.CountySubdivisionName &&
                    $scope.User.NCandidates.CountySubdivisionName != null
                  ) {
                    postobj.subcounty =
                      $scope.User.NCandidates.CountySubdivisionName;
                  }

                  if (
                    $scope.User.NCandidates &&
                    $scope.User.NCandidates.PlaceName &&
                    $scope.User.NCandidates.PlaceName != null
                  ) {
                    postobj.place = $scope.User.NCandidates.PlaceName;
                  }

                  if (
                    $scope.User.NCandidates &&
                    $scope.User.NCandidates.StateBoardEducationDistrict &&
                    $scope.User.NCandidates.StateBoardEducationDistrict != null
                  ) {
                    postobj.state_board_education_dist =
                      $scope.User.NCandidates.StateBoardEducationDistrict;
                  }

                  if (
                    $scope.User.NCandidates &&
                    $scope.User.NCandidates.UnifiedSchoolDistrictName &&
                    $scope.User.NCandidates.UnifiedSchoolDistrictName != null
                  ) {
                    postobj.unified_school_dist =
                      $scope.User.NCandidates.UnifiedSchoolDistrictName;
                  }

                  if (
                    $scope.User.NCandidates &&
                    $scope.User.NCandidates.ElementarySchoolDistrictName &&
                    $scope.User.NCandidates.ElementarySchoolDistrictName != null
                  ) {
                    postobj.elementary_school_dist =
                      $scope.User.NCandidates.ElementarySchoolDistrictName;
                  }

                  if (
                    $scope.User.NCandidates &&
                    $scope.User.NCandidates.SecondarySchoolDistrictName &&
                    $scope.User.NCandidates.SecondarySchoolDistrictName != null
                  ) {
                    postobj.secondary_school_dist =
                      $scope.User.NCandidates.SecondarySchoolDistrictName;
                  }
                } catch (e) {
                  $scope.RegisterButton = false;
                  growl.error("Valid office details are required.");
                  return null;
                }
              }
              if ($scope.User.web_url) postobj.web_url = $scope.User.web_url;
              if ($scope.User.facebook_url)
                postobj.fabebook_url = $scope.User.facebook_url;
              break;
          }
          // MyService.ConsoleLog("postobj:::::", postobj);
          if ($scope.User.cur_office_name && $scope.User.office_name) {
            postobj.poliAddress = poliAddress;
            postobj.runningPoliInfo = runningPoliInfo;
          } else if ($scope.User.cur_office_name) {
            postobj.poliAddress = poliAddress;
          } else if ($scope.User.office_name) {
            postobj.runningPoliInfo = runningPoliInfo;
          }
          return postobj;
        } //validation
        else {
          return null;
        }
      };

      $scope.disableRegister = function (opt) {
        if (opt == "P") {
          $scope.RegisterButton = true;
        } else {
          $scope.RegisterButton = false;
        }
      };
      $scope.verificationCode = "";
      $scope.getVerificationCode = function () {
        // $scope.number_exist = false;

        var cell = $scope.User.cellnumber;
        var carrier = $scope.User.carrier;
        // MyService.ConsoleLog(cell);
        // MyService.ConsoleLog(carrier);
        // MyService.ConsoleLog(carrier.domain);

        if (!cell || cell == "") {
          alert("Please enter phone number");
          return;
          //return false;
        }

        if (!carrier || carrier == "") {
          alert("Please select your phone carrier");
          return;
          //return false;
        }

        if (cell && cell != "" && carrier && carrier != "") {
          MyService.ConsoleLog("here");
          if (carrier.domain) {
            $scope.verificationCell = cell;
            $scope.verificationCarrier = carrier.domain;
            MyService.sendVerificationCode({
              cellnumber: cell,
              carrier: carrier.domain,
            }).then(
              function (payload) {
                MyService.ConsoleLog(payload);
                if (payload.data.success) {
                  $scope.verificationCode = payload.data.data;
                } else {
                  $scope.verificationCode = "";
                  // $scope.number_exist = true;

                  $(document).ready(function () {
                    $scope.number_exist = true;
                    setTimeout(function () {
                      $(".alert").alert("close");
                    }, 5000);
                  });
                  // alert("Something went wrong please try agian");
                }
              },
              function (errPayload) {
                $scope.verificationCode = "";
                alert("Something went wrong please try agian");
              }
            );
          }
        }
      };

      $scope.verifySSN = function () {
        //MyService.ConsoleLog("SSN<><><>", $scope.User.ssn);
        var returnval = "";
        if ($scope.User.ssn == "") {
          returnval = "Please enter valid SSN";
        }
        if ($scope.User.name == "") {
          returnval = "Please enter valid name to verify with the SSN";
        }
        if (returnval == "") {
          var aurl =
            "https://personator.melissadata.net/v3/WEB/ContactVerify/doContactVerify";
          aurl += "?id=RyMI8jlzD6dHUApvp_3XRP**";
          aurl += "&ss=" + $scope.User.ssn;
          aurl += "&full=" + $scope.User.name;
          aurl += "&format=JSON";
          // var deferred = $q.defer();
          //var furl = "https://personator.melissadata.net/v3/WEB/ContactVerify/doContactVerify?id=RyMI8jlzD6dHUApvp_3XRP**&cols=GrpCensus,GrpCensus2,GrpGeocode&a1=" + records.address + "&city=" + records.city + "&state=" + records.state + "&postal=" + records.zipcode + "&ctry=US&format=JSON";
          //MyService.ConsoleLog("furl <><>>", furl);
          $http.get(aurl).then(
            function successCallback(response) {
              //$scope.result = "";
              //MyService.ConsoleLog("response<><", response);
              $scope.finddetailsclicked = false;
              if (response.statusText == "OK") {
              }
            },
            function errorCallBack(error) {
              $scope.finddetailsclicked = false;
              //MyService.ConsoleLog(error);
            }
          );
        } else {
          alert(returnval);
        }
      };

      $scope.verifiedUser = "true";
      $scope.verificationMethod = "Email";
      $scope.verificationCell = "";
      $scope.verificationCarrier = "";
      $scope.matchVerficationCode = function (val) {
        //MyService.ConsoleLog("value : ", val);
        //MyService.ConsoleLog($scope.User.verificationCode);
        //MyService.ConsoleLog(val.length);
        $scope.RegisterButton = true;
        $scope.verifiedUser = "true";
        if (val.length == 6 && $scope.verificationCode != "") {
          if ($scope.verificationCode == val) {
            $scope.RegisterButton = false;
            $scope.verifiedUser = "true";
            $scope.verificationMethod = "Cell Phone Number";
          }
        }
      };

      $scope.resetPassword = function () {
        //MyService.ConsoleLog($scope.User.Email);
        //MyService.ConsoleLog($scope.User.cur_office_email);
        var emails = [];
        if ($scope.User.Email && $scope.User.Email != "") {
          if (emails.indexOf($scope.User.Email) == -1) {
            emails.push($scope.User.Email);
          }
        }

        if (
          $scope.User.cur_office_email &&
          $scope.User.cur_office_email != ""
        ) {
          if (emails.indexOf($scope.User.cur_office_email) == -1) {
            emails.push($scope.User.cur_office_email);
          }
        }

        if (emails.length > 0) {
          //MyService.ConsoleLog("emails<><><>", emails);
          MyService.forgotPoliticianPassword({
            email: JSON.stringify(emails),
            reset_url: $rootScope.getPasswordResetUrl(),
          }).then(
            function (payload) {
              //MyService.ConsoleLog("Payload<><><><>", payload);
              if (payload.data.success) {
                alert(payload.data.data);
              } else {
                alert("Something went wrong please try again later");
              }
            },
            function (errorPayload) {
              //MyService.ConsoleLog("Payload<><><><>", errorPayload);
            }
          );
        }
      };

      $scope.CreateUser = function () {
        //MyService.ConsoleLog(" CreateUser : ", $scope.User);
        //MyService.ConsoleLog(" address : ", $scope.address);

        if ($scope.User.ZipCode != "") {
          $scope.showAddressDropDowns($scope.User.ZipCode);
        }

        var postobj = $scope.generatePostUserObj();
        console.log("welcome postobject", postobj);
        // return;
        // MyService.ConsoleLog("postobj: ", postobj);
        if (postobj) {
          // $scope.RegisterButton = true;
          //MyService.ConsoleLog("postData : ", postobj);
          MyService.signUp(postobj).then(
            function (response) {
              //MyService.ConsoleLog("response: ", response);
              $scope.RegisterButton = false;
              if (response.data.success == true) {
                var message = "";
                switch ($scope.UserType.toLowerCase()) {
                  case "politician":
                    message = "Politician added successfully.";
                    break;
                  case "advocate":
                    message = "Advocate added successfully";
                    break;
                }
                growl.info(message);
                $scope.User = {};
                $scope.addPoli.$setUntouched();
                $scope.addPoli.$setPristine();
                $scope.displayDrop = false;
                $scope.displayCounty = false;
                $scope.flagShowStateDropdown = false;
                $scope.shownew_office_name = false;
                $scope.federalCongrassionalDist = "";
                $scope.unifiedSchoolDistrictNames = "";
                $scope.stateHouseOFRepresentativeDistricts = "";
                $scope.stateSenateDistrict = "";
                $scope.allsubcounty = "";
                $scope.places = "";
                $scope.address = {};
                $scope.counties = "";
                // $scope.address.state = "";
                // $scope.address.county = "";
                // $scope.address.countySubdivision ="";
                // $scope.address.place ="";
                $scope.address.federalCongrassionalDist = "";
                $scope.address.stateSenateDistrict = "";
                $scope.address.stateHouseOFRepresentativeDistrict = "";
                $scope.address.unifiedSchoolDistrictName = "";
                // var tempParam = {
                //   username: $scope.User.UserName,
                //   password: $scope.User.Password
                // };
                // //MyService.ConsoleLog("tempParam>>",tempParam);
                // // $rootScope.AuthenticateUser(tempParam);
                // $timeout(function() {
                //   $rootScope.AuthenticateUser(tempParam, "signup");
                // }, 2000);
              } else if (
                response.data.error &&
                typeof response.data.error == "string"
              ) {
                growl.error("Error: " + response.data.error);
              } else {
                growl.error("Something went wrong.");
              }
            },
            function (response) {
              //MyService.ConsoleLog("Signup response: ", response);
              $scope.RegisterButton = false;
              var validataionMsg = "";
              if (
                response.data &&
                response.data.error &&
                response.data.error.errors
              ) {
                var errors = response.data.error.errors;
                for (var k in errors) {
                  if (errors.hasOwnProperty(k)) {
                    //MyService.ConsoleLog(k);
                    var obj = errors[k];
                    if (obj.message !== undefined)
                      validataionMsg +=
                        obj.message.replace("Path", "") + "<br/>";
                  }
                }
                growl.error(validataionMsg);
              }
            }
          );
        }
      };

      $scope.userTypeChanged = function (type) {
        //MyService.ConsoleLog("type : " + type);
        $scope.UserType = type;
        console.log("check type", $scope.UserType);

        $scope.User.organization_name = "";
        $scope.User.organization = null;
        //MyService.ConsoleLog("user type : ", $scope.UserType);
        $("form").validationEngine();
        //MyService.ConsoleLog("validationEngine applied");
      };

      /*
      $scope.suggest_organization = function(term) {
        var q = term.toLowerCase().trim();
        //MyService.ConsoleLog("term: ",term);
        var deferred = $q.defer();

        var postdata = {
          max_records: 5,
          keyword: term,
          type: $scope.UserType.toLowerCase()
        };

        var request = apiCall.apiCall('GET', '/office/list', postdata);
        $http(
          request
        ).then(function successCallback(response) {
          //MyService.ConsoleLog("succss: ",response);
          if(response.data.success){
            angular.forEach(response.data.data, function(val, key){
              response.data.data[key].value = val.title;
              response.data.data[key].label = val.title;
            });
            //MyService.ConsoleLog("got org dtaa: ", response.data.data);
            deferred.resolve(response.data.data);
            // growl.success("Tagged successfully");
          }
          else
          deferred.resolve([]);
          // else{
          //   if(typeof response.data.error == "string")
          //       growl.error(response.data.error);
          //   else
          //       growl.error("Something went wrong");
          // }
        }, function errorCallback(response) {
          // growl.error("Something went wrong");
          deferred.resolve([]);
        });

        return deferred.promise;
      }
      */

      function getOrganisationData(term) {
        var q = term.toLowerCase().trim();
        MyService.ConsoleLog("term: ", term);

        var deferred = $q.defer();

        var postdata = {
          max_records: 5,
          keyword: term,
          type: $scope.UserType.toLowerCase(),
        };

        var request = apiCall.apiCall("GET", "/office/list", postdata);

        $http(request).then(
          function successCallback(response) {
            //MyService.ConsoleLog("succss: ", response);
            if (response.data.success) {
              var returnArr = [];
              angular.forEach(response.data.data, function (val, key) {
                MyService.ConsoleLog("value :", val.title);
                returnArr.push({
                  label: $sce.trustAsHtml(val.title),
                  value: val,
                });
              });
              //MyService.ConsoleLog(returnArr);
              deferred.resolve(returnArr);
              // growl.success("Tagged successfully");
            } else deferred.resolve([]);
            /*else{
              if(typeof response.data.error == "string")
              growl.error(response.data.error);
              else
              growl.error("Something went wrong");
            }*/
          },
          function errorCallback(response) {
            // growl.error("Something went wrong");
            deferred.resolve([]);
          }
        );

        return deferred.promise;
      }

      $scope.org_autocomplete_options = {
        suggest: getOrganisationData,
        on_select: function (selected) {
          MyService.ConsoleLog("selected: ", selected);
          // alert("org");
          // $scope.User.organization_name = selected.label;
          $scope.office_id = selected.value._id;
          $scope.User.organization_name = selected.value.title;
          $scope.User.outlet_name = selected.value.title;
          $scope.User.organization = selected;
          $scope.User.organization.web_url = selected.value.webUrl;
          if (selected.value.contactPerson.phoneNo) {
            $scope.User.organization.phone_no =
              selected.value.contactPerson.phoneNo;
          }

          $scope.User.name = selected.value.contactPerson.name;
          if (selected.value.contactPerson.position) {
            $scope.User.lastname = selected.value.contactPerson.position;
          }
          if (selected.value.contactPerson.position) {
            $scope.User.Email = selected.value.contactPerson.email;
          }
          $scope.User.ZipCode = selected.value.zipcode;

          if (selected.value.mailingAddress) {
            $scope.mailAdd = selected.value.mailingAddress;

            var apiKey = "AIzaSyD1oCVshO67SnASsVVvOoJiAQgl7PvOmxo";
            var addApi =
              "https://maps.googleapis.com/maps/api/geocode/json?address=" +
              selected.value.mailingAddress +
              "&key=" +
              apiKey +
              "";
            $http.get(addApi).then(function (respo) {
              MyService.ConsoleLog(
                "api data :",
                respo.data.results[0].geometry.location
              );
              if (
                respo.data.results[0].geometry.location.lat &&
                respo.data.results[0].geometry.location.lng
              ) {
                $scope.User.Address = selected.value.mailingAddress;

                $scope.latt = respo.data.results[0].geometry.location.lat;
                $scope.longg = respo.data.results[0].geometry.location.lng;
              }
            });
          }

          if (selected.value.address) {
            $scope.acounty = selected.value.address.county;
            MyService.ConsoleLog("county :", $scope.acounty);
            $scope.acountry = selected.value.address.country;
            $scope.acountySubdivision =
              selected.value.address.countySubdivision;
            $scope.aplace = selected.value.address.place;
            $scope.astatePostalCode = selected.value.address.statePostalCode;
          }
        },
        on_detach: function (current_value) {
          MyService.ConsoleLog("on_detach: ", current_value);
          MyService.ConsoleLog("on", $scope.office_id);
          /*try{
            if($scope.User.organization.label != current_value)
            $scope.User.organization = null;
          }
          catch(e){
            $scope.User.organization = null;
          }*/
          $scope.User.organization_name = current_value;
        },
      };

      $scope.political_office_options = {
        suggest: function (term) {
          // return $rootScope.suggest_organization(term, $scope.UserType)
          return $rootScope.suggestPoliticianOffice(term, $scope.UserType);
        },
        on_select: function (selected) {
          //MyService.ConsoleLog("selected: ", selected);
          // $scope.User.organization_name = selected.label;
          $scope.User.office = selected;
        },
        on_detach: function (current_value) {
          //MyService.ConsoleLog("on_detach: ", current_value);
          /*try{
            if($scope.User.organization.label != current_value)
            $scope.User.organization = null;
          }
          catch(e){
            $scope.User.organization = null;
          }*/
          $scope.User.office_name = current_value;
        },
      };

      $scope.political_curroffice_options = {
        suggest: function (term) {
          return $rootScope.suggestPoliticianOffice(term, $scope.UserType);
        },
        on_select: function (selected) {
          MyService.ConsoleLog("selected: ", selected);
          $scope.User.curoffice = selected;
        },
        on_detach: function (current_value) {
          //MyService.ConsoleLog("on_detach: ", current_value);
          /*try{
            if($scope.User.organization.label != current_value)
            $scope.User.organization = null;
          }
          catch(e){
            $scope.User.organization = null;
          }*/
          $scope.User.cur_office_name = current_value;
        },
      };

      $scope.org_jurisdiction_options = {
        suggest: function (term) {
          // return $rootScope.suggest_organization(term, $scope.UserType)
          return $rootScope.suggestJurisdiction(term);
        },
        on_select: function (selected) {
          //MyService.ConsoleLog("selected: ", selected);
          $scope.User.jurisdiction = selected;
        },
        on_detach: function (current_value) {
          //MyService.ConsoleLog("on_detach: ", current_value);
          /*try{
            if($scope.User.organization.label != current_value)
            $scope.User.organization = null;
          }
          catch(e){
            $scope.User.organization = null;
          }*/
          $scope.User.jurisdiction_name = current_value;
        },
      };

      $scope.oldaddress = {
        state: "",
        county: "",
        countySubdivision: "",
        place: "",
      };

      $scope.address = {
        state: "",
        county: "",
        countySubdivision: "",
        place: "",
      };
      $scope.runAddress = {
        state: "",
        county: "",
        countySubdivision: "",
        place: "",
      };

      $scope.getAllStates = function () {
        if ($scope.counties) $scope.counties.length = 0;
        if ($scope.places) $scope.places.length = 0;

        var request = apiCall.apiCall("GET", "/user/getAllStates", {
          country: "",
        });
        $http(request).then(
          function successCallback(response) {
            if (response.data.success) {
              MyService.ConsoleLog("Got States: ", response.data.data);

              $scope.states = response.data.data;
              $scope.states.unshift({
                state: "All State",
                stateFips: "",
                statePostalCode: "All USA",
              });
              MyService.ConsoleLog(" $scope.states: ", $scope.states);
            } else {
              growl.error("Something went wrong.");
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
            growl.error("Something went wrong.");
          }
        );
      };
      $scope.getAllStates();

      var getCountiesCanceler = $q.defer();
      $scope.getCounties = function () {
        // alert("first");
        // MyService.ConsoleLog("$scope.User.cur_state: ", $scope.User.cur_state)
        // MyService.ConsoleLog("old",$scope.oldaddress);
        $scope.counties = "";
        var statePostalCode = "";

        if ($scope.User.cur_state != "") {
          statePostalCode = $scope.User.cur_state.stateFips;
        }

        // MyService.ConsoleLog("selected state", $scope.address.state);

        // MyService.ConsoleLog("lbl", lbl);

        MyService.ConsoleLog("statePostalCode", statePostalCode);

        var request = apiCall.apiCall("POST", "/user/getAllCounties", {
          statePostalCode: statePostalCode,
          timeout: getCountiesCanceler.promise,
        });
        $http(request).then(
          function successCallback(response) {
            if (response.data.success) {
              MyService.ConsoleLog("response", response.data.data);
              $scope.counties = response.data.data;
              console.log("$scope.alllcounties>>", $scope.counties);
              // if (lbl == "new") {
              if ($scope.User.cur_level == "Local") {
                $scope.countyone = true;
                $scope.showLoader = false;
              }

              if ($scope.User.cur_level == "Other") {
                $scope.countyone = true;
                $scope.showLoader = false;
              }

              if ($scope.User.cur_level == "County") {
                $scope.countyone = true;
                $scope.showcur_office_nameDrop = true;
                $scope.showLoader = false;
              }

              // alert('counties');
              $scope.address.county = address.county;
              MyService.ConsoleLog(
                "$scope.address.county >",
                $scope.address.county
              );
              // }
            } else {
              growl.error("Something went wrong.");
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
          }
        );
      };

      $scope.getRunningCounties = function () {
        // alert("first");
        // MyService.ConsoleLog("$scope.User.cur_state: ", $scope.User.cur_state)
        // MyService.ConsoleLog("old",$scope.oldaddress);

        var statePostalCode = "";

        if ($scope.User.state != "") {
          statePostalCode = $scope.User.state.stateFips;
        }

        // MyService.ConsoleLog("selected state", $scope.address.state);

        // MyService.ConsoleLog("lbl", lbl);

        MyService.ConsoleLog("statePostalCode", statePostalCode);

        var request = apiCall.apiCall("POST", "/user/getAllCounties", {
          statePostalCode: statePostalCode,
          timeout: getCountiesCanceler.promise,
        });
        $http(request).then(
          function successCallback(response) {
            if (response.data.success) {
              MyService.ConsoleLog("response", response.data.data);
              $scope.runCounties = response.data.data;
              console.log("$scope.alllcounties>>", $scope.runCounties);
              // if (lbl == "new") {
              if ($scope.User.level == "Local") {
                $scope.running_countyone = true;
                $scope.running_showLoader = false;
              }

              if ($scope.User.level == "Other") {
                $scope.running_countyone = true;
                $scope.running_showLoader = false;
              }

              if ($scope.User.level == "County") {
                $scope.running_countyone = true;
                $scope.shownew_office_nameDrop = true;
                $scope.running_showLoader = false;
              }

              // alert('counties');

              // }
            } else {
              growl.error("Something went wrong.");
            }
          },
          function errorCallBack(response) {
            //MyService.ConsoleLog("Error: ", response);
          }
        );
      };

      var getLocalsCanceler = $q.defer();
      $scope.getLocals = function (lbl) {
        //MyService.ConsoleLog($scope.oldaddress);
        var state = {},
          county = {};

        if (lbl == "cur") {
          state = $scope.User.cur_state;
          county = JSON.parse($scope.User.cur_county);
        } else if (lbl == "new") {
          state.statePostalCode = $scope.oldaddress.state;
          county.county = $scope.oldaddress.county;
        } else {
          state = JSON.parse($scope.User.sel_state);
          county = JSON.parse($scope.User.sel_county);
        }

        //MyService.ConsoleLog("county : ", county);
        getLocalsCanceler.resolve();

        var request = apiCall.apiCall("GET", "/user/getAllSubCountiesLocal", {
          statePostalCode: state.statePostalCode,
          county: county.county,
          timeout: getLocalsCanceler.promise,
        });
        $http(request).then(
          function successCallback(response) {
            if (response.data.success) {
              if (response.data.data) {
                //MyService.ConsoleLog(response.data.data);
                $scope.places = response.data.data;

                if (lbl == "new") {
                  var subcounty = $scope.checksubCounty(
                    $scope.places,
                    $scope.oldaddress.countySubdivision
                  );

                  var places = $scope.checkPlaces(
                    $scope.places,
                    $scope.oldaddress.place
                  );
                  //MyService.ConsoleLog("subcounty<><><", subcounty[0])
                  $scope.address.countySubdivision = subcounty[0];
                  $scope.address.place = places[0];
                }
              }
            } else {
              growl("Something went wrong.");
            }
          },
          function errorCallBack(response) {
            growl("Something went wrong.");
          }
        );
      };

      $scope.emptyOrNull = function (item) {
        return !(
          item.places === null ||
          item.places === "" ||
          item.places === " "
        );
      };

      $scope.$watch("User.isRunningForEle", function (newVal, oldVal) {
        //MyService.ConsoleLog("newVal: ", newVal, "oldVal: ", oldVal);
        if (newVal == 1) {
          if ($scope.User.cur_state) {
            //MyService.ConsoleLog("cur_state set");
            $scope.User.sel_state = $scope.User.cur_state;
          } else {
            //MyService.ConsoleLog("cur_state not set");
          }

          if ($scope.User.cur_office_name) {
            $scope.User.office_name = $scope.User.cur_office_name;
          }
          if ($scope.User.cur_jurisdiction_name) {
            $scope.User.jurisdiction_name = $scope.User.cur_jurisdiction_name;
          }

          if ($scope.User.cur_county)
            $scope.User.sel_county = $scope.User.cur_county;
          if ($scope.User.cur_place)
            $scope.User.sel_place = $scope.User.cur_place;

          //MyService.ConsoleLog("sel_state: ", $scope.User.sel_state);
        }
      });

      function statusChangeCallback(response) {
        //MyService.ConsoleLog(response);
        if (response.status === "connected") {
          getUserInfo();
        } else if (response.status === "not_authorized") {
          growl.info("Please log " + "into this app.");
        } else {
          growl.error("Please log " + "into Facebook.");
        }
      }

      $scope.showZipLoader = false;
      $scope.showAddressDropDown = false;

      $scope.checkState = function (rdata, val) {
        return rdata.filter(function (rdata) {
          //MyService.ConsoleLog(rdata.statePostalCode + "==" + val);
          if (rdata.statePostalCode == val) return rdata;
        });
      };

      $scope.checkCounty = function (rdata, val) {
        MyService.ConsoleLog("County :", rdata);
        MyService.ConsoleLog("County val :", val);
        var sdata = [];
        var len = rdata.length;
        var j = 1;

        for (var i = 0; i < len; i++, j++) {
          var rsdata = rdata[i];
          var gdata = val.filter(function (obj) {
            if (
              rsdata.countyFips == obj.COUNTYFP &&
              rsdata.stateFips == obj.STATEFP
            ) {
              // MyService.ConsoleLog(rdata[i]);
              return rdata[i];
            }
          });
          if (gdata.length > 0) {
            if (sdata.indexOf(rdata[i]) == -1) {
              sdata.push(rdata[i]);
            }
          }

          if (j == len) {
            // MyService.ConsoleLog("gdata > ", sdata);
            return sdata;
          }
        }
      };
      $scope.checksubCounty = function (rdata, val) {
        return rdata.filter(function (rdata) {
          //MyService.ConsoleLog(rdata._id.countySubdivision + "==" + val);
          if (rdata._id.countySubdivision == val) return rdata;
        });
      };
      $scope.checkPlaces = function (rdata, val) {
        return rdata.filter(function (rdata) {
          //MyService.ConsoleLog(rdata.statePostalCode + "==" + val);
          if (rdata._id.place == val) return rdata;
        });
      };
      $scope.detectCode = function (event, zip) {
        //MyService.ConsoleLog(event);
        //MyService.ConsoleLog("keycode : ",event.key);
        if (event.keyCode == 9 && event.key == "Tab") {
          $scope.showAddressDropDowns(zip);
          $(this).blur();
        }
        if (event.keyCode == 13 && event.key == "Enter") {
          $scope.showAddressDropDowns(zip);
          $(this).blur();
        }
      };
      $scope.mainAddress = "";
      $scope.showAddressDropDowns = function (zipcode) {
        $scope.showZipLoader = true;
        var deferred = $q.defer();
        MyService.getOrganizedZipData({
          zipcode: zipcode,
        }).then(
          function (payload) {
            MyService.ConsoleLog(payload);
            if (payload.length > 0) {
              // var finalData = payload.data;
              //MyService.ConsoleLog(payload[0].countySubdivision);
              //MyService.ConsoleLog(payload[0].county);
              //MyService.ConsoleLog(payload[0].place);
              $scope.mainAddress = payload;
              $scope.showZipLoader = false;
              $scope.showAddressDropDown = false;
              $scope.oldaddress.state = payload[0].statePostalCode;
              $scope.oldaddress.county = payload[0].county;
              $scope.oldaddress.countySubdivision =
                payload[0].countySubdivision;
              $scope.oldaddress.place = payload[0].place;
              $scope.getCounties("new");

              $scope.getLocals("new");

              $scope.voterDistricts = payload;
              $scope.federalCongrassionalDist = payload;
              $scope.stateSenateDistrict = payload;
              $scope.stateHouseOFRepresentativeDistricts = payload;
              $scope.unifiedSchoolDistrictNames = payload;
              //$scope.$apply();
              var address = $scope.checkState(
                $scope.states,
                payload[0].statePostalCode
              );
              $scope.address.state = address[0];
              $scope.address.voterDistrict = $scope.voterDistricts[0];
              $scope.address.federalCongrassionalDist =
                $scope.federalCongrassionalDist[0];
              $scope.address.stateSenateDistrict =
                $scope.stateSenateDistrict[0];
              $scope.address.stateHouseOFRepresentativeDistrict =
                $scope.stateHouseOFRepresentativeDistricts[0];
              $scope.address.unifiedSchoolDistrictName =
                $scope.unifiedSchoolDistrictNames[0];
              deferred.resolve();
              //MyService.ConsoleLog("address ; ", address);
            }
          },
          function (errorPayload) {
            $scope.showZipLoader = false;
            growl.error(errorPayload);
            deferred.resolve();
          }
        );
        return deferred.promise;
      };

      // Mellisa data start //
      $scope.findaddress = {
        address: "",
        city: "",
        state: "",
        zipcode: "",
      };
      $scope.result = {
        city: "",
      };

      $scope.checkLength = function (vdata, val) {
        // MyService.ConsoleLog("vdata", vdata);
        if (vdata && vdata.length > 0) {
          var data = vdata.map(function (sub) {
            // MyService.ConsoleLog("SubDivision >>",sub);
            var returnval = "";
            switch (val) {
              case "federalCongrassionalDist":
                returnval = sub.congressionalDistrictFips;
                break;
              case "stateSenateDistrict":
                returnval = sub.stateSenateDistrictFips;
                break;
              case "stateHouseOFRepresentativeDistrict":
                returnval = sub.stateHouseofRepresentativesDistrict;
                break;
              case "unifiedSchoolDistrictName":
                returnval = sub.unifiedSchoolDistrict;
                break;
              case "place":
                returnval = sub.place;
                break;
              case "countySubdivision":
                returnval = sub.countySubdivision;
                break;
              case "county":
                returnval = sub.county;
                break;
              case "state":
                returnval = sub.state;
                break;
              case "default":
                returnval = sub.NAME;
                break;
            }
            return returnval;
          });

          var ndata = $filter("unique")(data);
          if (ndata.length > 1) {
            return "yellowBackground";
          } else {
            return "";
          }
        } else {
          return "";
        }
      };

      $scope.showFindAddress = function () {
        var q = {
          zipcode: $scope.User.ZipCode,
        };
        var addressModal = ngDialog.open({
          template: "app/popups/mellisa_data.html",
          scope: $scope,
          data: q,
        });
        $scope.findaddress.zipcode = $scope.User.ZipCode;
      };

      $scope.finddetailsclicked = false;
      $scope.getDetails = function (records) {
        var error = "";
        if ($scope.findaddress.address == "") {
          error = "Please enter address";
        }
        if (error == "" && $scope.findaddress.city == "") {
          error = "Please enter city";
        }
        if (error == "" && $scope.findaddress.state == "") {
          error = "Please enter state";
        }
        if (error == "" && $scope.findaddress.zipcode == "") {
          error = "Please enter zipcode";
        }

        if (error == "") {
          $scope.finddetailsclicked = true;
          //MyService.ConsoleLog("=============Address==============");
          //MyService.ConsoleLog($scope.findaddress);
          //MyService.ConsoleLog("findaddress<><><>", records);
          var aurl =
            "https://personator.melissadata.net/v3/WEB/ContactVerify/doContactVerify";
          aurl += "?id=RyMI8jlzD6dHUApvp_3XRP**";
          aurl += "&cols=GrpCensus,GrpCensus2,GrpGeocode";
          aurl += "&a1=" + records.address;
          aurl += "&city=" + records.city;
          aurl += "&state=" + records.state;
          aurl += "&postal=" + records.zipcode;
          aurl += "&ctry=US";
          aurl += "&format=JSON";
          // var deferred = $q.defer();
          //var furl = "https://personator.melissadata.net/v3/WEB/ContactVerify/doContactVerify?id=RyMI8jlzD6dHUApvp_3XRP**&cols=GrpCensus,GrpCensus2,GrpGeocode&a1=" + records.address + "&city=" + records.city + "&state=" + records.state + "&postal=" + records.zipcode + "&ctry=US&format=JSON";
          //MyService.ConsoleLog("furl <><>>", furl);
          $http.get(aurl).then(
            function successCallback(response) {
              //$scope.result = "";
              $scope.finddetailsclicked = false;
              if (response.statusText == "OK") {
                var rdata = response.data.Records[0];
                if (rdata) {
                  $scope.result = rdata;
                }
              }
              //MyService.ConsoleLog("response", response);
            },
            function errorCallBack(error) {
              $scope.finddetailsclicked = false;
              //MyService.ConsoleLog(error);
            }
          );
        } else {
          alert(error);
        }
      };
      // $scope.oldAddress = "";
      $scope.checkZipAddress = function (val) {
        // $scope.oldAddress = angular.copy($scope.mainAddress);
        return $scope.mainAddress.filter(function (rdata) {
          //MyService.ConsoleLog("Space:", parseInt(val.CongressionalDistrict));
          if (
            val.CongressionalDistrict == "" ||
            val.CongressionalDistrict == " "
          ) {
            //MyService.ConsoleLog("inside<><><><><>");

            if (
              parseInt(rdata.FIPScounty) == parseInt(val.CountyFIPS) &&
              parseInt(rdata.FIPScountySub) ==
                parseInt(val.CountySubdivisionCode) &&
              parseInt(rdata.stateHouseOFRepresentativeDistrict) ==
                parseInt(val.StateDistrictLower) &&
              parseInt(rdata.stateSenateDistrict) ==
                parseInt(val.StateDistrictUpper) &&
              parseInt(rdata.unifiedSchoolDistrict) ==
                parseInt(val.UnifiedSchoolDistrictCode)
            ) {
              //MyService.ConsoleLog("This is a match");
              return rdata;
            }
          } else {
            if (
              parseInt(rdata.FIPScounty) == parseInt(val.CountyFIPS) &&
              parseInt(rdata.FIPScountySub) ==
                parseInt(val.CountySubdivisionCode) &&
              parseInt(rdata.federalCongrassionalDist) ==
                parseInt(val.CongressionalDistrict) &&
              parseInt(rdata.stateHouseOFRepresentativeDistrict) ==
                parseInt(val.StateDistrictLower) &&
              parseInt(rdata.stateSenateDistrict) ==
                parseInt(val.StateDistrictUpper) &&
              parseInt(rdata.unifiedSchoolDistrict) ==
                parseInt(val.UnifiedSchoolDistrictCode)
            ) {
              //MyService.ConsoleLog("This is a match2");
              return rdata;
            }
          }
        });
      };

      $scope.setAddressNew = function () {
        //MyService.ConsoleLog($scope.result);
        var finalResult = $scope.checkZipAddress($scope.result);
        if (finalResult && finalResult.length > 0) {
          //MyService.ConsoleLog("finalResult::::", finalResult);
          // $scope.mainAddress = angular.copy(finalResult);
          $scope.voterDistricts = finalResult;
          $scope.federalCongrassionalDist = finalResult;
          $scope.stateSenateDistrict = finalResult;
          $scope.stateHouseOFRepresentativeDistricts = finalResult;
          $scope.unifiedSchoolDistrictNames = finalResult;
          ngDialog.closeAll();
          // $scope.$apply();
        } else {
          alert(
            "Address not matching with our database. Please enter detail address and try again."
          );
        }
      };

      var previousSelVal = {};
      $scope.setSelectedDropdown = function (
        listData,
        setfor,
        selectedUserAdrs
      ) {
        switch (setfor) {
          case "counties":
            previousSelVal.county = $scope.address.county;
            //MyService.ConsoleLog("selCountyNumber: ",previousSelVal.county);
            $scope.address.county = null;
            if (listData) {
              $scope.counties = listData;
              $scope.counties.unshift({
                number: null,
                name: "none",
              });

              // if(!selectedUserAdrs) selectedUserAdrs.countyFips = previousSelVal.county.number;
              var selCountyNumber = null;
              try {
                $scope.address.county = $scope.counties[0];
                if (selectedUserAdrs) {
                  selCountyNumber = selectedUserAdrs.countyFips;
                }
                if (previousSelVal.county) {
                  selCountyNumber = previousSelVal.county.number;
                }

                if (selCountyNumber) {
                  //MyService.ConsoleLog("selCountyNumber: ",selCountyNumber);
                  angular.forEach($scope.counties, function (val, key) {
                    if (selCountyNumber == val.number)
                      $scope.address.county = val;
                  });
                }
              } catch (e) {
                //MyService.ConsoleLog("Exception: ",e);
              }
            }
            break;
          case "subCounties":
            previousSelVal.subcounty = $scope.address.subcounty;
            $scope.address.subcounty = null;
            if (listData) {
              $scope.subCounties = listData;
              $scope.subCounties.unshift({
                number: null,
                name: "none",
              });
              var selSubCountyNo = null;
              try {
                $scope.address.subcounty = $scope.subCounties[0];
                if (selectedUserAdrs) {
                  selSubCountyNo = selectedUserAdrs.countySubdivisionFips;
                }
                if (previousSelVal.subcounty) {
                  selSubCountyNo = previousSelVal.subcounty.number;
                }
                if (selSubCountyNo) {
                  angular.forEach($scope.subCounties, function (val, key) {
                    //set selected state
                    // if(selectedUserAdrs.countySubdivisionFips == val.number)
                    if (selSubCountyNo == val.number)
                      $scope.address.subcounty = val;
                  });
                }
              } catch (e) {
                //MyService.ConsoleLog("Exception: ",e);
              }
            }
            break;
          case "places":
            previousSelVal.place = $scope.address.place;
            $scope.address.place = null;
            if (listData) {
              $scope.places = listData;
              $scope.places.unshift({
                number: null,
                name: "none",
              });

              try {
                $scope.address.place = $scope.places[0];
                var selPlaceNo = null;
                if (selectedUserAdrs) {
                  selPlaceNo = selectedUserAdrs.placeFips;
                }
                if (previousSelVal.place) {
                  selPlaceNo = previousSelVal.place.number;
                }
                if (selPlaceNo) {
                  angular.forEach($scope.places, function (val, key) {
                    if (selPlaceNo == val.number) $scope.address.place = val;
                  });
                }
              } catch (e) {
                //MyService.ConsoleLog("Exception: ",e);
              }
            }
            break;
          case "voterDistricts":
            if (listData) {
              previousSelVal.voterDistrict = $scope.address.voterDistrict;
              $scope.address.voterDistrict = null;
              $scope.voterDistricts = listData;
              $scope.voterDistricts.unshift({
                number: null,
                name: "none",
              });

              var voterDistrictNo = null;
              try {
                $scope.address.voterDistrict = $scope.voterDistricts[0];
                if (selectedUserAdrs) {
                  voterDistrictNo = selectedUserAdrs.voterDistrictFips;
                }
                if (previousSelVal.voterDistrict) {
                  voterDistrictNo = previousSelVal.voterDistrict.number;
                }

                if (voterDistrictNo) {
                  angular.forEach($scope.voterDistricts, function (val, key) {
                    //set selected
                    if (voterDistrictNo == val.number)
                      $scope.address.voterDistrict = val;
                  });
                }
              } catch (e) {
                //MyService.ConsoleLog("Exception: ",e);
              }
            }
            break;
          case "federalCongrassionalDist":
            $scope.address.federalCongrassionalDist = null;
            if (listData) {
              $scope.federalCongrassionalDist = listData;
              $scope.federalCongrassionalDist.unshift("none");

              if (selectedUserAdrs) {
                $scope.address.federalCongrassionalDist =
                  $scope.federalCongrassionalDist[0];
                angular.forEach(
                  $scope.federalCongrassionalDist,
                  function (val, key) {
                    //set selected state
                    if (selectedUserAdrs.federalCongrassionalDist == val)
                      $scope.address.federalCongrassionalDist = val;
                  }
                );
              }
            }
            break;
          case "stateSenateDistrict":
            $scope.address.stateSenateDistrict = null;
            if (listData) {
              $scope.stateSenateDistrict = listData;
              $scope.stateSenateDistrict.unshift("none");

              $scope.address.stateSenateDistrict =
                $scope.stateSenateDistrict[0];
              if (selectedUserAdrs) {
                angular.forEach(
                  $scope.stateSenateDistrict,
                  function (val, key) {
                    //set selected state
                    if (selectedUserAdrs.stateSenateDistrict == val)
                      $scope.address.stateSenateDistrict = val;
                  }
                );
              }
            }
            break;
          case "stateHouseOFRepresentativeDistrict":
            $scope.address.stateLegislativeDistrict = null;
            if (listData) {
              $scope.stateLegislativeDistrict = listData;
              $scope.stateLegislativeDistrict.unshift("none");
              $scope.address.stateLegislativeDistrict =
                $scope.stateLegislativeDistrict[0];
              if (selectedUserAdrs) {
                angular.forEach(
                  $scope.stateLegislativeDistrict,
                  function (val, key) {
                    //set selected state
                    if (selectedUserAdrs.legislativeDistrict == val)
                      $scope.address.stateLegislativeDistrict = val;
                  }
                );
              }
            }
            break;
          case "schoolDistricts":
            $scope.address.schoolDistrict = null;
            if (listData) {
              $scope.schoolDistricts = listData;
              $scope.schoolDistricts.unshift({
                number: null,
                name: "none",
              });
              $scope.address.schoolDistricts = $scope.schoolDistricts[0];
              if (selectedUserAdrs) {
                angular.forEach($scope.schoolDistricts, function (val, key) {
                  //set selected state
                  if (selectedUserAdrs.schoolDistrictFips == val.number)
                    $scope.address.schoolDistrict = val;
                });
              }
            }
            break;
        }
      };

      if ($scope.UserType == "advocate" || $scope.UserType == "politician") {
        $(document).ready(function () {
          $("#addPoli").validationEngine();
        });
      }
    },
  ]);

"use strict";
angular
  .module("myApp.addFiveMinEssayQues", ["ngRoute"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/addFiveMinEssayQues", {
        templateUrl: "app/addFiveMinEssayQues/addFiveMinEssayQues.html",
        controller: "addFiveMinEssayQuesCtrl",
      });
    },
  ])
  .controller("addFiveMinEssayQuesCtrl", [
    "$scope",
    "$http",
    "$location",
    "apiCall",
    "$routeParams",
    "$rootScope",
    "$q",
    "$timeout",
    "tokenService",
    "MyService",
    "growl",
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $rootScope,
      $q,
      $timeout,
      tokenService,
      MyService,
      growl
    ) {
      $scope.quiz = {
        content: "",
      };

      $scope.isEdit = false;

      if (tokenService.getUserId()) {
        $scope.userId = tokenService.getUserId();
        $scope.userType = tokenService.getUserRole();
      }

      /**
       * @description Function is use to submit essay questions to the rest api.
       */

      $scope.addQuestion = function () {
        if ($scope.userType == "admin" && $scope.quiz.content != "") {
          var params;
          if (!$scope.isEdit) {
            params = {
              content: $scope.quiz.content,
              author: $scope.userId,
              approved: true,
              approvedBy: $scope.userId,
              isUpdate: false,
            };
          } else {
            params = {
              isUpdate: true,
              content: $scope.quiz.content,
              qId: $scope.qId,
            };
          }
          MyService.ConsoleLog("params >> ", params);
          MyService.addFiveMinEssayQuestions(params).then(
            function (APIReponse) {
              $scope.quiz = {
                content: "",
              };
              $scope.isEdit = false;
              $scope.getQuestions();
              growl.success(APIReponse, {
                ttl: 2000,
              });
            },
            function (err) {
              growl.error(err);
            }
          );
        } else {
          growl.error("Please enter question first", {
            ttl: 2000,
          });
        }
      };

      /**
       * @description Function is use to get the list of five minute essay questions
       */

      $scope.getQuestions = function () {
        MyService.getFiveMinEssayQues().then(
          function (APIReponse) {
            $scope.fiveMinQuestion = APIReponse;
            MyService.ConsoleLog(
              "$scope.fiveMinQuestion ",
              $scope.fiveMinQuestion
            );
          },
          function (err) {
            growl.error(err);
          }
        );
      };

      /**
       * @description Function is use to update the content of the question
       * @param {*} val
       * @param {*} index
       */

      $scope.editQeustion = function (val, index) {
        $scope.isEdit = true;
        $scope.quiz.content = val.content;
        $scope.qId = val._id;
      };

      $scope.removeQuestion = function (val, index) {
        var params = {
          qId: val._id,
        };
        MyService.removeEssayQuestion(params).then(function (APIReponse) {
          MyService.ConsoleLog("APIReponse >> ", APIReponse);
          $scope.getQuestions();
          growl.success(APIReponse, {
            ttl: 2000,
          });
        });
      };

      $scope.getQuestions();
    },
  ]);

"use strict";

angular
  .module("myApp.addEssayAnswers", ["ngRoute"])

  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/addEssayAnswers", {
        templateUrl: "app/addEssayAnswers/addEssayAnswers.html",
        controller: "addEssayAnswersCtrl",
      });
    },
  ])

  .controller("addEssayAnswersCtrl", [
    "$scope",
    "apiCall",
    "MyService",
    "$location",
    "$anchorScroll",
    "$timeout",
    "$rootScope",
    "ngDialog",
    "$q",
    "$http",
    "$filter",
    "growl",
    "$routeParams",
    "baseApiUrl",
    "tokenService",
    "$cookies",
    function (
      $scope,
      apiCall,
      MyService,
      $location,
      $anchorScroll,
      $timeout,
      $rootScope,
      ngDialog,
      $q,
      $http,
      $filter,
      growl,
      $routeParams,
      baseApiUrl,
      tokenService,
      $cookies
    ) {
      MyService.ConsoleLog("this is new");
      $scope.currentIndex = 0;

      $scope.quiz = {
        eDate: "",
      };

      $scope.quizAns = {
        shortAns: "",
        mediAns: "",
        longAns: "",
      };

      $scope.isUser = {
        selected: "",
      };

      /**
       * @description Function is use to get the essay questions
       */

      $scope.getEssayQuestions = function () {
        MyService.getFiveMinEssayQues().then(
          function (APIResponse) {
            MyService.ConsoleLog("APIResponse >> ", APIResponse);
            $scope.questions = APIResponse;
          },
          function (err) {
            MyService.ConsoleLog("err >> ", err);
          }
        );
      };

      $scope.getCandidateListing = function () {
        MyService.ConsoleLog("$scope.quiz >> ", $scope.quiz);

        MyService.getCandidateListing($scope.quiz.eDate).then(
          function (APIResponse) {
            MyService.ConsoleLog("APIResponse >> ", APIResponse);
            $scope.candidates = APIResponse.data.data;
            $scope.getEssayQuestions();
          },
          function (err) {
            MyService.ConsoleLog("get candi >> ", err);
          }
        );
        //
      };

      $scope.getElectionDates = function () {
        MyService.getListOfDates().then(
          function (APIResponse) {
            MyService.ConsoleLog("APIResponse >> ", APIResponse);
            if (APIResponse.data.success) {
              var datesArr = [];
              var mainArr = APIResponse.data.data.map(function (item, index) {
                var date = new Date(item).toGMTString();

                var par = {
                  _id: index,
                  eDate: date.substr(5, 12),
                  date: item,
                };
                datesArr.push(par);
              });
              MyService.ConsoleLog("datesArr >> ", datesArr[0].eDate);
              $scope.electionDates = datesArr;

              $scope.electionDates.sort(function (a, b) {
                if (a != null && b != null) {
                  return new Date(b.date) - new Date(a.date);
                }
              });
              $scope.quiz.eDate = $scope.electionDates[0];
              $scope.getCandidateListing();
              MyService.ConsoleLog("$scope.quiz >> ", $scope.quiz);
              MyService.ConsoleLog(
                "$scope.electionDates >> ",
                $scope.electionDates
              );
            }
          },
          function (err) {
            MyService.ConsoleLog("error", err);
          }
        );
      };
      $scope.getElectionDates();

      $scope.getAnswerQuestion = function () {
        MyService.ConsoleLog(" $scope.isUser > ", $scope.isUser.selected);
        MyService.getEssayAns({ userId: $scope.isUser.selected._id }).then(
          function (APIResponse) {
            MyService.ConsoleLog("APIResponse ", APIResponse);
            if (APIResponse && APIResponse.data.success) {
              $scope.ansQue = APIResponse.data.data;
              $scope.selAns = $scope.ansQue.filter(function (ans) {
                if (ans.question == $scope.questions[$scope.currentIndex]._id) {
                  $scope.quizAns = {
                    shortAns: ans.shortAns ? ans.shortAns : "",
                    mediAns: ans.mediumAns ? ans.mediumAns : "",
                    longAns: ans.longAns ? ans.longAns : "",
                  };
                  return ans;
                }
              });
            }
          }
        );
      };

      //  prevQuestions
      $scope.prevQuestion = function () {
        MyService.ConsoleLog("** prevQuestion **");

        if ($scope.currentIndex > 0) {
          $scope.currentIndex--;
        } else if ($scope.currentIndex == 0) {
          if ($scope.currBackgroundIndex > 0) {
            $scope.currBackgroundIndex--;
            $scope.category =
              $scope.traverseBackgrounds[$scope.currBackgroundIndex];
          }
        }
      };

      $scope.skipQuestion = function () {
        MyService.ConsoleLog("* skipQuestion *");
        var skip = function () {
          var tempIndex = $scope.currentIndex + 1;
          if (tempIndex < $scope.questions.length) {
            $scope.currentIndex++;
            $scope.selAns = $scope.ansQue.filter(function (ans) {
              MyService.ConsoleLog("ans ", ans);
              if (ans.question == $scope.questions[$scope.currentIndex]._id) {
                $scope.quizAns = {
                  shortAns: ans.shortAns ? ans.shortAns : "",
                  mediAns: ans.mediumAns ? ans.mediumAns : "",
                  longAns: ans.longAns ? ans.longAns : "",
                };
                return ans;
              }
            });
          } else {
            MyService.ConsoleLog(
              "Congrats answer all the questions of candidate"
            );
          }
        };

        skip();
      };

      $scope.newQuestion = function () {
        var tempIndex = $scope.currentIndex;
        $scope.quizAns = {
          shortAns: "",
          mediAns: "",
          longAns: "",
        };

        if (tempIndex < $scope.questions.length) {
          $scope.quizAns = {
            shortAns: "",
            mediAns: "",
            longAns: "",
          };

          // if (window.localStorage.getItem("fiveMinMatch")) {
          //   $scope.getFiveMinData = [];
          //   $scope.getFiveMinData = JSON.parse(
          //     window.localStorage.getItem("fiveMinMatch")
          //   );
          //   MyService.ConsoleLog("Data : ", $scope.getFiveMinData);
          //   for (var i = 0; i < $scope.getFiveMinData.length; i++) {
          //     // MyService.ConsoleLog("for i : " + i + " currentIndex : " + $scope.currentIndex);
          //     if (i == $scope.currentIndex) {
          //       // MyService.ConsoleLog("index matched", $scope.getFiveMinData[i]);
          //       $scope.answer = $scope.getFiveMinData[i].answer;
          //       $scope.importance = $scope.getFiveMinData[i].importance;
          //       $scope.updata.comment = $scope.getFiveMinData[i].comment;
          //       // MyService.ConsoleLog("answer : " + $scope.answer);
          //       // MyService.ConsoleLog("importance : " + $scope.importance);
          //       // MyService.ConsoleLog("comment : " + $scope.comment);
          //       $timeout(function () {
          //         $scope.$apply();
          //       });
          //     }
          //   }
          // } else {
          //   console.log("Else is called");
          //   $scope.answer = "";
          //   $scope.importance = "";
          //   $scope.updata.comment = "";
          //   $scope.quizAns = {
          //     shortAns: "",
          //     mediAns: "",
          //     longAns: "",
          //   };
          //   MyService.ConsoleLog("Myans", $scope.getFiveMinData);

          //   // $scope.currentIndex++;
          // }
          //$scope.currentIndex++;
        }
      };

      $scope.submitAnswer = function () {
        if ($scope.isUser.selected && $scope.isUser.selected != "") {
          if (
            $scope.quizAns.shortAns == "" &&
            $scope.quizAns.mediAns == "" &&
            $scope.quizAns.longAns == ""
          ) {
            var message = "You need to write at least one answer";
            var modal = ngDialog.openConfirm({
              template:
                "<p>" +
                message +
                '</p>\
                       <div class="ngdialog-buttons">\
                           <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="closeThisDialog(0)">OK</button>\
                       </div>',
              plain: true,
            });
            modal.then(
              function fullfilled(data) {
                //MyService.ConsoleLog("fullfilled: ", data);
              },
              function rejected(data) {
                //MyService.ConsoleLog("rejected: ", data);
              }
            );
            $("html, body").animate(
              {
                scrollTop: 0,
              },
              "slow"
            );
            return;
          } // End of question checking
          var quizParams = {
            shortAns: $scope.quizAns.shortAns,
            mediAns: $scope.quizAns.mediAns,
            longAns: $scope.quizAns.longAns,
          };
          if (
            tokenService &&
            tokenService.getUserRole() == "admin" &&
            $scope.isUser &&
            $scope.isUser.selected &&
            $scope.isUser.selected != ""
          ) {
            if ($scope.ansQue && $scope.ansQue.length > 0) {
              MyService.ConsoleLog(" $scope.selAns  >> ", $scope.selAns[0]);
              quizParams.id = $scope.selAns[0]._id;
              quizParams.frontRunnerId = $scope.isUser.selected._id;
            } else {
              quizParams.frontRunnerId = $scope.isUser.selected._id;
            }
          }

          quizParams.questionId = $scope.questions[$scope.currentIndex]._id;

          MyService.ConsoleLog("quizParams >> ", quizParams);

          MyService.storeEssayAnswer(quizParams).then(
            function (APIResponse) {
              MyService.ConsoleLog("APIResponse >> ", APIResponse);
              if (APIResponse.data.success) {
                $scope.questions[$scope.currentIndex]["my_answer"] = {
                  _id: APIResponse.data.data._id,
                  created: new Date(),
                  shortAns: APIResponse.data.data.shortAns,
                  mediAns: APIResponse.data.data.mediumAns,
                  longAns: APIResponse.data.data.longAns,
                  questionId: APIResponse.data.data.question,
                };
              }

              var tempIndex = $scope.currentIndex + 1;
              if (tempIndex < $scope.questions.length) {
                MyService.ConsoleLog(" else tempIndex >> ", tempIndex);
                $scope.currentIndex = $scope.currentIndex + 1;
              } else {
                $scope.isUser.selected = "";
                $scope.currentIndex = 0;
                growl.success("Congrats you have answer all the questions");
              }
              $scope.newQuestion();
            },
            function (err) {
              MyService.ConsoleLog("Error >> ", err);
            }
          );
        } else {
          growl.warning("Please select candidate first");
        }
      };
    },
  ]);

'use strict';
angular.module('myApp.addEndorsement', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/addEndorsement', {
      templateUrl: 'app/addEndorsement/addEndorsement.html',
      controller: 'addEndorsementCtrl'
    });
    $routeProvider.when('/addEndorsement/:id/:isEdit?', {
      templateUrl: 'app/addEndorsement/addEndorsement.html',
      controller: 'addEndorsementCtrl'
    });
  }])
  .controller('addEndorsementCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', '$q', '$timeout', 'tokenService', 'MyService', '$sce', 'growl', function ($scope, $http, $location, apiCall, $routeParams, $rootScope, $q, $timeout, tokenService, MyService, $sce, growl) {
    $scope.locationIntrest = 'politician';
    $scope.selectionType = '';
    $scope.selectedUser = {};
    $scope.selectedReferal = {};
    $scope.userId = tokenService.getUserId();
    $scope.userData = JSON.parse(tokenService.getUserData());
    $scope.politiicanId = $routeParams.id;
    $scope.isEdit = $routeParams.isEdit;
    $scope.review = {
      toId: '',
      toName: '',
      fromId: $scope.userData.id,
      fromName: $scope.userData.name,
      referalId: '',
      referalName: '',
      grade: {
        number: 0,
        letter: '',
        like: 'true'
      },
      text: '',
      links: []
    };
    $scope.showLoader = false;

    $scope.$on('$viewContentLoaded', function () {
      //commented by Pankaj Patil to stop the autoload for politicians when called from incumbent page
      //$scope.getUsers('politician');
      if ($routeParams.id && $routeParams.id != "") {
        $scope.getUsersFromIds();
      }
      if (tokenService.getUserRole()) {
        MyService.ConsoleLog("tokenService.getUserRole()", tokenService.getUserRole());
      }
    });

    $scope.getUsers = function (type) {
      $scope.allUsers = [];
      $scope.selectedUser.value = '';
      $scope.selectedReferal.value = '';
      $scope.review.referalId = '';
      $scope.review.referalName = '';
      $scope.showLoader = true;
      $scope.review = {
        toId: '',
        toName: '',
        fromId: $scope.userData.id,
        fromName: $scope.userData.name,
        referalId: '',
        referalName: '',
        grade: {
          number: 0,
          letter: '',
          like: 'true'
        },
        text: '',
        links: []
      }
      $scope.selectionType = type;
      var request = apiCall.apiCall('GET', '/user/list', {
        usertype: type
      });
      $http(
        request
      ).then(function successCallback(response) {
        if (response.data.success) {
          // MyService.ConsoleLog(response);
          angular.forEach(response.data.data, function (val, key) {
            var fkey;
            var _id = response.data.data[key]._id;
            if ($routeParams.id && response.data.data[key]._id == $routeParams.id) {
              var fkey = '';
              if (response.data.data[key].userType == 'politician') {
                var name, officeName, state;
                name = response.data.data[key].name;
                if (response.data.data[key].politicianInfo && response.data.data[key].politicianInfo.length > 0) {
                  officeName = response.data.data[key].politicianInfo[0].officeName;
                  state = response.data.data[key].politicianInfo[0].state;
                }

                if (state && state != '') {
                  fkey = name + ' ' + state + ' ' + officeName;
                } else {
                  fkey = name + ' ' + officeName;
                }
              } else {
                var name, url;
                name = response.data.data[key].name;
                url = window.location.origin + '/#!/publicProfile/' + response.data.data[key]._id;
                fkey = name + ' ' + url;
              }
              $scope.selectedUser.value = fkey;
              $scope.review.toId = response.data.data[key]._id;
              $scope.review.toName = response.data.data[key].name;
              $scope.showLoader = false;
              document
                .getElementById("auto-referal-suggest-box")
                .getElementsByTagName("input")[0]
                .blur();
            } else {
              if ($scope.selectionType == 'politician') {
                MyService.ConsoleLog("politician Info", response.data.data[key].politicianInfo);
                var name, officeName, state;
                name = response.data.data[key].name;
                if (response.data.data[key].politicianInfo && response.data.data[key].politicianInfo.length > 0) {
                  officeName = response.data.data[key].politicianInfo[0].officeName;
                  state = response.data.data[key].politicianInfo[0].state;
                }



                if (state && state != '') {
                  fkey = name + ' ' + state + ' ' + officeName;
                } else {
                  fkey = name + ' ' + officeName;
                }
              } else {
                var name, url;
                name = response.data.data[key].name;
                url = window.location.origin + '/#!/publicProfile/' + response.data.data[key]._id;
                fkey = name + ' ' + url;
              }
              response.data.data[key].fkey = fkey
              $scope.allUsers.push(response.data.data[key]);
              $scope.showLoader = false;
            }

          });
        } else {
          growl.error("Something went wrong.");
          $scope.showLoader = false;
        }
      }, function errorCallBack(response) {
        growl.error("Something went wrong.");
        $scope.showLoader = false;
      });
    }

    $scope.getUsersFromIds = function () {
      var userIds = [];
      userIds.push($routeParams.id);
      if (!$scope.isEdit) {
        MyService.getUsersFromIds({
          "userIds": JSON.stringify(userIds)
        }).then(function (response) {
          console.log("response : ", response);
          if (response.data.success) {
            console.log("Data : ", response.data.data);
            var rdata = response.data.data;
            $scope.selectedUser.value = rdata[0].name;
            $scope.review = {
              toId: $routeParams.id,
              toName: rdata[0].name,
              fromId: $scope.userData.id,
              fromName: $scope.userData.name,
              udata: rdata[0],
              referalId: '',
              referalName: '',
              grade: {
                number: 0,
                letter: '',
                like: 'true'
              },
              text: '',
              links: []
            };
            console.log("review >>> ", $scope.review);
          }
        });
      } else {
        MyService.getEndorsementData({
          "userId": $scope.politiicanId,
          "advId": $scope.userId
        }).then(function (APIReponse) {
          MyService.ConsoleLog("APIResponse", APIReponse);
          var rdata = APIReponse.data.data;
          $scope.selectedUser.value = rdata.poliName;

          $scope.review = {
            toId: $routeParams.id,
            toName: rdata.poliName,
            fromId: $scope.userData.id,
            fromName: $scope.userData.name,
            text: rdata.note,
            links: []
          };
        }, function (err) {
          MyService.ConsoleLog("Error", err);
        });
      }
    };

    /**
     * @description Function is use to remove endorsemnet
     */
    $scope.removeEndorsement = function () {
      MyService.ConsoleLog("remove");
      MyService.removePoliFromEndorse({
        "orgId": $scope.userId,
        "pId": $scope.politiicanId
      }).then(function (APIReponse) {
        MyService.ConsoleLog("APIReponse", APIReponse);
        growl.success(APIReponse.data.data);
        $location.path('/compare-select/politician');
      }, function (err) {
        MyService.ConsoleLog("Error", err);
      });
    };

    function fuzzy_suggest(term) {
      if (!term) return [];
      var fuzzySearch = "";
      fuzzySearch = new Fuse($scope.allUsers, {
        shouldSort: true,
        keys: ["fkey"],
        caseSensitive: false,
        threshold: 0.4
      });
      // MyService.ConsoleLog(fuzzySearch);
      return fuzzySearch
        .search(term)
        .slice(0, 10)
        .map(function (i) {
          var val = i.fkey;
          // MyService.ConsoleLog("val:::", val);
          return {
            value: JSON.stringify(i),
            label: $sce.trustAsHtml(val)
          };
        });
    }

    function highlight(str, term) {
      var highlight_regex = new RegExp("(" + term + ")", "gi");
      return str.replace(
        highlight_regex,
        '<span class="highlight">$1</span>'
      );
    }

    $scope.closeEdit = function (col) {
      var nval = JSON.parse(col.value);
      // MyService.ConsoleLog(nval);
      // MyService.ConsoleLog('_id: ', nval._id);
      $scope.selectedUser.value = nval.fkey;
      $scope.review.toId = nval._id;
      $scope.review.toName = nval.name;
      document
        .getElementById("auto-user-suggest-box")
        .getElementsByTagName("input")[0]
        .blur();
    }

    $scope.user_options = {
      suggest: fuzzy_suggest,
      on_select: $scope.closeEdit
    };

    $scope.reviewYourself = function () {
      $scope.selectionType = 'yourself';
      // $scope.selectedUser.value = '';
      MyService.ConsoleLog("review : ", $scope.review);
      $scope.selectedReferal.value = '';
      /*
      $scope.review = {
        fromId: $scope.userData.id,
        fromName: $scope.userData.name,
        referalId: '',
        referalName: '',
        grade: {
          number: 0,
          letter: 'a',
          like: 'true'
        },
        text: '',
        links: []
      }
      */
    }

    function referal_suggest(term) {
      if (!term) return [];
      var fuzzySearch = "";
      fuzzySearch = new Fuse($scope.allUsers, {
        shouldSort: true,
        keys: ["fkey"],
        caseSensitive: false,
        threshold: 0.4
      });
      // MyService.ConsoleLog(fuzzySearch);
      return fuzzySearch
        .search(term)
        .slice(0, 10)
        .map(function (i) {
          var val = i.fkey;
          // MyService.ConsoleLog("val:::", val);
          return {
            value: JSON.stringify(i),
            label: $sce.trustAsHtml(val)
          };
        });
    }

    $scope.closeReferal = function (col) {
      var nval = JSON.parse(col.value);
      $scope.selectedReferal.value = nval.fkey;
      $scope.review.referalId = nval._id;
      $scope.review.referalName = nval.name;
      document
        .getElementById("auto-referal-suggest-box")
        .getElementsByTagName("input")[0]
        .blur();
    }

    $scope.referal_options = {
      suggest: referal_suggest,
      on_select: $scope.closeReferal
    };

    $scope.setLike = function (grade) {
      $scope.review.grade.like = grade;
    }

    $scope.endorsement = function () {
      // alert('alll');
      var endorse = true;
      $scope.review.endorse = endorse;
      if (!$scope.isEdit)
        $scope.review.isEdit = false;
      else
        $scope.review.isEdit = true;


      MyService.ConsoleLog("Reviews Text", $scope.review);

      MyService.endorsePoli($scope.review).then(function (response) {
        MyService.ConsoleLog("response", response);
        growl.success(response.data.data);
        if (!$scope.isEdit)
          $location.path('/compare-select/politician');
        else
          $location.path('/allEndorsements/' + $scope.politiicanId);
      }, function (err) {
        // MyService.ConsoleLog()
        growl.error(err);
      });
    }

  }]);

"use strict";
angular
  .module("myApp.addDebate", ["ngRoute"])
  .config([
    "$routeProvider",
    function ($routeProvider) {
      $routeProvider.when("/addDebate/:uId?", {
        templateUrl: "app/addDebate/addDebate.html",
        controller: "addDebatetrl",
      });
    },
  ])
  .controller("addDebatetrl", [
    "$scope",
    "$http",
    "$location",
    "apiCall",
    "$routeParams",
    "$rootScope",
    "$q",
    "$timeout",
    "growl",
    "tokenService",
    "MyService",
    "ngDialog",
    function (
      $scope,
      $http,
      $location,
      apiCall,
      $routeParams,
      $rootScope,
      $q,
      $timeout,
      growl,
      tokenService,
      MyService,
      ngDialog
    ) {
      /**
       * @description Get Current user info
       */
      if (tokenService.getUserData()) {
        $scope.uData = JSON.parse(tokenService.getUserData());
      }
      $scope.uId = $routeParams.uId;
      $scope.loader = false;

      $scope.isDefaultSelected = false;
      $scope.subCatArr = [];
      $scope.location = ["National", "State", "County", "Local"];
      $scope.ShowLocationOptions = false;
      $scope.isNational = "National (USA)";
      $scope.Topic = {
        title: "",
        description: "",
        location: "National",
        restrictedTo: "No Restrictions",
      };
      $scope.restrictedOptions = [
        "Locals Only",
        "My County",
        "My State",
        "National",
        "No Restrictions",
      ];

      $scope.params = {
        eDate: "",
        cityCouncil: "",
        officeType: "",
      };

      $scope.mainCatIds = [];
      $scope.mainCatIds.push($routeParams.categoryId);
      if ($routeParams.categoryId && $routeParams.subcatId) {
        $scope.subCatArr.push($routeParams.categoryId);
        $scope.subCatArr.push($routeParams.subcatId);
      } else if ($routeParams.categoryId) {
        $scope.subCatArr.push($routeParams.categoryId);
      } else {
        $scope.subCatArr.push($routeParams.subcatId);
      }
      console.log("$scope.subCatArr :>> ", $scope.subCatArr);

      /**
       * @description Get the city concil district info
       */
      $scope.getCityCouncilDistrict = function () {
        $scope.loader = true;
        MyService.getCityCouncilDistrict().then(function (APIResponse) {
          // MyService.ConsoleLog("APIResponse >> ", APIResponse);
          $scope.cityCouncilDistricts = APIResponse.filter(function (
            cityCouncil
          ) {
            cityCouncil.cityCouncilDistrictName = cityCouncil.COUNTDIST;
            cityCouncil.name =
              "cityCouncilDistrictName " + cityCouncil.COUNTDIST;
            return cityCouncil;
          });

          $scope.cityCouncilDistricts.sort(function (a, b) {
            var x, y;

            x = parseInt(a.COUNTDIST);
            y = parseInt(b.COUNTDIST);

            if (x < y) {
              return -1;
            }
            if (x > y) {
              return 1;
            }
            return 0;
          });
          MyService.ConsoleLog(
            " $scope.cityCouncilDistricts > ",
            $scope.cityCouncilDistricts
          );

          $scope.getElectionDates();
        });
      };

      /**
       * @description Get the election dates record
       */

      $scope.getElectionDates = function () {
        MyService.getListOfDates().then(function (APIResponse) {
          MyService.ConsoleLog("APIResponse > ", APIResponse);
          $scope.electionDates = APIResponse.data.data.map(function (
            electionDate
          ) {
            return new Date(electionDate).toISOString().split("T")[0];
          });
          $scope.loader = false;
        });
      };
      $scope.getCityCouncilDistrict();

      /**
       * @description Get the Candidates details
       */
      $scope.GetCandidates = function () {
        MyService.ConsoleLog("$scope.params >> ", $scope.params);
        MyService.getCandidatesWithParams($scope.params).then(function (
          APIResponse
        ) {
          MyService.ConsoleLog("APIResponse > ", APIResponse);
          $scope.candidates = APIResponse.filter(function (poli) {
            if (poli.politicianInfo && poli.politicianInfo.length > 0) {
              poli.office = poli.politicianInfo[0].officeName;
            } else {
              //  poli.office = poli.politicianInfo[0].officeName;
            }

            return poli;
          });

          angular.forEach($scope.candidates, function (val, key) {
            //MyService.ConsoleLog("key: ", key);

            val.selected = true;
          });
        });
      };

      $scope.selectUsersFromGroup = function (usres, flag) {
        angular.forEach(usres, function (val, key) {
          val.selected = flag;
        });
      };

      if (window.localStorage.getItem("VoteWiseCategory")) {
        $rootScope.allcategories = JSON.parse(
          window.localStorage.getItem("VoteWiseCategory")
        );
        MyService.ConsoleLog(
          "$rootScope.allcategories",
          $rootScope.allcategories
        );
        var chklen = 0;
        $scope.previouscatId = $rootScope.allcategories[chklen];
        if ($rootScope.allcategories.length >= 2) {
          $scope.mainCatIds.push($scope.previouscatId);
        }

        MyService.ConsoleLog("$scope.previouscatId", $scope.previouscatId);
        var idx = $rootScope.allcategories.indexOf($routeParams.subcatId);
        if (idx == -1) {
          $rootScope.allcategories.push($routeParams.subcatId);
          window.localStorage.setItem(
            "VoteWiseCategory",
            JSON.stringify($rootScope.allcategories)
          );
        }
      }
      //MyService.ConsoleLog("Final categories : ", window.localStorage.getItem("VoteWiseCategory"));
      $scope.subtopics = {
        subcategories: [],
      };

      $scope.getParentId = function (childId) {
        MyService.getParentCat({
          id: childId,
        }).then(
          function (APIResponse) {
            MyService.ConsoleLog("APIResponse", APIResponse);
            if (APIResponse && APIResponse.data.success) {
              var cobj = new Object();

              cobj.path =
                "," +
                APIResponse.data.data.parentIds[0].pid +
                "," +
                childId +
                ",";
              cobj.pid = childId;
              cobj.viewOrder = 1;
              $scope.SelectedTree.push(cobj);

              // APIResponse.data.data.parentIds[0].pid;
            } else {
              cobj.pid = childId;
              cobj.viewOrder = 1;

              cobj.path = "," + childId + ",";
              $scope.SelectedTree.push(cobj);
            }
            MyService.ConsoleLog("second", $scope.SelectedTree);
          },
          function (err) {
            MyService.ConsoleLog("err", err);
          }
        );
      };

      $scope.selectedCat = [];
      $scope.SelectedTree = [];
      $scope.disabled = [];
      $scope.isGeneral = false;
      $scope.getVal = function (data) {
        MyService.ConsoleLog(" getVal :", data);

        var idx = $scope.selectedCat.indexOf(data);
        if (idx > -1) {
          $scope.selectedCat.splice(idx, 1);
          var id = $scope.disabled.indexOf(data._id);
          $scope.disabled.splice(id, 1);
          var jdx = $scope.SelectedTree.indexOf(data.parentIds);
          if (jdx > -1) $scope.SelectedTree.splice(jdx, 1);
        } else {
          // MyService.ConsoleLog("ss")
          $scope.selectedCat.push(data);
          if (data && data.subcategories && data.subcategories.length > 0) {
            data.subcategories.filter(function (itm) {
              var inx = itm.title.indexOf("General");
              if (inx > -1) {
                MyService.ConsoleLog("itm", itm);
                $scope.mainCatIds.push(data._id);
                $scope.isGeneral = true;
                $scope.subId = itm._id;
                if (itm && itm.subcategories && itm.subcategories.length > 0) {
                  $scope.superSub = itm.subcategories[0];
                }
                $scope.selectedCat.push(itm);
              }
            });
          }
          MyService.ConsoleLog("mainCatIds", $scope.mainCatIds);
          var id = $scope.disabled.indexOf(data._id);
          if (id == -1) {
            $scope.disabled.push(data._id);
          }
          MyService.ConsoleLog("paren", data.parentIds);
          MyService.ConsoleLog("SelectedTree: ", $scope.SelectedTree);
          if ($scope.SelectedTree.length == 0) {
            if (data.parentIds.length > 0) {
              //var parents = Object.keys(data.parentIds).map(function (key) {return data.parentIds[key]});
              //angular.copy(data.parentIds, $scope.SelectedTree);
              var parents = data.parentIds;
              //MyService.ConsoleLog(parents);
              $scope.SelectedTree = parents;
            } else {
              MyService.ConsoleLog(" $scope.subId ", $scope.subId);
              var cobj = new Object();
              if ($scope.isGeneral == true && $scope.subId != "") {
                cobj.pid = data._id;
                cobj.viewOrder = 1;
                if ($scope.superSub) {
                  cobj.path =
                    "," +
                    data._id +
                    "," +
                    $scope.subId +
                    "," +
                    $scope.superSub._id +
                    ",";
                } else {
                  cobj.path = "," + data._id + "," + $scope.subId + ",";
                }
                // cobj.path = "," + data._id + "," + $scope.subId + ",";
                $scope.SelectedTree.push(cobj);
              } else {
                $scope.getParentId(data._id);
                // cobj.pid = data._id;
                // cobj.viewOrder = 1;

                // cobj.path = "," + data._id + ",";
                // $scope.SelectedTree.push(cobj);
              }

              //"pid":"57987dfb31411a7f224cf01e","viewOrder":6,"path":",57987dfb31411a7f224cf01e,"
            }
          } else {
            if (data.parentIds.length > 0) {
              //var parents = Object.keys(data.parentIds).map(function (key) {return data.parentIds[key]});
              var parents = angular.copy(data.parentIds);
              //var parents = data.parentIds;
              var plen = parents.length;
              for (var j = 0; j < plen; j++) {
                var jdx = indexOfExt($scope.SelectedTree, parents[j]);
                //MyService.ConsoleLog(jdx);
                if (jdx == -1) {
                  $scope.SelectedTree.push(parents[j]);
                  // MyService.ConsoleLog("parents[j]",parents[j]);
                  if ($scope.isGeneral == true && $scope.subId != "") {
                    var obj = {};
                    obj.pid = data._id;
                    obj.viewOrder = 1;
                    obj.path = "," + data._id + "," + $scope.subId + ",";
                    var sjdx = indexOfExt($scope.SelectedTree, obj);
                    if (sjdx == -1) {
                      MyService.ConsoleLog("Obj", obj);
                      $scope.SelectedTree.push(obj);
                    }
                  }
                }
              }
            } else {
              var cobj = new Object();
              cobj.pid = data._id;
              cobj.viewOrder = 1;

              if ($scope.isGeneral == true && $scope.subId != "") {
                // cobj.path = "," + data._id + "," + $scope.subId + ",";
                // MyService.ConsoleLog("is", cobj.path);
                if ($scope.superSub) {
                  cobj.path =
                    "," +
                    data._id +
                    "," +
                    $scope.subId +
                    "," +
                    $scope.superSub._id +
                    ",";
                } else {
                  cobj.path = "," + data._id + "," + $scope.subId + ",";
                }
                MyService.ConsoleLog("is", cobj.path);
                $scope.SelectedTree.push(cobj);
              } else {
                MyService.ConsoleLog("issssss");
                // cobj.path = "," + data._id + ",";
                $scope.getParentId(data._id);
              }

              //"pid":"57987dfb31411a7f224cf01e","viewOrder":6,"path":",57987dfb31411a7f224cf01e,"
            }
          }
        }
        MyService.ConsoleLog("$scope.SelectedTree", $scope.SelectedTree);
      };

      $scope.selectedAll = {
        id: [],
      };
      $scope.removeVal = function (data) {
        var idx = $scope.selectedCat.indexOf(data);
        MyService.ConsoleLog("data", data);
        MyService.ConsoleLog("idx", idx);
        if (idx > -1) {
          if ($scope.selectedCat[idx].title.indexOf("General") > -1) {
            $scope.selectedCat.filter(function (itms, ind) {
              if (itms._id == $scope.selectedCat[idx]._id) {
                MyService.ConsoleLog("yes", ind);
                // $scope.selectedCat.splice(ind, 1);
              }
            });
            var indx = $scope.selectedCat.indexOf(data);
            $scope.selectedCat.splice(indx, 1);
          } else {
            $scope.selectedCat.splice(idx, 1);
          }

          var id = $scope.disabled.indexOf(data._id);
          $scope.disabled.splice(id, 1);
          var parents = data.parentIds;

          var plen = parents.length;
          for (var j = 0; j < plen; j++) {
            var jdx = $scope.SelectedTree.indexOf(parents[j]);
            if (jdx > -1) $scope.SelectedTree.splice(jdx, 1);
          }
        }
        $scope.selectedAll.id.length = 0;
        //MyService.ConsoleLog($scope.SelectedTree);
        var allLen = $scope.SelectedTree.length;
        var chkboxe = document.getElementsByName("checkedidcat");
        for (var i = 0; i < allLen; i++) {
          chkboxe[i].checked = true;
        }
      };

      $scope.selectConfig = {
        requiredMin: 1,
        selectAll: true,
      };

      function areEqual() {
        var len = arguments.length;
        for (var i = 1; i < len; i++) {
          if (arguments[i] == null || arguments[i] != arguments[i - 1])
            return false;
        }
        return true;
      }

      function indexOfExt(list, item) {
        var len = list.length;

        for (var i = 0; i < len; i++) {
          var keys = Object.keys(list[i]);
          var flg = true;
          var arr = [];
          for (var j = 0, s = 1; j < keys.length; j++, s++) {
            var value = list[i][keys[j]];
            //MyService.ConsoleLog("value :" + value + "-----Item : " + item[keys[j]]);
            //MyService.ConsoleLog(typeof value + "===" + typeof item[keys[j]]);
            if (typeof value != "object" && typeof item[keys[j]] != "object") {
              if (item[keys[j]] !== value) {
                flg = false;
                //MyService.ConsoleLog("flg : ", typeof item[keys[j]], typeof value);
              }
            }
            if (item[keys[j]] == value) {
              arr.push(flg);
            } else if (
              typeof value == "object" &&
              typeof item[keys[j]] == "object"
            ) {
              arr.push(flg);
            }
          }
          if (flg == true) {
            //MyService.ConsoleLog(arr.length + "-----" + keys.length + "-----" + Object.keys(item).length);
            if (areEqual(arr.length, keys.length, Object.keys(item).length)) {
              return i;
            }
          }
        }
        return -1;
      }

      $scope.checksubCatExists = function (rdata, val) {
        return rdata.filter(function (rdata) {
          if (rdata.pid) {
            var idx = indexOfExt($scope.selectedCat, val);

            if (idx == -1) {
              $scope.selectedCat.push(val);
            }
            return rdata;
          }
        });
      };

      $scope.checkCatExists = function (rdata, val) {
        return rdata.filter(function (rdata) {
          if (rdata._id == val) {
            //MyService.ConsoleLog("parentIds : ", rdata.parentIds.length);
            if (rdata.parentIds.length > 0) {
              var parents = rdata.parentIds.length;
              for (var j = 0; j < parents; j++) {
                var newd = angular.copy(rdata.parentIds[j]);
                //MyService.ConsoleLog("newd:", newd);
                //MyService.ConsoleLog("SelectedTree:", $scope.SelectedTree);
                var jdx = indexOfExt($scope.SelectedTree, newd);
                //MyService.ConsoleLog(jdx);
                if (jdx == -1) {
                  $scope.SelectedTree.push(newd);
                }
              }
            }
            if (rdata.parentIds.length > 1) {
              var idx = indexOfExt($scope.selectedCat, angular.copy(rdata));
              if (idx == -1) {
                $scope.selectedCat.push(angular.copy(rdata));
              }
            } else {
              $scope.selectedCat.push(angular.copy(rdata));
            }
            return rdata;
          } else if (rdata.subcategories) {
            $scope.checkCatExists(rdata.subcategories, val);
          }
        });
      };

      $scope.getSubcatTree = function () {
        $scope.selectedCat.length = 0;
        $scope.EssayButton = true;
        var types;
        if ($scope.curState == "topic-politician") {
          types = "F,H";
        } else {
          types = "F";
        }
        MyService.getAllCatTree({
          type: types,
        }).then(
          function (payload) {
            $scope.subtopics.subcategories.length = 0;
            var subcatdata = payload;
            // MyService.ConsoleLog("subcatdata : ", subcatdata);
            $scope.disabled.length = 0;
            //$scope.disabled.push(window.localStorage.getItem("VoteWiseParentCategory"));
            $scope.subtopics.subcategories = subcatdata;
            if ($routeParams.categoryId) {
              $scope.disabled = JSON.parse(
                window.localStorage.getItem("VoteWiseCategory")
              );
              //MyService.ConsoleLog("subcat : ", $scope.disabled);
              var selectedCat = JSON.parse(
                window.localStorage.getItem("VoteWiseCategory")
              );
              if (selectedCat.length > 0) {
                for (var s = 0; s < selectedCat.length; s++) {
                  var checkcatdata = $scope.checkCatExists(
                    subcatdata,
                    selectedCat[s]
                  );
                }
                //MyService.ConsoleLog($scope.selectedCat);
                //$scope.SelectedTree = angular.copy($scope.selectedCat);
              }
              $scope.EssayButton = false;
              setTimeout(function () {
                var cols = document.getElementsByClassName("cmnUL");
                var clen = cols.length;
                for (var i = 0; i < clen; i++) {
                  cols[i].style.display = "none";
                }
              }, 300);
            } else {
              MyService.ConsoleLog("* Inside else *");
              angular.forEach(
                $scope.subtopics.subcategories,
                function (val, key) {
                  if (
                    val.title &&
                    val.title.toLowerCase() == "politician review"
                  ) {
                    $scope.disabled = [val._id];
                    // var checkcatdata = $scope.checkCatExists(subcatdata, val);
                    $scope.selectedCat.push(val);
                  }
                }
              );
            }
            MyService.ConsoleLog("$scope.selectedCat", $scope.selectedCat);
            var tmp = $scope.selectedCat.filter(function (itm, ind) {
              return (
                ind ==
                $scope.selectedCat.findIndex(function (ele) {
                  return JSON.stringify(ele) == JSON.stringify(itm);
                })
              );
            });
            MyService.ConsoleLog("tmp", tmp);
            $scope.selectedCat = "";
            $scope.selectedCat = tmp;
          },
          function (errorPayload) {
            alert("Something went wrong ");
          }
        );
      };
      $scope.getSubcatTree();
      $scope.SubmitTopic = function (data) {
        if ($.fn.validateForceFully($("#addDebateForm")) == true) {
          //$scope.TopicButton = true;
          MyService.ConsoleLog("first", $scope.disabled);
          data.parentcat = JSON.stringify($scope.disabled);
          if ($scope.curState == "topic-politician" && $scope.disabled <= 0) {
            growl.error(
              "There must be a root category to with title 'Politician Review'."
            );
            return;
          }
          var subcat = [];
          if ($scope.curState == "topic-politician" && $scope.disabled <= 0) {
            subcat = JSON.stringify($scope.disabled);
          } else {
            subcat = JSON.stringify($scope.SelectedTree);
          }

          data.subcategories = subcat;
          data.createdById = tokenService.getUserId();
          data.createdByName = tokenService.getUserName();
          data.createdByType = tokenService.getUserRole();
          if ($scope.selectedArea.length > 0) {
            var obj = {};
            var smplData = $scope.selectedArea.filter(function (sel, idx) {
              if (sel.state) {
                obj.country = sel.country;
                obj.state = sel.state;
              }
              if (sel.county) {
                obj.county = sel.county;
              }
              if (sel.place) {
                obj.place = sel.place;
                obj.placeName = sel.place;

                // MyService.ConsoleLog("obj", obj);
                // MyService.ConsoleLog("idx", idx);
                $scope.selectedArea[idx] = "";
                $scope.selectedArea[idx] = obj;
                MyService.ConsoleLog("cheek plz", $scope.selectedArea[idx]);
              }

              //
            });
            data.location = JSON.stringify($scope.selectedArea);
          } else {
            var arr = [];
            var acountry = "";
            if ($scope.uData) {
              if ($scope.uData.address.country == null) {
                if ($scope.isNational) {
                  acountry = $scope.isNational;
                } else {
                  acountry = "United States of America";
                }
              } else {
                acountry = $scope.uData.address.country;
              }
              if (acountry.indexOf("National (USA)") > -1) {
                var objNw = {
                  country: acountry,
                  state: null,
                  statePostalCode: null,
                  county: null,
                  countySubdivision: null,
                  place: null,
                };

                arr.push(objNw);
                var objState = {
                  country: "United States of America",
                  state: $scope.uData.address.state,
                  statePostalCode: $scope.uData.address.statePostalCode,
                  county: null,
                  countySubdivision: null,
                  place: null,
                };
                arr.push(objState);
                var objCounty = {
                  country: "United States of America",
                  state: $scope.uData.address.state,
                  statePostalCode: $scope.uData.address.statePostalCode,
                  county: $scope.uData.address.county,
                  countySubdivision: null,
                  place: null,
                };
                arr.push(objCounty);
                var obj = {
                  country: acountry,
                  state: $scope.uData.address.state,
                  statePostalCode: $scope.uData.address.statePostalCode,
                  county: $scope.uData.address.county,
                  countySubdivision: $scope.uData.address.countySubdivision,
                  place: $scope.uData.address.place,
                };
                arr.push(obj);
              } else {
                var obj = {
                  country: acountry,
                  state: $scope.uData.address.state,
                  statePostalCode: $scope.uData.address.statePostalCode,
                  county: $scope.uData.address.county,
                  countySubdivision: $scope.uData.address.countySubdivision,
                  place: $scope.uData.address.place,
                };
                arr.push(obj);
              }

              data.location = JSON.stringify(arr);
            }
          }

          //MyService.ConsoleLog(data);
          //MyService.ConsoleLog($scope.selectedArea);

          var tempPoliticianUids = [];
          try {
            /*angular.forEach($scope.allLocations, function(state, key){
              if(state.politicians){
                  angular.forEach(state.politicians, function(pol, i){
                      if(pol.selected){
                          tempPoliticianUids.push(pol._id);
                      }
                  });
              }
          });*/
            //MyService.ConsoleLog("catch: ", $rootScope.politicianThreadData.users.length);
            angular.forEach($scope.candidates, function (pol, key) {
              //MyService.ConsoleLog("key: ", key);
              if (pol.selected) {
                tempPoliticianUids.push(pol._id);
              }
            });
          } catch (e) {
            //MyService.ConsoleLog("politicians thread exception: ", e);
          }
          if (
            $scope.curState == "topic-politician" &&
            tempPoliticianUids.length <= 0
          ) {
            growl.error("Please select at least one politician.");
            return;
          }
          data.taggedUsers = tempPoliticianUids.join(",");
          MyService.ConsoleLog("data: ", data);
          // return;
          var request = apiCall.apiCall("POST", "/topics/create", data);
          $http(request).then(
            function successCallback(response) {
              MyService.ConsoleLog("Got categories: ", response);
              $scope.TopicButton = true;
              if (response.data.success) {
                if (!window.localStorage.getItem("VoteWiseParentCategory")) {
                  MyService.ConsoleLog(
                    "response.data.data",
                    response.data.data
                  );
                  MyService.ConsoleLog(response.data.data.parentCat[0]);
                  if ($routeParams.categoryId && $routeParams.subcatId) {
                    $location.path(
                      "/forum/" + response.data.data.parentCat[0] + "/home"
                    );
                  } else {
                    // alert('one');

                    $location.path("/politician-thread/" + $scope.uId);
                  }
                } else {
                  var cat =
                    window.localStorage.getItem("VoteWiseParentCategory") ||
                    null;
                  MyService.ConsoleLog(" window.localStorage.getIte", cat);
                  MyService.ConsoleLog(" window.localStorage.getIte", cat);

                  if (cat != "undefined") {
                    MyService.ConsoleLog("$$$$$$$$ IF $$$$$$$$$");
                    if ($routeParams.categoryId && $routeParams.subcatId) {
                      $location.path(
                        "/forum/" +
                          window.localStorage.getItem(
                            "VoteWiseParentCategory"
                          ) +
                          "/home"
                      );
                    } else {
                      // alert('two');

                      $location.path("/politician-thread/" + $scope.uId);
                    }
                  } else {
                    MyService.ConsoleLog("$$$$$$$$ ELSE $$$$$$$$$");
                    if ($routeParams.categoryId && $routeParams.subcatId) {
                      $location.path(
                        "/forum/" + response.data.data.parentCat[0] + "/home"
                      );
                    } else {
                      // alert('three');
                    }
                  }
                }
              } else {
                if (response.data.error) {
                  alert(response.data.error);
                  //MyService.ConsoleLog(response.data);
                  if (response.data.status && response.data.status == "405") {
                    var msg =
                      "Do you want to send request to Admin to reactivate your account?.";
                    MyService.GetDialogWithButtons(
                      ngDialog,
                      msg,
                      "YES",
                      "NO"
                    ).then(
                      function (payload) {
                        MyService.sendActivatationMailtoAdmin().then(
                          function (payload) {
                            alert("Request sent successfully to admin");
                          },
                          function (errorPayload) {
                            alert("Something went wrong");
                          }
                        );
                      },
                      function (errorPayload) {
                        //MyService.ConsoleLog(errorPayload);
                      }
                    );
                  }
                }
              }
            },
            function errorCallBack(response) {
              //MyService.ConsoleLog("Error: ", response);
            }
          );
        }
      };

      $scope.AddLocation = false;
      $scope.newlocation = {
        country: "",
      };
      $scope.Allcountries = [];
      $scope.SelectedCountry = "";

      $scope.ShowAddLocation = function () {
        if (!$scope.AddLocation) {
          $scope.AddLocation = true;
        } else {
          $scope.AddLocation = false;
        }
      };

      function suggest_country(term) {
        var q = term.toLowerCase().trim();
        var results = [];
        var len = $scope.Allcountries.length;
        // Find first 10 states that start with `term`.
        for (var i = 0; i < len && results.length < 10; i++) {
          var country = $scope.Allcountries[i];
          if (country.toLowerCase().indexOf(q) === 0)
            results.push({
              label: country,
              value: country,
            });
        }
        return results;
      }

      $scope.autocomplete_options = {
        suggest: suggest_country,
      };

      $scope.chnageType = function () {
        MyService.ConsoleLog("$scope.params");
        if ($scope.params.officeType == "boroughPresident") {
          $scope.getCounties("36");
        }
      };

      $scope.setByDefaultState = function (data) {
        data.filter(function (itms) {
          if (itms.state.indexOf($scope.uData.address.state) > -1) {
            MyService.ConsoleLog("itms", itms);

            var nobj = {
              country: "National (USA)",
            };
            $scope.nwStateFips = itms.stateFips;
            $scope.selectedArea.push(nobj);
            $scope.selectedArea.push(itms);
            $scope.disabledLocation.push(itms);
            $scope.getCounties(itms.stateFips);
          }
        });
      };

      $scope.getAllStates = function () {
        MyService.getAllStates().then(
          function (payload) {
            $scope.allLocations.length = 0;
            var subcatdata = payload;
            MyService.ConsoleLog("countires : ", subcatdata);
            $scope.allLocations = subcatdata;
            if ($scope.isDefaultSelected) {
              $scope.setByDefaultState($scope.allLocations);
            }
          },
          function (errorPayload) {
            alert("Something went wrong ");
          }
        );
      };
      $scope.getAllStates();

      $scope.allLocations = [];
      $scope.allCounties = [];
      $scope.selectedArea = [];
      $scope.rmselectedArea = [];
      $scope.myselectionarea = [];
      $scope.disabledLocation = [];

      $scope.checkExists = function (rdata, val) {
        return rdata.filter(function (rdata) {
          if (rdata.state == val) return rdata;
        });
      };

      $scope.checkCountyExists = function (rdata, val) {
        return rdata.filter(function (rdata) {
          if (rdata.county == val) return rdata;
        });
      };

      $scope.checkCountryExists = function (rdata, val) {
        return rdata.filter(function (rdata) {
          if (rdata.country == val) return rdata;
        });
      };

      $scope.checkDisabled = function (data, stateId, type) {
        data.country = "United States of America";
        data.state = stateId;

        var idx = indexOfExt($scope.disabledLocation, data);
        if (idx > -1) return true;
        else return false;
      };

      $scope.getAreaVal = function (data, stateId, type) {
        if (!data.country) {
          data.country = "United States of America";
        }
        if (!data.state) {
          data.state = stateId;
        }

        var idx = indexOfExt($scope.selectedArea, data);

        if (idx > -1) {
          alert("You have already selected the location");
        } else {
          $scope.selectedArea.push(data);
          $scope.disabledLocation.push(data);
        }

        MyService.ConsoleLog(
          "$scope.disabledLocation",
          $scope.disabledLocation
        );
        MyService.ConsoleLog("$scope.selectedArea", $scope.selectedArea);
      };
      $scope.selectedLAll = {
        id: [],
      };
      $scope.removeAreaVal = function (data) {
        var idx = $scope.selectedArea.indexOf(data);

        //MyService.ConsoleLog($scope.Topic.Locations);
        if (idx > -1) {
          //MyService.ConsoleLog("Country:",$scope.selectedArea[idx].country);
          if ($scope.selectedArea[idx].country == "International") {
            $scope.Topic.Locations = "NO";
          }
          if ($scope.selectedArea[idx].country == "National (USA)") {
            $scope.Topic.National = "NO";
          }
          $scope.selectedArea.splice(idx, 1);
          var jdx = $scope.disabledLocation.indexOf(data);
          if (jdx > -1) {
            $scope.disabledLocation.splice(jdx, 1);
          }
        }
        $scope.selectedLAll.id.length = 0;
        //MyService.ConsoleLog($scope.selectedArea);
        var allLen = $scope.selectedArea.length;
        var chkboxe = document.getElementsByName("checkedid");
        for (var i = 0; i < allLen; i++) {
          chkboxe[i].checked = true;
        }
      };
      $scope.allCounties = [];
      $scope.allLocals = [];
      $scope.setLocation = function (option) {
        $scope.Essay.location = option;
      };
      $scope.getLocations = function (val, type) {
        if (type == "National") {
          if (val == "National") {
            var nobj = {
              country: "National (USA)",
            };
            $scope.selectedArea.push(nobj);
            //MyService.ConsoleLog($scope.selectedArea);
          }
          if (val == "NO") {
            var nobj = {
              country: "National (USA)",
            };
            var idx = indexOfExt($scope.selectedArea, nobj);
            if (idx > -1) {
              $scope.selectedArea.splice(idx, 1);
            }
          }
        } else if (type == "International") {
          if (val == "International") {
            // $scope.selectedArea.length = 0;
            var nobj = {
              country: "International",
            };
            $scope.selectedArea.push(nobj);
            MyService.ConsoleLog("$scope.selectedArea", $scope.selectedArea);
          }
          if (val == "NO") {
            // $scope.selectedArea.length = 0;
            var nobj = {
              country: "International",
            };
            var idx = indexOfExt($scope.selectedArea, nobj);
            if (idx > -1) {
              $scope.selectedArea.splice(idx, 1);
            }
          }
        }
      };

      $scope.setByDefaultCounty = function (cdata) {
        // MyService
        cdata.filter(function (count) {
          if (count.countyName.indexOf($scope.uData.address.county) > -1) {
            $scope.selectedArea.push(count);
            $scope.disabledLocation.push(count);
            $scope.getLocals($scope.nwStateFips, count.countyFips);
          }
        });
      };

      $scope.AddCountry = function () {
        if ($scope.newlocation.country && $scope.newlocation.country != "") {
          var idx = $scope.Allcountries.indexOf($scope.newlocation.country);
          if (idx > -1) {
            var nobj = {
              country: $scope.newlocation.country,
            };
            $scope.selectedArea.push(nobj);
          } else {
            alert(
              "Country does not exists in our database. Please check if you have entered correct name."
            );
          }
        } else {
          alert("Please enter country name");
        }
      };
      $scope.showLoading = [];

      $scope.getCounties = function (state) {
        console.log("state > ", state);
        $scope.showLoading.push(state);
        if (
          !$scope.allCounties[state] ||
          $scope.allCounties[state].length == 0
        ) {
          MyService.getAllCounties(state).then(
            function (payload) {
              MyService.ConsoleLog("Payload >> ", payload);
              $scope.showLoading.length = 0;
              var sublocations = payload;
              $scope.counties = payload;
              MyService.ConsoleLog("$scope.counties > ", $scope.counties);
              if (!$scope.allCounties) {
                $scope.allCounties = [];
              }
              var upCounty = sublocations.filter(function (coun) {
                coun.county = "";
                coun.county = coun.countyName;
                return coun;
              });
              $scope.allCounties[state] = upCounty;

              if ($scope.isDefaultSelected) {
                $scope.setByDefaultCounty(sublocations);
              }
            },
            function (errorPayload) {
              alert("Something went wrong.");
            }
          );
        } else {
          $scope.showLoading.length = 0;
          $scope.allCounties[state].length = 0;
        }
      };
      $scope.setByDefaultLocal = function (ldata) {
        // MyService
        ldata.filter(function (local) {
          if (local.placeName.indexOf($scope.uData.address.place) > -1) {
            $scope.selectedArea.push(local);
            $scope.disabledLocation.push(local);
          }
        });
      };

      $scope.getLocals = function (state, county) {
        $scope.showLoadingCounty.push(county);
        if (
          !$scope.allLocals[state] ||
          !$scope.allLocals[state][county] ||
          $scope.allLocals[state][county].length == 0
        ) {
          MyService.getAllSubCountiesLocal(state, "", county).then(
            function (payload) {
              $scope.showLoadingCounty.length = 0;
              MyService.ConsoleLog("payload Locals : ", payload);
              if (!$scope.allLocals[state]) {
                $scope.allLocals[state] = [];
              }
              var upPlaces = payload.places.filter(function (pla) {
                pla.place = "";
                pla.place = pla.placeName;
                return pla;
              });
              // MyService.ConsoleLog("upPlaces", upPlaces);
              $scope.allLocals[state][county] = upPlaces;
              if ($scope.isDefaultSelected) {
                $scope.setByDefaultLocal(payload.places);
              }
            },
            function (errorPayload) {
              alert("Something went wrong ");
            }
          );
        } else {
          $scope.showLoadingCounty.length = 0;
          $scope.allLocals[state][county].length = 0;
        }
      };

      $scope.ShowLocation = function () {
        $scope.ShowLocationOptions = true;
        $scope.isDefaultSelected = true;
        MyService.getAllCountries().then(
          function (payload) {
            $scope.Allcountries = payload;
            // MyService.ConsoleLog("$scope.Allcountries", $scope.Allcountries);
          },
          function (errorPayload) {
            alert("Something went wrong ");
          }
        );
        $scope.getAllStates();
      };

      $("#addDebateForm").validationEngine();
    },
  ]);

'use strict';
angular.module('myApp.addCategory', ['ngRoute'])

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/addCategory/:type?', {
      templateUrl: 'app/addCategory/addCategory.html',
      controller: 'addCategoryCtrl'
    });
  }]).controller('addCategoryCtrl', ['$scope', '$http', '$location', 'apiCall', '$rootScope', 'baseApiUrl', '$q', '$filter', 'growl', 'ngDialog', 'tokenService', 'MyService', '$routeParams', function ($scope, $http, $location, apiCall, $rootScope, baseApiUrl, $q, $filter, growl, ngDialog, tokenService, MyService, $routeParams) {
    //MyService.ConsoleLog("** dashboardCtrl **");
    $rootScope.welcome = false;
    $scope.allParentCats = [];
    $scope.statusGetCats = 0;
    $scope.alert_msg = false;
    $scope.success_msg = false;
    // $scope.search = false;
    MyService.ConsoleLog("$routeParams.type :", $routeParams.type);

    if ($routeParams.type && $routeParams.type != "") {
      $scope.showAddCategories = true;
    } else {
      $scope.showUpdateCategories = true;
    }

    $rootScope.getParentCategories = function (idx) {
      //MyService.ConsoleLog("getParentCategories: ", idx);
      //
      if (idx == 0) {
        $scope.allParentCats = [];
      }
      $scope.statusGetCats = 1;
      var request = apiCall.apiCall('GET', '/categories/list', {
        root: 1,
        questions_counter: 0
      });
      request.headers['Cache-Control'] = 'No-Store';
      $http(
        request
      ).then(function successCallback(response) {
        if (response.data.success) {
          $scope.parentCategories = response.data.data;
          /*
          $scope.selectedCategories = [{ "selected": null, viewOrders: 0, "items": $scope.parentCategories }];
          $scope.selCatForQues = [{ "selected": null, viewOrders: 0, "items": $scope.parentCategories }];
          $scope.selCatForCatUpdate = [{ "selected": null, viewOrders: 0, "items": $scope.parentCategories }];
          $scope.selCatForNewCatUpdate = [{ "selected": null, viewOrders: 0, "items": $scope.parentCategories }];*/
          $scope.allParentCats[idx] = [{
            "selected": null,
            viewOrders: 0,
            "items": $scope.parentCategories
          }];
          $scope.selCatForCatUpdate = [{
            "selected": null,
            viewOrders: 0,
            "items": $scope.parentCategories
          }];
          $scope.selCatForNewCatUpdate = [{
            "selected": null,
            viewOrders: 0,
            "items": $scope.parentCategories
          }];
          $scope.statusGetCats = 2;
        } else {
          //MyService.ConsoleLog(response.data.error);
          growl.error("Something went wrong");
          $scope.statusGetCats = 3;
        }
      }, function errorCallBack(response) {
        growl.error("Something went wrong");
        $scope.statusGetCats = 3;
      });
    }
    $rootScope.getParentCategories(0);

    $scope.addOneMoreParent = function () {
      var idx = $scope.allParentCats.length;
      $scope.getParentCategories(idx);
    };
    $scope.removeParent = function (pindex) {
      // body...
      //MyService.ConsoleLog("removeParent pindex: ", pindex);
      // $scope.allParentCats.length = pindex;
      $scope.allParentCats.splice(pindex, 1);
    };
    $scope.hideAll = function () {
      //alert("1");
      $rootScope.showProfile = false;
      $rootScope.showPoliProfile = false;
      $rootScope.showFollowing = false;
      $scope.showAddCategories = false;
      $scope.showUpdateCategories = false;
      $scope.showAddQuestion = false;
      $rootScope.showReportQuestion = false;
      $scope.showFiveMatchQuestion = false;
      $scope.showUserVerification = false;
      $rootScope.showAllCongressman = false;
      $rootScope.showCongressbills = false;
      $rootScope.showUpload = false;
      $rootScope.showVUpload = false;
      $rootScope.showRUpload = false;
      $rootScope.showHUpload = false;
      $rootScope.showOrganized = false;
      $rootScope.showAdvocates = false;
      $rootScope.showPress = false;
      $rootScope.showTopicSpam = false;
      $rootScope.showAllUsers = false;
      $rootScope.showAllTopic = false;
      $rootScope.showAllEssay = false;
      $rootScope.showAllEmail = false;
      $rootScope.showOpenFec = false;
      $rootScope.showOpenFecCommittee = false;

      $rootScope.showPlacesShape = false;
      $rootScope.showAllRecommendation = false;
      $scope.showBackup = false;

    }

    // $scope.parentCategories = angular.copy($rootScope.categories);


    /*
    $rootScope.$on("EventParentCategoriesFetched", function() {
        $scope.parentCategories = angular.copy($rootScope.categories);
        $scope.selectedCategories = [{ "selected": null, viewOrders: 0, "items": $scope.parentCategories }];
        $scope.selCatForQues = [{ "selected": null, viewOrders: 0, "items": $scope.parentCategories }];

        $scope.selCatForCatUpdate = [{ "selected": null, viewOrders: 0, "items": $scope.parentCategories }];
        $scope.selCatForNewCatUpdate = [{ "selected": null, viewOrders: 0, "items": $scope.parentCategories }];
    });
    */

    // $scope.showAddCategories = false;

    $scope.cattypes = [{
      lbl: "Essay",
      val: "E"
    }, {
      lbl: "For forum",
      val: "F"
    }, {
      lbl: "For questions",
      val: "Q"
    }, {
      lbl: "Hide Category",
      val: "H"
    }];
    $scope.updateCatTypes = angular.copy($scope.cattypes);

    /*
    $scope.catTypeSelected = function (val, selected) {
        //MyService.ConsoleLog("* catTypeSelected *", val);
            if(!$scope.category.catType) $scope.category.catType = [];

            var idx = $scope.category.cat_type.indexOf(val);
            if(selected)
                $scope.category.catType.push(val);
            else
                $scope.category.catType.splice(idx, 1);

            //MyService.ConsoleLog("category.catType: ",$scope.category.catType);
    };
    $scope.updateCatTypeSelected = function (val, selected) {
        //MyService.ConsoleLog("* updateCatTypeSelected *", val);

            var idx = $scope.updateCat.cat_type.indexOf(val);
            if(selected)
                $scope.updateCat.cat_type.push(val);
            else
                $scope.updateCat.cat_type.splice(idx, 1);

        //MyService.ConsoleLog("updateCatTypeSelected: ",$scope.updateCat.cat_type);
    };
    */

    $scope.initVarCat = function () {
      $scope.category = {
        title: '',
        parentIds: [],
        viewOrders: [],
        description: '',
        viewOrder: 0,
        files: null,
        catType: []
      };
      $scope.selectedCategories = [{
        "selected": null,
        viewOrders: 0,
        "items": $scope.parentCategories
      }];
      angular.forEach($scope.cattypes, function (c, i) {
        c.selected = false;
      });
    };
    $scope.initVarCat();

    $scope.addCategory = function () {
      /*
      var tempParentIds = [],
          tempViewOrders = [];
      angular.forEach($scope.selectedCategories, function(val, key) {
          //MyService.ConsoleLog("key: ", key, " val: ", val);
          if (val) {
              // val = JSON.parse(val);
              var selectedVal = JSON.parse(val.selected);
              if (selectedVal && selectedVal._id) {
                  tempParentIds.push(selectedVal._id);
                  tempViewOrders[0] = val.viewOrders;
              }
          }
      });*/
      //MyService.ConsoleLog("allParentCats: ", $scope.allParentCats);
      var tempParentIdsAll = [],
        tempViewOrders = [];
      angular.forEach($scope.allParentCats, function (pcat, i) {
        // body...
        var tempParentIds = [];
        var len = pcat.length;
        var tViewOrder = null;
        angular.forEach(pcat, function (val, key) {
          //MyService.ConsoleLog("key: ", key, " val: ", val);
          if (val) {
            // val = JSON.parse(val);
            var selectedVal = JSON.parse(val.selected);
            if (selectedVal && selectedVal._id) {
              tempParentIds.push(selectedVal._id);
              tViewOrder = val.viewOrders;
            }
          }
        });
        //MyService.ConsoleLog("tViewOrder: ", tViewOrder);
        if (tViewOrder != null) tempViewOrders.push(tViewOrder);
        tempParentIdsAll.push(tempParentIds.join(","));
      });

      //MyService.ConsoleLog("--------------------------------");
      //MyService.ConsoleLog("tempParentIdsAll: ", tempParentIdsAll);
      //MyService.ConsoleLog("tempViewOrders: ", tempViewOrders);
      //MyService.ConsoleLog("cat_type: ", $scope.category.cat_type);
      var fd = new FormData();
      fd.append("title", $scope.category.title);
      fd.append("description", $scope.category.description);
      //MyService.ConsoleLog("category files: ", $scope.category.files);

      angular.forEach($scope.category.files, function (file) {
        //MyService.ConsoleLog("append file", file);
        fd.append('file', file);
      });

      fd.append('file', $scope.category.files);

      if (tempParentIdsAll.length > 0) {
        fd.append("parentIds", tempParentIdsAll.join(";"));
        fd.append("viewOrders", tempViewOrders.join(","));
      } else {
        fd.append("viewOrder", $scope.category.viewOrder);
      }


      var tempCatTypes = [];
      angular.forEach($scope.cattypes, function (c, i) {
        if (c.selected) {
          tempCatTypes.push(c.val);
        }
      });
      if (tempCatTypes <= 0) {
        growl.error("At least select one category type.");
        return;
      } else {
        fd.append("catType", tempCatTypes.join(","));
      }
      //MyService.ConsoleLog("formData: ",fd);
      var posturl = baseApiUrl + "/categories/create";
      $http({
        method: 'POST',
        url: posturl,
        // headers: { 'Content-Type': false },
        headers: {
          'Content-Type': undefined,
          'x-access-token': tokenService.getToken(),
          'Cache-Control': 'No-Store'
        },
        transformRequest: angular.identity,
        //Create an object that contains the model and files which will be transformed
        // in the above transformRequest method
        data: fd
      }).then(function (response, status, headers, config) {
        //MyService.ConsoleLog("success data: ", response.data);
        if (response.data.success) {
          $scope.initVarCat();
          $rootScope.getCategories();
          $rootScope.getParentCategories(0);
          growl.success("Added successfully!");
        } else if (response.data.error && typeof response.data.error == "string") {
          growl.error('Error: ' + response.data.error);
        } else {
          growl.error('Something went wrong.');
        }
      }, function (data, status, headers, config) {
        //MyService.ConsoleLog("error: ", data);
        growl.error("Something went wrong");
      });

      $scope.showProfile = false;
      $rootScope.showProfile = false;
      $rootScope.showUpload = false;
      $rootScope.showAllCongressman = false;
      $rootScope.showCongressbills = false;
      $rootScope.showVUpload = false;
      $rootScope.showRUpload = false;
      $rootScope.showHUpload = false;
      $rootScope.showOrganized = false;
      $rootScope.showAdvocates = false;
      $rootScope.showFollowing = false;
      $rootScope.showTopicSpam = false;
      $rootScope.showAllTopic = false;
      $rootScope.showReportQuestion = false;
      $scope.showFiveMatchQuestion = false;
      $rootScope.showAllEssay = false;
      $rootScope.showPress = false;
      $rootScope.showAllEvents = false;

      //$root.showAdvocates = !$root.showAdvocates
      //MyService.ConsoleLog("addCategory", $scope.category);

      /*
      var fd = new FormData();
      fd.append("title", $scope.category.title);
      fd.append("description", $scope.category.title);
      //MyService.ConsoleLog("category files: ", $scope.category.files);
      angular.forEach($scope.category.files, function(file){
          //MyService.ConsoleLog("append file", file);
          fd.append('file', file);
      });
      fd.append('file', $scope.category.files);
      var tempParentIds = [], tempViewOrders = [];
      angular.forEach($scope.category.parentIds, function(val, key){
          tempParentIds.push(val._id);
          tempViewOrders.push(val.viewOrders);
      });
      if(tempParentIds.length > 0){
          fd.append("parentIds", tempParentIds.join(","));
          fd.append("viewOrders", tempViewOrders.join(","));
      }
      //MyService.ConsoleLog("formData: ",fd);
      var posturl = baseApiUrl+"/categories/create";
      $http({
          method: 'POST',
          url: posturl,
          // headers: { 'Content-Type': false },
          headers: {'Content-Type': undefined},
          transformRequest: angular.identity,
          //Create an object that contains the model and files which will be transformed
          // in the above transformRequest method
          data: fd
      }).
      success(function (data, status, headers, config) {
          //MyService.ConsoleLog("success data: ",data);
          if(data.success){
              $scope.initVarCat();
              $rootScope.getCategories();
              alert("Added successfully!");
          }
          else{
              alert("Error: ", data.error);
          }
      }).
      error(function (data, status, headers, config) {
          //MyService.ConsoleLog("error: ",data);
          alert("failed!");
      });
       */
    };

    $scope.toggleCategorySelection = function (cat) {
      //MyService.ConsoleLog(" toggleCategorySelection ");
      var idx = $scope.category.parentIds.indexOf(cat);

      // is currently selected
      if (idx > -1) {
        $scope.category.parentIds.splice(idx, 1);
      }
      // is newly selected
      else {
        $scope.category.parentIds.push(cat);
        $scope.statusGetCats = 1;
        var request = apiCall.apiCall('GET', '/categories/list', {
          root: 1,
          questions_counter: 0,
          parentId: cat._id
        });
        request.headers['Cache-Control'] = 'No-Store';
        $http(
          request
        ).then(function successCallback(response) {
          if (response.data.success) {
            //MyService.ConsoleLog("Got subcategory data: ", response.data.data);
            // $scope.secondLevelCat = response.data.data;
            cat.subcategory = response.data.data;
            $scope.statusGetCats = 2;
          } else {
            $scope.statusGetCats = 3;
            growl.error("Something went wrong.");
          }
        }, function errorCallBack(response) {
          $scope.statusGetCats = 3;
          growl.error("Something went wrong.");
        });
      }
    };

    var toogleAddCatSelCanceler = $q.defer();
    $scope.toogleAddCatSel = function (cat, index, pindex) {
      cat = JSON.parse(cat);
      //MyService.ConsoleLog("$scope.selectedCategories: ",$scope.selectedCategories);
      //MyService.ConsoleLog("tempFun index: ", index, "pindex: ", pindex);
      /*
      //remove all elements after given index
      $scope.selectedCategories.length = index + 1;

      toogleAddCatSelCanceler.resolve();
      var params = {
          questions_counter: 0,
          parentId: cat._id,
          timeout: toogleAddCatSelCanceler.promise
      };
      var request = apiCall.apiCall('GET', '/categories/list', params);
      $http(
          request
      ).then(function successCallback(response) {
          if (response.data.success) {
              //MyService.ConsoleLog("Got subcategory data: ", response.data.data);
              if (response.data.data.length > 0)
                  $scope.selectedCategories.push({ "selected": null, viewOrders: 0, "items": response.data.data });
          } else {
              //MyService.ConsoleLog("Something went wrong: ", response.data);
          }
      }, function errorCallBack(response) {
          //MyService.ConsoleLog("Error: ", response);
      });
      */
      //MyService.ConsoleLog("allParentCats: ", $scope.allParentCats);
      $scope.allParentCats[pindex].length = index + 1;

      toogleAddCatSelCanceler.resolve();
      var params = {
        questions_counter: 0,
        parentId: cat._id,
        timeout: toogleAddCatSelCanceler.promise
      };
      var request = apiCall.apiCall('GET', '/categories/list', params);
      request.headers['Cache-Control'] = 'No-Store';
      $http(
        request
      ).then(function successCallback(response) {
        if (response.data.success) {
          //MyService.ConsoleLog("Got subcategory data: ", response.data.data);
          if (response.data.data.length > 0) {
            //MyService.ConsoleLog("allParentCats 2: ", $scope.allParentCats);
            //MyService.ConsoleLog("index: ", index, " pindex: ", pindex);
            $scope.allParentCats[pindex].push({
              "selected": null,
              viewOrders: 0,
              "items": response.data.data
            });
            //MyService.ConsoleLog("allParentCats 3: ", $scope.allParentCats);
          }
        } else {
          //MyService.ConsoleLog("Something went wrong: ", response.data);
        }
      }, function errorCallBack(response) {
        //MyService.ConsoleLog("Error: ", response);
      });
    };

    //--------- update category ----------------

    $scope.initUpdateCat = function () {
      $scope.updateCat = {
        id: null,
        title: '',
        parentIds: [],
        viewOrders: [],
        description: '',
        viewOrder: 0,
        files: null,
        iconImage: null,
        old_path: null,
        catType: null
      };
      $scope.selCatForCatUpdate = [{
        "selected": null,
        viewOrders: 0,
        "items": $scope.parentCategories
      }];
      $scope.selCatForNewCatUpdate = [{
        "selected": null,
        viewOrders: 0,
        "items": $scope.parentCategories
      }];
      angular.forEach($scope.updateCatTypes, function (c, i) {
        c.selected = false;
      });
    };
    $scope.initUpdateCat();

    var toggleUpdateCatSelCanceler = $q.defer();
    $scope.toggleUpdateCatSel = function (cat, index) {
      cat = JSON.parse(cat);
      //MyService.ConsoleLog("toggleUpdateCatSel : ", cat);
      $scope.updateCat.id = cat._id;
      $scope.updateCat.title = cat.title;
      $scope.updateCat.description = cat.description;
      if (cat.fbTitle) {
        $scope.updateCat.fbtitle = cat.fbTitle;
      }
      if (cat.fbDescription) {
        $scope.updateCat.fbdescription = cat.fbDescription;
      }
      $scope.updateCat.viewOrder = cat.order;
      $scope.selCatForCatUpdate[index].viewOrders = cat.order;
      //MyService.ConsoleLog(" viewOrders index: ", $scope.selCatForCatUpdate[index].viewOrders);

      angular.forEach($scope.updateCatTypes, function (c, i) {
        c.selected = false; //reset all selected categories
      });
      if (cat.catType) {
        angular.forEach(cat.catType, function (val, key) {
          angular.forEach($scope.updateCatTypes, function (c, i) {
            if (c.val == val) {
              c.selected = true;
            }
          });
        });
        // $scope.updateCat.cat_type = cat.cat_type;
        // angular.forEach($scope.cattypes, function(val, key){
        //  if(val.val == cat.cat_type)
        //      $scope.updateCat.cat_type = val;
        // });
      }
      $scope.updateCat.iconImage = cat.iconImage;
      if (cat.fbImage) {
        $scope.updateCat.fbimage = cat.fbImage;
      }
      //MyService.ConsoleLog("response.data: ", cat);
      try {
        $scope.updateCat.old_path = cat.parentIds._id;
      } catch (e) {
        //MyService.ConsoleLog("Exception :", old_path);
      }

      //remove all elements after given index
      $scope.selCatForCatUpdate.length = index + 1;

      toggleUpdateCatSelCanceler.resolve();
      var params = {
        questions_counter: 0,
        parentId: cat._id,
        timeout: toggleUpdateCatSelCanceler.promise
      };
      var request = apiCall.apiCall('GET', '/categories/list', params);
      request.headers['Cache-Control'] = 'No-Store';
      $http(
          request
        )
        .then(function successCallback(response) {
          if (response.data.success) {
            MyService.ConsoleLog("Got subcategory data: ", response.data.data);
            if (response.data.data.length > 0) {
              $scope.selCatForCatUpdate.push({
                "selected": null,
                viewOrders: 0,
                "items": response.data.data
              });
            }
          } else {
            //MyService.ConsoleLog("Something went wrong: ", response.data);
          }
        }, function errorCallBack(response) {
          //MyService.ConsoleLog("Error: ", response);
        });
    };

    var toggleUpdateNewCatSelCanceler = $q.defer();
    $scope.statusUpdateGetCats = 0;
    $scope.toggleUpdateNewCatSel = function (cat, index) {
      cat = JSON.parse(cat);
      //MyService.ConsoleLog("$scope.selectedCategories: ",$scope.selectedCategories);
      //MyService.ConsoleLog("tempFun index: ", index);
      //remove all elements after given index
      $scope.selCatForNewCatUpdate.length = index + 1;
      toggleUpdateNewCatSelCanceler.resolve();
      toggleUpdateNewCatSelCanceler = $q.defer();
      var params = {
        questions_counter: 0,
        parentId: cat._id,
      };
      $scope.statusUpdateGetCats = 1;
      var request = apiCall.apiCall('GET', '/categories/list', params);
      request.headers['Cache-Control'] = 'No-Store';
      request.timeout = toggleUpdateNewCatSelCanceler.promise;
      $http(
        request
      ).then(function successCallback(response) {
        if (response.data.success) {
          //MyService.ConsoleLog("Got subcategory data: ", response.data.data);
          if (response.data.data.length > 0)
            $scope.selCatForNewCatUpdate.push({
              "selected": null,
              viewOrders: 0,
              "items": response.data.data
            });
          $scope.statusUpdateGetCats = 2;
        } else {
          $scope.statusUpdateGetCats = 3;
          growl.error("Something went wrong.");
        }
      }, function errorCallBack(response) {
        //MyService.ConsoleLog("Error: ", response);
        $scope.statusUpdateGetCats = 3;
        growl.error("Something went wrong.");
      });
    };

    $scope.updateCategory = function () {
      //MyService.ConsoleLog("** updateCategory **");

      var tempParentIds = [],
        tempViewOrders = [];
      var parent_path_id = 0;
      var parent_path_order = 0;
      angular.forEach($scope.selCatForCatUpdate, function (val, key) {
        //MyService.ConsoleLog("key: ", key, " val: ", val);
        if (val) {
          // val = JSON.parse(val);
          var selectedVal = JSON.parse(val.selected);
          if (selectedVal && selectedVal._id) {
            // tempParentIds.push(selectedVal._id);
            // tempViewOrders[0] = val.viewOrders;
            //MyService.ConsoleLog("** parentIds: ", selectedVal.parentIds);
            parent_path_id = selectedVal.parentIds._id;
            parent_path_order = val.viewOrders;
          }
        }
      });
      //MyService.ConsoleLog("parent_pathid :", parent_path_id);
      //MyService.ConsoleLog("parent_path_order :", parent_path_order);
      //MyService.ConsoleLog("tempParentIds: ",tempParentIds);
      //MyService.ConsoleLog("tempViewOrders: ",tempViewOrders);




      var fd = new FormData();
      fd.append("id", $scope.updateCat.id);
      fd.append("title", $scope.updateCat.title);
      fd.append("description", $scope.updateCat.description);
      fd.append("fbtitle", $scope.updateCat.fbtitle);
      fd.append("fbdescription", $scope.updateCat.fbdescription);

      if (parent_path_id) {
        fd.append("parent_path_id", parent_path_id);
        fd.append("parent_path_order", parent_path_order);
      }

      //MyService.ConsoleLog("category files: ", $scope.updateCat.files);

      angular.forEach($scope.updateCat.files, function (file) {
        //MyService.ConsoleLog("append file", file);
        fd.append('file', file);
      });

      fd.append('file', $scope.updateCat.files);

      fd.append('fbfile', $scope.updateCat.fbimage);

      if (tempParentIds.length > 0) {
        fd.append("parentIds", tempParentIds.join(","));
        fd.append("viewOrders", tempViewOrders.join(","));
      } else {
        fd.append("viewOrder", $scope.updateCat.viewOrder);
      }

      var tempCatTypes = [];

      angular.forEach($scope.updateCatTypes, function (c, i) {
        if (c.selected) {
          tempCatTypes.push(c.val);
        }
      });

      if (tempCatTypes <= 0) {
        growl.error("At least select one category type.");
        return;
      } else {
        fd.append("catType", tempCatTypes.join(","));
      }
      //MyService.ConsoleLog(fd);
      var posturl = baseApiUrl + "/categories/create";
      $http({
          method: 'POST',
          url: posturl,
          // headers: { 'Content-Type': false },
          headers: {
            'Content-Type': undefined,
            'Cache-Control': 'No-Store'
          },
          transformRequest: angular.identity,
          //Create an object that contains the model and files which will be transformed
          // in the above transformRequest method
          data: fd
        })
        .then(function (data, status, headers, config) {
          //MyService.ConsoleLog("success data: ", data);
          if (data.data.success) {
            growl.success('Updated successfully.');
            $rootScope.getCategories();
            $scope.getParentCategories();
            $scope.initUpdateCat();
          } else if (data.data.error && typeof data.error == "string") {
            growl.error('Error: ' + data.error);
          } else {
            growl.error('Something went wrong.');
          }
        }, function (data, status, headers, config) {
          //MyService.ConsoleLog("error >> ", data);
          growl.error('Something went wrong.');
        });
    };

    $scope.removeCategory = function () {
      //MyService.ConsoleLog("-- removeCategory --");
      if (!$scope.updateCat || !$scope.updateCat.id) {
        growl.error("Select category first.");
        return;
      }

      var old_path_ids = null;
      var category_id = null;

      angular.forEach($scope.selCatForCatUpdate, function (val, key) {
        try {
          var selObj = JSON.parse(val.selected);
          if (selObj._id) {
            category_id = selObj._id;
            // selObj.parentIds = JSON.parse(selObj.parentIds);
            old_path_ids = selObj.parentIds._id;
          }
        } catch (e) {
          //MyService.ConsoleLog("Exception: ", e)
        }
      });

      var postobj = {
        id: category_id,
        old_path_ids: old_path_ids
      };

      //MyService.ConsoleLog("postobj : ", postobj);
      var request = apiCall.apiCall('POST', "/categories/remove", postobj);
      $http(
        request
      ).then(function successCallback(response) {
        //MyService.ConsoleLog("Got categories: ",response);
        if (response.data.success) {
          growl.success('Removed successfully.');
          $rootScope.getCategories();
          $scope.getParentCategories();
          $scope.initUpdateCat();
        } else if (response.data.error && typeof response.data.error == "string") {
          growl.error('Error: ' + response.data.error);
        } else {
          growl.error('Something went wrong.');
        }
      }, function errorCallBack(response) {
        growl.error('Something went wrong.');
      });

    };

    $scope.updateParentCategory = function () {
      //MyService.ConsoleLog("-- updateParentCategory --");
      //MyService.ConsoleLog("selCatForNewCatUpdate: ", $scope.selCatForNewCatUpdate);
      var tempParentIds = [],
        tempViewOrders = [];
      angular.forEach($scope.selCatForNewCatUpdate, function (val, key) {
        try {
          var selObj = JSON.parse(val.selected);
          if (selObj._id) {
            tempParentIds.push(selObj._id);
            tempViewOrders[0] = val.viewOrders;
          }
        } catch (e) {
          //MyService.ConsoleLog("Exception: ", e)
        }
      });

      var old_path_ids = null;
      angular.forEach($scope.selCatForCatUpdate, function (val, key) {
        try {
          var selObj = JSON.parse(val.selected);
          if (selObj._id) {
            // selObj.parentIds = JSON.parse(selObj.parentIds);
            old_path_ids = selObj.parentIds._id;
          }
        } catch (e) {
          //MyService.ConsoleLog("Exception: ", e)
        }
      });

      //MyService.ConsoleLog("tempParentIds: ",tempParentIds);
      //MyService.ConsoleLog("tempViewOrders: ",tempViewOrders);
      if (!$scope.updateCat || !$scope.updateCat.id) {
        growl.error("Select category first.");
      } else {
        var postobj = {
          parentIds: tempParentIds.join(","),
          viewOrders: tempViewOrders.join(","),
          id: $scope.updateCat.id,
          old_path_ids: old_path_ids,
          viewOrder: $scope.updateCat.viewOrder
        };
        //MyService.ConsoleLog("postobj: ", postobj);

        /*
        var message = 'Continue?';
        var modal = ngDialog.openConfirm({
            template:'<p>'+message+'</p>\
                    <div class="ngdialog-buttons">\
                        <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">OK</button>\
                    </div>',
            plain: true
        });
        modal.then(function fullfilled(data){
            //MyService.ConsoleLog("fullfilled: ",data);
        }, function rejected(data){
            //MyService.ConsoleLog("rejected: ",data);
        });
        */

        var request = apiCall.apiCall('POST', "/categories/update-parent", postobj);
        $http(
          request
        ).then(function successCallback(response) {
          if (response.data.success) {
            growl.success('Updated successfully.');
            $rootScope.getCategories();
            $scope.getParentCategories();
            $scope.initUpdateCat();
          } else if (response.data.error && typeof response.data.error == "string") {
            growl.error('Error: ' + response.data.error);
          } else {
            growl.error('Something went wrong.');
          }
        }, function errorCallBack(response) {
          growl.error('Something went wrong.');
        });
      }
    };
    $scope.addCongressBills = function () {
      MyService.ConsoleLog("In addCongressBills");
      $scope.loader = true;
      MyService.addCongressBills().then(function (data) {
        MyService.ConsoleLog('Congress bill data : ', data);
        if (data.status == 200) {
          $scope.loader = false;
          alert("Congress Bills added");
        }
      }, function (err) {
        MyService.ConsoleLog("Congress bill error: ", err);
        $scope.loader = false;
      });
    };


  }])

'use strict';

angular.module('myApp.absenteeBallots', ['ngRoute'])

.config(['$routeProvider', function ($routeProvider) {
     $routeProvider.when('/absenteeBallots', {
         templateUrl: 'app/absenteeBallots/absenteeBallots.html',
         controller: 'absenteeBallotsCtrl' 
     });
}])
.controller('absenteeBallotsCtrl', ['$scope', '$rootScope', function($scope, $rootScope) {
$rootScope.welcome = false;
}]);

'use strict';
angular.module('myApp.aboutUs', ['ngRoute'])
  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/aboutUs', {
      templateUrl: 'app/aboutUs/aboutUs.html',
      reloadOnSearch: false,
      controller: 'aboutUsCtrl' //we can name anythin
    });
  }])
  .controller('aboutUsCtrl', ['$scope', '$rootScope', '$window', function($scope, $rootScope, $window) {
    //this is controller for sampepage.html, we link the conttoler to page in config defination, check above .config
    $rootScope.welcome = false;
    $window.scrollTo(0, 0);
  }]);

'use strict';
angular.module('myApp.501c4Video', ['ngRoute'])
  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/501c4Video', {
      templateUrl: 'app/501c4Video/501c4Video.html',
      reloadOnSearch: false,
      controller: '501c4VideoCtrl' //we can name anythin
    });
  }])
  .controller('501c4VideoCtrl', ['$scope', '$rootScope', '$window', function($scope, $rootScope, $window) {
    //this is controller for sampepage.html, we link the conttoler to page in config defination, check above .config
    $rootScope.welcome = false;
    $window.scrollTo(0, 0);
  }]);

/*! jQuery v1.12.4 | (c) jQuery Foundation | jquery.org/license */
!function(a,b){"object"==typeof module&&"object"==typeof module.exports?module.exports=a.document?b(a,!0):function(a){if(!a.document)throw new Error("jQuery requires a window with a document");return b(a)}:b(a)}("undefined"!=typeof window?window:this,function(a,b){var c=[],d=a.document,e=c.slice,f=c.concat,g=c.push,h=c.indexOf,i={},j=i.toString,k=i.hasOwnProperty,l={},m="1.12.4",n=function(a,b){return new n.fn.init(a,b)},o=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,p=/^-ms-/,q=/-([\da-z])/gi,r=function(a,b){return b.toUpperCase()};n.fn=n.prototype={jquery:m,constructor:n,selector:"",length:0,toArray:function(){return e.call(this)},get:function(a){return null!=a?0>a?this[a+this.length]:this[a]:e.call(this)},pushStack:function(a){var b=n.merge(this.constructor(),a);return b.prevObject=this,b.context=this.context,b},each:function(a){return n.each(this,a)},map:function(a){return this.pushStack(n.map(this,function(b,c){return a.call(b,c,b)}))},slice:function(){return this.pushStack(e.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(a){var b=this.length,c=+a+(0>a?b:0);return this.pushStack(c>=0&&b>c?[this[c]]:[])},end:function(){return this.prevObject||this.constructor()},push:g,sort:c.sort,splice:c.splice},n.extend=n.fn.extend=function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!1;for("boolean"==typeof g&&(j=g,g=arguments[h]||{},h++),"object"==typeof g||n.isFunction(g)||(g={}),h===i&&(g=this,h--);i>h;h++)if(null!=(e=arguments[h]))for(d in e)a=g[d],c=e[d],g!==c&&(j&&c&&(n.isPlainObject(c)||(b=n.isArray(c)))?(b?(b=!1,f=a&&n.isArray(a)?a:[]):f=a&&n.isPlainObject(a)?a:{},g[d]=n.extend(j,f,c)):void 0!==c&&(g[d]=c));return g},n.extend({expando:"jQuery"+(m+Math.random()).replace(/\D/g,""),isReady:!0,error:function(a){throw new Error(a)},noop:function(){},isFunction:function(a){return"function"===n.type(a)},isArray:Array.isArray||function(a){return"array"===n.type(a)},isWindow:function(a){return null!=a&&a==a.window},isNumeric:function(a){var b=a&&a.toString();return!n.isArray(a)&&b-parseFloat(b)+1>=0},isEmptyObject:function(a){var b;for(b in a)return!1;return!0},isPlainObject:function(a){var b;if(!a||"object"!==n.type(a)||a.nodeType||n.isWindow(a))return!1;try{if(a.constructor&&!k.call(a,"constructor")&&!k.call(a.constructor.prototype,"isPrototypeOf"))return!1}catch(c){return!1}if(!l.ownFirst)for(b in a)return k.call(a,b);for(b in a);return void 0===b||k.call(a,b)},type:function(a){return null==a?a+"":"object"==typeof a||"function"==typeof a?i[j.call(a)]||"object":typeof a},globalEval:function(b){b&&n.trim(b)&&(a.execScript||function(b){a.eval.call(a,b)})(b)},camelCase:function(a){return a.replace(p,"ms-").replace(q,r)},nodeName:function(a,b){return a.nodeName&&a.nodeName.toLowerCase()===b.toLowerCase()},each:function(a,b){var c,d=0;if(s(a)){for(c=a.length;c>d;d++)if(b.call(a[d],d,a[d])===!1)break}else for(d in a)if(b.call(a[d],d,a[d])===!1)break;return a},trim:function(a){return null==a?"":(a+"").replace(o,"")},makeArray:function(a,b){var c=b||[];return null!=a&&(s(Object(a))?n.merge(c,"string"==typeof a?[a]:a):g.call(c,a)),c},inArray:function(a,b,c){var d;if(b){if(h)return h.call(b,a,c);for(d=b.length,c=c?0>c?Math.max(0,d+c):c:0;d>c;c++)if(c in b&&b[c]===a)return c}return-1},merge:function(a,b){var c=+b.length,d=0,e=a.length;while(c>d)a[e++]=b[d++];if(c!==c)while(void 0!==b[d])a[e++]=b[d++];return a.length=e,a},grep:function(a,b,c){for(var d,e=[],f=0,g=a.length,h=!c;g>f;f++)d=!b(a[f],f),d!==h&&e.push(a[f]);return e},map:function(a,b,c){var d,e,g=0,h=[];if(s(a))for(d=a.length;d>g;g++)e=b(a[g],g,c),null!=e&&h.push(e);else for(g in a)e=b(a[g],g,c),null!=e&&h.push(e);return f.apply([],h)},guid:1,proxy:function(a,b){var c,d,f;return"string"==typeof b&&(f=a[b],b=a,a=f),n.isFunction(a)?(c=e.call(arguments,2),d=function(){return a.apply(b||this,c.concat(e.call(arguments)))},d.guid=a.guid=a.guid||n.guid++,d):void 0},now:function(){return+new Date},support:l}),"function"==typeof Symbol&&(n.fn[Symbol.iterator]=c[Symbol.iterator]),n.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(a,b){i["[object "+b+"]"]=b.toLowerCase()});function s(a){var b=!!a&&"length"in a&&a.length,c=n.type(a);return"function"===c||n.isWindow(a)?!1:"array"===c||0===b||"number"==typeof b&&b>0&&b-1 in a}var t=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u="sizzle"+1*new Date,v=a.document,w=0,x=0,y=ga(),z=ga(),A=ga(),B=function(a,b){return a===b&&(l=!0),0},C=1<<31,D={}.hasOwnProperty,E=[],F=E.pop,G=E.push,H=E.push,I=E.slice,J=function(a,b){for(var c=0,d=a.length;d>c;c++)if(a[c]===b)return c;return-1},K="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",L="[\\x20\\t\\r\\n\\f]",M="(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",N="\\["+L+"*("+M+")(?:"+L+"*([*^$|!~]?=)"+L+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+M+"))|)"+L+"*\\]",O=":("+M+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+N+")*)|.*)\\)|)",P=new RegExp(L+"+","g"),Q=new RegExp("^"+L+"+|((?:^|[^\\\\])(?:\\\\.)*)"+L+"+$","g"),R=new RegExp("^"+L+"*,"+L+"*"),S=new RegExp("^"+L+"*([>+~]|"+L+")"+L+"*"),T=new RegExp("="+L+"*([^\\]'\"]*?)"+L+"*\\]","g"),U=new RegExp(O),V=new RegExp("^"+M+"$"),W={ID:new RegExp("^#("+M+")"),CLASS:new RegExp("^\\.("+M+")"),TAG:new RegExp("^("+M+"|[*])"),ATTR:new RegExp("^"+N),PSEUDO:new RegExp("^"+O),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+L+"*(even|odd|(([+-]|)(\\d*)n|)"+L+"*(?:([+-]|)"+L+"*(\\d+)|))"+L+"*\\)|)","i"),bool:new RegExp("^(?:"+K+")$","i"),needsContext:new RegExp("^"+L+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+L+"*((?:-\\d)?\\d*)"+L+"*\\)|)(?=[^-]|$)","i")},X=/^(?:input|select|textarea|button)$/i,Y=/^h\d$/i,Z=/^[^{]+\{\s*\[native \w/,$=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,_=/[+~]/,aa=/'|\\/g,ba=new RegExp("\\\\([\\da-f]{1,6}"+L+"?|("+L+")|.)","ig"),ca=function(a,b,c){var d="0x"+b-65536;return d!==d||c?b:0>d?String.fromCharCode(d+65536):String.fromCharCode(d>>10|55296,1023&d|56320)},da=function(){m()};try{H.apply(E=I.call(v.childNodes),v.childNodes),E[v.childNodes.length].nodeType}catch(ea){H={apply:E.length?function(a,b){G.apply(a,I.call(b))}:function(a,b){var c=a.length,d=0;while(a[c++]=b[d++]);a.length=c-1}}}function fa(a,b,d,e){var f,h,j,k,l,o,r,s,w=b&&b.ownerDocument,x=b?b.nodeType:9;if(d=d||[],"string"!=typeof a||!a||1!==x&&9!==x&&11!==x)return d;if(!e&&((b?b.ownerDocument||b:v)!==n&&m(b),b=b||n,p)){if(11!==x&&(o=$.exec(a)))if(f=o[1]){if(9===x){if(!(j=b.getElementById(f)))return d;if(j.id===f)return d.push(j),d}else if(w&&(j=w.getElementById(f))&&t(b,j)&&j.id===f)return d.push(j),d}else{if(o[2])return H.apply(d,b.getElementsByTagName(a)),d;if((f=o[3])&&c.getElementsByClassName&&b.getElementsByClassName)return H.apply(d,b.getElementsByClassName(f)),d}if(c.qsa&&!A[a+" "]&&(!q||!q.test(a))){if(1!==x)w=b,s=a;else if("object"!==b.nodeName.toLowerCase()){(k=b.getAttribute("id"))?k=k.replace(aa,"\\$&"):b.setAttribute("id",k=u),r=g(a),h=r.length,l=V.test(k)?"#"+k:"[id='"+k+"']";while(h--)r[h]=l+" "+qa(r[h]);s=r.join(","),w=_.test(a)&&oa(b.parentNode)||b}if(s)try{return H.apply(d,w.querySelectorAll(s)),d}catch(y){}finally{k===u&&b.removeAttribute("id")}}}return i(a.replace(Q,"$1"),b,d,e)}function ga(){var a=[];function b(c,e){return a.push(c+" ")>d.cacheLength&&delete b[a.shift()],b[c+" "]=e}return b}function ha(a){return a[u]=!0,a}function ia(a){var b=n.createElement("div");try{return!!a(b)}catch(c){return!1}finally{b.parentNode&&b.parentNode.removeChild(b),b=null}}function ja(a,b){var c=a.split("|"),e=c.length;while(e--)d.attrHandle[c[e]]=b}function ka(a,b){var c=b&&a,d=c&&1===a.nodeType&&1===b.nodeType&&(~b.sourceIndex||C)-(~a.sourceIndex||C);if(d)return d;if(c)while(c=c.nextSibling)if(c===b)return-1;return a?1:-1}function la(a){return function(b){var c=b.nodeName.toLowerCase();return"input"===c&&b.type===a}}function ma(a){return function(b){var c=b.nodeName.toLowerCase();return("input"===c||"button"===c)&&b.type===a}}function na(a){return ha(function(b){return b=+b,ha(function(c,d){var e,f=a([],c.length,b),g=f.length;while(g--)c[e=f[g]]&&(c[e]=!(d[e]=c[e]))})})}function oa(a){return a&&"undefined"!=typeof a.getElementsByTagName&&a}c=fa.support={},f=fa.isXML=function(a){var b=a&&(a.ownerDocument||a).documentElement;return b?"HTML"!==b.nodeName:!1},m=fa.setDocument=function(a){var b,e,g=a?a.ownerDocument||a:v;return g!==n&&9===g.nodeType&&g.documentElement?(n=g,o=n.documentElement,p=!f(n),(e=n.defaultView)&&e.top!==e&&(e.addEventListener?e.addEventListener("unload",da,!1):e.attachEvent&&e.attachEvent("onunload",da)),c.attributes=ia(function(a){return a.className="i",!a.getAttribute("className")}),c.getElementsByTagName=ia(function(a){return a.appendChild(n.createComment("")),!a.getElementsByTagName("*").length}),c.getElementsByClassName=Z.test(n.getElementsByClassName),c.getById=ia(function(a){return o.appendChild(a).id=u,!n.getElementsByName||!n.getElementsByName(u).length}),c.getById?(d.find.ID=function(a,b){if("undefined"!=typeof b.getElementById&&p){var c=b.getElementById(a);return c?[c]:[]}},d.filter.ID=function(a){var b=a.replace(ba,ca);return function(a){return a.getAttribute("id")===b}}):(delete d.find.ID,d.filter.ID=function(a){var b=a.replace(ba,ca);return function(a){var c="undefined"!=typeof a.getAttributeNode&&a.getAttributeNode("id");return c&&c.value===b}}),d.find.TAG=c.getElementsByTagName?function(a,b){return"undefined"!=typeof b.getElementsByTagName?b.getElementsByTagName(a):c.qsa?b.querySelectorAll(a):void 0}:function(a,b){var c,d=[],e=0,f=b.getElementsByTagName(a);if("*"===a){while(c=f[e++])1===c.nodeType&&d.push(c);return d}return f},d.find.CLASS=c.getElementsByClassName&&function(a,b){return"undefined"!=typeof b.getElementsByClassName&&p?b.getElementsByClassName(a):void 0},r=[],q=[],(c.qsa=Z.test(n.querySelectorAll))&&(ia(function(a){o.appendChild(a).innerHTML="<a id='"+u+"'></a><select id='"+u+"-\r\\' msallowcapture=''><option selected=''></option></select>",a.querySelectorAll("[msallowcapture^='']").length&&q.push("[*^$]="+L+"*(?:''|\"\")"),a.querySelectorAll("[selected]").length||q.push("\\["+L+"*(?:value|"+K+")"),a.querySelectorAll("[id~="+u+"-]").length||q.push("~="),a.querySelectorAll(":checked").length||q.push(":checked"),a.querySelectorAll("a#"+u+"+*").length||q.push(".#.+[+~]")}),ia(function(a){var b=n.createElement("input");b.setAttribute("type","hidden"),a.appendChild(b).setAttribute("name","D"),a.querySelectorAll("[name=d]").length&&q.push("name"+L+"*[*^$|!~]?="),a.querySelectorAll(":enabled").length||q.push(":enabled",":disabled"),a.querySelectorAll("*,:x"),q.push(",.*:")})),(c.matchesSelector=Z.test(s=o.matches||o.webkitMatchesSelector||o.mozMatchesSelector||o.oMatchesSelector||o.msMatchesSelector))&&ia(function(a){c.disconnectedMatch=s.call(a,"div"),s.call(a,"[s!='']:x"),r.push("!=",O)}),q=q.length&&new RegExp(q.join("|")),r=r.length&&new RegExp(r.join("|")),b=Z.test(o.compareDocumentPosition),t=b||Z.test(o.contains)?function(a,b){var c=9===a.nodeType?a.documentElement:a,d=b&&b.parentNode;return a===d||!(!d||1!==d.nodeType||!(c.contains?c.contains(d):a.compareDocumentPosition&&16&a.compareDocumentPosition(d)))}:function(a,b){if(b)while(b=b.parentNode)if(b===a)return!0;return!1},B=b?function(a,b){if(a===b)return l=!0,0;var d=!a.compareDocumentPosition-!b.compareDocumentPosition;return d?d:(d=(a.ownerDocument||a)===(b.ownerDocument||b)?a.compareDocumentPosition(b):1,1&d||!c.sortDetached&&b.compareDocumentPosition(a)===d?a===n||a.ownerDocument===v&&t(v,a)?-1:b===n||b.ownerDocument===v&&t(v,b)?1:k?J(k,a)-J(k,b):0:4&d?-1:1)}:function(a,b){if(a===b)return l=!0,0;var c,d=0,e=a.parentNode,f=b.parentNode,g=[a],h=[b];if(!e||!f)return a===n?-1:b===n?1:e?-1:f?1:k?J(k,a)-J(k,b):0;if(e===f)return ka(a,b);c=a;while(c=c.parentNode)g.unshift(c);c=b;while(c=c.parentNode)h.unshift(c);while(g[d]===h[d])d++;return d?ka(g[d],h[d]):g[d]===v?-1:h[d]===v?1:0},n):n},fa.matches=function(a,b){return fa(a,null,null,b)},fa.matchesSelector=function(a,b){if((a.ownerDocument||a)!==n&&m(a),b=b.replace(T,"='$1']"),c.matchesSelector&&p&&!A[b+" "]&&(!r||!r.test(b))&&(!q||!q.test(b)))try{var d=s.call(a,b);if(d||c.disconnectedMatch||a.document&&11!==a.document.nodeType)return d}catch(e){}return fa(b,n,null,[a]).length>0},fa.contains=function(a,b){return(a.ownerDocument||a)!==n&&m(a),t(a,b)},fa.attr=function(a,b){(a.ownerDocument||a)!==n&&m(a);var e=d.attrHandle[b.toLowerCase()],f=e&&D.call(d.attrHandle,b.toLowerCase())?e(a,b,!p):void 0;return void 0!==f?f:c.attributes||!p?a.getAttribute(b):(f=a.getAttributeNode(b))&&f.specified?f.value:null},fa.error=function(a){throw new Error("Syntax error, unrecognized expression: "+a)},fa.uniqueSort=function(a){var b,d=[],e=0,f=0;if(l=!c.detectDuplicates,k=!c.sortStable&&a.slice(0),a.sort(B),l){while(b=a[f++])b===a[f]&&(e=d.push(f));while(e--)a.splice(d[e],1)}return k=null,a},e=fa.getText=function(a){var b,c="",d=0,f=a.nodeType;if(f){if(1===f||9===f||11===f){if("string"==typeof a.textContent)return a.textContent;for(a=a.firstChild;a;a=a.nextSibling)c+=e(a)}else if(3===f||4===f)return a.nodeValue}else while(b=a[d++])c+=e(b);return c},d=fa.selectors={cacheLength:50,createPseudo:ha,match:W,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(a){return a[1]=a[1].replace(ba,ca),a[3]=(a[3]||a[4]||a[5]||"").replace(ba,ca),"~="===a[2]&&(a[3]=" "+a[3]+" "),a.slice(0,4)},CHILD:function(a){return a[1]=a[1].toLowerCase(),"nth"===a[1].slice(0,3)?(a[3]||fa.error(a[0]),a[4]=+(a[4]?a[5]+(a[6]||1):2*("even"===a[3]||"odd"===a[3])),a[5]=+(a[7]+a[8]||"odd"===a[3])):a[3]&&fa.error(a[0]),a},PSEUDO:function(a){var b,c=!a[6]&&a[2];return W.CHILD.test(a[0])?null:(a[3]?a[2]=a[4]||a[5]||"":c&&U.test(c)&&(b=g(c,!0))&&(b=c.indexOf(")",c.length-b)-c.length)&&(a[0]=a[0].slice(0,b),a[2]=c.slice(0,b)),a.slice(0,3))}},filter:{TAG:function(a){var b=a.replace(ba,ca).toLowerCase();return"*"===a?function(){return!0}:function(a){return a.nodeName&&a.nodeName.toLowerCase()===b}},CLASS:function(a){var b=y[a+" "];return b||(b=new RegExp("(^|"+L+")"+a+"("+L+"|$)"))&&y(a,function(a){return b.test("string"==typeof a.className&&a.className||"undefined"!=typeof a.getAttribute&&a.getAttribute("class")||"")})},ATTR:function(a,b,c){return function(d){var e=fa.attr(d,a);return null==e?"!="===b:b?(e+="","="===b?e===c:"!="===b?e!==c:"^="===b?c&&0===e.indexOf(c):"*="===b?c&&e.indexOf(c)>-1:"$="===b?c&&e.slice(-c.length)===c:"~="===b?(" "+e.replace(P," ")+" ").indexOf(c)>-1:"|="===b?e===c||e.slice(0,c.length+1)===c+"-":!1):!0}},CHILD:function(a,b,c,d,e){var f="nth"!==a.slice(0,3),g="last"!==a.slice(-4),h="of-type"===b;return 1===d&&0===e?function(a){return!!a.parentNode}:function(b,c,i){var j,k,l,m,n,o,p=f!==g?"nextSibling":"previousSibling",q=b.parentNode,r=h&&b.nodeName.toLowerCase(),s=!i&&!h,t=!1;if(q){if(f){while(p){m=b;while(m=m[p])if(h?m.nodeName.toLowerCase()===r:1===m.nodeType)return!1;o=p="only"===a&&!o&&"nextSibling"}return!0}if(o=[g?q.firstChild:q.lastChild],g&&s){m=q,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n&&j[2],m=n&&q.childNodes[n];while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if(1===m.nodeType&&++t&&m===b){k[a]=[w,n,t];break}}else if(s&&(m=b,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n),t===!1)while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if((h?m.nodeName.toLowerCase()===r:1===m.nodeType)&&++t&&(s&&(l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),k[a]=[w,t]),m===b))break;return t-=e,t===d||t%d===0&&t/d>=0}}},PSEUDO:function(a,b){var c,e=d.pseudos[a]||d.setFilters[a.toLowerCase()]||fa.error("unsupported pseudo: "+a);return e[u]?e(b):e.length>1?(c=[a,a,"",b],d.setFilters.hasOwnProperty(a.toLowerCase())?ha(function(a,c){var d,f=e(a,b),g=f.length;while(g--)d=J(a,f[g]),a[d]=!(c[d]=f[g])}):function(a){return e(a,0,c)}):e}},pseudos:{not:ha(function(a){var b=[],c=[],d=h(a.replace(Q,"$1"));return d[u]?ha(function(a,b,c,e){var f,g=d(a,null,e,[]),h=a.length;while(h--)(f=g[h])&&(a[h]=!(b[h]=f))}):function(a,e,f){return b[0]=a,d(b,null,f,c),b[0]=null,!c.pop()}}),has:ha(function(a){return function(b){return fa(a,b).length>0}}),contains:ha(function(a){return a=a.replace(ba,ca),function(b){return(b.textContent||b.innerText||e(b)).indexOf(a)>-1}}),lang:ha(function(a){return V.test(a||"")||fa.error("unsupported lang: "+a),a=a.replace(ba,ca).toLowerCase(),function(b){var c;do if(c=p?b.lang:b.getAttribute("xml:lang")||b.getAttribute("lang"))return c=c.toLowerCase(),c===a||0===c.indexOf(a+"-");while((b=b.parentNode)&&1===b.nodeType);return!1}}),target:function(b){var c=a.location&&a.location.hash;return c&&c.slice(1)===b.id},root:function(a){return a===o},focus:function(a){return a===n.activeElement&&(!n.hasFocus||n.hasFocus())&&!!(a.type||a.href||~a.tabIndex)},enabled:function(a){return a.disabled===!1},disabled:function(a){return a.disabled===!0},checked:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&!!a.checked||"option"===b&&!!a.selected},selected:function(a){return a.parentNode&&a.parentNode.selectedIndex,a.selected===!0},empty:function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType<6)return!1;return!0},parent:function(a){return!d.pseudos.empty(a)},header:function(a){return Y.test(a.nodeName)},input:function(a){return X.test(a.nodeName)},button:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&"button"===a.type||"button"===b},text:function(a){var b;return"input"===a.nodeName.toLowerCase()&&"text"===a.type&&(null==(b=a.getAttribute("type"))||"text"===b.toLowerCase())},first:na(function(){return[0]}),last:na(function(a,b){return[b-1]}),eq:na(function(a,b,c){return[0>c?c+b:c]}),even:na(function(a,b){for(var c=0;b>c;c+=2)a.push(c);return a}),odd:na(function(a,b){for(var c=1;b>c;c+=2)a.push(c);return a}),lt:na(function(a,b,c){for(var d=0>c?c+b:c;--d>=0;)a.push(d);return a}),gt:na(function(a,b,c){for(var d=0>c?c+b:c;++d<b;)a.push(d);return a})}},d.pseudos.nth=d.pseudos.eq;for(b in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})d.pseudos[b]=la(b);for(b in{submit:!0,reset:!0})d.pseudos[b]=ma(b);function pa(){}pa.prototype=d.filters=d.pseudos,d.setFilters=new pa,g=fa.tokenize=function(a,b){var c,e,f,g,h,i,j,k=z[a+" "];if(k)return b?0:k.slice(0);h=a,i=[],j=d.preFilter;while(h){c&&!(e=R.exec(h))||(e&&(h=h.slice(e[0].length)||h),i.push(f=[])),c=!1,(e=S.exec(h))&&(c=e.shift(),f.push({value:c,type:e[0].replace(Q," ")}),h=h.slice(c.length));for(g in d.filter)!(e=W[g].exec(h))||j[g]&&!(e=j[g](e))||(c=e.shift(),f.push({value:c,type:g,matches:e}),h=h.slice(c.length));if(!c)break}return b?h.length:h?fa.error(a):z(a,i).slice(0)};function qa(a){for(var b=0,c=a.length,d="";c>b;b++)d+=a[b].value;return d}function ra(a,b,c){var d=b.dir,e=c&&"parentNode"===d,f=x++;return b.first?function(b,c,f){while(b=b[d])if(1===b.nodeType||e)return a(b,c,f)}:function(b,c,g){var h,i,j,k=[w,f];if(g){while(b=b[d])if((1===b.nodeType||e)&&a(b,c,g))return!0}else while(b=b[d])if(1===b.nodeType||e){if(j=b[u]||(b[u]={}),i=j[b.uniqueID]||(j[b.uniqueID]={}),(h=i[d])&&h[0]===w&&h[1]===f)return k[2]=h[2];if(i[d]=k,k[2]=a(b,c,g))return!0}}}function sa(a){return a.length>1?function(b,c,d){var e=a.length;while(e--)if(!a[e](b,c,d))return!1;return!0}:a[0]}function ta(a,b,c){for(var d=0,e=b.length;e>d;d++)fa(a,b[d],c);return c}function ua(a,b,c,d,e){for(var f,g=[],h=0,i=a.length,j=null!=b;i>h;h++)(f=a[h])&&(c&&!c(f,d,e)||(g.push(f),j&&b.push(h)));return g}function va(a,b,c,d,e,f){return d&&!d[u]&&(d=va(d)),e&&!e[u]&&(e=va(e,f)),ha(function(f,g,h,i){var j,k,l,m=[],n=[],o=g.length,p=f||ta(b||"*",h.nodeType?[h]:h,[]),q=!a||!f&&b?p:ua(p,m,a,h,i),r=c?e||(f?a:o||d)?[]:g:q;if(c&&c(q,r,h,i),d){j=ua(r,n),d(j,[],h,i),k=j.length;while(k--)(l=j[k])&&(r[n[k]]=!(q[n[k]]=l))}if(f){if(e||a){if(e){j=[],k=r.length;while(k--)(l=r[k])&&j.push(q[k]=l);e(null,r=[],j,i)}k=r.length;while(k--)(l=r[k])&&(j=e?J(f,l):m[k])>-1&&(f[j]=!(g[j]=l))}}else r=ua(r===g?r.splice(o,r.length):r),e?e(null,g,r,i):H.apply(g,r)})}function wa(a){for(var b,c,e,f=a.length,g=d.relative[a[0].type],h=g||d.relative[" "],i=g?1:0,k=ra(function(a){return a===b},h,!0),l=ra(function(a){return J(b,a)>-1},h,!0),m=[function(a,c,d){var e=!g&&(d||c!==j)||((b=c).nodeType?k(a,c,d):l(a,c,d));return b=null,e}];f>i;i++)if(c=d.relative[a[i].type])m=[ra(sa(m),c)];else{if(c=d.filter[a[i].type].apply(null,a[i].matches),c[u]){for(e=++i;f>e;e++)if(d.relative[a[e].type])break;return va(i>1&&sa(m),i>1&&qa(a.slice(0,i-1).concat({value:" "===a[i-2].type?"*":""})).replace(Q,"$1"),c,e>i&&wa(a.slice(i,e)),f>e&&wa(a=a.slice(e)),f>e&&qa(a))}m.push(c)}return sa(m)}function xa(a,b){var c=b.length>0,e=a.length>0,f=function(f,g,h,i,k){var l,o,q,r=0,s="0",t=f&&[],u=[],v=j,x=f||e&&d.find.TAG("*",k),y=w+=null==v?1:Math.random()||.1,z=x.length;for(k&&(j=g===n||g||k);s!==z&&null!=(l=x[s]);s++){if(e&&l){o=0,g||l.ownerDocument===n||(m(l),h=!p);while(q=a[o++])if(q(l,g||n,h)){i.push(l);break}k&&(w=y)}c&&((l=!q&&l)&&r--,f&&t.push(l))}if(r+=s,c&&s!==r){o=0;while(q=b[o++])q(t,u,g,h);if(f){if(r>0)while(s--)t[s]||u[s]||(u[s]=F.call(i));u=ua(u)}H.apply(i,u),k&&!f&&u.length>0&&r+b.length>1&&fa.uniqueSort(i)}return k&&(w=y,j=v),t};return c?ha(f):f}return h=fa.compile=function(a,b){var c,d=[],e=[],f=A[a+" "];if(!f){b||(b=g(a)),c=b.length;while(c--)f=wa(b[c]),f[u]?d.push(f):e.push(f);f=A(a,xa(e,d)),f.selector=a}return f},i=fa.select=function(a,b,e,f){var i,j,k,l,m,n="function"==typeof a&&a,o=!f&&g(a=n.selector||a);if(e=e||[],1===o.length){if(j=o[0]=o[0].slice(0),j.length>2&&"ID"===(k=j[0]).type&&c.getById&&9===b.nodeType&&p&&d.relative[j[1].type]){if(b=(d.find.ID(k.matches[0].replace(ba,ca),b)||[])[0],!b)return e;n&&(b=b.parentNode),a=a.slice(j.shift().value.length)}i=W.needsContext.test(a)?0:j.length;while(i--){if(k=j[i],d.relative[l=k.type])break;if((m=d.find[l])&&(f=m(k.matches[0].replace(ba,ca),_.test(j[0].type)&&oa(b.parentNode)||b))){if(j.splice(i,1),a=f.length&&qa(j),!a)return H.apply(e,f),e;break}}}return(n||h(a,o))(f,b,!p,e,!b||_.test(a)&&oa(b.parentNode)||b),e},c.sortStable=u.split("").sort(B).join("")===u,c.detectDuplicates=!!l,m(),c.sortDetached=ia(function(a){return 1&a.compareDocumentPosition(n.createElement("div"))}),ia(function(a){return a.innerHTML="<a href='#'></a>","#"===a.firstChild.getAttribute("href")})||ja("type|href|height|width",function(a,b,c){return c?void 0:a.getAttribute(b,"type"===b.toLowerCase()?1:2)}),c.attributes&&ia(function(a){return a.innerHTML="<input/>",a.firstChild.setAttribute("value",""),""===a.firstChild.getAttribute("value")})||ja("value",function(a,b,c){return c||"input"!==a.nodeName.toLowerCase()?void 0:a.defaultValue}),ia(function(a){return null==a.getAttribute("disabled")})||ja(K,function(a,b,c){var d;return c?void 0:a[b]===!0?b.toLowerCase():(d=a.getAttributeNode(b))&&d.specified?d.value:null}),fa}(a);n.find=t,n.expr=t.selectors,n.expr[":"]=n.expr.pseudos,n.uniqueSort=n.unique=t.uniqueSort,n.text=t.getText,n.isXMLDoc=t.isXML,n.contains=t.contains;var u=function(a,b,c){var d=[],e=void 0!==c;while((a=a[b])&&9!==a.nodeType)if(1===a.nodeType){if(e&&n(a).is(c))break;d.push(a)}return d},v=function(a,b){for(var c=[];a;a=a.nextSibling)1===a.nodeType&&a!==b&&c.push(a);return c},w=n.expr.match.needsContext,x=/^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,y=/^.[^:#\[\.,]*$/;function z(a,b,c){if(n.isFunction(b))return n.grep(a,function(a,d){return!!b.call(a,d,a)!==c});if(b.nodeType)return n.grep(a,function(a){return a===b!==c});if("string"==typeof b){if(y.test(b))return n.filter(b,a,c);b=n.filter(b,a)}return n.grep(a,function(a){return n.inArray(a,b)>-1!==c})}n.filter=function(a,b,c){var d=b[0];return c&&(a=":not("+a+")"),1===b.length&&1===d.nodeType?n.find.matchesSelector(d,a)?[d]:[]:n.find.matches(a,n.grep(b,function(a){return 1===a.nodeType}))},n.fn.extend({find:function(a){var b,c=[],d=this,e=d.length;if("string"!=typeof a)return this.pushStack(n(a).filter(function(){for(b=0;e>b;b++)if(n.contains(d[b],this))return!0}));for(b=0;e>b;b++)n.find(a,d[b],c);return c=this.pushStack(e>1?n.unique(c):c),c.selector=this.selector?this.selector+" "+a:a,c},filter:function(a){return this.pushStack(z(this,a||[],!1))},not:function(a){return this.pushStack(z(this,a||[],!0))},is:function(a){return!!z(this,"string"==typeof a&&w.test(a)?n(a):a||[],!1).length}});var A,B=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,C=n.fn.init=function(a,b,c){var e,f;if(!a)return this;if(c=c||A,"string"==typeof a){if(e="<"===a.charAt(0)&&">"===a.charAt(a.length-1)&&a.length>=3?[null,a,null]:B.exec(a),!e||!e[1]&&b)return!b||b.jquery?(b||c).find(a):this.constructor(b).find(a);if(e[1]){if(b=b instanceof n?b[0]:b,n.merge(this,n.parseHTML(e[1],b&&b.nodeType?b.ownerDocument||b:d,!0)),x.test(e[1])&&n.isPlainObject(b))for(e in b)n.isFunction(this[e])?this[e](b[e]):this.attr(e,b[e]);return this}if(f=d.getElementById(e[2]),f&&f.parentNode){if(f.id!==e[2])return A.find(a);this.length=1,this[0]=f}return this.context=d,this.selector=a,this}return a.nodeType?(this.context=this[0]=a,this.length=1,this):n.isFunction(a)?"undefined"!=typeof c.ready?c.ready(a):a(n):(void 0!==a.selector&&(this.selector=a.selector,this.context=a.context),n.makeArray(a,this))};C.prototype=n.fn,A=n(d);var D=/^(?:parents|prev(?:Until|All))/,E={children:!0,contents:!0,next:!0,prev:!0};n.fn.extend({has:function(a){var b,c=n(a,this),d=c.length;return this.filter(function(){for(b=0;d>b;b++)if(n.contains(this,c[b]))return!0})},closest:function(a,b){for(var c,d=0,e=this.length,f=[],g=w.test(a)||"string"!=typeof a?n(a,b||this.context):0;e>d;d++)for(c=this[d];c&&c!==b;c=c.parentNode)if(c.nodeType<11&&(g?g.index(c)>-1:1===c.nodeType&&n.find.matchesSelector(c,a))){f.push(c);break}return this.pushStack(f.length>1?n.uniqueSort(f):f)},index:function(a){return a?"string"==typeof a?n.inArray(this[0],n(a)):n.inArray(a.jquery?a[0]:a,this):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(a,b){return this.pushStack(n.uniqueSort(n.merge(this.get(),n(a,b))))},addBack:function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}});function F(a,b){do a=a[b];while(a&&1!==a.nodeType);return a}n.each({parent:function(a){var b=a.parentNode;return b&&11!==b.nodeType?b:null},parents:function(a){return u(a,"parentNode")},parentsUntil:function(a,b,c){return u(a,"parentNode",c)},next:function(a){return F(a,"nextSibling")},prev:function(a){return F(a,"previousSibling")},nextAll:function(a){return u(a,"nextSibling")},prevAll:function(a){return u(a,"previousSibling")},nextUntil:function(a,b,c){return u(a,"nextSibling",c)},prevUntil:function(a,b,c){return u(a,"previousSibling",c)},siblings:function(a){return v((a.parentNode||{}).firstChild,a)},children:function(a){return v(a.firstChild)},contents:function(a){return n.nodeName(a,"iframe")?a.contentDocument||a.contentWindow.document:n.merge([],a.childNodes)}},function(a,b){n.fn[a]=function(c,d){var e=n.map(this,b,c);return"Until"!==a.slice(-5)&&(d=c),d&&"string"==typeof d&&(e=n.filter(d,e)),this.length>1&&(E[a]||(e=n.uniqueSort(e)),D.test(a)&&(e=e.reverse())),this.pushStack(e)}});var G=/\S+/g;function H(a){var b={};return n.each(a.match(G)||[],function(a,c){b[c]=!0}),b}n.Callbacks=function(a){a="string"==typeof a?H(a):n.extend({},a);var b,c,d,e,f=[],g=[],h=-1,i=function(){for(e=a.once,d=b=!0;g.length;h=-1){c=g.shift();while(++h<f.length)f[h].apply(c[0],c[1])===!1&&a.stopOnFalse&&(h=f.length,c=!1)}a.memory||(c=!1),b=!1,e&&(f=c?[]:"")},j={add:function(){return f&&(c&&!b&&(h=f.length-1,g.push(c)),function d(b){n.each(b,function(b,c){n.isFunction(c)?a.unique&&j.has(c)||f.push(c):c&&c.length&&"string"!==n.type(c)&&d(c)})}(arguments),c&&!b&&i()),this},remove:function(){return n.each(arguments,function(a,b){var c;while((c=n.inArray(b,f,c))>-1)f.splice(c,1),h>=c&&h--}),this},has:function(a){return a?n.inArray(a,f)>-1:f.length>0},empty:function(){return f&&(f=[]),this},disable:function(){return e=g=[],f=c="",this},disabled:function(){return!f},lock:function(){return e=!0,c||j.disable(),this},locked:function(){return!!e},fireWith:function(a,c){return e||(c=c||[],c=[a,c.slice?c.slice():c],g.push(c),b||i()),this},fire:function(){return j.fireWith(this,arguments),this},fired:function(){return!!d}};return j},n.extend({Deferred:function(a){var b=[["resolve","done",n.Callbacks("once memory"),"resolved"],["reject","fail",n.Callbacks("once memory"),"rejected"],["notify","progress",n.Callbacks("memory")]],c="pending",d={state:function(){return c},always:function(){return e.done(arguments).fail(arguments),this},then:function(){var a=arguments;return n.Deferred(function(c){n.each(b,function(b,f){var g=n.isFunction(a[b])&&a[b];e[f[1]](function(){var a=g&&g.apply(this,arguments);a&&n.isFunction(a.promise)?a.promise().progress(c.notify).done(c.resolve).fail(c.reject):c[f[0]+"With"](this===d?c.promise():this,g?[a]:arguments)})}),a=null}).promise()},promise:function(a){return null!=a?n.extend(a,d):d}},e={};return d.pipe=d.then,n.each(b,function(a,f){var g=f[2],h=f[3];d[f[1]]=g.add,h&&g.add(function(){c=h},b[1^a][2].disable,b[2][2].lock),e[f[0]]=function(){return e[f[0]+"With"](this===e?d:this,arguments),this},e[f[0]+"With"]=g.fireWith}),d.promise(e),a&&a.call(e,e),e},when:function(a){var b=0,c=e.call(arguments),d=c.length,f=1!==d||a&&n.isFunction(a.promise)?d:0,g=1===f?a:n.Deferred(),h=function(a,b,c){return function(d){b[a]=this,c[a]=arguments.length>1?e.call(arguments):d,c===i?g.notifyWith(b,c):--f||g.resolveWith(b,c)}},i,j,k;if(d>1)for(i=new Array(d),j=new Array(d),k=new Array(d);d>b;b++)c[b]&&n.isFunction(c[b].promise)?c[b].promise().progress(h(b,j,i)).done(h(b,k,c)).fail(g.reject):--f;return f||g.resolveWith(k,c),g.promise()}});var I;n.fn.ready=function(a){return n.ready.promise().done(a),this},n.extend({isReady:!1,readyWait:1,holdReady:function(a){a?n.readyWait++:n.ready(!0)},ready:function(a){(a===!0?--n.readyWait:n.isReady)||(n.isReady=!0,a!==!0&&--n.readyWait>0||(I.resolveWith(d,[n]),n.fn.triggerHandler&&(n(d).triggerHandler("ready"),n(d).off("ready"))))}});function J(){d.addEventListener?(d.removeEventListener("DOMContentLoaded",K),a.removeEventListener("load",K)):(d.detachEvent("onreadystatechange",K),a.detachEvent("onload",K))}function K(){(d.addEventListener||"load"===a.event.type||"complete"===d.readyState)&&(J(),n.ready())}n.ready.promise=function(b){if(!I)if(I=n.Deferred(),"complete"===d.readyState||"loading"!==d.readyState&&!d.documentElement.doScroll)a.setTimeout(n.ready);else if(d.addEventListener)d.addEventListener("DOMContentLoaded",K),a.addEventListener("load",K);else{d.attachEvent("onreadystatechange",K),a.attachEvent("onload",K);var c=!1;try{c=null==a.frameElement&&d.documentElement}catch(e){}c&&c.doScroll&&!function f(){if(!n.isReady){try{c.doScroll("left")}catch(b){return a.setTimeout(f,50)}J(),n.ready()}}()}return I.promise(b)},n.ready.promise();var L;for(L in n(l))break;l.ownFirst="0"===L,l.inlineBlockNeedsLayout=!1,n(function(){var a,b,c,e;c=d.getElementsByTagName("body")[0],c&&c.style&&(b=d.createElement("div"),e=d.createElement("div"),e.style.cssText="position:absolute;border:0;width:0;height:0;top:0;left:-9999px",c.appendChild(e).appendChild(b),"undefined"!=typeof b.style.zoom&&(b.style.cssText="display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1",l.inlineBlockNeedsLayout=a=3===b.offsetWidth,a&&(c.style.zoom=1)),c.removeChild(e))}),function(){var a=d.createElement("div");l.deleteExpando=!0;try{delete a.test}catch(b){l.deleteExpando=!1}a=null}();var M=function(a){var b=n.noData[(a.nodeName+" ").toLowerCase()],c=+a.nodeType||1;return 1!==c&&9!==c?!1:!b||b!==!0&&a.getAttribute("classid")===b},N=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,O=/([A-Z])/g;function P(a,b,c){if(void 0===c&&1===a.nodeType){var d="data-"+b.replace(O,"-$1").toLowerCase();if(c=a.getAttribute(d),"string"==typeof c){try{c="true"===c?!0:"false"===c?!1:"null"===c?null:+c+""===c?+c:N.test(c)?n.parseJSON(c):c}catch(e){}n.data(a,b,c)}else c=void 0;
}return c}function Q(a){var b;for(b in a)if(("data"!==b||!n.isEmptyObject(a[b]))&&"toJSON"!==b)return!1;return!0}function R(a,b,d,e){if(M(a)){var f,g,h=n.expando,i=a.nodeType,j=i?n.cache:a,k=i?a[h]:a[h]&&h;if(k&&j[k]&&(e||j[k].data)||void 0!==d||"string"!=typeof b)return k||(k=i?a[h]=c.pop()||n.guid++:h),j[k]||(j[k]=i?{}:{toJSON:n.noop}),"object"!=typeof b&&"function"!=typeof b||(e?j[k]=n.extend(j[k],b):j[k].data=n.extend(j[k].data,b)),g=j[k],e||(g.data||(g.data={}),g=g.data),void 0!==d&&(g[n.camelCase(b)]=d),"string"==typeof b?(f=g[b],null==f&&(f=g[n.camelCase(b)])):f=g,f}}function S(a,b,c){if(M(a)){var d,e,f=a.nodeType,g=f?n.cache:a,h=f?a[n.expando]:n.expando;if(g[h]){if(b&&(d=c?g[h]:g[h].data)){n.isArray(b)?b=b.concat(n.map(b,n.camelCase)):b in d?b=[b]:(b=n.camelCase(b),b=b in d?[b]:b.split(" ")),e=b.length;while(e--)delete d[b[e]];if(c?!Q(d):!n.isEmptyObject(d))return}(c||(delete g[h].data,Q(g[h])))&&(f?n.cleanData([a],!0):l.deleteExpando||g!=g.window?delete g[h]:g[h]=void 0)}}}n.extend({cache:{},noData:{"applet ":!0,"embed ":!0,"object ":"clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"},hasData:function(a){return a=a.nodeType?n.cache[a[n.expando]]:a[n.expando],!!a&&!Q(a)},data:function(a,b,c){return R(a,b,c)},removeData:function(a,b){return S(a,b)},_data:function(a,b,c){return R(a,b,c,!0)},_removeData:function(a,b){return S(a,b,!0)}}),n.fn.extend({data:function(a,b){var c,d,e,f=this[0],g=f&&f.attributes;if(void 0===a){if(this.length&&(e=n.data(f),1===f.nodeType&&!n._data(f,"parsedAttrs"))){c=g.length;while(c--)g[c]&&(d=g[c].name,0===d.indexOf("data-")&&(d=n.camelCase(d.slice(5)),P(f,d,e[d])));n._data(f,"parsedAttrs",!0)}return e}return"object"==typeof a?this.each(function(){n.data(this,a)}):arguments.length>1?this.each(function(){n.data(this,a,b)}):f?P(f,a,n.data(f,a)):void 0},removeData:function(a){return this.each(function(){n.removeData(this,a)})}}),n.extend({queue:function(a,b,c){var d;return a?(b=(b||"fx")+"queue",d=n._data(a,b),c&&(!d||n.isArray(c)?d=n._data(a,b,n.makeArray(c)):d.push(c)),d||[]):void 0},dequeue:function(a,b){b=b||"fx";var c=n.queue(a,b),d=c.length,e=c.shift(),f=n._queueHooks(a,b),g=function(){n.dequeue(a,b)};"inprogress"===e&&(e=c.shift(),d--),e&&("fx"===b&&c.unshift("inprogress"),delete f.stop,e.call(a,g,f)),!d&&f&&f.empty.fire()},_queueHooks:function(a,b){var c=b+"queueHooks";return n._data(a,c)||n._data(a,c,{empty:n.Callbacks("once memory").add(function(){n._removeData(a,b+"queue"),n._removeData(a,c)})})}}),n.fn.extend({queue:function(a,b){var c=2;return"string"!=typeof a&&(b=a,a="fx",c--),arguments.length<c?n.queue(this[0],a):void 0===b?this:this.each(function(){var c=n.queue(this,a,b);n._queueHooks(this,a),"fx"===a&&"inprogress"!==c[0]&&n.dequeue(this,a)})},dequeue:function(a){return this.each(function(){n.dequeue(this,a)})},clearQueue:function(a){return this.queue(a||"fx",[])},promise:function(a,b){var c,d=1,e=n.Deferred(),f=this,g=this.length,h=function(){--d||e.resolveWith(f,[f])};"string"!=typeof a&&(b=a,a=void 0),a=a||"fx";while(g--)c=n._data(f[g],a+"queueHooks"),c&&c.empty&&(d++,c.empty.add(h));return h(),e.promise(b)}}),function(){var a;l.shrinkWrapBlocks=function(){if(null!=a)return a;a=!1;var b,c,e;return c=d.getElementsByTagName("body")[0],c&&c.style?(b=d.createElement("div"),e=d.createElement("div"),e.style.cssText="position:absolute;border:0;width:0;height:0;top:0;left:-9999px",c.appendChild(e).appendChild(b),"undefined"!=typeof b.style.zoom&&(b.style.cssText="-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:1px;width:1px;zoom:1",b.appendChild(d.createElement("div")).style.width="5px",a=3!==b.offsetWidth),c.removeChild(e),a):void 0}}();var T=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,U=new RegExp("^(?:([+-])=|)("+T+")([a-z%]*)$","i"),V=["Top","Right","Bottom","Left"],W=function(a,b){return a=b||a,"none"===n.css(a,"display")||!n.contains(a.ownerDocument,a)};function X(a,b,c,d){var e,f=1,g=20,h=d?function(){return d.cur()}:function(){return n.css(a,b,"")},i=h(),j=c&&c[3]||(n.cssNumber[b]?"":"px"),k=(n.cssNumber[b]||"px"!==j&&+i)&&U.exec(n.css(a,b));if(k&&k[3]!==j){j=j||k[3],c=c||[],k=+i||1;do f=f||".5",k/=f,n.style(a,b,k+j);while(f!==(f=h()/i)&&1!==f&&--g)}return c&&(k=+k||+i||0,e=c[1]?k+(c[1]+1)*c[2]:+c[2],d&&(d.unit=j,d.start=k,d.end=e)),e}var Y=function(a,b,c,d,e,f,g){var h=0,i=a.length,j=null==c;if("object"===n.type(c)){e=!0;for(h in c)Y(a,b,h,c[h],!0,f,g)}else if(void 0!==d&&(e=!0,n.isFunction(d)||(g=!0),j&&(g?(b.call(a,d),b=null):(j=b,b=function(a,b,c){return j.call(n(a),c)})),b))for(;i>h;h++)b(a[h],c,g?d:d.call(a[h],h,b(a[h],c)));return e?a:j?b.call(a):i?b(a[0],c):f},Z=/^(?:checkbox|radio)$/i,$=/<([\w:-]+)/,_=/^$|\/(?:java|ecma)script/i,aa=/^\s+/,ba="abbr|article|aside|audio|bdi|canvas|data|datalist|details|dialog|figcaption|figure|footer|header|hgroup|main|mark|meter|nav|output|picture|progress|section|summary|template|time|video";function ca(a){var b=ba.split("|"),c=a.createDocumentFragment();if(c.createElement)while(b.length)c.createElement(b.pop());return c}!function(){var a=d.createElement("div"),b=d.createDocumentFragment(),c=d.createElement("input");a.innerHTML="  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>",l.leadingWhitespace=3===a.firstChild.nodeType,l.tbody=!a.getElementsByTagName("tbody").length,l.htmlSerialize=!!a.getElementsByTagName("link").length,l.html5Clone="<:nav></:nav>"!==d.createElement("nav").cloneNode(!0).outerHTML,c.type="checkbox",c.checked=!0,b.appendChild(c),l.appendChecked=c.checked,a.innerHTML="<textarea>x</textarea>",l.noCloneChecked=!!a.cloneNode(!0).lastChild.defaultValue,b.appendChild(a),c=d.createElement("input"),c.setAttribute("type","radio"),c.setAttribute("checked","checked"),c.setAttribute("name","t"),a.appendChild(c),l.checkClone=a.cloneNode(!0).cloneNode(!0).lastChild.checked,l.noCloneEvent=!!a.addEventListener,a[n.expando]=1,l.attributes=!a.getAttribute(n.expando)}();var da={option:[1,"<select multiple='multiple'>","</select>"],legend:[1,"<fieldset>","</fieldset>"],area:[1,"<map>","</map>"],param:[1,"<object>","</object>"],thead:[1,"<table>","</table>"],tr:[2,"<table><tbody>","</tbody></table>"],col:[2,"<table><tbody></tbody><colgroup>","</colgroup></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:l.htmlSerialize?[0,"",""]:[1,"X<div>","</div>"]};da.optgroup=da.option,da.tbody=da.tfoot=da.colgroup=da.caption=da.thead,da.th=da.td;function ea(a,b){var c,d,e=0,f="undefined"!=typeof a.getElementsByTagName?a.getElementsByTagName(b||"*"):"undefined"!=typeof a.querySelectorAll?a.querySelectorAll(b||"*"):void 0;if(!f)for(f=[],c=a.childNodes||a;null!=(d=c[e]);e++)!b||n.nodeName(d,b)?f.push(d):n.merge(f,ea(d,b));return void 0===b||b&&n.nodeName(a,b)?n.merge([a],f):f}function fa(a,b){for(var c,d=0;null!=(c=a[d]);d++)n._data(c,"globalEval",!b||n._data(b[d],"globalEval"))}var ga=/<|&#?\w+;/,ha=/<tbody/i;function ia(a){Z.test(a.type)&&(a.defaultChecked=a.checked)}function ja(a,b,c,d,e){for(var f,g,h,i,j,k,m,o=a.length,p=ca(b),q=[],r=0;o>r;r++)if(g=a[r],g||0===g)if("object"===n.type(g))n.merge(q,g.nodeType?[g]:g);else if(ga.test(g)){i=i||p.appendChild(b.createElement("div")),j=($.exec(g)||["",""])[1].toLowerCase(),m=da[j]||da._default,i.innerHTML=m[1]+n.htmlPrefilter(g)+m[2],f=m[0];while(f--)i=i.lastChild;if(!l.leadingWhitespace&&aa.test(g)&&q.push(b.createTextNode(aa.exec(g)[0])),!l.tbody){g="table"!==j||ha.test(g)?"<table>"!==m[1]||ha.test(g)?0:i:i.firstChild,f=g&&g.childNodes.length;while(f--)n.nodeName(k=g.childNodes[f],"tbody")&&!k.childNodes.length&&g.removeChild(k)}n.merge(q,i.childNodes),i.textContent="";while(i.firstChild)i.removeChild(i.firstChild);i=p.lastChild}else q.push(b.createTextNode(g));i&&p.removeChild(i),l.appendChecked||n.grep(ea(q,"input"),ia),r=0;while(g=q[r++])if(d&&n.inArray(g,d)>-1)e&&e.push(g);else if(h=n.contains(g.ownerDocument,g),i=ea(p.appendChild(g),"script"),h&&fa(i),c){f=0;while(g=i[f++])_.test(g.type||"")&&c.push(g)}return i=null,p}!function(){var b,c,e=d.createElement("div");for(b in{submit:!0,change:!0,focusin:!0})c="on"+b,(l[b]=c in a)||(e.setAttribute(c,"t"),l[b]=e.attributes[c].expando===!1);e=null}();var ka=/^(?:input|select|textarea)$/i,la=/^key/,ma=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,na=/^(?:focusinfocus|focusoutblur)$/,oa=/^([^.]*)(?:\.(.+)|)/;function pa(){return!0}function qa(){return!1}function ra(){try{return d.activeElement}catch(a){}}function sa(a,b,c,d,e,f){var g,h;if("object"==typeof b){"string"!=typeof c&&(d=d||c,c=void 0);for(h in b)sa(a,h,c,d,b[h],f);return a}if(null==d&&null==e?(e=c,d=c=void 0):null==e&&("string"==typeof c?(e=d,d=void 0):(e=d,d=c,c=void 0)),e===!1)e=qa;else if(!e)return a;return 1===f&&(g=e,e=function(a){return n().off(a),g.apply(this,arguments)},e.guid=g.guid||(g.guid=n.guid++)),a.each(function(){n.event.add(this,b,e,d,c)})}n.event={global:{},add:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=n._data(a);if(r){c.handler&&(i=c,c=i.handler,e=i.selector),c.guid||(c.guid=n.guid++),(g=r.events)||(g=r.events={}),(k=r.handle)||(k=r.handle=function(a){return"undefined"==typeof n||a&&n.event.triggered===a.type?void 0:n.event.dispatch.apply(k.elem,arguments)},k.elem=a),b=(b||"").match(G)||[""],h=b.length;while(h--)f=oa.exec(b[h])||[],o=q=f[1],p=(f[2]||"").split(".").sort(),o&&(j=n.event.special[o]||{},o=(e?j.delegateType:j.bindType)||o,j=n.event.special[o]||{},l=n.extend({type:o,origType:q,data:d,handler:c,guid:c.guid,selector:e,needsContext:e&&n.expr.match.needsContext.test(e),namespace:p.join(".")},i),(m=g[o])||(m=g[o]=[],m.delegateCount=0,j.setup&&j.setup.call(a,d,p,k)!==!1||(a.addEventListener?a.addEventListener(o,k,!1):a.attachEvent&&a.attachEvent("on"+o,k))),j.add&&(j.add.call(a,l),l.handler.guid||(l.handler.guid=c.guid)),e?m.splice(m.delegateCount++,0,l):m.push(l),n.event.global[o]=!0);a=null}},remove:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=n.hasData(a)&&n._data(a);if(r&&(k=r.events)){b=(b||"").match(G)||[""],j=b.length;while(j--)if(h=oa.exec(b[j])||[],o=q=h[1],p=(h[2]||"").split(".").sort(),o){l=n.event.special[o]||{},o=(d?l.delegateType:l.bindType)||o,m=k[o]||[],h=h[2]&&new RegExp("(^|\\.)"+p.join("\\.(?:.*\\.|)")+"(\\.|$)"),i=f=m.length;while(f--)g=m[f],!e&&q!==g.origType||c&&c.guid!==g.guid||h&&!h.test(g.namespace)||d&&d!==g.selector&&("**"!==d||!g.selector)||(m.splice(f,1),g.selector&&m.delegateCount--,l.remove&&l.remove.call(a,g));i&&!m.length&&(l.teardown&&l.teardown.call(a,p,r.handle)!==!1||n.removeEvent(a,o,r.handle),delete k[o])}else for(o in k)n.event.remove(a,o+b[j],c,d,!0);n.isEmptyObject(k)&&(delete r.handle,n._removeData(a,"events"))}},trigger:function(b,c,e,f){var g,h,i,j,l,m,o,p=[e||d],q=k.call(b,"type")?b.type:b,r=k.call(b,"namespace")?b.namespace.split("."):[];if(i=m=e=e||d,3!==e.nodeType&&8!==e.nodeType&&!na.test(q+n.event.triggered)&&(q.indexOf(".")>-1&&(r=q.split("."),q=r.shift(),r.sort()),h=q.indexOf(":")<0&&"on"+q,b=b[n.expando]?b:new n.Event(q,"object"==typeof b&&b),b.isTrigger=f?2:3,b.namespace=r.join("."),b.rnamespace=b.namespace?new RegExp("(^|\\.)"+r.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,b.result=void 0,b.target||(b.target=e),c=null==c?[b]:n.makeArray(c,[b]),l=n.event.special[q]||{},f||!l.trigger||l.trigger.apply(e,c)!==!1)){if(!f&&!l.noBubble&&!n.isWindow(e)){for(j=l.delegateType||q,na.test(j+q)||(i=i.parentNode);i;i=i.parentNode)p.push(i),m=i;m===(e.ownerDocument||d)&&p.push(m.defaultView||m.parentWindow||a)}o=0;while((i=p[o++])&&!b.isPropagationStopped())b.type=o>1?j:l.bindType||q,g=(n._data(i,"events")||{})[b.type]&&n._data(i,"handle"),g&&g.apply(i,c),g=h&&i[h],g&&g.apply&&M(i)&&(b.result=g.apply(i,c),b.result===!1&&b.preventDefault());if(b.type=q,!f&&!b.isDefaultPrevented()&&(!l._default||l._default.apply(p.pop(),c)===!1)&&M(e)&&h&&e[q]&&!n.isWindow(e)){m=e[h],m&&(e[h]=null),n.event.triggered=q;try{e[q]()}catch(s){}n.event.triggered=void 0,m&&(e[h]=m)}return b.result}},dispatch:function(a){a=n.event.fix(a);var b,c,d,f,g,h=[],i=e.call(arguments),j=(n._data(this,"events")||{})[a.type]||[],k=n.event.special[a.type]||{};if(i[0]=a,a.delegateTarget=this,!k.preDispatch||k.preDispatch.call(this,a)!==!1){h=n.event.handlers.call(this,a,j),b=0;while((f=h[b++])&&!a.isPropagationStopped()){a.currentTarget=f.elem,c=0;while((g=f.handlers[c++])&&!a.isImmediatePropagationStopped())a.rnamespace&&!a.rnamespace.test(g.namespace)||(a.handleObj=g,a.data=g.data,d=((n.event.special[g.origType]||{}).handle||g.handler).apply(f.elem,i),void 0!==d&&(a.result=d)===!1&&(a.preventDefault(),a.stopPropagation()))}return k.postDispatch&&k.postDispatch.call(this,a),a.result}},handlers:function(a,b){var c,d,e,f,g=[],h=b.delegateCount,i=a.target;if(h&&i.nodeType&&("click"!==a.type||isNaN(a.button)||a.button<1))for(;i!=this;i=i.parentNode||this)if(1===i.nodeType&&(i.disabled!==!0||"click"!==a.type)){for(d=[],c=0;h>c;c++)f=b[c],e=f.selector+" ",void 0===d[e]&&(d[e]=f.needsContext?n(e,this).index(i)>-1:n.find(e,this,null,[i]).length),d[e]&&d.push(f);d.length&&g.push({elem:i,handlers:d})}return h<b.length&&g.push({elem:this,handlers:b.slice(h)}),g},fix:function(a){if(a[n.expando])return a;var b,c,e,f=a.type,g=a,h=this.fixHooks[f];h||(this.fixHooks[f]=h=ma.test(f)?this.mouseHooks:la.test(f)?this.keyHooks:{}),e=h.props?this.props.concat(h.props):this.props,a=new n.Event(g),b=e.length;while(b--)c=e[b],a[c]=g[c];return a.target||(a.target=g.srcElement||d),3===a.target.nodeType&&(a.target=a.target.parentNode),a.metaKey=!!a.metaKey,h.filter?h.filter(a,g):a},props:"altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),fixHooks:{},keyHooks:{props:"char charCode key keyCode".split(" "),filter:function(a,b){return null==a.which&&(a.which=null!=b.charCode?b.charCode:b.keyCode),a}},mouseHooks:{props:"button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),filter:function(a,b){var c,e,f,g=b.button,h=b.fromElement;return null==a.pageX&&null!=b.clientX&&(e=a.target.ownerDocument||d,f=e.documentElement,c=e.body,a.pageX=b.clientX+(f&&f.scrollLeft||c&&c.scrollLeft||0)-(f&&f.clientLeft||c&&c.clientLeft||0),a.pageY=b.clientY+(f&&f.scrollTop||c&&c.scrollTop||0)-(f&&f.clientTop||c&&c.clientTop||0)),!a.relatedTarget&&h&&(a.relatedTarget=h===a.target?b.toElement:h),a.which||void 0===g||(a.which=1&g?1:2&g?3:4&g?2:0),a}},special:{load:{noBubble:!0},focus:{trigger:function(){if(this!==ra()&&this.focus)try{return this.focus(),!1}catch(a){}},delegateType:"focusin"},blur:{trigger:function(){return this===ra()&&this.blur?(this.blur(),!1):void 0},delegateType:"focusout"},click:{trigger:function(){return n.nodeName(this,"input")&&"checkbox"===this.type&&this.click?(this.click(),!1):void 0},_default:function(a){return n.nodeName(a.target,"a")}},beforeunload:{postDispatch:function(a){void 0!==a.result&&a.originalEvent&&(a.originalEvent.returnValue=a.result)}}},simulate:function(a,b,c){var d=n.extend(new n.Event,c,{type:a,isSimulated:!0});n.event.trigger(d,null,b),d.isDefaultPrevented()&&c.preventDefault()}},n.removeEvent=d.removeEventListener?function(a,b,c){a.removeEventListener&&a.removeEventListener(b,c)}:function(a,b,c){var d="on"+b;a.detachEvent&&("undefined"==typeof a[d]&&(a[d]=null),a.detachEvent(d,c))},n.Event=function(a,b){return this instanceof n.Event?(a&&a.type?(this.originalEvent=a,this.type=a.type,this.isDefaultPrevented=a.defaultPrevented||void 0===a.defaultPrevented&&a.returnValue===!1?pa:qa):this.type=a,b&&n.extend(this,b),this.timeStamp=a&&a.timeStamp||n.now(),void(this[n.expando]=!0)):new n.Event(a,b)},n.Event.prototype={constructor:n.Event,isDefaultPrevented:qa,isPropagationStopped:qa,isImmediatePropagationStopped:qa,preventDefault:function(){var a=this.originalEvent;this.isDefaultPrevented=pa,a&&(a.preventDefault?a.preventDefault():a.returnValue=!1)},stopPropagation:function(){var a=this.originalEvent;this.isPropagationStopped=pa,a&&!this.isSimulated&&(a.stopPropagation&&a.stopPropagation(),a.cancelBubble=!0)},stopImmediatePropagation:function(){var a=this.originalEvent;this.isImmediatePropagationStopped=pa,a&&a.stopImmediatePropagation&&a.stopImmediatePropagation(),this.stopPropagation()}},n.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(a,b){n.event.special[a]={delegateType:b,bindType:b,handle:function(a){var c,d=this,e=a.relatedTarget,f=a.handleObj;return e&&(e===d||n.contains(d,e))||(a.type=f.origType,c=f.handler.apply(this,arguments),a.type=b),c}}}),l.submit||(n.event.special.submit={setup:function(){return n.nodeName(this,"form")?!1:void n.event.add(this,"click._submit keypress._submit",function(a){var b=a.target,c=n.nodeName(b,"input")||n.nodeName(b,"button")?n.prop(b,"form"):void 0;c&&!n._data(c,"submit")&&(n.event.add(c,"submit._submit",function(a){a._submitBubble=!0}),n._data(c,"submit",!0))})},postDispatch:function(a){a._submitBubble&&(delete a._submitBubble,this.parentNode&&!a.isTrigger&&n.event.simulate("submit",this.parentNode,a))},teardown:function(){return n.nodeName(this,"form")?!1:void n.event.remove(this,"._submit")}}),l.change||(n.event.special.change={setup:function(){return ka.test(this.nodeName)?("checkbox"!==this.type&&"radio"!==this.type||(n.event.add(this,"propertychange._change",function(a){"checked"===a.originalEvent.propertyName&&(this._justChanged=!0)}),n.event.add(this,"click._change",function(a){this._justChanged&&!a.isTrigger&&(this._justChanged=!1),n.event.simulate("change",this,a)})),!1):void n.event.add(this,"beforeactivate._change",function(a){var b=a.target;ka.test(b.nodeName)&&!n._data(b,"change")&&(n.event.add(b,"change._change",function(a){!this.parentNode||a.isSimulated||a.isTrigger||n.event.simulate("change",this.parentNode,a)}),n._data(b,"change",!0))})},handle:function(a){var b=a.target;return this!==b||a.isSimulated||a.isTrigger||"radio"!==b.type&&"checkbox"!==b.type?a.handleObj.handler.apply(this,arguments):void 0},teardown:function(){return n.event.remove(this,"._change"),!ka.test(this.nodeName)}}),l.focusin||n.each({focus:"focusin",blur:"focusout"},function(a,b){var c=function(a){n.event.simulate(b,a.target,n.event.fix(a))};n.event.special[b]={setup:function(){var d=this.ownerDocument||this,e=n._data(d,b);e||d.addEventListener(a,c,!0),n._data(d,b,(e||0)+1)},teardown:function(){var d=this.ownerDocument||this,e=n._data(d,b)-1;e?n._data(d,b,e):(d.removeEventListener(a,c,!0),n._removeData(d,b))}}}),n.fn.extend({on:function(a,b,c,d){return sa(this,a,b,c,d)},one:function(a,b,c,d){return sa(this,a,b,c,d,1)},off:function(a,b,c){var d,e;if(a&&a.preventDefault&&a.handleObj)return d=a.handleObj,n(a.delegateTarget).off(d.namespace?d.origType+"."+d.namespace:d.origType,d.selector,d.handler),this;if("object"==typeof a){for(e in a)this.off(e,b,a[e]);return this}return b!==!1&&"function"!=typeof b||(c=b,b=void 0),c===!1&&(c=qa),this.each(function(){n.event.remove(this,a,c,b)})},trigger:function(a,b){return this.each(function(){n.event.trigger(a,b,this)})},triggerHandler:function(a,b){var c=this[0];return c?n.event.trigger(a,b,c,!0):void 0}});var ta=/ jQuery\d+="(?:null|\d+)"/g,ua=new RegExp("<(?:"+ba+")[\\s/>]","i"),va=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,wa=/<script|<style|<link/i,xa=/checked\s*(?:[^=]|=\s*.checked.)/i,ya=/^true\/(.*)/,za=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,Aa=ca(d),Ba=Aa.appendChild(d.createElement("div"));function Ca(a,b){return n.nodeName(a,"table")&&n.nodeName(11!==b.nodeType?b:b.firstChild,"tr")?a.getElementsByTagName("tbody")[0]||a.appendChild(a.ownerDocument.createElement("tbody")):a}function Da(a){return a.type=(null!==n.find.attr(a,"type"))+"/"+a.type,a}function Ea(a){var b=ya.exec(a.type);return b?a.type=b[1]:a.removeAttribute("type"),a}function Fa(a,b){if(1===b.nodeType&&n.hasData(a)){var c,d,e,f=n._data(a),g=n._data(b,f),h=f.events;if(h){delete g.handle,g.events={};for(c in h)for(d=0,e=h[c].length;e>d;d++)n.event.add(b,c,h[c][d])}g.data&&(g.data=n.extend({},g.data))}}function Ga(a,b){var c,d,e;if(1===b.nodeType){if(c=b.nodeName.toLowerCase(),!l.noCloneEvent&&b[n.expando]){e=n._data(b);for(d in e.events)n.removeEvent(b,d,e.handle);b.removeAttribute(n.expando)}"script"===c&&b.text!==a.text?(Da(b).text=a.text,Ea(b)):"object"===c?(b.parentNode&&(b.outerHTML=a.outerHTML),l.html5Clone&&a.innerHTML&&!n.trim(b.innerHTML)&&(b.innerHTML=a.innerHTML)):"input"===c&&Z.test(a.type)?(b.defaultChecked=b.checked=a.checked,b.value!==a.value&&(b.value=a.value)):"option"===c?b.defaultSelected=b.selected=a.defaultSelected:"input"!==c&&"textarea"!==c||(b.defaultValue=a.defaultValue)}}function Ha(a,b,c,d){b=f.apply([],b);var e,g,h,i,j,k,m=0,o=a.length,p=o-1,q=b[0],r=n.isFunction(q);if(r||o>1&&"string"==typeof q&&!l.checkClone&&xa.test(q))return a.each(function(e){var f=a.eq(e);r&&(b[0]=q.call(this,e,f.html())),Ha(f,b,c,d)});if(o&&(k=ja(b,a[0].ownerDocument,!1,a,d),e=k.firstChild,1===k.childNodes.length&&(k=e),e||d)){for(i=n.map(ea(k,"script"),Da),h=i.length;o>m;m++)g=k,m!==p&&(g=n.clone(g,!0,!0),h&&n.merge(i,ea(g,"script"))),c.call(a[m],g,m);if(h)for(j=i[i.length-1].ownerDocument,n.map(i,Ea),m=0;h>m;m++)g=i[m],_.test(g.type||"")&&!n._data(g,"globalEval")&&n.contains(j,g)&&(g.src?n._evalUrl&&n._evalUrl(g.src):n.globalEval((g.text||g.textContent||g.innerHTML||"").replace(za,"")));k=e=null}return a}function Ia(a,b,c){for(var d,e=b?n.filter(b,a):a,f=0;null!=(d=e[f]);f++)c||1!==d.nodeType||n.cleanData(ea(d)),d.parentNode&&(c&&n.contains(d.ownerDocument,d)&&fa(ea(d,"script")),d.parentNode.removeChild(d));return a}n.extend({htmlPrefilter:function(a){return a.replace(va,"<$1></$2>")},clone:function(a,b,c){var d,e,f,g,h,i=n.contains(a.ownerDocument,a);if(l.html5Clone||n.isXMLDoc(a)||!ua.test("<"+a.nodeName+">")?f=a.cloneNode(!0):(Ba.innerHTML=a.outerHTML,Ba.removeChild(f=Ba.firstChild)),!(l.noCloneEvent&&l.noCloneChecked||1!==a.nodeType&&11!==a.nodeType||n.isXMLDoc(a)))for(d=ea(f),h=ea(a),g=0;null!=(e=h[g]);++g)d[g]&&Ga(e,d[g]);if(b)if(c)for(h=h||ea(a),d=d||ea(f),g=0;null!=(e=h[g]);g++)Fa(e,d[g]);else Fa(a,f);return d=ea(f,"script"),d.length>0&&fa(d,!i&&ea(a,"script")),d=h=e=null,f},cleanData:function(a,b){for(var d,e,f,g,h=0,i=n.expando,j=n.cache,k=l.attributes,m=n.event.special;null!=(d=a[h]);h++)if((b||M(d))&&(f=d[i],g=f&&j[f])){if(g.events)for(e in g.events)m[e]?n.event.remove(d,e):n.removeEvent(d,e,g.handle);j[f]&&(delete j[f],k||"undefined"==typeof d.removeAttribute?d[i]=void 0:d.removeAttribute(i),c.push(f))}}}),n.fn.extend({domManip:Ha,detach:function(a){return Ia(this,a,!0)},remove:function(a){return Ia(this,a)},text:function(a){return Y(this,function(a){return void 0===a?n.text(this):this.empty().append((this[0]&&this[0].ownerDocument||d).createTextNode(a))},null,a,arguments.length)},append:function(){return Ha(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=Ca(this,a);b.appendChild(a)}})},prepend:function(){return Ha(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=Ca(this,a);b.insertBefore(a,b.firstChild)}})},before:function(){return Ha(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this)})},after:function(){return Ha(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this.nextSibling)})},empty:function(){for(var a,b=0;null!=(a=this[b]);b++){1===a.nodeType&&n.cleanData(ea(a,!1));while(a.firstChild)a.removeChild(a.firstChild);a.options&&n.nodeName(a,"select")&&(a.options.length=0)}return this},clone:function(a,b){return a=null==a?!1:a,b=null==b?a:b,this.map(function(){return n.clone(this,a,b)})},html:function(a){return Y(this,function(a){var b=this[0]||{},c=0,d=this.length;if(void 0===a)return 1===b.nodeType?b.innerHTML.replace(ta,""):void 0;if("string"==typeof a&&!wa.test(a)&&(l.htmlSerialize||!ua.test(a))&&(l.leadingWhitespace||!aa.test(a))&&!da[($.exec(a)||["",""])[1].toLowerCase()]){a=n.htmlPrefilter(a);try{for(;d>c;c++)b=this[c]||{},1===b.nodeType&&(n.cleanData(ea(b,!1)),b.innerHTML=a);b=0}catch(e){}}b&&this.empty().append(a)},null,a,arguments.length)},replaceWith:function(){var a=[];return Ha(this,arguments,function(b){var c=this.parentNode;n.inArray(this,a)<0&&(n.cleanData(ea(this)),c&&c.replaceChild(b,this))},a)}}),n.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(a,b){n.fn[a]=function(a){for(var c,d=0,e=[],f=n(a),h=f.length-1;h>=d;d++)c=d===h?this:this.clone(!0),n(f[d])[b](c),g.apply(e,c.get());return this.pushStack(e)}});var Ja,Ka={HTML:"block",BODY:"block"};function La(a,b){var c=n(b.createElement(a)).appendTo(b.body),d=n.css(c[0],"display");return c.detach(),d}function Ma(a){var b=d,c=Ka[a];return c||(c=La(a,b),"none"!==c&&c||(Ja=(Ja||n("<iframe frameborder='0' width='0' height='0'/>")).appendTo(b.documentElement),b=(Ja[0].contentWindow||Ja[0].contentDocument).document,b.write(),b.close(),c=La(a,b),Ja.detach()),Ka[a]=c),c}var Na=/^margin/,Oa=new RegExp("^("+T+")(?!px)[a-z%]+$","i"),Pa=function(a,b,c,d){var e,f,g={};for(f in b)g[f]=a.style[f],a.style[f]=b[f];e=c.apply(a,d||[]);for(f in b)a.style[f]=g[f];return e},Qa=d.documentElement;!function(){var b,c,e,f,g,h,i=d.createElement("div"),j=d.createElement("div");if(j.style){j.style.cssText="float:left;opacity:.5",l.opacity="0.5"===j.style.opacity,l.cssFloat=!!j.style.cssFloat,j.style.backgroundClip="content-box",j.cloneNode(!0).style.backgroundClip="",l.clearCloneStyle="content-box"===j.style.backgroundClip,i=d.createElement("div"),i.style.cssText="border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute",j.innerHTML="",i.appendChild(j),l.boxSizing=""===j.style.boxSizing||""===j.style.MozBoxSizing||""===j.style.WebkitBoxSizing,n.extend(l,{reliableHiddenOffsets:function(){return null==b&&k(),f},boxSizingReliable:function(){return null==b&&k(),e},pixelMarginRight:function(){return null==b&&k(),c},pixelPosition:function(){return null==b&&k(),b},reliableMarginRight:function(){return null==b&&k(),g},reliableMarginLeft:function(){return null==b&&k(),h}});function k(){var k,l,m=d.documentElement;m.appendChild(i),j.style.cssText="-webkit-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%",b=e=h=!1,c=g=!0,a.getComputedStyle&&(l=a.getComputedStyle(j),b="1%"!==(l||{}).top,h="2px"===(l||{}).marginLeft,e="4px"===(l||{width:"4px"}).width,j.style.marginRight="50%",c="4px"===(l||{marginRight:"4px"}).marginRight,k=j.appendChild(d.createElement("div")),k.style.cssText=j.style.cssText="-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0",k.style.marginRight=k.style.width="0",j.style.width="1px",g=!parseFloat((a.getComputedStyle(k)||{}).marginRight),j.removeChild(k)),j.style.display="none",f=0===j.getClientRects().length,f&&(j.style.display="",j.innerHTML="<table><tr><td></td><td>t</td></tr></table>",j.childNodes[0].style.borderCollapse="separate",k=j.getElementsByTagName("td"),k[0].style.cssText="margin:0;border:0;padding:0;display:none",f=0===k[0].offsetHeight,f&&(k[0].style.display="",k[1].style.display="none",f=0===k[0].offsetHeight)),m.removeChild(i)}}}();var Ra,Sa,Ta=/^(top|right|bottom|left)$/;a.getComputedStyle?(Ra=function(b){var c=b.ownerDocument.defaultView;return c&&c.opener||(c=a),c.getComputedStyle(b)},Sa=function(a,b,c){var d,e,f,g,h=a.style;return c=c||Ra(a),g=c?c.getPropertyValue(b)||c[b]:void 0,""!==g&&void 0!==g||n.contains(a.ownerDocument,a)||(g=n.style(a,b)),c&&!l.pixelMarginRight()&&Oa.test(g)&&Na.test(b)&&(d=h.width,e=h.minWidth,f=h.maxWidth,h.minWidth=h.maxWidth=h.width=g,g=c.width,h.width=d,h.minWidth=e,h.maxWidth=f),void 0===g?g:g+""}):Qa.currentStyle&&(Ra=function(a){return a.currentStyle},Sa=function(a,b,c){var d,e,f,g,h=a.style;return c=c||Ra(a),g=c?c[b]:void 0,null==g&&h&&h[b]&&(g=h[b]),Oa.test(g)&&!Ta.test(b)&&(d=h.left,e=a.runtimeStyle,f=e&&e.left,f&&(e.left=a.currentStyle.left),h.left="fontSize"===b?"1em":g,g=h.pixelLeft+"px",h.left=d,f&&(e.left=f)),void 0===g?g:g+""||"auto"});function Ua(a,b){return{get:function(){return a()?void delete this.get:(this.get=b).apply(this,arguments)}}}var Va=/alpha\([^)]*\)/i,Wa=/opacity\s*=\s*([^)]*)/i,Xa=/^(none|table(?!-c[ea]).+)/,Ya=new RegExp("^("+T+")(.*)$","i"),Za={position:"absolute",visibility:"hidden",display:"block"},$a={letterSpacing:"0",fontWeight:"400"},_a=["Webkit","O","Moz","ms"],ab=d.createElement("div").style;function bb(a){if(a in ab)return a;var b=a.charAt(0).toUpperCase()+a.slice(1),c=_a.length;while(c--)if(a=_a[c]+b,a in ab)return a}function cb(a,b){for(var c,d,e,f=[],g=0,h=a.length;h>g;g++)d=a[g],d.style&&(f[g]=n._data(d,"olddisplay"),c=d.style.display,b?(f[g]||"none"!==c||(d.style.display=""),""===d.style.display&&W(d)&&(f[g]=n._data(d,"olddisplay",Ma(d.nodeName)))):(e=W(d),(c&&"none"!==c||!e)&&n._data(d,"olddisplay",e?c:n.css(d,"display"))));for(g=0;h>g;g++)d=a[g],d.style&&(b&&"none"!==d.style.display&&""!==d.style.display||(d.style.display=b?f[g]||"":"none"));return a}function db(a,b,c){var d=Ya.exec(b);return d?Math.max(0,d[1]-(c||0))+(d[2]||"px"):b}function eb(a,b,c,d,e){for(var f=c===(d?"border":"content")?4:"width"===b?1:0,g=0;4>f;f+=2)"margin"===c&&(g+=n.css(a,c+V[f],!0,e)),d?("content"===c&&(g-=n.css(a,"padding"+V[f],!0,e)),"margin"!==c&&(g-=n.css(a,"border"+V[f]+"Width",!0,e))):(g+=n.css(a,"padding"+V[f],!0,e),"padding"!==c&&(g+=n.css(a,"border"+V[f]+"Width",!0,e)));return g}function fb(a,b,c){var d=!0,e="width"===b?a.offsetWidth:a.offsetHeight,f=Ra(a),g=l.boxSizing&&"border-box"===n.css(a,"boxSizing",!1,f);if(0>=e||null==e){if(e=Sa(a,b,f),(0>e||null==e)&&(e=a.style[b]),Oa.test(e))return e;d=g&&(l.boxSizingReliable()||e===a.style[b]),e=parseFloat(e)||0}return e+eb(a,b,c||(g?"border":"content"),d,f)+"px"}n.extend({cssHooks:{opacity:{get:function(a,b){if(b){var c=Sa(a,"opacity");return""===c?"1":c}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{"float":l.cssFloat?"cssFloat":"styleFloat"},style:function(a,b,c,d){if(a&&3!==a.nodeType&&8!==a.nodeType&&a.style){var e,f,g,h=n.camelCase(b),i=a.style;if(b=n.cssProps[h]||(n.cssProps[h]=bb(h)||h),g=n.cssHooks[b]||n.cssHooks[h],void 0===c)return g&&"get"in g&&void 0!==(e=g.get(a,!1,d))?e:i[b];if(f=typeof c,"string"===f&&(e=U.exec(c))&&e[1]&&(c=X(a,b,e),f="number"),null!=c&&c===c&&("number"===f&&(c+=e&&e[3]||(n.cssNumber[h]?"":"px")),l.clearCloneStyle||""!==c||0!==b.indexOf("background")||(i[b]="inherit"),!(g&&"set"in g&&void 0===(c=g.set(a,c,d)))))try{i[b]=c}catch(j){}}},css:function(a,b,c,d){var e,f,g,h=n.camelCase(b);return b=n.cssProps[h]||(n.cssProps[h]=bb(h)||h),g=n.cssHooks[b]||n.cssHooks[h],g&&"get"in g&&(f=g.get(a,!0,c)),void 0===f&&(f=Sa(a,b,d)),"normal"===f&&b in $a&&(f=$a[b]),""===c||c?(e=parseFloat(f),c===!0||isFinite(e)?e||0:f):f}}),n.each(["height","width"],function(a,b){n.cssHooks[b]={get:function(a,c,d){return c?Xa.test(n.css(a,"display"))&&0===a.offsetWidth?Pa(a,Za,function(){return fb(a,b,d)}):fb(a,b,d):void 0},set:function(a,c,d){var e=d&&Ra(a);return db(a,c,d?eb(a,b,d,l.boxSizing&&"border-box"===n.css(a,"boxSizing",!1,e),e):0)}}}),l.opacity||(n.cssHooks.opacity={get:function(a,b){return Wa.test((b&&a.currentStyle?a.currentStyle.filter:a.style.filter)||"")?.01*parseFloat(RegExp.$1)+"":b?"1":""},set:function(a,b){var c=a.style,d=a.currentStyle,e=n.isNumeric(b)?"alpha(opacity="+100*b+")":"",f=d&&d.filter||c.filter||"";c.zoom=1,(b>=1||""===b)&&""===n.trim(f.replace(Va,""))&&c.removeAttribute&&(c.removeAttribute("filter"),""===b||d&&!d.filter)||(c.filter=Va.test(f)?f.replace(Va,e):f+" "+e)}}),n.cssHooks.marginRight=Ua(l.reliableMarginRight,function(a,b){return b?Pa(a,{display:"inline-block"},Sa,[a,"marginRight"]):void 0}),n.cssHooks.marginLeft=Ua(l.reliableMarginLeft,function(a,b){return b?(parseFloat(Sa(a,"marginLeft"))||(n.contains(a.ownerDocument,a)?a.getBoundingClientRect().left-Pa(a,{
marginLeft:0},function(){return a.getBoundingClientRect().left}):0))+"px":void 0}),n.each({margin:"",padding:"",border:"Width"},function(a,b){n.cssHooks[a+b]={expand:function(c){for(var d=0,e={},f="string"==typeof c?c.split(" "):[c];4>d;d++)e[a+V[d]+b]=f[d]||f[d-2]||f[0];return e}},Na.test(a)||(n.cssHooks[a+b].set=db)}),n.fn.extend({css:function(a,b){return Y(this,function(a,b,c){var d,e,f={},g=0;if(n.isArray(b)){for(d=Ra(a),e=b.length;e>g;g++)f[b[g]]=n.css(a,b[g],!1,d);return f}return void 0!==c?n.style(a,b,c):n.css(a,b)},a,b,arguments.length>1)},show:function(){return cb(this,!0)},hide:function(){return cb(this)},toggle:function(a){return"boolean"==typeof a?a?this.show():this.hide():this.each(function(){W(this)?n(this).show():n(this).hide()})}});function gb(a,b,c,d,e){return new gb.prototype.init(a,b,c,d,e)}n.Tween=gb,gb.prototype={constructor:gb,init:function(a,b,c,d,e,f){this.elem=a,this.prop=c,this.easing=e||n.easing._default,this.options=b,this.start=this.now=this.cur(),this.end=d,this.unit=f||(n.cssNumber[c]?"":"px")},cur:function(){var a=gb.propHooks[this.prop];return a&&a.get?a.get(this):gb.propHooks._default.get(this)},run:function(a){var b,c=gb.propHooks[this.prop];return this.options.duration?this.pos=b=n.easing[this.easing](a,this.options.duration*a,0,1,this.options.duration):this.pos=b=a,this.now=(this.end-this.start)*b+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),c&&c.set?c.set(this):gb.propHooks._default.set(this),this}},gb.prototype.init.prototype=gb.prototype,gb.propHooks={_default:{get:function(a){var b;return 1!==a.elem.nodeType||null!=a.elem[a.prop]&&null==a.elem.style[a.prop]?a.elem[a.prop]:(b=n.css(a.elem,a.prop,""),b&&"auto"!==b?b:0)},set:function(a){n.fx.step[a.prop]?n.fx.step[a.prop](a):1!==a.elem.nodeType||null==a.elem.style[n.cssProps[a.prop]]&&!n.cssHooks[a.prop]?a.elem[a.prop]=a.now:n.style(a.elem,a.prop,a.now+a.unit)}}},gb.propHooks.scrollTop=gb.propHooks.scrollLeft={set:function(a){a.elem.nodeType&&a.elem.parentNode&&(a.elem[a.prop]=a.now)}},n.easing={linear:function(a){return a},swing:function(a){return.5-Math.cos(a*Math.PI)/2},_default:"swing"},n.fx=gb.prototype.init,n.fx.step={};var hb,ib,jb=/^(?:toggle|show|hide)$/,kb=/queueHooks$/;function lb(){return a.setTimeout(function(){hb=void 0}),hb=n.now()}function mb(a,b){var c,d={height:a},e=0;for(b=b?1:0;4>e;e+=2-b)c=V[e],d["margin"+c]=d["padding"+c]=a;return b&&(d.opacity=d.width=a),d}function nb(a,b,c){for(var d,e=(qb.tweeners[b]||[]).concat(qb.tweeners["*"]),f=0,g=e.length;g>f;f++)if(d=e[f].call(c,b,a))return d}function ob(a,b,c){var d,e,f,g,h,i,j,k,m=this,o={},p=a.style,q=a.nodeType&&W(a),r=n._data(a,"fxshow");c.queue||(h=n._queueHooks(a,"fx"),null==h.unqueued&&(h.unqueued=0,i=h.empty.fire,h.empty.fire=function(){h.unqueued||i()}),h.unqueued++,m.always(function(){m.always(function(){h.unqueued--,n.queue(a,"fx").length||h.empty.fire()})})),1===a.nodeType&&("height"in b||"width"in b)&&(c.overflow=[p.overflow,p.overflowX,p.overflowY],j=n.css(a,"display"),k="none"===j?n._data(a,"olddisplay")||Ma(a.nodeName):j,"inline"===k&&"none"===n.css(a,"float")&&(l.inlineBlockNeedsLayout&&"inline"!==Ma(a.nodeName)?p.zoom=1:p.display="inline-block")),c.overflow&&(p.overflow="hidden",l.shrinkWrapBlocks()||m.always(function(){p.overflow=c.overflow[0],p.overflowX=c.overflow[1],p.overflowY=c.overflow[2]}));for(d in b)if(e=b[d],jb.exec(e)){if(delete b[d],f=f||"toggle"===e,e===(q?"hide":"show")){if("show"!==e||!r||void 0===r[d])continue;q=!0}o[d]=r&&r[d]||n.style(a,d)}else j=void 0;if(n.isEmptyObject(o))"inline"===("none"===j?Ma(a.nodeName):j)&&(p.display=j);else{r?"hidden"in r&&(q=r.hidden):r=n._data(a,"fxshow",{}),f&&(r.hidden=!q),q?n(a).show():m.done(function(){n(a).hide()}),m.done(function(){var b;n._removeData(a,"fxshow");for(b in o)n.style(a,b,o[b])});for(d in o)g=nb(q?r[d]:0,d,m),d in r||(r[d]=g.start,q&&(g.end=g.start,g.start="width"===d||"height"===d?1:0))}}function pb(a,b){var c,d,e,f,g;for(c in a)if(d=n.camelCase(c),e=b[d],f=a[c],n.isArray(f)&&(e=f[1],f=a[c]=f[0]),c!==d&&(a[d]=f,delete a[c]),g=n.cssHooks[d],g&&"expand"in g){f=g.expand(f),delete a[d];for(c in f)c in a||(a[c]=f[c],b[c]=e)}else b[d]=e}function qb(a,b,c){var d,e,f=0,g=qb.prefilters.length,h=n.Deferred().always(function(){delete i.elem}),i=function(){if(e)return!1;for(var b=hb||lb(),c=Math.max(0,j.startTime+j.duration-b),d=c/j.duration||0,f=1-d,g=0,i=j.tweens.length;i>g;g++)j.tweens[g].run(f);return h.notifyWith(a,[j,f,c]),1>f&&i?c:(h.resolveWith(a,[j]),!1)},j=h.promise({elem:a,props:n.extend({},b),opts:n.extend(!0,{specialEasing:{},easing:n.easing._default},c),originalProperties:b,originalOptions:c,startTime:hb||lb(),duration:c.duration,tweens:[],createTween:function(b,c){var d=n.Tween(a,j.opts,b,c,j.opts.specialEasing[b]||j.opts.easing);return j.tweens.push(d),d},stop:function(b){var c=0,d=b?j.tweens.length:0;if(e)return this;for(e=!0;d>c;c++)j.tweens[c].run(1);return b?(h.notifyWith(a,[j,1,0]),h.resolveWith(a,[j,b])):h.rejectWith(a,[j,b]),this}}),k=j.props;for(pb(k,j.opts.specialEasing);g>f;f++)if(d=qb.prefilters[f].call(j,a,k,j.opts))return n.isFunction(d.stop)&&(n._queueHooks(j.elem,j.opts.queue).stop=n.proxy(d.stop,d)),d;return n.map(k,nb,j),n.isFunction(j.opts.start)&&j.opts.start.call(a,j),n.fx.timer(n.extend(i,{elem:a,anim:j,queue:j.opts.queue})),j.progress(j.opts.progress).done(j.opts.done,j.opts.complete).fail(j.opts.fail).always(j.opts.always)}n.Animation=n.extend(qb,{tweeners:{"*":[function(a,b){var c=this.createTween(a,b);return X(c.elem,a,U.exec(b),c),c}]},tweener:function(a,b){n.isFunction(a)?(b=a,a=["*"]):a=a.match(G);for(var c,d=0,e=a.length;e>d;d++)c=a[d],qb.tweeners[c]=qb.tweeners[c]||[],qb.tweeners[c].unshift(b)},prefilters:[ob],prefilter:function(a,b){b?qb.prefilters.unshift(a):qb.prefilters.push(a)}}),n.speed=function(a,b,c){var d=a&&"object"==typeof a?n.extend({},a):{complete:c||!c&&b||n.isFunction(a)&&a,duration:a,easing:c&&b||b&&!n.isFunction(b)&&b};return d.duration=n.fx.off?0:"number"==typeof d.duration?d.duration:d.duration in n.fx.speeds?n.fx.speeds[d.duration]:n.fx.speeds._default,null!=d.queue&&d.queue!==!0||(d.queue="fx"),d.old=d.complete,d.complete=function(){n.isFunction(d.old)&&d.old.call(this),d.queue&&n.dequeue(this,d.queue)},d},n.fn.extend({fadeTo:function(a,b,c,d){return this.filter(W).css("opacity",0).show().end().animate({opacity:b},a,c,d)},animate:function(a,b,c,d){var e=n.isEmptyObject(a),f=n.speed(b,c,d),g=function(){var b=qb(this,n.extend({},a),f);(e||n._data(this,"finish"))&&b.stop(!0)};return g.finish=g,e||f.queue===!1?this.each(g):this.queue(f.queue,g)},stop:function(a,b,c){var d=function(a){var b=a.stop;delete a.stop,b(c)};return"string"!=typeof a&&(c=b,b=a,a=void 0),b&&a!==!1&&this.queue(a||"fx",[]),this.each(function(){var b=!0,e=null!=a&&a+"queueHooks",f=n.timers,g=n._data(this);if(e)g[e]&&g[e].stop&&d(g[e]);else for(e in g)g[e]&&g[e].stop&&kb.test(e)&&d(g[e]);for(e=f.length;e--;)f[e].elem!==this||null!=a&&f[e].queue!==a||(f[e].anim.stop(c),b=!1,f.splice(e,1));!b&&c||n.dequeue(this,a)})},finish:function(a){return a!==!1&&(a=a||"fx"),this.each(function(){var b,c=n._data(this),d=c[a+"queue"],e=c[a+"queueHooks"],f=n.timers,g=d?d.length:0;for(c.finish=!0,n.queue(this,a,[]),e&&e.stop&&e.stop.call(this,!0),b=f.length;b--;)f[b].elem===this&&f[b].queue===a&&(f[b].anim.stop(!0),f.splice(b,1));for(b=0;g>b;b++)d[b]&&d[b].finish&&d[b].finish.call(this);delete c.finish})}}),n.each(["toggle","show","hide"],function(a,b){var c=n.fn[b];n.fn[b]=function(a,d,e){return null==a||"boolean"==typeof a?c.apply(this,arguments):this.animate(mb(b,!0),a,d,e)}}),n.each({slideDown:mb("show"),slideUp:mb("hide"),slideToggle:mb("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(a,b){n.fn[a]=function(a,c,d){return this.animate(b,a,c,d)}}),n.timers=[],n.fx.tick=function(){var a,b=n.timers,c=0;for(hb=n.now();c<b.length;c++)a=b[c],a()||b[c]!==a||b.splice(c--,1);b.length||n.fx.stop(),hb=void 0},n.fx.timer=function(a){n.timers.push(a),a()?n.fx.start():n.timers.pop()},n.fx.interval=13,n.fx.start=function(){ib||(ib=a.setInterval(n.fx.tick,n.fx.interval))},n.fx.stop=function(){a.clearInterval(ib),ib=null},n.fx.speeds={slow:600,fast:200,_default:400},n.fn.delay=function(b,c){return b=n.fx?n.fx.speeds[b]||b:b,c=c||"fx",this.queue(c,function(c,d){var e=a.setTimeout(c,b);d.stop=function(){a.clearTimeout(e)}})},function(){var a,b=d.createElement("input"),c=d.createElement("div"),e=d.createElement("select"),f=e.appendChild(d.createElement("option"));c=d.createElement("div"),c.setAttribute("className","t"),c.innerHTML="  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>",a=c.getElementsByTagName("a")[0],b.setAttribute("type","checkbox"),c.appendChild(b),a=c.getElementsByTagName("a")[0],a.style.cssText="top:1px",l.getSetAttribute="t"!==c.className,l.style=/top/.test(a.getAttribute("style")),l.hrefNormalized="/a"===a.getAttribute("href"),l.checkOn=!!b.value,l.optSelected=f.selected,l.enctype=!!d.createElement("form").enctype,e.disabled=!0,l.optDisabled=!f.disabled,b=d.createElement("input"),b.setAttribute("value",""),l.input=""===b.getAttribute("value"),b.value="t",b.setAttribute("type","radio"),l.radioValue="t"===b.value}();var rb=/\r/g,sb=/[\x20\t\r\n\f]+/g;n.fn.extend({val:function(a){var b,c,d,e=this[0];{if(arguments.length)return d=n.isFunction(a),this.each(function(c){var e;1===this.nodeType&&(e=d?a.call(this,c,n(this).val()):a,null==e?e="":"number"==typeof e?e+="":n.isArray(e)&&(e=n.map(e,function(a){return null==a?"":a+""})),b=n.valHooks[this.type]||n.valHooks[this.nodeName.toLowerCase()],b&&"set"in b&&void 0!==b.set(this,e,"value")||(this.value=e))});if(e)return b=n.valHooks[e.type]||n.valHooks[e.nodeName.toLowerCase()],b&&"get"in b&&void 0!==(c=b.get(e,"value"))?c:(c=e.value,"string"==typeof c?c.replace(rb,""):null==c?"":c)}}}),n.extend({valHooks:{option:{get:function(a){var b=n.find.attr(a,"value");return null!=b?b:n.trim(n.text(a)).replace(sb," ")}},select:{get:function(a){for(var b,c,d=a.options,e=a.selectedIndex,f="select-one"===a.type||0>e,g=f?null:[],h=f?e+1:d.length,i=0>e?h:f?e:0;h>i;i++)if(c=d[i],(c.selected||i===e)&&(l.optDisabled?!c.disabled:null===c.getAttribute("disabled"))&&(!c.parentNode.disabled||!n.nodeName(c.parentNode,"optgroup"))){if(b=n(c).val(),f)return b;g.push(b)}return g},set:function(a,b){var c,d,e=a.options,f=n.makeArray(b),g=e.length;while(g--)if(d=e[g],n.inArray(n.valHooks.option.get(d),f)>-1)try{d.selected=c=!0}catch(h){d.scrollHeight}else d.selected=!1;return c||(a.selectedIndex=-1),e}}}}),n.each(["radio","checkbox"],function(){n.valHooks[this]={set:function(a,b){return n.isArray(b)?a.checked=n.inArray(n(a).val(),b)>-1:void 0}},l.checkOn||(n.valHooks[this].get=function(a){return null===a.getAttribute("value")?"on":a.value})});var tb,ub,vb=n.expr.attrHandle,wb=/^(?:checked|selected)$/i,xb=l.getSetAttribute,yb=l.input;n.fn.extend({attr:function(a,b){return Y(this,n.attr,a,b,arguments.length>1)},removeAttr:function(a){return this.each(function(){n.removeAttr(this,a)})}}),n.extend({attr:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return"undefined"==typeof a.getAttribute?n.prop(a,b,c):(1===f&&n.isXMLDoc(a)||(b=b.toLowerCase(),e=n.attrHooks[b]||(n.expr.match.bool.test(b)?ub:tb)),void 0!==c?null===c?void n.removeAttr(a,b):e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:(a.setAttribute(b,c+""),c):e&&"get"in e&&null!==(d=e.get(a,b))?d:(d=n.find.attr(a,b),null==d?void 0:d))},attrHooks:{type:{set:function(a,b){if(!l.radioValue&&"radio"===b&&n.nodeName(a,"input")){var c=a.value;return a.setAttribute("type",b),c&&(a.value=c),b}}}},removeAttr:function(a,b){var c,d,e=0,f=b&&b.match(G);if(f&&1===a.nodeType)while(c=f[e++])d=n.propFix[c]||c,n.expr.match.bool.test(c)?yb&&xb||!wb.test(c)?a[d]=!1:a[n.camelCase("default-"+c)]=a[d]=!1:n.attr(a,c,""),a.removeAttribute(xb?c:d)}}),ub={set:function(a,b,c){return b===!1?n.removeAttr(a,c):yb&&xb||!wb.test(c)?a.setAttribute(!xb&&n.propFix[c]||c,c):a[n.camelCase("default-"+c)]=a[c]=!0,c}},n.each(n.expr.match.bool.source.match(/\w+/g),function(a,b){var c=vb[b]||n.find.attr;yb&&xb||!wb.test(b)?vb[b]=function(a,b,d){var e,f;return d||(f=vb[b],vb[b]=e,e=null!=c(a,b,d)?b.toLowerCase():null,vb[b]=f),e}:vb[b]=function(a,b,c){return c?void 0:a[n.camelCase("default-"+b)]?b.toLowerCase():null}}),yb&&xb||(n.attrHooks.value={set:function(a,b,c){return n.nodeName(a,"input")?void(a.defaultValue=b):tb&&tb.set(a,b,c)}}),xb||(tb={set:function(a,b,c){var d=a.getAttributeNode(c);return d||a.setAttributeNode(d=a.ownerDocument.createAttribute(c)),d.value=b+="","value"===c||b===a.getAttribute(c)?b:void 0}},vb.id=vb.name=vb.coords=function(a,b,c){var d;return c?void 0:(d=a.getAttributeNode(b))&&""!==d.value?d.value:null},n.valHooks.button={get:function(a,b){var c=a.getAttributeNode(b);return c&&c.specified?c.value:void 0},set:tb.set},n.attrHooks.contenteditable={set:function(a,b,c){tb.set(a,""===b?!1:b,c)}},n.each(["width","height"],function(a,b){n.attrHooks[b]={set:function(a,c){return""===c?(a.setAttribute(b,"auto"),c):void 0}}})),l.style||(n.attrHooks.style={get:function(a){return a.style.cssText||void 0},set:function(a,b){return a.style.cssText=b+""}});var zb=/^(?:input|select|textarea|button|object)$/i,Ab=/^(?:a|area)$/i;n.fn.extend({prop:function(a,b){return Y(this,n.prop,a,b,arguments.length>1)},removeProp:function(a){return a=n.propFix[a]||a,this.each(function(){try{this[a]=void 0,delete this[a]}catch(b){}})}}),n.extend({prop:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return 1===f&&n.isXMLDoc(a)||(b=n.propFix[b]||b,e=n.propHooks[b]),void 0!==c?e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:a[b]=c:e&&"get"in e&&null!==(d=e.get(a,b))?d:a[b]},propHooks:{tabIndex:{get:function(a){var b=n.find.attr(a,"tabindex");return b?parseInt(b,10):zb.test(a.nodeName)||Ab.test(a.nodeName)&&a.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),l.hrefNormalized||n.each(["href","src"],function(a,b){n.propHooks[b]={get:function(a){return a.getAttribute(b,4)}}}),l.optSelected||(n.propHooks.selected={get:function(a){var b=a.parentNode;return b&&(b.selectedIndex,b.parentNode&&b.parentNode.selectedIndex),null},set:function(a){var b=a.parentNode;b&&(b.selectedIndex,b.parentNode&&b.parentNode.selectedIndex)}}),n.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){n.propFix[this.toLowerCase()]=this}),l.enctype||(n.propFix.enctype="encoding");var Bb=/[\t\r\n\f]/g;function Cb(a){return n.attr(a,"class")||""}n.fn.extend({addClass:function(a){var b,c,d,e,f,g,h,i=0;if(n.isFunction(a))return this.each(function(b){n(this).addClass(a.call(this,b,Cb(this)))});if("string"==typeof a&&a){b=a.match(G)||[];while(c=this[i++])if(e=Cb(c),d=1===c.nodeType&&(" "+e+" ").replace(Bb," ")){g=0;while(f=b[g++])d.indexOf(" "+f+" ")<0&&(d+=f+" ");h=n.trim(d),e!==h&&n.attr(c,"class",h)}}return this},removeClass:function(a){var b,c,d,e,f,g,h,i=0;if(n.isFunction(a))return this.each(function(b){n(this).removeClass(a.call(this,b,Cb(this)))});if(!arguments.length)return this.attr("class","");if("string"==typeof a&&a){b=a.match(G)||[];while(c=this[i++])if(e=Cb(c),d=1===c.nodeType&&(" "+e+" ").replace(Bb," ")){g=0;while(f=b[g++])while(d.indexOf(" "+f+" ")>-1)d=d.replace(" "+f+" "," ");h=n.trim(d),e!==h&&n.attr(c,"class",h)}}return this},toggleClass:function(a,b){var c=typeof a;return"boolean"==typeof b&&"string"===c?b?this.addClass(a):this.removeClass(a):n.isFunction(a)?this.each(function(c){n(this).toggleClass(a.call(this,c,Cb(this),b),b)}):this.each(function(){var b,d,e,f;if("string"===c){d=0,e=n(this),f=a.match(G)||[];while(b=f[d++])e.hasClass(b)?e.removeClass(b):e.addClass(b)}else void 0!==a&&"boolean"!==c||(b=Cb(this),b&&n._data(this,"__className__",b),n.attr(this,"class",b||a===!1?"":n._data(this,"__className__")||""))})},hasClass:function(a){var b,c,d=0;b=" "+a+" ";while(c=this[d++])if(1===c.nodeType&&(" "+Cb(c)+" ").replace(Bb," ").indexOf(b)>-1)return!0;return!1}}),n.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "),function(a,b){n.fn[b]=function(a,c){return arguments.length>0?this.on(b,null,a,c):this.trigger(b)}}),n.fn.extend({hover:function(a,b){return this.mouseenter(a).mouseleave(b||a)}});var Db=a.location,Eb=n.now(),Fb=/\?/,Gb=/(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;n.parseJSON=function(b){if(a.JSON&&a.JSON.parse)return a.JSON.parse(b+"");var c,d=null,e=n.trim(b+"");return e&&!n.trim(e.replace(Gb,function(a,b,e,f){return c&&b&&(d=0),0===d?a:(c=e||b,d+=!f-!e,"")}))?Function("return "+e)():n.error("Invalid JSON: "+b)},n.parseXML=function(b){var c,d;if(!b||"string"!=typeof b)return null;try{a.DOMParser?(d=new a.DOMParser,c=d.parseFromString(b,"text/xml")):(c=new a.ActiveXObject("Microsoft.XMLDOM"),c.async="false",c.loadXML(b))}catch(e){c=void 0}return c&&c.documentElement&&!c.getElementsByTagName("parsererror").length||n.error("Invalid XML: "+b),c};var Hb=/#.*$/,Ib=/([?&])_=[^&]*/,Jb=/^(.*?):[ \t]*([^\r\n]*)\r?$/gm,Kb=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,Lb=/^(?:GET|HEAD)$/,Mb=/^\/\//,Nb=/^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,Ob={},Pb={},Qb="*/".concat("*"),Rb=Db.href,Sb=Nb.exec(Rb.toLowerCase())||[];function Tb(a){return function(b,c){"string"!=typeof b&&(c=b,b="*");var d,e=0,f=b.toLowerCase().match(G)||[];if(n.isFunction(c))while(d=f[e++])"+"===d.charAt(0)?(d=d.slice(1)||"*",(a[d]=a[d]||[]).unshift(c)):(a[d]=a[d]||[]).push(c)}}function Ub(a,b,c,d){var e={},f=a===Pb;function g(h){var i;return e[h]=!0,n.each(a[h]||[],function(a,h){var j=h(b,c,d);return"string"!=typeof j||f||e[j]?f?!(i=j):void 0:(b.dataTypes.unshift(j),g(j),!1)}),i}return g(b.dataTypes[0])||!e["*"]&&g("*")}function Vb(a,b){var c,d,e=n.ajaxSettings.flatOptions||{};for(d in b)void 0!==b[d]&&((e[d]?a:c||(c={}))[d]=b[d]);return c&&n.extend(!0,a,c),a}function Wb(a,b,c){var d,e,f,g,h=a.contents,i=a.dataTypes;while("*"===i[0])i.shift(),void 0===e&&(e=a.mimeType||b.getResponseHeader("Content-Type"));if(e)for(g in h)if(h[g]&&h[g].test(e)){i.unshift(g);break}if(i[0]in c)f=i[0];else{for(g in c){if(!i[0]||a.converters[g+" "+i[0]]){f=g;break}d||(d=g)}f=f||d}return f?(f!==i[0]&&i.unshift(f),c[f]):void 0}function Xb(a,b,c,d){var e,f,g,h,i,j={},k=a.dataTypes.slice();if(k[1])for(g in a.converters)j[g.toLowerCase()]=a.converters[g];f=k.shift();while(f)if(a.responseFields[f]&&(c[a.responseFields[f]]=b),!i&&d&&a.dataFilter&&(b=a.dataFilter(b,a.dataType)),i=f,f=k.shift())if("*"===f)f=i;else if("*"!==i&&i!==f){if(g=j[i+" "+f]||j["* "+f],!g)for(e in j)if(h=e.split(" "),h[1]===f&&(g=j[i+" "+h[0]]||j["* "+h[0]])){g===!0?g=j[e]:j[e]!==!0&&(f=h[0],k.unshift(h[1]));break}if(g!==!0)if(g&&a["throws"])b=g(b);else try{b=g(b)}catch(l){return{state:"parsererror",error:g?l:"No conversion from "+i+" to "+f}}}return{state:"success",data:b}}n.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:Rb,type:"GET",isLocal:Kb.test(Sb[1]),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":Qb,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":n.parseJSON,"text xml":n.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(a,b){return b?Vb(Vb(a,n.ajaxSettings),b):Vb(n.ajaxSettings,a)},ajaxPrefilter:Tb(Ob),ajaxTransport:Tb(Pb),ajax:function(b,c){"object"==typeof b&&(c=b,b=void 0),c=c||{};var d,e,f,g,h,i,j,k,l=n.ajaxSetup({},c),m=l.context||l,o=l.context&&(m.nodeType||m.jquery)?n(m):n.event,p=n.Deferred(),q=n.Callbacks("once memory"),r=l.statusCode||{},s={},t={},u=0,v="canceled",w={readyState:0,getResponseHeader:function(a){var b;if(2===u){if(!k){k={};while(b=Jb.exec(g))k[b[1].toLowerCase()]=b[2]}b=k[a.toLowerCase()]}return null==b?null:b},getAllResponseHeaders:function(){return 2===u?g:null},setRequestHeader:function(a,b){var c=a.toLowerCase();return u||(a=t[c]=t[c]||a,s[a]=b),this},overrideMimeType:function(a){return u||(l.mimeType=a),this},statusCode:function(a){var b;if(a)if(2>u)for(b in a)r[b]=[r[b],a[b]];else w.always(a[w.status]);return this},abort:function(a){var b=a||v;return j&&j.abort(b),y(0,b),this}};if(p.promise(w).complete=q.add,w.success=w.done,w.error=w.fail,l.url=((b||l.url||Rb)+"").replace(Hb,"").replace(Mb,Sb[1]+"//"),l.type=c.method||c.type||l.method||l.type,l.dataTypes=n.trim(l.dataType||"*").toLowerCase().match(G)||[""],null==l.crossDomain&&(d=Nb.exec(l.url.toLowerCase()),l.crossDomain=!(!d||d[1]===Sb[1]&&d[2]===Sb[2]&&(d[3]||("http:"===d[1]?"80":"443"))===(Sb[3]||("http:"===Sb[1]?"80":"443")))),l.data&&l.processData&&"string"!=typeof l.data&&(l.data=n.param(l.data,l.traditional)),Ub(Ob,l,c,w),2===u)return w;i=n.event&&l.global,i&&0===n.active++&&n.event.trigger("ajaxStart"),l.type=l.type.toUpperCase(),l.hasContent=!Lb.test(l.type),f=l.url,l.hasContent||(l.data&&(f=l.url+=(Fb.test(f)?"&":"?")+l.data,delete l.data),l.cache===!1&&(l.url=Ib.test(f)?f.replace(Ib,"$1_="+Eb++):f+(Fb.test(f)?"&":"?")+"_="+Eb++)),l.ifModified&&(n.lastModified[f]&&w.setRequestHeader("If-Modified-Since",n.lastModified[f]),n.etag[f]&&w.setRequestHeader("If-None-Match",n.etag[f])),(l.data&&l.hasContent&&l.contentType!==!1||c.contentType)&&w.setRequestHeader("Content-Type",l.contentType),w.setRequestHeader("Accept",l.dataTypes[0]&&l.accepts[l.dataTypes[0]]?l.accepts[l.dataTypes[0]]+("*"!==l.dataTypes[0]?", "+Qb+"; q=0.01":""):l.accepts["*"]);for(e in l.headers)w.setRequestHeader(e,l.headers[e]);if(l.beforeSend&&(l.beforeSend.call(m,w,l)===!1||2===u))return w.abort();v="abort";for(e in{success:1,error:1,complete:1})w[e](l[e]);if(j=Ub(Pb,l,c,w)){if(w.readyState=1,i&&o.trigger("ajaxSend",[w,l]),2===u)return w;l.async&&l.timeout>0&&(h=a.setTimeout(function(){w.abort("timeout")},l.timeout));try{u=1,j.send(s,y)}catch(x){if(!(2>u))throw x;y(-1,x)}}else y(-1,"No Transport");function y(b,c,d,e){var k,s,t,v,x,y=c;2!==u&&(u=2,h&&a.clearTimeout(h),j=void 0,g=e||"",w.readyState=b>0?4:0,k=b>=200&&300>b||304===b,d&&(v=Wb(l,w,d)),v=Xb(l,v,w,k),k?(l.ifModified&&(x=w.getResponseHeader("Last-Modified"),x&&(n.lastModified[f]=x),x=w.getResponseHeader("etag"),x&&(n.etag[f]=x)),204===b||"HEAD"===l.type?y="nocontent":304===b?y="notmodified":(y=v.state,s=v.data,t=v.error,k=!t)):(t=y,!b&&y||(y="error",0>b&&(b=0))),w.status=b,w.statusText=(c||y)+"",k?p.resolveWith(m,[s,y,w]):p.rejectWith(m,[w,y,t]),w.statusCode(r),r=void 0,i&&o.trigger(k?"ajaxSuccess":"ajaxError",[w,l,k?s:t]),q.fireWith(m,[w,y]),i&&(o.trigger("ajaxComplete",[w,l]),--n.active||n.event.trigger("ajaxStop")))}return w},getJSON:function(a,b,c){return n.get(a,b,c,"json")},getScript:function(a,b){return n.get(a,void 0,b,"script")}}),n.each(["get","post"],function(a,b){n[b]=function(a,c,d,e){return n.isFunction(c)&&(e=e||d,d=c,c=void 0),n.ajax(n.extend({url:a,type:b,dataType:e,data:c,success:d},n.isPlainObject(a)&&a))}}),n._evalUrl=function(a){return n.ajax({url:a,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,"throws":!0})},n.fn.extend({wrapAll:function(a){if(n.isFunction(a))return this.each(function(b){n(this).wrapAll(a.call(this,b))});if(this[0]){var b=n(a,this[0].ownerDocument).eq(0).clone(!0);this[0].parentNode&&b.insertBefore(this[0]),b.map(function(){var a=this;while(a.firstChild&&1===a.firstChild.nodeType)a=a.firstChild;return a}).append(this)}return this},wrapInner:function(a){return n.isFunction(a)?this.each(function(b){n(this).wrapInner(a.call(this,b))}):this.each(function(){var b=n(this),c=b.contents();c.length?c.wrapAll(a):b.append(a)})},wrap:function(a){var b=n.isFunction(a);return this.each(function(c){n(this).wrapAll(b?a.call(this,c):a)})},unwrap:function(){return this.parent().each(function(){n.nodeName(this,"body")||n(this).replaceWith(this.childNodes)}).end()}});function Yb(a){return a.style&&a.style.display||n.css(a,"display")}function Zb(a){if(!n.contains(a.ownerDocument||d,a))return!0;while(a&&1===a.nodeType){if("none"===Yb(a)||"hidden"===a.type)return!0;a=a.parentNode}return!1}n.expr.filters.hidden=function(a){return l.reliableHiddenOffsets()?a.offsetWidth<=0&&a.offsetHeight<=0&&!a.getClientRects().length:Zb(a)},n.expr.filters.visible=function(a){return!n.expr.filters.hidden(a)};var $b=/%20/g,_b=/\[\]$/,ac=/\r?\n/g,bc=/^(?:submit|button|image|reset|file)$/i,cc=/^(?:input|select|textarea|keygen)/i;function dc(a,b,c,d){var e;if(n.isArray(b))n.each(b,function(b,e){c||_b.test(a)?d(a,e):dc(a+"["+("object"==typeof e&&null!=e?b:"")+"]",e,c,d)});else if(c||"object"!==n.type(b))d(a,b);else for(e in b)dc(a+"["+e+"]",b[e],c,d)}n.param=function(a,b){var c,d=[],e=function(a,b){b=n.isFunction(b)?b():null==b?"":b,d[d.length]=encodeURIComponent(a)+"="+encodeURIComponent(b)};if(void 0===b&&(b=n.ajaxSettings&&n.ajaxSettings.traditional),n.isArray(a)||a.jquery&&!n.isPlainObject(a))n.each(a,function(){e(this.name,this.value)});else for(c in a)dc(c,a[c],b,e);return d.join("&").replace($b,"+")},n.fn.extend({serialize:function(){return n.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var a=n.prop(this,"elements");return a?n.makeArray(a):this}).filter(function(){var a=this.type;return this.name&&!n(this).is(":disabled")&&cc.test(this.nodeName)&&!bc.test(a)&&(this.checked||!Z.test(a))}).map(function(a,b){var c=n(this).val();return null==c?null:n.isArray(c)?n.map(c,function(a){return{name:b.name,value:a.replace(ac,"\r\n")}}):{name:b.name,value:c.replace(ac,"\r\n")}}).get()}}),n.ajaxSettings.xhr=void 0!==a.ActiveXObject?function(){return this.isLocal?ic():d.documentMode>8?hc():/^(get|post|head|put|delete|options)$/i.test(this.type)&&hc()||ic()}:hc;var ec=0,fc={},gc=n.ajaxSettings.xhr();a.attachEvent&&a.attachEvent("onunload",function(){for(var a in fc)fc[a](void 0,!0)}),l.cors=!!gc&&"withCredentials"in gc,gc=l.ajax=!!gc,gc&&n.ajaxTransport(function(b){if(!b.crossDomain||l.cors){var c;return{send:function(d,e){var f,g=b.xhr(),h=++ec;if(g.open(b.type,b.url,b.async,b.username,b.password),b.xhrFields)for(f in b.xhrFields)g[f]=b.xhrFields[f];b.mimeType&&g.overrideMimeType&&g.overrideMimeType(b.mimeType),b.crossDomain||d["X-Requested-With"]||(d["X-Requested-With"]="XMLHttpRequest");for(f in d)void 0!==d[f]&&g.setRequestHeader(f,d[f]+"");g.send(b.hasContent&&b.data||null),c=function(a,d){var f,i,j;if(c&&(d||4===g.readyState))if(delete fc[h],c=void 0,g.onreadystatechange=n.noop,d)4!==g.readyState&&g.abort();else{j={},f=g.status,"string"==typeof g.responseText&&(j.text=g.responseText);try{i=g.statusText}catch(k){i=""}f||!b.isLocal||b.crossDomain?1223===f&&(f=204):f=j.text?200:404}j&&e(f,i,j,g.getAllResponseHeaders())},b.async?4===g.readyState?a.setTimeout(c):g.onreadystatechange=fc[h]=c:c()},abort:function(){c&&c(void 0,!0)}}}});function hc(){try{return new a.XMLHttpRequest}catch(b){}}function ic(){try{return new a.ActiveXObject("Microsoft.XMLHTTP")}catch(b){}}n.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(a){return n.globalEval(a),a}}}),n.ajaxPrefilter("script",function(a){void 0===a.cache&&(a.cache=!1),a.crossDomain&&(a.type="GET",a.global=!1)}),n.ajaxTransport("script",function(a){if(a.crossDomain){var b,c=d.head||n("head")[0]||d.documentElement;return{send:function(e,f){b=d.createElement("script"),b.async=!0,a.scriptCharset&&(b.charset=a.scriptCharset),b.src=a.url,b.onload=b.onreadystatechange=function(a,c){(c||!b.readyState||/loaded|complete/.test(b.readyState))&&(b.onload=b.onreadystatechange=null,b.parentNode&&b.parentNode.removeChild(b),b=null,c||f(200,"success"))},c.insertBefore(b,c.firstChild)},abort:function(){b&&b.onload(void 0,!0)}}}});var jc=[],kc=/(=)\?(?=&|$)|\?\?/;n.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var a=jc.pop()||n.expando+"_"+Eb++;return this[a]=!0,a}}),n.ajaxPrefilter("json jsonp",function(b,c,d){var e,f,g,h=b.jsonp!==!1&&(kc.test(b.url)?"url":"string"==typeof b.data&&0===(b.contentType||"").indexOf("application/x-www-form-urlencoded")&&kc.test(b.data)&&"data");return h||"jsonp"===b.dataTypes[0]?(e=b.jsonpCallback=n.isFunction(b.jsonpCallback)?b.jsonpCallback():b.jsonpCallback,h?b[h]=b[h].replace(kc,"$1"+e):b.jsonp!==!1&&(b.url+=(Fb.test(b.url)?"&":"?")+b.jsonp+"="+e),b.converters["script json"]=function(){return g||n.error(e+" was not called"),g[0]},b.dataTypes[0]="json",f=a[e],a[e]=function(){g=arguments},d.always(function(){void 0===f?n(a).removeProp(e):a[e]=f,b[e]&&(b.jsonpCallback=c.jsonpCallback,jc.push(e)),g&&n.isFunction(f)&&f(g[0]),g=f=void 0}),"script"):void 0}),n.parseHTML=function(a,b,c){if(!a||"string"!=typeof a)return null;"boolean"==typeof b&&(c=b,b=!1),b=b||d;var e=x.exec(a),f=!c&&[];return e?[b.createElement(e[1])]:(e=ja([a],b,f),f&&f.length&&n(f).remove(),n.merge([],e.childNodes))};var lc=n.fn.load;n.fn.load=function(a,b,c){if("string"!=typeof a&&lc)return lc.apply(this,arguments);var d,e,f,g=this,h=a.indexOf(" ");return h>-1&&(d=n.trim(a.slice(h,a.length)),a=a.slice(0,h)),n.isFunction(b)?(c=b,b=void 0):b&&"object"==typeof b&&(e="POST"),g.length>0&&n.ajax({url:a,type:e||"GET",dataType:"html",data:b}).done(function(a){f=arguments,g.html(d?n("<div>").append(n.parseHTML(a)).find(d):a)}).always(c&&function(a,b){g.each(function(){c.apply(this,f||[a.responseText,b,a])})}),this},n.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(a,b){n.fn[b]=function(a){return this.on(b,a)}}),n.expr.filters.animated=function(a){return n.grep(n.timers,function(b){return a===b.elem}).length};function mc(a){return n.isWindow(a)?a:9===a.nodeType?a.defaultView||a.parentWindow:!1}n.offset={setOffset:function(a,b,c){var d,e,f,g,h,i,j,k=n.css(a,"position"),l=n(a),m={};"static"===k&&(a.style.position="relative"),h=l.offset(),f=n.css(a,"top"),i=n.css(a,"left"),j=("absolute"===k||"fixed"===k)&&n.inArray("auto",[f,i])>-1,j?(d=l.position(),g=d.top,e=d.left):(g=parseFloat(f)||0,e=parseFloat(i)||0),n.isFunction(b)&&(b=b.call(a,c,n.extend({},h))),null!=b.top&&(m.top=b.top-h.top+g),null!=b.left&&(m.left=b.left-h.left+e),"using"in b?b.using.call(a,m):l.css(m)}},n.fn.extend({offset:function(a){if(arguments.length)return void 0===a?this:this.each(function(b){n.offset.setOffset(this,a,b)});var b,c,d={top:0,left:0},e=this[0],f=e&&e.ownerDocument;if(f)return b=f.documentElement,n.contains(b,e)?("undefined"!=typeof e.getBoundingClientRect&&(d=e.getBoundingClientRect()),c=mc(f),{top:d.top+(c.pageYOffset||b.scrollTop)-(b.clientTop||0),left:d.left+(c.pageXOffset||b.scrollLeft)-(b.clientLeft||0)}):d},position:function(){if(this[0]){var a,b,c={top:0,left:0},d=this[0];return"fixed"===n.css(d,"position")?b=d.getBoundingClientRect():(a=this.offsetParent(),b=this.offset(),n.nodeName(a[0],"html")||(c=a.offset()),c.top+=n.css(a[0],"borderTopWidth",!0),c.left+=n.css(a[0],"borderLeftWidth",!0)),{top:b.top-c.top-n.css(d,"marginTop",!0),left:b.left-c.left-n.css(d,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var a=this.offsetParent;while(a&&!n.nodeName(a,"html")&&"static"===n.css(a,"position"))a=a.offsetParent;return a||Qa})}}),n.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(a,b){var c=/Y/.test(b);n.fn[a]=function(d){return Y(this,function(a,d,e){var f=mc(a);return void 0===e?f?b in f?f[b]:f.document.documentElement[d]:a[d]:void(f?f.scrollTo(c?n(f).scrollLeft():e,c?e:n(f).scrollTop()):a[d]=e)},a,d,arguments.length,null)}}),n.each(["top","left"],function(a,b){n.cssHooks[b]=Ua(l.pixelPosition,function(a,c){return c?(c=Sa(a,b),Oa.test(c)?n(a).position()[b]+"px":c):void 0})}),n.each({Height:"height",Width:"width"},function(a,b){n.each({
padding:"inner"+a,content:b,"":"outer"+a},function(c,d){n.fn[d]=function(d,e){var f=arguments.length&&(c||"boolean"!=typeof d),g=c||(d===!0||e===!0?"margin":"border");return Y(this,function(b,c,d){var e;return n.isWindow(b)?b.document.documentElement["client"+a]:9===b.nodeType?(e=b.documentElement,Math.max(b.body["scroll"+a],e["scroll"+a],b.body["offset"+a],e["offset"+a],e["client"+a])):void 0===d?n.css(b,c,g):n.style(b,c,d,g)},b,f?d:void 0,f,null)}})}),n.fn.extend({bind:function(a,b,c){return this.on(a,null,b,c)},unbind:function(a,b){return this.off(a,null,b)},delegate:function(a,b,c,d){return this.on(b,a,c,d)},undelegate:function(a,b,c){return 1===arguments.length?this.off(a,"**"):this.off(b,a||"**",c)}}),n.fn.size=function(){return this.length},n.fn.andSelf=n.fn.addBack,"function"==typeof define&&define.amd&&define("jquery",[],function(){return n});var nc=a.jQuery,oc=a.$;return n.noConflict=function(b){return a.$===n&&(a.$=oc),b&&a.jQuery===n&&(a.jQuery=nc),n},b||(a.jQuery=a.$=n),n});

/*
 * Inline Form Validation Engine 2.6, jQuery plugin
 *
 * Copyright(c) 2010, Cedric Dugas
 * http://www.position-absolute.com
 *
 * 2.0 Rewrite by Olivier Refalo
 * http://www.crionics.com
 *
 * Form validation engine allowing custom regex rules to be added.
 * Licensed under the MIT License
 */
(function($) {

  "use strict";

  var methods = {

    /**
     * Kind of the constructor, called before any action
     * @param {Map} user options
     */
    init: function(options) {
      var form = this;
      if (!form.data('jqv') || form.data('jqv') == null) {
        options = methods._saveOptions(form, options);
        // bind all formError elements to close on click
        $(".formError").off("click");
        $(".formError").on("click", function() {
          $(this).fadeOut(150, function() {
            // remove prompt once invisible
            $(this).parent('.formErrorOuter').remove();
            $(this).remove();
          });
        });
      }
      return this;
    },
    /**
     * Attachs jQuery.validationEngine to form.submit and field.blur events
     * Takes an optional params: a list of options
     * ie. jQuery("#formID1").validationEngine('attach', {promptPosition : "centerRight"});
     */
    attach: function(userOptions) {

      if (!$(this).is("form")) {
        alert("Sorry, jqv.attach() only applies to a form");
        return this;
      }

      var form = this;
      var options;

      if (userOptions)
        options = methods._saveOptions(form, userOptions);
      else
        options = form.data('jqv');

      options.validateAttribute = (form.find("[data-validation-engine*=validate]").length) ? "data-validation-engine" : "class";
      if (options.binded) {

        // bind fields
        form.find("[" + options.validateAttribute + "*=validate]").not("[type=checkbox]").not("[type=radio]").not(".datepicker").bind(options.validationEventTrigger, methods._onFieldEvent);
        form.find("[" + options.validateAttribute + "*=validate][type=checkbox],[" + options.validateAttribute + "*=validate][type=radio]").bind("click", methods._onFieldEvent);
        form.find("[" + options.validateAttribute + "*=validate][class*=datepicker]").bind(options.validationEventTrigger, { "delay": 300 }, methods._onFieldEvent);
      }
      if (options.autoPositionUpdate) {
        $(window).bind("resize", {
          "noAnimation": true,
          "formElem": form
        }, methods.updatePromptsPosition);
      }
      // bind form.submit
      form.bind("submit", methods._onSubmitEvent);
      return this;
    },
    /**
     * Unregisters any bindings that may point to jQuery.validaitonEngine
     */
    detach: function() {

      if (!$(this).is("form")) {
        alert("Sorry, jqv.detach() only applies to a form");
        return this;
      }

      var form = this;
      var options = form.data('jqv');

      // unbind fields
      form.find("[" + options.validateAttribute + "*=validate]").not("[type=checkbox]").unbind(options.validationEventTrigger, methods._onFieldEvent);
      form.find("[" + options.validateAttribute + "*=validate][type=checkbox],[class*=validate][type=radio]").unbind("click", methods._onFieldEvent);

      // unbind form.submit
      form.unbind("submit", methods.onAjaxFormComplete);

      // unbind live fields (kill)
      form.find("[" + options.validateAttribute + "*=validate]").not("[type=checkbox]").die(options.validationEventTrigger, methods._onFieldEvent);
      form.find("[" + options.validateAttribute + "*=validate][type=checkbox]").die("click", methods._onFieldEvent);

      // unbind form.submit
      form.die("submit", methods.onAjaxFormComplete);
      form.removeData('jqv');

      if (options.autoPositionUpdate)
        $(window).unbind("resize", methods.updatePromptsPosition);

      return this;
    },
    /**
     * Validates either a form or a list of fields, shows prompts accordingly.
     * Note: There is no ajax form validation with this method, only field ajax validation are evaluated
     *
     * @return true if the form validates, false if it fails
     */
    validate: function() {
      var element = $(this);
      var valid = null;
      if (element.is("form") && !element.hasClass('validating')) {
        element.addClass('validating');
        var options = element.data('jqv');
        valid = methods._validateFields(this);

        // If the form doesn't validate, clear the 'validating' class before the user has a chance to submit again
        setTimeout(function() {
          element.removeClass('validating');
        }, 100);
        if (valid && options.onFormSuccess) {
          options.onFormSuccess();
        } else if (!valid && options.onFormFailure) {
          options.onFormFailure();
        }
      } else if (element.is('form')) {
        element.removeClass('validating');
      } else {
        // field validation
        var form = element.closest('form');
        var options = form.data('jqv');
        valid = methods._validateField(element, options);

        if (valid && options.onFieldSuccess)
          options.onFieldSuccess();
        else if (options.onFieldFailure && options.InvalidFields.length > 0) {
          options.onFieldFailure();
        }
      }
      return valid;
    },
    /**
     *  Redraw prompts position, useful when you change the DOM state when validating
     */
    updatePromptsPosition: function(event) {

      if (event && this == window) {
        var form = event.data.formElem;
        var noAnimation = event.data.noAnimation;
      } else
        var form = $(this.closest('form'));

      var options = form.data('jqv');
      // No option, take default one
      form.find('[' + options.validateAttribute + '*=validate]').not(":disabled").each(function() {
        var field = $(this);
        if (options.prettySelect && field.is(":hidden"))
          field = form.find("#" + options.usePrefix + field.attr('id') + options.useSuffix);
        var prompt = methods._getPrompt(field);
        var promptText = $(prompt).find(".formErrorContent").html();

        if (prompt)
          methods._updatePrompt(field, $(prompt), promptText, undefined, false, options, noAnimation);
      });
      return this;
    },
    /**
     * Displays a prompt on a element.
     * Note that the element needs an id!
     *
     * @param {String} promptText html text to display type
     * @param {String} type the type of bubble: 'pass' (green), 'load' (black) anything else (red)
     * @param {String} possible values topLeft, topRight, bottomLeft, centerRight, bottomRight
     */
    showPrompt: function(promptText, type, promptPosition, showArrow) {

      var form = this.closest('form');
      var options = form.data('jqv');
      // No option, take default one
      console.log("promptPosition >>> ", promptPosition);
      if (!options)
        options = methods._saveOptions(this, options);
      if (promptPosition)
        options.promptPosition = promptPosition;
      options.showArrow = showArrow == true;

      methods._showPrompt(this, promptText, type, false, options);
      return this;
    },
    /**
     * Closes form error prompts, CAN be invidual
     */
    hide: function() {
      var form = $(this).closest('form');
      var options = form.data('jqv');
      var fadeDuration = (options && options.fadeDuration) ? options.fadeDuration : 0.3;
      var closingtag;

      if ($(this).is("form")) {
        closingtag = "parentForm" + methods._getClassName($(this).attr("id"));
      } else {
        closingtag = methods._getClassName($(this).attr("id")) + "formError";
      }
      $('.' + closingtag).fadeTo(fadeDuration, 0.3, function() {
        $(this).parent('.formErrorOuter').remove();
        $(this).remove();
      });
      return this;
    },
    /**
     * Closes all error prompts on the page
     */
    hideAll: function() {

      var form = this;
      var options = form.data('jqv');
      var duration = options ? options.fadeDuration : 0.3;
      $('.formError').fadeTo(duration, 0.3, function() {
        $(this).parent('.formErrorOuter').remove();
        $(this).remove();
      });
      return this;
    },
    /**
     * Typically called when user exists a field using tab or a mouse click, triggers a field
     * validation
     */
    _onFieldEvent: function(event) {
      var field = $(this);
      var form = field.closest('form');
      var options = form.data('jqv');
      options.eventTrigger = "field";
      // validate the current field
      window.setTimeout(function() {
        methods._validateField(field, options);
        if (options.InvalidFields.length == 0 && options.onFieldSuccess) {
          options.onFieldSuccess();
        } else if (options.InvalidFields.length > 0 && options.onFieldFailure) {
          options.onFieldFailure();
        }
      }, (event.data) ? event.data.delay : 0);

    },
    /**
     * Called when the form is submited, shows prompts accordingly
     *
     * @param {jqObject}
     *            form
     * @return false if form submission needs to be cancelled
     */
    _onSubmitEvent: function() {
      var form = $(this);
      var options = form.data('jqv');
      options.eventTrigger = "submit";

      // validate each field 
      // (- skip field ajax validation, not necessary IF we will perform an ajax form validation)
      var r = methods._validateFields(form);

      if (r && options.ajaxFormValidation) {
        methods._validateFormWithAjax(form, options);
        // cancel form auto-submission - process with async call onAjaxFormComplete
        return false;
      }

      if (options.onValidationComplete) {
        // !! ensures that an undefined return is interpreted as return false but allows a onValidationComplete() to possibly return true and have form continue processing
        return !!options.onValidationComplete(form, r);
      }
      return r;
    },
    /**
     * Return true if the ajax field validations passed so far
     * @param {Object} options
     * @return true, is all ajax validation passed so far (remember ajax is async)
     */
    _checkAjaxStatus: function(options) {
      var status = true;
      $.each(options.ajaxValidCache, function(key, value) {
        if (!value) {
          status = false;
          // break the each
          return false;
        }
      });
      return status;
    },

    /**
     * Return true if the ajax field is validated
     * @param {String} fieldid
     * @param {Object} options
     * @return true, if validation passed, false if false or doesn't exist
     */
    _checkAjaxFieldStatus: function(fieldid, options) {
      return options.ajaxValidCache[fieldid] == true;
    },
    /**
     * Validates form fields, shows prompts accordingly
     *
     * @param {jqObject}
     *            form
     * @param {skipAjaxFieldValidation}
     *            boolean - when set to true, ajax field validation is skipped, typically used when the submit button is clicked
     *
     * @return true if form is valid, false if not, undefined if ajax form validation is done
     */
    _validateFields: function(form) {
      var options = form.data('jqv');

      // this variable is set to true if an error is found
      var errorFound = false;

      // Trigger hook, start validation
      form.trigger("jqv.form.validating");
      // first, evaluate status of non ajax fields
      var first_err = null;
      form.find('[' + options.validateAttribute + '*=validate]').not(":disabled").each(function() {
        var field = $(this);
        var names = [];
        if ($.inArray(field.attr('name'), names) < 0) {
          errorFound |= methods._validateField(field, options);
          if (errorFound && first_err == null)
            if (field.is(":hidden") && options.prettySelect)
              first_err = field = form.find("#" + options.usePrefix + methods._jqSelector(field.attr('id')) + options.useSuffix);
            else
              first_err = field;
          if (options.doNotShowAllErrosOnSubmit)
            return false;
          names.push(field.attr('name'));

          //if option set, stop checking validation rules after one error is found
          if (options.showOneMessage == true && errorFound) {
            return false;
          }
        }
      });

      // second, check to see if all ajax calls completed ok
      // errorFound |= !methods._checkAjaxStatus(options);

      // third, check status and scroll the container accordingly
      form.trigger("jqv.form.result", [errorFound]);

      if (errorFound) {
        if (options.scroll) {
          var destination = first_err.offset().top;
          // console.log("destination first ", destination);
          // console.log("options first ", options);
          var fixleft = first_err.offset().left;

          //prompt positioning adjustment support. Usage: positionType:Xshift,Yshift (for ex.: bottomLeft:+20 or bottomLeft:-20,+10)
          var positionType = options.promptPosition;
          if (typeof(positionType) == 'string' && positionType.indexOf(":") != -1)
            positionType = positionType.substring(0, positionType.indexOf(":"));

          if (positionType != "bottomRight" && positionType != "bottomLeft") {
            var prompt_err = methods._getPrompt(first_err);
            // console.log("prompt_err > ", prompt_err);
            // console.log("prompt_err top > ", prompt_err.offset().top);
            if (prompt_err) {
              // var diff = destination - prompt_err.offset().top;
              destination = prompt_err.offset().top + 80;
            }
          }
          // console.log("destination Second ", destination);

          // get the position of the first error, there should be at least one, no need to check this
          //var destination = form.find(".formError:not('.greenPopup'):first").offset().top;
          if (options.isOverflown) {
            var overflowDIV = $(options.overflownDIV);
            if (!overflowDIV.length) return false;
            var scrollContainerScroll = overflowDIV.scrollTop();
            var scrollContainerPos = -parseInt(overflowDIV.offset().top);

            destination += scrollContainerScroll + scrollContainerPos - 5;
            var scrollContainer = $(options.overflownDIV + ":not(:animated)");
            // console.log("destination if : ", destination);
            scrollContainer.animate({ scrollTop: destination }, 1100, function() {
              if (options.focusFirstField) first_err.focus();
            });
          } else {
            // console.log("destination else : ", destination);
            $("body,html").stop().animate({
              scrollTop: destination,
              scrollLeft: fixleft
            }, 1100, function() {
              if (options.focusFirstField) first_err.focus();
            });
          }

        } else if (options.focusFirstField)
          first_err.focus();
        return false;
      }
      return true;
    },
    /**
     * This method is called to perform an ajax form validation.
     * During this process all the (field, value) pairs are sent to the server which returns a list of invalid fields or true
     *
     * @param {jqObject} form
     * @param {Map} options
     */
    _validateFormWithAjax: function(form, options) {

      var data = form.serialize();
      var type = (options.ajaxmethod) ? options.ajaxmethod : "GET";
      var url = (options.ajaxFormValidationURL) ? options.ajaxFormValidationURL : form.attr("action");
      var dataType = (options.dataType) ? options.dataType : "json";
      $.ajax({
        type: type,
        url: url,
        cache: false,
        dataType: dataType,
        data: data,
        form: form,
        methods: methods,
        options: options,
        beforeSend: function() {
          return options.onBeforeAjaxFormValidation(form, options);
        },
        error: function(data, transport) {
          methods._ajaxError(data, transport);
        },
        success: function(json) {
          if ((dataType == "json") && (json !== true)) {
            // getting to this case doesn't necessary means that the form is invalid
            // the server may return green or closing prompt actions
            // this flag helps figuring it out
            var errorInForm = false;
            for (var i = 0; i < json.length; i++) {
              var value = json[i];

              var errorFieldId = value[0];
              var errorField = $($("#" + errorFieldId)[0]);

              // make sure we found the element
              if (errorField.length == 1) {

                // promptText or selector
                var msg = value[2];
                // if the field is valid
                if (value[1] == true) {

                  if (msg == "" || !msg) {
                    // if for some reason, status==true and error="", just close the prompt
                    methods._closePrompt(errorField);
                  } else {
                    // the field is valid, but we are displaying a green prompt
                    if (options.allrules[msg]) {
                      var txt = options.allrules[msg].alertTextOk;
                      if (txt)
                        msg = txt;
                    }
                    methods._showPrompt(errorField, msg, "pass", false, options, true);
                  }
                } else {
                  // the field is invalid, show the red error prompt
                  errorInForm |= true;
                  if (options.allrules[msg]) {
                    var txt = options.allrules[msg].alertText;
                    if (txt)
                      msg = txt;
                  }
                  methods._showPrompt(errorField, msg, "", false, options, true);
                }
              }
            }
            options.onAjaxFormComplete(!errorInForm, form, json, options);
          } else
            options.onAjaxFormComplete(true, form, json, options);

        }
      });

    },
    /**
     * Validates field, shows prompts accordingly
     *
     * @param {jqObject}
     *            field
     * @param {Array[String]}
     *            field's validation rules
     * @param {Map}
     *            user options
     * @return false if field is valid (It is inversed for *fields*, it return false on validate and true on errors.)
     */
    _validateField: function(field, options, skipAjaxValidation) {
      if (!field.attr("id")) {
        field.attr("id", "form-validation-field-" + $.validationEngine.fieldIdCounter);
        ++$.validationEngine.fieldIdCounter;
      }

      if (field.is(":hidden") && !options.prettySelect || field.parent().is(":hidden"))
        return false;

      var rulesParsing = field.attr(options.validateAttribute);
      var getRules = /validate\[(.*)\]/.exec(rulesParsing);

      if (!getRules)
        return false;
      var str = getRules[1];
      var rules = str.split(/\[|,|\]/);

      // true if we ran the ajax validation, tells the logic to stop messing with prompts
      var isAjaxValidator = false;
      var fieldName = field.attr("name");
      var promptText = "";
      var promptType = "";
      var required = false;
      var limitErrors = false;
      options.isError = false;
      options.showArrow = true;

      // If the programmer wants to limit the amount of error messages per field,
      if (options.maxErrorsPerField > 0) {
        limitErrors = true;
      }

      var form = $(field.closest("form"));
      // Fix for adding spaces in the rules
      for (var i in rules) {
        rules[i] = rules[i].replace(" ", "");
        // Remove any parsing errors
        if (rules[i] === '') {
          delete rules[i];
        }
      }

      for (var i = 0, field_errors = 0; i < rules.length; i++) {

        // If we are limiting errors, and have hit the max, break
        if (limitErrors && field_errors >= options.maxErrorsPerField) {
          // If we haven't hit a required yet, check to see if there is one in the validation rules for this
          // field and that it's index is greater or equal to our current index
          if (!required) {
            var have_required = $.inArray('required', rules);
            required = (have_required != -1 && have_required >= i);
          }
          break;
        }


        var errorMsg = undefined;
        switch (rules[i]) {

          case "required":
            required = true;
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._required);
            break;
          case "custom":
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._custom);
            break;
          case "groupRequired":
            // Check is its the first of group, if not, reload validation with first field
            // AND continue normal validation on present field
            var classGroup = "[" + options.validateAttribute + "*=" + rules[i + 1] + "]";
            var firstOfGroup = form.find(classGroup).eq(0);
            if (firstOfGroup[0] != field[0]) {
              methods._validateField(firstOfGroup, options, skipAjaxValidation);
              options.showArrow = true;
              continue;
            }
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._groupRequired);
            if (errorMsg) required = true;
            options.showArrow = false;
            break;
          case "ajax":
            // AJAX defaults to returning it's loading message
            errorMsg = methods._ajax(field, rules, i, options);
            if (errorMsg) {
              promptType = "load";
            }
            break;
          case "minSize":
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._minSize);
            break;
          case "maxSize":
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._maxSize);
            break;
          case "min":
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._min);
            break;
          case "max":
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._max);
            break;
          case "past":
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._past);
            break;
          case "future":
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._future);
            break;
          case "dateRange":
            var classGroup = "[" + options.validateAttribute + "*=" + rules[i + 1] + "]";
            options.firstOfGroup = form.find(classGroup).eq(0);
            options.secondOfGroup = form.find(classGroup).eq(1);

            //if one entry out of the pair has value then proceed to run through validation
            if (options.firstOfGroup[0].value || options.secondOfGroup[0].value) {
              errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._dateRange);
            }
            if (errorMsg) required = true;
            options.showArrow = false;
            break;

          case "dateTimeRange":
            var classGroup = "[" + options.validateAttribute + "*=" + rules[i + 1] + "]";
            options.firstOfGroup = form.find(classGroup).eq(0);
            options.secondOfGroup = form.find(classGroup).eq(1);

            //if one entry out of the pair has value then proceed to run through validation
            if (options.firstOfGroup[0].value || options.secondOfGroup[0].value) {
              errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._dateTimeRange);
            }
            if (errorMsg) required = true;
            options.showArrow = false;
            break;
          case "maxCheckbox":
            field = $(form.find("input[name='" + fieldName + "']"));
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._maxCheckbox);
            break;
          case "minCheckbox":
            field = $(form.find("input[name='" + fieldName + "']"));
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._minCheckbox);
            break;
          case "equals":
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._equals);
            break;
          case "funcCall":
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._funcCall);
            break;
          case "creditCard":
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._creditCard);
            break;
          case "condRequired":
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._condRequired);
            if (errorMsg !== undefined) {
              required = true;
            }
            break;

          default:
        }

        var end_validation = false;

        // If we were passed back an message object, check what the status was to determine what to do
        if (typeof errorMsg == "object") {
          switch (errorMsg.status) {
            case "_break":
              end_validation = true;
              break;
              // If we have an error message, set errorMsg to the error message
            case "_error":
              errorMsg = errorMsg.message;
              break;
              // If we want to throw an error, but not show a prompt, return early with true
            case "_error_no_prompt":
              return true;
              break;
              // Anything else we continue on
            default:
              break;
          }
        }

        // If it has been specified that validation should end now, break
        if (end_validation) {
          break;
        }

        // If we have a string, that means that we have an error, so add it to the error message.
        if (typeof errorMsg == 'string') {
          promptText += errorMsg + "<br/>";
          options.isError = true;
          field_errors++;
        }
      }
      // If the rules required is not added, an empty field is not validated
      if (!required && field.val().length < 1) options.isError = false;

      // Hack for radio/checkbox group button, the validation go into the
      // first radio/checkbox of the group
      var fieldType = field.prop("type");

      if ((fieldType == "radio" || fieldType == "checkbox") && form.find("input[name='" + fieldName + "']").size() > 1) {
        field = $(form.find("input[name='" + fieldName + "'][type!=hidden]:first"));
        options.showArrow = false;
      }

      if (field.is(":hidden") && options.prettySelect) {
        field = form.find("#" + options.usePrefix + methods._jqSelector(field.attr('id')) + options.useSuffix);
      }

      if (options.isError) {
        methods._showPrompt(field, promptText, promptType, false, options);
      } else {
        if (!isAjaxValidator) methods._closePrompt(field);
      }

      if (!isAjaxValidator) {
        field.trigger("jqv.field.result", [field, options.isError, promptText]);
      }

      /* Record error */
      var errindex = $.inArray(field[0], options.InvalidFields);
      if (errindex == -1) {
        if (options.isError)
          options.InvalidFields.push(field[0]);
      } else if (!options.isError) {
        options.InvalidFields.splice(errindex, 1);
      }

      methods._handleStatusCssClasses(field, options);

      return options.isError;
    },
    /**
     * Handling css classes of fields indicating result of validation 
     *
     * @param {jqObject}
     *            field
     * @param {Array[String]}
     *            field's validation rules            
     * @private
     */
    _handleStatusCssClasses: function(field, options) {
      /* remove all classes */
      if (options.addSuccessCssClassToField)
        field.removeClass(options.addSuccessCssClassToField);

      if (options.addFailureCssClassToField)
        field.removeClass(options.addFailureCssClassToField);

      /* Add classes */
      if (options.addSuccessCssClassToField && !options.isError)
        field.addClass(options.addSuccessCssClassToField);

      if (options.addFailureCssClassToField && options.isError)
        field.addClass(options.addFailureCssClassToField);
    },

    /********************
     * _getErrorMessage
     *
     * @param form
     * @param field
     * @param rule
     * @param rules
     * @param i
     * @param options
     * @param originalValidationMethod
     * @return {*}
     * @private
     */
    _getErrorMessage: function(form, field, rule, rules, i, options, originalValidationMethod) {
      // If we are using the custon validation type, build the index for the rule.
      // Otherwise if we are doing a function call, make the call and return the object
      // that is passed back.
      var beforeChangeRule = rule;
      if (rule == "custom") {
        var custom_validation_type_index = jQuery.inArray(rule, rules) + 1;
        var custom_validation_type = rules[custom_validation_type_index];
        rule = "custom[" + custom_validation_type + "]";
      }
      var element_classes = (field.attr("data-validation-engine")) ? field.attr("data-validation-engine") : field.attr("class");
      var element_classes_array = element_classes.split(" ");

      // Call the original validation method. If we are dealing with dates or checkboxes, also pass the form
      var errorMsg;
      if (rule == "future" || rule == "past" || rule == "maxCheckbox" || rule == "minCheckbox") {
        errorMsg = originalValidationMethod(form, field, rules, i, options);
      } else {
        errorMsg = originalValidationMethod(field, rules, i, options);
      }

      // If the original validation method returned an error and we have a custom error message,
      // return the custom message instead. Otherwise return the original error message.
      if (errorMsg != undefined) {
        var custom_message = methods._getCustomErrorMessage($(field), element_classes_array, beforeChangeRule, options);
        if (custom_message) errorMsg = custom_message;
      }
      return errorMsg;

    },
    _getCustomErrorMessage: function(field, classes, rule, options) {
      var custom_message = false;
      var validityProp = methods._validityProp[rule];
      // If there is a validityProp for this rule, check to see if the field has an attribute for it
      if (validityProp != undefined) {
        custom_message = field.attr("data-errormessage-" + validityProp);
        // If there was an error message for it, return the message
        if (custom_message != undefined)
          return custom_message;
      }
      custom_message = field.attr("data-errormessage");
      // If there is an inline custom error message, return it
      if (custom_message != undefined)
        return custom_message;
      var id = '#' + field.attr("id");
      // If we have custom messages for the element's id, get the message for the rule from the id.
      // Otherwise, if we have custom messages for the element's classes, use the first class message we find instead.
      if (typeof options.custom_error_messages[id] != "undefined" &&
        typeof options.custom_error_messages[id][rule] != "undefined") {
        custom_message = options.custom_error_messages[id][rule]['message'];
      } else if (classes.length > 0) {
        for (var i = 0; i < classes.length && classes.length > 0; i++) {
          var element_class = "." + classes[i];
          if (typeof options.custom_error_messages[element_class] != "undefined" &&
            typeof options.custom_error_messages[element_class][rule] != "undefined") {
            custom_message = options.custom_error_messages[element_class][rule]['message'];
            break;
          }
        }
      }
      if (!custom_message &&
        typeof options.custom_error_messages[rule] != "undefined" &&
        typeof options.custom_error_messages[rule]['message'] != "undefined") {
        custom_message = options.custom_error_messages[rule]['message'];
      }
      return custom_message;
    },
    _validityProp: {
      "required": "value-missing",
      "custom": "custom-error",
      "groupRequired": "value-missing",
      "ajax": "custom-error",
      "minSize": "range-underflow",
      "maxSize": "range-overflow",
      "min": "range-underflow",
      "max": "range-overflow",
      "past": "type-mismatch",
      "future": "type-mismatch",
      "dateRange": "type-mismatch",
      "dateTimeRange": "type-mismatch",
      "maxCheckbox": "range-overflow",
      "minCheckbox": "range-underflow",
      "equals": "pattern-mismatch",
      "funcCall": "custom-error",
      "creditCard": "pattern-mismatch",
      "condRequired": "value-missing"
    },
    /**
     * Required validation
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return an error string if validation failed
     */
    _required: function(field, rules, i, options) {
      switch (field.prop("type")) {
        case "text":
        case "password":
        case "textarea":
        case "file":
        case "select-one":
        case "select-multiple":
        default:

          if (!$.trim(field.val()) || field.val() == field.attr("data-validation-placeholder") || field.val() == field.attr("placeholder"))
            return options.allrules[rules[i]].alertText;
          break;
        case "radio":
        case "checkbox":
          var form = field.closest("form");
          var name = field.attr("name");
          if (form.find("input[name='" + name + "']:checked").size() == 0) {
            if (form.find("input[name='" + name + "']:visible").size() == 1)
              return options.allrules[rules[i]].alertTextCheckboxe;
            else
              return options.allrules[rules[i]].alertTextCheckboxMultiple;
          }
          break;
      }
    },
    /**
     * Validate that 1 from the group field is required
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return an error string if validation failed
     */
    _groupRequired: function(field, rules, i, options) {
      var classGroup = "[" + options.validateAttribute + "*=" + rules[i + 1] + "]";
      var isValid = false;
      // Check all fields from the group
      field.closest("form").find(classGroup).each(function() {
        if (!methods._required($(this), rules, i, options)) {
          isValid = true;
          return false;
        }
      });

      if (!isValid) {
        return options.allrules[rules[i]].alertText;
      }
    },
    /**
     * Validate rules
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return an error string if validation failed
     */
    _custom: function(field, rules, i, options) {
      var customRule = rules[i + 1];
      var rule = options.allrules[customRule];
      var fn;
      if (!rule) {
        alert("jqv:custom rule not found - " + customRule);
        return;
      }

      if (rule["regex"]) {
        var ex = rule.regex;
        if (!ex) {
          alert("jqv:custom regex not found - " + customRule);
          return;
        }
        var pattern = new RegExp(ex);

        if (!pattern.test(field.val())) return options.allrules[customRule].alertText;

      } else if (rule["func"]) {
        fn = rule["func"];

        if (typeof(fn) !== "function") {
          alert("jqv:custom parameter 'function' is no function - " + customRule);
          return;
        }

        if (!fn(field, rules, i, options))
          return options.allrules[customRule].alertText;
      } else {
        alert("jqv:custom type not allowed " + customRule);
        return;
      }
    },
    /**
     * Validate custom function outside of the engine scope
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return an error string if validation failed
     */
    _funcCall: function(field, rules, i, options) {
      var functionName = rules[i + 1];
      var fn;
      if (functionName.indexOf('.') > -1) {
        var namespaces = functionName.split('.');
        var scope = window;
        while (namespaces.length) {
          scope = scope[namespaces.shift()];
        }
        fn = scope;
      } else
        fn = window[functionName] || options.customFunctions[functionName];
      if (typeof(fn) == 'function')
        return fn(field, rules, i, options);

    },
    /**
     * Field match
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return an error string if validation failed
     */
    _equals: function(field, rules, i, options) {
      var equalsField = rules[i + 1];

      if (field.val() != $("#" + equalsField).val())
        return options.allrules.equals.alertText;
    },
    /**
     * Check the maximum size (in characters)
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return an error string if validation failed
     */
    _maxSize: function(field, rules, i, options) {
      var max = rules[i + 1];
      var len = field.val().length;

      if (len > max) {
        var rule = options.allrules.maxSize;
        return rule.alertText + max + rule.alertText2;
      }
    },
    /**
     * Check the minimum size (in characters)
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return an error string if validation failed
     */
    _minSize: function(field, rules, i, options) {
      var min = rules[i + 1];
      var len = field.val().length;

      if (len < min) {
        var rule = options.allrules.minSize;
        return rule.alertText + min + rule.alertText2;
      }
    },
    /**
     * Check number minimum value
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return an error string if validation failed
     */
    _min: function(field, rules, i, options) {
      var min = parseFloat(rules[i + 1]);
      var len = parseFloat(field.val());

      if (len < min) {
        var rule = options.allrules.min;
        if (rule.alertText2) return rule.alertText + min + rule.alertText2;
        return rule.alertText + min;
      }
    },
    /**
     * Check number maximum value
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return an error string if validation failed
     */
    _max: function(field, rules, i, options) {
      var max = parseFloat(rules[i + 1]);
      var len = parseFloat(field.val());

      if (len > max) {
        var rule = options.allrules.max;
        if (rule.alertText2) return rule.alertText + max + rule.alertText2;
        //orefalo: to review, also do the translations
        return rule.alertText + max;
      }
    },
    /**
     * Checks date is in the past
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return an error string if validation failed
     */
    _past: function(form, field, rules, i, options) {

      var p = rules[i + 1];
      var fieldAlt = $(form.find("input[name='" + p.replace(/^#+/, '') + "']"));
      var pdate;

      if (p.toLowerCase() == "now") {
        pdate = new Date();
      } else if (undefined != fieldAlt.val()) {
        if (fieldAlt.is(":disabled"))
          return;
        pdate = methods._parseDate(fieldAlt.val());
      } else {
        pdate = methods._parseDate(p);
      }
      var vdate = methods._parseDate(field.val());

      if (vdate > pdate) {
        var rule = options.allrules.past;
        if (rule.alertText2) return rule.alertText + methods._dateToString(pdate) + rule.alertText2;
        return rule.alertText + methods._dateToString(pdate);
      }
    },
    /**
     * Checks date is in the future
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return an error string if validation failed
     */
    _future: function(form, field, rules, i, options) {

      var p = rules[i + 1];
      var fieldAlt = $(form.find("input[name='" + p.replace(/^#+/, '') + "']"));
      var pdate;

      if (p.toLowerCase() == "now") {
        pdate = new Date();
      } else if (undefined != fieldAlt.val()) {
        if (fieldAlt.is(":disabled"))
          return;
        pdate = methods._parseDate(fieldAlt.val());
      } else {
        pdate = methods._parseDate(p);
      }
      var vdate = methods._parseDate(field.val());

      if (vdate < pdate) {
        var rule = options.allrules.future;
        if (rule.alertText2)
          return rule.alertText + methods._dateToString(pdate) + rule.alertText2;
        return rule.alertText + methods._dateToString(pdate);
      }
    },
    /**
     * Checks if valid date
     *
     * @param {string} date string
     * @return a bool based on determination of valid date
     */
    _isDate: function(value) {
      var dateRegEx = new RegExp(/^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$|^(?:(?:(?:0?[13578]|1[02])(\/|-)31)|(?:(?:0?[1,3-9]|1[0-2])(\/|-)(?:29|30)))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^(?:(?:0?[1-9]|1[0-2])(\/|-)(?:0?[1-9]|1\d|2[0-8]))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^(0?2(\/|-)29)(\/|-)(?:(?:0[48]00|[13579][26]00|[2468][048]00)|(?:\d\d)?(?:0[48]|[2468][048]|[13579][26]))$/);
      return dateRegEx.test(value);
    },
    /**
     * Checks if valid date time
     *
     * @param {string} date string
     * @return a bool based on determination of valid date time
     */
    _isDateTime: function(value) {
      var dateTimeRegEx = new RegExp(/^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])\s+(1[012]|0?[1-9]){1}:(0?[1-5]|[0-6][0-9]){1}:(0?[0-6]|[0-6][0-9]){1}\s+(am|pm|AM|PM){1}$|^(?:(?:(?:0?[13578]|1[02])(\/|-)31)|(?:(?:0?[1,3-9]|1[0-2])(\/|-)(?:29|30)))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^((1[012]|0?[1-9]){1}\/(0?[1-9]|[12][0-9]|3[01]){1}\/\d{2,4}\s+(1[012]|0?[1-9]){1}:(0?[1-5]|[0-6][0-9]){1}:(0?[0-6]|[0-6][0-9]){1}\s+(am|pm|AM|PM){1})$/);
      return dateTimeRegEx.test(value);
    },
    //Checks if the start date is before the end date
    //returns true if end is later than start
    _dateCompare: function(start, end) {
      return (new Date(start.toString()) < new Date(end.toString()));
    },
    /**
     * Checks date range
     *
     * @param {jqObject} first field name
     * @param {jqObject} second field name
     * @return an error string if validation failed
     */
    _dateRange: function(field, rules, i, options) {
      //are not both populated
      if ((!options.firstOfGroup[0].value && options.secondOfGroup[0].value) || (options.firstOfGroup[0].value && !options.secondOfGroup[0].value)) {
        return options.allrules[rules[i]].alertText + options.allrules[rules[i]].alertText2;
      }

      //are not both dates
      if (!methods._isDate(options.firstOfGroup[0].value) || !methods._isDate(options.secondOfGroup[0].value)) {
        return options.allrules[rules[i]].alertText + options.allrules[rules[i]].alertText2;
      }

      //are both dates but range is off
      if (!methods._dateCompare(options.firstOfGroup[0].value, options.secondOfGroup[0].value)) {
        return options.allrules[rules[i]].alertText + options.allrules[rules[i]].alertText2;
      }
    },
    /**
     * Checks date time range
     *
     * @param {jqObject} first field name
     * @param {jqObject} second field name
     * @return an error string if validation failed
     */
    _dateTimeRange: function(field, rules, i, options) {
      //are not both populated
      if ((!options.firstOfGroup[0].value && options.secondOfGroup[0].value) || (options.firstOfGroup[0].value && !options.secondOfGroup[0].value)) {
        return options.allrules[rules[i]].alertText + options.allrules[rules[i]].alertText2;
      }
      //are not both dates
      if (!methods._isDateTime(options.firstOfGroup[0].value) || !methods._isDateTime(options.secondOfGroup[0].value)) {
        return options.allrules[rules[i]].alertText + options.allrules[rules[i]].alertText2;
      }
      //are both dates but range is off
      if (!methods._dateCompare(options.firstOfGroup[0].value, options.secondOfGroup[0].value)) {
        return options.allrules[rules[i]].alertText + options.allrules[rules[i]].alertText2;
      }
    },
    /**
     * Max number of checkbox selected
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return an error string if validation failed
     */
    _maxCheckbox: function(form, field, rules, i, options) {

      var nbCheck = rules[i + 1];
      var groupname = field.attr("name");
      var groupSize = form.find("input[name='" + groupname + "']:checked").size();
      if (groupSize > nbCheck) {
        options.showArrow = false;
        if (options.allrules.maxCheckbox.alertText2)
          return options.allrules.maxCheckbox.alertText + " " + nbCheck + " " + options.allrules.maxCheckbox.alertText2;
        return options.allrules.maxCheckbox.alertText;
      }
    },
    /**
     * Min number of checkbox selected
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return an error string if validation failed
     */
    _minCheckbox: function(form, field, rules, i, options) {

      var nbCheck = rules[i + 1];
      var groupname = field.attr("name");
      var groupSize = form.find("input[name='" + groupname + "']:checked").size();
      if (groupSize < nbCheck) {
        options.showArrow = false;
        return options.allrules.minCheckbox.alertText + " " + nbCheck + " " + options.allrules.minCheckbox.alertText2;
      }
    },
    /**
     * Checks that it is a valid credit card number according to the
     * Luhn checksum algorithm.
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return an error string if validation failed
     */
    _creditCard: function(field, rules, i, options) {
      //spaces and dashes may be valid characters, but must be stripped to calculate the checksum.
      var valid = false,
        cardNumber = field.val().replace(/ +/g, '').replace(/-+/g, '');

      var numDigits = cardNumber.length;
      if (numDigits >= 14 && numDigits <= 16 && parseInt(cardNumber) > 0) {

        var sum = 0,
          i = numDigits - 1,
          pos = 1,
          digit, luhn = new String();
        do {
          digit = parseInt(cardNumber.charAt(i));
          luhn += (pos++ % 2 == 0) ? digit * 2 : digit;
        } while (--i >= 0)

        for (i = 0; i < luhn.length; i++) {
          sum += parseInt(luhn.charAt(i));
        }
        valid = sum % 10 == 0;
      }
      if (!valid) return options.allrules.creditCard.alertText;
    },
    /**
     * Ajax field validation
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return nothing! the ajax validator handles the prompts itself
     */
    _ajax: function(field, rules, i, options) {

      var errorSelector = rules[i + 1];
      var rule = options.allrules[errorSelector];
      var extraData = rule.extraData;
      var extraDataDynamic = rule.extraDataDynamic;
      var data = {
        "fieldId": field.attr("id"),
        "fieldValue": field.val()
      };

      if (typeof extraData === "object") {
        $.extend(data, extraData);
      } else if (typeof extraData === "string") {
        var tempData = extraData.split("&");
        for (var i = 0; i < tempData.length; i++) {
          var values = tempData[i].split("=");
          if (values[0] && values[0]) {
            data[values[0]] = values[1];
          }
        }
      }

      if (extraDataDynamic) {
        var tmpData = [];
        var domIds = String(extraDataDynamic).split(",");
        for (var i = 0; i < domIds.length; i++) {
          var id = domIds[i];
          if ($(id).length) {
            var inputValue = field.closest("form").find(id).val();
            var keyValue = id.replace('#', '') + '=' + escape(inputValue);
            data[id.replace('#', '')] = inputValue;
          }
        }
      }

      // If a field change event triggered this we want to clear the cache for this ID
      if (options.eventTrigger == "field") {
        delete(options.ajaxValidCache[field.attr("id")]);
      }

      // If there is an error or if the the field is already validated, do not re-execute AJAX
      if (!options.isError && !methods._checkAjaxFieldStatus(field.attr("id"), options)) {
        $.ajax({
          type: options.ajaxFormValidationMethod,
          url: rule.url,
          cache: false,
          dataType: "json",
          data: data,
          field: field,
          rule: rule,
          methods: methods,
          options: options,
          beforeSend: function() {},
          error: function(data, transport) {
            methods._ajaxError(data, transport);
          },
          success: function(json) {

            // asynchronously called on success, data is the json answer from the server
            var errorFieldId = json[0];
            //var errorField = $($("#" + errorFieldId)[0]);
            var errorField = $("#" + errorFieldId + "']").eq(0);

            // make sure we found the element
            if (errorField.length == 1) {
              var status = json[1];
              // read the optional msg from the server
              var msg = json[2];
              if (!status) {
                // Houston we got a problem - display an red prompt
                options.ajaxValidCache[errorFieldId] = false;
                options.isError = true;

                // resolve the msg prompt
                if (msg) {
                  if (options.allrules[msg]) {
                    var txt = options.allrules[msg].alertText;
                    if (txt) {
                      msg = txt;
                    }
                  }
                } else
                  msg = rule.alertText;

                methods._showPrompt(errorField, msg, "", true, options);
              } else {
                options.ajaxValidCache[errorFieldId] = true;

                // resolves the msg prompt
                if (msg) {
                  if (options.allrules[msg]) {
                    var txt = options.allrules[msg].alertTextOk;
                    if (txt) {
                      msg = txt;
                    }
                  }
                } else
                  msg = rule.alertTextOk;

                // see if we should display a green prompt
                if (msg)
                  methods._showPrompt(errorField, msg, "pass", true, options);
                else
                  methods._closePrompt(errorField);

                // If a submit form triggered this, we want to re-submit the form
                if (options.eventTrigger == "submit")
                  field.closest("form").submit();
              }
            }
            errorField.trigger("jqv.field.result", [errorField, options.isError, msg]);
          }
        });

        return rule.alertTextLoad;
      }
    },
    /**
     * Common method to handle ajax errors
     *
     * @param {Object} data
     * @param {Object} transport
     */
    _ajaxError: function(data, transport) {
      if (data.status == 0 && transport == null)
        alert("The page is not served from a server! ajax call failed");
      else if (typeof console != "undefined")
        console.log("Ajax error: " + data.status + " " + transport);
    },
    /**
     * date -> string
     *
     * @param {Object} date
     */
    _dateToString: function(date) {
      return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    },
    /**
     * Parses an ISO date
     * @param {String} d
     */
    _parseDate: function(d) {

      var dateParts = d.split("-");
      if (dateParts == d)
        dateParts = d.split("/");
      return new Date(dateParts[0], (dateParts[1] - 1), dateParts[2]);
    },
    /**
     * Builds or updates a prompt with the given information
     *
     * @param {jqObject} field
     * @param {String} promptText html text to display type
     * @param {String} type the type of bubble: 'pass' (green), 'load' (black) anything else (red)
     * @param {boolean} ajaxed - use to mark fields than being validated with ajax
     * @param {Map} options user options
     */
    _showPrompt: function(field, promptText, type, ajaxed, options, ajaxform) {
      var prompt = methods._getPrompt(field);
      // The ajax submit errors are not see has an error in the form,
      // When the form errors are returned, the engine see 2 bubbles, but those are ebing closed by the engine at the same time
      // Because no error was found befor submitting
      if (ajaxform) prompt = false;
      if (prompt)
        methods._updatePrompt(field, prompt, promptText, type, ajaxed, options);
      else
        methods._buildPrompt(field, promptText, type, ajaxed, options);
    },
    /**
     * Builds and shades a prompt for the given field.
     *
     * @param {jqObject} field
     * @param {String} promptText html text to display type
     * @param {String} type the type of bubble: 'pass' (green), 'load' (black) anything else (red)
     * @param {boolean} ajaxed - use to mark fields than being validated with ajax
     * @param {Map} options user options
     */
    _buildPrompt: function(field, promptText, type, ajaxed, options) {

      // create the prompt
      var prompt = $('<div>');
      prompt.addClass(methods._getClassName(field.attr("id")) + "formError");
      // add a class name to identify the parent form of the prompt
      prompt.addClass("parentForm" + methods._getClassName(field.parents('form').attr("id")));
      prompt.addClass("formError");

      switch (type) {
        case "pass":
          prompt.addClass("greenPopup");
          break;
        case "load":
          prompt.addClass("blackPopup");
          break;
        default:
          /* it has error  */
          //alert("unknown popup type:"+type);
      }
      if (ajaxed)
        prompt.addClass("ajaxed");

      // create the prompt content
      var promptContent = $('<div>').addClass("formErrorContent").html(promptText).appendTo(prompt);
      // create the css arrow pointing at the field
      // note that there is no triangle on max-checkbox and radio
      if (options.showArrow) {
        var arrow = $('<div>').addClass("formErrorArrow");

        //prompt positioning adjustment support. Usage: positionType:Xshift,Yshift (for ex.: bottomLeft:+20 or bottomLeft:-20,+10)
        var positionType = field.data("promptPosition") || options.promptPosition;
        if (typeof(positionType) == 'string') {
          var pos = positionType.indexOf(":");
          if (pos != -1)
            positionType = positionType.substring(0, pos);
        }

        switch (positionType) {
          case "bottomLeft":
          case "bottomRight":
            prompt.find(".formErrorContent").before(arrow);
            arrow.addClass("formErrorArrowBottom").html('<div class="line1"><!-- --></div><div class="line2"><!-- --></div><div class="line3"><!-- --></div><div class="line4"><!-- --></div><div class="line5"><!-- --></div><div class="line6"><!-- --></div><div class="line7"><!-- --></div><div class="line8"><!-- --></div><div class="line9"><!-- --></div><div class="line10"><!-- --></div>');
            break;
          case "topLeft":
          case "topRight":
            arrow.html('<div class="line10"><!-- --></div><div class="line9"><!-- --></div><div class="line8"><!-- --></div><div class="line7"><!-- --></div><div class="line6"><!-- --></div><div class="line5"><!-- --></div><div class="line4"><!-- --></div><div class="line3"><!-- --></div><div class="line2"><!-- --></div><div class="line1"><!-- --></div>');
            prompt.append(arrow);
            break;
        }
      }
      // Modify z-indexes  for jquery ui
      if (field.closest('.ui-dialog').length)
        prompt.addClass('formErrorInsideDialog');

      prompt.css({
        "opacity": 0,
        'position': 'absolute'
      });
      field.before(prompt);

      var pos = methods._calculatePosition(field, prompt, options);
      prompt.css({
        "top": pos.callerTopPosition,
        "left": pos.callerleftPosition,
        "marginTop": pos.marginTopSize,
        "opacity": 0
      }).data("callerField", field);

      if (options.autoHidePrompt) {
        setTimeout(function() {
          prompt.animate({
            "opacity": 0
          }, function() {
            prompt.closest('.formErrorOuter').remove();
            prompt.remove();
          });
        }, options.autoHideDelay);
      }
      return prompt.animate({
        "opacity": 0.87
      });
    },
    /**
     * Updates the prompt text field - the field for which the prompt
     * @param {jqObject} field
     * @param {String} promptText html text to display type
     * @param {String} type the type of bubble: 'pass' (green), 'load' (black) anything else (red)
     * @param {boolean} ajaxed - use to mark fields than being validated with ajax
     * @param {Map} options user options
     */
    _updatePrompt: function(field, prompt, promptText, type, ajaxed, options, noAnimation) {

      if (prompt) {
        if (typeof type !== "undefined") {
          if (type == "pass")
            prompt.addClass("greenPopup");
          else
            prompt.removeClass("greenPopup");

          if (type == "load")
            prompt.addClass("blackPopup");
          else
            prompt.removeClass("blackPopup");
        }
        if (ajaxed)
          prompt.addClass("ajaxed");
        else
          prompt.removeClass("ajaxed");

        prompt.find(".formErrorContent").html(promptText);

        var pos = methods._calculatePosition(field, prompt, options);
        var css = {
          "top": pos.callerTopPosition,
          "left": pos.callerleftPosition,
          "marginTop": pos.marginTopSize
        };

        if (noAnimation)
          prompt.css(css);
        else
          prompt.animate(css);
      }
    },
    /**
     * Closes the prompt associated with the given field
     *
     * @param {jqObject}
     *            field
     */
    _closePrompt: function(field) {
      var prompt = methods._getPrompt(field);
      if (prompt)
        prompt.fadeTo("fast", 0, function() {
          prompt.parent('.formErrorOuter').remove();
          prompt.remove();
        });
    },
    closePrompt: function(field) {
      return methods._closePrompt(field);
    },
    /**
     * Returns the error prompt matching the field if any
     *
     * @param {jqObject}
     *            field
     * @return undefined or the error prompt (jqObject)
     */
    _getPrompt: function(field) {
      var formId = $(field).closest('form').attr('id');
      var className = methods._getClassName(field.attr("id")) + "formError";
      var match = $("." + methods._escapeExpression(className) + '.parentForm' + formId)[0];
      if (match)
        return $(match);
    },
    /**
     * Returns the escapade classname
     *
     * @param {selector}
     *            className
     */
    _escapeExpression: function(selector) {
      return selector.replace(/([#;&,\.\+\*\~':"\!\^$\[\]\(\)=>\|])/g, "\\$1");
    },
    /**
     * returns true if we are in a RTLed document
     *
     * @param {jqObject} field
     */
    isRTL: function(field) {
      var $document = $(document);
      var $body = $('body');
      var rtl =
        (field && field.hasClass('rtl')) ||
        (field && (field.attr('dir') || '').toLowerCase() === 'rtl') ||
        $document.hasClass('rtl') ||
        ($document.attr('dir') || '').toLowerCase() === 'rtl' ||
        $body.hasClass('rtl') ||
        ($body.attr('dir') || '').toLowerCase() === 'rtl';
      return Boolean(rtl);
    },
    /**
     * Calculates prompt position
     *
     * @param {jqObject}
     *            field
     * @param {jqObject}
     *            the prompt
     * @param {Map}
     *            options
     * @return positions
     */
    _calculatePosition: function(field, promptElmt, options) {

      var promptTopPosition, promptleftPosition, marginTopSize;
      var fieldWidth = field.width();
      var fieldLeft = field.position().left;
      var fieldTop = field.position().top;
      var fieldHeight = field.height();
      var promptHeight = promptElmt.height();


      // is the form contained in an overflown container?
      promptTopPosition = promptleftPosition = 0;
      // compensation for the arrow
      marginTopSize = -promptHeight;


      //prompt positioning adjustment support
      //now you can adjust prompt position
      //usage: positionType:Xshift,Yshift
      //for example:
      //   bottomLeft:+20 means bottomLeft position shifted by 20 pixels right horizontally
      //   topRight:20, -15 means topRight position shifted by 20 pixels to right and 15 pixels to top
      //You can use +pixels, - pixels. If no sign is provided than + is default.
      var positionType = field.data("promptPosition") || options.promptPosition;
      var shift1 = "";
      var shift2 = "";
      var shiftX = 0;
      var shiftY = 0;
      if (typeof(positionType) == 'string') {
        //do we have any position adjustments ?
        if (positionType.indexOf(":") != -1) {
          shift1 = positionType.substring(positionType.indexOf(":") + 1);
          positionType = positionType.substring(0, positionType.indexOf(":"));

          //if any advanced positioning will be needed (percents or something else) - parser should be added here
          //for now we use simple parseInt()

          //do we have second parameter?
          if (shift1.indexOf(",") != -1) {
            shift2 = shift1.substring(shift1.indexOf(",") + 1);
            shift1 = shift1.substring(0, shift1.indexOf(","));
            shiftY = parseInt(shift2);
            if (isNaN(shiftY)) shiftY = 0;
          };

          shiftX = parseInt(shift1);
          if (isNaN(shift1)) shift1 = 0;

        };
      };
      // if (fieldTop < 100) {
      //   promptTopPosition = 100;
      // }

      console.log("fieldTop > ", fieldTop);
      console.log("promptTopPosition > ", promptTopPosition);

      switch (positionType) {
        default:
        case "topRight":
          promptleftPosition += fieldLeft + fieldWidth - 30;

          promptTopPosition += fieldTop;



          console.log("promptTopPosition >> ", promptTopPosition);
          break;

        case "topLeft":
          promptTopPosition += fieldTop;
          promptleftPosition += fieldLeft;
          break;

        case "centerRight":
          promptTopPosition = fieldTop + 4;
          marginTopSize = 0;
          promptleftPosition = fieldLeft + field.outerWidth(true) + 5;
          break;
        case "centerLeft":
          promptleftPosition = fieldLeft - (promptElmt.width() + 2);
          promptTopPosition = fieldTop + 4;
          marginTopSize = 0;

          break;

        case "bottomLeft":
          promptTopPosition = fieldTop + field.height() + 5;
          marginTopSize = 0;
          promptleftPosition = fieldLeft;
          break;
        case "bottomRight":
          promptleftPosition = fieldLeft + fieldWidth - 30;
          promptTopPosition = fieldTop + field.height() + 5;
          marginTopSize = 0;
      };


      //apply adjusments if any
      promptleftPosition += shiftX;
      promptTopPosition += shiftY;

      return {
        "callerTopPosition": promptTopPosition + "px",
        "callerleftPosition": promptleftPosition + "px",
        "marginTopSize": marginTopSize + "px"
      };
    },
    /**
     * Saves the user options and variables in the form.data
     *
     * @param {jqObject}
     *            form - the form where the user option should be saved
     * @param {Map}
     *            options - the user options
     * @return the user options (extended from the defaults)
     */
    _saveOptions: function(form, options) {

      // is there a language localisation ?
      if ($.validationEngineLanguage)
        var allRules = $.validationEngineLanguage.allRules;
      else
        $.error("jQuery.validationEngine rules are not loaded, plz add localization files to the page");
      // --- Internals DO NOT TOUCH or OVERLOAD ---
      // validation rules and i18
      $.validationEngine.defaults.allrules = allRules;

      var userOptions = $.extend(true, {}, $.validationEngine.defaults, options);

      form.data('jqv', userOptions);
      return userOptions;
    },

    /**
     * Removes forbidden characters from class name
     * @param {String} className
     */
    _getClassName: function(className) {
      if (className)
        return className.replace(/:/g, "_").replace(/\./g, "_");
    },
    /**
     * Escape special character for jQuery selector
     * http://totaldev.com/content/escaping-characters-get-valid-jquery-id
     * @param {String} selector
     */
    _jqSelector: function(str) {
      return str.replace(/([;&,\.\+\*\~':"\!\^#$%@\[\]\(\)=>\|])/g, '\\$1');
    },
    /**
     * Conditionally required field
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     * user options
     * @return an error string if validation failed
     */
    _condRequired: function(field, rules, i, options) {
      var idx, dependingField;

      for (idx = (i + 1); idx < rules.length; idx++) {
        dependingField = jQuery("#" + rules[idx]).first();

        /* Use _required for determining wether dependingField has a value.
         * There is logic there for handling all field types, and default value; so we won't replicate that here
         */
        if (dependingField.length && methods._required(dependingField, ["required"], 0, options) == undefined) {
          /* We now know any of the depending fields has a value,
           * so we can validate this field as per normal required code
           */
          return methods._required(field, ["required"], 0, options);
        }
      }
    }
  };

  /**
   * Plugin entry point.
   * You may pass an action as a parameter or a list of options.
   * if none, the init and attach methods are being called.
   * Remember: if you pass options, the attached method is NOT called automatically
   *
   * @param {String}
   *            method (optional) action
   */

  $.fn.validateForceFully = function(form) {
    return methods.validate.apply(form);
  }

  $.fn.validationEngine = function(method) {

    var form = $(this);
    if (!form[0]) return form; // stop here if the form does not exist

    if (typeof(method) == 'string' && method.charAt(0) != '_' && methods[method]) {

      // make sure init is called once
      if (method != "showPrompt" && method != "hide" && method != "hideAll")
        methods.init.apply(form);

      return methods[method].apply(form, Array.prototype.slice.call(arguments, 1));
    } else if (typeof method == 'object' || !method) {

      // default constructor with or without arguments
      methods.init.apply(form, arguments);
      return methods.attach.apply(form);
    } else {
      $.error('Method ' + method + ' does not exist in jQuery.validationEngine');
    }
  };



  // LEAK GLOBAL OPTIONS
  $.validationEngine = {
    fieldIdCounter: 0,
    defaults: {

      // Name of the event triggering field validation
      validationEventTrigger: "blur",
      // Automatically scroll viewport to the first error
      scroll: true,
      // Focus on the first input
      focusFirstField: true,
      // Opening box position, possible locations are: topLeft,
      // topRight, bottomLeft, centerRight, bottomRight
      promptPosition: "topRight",
      bindMethod: "bind",
      // internal, automatically set to true when it parse a _ajax rule
      inlineAjax: false,
      // if set to true, the form data is sent asynchronously via ajax to the form.action url (get)
      ajaxFormValidation: false,
      // The url to send the submit ajax validation (default to action)
      ajaxFormValidationURL: false,
      // HTTP method used for ajax validation
      ajaxFormValidationMethod: 'get',
      // Ajax form validation callback method: boolean onComplete(form, status, errors, options)
      // retuns false if the form.submit event needs to be canceled.
      onAjaxFormComplete: $.noop,
      // called right before the ajax call, may return false to cancel
      onBeforeAjaxFormValidation: $.noop,
      // Stops form from submitting and execute function assiciated with it
      onValidationComplete: false,

      // Used when you have a form fields too close and the errors messages are on top of other disturbing viewing messages
      doNotShowAllErrosOnSubmit: false,
      // Object where you store custom messages to override the default error messages
      custom_error_messages: {},
      // true if you want to vind the input fields
      binded: true,
      // set to true, when the prompt arrow needs to be displayed
      showArrow: true,
      // did one of the validation fail ? kept global to stop further ajax validations
      isError: false,
      // Limit how many displayed errors a field can have
      maxErrorsPerField: false,

      // Caches field validation status, typically only bad status are created.
      // the array is used during ajax form validation to detect issues early and prevent an expensive submit
      ajaxValidCache: {},
      // Auto update prompt position after window resize
      autoPositionUpdate: false,

      InvalidFields: [],
      onFieldSuccess: false,
      onFieldFailure: false,
      onFormSuccess: false,
      onFormFailure: false,
      addSuccessCssClassToField: false,
      addFailureCssClassToField: false,

      // Auto-hide prompt
      autoHidePrompt: false,
      // Delay before auto-hide
      autoHideDelay: 10000,
      // Fade out duration while hiding the validations
      fadeDuration: 0.3,
      // Use Prettify select library
      prettySelect: false,
      // Custom ID uses prefix
      usePrefix: "",
      // Custom ID uses suffix
      useSuffix: "",
      // Only show one message per error prompt
      showOneMessage: false
    }
  };
  $(function() { $.validationEngine.defaults.promptPosition = methods.isRTL() ? 'topLeft' : "topRight" });
})(jQuery);

(function($){
    $.fn.validationEngineLanguage = function(){
    };
    $.validationEngineLanguage = {
        newLang: function(){
            $.validationEngineLanguage.allRules = {
                "required": { // Add your regex rules here, you can take telephone as an example
                    "regex": "none",
                    "alertText": "* This field is required",
                    "alertTextCheckboxMultiple": "* Please select an option",
                    "alertTextCheckboxe": "* This checkbox is required",
                    "alertTextDateRange": "* Both date range fields are required"
                },
                "requiredInFunction": { 
                    "func": function(field, rules, i, options){
                        return (field.val() == "test") ? true : false;
                    },
                    "alertText": "* Field must equal test"
                },
                "dateRange": {
                    "regex": "none",
                    "alertText": "* Invalid ",
                    "alertText2": "Date Range"
                },
                "dateTimeRange": {
                    "regex": "none",
                    "alertText": "* Invalid ",
                    "alertText2": "Date Time Range"
                },
                "minSize": {
                    "regex": "none",
                    "alertText": "* Minimum ",
                    "alertText2": " characters allowed"
                },
                "maxSize": {
                    "regex": "none",
                    "alertText": "* Maximum ",
                    "alertText2": " characters allowed"
                },
				"groupRequired": {
                    "regex": "none",
                    "alertText": "* You must fill one of the following fields"
                },
                "min": {
                    "regex": "none",
                    "alertText": "* Minimum value is "
                },
                "max": {
                    "regex": "none",
                    "alertText": "* Maximum value is "
                },
                "past": {
                    "regex": "none",
                    "alertText": "* Date prior to "
                },
                "future": {
                    "regex": "none",
                    "alertText": "* Date past "
                },	
                "maxCheckbox": {
                    "regex": "none",
                    "alertText": "* Maximum ",
                    "alertText2": " options allowed"
                },
                "minCheckbox": {
                    "regex": "none",
                    "alertText": "* Please select ",
                    "alertText2": " options"
                },
                "equals": {
                    "regex": "none",
                    "alertText": "* Fields do not match"
                },
                "creditCard": {
                    "regex": "none",
                    "alertText": "* Invalid credit card number"
                },
                "phone": {
                    // credit: jquery.h5validate.js / orefalo
                    // ^([0-9]{3}\)[0-9]{3}-[0-9]{4}$
                    "regex": /^\([0-9]{3}\)[0-9]{3}-[0-9]{4}$/,
                    // "regex": /^([\+][0-9]{1,3}[\ \.\-])?([\(]{1}[0-9]{2,6}[\)])?([0-9\ \.\-\/]{3,20})((x|ext|extension)[\ ]?[0-9]{1,4})?$/,
                    "alertText": "* Invalid phone number"
                },
                "email": {
                    // HTML5 compatible email regex ( http://www.whatwg.org/specs/web-apps/current-work/multipage/states-of-the-type-attribute.html#    e-mail-state-%28type=email%29 )
                    "regex": /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                    "alertText": "* Invalid email address"
                },
                "integer": {
                    "regex": /^[\-\+]?\d+$/,
                    "alertText": "* Not a valid integer"
                },
                "number": {
                    // Number, including positive, negative, and floating decimal. credit: orefalo
                    "regex": /^[\-\+]?((([0-9]{1,3})([,][0-9]{3})*)|([0-9]+))?([\.]([0-9]+))?$/,
                    "alertText": "* Invalid floating decimal number"
                },
                "date": {                    
                    //	Check if date is valid by leap year
			"func": function (field) {
					var pattern = new RegExp(/^(\d{4})[\/\-\.](0?[1-9]|1[012])[\/\-\.](0?[1-9]|[12][0-9]|3[01])$/);
					var match = pattern.exec(field.val());
					if (match == null)
					   return false;
	
					var year = match[1];
					var month = match[2]*1;
					var day = match[3]*1;					
					var date = new Date(year, month - 1, day); // because months starts from 0.
	
					return (date.getFullYear() == year && date.getMonth() == (month - 1) && date.getDate() == day);
				},                		
			 "alertText": "* Invalid date, must be in YYYY-MM-DD format"
                },
                "ipv4": {
                    "regex": /^((([01]?[0-9]{1,2})|(2[0-4][0-9])|(25[0-5]))[.]){3}(([0-1]?[0-9]{1,2})|(2[0-4][0-9])|(25[0-5]))$/,
                    "alertText": "* Invalid IP address"
                },
                "url": {
                    // "regex": /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i,
                    "regex": /^((https?|ftp):\/\/)?(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i,
                    "alertText": "* Invalid URL"
                },
                "onlyNumberSp": {
                    "regex": /^[0-9\ ]+$/,
                    "alertText": "* Numbers only"
                },
                "onlyLetterSp": {
                    "regex": /^[a-zA-Z\ \']+$/,
                    "alertText": "* Letters only"
                },
                "onlyLetterNumber": {
                    "regex": /^[0-9a-zA-Z]+$/,
                    "alertText": "* No special characters allowed"
                },
                // --- CUSTOM RULES -- Those are specific to the demos, they can be removed or changed to your likings
                "ajaxUserCall": {
                    "url": "ajaxValidateFieldUser",
                    // you may want to pass extra data on the ajax call
                    "extraData": "name=eric",
                    "alertText": "* This user is already taken",
                    "alertTextLoad": "* Validating, please wait"
                },
				"ajaxUserCallPhp": {
                    "url": "phpajax/ajaxValidateFieldUser.php",
                    // you may want to pass extra data on the ajax call
                    "extraData": "name=eric",
                    // if you provide an "alertTextOk", it will show as a green prompt when the field validates
                    "alertTextOk": "* This username is available",
                    "alertText": "* This user is already taken",
                    "alertTextLoad": "* Validating, please wait"
                },
                "ajaxNameCall": {
                    // remote json service location
                    "url": "ajaxValidateFieldName",
                    // error
                    "alertText": "* This name is already taken",
                    // if you provide an "alertTextOk", it will show as a green prompt when the field validates
                    "alertTextOk": "* This name is available",
                    // speaks by itself
                    "alertTextLoad": "* Validating, please wait"
                },
				 "ajaxNameCallPhp": {
	                    // remote json service location
	                    "url": "phpajax/ajaxValidateFieldName.php",
	                    // error
	                    "alertText": "* This name is already taken",
	                    // speaks by itself
	                    "alertTextLoad": "* Validating, please wait"
	                },
                "validate2fields": {
                    "alertText": "* Please input HELLO"
                },
	            //tls warning:homegrown not fielded 
                "dateFormat":{
                    "regex": /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$|^(?:(?:(?:0?[13578]|1[02])(\/|-)31)|(?:(?:0?[1,3-9]|1[0-2])(\/|-)(?:29|30)))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^(?:(?:0?[1-9]|1[0-2])(\/|-)(?:0?[1-9]|1\d|2[0-8]))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^(0?2(\/|-)29)(\/|-)(?:(?:0[48]00|[13579][26]00|[2468][048]00)|(?:\d\d)?(?:0[48]|[2468][048]|[13579][26]))$/,
                    "alertText": "* Invalid Date"
                },
                //tls warning:homegrown not fielded 
				"dateTimeFormat": {
	                "regex": /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])\s+(1[012]|0?[1-9]){1}:(0?[1-5]|[0-6][0-9]){1}:(0?[0-6]|[0-6][0-9]){1}\s+(am|pm|AM|PM){1}$|^(?:(?:(?:0?[13578]|1[02])(\/|-)31)|(?:(?:0?[1,3-9]|1[0-2])(\/|-)(?:29|30)))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^((1[012]|0?[1-9]){1}\/(0?[1-9]|[12][0-9]|3[01]){1}\/\d{2,4}\s+(1[012]|0?[1-9]){1}:(0?[1-5]|[0-6][0-9]){1}:(0?[0-6]|[0-6][0-9]){1}\s+(am|pm|AM|PM){1})$/,
                    "alertText": "* Invalid Date or Date Format",
                    "alertText2": "Expected Format: ",
                    "alertText3": "mm/dd/yyyy hh:mm:ss AM|PM or ", 
                    "alertText4": "yyyy-mm-dd hh:mm:ss AM|PM"
	            }
            };
            
        }
    };

    $.validationEngineLanguage.newLang();
    
})(jQuery);

/*
 * angular-ui-bootstrap
 * http://angular-ui.github.io/bootstrap/

 * Version: 1.2.4 - 2016-03-06
 * License: MIT
 */
angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.collapse", "ui.bootstrap.accordion", "ui.bootstrap.alert", "ui.bootstrap.buttons", "ui.bootstrap.carousel", "ui.bootstrap.dateparser", "ui.bootstrap.isClass", "ui.bootstrap.position", "ui.bootstrap.datepicker", "ui.bootstrap.debounce", "ui.bootstrap.dropdown", "ui.bootstrap.stackedMap", "ui.bootstrap.modal", "ui.bootstrap.paging", "ui.bootstrap.pager", "ui.bootstrap.pagination", "ui.bootstrap.tooltip", "ui.bootstrap.popover", "ui.bootstrap.progressbar", "ui.bootstrap.rating", "ui.bootstrap.tabs", "ui.bootstrap.timepicker", "ui.bootstrap.typeahead"]);
angular.module("ui.bootstrap.tpls", ["uib/template/accordion/accordion-group.html", "uib/template/accordion/accordion.html", "uib/template/alert/alert.html", "uib/template/carousel/carousel.html", "uib/template/carousel/slide.html", "uib/template/datepicker/datepicker.html", "uib/template/datepicker/day.html", "uib/template/datepicker/month.html", "uib/template/datepicker/popup.html", "uib/template/datepicker/year.html", "uib/template/modal/backdrop.html", "uib/template/modal/window.html", "uib/template/pager/pager.html", "uib/template/pagination/pagination.html", "uib/template/tooltip/tooltip-html-popup.html", "uib/template/tooltip/tooltip-popup.html", "uib/template/tooltip/tooltip-template-popup.html", "uib/template/popover/popover-html.html", "uib/template/popover/popover-template.html", "uib/template/popover/popover.html", "uib/template/progressbar/bar.html", "uib/template/progressbar/progress.html", "uib/template/progressbar/progressbar.html", "uib/template/rating/rating.html", "uib/template/tabs/tab.html", "uib/template/tabs/tabset.html", "uib/template/timepicker/timepicker.html", "uib/template/typeahead/typeahead-match.html", "uib/template/typeahead/typeahead-popup.html"]);
angular.module('ui.bootstrap.collapse', [])

  .directive('uibCollapse', ['$animate', '$q', '$parse', '$injector', function ($animate, $q, $parse, $injector) {
    var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
    return {
      link: function (scope, element, attrs) {
        var expandingExpr = $parse(attrs.expanding),
          expandedExpr = $parse(attrs.expanded),
          collapsingExpr = $parse(attrs.collapsing),
          collapsedExpr = $parse(attrs.collapsed);

        if (!scope.$eval(attrs.uibCollapse)) {
          element.addClass('in')
            .addClass('collapse')
            .attr('aria-expanded', true)
            .attr('aria-hidden', false)
            .css({
              height: 'auto'
            });
        }

        function expand() {
          if (element.hasClass('collapse') && element.hasClass('in')) {
            return;
          }

          $q.resolve(expandingExpr(scope))
            .then(function () {
              element.removeClass('collapse')
                .addClass('collapsing')
                .attr('aria-expanded', true)
                .attr('aria-hidden', false);

              if ($animateCss) {
                $animateCss(element, {
                  addClass: 'in',
                  easing: 'ease',
                  to: {
                    height: element[0].scrollHeight + 'px'
                  }
                }).start()['finally'](expandDone);
              } else {
                $animate.addClass(element, 'in', {
                  to: {
                    height: element[0].scrollHeight + 'px'
                  }
                }).then(expandDone);
              }
            });
        }

        function expandDone() {
          element.removeClass('collapsing')
            .addClass('collapse')
            .css({
              height: 'auto'
            });
          expandedExpr(scope);
        }

        function collapse() {
          if (!element.hasClass('collapse') && !element.hasClass('in')) {
            return collapseDone();
          }

          $q.resolve(collapsingExpr(scope))
            .then(function () {
              element
                // IMPORTANT: The height must be set before adding "collapsing" class.
                // Otherwise, the browser attempts to animate from height 0 (in
                // collapsing class) to the given height here.
                .css({
                  height: element[0].scrollHeight + 'px'
                })
                // initially all panel collapse have the collapse class, this removal
                // prevents the animation from jumping to collapsed state
                .removeClass('collapse')
                .addClass('collapsing')
                .attr('aria-expanded', false)
                .attr('aria-hidden', true);

              if ($animateCss) {
                $animateCss(element, {
                  removeClass: 'in',
                  to: {
                    height: '0'
                  }
                }).start()['finally'](collapseDone);
              } else {
                $animate.removeClass(element, 'in', {
                  to: {
                    height: '0'
                  }
                }).then(collapseDone);
              }
            });
        }

        function collapseDone() {
          element.css({
            height: '0'
          }); // Required so that collapse works when animation is disabled
          element.removeClass('collapsing')
            .addClass('collapse');
          collapsedExpr(scope);
        }

        scope.$watch(attrs.uibCollapse, function (shouldCollapse) {
          if (shouldCollapse) {
            collapse();
          } else {
            expand();
          }
        });
      }
    };
  }]);

angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse'])

  .constant('uibAccordionConfig', {
    closeOthers: true
  })

  .controller('UibAccordionController', ['$scope', '$attrs', 'uibAccordionConfig', function ($scope, $attrs, accordionConfig) {
    // This array keeps track of the accordion groups
    this.groups = [];

    // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
    this.closeOthers = function (openGroup) {
      var closeOthers = angular.isDefined($attrs.closeOthers) ?
        $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
      if (closeOthers) {
        angular.forEach(this.groups, function (group) {
          if (group !== openGroup) {
            group.isOpen = false;
          }
        });
      }
    };

    // This is called from the accordion-group directive to add itself to the accordion
    this.addGroup = function (groupScope) {
      var that = this;
      this.groups.push(groupScope);

      groupScope.$on('$destroy', function (event) {
        that.removeGroup(groupScope);
      });
    };

    // This is called from the accordion-group directive when to remove itself
    this.removeGroup = function (group) {
      var index = this.groups.indexOf(group);
      if (index !== -1) {
        this.groups.splice(index, 1);
      }
    };
  }])

  // The accordion directive simply sets up the directive controller
  // and adds an accordion CSS class to itself element.
  .directive('uibAccordion', function () {
    return {
      controller: 'UibAccordionController',
      controllerAs: 'accordion',
      transclude: true,
      templateUrl: function (element, attrs) {
        return attrs.templateUrl || 'uib/template/accordion/accordion.html';
      }
    };
  })

  // The accordion-group directive indicates a block of html that will expand and collapse in an accordion
  .directive('uibAccordionGroup', function () {
    return {
      require: '^uibAccordion', // We need this directive to be inside an accordion
      transclude: true, // It transcludes the contents of the directive into the template
      replace: true, // The element containing the directive will be replaced with the template
      templateUrl: function (element, attrs) {
        return attrs.templateUrl || 'uib/template/accordion/accordion-group.html';
      },
      scope: {
        heading: '@', // Interpolate the heading attribute onto this scope
        isOpen: '=?',
        isDisabled: '=?'
      },
      controller: function () {
        this.setHeading = function (element) {
          this.heading = element;
        };
      },
      link: function (scope, element, attrs, accordionCtrl) {
        accordionCtrl.addGroup(scope);

        scope.openClass = attrs.openClass || 'panel-open';
        scope.panelClass = attrs.panelClass || 'panel-default';
        scope.$watch('isOpen', function (value) {
          element.toggleClass(scope.openClass, !!value);
          if (value) {
            accordionCtrl.closeOthers(scope);
          }
        });

        scope.toggleOpen = function ($event) {
          if (!scope.isDisabled) {
            if (!$event || $event.which === 32) {
              scope.isOpen = !scope.isOpen;
            }
          }
        };

        var id = 'accordiongroup-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
        scope.headingId = id + '-tab';
        scope.panelId = id + '-panel';
      }
    };
  })

  // Use accordion-heading below an accordion-group to provide a heading containing HTML
  .directive('uibAccordionHeading', function () {
    return {
      transclude: true, // Grab the contents to be used as the heading
      template: '', // In effect remove this element!
      replace: true,
      require: '^uibAccordionGroup',
      link: function (scope, element, attrs, accordionGroupCtrl, transclude) {
        // Pass the heading to the accordion-group controller
        // so that it can be transcluded into the right place in the template
        // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
        accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
      }
    };
  })

  // Use in the accordion-group template to indicate where you want the heading to be transcluded
  // You must provide the property on the accordion-group controller that will hold the transcluded element
  .directive('uibAccordionTransclude', function () {
    return {
      require: '^uibAccordionGroup',
      link: function (scope, element, attrs, controller) {
        scope.$watch(function () {
          return controller[attrs.uibAccordionTransclude];
        }, function (heading) {
          if (heading) {
            var elem = angular.element(element[0].querySelector('[uib-accordion-header]'));
            elem.html('');
            elem.append(heading);
          }
        });
      }
    };
  });

angular.module('ui.bootstrap.alert', [])

  .controller('UibAlertController', ['$scope', '$attrs', '$interpolate', '$timeout', function ($scope, $attrs, $interpolate, $timeout) {
    $scope.closeable = !!$attrs.close;

    var dismissOnTimeout = angular.isDefined($attrs.dismissOnTimeout) ?
      $interpolate($attrs.dismissOnTimeout)($scope.$parent) : null;

    if (dismissOnTimeout) {
      $timeout(function () {
        $scope.close();
      }, parseInt(dismissOnTimeout, 10));
    }
  }])

  .directive('uibAlert', function () {
    return {
      controller: 'UibAlertController',
      controllerAs: 'alert',
      templateUrl: function (element, attrs) {
        return attrs.templateUrl || 'uib/template/alert/alert.html';
      },
      transclude: true,
      replace: true,
      scope: {
        type: '@',
        close: '&'
      }
    };
  });

angular.module('ui.bootstrap.buttons', [])

  .constant('uibButtonConfig', {
    activeClass: 'active',
    toggleEvent: 'click'
  })

  .controller('UibButtonsController', ['uibButtonConfig', function (buttonConfig) {
    this.activeClass = buttonConfig.activeClass || 'active';
    this.toggleEvent = buttonConfig.toggleEvent || 'click';
  }])

  .directive('uibBtnRadio', ['$parse', function ($parse) {
    return {
      require: ['uibBtnRadio', 'ngModel'],
      controller: 'UibButtonsController',
      controllerAs: 'buttons',
      link: function (scope, element, attrs, ctrls) {
        var buttonsCtrl = ctrls[0],
          ngModelCtrl = ctrls[1];
        var uncheckableExpr = $parse(attrs.uibUncheckable);

        element.find('input').css({
          display: 'none'
        });

        //model -> UI
        ngModelCtrl.$render = function () {
          element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.uibBtnRadio)));
        };

        //ui->model
        element.on(buttonsCtrl.toggleEvent, function () {
          if (attrs.disabled) {
            return;
          }

          var isActive = element.hasClass(buttonsCtrl.activeClass);

          if (!isActive || angular.isDefined(attrs.uncheckable)) {
            scope.$apply(function () {
              ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.uibBtnRadio));
              ngModelCtrl.$render();
            });
          }
        });

        if (attrs.uibUncheckable) {
          scope.$watch(uncheckableExpr, function (uncheckable) {
            attrs.$set('uncheckable', uncheckable ? '' : undefined);
          });
        }
      }
    };
  }])

  .directive('uibBtnCheckbox', function () {
    return {
      require: ['uibBtnCheckbox', 'ngModel'],
      controller: 'UibButtonsController',
      controllerAs: 'button',
      link: function (scope, element, attrs, ctrls) {
        var buttonsCtrl = ctrls[0],
          ngModelCtrl = ctrls[1];

        element.find('input').css({
          display: 'none'
        });

        function getTrueValue() {
          return getCheckboxValue(attrs.btnCheckboxTrue, true);
        }

        function getFalseValue() {
          return getCheckboxValue(attrs.btnCheckboxFalse, false);
        }

        function getCheckboxValue(attribute, defaultValue) {
          return angular.isDefined(attribute) ? scope.$eval(attribute) : defaultValue;
        }

        //model -> UI
        ngModelCtrl.$render = function () {
          element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
        };

        //ui->model
        element.on(buttonsCtrl.toggleEvent, function () {
          if (attrs.disabled) {
            return;
          }

          scope.$apply(function () {
            ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
            ngModelCtrl.$render();
          });
        });
      }
    };
  });

angular.module('ui.bootstrap.carousel', [])

  .controller('UibCarouselController', ['$scope', '$element', '$interval', '$timeout', '$animate', function ($scope, $element, $interval, $timeout, $animate) {
    var self = this,
      slides = self.slides = $scope.slides = [],
      SLIDE_DIRECTION = 'uib-slideDirection',
      currentIndex = $scope.active,
      currentInterval, isPlaying, bufferedTransitions = [];

    var destroyed = false;

    self.addSlide = function (slide, element) {
      slides.push({
        slide: slide,
        element: element
      });
      slides.sort(function (a, b) {
        return +a.slide.index > +b.slide.index;
      });
      //if this is the first slide or the slide is set to active, select it
      if (slide.index === $scope.active || slides.length === 1 && !angular.isNumber($scope.active)) {
        if ($scope.$currentTransition) {
          $scope.$currentTransition = null;
        }

        currentIndex = slide.index;
        $scope.active = slide.index;
        setActive(currentIndex);
        self.select(slides[findSlideIndex(slide)]);
        if (slides.length === 1) {
          $scope.play();
        }
      }
    };

    self.getCurrentIndex = function () {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].slide.index === currentIndex) {
          return i;
        }
      }
    };

    self.next = $scope.next = function () {
      var newIndex = (self.getCurrentIndex() + 1) % slides.length;

      if (newIndex === 0 && $scope.noWrap()) {
        $scope.pause();
        return;
      }

      return self.select(slides[newIndex], 'next');
    };

    self.prev = $scope.prev = function () {
      var newIndex = self.getCurrentIndex() - 1 < 0 ? slides.length - 1 : self.getCurrentIndex() - 1;

      if ($scope.noWrap() && newIndex === slides.length - 1) {
        $scope.pause();
        return;
      }

      return self.select(slides[newIndex], 'prev');
    };

    self.removeSlide = function (slide) {
      var index = findSlideIndex(slide);

      var bufferedIndex = bufferedTransitions.indexOf(slides[index]);
      if (bufferedIndex !== -1) {
        bufferedTransitions.splice(bufferedIndex, 1);
      }

      //get the index of the slide inside the carousel
      slides.splice(index, 1);
      if (slides.length > 0 && currentIndex === index) {
        if (index >= slides.length) {
          currentIndex = slides.length - 1;
          $scope.active = currentIndex;
          setActive(currentIndex);
          self.select(slides[slides.length - 1]);
        } else {
          currentIndex = index;
          $scope.active = currentIndex;
          setActive(currentIndex);
          self.select(slides[index]);
        }
      } else if (currentIndex > index) {
        currentIndex--;
        $scope.active = currentIndex;
      }

      //clean the active value when no more slide
      if (slides.length === 0) {
        currentIndex = null;
        $scope.active = null;
        clearBufferedTransitions();
      }
    };

    /* direction: "prev" or "next" */
    self.select = $scope.select = function (nextSlide, direction) {
      var nextIndex = findSlideIndex(nextSlide.slide);
      //Decide direction if it's not given
      if (direction === undefined) {
        direction = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
      }
      //Prevent this user-triggered transition from occurring if there is already one in progress
      if (nextSlide.slide.index !== currentIndex &&
        !$scope.$currentTransition) {
        goNext(nextSlide.slide, nextIndex, direction);
      } else if (nextSlide && nextSlide.slide.index !== currentIndex && $scope.$currentTransition) {
        bufferedTransitions.push(slides[nextIndex]);
      }
    };

    /* Allow outside people to call indexOf on slides array */
    $scope.indexOfSlide = function (slide) {
      return +slide.slide.index;
    };

    $scope.isActive = function (slide) {
      return $scope.active === slide.slide.index;
    };

    $scope.pause = function () {
      if (!$scope.noPause) {
        isPlaying = false;
        resetTimer();
      }
    };

    $scope.play = function () {
      if (!isPlaying) {
        isPlaying = true;
        restartTimer();
      }
    };

    $scope.$on('$destroy', function () {
      destroyed = true;
      resetTimer();
    });

    $scope.$watch('noTransition', function (noTransition) {
      $animate.enabled($element, !noTransition);
    });

    $scope.$watch('interval', restartTimer);

    $scope.$watchCollection('slides', resetTransition);

    $scope.$watch('active', function (index) {
      if (angular.isNumber(index) && currentIndex !== index) {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].slide.index === index) {
            index = i;
            break;
          }
        }

        var slide = slides[index];
        if (slide) {
          currentIndex = index;
          setActive(index);
          self.select(slides[index]);
        }
      }
    });

    function clearBufferedTransitions() {
      while (bufferedTransitions.length) {
        bufferedTransitions.shift();
      }
    }

    function getSlideByIndex(index) {
      for (var i = 0, l = slides.length; i < l; ++i) {
        if (slides[i].index === index) {
          return slides[i];
        }
      }
    }

    function setActive(index) {
      for (var i = 0; i < slides.length; i++) {
        slides[i].slide.active = i === index;
      }
    }

    function goNext(slide, index, direction) {
      if (destroyed) {
        return;
      }

      angular.extend(slide, {
        direction: direction
      });
      angular.extend(slides[currentIndex].slide || {}, {
        direction: direction
      });
      if ($animate.enabled($element) && !$scope.$currentTransition &&
        slides[index].element && self.slides.length > 1) {
        slides[index].element.data(SLIDE_DIRECTION, slide.direction);
        var currentIdx = self.getCurrentIndex();

        if (angular.isNumber(currentIdx) && slides[currentIdx].element) {
          slides[currentIdx].element.data(SLIDE_DIRECTION, slide.direction);
        }

        $scope.$currentTransition = true;
        $animate.on('addClass', slides[index].element, function (element, phase) {
          if (phase === 'close') {
            $scope.$currentTransition = null;
            $animate.off('addClass', element);
            if (bufferedTransitions.length) {
              var nextSlide = bufferedTransitions.pop().slide;
              var nextIndex = nextSlide.index;
              var nextDirection = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
              clearBufferedTransitions();

              goNext(nextSlide, nextIndex, nextDirection);
            }
          }
        });
      }

      $scope.active = slide.index;
      currentIndex = slide.index;
      setActive(index);

      //every time you change slides, reset the timer
      restartTimer();
    }

    function findSlideIndex(slide) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].slide === slide) {
          return i;
        }
      }
    }

    function resetTimer() {
      if (currentInterval) {
        $interval.cancel(currentInterval);
        currentInterval = null;
      }
    }

    function resetTransition(slides) {
      if (!slides.length) {
        $scope.$currentTransition = null;
        clearBufferedTransitions();
      }
    }

    function restartTimer() {
      resetTimer();
      var interval = +$scope.interval;
      if (!isNaN(interval) && interval > 0) {
        currentInterval = $interval(timerFn, interval);
      }
    }

    function timerFn() {
      var interval = +$scope.interval;
      if (isPlaying && !isNaN(interval) && interval > 0 && slides.length) {
        $scope.next();
      } else {
        $scope.pause();
      }
    }
  }])

  .directive('uibCarousel', function () {
    return {
      transclude: true,
      replace: true,
      controller: 'UibCarouselController',
      controllerAs: 'carousel',
      templateUrl: function (element, attrs) {
        return attrs.templateUrl || 'uib/template/carousel/carousel.html';
      },
      scope: {
        active: '=',
        interval: '=',
        noTransition: '=',
        noPause: '=',
        noWrap: '&'
      }
    };
  })

  .directive('uibSlide', function () {
    return {
      require: '^uibCarousel',
      transclude: true,
      replace: true,
      templateUrl: function (element, attrs) {
        return attrs.templateUrl || 'uib/template/carousel/slide.html';
      },
      scope: {
        actual: '=?',
        index: '=?'
      },
      link: function (scope, element, attrs, carouselCtrl) {
        carouselCtrl.addSlide(scope, element);
        //when the scope is destroyed then remove the slide from the current slides array
        scope.$on('$destroy', function () {
          carouselCtrl.removeSlide(scope);
        });
      }
    };
  })

  .animation('.item', ['$animateCss',
    function ($animateCss) {
      var SLIDE_DIRECTION = 'uib-slideDirection';

      function removeClass(element, className, callback) {
        element.removeClass(className);
        if (callback) {
          callback();
        }
      }

      return {
        beforeAddClass: function (element, className, done) {
          if (className === 'active') {
            var stopped = false;
            var direction = element.data(SLIDE_DIRECTION);
            var directionClass = direction === 'next' ? 'left' : 'right';
            var removeClassFn = removeClass.bind(this, element,
              directionClass + ' ' + direction, done);
            element.addClass(direction);

            $animateCss(element, {
                addClass: directionClass
              })
              .start()
              .done(removeClassFn);

            return function () {
              stopped = true;
            };
          }
          done();
        },
        beforeRemoveClass: function (element, className, done) {
          if (className === 'active') {
            var stopped = false;
            var direction = element.data(SLIDE_DIRECTION);
            var directionClass = direction === 'next' ? 'left' : 'right';
            var removeClassFn = removeClass.bind(this, element, directionClass, done);

            $animateCss(element, {
                addClass: directionClass
              })
              .start()
              .done(removeClassFn);

            return function () {
              stopped = true;
            };
          }
          done();
        }
      };
    }
  ]);

angular.module('ui.bootstrap.dateparser', [])

  .service('uibDateParser', ['$log', '$locale', 'dateFilter', 'orderByFilter', function ($log, $locale, dateFilter, orderByFilter) {
    // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
    var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

    var localeId;
    var formatCodeToRegex;

    this.init = function () {
      localeId = $locale.id;

      this.parsers = {};
      this.formatters = {};

      formatCodeToRegex = [{
          key: 'yyyy',
          regex: '\\d{4}',
          apply: function (value) {
            this.year = +value;
          },
          formatter: function (date) {
            var _date = new Date();
            _date.setFullYear(Math.abs(date.getFullYear()));
            return dateFilter(_date, 'yyyy');
          }
        },
        {
          key: 'yy',
          regex: '\\d{2}',
          apply: function (value) {
            this.year = +value + 2000;
          },
          formatter: function (date) {
            var _date = new Date();
            _date.setFullYear(Math.abs(date.getFullYear()));
            return dateFilter(_date, 'yy');
          }
        },
        {
          key: 'y',
          regex: '\\d{1,4}',
          apply: function (value) {
            this.year = +value;
          },
          formatter: function (date) {
            var _date = new Date();
            _date.setFullYear(Math.abs(date.getFullYear()));
            return dateFilter(_date, 'y');
          }
        },
        {
          key: 'M!',
          regex: '0?[1-9]|1[0-2]',
          apply: function (value) {
            this.month = value - 1;
          },
          formatter: function (date) {
            var value = date.getMonth();
            if (/^[0-9]$/.test(value)) {
              return dateFilter(date, 'MM');
            }

            return dateFilter(date, 'M');
          }
        },
        {
          key: 'MMMM',
          regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
          apply: function (value) {
            this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value);
          },
          formatter: function (date) {
            return dateFilter(date, 'MMMM');
          }
        },
        {
          key: 'MMM',
          regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
          apply: function (value) {
            this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value);
          },
          formatter: function (date) {
            return dateFilter(date, 'MMM');
          }
        },
        {
          key: 'MM',
          regex: '0[1-9]|1[0-2]',
          apply: function (value) {
            this.month = value - 1;
          },
          formatter: function (date) {
            return dateFilter(date, 'MM');
          }
        },
        {
          key: 'M',
          regex: '[1-9]|1[0-2]',
          apply: function (value) {
            this.month = value - 1;
          },
          formatter: function (date) {
            return dateFilter(date, 'M');
          }
        },
        {
          key: 'd!',
          regex: '[0-2]?[0-9]{1}|3[0-1]{1}',
          apply: function (value) {
            this.date = +value;
          },
          formatter: function (date) {
            var value = date.getDate();
            if (/^[1-9]$/.test(value)) {
              return dateFilter(date, 'dd');
            }

            return dateFilter(date, 'd');
          }
        },
        {
          key: 'dd',
          regex: '[0-2][0-9]{1}|3[0-1]{1}',
          apply: function (value) {
            this.date = +value;
          },
          formatter: function (date) {
            return dateFilter(date, 'dd');
          }
        },
        {
          key: 'd',
          regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
          apply: function (value) {
            this.date = +value;
          },
          formatter: function (date) {
            return dateFilter(date, 'd');
          }
        },
        {
          key: 'EEEE',
          regex: $locale.DATETIME_FORMATS.DAY.join('|'),
          formatter: function (date) {
            return dateFilter(date, 'EEEE');
          }
        },
        {
          key: 'EEE',
          regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|'),
          formatter: function (date) {
            return dateFilter(date, 'EEE');
          }
        },
        {
          key: 'HH',
          regex: '(?:0|1)[0-9]|2[0-3]',
          apply: function (value) {
            this.hours = +value;
          },
          formatter: function (date) {
            return dateFilter(date, 'HH');
          }
        },
        {
          key: 'hh',
          regex: '0[0-9]|1[0-2]',
          apply: function (value) {
            this.hours = +value;
          },
          formatter: function (date) {
            return dateFilter(date, 'hh');
          }
        },
        {
          key: 'H',
          regex: '1?[0-9]|2[0-3]',
          apply: function (value) {
            this.hours = +value;
          },
          formatter: function (date) {
            return dateFilter(date, 'H');
          }
        },
        {
          key: 'h',
          regex: '[0-9]|1[0-2]',
          apply: function (value) {
            this.hours = +value;
          },
          formatter: function (date) {
            return dateFilter(date, 'h');
          }
        },
        {
          key: 'mm',
          regex: '[0-5][0-9]',
          apply: function (value) {
            this.minutes = +value;
          },
          formatter: function (date) {
            return dateFilter(date, 'mm');
          }
        },
        {
          key: 'm',
          regex: '[0-9]|[1-5][0-9]',
          apply: function (value) {
            this.minutes = +value;
          },
          formatter: function (date) {
            return dateFilter(date, 'm');
          }
        },
        {
          key: 'sss',
          regex: '[0-9][0-9][0-9]',
          apply: function (value) {
            this.milliseconds = +value;
          },
          formatter: function (date) {
            return dateFilter(date, 'sss');
          }
        },
        {
          key: 'ss',
          regex: '[0-5][0-9]',
          apply: function (value) {
            this.seconds = +value;
          },
          formatter: function (date) {
            return dateFilter(date, 'ss');
          }
        },
        {
          key: 's',
          regex: '[0-9]|[1-5][0-9]',
          apply: function (value) {
            this.seconds = +value;
          },
          formatter: function (date) {
            return dateFilter(date, 's');
          }
        },
        {
          key: 'a',
          regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
          apply: function (value) {
            if (this.hours === 12) {
              this.hours = 0;
            }

            if (value === 'PM') {
              this.hours += 12;
            }
          },
          formatter: function (date) {
            return dateFilter(date, 'a');
          }
        },
        {
          key: 'Z',
          regex: '[+-]\\d{4}',
          apply: function (value) {
            var matches = value.match(/([+-])(\d{2})(\d{2})/),
              sign = matches[1],
              hours = matches[2],
              minutes = matches[3];
            this.hours += toInt(sign + hours);
            this.minutes += toInt(sign + minutes);
          },
          formatter: function (date) {
            return dateFilter(date, 'Z');
          }
        },
        {
          key: 'ww',
          regex: '[0-4][0-9]|5[0-3]',
          formatter: function (date) {
            return dateFilter(date, 'ww');
          }
        },
        {
          key: 'w',
          regex: '[0-9]|[1-4][0-9]|5[0-3]',
          formatter: function (date) {
            return dateFilter(date, 'w');
          }
        },
        {
          key: 'GGGG',
          regex: $locale.DATETIME_FORMATS.ERANAMES.join('|').replace(/\s/g, '\\s'),
          formatter: function (date) {
            return dateFilter(date, 'GGGG');
          }
        },
        {
          key: 'GGG',
          regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
          formatter: function (date) {
            return dateFilter(date, 'GGG');
          }
        },
        {
          key: 'GG',
          regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
          formatter: function (date) {
            return dateFilter(date, 'GG');
          }
        },
        {
          key: 'G',
          regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
          formatter: function (date) {
            return dateFilter(date, 'G');
          }
        }
      ];
    };

    this.init();

    function createParser(format, func) {
      var map = [],
        regex = format.split('');

      // check for literal values
      var quoteIndex = format.indexOf('\'');
      if (quoteIndex > -1) {
        var inLiteral = false;
        format = format.split('');
        for (var i = quoteIndex; i < format.length; i++) {
          if (inLiteral) {
            if (format[i] === '\'') {
              if (i + 1 < format.length && format[i + 1] === '\'') { // escaped single quote
                format[i + 1] = '$';
                regex[i + 1] = '';
              } else { // end of literal
                regex[i] = '';
                inLiteral = false;
              }
            }
            format[i] = '$';
          } else {
            if (format[i] === '\'') { // start of literal
              format[i] = '$';
              regex[i] = '';
              inLiteral = true;
            }
          }
        }

        format = format.join('');
      }

      angular.forEach(formatCodeToRegex, function (data) {
        var index = format.indexOf(data.key);

        if (index > -1) {
          format = format.split('');

          regex[index] = '(' + data.regex + ')';
          format[index] = '$'; // Custom symbol to define consumed part of format
          for (var i = index + 1, n = index + data.key.length; i < n; i++) {
            regex[i] = '';
            format[i] = '$';
          }
          format = format.join('');

          map.push({
            index: index,
            key: data.key,
            apply: data[func],
            matcher: data.regex
          });
        }
      });

      return {
        regex: new RegExp('^' + regex.join('') + '$'),
        map: orderByFilter(map, 'index')
      };
    }

    this.filter = function (date, format) {
      if (!angular.isDate(date) || isNaN(date) || !format) {
        return '';
      }

      format = $locale.DATETIME_FORMATS[format] || format;

      if ($locale.id !== localeId) {
        this.init();
      }

      if (!this.formatters[format]) {
        this.formatters[format] = createParser(format, 'formatter');
      }

      var parser = this.formatters[format],
        map = parser.map;

      var _format = format;

      return map.reduce(function (str, mapper, i) {
        var match = _format.match(new RegExp('(.*)' + mapper.key));
        if (match && angular.isString(match[1])) {
          str += match[1];
          _format = _format.replace(match[1] + mapper.key, '');
        }

        var endStr = i === map.length - 1 ? _format : '';

        if (mapper.apply) {
          return str + mapper.apply.call(null, date) + endStr;
        }

        return str + endStr;
      }, '');
    };

    this.parse = function (input, format, baseDate) {
      if (!angular.isString(input) || !format) {
        return input;
      }

      format = $locale.DATETIME_FORMATS[format] || format;
      format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');

      if ($locale.id !== localeId) {
        this.init();
      }

      if (!this.parsers[format]) {
        this.parsers[format] = createParser(format, 'apply');
      }

      var parser = this.parsers[format],
        regex = parser.regex,
        map = parser.map,
        results = input.match(regex),
        tzOffset = false;
      if (results && results.length) {
        var fields, dt;
        if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
          fields = {
            year: baseDate.getFullYear(),
            month: baseDate.getMonth(),
            date: baseDate.getDate(),
            hours: baseDate.getHours(),
            minutes: baseDate.getMinutes(),
            seconds: baseDate.getSeconds(),
            milliseconds: baseDate.getMilliseconds()
          };
        } else {
          if (baseDate) {
            $log.warn('dateparser:', 'baseDate is not a valid date');
          }
          fields = {
            year: 1900,
            month: 0,
            date: 1,
            hours: 0,
            minutes: 0,
            seconds: 0,
            milliseconds: 0
          };
        }

        for (var i = 1, n = results.length; i < n; i++) {
          var mapper = map[i - 1];
          if (mapper.matcher === 'Z') {
            tzOffset = true;
          }

          if (mapper.apply) {
            mapper.apply.call(fields, results[i]);
          }
        }

        var datesetter = tzOffset ? Date.prototype.setUTCFullYear :
          Date.prototype.setFullYear;
        var timesetter = tzOffset ? Date.prototype.setUTCHours :
          Date.prototype.setHours;

        if (isValid(fields.year, fields.month, fields.date)) {
          if (angular.isDate(baseDate) && !isNaN(baseDate.getTime()) && !tzOffset) {
            dt = new Date(baseDate);
            datesetter.call(dt, fields.year, fields.month, fields.date);
            timesetter.call(dt, fields.hours, fields.minutes,
              fields.seconds, fields.milliseconds);
          } else {
            dt = new Date(0);
            datesetter.call(dt, fields.year, fields.month, fields.date);
            timesetter.call(dt, fields.hours || 0, fields.minutes || 0,
              fields.seconds || 0, fields.milliseconds || 0);
          }
        }

        return dt;
      }
    };

    // Check if date is valid for specific month (and year for February).
    // Month: 0 = Jan, 1 = Feb, etc
    function isValid(year, month, date) {
      if (date < 1) {
        return false;
      }

      if (month === 1 && date > 28) {
        return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);
      }

      if (month === 3 || month === 5 || month === 8 || month === 10) {
        return date < 31;
      }

      return true;
    }

    function toInt(str) {
      return parseInt(str, 10);
    }

    this.toTimezone = toTimezone;
    this.fromTimezone = fromTimezone;
    this.timezoneToOffset = timezoneToOffset;
    this.addDateMinutes = addDateMinutes;
    this.convertTimezoneToLocal = convertTimezoneToLocal;

    function toTimezone(date, timezone) {
      return date && timezone ? convertTimezoneToLocal(date, timezone) : date;
    }

    function fromTimezone(date, timezone) {
      return date && timezone ? convertTimezoneToLocal(date, timezone, true) : date;
    }

    //https://github.com/angular/angular.js/blob/4daafd3dbe6a80d578f5a31df1bb99c77559543e/src/Angular.js#L1207
    function timezoneToOffset(timezone, fallback) {
      var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
      return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
    }

    function addDateMinutes(date, minutes) {
      date = new Date(date.getTime());
      date.setMinutes(date.getMinutes() + minutes);
      return date;
    }

    function convertTimezoneToLocal(date, timezone, reverse) {
      reverse = reverse ? -1 : 1;
      var timezoneOffset = timezoneToOffset(timezone, date.getTimezoneOffset());
      return addDateMinutes(date, reverse * (timezoneOffset - date.getTimezoneOffset()));
    }
  }]);

// Avoiding use of ng-class as it creates a lot of watchers when a class is to be applied to
// at most one element.
angular.module('ui.bootstrap.isClass', [])
  .directive('uibIsClass', [
    '$animate',
    function ($animate) {
      //                    11111111          22222222
      var ON_REGEXP = /^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/;
      //                    11111111           22222222
      var IS_REGEXP = /^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;

      var dataPerTracked = {};

      return {
        restrict: 'A',
        compile: function (tElement, tAttrs) {
          var linkedScopes = [];
          var instances = [];
          var expToData = {};
          var lastActivated = null;
          var onExpMatches = tAttrs.uibIsClass.match(ON_REGEXP);
          var onExp = onExpMatches[2];
          var expsStr = onExpMatches[1];
          var exps = expsStr.split(',');

          return linkFn;

          function linkFn(scope, element, attrs) {
            linkedScopes.push(scope);
            instances.push({
              scope: scope,
              element: element
            });

            exps.forEach(function (exp, k) {
              addForExp(exp, scope);
            });

            scope.$on('$destroy', removeScope);
          }

          function addForExp(exp, scope) {
            var matches = exp.match(IS_REGEXP);
            var clazz = scope.$eval(matches[1]);
            var compareWithExp = matches[2];
            var data = expToData[exp];
            if (!data) {
              var watchFn = function (compareWithVal) {
                var newActivated = null;
                instances.some(function (instance) {
                  var thisVal = instance.scope.$eval(onExp);
                  if (thisVal === compareWithVal) {
                    newActivated = instance;
                    return true;
                  }
                });
                if (data.lastActivated !== newActivated) {
                  if (data.lastActivated) {
                    $animate.removeClass(data.lastActivated.element, clazz);
                  }
                  if (newActivated) {
                    $animate.addClass(newActivated.element, clazz);
                  }
                  data.lastActivated = newActivated;
                }
              };
              expToData[exp] = data = {
                lastActivated: null,
                scope: scope,
                watchFn: watchFn,
                compareWithExp: compareWithExp,
                watcher: scope.$watch(compareWithExp, watchFn)
              };
            }
            data.watchFn(scope.$eval(compareWithExp));
          }

          function removeScope(e) {
            var removedScope = e.targetScope;
            var index = linkedScopes.indexOf(removedScope);
            linkedScopes.splice(index, 1);
            instances.splice(index, 1);
            if (linkedScopes.length) {
              var newWatchScope = linkedScopes[0];
              angular.forEach(expToData, function (data) {
                if (data.scope === removedScope) {
                  data.watcher = newWatchScope.$watch(data.compareWithExp, data.watchFn);
                  data.scope = newWatchScope;
                }
              });
            } else {
              expToData = {};
            }
          }
        }
      };
    }
  ]);
angular.module('ui.bootstrap.position', [])

  /**
   * A set of utility methods for working with the DOM.
   * It is meant to be used where we need to absolute-position elements in
   * relation to another element (this is the case for tooltips, popovers,
   * typeahead suggestions etc.).
   */
  .factory('$uibPosition', ['$document', '$window', function ($document, $window) {
    /**
     * Used by scrollbarWidth() function to cache scrollbar's width.
     * Do not access this variable directly, use scrollbarWidth() instead.
     */
    var SCROLLBAR_WIDTH;
    var OVERFLOW_REGEX = {
      normal: /(auto|scroll)/,
      hidden: /(auto|scroll|hidden)/
    };
    var PLACEMENT_REGEX = {
      auto: /\s?auto?\s?/i,
      primary: /^(top|bottom|left|right)$/,
      secondary: /^(top|bottom|left|right|center)$/,
      vertical: /^(top|bottom)$/
    };

    return {

      /**
       * Provides a raw DOM element from a jQuery/jQLite element.
       *
       * @param {element} elem - The element to convert.
       *
       * @returns {element} A HTML element.
       */
      getRawNode: function (elem) {
        return elem.nodeName ? elem : elem[0] || elem;
      },

      /**
       * Provides a parsed number for a style property.  Strips
       * units and casts invalid numbers to 0.
       *
       * @param {string} value - The style value to parse.
       *
       * @returns {number} A valid number.
       */
      parseStyle: function (value) {
        value = parseFloat(value);
        return isFinite(value) ? value : 0;
      },

      /**
       * Provides the closest positioned ancestor.
       *
       * @param {element} element - The element to get the offest parent for.
       *
       * @returns {element} The closest positioned ancestor.
       */
      offsetParent: function (elem) {
        elem = this.getRawNode(elem);

        var offsetParent = elem.offsetParent || $document[0].documentElement;

        function isStaticPositioned(el) {
          return ($window.getComputedStyle(el).position || 'static') === 'static';
        }

        while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
          offsetParent = offsetParent.offsetParent;
        }

        return offsetParent || $document[0].documentElement;
      },

      /**
       * Provides the scrollbar width, concept from TWBS measureScrollbar()
       * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
       *
       * @returns {number} The width of the browser scollbar.
       */
      scrollbarWidth: function () {
        if (angular.isUndefined(SCROLLBAR_WIDTH)) {
          var scrollElem = angular.element('<div class="uib-position-scrollbar-measure"></div>');
          $document.find('body').append(scrollElem);
          SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
          SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
          scrollElem.remove();
        }

        return SCROLLBAR_WIDTH;
      },

      /**
       * Checks to see if the element is scrollable.
       *
       * @param {element} elem - The element to check.
       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
       *   default is false.
       *
       * @returns {boolean} Whether the element is scrollable.
       */
      isScrollable: function (elem, includeHidden) {
        elem = this.getRawNode(elem);

        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
        var elemStyle = $window.getComputedStyle(elem);
        return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);
      },

      /**
       * Provides the closest scrollable ancestor.
       * A port of the jQuery UI scrollParent method:
       * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
       *
       * @param {element} elem - The element to find the scroll parent of.
       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
       *   default is false.
       *
       * @returns {element} A HTML element.
       */
      scrollParent: function (elem, includeHidden) {
        elem = this.getRawNode(elem);

        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
        var documentEl = $document[0].documentElement;
        var elemStyle = $window.getComputedStyle(elem);
        var excludeStatic = elemStyle.position === 'absolute';
        var scrollParent = elem.parentElement || documentEl;

        if (scrollParent === documentEl || elemStyle.position === 'fixed') {
          return documentEl;
        }

        while (scrollParent.parentElement && scrollParent !== documentEl) {
          var spStyle = $window.getComputedStyle(scrollParent);
          if (excludeStatic && spStyle.position !== 'static') {
            excludeStatic = false;
          }

          if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
            break;
          }
          scrollParent = scrollParent.parentElement;
        }

        return scrollParent;
      },

      /**
       * Provides read-only equivalent of jQuery's position function:
       * http://api.jquery.com/position/ - distance to closest positioned
       * ancestor.  Does not account for margins by default like jQuery position.
       *
       * @param {element} elem - The element to caclulate the position on.
       * @param {boolean=} [includeMargins=false] - Should margins be accounted
       * for, default is false.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**width**: the width of the element</li>
       *     <li>**height**: the height of the element</li>
       *     <li>**top**: distance to top edge of offset parent</li>
       *     <li>**left**: distance to left edge of offset parent</li>
       *   </ul>
       */
      position: function (elem, includeMagins) {
        elem = this.getRawNode(elem);

        var elemOffset = this.offset(elem);
        if (includeMagins) {
          var elemStyle = $window.getComputedStyle(elem);
          elemOffset.top -= this.parseStyle(elemStyle.marginTop);
          elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
        }
        var parent = this.offsetParent(elem);
        var parentOffset = {
          top: 0,
          left: 0
        };

        if (parent !== $document[0].documentElement) {
          parentOffset = this.offset(parent);
          parentOffset.top += parent.clientTop - parent.scrollTop;
          parentOffset.left += parent.clientLeft - parent.scrollLeft;
        }

        return {
          width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
          height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
          top: Math.round(elemOffset.top - parentOffset.top),
          left: Math.round(elemOffset.left - parentOffset.left)
        };
      },

      /**
       * Provides read-only equivalent of jQuery's offset function:
       * http://api.jquery.com/offset/ - distance to viewport.  Does
       * not account for borders, margins, or padding on the body
       * element.
       *
       * @param {element} elem - The element to calculate the offset on.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**width**: the width of the element</li>
       *     <li>**height**: the height of the element</li>
       *     <li>**top**: distance to top edge of viewport</li>
       *     <li>**right**: distance to bottom edge of viewport</li>
       *   </ul>
       */
      offset: function (elem) {
        elem = this.getRawNode(elem);

        var elemBCR = elem.getBoundingClientRect();
        return {
          width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
          height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
          top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
          left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))
        };
      },

      /**
       * Provides offset distance to the closest scrollable ancestor
       * or viewport.  Accounts for border and scrollbar width.
       *
       * Right and bottom dimensions represent the distance to the
       * respective edge of the viewport element.  If the element
       * edge extends beyond the viewport, a negative value will be
       * reported.
       *
       * @param {element} elem - The element to get the viewport offset for.
       * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
       * of the first scrollable element, default is false.
       * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
       * be accounted for, default is true.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**top**: distance to the top content edge of viewport element</li>
       *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
       *     <li>**left**: distance to the left content edge of viewport element</li>
       *     <li>**right**: distance to the right content edge of viewport element</li>
       *   </ul>
       */
      viewportOffset: function (elem, useDocument, includePadding) {
        elem = this.getRawNode(elem);
        includePadding = includePadding !== false ? true : false;

        var elemBCR = elem.getBoundingClientRect();
        var offsetBCR = {
          top: 0,
          left: 0,
          bottom: 0,
          right: 0
        };

        var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
        var offsetParentBCR = offsetParent.getBoundingClientRect();

        offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
        offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
        if (offsetParent === $document[0].documentElement) {
          offsetBCR.top += $window.pageYOffset;
          offsetBCR.left += $window.pageXOffset;
        }
        offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
        offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;

        if (includePadding) {
          var offsetParentStyle = $window.getComputedStyle(offsetParent);
          offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
          offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
          offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
          offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
        }

        return {
          top: Math.round(elemBCR.top - offsetBCR.top),
          bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
          left: Math.round(elemBCR.left - offsetBCR.left),
          right: Math.round(offsetBCR.right - elemBCR.right)
        };
      },

      /**
       * Provides an array of placement values parsed from a placement string.
       * Along with the 'auto' indicator, supported placement strings are:
       *   <ul>
       *     <li>top: element on top, horizontally centered on host element.</li>
       *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
       *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
       *     <li>bottom: element on bottom, horizontally centered on host element.</li>
       *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
       *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
       *     <li>left: element on left, vertically centered on host element.</li>
       *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
       *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
       *     <li>right: element on right, vertically centered on host element.</li>
       *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
       *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
       *   </ul>
       * A placement string with an 'auto' indicator is expected to be
       * space separated from the placement, i.e: 'auto bottom-left'  If
       * the primary and secondary placement values do not match 'top,
       * bottom, left, right' then 'top' will be the primary placement and
       * 'center' will be the secondary placement.  If 'auto' is passed, true
       * will be returned as the 3rd value of the array.
       *
       * @param {string} placement - The placement string to parse.
       *
       * @returns {array} An array with the following values
       * <ul>
       *   <li>**[0]**: The primary placement.</li>
       *   <li>**[1]**: The secondary placement.</li>
       *   <li>**[2]**: If auto is passed: true, else undefined.</li>
       * </ul>
       */
      parsePlacement: function (placement) {
        var autoPlace = PLACEMENT_REGEX.auto.test(placement);
        if (autoPlace) {
          placement = placement.replace(PLACEMENT_REGEX.auto, '');
        }

        placement = placement.split('-');

        placement[0] = placement[0] || 'top';
        if (!PLACEMENT_REGEX.primary.test(placement[0])) {
          placement[0] = 'top';
        }

        placement[1] = placement[1] || 'center';
        if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
          placement[1] = 'center';
        }

        if (autoPlace) {
          placement[2] = true;
        } else {
          placement[2] = false;
        }

        return placement;
      },

      /**
       * Provides coordinates for an element to be positioned relative to
       * another element.  Passing 'auto' as part of the placement parameter
       * will enable smart placement - where the element fits. i.e:
       * 'auto left-top' will check to see if there is enough space to the left
       * of the hostElem to fit the targetElem, if not place right (same for secondary
       * top placement).  Available space is calculated using the viewportOffset
       * function.
       *
       * @param {element} hostElem - The element to position against.
       * @param {element} targetElem - The element to position.
       * @param {string=} [placement=top] - The placement for the targetElem,
       *   default is 'top'. 'center' is assumed as secondary placement for
       *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
       *   <ul>
       *     <li>top</li>
       *     <li>top-right</li>
       *     <li>top-left</li>
       *     <li>bottom</li>
       *     <li>bottom-left</li>
       *     <li>bottom-right</li>
       *     <li>left</li>
       *     <li>left-top</li>
       *     <li>left-bottom</li>
       *     <li>right</li>
       *     <li>right-top</li>
       *     <li>right-bottom</li>
       *   </ul>
       * @param {boolean=} [appendToBody=false] - Should the top and left values returned
       *   be calculated from the body element, default is false.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**top**: Value for targetElem top.</li>
       *     <li>**left**: Value for targetElem left.</li>
       *     <li>**placement**: The resolved placement.</li>
       *   </ul>
       */
      positionElements: function (hostElem, targetElem, placement, appendToBody) {
        hostElem = this.getRawNode(hostElem);
        targetElem = this.getRawNode(targetElem);

        // need to read from prop to support tests.
        var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
        var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');

        placement = this.parsePlacement(placement);

        var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
        var targetElemPos = {
          top: 0,
          left: 0,
          placement: ''
        };

        if (placement[2]) {
          var viewportOffset = this.viewportOffset(hostElem, appendToBody);

          var targetElemStyle = $window.getComputedStyle(targetElem);
          var adjustedSize = {
            width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
            height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))
          };

          placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' :
            placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' :
            placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' :
            placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' :
            placement[0];

          placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' :
            placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' :
            placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' :
            placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' :
            placement[1];

          if (placement[1] === 'center') {
            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
              var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
              if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
                placement[1] = 'left';
              } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
                placement[1] = 'right';
              }
            } else {
              var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
              if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
                placement[1] = 'top';
              } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
                placement[1] = 'bottom';
              }
            }
          }
        }

        switch (placement[0]) {
          case 'top':
            targetElemPos.top = hostElemPos.top - targetHeight;
            break;
          case 'bottom':
            targetElemPos.top = hostElemPos.top + hostElemPos.height;
            break;
          case 'left':
            targetElemPos.left = hostElemPos.left - targetWidth;
            break;
          case 'right':
            targetElemPos.left = hostElemPos.left + hostElemPos.width;
            break;
        }

        switch (placement[1]) {
          case 'top':
            targetElemPos.top = hostElemPos.top;
            break;
          case 'bottom':
            targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
            break;
          case 'left':
            targetElemPos.left = hostElemPos.left;
            break;
          case 'right':
            targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
            break;
          case 'center':
            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
              targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
            } else {
              targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
            }
            break;
        }

        targetElemPos.top = Math.round(targetElemPos.top);
        targetElemPos.left = Math.round(targetElemPos.left);
        targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];

        return targetElemPos;
      },

      /**
       * Provides a way for positioning tooltip & dropdown
       * arrows when using placement options beyond the standard
       * left, right, top, or bottom.
       *
       * @param {element} elem - The tooltip/dropdown element.
       * @param {string} placement - The placement for the elem.
       */
      positionArrow: function (elem, placement) {
        elem = this.getRawNode(elem);

        var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
        if (!innerElem) {
          return;
        }

        var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');

        var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
        if (!arrowElem) {
          return;
        }

        var arrowCss = {
          top: '',
          bottom: '',
          left: '',
          right: ''
        };

        placement = this.parsePlacement(placement);
        if (placement[1] === 'center') {
          // no adjustment necessary - just reset styles
          angular.element(arrowElem).css(arrowCss);
          return;
        }

        var borderProp = 'border-' + placement[0] + '-width';
        var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];

        var borderRadiusProp = 'border-';
        if (PLACEMENT_REGEX.vertical.test(placement[0])) {
          borderRadiusProp += placement[0] + '-' + placement[1];
        } else {
          borderRadiusProp += placement[1] + '-' + placement[0];
        }
        borderRadiusProp += '-radius';
        var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];

        switch (placement[0]) {
          case 'top':
            arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'bottom':
            arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'left':
            arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'right':
            arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
            break;
        }

        arrowCss[placement[1]] = borderRadius;

        angular.element(arrowElem).css(arrowCss);
      }
    };
  }]);

angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.isClass', 'ui.bootstrap.position'])

  .value('$datepickerSuppressError', false)
  .value('uibDatepickerAttributeWarning', true)

  .constant('uibDatepickerConfig', {
    datepickerMode: 'day',
    formatDay: 'dd',
    formatMonth: 'MMMM',
    formatYear: 'yyyy',
    formatDayHeader: 'EEE',
    formatDayTitle: 'MMMM yyyy',
    formatMonthTitle: 'yyyy',
    maxDate: null,
    maxMode: 'year',
    minDate: null,
    minMode: 'day',
    ngModelOptions: {},
    shortcutPropagation: false,
    showWeeks: true,
    yearColumns: 5,
    yearRows: 4
  })

  .controller('UibDatepickerController', ['$scope', '$attrs', '$parse', '$interpolate', '$locale', '$log', 'dateFilter', 'uibDatepickerConfig', '$datepickerSuppressError', 'uibDatepickerAttributeWarning', 'uibDateParser',
    function ($scope, $attrs, $parse, $interpolate, $locale, $log, dateFilter, datepickerConfig, $datepickerSuppressError, datepickerAttributeWarning, dateParser) {
      var self = this,
        ngModelCtrl = {
          $setViewValue: angular.noop
        }, // nullModelCtrl;
        ngModelOptions = {},
        watchListeners = [],
        optionsUsed = !!$attrs.datepickerOptions;

      // Modes chain
      this.modes = ['day', 'month', 'year'];

      if (optionsUsed) {
        [
          'customClass',
          'dateDisabled',
          'datepickerMode',
          'formatDay',
          'formatDayHeader',
          'formatDayTitle',
          'formatMonth',
          'formatMonthTitle',
          'formatYear',
          'initDate',
          'maxDate',
          'maxMode',
          'minDate',
          'minMode',
          'showWeeks',
          'shortcutPropagation',
          'startingDay',
          'yearColumns',
          'yearRows'
        ].forEach(function (key) {
          switch (key) {
            case 'customClass':
            case 'dateDisabled':
              $scope[key] = $scope.datepickerOptions[key] || angular.noop;
              break;
            case 'datepickerMode':
              $scope.datepickerMode = angular.isDefined($scope.datepickerOptions.datepickerMode) ?
                $scope.datepickerOptions.datepickerMode : datepickerConfig.datepickerMode;
              break;
            case 'formatDay':
            case 'formatDayHeader':
            case 'formatDayTitle':
            case 'formatMonth':
            case 'formatMonthTitle':
            case 'formatYear':
              self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
                $interpolate($scope.datepickerOptions[key])($scope.$parent) :
                datepickerConfig[key];
              break;
            case 'showWeeks':
            case 'shortcutPropagation':
            case 'yearColumns':
            case 'yearRows':
              self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
                $scope.datepickerOptions[key] : datepickerConfig[key];
              break;
            case 'startingDay':
              if (angular.isDefined($scope.datepickerOptions.startingDay)) {
                self.startingDay = $scope.datepickerOptions.startingDay;
              } else if (angular.isNumber(datepickerConfig.startingDay)) {
                self.startingDay = datepickerConfig.startingDay;
              } else {
                self.startingDay = ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
              }

              break;
            case 'maxDate':
            case 'minDate':
              if ($scope.datepickerOptions[key]) {
                $scope.$watch(function () {
                  return $scope.datepickerOptions[key];
                }, function (value) {
                  if (value) {
                    if (angular.isDate(value)) {
                      self[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.timezone);
                    } else {
                      self[key] = new Date(dateFilter(value, 'medium'));
                    }
                  } else {
                    self[key] = null;
                  }

                  self.refreshView();
                });
              } else {
                self[key] = datepickerConfig[key] ? dateParser.fromTimezone(new Date(datepickerConfig[key]), ngModelOptions.timezone) : null;
              }

              break;
            case 'maxMode':
            case 'minMode':
              if ($scope.datepickerOptions[key]) {
                $scope.$watch(function () {
                  return $scope.datepickerOptions[key];
                }, function (value) {
                  self[key] = $scope[key] = angular.isDefined(value) ? value : datepickerOptions[key];
                  if (key === 'minMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) < self.modes.indexOf(self[key]) ||
                    key === 'maxMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) > self.modes.indexOf(self[key])) {
                    $scope.datepickerMode = self[key];
                    $scope.datepickerOptions.datepickerMode = self[key];
                  }
                });
              } else {
                self[key] = $scope[key] = datepickerConfig[key] || null;
              }

              break;
            case 'initDate':
              if ($scope.datepickerOptions.initDate) {
                self.activeDate = dateParser.fromTimezone($scope.datepickerOptions.initDate, ngModelOptions.timezone) || new Date();
                $scope.$watch(function () {
                  return $scope.datepickerOptions.initDate;
                }, function (initDate) {
                  if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
                    self.activeDate = dateParser.fromTimezone(initDate, ngModelOptions.timezone);
                    self.refreshView();
                  }
                });
              } else {
                self.activeDate = new Date();
              }
          }
        });
      } else {
        // Interpolated configuration attributes
        angular.forEach(['formatDay', 'formatMonth', 'formatYear', 'formatDayHeader', 'formatDayTitle', 'formatMonthTitle'], function (key) {
          self[key] = angular.isDefined($attrs[key]) ? $interpolate($attrs[key])($scope.$parent) : datepickerConfig[key];

          if (angular.isDefined($attrs[key]) && datepickerAttributeWarning) {
            $log.warn('uib-datepicker ' + key + ' attribute usage is deprecated, use datepicker-options attribute instead');
          }
        });

        // Evaled configuration attributes
        angular.forEach(['showWeeks', 'yearRows', 'yearColumns', 'shortcutPropagation'], function (key) {
          self[key] = angular.isDefined($attrs[key]) ?
            $scope.$parent.$eval($attrs[key]) : datepickerConfig[key];

          if (angular.isDefined($attrs[key]) && datepickerAttributeWarning) {
            $log.warn('uib-datepicker ' + key + ' attribute usage is deprecated, use datepicker-options attribute instead');
          }
        });

        angular.forEach(['dateDisabled', 'customClass'], function (key) {
          if (angular.isDefined($attrs[key]) && datepickerAttributeWarning) {
            $log.warn('uib-datepicker ' + key + ' attribute usage is deprecated, use datepicker-options attribute instead');
          }
        });

        if (angular.isDefined($attrs.startingDay)) {
          if (datepickerAttributeWarning) {
            $log.warn('uib-datepicker startingDay attribute usage is deprecated, use datepicker-options attribute instead');
          }

          self.startingDay = $scope.$parent.$eval($attrs.startingDay);
        } else if (angular.isNumber(datepickerConfig.startingDay)) {
          self.startingDay = datepickerConfig.startingDay;
        } else {
          self.startingDay = ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
        }

        // Watchable date attributes
        angular.forEach(['minDate', 'maxDate'], function (key) {
          if ($attrs[key]) {
            if (datepickerAttributeWarning) {
              $log.warn('uib-datepicker ' + key + ' attribute usage is deprecated, use datepicker-options attribute instead');
            }

            watchListeners.push($scope.$parent.$watch($attrs[key], function (value) {
              if (value) {
                if (angular.isDate(value)) {
                  self[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.timezone);
                } else {
                  self[key] = new Date(dateFilter(value, 'medium'));
                }
              } else {
                self[key] = null;
              }

              self.refreshView();
            }));
          } else {
            self[key] = datepickerConfig[key] ? dateParser.fromTimezone(new Date(datepickerConfig[key]), ngModelOptions.timezone) : null;
          }
        });

        angular.forEach(['minMode', 'maxMode'], function (key) {
          if ($attrs[key]) {
            if (datepickerAttributeWarning) {
              $log.warn('uib-datepicker ' + key + ' attribute usage is deprecated, use datepicker-options attribute instead');
            }

            watchListeners.push($scope.$parent.$watch($attrs[key], function (value) {
              self[key] = $scope[key] = angular.isDefined(value) ? value : $attrs[key];
              if (key === 'minMode' && self.modes.indexOf($scope.datepickerMode) < self.modes.indexOf(self[key]) ||
                key === 'maxMode' && self.modes.indexOf($scope.datepickerMode) > self.modes.indexOf(self[key])) {
                $scope.datepickerMode = self[key];
              }
            }));
          } else {
            self[key] = $scope[key] = datepickerConfig[key] || null;
          }
        });

        if (angular.isDefined($attrs.initDate)) {
          if (datepickerAttributeWarning) {
            $log.warn('uib-datepicker initDate attribute usage is deprecated, use datepicker-options attribute instead');
          }

          var initDate = dateParser.fromTimezone($scope.$parent.$eval($attrs.initDate), ngModelOptions.timezone);
          this.activeDate = !isNaN(initDate) ? initDate : new Date();
          watchListeners.push($scope.$parent.$watch($attrs.initDate, function (initDate) {
            if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
              initDate = dateParser.fromTimezone(initDate, ngModelOptions.timezone);
              self.activeDate = !isNaN(initDate) ? initDate : new Date();
              self.refreshView();
            }
          }));
        } else {
          this.activeDate = new Date();
        }

        if ($attrs.datepickerMode && datepickerAttributeWarning) {
          $log.warn('uib-datepicker datepickerMode attribute usage is deprecated, use datepicker-options attribute instead');
        }

        $scope.datepickerMode = $scope.datepickerMode ||
          datepickerConfig.datepickerMode;
      }

      $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);

      $scope.disabled = angular.isDefined($attrs.disabled) || false;
      if (angular.isDefined($attrs.ngDisabled)) {
        watchListeners.push($scope.$parent.$watch($attrs.ngDisabled, function (disabled) {
          $scope.disabled = disabled;
          self.refreshView();
        }));
      }

      $scope.isActive = function (dateObject) {
        if (self.compare(dateObject.date, self.activeDate) === 0) {
          $scope.activeDateId = dateObject.uid;
          return true;
        }
        return false;
      };

      this.init = function (ngModelCtrl_) {
        ngModelCtrl = ngModelCtrl_;
        ngModelOptions = ngModelCtrl_.$options || datepickerConfig.ngModelOptions;

        this.activeDate = ngModelCtrl.$modelValue || new Date();

        ngModelCtrl.$render = function () {
          self.render();
        };
      };

      this.render = function () {
        if (ngModelCtrl.$viewValue) {
          var date = new Date(ngModelCtrl.$viewValue),
            isValid = !isNaN(date);

          if (isValid) {
            this.activeDate = dateParser.fromTimezone(date, ngModelOptions.timezone);
          } else if (!$datepickerSuppressError) {
            $log.error('Datepicker directive: "ng-model" value must be a Date object');
          }
        }
        this.refreshView();
      };

      this.refreshView = function () {
        if (this.element) {
          $scope.selectedDt = null;
          this._refreshView();
          if ($scope.activeDt) {
            $scope.activeDateId = $scope.activeDt.uid;
          }

          var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
          date = dateParser.fromTimezone(date, ngModelOptions.timezone);
          ngModelCtrl.$setValidity('dateDisabled', !date ||
            this.element && !this.isDisabled(date));
        }
      };

      this.createDateObject = function (date, format) {
        var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
        model = dateParser.fromTimezone(model, ngModelOptions.timezone);
        var today = new Date();
        today = dateParser.fromTimezone(today, ngModelOptions.timezone);
        var time = this.compare(date, today);
        var dt = {
          date: date,
          label: dateParser.filter(date, format),
          selected: model && this.compare(date, model) === 0,
          disabled: this.isDisabled(date),
          past: time < 0,
          current: time === 0,
          future: time > 0,
          customClass: this.customClass(date) || null
        };

        if (model && this.compare(date, model) === 0) {
          $scope.selectedDt = dt;
        }

        if (self.activeDate && this.compare(dt.date, self.activeDate) === 0) {
          $scope.activeDt = dt;
        }

        return dt;
      };

      this.isDisabled = function (date) {
        return $scope.disabled ||
          this.minDate && this.compare(date, this.minDate) < 0 ||
          this.maxDate && this.compare(date, this.maxDate) > 0 ||
          $scope.dateDisabled && $scope.dateDisabled({
            date: date,
            mode: $scope.datepickerMode
          });
      };

      this.customClass = function (date) {
        return $scope.customClass({
          date: date,
          mode: $scope.datepickerMode
        });
      };

      // Split array into smaller arrays
      this.split = function (arr, size) {
        var arrays = [];
        while (arr.length > 0) {
          arrays.push(arr.splice(0, size));
        }
        return arrays;
      };

      $scope.select = function (date) {
        if ($scope.datepickerMode === self.minMode) {
          var dt = ngModelCtrl.$viewValue ? dateParser.fromTimezone(new Date(ngModelCtrl.$viewValue), ngModelOptions.timezone) : new Date(0, 0, 0, 0, 0, 0, 0);
          dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
          dt = dateParser.toTimezone(dt, ngModelOptions.timezone);
          ngModelCtrl.$setViewValue(dt);
          ngModelCtrl.$render();
        } else {
          self.activeDate = date;
          setMode(self.modes[self.modes.indexOf($scope.datepickerMode) - 1]);

          $scope.$emit('uib:datepicker.mode');
        }
      };

      $scope.move = function (direction) {
        var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
          month = self.activeDate.getMonth() + direction * (self.step.months || 0);
        self.activeDate.setFullYear(year, month, 1);
        self.refreshView();
      };

      $scope.toggleMode = function (direction) {
        direction = direction || 1;

        if ($scope.datepickerMode === self.maxMode && direction === 1 ||
          $scope.datepickerMode === self.minMode && direction === -1) {
          return;
        }

        setMode(self.modes[self.modes.indexOf($scope.datepickerMode) + direction]);

        $scope.$emit('uib:datepicker.mode');
      };

      // Key event mapper
      $scope.keys = {
        13: 'enter',
        32: 'space',
        33: 'pageup',
        34: 'pagedown',
        35: 'end',
        36: 'home',
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down'
      };

      var focusElement = function () {
        self.element[0].focus();
      };

      // Listen for focus requests from popup directive
      $scope.$on('uib:datepicker.focus', focusElement);

      $scope.keydown = function (evt) {
        var key = $scope.keys[evt.which];

        if (!key || evt.shiftKey || evt.altKey || $scope.disabled) {
          return;
        }

        evt.preventDefault();
        if (!self.shortcutPropagation) {
          evt.stopPropagation();
        }

        if (key === 'enter' || key === 'space') {
          if (self.isDisabled(self.activeDate)) {
            return; // do nothing
          }
          $scope.select(self.activeDate);
        } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
          $scope.toggleMode(key === 'up' ? 1 : -1);
        } else {
          self.handleKeyDown(key, evt);
          self.refreshView();
        }
      };

      $scope.$on("$destroy", function () {
        //Clear all watch listeners on destroy
        while (watchListeners.length) {
          watchListeners.shift()();
        }
      });

      function setMode(mode) {
        $scope.datepickerMode = mode;
        if (optionsUsed) {
          $scope.datepickerOptions.datepickerMode = mode;
        }
      }
    }
  ])

  .controller('UibDaypickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
    var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    this.step = {
      months: 1
    };
    this.element = $element;

    function getDaysInMonth(year, month) {
      return month === 1 && year % 4 === 0 &&
        (year % 100 !== 0 || year % 400 === 0) ? 29 : DAYS_IN_MONTH[month];
    }

    this.init = function (ctrl) {
      angular.extend(ctrl, this);
      scope.showWeeks = ctrl.showWeeks;
      ctrl.refreshView();
    };

    this.getDates = function (startDate, n) {
      var dates = new Array(n),
        current = new Date(startDate),
        i = 0,
        date;
      while (i < n) {
        date = new Date(current);
        dates[i++] = date;
        current.setDate(current.getDate() + 1);
      }
      return dates;
    };

    this._refreshView = function () {
      var year = this.activeDate.getFullYear(),
        month = this.activeDate.getMonth(),
        firstDayOfMonth = new Date(this.activeDate);

      firstDayOfMonth.setFullYear(year, month, 1);

      var difference = this.startingDay - firstDayOfMonth.getDay(),
        numDisplayedFromPreviousMonth = difference > 0 ?
        7 - difference : -difference,
        firstDate = new Date(firstDayOfMonth);

      if (numDisplayedFromPreviousMonth > 0) {
        firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
      }

      // 42 is the number of days on a six-week calendar
      var days = this.getDates(firstDate, 42);
      for (var i = 0; i < 42; i++) {
        days[i] = angular.extend(this.createDateObject(days[i], this.formatDay), {
          secondary: days[i].getMonth() !== month,
          uid: scope.uniqueId + '-' + i
        });
      }

      scope.labels = new Array(7);
      for (var j = 0; j < 7; j++) {
        scope.labels[j] = {
          abbr: dateFilter(days[j].date, this.formatDayHeader),
          full: dateFilter(days[j].date, 'EEEE')
        };
      }

      scope.title = dateFilter(this.activeDate, this.formatDayTitle);
      scope.rows = this.split(days, 7);

      if (scope.showWeeks) {
        scope.weekNumbers = [];
        var thursdayIndex = (4 + 7 - this.startingDay) % 7,
          numWeeks = scope.rows.length;
        for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
          scope.weekNumbers.push(
            getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
        }
      }
    };

    this.compare = function (date1, date2) {
      var _date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
      var _date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
      _date1.setFullYear(date1.getFullYear());
      _date2.setFullYear(date2.getFullYear());
      return _date1 - _date2;
    };

    function getISO8601WeekNumber(date) {
      var checkDate = new Date(date);
      checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
      var time = checkDate.getTime();
      checkDate.setMonth(0); // Compare with Jan 1
      checkDate.setDate(1);
      return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
    }

    this.handleKeyDown = function (key, evt) {
      var date = this.activeDate.getDate();

      if (key === 'left') {
        date = date - 1;
      } else if (key === 'up') {
        date = date - 7;
      } else if (key === 'right') {
        date = date + 1;
      } else if (key === 'down') {
        date = date + 7;
      } else if (key === 'pageup' || key === 'pagedown') {
        var month = this.activeDate.getMonth() + (key === 'pageup' ? -1 : 1);
        this.activeDate.setMonth(month, 1);
        date = Math.min(getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth()), date);
      } else if (key === 'home') {
        date = 1;
      } else if (key === 'end') {
        date = getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth());
      }
      this.activeDate.setDate(date);
    };
  }])

  .controller('UibMonthpickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
    this.step = {
      years: 1
    };
    this.element = $element;

    this.init = function (ctrl) {
      angular.extend(ctrl, this);
      ctrl.refreshView();
    };

    this._refreshView = function () {
      var months = new Array(12),
        year = this.activeDate.getFullYear(),
        date;

      for (var i = 0; i < 12; i++) {
        date = new Date(this.activeDate);
        date.setFullYear(year, i, 1);
        months[i] = angular.extend(this.createDateObject(date, this.formatMonth), {
          uid: scope.uniqueId + '-' + i
        });
      }

      scope.title = dateFilter(this.activeDate, this.formatMonthTitle);
      scope.rows = this.split(months, 3);
    };

    this.compare = function (date1, date2) {
      var _date1 = new Date(date1.getFullYear(), date1.getMonth());
      var _date2 = new Date(date2.getFullYear(), date2.getMonth());
      _date1.setFullYear(date1.getFullYear());
      _date2.setFullYear(date2.getFullYear());
      return _date1 - _date2;
    };

    this.handleKeyDown = function (key, evt) {
      var date = this.activeDate.getMonth();

      if (key === 'left') {
        date = date - 1;
      } else if (key === 'up') {
        date = date - 3;
      } else if (key === 'right') {
        date = date + 1;
      } else if (key === 'down') {
        date = date + 3;
      } else if (key === 'pageup' || key === 'pagedown') {
        var year = this.activeDate.getFullYear() + (key === 'pageup' ? -1 : 1);
        this.activeDate.setFullYear(year);
      } else if (key === 'home') {
        date = 0;
      } else if (key === 'end') {
        date = 11;
      }
      this.activeDate.setMonth(date);
    };
  }])

  .controller('UibYearpickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
    var columns, range;
    this.element = $element;

    function getStartingYear(year) {
      return parseInt((year - 1) / range, 10) * range + 1;
    }

    this.yearpickerInit = function () {
      columns = this.yearColumns;
      range = this.yearRows * columns;
      this.step = {
        years: range
      };
    };

    this._refreshView = function () {
      var years = new Array(range),
        date;

      for (var i = 0, start = getStartingYear(this.activeDate.getFullYear()); i < range; i++) {
        date = new Date(this.activeDate);
        date.setFullYear(start + i, 0, 1);
        years[i] = angular.extend(this.createDateObject(date, this.formatYear), {
          uid: scope.uniqueId + '-' + i
        });
      }

      scope.title = [years[0].label, years[range - 1].label].join(' - ');
      scope.rows = this.split(years, columns);
      scope.columns = columns;
    };

    this.compare = function (date1, date2) {
      return date1.getFullYear() - date2.getFullYear();
    };

    this.handleKeyDown = function (key, evt) {
      var date = this.activeDate.getFullYear();

      if (key === 'left') {
        date = date - 1;
      } else if (key === 'up') {
        date = date - columns;
      } else if (key === 'right') {
        date = date + 1;
      } else if (key === 'down') {
        date = date + columns;
      } else if (key === 'pageup' || key === 'pagedown') {
        date += (key === 'pageup' ? -1 : 1) * range;
      } else if (key === 'home') {
        date = getStartingYear(this.activeDate.getFullYear());
      } else if (key === 'end') {
        date = getStartingYear(this.activeDate.getFullYear()) + range - 1;
      }
      this.activeDate.setFullYear(date);
    };
  }])

  .directive('uibDatepicker', function () {
    return {
      replace: true,
      templateUrl: function (element, attrs) {
        return attrs.templateUrl || 'uib/template/datepicker/datepicker.html';
      },
      scope: {
        datepickerMode: '=?',
        datepickerOptions: '=?',
        dateDisabled: '&',
        customClass: '&',
        shortcutPropagation: '&?'
      },
      require: ['uibDatepicker', '^ngModel'],
      controller: 'UibDatepickerController',
      controllerAs: 'datepicker',
      link: function (scope, element, attrs, ctrls) {
        var datepickerCtrl = ctrls[0],
          ngModelCtrl = ctrls[1];

        datepickerCtrl.init(ngModelCtrl);
      }
    };
  })

  .directive('uibDaypicker', function () {
    return {
      replace: true,
      templateUrl: function (element, attrs) {
        return attrs.templateUrl || 'uib/template/datepicker/day.html';
      },
      require: ['^uibDatepicker', 'uibDaypicker'],
      controller: 'UibDaypickerController',
      link: function (scope, element, attrs, ctrls) {
        var datepickerCtrl = ctrls[0],
          daypickerCtrl = ctrls[1];

        daypickerCtrl.init(datepickerCtrl);
      }
    };
  })

  .directive('uibMonthpicker', function () {
    return {
      replace: true,
      templateUrl: function (element, attrs) {
        return attrs.templateUrl || 'uib/template/datepicker/month.html';
      },
      require: ['^uibDatepicker', 'uibMonthpicker'],
      controller: 'UibMonthpickerController',
      link: function (scope, element, attrs, ctrls) {
        var datepickerCtrl = ctrls[0],
          monthpickerCtrl = ctrls[1];

        monthpickerCtrl.init(datepickerCtrl);
      }
    };
  })

  .directive('uibYearpicker', function () {
    return {
      replace: true,
      templateUrl: function (element, attrs) {
        return attrs.templateUrl || 'uib/template/datepicker/year.html';
      },
      require: ['^uibDatepicker', 'uibYearpicker'],
      controller: 'UibYearpickerController',
      link: function (scope, element, attrs, ctrls) {
        var ctrl = ctrls[0];
        angular.extend(ctrl, ctrls[1]);
        ctrl.yearpickerInit();

        ctrl.refreshView();
      }
    };
  })

  .value('uibDatepickerPopupAttributeWarning', true)

  .constant('uibDatepickerPopupConfig', {
    altInputFormats: [],
    appendToBody: false,
    clearText: 'Clear',
    closeOnDateSelection: true,
    closeText: 'Done',
    currentText: 'Today',
    datepickerPopup: 'yyyy-MM-dd',
    datepickerPopupTemplateUrl: 'uib/template/datepicker/popup.html',
    datepickerTemplateUrl: 'uib/template/datepicker/datepicker.html',
    html5Types: {
      date: 'yyyy-MM-dd',
      'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
      'month': 'yyyy-MM'
    },
    onOpenFocus: true,
    showButtonBar: true,
    placement: 'auto bottom-left'
  })

  .controller('UibDatepickerPopupController', ['$scope', '$element', '$attrs', '$compile', '$log', '$parse', '$window', '$document', '$rootScope', '$uibPosition', 'dateFilter', 'uibDateParser', 'uibDatepickerPopupConfig', '$timeout', 'uibDatepickerConfig', 'uibDatepickerPopupAttributeWarning',
    function ($scope, $element, $attrs, $compile, $log, $parse, $window, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout, datepickerConfig, datepickerPopupAttributeWarning) {
      var cache = {},
        isHtml5DateInput = false;
      var dateFormat, closeOnDateSelection, appendToBody, onOpenFocus,
        datepickerPopupTemplateUrl, datepickerTemplateUrl, popupEl, datepickerEl, scrollParentEl,
        ngModel, ngModelOptions, $popup, altInputFormats, watchListeners = [];

      $scope.watchData = {};

      this.init = function (_ngModel_) {
        ngModel = _ngModel_;
        ngModelOptions = _ngModel_.$options || datepickerConfig.ngModelOptions;
        closeOnDateSelection = angular.isDefined($attrs.closeOnDateSelection) ?
          $scope.$parent.$eval($attrs.closeOnDateSelection) :
          datepickerPopupConfig.closeOnDateSelection;
        appendToBody = angular.isDefined($attrs.datepickerAppendToBody) ?
          $scope.$parent.$eval($attrs.datepickerAppendToBody) :
          datepickerPopupConfig.appendToBody;
        onOpenFocus = angular.isDefined($attrs.onOpenFocus) ?
          $scope.$parent.$eval($attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus;
        datepickerPopupTemplateUrl = angular.isDefined($attrs.datepickerPopupTemplateUrl) ?
          $attrs.datepickerPopupTemplateUrl :
          datepickerPopupConfig.datepickerPopupTemplateUrl;
        datepickerTemplateUrl = angular.isDefined($attrs.datepickerTemplateUrl) ?
          $attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl;
        altInputFormats = angular.isDefined($attrs.altInputFormats) ?
          $scope.$parent.$eval($attrs.altInputFormats) :
          datepickerPopupConfig.altInputFormats;

        $scope.showButtonBar = angular.isDefined($attrs.showButtonBar) ?
          $scope.$parent.$eval($attrs.showButtonBar) :
          datepickerPopupConfig.showButtonBar;

        if (datepickerPopupConfig.html5Types[$attrs.type]) {
          dateFormat = datepickerPopupConfig.html5Types[$attrs.type];
          isHtml5DateInput = true;
        } else {
          dateFormat = $attrs.uibDatepickerPopup || datepickerPopupConfig.datepickerPopup;
          $attrs.$observe('uibDatepickerPopup', function (value, oldValue) {
            var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
            // Invalidate the $modelValue to ensure that formatters re-run
            // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
            if (newDateFormat !== dateFormat) {
              dateFormat = newDateFormat;
              ngModel.$modelValue = null;

              if (!dateFormat) {
                throw new Error('uibDatepickerPopup must have a date format specified.');
              }
            }
          });
        }

        if (!dateFormat) {
          throw new Error('uibDatepickerPopup must have a date format specified.');
        }

        if (isHtml5DateInput && $attrs.uibDatepickerPopup) {
          throw new Error('HTML5 date input types do not support custom formats.');
        }

        // popup element used to display calendar
        popupEl = angular.element('<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>');
        $scope.ngModelOptions = angular.copy(ngModelOptions);
        $scope.ngModelOptions.timezone = null;
        if ($scope.ngModelOptions.updateOnDefault === true) {
          $scope.ngModelOptions.updateOn = $scope.ngModelOptions.updateOn ?
            $scope.ngModelOptions.updateOn + ' default' : 'default';
        }

        popupEl.attr({
          'ng-model': 'date',
          'ng-model-options': 'ngModelOptions',
          'ng-change': 'dateSelection(date)',
          'template-url': datepickerPopupTemplateUrl
        });

        // datepicker element
        datepickerEl = angular.element(popupEl.children()[0]);
        datepickerEl.attr('template-url', datepickerTemplateUrl);

        if (isHtml5DateInput) {
          if ($attrs.type === 'month') {
            datepickerEl.attr('datepicker-mode', '"month"');
            datepickerEl.attr('min-mode', 'month');
          }
        }

        if ($scope.datepickerOptions) {
          datepickerEl.attr('datepicker-options', 'datepickerOptions');
        }

        angular.forEach(['minMode', 'maxMode', 'datepickerMode', 'shortcutPropagation'], function (key) {
          if ($attrs[key]) {
            if (datepickerPopupAttributeWarning) {
              $log.warn('uib-datepicker settings via uib-datepicker-popup attributes are deprecated and will be removed in UI Bootstrap 1.3, use datepicker-options attribute instead');
            }

            var getAttribute = $parse($attrs[key]);
            var propConfig = {
              get: function () {
                return getAttribute($scope.$parent);
              }
            };

            datepickerEl.attr(cameltoDash(key), 'watchData.' + key);

            // Propagate changes from datepicker to outside
            if (key === 'datepickerMode') {
              var setAttribute = getAttribute.assign;
              propConfig.set = function (v) {
                setAttribute($scope.$parent, v);
              };
            }

            Object.defineProperty($scope.watchData, key, propConfig);
          }
        });

        angular.forEach(['minDate', 'maxDate', 'initDate'], function (key) {
          if ($attrs[key]) {
            if (datepickerPopupAttributeWarning) {
              $log.warn('uib-datepicker settings via uib-datepicker-popup attributes are deprecated and will be removed in UI Bootstrap 1.3, use datepicker-options attribute instead');
            }

            var getAttribute = $parse($attrs[key]);

            watchListeners.push($scope.$parent.$watch(getAttribute, function (value) {
              if (key === 'minDate' || key === 'maxDate') {
                if (value === null) {
                  cache[key] = null;
                } else if (angular.isDate(value)) {
                  cache[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.timezone);
                } else {
                  cache[key] = new Date(dateFilter(value, 'medium'));
                }

                $scope.watchData[key] = value === null ? null : cache[key];
              } else {
                var date = value ? new Date(value) : new Date();
                $scope.watchData[key] = dateParser.fromTimezone(date, ngModelOptions.timezone);
              }
            }));

            datepickerEl.attr(cameltoDash(key), 'watchData.' + key);
          }
        });

        if ($attrs.dateDisabled) {
          if (datepickerPopupAttributeWarning) {
            $log.warn('uib-datepicker settings via uib-datepicker-popup attributes are deprecated and will be removed in UI Bootstrap 1.3, use datepicker-options attribute instead');
          }

          datepickerEl.attr('date-disabled', 'dateDisabled({ date: date, mode: mode })');
        }

        angular.forEach(['formatDay', 'formatMonth', 'formatYear', 'formatDayHeader', 'formatDayTitle', 'formatMonthTitle', 'showWeeks', 'startingDay', 'yearRows', 'yearColumns'], function (key) {
          if (angular.isDefined($attrs[key])) {
            if (datepickerPopupAttributeWarning) {
              $log.warn('uib-datepicker settings via uib-datepicker-popup attributes are deprecated and will be removed in UI Bootstrap 1.3, use datepicker-options attribute instead');
            }

            datepickerEl.attr(cameltoDash(key), $attrs[key]);
          }
        });

        if ($attrs.customClass) {
          if (datepickerPopupAttributeWarning) {
            $log.warn('uib-datepicker settings via uib-datepicker-popup attributes are deprecated and will be removed in UI Bootstrap 1.3, use datepicker-options attribute instead');
          }

          datepickerEl.attr('custom-class', 'customClass({ date: date, mode: mode })');
        }

        if (!isHtml5DateInput) {
          // Internal API to maintain the correct ng-invalid-[key] class
          ngModel.$$parserName = 'date';
          ngModel.$validators.date = validator;
          ngModel.$parsers.unshift(parseDate);
          ngModel.$formatters.push(function (value) {
            if (ngModel.$isEmpty(value)) {
              $scope.date = value;
              return value;
            }

            $scope.date = dateParser.fromTimezone(value, ngModelOptions.timezone);

            if (angular.isNumber($scope.date)) {
              $scope.date = new Date($scope.date);
            }

            return dateParser.filter($scope.date, dateFormat);
          });
        } else {
          ngModel.$formatters.push(function (value) {
            $scope.date = dateParser.fromTimezone(value, ngModelOptions.timezone);
            return value;
          });
        }

        // Detect changes in the view from the text box
        ngModel.$viewChangeListeners.push(function () {
          $scope.date = parseDateString(ngModel.$viewValue);
        });

        $element.on('keydown', inputKeydownBind);

        $popup = $compile(popupEl)($scope);
        // Prevent jQuery cache memory leak (template is now redundant after linking)
        popupEl.remove();

        if (appendToBody) {
          $document.find('body').append($popup);
        } else {
          $element.after($popup);
        }

        $scope.$on('$destroy', function () {
          if ($scope.isOpen === true) {
            if (!$rootScope.$$phase) {
              $scope.$apply(function () {
                $scope.isOpen = false;
              });
            }
          }

          $popup.remove();
          $element.off('keydown', inputKeydownBind);
          $document.off('click', documentClickBind);
          if (scrollParentEl) {
            scrollParentEl.off('scroll', positionPopup);
          }
          angular.element($window).off('resize', positionPopup);

          //Clear all watch listeners on destroy
          while (watchListeners.length) {
            watchListeners.shift()();
          }
        });
      };

      $scope.getText = function (key) {
        return $scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
      };

      $scope.isDisabled = function (date) {
        if (date === 'today') {
          date = new Date();
        }

        return $scope.watchData.minDate && $scope.compare(date, cache.minDate) < 0 ||
          $scope.watchData.maxDate && $scope.compare(date, cache.maxDate) > 0;
      };

      $scope.compare = function (date1, date2) {
        return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
      };

      // Inner change
      $scope.dateSelection = function (dt) {
        if (angular.isDefined(dt)) {
          $scope.date = dt;
        }
        var date = $scope.date ? dateParser.filter($scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
        $element.val(date);
        ngModel.$setViewValue(date);

        if (closeOnDateSelection) {
          $scope.isOpen = false;
          $element[0].focus();
        }
      };

      $scope.keydown = function (evt) {
        if (evt.which === 27) {
          evt.stopPropagation();
          $scope.isOpen = false;
          $element[0].focus();
        }
      };

      $scope.select = function (date, evt) {
        evt.stopPropagation();

        if (date === 'today') {
          var today = new Date();
          if (angular.isDate($scope.date)) {
            date = new Date($scope.date);
            date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
          } else {
            date = new Date(today.setHours(0, 0, 0, 0));
          }
        }
        $scope.dateSelection(date);
      };

      $scope.close = function (evt) {
        evt.stopPropagation();

        $scope.isOpen = false;
        $element[0].focus();
      };

      $scope.disabled = angular.isDefined($attrs.disabled) || false;
      if ($attrs.ngDisabled) {
        watchListeners.push($scope.$parent.$watch($parse($attrs.ngDisabled), function (disabled) {
          $scope.disabled = disabled;
        }));
      }

      $scope.$watch('isOpen', function (value) {
        if (value) {
          if (!$scope.disabled) {
            $timeout(function () {
              positionPopup();

              if (onOpenFocus) {
                $scope.$broadcast('uib:datepicker.focus');
              }
              $document.on('click', documentClickBind);

              var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
              if (appendToBody || $position.parsePlacement(placement)[2]) {
                scrollParentEl = scrollParentEl || angular.element($position.scrollParent($element));
                if (scrollParentEl) {
                  scrollParentEl.on('scroll', positionPopup);
                }
              } else {
                scrollParentEl = null;
              }

              angular.element($window).on('resize', positionPopup);
            }, 0, false);
          } else {
            $scope.isOpen = false;
          }
        } else {
          $document.off('click', documentClickBind);
          if (scrollParentEl) {
            scrollParentEl.off('scroll', positionPopup);
          }
          angular.element($window).off('resize', positionPopup);
        }
      });

      function cameltoDash(string) {
        return string.replace(/([A-Z])/g, function ($1) {
          return '-' + $1.toLowerCase();
        });
      }

      function parseDateString(viewValue) {
        var date = dateParser.parse(viewValue, dateFormat, $scope.date);
        if (isNaN(date)) {
          for (var i = 0; i < altInputFormats.length; i++) {
            date = dateParser.parse(viewValue, altInputFormats[i], $scope.date);
            if (!isNaN(date)) {
              return date;
            }
          }
        }
        return date;
      }

      function parseDate(viewValue) {
        if (angular.isNumber(viewValue)) {
          // presumably timestamp to date object
          viewValue = new Date(viewValue);
        }

        if (!viewValue) {
          return null;
        }

        if (angular.isDate(viewValue) && !isNaN(viewValue)) {
          return viewValue;
        }

        if (angular.isString(viewValue)) {
          var date = parseDateString(viewValue);
          if (!isNaN(date)) {
            return dateParser.toTimezone(date, ngModelOptions.timezone);
          }
        }

        return ngModel.$options && ngModel.$options.allowInvalid ? viewValue : undefined;
      }

      function validator(modelValue, viewValue) {
        var value = modelValue || viewValue;

        if (!$attrs.ngRequired && !value) {
          return true;
        }

        if (angular.isNumber(value)) {
          value = new Date(value);
        }

        if (!value) {
          return true;
        }

        if (angular.isDate(value) && !isNaN(value)) {
          return true;
        }

        if (angular.isString(value)) {
          return !isNaN(parseDateString(viewValue));
        }

        return false;
      }

      function documentClickBind(event) {
        if (!$scope.isOpen && $scope.disabled) {
          return;
        }

        var popup = $popup[0];
        var dpContainsTarget = $element[0].contains(event.target);
        // The popup node may not be an element node
        // In some browsers (IE) only element nodes have the 'contains' function
        var popupContainsTarget = popup.contains !== undefined && popup.contains(event.target);
        if ($scope.isOpen && !(dpContainsTarget || popupContainsTarget)) {
          $scope.$apply(function () {
            $scope.isOpen = false;
          });
        }
      }

      function inputKeydownBind(evt) {
        if (evt.which === 27 && $scope.isOpen) {
          evt.preventDefault();
          evt.stopPropagation();
          $scope.$apply(function () {
            $scope.isOpen = false;
          });
          $element[0].focus();
        } else if (evt.which === 40 && !$scope.isOpen) {
          evt.preventDefault();
          evt.stopPropagation();
          $scope.$apply(function () {
            $scope.isOpen = true;
          });
        }
      }

      function positionPopup() {
        if ($scope.isOpen) {
          var dpElement = angular.element($popup[0].querySelector('.uib-datepicker-popup'));
          var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
          var position = $position.positionElements($element, dpElement, placement, appendToBody);
          dpElement.css({
            top: position.top + 'px',
            left: position.left + 'px'
          });
          if (dpElement.hasClass('uib-position-measure')) {
            dpElement.removeClass('uib-position-measure');
          }
        }
      }

      $scope.$on('uib:datepicker.mode', function () {
        $timeout(positionPopup, 0, false);
      });
    }
  ])

  .directive('uibDatepickerPopup', function () {
    return {
      require: ['ngModel', 'uibDatepickerPopup'],
      controller: 'UibDatepickerPopupController',
      scope: {
        datepickerOptions: '=?',
        isOpen: '=?',
        currentText: '@',
        clearText: '@',
        closeText: '@',
        dateDisabled: '&',
        customClass: '&'
      },
      link: function (scope, element, attrs, ctrls) {
        var ngModel = ctrls[0],
          ctrl = ctrls[1];

        ctrl.init(ngModel);
      }
    };
  })

  .directive('uibDatepickerPopupWrap', function () {
    return {
      replace: true,
      transclude: true,
      templateUrl: function (element, attrs) {
        return attrs.templateUrl || 'uib/template/datepicker/popup.html';
      }
    };
  });

angular.module('ui.bootstrap.debounce', [])
  /**
   * A helper, internal service that debounces a function
   */
  .factory('$$debounce', ['$timeout', function ($timeout) {
    return function (callback, debounceTime) {
      var timeoutPromise;

      return function () {
        var self = this;
        var args = Array.prototype.slice.call(arguments);
        if (timeoutPromise) {
          $timeout.cancel(timeoutPromise);
        }

        timeoutPromise = $timeout(function () {
          callback.apply(self, args);
        }, debounceTime);
      };
    };
  }]);

angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.position'])

  .constant('uibDropdownConfig', {
    appendToOpenClass: 'uib-dropdown-open',
    openClass: 'open'
  })

  .service('uibDropdownService', ['$document', '$rootScope', function ($document, $rootScope) {
    var openScope = null;

    this.open = function (dropdownScope) {
      if (!openScope) {
        $document.on('click', closeDropdown);
        $document.on('keydown', keybindFilter);
      }

      if (openScope && openScope !== dropdownScope) {
        openScope.isOpen = false;
      }

      openScope = dropdownScope;
    };

    this.close = function (dropdownScope) {
      if (openScope === dropdownScope) {
        openScope = null;
        $document.off('click', closeDropdown);
        $document.off('keydown', keybindFilter);
      }
    };

    var closeDropdown = function (evt) {
      // This method may still be called during the same mouse event that
      // unbound this event handler. So check openScope before proceeding.
      if (!openScope) {
        return;
      }

      if (evt && openScope.getAutoClose() === 'disabled') {
        return;
      }

      if (evt && evt.which === 3) {
        return;
      }

      var toggleElement = openScope.getToggleElement();
      if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
        return;
      }

      var dropdownElement = openScope.getDropdownElement();
      if (evt && openScope.getAutoClose() === 'outsideClick' &&
        dropdownElement && dropdownElement[0].contains(evt.target)) {
        return;
      }

      openScope.isOpen = false;

      if (!$rootScope.$$phase) {
        openScope.$apply();
      }
    };

    var keybindFilter = function (evt) {
      if (evt.which === 27) {
        openScope.focusToggleElement();
        closeDropdown();
      } else if (openScope.isKeynavEnabled() && [38, 40].indexOf(evt.which) !== -1 && openScope.isOpen) {
        evt.preventDefault();
        evt.stopPropagation();
        openScope.focusDropdownEntry(evt.which);
      }
    };
  }])

  .controller('UibDropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function ($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {
    var self = this,
      scope = $scope.$new(), // create a child scope so we are not polluting original one
      templateScope,
      appendToOpenClass = dropdownConfig.appendToOpenClass,
      openClass = dropdownConfig.openClass,
      getIsOpen,
      setIsOpen = angular.noop,
      toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
      appendToBody = false,
      appendTo = null,
      keynavEnabled = false,
      selectedOption = null,
      body = $document.find('body');

    $element.addClass('dropdown');

    this.init = function () {
      if ($attrs.isOpen) {
        getIsOpen = $parse($attrs.isOpen);
        setIsOpen = getIsOpen.assign;

        $scope.$watch(getIsOpen, function (value) {
          scope.isOpen = !!value;
        });
      }

      if (angular.isDefined($attrs.dropdownAppendTo)) {
        var appendToEl = $parse($attrs.dropdownAppendTo)(scope);
        if (appendToEl) {
          appendTo = angular.element(appendToEl);
        }
      }

      appendToBody = angular.isDefined($attrs.dropdownAppendToBody);
      keynavEnabled = angular.isDefined($attrs.keyboardNav);

      if (appendToBody && !appendTo) {
        appendTo = body;
      }

      if (appendTo && self.dropdownMenu) {
        appendTo.append(self.dropdownMenu);
        $element.on('$destroy', function handleDestroyEvent() {
          self.dropdownMenu.remove();
        });
      }
    };

    this.toggle = function (open) {
      scope.isOpen = arguments.length ? !!open : !scope.isOpen;
      if (angular.isFunction(setIsOpen)) {
        setIsOpen(scope, scope.isOpen);
      }

      return scope.isOpen;
    };

    // Allow other directives to watch status
    this.isOpen = function () {
      return scope.isOpen;
    };

    scope.getToggleElement = function () {
      return self.toggleElement;
    };

    scope.getAutoClose = function () {
      return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
    };

    scope.getElement = function () {
      return $element;
    };

    scope.isKeynavEnabled = function () {
      return keynavEnabled;
    };

    scope.focusDropdownEntry = function (keyCode) {
      var elems = self.dropdownMenu ? //If append to body is used.
        angular.element(self.dropdownMenu).find('a') :
        $element.find('ul').eq(0).find('a');

      switch (keyCode) {
        case 40: {
          if (!angular.isNumber(self.selectedOption)) {
            self.selectedOption = 0;
          } else {
            self.selectedOption = self.selectedOption === elems.length - 1 ?
              self.selectedOption :
              self.selectedOption + 1;
          }
          break;
        }
        case 38: {
          if (!angular.isNumber(self.selectedOption)) {
            self.selectedOption = elems.length - 1;
          } else {
            self.selectedOption = self.selectedOption === 0 ?
              0 : self.selectedOption - 1;
          }
          break;
        }
      }
      elems[self.selectedOption].focus();
    };

    scope.getDropdownElement = function () {
      return self.dropdownMenu;
    };

    scope.focusToggleElement = function () {
      if (self.toggleElement) {
        self.toggleElement[0].focus();
      }
    };

    scope.$watch('isOpen', function (isOpen, wasOpen) {
      console.log("welcome");
      if (appendTo && self.dropdownMenu) {
        var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true),
          css,
          rightalign;

        css = {
          top: pos.top + 'px',
          display: isOpen ? 'block' : 'none'
        };

        rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
        if (!rightalign) {
          css.left = pos.left + 'px';
          css.right = 'auto';
        } else {
          css.left = 'auto';
          css.right = window.innerWidth -
            (pos.left + $element.prop('offsetWidth') + 20) + 'px';
        }

        // Need to adjust our positioning to be relative to the appendTo container
        // if it's not the body element
        if (!appendToBody) {
          var appendOffset = $position.offset(appendTo);

          css.top = pos.top - appendOffset.top + 'px';

          if (!rightalign) {
            css.left = pos.left - appendOffset.left + 'px';
          } else {
            css.right = window.innerWidth -
              (pos.left - appendOffset.left + $element.prop('offsetWidth') + 20) + 'px';
          }
        }
        console.log("position", css);
        self.dropdownMenu.css(css);
      }

      var openContainer = appendTo ? appendTo : $element;
      var hasOpenClass = openContainer.hasClass(appendTo ? appendToOpenClass : openClass);

      if (hasOpenClass === !isOpen) {
        $animate[isOpen ? 'addClass' : 'removeClass'](openContainer, appendTo ? appendToOpenClass : openClass).then(function () {
          if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
            toggleInvoker($scope, {
              open: !!isOpen
            });
          }
        });
      }

      if (isOpen) {
        if (self.dropdownMenuTemplateUrl) {
          $templateRequest(self.dropdownMenuTemplateUrl).then(function (tplContent) {
            templateScope = scope.$new();
            $compile(tplContent.trim())(templateScope, function (dropdownElement) {
              var newEl = dropdownElement;
              self.dropdownMenu.replaceWith(newEl);
              self.dropdownMenu = newEl;
            });
          });
        }

        scope.focusToggleElement();
        uibDropdownService.open(scope);
      } else {
        if (self.dropdownMenuTemplateUrl) {
          if (templateScope) {
            templateScope.$destroy();
          }
          var newEl = angular.element('<ul class="dropdown-menu"></ul>');
          self.dropdownMenu.replaceWith(newEl);
          self.dropdownMenu = newEl;
        }

        uibDropdownService.close(scope);
        self.selectedOption = null;
      }

      if (angular.isFunction(setIsOpen)) {
        setIsOpen($scope, isOpen);
      }
    });

    $scope.$on('$locationChangeSuccess', function () {
      if (scope.getAutoClose() !== 'disabled') {
        scope.isOpen = false;
      }
    });
  }])

  .directive('uibDropdown', function () {
    return {
      controller: 'UibDropdownController',
      link: function (scope, element, attrs, dropdownCtrl) {
        dropdownCtrl.init();
      }
    };
  })

  .directive('uibDropdownMenu', function () {
    return {
      restrict: 'A',
      require: '?^uibDropdown',
      link: function (scope, element, attrs, dropdownCtrl) {
        if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
          return;
        }

        element.addClass('dropdown-menu');

        var tplUrl = attrs.templateUrl;
        if (tplUrl) {
          dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
        }

        if (!dropdownCtrl.dropdownMenu) {
          dropdownCtrl.dropdownMenu = element;
        }
      }
    };
  })

  .directive('uibDropdownToggle', function () {
    return {
      require: '?^uibDropdown',
      link: function (scope, element, attrs, dropdownCtrl) {
        if (!dropdownCtrl) {
          return;
        }

        element.addClass('dropdown-toggle');

        dropdownCtrl.toggleElement = element;

        var toggleDropdown = function (event) {
          event.preventDefault();

          if (!element.hasClass('disabled') && !attrs.disabled) {
            scope.$apply(function () {
              dropdownCtrl.toggle();
            });
          }
        };

        element.bind('click', toggleDropdown);

        // WAI-ARIA
        element.attr({
          'aria-haspopup': true,
          'aria-expanded': false
        });
        scope.$watch(dropdownCtrl.isOpen, function (isOpen) {
          element.attr('aria-expanded', !!isOpen);
        });

        scope.$on('$destroy', function () {
          element.unbind('click', toggleDropdown);
        });
      }
    };
  });

angular.module('ui.bootstrap.stackedMap', [])
  /**
   * A helper, internal data structure that acts as a map but also allows getting / removing
   * elements in the LIFO order
   */
  .factory('$$stackedMap', function () {
    return {
      createNew: function () {
        var stack = [];

        return {
          add: function (key, value) {
            stack.push({
              key: key,
              value: value
            });
          },
          get: function (key) {
            for (var i = 0; i < stack.length; i++) {
              if (key === stack[i].key) {
                return stack[i];
              }
            }
          },
          keys: function () {
            var keys = [];
            for (var i = 0; i < stack.length; i++) {
              keys.push(stack[i].key);
            }
            return keys;
          },
          top: function () {
            return stack[stack.length - 1];
          },
          remove: function (key) {
            var idx = -1;
            for (var i = 0; i < stack.length; i++) {
              if (key === stack[i].key) {
                idx = i;
                break;
              }
            }
            return stack.splice(idx, 1)[0];
          },
          removeTop: function () {
            return stack.splice(stack.length - 1, 1)[0];
          },
          length: function () {
            return stack.length;
          }
        };
      }
    };
  });
angular.module('ui.bootstrap.modal', ['ui.bootstrap.stackedMap'])
  /**
   * A helper, internal data structure that stores all references attached to key
   */
  .factory('$$multiMap', function () {
    return {
      createNew: function () {
        var map = {};

        return {
          entries: function () {
            return Object.keys(map).map(function (key) {
              return {
                key: key,
                value: map[key]
              };
            });
          },
          get: function (key) {
            return map[key];
          },
          hasKey: function (key) {
            return !!map[key];
          },
          keys: function () {
            return Object.keys(map);
          },
          put: function (key, value) {
            if (!map[key]) {
              map[key] = [];
            }

            map[key].push(value);
          },
          remove: function (key, value) {
            var values = map[key];

            if (!values) {
              return;
            }

            var idx = values.indexOf(value);

            if (idx !== -1) {
              values.splice(idx, 1);
            }

            if (!values.length) {
              delete map[key];
            }
          }
        };
      }
    };
  })

  /**
   * Pluggable resolve mechanism for the modal resolve resolution
   * Supports UI Router's $resolve service
   */
  .provider('$uibResolve', function () {
    var resolve = this;
    this.resolver = null;

    this.setResolver = function (resolver) {
      this.resolver = resolver;
    };

    this.$get = ['$injector', '$q', function ($injector, $q) {
      var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
      return {
        resolve: function (invocables, locals, parent, self) {
          if (resolver) {
            return resolver.resolve(invocables, locals, parent, self);
          }

          var promises = [];

          angular.forEach(invocables, function (value) {
            if (angular.isFunction(value) || angular.isArray(value)) {
              promises.push($q.resolve($injector.invoke(value)));
            } else if (angular.isString(value)) {
              promises.push($q.resolve($injector.get(value)));
            } else {
              promises.push($q.resolve(value));
            }
          });

          return $q.all(promises).then(function (resolves) {
            var resolveObj = {};
            var resolveIter = 0;
            angular.forEach(invocables, function (value, key) {
              resolveObj[key] = resolves[resolveIter++];
            });

            return resolveObj;
          });
        }
      };
    }];
  })

  /**
   * A helper directive for the $modal service. It creates a backdrop element.
   */
  .directive('uibModalBackdrop', ['$animate', '$injector', '$uibModalStack',
    function ($animate, $injector, $modalStack) {
      return {
        replace: true,
        templateUrl: 'uib/template/modal/backdrop.html',
        compile: function (tElement, tAttrs) {
          tElement.addClass(tAttrs.backdropClass);
          return linkFn;
        }
      };

      function linkFn(scope, element, attrs) {
        if (attrs.modalInClass) {
          $animate.addClass(element, attrs.modalInClass);

          scope.$on($modalStack.NOW_CLOSING_EVENT, function (e, setIsAsync) {
            var done = setIsAsync();
            if (scope.modalOptions.animation) {
              $animate.removeClass(element, attrs.modalInClass).then(done);
            } else {
              done();
            }
          });
        }
      }
    }
  ])

  .directive('uibModalWindow', ['$uibModalStack', '$q', '$animateCss', '$document',
    function ($modalStack, $q, $animateCss, $document) {
      return {
        scope: {
          index: '@'
        },
        replace: true,
        transclude: true,
        templateUrl: function (tElement, tAttrs) {
          return tAttrs.templateUrl || 'uib/template/modal/window.html';
        },
        link: function (scope, element, attrs) {
          element.addClass(attrs.windowClass || '');
          element.addClass(attrs.windowTopClass || '');
          scope.size = attrs.size;

          scope.close = function (evt) {
            var modal = $modalStack.getTop();
            if (modal && modal.value.backdrop &&
              modal.value.backdrop !== 'static' &&
              evt.target === evt.currentTarget) {
              evt.preventDefault();
              evt.stopPropagation();
              $modalStack.dismiss(modal.key, 'backdrop click');
            }
          };

          // moved from template to fix issue #2280
          element.on('click', scope.close);

          // This property is only added to the scope for the purpose of detecting when this directive is rendered.
          // We can detect that by using this property in the template associated with this directive and then use
          // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
          scope.$isRendered = true;

          // Deferred object that will be resolved when this modal is render.
          var modalRenderDeferObj = $q.defer();
          // Observe function will be called on next digest cycle after compilation, ensuring that the DOM is ready.
          // In order to use this way of finding whether DOM is ready, we need to observe a scope property used in modal's template.
          attrs.$observe('modalRender', function (value) {
            if (value === 'true') {
              modalRenderDeferObj.resolve();
            }
          });

          modalRenderDeferObj.promise.then(function () {
            var animationPromise = null;

            if (attrs.modalInClass) {
              animationPromise = $animateCss(element, {
                addClass: attrs.modalInClass
              }).start();

              scope.$on($modalStack.NOW_CLOSING_EVENT, function (e, setIsAsync) {
                var done = setIsAsync();
                $animateCss(element, {
                  removeClass: attrs.modalInClass
                }).start().then(done);
              });
            }


            $q.when(animationPromise).then(function () {
              // Notify {@link $modalStack} that modal is rendered.
              var modal = $modalStack.getTop();
              if (modal) {
                $modalStack.modalRendered(modal.key);
              }

              /**
               * If something within the freshly-opened modal already has focus (perhaps via a
               * directive that causes focus). then no need to try and focus anything.
               */
              if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {
                var inputWithAutofocus = element[0].querySelector('[autofocus]');
                /**
                 * Auto-focusing of a freshly-opened modal element causes any child elements
                 * with the autofocus attribute to lose focus. This is an issue on touch
                 * based devices which will show and then hide the onscreen keyboard.
                 * Attempts to refocus the autofocus element via JavaScript will not reopen
                 * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
                 * the modal element if the modal does not contain an autofocus element.
                 */
                if (inputWithAutofocus) {
                  inputWithAutofocus.focus();
                } else {
                  element[0].focus();
                }
              }
            });
          });
        }
      };
    }
  ])

  .directive('uibModalAnimationClass', function () {
    return {
      compile: function (tElement, tAttrs) {
        if (tAttrs.modalAnimation) {
          tElement.addClass(tAttrs.uibModalAnimationClass);
        }
      }
    };
  })

  .directive('uibModalTransclude', function () {
    return {
      link: function (scope, element, attrs, controller, transclude) {
        transclude(scope.$parent, function (clone) {
          element.empty();
          element.append(clone);
        });
      }
    };
  })

  .factory('$uibModalStack', ['$animate', '$animateCss', '$document',
    '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap',
    function ($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap) {
      var OPENED_MODAL_CLASS = 'modal-open';

      var backdropDomEl, backdropScope;
      var openedWindows = $$stackedMap.createNew();
      var openedClasses = $$multiMap.createNew();
      var $modalStack = {
        NOW_CLOSING_EVENT: 'modal.stack.now-closing'
      };

      //Modal focus behavior
      var focusableElementList;
      var focusIndex = 0;
      var tababbleSelector = 'a[href], area[href], input:not([disabled]), ' +
        'button:not([disabled]),select:not([disabled]), textarea:not([disabled]), ' +
        'iframe, object, embed, *[tabindex], *[contenteditable=true]';

      function backdropIndex() {
        var topBackdropIndex = -1;
        var opened = openedWindows.keys();
        for (var i = 0; i < opened.length; i++) {
          if (openedWindows.get(opened[i]).value.backdrop) {
            topBackdropIndex = i;
          }
        }
        return topBackdropIndex;
      }

      $rootScope.$watch(backdropIndex, function (newBackdropIndex) {
        if (backdropScope) {
          backdropScope.index = newBackdropIndex;
        }
      });

      function removeModalWindow(modalInstance, elementToReceiveFocus) {
        var modalWindow = openedWindows.get(modalInstance).value;
        var appendToElement = modalWindow.appendTo;

        //clean up the stack
        openedWindows.remove(modalInstance);

        removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function () {
          var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
          openedClasses.remove(modalBodyClass, modalInstance);
          appendToElement.toggleClass(modalBodyClass, openedClasses.hasKey(modalBodyClass));
          toggleTopWindowClass(true);
        }, modalWindow.closedDeferred);
        checkRemoveBackdrop();

        //move focus to specified element if available, or else to body
        if (elementToReceiveFocus && elementToReceiveFocus.focus) {
          elementToReceiveFocus.focus();
        } else if (appendToElement.focus) {
          appendToElement.focus();
        }
      }

      // Add or remove "windowTopClass" from the top window in the stack
      function toggleTopWindowClass(toggleSwitch) {
        var modalWindow;

        if (openedWindows.length() > 0) {
          modalWindow = openedWindows.top().value;
          modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
        }
      }

      function checkRemoveBackdrop() {
        //remove backdrop if no longer needed
        if (backdropDomEl && backdropIndex() === -1) {
          var backdropScopeRef = backdropScope;
          removeAfterAnimate(backdropDomEl, backdropScope, function () {
            backdropScopeRef = null;
          });
          backdropDomEl = undefined;
          backdropScope = undefined;
        }
      }

      function removeAfterAnimate(domEl, scope, done, closedDeferred) {
        var asyncDeferred;
        var asyncPromise = null;
        var setIsAsync = function () {
          if (!asyncDeferred) {
            asyncDeferred = $q.defer();
            asyncPromise = asyncDeferred.promise;
          }

          return function asyncDone() {
            asyncDeferred.resolve();
          };
        };
        scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);

        // Note that it's intentional that asyncPromise might be null.
        // That's when setIsAsync has not been called during the
        // NOW_CLOSING_EVENT broadcast.
        return $q.when(asyncPromise).then(afterAnimating);

        function afterAnimating() {
          if (afterAnimating.done) {
            return;
          }
          afterAnimating.done = true;

          $animate.leave(domEl).then(function () {
            domEl.remove();
            if (closedDeferred) {
              closedDeferred.resolve();
            }
          });

          scope.$destroy();
          if (done) {
            done();
          }
        }
      }

      $document.on('keydown', keydownListener);

      $rootScope.$on('$destroy', function () {
        $document.off('keydown', keydownListener);
      });

      function keydownListener(evt) {
        if (evt.isDefaultPrevented()) {
          return evt;
        }

        var modal = openedWindows.top();
        if (modal) {
          switch (evt.which) {
            case 27: {
              if (modal.value.keyboard) {
                evt.preventDefault();
                $rootScope.$apply(function () {
                  $modalStack.dismiss(modal.key, 'escape key press');
                });
              }
              break;
            }
            case 9: {
              $modalStack.loadFocusElementList(modal);
              var focusChanged = false;
              if (evt.shiftKey) {
                if ($modalStack.isFocusInFirstItem(evt) || $modalStack.isModalFocused(evt, modal)) {
                  focusChanged = $modalStack.focusLastFocusableElement();
                }
              } else {
                if ($modalStack.isFocusInLastItem(evt)) {
                  focusChanged = $modalStack.focusFirstFocusableElement();
                }
              }

              if (focusChanged) {
                evt.preventDefault();
                evt.stopPropagation();
              }
              break;
            }
          }
        }
      }

      $modalStack.open = function (modalInstance, modal) {
        var modalOpener = $document[0].activeElement,
          modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;

        toggleTopWindowClass(false);

        openedWindows.add(modalInstance, {
          deferred: modal.deferred,
          renderDeferred: modal.renderDeferred,
          closedDeferred: modal.closedDeferred,
          modalScope: modal.scope,
          backdrop: modal.backdrop,
          keyboard: modal.keyboard,
          openedClass: modal.openedClass,
          windowTopClass: modal.windowTopClass,
          animation: modal.animation,
          appendTo: modal.appendTo
        });

        openedClasses.put(modalBodyClass, modalInstance);

        var appendToElement = modal.appendTo,
          currBackdropIndex = backdropIndex();

        if (!appendToElement.length) {
          throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
        }

        if (currBackdropIndex >= 0 && !backdropDomEl) {
          backdropScope = $rootScope.$new(true);
          backdropScope.modalOptions = modal;
          backdropScope.index = currBackdropIndex;
          backdropDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
          backdropDomEl.attr('backdrop-class', modal.backdropClass);
          if (modal.animation) {
            backdropDomEl.attr('modal-animation', 'true');
          }
          $compile(backdropDomEl)(backdropScope);
          $animate.enter(backdropDomEl, appendToElement);
        }

        var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
        angularDomEl.attr({
          'template-url': modal.windowTemplateUrl,
          'window-class': modal.windowClass,
          'window-top-class': modal.windowTopClass,
          'size': modal.size,
          'index': openedWindows.length() - 1,
          'animate': 'animate'
        }).html(modal.content);
        if (modal.animation) {
          angularDomEl.attr('modal-animation', 'true');
        }

        $animate.enter($compile(angularDomEl)(modal.scope), appendToElement)
          .then(function () {
            if (!modal.scope.$$uibDestructionScheduled) {
              $animate.addClass(appendToElement, modalBodyClass);
            }
          });

        openedWindows.top().value.modalDomEl = angularDomEl;
        openedWindows.top().value.modalOpener = modalOpener;

        $modalStack.clearFocusListCache();
      };

      function broadcastClosing(modalWindow, resultOrReason, closing) {
        return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
      }

      $modalStack.close = function (modalInstance, result) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow && broadcastClosing(modalWindow, result, true)) {
          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
          modalWindow.value.deferred.resolve(result);
          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
          return true;
        }
        return !modalWindow;
      };

      $modalStack.dismiss = function (modalInstance, reason) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
          modalWindow.value.deferred.reject(reason);
          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
          return true;
        }
        return !modalWindow;
      };

      $modalStack.dismissAll = function (reason) {
        var topModal = this.getTop();
        while (topModal && this.dismiss(topModal.key, reason)) {
          topModal = this.getTop();
        }
      };

      $modalStack.getTop = function () {
        return openedWindows.top();
      };

      $modalStack.modalRendered = function (modalInstance) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow) {
          modalWindow.value.renderDeferred.resolve();
        }
      };

      $modalStack.focusFirstFocusableElement = function () {
        if (focusableElementList.length > 0) {
          focusableElementList[0].focus();
          return true;
        }
        return false;
      };
      $modalStack.focusLastFocusableElement = function () {
        if (focusableElementList.length > 0) {
          focusableElementList[focusableElementList.length - 1].focus();
          return true;
        }
        return false;
      };

      $modalStack.isModalFocused = function (evt, modalWindow) {
        if (evt && modalWindow) {
          var modalDomEl = modalWindow.value.modalDomEl;
          if (modalDomEl && modalDomEl.length) {
            return (evt.target || evt.srcElement) === modalDomEl[0];
          }
        }
        return false;
      };

      $modalStack.isFocusInFirstItem = function (evt) {
        if (focusableElementList.length > 0) {
          return (evt.target || evt.srcElement) === focusableElementList[0];
        }
        return false;
      };

      $modalStack.isFocusInLastItem = function (evt) {
        if (focusableElementList.length > 0) {
          return (evt.target || evt.srcElement) === focusableElementList[focusableElementList.length - 1];
        }
        return false;
      };

      $modalStack.clearFocusListCache = function () {
        focusableElementList = [];
        focusIndex = 0;
      };

      $modalStack.loadFocusElementList = function (modalWindow) {
        if (focusableElementList === undefined || !focusableElementList.length) {
          if (modalWindow) {
            var modalDomE1 = modalWindow.value.modalDomEl;
            if (modalDomE1 && modalDomE1.length) {
              focusableElementList = modalDomE1[0].querySelectorAll(tababbleSelector);
            }
          }
        }
      };

      return $modalStack;
    }
  ])

  .provider('$uibModal', function () {
    var $modalProvider = {
      options: {
        animation: true,
        backdrop: true, //can also be false or 'static'
        keyboard: true
      },
      $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack',
        function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
          var $modal = {};

          function getTemplatePromise(options) {
            return options.template ? $q.when(options.template) :
              $templateRequest(angular.isFunction(options.templateUrl) ?
                options.templateUrl() : options.templateUrl);
          }

          var promiseChain = null;
          $modal.getPromiseChain = function () {
            return promiseChain;
          };

          $modal.open = function (modalOptions) {
            var modalResultDeferred = $q.defer();
            var modalOpenedDeferred = $q.defer();
            var modalClosedDeferred = $q.defer();
            var modalRenderDeferred = $q.defer();

            //prepare an instance of a modal to be injected into controllers and returned to a caller
            var modalInstance = {
              result: modalResultDeferred.promise,
              opened: modalOpenedDeferred.promise,
              closed: modalClosedDeferred.promise,
              rendered: modalRenderDeferred.promise,
              close: function (result) {
                return $modalStack.close(modalInstance, result);
              },
              dismiss: function (reason) {
                return $modalStack.dismiss(modalInstance, reason);
              }
            };

            //merge and clean up options
            modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
            modalOptions.resolve = modalOptions.resolve || {};
            modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);

            //verify options
            if (!modalOptions.template && !modalOptions.templateUrl) {
              throw new Error('One of template or templateUrl options is required.');
            }

            var templateAndResolvePromise =
              $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);

            function resolveWithTemplate() {
              return templateAndResolvePromise;
            }

            // Wait for the resolution of the existing promise chain.
            // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
            // Then add to $modalStack and resolve opened.
            // Finally clean up the chain variable if no subsequent modal has overwritten it.
            var samePromise;
            samePromise = promiseChain = $q.all([promiseChain])
              .then(resolveWithTemplate, resolveWithTemplate)
              .then(function resolveSuccess(tplAndVars) {
                var providedScope = modalOptions.scope || $rootScope;

                var modalScope = providedScope.$new();
                modalScope.$close = modalInstance.close;
                modalScope.$dismiss = modalInstance.dismiss;

                modalScope.$on('$destroy', function () {
                  if (!modalScope.$$uibDestructionScheduled) {
                    modalScope.$dismiss('$uibUnscheduledDestruction');
                  }
                });

                var ctrlInstance, ctrlInstantiate, ctrlLocals = {};

                //controllers
                if (modalOptions.controller) {
                  ctrlLocals.$scope = modalScope;
                  ctrlLocals.$uibModalInstance = modalInstance;
                  angular.forEach(tplAndVars[1], function (value, key) {
                    ctrlLocals[key] = value;
                  });

                  // the third param will make the controller instantiate later,private api
                  // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
                  ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true);
                  if (modalOptions.controllerAs) {
                    ctrlInstance = ctrlInstantiate.instance;

                    if (modalOptions.bindToController) {
                      ctrlInstance.$close = modalScope.$close;
                      ctrlInstance.$dismiss = modalScope.$dismiss;
                      angular.extend(ctrlInstance, providedScope);
                    }

                    ctrlInstance = ctrlInstantiate();

                    modalScope[modalOptions.controllerAs] = ctrlInstance;
                  } else {
                    ctrlInstance = ctrlInstantiate();
                  }

                  if (angular.isFunction(ctrlInstance.$onInit)) {
                    ctrlInstance.$onInit();
                  }
                }

                $modalStack.open(modalInstance, {
                  scope: modalScope,
                  deferred: modalResultDeferred,
                  renderDeferred: modalRenderDeferred,
                  closedDeferred: modalClosedDeferred,
                  content: tplAndVars[0],
                  animation: modalOptions.animation,
                  backdrop: modalOptions.backdrop,
                  keyboard: modalOptions.keyboard,
                  backdropClass: modalOptions.backdropClass,
                  windowTopClass: modalOptions.windowTopClass,
                  windowClass: modalOptions.windowClass,
                  windowTemplateUrl: modalOptions.windowTemplateUrl,
                  size: modalOptions.size,
                  openedClass: modalOptions.openedClass,
                  appendTo: modalOptions.appendTo
                });
                modalOpenedDeferred.resolve(true);

              }, function resolveError(reason) {
                modalOpenedDeferred.reject(reason);
                modalResultDeferred.reject(reason);
              })['finally'](function () {
                if (promiseChain === samePromise) {
                  promiseChain = null;
                }
              });

            return modalInstance;
          };

          return $modal;
        }
      ]
    };

    return $modalProvider;
  });

angular.module('ui.bootstrap.paging', [])
  /**
   * Helper internal service for generating common controller code between the
   * pager and pagination components
   */
  .factory('uibPaging', ['$parse', function ($parse) {
    return {
      create: function (ctrl, $scope, $attrs) {
        ctrl.setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
        ctrl.ngModelCtrl = {
          $setViewValue: angular.noop
        }; // nullModelCtrl
        ctrl._watchers = [];

        ctrl.init = function (ngModelCtrl, config) {
          ctrl.ngModelCtrl = ngModelCtrl;
          ctrl.config = config;

          ngModelCtrl.$render = function () {
            ctrl.render();
          };

          if ($attrs.itemsPerPage) {
            ctrl._watchers.push($scope.$parent.$watch($attrs.itemsPerPage, function (value) {
              ctrl.itemsPerPage = parseInt(value, 10);
              $scope.totalPages = ctrl.calculateTotalPages();
              ctrl.updatePage();
            }));
          } else {
            ctrl.itemsPerPage = config.itemsPerPage;
          }

          $scope.$watch('totalItems', function (newTotal, oldTotal) {
            if (angular.isDefined(newTotal) || newTotal !== oldTotal) {
              $scope.totalPages = ctrl.calculateTotalPages();
              ctrl.updatePage();
            }
          });
        };

        ctrl.calculateTotalPages = function () {
          var totalPages = ctrl.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / ctrl.itemsPerPage);
          return Math.max(totalPages || 0, 1);
        };

        ctrl.render = function () {
          $scope.page = parseInt(ctrl.ngModelCtrl.$viewValue, 10) || 1;
        };

        $scope.selectPage = function (page, evt) {
          if (evt) {
            evt.preventDefault();
          }

          var clickAllowed = !$scope.ngDisabled || !evt;
          if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
            if (evt && evt.target) {
              evt.target.blur();
            }
            ctrl.ngModelCtrl.$setViewValue(page);
            ctrl.ngModelCtrl.$render();
          }
        };

        $scope.getText = function (key) {
          return $scope[key + 'Text'] || ctrl.config[key + 'Text'];
        };

        $scope.noPrevious = function () {
          return $scope.page === 1;
        };

        $scope.noNext = function () {
          return $scope.page === $scope.totalPages;
        };

        ctrl.updatePage = function () {
          ctrl.setNumPages($scope.$parent, $scope.totalPages); // Readonly variable

          if ($scope.page > $scope.totalPages) {
            $scope.selectPage($scope.totalPages);
          } else {
            ctrl.ngModelCtrl.$render();
          }
        };

        $scope.$on('$destroy', function () {
          while (ctrl._watchers.length) {
            ctrl._watchers.shift()();
          }
        });
      }
    };
  }]);

angular.module('ui.bootstrap.pager', ['ui.bootstrap.paging'])

  .controller('UibPagerController', ['$scope', '$attrs', 'uibPaging', 'uibPagerConfig', function ($scope, $attrs, uibPaging, uibPagerConfig) {
    $scope.align = angular.isDefined($attrs.align) ? $scope.$parent.$eval($attrs.align) : uibPagerConfig.align;

    uibPaging.create(this, $scope, $attrs);
  }])

  .constant('uibPagerConfig', {
    itemsPerPage: 10,
    previousText: '« Previous',
    nextText: 'Next »',
    align: true
  })

  .directive('uibPager', ['uibPagerConfig', function (uibPagerConfig) {
    return {
      scope: {
        totalItems: '=',
        previousText: '@',
        nextText: '@',
        ngDisabled: '='
      },
      require: ['uibPager', '?ngModel'],
      controller: 'UibPagerController',
      controllerAs: 'pager',
      templateUrl: function (element, attrs) {
        return attrs.templateUrl || 'uib/template/pager/pager.html';
      },
      replace: true,
      link: function (scope, element, attrs, ctrls) {
        var paginationCtrl = ctrls[0],
          ngModelCtrl = ctrls[1];

        if (!ngModelCtrl) {
          return; // do nothing if no ng-model
        }

        paginationCtrl.init(ngModelCtrl, uibPagerConfig);
      }
    };
  }]);

angular.module('ui.bootstrap.pagination', ['ui.bootstrap.paging'])
  .controller('UibPaginationController', ['$scope', '$attrs', '$parse', 'uibPaging', 'uibPaginationConfig', function ($scope, $attrs, $parse, uibPaging, uibPaginationConfig) {
    var ctrl = this;
    // Setup configuration parameters
    var maxSize = angular.isDefined($attrs.maxSize) ? $scope.$parent.$eval($attrs.maxSize) : uibPaginationConfig.maxSize,
      rotate = angular.isDefined($attrs.rotate) ? $scope.$parent.$eval($attrs.rotate) : uibPaginationConfig.rotate,
      forceEllipses = angular.isDefined($attrs.forceEllipses) ? $scope.$parent.$eval($attrs.forceEllipses) : uibPaginationConfig.forceEllipses,
      boundaryLinkNumbers = angular.isDefined($attrs.boundaryLinkNumbers) ? $scope.$parent.$eval($attrs.boundaryLinkNumbers) : uibPaginationConfig.boundaryLinkNumbers,
      pageLabel = angular.isDefined($attrs.pageLabel) ? function (idx) {
        return $scope.$parent.$eval($attrs.pageLabel, {
          $page: idx
        });
      } : angular.identity;
    $scope.boundaryLinks = angular.isDefined($attrs.boundaryLinks) ? $scope.$parent.$eval($attrs.boundaryLinks) : uibPaginationConfig.boundaryLinks;
    $scope.directionLinks = angular.isDefined($attrs.directionLinks) ? $scope.$parent.$eval($attrs.directionLinks) : uibPaginationConfig.directionLinks;

    uibPaging.create(this, $scope, $attrs);

    if ($attrs.maxSize) {
      ctrl._watchers.push($scope.$parent.$watch($parse($attrs.maxSize), function (value) {
        maxSize = parseInt(value, 10);
        ctrl.render();
      }));
    }

    // Create page object used in template
    function makePage(number, text, isActive) {
      return {
        number: number,
        text: text,
        active: isActive
      };
    }

    function getPages(currentPage, totalPages) {
      var pages = [];

      // Default page limits
      var startPage = 1,
        endPage = totalPages;
      var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;

      // recompute if maxSize
      if (isMaxSized) {
        if (rotate) {
          // Current page is displayed in the middle of the visible ones
          startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
          endPage = startPage + maxSize - 1;

          // Adjust if limit is exceeded
          if (endPage > totalPages) {
            endPage = totalPages;
            startPage = endPage - maxSize + 1;
          }
        } else {
          // Visible pages are paginated with maxSize
          startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;

          // Adjust last page if limit is exceeded
          endPage = Math.min(startPage + maxSize - 1, totalPages);
        }
      }

      // Add page number links
      for (var number = startPage; number <= endPage; number++) {
        var page = makePage(number, pageLabel(number), number === currentPage);
        pages.push(page);
      }

      // Add links to move between page sets
      if (isMaxSized && maxSize > 0 && (!rotate || forceEllipses || boundaryLinkNumbers)) {
        if (startPage > 1) {
          if (!boundaryLinkNumbers || startPage > 3) { //need ellipsis for all options unless range is too close to beginning
            var previousPageSet = makePage(startPage - 1, '...', false);
            pages.unshift(previousPageSet);
          }
          if (boundaryLinkNumbers) {
            if (startPage === 3) { //need to replace ellipsis when the buttons would be sequential
              var secondPageLink = makePage(2, '2', false);
              pages.unshift(secondPageLink);
            }
            //add the first page
            var firstPageLink = makePage(1, '1', false);
            pages.unshift(firstPageLink);
          }
        }

        if (endPage < totalPages) {
          if (!boundaryLinkNumbers || endPage < totalPages - 2) { //need ellipsis for all options unless range is too close to end
            var nextPageSet = makePage(endPage + 1, '...', false);
            pages.push(nextPageSet);
          }
          if (boundaryLinkNumbers) {
            if (endPage === totalPages - 2) { //need to replace ellipsis when the buttons would be sequential
              var secondToLastPageLink = makePage(totalPages - 1, totalPages - 1, false);
              pages.push(secondToLastPageLink);
            }
            //add the last page
            var lastPageLink = makePage(totalPages, totalPages, false);
            pages.push(lastPageLink);
          }
        }
      }
      return pages;
    }

    var originalRender = this.render;
    this.render = function () {
      originalRender();
      if ($scope.page > 0 && $scope.page <= $scope.totalPages) {
        $scope.pages = getPages($scope.page, $scope.totalPages);
      }
    };
  }])

  .constant('uibPaginationConfig', {
    itemsPerPage: 100,
    boundaryLinks: false,
    boundaryLinkNumbers: false,
    directionLinks: true,
    firstText: 'First',
    previousText: 'Previous',
    nextText: 'Next',
    lastText: 'Last',
    rotate: true,
    forceEllipses: false
  })

  .directive('uibPagination', ['$parse', 'uibPaginationConfig', function ($parse, uibPaginationConfig) {
    return {
      scope: {
        totalItems: '=',
        firstText: '@',
        previousText: '@',
        nextText: '@',
        lastText: '@',
        ngDisabled: '='
      },
      require: ['uibPagination', '?ngModel'],
      controller: 'UibPaginationController',
      controllerAs: 'pagination',
      templateUrl: function (element, attrs) {
        return attrs.templateUrl || 'uib/template/pagination/pagination.html';
      },
      replace: true,
      link: function (scope, element, attrs, ctrls) {
        var paginationCtrl = ctrls[0],
          ngModelCtrl = ctrls[1];

        if (!ngModelCtrl) {
          return; // do nothing if no ng-model
        }

        paginationCtrl.init(ngModelCtrl, uibPaginationConfig);
      }
    };
  }]);

/**
 * The following features are still outstanding: animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, html tooltips, and selector delegation.
 */
angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.stackedMap'])

  /**
   * The $tooltip service creates tooltip- and popover-like directives as well as
   * houses global options for them.
   */
  .provider('$uibTooltip', function () {
    // The default options tooltip and popover.
    var defaultOptions = {
      placement: 'top',
      placementClassPrefix: '',
      animation: true,
      popupDelay: 0,
      popupCloseDelay: 0,
      useContentExp: false
    };

    // Default hide triggers for each show trigger
    var triggerMap = {
      'mouseenter': 'mouseleave',
      'click': 'click',
      'outsideClick': 'outsideClick',
      'focus': 'blur',
      'none': ''
    };

    // The options specified to the provider globally.
    var globalOptions = {};

    /**
     * `options({})` allows global configuration of all tooltips in the
     * application.
     *
     *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
     *     // place tooltips left instead of top by default
     *     $tooltipProvider.options( { placement: 'left' } );
     *   });
     */
    this.options = function (value) {
      angular.extend(globalOptions, value);
    };

    /**
     * This allows you to extend the set of trigger mappings available. E.g.:
     *
     *   $tooltipProvider.setTriggers( 'openTrigger': 'closeTrigger' );
     */
    this.setTriggers = function setTriggers(triggers) {
      angular.extend(triggerMap, triggers);
    };

    /**
     * This is a helper function for translating camel-case to snake_case.
     */
    function snake_case(name) {
      var regexp = /[A-Z]/g;
      var separator = '-';
      return name.replace(regexp, function (letter, pos) {
        return (pos ? separator : '') + letter.toLowerCase();
      });
    }

    /**
     * Returns the actual instance of the $tooltip service.
     * TODO support multiple triggers
     */
    this.$get = ['$window', '$compile', '$timeout', '$document', '$uibPosition', '$interpolate', '$rootScope', '$parse', '$$stackedMap', function ($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse, $$stackedMap) {
      var openedTooltips = $$stackedMap.createNew();
      $document.on('keypress', keypressListener);

      $rootScope.$on('$destroy', function () {
        $document.off('keypress', keypressListener);
      });

      function keypressListener(e) {
        if (e.which === 27) {
          var last = openedTooltips.top();
          if (last) {
            last.value.close();
            openedTooltips.removeTop();
            last = null;
          }
        }
      }

      return function $tooltip(ttType, prefix, defaultTriggerShow, options) {
        options = angular.extend({}, defaultOptions, globalOptions, options);

        /**
         * Returns an object of show and hide triggers.
         *
         * If a trigger is supplied,
         * it is used to show the tooltip; otherwise, it will use the `trigger`
         * option passed to the `$tooltipProvider.options` method; else it will
         * default to the trigger supplied to this directive factory.
         *
         * The hide trigger is based on the show trigger. If the `trigger` option
         * was passed to the `$tooltipProvider.options` method, it will use the
         * mapped trigger from `triggerMap` or the passed trigger if the map is
         * undefined; otherwise, it uses the `triggerMap` value of the show
         * trigger; else it will just use the show trigger.
         */
        function getTriggers(trigger) {
          var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
          var hide = show.map(function (trigger) {
            return triggerMap[trigger] || trigger;
          });
          return {
            show: show,
            hide: hide
          };
        }

        var directiveName = snake_case(ttType);

        var startSym = $interpolate.startSymbol();
        var endSym = $interpolate.endSymbol();
        var template =
          '<div ' + directiveName + '-popup ' +
          'title="' + startSym + 'title' + endSym + '" ' +
          (options.useContentExp ?
            'content-exp="contentExp()" ' :
            'content="' + startSym + 'content' + endSym + '" ') +
          'placement="' + startSym + 'placement' + endSym + '" ' +
          'popup-class="' + startSym + 'popupClass' + endSym + '" ' +
          'animation="animation" ' +
          'is-open="isOpen"' +
          'origin-scope="origScope" ' +
          'class="uib-position-measure"' +
          '>' +
          '</div>';

        return {
          compile: function (tElem, tAttrs) {
            var tooltipLinker = $compile(template);

            return function link(scope, element, attrs, tooltipCtrl) {
              var tooltip;
              var tooltipLinkedScope;
              var transitionTimeout;
              var showTimeout;
              var hideTimeout;
              var positionTimeout;
              var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
              var triggers = getTriggers(undefined);
              var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
              var ttScope = scope.$new(true);
              var repositionScheduled = false;
              var isOpenParse = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;
              var contentParse = options.useContentExp ? $parse(attrs[ttType]) : false;
              var observers = [];
              var lastPlacement;

              var positionTooltip = function () {
                // check if tooltip exists and is not empty
                if (!tooltip || !tooltip.html()) {
                  return;
                }

                if (!positionTimeout) {
                  positionTimeout = $timeout(function () {
                    var ttPosition = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
                    tooltip.css({
                      top: ttPosition.top + 'px',
                      left: ttPosition.left + 'px'
                    });

                    if (!tooltip.hasClass(ttPosition.placement.split('-')[0])) {
                      tooltip.removeClass(lastPlacement.split('-')[0]);
                      tooltip.addClass(ttPosition.placement.split('-')[0]);
                    }

                    if (!tooltip.hasClass(options.placementClassPrefix + ttPosition.placement)) {
                      tooltip.removeClass(options.placementClassPrefix + lastPlacement);
                      tooltip.addClass(options.placementClassPrefix + ttPosition.placement);
                    }

                    // first time through tt element will have the
                    // uib-position-measure class or if the placement
                    // has changed we need to position the arrow.
                    if (tooltip.hasClass('uib-position-measure')) {
                      $position.positionArrow(tooltip, ttPosition.placement);
                      tooltip.removeClass('uib-position-measure');
                    } else if (lastPlacement !== ttPosition.placement) {
                      $position.positionArrow(tooltip, ttPosition.placement);
                    }
                    lastPlacement = ttPosition.placement;

                    positionTimeout = null;
                  }, 0, false);
                }
              };

              // Set up the correct scope to allow transclusion later
              ttScope.origScope = scope;

              // By default, the tooltip is not open.
              // TODO add ability to start tooltip opened
              ttScope.isOpen = false;
              openedTooltips.add(ttScope, {
                close: hide
              });

              function toggleTooltipBind() {
                if (!ttScope.isOpen) {
                  showTooltipBind();
                } else {
                  hideTooltipBind();
                }
              }

              // Show the tooltip with delay if specified, otherwise show it immediately
              function showTooltipBind() {
                if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
                  return;
                }

                cancelHide();
                prepareTooltip();

                if (ttScope.popupDelay) {
                  // Do nothing if the tooltip was already scheduled to pop-up.
                  // This happens if show is triggered multiple times before any hide is triggered.
                  if (!showTimeout) {
                    showTimeout = $timeout(show, ttScope.popupDelay, false);
                  }
                } else {
                  show();
                }
              }

              function hideTooltipBind() {
                cancelShow();

                if (ttScope.popupCloseDelay) {
                  if (!hideTimeout) {
                    hideTimeout = $timeout(hide, ttScope.popupCloseDelay, false);
                  }
                } else {
                  hide();
                }
              }

              // Show the tooltip popup element.
              function show() {
                cancelShow();
                cancelHide();

                // Don't show empty tooltips.
                if (!ttScope.content) {
                  return angular.noop;
                }

                createTooltip();

                // And show the tooltip.
                ttScope.$evalAsync(function () {
                  ttScope.isOpen = true;
                  assignIsOpen(true);
                  positionTooltip();
                });
              }

              function cancelShow() {
                if (showTimeout) {
                  $timeout.cancel(showTimeout);
                  showTimeout = null;
                }

                if (positionTimeout) {
                  $timeout.cancel(positionTimeout);
                  positionTimeout = null;
                }
              }

              // Hide the tooltip popup element.
              function hide() {
                if (!ttScope) {
                  return;
                }

                // First things first: we don't show it anymore.
                ttScope.$evalAsync(function () {
                  if (ttScope) {
                    ttScope.isOpen = false;
                    assignIsOpen(false);
                    // And now we remove it from the DOM. However, if we have animation, we
                    // need to wait for it to expire beforehand.
                    // FIXME: this is a placeholder for a port of the transitions library.
                    // The fade transition in TWBS is 150ms.
                    if (ttScope.animation) {
                      if (!transitionTimeout) {
                        transitionTimeout = $timeout(removeTooltip, 150, false);
                      }
                    } else {
                      removeTooltip();
                    }
                  }
                });
              }

              function cancelHide() {
                if (hideTimeout) {
                  $timeout.cancel(hideTimeout);
                  hideTimeout = null;
                }

                if (transitionTimeout) {
                  $timeout.cancel(transitionTimeout);
                  transitionTimeout = null;
                }
              }

              function createTooltip() {
                // There can only be one tooltip element per directive shown at once.
                if (tooltip) {
                  return;
                }

                tooltipLinkedScope = ttScope.$new();
                tooltip = tooltipLinker(tooltipLinkedScope, function (tooltip) {
                  if (appendToBody) {
                    $document.find('body').append(tooltip);
                  } else {
                    element.after(tooltip);
                  }
                });

                prepObservers();
              }

              function removeTooltip() {
                cancelShow();
                cancelHide();
                unregisterObservers();

                if (tooltip) {
                  tooltip.remove();
                  tooltip = null;
                }
                if (tooltipLinkedScope) {
                  tooltipLinkedScope.$destroy();
                  tooltipLinkedScope = null;
                }
              }

              /**
               * Set the initial scope values. Once
               * the tooltip is created, the observers
               * will be added to keep things in sync.
               */
              function prepareTooltip() {
                ttScope.title = attrs[prefix + 'Title'];
                if (contentParse) {
                  ttScope.content = contentParse(scope);
                } else {
                  ttScope.content = attrs[ttType];
                }

                ttScope.popupClass = attrs[prefix + 'Class'];
                ttScope.placement = angular.isDefined(attrs[prefix + 'Placement']) ? attrs[prefix + 'Placement'] : options.placement;
                var placement = $position.parsePlacement(ttScope.placement);
                lastPlacement = placement[1] ? placement[0] + '-' + placement[1] : placement[0];

                var delay = parseInt(attrs[prefix + 'PopupDelay'], 10);
                var closeDelay = parseInt(attrs[prefix + 'PopupCloseDelay'], 10);
                ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
                ttScope.popupCloseDelay = !isNaN(closeDelay) ? closeDelay : options.popupCloseDelay;
              }

              function assignIsOpen(isOpen) {
                if (isOpenParse && angular.isFunction(isOpenParse.assign)) {
                  isOpenParse.assign(scope, isOpen);
                }
              }

              ttScope.contentExp = function () {
                return ttScope.content;
              };

              /**
               * Observe the relevant attributes.
               */
              attrs.$observe('disabled', function (val) {
                if (val) {
                  cancelShow();
                }

                if (val && ttScope.isOpen) {
                  hide();
                }
              });

              if (isOpenParse) {
                scope.$watch(isOpenParse, function (val) {
                  if (ttScope && !val === ttScope.isOpen) {
                    toggleTooltipBind();
                  }
                });
              }

              function prepObservers() {
                observers.length = 0;

                if (contentParse) {
                  observers.push(
                    scope.$watch(contentParse, function (val) {
                      ttScope.content = val;
                      if (!val && ttScope.isOpen) {
                        hide();
                      }
                    })
                  );

                  observers.push(
                    tooltipLinkedScope.$watch(function () {
                      if (!repositionScheduled) {
                        repositionScheduled = true;
                        tooltipLinkedScope.$$postDigest(function () {
                          repositionScheduled = false;
                          if (ttScope && ttScope.isOpen) {
                            positionTooltip();
                          }
                        });
                      }
                    })
                  );
                } else {
                  observers.push(
                    attrs.$observe(ttType, function (val) {
                      ttScope.content = val;
                      if (!val && ttScope.isOpen) {
                        hide();
                      } else {
                        positionTooltip();
                      }
                    })
                  );
                }

                observers.push(
                  attrs.$observe(prefix + 'Title', function (val) {
                    ttScope.title = val;
                    if (ttScope.isOpen) {
                      positionTooltip();
                    }
                  })
                );

                observers.push(
                  attrs.$observe(prefix + 'Placement', function (val) {
                    ttScope.placement = val ? val : options.placement;
                    var placement = $position.parsePlacement(ttScope.placement);
                    lastPlacement = placement[1] ? placement[0] + '-' + placement[1] : placement[0];
                    if (ttScope.isOpen) {
                      positionTooltip();
                    }
                  })
                );
              }

              function unregisterObservers() {
                if (observers.length) {
                  angular.forEach(observers, function (observer) {
                    observer();
                  });
                  observers.length = 0;
                }
              }

              // hide tooltips/popovers for outsideClick trigger
              function bodyHideTooltipBind(e) {
                if (!ttScope || !ttScope.isOpen || !tooltip) {
                  return;
                }
                // make sure the tooltip/popover link or tool tooltip/popover itself were not clicked
                if (!element[0].contains(e.target) && !tooltip[0].contains(e.target)) {
                  hideTooltipBind();
                }
              }

              var unregisterTriggers = function () {
                triggers.show.forEach(function (trigger) {
                  if (trigger === 'outsideClick') {
                    element.off('click', toggleTooltipBind);
                  } else {
                    element.off(trigger, showTooltipBind);
                    element.off(trigger, toggleTooltipBind);
                  }
                });
                triggers.hide.forEach(function (trigger) {
                  if (trigger === 'outsideClick') {
                    $document.off('click', bodyHideTooltipBind);
                  } else {
                    element.off(trigger, hideTooltipBind);
                  }
                });
              };

              function prepTriggers() {
                var val = attrs[prefix + 'Trigger'];
                unregisterTriggers();

                triggers = getTriggers(val);

                if (triggers.show !== 'none') {
                  triggers.show.forEach(function (trigger, idx) {
                    if (trigger === 'outsideClick') {
                      element.on('click', toggleTooltipBind);
                      $document.on('click', bodyHideTooltipBind);
                    } else if (trigger === triggers.hide[idx]) {
                      element.on(trigger, toggleTooltipBind);
                    } else if (trigger) {
                      element.on(trigger, showTooltipBind);
                      element.on(triggers.hide[idx], hideTooltipBind);
                    }

                    element.on('keypress', function (e) {
                      if (e.which === 27) {
                        hideTooltipBind();
                      }
                    });
                  });
                }
              }

              prepTriggers();

              var animation = scope.$eval(attrs[prefix + 'Animation']);
              ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;

              var appendToBodyVal;
              var appendKey = prefix + 'AppendToBody';
              if (appendKey in attrs && attrs[appendKey] === undefined) {
                appendToBodyVal = true;
              } else {
                appendToBodyVal = scope.$eval(attrs[appendKey]);
              }

              appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;

              // Make sure tooltip is destroyed and removed.
              scope.$on('$destroy', function onDestroyTooltip() {
                unregisterTriggers();
                removeTooltip();
                openedTooltips.remove(ttScope);
                ttScope = null;
              });
            };
          }
        };
      };
    }];
  })

  // This is mostly ngInclude code but with a custom scope
  .directive('uibTooltipTemplateTransclude', [
    '$animate', '$sce', '$compile', '$templateRequest',
    function ($animate, $sce, $compile, $templateRequest) {
      return {
        link: function (scope, elem, attrs) {
          var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);

          var changeCounter = 0,
            currentScope,
            previousElement,
            currentElement;

          var cleanupLastIncludeContent = function () {
            if (previousElement) {
              previousElement.remove();
              previousElement = null;
            }

            if (currentScope) {
              currentScope.$destroy();
              currentScope = null;
            }

            if (currentElement) {
              $animate.leave(currentElement).then(function () {
                previousElement = null;
              });
              previousElement = currentElement;
              currentElement = null;
            }
          };

          scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude), function (src) {
            var thisChangeId = ++changeCounter;

            if (src) {
              //set the 2nd param to true to ignore the template request error so that the inner
              //contents and scope can be cleaned up.
              $templateRequest(src, true).then(function (response) {
                if (thisChangeId !== changeCounter) {
                  return;
                }
                var newScope = origScope.$new();
                var template = response;

                var clone = $compile(template)(newScope, function (clone) {
                  cleanupLastIncludeContent();
                  $animate.enter(clone, elem);
                });

                currentScope = newScope;
                currentElement = clone;

                currentScope.$emit('$includeContentLoaded', src);
              }, function () {
                if (thisChangeId === changeCounter) {
                  cleanupLastIncludeContent();
                  scope.$emit('$includeContentError', src);
                }
              });
              scope.$emit('$includeContentRequested', src);
            } else {
              cleanupLastIncludeContent();
            }
          });

          scope.$on('$destroy', cleanupLastIncludeContent);
        }
      };
    }
  ])

  /**
   * Note that it's intentional that these classes are *not* applied through $animate.
   * They must not be animated as they're expected to be present on the tooltip on
   * initialization.
   */
  .directive('uibTooltipClasses', ['$uibPosition', function ($uibPosition) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        // need to set the primary position so the
        // arrow has space during position measure.
        // tooltip.positionTooltip()
        if (scope.placement) {
          // // There are no top-left etc... classes
          // // in TWBS, so we need the primary position.
          var position = $uibPosition.parsePlacement(scope.placement);
          element.addClass(position[0]);
        }

        if (scope.popupClass) {
          element.addClass(scope.popupClass);
        }

        if (scope.animation()) {
          element.addClass(attrs.tooltipAnimationClass);
        }
      }
    };
  }])

  .directive('uibTooltipPopup', function () {
    return {
      replace: true,
      scope: {
        content: '@',
        placement: '@',
        popupClass: '@',
        animation: '&',
        isOpen: '&'
      },
      templateUrl: 'uib/template/tooltip/tooltip-popup.html'
    };
  })

  .directive('uibTooltip', ['$uibTooltip', function ($uibTooltip) {
    return $uibTooltip('uibTooltip', 'tooltip', 'mouseenter');
  }])

  .directive('uibTooltipTemplatePopup', function () {
    return {
      replace: true,
      scope: {
        contentExp: '&',
        placement: '@',
        popupClass: '@',
        animation: '&',
        isOpen: '&',
        originScope: '&'
      },
      templateUrl: 'uib/template/tooltip/tooltip-template-popup.html'
    };
  })

  .directive('uibTooltipTemplate', ['$uibTooltip', function ($uibTooltip) {
    return $uibTooltip('uibTooltipTemplate', 'tooltip', 'mouseenter', {
      useContentExp: true
    });
  }])

  .directive('uibTooltipHtmlPopup', function () {
    return {
      replace: true,
      scope: {
        contentExp: '&',
        placement: '@',
        popupClass: '@',
        animation: '&',
        isOpen: '&'
      },
      templateUrl: 'uib/template/tooltip/tooltip-html-popup.html'
    };
  })

  .directive('uibTooltipHtml', ['$uibTooltip', function ($uibTooltip) {
    return $uibTooltip('uibTooltipHtml', 'tooltip', 'mouseenter', {
      useContentExp: true
    });
  }]);

/**
 * The following features are still outstanding: popup delay, animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, and selector delegatation.
 */
angular.module('ui.bootstrap.popover', ['ui.bootstrap.tooltip'])

  .directive('uibPopoverTemplatePopup', function () {
    return {
      replace: true,
      scope: {
        title: '@',
        contentExp: '&',
        placement: '@',
        popupClass: '@',
        animation: '&',
        isOpen: '&',
        originScope: '&'
      },
      templateUrl: 'uib/template/popover/popover-template.html'
    };
  })

  .directive('uibPopoverTemplate', ['$uibTooltip', function ($uibTooltip) {
    return $uibTooltip('uibPopoverTemplate', 'popover', 'click', {
      useContentExp: true
    });
  }])

  .directive('uibPopoverHtmlPopup', function () {
    return {
      replace: true,
      scope: {
        contentExp: '&',
        title: '@',
        placement: '@',
        popupClass: '@',
        animation: '&',
        isOpen: '&'
      },
      templateUrl: 'uib/template/popover/popover-html.html'
    };
  })

  .directive('uibPopoverHtml', ['$uibTooltip', function ($uibTooltip) {
    return $uibTooltip('uibPopoverHtml', 'popover', 'click', {
      useContentExp: true
    });
  }])

  .directive('uibPopoverPopup', function () {
    return {
      replace: true,
      scope: {
        title: '@',
        content: '@',
        placement: '@',
        popupClass: '@',
        animation: '&',
        isOpen: '&'
      },
      templateUrl: 'uib/template/popover/popover.html'
    };
  })

  .directive('uibPopover', ['$uibTooltip', function ($uibTooltip) {
    return $uibTooltip('uibPopover', 'popover', 'click');
  }]);

angular.module('ui.bootstrap.progressbar', [])

  .constant('uibProgressConfig', {
    animate: true,
    max: 100
  })

  .controller('UibProgressController', ['$scope', '$attrs', 'uibProgressConfig', function ($scope, $attrs, progressConfig) {
    var self = this,
      animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;

    this.bars = [];
    $scope.max = getMaxOrDefault();

    this.addBar = function (bar, element, attrs) {
      if (!animate) {
        element.css({
          'transition': 'none'
        });
      }

      this.bars.push(bar);

      bar.max = getMaxOrDefault();
      bar.title = attrs && angular.isDefined(attrs.title) ? attrs.title : 'progressbar';

      bar.$watch('value', function (value) {
        bar.recalculatePercentage();
      });

      bar.recalculatePercentage = function () {
        var totalPercentage = self.bars.reduce(function (total, bar) {
          bar.percent = +(100 * bar.value / bar.max).toFixed(2);
          return total + bar.percent;
        }, 0);

        if (totalPercentage > 100) {
          bar.percent -= totalPercentage - 100;
        }
      };

      bar.$on('$destroy', function () {
        element = null;
        self.removeBar(bar);
      });
    };

    this.removeBar = function (bar) {
      this.bars.splice(this.bars.indexOf(bar), 1);
      this.bars.forEach(function (bar) {
        bar.recalculatePercentage();
      });
    };

    //$attrs.$observe('maxParam', function(maxParam) {
    $scope.$watch('maxParam', function (maxParam) {
      self.bars.forEach(function (bar) {
        bar.max = getMaxOrDefault();
        bar.recalculatePercentage();
      });
    });

    function getMaxOrDefault() {
      return angular.isDefined($scope.maxParam) ? $scope.maxParam : progressConfig.max;
    }
  }])

  .directive('uibProgress', function () {
    return {
      replace: true,
      transclude: true,
      controller: 'UibProgressController',
      require: 'uibProgress',
      scope: {
        maxParam: '=?max'
      },
      templateUrl: 'uib/template/progressbar/progress.html'
    };
  })

  .directive('uibBar', function () {
    return {
      replace: true,
      transclude: true,
      require: '^uibProgress',
      scope: {
        value: '=',
        type: '@'
      },
      templateUrl: 'uib/template/progressbar/bar.html',
      link: function (scope, element, attrs, progressCtrl) {
        progressCtrl.addBar(scope, element, attrs);
      }
    };
  })

  .directive('uibProgressbar', function () {
    return {
      replace: true,
      transclude: true,
      controller: 'UibProgressController',
      scope: {
        value: '=',
        maxParam: '=?max',
        type: '@'
      },
      templateUrl: 'uib/template/progressbar/progressbar.html',
      link: function (scope, element, attrs, progressCtrl) {
        progressCtrl.addBar(scope, angular.element(element.children()[0]), {
          title: attrs.title
        });
      }
    };
  });

angular.module('ui.bootstrap.rating', [])

  .constant('uibRatingConfig', {
    max: 5,
    stateOn: null,
    stateOff: null,
    titles: ['one', 'two', 'three', 'four', 'five']
  })

  .controller('UibRatingController', ['$scope', '$attrs', 'uibRatingConfig', function ($scope, $attrs, ratingConfig) {
    var ngModelCtrl = {
        $setViewValue: angular.noop
      },
      self = this;

    this.init = function (ngModelCtrl_) {
      ngModelCtrl = ngModelCtrl_;
      ngModelCtrl.$render = this.render;

      ngModelCtrl.$formatters.push(function (value) {
        if (angular.isNumber(value) && value << 0 !== value) {
          value = Math.round(value);
        }

        return value;
      });

      this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
      this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;
      var tmpTitles = angular.isDefined($attrs.titles) ? $scope.$parent.$eval($attrs.titles) : ratingConfig.titles;
      this.titles = angular.isArray(tmpTitles) && tmpTitles.length > 0 ?
        tmpTitles : ratingConfig.titles;

      var ratingStates = angular.isDefined($attrs.ratingStates) ?
        $scope.$parent.$eval($attrs.ratingStates) :
        new Array(angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max);
      $scope.range = this.buildTemplateObjects(ratingStates);
    };

    this.buildTemplateObjects = function (states) {
      for (var i = 0, n = states.length; i < n; i++) {
        states[i] = angular.extend({
          index: i
        }, {
          stateOn: this.stateOn,
          stateOff: this.stateOff,
          title: this.getTitle(i)
        }, states[i]);
      }
      return states;
    };

    this.getTitle = function (index) {
      if (index >= this.titles.length) {
        return index + 1;
      }

      return this.titles[index];
    };

    $scope.rate = function (value) {
      if (!$scope.readonly && value >= 0 && value <= $scope.range.length) {
        ngModelCtrl.$setViewValue(ngModelCtrl.$viewValue === value ? 0 : value);
        ngModelCtrl.$render();
      }
    };

    $scope.enter = function (value) {
      if (!$scope.readonly) {
        $scope.value = value;
      }
      $scope.onHover({
        value: value
      });
    };

    $scope.reset = function () {
      $scope.value = ngModelCtrl.$viewValue;
      $scope.onLeave();
    };

    $scope.onKeydown = function (evt) {
      if (/(37|38|39|40)/.test(evt.which)) {
        evt.preventDefault();
        evt.stopPropagation();
        $scope.rate($scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1));
      }
    };

    this.render = function () {
      $scope.value = ngModelCtrl.$viewValue;
      $scope.title = self.getTitle($scope.value - 1);
    };
  }])

  .directive('uibRating', function () {
    return {
      require: ['uibRating', 'ngModel'],
      scope: {
        readonly: '=?readOnly',
        onHover: '&',
        onLeave: '&'
      },
      controller: 'UibRatingController',
      templateUrl: 'uib/template/rating/rating.html',
      replace: true,
      link: function (scope, element, attrs, ctrls) {
        var ratingCtrl = ctrls[0],
          ngModelCtrl = ctrls[1];
        ratingCtrl.init(ngModelCtrl);
      }
    };
  });

angular.module('ui.bootstrap.tabs', [])

  .controller('UibTabsetController', ['$scope', function ($scope) {
    var ctrl = this,
      oldIndex;
    ctrl.tabs = [];

    ctrl.select = function (index) {
      if (!destroyed) {
        var previousIndex = findTabIndex(oldIndex);
        var previousSelected = ctrl.tabs[previousIndex];
        if (previousSelected) {
          previousSelected.tab.onDeselect();
          previousSelected.tab.active = false;
        }

        var selected = ctrl.tabs[index];
        if (selected) {
          selected.tab.onSelect();
          selected.tab.active = true;
          ctrl.active = selected.index;
          oldIndex = selected.index;
        } else if (!selected && angular.isNumber(oldIndex)) {
          ctrl.active = null;
          oldIndex = null;
        }
      }
    };

    ctrl.addTab = function addTab(tab) {
      ctrl.tabs.push({
        tab: tab,
        index: tab.index
      });
      ctrl.tabs.sort(function (t1, t2) {
        if (t1.index > t2.index) {
          return 1;
        }

        if (t1.index < t2.index) {
          return -1;
        }

        return 0;
      });

      if (tab.index === ctrl.active || !angular.isNumber(ctrl.active) && ctrl.tabs.length === 1) {
        var newActiveIndex = findTabIndex(tab.index);
        ctrl.select(newActiveIndex);
      }
    };

    ctrl.removeTab = function removeTab(tab) {
      var index = findTabIndex(tab.index);

      if (tab.index === ctrl.active) {
        var newActiveTabIndex = index === ctrl.tabs.length - 1 ?
          index - 1 : index + 1 % ctrl.tabs.length;
        ctrl.select(newActiveTabIndex);
      }

      ctrl.tabs.splice(index, 1);
    };

    $scope.$watch('tabset.active', function (val) {
      if (angular.isNumber(val) && val !== oldIndex) {
        ctrl.select(findTabIndex(val));
      }
    });

    var destroyed;
    $scope.$on('$destroy', function () {
      destroyed = true;
    });

    function findTabIndex(index) {
      for (var i = 0; i < ctrl.tabs.length; i++) {
        if (ctrl.tabs[i].index === index) {
          return i;
        }
      }
    }
  }])

  .directive('uibTabset', function () {
    return {
      transclude: true,
      replace: true,
      scope: {},
      bindToController: {
        active: '=?',
        type: '@'
      },
      controller: 'UibTabsetController',
      controllerAs: 'tabset',
      templateUrl: function (element, attrs) {
        return attrs.templateUrl || 'uib/template/tabs/tabset.html';
      },
      link: function (scope, element, attrs) {
        scope.vertical = angular.isDefined(attrs.vertical) ?
          scope.$parent.$eval(attrs.vertical) : false;
        scope.justified = angular.isDefined(attrs.justified) ?
          scope.$parent.$eval(attrs.justified) : false;
        if (angular.isUndefined(attrs.active)) {
          scope.active = 0;
        }
      }
    };
  })

  .directive('uibTab', ['$parse', function ($parse) {
    return {
      require: '^uibTabset',
      replace: true,
      templateUrl: function (element, attrs) {
        return attrs.templateUrl || 'uib/template/tabs/tab.html';
      },
      transclude: true,
      scope: {
        heading: '@',
        index: '=?',
        classes: '@?',
        onSelect: '&select', //This callback is called in contentHeadingTransclude
        //once it inserts the tab's content into the dom
        onDeselect: '&deselect'
      },
      controller: function () {
        //Empty controller so other directives can require being 'under' a tab
      },
      controllerAs: 'tab',
      link: function (scope, elm, attrs, tabsetCtrl, transclude) {
        scope.disabled = false;
        if (attrs.disable) {
          scope.$parent.$watch($parse(attrs.disable), function (value) {
            scope.disabled = !!value;
          });
        }

        if (angular.isUndefined(attrs.index)) {
          if (tabsetCtrl.tabs && tabsetCtrl.tabs.length) {
            scope.index = Math.max.apply(null, tabsetCtrl.tabs.map(function (t) {
              return t.index;
            })) + 1;
          } else {
            scope.index = 0;
          }
        }

        if (angular.isUndefined(attrs.classes)) {
          scope.classes = '';
        }

        scope.select = function () {
          if (!scope.disabled) {
            var index;
            for (var i = 0; i < tabsetCtrl.tabs.length; i++) {
              if (tabsetCtrl.tabs[i].tab === scope) {
                index = i;
                break;
              }
            }

            tabsetCtrl.select(index);
          }
        };

        tabsetCtrl.addTab(scope);
        scope.$on('$destroy', function () {
          tabsetCtrl.removeTab(scope);
        });

        //We need to transclude later, once the content container is ready.
        //when this link happens, we're inside a tab heading.
        scope.$transcludeFn = transclude;
      }
    };
  }])

  .directive('uibTabHeadingTransclude', function () {
    return {
      restrict: 'A',
      require: '^uibTab',
      link: function (scope, elm) {
        scope.$watch('headingElement', function updateHeadingElement(heading) {
          if (heading) {
            elm.html('');
            elm.append(heading);
          }
        });
      }
    };
  })

  .directive('uibTabContentTransclude', function () {
    return {
      restrict: 'A',
      require: '^uibTabset',
      link: function (scope, elm, attrs) {
        var tab = scope.$eval(attrs.uibTabContentTransclude).tab;

        //Now our tab is ready to be transcluded: both the tab heading area
        //and the tab content area are loaded.  Transclude 'em both.
        tab.$transcludeFn(tab.$parent, function (contents) {
          angular.forEach(contents, function (node) {
            if (isTabHeading(node)) {
              //Let tabHeadingTransclude know.
              tab.headingElement = node;
            } else {
              elm.append(node);
            }
          });
        });
      }
    };

    function isTabHeading(node) {
      return node.tagName && (
        node.hasAttribute('uib-tab-heading') ||
        node.hasAttribute('data-uib-tab-heading') ||
        node.hasAttribute('x-uib-tab-heading') ||
        node.tagName.toLowerCase() === 'uib-tab-heading' ||
        node.tagName.toLowerCase() === 'data-uib-tab-heading' ||
        node.tagName.toLowerCase() === 'x-uib-tab-heading' ||
        node.tagName.toLowerCase() === 'uib:tab-heading'
      );
    }
  });

angular.module('ui.bootstrap.timepicker', [])

  .constant('uibTimepickerConfig', {
    hourStep: 1,
    minuteStep: 1,
    secondStep: 1,
    showMeridian: true,
    showSeconds: false,
    meridians: null,
    readonlyInput: false,
    mousewheel: true,
    arrowkeys: true,
    showSpinners: true,
    templateUrl: 'uib/template/timepicker/timepicker.html'
  })

  .controller('UibTimepickerController', ['$scope', '$element', '$attrs', '$parse', '$log', '$locale', 'uibTimepickerConfig', function ($scope, $element, $attrs, $parse, $log, $locale, timepickerConfig) {
    var selected = new Date(),
      watchers = [],
      ngModelCtrl = {
        $setViewValue: angular.noop
      }, // nullModelCtrl
      meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS;

    $scope.tabindex = angular.isDefined($attrs.tabindex) ? $attrs.tabindex : 0;
    $element.removeAttr('tabindex');

    this.init = function (ngModelCtrl_, inputs) {
      ngModelCtrl = ngModelCtrl_;
      ngModelCtrl.$render = this.render;

      ngModelCtrl.$formatters.unshift(function (modelValue) {
        return modelValue ? new Date(modelValue) : null;
      });

      var hoursInputEl = inputs.eq(0),
        minutesInputEl = inputs.eq(1),
        secondsInputEl = inputs.eq(2);

      var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;

      if (mousewheel) {
        this.setupMousewheelEvents(hoursInputEl, minutesInputEl, secondsInputEl);
      }

      var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
      if (arrowkeys) {
        this.setupArrowkeyEvents(hoursInputEl, minutesInputEl, secondsInputEl);
      }

      $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
      this.setupInputEvents(hoursInputEl, minutesInputEl, secondsInputEl);
    };

    var hourStep = timepickerConfig.hourStep;
    if ($attrs.hourStep) {
      watchers.push($scope.$parent.$watch($parse($attrs.hourStep), function (value) {
        hourStep = +value;
      }));
    }

    var minuteStep = timepickerConfig.minuteStep;
    if ($attrs.minuteStep) {
      watchers.push($scope.$parent.$watch($parse($attrs.minuteStep), function (value) {
        minuteStep = +value;
      }));
    }

    var min;
    watchers.push($scope.$parent.$watch($parse($attrs.min), function (value) {
      var dt = new Date(value);
      min = isNaN(dt) ? undefined : dt;
    }));

    var max;
    watchers.push($scope.$parent.$watch($parse($attrs.max), function (value) {
      var dt = new Date(value);
      max = isNaN(dt) ? undefined : dt;
    }));

    var disabled = false;
    if ($attrs.ngDisabled) {
      watchers.push($scope.$parent.$watch($parse($attrs.ngDisabled), function (value) {
        disabled = value;
      }));
    }

    $scope.noIncrementHours = function () {
      var incrementedSelected = addMinutes(selected, hourStep * 60);
      return disabled || incrementedSelected > max ||
        incrementedSelected < selected && incrementedSelected < min;
    };

    $scope.noDecrementHours = function () {
      var decrementedSelected = addMinutes(selected, -hourStep * 60);
      return disabled || decrementedSelected < min ||
        decrementedSelected > selected && decrementedSelected > max;
    };

    $scope.noIncrementMinutes = function () {
      var incrementedSelected = addMinutes(selected, minuteStep);
      return disabled || incrementedSelected > max ||
        incrementedSelected < selected && incrementedSelected < min;
    };

    $scope.noDecrementMinutes = function () {
      var decrementedSelected = addMinutes(selected, -minuteStep);
      return disabled || decrementedSelected < min ||
        decrementedSelected > selected && decrementedSelected > max;
    };

    $scope.noIncrementSeconds = function () {
      var incrementedSelected = addSeconds(selected, secondStep);
      return disabled || incrementedSelected > max ||
        incrementedSelected < selected && incrementedSelected < min;
    };

    $scope.noDecrementSeconds = function () {
      var decrementedSelected = addSeconds(selected, -secondStep);
      return disabled || decrementedSelected < min ||
        decrementedSelected > selected && decrementedSelected > max;
    };

    $scope.noToggleMeridian = function () {
      if (selected.getHours() < 12) {
        return disabled || addMinutes(selected, 12 * 60) > max;
      }

      return disabled || addMinutes(selected, -12 * 60) < min;
    };

    var secondStep = timepickerConfig.secondStep;
    if ($attrs.secondStep) {
      watchers.push($scope.$parent.$watch($parse($attrs.secondStep), function (value) {
        secondStep = +value;
      }));
    }

    $scope.showSeconds = timepickerConfig.showSeconds;
    if ($attrs.showSeconds) {
      watchers.push($scope.$parent.$watch($parse($attrs.showSeconds), function (value) {
        $scope.showSeconds = !!value;
      }));
    }

    // 12H / 24H mode
    $scope.showMeridian = timepickerConfig.showMeridian;
    if ($attrs.showMeridian) {
      watchers.push($scope.$parent.$watch($parse($attrs.showMeridian), function (value) {
        $scope.showMeridian = !!value;

        if (ngModelCtrl.$error.time) {
          // Evaluate from template
          var hours = getHoursFromTemplate(),
            minutes = getMinutesFromTemplate();
          if (angular.isDefined(hours) && angular.isDefined(minutes)) {
            selected.setHours(hours);
            refresh();
          }
        } else {
          updateTemplate();
        }
      }));
    }

    // Get $scope.hours in 24H mode if valid
    function getHoursFromTemplate() {
      var hours = +$scope.hours;
      var valid = $scope.showMeridian ? hours > 0 && hours < 13 :
        hours >= 0 && hours < 24;
      if (!valid) {
        return undefined;
      }

      if ($scope.showMeridian) {
        if (hours === 12) {
          hours = 0;
        }
        if ($scope.meridian === meridians[1]) {
          hours = hours + 12;
        }
      }
      return hours;
    }

    function getMinutesFromTemplate() {
      var minutes = +$scope.minutes;
      return minutes >= 0 && minutes < 60 ? minutes : undefined;
    }

    function getSecondsFromTemplate() {
      var seconds = +$scope.seconds;
      return seconds >= 0 && seconds < 60 ? seconds : undefined;
    }

    function pad(value) {
      if (value === null) {
        return '';
      }

      return angular.isDefined(value) && value.toString().length < 2 ?
        '0' + value : value.toString();
    }

    // Respond on mousewheel spin
    this.setupMousewheelEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
      var isScrollingUp = function (e) {
        if (e.originalEvent) {
          e = e.originalEvent;
        }
        //pick correct delta variable depending on event
        var delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
        return e.detail || delta > 0;
      };

      hoursInputEl.bind('mousewheel wheel', function (e) {
        if (!disabled) {
          $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
        }
        e.preventDefault();
      });

      minutesInputEl.bind('mousewheel wheel', function (e) {
        if (!disabled) {
          $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
        }
        e.preventDefault();
      });

      secondsInputEl.bind('mousewheel wheel', function (e) {
        if (!disabled) {
          $scope.$apply(isScrollingUp(e) ? $scope.incrementSeconds() : $scope.decrementSeconds());
        }
        e.preventDefault();
      });
    };

    // Respond on up/down arrowkeys
    this.setupArrowkeyEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
      hoursInputEl.bind('keydown', function (e) {
        if (!disabled) {
          if (e.which === 38) { // up
            e.preventDefault();
            $scope.incrementHours();
            $scope.$apply();
          } else if (e.which === 40) { // down
            e.preventDefault();
            $scope.decrementHours();
            $scope.$apply();
          }
        }
      });

      minutesInputEl.bind('keydown', function (e) {
        if (!disabled) {
          if (e.which === 38) { // up
            e.preventDefault();
            $scope.incrementMinutes();
            $scope.$apply();
          } else if (e.which === 40) { // down
            e.preventDefault();
            $scope.decrementMinutes();
            $scope.$apply();
          }
        }
      });

      secondsInputEl.bind('keydown', function (e) {
        if (!disabled) {
          if (e.which === 38) { // up
            e.preventDefault();
            $scope.incrementSeconds();
            $scope.$apply();
          } else if (e.which === 40) { // down
            e.preventDefault();
            $scope.decrementSeconds();
            $scope.$apply();
          }
        }
      });
    };

    this.setupInputEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
      if ($scope.readonlyInput) {
        $scope.updateHours = angular.noop;
        $scope.updateMinutes = angular.noop;
        $scope.updateSeconds = angular.noop;
        return;
      }

      var invalidate = function (invalidHours, invalidMinutes, invalidSeconds) {
        ngModelCtrl.$setViewValue(null);
        ngModelCtrl.$setValidity('time', false);
        if (angular.isDefined(invalidHours)) {
          $scope.invalidHours = invalidHours;
        }

        if (angular.isDefined(invalidMinutes)) {
          $scope.invalidMinutes = invalidMinutes;
        }

        if (angular.isDefined(invalidSeconds)) {
          $scope.invalidSeconds = invalidSeconds;
        }
      };

      $scope.updateHours = function () {
        var hours = getHoursFromTemplate(),
          minutes = getMinutesFromTemplate();

        ngModelCtrl.$setDirty();

        if (angular.isDefined(hours) && angular.isDefined(minutes)) {
          selected.setHours(hours);
          selected.setMinutes(minutes);
          if (selected < min || selected > max) {
            invalidate(true);
          } else {
            refresh('h');
          }
        } else {
          invalidate(true);
        }
      };

      hoursInputEl.bind('blur', function (e) {
        ngModelCtrl.$setTouched();
        if ($scope.hours === null || $scope.hours === '') {
          invalidate(true);
        } else if (!$scope.invalidHours && $scope.hours < 10) {
          $scope.$apply(function () {
            $scope.hours = pad($scope.hours);
          });
        }
      });

      $scope.updateMinutes = function () {
        var minutes = getMinutesFromTemplate(),
          hours = getHoursFromTemplate();

        ngModelCtrl.$setDirty();

        if (angular.isDefined(minutes) && angular.isDefined(hours)) {
          selected.setHours(hours);
          selected.setMinutes(minutes);
          if (selected < min || selected > max) {
            invalidate(undefined, true);
          } else {
            refresh('m');
          }
        } else {
          invalidate(undefined, true);
        }
      };

      minutesInputEl.bind('blur', function (e) {
        ngModelCtrl.$setTouched();
        if ($scope.minutes === null) {
          invalidate(undefined, true);
        } else if (!$scope.invalidMinutes && $scope.minutes < 10) {
          $scope.$apply(function () {
            $scope.minutes = pad($scope.minutes);
          });
        }
      });

      $scope.updateSeconds = function () {
        var seconds = getSecondsFromTemplate();

        ngModelCtrl.$setDirty();

        if (angular.isDefined(seconds)) {
          selected.setSeconds(seconds);
          refresh('s');
        } else {
          invalidate(undefined, undefined, true);
        }
      };

      secondsInputEl.bind('blur', function (e) {
        if (!$scope.invalidSeconds && $scope.seconds < 10) {
          $scope.$apply(function () {
            $scope.seconds = pad($scope.seconds);
          });
        }
      });

    };

    this.render = function () {
      var date = ngModelCtrl.$viewValue;

      if (isNaN(date)) {
        ngModelCtrl.$setValidity('time', false);
        $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
      } else {
        if (date) {
          selected = date;
        }

        if (selected < min || selected > max) {
          ngModelCtrl.$setValidity('time', false);
          $scope.invalidHours = true;
          $scope.invalidMinutes = true;
        } else {
          makeValid();
        }
        updateTemplate();
      }
    };

    // Call internally when we know that model is valid.
    function refresh(keyboardChange) {
      makeValid();
      ngModelCtrl.$setViewValue(new Date(selected));
      updateTemplate(keyboardChange);
    }

    function makeValid() {
      ngModelCtrl.$setValidity('time', true);
      $scope.invalidHours = false;
      $scope.invalidMinutes = false;
      $scope.invalidSeconds = false;
    }

    function updateTemplate(keyboardChange) {
      if (!ngModelCtrl.$modelValue) {
        $scope.hours = null;
        $scope.minutes = null;
        $scope.seconds = null;
        $scope.meridian = meridians[0];
      } else {
        var hours = selected.getHours(),
          minutes = selected.getMinutes(),
          seconds = selected.getSeconds();

        if ($scope.showMeridian) {
          hours = hours === 0 || hours === 12 ? 12 : hours % 12; // Convert 24 to 12 hour system
        }

        $scope.hours = keyboardChange === 'h' ? hours : pad(hours);
        if (keyboardChange !== 'm') {
          $scope.minutes = pad(minutes);
        }
        $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];

        if (keyboardChange !== 's') {
          $scope.seconds = pad(seconds);
        }
        $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
      }
    }

    function addSecondsToSelected(seconds) {
      selected = addSeconds(selected, seconds);
      refresh();
    }

    function addMinutes(selected, minutes) {
      return addSeconds(selected, minutes * 60);
    }

    function addSeconds(date, seconds) {
      var dt = new Date(date.getTime() + seconds * 1000);
      var newDate = new Date(date);
      newDate.setHours(dt.getHours(), dt.getMinutes(), dt.getSeconds());
      return newDate;
    }

    $scope.showSpinners = angular.isDefined($attrs.showSpinners) ?
      $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;

    $scope.incrementHours = function () {
      if (!$scope.noIncrementHours()) {
        addSecondsToSelected(hourStep * 60 * 60);
      }
    };

    $scope.decrementHours = function () {
      if (!$scope.noDecrementHours()) {
        addSecondsToSelected(-hourStep * 60 * 60);
      }
    };

    $scope.incrementMinutes = function () {
      if (!$scope.noIncrementMinutes()) {
        addSecondsToSelected(minuteStep * 60);
      }
    };

    $scope.decrementMinutes = function () {
      if (!$scope.noDecrementMinutes()) {
        addSecondsToSelected(-minuteStep * 60);
      }
    };

    $scope.incrementSeconds = function () {
      if (!$scope.noIncrementSeconds()) {
        addSecondsToSelected(secondStep);
      }
    };

    $scope.decrementSeconds = function () {
      if (!$scope.noDecrementSeconds()) {
        addSecondsToSelected(-secondStep);
      }
    };

    $scope.toggleMeridian = function () {
      var minutes = getMinutesFromTemplate(),
        hours = getHoursFromTemplate();

      if (!$scope.noToggleMeridian()) {
        if (angular.isDefined(minutes) && angular.isDefined(hours)) {
          addSecondsToSelected(12 * 60 * (selected.getHours() < 12 ? 60 : -60));
        } else {
          $scope.meridian = $scope.meridian === meridians[0] ? meridians[1] : meridians[0];
        }
      }
    };

    $scope.blur = function () {
      ngModelCtrl.$setTouched();
    };

    $scope.$on('$destroy', function () {
      while (watchers.length) {
        watchers.shift()();
      }
    });
  }])

  .directive('uibTimepicker', ['uibTimepickerConfig', function (uibTimepickerConfig) {
    return {
      require: ['uibTimepicker', '?^ngModel'],
      controller: 'UibTimepickerController',
      controllerAs: 'timepicker',
      replace: true,
      scope: {},
      templateUrl: function (element, attrs) {
        return attrs.templateUrl || uibTimepickerConfig.templateUrl;
      },
      link: function (scope, element, attrs, ctrls) {
        var timepickerCtrl = ctrls[0],
          ngModelCtrl = ctrls[1];

        if (ngModelCtrl) {
          timepickerCtrl.init(ngModelCtrl, element.find('input'));
        }
      }
    };
  }]);

angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.debounce', 'ui.bootstrap.position'])

  /**
   * A helper service that can parse typeahead's syntax (string provided by users)
   * Extracted to a separate service for ease of unit testing
   */
  .factory('uibTypeaheadParser', ['$parse', function ($parse) {
    //                      00000111000000000000022200000000000000003333333333333330000000000044000
    var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
    return {
      parse: function (input) {
        var match = input.match(TYPEAHEAD_REGEXP);
        if (!match) {
          throw new Error(
            'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
            ' but got "' + input + '".');
        }

        return {
          itemName: match[3],
          source: $parse(match[4]),
          viewMapper: $parse(match[2] || match[1]),
          modelMapper: $parse(match[1])
        };
      }
    };
  }])

  .controller('UibTypeaheadController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$$debounce', '$uibPosition', 'uibTypeaheadParser',
    function (originalScope, element, attrs, $compile, $parse, $q, $timeout, $document, $window, $rootScope, $$debounce, $position, typeaheadParser) {
      var HOT_KEYS = [9, 13, 27, 38, 40];
      var eventDebounceTime = 200;
      var modelCtrl, ngModelOptions;
      //SUPPORTED ATTRIBUTES (OPTIONS)

      //minimal no of characters that needs to be entered before typeahead kicks-in
      var minLength = originalScope.$eval(attrs.typeaheadMinLength);
      if (!minLength && minLength !== 0) {
        minLength = 1;
      }

      originalScope.$watch(attrs.typeaheadMinLength, function (newVal) {
        minLength = !newVal && newVal !== 0 ? 1 : newVal;
      });

      //minimal wait time after last character typed before typeahead kicks-in
      var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;

      //should it restrict model values to the ones selected from the popup only?
      var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
      originalScope.$watch(attrs.typeaheadEditable, function (newVal) {
        isEditable = newVal !== false;
      });

      //binding to a variable that indicates if matches are being retrieved asynchronously
      var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;

      //a callback executed when a match is selected
      var onSelectCallback = $parse(attrs.typeaheadOnSelect);

      //should it select highlighted popup value when losing focus?
      var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;

      //binding to a variable that indicates if there were no results after the query is completed
      var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;

      var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;

      var appendToBody = attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;

      var appendTo = attrs.typeaheadAppendTo ?
        originalScope.$eval(attrs.typeaheadAppendTo) : null;

      var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;

      //If input matches an item of the list exactly, select it automatically
      var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;

      //binding to a variable that indicates if dropdown is open
      var isOpenSetter = $parse(attrs.typeaheadIsOpen).assign || angular.noop;

      var showHint = originalScope.$eval(attrs.typeaheadShowHint) || false;

      //INTERNAL VARIABLES

      //model setter executed upon match selection
      var parsedModel = $parse(attrs.ngModel);
      var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
      var $setModelValue = function (scope, newValue) {
        if (angular.isFunction(parsedModel(originalScope)) &&
          ngModelOptions && ngModelOptions.$options && ngModelOptions.$options.getterSetter) {
          return invokeModelSetter(scope, {
            $$$p: newValue
          });
        }

        return parsedModel.assign(scope, newValue);
      };

      //expressions used by typeahead
      var parserResult = typeaheadParser.parse(attrs.uibTypeahead);

      var hasFocus;

      //Used to avoid bug in iOS webview where iOS keyboard does not fire
      //mousedown & mouseup events
      //Issue #3699
      var selected;

      //create a child scope for the typeahead directive so we are not polluting original scope
      //with typeahead-specific data (matches, query etc.)
      var scope = originalScope.$new();
      var offDestroy = originalScope.$on('$destroy', function () {
        scope.$destroy();
      });
      scope.$on('$destroy', offDestroy);

      // WAI-ARIA
      var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
      element.attr({
        'aria-autocomplete': 'list',
        'aria-expanded': false,
        'aria-owns': popupId
      });

      var inputsContainer, hintInputElem;
      //add read-only input to show hint
      if (showHint) {
        inputsContainer = angular.element('<div></div>');
        inputsContainer.css('position', 'relative');
        element.after(inputsContainer);
        hintInputElem = element.clone();
        hintInputElem.attr('placeholder', '');
        hintInputElem.attr('tabindex', '-1');
        hintInputElem.val('');
        hintInputElem.css({
          'position': 'absolute',
          'top': '0px',
          'left': '0px',
          'border-color': 'transparent',
          'box-shadow': 'none',
          'opacity': 1,
          'background': 'none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)',
          'color': '#999'
        });
        element.css({
          'position': 'relative',
          'vertical-align': 'top',
          'background-color': 'transparent'
        });
        inputsContainer.append(hintInputElem);
        hintInputElem.after(element);
      }

      //pop-up element used to display matches
      var popUpEl = angular.element('<div uib-typeahead-popup></div>');
      popUpEl.attr({
        id: popupId,
        matches: 'matches',
        active: 'activeIdx',
        select: 'select(activeIdx, evt)',
        'move-in-progress': 'moveInProgress',
        query: 'query',
        position: 'position',
        'assign-is-open': 'assignIsOpen(isOpen)',
        debounce: 'debounceUpdate'
      });
      //custom item template
      if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
        popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
      }

      if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
        popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
      }

      var resetHint = function () {
        if (showHint) {
          hintInputElem.val('');
        }
      };

      var resetMatches = function () {
        scope.matches = [];
        scope.activeIdx = -1;
        element.attr('aria-expanded', false);
        resetHint();
      };

      var getMatchId = function (index) {
        return popupId + '-option-' + index;
      };

      // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
      // This attribute is added or removed automatically when the `activeIdx` changes.
      scope.$watch('activeIdx', function (index) {
        if (index < 0) {
          element.removeAttr('aria-activedescendant');
        } else {
          element.attr('aria-activedescendant', getMatchId(index));
        }
      });

      var inputIsExactMatch = function (inputValue, index) {
        if (scope.matches.length > index && inputValue) {
          return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
        }

        return false;
      };

      var getMatchesAsync = function (inputValue, evt) {
        var locals = {
          $viewValue: inputValue
        };
        isLoadingSetter(originalScope, true);
        isNoResultsSetter(originalScope, false);
        $q.when(parserResult.source(originalScope, locals)).then(function (matches) {
          //it might happen that several async queries were in progress if a user were typing fast
          //but we are interested only in responses that correspond to the current view value
          var onCurrentRequest = inputValue === modelCtrl.$viewValue;
          if (onCurrentRequest && hasFocus) {
            if (matches && matches.length > 0) {
              scope.activeIdx = focusFirst ? 0 : -1;
              isNoResultsSetter(originalScope, false);
              scope.matches.length = 0;

              //transform labels
              for (var i = 0; i < matches.length; i++) {
                locals[parserResult.itemName] = matches[i];
                scope.matches.push({
                  id: getMatchId(i),
                  label: parserResult.viewMapper(scope, locals),
                  model: matches[i]
                });
              }

              scope.query = inputValue;
              //position pop-up with matches - we need to re-calculate its position each time we are opening a window
              //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
              //due to other elements being rendered
              recalculatePosition();

              element.attr('aria-expanded', true);

              //Select the single remaining option if user input matches
              if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
                if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
                  $$debounce(function () {
                    scope.select(0, evt);
                  }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
                } else {
                  scope.select(0, evt);
                }
              }

              if (showHint) {
                var firstLabel = scope.matches[0].label;
                if (angular.isString(inputValue) &&
                  inputValue.length > 0 &&
                  firstLabel.slice(0, inputValue.length).toUpperCase() === inputValue.toUpperCase()) {
                  hintInputElem.val(inputValue + firstLabel.slice(inputValue.length));
                } else {
                  hintInputElem.val('');
                }
              }
            } else {
              resetMatches();
              isNoResultsSetter(originalScope, true);
            }
          }
          if (onCurrentRequest) {
            isLoadingSetter(originalScope, false);
          }
        }, function () {
          resetMatches();
          isLoadingSetter(originalScope, false);
          isNoResultsSetter(originalScope, true);
        });
      };

      // bind events only if appendToBody params exist - performance feature
      if (appendToBody) {
        angular.element($window).on('resize', fireRecalculating);
        $document.find('body').on('scroll', fireRecalculating);
      }

      // Declare the debounced function outside recalculating for
      // proper debouncing
      var debouncedRecalculate = $$debounce(function () {
        // if popup is visible
        if (scope.matches.length) {
          recalculatePosition();
        }

        scope.moveInProgress = false;
      }, eventDebounceTime);

      // Default progress type
      scope.moveInProgress = false;

      function fireRecalculating() {
        if (!scope.moveInProgress) {
          scope.moveInProgress = true;
          scope.$digest();
        }

        debouncedRecalculate();
      }

      // recalculate actual position and set new values to scope
      // after digest loop is popup in right position
      function recalculatePosition() {
        scope.position = appendToBody ? $position.offset(element) : $position.position(element);
        scope.position.top += element.prop('offsetHeight');
      }

      //we need to propagate user's query so we can higlight matches
      scope.query = undefined;

      //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
      var timeoutPromise;

      var scheduleSearchWithTimeout = function (inputValue) {
        timeoutPromise = $timeout(function () {
          getMatchesAsync(inputValue);
        }, waitTime);
      };

      var cancelPreviousTimeout = function () {
        if (timeoutPromise) {
          $timeout.cancel(timeoutPromise);
        }
      };

      resetMatches();

      scope.assignIsOpen = function (isOpen) {
        isOpenSetter(originalScope, isOpen);
      };

      scope.select = function (activeIdx, evt) {
        //called from within the $digest() cycle
        var locals = {};
        var model, item;

        selected = true;
        locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
        model = parserResult.modelMapper(originalScope, locals);
        $setModelValue(originalScope, model);
        modelCtrl.$setValidity('editable', true);
        modelCtrl.$setValidity('parse', true);

        onSelectCallback(originalScope, {
          $item: item,
          $model: model,
          $label: parserResult.viewMapper(originalScope, locals),
          $event: evt
        });

        resetMatches();

        //return focus to the input element if a match was selected via a mouse click event
        // use timeout to avoid $rootScope:inprog error
        if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
          $timeout(function () {
            element[0].focus();
          }, 0, false);
        }
      };

      //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
      element.on('keydown', function (evt) {
        //typeahead is open and an "interesting" key was pressed
        if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
          return;
        }

        /**
         * if there's nothing selected (i.e. focusFirst) and enter or tab is hit
         * or
         * shift + tab is pressed to bring focus to the previous element
         * then clear the results
         */
        if (scope.activeIdx === -1 && (evt.which === 9 || evt.which === 13) || evt.which === 9 && !!evt.shiftKey) {
          resetMatches();
          scope.$digest();
          return;
        }

        evt.preventDefault();
        var target;
        switch (evt.which) {
          case 9:
          case 13:
            scope.$apply(function () {
              if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
                $$debounce(function () {
                  scope.select(scope.activeIdx, evt);
                }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
              } else {
                scope.select(scope.activeIdx, evt);
              }
            });
            break;
          case 27:
            evt.stopPropagation();

            resetMatches();
            originalScope.$digest();
            break;
          case 38:
            scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
            scope.$digest();
            target = popUpEl.find('li')[scope.activeIdx];
            target.parentNode.scrollTop = target.offsetTop;
            break;
          case 40:
            scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
            scope.$digest();
            target = popUpEl.find('li')[scope.activeIdx];
            target.parentNode.scrollTop = target.offsetTop;
            break;
        }
      });

      element.bind('focus', function (evt) {
        hasFocus = true;
        if (minLength === 0 && !modelCtrl.$viewValue) {
          $timeout(function () {
            getMatchesAsync(modelCtrl.$viewValue, evt);
          }, 0);
        }
      });

      element.bind('blur', function (evt) {
        if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
          selected = true;
          scope.$apply(function () {
            if (angular.isObject(scope.debounceUpdate) && angular.isNumber(scope.debounceUpdate.blur)) {
              $$debounce(function () {
                scope.select(scope.activeIdx, evt);
              }, scope.debounceUpdate.blur);
            } else {
              scope.select(scope.activeIdx, evt);
            }
          });
        }
        if (!isEditable && modelCtrl.$error.editable) {
          modelCtrl.$viewValue = '';
          element.val('');
        }
        hasFocus = false;
        selected = false;
      });

      // Keep reference to click handler to unbind it.
      var dismissClickHandler = function (evt) {
        // Issue #3973
        // Firefox treats right click as a click on document
        if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
          resetMatches();
          if (!$rootScope.$$phase) {
            originalScope.$digest();
          }
        }
      };

      $document.on('click', dismissClickHandler);

      originalScope.$on('$destroy', function () {
        $document.off('click', dismissClickHandler);
        if (appendToBody || appendTo) {
          $popup.remove();
        }

        if (appendToBody) {
          angular.element($window).off('resize', fireRecalculating);
          $document.find('body').off('scroll', fireRecalculating);
        }
        // Prevent jQuery cache memory leak
        popUpEl.remove();

        if (showHint) {
          inputsContainer.remove();
        }
      });

      var $popup = $compile(popUpEl)(scope);

      if (appendToBody) {
        $document.find('body').append($popup);
      } else if (appendTo) {
        angular.element(appendTo).eq(0).append($popup);
      } else {
        element.after($popup);
      }

      this.init = function (_modelCtrl, _ngModelOptions) {
        modelCtrl = _modelCtrl;
        ngModelOptions = _ngModelOptions;

        scope.debounceUpdate = modelCtrl.$options && $parse(modelCtrl.$options.debounce)(originalScope);

        //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
        //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
        modelCtrl.$parsers.unshift(function (inputValue) {
          hasFocus = true;

          if (minLength === 0 || inputValue && inputValue.length >= minLength) {
            if (waitTime > 0) {
              cancelPreviousTimeout();
              scheduleSearchWithTimeout(inputValue);
            } else {
              getMatchesAsync(inputValue);
            }
          } else {
            isLoadingSetter(originalScope, false);
            cancelPreviousTimeout();
            resetMatches();
          }

          if (isEditable) {
            return inputValue;
          }

          if (!inputValue) {
            // Reset in case user had typed something previously.
            modelCtrl.$setValidity('editable', true);
            return null;
          }

          modelCtrl.$setValidity('editable', false);
          return undefined;
        });

        modelCtrl.$formatters.push(function (modelValue) {
          var candidateViewValue, emptyViewValue;
          var locals = {};

          // The validity may be set to false via $parsers (see above) if
          // the model is restricted to selected values. If the model
          // is set manually it is considered to be valid.
          if (!isEditable) {
            modelCtrl.$setValidity('editable', true);
          }

          if (inputFormatter) {
            locals.$model = modelValue;
            return inputFormatter(originalScope, locals);
          }

          //it might happen that we don't have enough info to properly render input value
          //we need to check for this situation and simply return model value if we can't apply custom formatting
          locals[parserResult.itemName] = modelValue;
          candidateViewValue = parserResult.viewMapper(originalScope, locals);
          locals[parserResult.itemName] = undefined;
          emptyViewValue = parserResult.viewMapper(originalScope, locals);

          return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
        });
      };
    }
  ])

  .directive('uibTypeahead', function () {
    return {
      controller: 'UibTypeaheadController',
      require: ['ngModel', '^?ngModelOptions', 'uibTypeahead'],
      link: function (originalScope, element, attrs, ctrls) {
        ctrls[2].init(ctrls[0], ctrls[1]);
      }
    };
  })

  .directive('uibTypeaheadPopup', ['$$debounce', function ($$debounce) {
    return {
      scope: {
        matches: '=',
        query: '=',
        active: '=',
        position: '&',
        moveInProgress: '=',
        select: '&',
        assignIsOpen: '&',
        debounce: '&'
      },
      replace: true,
      templateUrl: function (element, attrs) {
        return attrs.popupTemplateUrl || 'uib/template/typeahead/typeahead-popup.html';
      },
      link: function (scope, element, attrs) {
        scope.templateUrl = attrs.templateUrl;

        scope.isOpen = function () {
          var isDropdownOpen = scope.matches.length > 0;
          scope.assignIsOpen({
            isOpen: isDropdownOpen
          });
          return isDropdownOpen;
        };

        scope.isActive = function (matchIdx) {
          return scope.active === matchIdx;
        };

        scope.selectActive = function (matchIdx) {
          scope.active = matchIdx;
        };

        scope.selectMatch = function (activeIdx, evt) {
          var debounce = scope.debounce();
          if (angular.isNumber(debounce) || angular.isObject(debounce)) {
            $$debounce(function () {
              scope.select({
                activeIdx: activeIdx,
                evt: evt
              });
            }, angular.isNumber(debounce) ? debounce : debounce['default']);
          } else {
            scope.select({
              activeIdx: activeIdx,
              evt: evt
            });
          }
        };
      }
    };
  }])

  .directive('uibTypeaheadMatch', ['$templateRequest', '$compile', '$parse', function ($templateRequest, $compile, $parse) {
    return {
      scope: {
        index: '=',
        match: '=',
        query: '='
      },
      link: function (scope, element, attrs) {
        var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'uib/template/typeahead/typeahead-match.html';
        $templateRequest(tplUrl).then(function (tplContent) {
          var tplEl = angular.element(tplContent.trim());
          element.replaceWith(tplEl);
          $compile(tplEl)(scope);
        });
      }
    };
  }])

  .filter('uibTypeaheadHighlight', ['$sce', '$injector', '$log', function ($sce, $injector, $log) {
    var isSanitizePresent;
    isSanitizePresent = $injector.has('$sanitize');

    function escapeRegexp(queryToEscape) {
      // Regex: capture the whole query string and replace it with the string that will be used to match
      // the results, for example if the capture is "a" the result will be \a
      return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
    }

    function containsHtml(matchItem) {
      return /<.*>/g.test(matchItem);
    }

    return function (matchItem, query) {
      if (!isSanitizePresent && containsHtml(matchItem)) {
        $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
      }
      matchItem = query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
      if (!isSanitizePresent) {
        matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
      }
      return matchItem;
    };
  }]);

angular.module("uib/template/accordion/accordion-group.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/accordion/accordion-group.html",
    "<div class=\"panel\" ng-class=\"panelClass || 'panel-default'\">\n" +
    "  <div role=\"tab\" id=\"{{::headingId}}\" aria-selected=\"{{isOpen}}\" class=\"panel-heading\" ng-keypress=\"toggleOpen($event)\">\n" +
    "    <h4 class=\"panel-title\">\n" +
    "      <a role=\"button\" data-toggle=\"collapse\" href aria-expanded=\"{{isOpen}}\" aria-controls=\"{{::panelId}}\" tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\"><span uib-accordion-header ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" +
    "    </h4>\n" +
    "  </div>\n" +
    "  <div id=\"{{::panelId}}\" aria-labelledby=\"{{::headingId}}\" aria-hidden=\"{{!isOpen}}\" role=\"tabpanel\" class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n" +
    "    <div class=\"panel-body\" ng-transclude></div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/accordion/accordion.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/accordion/accordion.html",
    "<div role=\"tablist\" class=\"panel-group\" ng-transclude></div>");
}]);

angular.module("uib/template/alert/alert.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/alert/alert.html",
    "<div class=\"alert\" ng-class=\"['alert-' + (type || 'warning'), closeable ? 'alert-dismissible' : null]\" role=\"alert\">\n" +
    "    <button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close({$event: $event})\">\n" +
    "        <span aria-hidden=\"true\">&times;</span>\n" +
    "        <span class=\"sr-only\">Close</span>\n" +
    "    </button>\n" +
    "    <div ng-transclude></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/carousel/carousel.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/carousel/carousel.html",
    "<div ng-mouseenter=\"pause()\" ng-mouseleave=\"play()\" class=\"carousel\" ng-swipe-right=\"prev()\" ng-swipe-left=\"next()\">\n" +
    "  <div class=\"carousel-inner\" ng-transclude></div>\n" +
    "  <a role=\"button\" href class=\"left carousel-control\" ng-click=\"prev()\" ng-show=\"slides.length > 1\">\n" +
    "    <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></span>\n" +
    "    <span class=\"sr-only\">previous</span>\n" +
    "  </a>\n" +
    "  <a role=\"button\" href class=\"right carousel-control\" ng-click=\"next()\" ng-show=\"slides.length > 1\">\n" +
    "    <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></span>\n" +
    "    <span class=\"sr-only\">next</span>\n" +
    "  </a>\n" +
    "  <ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n" +
    "    <li ng-repeat=\"slide in slides | orderBy:indexOfSlide track by $index\" ng-class=\"{ active: isActive(slide) }\" ng-click=\"select(slide)\">\n" +
    "      <span class=\"sr-only\">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if=\"isActive(slide)\">, currently active</span></span>\n" +
    "    </li>\n" +
    "  </ol>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/carousel/slide.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/carousel/slide.html",
    "<div ng-class=\"{\n" +
    "    'active': active\n" +
    "  }\" class=\"item text-center\" ng-transclude></div>\n" +
    "");
}]);

angular.module("uib/template/datepicker/datepicker.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/datepicker/datepicker.html",
    "<div class=\"uib-datepicker\" ng-switch=\"datepickerMode\" role=\"application\" ng-keydown=\"keydown($event)\">\n" +
    "  <uib-daypicker ng-switch-when=\"day\" tabindex=\"0\"></uib-daypicker>\n" +
    "  <uib-monthpicker ng-switch-when=\"month\" tabindex=\"0\"></uib-monthpicker>\n" +
    "  <uib-yearpicker ng-switch-when=\"year\" tabindex=\"0\"></uib-yearpicker>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/datepicker/day.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/datepicker/day.html",
    "<table class=\"uib-daypicker\" role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
    "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
    "    </tr>\n" +
    "    <tr>\n" +
    "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" +
    "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr class=\"uib-weeks\" ng-repeat=\"row in rows track by $index\">\n" +
    "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
    "      <td ng-repeat=\"dt in row\" class=\"uib-day text-center\" role=\"gridcell\"\n" +
    "        id=\"{{::dt.uid}}\"\n" +
    "        ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" class=\"btn btn-default btn-sm\"\n" +
    "          uib-is-class=\"\n" +
    "            'btn-info' for selectedDt,\n" +
    "            'active' for activeDt\n" +
    "            on dt\"\n" +
    "          ng-click=\"select(dt.date)\"\n" +
    "          ng-disabled=\"::dt.disabled\"\n" +
    "          tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/datepicker/month.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/datepicker/month.html",
    "<table class=\"uib-monthpicker\" role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
    "      <th><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr class=\"uib-months\" ng-repeat=\"row in rows track by $index\">\n" +
    "      <td ng-repeat=\"dt in row\" class=\"uib-month text-center\" role=\"gridcell\"\n" +
    "        id=\"{{::dt.uid}}\"\n" +
    "        ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" class=\"btn btn-default\"\n" +
    "          uib-is-class=\"\n" +
    "            'btn-info' for selectedDt,\n" +
    "            'active' for activeDt\n" +
    "            on dt\"\n" +
    "          ng-click=\"select(dt.date)\"\n" +
    "          ng-disabled=\"::dt.disabled\"\n" +
    "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/datepicker/popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/datepicker/popup.html",
    "<div>\n" +
    "  <ul class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
    "    <li ng-transclude></li>\n" +
    "    <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" +
    "      <span class=\"btn-group pull-left\">\n" +
    "        <button type=\"button\" class=\"btn btn-sm btn-info uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
    "        <button type=\"button\" class=\"btn btn-sm btn-danger uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" +
    "      </span>\n" +
    "      <button type=\"button\" class=\"btn btn-sm btn-success pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/datepicker/year.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/datepicker/year.html",
    "<table class=\"uib-yearpicker\" role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
    "      <th colspan=\"{{::columns - 2}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr class=\"uib-years\" ng-repeat=\"row in rows track by $index\">\n" +
    "      <td ng-repeat=\"dt in row\" class=\"uib-year text-center\" role=\"gridcell\"\n" +
    "        id=\"{{::dt.uid}}\"\n" +
    "        ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" class=\"btn btn-default\"\n" +
    "          uib-is-class=\"\n" +
    "            'btn-info' for selectedDt,\n" +
    "            'active' for activeDt\n" +
    "            on dt\"\n" +
    "          ng-click=\"select(dt.date)\"\n" +
    "          ng-disabled=\"::dt.disabled\"\n" +
    "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/modal/backdrop.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/modal/backdrop.html",
    "<div class=\"modal-backdrop\"\n" +
    "     uib-modal-animation-class=\"fade\"\n" +
    "     modal-in-class=\"in\"\n" +
    "     ng-style=\"{'z-index': 1040 + (index && 1 || 0) + index*10}\"\n" +
    "></div>\n" +
    "");
}]);

angular.module("uib/template/modal/window.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/modal/window.html",
    "<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\"\n" +
    "    uib-modal-animation-class=\"fade\"\n" +
    "    modal-in-class=\"in\"\n" +
    "    ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\">\n" +
    "    <div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/pager/pager.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/pager/pager.html",
    "<ul class=\"pager\">\n" +
    "  <li ng-class=\"{disabled: noPrevious()||ngDisabled, previous: align}\"><a href ng-click=\"selectPage(page - 1, $event)\">{{::getText('previous')}}</a></li>\n" +
    "  <li ng-class=\"{disabled: noNext()||ngDisabled, next: align}\"><a href ng-click=\"selectPage(page + 1, $event)\">{{::getText('next')}}</a></li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("uib/template/pagination/pager.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/pagination/pager.html",
    "<ul class=\"pager\">\n" +
    "  <li ng-class=\"{disabled: noPrevious()||ngDisabled, previous: align}\"><a href ng-click=\"selectPage(page - 1, $event)\">{{::getText('previous')}}</a></li>\n" +
    "  <li ng-class=\"{disabled: noNext()||ngDisabled, next: align}\"><a href ng-click=\"selectPage(page + 1, $event)\">{{::getText('next')}}</a></li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("uib/template/pagination/pagination.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/pagination/pagination.html",
    "<ul class=\"pagination\">\n" +
    "  <li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-first\"><a href ng-click=\"selectPage(1, $event)\">{{::getText('first')}}</a></li>\n" +
    "  <li ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-prev\"><a href ng-click=\"selectPage(page - 1, $event)\">{{::getText('previous')}}</a></li>\n" +
    "  <li ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"pagination-page\"><a href ng-click=\"selectPage(page.number, $event)\">{{page.text}}</a></li>\n" +
    "  <li ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-next\"><a href ng-click=\"selectPage(page + 1, $event)\">{{::getText('next')}}</a></li>\n" +
    "  <li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-last\"><a href ng-click=\"selectPage(totalPages, $event)\">{{::getText('last')}}</a></li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("uib/template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-html-popup.html",
    "<div class=\"tooltip\"\n" +
    "  tooltip-animation-class=\"fade\"\n" +
    "  uib-tooltip-classes\n" +
    "  ng-class=\"{ in: isOpen() }\">\n" +
    "  <div class=\"tooltip-arrow\"></div>\n" +
    "  <div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/tooltip/tooltip-popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-popup.html",
    "<div class=\"tooltip\"\n" +
    "  tooltip-animation-class=\"fade\"\n" +
    "  uib-tooltip-classes\n" +
    "  ng-class=\"{ in: isOpen() }\">\n" +
    "  <div class=\"tooltip-arrow\"></div>\n" +
    "  <div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-template-popup.html",
    "<div class=\"tooltip\"\n" +
    "  tooltip-animation-class=\"fade\"\n" +
    "  uib-tooltip-classes\n" +
    "  ng-class=\"{ in: isOpen() }\">\n" +
    "  <div class=\"tooltip-arrow\"></div>\n" +
    "  <div class=\"tooltip-inner\"\n" +
    "    uib-tooltip-template-transclude=\"contentExp()\"\n" +
    "    tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/popover/popover-html.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/popover/popover-html.html",
    "<div class=\"popover\"\n" +
    "  tooltip-animation-class=\"fade\"\n" +
    "  uib-tooltip-classes\n" +
    "  ng-class=\"{ in: isOpen() }\">\n" +
    "  <div class=\"arrow\"></div>\n" +
    "\n" +
    "  <div class=\"popover-inner\">\n" +
    "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-if=\"title\"></h3>\n" +
    "      <div class=\"popover-content\" ng-bind-html=\"contentExp()\"></div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/popover/popover-template.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/popover/popover-template.html",
    "<div class=\"popover\"\n" +
    "  tooltip-animation-class=\"fade\"\n" +
    "  uib-tooltip-classes\n" +
    "  ng-class=\"{ in: isOpen() }\">\n" +
    "  <div class=\"arrow\"></div>\n" +
    "\n" +
    "  <div class=\"popover-inner\">\n" +
    "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-if=\"title\"></h3>\n" +
    "      <div class=\"popover-content\"\n" +
    "        uib-tooltip-template-transclude=\"contentExp()\"\n" +
    "        tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/popover/popover.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/popover/popover.html",
    "<div class=\"popover\"\n" +
    "  tooltip-animation-class=\"fade\"\n" +
    "  uib-tooltip-classes\n" +
    "  ng-class=\"{ in: isOpen() }\">\n" +
    "  <div class=\"arrow\"></div>\n" +
    "\n" +
    "  <div class=\"popover-inner\">\n" +
    "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-if=\"title\"></h3>\n" +
    "      <div class=\"popover-content\" ng-bind=\"content\"></div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/progressbar/bar.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/progressbar/bar.html",
    "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
    "");
}]);

angular.module("uib/template/progressbar/progress.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/progressbar/progress.html",
    "<div class=\"progress\" ng-transclude aria-labelledby=\"{{::title}}\"></div>");
}]);

angular.module("uib/template/progressbar/progressbar.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/progressbar/progressbar.html",
    "<div class=\"progress\">\n" +
    "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/rating/rating.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/rating/rating.html",
    "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\" aria-valuetext=\"{{title}}\">\n" +
    "    <span ng-repeat-start=\"r in range track by $index\" class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" +
    "    <i ng-repeat-end ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\" ng-attr-title=\"{{r.title}}\"></i>\n" +
    "</span>\n" +
    "");
}]);

angular.module("uib/template/tabs/tab.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/tabs/tab.html",
    "<li ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"uib-tab nav-item\">\n" +
    "  <a href ng-click=\"select()\" class=\"nav-link\" uib-tab-heading-transclude>{{heading}}</a>\n" +
    "</li>\n" +
    "");
}]);

angular.module("uib/template/tabs/tabset.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/tabs/tabset.html",
    "<div>\n" +
    "  <ul class=\"nav nav-{{tabset.type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" +
    "  <div class=\"tab-content\">\n" +
    "    <div class=\"tab-pane\"\n" +
    "         ng-repeat=\"tab in tabset.tabs\"\n" +
    "         ng-class=\"{active: tabset.active === tab.index}\"\n" +
    "         uib-tab-content-transclude=\"tab\">\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/timepicker/timepicker.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/timepicker/timepicker.html",
    "<table class=\"uib-timepicker\">\n" +
    "  <tbody>\n" +
    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
    "      <td class=\"uib-increment hours\"><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementHours()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td>&nbsp;</td>\n" +
    "      <td class=\"uib-increment minutes\"><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
    "      <td ng-show=\"showSeconds\" class=\"uib-increment seconds\"><a ng-click=\"incrementSeconds()\" ng-class=\"{disabled: noIncrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementSeconds()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td ng-show=\"showMeridian\"></td>\n" +
    "    </tr>\n" +
    "    <tr>\n" +
    "      <td class=\"form-group uib-time hours\" ng-class=\"{'has-error': invalidHours}\">\n" +
    "        <input style=\"width:50px;\" type=\"text\" placeholder=\"HH\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementHours()\" ng-blur=\"blur()\">\n" +
    "      </td>\n" +
    "      <td class=\"uib-separator\">:</td>\n" +
    "      <td class=\"form-group uib-time minutes\" ng-class=\"{'has-error': invalidMinutes}\">\n" +
    "        <input style=\"width:50px;\" type=\"text\" placeholder=\"MM\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementMinutes()\" ng-blur=\"blur()\">\n" +
    "      </td>\n" +
    "      <td ng-show=\"showSeconds\" class=\"uib-separator\">:</td>\n" +
    "      <td class=\"form-group uib-time seconds\" ng-class=\"{'has-error': invalidSeconds}\" ng-show=\"showSeconds\">\n" +
    "        <input style=\"width:50px;\" type=\"text\" placeholder=\"SS\" ng-model=\"seconds\" ng-change=\"updateSeconds()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementSeconds()\" ng-blur=\"blur()\">\n" +
    "      </td>\n" +
    "      <td ng-show=\"showMeridian\" class=\"uib-time am-pm\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</button></td>\n" +
    "    </tr>\n" +
    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
    "      <td class=\"uib-decrement hours\"><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementHours()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td>&nbsp;</td>\n" +
    "      <td class=\"uib-decrement minutes\"><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
    "      <td ng-show=\"showSeconds\" class=\"uib-decrement seconds\"><a ng-click=\"decrementSeconds()\" ng-class=\"{disabled: noDecrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementSeconds()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td ng-show=\"showMeridian\"></td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/typeahead/typeahead-match.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/typeahead/typeahead-match.html",
    "<a class=\"typeahreadlink\" href\n" +
    "   tabindex=\"-1\"\n" +
    "   ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"\n" +
    "   ng-attr-title=\"{{match.label}}\"></a>\n" +
    "");
}]);

angular.module("uib/template/typeahead/typeahead-popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/typeahead/typeahead-popup.html",
    "<ul class=\"dropdown-menu\" ng-show=\"isOpen() && !moveInProgress\" ng-style=\"{top: position().top+'px', left: position().left+'px'}\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" +
    "    <li ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index, $event)\" role=\"option\" id=\"{{::match.id}}\">\n" +
    "        <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" +
    "    </li>\n" +
    "</ul>\n" +
    "");
}]);
angular.module('ui.bootstrap.carousel').run(function () {
  !angular.$$csp().noInlineStyle && !angular.$$uibCarouselCss && angular.element(document).find('head').prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>');
  angular.$$uibCarouselCss = true;
});
angular.module('ui.bootstrap.position').run(function () {
  !angular.$$csp().noInlineStyle && !angular.$$uibPositionCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-position-measure{display:block !important;visibility:hidden !important;position:absolute !important;top:-9999px !important;left:-9999px !important;}.uib-position-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll;}</style>');
  angular.$$uibPositionCss = true;
});
angular.module('ui.bootstrap.datepicker').run(function () {
  !angular.$$csp().noInlineStyle && !angular.$$uibDatepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker .uib-title{width:100%;}.uib-day button,.uib-month button,.uib-year button{min-width:100%;}.uib-datepicker-popup.dropdown-menu{display:block;float:none;margin:0;}.uib-button-bar{padding:10px 9px 2px;}.uib-left,.uib-right{width:100%}</style>');
  angular.$$uibDatepickerCss = true;
});
angular.module('ui.bootstrap.tooltip').run(function () {
  !angular.$$csp().noInlineStyle && !angular.$$uibTooltipCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-tooltip-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-bottom > .tooltip-arrow,[uib-popover-popup].popover.top-left > .arrow,[uib-popover-popup].popover.top-right > .arrow,[uib-popover-popup].popover.bottom-left > .arrow,[uib-popover-popup].popover.bottom-right > .arrow,[uib-popover-popup].popover.left-top > .arrow,[uib-popover-popup].popover.left-bottom > .arrow,[uib-popover-popup].popover.right-top > .arrow,[uib-popover-popup].popover.right-bottom > .arrow{top:auto;bottom:auto;left:auto;right:auto;margin:0;}[uib-popover-popup].popover,[uib-popover-template-popup].popover{display:block !important;}</style>');
  angular.$$uibTooltipCss = true;
});
angular.module('ui.bootstrap.timepicker').run(function () {
  !angular.$$csp().noInlineStyle && !angular.$$uibTimepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-time input{width:50px;}</style>');
  angular.$$uibTimepickerCss = true;
});
angular.module('ui.bootstrap.typeahead').run(function () {
  !angular.$$csp().noInlineStyle && !angular.$$uibTypeaheadCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-typeahead-popup].dropdown-menu{display:block;}</style>');
  angular.$$uibTypeaheadCss = true;
});

/*!
 * Modernizr v2.8.2
 * www.modernizr.com
 *
 * Copyright (c) Faruk Ates, Paul Irish, Alex Sexton
 * Available under the BSD and MIT licenses: www.modernizr.com/license/
 */

/*
 * Modernizr tests which native CSS3 and HTML5 features are available in
 * the current UA and makes the results available to you in two ways:
 * as properties on a global Modernizr object, and as classes on the
 * <html> element. This information allows you to progressively enhance
 * your pages with a granular level of control over the experience.
 *
 * Modernizr has an optional (not included) conditional resource loader
 * called Modernizr.load(), based on Yepnope.js (yepnopejs.com).
 * To get a build that includes Modernizr.load(), as well as choosing
 * which tests to include, go to www.modernizr.com/download/
 *
 * Authors        Faruk Ates, Paul Irish, Alex Sexton
 * Contributors   Ryan Seddon, Ben Alman
 */

window.Modernizr = (function( window, document, undefined ) {

    var version = '2.8.2',

    Modernizr = {},

    /*>>cssclasses*/
    // option for enabling the HTML classes to be added
    enableClasses = true,
    /*>>cssclasses*/

    docElement = document.documentElement,

    /**
     * Create our "modernizr" element that we do most feature tests on.
     */
    mod = 'modernizr',
    modElem = document.createElement(mod),
    mStyle = modElem.style,

    /**
     * Create the input element for various Web Forms feature tests.
     */
    inputElem /*>>inputelem*/ = document.createElement('input') /*>>inputelem*/ ,

    /*>>smile*/
    smile = ':)',
    /*>>smile*/

    toString = {}.toString,

    // TODO :: make the prefixes more granular
    /*>>prefixes*/
    // List of property values to set for css tests. See ticket #21
    prefixes = ' -webkit- -moz- -o- -ms- '.split(' '),
    /*>>prefixes*/

    /*>>domprefixes*/
    // Following spec is to expose vendor-specific style properties as:
    //   elem.style.WebkitBorderRadius
    // and the following would be incorrect:
    //   elem.style.webkitBorderRadius

    // Webkit ghosts their properties in lowercase but Opera & Moz do not.
    // Microsoft uses a lowercase `ms` instead of the correct `Ms` in IE8+
    //   erik.eae.net/archives/2008/03/10/21.48.10/

    // More here: github.com/Modernizr/Modernizr/issues/issue/21
    omPrefixes = 'Webkit Moz O ms',

    cssomPrefixes = omPrefixes.split(' '),

    domPrefixes = omPrefixes.toLowerCase().split(' '),
    /*>>domprefixes*/

    /*>>ns*/
    ns = {'svg': 'http://www.w3.org/2000/svg'},
    /*>>ns*/

    tests = {},
    inputs = {},
    attrs = {},

    classes = [],

    slice = classes.slice,

    featureName, // used in testing loop


    /*>>teststyles*/
    // Inject element with style element and some CSS rules
    injectElementWithStyles = function( rule, callback, nodes, testnames ) {

      var style, ret, node, docOverflow,
          div = document.createElement('div'),
          // After page load injecting a fake body doesn't work so check if body exists
          body = document.body,
          // IE6 and 7 won't return offsetWidth or offsetHeight unless it's in the body element, so we fake it.
          fakeBody = body || document.createElement('body');

      if ( parseInt(nodes, 10) ) {
          // In order not to give false positives we create a node for each test
          // This also allows the method to scale for unspecified uses
          while ( nodes-- ) {
              node = document.createElement('div');
              node.id = testnames ? testnames[nodes] : mod + (nodes + 1);
              div.appendChild(node);
          }
      }

      // <style> elements in IE6-9 are considered 'NoScope' elements and therefore will be removed
      // when injected with innerHTML. To get around this you need to prepend the 'NoScope' element
      // with a 'scoped' element, in our case the soft-hyphen entity as it won't mess with our measurements.
      // msdn.microsoft.com/en-us/library/ms533897%28VS.85%29.aspx
      // Documents served as xml will throw if using &shy; so use xml friendly encoded version. See issue #277
      style = ['&#173;','<style id="s', mod, '">', rule, '</style>'].join('');
      div.id = mod;
      // IE6 will false positive on some tests due to the style element inside the test div somehow interfering offsetHeight, so insert it into body or fakebody.
      // Opera will act all quirky when injecting elements in documentElement when page is served as xml, needs fakebody too. #270
      (body ? div : fakeBody).innerHTML += style;
      fakeBody.appendChild(div);
      if ( !body ) {
          //avoid crashing IE8, if background image is used
          fakeBody.style.background = '';
          //Safari 5.13/5.1.4 OSX stops loading if ::-webkit-scrollbar is used and scrollbars are visible
          fakeBody.style.overflow = 'hidden';
          docOverflow = docElement.style.overflow;
          docElement.style.overflow = 'hidden';
          docElement.appendChild(fakeBody);
      }

      ret = callback(div, rule);
      // If this is done after page load we don't want to remove the body so check if body exists
      if ( !body ) {
          fakeBody.parentNode.removeChild(fakeBody);
          docElement.style.overflow = docOverflow;
      } else {
          div.parentNode.removeChild(div);
      }

      return !!ret;

    },
    /*>>teststyles*/

    /*>>mq*/
    // adapted from matchMedia polyfill
    // by Scott Jehl and Paul Irish
    // gist.github.com/786768
    testMediaQuery = function( mq ) {

      var matchMedia = window.matchMedia || window.msMatchMedia;
      if ( matchMedia ) {
        return matchMedia(mq) && matchMedia(mq).matches || false;
      }

      var bool;

      injectElementWithStyles('@media ' + mq + ' { #' + mod + ' { position: absolute; } }', function( node ) {
        bool = (window.getComputedStyle ?
                  getComputedStyle(node, null) :
                  node.currentStyle)['position'] == 'absolute';
      });

      return bool;

     },
     /*>>mq*/


    /*>>hasevent*/
    //
    // isEventSupported determines if a given element supports the given event
    // kangax.github.com/iseventsupported/
    //
    // The following results are known incorrects:
    //   Modernizr.hasEvent("webkitTransitionEnd", elem) // false negative
    //   Modernizr.hasEvent("textInput") // in Webkit. github.com/Modernizr/Modernizr/issues/333
    //   ...
    isEventSupported = (function() {

      var TAGNAMES = {
        'select': 'input', 'change': 'input',
        'submit': 'form', 'reset': 'form',
        'error': 'img', 'load': 'img', 'abort': 'img'
      };

      function isEventSupported( eventName, element ) {

        element = element || document.createElement(TAGNAMES[eventName] || 'div');
        eventName = 'on' + eventName;

        // When using `setAttribute`, IE skips "unload", WebKit skips "unload" and "resize", whereas `in` "catches" those
        var isSupported = eventName in element;

        if ( !isSupported ) {
          // If it has no `setAttribute` (i.e. doesn't implement Node interface), try generic element
          if ( !element.setAttribute ) {
            element = document.createElement('div');
          }
          if ( element.setAttribute && element.removeAttribute ) {
            element.setAttribute(eventName, '');
            isSupported = is(element[eventName], 'function');

            // If property was created, "remove it" (by setting value to `undefined`)
            if ( !is(element[eventName], 'undefined') ) {
              element[eventName] = undefined;
            }
            element.removeAttribute(eventName);
          }
        }

        element = null;
        return isSupported;
      }
      return isEventSupported;
    })(),
    /*>>hasevent*/

    // TODO :: Add flag for hasownprop ? didn't last time

    // hasOwnProperty shim by kangax needed for Safari 2.0 support
    _hasOwnProperty = ({}).hasOwnProperty, hasOwnProp;

    if ( !is(_hasOwnProperty, 'undefined') && !is(_hasOwnProperty.call, 'undefined') ) {
      hasOwnProp = function (object, property) {
        return _hasOwnProperty.call(object, property);
      };
    }
    else {
      hasOwnProp = function (object, property) { /* yes, this can give false positives/negatives, but most of the time we don't care about those */
        return ((property in object) && is(object.constructor.prototype[property], 'undefined'));
      };
    }

    // Adapted from ES5-shim https://github.com/kriskowal/es5-shim/blob/master/es5-shim.js
    // es5.github.com/#x15.3.4.5

    if (!Function.prototype.bind) {
      Function.prototype.bind = function bind(that) {

        var target = this;

        if (typeof target != "function") {
            throw new TypeError();
        }

        var args = slice.call(arguments, 1),
            bound = function () {

            if (this instanceof bound) {

              var F = function(){};
              F.prototype = target.prototype;
              var self = new F();

              var result = target.apply(
                  self,
                  args.concat(slice.call(arguments))
              );
              if (Object(result) === result) {
                  return result;
              }
              return self;

            } else {

              return target.apply(
                  that,
                  args.concat(slice.call(arguments))
              );

            }

        };

        return bound;
      };
    }

    /**
     * setCss applies given styles to the Modernizr DOM node.
     */
    function setCss( str ) {
        mStyle.cssText = str;
    }

    /**
     * setCssAll extrapolates all vendor-specific css strings.
     */
    function setCssAll( str1, str2 ) {
        return setCss(prefixes.join(str1 + ';') + ( str2 || '' ));
    }

    /**
     * is returns a boolean for if typeof obj is exactly type.
     */
    function is( obj, type ) {
        return typeof obj === type;
    }

    /**
     * contains returns a boolean for if substr is found within str.
     */
    function contains( str, substr ) {
        return !!~('' + str).indexOf(substr);
    }

    /*>>testprop*/

    // testProps is a generic CSS / DOM property test.

    // In testing support for a given CSS property, it's legit to test:
    //    `elem.style[styleName] !== undefined`
    // If the property is supported it will return an empty string,
    // if unsupported it will return undefined.

    // We'll take advantage of this quick test and skip setting a style
    // on our modernizr element, but instead just testing undefined vs
    // empty string.

    // Because the testing of the CSS property names (with "-", as
    // opposed to the camelCase DOM properties) is non-portable and
    // non-standard but works in WebKit and IE (but not Gecko or Opera),
    // we explicitly reject properties with dashes so that authors
    // developing in WebKit or IE first don't end up with
    // browser-specific content by accident.

    function testProps( props, prefixed ) {
        for ( var i in props ) {
            var prop = props[i];
            if ( !contains(prop, "-") && mStyle[prop] !== undefined ) {
                return prefixed == 'pfx' ? prop : true;
            }
        }
        return false;
    }
    /*>>testprop*/

    // TODO :: add testDOMProps
    /**
     * testDOMProps is a generic DOM property test; if a browser supports
     *   a certain property, it won't return undefined for it.
     */
    function testDOMProps( props, obj, elem ) {
        for ( var i in props ) {
            var item = obj[props[i]];
            if ( item !== undefined) {

                // return the property name as a string
                if (elem === false) return props[i];

                // let's bind a function
                if (is(item, 'function')){
                  // default to autobind unless override
                  return item.bind(elem || obj);
                }

                // return the unbound function or obj or value
                return item;
            }
        }
        return false;
    }

    /*>>testallprops*/
    /**
     * testPropsAll tests a list of DOM properties we want to check against.
     *   We specify literally ALL possible (known and/or likely) properties on
     *   the element including the non-vendor prefixed one, for forward-
     *   compatibility.
     */
    function testPropsAll( prop, prefixed, elem ) {

        var ucProp  = prop.charAt(0).toUpperCase() + prop.slice(1),
            props   = (prop + ' ' + cssomPrefixes.join(ucProp + ' ') + ucProp).split(' ');

        // did they call .prefixed('boxSizing') or are we just testing a prop?
        if(is(prefixed, "string") || is(prefixed, "undefined")) {
          return testProps(props, prefixed);

        // otherwise, they called .prefixed('requestAnimationFrame', window[, elem])
        } else {
          props = (prop + ' ' + (domPrefixes).join(ucProp + ' ') + ucProp).split(' ');
          return testDOMProps(props, prefixed, elem);
        }
    }
    /*>>testallprops*/


    /**
     * Tests
     * -----
     */

    // The *new* flexbox
    // dev.w3.org/csswg/css3-flexbox

    tests['flexbox'] = function() {
      return testPropsAll('flexWrap');
    };

    // The *old* flexbox
    // www.w3.org/TR/2009/WD-css3-flexbox-20090723/

    tests['flexboxlegacy'] = function() {
        return testPropsAll('boxDirection');
    };

    // On the S60 and BB Storm, getContext exists, but always returns undefined
    // so we actually have to call getContext() to verify
    // github.com/Modernizr/Modernizr/issues/issue/97/

    tests['canvas'] = function() {
        var elem = document.createElement('canvas');
        return !!(elem.getContext && elem.getContext('2d'));
    };

    tests['canvastext'] = function() {
        return !!(Modernizr['canvas'] && is(document.createElement('canvas').getContext('2d').fillText, 'function'));
    };

    // webk.it/70117 is tracking a legit WebGL feature detect proposal

    // We do a soft detect which may false positive in order to avoid
    // an expensive context creation: bugzil.la/732441

    tests['webgl'] = function() {
        return !!window.WebGLRenderingContext;
    };

    /*
     * The Modernizr.touch test only indicates if the browser supports
     *    touch events, which does not necessarily reflect a touchscreen
     *    device, as evidenced by tablets running Windows 7 or, alas,
     *    the Palm Pre / WebOS (touch) phones.
     *
     * Additionally, Chrome (desktop) used to lie about its support on this,
     *    but that has since been rectified: crbug.com/36415
     *
     * We also test for Firefox 4 Multitouch Support.
     *
     * For more info, see: modernizr.github.com/Modernizr/touch.html
     */

    tests['touch'] = function() {
        var bool;

        if(('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
          bool = true;
        } else {
          injectElementWithStyles(['@media (',prefixes.join('touch-enabled),('),mod,')','{#modernizr{top:9px;position:absolute}}'].join(''), function( node ) {
            bool = node.offsetTop === 9;
          });
        }

        return bool;
    };


    // geolocation is often considered a trivial feature detect...
    // Turns out, it's quite tricky to get right:
    //
    // Using !!navigator.geolocation does two things we don't want. It:
    //   1. Leaks memory in IE9: github.com/Modernizr/Modernizr/issues/513
    //   2. Disables page caching in WebKit: webk.it/43956
    //
    // Meanwhile, in Firefox < 8, an about:config setting could expose
    // a false positive that would throw an exception: bugzil.la/688158

    tests['geolocation'] = function() {
        return 'geolocation' in navigator;
    };


    tests['postmessage'] = function() {
      return !!window.postMessage;
    };


    // Chrome incognito mode used to throw an exception when using openDatabase
    // It doesn't anymore.
    tests['websqldatabase'] = function() {
      return !!window.openDatabase;
    };

    // Vendors had inconsistent prefixing with the experimental Indexed DB:
    // - Webkit's implementation is accessible through webkitIndexedDB
    // - Firefox shipped moz_indexedDB before FF4b9, but since then has been mozIndexedDB
    // For speed, we don't test the legacy (and beta-only) indexedDB
    tests['indexedDB'] = function() {
      return !!testPropsAll("indexedDB", window);
    };

    // documentMode logic from YUI to filter out IE8 Compat Mode
    //   which false positives.
    tests['hashchange'] = function() {
      return isEventSupported('hashchange', window) && (document.documentMode === undefined || document.documentMode > 7);
    };

    // Per 1.6:
    // This used to be Modernizr.historymanagement but the longer
    // name has been deprecated in favor of a shorter and property-matching one.
    // The old API is still available in 1.6, but as of 2.0 will throw a warning,
    // and in the first release thereafter disappear entirely.
    tests['history'] = function() {
      return !!(window.history && history.pushState);
    };

    tests['draganddrop'] = function() {
        var div = document.createElement('div');
        return ('draggable' in div) || ('ondragstart' in div && 'ondrop' in div);
    };

    // FF3.6 was EOL'ed on 4/24/12, but the ESR version of FF10
    // will be supported until FF19 (2/12/13), at which time, ESR becomes FF17.
    // FF10 still uses prefixes, so check for it until then.
    // for more ESR info, see: mozilla.org/en-US/firefox/organizations/faq/
    tests['websockets'] = function() {
        return 'WebSocket' in window || 'MozWebSocket' in window;
    };


    // css-tricks.com/rgba-browser-support/
    tests['rgba'] = function() {
        // Set an rgba() color and check the returned value

        setCss('background-color:rgba(150,255,150,.5)');

        return contains(mStyle.backgroundColor, 'rgba');
    };

    tests['hsla'] = function() {
        // Same as rgba(), in fact, browsers re-map hsla() to rgba() internally,
        //   except IE9 who retains it as hsla

        setCss('background-color:hsla(120,40%,100%,.5)');

        return contains(mStyle.backgroundColor, 'rgba') || contains(mStyle.backgroundColor, 'hsla');
    };

    tests['multiplebgs'] = function() {
        // Setting multiple images AND a color on the background shorthand property
        //  and then querying the style.background property value for the number of
        //  occurrences of "url(" is a reliable method for detecting ACTUAL support for this!

        setCss('background:url(https://),url(https://),red url(https://)');

        // If the UA supports multiple backgrounds, there should be three occurrences
        //   of the string "url(" in the return value for elemStyle.background

        return (/(url\s*\(.*?){3}/).test(mStyle.background);
    };



    // this will false positive in Opera Mini
    //   github.com/Modernizr/Modernizr/issues/396

    tests['backgroundsize'] = function() {
        return testPropsAll('backgroundSize');
    };

    tests['borderimage'] = function() {
        return testPropsAll('borderImage');
    };


    // Super comprehensive table about all the unique implementations of
    // border-radius: muddledramblings.com/table-of-css3-border-radius-compliance

    tests['borderradius'] = function() {
        return testPropsAll('borderRadius');
    };

    // WebOS unfortunately false positives on this test.
    tests['boxshadow'] = function() {
        return testPropsAll('boxShadow');
    };

    // FF3.0 will false positive on this test
    tests['textshadow'] = function() {
        return document.createElement('div').style.textShadow === '';
    };


    tests['opacity'] = function() {
        // Browsers that actually have CSS Opacity implemented have done so
        //  according to spec, which means their return values are within the
        //  range of [0.0,1.0] - including the leading zero.

        setCssAll('opacity:.55');

        // The non-literal . in this regex is intentional:
        //   German Chrome returns this value as 0,55
        // github.com/Modernizr/Modernizr/issues/#issue/59/comment/516632
        return (/^0.55$/).test(mStyle.opacity);
    };


    // Note, Android < 4 will pass this test, but can only animate
    //   a single property at a time
    //   goo.gl/v3V4Gp
    tests['cssanimations'] = function() {
        return testPropsAll('animationName');
    };


    tests['csscolumns'] = function() {
        return testPropsAll('columnCount');
    };


    tests['cssgradients'] = function() {
        /**
         * For CSS Gradients syntax, please see:
         * webkit.org/blog/175/introducing-css-gradients/
         * developer.mozilla.org/en/CSS/-moz-linear-gradient
         * developer.mozilla.org/en/CSS/-moz-radial-gradient
         * dev.w3.org/csswg/css3-images/#gradients-
         */

        var str1 = 'background-image:',
            str2 = 'gradient(linear,left top,right bottom,from(#9f9),to(white));',
            str3 = 'linear-gradient(left top,#9f9, white);';

        setCss(
             // legacy webkit syntax (FIXME: remove when syntax not in use anymore)
              (str1 + '-webkit- '.split(' ').join(str2 + str1) +
             // standard syntax             // trailing 'background-image:'
              prefixes.join(str3 + str1)).slice(0, -str1.length)
        );

        return contains(mStyle.backgroundImage, 'gradient');
    };


    tests['cssreflections'] = function() {
        return testPropsAll('boxReflect');
    };


    tests['csstransforms'] = function() {
        return !!testPropsAll('transform');
    };


    tests['csstransforms3d'] = function() {

        var ret = !!testPropsAll('perspective');

        // Webkit's 3D transforms are passed off to the browser's own graphics renderer.
        //   It works fine in Safari on Leopard and Snow Leopard, but not in Chrome in
        //   some conditions. As a result, Webkit typically recognizes the syntax but
        //   will sometimes throw a false positive, thus we must do a more thorough check:
        if ( ret && 'webkitPerspective' in docElement.style ) {

          // Webkit allows this media query to succeed only if the feature is enabled.
          // `@media (transform-3d),(-webkit-transform-3d){ ... }`
          injectElementWithStyles('@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}', function( node, rule ) {
            ret = node.offsetLeft === 9 && node.offsetHeight === 3;
          });
        }
        return ret;
    };


    tests['csstransitions'] = function() {
        return testPropsAll('transition');
    };


    /*>>fontface*/
    // @font-face detection routine by Diego Perini
    // javascript.nwbox.com/CSSSupport/

    // false positives:
    //   WebOS github.com/Modernizr/Modernizr/issues/342
    //   WP7   github.com/Modernizr/Modernizr/issues/538
    tests['fontface'] = function() {
        var bool;

        injectElementWithStyles('@font-face {font-family:"font";src:url("https://")}', function( node, rule ) {
          var style = document.getElementById('smodernizr'),
              sheet = style.sheet || style.styleSheet,
              cssText = sheet ? (sheet.cssRules && sheet.cssRules[0] ? sheet.cssRules[0].cssText : sheet.cssText || '') : '';

          bool = /src/i.test(cssText) && cssText.indexOf(rule.split(' ')[0]) === 0;
        });

        return bool;
    };
    /*>>fontface*/

    // CSS generated content detection
    tests['generatedcontent'] = function() {
        var bool;

        injectElementWithStyles(['#',mod,'{font:0/0 a}#',mod,':after{content:"',smile,'";visibility:hidden;font:3px/1 a}'].join(''), function( node ) {
          bool = node.offsetHeight >= 3;
        });

        return bool;
    };



    // These tests evaluate support of the video/audio elements, as well as
    // testing what types of content they support.
    //
    // We're using the Boolean constructor here, so that we can extend the value
    // e.g.  Modernizr.video     // true
    //       Modernizr.video.ogg // 'probably'
    //
    // Codec values from : github.com/NielsLeenheer/html5test/blob/9106a8/index.html#L845
    //                     thx to NielsLeenheer and zcorpan

    // Note: in some older browsers, "no" was a return value instead of empty string.
    //   It was live in FF3.5.0 and 3.5.1, but fixed in 3.5.2
    //   It was also live in Safari 4.0.0 - 4.0.4, but fixed in 4.0.5

    tests['video'] = function() {
        var elem = document.createElement('video'),
            bool = false;

        // IE9 Running on Windows Server SKU can cause an exception to be thrown, bug #224
        try {
            if ( bool = !!elem.canPlayType ) {
                bool      = new Boolean(bool);
                bool.ogg  = elem.canPlayType('video/ogg; codecs="theora"')      .replace(/^no$/,'');

                // Without QuickTime, this value will be `undefined`. github.com/Modernizr/Modernizr/issues/546
                bool.h264 = elem.canPlayType('video/mp4; codecs="avc1.42E01E"') .replace(/^no$/,'');

                bool.webm = elem.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/,'');
            }

        } catch(e) { }

        return bool;
    };

    tests['audio'] = function() {
        var elem = document.createElement('audio'),
            bool = false;

        try {
            if ( bool = !!elem.canPlayType ) {
                bool      = new Boolean(bool);
                bool.ogg  = elem.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/,'');
                bool.mp3  = elem.canPlayType('audio/mpeg;')               .replace(/^no$/,'');

                // Mimetypes accepted:
                //   developer.mozilla.org/En/Media_formats_supported_by_the_audio_and_video_elements
                //   bit.ly/iphoneoscodecs
                bool.wav  = elem.canPlayType('audio/wav; codecs="1"')     .replace(/^no$/,'');
                bool.m4a  = ( elem.canPlayType('audio/x-m4a;')            ||
                              elem.canPlayType('audio/aac;'))             .replace(/^no$/,'');
            }
        } catch(e) { }

        return bool;
    };


    // In FF4, if disabled, window.localStorage should === null.

    // Normally, we could not test that directly and need to do a
    //   `('localStorage' in window) && ` test first because otherwise Firefox will
    //   throw bugzil.la/365772 if cookies are disabled

    // Also in iOS5 Private Browsing mode, attempting to use localStorage.setItem
    // will throw the exception:
    //   QUOTA_EXCEEDED_ERRROR DOM Exception 22.
    // Peculiarly, getItem and removeItem calls do not throw.

    // Because we are forced to try/catch this, we'll go aggressive.

    // Just FWIW: IE8 Compat mode supports these features completely:
    //   www.quirksmode.org/dom/html5.html
    // But IE8 doesn't support either with local files

    tests['localstorage'] = function() {
        try {
            localStorage.setItem(mod, mod);
            localStorage.removeItem(mod);
            return true;
        } catch(e) {
            return false;
        }
    };

    tests['sessionstorage'] = function() {
        try {
            sessionStorage.setItem(mod, mod);
            sessionStorage.removeItem(mod);
            return true;
        } catch(e) {
            return false;
        }
    };


    tests['webworkers'] = function() {
        return !!window.Worker;
    };


    tests['applicationcache'] = function() {
        return !!window.applicationCache;
    };


    // Thanks to Erik Dahlstrom
    tests['svg'] = function() {
        return !!document.createElementNS && !!document.createElementNS(ns.svg, 'svg').createSVGRect;
    };

    // specifically for SVG inline in HTML, not within XHTML
    // test page: paulirish.com/demo/inline-svg
    tests['inlinesvg'] = function() {
      var div = document.createElement('div');
      div.innerHTML = '<svg/>';
      return (div.firstChild && div.firstChild.namespaceURI) == ns.svg;
    };

    // SVG SMIL animation
    tests['smil'] = function() {
        return !!document.createElementNS && /SVGAnimate/.test(toString.call(document.createElementNS(ns.svg, 'animate')));
    };

    // This test is only for clip paths in SVG proper, not clip paths on HTML content
    // demo: srufaculty.sru.edu/david.dailey/svg/newstuff/clipPath4.svg

    // However read the comments to dig into applying SVG clippaths to HTML content here:
    //   github.com/Modernizr/Modernizr/issues/213#issuecomment-1149491
    tests['svgclippaths'] = function() {
        return !!document.createElementNS && /SVGClipPath/.test(toString.call(document.createElementNS(ns.svg, 'clipPath')));
    };

    /*>>webforms*/
    // input features and input types go directly onto the ret object, bypassing the tests loop.
    // Hold this guy to execute in a moment.
    function webforms() {
        /*>>input*/
        // Run through HTML5's new input attributes to see if the UA understands any.
        // We're using f which is the <input> element created early on
        // Mike Taylr has created a comprehensive resource for testing these attributes
        //   when applied to all input types:
        //   miketaylr.com/code/input-type-attr.html
        // spec: www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary

        // Only input placeholder is tested while textarea's placeholder is not.
        // Currently Safari 4 and Opera 11 have support only for the input placeholder
        // Both tests are available in feature-detects/forms-placeholder.js
        Modernizr['input'] = (function( props ) {
            for ( var i = 0, len = props.length; i < len; i++ ) {
                attrs[ props[i] ] = !!(props[i] in inputElem);
            }
            if (attrs.list){
              // safari false positive's on datalist: webk.it/74252
              // see also github.com/Modernizr/Modernizr/issues/146
              attrs.list = !!(document.createElement('datalist') && window.HTMLDataListElement);
            }
            return attrs;
        })('autocomplete autofocus list placeholder max min multiple pattern required step'.split(' '));
        /*>>input*/

        /*>>inputtypes*/
        // Run through HTML5's new input types to see if the UA understands any.
        //   This is put behind the tests runloop because it doesn't return a
        //   true/false like all the other tests; instead, it returns an object
        //   containing each input type with its corresponding true/false value

        // Big thanks to @miketaylr for the html5 forms expertise. miketaylr.com/
        Modernizr['inputtypes'] = (function(props) {

            for ( var i = 0, bool, inputElemType, defaultView, len = props.length; i < len; i++ ) {

                inputElem.setAttribute('type', inputElemType = props[i]);
                bool = inputElem.type !== 'text';

                // We first check to see if the type we give it sticks..
                // If the type does, we feed it a textual value, which shouldn't be valid.
                // If the value doesn't stick, we know there's input sanitization which infers a custom UI
                if ( bool ) {

                    inputElem.value         = smile;
                    inputElem.style.cssText = 'position:absolute;visibility:hidden;';

                    if ( /^range$/.test(inputElemType) && inputElem.style.WebkitAppearance !== undefined ) {

                      docElement.appendChild(inputElem);
                      defaultView = document.defaultView;

                      // Safari 2-4 allows the smiley as a value, despite making a slider
                      bool =  defaultView.getComputedStyle &&
                              defaultView.getComputedStyle(inputElem, null).WebkitAppearance !== 'textfield' &&
                              // Mobile android web browser has false positive, so must
                              // check the height to see if the widget is actually there.
                              (inputElem.offsetHeight !== 0);

                      docElement.removeChild(inputElem);

                    } else if ( /^(search|tel)$/.test(inputElemType) ){
                      // Spec doesn't define any special parsing or detectable UI
                      //   behaviors so we pass these through as true

                      // Interestingly, opera fails the earlier test, so it doesn't
                      //  even make it here.

                    } else if ( /^(url|email)$/.test(inputElemType) ) {
                      // Real url and email support comes with prebaked validation.
                      bool = inputElem.checkValidity && inputElem.checkValidity() === false;

                    } else {
                      // If the upgraded input compontent rejects the :) text, we got a winner
                      bool = inputElem.value != smile;
                    }
                }

                inputs[ props[i] ] = !!bool;
            }
            return inputs;
        })('search tel url email datetime date month week time datetime-local number range color'.split(' '));
        /*>>inputtypes*/
    }
    /*>>webforms*/


    // End of test definitions
    // -----------------------



    // Run through all tests and detect their support in the current UA.
    // todo: hypothetically we could be doing an array of tests and use a basic loop here.
    for ( var feature in tests ) {
        if ( hasOwnProp(tests, feature) ) {
            // run the test, throw the return value into the Modernizr,
            //   then based on that boolean, define an appropriate className
            //   and push it into an array of classes we'll join later.
            featureName  = feature.toLowerCase();
            Modernizr[featureName] = tests[feature]();

            classes.push((Modernizr[featureName] ? '' : 'no-') + featureName);
        }
    }

    /*>>webforms*/
    // input tests need to run.
    Modernizr.input || webforms();
    /*>>webforms*/


    /**
     * addTest allows the user to define their own feature tests
     * the result will be added onto the Modernizr object,
     * as well as an appropriate className set on the html element
     *
     * @param feature - String naming the feature
     * @param test - Function returning true if feature is supported, false if not
     */
     Modernizr.addTest = function ( feature, test ) {
       if ( typeof feature == 'object' ) {
         for ( var key in feature ) {
           if ( hasOwnProp( feature, key ) ) {
             Modernizr.addTest( key, feature[ key ] );
           }
         }
       } else {

         feature = feature.toLowerCase();

         if ( Modernizr[feature] !== undefined ) {
           // we're going to quit if you're trying to overwrite an existing test
           // if we were to allow it, we'd do this:
           //   var re = new RegExp("\\b(no-)?" + feature + "\\b");
           //   docElement.className = docElement.className.replace( re, '' );
           // but, no rly, stuff 'em.
           return Modernizr;
         }

         test = typeof test == 'function' ? test() : test;

         if (typeof enableClasses !== "undefined" && enableClasses) {
           docElement.className += ' ' + (test ? '' : 'no-') + feature;
         }
         Modernizr[feature] = test;

       }

       return Modernizr; // allow chaining.
     };


    // Reset modElem.cssText to nothing to reduce memory footprint.
    setCss('');
    modElem = inputElem = null;

    /*>>shiv*/
    /**
     * @preserve HTML5 Shiv prev3.7.1 | @afarkas @jdalton @jon_neal @rem | MIT/GPL2 Licensed
     */
    ;(function(window, document) {
        /*jshint evil:true */
        /** version */
        var version = '3.7.0';

        /** Preset options */
        var options = window.html5 || {};

        /** Used to skip problem elements */
        var reSkip = /^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i;

        /** Not all elements can be cloned in IE **/
        var saveClones = /^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i;

        /** Detect whether the browser supports default html5 styles */
        var supportsHtml5Styles;

        /** Name of the expando, to work with multiple documents or to re-shiv one document */
        var expando = '_html5shiv';

        /** The id for the the documents expando */
        var expanID = 0;

        /** Cached data for each document */
        var expandoData = {};

        /** Detect whether the browser supports unknown elements */
        var supportsUnknownElements;

        (function() {
          try {
            var a = document.createElement('a');
            a.innerHTML = '<xyz></xyz>';
            //if the hidden property is implemented we can assume, that the browser supports basic HTML5 Styles
            supportsHtml5Styles = ('hidden' in a);

            supportsUnknownElements = a.childNodes.length == 1 || (function() {
              // assign a false positive if unable to shiv
              (document.createElement)('a');
              var frag = document.createDocumentFragment();
              return (
                typeof frag.cloneNode == 'undefined' ||
                typeof frag.createDocumentFragment == 'undefined' ||
                typeof frag.createElement == 'undefined'
              );
            }());
          } catch(e) {
            // assign a false positive if detection fails => unable to shiv
            supportsHtml5Styles = true;
            supportsUnknownElements = true;
          }

        }());

        /*--------------------------------------------------------------------------*/

        /**
         * Creates a style sheet with the given CSS text and adds it to the document.
         * @private
         * @param {Document} ownerDocument The document.
         * @param {String} cssText The CSS text.
         * @returns {StyleSheet} The style element.
         */
        function addStyleSheet(ownerDocument, cssText) {
          var p = ownerDocument.createElement('p'),
          parent = ownerDocument.getElementsByTagName('head')[0] || ownerDocument.documentElement;

          p.innerHTML = 'x<style>' + cssText + '</style>';
          return parent.insertBefore(p.lastChild, parent.firstChild);
        }

        /**
         * Returns the value of `html5.elements` as an array.
         * @private
         * @returns {Array} An array of shived element node names.
         */
        function getElements() {
          var elements = html5.elements;
          return typeof elements == 'string' ? elements.split(' ') : elements;
        }

        /**
         * Returns the data associated to the given document
         * @private
         * @param {Document} ownerDocument The document.
         * @returns {Object} An object of data.
         */
        function getExpandoData(ownerDocument) {
          var data = expandoData[ownerDocument[expando]];
          if (!data) {
            data = {};
            expanID++;
            ownerDocument[expando] = expanID;
            expandoData[expanID] = data;
          }
          return data;
        }

        /**
         * returns a shived element for the given nodeName and document
         * @memberOf html5
         * @param {String} nodeName name of the element
         * @param {Document} ownerDocument The context document.
         * @returns {Object} The shived element.
         */
        function createElement(nodeName, ownerDocument, data){
          if (!ownerDocument) {
            ownerDocument = document;
          }
          if(supportsUnknownElements){
            return ownerDocument.createElement(nodeName);
          }
          if (!data) {
            data = getExpandoData(ownerDocument);
          }
          var node;

          if (data.cache[nodeName]) {
            node = data.cache[nodeName].cloneNode();
          } else if (saveClones.test(nodeName)) {
            node = (data.cache[nodeName] = data.createElem(nodeName)).cloneNode();
          } else {
            node = data.createElem(nodeName);
          }

          // Avoid adding some elements to fragments in IE < 9 because
          // * Attributes like `name` or `type` cannot be set/changed once an element
          //   is inserted into a document/fragment
          // * Link elements with `src` attributes that are inaccessible, as with
          //   a 403 response, will cause the tab/window to crash
          // * Script elements appended to fragments will execute when their `src`
          //   or `text` property is set
          return node.canHaveChildren && !reSkip.test(nodeName) && !node.tagUrn ? data.frag.appendChild(node) : node;
        }

        /**
         * returns a shived DocumentFragment for the given document
         * @memberOf html5
         * @param {Document} ownerDocument The context document.
         * @returns {Object} The shived DocumentFragment.
         */
        function createDocumentFragment(ownerDocument, data){
          if (!ownerDocument) {
            ownerDocument = document;
          }
          if(supportsUnknownElements){
            return ownerDocument.createDocumentFragment();
          }
          data = data || getExpandoData(ownerDocument);
          var clone = data.frag.cloneNode(),
          i = 0,
          elems = getElements(),
          l = elems.length;
          for(;i<l;i++){
            clone.createElement(elems[i]);
          }
          return clone;
        }

        /**
         * Shivs the `createElement` and `createDocumentFragment` methods of the document.
         * @private
         * @param {Document|DocumentFragment} ownerDocument The document.
         * @param {Object} data of the document.
         */
        function shivMethods(ownerDocument, data) {
          if (!data.cache) {
            data.cache = {};
            data.createElem = ownerDocument.createElement;
            data.createFrag = ownerDocument.createDocumentFragment;
            data.frag = data.createFrag();
          }


          ownerDocument.createElement = function(nodeName) {
            //abort shiv
            if (!html5.shivMethods) {
              return data.createElem(nodeName);
            }
            return createElement(nodeName, ownerDocument, data);
          };

          ownerDocument.createDocumentFragment = Function('h,f', 'return function(){' +
                                                          'var n=f.cloneNode(),c=n.createElement;' +
                                                          'h.shivMethods&&(' +
                                                          // unroll the `createElement` calls
                                                          getElements().join().replace(/[\w\-]+/g, function(nodeName) {
            data.createElem(nodeName);
            data.frag.createElement(nodeName);
            return 'c("' + nodeName + '")';
          }) +
            ');return n}'
                                                         )(html5, data.frag);
        }

        /*--------------------------------------------------------------------------*/

        /**
         * Shivs the given document.
         * @memberOf html5
         * @param {Document} ownerDocument The document to shiv.
         * @returns {Document} The shived document.
         */
        function shivDocument(ownerDocument) {
          if (!ownerDocument) {
            ownerDocument = document;
          }
          var data = getExpandoData(ownerDocument);

          if (html5.shivCSS && !supportsHtml5Styles && !data.hasCSS) {
            data.hasCSS = !!addStyleSheet(ownerDocument,
                                          // corrects block display not defined in IE6/7/8/9
                                          'article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}' +
                                            // adds styling not present in IE6/7/8/9
                                            'mark{background:#FF0;color:#000}' +
                                            // hides non-rendered elements
                                            'template{display:none}'
                                         );
          }
          if (!supportsUnknownElements) {
            shivMethods(ownerDocument, data);
          }
          return ownerDocument;
        }

        /*--------------------------------------------------------------------------*/

        /**
         * The `html5` object is exposed so that more elements can be shived and
         * existing shiving can be detected on iframes.
         * @type Object
         * @example
         *
         * // options can be changed before the script is included
         * html5 = { 'elements': 'mark section', 'shivCSS': false, 'shivMethods': false };
         */
        var html5 = {

          /**
           * An array or space separated string of node names of the elements to shiv.
           * @memberOf html5
           * @type Array|String
           */
          'elements': options.elements || 'abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output progress section summary template time video',

          /**
           * current version of html5shiv
           */
          'version': version,

          /**
           * A flag to indicate that the HTML5 style sheet should be inserted.
           * @memberOf html5
           * @type Boolean
           */
          'shivCSS': (options.shivCSS !== false),

          /**
           * Is equal to true if a browser supports creating unknown/HTML5 elements
           * @memberOf html5
           * @type boolean
           */
          'supportsUnknownElements': supportsUnknownElements,

          /**
           * A flag to indicate that the document's `createElement` and `createDocumentFragment`
           * methods should be overwritten.
           * @memberOf html5
           * @type Boolean
           */
          'shivMethods': (options.shivMethods !== false),

          /**
           * A string to describe the type of `html5` object ("default" or "default print").
           * @memberOf html5
           * @type String
           */
          'type': 'default',

          // shivs the document according to the specified `html5` object options
          'shivDocument': shivDocument,

          //creates a shived element
          createElement: createElement,

          //creates a shived documentFragment
          createDocumentFragment: createDocumentFragment
        };

        /*--------------------------------------------------------------------------*/

        // expose html5
        window.html5 = html5;

        // shiv the document
        shivDocument(document);

    }(this, document));
    /*>>shiv*/

    // Assign private properties to the return object with prefix
    Modernizr._version      = version;

    // expose these for the plugin API. Look in the source for how to join() them against your input
    /*>>prefixes*/
    Modernizr._prefixes     = prefixes;
    /*>>prefixes*/
    /*>>domprefixes*/
    Modernizr._domPrefixes  = domPrefixes;
    Modernizr._cssomPrefixes  = cssomPrefixes;
    /*>>domprefixes*/

    /*>>mq*/
    // Modernizr.mq tests a given media query, live against the current state of the window
    // A few important notes:
    //   * If a browser does not support media queries at all (eg. oldIE) the mq() will always return false
    //   * A max-width or orientation query will be evaluated against the current state, which may change later.
    //   * You must specify values. Eg. If you are testing support for the min-width media query use:
    //       Modernizr.mq('(min-width:0)')
    // usage:
    // Modernizr.mq('only screen and (max-width:768)')
    Modernizr.mq            = testMediaQuery;
    /*>>mq*/

    /*>>hasevent*/
    // Modernizr.hasEvent() detects support for a given event, with an optional element to test on
    // Modernizr.hasEvent('gesturestart', elem)
    Modernizr.hasEvent      = isEventSupported;
    /*>>hasevent*/

    /*>>testprop*/
    // Modernizr.testProp() investigates whether a given style property is recognized
    // Note that the property names must be provided in the camelCase variant.
    // Modernizr.testProp('pointerEvents')
    Modernizr.testProp      = function(prop){
        return testProps([prop]);
    };
    /*>>testprop*/

    /*>>testallprops*/
    // Modernizr.testAllProps() investigates whether a given style property,
    //   or any of its vendor-prefixed variants, is recognized
    // Note that the property names must be provided in the camelCase variant.
    // Modernizr.testAllProps('boxSizing')
    Modernizr.testAllProps  = testPropsAll;
    /*>>testallprops*/


    /*>>teststyles*/
    // Modernizr.testStyles() allows you to add custom styles to the document and test an element afterwards
    // Modernizr.testStyles('#modernizr { position:absolute }', function(elem, rule){ ... })
    Modernizr.testStyles    = injectElementWithStyles;
    /*>>teststyles*/


    /*>>prefixed*/
    // Modernizr.prefixed() returns the prefixed or nonprefixed property name variant of your input
    // Modernizr.prefixed('boxSizing') // 'MozBoxSizing'

    // Properties must be passed as dom-style camelcase, rather than `box-sizing` hypentated style.
    // Return values will also be the camelCase variant, if you need to translate that to hypenated style use:
    //
    //     str.replace(/([A-Z])/g, function(str,m1){ return '-' + m1.toLowerCase(); }).replace(/^ms-/,'-ms-');

    // If you're trying to ascertain which transition end event to bind to, you might do something like...
    //
    //     var transEndEventNames = {
    //       'WebkitTransition' : 'webkitTransitionEnd',
    //       'MozTransition'    : 'transitionend',
    //       'OTransition'      : 'oTransitionEnd',
    //       'msTransition'     : 'MSTransitionEnd',
    //       'transition'       : 'transitionend'
    //     },
    //     transEndEventName = transEndEventNames[ Modernizr.prefixed('transition') ];

    Modernizr.prefixed      = function(prop, obj, elem){
      if(!obj) {
        return testPropsAll(prop, 'pfx');
      } else {
        // Testing DOM property e.g. Modernizr.prefixed('requestAnimationFrame', window) // 'mozRequestAnimationFrame'
        return testPropsAll(prop, obj, elem);
      }
    };
    /*>>prefixed*/


    /*>>cssclasses*/
    // Remove "no-js" class from <html> element, if it exists:
    docElement.className = docElement.className.replace(/(^|\s)no-js(\s|$)/, '$1$2') +

                            // Add the new classes to the <html> element.
                            (enableClasses ? ' js ' + classes.join(' ') : '');
    /*>>cssclasses*/

    return Modernizr;

})(this, this.document);
angular.module('igTypeahead', []).directive('typeahead', function(){
  return{
    restrict: 'E',
    replace: true,
    scope: {
      choice: '=',
      list: '='
    },
    template: '<input type="text" ng-model="choice" />',
    link: function(scope, element, attrs){
      scope.typeaheadElement = element;
      $(element).typeahead({
        source: scope.list,
        updater: function(item){
          scope.$apply(function(){
            scope.choice = item;
          });
          return item;
        }
      });
      
      scope.$watch('list', function(newList, oldList){
        $(element).data('typeahead').source = newList;
      } ,true);
    }
  };
});
/*
 Multiple-select directive for AngularJS
 (c) 2013 Alec LaLonde (https://github.com/alalonde/angular-multi-select)
 License: MIT
*/
(function(angular) {
    'use strict';

    angular.module('multi-select', ["template/multiSelect.html"])
        .directive('multiSelect', ['$q', '$parse', function($q, $parse) {

            function appendSelected(entities) {
                var newEntities = [];
                angular.forEach(entities, function(entity) {
                    var appended = entity;
                    appended.selected = false;
                    newEntities.push(appended);
                });
                return newEntities;
            }

            return {
                restrict: 'E',
                require: 'ngModel',
                scope: {
                    selectedLabel: "@",
                    availableLabel: "@",
                    available: "=",
                    model: "=ngModel",
                    config: "="
                },
                templateUrl: "template/multiSelect.html",
                link: function(scope, elm, attrs, controllers) {
                    scope.selected = {
                        available: [],
                        current: []
                    };

                    /* Filters out items in original that are also in toFilter. Compares by reference. */
                    function filterOut(original, toFilter) {
                        var filtered = [];
                        angular.forEach(original, function(entity) {
                            var match = false;
                            for (var i = 0; i < toFilter.length; i++) {
                                if (scope.renderItem(toFilter[i]) == scope.renderItem(entity)) {
                                    match = true;
                                    break;
                                }
                            }
                            if (!match) {
                                filtered.push(entity);
                            }
                        });
                        return filtered;
                    }

                    function parseExpression(item, expr) {
                        var displayComponents = expr.match(/(.+)\s+as\s+(.+)/);
                        var ctx = {};
                        ctx[displayComponents[1]] = item;
                        return $parse(displayComponents[2])(ctx);
                    }

                    var requiredMin, inputModel;

                    function ensureMinSelected() {
                        if (requiredMin && scope.model) {
                            scope.numSelected = scope.model.length;
                            inputModel.$setValidity('min', scope.numSelected >= requiredMin);
                        }
                    }

                    scope.refreshAvailable = function() {
                        if (scope.model && scope.available) {
                            scope.available = filterOut(scope.available, scope.model);
                            scope.selected.available = appendSelected(scope.available);
                            scope.selected.current = appendSelected(scope.model);
                        }
                    };

                    scope.add = function() {
                        if (!scope.model.length)
                            scope.model = [];
                        scope.model = scope.model.concat(scope.selected(scope.selected.available));
                    };
                    scope.remove = function() {
                        var selected = scope.selected(scope.selected.current);
                        scope.available = scope.available.concat(selected);
                        scope.model = filterOut(scope.model, selected);
                    };
                    scope.selected = function(list) {
                        var found = [];
                        angular.forEach(list, function(item) {
                            if (item.selected === true) found.push(item); });
                        return found;
                    };

                    //Watching the model, updating if the model is a resolved promise
                    scope.watchModel = function() {
                        if (scope.model && scope.model.hasOwnProperty('$promise') && !scope.model.$resolved) {
                            scope.model.then(function(results) {
                                scope.$watch('model', scope.watchModel);
                            });
                        } else {
                            scope.refreshAvailable();
                            scope.$watch('model', scope.refreshAvailable);
                        }
                    };

                    //Watching the list of available items. Updating if it is a resolved promise, and refreshing the 
                    //available list if the list has changed
                    var _oldAvailable = {};
                    scope.watchAvailable = function() {
                        if (scope.available && scope.available.hasOwnProperty('$promise') && !scope.available.$resolved) {
                            scope.available.$promise.then(function(results) {
                                scope.$watch('available', scope.watchAvailable);
                            });
                        } else {
                            //We only want to refresh the list if the list of available items has changed
                            //and the variable is defined
                            if (scope.available && scope.available != _oldAvailable) {
                                scope.refreshAvailable();
                                _oldAvailable = scope.available;
                            }
                        }
                    };

                    scope.$watch("available", scope.watchAvailable);
                    scope.$watch("model", scope.watchModel);

                    scope.renderItem = function(item) {
                        return parseExpression(item, attrs.display);
                    };

                    scope.renderTitle = function(item) {
                        if (attrs.title) {
                            return parseExpression(item, attrs.title);
                        }
                        return "";
                    };

                    if (scope.config && angular.isDefined(scope.config.requiredMin)) {
                        var inputs = elm.find("input");
                        var validationInput = angular.element(inputs[inputs.length - 1]);
                        inputModel = validationInput.controller('ngModel');
                    }

                    scope.$watch('config.requiredMin', function(value) {
                        if (angular.isDefined(value)) {
                            requiredMin = parseInt(value, 10);
                            ensureMinSelected();
                        }
                    });

                    scope.$watch('model', function(selected) {
                        ensureMinSelected();
                    });
                }
            };
        }]);
  

    
    angular.module("template/multiSelect.html", []).run(["$templateCache", function($templateCache) {
        $templateCache.put("template/multiSelect.html",
            '<div class="multiSelect">' +
            '<div class="select seldiv">' +
            '<label class="control-label" for="multiSelectAvailable">{{ availableLabel }} ' +
            '({{ available.length }})</label>' +
            '<ul>' +
            '<li ng-repeat="entity in available">' +
            '<label class="checkbox" title="{{ renderTitle(entity) }}">' +
            '<input type="checkbox" ng-model="selected.available[$index].selected"> ' +
            '{{ renderItem(entity) }}' +
            '</label>' +          
            '</li>'+
            '</ul>' +
            '</div>' +
            '<div class="select buttons" style="padding-left: 20px;">' +
            '<button class="btn mover left" ng-click="add()" title="Add selected" ' +
            'ng-disabled="!selected(selected.available).length">' +
            '<i class="fa fa-arrow-right" aria-hidden="true"></i>' +
            '</button>' +
            '<button class="btn mover right" ng-click="remove()" title="Remove selected" ' +
            'ng-disabled="!selected(selected.current).length">' +
            '<i class="fa fa-arrow-left" aria-hidden="true"></i>' +
            '</button>' +

            '</div>' +
            '<div class="select seldiv">' +
            '<label class="control-label" for="multiSelectSelected">{{ selectedLabel }} ' +
            '({{ model.length }})</label>' +
            '<ul>' +
            '<li ng-repeat="entity in model">' +
            '<label class="checkbox" title="{{ renderTitle(entity) }}">' +
            '<input type="checkbox" ng-model="selected.current[$index].selected"> ' +
            '{{ renderItem(entity) }}' +
            '</label>' +
            '</li>' +
            '</ul>' +
            '</div>' +
            '<input type="number" name="numSelected" ng-model="numSelected" ' +
            'style="display: none">' +
            '</div>');
    }]);
})(angular);

"use strict";

// Declare app level module which depends on views, and components
var mainApp = angular.module("myApp", [
  "ngRoute",
  "ngDragDrop",
  "ui.tinymce",
  "angular-growl",
  "ui.bootstrap",
  "ui.grid",
  "ui.grid.edit",
  "ui.grid.rowEdit",
  "ui.grid.saveState",
  "ui.grid.pagination",
  "ui.grid.moveColumns",
  "ui.grid.resizeColumns",
  "ui.grid.selection",
  "infinite-scroll",
  "toggle-switch",
  "angular-input-stars",
  "angularUtils.directives.dirPagination",
  "MassAutoComplete",
  "angular.filter",
  "myApp.howToVideo",
  "ngIdle",
  "chart.js",
  "myApp.welcomeView",
  "myApp.voterSignup",
  "myApp.politicianSignup",
  "myApp.advocateSignup",
  "myApp.questionHome",
  "myApp.questionSubcategories",
  "myApp.question",
  "myApp.debateHome",
  "myApp.essay",
  "myApp.essayStaff",
  "myApp.essayDetails",
  "myApp.essayList",
  "myApp.newEssay",
  "myApp.essayUpdate",
  "myApp.essaySearch",
  "myApp.forum",
  "myApp.updateTopic",
  "myApp.forumthread",
  "myApp.forumSearch",
  "myApp.forumReply",
  "myApp.forumList",
  "myApp.publicProfile",
  "myApp.votingRecords",
  "myApp.sponsored",
  "myApp.topic",
  "myApp.localDebate",
  "myApp.learnHome",
  "myApp.pressHome",
  "myApp.liveFeed",
  "myApp.pressProfile",
  "myApp.pressComment",
  "myApp.signin",
  "myApp.advocateHome",
  "myApp.signup",
  "myApp.localPress",
  "myApp.advocateHome",
  "myApp.compareSelect",
  "myApp.compareSubjectWise",
  "myApp.compareSubcategories",
  "myApp.dashboard",
  "myApp.snapshot",
  "myApp.reports",
  "myApp.match",
  "myApp.emailunsubscribe",
  "myApp.updateUserAddress",
  "myApp.forgotpassword",
  "myApp.donate",
  "myApp.contactUs",
  "myApp.faq",
  "myApp.printUsers",
  "myApp.boardsofelections",
  "myApp.politicianThread",
  "myApp.essayPress",
  "myApp.newPressEssay",
  "myApp.pressEssayUpdate",
  "myApp.pressEssayStaff",
  "myApp.pressEssayDetails",
  "myApp.commonPhrases",
  "myApp.electionProblems",
  "myApp.aboutUs",
  "myApp.incumbentPolitician",
  "myApp.calendar",
  "myApp.digDeeperView",
  "myApp.fiveMatchView",
  "myApp.fiveMatchCompare",
  "myApp.fiveMinSaveUser",
  "myApp.fiveminsignin",
  "myApp.politician_compare",
  "myApp.compare_politician_questions",
  "myApp.gettingStarted",
  "myApp.gettingStartedOrg",
  "myApp.gettingStartedPol",
  "myApp.speakOut",
  "myApp.legislation",
  "myApp.geoCode",
  "myApp.polProfile",
  "myApp.polProfileSetUp",
  "myApp.winVoters",
  "myApp.allRatings",
  "myApp.compareRatings",
  "myApp.ratingsDetails",
  "myApp.polFinance",
  "myApp.research",
  "myApp.findMatch",
  "myApp.addRating",
  "myApp.userProfile",
  "myApp.checkRegistration",
  "myApp.registerToVote",
  "myApp.getAReminder",
  "myApp.absenteeBallots",
  "angular-js-xlsx",
  "ngJsonExportExcel",
  "youtube-embed",
  "myApp.ratingReviews",
  "myApp.votesmart",
  "myApp.allies",
  "updateMeta",
  "myApp.ballotMatch",
  "myApp.answeredQuestions",
  "myApp.followingUsers",
  "myApp.addCategory",
  "myApp.manageQue",
  "myApp.fiveMatchQuestions",
  "myApp.verifyUsers",
  "myApp.uploadPolitician",
  "myApp.restorePolitician",
  "myApp.uploadAdvocate",
  "myApp.uploadPress",
  "myApp.topicSpams",
  "myApp.allUsers",
  "myApp.allTopics",
  "myApp.allEssay",
  "myApp.allCongressman",
  "myApp.sendEmail",
  "myApp.organizedTable",
  "myApp.backup",
  "myApp.openFecCandidates",
  "myApp.openFecCommittee",
  "myApp.placesShape",
  "myApp.gridState",
  "myApp.uploadNewPolitician",
  "myApp.questionBackGround",
  "myApp.questionAnsweredBy",
  "myApp.questionSearch",
  "myApp.questionComparePolitician",
  "myApp.questionCompare",
  "myApp.totalUsers",
  "myApp.openState",
  "myApp.openStateBills",
  "myApp.viewBills",
  "myApp.viewBillDetails",
  "myApp.theConstitution",
  "myApp.getBillVoteRecords",
  "myApp.federalLegislation",
  "myApp.federalDetail",
  "myApp.federalBills",
  "myApp.getRollVotes",
  "myApp.getVotesDetails",
  "myApp.federalTextBills",
  "myApp.upcomingElection",
  "myApp.takeAction",
  "myApp.addPolitician",
  "ngCookies",
  "myApp.whatAmILookingAt1",
  "myApp.whatAmILookingAt2",
  "myApp.whatAmILookingAt3",
  "myApp.whatAmILookingAt4",
  "myApp.compareGuest",
  "myApp.compareGuestWith",
  "myApp.displayGuestForPolitician",
  "myApp.compareWithGroup",
  "myApp.showComments",
  "myApp.showAnswers",
  "myApp.showGroupAnswer",
  "myApp.trackUserActivities",
  "myApp.uploadElectionDate",
  "myApp.ratePolitician",
  "myApp.highlightedPost",
  "myApp.manageOrganizationQuestions",
  "myApp.allEndorsements",
  "myApp.addEndorsement",
  "myApp.endorsePolitician",
  "myApp.orgQuestions",
  "myApp.ballotMeasures",
  "myApp.orgRating",
  "myApp.allQuizzes",
  "myApp.invitePoliticians",
  "myApp.organizationQuiz",
  "myApp.orgActivityDetails",
  "myApp.alliesP",
  "myApp.compositeQuiz",
  "myApp.getPopularQues",
  "myApp.uploadFollowers",
  "myApp.followersQuiz",
  "myApp.quizzes",
  "myApp.quizzesOrg",
  "myApp.showPoliAns",
  "myApp.orgQuizComparison",
  "myApp.orgMatch",
  "myApp.quizResult",
  "myApp.showPoliQuiz",
  "myApp.showFollowersQuiz",
  "myApp.showPopUp",
  "myApp.poliAnswers",
  "myApp.politicianMatch",
  "myApp.listOfFollowers",
  "myApp.poliCompare",
  "myApp.matchOfFollowers",
  "myApp.popularQuizMatch",
  "myApp.getPopularComparison",
  "myApp.showFbMessage",
  "myApp.postOnFaceBook",
  "myApp.voterProfile",
  "myApp.showHideAns",
  "myApp.resetPassword",
  "myApp.stripe",
  "myApp.showMelisaData",
  "myApp.privacyPolicy",
  "myApp.discussWithOthers",
  "myApp.showMessage",
  "myApp.howABillBecomesALaw",
  "myApp.uploadBallotMeasures",
  "myApp.editBallotMeasures",
  "myApp.rateBallotMeasures",
  "myApp.ballotRating",
  "myApp.ballotReviewDetails",
  "myApp.endorseBallot",
  "myApp.showBallotEndorsement",
  "myApp.ballotThread",
  "myApp.createBallotThread",
  "myApp.showVotesmartAnsQues",
  "myApp.otherPoliticians",
  "myApp.showListOfMatch",
  "myApp.501c4Video",
  "myApp.exportOrgRatings",
  "myApp.exploreQuiz",
  "myApp.followersGroupAnswer",
  "myApp.findFollowerMatch",
  "myApp.showAllUsersMatch",
  "myApp.orgVideo",
  "myApp.politicianVideo",
  "myApp.postingHints",
  "myApp.representativeVideo",
  "myApp.fiveMinLanding",
  "myApp.trackFiveMinQuizAns",
  "myApp.uploadPopulationData",
  "myApp.trackPoliticians",
  "myApp.showCompetitors",
  "myApp.addFiveMinEssayQues",
  "myApp.fiveMinEssayAnswers",
  "myApp.addEssayAnswers",
  "myApp.compareEssayAns",
  "myApp.uploadBarAssociations",
  "myApp.createBanner",
  "myApp.generatePostCards",
  "myApp.addDebate",
  "myApp.sendInvitations",
]);

// mainApp.value("baseApiUrl", "http://localhost:8080");
//mainApp.value("baseApiUrl", "https://test.votewise.net");
 mainApp.value("baseApiUrl", "https://api.votewise.net");
//mainApp.value('baseApiUrl', 'http://162.243.162.231:8080');
mainApp.value("showConsole", false);

var tokenName = "VoteWise:JWT";
var tokenUserName = "VoteWise:User";
var tokenUserId = "VoteWise:UserId";
var tokenUserRole = "VoteWise:UserRole";
var tokenUserData = "VoteWise:UserData";

mainApp.service("tokenService", [
  "$http",
  "$rootScope",
  function ($http, $rootScope) {
    var tokenService = {
      saveToken: function (token) {
        window.localStorage[tokenName] = token;
      },
      getToken: function () {
        return window.localStorage[tokenName];
      },
      destroyToken: function () {
        window.localStorage.removeItem(tokenName);
        window.localStorage.removeItem(tokenUserName);
        window.localStorage.removeItem(tokenUserId);
        window.localStorage.removeItem(tokenUserRole);
        window.localStorage.removeItem(tokenUserData);

        $rootScope.userRole = null;
        $rootScope.User = null;
        $rootScope.UserId = null;
      },
      saveUserName: function (name) {
        window.localStorage[tokenUserName] = name;
      },
      saveUserRole: function (userobj) {
        $rootScope.userRole = userobj.userType;
        window.localStorage[tokenUserRole] = $rootScope.userRole;
      },
      getUserRole: function () {
        return window.localStorage[tokenUserRole];
      },
      getUserName: function () {
        return window.localStorage[tokenUserName];
      },
      saveUserId: function (id) {
        window.localStorage[tokenUserId] = id;
      },
      getUserId: function () {
        return window.localStorage[tokenUserId];
      },
      saveUserData: function (data) {
        window.localStorage[tokenUserData] = data;
      },
      getUserData: function () {
        return window.localStorage[tokenUserData];
      },
    };
    return tokenService;
  },
]);

mainApp.config([
  "$locationProvider",
  "$routeProvider",
  "growlProvider",
  "$httpProvider",
  "IdleProvider",
  "KeepaliveProvider",
  "$rootScopeProvider",
  "$compileProvider",
  function (
    $locationProvider,
    $routeProvider,
    growlProvider,
    $httpProvider,
    IdleProvider,
    KeepaliveProvider,
    $rootScopeProvider,
    $compileProvider
  ) {
    // $locationProvider.hashPrefix('!');
    // console.log('load');
    $compileProvider.aHrefSanitizationWhitelist(
      /^\s*(https?|file|tel|javascript):/
    );
    var url =
      "https://api.votewise.net/resources/stop-and-frisk-2-(1-of-1)-1488802259580.jpg";
    // var url = "stop-and-frisk-2-(1-of-1)-1488802259580.jpg";

    $("head > meta[property='og:image']").attr("content", url);
    IdleProvider.idle(2 * 60 * 60); // in seconds
    IdleProvider.timeout(30 * 60); // in seconds
    KeepaliveProvider.interval(40 * 60); // in seconds
    $rootScopeProvider.welcome = false;

    function checkUser() {
      var token = window.localStorage["VoteWise:JWT"];
      if (token) {
        // return $routeProvider.otherwise({ redirectTo: '/debateHome' });
        return $routeProvider.otherwise({
          redirectTo: "/questionHome",
        });
      }
      return $routeProvider.otherwise({
        redirectTo: "/welcome",
      });
    }
    checkUser();
    growlProvider.globalTimeToLive(60000);
    growlProvider.globalDisableCountDown(true);
    growlProvider.globalPosition("top-center");
    $httpProvider.interceptors.push("APIInterceptor");
  },
]);

mainApp.run([
  "tokenService",
  "MyService",
  "$location",
  "$rootScope",
  "$http",
  "$window",
  "growl",
  "$uibModal",
  "baseApiUrl",
  "apiCall",
  "$timeout",
  "$q",
  "$filter",
  "ngDialog",
  "$anchorScroll",
  "Idle",
  "$cookies",
  function (
    tokenService,
    MyService,
    $location,
    $rootScope,
    $http,
    $window,
    growl,
    $uibModal,
    baseApiUrl,
    apiCall,
    $timeout,
    $q,
    $filter,
    ngDialog,
    $anchorScroll,
    Idle,
    $cookies
  ) {
    $(window).load(function () {
      setTimeout;
      // Animate loader off screen
      $(".se-pre-con").fadeOut("slow");
    });
    $(window).load(function () {
      // Animate loader off screen
      $(".backLogo").fadeOut("slow");
    });
    $cookies.remove("showLongPopUp");
    $rootScope.welcome = false;
    Idle.watch();
    $rootScope.imgUrl = baseApiUrl + "/resources";
    $rootScope.redirectExceptions = ["forgot-password", "signin", "signup"];
    var path = $location.path();
    $window.ga("create", "UA-84996430-1", "auto");

    $rootScope.dynamicTitle =
      "VoteWise.net - In life, you can vote with wallet, with your voice, with your actions and at the ballot box. But it's important to always vote wisely.";
    $rootScope.dynamicDescription =
      "VoteWise.net is a non-partisan non-profit tool aimed at repairing democracy by connecting voters, politicians and organizations without advertising dollars getting in the way. There are different tools available to different types of users, so click on a user type below, watch the 2 minute video and start saving the world.";
    $rootScope.dynamicImage =
      "https://votewise.net/assets/images/VoteWiseMeta.jpg";
    MyService.ConsoleLog("Here in run");
    // track pageview on state change
    window.localStorage.removeItem("HistoryPage");
    $rootScope.$on("$routeChangeSuccess", function (event) {
      //console.log("path<><><><",$location.path());
      // //  MyService.ConsoleLog("path1<><><><",path);
      // $rootScope.title = window.localStorage.getItem('fbName');
      // $rootScope.ogImgUrl =$rootScope.imgUrl+'/'+ window.localStorage.getItem('fbImg');
      $window.ga("send", "pageview", $location.path());
    });

    // $rootScope.getElectionsDate = function () {
    //   MyService.ConsoleLog("In get elections date");
    //   MyService.getElectionsDate({}).then(function (success) {
    //     MyService.ConsoleLog("Elections date : ", success);
    //   }, function (err) {
    //     MyService.ConsoleLog("error : ", err);
    //   });
    // };
    // $rootScope.getElectionsDate();
    $rootScope.gotoAnchor = function (x) {
      var newHash = x;
      if ($location.hash() !== newHash) {
        // set the $location.hash to `newHash` and
        // $anchorScroll will automatically scroll to it
        $location.hash(x);
      } else {
        // call $anchorScroll() explicitly,
        // since $location.hash hasn't changed
        $anchorScroll();
      }
    };

    $rootScope.$on("IdleTimeout", function () {
      //alert("Ideal timeout called");
      // the user has timed out (meaning idleDuration + timeout has passed without any activity)
      //this is where you'd log them
      $rootScope.Logout();
    });

    $rootScope.statusGetCategories = 0;
    var getCategoriesCanceler = $q.defer();
    $rootScope.getCategories = function () {
      $rootScope.statusGetCategories = 1;
      getCategoriesCanceler.resolve();
      getCategoriesCanceler = $q.defer();
      var request = apiCall.apiCall("GET", "/categories/list", {
        root: 1,
        questions_counter: 1,
        catTypes: "Q,B",
      });
      request.timeout = getCategoriesCanceler;
      $http(request).then(
        function successCallback(response) {
          if (response.data.success) {
            $rootScope.categories = response.data.data;
            $rootScope.statusGetCategories = 2;
            $rootScope.$broadcast("EventParentCategoriesFetched");
            //MyService.ConsoleLog("Got rootScope categories");
          } else {
            $rootScope.statusGetCategories = 3;
            //MyService.ConsoleLog("Something went wrong: ", response.data);
          }
        },
        function errorCallBack(response) {
          $rootScope.statusGetCategories = 3;
          //MyService.ConsoleLog("Error: ", response);
        }
      );
    };

    $rootScope.getVerificationUrl = function () {
      var hostUrl = window.location.host;
      var port = window.location.port;
      if (port == undefined || port == "") {
        hostUrl += ":" + port;
      }

      hostUrl += "/#!/verify";

      if (hostUrl.indexOf("http") == -1) hostUrl = "http://" + hostUrl;

      return hostUrl;
    };

    $rootScope.getPasswordResetUrl = function () {
      var hostUrl = window.location.host;
      var port = window.location.port;
      if (port == undefined || port == "") {
        hostUrl += ":" + port;
      }

      hostUrl += "/#!/forgot-password/<RESET_TOKEN>";

      if (hostUrl.indexOf("http") == -1) hostUrl = "http://" + hostUrl;

      return hostUrl;
    };
    $rootScope.getEmailUnsubscribeUrl = function () {
      var hostUrl = window.location.host;
      var port = window.location.port;
      if (port == undefined || port == "") {
        hostUrl += ":" + port;
      }

      hostUrl += "/#!/email-unsubscribe";
      if (hostUrl.indexOf("http") == -1) hostUrl = "http://" + hostUrl;

      return hostUrl;
    };

    $rootScope.NewUserData = {
      zipcode: "",
      usertype: "",
    };

    if (
      tokenService.getToken() != undefined &&
      tokenService.getToken() != null &&
      tokenService.getToken() != ""
    ) {
      // $http.defaults.headers.common['x-access-token'] = tokenService.getToken();
      //console.log("got the place one");
      $rootScope.Auth = true;
      $rootScope.User = tokenService.getUserName();
      $rootScope.UserId = tokenService.getUserId();
      $rootScope.getCategories();
      $rootScope.userRole = window.localStorage[tokenUserRole];
    }
    //MyService.ConsoleLog("App Run");
    $rootScope.$on("$routeChangeStart", function (event) {
      $timeout(function () {
        $(".growl-item .close").trigger("click");
      });
      // $http.defaults.headers.common['x-access-token'] = tokenService.getToken();
      $rootScope.User = tokenService.getUserName();
      //}
      // //console.log("got the place two", $location.path());
      if ($location.path() != "/welcome") {
        $rootScope.getCategories();
      }
    });

    $rootScope.searchQuestion = function () {
      if (!$filter("isBlankString")($rootScope.searchQuestionKeyword)) {
        $location.path("/question-search");
      }
    };

    $rootScope.dismissLoginConfirmation = function () {
      $("#loginConfirmModal").modal("hide");
      window.history.back();
    };

    $rootScope.showLoginConfirmation = function () {
      // MyService.ConsoleLog("Show login confirmation");
      $("#loginConfirmModal").modal("show");
    };

    $rootScope.logoutConfirmed = function (hideModal) {
      $cookies.remove("isExist");
      $cookies.remove("qName");
      $cookies.remove("orgId");
      $cookies.remove("poliId");
      $cookies.remove("showLogin");
      window.localStorage.removeItem("inviterInfo");
      $cookies.remove("quizTakerIdsArr");
      window.localStorage.removeItem("isFindFollowers");
      window.localStorage.removeItem("inviterId");
      window.localStorage.removeItem("isShowSpecialMatch");
      window.localStorage.removeItem("specialQueAns");
      window.localStorage.removeItem("isShowOldResult");
      window.localStorage.removeItem("compareResult");
      window.localStorage.removeItem("isPostCard");
      // window.localStorage.removeItem("queIdsN");

      if (hideModal) $("#loginConfirmModal").modal("hide");
      var request = apiCall.apiCall("POST", "/user/logout", {
        userid: $rootScope.UserId,
      });
      $http(request).then(
        function successCallback(response) {
          //MyService.ConsoleLog("Logout successful");
        },
        function errorCallBack(response) {
          //MyService.ConsoleLog("Error: ", response);
        }
      );

      // $http.defaults.headers.common['x-access-token'] = '';
      // $rootScope.Auth = false;

      tokenService.destroyToken();
      $location.path("/signin");
      if (!hideModal) $window.location.reload();
    };

    $rootScope.Logout = function (menu) {
      if (menu) {
        $rootScope.logoutConfirmed(false);
      } else {
        $rootScope.showLoginConfirmation();
      }
    };

    $rootScope.OpenLoginPopup = function () {
      /*$rootScope.modalInstance = $uibModal.open({
        templateUrl: 'signin/user-info-popup.html',
        //scope: $rootScope,
        size: 'md',
        resolve: {
            Context: function () {
                return {

                };
            }
        }
    });*/
      if (typeof FB != "undefined" && FB != null) {
        $rootScope.statusAuthenticate = 1;
        FB.login(
          function (response) {
            //MyService.ConsoleLog(response);
            statusChangeCallback(response, "login");
          },
          {
            scope: "public_profile,email",
          }
        );
      } else {
        growl.error(
          "Facebook resources not loaded yet. Please try after some time."
        );
      }
    };

    $rootScope.LoginWithFacebook = function () {
      /*if ($.fn.validateForceFully($("#userinfoform")) == true) {}*/
      if ($("#userinfoform").validationEngine("validate") == true) {
        //MyService.ConsoleLog("all good: ", $rootScope.NewUserData);
        FB.login(
          function (response) {
            //MyService.ConsoleLog(response);
            statusChangeCallback(response, "signup");
          },
          {
            scope: "public_profile,email",
          }
        );
      }
    };

    // This is called with the results from from FB.getLoginStatus().
    function statusChangeCallback(response, optn) {
      // MyService.ConsoleLog("response",response);
      if (response.status === "connected") {
        getUserInfo(optn);
      } else if (response.status === "not_authorized") {
        growl.info("Please log " + "into this app.");
        $rootScope.statusAuthenticate = 3;
      } else {
        // alert("heh");
        growl.error("Please log " + "into Facebook.");
        $rootScope.statusAuthenticate = 3;
      }
    }

    $rootScope.suggest_organization = function (term, org_type) {
      var q = term.toLowerCase().trim();
      //MyService.ConsoleLog("term: ", term);

      var deferred = $q.defer();

      var postdata = {
        max_records: 5,
        keyword: term,
        type: org_type.toLowerCase(),
      };

      var request = apiCall.apiCall("GET", "/office/list", postdata);

      $http(request).then(
        function successCallback(response) {
          //MyService.ConsoleLog("succss: ", response);
          if (response.data.success) {
            angular.forEach(response.data.data, function (val, key) {
              response.data.data[key].value = val.title;
              response.data.data[key].label = val.title;
            });
            //MyService.ConsoleLog("got org dtaa: ", response.data.data);
            deferred.resolve(response.data.data);
            // growl.success("Tagged successfully");
          } else deferred.resolve([]);
          /*else{
        if(typeof response.data.error == "string")
            growl.error(response.data.error);
        else
            growl.error("Something went wrong");
      }*/
        },
        function errorCallback(response) {
          // growl.error("Something went wrong");
          deferred.resolve([]);
        }
      );

      return deferred.promise;
    };

    $rootScope.suggestPoliticianOffice = function (term, org_type) {
      var q = term.toLowerCase().trim();
      //MyService.ConsoleLog("term: ", term);

      var deferred = $q.defer();

      var postdata = {
        max_records: 5,
        keyword: term,
        type: org_type.toLowerCase(),
      };

      var request = apiCall.apiCall("GET", "/politician-office/list", postdata);

      $http(request).then(
        function successCallback(response) {
          //MyService.ConsoleLog("succss: ", response);
          if (response.data.success) {
            angular.forEach(response.data.data, function (val, key) {
              response.data.data[key].value = val.title;
              response.data.data[key].label = val.title;
            });
            //MyService.ConsoleLog("got org dtaa: ", response.data.data);
            deferred.resolve(response.data.data);
            // growl.success("Tagged successfully");
          } else deferred.resolve([]);
          /*else{
        if(typeof response.data.error == "string")
            growl.error(response.data.error);
        else
            growl.error("Something went wrong");
      }*/
        },
        function errorCallback(response) {
          // growl.error("Something went wrong");
          deferred.resolve([]);
        }
      );

      return deferred.promise;
    };
    $rootScope.suggestJurisdiction = function (term) {
      var q = term.toLowerCase().trim();
      //MyService.ConsoleLog("term: ", term);

      var deferred = $q.defer();

      var postdata = {
        max_records: 5,
        keyword: term,
      };

      var request = apiCall.apiCall("GET", "/jurisdiction/list", postdata);

      $http(request).then(
        function successCallback(response) {
          //MyService.ConsoleLog("succss: ", response);
          if (response.data.success) {
            angular.forEach(response.data.data, function (val, key) {
              response.data.data[key].value = val.title;
              response.data.data[key].label = val.title;
            });
            //MyService.ConsoleLog("got org dtaa: ", response.data.data);
            deferred.resolve(response.data.data);
            // growl.success("Tagged successfully");
          } else deferred.resolve([]);
          /*else{
        if(typeof response.data.error == "string")
            growl.error(response.data.error);
        else
            growl.error("Something went wrong");
      }*/
        },
        function errorCallback(response) {
          // growl.error("Something went wrong");
          deferred.resolve([]);
        }
      );

      return deferred.promise;
    };

    $rootScope.userTypeChanged = function () {
      $rootScope.NewUserData.organization = null;
      $rootScope.NewUserData.organization_name = "";
    };

    $rootScope.org_autocomplete_options = {
      suggest: function (term) {
        return $rootScope.suggest_organization(
          term,
          $rootScope.NewUserData.usertype
        );
      },
      on_select: function (selected) {
        //MyService.ConsoleLog("selected: ", selected);
        // $scope.User.organization_name = selected.label;
        $rootScope.NewUserData.organization = selected;
      },
      on_detach: function (current_value) {
        //MyService.ConsoleLog("on_detach: ", current_value);
        $rootScope.NewUserData.organization_name = current_value;
        /*try{
          if($rootScope.NewUserData.organization.label != current_value)
            $rootScope.NewUserData.organization = null;
      }
      catch(e){
          //MyService.ConsoleLog("Exceptoin: ",e)
          $rootScope.NewUserData.organization = null;
      }*/
      },
    };

    // This function is called when someone finishes with the Login
    // Button. See the onlogin handler attached to it in the sample
    // code below.
    function checkLoginState() {
      FB.getLoginStatus(function (response) {
        statusChangeCallback(response);
      });
    }

    // Here we run a very simple test of the Graph API after login is
    // successful.  See statusChangeCallback() for when this call is made.
    function getUserInfo(optn) {
      FB.api(
        "/me",
        {
          fields: "first_name,last_name,email",
        },
        function (response) {
          //MyService.ConsoleLog("response: ", response);
          if (response != undefined && response != null && response != "") {
            $rootScope.CreateFBUser(response, optn);
          } else {
            $rootScope.statusAuthenticate = 3;
          }
        }
      );
    }
    $rootScope.Errors = [];

    $rootScope.CreateFBUser = function (fbResponse, optn) {
      MyService.ConsoleLog("CreateFBUser : ", optn);
      //MyService.ConsoleLog("CreateFBUser: ", fbResponse);
      //MyService.ConsoleLog("organization_name: ", $rootScope.NewUserData.organization_name);
      $rootScope.Errors = [];

      $rootScope.FBSignIn(fbResponse, function () {
        var postobj = {
          name: fbResponse.first_name + " " + fbResponse.last_name,
          // last_name: fbResponse.last_name,
          username: fbResponse.email.split("@")[0],
          password: "",
          email: fbResponse.email,
          zipcode: $rootScope.NewUserData.zipcode,
          type: $rootScope.NewUserData.usertype.toLowerCase(),
          isfacebooksigin: true,
          facebookid: fbResponse.id,
          verificationurl: $rootScope.getVerificationUrl(),
          unsubscribeurl: $rootScope.getEmailUnsubscribeUrl(),
        };

        switch ($rootScope.NewUserData.usertype.toLowerCase()) {
          case "advocate":
          case "press":
            try {
              if (
                $rootScope.NewUserData &&
                $rootScope.NewUserData.organization._id
              )
                postobj.office_id = $rootScope.NewUserData.organization._id;
              else {
                if (
                  $filter("isBlankString")(
                    $rootScope.NewUserData.organization_name
                  )
                ) {
                  //MyService.ConsoleLog("o: ", $rootScope.NewUserData.organization_name);
                  growl.error("Organization name is required");
                  return;
                }

                postobj.office_phone_number =
                  $rootScope.NewUserData.organization.phone_no;
                postobj.office_web_url =
                  $rootScope.NewUserData.organization.web_url;
                postobj.office_name = $rootScope.NewUserData.organization_name;
              }
            } catch (e) {
              //MyService.ConsoleLog("Exceptoin : ", e);
            }

            postobj.extention_no = $rootScope.NewUserData.extention_no;
            postobj.verification_note =
              $rootScope.NewUserData.verification_note;
            break;
          case "politician":
            postobj.name_on_ballot = $rootScope.NewUserData.name_on_ballot;
            postobj.phone_no = $rootScope.NewUserData.phone_no;
            postobj.mailing_address = $rootScope.NewUserData.mailing_address;
            try {
              if (
                $rootScope.NewUserData &&
                $rootScope.NewUserData.organization._id
              )
                postobj.office_id = $rootScope.NewUserData.organization._id;
              else {
                if (
                  $filter("isBlankString")(
                    $rootScope.NewUserData.organization_name
                  )
                ) {
                  growl.error("Office name is required");
                  return;
                }
                postobj.office_phone_number =
                  $rootScope.NewUserData.organization.phone_no;
                postobj.office_web_url =
                  $rootScope.NewUserData.organization.web_url;
                postobj.office_name = $rootScope.NewUserData.organization_name;
                postobj.office_fabebook_url =
                  $rootScope.NewUserData.organization.facebook_url;
              }
            } catch (e) {}
            break;
        }

        //MyService.ConsoleLog("FBSignIn: ", postobj);

        $http.post(baseApiUrl + "/user/signup", postobj).then(
          function (response) {
            //MyService.ConsoleLog("response: ", response);
            if (response.data.success == true) {
              $rootScope.statusAuthenticate = 2;
              //MyService.ConsoleLog($rootScope.NewUserData.usertype);
              var message = "";
              switch ($rootScope.NewUserData.usertype.toLowerCase()) {
                case "politician":
                  message =
                    "It may take us some time to confirm your identity.  In the meantime, you can use the site, but everything you do will have the byline 'Unknown Politician.'  As soon as we confirm who you are, all your old posts will automatically switch to your real name.";
                  break;
                case "voter":
                  message =
                    "Until you confirm your email, you can read and explore the site, but you won't be able to write responses.";
                  break;
                case "press":
                  message =
                    "It may take us some time to confirm your identity.  In the meantime, you can use the site, but everything you do will have the byline 'Unknown Press.'  As soon as we confirm who you are, all your old posts will automatically switch to your real name.";
                  break;
                case "advocate":
                  message =
                    "It may take us some time to confirm your identity.  In the meantime, you can use the site, but everything you do will have the byline 'Unknown Organization.'  As soon as we confirm who you are, all your old posts will automatically switch to your real name.";
                  break;
              }
              growl.success(message);
              $cookies.put("showLongPopUp", message);

              $rootScope.FBSignIn(fbResponse);

              // $rootScope.modalInstance.dismiss('cancel');

              $location.path("debate");
            } else if (
              response.data.error &&
              typeof response.data.error == "string"
            ) {
              if (optn == "login") {
                growl.error(
                  "User may not exist on server, please sign up first."
                );
              } else {
                growl.error("Error: " + response.data.error);
              }
              $rootScope.statusAuthenticate = 3;
            } else {
              growl.error("Something went wrong.");
              $rootScope.statusAuthenticate = 3;
            }
          },
          function (response) {
            $rootScope.statusAuthenticate = 3;
            var validataionMsg = "";
            //MyService.ConsoleLog("response: ", response)
            var errors = response.data.error.errors;
            for (var k in errors) {
              if (errors.hasOwnProperty(k)) {
                //MyService.ConsoleLog(k)
                var obj = errors[k];
                if (obj.message !== undefined)
                  validataionMsg += obj.message.replace("Path", "") + "<br/>";
              }
            }
            growl.error(validataionMsg);
          }
        );
      });
    };

    /**
     * @description Add answers after login
     */
    function saveFiveMinAnswers() {
      console.log("$cookies.get", $cookies.get("sessionId"));
      if ($cookies.get("sessionId")) {
        MyService.ConsoleLog("saveFiveMinAnswers : ", $rootScope.guestMatch);

        // alert("Inside");

        // var guestArr = $rootScope.guestMatch.filter(function (itms) {
        //   itms._id = itms.questionId;
        //   return itms;
        // });
        // MyService.ConsoleLog('<<<<<<< guestArr >>>>>>>>', guestArr);
        // $rootScope.guestMatch = '';
        // $rootScope.guestMatch = guestArr;
        var len = $rootScope.guestMatch.length;
        if (len > 0) {
          for (var i = 0; i < len; i++) {
            MyService.ConsoleLog($rootScope.guestMatch[i]);
            MyService.postAnswer($rootScope.guestMatch[i]).then(
              function (response) {
                MyService.ConsoleLog(response);
                if (response.data.success) {
                  MyService.ConsoleLog("Answer updated successfully");
                } else {
                  MyService.ConsoleLog("Error: " + response.data.error);
                }
              },
              function (err) {
                MyService.ConsoleLog("Error: ");
              }
            );

            MyService.deleteGuest($rootScope.guestMatch[i]).then(
              function (success) {
                MyService.ConsoleLog("SUccess >>>", success);
              },
              function (err) {
                MyService.ConsoleLog("Error >>", err);
              }
            );
          }
          // $rootScope.guestMatch = "";
          $cookies.remove("sessionId");
          $location.path("/findMatch/true");
        }
      }
      // else {
      //   MyService.ConsoleLog('saveFiveMinAnswers : ');
      //   MyService.ConsoleLog($rootScope.fiveMatch);
      //   var len = $rootScope.fiveMatch.length;
      //   if (len > 0) {
      //     for (var i = 0; i < len; i++) {
      //       MyService.ConsoleLog($rootScope.fiveMatch[i]);
      //       MyService.postAnswer($rootScope.fiveMatch[i]).then(
      //         function (response) {
      //           MyService.ConsoleLog(response);
      //           if (response.data.success) {
      //             MyService.ConsoleLog('Answer updated successfully');
      //           } else {
      //             MyService.ConsoleLog('Error: ' + response.data.error);
      //           }
      //         },
      //         function (err) {
      //           MyService.ConsoleLog('Error: ');
      //         }
      //       );
      //     }
      //   }
      // }
    }
    /**
     * @description Function to get records of the running candidates for researchers quiz.
     */

    $rootScope.getRunningCandidateRecords = function () {
      try {
        MyService.getRunningCandidateRecords().then(
          function (APIResponse) {
            MyService.ConsoleLog("this is me >>>>>>>", APIResponse);
            if (APIResponse && APIResponse.length > 0) {
              window.localStorage.setItem(
                "frontRunners",
                JSON.stringify(APIResponse)
              );
            }
          },
          function (error) {
            MyService.ConsoleLog("Error", error);
          }
        );
      } catch (err) {
        console.log("check err", err);
      }
    };

    $rootScope.getCurrentUserAns = function (userId) {
      MyService.getFiveMinAnswers({
        authorId: userId,
      }).then(
        function (payload) {
          MyService.ConsoleLog("app.js ans >> ", payload);
          if (payload.data.success) {
            window.localStorage.setItem(
              "fiveMatch",
              JSON.stringify(payload.data.data)
            );
            // $scope.getFiveMinQues();
          }
        },
        function (errpayload) {
          MyService.ConsoleLog(
            "getAllAnsweredQuestions errpayload >> ",
            errpayload
          );
        }
      );
    };

    $rootScope.initAuthorizedUser = function (userdata, type) {
      // body...
      window.localStorage.removeItem("frontRunners");
      window.localStorage.removeItem("isPostCard");

      MyService.ConsoleLog("userdata>>", userdata);
      $rootScope.getCurrentUserAns(userdata.id);
      MyService.ConsoleLog("type : ", type);
      tokenService.saveToken(userdata.token);
      tokenService.saveUserName(userdata.name);
      tokenService.saveUserId(userdata.id);
      tokenService.saveUserRole(userdata);
      window.localStorage.setItem("isPostCard", userdata.isPostCard);
      var udata = {
        id: userdata.id,
        lastLogin: userdata.lastLogin,
        uname: userdata.username,
        email: userdata.email,
        followlist: userdata.followlist,
        isemailverified: userdata.isemailverified,
        subject_of_deep_interest: userdata.subject_of_deep_interest,
        subject_of_interest: userdata.subject_of_interest,
        location_of_interest: userdata.location_of_interest,
        address: userdata.address,
        selectedColumns: userdata.selectedColumns,
        facebookid: userdata.facebookid,
        volunteers: userdata.volunteers,
        name: userdata.name,
      };
      //MyService.ConsoleLog("udata : ", udata);
      $rootScope.tempUserAddress = userdata.address;
      tokenService.saveUserData(JSON.stringify(udata));

      $http.defaults.headers.common["x-access-token"] = tokenService.getToken();
      // $http.defaults.headers.common['Authorization'] = tokenService.getToken();
      $rootScope.Auth = true;
      $rootScope.User = tokenService.getUserName();
      $rootScope.UserId = tokenService.getUserId();

      // if (userdata && userdata.userType == 'admin') {
      $rootScope.getRunningCandidateRecords();
      // }

      //$location.path('howToVideo');
      //$scope.historyUrl = window.localStorage.getItem("HistoryPage");
      MyService.ConsoleLog(
        "Here : ",
        window.localStorage.getItem("HistoryPage")
      );
      if (
        window.localStorage.getItem("HistoryPage") &&
        window.localStorage.getItem("HistoryPage") != ""
      ) {
        // MyService.ConsoleLog("location url <><><><><><",window.localStorage.getItem("HistoryPage"));
        $location.path(window.localStorage.getItem("HistoryPage"));
      } else {
        var isExist = $cookies.get("isExist");
        var qName = $cookies.get("qName");
        var orgId = $cookies.get("orgId");
        var poliId = $cookies.get("poliId");
        console.log("poliId", poliId);
        if (type == "signup") {
          MyService.ConsoleLog("show getting strated page");

          if ($cookies.get("showLogin") == "true") {
            console.log("qname", qName);
            console.log("orgId", orgId);
            if (qName && qName != "" && orgId && orgId != "") {
              // $location.path('/organizationQuiz/' + qName + "/" + orgId);
              // $cookies.put('showBanner', true);
              $location.path("/showPoliQuiz/" + qName + "/" + orgId);
            } else {
              $location.path("/showPoliticianAns/" + qName + "/" + poliId);
            }
          } else if (isExist == "true") {
            // alert('inside');
            // $location.path('/followersQuiz/' + qName + "/" + orgId);
            $location.path("/showFollowersQuiz/" + qName + "/" + orgId);
          } else {
            console.log("userType", userdata.userType);
            switch (userdata.userType) {
              case "voter":
                $location.path("gettingstarted");
                break;
              case "politician":
                $location.path("/gettingStartedPol");
                break;
              case "advocate":
                $location.path("/gettingStartedOrg");
                break;
              default:
                break;
            }
          }
        } else {
          // alert('here')
          MyService.ConsoleLog("cook", $cookies.get("showLogin"));

          if ($cookies.get("showLogin") == "true") {
            // console.log("qname", qName);
            // console.log("orgId", orgId);
            if (qName && qName != "" && orgId && orgId != "") {
              // $location.path('/organizationQuiz/' + qName + "/" + orgId);
              $location.path("/showPoliQuiz/" + qName + "/" + orgId);
            } else {
              $location.path("/showPoliticianAns/" + qName + "/" + poliId);
            }
          } else if (isExist == "true") {
            // alert('inside');

            // $location.path('/followersQuiz/' + qName + "/" + orgId);
            $cookies.remove("isExist");
            $location.path("/showFollowersQuiz/" + qName + "/" + orgId);
          } else {
            MyService.ConsoleLog("go to snapshot");
            $location.path("snapshot");
          }
        }
      }
      //console.log("got the place three");
      saveFiveMinAnswers();

      $rootScope.getCategories();
    };

    $rootScope.statusAuthenticate = 0;
    $rootScope.AuthenticateUser = function (postObj, type) {
      $rootScope.statusAuthenticate = 1;
      $http.post(baseApiUrl + "/user/authenticate", postObj).then(
        function (response) {
          if (response.data.success == true) {
            //MyService.ConsoleLog("Login Data");
            //MyService.ConsoleLog(response.data);
            $rootScope.initAuthorizedUser(response.data, type);
            /*
          tokenService.saveToken(response.data.token);
          tokenService.saveUserName(response.data.name);
          tokenService.saveUserId(response.data.id);
          tokenService.saveUserRole(response.data);
          var userData = {
              id: response.data.id,
              lastLogin: response.data.lastLogin,
              uname: response.data.username,
              name: response.data.name
          };
          //MyService.ConsoleLog("username: ", userData);
          tokenService.saveUserData(JSON.stringify(userData));
          $http.defaults.headers.common['x-access-token'] = tokenService.getToken();
          $rootScope.Auth = true;
          $rootScope.User = tokenService.getUserName();
          $rootScope.UserId = tokenService.getUserId();
          $location.path('debateHome');

          $rootScope.getCategories();
          */
            //console.log("got the place Four");

            $rootScope.statusAuthenticate = 2;
          } else {
            $rootScope.statusAuthenticate = 3;
            growl.error("Invalid Username or Password. Please try again.");
          }
        },
        function (response) {
          $rootScope.statusAuthenticate = 3;
          var validataionMsg = "";
          //MyService.ConsoleLog("response: ", response);
          if (response.data && response.data.error) {
            var errors = response.data.error.errors;
            for (var k in errors) {
              if (errors.hasOwnProperty(k)) {
                //MyService.ConsoleLog(k)
                var obj = errors[k];
                if (obj.message !== undefined)
                  validataionMsg += obj.message.replace("Path", "") + "<br/>";
              }
            }
            growl.error(validataionMsg);
          }
        }
      );
    };

    $rootScope.FBSignIn = function (fbresponse, callback) {
      //MyService.ConsoleLog(fbresponse);
      $http
        .post(baseApiUrl + "/user/authenticateEmail", {
          email: fbresponse.email,
        })
        .then(
          function (response) {
            if (response.data.success == true) {
              // $rootScope.modalInstance.dismiss('cancel');
              /*
                  tokenService.saveToken(response.data.token);
                  tokenService.saveUserName(response.data.name);
                  tokenService.saveUserId(response.data.id);
                  tokenService.saveUserRole(response.data);
                  $http.defaults.headers.common['Authorization'] = tokenService.getToken();
                  $http.defaults.headers.common['x-access-token'] = tokenService.getToken();
                  $rootScope.Auth = true;
                  $rootScope.User = tokenService.getUserName();
                  $rootScope.UserId = tokenService.getUserId();

                  $location.path('debateHome');
                  */
              //MyService.ConsoleLog("Response Data :");
              //MyService.ConsoleLog(response.data);
              //MyService.ConsoleLog(response.data.facebookid);
              if (!response.data.facebookid) {
                $http
                  .post(baseApiUrl + "/user/updateFacebookId", {
                    facebookid: fbresponse.id,
                    userId: response.data.id,
                  })
                  .then(function (userresponse) {
                    $rootScope.initAuthorizedUser(response.data, "signup");
                  });
              } else {
                $rootScope.initAuthorizedUser(response.data, "signup");
              }
            } else {
              //growl.error('Invalid Username or Password. Please try again.');
              if (callback !== undefined) callback();
            }
          },
          function (response) {
            var validataionMsg = "";
            var errors = response.data.error.errors;
            for (var k in errors) {
              if (errors.hasOwnProperty(k)) {
                //MyService.ConsoleLog(k)
                var obj = errors[k];
                if (obj.message !== undefined)
                  validataionMsg += obj.message.replace("Path", "") + "<br/>";
              }
            }
            growl.error(validataionMsg);
          }
        );
    };
    $rootScope.cancel = function () {
      $rootScope.modalInstance.dismiss("close");
    };

    $rootScope.calculateSreenSizeValues = function () {
      $rootScope.screenHeight = $(document).height();
      $rootScope.screenWidth = $(document).width();
      //MyService.ConsoleLog("width: ",$rootScope.screenWidth," height: ",$rootScope.screenHeight);
    };

    $rootScope.printPage = function () {
      window.print();
    };

    $rootScope.triggerMouseLeave = function (clsName) {
      //MyService.ConsoleLog(" triggerMouseLeave ", clsName);
      // $(clsName).trigger('mouseover');
      /*$timeout(function(argument) {
        //MyService.ConsoleLog("triggered click event");
        $(".body-tag").trigger('click');
        $(".flexbox").trigger('click');
        $(".juliedropdown").trigger('click');
        $(".juliedropdown").mouseover();
    }, 1000);*/
      // $(".juliedropdown").toggleClass("open");
    };
    //MyService.ConsoleLog("path<><><>",$location.path());
    $(document).click(function (e) {
      var container = $(".juliedropdown");

      if (
        !container.is(e.target) && // if the target of the click isn't the container...
        container.has(e.target).length === 0
      ) {
        // ... nor a descendant of the container{
        $(".juliedropdown").removeClass("open");
      }
    });

    $(".juliedropdown").click(function () {
      //MyService.ConsoleLog("clicked");
      $(".juliedropdown").toggleClass("open");
    });

    angular.element($window).bind("resize", function () {
      //MyService.ConsoleLog("resize");
      $timeout(function () {
        $rootScope.calculateSreenSizeValues();
      });
    });
  },
]);

mainApp.factory("apiService", ["baseApiUrl", function (baseApiUrl) {
  return {
    constants: function () {
      return {
        regex: {
          username: /^[a-z][\w\.]{1,25}$/,
          password: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/, // Contain 8 charectors, 1 uppercase
          email:
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          city: /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/,
        },
      };
    },
    apiCall: function (verb, url, data, headers) {
      ////console.log(verb, url, data, headers);
      // var root = 'http://104.131.115.102:8080';

      var root = baseApiUrl;
      ////console.log("root : ", root);

      var obj = {
        method: verb,
        url: root + url,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          //'x-access-token': window.localStorage[tokenName]
        },
        transformRequest: function (obj) {
          var str = [];
          for (var p in obj)
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
          return str.join("&");
        },
        // data: data
      };

      if (verb.toLowerCase() == "get") {
        ////console.log("GET method");
        obj.params = data;
      } else {
        obj.data = data;
      }

      ////console.log("OBJ :",obj);
      return obj;
    },
  };
  /*
  const factory = {};

  factory.constants = () => {
      return {
          regex: {
              username: /^[a-z][\w\.]{1,25}$/,
              password: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/, // Contain 8 charectors, 1 uppercase
              email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              city: /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/
          }
      }
  }

  factory.apiCall = (verb, url, data, headers) => {
      ////console.log(verb, url, data, headers);
      const root = 'http://104.131.115.102:8080';

      var obj = {
          method: verb,
          url: root + url,
          headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              // 'x-access-token': window.localStorage[tokenName]
          },
          transformRequest: function(obj) {
              var str = [];
              for (var p in obj)
                  str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
              return str.join("&");
          },
          // data: data
      };

      if (verb.toLowerCase() == "get") {
          ////console.log("GET method");
          obj.params = data;
      } else {
          obj.data = data;
      }

      ////console.log("OBJ :",obj);
      return obj;
  }

  return factory;
  */
}]);

//factory.constants = () => {
//    return {
//        regex: {
//            username: /^[a-z][\w\.]{1,25}$/,
//            password: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/, // Contain 8 charectors, 1 uppercase
//            email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
//            city: /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/
//        }
//    }
//}

//factory.apiCall = (verb, url, data, headers) => {
//    ////console.log(verb, url, data, headers);
//    const root = 'http://104.131.115.102:8080';
//return {
//    method: verb,
//    url: root + url,
//    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
//    transformRequest: function(obj) {
//        var str = [];
//        for(var p in obj)
//            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
//        return str.join("&");
//    },
//    data: data
//}
//}

//return factory;
//});

mainApp
  .service("apiCall", ["apiService", "tokenService", function (apiService, tokenService) {
    /*
    this.apiCall = (verb, url, data, headers) => {
        return apiService.apiCall(verb, url, data, headers);
    }
    this.constants = () => {
        return apiService.constants();
    }
    this.saveToken = (token) => {
        return apiService.saveToken(token);
    }
    this.getToken = () => {
        return tokenService.getToken();
    }
    this.destroyToken = () => {
        return apiService.destroyToken();
    }
    */
    return {
      apiCall: function (verb, url, data, headers) {
        return apiService.apiCall(verb, url, data, headers);
      },
      constants: function () {
        return apiService.constants();
      },
      saveToken: function (token) {
        return apiService.saveToken(token);
      },
      getToken: function () {
        return tokenService.getToken();
      },
      destroyToken: function () {
        return apiService.destroyToken();
      },
    };
  }])
  .filter("getItemById", function () {
    //order the groupped dat with by it's key
    return function (data, id) {
      var item = null;
      var len = data.length;
      for (var i = 0; i < len; i++) {
        if (data[i]._id == id) {
          item = data[i];
          break;
        }
      }
      return item;
    };
  });

"use strict";

angular
  .module("myApp")
  .service("APIInterceptor", [
    "$rootScope",
    "$location",
    "$q",
    function ($rootScope, $location, $q) {
      var service = this;

      service.request = function (config) {
        config.headers = config.headers || {};
        var bwurl = config.url;

        // console.log(config.url + "======" + bwurl.indexOf("newsapi.org"));
        if (window.localStorage[tokenName] && bwurl.indexOf("newsapi") == -1) {
          //config.headers.Authorization = 'Bearer ' + $localStorage.token;
          //console.log("config>>>",config);
          //console.log(config.url);
          config.headers["x-access-token"] = window.localStorage[tokenName];
        }
        //if(bwurl.indexOf("newsapi") != -1)
        if (bwurl.indexOf("newsapi") > -1) {
          delete config.headers["x-access-token"];
        }
        if (bwurl.indexOf("melissadata") > -1) {
          delete config.headers["x-access-token"];
        }
        if (bwurl.indexOf("votesmart") > -1) {
          delete config.headers["x-access-token"];
        }

        // console.log(config.url + "======" + JSON.stringify(config.headers));
        return config;
      };
      service.response = function (response) {
        // console.log("Response", response);
        if (response && response.data) {
          if (
            response.data.error &&
            response.data.error == "TokenExpiredError"
          ) {
            var histroyPageUrl = $location.url();
            // console.log("histroyPageUrl:::",histroyPageUrl);
            window.localStorage.setItem("HistoryPage", histroyPageUrl);
            $rootScope.Logout();
          }
        }
        return response;
      };
      service.responseError = function (response) {
        if (response.status === 401 || response.status === 403) {
          // $location.path('/signin');
          var histroyPageUrl = $location.url();
          // console.log("histroyPageUrl:::",histroyPageUrl);
          window.localStorage.setItem("HistoryPage", histroyPageUrl);
          $rootScope.Logout();
        }
        return $q.reject(response);
      };
    },
  ])
  .factory("MyService", ["$http", "$q", "apiCall", "showConsole", "$rootScope", function ($http, $q, apiCall, showConsole, $rootScope) {
    var obj = {};
    obj.ConsoleLog = function (name, value) {
      if (showConsole) {
        if (value && value != "") console.log(name, value);
        else console.log(name);
      }
    };
    obj.getPayment = function (params) {
      // console.log("hello welcome", params)
      var deferred = $q.defer();

      var request = apiCall.apiCall("POST", "/user/getPayment", params);
      // request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getAllUsers = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/getAllUsers", params);
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * SendVerificationMail
     */

    obj.SendVerificationMail = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/user/SendVerificationMail",
        params
      );
      //request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          if (response) {
            //var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /*OpenFEC API calls*/
    obj.getPlaceShape = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/openfec/placeShape", params);
      //request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          if (response) {
            //var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getElectionsDate = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/openfec/getElectionsDate", params);
      //request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          if (response) {
            //var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getopenFECCandidates = function (params, canceler) {
      var deferred = $q.defer();
      var currentYear = new Date().getFullYear();
      //params.year = currentYear;
      // console.log(params.page);
      var request = apiCall.apiCall("GET", "/openfec/getFECCandidates", params);
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          if (response) {
            // var subcatdata = response.data.data;
            // console.log("candidites : ", subcatdata);
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getCurrentFECCandidates = function (params) {
      var deferred = $q.defer();
      var currentYear = new Date().getFullYear();
      //params.year = currentYear;
      // console.log(params.pageno);
      var request = apiCall.apiCall("GET", "/openfec/openFECCandidates", {
        year: currentYear,
        pageno: params.pageno,
      });
      //request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          if (response) {
            //var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getopenFECCandidateDetails = function (params) {
      var deferred = $q.defer();
      var currentYear = new Date().getFullYear();
      var request = apiCall.apiCall("GET", "/openfec/openFECCandidateDetails", {
        id: params.cid,
      });
      //request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          if (response) {
            //var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getopenFECCandidateCommittees = function (params) {
      var deferred = $q.defer();
      var currentYear = new Date().getFullYear();
      var request = apiCall.apiCall(
        "GET",
        "/openfec/openFECCandidateCommittee",
        {
          id: params.cid,
        }
      );
      //request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          if (response) {
            // console.log("data come");
            // var subcatdata = response.data.data;
            // console.log("countires : ", subcatdata);
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getAllFECCommittees = function () {
      // console.log("hello welcome to get all committee");
      var deferred = $q.defer();
      // var currentYear = (new Date()).getFullYear();
      var request = apiCall.apiCall("GET", "/openfec/openFECGetAllCommittee");
      //request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          if (response) {
            // console.log("hello welcome");

            var subcatdata = response.data.data;
            // console.log("committee : ", subcatdata);
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getAllFECCommitteesData = function (params, canceler) {
      // console.log("cat_id", params.cid);
      // console.log("hello welcome to get all committee");
      var deferred = $q.defer();
      // console.log("pagination", params.pageno);

      // var currentYear = (new Date()).getFullYear();
      var request = apiCall.apiCall(
        "GET",
        "/openfec/openFECGetAllCommitteeData",
        params
      );
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          if (response) {
            // console.log("hello welcome");

            // var subcatdata = response.data.data;
            // console.log("committee Data : ", subcatdata);
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.UpdatePassword = function (params) {
      // console.log("params", params);
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/updatePassword", params);
      // request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.searchUserByDetail = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/search", params);
      request.headers["Cache-Control"] = "No-Store";
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.registerLogin = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/registerwithLogin", params);
      // request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * registerWithOrgs
     */
    obj.registerWithOrgs = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/registerWithOrgs", params);
      // request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    /*
     * End of the registerWithOrgs
     */
    obj.searchUserByOrgDetail = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/search-by-org", params);
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    //  search by Name

    obj.SearchByName = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/openState/SearchByName", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // SearchByTitle

    obj.SearchByTitle = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/openState/SearchByTitle", params);
      request.timeout = canceler;

      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    //getFullText

    //   obj.getFullText = function(params) {
    //   var deferred = $q.defer();
    //   var request = apiCall.apiCall('GET', '/federalBills/getFullText', params);
    //   // request.timeout = canceler;

    //   $http(
    //     request
    //   ).then(function successCallback(response) {
    //     //console.log("Got countires: ", response);
    //     if (response.data.success) {
    //       var subcatdata = response.data.data;
    //       //console.log("countires : ", subcatdata);
    //       deferred.resolve(subcatdata);

    //     } else {
    //       //alert("Something went wrong: ", response.data);
    //       deferred.reject(response.data.error);
    //     }
    //   }, function errorCallBack(response) {
    //     //console.log("Error: ", response);
    //     deferred.reject(response);
    //   });
    //   return deferred.promise;
    // };

    // fedCommittees
    obj.fedCommittees = function () {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/federalBills/fedCommittees");
      // request.timeout = canceler;

      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    //

    obj.SearchByTitleOne = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/openState/SearchByTitleOne",
        params
      );
      request.timeout = canceler;

      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getAllEssay = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/essay/getAllEssay", params);
      $http(request).then(
        function successCallback(response) {
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // get Open Data

    obj.getOpenData = function (params, canceler) {
      // console.log("cat_id", params.cid);
      // console.log("hello welcome to get all committee");
      var deferred = $q.defer();
      // console.log("pagination", params.pageno);

      // var currentYear = (new Date()).getFullYear();
      var request = apiCall.apiCall("GET", "/openState/openData", params);
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          if (response) {
            // console.log("hello welcome");

            // var subcatdata = response.data.data;
            // console.log("committee Data : ", subcatdata);
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    //  get Open State Bills

    obj.getBills = function () {
      // console.log("cat_id", params.cid);
      // console.log("hello welcome to get all committee");
      var deferred = $q.defer();
      // console.log("pagination", params.pageno);

      // var currentYear = (new Date()).getFullYear();
      var request = apiCall.apiCall("POST", "/openState/getAllBills");
      // request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          if (response) {
            // console.log("hello welcome");

            // var subcatdata = response.data.data;
            // console.log("committee Data : ", subcatdata);
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    //addFederal

    obj.addFederal = function (params) {
      // console.log("cat_id", params.cid);
      // console.log("hello welcome to get all committee");
      var deferred = $q.defer();
      // console.log("pagination", params.pageno);

      // var currentYear = (new Date()).getFullYear();
      var request = apiCall.apiCall("GET", "/trackFederal/getData", params);
      // request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          if (response) {
            // console.log("hello welcome");

            // var subcatdata = response.data.data;
            // console.log("committee Data : ", subcatdata);
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // getDetails

    obj.getDetails = function (params) {
      // console.log("cat_id", params.cid);
      // console.log("hello welcome to get all committee");
      var deferred = $q.defer();
      // console.log("pagination", params.pageno);

      // var currentYear = (new Date()).getFullYear();
      var request = apiCall.apiCall("GET", "/trackFederal/getFDetails", params);
      // request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          if (response) {
            // console.log("hello welcome");

            // var subcatdata = response.data.data;
            // console.log("committee Data : ", subcatdata);
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // getFederalData

    obj.getFederalData = function (params, canceler) {
      // console.log("cat_id", params.cid);
      // console.log("hello welcome to get all committee");
      var deferred = $q.defer();
      // console.log("pagination", params.pageno);

      // var currentYear = (new Date()).getFullYear();
      var request = apiCall.apiCall("GET", "/federalTrack/getFederal", params);
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          if (response) {
            // console.log("hello welcome");

            // var subcatdata = response.data.data;
            // console.log("committee Data : ", subcatdata);
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    //getTextBills

    obj.getTextBills = function (params, canceler) {
      // console.log("cat_id", params.cid);
      // console.log("hello welcome to get all committee");
      var deferred = $q.defer();
      // console.log("pagination", params.pageno);

      // var currentYear = (new Date()).getFullYear();
      var request = apiCall.apiCall(
        "GET",
        "/federalTrack/getTextBills",
        params
      );
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          if (response) {
            // console.log("hello welcome");

            // var subcatdata = response.data.data;
            // console.log("committee Data : ", subcatdata);
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // get Votes Data

    // addorgQuestions

    obj.addorgQuestions = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/questions/addorgQuestions",
        params
      );
      $http(request).then(
        function successCallback(response) {
          if (response) {
            // console.log("hello welcome");

            // var subcatdata = response.data.data;
            // console.log("committee Data : ", subcatdata);
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getVotesData = function (params, canceler) {
      // console.log("cat_id", params.cid);
      // console.log("hello welcome to get all committee");
      var deferred = $q.defer();
      // console.log("pagination", params.pageno);

      // var currentYear = (new Date()).getFullYear();
      var request = apiCall.apiCall(
        "GET",
        "/federalBills/getVotesData",
        params
      );
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          if (response) {
            // console.log("hello welcome");

            // var subcatdata = response.data.data;
            // console.log("committee Data : ", subcatdata);
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // get open bills
    obj.getOpenBills = function (params, canceler) {
      // console.log("cat_id", params.cid);
      // console.log("hello welcome to get all committee");
      var deferred = $q.defer();
      // console.log("pagination", params.pageno);

      // var currentYear = (new Date()).getFullYear();
      var request = apiCall.apiCall("GET", "/openState/getBills", params);
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          if (response) {
            // console.log("hello welcome");

            // var subcatdata = response.data.data;
            // console.log("committee Data : ", subcatdata);
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getBillDetail = function (params) {
      // console.log("cat_id", params.cid);
      // console.log("hello welcome to get all committee");
      var deferred = $q.defer();
      // console.log("pagination", params.pageno);

      // var currentYear = (new Date()).getFullYear();
      var request = apiCall.apiCall("GET", "/openState/getBillDetails", params);
      // request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          if (response) {
            // console.log("hello welcome");

            // var subcatdata = response.data.data;
            // console.log("committee Data : ", subcatdata);
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // addFederalBills

    obj.addFederalBills = function (params) {
      // console.log("cat_id", params.cid);
      // console.log("hello welcome to get all committee");
      var deferred = $q.defer();
      // console.log("pagination", params.pageno);

      // var currentYear = (new Date()).getFullYear();
      var request = apiCall.apiCall(
        "GET",
        "/federalBills/getFederalBills",
        params
      );
      // request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          if (response) {
            // console.log("hello welcome");

            // var subcatdata = response.data.data;
            // console.log("committee Data : ", subcatdata);
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // addRollVotes

    obj.addRollVotes = function () {
      // console.log("cat_id", params.cid);
      // console.log("hello welcome to get all committee");
      var deferred = $q.defer();
      // console.log("pagination", params.pageno);

      // var currentYear = (new Date()).getFullYear();
      var request = apiCall.apiCall("GET", "/federalBills/addRollVotes");
      // request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          if (response) {
            // console.log("hello welcome");

            // var subcatdata = response.data.data;
            // console.log("committee Data : ", subcatdata);
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // getVotesDetail

    obj.getVotesDetail = function (params) {
      // console.log("cat_id", params.cid);
      // console.log("hello welcome to get all committee");
      var deferred = $q.defer();
      // console.log("pagination", params.pageno);

      // var currentYear = (new Date()).getFullYear();
      var request = apiCall.apiCall(
        "GET",
        "/federalBills/getVoteDetail",
        params
      );
      // request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          if (response) {
            // console.log("hello welcome");

            // var subcatdata = response.data.data;
            // console.log("committee Data : ", subcatdata);
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // SearchBills

    obj.SearchBills = function (params, canceler) {
      // console.log("cat_id", params.cid);
      // console.log("hello welcome to get all committee");
      var deferred = $q.defer();
      // console.log("pagination", params.pageno);

      // var currentYear = (new Date()).getFullYear();
      var request = apiCall.apiCall("GET", "/federalBills/SearchBills", params);
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          if (response) {
            // console.log("hello welcome");

            // var subcatdata = response.data.data;
            // console.log("committee Data : ", subcatdata);
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.removeEssay = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/essay/removeEssay", data);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getSpamTopics = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/topics/getSpamTopics", params);
      $http(request).then(
        function successCallback(response) {
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getAllTopics = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/topics/getAllTopics", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.notSpamTopic = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/topics/notSpamTopic", data);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.removeSpamTopic = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/topics/removeSpamTopic", data);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getAllPoliticians = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/getAllPoliticians", data);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.removePoliticians = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/politician/removePoliticians",
        data
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          var subcatdata = response;
          //console.log("countires : ", subcatdata);
          deferred.resolve(subcatdata);
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    /**
     * Get votesmart ques data
     */
    obj.getVotesmartData = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/votequestions/getAllVotesmartData",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          var subcatdata = response;
          //console.log("countires : ", subcatdata);
          deferred.resolve(subcatdata);
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * Remove ballot measures
     */

    obj.removeBallotMeasures = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/elections/removeBallotMeasures",
        data
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          var subcatdata = response;
          //console.log("countires : ", subcatdata);
          deferred.resolve(subcatdata);
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    /**
     * Rate ballot measures
     */

    obj.rateBallotMeasures = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/reviews/rateBallotMeasures",
        data
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          var subcatdata = response;
          //console.log("countires : ", subcatdata);
          deferred.resolve(subcatdata);
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // checkUserExist
    obj.checkUserExist = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/politician/checkUserExistFor",
        data
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          var subcatdata = response;
          //console.log("countires : ", subcatdata);
          deferred.resolve(subcatdata);
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    //  End of checkUserExist
    obj.getAllOrganizations = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/office/getAllOrganizations",
        params
      );
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.inactiveOrg = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/office/inactiveOrg", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.exportOrganizationData = function (params, canceler) {
      var deferred = $q.defer();
      //console.log(params);
      var request = apiCall.apiCall(
        "POST",
        "/office/exportOrganizations",
        params
      );
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getAllOrganizationsPaginated = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/office/getAllOrganizationsPaginated",
        params
      );
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.updatePoliticianData = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/politician/updatePoliticianData",
        data
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.exportPoliticianData = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/politician/exportPoliticianData",
        data
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.generatePostCard = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/generatePostCard", data);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.checkMetaWithSSR = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/checkMetaWithSSR", params);
      // request.headers['Content-Type'] = 'text/html';
      $http(request).then(
        function successCallback(response) {
          console.log("Got countires: ", response);
          if (response.status == 200) {
            var subcatdata = response.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * @description Function is use to export records of rating organizations.
     */
    obj.exportOrgRatingData = function () {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/reviews/exportOrgRatingData");
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    /**
     * End of exportOrgRatingData
     */

    /**
     * @description Function is use to export users and politicians records
     */
    obj.exportBoth = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/politician/exportBoth", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    /**
     * End of exportBoth
     */

    /**
     * Get details of politicians
     */

    obj.getPoliDetails = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/politician/getPoliDetails",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * @description Function is use to search politician
     */
    obj.searchPoliticiansWith = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/politician/searchPoliticiansWith",
        params
      );
      $http(request).then(
        function successCallback(response) {
          if (response.data.success) {
            var subcatdata = response.data.data;

            deferred.resolve(subcatdata);
          } else {
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    /**
     * End Of searchPoliticiansWith
     * */

    /**
     * Get details of the ballot measures
     */
    obj.getDetailsOfBallotMeasures = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/elections/getDetailsOfBallotMeasures",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * Update ballot measures
     */
    obj.updateBallotMeasures = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/elections/updateBallotMeasures",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.exportBallotMeasures = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/elections/exportBallotMeasures",
        data
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.registerPoliticianData = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/user/autogeneratePolitician",
        data
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // get Count of users

    obj.getUsersCount = function () {
      // console.log("hello welcome to get all committee");
      var deferred = $q.defer();
      // var currentYear = (new Date()).getFullYear();
      var request = apiCall.apiCall("GET", "/user/userCount");
      //request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          if (response) {
            // console.log("hello welcome");

            var subcatdata = response.data.data;
            // console.log("committee : ", subcatdata);
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // get user count stateWise

    // getGuestUsersAnswers

    obj.getGuestUsersAnswers = function (params) {
      // console.log("hello welcome to get all committee");
      var deferred = $q.defer();
      // var currentYear = (new Date()).getFullYear();
      var request = apiCall.apiCall(
        "GET",
        "/answers/getGuestUsersAnswers",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      //request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          if (response) {
            // console.log("hello welcome");

            var subcatdata = response.data.data;
            // console.log("committee : ", subcatdata);
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    //  End of getGuestUsersAnswers

    obj.getUsersCountStateWise = function (params) {
      // console.log("hello welcome to get all committee");
      var deferred = $q.defer();
      // var currentYear = (new Date()).getFullYear();
      var request = apiCall.apiCall("GET", "/user/userCountState", params);
      //request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          if (response) {
            // console.log("hello welcome");

            var subcatdata = response.data.data;
            // console.log("committee : ", subcatdata);
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // Export Courage Data

    obj.ExportCourageData = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/votequestions/exportCourageData",
        data
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.updateOfficeData = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/office/updateOfficeData", data);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.registerAdvocateData = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/user/autoGenerateAdvocates",
        data
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.addToMyFollow = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/office/addToMyFollow", data);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got addToMyFollow: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getAllUsersData = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/getAllUsersData", data);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getOrganizationQuesAnswers = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/questions/getOrganizationQuesAnswers",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          //console.log("Got categories: ", response);
          /*
        if (response.data.success) {
        deferred.resolve(response.data.data);
        } else {
        deferred.reject(response.data);
        }
        */
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getAllCountries = function () {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/getAllCountries", {});
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("countires : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getAllStates = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/getAllStates", params);
      $http(request).then(
        function successCallback(response) {
          // console.log("Got countires: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // get votesmart Candiates
    obj.getVoteCandidates = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/elections/getCandidatesData",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getCityCouncilDistrict = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/user/getCityCouncilDistrict",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getCandidatesWithParams = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/user/getCandidatesWithParams",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * @description Function is use to insert records of presidential race.
     */

    obj.getPresidentData = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/elections/getPresidentData",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * End of getPresidentData
     */

    // getUsersCountCityWise
    obj.getUsersCountCityWise = function (params) {
      console.log("add-parents >>", params);
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/user/getUsersCountCityWise",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // get user cound county wise

    // getCity

    obj.getCity = function (params) {
      console.log("getCity >>", params);
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/getCity", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    //  End of getcity

    obj.getUsersCountyWise = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/getUsersCountyWise", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // End of get user county wise

    // getStateLevelPoli

    obj.getStateLevelPoli = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/getStateLevelPoli", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // End of getStateLevelPoli

    // get Open State People

    obj.getOpenStatePeopleData = function () {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/openState/getPeople");
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getReviewCategory = function (params) {
      // console.log(params);
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/reviews/getReviewCategoryList",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * @description get Org list
     */
    obj.getOrgList = function (params) {
      // console.log(params);
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/reviews/getOrgList", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // for courage Data

    obj.getCourageTest = function (params) {
      // console.log(params);
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/votequestions/getQuestions",
        params
      );
      $http(request).then(
        function successCallback(response) {
          // console.log("Got countires: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getTestData = function (params) {
      // console.log(params);
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/votequestions/getTestData",
        params
      );
      $http(request).then(
        function successCallback(response) {
          console.log("Got countires: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    //  get data for candidate

    obj.getCourageForCandidate = function (params) {
      // console.log(params);
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/votequestions/getQuestionsForCandidate",
        params
      );
      $http(request).then(
        function successCallback(response) {
          // console.log("Got countires: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // show in five match

    obj.UpdateFiveMatchCou = function (params) {
      // console.log(params);
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/votequestions/UpdateFiveMatch",
        params
      );
      $http(request).then(
        function successCallback(response) {
          // console.log("Got countires: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     *
     * @param {*}
     */
    obj.getRunningCandidateRecords = function () {
      // console.log(params);
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/getRunningCandidateRecords");
      $http(request).then(
        function successCallback(response) {
          // console.log("Got countires: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // for localdata

    obj.getLocalOffices = function (params) {
      // console.log(params);
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/localoffice/getCandidates",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // getCandi

    obj.getCandi = function () {
      // console.log(params);
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/federalBills/getCandi");
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getLocalOfficesForCity = function (params) {
      // console.log(params);
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/localoffice/getCityCandidates",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getElectionData = function (params) {
      console.log(params);
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/elections/getElectionByYearState",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getIncumbentData = function (params) {
      console.log(params);
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/elections/getIncumbentByState",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getCityCouncil = function (params) {
      console.log(params);
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/localoffice/getNewYorkCityCandidates",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got countires: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getAllCounties = function (statePostalCode, state) {
      var deferred = $q.defer();
      var params;
      if (statePostalCode == "") {
        params = state.stateFips;
      } else {
        params = {
          statePostalCode: statePostalCode,
          state: state,
        };
      }

      console.log("params", params);
      var request = apiCall.apiCall("POST", "/user/getAllCounties", params);
      $http(request).then(
        function successCallback(response) {
          console.log("Got getAllCounties: ", response);

          if (response.data.success) {
            //$scope.allCounties.length = 0;
            if (response.data.data) {
              var sublocations = response.data.data;
              //console.log("sublocations counties : ", sublocations);
              deferred.resolve(sublocations);
            }
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getAllSubCountiesLocal = function (statePostalCode, county, state) {
      var deferred = $q.defer();
      var params = {};
      params.statePostalCode = statePostalCode;
      if (state) params.state = state;
      if (county) params.county = county;
      console.log("params", params);

      var request = apiCall.apiCall(
        "POST",
        "/user/getAllSubCountiesLocal",
        params
      );

      $http(request).then(
        function successCallback(response) {
          // console.log("Got sublocations: ", response);
          if (response.data.success) {
            //$scope.allCounties.length = 0;
            if (response.data.data) {
              var sublocations = response.data.data;
              //console.log("sublocations Locals : ", sublocations);
              deferred.resolve(sublocations);
              //console.log($scope.allLocals[state])
            }
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );

      return deferred.promise;
    };

    /*
     *
     * this service fetch data from the placesshape file
     * take three parameters statefifps county and state
     ***/

    obj.getPlacesAndSubCounty = function (statePostalCode, county, state) {
      var deferred = $q.defer();
      var params = {};
      params.statePostalCode = statePostalCode;
      if (state) params.state = state;
      if (county) params.county = county;
      console.log("params", params);

      var request = apiCall.apiCall(
        "POST",
        "/user/getPlacesAndSubCounty",
        params
      );

      $http(request).then(
        function successCallback(response) {
          // console.log("Got sublocations: ", response);
          if (response.data.success) {
            //$scope.allCounties.length = 0;
            if (response.data.data) {
              var sublocations = response.data.data;
              //console.log("sublocations Locals : ", sublocations);
              deferred.resolve(sublocations);
              //console.log($scope.allLocals[state])
            }
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );

      return deferred.promise;
    };

    // end of getPlacesAndSubCounty

    /*
     *
     * this service fetch data of congressional districts
     * take object of places
     ***/

    obj.getAllcogressionalData = function (params) {
      var deferred = $q.defer();

      var request = apiCall.apiCall(
        "GET",
        "/user/getAllcogressionalData",
        params
      );

      $http(request).then(
        function successCallback(response) {
          //console.log("Got sublocations: ", response);
          if (response.data.success) {
            //$scope.allCounties.length = 0;
            if (response.data.data) {
              var sublocations = response.data.data;
              //console.log("sublocations Locals : ", sublocations);
              deferred.resolve(sublocations);
              //console.log($scope.allLocals[state])
            }
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );

      return deferred.promise;
    };

    // End of getAllcogressionalData

    // getStateHouseData

    obj.getStateHouseData = function (params) {
      var deferred = $q.defer();

      var request = apiCall.apiCall("GET", "/user/getStateHouseData", params);

      $http(request).then(
        function successCallback(response) {
          //console.log("Got sublocations: ", response);
          if (response.data.success) {
            //$scope.allCounties.length = 0;
            if (response.data.data) {
              var sublocations = response.data.data;
              //console.log("sublocations Locals : ", sublocations);
              deferred.resolve(sublocations);
              //console.log($scope.allLocals[state])
            }
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );

      return deferred.promise;
    };

    // getSchool
    obj.getSchool = function (params) {
      var deferred = $q.defer();

      var request = apiCall.apiCall("GET", "/user/getSchool", params);

      $http(request).then(
        function successCallback(response) {
          //console.log("Got sublocations: ", response);
          if (response.data.success) {
            //$scope.allCounties.length = 0;
            if (response.data.data) {
              var sublocations = response.data.data;
              //console.log("sublocations Locals : ", sublocations);
              deferred.resolve(sublocations);
              //console.log($scope.allLocals[state])
            }
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );

      return deferred.promise;
    };

    // End of getSchool

    obj.getAllPostalDetails = function (state, county, params) {
      var deferred = $q.defer();
      if (!params) params = {};
      if (state) params.statePostalCode = state;
      if (county) params.county = county;

      var request = apiCall.apiCall("GET", "/user/getAllPostalDetails", params);

      $http(request).then(
        function successCallback(response) {
          //console.log("Got sublocations: ", response);
          if (response.data.success) {
            //$scope.allCounties.length = 0;
            if (response.data.data) {
              var sublocations = response.data.data;
              //console.log("sublocations Locals : ", sublocations);
              deferred.resolve(sublocations);
              //console.log($scope.allLocals[state])
            }
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );

      return deferred.promise;
    };

    // get all data

    obj.getAllData = function (params) {
      var deferred = $q.defer();

      var request = apiCall.apiCall("GET", "/user/getAllAddDetails", params);

      $http(request).then(
        function successCallback(response) {
          //console.log("Got sublocations: ", response);
          if (response.data.success) {
            //$scope.allCounties.length = 0;
            if (response.data.data) {
              var sublocations = response.data.data;
              //console.log("sublocations Locals : ", sublocations);
              deferred.resolve(sublocations);
              //console.log($scope.allLocals[state])
            }
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );

      return deferred.promise;
    };

    obj.getAllLocalDetails = function (state, county) {
      var deferred = $q.defer();
      var params = {};
      if (state) params.statePostalCode = state;
      if (county) params.county = county;
      var request = apiCall.apiCall("GET", "/user/getAllLocalDetails", params);

      $http(request).then(
        function successCallback(response) {
          //console.log("Got sublocations: ", response);
          if (response.data.success) {
            //$scope.allCounties.length = 0;
            if (response.data.data) {
              var sublocations = response.data.data;
              //console.log("sublocations Locals : ", sublocations);
              deferred.resolve(sublocations);
              //console.log($scope.allLocals[state])
            }
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.setWinRecords = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/politician/setWinRecords",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got sublocations: ", response);
          if (response.data.success) {
            //$scope.allCounties.length = 0;
            if (response.data.data) {
              var sublocations = response.data.data;
              //console.log("sublocations Locals : ", sublocations);
              deferred.resolve(sublocations);
              //console.log($scope.allLocals[state])
            }
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.savePreferences = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/savePreferences", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got sublocations: ", response);
          if (response.data.success) {
            //$scope.allCounties.length = 0;
            if (response.data.data) {
              var sublocations = response.data.data;
              //console.log("sublocations Locals : ", sublocations);
              deferred.resolve(sublocations);
              //console.log($scope.allLocals[state])
            }
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.removePreferences = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/removePreferences", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got sublocations: ", response);
          if (response.data.success) {
            //$scope.allCounties.length = 0;
            if (response.data.data) {
              var sublocations = response.data.data;
              //console.log("sublocations Locals : ", sublocations);
              deferred.resolve(sublocations);
              //console.log($scope.allLocals[state])
            }
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getHistoryPolitician = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/politician/getHistoryPolitician",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got subcategories: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getGridHistory = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/politician/getGridHistory",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got subcategories: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    // obj.removeGridHistory = function(params) {
    //     var deferred = $q.defer();
    //     var request = apiCall.apiCall('POST', '/politician/restorePolitician', params);
    //     $http(
    //         request
    //     ).then(function successCallback(response) {
    //         //console.log("Got subcategories: ", response);
    //         if (response.data.success) {
    //             deferred.resolve(response.data.data);
    //         } else {
    //             deferred.reject(response.data);
    //         }
    //     }, function errorCallBack(response) {
    //         deferred.reject(response);
    //     });
    //     return deferred.promise;
    // };
    obj.restorePolitician = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/politician/restorePolitician",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got subcategories: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getAllCatTree = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/categories/getAllTree", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got subcategories: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getProfile = function (userId) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/profile", {
        userId: userId,
      });
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          //console.log("Got User Data: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // getQuizNames
    obj.getQuizNames = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/questions/getQuizNames", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          //console.log("Got User Data: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // End Of getQuizNames

    /**
     * Quiz list
     */
    obj.getQuizList = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/questions/getQuizList", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          //console.log("Got User Data: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    /** End of getQuizList */

    /**
     * Get List of categories which is used to create the category
     */
    obj.getQuizzesCategories = function () {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/questions/getQuizzesCategories");
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          //console.log("Got subcategories: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    /**
     * End of
     */

    /**
     * Add all the melisa data info into the table
     */
    obj.saveMelisaStripe = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/saveMelisaStripe", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got subcategories: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    /**
     * End of  saveMelisaStripe
     */

    /**
     * Get melisa Data
     */
    obj.getMeliSa = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/getMeliSa", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got subcategories: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    /**
     * End of melisa data
     */

    /**
     * Block user
     */
    obj.makeInvisible = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/makeInvisible", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got subcategories: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    /**
     * End of makeInvisible
     */

    /**
     * Update the view order of the questions
     */
    obj.updateViewOrder = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/questions/updateViewOrder",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          //console.log("Got subcategories: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    /**
     * End of the updateViewOrder
     */

    obj.updateUserFollowList = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/updateFollow", data);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got Response: ", response);
          if (response.data.success) {
            deferred.resolve(response.data);
          } else {
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.removeUserFollowList = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/removeFollow", data);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got Response: ", response);
          if (response.data.success) {
            deferred.resolve(response.data);
          } else {
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.updateProfile = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/updateProfile", data);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          //console.log("Got Essay: ", response);
          if (response.data.success) {
            deferred.resolve(response.data);
          } else {
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    //updateAddress
    obj.updateAddress = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/updateAddress", data);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got Essay: ", response);
          if (response.data.success) {
            deferred.resolve(response.data);
          } else {
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("Error: ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    // End of updateAddress
    obj.getPress = function (Id) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/office/getone", {
        officeId: Id,
      });
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          //console.log("Got Office: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            deferred.resolve(subcatdata);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /** getMatchForPress */
    obj.getMatchForPress = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/office/getMatch", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          if (response.data.success) {
            var subcatdata = response.data.data;
            deferred.resolve(subcatdata);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    /** End Of getMatchForPress */

    obj.getEssay = function (Id) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/essay/getone", {
        essayId: Id,
      });
      $http(request).then(
        function successCallback(response) {
          //console.log("Got Essay: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            deferred.resolve(subcatdata);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getPressEssay = function (Id) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/essay-press/getone", {
        essayId: Id,
      });
      $http(request).then(
        function successCallback(response) {
          //console.log("Got Essay: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            deferred.resolve(subcatdata);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.removePressEssay = function (Id) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/essay-press/removeEssay", {
        id: Id,
      });
      $http(request).then(
        function successCallback(response) {
          //console.log("Got Essay: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            deferred.resolve(subcatdata);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.updateEssay = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/essay/update?mediaType=" + data.mediaType,
        data
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got Response: ", response);
          if (response.data.success) {
            var subcatdata = response.data;
            deferred.resolve(subcatdata);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     *
     * highlightPost
     */
    obj.highlightPost = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/essay/highlightPost", data);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got Response: ", response);
          if (response.data.success) {
            var subcatdata = response.data;
            deferred.resolve(subcatdata);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * getHighlighatedPost
     */
    obj.getHighlighatedPost = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/essay/getHighlighatedPost", data);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          //console.log("Got Response: ", response);
          if (response.data.success) {
            var subcatdata = response.data;
            deferred.resolve(subcatdata);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * getFollowersList for organizations
     */

    obj.getFollowersList = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/office/getFollowersList", data);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          //console.log("Got Response: ", response);
          if (response.data.success) {
            var subcatdata = response.data;
            deferred.resolve(subcatdata);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    /*
    **saves legislation rating into the table

    */

    obj.saveLegisRating = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/trackFederal/saveLegisRating",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got Response: ", response);
          if (response.data.success) {
            var subcatdata = response.data;
            deferred.resolve(subcatdata);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /*
      **Save legislation comment

      */

    obj.saveLegisComment = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/trackFederal/saveLegisComment",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got Response: ", response);
          if (response.data.success) {
            var subcatdata = response.data;
            deferred.resolve(subcatdata);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /*
       **get rating from database

       */

    obj.getLegisRate = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/trackFederal/getLegisRate",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got Response: ", response);
          if (response.data.success) {
            var subcatdata = response.data;
            deferred.resolve(subcatdata);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * getQuizDetailsFor
     */
    obj.getQuizDetailsFor = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/questions/getQuizDetailsFor",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          //console.log("Got Response: ", response);
          if (response.data.success) {
            var subcatdata = response.data;
            deferred.resolve(subcatdata);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * End of getQuizDetailsFor */

    /**
     * getFilterQuizzes
     */

    obj.getFilterQuizzes = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/questions/getFilterQuizzes",
        params
      );
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          if (response.data.success) {
            var subcatdata = response.data;
            deferred.resolve(subcatdata);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * End Of getFilterQuizzes
     */

    /**
     * Send Email To the Org
     */

    obj.sendEmailToOrg = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/questions/sendEmailToOrg", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          if (response.data.success) {
            var subcatdata = response.data;
            deferred.resolve(subcatdata);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * End of sendEmailToOrg
     */

    /**
     * Get details of the solved quiz
     */

    obj.getDetailsofQuiz = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/questions/getDetailsofQuiz",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          if (response.data.success) {
            var subcatdata = response.data;
            deferred.resolve(subcatdata);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * End of getDetailsofQuiz
     */

    /**
     * Get match with politicians
     */

    obj.getPoliMatch = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/questions/getPoliMatch", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          if (response.data.success) {
            var subcatdata = response.data;
            deferred.resolve(subcatdata);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * End of get poli match
     */

    /**
     * getCompositeQuiz
     */
    obj.getCompositeQuiz = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/questions/getCompositeQuiz",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          //console.log("Got Response: ", response);
          if (response.data.success) {
            var subcatdata = response.data;
            deferred.resolve(subcatdata);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**End of getCompositeQuiz */

    /**
     * getAnsQues
     */

    obj.getAnsQues = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/questions/getAnsQues", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          //console.log("Got Response: ", response);
          if (response.data.success) {
            var subcatdata = response.data;
            deferred.resolve(subcatdata);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * End getAnsQues
     */

    /**getPopularQuestion */
    obj.getPopularQuestion = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/questions/getPopularQuestion",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          //console.log("Got Response: ", response);
          if (response.data.success) {
            var subcatdata = response.data;
            deferred.resolve(subcatdata);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    /** End of getPopularQuestion */

    /**
     * Get All Essay
     */
    obj.getAllEssaysList = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/essay/getAllEssaysList", params);
      $http(request).then(
        function successCallback(response) {
          if (response.data.success) {
            var subcatdata = response.data;
            deferred.resolve(subcatdata);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    /**
     * End of
     */

    obj.updateEssayComts = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/comments/updateComt", data);
      $http(request).then(
        function successCallback(response) {
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.removeEssayComment = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/comments/removeEssayComment",
        data
      );
      $http(request).then(
        function successCallback(response) {
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.updatePressEssay = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/essay-press/update?mediaType=" + data.mediaType,
        data
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("Got Response: ", response);
          if (response.data.success) {
            var subcatdata = response.data;
            deferred.resolve(subcatdata);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.updatePress = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/office/updateOfficeData", data);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got Response: ", response);
          if (response.data.success) {
            var subcatdata = response.data;
            deferred.resolve(subcatdata);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getEssayComments = function (essayId) {
      var deferred = $q.defer();
      var nrequest = apiCall.apiCall("GET", "/comments/getList", {
        essayId: essayId,
      });
      $http(nrequest).then(
        function successCallback(response) {
          //console.log(response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getPressEssayComments = function (essayId) {
      var deferred = $q.defer();
      var nrequest = apiCall.apiCall("GET", "/eassy-comments-press/getList", {
        essayId: essayId,
      });
      $http(nrequest).then(
        function successCallback(response) {
          //console.log(response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getPressComments = function (pressId) {
      var deferred = $q.defer();
      var nrequest = apiCall.apiCall("GET", "/presscomments/getList", {
        pressId: pressId,
      });
      nrequest.headers["Cache-Control"] = "No-Store";
      $http(nrequest).then(
        function successCallback(response) {
          //console.log(response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.updateEssayComments = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/comments/update", data);
      $http(request).then(
        function successCallback(response) {
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.updatePressEssayComments = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/eassy-comments-press/update",
        data
      );
      $http(request).then(
        function successCallback(response) {
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.updatePressComments = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/presscomments/update", data);
      $http(request).then(
        function successCallback(response) {
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.submitEssayComments = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/comments/create", data);
      $http(request).then(
        function successCallback(response) {
          //console.log("reply success");
          //console.log(response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.submitPressEssayComments = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/eassy-comments-press/create",
        data
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("reply success");
          //console.log(response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.submitPressComments = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/presscomments/create", data);
      $http(request).then(
        function successCallback(response) {
          //console.log("reply success");
          //console.log(response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getCategoryList = function (categoryId) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/categories/list", {
        id: categoryId,
      });
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          //console.log("Got categories: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getRootCategoryList = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/categories/list", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          //console.log("Got categories: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getCategoryListWithTopics = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/categories/listWithTopics",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          //console.log("Got categories: ", response);

          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getSubCategoryList = function (categoryId) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/categories/list", {
        parentId: categoryId,
      });
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          //console.log("Got categories: ", response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getExtraData = function (userData) {
      var deferred = $q.defer();
      var nrequest = apiCall.apiCall("GET", "/topics/getExtraData", {
        userData: userData,
      });
      nrequest.headers["Cache-Control"] = "No-Store";
      $http(nrequest).then(
        function successCallback(response) {
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * extraDataUpdated
     */
    obj.extraDataUpdated = function (userData) {
      var deferred = $q.defer();
      var nrequest = apiCall.apiCall("GET", "/topics/extraDataUpdated", {
        userData: userData,
      });
      $http(nrequest).then(
        function successCallback(response) {
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getOneTopic = function (params) {
      var deferred = $q.defer();
      var nrequest = apiCall.apiCall("GET", "/topics/getone", params);
      nrequest.headers["Cache-Control"] = "No-Store";
      $http(nrequest).then(
        function successCallback(response) {
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    /**
     * Get records of the topics
     *  */
    obj.getRecordsOf = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/topics/getRecordsOf", params);
      $http(request).then(
        function successCallback(response) {
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.updateTopic = function (params) {
      var deferred = $q.defer();
      var nrequest = apiCall.apiCall("POST", "/topics/update", params);
      $http(nrequest).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getLatestTopics = function (params) {
      var deferred = $q.defer();
      //console.log("params : ", params);
      var nrequest = apiCall.apiCall("POST", "/topics/latest", params);
      nrequest.headers["Cache-Control"] = "No-Store";
      $http(nrequest).then(
        function successCallback(response) {
          //console.log("response : ",response);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(responseLatest) {
          deferred.reject(responseLatest);
        }
      );
      return deferred.promise;
    };
    obj.getPoliticianOffice = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/politician-office/list", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got Essay: ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            deferred.resolve(subcatdata);
          } else {
            deferred.resolve(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getOfficeList = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/office/list", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got Essay: ", response);
          /*if (response.data.success) {
            var subcatdata = response.data.data;
            deferred.resolve(subcatdata);
        } else {
            deferred.resolve(response.data);
        }*/
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getOnePolitician = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/politician/getone", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got Essay: ", response);
          // if (response.data.success) {
          //     var subcatdata = response.data.data;
          //     deferred.resolve(subcatdata);
          // } else {
          //     deferred.reject(response.error);
          // }
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getMultiCategoryByIds = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/categories/list-multiple",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getSubCatUsingIds = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/categories/getSubCatUsingIds",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * @description Service is use to add or edit questions using Post Mehod
     * @param {*} data
     */

    obj.addFiveMinEssayQuestions = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/questions/addfiveMinEssayQues",
        data
      );
      $http(request).then(
        function successCallback(response) {
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * @method Get
     * @description Service is use to get the list of five minute essay questions
     */

    obj.getFiveMinEssayQues = function () {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/questions/getFiveMinEssayQues");
      $http(request).then(
        function successCallback(response) {
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * @description Service is use to remove the question from the db.
     * @param {*} params
     */

    obj.removeEssayQuestion = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/questions/removeEssayQuestion",
        params
      );
      $http(request).then(
        function successCallback(response) {
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getQuestions = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/questions/list", params);
      request.headers["Cache-Control"] = "No-Store";
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // update courage questions

    obj.UpdateCourage = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/votequestions/updateCourageQue",
        params
      );
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getfivematch = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/questions/getfivematch", params);
      request.headers["Cache-Control"] = "No-Store";
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getFiveMinAnswers = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/answers/getFiveMinAnswers",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * @description Get count of answer question for five minute quiz.
     * @param {*} params
     */
    obj.getFiveMinCount = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/answers/getFiveMinCount", params);
      request.headers["Cache-Control"] = "No-Store";

      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * Get match of local politicians
     */

    obj.getMatchOfLocalPoli = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/questions/getMatchOfLocalPoli",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getAllFiveMatch = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/votequestions/getAllfivematch",
        params
      );
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.digDeepperQuestions = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/questions/digDeepperQuestions",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getMatchQUestions = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/questions/list", params);
      request.headers["Cache-Control"] = "No-Store";
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.signUp = function (params) {
      console.log("vishal", params);
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/signup", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got result from server: ", response);
          // if (response.data.success) {
          //     var subcatdata = response.data.data;
          //     deferred.resolve(subcatdata);
          // } else {
          //     deferred.resolve(response.data);
          // }
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.UpdateUser = function (params) {
      console.log("welcome to service", params);
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/UpdateUser", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got result from server: ", response);
          // if (response.data.success) {
          //     var subcatdata = response.data.data;
          //     deferred.resolve(subcatdata);
          // } else {
          //     deferred.resolve(response.data);
          // }
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.removeUser = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/remove", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got Essay: ", response);
          // if (response.data.success) {
          //     var subcatdata = response.data.data;
          //     deferred.resolve(subcatdata);
          // } else {
          //     deferred.resolve(response.data);
          // }
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.updateUserStatus = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/updateUserStatus", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got Essay: ", response);
          if (response.data.success) {
            //var subcatdata = response.data.data;
            deferred.resolve(response.data);
          } else {
            deferred.resolve(response.data);
          }
          //deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.managePoliticianOffice = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/user/manage-politician-office",
        params
      );
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getAddressData = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/ziplookup/list/filter", params);
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getfilterAddressData = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/user/getfilterOrganizedZipData",
        params
      );
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.postAnswer = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/answers/create", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * @description Service is use to store the essay answers into the db.
     * @param {*} params
     */
    obj.storeEssayAnswer = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/answers/storeEssayAnswer",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // guestAnswers

    obj.guestAnswers = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/answers/guestAnswers", params);
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    //  End of guestAnswers

    /**
     * @description Service is use to check if the quiz taker is exist or not
     */
    obj.checkIfQuizTakerExist = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/answers/checkIfQuizTakerExist",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    /**
     * End of checkIfQuizTakerExist
     */

    obj.getAllAnsweredQuestions = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/answers/list", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * Get all ques Data
     */

    obj.getAllAnsQuesWithIds = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/answers/getAllAnsQuesWithIds",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * Get cat for quiz
     */

    obj.getCatForQuiz = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/questions/getCatForQuiz", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * Get records of unverified users
     */

    obj.getUnVerifiedUser = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/getUnVerifiedUser", params);
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * getResultData
     */

    obj.getResultData = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/answers/getResultData", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /*
     * getFollowersAnsQues
     */

    obj.getFollowersAnsQues = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/answers/getFollowersAnsQues",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getAddressOfRunningPoli = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/politician/address/list", params);
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.AddNewOfficeData = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/office/add", params);
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.UpdateOfficeData = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/office/update", params);
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.forgotPassword = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/forgot-password", params);
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * This service fetch users having same email address
     */
    obj.checkEmailForMultiUsers = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/user/checkEmailForMultiUsers",
        params
      );
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // End Of checkEmailForMultiUsers

    // Update org quiz name

    obj.updateQuizName = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/questions/updateQuizName", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.trackPoliticians = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/trackPoliticians", params);
      request.headers["Cache-Control"] = "No-Store";
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getListOfCompetitors = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/user/getListOfCompetitors",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    //getRegisterUSersFrom

    obj.getRegisterUsersFrom = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/user/getRegisterUsersFrom",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getListOfOtherQuizzes = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/answers/getListOfOtherQuizzes",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getListOfFiveMinQuiz = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/answers/getListOfFiveMinQuiz",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * @description  uploadPopulationData
     */

    obj.uploadPopulationData = function () {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/uploadPopulationData");
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // End of getRegisterUSersFrom
    obj.getWithoutState = function () {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/elections/getWithoutState");
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * addBallotMeasuresData
     */
    obj.addBallotMeasuresData = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/elections/getBallotMeasures",
        params
      );
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * Get ballot measures data statewise
     */

    obj.getBallotMeasuresData = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/elections/getBallotMeasuresData",
        params
      );
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    /**
     * End of addBallotMeasures
     */

    obj.getListOfDates = function () {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/politician/getListOfParties");
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // searchForRate
    obj.searchForRate = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/politician/searchForRate", params);
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    // End of searchForRate

    /**
     * Get reviews by ballot Id
     */
    obj.getReviewsByBallotId = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/reviews/getReviewsByBallotId",
        params
      );
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * Get Review details
     */

    obj.getReviewsDetailsOf = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/reviews/getReviewsDetailsOf",
        params
      );
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * Get ballot measures data statewise
     */

    obj.getBallotMeausres = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/elections/getBallotMeausres",
        params
      );
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    /**
     * getOrgQuizQuestions
     */
    obj.getOrgQuizQuestions = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/questions/getOrgQuizQuestions",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * End of getOrgQuizQuestions
     */
    //  endorsePoli

    obj.endorsePoli = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/reviews/endorsePoli", params);
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    // End of endorsePoli

    /**
     * Endorse ballot measures
     */

    obj.endorseBallotMeasures = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/reviews/endorseBallotMeasures",
        params
      );
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * Get list of endorsers
     */
    obj.getListOfEndorsers = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/reviews/getListOfEndorsers",
        params
      );
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // Search poli for invitation
    obj.searchPoli = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/politician/searchPoli", params);
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    // end of searchPoli

    /**
     * Send Invitations to politician for solving quiz create by advocate. */
    obj.sendQuizInvitation = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/questions/sendQuizInvitation",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * End of send quiz invitations
     */

    /**
     * Get Records of all followers
     */
    obj.getIdsOfFollowers = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/questions/getIdsOfFollowers",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * End of getIdsOfFollowers
     */
    /**
     * Get info of invited politicians
     */

    obj.getInfoOfInvited = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/questions/getInfoOfInvited",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * End of sendQuizInvitation
     */

    /**
     * Get info of selected types
     */

    obj.getSeletedTypes = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/questions/getSeletedTypes",
        params
      );
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * removeOrgQues
     */
    obj.removeOrgQues = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/questions/removeOrgQues", params);
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    // End of removeOrgQues
    /**
     * Get Endorse Politician list
     */

    obj.getEndorsePoliList = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/reviews/getEndorsePoliList",
        params
      );
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // End of getEndorsePoliList

    /**
     * Get Selected Questions By Organizations
     */

    obj.getSelectedQues = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/questions/getSelectedQues",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // End of

    /**
     * Update order of questions
     */

    obj.updateOrder = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/questions/updateOrder", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // End of updateOrder

    /**
     * Fetch records of endorser
     */

    obj.getEndorsementsByUserId = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/reviews/getEndorsementsByUserId",
        params
      );
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * -- End of  getEndorsementsByUserId
     */

    /**
     * getFinalGroup
     */
    obj.getFinalGroup = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/answers/getFinalGroup", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          // alert(JSON.stringify(response));
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    /**
     * getFollowerMatch
     */
    obj.getFollowerMatch = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/answers/getFollowerMatch",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          // alert(JSON.stringify(response));
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * End of the getFollowerMatch
     */

    /**
     * Remove Politician from endorse table
     */
    obj.removePoliFromEndorse = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/reviews/removePoliFromEndorse",
        params
      );
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    // removePoliFromEndorse

    obj.forgotPoliticianPassword = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/user/forgotPoliticianPassword",
        params
      );
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.resetPassword = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/reset-password", params);
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.compareWithVotersFivemin = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/user/othervoters-listfivemin",
        params
      );
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          //console.log("Got User Data: ", response);
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getLocalPoliForVoterFivemin = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/user/politicians-listfivemin",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          //console.log("Got User Data: ", response);
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getCandidateListing = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/getCandidateListing", params);
      request.headers["Cache-Control"] = "No-Store";
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          //console.log("Got User Data: ", response);
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     *
     * GetAllLocalPoli
     */
    obj.getAllLocalPoli = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/getAllPoli", params);
      request.headers["Cache-Control"] = "No-Store";
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          //console.log("Got User Data: ", response);
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**End Of getAllLocalPoli */

    // getMailingAddress
    obj.getMailingAddress = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/getMailingAddress", params);
      request.headers["Cache-Control"] = "No-Store";
      // console.log('request :>> ', request);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got User Data: ", response);
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // End Of getMailingAddress

    obj.getLocalPoliForVoter = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/politicians-list", params);
      request.headers["Cache-Control"] = "No-Store";
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          //console.log("Got User Data: ", response);
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getLocalIncumbentPoliForVoter = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/user/incumbent-politicians-list",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          //console.log("Got User Data: ", response);
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.changeUsername = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/change-username", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("Got User Data: ", response);
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.changeEmailID = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/change-emailid", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          //console.log("Got User Data: ", response);
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getUserList = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/list", params);
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          //console.log("Got User Data: ", response);
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getCatListWithQueAnsCountUserwise = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/categories/list-question-answer-count-userwise",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          //console.log("Got User Data: ", response);
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getCategories = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/categories/list", params);
      request.headers["Cache-Control"] = "No-Store";
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          //console.log("Got categories: ", response);
          /*
        if (response.data.success) {
            deferred.resolve(response.data.data);
        } else {
            deferred.reject(response.data);
        }
        */
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * Get Parent cat Id
     */
    obj.getParentCat = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/categories/getParentCat", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          //console.log("Got categories: ", response);
          /*
        if (response.data.success) {
            deferred.resolve(response.data.data);
        } else {
            deferred.reject(response.data);
        }
        */
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getCompareAns = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/answers/compare", params);
      request.headers["Cache-Control"] = "No-Store";
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          //console.log("Got categories: ", response);
          /*
        if (response.data.success) {
            deferred.resolve(response.data.data);
        } else {
            deferred.reject(response.data);
        }
        */
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getSideBySide = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/answer/getSideBySide", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // getGuestCompareAns

    obj.getGuestCompareAns = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/answers/getGuestCompareAns",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          //console.log("Got categories: ", response);
          /*
        if (response.data.success) {
            deferred.resolve(response.data.data);
        } else {
            deferred.reject(response.data);
        }
        */
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    //  End of

    obj.sendActivatationMailtoAdmin = function () {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/sendReactivateMail", {});
      $http(request).then(
        function successCallback(response) {
          //console.log(response);
          if (response.data.success) {
            deferred.resolve(response.data);
          } else {
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.GetDialogWithButtons = function (ngDialog, message, button1, button2) {
      var deferred = $q.defer();
      //console.log("GetDialogWithButtons called");
      var modal = ngDialog.openConfirm({
        template:
          "<p>" +
          message +
          '</p>\
            <div class="ngdialog-buttons">\
                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">' +
          button1 +
          '</button>\
                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">' +
          button2 +
          "</button>\
            </div>",
        plain: true,
      });
      modal.then(
        function fullfilled(response) {
          //console.log("fullfilled: ", mydata);
          deferred.resolve(response);
        },
        function rejected(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.addParents = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/categories/add-parents", params);
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.editQuestion = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/questions/update", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getEssayAns = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/answers/getEssayAnswers", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.approveQuestion = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/questions/approve", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.checkUnm = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/check/username", params);
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.checkEmail = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/check/email", params);
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.checkPostCard = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/check/postCard", params);
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getPoliticianLocWise = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/user/politician-office-locationwise",
        params
      );
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getPoliticians = function (params) {
      console.log(params);
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/politician/getSearchedPolitician",
        params
      );
      $http(request).then(
        function successCallback(response) {
          console.log("Data:", response.data);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response.error);
        }
      );
      return deferred.promise;
    };

    // getPresident

    obj.getPresident = function (params) {
      console.log(params);
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/politician/getPresident", params);
      $http(request).then(
        function successCallback(response) {
          console.log("Data:", response.data);
          if (response.data.success) {
            deferred.resolve(response.data.data);
          } else {
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response.error);
        }
      );
      return deferred.promise;
    };

    obj.sendVerificationCode = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/user/sendVerificationCode",
        params
      );
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.sendBatchMail = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/sendBatchMail", params);
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.sendInvitations = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/sendInvitations", params);
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // obj.sendBatchMailTo = function (params) {
    //   var deferred = $q.defer();
    //   var request = apiCall.apiCall('POST', '/user/sendBatchMailTo', params);
    //   $http(request).then(
    //     function successCallback(response) {
    //       deferred.resolve(response);
    //     },
    //     function errorCallBack(response) {
    //       deferred.reject(response);
    //     }
    //   );
    //   return deferred.promise;
    // };

    /**
     * @description Function is use to create user's of orgs
     */
    obj.createUsersOfOrg = function () {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/createUsersOfOrg");
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.notifyUsersPasswords = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/send-password", params);
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.GetAnsQuestionReport = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/questions/GetAnsQuestionReport",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.GetAreaQuestionReport = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/questions/GetAreaQuestionReport",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.GetAllUsersAnsReport = function () {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/questions/GetAllUsersAnsReport",
        {}
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.GetCommentsQuestionReport = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/questions/GetCommentsQuestionReport",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getComments = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/questions/GetComments", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getUserAnsQuestion = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/questions/getUserAnsQuestion",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getUsersFromIds = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/getUsersFromIds", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          if (response.data.success) {
            deferred.resolve(response);
          } else {
            deferred.reject(response);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * @description Funtion is use to get records of endorsement for selected politician.
     */
    obj.getEndorsementData = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/reviews/getEndorsementData",
        params
      );
      $http(request).then(
        function successCallback(response) {
          if (response.data.success) {
            deferred.resolve(response);
          } else {
            deferred.reject(response);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    /**
     * End of
     */

    obj.getRatingsFor = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/reviews/getRatingsFor", params);
      $http(request).then(
        function successCallback(response) {
          if (response.data.success) {
            deferred.resolve(response);
          } else {
            deferred.reject(response);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.updateRating = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/reviews/updateRating", params);
      $http(request).then(
        function successCallback(response) {
          if (response.data.success) {
            deferred.resolve(response);
          } else {
            deferred.reject(response);
          }
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getUserPublicProfile = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/publicProfile", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          // console.log('User ======== response in service :', response);
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    /**
     * @description Add ratings
     */
    obj.getRatingsOfCandidate = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/reviews/getRatingsOfCandidate",
        params
      );
      $http(request).then(
        function successCallback(response) {
          // console.log('User ======== response in service :', response);
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.setDeepInterest = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/setDeepInterest", params);
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getReviewSearchResult = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/reviews/getReviewSearchResult",
        params
      );
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getNewsFeed = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/essay-press/getNewsFeed", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.AddFavorite = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/recommendation/add", params);
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.RemoveFavorite = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/recommendation/remove", params);
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.recommendFav = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/recommendation/recommendFav",
        params
      );
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.ListMyFavorite = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/recommendation/listAll", params);
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getRecommended = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/recommendation/getRecommended",
        params
      );
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.spamMail = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/sendSpamMail", params);
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.updateFBID = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/updateFacebookId", params);
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.matchQuestionwithPolitician = function () {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/answers/matchQuestionwithPolitician",
        {}
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // For Ballot match

    obj.getBallotQue = function () {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/answers/getBallotQuestion", {});
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    //For answered Questions

    obj.getAnsweredQuestions = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/answers/getAnsweredQuestions",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.matchQuestionwithOrg = function () {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/answers/matchQuestionwithOrg", {});
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getFiveFacebookPost = function () {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/getFiveFacebookPost", {});
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.CompareWithFreinds = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/answers/CompareWithFreinds",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.CompareWithPolitcians = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/answers/CompareWithPolitcians",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.compareFiveMinAnswers = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/answers/compareFiveMinAnswers",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          alert(JSON.stringify(response));
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.CompareWithAllPolitcians = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/answers/CompareWithAllPolitcians",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.addBannerInfo = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/addBannerInfo", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getBannerInfo = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/getBannerInfo", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    //checkInviter

    obj.checkInviter = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/answers/checkInviter", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    //  compareRegisterGuestUsers

    obj.compareRegisterGuestUsers = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/answers/compareRegisterGuestUsers",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // End of compareRegisterGuestUsers

    /**
     * Get match of popular quiz
     */

    obj.getPopularMatch = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/answers/getPopularMatch", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * Compare with all
     */

    obj.compareWithAll = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/questions/compareWithAll",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * End of compare with all
     */

    // compareGuest

    obj.compareGuest = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/answers/compareGuest", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    //  End of compareGuest

    // getAdvocates
    obj.getAdvocates = function () {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/getAdvocates");
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    //  End of getAdvocates

    // getComparisonOfGroup
    obj.getComparisonOfGroup = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/answers/getGroupComparison",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    //getUserSpecificQues
    obj.getUserSpecificQues = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/answers/getUserSpecificQues",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    //  End Of getComparisonOfGroup

    obj.getOthersMatch = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/answers/getOthersMatch", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * Get popular quiz comparison
     */
    obj.getPopularComparison = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/answers/getPopularComparison",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * Show all quizzes
     */
    obj.showAllQuizzes = function () {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/questions/showAllQuizzes");
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.checkIfInvited = function () {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/questions/checkIfInvited");
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * Delete quiz
     */
    obj.deleteQuiz = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/questions/deleteQuiz", params);
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // showUsersAnswers

    obj.showUsersAnswers = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/answers/getUsersAnswers", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    //  End Of showUsersAnswers

    /**
     * getQuesCount
     */
    obj.getQuesCount = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/questions/getQuesCount", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * End of the getQuesCount
     */

    // getAllUsersOfNation

    obj.getAllUsersOfNation = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/answers/getAllUsersOfNation",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    //  End of getAllUsersOfNation

    //  getRegisterUsersOfNation

    obj.getRegisterUsersOfNation = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/answers/getRegisterUsersOfNation",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    //  End of getRegisterUsersOfNation

    /**
     * @description Get list of politicians and org with individual match.
     */

    obj.getIndividualMatchList = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/answers/getIndividualMatchList",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    /**
     * End of getIndividualMatchList
     */

    obj.checkfreindsIfanswered = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/answers/checkfreindsIfanswered",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.updateAnswers = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/answers/updateShow", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getReportedQuestions = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/questions/reportlist", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.removeReportedQuestion = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/questions/removeReportedQeustion",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.removeMatchedQuestion = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/questions/removeMatchedQuestion",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getLatestEssay = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/latestEssay", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getLatestPost = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/latestPost", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getLatestThread = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/latestThread", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.latestDataDateWise = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/latestDataDateWise", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getLiveUsers = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/getLiveUsers", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getLinkPreview = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/check/linkpreview", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.saveTempPolitician = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/politician/savetemp", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.restoreTempPolitician = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/politician/restoretemp", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.checkifStateExists = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/politician/checkifStateExists",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getOrganizedData = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/getOrganizedData", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getOrganizedZipData = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/getOrganizedZipData", params);
      $http(request).then(
        function successCallback(response) {
          // console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // deleteGuest

    obj.deleteGuest = function (params) {
      // console.log("$$$$$$$$ params >>>>", params);
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/answers/deleteGuest", params);
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          // console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     *
     * @param {*} params
     * @description Method to get the list of guest users five minute answers.
     * @method GET
     */

    obj.getGuestFiveMinAns = function (params) {
      // console.log("$$$$$$$$ params >>>>", params);
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/answers/getGuestFiveMinAns",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          // console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // End of deleteGuest

    obj.removeStoredTempPolitician = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/politician/removeStoredTempPolitician",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.savePoliticianGrid = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/savePoliticianGrid", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.updatePoliticianGrid = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/user/updatePoliticianGrid",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.removePoliticianGrid = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/user/removePoliticianGrid",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.saveFavChannel = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/user/saveFavChannel", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getCalendarList = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/calendar/listAll", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getCalendarEventList = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/calendar/listAllEvents", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.matchMembers = function (params) {
      // console.log(params);
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/congressbill/matchMembersWithName",
        params
      );
      $http(request).then(
        function successCallback(response) {
          // console.log("topics : ", response);
          if (response.data.success) {
            // var subcatdata = response.data.data;

            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getIndustryData = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/congressbill/getIndustrySupportData",
        data
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getPersonalHoldings = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/congressbill/getPersonalHoldingsData",
        data
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getFundRaising = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/congressbill/getFundRaisingData",
        data
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getTopContributor = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/congressbill/topContributorData",
        data
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getVotingRecords = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/congressbill/getVotingRecordOfMember",
        data
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getBillCosponsoredData = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/congressbill/getBillCosponsoredData",
        data
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.getProbublicaData = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/congressman/getProbublicaData",
        data
      );
      $http(request).then(
        function successCallback(response) {
          console.log("got data");
          // console.log("topics : ", response);
          if (response) {
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getFollowerForPublic = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/user/getFollowerForPublic", data);
      $http(request).then(
        function successCallback(response) {
          // console.log('got data');
          // console.log('topics : ', response);
          if (response.data.success) {
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getRatingData = function (data) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/reviews/getRatingData", data);
      $http(request).then(
        function successCallback(response) {
          // console.log('got data');
          // console.log('topics : ', response);
          if (response.data.success) {
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getOpenStateData = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/openState/getOpenStateData",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    // get Billvotes
    obj.getBillVotes = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/openState/getBillVotes", params);
      request.timeout = canceler;

      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    // End of get Billvotes

    // get Bills stateWise

    obj.viewBills = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/openState/viewBillsStateWise",
        params
      );
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    //End Of get Bills stateWise

    obj.addCongressBills = function () {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/congressbills/addCongressbills");
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            deferred.resolve(response);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getAllCongressman = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/congressman/getCongressman",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.findCongressmenMismatch = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/congressman/findCongressmenMismatch",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };
    obj.addCongressman = function () {
      var deferred = $q.defer();
      var params = "";
      var request = apiCall.apiCall(
        "GET",
        "/congressman/addCongressman",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.addMatchedMembers = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/congressbill/addmatchedMembers",
        params
      );
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.matchPeople = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/openState/matchPeople", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.saveForLaterQuiz = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/questions/saveForLaterQuiz",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * @description Get remaining quiz details
     * @param {*} params
     */
    obj.getRemainingQuizData = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/questions/getRemainingQuizData",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    /**
     * @description Update remainig quiz links array
     * @param {*} params
     */

    obj.updateRemainingQuiz = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/questions/updateRemainingQuiz",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.addMatchedPeople = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("GET", "/openState/addMatchPeople", params);
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.success) {
            var subcatdata = response.data.data;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            //alert("Something went wrong: ", response.data);
            deferred.reject(response.data.error);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getNewsSource = function (params) {
      var deferred = $q.defer();
      // var proxyUrl = "https://cors-anywhere.herokuapp.com/";
      // var request = {
      //   method: 'GET',
      //   url: proxyUrl+'https://newsapi.org/v2/sources?language=en&apiKey=bb63dab0fb0044628b12fa12ce8c4809',
      //   headers: {
      //     'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
      //   },
      // };
      var request = apiCall.apiCall("GET", "/user/getNewsSource");
      $http(request).then(
        function successCallback(response) {
          // console.log("topics : ", response);
          if (response.data.data.status == "ok") {
            var subcatdata = response.data.data.sources;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            deferred.reject(response);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getFavNews = function (params) {
      //console.log("https://newsapi.org/v1/articles?source=" + params.favChannel + "&sortBy=top&apiKey=bb63dab0fb0044628b12fa12ce8c4809&callback=foo");
      var deferred = $q.defer();
      // var request = {
      //   method: 'GET',
      //   url: 'https://newsapi.org/v2/articles?source=' +
      //     params.favChannel +
      //     '&sortBy=top&apiKey=bb63dab0fb0044628b12fa12ce8c4809&callback=foo',
      //   headers: {
      //     'Content-Type': 'application/x-www-form-urlencoded;',
      //   },
      // };
      var request = apiCall.apiCall("GET", "/user/getFavNewsChannel", params);

      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          if (response.data.data.status == "ok") {
            var subcatdata = response.data.data.articles;
            //console.log("topics : ", subcatdata);
            deferred.resolve(subcatdata);
          } else {
            deferred.reject(response);
          }
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.addReview = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall("POST", "/reviews/store-review", params);
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getReviewsByUserId = function (params, canceler) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/reviews/get-reviews-by-user-id",
        params
      );
      request.timeout = canceler;
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getReviewsById = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/reviews/get-reviews-by-id",
        params
      );
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getCompareReviewList = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "POST",
        "/reviews/getCompareReviewList",
        params
      );
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getOrgCompareAnswers = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/answers/getOrgCompareAnswers",
        params
      );
      request.headers["Cache-Control"] = "No-Store";
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getVotesmartPressDetails = function (params) {
      var deferred = $q.defer();
      var request = apiCall.apiCall(
        "GET",
        "/reviews/getVotesmartPressDetails",
        params
      );
      $http(request).then(
        function successCallback(response) {
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    obj.getVotesmartRatings = function (params) {
      var deferred = $q.defer();
      var request = {
        method: "GET",
        url:
          "https://api.votesmart.org/Rating.getCandidateRating?key=" +
          params.key +
          "&candidateId=" +
          params.id +
          "&sigId=" +
          params.sigid +
          "&o=JSON",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
        },
      };
      console.log("request > ", request);
      $http(request).then(
        function successCallback(response) {
          //console.log("topics : ", response);
          deferred.resolve(response);
        },
        function errorCallBack(response) {
          //console.log("topics : ", response);
          deferred.reject(response);
        }
      );
      return deferred.promise;
    };

    return obj;
  }]);

mainApp
  .directive('fileModel', [
    '$parse',
    function ($parse) {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          var model = $parse(attrs.fileModel);
          var modelSetter = model.assign;
          var maxSize = 1000000;

          element.bind('change', function () {
            scope.$apply(function () {
              if (attrs.multiple) {
                modelSetter(scope, element[0].files);
              } else {
                modelSetter(scope, element[0].files[0]);
              }

              var fileSize = element[0].files[0].size;
              if (fileSize > maxSize) {
                scope.upload.PoliticianButton = true;
                scope.upload.maxSizeError = true;
                alert("Maximum file size allowed is 1MB.");
              }
            });
          });
        }
      };
    }
  ])
  // directive('formscroll', function formScroll($window) {
  //      return {
  //        link: function(scope, elem) {
  //               elem.bind('focus', function() {
  //                 console.log("after focus");
  //                //  var offset,
  //                // elOffset = elem.prop('offsetTop'), //.offset().top,
  //                // elHeight = elem.prop('height'), //elem.height(),
  //                // windowHeight = $window.innerHeight;
  //                // offset = elOffset - ((windowHeight - elHeight) / 2);
  //                //$window.scrollTo(0, offset);
  //                $(window).resize();
  //              });
  //        }
  //     }
  //  })

  .directive('viDropdown', [
    '$parse',
    function ($parse) {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {

          element.bind('click', function () {
            $(element).toggleClass("open");
          });
        }
      };
    }
  ])
  .directive("fixedFirstColumn", [function () {
    return {
      restrict: "A",
      template: "<div class='table-responsive'><div ng-transclude></div></div>",
      transclude: true,
      link: function ($scope, $element) {
        var interval = setInterval(function () {
          var tr = $element.find("tr");

          angular.forEach(tr, function (i) {
            var columns = angular.element(i).children();

            if (columns.length < 1) {
              // Row with no columns? Ignore it.
              return;
            }

            var column0 = angular.element(columns[0]).children()[0] || columns[0];
            var column1 = columns[2];

            // Calculate heights of each <td>.
            var height0 = (column0).offsetHeight;
            var height1 = column1 ? column1.offsetHeight : 0;

            // Calculate final height.
            var height = Math.max(height0, height1);

            // Set heights of <td> and <tr>.
            columns[0].style.height = height + "px";
            i.style.height = height + "px";

            if (column1) {
              column1.style.height = height + "px";
            }

            // If <td> heights have stabilized.
            if (height0 !== 0 && height0 === height1) {
              clearInterval(interval);
            }
          });
        }, 1000);
      }
    };
  }])
  .directive('autoComplete', ["$timeout", function ($timeout) {
    return function (scope, iElement, iAttrs) {
      iElement.autocomplete({
        source: scope[iAttrs.uiItems],
        select: function () {
          $timeout(function () {
            iElement.trigger('input');
          }, 0);
        }
      });
    };
  }])
  .directive('validFile', ["$parse", function ($parse) {
    return {
      require: 'ngModel',
      restrict: 'A',
      link: function (scope, el, attrs, ngModel) {
        var model = $parse(attrs.ngModel);
        var modelSetter = model.assign;
        var maxSize = 2000; //2000 B
        el.bind('change', function () {

          scope.$apply(function () {
            scope.ebook.maxSizeError = false;
            if (el[0].files.length > 1) {
              modelSetter(scope, el[0].files);
            } else {
              modelSetter(scope, el[0].files[0]);
            }
            var fileSize = el[0].files[0].size;
            if (fileSize > maxSize) {
              scope.ebook.maxSizeError = true;
            }
          });
        });
      }
    }
  }])
  .directive('checkFileSize', function () {
    return {
      link: function (scope, elem, attr, ctrl) {
        function bindEvent(element, type, handler) {
          if (element.addEventListener) {
            element.addEventListener(type, handler, false);
          } else {
            element.attachEvent('on' + type, handler);
          }
        }

        bindEvent(elem[0], 'change', function () {
          var _validFileExtensions = [".jpg", ".jpeg", ".bmp", ".gif", ".png", ".svg", ".xlsx"];
          var sFileName = this.value;
          //console.log(this.value);
          if (sFileName.length > 0) {
            var blnValid = false;
            for (var j = 0; j < _validFileExtensions.length; j++) {
              var sCurExtension = _validFileExtensions[j];
              if (sFileName.substr(sFileName.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) {
                blnValid = true;
                break;
              }
            }

            if (!blnValid) {
              alert("Sorry, " + sFileName + " is invalid, allowed extensions are: " + _validFileExtensions.join(", "));
              this.value = "";
              return false;
            }
          }
          if (this.files[0].size > 1000000) {
            alert("Maximum file size allowed is 1MB. You are uploading file of size " + this.files[0].size);
            this.value = '';
          }

        });
      }
    }
  })
  .filter('addHttp', [function () {
    return function (url) {
      //check if is string is blank return true if blank
      if (url.indexOf("http://") != 0 && url.indexOf("https://") != 0)
        url = "http://" + url;

      return url;
    }
  }])
  .filter('isBlankString', [function () {
    return function (str) {
      //check if is string is blank return true if blank
      if (!str) {
        return true;
      } else if (str == "null" || str == "undefined") {
        return true;
      }
      var regex = /^\s*$/;
      if (regex.test(str)) {
        return true;
      } else {
        return false;
      }
    }
  }])
  .filter('getItemIndex', function () {
    //order the groupped dat with by it's key
    return function (data, id) {
      var index = -1;
      var len = data.length;
      for (var i = 0; i < len; i++) {
        if (data[i]._id == id) {
          // item = data[i];
          index = i;
          break;
        }
      }
      return index;
    };
  })
  .filter('newlines', ['$sce', function ($sce) {
    return function (text) {
      // return text.split(/\n/g);
      if (text)
        return $sce.trustAsHtml(text.replace(/(?:\r\n|\r|\n)/g, '<br />'));
      else
        return $sce.trustAsHtml(text);
    };
  }])
  .filter('to_trusted', ['$sce', function ($sce) {
    return function (text) {
      return $sce.trustAsHtml(text);
    };
  }])
  .filter('vdourl', ['$sce', function ($sce) { // My custom filter
    return function (vdurl) {
      //console.log("vdurl : ", vdurl);
      var url = vdurl;
      if (url.indexOf("youtube.com") >= 0) {
        var url = url.replace("watch?v=", "v/");
        return $sce.trustAsHtml('<br/><iframe width="560" height="315" src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>');
      }
      if (url.indexOf("facebook.com") >= 0) {
        return $sce.trustAsHtml('<br/><iframe src="' + url + '" width="560" height="600" frameborder="0"></iframe><br/>');
      }
      if (url.indexOf("vimeo.com") >= 0) {
        if (url.indexOf("https://vimeo.com/") >= 0) {
          var id = url.replace("https://vimeo.com/", "");
          var newurl = "https://player.vimeo.com/video/" + id;
        } else {
          var newurl = url;
        }

        return $sce.trustAsHtml('<br/><iframe src="' + newurl + '" width="500" height="281" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe><br/>');
      }
      return $sce.trustAsHtml('<br/><iframe width="560" height="315" src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>');
    }
  }])
  .filter('convertHTML', ['$sce', function ($sce) { // My custom filter
    return function (html) {
      var newHTML = $sce.trustAsHtml(html);
      var newDiv = document.createElement("div");
      newDiv.innerHTML = newHTML;
      //console.log("Origininal : ", newDiv);
      var tags = newDiv.getElementsByTagName("p");
      //console.log(tags[0]);
      if (tags[0]) {
        //console.log("Firs P Tag : ", $(tags[0]).html());
        return $sce.trustAsHtml($(tags[0]).html());
      } else {
        return $sce.trustAsHtml(html.substring(0, 100) + "...");
      }
    }
  }])
  .filter('urlify', ["$sce", "$q", "$http", "$filter", "baseApiUrl", "MyService", function ($sce, $q, $http, $filter, baseApiUrl, MyService) { // My custom filter
    var deferred = $q.defer();
    var promise = deferred.promise;
    var ncahche = {};

    var tempWDefault = 560;
    var tempHDefault = 315;
    var tempW = 560;
    var tempH = 315;

    function getHttpData(xurl, fdata) {
      if (ncahche[xurl]) {
        return ncahche[xurl];
      }
      ncahche[xurl] = "fetching...";
      //console.log(xurl);

      // $http.jsonp(url)
      //     .success(function(response) {
      //         //console.log(response);
      //         ncahche[xurl] = $sce.trustAsHtml('<br/><a href="' + response.url + '" target="_blank"><h3>' + response.title + '</h3><div style="width:98%%; clear:both;"><img src="' + response.image + '" style="width:'+tempWDefault+'px; height:auto; max-width: 98%;" /></div><div style="width:98%; clear:both;">' + response.description + '</div></a><br/>');
      //     });
      MyService.getLinkPreview({
        "weburl": xurl
      }).then(function (response) {
        //console.log(response);
        ncahche[xurl] = $sce.trustAsHtml('<br/><a href="' + xurl + '" target="_blank"><h3>' + response.title + '</h3><div style="width:98%%; clear:both;"><img src="' + response.image + '" style="width:' + tempWDefault + 'px; height:auto; max-width: 98%;" /></div><div style="width:98%; clear:both;">' + response.description + '</div></a><br/>');

      }, function (error) {
        //console.log(error);
        ncahche[xurl] = error;

      });

    }

    function urlifyFilter(text) {
      //console.log("------------------------------");
      //console.log("text:", text);
      //console.log("width: ", tempW);
      //console.log("height: ", tempH);
      //console.log("------------------------------");

      text = text.replace(/(?:\r\n|\r|\n)/g, '<br />');
      var regex = new RegExp('<iframe.*src=(.+?) .*<\/iframe>', "g");
      var newurl = text.match(regex);
      var finaltext = "";
      if ((newurl) && (newurl.length > 0)) {
        try {
          var chk = $(text);
          tempW = chk.attr("width") || 560;
          tempH = chk.attr("height") || 315;
        } catch (e) {
          //console.log("Exception: ", e);
        }
        newurl.forEach(function (val, idx) {
          finaltext = val.match(/<iframe.*src=(.+?) .*<\/iframe>/);
          var finalurl = finaltext[1].replace(/"/g, '');
          text = text.replace(val, finalurl);
        });
      }

      var urlRegex = /(http(s?):\/\/[^\s]+)/g;
      var data = text.replace(urlRegex, function (url) {
        var rdata = url;
        if (url.indexOf("youtube.com") >= 0) {
          var url = url.replace("watch?v=", "embed/");
          //var url = url.replace("watch?v=", "embed/");
          var nurl = url.split("&");
          var durl = nurl[0];
          //url = 'https://www.google.com/search?q=%'+url+"&output=embed";
          return '<br/><iframe sandbox="allow-forms allow-same-origin allow-scripts" width="' + tempWDefault + '" height="' + tempHDefault + '" src="' + durl + '" style="max-width:98%;" frameborder="0" allowfullscreen></iframe><br/>';
        }
        if (url.indexOf("facebook.com") >= 0) {
          return '<br/><iframe sandbox="allow-forms allow-same-origin allow-scripts" src="' + url + '" width="' + tempW + '" height="' + tempH + '" frameborder="0" style="max-width:98%;"></iframe><br/>';
        }
        if (url.indexOf("vimeo.com") >= 0) {
          if (url.indexOf("https://vimeo.com/") >= 0) {
            var id = url.replace("https://vimeo.com/", "");
            var newurl = "https://player.vimeo.com/video/" + id;
          } else {
            //url = 'https://www.google.com/search?q=%'+url+"&output=embed";
            var newurl = url;
          }
          return '<br/><iframe sandbox="allow-forms allow-same-origin allow-scripts" src="' + newurl + '" width="' + tempWDefault + '" height="' + tempHDefault + '" style="max-width:98%;" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe><br/>';
        }
        //url = 'https://www.google.com/search?q=%'+url+"&output=embed";
        //url = url.replace("https://", "http://");
        //var nurl = 'http://localhost:8080/ topics/getHttpUrl?url=' + url;
        //console.log("baseApiUrl::::",baseApiUrl);
        if (url.indexOf("http://") > -1) {
          var nurl = baseApiUrl + '/topics/getHttpUrl?url=' + url;
        } else {
          var nurl = url;
        }
        var fdata = $sce.trustAsHtml('<br/><iframe sandbox="allow-forms allow-same-origin allow-scripts" width="' + tempWDefault + '" height="' + tempHDefault + '" src="' + nurl + '" style="max-width:98%;" frameborder="0" allowfullscreen></iframe><br/>');
        //var para = document.createElement("DIV");
        //return getHttpData(xurl, fdata);
        return getHttpData(url, fdata);
      });
      //console.log(data);
      return $sce.trustAsHtml(data);
    }

    urlifyFilter.$stateful = true;

    return urlifyFilter;
  }])
  .filter('urlifyshort', ["$sce", "$q", "$http", "$filter", "baseApiUrl", "MyService", function ($sce, $q, $http, $filter, baseApiUrl, MyService) { // My custom filter
    var deferred = $q.defer();
    var promise = deferred.promise;
    var ncahche = {};

    var tempWDefault = 560;
    var tempHDefault = 315;
    var tempW = 560;
    var tempH = 315;

    function getHttpData(xurl, fdata) {
      if (ncahche[xurl]) {
        return ncahche[xurl];
      }
      ncahche[xurl] = "fetching...";
      //console.log(xurl);

      // $http.jsonp(url)
      //     .success(function(response) {
      //         //console.log(response);
      //         ncahche[xurl] = $sce.trustAsHtml('<br/><a href="' + response.url + '" target="_blank"><h3>' + response.title + '</h3><div style="width:98%%; clear:both;"><img src="' + response.image + '" style="width:'+tempWDefault+'px; height:auto; max-width: 98%;" /></div><div style="width:98%; clear:both;">' + response.description + '</div></a><br/>');
      //     });
      MyService.getLinkPreview({
        "weburl": xurl
      }).then(function (response) {
        //console.log(response);
        ncahche[xurl] = $sce.trustAsHtml('<img src="' + response.image + '" style="width:' + tempWDefault + 'px; height:auto; max-width: 30%; float:left;" />');

      }, function (error) {
        //console.log(error);
        ncahche[xurl] = error;

      });

    }

    function urlifyshortFilter(text) {
      //console.log("------------------------------");
      //console.log("text:", text);
      //console.log("width: ", tempW);
      //console.log("height: ", tempH);
      //console.log("------------------------------");

      text = text.replace(/(?:\r\n|\r|\n)/g, '');
      var regex = new RegExp('<iframe.*src=(.+?) .*<\/iframe>', "g");
      var newurl = text.match(regex);
      var finaltext = "";
      if ((newurl) && (newurl.length > 0)) {
        try {
          var chk = $(text);
          tempW = chk.attr("width") || 560;
          tempH = chk.attr("height") || 315;
        } catch (e) {
          //console.log("Exception: ", e);
        }
        newurl.forEach(function (val, idx) {
          finaltext = val.match(/<iframe.*src=(.+?) .*<\/iframe>/);
          var finalurl = finaltext[1].replace(/"/g, '');
          text = text.replace(val, finalurl);
        });
      }

      var urlRegex = /(http(s?):\/\/[^\s]+)/g;
      var data = text.replace(urlRegex, function (url) {
        var rdata = url;
        if (url.indexOf("youtube.com") >= 0) {
          var url = url.replace("watch?v=", "embed/");
          //var url = url.replace("watch?v=", "embed/");
          var nurl = url.split("&");
          var durl = nurl[0];
          //url = 'https://www.google.com/search?q=%'+url+"&output=embed";
          return '<br/><iframe sandbox="allow-scripts allow-same-origin allow-presentation" width="' + tempWDefault + '" height="' + tempHDefault + '" src="' + durl + '" style="max-width:98%;" frameborder="0" allowfullscreen></iframe><br/>';
        }
        if (url.indexOf("facebook.com") >= 0) {
          return '<br/><iframe sandbox="allow-scripts allow-same-origin allow-presentation" src="' + url + '" width="' + tempW + '" height="' + tempH + '" frameborder="0" style="max-width:98%;"></iframe><br/>';
        }
        if (url.indexOf("vimeo.com") >= 0) {
          if (url.indexOf("https://vimeo.com/") >= 0) {
            var id = url.replace("https://vimeo.com/", "");
            var newurl = "https://player.vimeo.com/video/" + id;
          } else {
            //url = 'https://www.google.com/search?q=%'+url+"&output=embed";
            var newurl = url;
          }
          return '<br/><iframe sandbox="allow-scripts allow-same-origin allow-presentation" src="' + newurl + '" width="' + tempWDefault + '" height="' + tempHDefault + '" style="max-width:98%;" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe><br/>';
        }
        //url = 'https://www.google.com/search?q=%'+url+"&output=embed";
        //url = url.replace("https://", "http://");
        //var nurl = 'http://localhost:8080/ topics/getHttpUrl?url=' + url;
        //console.log("baseApiUrl::::",baseApiUrl);
        if (url.indexOf("http://") > -1) {
          var nurl = baseApiUrl + '/topics/getHttpUrl?url=' + url;
        } else {
          var nurl = url;
        }
        var fdata = $sce.trustAsHtml('<iframe sandbox="allow-scripts allow-same-origin allow-presentation" width="' + tempWDefault + '" height="' + tempHDefault + '" src="' + nurl + '" style="max-width:98%;" frameborder="0" allowfullscreen></iframe>');
        //var para = document.createElement("DIV");
        //return getHttpData(xurl, fdata);
        return getHttpData(url, fdata);
      });
      /*var checkimg = data.match(/<img/);
      var checkiframe = data.match(/<iframe/);
      var imageTag = document.querySelector("img").outerHTML;
      //console.log(imageTag);
      var iframeTag = document.querySelector("iframe").outerHTML;
      var hdata = data.replace(iframeTag, '');
      hdata = data.replace(imageTag, '');
      if(checkimg) {
          var fdata = hdata.substring(0,100)+"...";
          return $sce.trustAsHtml(imageTag+'<div style="float:left;">'+fdata+'</div>');
      } else if(checkiframe) {
           var fdata = hdata.substring(0,100)+"...";
          return $sce.trustAsHtml(fdata+iframeTag);
      } else {

      }*/
      var checkimg = data.match(/<img/);
      var checkiframe = data.match(/<iframe/);
      if (checkimg) {
        var elem = data.match(/<img[^>]+>/);
        var hdata = data.replace(elem[0], '');
        if (hdata != "") {
          var fdata = hdata.substring(0, 100) + "...";
        } else {
          var fdata = '';
        }
        return $sce.trustAsHtml(elem[0] + fdata);
      } else if (checkiframe) {
        var elem = data.match(/<iframe[^>]+>/);
        if (elem) {
          var newelem = elem[0] + '</iframe>';
          var hdata = data.replace(newelem, '');
          hdata = hdata.replace('<br/><br/>', '');
          if (hdata != "") {
            var fdata = hdata.substring(0, 100) + "...";
          } else {
            var fdata = '';
          }
          return $sce.trustAsHtml(fdata + '<br/>' + newelem);
        }

      } else {
        return $sce.trustAsHtml(data.substring(0, 100) + "...");
      }
    }

    urlifyshortFilter.$stateful = true;
    return urlifyshortFilter;
  }])
  .filter('escape', function () {
    return function (input) {
      if (input) {
        return window.encodeURIComponent(input);
      }
      return "";
    }
  })
  .filter('fuzzy', function () {
    return function (collection, search, csensitive) {
      var sensitive = csensitive || false;

      collection = collection;

      if (!angular.isArray(collection) || angular.isUndefined(search)) {
        return collection;
      }

      search = (sensitive) ? search : search.toLowerCase();

      return collection.filter(function (elm) {
        if (angular.isString(elm)) {
          elm = (sensitive) ? elm : elm.toLowerCase();
          return hasApproxPattern(elm, search) !== false
        }
        return (angular.isObject(elm)) ? _hasApproximateKey(elm, search) : false;
      });

      /**
       * checks if object has key{string} that match
       * to fuzzy search pattern
       * @param object
       * @param search
       * @returns {boolean}
       * @private
       */
      function hasApproxPattern(word, pattern) {
        // cheaper version of indexOf; instead of creating each
        // iteration new str.
        function indexOf(word, p, c) {
          var j = 0;
          while ((p + j) <= word.length) {
            if (word.charAt(p + j) == c) return j;
            j++;
          }
          return -1;
        }
        var p = 0;
        for (var i = 0; i <= pattern.length; i++) {
          var index = indexOf(word, p, pattern.charAt(i));
          if (index == -1) return false;
          p += index + 1;
        }
        return true
      }

      function _hasApproximateKey(object, search) {
        var properties = Object.keys(object),
          prop, flag;
        return 0 < properties.filter(function (elm) {
          prop = object[elm];

          //avoid iteration if we found some key that equal[performance]
          if (flag) return true;

          if (angular.isString(prop)) {
            prop = (sensitive) ? prop : prop.toLowerCase();
            return flag = (hasApproxPattern(prop, search) !== false);
          }

          return false;

        }).length;
      }
    }
  })
  .filter('nospace', function () {
    return function (value) {
      return (!value) ? '' : value.replace(/ /g, '');
    };
  })
  .filter('decode_newline', ['$sce', function ($sce) { // My custom filter
    return function (text) {
      ;
      text = text.replace(/(?:\r\n|\r|\n)/g, '<br />');
      return $sce.trustAsHtml(text);
    }
  }]);

/**
 * Bunch of useful filters for angularJS(with no external dependencies!)
 * @version v0.5.7 - 2015-10-04 * @link https://github.com/a8m/angular-filter
 * @author Ariel Mashraki <ariel@mashraki.co.il>
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
(function ( window, angular, undefined ) {
/*jshint globalstrict:true*/
'use strict';

var isDefined = angular.isDefined,
    isUndefined = angular.isUndefined,
    isFunction = angular.isFunction,
    isString = angular.isString,
    isNumber = angular.isNumber,
    isObject = angular.isObject,
    isArray = angular.isArray,
    forEach = angular.forEach,
    extend = angular.extend,
    copy = angular.copy,
    equals = angular.equals;


/**
 * @description
 * get an object and return array of values
 * @param object
 * @returns {Array}
 */
function toArray(object) {
  return isArray(object) 
    ? object 
    : Object.keys(object).map(function(key) {
      return object[key];
    });
}

/**
 * @param value
 * @returns {boolean}
 */
function isNull(value) {
    return value === null;
}

/**
 * @description
 * return if object contains partial object
 * @param partial{object}
 * @param object{object}
 * @returns {boolean}
 */
function objectContains(partial, object) {
  var keys = Object.keys(partial);

  return keys.map(function(el) {
    return (object[el] !== undefined) && (object[el] == partial[el]);
  }).indexOf(false) == -1;

}

/**
 * @description
 * search for approximate pattern in string
 * @param word
 * @param pattern
 * @returns {*}
 */
function hasApproxPattern(word, pattern) {
  if(pattern === '')
    return word;

  var index = word.indexOf(pattern.charAt(0));

  if(index === -1)
    return false;

  return hasApproxPattern(word.substr(index+1), pattern.substr(1))
}

/**
 * @description
 * return the first n element of an array,
 * if expression provided, is returns as long the expression return truthy
 * @param array
 * @param n {number}
 * @param expression {$parse}
 * @return array or single object
 */
function getFirstMatches(array, n, expression) {
  var count = 0;

  return array.filter(function(elm) {
    var rest = isDefined(expression) ? (count < n && expression(elm)) : count < n;
    count = rest ? count+1 : count;

    return rest;
  });
}
/**
 * Polyfill to ECMA6 String.prototype.contains
 */
if (!String.prototype.contains) {
  String.prototype.contains = function() {
    return String.prototype.indexOf.apply(this, arguments) !== -1;
  };
}

/**
 * @param num {Number}
 * @param decimal {Number}
 * @param $math
 * @returns {Number}
 */
function convertToDecimal(num, decimal, $math){
  return $math.round(num * $math.pow(10,decimal)) / ($math.pow(10,decimal));
}

/**
 * @description
 * Get an object, and return an array composed of it's properties names(nested too).
 * @param obj {Object}
 * @param stack {Array}
 * @param parent {String}
 * @returns {Array}
 * @example
 * parseKeys({ a:1, b: { c:2, d: { e: 3 } } }) ==> ["a", "b.c", "b.d.e"]
 */
function deepKeys(obj, stack, parent) {
  stack = stack || [];
  var keys = Object.keys(obj);

  keys.forEach(function(el) {
    //if it's a nested object
    if(isObject(obj[el]) && !isArray(obj[el])) {
      //concatenate the new parent if exist
      var p = parent ? parent + '.' + el : parent;
      deepKeys(obj[el], stack, p || el);
    } else {
      //create and save the key
      var key = parent ? parent + '.' + el : el;
      stack.push(key)
    }
  });
  return stack
}

/**
 * @description
 * Test if given object is a Scope instance
 * @param obj
 * @returns {Boolean}
 */
function isScope(obj) {
  return obj && obj.$evalAsync && obj.$watch;
}

/**
 * @ngdoc filter
 * @name a8m.angular
 * @kind function
 *
 * @description
 * reference to angular function
 */

angular.module('a8m.angular', [])

    .filter('isUndefined', function () {
      return function (input) {
        return angular.isUndefined(input);
      }
    })
    .filter('isDefined', function() {
      return function (input) {
        return angular.isDefined(input);
      }
    })
    .filter('isFunction', function() {
      return function (input) {
        return angular.isFunction(input);
      }
    })
    .filter('isString', function() {
      return function (input) {
        return angular.isString(input)
      }
    })
    .filter('isNumber', function() {
      return function (input) {
        return angular.isNumber(input);
      }
    })
    .filter('isArray', function() {
      return function (input) {
        return angular.isArray(input);
      }
    })
    .filter('isObject', function() {
      return function (input) {
        return angular.isObject(input);
      }
    })
    .filter('isEqual', function() {
      return function (o1, o2) {
        return angular.equals(o1, o2);
      }
    });

/**
 * @ngdoc filter
 * @name a8m.conditions
 * @kind function
 *
 * @description
 * reference to math conditions
 */
 angular.module('a8m.conditions', [])

  .filter({
    isGreaterThan  : isGreaterThanFilter,
    '>'            : isGreaterThanFilter,

    isGreaterThanOrEqualTo  : isGreaterThanOrEqualToFilter,
    '>='                    : isGreaterThanOrEqualToFilter,

    isLessThan  : isLessThanFilter,
    '<'         : isLessThanFilter,

    isLessThanOrEqualTo  : isLessThanOrEqualToFilter,
    '<='                 : isLessThanOrEqualToFilter,

    isEqualTo  : isEqualToFilter,
    '=='       : isEqualToFilter,

    isNotEqualTo  : isNotEqualToFilter,
    '!='          : isNotEqualToFilter,

    isIdenticalTo  : isIdenticalToFilter,
    '==='          : isIdenticalToFilter,

    isNotIdenticalTo  : isNotIdenticalToFilter,
    '!=='             : isNotIdenticalToFilter
  });

  function isGreaterThanFilter() {
    return function (input, check) {
      return input > check;
    };
  }

  function isGreaterThanOrEqualToFilter() {
    return function (input, check) {
      return input >= check;
    };
  }

  function isLessThanFilter() {
    return function (input, check) {
      return input < check;
    };
  }

  function isLessThanOrEqualToFilter() {
    return function (input, check) {
      return input <= check;
    };
  }

  function isEqualToFilter() {
    return function (input, check) {
      return input == check;
    };
  }

  function isNotEqualToFilter() {
    return function (input, check) {
      return input != check;
    };
  }

  function isIdenticalToFilter() {
    return function (input, check) {
      return input === check;
    };
  }

  function isNotIdenticalToFilter() {
    return function (input, check) {
      return input !== check;
    };
  }
/**
 * @ngdoc filter
 * @name isNull
 * @kind function
 *
 * @description
 * checks if value is null or not
 * @return Boolean
 */
angular.module('a8m.is-null', [])
    .filter('isNull', function () {
      return function(input) {
        return isNull(input);
      }
    });

/**
 * @ngdoc filter
 * @name after-where
 * @kind function
 *
 * @description
 * get a collection and properties object, and returns all of the items
 * in the collection after the first that found with the given properties.
 *
 */
angular.module('a8m.after-where', [])
    .filter('afterWhere', function() {
      return function (collection, object) {

        collection = isObject(collection)
          ? toArray(collection)
          : collection;

        if(!isArray(collection) || isUndefined(object)) return collection;

        var index = collection.map( function( elm ) {
          return objectContains(object, elm);
        }).indexOf( true );

        return collection.slice((index === -1) ? 0 : index);
      }
    });

/**
 * @ngdoc filter
 * @name after
 * @kind function
 *
 * @description
 * get a collection and specified count, and returns all of the items
 * in the collection after the specified count.
 *
 */

angular.module('a8m.after', [])
    .filter('after', function() {
      return function (collection, count) {
        collection = isObject(collection)
          ? toArray(collection)
          : collection;

        return (isArray(collection))
          ? collection.slice(count)
          : collection;
      }
    });

/**
 * @ngdoc filter
 * @name before-where
 * @kind function
 *
 * @description
 * get a collection and properties object, and returns all of the items
 * in the collection before the first that found with the given properties.
 */
angular.module('a8m.before-where', [])
  .filter('beforeWhere', function() {
    return function (collection, object) {

      collection = isObject(collection)
        ? toArray(collection)
        : collection;

      if(!isArray(collection) || isUndefined(object)) return collection;

      var index = collection.map( function( elm ) {
        return objectContains(object, elm);
      }).indexOf( true );

      return collection.slice(0, (index === -1) ? collection.length : ++index);
    }
  });

/**
 * @ngdoc filter
 * @name before
 * @kind function
 *
 * @description
 * get a collection and specified count, and returns all of the items
 * in the collection before the specified count.
 */
angular.module('a8m.before', [])
    .filter('before', function() {
      return function (collection, count) {
        collection = isObject(collection)
          ? toArray(collection)
          : collection;

        return (isArray(collection))
          ? collection.slice(0, (!count) ? count : --count)
          : collection;
      }
    });

/**
 * @ngdoc filter
 * @name chunkBy
 * @kind function
 *
 * @description
 * Collect data into fixed-length chunks or blocks
 */

angular.module('a8m.chunk-by', ['a8m.filter-watcher'])
    .filter('chunkBy', ['filterWatcher', function (filterWatcher) {
      return function (array, n, fillVal) {

        return filterWatcher.isMemoized('chunkBy', arguments) ||
            filterWatcher.memoize('chunkBy', arguments, this,
                _chunkBy(array, n, fillVal));
        /**
         * @description
         * Get array with size `n` in `val` inside it.
         * @param n
         * @param val
         * @returns {Array}
         */
        function fill(n, val) {
          var ret = [];
          while (n--) ret[n] = val;
          return ret;
        }

        function _chunkBy(array, n, fillVal) {
          if (!isArray(array)) return array;
          return array.map(function (el, i, self) {
            i = i * n;
            el = self.slice(i, i + n);
            return !isUndefined(fillVal) && el.length < n
                ? el.concat(fill(n - el.length, fillVal))
                : el;
          }).slice(0, Math.ceil(array.length / n));
        }
      }
    }]);

/**
 * @ngdoc filter
 * @name concat
 * @kind function
 *
 * @description
 * get (array/object, object/array) and return merged collection
 */
angular.module('a8m.concat', [])
  .filter('concat', [function () {
    return function (collection, joined) {

      if (isUndefined(joined)) return collection;

      if (isArray(collection)) {
        return isObject(joined)
          ? collection.concat(toArray(joined))
          : collection.concat(joined);
      }

      if (isObject(collection)) {
        var array = toArray(collection);
        return (isObject(joined))
          ? array.concat(toArray(joined))
          : array.concat(joined);
      }
      return collection;
    };
  }
]);

/**
 * @ngdoc filter
 * @name contains
 * @kind function
 *
 * @description
 * Checks if given expression is present in one or more object in the collection
 */
angular.module('a8m.contains', [])
  .filter({
    contains: ['$parse', containsFilter],
    some: ['$parse', containsFilter]
  });

function containsFilter($parse) {
    return function (collection, expression) {

      collection = isObject(collection) ? toArray(collection) : collection;

      if(!isArray(collection) || isUndefined(expression)) {
        return false;
      }

      return collection.some(function(elm) {
        return (isObject(elm) || isFunction(expression))
          ? $parse(expression)(elm)
          : elm === expression;
      });

    }
 }

/**
 * @ngdoc filter
 * @name countBy
 * @kind function
 *
 * @description
 * Sorts a list into groups and returns a count for the number of objects in each group.
 */

angular.module('a8m.count-by', [])

  .filter('countBy', [ '$parse', function ( $parse ) {
    return function (collection, property) {

      var result = {},
        get = $parse(property),
        prop;

      collection = (isObject(collection)) ? toArray(collection) : collection;

      if(!isArray(collection) || isUndefined(property)) {
        return collection;
      }

      collection.forEach( function( elm ) {
        prop = get(elm);

        if(!result[prop]) {
          result[prop] = 0;
        }

        result[prop]++;
      });

      return result;
    }
  }]);

/**
 * @ngdoc filter
 * @name defaults
 * @kind function
 *
 * @description
 * defaultsFilter allows to specify a default fallback value for properties that resolve to undefined.
 */
angular.module('a8m.defaults', [])
  .filter('defaults', ['$parse', function( $parse ) {
    return function(collection, defaults) {

      collection = isObject(collection) ? toArray(collection) : collection;

      if(!isArray(collection) || !isObject(defaults)) {
        return collection;
      }

      var keys = deepKeys(defaults);

      collection.forEach(function(elm) {
        //loop through all the keys
        keys.forEach(function(key) {
          var getter = $parse(key);
          var setter = getter.assign;
          //if it's not exist
          if(isUndefined(getter(elm))) {
            //get from defaults, and set to the returned object
            setter(elm, getter(defaults))
          }
        });
      });

      return collection;
    }
  }]);
/**
 * @ngdoc filter
 * @name every
 * @kind function
 *
 * @description
 * Checks if given expression is present in all members in the collection
 *
 */
angular.module('a8m.every', [])
  .filter('every', ['$parse', function($parse) {
    return function (collection, expression) {
      collection = isObject(collection) ? toArray(collection) : collection;

      if(!isArray(collection) || isUndefined(expression)) {
        return true;
      }

      return collection.every( function(elm) {
        return (isObject(elm) || isFunction(expression))
          ? $parse(expression)(elm)
          : elm === expression;
      });
    }
  }]);

/**
 * @ngdoc filter
 * @name filterBy
 * @kind function
 *
 * @description
 * filter by specific properties, avoid the rest
 */
angular.module('a8m.filter-by', [])
  .filter('filterBy', ['$parse', function( $parse ) {
    return function(collection, properties, search) {
      var comparator;

      search = (isString(search) || isNumber(search)) ?
        String(search).toLowerCase() : undefined;

      collection = isObject(collection) ? toArray(collection) : collection;

      if(!isArray(collection) || isUndefined(search)) {
        return collection;
      }

      return collection.filter(function(elm) {
        return properties.some(function(prop) {

          /**
           * check if there is concatenate properties
           * example:
           * object: { first: 'foo', last:'bar' }
           * filterBy: ['first + last'] => search by full name(i.e 'foo bar')
           */
          if(!~prop.indexOf('+')) {
            comparator = $parse(prop)(elm)
          } else {
            var propList = prop.replace(new RegExp('\\s', 'g'), '').split('+');
            comparator = propList.reduce(function(prev, cur, index) {
              return (index === 1) ? $parse(prev)(elm) + ' ' + $parse(cur)(elm) :
                prev + ' ' + $parse(cur)(elm);
            });
          }

          return (isString(comparator) || isNumber(comparator))
            ? String(comparator).toLowerCase().contains(search)
            : false;
        });
      });
    }
  }]);

/**
 * @ngdoc filter
 * @name first
 * @kind function
 *
 * @description
 * Gets the first element or first n elements of an array
 * if callback is provided, is returns as long the callback return truthy
 */
angular.module('a8m.first', [])
  .filter('first', ['$parse', function( $parse ) {
    return function(collection) {
      var n
        , getter
        , args;

      collection = isObject(collection)
        ? toArray(collection)
        : collection;

      if(!isArray(collection)) {
        return collection;
      }

      args = Array.prototype.slice.call(arguments, 1);
      n = (isNumber(args[0])) ? args[0] : 1;
      getter = (!isNumber(args[0]))  ? args[0] : (!isNumber(args[1])) ? args[1] : undefined;

      return (args.length) ? getFirstMatches(collection, n,(getter) ? $parse(getter) : getter) :
        collection[0];
    }
  }]);

/**
 * @ngdoc filter
 * @name flatten
 * @kind function
 *
 * @description
 * Flattens a nested array (the nesting can be to any depth).
 * If you pass shallow, the array will only be flattened a single level
 */
angular.module('a8m.flatten', [])
  .filter('flatten', function () {
    return function(collection, shallow) {

      shallow = shallow || false;
      collection = isObject(collection)
        ? toArray(collection)
        : collection;

      if(!isArray(collection)) {
        return collection;
      }

      return !shallow
        ? flatten(collection, 0)
        : [].concat.apply([], collection);
    }
  });

/**
 * flatten nested array (the nesting can be to any depth).
 * @param array {Array}
 * @param i {int}
 * @returns {Array}
 * @private
 */
function flatten(array, i) {
  i = i || 0;

  if(i >= array.length)
    return array;

  if(isArray(array[i])) {
    return flatten(array.slice(0,i)
      .concat(array[i], array.slice(i+1)), i);
  }
  return flatten(array, i+1);
}

/**
 * @ngdoc filter
 * @name fuzzyByKey
 * @kind function
 *
 * @description
 * fuzzy string searching by key
 */
angular.module('a8m.fuzzy-by', [])
  .filter('fuzzyBy', ['$parse', function ( $parse ) {
    return function (collection, property, search, csensitive) {

      var sensitive = csensitive || false,
        prop, getter;

      collection = isObject(collection) ? toArray(collection) : collection;

      if(!isArray(collection) || isUndefined(property)
        || isUndefined(search)) {
        return collection;
      }

      getter = $parse(property);

      return collection.filter(function(elm) {

        prop = getter(elm);
        if(!isString(prop)) {
          return false;
        }

        prop = (sensitive) ? prop : prop.toLowerCase();
        search = (sensitive) ? search : search.toLowerCase();

        return hasApproxPattern(prop, search) !== false
      })
    }

 }]);

/**
 * @ngdoc filter
 * @name fuzzy
 * @kind function
 *
 * @description
 * fuzzy string searching for array of strings, objects
 */
 
angular.module('a8m.fuzzy', [])
  .filter('fuzzy', function () {
    return function (collection, search, csensitive) {
      var sensitive = csensitive || false;
      collection = isObject(collection) ? toArray(collection) : collection;

      if(!isArray(collection) || isUndefined(search)) {
        return collection;
      }

      search = (sensitive) ? search : search.toLowerCase();

      return collection.filter(function(elm) {
        if(isString(elm)) {
          elm = (sensitive) ? elm : elm.toLowerCase();
          return hasApproxPattern(elm, search) !== false
        }
        return (isObject(elm)) ? _hasApproximateKey(elm, search) : false;
      });

      /**
       * checks if object has key{string} that match
       * to fuzzy search pattern
       * @param object
       * @param search
       * @returns {boolean}
       * @private
       */
      function _hasApproximateKey(object, search) {
        var properties = Object.keys(object),
          prop, flag;
        return 0 < properties.filter(function (elm) {
          prop = object[elm];

          //avoid iteration if we found some key that equal[performance]
          if(flag) return true;

          if (isString(prop)) {
            prop = (sensitive) ? prop : prop.toLowerCase();
            return flag = (hasApproxPattern(prop, search) !== false);
          }

          return false;

        }).length;
      }
    }
  });

/**
 * @ngdoc filter
 * @name groupBy
 * @kind function
 *
 * @description
 * Create an object composed of keys generated from the result of running each element of a collection,
 * each key is an array of the elements.
 */

angular.module('a8m.group-by', [ 'a8m.filter-watcher' ])
  .filter('groupBy', [ '$parse', 'filterWatcher', function ( $parse, filterWatcher ) {
    return function (collection, property) {

      if(!isObject(collection) || isUndefined(property)) {
        return collection;
      }

      return filterWatcher.isMemoized('groupBy', arguments) ||
        filterWatcher.memoize('groupBy', arguments, this,
          _groupBy(collection, $parse(property)));

      /**
       * groupBy function
       * @param collection
       * @param getter
       * @returns {{}}
       */
      function _groupBy(collection, getter) {
        var result = {};
        var prop;

        forEach( collection, function( elm ) {
          prop = getter(elm);

          if(!result[prop]) {
            result[prop] = [];
          }
          result[prop].push(elm);
        });
        return result;
      }
    }
 }]);

/**
 * @ngdoc filter
 * @name isEmpty
 * @kind function
 *
 * @description
 * get collection or string and return if it empty
 */
angular.module('a8m.is-empty', [])
  .filter('isEmpty', function () {
    return function(collection) {
      return isObject(collection)
        ? !toArray(collection).length
        : !collection.length;
    }
  });

/**
 * @ngdoc filter
 * @name join
 * @kind function
 *
 * @description
 * join a collection by a provided delimiter (space by default)
 */
angular.module('a8m.join', [])
  .filter('join', function () {
    return function (input, delimiter) {
      if (isUndefined(input) || !isArray(input)) {
        return input;
      }
      if (isUndefined(delimiter)) delimiter = ' ';

      return input.join(delimiter);
    };
  })
;

/**
 * @ngdoc filter
 * @name last
 * @kind function
 *
 * @description
 * Gets the last element or last n elements of an array
 * if callback is provided, is returns as long the callback return truthy
 */
angular.module('a8m.last', [])
  .filter('last', ['$parse', function( $parse ) {
    return function(collection) {
      var n
        , getter
        , args
        //cuz reverse change our src collection
        //and we don't want side effects
        , reversed = copy(collection);

      reversed = isObject(reversed)
        ? toArray(reversed)
        : reversed;

      if(!isArray(reversed)) {
        return reversed;
      }

      args = Array.prototype.slice.call(arguments, 1);
      n = (isNumber(args[0])) ? args[0] : 1;
      getter = (!isNumber(args[0]))  ? args[0] : (!isNumber(args[1])) ? args[1] : undefined;

      return (args.length)
        //send reversed collection as arguments, and reverse it back as result
        ? getFirstMatches(reversed.reverse(), n,(getter) ? $parse(getter) : getter).reverse()
        //get the last element
        : reversed[reversed.length-1];
    }
  }]);

/**
 * @ngdoc filter
 * @name map
 * @kind function
 *
 * @description
 * Returns a new collection of the results of each expression execution.
 */
angular.module('a8m.map', [])
  .filter('map', ['$parse', function($parse) {
    return function (collection, expression) {

      collection = isObject(collection)
        ? toArray(collection)
        : collection;

      if(!isArray(collection) || isUndefined(expression)) {
        return collection;
      }

      return collection.map(function (elm) {
        return $parse(expression)(elm);
      });
    }
  }]);

/**
 * @ngdoc filter
 * @name omit
 * @kind function
 *
 * @description
 * filter collection by expression
 */

angular.module('a8m.omit', [])

  .filter('omit', ['$parse', function($parse) {
    return function (collection, expression) {

      collection = isObject(collection)
        ? toArray(collection)
        : collection;

      if(!isArray(collection) || isUndefined(expression)) {
        return collection;
      }

      return collection.filter(function (elm) {
        return !($parse(expression)(elm));
      });
    }
  }]);

/**
 * @ngdoc filter
 * @name pick
 * @kind function
 *
 * @description
 * filter collection by expression
 */

angular.module('a8m.pick', [])

  .filter('pick', ['$parse', function($parse) {
    return function (collection, expression) {

      collection = isObject(collection)
        ? toArray(collection)
        : collection;

      if(!isArray(collection) || isUndefined(expression)) {
        return collection;
      }

      return collection.filter(function (elm) {
        return $parse(expression)(elm);
      });
    }
  }]);

/**
 * @ngdoc filter
 * @name range
 * @kind function
 *
 * @description
 * rangeFilter provides some support for a for loop using numbers
 */
angular.module('a8m.range', [])
  .filter('range', function () {
    return function (input, total) {
      for (var i = 0; i < parseInt(total); i++) {
        input.push(i);
      }
      return input;
	  };
  });
/**
 * @ngdoc filter
 * @name removeWith
 * @kind function
 *
 * @description
 * get collection and properties object, and removed elements
 * with this properties
 */

angular.module('a8m.remove-with', [])
  .filter('removeWith', function() {
    return function (collection, object) {

      if(isUndefined(object)) {
        return collection;
      }
      collection = isObject(collection)
        ? toArray(collection)
        : collection;

      return collection.filter(function (elm) {
        return !objectContains(object, elm);
      });
    }
  });


/**
 * @ngdoc filter
 * @name remove
 * @kind function
 *
 * @description
 * remove specific members from collection
 */

angular.module('a8m.remove', [])

  .filter('remove', function () {
    return function (collection) {
      collection = isObject(collection) ? toArray(collection) : collection;
      var args = Array.prototype.slice.call(arguments, 1);

      if(!isArray(collection)) {
        return collection;
      }

      return collection.filter( function( member ) {
        return !args.some(function(nest) {
          return equals(nest, member);
        })
      });
    }
  });

/**
 * @ngdoc filter
 * @name reverse
 * @kind function
 *
 * @description
 * Reverses a string or collection
 */
angular.module('a8m.reverse', [])
    .filter('reverse',[ function () {
      return function (input) {
        input = isObject(input) ? toArray(input) : input;

        if(isString(input)) {
          return input.split('').reverse().join('');
        }

        return isArray(input)
          ? input.slice().reverse()
          : input;
      }
    }]);

/**
 * @ngdoc filter
 * @name searchField
 * @kind function
 *
 * @description
 * for each member, join several strings field and add them to
 * new field called 'searchField' (use for search filtering)
 */
angular.module('a8m.search-field', [])
  .filter('searchField', ['$parse', function ($parse) {
    return function (collection) {

      var get, field;

      collection = isObject(collection) ? toArray(collection) : collection;

      var args = Array.prototype.slice.call(arguments, 1);

      if(!isArray(collection) || !args.length) {
        return collection;
      }

      return collection.map(function(member) {

        field = args.map(function(field) {
          get = $parse(field);
          return get(member);
        }).join(' ');

        return extend(member, { searchField: field });
      });
    }
  }]);

/**
 * @ngdoc filter
 * @name toArray
 * @kind function
 *
 * @description
 * Convert objects into stable arrays.
 * if addKey set to true,the filter also attaches a new property
 * $key to the value containing the original key that was used in
 * the object we are iterating over to reference the property
 */
angular.module('a8m.to-array', [])
  .filter('toArray', function() {
    return function (collection, addKey) {

      if(!isObject(collection)) {
        return collection;
      }

      return !addKey
        ? toArray(collection)
        : Object.keys(collection).map(function (key) {
            return extend(collection[key], { $key: key });
          });
    }
  });

/**
 * @ngdoc filter
 * @name unique/uniq
 * @kind function
 *
 * @description
 * get collection and filter duplicate members
 * if uniqueFilter get a property(nested to) as argument it's
 * filter by this property as unique identifier
 */

angular.module('a8m.unique', [])
  .filter({
      unique: ['$parse', uniqFilter],
      uniq: ['$parse', uniqFilter]
    });

function uniqFilter($parse) {
    return function (collection, property) {

      collection = isObject(collection) ? toArray(collection) : collection;

      if (!isArray(collection)) {
        return collection;
      }

      //store all unique identifiers
      var uniqueItems = [],
          get = $parse(property);

      return (isUndefined(property))
        //if it's kind of primitive array
        ? collection.filter(function (elm, pos, self) {
          return self.indexOf(elm) === pos;
        })
        //else compare with equals
        : collection.filter(function (elm) {
          var prop = get(elm);
          if(some(uniqueItems, prop)) {
            return false;
          }
          uniqueItems.push(prop);
          return true;
      });

      //checked if the unique identifier is already exist
      function some(array, member) {
        if(isUndefined(member)) {
          return false;
        }
        return array.some(function(el) {
          return equals(el, member);
        });
      }
    }
}

/**
 * @ngdoc filter
 * @name where
 * @kind function
 *
 * @description
 * of each element in a collection to the given properties object,
 * returning an array of all elements that have equivalent property values.
 *
 */
angular.module('a8m.where', [])
  .filter('where', function() {
    return function (collection, object) {
      if(isUndefined(object)) return collection;
      collection = isObject(collection)
        ? toArray(collection)
        : collection;

      return collection.filter(function (elm) {
        return objectContains(object, elm);
      });
    }
  });

/**
 * @ngdoc filter
 * @name xor
 * @kind function
 *
 * @description
 * Exclusive or filter by expression
 */

angular.module('a8m.xor', [])

  .filter('xor', ['$parse', function($parse) {
    return function (col1, col2, expression) {

      expression = expression || false;

      col1 = isObject(col1) ? toArray(col1) : col1;
      col2 = isObject(col2) ? toArray(col2) : col2;

      if(!isArray(col1) || !isArray(col2)) return col1;

      return col1.concat(col2)
        .filter(function(elm) {
          return !(some(elm, col1) && some(elm, col2));
        });

      function some(el, col) {
        var getter = $parse(expression);
        return col.some(function(dElm) {
          return expression
            ? equals(getter(dElm), getter(el))
            : equals(dElm, el);
        });
      }
    }
  }]);

/**
 * @ngdoc filter
 * @name formatBytes
 * @kind function
 *
 * @description
 * Convert bytes into appropriate display 
 * 1024 bytes => 1 KB
 */
angular.module('a8m.math.byteFmt', ['a8m.math'])
  .filter('byteFmt', ['$math', function ($math) {
    return function (bytes, decimal) {

      if(isNumber(decimal) && isFinite(decimal) && decimal%1===0 && decimal >= 0 &&
        isNumber(bytes) && isFinite(bytes)) {
        if(bytes < 1024) { // within 1 KB so B
          return convertToDecimal(bytes, decimal, $math) + ' B';
        } else if(bytes < 1048576) { // within 1 MB so KB
          return convertToDecimal((bytes / 1024), decimal, $math) + ' KB';
        } else if(bytes < 1073741824){ // within 1 GB so MB
          return convertToDecimal((bytes / 1048576), decimal, $math) + ' MB';
        } else { // GB or more
          return convertToDecimal((bytes / 1073741824), decimal, $math) + ' GB';
        }

      }
      return "NaN";
    }
  }]);
/**
 * @ngdoc filter
 * @name degrees
 * @kind function
 *
 * @description
 * Convert angle from radians to degrees
 */
angular.module('a8m.math.degrees', ['a8m.math'])
  .filter('degrees', ['$math', function ($math) {
    return function (radians, decimal) {
      // if decimal is not an integer greater than -1, we cannot do. quit with error "NaN"
      // if degrees is not a real number, we cannot do also. quit with error "NaN"
      if(isNumber(decimal) && isFinite(decimal) && decimal%1===0 && decimal >= 0 &&
        isNumber(radians) && isFinite(radians)) {
        var degrees = (radians * 180) / $math.PI;
        return $math.round(degrees * $math.pow(10,decimal)) / ($math.pow(10,decimal));
      } else {
        return "NaN";
      }
    }
  }]);

 
 
/**
 * @ngdoc filter
 * @name formatBytes
 * @kind function
 *
 * @description
 * Convert bytes into appropriate display 
 * 1024 kilobytes => 1 MB
 */
angular.module('a8m.math.kbFmt', ['a8m.math'])
  .filter('kbFmt', ['$math', function ($math) {
    return function (bytes, decimal) {

      if(isNumber(decimal) && isFinite(decimal) && decimal%1===0 && decimal >= 0 &&
        isNumber(bytes) && isFinite(bytes)) {
        if(bytes < 1024) { // within 1 MB so KB
          return convertToDecimal(bytes, decimal, $math) + ' KB';
        } else if(bytes < 1048576) { // within 1 GB so MB
          return convertToDecimal((bytes / 1024), decimal, $math) + ' MB';
        } else {
          return convertToDecimal((bytes / 1048576), decimal, $math) + ' GB';
        }
      }
      return "NaN";
    }
  }]);
/**
 * @ngdoc module
 * @name math
 * @description
 * reference to global Math object
 */
angular.module('a8m.math', [])
  .factory('$math', ['$window', function ($window) {
    return $window.Math;
  }]);

/**
 * @ngdoc filter
 * @name max
 * @kind function
 *
 * @description
 * Math.max will get an array and return the max value. if an expression
 * is provided, will return max value by expression.
 */
angular.module('a8m.math.max', ['a8m.math'])
  .filter('max', ['$math', '$parse', function ($math, $parse) {
    return function (input, expression) {

      if(!isArray(input)) {
        return input;
      }
      return isUndefined(expression)
        ? $math.max.apply($math, input)
        : input[indexByMax(input, expression)];
    };

    /**
     * @private
     * @param array
     * @param exp
     * @returns {number|*|Number}
     */
    function indexByMax(array, exp) {
      var mappedArray = array.map(function(elm){
        return $parse(exp)(elm);
      });
      return mappedArray.indexOf($math.max.apply($math, mappedArray));
    }
  }]);
/**
 * @ngdoc filter
 * @name min
 * @kind function
 *
 * @description
 * Math.min will get an array and return the min value. if an expression
 * is provided, will return min value by expression.
 */
angular.module('a8m.math.min', ['a8m.math'])
  .filter('min', ['$math', '$parse', function ($math, $parse) {
    return function (input, expression) {

      if(!isArray(input)) {
        return input;
      }
      return isUndefined(expression)
        ? $math.min.apply($math, input)
        : input[indexByMin(input, expression)];
    };

    /**
     * @private
     * @param array
     * @param exp
     * @returns {number|*|Number}
     */
    function indexByMin(array, exp) {
      var mappedArray = array.map(function(elm){
        return $parse(exp)(elm);
      });
      return mappedArray.indexOf($math.min.apply($math, mappedArray));
    }
  }]);
/**
 * @ngdoc filter
 * @name Percent
 * @kind function
 *
 * @description
 * percentage between two numbers
 */
angular.module('a8m.math.percent', ['a8m.math'])
  .filter('percent', ['$math', '$window', function ($math, $window) {
    return function (input, divided, round) {

      var divider = isString(input) ? $window.Number(input) : input;
      divided = divided || 100;
      round = round || false;

      if (!isNumber(divider) || $window.isNaN(divider)) return input;

      return round
        ? $math.round((divider / divided) * 100)
        : (divider / divided) * 100;
    }
  }]);

/**
 * @ngdoc filter
 * @name toRadians
 * @kind function
 *
 * @description
 * Convert angle from degrees to radians
 */
angular.module('a8m.math.radians', ['a8m.math'])
  .filter('radians', ['$math', function ($math) {
    return function (degrees, decimal) {
      // if decimal is not an integer greater than -1, we cannot do. quit with error "NaN"
      // if degrees is not a real number, we cannot do also. quit with error "NaN"
      if(isNumber(decimal) && isFinite(decimal) && decimal%1===0 && decimal >= 0 &&
        isNumber(degrees) && isFinite(degrees)) {
        var radians = (degrees * 3.14159265359) / 180;
        return $math.round(radians * $math.pow(10,decimal)) / ($math.pow(10,decimal));
      }
      return "NaN";
    }
  }]);

 
 
/**
 * @ngdoc filter
 * @name Radix
 * @kind function
 *
 * @description
 * converting decimal numbers to different bases(radix)
 */
angular.module('a8m.math.radix', [])
  .filter('radix', function () {
    return function (input, radix) {
      var RANGE = /^[2-9]$|^[1-2]\d$|^3[0-6]$/;

      if(!isNumber(input) || !RANGE.test(radix)) {
        return input;
      }

      return input.toString(radix).toUpperCase();
    }
  });

/**
 * @ngdoc filter
 * @name formatBytes
 * @kind function
 *
 * @description
 * Convert number into abbreviations.
 * i.e: K for one thousand, M for Million, B for billion
 * e.g: number of users:235,221, decimal:1 => 235.2 K
 */
angular.module('a8m.math.shortFmt', ['a8m.math'])
  .filter('shortFmt', ['$math', function ($math) {
    return function (number, decimal) {
      if(isNumber(decimal) && isFinite(decimal) && decimal%1===0 && decimal >= 0 &&
        isNumber(number) && isFinite(number)){
        if(number < 1e3) {
          return number;
        } else if(number < 1e6) {
          return convertToDecimal((number / 1e3), decimal, $math) + ' K';
        } else if(number < 1e9){
          return convertToDecimal((number / 1e6), decimal, $math) + ' M';
        } else {
          return convertToDecimal((number / 1e9), decimal, $math) + ' B';
        }

      }
      return "NaN";
    }
  }]);
/**
 * @ngdoc filter
 * @name sum
 * @kind function
 *
 * @description
 * Sum up all values within an array
 */
angular.module('a8m.math.sum', [])
  .filter('sum', function () {
    return function (input, initial) {
      return !isArray(input)
        ? input
        : input.reduce(function(prev, curr) {
          return prev + curr;
        }, initial || 0);
    }
  });

/**
 * @ngdoc filter
 * @name endsWith
 * @kind function
 *
 * @description
 * checks whether string ends with the ends parameter.
 */
angular.module('a8m.ends-with', [])

  .filter('endsWith', function () {
    return function (input, ends, csensitive) {

      var sensitive = csensitive || false,
        position;

      if(!isString(input) || isUndefined(ends)) {
        return input;
      }

      input = (sensitive) ? input : input.toLowerCase();
      position = input.length - ends.length;

      return input.indexOf((sensitive) ? ends : ends.toLowerCase(), position) !== -1;
    }
  });

/**
 * @ngdoc filter
 * @name latinize
 * @kind function
 *
 * @description
 * remove accents/diacritics from a string
 */
angular.module('a8m.latinize', [])
  .filter('latinize',[ function () {
    var defaultDiacriticsRemovalap = [
      {'base':'A', 'letters':'\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'},
      {'base':'AA','letters':'\uA732'},
      {'base':'AE','letters':'\u00C6\u01FC\u01E2'},
      {'base':'AO','letters':'\uA734'},
      {'base':'AU','letters':'\uA736'},
      {'base':'AV','letters':'\uA738\uA73A'},
      {'base':'AY','letters':'\uA73C'},
      {'base':'B', 'letters':'\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'},
      {'base':'C', 'letters':'\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'},
      {'base':'D', 'letters':'\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'},
      {'base':'DZ','letters':'\u01F1\u01C4'},
      {'base':'Dz','letters':'\u01F2\u01C5'},
      {'base':'E', 'letters':'\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'},
      {'base':'F', 'letters':'\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'},
      {'base':'G', 'letters':'\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'},
      {'base':'H', 'letters':'\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'},
      {'base':'I', 'letters':'\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'},
      {'base':'J', 'letters':'\u004A\u24BF\uFF2A\u0134\u0248'},
      {'base':'K', 'letters':'\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'},
      {'base':'L', 'letters':'\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'},
      {'base':'LJ','letters':'\u01C7'},
      {'base':'Lj','letters':'\u01C8'},
      {'base':'M', 'letters':'\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'},
      {'base':'N', 'letters':'\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'},
      {'base':'NJ','letters':'\u01CA'},
      {'base':'Nj','letters':'\u01CB'},
      {'base':'O', 'letters':'\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'},
      {'base':'OI','letters':'\u01A2'},
      {'base':'OO','letters':'\uA74E'},
      {'base':'OU','letters':'\u0222'},
      {'base':'OE','letters':'\u008C\u0152'},
      {'base':'oe','letters':'\u009C\u0153'},
      {'base':'P', 'letters':'\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'},
      {'base':'Q', 'letters':'\u0051\u24C6\uFF31\uA756\uA758\u024A'},
      {'base':'R', 'letters':'\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'},
      {'base':'S', 'letters':'\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'},
      {'base':'T', 'letters':'\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'},
      {'base':'TZ','letters':'\uA728'},
      {'base':'U', 'letters':'\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'},
      {'base':'V', 'letters':'\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'},
      {'base':'VY','letters':'\uA760'},
      {'base':'W', 'letters':'\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'},
      {'base':'X', 'letters':'\u0058\u24CD\uFF38\u1E8A\u1E8C'},
      {'base':'Y', 'letters':'\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'},
      {'base':'Z', 'letters':'\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'},
      {'base':'a', 'letters':'\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'},
      {'base':'aa','letters':'\uA733'},
      {'base':'ae','letters':'\u00E6\u01FD\u01E3'},
      {'base':'ao','letters':'\uA735'},
      {'base':'au','letters':'\uA737'},
      {'base':'av','letters':'\uA739\uA73B'},
      {'base':'ay','letters':'\uA73D'},
      {'base':'b', 'letters':'\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'},
      {'base':'c', 'letters':'\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'},
      {'base':'d', 'letters':'\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'},
      {'base':'dz','letters':'\u01F3\u01C6'},
      {'base':'e', 'letters':'\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'},
      {'base':'f', 'letters':'\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'},
      {'base':'g', 'letters':'\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'},
      {'base':'h', 'letters':'\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'},
      {'base':'hv','letters':'\u0195'},
      {'base':'i', 'letters':'\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'},
      {'base':'j', 'letters':'\u006A\u24D9\uFF4A\u0135\u01F0\u0249'},
      {'base':'k', 'letters':'\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'},
      {'base':'l', 'letters':'\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'},
      {'base':'lj','letters':'\u01C9'},
      {'base':'m', 'letters':'\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'},
      {'base':'n', 'letters':'\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'},
      {'base':'nj','letters':'\u01CC'},
      {'base':'o', 'letters':'\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'},
      {'base':'oi','letters':'\u01A3'},
      {'base':'ou','letters':'\u0223'},
      {'base':'oo','letters':'\uA74F'},
      {'base':'p','letters':'\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'},
      {'base':'q','letters':'\u0071\u24E0\uFF51\u024B\uA757\uA759'},
      {'base':'r','letters':'\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'},
      {'base':'s','letters':'\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'},
      {'base':'t','letters':'\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'},
      {'base':'tz','letters':'\uA729'},
      {'base':'u','letters': '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'},
      {'base':'v','letters':'\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'},
      {'base':'vy','letters':'\uA761'},
      {'base':'w','letters':'\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'},
      {'base':'x','letters':'\u0078\u24E7\uFF58\u1E8B\u1E8D'},
      {'base':'y','letters':'\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'},
      {'base':'z','letters':'\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'}
    ];

    var diacriticsMap = {};
    for (var i = 0; i < defaultDiacriticsRemovalap.length; i++) {
      var letters = defaultDiacriticsRemovalap[i].letters.split("");
      for (var j = 0; j < letters.length ; j++){
        diacriticsMap[letters[j]] = defaultDiacriticsRemovalap[i].base;
      }
    }

    // "what?" version ... http://jsperf.com/diacritics/12
    function removeDiacritics (str) {
      return str.replace(/[^\u0000-\u007E]/g, function(a){
        return diacriticsMap[a] || a;
      });
    }

    return function (input) {

      return isString(input)
        ? removeDiacritics(input)
        : input;
    }
  }]);

/**
 * @ngdoc filter
 * @name ltrim
 * @kind function
 *
 * @description
 * Left trim. Similar to trimFilter, but only for left side.
 */
angular.module('a8m.ltrim', [])
  .filter('ltrim', function () {
    return function(input, chars) {

      var trim = chars || '\\s';

      return isString(input)
        ? input.replace(new RegExp('^' + trim + '+'), '')
        : input;
    }
  });

/**
 * @ngdoc filter
 * @name match
 * @kind function
 *
 * @description
 * Return the matched pattern in a string.
 */
angular.module('a8m.match', [])
  .filter('match', function () {
    return function (input, pattern, flag) {

      var reg = new RegExp(pattern, flag);

      return isString(input)
        ? input.match(reg)
        : null;
    }
  });

/**
 * @ngdoc filter
 * @name repeat
 * @kind function
 *
 * @description
 * Repeats a string n times
 */
angular.module('a8m.repeat', [])
  .filter('repeat',[ function () {
    return function (input, n, separator) {

      var times = ~~n;

      if(!isString(input)) {
        return input;
      }

      return !times
        ? input
        : strRepeat(input, --n, separator || '');
    }
  }]);

/**
 * Repeats a string n times with given separator
 * @param str string to repeat
 * @param n number of times
 * @param sep separator
 * @returns {*}
 */
function strRepeat(str, n, sep) {
  if(!n) {
    return str;
  }
  return str + sep + strRepeat(str, --n, sep);
}
/**
* @ngdoc filter
* @name rtrim
* @kind function
*
* @description
* Right trim. Similar to trimFilter, but only for right side.
*/
angular.module('a8m.rtrim', [])
  .filter('rtrim', function () {
    return function(input, chars) {

      var trim = chars || '\\s';

      return isString(input)
        ? input.replace(new RegExp(trim + '+$'), '')
        : input;
    }
  });

/**
 * @ngdoc filter
 * @name slugify
 * @kind function
 *
 * @description
 * remove spaces from string, replace with "-" or given argument
 */
angular.module('a8m.slugify', [])
  .filter('slugify',[ function () {
    return function (input, sub) {

      var replace = (isUndefined(sub)) ? '-' : sub;

      return isString(input)
        ? input.toLowerCase().replace(/\s+/g, replace)
        : input;
    }
  }]);

/**
 * @ngdoc filter
 * @name startWith
 * @kind function
 *
 * @description
 * checks whether string starts with the starts parameter.
 */
angular.module('a8m.starts-with', [])
  .filter('startsWith', function () {
    return function (input, start, csensitive) {

      var sensitive = csensitive || false;

      if(!isString(input) || isUndefined(start)) {
        return input;
      }

      input = (sensitive) ? input : input.toLowerCase();

      return !input.indexOf((sensitive) ? start : start.toLowerCase());
    }
  });

/**
 * @ngdoc filter
 * @name stringular
 * @kind function
 *
 * @description
 * get string with {n} and replace match with enumeration values
 */
angular.module('a8m.stringular', [])
  .filter('stringular', function () {
    return function(input) {

      var args = Array.prototype.slice.call(arguments, 1);

      return input.replace(/{(\d+)}/g, function (match, number) {
        return isUndefined(args[number]) ? match : args[number];
      });
    }
  });

/**
 * @ngdoc filter
 * @name stripTags
 * @kind function
 *
 * @description
 * strip html tags from string
 */
angular.module('a8m.strip-tags', [])
  .filter('stripTags', function () {
    return function(input) {
      return isString(input)
        ? input.replace(/<\S[^><]*>/g, '')
        : input;
    }
  });

/**
 * @ngdoc filter
 * @name test
 * @kind function
 *
 * @description
 * test if a string match a pattern.
 */
angular.module('a8m.test', [])
  .filter('test', function () {
    return function (input, pattern, flag) {

      var reg = new RegExp(pattern, flag);

      return isString(input)
        ? reg.test(input)
        : input;
    }
  });

/**
 * @ngdoc filter
 * @name trim
 * @kind function
 *
 * @description
 *  Strip whitespace (or other characters) from the beginning and end of a string
 */
angular.module('a8m.trim', [])
  .filter('trim', function () {
    return function(input, chars) {

      var trim = chars || '\\s';

      return isString(input)
        ? input.replace(new RegExp('^' + trim + '+|' + trim + '+$', 'g'), '')
        : input;
    }
  });

/**
 * @ngdoc filter
 * @name truncate
 * @kind function
 *
 * @description
 * truncates a string given a specified length, providing a custom string to denote an omission.
 */
angular.module('a8m.truncate', [])
  .filter('truncate', function () {
    return function(input, length, suffix, preserve) {

      length = isUndefined(length) ? input.length : length;
      preserve = preserve || false;
      suffix = suffix || '';

      if(!isString(input) || (input.length <= length)) return input;

      return input.substring(0, (preserve)
        ? ((input.indexOf(' ', length) === -1) ? input.length : input.indexOf(' ', length))
        : length) + suffix;
    };
  });

/**
 * @ngdoc filter
 * @name ucfirst
 * @kind function
 *
 * @description
 * ucfirst
 */
angular.module('a8m.ucfirst', [])
  .filter('ucfirst', [function() {
    return function(input) {
      return isString(input)
        ? input
            .split(' ')
            .map(function (ch) {
              return ch.charAt(0).toUpperCase() + ch.substring(1);
            })
            .join(' ')
        : input;
    }
  }]);

/**
 * @ngdoc filter
 * @name uriComponentEncode
 * @kind function
 *
 * @description
 * get string as parameter and return encoded string
 */
angular.module('a8m.uri-component-encode', [])
  .filter('uriComponentEncode',['$window', function ($window) {
      return function (input) {
        return isString(input)
          ? $window.encodeURIComponent(input)
          : input;
      }
    }]);

/**
 * @ngdoc filter
 * @name uriEncode
 * @kind function
 *
 * @description
 * get string as parameter and return encoded string
 */
angular.module('a8m.uri-encode', [])
  .filter('uriEncode',['$window', function ($window) {
      return function (input) {
        return isString(input)
          ? $window.encodeURI(input)
          : input;
      }
    }]);

/**
 * @ngdoc filter
 * @name wrap
 * @kind function
 *
 * @description
 * Wrap a string with another string
 */
angular.module('a8m.wrap', [])
  .filter('wrap', function () {
    return function(input, wrap, ends) {
      return isString(input) && isDefined(wrap)
        ? [wrap, input, ends || wrap].join('')
        : input;
    }
  });

/**
 * @ngdoc provider
 * @name filterWatcher
 * @kind function
 *
 * @description
 * store specific filters result in $$cache, based on scope life time(avoid memory leak).
 * on scope.$destroy remove it's cache from $$cache container
 */

angular.module('a8m.filter-watcher', [])
  .provider('filterWatcher', function() {

    this.$get = ['$window', '$rootScope', function($window, $rootScope) {

      /**
       * Cache storing
       * @type {Object}
       */
      var $$cache = {};

      /**
       * Scope listeners container
       * scope.$destroy => remove all cache keys
       * bind to current scope.
       * @type {Object}
       */
      var $$listeners = {};

      /**
       * $timeout without triggering the digest cycle
       * @type {function}
       */
      var $$timeout = $window.setTimeout;

      /**
       * @description
       * get `HashKey` string based on the given arguments.
       * @param fName
       * @param args
       * @returns {string}
       */
      function getHashKey(fName, args) {
        function replacerFactory() {
          var cache = [];
          return function(key, val) {
            if(isObject(val) && !isNull(val)) {
              if (~cache.indexOf(val)) return '[Circular]';
              cache.push(val)
            }
            if($window == val) return '$WINDOW';
            if($window.document == val) return '$DOCUMENT';
            if(isScope(val)) return '$SCOPE';
            return val;
          }
        }
        return [fName, JSON.stringify(args, replacerFactory())]
          .join('#')
          .replace(/"/g,'');
      }

      /**
       * @description
       * fir on $scope.$destroy,
       * remove cache based scope from `$$cache`,
       * and remove itself from `$$listeners`
       * @param event
       */
      function removeCache(event) {
        var id = event.targetScope.$id;
        forEach($$listeners[id], function(key) {
          delete $$cache[key];
        });
        delete $$listeners[id];
      }

      /**
       * @description
       * for angular version that greater than v.1.3.0
       * it clear cache when the digest cycle is end.
       */
      function cleanStateless() {
        $$timeout(function() {
          if(!$rootScope.$$phase)
            $$cache = {};
        }, 2000);
      }

      /**
       * @description
       * Store hashKeys in $$listeners container
       * on scope.$destroy, remove them all(bind an event).
       * @param scope
       * @param hashKey
       * @returns {*}
       */
      function addListener(scope, hashKey) {
        var id = scope.$id;
        if(isUndefined($$listeners[id])) {
          scope.$on('$destroy', removeCache);
          $$listeners[id] = [];
        }
        return $$listeners[id].push(hashKey);
      }

      /**
       * @description
       * return the `cacheKey` or undefined.
       * @param filterName
       * @param args
       * @returns {*}
       */
      function $$isMemoized(filterName, args) {
        var hashKey = getHashKey(filterName, args);
        return $$cache[hashKey];
      }

      /**
       * @description
       * store `result` in `$$cache` container, based on the hashKey.
       * add $destroy listener and return result
       * @param filterName
       * @param args
       * @param scope
       * @param result
       * @returns {*}
       */
      function $$memoize(filterName, args, scope, result) {
        var hashKey = getHashKey(filterName, args);
        //store result in `$$cache` container
        $$cache[hashKey] = result;
        // for angular versions that less than 1.3
        // add to `$destroy` listener, a cleaner callback
        if(isScope(scope)) {
          addListener(scope, hashKey);
        } else {
          cleanStateless();
        }
        return result;
      }

      return {
        isMemoized: $$isMemoized,
        memoize: $$memoize
      }
    }];
  });
  

/**
 * @ngdoc module
 * @name angular.filters
 * @description
 * Bunch of useful filters for angularJS
 */

angular.module('angular.filter', [

  'a8m.ucfirst',
  'a8m.uri-encode',
  'a8m.uri-component-encode',
  'a8m.slugify',
  'a8m.latinize',
  'a8m.strip-tags',
  'a8m.stringular',
  'a8m.truncate',
  'a8m.starts-with',
  'a8m.ends-with',
  'a8m.wrap',
  'a8m.trim',
  'a8m.ltrim',
  'a8m.rtrim',
  'a8m.repeat',
  'a8m.test',
  'a8m.match',

  'a8m.to-array',
  'a8m.concat',
  'a8m.contains',
  'a8m.unique',
  'a8m.is-empty',
  'a8m.after',
  'a8m.after-where',
  'a8m.before',
  'a8m.before-where',
  'a8m.defaults',
  'a8m.where',
  'a8m.reverse',
  'a8m.remove',
  'a8m.remove-with',
  'a8m.group-by',
  'a8m.count-by',
  'a8m.chunk-by',
  'a8m.search-field',
  'a8m.fuzzy-by',
  'a8m.fuzzy',
  'a8m.omit',
  'a8m.pick',
  'a8m.every',
  'a8m.filter-by',
  'a8m.xor',
  'a8m.map',
  'a8m.first',
  'a8m.last',
  'a8m.flatten',
  'a8m.join',
  'a8m.range',
  
  'a8m.math',
  'a8m.math.max',
  'a8m.math.min',
  'a8m.math.percent',
  'a8m.math.radix',
  'a8m.math.sum',
  'a8m.math.degrees',
  'a8m.math.radians',
  'a8m.math.byteFmt',
  'a8m.math.kbFmt',
  'a8m.math.shortFmt',

  'a8m.angular',
  'a8m.conditions',
  'a8m.is-null',

  'a8m.filter-watcher'
]);
})( window, window.angular );
angular.module("myApp").run(["$templateCache", function($templateCache) {$templateCache.put("index-async.html","<!doctype html>\r\n<html lang=\"en\">\r\n<head>\r\n  <meta charset=\"utf-8\">\r\n  <link rel=\"stylesheet\" href=\"bower_components/html5-boilerplate/css/normalize.css\">\r\n  <link rel=\"stylesheet\" href=\"bower_components/html5-boilerplate/css/main.css\">\r\n  <style>\r\n    [ng-cloak] {\r\n      display: none;\r\n    }\r\n  </style>\r\n  <script src=\"bower_components/html5-boilerplate/js/vendor/modernizr-2.6.2.min.js\"></script>\r\n  <script>\r\n    // include angular loader, which allows the files to load in any order\r\n    //@@NG_LOADER_START@@\r\n    // You need to run `npm run update-index-async` to inject the angular async code here\r\n    //@@NG_LOADER_END@@\r\n\r\n    // include a third-party async loader library\r\n    /*!\r\n     * $script.js v1.3\r\n     * https://github.com/ded/script.js\r\n     * Copyright: @ded & @fat - Dustin Diaz, Jacob Thornton 2011\r\n     * Follow our software http://twitter.com/dedfat\r\n     * License: MIT\r\n     */\r\n    !function(a,b,c){function t(a,c){var e=b.createElement(\"script\"),f=j;e.onload=e.onerror=e[o]=function(){e[m]&&!/^c|loade/.test(e[m])||f||(e.onload=e[o]=null,f=1,c())},e.async=1,e.src=a,d.insertBefore(e,d.firstChild)}function q(a,b){p(a,function(a){return!b(a)})}var d=b.getElementsByTagName(\"head\")[0],e={},f={},g={},h={},i=\"string\",j=!1,k=\"push\",l=\"DOMContentLoaded\",m=\"readyState\",n=\"addEventListener\",o=\"onreadystatechange\",p=function(a,b){for(var c=0,d=a.length;c<d;++c)if(!b(a[c]))return j;return 1};!b[m]&&b[n]&&(b[n](l,function r(){b.removeEventListener(l,r,j),b[m]=\"complete\"},j),b[m]=\"loading\");var s=function(a,b,d){function o(){if(!--m){e[l]=1,j&&j();for(var a in g)p(a.split(\"|\"),n)&&!q(g[a],n)&&(g[a]=[])}}function n(a){return a.call?a():e[a]}a=a[k]?a:[a];var i=b&&b.call,j=i?b:d,l=i?a.join(\"\"):b,m=a.length;c(function(){q(a,function(a){h[a]?(l&&(f[l]=1),o()):(h[a]=1,l&&(f[l]=1),t(s.path?s.path+a+\".js\":a,o))})},0);return s};s.get=t,s.ready=function(a,b,c){a=a[k]?a:[a];var d=[];!q(a,function(a){e[a]||d[k](a)})&&p(a,function(a){return e[a]})?b():!function(a){g[a]=g[a]||[],g[a][k](b),c&&c(d)}(a.join(\"|\"));return s};var u=a.$script;s.noConflict=function(){a.$script=u;return this},typeof module!=\"undefined\"&&module.exports?module.exports=s:a.$script=s}(this,document,setTimeout)\r\n\r\n    // load all of the dependencies asynchronously.\r\n    $script([\r\n      \'bower_components/angular/angular.js\',\r\n      \'bower_components/angular-route/angular-route.js\',\r\n      \'app.js\',\r\n      \'welcomeView/welcomeView.js\',\r\n      \'voterSignup/voterSignup.js\',\r\n      \'politicianSignup/politicianSignup.js\',\r\n      \'advocateSignup/advocateSignup.js\',\r\n      \'advocateHome/advocateHome.js\',\r\n      \'questionHome/questionHome.js\',\r\n      \"debateHome/debateHome.js\",\r\n      \'localDebate/localDebate.js\',\r\n      \'learnHome/learnHome.js\',\r\n      \'pressHome/pressHome.js\',\r\n      \'signin/signin.js\',\r\n      \'localPress/localPress.js\',\r\n      \'components/version/version.js\',\r\n      \'components/version/version-directive.js\',\r\n      \'components/version/interpolate-filter.js\'\r\n    ], function() {\r\n      // when all is done, execute bootstrap angular application\r\n      angular.bootstrap(document, [\'myApp\']);\r\n    });\r\n  </script>\r\n  <title>My AngularJS App</title>\r\n  <link rel=\"stylesheet\" href=\"newStyle.css\">\r\n  <link rel=\"stylesheet\" href=\"app.css\">\r\n  <link rel=\"stylesheet\" href=\"styles.css\">\r\n</head>\r\n<body ng-cloak>\r\n  <ul class=\"menu\">\r\n    <li><a href=\"#/welcomeView\">view1</a></li>\r\n    <li><a href=\"#/view2\">view2</a></li>\r\n  </ul>\r\n\r\n  <div ng-view></div>\r\n\r\n\r\n</body>\r\n</html>\r\n");
$templateCache.put("index.html","<!DOCTYPE html>\r\n<!--[if lt IE 7]>      <html lang=\"en\" ng-app=\"myApp\" class=\"no-js lt-ie9 lt-ie8 lt-ie7\"> <![endif]-->\r\n<!--[if IE 7]>         <html lang=\"en\" ng-app=\"myApp\" class=\"no-js lt-ie9 lt-ie8\"> <![endif]-->\r\n<!--[if IE 8]>         <html lang=\"en\" ng-app=\"myApp\" class=\"no-js lt-ie9\"> <![endif]-->\r\n<!--[if gt IE 8]><!-->\r\n<html lang=\"en\" ng-app=\"myApp\" id=\"globalHtmlTag\" class=\"no-js\">\r\n<!--<![endif]-->\r\n\r\n<head>\r\n  <meta charset=\"utf-8\">\r\n  <meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\">\r\n  <title>Votewise</title>\r\n  <!-- <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\"> -->\r\n  <meta name=\"viewport\" content=\"initial-scale=1, maximum-scale=1\">\r\n  <meta name=“fragment” content=“!”/>\r\n  <meta property=\"og:title\" content=\"Get matched and get heard by politicians and organizations.\" />\r\n  <meta property=\"og:description\"\r\n    content=\"VoteWise.net is a non-partisan non-profit tool aimed at repairing democracy by depolarizing the issues and connecting voters, politicians and organizations without advertising dollars getting in the way.\" />\r\n  <meta property=\"og:type\" content=\"website\" />\r\n  <meta propety=\"fb:page_id\" content=\"723630358083200\" />\r\n  <meta property=\"og:image\" content=\"https://votewise.net/assets/images/VoteWiseMeta.jpg\" />\r\n  <meta property=\"keywords\"\r\n    content=\"democracy, voting, registration, democratic, debate, vote, politics, politicians, 501c3, 501c4, non-profit, nonpartisan, nonprofit, non-partisan, learn, educational\" />\r\n  <!-- Global site tag (gtag.js) - Google Analytics -->\r\n  <script async src=\"https://www.googletagmanager.com/gtag/js?id=UA-77445212-1\"></script>\r\n  <script>\r\n    window.dataLayer = window.dataLayer || [];\r\n\r\n    function gtag() {\r\n      dataLayer.push(arguments);\r\n    }\r\n    gtag(\'js\', new Date());\r\n    gtag(\'config\', \'UA-77445212-1\');\r\n\r\n  </script>\r\n\r\n\r\n  <style>\r\n    .no-js #loader {\r\n      display: none;\r\n    }\r\n\r\n    .js #loader {\r\n      display: block;\r\n      position: absolute;\r\n      left: 100px;\r\n      top: 0;\r\n    }\r\n\r\n    .se-pre-con {\r\n      position: fixed;\r\n      left: 0px;\r\n      top: 0px;\r\n      width: 100%;\r\n      height: 100%;\r\n      z-index: 9999;\r\n      background: url(assets/images/loader/small.gif) center no-repeat;\r\n      /* opacity: 0.6; */\r\n\r\n    }\r\n\r\n    .backLogo {\r\n      position: fixed;\r\n      left: 0px;\r\n      top: 0px;\r\n      width: 100%;\r\n      height: 100%;\r\n      z-index: 9999;\r\n      background: url(assets/images/loader/logo.svg) center no-repeat white;\r\n      /* background-size: auto; */\r\n      opacity: 0.7;\r\n\r\n    }\r\n  </style>\r\n  <script src=\"https://ajax.googleapis.com/ajax/libs/jquery/1.5.2/jquery.min.js\"></script>\r\n  <!-- <script async defer src=\"https://cdnjs.cloudflare.com/ajax/libs/modernizr/2.8.2/modernizr.js\"></script> -->\r\n\r\n  <script async defer src=\"assets/js//modernizr.js\"></script>\r\n\r\n\r\n  <!-- <script src=\"http://ajax.aspnetcdn.com/ajax/jquery.validate/1.11.1/jquery.validate.min.js\"></script> -->\r\n\r\n\r\n\r\n\r\n  <!-- favicon -->\r\n  <!-- <link rel=\"shortcut icon\" type=\"image/x-icon\" href=\"/assets/images/favicon/favicon.ico\"/> -->\r\n  <link rel=\"apple-touch-icon\" sizes=\"180x180\" href=\"/assets/images/favicon/apple-touch-icon.png\">\r\n  <link rel=\"icon\" type=\"image/png\" sizes=\"32x32\" href=\"/assets/images/favicon/favicon-32x32.png\">\r\n  <link rel=\"icon\" type=\"image/png\" sizes=\"16x16\" href=\"/assets/images/favicon/favicon-16x16.png\">\r\n  <link rel=\"manifest\" href=\"/assets/images/favicon/manifest.json\">\r\n  <link rel=\"mask-icon\" href=\"/assets/images/favicon/safari-pinned-tab.svg\" color=\"#6100ff\">\r\n  <meta name=\"msapplication-TileColor\" content=\"#603cba\">\r\n  <meta name=\"msapplication-TileImage\" content=\"/mstile-144x144.png\">\r\n  <meta name=\"theme-color\" content=\"#ffffff\">\r\n  <link rel=\"stylesheet\" href=\"https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css\"\r\n    integrity=\"sha384-Gn5384xqQ1aoWXA+058RXPxPg6fy4IWvTNh0E263XmFcJlSAwiGgFAW/dAiS6JXm\" crossorigin=\"anonymous\">\r\n  <!--\r\n    <link rel=\"stylesheet\" href=\"bower_components/ng-dialog/css/ngDialog.css\">\r\n    <link rel=\"stylesheet\" href=\"bower_components/ng-dialog/css/ngDialog-theme-default.css\">\r\n    <link rel=\"stylesheet\" href=\"app.css\">\r\n    <script src=\"bower_components/html5-boilerplate/dist/js/vendor/modernizr-2.8.3.min.js\"></script>\r\n    <link rel=\"stylesheet\" href=\"https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css\" />\r\n    <script src=\"lib/jquery-1.12.4.min.js\"></script>\r\n    <script src=\"lib/jquery.scrollTo.min.js\"></script>\r\n    <script src=\"assets/validation/jquery.validationEngine-en.js\"></script>\r\n    <script src=\"assets/validation/jquery.validationEngine.js\"></script>\r\n    <link href=\"assets/validation/validationEngine.jquery.css\" rel=\"stylesheet\" />\r\n    <link href=\"assets/css/style.css\" rel=\"stylesheet\" />\r\n    <link href=\"assets/css/angular-toggle-switch-bootstrap-2.css\" rel=\"stylesheet\" />\r\n    <link rel=\"stylesheet\" type=\"text/css\" href=\"bower_components/angular-mass-autocomplete/massautocomplete.theme.css\" />\r\n    <link rel=\"stylesheet\" type=\"text/css\" href=\"bower_components/angular-input-stars-directive/angular-input-stars.css\"> -->\r\n  <!-- build:css({.tmp,src}) styles/vendor.css -->\r\n  <!-- bower:css -->\r\n  <!-- run `gulp inject` to automatically populate bower styles dependencies -->\r\n  <!-- endbower -->\r\n  <!-- endbuild -->\r\n  <!-- build:css({.tmp,src}) styles/app.css -->\r\n  <!-- inject:css -->\r\n  <!-- css files will be automatically insert here -->\r\n  <!-- endinject -->\r\n  <!-- endbuild -->\r\n</head>\r\n\r\n<body class=\"body-tag\" ng-class=\'$root.welcome == true ? \"removeBgImage\" : \"applyBgImage\"\'>\r\n\r\n  <div class=\"backLogo\">\r\n    <div class=\"se-pre-con\"></div>\r\n  </div>\r\n\r\n\r\n\r\n  <div id=\"fb-root\"></div>\r\n  <header class=\"header sticky-top\">\r\n    <div>\r\n      <!-- HEADER FOR VOTER AND UNSIGNED--->\r\n      <div class=\"row topHeader alert alert-primary\" ng-cloak ng-show=\"!$root.userRole || $root.userRole == \'voter\'\">\r\n        <div class=\"col col-lg-12 userName\">\r\n          <a class=\"navbar-brand\" href=\"#!/welcome\">\r\n              <img src=\"./assets/images/votewiselogoOffWhite.svg\" class=\"d-inline-block align-top brandLogo\" alt=\"Welcome\">\r\n            </a>\r\n\r\n          <span class=\"headerSpacer d-md-none \">...................</span>\r\n          <span ng-if=\"$root.User\" ng-cloak><a class=\"navbar-brand\" href=\"#!/snapshot\" style=\"text-transform: capitalize;\">Hello, {{$root.User}} :\r\n											<span style=\"text-transform: capitalize;\">{{$root.userRole}}</span></a>\r\n          </span>\r\n          <span class=\"headerContactUs \">\r\n              <span>\r\n                <a href=\"#!/donate\" style=\"margin-right:15px;\">DONATE </a> | </span>\r\n          <a href=\"#!/signin\" ng-if=\"!$root.User\" style=\"margin-left:15px;\">LOGIN</a>\r\n          <span ng-if=\"$root.User\" style=\"display:inline-block;\">\r\n                <div class=\"dropdown show\">\r\n                  <a class=\"btn btn-secondary dropdown-toggle menuDropdown\" href=\"\" role=\"button\" id=\"dropdownMenuLink\" data-toggle=\"dropdown\"\r\n                    aria-haspopup=\"true\" aria-expanded=\"true\">\r\n                    <i class=\"fa userIcon\"></i>\r\n                    MY ACCOUNT\r\n                  </a>\r\n\r\n                  <div class=\"dropdown-menu dropdownMenu\" aria-labelledby=\"dropdownMenuLink\">\r\n                    <h6 class=\"dropdown-header dropdownHeader\">{{$root.User}}</h6>\r\n                    <!-- <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/snapshot\">Personal Home Page</a>  -->\r\n\r\n                     <a class=\"dropdown-item dropdownMenuItem\" ng-show=\"$root.userRole==\'voter\'\" href=\"#!/gettingstarted\">Getting Started</a>\r\n                    <a class=\"dropdown-item dropdownMenuItem\" ng-show=\"$root.userRole==\'advocate\'\" href=\"#!/gettingStartedOrg\">Getting Started</a>\r\n                    <a class=\"dropdown-item dropdownMenuItem\" ng-show=\"$root.userRole==\'politician\'\" href=\"#!/gettingStartedPol\">Getting Started</a>\r\n																			<a class=\"dropdown-item dropdownMenuItem\" ng-show=\"$root.userRole==\'voter\'\" href=\"#!/fiveCompare/skip_to_result\">Skip to Election</a>				\r\n                      <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/userProfile\">My Profile</a>\r\n                      <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/wheretovote\">Problems Voting</a>\r\n                   <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/answeredQuestions\"> My Answered Questions</a>\r\n                   <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/legislation\">Legislation</a>\r\n\r\n                    <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/followingUsers\">Following</a>\r\n                    <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/howToVideo\">How To Videos</a>\r\n                    <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/faq\">FAQ\'s</a>\r\n                    <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/aboutUs\">About Us</a>\r\n                    <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/snapshot\">Personal Home</a>\r\n																			<a class=\"dropdown-item dropdownMenuItem\" href=\"#!/welcome\">Welcome Home</a>\r\n                    <div class=\"dropdown-divider\"></div>\r\n                    <div class=\"dropdown-item logoutContainer\">\r\n                      <button class=\"btn btn-primary logoutBtn\" ng-click=\"Logout(true)\">Logout</button>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </span>\r\n          </span>\r\n        </div>\r\n				\r\n      </div>\r\n      <!--  HEADER FOR ADMIN -->\r\n      <div class=\"row topHeaderAdm alert alert-primary\" ng-cloak ng-show=\"$root.userRole==\'admin\'\">\r\n        <div class=\"col col-lg-12 userName\">\r\n          <a class=\"navbar-brand\" href=\"#!/welcome\">\r\n              <img src=\"./assets/images/votewiselogo.svg\" class=\"d-inline-block align-top brandLogo\" alt=\"Welcome\">\r\n            </a>\r\n\r\n          <span class=\"headerSpacerAdm d-md-none \">...................</span>\r\n          <span ng-if=\"$root.User\" ng-cloak class=\"blackText\"><a class=\"navbar-brand\" href=\"#!/snapshot\"style=\"text-transform: capitalize;\">Hello, {{$root.User}} :\r\n											<span style=\"text-transform: capitalize;\">{{$root.userRole}}</span></a>\r\n          </span>\r\n          <span class=\"headerContactUs \">\r\n              <span>\r\n                <a href=\"#!/donate\" style=\"margin-right:15px;\" class=\"blackText\">DONATE </a> | </span>\r\n          <a href=\"#!/signin\" ng-if=\"!$root.User\" style=\"margin-left:15px;\" class=\"blackText\">LOGIN</a>\r\n          <span ng-if=\"$root.User\" style=\"display:inline-block;\">\r\n                <div class=\"dropdown show\">\r\n                  <a class=\"btn btn-secondary dropdown-toggle menuDropdown blackText\" href=\"\" role=\"button\" id=\"dropdownMenuLink\" data-toggle=\"dropdown\"\r\n                    aria-haspopup=\"true\" aria-expanded=\"true\">\r\n                    <i class=\"fa userIcon\"></i>\r\n                    <span class=\"blackText\"> MY ACCOUNT</span>\r\n          </a>\r\n          <div class=\"dropdown-menu dropdownMenu\" aria-labelledby=\"dropdownMenuLink\">\r\n            <h6 class=\"dropdown-header dropdownHeader\">{{$root.User}}</h6>\r\n            <!-- <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/snapshot\">Personal Home Page</a>  -->\r\n            <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/userProfile\">My Profile</a>\r\n											<a class=\"dropdown-item dropdownMenuItem\" ng-show=\"$root.userRole==\'admin\'\" href=\"#!/fiveCompare/skip_to_result\">Skip to Election</a>				\r\n            <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/wheretovote\">Problems Voting</a>\r\n            <a class=\"dropdown-item dropdownMenuItem\"\r\n               href=\"#!/answeredQuestions\">My Answered Questions</a>\r\n            <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/legislation\">Legislation</a>\r\n            <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/votesmart\">Votesmart Data</a>\r\n            <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/ratingReviews\">Organization Reviews</a>\r\n            <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/followingUsers\">Following</a>\r\n            <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/howToVideo\">How To Videos</a>\r\n            <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/faq\">FAQ\'s</a>\r\n            <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/aboutUs\">About Us</a>\r\n            <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/snapshot\">Personal Home</a>\r\n            <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/welcome\">Welcome Home</a>\r\n            <div class=\"dropdown-divider\"></div>\r\n            <div class=\"dropdown-item logoutContainer\">\r\n              <button class=\"btn btn-primary logoutBtn\" ng-click=\"Logout(true)\">Logout</button>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        </span>\r\n        </span>\r\n      </div>\r\n    </div>\r\n    <!-- HEADER FOR POL -->\r\n    <div class=\"row topHeaderPol alert alert-primary\" ng-cloak ng-show=\"$root.userRole==\'politician\'\">\r\n      <div class=\"col col-lg-12 userName\">\r\n        <a class=\"navbar-brand\" href=\"#!/welcome\">\r\n              <img src=\"./assets/images/votewiselogoOffWhite.svg\" class=\"d-inline-block align-top brandLogo\" alt=\"Welcome\" >\r\n            </a>\r\n\r\n        <span class=\"headerSpacerPol d-md-none \">...................</span>\r\n        <span ng-if=\"$root.User\" ng-cloak><a class=\"navbar-brand\" href=\"#!/snapshot\" style=\"text-transform: capitalize;\">Hello, {{$root.User}} :\r\n									<span style=\"text-transform: capitalize;\">{{$root.userRole}}</span></a>\r\n        </span>\r\n        <span class=\"headerContactUs \">\r\n              <span>\r\n                <a href=\"#!/donate\" style=\"margin-right:15px;\">DONATE </a> | </span>\r\n        <a href=\"#!/signin\" ng-if=\"!$root.User\" style=\"margin-left:15px;\">LOGIN</a>\r\n        <span ng-if=\"$root.User\" style=\"display:inline-block;\">\r\n                <div class=\"dropdown show\">\r\n                  <a class=\"btn btn-secondary dropdown-toggle menuDropdown\" href=\"\" role=\"button\" id=\"dropdownMenuLink\" data-toggle=\"dropdown\"\r\n                    aria-haspopup=\"true\" aria-expanded=\"true\">\r\n                    <i class=\"fa userIcon\"></i>\r\n                    MY ACCOUNT\r\n                  </a>\r\n\r\n                  <div class=\"dropdown-menu dropdownMenu\" aria-labelledby=\"dropdownMenuLink\">\r\n                    <h6 class=\"dropdown-header dropdownHeader\">{{$root.User}}</h6>\r\n                    <!-- <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/snapshot\">Personal Home Page</a>  -->\r\n\r\n\r\n                    <a class=\"dropdown-item dropdownMenuItem\" ng-show=\"$root.userRole==\'politician\'\" href=\"#!/gettingStartedPol\">Getting Started</a>\r\n																			<a class=\"dropdown-item dropdownMenuItem\" ng-show=\"$root.userRole==\'politician\'\" href=\"#!/fiveCompare/skip_to_result\">Skip to Election</a>				\r\n                      <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/userProfile\">My Profile</a>\r\n<!--                   <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/displayGuestForPolitician\">Unorganized Users</a>-->\r\n\r\n                      <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/wheretovote\">Problems Voting</a>\r\n                   <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/answeredQuestions\">My Answered Questions</a>\r\n\r\n                         <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/followingUsers\">Following</a>\r\n                    <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/howToVideo\">How To Videos</a>\r\n                    <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/faq\">FAQ\'s</a>\r\n                    <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/aboutUs\">About Us</a>\r\n                    <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/snapshot\">Personal Home</a>\r\n																			<a class=\"dropdown-item dropdownMenuItem\" href=\"#!/welcome\">Welcome Home</a>\r\n                    <div class=\"dropdown-divider\"></div>\r\n                    <div class=\"dropdown-item logoutContainer\">\r\n                      <button class=\"btn btn-primary logoutBtn\" ng-click=\"Logout(true)\">Logout</button>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </span>\r\n        </span>\r\n      </div>\r\n    </div>\r\n    <!-- HEADER FOR ORG -->\r\n    <div class=\"row topHeaderOrg alert alert-primary\" ng-cloak ng-show=\"$root.userRole==\'advocate\' \">\r\n      <div class=\"col col-lg-12 userName\">\r\n        <a class=\"navbar-brand\" href=\"#!/welcome\">\r\n              <img src=\"./assets/images/votewiselogoOffWhite.svg\" class=\"d-inline-block align-top brandLogo\" alt=\"Welcome\" >\r\n            </a>\r\n\r\n        <span class=\"headerSpacerOrg d-md-none \">...................</span>\r\n        <span ng-if=\"$root.User\" ng-cloak><a class=\"navbar-brand\" href=\"#!/snapshot\"style=\"text-transform: capitalize;\">Hello, {{$root.User}} :\r\n									<span style=\"text-transform: capitalize;\">{{$root.userRole}}</span></a>\r\n        </span>\r\n        <span class=\"headerContactUs \">\r\n              <span>\r\n                <a href=\"#!/donate\" style=\"margin-right:15px;\">DONATE </a> | </span>\r\n        <a href=\"#!/signin\" ng-if=\"!$root.User\" style=\"margin-left:15px;\">LOGIN</a>\r\n        <span ng-if=\"$root.User\" style=\"display:inline-block;\">\r\n                <div class=\"dropdown show\">\r\n                  <a class=\"btn btn-secondary dropdown-toggle menuDropdown\" href=\"\" role=\"button\" id=\"dropdownMenuLink\" data-toggle=\"dropdown\"\r\n                    aria-haspopup=\"true\" aria-expanded=\"true\">\r\n                    <i class=\"fa userIcon\"></i>\r\n                    MY ACCOUNT\r\n                  </a>\r\n\r\n                  <div class=\"dropdown-menu dropdownMenu\" aria-labelledby=\"dropdownMenuLink\">\r\n                    <h6 class=\"dropdown-header dropdownHeader\">{{$root.User}}</h6>\r\n                    <!-- <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/snapshot\">Personal Home Page</a>  -->\r\n\r\n                    <a class=\"dropdown-item dropdownMenuItem\" ng-show=\"$root.userRole==\'advocate\'\" href=\"#!/gettingStartedOrg\">Getting Started</a>\r\n	                    <a class=\"dropdown-item dropdownMenuItem\" ng-show=\"$root.userRole==\'advocate\'\" href=\"#!/fiveCompare/skip_to_result\">Skip to Election</a>																		\r\n                      <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/userProfile\">My Profile</a>\r\n                      <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/wheretovote\">Problems Voting</a>\r\n                    <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/answeredQuestions\">My Answered Questions</a>\r\n                    <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/legislation\">Legislation</a>\r\n                  <!--  <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/ratePolitician\">Rate Politicians</a>  -->\r\n                 <!--   <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/endorsePolitician\">Endorse Politicians</a>  -->\r\n<!--                 <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/quizResult\">Result of followers</a>\r\n                    <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/manageOrganizationQuestions\">Add Questions</a>\r\n                    <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/allQuizzes\">All Quizzes</a>\r\n                    <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/orgQuestions\">Manage Questions</a>-->\r\n                      <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/followingUsers\">Following</a>\r\n                    <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/howToVideo\">How To Videos</a>\r\n                    <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/faq\">FAQ\'s</a>\r\n                    <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/aboutUs\">About Us</a>\r\n                    <a class=\"dropdown-item dropdownMenuItem\" href=\"#!/snapshot\">Personal Home</a>\r\n																			<a class=\"dropdown-item dropdownMenuItem\" href=\"#!/welcome\">Welcome Home</a>\r\n                    <div class=\"dropdown-divider\"></div>\r\n                    <div class=\"dropdown-item logoutContainer\">\r\n                      <button class=\"btn btn-primary logoutBtn\" ng-click=\"Logout(true)\">Logout</button>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </span>\r\n        </span>\r\n      </div>\r\n    </div>\r\n    <div class=\"container-fluid container-fluidCustom\">\r\n      <nav class=\"navbar navbar-expand-md navbar-light bg-faded navbarColor\" style=\"width:100%;\">\r\n        <!--  <a href=\"#!/donate\" style=\"margin-top:10px;\" class=\"d-lg-none d-md-none\">\r\n          <button type=\"button\" class=\"donateBtn btn\">Donate</button>\r\n        </a>  -->\r\n     <!--   FOR VOTERS small-->\r\n        <div class=\"tinyPrint d-md-none\" ng-show=\"!$root.userRole || $root.userRole == \'voter\'\">\r\n									<span>\r\n                <a href=\"#!/gettingstarted\" class=\"footerLink\">Start |</a>\r\n									</span>\r\n									<span>\r\n                <a href=\"#!/fiveCompare/skip_to_result\" class=\"footerLink\">Election |</a>\r\n									</span>\r\n									<span>\r\n                <a href=\"#!/questionHome\" class=\"footerLink\">Quiz |</a>\r\n              </span>\r\n          <span>\r\n                <a href=\"#!/learnHome\" class=\"footerLink\"> Learn |</a>\r\n              </span>\r\n          <span>\r\n                <a href=\"#!/debateHome\" class=\"footerLink\">Discuss |</a>\r\n              </span>\r\n<!--           <span>\r\n               <a href=\"#!/incumbent_politician/politician\" class=\"footerLink\">Politicians |</a>\r\n              </span> -->\r\n          <span>\r\n                <a href=\"#!/advocateHome\" class=\"footerLink\">Orgs |</a>\r\n              </span>\r\n          <span>\r\n                <a href=\"#!/liveFeed\" class=\"footerLink\">News</a>\r\n              </span>\r\n\r\n        </div>\r\n        <!-- FOR VOTERS BIG -->\r\n        <div class=\"d-none d-md-block\" ng-show=\"!$root.userRole || $root.userRole == \'voter\'\">\r\n          <span>\r\n                <a href=\"#!/gettingstarted\" class=\"footerLink\">Getting Started |</a>\r\n									</span>\r\n          <span ng-if=\"$root.userRole == \'voter\'\">\r\n                <a href=\"#!/fiveCompare/skip_to_result\" class=\"footerLink\">Skip to Election |</a>\r\n									</span>\r\n									<span>\r\n                <a href=\"#!/questionHome\" class=\"footerLink\">Match Quizzes |</a>\r\n              </span>\r\n          <span>\r\n                <a href=\"#!/learnHome\" class=\"footerLink\"> Learn |</a>\r\n              </span>\r\n          <span>\r\n                <a href=\"#!/debateHome\" class=\"footerLink\">Discuss |</a>\r\n              </span>\r\n          <span>\r\n                <a href=\"#!/incumbent_politician/politician\" class=\"footerLink\">Politicians |</a>\r\n              </span>\r\n          <span>\r\n                <a href=\"#!/advocateHome\" class=\"footerLink\">Organizations |</a>\r\n              </span>\r\n									<span>\r\n                <a href=\"#!/liveFeed\" class=\"footerLink\">News</a>\r\n              </span>\r\n\r\n        </div>\r\n        <!--  FOR ORGANIZATIONS small-->\r\n        <div class=\"tinyPrint d-md-none\" ng-show=\"$root.userRole==\'advocate\'\">\r\n          <span>\r\n                <a href=\"#!/userProfile\" class=\"footerLink\">Profile |</a>\r\n              </span>\r\n																		<span ng-if=\"$root.userRole == \'voter\'\">\r\n                <a href=\"#!/fiveCompare/skip_to_result\" class=\"footerLink\">Election |</a>\r\n									</span>\r\n          <span>\r\n                <a href=\"#!/speakOut\" class=\"footerLink\"> Speak |</a>\r\n              </span>\r\n          <span>\r\n                <a href=\"#!/learnHome\" class=\"footerLink\">Research |</a>\r\n              </span>\r\n          <span>\r\n                <a href=\"#!/allies\" class=\"footerLink\">Allies |</a>\r\n              </span>\r\n          <!--   REACTIVATE WHEN DONATE TOOL IS BUILT\r\n                <span>\r\n                <a href=\"#!/orgCampaign\" class=\"footerLink\">Campaign |</a>\r\n              </span>\r\n -->\r\n          <span>\r\n                <a href=\"#!/liveFeed\" class=\"footerLink\">News</a>\r\n              </span>\r\n\r\n        </div>\r\n        <!--  FOR ORGANIZATIONS Big-->\r\n        <div class=\"d-none d-md-block\" ng-show=\"$root.userRole==\'advocate\'\">\r\n           <span>\r\n                <a href=\"#!/gettingStartedOrg\" class=\"footerLink\">Getting Started |</a>\r\n              </span>\r\n									          <span>\r\n                <a href=\"#!/fiveCompare/skip_to_result\" class=\"footerLink\">Skip to Election |</a>\r\n									</span>\r\n									<span>\r\n                <a href=\"#!/userProfile\" class=\"footerLink\">Profile |</a>\r\n              </span>\r\n          <span>\r\n                <a href=\"#!/speakOut\" class=\"footerLink\"> Speak Out |</a>\r\n              </span>\r\n          <span>\r\n                <a href=\"#!/learnHome\" class=\"footerLink\">Research |</a>\r\n              </span>\r\n          <span>\r\n                <a href=\"#!/allies\" class=\"footerLink\">Allies |</a>\r\n              </span>\r\n          <!--   REACTIVATE WHEN DONATION TOOL IS BUILT\r\n                <span>\r\n                <a href=\"#!/orgCampaign\" class=\"footerLink\">Campaign |</a>\r\n              </span>\r\n-->\r\n          <span>\r\n                <a href=\"#!/liveFeed\" class=\"footerLink\">News</a>\r\n              </span>\r\n\r\n        </div>\r\n        <!-- FOR POLITICIANS SMALL -->\r\n        <div class=\"tinyPrint d-md-none\" ng-show=\"$root.userRole==\'politician\'\">\r\n          <span>\r\n                <a href=\"#!/userProfile\" class=\"footerLink\">Profile |</a>\r\n              </span>\r\n																		<span>\r\n                <a href=\"#!/fiveCompare/skip_to_result\" class=\"footerLink\">Election |</a>\r\n									</span>\r\n          <span>\r\n                <a href=\"#!/winVoters\" class=\"footerLink\"> Voters |</a>\r\n              </span>\r\n          <span>\r\n                <a href=\"#!/debateHome\" class=\"footerLink\">Discuss|</a>\r\n              </span>\r\n          <span>\r\n                <a href=\"#!/learnHome\" class=\"footerLink\">Research |</a>\r\n              </span>\r\n          <span>\r\n                <a href=\"#!/alliesP\" class=\"footerLink\">Allies |</a>\r\n              </span>\r\n          <!-- ************* BRING BACK\r\n              <span>\r\n                <a href=\"#!/polCampaign\" class=\"footerLink\">Campaign |</a>\r\n              </span>\r\n-->\r\n          <span>\r\n                <a href=\"#!/liveFeed\" class=\"footerLink\">News</a>\r\n              </span>\r\n\r\n        </div>\r\n        <!-- FOR POLITICIANS BIG -->\r\n        <div class=\"d-none d-md-block\" ng-show=\"$root.userRole==\'politician\'\">\r\n           <span>\r\n                <a href=\"#!/gettingStartedPol\" class=\"footerLink\">Getting Started |</a>\r\n              </span>\r\n									          <span>\r\n                <a href=\"#!/fiveCompare/skip_to_result\" class=\"footerLink\">Skip to Election |</a>\r\n									</span>\r\n									<span>\r\n                <a href=\"#!/userProfile\" class=\"footerLink\">Profile |</a>\r\n              </span>\r\n          <span>\r\n                <a href=\"#!/winVoters\" class=\"footerLink\"> Win Voters |</a>\r\n              </span>\r\n          <span>\r\n                <a href=\"#!/debateHome\" class=\"footerLink\">Discuss|</a>\r\n              </span>\r\n          <span>\r\n                <a href=\"#!/learnHome\" class=\"footerLink\">Research |</a>\r\n              </span>\r\n          <span>\r\n                <a href=\"#!/alliesP\" class=\"footerLink\">Allies |</a>\r\n              </span>\r\n          <!--   ********** BRING BACK\r\n              <span>\r\n                <a href=\"#!/polCampaign\" class=\"footerLink\">Campaign |</a>\r\n              </span>\r\n-->\r\n\r\n          <span>\r\n                <a href=\"#!/liveFeed\" class=\"footerLink\">News</a>\r\n              </span>\r\n\r\n        </div>\r\n        <!-- FOR ADMIN SMALL -->\r\n        <div class=\"tinyPrint d-md-none\" ng-show=\"$root.userRole==\'admin\'\">\r\n          <span>\r\n                <a href=\"#!/questionHome\" class=\"footerLink\">Quiz |</a>\r\n              </span>\r\n																		<span>\r\n                <a href=\"#!/fiveCompare/skip_to_result\" class=\"footerLink\">Election |</a>\r\n									</span>\r\n          <span>\r\n                <a href=\"#!/learnHome\" class=\"footerLink\"> Learn |</a>\r\n              </span>\r\n          <span>\r\n                <a href=\"#!/debateHome\" class=\"footerLink\">Discuss |</a>\r\n              </span>\r\n          <span>\r\n                <a href=\"#!/incumbent_politician/politician\" class=\"footerLink\">Politicians |</a>\r\n              </span>\r\n          <span>\r\n                <a href=\"#!/advocateHome\" class=\"footerLink\">Orgs |</a>\r\n              </span>\r\n          <span>\r\n                <a href=\"#!/liveFeed\" class=\"footerLink\" class=\"footerLink\">News</a>\r\n              </span>\r\n\r\n        </div>\r\n        <!-- FOR ADMIN BIG -->\r\n        <div class=\"d-none d-md-block\" ng-show=\"$root.userRole==\'admin\'\">\r\n          <span>\r\n                <a href=\"#!/questionHome\" class=\"footerLink\">Match Quizzes |</a>\r\n              </span>\r\n									          <span>\r\n                <a href=\"#!/fiveCompare/skip_to_result\" class=\"footerLink\">Skip to Election |</a>\r\n									</span>\r\n          <span>\r\n                <a href=\"#!/learnHome\" class=\"footerLink\"> Learn |</a>\r\n              </span>\r\n          <span>\r\n                <a href=\"#!/debateHome\" class=\"footerLink\">Discuss |</a>\r\n              </span>\r\n          <span>\r\n                <a href=\"#!/incumbent_politician/politician\" class=\"footerLink\">Politicians |</a>\r\n              </span>\r\n          <span>\r\n                <a href=\"#!/advocateHome\" class=\"footerLink\">Organizations |</a>\r\n                <span>\r\n                  <a href=\"#!/gettingStartedPol\" class=\"footerLink\">| | Getting Started Pol |</a>\r\n                </span>\r\n          <span>\r\n                  <a href=\"#!/gettingStartedOrg\" class=\"footerLink\"> Getting Started Org |</a>\r\n                </span>\r\n          </span>\r\n          <span>\r\n                <a href=\"#!/dashboard\" class=\"footerLink\">| | Dashboard |</a>\r\n              </span>\r\n          <span>\r\n                <a href=\"#!/liveFeed\" class=\"footerLink\">News</a>\r\n              </span>\r\n\r\n        </div>\r\n\r\n      </nav>\r\n												<br><div class=\"desktop\" style=\"background-color:yellow; color:black\";><center><h1>WE ARE NOT COVERING ELECTIONS THIS YEAR. &nbsp; &nbsp; INFORMATION MAY BE OUT OF DATE.</h1></center></div>\r\n					<div class=\"cell\" style=\"background-color:yellow; color:black\";><center><b>WE ARE NOT COVERING ELECTIONS THIS YEAR.  &nbsp; &nbsp; INFORMATION MAY BE OUT OF DATE.</b></center></div>\r\n    </div>\r\n    </div>\r\n  </header>\r\n  <div growl></div>\r\n  <div ng-view style=\"width:95%;\" autoscroll=\"true\"></div>\r\n  <footer class=\"siteFooter\">\r\n    <div class=\"container-fluid container-fluidCustom\">\r\n      <div class=\"siteFooterContent\">\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-8 col-lg-10\">\r\n            <a href=\"#!/howToVideo\" class=\"footerLink\">HELP</a> |\r\n            <a href=\"#!/contactUs\" class=\"footerLink\">CONTACT US</a> |\r\n            <a href=\"#!/aboutUs\" class=\"footerLink\">ABOUT US</a> |\r\n            <a href=\"#!/faq\" class=\"footerLink\">FAQ\'s</a>\r\n          </div>\r\n          <div class=\"col-sm-6 col-lg-2\" style=\"text-align:center;\">\r\n            <a href=\"#!/donate\">\r\n                <button type=\"button\" class=\"donateBtn btn float-lg-right\">Donate</button>\r\n              </a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <br />\r\n      <div id=\"footerContact\">\r\n        <span>Email us at : email@votewise.net</span>\r\n        <br />\r\n        <span>Call 70-VoteWise (708)683-9473</span>\r\n        <div id=\"footerLogo\" class=\"text-center\">\r\n          <img src=\"assets/images/votewiselogoOffWhite.svg\" class=\"img-fluid\">\r\n          <p>Copyright &copy; VoteWise.net 2018. All Rights Reserved</p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </footer>\r\n  <!-- Login Confirmation Modal-->\r\n  <div class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" id=\"loginConfirmModal\">\r\n    <div class=\"modal-dialog modal-dialog-centered\" role=\"document\">\r\n      <div class=\"modal-content\" style=\"color:#000\">\r\n        <div class=\"modal-header\">\r\n          <h5 class=\"modal-title\">Login Required</h5>\r\n          <!-- <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\r\n              <span aria-hidden=\"true\">&times;</span>\r\n            </button> -->\r\n        </div>\r\n        <div class=\"modal-body\" style=\"font-size:20px\">\r\n          <p style=\"padding-left:10px\">This feature requires login. Do you want to login/sign up?</p>\r\n        </div>\r\n        <div class=\"modal-footer\">\r\n          <button type=\"button\" class=\"btn2 btn-primary\" ng-click=\"$root.logoutConfirmed(true)\">Yes</button>\r\n          <button type=\"button\" class=\"btn2 btn-secondary\" ng-click=\"$root.dismissLoginConfirmation()\">No</button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <!--</script>  -->\r\n  <script type=\"text/javascript\" src=\"//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit\">\r\n  </script>\r\n\r\n  <!-- <script src=\"https://unpkg.com/masonry-layout@4/dist/masonry.pkgd.js\"></script> -->\r\n  <!-- <script src=\"assets/js/masonry.pkgd.js\"></script> -->\r\n  <!-- <script src=\"/path/to/masonry.pkgd.min.js\"></script> -->\r\n  <script src=\"https://www.youtube.com/iframe_api\" async defer></script>\r\n  <!-- google api for autocomplete text -->\r\n  <script src=\"https://maps.googleapis.com/maps/api/js?key=AIzaSyD1oCVshO67SnASsVVvOoJiAQgl7PvOmxo&libraries=places\"\r\n    async defer></script>\r\n\r\n\r\n  <!-- for stripe -->\r\n  <!-- //for stripe -->\r\n  <!-- build:js({.tmp,src}) scripts/vendor.js -->\r\n  <!-- bower:js -->\r\n  <!-- run `gulp inject` to automatically populate bower script dependencies -->\r\n  <!-- endbower -->\r\n  <!-- endbuild -->\r\n  <!-- build:js({.tmp,src}) scripts/app.js -->\r\n  <!-- inject:js -->\r\n  <!-- js files will be automatically insert here -->\r\n  <!-- endinject -->\r\n  <!-- inject:partials -->\r\n  <!-- angular templates will be automatically converted in js and inserted here -->\r\n  <!-- endinject -->\r\n  <!-- endbuild -->\r\n  <!-- In production use:\r\n    <script src=\"//ajax.googleapis.com/ajax/libs/angularjs/x.x.x/angular.min.js\"></script>\r\n    -->\r\n  <!-- <script type=\"text/javascript\" src=\"bower_components/tinymce-dist/tinymce.js\"></script>\r\n    <script type=\"text/javascript\" src=\"bower_components/angular/angular.js\"></script>\r\n    <script type=\"text/javascript\" src=\"bower_components/angular-cookies/angular-cookies.js\"></script>\r\n    <script type=\"text/javascript\" src=\"bower_components/angular-ui-tinymce/dist/tinymce.min.js\"></script>\r\n    <script type=\"text/javascript\" src=\"bower_components/angular-ui-tinymce/src/tinymce.js\"></script>\r\n    <script type=\"text/javascript\" src=\"bower_components/tinymce/tinymce.min.js\"></script>\r\n    <script src=\"bower_components/chart.js/dist/Chart.min.js\"></script>\r\n    <script src=\"bower_components/angular-chart.js/dist/angular-chart.min.js\"></script>\r\n    <script src=\"bower_components/angular-route/angular-route.js\"></script>\r\n  <script src=\"bower_components/fuse.js/dist/fuse.js\"></script>\r\n\r\n\r\n  <script type=\"text/javascript\" src=\"bower_components/angular-payments/lib/angular-payments.js\">\r\n  </script>\r\n\r\n\r\n  <script src=\"bower_components/angular-youtube-mb/dist/angular-youtube-embed.js\"></script>\r\n  <script src=\"bower_components/ng-dialog/js/ngDialog.js\"></script>\r\n  <script src=\"bower_components/angular-dragdrop/src/angular-dragdrop.min.js\"></script>\r\n  <script src=\"bower_components/angular-mass-autocomplete/massautocomplete.js\"></script>\r\n  <script src=\"bower_components/angular-input-stars-directive/angular-input-stars.js\"></script>\r\n  <script src=\"bower_components/angularUtils-pagination/dirPagination.js\"></script>\r\n  <script src=\"bower_components/ng-idle/angular-idle.min.js\"></script> -->\r\n  <!-- <link href=\"assets/growl/angular-growl.css\" rel=\"stylesheet\" />\r\n    <script src=\"assets/growl/angular-growl.js\"></script> -->\r\n  <!-- <script src=\"bower_components/ngInfiniteScroll/build/ng-infinite-scroll.js\"></script> -->\r\n  <!--  <script src=\"lib/infinite-scroll.js\"></script>\r\n    <script src=\"lib/angular-toggle-switch.min.js\"></script>\r\n    <script src=\"app.js\"></script>\r\n    <script src=\"directives.js\"></script>\r\n    <script src=\"service.js\"></script>\r\n    <script src=\"questionHome/questionHome.js\"></script>\r\n    <script src=\"questionSubcategories/questionSubcategories.js\"></script>\r\n    <script src=\"question/question.js\"></script>\r\n    <script src=\"howToVideo/howToVideo.js\"></script>\r\n    <script src=\"welcomeView/welcomeView.js\"></script>\r\n    <script src=\"voterSignup/voterSignup.js\"></script>\r\n    <script src=\"signup/signup.js\"></script>\r\n    <script src=\"debateHome/debateHome.js\"></script>\r\n    <script src=\"essay/essay.js\"></script>\r\n    <script src=\"essay_press/essay.js\"></script>\r\n    <script src=\"essayUpdate/essayUpdate.js\"></script>\r\n    <script src=\"pressEssayUpdate/essayUpdate.js\"></script>\r\n    <script src=\"essayDetails/essayDetails.js\"></script>\r\n    <script src=\"pressEssayDetails/essayDetails.js\"></script>\r\n    <script src=\"essayList/essayList.js\"></script>\r\n    <script src=\"essayStaff/essayStaff.js\"></script>\r\n    <script src=\"pressEssayStaff/essayStaff.js\"></script>\r\n    <script src=\"newEssay/newEssay.js\"></script>\r\n    <script src=\"newPressEssay/newEssay.js\"></script>\r\n    <script src=\"essaySearch/essaySearch.js\"></script>\r\n    <script src=\"forum/forum.js\"></script>\r\n    <script src=\"forumthread/forumthread.js\"></script>\r\n    <script src=\"forumReply/forumReply.js\"></script>\r\n    <script src=\"forumList/forumList.js\"></script>\r\n    <script src=\"politician_thread/politician_thread.js\"></script>\r\n    <script src=\"forumSearch/forumSearch.js\"></script>\r\n    <script src=\"updateTopic/updateTopic.js\"></script>\r\n    <script src=\"publicProfile/publicProfile.js\"></script>\r\n    <script src=\"topic/topic.js\"></script>\r\n    <script src=\"learnHome/learnHome.js\"></script>\r\n    <script src=\"advocateSignup/advocateSignup.js\"></script>\r\n    <script src=\"localDebate/localDebate.js\"></script>\r\n    <script src=\"pressProfile/pressProfile.js\"></script>\r\n    <script src=\"pressComment/pressComment.js\"></script>\r\n    <script src=\"localPress/localPress.js\"></script>\r\n    <script src=\"signin/signin.js\"></script>\r\n    <script src=\"pressHome/pressHome.js\"></script>\r\n    <script src=\"liveFeed/liveFeed.js\"></script>\r\n    <script src=\"politicianSignup/politicianSignup.js\"></script>\r\n    <script src=\"advocateHome/advocateHome.js\"></script>\r\n    <script src=\"compare_select/compare_select.js\"></script>\r\n    <script src=\"compare_subject/compare_subject.js\"></script>\r\n    <script src=\"compare_subcategories/compare_subcategories.js\"></script>\r\n    <script src=\"snapshot/snapshot.js\"></script>\r\n    <script src=\"dashboard/dashboard.js\"></script>\r\n    <script src=\"reports/reports.js\"></script>\r\n    <script src=\"match/match.js\"></script>\r\n    <script src=\"contactUs/contactUs.js\"></script>\r\n    <script src=\"faq/faq.js\"></script>\r\n    <script src=\"donate/donate.js\"></script>\r\n    <script src=\"speakOut/speakOut.js\"></script>\r\n    <script src=\"commonPhrases/commonPhrases.js\"></script>\r\n    <script src=\"components/version/version.js\"></script>\r\n    <script src=\"components/version/version-directive.js\"></script>\r\n    <script src=\"components/version/interpolate-filter.js\"></script>\r\n    <script src=\"gettingStartedOrg/gettingStartedOrg.js\"></script>\r\n    <script src=\"signup/verify-email.js\"></script>\r\n    <script src=\"email_unsubscribe/email_unsubscribe.js\"></script>\r\n    <script src=\"forgot-password/forgot-password.js\"></script>\r\n    <script src=\"printUsers/printUsers.js\"></script>\r\n    <script src=\"gettingStartedPol/gettingStartedPol.js\"></script>\r\n    <script src=\"boardsofelections/boardsofelections.js\"></script>\r\n    <script src=\"legislation/legislation.js\"></script>\r\n    <script src=\"orgProfile/orgProfile.js\"></script>\r\n    <script src=\"geoCode/geoCode.js\"></script>\r\n    <script src=\"polProfile/polProfile.js\"></script>\r\n    <script src=\"polProfileSetUp/polProfileSetUp.js\"></script>\r\n    <script src=\"winVoters/winVoters.js\"></script>\r\n    <script src=\"polFinance/polFinance.js\"></script>\r\n    <script src=\"allRatings/allRatings.js\"></script>\r\n    <script src=\"compareRatings/compareRatings.js\"></script>\r\n    <script src=\"ratingsDetails/ratingsDetails.js\"></script>\r\n    <script src=\"research/research.js\"></script>\r\n<script src=\"checkRegistration/checkRegistration.js\"></script>\r\n<script src=\"registerToVote/registerToVote.js\"></script>\r\n<script src=\"getAReminder/getAReminder.js\"></script>\r\n<script src=\"absenteeBallots/absenteeBallots.js\"></script>\r\n    <script src=\"aboutUs/aboutUs.js\"></script>\r\n    <script src=\"electionProblems/electionProblems.js\"></script>\r\n    <script src=\"voteSmart/votesmart.js\"></script>\r\n    <script src=\"allies/allies.js\"></script>\r\n<script src=\"upcomingElection/upcomingElection.js\"</script>\r\n<script src=\"takeAction/takeAction.js\"</script>\r\n<script src=\"whatAmILookingAt1/whatAmILookingAt1.js\"</script>\r\n<script src=\"whatAmILookingAt2/whatAmILookingAt2.js\"</script>\r\n<script src=\"whatAmILookingAt3/whatAmILookingAt3.js\"</script>\r\n<script src=\"whatAmILookingAt4/whatAmILookingAt4.js\"</script>\r\n<script src=\"theConstitution/theConstitution.js\"></script>\r\n<script src=\"//ajax.googleapis.com/ajax/libs/angularjs/1.4.2/angular.min.js\"></script>\r\n<script src=\"bower_components/ngtweet/dist/ngtweet.min.js\"></script>-->\r\n  <!-- popups -->\r\n  <!-- <script src=\"popup_ctrl/user_localupdate.js\"></script> -->\r\n  <!-- Google Analytics-->\r\n  <script>\r\n    window.fbAsyncInit = function () {\r\n      FB.init({\r\n        appId: \'141210366313012\', //848697741932678, \'848697741932678 \',//671848099633283,//141210366313012\r\n        cookie: true, // enable cookies to allow the server to access // test app 372276370040161\r\n        // the session // this is the id of the test app created by the spencer 723630358083200\r\n        //live 141210366313012\r\n\r\n        xfbml: true, // parse social plugins on this page\r\n        version: \'v4.0\' // use graph api version 2.5\r\n      });\r\n      //FB.getLoginStatus(function(response) {\r\n      //    statusChangeCallback(response);\r\n      //});\r\n    };\r\n    // Load the SDK asynchronously\r\n    (function (d, s, id) {\r\n      var js, fjs = d.getElementsByTagName(s)[0];\r\n      if (d.getElementById(id)) return;\r\n      js = d.createElement(s);\r\n      js.id = id;\r\n      js.src = \"//connect.facebook.net/en_US/sdk.js\";\r\n      fjs.parentNode.insertBefore(js, fjs);\r\n    }(document, \'script\', \'facebook-jssdk\'));\r\n    (function (i, s, o, g, r, a, m) {\r\n      i[\'GoogleAnalyticsObject\'] = r;\r\n      i[r] = i[r] || function () {\r\n        (i[r].q = i[r].q || []).push(arguments)\r\n      }, i[r].l = 1 * new Date();\r\n      a = s.createElement(o),\r\n        m = s.getElementsByTagName(o)[0];\r\n      a.async = 1;\r\n      a.src = g;\r\n      m.parentNode.insertBefore(a, m)\r\n    })(window, document, \'script\', \'https://www.google-analytics.com/analytics.js\', \'ga\');\r\n    //ga(\'create\', \'UA-77445212-1\', \'auto\');\r\n    //ga(\'send\', \'pageview\');\r\n    // Collapse menu after click\r\n    $(\'.navbar-nav>li>a\').on(\'click\', function () {\r\n      $(\'.navbar-collapse\').collapse(\'hide\');\r\n    });\r\n    $(window).on(\"scroll\", function () {\r\n      if ($(window).scrollTop() > 5) {\r\n        $(\".header\").addClass(\"activeHeader\");\r\n      } else {\r\n        //remove the background property so it comes transparent again (defined in your css)\r\n        $(\".header\").removeClass(\"activeHeader\");\r\n      }\r\n    });\r\n    $(document).ready(function () {\r\n      setTimeout(function () {\r\n        // console.log(\"apply\");\r\n        $(\".main-table\").clone(true).appendTo(\'.table-scroll\').addClass(\'clone\');\r\n      }, 2000);\r\n    });\r\n    /*$(window).scroll(function(){\r\n      console.log(\"scroll\");\r\n      if($(window).scrollTop() + $(window).height() == $(document).height()) {\r\n           alert(\"bottom!\");\r\n           $(\"#social-float\").css(\"margin-top\",Math.max(-250,0-$(this).scrollTop()));\r\n       }\r\n    });*/\r\n\r\n  </script>\r\n  <img class=\"votewise\" title=\"Home\" src=\"/assets/images/VoteWiseLogo.jpg\" alt=\"Home Page\" style=\"display:none;\" />\r\n  <img class=\"votewise\" title=\"Home\" src=\"https://votewise.net/assets/images/VoteWiseLogo.jpg\" alt=\"Home Page\" style=\"display:none;\"\r\n    />\r\n  <script src=\"https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.12.9/umd/popper.min.js\"\r\n    integrity=\"sha384-ApNbgh9B+Y1QKtv3Rn7W3mgPxhU9K/ScQsAP7hUibX39j7fakFPskvXusvfa0b4Q\" crossorigin=\"anonymous\">\r\n    </script>\r\n  <script src=\"https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/js/bootstrap.min.js\"\r\n    integrity=\"sha384-JZR6Spejh4U02d8jOt6vLEHfe/JQGiRRSQQxSfFWpi1MquVdAyjUar5+76PVCmYl\" crossorigin=\"anonymous\" async\r\n    defer>\r\n    </script>\r\n  <!-- commented out by vishal for optimization on 9th january 2019 -->\r\n  <script type=\"text/javascript\" src=\"https://js.stripe.com/v2/\" async defer></script>\r\n  <!-- <script src=\"http://ajax.aspnetcdn.com/ajax/jquery.validate/1.11.1/jquery.validate.min.js\"></script>\r\n\r\n</body>\r\n\r\n</html>\r\n");
$templateCache.put("app/501c4Video/501c4Video.html","\r\n<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">501.C.4</h2>\r\n  <p class=\"pageSubHeading\"></p>\r\n 									<style>\r\n.iframe-container {\r\n  overflow: hidden;\r\n  padding-top: 56.25%;\r\n  position: relative;\r\n	top: -10%;\r\n}\r\n \r\n.iframe-container iframe {\r\n   border: 0;\r\n   height: 100%;\r\n   left: 0;\r\n   position: absolute;\r\n   top: 0;\r\n   width: 100%;\r\n	max-height: 400px;\r\n}\r\n											.fgtrh-container iframe{\r\n												left: 0;\r\n												top: 250px;\r\n												position:absolute;\r\n												height:50%;\r\n												width:50%;\r\n											}\r\n/* 4x3 Aspect Ratio */\r\n.iframe-container-4x3 {\r\n  padding-top: 75%;\r\n}</style>\r\n\r\n<div class=\"iframe-container\">\r\n  <iframe src=\"https://player.vimeo.com/video/393039969\" allowfullscreen></iframe>\r\n</div>\r\n <!--  \r\n    <center>\r\n<div class=\"fgtrh-container\">\r\n  <iframe src=\"https://player.vimeo.com/video/393039969\" allowfullscreen></iframe>\r\n									</div></center>	\r\n<!--\r\n  <div class=\"row d-flex justify-content-center\">\r\n    <div class=\"col col-lg-12 col-med-12 col-sm-12 col-12\">\r\n      <div class=\"row\">\r\n							<br>\r\n        <center>\r\n<div class=\"iframe-container\">\r\n  <iframe src=\"https://player.vimeo.com/video/393039969\" allowfullscreen></iframe>\r\n									</div><p>dog</p> </center>	");
$templateCache.put("app/aboutUs/aboutUs.html","\r\n<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">ABOUT US</h2>\r\n  <p class=\"pageSubHeading\"></p>\r\n    \r\n \r\n\r\n  <div class=\"row d-flex justify-content-center\">\r\n    <div class=\"col col-lg-12 col-med-12 col-sm-12 col-12\">\r\n      <div class=\"row\">\r\n        <center><div class=\"col-lg-12 col-sm-12 contactBlock\">\r\n            <br>\r\n              <h4 class=\"blockTitleLearn\"> What is VoteWise?</h4>\r\n            <div style=\"text-align: left;\"><p>\r\n      VoteWise.net is a non-partisan non-profit tool aimed at repairing democracy by connecting voters, politicians and organizations without advertising dollars getting in the way.  Our goal is to make elections more democratic and to make year-round problem solving easier and more effective.</p>\r\n               \r\n         <p>Google, Facebook, and Amazon used massive data collection to revolutionize your commercial and social experiences.  We intend to do the same for democracy and community development by collecting and sharing voluntary info with other organizations who are trying to help people in your community.</p>\r\n                <p>There are different tools available to different types of users, so click on a user type below, watch the 2 minute video and start saving the world.</p>\r\n                  <center>\r\n      <a href=\"#!/signup/voter\">\r\n        <button class=\"compareBtn\">\r\n          <b>Sign Up</b>\r\n        </button>\r\n      </a>\r\n    </center>\r\n              \r\n            </div></div></center>\r\n    <center> \r\n          <iframe id=videoblock2 width=\"345\" height=\"194\" src=\"https://www.youtube.com/embed/HrZqeFsbQZk?rel=0\" frameborder=\"0\" allowfullscreen></iframe>\r\n          <iframe id=videoblock2 width=\"345\" height=\"194\" src=\"https://www.youtube.com/embed/Yx33ZVgs4xo?rel=0\" frameborder=\"0\" allowfullscreen></iframe>\r\n        <iframe id=videoblock2 width=\"345\" height=\"194\" src=\"https://www.youtube.com/embed/S1copOipUxY?rel=0\" frameborder=\"0\" allowfullscreen></iframe>\r\n</center>\r\n    \r\n    <!--<fb:login-button scope=\"public_profile,email\" onlogin=\"checkLoginState();\">\r\n        </fb:login-button>-->\r\n \r\n          \r\n<br><br>\r\n         \r\n        <center><div class=\"col-lg-12 col-sm-12 contactBlock\"><br>\r\n              <h4 class=\"blockTitleLearn\"> Our Mission:</h4>\r\n <div style=\"text-align: left;\">\r\n<p>In life, you can vote with wallet, with your voice, with your actions and at the ballot box.  But it\'s important to always vote wisely.</p>\r\n      <p>\r\nVoteWise is dedicated to teaching people about the issues and giving them the tools to take whatever actions they feel best to make the world a better place.  We are non-profit, non-partisan, and absolutely free.\r\n</p> \r\n<p>\r\n    <b>With VoteWise, you can:</b> <ul><li>Take quizzes that tell politicians how they should vote</li><li>Get matched up with politicians and organizations that can help you make a difference</li><li>Discuss the issues with people in your town or across the globe</li> <li>Read about the issues straight from the organizations that are fighting hard every day to make the world a better place </li> <li>Choose from a thousand different news sources to get details on events around the world and in your home town.</li> </ul> <p> \r\n    \r\n   <b>Real change, if it expects to work and thrive,</b> requires wisdom that can only be gained from gathering together voters, politicians, press and organizations dedicated to making a difference.  All sides of the argument need to be heard in order to find common ground.  VoteWise is set up as a tool to make that happen. It’s up to you to play your part.</p>\r\n<p><b>Find out about the issues that face your community and see what you can do about it by signing up.</b></p></div>\r\n    <center>\r\n      <a href=\"#!/signup/voter\">\r\n        <button class=\"compareBtn\">\r\n          <b>Sign Up</b>\r\n        </button>\r\n      </a>\r\n    </center>\r\n\r\n<div><br><hr>\r\n              <h4 class=\"blockTitleLearn\"> MORE</h4>\r\n<br><div style=\"text-align: left;\">\r\n<p><b>VoteWise.net</b> is a non-partisan website aimed at connecting voters and politicians without advertising dollars getting in the way.    It was built by Silent Monkeys Inc, a 501 (c)(3) non-profit based in Allentown, PA.  </p>\r\n<p>It is the civic duty of all voters to choose representatives that best suit their visions of the future.  Likewise, it is the duty of politicians to help their community to the best of their ability.  Unfortunately, it has become increasingly difficult for both voters and politicians to do their jobs. So we created tools to make this process work better. Not all problems are best solved through legislation, so we also do our best to make community action easier as well.</p>\r\n<p>Until now, politicians have had no easy way of reaching massive voters without advertising. This means that politicians had to waste a lot of time begging for money instead of doing what they are hired to do – help the community. This often forces politicians to listen more closely to the people who give them money than they do to the voters. Sometimes it means that the people who pay for the advertising effectively pre-select the candidates for us. So, instead of getting politicians that we want, we often get politicians that deep pockets want.  This is not a great way to run a democracy.  Politics should be about ideas, not dollars.</p>\r\n<p>At the same time, we are entering an age where people aren’t discussing local issues – despite the fact that they have the most immediate impact on their lives – crime, traffic, noise, parks, schools, litter, local availability of the things that make you happy.  And why is this?  It’s because we have become a commuter nation.  We might commute half an hour or more to our job, where we meet people who commute the same or even longer distances from the opposite direction.  We don’t have anything in common to talk about other than national issues.  Then we go home and rather than sit on the porch and talk to our neighbors (who are constantly moving jobs and locations), we sit inside and enjoy the air conditioning and electronic entertainment.  So, we never have an opportunity to talk about local issues.  And because of this, local papers are dying left and right, making it impossible to make informed decisions about local elections.  We are creating tools to combat this.  First, there’s the Press tool, which (when it is completed) will help you find online material from local papers, and then the Debate/Chat tool which allows you to find people in your local community to discuss the issues (as opposed to other chat rooms that don’t differentiate between New York City and Toledo, Ohio. )  And of course, you can use these same tools to find national and international news and discuss issues with people across the globe.</p>\r\n<p>When we discuss making the world a better place, we must also realize that some of the biggest changes have nothing to do with laws or politics at all.  They have to do with getting involved directly.  For this, there is nothing better than advocacy organizations that dedicate themselves to whatever cause they believe in.  VoteWise gives a voice to these organizations so you can learn about their issues without any filter between you and them.  If you like what they stand for, you can contact them and get involved directly too.</p>\r\n<p>According to a 2006 Pew Research poll, almost half of eligible voters say they don’t vote regularly because they don’t know enough about the candidates.  VoteWise could fix that because all the information is easily accessible in one place with great detail.  Voters will no longer have to follow the drama created by media over months and months.  They won’t have to decipher politically evasive language.  And they won\'t have to vote blindly along party lines.</p>\r\n\r\n<p>A successful democracy relies upon an informed electorate.  VoteWise gives this to you absolutely free.  We bring the “Free” back to “Free Speech.”</p>\r\n\r\n        <br>\r\n              <h4 class=\"blockTitleLearn\">STAFF</h4>\r\n             \r\n<br>\r\n<p>So who are these people making VoteWise?  It has mostly been volunteers over the last ten years with small donations here and there to fix problems that hard work alone couldn’t fix.</p>\r\n<p>Among the people contributing their work, their wisdom, or other assets to the success of this site are:\r\nSpencer Snygg, Vishal Prajapati, Sharon Trimble, James Foley, Matias Salas, Code for Philly, Chris Alfano, Jeremy Sawruck, Matt Solt, AJ Bisson, Marino Hernandez, Rahul Bansode, Yogesh Patel, Gabrielle Patterson, Alec Newman, Kyle Permuy, Pankaj Patil, Damien Touchette, Peter Timpone,Garret James, Ryan Smith, Ellis Farmer, Adrian Shankar, Dorothy Larew, Philip Gaziano, and hundreds of other people who did countless things along the way to make this possible.</p>\r\n            </div>\r\n<script type=\"text/javascript\">\r\n    jQuery(document).ready(function () {");
$templateCache.put("app/absenteeBallots/absenteeBallots.html","<div class=\"container-fluid\">\r\n     <h2 class=\"pageHeading\">ABSENTEE BALLOTS</h2>\r\n  <p class=\"pageSubHeading\">Use the form below to request an absentee ballot if you don\'t think you\'ll be able to physically get to the polls on election day.  Every locality is different, so make sure to order your ballot well in advance.  This tool was created by Vote.org (unrelated to VoteWise)</p>\r\n  <iframe src=\"https://absentee.vote.org/?partner=111111&campaign=free-tools\" width=\"100%\" height=\"1200\" marginheight=\"0\" frameborder=\"0\" id=\"frame2\" scrollable=\"no\"></iframe><script type=\"text/javascript\" src=\"//cdnjs.cloudflare.com/ajax/libs/iframe-resizer/3.5.3/iframeResizer.min.js\"></script><script type=\"text/javascript\">iFrameResize({ log:true, checkOrigin:false});</script>");
$templateCache.put("app/addCategory/addCategory.html","<div class=\"container-fluid ng-scope\" ng-cloak ng-show=\"$root.userRole==\'admin\'\">\r\n  <h2 class=\"pageHeading\">Settings</h2>\r\n  <div>\r\n    <div class=\"closeForm\" ng-include=\"\'app/popups/setting_Ctrl.html\'\"></div>\r\n\r\n  </div>\r\n  <form ng-show=\"showAddCategories\" name=\"signupform\" id=\"signInform\" class=\"closeForm\">\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Add category</legend>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel removeTopMargin\" for=\"category-title\">Title</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"category.title\" class=\"form-control input-md text-input\">\r\n            </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\" for=\"description\">Description (displayed as \'Background Text\')</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"category.description\" class=\"form-control input-md text-input\">\r\n            </div>\r\n              </div>\r\n              <br>\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel removeTopMargin\">View order(Applicable only if it\'s root category): </label>\r\n                <div class=\"controls\">\r\n                  <input type=\"number\" ng-model=\"category.viewOrder\" min=\"0\" class=\"form-control input-md text-input\">\r\n            </div>\r\n                </div>\r\n                <br>\r\n                <div class=\"control-group\" ng-init=\"category.catType = [];\">\r\n                  <label class=\"control-label formLabel removeTopMargin\">Category Type: </label>\r\n                  <div class=\"controls\">\r\n                    <!-- ng-options=\"item as item.lbl for item in items\" -->\r\n                    <!-- <select ng-model=\"category.catType\" multiple>\r\n                                            <option ng-repeat=\"item in cattypes\" value=\"{{item.val}}\">{{item.lbl}}</option>\r\n                                        </select> -->\r\n                    <label ng-repeat=\"item in cattypes\">\r\n                <input type=\"checkbox\" ng-model=\"item.selected\"> {{item.lbl}} &nbsp; &nbsp;\r\n              </label>\r\n                    <br>\r\n            </div>\r\n                  </div>\r\n                  <br>\r\n                  <div class=\"control-group\">\r\n                    <label class=\"control-label formLabel removeTopMargin\" for=\"category-title\">Image icon</label>\r\n                    <div class=\"controls\">\r\n                      <input type=\"file\" file-model=\"category.files\" class=\"form-control input-md text-input\" accept=\"image/x-png, image/gif, image/jpeg, image/jpeg, image/svg+xml\">\r\n            </div>\r\n                    </div>\r\n                  </div>\r\n                  <!--\r\n                            <div class=\"clearfix\">\r\n                                <p>Parent category (to make this parent don\'t select any category): </p>\r\n                                <ul style=\"list-style: none;\">\r\n                                    <li ng-repeat=\"cat in parentCategories\">\r\n                                        <label>\r\n                                          <input type=\"checkbox\" ng-click=\"toggleCategorySelection(cat)\" ng-checked=\"category.parentIds.indexOf(cat) > -1\" value=\"{{cat._id}}\" > {{cat.title}}\r\n                                        </label>\r\n                                        <div ng-if=\"cat.subcategory.length > 0\">\r\n                                            All available sub-category under this category:\r\n                                            <br>\r\n                                            View order | title\r\n                                            <div ng-repeat=\"c in cat.subcategory\">\r\n                                                <b>{{c.order}}</b> | {{c.title}}\r\n                                            </div>\r\n                                            <br>\r\n                                        </div>\r\n                                    </li>\r\n                                </ul>\r\n                            </div>\r\n                            -->\r\n                  <p>Parent category (to make this \'root\' category don\'t select any category): </p>\r\n                  <p ng-if=\"statusGetCats == 1\" class=\"fwb\">Loading categories ...</p>\r\n                  <div class=\"clearfix\" ng-repeat=\"pitem in allParentCats\">\r\n                    <div ng-repeat=\"cat in pitem\" class=\"pull-left\" style=\"padding: 5px;\">\r\n                      <select class=\"pull-left changeTextColor\" ng-model=\"cat[\'selected\']\" ng-change=\"toogleAddCatSel(cat[\'selected\'], $index, $parent.$index)\">\r\n              <option ng-repeat=\"item in cat.items\" value=\"{{item}}\">\r\n                {{item.order}}) {{item.title}}\r\n              </option>\r\n            </select>\r\n                      >\r\n                      <input class=\"pull-left changeTextColor\" type=\"number\" ng-model=\"cat[\'viewOrders\']\" ng-disabled=\"!cat[\'selected\'] || pitem[$index+1][\'selected\']\" style=\"max-width: 50px;\">\r\n          </div>\r\n                      <button ng-if=\"allParentCats.length > 1\" ng-click=\"removeParent($index)\" class=\"link changeTextColor\">\r\n            Remove\r\n          </button>\r\n                      <hr class=\"w100 pull-left\">\r\n                    </div>\r\n                    <div class=\"clearfix w100\">\r\n                      <button ng-click=\"addOneMoreParent()\" class=\"changeTextColor\">\r\n            Add one more parent\r\n          </button>\r\n                    </div>\r\n                    <div class=\"clearfix\" ng-show=\"category.parentIds.length > 0\">\r\n                      <p>Parent category: </p>\r\n                      <ul style=\"list-style: none;\">\r\n                        <li ng-repeat=\"cat in category.parentIds\">\r\n                          <label ng-init=\"cat.viewOrders = 0;\">\r\n                View order in\"{{cat.title}}\"\"\r\n                <input type=\"number\" ng-model=\"cat.viewOrders\" min=\"0\">\r\n              </label>\r\n                        </li>\r\n                      </ul>\r\n                    </div>\r\n                    <div style=\"clear: both;\"></div>\r\n                    <div class=\"forgetPassButtons\">\r\n                      <button ng-click=\"addCategory()\" type=\"submit\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n                      <!--<fb:login-button scope=\"public_profile,email\" onlogin=\"checkLoginState();\">\r\n                                </fb:login-button>-->\r\n                      <div style=\"clear: both;\"></div>\r\n                    </div>\r\n                    <div style=\"clear: both;\"></div>\r\n                  </div>\r\n    </fieldset>\r\n  </form>\r\n  <!-- Update category -->\r\n  <form ng-show=\"showUpdateCategories\" name=\"signupform\" id=\"signInform\" class=\"closeForm\">\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Update category</legend>\r\n      <div class=\"row\">\r\n        <div class=\"clearfix\">\r\n          <p>Select category to update: </p>\r\n          <div ng-repeat=\"cat in selCatForCatUpdate\" class=\"pull-left\" style=\"padding: 5px;\">\r\n            <select class=\"pull-left changeTextColor\" ng-model=\"cat[\'selected\']\" ng-change=\"toggleUpdateCatSel(cat[\'selected\'], $index)\">\r\n              <option ng-repeat=\"item in cat.items\" value=\"{{item}}\">\r\n                {{item.order}}) {{item.title}}\r\n              </option>\r\n            </select>\r\n            >\r\n            <input ng-hide=\"selCatForCatUpdate[$index+1].selected\" class=\"pull-left changeTextColor\" type=\"number\" ng-model=\"cat[\'viewOrders\']\" ng-disabled=\"!cat[\'selected\']\" style=\"max-width: 50px;\">\r\n          </div>\r\n          </div>\r\n          <div class=\"col-md-12\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\" for=\"updateCat-title\">Title</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"updateCat.title\" class=\"form-control input-md text-input\">\r\n            </div>\r\n              </div>\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel\" for=\"description\">Description (displayed as \'Background Text\')</label>\r\n                <div class=\"controls\">\r\n                  <textarea class=\"w100 changeTextColor\" ng-model=\"updateCat.description\">\r\n                    </textarea>\r\n                  <!-- <input type=\"text\"  class=\"form-control input-md text-input\"> -->\r\n                </div>\r\n              </div>\r\n              <br>\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel removeTopMargin\">View order(Applicable only if it\'s root category): </label>\r\n                <div class=\"controls\">\r\n                  <input type=\"number\" ng-model=\"updateCat.viewOrder\" min=\"0\" class=\"form-control input-md text-input\">\r\n            </div>\r\n                </div>\r\n                <br>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel removeTopMargin\">Category Type: </label>\r\n                  <div class=\"controls\" ng-init=\"updateCat.catType = [];\">\r\n                    <!-- <select ng-model=\"updateCat.catType\">\r\n                                            <option ng-repeat=\"item in cattypes\" value=\"{{item.val}}\">{{item.lbl}}</option>\r\n                                        </select> -->\r\n                    <label ng-repeat=\"item in updateCatTypes\">\r\n                <input type=\"checkbox\" ng-model=\"item.selected\"> {{item.lbl}}\r\n              </label>\r\n                    <br>\r\n            </div>\r\n                  </div>\r\n                  <br>\r\n                  <div class=\"control-group\">\r\n                    <label class=\"control-label formLabel removeTopMargin\" for=\"category-title\">Image icon</label>\r\n                    <!-- <img class=\"allTopics\" ng-src=\"{{$root.imgUrl}}/{{item.iconImage}}\" alt=\"{{item.title}}\"> -->\r\n                    <span once-text=\"updateCat,iconImage\"></span>\r\n                    <div class=\"controls\">\r\n                      <input type=\"file\" file-model=\"updateCat.files\" class=\"form-control input-md text-input\" accept=\"image/x-png, image/gif, image/jpeg, image/jpeg, image/svg+xml\">\r\n            </div>\r\n                    </div>\r\n                    <br>\r\n                    <div class=\"control-group\">\r\n                      <label class=\"control-label formLabel removeTopMargin\" for=\"updateCat-fbtitle\">Facebook Title</label>\r\n                      <div class=\"controls\">\r\n                        <input type=\"text\" ng-model=\"updateCat.fbtitle\" class=\"form-control input-md text-input\">\r\n            </div>\r\n                      </div>\r\n                      <br>\r\n                      <div class=\"control-group\">\r\n                        <label class=\"control-label formLabel removeTopMargin\" for=\"fbdescription\">Facebook Description</label>\r\n                        <div class=\"controls\">\r\n                          <textarea class=\"w100 changeTextColor\" ng-model=\"updateCat.fbdescription\">\r\n                    </textarea>\r\n                          <!-- <input type=\"text\"  class=\"form-control input-md text-input\"> -->\r\n                        </div>\r\n                      </div>\r\n                      <div class=\"control-group\">\r\n                        <img ng-src=\"https://api.votewise.net/resources/{{updateCat.fbimage}}\" width=\"300\" ng-if=\"updateCat.fbimage\">\r\n                        <br />\r\n                        <label class=\"control-label formLabel removeTopMargin\" for=\"facebook-image\">Facebook Image</label>\r\n                        <!-- <img class=\"subjects\" ng-src=\"{{$root.imgUrl}}/{{item.iconImage}}\" alt=\"{{item.title}}\"> -->\r\n                        <span once-text=\"updateCat.fbimage\"></span>\r\n                        <div class=\"controls\">\r\n                          <input type=\"file\" file-model=\"updateCat.fbimage\" class=\"form-control input-md text-input\" accept=\"image/x-png, image/gif, image/jpeg, image/jpeg, image/svg+xml\">\r\n            </div>\r\n                        </div>\r\n                      </div>\r\n                      <div style=\"clear: both;\"></div>\r\n                      <div class=\"forgetPassButtons\">\r\n                        <button ng-click=\"updateCategory()\" type=\"submit\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n                      </div>\r\n                      <div style=\"clear: both;\"></div>\r\n                      <div class=\"forgetPassButtons clearfix\" style=\"margin-top: 10px;\">\r\n                        <button ng-click=\"removeCategory()\" type=\"submit\" class=\"btn btn-success\" style=\"float: right; margin-left: 10px;\">Remove</button>\r\n                      </div>\r\n                    </div>\r\n                    <hr style=\"border-color: #797979;\">\r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-12\">\r\n                        <!-- ******* Update parent node section ******** -->\r\n                        <h3>Update parent child relationship: </h3>\r\n                        <div class=\"control-group clearfix\">\r\n                          <label class=\"control-label formLabel\">View order(Applicable only if it\'s root category): </label>\r\n                          <div class=\"controls\">\r\n                            <input type=\"number\" ng-model=\"updateCat.viewOrder\" min=\"0\" class=\"form-control input-md text-input\">\r\n            </div>\r\n                          </div>\r\n                          <div class=\"clearfix\">\r\n                            <p class=\"formLabel\">Parent category (to make this \'root\' category don\'t select any\r\n                              category): </p>\r\n                            <p ng-if=\"statusUpdateGetCats == 1\" class=\"fwb\">Loading categories ...</p>\r\n                            <div ng-repeat=\"cat in selCatForNewCatUpdate\" class=\"pull-left\" style=\"padding: 5px;\">\r\n                              <select class=\"pull-left changeTextColor\" ng-model=\"cat[\'selected\']\" ng-change=\"toggleUpdateNewCatSel(cat[\'selected\'], $index)\">\r\n                <option ng-repeat=\"item in cat.items\" value=\"{{item}}\">\r\n                  {{item.order}}) {{item.title}}\r\n                </option>\r\n              </select>\r\n                              >\r\n                              <input class=\"pull-left changeTextColor\" type=\"number\" ng-model=\"cat[\'viewOrders\']\" ng-disabled=\"!cat[\'selected\']\" style=\"max-width: 50px;\">\r\n            </div>\r\n                            </div>\r\n                            <div style=\"clear: both;\"></div>\r\n                            <div class=\"forgetPassButtons\">\r\n                              <button ng-click=\"updateParentCategory()\" type=\"submit\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n                            </div>\r\n                          </div>\r\n                        </div>\r\n                        <div style=\"clear: both;\"></div>\r\n                        <hr style=\"border-color: #797979;\">\r\n                        <div ng-include=\"\'app/popups/add_parent_category.html\'\"></div>\r\n    </fieldset>\r\n  </form>\r\n</div>\r\n");
$templateCache.put("app/addDebate/addDebate.html","<div class=\"container-fluid\">\r\n  <fieldset class=\"scheduler-border\">\r\n    <legend class=\"scheduler-border\">Search candidates</legend>\r\n\r\n    <div class=\"dropdwn-container\">\r\n      <label for=\"electionDate\"\r\n        ><h4><b>Election Date</b></h4>\r\n      </label>\r\n      <select\r\n        ng-model=\"params.eDate\"\r\n        ng-options=\"item  for item in electionDates\"\r\n        class=\"changeTextColor election-dropdwn form-control\"\r\n      ></select>\r\n        <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loader\"></i>\r\n    </div>\r\n\r\n        <label class=\"control-label formLabel whiteText\" for=\"email\">Office Type</label>\r\n    <select\r\n      class=\"form-control\"\r\n      ng-model=\"params.officeType\"\r\n      style=\"text-transform: capitalize; display: block\"\r\n      ng-change=\"chnageType()\"\r\n    >\r\n      <option value=\"\" selected>Select Office Type</option>\r\n      <option value=\"cityCouncil\">City Council</option>\r\n      <option value=\"boroughPresident\"> Borough President </option>\r\n\r\n    </select>\r\n    <div ng-if=\"cityCouncilDistricts && cityCouncilDistricts.length > 0 && params.officeType == \'cityCouncil\' \">\r\n      <div class=\"control-group front-drop\">\r\n        <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n          >Select City Council District</label\r\n        >\r\n        <select\r\n          ng-model=\"params.cityCouncil\"\r\n          style=\"text-transform: capitalize; display: block\"\r\n          ng-options=\"item as item.name for item in cityCouncilDistricts\"\r\n          ng-change=\"GetCandidates()\"\r\n          class=\"changeTextColor form-control\"\r\n        ></select>\r\n      </div>\r\n    </div>\r\n\r\n     <div ng-if=\"cityCouncilDistricts && cityCouncilDistricts.length > 0 && params.officeType == \'boroughPresident\' \">\r\n      <div class=\"control-group front-drop\">\r\n        <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n          >Select County Name</label\r\n        >\r\n        <select\r\n          ng-model=\"params.countyName\"\r\n          style=\"text-transform: capitalize; display: block\"\r\n          ng-options=\"item as item.countyName for item in counties\"\r\n          ng-change=\"GetCandidates()\"\r\n          class=\"changeTextColor form-control\"\r\n        ></select>\r\n      </div>\r\n    </div>\r\n  </fieldset>\r\n\r\n     <form name=\"addDebateForm\" id=\"addDebateForm\">\r\n      <fieldset class=\"scheduler-border\">\r\n        <legend class=\"scheduler-border\">Thread details</legend>\r\n        <p></p>\r\n\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"title\">Title</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"Topic.title\" placeholder=\"\"\r\n                                       data-errormessage=\"Topic is required.\"  class=\"form-control input-md  validate[required] text-input\" style=\"width:90%;\">\r\n                                </div>\r\n              </div>\r\n\r\n              <div class=\"control-group\">\r\n                <div class=\"control-label\" for=\"title\">Select politician to tag</div>\r\n                <div class=\"DisplayCat\">\r\n                  <div style=\"background-color: #eee; padding:5px;\">All Politician <br><small>(click to select)</small>\r\n                  </div>\r\n                  <div ng-if=\"statusfetchPoliticiansByState == 1\" class=\"loadingSpinner\">\r\n                    <i class=\"fa fa-refresh fa-spin fa-3x fa-fw\"></i>\r\n                  </div>\r\n                  <div class=\"catname\" ng-repeat=\"(key, value) in candidates | groupBy: \'office\'\">\r\n                    <label class=\"ng-binding\">\r\n\r\n                                            <input type=\"checkbox\" ng-model=\"item.loadPolitician\" ng-change=\"selectUsersFromGroup(value, item.loadPolitician)\">\r\n                                            {{key}}&nbsp;\r\n                                            <i class=\"fa fa-caret-down ng-scope\" aria-hidden=\"true\"></i>\r\n\r\n                    <ul ng-show=\"value.length > 0\" style=\"margin: 0px; list-style: none;\">\r\n                      <li ng-repeat=\"pol in value\">\r\n                        <label>\r\n                                                    <input type=\"checkbox\" ng-model=\"pol.selected\">\r\n                                                    <span ng-if=\"pol.registeredUser\">\r\n                                                        <span ng-if=\"pol.name_on_ballot\">{{pol.name_on_ballot}}</span>\r\n                                                        <span ng-if=\"!pol.name_on_ballot\">{{pol.name}}</span>\r\n                                                    </span>\r\n                                                    <span ng-if=\"!pol.registeredUser\">\r\n                                                        <span ng-if=\"pol.name_on_ballot\">{{pol.name_on_ballot}}</span>\r\n                                                        <span ng-if=\"!pol.name_on_ballot\">{{pol.name}}</span>\r\n                                                    </span>\r\n                                                </label>\r\n                      </li>\r\n                    </ul>\r\n                  </div>\r\n                </div>\r\n                <div class=\"select buttons\" style=\"padding-left: 20px;\">&nbsp;\r\n                </div>\r\n                <div class=\"DisplayCat\">\r\n                  <div style=\"background-color: #eee; padding:5px;\">Selected Tags<br><small>(click to remove)</small>\r\n                  </div>\r\n\r\n                  <ul ng-show=\"candidates.length > 0\"\r\n                    style=\"margin: 0px; list-style: none; padding: 0;\">\r\n                    <li ng-repeat=\"pol in candidates\" ng-if=\"pol.selected\">\r\n                      <label>\r\n                                                <input type=\"checkbox\" ng-model=\"pol.selected\">\r\n                                                <span ng-if=\"pol.registeredUser\">\r\n                                                    <span ng-if=\"pol.name_on_ballot\">{{pol.name_on_ballot}}</span>\r\n                                                    <span ng-if=\"!pol.name_on_ballot\">{{pol.name}}</span>\r\n                                                </span>\r\n                                                <span ng-if=\"!pol.registeredUser\">\r\n                                                    <span ng-if=\"pol.name_on_ballot\">{{pol.name_on_ballot}}</span>\r\n                                                    <span ng-if=\"!pol.name_on_ballot\">{{pol.name}}</span>\r\n                                                </span>\r\n                                            </label>\r\n                    </li>\r\n                  </ul>\r\n                </div>\r\n                <div style=\"clear:both;\"></div>\r\n              </div>\r\n\r\n\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label\" for=\"description\">Description</label>\r\n                <div class=\"controls\">\r\n                  <textarea id=\"description\" ng-model=\"Topic.description\" placeholder=\"\"\r\n                                       data-errormessage=\"Description is required.\" class=\"form-control input-md  validate[required] text-area\"></textarea>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label\" for=\"location\">Thread Location</label>\r\n              </div>\r\n              <div class=\"control-group\" ng-if=\"!ShowLocationOptions\">\r\n\r\n                <div class=\"controls\">\r\n                  <div style=\"float: left; padding-right:20px; padding-top:20px; padding-bottom:20px;\">\r\n                    <strong>City :</strong> {{uData.address.place}},<br /><strong>Sub county :</strong>\r\n                    {{uData.address.countySubdivision}},<br />\r\n                    <strong>County :</strong> {{uData.address.county}},<br /><strong>State :</strong>\r\n                    {{uData.address.state}}<br><strong>Country: {{isNational}}</strong>\r\n                  </div>\r\n                  <div style=\"float: left; margin-left:2%; padding-top:40px; padding-bottom:20px;\">\r\n                    <input type=\"button\" class=\"btnShort-style\" value=\"Change\" ng-click=\"ShowLocation()\">\r\n                                    </div>\r\n                    <div style=\"clear:both;\"></div>\r\n                  </div>\r\n                </div>\r\n\r\n                <div class=\"control-group\" ng-if=\"ShowLocationOptions\">\r\n\r\n                  <div class=\"DisplayCat changeTextColor\">\r\n                    <div style=\"background-color: #eee; padding:5px;\">Choose Location\r\n                      <br><small>(click to select)</small></div>\r\n                    <ul class=\"TcatList\">\r\n                      <li style=\"padding-bottom:10px;\">\r\n\r\n                        <input type=\"checkbox\" ng-change=\"getLocations(Essay.Locations, \'International\')\" ng-model=\"Essay.Locations\" ng-true-value=\"\'International\'\" ng-false-value=\"\'NO\'\">\r\n                        <label ng-click=\"ShowAddLocation();\">International&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-show=\"never\"></i></label>\r\n\r\n                      </li>\r\n                      <li>\r\n                        <input type=\"checkbox\" ng-model=\"Essay.National\"  ng-change=\"getLocations(Essay.National, \'National\')\" ng-true-value=\"\'National\'\" ng-false-value=\"\'NO\'\">\r\n                        <label>National</label>\r\n                        </i>\r\n                        <ul class=\"TcatList\">\r\n                          <li ng-repeat=\"area in allLocations track by $index\">\r\n                            <input type=\"checkbox\" ng-click=\"getAreaVal(area, area.state, \'state\')\" ng-disabled=\"checkDisabled(area, area.state, \'state\')\" ng-checked=\"checkDisabled(area, area.state, \'state\')\">\r\n                            <label ng-click=\"getCounties(area.stateFips)\">{{area.state}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoading.indexOf(area.stateFips)==-1\"></i> <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoading.indexOf(area.stateFips) > -1\"></i></label>\r\n                            <!-- Display Counties -->\r\n                            <ul class=\"TcatList\">\r\n                              <li\r\n                                ng-repeat=\"county in allCounties[area.stateFips] | orderBy:\'countyName\' track by $index\">\r\n                                <input type=\"checkbox\" ng-click=\"getAreaVal(county, area.state, \'county\')\" ng-disabled=\"checkDisabled(county, area.state, \'county\')\" ng-checked=\"checkDisabled(county, area.state, \'county\')\">\r\n                                <label ng-click=\"getLocals(area.stateFips, county.countyFips)\">{{county.countyName}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoadingCounty.indexOf(county.county) == -1\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingCounty.indexOf(county.county) > -1\"></i></label>\r\n                                <!-- Display Locals and sub counties -->\r\n                                <ul class=\"TcatList\" ng-if=\"Essay.location!=\'National\'\">\r\n                                  <li\r\n                                    ng-repeat=\"local in allLocals[area.stateFips][county.countyFips] | orderBy:\'placeName\'  track by $index\">\r\n                                    <label class=\"checkbox\" title=\"{{local.place}}\">\r\n                                  <input type=\"checkbox\" ng-click=\"getAreaVal(local, area.state, \'local\')\" ng-disabled=\"disabledLocation.indexOf(local) > -1 ? true : false\" ng-checked=\"disabledLocation.indexOf(local) > -1 ? true : false\"> {{local.placeName}}\r\n                                </label>\r\n                                  </li>\r\n                                </ul>\r\n                                <!-- Display Locals and sub counties End -->\r\n                              </li>\r\n                            </ul>\r\n                            <!-- Display Counties End -->\r\n                          </li>\r\n                        </ul>\r\n                      </li>\r\n                    </ul>\r\n                  </div>\r\n\r\n                  <div class=\"DisplayCat changeTextColor\">\r\n                    <div style=\"background-color: #eee; padding:5px;\">Selected Location\'s\r\n                      <br><small>(click to remove)</small></div>\r\n                    <ul class=\"TcatList\">\r\n                      <li ng-repeat=\"area in selectedArea track by $index\">\r\n\r\n                        <label class=\"checkbox\" title=\"{{area}}\">\r\n                      <input type=\"checkbox\" ng-click=\"removeAreaVal(area)\" name=\"checkedid\" ng-model=\"selectedLAll.id[$index]\" ng-checked=\"true\"> <span ng-if=\"area.country && (!(area.state) && !(area.county) && !(area.countySubdivision) && !(area.place))\">{{area.country}}</span> <span ng-if=\"area.state && (!(area.county) && !(area.countySubdivision) && !(area.place))\">{{area.state}}</span><span ng-if=\"area.county && (!(area.countySubdivision) && !(area.place))\">{{area.countyName}}</span><span ng-if=\"area.countySubdivision\">{{area.countySubdivision}}</span><span ng-if=\"area.place\"> - {{area.placeName}}</span>\r\n                    </label>\r\n                      </li>\r\n                    </ul>\r\n                  </div>\r\n                  <div style=\"clear:both;\"></div>\r\n\r\n                </div>\r\n                <div style=\"clear: both;\"></div>\r\n\r\n                <div style=\"margin-top:20px;\">\r\n                  <button ng-click=\"SubmitTopic(Topic)\" type=\"button\" class=\"btn btn-success\" ng-disabled=\"TopicButton\"  style=\"float: left;\">Submit Thread</button>\r\n                  &nbsp;&nbsp;&nbsp;&nbsp;\r\n                  <button ng-click=\"goBack();\" class=\"btnShort-style\" type=\"button\" style=\"float: left;\">Cancel</button>\r\n                  <div style=\"clear: both;\"></div>\r\n                </div>\r\n\r\n                <div style=\"clear: both;\"></div>\r\n\r\n\r\n\r\n      </fieldset>\r\n    </form>\r\n</div>\r\n\r\n\r\n\r\n");
$templateCache.put("app/addEndorsement/addEndorsement.html","<div class=\"container-fluid add-rating-container\" ng-cloak\r\n  ng-show=\"$root.userRole==\'admin\'|| $root.userRole==\'advocate\'|| $root.userRole==\'politician\'\">\r\n  <h2 class=\"pageHeading\" ng-if=\"!isEdit\">ADD ENDORSEMENT</h2>\r\n  <h2 class=\"pageHeading\" ng-if=\"isEdit\">Edit ENDORSEMENT</h2>\r\n  <div class=\"row d-lg-flex\">\r\n    <div class=\"col-lg-12\">\r\n      <!-- <fieldset class=\"scheduler-border\">\r\n        <legend class=\"scheduler-border\">Choose</legend>\r\n        <label>\r\n          <input type=\"radio\" name=\"geographic-focus\" value=\"politician\" ng-model=\"locationIntrest\" ng-change=\"getUsers(\'politician\')\"\r\n          /> Politician\r\n        </label>\r\n        <label>\r\n          <input type=\"radio\" name=\"geographic-focus\" value=\"organization\" ng-model=\"locationIntrest\" ng-change=\"getUsers(\'advocate\')\"\r\n          /> Organization\r\n        </label>\r\n        <label>\r\n          <input type=\"radio\" name=\"geographic-focus\" value=\"press\" ng-model=\"locationIntrest\" ng-change=\"getUsers(\'press\')\"> Press\r\n        </label>\r\n        <label>\r\n          <input type=\"radio\" name=\"geographic-focus\" value=\"yourself\" ng-model=\"locationIntrest\" ng-change=\"reviewYourself()\"> Reviews of Yourself\r\n        </label>\r\n        <br>\r\n      </fieldset> -->\r\n    </div>\r\n  </div>\r\n  <div class=\"row d-lg-flex\">\r\n    <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\">\r\n      <div ng-if=\"selectionType != \'yourself\'\">\r\n        <div class=\"control-group\" id=\"auto-user-suggest-box\">\r\n          <label class=\"control-label\" for=\"title\" style=\"text-transform: capitalize;\">Selected {{locationIntrest}}</label>&nbsp;&nbsp;<i ng-if=\"showLoader \" class=\"fa fa-refresh fa-spin fa-1x fa-fw \"></i>\r\n          <div class=\"controls\" mass-autocomplete>\r\n            <input ng-model=\'selectedUser.value\' ng-disabled=\"true\" class=\"form-control\" />\r\n          </div>\r\n          </div>\r\n          <div class=\"control-group\" ng-if=\"politiicanId==userId\" id=\"auto-referal-suggest-box\">\r\n            <label class=\"control-label\">Review From</label>\r\n            <div class=\"controls\" mass-autocomplete>\r\n              <!-- <input ng-model=\'review.referal\' class=\"form-control\" /> -->\r\n              <input ng-model=\'selectedReferal.value\' mass-autocomplete-item=referal_options class=\"matrix-cell form-control\" />\r\n          </div>\r\n            </div>\r\n            <br />\r\n\r\n            <br />\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"title\" ng-if=\"politiicanId!=userId\" style=\"text-transform: capitalize;\">Add Comments</label>\r\n              <label class=\"control-label\" for=\"title\" ng-if=\"politiicanId==userId\" style=\"text-transform: capitalize;\">Copy Outside Review</label>\r\n              <div class=\"controls\">\r\n                <textarea ng-model=\"review.text\" class=\"form-control\"></textarea>\r\n              </div>\r\n            </div>\r\n            <br />\r\n            <!-- <div class=\"control-group\">\r\n          <label class=\"control-label\" for=\"title\" style=\"text-transform: capitalize;\">Relevent Links</label>\r\n          <div class=\"controls\">\r\n            <textarea ng-model=\"review.links\" class=\"form-control\"></textarea>\r\n          </div>\r\n        </div> -->\r\n            <!-- <div class=\"control-group\">\r\n          <label class=\"control-label\" for=\"title\" style=\"text-transform: capitalize;\">Links to outside articles or other relevant items</label>\r\n          <div class=\"controls\">\r\n            <input type=\"text\" ng-model=\"review.links[0]\" class=\"form-control\" />\r\n            <br />\r\n            <input type=\"text\" ng-model=\"review.links[1]\" class=\"form-control\" />\r\n            <br />\r\n            <input type=\"text\" ng-model=\"review.links[2]\" class=\"form-control\" />\r\n          </div>\r\n        </div> -->\r\n          </div>\r\n          <div class=\"control-group\" ng-if=\"isEdit\">\r\n            <label for=\"removeEndorsement\">Do you want to remove endorsement</label>\r\n            <a href=\"\" class=\"ylink\" ng-click=\"removeEndorsement()\">Remove</a>\r\n          </div>\r\n\r\n          <a ng-click=\"endorsement()\" class=\"donateBtn btn\" style=\"width: auto;margin-top: 20px;margin-left: 0;\">Submit Endorsement</a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n");
$templateCache.put("app/addEssayAnswers/addEssayAnswers.html","<div class=\"container\">\r\n  <div class=\"dropdwn-container\">\r\n    <label for=\"electionDate\"> CANDIDATES</label>\r\n    <select\r\n      ng-init=\"quiz.eDate = electionDates[0]\"\r\n      ng-model=\"quiz.eDate\"\r\n      ng-options=\"item as item.eDate for item in electionDates\"\r\n      ng-change=\"getCandidateListing()\"\r\n      class=\"changeTextColor election-dropdwn form-control\"\r\n    ></select>\r\n  </div>\r\n\r\n  <div ng-if=\"candidates && candidates.length > 0\">\r\n    <div class=\"control-group front-drop\">\r\n      <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n        >Select Candidates To Answer For</label\r\n      >\r\n      <select\r\n        ng-model=\"isUser.selected\"\r\n        style=\"text-transform: capitalize; display: block\"\r\n        ng-options=\"item as item.name for item in candidates\"\r\n        ng-change=\"getAnswerQuestion()\"\r\n        class=\"changeTextColor form-control\"\r\n      ></select>\r\n    </div>\r\n  </div>\r\n  <div class=\"container\" ng-if=\"questions.length > 0\">\r\n    <div class=\"col-lg-12 col-sm-12\">\r\n      <h4 class=\"text-center\">Questions</h4>\r\n\r\n      <div class=\"card customCard\">\r\n        <div class=\"card-header quesCardHeaderMain\">\r\n          <div class=\"d-flex justify-content-between bd-highlight\">\r\n            <!-- <div class=\"p-2 bd-highlight quesCardHeader\">Statement</div> -->\r\n            <div class=\"p-2 bd-highlight\">\r\n              <span class=\"textYellow\">{{currentIndex+1}}</span\r\n              >/{{questions.length}}\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"card-body customCardBody\">\r\n          <p\r\n            class=\"card-text\"\r\n            ng-bind-html=\"questions[currentIndex].content | newlines\"\r\n          ></p>\r\n        </div>\r\n      </div>\r\n      <div class=\"card card1\">\r\n        <div class=\"card-header card1Header\">\r\n          <p class=\"card-title\">Write Your Answers</p>\r\n        </div>\r\n\r\n        <div class=\"card-body card1Body\">\r\n          <textarea\r\n            class=\"form-control addComment\"\r\n            ng-model=\"quizAns.shortAns\"\r\n            maxlength=\"300\"\r\n            placeholder=\"Short Answer (300 Characters are Allowed)\"\r\n          ></textarea>\r\n          <br />\r\n          <textarea\r\n            class=\"form-control addComment\"\r\n            ng-model=\"quizAns.mediAns\"\r\n            maxlength=\"2000\"\r\n            placeholder=\"Medium Answer (2000 Characters are Allowed)\"\r\n          ></textarea>\r\n          <br />\r\n          <textarea\r\n            class=\"form-control addComment\"\r\n            ng-model=\"quizAns.longAns\"\r\n            rows=\"8\"\r\n            maxlength=\"15000\"\r\n            placeholder=\"Long Answer (15000 Characters are Allowed)\"\r\n          ></textarea>\r\n          <br />\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col bottomBtns\">\r\n          <div class=\"btn-group\" role=\"group\" aria-label=\"Default button group\">\r\n            <button\r\n              type=\"button\"\r\n              id=\"backBtn\"\r\n              class=\"btn-transparent\"\r\n              ng-click=\"prevQuestion()\"\r\n            >\r\n              <i class=\"fa fa-angle-left arrowIconBack\"></i> Back\r\n            </button>\r\n            <button\r\n              type=\"button\"\r\n              id=\"skipBtn\"\r\n              class=\"btn-transparent\"\r\n              ng-click=\"skipQuestion()\"\r\n            >\r\n              Skip\r\n            </button>\r\n            <button\r\n              type=\"button\"\r\n              id=\"submitBtn\"\r\n              class=\"btn-transparent\"\r\n              ng-click=\"submitAnswer()\"\r\n              ng-class=\"{\'activeSubmit\': (answer &&importance)}\"\r\n            >\r\n              Submit <i class=\"fa fa-angle-right arrowIconSubmit\"></i>\r\n            </button>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/addFiveMinEssayQues/addFiveMinEssayQues.html","<div class=\"container-fluid\">\r\n  <h1>Add Five Minute Essay Questions</h1>\r\n  <label for=\"question\"> Question</label>\r\n  <textarea\r\n    class=\"form-control question\"\r\n    ng-model=\"quiz.content\"\r\n    placeholder=\"Question Content\"\r\n  ></textarea>\r\n  <br />\r\n  <button\r\n    type=\"button\"\r\n    class=\"btn-success btn-add-five\"\r\n    ng-click=\"addQuestion()\"\r\n  >\r\n    <span ng-if=\"!isEdit\"> Add Question </span>\r\n    <span ng-if=\"isEdit\"> Update Question </span>\r\n  </button>\r\n\r\n  <div class=\"question-container\" ng-if=\"fiveMinQuestion.length > 0\">\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">\r\n        Manage five match Essay Questions\r\n      </legend>\r\n      <div class=\"row\">\r\n        <table\r\n          class=\"w100 changeTextColor\"\r\n          ng-if=\"fiveMinQuestion.length > 0\"\r\n          style=\"margin-top: 10px\"\r\n        >\r\n          <tr>\r\n            <th style=\"width: 70%\">Question</th>\r\n            <th style=\"width: 15%\">Edit</th>\r\n            <th style=\"width: 15%\">Remove</th>\r\n          </tr>\r\n          <tr ng-repeat=\"q in fiveMinQuestion\">\r\n            <td>{{q.content}}</td>\r\n            <td>\r\n              <a href=\"javascript: void(0)\" ng-click=\"editQeustion(q, $index)\"\r\n                >Edit</a\r\n              >\r\n            </td>\r\n            <td>\r\n              <a\r\n                href=\"javascript: void(0)\"\r\n                ng-click=\"removeQuestion(q, $index)\"\r\n                class=\"link\"\r\n                >Remove</a\r\n              >\r\n            </td>\r\n          </tr>\r\n        </table>\r\n      </div>\r\n    </fieldset>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/addPolitician/addPolitician.html","<style type=\"text/css\">\r\n  .highlight {\r\n    background-color: lightyellow;\r\n    font-weight: bold;\r\n  }\r\n</style>\r\n<div class=\"container-fluid\" ng-cloak ng-show=\"$root.userRole==\'admin\'\">\r\n  <h3>Add Politician & Organization</h3>\r\n  <form name=\"addPoli\" id=\"addPoli\" ng-controller=\"addPoliticianCtrl\">\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Add New Politician</legend>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <div style=\"width: 30%\" class=\"control-group\">\r\n            <label\r\n              class=\"control-label formLabel removeTopMargin whiteText\"\r\n              for=\"firstname\"\r\n              >Type of user?</label\r\n            >\r\n            <div class=\"controls\" style=\"background-color: yellow\">\r\n              <select\r\n                ng-model=\"UserType\"\r\n                style=\"text-transform: capitalize; background-color: yellow\"\r\n                ng-change=\"userTypeChanged(UserType)\"\r\n                class=\"changeTextColor form-control\"\r\n              >\r\n                <option ng-repeat=\" item in MUserType\" value=\"{{item.key}}\">\r\n                  {{item.name}}\r\n                </option>\r\n              </select>\r\n            </div>\r\n          </div>\r\n          <div ng-if=\"UserType == \'advocate\'\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                >Organization Name</label\r\n              >\r\n              <div mass-autocomplete>\r\n                <input\r\n                  ng-model=\"User.organization_name\"\r\n                  mass-autocomplete-item=\"org_autocomplete_options\"\r\n                  class=\"changeTextColor\"\r\n                  style=\"background-color: yellow\"\r\n                />\r\n              </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                >Website for organization</label\r\n              >\r\n              <div class=\"controls\">\r\n                <input\r\n                  type=\"text\"\r\n                  ng-model=\"User.organization.web_url\"\r\n                  ng-disabled=\"User.organization._id\"\r\n                  data-errormessage-custom-error=\"Invalid URL.\"\r\n                  data-errormessage=\"Website for organization is required.\"\r\n                  class=\"form-control input-md validate[required, custom[url]] text-input\"\r\n                  style=\"background-color: yellow\"\r\n                />\r\n              </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                >Organization Type</label\r\n              >\r\n              <div class=\"controls\">\r\n                <select\r\n                  ng-model=\"User.organization.orgType\"\r\n                  class=\"form-control\"\r\n                  style=\"width: 60%; background-color: lawngreen\"\r\n                >\r\n                  <option value=\"\">Select Organization</option>\r\n                  <option value=\"501c3\">501c3</option>\r\n                  <option value=\"501c4\">501c4</option>\r\n                  <option value=\"501c5\">501c5</option>\r\n                  <option value=\"501c6\">501c6</option>\r\n                  <option value=\"State level non-profit\">\r\n                    State Level Non-Profit\r\n                  </option>\r\n                  <option value=\"registered lobbyist \">\r\n                    Registered Lobbyist\r\n                  </option>\r\n                </select>\r\n              </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                >Employer Identification Number<br />\r\n                or US House Lobbyist Registration #\r\n              </label>\r\n              <div class=\"controls\">\r\n                <input\r\n                  type=\"tel\"\r\n                  ng-model=\"User.organization.empIndNo\"\r\n                  class=\"form-control input-md text-input\"\r\n                  style=\"width: 60%; background-color: lawngreen\"\r\n                />\r\n              </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                >Phone number of organization (xxx)xxx-xxxx</label\r\n              >\r\n              <div class=\"controls\">\r\n                <input\r\n                  type=\"tel\"\r\n                  ng-model=\"User.organization.phone_no\"\r\n                  ng-disabled=\"User.organization._id\"\r\n                  data-errormessage=\"Phone number of organization is required.\"\r\n                  class=\"form-control input-md validate[required] text-input\"\r\n                  style=\"background-color: yellow\"\r\n                />\r\n              </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                >Their extension number (if any)</label\r\n              >\r\n              <div class=\"controls\">\r\n                <input\r\n                  type=\"tel\"\r\n                  ng-model=\"User.extention_no\"\r\n                  class=\"form-control input-md text-input\"\r\n                />\r\n              </div>\r\n            </div>\r\n            <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"firstname\"\r\n                >Their Name</label\r\n              >\r\n              <div class=\"controls\">\r\n                <input\r\n                  ng-if=\"UserType == \'voter\'\"\r\n                  type=\"text\"\r\n                  ng-model=\"User.name\"\r\n                  placeholder=\"\"\r\n                  class=\"form-control input-md text-input\"\r\n                  style=\"background-color: yellow\"\r\n                />\r\n                <input\r\n                  ng-if=\"UserType != \'voter\'\"\r\n                  type=\"text\"\r\n                  ng-model=\"User.name\"\r\n                  placeholder=\"\"\r\n                  data-errormessage=\"Name is required.\"\r\n                  class=\"form-control input-md validate[required] text-input\"\r\n                  style=\"background-color: yellow\"\r\n                />\r\n              </div>\r\n            </div>\r\n            <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"firstname\"\r\n                >Their Position</label\r\n              >\r\n              <div class=\"controls\">\r\n                <input\r\n                  ng-if=\"UserType != \'voter\'\"\r\n                  type=\"text\"\r\n                  ng-model=\"User.position\"\r\n                  placeholder=\"\"\r\n                  data-errormessage=\"Position  is required.\"\r\n                  class=\"form-control input-md validate[required] text-input\"\r\n                  style=\"background-color: yellow\"\r\n                />\r\n              </div>\r\n            </div>\r\n            <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"firstname\"\r\n                >UserName for future Log In</label\r\n              >\r\n              <div class=\"controls\">\r\n                <input\r\n                  type=\"text\"\r\n                  ng-model=\"User.UserName\"\r\n                  ng-blur=\"CheckUserName()\"\r\n                  placeholder=\"\"\r\n                  data-errormessage=\"UserName is required.\"\r\n                  class=\"form-control input-md validate[required] text-input\"\r\n                  style=\"background-color: yellow\"\r\n                />\r\n              </div>\r\n            </div>\r\n            <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"password\"\r\n                >Password</label\r\n              >\r\n              -\r\n              <a href=\"\" ng-click=\"generatePassword()\" class=\"whiteText ylink\"\r\n                >Click here to generate Password</a\r\n              >\r\n              <div class=\"controls\">\r\n                <input\r\n                  type=\"text\"\r\n                  id=\"password\"\r\n                  ng-model=\"User.Password\"\r\n                  ng-readonly=\"true\"\r\n                  placeholder=\"\"\r\n                  data-errormessage=\"Password is required.\"\r\n                  class=\"form-control input-md validate[required] text-input\"\r\n                  style=\"width: 88%; background-color: yellow\"\r\n                />\r\n              </div>\r\n            </div>\r\n            <!--  <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"password\">Create Password</label>\r\n              <div class=\"controls\">\r\n                <input type=\"password\" id=\"password\" ng-model=\"User.Password\" placeholder=\"\" data-errormessage=\"Password is required.\" class=\"form-control input-md  validate[required] text-input\" />\r\n              </div>\r\n            </div>\r\n            <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"password\">Confirm Password</label>\r\n              <div class=\"controls\">\r\n                <input type=\"password\" id=\"confirm_password\" ng-model=\"ConfirmPassword\" data-errormessage=\"Password and Confirm password do not match.\" placeholder=\"\" class=\"form-control input-md  validate[required,equals[password]] text-input \" />\r\n                <small id=\"message\"></small>\r\n              </div>\r\n            </div> -->\r\n            <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                >Email for account</label\r\n              >\r\n              <div class=\"controls\">\r\n                <input\r\n                  type=\"email\"\r\n                  ng-model=\"User.Email\"\r\n                  data-errormessage=\"Email is required.\"\r\n                  class=\"form-control input-md validate[required] text-input\"\r\n                  style=\"background-color: yellow\"\r\n                />\r\n              </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel whiteText\"\r\n                >Address for account (Leave out Apt #)</label\r\n              >\r\n              <div class=\"control-group\">\r\n                <input\r\n                  type=\"text\"\r\n                  id=\"address\"\r\n                  ng-model=\"User.Address\"\r\n                  ng-keyup=\"detectAddress($event)\"\r\n                  class=\"zipInput form-control\"\r\n                  style=\"background-color: lawngreen\"\r\n                />&nbsp;\r\n              </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"zipcode\"\r\n                >ZipCode for account</label\r\n              >\r\n              <div class=\"control-group\">\r\n                <input\r\n                  type=\"text\"\r\n                  ng-model=\"User.ZipCode\"\r\n                  id=\"zip\"\r\n                  class=\"zipInput form-control validate[required,custom[integer],minSize[5]] text-input\"\r\n                  style=\"background-color: yellow\"\r\n                />&nbsp;\r\n              </div>\r\n            </div>\r\n            <div style=\"clear: both\"></div>\r\n            <div\r\n              class=\"btn-style\"\r\n              style=\"width: 100%; margin-right: 0px\"\r\n              ng-if=\"UserType == \'advocate\'\"\r\n            >\r\n              <button\r\n                class=\"btnShort-style\"\r\n                ng-if=\"!forFacebook\"\r\n                ng-click=\"CreateUser()\"\r\n                type=\"button\"\r\n                class=\"btn btn-success\"\r\n                ng-disabled=\"RegisterButton\"\r\n                style=\"float: right\"\r\n              >\r\n                submit\r\n              </button>\r\n              <br />\r\n              <br />\r\n            </div>\r\n          </div>\r\n          <div ng-if=\"UserType == \'politician\'\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                >Are they currently in Office?</label\r\n              >\r\n              <div class=\"controls whiteText\">\r\n                <label>\r\n                  <input\r\n                    type=\"radio\"\r\n                    ng-model=\"User.isInCurrentOffice\"\r\n                    value=\"1\"\r\n                  />\r\n                  Yes\r\n                </label>\r\n                <label>\r\n                  <input\r\n                    type=\"radio\"\r\n                    ng-model=\"User.isInCurrentOffice\"\r\n                    value=\"0\"\r\n                  />\r\n                  No\r\n                </label>\r\n              </div>\r\n            </div>\r\n            <div ng-if=\"User.isInCurrentOffice == 1\">\r\n              <div style=\"width: 40%\" class=\"control-group\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                  >What level of government?</label\r\n                >\r\n                <select\r\n                  ng-model=\"User.cur_level\"\r\n                  style=\"text-transform: capitalize; display: block\"\r\n                  ng-options=\"item as item for item in levelOfGovt\"\r\n                  ng-change=\"govLevelChanged(\'incumbent\')\"\r\n                  class=\"changeTextColor form-control\"\r\n                ></select>\r\n              </div>\r\n              <div ng-if=\"showOther\" style=\"width: 35%\">\r\n                <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                  <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                    >Level of Government for Other</label\r\n                  >\r\n                  <div class=\"controls\">\r\n                    <input\r\n                      type=\"Text\"\r\n                      ng-model=\"User.otherLevel\"\r\n                      class=\"form-control\"\r\n                    />\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div\r\n                style=\"width: 40%\"\r\n                class=\"control-group\"\r\n                ng-if=\"flagShowStateDropdown\"\r\n              >\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                  >Select State: (if applicable)</label\r\n                >\r\n                <select\r\n                  ng-model=\"User.cur_state\"\r\n                  style=\"\r\n                    text-transform: capitalize;\r\n                    max-width: 85%;\r\n                    display: inline;\r\n                  \"\r\n                  ng-options=\"item as item.state for item in states\"\r\n                  ng-change=\"onOfficeChange(\'incumbent\')\"\r\n                  class=\"changeTextColor form-control\"\r\n                ></select\r\n                >&nbsp; &nbsp;\r\n                <i\r\n                  ng-if=\"showLoader\"\r\n                  class=\"fa fa-refresh fa-spin fa-1x fa-fw\"\r\n                ></i>\r\n              </div>\r\n              <div\r\n                style=\"width: 40%\"\r\n                class=\"control-group\"\r\n                ng-if=\"flagShowStateDropdownPres\"\r\n              >\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                  >Select State: (if applicable)</label\r\n                >\r\n                <select\r\n                  ng-model=\"User.cur_state\"\r\n                  style=\"\r\n                    text-transform: capitalize;\r\n                    max-width: 85%;\r\n                    display: inline;\r\n                  \"\r\n                  ng-options=\"item as item.state for item in states\"\r\n                  class=\"changeTextColor form-control\"\r\n                ></select\r\n                >&nbsp; &nbsp;\r\n                <i\r\n                  ng-if=\"showLoader\"\r\n                  class=\"fa fa-refresh fa-spin fa-1x fa-fw\"\r\n                ></i>\r\n              </div>\r\n              <div style=\"width: 40%\" class=\"control-group\" ng-if=\"countyone\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                  >County\r\n                </label>\r\n                <div class=\"controls\">\r\n                  <select\r\n                    ng-model=\"address.county\"\r\n                    style=\"text-transform: capitalize; display: inline\"\r\n                    ng-options=\"item as item.countyName for item in counties | orderBy : \'county\'\"\r\n                    ng-change=\"getSubCounties()\"\r\n                    class=\"changeTextColor form-control\"\r\n                  ></select>\r\n                  <i\r\n                    ng-if=\"showLoaderOne\"\r\n                    class=\"fa fa-refresh fa-spin fa-1x fa-fw\"\r\n                  ></i>\r\n                </div>\r\n              </div>\r\n              <div style=\"width: 40%\" class=\"control-group\" ng-if=\"cityone\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                  >City\r\n                </label>\r\n                <div class=\"controls\">\r\n                  <select\r\n                    ng-model=\"address.place\"\r\n                    style=\"text-transform: capitalize\"\r\n                    ng-options=\"item as item.city for item in places | orderBy : \'place\' \"\r\n                    class=\"changeTextColor form-control\"\r\n                  ></select>\r\n                  <!-- <i ng-if=\"LoaderTwo \" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i> -->\r\n                </div>\r\n              </div>\r\n              <div style=\"width: 40%\" class=\"control-group\" ng-if=\"federalCong\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                  >Federal Congressional District\r\n                </label>\r\n                <div class=\"controls\">\r\n                  <select\r\n                    class=\"changeTextColor form-control\"\r\n                    ng-model=\"address.federalCongrassionalDist\"\r\n                    style=\"text-transform: capitalize\"\r\n                    ng-options=\"item as item.congressionalDistrict for item in federalCongrassionalDist |orderBy : \'congressionalDistrictFips\'  track by item.congressionalDistrict\"\r\n                    ng-class=\"checkLength(federalCongrassionalDist, \'congressionalDistrictFips\')\"\r\n                  ></select>\r\n                </div>\r\n              </div>\r\n              <div\r\n                style=\"width: 40%\"\r\n                class=\"control-group\"\r\n                ng-if=\"stateSenate && stateHouse\"\r\n              >\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                  >State Senate District\r\n                </label>\r\n                <div class=\"controls\">\r\n                  <select\r\n                    class=\"changeTextColor form-control\"\r\n                    ng-model=\"address.stateSenateDistrict\"\r\n                    style=\"text-transform: capitalize\"\r\n                    ng-options=\"item as item.stateSenateDistrict for item in stateSenateDistrict | unique:\'stateSenateDistrict\' | orderBy : \'stateSenateDistrictFips\' track by item.stateSenateDistrict\"\r\n                    ng-class=\"checkLength(stateSenateDistrict, \'stateSenateDistrict\')\"\r\n                  ></select>\r\n                </div>\r\n              </div>\r\n              <div\r\n                style=\"width: 40%\"\r\n                class=\"control-group\"\r\n                ng-if=\"stateSenate && federalCong && dis\"\r\n              >\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                  >State Senate District\r\n                </label>\r\n                <div class=\"controls\">\r\n                  <select\r\n                    class=\"changeTextColor form-control\"\r\n                    ng-model=\"address.stateSenateDistrict\"\r\n                    style=\"text-transform: capitalize\"\r\n                    ng-options=\"item as item.stateSenateDistrict for item in stateSenateDistrictOne | unique:\'stateSenateDistrict\' | orderBy : \'stateSenateDistrictFips\' track by item.stateSenateDistrict\"\r\n                    ng-class=\"checkLength(stateSenateDistrict, \'stateSenateDistrict\')\"\r\n                  ></select>\r\n                </div>\r\n              </div>\r\n              <div\r\n                style=\"width: 40%\"\r\n                class=\"control-group\"\r\n                ng-if=\"stateSenate && stateHouse\"\r\n              >\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                  >State House of Representative District\r\n                </label>\r\n                <div class=\"controls\">\r\n                  <select\r\n                    class=\"changeTextColor form-control\"\r\n                    ng-model=\"address.stateHouseOFRepresentativeDistrict\"\r\n                    style=\"text-transform: capitalize\"\r\n                    ng-options=\"item as item.stateHouseofRepresentativesDistrictName for item in stateHouseOFRepresentativeDistricts | unique:\'stateHouseofRepresentativesDistrictFips\' | orderBy : \'stateHouseofRepresentativesDistrictFips\' track by item.stateHouseofRepresentativesDistrictFips\"\r\n                    ng-class=\"checkLength(stateHouseOFRepresentativeDistricts, \'stateHouseOFRepresentativeDistrict\')\"\r\n                  ></select>\r\n                </div>\r\n              </div>\r\n              <div style=\"width: 40%\" class=\"control-group\" ng-if=\"school\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                  >School District Name\r\n                </label>\r\n                <div class=\"controls\">\r\n                  <select\r\n                    class=\"changeTextColor form-control\"\r\n                    ng-model=\"address.unifiedSchoolDistrictName\"\r\n                    style=\"text-transform: capitalize\"\r\n                    ng-options=\"item as item.unifiedSchoolDistrict for item in unifiedSchoolDistrictNames |orderBy : \'unifiedSchoolDistrict\' track by item.unifiedSchoolDistrict\"\r\n                    ng-class=\"checkLength(unifiedSchoolDistrictNames, \'unifiedSchoolDistrictName\')\"\r\n                  ></select>\r\n                </div>\r\n              </div>\r\n              <div\r\n                class=\"control-group\"\r\n                ng-if=\"showcur_office_nameDrop\"\r\n                style=\"width: 40%\"\r\n              >\r\n                <label class=\"control-label formLabel\" for=\"email\"\r\n                  >Office Name?</label\r\n                >\r\n                <div class=\"controls\">\r\n                  <select\r\n                    class=\"changeTextColor form-control\"\r\n                    ng-model=\"User.cur_office_name\"\r\n                    ng-change=\"getofficeDrop()\"\r\n                    style=\"text-transform: capitalize\"\r\n                    ng-options=\"item as item.officeName for item in cur_offiArr track by item.officeName\"\r\n                  ></select>\r\n                </div>\r\n              </div>\r\n              <div class=\"control-group\" ng-if=\"showtxt\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                  >Enter Position For Other?</label\r\n                >\r\n                <div class=\"controls\" mass-autocomplete>\r\n                  <input\r\n                    type=\"text\"\r\n                    ng-model=\"User.newcur_office_name\"\r\n                    class=\"form-control input-md text-input\"\r\n                    style=\"width: 88%\"\r\n                  />\r\n                </div>\r\n              </div>\r\n              <!-- <div id=\"curCandidate\" class=\"control-group\" ng-if=\"flagShowCandidateDropdown\">\r\n                                          <label class=\"control-label formLabel whiteText\" for=\"email\">What is their name as it appears on the ballot?</label>\r\n                                          <div mass-autocomplete>\r\n                                            <input ng-model=\"User.cur_Candidates\" ng-blur=\"checkExists();\" mass-autocomplete-item=\"autocomplete_options\" class=\"changeTextColor\">\r\n                                         </div>\r\n                                          </div> -->\r\n\r\n              <!-- <div ng-if=\"showcur_office_name\" class=\"control-group\">\r\n                                          <label class=\"control-label formLabel whiteText\" for=\"email\">Candidate Status</label>\r\n                                          <div class=\"controls\">\r\n                                            <select ng-model=\"User.cur_status\" class=\"form-control\" ng-change=\"selectStatus()\" style=\"width:170px;\">\r\n                                              <option value=\"\">Select Status</option>\r\n                                              <option value=\"Announced\">Announced</option>\r\n                                              <option value=\"Write in\">Write in</option>\r\n                                              <option value=\"Running\">Running</option>\r\n                                              <option value=\"Active\">Active</option>\r\n                                              <option value=\"Campaign Suspended\">Campaign Suspended</option>\r\n                                            </select>\r\n                                          </div>\r\n                                        </div>\r\n                                        <div ng-if=\"showcur_office_name\" class=\"control-group\">\r\n                                          <label class=\"control-label formLabel whiteText\" for=\"email\">Election Type</label>\r\n                                          <div class=\"controls\">\r\n                                            <select ng-model=\"User.cur_eleType\" class=\"form-control\" ng-change=\"selectStatus()\" style=\"width:190px;\">\r\n                                              <option value=\"\">Select Election Type</option>\r\n                                              <option value=\"P\">Primary</option>\r\n                                              <option value=\"R\">Run off</option>\r\n                                              <option value=\"S\">Special</option>\r\n                                              <option value=\"G\">General</option>\r\n                                            </select>\r\n                                          </div>\r\n                                        </div>\r\n\r\n\r\n\r\n                                        <div ng-if=\"showcur_office_name\">\r\n                                          <div ng-if=\"!forFacebook\" class=\"control-group\" style=\"width: 25%\">\r\n                                            <label class=\"control-label formLabel whiteText\" for=\"email\">Election Date</label>\r\n                                            <div class=\"controls\">\r\n                                              <input type=\"Date\" ng-model=\"User.cur_ElectionDate\"  class=\"form-control\">\r\n                                             </div>\r\n                                            </div>\r\n                                          </div> -->\r\n\r\n              <div\r\n                class=\"control-group\"\r\n                id=\"autoFillText\"\r\n                ng-if=\" showcur_office_name && showcur_office_nameOther\"\r\n              >\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                  >Office Name?</label\r\n                >\r\n                <div class=\"controls\" mass-autocomplete>\r\n                  <input\r\n                    type=\"text\"\r\n                    ng-model=\"User.cur_office_name\"\r\n                    ng-blur=\"setOfficeCur()\"\r\n                    class=\"form-control input-md text-input\"\r\n                    mass-autocomplete-item=\"autoFillCur_options\"\r\n                    style=\"width: 88%\"\r\n                  />\r\n                </div>\r\n              </div>\r\n              <div class=\"control-group\" ng-if=\"showcur_office_name\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                  >Office Phone</label\r\n                >\r\n                <div class=\"controls\">\r\n                  <input\r\n                    type=\"text\"\r\n                    ng-model=\"User.cur_office_phone\"\r\n                    class=\"form-control input-md text-input\"\r\n                    style=\"width: 88%\"\r\n                  />\r\n                </div>\r\n              </div>\r\n              <div class=\"control-group\" ng-if=\"showcur_office_name\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                  >Office Email</label\r\n                >\r\n                <div class=\"controls\">\r\n                  <input\r\n                    type=\"text\"\r\n                    ng-model=\"User.cur_office_email\"\r\n                    class=\"form-control input-md text-input\"\r\n                    style=\"width: 88%\"\r\n                  />\r\n                </div>\r\n              </div>\r\n              <div class=\"control-group\" ng-if=\"showcur_office_name\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                  >Office Website</label\r\n                >\r\n                <div class=\"controls\">\r\n                  <input\r\n                    type=\"text\"\r\n                    ng-model=\"User.cur_office_website\"\r\n                    class=\"form-control validate[custom[url]] input-md text-input\"\r\n                    style=\"width: 88%\"\r\n                  />\r\n                </div>\r\n              </div>\r\n              <div class=\"control-group whiteText\" ng-if=\"sendPostCard\">\r\n                <p>\r\n                  We have you in our system, but in order to confirm your\r\n                  identity, you need to call\r\n                  <br />\r\n                  <b>72-VoteWise</b>.\r\n                </p>\r\n              </div>\r\n            </div>\r\n            <br />\r\n            <div>\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                  >Are you running for office this coming election?</label\r\n                >\r\n                <div class=\"controls whiteText\">\r\n                  <label>\r\n                    <input\r\n                      type=\"radio\"\r\n                      ng-model=\"User.isRunningForEle\"\r\n                      ng-click=\"User.RunningForOtherOffice = 0;  \"\r\n                      value=\"1\"\r\n                    />\r\n                    Yes\r\n                  </label>\r\n                  <label>\r\n                    <input\r\n                      type=\"radio\"\r\n                      ng-model=\"User.isRunningForEle\"\r\n                      ng-click=\"User.RunningForOtherOffice = 0;  \"\r\n                      value=\"0\"\r\n                    />\r\n                    No\r\n                  </label>\r\n                </div>\r\n              </div>\r\n              <div\r\n                ng-if=\"User.isRunningForEle == 1 && User.isInCurrentOffice == 1\"\r\n              >\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                  >Are you running for same office?</label\r\n                >\r\n                <div class=\"controls whiteText\">\r\n                  <label>\r\n                    <input\r\n                      type=\"radio\"\r\n                      ng-model=\"User.RunningForOtherOffice\"\r\n                      ng-checked=\"User.RunningForOtherOffice == 1\"\r\n                      value=\"1\"\r\n                    />\r\n                    Yes\r\n                  </label>\r\n                  <label>\r\n                    <input\r\n                      type=\"radio\"\r\n                      ng-model=\"User.RunningForOtherOffice\"\r\n                      ng-checked=\"User.RunningForOtherOffice == 0\"\r\n                      value=\"0\"\r\n                    />\r\n                    No\r\n                  </label>\r\n                </div>\r\n              </div>\r\n              <div ng-if=\"User.RunningForOtherOffice == 1\" style=\"width: 36%\">\r\n                <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                  <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                    >Election Date</label\r\n                  >\r\n                  <div class=\"controls\">\r\n                    <input\r\n                      type=\"date\"\r\n                      ng-model=\"User.runElectionDate\"\r\n                      class=\"form-control\"\r\n                    />\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div ng-if=\"User.RunningForOtherOffice == 1\">\r\n                <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                  <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                    >Candidate Status</label\r\n                  >\r\n                  <div class=\"controls\">\r\n                    <select\r\n                      ng-model=\"User.runStatus\"\r\n                      class=\"form-control\"\r\n                      ng-change=\"selectStatus()\"\r\n                      style=\"width: 36%\"\r\n                    >\r\n                      <option value=\"\">Select Status</option>\r\n                      <option value=\"Announced\">Announced</option>\r\n                      <option value=\"Write in\">Write in</option>\r\n                      <option value=\"Running\">Running</option>\r\n                      <option value=\"Active\">Active</option>\r\n                      <option value=\"Campaign Suspended\">\r\n                        Campaign Suspended\r\n                      </option>\r\n                    </select>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div\r\n                ng-if=\"User.isInCurrentOffice == 1? User.isRunningForEle==1? User.RunningForOtherOffice == 0: false : User.isRunningForEle==1\"\r\n              >\r\n                <div style=\"width: 40%\" class=\"control-group\">\r\n                  <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                    >What level of government?</label\r\n                  >\r\n                  <select\r\n                    class=\"form-control\"\r\n                    ng-model=\"User.level\"\r\n                    style=\"text-transform: capitalize; display: block\"\r\n                    ng-change=\"govLevelChanged(\'running\')\"\r\n                    ng-options=\"item as item for item in levelOfGovt\"\r\n                    class=\"changeTextColor\"\r\n                  ></select>\r\n                </div>\r\n                <div ng-if=\"show_run_Other\" style=\"width: 25%\">\r\n                  <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                    <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                      >Level of Government for Other</label\r\n                    >\r\n                    <div class=\"controls\">\r\n                      <input\r\n                        type=\"Text\"\r\n                        ng-model=\"User.runOtherLevel\"\r\n                        class=\"form-control\"\r\n                      />\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div\r\n                  style=\"width: 40%\"\r\n                  class=\"control-group\"\r\n                  ng-if=\"running_flagShowStateDropdown\"\r\n                >\r\n                  <label class=\"control-label formLabel whiteText\" for=\"email\">\r\n                    Select State: (if applicable)</label\r\n                  >\r\n                  <select\r\n                    class=\"form-control\"\r\n                    ng-model=\"User.state\"\r\n                    style=\"text-transform: capitalize; display: inline\"\r\n                    ng-options=\"item as item.state for item in states\"\r\n                    ng-change=\"onOfficeChange(\'running\')\"\r\n                    class=\"changeTextColor form-control\"\r\n                  ></select\r\n                  >&nbsp; &nbsp;\r\n                  <i\r\n                    ng-if=\"running_showLoader\"\r\n                    class=\"fa fa-refresh fa-spin fa-1x fa-fw\"\r\n                  ></i>\r\n                </div>\r\n                <div\r\n                  style=\"width: 40%\"\r\n                  class=\"control-group\"\r\n                  ng-if=\"running_flagShowStateDropdownPre\"\r\n                >\r\n                  <label class=\"control-label formLabel whiteText\" for=\"email\">\r\n                    Select State: (if applicable)</label\r\n                  >\r\n                  <select\r\n                    ng-model=\"User.state\"\r\n                    style=\"text-transform: capitalize; display: inline\"\r\n                    ng-options=\"item as item.state for item in states\"\r\n                    ng-change=\"onOfficeChange(\'running\')\"\r\n                    class=\"changeTextColor form-control\"\r\n                  ></select\r\n                  >&nbsp; &nbsp;\r\n                  <i\r\n                    ng-if=\"running_showLoader\"\r\n                    class=\"fa fa-refresh fa-spin fa-1x fa-fw\"\r\n                  ></i>\r\n                </div>\r\n                <div\r\n                  style=\"width: 40%\"\r\n                  class=\"control-group\"\r\n                  ng-if=\" running_flagShowStateDropdown && running_countyone\"\r\n                >\r\n                  <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                    >County\r\n                  </label>\r\n                  <div class=\"controls\">\r\n                    <select\r\n                      ng-model=\"runAddress.county\"\r\n                      style=\"text-transform: capitalize; display: inline\"\r\n                      ng-options=\"item as item.countyName for item in runCounties | orderBy : \'county\'\"\r\n                      ng-change=\"getRunningSubCounties()\"\r\n                      class=\"changeTextColor form-control\"\r\n                    ></select>\r\n                    <i\r\n                      ng-if=\"running_showLoaderOne\"\r\n                      class=\"fa fa-refresh fa-spin fa-1x fa-fw\"\r\n                    ></i>\r\n                  </div>\r\n                </div>\r\n                <div\r\n                  style=\"width: 40%\"\r\n                  class=\"control-group\"\r\n                  ng-if=\"running_flagShowStateDropdown && running_cityone\"\r\n                >\r\n                  <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                    >City\r\n                  </label>\r\n                  <div class=\"controls\">\r\n                    <select\r\n                      ng-model=\"runAddress.place\"\r\n                      style=\"text-transform: capitalize\"\r\n                      ng-options=\"item as item.city for item in runPlaces | orderBy : \'place\'\"\r\n                      class=\"changeTextColor form-control\"\r\n                    ></select>\r\n                  </div>\r\n                </div>\r\n                <div\r\n                  style=\"width: 40%\"\r\n                  class=\"control-group\"\r\n                  ng-if=\"running_flagShowStateDropdown && running_federalCong\"\r\n                >\r\n                  <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                    >Federal Congressional District\r\n                  </label>\r\n                  <div class=\"controls\">\r\n                    <select\r\n                      class=\"changeTextColor form-control\"\r\n                      ng-model=\"runAddress.federalCongrassionalDist\"\r\n                      style=\"text-transform: capitalize\"\r\n                      ng-options=\"item as item.congressionalDistrict for item in runFederalCongrassionalDist | orderBy: \'congressionalDistrictFips\'  track by item.congressionalDistrict\"\r\n                      ng-class=\"checkLength(federalCongrassionalDist, \'congressionalDistrictFips\')\"\r\n                    ></select>\r\n                  </div>\r\n                </div>\r\n                <div\r\n                  style=\"width: 40%\"\r\n                  class=\"control-group\"\r\n                  ng-if=\"running_flagShowStateDropdown && running_stateSenate && running_stateHouse\"\r\n                >\r\n                  <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                    >State Senate District\r\n                  </label>\r\n                  <div class=\"controls\">\r\n                    <select\r\n                      class=\"changeTextColor form-control\"\r\n                      ng-model=\"runAddress.stateSenateDistrict\"\r\n                      style=\"text-transform: capitalize\"\r\n                      ng-options=\"item as item.stateSenateDistrict for item in runStateSenateDistrict | unique:\'stateSenateDistrict\' | orderBy : \'stateSenateDistrictFips\' track by item.stateSenateDistrict\"\r\n                      ng-class=\"checkLength(stateSenateDistrict, \'stateSenateDistrict\')\"\r\n                    ></select>\r\n                  </div>\r\n                </div>\r\n                <div\r\n                  style=\"width: 40%\"\r\n                  class=\"control-group\"\r\n                  ng-if=\"running_flagShowStateDropdown && running_stateSenate && running_federalCong && running_dis\"\r\n                >\r\n                  <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                    >State Senate District\r\n                  </label>\r\n                  <div class=\"controls\">\r\n                    <select\r\n                      class=\"changeTextColor form-control\"\r\n                      ng-model=\"runAddress.stateSenateDistrict\"\r\n                      style=\"text-transform: capitalize\"\r\n                      ng-options=\"item as item.stateSenateDistrict for item in runStateSenateDistrictOne | unique:\'stateSenateDistrict\' | orderBy : \'stateSenateDistrictFips\' track by item.stateSenateDistrict\"\r\n                      ng-class=\"checkLength(stateSenateDistrict, \'stateSenateDistrict\')\"\r\n                    ></select>\r\n                  </div>\r\n                </div>\r\n                <div\r\n                  style=\"width: 40%\"\r\n                  class=\"control-group\"\r\n                  ng-if=\"running_flagShowStateDropdown && running_stateSenate && running_stateHouse\"\r\n                >\r\n                  <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                    >State House of Representative District\r\n                  </label>\r\n                  <div class=\"controls\">\r\n                    <select\r\n                      class=\"changeTextColor form-control\"\r\n                      ng-model=\"runAddress.stateHouseOFRepresentativeDistrict\"\r\n                      style=\"text-transform: capitalize\"\r\n                      ng-options=\"item as item.stateHouseofRepresentativesDistrictName for item in runStateHouseOFRepresentativeDistricts | unique:\'stateHouseOFRepresentativeDistrict\' | orderBy : \'stateHouseofRepresentativesDistrictFips\' track by item.stateHouseofRepresentativesDistrictName\"\r\n                      ng-class=\"checkLength(stateHouseOFRepresentativeDistricts, \'stateHouseOFRepresentativeDistrict\')\"\r\n                    ></select>\r\n                  </div>\r\n                </div>\r\n                <div\r\n                  style=\"width: 40%\"\r\n                  class=\"control-group\"\r\n                  ng-if=\"running_flagShowStateDropdown && running_school\"\r\n                >\r\n                  <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                    >School District Name\r\n                  </label>\r\n                  <div class=\"controls\">\r\n                    <select\r\n                      class=\"changeTextColor form-control\"\r\n                      ng-model=\"runAddress.unifiedSchoolDistrictName\"\r\n                      style=\"text-transform: capitalize\"\r\n                      ng-options=\"item as item.unifiedSchoolDistrict for item in runUnifiedSchoolDistrictNames | orderBy : \'unifiedSchoolDistrict\'  track by item.unifiedSchoolDistrict\"\r\n                      ng-class=\"checkLength(unifiedSchoolDistrictNames, \'unifiedSchoolDistrictName\')\"\r\n                    ></select>\r\n                  </div>\r\n                </div>\r\n                <div\r\n                  style=\"width: 40%\"\r\n                  class=\"control-group\"\r\n                  ng-if=\"shownew_office_nameDrop\"\r\n                >\r\n                  <label class=\"control-label formLabel\" for=\"email\"\r\n                    >Office Name?</label\r\n                  >\r\n                  <div class=\"controls\">\r\n                    <select\r\n                      class=\"changeTextColor form-control\"\r\n                      ng-model=\"User.office_name\"\r\n                      ng-change=\"getofficeDropRun()\"\r\n                      style=\"text-transform: capitalize\"\r\n                      ng-options=\"item as item.officeName for item in offiArr track by item.officeName\"\r\n                    ></select>\r\n                  </div>\r\n                </div>\r\n\r\n                <div class=\"control-group\" ng-if=\"showtxtRun\">\r\n                  <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                    >Enter Position For Other?</label\r\n                  >\r\n                  <div class=\"controls\" mass-autocomplete>\r\n                    <input\r\n                      type=\"text\"\r\n                      ng-model=\"User.newoffice_name\"\r\n                      class=\"form-control input-md text-input\"\r\n                      style=\"width: 40%\"\r\n                    />\r\n                  </div>\r\n                </div>\r\n\r\n                <!-- <div id=\"curCandidate\" class=\"control-group\"\r\n                                                      ng-if=\"running_flagShowCandidateDropdown\">\r\n                                                      <label class=\"control-label formLabel formLabel whiteText\" for=\"email\">What is their name as it appears on the ballot?</label>\r\n                                                      <div mass-autocomplete>\r\n                                                        <input ng-model=\"User.new_Candidates\" class=\"blackText\" ng-blur=\"checkExistsNew()\" mass-autocomplete-item=\"autocomplete_new_options\">\r\n                  </div>\r\n                                                      </div> -->\r\n                <!--  <div class=\"control-group whiteText\" ng-if=\"sendPostCardNew\">\r\n                  <p>We have you in our system, but in order to confirm your identity, you need to call\r\n                    <br />\r\n                    <b>72-VoteWise</b>.</p>\r\n                </div> -->\r\n              </div>\r\n            </div>\r\n            <br />\r\n            <div\r\n              ng-if=\"shownew_office_name && User.RunningForOtherOffice != 1\"\r\n              style=\"width: 36%\"\r\n            >\r\n              <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                  >Election Date</label\r\n                >\r\n                <div class=\"controls\">\r\n                  <input\r\n                    type=\"date\"\r\n                    ng-model=\"User.runElectionDate\"\r\n                    class=\"form-control\"\r\n                  />\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div ng-if=\"shownew_office_name && User.RunningForOtherOffice != 1\">\r\n              <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                  >Candidate Status</label\r\n                >\r\n                <div class=\"controls\">\r\n                  <select\r\n                    ng-model=\"User.runStatus\"\r\n                    class=\"form-control\"\r\n                    ng-change=\"selectStatus()\"\r\n                    style=\"width: 36%\"\r\n                  >\r\n                    <option value=\"\">Select Status</option>\r\n                    <option value=\"Announced\">Announced</option>\r\n                    <option value=\"Write in\">Write in</option>\r\n                    <option value=\"Running\">Running</option>\r\n                    <option value=\"Active\">Active</option>\r\n                    <option value=\"Campaign Suspended\">\r\n                      Campaign Suspended\r\n                    </option>\r\n                  </select>\r\n                </div>\r\n              </div>\r\n\r\n              <div\r\n                ng-if=\"shownew_office_name && User.RunningForOtherOffice != 1\"\r\n                class=\"control-group\"\r\n              >\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                  >Election Type</label\r\n                >\r\n                <div class=\"controls\">\r\n                  <select\r\n                    ng-model=\"User.runElecType\"\r\n                    class=\"form-control\"\r\n                    ng-change=\"selectStatus()\"\r\n                    style=\"width: 36%\"\r\n                  >\r\n                    <option value=\"\">Select Election Type</option>\r\n                    <option value=\"Primary\">Primary</option>\r\n                    <option value=\"Run off\">Run off</option>\r\n                    <option value=\"Special\">Special</option>\r\n                    <option value=\"General\">General</option>\r\n                    <option value=\"Presidential Preference\">\r\n                      Presidential Preference\r\n                    </option>\r\n                  </select>\r\n                </div>\r\n              </div>\r\n              <div\r\n                class=\"control-group\"\r\n                id=\"autoOff\"\r\n                ng-if=\"shownew_office_name && shownew_office_nameOther\"\r\n              >\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                  >Office Name?</label\r\n                >\r\n                <div class=\"controls\" mass-autocomplete>\r\n                  <input\r\n                    type=\"text\"\r\n                    ng-model=\"User.office_name\"\r\n                    ng-blur=\"setOfficeRun()\"\r\n                    class=\"form-control input-md text-input\"\r\n                    mass-autocomplete-item=\"autoFill_options\"\r\n                    style=\"width: 88%\"\r\n                  />\r\n                </div>\r\n              </div>\r\n              <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                  >Public Campaign Email</label\r\n                >\r\n                <div class=\"controls\">\r\n                  <input\r\n                    type=\"email\"\r\n                    ng-model=\"User.campEmail\"\r\n                    class=\"form-control input-md text-input\"\r\n                    ng-readonly=\"checkReadOnly\"\r\n                    style=\"width: 88%\"\r\n                  />\r\n                </div>\r\n              </div>\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                  >Public Campaign Phone number (xxx)xxx-xxxx</label\r\n                >\r\n                <div class=\"controls\">\r\n                  <input\r\n                    type=\"tel\"\r\n                    ng-model=\"User.campPhone_no\"\r\n                    data-errormessage-custom-error=\"Invalid phone number.\"\r\n                    class=\"form-control input-md text-input\"\r\n                    style=\"width: 88%\"\r\n                  />\r\n                </div>\r\n              </div>\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                  >Campaign Website</label\r\n                >\r\n                <div class=\"controls\">\r\n                  <input\r\n                    type=\"text\"\r\n                    ng-model=\"User.campWeb_url\"\r\n                    ng-disabled=\"User.organization._id\"\r\n                    class=\"form-control validate[custom[url]] input-md text-input\"\r\n                    style=\"width: 88%\"\r\n                  />\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div ng-if=\"!HideRegisterButton && !HideNewRegisterButton\">\r\n              <div ng-if=\"!shownew_office_name\">\r\n                <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                  <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                    >Email For Account</label\r\n                  >\r\n                  <div class=\"controls\">\r\n                    <input\r\n                      type=\"email\"\r\n                      ng-model=\"User.Email\"\r\n                      data-errormessage=\"Email is required.\"\r\n                      class=\"form-control input-md validate[required] text-input\"\r\n                      ng-readonly=\"checkReadOnly\"\r\n                      style=\"width: 88%; background-color: yellow\"\r\n                    />\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                    >Phone number For Account (xxx)xxx-xxxx</label\r\n                  >\r\n                  <div class=\"controls\">\r\n                    <input\r\n                      type=\"tel\"\r\n                      ng-model=\"User.phone_no\"\r\n                      data-errormessage=\"Phone number is required.\"\r\n                      data-errormessage-custom-error=\"Invalid phone number.\"\r\n                      class=\"form-control input-md validate[required] text-input\"\r\n                      style=\"width: 88%; background-color: yellow\"\r\n                    />\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                    >Website</label\r\n                  >\r\n                  <div class=\"controls\">\r\n                    <input\r\n                      type=\"text\"\r\n                      ng-model=\"User.web_url\"\r\n                      ng-disabled=\"User.organization._id\"\r\n                      class=\"form-control validate[custom[url]] input-md text-input\"\r\n                      style=\"width: 88%\"\r\n                    />\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div ng-if=\"shownew_office_name\">\r\n                <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                  <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                    >Email For Account</label\r\n                  >\r\n                  <div class=\"controls\">\r\n                    <input\r\n                      type=\"email\"\r\n                      ng-model=\"User.Email\"\r\n                      data-errormessage=\"Email is required.\"\r\n                      class=\"form-control input-md validate[required] text-input\"\r\n                      ng-readonly=\"checkReadOnly\"\r\n                      style=\"width: 88%; background-color: yellow\"\r\n                    />\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                    >Phone number For Account (xxx)xxx-xxxx</label\r\n                  >\r\n                  <div class=\"controls\">\r\n                    <input\r\n                      type=\"tel\"\r\n                      ng-model=\"User.phone_no\"\r\n                      data-errormessage=\"Phone number is required.\"\r\n                      data-errormessage-custom-error=\"Invalid phone number.\"\r\n                      class=\"form-control input-md validate[required] text-input\"\r\n                      style=\"width: 88%; background-color: yellow\"\r\n                    />\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                    >Website</label\r\n                  >\r\n                  <div class=\"controls\">\r\n                    <input\r\n                      type=\"text\"\r\n                      ng-model=\"User.web_url\"\r\n                      ng-disabled=\"User.organization._id\"\r\n                      class=\"form-control validate[custom[url]] input-md text-input\"\r\n                      style=\"width: 88%\"\r\n                    />\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n                  >Facebook Url</label\r\n                >\r\n                <div class=\"controls\">\r\n                  <input\r\n                    type=\"text\"\r\n                    ng-model=\"User.facebook_url\"\r\n                    ng-disabled=\"User.organization._id\"\r\n                    class=\"form-control validate[custom[url]] input-md text-input\"\r\n                    style=\"width: 88%\"\r\n                  />\r\n                </div>\r\n              </div>\r\n              <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"firstname\"\r\n                  >Contact Person</label\r\n                >\r\n                <div class=\"controls\">\r\n                  <input\r\n                    ng-if=\"UserType != \'voter\'\"\r\n                    type=\"text\"\r\n                    ng-model=\"User.name\"\r\n                    placeholder=\"\"\r\n                    data-errormessage=\"Name is required.\"\r\n                    class=\"form-control input-md validate[required] text-input\"\r\n                    style=\"width: 88%; background-color: yellow\"\r\n                  />\r\n                </div>\r\n              </div>\r\n              <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"firstname\"\r\n                  >Name On Ballot</label\r\n                >\r\n                <div class=\"controls\">\r\n                  <input\r\n                    ng-if=\"UserType != \'voter\'\"\r\n                    type=\"text\"\r\n                    ng-model=\"User.name_on_ballot\"\r\n                    placeholder=\"\"\r\n                    data-errormessage=\"Name is required.\"\r\n                    class=\"form-control input-md validate[required] text-input\"\r\n                    style=\"width: 88%; background-color: yellow\"\r\n                  />\r\n                </div>\r\n              </div>\r\n              <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"firstname\"\r\n                  >UserName for future Log In</label\r\n                >\r\n                <div class=\"controls\">\r\n                  <input\r\n                    type=\"text\"\r\n                    ng-model=\"User.UserName\"\r\n                    ng-blur=\"CheckUserName()\"\r\n                    placeholder=\"\"\r\n                    data-errormessage=\"UserName is required.\"\r\n                    class=\"form-control input-md validate[required] text-input\"\r\n                    style=\"width: 88%; background-color: yellow\"\r\n                  />\r\n                </div>\r\n              </div>\r\n              <!--    <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"password\"> Create Password</label>\r\n                <div class=\"controls\">\r\n                  <input type=\"password\" id=\"password\" ng-model=\"User.Password\" placeholder=\"\" data-errormessage=\"Password is required.\" class=\"form-control input-md  validate[required] text-input\" style=\"width: 88%\" />\r\n                </div>\r\n              </div> -->\r\n              <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"password\">\r\n                  Password</label\r\n                >\r\n                -\r\n                <a href=\"\" ng-click=\"generatePassword()\" class=\"whiteText ylink\"\r\n                  >Click here to generate Password</a\r\n                >\r\n                <div class=\"controls\">\r\n                  <input\r\n                    type=\"text\"\r\n                    id=\"password\"\r\n                    ng-model=\"User.Password\"\r\n                    placeholder=\"\"\r\n                    ng-readonly=\"true\"\r\n                    data-errormessage=\"Password is required.\"\r\n                    class=\"form-control input-md validate[required] text-input\"\r\n                    style=\"width: 88%; background-color: yellow\"\r\n                  />\r\n                </div>\r\n              </div>\r\n              <!--    <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"password\">Confirm Password</label>\r\n                <div class=\"controls\">\r\n                  <input type=\"password\" id=\"confirm_password\" ng-model=\"ConfirmPassword\" data-errormessage=\"Password and Confirm password do not match.\" placeholder=\"\" class=\"form-control input-md  validate[required,equals[password]] text-input \" style=\"width: 88%\" />\r\n                  <small id=\"message\"></small>\r\n                </div>\r\n              </div> -->\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel whiteText\"\r\n                  >Address for Account</label\r\n                >\r\n                <div class=\"control-group\">\r\n                  <input\r\n                    type=\"text\"\r\n                    id=\"address\"\r\n                    ng-model=\"User.Address\"\r\n                    ng-keyup=\"detectAddress($event)\"\r\n                    class=\"zipInput form-control\"\r\n                    style=\"background-color: yellow\"\r\n                  />&nbsp;\r\n                </div>\r\n              </div>\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"zipcode\"\r\n                  >ZipCode</label\r\n                >\r\n                <div class=\"control-group\">\r\n                  <input\r\n                    type=\"text\"\r\n                    ng-model=\"User.ZipCode\"\r\n                    id=\"zip\"\r\n                    class=\"zipInput form-control\"\r\n                    style=\"background-color: yellow\"\r\n                  />&nbsp;\r\n                </div>\r\n              </div>\r\n              <div style=\"clear: both\"></div>\r\n              <div class=\"btn-style\" style=\"width: 100%; margin-right: 0px\">\r\n                <button\r\n                  class=\"btnShort-style\"\r\n                  ng-if=\"!forFacebook\"\r\n                  ng-click=\"CreateUser()\"\r\n                  type=\"button\"\r\n                  class=\"btn btn-success\"\r\n                  ng-disabled=\"RegisterButton\"\r\n                  style=\"float: right\"\r\n                >\r\n                  submit\r\n                </button>\r\n                <br />\r\n                <br />\r\n              </div>\r\n            </div>\r\n            <div ng-if=\"HideRegisterButton || HideNewRegisterButton\">\r\n              <div class=\"control-group whiteText\">\r\n                <p>\r\n                  Congratulations. We already have you in our system and sent\r\n                  you a password awhile ago to {{shortEmail}}. If you lost the\r\n                  password and want to reset it, click on the link below. If you\r\n                  have other issues call 70-VoteWise\r\n                </p>\r\n              </div>\r\n              <p>Login</p>\r\n              <div\r\n                ng-if=\"!forFacebook\"\r\n                class=\"control-group\"\r\n                style=\"width: 88%\"\r\n              >\r\n                <label class=\"control-label formLabel whiteText\" for=\"firstname\"\r\n                  >UserName/Email</label\r\n                >\r\n                <div class=\"controls\">\r\n                  <input\r\n                    type=\"text\"\r\n                    ng-model=\"User.UserName\"\r\n                    placeholder=\"\"\r\n                    data-errormessage=\"UserName is required.\"\r\n                    class=\"form-control input-md validate[required] text-input\"\r\n                  />\r\n                </div>\r\n              </div>\r\n              <div\r\n                ng-if=\"!forFacebook\"\r\n                class=\"control-group\"\r\n                style=\"width: 88%\"\r\n              >\r\n                <label class=\"control-label formLabel whiteText\" for=\"password\"\r\n                  >Password</label\r\n                >\r\n                <div class=\"controls\">\r\n                  <input\r\n                    type=\"password\"\r\n                    id=\"password\"\r\n                    ng-model=\"User.Password\"\r\n                    placeholder=\"\"\r\n                    data-errormessage=\"Password is required.\"\r\n                    class=\"form-control input-md validate[required] text-input\"\r\n                  />\r\n                </div>\r\n              </div>\r\n              <div style=\"clear: both\"></div>\r\n              <div class=\"btn-style\">\r\n                <button\r\n                  class=\"btnShort-style\"\r\n                  ng-if=\"!forFacebook\"\r\n                  ng-click=\"UserLogin()\"\r\n                  type=\"button\"\r\n                  class=\"btn btn-success\"\r\n                  style=\"float: right; width: 258px; margin-right: 25%\"\r\n                >\r\n                  Update details & Login\r\n                </button>\r\n              </div>\r\n              <div style=\"clear: both\"></div>\r\n              <p style=\"padding-top: 5%; padding-left: 3%; color: white\">\r\n                Forgot password?\r\n              </p>\r\n              <div class=\"btn-style\">\r\n                <button\r\n                  class=\"btnShort-style whiteText\"\r\n                  ng-if=\"!forFacebook\"\r\n                  ng-click=\"resetPassword()\"\r\n                  type=\"button\"\r\n                  class=\"btn btn-success\"\r\n                  style=\"float: right; width: 258px; margin-right: 25%\"\r\n                >\r\n                  Please email me my password\r\n                </button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </fieldset>\r\n  </form>\r\n  <script type=\"text/javascript\">\r\n    jQuery(document).ready(function () {\r\n      // binds form submission and fields to the validation engine\r\n      // binds form submission and fields to the validation engine\r\n      setTimeout(function () {\r\n        $(\"form\").validationEngine();\r\n      }, 500);\r\n    });\r\n  </script>\r\n</div>\r\n<!--  <fieldset ng-if=\"$root.showFacebookLoging\" class=\"scheduler-border\">\r\n    <legend class=\"scheduler-border\">To continue, we need some information from you.</legend>\r\n    <div class=\"control-group\">\r\n      <label class=\"control-label formLabel removeTopMargin\" for=\"firstname\">What type of user are you?</label>\r\n      <div class=\"controls\">\r\n        <select ng-model=\"User.UserType\" style=\"text-transform: capitalize;\" class=\"form-control validate[required]\" ng-change=\"userTypeChanged()\">\r\n          <option ng-repeat=\" item in MUserType\" ng-selected=\"item.name==\'Voter\'\" value=\"{{item.key}}\">{{item.name}}</option>\r\n        </select>\r\n      </div>\r\n    </div>\r\n    <div ng-if=\"User.UserType == \'advocate\'\">\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel whiteText\" for=\"email\">Organization Name</label>\r\n        <div mass-autocomplete>\r\n          <input ng-model=\"User.organization_name\" ng-blur=\"checkExists();\" mass-autocomplete-item=\"org_autocomplete_options\">\r\n        </div>\r\n      </div>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel whiteText\" for=\"email\">Website for organization</label>\r\n        <div class=\"controls\">\r\n          <input type=\"text\" ng-model=\"User.organization.web_url\" ng-disabled=\"User.organization._id\" data-errormessage-custom-error=\"Invalid URL.\" data-errormessage=\"Website for organization is required.\" class=\"form-control input-md  validate[required, custom[url]] text-input\">\r\n        </div>\r\n      </div>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel whiteText\" for=\"email\">Phone number of organization (xxx)xxx-xxxx</label>\r\n        <div class=\"controls\">\r\n          <input type=\"tel\" ng-model=\"User.organization.phone_no\" ng-disabled=\"User.organization._id\" data-errormessage=\"Phone number of organization is required.\" class=\"form-control input-md  validate[required] text-input\">\r\n        </div>\r\n      </div>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel whiteText\" for=\"email\">Your extension number (if any)</label>\r\n        <div class=\"controls\">\r\n\r\n          <input type=\"tel\" ng-model=\"User.extention_no\" class=\"form-control input-md text-input\">\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div ng-if=\"User.UserType == \'press\'\">\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel whiteText\" for=\"email\">Name of Press outlet</label>\r\n        <div mass-autocomplete>\r\n          <input ng-model=\"User.outlet_name\" ng-blur=\"checkExists();\" mass-autocomplete-item=\"org_autocomplete_options\">\r\n        </div>\r\n      </div>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel whiteText\" for=\"email\">Website for press outlet</label>\r\n        <div class=\"controls\">\r\n          <input type=\"text\" ng-model=\"User.outlet_web\" ng-disabled=\"User.organization._id\" data-errormessage-custom-error=\"Invalid URL.\" data-errormessage=\"Website for press outlet is required.\" class=\"form-control input-md  validate[required, custom[url]] text-input\">\r\n        </div>\r\n      </div>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel whiteText\" for=\"email\">Phone number of press outlet (xxx)xxx-xxxx</label>\r\n        <div class=\"controls\">\r\n          <input type=\"tel\" ng-model=\"User.outlet_phone_no\" ng-disabled=\"User.organization._id\" data-errormessage=\"Phone number of press outlet is required.\" class=\"form-control input-md  validate[required] text-input\">\r\n        </div>\r\n      </div>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel whiteText\" for=\"email\">Your extension number (if any)</label>\r\n        <div class=\"controls\">\r\n          <input type=\"text\" ng-model=\"User.press_extension_no\" class=\"form-control input-md text-input\">\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel whiteText\" for=\"zipcode\">ZipCode</label>\r\n        <div class=\"control-group\">\r\n\r\n          <input type=\"text\" ng-model=\"User.ZipCode\" class=\"zipInput form-control validate[required,custom[integer],minSize[5]] text-input\" />\r\n        </div>\r\n      </div>\r\n      <div ng-if=\"showAddressDropDown\">\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel removeTopMargin\" for=\"email\">State </label>\r\n          <div class=\"controls\">\r\n            <select ng-model=\"address.state\" style=\"text-transform: capitalize;\" disabled=\"true\" ng-change=\"getCounties()\" ng-options=\"item.state for item in states track by item.statePostalCode\"></select>\r\n          </div>\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">County </label>\r\n          <div class=\"controls\">\r\n            <select ng-model=\"address.county\" style=\"text-transform: capitalize;\" ng-options=\"item._id.county for item in counties track by item._id.county\" ng-change=\"onCountyChange()\"></select>\r\n          </div>\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Sub county </label>\r\n          <div class=\"controls\">\r\n            <select ng-model=\"address.countySubdivision\" style=\"text-transform: capitalize;\" ng-options=\"countySubdivision as item._id.countySubdivision for item in places | unique:\'_id.countySubdivision\' track by item._id.countySubdivision\" ng-change=\"onSubCountyChange()\"></select>\r\n          </div>\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">City </label>\r\n          <div class=\"controls\">\r\n            <select ng-model=\"address.place\" style=\"text-transform: capitalize;\" ng-options=\"item as item._id.place for item in places | filter:emptyOrNull\"></select>\r\n          </div>\r\n\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Voter District (click if incorrect) </label>\r\n          <div class=\"controls\">\r\n            <select ng-model=\"address.voterDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item.voterDistrictName for item in voterDistricts | unique:\'voterDistrictName\' track by item.voterDistrictName\" ng-change=\"onVoterDistChange()\"></select>\r\n          </div>\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Federal Congressional District (click if incorrect) </label>\r\n          <div class=\"controls\">\r\n            <select ng-model=\"address.federalCongrassionalDist\" style=\"text-transform: capitalize;\" ng-options=\"item as item.federalCongrassionalDist for item in federalCongrassionalDist | unique:\'federalCongrassionalDist\' track by item.federalCongrassionalDist\"></select>\r\n          </div>\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">State Senate District (click if incorrect) </label>\r\n          <div class=\"controls\">\r\n            <select ng-model=\"address.stateSenateDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item.stateSenateDistrict for item in stateSenateDistrict | unique:\'stateSenateDistrict\' track by item.stateSenateDistrict\"></select>\r\n          </div>\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">State House of Representative District (click if incorrect) </label>\r\n          <div class=\"controls\">\r\n            <select ng-model=\"address.stateHouseOFRepresentativeDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item.stateHouseOFRepresentativeDistrict for item in stateHouseOFRepresentativeDistricts | unique:\'stateHouseOFRepresentativeDistrict\' track by item.stateHouseOFRepresentativeDistrict\"></select>\r\n          </div>\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">School District Name (click if incorrect) </label>\r\n          <div class=\"controls\">\r\n            <select ng-model=\"address.unifiedSchoolDistrictName\" style=\"text-transform: capitalize;\" ng-options=\"item as item.unifiedSchoolDistrictName for item in unifiedSchoolDistrictNames | unique:\'unifiedSchoolDistrictName\' track by item.unifiedSchoolDistrictName\"></select>\r\n          </div>\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <p>\r\n            Don\'t know your info?\r\n            <a ng-click=\"showFindAddress();\" class=\"ylink\">Click Here</a>\r\n\r\n          </p>\r\n        </div>\r\n        <div style=\"clear: both;\"></div>\r\n      </div>\r\n    </div>\r\n    <div style=\"clear: both;\"></div>\r\n    <br />\r\n    <button ng-click=\"LoginWithFacebook()\" type=\"button\" class=\"btn btn-primary\" style=\"float: left;\">Continue To Sign Up Using Facebook</button>\r\n    <div style=\"clear: both;\"></div>\r\n    <p ng-if=\"!HideRegisterButton && !HideNewRegisterButton\">\r\n      <button ng-click=\"ShowFB()\" type=\"button\" class=\"btnB275\" style=\"float: left;\"> Regular Signup</button>\r\n    </p>\r\n  </fieldset> -->\r\n");
$templateCache.put("app/addRating/addRating.html","<div class=\"container-fluid add-rating-container\" ng-cloak\r\n  ng-show=\"$root.userRole==\'admin\'|| $root.userRole==\'advocate\'|| $root.userRole==\'politician\'\">\r\n  <h2 class=\"pageHeading\" ng-if=\"!isEdit\">Add Rating</h2>\r\n  <h2 class=\"pageHeading\" ng-if=\"isEdit\">Edit Rating</h2>\r\n\r\n  <div class=\"row d-lg-flex\">\r\n    <div class=\"col-lg-12\">\r\n      <!-- <fieldset class=\"scheduler-border\">\r\n        <legend class=\"scheduler-border\">Choose</legend>\r\n        <label>\r\n          <input type=\"radio\" name=\"geographic-focus\" value=\"politician\" ng-model=\"locationIntrest\" ng-change=\"getUsers(\'politician\')\"\r\n          /> Politician\r\n        </label>\r\n        <label>\r\n          <input type=\"radio\" name=\"geographic-focus\" value=\"organization\" ng-model=\"locationIntrest\" ng-change=\"getUsers(\'advocate\')\"\r\n          /> Organization\r\n        </label>\r\n        <label>\r\n          <input type=\"radio\" name=\"geographic-focus\" value=\"press\" ng-model=\"locationIntrest\" ng-change=\"getUsers(\'press\')\"> Press\r\n        </label>\r\n        <label>\r\n          <input type=\"radio\" name=\"geographic-focus\" value=\"yourself\" ng-model=\"locationIntrest\" ng-change=\"reviewYourself()\"> Reviews of Yourself\r\n        </label>\r\n        <br>\r\n      </fieldset> -->\r\n    </div>\r\n  </div>\r\n  <form ng-submit=\"submitReview()\" name=\"myform\" id=\"myform\">\r\n\r\n    <div class=\"row d-lg-flex\">\r\n\r\n      <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\">\r\n        <div ng-if=\"selectionType != \'yourself\'\">\r\n          <div class=\"control-group\" id=\"auto-user-suggest-box\">\r\n            <label class=\"control-label\" for=\"title\" style=\"text-transform: capitalize;\">Selected {{locationIntrest}}</label>&nbsp;&nbsp;<i ng-if=\"showLoader \" class=\"fa fa-refresh fa-spin fa-1x fa-fw \"></i>\r\n            <div class=\"controls\" mass-autocomplete>\r\n              <input ng-model=\'selectedUser.value\' ng-disabled=\"true\" class=\"form-control\" />\r\n                </div>\r\n            </div>\r\n            <div class=\"control-group\" ng-if=\"politiicanId==userId\" id=\"auto-referal-suggest-box\">\r\n              <label class=\"control-label\">Review From</label>\r\n              <div class=\"controls\" mass-autocomplete>\r\n                <!-- <input ng-model=\'review.referal\' class=\"form-control\" /> -->\r\n                <input ng-model=\'selectedReferal.value\' mass-autocomplete-item=referal_options class=\"matrix-cell form-control\" />\r\n                </div>\r\n              </div>\r\n              <br />\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label\" for=\"grade\" style=\"text-transform: capitalize;\">Select Grade 0-100</label>\r\n                <div class=\"controls\">\r\n                  <input type=\"number\" name=\"rating\" ng-model=\"review.grade.number\" class=\"form-control validate[required]\"  min=\"0\" max=\"100\"/>\r\n                  <div role=\"alert\">\r\n                    <span class=\"error\" ng-show=\"myform.rating.$dirty && myform.rating.$error.number\">Please Add Valid Number</span>\r\n                    <span class=\"error\" ng-show=\"myform.rating.$dirty && myform.rating.$error.required\">Required field</span>\r\n\r\n                  </div>\r\n\r\n                  <br />\r\n\r\n\r\n                  <!--\r\n                  <input type=\"radio\" ng-model=\"review.grade.letter\" value=\"a\"> A\r\n                  <input type=\"radio\" ng-model=\"review.grade.letter\" value=\"b\"> B\r\n                  <input type=\"radio\" ng-model=\"review.grade.letter\" value=\"c\"> C\r\n                  <input type=\"radio\" ng-model=\"review.grade.letter\" value=\"d\"> D\r\n                  <input type=\"radio\" ng-model=\"review.grade.letter\" value=\"e\"> E\r\n                  <input type=\"radio\" ng-model=\"review.grade.letter\" value=\"f\"> F\r\n                  <br />\r\n                  <br />\r\n                  <input type=\"radio\" ng-model=\"review.grade.like\" value=\"true\">\r\n                  <img src=\"../assets/images/thumbsup.svg\" ng-click=\"setLike(\'like\');\" style=\"cursor: pointer;margin-left: 0px;height: 30px;width: 30px;\"\r\n                    alt=\"Like\">\r\n                  <input type=\"radio\" ng-model=\"review.grade.like\" value=\"false\">\r\n                  <img src=\"../assets/images/thumbsdown.svg\" ng-click=\"setLike(\'dislike\');\" style=\"cursor: pointer;margin-left: 10px;height: 30px;width: 30px;\" alt=\"Dislike\">\r\n                  -->\r\n                </div>\r\n              </div>\r\n              <br />\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label\" for=\"title\" ng-if=\"politiicanId!=userId\" style=\"text-transform: capitalize;\">Write Review</label>\r\n                <label class=\"control-label\" for=\"title\" ng-if=\"politiicanId==userId\" style=\"text-transform: capitalize;\">Copy Outside Review</label>\r\n                <div class=\"controls\">\r\n                  <textarea ng-model=\"review.text\" class=\"form-control\"></textarea>\r\n                </div>\r\n              </div>\r\n              <br />\r\n              <!-- <div class=\"control-group\">\r\n                <label class=\"control-label\" for=\"title\" style=\"text-transform: capitalize;\">Relevent Links</label>\r\n                <div class=\"controls\">\r\n                  <textarea ng-model=\"review.links\" class=\"form-control\"></textarea>\r\n                </div>\r\n              </div> -->\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label\" for=\"title\" style=\"text-transform: capitalize;\">Links to outside reviews or other relevant items</label>\r\n                <div class=\"controls\">\r\n                  <input type=\"text\" ng-model=\"review.links[0]\" class=\"form-control\" />\r\n                  <br />\r\n                  <input type=\"text\" ng-model=\"review.links[1]\" class=\"form-control\" />\r\n                  <br />\r\n                  <input type=\"text\" ng-model=\"review.links[2]\" class=\"form-control\" />\r\n                </div>\r\n                </div>\r\n              </div>\r\n\r\n              <!-- <a ng-click=\"submitReview()\" class=\"donateBtn btn\" style=\"width: auto;margin-top: 20px;margin-left: 0;\">Submit Review</a> -->\r\n              <button type=\"submit\" class=\"donateBtn btn\"  style=\"width: auto;margin-top: 20px;margin-left: 0;\">Submit Review</button>\r\n            </div>\r\n  </form>\r\n\r\n</div>\r\n\r\n\r\n</div>\r\n");
$templateCache.put("app/advocateHome/advocateHome.html","<head>\r\n\r\n  <title>Advocate_Home</title>\r\n  <!-- This next line keeps buttons and forms at a legible size on cell phones -->\r\n  <meta name=\"viewport\" content=\"initial-scale=1, maximum-scale=1\">\r\n</head>\r\n\r\n\r\n\r\n<!-- This is the end of the header -->\r\n\r\n<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">ORGANIZATIONS</h2>\r\n  <p class=\"pageSubHeading\">There are thousands of organizations out there that are trying every day to fix the many\r\n    broken things about our society. </p>\r\n  <div class=\"row d-flex justify-content-center\">\r\n    <div class=\"col col-lg-9 col-med-12 col-sm-12 col-12 colPadding1\">\r\n      <div class=\"row\">\r\n        <div class=\"col-lg-12 col-sm-12 learnHeader\">\r\n          <img ng-src=\"./assets/images/Organizations.svg\" class=\"blockInfoImgLearn img-fluid\">\r\n          <div id=\"blockInfoLearn3\">\r\n            <div>\r\n              <h4 class=\"blockTitleLearn\">CHOOSE A CAUSE</h4>\r\n              <span class=\"blockDesc\"> Pick a topic and find organizations that match your vision of the future so you can help each other make the world a better place.</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"newUserLearn\">\r\n          <form class=\"ng-pristine ng-valid\">\r\n            <div>\r\n              <!-- This is the Start of the subject assets/images -->\r\n\r\n              <p class=\"fwb\" ng-if=\"statusGetEssayCat == 1\">Loading categories...</p>\r\n              <p class=\"fwb\" ng-if=\"statusGetEssayCat == 2 && categories.length <= 0\">No category available to select\r\n              </p>\r\n              <a ng-repeat=\"item in categories | orderBy: \'order\'\" ng-href=\"#!/presshome/advocate/{{item.title | escape}}/{{item._id}}\" title=\"{{item.title}}\" style=\"padding: 10px 0px;\">\r\n	<div class=\"allTopics\">\r\n                  <img src=\"{{imgUrl}}/{{item.iconImage}}\" alt=\"{{item.title}}\" />\r\n                  <span>{{item.title}}</span>\r\n                </div>\r\n\r\n</a>\r\n\r\n            </div>\r\n            <!--     BRING BACK\r\n     <br><br>\r\n<a href=\"#!/ratingReviews\">See a Quick Match here.</a>\r\n-->\r\n");
$templateCache.put("app/advocateSignup/advocateSignup.html","<head>\r\n<title>Press and Interest Groups</title>\r\n<!-- This next line keeps buttons and forms at a legible size on cell phones -->\r\n<meta name=\"viewport\" content=\"initial-scale=1, maximum-scale=1\">\r\n</head>\r\n<div>\r\n    <div>\r\n<p align = left>\r\nPress and Interest Groups play a key part in informing the voters and the politicians about the issues &#8211 locally and across the country. In the current launch, we teach the users about the issues by asking the users questions that inform them while poling them at the same time.  We have over a thousand questions written, but there is a very good chance that we missed many things that are vital to your interests.  We invite you to review our questions and suggest more. </p>\r\n\r\n\r\n<p>In future launches, we will be posting essays from Interest Groups and the Press.  Users of all kinds will be able to comment on the quality of the information, how useful the essay is, and how pro or con the essay is about the issue. </p>\r\n\r\n\r\n<p>A user forum will also be added that will (among other things) allow Press to rate the performance of local officials based on the promises they made.  And special interest groups will be able to form chat groups and organize people on a local level.  Press will also be able to ask politicians questions in online debates.</p>\r\n\r\n<p>There are many other functions on the way.  It is a great way to engage your audience.  If you would like to see our current set of questions, submit questions of your own, or essays to be posted in the next launch, please don&#8217t hesitate to contact us at the appropriate email below. </p>\r\n<br>\r\nPress@SilentMonkeys.com <div>\r\nInterestGroups@SilentMonkeys.com\r\n<br>\r\n<br>\r\n<br>\r\n<br>\r\n<p> VoteWise is a project of Silent Monkeys Inc. Silent Monkeys is a Not-for-Profit 501(c)(3) organization. We do not endorse any political party, candidate or legislation. Donations are tax deductible.</p>\r\n\r\n<p>The official registration and financial information of Silent Monkeys may be obtained from the Pennsylvania Department of State by calling toll free, within Pennsylvania, 1 (800) 732-0999. Registration does not imply endorsement.\r\n</p>\r\n\r\n</div>\r\n\r\n");
$templateCache.put("app/allCongressman/allCongressman.html","<div class=\"container-fluid ng-scope\" ng-cloak ng-show=\"$root.userRole==\'admin\'\">\r\n  <h2 class=\"pageHeading\">Settings</h2>\r\n  <div>\r\n    <div class=\"closeForm\" ng-include=\"\'app/popups/setting_Ctrl.html\'\"></div>\r\n  </div>\r\n  <!-- All Congressman Start -->\r\n  <form ng-if=\"$root.showAllCongressman\" name=\"showAllCongressman\" id=\"showAllCongressman\"\r\n    ng-controller=\"AllCongressmanCtrl\" class=\"closeForm textColor\">\r\n    <h2 style=\"color:#ffffff;\">Congressmen in the House</h2>\r\n    <p class=\"whiteText\">This is the list of current congressmen from Propublica. If it says \"Present in Database\" then\r\n      it matches downloads from VoteSmart or wherever else we are getting data. Clicking \"yes\" will take you to their\r\n      public profile page. If they aren\'t in our database, then you will see the \"Find\" link which will take you to\r\n      another view of this same page which includes a tool that finds names in the VoteSmart database that closely match\r\n      that user and you can \"Add\" an association to the VoteSmart database. The names that appear on incumbent pages and\r\n      candidate pages are currently gotten from the VoteSmart database. Information about the politician on the public\r\n      profile page is partially gotten from Propublica. I\'m not sure if this is linked to the xlxs uploads or not.</p>\r\n    <a href=\"javascript: void(0);\" ng-click=\"currentCongressman();\" class=\"ylink\">Get current Congressmen</a> &nbsp;\r\n    &nbsp;\r\n    <i ng-if=\"showLoader\" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>\r\n    <br />\r\n    <br />\r\n    <!-- <p ng-click=\"findCongressmenMismatch()\">Find Mismatch</p> -->\r\n    <div ng-show=\"allCongressman\">\r\n      <div class=\"form-group row\">\r\n        <label for=\"selChamber\" class=\"col-lg-2 col-sm-5 col-form-label\" style=\"color:#ffffff;\">Select Chamber :\r\n        </label>\r\n        <div class=\"col-lg-5 col-sm-5\">\r\n          <select ng-model=\"selChamber.chamber\" class=\"form-control\" style=\"width:170px;\">\r\n            <option value=\"\">Select Chamber</option>\r\n            <option value=\"house\">House</option>\r\n            <option value=\"senate\">Senate</option>\r\n          </select>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div ng-show=\"allCongressman\">\r\n      <div class=\"form-group row\">\r\n        <label for=\"selDbPresent\" class=\"col-lg-2 col-sm-5 col-form-label\" style=\"color:#ffffff;\">Present in Database :\r\n        </label>\r\n        <div class=\"col-lg-5 col-sm-5\">\r\n          <select ng-model=\"selDbPresent.present\" class=\"form-control\" style=\"width:170px;\">\r\n            <option value=\"\">Select Option</option>\r\n            <option value=\"Y\">Yes</option>\r\n            <option value=\"N\">No</option>\r\n          </select>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"form-group row\" ng-show=\"allCongressman\">\r\n      <label for=\"searchCongressmen\" class=\"col-lg-2 col-sm-5 col-form-label\" style=\"color:#ffffff;\">Name : </label>\r\n      <div class=\"col-lg-5 col-sm-5\">\r\n        <input type=\"text\" ng-model=\"searchCongressmen\" id=\"searchCongressmen\" class=\"form-control\" placeholder=\"Search by Name\"\r\n          style=\"width:170px;\">\r\n      </div>\r\n      </div>\r\n      <div ng-if=\"allCongressman\">\r\n        <div class=\"row\" ng-if=\"allCongressmanData.length > 0\" style=\"margin-top: 10px;\">\r\n          <table class=\"w100\">\r\n            <tr>\r\n              <th style=\"width:70%;\">Name</th>\r\n              <th style=\"width:10%;\">Chamber</th>\r\n              <th style=\"width:10%;\">Party</th>\r\n              <th style=\"width:10%;\">Present In Database</th>\r\n            </tr>\r\n            <tr\r\n              ng-repeat=\"u in allCongressmanData | filter:{chamber: selChamber.chamber,presentInDB: selDbPresent.present} | filter:searchMe\">\r\n              <td>\r\n                <strong>{{u.firstName}} {{u.lastName}}</strong>\r\n                <p>\r\n                  <b>Title:</b> {{u.title}},\r\n                  <b>State:</b> {{u.state}},\r\n                  <b>Office:</b> {{u.office}}</p>\r\n              </td>\r\n              <td>\r\n                {{u.chamber}}\r\n              </td>\r\n              <td>\r\n                {{u.party}}\r\n              </td>\r\n              <td>\r\n                <!-- {{u.presentInDB}} -   {{u.userId}} - {{u.politicianId}}-->\r\n                <a href=\"#!/publicProfile/{{u.userId}}/false\" class=\"link\" ng-if=\"u.presentInDB==\'Y\' && u.userId && !u.politicianId\">Yes</a>\r\n                <a href=\"#!/publicProfile/{{u.politicianId}}/true\" class=\"link\" ng-if=\"u.presentInDB==\'Y\' && u.politicianId && !u.userId\">Yes</a>\r\n                <a href=\"\" ng-click=\"matchMembers(u)\" class=\"link\" ng-if=\"u.presentInDB==\'N\'\">Find</a>\r\n              </td>\r\n            </tr>\r\n          </table>\r\n        </div>\r\n      </div>\r\n      <div ng-if=\"!allCongressman\" style=\"margin-top: 10px;\">\r\n        <div class=\"ylink\" ng-click=\"back()\">Back</div>\r\n        <div class=\"form-group row\" style=\"color:#ffffff;display:block;text-align:center;\">\r\n          <p>\r\n            <h3>{{propublicaData.firstName}} {{propublicaData.lastName}}</h3>\r\n          </p>\r\n          <p> {{propublicaData.title}},{{propublicaData.state}},{{propublicaData.office}}\r\n          </p>\r\n        </div>\r\n        <div class=\"alert alert-danger alert-dismissible\" ng-if=\"alert_msg\" style=\"width:40%;margin-left:\r\n            28% \">\r\n          <button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button>\r\n          <strong>Record Not Found</strong>\r\n        </div>\r\n        <div>\r\n          <div class=\"form-group row\">\r\n            <label for=\"selectCandidate\" class=\"col-lg-2 col-sm-5 col-form-label\" style=\"color:#ffffff; \">Filter :\r\n          </label>\r\n            <div class=\"col-lg-5 col-sm-5\">\r\n              <select ng-model=\"selectCandidate.selectCandy\" class=\"form-control\" style=\"width:170px;\">\r\n              <option value=\"\">Select</option>\r\n              <option value=\"user\">User</option>\r\n              <option value=\"politician\">Politicians</option>\r\n            </select>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"alert alert-success alert-dismissible\" id=\"alert\" ng-if=\"success_msg\" style=\"width:40%;margin-left:\r\n            28%\">\r\n          <button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button>\r\n          <strong>Politician matched successfully to local database</strong>\r\n        </div>\r\n        <table class=\"w100\" ng-show=\"allmatchData.user.length > 0 || allmatchData.politicians.length > 0 \">\r\n          <tr>\r\n            <th style=\"width:50%;\">Name</th>\r\n            <th style=\"width:30%;\">office</th>\r\n            <th style=\"width:20%;\">Add</th>\r\n            <!-- <th style=\"width:10%;\">Party</th>\r\n                <th style=\"width:10%;\">Present In Database</th> -->\r\n          </tr>\r\n          <tr ng-repeat=\"u in allmatchData.politicians\" ng-if=\"selectCandidate.selectCandy==\'politician\'\">\r\n            <td>\r\n              {{u.name}}&nbsp;&nbsp; &nbsp;\r\n              <a href=\"\" class=\"link\" ng-if=\"!more[u._id]\" ng-click=\"getDetailsOfCandidates(u._id);\">More</a>\r\n              <div ng-if=\"more[u._id]\">\r\n                <h6 ng-if=\"u.incumbent\">incumbent: {{u.incumbent}}</h6>\r\n                <h6 ng-if=\"u.party\">Party: {{u.party}}</h6>\r\n                <h6 ng-if=\"u.federalCongressionalDistrict\">federalCongressionalDistrict:\r\n                  {{u.federalCongressionalDistrict}}</h6>\r\n                <h6 ng-if=\"u.voterScope\">voterScope: {{u.voterScope}}</h6>\r\n                <h6 ng-if=\"u.statePostalCode\">statePostalCode: {{u.statePostalCode}}</h6>\r\n                <h6 ng-if=\"u.runningForOffice\">runningForOffice: {{u.runningForOffice}}</h6>\r\n                <h6 ng-if=\"u.openFecId\">openFecId: {{u.openFecId}}</h6>\r\n                <a href=\"\" ng-if=\"more[u._id]\" class=\"link\" ng-click=\"showLess(u._id)\">Less</a>\r\n              </div>\r\n            </td>\r\n            <td>\r\n              {{u.office}}\r\n            </td>\r\n            <td>\r\n              <a href=\"\" ng-click=\"addMatchCandidates(u._id,\'politician\')\" class=\"link\">Add</a>\r\n            </td>\r\n          </tr>\r\n          <tr ng-repeat=\"u in allmatchData.user\" ng-if=\"selectCandidate.selectCandy==\'user\'\">\r\n            <td>\r\n              {{u.name}} &nbsp;&nbsp; &nbsp;\r\n              <a href=\"\" class=\"link\" ng-if=\"!more[u._id]\" ng-click=\"getDetailsOfCandidates(u._id);\">More</a>\r\n              <div ng-if=\"more[u._id]\">\r\n                <h6 ng-if=\"u.email[0]\">Email: {{u.email[0]}}</h6>\r\n                <h6 ng-if=\"u.address.place\">Address: {{u.address.place}}</h6>\r\n                <h6 ng-if=\"u.userType\">Usertype: {{u.userType}}</h6>\r\n                <a href=\"\" ng-if=\"more[u._id]\" class=\"link\" ng-click=\"showLess(u._id)\">Less</a>\r\n              </div>\r\n            </td>\r\n            <td>\r\n              {{u.politicianInfo[0].officeName}}\r\n            </td>\r\n            <td>\r\n              <a href=\"\" ng-click=\"addMatchCandidates(u._id, \'user\') \" class=\"link \">Add</a>\r\n            </td>\r\n          </tr>\r\n        </table>\r\n      </div>\r\n  </form>\r\n</div>\r\n");
$templateCache.put("app/allEndorsements/allEndorsements.html","<!-- <div id=\"background\"></div> -->\r\n<div class=\"container-fluid\">\r\n  <!-- <div class=\"back-btn-wrapper\">\r\n    <a href=\"\" ng-click=\"BackToPrev()\" class=\"ylink\">Back</a>\r\n  </div> -->\r\n  <h2 class=\"pageHeading\">ENDORSEMENTS<br>\r\n    <a href=\"#!/publicProfile/{{selectedPolitician}}/true\" class=\"hoverYellow\">{{username}} </a>\r\n  </h2>\r\n  <p class=\"pageSubHeading\">An \"Endorsement\" is a person or an organization\'s official public choice to say you should\r\n    vote for this option over all other options.\r\n  </p>\r\n  <div class=\"row\">\r\n    <div class=\"col-lg-12\">\r\n      <div id=\"topHeader\">\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <!-- Small Screen -->\r\n  <div class=\"row d-lg-none\">\r\n    <div class=\"col-12\">\r\n      <!--\r\n      <img ng-src=\"./assets/images/yourPoliticansIcon200.jpg\" class=\"politicianIconSmall img-fluid\">\r\n-->\r\n      <div>\r\n        <div id=\"descContainer\">\r\n        </div>\r\n        <div id=\"selectBoxContainer\">\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div>\r\n    <div class=\"col-lg-12 col-centered\" id=\"compareContent\">\r\n      <div class=\"tableContainer\">\r\n        <div class=\"alert alert-success alert-dismissible\" id=\"alert\" ng-if=\"success_msg\" style=\"width:40%;margin-left:\r\n            28%\">\r\n          <button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button>\r\n          <strong>Endorsement added Sucessfully</strong>\r\n        </div>\r\n        <center>\r\n          <h3 style=\"text-transform: capitalize; color:#fff;\">ENDORSEMENTS</h3>\r\n        </center>\r\n        If you are signed in, the endorsements are listed in order of best match to you, but you can reorder by clicking\r\n        any of the headers. Click on an endorser to learn more about them.\r\n        <br>\r\n        <br>\r\n        <!-- <div class=\"table-responsive\">\r\n          <center>\r\n            <div class=\"w-50\">\r\n              <form>\r\n                <div class=\"form-group row\">\r\n                  <label for=\"inputEmail3\" class=\"col-sm-2 col-form-label\">Reviewer</label>\r\n                  <div class=\"col-sm-10\">\r\n                    <input type=\"text\" class=\"form-control\" ng-model=\"search.name\" id=\"inputEmail3\" placeholder=\"Reviewer\">\r\n                  </div>\r\n                </div>\r\n                <div class=\"form-group row has-error has-feedback\">\r\n                  <label for=\"inputPassword3\" class=\"col-sm-2 col-form-label\">Rating</label>\r\n                  <div class=\"col-sm-3\">\r\n                    <input type=\"number\" class=\"form-control\" ng-model=\"search.rangeMin\" id=\"inputPassword3\" min=\"0\" max=\"80\" placeholder=\"Min\">\r\n                  </div>\r\n                  <div class=\"col-sm-3\">\r\n                    <input type=\"number\" class=\"form-control\" ng-model=\"search.rangeMax\" id=\"inputPassword3\" min=\"20\" max=\"100\" placeholder=\"Max\">\r\n                  </div>\r\n                </div>\r\n                <div class=\"form-group row\">\r\n                  <div class=\"col-lg-4 center-block\">\r\n                    <button type=\"button\" ng-click=\"searchRecord(search)\" class=\"btn\">Search</button>\r\n                  </div>\r\n                </div>\r\n              </form>\r\n            </div>\r\n          </center>\r\n        </div> -->\r\n        <div class=\"table-responsive\">\r\n          <table class=\"table table-striped\" style=\"margin-bottom:0px;\">\r\n            <tr>\r\n              <th class=\"tableHead\">\r\n                <span ng-click=\"sortSearch(\'name\')\" style=\"cursor:pointer; text-decoration:underline;\" class=\"hoverYellow\">Endorser</span>&nbsp;<i ng-if=\"nameUp\" class=\"fa fa-arrow-circle-up\"></i><i ng-if=\"nameDown\" class=\"fa fa-arrow-circle-down\"></i>\r\n              </th>\r\n              <!-- <th class=\"tableHead\">Subject</th> -->\r\n              <th class=\"tableHead\">\r\n                <span ng-click=\"sortSearch(\'endorsement\')\" style=\"cursor:pointer; text-decoration:underline;\" class=\"hoverYellow\">Match to you</span>&nbsp;<i ng-if=\"ratingUp\" class=\"fa fa-arrow-circle-up\"></i><i ng-if=\"ratingDown\" class=\"fa fa-arrow-circle-down\"></i>\r\n              </th>\r\n              <!--\r\n            <th class=\"tableHead\"><span ng-click=\"sortSearch(\'date\')\" style=\"cursor:pointer; text-decoration:underline;\">Date</span>&nbsp;<i ng-if=\"dateUp\" class=\"fa fa-arrow-circle-up\"></i><i ng-if=\"dateDown\" class=\"fa fa-arrow-circle-down\"></i></th>\r\n-->\r\n              <th class=\"tableHead\">Details</th>\r\n              <!-- <th class=\"tableHead\">View</th>\r\n              <!-- <th class=\"tableHead\">Your Match</th> -->\r\n            </tr>\r\n            <tr ng-repeat=\"endorsement in allEndorsements\">\r\n              <td class=\"tableRow\" ng-if=\"endorsement.name\">\r\n                <img ng-src=\"../assets/images/profile/{{item.returndata.createdby.utype}}.svg\" ng-if=\"item.returndata.createdby.utype\" class=\"usertype\"><a href=\"#!/pressProfile/{{endorsement._id}}\" ng-if=\"endorsement.userType == \'advocate\' && endorsement.isEmailVerified && endorsement.verifiedUser\" style=\"text-transform: capitalize;\" class=\"link\">{{endorsement.name}}</a>\r\n                <b ng-if=\"endorsement.userType == \'advocate\' && !endorsement.isEmailVerified || !endorsement.verifiedUser\" style=\"text-transform: capitalize;\">{{endorsement.tempName}}</b>\r\n                <span ng-if=\"endorsement.tempName && endorsement.userType == \'advocate\' && !endorsement.isEmailVerified || !endorsement.verifiedUser\" style=\"text-transform: capitalize;\">*</span>\r\n                <a href=\"#!/publicProfile/{{endorsement._id}}\" ng-if=\"endorsement.userType == \'politician\'  && endorsement.isEmailVerified && endorsement.verifiedUser\" style=\"text-transform: capitalize;\">{{endorsement.name}}</a>\r\n              </td>\r\n              <!-- <td class=\"tableRow\"></td> -->\r\n              <td class=\"tableRow\">\r\n                <b ng-if=\"endorsement.match != 0\">{{endorsement.match}}%</b>\r\n                <b ng-if=\"endorsement.match == 0\">N/A</b>\r\n              </td>\r\n              <!-- <td class=\"tableRow\">{{endorsement.endorsecreatedOn | date}}</td> -->\r\n              <td class=\"tableRow\">\r\n                <a href=\"\" ng-if=\"endorsement.note !=\'\'\" ng-click=\"getNotes(endorsement.note)\" class=\"link\">View</a>\r\n                <span ng-if=\"!endorsement.note\">N/A</span>\r\n                <span ng-if=\"endorsement._id == userId\">&nbsp; <a href=\"#!/addEndorsement/{{selectedPolitician}}/true\" class=\"link\">Edit</a></span>\r\n\r\n              </td>\r\n              <!-- <td class=\"tableRow\"></td> -->\r\n            </tr>\r\n          </table>\r\n          <center>\r\n            <div ng-if=\"loader\" style=\"z-index: 2; background:black;\">\r\n              <i class=\"fa fa-refresh fa-spin loader-stly\"></i><br><span class=\"loader-text\">LOADING. PLEASE WAIT.</span>\r\n            </div>\r\n\r\n          </center>\r\n          <p>* \"Unknown Organizations\" have not yet been confirmed</p>\r\n        </div>\r\n        <!-- <div class=\"table-responsive\">\r\n          <table class=\"table table-striped\" style=\"margin-bottom:0px;\">\r\n            <tr>\r\n              <th class=\"tableHead\">endorsementer\r\n                <i class=\"fa fa-caret-down\"></i>\r\n              </th>\r\n\r\n              <th class=\"tableHead\">Subject\r\n                <i class=\"fa fa-caret-down\"></i>\r\n              </th>\r\n              <th class=\"tableHead\">Rating\r\n                <i class=\"fa fa-caret-down\"></i>\r\n              </th>\r\n              <th class=\"tableHead\">Details</th>\r\n              <th class=\"tableHead\">Your Match\r\n                <i class=\"fa fa-caret-down\"></i>\r\n              </th>\r\n            </tr>\r\n            <tr>\r\n\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/pressProfile/57fb97f355e195b227f91db3\">\r\n                  Southern Poverty Law Center</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                Crime and Punishment\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  C</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  VIEW</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                97%\r\n              </td>\r\n            </tr>\r\n\r\n            <tr>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/pressProfile/57fb97f355e195b227f91db3\">\r\n                  Southern Poverty Law Center</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                Environment\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  A</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  VIEW</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                91%\r\n              </td>\r\n            </tr>\r\n\r\n            <tr>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/pressProfile/57fb97f355e195b227f91db3\">\r\n                  Turtles Against Speed</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                Quality of Life\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                A\r\n              </td>\r\n              <td class=\"tableRow\">-\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                80%\r\n              </td>\r\n            </tr>\r\n\r\n            <tr>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/pressProfile/57fb97f355e195b227f91db3\">\r\n                  Speedy Snails</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                Quality of Life\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  F</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  VIEW</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                -\r\n              </td>\r\n            </tr>\r\n\r\n            <tr>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/pressProfile/57fb97f355e195b227f91db3\">\r\n                  Justice Center</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                All\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  YES</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  VIEW</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                -\r\n              </td>\r\n            </tr>\r\n\r\n            <tr>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/pressProfile/57fb97f355e195b227f91db3\">\r\n                  Automotive Employees</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                All\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  47%</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  VIEW</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                20%\r\n              </td>\r\n            </tr>\r\n\r\n            <tr>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/pressProfile/57fb97f355e195b227f91db3\">\r\n                  Cats Against Humanity</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                Environment\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  A</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  VIEW</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                15%\r\n              </td>\r\n            </tr>\r\n\r\n            <tr>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/pressProfile/57fb97f355e195b227f91db3\">\r\n                  Dogs Against Humanity</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                Environment\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  A</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  VIEW</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                -\r\n              </td>\r\n            </tr>\r\n\r\n            <tr>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/pressProfile/57fb97f355e195b227f91db3\">\r\n                  Muskrats Against Humanity</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                Environment\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  A</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  VIEW</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                47%\r\n              </td>\r\n            </tr>\r\n\r\n            <tr>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/pressProfile/57fb97f355e195b227f91db3\">\r\n                  Planets Against Humanity</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                Environment\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  A</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  VIEW</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                23%\r\n              </td>\r\n            </tr>\r\n\r\n            <tr>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/pressProfile/57fb97f355e195b227f91db3\">\r\n                  Dr Who Saves Humanity</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                Environment\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                A\r\n              </td>\r\n              <td class=\"tableRow\">-\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                -\r\n              </td>\r\n            </tr>\r\n\r\n            <tr>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/pressProfile/57fb97f355e195b227f91db3\">\r\n                  French Toast Eaters</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                Quality of Life\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  NO </a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  VIEW</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                -\r\n              </td>\r\n            </tr>\r\n\r\n\r\n          </table>\r\n        </div> -->\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<script type=\"text/ng-template\" id=\"viewNotes\">\r\n  <div>\r\n    <h3>Note: <span  ng-if=\"showNote\"> {{showNote}}</span> <span ng-if=\"!showNote\">N/A</span></h3>\r\n</div>\r\n\r\n</script>\r\n");
$templateCache.put("app/allEssay/allEssay.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">Settings</h2>\r\n  <div>\r\n    <div class=\"closeForm\" ng-include=\"\'app/popups/setting_Ctrl.html\'\"></div>\r\n  </div>\r\n  <!-- All Essay Start -->\r\n  <form ng-if=\"$root.showAllEssay\" name=\"showAllEssay\" id=\"showAllEssay\" ng-controller=\"AllEssayCtrl\" class=\"closeForm\">\r\n    <div class=\"row\" style=\"margin-top: 10px;\">\r\n      <p>\r\n        <h3>All Essay</h3>\r\n      </p>\r\n      <div style=\"float:right;\" class=\"changeTextColor\">\r\n        <dir-pagination-controls max-size=\"5\" on-page-change=\"pageChanged(newPageNumber)\"></dir-pagination-controls>\r\n      </div>\r\n      <table class=\"w100 changeTextColor\">\r\n        <tr>\r\n          <th style=\"width:90%\">Essay</th>\r\n          <th style=\"width:10%\">Remove</th>\r\n        </tr>\r\n        <tr dir-paginate=\"u in essay.data | itemsPerPage :usersPerPage\" total-items=\"totalUsers\" current-page=\"pagination.current\">\r\n          <td>\r\n            <div class=\"boldbox\">\r\n              <b>{{u.title}}</b>\r\n            </div>\r\n            <p>\r\n              <img src=\"../assets/images/profile/{{u.createdBy.utype}}.svg\" class=\"UserTypeImg\" /> Created By :\r\n              <a href=\"#!/publicProfile/{{u.createdBy.id}}\" class=\"link\">{{u.createdBy.name}}</a>\r\n            </p>\r\n            <div class=\"DescriptionImg\" ng-bind-html=\'u.description | convertHTML\'></div>\r\n          </td>\r\n          <td>\r\n            <a href=\"javascript: void(0)\" ng-click=\"removeEssay(u, $index)\" class=\"link\">Remove</a>\r\n          </td>\r\n        </tr>\r\n        <tr ng-if=\"essay.data.length==0\">\r\n          <td colspan=\"3\">\r\n            <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoading\"></i>\r\n            <spam ng-if=\"!showLoading\">No records found.</spam>\r\n          </td>\r\n        </tr>\r\n      </table>\r\n      <div style=\"float:right;\" class=\"changeTextColor\">\r\n        <dir-pagination-controls max-size=\"5\" on-page-change=\"pageChanged(newPageNumber)\"></dir-pagination-controls>\r\n      </div>\r\n    </div>\r\n  </form>\r\n</div>\r\n");
$templateCache.put("app/allies/allies.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">ALLIES</h2>\r\n  <p class=\"pageSubHeading\">Find people and organiztions to team up with.</p>\r\n  <div class=\"row\">\r\n  \r\n      \r\n   <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/quizzesOrg\" class=\"blockLink\"><img ng-src=\"./assets/images/quiz.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock2\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">IDEOLOGICAL MATCH QUESTIONS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Answer or create multiple choice quizzes to get matched up with politicians, organizations and individuals. We reccommend answering as many questions as make sense for your organization, but skip any that you don\'t have a position on.  You can also use our questions to create quizzes to poll your members or to test politicians to see if they are worthy of your endorsements.\r\n          </p>\r\n            \r\n        </div>\r\n      </div></a>\r\n    </div>\r\n    \r\n   \r\n      \r\n          <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/incumbent_politician/politician\" class=\"blockLink\"><img ng-src=\"./assets/images/politiciansRBB7-01.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock5\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">POLITICIANS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Find the politicians near you.  See their voting records, reviews, and who paid for their campaigns.  Rate or endorse them.  If you\'ve taken the Ideological Match quiz, you can see which ones would be best to team up with.\r\n          </p>\r\n            \r\n        </div>\r\n      </div></a>\r\n    </div>\r\n      \r\n    \r\n      \r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/advocateHome\" class=\"blockLink\"><img ng-src=\"./assets/images/Organizations.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock4\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">ORGANIZATIONS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">See organizations that match you based on your Match Questions, or see a list of organizations in the areas you are interested in.</p>\r\n<!--          BRING BACK\r\n<p><a href=\"#!/ratingReviews\" class=\"link\">Organization Matches</a></p>\r\n\r\n            <p><a href=\"#!/advocateHome\" class=\"link\">Organization List</a></p>-->\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n   \r\n    \r\n         \r\n      \r\n      \r\n      \r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/alliesP/alliesP.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">ALLIES</h2>\r\n  <p class=\"pageSubHeading\">Find people and organiztions to team up with.</p>\r\n  <div class=\"row\">\r\n  \r\n   <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/quizzes\" class=\"blockLink\"><img ng-src=\"./assets/images/quiz.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock2\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">IDEOLOGICAL MATCH QUESTIONS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Answer multiple choice questions to get matched up with politicians, organizations and individuals. We reccommend answering as many questions as make sense for your organization, but skip any that you don\'t have a position on.\r\n          </p>\r\n            \r\n        </div>\r\n      </div></a>\r\n    </div>\r\n    \r\n   \r\n      \r\n          <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/incumbent_politician/politician\" class=\"blockLink\"><img ng-src=\"./assets/images/politiciansRBB7-01.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock5\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">POLITICIANS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">\r\n              See who represents you, who you might team up with to get things done, and who you are running against.  Rate or endorse other politicians. If you\'ve taken the Ideological Match quiz, you can see who would be best to team up with issue by issue.  Also see yourself as the voters see you.\r\n          </p>\r\n            \r\n        </div>\r\n      </div></a>\r\n    </div>\r\n      \r\n    \r\n      \r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/advocateHome\" class=\"blockLink\"><img ng-src=\"./assets/images/Organizations.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock4\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">ORGANIZATIONS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">See organizations that match you based on your Match Questions, or see a list of organizations in the areas you are interested in.</p>\r\n<!--          BRING BACK\r\n<p><a href=\"#!/ratingReviews\" class=\"link\">Organization Matches</a></p>\r\n\r\n            <p><a href=\"#!/advocateHome\" class=\"link\">Organization List</a></p>-->\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n   \r\n    \r\n         \r\n      \r\n      \r\n      \r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/allQuizzes/allQuizzes.html","<div class=\"container-fluid\">\r\n\r\n  <h2 class=\"pageHeading\">YOUR QUIZZES</h2>\r\n  <p class=\"pageSubHeading\">View, Edit, or send your quizzes out to be taken by politicians you choose or a list of\r\n    members whose email addresses you upload from an Excel sheet.</p>\r\n\r\n  <br>\r\n  <br>\r\n  <div class=\"row table-responsive\" ng-if=\"quizzes.length > 0\" style=\"margin-top: 10px;\">\r\n    <table class=\"table w100 changeTextColor\">\r\n      <tr>\r\n        <th>\r\n          Quiz Name\r\n        </th>\r\n        <th>Created On</th>\r\n        <th>Delete Quiz</th>\r\n        <th>\r\n          View Quiz\r\n        </th>\r\n        <th>Take Quiz</th>\r\n        <th>\r\n          Invite Politicians\r\n        </th>\r\n        <th>Politician\'s Answers</th>\r\n      </tr>\r\n      <tr ng-repeat=\"item in quizzes track by $index\">\r\n        <td> <a href=\"\" ng-click=\"editName(item)\">{{item.quizName}}</a></td>\r\n        <td>{{item.createdOn | date: \"MM-dd-y\"}}</td>\r\n        <td><a href=\"\" class=\"link\" ng-click=\"showPopUp(item)\">Delete</a> </td>\r\n        <td>\r\n          <a href=\"#!/orgQuestions/{{item.quizName}}\" class=\"link\">View/Edit</a>\r\n        </td>\r\n        <td>\r\n          <a href=\"\" ng-click=\"takeQuiz(item)\"class=\"link\">Take Quiz</a>\r\n        </td>\r\n        <td>\r\n          <a href=\"#!/invitePoliticians/{{item.quizName}}\" class=\"link\">Invite Politicians</a>\r\n          <!--        or\r\n          <a href=\"#!/uploadFollowers/{{item.quizName}}\" class=\"link\">Invite Followers</a>  -->\r\n\r\n        </td>\r\n        <td><a href=\"#!/listOfFollowers/{{item.quizName}}\" class=\"link\">See Answers</a></td>\r\n      </tr>\r\n    </table>\r\n  </div>\r\n</div>\r\n\r\n<script type=\"text/ng-template\" id=\"viewQuiz\">\r\n  <div>\r\n      <center>\r\n    <label for=\"editQuizName\">Edit Quiz Name</label>\r\n    <input type=\"text\" id=\"quiz\" name=\"quiz\" ng-model=\"questions.quiz\"  class=\"form-control input-md text-input\" style=\"width: 50%\">\r\n    <br>\r\n\r\n      <button ng-click=\"updateName()\" type=\"submit\" class=\"btnShort-style\">Update</button>\r\n    </center>\r\n</div>\r\n\r\n</script>\r\n");
$templateCache.put("app/allRatings/allRatings.html","<!-- <div id=\"background\"></div> -->\r\n<div class=\"container-fluid\">\r\n  <!--  <div class=\"back-btn-wrapper\">\r\n    <a href=\"\" ng-click=\"BackToPrev()\" class=\"ylink\">Back</a>\r\n  </div> -->\r\n  <h2 class=\"pageHeading\">RATINGS<br>\r\n\r\n    <a href=\"#!/publicProfile/{{politicianIds}}/true\" class=\"hoverYellow\" ng-if=\"politicianIds\">{{username}}</a>\r\n    <a href=\"#!/publicProfile/{{selectedPolitician}}/true\" class=\"hoverYellow\" ng-if=\"!politicianIds\">{{username}}</a>\r\n\r\n  </h2>\r\n  <p class=\"pageSubHeading\">See How Organizations Rated Your Elected Officials and Candidates on the different topics\r\n  </p>\r\n  <div class=\"row\">\r\n    <div class=\"col-lg-12\">\r\n      <div id=\"topHeader\">\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <!-- Small Screen -->\r\n  <div class=\"row d-lg-none\">\r\n    <div class=\"col-12\">\r\n      <!--\r\n      <img ng-src=\"./assets/images/yourPoliticansIcon200.jpg\" class=\"politicianIconSmall img-fluid\">\r\n-->\r\n      <div>\r\n        <div id=\"descContainer\">\r\n        </div>\r\n        <div id=\"selectBoxContainer\">\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div>\r\n    <div class=\"col-lg-12 col-centered\" id=\"compareContent\">\r\n      <div class=\"tableContainer\">\r\n        <div class=\"alert alert-success alert-dismissible\" id=\"alert\" ng-if=\"success_msg\" style=\"width:40%;margin-left:\r\n            28%\">\r\n          <button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button>\r\n          <strong>Review added Sucessfully</strong>\r\n        </div>\r\n        <center>\r\n          <h3 style=\"text-transform: capitalize; color:#fff;\">RATINGS</h3>\r\n        </center>\r\n        If you are signed in, the ratings are listed in order of best match to you, but you can reorder by clicking any\r\n        of the headers.\r\n        <br>\r\n        <br>\r\n        <!-- <div class=\"table-responsive\">\r\n          <center>\r\n            <div class=\"w-50\">\r\n              <form>\r\n                <div class=\"form-group row\">\r\n                  <label for=\"inputEmail3\" class=\"col-sm-2 col-form-label\">Reviewer</label>\r\n                  <div class=\"col-sm-10\">\r\n                    <input type=\"text\" class=\"form-control\" ng-model=\"search.name\" id=\"inputEmail3\" placeholder=\"Reviewer\">\r\n                  </div>\r\n                </div>\r\n                <div class=\"form-group row has-error has-feedback\">\r\n                  <label for=\"inputPassword3\" class=\"col-sm-2 col-form-label\">Rating</label>\r\n                  <div class=\"col-sm-3\">\r\n                    <input type=\"number\" class=\"form-control\" ng-model=\"search.rangeMin\" id=\"inputPassword3\" min=\"0\" max=\"80\" placeholder=\"Min\">\r\n                  </div>\r\n                  <div class=\"col-sm-3\">\r\n                    <input type=\"number\" class=\"form-control\" ng-model=\"search.rangeMax\" id=\"inputPassword3\" min=\"20\" max=\"100\" placeholder=\"Max\">\r\n                  </div>\r\n                </div>\r\n                <div class=\"form-group row\">\r\n                  <div class=\"col-lg-4 center-block\">\r\n                    <button type=\"button\" ng-click=\"searchRecord(search)\" class=\"btn\">Search</button>\r\n                  </div>\r\n                </div>\r\n              </form>\r\n            </div>\r\n          </center>\r\n        </div> -->\r\n        <div class=\"table-responsive\" infinite-scroll=\'myPagingFunction()\'>\r\n          <table class=\"table table-striped\" style=\"margin-bottom:0px;\">\r\n            <tr>\r\n              <th class=\"tableHead\">\r\n                <span ng-click=\"sortSearch(\'name\')\" style=\"cursor:pointer;\">Reviewer</span>&nbsp;<i ng-if=\"nameUp\" class=\"fa fa-arrow-circle-up\"></i><i ng-if=\"nameDown\" class=\"fa fa-arrow-circle-down\"></i>\r\n              </th>\r\n              <!-- <th class=\"tableHead\">Subject</th> -->\r\n              <th class=\"tableHead\">\r\n                <span ng-click=\"sortSearch(\'match\')\" style=\"cursor:pointer;\" class=\"hoverYellow\">Organization Match to You</span>&nbsp;<i ng-if=\"matchUp\" class=\"fa fa-arrow-circle-up\"></i><i ng-if=\"matchDown\" class=\"fa fa-arrow-circle-down\"></i>\r\n              </th>\r\n              <th class=\"tableHead\">\r\n                <span ng-click=\"sortSearch(\'rating\')\" style=\"cursor:pointer;\">Organization Rating of {{username}}</span>&nbsp;<i ng-if=\"ratingUp\" class=\"fa fa-arrow-circle-up\"></i><i ng-if=\"ratingDown\" class=\"fa fa-arrow-circle-down\"></i>\r\n              </th>\r\n\r\n              <!-- <th class=\"tableHead\">\r\n                <span ng-click=\"sortSearch(\'date\')\" style=\"cursor:pointer; text-decoration:underline;\">Date</span>&nbsp;<i ng-if=\"dateUp\" class=\"fa fa-arrow-circle-up\"></i><i ng-if=\"dateDown\" class=\"fa fa-arrow-circle-down\"></i>\r\n              </th> -->\r\n\r\n              <th class=\"tableHead\">\r\n                <span ng-click=\"sortDate()\" style=\"cursor:pointer;\">Date of Review</span>&nbsp;<i ng-if=\"ratingDateUp\" class=\"fa fa-arrow-circle-up\"></i><i ng-if=\"ratingDateDown\" class=\"fa fa-arrow-circle-down\"></i>\r\n              </th>\r\n              <th class=\"tableHead\" ng-if=\"allReviews.length > 0 || allReviews.votesmart.length > 0 \">Details\r\n              </th>\r\n              <!-- <th class=\"tableHead\">Your Match</th> -->\r\n            </tr>\r\n\r\n            <tr ng-repeat=\"review in allReviews\">\r\n              <td class=\"tableRow\">\r\n                <a ng-if=\"review.from && review.from.length > 0 && review.isEmailVerified && review.verifiedUser\" href=\"#!/pressProfile/{{review.sig.sigId}}/true\" class=\"link\">\r\n                 <span ng-if=\"review.orgName\" style=\"text-transform: capitalize;\">{{review.orgName}}</span>\r\n																	<span ng-if=\"review.pName &&  review.isEmailVerified && review.verifiedUser\" style=\"text-transform: capitalize;\">{{review.pName}}</span>\r\n                <span ng-if=\"!review.orgName && !review.pName && review.name && review.isEmailVerified && review.verifiedUser\" style=\"text-transform: capitalize;\">{{review.name}}</span>\r\n                </a>\r\n                <a ng-if=\"!review.from\" href=\"#!/pressProfile/{{review.sig.sigId}}/false\" class=\"link\" style=\"text-transform: capitalize;\">{{review.sig.name}}</a>\r\n\r\n                <b ng-if=\"review.userType == \'advocate\' && !review.isEmailVerified || !review.verifiedUser\" style=\"text-transform: capitalize;\">{{review.tempName}}</b>\r\n                <span ng-if=\"review.from && review.from.length > 0 && review.tempName && review.tempName !=null &&  !review.verifiedUser\"  style=\"text-transform: capitalize;\">*</span>\r\n\r\n                <!--\r\n<small style=\"color:red;\">As Reported by Other</small>\r\n-->\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <div ng-if=\"review.match && review.match !=\'\'\">{{review.match}}%</div>\r\n                <div ng-if=\"!review.match\">N/A</div>\r\n              </td>\r\n              <!--  <td class=\"tableRow\" ng-if=\"review.to[0].uid==review.from[0].uid\">{{review.referal[0].name}} <small style=\"color:red;\">As Reported by Other</small></td> -->\r\n              <!-- <td class=\"tableRow\"></td> -->\r\n              <td class=\"tableRow\">\r\n                <!-- <div ng-repeat=\" votewise in review.votesmart\">\r\n                   {{votewise.sig.name}}\r\n                </div> -->\r\n                {{review.candidateRating[0].rating}}%\r\n                <span ng-if=\"userId == review.sig.sigId \">&nbsp;&nbsp;<a href=\"#!/addRating/{{review._id}}/true\" class=\"link\">Edit</a></span>\r\n                <span ng-if=\"sigId == review.sig.sigId \">&nbsp;&nbsp;<a href=\"#!/addRating/{{review._id}}/true/{{review.candidateRating[0].candidateId}}\" class=\"link\">Edit</a></span>\r\n              </td>\r\n\r\n              <td class=\"tableRow\">\r\n                <span ng-if=\"review.createdBy\" style=\"text-transform: capitalize;\">{{review.createdBy  | date : \"y\"}}</span>\r\n                <span ng-if=\"!review.createdBy\">{{review.timespan}}</span>\r\n\r\n              </td>\r\n\r\n              <td class=\"tableRow\">\r\n                <a ng-if=\"review.from && review.from.length > 0\" href=\"#!/ratingsDetails/{{review._id}}/{{selectedPolitician}}/{{type}}\" class=\"link\">View</a>\r\n                <a ng-if=\"!review.from\" href=\"#!/ratingsDetails/{{review.candidateRating[0]._id}}/{{selectedPolitician}}/{{type}}\" class=\"link\">View</a>\r\n              </td>\r\n              <!-- <td class=\"tableRow\"></td> -->\r\n            </tr>\r\n          </table>\r\n        </div>\r\n        <!-- <p ng-if=\"statusGetResPg == 1\" class=\"fwb\">Loading ratings...</p> -->\r\n        <center>\r\n          <div ng-if=\"showLoader\" style=\"z-index: 2; background:black;\">\r\n            <i class=\"fa fa-refresh fa-spin loader-stly\"></i><br><span class=\"loader-text\">LOADING. PLEASE WAIT.</span>\r\n          </div>\r\n\r\n        </center>\r\n        <!-- <div class=\"table-responsive\">\r\n          <table class=\"table table-striped\" style=\"margin-bottom:0px;\">\r\n            <tr>\r\n              <th class=\"tableHead\">Reviewer\r\n                <i class=\"fa fa-caret-down\"></i>\r\n              </th>\r\n\r\n              <th class=\"tableHead\">Subject\r\n                <i class=\"fa fa-caret-down\"></i>\r\n              </th>\r\n              <th class=\"tableHead\">Rating\r\n                <i class=\"fa fa-caret-down\"></i>\r\n              </th>\r\n              <th class=\"tableHead\">Details</th>\r\n              <th class=\"tableHead\">Your Match\r\n                <i class=\"fa fa-caret-down\"></i>\r\n              </th>\r\n            </tr>\r\n            <tr>\r\n\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/pressProfile/57fb97f355e195b227f91db3\">\r\n                  Southern Poverty Law Center</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                Crime and Punishment\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  C</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  VIEW</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                97%\r\n              </td>\r\n            </tr>\r\n\r\n            <tr>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/pressProfile/57fb97f355e195b227f91db3\">\r\n                  Southern Poverty Law Center</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                Environment\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  A</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  VIEW</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                91%\r\n              </td>\r\n            </tr>\r\n\r\n            <tr>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/pressProfile/57fb97f355e195b227f91db3\">\r\n                  Turtles Against Speed</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                Quality of Life\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                A\r\n              </td>\r\n              <td class=\"tableRow\">-\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                80%\r\n              </td>\r\n            </tr>\r\n\r\n            <tr>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/pressProfile/57fb97f355e195b227f91db3\">\r\n                  Speedy Snails</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                Quality of Life\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  F</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  VIEW</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                -\r\n              </td>\r\n            </tr>\r\n\r\n            <tr>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/pressProfile/57fb97f355e195b227f91db3\">\r\n                  Justice Center</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                All\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  YES</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  VIEW</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                -\r\n              </td>\r\n            </tr>\r\n\r\n            <tr>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/pressProfile/57fb97f355e195b227f91db3\">\r\n                  Automotive Employees</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                All\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  47%</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  VIEW</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                20%\r\n              </td>\r\n            </tr>\r\n\r\n            <tr>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/pressProfile/57fb97f355e195b227f91db3\">\r\n                  Cats Against Humanity</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                Environment\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  A</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  VIEW</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                15%\r\n              </td>\r\n            </tr>\r\n\r\n            <tr>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/pressProfile/57fb97f355e195b227f91db3\">\r\n                  Dogs Against Humanity</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                Environment\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  A</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  VIEW</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                -\r\n              </td>\r\n            </tr>\r\n\r\n            <tr>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/pressProfile/57fb97f355e195b227f91db3\">\r\n                  Muskrats Against Humanity</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                Environment\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  A</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  VIEW</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                47%\r\n              </td>\r\n            </tr>\r\n\r\n            <tr>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/pressProfile/57fb97f355e195b227f91db3\">\r\n                  Planets Against Humanity</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                Environment\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  A</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  VIEW</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                23%\r\n              </td>\r\n            </tr>\r\n\r\n            <tr>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/pressProfile/57fb97f355e195b227f91db3\">\r\n                  Dr Who Saves Humanity</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                Environment\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                A\r\n              </td>\r\n              <td class=\"tableRow\">-\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                -\r\n              </td>\r\n            </tr>\r\n\r\n            <tr>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/pressProfile/57fb97f355e195b227f91db3\">\r\n                  French Toast Eaters</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                Quality of Life\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  NO </a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"#!/ratingsDetails\">\r\n                  VIEW</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                -\r\n              </td>\r\n            </tr>\r\n\r\n\r\n          </table>\r\n        </div> -->\r\n        <p>* \"Unknown Organizations\" have not yet been confirmed</p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/allTopics/allTopics.html","<div class=\"container-fluid  ng-scope\" ng-cloak ng-show=\"$root.userRole==\'admin\'\">\r\n  <h2 class=\"pageHeading\">Settings</h2>\r\n  <div>\r\n    <div class=\"closeForm\" ng-include=\"\'app/popups/setting_Ctrl.html\'\"></div>\r\n  </div>\r\n  <!-- All Topics Start -->\r\n  <form ng-if=\"$root.showAllTopic\" name=\"showAllTopic\" id=\"showAllTopic\" ng-controller=\"AllTopicsCtrl\" class=\"closeForm\">\r\n    <div class=\"row\" style=\"margin-top: 10px;\">\r\n      <p>\r\n        <h3>All Topics</h3>\r\n      </p>\r\n      <!-- <div style=\"float:right;\">\r\n                            <dir-pagination-controls max-size=\"5\" on-page-change=\"pageChanged(newPageNumber)\"></dir-pagination-controls>\r\n                        </div> -->\r\n      <div infinite-scroll=\'loadMoreTopics()\'>\r\n        <table class=\"w100 changeTextColor\" style=\"margin-bottom: 15px;\">\r\n          <tr>\r\n            <th style=\"width:90%\">Topic</th>\r\n            <th style=\"width:10%\">Remove</th>\r\n          </tr>\r\n          <tr ng-repeat=\"u in topic.data\">\r\n            <!-- dir-paginate=\"u in topic.data | itemsPerPage :usersPerPage\" total-items=\"totalUsers\" current-page=\"pagination.current\" -->\r\n            <td>\r\n              <div ng-bind-html=\'u.description | urlify\'></div>\r\n              <p>\r\n                <img src=\"../assets/images/profile/{{u.createdBy.utype}}.svg\" class=\"UserTypeImg\" /> Created By :\r\n                <a href=\"#!/publicProfile/{{u.createdBy.id}}\" class=\"link\">{{u.createdBy.name}}</a>\r\n              </p>\r\n            </td>\r\n            <td>\r\n              <a href=\"javascript: void(0)\" ng-click=\"removeTopic(u, $index)\" class=\"link\">Remove</a>\r\n            </td>\r\n          </tr>\r\n          <tr ng-if=\"!showLoading && topic.data.length <= 0\">\r\n            <td colspan=\"3\">\r\n              <span>No records found.</span>\r\n            </td>\r\n          </tr>\r\n        </table>\r\n        <p ng-if=\"showLoading\">\r\n          <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>\r\n        </p>\r\n      </div>\r\n      <!-- <div style=\"float:right;\">\r\n                            <dir-pagination-controls max-size=\"5\" on-page-change=\"pageChanged(newPageNumber)\"></dir-pagination-controls>\r\n                        </div> -->\r\n    </div>\r\n  </form>\r\n  <!-- All Topics End -->\r\n</div>\r\n");
$templateCache.put("app/allUsers/allUsers.html","<div class=\"container-fluid ng-scope\" ng-cloak ng-show=\"$root.userRole==\'admin\'\">\r\n  <h2 class=\"pageHeading\">Settings</h2>\r\n  <div>\r\n    <div class=\"closeForm\" ng-include=\"\'app/popups/setting_Ctrl.html\'\"></div>\r\n  </div>\r\n  <!-- All Users Start -->\r\n  <form ng-if=\"$root.showAllUsers\" name=\"AllUsersform\" id=\"AllUsersform\" ng-controller=\"AllUsersCtrl\" class=\"closeForm\">\r\n    <div class=\"row\" style=\"margin-top: 10px;\" ng-if=\"UserFormDiv==\'New\'\">\r\n      <fieldset class=\"scheduler-border\">\r\n        <legend class=\"scheduler-border\">Add New User</legend>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel removeTopMargin\" for=\"category-title\">User Type</label>\r\n              <div class=\"controls\">\r\n                <select ng-model=\"newuser.subtype\" class=\"changeTextColor\">\r\n                  <option ng-repeat=\"item in userTypes\" value=\"{{item}}\">{{item}}</option>\r\n                </select>\r\n              </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\" for=\"description\">Name</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"newuser.name\" class=\"form-control input-md text-input validate[required]\">\r\n              </div>\r\n              </div>\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel\" for=\"description\">Email</label>\r\n                <div class=\"controls\">\r\n                  <input type=\"text\" ng-model=\"newuser.email\" class=\"form-control input-md text-input validate[required, custom[email]]\">\r\n              </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"description\">UserName</label>\r\n                  <div class=\"controls\">\r\n                    <input type=\"text\" ng-model=\"newuser.username\" class=\"form-control input-md text-input validate[required]\">\r\n              </div>\r\n                  </div>\r\n                  <div class=\"control-group\">\r\n                    <label class=\"control-label formLabel\" for=\"description\">Password</label>\r\n                    <div class=\"controls\">\r\n                      <input type=\"password\" ng-model=\"newuser.password\" id=\"userpass\" name=\"userpass\" class=\"form-control input-md text-input validate[required]\">\r\n              </div>\r\n                    </div>\r\n                    <div class=\"control-group\">\r\n                      <label class=\"control-label formLabel\" for=\"description\">Confirm Password</label>\r\n                      <div class=\"controls\">\r\n                        <input type=\"password\" ng-model=\"newuser.cpassword\" class=\"form-control input-md text-input validate[required,equals[userpass]]\">\r\n              </div>\r\n                      </div>\r\n                      <div class=\"control-group\">\r\n                        <label class=\"control-label formLabel\" for=\"description\">Zipcode</label>\r\n                        <div class=\"controls\">\r\n                          <input type=\"text\" ng-model=\"newuser.zipcode\" class=\"form-control input-md text-input validate[required]\">\r\n              </div>\r\n                        </div>\r\n                        <div class=\"control-group\">\r\n                          <div class=\"control-label formLabel\" for=\"title\">Select subjects of interest</div>\r\n                          <div class=\"DisplayCat changeTextColor\">\r\n                            <div style=\"background-color: #eee; padding:5px;\">All Tags\r\n                              <br>\r\n                              <small>(click to select)</small>\r\n                            </div>\r\n                            <div ng-repeat=\"subent in subtopics.subcategories track by $index\"\r\n                              ng-include=\"\'field_renderer\'\">Loading...</div>\r\n                            <div ng-if=\"subtopics.subcategories.length == 0\" class=\"loadingSpinner\">\r\n                              <i class=\"fa fa-refresh fa-spin fa-3x fa-fw\"></i>\r\n                            </div>\r\n                          </div>\r\n                          <div class=\"select buttons\" style=\"padding-left: 20px;\">&nbsp;</div>\r\n                          <div class=\"DisplayCat changeTextColor\">\r\n                            <div style=\"background-color: #eee; padding:5px;\">Selected Tags\r\n                              <br>\r\n                              <small>(click to remove)</small>\r\n                            </div>\r\n                            <ul class=\"TcatList\">\r\n                              <li ng-repeat=\"subent in selectedCat track by $index\">\r\n                                <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                      <input type=\"checkbox\" ng-click=\"removeVal(subent)\" ng-model=\"selectedAll.id[$index]\" ng-checked=\"true\" name=\"checkedidcat\"> {{subent.title}}\r\n                    </label>\r\n                              </li>\r\n                            </ul>\r\n                          </div>\r\n                          <div style=\"clear:both;\"></div>\r\n                        </div>\r\n                        <div class=\"control-group\" style=\"margin-top:30px;\">\r\n                          <div class=\"control-label\" for=\"title\">Select locations of interest</div>\r\n                          <div class=\"DisplayCat changeTextColor\">\r\n                            <div style=\"background-color: #eee; padding:5px;\">Choose Location\r\n                              <br>\r\n                              <small>(click to select)</small>\r\n                            </div>\r\n                            <ul class=\"TcatList\">\r\n                              <li>\r\n                                <input type=\"checkbox\" ng-model=\"Essay.National\" ng-click=\"getLocations(Essay.National, \'National\')\" ng-true-value=\"\'National\'\" ng-false-value=\"\'NO\'\">\r\n                                <label>National</label>\r\n                                </i>\r\n                                <ul class=\"TcatList\">\r\n                                  <li ng-repeat=\"area in allLocations track by $index\">\r\n                                    <input type=\"checkbox\" ng-click=\"getAreaVal(area, area.state, \'state\')\" ng-disabled=\"checkDisabled(area, area.state, \'state\')\" ng-checked=\"checkDisabled(area, area.state, \'state\')\">\r\n                                    <label ng-click=\"getCounties(area.statePostalCode, \'location\')\">{{area.state}}&nbsp;\r\n                          <i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoading.indexOf(area.statePostalCode)==-1\"></i>\r\n                          <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoading.indexOf(area.statePostalCode) > -1\"></i>\r\n                        </label>\r\n                                    <!-- Display Counties -->\r\n                                    <ul class=\"TcatList\">\r\n                                      <li ng-repeat=\"county in allCounties[area.statePostalCode] track by $index\">\r\n                                        <input type=\"checkbox\" ng-click=\"getAreaVal(county._id, area.state, \'county\')\" ng-disabled=\"checkDisabled(county._id, area.state, \'county\')\" ng-checked=\"checkDisabled(county._id, area.state, \'county\')\">\r\n                                        <label ng-click=\"getLocals(area.statePostalCode, county._id.county, \'location\')\">{{county._id.county}}&nbsp;\r\n                              <i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoadingCounty.indexOf(county._id.county) == -1\"></i>\r\n                              <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingCounty.indexOf(county._id.county) > -1\"></i>\r\n                            </label>\r\n                                        <!-- Display Locals and sub counties -->\r\n                                        <ul class=\"TcatList\" ng-if=\"Essay.location!=\'National\'\">\r\n                                          <li\r\n                                            ng-repeat=\"local in allLocals[area.statePostalCode][county._id.county] track by $index\">\r\n                                            <label class=\"checkbox\" title=\"{{local._id.place}}\">\r\n                                  <input type=\"checkbox\" ng-click=\"getAreaVal(local._id, area.state, \'local\')\" ng-disabled=\"disabledLocation.indexOf(local._id) > -1 ? true : false\" ng-checked=\"disabledLocation.indexOf(local._id) > -1 ? true : false\"> {{local._id.countySubdivision}} - {{local._id.place}}\r\n                                </label>\r\n                                          </li>\r\n                                        </ul>\r\n                                        <!-- Display Locals and sub counties End -->\r\n                                      </li>\r\n                                    </ul>\r\n                                    <!-- Display Counties End -->\r\n                                  </li>\r\n                                </ul>\r\n                              </li>\r\n                            </ul>\r\n                          </div>\r\n                          <div class=\"select buttons\" style=\"padding-left: 20px;\">&nbsp;</div>\r\n                          <div class=\"DisplayCat changeTextColor\">\r\n                            <div style=\"background-color: #eee; padding:5px;\">Selected Location\'s\r\n                              <br>\r\n                              <small>(click to remove)</small>\r\n                            </div>\r\n                            <ul class=\"TcatList\">\r\n                              <li ng-repeat=\"area in selectedArea track by $index\">\r\n                                <label class=\"checkbox\" title=\"{{area}}\">\r\n                      <input type=\"checkbox\" ng-click=\"removeAreaVal(area)\" ng-model=\"selectedLAll.id[$index]\" ng-checked=\"true\" name=\"checkedid\">\r\n                      <span ng-if=\"area.country && (!(area.state) && !(area.county) && !(area.countySubdivision) && !(area.place))\">{{area.country}}</span>\r\n                      <span ng-if=\"area.state && (!(area.county) && !(area.countySubdivision) && !(area.place))\">{{area.state}}</span>\r\n                      <span ng-if=\"area.county && (!(area.countySubdivision) && !(area.place))\">{{area.county}}</span>\r\n                      <span ng-if=\"area.countySubdivision\">{{area.countySubdivision}}</span>\r\n                      <span ng-if=\"area.place\"> - {{area.place}}</span>\r\n                    </label>\r\n                              </li>\r\n                            </ul>\r\n                          </div>\r\n                          <div style=\"clear:both;\"></div>\r\n                        </div>\r\n                      </div>\r\n                      <div style=\"clear: both;\"></div>\r\n                      <div style=\"width: 55%; margin-top: 10px; float: right; margin-right: 17px;\">\r\n                        <button ng-click=\"closeUserEdit()\" type=\"button\" class=\"btnShort-style\" style=\"float: right;\">Cancel</button>&nbsp;\r\n                        <button ng-click=\"addNewUser(newuser)\" type=\"submit\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n                        <!--<fb:login-button scope=\"public_profile,email\" onlogin=\"checkLoginState();\">\r\n                                </fb:login-button>-->\r\n                        <div style=\"clear: both;\"></div>\r\n                      </div>\r\n                      <div style=\"clear: both;\"></div>\r\n                    </div>\r\n      </fieldset>\r\n    </div>\r\n    <!-- Edit User start -->\r\n    <div class=\"row\" style=\"margin-top: 10px;\" ng-if=\"UserFormDiv==\'Edit\'\">\r\n      <fieldset class=\"scheduler-border\">\r\n        <legend class=\"scheduler-border\">Update User</legend>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <!--\r\n                  <div class=\"control-group\">\r\n                    <label class=\"control-label\" for=\"description\">Name</label>\r\n                    <div class=\"controls\">\r\n                      <input type=\"text\" ng-model=\"upuser.name\" class=\"form-control input-md text-input validate[required]\">\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"control-group\">\r\n                    <label class=\"control-label\" for=\"description\">Email</label>\r\n                    <div class=\"controls\">\r\n                      <input type=\"text\" ng-model=\"upuser.email\" class=\"form-control input-md text-input validate[required, custom[email]]\">\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"control-group\">\r\n                    <label class=\"control-label\" for=\"description\">UserName</label>\r\n                    <div class=\"controls\">\r\n                      <input type=\"text\" ng-model=\"upuser.username\" class=\"form-control input-md text-input validate[required]\">\r\n                    </div>\r\n                  </div>\r\n                  -->\r\n            <div class=\"col-mainleft\">\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel removeTopMargin\" for=\"description\">UserName</label>\r\n                <div class=\"controls\">\r\n                  <input type=\"text\" ng-model=\"upuser.username\" class=\"form-control input-md text-input validate[required]\">\r\n                </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"ShowData-name\">Name</label>\r\n                  <div class=\"controls\">\r\n                    <input type=\"text\" ng-model=\"upuser.name\" class=\"form-control input-md text-input validate[required]\">\r\n                </div>\r\n                  </div>\r\n                  <div class=\"control-group\">\r\n                    <label class=\"control-label formLabel\" for=\"ShowData-nameOnBallot\">Name on Ballot</label>\r\n                    <div class=\"controls\">\r\n                      <input type=\"text\" ng-model=\"upuser.nameOnBallot\" class=\"form-control input-md text-input validate[required]\">\r\n                </div>\r\n                    </div>\r\n                    <p>\r\n                      <a href=\"javascript: void(0)\" ng-click=\"updateAddress(upuser._id)\" style=\"text-decoration: underline; font-weight: bolder;\"\r\n                        class=\"ylink\">Click here to update address</a>&nbsp; &nbsp;\r\n                      <i ng-if=\"UpdateAddressLoader\" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>\r\n                    </p>\r\n                    <div class=\"control-group\">\r\n                      <label class=\"control-label formLabel\" for=\"ShowData-email\">Email</label>\r\n                      <div class=\"controls\">\r\n                        <input type=\"text\" ng-model=\"upuser.email\" class=\"form-control input-md text-input validate[custom[email]]\">\r\n                </div>\r\n                      </div>\r\n                      <div class=\"control-group\">\r\n                        <label class=\"control-label formLabel\" for=\"ShowData-webUrl\">Website</label>\r\n                        <div class=\"controls\">\r\n                          <input type=\"text\" ng-model=\"upuser.webUrl\" class=\"form-control input-md text-input validate[custom[url]]\">\r\n                </div>\r\n                        </div>\r\n                        <div class=\"control-group\">\r\n                          <label class=\"control-label formLabel\" for=\"profile-phone\">Phone</label>\r\n                          <div class=\"controls\">\r\n                            <input type=\"text\" ng-model=\"upuser.phone\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                          </div>\r\n                          <div class=\"control-group\">\r\n                            <label class=\"control-label formLabel\" for=\"profile-facebookUrl\">facebook Url</label>\r\n                            <div class=\"controls\">\r\n                              <input type=\"text\" ng-model=\"upuser.facebookUrl\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                            </div>\r\n                            <div class=\"control-group\">\r\n                              <label class=\"control-label\" for=\"profile-web_url\">Donation Link For Campaign</label>\r\n                              <div class=\"controls\">\r\n                                <input type=\"text\" ng-model=\"upuser.donationLink\" class=\"form-control input-md text-input validate[custom[url]]\">\r\n                </div>\r\n                              </div>\r\n                              <div class=\"control-group\">\r\n                                <label class=\"control-label formLabel\" for=\"profile-mailingAddress\">Mailing Address</label>\r\n                                <div class=\"controls\">\r\n                                  <textarea ng-model=\"upuser.mailingAddress\" class=\"form-control input-md text-input\" style=\"height:80px;\"></textarea>\r\n                                </div>\r\n                              </div>\r\n                              <div class=\"control-group\">\r\n                                <label class=\"control-label formLabel\" for=\"profile-aboutMe\">About Me</label>\r\n                                <div class=\"controls\">\r\n                                  <textarea ng-model=\"upuser.aboutMe\" class=\"form-control input-md text-input\" style=\"height:80px;\"></textarea>\r\n                                </div>\r\n                              </div>\r\n                              <div class=\"control-group\">\r\n                                <label class=\"control-label formLabel\" for=\"profile-statement\">Statement</label>\r\n                                <div class=\"controls\">\r\n                                  <textarea ng-model=\"upuser.statement\" class=\"form-control input-md text-input\" style=\"height:80px;\"></textarea>\r\n                                </div>\r\n                              </div>\r\n                              <div class=\"control-group\">\r\n                                <div class=\"control-label formLabel\" for=\"title\">Select subjects of interest</div>\r\n                                <div class=\"DisplayCat changeTextColor\">\r\n                                  <div style=\"background-color: #eee; padding:5px;\">All Tags\r\n                                    <br>\r\n                                    <small>(click to select)</small>\r\n                                  </div>\r\n                                  <div ng-repeat=\"subent in subtopics.subcategories track by $index\"\r\n                                    ng-include=\"\'field_renderer\'\">Loading...</div>\r\n                                  <div ng-if=\"subtopics.subcategories.length == 0\" class=\"loadingSpinner\">\r\n                                    <i class=\"fa fa-refresh fa-spin fa-3x fa-fw\"></i>\r\n                                  </div>\r\n                                </div>\r\n                                <div class=\"select buttons\" style=\"padding-left: 20px;\">&nbsp;</div>\r\n                                <div class=\"DisplayCat changeTextColor\">\r\n                                  <div style=\"background-color: #eee; padding:5px;\">Selected Tags\r\n                                    <br>\r\n                                    <small>(click to remove)</small>\r\n                                  </div>\r\n                                  <ul class=\"TcatList\">\r\n                                    <li ng-repeat=\"subent in selectedCat track by $index\">\r\n                                      <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                        <input type=\"checkbox\" ng-click=\"removeVal(subent)\" ng-model=\"selectedAll.id[$index]\" ng-checked=\"true\" name=\"checkedidcat\"> {{subent.title}}\r\n                      </label>\r\n                                    </li>\r\n                                  </ul>\r\n                                </div>\r\n                                <div style=\"clear:both;\"></div>\r\n                              </div>\r\n                              <div class=\"control-group\" style=\"margin-top:30px;\">\r\n                                <div class=\"control-label formLabel\" for=\"title\">Select locations of interest</div>\r\n                                <div class=\"DisplayCat changeTextColor\">\r\n                                  <div style=\"background-color: #eee; padding:5px;\">Choose Location\r\n                                    <br>\r\n                                    <small>(click to select)</small>\r\n                                  </div>\r\n                                  <ul class=\"TcatList\">\r\n                                    <li>\r\n                                      <input type=\"checkbox\" ng-model=\"Essay.National\" ng-click=\"getLocations(Essay.National, \'National\')\" ng-true-value=\"\'National\'\" ng-false-value=\"\'NO\'\">\r\n                                      <label>National</label>\r\n                                      </i>\r\n                                      <ul class=\"TcatList\">\r\n                                        <li ng-repeat=\"area in allLocations track by $index\">\r\n                                          <input type=\"checkbox\" ng-click=\"getAreaVal(area, area.state, \'state\')\" ng-disabled=\"checkDisabled(area, area.state, \'state\')\" ng-checked=\"checkDisabled(area, area.state, \'state\')\">\r\n                                          <label ng-click=\"getCounties(area.statePostalCode, \'location\')\">{{area.state}}&nbsp;\r\n                            <i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoading.indexOf(area.statePostalCode)==-1\"></i>\r\n                            <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoading.indexOf(area.statePostalCode) > -1\"></i>\r\n                          </label>\r\n                                          <ul class=\"TcatList\">\r\n                                            <li ng-repeat=\"county in allCounties[area.statePostalCode] track by $index\">\r\n                                              <input type=\"checkbox\" ng-click=\"getAreaVal(county._id, area.state, \'county\')\" ng-disabled=\"checkDisabled(county._id, area.state, \'county\')\" ng-checked=\"checkDisabled(county._id, area.state, \'county\')\">\r\n                                              <label ng-click=\"getLocals(area.statePostalCode, county._id.county, \'location\')\">{{county._id.county}}&nbsp;\r\n                                <i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoadingCounty.indexOf(county._id.county) == -1\"></i>\r\n                                <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingCounty.indexOf(county._id.county) > -1\"></i>\r\n                              </label>\r\n                                              <ul class=\"TcatList\" ng-if=\"Essay.location!=\'National\'\">\r\n                                                <li\r\n                                                  ng-repeat=\"local in allLocals[area.statePostalCode][county._id.county] track by $index\">\r\n                                                  <label class=\"checkbox\" title=\"{{local._id.place}}\">\r\n                                    <input type=\"checkbox\" ng-click=\"getAreaVal(local._id, area.state, \'local\')\" ng-disabled=\"disabledLocation.indexOf(local._id) > -1 ? true : false\" ng-checked=\"disabledLocation.indexOf(local._id) > -1 ? true : false\"> {{local._id.countySubdivision}} - {{local._id.place}}\r\n                                  </label>\r\n                                                </li>\r\n                                              </ul>\r\n                                            </li>\r\n                                          </ul>\r\n                                        </li>\r\n                                      </ul>\r\n                                    </li>\r\n                                  </ul>\r\n                                </div>\r\n                                <div class=\"select buttons\" style=\"padding-left: 20px;\">&nbsp;</div>\r\n                                <div class=\"DisplayCat changeTextColor\">\r\n                                  <div style=\"background-color: #eee; padding:5px;\">Selected Location\'s\r\n                                    <br>\r\n                                    <small>(click to remove)</small>\r\n                                  </div>\r\n                                  <ul class=\"TcatList\">\r\n                                    <li ng-repeat=\"area in selectedArea track by $index\">\r\n                                      <label class=\"checkbox\" title=\"{{area}}\">\r\n                        <input type=\"checkbox\" ng-click=\"removeAreaVal(area)\" ng-model=\"selectedLAll.id[$index]\" ng-checked=\"true\" name=\"checkedid\">\r\n                        <span ng-if=\"area.country && (!(area.state) && !(area.county) && !(area.countySubdivision) && !(area.place))\">{{area.country}}</span>\r\n                        <span ng-if=\"area.state && (!(area.county) && !(area.countySubdivision) && !(area.place))\">{{area.state}}</span>\r\n                        <span ng-if=\"area.county && (!(area.countySubdivision) && !(area.place))\">{{area.county}}</span>\r\n                        <span ng-if=\"area.countySubdivision\">{{area.countySubdivision}}</span>\r\n                        <span ng-if=\"area.place\"> - {{area.place}}</span>\r\n                      </label>\r\n                                    </li>\r\n                                  </ul>\r\n                                </div>\r\n                                <div style=\"clear:both;\"></div>\r\n                              </div>\r\n                            </div>\r\n                            <div class=\"col-mainright\">\r\n                              <div class=\"col-left\" ng-repeat=\"pol in upuser.politicianInfo\">\r\n                                <div class=\"control-group\">\r\n                                  <label class=\"control-label\" for=\"pol.officeName\">Office</label>\r\n                                  <div class=\"controls\">\r\n                                    <input type=\"text\" ng-model=\"pol.officeName\" class=\"form-control input-md text-input validate[required]\">\r\n                  </div>\r\n                                  </div>\r\n                                  <div class=\"control-group\">\r\n                                    <label class=\"control-label\" for=\"pol.candidateStatus\">Candidate Status</label>\r\n                                    <div class=\"controls\">\r\n                                      <input type=\"text\" ng-model=\"pol.candidateStatus\" class=\"form-control input-md text-input validate[required]\">\r\n                  </div>\r\n                                    </div>\r\n                                    <div class=\"control-group\">\r\n                                      <label class=\"control-label\" for=\"pol.party\">Party</label>\r\n                                      <div class=\"controls\">\r\n                                        <input type=\"text\" ng-model=\"pol.party\" class=\"form-control input-md text-input\">\r\n                  </div>\r\n                                      </div>\r\n                                      <div class=\"control-group\">\r\n                                        <label class=\"control-label\" for=\"pol-fromDate\">From Date</label>\r\n                                        <div class=\"controls\">\r\n                                          <input type=\"text\" ng-model=\"pol.fromDate\" class=\"form-control input-md text-input\">\r\n                  </div>\r\n                                        </div>\r\n                                        <div class=\"control-group\">\r\n                                          <label class=\"control-label\" for=\"pol-endDate\">To Date</label>\r\n                                          <div class=\"controls\">\r\n                                            <input type=\"text\" ng-model=\"pol.endDate\" class=\"form-control input-md text-input\">\r\n                  </div>\r\n                                          </div>\r\n                                          <div class=\"control-group\">\r\n                                            <label class=\"control-label\" for=\"pol-levelOfGov\">Voter Scope</label>\r\n                                            <div class=\"controls\">\r\n                                              <input type=\"text\" ng-model=\"pol.levelOfGov\" class=\"form-control input-md text-input validate[required]\">\r\n                  </div>\r\n                                            </div>\r\n                                            <div class=\"control-group\">\r\n                                              <label class=\"control-label\" for=\"pol-runningForOffice\">Running for Office</label>\r\n                                              <div class=\"controls blackText\">\r\n                                                <!--  <input type=\"text\" ng-model=\"pol.runningForOffice\" class=\"form-control input-md text-input\"> -->\r\n                                                <select ng-model=\"pol.runningForOffice\">\r\n                      <option value=\"Y\" ng-selected=\"pol.runningForOffice==\'Y\'\">Yes</option>\r\n                      <option value=\"N\" ng-selected=\"pol.runningForOffice==\'N\'\">No</option>\r\n                    </select>\r\n                                              </div>\r\n                                            </div>\r\n                                            <div class=\"control-group\">\r\n                                              <label class=\"control-label\" for=\"pol-jurisdictionName\">Jurisdiction</label>\r\n                                              <div class=\"controls\">\r\n                                                <input type=\"text\" ng-model=\"pol.jurisdictionName\" class=\"form-control input-md text-input\">\r\n                  </div>\r\n                                              </div>\r\n                                              <div class=\"control-group\">\r\n                                                <label class=\"control-label\" for=\"pol-incumbent\">Incumbent</label>\r\n                                                <div class=\"controls\">\r\n                                                  <input type=\"text\" ng-model=\"pol.incumbent\" class=\"form-control input-md text-input\">\r\n                  </div>\r\n                                                </div>\r\n                                                <div class=\"control-group\">\r\n                                                  <label class=\"control-label\" for=\"pol-stateBoardEducationDistrict\">State Board Education District</label>\r\n                                                  <div class=\"controls\">\r\n                                                    <input type=\"text\" ng-model=\"pol.stateBoardEducationDistrict\" class=\"form-control input-md text-input\">\r\n                  </div>\r\n                                                  </div>\r\n                                                  <div class=\"control-group\">\r\n                                                    <label class=\"control-label\" for=\"pol-judicialCircuitNumber\">Judicial Circuit Number</label>\r\n                                                    <div class=\"controls\">\r\n                                                      <input type=\"text\" ng-model=\"pol.judicialCircuitNumber\" class=\"form-control input-md text-input\">\r\n                  </div>\r\n                                                    </div>\r\n                                                    <div class=\"control-group\">\r\n                                                      <label class=\"control-label\" for=\"pol-county\">County</label>\r\n                                                      <div class=\"controls\">\r\n                                                        <input type=\"text\" ng-model=\"pol.county\" class=\"form-control input-md text-input\">\r\n                  </div>\r\n                                                      </div>\r\n                                                      <div class=\"control-group\">\r\n                                                        <label class=\"control-label\" for=\"pol-countySubdivision\">County Subdivision</label>\r\n                                                        <div class=\"controls\">\r\n                                                          <input type=\"text\" ng-model=\"pol.countySubdivision\" class=\"form-control input-md text-input\">\r\n                  </div>\r\n                                                        </div>\r\n                                                        <div class=\"control-group\">\r\n                                                          <label class=\"control-label\" for=\"pol-place\">Place</label>\r\n                                                          <div class=\"controls\">\r\n                                                            <input type=\"text\" ng-model=\"pol.place\" class=\"form-control input-md text-input\">\r\n                  </div>\r\n                                                          </div>\r\n                                                          <div class=\"control-group\">\r\n                                                            <label class=\"control-label\" for=\"pol-federalCongressionalDistrict\">Federal Congressional District</label>\r\n                                                            <div class=\"controls\">\r\n                                                              <input type=\"text\" ng-model=\"pol.federalCongressionalDistrict\" class=\"form-control input-md text-input\">\r\n                  </div>\r\n                                                            </div>\r\n                                                            <div class=\"control-group\">\r\n                                                              <label class=\"control-label\" for=\"pol-stateSenateDistrict\">State Senate District</label>\r\n                                                              <div class=\"controls\">\r\n                                                                <input type=\"text\" ng-model=\"pol.stateSenateDistrict\" class=\"form-control input-md text-input\">\r\n                  </div>\r\n                                                              </div>\r\n                                                              <div class=\"control-group\">\r\n                                                                <label class=\"control-label\" for=\"pol-stateHouseofRepresentativesDistrict\">State House of Representatives District</label>\r\n                                                                <div class=\"controls\">\r\n                                                                  <input type=\"text\" ng-model=\"pol.stateHouseofRepresentativesDistrict\" class=\"form-control input-md text-input\">\r\n                  </div>\r\n                                                                </div>\r\n                                                                <div class=\"control-group\">\r\n                                                                  <label class=\"control-label\" for=\"pol-unifiedSchoolDistrictName\">Unified School District Name</label>\r\n                                                                  <div class=\"controls\">\r\n                                                                    <input type=\"text\" ng-model=\"pol.unifiedSchoolDistrictName\" class=\"form-control input-md text-input\">\r\n                  </div>\r\n                                                                  </div>\r\n                                                                  <div class=\"control-group\">\r\n                                                                    <label class=\"control-label\" for=\"pol-elementarySchoolDistrictName\">Elementary School District Name</label>\r\n                                                                    <div class=\"controls\">\r\n                                                                      <input type=\"text\" ng-model=\"pol.elementarySchoolDistrictName\" class=\"form-control input-md text-input\">\r\n                  </div>\r\n                                                                    </div>\r\n                                                                    <div class=\"control-group\">\r\n                                                                      <label class=\"control-label\" for=\"pol-secondarySchoolDistrictName\">Secondary School District Name</label>\r\n                                                                      <div class=\"controls\">\r\n                                                                        <input type=\"text\" ng-model=\"pol.secondarySchoolDistrictName\" class=\"form-control input-md text-input\">\r\n                  </div>\r\n                                                                      </div>\r\n                                                                    </div>\r\n                                                                    <div class=\"col-right\">\r\n                                                                    </div>\r\n                                                                    <div style=\"clear:both;\"></div>\r\n                                                                  </div>\r\n                                                                </div>\r\n                                                                <div style=\"clear: both;\"></div>\r\n                                                                <div\r\n                                                                  style=\"width: 55%; margin-top: 10px; float: right; margin-right: 17px;\">\r\n                                                                  <button ng-click=\"closeUserEdit()\" type=\"button\" class=\"btnShort-style\" style=\"float: right;\">Cancel</button>&nbsp;\r\n                                                                  <button ng-click=\"UpdateUser(upuser)\" type=\"submit\" class=\"btnShort-style\" style=\"float: right;\">Update</button>\r\n                                                                  <!--<fb:login-button scope=\"public_profile,email\" onlogin=\"checkLoginState();\">\r\n                                </fb:login-button>-->\r\n                                                                  <div style=\"clear: both;\"></div>\r\n                                                                </div>\r\n                                                                <div style=\"clear: both;\"></div>\r\n                                                              </div>\r\n      </fieldset>\r\n    </div>\r\n    <!-- Edit User End -->\r\n    <div class=\"row\" style=\"margin-top: 10px;\" ng-show=\"!UserFormDiv\">\r\n      <div class=\"col-md-12\">\r\n        <a href=\"javascript: void(0)\" ng-click=\"ShowUserForm()\">Add new user</a>\r\n        <p>\r\n          <h3>All users</h3>\r\n        </p>\r\n        <!-- <div style=\"float:right;\">\r\n                            <dir-pagination-controls max-size=\"5\" on-page-change=\"pageChanged(newPageNumber)\"></dir-pagination-controls>\r\n                        </div> -->\r\n        <label>\r\n          Search by user detail:\r\n          <input type=\"text\" ng-model=\"userDetailKeyword\" ng-change=\"userDetailTextChange()\" class=\"changeTextColor\">\r\n        </label>\r\n        <br />\r\n        <label>\r\n          Get Users Asked for :\r\n          <select ng-model=\"userDetailFilter\" class=\"changeTextColor\">\r\n            <option ng-repeat=\"item in postOptions\" value=\"{{item}}\">{{item}}</option>\r\n          </select>\r\n        </label>\r\n        <h3>OR</h3>\r\n        <label>\r\n          Search by organization detail:\r\n          <input type=\"text\" ng-model=\"orgDetailKeyword\" ng-change=\"orgDetailTextChange()\" class=\"changeTextColor\">\r\n        </label>\r\n        <br />\r\n        <button ng-click=\"searchPeople()\" class=\"changeTextColor\">Search</button>\r\n        <br>\r\n        <select ng-model=\"filterUser\" ng-change=\"filterUsers(filterUser)\" class=\"changeTextColor\">\r\n          <option ng-repeat=\"item in [\'all\', \'politician\', \'advocate\', \'press\']\" value=\"{{item}}\">{{item}}</option>\r\n        </select>\r\n        <button ng-show=\"notifyUser != 1\" ng-click=\"selectAll()\" class=\"blackText\">Select All</button>\r\n        <button ng-show=\"notifyUser != 1\" ng-click=\"notifyUsersTheirPasswords()\" style=\"margin-bottom: 15px;\" class=\"changeTextColor\">Send Passwords</button>\r\n        <br>\r\n        <label for=\"selState\" class=\"col-lg-2 col-sm-5 col-form-label\" style=\"color:#ffffff;\">Select State :\r\n        </label>\r\n        <div class=\"col-lg-5 col-sm-5\">\r\n          <select ng-model=\"sel.state\"  style=\"text-transform: capitalize;width:170px;display:inline\" ng-options=\"item as item.state for item in allLocations\"  class=\"changeTextColor form-control\">\r\n        </select>&nbsp; &nbsp;\r\n          <i ng-if=\"showLoader\"  class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>\r\n        </div>\r\n        <br>\r\n        <a href=\"\" ng-click=\"exportBoth()\" class=\"ylink\">Export Users and Politicians</a>\r\n        <br>\r\n        <br>\r\n        <div infinite-scroll=\'myPagingFunction()\'>\r\n          <!-- infinite-scroll-distance=\'2\' infinite-scroll-container=\"\'#globalHtmlTag\'\" -->\r\n          <table class=\"w100 changeTextColor\" ng-show=\"users.data.length > 0\">\r\n            <tr>\r\n              <th>Select</th>\r\n              <th>User Details</th>\r\n              <th>Status</th>\r\n              <th>Password</th>\r\n              <th>Melisa Data</th>\r\n              <th>Block Account</th>\r\n              <th>Edit / Remove</th>\r\n            </tr>\r\n            <tr ng-repeat=\"u in users.data\">\r\n              <!-- dir-paginate=\"u in users.data | itemsPerPage :usersPerPage\" total-items=\"totalUsers\" current-page=\"pagination.current\" -->\r\n              <td>\r\n                <input type=\"checkbox\" ng-model=\"u.isSelected\">\r\n              </td>\r\n              <td>\r\n                <img ng-src=\"../assets/images/profile/{{u.userType}}.svg\" alt=\"{{u.userType}}\" class=\"UserTypeImg\" />\r\n                <!-- <img src=\"../assets/images/profile/politician.svg\" alt=\"Politician\" ng-if=\"u.politician\" class=\"UserTypeImg\" />\r\n                    <img src=\"../assets/images/profile/press.svg\" class=\"UserTypeImg\" alt=\"Press\" ng-if=\"u.press\" />\r\n                    <img src=\"../assets/images/profile/voter.svg\" class=\"UserTypeImg\" alt=\"Voter\" ng-if=\"u.voter\" />\r\n                    <img src=\"../assets/images/profile/voter.svg\" class=\"UserTypeImg\" alt=\"Voter\" ng-if=\"u.admin\" />\r\n                    <img src=\"../assets/images/profile/voter.svg\" class=\"UserTypeImg\" alt=\"Voter\" ng-if=\"u.forumadmin\" />\r\n                    <img src=\"../assets/images/profile/voter.svg\" class=\"UserTypeImg\" alt=\"Voter\" ng-if=\"u.voteradmin\" />\r\n                    <img src=\"../assets/images/profile/advocate.svg\" class=\"UserTypeImg\" alt=\"Advocate\" ng-if=\"u.advocate\" /> -->\r\n                <p ng-if=\"u.name\" style=\"margin: 0;\">\r\n                  <strong>Name:</strong>\r\n                  <a href=\"#!/publicProfile/{{u._id}}\">{{u.name}}</a>\r\n                </p>\r\n                <p ng-if=\"u.username\" style=\"margin: 0;\">\r\n                  <strong>UserName:</strong>\r\n                  <a href=\"#!/publicProfile/{{u._id}}\">{{u.username}}</a>\r\n                </p>\r\n                <p ng-if=\"u.orgData.title\" style=\"margin: 0;\">\r\n                  <strong>Org:</strong>\r\n                  <a href=\"#!/pressProfile/{{u._id}}\">{{u.orgData.title}}</a>\r\n                </p>\r\n                <p ng-if=\"u.public_email\" style=\"margin: 0;\">\r\n                  <strong>Email:</strong> {{u.public_email}}</p>\r\n                <p ng-if=\"u.mailing_address\" style=\"margin: 0;\">\r\n                  <strong>Address:</strong> {{u.mailing_address}} </p>\r\n                <p ng-if=\"u.postCard\" style=\"margin: 0;\">\r\n                  <strong>postCard:</strong> {{u.postCard}} </p>\r\n                <p ng-if=\"u.govtOfficialWebsite\" style=\"margin: 0;\">\r\n                  <strong>Government Official Website:</strong>\r\n                  <a ng-href=\"{{u.govtOfficialWebsite}}\" target=\"_blank\">{{u.govtOfficialWebsite}}</a>\r\n                </p>\r\n              </td>\r\n              <td>\r\n                <b>Current Status: {{u.userStatus}}</b>\r\n                <br />\r\n                <a href=\"javascript: void(0);\" ng-click=\"changeStatus(u, \'block\')\" ng-if=\"u.userStatus!=\'block\'\" class=\"link\">Block</a>\r\n                <a href=\"javascript: void(0);\" ng-click=\"changeStatus(u, \'Active\')\" ng-if=\"u.userStatus==\'block\'\" class=\"link\">Make Active</a>\r\n              </td>\r\n              <td>\r\n                <a href=\"javascript: void(0)\" ng-click=\"generatePassword(u)\" class=\"link\">Generate</a>\r\n                <p ng-if=\"pass==u._id\" style=\"margin: 0;\">password:\r\n                  <b> {{password}}</b>\r\n                </p>\r\n              </td>\r\n              <td>\r\n                <a href=\"\" class=\"link\" ng-click=\"showMelisa(u._id)\">See</a>\r\n              </td>\r\n              <td>\r\n                <a href=\"\" class=\"link\" ng-click=\"makeInvisible(u,\'block\')\" ng-if=\"!u.isTempBlock\">Temp Block</a>\r\n                <a href=\"\" class=\"link\" ng-click=\"makeInvisible(u,\'unblock\')\" ng-if=\"u.isTempBlock\"> UnBlock</a>\r\n\r\n              </td>\r\n              <td>\r\n                <a href=\"\" ng-click=\"EditUser(u, $index)\" class=\"link\">Edit</a> |\r\n                <a href=\"javascript: void(0)\" ng-click=\"removeUser(u, $index)\" class=\"link\">Remove</a>\r\n              </td>\r\n            </tr>\r\n            <tr ng-if=\"users.data.length == 0\">\r\n              <td colspan=\"3\"> No records found.\r\n              </td>\r\n            </tr>\r\n          </table>\r\n        </div>\r\n        <button ng-show=\"notifyUser != 1\" ng-click=\"selectAll()\" class=\"blackText\">Select All</button>\r\n        <button ng-show=\"notifyUser != 1\" ng-click=\"notifyUsersTheirPasswords()\" style=\"margin-bottom: 15px;\" class=\"changeTextColor\">Send Passwords</button>\r\n        <p ng-if=\"statusGetResPg == 1\" class=\"fwb\">Loading users...</p>\r\n        <p ng-if=\"notifyUser == 1\">Sending passwords to user...</p>\r\n        <!-- <div style=\"float:right;\">\r\n                            <dir-pagination-controls max-size=\"5\" on-page-change=\"pageChanged(newPageNumber)\"></dir-pagination-controls>\r\n                        </div> -->\r\n      </div>\r\n    </div>\r\n  </form>\r\n  <!-- All Users End -->\r\n</div>\r\n<script type=\"text/ng-template\" id=\"addressPopUp\">\r\n  <div>\r\n    <h5>Change Your Login Details.</h5>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\">Email</label>\r\n              <div class=\"control-group\">\r\n                <!-- <input type=\"text\" id=\"address\" ng-model=\"User.email\"  class=\"form-control\" />&nbsp; -->\r\n                <input type=\"email\" ng-model=\"User.email\" data-errormessage=\"Email is required.\" class=\"form-control input-md  validate[required] text-input\"  style=\"width: 88%\">\r\n            </div>\r\n              </div>\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel\">UserName</label>\r\n                <div class=\"control-group\">\r\n                  <input type=\"text\" id=\"address\" ng-model=\"User.username\"  class=\"form-control\" />&nbsp;\r\n              </div>\r\n                </div> <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\">Password</label>\r\n                  <div class=\"control-group\">\r\n                    <input type=\"text\" id=\"address\" ng-model=\"User.password\"  class=\"form-control\" />&nbsp;\r\n                </div>\r\n                  </div>\r\n\r\n                <center>\r\n                  <button ng-click=\"updateCredentials(User)\" type=\"button\" class=\"btn2Short-style widthAuto btn-success\">Update Credentials</button>\r\n                </center>\r\n\r\n                <br><br>\r\n              </div>\r\n            </div>\r\n</script>\r\n");
$templateCache.put("app/answeredQuestions/answeredQuestions.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">ANSWERED QUESTIONS</h2>\r\n  <p class=\"pageSubHeading\">Take a look at the questions you\'ve answered in the past. We keep a history of your\r\n    answers, so if you change your answers, please say why you changed them so that you can tell people what world\r\n    events, gained wisdom or other things convinced you to change your mind.</p>\r\n\r\n  <p class=\"pageSubHeading\">If you are looking for a particular questions, use the search window below.</p>\r\n  <div ng-if=\"frontRunners && frontRunners.length > 0\">\r\n    <div class=\"control-group front-drop\">\r\n      <label class=\"control-label formLabel whiteText\" for=\"email\">Select Front Runner To Answer For</label>\r\n      <select ng-model=\"isUser.selected\" style=\"text-transform: capitalize;display: block;\" ng-options=\"item as item.name for item in frontRunners\" ng-change=\"setUserId()\" class=\"changeTextColor form-control \">\r\n    </select>\r\n    </div>\r\n  </div>\r\n  <div>\r\n    <center>\r\n      <input ng-model=\"ques.searchQuestionKeyword\" class=\"blackText\">\r\n      <button ng-click=\"searchQuestion(ques.searchQuestionKeyword)\" class=\"blackText\">Search Questions</button>\r\n    </center>\r\n  </div>\r\n\r\n  <!-- <pre>{{status.category}} | {{status.levlCat}}</pre> -->\r\n  <p ng-if=\"status.levlCat == 1\" class=\"fwb\">Loading background ...</p>\r\n  <div class=\"pad10\">\r\n    <div ng-if=\"state == \'question-not-answered\'\">\r\n      <div class=\"clearfix w100\" ng-if=\"state == \'question-answered-by\' && politicianName\">\r\n        Showing questions answered by <b>{{politicianName}}</b>\r\n      </div>\r\n      <div>\r\n        <p>\r\n          <h1>\r\n            <center>{{category.title}}</center>\r\n          </h1>\r\n        </p>\r\n        <p></p>\r\n        <div>\r\n          <center ng-if=\"category.fbImage\">\r\n            <img ng-src=\"https://api.votewise.net/resources/{{category.fbImage}}\" class=\"wibble\" />\r\n      </center>\r\n        </div>\r\n        <center id=\"DisplayC\">\r\n          <h2>BACKGROUND</h2>\r\n        </center>\r\n        <p></p>\r\n        <div class=\"row d-flex justify-content-center\">\r\n          <div class=\"col-lg-7 col-sm-12\">\r\n            <p ng-bind-html=\"category.description | newlines\"></p>\r\n          </div>\r\n          <!--  <div ng-if=\"state == \'question-not-answered\'\">\r\n    <center><p>Following are the questions which are answered by your politicians. You can also answer them to see the match.</p></center>\r\n  </div> -->\r\n          <div ng-if=\"status.category == 1\" class=\"fwb\">\r\n            Loading category ...\r\n          </div>\r\n          <div ng-if=\"status.category == 3\" class=\"fwb\">\r\n            Something went wrong while loading category.\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <br>\r\n      <br>\r\n      <div id=\"DisplayQue\">\r\n\r\n        <br>\r\n        <div ng-show=\"questions[currentIndex]\">\r\n          <!-- <type=\"button\" value=\"LEARN MORE\"> -->\r\n          <p></p>\r\n          <div class=\"row  d-flex justify-content-center\">\r\n            <div class=\"col-lg-7 col-sm-12 \">\r\n              <h4 class=\"text-center\">Questions</h4>\r\n              <!-- <div style=\"display: block; text-align: center;\">\r\n  <button type=\"button\" id=\"skipMatchOne\" ng-disabled=\"skipMatchOne == 1 \" class=\"skipMatch\" ng-click=\"skipToMatchOne()\">Skip To Results</button>\r\n</div>\r\n -->\r\n\r\n              <div class=\"card customCard\">\r\n                <div class=\"card-header quesCardHeaderMain\">\r\n                  <div class=\"d-flex justify-content-between bd-highlight\">\r\n                    <!-- <div class=\"p-2 bd-highlight quesCardHeader\">Statement</div> -->\r\n                    <div class=\"p-2 bd-highlight\">\r\n                      <span class=\"textYellow\">{{currentIndex+1}}</span>/{{questions.length}}</div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"card-body customCardBody\">\r\n                  <p  class=\"card-text\" ng-bind-html=\"questions[currentIndex].content | newlines\"></p>\r\n                  <div class=\"row vdivide\">\r\n                    <div class=\"col col-6\">\r\n                      <div class=\"rcontent\" style=\"float:right; line-height: 9px;\">\r\n                        <span id=\"disagreeText\">DISAGREE &nbsp;</span>\r\n                        <div style=\"float:right;\">\r\n                          <div class=\"box\">\r\n                            <ul class=\"vi-radio\">\r\n                              <li>\r\n                                <input type=\"radio\" id=\"agreedisagree-id6\" name=\"agreeDisagree\" value=\"6\" ng-model=\"answer\" ng-checked=\"checkIfExists(6)\"  ng-change=\"chgAns(6)\" ng-click=\"ansCheck(6)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                                <label for=\"agreedisagree-id6\"></label>\r\n                                <div class=\"checknew red sixth\"></div>\r\n                              </li>\r\n                            </ul>\r\n                          </div>\r\n                          <div class=\"box\">\r\n                            <ul class=\"vi-radio\">\r\n                              <li>\r\n                                <input type=\"radio\" id=\"agreedisagree-id5\" name=\"agreeDisagree\" value=\"5\"  ng-model=\"answer\" ng-checked=\"checkIfExists(5)\" ng-change=\"chgAns(5)\"  ng-click=\"ansCheck(5)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                                <label for=\"agreedisagree-id5\"></label>\r\n                                <div class=\"checknew five fifth\"></div>\r\n                              </li>\r\n                            </ul>\r\n                          </div>\r\n                          <div class=\"box\">\r\n                            <ul class=\"vi-radio\">\r\n                              <li>\r\n                                <input type=\"radio\" id=\"agreedisagree-id4\" name=\"agreeDisagree\" value=\"4\"  ng-model=\"answer\" ng-checked=\"checkIfExists(4)\" ng-change=\"chgAns(4)\" ng-click=\"ansCheck(4)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                                <label for=\"agreedisagree-id4\"></label>\r\n                                <div class=\"checknew four forth\"></div>\r\n                              </li>\r\n                            </ul>\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"col col-6\">\r\n                      <div class=\"rcontent\">\r\n                        <span style=\"color: #04A752; font-weight: vold;\">&nbsp; AGREE</span>\r\n                        <div style=\"float:left;\">\r\n                          <div class=\"box\">\r\n                            <ul class=\"vi-radio\">\r\n                              <li>\r\n                                <input type=\"radio\" id=\"agreedisagree-id3\" name=\"agreeDisagree\" value=\"3\" ng-model=\"answer\" ng-checked=\"checkIfExists(3)\"  ng-change=\"chgAns(3)\" ng-click=\"ansCheck(3)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                                <label for=\"agreedisagree-id3\"></label>\r\n                                <div class=\"checknew three third\"></div>\r\n                              </li>\r\n                            </ul>\r\n                          </div>\r\n                          <div class=\"box\">\r\n                            <ul class=\"vi-radio\">\r\n                              <li>\r\n                                <input type=\"radio\" id=\"agreedisagree-id2\" name=\"agreeDisagree\" value=\"2\" ng-model=\"answer\" ng-checked=\"checkIfExists(2)\"  ng-change=\"chgAns(2)\" ng-click=\"ansCheck(2)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                                <label for=\"agreedisagree-id2\"></label>\r\n                                <div class=\"checknew two second\"></div>\r\n                              </li>\r\n                            </ul>\r\n                          </div>\r\n                          <div class=\"box\">\r\n                            <ul class=\"vi-radio\">\r\n                              <li>\r\n                                <input type=\"radio\" id=\"agreedisagree-id1\" name=\"agreeDisagree\"  ng-model=\"answer\" value=\"1\" ng-checked=\"checkIfExists(1)\" ng-change=\"chgAns(1)\" ng-click=\"ansCheck(1)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                                <label for=\"agreedisagree-id1\"></label>\r\n                                <div class=\"checknew first\"></div>\r\n                              </li>\r\n                            </ul>\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"card card1\">\r\n                <div class=\"card-header card1Header\">\r\n                  <p class=\"card-title\">ADD COMMENT</p>\r\n                </div>\r\n                <div class=\"card-body card1Body\">\r\n                  <textarea class=\"form-control addComment\" id=\"exampleFormControlTextarea1\" ng-model=\"updata.comment\" rows=\"1\" placeholder=\"(not required...)\"></textarea>\r\n                  <textarea ng-show=\"questions[currentIndex].my_answer\" ng-model=\"updata.reason\" id=\"txtReason\" name=\"txtReason\" class=\"vi-textarea\" placeholder=\"REASON TO CHANGE ANSWER\" style=\"margin-top: 10px;\"></textarea>\r\n                </div>\r\n                <!--  <a class=\"fwb\" ng-if=\"questions[currentIndex].my_answer.old_answers.length > 0\" href=\"javascript: void(0)\" ng-click=\"viewOldAnswers(questions[currentIndex].my_answer.old_answers)\">* Answer has been changed (click here to view old answers)</a> -->\r\n                <br>\r\n            </div>\r\n\r\n                <div class=\"card card1\">\r\n                  <div class=\"card-header card1Header\">\r\n                    <p class=\"card-title\">IMPORTANCE</p>\r\n                  </div>\r\n                  <div class=\"card-body card1Body\" style=\"margin:0 auto;\">\r\n                    <form class=\"impSection d-md-flex d-sm-block\">\r\n                      <div class=\"A\">\r\n                        <input type=\"radio\" class=\"button\" id=\"importance-id1\" ng-model=\"importance\" ng-change=\"chgImp(1)\" name=\"importance\" ng-model=\"importance\" ng-checked=\"checkImpExists(1)\" ng-click=\"newSub(1)\" value=\"1\"></input>\r\n                        <label for=\"importance-id1\">Not Very</label>\r\n                      </div>\r\n                      <div class=\"B\">\r\n                        <input type=\"radio\" class=\"button\" id=\"importance-id2\" ng-model=\"importance\" ng-change=\"chgImp(2)\" name=\"importance\" ng-model=\"importance\" ng-checked=\"checkImpExists(2)\"  ng-click=\"newSub(2)\" value=\"2\"></input>\r\n                        <label for=\"importance-id2\">Somewhat</label>\r\n                      </div>\r\n                      <div class=\"C\">\r\n                        <input type=\"radio\" class=\"button\" id=\"importance-id3\" ng-model=\"importance\" ng-change=\"chgImp(3)\" name=\"importance\" ng-model=\"importance\" ng-checked=\"checkImpExists(3)\"  ng-click=\"newSub(3)\" value=\"3\"></input>\r\n                        <label for=\"importance-id3\">Very</label>\r\n                      </div>\r\n                      <!-- </div> -->\r\n                    </form>\r\n                  </div>\r\n                </div>\r\n\r\n\r\n\r\n\r\n\r\n              </div>\r\n            </div>\r\n            <div ng-show=\"questions.length > 0\" class=\"row\">\r\n              <div class=\"col bottomBtns\">\r\n                <div class=\"btn-group\" role=\"group\" aria-label=\"Default button group\">\r\n                  <button type=\"button\" id=\"backBtn\" class=\"btn-transparent\" ng-click=\"prevQuestion()\">\r\n                <i class=\"fa fa-angle-left arrowIconBack\"></i> Back</button>\r\n                  <button type=\"button\" id=\"skipBtn\" class=\"btn-transparent\" ng-click=\"skipQuestions()\">Skip</button>\r\n                  <button type=\"button\" id=\"submitBtn\" class=\"btn-transparent\" ng-click=\"submitAnswer()\" ng-class=\"{\'activeSubmit\': (answer &&importance)}\">Submit\r\n                <i class=\"fa fa-angle-right arrowIconSubmit\"></i>\r\n              </button>\r\n                </div>\r\n              </div>\r\n          <!--    <div ng-if=\"!userData.isemailverified\" style=color:red>\r\n                <h4>You can\'t submit your answers until you verify your email address and re-log in. But feel free to\r\n                  explore.</h4>\r\n                </style>\r\n              </div> -->\r\n            </div>\r\n            <br>\r\n            <br>\r\n            <br>\r\n            <center>\r\n              <button type=\"button\" id=\"btnY\" class=\"btn-transparent\" ng-click=\"notAnswerableSelected()\" ng-show=\"$root.userRole==\'admin\'||$root.userRole==\'advocate\' \">REPORT BAD QUESTION</button>\r\n            </center>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n");
$templateCache.put("app/backup/backup.html","<div class=\"container-fluid ng-scope\" ng-cloak ng-show=\"$root.userRole==\'admin\'\">\r\n  <h2 class=\"pageHeading\">Settings</h2>\r\n  <div>\r\n    <div class=\"closeForm\" ng-include=\"\'app/popups/setting_Ctrl.html\'\"></div>\r\n  </div>\r\n  <form  name=\"signupform\" id=\"signInform\" ng-controller=\"AdminBackup\" class=\"closeForm\">\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Backup</legend>\r\n      <a href=\"javascript: void(0)\" ng-click=\"takeBackupOfDb()\">\r\n              <button class=\"changeTextColor\">Take Backup</button>\r\n            </a>\r\n      <p ng-if=\"statusTakeBackup == 1\">Taking backup ...</p>\r\n      <br>\r\n      <a href=\"javascript: void(0)\" ng-click=\"getBackupFiles()\">Refresh</a>\r\n      <div class=\"row\" ng-if=\"backupFiles.length > 0\" style=\"margin-top: 10px;\">\r\n        <table class=\"w100\">\r\n          <tr>\r\n            <th>File</th>\r\n            <th>Download</th>\r\n          </tr>\r\n          <tr ng-repeat=\"f in backupFiles\">\r\n            <td>{{f}}</td>\r\n            <td ng-if=\"$root.userRole == \'admin\'\">\r\n              <a ng-if=\"!u.approved\" href=\"javascript: void(0)\" ng-click=\"downloadFile(f)\">Download</a>\r\n            </td>\r\n          </tr>\r\n        </table>\r\n      </div>\r\n      <p ng-if=\"backupFiles.length <= 0 && statusGetBackup == 2\">No results found</p>\r\n      <p ng-if=\"statusGetBackup == 1\">Loading data...</p>\r\n    </fieldset>\r\n  </form>\r\n</div>\r\n");
$templateCache.put("app/ballotMatch/ballotMatch.html","<!-- <pre>{{status.category}} | {{status.levlCat}}</pre> -->\r\n<p ng-if=\"status.levlCat == 1\" class=\"fwb\">Loading background ...</p>\r\n<div class=\"pad10\">\r\n  <div class=\"clearfix w100\" ng-if=\"state == \'question-answered-by\' && politicianName\">\r\n    Showing questions answered by <b>{{politicianName}}</b>\r\n  </div>\r\n  <div>\r\n    <p>\r\n      <h1>\r\n        <center>{{category.title}}</center>\r\n      </h1>\r\n    </p>\r\n    <p></p>\r\n    <div>\r\n      <center ng-if=\"category.fbImage\">\r\n        <img ng-src=\"https://api.votewise.net/resources/{{category.fbImage}}\" class=\"wibble\" />\r\n      </center>\r\n    </div>\r\n    <center id=\"DisplayC\">\r\n      <h2>BACKGROUND</h2>\r\n    </center>\r\n    <p></p>\r\n    <div class=\"row d-flex justify-content-center\">\r\n      <div class=\"col-lg-7 col-sm-12\">\r\n        <p ng-bind-html=\"category.description | newlines\"></p>\r\n      </div>\r\n      <!--  <div ng-if=\"state == \'question-not-answered\'\">\r\n    <center><p>Following are the questions which are answered by your politicians. You can also answer them to see the match.</p></center>\r\n  </div> -->\r\n      <div ng-if=\"status.category == 1\" class=\"fwb\">\r\n        Loading category ...\r\n      </div>\r\n      <div ng-if=\"status.category == 3\" class=\"fwb\">\r\n        Something went wrong while loading category.\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <br>\r\n  <br>\r\n  <div>\r\n    <div id=\" DisplayQue\">\r\n      <center>\r\n        <label>\r\n          <input type=\"checkbox\" ng-model=\"flagSkipAnsweredQuestion\" ng-change=\"skipAnswerChagne()\"> Skip Answered Questions\r\n          <!-- {{flagSkipAnsweredQuestion}} -->\r\n        </label>\r\n      </center>\r\n      <div ng-show=\"questions[currentIndex]\">\r\n        <!-- <type=\"button\" value=\"LEARN MORE\"> -->\r\n        <p></p>\r\n        <div class=\"row  d-flex justify-content-center\">\r\n          <div class=\"col-lg-7 col-sm-12\" id=\"DisplayQ1\">\r\n            <h4 class=\"text-center\">Questions</h4>\r\n            <div style=\"display: block; text-align: center;\">\r\n              <button type=\"button\" id=\"skipMatchOne\" ng-disabled=\"skipMatchOne == 1 \" class=\"skipMatch\" ng-click=\"skipToMatchOne()\">Skip To Results</button>\r\n            </div>\r\n            <div class=\"card customCard\">\r\n              <div class=\"card-header quesCardHeaderMain\">\r\n                <div class=\"d-flex justify-content-between bd-highlight\">\r\n                  <!-- <div class=\"p-2 bd-highlight quesCardHeader\">Statement</div> -->\r\n                  <div class=\"p-2 bd-highlight\">\r\n                    <span class=\"textYellow\">{{currentIndex+1}}</span>/{{questions.length}}</div>\r\n                </div>\r\n              </div>\r\n              <div class=\"card-body customCardBody\">\r\n                <p  class=\"card-text\" ng-bind-html=\"questions[currentIndex].content | newlines\"></p>\r\n                <div class=\"row vdivide\">\r\n                  <div class=\"col col-6\">\r\n                    <div class=\"rcontent\" style=\"float:right;\">\r\n                      <span id=\"disagreeText\">DISAGREE &nbsp</span>\r\n                      <div style=\"float:right;\">\r\n                        <div class=\"box\">\r\n                          <ul class=\"vi-radio\">\r\n                            <li>\r\n                              <input type=\"radio\" id=\"agreedisagree-id6\" name=\"agreeDisagree\" value=\"6\" ng-model=\"answer\" ng-checked=\"checkIfExists(6)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                              <label for=\"agreedisagree-id6\"></label>\r\n                              <div class=\"checknew red sixth\"></div>\r\n                            </li>\r\n                          </ul>\r\n                        </div>\r\n                        <div class=\"box\">\r\n                          <ul class=\"vi-radio\">\r\n                            <li>\r\n                              <input type=\"radio\" id=\"agreedisagree-id5\" name=\"agreeDisagree\" value=\"5\" ng-model=\"answer\" ng-checked=\"checkIfExists(5)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                              <label for=\"agreedisagree-id5\"></label>\r\n                              <div class=\"checknew five fifth\"></div>\r\n                            </li>\r\n                          </ul>\r\n                        </div>\r\n                        <div class=\"box\">\r\n                          <ul class=\"vi-radio\">\r\n                            <li>\r\n                              <input type=\"radio\" id=\"agreedisagree-id4\" name=\"agreeDisagree\" value=\"4\" ng-model=\"answer\" ng-checked=\"checkIfExists(4)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                              <label for=\"agreedisagree-id4\"></label>\r\n                              <div class=\"checknew four forth\"></div>\r\n                            </li>\r\n                          </ul>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col col-6\">\r\n                    <div class=\"rcontent\">\r\n                      <span  style=\"color: #04A752; font-weight: bold;\">&nbsp;AGREE</span>\r\n                      <div style=\"float:left;\">\r\n                        <div class=\"box\">\r\n                          <ul class=\"vi-radio\">\r\n                            <li>\r\n                              <input type=\"radio\" id=\"agreedisagree-id3\" name=\"agreeDisagree\" value=\"3\" ng-model=\"answer\" ng-checked=\"checkIfExists(3)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                              <label for=\"agreedisagree-id3\"></label>\r\n                              <div class=\"checknew three third\"></div>\r\n                            </li>\r\n                          </ul>\r\n                        </div>\r\n                        <div class=\"box\">\r\n                          <ul class=\"vi-radio\">\r\n                            <li>\r\n                              <input type=\"radio\" id=\"agreedisagree-id2\" name=\"agreeDisagree\" value=\"2\" ng-model=\"answer\" ng-checked=\"checkIfExists(2)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                              <label for=\"agreedisagree-id2\"></label>\r\n                              <div class=\"checknew two second\"></div>\r\n                            </li>\r\n                          </ul>\r\n                        </div>\r\n                        <div class=\"box\">\r\n                          <ul class=\"vi-radio\">\r\n                            <li>\r\n                              <input type=\"radio\" id=\"agreedisagree-id1\" name=\"agreeDisagree\" value=\"1\" ng-model=\"answer\" ng-checked=\"checkIfExists(1)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                              <label for=\"agreedisagree-id1\"></label>\r\n                              <div class=\"checknew first\"></div>\r\n                            </li>\r\n                          </ul>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"card card1\">\r\n              <div class=\"card-header card1Header\">\r\n                <p class=\"card-title\">ADD COMMENT</p>\r\n              </div>\r\n              <div class=\"card-body card1Body\">\r\n                <textarea class=\"form-control addComment\" id=\"exampleFormControlTextarea1\" ng-model=\"updata.comment\" rows=\"1\" placeholder=\"(not required)....\"></textarea>\r\n                <textarea ng-show=\"questions[currentIndex].my_answer\" ng-model=\"updata.reason\" id=\"txtReason\" name=\"txtReason\" class=\"vi-textarea\" placeholder=\"REASON TO CHANGE ANSWER\" style=\"margin-top: 10px;\"></textarea>\r\n              </div>\r\n              <!--  <a class=\"fwb\" ng-if=\"questions[currentIndex].my_answer.old_answers.length > 0\" href=\"javascript: void(0)\" ng-click=\"viewOldAnswers(questions[currentIndex].my_answer.old_answers)\">* Answer has been changed (click here to view old answers)</a> -->\r\n              <br>\r\n            </div>\r\n              <div class=\"card card1\">\r\n                <div class=\"card-header card1Header\">\r\n                  <p class=\"card-title\">IMPORTANCE</p>\r\n                </div>\r\n                <div class=\"card-body card1Body\" style=\"margin:0 auto;\">\r\n                  <form class=\"impSection d-md-flex d-sm-block\">\r\n                    <div class=\"A\">\r\n                      <input type=\"radio\" class=\"button\" id=\"importance-id1\" ng-model=\"importance\" name=\"importance\"  ng-checked=\"checkImpExists(1)\"  ng-click=\"newOne(1)\" value=\"1\"></input>\r\n                      <label for=\"importance-id1\">Not Very</label>\r\n                    </div>\r\n                    <div class=\"B\">\r\n                      <input type=\"radio\" class=\"button\" id=\"importance-id2\" ng-model=\"importance\" name=\"importance\"  ng-checked=\"checkImpExists(2)\"  ng-click=\"newOne(2)\" value=\"2\"></input>\r\n                      <label for=\"importance-id2\">Somewhat</label>\r\n                    </div>\r\n                    <div class=\"C\">\r\n                      <input type=\"radio\" class=\"button\" id=\"importance-id3\" ng-model=\"importance\" name=\"importance\"  ng-checked=\"checkImpExists(3)\" ng-click=\"newOne(3)\" value=\"3\"></input>\r\n                      <label for=\"importance-id3\">Very</label>\r\n                    </div>\r\n                    <!-- </div> -->\r\n                  </form>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div ng-show=\"questions.length > 0\" class=\"row\">\r\n            <div class=\"col bottomBtns\">\r\n              <div class=\"btn-group\" role=\"group\" aria-label=\"Default button group\">\r\n                <button type=\"button\" id=\"backBtn\" class=\"btn-transparent\" ng-click=\"prevQuestion()\">\r\n                <i class=\"fa fa-angle-left arrowIconBack\"></i> Back</button>\r\n                <button type=\"button\" id=\"skipBtn\" class=\"btn-transparent\" ng-click=\"skipQuestions()\">Skip</button>\r\n                <button type=\"button\" id=\"submitBtn\" class=\"btn-transparent\" ng-click=\"submitAnswer()\" ng-class=\"{\'activeSubmit\': (answer &&importance)}\">Submit\r\n                <i class=\"fa fa-angle-right arrowIconSubmit\"></i>\r\n              </button>\r\n              </div>\r\n            </div>\r\n            <div ng-if=\"!userData.isemailverified\" style=color:red>\r\n              <h4>\r\n                <p>Your politicians won\'t know how you feel about the topics until you confirm your email and we can be\r\n                  sure that you\'re not a fake user trying to change the polling data.</p>\r\n              </h4>\r\n              </style>\r\n            </div>\r\n          </div>\r\n          <br>\r\n          <br>\r\n          <br>\r\n          <center>\r\n            <button type=\"button\" id=\"btnY\" class=\"btn-transparent\" ng-click=\"notAnswerableSelected()\" ng-show=\"$root.userRole==\'admin\'||$root.userRole==\'advocate\' \">REPORT BAD QUESTION</button>\r\n          </center>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <!-- <div class=\"mb5 clearfix print-hide\">\r\n <a class=\"clk fwb\" ng-click=\"prevQuestion()\">Prev</a>&nbsp;\r\n                  <a class=\"clk fwb\" ng-click=\"skipQuestion()\">Next</a>\r\n    <button class=\"compareBtnS\" ng-click=\"prevQuestion()\"><i class=\"fa fa-angle-left arrowIconBack\"></i>Prev</button>\r\n    <button class=\"compareBtnS\" ng-click=\"skipQuestion()\">Next<i class=\"fa fa-angle-right arrowIconSubmit\"></i></button>\r\n</div> -->\r\n</div>\r\n</div>\r\n<div ng-if=\"status.questions == 2 && questions.length == 0\" class=\"fwb\">\r\n  <center>No unanswered questions found.</center>\r\n	<div style=\"display: block; text-align: center;\">\r\n              <button type=\"button\" id=\"skipMatchOne\" ng-disabled=\"skipMatchOne == 1 \" class=\"skipMatch\" ng-click=\"skipToMatchOne()\">Skip To Results</button>\r\n            </div>\r\n	<div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/incumbent_politician/politician\" class=\"blockLink\"><img ng-src=\"./assets/images/politiciansRBB7-01.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock4\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">YOUR POLITICIANS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Find out what they stand for, who stands behind them, and who pays for their campaigns.  See their voting record. See their ratings.  Compare politicians who are running for office, using your match quizzes to see who would best represent your interests.  Contact the politicians that represent you to ask for help.  Watch debates, read essays, and more.</p>\r\n\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n</div>\r\n\r\n\r\n   <div ng-if=\"status.questions == 1\" style=\"z-index: 2; background:black;\"><center>\r\n      <i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span></center>\r\n    </div>\r\n<div ng-if=\"status.questions == 3\" class=\"fwb\">\r\n  Something went wrong while loading questions.\r\n</div>\r\n<!--\r\n  <div>\r\n    <br>\r\n    <br>\r\n\r\n    <table>\r\n      <tbody>\r\n        <tr>\r\n          <th>\r\n            <center>\r\n              <a href=\"NotBuiltYet.html\">\r\n                <img src=\"assets/images/back3.svg\" alt=\"Back\" class=\"back\">\r\n              </a>\r\n            </center>\r\n          </th>\r\n          <th>\r\n            <center>\r\n              <a href=\"compare.html\">\r\n                <img src=\"assets/images/submit.svg\" alt=\"Submit\" class=\"submit\">\r\n              </a>\r\n            </center>\r\n          </th>\r\n          <th>\r\n            <center>\r\n              <a href=\"NotBuiltYet.html\">\r\n                <img src=\"assets/images/skip3.svg\" alt=\"Skip\" class=\"back\">\r\n              </a>\r\n            </center>\r\n          </th>\r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n  </div>\r\n  -->\r\n<script type=\"text/ng-template\" id=\"nextQuestionOptions\">\r\n  <ul class=\"catList\">\r\n    <li>\r\n      <input type=\"radio\" id=\"options1\" ng-model=\"fb.options\" value=\"C\" />\r\n      <label for=\"options1\">Continue Answering questions so your politicians know what you want them to do.</label>\r\n    </li>\r\n  <!--\r\n    <li>\r\n      <input type=\"radio\" id=\"options2\" ng-model=\"fb.options\" value=\"P\" />\r\n      <label for=\"options2\">Post this quiz for your friends to answer on Facebook.</label>\r\n    </li>\r\n    <li>\r\n      <input type=\"radio\" id=\"options3\" ng-model=\"fb.options\" value=\"Q\" />\r\n      <label for=\"options3\">Let me choose which questions to hide from Facebook.</label>\r\n    </li>\r\n    <li>\r\n      <input type=\"radio\" id=\"options4\" ng-model=\"fb.options\" value=\"M\" />\r\n      <label for=\"options4\">See how your friends match your answers.</label>\r\n    </li>\r\n-->\r\n    <li>\r\n      <input type=\"radio\" id=\"options5\" ng-model=\"fb.options\" value=\"F\" />\r\n      <label for=\"options5\">See how others answered</label>\r\n    </li>\r\n    <li>\r\n      <center><input type=\"button\" ng-click=\"NextOptions(fb.options)\" class=\"compareBtn\" value=\"Next\" />&nbsp;\r\n      <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"DisplayFLoader\"></i></center>\r\n    </li>\r\n\r\n  </ul>\r\n</script>\r\n<script type=\"text/ng-template\" id=\"FBComposeMessage\">\r\n  <center>\r\n    <h2>Post message on Facebook</h2>\r\n    <div>\r\n      <div style=\"width:15%; float:left;\">Message: </div>\r\n      <div style=\"width:84%; float:left;\">\r\n        <textarea ng-model=\"fb.message\" style=\"width:100%; height: 100px;\"></textarea>\r\n      </div>\r\n    </div>\r\n    <div style=\"clear:both;\"></div>\r\n    <div>\r\n      <div style=\"width:15%; float:left;\">&nbsp;</div>\r\n      <div style=\"width:84%; float:left; text-align:left;\">\r\n        <input type=\"button\" ng-click=\"postFB(fb.message)\" value=\"Submit to Facebook*\" />&nbsp;\r\n        <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"DisplayFPostLoader\"></i>\r\n        <p>\r\n          <b>*Note:</b>If you are not currently logged into Facebook, you must enable pop-ups in your browser in order for the\r\n          Facebook sign in window to pop up.</p>\r\n      </div>\r\n    </div>\r\n    <div style=\"clear:both;\"></div>\r\n</script>\r\n<script type=\"text/ng-template\" id=\"FBFreindList\">\r\n  <h3>Select friends to compare with your answers.</h3>\r\n  <ul class=\"catList\">\r\n    <li ng-repeat=\"frd in FBfreinds track by $index\">\r\n      <!--<div style=\"width:15%; height: 50px; float: left;\">\r\n            <i class=\"fa fa-check-circle\" aria-hidden=\"true\"></i> -->\r\n      <input type=\"checkbox\" id=\"{{$index}}\" name=\"selectedFrds[]\" value=\"{{frd.id}}\" ng-click=\"selectedFrd(frd)\" ng-checked=\"selection.indexOf({{frd.id}}) > -1\"\r\n      />\r\n      <label for=\"{{$index}}\">\r\n        <img ng-src=\"http://graph.facebook.com/{{frd.id}}/picture?type=square\" /> {{frd.name}}</label>\r\n      <!-- </div><div style=\"width:15%; height: 50px; float: left;\"><img ng-src=\"http://graph.facebook.com/{{frd.id}}/picture?type=square\" /></div> <div style=\"width:48%; height: 50px; float: left;\">{{frd.name}}</div> -->\r\n    </li>\r\n    <li>\r\n      <input type=\"button\" ng-click=\"ComapreWithSelected()\" value=\"Compare\" />\r\n    </li>\r\n  </ul>\r\n</script>\r\n<!--\r\n<script type=\"text/ng-template\" id=\"FBFreindCompare\">\r\n    <h3>Comparision with your freinds.</h3>\r\n    <ul class=\"catList\">\r\n        <li ng-repeat=\"quest in FBCompareList track by $index\">\r\n            <div style=\"width: 3%; float:left;\">{{$index + 1}}</div>\r\n            <div style=\"width: 96%; float:left;\">\r\n                <div>{{quest.content}}</div>\r\n                <div><b>My Answer:</b> {{AnswerArray[quest.my_answer.answer]}}, <b>Importance:</b> {{AnswerImpArray[quest.my_answer.importance]}}\r\n                <div ng-if=\"quest.my_answer.comment!=\'\'\" style=\"padding-left:10px;padding-right:10px;\"><i><small>Comments: {{quest.my_answer.comment}}</small></i></div>\r\n                </div>\r\n                <div ng-repeat=\"frd in quest.answers\"><b>{{frd.author.username}}:</b> {{AnswerArray[frd.answer]}}, <b>Importance:</b> {{AnswerImpArray[frd.importance]}}\r\n                    <div ng-if=\"frd.comment!=\'\'\" style=\"padding-left:10px;padding-right:10px;\"><i><small>Comments: {{frd.comment}}</i></small></div>\r\n                </div>\r\n            </div>\r\n            <div style=\"clear:both;\"></div>\r\n        </li>\r\n    </ul>\r\n</script>\r\n-->\r\n<script type=\"text/ng-template\" id=\"FBFreindCompare\">\r\n  <center>\r\n    <h2>Match</h2>\r\n    <h3>{{category.title}}</h3>\r\n  </center>\r\n  <div>\r\n    <div class=\"squareBoxY\" >&nbsp;</div>\r\n    <div class=\"squareMenu\">= Simple Comparison by answers alone.</div>\r\n    <div style=\"clear:both;\"></div>\r\n    <div class=\"squareBoxB\" >&nbsp;</div>\r\n    <div class=\"squareMenu\">= Weighted Comparison by answers and importance.</div>\r\n    <div style=\"clear:both;\"></div>\r\n  </div>\r\n  <div>\r\n    <div style=\"width:30%; float:left; text-align:right;\">Order By :&nbsp;&nbsp;</div>\r\n    <div style=\"width:65%; float:left; text-align:left;\">\r\n      <select ng-model=\"ord.Option\">\r\n        <option value=\"BW\">Best Weighted match</option>\r\n        <option value=\"W\">Worst weighted match</option>\r\n        <option value=\"BS\">Best simple match</option>\r\n        <option value=\"S\">Worst simple match</option>\r\n      </select>\r\n    </div>\r\n    <div style=\"clear:both;\"></div>\r\n  </div>\r\n  <ul class=\"catList\">\r\n    <li ng-repeat=\"frd in FBfreinds | orderBy:checkMyOrder track by $index\" ng-if=\"FBunWeighted[frd.id] && fbcombinedWeight[frd.id]\">\r\n      <div style=\"background-color:#bbb; padding:10px;\">\r\n        <div style=\"width: 15%; float:left;\">\r\n          <img ng-src=\"http://graph.facebook.com/{{frd.id}}/picture?type=square\" />\r\n          <br/>{{frd.name}}</div>\r\n        <div style=\"width: 84%; float:left;\">\r\n          <div>\r\n            <div class=\"fbunweighted\" style=\"width:{{(FBunWeighted[frd.id] / fbqlen[frd.id] )  | number:2}}%\">{{(FBunWeighted[frd.id] / fbqlen[frd.id] ) | number:2}}%</div>\r\n          </div>\r\n          <div>\r\n            <div class=\"fbweighted\" style=\"width:{{(fbcombinedWeight[frd.id] / fbmultiplier[frd.id])  | number:2}}%\">{{(fbcombinedWeight[frd.id] / fbmultiplier[frd.id]) | number:2}}%</div>\r\n          </div>\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n      </div>\r\n    </li>\r\n  </ul>\r\n</script>\r\n<script type=\"text/ng-template\" id=\"ReviewMyAnswers\">\r\n  <h3>Review Answers and hide them from your friends.</h3>\r\n	 <center>\r\n    <div ng-if=\"showLoader\" style=\"z-index: 2; background:black;\"><i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span></div>\r\n\r\n  </center>\r\n  <table class=\"w100\">\r\n    <tr>\r\n      <th>Sr.</th>\r\n      <th>Question</th>\r\n      <th>Answer</th>\r\n      <th>Importance</th>\r\n      <th>Show/Hide</th>\r\n    </tr>\r\n    <tr ng-repeat=\"q in allQuestions track by $index\" ng-init=\"q.my_answer.show!=\'N\'? switchStatus[$index]=true: switchStatus[$index]=false;\">\r\n      <td>\r\n        {{$index + 1}}\r\n      </td>\r\n      <td style=\"text-align:left;\">\r\n        {{q.content}}\r\n      </td>\r\n      <td>\r\n        {{AnswerArray[q.my_answer.answer]}}\r\n      </td>\r\n      <td>\r\n        {{AnswerImpArray[q.my_answer.importance]}}\r\n      </td>\r\n      <td>\r\n        <!-- <div toggle-switch class=\"switch-small\" on-label=\"Show\" off-label=\"Hide\" ng-model=\"switchStatus\"></div> -->\r\n        <toggle-switch ng-model=\"switchStatus[$index]\" class=\"switch-small\" on-label=\"Show\" off-label=\"Hide\" ng-change=\"switchFilters(switchStatus, $index, q)\"></toggle-switch>\r\n      </td>\r\n    </tr>\r\n  </table>\r\n</script>\r\n");
$templateCache.put("app/ballotMeasures/ballotMeasures.html","<div class=\"container-fluid\">\r\n\r\n  <!-- <h4>Get</h4> -->\r\n  <form ng-controller=\"ballotMeasuresCtrl\" class=\"closeForm\">\r\n    <div>\r\n      <div class=\"form-group row\" style=\"margin-top: 10px;\">\r\n        <p>\r\n          <h3>Ballot Measures</h3>\r\n        </p>\r\n      </div>\r\n      <h2>Select State</h2>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label\" for=\"email\">State </label>\r\n        <div class=\"controls\">\r\n          <select class=\"changeTextColor\" ng-model=\"address.state\" style=\"text-transform: capitalize;\" ng-change=\"addBallotMeasures()\" ng-options=\"item.state for item in allState track by item.state\"></select>&nbsp;\r\n          <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loader\"></i>\r\n        </div>\r\n      </div>\r\n      <div class=\"row table-responsive \" ng-if=\"ballotData.length> 0\" style=\"margin-top: 10px;\">\r\n        <table class=\"table w100 changeTextColor\">\r\n          <tr>\r\n            <th>MeasureId</th>\r\n            <th>title</th>\r\n            <th>Yes</th>\r\n            <th>No</th>\r\n            <th>Outcome</th>\r\n\r\n          </tr>\r\n          <tr ng-repeat=\"u in ballotData\">\r\n            <td>\r\n              {{u.measureId}}\r\n            </td>\r\n            <td>\r\n              {{u.title}}\r\n            </td>\r\n            <td>\r\n              {{u.yes}}\r\n            </td>\r\n\r\n            <td>\r\n              {{u.no}}\r\n            </td>\r\n            <td>{{u.outCome}}</td>\r\n\r\n          </tr>\r\n        </table>\r\n        <!-- <p ng-if=\"statusGetResPg == 1\" class=\"fwb\">Loading candidiates...</p> -->\r\n      </div>\r\n    </div>\r\n  </form>\r\n</div>\r\n");
$templateCache.put("app/ballotRating/ballotRating.html","<!-- <div id=\"background\"></div> -->\r\n<div class=\"container-fluid\">\r\n  <h2 class=\"pageHeading\">RATINGS Of Ballot Measures<br>\r\n    {{title}}\r\n  </h2>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-lg-12\">\r\n        <div id=\"topHeader\">\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <!-- Small Screen -->\r\n    <div class=\"row d-lg-none\">\r\n      <div class=\"col-12\">\r\n\r\n        <div>\r\n          <div id=\"descContainer\">\r\n          </div>\r\n          <div id=\"selectBoxContainer\">\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <div class=\"col-lg-12 col-centered\" id=\"compareContent\">\r\n        <div class=\"tableContainer\">\r\n          <div class=\"alert alert-success alert-dismissible\" id=\"alert\" ng-if=\"success_msg\" style=\"width:40%;margin-left:\r\n              28%\">\r\n            <button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button>\r\n            <strong>Review added Sucessfully</strong>\r\n          </div>\r\n          <center>\r\n            <h3 style=\"text-transform: capitalize; color:#fff;\">RATINGS</h3>\r\n          </center>\r\n          The ratings are listed in order of most active reviewer, but you can reorder using any of the headers.\r\n          <br>\r\n          <br>\r\n\r\n          <div class=\"table-responsive\">\r\n            <table class=\"table table-striped\" style=\"margin-bottom:0px;\">\r\n              <tr>\r\n                <th class=\"tableHead\">\r\n                  <span ng-click=\"sortSearch(\'name\')\" style=\"cursor:pointer; text-decoration:underline;\">Reviewer</span>&nbsp;<i ng-if=\"nameUp\" class=\"fa fa-arrow-circle-up\"></i><i ng-if=\"nameDown\" class=\"fa fa-arrow-circle-down\"></i>\r\n                </th>\r\n                <!-- <th class=\"tableHead\">Subject</th> -->\r\n                <th class=\"tableHead\">\r\n                  <span ng-click=\"sortSearch(\'rating\')\" style=\"cursor:pointer; text-decoration:underline;\">Rating</span>&nbsp;<i ng-if=\"ratingUp\" class=\"fa fa-arrow-circle-up\"></i><i ng-if=\"ratingDown\" class=\"fa fa-arrow-circle-down\"></i>\r\n                </th>\r\n\r\n                <!-- <th class=\"tableHead\">\r\n                  <span ng-click=\"sortSearch(\'date\')\" style=\"cursor:pointer; text-decoration:underline;\">Date</span>&nbsp;<i ng-if=\"dateUp\" class=\"fa fa-arrow-circle-up\"></i><i ng-if=\"dateDown\" class=\"fa fa-arrow-circle-down\"></i>\r\n                </th> -->\r\n\r\n                <th class=\"tableHead\">\r\n                  <span ng-click=\"sortDate()\" style=\"cursor:pointer; text-decoration:underline;\">Years</span>&nbsp;<i ng-if=\"ratingDateUp\" class=\"fa fa-arrow-circle-up\"></i><i ng-if=\"ratingDateDown\" class=\"fa fa-arrow-circle-down\"></i>\r\n                </th>\r\n                <th class=\"tableHead\" ng-if=\"allReviews.length > 0\">Details\r\n                </th>\r\n                <!-- <th class=\"tableHead\">Your Match</th> -->\r\n              </tr>\r\n              <tr ng-repeat=\"review in allReviews\">\r\n                <td class=\"tableRow\">\r\n                  <a ng-if=\"review.from[0].uType == \'advocate\'\" href=\"#!/pressProfile/{{review.from[0].uid}}/true\" class=\"link\">{{review.orgName}}</a>\r\n                  <a ng-if=\"review.from[0].uType == \'politician\'\" href=\"#!/publicProfile/{{review.from[0].uid}}/false\" class=\"link\">{{review.pName}}</a>\r\n                  <a ng-if=\"review.from[0].uType == \'admin\'\" href=\"#!/publicProfile/{{review.from[0].uid}}/false\" class=\"link\">{{review.from[0].name}}</a>\r\n\r\n\r\n                </td>\r\n\r\n                <td class=\"tableRow\">\r\n\r\n                  {{review.number}}%\r\n                </td>\r\n\r\n                <td class=\"tableRow\">\r\n                  <span ng-if=\"review.createdBy\">{{review.createdBy  | date : \"y\"}}</span>\r\n                </td>\r\n\r\n                <td class=\"tableRow\">\r\n                  <a ng-if=\"review.from && review.from.length > 0\" href=\"#!/ballotReviewDetails/{{review.to[0].bid}}/{{review.from[0].uid}}\" class=\"link\">View</a>\r\n                </td>\r\n              </tr>\r\n            </table>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/ballotReviewDetails/ballotReviewDetails.html","<!-- <div id=\"background\"></div> -->\r\n<div class=\"container-fluid\">\r\n  <h2 class=\"pageHeading\">\r\n    <a href=\"#!/pressProfile/{{reviewDetails.from[0].uid}}\" ng-if=\"reviewDetails.to[0].bid != reviewDetails.from[0].uid && reviewDetails.from[0].uType == \'advocate\'\" style=\"text-transform: capitalize;\">{{reviewDetails.orgName}}</a>\r\n    <a href=\"#!/pressProfile/{{reviewDetails.from[0].uid}}\" ng-if=\"reviewDetails.to[0].bid != reviewDetails.from[0].uid && reviewDetails.from[0].uType == \'politician\' || reviewDetails.from[0].uType == \'admin\' \">{{reviewDetails.pName}}</a>\r\n\r\n\r\n  </h2>\r\n  <p class=\"pageSubHeading\">Rating of\r\n    <span ng-if=\"reviewDetails.to[0].title\" style=\"text-transform: capitalize;\">{{reviewDetails.to[0].title}}</span>\r\n  </p>\r\n  <div class=\"row\" style=\"text-align:right;\">\r\n    <div class=\"col-lg-12\">\r\n      <div id=\"topHeader\">\r\n        <a href=\"#!/ballotRatings/{{reviewDetails.to[0].bid}}\"  class=\"ylink\">Back</a>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <!-- Small Screen -->\r\n  <div class=\"col-lg-12 col-centered\" id=\"compareContent\">\r\n    <div class=\"tableContainer\" ng-if=\"reviewDetails.length > 0\">\r\n      <center>\r\n        <h3 style=\"text-transform: capitalize; color:#fff;\" style=\"text-transform: capitalize;\">Rating {{reviewDetails.number}}%</h3>\r\n      </center>\r\n      {{reviewDetails.review}}\r\n      <br>\r\n      <br>\r\n\r\n      <br>\r\n\r\n\r\n      <div ng-repeat=\"link in arrLinks track by $index\">\r\n        <div ng-if=\"link !=\'\'\">\r\n          <h5>Relevant Link</h5>\r\n        </div>\r\n        <a href=\"{{link}}\" target=\"_blank\" class=\"ylink\">{{link}}</a>\r\n      </div>\r\n    </div>\r\n    <div class=\"tableContainer\">\r\n      <center>\r\n        <h3 style=\"text-transform: capitalize; color:#fff;\" ng-if=\"reviewDetails.number\" style=\"text-transform: capitalize;\">Rating\r\n          {{reviewDetails.number}}%</h3>\r\n      </center>\r\n\r\n      <div ng-if=\"reviewDetails.review\">{{reviewDetails.review}}</div>\r\n      <br>\r\n      <br>\r\n      <div ng-repeat=\"link in arrLinks track by $index\">\r\n        <div ng-if=\"link !=\'\'\">\r\n          <h5>Relevant Link</h5>\r\n        </div>\r\n        <a href=\"{{link}}\" target=\"_blank\" class=\"ylink\">{{link}}</a>\r\n      </div>\r\n    </div>\r\n    <br>\r\n    <!-- Bring this back -->\r\n    <!-- <div ng-hide=\"reviewDetails.referal[0].name==reviewDetails.from[0].name\">\r\n      <h5>NOTE: This entry was created by {{reviewDetails.votewise[0].from[0].name}} based on an outside article or\r\n        review by {{reviewDetails.votewise[0].referal[0].name}}</h5>\r\n    </div> -->\r\n  </div>\r\n</div>\r\n\r\n</div>\r\n");
$templateCache.put("app/ballotThread/ballotThread.html","<link rel=\"stylesheet\" type=\"text/css\" href=\"./forumList/forumList.css\">\r\n<div class=\"inline2\">\r\n  <div class=\"container-fluid\">\r\n\r\n    <h2 class=\"pageHeading\">BALLOT MEASURES THREAD </h2>\r\n\r\n    <br>\r\n\r\n    <p ng-if=\"statusGetForumList == 1\">Loading ...</p>\r\n    <table style=\"width:100%\" class=\"blackText\">\r\n      <tr>\r\n        <th>Threads</th>\r\n        <th> Replies</th>\r\n\r\n      </tr>\r\n\r\n      <tr ng-repeat=\"post in DisplayData\" ng-if=\"DisplayData.length > 0\" ng-style=\"checkSticky(post.postSticky)\">\r\n        <td>\r\n          <span ng-click=\"gotoThread(post._id);\" style=\"cursor:pointer;\"><div class=\"link\" >{{post.title}}</div></span><span>\r\n            Original Post by <img src=\"../assets/images/profile/{{post.createdBy.utype}}.svg\" class=\"usertype\"> <a href =\"#!/publicProfile/{{post.createdBy.id}}\"  class=\"link\" ng-if=\"post.createdBy.utype==\'voter\'\">{{post.createdBy.name}}</a>\r\n          <a href =\"#!/publicProfile/{{post.createdBy.id}}\"  class=\"link\" ng-if=\"post.createdBy.utype==\'advocate\'\" >Z{{post.createdBy.orgdata.title}}</a>\r\n          <b ng-if=\"post.createdBy.utype == \'politician\' && !post.createdBy.isEmailVerified || !post.createdBy.verifiedUser\">\r\n           <a href=\"#!/publicProfile/{{post.createdBy.id}}\"> {{post.createdBy.name}}</a> </b>\r\n          </span>\r\n          <br>\r\n          <div ng-if=\"post.lastTopic\">Latest post by\r\n            <img src=\"../assets/images/profile/{{post.lastTopic.createdBy.utype}}.svg\" class=\"usertype\"> <a href =\"#!/publicProfile/{{post.lastTopic.createdBy.id}}\" class=\"link\">\r\n            {{post.lastTopic.createdBy.name}}\r\n            </a><br>\r\n            {{post.lastTopic.createdOn | date:\'medium\'}}\r\n        </div>\r\n        </td>\r\n        <td>{{post.totalReply}} </td>\r\n      </tr>\r\n      <tr ng-if=\"DisplayData.length == 0\">\r\n        <td ng-if=\"userType!=\'admin\'\" colspan=\"3\">No records found.</td>\r\n        <td ng-if=\"userType==\'admin\'\" colspan=\"4\">No records found.</td>\r\n      </tr>\r\n    </table>\r\n    <br>\r\n    <center>\r\n      <input type=\"submit\" class=\"btn\" ng-click=\"createNew()\" value=\"Create New Thread\" /></center>\r\n  </div>\r\n");
$templateCache.put("app/boardsofelections/boardsofelections.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">BOARDS OF ELECTIONS</h2>\r\n  <p class=\"pageSubHeading\">Choose your state and click its link.</p>\r\n\r\n\r\n\r\n  <div class=\"row d-flex justify-content-center\">\r\n    <div class=\"col col-lg-6 col-med-12 col-sm-12 col-12 colPadding1\">\r\n      <div class=\"row\">\r\n        <div class=\"col-lg-12 col-sm-12 genericBlock\">\r\n           \r\n          \r\n            <div><br>\r\n              <h4 class=\"blockTitleLearn\">BOARDS OF ELECTIONS</h4>\r\n             \r\n            </div>\r\n   \r\n<div> Some sites are more reliable than others, so if your state\'s site is down, try <a target= \"_blank\" class=\"link\" href=\"http://lwv.org/\"><b>the League of Women Voters</b></a> to get additional information.</div><br><br>\r\n\r\n\r\n<div><a target=\"_blank\" class=\"link\"  href=\"https://myinfo.alabamavotes.gov/VoterView/RegistrantSearch.do\"><b>Alabama</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\" href=\"http://www.elections.alaska.gov/\"><b>Alaska</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\"  href=\"https://voter.azsos.gov/VoterView/RegistrantSearch.do\"><b>Arizona</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\" href=\"https://www.voterview.ar-nova.org/VoterView/RegistrantSearch.do\"><b>Arkansas</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\" href=\"http://voterguide.sos.ca.gov/\"><b>California</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\"  href=\"http://www.sos.state.co.us/pubs/elections/vote/VoterHome.html\"><b>Colorado</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\" href=\"http://www.ct.gov/sots/cwp/view.asp?a=3172&q=512796\"><b>Connecticut</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\" href=\"https://ivote.de.gov/default.aspx\"><b>Delaware</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\" href=\"https://www.dcboee.org/voter_info/reg_status/\"><b>District of COlumbia</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\"  href=\"http://registration.elections.myflorida.com/CheckVoterStatus\"><b>Florida</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\" href=\"https://www.mvp.sos.ga.gov/MVP/mvp.do\"><b>Georgia </b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\" href=\"http://elections.hawaii.gov/\"><b>Hawaii</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\"  href=\"http://www.idahovotes.gov/YPP_NEW/AmIRegistered.aspx\"><b>Idaho</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\"  href=\"https://ova.elections.il.gov/RegistrationLookup.aspx\"><b>Illinois</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\"  href=\"https://indianavoters.in.gov/PublicSite/Public/FT1/PublicLookupMain.aspx?AspxAutoDetectCookieSupport=1\"><b>Indiana</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\"  href=\"https://sos.iowa.gov/elections/voterreg/regtovote/search.aspx\"><b>Iowa</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\"  href=\"https://myvoteinfo.voteks.org/VoterView/RegistrantSearch.do\"><b>Kansas</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\" href=\"https://vrsws.sos.ky.gov/vic//\"><b>Kentucky</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\" href=\"https://voterportal.sos.la.gov/\"><b>Louisiana</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\"  href=\"https://www1.maine.gov/sos/cec/elec/\"><b>Maine</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\"  href=\"https://voterservices.elections.maryland.gov/votersearch\"><b>Maryland</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\"  href=\"https://www.sec.state.ma.us/VoterRegistrationSearch/MyVoterRegStatus.aspx\"><b>Massachusetts</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\" href=\"https://webapps.sos.state.mi.us/MVIC/\"><b>Michigan</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\" href=\"https://mnvotes.sos.state.mn.us/VoterStatus.aspx\"><b>Minnesota</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\"  href=\"http://www.sos.ms.gov/pollingplace/Pages/default.aspx\"><b>Mississippi</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\" href=\"https://s1.sos.mo.gov/elections/voterlookup/\"><b>Missouri</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\" href=\"https://app.mt.gov/cgi-bin/voterinfo/voterinfo.cgi\"><b>Montana</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\"  href=\"https://www.votercheck.necvr.ne.gov/VoterView/RegistrantSearch.do\"><b>Nebraska</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\" href=\"https://nvsos.gov/VoterSearch/index.aspx\"><b>Nevada</b></a></div> \r\n\r\n<div><a target=\"_blank\" class=\"link\"  href=\"https://voter.njsvrs.com/PublicAccess/servlet/com.saber.publicaccess.control.PublicAccessNavigationServlet?USERPROCESS=PublicSearch\"><b>New Jersey</b></a></div> \r\n\r\n<div><a target=\"_blank\" class=\"link\"  href=\"https://voterview.state.nm.us/VoterView/RegistrantSearch.do\"><b>New Mexico</b></a></div> \r\n\r\n<div><a target=\"_blank\" class=\"link\"  href=\"https://voterlookup.elections.state.ny.us/votersearch.aspx\"><b>New York</b></a></div> \r\n\r\n<div><a target=\"_blank\" class=\"link\" href=\"http://www.ncsbe.gov/\"><b>North Carolina</b></a></div> \r\n\r\n<div><a target=\"_blank\" class=\"link\" href=\"https://vip.sos.nd.gov/WhereToVote.aspx?tab=&ptlPKID=&ptlhPKID=\"><b>North Dakota</b></a></div> \r\n\r\n<div><a target=\"_blank\" class=\"link\" href=\"http://voterlookup.sos.state.oh.us/voterlookup.aspx\"><b>Ohio</b></a></div> \r\n\r\n <div><a target=\"_blank\" class=\"link\" href=\"https://services.okelections.us/voterSearch.aspx\"><b>Oklahoma</b></a></div>\r\n\r\n<div><a target= \"_blank\" class=\"link\" href=\"http://sos.oregon.gov/voting/Pages/voteinor.aspx\"><b>Oregon</b></a> </div>\r\n\r\n\r\n<div><a target=\"_blank\"class=\"link\"  href=\"https://www.pavoterservices.state.pa.us/Pages/voterregistrationstatus.aspx\"><b>Pennsylvania</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\" href=\"https://vote.sos.ri.gov/\"><b>Rhode Island</b></a></div>\r\n\r\n<div><a target=\"_blank\"class=\"link\"  href=\"https://info.scvotes.sc.gov/eng/voterinquiry/VoterInformationRequest.aspx\"><b>South Carolina</b></a>\r\n\r\n<div><a target=\"_blank\" class=\"link\" href=\"https://sos.sd.gov/Elections/VIPLogin.aspx\"><b>South Dakota</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\" href=\"https://tnmap.tn.gov/voterlookup/\"><b>Tennessee</b></a></div>\r\n \r\n<div><a target=\"_blank\" class=\"link\" href=\"https://teamrv-mvp.sos.texas.gov/MVP/mvp.do\"><b>Texas</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\" href=\"https://vote.utah.gov/vote/menu/index\"><b>Utah</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\" href=\"https://www.sec.state.vt.us/elections.aspx\"><b>Vermont</b></a></div>\r\n\r\n<div><a target=\"_blank\"class=\"link\"  href=\"https://vote.elections.virginia.gov/VoterInformation\"><b>Virginia</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\" href=\"https://www.sos.wa.gov/elections/\"><b>Washington</b></a></div>\r\n\r\n<div><a target=\"_blank\"class=\"link\"  href=\"https://services.sos.wv.gov/Elections/Voter/AmIRegisteredToVote\"><b>West Virginia</b></a></div>\r\n\r\n<div><a target=\"_blank\" class=\"link\" href=\"https://myvote.wi.gov/en-us/\"><b>Wisconsin</b></a></div>\r\n    \r\n<div><a target=\"_blank\"class=\"link\"  href=\"http://soswy.state.wy.us/Elections/PollPlace/Default.aspx\"><b>Wyoming</b></a></div><br><br><br>\r\n    </div>\r\n    </div>\r\n\r\n");
$templateCache.put("app/calendar/calendar-event.html","<center>\r\n    <h1><b>Calendar Events</b></h1></center>\r\n<!-- <center><iframe src=\"https://calendar.google.com/calendar/embed?mode=AGENDA&amp;height=600&amp;wkst=1&amp;bgcolor=%23FFFFFF&amp;src=ipohkpi2o7ovlrmbt68ui9l5e4%40group.calendar.google.com&amp;color=%238C500B&amp;ctz=America%2FNew_York\" style=\"border-width:0\" width=\"800\" height=\"600\" frameborder=\"0\"></iframe></center> -->\r\n<p><a ng-href=\"#!/calendar\">Back</a></p>\r\n<div style=\"padding: 20px;\">\r\n    <ul style=\"list-style: none;\">\r\n        <li ng-repeat=\"event in CalendarEventList\" ng-if=\"CalendarEventList.length>0\" style=\"padding: 10px;\">\r\n            <h3>{{event.summary}}</h3>\r\n            <p>\r\n            	<span>{{event.start.dateTime | date : \'EEE MMM dd yyyy   hh:mma\'}} </span> - <span>{{event.end.dateTime | date : \'EEE MMM dd yyyy   hh:mma\'}} </span>\r\n\r\n            </p>\r\n            <p>{{event.description}}</p>\r\n\r\n        </li>\r\n        <li ng-if=\"CalendarEventList.length==0\" style=\"padding: 10px;\">\r\n            No upcoming events found.\r\n        </li>\r\n    </ul>\r\n</div>\r\n");
$templateCache.put("app/calendar/calendar.html","<center>\r\n    <h1><b>Calendar</b></h1></center>\r\n<!-- <center><iframe src=\"https://calendar.google.com/calendar/embed?mode=AGENDA&amp;height=600&amp;wkst=1&amp;bgcolor=%23FFFFFF&amp;src=ipohkpi2o7ovlrmbt68ui9l5e4%40group.calendar.google.com&amp;color=%238C500B&amp;ctz=America%2FNew_York\" style=\"border-width:0\" width=\"800\" height=\"600\" frameborder=\"0\"></iframe></center> -->\r\n<div style=\"padding: 20px;\">\r\n    <ul style=\"list-style: none;\">\r\n        <!-- <li style=\"padding: 10px;\">\r\n            <a ng-href=\"\" ng-click=\"calendarEvent(\'primary\')\">\r\n                <div style=\"width:25px; height:25px; float:left; background-color: #FFF;\">&nbsp;</div>\r\n                <div style=\"margin-left: 30px; width:80%;\">Primary</div>\r\n            </a>\r\n        </li> -->\r\n        <li ng-repeat=\"cl in CalendarList\" style=\"padding: 10px;\">\r\n            <a ng-href=\"\" ng-click=\"calendarEvent(cl.id)\">\r\n                <div style=\"width:25px; height:25px; float:left; background-color: {{cl.backgroundColor}}\">&nbsp;</div>\r\n                <div style=\"margin-left: 30px; width:80%;\">{{cl.summary}}</div>\r\n            </a>\r\n        </li>\r\n    </ul>\r\n</div>\r\n");
$templateCache.put("app/checkRegistration/checkRegistration.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">CHECK REGISTRATION</h2>\r\n    <p class=\"pageSubHeading\">Use the form below to have Vote.org check to see if you are registered to vote.  Vote.org is not related to VoteWise.</p>\r\n<iframe src=\"https://verify.vote.org/?partner=111111&campaign=free-tools\" width=\"100%\" height=\"1200\"  marginheight=\"0\" frameborder=\"0\" id=\"frame3\" scrollable=\"no\"></iframe><script type=\"text/javascript\" src=\"//cdnjs.cloudflare.com/ajax/libs/iframe-resizer/3.5.3/iframeResizer.min.js\" ></script><script type=\"text/javascript\">iFrameResize({ log:true, checkOrigin:false});</script>\r\n      ");
$templateCache.put("app/commonPhrases/commonPhrases.html","<div style=\"text-align: center;\">\r\n	<label style=\"font-weight:bold;\">Search : </label>\r\n	<input type=\"text\" ng-model=\"search.text\" ng-change=\"searchTerm()\" class=\"form-control input-md text-input\">\r\n</div>\r\n<div id=\"content\">\r\n<p><h3>Here are some common words and phrases used by the media\r\nthat aren’t used in everyday conversation:</h3></p>\r\n\r\n<p>&nbsp;</p>\r\n\r\n<p>Accord – an accord is a diplomatic agreement that doesn’t\r\nhave the same binding force as a treaty.</p>\r\n\r\n<p>Adjournment – the temporary interruption of a legal or political\r\nproceedings. </p>\r\n\r\n<p>Autocracy – a form of government where unlimited power is in\r\nthe hands of just one person.</p>\r\n\r\n<p>Bellwether- a small entity that has the characteristics\r\nsimilar to a much larger system.  This is used to make an assumption that if,\r\nfor example, a bellwether town voted one way, the whole nation would likely\r\nvote the same way.</p>\r\n\r\n<p>The Beltway- a term used to describe the inner circle bubble\r\nof politicians, press, and others within Washington DC.  (it comes from the\r\nname of the highway that surrounds the town).</p>\r\n\r\n<p>Benign neglect – when there are calls to action to fix\r\nthings but the politicians do nothing, thinking that it will probably get\r\nbetter by itself if they stay out of it.</p>\r\n\r\n<p>Bill- a piece of legislation that has been proposed but has\r\nnot yet been voted into law.</p>\r\n\r\n<p>Bill of Rights – the first ten amendments to the\r\nConstitution.  These state some basic protections and rights.</p>\r\n\r\n<p>Bipartisan – this means it has support of both Democrats and\r\nRepublicans.</p>\r\n\r\n<p>Boondoggle – something that costs far more than it’s worth\r\nthat was paid for to gain political favor.  (for example building a bridge that\r\ngoes nowhere).</p>\r\n\r\n<p>Bourgeois – an insulting term meant to describe people in\r\nthe middle class living in relative luxury or are otherwise very materialistic.</p>\r\n\r\n<p>Brinkmanship – this is basically a very rough diplomatic\r\ntactic where you are threatening to go to war or economic collapse or some\r\nother horrible outcome if you don’t get your way. </p>\r\n\r\n<p>By-law – a rule that isn’t a law.  </p>\r\n\r\n<p>Bicameral/Unicameral – this refers to how many houses of\r\nCongress a nation has.  In America, we have two houses – the Senate and the\r\nHouse of Representative.  But in some other countries they only have one.</p>\r\n\r\n<p>Cabinet – This is the President’s inner circle.  As part of\r\nthe Executive branch of government, each member of the Cabinet has\r\nresponsibility for a different part of the job of President.  So the Secretary\r\nof Defense would keep a close eye on defense issues, keep the President\r\ninformed, and might make decisions too small to merit the President’s full\r\nattention.</p>\r\n\r\n<p>Caliphate – a government run by a Caliph-  an Islamic\r\nreligious and political leader.</p>\r\n\r\n<p>Camp David – the is the country house retreat for the\r\nPresident of the United States.</p>\r\n\r\n<p>Carpetbagger-an insulting term meaning an outsider moving in\r\nand taking advantage of a situation.</p>\r\n\r\n<p>Casus Beli – this isn’t used that often.  But it means the\r\nexcuse you’re using to go to war.</p>\r\n\r\n<p>Caucus- this is like a primary but instead of people\r\nfiltering into a voting booth throughout the day, they all get together in a\r\nroom and discuss things for a couple hours and then vote there. </p>\r\n\r\n<p>Cause Celebre – a controversy that has generated a lot of\r\ninterest.</p>\r\n\r\n<p>Clear and Present Danger – a situation where some think that\r\nbasic constitutional rights can be suspended in order to save lives for the greater\r\ngood.</p>\r\n\r\n<p>Client State – a country that is economically or militarily\r\nreliant upon another country but isn’t controlled by that other state.  (as\r\nopposed to a puppet state, where the more powerful state would insert its own\r\nleaders.)</p>\r\n\r\n<p>Closed Shop – a workplace where the union and the employers\r\nhave an agreement where only union employees can work there.</p>\r\n\r\n<p>Citizens initiated referendum – In some states, citizens can\r\ncreate proposals for laws and rather than have the politicians vote on these\r\nreferendum, the citizens vote on them on voting day.</p>\r\n\r\n<p>Coat tails effect– If a candidate is popular enough, he can\r\nwin votes not just for himself, but for other candidates as well.  So it’s\r\npossible for an otherwise unpopular candidate to win simply because he is\r\nassociated with a more popular one.</p>\r\n\r\n<p>Collateral Damage – a term used for unintentional killing or\r\nwounding innocent non-combatants when aiming for a military target.</p>\r\n\r\n<p>Command Economy – this is an economy which is mostly under\r\nthe command of the government as opposed to a free economy.  So a communist\r\ncountry for example would be a command economy.</p>\r\n\r\n<p>Common Law – these are laws enforced through tradition\r\nrather than legislation.  So they might have come down from English law before\r\nwe were a country for example.</p>\r\n\r\n<p>Comparative advantage – the ability for a country to produce\r\nsomething at a cheaper cost than another.  This “cost” could be a financial,\r\npolitical, environmental or any other cost, but it is mostly talked about in\r\nfinancial terms.</p>\r\n\r\n<p>Conservative – A person who believes that the current ways\r\nof doing things are the best and is resistant to change.  It currently has the\r\nconnotation or being right wing, supporting censorship, and taking away\r\npersonal liberties from people who they deem “immoral.”  See more in The Basics\r\nof Politics’</p>\r\n\r\n<p>Constituent – a citizen that the politician represents.</p>\r\n\r\n<p>Constitutional Referendum – When there is a proposal to\r\nchange the constitution, it must go to a vote amongst the people.  This is done\r\nmore often for state constitutions, but is extremely rare on a national level.</p>\r\n\r\n<p>Consumer Price Index – A measurement of inflation by gauging\r\nthe change in price of various commonly purchased goods.</p>\r\n\r\n<p>Consumption Tax – A tax that is taken out when you spend\r\nmoney rather than earning it.  This could be sales tax, VAT tax, fuel tax, or\r\nmany other things.</p>\r\n\r\n<p>Coup or Coup d’etat – A sudden (often violent) overthrow of\r\na government.</p>\r\n\r\n<p>Damage Control – an effort to fix, divert or otherwise\r\nreduce attention on a mistake made in the public media.  </p>\r\n\r\n<p>Dark Horse Candidate – An unexpected or perhaps even\r\npreviously unknown candidate who has a chance of winning versus a more\r\nestablished candidate.</p>\r\n\r\n<p>Deficit/ National Debt – When you spend more money that the\r\ntaxes you collect, you go into debt.  The amount of debt you go into in a year\r\nis called the Deficit, and the amount of debt that has accumulated over the\r\nyears is called the National Debt. </p>\r\n\r\n<p>Deficit Spending – when the government intentionally spends\r\nmore money than it has.</p>\r\n\r\n<p>Demagogue – a politician who gains popularity by stoking the\r\nflames of racism or appealing to other “base instincts.”  This is generally\r\nseen as a dangerous thing.</p>\r\n\r\n<p>Devolution –the transfer or delegation of power from higher\r\nlevels of power to lower levels.  (Country to state for example)</p>\r\n\r\n<p>Direct Democracy – this is where the citizens vote on every\r\nsingle piece of legislation as opposed to choosing a politician to represent\r\nthem.  Since being a politician is a full time job, this would mean that\r\neveryone would have two full time jobs – one to earn a living and the other to\r\nlegislate.  It’s not very common.</p>\r\n\r\n<p>Disinformation – intentionally spreading false or misleading\r\ninformation.</p>\r\n\r\n<p>Donkey Vote – the extra votes a candidate gets just because\r\nthey are the at the top of the ballot and the voter didn’t want to read, study,\r\nand weigh the rest of the options.  This is also known as the “unthinking\r\nvote.”</p>\r\n\r\n<p>Doublespeak – deliberately obscure language that hides the\r\ntrue meaning.  This is often used to cover a situation that is dire.  For\r\nexample, a corporation that is failing and decides it wants to fire half its\r\nemployees might say “we are trimming the fat so we can be more nimble.”</p>\r\n\r\n<p>Dynasty – a series of leaders related to each other.  Like a\r\nfather passing his reign to his son or nephew.</p>\r\n\r\n<p>Elector – a person chosen to vote for you.  For example, in\r\nthe US Presidency, you technically are voting for a guy to vote for you.  Check\r\nout the Electoral College in the Basics of Politics page.</p>\r\n\r\n<p>Electorate – A geographic voting area.</p>\r\n\r\n<p>Émigré – someone who leaves their country.</p>\r\n\r\n<p>Exchange Rate – the relationship of the value of one\r\ncountry’s money to another.   This is important if you want to travel to\r\nanother country or if you want to buy or sell good s to another country.</p>\r\n\r\n<p>Facism – an authoritarian and nationalistic system of\r\ngovernment and social organization.  It shuns individualism, pluralism,\r\nmulticulturalism and is associated with willingness to commit violence or wage\r\nwar for the interests of the state.</p>\r\n\r\n<p>Federalism – A system like the United States where the power\r\nis divided between the Federal Government and the States.</p>\r\n\r\n<p>Fence Mending – a politician going back to the people he\r\nrepresents to restore his reputation and try to make them happy after he made\r\nthem unhappy.</p>\r\n\r\n<p>Fifth Columnist – in a military or political situation, it\r\nis a person who secretly works to try to take down the group from within.</p>\r\n\r\n<p>Filibuster – an action such as a really long speech that\r\ndoesn’t break the rules, but is at the same time intended to disrupt the\r\nprogress of passing a bill.</p>\r\n\r\n<p>First-past-the post – election system where you don’t need\r\nthe majority of the votes, you just need to get more than anyone else.</p>\r\n\r\n<p>Friday News Dump – the practice of a government releasing a\r\nlot of bad news on a Friday, thinking no one is going to read the papers on\r\nSaturdays.</p>\r\n\r\n<p>Fourth Estate – It’s another term for the Press.  The\r\nconcept is that  democracy can’t exist without informed voters, so the Press is\r\nessentially a fourth branch of the government. (actually has its origins in\r\nFrench history but that’s the general concept.)</p>\r\n\r\n<p>Free rider- someone who benefits from legislation meant to\r\nhelp other people but doesn’t pay for them, potentially preventing the\r\nresources getting to those in need.  </p>\r\n\r\n<p>Champagne Socialist/ Limousine Liberal – an insulting term\r\nfor people who spout ideas of Socialism but live in the lap of luxury.</p>\r\n\r\n<p>General Election – An election that determines the final results\r\nafter primaries or other pre-general election elections.</p>\r\n\r\n<p>Gerrymander – this is the process where politicians redraw\r\ndistrict lines in bizarre ways to make it easier for them or their party to get\r\nelected again in the future.  So for example, if you wanted your party to win,\r\nyou would pack all the voters from the opposing party into one district and\r\nspread your party’s voters out in other districts so each of the other\r\ndistricts would have just enough of your voters to win.  The end result would\r\nbe even though your sate has more voters of the opposing party, your party wins\r\n6 out of 7 of the state’s congressional districts, and win the day.  Instead of\r\nsquare districts, or districts bound by natural boundaries, the districts end\r\nup looking like many tentacled space creatures – or perhaps a salamander.</p>\r\n\r\n<p>Glad- handler – an overly friendly person who is faking it\r\nto try to gain popularity.</p>\r\n\r\n<p>Glasnost – A Russian policy that commits the government to\r\ngreater accountability and visibility such as freedom of information laws.</p>\r\n\r\n<p>GNP/GDP – Gross National Product is the total output of\r\ngoods and services by Americans and American companies whether they were done\r\nhere or abroad.  Gross Domestic Product counts the goods or services on\r\nAmerican soil whether or not they were made by Americans or by people from\r\nother countries.</p>\r\n\r\n<p>Going Negative – a campaign tactic of attacking the\r\nopponent’s negative aspects rather than promoting their own policies or other\r\ngood qualities.</p>\r\n\r\n<p>Grandfather Clause – something which permits existing things\r\nto continue to exist without being altered by the new law.  For example, if you\r\nmake a law saying that any new railings had to be 3’6” but older ones could\r\ncontinue to exist.</p>\r\n\r\n<p>Grass roots – ordinary people.  It’s often used to refer to\r\ncampaigns that are backed by a lot of small donations or efforts from many\r\ncitizens as opposed to mainly being backed by large corporations or other\r\ngroups.</p>\r\n\r\n<p>Groupthink – this is a somewhat insulting term used to\r\ndescribe a group of people who are afraid or too lazy to think for themselves,\r\nso they go with the crowd.</p>\r\n\r\n<p>Gubernatorial  - things relating to the Governor.</p>\r\n\r\n<p>Habeas Corpus – a writ issued by a court asking another\r\ngovernment agency to show them the person they are detaining and giving them a\r\nreason why they should continue to be detained.</p>\r\n\r\n<p>Hack – an insulting term for a journalist or someone else\r\nwho isn’t very good at their job, but does it anyway.</p>\r\n\r\n<p>Hegemony – dominance of one group over another.</p>\r\n\r\n<p>Hoi Polloi – not used much anymore but you can see it old\r\nmovies.  It refers to the common folk as opposed to the wealthy, educated or\r\notherwise elite.</p>\r\n\r\n<p>Honeymoon Period – the first few months of a new government\r\nbefore things start getting nasty.</p>\r\n\r\n<p>Humanism – a philosophy which supports the idea of self-fulfilment\r\nwithout religion.</p>\r\n\r\n<p>Impeachment – a political equivalent to a criminal\r\nprosecution except instead of a judge and Jury, you have congress.   All level\r\nof government have their own rules for this, but if you’re talking about the\r\nPresident, The House of Representatives votes to make the charge and the Senate\r\nconducts the trial.  If you are convicted, you get kicked out of office and\r\ncan’t come back – and the laws of double jeopardy don’t come into play so you\r\ncan then be taken to a regular court where you can be tried and found guilty\r\nagain and punished by the laws of the land.</p>\r\n\r\n<p>Incumbent – the current politician in office who is running for office (as opposed to\r\nsomeone running against them in an election to unseat him)</p>\r\n\r\n<p>Identity Politics – A tendency for a particular religion,\r\nrace or other self-identified group to form political alliances based on that\r\nidentity rather than more traditional issues like crime, taxes, foreign policy,\r\netc..</p>\r\n\r\n<p>Invisible hand – a theory proposed by Adam Smith that\r\nwithout government interference, there will always be supply to meet demand.</p>\r\n\r\n<p>Isolationism – A policy of isolating your country from\r\nothers militarily and often also in trade.  This country would try to stand\r\nalone, be self-sufficient and not get involved with other things going on\r\naround the world.</p>\r\n\r\n<p>Jingoism – a term describing chauvinistic, boisterous\r\nnationalism in warlike pursuits.</p>\r\n\r\n<p>Jobs for the boys – political nepotism where you give jobs\r\nto those who don’t have the skills to do the job, but helped you out in the\r\npast.</p>\r\n\r\n<p>Judicial activism – A judicial philosophy where laws should\r\nbe re-interpreted to the benefit of making a positive change in the world as\r\nopposed to following the way the law has traditionally been interpreted.</p>\r\n\r\n<p>Junta- a small group that takes over a country.</p>\r\n\r\n<p>Kitchen Cabinet – an informal name for the cabinet members\r\nthat the President trusts most.</p>\r\n\r\n<p>Kleptocracy – insulting term used to describe a highly\r\ncorrupt government where bribes buy licenses or whatever else.</p>\r\n\r\n<p>Laissez-Faire – French for “Allow to do.“  This is a hands\r\noff approach to governance often referring to governmental  non-interference in\r\nthe economy.</p>\r\n\r\n<p>Left Wing/ Right Wing – The left wing, generally speaking,\r\nis in favor of government care for individuals, acceptance of cultural,\r\nreligious and other differences, and have an eye on internationalism.  The\r\nright wing, generally speaking, is in favor of conservative policies,\r\npro-business, strict law and order, a strong military and strong nationalism. \r\nThe terms come from the French Estates General a few hundred years ago when the\r\nnobles who favored the status quo would sit on the King’s right and those that\r\nfavored change and helping the peasants would sit on the King’s left.</p>\r\n\r\n<p>Liberal – a person who is open minded to other ways of doing\r\nthings and is not constrained by tradition.  The current connotation is being\r\nleft wing supporting social programs, levying taxes on the rich, and supporting\r\n“immorality”.  See more in The Basics of Politics </p>\r\n\r\n<p>Libertarianism - A political philosophy of self-reliance,\r\nreason and non-interference from the state in both economic and personal\r\naffairs. Having qualities of both the left and the right, a libertarian would\r\nbelieve in the right to bear arms, legal hallucinogenic drugs for any adult, a\r\nfree market capitalist economy and the abolition of censorship.</p>\r\n\r\n<p>Limited Government – the right wing concept that the\r\nGovernment should only provide public services if it is impossible for the free\r\nmarket to do it alone.  For example, they believe that if the government were\r\nto stop feeding the poor that Churches and other organizations would step in to\r\nfill the gap.</p>\r\n\r\n<p>Limited War – military combat that is often not declared as\r\na war that is done to complete a specific military objective rather than the\r\ncomplete surrender of the other country.</p>\r\n\r\n<p>Lower House/Upper House – The Lower House is the House of\r\nRepresentatives and the Upper House is the Senate.</p>\r\n\r\n<p>Log Rolling – A political practice where two politicians\r\nagree to support each other’s legislation.</p>\r\n\r\n<p>Luddites – those opposed to technological progress.</p>\r\n\r\n<p>Mandate – if someone wins something by a landslide, it is\r\npresumed that the issue that they ran on would be easy to pass into law.</p>\r\n\r\n<p>NGO – A Non-Governmental Organization is a type of\r\nnon-profit organization that is not closely tied to a government.  The\r\ndifference between NGO’s and other non-profits is not clearly defined and\r\nvaries from place to place, but generally speaking, the goal of an NGO is to\r\nprovide for the social welfare of others where the government can’t.  The term\r\nis often used for organizations doing work internationally rather than in\r\nAmerica.  NGO’s are much more effective at international work than American\r\nGovernment missions in situations where the American Government might be seen\r\nas the enemy.</p>\r\n\r\n<p>Nomination – when someone is suggested for office before\r\nthere has been a vote.</p>\r\n\r\n<p>Oligarchy – a form of government where power is held by very\r\nfew people and they use it for their own interest rather than the good of\r\nothers.</p>\r\n\r\n<p>Ombudsman – an ombudsman is a government position whose job\r\nit is to protect the people from the government and make sure the government\r\nsupplies the people what they need.  The ombudsman has no power other than the\r\npower to investigate wrong doings, and the power to suggest things.  Actual\r\nprosecution would go in someone else’s hands.  Not all areas have ombudsmen.</p>\r\n\r\n<p>Platform – When someone is running for office, they usually\r\nmake a list of things they stand for or want to accomplish.  These are the\r\nprinciples they stand on – their “platform.”</p>\r\n\r\n<p>Pork Barrel Legislation – This is spending or other\r\nlegislation that benefits one politician’s district as opposed to the whole\r\ncountry.  The concept is that a deal like this would be made in some darkened warehouse\r\nusing food crates as a table.  This usually happens when a group is having a\r\nhard time passing a piece of legislation but they can get it through if they\r\njust have a couple more votes.  So politicians who don’t feel strongly one way\r\nor another about that legislation line up to get something for the people who\r\nput them in office.</p>\r\n\r\n<p>Neocon/Neoconservative – A neocon is a person who used to be\r\nliberal but switched over to conservatism.  The neocon movement tends to lean\r\ntowards militarism.</p>\r\n\r\n<p>Pragmatism – looking at things in practical terms instead of\r\nalong ideological lines.  </p>\r\n\r\n<p>Progressive Tax – This is the current American System of\r\nincome tax where the more you earn, the higher percentage of your income you\r\npay in taxes.</p>\r\n\r\n<p>Flat Tax – This is a system where everyone pays the same\r\npercentage of their income.</p>\r\n\r\n<p>Regressive Tax- This is a tax that effectively costs more to\r\npoor people than rich people.  For example, a 35 cent tax per gallon tax on\r\ngasoline will impact a person earning $10/hr a lot more than it would a person\r\nwho drives the same amount who earns $80/hr.</p>\r\n\r\n<p>Pundit- an expert in a field who is called upon often to\r\ngive talks.  This term is most often used to refer to experts in the areas of\r\npolitics.</p>\r\n\r\n<p>Recession – This is the name for a country’s economic status\r\nif they have two quarters in a row where there was a drop in Gross National\r\nProduct or Gross Domestic Product.</p>\r\n\r\n<p>Depression – a long or severe recession.</p>\r\n\r\n<p>Referendum – A public vote on an issue or law.  Sometimes,\r\npoliticians feel an issue is too important, too politically charged or they are\r\njust forced by law to have the public vote on an issue rather than have the\r\npoliticians vote for it.</p>\r\n\r\n<p>Repatriation- sending a citizen back to the country they\r\ncame from.  This happens when </p>\r\n\r\n<p>Socialism – a form of government where the major businesses\r\nare owned and run by the government for the benefit of the people as opposed to\r\nprivately run businesses run for the benefit of the shareholders.</p>\r\n\r\n<p>Spin – to tell the news in a certain way so that it favors\r\none side or another.</p>\r\n\r\n<p>Sunset Clause – a part of a law that says it will expire at\r\na certain date.  Most laws don’t have this.</p>\r\n\r\n<p>Supply Side Economics – the theory that if you tax and\r\nregulate businesses less, it will be such a boon to the economy that the\r\ngovernment will make more in tax revenue even if the tax rate is lower.</p>\r\n\r\n<p>Swing State – a state where the parties have close to equal\r\nsupport among voters and the results of an election could swing one way or\r\nanother.</p>\r\n\r\n<p>Theocracy – government run by a religious organization.</p>\r\n\r\n<p>Totalitarian -  government system that not only wants to\r\ntake total control over what you do, but what you think as well.</p>\r\n\r\n<p>Vote of No Confidence – In Parliamentary governments, like\r\nthe United Kingdom of Great Britain, if the head of state is doing things that\r\nthey perceive as detrimental to the government, other politicians can vote them\r\nout and force a public election.  They can also make a vote of “censure” which\r\ndoesn’t cause an election, but just demonstrates that they are united in\r\nthinking that the head of state is screwing up and needs to change his ways.</p>\r\n\r\n<p>Wonk – someone who is intensely interested in the minute\r\ndetails of something.</p>\r\n</div>");
$templateCache.put("app/compare-politician-questions/compare-politician-questions.html","<center>\r\n  <h2>Match</h2>\r\n	  <div id=\"match5MinWarning\" ng-if=\"FBCompareList.length > 0\">\r\n    <div>\r\n      <h4 class=\"blockTitleLearn\">THIS LIST IS INCOMPLETE</h4>\r\n					<span class=\"blockDesc\">This only shows active candidates that have answered our quizzes. For the rest, you need to click <a href=\"#!/compare-select/politician\" class=\"link\"><b>HERE</b> </a>  where you can see their voting records, who financed their campaigns, and how the organizations you care about rated them.</span>\r\n    </div>\r\n  </div>\r\n  <center>\r\n    <!-- <h2>BACKGROUND</h2></center> -->\r\n    <div>\r\n      <center>\r\n        <a href=\"\" ng-click=\"showDetails()\"><button class=\"compareBtn\">Match Details</button></a>\r\n        <a href=\"#!/compare-select/politician\"><button class=\"compareBtn\">See All Candidates</button></a></center>\r\n      <br><br>\r\n      <!-- <div class=\"fb-share-button\" data-href=\"https://votewise.net:8443/#!/compare-politician-questions\"\r\n        data-layout=\"button_count\">\r\n      </div> -->\r\n    </div>\r\n    <div ng-if=\"status == 1\" style=\"z-index: 2; background:black;\">\r\n      <center>\r\n        <i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span>\r\n      </center>\r\n    </div>\r\n    <p></p>\r\n    <p ng-bind-html=\"category.description | newlines\"></p>\r\n    <div class=\"alert alert-danger alert-dismissible\" id=\"alert\" ng-if=\"showAlert\" style=\"width:60%;margin-left:\r\n            20%;margin-top:10%\">\r\n      <button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button>\r\n      <strong> You haven\'t answered these questions yet to make the match. </strong>\r\n    </div>\r\n    <div style=\"text-align:left;\">\r\n      <div>\r\n        <div class=\"squareBoxY\" style=\"margin-left:10px;\">&nbsp;</div>\r\n        <span>= Simple Comparison by answers alone.</span>\r\n        <div style=\"clear:both;\"></div>\r\n        <div class=\"squareBoxB\" style=\"margin-left:10px\">&nbsp;</div>\r\n        <span>= Weighted Comparison by answers and importance.</span>\r\n        <div style=\"clear:both;\"></div>\r\n      </div>\r\n      <!--\r\n    <div>\r\n        <div style=\"width:30%; float:left; text-align:right;\">Order By :&nbsp;&nbsp;</div>\r\n        <div style=\"width:65%; float:left; text-align:left;\">\r\n            <select ng-model=\"ord.Option\">\r\n                <option value=\"BW\">Best Weighted match</option>\r\n                <option value=\"W\">Worst weighted match</option>\r\n                <option value=\"BS\">Best simple match</option>\r\n                <option value=\"S\">worst simple match</option>\r\n            </select>\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n    </div>\r\n    -->\r\n      <ul class=\"catList\">\r\n        <li ng-repeat=\"frd in AllUsers track by $index\" ng-if=\"answeredQuestions[frd._id]\">\r\n          <div style=\"background-color:#ffffd5; padding:10px; color:#000;\">\r\n											<div><i ng-if=\"isShowAsterix[frd._id]\" class=\"fa fa-asterisk clk info-color\"  aria-hidden=\"true\"></i><span ng-if=\"isShowAsterix[frd._id]\">&nbsp;&nbsp;</span><a href=\"#!/publicProfile/{{frd._id}}\"><b style=\"text-transform: capitalize;\" class=\"link\">{{frd.name}}</b> </a>&nbsp;&nbsp;&nbsp;Total Answered Questions:\r\n              {{answeredQuestions[frd._id]}}\r\n              <div>\r\n                <b style=\"line-height:15px;text-transform: capitalize;\" ng-if=\"frd.politicianInfo[0].candidateStatus==\'Running\' || frd.politicianInfo[0].candidateStatus==\'active\' || frd.politicianInfo[0].candidateStatus==\'Announced\'\" >{{frd.politicianInfo[0].officeName}}</b>\r\n              </div>\r\n            </div>\r\n            <div style=\"width: 84%; float:left;\">\r\n              <div>\r\n                <div class=\"fbunweighted\"\r\n                  style=\"width:{{(FBunWeighted[frd._id] / answeredQuestions[frd._id] )  | number:2}}%\">\r\n                  {{(FBunWeighted[frd._id] / answeredQuestions[frd._id] ) | number:2}}% Match</div>\r\n              </div>\r\n              <div>\r\n                <div class=\"fbweighted\"\r\n                  style=\"width:{{(fbcombinedWeight[frd._id] / fbmultiplier[frd._id])  | number:2}}%\">\r\n                  {{(fbcombinedWeight[frd._id] / fbmultiplier[frd._id]) | number:2}}% Weighted Match</div>\r\n              </div>\r\n            </div>\r\n            <div style=\"clear:both;\"></div>\r\n          </div>\r\n        </li>\r\n      </ul>\r\n\r\n      <ul class=\"catList\" ng-if=\"showSpecial\">\r\n        <li ng-if=\"FBunWeighted[AllUsers._id] && fbcombinedWeight[AllUsers._id]\">\r\n          <div style=\"background-color:#ffffee; padding:10px;\">\r\n            <div style=\"color: #000000;\"><i ng-if=\"isShowAsterix[frd._id]\" class=\"fa fa-asterisk clk info-color\"  aria-hidden=\"true\"></i><span ng-if=\"isShowAsterix[frd._id]\">&nbsp;&nbsp;</span>\r\n              <a href=\"#!/publicProfile/{{AllUsers._id}}\" class=\"link\"><b>{{poliName}}</b></a>&nbsp;&nbsp;&nbsp;Total\r\n              Answered Questions: {{fbqlen[AllUsers._id]}}\r\n            </div>\r\n            <div style=\"width: 84%; float:left;\">\r\n              <div>\r\n                <div class=\"fbunweighted\"\r\n                  style=\"width:{{(FBunWeighted[AllUsers._id] / fbqlen[AllUsers._id] )  | number:2}}%\">\r\n                  {{(FBunWeighted[AllUsers._id] / fbqlen[AllUsers._id] ) | number:2}}% Match</div>\r\n              </div>\r\n              <div>\r\n                <div class=\"fbweighted\"\r\n                  style=\"width:{{(fbcombinedWeight[AllUsers._id] / fbmultiplier[AllUsers._id])  | number:2}}%\">\r\n                  {{(fbcombinedWeight[AllUsers._id] / fbmultiplier[AllUsers._id]) | number:2}}% Weighted Match</div>\r\n              </div>\r\n            </div>\r\n            <div style=\"clear:both;\"></div>\r\n          </div>\r\n        </li>\r\n      </ul>\r\n      <!-- <div><center><input type=\"button\" name=\"btnNext\" value=\"Next\" ng-click=\"nextCat()\"></center></div> -->\r\n<div><center>\r\n    <a href=\"\" ng-click=\"showDetails()\"><button class=\"compareBtnL\" style=\"background-color: aqua\"> See Question by Question Match Details</button></a></center>\r\n\r\n		<div style=\"margin-left:10px\">&nbsp;<i class=\"fa fa-asterisk info-color\"></i><span style=\"display:inline-flex; width:80%; margin-left: 25px;\">If a politician has a yellow asterisk by their name, some or all of their answers are based on research rather than actual responses from the politicians.</span></div>\r\n		<div style=\"margin-left:10px\">NOTE: <span style=\"display:inline-flex; width:80%;\">Some of the politician questions were taken from other sources where an answer of \"True\" or \"False\" was converted to \"Somewhat Agree\" or \"Somewhat Disagree\" (one point from either extreme) and we gave those answers an importance level of \"Somewhat important\". This may mean their answers do not fully express their passion or conviction.</span>\r\n</div>\r\n    <div class=\"squareBoxY\" style=\"margin-left:10px;\">&nbsp;</div>&nbsp;=\r\n    <span style=\"display:inline-flex; width:80%; margin-left: 10px;\">Simple Comparison by answers alone.</span>\r\n    <div style=\"clear:both;\"></div>\r\n    <div class=\"squareBoxB\" style=\"margin-left:10px\">&nbsp;</div>&nbsp;=\r\n    <span style=\"display:inline-flex; width:80%; margin-left: 10px;\">Weighted Comparison by answers and importance.</span>\r\n    <div style=\"clear:both;\"></div>\r\n				<button class=\"compareBtn\"><a href=\"#!/whatAmILookingAt3\">What this means</a></button>\r\n  </div>\r\n	\r\n   <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/incumbent_politician/politician\" class=\"blockLink\"><img ng-src=\"./assets/images/politiciansRBB7-01.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock4\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">YOUR POLITICIANS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Find out what they stand for, who stands behind them, and who pays for their campaigns.  See their voting record. See their ratings.  Compare politicians who are running for office, using your match quizzes to see who would best represent your interests.  Contact the politicians that represent you to ask for help.  Watch debates, read essays, and more.</p>\r\n\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n\r\n   <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\" ng-show=\"$root.userRole==\'voter\'\">\r\n      <a href=\"#!/gettingstarted\" class=\"blockLink\"><img ng-src=\"./assets/images/siteTour.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock5\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">TOUR THE SITE</h4>\r\n          <p class=\"gettingStartedBlockDesc\">The site has a lot of amazing things it can do.  Start here to learn more.</p>\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n   <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\" ng-show=\"$root.userRole==\'politician\'\">\r\n      <a href=\"#!/gettingStartedPol\" class=\"blockLink\"><img ng-src=\"./assets/images/siteTour.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock5\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">TOUR THE SITE</h4>\r\n          <p class=\"gettingStartedBlockDesc\">The site has a lot of amazing things it can do.  Start here to learn more.</p>\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n   <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\" ng-show=\"$root.userRole==\'advocate\'\">\r\n      <a href=\"#!/gettingStartedOrg\" class=\"blockLink\"><img ng-src=\"./assets/images/siteTour.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock5\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">TOUR THE SITE</h4>\r\n          <p class=\"gettingStartedBlockDesc\">The site has a lot of amazing things it can do.  Start here to learn more.</p>\r\n        </div>\r\n      </div></a>\r\n    </div>");
$templateCache.put("app/compareEssayAns/compareEssayAns.html","<div class=\"container\">\r\n  <div class=\"hideCell\">\r\n    <div class=\"row d-none d-lg-flex\" style=\"margin-top: 15%\">\r\n      <div class=\"col-lg-12\">\r\n        <div id=\"topHeaderCandidate\">\r\n          <div id=\"candidateDesc\">\r\n            <h2>Compare Essay Answers</h2>\r\n\r\n            <nav class=\"nav nav-pills flex-column flex-sm-row optionTabs\">\r\n              <a\r\n              class=\"dayButtons flex-sm-fill text-sm-center nav-link csm-width\"\r\n              ng-if=\"showShort\"\r\n              ng-click=\"getEssayAns(\'short\')\"\r\n              ng-class=\"{\'acivetab\': aType == \'short\'}\"\r\n              >Short Answer</a>\r\n              <a\r\n              class=\"dayButtons flex-sm-fill text-sm-center nav-link csm-width\"\r\n              ng-if=\"showMedium\"\r\n              ng-click=\"getEssayAns(\'medium\')\"\r\n              ng-class=\"{\'acivetab\': aType == \'medium\'}\"\r\n              >Medium Answer</a>\r\n              <a\r\n              class=\"dayButtons flex-sm-fill text-sm-center nav-link csm-width\"\r\n              ng-if=\"showLong\"\r\n              ng-click=\"getEssayAns(\'long\')\"\r\n              ng-class=\"{\'acivetab\': aType == \'long\'}\"\r\n              >Long Answer</a>\r\n            </nav>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <center>\r\n      <div ng-if=\"loader\" style=\"z-index: 2; background:black;\">\r\n        <i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span>\r\n      </div>\r\n    </center>\r\n\r\n    <!--\r\n  <div\r\n    class=\"col-lg-12\"\r\n    id=\"compareContent\"\r\n    ng-if=\"showCandidates.length > 0\"\r\n  >\r\n    <div class=\"table-responsive\">\r\n      <div\r\n        ng-repeat=\"(key, value) in showCandidates | orderBy: \'-office\' | groupBy: \'office\' \"\r\n        style=\"margin-top: 2%\"\r\n      >\r\n        <div class=\"offices-info\">\r\n          <div style=\"text-transform: capitalize\"><b><h2>{{key}}</h2></b></div>\r\n        </div>\r\n        <div>\r\n\r\n\r\n        <br>\r\n        <div ng-repeat=\"q in  fiveMinQuestion track by $index\">\r\n        <table\r\n              class=\"table table-striped blackText\"\r\n              style=\"margin-bottom: 0px; width: 80%; margin-left: 10%\"\r\n              ng-if=\"fiveMinQuestion.length > 0\"\r\n            >\r\n              <tr>\r\n                <th class=\"tableHead\">\r\n                  <span>Question</span>\r\n                </th>\r\n\r\n              </tr>\r\n\r\n              <tr>\r\n                <td>\r\n\r\n                    <b style=\"text-align:left\">{{q.content}}</b>\r\n\r\n                </td>\r\n                </tr>\r\n                </table>\r\n<br>\r\n          <div>\r\n            <table\r\n              class=\"table table-striped blackText\"\r\n              style=\"margin-bottom: 0px; width: 80%; margin-left: 10%\"\r\n              ng-if=\"showCandidates.length > 0\"\r\n            >\r\n              <tr>\r\n                <th class=\"tableHead\">\r\n                  <span>Name</span>\r\n                </th>\r\n                <th class=\"tableHead\" style=\"width: 40%;\">Answer</th>\r\n                <th class=\"tableHead\">\r\n                Ratings</th>\r\n                <th class=\"tableHead\">Endorsement</th>\r\n                 <th class=\"tableHead\">Debate</th>\r\n\r\n              </tr>\r\n\r\n\r\n              <tr ng-repeat=\"itm in showCandidates | orderBy:\'-isOnBallot\'  track by $index\">\r\n                <td>\r\n                  <a href=\"#!/publicProfile/{{itm._id}}\" class=\"link\">\r\n                    <b>{{itm.name}}</b>\r\n                  </a>\r\n                </td>\r\n                <td>\r\n                  <div ng-if=\"essayAns[itm._id].length == 0\">N/A</div>\r\n                  <div ng-if=\"type == \'short\'\">\r\n                    <div ng-repeat=\"item in essayAns[itm._id]\">\r\n\r\n                       <p ng-if=\"item.questionContent == q.content\" class=\"answer-container\" ng-bind-html=\'item.shortAns | urlify\'> <b>Answer:</b> {{item.shortAns}}</p>\r\n                       <p ng-if=\"item.questionContent != q.content\">N/A</p>\r\n                    </div>\r\n                  </div>\r\n                  <div ng-if=\"type == \'medium\'\">\r\n                    <div ng-repeat=\"item in essayAns[itm._id]\">\r\n\r\n                      <p ng-if=\"item.questionContent == q.content\" class=\"answer-container\" ng-bind-html=\'item.mediumAns | urlify\'><b>Answer:</b> {{item.mediumAns}}</p>\r\n                       <p ng-if=\"item.questionContent != q.content\">N/A</p>\r\n                    </div>\r\n                  </div>\r\n                  <div ng-if=\"type == \'long\'\">\r\n                    <div ng-repeat=\"item in essayAns[itm._id]\">\r\n\r\n                      <p ng-if=\"item.questionContent == q.content\" class=\"answer-container\" ng-bind-html=\'item.longAns | urlify\'> <b>Answer:</b> {{item.longAns}}</p>\r\n                       <p ng-if=\"item.questionContent != q.content\">N/A</p>\r\n                    </div>\r\n                  </div>\r\n                </td>\r\n                                 <td class=\"tableRow\">\r\n                    <a  href=\"#!/allRatings/{{itm._id}}\" ng-if=\"itm.total_reviews != 0\" class=\"link\">\r\n                  <b>{{itm.total_reviews}}</b>\r\n                </a>\r\n                    <b ng-if=\"itm.total_reviews == 0\">{{itm.total_reviews}}</b>\r\n                    <span ng-if=\"$root.userRole==\'politician\' ||$root.userRole==\'advocate\' || $root.userRole==\'admin\'\"> /\r\n                <a href=\"#!/addRating/{{itm._id}}\" class=\"link\">\r\n                  <b>Add</b>\r\n                </a></span>\r\n                </td>\r\n                <td>\r\n\r\n                <a href=\"#!/allEndorsements/{{itm._id}}\"  ng-if=\"itm.total_endorsements != 0\" class=\"link\">\r\n                        <b>{{itm.total_endorsements}}</b>\r\n                      </a>\r\n                    <b  ng-if=\"itm.total_endorsements == 0\">{{itm.total_endorsements}}</b>\r\n                    <span ng-if=\"$root.userRole==\'politician\' || $root.userRole==\'advocate\' || $root.userRole==\'admin\'\"> /\r\n                <a href=\"#!/addEndorsement/{{itm._id}}\" class=\"link\">\r\n                  <b>Add</b>\r\n                </a></span>\r\n                </td>\r\n                <td>\r\n                  <a href=\"javascript: void(0)\" ng-click=\"goToPoliticianThread(key, value, itm)\" style=\"text-decoration:underline;\" class=\"link\"\r\n                  ng-if=\"itm.total_tagged && itm.total_tagged != 0\">\r\n                  <b>View</b>\r\n                </a>\r\n\r\n                  <b  ng-if=\"!itm.total_tagged || itm.total_tagged == 0\">N/A</b>\r\n\r\n                </td>\r\n              </tr>\r\n            </table>\r\n											<br>\r\n											<center>\r\n            <button  ng-click=\"compareRatings(value)\" class=\"compareBtn wlink\">Compare Ratings</button>\r\n												</center>\r\n											<br><br><br>\r\n\r\n            <br>\r\n          </div>\r\n       </div>\r\n\r\n        </div>\r\n\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n</div>\r\n	-->\r\n  </div>\r\n\r\n  <!--<div class=\"hideNonCell\">-->\r\n  <div class=\"row d-lg-none\">\r\n    <div class=\"col-12\">\r\n      <div>\r\n        <div id=\"descContainer\">\r\n          <div class=\"candidateDescSmall\">\r\n            <h5 class=\"blockTitle\">Compare Essay Answers</h5>\r\n          </div>\r\n        </div>\r\n        <div id=\"selectBoxContainer\">\r\n          <select\r\n            class=\"custom-select selectBox\"\r\n            ng-model=\"aType\"\r\n            ng-change=\"getEssayAns(aType)\"\r\n          >\r\n            <option selected value=\"short\" ng-if=\"showShort\">\r\n              Short Answer\r\n            </option>\r\n            <option value=\"medium\" ng-if=\"showMedium\">Medium Answer</option>\r\n            <option selected value=\"long\" ng-if=\"showLong\">\r\n              Long Answer\r\n            </option>\r\n          </select>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <br>\r\n  <br>\r\n  <br>\r\n  <center>\r\n    <div class=\"hideNonCell\" ng-if=\"loader\" style=\"z-index: 2; background:black;\">\r\n      <i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span>\r\n    </div>\r\n  </center>\r\n  <br>\r\n  <div ng-repeat=\"(key, value) in showCandidates | orderBy: \'-office\' | groupBy: \'office\' \" style=\"margin-top: 2%\">\r\n    <div class=\"offices-info\">\r\n      <div style=\"text-transform: capitalize\"><b><h2>{{key}}</h2></b></div>\r\n    </div>\r\n    <div>\r\n\r\n      <div ng-repeat=\"q in  fiveMinQuestion | orderBy:\'matchOrder\' track by $index\">\r\n        <div id=\"blockInfoLearn3\">\r\n          <div class=\"blockTitleLearn\">\r\n            <h4>\r\n              <center>Question:</center>\r\n            </h4>\r\n            <span class=\"blockDesc\">\r\n\r\n															<p style=\"text-align:left\">{{q.content}}</p></span>\r\n          </div>\r\n        </div><br>\r\n\r\n\r\n        <div ng-repeat=\"itm in showCandidates | orderBy:\'-isOnBallot\'  track by $index\">\r\n          <div ng-if=\"isShowEssayAns(itm,q)\">\r\n            <!-- <div ng-if=\"essayAns[itm._id].length != 0\"> -->\r\n            <a href=\"#!/publicProfile/{{itm._id}}\" class=\"ylink\">\r\n                    <b><center>{{itm.name}}</center></b>\r\n                  </a>\r\n\r\n\r\n            <div ng-if=\"essayAns[itm._id].length == 0\">N/A</div>\r\n            <div ng-if=\"type == \'short\'\">\r\n              <div ng-repeat=\"item in essayAns[itm._id]\">\r\n                <!-- <b>Question:</b> {{item.questionContent}}\r\n                      <br /> -->\r\n                <p ng-if=\"item.questionContent == q.content\" class=\"answer-container\"\r\n                  ng-bind-html=\'item.shortAns | urlify\'> <b>Answer:</b> {{item.shortAns}}</p>\r\n                <p ng-if=\"item.questionContent != q.content\">N/A</p>\r\n              </div>\r\n            </div>\r\n            <div ng-if=\"type == \'medium\'\">\r\n              <div ng-repeat=\"item in essayAns[itm._id]\">\r\n                <!-- <b>Question:</b> {{item.questionContent}}\r\n                      <br /> -->\r\n                <p ng-if=\"item.questionContent == q.content\" class=\"answer-container\"\r\n                  ng-bind-html=\'item.mediumAns | urlify\'><b>Answer:</b> {{item.mediumAns}}</p>\r\n                <p ng-if=\"item.questionContent != q.content\">N/A</p>\r\n              </div>\r\n            </div>\r\n            <div ng-if=\"type == \'long\'\">\r\n              <div ng-repeat=\"item in essayAns[itm._id]\">\r\n                <!-- <b>Question:</b> {{item.questionContent}}\r\n                      <br /> -->\r\n                <p ng-if=\"item.questionContent == q.content\" class=\"answer-container\"\r\n                  ng-bind-html=\'item.longAns | urlify\'> <b>Answer:</b> {{item.longAns}}</p>\r\n                <p ng-if=\"item.questionContent != q.content\">N/A</p>\r\n              </div>\r\n            </div>\r\n\r\n            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Reviews&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;\r\n            <a  href=\"#!/allRatings/{{itm._id}}\" ng-if=\"itm.total_reviews != 0\" class=\"ylink\">\r\n                  <b>{{itm.total_reviews}}</b>\r\n                </a>\r\n            <b ng-if=\"itm.total_reviews == 0\">{{itm.total_reviews}}</b>\r\n            <span ng-if=\"$root.userRole==\'politician\' ||$root.userRole==\'advocate\' || $root.userRole==\'admin\'\"> /\r\n                <a href=\"#!/addRating/{{itm._id}}\" class=\"ylink\">\r\n                  <b>Add</b>\r\n                </a></span>\r\n\r\n            <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Endorsements&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;\r\n            <a href=\"#!/allEndorsements/{{itm._id}}\"  ng-if=\"itm.total_endorsements != 0\" class=\"ylink\">\r\n                        <b>{{itm.total_endorsements}}</b>\r\n                      </a>\r\n            <b  ng-if=\"itm.total_endorsements == 0\">{{itm.total_endorsements}}</b>\r\n            <span ng-if=\"$root.userRole==\'politician\' || $root.userRole==\'advocate\' || $root.userRole==\'admin\'\"> /\r\n                <a href=\"#!/addEndorsement/{{itm._id}}\" class=\"ylink\">\r\n                  <b>Add</b>\r\n                </a></span>\r\n            <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Debates&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;\r\n            <a href=\"javascript: void(0)\" ng-click=\"goToPoliticianThread(key, value, itm)\" style=\"text-decoration:underline;\" class=\"ylink\"\r\n                  ng-if=\"itm.total_tagged && itm.total_tagged != 0\">\r\n                  <b>View</b>\r\n                </a>\r\n\r\n            <b  ng-if=\"!itm.total_tagged || itm.total_tagged == 0\">N/A</b>\r\n\r\n\r\n            <br>\r\n            <hr>\r\n          </div>\r\n\r\n        </div>\r\n        <center>\r\n          <button  ng-click=\"compareRatings(value)\" class=\"compareBtn wlink\">Compare Reviews</button>\r\n        </center>\r\n        <br>\r\n          </div>\r\n\r\n      </div>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/compareGuestUsers/compareGuestUsers.html","<div class=\"container-fluid\" controller=\"compareGuestUsersCtrl\">\r\n  <div style=\"text-align:left;\">\r\n    <div ng-if=\"noDataFound == false\">\r\n      <div class=\"squareBoxY\" style=\"margin-left:10px;\">&nbsp;</div>\r\n      <span>= Simple Comparison by answers alone.</span>\r\n      <div style=\"clear:both;\"></div>\r\n      <div class=\"squareBoxB\" style=\"margin-left:10px\">&nbsp;</div>\r\n      <span>= Weighted Comparison by answers and importance.</span>\r\n      <div style=\"clear:both;\"></div>\r\n    </div>\r\n    <!--   <div ng-if=\"noDataFound == true\">\r\n      <div class=\"squareBoxY\" style=\"margin-left:10px;\">&nbsp;</div>\r\n      <span>= Simple Comparison by answers alone.</span>\r\n      <div style=\"clear:both;\"></div>\r\n      <div class=\"squareBoxB\" style=\"margin-left:10px\">&nbsp;</div>\r\n      <span>= Weighted Comparison by answers and importance.</span>\r\n      <div style=\"clear:both;\"></div>\r\n    </div> -->\r\n    <!--\r\n    <div>\r\n        <div style=\"width:30%; float:left; text-align:right;\">Order By :&nbsp;&nbsp;</div>\r\n        <div style=\"width:65%; float:left; text-align:left;\">\r\n            <select ng-model=\"ord.Option\">\r\n                <option value=\"BW\">Best Weighted match</option>\r\n                <option value=\"W\">Worst weighted match</option>\r\n                <option value=\"BS\">Best simple match</option>\r\n                <option value=\"S\">worst simple match</option>\r\n            </select>\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n    </div>\r\n    --><br>\r\n    <div>\r\n      <h4>\r\n          <p style=\"color:yellow\">If you register, we can also use your address to show you how you compare with your local politicians.</p></h4>\r\n         <center> <button ng-if=\"!userId\" class=\"btnB275\" style=\"width:200px;\" ng-click=\"finalSignIn()\">Register Now</button></center>\r\n        \r\n     \r\n    </div>\r\n    <br>\r\n    <!-- <ul class=\"catList\" ng-if=\"noDataFound == false\">\r\n      <li ng-repeat=\"frd in AllUsers track by $index\" ng-if=\"FBunWeighted[frd._id] && fbcombinedWeight[frd._id]\">\r\n        <div style=\"background-color:#ffffee; padding:10px;\">\r\n          <div style=\"color: #000000;\"><b>\r\n              <div ng-repeat=\"fd in frd.politicianInfo\" ng-if=\"fd.candidateStatus==\'Running\'\"><span>{{fd.officeName}}</span></div>\r\n            </b><b ng-if=\"frd.name\">{{frd.name}}</b> <b ng-if=\"!frd.name && frd.username\">{{frd.username}}</b>&nbsp;&nbsp;&nbsp;Total Answered questions: {{fbqlen[frd._id]}}\r\n          </div>\r\n          <div style=\"width: 84%; float:left;\">\r\n            <div>\r\n              <div class=\"fbunweighted\" style=\"width:{{(FBunWeighted[frd._id] / fbqlen[frd._id] )  | number:2}}%\">{{(FBunWeighted[frd._id] / fbqlen[frd._id] ) | number:2}}%</div>\r\n            </div>\r\n            <div>\r\n              <div class=\"fbweighted\" style=\"width:{{(fbcombinedWeight[frd._id] / fbmultiplier[frd._id])  | number:2}}%\">{{(fbcombinedWeight[frd._id] / fbmultiplier[frd._id]) | number:2}}%</div>\r\n            </div>\r\n          </div>\r\n          <div style=\"clear:both;\"></div>\r\n        </div>\r\n      </li>\r\n    </ul> -->\r\n    <ul class=\"catList\" ng-if=\"noDataFound == false\">\r\n      <li ng-if=\"FBunWeighted\">\r\n        <div style=\"background-color:#ffffee; padding:10px;\">\r\n          <div style=\"color: #000000;\"><b>\r\n\r\n           </b> <b ng-if=\"!userId\">Email Confirmed Users</b><b ng-if=\"userId\">Politicians</b>&nbsp;&nbsp;&nbsp;Total\r\n            Answered questions: {{fbqlen}}\r\n          </div>\r\n          <div style=\"width: 84%; float:left;\">\r\n            <div>\r\n              <div class=\"fbunweighted\" style=\"width:{{(FBunWeighted)  | number:2}}%\">{{(FBunWeighted) | number:2}}%</div>\r\n            </div>\r\n            <div>\r\n              <div class=\"fbweighted\" style=\"width:{{(fbcombinedWeight / fbmultiplier)  | number:2}}%\">{{(fbcombinedWeight\r\n                / fbmultiplier) | number:2}}%</div>\r\n            </div>\r\n          </div>\r\n          <div style=\"clear:both;\"></div>\r\n        </div>\r\n      </li>\r\n    </ul>\r\n    <ul class=\"catList\" ng-if=\"noDataFound == false\">\r\n      <li ng-if=\"unVerifiedFBunWeighted\">\r\n        <div style=\"background-color:#ffffee; padding:10px;\">\r\n          <div style=\"color: #000000;\"><b>\r\n\r\n           </b> <b>Unregistered Users</b>&nbsp;&nbsp;&nbsp;Total Answered questions: {{fbqlen}}\r\n          </div>\r\n          <div style=\"width: 84%; float:left;\">\r\n            <div>\r\n              <div class=\"fbunweighted\" style=\"width:{{(unVerifiedFBunWeighted  )  | number:2}}%\">{{(unVerifiedFBunWeighted\r\n               ) | number:2}}%</div>\r\n            </div>\r\n            <div>\r\n              <div class=\"fbweighted\" style=\"width:{{(unVerifiedWeighated / unFbmultiplier)  | number:2}}%\">{{(unVerifiedWeighated\r\n                / unFbmultiplier) | number:2}}%</div>\r\n            </div>\r\n          </div>\r\n          <div style=\"clear:both;\"></div>\r\n        </div>\r\n      </li>\r\n    </ul>\r\n    <!--   <ul class=\"catList\" ng-if=\"noDataFound == true\">\r\n      <li  ng-if=\"FBunWeighted[AllUsers._id] && fbcombinedWeight[AllUsers._id]\">\r\n        <div style=\"background-color:#ffffee; padding:10px;\" ng-if=\"AllUsers.name\">\r\n          <div style=\"color: #000000;\"><b>\r\n              <div ng-repeat=\"fd in frd.politicianInfo\" ng-if=\"fd.candidateStatus==\'Running\'\"><span>{{fd.officeName}}</span></div>\r\n            </b><b>{{AllUsers.name}}</b>&nbsp;&nbsp;&nbsp;Total Answered questions: {{fbqlen[AllUsers._id]}}\r\n          </div>\r\n          <div style=\"width: 84%; float:left;\">\r\n            <div ng-if=\"AllUsers.name\">\r\n              <div class=\"fbunweighted\" style=\"width:{{(FBunWeighted[AllUsers._id] / fbqlen[AllUsers._id] )  | number:2}}%\">{{(FBunWeighted[AllUsers._id] / fbqlen[AllUsers._id] ) | number:2}}%</div>\r\n            </div>\r\n            <div ng-if=\"AllUsers.name\">\r\n              <div class=\"fbweighted\" style=\"width:{{(fbcombinedWeight[AllUsers._id] / fbmultiplier[AllUsers._id])  | number:2}}%\">{{(fbcombinedWeight[AllUsers._id] / fbmultiplier[AllUsers._id]) | number:2}}%</div>\r\n            </div>\r\n          </div>\r\n          <div style=\"clear:both;\"></div>\r\n        </div>\r\n      </li>\r\n    </ul> -->\r\n    <!--\r\n  <center><button class=\"btnB275\" ng-click=\"postonFacebook()\">Post Quiz to Facebook</button></center>\r\n-->\r\n    <!-- <div><center><input type=\"button\" name=\"btnNext\" value=\"Next\" ng-click=\"nextCat()\"></center></div> -->\r\n  </div>\r\n    <button class=\"compareBtn\"><a href=\"#!/whatAmILookingAt2\">What Am I Looking At?</a></button>\r\n</div>\r\n");
$templateCache.put("app/compareGuestWith/compareGuestWith.html","<div class=\"container-fluid\" controller=\"compareGuestWithCtrl\">\r\n  <div style=\"text-align:left;\">\r\n    <div ng-if=\"noDataFound == false\">\r\n      <div class=\"squareBoxY\" style=\"margin-left:10px;\">&nbsp;</div>\r\n      <span>= Simple Comparison by answers alone.</span>\r\n      <div style=\"clear:both;\"></div>\r\n      <div class=\"squareBoxB\" style=\"margin-left:10px\">&nbsp;</div>\r\n      <span>= Weighted Comparison by answers and importance.</span>\r\n      <div style=\"clear:both;\"></div>\r\n    </div>\r\n  <!--   <div ng-if=\"noDataFound == true\">\r\n      <div class=\"squareBoxY\" style=\"margin-left:10px;\">&nbsp;</div>\r\n      <span>= Simple Comparison by answers alone.</span>\r\n      <div style=\"clear:both;\"></div>\r\n      <div class=\"squareBoxB\" style=\"margin-left:10px\">&nbsp;</div>\r\n      <span>= Weighted Comparison by answers and importance.</span>\r\n      <div style=\"clear:both;\"></div>\r\n    </div> -->\r\n    <!-- \r\n    <div>\r\n        <div style=\"width:30%; float:left; text-align:right;\">Order By :&nbsp;&nbsp;</div>\r\n        <div style=\"width:65%; float:left; text-align:left;\">\r\n            <select ng-model=\"ord.Option\">\r\n                <option value=\"BW\">Best Weighted match</option>\r\n                <option value=\"W\">Worst weighted match</option>\r\n                <option value=\"BS\">Best simple match</option>\r\n                <option value=\"S\">worst simple match</option>\r\n            </select>\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n    </div> \r\n    --><br>\r\n  \r\n      <br>\r\n    <ul class=\"catList\" ng-if=\"noDataFound == false\">\r\n      <li ng-repeat=\"frd in AllUsers track by $index\" ng-if=\"FBunWeighted[frd.guestId] && fbcombinedWeight[frd.guestId]\">\r\n        <div style=\"background-color:#ffffee; padding:10px;\" ng-if=\"frd.guestId\">\r\n          <div style=\"color: #000000;\"><b>\r\n              <div ng-repeat=\"fd in frd.politicianInfo\" ng-if=\"fd.candidateStatus==\'Running\'\"><span style=\"text-transform: capitalize;\">{{fd.officeName}}</span></div>\r\n            </b><b>Unorganized User {{$index+1}}</b>&nbsp;&nbsp;&nbsp;Total Answered questions: {{fbqlen[frd.guestId]}}\r\n          </div>\r\n          <div style=\"width: 84%; float:left;\">\r\n            <div ng-if=\"frd.guestId\">\r\n              <div class=\"fbunweighted\" style=\"width:{{(FBunWeighted[frd.guestId] / fbqlen[frd.guestId] )  | number:2}}%\">{{(FBunWeighted[frd.guestId] / fbqlen[frd.guestId] ) | number:2}}%</div>\r\n            </div>\r\n            <div ng-if=\"frd.guestId\">\r\n              <div class=\"fbweighted\" style=\"width:{{(fbcombinedWeight[frd.guestId] / fbmultiplier[frd.guestId])  | number:2}}%\">{{(fbcombinedWeight[frd.guestId] / fbmultiplier[frd.guestId]) | number:2}}%</div>\r\n            </div>\r\n          </div>\r\n          <div style=\"clear:both;\"></div>\r\n        </div>\r\n      </li>\r\n    </ul>\r\n\r\n\r\n\r\n  <!--   <ul class=\"catList\" ng-if=\"noDataFound == true\">\r\n      <li  ng-if=\"FBunWeighted[AllUsers._id] && fbcombinedWeight[AllUsers._id]\">\r\n        <div style=\"background-color:#ffffee; padding:10px;\" ng-if=\"AllUsers.name\">\r\n          <div style=\"color: #000000;\"><b>\r\n              <div ng-repeat=\"fd in frd.politicianInfo\" ng-if=\"fd.candidateStatus==\'Running\'\"><span>{{fd.officeName}}</span></div>\r\n            </b><b>{{AllUsers.name}}</b>&nbsp;&nbsp;&nbsp;Total Answered questions: {{fbqlen[AllUsers._id]}}\r\n          </div>\r\n          <div style=\"width: 84%; float:left;\">\r\n            <div ng-if=\"AllUsers.name\">\r\n              <div class=\"fbunweighted\" style=\"width:{{(FBunWeighted[AllUsers._id] / fbqlen[AllUsers._id] )  | number:2}}%\">{{(FBunWeighted[AllUsers._id] / fbqlen[AllUsers._id] ) | number:2}}%</div>\r\n            </div>\r\n            <div ng-if=\"AllUsers.name\">\r\n              <div class=\"fbweighted\" style=\"width:{{(fbcombinedWeight[AllUsers._id] / fbmultiplier[AllUsers._id])  | number:2}}%\">{{(fbcombinedWeight[AllUsers._id] / fbmultiplier[AllUsers._id]) | number:2}}%</div>\r\n            </div>\r\n          </div>\r\n          <div style=\"clear:both;\"></div>\r\n        </div>\r\n      </li>\r\n    </ul> -->\r\n\r\n    <!--\r\n  <center><button class=\"btnB275\" ng-click=\"postonFacebook()\">Post Quiz to Facebook</button></center>\r\n-->\r\n    <!-- <div><center><input type=\"button\" name=\"btnNext\" value=\"Next\" ng-click=\"nextCat()\"></center></div> -->\r\n    \r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/compareRatings/compareRatings.html","<!-- <div id=\"background\"></div> -->\r\n<div class=\"container-fluid\">\r\n  <h2 class=\"pageHeading\">POLITICIAN RATINGS</h2>\r\n  <p class=\"pageSubHeading\">See How Organizations Rated Your Elected Officials and Candidates on the different topics\r\n  </p>\r\n  <!--    ADD THIS FUNCTIONALITY LATER <div class=\"col-4\">The default is to show overall ratings, but you may choose to look for ratings on specific topics.\r\n  </div>-->\r\n  <br>\r\n  <div class=\"col-lg-12 col-centered\" id=\"compareContent\">\r\n    <div class=\"tableContainer\">\r\n      <center>\r\n        <h3 style=\"text-transform: capitalize; color:#fff;\">{{key}}</h3>\r\n      </center>\r\n      <div class=\"table-responsive\">\r\n        <table class=\"table table-striped\" style=\"margin-bottom:0px;\">\r\n          <tr>\r\n            <th class=\"tableHead\">See All Ratings</th>\r\n            <th class=\"tableHead\">Name</th>\r\n            <th class=\"tableHead\" style=\"width:20%;\">Reviewer 1\r\n              <br>\r\n              <div class=\"controls\" style=\"width:200px;\">\r\n                <select class=\"changeTextColor\" ng-model=\"review.data1\" style=\"text-transform: capitalize;\" ng-change=\"setReviewer1(review.data1)\">\r\n                  <!-- <option ng-repeat=\"item in reviewData | orderBy: \'-matchCount\' | unique:\'referal[0].name\'\" ng-if=\"item.referal[0].name && item.referal[0].name!=\'\'\"\r\n                    value=\"{{item}}\" ng-selected=\"review.data1\">{{item.referal[0].name}} {{item.matchCount}}%</option>\r\n                  <option ng-repeat=\"item in reviewData | orderBy: \'-matchCount\' | unique:\'from[0].name\'\" ng-if=\"!item.referal[0].name\" value=\"{{item}}\"\r\n                    ng-selected=\"review.data1\">{{item.from[0].name}} {{item.matchCount}}%</option> -->\r\n                  <option ng-repeat=\"item in orgData track by $index \" value=\"{{item}}\">{{item}}-</option>\r\n                </select>\r\n              </div>\r\n            </th>\r\n            <th class=\"tableHead\" style=\"width:20%;\">Reviewer 2\r\n              <br>\r\n              <div class=\"controls\" style=\"width:200px;\">\r\n                <select class=\"changeTextColor\" ng-model=\"review.data2\" style=\"text-transform: capitalize;\" ng-change=\"setReviewer2(review.data2)\">\r\n                  <!-- <option ng-repeat=\"item2 in reviewData | orderBy: \'-matchCount\' | unique:\'referal[0].name\'\" ng-if=\"item2.referal[0].name && item2.referal[0].name!=\'\'\"\r\n                    value=\"{{item2}}\" ng-selected=\"{{review.data2._id == item2._id}}\">{{item2.referal[0].name}} {{item2.matchCount}}%</option>\r\n                  <option ng-repeat=\"item2 in reviewData | orderBy: \'-matchCount\' | unique:\'from[0].name\'\" ng-if=\"!item2.referal[0].name\" value=\"{{item2}}\"\r\n                    ng-selected=\"{{review.data2._id == item2._id}}\">{{item2.from[0].name}} {{item2.matchCount}}%</option> -->\r\n                  <option ng-repeat=\"item2 in orgData track by $index\" value=\"{{item2}}\">{{item2}}</option>\r\n                </select>\r\n              </div>\r\n            </th>\r\n            <th class=\"tableHead\" style=\"width:20%;\">Reviewer 3\r\n              <br>\r\n              <div class=\"controls\" style=\"width:200px;\">\r\n                <select class=\"changeTextColor\" ng-model=\"review.data3\" style=\"text-transform: capitalize;\" ng-change=\"setReviewer3(review.data3)\">\r\n                  <!-- <option ng-repeat=\"item3 in reviewData | orderBy: \'-matchCount\' | unique:\'referal[0].name\'\" ng-if=\"item3.referal[0].name && item3.referal[0].name!=\'\'\"\r\n                    value=\"{{item3}}\" ng-selected=\"review.data3\">{{item3.referal[0].name}} {{item3.matchCount}}%</option>\r\n                  <option ng-repeat=\"item3 in reviewData | orderBy: \'-matchCount\' | unique:\'from[0].name\'\" ng-if=\"!item3.referal[0].name\" value=\"{{item3}}\"\r\n                    ng-selected=\"review.data3\">{{item3.from[0].name}} {{item3.matchCount}}%</option> -->\r\n                  <option ng-repeat=\"item3 in orgData track by $index\" value=\"{{item3}}\">{{item3}}</option>\r\n                </select>\r\n              </div>\r\n            </th>\r\n          </tr>\r\n          <tr ng-repeat=\"item in politicians track by $index\">\r\n            <td class=\"tableRow\">\r\n\r\n              <!-- {{item._id}} -->\r\n              <a href=\"#!/allRatings/{{item.politicianIds[0]}}/false/true\" class=\"link\">{{getRatingsTotal(item.politicianIds[0])}}</a>\r\n            </td>\r\n            <td class=\"tableRow\">\r\n              <a href=\"#!/publicProfile/{{item.politicianIds[0]}}/false\">\r\n                {{item.name}}</a>\r\n            </td>\r\n            <td class=\"tableRow\" style=\"width:20%;\">\r\n              <span ng-if=\"rating1[item.politicianIds[0]]==0\">{{rating1[item.politicianIds[0]]}}</span>\r\n              <a href=\"#!/ratingsDetails/{{item._id}}\" ng-if=\"rating1[item.politicianIds[0]]!=0\">\r\n                {{rating1[item.politicianIds[0]]}}\r\n              </a>\r\n            </td>\r\n            <td class=\"tableRow\" style=\"width:20%;\">\r\n              <span ng-if=\"rating2[item.politicianIds[0]]==0\">{{rating2[item.politicianIds[0]]}}</span>\r\n              <a href=\"#!/ratingsDetails/{{reviewId2[item.politicianIds[0]]}}\" ng-if=\"rating2[item.politicianIds[0]]!=0\">\r\n                {{rating2[item.politicianIds[0]]}}</a>\r\n            </td>\r\n            <td class=\"tableRow\" style=\"width:20%;\">\r\n              <span ng-if=\"rating3[item.politicianIds[0]]==0\">{{rating3[item.politicianIds[0]]}}</span>\r\n              <a href=\"#!/ratingsDetails/{{reviewId3[item.politicianIds[0]]}}\" ng-if=\"rating3[item.politicianIds[0]]!=0\">\r\n                {{rating3[item.politicianIds[0]]}}</a>\r\n            </td>\r\n          </tr>\r\n        </table>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"bottomInfo\">\r\n    <p>Candidate information is provided in part by The Center for Tech and Civil Life and by your local boards of\r\n      elections.\r\n      Please keep in mind that we get candidiate information before it is finalized and there is a possibility some of\r\n      our\r\n      information about who is running may be incomplete or incorrect. We currently don\'t cover all towns and cities,\r\n      but\r\n      your donations of money and information can help us reach that goal. For the most current information, please\r\n      contact\r\n      your local state or county board of elections. </p>\r\n  </div>\r\n</div>\r\n</div>\r\n</script>\r\n");
$templateCache.put("app/compareWithGroup/compareWithGroup.html","<div class=\"container-fluid\">\r\n  <center>\r\n    <h1>{{quizTitle}}</h1>\r\n  </center>\r\n  <div style=\"text-align:left;\">\r\n    <div ng-if=\"noDataFound == false\">\r\n      <div class=\"squareBoxY\" style=\"margin-left:10px;\">&nbsp;</div>\r\n      <span>= Simple Comparison by answers alone.</span>\r\n      <div style=\"clear:both;\"></div>\r\n      <div class=\"squareBoxB\" style=\"margin-left:10px\">&nbsp;</div>\r\n      <span>= Weighted Comparison by answers and importance.</span>\r\n      <div style=\"clear:both;\"></div>\r\n    </div>\r\n			    <div ng-if=\"loader\" style=\"z-index: 2; background:black;\">\r\n      <center>\r\n        <i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span>\r\n      </center>\r\n    </div>\r\n    <!--   <div ng-if=\"noDataFound == true\">\r\n      <div class=\"squareBoxY\" style=\"margin-left:10px;\">&nbsp;</div>\r\n      <span>= Simple Comparison by answers alone.</span>\r\n      <div style=\"clear:both;\"></div>\r\n      <div class=\"squareBoxB\" style=\"margin-left:10px\">&nbsp;</div>\r\n      <span>= Weighted Comparison by answers and importance.</span>\r\n      <div style=\"clear:both;\"></div>\r\n    </div> -->\r\n    <!--\r\n    <div>\r\n        <div style=\"width:30%; float:left; text-align:right;\">Order By :&nbsp;&nbsp;</div>\r\n        <div style=\"width:65%; float:left; text-align:left;\">\r\n            <select ng-model=\"ord.Option\">\r\n                <option value=\"BW\">Best Weighted match</option>\r\n                <option value=\"W\">Worst weighted match</option>\r\n                <option value=\"BS\">Best simple match</option>\r\n                <option value=\"S\">worst simple match</option>\r\n            </select>\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n    </div>\r\n    --><br>\r\n    <div>\r\n      <h4 ng-if=\"!userId\">\r\n        <p>If you register, we can also use your address to you how you compare with your local politicians.</p>\r\n        <center>\r\n          <button ng-if=\"!userId\" class=\"btnB275\" style=\"width:200px; float:left;\" ng-click=\"finalSignIn()\">Register Now</button>\r\n        </center>\r\n\r\n      </h4>\r\n    </div>\r\n    <br>\r\n\r\n    <ul class=\"catList\" ng-if=\"noDataFound == false\">\r\n      <li ng-if=\"politician\">\r\n        <div style=\"background-color:#ffffee; padding:10px;\">\r\n          <div style=\"color: #000000;\"><b>\r\n\r\n           </b>\r\n            <b ng-if=\"!userId\">Email Confirmed Users</b><a href=\"\" ng-click=\"redirectTo(\'politician\')\"><b ng-if=\"userId && !inviterName\" class=\"link\">Politicians in your area</b> <b ng-if=\"inviterName && allUser.length == 1\" style=\"text-transform: capitalize;\" class=\"link\">{{inviterName}}</b> <b ng-if=\"isShowFollow && allUser.length > 1\" class=\"link\">Your Followers (Politicians)</b> </a>&nbsp;&nbsp;&nbsp;Total\r\n            Answered questions: {{fbqlen}}\r\n          </div>\r\n          <div style=\"width: 84%; float:left;\">\r\n            <div>\r\n              <div class=\"fbunweighted\" style=\"width:{{(FBunWeighted  )  | number:2}}%\">{{(FBunWeighted ) | number:2}}% Match\r\n              </div>\r\n            </div>\r\n            <div>\r\n              <div class=\"fbweighted\" style=\"width:{{(fbcombinedWeight / fbmultiplier)  | number:2}}%\">{{(fbcombinedWeight\r\n                / fbmultiplier) | number:2}}% Weighted Match</div>\r\n            </div>\r\n          </div>\r\n          <div style=\"clear:both;\"></div>\r\n        </div>\r\n      </li>\r\n    </ul>\r\n    <ul class=\"catList\" ng-if=\"noDataFound == false\">\r\n      <li ng-if=\"showadv\">\r\n        <div style=\"background-color:#ffffee; padding:10px;\">\r\n          <div style=\"color: #000000;\"><b>\r\n\r\n           </b><a href=\"\" ng-click=\"redirectTo(\'advocate\')\"><b ng-if=\"userId && !inviterName && !isShowFollow\" class=\"link\">Organizations</b> <b ng-if=\"inviterName && allUser.length == 1\" style=\"text-transform: capitalize;\" >{{inviterName}}</b> <b ng-if=\"isShowFollow && allUser.length > 1\" class=\"link\">Your Followers (Organizations)</b> </a>&nbsp;&nbsp;&nbsp;Total\r\n            Answered questions: {{fbqlen}}\r\n          </div>\r\n          <div style=\"width: 84%; float:left;\">\r\n            <div>\r\n              <div class=\"fbunweighted\" style=\"width:{{(advUnWeighated)  | number:2}}%\">{{(advUnWeighated) | number:2}}% Match\r\n              </div>\r\n            </div>\r\n            <div>\r\n              <div class=\"fbweighted\" style=\"width:{{(advCombined / advMulti)  | number:2}}%\">{{(advCombined\r\n                / advMulti) | number:2}}% Weighted Match</div>\r\n            </div>\r\n          </div>\r\n          <div style=\"clear:both;\"></div>\r\n        </div>\r\n      </li>\r\n    </ul>\r\n\r\n    <ul class=\"catList\" ng-if=\"noDataFound == false\">\r\n      <li ng-if=\"showvoter\">\r\n        <div style=\"background-color:#ffffee; padding:10px;\">\r\n          <div style=\"color: #000000;\"><b>\r\n\r\n           </b><b ng-if=\"userId && !inviterName && !isShowFollow\">Email Confirmed Voter</b>\r\n            <b ng-if=\"inviterName && allUser.length == 1\" style=\"text-transform: capitalize;\">{{inviterName}}</b>\r\n            <b ng-if=\"isShowFollow && allUser.length > 1\" class=\"link\">Your Followers (Voters)</b>\r\n            &nbsp;&nbsp;&nbsp;Total\r\n            Answered questions: {{fbqlen}}\r\n          </div>\r\n          <div style=\"width: 84%; float:left;\">\r\n            <div>\r\n              <div class=\"fbunweighted\" style=\"width:{{(voterUnWeighated  )  | number:2}}%\">{{(voterUnWeighated\r\n                 ) | number:2}}% Match</div>\r\n            </div>\r\n            <div>\r\n              <div class=\"fbweighted\" style=\"width:{{(voterCombined / voterMulti)  | number:2}}%\">{{(voterCombined\r\n                / voterMulti) | number:2}}% Weighted Match</div>\r\n            </div>\r\n          </div>\r\n          <div style=\"clear:both;\"></div>\r\n        </div>\r\n      </li>\r\n    </ul>\r\n\r\n\r\n    <ul class=\"catList\" ng-if=\"noDataFound == false\">\r\n      <li ng-if=\"shownonUser\">\r\n        <div style=\"background-color:#ffffee; padding:10px;\">\r\n          <div style=\"color: #000000;\"><b>\r\n\r\n           </b> <b>Unregistered Users</b>&nbsp;&nbsp;&nbsp;Total Answered questions: {{fbqlen}}\r\n          </div>\r\n          <div style=\"width: 84%; float:left;\">\r\n            <div>\r\n              <div class=\"fbunweighted\" style=\"width:{{(unVerifiedFBunWeighted )  | number:2}}%\">{{(unVerifiedFBunWeighted\r\n               ) | number:2}}% Match</div>\r\n            </div>\r\n            <div>\r\n              <div class=\"fbweighted\" style=\"width:{{(unVerifiedWeighated / unFbmultiplier)  | number:2}}%\">{{(unVerifiedWeighated\r\n                / unFbmultiplier) | number:2}}% Weighted Match</div>\r\n            </div>\r\n          </div>\r\n          <div style=\"clear:both;\"></div>\r\n        </div>\r\n      </li>\r\n    </ul>\r\n    <!--   <ul class=\"catList\" ng-if=\"noDataFound == true\">\r\n      <li  ng-if=\"FBunWeighted[AllUsers._id] && fbcombinedWeight[AllUsers._id]\">\r\n        <div style=\"background-color:#ffffee; padding:10px;\" ng-if=\"AllUsers.name\">\r\n          <div style=\"color: #000000;\"><b>\r\n              <div ng-repeat=\"fd in frd.politicianInfo\" ng-if=\"fd.candidateStatus==\'Running\'\"><span>{{fd.officeName}}</span></div>\r\n            </b><b>{{AllUsers.name}}</b>&nbsp;&nbsp;&nbsp;Total Answered questions: {{fbqlen[AllUsers._id]}}\r\n          </div>\r\n          <div style=\"width: 84%; float:left;\">\r\n            <div ng-if=\"AllUsers.name\">\r\n              <div class=\"fbunweighted\" style=\"width:{{(FBunWeighted[AllUsers._id] / fbqlen[AllUsers._id] )  | number:2}}%\">{{(FBunWeighted[AllUsers._id] / fbqlen[AllUsers._id] ) | number:2}}%</div>\r\n            </div>\r\n            <div ng-if=\"AllUsers.name\">\r\n              <div class=\"fbweighted\" style=\"width:{{(fbcombinedWeight[AllUsers._id] / fbmultiplier[AllUsers._id])  | number:2}}%\">{{(fbcombinedWeight[AllUsers._id] / fbmultiplier[AllUsers._id]) | number:2}}%</div>\r\n            </div>\r\n          </div>\r\n          <div style=\"clear:both;\"></div>\r\n        </div>\r\n      </li>\r\n    </ul> -->\r\n    <!--\r\n  <center><button class=\"btnB275\" ng-click=\"postonFacebook()\">Post Quiz to Facebook</button></center>\r\n-->\r\n    <!-- <div><center><input type=\"button\" name=\"btnNext\" value=\"Next\" ng-click=\"nextCat()\"></center></div> -->\r\n  </div>\r\n	 <div ng-if=\"noDataFound == false\">\r\n      <div class=\"squareBoxY\" style=\"margin-left:10px;\">&nbsp;</div>\r\n      <span>= Simple Comparison by answers alone.</span>\r\n      <div style=\"clear:both;\"></div>\r\n      <div class=\"squareBoxB\" style=\"margin-left:10px\">&nbsp;</div>\r\n      <span>= Weighted Comparison by answers and importance.</span>\r\n      <div style=\"clear:both;\"></div>\r\n    </div>\r\n  <button class=\"compareBtn\"><a href=\"#!/whatAmILookingAt2\">What Am I Looking At?</a></button>\r\n</div>\r\n\r\n<script type=\"text/ng-template\" id=\"exporeQuizLink\">\r\n  <h5>Copy and paste the link below to wherever you want to invite others to take the quiz.  If people decide to take the quiz, you can each see how you compare and they will become your \"followers.\"</h5>\r\n <div>\r\n   <p>{{shareLink}}</p>\r\n </div>\r\n</script>\r\n\r\n<script type=\"text/ng-template\" id=\"ReviewMyAnswers\">\r\n  <h3>Review Answers and hide them from your friends.</h3>\r\n<p>Please review the questions and make sure you want to make your answers public.</p>\r\n  <center>\r\n  <div ng-if=\"showLoader\" style=\"z-index: 2; background:black;\"><i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span></div>\r\n\r\n</center>\r\n<table class=\"w100\">\r\n  <tr>\r\n    <th>Num.</th>\r\n    <th>Question</th>\r\n    <th>Answer</th>\r\n    <th>Importance</th>\r\n    <th>Show/Hide</th>\r\n  </tr>\r\n  <tr ng-repeat=\"q in allQuestions | orderBy:\'categories[0].viewOrder\' track by $index\" ng-init=\"q.my_answer.show!=\'N\'? switchStatus[$index]=true: switchStatus[$index]=false;\">\r\n    <td>\r\n      {{$index + 1}}\r\n    </td>\r\n    <td style=\"text-align:left;\">\r\n      {{q.content}}\r\n    </td>\r\n    <td>\r\n      {{AnswerArray[q.my_answer.answer]}}\r\n    </td>\r\n    <td>\r\n      {{AnswerImpArray[q.my_answer.importance]}}\r\n    </td>\r\n    <td>\r\n      <!-- <div toggle-switch class=\"switch-small\" on-label=\"Show\" off-label=\"Hide\" ng-model=\"switchStatus\"></div> -->\r\n      <toggle-switch ng-model=\"switchStatus[$index]\" class=\"switch-small\" on-label=\"Show\" off-label=\"Hide\" ng-change=\"switchFilters(switchStatus, $index, q)\"></toggle-switch>\r\n    </td>\r\n  </tr>\r\n</table>\r\n<br>\r\n<center>\r\n  <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"next()\">\r\n     Next\r\n     </button>\r\n  <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"cancel()\">\r\n     Cancel\r\n     </button>\r\n</center>\r\n</script>\r\n");
$templateCache.put("app/compare_select/compare_select.html","<!-- <div id=\"background\"></div> -->\r\n<div class=\"container-fluid\">\r\n  <h2 class=\"pageHeading\">YOUR CANDIDATES</h2>\r\n  <!--<p class=\"pageSubHeading noPaddBott\">Elected Officials and Candidates</p>-->\r\n  <div\r\n    ng-cloak\r\n    ng-show=\"$root.userRole==\'advocate\' || $root.userRole==\'politician\'\"\r\n  >\r\n    <p class=\"pageSubHeading\">\r\n      The politicians listed here are running to represent the address you\r\n      specified as your home office. Find the politician you want and click the\r\n      Add Rating, Endorsement, or Debate column to make your thoughts known. If\r\n      you want to leave reviews of your current representatives, click the\r\n      <a href=\"#!/incumbent_politician/politician\" class=\"ylink\"\r\n        >See Your Representatives</a\r\n      >\r\n      tab. If you want to rate or endorse politicians outside this area, hit the\r\n      <a href=\"#!/ratePolitician\" class=\"ylink\">Rate Unlisted Politicians </a\r\n      >button.\r\n    </p>\r\n  </div>\r\n  <div ng-if=\"$root.userRole == \'voter\' \">\r\n    <p class=\"pageSubHeading\">\r\n      The politicians listed here are running to represent you. Pick the date of\r\n      the election you want to know about, and learn about your candidates.\r\n    </p>\r\n  </div>\r\n  <div\r\n    ng-if=\"$root.userRole != \'voter\' && $root.userRole != \'politician\' && $root.userRole != \'advocate\'\"\r\n  >\r\n    <p class=\"pageSubHeading\">\r\n      The politicians listed here are running to represent you. Set your\r\n      location. Pick the date of the election you want to know about, and learn\r\n      about your candidates.\r\n    </p>\r\n  </div>\r\n  <div class=\"centerediframe\">\r\n    <iframe\r\n      src=\"https://player.vimeo.com/video/407429014?byline=false&title=false\"\r\n      allowfullscreen\r\n    ></iframe>\r\n  </div>\r\n  <!-- <button ng-click=\"showPopups()\" ng-if=\"pop\" type=\"button\" class=\"btn2Short-style widthAuto btn-success\">Set or Change Location</button> -->\r\n  <button\r\n    ng-click=\"showPopups()\"\r\n    type=\"button\"\r\n    class=\"btn2Short-style widthAuto btn-success\"\r\n  >\r\n    Set or Change Location\r\n  </button>\r\n  <div class=\"row d-none d-lg-flex\">\r\n    <div class=\"col-lg-4 offset-md-2 removePaddingRight\">\r\n      <a\r\n        href=\"#!/incumbent_politician/{{usertype}}\"\r\n        class=\"removeAnchorUnderline\"\r\n      >\r\n        <div id=\"seeElectedPoliticianCompare\">See Your Elected Politicians</div>\r\n      </a>\r\n    </div>\r\n    <div class=\"col-lg-4 removePaddingLeft\">\r\n      <div id=\"seeCandidiatesCompare\">These are Your Candidates</div>\r\n    </div>\r\n  </div>\r\n  <!-- Small Screen -->\r\n  <div class=\"row d-lg-none\">\r\n    <div class=\"col-6 removePaddingRight\">\r\n      <a\r\n        href=\"#!/incumbent_politician/{{usertype}}\"\r\n        class=\"removeAnchorUnderline\"\r\n      >\r\n        <div id=\"seeElectedPoliticianCompareSmall\">See Your Reps</div>\r\n      </a>\r\n    </div>\r\n    <div class=\"col-6 removePaddingLeft\">\r\n      <div id=\"seeCandidiatesCompareSmall\">Your Candidates</div>\r\n    </div>\r\n  </div>\r\n  <!-- <h2>test</h2> -->\r\n  <!-- <center>\r\n    <i ng-if=\"loaders\" class=\"fa fa-refresh fa-spin\" style=\"font-size:72px;\"></i>\r\n\r\n  </center> -->\r\n  <!-- Election Dates Drop down -->\r\n  <center>\r\n    <div ng-if=\"showLoader\" style=\"z-index: 2; background: black\">\r\n      <i\r\n        class=\"fa fa-refresh fa-spin\"\r\n        style=\"\r\n          font-size: 125px;\r\n          margin-top: 5%;\r\n          color: yellow;\r\n          font-weight: bold;\r\n        \"\r\n      ></i\r\n      ><br /><span\r\n        style=\"\r\n          font-size: 20px;\r\n          z-index: 3;\r\n          position: relative;\r\n          top: -60px;\r\n          color: yellow;\r\n          background-color: black;\r\n          padding: 1px;\r\n          font-weight: bold;\r\n        \"\r\n        >LOADING. PLEASE WAIT.</span\r\n      >\r\n    </div>\r\n  </center>\r\n  <div style=\"width: 200px; margin-left: 40%\" class=\"control-group\">\r\n    <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n      >Election Date</label\r\n    >\r\n    <select\r\n      class=\"form-control\"\r\n      ng-model=\"comp.election\"\r\n      style=\"text-transform: capitalize; display: block\"\r\n      ng-change=\"checkElectionDate()\"\r\n      ng-options=\"item.electionDate for item in eleDates\"\r\n    ></select>\r\n  </div>\r\n  <center>To see all 200 Presidential Candidates, choose 2020-11-03</center>\r\n  <div\r\n    ng-if=\"showParty\"\r\n    style=\"width: 200px; margin-left: 40%\"\r\n    class=\"control-group\"\r\n  >\r\n    <label class=\"control-label formLabel whiteText\" for=\"email\">Party</label>\r\n    <select\r\n      class=\"form-control\"\r\n      ng-model=\"comp.party\"\r\n      style=\"text-transform: capitalize; display: block\"\r\n      ng-change=\"checkElectionDate()\"\r\n      ng-options=\"item for item in party\"\r\n    >\r\n      <!-- <option value=\"\" selected>Select Party</option>\r\n      <option value=\"Democratic\">Democratic</option>\r\n      <option value=\"Republican\">Republican</option>\r\n      <option value=\"Libertarian\">Libertarian</option>\r\n      <option value=\"American Independent\">American Independent\r\n      </option> -->\r\n    </select>\r\n\r\n    <!-- <select class=\"form-control\" ng-model=\"comp.party\" style=\"text-transform: capitalize; display: block;\"  ng-change=\"getByType(\'local\', \'\')\"  ng-options=\"item for item in party\">\r\n    <option value=\"\" selected>Select Party</option>\r\n    <option value=\"Democratic\">Democratic</option>\r\n    <option value=\"Republican\">Republican</option>\r\n\r\n    </select> -->\r\n\r\n    <div ng-if=\"searchUsersByType.length == 0\">\r\n      VoteWise is a national organization, but we have a few holes in our local\r\n      elections coverage. If you have entered your address and you don\'t see\r\n      anything here, we have no information on your next election yet. Please\r\n      come back soon.\r\n      <!-- {{showWar}} -->\r\n    </div>\r\n  </div>\r\n  <br />\r\n  <br />\r\n  <div ng-if=\"bannerInfo.length > 0\" class=\"app-mk-center\">\r\n    <div\r\n      class=\"col-lg-12 col-sm-12 gettingStartedContainer\"\r\n      ng-repeat=\"banner in bannerInfo\"\r\n    >\r\n      <div ng-if=\"banner.isActive\">\r\n        <div\r\n          class=\"gettingStartedBlock gettingStartedBlock4\"\r\n          style=\"background-color: yellow\"\r\n        >\r\n          <div>\r\n            <h4 class=\"gettingStartedBlockTitle\">Note</h4>\r\n            <p\r\n              class=\"gettingStartedBlockDesc\"\r\n              ng-bind-html=\"banner.description | newlines\"\r\n            ></p>\r\n											            <center>\r\n              <b> <a href=\"{{banner.webLink}}\" target=\"_blank\">{{banner.webLink}}</a></b>\r\n            </center>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <br />\r\n  <br />\r\n  <br />\r\n  <div class=\"row d-none d-lg-flex\">\r\n    <div class=\"col-lg-12\">\r\n      <div id=\"topHeaderCandidate\">\r\n        <div id=\"candidateDesc\">\r\n          <h2>CANDIDATES</h2>\r\n          <p>Find out what they stand for.</p>\r\n\r\n          <nav class=\"nav nav-pills flex-column flex-sm-row optionTabs\">\r\n            <a\r\n              class=\"dayButtons flex-sm-fill text-sm-center nav-link\"\r\n              ng-if=\"showlocal\"\r\n              ng-click=\"getByType(\'local\',\'touch\')\"\r\n              ng-class=\"{\'acivetab\': sortype == \'local\'}\"\r\n              >Local</a\r\n            >\r\n            <a\r\n              class=\"dayButtons flex-sm-fill text-sm-center nav-link\"\r\n              ng-if=\"showcounty\"\r\n              ng-click=\"getByType(\'county\',\'touch\')\"\r\n              ng-class=\"{\'acivetab\': sortype == \'county\'}\"\r\n              >County</a\r\n            >\r\n            <a\r\n              class=\"dayButtons flex-sm-fill text-sm-center nav-link\"\r\n              ng-if=\"showstate\"\r\n              ng-click=\"getByType(\'state\',\'touch\')\"\r\n              ng-class=\"{\'acivetab\': sortype == \'state\'}\"\r\n              >State</a\r\n            >\r\n            <a\r\n              class=\"dayButtons flex-sm-fill text-sm-center nav-link\"\r\n              ng-if=\"showfederal\"\r\n              ng-click=\"getByType(\'federal\',\'touch\')\"\r\n              ng-class=\"{\'acivetab\': sortype == \'federal\'}\"\r\n              >Federal</a\r\n            >\r\n            <a\r\n              class=\"dayButtons flex-sm-fill text-sm-center nav-link\"\r\n              ng-if=\"showother\"\r\n              ng-click=\"getByType(\'other\',\'touch\')\"\r\n              ng-class=\"{\'acivetab\': sortype == \'other\'}\"\r\n              >Other</a\r\n            >\r\n          </nav>\r\n        </div>\r\n        <div id=\"candidiateIcon\">\r\n          <img\r\n            src=\"./assets/images/candidatesIcon4.svg\"\r\n            class=\"img-fluid\"\r\n            style=\"height: 250px\"\r\n          />\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <!-- Small Screen -->\r\n  <div class=\"row d-lg-none\">\r\n    <div class=\"col-12\">\r\n      <img\r\n        ng-src=\"./assets/images/candidatesIcon4.svg\"\r\n        class=\"candidiateIconSmall img-fluid\"\r\n      />\r\n      <div>\r\n        <div id=\"descContainer\">\r\n          <div class=\"candidateDescSmall\">\r\n            <h5 class=\"blockTitle\">CANDIDATES</h5>\r\n            <span class=\"blockDesc\">Find out what they stand for.</span>\r\n          </div>\r\n        </div>\r\n        <div id=\"selectBoxContainer\">\r\n          <select\r\n            class=\"custom-select selectBox\"\r\n            ng-model=\"sortype\"\r\n            ng-change=\"getByType(sortype)\"\r\n          >\r\n            <option selected value=\"local\" ng-if=\"showlocal\">Local</option>\r\n            <option value=\"county\" ng-if=\"showcounty\">County</option>\r\n            <option selected value=\"state\" ng-if=\"showstate\">State</option>\r\n            <option value=\"federal\" ng-if=\"showfederal\">Federal</option>\r\n            <option value=\"other\" ng-if=\"showother\">Other</option>\r\n          </select>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <!-- <div id=\"topHeaderCandidate\">\r\n        <div id=\"candidateDesc\">\r\n          <h2>CANDIDATES</h2>\r\n          <p>Find out what they stand for.</p>\r\n          <nav class=\"nav nav-pills flex-column flex-sm-row optionTabs\">\r\n            <a class=\"dayButtons flex-sm-fill text-sm-center nav-link\">Local</a>\r\n            <a class=\"dayButtons flex-sm-fill text-sm-center nav-link\">County</a>\r\n            <a class=\"dayButtons flex-sm-fill text-sm-center nav-link\">State</a>\r\n            <a class=\"dayButtons flex-sm-fill text-sm-center nav-link\">Federal</a>\r\n            <a class=\"dayButtons flex-sm-fill text-sm-center nav-link\">Other</a>\r\n          </nav>\r\n        </div>\r\n        <div id=\"candidiateIcon\"><img src=\"./assets/images/candidatesIcon4.svg\" class=\"img-fluid\" style=\"height:250px;\"></div>\r\n      </div> -->\r\n  </div>\r\n  <div>\r\n    <div class=\"col-lg-12 col-centered\" id=\"compareContent\">\r\n      <!--  <div class=\"tableContainer\" ng-repeat=\"(key, value) in searchUsersByType | orderBy: \'office\' | groupBy: \'office\'\" ng-if=\"user.flagSkipAnsweredQuestion != \'YES\' ? value.length > 1 : value.length > 0\"> -->\r\n\r\n      <div\r\n        class=\"tableContainer\"\r\n        ng-repeat=\"(key, value) in topCandidates | orderBy: \'office\' | groupBy: \'office\' \"\r\n        ng-if=\"value.length >0\"\r\n      >\r\n        <center>\r\n          <h3 style=\"text-transform: capitalize; color: #fff\">\r\n            Presidential Front Runners\r\n          </h3>\r\n        </center>\r\n        <div class=\"table-responsive\">\r\n          <table class=\"table table-striped\" style=\"margin-bottom: 0px\">\r\n            <tr>\r\n              <th class=\"tableHeadTop\">\r\n                <span class=\"d-none d-md-flex\">Compare</span>\r\n              </th>\r\n              <th class=\"tableHeadTop\">Name</th>\r\n              <!--              <th class=\"tableHead\">Contact Politician</th>    -->\r\n              <th class=\"tableHeadTop\">Status</th>\r\n              <th class=\"tableHeadTop\">Questions Answered</th>\r\n              <th class=\"tableHeadTop\">Ratings</th>\r\n              <th class=\"tableHeadTop\">Endorsements</th>\r\n              <th class=\"tableHeadTop\">Debate/ Discuss</th>\r\n              <th class=\"tableHeadTop\">Statement</th>\r\n              <th class=\"tableHeadTop\">Resume</th>\r\n              <th class=\"tableHeadTop\">Website</th>\r\n\r\n              <th class=\"tableHeadTop\">Party</th>\r\n              <!--     <th class=\"tableHead\">Incumbent</th> -->\r\n              <!--          <th class=\"tableHead\">More Info</th>  -->\r\n            </tr>\r\n            <tr\r\n              ng-repeat=\"user in value | orderBy : [\'-registeredUser\', \'-total_answers\'] track by $index\"\r\n            >\r\n              <td\r\n                class=\"tableRow\"\r\n                ng-init=\"user.registeredUser ? user.isSelected = true : user.isSelected = false\"\r\n              >\r\n                <!-- {{user.registeredUser}} -->\r\n                <div class=\"checkbox_wrapper\" ng-if=\"!selectForPrint\">\r\n                  <input\r\n                    type=\"checkbox\"\r\n                    name=\"Compare\"\r\n                    value=\"{{user._id}}\"\r\n                    ng-checked=\"true\"\r\n                    ng-click=\"toggleSelection(user)\"\r\n                    ng-if=\"!selectForPrint\"\r\n                  />\r\n                  <label></label>\r\n                </div>\r\n                <!-- <div class=\"checkbox_wrapper\" ng-show=\"selectForPrint\">\r\n                  <input type=\"checkbox\" name=\"print\" value=\"{{user._id}}\" ng-checked=\"selectedUserPrint.indexOf(user) > -1\" ng-click=\"togglePrintSelection(user)\"\r\n                    ng-show=\"selectForPrint\" />\r\n                  <label></label>\r\n                </div> -->\r\n                <!-- <span ng-if=\"!selectForPrint && !user.registeredUser\">N/A</span>\r\n -->\r\n                <!-- <input type=\"checkbox\" name=\"Compare\" value=\"{{user._id}}\" ng-model=\"user.isSelected\" ng-checked=\"selectedUser.indexOf(user) > -1\" ng-click=\"toggleSelection(user)\" ng-if=\"user.registeredUser && !selectForPrint\">compareContent\r\n                <input type=\"checkbox\" name=\"print\" value=\"{{user._id}}\" ng-checked=\"selectedUserPrint.indexOf(user) > -1\" ng-click=\"togglePrintSelection(user)\" ng-show=\"selectForPrint\"> -->\r\n                <!-- <span ng-if=\"!selectForPrint && !user.registeredUser\">N/A</span> -->\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a\r\n                  ng-if=\"user.registeredUser\"\r\n                  ng-href=\"#!/publicProfile/{{user.politicianIds[0]}}/true\"\r\n                >\r\n                  <span\r\n                    ng-if=\"user.nameOnBallot && user\"\r\n                    style=\"text-decoration: underline\"\r\n                    class=\"link\"\r\n                  >\r\n                    <b>{{user.nameOnBallot}}</b>\r\n                  </span>\r\n                  <span\r\n                    ng-if=\"!user.nameOnBallot\"\r\n                    style=\"text-decoration: underline\"\r\n                    class=\"link\"\r\n                  >\r\n                    <b>{{user.name}}</b>\r\n                  </span>\r\n                </a>\r\n                <a\r\n                  ng-if=\"!user.registeredUser\"\r\n                  ng-href=\"#!/publicProfile/{{user._id}}/true\"\r\n                >\r\n                  <span\r\n                    ng-if=\"user.nameOnBallot\"\r\n                    style=\"text-decoration: underline\"\r\n                    class=\"link\"\r\n                  >\r\n                    <b>{{user.nameOnBallot}}</b>\r\n                  </span>\r\n\r\n                  <span\r\n                    ng-if=\"!user.nameOnBallot  \"\r\n                    style=\"text-decoration: underline\"\r\n                    class=\"link\"\r\n                  >\r\n                    <b>{{user.name}}</b>\r\n                  </span>\r\n                </a>\r\n              </td>\r\n              <!--                <td class=\"tableRow\">\r\n                  <a ng-href=\"#!/publicProfile/{{user._id}}/false\">\r\n                  <button ng-if=\"user.registeredUser\" class=\"btnW\">\r\n                    Contact\r\n                  </button>\r\n                </a>\r\n                  <a ng-href=\"#!/publicProfile/{{user._id}}/true\">\r\n                  <button ng-if=\"!user.registeredUser\" class=\"btnW\">\r\n                    Contact\r\n                  </button>\r\n                </a>\r\n                </td>  -->\r\n              <td class=\"tableRow\">\r\n                <span>{{user.candidateStatus}}</span>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <span ng-if=\"user.total_answers == 0\"\r\n                  >{{user.total_answers}}</span\r\n                >\r\n                <a\r\n                  ng-if=\"user.total_answers > 0\"\r\n                  href=\"#!/question-answered-by/{{user._id}}/{{user.votesmartCandidateId}}/\'\'/{{user.name}}\"\r\n                  style=\"text-decoration: underline\"\r\n                  class=\"link\"\r\n                >\r\n                  <b>{{user.total_answers}}</b>\r\n                </a>\r\n                <span\r\n                  ng-if=\"user.total_answers == null || user.total_answers == undefined\"\r\n                  >-</span\r\n                >\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a\r\n                  href=\"#!/allRatings/{{user._id}}\"\r\n                  ng-if=\"user.total_reviews != 0\"\r\n                  class=\"link\"\r\n                >\r\n                  <b>{{user.total_reviews}}</b>\r\n                </a>\r\n                <b ng-if=\"user.total_reviews == 0\">{{user.total_reviews}}</b>\r\n                <span\r\n                  ng-if=\"$root.userRole==\'politician\' ||$root.userRole==\'advocate\' || $root.userRole==\'admin\'\"\r\n                >\r\n                  /\r\n                  <a href=\"#!/addRating/{{user._id}}\" class=\"link\">\r\n                    <b>Add</b>\r\n                  </a></span\r\n                >\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a\r\n                  href=\"#!/allEndorsements/{{user._id}}\"\r\n                  ng-if=\"user.total_endorsements != 0\"\r\n                  class=\"link\"\r\n                >\r\n                  <b>{{user.total_endorsements}}</b>\r\n                </a>\r\n                <b ng-if=\"user.total_endorsements == 0\"\r\n                  >{{user.total_endorsements}}</b\r\n                >\r\n                <span\r\n                  ng-if=\"$root.userRole==\'politician\' || $root.userRole==\'advocate\' || $root.userRole==\'admin\'\"\r\n                >\r\n                  /\r\n                  <a href=\"#!/addEndorsement/{{user._id}}\" class=\"link\">\r\n                    <b>Add</b>\r\n                  </a></span\r\n                >\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a\r\n                  href=\"javascript: void(0)\"\r\n                  ng-click=\"goToPoliticianThread(key, value, user)\"\r\n                  style=\"text-decoration: underline\"\r\n                  class=\"link\"\r\n                  ng-if=\"user.total_tagged && user.total_tagged > 0\"\r\n                >\r\n                  <b>View</b>\r\n                </a>\r\n                <a\r\n                  href=\"javascript: void(0)\"\r\n                  ng-click=\"goToPoliticianThread(key, value, user)\"\r\n                  style=\"text-decoration: underline\"\r\n                  class=\"flink\"\r\n                  ng-if=\"!user.total_tagged || user.total_tagged == 0\"\r\n                >\r\n                  <b>Create</b>\r\n                </a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a\r\n                  href=\"javascript: void(0)\"\r\n                  ng-if=\"user.statement\"\r\n                  ng-click=\"showHtmlViewer1(user.statement, \'Statement\')\"\r\n                  class=\"link\"\r\n                >\r\n                  <b>View</b>\r\n                </a>\r\n                <span ng-if=\"!user.resume\">-</span>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a\r\n                  href=\"javascript: void(0)\"\r\n                  ng-if=\"user.resume\"\r\n                  ng-click=\"showHtmlViewer1(user.resume, \'Resume\')\"\r\n                  style=\"text-decoration: underline\"\r\n                  class=\"link\"\r\n                >\r\n                  <b>View</b>\r\n                </a>\r\n                <span ng-if=\"!user.statement\">-</span>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <!-- {{user.webUrl}} -->\r\n                <span ng-if=\"user.webUrl && user.webUrl == \'null\'\">-</span>\r\n\r\n                <a\r\n                  ng-if=\"user.webUrl && user.webUrl != \'null\' && user.campaignInfo.length == 0\"\r\n                  ng-href=\"{{user.webUrl | addHttp}}\"\r\n                  target=\"_blank\"\r\n                  style=\"text-decoration: underline\"\r\n                  class=\"link\"\r\n                >\r\n                  <b>View</b>\r\n                </a>\r\n                <a\r\n                  ng-if=\"user.webUrl && user.webUrl != \'null\' && !user.campaignInfo\"\r\n                  ng-href=\"{{user.webUrl | addHttp}}\"\r\n                  target=\"_blank\"\r\n                  style=\"text-decoration: underline\"\r\n                  class=\"link\"\r\n                >\r\n                  <b>View</b>\r\n                </a>\r\n\r\n                <a\r\n                  ng-if=\"user.campaignInfo.length != 0 &&user.campaignInfo[0].campaignWeburl\"\r\n                  ng-href=\"{{user.campaignInfo[0].campaignWeburl | addHttp}}\"\r\n                  target=\"_blank\"\r\n                  style=\"text-decoration: underline\"\r\n                  class=\"link\"\r\n                >\r\n                  <b>View</b>\r\n                </a>\r\n                <a\r\n                  ng-if=\"user.website && user.website !=null\"\r\n                  ng-href=\"{{user.website | addHttp}}\"\r\n                  target=\"_blank\"\r\n                  style=\"text-decoration: underline\"\r\n                  class=\"link\"\r\n                >\r\n                  <b>View</b>\r\n                </a>\r\n                <span ng-if=\"!user.webUrl && !user.website\">-</span>\r\n              </td>\r\n\r\n              <td class=\"tableRow\">\r\n                <!-- <span>test</span>{{user.party}} -->\r\n                <span ng-if=\'user.party && user.party !=\"\"\'\r\n                  >{{user.party}}</span\r\n                >\r\n                <!-- <span ng-repeat=\"p in user.party track by $index\">{{p}} </span> -->\r\n                <!-- test{{user.politicianInfo[0].party}} -->\r\n                <span ng-if=\"!user.party && user.politicianInfo[0].party !=\'\'\"\r\n                  >{{user.politicianInfo[0].party}}</span\r\n                >\r\n              </td>\r\n              <!--         <td>\r\n                        <span ng-if=\"user.incumbent\">{{user.incumbent}}</span>\r\n                        <span ng-if=\"!user.incumbent\">No</span>\r\n                    </td>    -->\r\n              <!--      <td class=\"tableRow\" style=\"text-transform: capitalize;\">\r\n                <a ng-if=\"user.dataX\" ng-href=\"{{user.dataX}}\" target=\"_blank\" style=\"text-decoration:underline;\" class=\"link\">\r\n                  <b>Open</b>\r\n                </a>\r\n              </td>   -->\r\n            </tr>\r\n          </table>\r\n        </div>\r\n        <button\r\n          ng-hide=\"selectForPrint || users.length <= 0\"\r\n          ng-click=\"compareOfficeWiseSubject(value)\"\r\n          class=\"compareBtn\"\r\n        >\r\n          Compare Answers\r\n        </button>\r\n        <button\r\n          ng-hide=\"selectForPrint || users.length <= 0\"\r\n          ng-click=\"compareRatings(value)\"\r\n          class=\"compareBtn wlink\"\r\n        >\r\n          Compare Ratings\r\n        </button>\r\n      </div>\r\n      <br />\r\n      <div\r\n        ng-if=\"$root.userRole==\'politician\' ||$root.userRole==\'advocate\' || $root.userRole==\'admin\'\"\r\n      >\r\n        <a\r\n          ng-if=\"searchUsersByType.length > 0\"\r\n          href=\"#!/endorsePolitician\"\r\n          class=\"btn\"\r\n        >\r\n          Remove Your Endorsement </a\r\n        ><br /><br />\r\n      </div>\r\n      <div\r\n        ng-if=\"$root.userRole==\'politician\' ||$root.userRole==\'advocate\' || $root.userRole==\'admin\'\"\r\n      >\r\n        <a\r\n          ng-if=\"searchUsersByType.length > 0\"\r\n          href=\"#!/ratePolitician\"\r\n          class=\"btn\"\r\n        >\r\n          Rate Unlisted Politicians\r\n        </a>\r\n      </div>\r\n\r\n      <div\r\n        class=\"tableContainer\"\r\n        ng-repeat=\"(key, value) in searchUsersByType | orderBy: \'-office\' | groupBy: \'office\' \"\r\n        ng-if=\"value.length >0\"\r\n      >\r\n        <center>\r\n          <h3 style=\"text-transform: capitalize; color: #fff\">{{key}}</h3>\r\n        </center>\r\n        <div class=\"table-responsive\">\r\n          <table class=\"table table-striped\" style=\"margin-bottom: 0px\">\r\n            <tr>\r\n              <th class=\"tableHead\">\r\n                <span class=\"d-none d-md-flex\">Compare</span>\r\n              </th>\r\n              <th class=\"tableHead\">Name</th>\r\n              <!--              <th class=\"tableHead\">Contact Politician</th>    -->\r\n              <th class=\"tableHead\">Status</th>\r\n              <th class=\"tableHead\">Questions Answered</th>\r\n              <th class=\"tableHead\">Ratings</th>\r\n              <th class=\"tableHead\">Endorsements</th>\r\n              <th class=\"tableHead\">Debate/ Discuss</th>\r\n              <th class=\"tableHead\">Statement</th>\r\n              <th class=\"tableHead\">Resume</th>\r\n              <th class=\"tableHead\">Website</th>\r\n\r\n              <th class=\"tableHead\">Party</th>\r\n              <!--     <th class=\"tableHead\">Incumbent</th> -->\r\n              <!--          <th class=\"tableHead\">More Info</th>  -->\r\n            </tr>\r\n            <tr\r\n              ng-repeat=\"user in value | orderBy : [\'-registeredUser\', \'-total_answers\'] track by $index\"\r\n            >\r\n              <td\r\n                class=\"tableRow\"\r\n                ng-init=\"user.registeredUser ? user.isSelected = true : user.isSelected = false\"\r\n              >\r\n                <!-- {{user.registeredUser}} -->\r\n                <div class=\"checkbox_wrapper\" ng-if=\"!selectForPrint\">\r\n                  <input\r\n                    type=\"checkbox\"\r\n                    name=\"Compare\"\r\n                    value=\"{{user._id}}\"\r\n                    ng-checked=\"true\"\r\n                    ng-click=\"toggleSelection(user)\"\r\n                    ng-if=\"!selectForPrint\"\r\n                  />\r\n                  <label></label>\r\n                </div>\r\n                <!-- <div class=\"checkbox_wrapper\" ng-show=\"selectForPrint\">\r\n                  <input type=\"checkbox\" name=\"print\" value=\"{{user._id}}\" ng-checked=\"selectedUserPrint.indexOf(user) > -1\" ng-click=\"togglePrintSelection(user)\"\r\n                    ng-show=\"selectForPrint\" />\r\n                  <label></label>\r\n                </div> -->\r\n                <!-- <span ng-if=\"!selectForPrint && !user.registeredUser\">N/A</span>\r\n -->\r\n                <!-- <input type=\"checkbox\" name=\"Compare\" value=\"{{user._id}}\" ng-model=\"user.isSelected\" ng-checked=\"selectedUser.indexOf(user) > -1\" ng-click=\"toggleSelection(user)\" ng-if=\"user.registeredUser && !selectForPrint\">compareContent\r\n                <input type=\"checkbox\" name=\"print\" value=\"{{user._id}}\" ng-checked=\"selectedUserPrint.indexOf(user) > -1\" ng-click=\"togglePrintSelection(user)\" ng-show=\"selectForPrint\"> -->\r\n                <!-- <span ng-if=\"!selectForPrint && !user.registeredUser\">N/A</span> -->\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a\r\n                  ng-if=\"user.registeredUser\"\r\n                  ng-href=\"#!/publicProfile/{{user.politicianIds[0]}}/true\"\r\n                >\r\n                  <span\r\n                    ng-if=\"user.nameOnBallot && user\"\r\n                    style=\"text-decoration: underline\"\r\n                    class=\"link\"\r\n                  >\r\n                    <b>{{user.nameOnBallot}}</b>\r\n                  </span>\r\n                  <span\r\n                    ng-if=\"!user.nameOnBallot\"\r\n                    style=\"text-decoration: underline\"\r\n                    class=\"link\"\r\n                  >\r\n                    <b>{{user.name}}</b>\r\n                  </span>\r\n                </a>\r\n                <a\r\n                  ng-if=\"!user.registeredUser\"\r\n                  ng-href=\"#!/publicProfile/{{user._id}}/true\"\r\n                >\r\n                  <span\r\n                    ng-if=\"user.nameOnBallot\"\r\n                    style=\"text-decoration: underline\"\r\n                    class=\"link\"\r\n                  >\r\n                    <b>{{user.nameOnBallot}}</b>\r\n                  </span>\r\n\r\n                  <span\r\n                    ng-if=\"!user.nameOnBallot  \"\r\n                    style=\"text-decoration: underline\"\r\n                    class=\"link\"\r\n                  >\r\n                    <b>{{user.name}}</b>\r\n                  </span>\r\n                </a>\r\n              </td>\r\n              <!--                <td class=\"tableRow\">\r\n                  <a ng-href=\"#!/publicProfile/{{user._id}}/false\">\r\n                  <button ng-if=\"user.registeredUser\" class=\"btnW\">\r\n                    Contact\r\n                  </button>\r\n                </a>\r\n                  <a ng-href=\"#!/publicProfile/{{user._id}}/true\">\r\n                  <button ng-if=\"!user.registeredUser\" class=\"btnW\">\r\n                    Contact\r\n                  </button>\r\n                </a>\r\n                </td>  -->\r\n              <td class=\"tableRow\">\r\n                <span>{{user.candidateStatus}}</span>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <span ng-if=\"user.total_answers == 0\"\r\n                  >{{user.total_answers}}</span\r\n                >\r\n                <a\r\n                  ng-if=\"user.total_answers > 0\"\r\n                  href=\"#!/question-answered-by/{{user._id}}/{{user.votesmartCandidateId}}/\'\'/{{user.name}}\"\r\n                  style=\"text-decoration: underline\"\r\n                  class=\"link\"\r\n                >\r\n                  <b>{{user.total_answers}}</b>\r\n                </a>\r\n                <span\r\n                  ng-if=\"user.total_answers == null || user.total_answers == undefined\"\r\n                  >-</span\r\n                >\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a\r\n                  href=\"#!/allRatings/{{user._id}}\"\r\n                  ng-if=\"user.total_reviews != 0\"\r\n                  class=\"link\"\r\n                >\r\n                  <b>{{user.total_reviews}}</b>\r\n                </a>\r\n                <b ng-if=\"user.total_reviews == 0\">{{user.total_reviews}}</b>\r\n                <span\r\n                  ng-if=\"$root.userRole==\'politician\' ||$root.userRole==\'advocate\' || $root.userRole==\'admin\'\"\r\n                >\r\n                  /\r\n                  <a href=\"#!/addRating/{{user._id}}\" class=\"link\">\r\n                    <b>Add</b>\r\n                  </a></span\r\n                >\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a\r\n                  href=\"#!/allEndorsements/{{user._id}}\"\r\n                  ng-if=\"user.total_endorsements != 0\"\r\n                  class=\"link\"\r\n                >\r\n                  <b>{{user.total_endorsements}}</b>\r\n                </a>\r\n                <b ng-if=\"user.total_endorsements == 0\"\r\n                  >{{user.total_endorsements}}</b\r\n                >\r\n                <span\r\n                  ng-if=\"$root.userRole==\'politician\' || $root.userRole==\'advocate\' || $root.userRole==\'admin\'\"\r\n                >\r\n                  /\r\n                  <a href=\"#!/addEndorsement/{{user._id}}\" class=\"link\">\r\n                    <b>Add</b>\r\n                  </a></span\r\n                >\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a\r\n                  href=\"javascript: void(0)\"\r\n                  ng-click=\"goToPoliticianThread(key, value, user)\"\r\n                  style=\"text-decoration: underline\"\r\n                  class=\"link\"\r\n                  ng-if=\"user.total_tagged && user.total_tagged > 0\"\r\n                >\r\n                  <b>View</b>\r\n                </a>\r\n                <a\r\n                  href=\"javascript: void(0)\"\r\n                  ng-click=\"goToPoliticianThread(key, value, user)\"\r\n                  style=\"text-decoration: underline\"\r\n                  class=\"flink\"\r\n                  ng-if=\"!user.total_tagged || user.total_tagged == 0\"\r\n                >\r\n                  <b>Create</b>\r\n                </a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a\r\n                  href=\"javascript: void(0)\"\r\n                  ng-if=\"user.statement\"\r\n                  ng-click=\"showHtmlViewer1(user.statement, \'Statement\')\"\r\n                  class=\"link\"\r\n                >\r\n                  <b>View</b>\r\n                </a>\r\n                <span ng-if=\"!user.resume\">-</span>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a\r\n                  href=\"javascript: void(0)\"\r\n                  ng-if=\"user.resume\"\r\n                  ng-click=\"showHtmlViewer1(user.resume, \'Resume\')\"\r\n                  style=\"text-decoration: underline\"\r\n                  class=\"link\"\r\n                >\r\n                  <b>View</b>\r\n                </a>\r\n                <span ng-if=\"!user.statement\">-</span>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <!-- {{user.webUrl}} -->\r\n                <span ng-if=\"user.webUrl && user.webUrl == \'null\'\">-</span>\r\n\r\n                <a\r\n                  ng-if=\"user.webUrl && user.webUrl != \'null\' && user.campaignInfo.length == 0\"\r\n                  ng-href=\"{{user.webUrl | addHttp}}\"\r\n                  target=\"_blank\"\r\n                  style=\"text-decoration: underline\"\r\n                  class=\"link\"\r\n                >\r\n                  <b>View</b>\r\n                </a>\r\n                <a\r\n                  ng-if=\"user.webUrl && user.webUrl != \'null\' && !user.campaignInfo\"\r\n                  ng-href=\"{{user.webUrl | addHttp}}\"\r\n                  target=\"_blank\"\r\n                  style=\"text-decoration: underline\"\r\n                  class=\"link\"\r\n                >\r\n                  <b>View</b>\r\n                </a>\r\n\r\n                <a\r\n                  ng-if=\"user.campaignInfo.length != 0 &&user.campaignInfo[0].campaignWeburl\"\r\n                  ng-href=\"{{user.campaignInfo[0].campaignWeburl | addHttp}}\"\r\n                  target=\"_blank\"\r\n                  style=\"text-decoration: underline\"\r\n                  class=\"link\"\r\n                >\r\n                  <b>View</b>\r\n                </a>\r\n                <a\r\n                  ng-if=\"user.website && user.website !=null\"\r\n                  ng-href=\"{{user.website | addHttp}}\"\r\n                  target=\"_blank\"\r\n                  style=\"text-decoration: underline\"\r\n                  class=\"link\"\r\n                >\r\n                  <b>View</b>\r\n                </a>\r\n                <span ng-if=\"!user.webUrl && !user.website\">-</span>\r\n              </td>\r\n\r\n              <td class=\"tableRow\">\r\n                <!-- <span>test</span>{{user.party}} -->\r\n                <span ng-if=\'user.party && user.party !=\"\"\'\r\n                  >{{user.party}}</span\r\n                >\r\n                <!-- <span ng-repeat=\"p in user.party track by $index\">{{p}} </span> -->\r\n                <!-- test{{user.politicianInfo[0].party}} -->\r\n                <span ng-if=\"!user.party && user.politicianInfo[0].party !=\'\'\"\r\n                  >{{user.politicianInfo[0].party}}</span\r\n                >\r\n              </td>\r\n              <!--         <td>\r\n                        <span ng-if=\"user.incumbent\">{{user.incumbent}}</span>\r\n                        <span ng-if=\"!user.incumbent\">No</span>\r\n                    </td>    -->\r\n              <!--      <td class=\"tableRow\" style=\"text-transform: capitalize;\">\r\n                <a ng-if=\"user.dataX\" ng-href=\"{{user.dataX}}\" target=\"_blank\" style=\"text-decoration:underline;\" class=\"link\">\r\n                  <b>Open</b>\r\n                </a>\r\n              </td>   -->\r\n            </tr>\r\n          </table>\r\n        </div>\r\n        <button\r\n          ng-hide=\"selectForPrint || users.length <= 0\"\r\n          ng-click=\"compareOfficeWiseSubject(value)\"\r\n          class=\"compareBtn\"\r\n        >\r\n          Compare Answers\r\n        </button>\r\n        <button\r\n          ng-hide=\"selectForPrint || users.length <= 0\"\r\n          ng-click=\"compareRatings(value)\"\r\n          class=\"compareBtn wlink\"\r\n        >\r\n          Compare Ratings\r\n        </button>\r\n      </div>\r\n      <br />\r\n      <div\r\n        ng-if=\"$root.userRole==\'politician\' ||$root.userRole==\'advocate\' || $root.userRole==\'admin\'\"\r\n      >\r\n        <a\r\n          ng-if=\"searchUsersByType.length > 0\"\r\n          href=\"#!/endorsePolitician\"\r\n          class=\"btn\"\r\n        >\r\n          Remove Your Endorsement </a\r\n        ><br /><br />\r\n      </div>\r\n      <div\r\n        ng-if=\"$root.userRole==\'politician\' ||$root.userRole==\'advocate\' || $root.userRole==\'admin\'\"\r\n      >\r\n        <a\r\n          ng-if=\"searchUsersByType.length > 0\"\r\n          href=\"#!/ratePolitician\"\r\n          class=\"btn\"\r\n        >\r\n          Rate Unlisted Politicians\r\n        </a>\r\n      </div>\r\n\r\n      <div ng-if=\"searchUsersByType.length == 0\">\r\n        VoteWise is a national organization, but we have a few holes in our\r\n        local elections coverage. If you have entered your address and you don\'t\r\n        see anything here, we have no information on your next election yet.\r\n        Please come back soon.\r\n        <!-- {{showWar}} -->\r\n      </div>\r\n    </div>\r\n    <br />\r\n    <br />\r\n    <br />\r\n    <br />\r\n    <br />\r\n    <br />\r\n    <br />\r\n    <div class=\"row d-none d-lg-flex\" ng-if=\"balloType.length > 0\">\r\n      <div class=\"col-lg-12\">\r\n        <div id=\"topHeaderCandidate\">\r\n          <div id=\"candidateDesc\">\r\n            <h2>Ballot Measures</h2>\r\n\r\n            <nav class=\"nav nav-pills flex-column flex-sm-row optionTabs\">\r\n              <a\r\n                class=\"dayButtons flex-sm-fill text-sm-center nav-link\"\r\n                ng-if=\"shwLocal\"\r\n                ng-click=\"getBallotByType(\'local\')\"\r\n                ng-class=\"{\'acivetab\': bType == \'local\'}\"\r\n                >Local</a\r\n              >\r\n              <a\r\n                class=\"dayButtons flex-sm-fill text-sm-center nav-link\"\r\n                ng-if=\"shwCounty\"\r\n                ng-click=\"getBallotByType(\'county\')\"\r\n                ng-class=\"{\'acivetab\': bType == \'county\'}\"\r\n                >County</a\r\n              >\r\n              <a\r\n                class=\"dayButtons flex-sm-fill text-sm-center nav-link\"\r\n                ng-if=\"shwSbCounty\"\r\n                ng-click=\"getBallotByType(\'subCounty\')\"\r\n                ng-class=\"{\'acivetab\': bType == \'subCounty\'}\"\r\n                >County Sub Division</a\r\n              >\r\n              <a\r\n                class=\"dayButtons flex-sm-fill text-sm-center nav-link\"\r\n                ng-if=\"shwState\"\r\n                ng-click=\"getBallotByType(\'state\')\"\r\n                ng-class=\"{\'acivetab\': bType == \'state\'}\"\r\n                >State</a\r\n              >\r\n            </nav>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <!-- For small screens -->\r\n    <div class=\"row d-lg-none\">\r\n      <div class=\"col-12\">\r\n        <div>\r\n          <div id=\"descContainer\">\r\n            <div class=\"candidateDescSmall\">\r\n              <h5 class=\"blockTitle\">Ballot Measures</h5>\r\n            </div>\r\n          </div>\r\n          <div id=\"selectBoxContainer\">\r\n            <select\r\n              class=\"custom-select selectBox\"\r\n              ng-model=\"bType\"\r\n              ng-change=\"getBallotByType(bType)\"\r\n            >\r\n              <option selected value=\"local\" ng-if=\"shwLocal\">Local</option>\r\n              <option value=\"county\" ng-if=\"shwCounty\">County</option>\r\n              <option selected value=\"subCounty\" ng-if=\"shwSbCounty\">\r\n                County Sub Division\r\n              </option>\r\n              <option value=\"state\" ng-if=\"shwState\">State</option>\r\n            </select>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div\r\n      class=\"col-lg-12 col-centered\"\r\n      id=\"compareContent\"\r\n      ng-if=\"balloType.length > 0\"\r\n    >\r\n      <div class=\"table-responsive\">\r\n        <div\r\n          ng-repeat=\"itms in balloType track by $index\"\r\n          style=\"margin-top: 2%\"\r\n          class=\"ballotMeasure\"\r\n        >\r\n          <!-- <div class=\"ballotMeasure\"> -->\r\n\r\n          <p ng-if=\"itms.measureId\" style=\"margin-top: 2%\">\r\n            <span>Meaasure ID:- {{itms.measureId}}</span>\r\n          </p>\r\n          <p ng-if=\"itms.title\">\r\n            <span>Title:- {{itms.title}}</span>\r\n          </p>\r\n          <p ng-if=\"itms.summary\"><span>Summary:-</span> {{itms.summary}}</p>\r\n          <p>\r\n            <span\r\n              >Measure Text:-\r\n              <a\r\n                href=\"javascript: void(0)\"\r\n                ng-if=\"itms.measureText\"\r\n                ng-click=\"showHtmlViewer1(itms.measureText, \'BallotMeaures\')\"\r\n                class=\"link\"\r\n              >\r\n                <b>View</b>\r\n              </a></span\r\n            >\r\n          </p>\r\n          <!-- </div> -->\r\n\r\n          <table\r\n            class=\"table table-striped blackText\"\r\n            style=\"margin-bottom: 0px; width: 80%; margin-left: 10%\"\r\n            ng-if=\"balloType.length > 0\"\r\n          >\r\n            <tr>\r\n              <th class=\"tableHead\">\r\n                <span class=\"d-none d-md-flex\">Reviews</span>\r\n              </th>\r\n              <th class=\"tableHead\">Endorsements</th>\r\n              <th class=\"tableHead\">ProUrl</th>\r\n              <th class=\"tableHead\">Con Url</th>\r\n              <th class=\"tableHead\">Discuss/Debate</th>\r\n            </tr>\r\n\r\n            <tr\r\n              ng-repeat=\"itm in balloType track by $index\"\r\n              ng-if=\"itm._id == itms._id\"\r\n            >\r\n              <td>\r\n                <a href=\"#!/ballotRatings/{{itm._id}}\" class=\"link\">\r\n                  <b>{{itm.total_reviwes}}</b>\r\n                </a>\r\n                <span\r\n                  ng-if=\"$root.userRole==\'politician\' ||$root.userRole==\'advocate\' || $root.userRole==\'admin\'\"\r\n                >\r\n                  /\r\n                  <a href=\"#!/rateBallotMeasures/{{itm._id}}\" class=\"link\">\r\n                    <b>Add</b>\r\n                  </a></span\r\n                >\r\n              </td>\r\n              <td>\r\n                <a href=\"#!/showBallotEndorsement/{{itm._id}}\" class=\"link\">\r\n                  <b>{{itm.total_endorsements}}</b>\r\n                </a>\r\n                <span\r\n                  ng-if=\"$root.userRole==\'politician\' || $root.userRole==\'advocate\' || $root.userRole==\'admin\'\"\r\n                >\r\n                  /\r\n                  <a href=\"#!/endorseBallot/{{itm._id}}\" class=\"link\">\r\n                    <b>Add</b>\r\n                  </a></span\r\n                >\r\n              </td>\r\n              <td>\r\n                <a href=\"{{itm.proUrl}}\" target=\"_blank\" class=\"link\"\r\n                  >{{itm.proUrl}}</a\r\n                >\r\n              </td>\r\n              <td>\r\n                <a\r\n                  ng-if=\"itm.conUrl\"\r\n                  href=\"{{itm.conUrl}}\"\r\n                  target=\"_blank\"\r\n                  class=\"link\"\r\n                  >{{itm.conUrl}}</a\r\n                >\r\n                <span ng-if=\"!itm.conUrl\">N/A</span>\r\n              </td>\r\n\r\n              <td>\r\n                <a\r\n                  href=\"javascript: void(0)\"\r\n                  ng-click=\"goToBallotThread(itm)\"\r\n                  style=\"text-decoration: underline\"\r\n                  class=\"link\"\r\n                  ng-if=\"itm.total_tagged && itm.total_tagged > 0\"\r\n                >\r\n                  <b>View</b>\r\n                </a>\r\n                <a\r\n                  href=\"javascript: void(0)\"\r\n                  ng-click=\"goToBallotThread(itm)\"\r\n                  style=\"text-decoration: underline\"\r\n                  class=\"flink\"\r\n                  ng-if=\"!itm.total_tagged || itm.total_tagged == 0\"\r\n                >\r\n                  <b>Create</b>\r\n                </a>\r\n              </td>\r\n            </tr>\r\n          </table>\r\n        </div>\r\n      </div>\r\n      <div ng-if=\"balloType.length == 0\">\r\n        VoteWise is a national organization, but we have a few holes in our\r\n        local elections coverage. If you have entered your address and you don\'t\r\n        see anything here, we have no information on your next election yet.\r\n        Please come back soon.\r\n      </div>\r\n    </div>\r\n\r\n    <div></div>\r\n    <div class=\"bottomInfo\">\r\n      <p>\r\n        Politicians are listed in order of how many questions they answered.\r\n      </p>\r\n      <br />\r\n  <p>\r\n       <a href=\"https://www.techandciviclife.org/\" target=\"_blank\">\r\n          <image\r\n            src=\"../assets/images/TechAndCivicLife.png\"\r\n            class=\"partners\"\r\n          ></image\r\n        ></a>\r\n			<a href=\"https://votesmart.org/\" target=\"_blank\">\r\n                    <image src=\"../assets/images/VoteSmartLogoD.png\" class=\"partners\"></image></a>\r\n    <a href=\"https://www.propublica.org/\" target=\"_blank\">\r\n                    <image src=\"../assets/images/logo-propublica.svg\" class=\"partners\"></image></a>\r\n\r\n    <a href=\"https://openstates.org/\" target=\"_blank\">\r\n                    <image src=\"../assets/images/openstates_logo.d5ae3c5f606e.svg\" class=\"partners\"></image></a>\r\n    <a href=\"https://www.opensecrets.org//\" target=\"_blank\">\r\n                    <image src=\"../assets/images/opensecrets_databy250x88.gif\" class=\"partners\"></image></a>\r\n    <a href=\"https://www.loc.gov/\" target=\"_blank\">\r\n                    <image src=\"../assets/images/LibraryOfCongressLogo.svg\" class=\"partners\"></image></a>\r\n    <a href=\"https://www.fec.gov/\" target=\"_blank\">\r\n                    <image src=\"../assets/images/FECseal.svg\" class=\"partnersCircle\"></image></a>\r\n				<a href=\"https://my.lwv.org/new-york/city-new-york\" target=\"_blank\"><image src=\"../assets/images/LWVofNYCsmall.jpg\" class=\"partners\"></image></a>\r\n  </p>\r\n        Candidate information is provided in part by The Center for Tech and\r\n        Civic Life, VoteSmart, WeVote, and by your local boards of elections.\r\n        Please keep in mind that we get candidiate information before it is\r\n        finalized and there is a possibility some of our information about who\r\n        is running may be incomplete or incorrect. We currently don\'t cover all\r\n        towns and cities, but your donations of money and information can help\r\n        us reach that goal. For the most current information, please contact\r\n        your local state or county board of elections.\r\n      </p>\r\n    </div>\r\n  </div>\r\n</div>\r\n<script type=\"text/ng-template\" id=\"guest_location\">\r\n      <div class=\"row\">\r\n    <div class=\"col-12\">\r\n      <h3>Select your location</h3>\r\n      <div class=\"col-md-12\">\r\n\r\n        <!-- <div class=\"control-group\">\r\n        <label class=\"control-label formLabel removeTopMargin\" for=\"email\">State (click if incorrect) </label>\r\n        <select ng-model=\"Location.state\" style=\"text-transform: capitalize;\" ng-options=\"item as item.state for item in allState\" ng-change=\"getCounties()\"></select>\r\n      </div>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel\" for=\"email\">County (click if incorrect) </label>\r\n        <select ng-model=\"Location.county\" style=\"text-transform: capitalize;\" ng-options=\"item as item._id.county for item in allcounties\" ng-change=\"getSubCounties()\"></select>\r\n      </div>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel\" for=\"email\">Sub county (click if incorrect) </label>\r\n        <select ng-model=\"Location.subcounty\" style=\"text-transform: capitalize;\" ng-options=\" item._id.countySubdivision for item in MyPlaces.allsubcounty\" ng-change=\"getPlacesData(Location.subcounty)\"></select>\r\n      </div>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel\" for=\"email\">City (click if incorrect) </label>\r\n        <select ng-model=\"Location.place\" style=\"text-transform: capitalize;\" ng-options=\"item._id.place for item in displayPlaces\" ng-change=\"getVoterDistrcitData(Location.place)\"></select>\r\n\r\n      </div>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel\" for=\"email\">Voter District (click if incorrect) </label>\r\n        <select ng-model=\"Location.voterDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item._id.voterDistrict for item in displayVoterDistrict\"></select>\r\n      </div>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel\" for=\"email\">Federal Congressional District (click if incorrect) </label>\r\n        <select ng-model=\"Location.federalCongrassionalDist\" style=\"text-transform: capitalize;\" ng-options=\"item as item._id.federalCongrassionalDist for item in displayFederalDistrict\"></select>\r\n      </div>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel\" for=\"email\">State Senate District (click if incorrect) </label>\r\n        <select ng-model=\"Location.stateSenateDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item._id.stateSenateDistrict for item in displayStateSenate\"></select>\r\n      </div>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel\" for=\"email\">State House OF Representative District </label>\r\n        <select ng-model=\"Location.stateLegislativeDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item._id.stateHouseOFRepresentativeDistrict for item in displayStateLegislative\"></select>\r\n      </div>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel\" for=\"email\">Unified School District Name (click if incorrect) </label>\r\n        <select ng-model=\"Location.schoolDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item._id.unifiedSchoolDistrictName for item in displaySchoolDistrict\"></select>\r\n      </div> -->\r\n      <div class=\"control-group\"ng-if=\"Zip\">\r\n          <label class=\"control-label formLabel\">Street Address (Leave out Apt #)</label>\r\n          <div class=\"control-group\">\r\n            <input type=\"text\" id=\"address\" ng-model=\"User.Address\" ng-keyup=\"detectAddress($event)\" class=\"zipInput form-control\" />&nbsp;\r\n          </div>\r\n          <br>\r\n        </div>\r\n        <div class=\"control-group\" ng-if=\"Address\">\r\n          <label class=\"control-label formLabel removeTopMargin\" for=\"zipcode\">ZipCode</label>\r\n          <div class=\"control-group\">\r\n            <input type=\"text\" id=\"zipcodeinput\" ng-model=\"Location.ZipCode\" ng-keyup=\"detectCode($event)\" class=\"form-control validate[required,custom[integer],minSize[5]] text-input\"\r\n              tabindex=\"1\" />&nbsp; &nbsp;\r\n            <i ng-if=\"showZipLoader\" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>\r\n            <input type=\"hidden\" ng-model=\"hidzip\">\r\n          </div>\r\n        </div>\r\n         <div ng-if=\"showAddressDropDown\">\r\n          <div class=\"form-group\" ng-if=\"Location.state && Location.state!=\'\'\">\r\n            <p style=\"float:right\" ng-if=\"Link\">\r\n               <br><br> <center>\r\n            <button ng-click=\"submitLocation(Location)\" type=\"button\" class=\"btn2Short-style widthAuto btn-success\">Save</button>\r\n          </center>\r\n                <br>\r\n                Check the details below to see if they look right.  If any are marked in yellow, you should select from the available options.\r\n\r\n            </p>\r\n            <!--    <center>\r\n            <button ng-click=\"submitLocation()\" type=\"button\" class=\"btnShort-style widthAuto btn-success\">Set Location</button>\r\n          </center> -->\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel removeTopMargin\" for=\"email\">State </label>\r\n            <div class=\"controls\">\r\n              <select ng-model=\"Location.state\" style=\"text-transform: capitalize;\" ng-options=\"item.state for item in allstates track by item.stateFips\"\r\n                ng-class=\"checkLength(allstates, \'state\')\"></select>\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"email\">County </label>\r\n            <div class=\"controls\">\r\n              <select ng-model=\"Location.county\" style=\"text-transform: capitalize;\" ng-options=\"item.countyName for item in allcounties track by item.countyFips\"\r\n                ng-class=\"checkLength(allcounties, \'county\')\"></select>\r\n            </div>\r\n          </div>\r\n          <!-- <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"email\">Sub county </label>\r\n            <div class=\"controls\">\r\n              <select ng-model=\"Location.countySubdivision\" style=\"text-transform: capitalize;\" ng-options=\"countySubdivision as item.countySubdivision for item in subcounties track by item.countySubdivision\"\r\n                ng-class=\"checkLength(subcounties, \'countySubdivision\')\"></select>\r\n            </div>\r\n          </div> -->\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"email\">City </label>\r\n            <div class=\"controls\">\r\n              <select ng-model=\"Location.place\" style=\"text-transform: capitalize;\" ng-options=\"item as item.placeName for item in places track by item.place\"\r\n                ng-class=\"checkLength(places, \'place\')\"></select>\r\n            </div>\r\n            <!-- ng-change=\"getZipDataTwo()\" -->\r\n          </div>\r\n  <!--  <div class=\"control-group\">\r\n          <label class=\"control-label formLabel\" for=\"email\">Voter District (click if incorrect) </label>\r\n          <div class=\"controls\">\r\n            <select ng-model=\"Location.voterDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item.voterDistrictName for item in voterDistricts | unique:\'voterDistrictName\' track by item.voterDistrictName\" ng-change=\"onVoterDistChange()\" ng-class=\"{yellowBackground: voterDistricts.length > 1}\"></select>\r\n          </div>\r\n        </div> -->\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"email\">Federal Congressional District (click if incorrect) </label>\r\n            <div class=\"controls\">\r\n              <select ng-model=\"Location.federalCongrassionalDist\" style=\"text-transform: capitalize;\" ng-options=\"item as item.CD115FP for item in federalCongrassionalDist track by item.CD115FP\"\r\n                ng-class=\"checkLength(federalCongrassionalDist, \'federalCongrassionalDist\')\"></select>\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"email\">State Senate District (click if incorrect) </label>\r\n            <div class=\"controls\">\r\n              <select ng-model=\"Location.stateSenateDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item.NAMELSAD for item in stateSenateDistrict track by item.SLDUST\"\r\n                ng-class=\"checkLength(stateSenateDistrict, \'stateSenateDistrict\')\"></select>\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"email\">State House of Representative District (click if incorrect) </label>\r\n            <div class=\"controls\">\r\n              <select ng-model=\"Location.stateHouseOFRepresentativeDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item.NAMELSAD for item in stateHouseOFRepresentativeDistricts track by item.NAMELSAD\"\r\n                ng-class=\"checkLength(stateHouseOFRepresentativeDistricts, \'stateHouseOFRepresentativeDistrict\')\"></select>\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"email\">School District Name (click if incorrect) </label>\r\n            <div class=\"controls\">\r\n              <select ng-model=\"Location.unifiedSchoolDistrictName\" style=\"text-transform: capitalize;\" ng-options=\"item as item.NAME for item in unifiedSchoolDistrictNames track by item.NAME\"\r\n                ng-class=\"checkLength(unifiedSchoolDistrictNames, \'unifiedSchoolDistrictName\')\"></select>\r\n            </div>\r\n          </div>\r\n           <div class=\"control-group\" ng-if=\"cityCouncilDistrict.length > 0\">\r\n            <label class=\"control-label formLabel\" for=\"email\">City Council District Name(click if incorrect) </label>\r\n            <div class=\"controls\">\r\n              <select ng-model=\"Location.cityCouncilDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item.COUNTDIST for item in cityCouncilDistrict track by item.COUNTDIST\"\r\n                 ng-class=\"checkLength(cityCouncilDistrict, \'cityCouncilDistrict\')\"></select>\r\n            </div>\r\n          </div>\r\n          <div style=\"clear: both;\"></div>\r\n        </div>\r\n        <div style=\"clear: both;\"></div>\r\n        <div class=\"control-group\" ng-if=\"Location.state && Location.state!=\'\'\"><br>\r\n          <center>\r\n            <button ng-click=\"submitLocation(Location)\" type=\"button\" class=\"btn2Short-style widthAuto btn-success\">This Looks Right</button>\r\n          </center>\r\n   <!--         <br><br>\r\n              <center>\r\n                <a ng-click=\"getAddress()\" class=\"btn2Short-style widthAuto btn-success\">\r\n                  Try Zip Code Tool Instead\r\n                </a>\r\n              </center>   -->\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</script>\r\n<script type=\"text/ng-template\" id=\"statement\">\r\n      <div class=\"row\">\r\n    <div ng-bind-html=\'displayContent\' class=\"txtwindow\"></div>\r\n  </div>\r\n</script>\r\n");
$templateCache.put("app/compare_subcategories/compare_subcategories.html","\r\n<html>\r\n  <head>\r\n  <title>Question Subcategories</title>\r\n  <!-- This next line keeps buttons and forms at a legible size on cell phones -->\r\n  <meta name=\"viewport\" content=\"initial-scale=1, maximum-scale=1\">\r\n  </head>\r\n  <div>\r\n<body>\r\n<p>COMPARE</p>\r\n<p><h1><center>{{category.title}}</center></h1></p>\r\n<p><center>Choose a subcategory</center></p>\r\n  <!--\r\n  <center>\r\n    7<a href=\"compare.html\"><input type=\"button\" class=button_width value=\"ALL\" ></a> <br><br>\r\n\r\n    ASK<a href=\"askToAnswer.html\"><input type=\"button\" class=button_width value=\"Privacy\" ></a> <br><br>\r\n\r\n    1<a href=\"compare.html\"><input type=\"button\" class=button_width value=\"Marriage\" ></a> <br><br>\r\n\r\n    3<a href=\"compare.html\"><input type=\"button\" class=button_width value=\"Racial Profiling\" ></a> <br><br>\r\n\r\n    3<a href=\"compare.html\"><input type=\"button\" class=button_width value=\"Voting\" ></a> <br><br>\r\n\r\n    3<input type=\"button\" name=\"subtopic\" value=\"Voting\"class=button_width><br><br>\r\n\r\n    ASK<a href=\"askToAnswer.html\"><input type=\"button\" class=button_width value=\"LGBT Issues\" ></a> <br><br>\r\n\r\n    <img src=\"images/pressB.svg\" alt=\"Press\"/><br>\r\n    ASK<a href=\"askToAnswer.html\"><input type=\"button\" class=button_width value=\"Questions from the Press\" ></a> \r\n    <br>\r\n  </center>\r\n  -->\r\n    <center class=\"fwb\" ng-if=\"statusGetCompareAnswers == 1\">Loading ...</center>\r\n    <center class=\"fwb\" ng-if=\"statusGetSubCategories == 1\">Loading categories ...</center>\r\n\r\n    <center>\r\n      <div ng-repeat=\"subcat in subCategories\" style=\"margin-bottom: 20px;\">\r\n          <div ng-hide=\"subcat.total_answers <= 0\">\r\n          <span ng-if=\"subcat.total_answers > 0\">{{subcat.total_answers}}</span>\r\n          <span ng-if=\"subcat.total_answers <= 0\">ASK</span>\r\n              <a ng-click=\"compare(subcat)\"><input type=\"button\" class=\"btn\" value=\"{{subcat.title}}\" ></a></div>\r\n      </div>\r\n    </center>\r\n</html>");
$templateCache.put("app/compare_subject/compare_subject.html","<div class=\"container-fluid\">\r\n  <h2 class=\"pageHeading\">COMPARE ANSWERS</h2>\r\n  <p class=\"pageSubHeading\">Compare how your selected politicians answered the 5 Min Quiz, All Questions, or select from specific Topic Quizzes.</p>\r\n  <div class=\"newUser\">\r\n    <center>\r\n					\r\n    <h2><center ng-if=\"fiveMinData.length > 0\">COMPARE BY 5 MIN or ALL</center></h2>\r\n      <div ng-if=\"showLoader\" style=\"z-index: 2; background:black;\">\r\n            <i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span>\r\n          </div>\r\n      </center>\r\n    <div class=\"allTopics clk\" ng-repeat=\"item in fiveMinData\"  ng-hide=\"item.ansCount == 0\" ng-click=\"goToFiveCompare(item)\" style=\"border: none;\">\r\n          \r\n      <a href=\"javascript: void(0)\">\r\n           \r\n        <!-- {{cat.title}} -->\r\n        <img class=\"w100\" ng-src=\"{{item.imgUrl}}\" alt=\"{{item.title}}\" ><span>{{item.title}}</span>\r\n      </a>\r\n      <span ng-if=\"item.ansCount > 0\" class=\"button_badge\">{{item.ansCount}}</span>\r\n      <span ng-if=\"item.ansCount == 0\" class=\"no_thread_badge\">0</span>\r\n    </div>\r\n  </div>\r\n  <p>\r\n    <h2><center>COMPARE BY SUBJECT</center></h2></p>\r\n  <!-- This is the Start of the subject images \r\n  <p ng-if=\"statusCat == 1\">Loading categories ...</p>-->\r\n \r\n<center>\r\n<div ng-if=\"statusCat == 1\" style=\"z-index: 2; background:black;\">\r\n      <i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span>\r\n    </div>\r\n</center>\r\n  <div class=\"newUser\">\r\n    <div ng-if=\"statusCat == 2\">\r\n      <div class=\"allTopics clk\" ng-repeat=\"cat in categories | orderBy: \'order\'\"  ng-hide=\"cat.total_answers == 0\" ng-click=\"goToCompareSubcategories(cat)\" style=\"border: none;\">\r\n          \r\n        <a href=\"javascript: void(0)\">\r\n             \r\n          <!-- {{cat.title}} -->\r\n          <img class=\"w100\" ng-src=\"{{$root.imgUrl}}/{{cat.iconImage}}\" alt=\"{{cat.title}}\" ><span>{{cat.title}}</span>\r\n        </a>\r\n        <span ng-if=\"cat.total_answers > 0\" class=\"button_badge\">{{cat.total_answers}}</span>\r\n        <span ng-if=\"cat.total_answers == 0\" class=\"no_thread_badge\">0</span>\r\n      </div>\r\n    </div>\r\n    <!-- <p><center>~OR~</center></p>\r\n        \r\n    <center><a href=\"compare.html\"><input type=\"button\" value=\"Compare All Answers\" ></a> </center>\r\n   -->\r\n  </div>\r\n</div>\r\n<p>If you don\'t see any subjects here after the page finishes loading, they have not answered any questions.  You should ask them to get involved.</p>");
$templateCache.put("app/compositeQuiz/compositeQuiz.html","<div class=\"container-fluid\">\r\n  <h2 class=\"pageHeading\">ORGANIZATION QUIZZES</h2>\r\n  <p class=\"pageSubHeading\">Select a quiz below or select multiple quizzes and answer them all together in one quiz.\r\n    There is very likely some cross over between the quizzes, so the composite quiz will likely be shorter than you\'d\r\n    think. </p>\r\n  <form name=\"myForm\" role=\"form\">\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">\r\n        Filter Quizzes\r\n      </legend>\r\n      <div class=\"row\" style=\"margin-left: 30%\">\r\n        <div class=\"col-lg-4 col-md-4 col-sm-4\">\r\n          <h6 class=\"makeCenter\">Filter</h6>\r\n          <!-- <div class=\"input-wrapper\"> -->\r\n          <input type=\"text\" placeholder=\"Click Here\" readonly ng-click=\"showFilter()\" class=\"form-control\"   ng-model=\"search.Locations\">\r\n          <!-- </div> -->\r\n          <span ng-click=\"showFilter()\" class=\"fa  fa-chevron-down sampl\"></span>\r\n          <div id=\"tfheader\" class=\"searchbox\" ng-if=\"isShowFilter\">\r\n            <form name=\"searchform\" id=\"searchform\" method=\"post\" action=\"submit.action\">\r\n              <div style=\"clear:both;\"></div>\r\n              <div>\r\n                <div class=\"showFilter changeTextColor\">\r\n                  <div class=\"DivClass\">\r\n                    <div class=\"leftClass\">\r\n                      <input type=\"checkbox\" ng-model=\"search.subject\" ng-true-value=\"\'Subject of Interest\'\" ng-false-value=\"\'NO\'\">\r\n                              </div>\r\n                      <div class=\"rightClass\" ng-click=\"showAllFilter($event, \'Interest\');\">\r\n                        Subject of\r\n                        Interest&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"!ShowSubcatTree\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"ShowSubcatTree\"></i>\r\n                      </div>\r\n                    </div>\r\n                    <div ng-repeat=\"subent in subtopics.subcategories track by $index\" ng-include=\"\'field_renderer\'\">\r\n                      Loading...</div>\r\n                    <div class=\"DivClass\">\r\n                      <div class=\"leftClass\">\r\n                        <input type=\"checkbox\" ng-model=\"search.Locations\" ng-true-value=\"\'Location\'\" ng-false-value=\"\'NO\'\">\r\n                              </div>\r\n                        <div class=\"rightClass\" ng-click=\"showAllFilter($event, \'Location\');\">\r\n                          Location&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"!showLoadingLocation\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingLocation\"></i>\r\n                        </div>\r\n                      </div>\r\n                      <ul class=\"TcatList innerCat\" ng-if=\"showRefineLocation\">\r\n                        <li ng-repeat=\"local in Location track by $index\">\r\n                          <input type=\"checkbox\" ng-click=\"SelectDefaultLocation(local)\" ng-true-value=\"\'{{local}}\'\" ng-false-value=\"\'NO\'\">\r\n                          <label class=\"checkbox\" ng-if=\"local!=\'Other Specific\'\" title=\"{{local}}\"> {{local}}&nbsp;</label>\r\n                          <label class=\"checkbox\" ng-if=\"local==\'Other Specific\'\" ng-click=\"showAllFilter($event, \'AllLocation\')\" title=\"{{local}}\"> {{local}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"!ShowStateLoader\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"ShowStateLoader\"></i></label>\r\n                          <!-- Select Location Start -->\r\n                          <ul class=\"TcatList innerCat\"\r\n                            ng-if=\"local==\'Other Specific\' && showRefineLocation && showStates\">\r\n                            <li ng-repeat=\"area in allLocations track by $index\">\r\n                              <input type=\"checkbox\" ng-click=\"selectLocation(area, area.state, area.statePostalCode, \'state\')\">\r\n                              <label ng-click=\"getCounties(area, \'location\')\"> <b>{{area.state}}</b>&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoading.indexOf(area.statePostalCode)==-1\"></i> <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoading.indexOf(area.statePostalCode) > -1\"></i></label>\r\n                              <!-- Display Counties -->\r\n                              <ul class=\"TcatList innerCat\" ng-if=\"allCounties[area.statePostalCode].length > 0\">\r\n                                <li ng-repeat=\"county in allCounties[area.statePostalCode] track by $index\">\r\n                                  <input type=\"checkbox\" ng-click=\"selectLocation(area, county, county.countyName, \'county\')\">\r\n                                  <label ng-click=\"getLocals(area.stateFips, county.countyFips, \'location\')\"> <u>{{county.countyName}}</u>&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoadingCounty.indexOf(county._id.county) == -1\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingCounty.indexOf(county.county) > -1\"></i></label>\r\n                                  <!-- Display Locals and sub counties -->\r\n                                  <ul class=\"TcatList innerCat\" ng-if=\"Essay.location!=\'National\'\">\r\n                                    <li\r\n                                      ng-repeat=\"local in allLocals[area.stateFips][county.countyFips] track by $index\">\r\n                                      <!-- {{local}} -->\r\n                                      <label class=\"checkbox\" title=\"{{local.placeName}}\">\r\n                                              <input type=\"checkbox\" ng-click=\"selectLocation(area, county.countyName, local, \'local\')\"> {{local.placeName}}\r\n                                            </label>\r\n                                    </li>\r\n                                  </ul>\r\n                                  <!-- Display Locals and sub counties End -->\r\n                                </li>\r\n                              </ul>\r\n                              <!-- Display Counties End -->\r\n                            </li>\r\n                          </ul>\r\n                          <!-- Select Location End -->\r\n                        </li>\r\n                      </ul>\r\n                    </div>\r\n                    <div style=\"clear:both;\"></div>\r\n                  </div>\r\n                  <div style=\"clear:both;\"></div>\r\n            </form>\r\n            <div class=\"DivClassLeft\">&nbsp;</div>\r\n\r\n            <div style=\"clear:both;\"></div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-lg-4 col-md-4 col-sm-4\">\r\n          <div style=\"margin-top: 10%\">\r\n            <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"filterQuizzes()\">\r\n             Filter\r\n            </button>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </fieldset>\r\n\r\n    <center>\r\n      <div ng-if=\"loadernew\" style=\"z-index: 2; background:black;\">\r\n        <i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span>\r\n      </div>\r\n    </center>\r\n    <div class=\"row table-responsive\" infinite-scroll=\"pageFunction()\" style=\"margin-top: 10px;\">\r\n      <table class=\"table w100 changeTextColor\" ng-if=\"compositeQuiz.length > 0\">\r\n        <tr>\r\n          <th>\r\n            <input type=\"checkbox\" ng-change=\"SelectChecks()\" ng-model=\"isSelected\">\r\n             Select\r\n          </th>\r\n          <th>\r\n            <input type=\"checkbox\" ng-change=\"toggleList()\" ng-model=\"isInvited\">\r\n             Invited\r\n          </th>\r\n          <th>\r\n            <a href=\"\" ng-click=\"orderByField=\'orgName\'; reverseSort = !reverseSort\">\r\n                Organization Name <span ng-show=\"orderByField == \'orgName\'\"><i ng-show=\"!reverseSort\" class=\"fa fa-arrow-circle-up\"></i><i ng-show=\"reverseSort\" class=\"fa fa-arrow-circle-down\"></i>\r\n           </a>\r\n          </th>\r\n          <th>\r\n            Quiz Name\r\n          </th>\r\n\r\n          <th>\r\n            <a href=\"\" ng-click=\"sortQues()\">Questions &nbsp;<i ng-if=\"queUp\" class=\"fa fa-arrow-circle-up\"></i><i ng-if=\"queDown\" class=\"fa fa-arrow-circle-down\"></i>\r\n            </a>\r\n          </th>\r\n          <th>\r\n            <a href=\"\" ng-click=\"unAns()\">Unanswered Questions &nbsp;<i ng-if=\"unAnsUp\" class=\"fa fa-arrow-circle-up\"></i><i ng-if=\"unAnsDown\" class=\"fa fa-arrow-circle-down\"></i>\r\n            </a>\r\n          </th>\r\n          <th>\r\n            Topics\r\n          </th>\r\n          <th>Geographic Interest</th>\r\n          <th>\r\n            Followers\r\n          </th>\r\n\r\n        </tr>\r\n        <tr ng-repeat=\"u in compositeQuiz | orderBy:orderByField:reverseSort   track by $index\"\r\n          style=\"text-transform:capitalize;\">\r\n          <td>\r\n            <input type=\"checkbox\" value=\"{{u}}\" ng-model=\"u.isSelected\" ng-click=\"select(u.orgId,u.quizName,u)\">\r\n          </td>\r\n          <td>\r\n            <input type=\"checkbox\" value=\"{{u}}\" ng-model=\"u.isInvited\" disabled ng-click=\"Invited(u.orgId,u.quizName)\">\r\n          </td>\r\n          <td>\r\n            <p ng-if=\"u.orgName\" style=\"margin: 0;\">\r\n              <a href=\"#!/pressProfile/{{u.orgId}}\">{{u.orgName}}</a>\r\n            </p>\r\n          </td>\r\n          <td>\r\n            {{u.quizName}}\r\n          </td>\r\n          <td>\r\n            <div ng-hide=\"view[u.orgId] && viewTwo[u.quizName]\">\r\n              <a href=\"\"  ng-click=\"showQuestions(u,show)\" class=\"link\">Preview</a><br> ( {{u.noOfQues}} )</div><span>\r\n              <a href=\"\" ng-if=\"view[u.orgId] && viewTwo[u.quizName]\" class=\"link\" ng-click=\"showLess(u)\">Hide Questions</a></span>\r\n\r\n              <div ng-if=\"view[u.orgId] && viewTwo[u.quizName]\">\r\n                <table>\r\n                  <tr>\r\n                    <th>Questions in quiz</th>\r\n                  </tr>\r\n                  <tr ng-repeat=\"q in questions |orderBy:\'qOrder\'  track by $index\">\r\n                    <td>\r\n                      <span>{{$index+1}})  <strong>{{q.content}}</strong></span>\r\n                    </td>\r\n                  </tr>\r\n                </table>\r\n                <!-- <div ng-repeat=\"q in questions track by $index\">\r\n                <span>{{$index+1}})  <strong>{{q.content}}</strong></span>\r\n              </div> -->\r\n                <a href=\"\" ng-if=\"view[u.orgId] && viewTwo[u.quizName]\" class=\"link\" ng-click=\"showLess(u)\">Hide Questions</a>\r\n\r\n              </div>\r\n          </td>\r\n          <td>\r\n            <a href=\"\" ng-click=\"redirectToQuestions(u)\" class=\"link\">{{u.unAnsweredQues}}</a>\r\n\r\n          </td>\r\n          <!-- <td>Civil Liberties, Cat Sitting, Dog grooming</td> -->\r\n          <td>\r\n            <div ng-repeat=\"itm in u.catTopics track by $index\">\r\n              <b ng-if=\"itm.superPar\"> <u>{{itm.superPar}}</u> => </b> <b ng-if=\"itm.parentCat\">{{itm.parentCat}} =></b>\r\n              {{itm.title}}\r\n            </div>\r\n          </td>\r\n          <!-- <td>National, Pennsylvania, Alabama, New Hope</td> -->\r\n          <td>\r\n            <div ng-repeat=\"area in  u.geographicInterest\">\r\n              <span ng-if=\"area.country && !area.state && !area.county && !area.place\">\r\n                {{area.country}},\r\n              </span>\r\n              <span ng-if=\"area.state && !area.county && !area.place\">\r\n                {{area.state}},\r\n              </span>\r\n              <span ng-if=\"area.county\">\r\n                {{area.county}},\r\n              </span>\r\n              <span ng-if=\"area.place\">\r\n                {{area.place}},\r\n              </span>\r\n            </div>\r\n          </td>\r\n          <td>\r\n            <a href=\"#!/orgActivityDetails/followers/{{u.orgId}}\" class=\"link\">{{u.followerCount}}</a>\r\n          </td>\r\n        </tr>\r\n      </table>\r\n      <p ng-if=\"statusGetResPg == 1 && totalRecords > compositeQuiz.length\" class=\"fwb\">Loading Quizzes...</p>\r\n      <p ng-if=\"statusGetResPg == 3\" class=\"fwb\">Quizzes not found for this topic</p>\r\n      <div ng-if=\"selectedQuestions != 0\">\r\n        <h3>Questions in your personlaized quiz: {{selectedQuestions}}</h3>\r\n        <h3 ng-if=\"unAnsCount.length > 0\">UnAnswered Questions: {{unAnsCount.length}}</h3>\r\n        <h3 ng-if=\"unAnsCount.length == 0\">UnAnswered Questions: 0</h3>\r\n      </div>\r\n      <div style=\"margin-top: 5%\">\r\n        <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"getQuiz()\">\r\n                              Get Quiz\r\n                            </button>\r\n\r\n      </div>\r\n    </div>\r\n\r\n  </form>\r\n</div>\r\n\r\n<script type=\"text/ng-template\" id=\"field_renderer\">\r\n  <ul class=\"TcatList\">\r\n<li>\r\n<div class=\"catname\" id=\"{{subent._id}}\" ng-if=\"(subent.parentIds.length == 0) && (subent.subcategories)\">\r\n<input type=\"checkbox\" ng-click=\"getVal(subent)\">\r\n<label ng-click=\"ChangeShow(subent._id);\">{{::subent.title}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id)==-1\"></i><i class=\"fa fa-caret-right\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id) > -1\"></i></label>\r\n</div>\r\n<!-- {{(subent.parentIds.length}} -->\r\n<div class=\"catname\" ng-if=\"(subent.parentIds.length == 0) && (!subent.subcategories)\">\r\n<label class=\"checkbox\" title=\"{{subent.title}}\">\r\n<input type=\"checkbox\" ng-click=\"getVal(subent)\"> {{::subent.title}}\r\n</label>\r\n</div>\r\n<label class=\"checkbox\" ng-if=\"subent.parentIds.length > 0 && showSubCat\" title=\"{{subent.title}}\">\r\n<input type=\"checkbox\" ng-click=\"getVal(subent)\"> {{::subent.title}}\r\n</label>\r\n<ul ng-if=\"subent.subcategories\" ng-class=\"subent.parentIds.length == 0 ? \'cmnUL MainCatLi_{{subent._id}}\' : \'\'\">\r\n<li ng-repeat=\"subent in subent.subcategories track by $index\" ng-include=\"\'field_renderer\'\">\r\n<!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n        <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n      </label> -->\r\n</li>\r\n</ul>\r\n</li>\r\n</ul>\r\n</script>\r\n");
$templateCache.put("app/contactUs/contactUs.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">CONTACT US</h2>\r\n  <p class=\"pageSubHeading\"></p>\r\n\r\n   <center> <p>Email us at <a href=\"mailto:email@votewise.net\">email@votewise.net</a></p>\r\n    <p> or mail us at: </p>\r\n    <p>Silent Monkeys</p>\r\n    <p>721 W Green St</p>\r\n    <p>Allentown, PA 18102</p>\r\n    \r\n    <br>\r\n    <br>\r\n    <p>Or Call <a href=\"tel:(708)683-9473\">70-VoteWise <br>  (708)683-9473</a></p></center>\r\n\r\n\r\n\r\n\r\n\r\n");
$templateCache.put("app/createBallotThread/createBallotThread.html","<p></p>\r\n<h1>\r\n  <center>Create new thread</center>\r\n</h1>\r\n<p></p>\r\n<center>\r\n  <div class=\"inline2\">\r\n    <form name=\"topicform\" id=\"topicform\">\r\n      <fieldset class=\"scheduler-border\">\r\n        <legend class=\"scheduler-border\">Thread details</legend>\r\n        <p></p>\r\n\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"title\">Title</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"Topic.title\" placeholder=\"\"\r\n                                       data-errormessage=\"Topic is required.\"  class=\"form-control input-md  validate[required] text-input\" style=\"width:90%;\">\r\n                                </div>\r\n              </div>\r\n\r\n              <div class=\"control-group\" ng-show=\"curState == \'topic\'\">\r\n                <div class=\"control-label\" for=\"title\">Select Tags</div>\r\n\r\n                <div class=\"DisplayCat changeTextColor\">\r\n                  <div style=\"background-color: #eee; padding:5px;\">All Tags <br><small>(click to select)</small></div>\r\n\r\n                  <div ng-repeat=\"subent in subtopics.subcategories track by $index\" ng-include=\"\'field_renderer\'\">\r\n                    Loading...</div>\r\n                  <div ng-if=\"subtopics.subcategories.length == 0\" class=\"loadingSpinner\">\r\n                    <i class=\"fa fa-refresh fa-spin fa-3x fa-fw\"></i>\r\n                  </div>\r\n                </div>\r\n                <div class=\"select buttons\" style=\"padding-left: 20px;\">&nbsp;\r\n                  <!-- <button class=\"btn mover left\" ng-click=\"AddmyCats()\" title=\"Add selected\" ng-disabled=\"!selectedCat.length\"><i class=\"fa fa-arrow-right\" aria-hidden=\"true\"></i></button>\r\n                                    <button class=\"btn mover right\" ng-click=\"RemoveCats()\" title=\"Remove selected\" ng-disabled=\"!rmselectedCat.length\">\r\n                                        <i class=\"fa fa-arrow-left\" aria-hidden=\"true\"></i>\r\n                                    </button> -->\r\n                </div>\r\n                <div class=\"DisplayCat changeTextColor\">\r\n                  <div style=\"background-color: #eee; padding:5px;\">Selected Tags<br><small>(click to remove)</small>\r\n                  </div>\r\n                  <ul class=\"TcatList\">\r\n                    <li ng-repeat=\"subent in selectedCat track by $index\">\r\n                      <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                                                <input type=\"checkbox\" ng-click=\"removeVal(subent)\" ng-model=\"selectedAll.id[$index]\" ng-checked=\"true\" name=\"checkedidcat\"> {{subent.title}}\r\n                                            </label>\r\n                    </li>\r\n                  </ul>\r\n                </div>\r\n                <div style=\"clear:both;\"></div>\r\n                <!-- <multi-select ng-model=\"Essay.subcategories\" available=\"subtopics\" selected-label=\"Selected subtopics\" available-label=\"All subtopics\" display=\"r as r.title\" title=\"r as r.title\" config=\"selectConfig\"></multi-select>\r\n                                <div class=\"input-error\" ng-show=\"selectForm.numSelected.$error.min\">\r\n                                    Please select at least\r\n                                    <ng-pluralize count=\"selectConfig.requiredMin\" when=\"{\'one\': \'one role\', \'other\': \'{} roles\'}\">.\r\n                                </div>\r\n                                <input type=\"hidden\" id=\"reqMin\" ng-model=\"selectConfig.requiredMin\" min=\"1\">-->\r\n              </div>\r\n\r\n              <div class=\"control-group\" ng-show=\"curState == \'topic-politician\'\">\r\n                <div class=\"control-label\" for=\"title\">Select politician to tag</div>\r\n                <div class=\"DisplayCat\">\r\n                  <div style=\"background-color: #eee; padding:5px;\">All Politician <br><small>(click to select)</small>\r\n                  </div>\r\n                  <div ng-if=\"statusfetchPoliticiansByState == 1\" class=\"loadingSpinner\">\r\n                    <i class=\"fa fa-refresh fa-spin fa-3x fa-fw\"></i>\r\n                  </div>\r\n                  <div class=\"catname\" ng-repeat=\"(key, value) in $root.politicianThreadData.users | groupBy: \'office\'\">\r\n                    <label class=\"ng-binding\">\r\n                                            <!-- <input type=\"checkbox\" ng-model=\"item.loadPolitician\" ng-change=\"fetchPoliticiansByState(item, $index);\">\r\n                                            {{item.state}}&nbsp; -->\r\n                                            <input type=\"checkbox\" ng-model=\"item.loadPolitician\" ng-change=\"selectUsersFromGroup(value, item.loadPolitician)\">\r\n                                            {{key}}&nbsp;\r\n                                            <i class=\"fa fa-caret-down ng-scope\" aria-hidden=\"true\"></i>\r\n                                        </label>\r\n                    <!-- <p ng-if=\"item.getPolStatus == 1\">Loading ...</p>\r\n                                        <ul ng-show=\"item.politicians.length > 0\" style=\"margin: 0px; list-style: none;\">\r\n                                            <li ng-repeat=\"pol in item.politicians\">\r\n                                                <label>\r\n                                                    <input type=\"checkbox\" ng-model=\"pol.selected\"> {{pol.name_on_ballot}}\r\n                                                </label>\r\n                                            </li>\r\n                                        </ul> -->\r\n                    <ul ng-show=\"value.length > 0\" style=\"margin: 0px; list-style: none;\">\r\n                      <li ng-repeat=\"pol in value\">\r\n                        <label>\r\n                                                    <input type=\"checkbox\" ng-model=\"pol.selected\">\r\n                                                    <span ng-if=\"pol.registeredUser\">\r\n                                                        <span ng-if=\"pol.name_on_ballot\">{{pol.name_on_ballot}}</span>\r\n                                                        <span ng-if=\"!pol.name_on_ballot\">{{pol.name}}</span>\r\n                                                    </span>\r\n                                                    <span ng-if=\"!pol.registeredUser\">\r\n                                                        <span ng-if=\"pol.name_on_ballot\">{{pol.name_on_ballot}}</span>\r\n                                                        <span ng-if=\"!pol.name_on_ballot\">{{pol.name}}</span>\r\n                                                    </span>\r\n                                                </label>\r\n                      </li>\r\n                    </ul>\r\n                  </div>\r\n                </div>\r\n                <div class=\"select buttons\" style=\"padding-left: 20px;\">&nbsp;\r\n                </div>\r\n                <div class=\"DisplayCat\">\r\n                  <div style=\"background-color: #eee; padding:5px;\">Selected Tags<br><small>(click to remove)</small>\r\n                  </div>\r\n                  <!-- <div ng-repeat=\"item in allLocations\">\r\n                                        <ul ng-show=\"item.politicians.length > 0\" style=\"margin: 0px; list-style: none; padding: 0;\">\r\n                                            <li ng-repeat=\"pol in item.politicians\" ng-if=\"pol.selected\">\r\n                                                <label>\r\n                                                    <input type=\"checkbox\" ng-model=\"pol.selected\"> {{pol.name_on_ballot}}\r\n                                                </label>\r\n                                            </li>\r\n                                        </ul>\r\n                                    </div> -->\r\n                  <ul ng-show=\"$root.politicianThreadData.users.length > 0\"\r\n                    style=\"margin: 0px; list-style: none; padding: 0;\">\r\n                    <li ng-repeat=\"pol in $root.politicianThreadData.users\" ng-if=\"pol.selected\">\r\n                      <label>\r\n                                                <input type=\"checkbox\" ng-model=\"pol.selected\">\r\n                                                <span ng-if=\"pol.registeredUser\">\r\n                                                    <span ng-if=\"pol.name_on_ballot\">{{pol.name_on_ballot}}</span>\r\n                                                    <span ng-if=\"!pol.name_on_ballot\">{{pol.name}}</span>\r\n                                                </span>\r\n                                                <span ng-if=\"!pol.registeredUser\">\r\n                                                    <span ng-if=\"pol.name_on_ballot\">{{pol.name_on_ballot}}</span>\r\n                                                    <span ng-if=\"!pol.name_on_ballot\">{{pol.name}}</span>\r\n                                                </span>\r\n                                            </label>\r\n                    </li>\r\n                  </ul>\r\n                </div>\r\n                <div style=\"clear:both;\"></div>\r\n              </div>\r\n\r\n\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label\" for=\"description\">Description</label>\r\n                <div class=\"controls\">\r\n                  <textarea id=\"description\" ng-model=\"Topic.description\" placeholder=\"\"\r\n                                       data-errormessage=\"Description is required.\" class=\"form-control input-md  validate[required] text-area\"></textarea>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label\" for=\"location\">Thread Location</label>\r\n              </div>\r\n              <div class=\"control-group\" ng-if=\"!ShowLocationOptions\">\r\n                <!-- <label class=\"control-label\" for=\"location\">Thread Location</label> -->\r\n                <div class=\"controls\">\r\n                  <div style=\"float: left; padding-right:20px; padding-top:20px; padding-bottom:20px;\">\r\n                    <strong>City :</strong> {{uData.address.place}},<br /><strong>Sub county :</strong>\r\n                    {{uData.address.countySubdivision}},<br />\r\n                    <strong>County :</strong> {{uData.address.county}},<br /><strong>State :</strong>\r\n                    {{uData.address.state}}<br>\r\n                                    </div>\r\n                    <div style=\"float: left; margin-left:2%; padding-top:40px; padding-bottom:20px;\">\r\n                      <input type=\"button\" class=\"btnShort-style\" value=\"Change\" ng-click=\"ShowLocation()\">\r\n                                    </div>\r\n                      <div style=\"clear:both;\"></div>\r\n                    </div>\r\n                  </div>\r\n\r\n                  <div class=\"control-group\" ng-if=\"ShowLocationOptions\">\r\n\r\n                    <div class=\"DisplayCat\">\r\n                      <div style=\"background-color: #eee; padding:5px;\">Choose\r\n                        Location<br><small>(click to select)</small></div>\r\n                      <ul class=\"TcatList\">\r\n                        <li style=\"padding-bottom:10px;\">\r\n                          <input type=\"checkbox\" ng-click=\"getLocations(Essay.Locations, \'International\')\" ng-model=\"Essay.Locations\" ng-true-value=\"\'International\'\" ng-false-value=\"\'NO\'\">\r\n                          <label ng-click=\"ShowAddLocation();\">International&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i></label>\r\n                          <div style=\"padding-left:20px;\" ng-if=\"AddLocation\">\r\n                            <div mass-autocomplete>\r\n                              <input ng-model=\"newlocation.country\" mass-autocomplete-item=\"autocomplete_options\">\r\n                                            </div>\r\n                              <div style=\"text-align: right;\"><button ng-click=\"AddCountry();\">Add country</button>\r\n                              </div>\r\n                            </div>\r\n                        </li>\r\n                        <li>\r\n                          <input type=\"checkbox\" ng-model=\"Essay.National\" ng-click=\"getLocations(Essay.National, \'National\')\" ng-true-value=\"\'National\'\" ng-false-value=\"\'NO\'\">\r\n                          <label>National</label>\r\n                          </i>\r\n                          <ul class=\"TcatList\">\r\n                            <li ng-repeat=\"area in allLocations track by $index\">\r\n                              <input type=\"checkbox\" ng-click=\"getAreaVal(area, area.state, \'state\')\" ng-disabled=\"checkDisabled(area, area.state, \'state\')\" ng-checked=\"checkDisabled(area, area.state, \'state\')\">\r\n                              <label ng-click=\"getCounties(area.stateFips)\">{{area.state}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoading.indexOf(area.stateFips)==-1\"></i> <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoading.indexOf(area.stateFips) > -1\"></i></label>\r\n                              <!-- Display Counties -->\r\n                              <ul class=\"TcatList\">\r\n                                <li\r\n                                  ng-repeat=\"county in allCounties[area.stateFips] | orderBy: \'countyName\' track by $index\">\r\n                                  <input type=\"checkbox\" ng-click=\"getAreaVal(county, area.state, \'county\')\" ng-disabled=\"checkDisabled(county, area.state, \'county\')\" ng-checked=\"checkDisabled(county, area.state, \'county\')\">\r\n                                  <label ng-click=\"getLocals(area.stateFips, county.countyFips)\">{{county.countyName}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoadingCounty.indexOf(county.countyFips) == -1\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingCounty.indexOf(county.county) > -1\"></i></label>\r\n                                  <!-- Display Locals and sub counties -->\r\n                                  <ul class=\"TcatList\" ng-if=\"Essay.location!=\'National\'\">\r\n                                    <li\r\n                                      ng-repeat=\"local in allLocals[area.stateFips][county.countyFips] |    orderBy: \'placeName\'  track by $index\">\r\n                                      <label class=\"checkbox\" title=\"{{local.place}}\">\r\n                                                                        <input type=\"checkbox\" ng-click=\"getAreaVal(local, area.state, \'local\')\" ng-disabled=\"disabledLocation.indexOf(local) > -1 ? true : false\" ng-checked=\"disabledLocation.indexOf(local) > -1 ? true : false\"> {{local.placeName}}\r\n                                                                    </label>\r\n                                    </li>\r\n                                  </ul>\r\n                                  <!-- Display Locals and sub counties End -->\r\n                                </li>\r\n                              </ul>\r\n                              <!-- Display Counties End -->\r\n                            </li>\r\n                          </ul>\r\n                        </li>\r\n                      </ul>\r\n                    </div>\r\n                    <div class=\"select buttons\" style=\"padding-left: 20px;\">&nbsp;\r\n                      <!-- <button class=\"btn mover left\" ng-click=\"AddmyArea()\" title=\"Add selected\" ng-disabled=\"!selectedArea.length\"><i class=\"fa fa-arrow-right\" aria-hidden=\"true\"></i></button>\r\n                                    <button class=\"btn mover right\" ng-click=\"RemoveArea()\" title=\"Remove selected\" ng-disabled=\"!rmselectedArea.length\">\r\n                                        <i class=\"fa fa-arrow-left\" aria-hidden=\"true\"></i>\r\n                                    </button> -->\r\n                    </div>\r\n                    <div class=\"DisplayCat\">\r\n                      <div style=\"background-color: #eee; padding:5px;\">Selected Location\'s\r\n                        <br><small>(click to remove)</small></div>\r\n                      <ul class=\"TcatList\">\r\n                        <li ng-repeat=\"area in selectedArea track by $index\">\r\n                          <label class=\"checkbox\" title=\"{{area}}\">\r\n                                                <input type=\"checkbox\" ng-click=\"removeAreaVal(area)\" ng-model=\"selectedLAll.id[$index]\" ng-checked=\"true\" name=\"checkedid\"> <span ng-if=\"area.country && (!(area.state) && !(area.county) && !(area.countySubdivision) && !(area.place))\">{{area.country}}</span> <span ng-if=\"area.state && (!(area.county) && !(area.countySubdivision) && !(area.place))\">{{area.state}}</span><span ng-if=\"area.county && (!(area.countySubdivision) && !(area.place))\">{{area.county}}</span><span ng-if=\"area.countySubdivision\">{{area.countySubdivision}}</span><span ng-if=\"area.place\"> - {{area.place}}</span>\r\n                                            </label>\r\n                        </li>\r\n                      </ul>\r\n                    </div>\r\n                    <div style=\"clear:both;\"></div>\r\n                    <!--\r\n                                <multi-select ng-model=\"Essay.subcategories\" available=\"subtopics\" selected-label=\"Selected subtopics\" available-label=\"All subtopics\" display=\"r as r.title\" title=\"r as r.title\" config=\"selectConfig\"></multi-select>\r\n                                <div class=\"input-error\" ng-show=\"selectForm.numSelected.$error.min\">\r\n                                    Please select at least\r\n                                    <ng-pluralize count=\"selectConfig.requiredMin\" when=\"{\'one\': \'one role\', \'other\': \'{} roles\'}\">.\r\n                                </div>\r\n                                <input type=\"hidden\" id=\"reqMin\" ng-model=\"selectConfig.requiredMin\" min=\"1\">\r\n                                -->\r\n                  </div>\r\n\r\n          <!--        <div class=\"control-group\">\r\n                    <label class=\"control-label\" for=\"restricted\">Any Restrictions</label>\r\n                    <div class=\"control-group\">\r\n                      <select ng-model=\"Topic.restrictedTo\" class=\"changeTextColor\">\r\n                                       <option ng-repeat=\"option in restrictedOptions\" value=\"{{option}}\">{{option}}</option>\r\n                                    </select>\r\n\r\n                    </div>\r\n                  </div>  -->\r\n\r\n\r\n                  <div style=\"clear: both;\"></div>\r\n\r\n                  <div style=\"margin-top:20px;\">\r\n                    <button ng-click=\"SubmitTopic(Topic)\" type=\"button\" class=\"btn btn-success\" ng-disabled=\"TopicButton\"  style=\"float: left;\">Submit Thread</button>\r\n                    &nbsp;&nbsp;&nbsp;&nbsp;\r\n                    <button ng-click=\"goBack();\" class=\"btnShort-style\" type=\"button\" style=\"float: left;\">Cancel</button>\r\n                    <div style=\"clear: both;\"></div>\r\n                  </div>\r\n\r\n                  <div style=\"clear: both;\"></div>\r\n      </fieldset>\r\n    </form>\r\n  </div>\r\n</center>\r\n<script type=\"text/ng-template\" id=\"field_renderer\">\r\n  <ul class=\"TcatList\">\r\n        <li>\r\n             <div class=\"catname\" id=\"{{subent._id}}\" ng-if=\"(subent.parentIds.length == 0) && (subent.subcategories)\">\r\n                <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\">  <label ng-click=\"ChangeShow(subent._id);\">{{::subent.title}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id)==-1\"></i><i class=\"fa fa-caret-right\" aria-hidden=\"true\"  ng-if=\"showDown.indexOf(subent._id) > -1\"></i></label>\r\n            </div>\r\n            <div class=\"catname\" ng-if=\"(subent.parentIds.length == 0) && (!subent.subcategories)\">\r\n                <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                    <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\"> {{::subent.title}}\r\n                </label>\r\n            </div>\r\n            <label class=\"checkbox\" ng-if=\"subent.parentIds.length > 0 && showSubCat\" title=\"{{subent.title}}\" >\r\n                <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\"> {{::subent.title}}\r\n            </label>\r\n            <ul ng-if=\"subent.subcategories\" ng-class=\"subent.parentIds.length == 0 ? \'cmnUL MainCatLi_{{subent._id}}\' : \'\'\">\r\n                <li ng-repeat=\"subent in subent.subcategories track by $index\" ng-include=\"\'field_renderer\'\">\r\n                    <!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                      <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n                  </label> -->\r\n                </li>\r\n            </ul>\r\n        </li>\r\n    </ul>\r\n</script>\r\n<script type=\"text/javascript\">\r\n  jQuery(document).ready(function () {\r\n    // binds form submission and fields to the validation engine\r\n    // binds form submission and fields to the validation engine\r\n    $(\"form\").validationEngine();\r\n  });\r\n\r\n</script>\r\n");
$templateCache.put("app/createBanner/createBanner.html","<div class=\"container-fluid\">\r\n  <h2>Create Banner</h2>\r\n\r\n  <fieldset class=\"scheduler-border\">\r\n    <legend class=\"scheduler-border\">Add Banner</legend>\r\n    <br>\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <div class=\"control-group\">\r\n          <select class=\"form-control\" ng-model=\"banner.event\" ng-change=\"getBannerInfo()\" style=\"text-transform: capitalize; display: block;\">\r\n        <option value=\"\" selected>Select Event</option>\r\n        <option value=\"Election Result\">Election Result</option>\r\n        <option value=\"Ranked Choice Voting\">Ranked Choice Voting</option>\r\n        </select>\r\n        </div>\r\n        <br>\r\n\r\n        <div class=\"control-group\">\r\n          <div class=\"controls\">\r\n            <label class=\"control-label formLabel removeTopMargin\" for=\"category-title\">Is Banner Active</label>\r\n            <select class=\"form-control\" ng-model=\"banner.isActive\"  style=\"text-transform: capitalize; display: block;\">\r\n        <option value=\"\" selected>Select</option>\r\n        <option value=\"true\">Yes</option>\r\n        <option value=\"false\">No</option>\r\n        </select>\r\n          </div>\r\n        </div>\r\n        <br>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel removeTopMargin\" for=\"category-title\">Link</label>\r\n          <div class=\"controls\">\r\n            <input type=\"text\" ng-model=\"banner.link\" class=\"form-control input-md text-input\">\r\n            </div>\r\n          </div>\r\n          <br>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"description\">Description</label>\r\n            <div class=\"controls\">\r\n              <textarea class=\"form-control addComment\"  ng-model=\"banner.description\" maxlength=\"800\"  placeholder=\"Description\"></textarea>\r\n\r\n            </div>\r\n          </div>\r\n          <br>\r\n          </div>\r\n        </div>\r\n        <div style=\"clear: both;\"></div>\r\n        <div class=\"forgetPassButtons\">\r\n          <button ng-click=\"addBanner()\" type=\"submit\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n          <div style=\"clear: both;\"></div>\r\n        </div>\r\n        <div style=\"clear: both;\"></div>\r\n      </div>\r\n  </fieldset>\r\n</div>\r\n");
$templateCache.put("app/dashboard/dashboard.html","<div\r\n  class=\"container-fluid ng-scope\"\r\n  ng-cloak\r\n  ng-show=\"$root.userRole==\'admin\'\"\r\n>\r\n  <!-- This is the end of the header -->\r\n  <h2 class=\"pageHeading\">Most Used Actions</h2>\r\n  <a\r\n    ng-show=\"$root.userRole == \'admin\'\"\r\n    ng-click=\"hideAll();\"\r\n    href=\"#!/addPolitician\"\r\n    style=\"color: white\"\r\n    >Add Politician/Org</a\r\n  ><br /><br />\r\n  <a\r\n    ng-show=\"$root.userRole == \'admin\' || $root.userRole == \'voteradmin\' || $root.userRole == \'dataentryadmin\'\"\r\n    href=\"#!/uploadPolitician\"\r\n    ng-click=\"hideAll(); $root.showUpload = !$root.showUpload\"\r\n    ng-class=\"{\'active\': $root.showUpload}\"\r\n    style=\"color: white\"\r\n    >Upload Politician</a\r\n  ><br />\r\n  <hr />\r\n  <div>\r\n    <!-- <a ng-show=\"[\'advocate\', \'press\', \'voter\', \'forumadmin\', \'voteradmin\', \'admin\'].indexOf($root.userRole) > -1\" ng-click=\"hideAll(); $root.showProfile = !$root.showProfile\"\r\n      ng-class=\"{\'active\': $root.showProfile}\" class=\"link\">My Profile&nbsp;|&nbsp;</a> -->\r\n    <!-- <a ng-show=\"$root.userRole == \'politician\'\" ng-click=\"hideAll(); $root.showPoliProfile = !$root.showPoliProfile\" ng-class=\"{\'active\': showPoliProfile}\"\r\n      class=\"link\">My Profile&nbsp;|&nbsp;</a> -->\r\n    <!--    <a ng-click=\"hideAll();  $root.showFollowing = !$root.showFollowing\" ng-class=\"{\'active\': $root.showFollowing}\" href=\"#!/followingUsers\" style=\"color: white\">Following Users&nbsp;|&nbsp;</a>\r\n			<br><br>-->\r\n    <b>Topic and Question Management</b><br />\r\n    <a\r\n      ng-show=\"$root.userRole == \'admin\'\"\r\n      ng-click=\"hideAll(); showAddCategories = !showAddCategories\"\r\n      href=\"#!/addCategory/Add\"\r\n      ng-class=\"{\'active\': showAddCategories}\"\r\n      style=\"color: white\"\r\n      >Add category&nbsp;|&nbsp;</a\r\n    >\r\n    <a\r\n      ng-show=\"$root.userRole == \'admin\'\"\r\n      ng-click=\"hideAll(); showUpdateCategories = !showUpdateCategories\"\r\n      href=\"#!/addCategory\"\r\n      ng-class=\"{\'active\': showUpdateCategories}\"\r\n      style=\"color: white\"\r\n      >Update category&nbsp;|&nbsp;</a\r\n    >\r\n    <a\r\n      ng-show=\"$root.userRole == \'admin\'\"\r\n      ng-click=\"hideAll(); showAddQuestion = !showAddQuestion\"\r\n      href=\"#!/manageQue\"\r\n      ng-class=\"{\'active\': showAddQuestion}\"\r\n      style=\"color: white\"\r\n      >Manage Questions&nbsp;|&nbsp;</a\r\n    >\r\n    <a\r\n      ng-show=\"$root.userRole == \'admin\'\"\r\n      ng-click=\"hideAll(); showFiveMatchQuestion = !showFiveMatchQuestion\"\r\n      href=\"#!/fiveMatchQuestions\"\r\n      ng-class=\"{\'active\': showFiveMatchQuestion}\"\r\n      style=\"color: white\"\r\n      >Five Minute Match Questions&nbsp;|&nbsp;</a\r\n    >\r\n    <a\r\n      ng-show=\"$root.userRole == \'admin\'\"\r\n      ng-click=\"hideAll(); $root.showReportQuestion = !$root.showReportQuestion\"\r\n      href=\"#!/fiveMatchQuestions/Reported\"\r\n      ng-class=\"{\'active\': $root.showReportQuestion}\"\r\n      style=\"color: white\"\r\n      >Reported Questions&nbsp;|&nbsp;</a\r\n    >&nbsp;\r\n    <a\r\n      ng-show=\"$root.userRole == \'admin\'\"\r\n      ng-click=\"hideAll();\"\r\n      href=\"#!/trackFiveMinQuizAns\"\r\n      style=\"color: white\"\r\n      >Track Five Minute Quiz&nbsp;|&nbsp;</a\r\n    >\r\n    &nbsp;\r\n    <a\r\n      ng-show=\"$root.userRole == \'admin\'\"\r\n      ng-click=\"hideAll();\"\r\n      href=\"#!/addFiveMinEssayQues\"\r\n      style=\"color: white\"\r\n      >Add Five Minute Essay Questions&nbsp;|&nbsp;</a\r\n    >\r\n    &nbsp;\r\n    <a\r\n      ng-show=\"$root.userRole == \'admin\'\"\r\n      ng-click=\"hideAll();\"\r\n      href=\"#!/addEssayAnswers\"\r\n      style=\"color: white\"\r\n      >Add Five Minute Essay Answers&nbsp;|&nbsp;</a\r\n    >\r\n    <br /><br />\r\n    <b>User Management</b><br />\r\n    <p>\r\n      <b>Politicians</b><br />\r\n      <a\r\n        ng-show=\"$root.userRole == \'admin\'\"\r\n        ng-click=\"hideAll();\"\r\n        href=\"#!/addPolitician\"\r\n        style=\"color: white\"\r\n        >Add Politician&nbsp;|&nbsp;</a\r\n      >&nbsp; &nbsp;\r\n      <a\r\n        ng-show=\"$root.userRole == \'admin\'\"\r\n        ng-click=\"hideAll(); showUserVerification = !showUserVerification\"\r\n        href=\"#!/verifyUsers\"\r\n        ng-class=\"{\'active\': showUserVerification}\"\r\n        style=\"color: white\"\r\n        >Verify Users&nbsp;|&nbsp;</a\r\n      >\r\n      <a\r\n        ng-show=\"$root.userRole == \'admin\' || $root.userRole == \'voteradmin\' || $root.userRole == \'dataentryadmin\'\"\r\n        href=\"#!/uploadPolitician\"\r\n        ng-click=\"hideAll(); $root.showUpload = !$root.showUpload\"\r\n        ng-class=\"{\'active\': $root.showUpload}\"\r\n        style=\"color: white\"\r\n        >Upload Politician&nbsp;|&nbsp;</a\r\n      >\r\n      <a\r\n        ng-show=\"$root.userRole == \'admin\' || $root.userRole == \'voteradmin\' || $root.userRole == \'dataentryadmin\'\"\r\n        ng-click=\"hideAll(); $root.showVUpload = !$root.showVUpload\"\r\n        ng-class=\"{\'active\': $root.showVUpload}\"\r\n        href=\"#!/uploadNewPolitician\"\r\n        style=\"color: white\"\r\n        >Upload Politician New&nbsp;|&nbsp;</a\r\n      >\r\n      <a\r\n        ng-show=\"$root.userRole == \'admin\' || $root.userRole == \'voteradmin\' || $root.userRole == \'dataentryadmin\'\"\r\n        ng-click=\"hideAll(); $root.showRUpload = !$root.showRUpload\"\r\n        href=\"#!/restorePolitician/remove\"\r\n        ng-class=\"{\'active\': $root.showRUpload}\"\r\n        style=\"color: white\"\r\n        >Restore deleted politician&nbsp;|&nbsp;</a\r\n      >\r\n      <a\r\n        ng-show=\"$root.userRole == \'admin\' || $root.userRole == \'voteradmin\' || $root.userRole == \'dataentryadmin\'\"\r\n        ng-click=\"hideAll(); $root.postCard = !$root.postCard\"\r\n        href=\"#!/generatePostCards\"\r\n        ng-class=\"{\'active\': $root.postCard}\"\r\n        style=\"color: white\"\r\n        >Generate Post Cards&nbsp;|&nbsp;</a\r\n      >\r\n      <a\r\n        ng-show=\"$root.userRole == \'admin\' || $root.userRole == \'voteradmin\' || $root.userRole == \'dataentryadmin\'\"\r\n        ng-click=\"hideAll(); $root.postCard = !$root.postCard\"\r\n        href=\"#!/addDebate\"\r\n        ng-class=\"{\'active\': $root.postCard}\"\r\n        style=\"color: white\"\r\n        >Add Debate&nbsp;|&nbsp;</a\r\n      >\r\n    </p>\r\n    <p>\r\n      <b>Outside Politician Data</b><br />\r\n      <a\r\n        ng-show=\"$root.userRole == \'admin\'\"\r\n        ng-click=\"hideAll(); $root.showAllCongressman = !$root.showAllCongressman\"\r\n        ng-class=\"{\'active\': $root.showAllCongressman}\"\r\n        href=\"#!/allCongressman\"\r\n        style=\"color: white\"\r\n        >All Congressmen&nbsp;|&nbsp;</a\r\n      >\r\n      <a\r\n        ng-show=\"$root.userRole == \'admin\'\"\r\n        ng-click=\"hideAll(); $root.showOpenFec = !$root.showOpenFec\"\r\n        ng-class=\"{\'active\': $root.showCongressbills}\"\r\n        href=\"#!/openFecCandidates\"\r\n        style=\"color: white\"\r\n        >OpenFEC Candidates&nbsp;|&nbsp;</a\r\n      >&nbsp; &nbsp;\r\n      <a\r\n        ng-show=\"$root.userRole == \'admin\'\"\r\n        ng-click=\"hideAll(); $root.showOpenFecCommittee = !$root.showOpenFecCommittee\"\r\n        ng-class=\"{\'active\': $root.showCongressbills}\"\r\n        href=\"#!/openFecCommittees\"\r\n        style=\"color: white\"\r\n        >OpenFEC Committees&nbsp;|&nbsp;</a\r\n      >&nbsp; &nbsp;\r\n    </p>\r\n\r\n    <p>\r\n      <b>Organizations</b><br />\r\n      <a\r\n        ng-show=\"$root.userRole == \'admin\'\"\r\n        ng-click=\"hideAll();\"\r\n        href=\"#!/addPolitician\"\r\n        style=\"color: white\"\r\n        >Add Organization &nbsp;|&nbsp;</a\r\n      >&nbsp; &nbsp;\r\n      <a\r\n        ng-show=\"$root.userRole == \'admin\' || $root.userRole == \'voteradmin\'\"\r\n        ng-click=\"hideAll(); $root.showAdvocates = !$root.showAdvocates\"\r\n        ng-class=\"{\'active\': $root.showAdvocates}\"\r\n        href=\"#!/uploadAdvocates\"\r\n        style=\"color: white\"\r\n        >Upload Advocates&nbsp;|&nbsp;</a\r\n      >\r\n      <a\r\n        ng-show=\"$root.userRole == \'admin\'\"\r\n        ng-click=\"hideAll(); showUserVerification = !showUserVerification\"\r\n        href=\"#!/verifyUsers\"\r\n        ng-class=\"{\'active\': showUserVerification}\"\r\n        style=\"color: white\"\r\n        >Verify Users&nbsp;|&nbsp;</a\r\n      >\r\n      <a\r\n        ng-show=\"$root.userRole == \'admin\'\"\r\n        ng-click=\"hideAll();\"\r\n        href=\"#!/exportOrgRatings\"\r\n        style=\"color: white\"\r\n        >Export Organization Ratings&nbsp;|&nbsp;</a\r\n      >\r\n    </p>\r\n    <p>\r\n      <b>All Users</b><br />\r\n      <a\r\n        ng-show=\"$root.userRole == \'admin\'\"\r\n        ng-click=\"hideAll(); $root.showAllUsers = !$root.showAllUsers\"\r\n        ng-class=\"{\'active\': $root.showAllUsers}\"\r\n        href=\"#!/allUsers\"\r\n        style=\"color: white\"\r\n        >All Users&nbsp;|&nbsp;</a\r\n      >\r\n      <a\r\n        ng-show=\"$root.userRole == \'admin\' || $root.userRole == \'voteradmin\'\"\r\n        ng-click=\"hideAll(); $root.showPress = !$root.showPress\"\r\n        ng-class=\"{\'active\': $root.showPress}\"\r\n        href=\"#!/uploadPress\"\r\n        style=\"color: white\"\r\n        >Upload Press&nbsp;|&nbsp;</a\r\n      >\r\n      <a\r\n        ng-show=\"$root.userRole == \'admin\'\"\r\n        ng-click=\"hideAll();\"\r\n        ng-class=\"{\'active\': $root.showPlacesShape}\"\r\n        href=\"#!/totalUsers\"\r\n        style=\"color: white\"\r\n        >Total Users&nbsp;|&nbsp;</a\r\n      >&nbsp; &nbsp;\r\n      <a\r\n        ng-show=\"$root.userRole == \'admin\'\"\r\n        ng-click=\"hideAll();\"\r\n        href=\"#!/trackUserActivities\"\r\n        style=\"color: white\"\r\n        >Track User Activities&nbsp;|&nbsp;</a\r\n      >\r\n      <a\r\n        ng-show=\"$root.userRole == \'admin\'\"\r\n        ng-click=\"hideAll();\"\r\n        href=\"#!/trackPoliticians\"\r\n        style=\"color: white\"\r\n        >Track Politicians &nbsp;|&nbsp;</a\r\n      >\r\n    </p>\r\n    <br /><br /><b>Elections</b><br />\r\n    <a\r\n      ng-show=\"$root.userRole == \'admin\'\"\r\n      ng-click=\"hideAll();\"\r\n      href=\"#!/uploadElectionDate\"\r\n      style=\"color: white\"\r\n      >Upload Election Dates&nbsp;|&nbsp;</a\r\n    >\r\n    <a\r\n      ng-show=\"$root.userRole == \'admin\'\"\r\n      ng-click=\"hideAll();\"\r\n      href=\"#!/uploadBallotMeasures\"\r\n      style=\"color: white\"\r\n      >Upload Ballot Measures&nbsp;|&nbsp;</a\r\n    >\r\n    <a\r\n      ng-show=\"$root.userRole == \'admin\' || $root.userRole == \'voteradmin\' || $root.userRole == \'dataentryadmin\'\"\r\n      href=\"#!/uploadPolitician\"\r\n      ng-click=\"hideAll(); $root.showUpload = !$root.showUpload\"\r\n      ng-class=\"{\'active\': $root.showUpload}\"\r\n      style=\"color: white\"\r\n      >Upload Politicians&nbsp;|&nbsp;</a\r\n    >\r\n\r\n    <a\r\n      ng-show=\"$root.userRole == \'admin\' || $root.userRole == \'voteradmin\' || $root.userRole == \'dataentryadmin\'\"\r\n      href=\"#!/createBanner\"\r\n      ng-click=\"hideAll(); $root.showUpload = !$root.showUpload\"\r\n      ng-class=\"{\'active\': $root.showUpload}\"\r\n      style=\"color: white\"\r\n      >Create Banner&nbsp;|&nbsp;</a\r\n    >\r\n\r\n    <br /><br /><b>Data Management</b><br />\r\n    <a\r\n      ng-show=\"$root.userRole == \'admin\'\"\r\n      ng-click=\"hideAll(); $root.showPlacesShape = !$root.showPlacesShape\"\r\n      ng-class=\"{\'active\': $root.showPlacesShape}\"\r\n      href=\"#!/placesShapes\"\r\n      style=\"color: white\"\r\n      >Show Places Shapes&nbsp;|&nbsp;</a\r\n    >&nbsp; &nbsp;\r\n    <a\r\n      ng-show=\"$root.userRole == \'admin\' || $root.userRole == \'voteradmin\' || $root.userRole == \'dataentryadmin\'\"\r\n      href=\"#!/gridState\"\r\n      ng-click=\"hideAll(); $root.showHUpload = !$root.showHUpload\"\r\n      ng-class=\"{\'active\': $root.showHUpload}\"\r\n      style=\"color: white\"\r\n      >Grid state saved&nbsp;|&nbsp;</a\r\n    >\r\n    <a\r\n      ng-show=\"$root.userRole == \'admin\'\"\r\n      ng-click=\"hideAll(); $root.showOrganized = !$root.showOrganized\"\r\n      ng-class=\"{\'active\': $root.showOrganized}\"\r\n      href=\"#!/organizedTable\"\r\n      style=\"color: white\"\r\n      >Organized Table&nbsp;|&nbsp;</a\r\n    >\r\n    <a\r\n      ng-show=\"$root.userRole == \'admin\'\"\r\n      ng-click=\"hideAll(); showBackup = !showBackup\"\r\n      ng-class=\"{\'active\': showBackup}\"\r\n      href=\"#!/backup\"\r\n      style=\"color: white\"\r\n      >Backup&nbsp;|&nbsp;</a\r\n    >\r\n\r\n    <br /><br /><b>Activities Management</b><br />\r\n    <a\r\n      ng-show=\"$root.userRole == \'admin\' || $root.userRole == \'voteradmin\' || $root.userRole == \'forumadmin\'\"\r\n      ng-click=\"hideAll(); $root.showTopicSpam = !$root.showTopicSpam\"\r\n      ng-class=\"{\'active\': $root.showTopicSpam}\"\r\n      href=\"#!/topicSpams\"\r\n      style=\"color: white\"\r\n      >Topic Spams&nbsp;|&nbsp;</a\r\n    >\r\n    <a\r\n      ng-show=\"$root.userRole == \'admin\'\"\r\n      ng-click=\"hideAll(); $root.showAllTopic = !$root.showAllTopic\"\r\n      ng-class=\"{\'active\': $root.showAllTopic}\"\r\n      href=\"#!/allTopics\"\r\n      style=\"color: white\"\r\n      >All Topics&nbsp;|&nbsp;</a\r\n    >\r\n    <a\r\n      ng-show=\"$root.userRole == \'admin\'\"\r\n      ng-click=\"hideAll(); $root.showAllEssay = !$root.showAllEssay\"\r\n      ng-class=\"{\'active\': $root.showAllEssay}\"\r\n      href=\"#!/allEssay\"\r\n      style=\"color: white\"\r\n      >All Essay&nbsp;|&nbsp;</a\r\n    ><a\r\n      ng-show=\"$root.userRole == \'admin\'\"\r\n      ng-click=\"hideAll(); $root.showAllEssay = !$root.showAllEssay\"\r\n      ng-class=\"{\'active\': $root.showAllEssay}\"\r\n      href=\"#!/uploadPopulationData\"\r\n      style=\"color: white\"\r\n      >Upload Population Data&nbsp;|&nbsp;</a\r\n    >\r\n    <a\r\n      ng-show=\"$root.userRole == \'admin\'\"\r\n      ng-click=\"hideAll(); $root.showAllEssay = !$root.showAllEssay\"\r\n      ng-class=\"{\'active\': $root.showAllEssay}\"\r\n      href=\"#!/uploadBarAssociations\"\r\n      style=\"color: white\"\r\n      >Upload Bar Associations Rating &nbsp;|&nbsp;</a\r\n    >\r\n\r\n    <br /><br /><b>Legislation</b><br />\r\n    <a\r\n      ng-show=\"$root.userRole == \'admin\'\"\r\n      ng-click=\"hideAll();\"\r\n      ng-class=\"{\'active\': $root.showPlacesShape}\"\r\n      href=\"#!/openState\"\r\n      style=\"color: white\"\r\n      >OpenStateData&nbsp;|&nbsp;</a\r\n    >&nbsp; &nbsp;\r\n    <a\r\n      ng-show=\"$root.userRole == \'admin\'\"\r\n      ng-click=\"hideAll();\"\r\n      ng-class=\"{\'active\': $root.showPlacesShape}\"\r\n      href=\"#!/openStateBills\"\r\n      style=\"color: white\"\r\n      >OpenState Bills&nbsp;|&nbsp;</a\r\n    >&nbsp; &nbsp;\r\n    <a\r\n      ng-show=\"$root.userRole == \'admin\'\"\r\n      ng-click=\"hideAll();\"\r\n      href=\"#!/federalLegislation\"\r\n      style=\"color: white\"\r\n      >Federal Legislation&nbsp;|&nbsp;</a\r\n    >&nbsp; &nbsp;\r\n    <a\r\n      ng-show=\"$root.userRole == \'admin\'\"\r\n      ng-click=\"hideAll();\"\r\n      href=\"#!/getRollVotes\"\r\n      style=\"color: white\"\r\n      >Get Votes &nbsp;|&nbsp;</a\r\n    >&nbsp; &nbsp;\r\n    <a\r\n      ng-show=\"$root.userRole == \'admin\'\"\r\n      ng-click=\"hideAll();\"\r\n      href=\"#!/federalTextBills\"\r\n      style=\"color: white\"\r\n      >Get Federal Text Bills &nbsp;|&nbsp;</a\r\n    >&nbsp; &nbsp;\r\n    <a\r\n      ng-show=\"$root.userRole == \'admin\'\"\r\n      ng-click=\"hideAll(); addCongressBills()\"\r\n      ng-class=\"{\'active\': $root.showCongressbills}\"\r\n      class=\"link\"\r\n      >Congress Bills&nbsp;|&nbsp;</a\r\n    >&nbsp; &nbsp;\r\n\r\n    <!-- <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"showQuesApproval = !showQuesApproval\" ng-class=\"{\'active\': showQuesApproval}\">Approve questions | </a> -->\r\n    <br /><br /><b>Other Actions</b><br />\r\n\r\n    <a\r\n      ng-show=\"$root.userRole == \'admin\'\"\r\n      ng-click=\"hideAll(); $root.showAllEmail = !$root.showAllEmail\"\r\n      ng-class=\"{\'active\': $root.showAllEmail}\"\r\n      href=\"#!/sendEmail\"\r\n      style=\"color: white\"\r\n      >Send Email&nbsp;|&nbsp;</a\r\n    >\r\n\r\n    <a\r\n      ng-show=\"$root.userRole == \'admin\'\"\r\n      ng-click=\"hideAll(); $root.showInvitation = !$root.showInvitation\"\r\n      ng-class=\"{\'active\': $root.showInvitation}\"\r\n      href=\"#!/sendInvitations\"\r\n      style=\"color: white\"\r\n      >Send Invitations&nbsp;|&nbsp;</a\r\n    >\r\n\r\n    <!-- <a ng-click=\"hideAll(); $root.showAllRecommendation = !$root.showAllRecommendation\" ng-class=\"{\'active\': $root.showAllRecommendation}\" class=\"link\">My Favorites&nbsp;|&nbsp;</a> -->\r\n\r\n    <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loader\"></i>\r\n\r\n    <!-- <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll();\"\r\n        href=\"#!/sendMailTo\"  style=\"color: white\">Send Email To&nbsp;|&nbsp;</a> -->\r\n    <!-- <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll();\"\r\n        href=\"#!/manageOrganizationQuestions\"  style=\"color: white\">Manage Organization Questions&nbsp;|&nbsp;</a> -->\r\n    <!-- <hr ng-show=\"Auth\" size=\"5\" noshade=\"\"> -->\r\n    <div class=\"flex\">\r\n      <div class=\"margin-auto\">\r\n        <!-- Upload Politicians -->\r\n        <!-- Upload Politicians End -->\r\n        <!-- Following Start -->\r\n        <!-- <form ng-if=\"$root.showFollowing\" name=\"followingform\" id=\"followingform\" ng-controller=\"FollowingCtrl\" class=\"closeForm\">\r\n          <div class=\"row\" style=\"margin-top: 10px;\">\r\n            <p>\r\n              <h3>Following users</h3>\r\n            </p>\r\n            <div style=\"float:right;\">\r\n              <dir-pagination-controls max-size=\"5\" pagination-id=\"list.id\"></dir-pagination-controls>\r\n            </div>\r\n            <table class=\"w100\">\r\n              <tr>\r\n                <th>User Details</th>\r\n                <th>Unfollow</th>\r\n              </tr>\r\n              <tr dir-paginate=\"u in users.data | itemsPerPage : 25\" ng-if=\"users.data.length> 0\" pagination-id=\"list.id\">\r\n                <td>\r\n                  <img src=\"../assets/images/profile/politician.svg\" alt=\"Politician\" ng-if=\"u.politician\" class=\"UserTypeImg\" />\r\n                  <img src=\"../assets/images/profile/press.svg\" class=\"UserTypeImg\" alt=\"Press\" ng-if=\"u.press\" />\r\n                  <img src=\"../assets/images/profile/voter.svg\" class=\"UserTypeImg\" alt=\"Voter\" ng-if=\"u.voter\" />\r\n                  <img src=\"../assets/images/profile/voter.svg\" class=\"UserTypeImg\" alt=\"Voter\" ng-if=\"u.admin\" />\r\n                  <img src=\"../assets/images/profile/voter.svg\" class=\"UserTypeImg\" alt=\"Voter\" ng-if=\"u.forumadmin\" />\r\n                  <img src=\"../assets/images/profile/voter.svg\" class=\"UserTypeImg\" alt=\"Voter\" ng-if=\"u.voteradmin\" />\r\n                  <img src=\"../assets/images/profile/advocate.svg\" class=\"UserTypeImg\" alt=\"Advocate\" ng-if=\"u.advocate\" />\r\n                  <p ng-if=\"u.name\" style=\"margin: 0;\">\r\n                    <strong>Name:</strong>\r\n                    <a href=\"#!/publicProfile/{{u._id}}\">{{u.name}}</a>\r\n                  </p>\r\n                  <p ng-if=\"u.username\" style=\"margin: 0;\">\r\n                    <strong>UserName:</strong> {{u.username}}</p>\r\n                  <p ng-if=\"u.public_email\" style=\"margin: 0;\">\r\n                    <strong>Email:</strong> {{u.public_email}}</p>\r\n                  <p ng-if=\"u.mailing_address\" style=\"margin: 0;\">\r\n                    <strong>Address:</strong> {{u.mailing_address}} </p>\r\n                </td>\r\n                <td>\r\n                  <a href=\"javascript: void(0)\" ng-click=\"unfollow(u, $index)\">Unfollow</a>\r\n                </td>\r\n              </tr>\r\n              <tr ng-if=\"users.data.length == 0\">\r\n                <td colspan=\"2\"> No records found.\r\n                </td>\r\n              </tr>\r\n            </table>\r\n            <div style=\"float:right;\">\r\n              <dir-pagination-controls max-size=\"5\" pagination-id=\"list.id\"></dir-pagination-controls>\r\n            </div>\r\n          </div>\r\n        </form> -->\r\n        <!-- Following End -->\r\n        <!-- Add category -->\r\n        <!--   <div class=\"closeForm\" ng-if=\"showReportQuestion\" ng-controller=\"ReportQuestionsCtrl\">\r\n          <fieldset class=\"scheduler-border\">\r\n            <legend class=\"scheduler-border\">Manage reported Questions</legend>\r\n            <div class=\"row\">\r\n              <table class=\"w100 changeTextColor\" ng-if=\"questions.length > 0\" style=\"margin-top: 10px;\">\r\n                <tr>\r\n                  <th>Question</th>\r\n                  <th>Reason</th>\r\n                  <th>Reported By</th>\r\n                  <th>Edit</th>\r\n                  <th>Remove</th>\r\n                </tr>\r\n                <tr ng-repeat=\"q in questions\">\r\n                  <td>{{q.question.content}}</td>\r\n                  <td>\r\n                    {{q.data.comment}}\r\n                  </td>\r\n                  <td>\r\n                    {{q.user.username}}\r\n                  </td>\r\n                  <th>\r\n                    <a href=\"javascript: void(0)\" ng-click=\"editQeustion(q.question, $index)\">Edit</a>\r\n                  </th>\r\n                  <th>\r\n                    <a href=\"javascript: void(0)\" ng-click=\"removeReportedQeustion(q.data, $index)\" class=\"link\">Remove from reported</a>\r\n                  </th>\r\n                </tr>\r\n              </table>\r\n            </div>\r\n          </fieldset>\r\n        </div> -->\r\n        <!-- All Topics End -->\r\n        <!-- All Congressman End -->\r\n        <!-- My Favorite -->\r\n        <form\r\n          ng-if=\"$root.showAllRecommendation\"\r\n          name=\"recommendform\"\r\n          id=\"recommendform\"\r\n          ng-controller=\"recommendCtrl\"\r\n          class=\"closeForm\"\r\n        >\r\n          <a\r\n            href=\"javascript: void(0);\"\r\n            ng-click=\"DisplayFavorite();\"\r\n            class=\"link\"\r\n            >Add New</a\r\n          >\r\n          <div\r\n            class=\"row\"\r\n            ng-if=\"fav.data.length > 0 && showFaouriteList==1\"\r\n            style=\"margin-top: 10px\"\r\n          >\r\n            <table class=\"w100\">\r\n              <tr>\r\n                <th style=\"width: 70%\">Favorite</th>\r\n                <th style=\"width: 10%\">Type</th>\r\n                <th style=\"width: 10%\">Recommend to your followers</th>\r\n                <th style=\"width: 70%\">Remove</th>\r\n              </tr>\r\n              <tr ng-repeat=\"u in fav.data\">\r\n                <td>\r\n                  <strong>{{u.name}}</strong>\r\n                  <p ng-if=\"u.contact_person.name\">\r\n                    <strong>{{u.artist}}</strong>\r\n                  </p>\r\n                </td>\r\n                <td>{{u.type}}</td>\r\n                <td>\r\n                  <a\r\n                    href=\"javascript: void(0)\"\r\n                    ng-if=\"!u.recommend || u.recommend==\'N\'\"\r\n                    ng-click=\"recommendFav(u, \'Y\')\"\r\n                    >Recommend</a\r\n                  >\r\n                  <a\r\n                    href=\"javascript: void(0)\"\r\n                    ng-if=\"u.recommend==\'Y\'\"\r\n                    ng-click=\"recommendFav(u, \'N\')\"\r\n                    class=\"link\"\r\n                    >Remove as Recommend</a\r\n                  >\r\n                </td>\r\n                <td>\r\n                  <a\r\n                    href=\"javascript: void(0)\"\r\n                    ng-click=\"removeFav(u, $index)\"\r\n                    class=\"link\"\r\n                    >Remove</a\r\n                  >\r\n                </td>\r\n              </tr>\r\n            </table>\r\n          </div>\r\n          <div\r\n            class=\"row\"\r\n            ng-if=\"fav.data.length == 0 && showFaouriteList==3\"\r\n            style=\"margin-top: 10px\"\r\n          >\r\n            Loading data please wait...\r\n          </div>\r\n          <div\r\n            class=\"row\"\r\n            ng-if=\"fav.data.length == 0 && showFaouriteList==1\"\r\n            style=\"margin-top: 10px\"\r\n          >\r\n            No Records Found\r\n          </div>\r\n          <div class=\"row\" ng-if=\"showFaouriteList==2\" style=\"margin-top: 10px\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-12\">\r\n                <div class=\"control-group\" style=\"margin-top: 30px\">\r\n                  <div class=\"controls\">\r\n                    <h3>Favorite Details</h3>\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label\" for=\"favorite-type\">Type</label>\r\n                  <div class=\"controls\">\r\n                    <select ng-model=\"favorite.type\">\r\n                      <option\r\n                        ng-repeat=\"opt in allType track by $index\"\r\n                        value=\"{{opt}}\"\r\n                      >\r\n                        {{opt}}\r\n                      </option>\r\n                    </select>\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label\" for=\"favorite-name\">Name</label>\r\n                  <div class=\"controls\">\r\n                    <input\r\n                      type=\"text\"\r\n                      ng-model=\"favorite.name\"\r\n                      class=\"\r\n                        form-control\r\n                        input-md\r\n                        text-input\r\n                        validate[required]\r\n                      \"\r\n                    />\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label\" for=\"favorite-artist\"\r\n                    >Director/Artist/Author</label\r\n                  >\r\n                  <div class=\"controls\">\r\n                    <input\r\n                      type=\"text\"\r\n                      ng-model=\"favorite.artist\"\r\n                      class=\"form-control input-md text-input\"\r\n                    />\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label\" for=\"favorite-releaseDate\"\r\n                    >Date of release</label\r\n                  >\r\n                  <div class=\"controls\">\r\n                    <input\r\n                      type=\"date\"\r\n                      ng-model=\"favorite.releaseDate\"\r\n                      class=\"form-control input-md text-input\"\r\n                    />\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\" ng-if=\"favorite.type==\'Movie\'\">\r\n                  <label class=\"control-label\" for=\"favorite-imdburl\"\r\n                    >IMDB URL</label\r\n                  >\r\n                  <div class=\"controls\">\r\n                    <input\r\n                      type=\"text\"\r\n                      ng-model=\"favorite.imdburl\"\r\n                      class=\"form-control input-md text-input\"\r\n                    />\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label\" for=\"favorite-website\"\r\n                    >Website</label\r\n                  >\r\n                  <div class=\"controls\">\r\n                    <input\r\n                      type=\"text\"\r\n                      ng-model=\"favorite.website\"\r\n                      class=\"form-control input-md text-input\"\r\n                    />\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label\" for=\"favorite-description\"\r\n                    >Description</label\r\n                  >\r\n                  <div class=\"controls\">\r\n                    <textarea ng-model=\"favorite.description\"></textarea>\r\n                  </div>\r\n                </div>\r\n                <div style=\"clear: both\"></div>\r\n                <div>\r\n                  <button\r\n                    ng-click=\"AddFavorite(favorite)\"\r\n                    type=\"submit\"\r\n                    ng-disabled=\"EssayButton\"\r\n                    class=\"btnShort-style\"\r\n                  >\r\n                    Save\r\n                  </button>\r\n                  &nbsp;\r\n                  <!-- <button ng-click=\"registerAdvocateData(ShowData)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btn btn-success\">Create User</button> -->\r\n                  &nbsp;\r\n                  <button\r\n                    ng-click=\"goBack()\"\r\n                    type=\"button\"\r\n                    class=\"btn btn-success\"\r\n                  >\r\n                    Cancel\r\n                  </button>\r\n                  <div style=\"clear: both\"></div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </form>\r\n        <!-- My Favorite End -->\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <script type=\"text/ng-template\" id=\"field_renderer\">\r\n    <ul class=\"TcatList\">\r\n      <li>\r\n        <div class=\"catname\" id=\"{{subent._id}}\" ng-if=\"(subent.parentIds.length == 0) && (subent.subcategories)\">\r\n          <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\">\r\n          <label ng-click=\"ChangeShow(subent._id);\">{{::subent.title}}&nbsp;\r\n            <i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id)==-1\"></i>\r\n            <i class=\"fa fa-caret-right\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id) > -1\"></i>\r\n          </label>\r\n        </div>\r\n        <div class=\"catname\" ng-if=\"(subent.parentIds.length == 0) && (!subent.subcategories)\">\r\n          <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n            <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\"> {{::subent.title}}\r\n          </label>\r\n        </div>\r\n        <label class=\"checkbox\" ng-if=\"subent.parentIds.length > 0 && showSubCat\" title=\"{{subent.title}}\">\r\n          <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\"> {{::subent.title}}\r\n        </label>\r\n        <ul ng-if=\"subent.subcategories\" ng-class=\"subent.parentIds.length == 0 ? \'cmnUL MainCatLi_{{subent._id}}\' : \'\'\">\r\n          <li ng-repeat=\"subent in subent.subcategories track by $index\" ng-include=\"\'field_renderer\'\">\r\n            <!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                      <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n                  </label> -->\r\n          </li>\r\n        </ul>\r\n      </li>\r\n    </ul>\r\n  </script>\r\n  <script type=\"text/javascript\">\r\n    $(document).ready(function () {\r\n      // binds form submission and fields to the validation engine\r\n      // binds form submission and fields to the validation engine\r\n      $(\"form\").validationEngine();\r\n      $(\"#AllUsersform\").validationEngine();\r\n    });\r\n  </script>\r\n</div>\r\n");
$templateCache.put("app/debateHome/debateHome.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">DISCUSS</h2>\r\n  <p class=\"pageSubHeading\">Choose a subject and location below to discuss the topics that matter most to you - locally\r\n    or around the nation.</p>\r\n  <div class=\"centerediframe\">\r\n    <iframe src=\"https://player.vimeo.com/video/407463229?byline=false&title=false\" allowfullscreen></iframe>\r\n  </div>\r\n  <div class=\"row d-flex justify-content-center\">\r\n    <div class=\"col col-lg-9 col-med-12 col-sm-12 col-12 colPadding1\">\r\n      <div class=\"row\">\r\n        <div class=\"col-lg-12 col-sm-12 learnHeader\">\r\n          <img ng-src=\"./assets/images/discuss4.svg\" class=\"blockInfoImgLearn img-fluid\">\r\n          <div id=\"blockInfoLearn2\">\r\n            <div>\r\n              <h4 class=\"blockTitleLearn\">CHOOSE LOCATION</h4>\r\n              <span class=\"blockDesc d-flex justify-content-center\"><form action=\"\">\r\n	<input type=\"checkbox\" name=\"geographic-focus\" ng-model=\"location.isInternational\" value=\"International\" ng-change=\"getResult(\'International\')\" ng-checked=\"location.isInternational\" /> International\r\n    <input type=\"checkbox\" name=\"geographic-focus\" ng-model=\"location.isNational\" value=\"National\" ng-change=\"getResult(\'National\')\" ng-checked=\"location.isNational\" /> National\r\n    <input type=\"checkbox\" name=\"geographic-focus\" ng-model=\"location.isState\" value=\"State\" ng-change=\"getResult(\'State\')\" ng-checked=\"location.isState\"> My State\r\n    <input type=\"checkbox\" name=\"geographic-focus\" ng-model=\"location.isCounty\" value=\"County\" ng-change=\"getResult(\'County\')\" ng-checked=\"location.isCounty\"> My County\r\n    <input type=\"checkbox\" name=\"geographic-focus\" ng-model=\"location.isLocal\" value=\"Local\" ng-change=\"getResult(\'Local\')\" ng-checked=\"location.isLocal\"> My Local\r\n    <input type=\"checkbox\" name=\"geographic-focus\" ng-model=\"location.options\" value=\"other\" ng-click=\"showHtmlViewer()\" checked > Other<br>\r\n\r\n</form></span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n\r\n        <div class=\"newUserLearn\">\r\n          <form class=\"ng-pristine ng-valid\">\r\n            <div>\r\n              <!-- <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Discuss the Issues</legend>   -->\r\n              <div ng-repeat=\"item in categories | orderBy : \'order\'\" class=\"allTopics\">\r\n                <a href=\"javascript: void(0);\" ng-click=\"gotoForum(item);\" title=\"{{item.title}}\">\r\n	 <img ng-src=\"{{imgUrl}}/{{item.iconImage}}\" alt=\"{{item.title}}\"/>\r\n	<span class=\"button_badge\" id=\"qualityOfLifeThreads\">{{item.count}}</span>\r\n   <span>{{item.title}}</span>\r\n</a>\r\n              </div>\r\n            </div>\r\n          </form>\r\n        </div>\r\n        <!--    </fieldset> -->\r\n\r\n        <script type=\"text/ng-template\" id=\"guest_location\">\r\n            <div class=\"row\">\r\n                <h3>Select your location</h3>\r\n\r\n                <div class=\"col-md-12\">\r\n                    <div class=\"control-group\">\r\n                        <label class=\"control-label\" for=\"Location.state\">Select State</label>\r\n                        <div class=\"controls\">\r\n                            <select ng-model=\"Location.state\" style=\"text-transform: capitalize;\" ng-options=\"item as item.state for item in allState\" ng-change=\"getCounties()\"></select>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"control-group\" ng-if=\"Location.state!=\'\'\">\r\n                        <label class=\"control-label\" for=\"Location.county\">Select County</label>\r\n                        <div class=\"controls\">\r\n                            <select ng-model=\"Location.county\" style=\"text-transform: capitalize;\" ng-options=\"item as item._id.county for item in allcounties\" ng-change=\"getSubCounties()\"></select>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"control-group\" ng-if=\"Location.county && Location.county!=\'\'\">\r\n                        <label class=\"control-label\" for=\"Location.place\">Select Location</label>\r\n                        <div class=\"controls\">\r\n                            <select ng-model=\"Location.place\" style=\"text-transform: capitalize;\" ng-options=\" item._id.countySubdivision + \'-\' + item._id.place for item in MyPlaces\" ng-change=\"submitLocation()\"></select>\r\n                        </div>\r\n                    </div>\r\n                    <!-- <div class=\"control-group\" ng-if=\"Location.state && Location.state!=\'\'\">\r\n                        <button ng-click=\"submitLocation()\" type=\"button\" class=\"btn btn-success\">Set Location</button>\r\n                    </div>  -->\r\n                </div>\r\n            </div>\r\n        </script>\r\n");
$templateCache.put("app/dig_deeper/dig_deeper.html","<style type=\"text/css\">\r\nbody {\r\n  background-color: #ccccff;\r\n  color: #FFFFFF;\r\n}\r\n\r\n#headerImg img {\r\n  width: 95%;\r\n  min-width: 10px;\r\n  max-width: 300px;\r\n  left: 0px;\r\n}\r\n\r\n#headerImg a img:hover {\r\n  transform: scale(1.1);\r\n}\r\n\r\n#headerImg a img:active {\r\n  transform: scale(1.5);\r\n}\r\n\r\n.embed-responsive {\r\n  position: relative;\r\n  display: block;\r\n  height: 0;\r\n  padding: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.embed-responsive.embed-responsive-16by9 {\r\n  padding-bottom: 56.25%;\r\n}\r\n\r\n.embed-responsive-item {\r\n  position: absolute;\r\n  top:0;\r\n  left:0;\r\n  bottom: 0;\r\n  width: 100%;\r\n  height:100%;\r\n  border: 0;\r\n}\r\n.youtubeContainer {\r\n      max-width: 700px;\r\n    margin: 0 auto;\r\n}\r\n\r\n</style>\r\n<div id=\"headerImg\">\r\n  <center>\r\n    <a href=\"index.html\">\r\n      <center><img class=\"votewise\" embed ng-src=\"../assets/images/votewiseTop.svg\" alt=\"About Us\" /></center>\r\n    </a>\r\n  </center>\r\n</div>\r\n<br>\r\n<!-- <div  class=\"embed-responsive embed-responsive-16by9\">\r\n  <ng-youtube-embed video=\"videoID\" enablejsapi=\"true\" videoid=\"myvideo\" onready=\"playerReady\" onstatechange=\"playerStateChanged\" class=\"embed-responsive-item\"> </ng-youtube-embed>\r\n</div> -->\r\n<div class=\"youtubeContainer\">\r\n<div class=\"embed-responsive embed-responsive-16by9\">\r\n  <youtube-video class=\"embed-responsive-item\" video-id=\"videoID\"></youtube-video>\r\n</div>\r\n</div>\r\n<!-- This is the end of the header -->\r\n");
$templateCache.put("app/discussWithOthers/discussWithOthers.html","<div class=\"container-fluid\">\r\n  <h2 class=\"pageHeading\" style=\"text-transform:uppercase\">DISCUSSIONS ABOUT {{subcat.title}}</h2>\r\n  <p class=\"pageSubHeading\">You can discuss issues with people in your town, your county, your state, or nationwide.\r\n    <span ng-if= \"!showtxt\"> Click on any category to continue.</span>\r\n  </p>\r\n  <br ng-if= \"!showtxt\"><br ng-if= \"!showtxt\">\r\n  <table style=\"width:100%\" class=\"changeTextColor\" ng-if=\"records.length > 0\">\r\n    <tr>\r\n      <th>Location</th>\r\n      <th>Number of Threads</th>\r\n\r\n      <!--   <th><image src=\"../assets/images/peace.svg\" class=\"tablehead\" /><br>Solutions</th> -->\r\n      <!--<th> Total Threads</th> -->\r\n      <!-- <th>Total Posts</th> -->\r\n    </tr>\r\n    <tr ng-repeat=\"item in records\">\r\n      <td>\r\n        <span ng-if=\"item.type == \'place\'\"><a href=\"#!/forumList/{{catId}}/{{subCat}}/place\" class=\"link\">My Local</a></span>\r\n        <span ng-if=\"item.type == \'county\'\"><a href=\"#!/forumList/{{catId}}/{{subCat}}/county\" class=\"link\">My County</a></span>\r\n        <span ng-if=\"item.type == \'state\'\"><a href=\"#!/forumList/{{catId}}/{{subCat}}/state\" class=\"link\">My State</a></span>\r\n        <span ng-if=\"item.type == \'country\'\"><a href=\"#!/forumList/{{catId}}/{{subCat}}/country\" class=\"link\">Nationwide</a></span>\r\n\r\n      </td>\r\n      <td>\r\n        <span ng-if=\"item.type == \'place\'\"> <a href=\"#!/forumList/{{catId}}/{{subCat}}/place\" class=\"link\">{{item.place}}</a></span>\r\n        <span ng-if=\"item.type == \'county\'\"><a href=\"#!/forumList/{{catId}}/{{subCat}}/county\" class=\"link\">{{item.county}}</a></span>\r\n        <span ng-if=\"item.type == \'state\'\"><a href=\"#!/forumList/{{catId}}/{{subCat}}/state\" class=\"link\">{{item.state}}</a></span>\r\n        <span ng-if=\"item.type == \'country\'\"><a href=\"#!/forumList/{{catId}}/{{subCat}}/country\" class=\"link\">{{item.country}}</a></span>\r\n\r\n      </td>\r\n    </tr>\r\n  </table>\r\n  <p class=\"pageSubHeading\" ng-if=\"showtxt\">It looks like you are a\r\n    pioneer. No one has started a discussion about this\r\n    topic yet.</p>\r\n  <center><a href=\" #!/topic/{{catId}}/{{subCat}}\" class=\"compareBtn\"><b>Start a new discussion</b></a></center>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n  <!-- <td>{{item.returndata.solution}}</td> -->\r\n  <!--  <td> <span ng-if=\"item &&  item.returndata && item.returndata.totalThread\">{{item.returndata.totalThread}}</span> </td> -->\r\n  <!-- <td> <span ng-if=\"item &&  item.returndata && item.returndata.totalPost\">{{item.returndata.totalPost}}</span> </td> -->\r\n\r\n\r\n\r\n</div>\r\n<script type=\"text/ng-template\" id=\"addressPopUp\">\r\n  <div>\r\n    <h5>We need your address to show you your local politicians and other location-based tools.</h5>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\">Street Address (Leave out Apt#)</label>\r\n              <div class=\"control-group\">\r\n                <input type=\"text\" id=\"address\" ng-model=\"User.Address\" ng-keyup=\"detectAddress($event)\" class=\"zipInput form-control\" />&nbsp;\r\n            </div>\r\n              </div>\r\n\r\n              <!-- Drop down -->\r\n\r\n              <div ng-if=\"showAddressDrop\">\r\n                <div class=\"control-group\">\r\n                  <br>\r\n                  <center>\r\n                    <button ng-click=\"setAddressNew(Location)\" type=\"button\" class=\"btn2Short-style widthAuto btn-success\">Save</button>\r\n                  </center>\r\n                  <br>\r\n\r\n                  <label class=\"control-label formLabel removeTopMargin\" for=\"email\">State </label>\r\n                  <div class=\"controls\">\r\n                    <select ng-model=\"Location.state\" style=\"text-transform: capitalize;\" ng-init=\"Location.state = allstatesData[0]\" ng-options=\"item.state for item in allstatesData track by item.stateFips\" ng-class=\"checkLen(allstatesData, \'state\')\"></select>\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"email\">County </label>\r\n                  <div class=\"controls\">\r\n                    <select ng-model=\"Location.county\" style=\"text-transform: capitalize;\"  ng-options=\"item.countyName for item in allcounties track by item.countyFips\" ng-class=\"checkLen(allcounties, \'county\')\"></select>\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"email\">City </label>\r\n                  <div class=\"controls\">\r\n                    <select ng-model=\"Location.place\" style=\"text-transform: capitalize;\"  ng-options=\"item as item.placeName for item in places track by item.place\" ng-class=\"checkLen(places, \'place\')\"></select>\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"email\">Federal Congressional District (click if incorrect) </label>\r\n                  <div class=\"controls\">\r\n                    <select ng-model=\"Location.federalCongrassionalDist\" style=\"text-transform: capitalize;\" ng-init=\"Location.federalCongrassionalDist = federalCongrassionalDist[0]\" ng-options=\"item as item.CD115FP for item in federalCongrassionalDist track by item.CD115FP\" ng-class=\"checkLen(federalCongrassionalDist, \'federalCongrassionalDist\')\"></select>\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"email\">State Senate District (click if incorrect) </label>\r\n                  <div class=\"controls\">\r\n                    <select ng-model=\"Location.stateSenateDistrict\" style=\"text-transform: capitalize;\" ng-init=\"Location.stateSenateDistrict = stateSenateDistrict[0]\" ng-options=\"item as item.NAMELSAD for item in stateSenateDistrict track by item.SLDUST\" ng-class=\"checkLen(stateSenateDistrict, \'stateSenateDistrict\')\"></select>\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"email\">State House of Representative District (click if incorrect) </label>\r\n                  <div class=\"controls\">\r\n                    <select ng-model=\"Location.stateHouseOFRepresentativeDistrict\" style=\"text-transform: capitalize;\" ng-init=\"Location.stateHouseOFRepresentativeDistrict = stateHouseOFRepresentativeDistricts[0]\" ng-options=\"item as item.NAMELSAD for item in stateHouseOFRepresentativeDistricts track by item.NAMELSAD\" ng-class=\"checkLen(stateHouseOFRepresentativeDistricts, \'stateHouseOFRepresentativeDistrict\')\"></select>\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"email\">School District Name (click if incorrect) </label>\r\n                  <div class=\"controls\">\r\n                    <select ng-model=\"Location.unifiedSchoolDistrictName\" ng-init=\"Location.unifiedSchoolDistrictName = unifiedSchoolDistrictNames[0]\" style=\"text-transform: capitalize;\" ng-options=\"item as item.NAME for item in unifiedSchoolDistrictNames track by item.NAME\" ng-class=\"checkLen(unifiedSchoolDistrictNames, \'unifiedSchoolDistrictName\')\"></select>\r\n                  </div>\r\n                </div><br>\r\n                <center>\r\n                  <button ng-click=\"setAddressNew(Location)\" type=\"button\" class=\"btn2Short-style widthAuto btn-success\">This Looks Correct</button>\r\n                </center>\r\n\r\n                <br><br>\r\n              </div>\r\n            </div>\r\n</script>\r\n");
$templateCache.put("app/displayGuestForPolitician/displayGuestForPolitician.html","<div class=\"container-fluid ng-scope\">\r\n  <div ng-if=\"showTotal\">\r\n    <br>\r\n    <h2>\r\n      Unorganized Users\r\n    </h2>\r\n    <br>\r\n    <br>\r\n    <fieldset class=\"scheduler-border\">\r\n      <br>\r\n      <label> Guest Users: </label>&nbsp; &nbsp;<a href=\"\" ng-click=\"getGuestUsersAnswers()\" class=\"ylink\">{{count.guestCount}}</a>\r\n      <br>\r\n    </fieldset>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/donate/donate.html","\r\n<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">DONATION PAGE</h2>\r\n  <p class=\"pageSubHeading\"></p>\r\n      \r\n<center>\r\n<!-- Pay Pal Button Start -->\r\n<form action=\"https://www.paypal.com/cgi-bin/webscr\" method=\"post\" target=\"_top\">\r\n<input type=\"hidden\" name=\"cmd\" value=\"_s-xclick\">\r\n<input type=\"hidden\" name=\"hosted_button_id\" value=\"LFW4FAQLR2FA8\">\r\n<input type=\"image\" src=\"https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif\" border=\"0\" name=\"submit\" alt=\"PayPal - The safer, easier way to pay online!\">\r\n<img alt=\"\" border=\"0\" src=\"https://www.paypalobjects.com/en_US/i/scr/pixel.gif\" width=\"1\" height=\"1\">\r\n</form>\r\n<!-- Pay Pal Button END -->\r\n    </center>\r\n<p>Clicking the above \"Donate\" button will take you to PayPal where you can use your credit card or sign into your PayPal account and pay that way. Any and all donations are deeply appreciated and needed. Thank you very much.</p>\r\n    \r\n<p>VoteWise is a project of SilentMonkeys Inc, a Not-for-Profit 501(c)(3) organization. We do not endorse any political party, candidate or legislation. Donations are tax deductible. </p>\r\n    \r\n<p>All donations made to Silent Monkeys through this website will go directly to the VoteWise project.</p>\r\n\r\n<p>\r\nThe official registration and financial information of Silent Monkeys may be obtained from the Pennsylvania Department of State by calling toll free, within Pennsylvania, 1 (800) 732-0999. Registration does not imply endorsement. \r\n    </p>\r\n<br><br>\r\n<h2><b><center>Donate Your Time</center></b></h2>\r\n<p>Your time is just as valuable as your money.  We need people for all sorts of fun and challenging tasks.</p>\r\n<p>We need:</p><ul>\r\n    <li>Democracy ambassador to contact local boards of elections to get information about elections and politicians in office</li>\r\n    <li>Outreach teams to invite Politicians, Organizations and the Press to get involved.</li>\r\n<li>Forum Moderators to make sure that debates stay interesting, informitive, and productive</li><li>Coders to help build out the site to make it even better than it is now</li><li>Researchers... We are always in demand for infomation about one thing or another.</li></ul>\r\n<br>\r\n<p>If you would like to get involved, contact us at Volunteer@VoteWise.net</p>\r\n\r\n\r\n<p>\r\n        <h1>\r\n          <center>Spread The Word</center>\r\n        </h1>\r\n      </p>\r\n<p>Facebook is always changing its rules, but if our quiz-share function is working, it\'s a fun and educational way to get people involved.  If Facebook rules haven\'t changed, you can find a Facebook share function at the end of each quiz (exceptt he 5 min quiz).</p>\r\n      <p>Another great way you can help us is by clicking\r\n        on the paper airplane icons to share our ads on your social media and telling your friends to do the same.</p>\r\n      <br>\r\n      <iframe src=\"https://player.vimeo.com/video/295984284\" width=\"345\" height=\"194\" frameborder=\"0\"\r\n        webkitallowfullscreen mozallowfullscreen allowfullscreen style=\"padding:10px\"></iframe>\r\n\r\n      <iframe src=\"https://player.vimeo.com/video/294472087\" width=\"345\" height=\"194\" frameborder=\"0\"\r\n        webkitallowfullscreen mozallowfullscreen allowfullscreen style=\"padding:10px\"></iframe>\r\n\r\n      <iframe src=\"https://player.vimeo.com/video/295179318\" width=\"345\" height=\"194\" frameborder=\"0\"\r\n        webkitallowfullscreen mozallowfullscreen allowfullscreen style=\"padding:10px\"></iframe>\r\n\r\n      <iframe width=\"345\" height=\"194\" src=\"https://www.youtube.com/embed/MZCnDRcV7mw?rel=0\" frameborder=\"0\"\r\n        allowfullscreen style=\"padding:10px\"></iframe>");
$templateCache.put("app/editBallotMeasures/editBallotMeasures.html","<div class=\"container-fluid\">\r\n  <div class=\"row\" style=\"margin-top: 10px;\">\r\n    <div class=\"row\">\r\n      <!-- <div class=\"col-lg-12\"> -->\r\n      <div class=\"col-md-4\">\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel\" for=\"showBallot-name\">Title</label>\r\n          <div class=\"controls\">\r\n            <input type=\"text\" ng-model=\"showBallot.title\" class=\"form-control input-md text-input validate[required]\">\r\n\r\n          </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"showBallot-email\">MeasureId</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"showBallot.measureId\" class=\"form-control input-md text-input\">\r\n          </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\" for=\"showBallot-privateemail\">MeasureText</label>\r\n              <div class=\"controls\">\r\n\r\n                <textarea ng-model=\"showBallot.measureText\" class=\"form-control input-md text-input\" style=\"height:80px;\"></textarea>\r\n              </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\" for=\"showBallot-website\">No</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"showBallot.no\" class=\"form-control input-md text-input\">\r\n          </div>\r\n              </div>\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel\" for=\"profile-phone_no\">Yes</label>\r\n                <div class=\"controls\">\r\n                  <input type=\"text\" ng-model=\"showBallot.yes\" class=\"form-control input-md text-input\">\r\n          </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"profile-phone_no\">Out Come</label>\r\n                  <div class=\"controls\">\r\n                    <input type=\"text\" ng-model=\"showBallot.outCome\" class=\"form-control input-md text-input\">\r\n          </div>\r\n                  </div>\r\n                  <div class=\"control-group\">\r\n                    <label class=\"control-label formLabel\" for=\"profile-public_mailing_address\">summary</label>\r\n                    <div class=\"controls\">\r\n                      <textarea ng-model=\"showBallot.summary\" class=\"form-control input-md text-input\" style=\"height:80px;\"></textarea>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-md-8\">\r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-6\">\r\n                      <div class=\"control-group\">\r\n                        <label class=\"control-label formLabel\" for=\"showBallot-office\">statePostalCode</label>\r\n                        <div class=\"controls\">\r\n                          <input type=\"text\" ng-model=\"showBallot.statePostalCode\" class=\"form-control input-md text-input validate[required]\">\r\n              </div>\r\n                        </div>\r\n                        <div class=\"control-group\">\r\n                          <label class=\"control-label formLabel\" for=\"showBallot-office\">County</label>\r\n                          <div class=\"controls\">\r\n                            <input type=\"text\" ng-model=\"showBallot.county\" class=\"form-control input-md text-input\">\r\n              </div>\r\n                          </div>\r\n                          <div class=\"control-group\">\r\n                            <label class=\"control-label formLabel\" for=\"showBallot-candidateStatus\">Place</label>\r\n                            <div class=\"controls\">\r\n                              <input type=\"text\" ng-model=\"showBallot.place\" class=\"form-control input-md text-input\">\r\n              </div>\r\n                            </div>\r\n                            <div class=\"control-group\">\r\n                              <label class=\"control-label formLabel\" for=\"showBallot-party\">countySubdivision</label>\r\n                              <div class=\"controls\">\r\n                                <input type=\"text\" ng-model=\"showBallot.countySubdivision\" class=\"form-control input-md text-input\">\r\n              </div>\r\n                              </div>\r\n                              <div class=\"control-group\">\r\n                                <label class=\"control-label formLabel\" for=\"showBallot-electionDate\">Election Date</label>\r\n                                <div class=\"controls\">\r\n                                  <input type=\"text\" ng-model=\"showBallot.electionDate\" class=\"form-control input-md text-input\">\r\n              </div>\r\n                                </div>\r\n                                <div class=\"control-group\">\r\n                                  <label class=\"control-label formLabel\" for=\"showBallot-voterscope\">Voter Scope</label>\r\n                                  <div class=\"controls\">\r\n                                    <input type=\"text\" ng-model=\"showBallot.voterScope\" class=\"form-control input-md text-input validate[required]\">\r\n              </div>\r\n                                  </div>\r\n                                  <div class=\"control-group\">\r\n                                    <label class=\"control-label formLabel\" for=\"showBallot-rapidTransitDistrict\">ElectionType</label>\r\n                                    <div class=\"controls\">\r\n                                      <input type=\"text\" ng-model=\"showBallot.electionType\" class=\"form-control input-md text-input\">\r\n              </div>\r\n                                    </div>\r\n\r\n                                  </div>\r\n                                  <div class=\"col-md-6\">\r\n                                    <div class=\"control-group\">\r\n                                      <label class=\"control-label formLabel\" for=\"showBallot-voterDistrict\">ConUrl</label>\r\n                                      <div class=\"controls\">\r\n                                        <input type=\"text\" ng-model=\"showBallot.conUrl\" class=\"form-control input-md text-input\">\r\n              </div>\r\n                                      </div>\r\n                                      <div class=\"control-group\">\r\n                                        <label class=\"control-label formLabel\" for=\"showBallot-votingDistrictName\">Pro Url</label>\r\n                                        <div class=\"controls\">\r\n                                          <input type=\"text\" ng-model=\"showBallot.proUrl\" class=\"form-control input-md text-input\">\r\n              </div>\r\n                                        </div>\r\n                                        <div class=\"control-group\">\r\n                                          <label class=\"control-label formLabel\" for=\"showBallot-summaryUrl\">Summary Url</label>\r\n                                          <div class=\"controls\">\r\n                                            <input type=\"text\" ng-model=\"showBallot.summaryUrl\" class=\"form-control input-md text-input\">\r\n              </div>\r\n                                          </div>\r\n                                          <div class=\"control-group\">\r\n                                            <label class=\"control-label formLabel\" for=\"showBallot-textUrl\">TextUrl</label>\r\n                                            <div class=\"controls\">\r\n                                              <input type=\"text\" ng-model=\"showBallot.textUrl\" class=\"form-control input-md text-input\">\r\n              </div>\r\n                                            </div>\r\n                                            <div class=\"control-group\">\r\n                                              <label class=\"control-label formLabel\" for=\"showBallot-url\">Url</label>\r\n                                              <div class=\"controls\">\r\n                                                <input type=\"text\" ng-model=\"showBallot.url\" class=\"form-control input-md text-input\">\r\n              </div>\r\n                                              </div>\r\n                                              <div class=\"control-group\">\r\n                                                <label class=\"control-label formLabel\" for=\"showBallot-source\">Source</label>\r\n                                                <div class=\"controls\">\r\n                                                  <input type=\"text\" ng-model=\"showBallot.source\" class=\"form-control input-md text-input\">\r\n              </div>\r\n                                                </div>\r\n                                                <div class=\"control-group\">\r\n                                                  <label class=\"control-label formLabel\" for=\"showBallot-measureCode\">MeasureCode</label>\r\n                                                  <div class=\"controls\">\r\n                                                    <input type=\"text\" ng-model=\"showBallot.measureCode\" class=\"form-control input-md text-input\">\r\n              </div>\r\n                                                  </div>\r\n\r\n\r\n                                                </div>\r\n                                              </div>\r\n                                              <div style=\"clear:both;\">\r\n                                              </div>\r\n                                            </div>\r\n                                            <div style=\"clear:both;\">\r\n                                            </div>\r\n                                            <div class=\"forgetPassButtons\" style=\"text-align:center;\">\r\n                                              <button ng-click=\"updateBallot(showBallot)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btn btn-success\">Update</button>\r\n                                              &nbsp;\r\n                                              <button ng-click=\"goBack()\" type=\"button\" class=\"btn btn-success\">Cancel</button>\r\n                                              <!--<fb:login-button scope=\"public_profile,email\" onlogin=\"checkLoginState();\">\r\n                              </fb:login-button>-->\r\n                                              <div style=\"clear: both;\">\r\n                                              </div>\r\n                                            </div>\r\n                                            <!-- </div> -->\r\n                                          </div>\r\n                                        </div>\r\n                                      </div>\r\n");
$templateCache.put("app/electionProblems/electionProblems.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">Election Problems</h2>\r\n  <p class=\"pageSubHeading\">Are you having problems on election day?</p>\r\n  <div class=\"row\">\r\n  \r\n      \r\n          <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n    <div class=\"blockLink\"><img ng-src=\"./assets/images/phoneCall.svg\" class=\"gettingStartedImg img-fluid\"></div>\r\n      <div class=\"gettingStartedBlock gettingStartedBlock5\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">CALL FOR HELP</h4>\r\n          <p class=\"gettingStartedBlockDesc\">If you have questions, or if someone is trying to prevent you from voting, there are a couple numbers you can call:<br><br>Common Cause and the Lawyers’ Committee for Civil Rights Under Law have a hotline that you can call.\r\n          <a href=\"tel:+18666878683\">1-866-OUR-VOTE</a> <br>\r\n            <a href=\"tel:+18666878683\">1-866-687-8683</a> \r\n            <br><br>The NALEO Educational Fund has <a href=\"tel:+18888398682\">1-888-Ve-Y-Vota</a><br>\r\n            <a href=\"tel:+18888398682\">1-888-839-8682</a><br><br>\r\n            The Arab American Institute has in Arabic and English <a href=\"tel:+18449255287\">1-844-Yalla-US</a>  <br>\r\n            <a href=\"tel:+18449255287\">1-844-925-5287</a><br><br>  APIAVote & Asian Americans Advancing Justice-AAJC have  <a href=\"tel:+18882748683\">1-888-API-VOTE</a>   <br> <a href=\"tel:+18882748683\">1-888-274-8683</a></p> \r\n          <br>\r\n           <p>  In most states, if you are still waiting in line when the polls officially close, they must still take your ballot.  If there is a conflict over whether you can or can\'t vote, most states require that the polling place give you a \"Provisional Ballot.\"  This is a way of them taking your vote and then, after they figure out if you were allowed to vote or not, they will count that provisional ballot - or not.  Because there is the possibility of them NOT counting that vote, it is far better to straighten out the problems instead of getting a provisional ballot.</p> <br>\r\n        </div>\r\n        \r\n      </div>\r\n              \r\n    </div>\r\n      \r\n    \r\n      \r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <div class=\"blockLink\"><img ng-src=\"./assets/images/officePenG2.svg\" class=\"gettingStartedImg img-fluid\"></div>\r\n      <div class=\"gettingStartedBlock gettingStartedBlock4\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">FILE A COMPLAINT</h4>\r\n          <p class=\"gettingStartedBlockDesc\">If you were unfairly treated at the polls, you should file a complaint with the United States Department of Justice</p>\r\n\r\n            <p>             <a href=\"https://www.justice.gov/crt/complaint/votintake/index.php\" target=\"_blank\" class=\"link\"> FILE A COMPLAINT</a></p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n   \r\n    \r\n    ");
$templateCache.put("app/email_unsubscribe/email_unsubscribe.html","<div class=\"voter-signup\">\r\n  <br />\r\n  <div class=\"signup-margin\">\r\n    <p ng-if=\"status == 1\">Please wait ...</p>\r\n    <div ng-if=\"status == 2\">\r\n      <p>Unsubscribed successfully</p>\r\n    </div>\r\n    <p ng-if=\"status == 3\">\r\n      Unable to unsubscribe. <a href=\"/#!/welcome\">Home</a>\r\n    </p>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/endorseBallot/endorseBallot.html","<div class=\"container-fluid add-rating-container\" ng-cloak\r\n  ng-show=\"$root.userRole==\'admin\'|| $root.userRole==\'advocate\'|| $root.userRole==\'politician\'\">\r\n  <h2 class=\"pageHeading\">ADD ENDORSEMENT</h2>\r\n  <div class=\"row d-lg-flex\">\r\n    <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\">\r\n      <div ng-if=\"selectionType != \'yourself\'\">\r\n        <div class=\"control-group\" id=\"auto-user-suggest-box\">\r\n          <label class=\"control-label\" for=\"title\" style=\"text-transform: capitalize;\">Selected Ballot Measure</label>&nbsp;&nbsp;<i ng-if=\"showLoader \" class=\"fa fa-refresh fa-spin fa-1x fa-fw \"></i>\r\n          <div class=\"controls\" mass-autocomplete>\r\n            <input ng-model=\'selectedUser.value\' ng-disabled=\"true\" class=\"form-control\" />\r\n          </div>\r\n          </div>\r\n          <div class=\"control-group\" ng-if=\"politiicanId==userId\" id=\"auto-referal-suggest-box\">\r\n            <label class=\"control-label\">Review From</label>\r\n            <div class=\"controls\" mass-autocomplete>\r\n              <!-- <input ng-model=\'review.referal\' class=\"form-control\" /> -->\r\n              <input ng-model=\'selectedReferal.value\' mass-autocomplete-item=referal_options class=\"matrix-cell form-control\" />\r\n          </div>\r\n            </div>\r\n            <br />\r\n\r\n            <br />\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"title\"  style=\"text-transform: capitalize;\">Add Comments</label>\r\n              <div class=\"controls\">\r\n                <textarea ng-model=\"endorse.note\" class=\"form-control\"></textarea>\r\n              </div>\r\n            </div>\r\n            <br />\r\n          </div>\r\n\r\n            <a ng-click=\"submitEndorse()\" class=\"donateBtn btn\" style=\"width: auto;margin-top: 20px;margin-left: 0;\">Submit Endorsement</a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n");
$templateCache.put("app/endorsePolitician/endorsePolitician.html","<div class=\"container-fluid\">\r\n<h2 class=\"pageHeading\">REMOVE ENDORSEMENTS</h2>\r\n    <p class=\"pageSubHeading\">Use this tool to remove endorsements you made.</p>\r\n    <div ng-show=\"endorseList.length< 1\"> <h4><b>You have not yet endorsed any candidates currently running for office.</b></h4> <br><br><br></div>\r\n   \r\n  <div class=\"row table-responsive \" ng-if=\"endorseList.length> 0\" style=\"margin-top: 10px;\">\r\n    <table class=\"table w100 changeTextColor\"> \r\n      <tr>\r\n\r\n        <th>Name</th>\r\n        <th>Party</th>\r\n        <th>Office</th>\r\n        <th>Candidate Status</th>\r\n        <th>Remove Endorse</th>\r\n      </tr>\r\n      <tr ng-repeat=\"u in endorseList\">\r\n        <td>\r\n          <a href=\"#!/publicProfile/{{u._id}}\">{{u.name}}</a>\r\n        </td>\r\n        <td>\r\n          {{u.party[0]}}\r\n        </td>\r\n        <td>{{u.office}}</td>\r\n        <td>\r\n          {{u.candidateStatus}}\r\n        </td>\r\n        <td>\r\n          <a href=\"\" class=\"link\" ng-click=\"removeEndorse(u._id)\">Remove</a>\r\n        </td>\r\n      </tr>\r\n    </table>\r\n    <!-- <p ng-if=\"statusGetResPg == 1\" class=\"fwb\">Loading candidiates...</p> -->\r\n  </div>\r\n    \r\n</div>\r\n");
$templateCache.put("app/essay/essay.html","<h1>\r\n  <center style=\"text-transform: capitalize;\">{{category.title}}</center>\r\n</h1>\r\n<div class=\"container-fluid\" style=\"background-color: #efefef;box-sizing: content-box;\r\n\">\r\n  <!-- <div style=\" width: 100%;\"> -->\r\n  <center style=\"width:90%; margin: auto;\" ng-if=\"staffResults.data.length > 0\">\r\n    <h3 class=\"blackText\">Essays by Votewise</h3>\r\n  </center>\r\n  <div style=\"background-color: #eee; padding:10px; border: solid 1px #000; width: 90%; margin: auto; color:black;\"\r\n    ng-if=\"staffResults.data.length > 0\">\r\n    <div ng-repeat=\"essay in staffResults.data\">\r\n      <div style=\"padding:10px;\">\r\n        <div style=\"width:83%; float: left;\">\r\n          <div class=\"boldbox\">\r\n            <!-- <span ng-click=\"gotoThread(essay._id);\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\" class=\"link\">{{essay.title}}</span> -->\r\n            <a href=\"#!/essayDetails/{{categoryId}}/{{essay._id}}\" class=\"link\">{{essay.title}}</a>\r\n          </div>\r\n          <!-- <div><strong>Recommended :</strong>\r\n                    <input-stars max=\"5\" ng-model=\"essay.recavg\" ng-if=\"showAvg\" readonly></input-stars>\r\n                    , <strong>Factual :</strong>\r\n                    <input-stars max=\"5\" ng-model=\"essay.factfavg\" ng-if=\"showfAvg\" readonly></input-stars>\r\n                </div> -->\r\n          <div class=\"DescriptionImg\" ng-bind-html=\'essay.description | urlifyshort\'></div>\r\n          <!-- <div> Posted by <a href=\"#!/publicProfile/{{essay.createdBy.id}}\">{{essay.createdBy.name}}</a> on {{essay.createdOn | date:\'medium\'}}</div> -->\r\n        </div>\r\n        <div style=\"width:15%; float: left; text-align: center;\" ng-if=\"essay.createdBy.id==userId\">\r\n          <span ng-click=\"GotoEdit(essay._id);\" style=\"text-decoration: underline; cursor: pointer;\">Edit</span>\r\n          &nbsp;&nbsp;\r\n          <span ng-click=\"removeEssay(essay, $index, \'S\');\" style=\"text-decoration: underline; cursor: pointer;\">Remove</span>\r\n        </div>\r\n      </div>\r\n      <div style=\"clear:both;\"></div>\r\n    </div>\r\n  </div>\r\n  <div style=\"width:90%; margin: auto; text-align: right;\" ng-if=\"staffResults.data.length > 0\">\r\n    <a href=\"#!/essayStaff/{{categoryId}}\">more...</a></div>\r\n  <p>\r\n    <br>\r\n    <center>\r\n      <h3 class=\"blackText\">Essays By Organizations</h3>\r\n    </center>\r\n    <div style=\"width:90%; float: left;\">\r\n      <button class=\"compareBtn\" ng-if=\"userRole == \'advocate\' || userRole == \'admin\' &&  mainData.isEmailVerified\" ><a href=\"#!/newEssay/{{categoryId}}\" ><b>Add new essay</b></a></button>\r\n					<div class=\"blackText\" ng-if=\"userRole == \'advocate\' && mainData.isEmailVerified && !mainData.verifiedUser\" ><div id=\"blockInfoLearn1\" >We are working hard to confirm that you are who you claim to be.  In the meantime, everything you write will temporarily have the byline \"Unknown Organization.\"  As soon as we confirm your ID, all your old posts will be refreshed with your actual organization name.</div><br></div>\r\n    </div>\r\n  </p>\r\n  <br>\r\n  <br>\r\n  <!-- <h2>\r\n\r\n        <center>Search</center>\r\n      </h2> -->\r\n  <div class=\"jumbotron jumbotron-fluid tempCard\">\r\n    <div class=\"container\">\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-lg col-md col-sm\">\r\n          <h6 class=\"searchTitle\">Search Essay</h6>\r\n          <input type=\"text\"  placeholder=\"Type Here\"  ng-model=\"search.text\" class=\"form-control changeTextColor\" name=\"q\" size=\"21\" maxlength=\"120\">\r\n          <div class=\"vertiLine\"></div>\r\n        </div>\r\n        <div class=\"col-lg-3 col-md-3 col-sm-3\">\r\n          <h6 class=\"searchTitle\">Refine</h6>\r\n          <!-- <div class=\"input-wrapper\"> -->\r\n          <input type=\"text\" placeholder=\"Click Here\" readonly ng-click=\"showadvace()\" class=\"form-control\"  ng-model=\"search.Locations\">\r\n          <!-- </div> -->\r\n          <span ng-click=\"showadvace()\" class=\"fa  fa-chevron-down sampl\"></span>\r\n\r\n          <div class=\"vertiLine\"></div>\r\n        </div>\r\n							\r\n        <div class=\"col-lg-3 col-md-3 col-sm-3\">\r\n          <h6 class=\"searchTitle\">Sort</h6>\r\n          <input type=\"text\" placeholder=\"Click Here\" readonly ng-model=\"search.order\" ng-click=\"showOrder()\" class=\"form-control\">\r\n          <span ng-click=\"showOrder()\" class=\"fa  fa-chevron-down sampl\"></span>\r\n                      <div class=\"vertiLine\"></div>\r\n                    </div>\r\n	\r\n	<!-- SEARCH BUTTON -->						\r\n                    <div class=\"col-lg-3 col-md-3 col-sm-3\">\r\n\r\n                      <div style=\"margin-top:11%;padding-left:30px\">\r\n                        <button type=\"button\" ng-click=\"getEssayListAdvance(search);\" class=\"form-control btnSearch\">SEARCH</button>\r\n\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n	<!-- END OF SEARCH BUTTON-->				\r\n					\r\n					\r\n					\r\n		<!--SEARCH DETAILS-->			\r\n					          <div id=\"tfheader\" class=\"searchbox\" ng-if=\"ShowAdavace\">\r\n            <form name=\"searchform\" id=\"searchform\" method=\"post\" action=\"submit.action\">\r\n              <div style=\"clear:both;\"></div>\r\n              <div>\r\n                <div class=\"DisplayCat changeTextColor\" style=\"width:300px;\">\r\n                  <div class=\"DivClass\">\r\n                    <!-- {{ShowSubcatTree}} -->\r\n\r\n                    <div class=\"leftClass\">\r\n                      <input type=\"checkbox\" ng-model=\"search.subject\" ng-true-value=\"\'Subject of Interest\'\" ng-false-value=\"\'NO\'\">\r\n                        </div>\r\n                      <div class=\"rightClass\" ng-click=\"showRefine($event, \'Interest\');\" style=\"cursor: pointer;\">\r\n                        Subject of\r\n                        Interest&nbsp;<i class=\"fa fa-caret-right\" aria-hidden=\"true\" ng-if=\"(!showArr && !showLoadingMedia)\" style=\"cursor: pointer;\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingMedia\"></i><i class=\"fa fa-caret-down\" ng-if=\"showArr\"></i>\r\n                      </div>\r\n                    </div>\r\n                    <div ng-repeat=\"subent in subtopics.subcategories track by $index\" ng-include=\"\'field_renderer\'\"\r\n                      style=\"padding-left:5px;\">\r\n                      Loading...</div>\r\n                    <div class=\"DivClass\">\r\n                      <div class=\"leftClass\">\r\n                        <input type=\"checkbox\" ng-model=\"search.Locations\" ng-true-value=\"\'Location\'\" ng-false-value=\"\'NO\'\" style=\"cursor: pointer;\">\r\n                        </div>\r\n                        <div class=\"rightClass\" ng-click=\"showRefine($event, \'Location\');\" style=\"cursor: pointer;\">\r\n                          Location&nbsp;<i class=\"fa fa-caret-right\" aria-hidden=\"true\" ng-if=\"!showLoadingLocation && !showRefineLocation\" style=\"cursor: pointer;\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingLocation\"></i><i class=\"fa fa-caret-down\" ng-if=\"showRefineLocation\"></i>\r\n                        </div>\r\n                      </div>\r\n                      <ul class=\"TcatList innerCat\" ng-if=\"showRefineLocation\" style=\"padding-left:10px;\"><br>\r\n                        <li ng-repeat=\"local in Location track by $index\">\r\n                          <input type=\"checkbox\" ng-click=\"SelectDefaultLocation(local)\" ng-true-value=\"\'{{local}}\'\" ng-false-value=\"\'NO\'\" style=\"cursor: pointer;\">\r\n                          <label class=\"checkbox\" ng-if=\"local!=\'Other Specific\'\" title=\"{{local}}\" style=\"cursor: pointer;\"> {{local}}&nbsp;</label>\r\n                          <label class=\"checkbox\" ng-if=\"local==\'Other Specific\'\" ng-click=\"showRefine($event, \'AllLocation\')\" title=\"{{local}}\" style=\"cursor: pointer;\"> {{local}}&nbsp;<i class=\"fa fa-caret-right\" aria-hidden=\"true\" ng-if=\"local==\'Other Specific\' && !(showRefineLocation && showStates)\" style=\"cursor: pointer;\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"ShowStateLoader\" style=\"cursor: pointer;\"></i><i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"local==\'Other Specific\' && showRefineLocation && showStates\" style=\"cursor: pointer;\"></i></label>\r\n                          <!-- Select Location Start -->\r\n                          <ul class=\"TcatList innerCat\"\r\n                            ng-if=\"local==\'Other Specific\' && showRefineLocation && showStates\">\r\n                            <li ng-repeat=\"area in allLocations track by $index\">\r\n                              <input type=\"checkbox\" ng-click=\"selectLocation(area, area.state, area.statePostalCode, \'state\')\">\r\n                              <label ng-click=\"getCounties(area.stateFips, \'location\')\" style=\"cursor: pointer;\"> {{area.state}}&nbsp;<i class=\"fa fa-caret-right\" aria-hidden=\"true\" ng-if=\"!showSts[area.stateFips]\" style=\"cursor: pointer;\"></i> <i class=\"fa fa-caret-down\" ng-if=\"showSts[area.stateFips]\" style=\"cursor: pointer;\"></i></label>\r\n                              <!-- Display Counties -->\r\n                              <ul class=\"TcatList innerCat\">\r\n                                <li ng-repeat=\"county in allCounties[area.stateFips] track by $index\"\r\n                                  style=\"cursor: pointer;\">\r\n                                  <input type=\"checkbox\" ng-click=\"selectLocation(area, county._id, county._id.county, \'county\')\" style=\"cursor: pointer;\">\r\n                                  <label ng-click=\"getLocals(area.stateFips, county.countyFips, \'location\')\"style=\"cursor: pointer;\"> {{county.countyName}}&nbsp;<i class=\"fa fa-caret-right\" aria-hidden=\"true\" ng-if=\"!showCount[county.countyFips]\" style=\"cursor: pointer;\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingCounty.indexOf(county.countyFips) > -1\"></i><i class=\"fa fa-caret-down\" ng-if=\"showCount[county.countyFips]\" style=\"cursor: pointer;\"></i></label>\r\n                                  <!-- Display Locals and sub counties -->\r\n                                  <ul class=\"TcatList innerCat\" ng-if=\"Essay.location!=\'National\'\">\r\n                                    <li\r\n                                      ng-repeat=\"local in allLocals[area.stateFips][county.countyFips] track by $index\"\r\n                                      style=\"cursor: pointer;\">\r\n                                      <!-- {{local}} -->\r\n                                      <label class=\"checkbox\" title=\"{{local.placeName}}\" style=\"cursor: pointer;\">\r\n                                        <input type=\"checkbox\" ng-click=\"selectLocation(area, county.county, local._id, \'local\')\" style=\"cursor: pointer;\"> {{local.placeName}}\r\n                                      </label>\r\n                                    </li>\r\n                                  </ul>\r\n                                  <!-- Display Locals and sub counties End -->\r\n                                </li>\r\n                              </ul>\r\n                              <!-- Display Counties End -->\r\n                            </li>\r\n                          </ul>\r\n                          <!-- Select Location End -->\r\n                        </li>\r\n                      </ul>\r\n                      <!-- Select Media Type Start -->\r\n                      <!--\r\n                      <div class=\"DivClass\">\r\n                        <div class=\"leftClass\">\r\n                          <input type=\"checkbox\" ng-model=\"search.mediaType\" ng-true-value=\"\'MediaType\'\" ng-false-value=\"\'NO\'\">\r\n                        </div>\r\n                        <div class=\"rightClass\" ng-click=\"showRefine($event, \'Media\');\">\r\n                          Media Type&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"!showLoadingMedia\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingMedia\"></i></div>\r\n                      </div>\r\n                      <ul class=\"TcatList innerCat\" ng-if=\"showmediaType\">\r\n                        <li ng-repeat=\"media in mediaType track by $index\">\r\n                          <label class=\"checkbox\" title=\"{{search.mediaoption}}\">\r\n                            <input type=\"checkbox\" ng-model=\"search.mediaoption[$index]\" ng-true-value=\"\'{{media}}\'\" ng-false-value=\"\"> {{media}}\r\n                          </label>\r\n                        </li>\r\n                      </ul>\r\n            -->\r\n                      <!-- Select Media Type End -->\r\n                      <!-- Select Date Range Start -->\r\n                      <div class=\"DivClass\">\r\n                        <div class=\"leftClass\">\r\n                          <input type=\"checkbox\" ng-model=\"search.DateRange\" ng-true-value=\"\'DateRange\'\" ng-false-value=\"\'NO\'\">\r\n                        </div>\r\n                          <div class=\"rightClass\" ng-click=\"showRefine($event, \'Date\');\" style=\"cursor: pointer;\">\r\n                            Date\r\n                            Range&nbsp;<i class=\"fa fa-caret-right\" aria-hidden=\"true\" ng-if=\"(!showLoadingMedia && !showDateRange)\" style=\"cursor: pointer;\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingMedia\"></i><i class=\"fa fa-caret-down\" ng-if=\"showDateRange\" style=\"cursor: pointer;\"></i>\r\n                          </div>\r\n                        </div>\r\n                        <ul class=\"TcatList innerCat\" ng-if=\"showDateRange\">\r\n                          <form name=\"myForm\">\r\n                            <li ng-repeat=\"range in dateRange track by $index\">\r\n                              <label class=\"checkbox\" title=\"search.dateoption\">\r\n                            <input type=\"checkbox\" ng-model=\"search.dateoption\" ng-true-value=\"\'{{range}}\'\" ng-false-value=\"\'NO\'\"> {{range}}\r\n                          </label>\r\n                            </li>\r\n                            <li>\r\n                              <input type=\"checkbox\" ng-model=\"search.dateoption\" ng-true-value=\"\'Before\'\" ng-false-value=\"\'NO\'\">\r\n                              <label class=\"checkbox\">Before\r\n                            <input type=\"date\" name=\"bdate\" ng-model=\"search.dateBefore\" max=\"{{search.dateAfter | date: \'yyyy-MM-dd\'}}\">\r\n                            <div role=\"alert\">\r\n                                <span class=\"error\" ng-show=\"myForm.bdate.$error.date\">\r\n                                    <b>Invalid Date</b>\r\n                                  </span>\r\n                            </div>\r\n\r\n                          </label>\r\n                            </li>\r\n                            <li>\r\n                              <!-- {{search.dateBefore}} -->\r\n                              <input type=\"checkbox\" ng-model=\"search.dateoption1\" ng-true-value=\"\'After\'\" ng-false-value=\"\'NO\'\">\r\n                              <label class=\"checkbox\">After\r\n                            <input type=\"date\" ng-model=\"search.dateAfter\" name=\"afterDate\" min=\"{{search.dateBefore | date: \'yyyy-MM-dd\'}}\">\r\n                            <span ng-show=\"myForm.afterDate.$error.date\">\r\n                              Invalid Date\r\n                            </span>\r\n                          </label>\r\n                            </li>\r\n                          </form>\r\n                        </ul>\r\n                        <!-- Select Date Range End -->\r\n                        <!-- Match to author Start -->\r\n                        <div class=\"DivClass\">\r\n                          <div class=\"leftClass\">\r\n                            <input type=\"checkbox\" ng-model=\"search.matchauthor\" ng-true-value=\"\'Before\'\" ng-false-value=\"\'NO\'\">\r\n                        </div>\r\n                            <div class=\"rightClass\" ng-click=\"showRefine($event, \'Author\');\" style=\"cursor: pointer;\">Match to\r\n                              Author&nbsp;<i class=\"fa fa-caret-right\" aria-hidden=\"true\" ng-if=\"(!showLoadingMedia && !showMatchAuthor)\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingMedia\"></i><i class=\"fa fa-caret-down\" ng-if=\"showMatchAuthor\"></i>\r\n                            </div>\r\n                          </div>\r\n                          <ul class=\"TcatList\" ng-if=\"showMatchAuthor\">\r\n                            <li> Authors who match you between\r\n                              <input type=\"text\" class=\"numberText\" ng-model=\"search.matchFrom\" id=\"matchFrom\" data-errormessage=\"Please enter only numbers.\" maxlength=\"2\" size=\"2\" /> and\r\n                              <input type=\"text\" class=\"numberText\" ng-model=\"search.matchTo\" id=\"matchTo\" data-errormessage=\"Please enter only numbers.\" maxlength=\"3\" size=\"3\" /> percent\r\n                        </li>\r\n                          </ul>\r\n                          <!-- Match to author End -->\r\n                          <div class=\"DivClass\">\r\n                            <input type=\"checkbox\" ng-model=\"search.fromfollowlist\" ng-true-value=\"\'YES\'\" ng-false-value=\"\'NO\'\"> Authors on my follow list</div>\r\n                            <!-- User Rated Start -->\r\n                            <div class=\"DivClass\">\r\n                              <div class=\"leftClass\">\r\n                                <input type=\"checkbox\" ng-model=\"search.essayRating\" ng-true-value=\"\'Rating\'\" ng-false-value=\"\'NO\'\"> </div>\r\n                                <div class=\"rightClass\" ng-click=\"showRefine($event, \'EssayRated\');\" style=\"cursor:pointer;\"> Essay\r\n                                  Rating&nbsp;<i class=\"fa fa-caret-right\" aria-hidden=\"true\" ng-if=\"(!showLoadingMedia && !showEssayRating)\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingMedia\"></i><i class=\"fa fa-caret-down\"  ng-if=\"showEssayRating\"></i>\r\n                                </div>\r\n                              </div>\r\n                              <ul class=\"TcatList innerCat\" ng-if=\"showEssayRating\">\r\n                                <li>\r\n                                  <input type=\"checkbox\" ng-model=\"search.Recommended\" ng-true-value=\"\'Recommended\'\" ng-false-value=\"\'NO\'\"> \"Recommended\" Between<br>\r\n                                  <input type=\"text\" class=\"numberText\" ng-model=\"search.recommendFrom\" maxlength=\"2\" size=\"2\" /> and\r\n                                  <input type=\"text\" class=\"numberText\" ng-model=\"search.recommendTo\" maxlength=\"2\" size=\"2\" /> percent\r\n                                  <ul class=\"TcatList innerCat\">\r\n                                    <li>As rated by</li>\r\n                                    <li ng-repeat=\"user in users track by $index\">\r\n                                      <label class=\"checkbox\" title=\"search.recommend\">\r\n                                <input type=\"checkbox\" ng-model=\"search.recommendFilter\" ng-true-value=\"\'{{user}}\'\" ng-false-value=\"\'NO\'\"> {{user}}\r\n                              </label>\r\n                                    </li>\r\n                                  </ul>\r\n                                </li>\r\n                                <li>\r\n                                  <input type=\"checkbox\" ng-model=\"search.Factual\" ng-true-value=\"\'Factual\'\" ng-false-value=\"\'NO\'\"> \"Factual\" Between<br>\r\n                                  <input type=\"text\" class=\"numberText\" ng-model=\"search.factualFrom\" maxlength=\"2\" size=\"2\" /> and\r\n                                  <input type=\"text\" class=\"numberText\" ng-model=\"search.factualTo\" maxlength=\"2\" size=\"2\" /> percent\r\n                                  <ul class=\"TcatList innerCat\">\r\n                                    <li>As rated by</li>\r\n                                    <li ng-repeat=\"user in users track by $index\">\r\n                                      <label class=\"checkbox\" title=\"search.factual\">\r\n                                <input type=\"checkbox\" ng-model=\"search.factualFilter\" ng-true-value=\"\'{{user}}\'\" ng-false-value=\"\'NO\'\"> {{user}}\r\n                              </label>\r\n                                    </li>\r\n                                  </ul>\r\n                                </li>\r\n                              </ul>\r\n                              <!-- User Rated End -->\r\n                            </div>\r\n                            <div style=\"clear:both;\"></div>\r\n                          </div>\r\n                          <div style=\"clear:both;\"></div>\r\n            </form>\r\n            <div class=\"DivClassLeft\">&nbsp;</div>\r\n\r\n            <div style=\"clear:both;\"></div>\r\n          </div>\r\n<!-- END OF SEARCH DETAILS -->					\r\n					\r\n					\r\n														\r\n		<!-- SORT DETAILS -->\r\n          \r\n            <div class=\"DisplayCat changeTextColor\"  ng-if=\"ShowOrderList\" style=\"width:300px; float: right; margin-top: 6px;\">\r\n													<div style=\"clear:both;\"></div>\r\n              <div class=\"DivClass\">\r\n															<label  title=\"search.recommend\" style=\"cursor:pointer;\">\r\n																<input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Most Recent\'\" ng-false-value=\"\'NO\'\" style=\"cursor:pointer;\"><span style=\"padding-left: 15px\">Most Recent</span></label>\r\n              </div>\r\n                <div class=\"DivClass\">\r\n																	<label  title=\"search.recommend\" style=\"cursor:pointer;\">\r\n																		<input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Oldest\'\" ng-false-value=\"\'NO\'\" style=\"cursor:pointer;\"><span style=\"padding-left: 15px\">Oldest</span></label>\r\n              </div>\r\n                  <div class=\"DivClass\">\r\n                    <div class=\"leftClass\" style=\"width:8%;\">\r\n                      <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Highest Recommended\'\" ng-false-value=\"\'NO\'\">\r\n              </div>\r\n                      <div class=\"rightClass\" style=\"width:92%; cursor:pointer;\" ng-click=\"ShowUsers(\'HighestRecommended\')\">Highest\r\n                        Recommended&nbsp;<i class=\"fa fa-caret-right\" aria-hidden=\"true\" ng-if=\"!HighestRecommended\"></i><i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"HighestRecommended\"></i></div>\r\n                    </div>\r\n                    <ul class=\"TcatList innerCat\" ng-if=\"HighestRecommended\" style=\"padding-left: 5px; \">\r\n                      <li>As rated by</li>\r\n                      <li ng-repeat=\"user in users track by $index\" >\r\n                        <label class=\"checkbox\" title=\"search.recommend\" style=\"cursor:pointer;\">\r\n              <input type=\"checkbox\" ng-model=\"search.recommendorder\" ng-true-value=\"\'{{user}}\'\" ng-false-value=\"\'NO\'\" style=\"cursor:pointer;\"> {{user}}\r\n              </label>\r\n                      </li>\r\n                    </ul>\r\n                    <div class=\"DivClass\">\r\n                      <div class=\"leftClass\" style=\"width:8%;\">\r\n                        <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Least Recommended\'\" ng-false-value=\"\'NO\'\">\r\n              </div>\r\n                        <div class=\"rightClass\" style=\"width:92%; cursor:pointer;\" ng-click=\"ShowUsers(\'LeastRecommended\')\" >\r\n                          Least Recommended&nbsp;<i class=\"fa fa-caret-right\" aria-hidden=\"true\" ng-if=\"!LeastRecommended\"></i><i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"LeastRecommended\"></i></div>\r\n                      </div>\r\n                      <ul class=\"TcatList innerCat\" ng-if=\"LeastRecommended\" style=\"padding-left: 5px; \">\r\n                        <li>As rated by</li>\r\n                        <li ng-repeat=\"user in users track by $index\">\r\n                          <label class=\"checkbox\" title=\"search.lrecommend\" style=\"cursor:pointer;\">\r\n              <input type=\"checkbox\" ng-model=\"search.lrecommendorder\" ng-true-value=\"\'{{user}}\'\" ng-false-value=\"\'NO\'\" style=\"cursor:pointer;\"> {{user}}\r\n              </label>\r\n                        </li>\r\n                      </ul>\r\n                      <div class=\"DivClass\">\r\n                        <div class=\"leftClass\" style=\"width:8%;\">\r\n                          <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Most Factual\'\" ng-false-value=\"\'NO\'\">\r\n              </div>\r\n                          <div class=\"rightClass\" style=\"width:92%; cursor:pointer;\" ng-click=\"ShowUsers(\'MostFactual\')\">Most\r\n                            Factual&nbsp;<i class=\"fa fa-caret-right\" aria-hidden=\"true\" ng-if=\"!MostFactual\"></i><i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"MostFactual\"></i></div>\r\n                        </div>\r\n                        <ul class=\"TcatList innerCat\" ng-if=\"MostFactual\" style=\"padding-left: 5px; \">\r\n                          <li>As rated by</li>\r\n                          <li ng-repeat=\"user in users track by $index\">\r\n                            <label class=\"checkbox\" title=\"search.factual\" style=\"cursor:pointer;\">\r\n              <input type=\"checkbox\" ng-model=\"search.factualorder\" ng-true-value=\"\'{{user}}\'\" ng-false-value=\"\'NO\'\" style=\"cursor:pointer;\"> {{user}}\r\n              </label>\r\n                          </li>\r\n                        </ul>\r\n                        <div class=\"DivClass\">\r\n                          <div class=\"leftClass\" style=\"width:8%;\">\r\n                            <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Least Factual\'\" ng-false-value=\"\'NO\'\">\r\n              </div>\r\n                            <div class=\"rightClass\" style=\"width:92%; cursor:pointer;\" ng-click=\"ShowUsers(\'LeastFactual\')\" >Least\r\n                              Factual&nbsp;<i class=\"fa fa-caret-right\" aria-hidden=\"true\" ng-if=\"!LeastFactual\"></i><i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"LeastFactual\"></i></div>\r\n                          </div>\r\n                          <ul class=\"TcatList innerCat\" ng-if=\"LeastFactual\" style=\"padding-left: 5px; \">\r\n                            <li>As rated by</li>\r\n                            <li ng-repeat=\"user in users track by $index\">\r\n                              <label class=\"checkbox\" title=\"search.lfactual\" style=\"cursor:pointer;\">\r\n              <input type=\"checkbox\" ng-model=\"search.lfactualorder\" ng-true-value=\"\'{{user}}\'\" ng-false-value=\"\'NO\'\" style=\"cursor:pointer;\"> {{user}}\r\n              </label>\r\n                            </li>\r\n                          </ul>\r\n                        </div>\r\n                        <div style=\"clear:both;\"></div>\r\n                     \r\n	<!-- END OF SORT DETAILS -->	\r\n									\r\n							\r\n					\r\n                  <div class=\"row\">\r\n                    <div class=\"col-lg-3 col-md-3 col-sm-3\">\r\n                      <div style=\"display:flex; flex-direction: row; justify-content: center; align-items: center;\">\r\n                        <label for=\"Search All Essays\" class=\"blackText\">Search All Essays</label>\r\n                        <input type=\"checkbox\"  name=\"chk\" id=\"chk\" ng-model=\"search.chk\" class=\"form-control\" style=\"margin-left:5%\">\r\n                      </div>\r\n\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n\r\n                <!-- <div id=\"tfheader\" class=\"searchbox\" ng-if=\"!ShowAdavace\" style=\"padding-left:10px;\">\r\n            <input type=\"text\" class=\"tftextinput changeTextColor\" ng-model=\"search.text\" name=\"q\" size=\"21\" maxlength=\"120\">\r\n            <input type=\"button\" ng-click=\"getEssayListAdvance(search);\" value=\"Essay Search\" class=\"tfbutton\" style=\"margin-left:-4px;\">\r\n    <div ng-click=\"showadvace();\" class=\"ylink\"\r\n      style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">\r\n      More Search Options</div>\r\n    <div class=\"tfclear\"></div>\r\n  </div>-->\r\n\r\n                <!-- </div> -->\r\n                <!-- bring this back when design is completed -->\r\n                <!-- <div style=\"padding:10px;\"> -->\r\n\r\n                <!--   <div style=\"width:9%; float: right; text-align: center;\" ng-if=\"searchResults.data.length > 0\">\r\n              <span ng-click=\"showOrder()\" class=\"ylink\" >Sort</span>\r\n            </div>\r\n          </div> -->\r\n                <div style=\"clear:both;\"></div>\r\n\r\n                <div style=\"clear:both;\"></div>\r\n                <p ng-if=\"displayMsg && search.text!=\'\'\" class=\"blackText\">Search results for: {{search.text}}</p>\r\n                <div>\r\n                  <!-- <div class=\"jumbotron jumbotron-fluid tempCard\"> -->\r\n                  <div class=\"container blackText\">\r\n                    <div class=\"row\">\r\n                      <div class=\"col-lg-6 col-md-6 col-sm-6\"\r\n                        dir-paginate=\"forumthread in searchResults.data | orderBy:sortValues:isreverse | itemsPerPage : 10\">\r\n                        <!-- <div\r\n                                          > -->\r\n                        <!-- <div style=\"background-color: #eee; padding:10px; border: solid 1px #000;\" ng-repeat=\"forumthread in searchResults | orderBy:sortValues:isreverse\" ng-if=\"searchResults.length > 0\"> -->\r\n                        <div class=\"jumbotron jumbotron-fluid infoCard\">\r\n                          <div class=\"container\">\r\n                            <div style=\"width:100%; float: left;\">\r\n                              <div class=\"boldbox\">\r\n                                <!-- <span ng-click=\"gotoThread(forumthread._id);\" class=\"link\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">{{forumthread.title}}</span>  -->\r\n                                <a href=\"#!/essayDetails/{{categoryId}}/{{forumthread._id}}\" class=\"elink\">{{forumthread.title}}</a>\r\n                                <div class=\"DescriptionImg\" ng-bind-html=\'forumthread.description | urlifyshort\'>\r\n                                </div>\r\n\r\n                              </div>\r\n                              <br>\r\n                              <div><strong>Recommended :</strong>\r\n                                <input-stars max=\"5\" ng-model=\"forumthread.recavg\" ng-if=\"showAvg\" readonly>\r\n                                </input-stars>\r\n                                <input-stars max=\"5\" ng-model=\"forumthread.recavgvoters\" ng-if=\"showVoters\" readonly>\r\n                                </input-stars>\r\n                                <input-stars max=\"5\" ng-model=\"forumthread.recavgpolitician\" ng-if=\"showPolitician\"\r\n                                  readonly>\r\n                                </input-stars>\r\n                                <input-stars max=\"5\" ng-model=\"forumthread.recavgadvocate\" ng-if=\"showAdvocate\"\r\n                                  readonly>\r\n                                </input-stars>\r\n                                <input-stars max=\"5\" ng-model=\"forumthread.recavgpress\" ng-if=\"showPress\" readonly>\r\n                                </input-stars>\r\n                                <input-stars max=\"5\" ng-model=\"forumthread.recavgfollow\" ng-if=\"showFollow\" readonly>\r\n                                </input-stars>\r\n                                , <strong>Factual :</strong>\r\n                                <input-stars max=\"5\" ng-model=\"forumthread.factfavg\" ng-if=\"showfAvg\" readonly>\r\n                                </input-stars>\r\n                                <input-stars max=\"5\" ng-model=\"forumthread.factfavgvoters\" ng-if=\"showfVoters\" readonly>\r\n                                </input-stars>\r\n                                <input-stars max=\"5\" ng-model=\"forumthread.factfavgpolitician\" ng-if=\"showfPolitician\"\r\n                                  readonly>\r\n                                </input-stars>\r\n                                <input-stars max=\"5\" ng-model=\"forumthread.factfavgadvocate\" ng-if=\"showfAdvocate\"\r\n                                  readonly>\r\n                                </input-stars>\r\n                                <input-stars max=\"5\" ng-model=\"forumthread.factfavgpress\" ng-if=\"showfPress\" readonly>\r\n                                </input-stars>\r\n                                <input-stars max=\"5\" ng-model=\"forumthread.factfavgfollow\" ng-if=\"showfFollow\" readonly>\r\n                                </input-stars>\r\n\r\n                              </div>\r\n                     <!--         <a href=\"\" class=\"link\" ng-if=\"userRole == \'advocate\'\" ng-click=\"highlight(forumthread._id)\">Highlight</a> -->\r\n                              <hr>\r\n                              <div style=\"clear:both;\">\r\n                                <!-- {{forumthread}} -->\r\n                                Posted by\r\n                                <a ng-if=\"forumthread.createdBy.utype == \'advocate\' && forumthread.createdBy.userInfo.isEmailVerified && forumthread.createdBy.userInfo.verifiedUser\" href=\"#!/pressProfile/{{forumthread.createdBy.id}}\" class=\"link\" style=\"text-transform: capitalize;\">\r\n                                    {{forumthread.createdBy.orgdata.title}}\r\n               <!--                     <span ng-if=\"forumthread.createdBy.orgdata\">({{forumthread.createdBy.orgdata.title}})</span> -->\r\n                                    </a>\r\n                                <b ng-if=\"!forumthread.createdBy.userInfo.isEmailVerified ||!forumthread.createdBy.userInfo.verifiedUser\">{{forumthread.createdBy.userInfo.tempName}}</b>\r\n\r\n                                <a ng-if=\"forumthread.createdBy.utype == \'politician\'\" href=\"#!/publicProfile/{{forumthread.createdBy.id}}\" class=\"link\" style=\"text-transform: capitalize;\">\r\n                                      {{forumthread.createdBy.orgdata.title}}\r\n                                      <span ng-if=\"forumthread.createdBy.orgdata\">({{forumthread.createdBy.orgdata.title}})</span>\r\n                                      </a> on {{forumthread.createdOn | date:\'medium\'}}\r\n                              </div>\r\n                            </div>\r\n                            <div style=\"width:9%; float: left; text-align: center;\"\r\n                              ng-if=\"userRole==\'admin\' || forumthread.createdBy.id==userId\">\r\n                              <span ng-click=\"GotoEdit(forumthread._id);\" style=\"text-decoration: underline; cursor: pointer;\">Edit</span>&nbsp;&nbsp;<span ng-click=\"removeEssay(forumthread, $index, \'A\');\" style=\"text-decoration: underline; cursor: pointer;\">Remove</span>\r\n                            </div>\r\n                            <div style=\"clear:both;\"></div>\r\n                          </div>\r\n\r\n                        </div>\r\n                      </div>\r\n                      <!-- </div> -->\r\n\r\n                      <div style=\"float: right;width:100%\">\r\n                        <div style=\"float:right; min-width: 30%;\">\r\n                          <dir-pagination-controls max-size=\"5\" class=\"changeTextColor\"></dir-pagination-controls>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n\r\n                  </div>\r\n\r\n                  <!-- </div> -->\r\n\r\n                  <div style=\"background-color: #eee; padding:10px; border: solid 1px #000; height:100px; color:#000;\"\r\n                    ng-if=\"searchResults.data.length == 0\">\r\n                    No records found.\r\n                  </div>\r\n\r\n                </div>\r\n\r\n                <!-- <div style=\"padding-right:30px; float:right; min-width: 30%;\" class=\"changeTextColor\">\r\n                      <dir-pagination-controls max-size=\"5\" class=\"changeTextColor\"></dir-pagination-controls>\r\n                    </div> -->\r\n\r\n\r\n\r\n\r\n\r\n                <script type=\"text/ng-template\" id=\"field_renderer\">\r\n               <ul class=\"TcatList\" >\r\n      <li class=\"catname\" id=\"{{subent._id}}\" ng-if=\"(subent.parentIds.length == 0) && (subent.subcategories)\" style=\"padding-left: 10px;\">\r\n        <input type=\"checkbox\" ng-click=\"getVal(subent)\" style=\"cursor: pointer;\">\r\n        <label ng-click=\"ChangeShow(subent._id);\" style=\"cursor: pointer;\">{{::subent.title}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id)==-1\"></i><i class=\"fa fa-caret-right\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id) > -1\"></i></label>\r\n      </li>\r\n      <li class=\"catname\" ng-if=\"(subent.parentIds.length == 0) && (!subent.subcategories)\">\r\n        <label class=\"checkbox\" title=\"{{subent.title}}\" style=\"cursor: pointer;\">\r\n          <input type=\"checkbox\" ng-click=\"getVal(subent)\" style=\"cursor: pointer;\"> {{::subent.title}}\r\n        </label>\r\n      </li>\r\n      <label class=\"checkbox\" ng-if=\"subent.parentIds.length > 0 && showSubCat\" title=\"{{subent.title}}\" style=\"cursor: pointer;\">\r\n        <input type=\"checkbox\" ng-click=\"getVal(subent)\" style=\"cursor: pointer;\"> {{::subent.title}}\r\n      </label>\r\n      <ul ng-if=\"subent.subcategories && showSubs[subent._id]\" ng-class=\"subent.parentIds.length == 0 ? \'cmnUL MainCatLi_{{subent._id}}\' : \'\'\" style=\"padding-left: 25px;\">\r\n        <li ng-repeat=\"subent in subent.subcategories track by $index\" ng-include=\"\'field_renderer\'\" style=\"cursor: pointer;\" >\r\n          <!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                      <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n                    </label> -->\r\n        </li>\r\n      </ul>\r\n\r\n  </ul>\r\n</script>\r\n");
$templateCache.put("app/essayDetails/essayDetails.html","<div>\r\n  <p><a href=\"#!/learnHome\" class=\"ylink\">Essay</a> >\r\n    <a href=\"#!/essay/{{categoryId}}/home\" class=\"ylink\"> {{category.title}} </a> </p>\r\n</div>\r\n<p>\r\n  <h2>\r\n    <center>{{essay.title}}</center>\r\n  </h2>\r\n</p>\r\n<div class=\"inline2\">\r\n  <p class=\"DescrImg\" ng-if=\"essay.mediaType==\'Text\'\" ng-bind-html=\"essay.description |  urlify\"></p>\r\n  <div ng-if=\"essay.mediaType!=\'Text\'\">\r\n    <p class=\"DescrImg\">{{essay.description}}</p>\r\n    <p></p>\r\n    <div ng-if=\"essay.mediaType==\'Video\'\" ng-bind-html=\'CheckUrl(essay.mediaFile, \"V\")\' style=\"text-align:center;\">\r\n    </div>\r\n    <div ng-if=\"essay.mediaType==\'Audio\'\" ng-bind-html=\'CheckUrl(essay.mediaFile, \"A\")\' style=\"text-align:center;\">\r\n    </div>\r\n    <p ng-if=\"essay.mediaType==\'Stills\'\" style=\"text-align: center;\">\r\n      <img ng-src=\"{{GalleryFolder}}/{{essay.mediaFile}}\" />\r\n        </p>\r\n  </div>\r\n  <!-- Geo Proximity tab -->\r\n</div>\r\n<div style=\"clear:both;\"></div>\r\n<div>\r\n  <hr size=\"5\" style=\"height:2px;border-width:0;color:gray;background-color:gray\">\r\n  <h3>Rate it: </h3>\r\n  <div ng-if=\"uData.isemailverified\">\r\n    <p>Recommended :\r\n      <input-stars max=\"5\" ng-click=\"EssayVote(\'Recommended\');\" ng-model=\"vote.recommend\"></input-stars>\r\n      <br/>Factual :\r\n      <input-stars max=\"5\" ng-click=\"EssayVote(\'Factual\');\" ng-model=\"vote.factual\"></input-stars>\r\n    </p>\r\n  </div>\r\n</div>\r\n<div ng-if=\"!uData.isemailverified\" style=color:red>\r\n  <center>\r\n    <p>Confirm your Email to Rate Essay</p>\r\n  </center>\r\n</div>\r\n<div style=\"clear:both;\"></div>\r\n<div>\r\n  <div ng-if=\"!uData.isemailverified\" style=color:red>\r\n    <center>\r\n      <p>Confirm your Email to Add Comments</p>\r\n    </center>\r\n  </div>\r\n  <div ng-if=\"uData.isemailverified\">\r\n    <hr size=\"5\" style=\"height:2px;border-width:0;color:gray;background-color:gray\"> Comments:\r\n    <center>\r\n      <button ng-click=\"redirectToComment();\" ng-if=\"displayComments\" class=\"compareBtn\">Add comment</button>\r\n    </center>\r\n  </div>\r\n  <div ng-if=\"ShowComments\">\r\n    <form name=\"essayform\" id=\"essayform\">\r\n      <fieldset class=\"scheduler-border\">\r\n        <legend class=\"scheduler-border\">Your Comments</legend>\r\n        <p></p>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <div class=\"control-group\">\r\n              <div class=\"controls\">\r\n                <textarea id=\"comments\" ng-model=\"comments.content\" placeholder=\"\" data-errormessage=\"Comments is required.\" class=\"form-control input-md  validate[required] text-area\"></textarea>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div style=\"clear: both;\"></div>\r\n          <div style=\"margin-top:20px;\">\r\n            <button ng-click=\"SubmitComment(comments)\" type=\"button\" class=\"btn btn-success\" ng-disabled=\"CommentButton\" style=\"float: left;\">Submit Comments</button>\r\n            &nbsp;&nbsp;&nbsp;&nbsp;\r\n            <button ng-click=\"goBack();\" type=\"button\" style=\"float: left;\" class=\"changeTextColor\">Cancel</button>\r\n            <div style=\"clear: both;\"></div>\r\n          </div>\r\n          <div style=\"clear: both;\"></div>\r\n        </div>\r\n      </fieldset>\r\n    </form>\r\n  </div>\r\n  <script type=\"text/ng-template\" id=\"templateId\">\r\n        <fieldset class=\"scheduler-border\">\r\n            <legend class=\"scheduler-border\">Update reply</legend>\r\n            <p></p>\r\n            <div class=\"row\">\r\n                <div class=\"col-md-12\">\r\n                    <div class=\"control-group\">\r\n                        <div class=\"controls\">\r\n                            <textarea id=\"description\" ng-model=\"editDescription.description\" placeholder=\"\" data-errormessage=\"Description is required.\" class=\"form-control input-md  validate[required] text-area\" style=\"width:95%; height:250px;\"></textarea>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div style=\"clear: both;\"></div>\r\n                <div style=\"margin-top:20px;\">\r\n                    <button ng-click=\"UpdateReply(editDescription)\" type=\"button\" class=\"btn btn-success\" style=\"float: left;\">Update Reply</button>\r\n                    &nbsp;&nbsp;&nbsp;&nbsp;\r\n                    <button ng-click=\"closeThisDialog(\'templateId\');\" type=\"button\" style=\"float: left;\">Cancel</button>\r\n                    <div style=\"clear: both;\"></div>\r\n                </div>\r\n                <div style=\"clear: both;\"></div>\r\n            </div>\r\n        </fieldset>\r\n        </form>\r\n    </script>\r\n</div>\r\n<div>\r\n  <table style=\"width:100%; color:black;\" ng-repeat=\"comment in essayComments track by $index\">\r\n    <tr>\r\n      <th colspan=\"2\">{{comment.createdOn | date:\'medium\'}}</th>\r\n    </tr>\r\n    <tr>\r\n      <td width=\"10%;\">\r\n        <img src=\"../assets/images/profile/{{comment.createdBy.utype}}.svg\" style=\"width: 30px; height:30px;\" class=\"usertype\" alt=\"Politician\" ng-if=\"comment.createdBy.utype!=\'admin\'\" />\r\n        <img src=\"../assets/images/profile/voter.svg\" style=\"width: 30px; height:30px;\" class=\"usertype\" alt=\"Politician\" ng-if=\"comment.createdBy.utype==\'admin\'\" />\r\n        <br>\r\n        <a ng-if=\"comment.createdBy.utype == \'politician\' && comment.createdBy.userData.isEmailVerified && comment.createdBy.userData.verifiedUser && comment.createdBy.userData.nameOnBallot\" href=\"#!/publicProfile/{{comment.createdBy.id}}\" style=text-decoration:underline><b>\r\n                    {{comment.createdBy.userData.nameOnBallot}}</b>\r\n\r\n                </a>\r\n        <a ng-if=\"comment.createdBy.utype == \'politician\' && comment.createdBy.userData.isEmailVerified && comment.createdBy.userData.verifiedUser && !comment.createdBy.userData.nameOnBallot\" href=\"#!/publicProfile/{{comment.createdBy.id}}\" style=text-decoration:underline><b>\r\n                  {{comment.createdBy.name}}</b>\r\n\r\n              </a>\r\n        <a ng-if=\"comment.createdBy.utype == \'advocate\' && comment.createdBy.userData.isEmailVerified && comment.createdBy.userData.verifiedUser\" href=\"#!/pressProfile/{{comment.createdBy.id}}\" style=text-decoration:underline>\r\n                  <span ng-if=\"comment.createdBy.orgdata\" style=\"text-decoration:underline; text-transform: capitalize;\"><b>{{comment.createdBy.orgdata.title}}</b></span></a>\r\n        <a ng-if=\"comment.createdBy.utype == \'voter\'\" href=\"#!/voterProfile/{{comment.createdBy.id}}\" style=text-decoration:underline>\r\n                  <span style=\"text-decoration:underline; text-transform: capitalize;\"><b>{{comment.createdBy.name}}</b></span></a>\r\n        <span ng-if=\"!comment.createdBy.userData.isEmailVerified || !comment.createdBy.userData.verifiedUser\">\r\n                   {{comment.createdBy.userData.tempName}}\r\n                  </span>\r\n\r\n      </td>\r\n      <td>\r\n        <div ng-if=\"comment && comment.spam.length != 3\" ng-bind-html=\'comment.comments | urlify\'></div>\r\n        <br>\r\n        <div ng-if=\"uData.isemailverified && comment && comment.spam.length != 3\">\r\n          <div style=\"text-align: left;\">\r\n            <i class=\"fa fa-thumbs-up thumbs\" ng-click=\"updateComments(\'like\', comment._id, $index);\" style=\"cursor:pointer;\"  style=\"cursor:pointer;\" alt=\"Like\">\r\n            {{comment.totalLikes}}</i>\r\n            <i class=\"fa fa-thumbs-down thumbs\" ng-click=\"updateComments(\'dislike\', comment._id, $index);\" style=\"cursor:pointer;\" style=\"cursor:pointer;\" alt=\"Dislike\">\r\n            {{comment.totalDislike}}</i>\r\n            <i class=\"fa fa-exclamation-triangle thumbs\"ng-click=\"updateComments(\'spam\', comment._id, $index);\" style=\"cursor:pointer; color:red;\" alt=\"Report Abuse\">\r\n            {{comment.totalSpam}}</i>\r\n            <span style=\"float:right;\">\r\n                        <span ng-click=\"editComments(comment)\" ng-if=\"comment.createdBy.id == $root.UserId || userType==\'admin\'\" style=\"cursor:pointer;\" class=\"link\">Edit</span>&nbsp;\r\n            <span ng-click=\"removeComments(comment)\" ng-if=\"comment.createdBy.id == $root.UserId || userType==\'admin\'\" style=\"cursor:pointer;\" class=\"link\">Remove</span>&nbsp;\r\n            &nbsp;&nbsp;\r\n            </span>\r\n          </div>\r\n        </div>\r\n        <div ng-if=\"comment && comment.spam.length == 3\" style=\"color: red;\">\r\n          <div ng-click=\"DisplaySpam(comment._id)\" style=\"text-decoration:underline; cursor:pointer;\">This\r\n            comment\r\n            is reported as spam or abusive.</div>\r\n          <br/>\r\n          <small ng-if=\"userType==\'admin\' || showSpam.indexOf(comment._id) > -1\"><div ng-bind-html=\'comment.comments | urlify\'></div></small>\r\n          <div ng-if=\"userType==\'admin\'\" style=\"float: right;\">\r\n            <span ng-click=\"sendMessage(comment)\" style=\"cursor:pointer; text-decoration: underline;\">Send message to {{comment.createdBy.name}} </span>&nbsp;&nbsp;&nbsp;\r\n            <span ng-click=\"removeComments(comment)\" style=\"cursor:pointer; text-decoration: underline;\" class=\"link\">Remove</span>&nbsp;&nbsp;&nbsp;<span ng-click=\"notSpam(comment)\" style=\"cursor:pointer; text-decoration: underline;\" class=\"link\">Not a spam</span>\r\n          </div>\r\n        </div>\r\n\r\n      </td>\r\n    </tr>\r\n  </table>\r\n</div>\r\n<script type=\"text/ng-template\" id=\"popUp\">\r\n  <div class=\"container\">\r\n   <p ng-if=\"showBoth && $root.userRole==\'politician\'\">You can read, but you can\'t write anything on the site until you confirm your email address.  <br><br> After you confirm your email, you can write, but everything will have the byline \"Unknown Politician\" until we can confirm your identification (then all your work will change to your byline).  You can wait for us to research you or you can use our automated ID confirmation system (which costs $1)</p>\r\n			<p ng-if=\"showBoth && $root.userRole==\'advocate\'\">You can read, but you can\'t write anything on the site until you confirm your email address.  <br><br> After you confirm your email, you can write, but everything will have the byline \"Unknown Organization\" until we can confirm your identification (then all your work will change to your byline).</p>\r\n   <p ng-if=\"showEm\">You can read, but you can\'t write anything on the site until you confirm your email address.</p>\r\n   <p ng-if=\"showCon && !showBoth && !showEm && $root.userRole==\'politician\'\">We still need to confirm you are who you say you are. If you are running for a large office, we will do the research to figure that out.  If you are running for a more local office and you don\'t want to wait for us, you can use the automated ID check which costs $1.</p>\r\n\r\n   <div class=\"ngdialog-buttons\">\r\n   <button  ng-click=\"sendMail()\" type=\"button\" class=\"ngdialog-button ngdialog-button-primary\" ng-if=\"showEm  || (showBoth && $root.userRole==\'politician\')\">Resend Confirmation Email</button>\r\n   <button ng-click=\"goto()\" ng-if=\"showCon && $root.userRole==\'politician\'\" type=\"button\" class=\"ngdialog-button ngdialog-button-primary\">Confirm Id</button>\r\n   <button ng-click=\"closeIt()\" type=\"button\" class=\"ngdialog-button ngdialog-button-primary\">Later</button>\r\n   </div>\r\n  </div>\r\n\r\n\r\n\r\n</script>\r\n<script type=\"text/ng-template\" id=\"sendMessage\">\r\n  <div>\r\n      <div class=\"catname\">\r\n          <div>Message :</div>\r\n          <div>\r\n              <textarea ng-model=\"spamMessage\" style=\"width:100%; height:100px;\"></textarea>\r\n          </div>\r\n      </div>\r\n      <div class=\"ngdialog-buttons\">\r\n          <button type=\"button\" class=\"ngdialog-button ngdialog-button-primary\" ng-click=\"sendMail(spamMessage)\">Send</button>\r\n          <button type=\"button\" class=\"ngdialog-button ngdialog-button-secondary\" ng-click=\"closeThisDialog(0)\">Cancel</button>\r\n      </div>\r\n  </div>\r\n</script>\r\n");
$templateCache.put("app/essayList/essayList.html","<link rel=\"stylesheet\" type=\"text/css\" href=\"./essayList/essayList.css\">\r\n  <div class=\"geobox\">\r\n    <p>\r\n      <a href=\"#!/learnHome\">Essay</a> >\r\n      <a href=\"#!/essay/{{categoryId}}/{{type}}\"> {{category.title}} </a> > {{subcategory.title}}\r\n    </p>\r\n  </div>\r\n\r\n  <p><h2><center>{{subcategory.title}}</center></h2></p>\r\n    \r\n  <!-- Geo Proximity tab -->    \r\n  <!--<div class=\"geobox\">\r\n  <form action=\"\"><fieldset>\r\n      <legend>Choose</legend>\r\n      <input type=\"radio\" name=\"geographic-focus\" value=\"national\" checked /> National\r\n      <input type=\"radio\" name=\"geographic-focus\" value=\"state\"> State\r\n      <input type=\"radio\" name=\"geographic-focus\" value=\"county\"> County\r\n      <input type=\"radio\" name=\"geographic-focus\" value=\"local\"> Local<br>\r\n      </fieldset>\r\n  </form>\r\n      </div>\r\n    <div class=\"geobox\">\r\n      <form>\r\n   \r\n  Skip to: <br>\r\n  <select name=\"SUBJECT\">\r\n    <option value=\"CivilLiberties\">Civil Liberties</option>\r\n    <option value=\"Crime\">Crime and Punishment</option>\r\n    <option value=\"Education\">Education</option>\r\n    <option value=\"Energy\">Energy</option>\r\n    <option value=\"Environment\">Environment</option>\r\n    <option value=\"Gun\">Gun Control</option>\r\n    <option value=\"Health\">Health and Safety</option>\r\n    <option value=\"Immigration\">Immigration</option>\r\n    <option value=\"Infrastructure\">Infrastructure</option>\r\n    <option value=\"International\">International Relations</option>\r\n    <option value=\"Jobs\">Jobs and the Economy</option>\r\n    <option value=\"Quality\">Quality of Life</option>\r\n    <option value=\"Reproduction\">Reproduction</option>\r\n    <option value=\"Social\">Social Services</option>\r\n    <option value=\"Taxes\">Taxes</option>\r\n    <option class=\"select-dash\" disabled=\"disabled\">----</option>\r\n      <option value=\"Conspiracy\">Conspiracy Corner</option>\r\n  </select>\r\n      </form>\r\n      </div>\r\n  <button class=\"geobox\">Change Location</button>\r\n      \r\n    <div id=\"tfheader\" class=\"searchbox\">\r\n      <form id=\"tfnewsearch\" method=\"get\" action=\"http://www.google.com\">\r\n              <input type=\"text\" class=\"tftextinput\" name=\"q\" size=\"21\" maxlength=\"120\"><input type=\"submit\" value=\"Forum Search\" class=\"tfbutton\">\r\n      </form>\r\n    <div class=\"tfclear\"></div>\r\n    </div>\r\n    <br><br>\r\n  -->\r\n  <a href=\"#!/newEssay/{{categoryId}}/{{subcategoryId}}\">Add new essay</a>\r\n\r\n  <br><br>\r\n\r\n  <div class=\"inline2\">\r\n    <table style=\"width:100%\">\r\n      <tr>\r\n        <th>Essay</th>\r\n      </tr>\r\n      <!--<tr ng-repeat=\"key in objectKeys(DisplayData)\" ng-init=\"post = DisplayData[key]\"> -->\r\n      <tr ng-repeat=\"post in DisplayData\" ng-if=\"post._id\"> \r\n        <td>\r\n          <span ng-click=\"gotoThread(post._id);\" style=\"cursor:pointer;\">\r\n            <image src=\"../assets/images/ideas.svg\" class=\"usertype\"></image>\r\n            {{post.title}}\r\n            <br>Original Post by\r\n            <img src=\"../assets/images/VOTERbutton.svg\" class=\"usertype\">\r\n            <a href =\"#!/publicProfile/{{post.createdBy.id}}\">{{post.createdBy.name}} </a>\r\n          </span>\r\n          <br>on {{post.updatedOn | date:\'medium\'}}\r\n        </td>\r\n      </tr>\r\n    </table> \r\n  </div>\r\n    \r\n\r\n<!--<div class=\"boxed\">\r\n    <center><h2>Local Threads</h2></center>\r\n    <p>  This is to be implemented. </p>\r\n    </div>-->");
$templateCache.put("app/essaySearch/essaySearch.html","<link rel=\"stylesheet\" type=\"text/css\" href=\"./essaySearch/essaySearch.css\">\r\n<div style=\"width: 100%;\">\r\n    <p>\r\n        <h2><center>Search</center></h2></p>\r\n    <div id=\"tfheader\" class=\"searchbox\" ng-if=\"!ShowAdavace\" style=\"padding-left:10px;\">\r\n        <input type=\"text\" class=\"tftextinput\" ng-model=\"search.text\" name=\"q\" size=\"21\" maxlength=\"120\">\r\n        <input type=\"button\" ng-click=\"getEssayListAdvance(search);\" value=\"Essay Search\" class=\"tfbutton\" style=\"margin-left:-4px;\">\r\n        <div ng-click=\"showadvace();\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">More Search Options</div>\r\n        <div class=\"tfclear\"></div>\r\n    </div>\r\n    <div id=\"tfheader\" class=\"searchbox\" ng-if=\"ShowAdavace\" style=\"padding-left:10px;\">\r\n        <form name=\"searchform\" id=\"searchform\" method=\"post\" action=\"submit.action\">\r\n            <div class=\"DivClassLeft\">Search for</div>\r\n            <div class=\"DivClassRight\">\r\n                <input type=\"text\" ng-model=\"search.text\" name=\"q\" size=\"21\" maxlength=\"120\">\r\n            </div>\r\n            <div style=\"clear:both;\"></div>\r\n            <div>\r\n                <div class=\"DivClassLeft\">Refine : </div>\r\n                <div class=\"DisplayCat\">\r\n                    <div class=\"DivClass\">\r\n                        <div class=\"leftClass\">\r\n                            <input type=\"checkbox\" ng-model=\"search.subject\" ng-true-value=\"\'Subject of Interest\'\" ng-false-value=\"\'NO\'\">\r\n                        </div>\r\n                        <div class=\"rightClass\" ng-click=\"showRefine($event, \'Interest\');\">\r\n                            Subject of Interest&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"!ShowSubcatTree\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"ShowSubcatTree\"></i></div>\r\n                    </div>\r\n                    <div ng-repeat=\"subent in subtopics.subcategories track by $index\" ng-include=\"\'field_renderer\'\">Loading...</div>\r\n                    <div class=\"DivClass\">\r\n                        <div class=\"leftClass\">\r\n                            <input type=\"checkbox\" ng-model=\"search.Locations\" ng-true-value=\"\'Location\'\" ng-false-value=\"\'NO\'\">\r\n                        </div>\r\n                        <div class=\"rightClass\" ng-click=\"showRefine($event, \'Location\');\">\r\n                            Location&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"!showLoadingLocation\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingLocation\"></i></div>\r\n                    </div>\r\n                    <ul class=\"catList innerCat\" ng-if=\"showRefineLocation\">\r\n                        <li ng-repeat=\"local in Location track by $index\">\r\n                            <input type=\"checkbox\" ng-click=\"SelectDefaultLocation(local)\" ng-true-value=\"\'{{local}}\'\" ng-false-value=\"\'NO\'\">\r\n                            <label class=\"checkbox\" ng-if=\"local!=\'Other Specific\'\" title=\"{{local}}\"> {{local}}&nbsp;</label>\r\n                            <label class=\"checkbox\" ng-if=\"local==\'Other Specific\'\" ng-click=\"showRefine($event, \'AllLocation\')\" title=\"{{local}}\"> {{local}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"!ShowStateLoader\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"ShowStateLoader\"></i></label>\r\n                            <!-- Select Location Start -->\r\n                            <ul class=\"catList innerCat\" ng-if=\"local==\'Other Specific\' && showRefineLocation && showStates\">\r\n                                <li ng-repeat=\"area in allLocations track by $index\">\r\n                                    <input type=\"checkbox\" ng-click=\"selectLocation(area, area.state, area.statePostalCode, \'state\')\">\r\n                                    <label ng-click=\"getCounties(area.statePostalCode, \'location\')\">{{area.state}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoading.indexOf(area.statePostalCode)==-1\"></i> <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoading.indexOf(area.statePostalCode) > -1\"></i></label>\r\n                                    <!-- Display Counties -->\r\n                                    <ul class=\"catList innerCat\">\r\n                                        <li ng-repeat=\"county in allCounties[area.statePostalCode] track by $index\">\r\n                                            <input type=\"checkbox\" ng-click=\"selectLocation(area, county._id, county._id.county, \'county\')\">\r\n                                            <label ng-click=\"getLocals(area.statePostalCode, county._id.county, \'location\')\">{{county._id.county}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoadingCounty.indexOf(county._id.county) == -1\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingCounty.indexOf(county._id.county) > -1\"></i></label>\r\n                                            <!-- Display Locals and sub counties -->\r\n                                            <ul class=\"catList innerCat\" ng-if=\"Essay.location!=\'National\'\">\r\n                                                <li ng-repeat=\"local in allLocals[area.statePostalCode][county._id.county] track by $index\">\r\n                                                    <label class=\"checkbox\" title=\"{{local._id.place}}\">\r\n                                                        <input type=\"checkbox\" ng-click=\"selectLocation(area, county._id.county, local._id, \'local\')\"> {{local._id.countySubdivision}} - {{local._id.place}}\r\n                                                    </label>\r\n                                                </li>\r\n                                            </ul>\r\n                                            <!-- Display Locals and sub counties End -->\r\n                                        </li>\r\n                                    </ul>\r\n                                    <!-- Display Counties End -->\r\n                                </li>\r\n                            </ul>\r\n                            <!-- Select Location End -->\r\n                        </li>\r\n                    </ul>\r\n                    \r\n\r\n                    <!-- Select Media Type Start -->\r\n<!--\r\n                    <div class=\"DivClass\">\r\n                        <div class=\"leftClass\">\r\n                            <input type=\"checkbox\" ng-model=\"search.mediaType\" ng-true-value=\"\'MediaType\'\" ng-false-value=\"\'NO\'\">\r\n                        </div>\r\n                        <div class=\"rightClass\" ng-click=\"showRefine($event, \'Media\');\">\r\n                            Media Type&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"!showLoadingMedia\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingMedia\"></i></div>\r\n                    </div>\r\n                    <ul class=\"catList innerCat\" ng-if=\"showmediaType\">\r\n                        <li ng-repeat=\"media in mediaType track by $index\">\r\n                            <label class=\"checkbox\" title=\"{{search.mediaoption}}\">\r\n                                <input type=\"checkbox\" ng-model=\"search.mediaoption[$index]\" ng-true-value=\"\'{{media}}\'\" ng-false-value=\"\"> {{media}}\r\n                            </label>\r\n                        </li>\r\n                    </ul>\r\n-->\r\n                    <!-- Select Media Type End -->\r\n                    <!-- Select Date Range Start -->\r\n                    <div class=\"DivClass\">\r\n                        <div class=\"leftClass\">\r\n                            <input type=\"checkbox\" ng-model=\"search.DateRange\" ng-true-value=\"\'DateRange\'\" ng-false-value=\"\'NO\'\">\r\n                        </div>\r\n                        <div class=\"rightClass\" ng-click=\"showRefine($event, \'Date\');\">\r\n                            Date Range&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"!showLoadingMedia\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingMedia\"></i></div>\r\n                    </div>\r\n                    <ul class=\"catList innerCat\" ng-if=\"showDateRange\">\r\n                        <li ng-repeat=\"range in dateRange track by $index\">\r\n                            <label class=\"checkbox\" title=\"search.dateoption\">\r\n                                <input type=\"checkbox\" ng-model=\"search.dateoption\" ng-true-value=\"\'{{range}}\'\" ng-false-value=\"\'NO\'\"> {{range}}\r\n                            </label>\r\n                        </li>\r\n                        <li>\r\n                            <input type=\"checkbox\" ng-model=\"search.dateoption\" ng-true-value=\"\'Before\'\" ng-false-value=\"\'NO\'\">\r\n                            <label class=\"checkbox\">Before\r\n                                <input type=\"date\" ng-model=\"search.dateBefore\">\r\n                            </label>\r\n                        </li>\r\n                        <li>\r\n                            <input type=\"checkbox\" ng-model=\"search.dateoption1\" ng-true-value=\"\'After\'\" ng-false-value=\"\'NO\'\">\r\n                            <label class=\"checkbox\">After\r\n                                <input type=\"date\" ng-model=\"search.dateAfter\">\r\n                            </label>\r\n                        </li>\r\n                    </ul>\r\n                    <!-- Select Date Range End -->\r\n                    <!-- Match to author Start -->\r\n                    <div class=\"DivClass\">\r\n                        <div class=\"leftClass\">\r\n                            <input type=\"checkbox\" ng-model=\"search.matchauthor\" ng-true-value=\"\'Before\'\" ng-false-value=\"\'NO\'\">\r\n                        </div>\r\n                        <div class=\"rightClass\" ng-click=\"showRefine($event, \'Author\');\">Match to Author&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"!showLoadingMedia\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingMedia\"></i></div>\r\n                    </div>\r\n                    <ul class=\"catList\" ng-if=\"showMatchAuthor\">\r\n                        <li> Authors who match you between\r\n                            <input type=\"text\" class=\"numberText\" ng-model=\"search.matchFrom\" id=\"matchFrom\" data-errormessage=\"Please enter only numbers.\" maxlength=\"2\" size=\"2\" /> and\r\n                            <input type=\"text\" class=\"numberText\" ng-model=\"search.matchTo\" id=\"matchTo\" data-errormessage=\"Please enter only numbers.\" maxlength=\"2\" size=\"2\" /> percent\r\n                        </li>\r\n                    </ul>\r\n                    <!-- Match to author End -->\r\n                    <div class=\"DivClass\">\r\n                        <input type=\"checkbox\" ng-model=\"search.fromfollowlist\" ng-true-value=\"\'YES\'\" ng-false-value=\"\'NO\'\"> Authors on my follow list</div>\r\n                    <!-- User Rated Start -->\r\n                    <div class=\"DivClass\">\r\n                        <div class=\"leftClass\">\r\n                            <input type=\"checkbox\" ng-model=\"search.essayRating\" ng-true-value=\"\'Rating\'\" ng-false-value=\"\'NO\'\"> </div>\r\n                        <div class=\"rightClass\" ng-click=\"showRefine($event, \'EssayRated\');\"> Essay Rating&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"!showLoadingMedia\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingMedia\"></i></div>\r\n                    </div>\r\n                    <ul class=\"catList innerCat\" ng-if=\"showEssayRating\">\r\n                        <li>\r\n                            <input type=\"checkbox\" ng-model=\"search.Recommended\" ng-true-value=\"\'Recommended\'\" ng-false-value=\"\'NO\'\"> Recommended -\r\n                            <input type=\"text\" class=\"numberText\" ng-model=\"search.recommendFrom\" maxlength=\"2\" size=\"2\" /> and\r\n                            <input type=\"text\" class=\"numberText\" ng-model=\"search.recommendTo\" maxlength=\"2\" size=\"2\" /> percent\r\n                        </li>\r\n                        <li>\r\n                            <input type=\"checkbox\" ng-model=\"search.Factual\" ng-true-value=\"\'Factual\'\" ng-false-value=\"\'NO\'\"> Factual -\r\n                            <input type=\"text\" class=\"numberText\" ng-model=\"search.factualFrom\" maxlength=\"2\" size=\"2\" /> and\r\n                            <input type=\"text\" class=\"numberText\" ng-model=\"search.factualTo\" maxlength=\"2\" size=\"2\" /> percent\r\n                        </li>\r\n                    </ul>\r\n                    <!-- User Rated End -->\r\n                </div>\r\n                <div style=\"clear:both;\"></div>\r\n            </div>\r\n            <div style=\"clear:both;\"></div>\r\n        </form>\r\n        <div class=\"DivClassLeft\">&nbsp;</div>\r\n        <div class=\"DivClassRight\">\r\n            <input type=\"button\" ng-click=\"getEssayListAdvance(search);\" value=\"Essay Search\" class=\"tfbuttonNew\">\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n    </div>\r\n</div>\r\n<br>\r\n<br>\r\n<br>\r\n<div style=\"padding:10px;\">\r\n    <div style=\"width:90%; float: left;\">\r\n        <a href=\"#!/newEssay\" ng-if=\"userRole!=\'voter\'\">Add new essay</a>\r\n    </div>\r\n    <div style=\"width:9%; float: left; text-align: center;\" ng-if=\"searchResults.data.length > 0\">\r\n        <span ng-click=\"showOrder()\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">Sort</span>\r\n    </div>\r\n    <div style=\"clear:both;\"></div>\r\n    <div class=\"OrderList\">\r\n        <div class=\"DisplayCat\" ng-if=\"ShowOrderList\">\r\n            <div class=\"DivClass\">\r\n                <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Most Recent\'\" ng-false-value=\"\'NO\'\">Most Recent\r\n            </div>\r\n            <div class=\"DivClass\">\r\n                <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Oldest\'\" ng-false-value=\"\'NO\'\">Oldest\r\n            </div>\r\n            <div class=\"DivClass\">\r\n                <div class=\"leftClass\">\r\n                    <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Highest Recommended\'\" ng-false-value=\"\'NO\'\">\r\n                </div>\r\n                <div class=\"rightClass\" ng-click=\"ShowUsers(\'HighestRecommended\')\">Highest Recommended&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i></div>\r\n            </div>\r\n            <ul class=\"catList innerCat\" ng-if=\"HighestRecommended\">\r\n                <li>As rated by</li>\r\n                <li ng-repeat=\"user in users track by $index\">\r\n                    <label class=\"checkbox\" title=\"search.recommend\">\r\n                        <input type=\"checkbox\" ng-model=\"search.recommendorder\" ng-true-value=\"\'{{user}}\'\" ng-false-value=\"\'NO\'\"> {{user}}\r\n                    </label>\r\n                </li>\r\n            </ul>\r\n            <div class=\"DivClass\">\r\n                <div class=\"leftClass\">\r\n                    <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Least Recommended\'\" ng-false-value=\"\'NO\'\">\r\n                </div>\r\n                <div class=\"rightClass\" ng-click=\"ShowUsers(\'LeastRecommended\')\">\r\n                    Least Recommended&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i></div>\r\n            </div>\r\n            <ul class=\"catList innerCat\" ng-if=\"LeastRecommended\">\r\n                <li>As rated by</li>\r\n                <li ng-repeat=\"user in users track by $index\">\r\n                    <label class=\"checkbox\" title=\"search.lrecommend\">\r\n                        <input type=\"checkbox\" ng-model=\"search.lrecommendorder\" ng-true-value=\"\'{{user}}\'\" ng-false-value=\"\'NO\'\"> {{user}}\r\n                    </label>\r\n                </li>\r\n            </ul>\r\n            <div class=\"DivClass\">\r\n                <div class=\"leftClass\">\r\n                <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Most Factual\'\" ng-false-value=\"\'NO\'\">\r\n                </div>\r\n                <div class=\"rightClass\" ng-click=\"ShowUsers(\'MostFactual\')\">Most Factual&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i></div>\r\n            </div>\r\n            <ul class=\"catList innerCat\" ng-if=\"MostFactual\">\r\n                <li>As rated by</li>\r\n                <li ng-repeat=\"user in users track by $index\">\r\n                    <label class=\"checkbox\" title=\"search.factual\">\r\n                        <input type=\"checkbox\" ng-model=\"search.factualorder\" ng-true-value=\"\'{{user}}\'\" ng-false-value=\"\'NO\'\"> {{user}}\r\n                    </label>\r\n                </li>\r\n            </ul>\r\n             <div class=\"DivClass\">\r\n                <div class=\"leftClass\">\r\n                <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Least Factual\'\" ng-false-value=\"\'NO\'\">\r\n                </div>\r\n                <div class=\"rightClass\" ng-click=\"ShowUsers(\'LeastFactual\')\">Least Factual&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i></div>\r\n            </div>\r\n            <ul class=\"catList innerCat\" ng-if=\"LeastFactual\">\r\n                <li>As rated by</li>\r\n                <li ng-repeat=\"user in users track by $index\">\r\n                    <label class=\"checkbox\" title=\"search.lfactual\">\r\n                        <input type=\"checkbox\" ng-model=\"search.lfactualorder\" ng-true-value=\"\'{{user}}\'\" ng-false-value=\"\'NO\'\"> {{user}}\r\n                    </label>\r\n                </li>\r\n            </ul>\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n    </div>\r\n    <div style=\"clear:both;\"></div>\r\n</div>\r\n<div style=\"padding-right:30px; float:right;\">\r\n     <dir-pagination-controls max-size=\"5\" pagination-id=\"list.id\"></dir-pagination-controls> \r\n</div>\r\n<div class=\"inline2\">\r\n    <div style=\"background-color: #eee; padding:10px; border: solid 1px #000;\" dir-paginate=\"forumthread in searchResults.data | orderBy:sortValues:isreverse | itemsPerPage : 10\" total-items=\"totalResults\" pagination-id=\"list.id\">\r\n        <!-- <div style=\"background-color: #eee; padding:10px; border: solid 1px #000;\" ng-repeat=\"forumthread in searchResults | orderBy:sortValues:isreverse\" ng-if=\"searchResults.length > 0\"> -->\r\n        <div>\r\n            <div style=\"width:90%; float: left;\">\r\n                <div class=\"boldbox\"> <span ng-click=\"gotoThread(forumthread._id);\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">{{forumthread.title}}</span> </div>\r\n                <div><strong>Recommended :</strong>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.recavg\" ng-if=\"showAvg\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.recavgvoters\" ng-if=\"showVoters\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.recavgpolitician\" ng-if=\"showPolitician\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.recavgadvocate\" ng-if=\"showAdvocate\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.recavgpress\" ng-if=\"showPress\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.recavgfollow\" ng-if=\"showFollow\" readonly></input-stars>\r\n                    , <strong>Factual :</strong>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.factfavg\" ng-if=\"showfAvg\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.factfavgvoters\" ng-if=\"showfVoters\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.factfavgpolitician\" ng-if=\"showfPolitician\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.factfavgadvocate\" ng-if=\"showfAdvocate\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.factfavgpress\" ng-if=\"showfPress\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.factfavgfollow\" ng-if=\"showfFollow\" readonly></input-stars>\r\n                </div>\r\n                <div class=\"DescriptionImg\" ng-bind-html=\'forumthread.description | convertHTML\'></div>\r\n                <div> Posted by <a href=\"#!/publicProfile/{{forumthread.createdBy.id}}\">{{forumthread.createdBy.name}}</a> on {{forumthread.createdOn | date:\'medium\'}}</div>\r\n            </div>\r\n            <div style=\"width:9%; float: left; text-align: center;\" ng-if=\"forumthread.createdBy.id==userId\">\r\n                <span ng-click=\"GotoEdit(forumthread._id);\" style=\"text-decoration: underline; cursor: pointer;\">Edit</span>\r\n            </div>\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n    </div>\r\n    <div style=\"background-color: #eee; padding:10px; border: solid 1px #000; height:100px;\" ng-if=\"searchResults.data == 0\">\r\n        No records found.\r\n    </div>\r\n    <div style=\"float:right;\">\r\n        <dir-pagination-controls max-size=\"5\" pagination-id=\"list.id\"></dir-pagination-controls>\r\n    </div>\r\n</div>\r\n<script type=\"text/ng-template\" id=\"field_renderer\">\r\n    <ul class=\"catList\">\r\n        <li>\r\n            <div class=\"catname\" id=\"{{subent._id}}\" ng-if=\"(subent.parentIds.length == 0) && (subent.subcategories)\">\r\n                <input type=\"checkbox\" ng-click=\"getVal(subent)\">\r\n                <label ng-click=\"ChangeShow(subent._id);\">{{::subent.title}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id)==-1\"></i><i class=\"fa fa-caret-right\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id) > -1\"></i></label>\r\n            </div>\r\n            <div class=\"catname\" ng-if=\"(subent.parentIds.length == 0) && (!subent.subcategories)\">\r\n                <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                    <input type=\"checkbox\" ng-click=\"getVal(subent)\"> {{::subent.title}}\r\n                </label>\r\n            </div>\r\n            <label class=\"checkbox\" ng-if=\"subent.parentIds.length > 0 && showSubCat\" title=\"{{subent.title}}\">\r\n                <input type=\"checkbox\" ng-click=\"getVal(subent)\"> {{::subent.title}}\r\n            </label>\r\n            <ul ng-if=\"subent.subcategories\" ng-class=\"subent.parentIds.length == 0 ? \'cmnUL MainCatLi_{{subent._id}}\' : \'\'\">\r\n                <li ng-repeat=\"subent in subent.subcategories track by $index\" ng-include=\"\'field_renderer\'\">\r\n                    <!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                      <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n                    </label> -->\r\n                </li>\r\n            </ul>\r\n        </li>\r\n    </ul>\r\n</script>\r\n");
$templateCache.put("app/essayStaff/essayStaff.html","<link rel=\"stylesheet\" type=\"text/css\" href=\"./essayStaff/essayStaff.css\">\r\n<div style=\"width: 100%;\">\r\n    <div style=\"width:90%; margin: auto;\">\r\n        <h3>ESSAY BY VOTEWISE</h3></div>\r\n    <p>\r\n        <h2><center>Search</center></h2>\r\n    </p>\r\n    <div id=\"tfheader\" class=\"searchbox\" ng-if=\"!ShowAdavace\" style=\"padding-left:10px;\">\r\n        <input type=\"text\" class=\"tftextinput\" ng-model=\"search.text\" name=\"q\" size=\"21\" maxlength=\"120\">\r\n        <input type=\"button\" ng-click=\"getEssayListAdvance(search);\" value=\"Essay Search\" class=\"tfbutton\" style=\"margin-left:-4px;\">\r\n        <div class=\"tfclear\"></div>\r\n    </div>\r\n</div>\r\n<br>\r\n<br>\r\n<br>\r\n<div style=\"padding:10px;\">\r\n    <div style=\"width:90%; float: left;\" \">&nbsp;</div>\r\n    <div style=\"width:9%; float: left; text-align: center; \" ng-if=\"searchResults.data.length> 0\">\r\n        <span ng-click=\"showOrder()\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">Sort</span>\r\n    </div>\r\n    <div style=\"clear:both;\"></div>\r\n    <div class=\"OrderList\">\r\n        <div class=\"DisplayCat\" ng-if=\"ShowOrderList\">\r\n            <div class=\"DivClass\">\r\n                <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Most Recent\'\" ng-false-value=\"\'NO\'\">Most Recent\r\n            </div>\r\n            <div class=\"DivClass\">\r\n                <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Oldest\'\" ng-false-value=\"\'NO\'\">Oldest\r\n            </div>\r\n            <div class=\"DivClass\">\r\n                <div class=\"leftClass\">\r\n                    <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Highest Recommended\'\" ng-false-value=\"\'NO\'\">\r\n                </div>\r\n                <div class=\"rightClass\" ng-click=\"ShowUsers(\'HighestRecommended\')\">Highest Recommended&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i></div>\r\n            </div>\r\n            <ul class=\"catList innerCat\" ng-if=\"HighestRecommended\">\r\n                <li>As rated by</li>\r\n                <li ng-repeat=\"user in users track by $index\">\r\n                    <label class=\"checkbox\" title=\"search.recommend\">\r\n                        <input type=\"checkbox\" ng-model=\"search.recommendorder\" ng-true-value=\"\'{{user}}\'\" ng-false-value=\"\'NO\'\"> {{user}}\r\n                    </label>\r\n                </li>\r\n            </ul>\r\n            <div class=\"DivClass\">\r\n                <div class=\"leftClass\">\r\n                    <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Least Recommended\'\" ng-false-value=\"\'NO\'\">\r\n                </div>\r\n                <div class=\"rightClass\" ng-click=\"ShowUsers(\'LeastRecommended\')\">\r\n                    Least Recommended&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i></div>\r\n            </div>\r\n            <ul class=\"catList innerCat\" ng-if=\"LeastRecommended\">\r\n                <li>As rated by</li>\r\n                <li ng-repeat=\"user in users track by $index\">\r\n                    <label class=\"checkbox\" title=\"search.lrecommend\">\r\n                        <input type=\"checkbox\" ng-model=\"search.lrecommendorder\" ng-true-value=\"\'{{user}}\'\" ng-false-value=\"\'NO\'\"> {{user}}\r\n                    </label>\r\n                </li>\r\n            </ul>\r\n            <div class=\"DivClass\">\r\n                <div class=\"leftClass\">\r\n                    <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Most Factual\'\" ng-false-value=\"\'NO\'\">\r\n                </div>\r\n                <div class=\"rightClass\" ng-click=\"ShowUsers(\'MostFactual\')\">Most Factual&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i></div>\r\n            </div>\r\n            <ul class=\"catList innerCat\" ng-if=\"MostFactual\">\r\n                <li>As rated by</li>\r\n                <li ng-repeat=\"user in users track by $index\">\r\n                    <label class=\"checkbox\" title=\"search.factual\">\r\n                        <input type=\"checkbox\" ng-model=\"search.factualorder\" ng-true-value=\"\'{{user}}\'\" ng-false-value=\"\'NO\'\"> {{user}}\r\n                    </label>\r\n                </li>\r\n            </ul>\r\n            <div class=\"DivClass\">\r\n                <div class=\"leftClass\">\r\n                    <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Least Factual\'\" ng-false-value=\"\'NO\'\">\r\n                </div>\r\n                <div class=\"rightClass\" ng-click=\"ShowUsers(\'LeastFactual\')\">Least Factual&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i></div>\r\n            </div>\r\n            <ul class=\"catList innerCat\" ng-if=\"LeastFactual\">\r\n                <li>As rated by</li>\r\n                <li ng-repeat=\"user in users track by $index\">\r\n                    <label class=\"checkbox\" title=\"search.lfactual\">\r\n                        <input type=\"checkbox\" ng-model=\"search.lfactualorder\" ng-true-value=\"\'{{user}}\'\" ng-false-value=\"\'NO\'\"> {{user}}\r\n                    </label>\r\n                </li>\r\n            </ul>\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n    </div>\r\n    <div style=\"clear:both;\"></div>\r\n</div>\r\n<div style=\"padding-right:30px; float:right;\">\r\n    <dir-pagination-controls max-size=\"5\" pagination-id=\"list.id\"></dir-pagination-controls>\r\n</div>\r\n<div class=\"inline2\">\r\n    <div style=\"background-color: #eee; padding:10px; border: solid 1px #000;\" dir-paginate=\"forumthread in searchResults.data | orderBy:sortValues:isreverse | filter : search.text | itemsPerPage : 10\" total-items=\"totalResults\" pagination-id=\"list.id\">\r\n        <!-- <div style=\"background-color: #eee; padding:10px; border: solid 1px #000;\" ng-repeat=\"forumthread in searchResults | orderBy:sortValues:isreverse\" ng-if=\"searchResults.length > 0\"> -->\r\n        <div>\r\n            <div style=\"width:90%; float: left;\">\r\n                <div class=\"boldbox\"> <span ng-click=\"gotoThread(forumthread._id);\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">{{forumthread.title}}</span> </div>\r\n                <div><strong>Recommended :</strong>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.recavg\" ng-if=\"showAvg\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.recavgvoters\" ng-if=\"showVoters\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.recavgpolitician\" ng-if=\"showPolitician\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.recavgadvocate\" ng-if=\"showAdvocate\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.recavgpress\" ng-if=\"showPress\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.recavgfollow\" ng-if=\"showFollow\" readonly></input-stars>\r\n                    , <strong>Factual :</strong>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.factfavg\" ng-if=\"showfAvg\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.factfavgvoters\" ng-if=\"showfVoters\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.factfavgpolitician\" ng-if=\"showfPolitician\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.factfavgadvocate\" ng-if=\"showfAdvocate\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.factfavgpress\" ng-if=\"showfPress\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.factfavgfollow\" ng-if=\"showfFollow\" readonly></input-stars>\r\n                </div>\r\n                <div class=\"DescriptionImg\" ng-bind-html=\'forumthread.description | convertHTML\'></div>\r\n                <div> Posted by <a href=\"#!/publicProfile/{{forumthread.createdBy.id}}\">{{forumthread.createdBy.name}}</a> on {{forumthread.createdOn | date:\'medium\'}}</div>\r\n            </div>\r\n            <div style=\"width:15%; float: left; text-align: center;\" ng-if=\"userId && forumthread.createdBy.id==userId\">\r\n                <span ng-click=\"GotoEdit(forumthread._id);\" style=\"text-decoration: underline; cursor: pointer;\">Edit</span>&nbsp;&nbsp;<span ng-click=\"removeEssay(forumthread, $index);\" style=\"text-decoration: underline; cursor: pointer;\">Remove</span>\r\n            </div>\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n    </div>\r\n    <div style=\"background-color: #eee; padding:10px; border: solid 1px #000; height:100px;\" ng-if=\"searchResults.data == 0\">\r\n        No records found.\r\n    </div>\r\n    <div style=\"float:right;\">\r\n        <dir-pagination-controls max-size=\"5\" pagination-id=\"list.id\"></dir-pagination-controls>\r\n    </div>\r\n</div>\r\n<script type=\"text/ng-template\" id=\"field_renderer\">\r\n    <ul class=\"catList\">\r\n        <li>\r\n            <div class=\"catname\" id=\"{{subent._id}}\" ng-if=\"(subent.parentIds.length == 0) && (subent.subcategories)\">\r\n                <input type=\"checkbox\" ng-click=\"getVal(subent)\">\r\n                <label ng-click=\"ChangeShow(subent._id);\">{{::subent.title}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id)==-1\"></i><i class=\"fa fa-caret-right\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id) > -1\"></i></label>\r\n            </div>\r\n            <div class=\"catname\" ng-if=\"(subent.parentIds.length == 0) && (!subent.subcategories)\">\r\n                <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                    <input type=\"checkbox\" ng-click=\"getVal(subent)\"> {{::subent.title}}\r\n                </label>\r\n            </div>\r\n            <label class=\"checkbox\" ng-if=\"subent.parentIds.length > 0 && showSubCat\" title=\"{{subent.title}}\">\r\n                <input type=\"checkbox\" ng-click=\"getVal(subent)\"> {{::subent.title}}\r\n            </label>\r\n            <ul ng-if=\"subent.subcategories\" ng-class=\"subent.parentIds.length == 0 ? \'cmnUL MainCatLi_{{subent._id}}\' : \'\'\">\r\n                <li ng-repeat=\"subent in subent.subcategories track by $index\" ng-include=\"\'field_renderer\'\">\r\n                    <!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                      <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n                    </label> -->\r\n                </li>\r\n            </ul>\r\n        </li>\r\n    </ul>\r\n</script>\r\n");
$templateCache.put("app/essayUpdate/dialogGallery.html","\r\n<p></p>\r\n<h1><center>Upload Media</center></h1>\r\n<p></p>\r\n<div>\r\n	<ul style=\"padding:0; height:50px;\">\r\n	<li class=\"liclass lispecial\" ng-click=\"ChangeMedia(\'U\');\" ><div>Upload Media</div></li>\r\n	<li class=\"liclass\" style=\"width:1%; height:50px;\">|</li>\r\n	<li class=\"liclass lispecial\" ng-click=\"ChangeMedia(\'G\');\"><div>Gallery</div></li>\r\n	</ul>\r\n	<div ng-if=\"uploadMedia\">\r\n		<form name=\"topicform\" id=\"topicform\">\r\n            <fieldset class=\"scheduler-border\">\r\n                <legend class=\"scheduler-border\">Upload file</legend>\r\n                <p><small>File size should not be greater than 1MB.</small></p>\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-12\">\r\n                        <div class=\"control-group\">\r\n                            \r\n                            <div class=\"controls\"><input type=\"file\" file-model=\"uploads.files\" check-file-size=\"\" class=\"form-control input-md text-input\" accept=\"image/x-png, image/gif, image/jpeg, image/jpeg, image/svg+xml\">\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"control-group\" style=\"margin-top:15px; margin-bottom:10px;\" >\r\n                            \r\n                            <div class=\"controls\"><input type=\"button\" ng-click=\"uploadFile();\" value=\"Upload File\">\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </fieldset>\r\n        </form>\r\n	</div>\r\n	<div ng-if=\"Gallery\"> \r\n	<p ng-if=\"MainGallery.length > 0\">\r\n		<p>Select the file then select the url from textbox to insert it in the Description</p>\r\n		<p ng-if=\"ShowPath\">Use Ctrl+C to copy from text box<input type=\"text\" ng-model=\"uploads.path\" style=\"width:100%;\"></p>\r\n		<div style=\"width:100%; max-height: 350px; overflow: scroll;\">\r\n			<span ng-repeat=\"img in MainGallery\" style=\"cursor: pointer; padding:10px;\" ng-click=\"ShowSelectedPath(img.fileName);\"><img src=\"{{GalleryFolder}}/{{img.fileName}}\" style=\"width:100px;\" /></span>\r\n\r\n		</div>\r\n	</p>\r\n	<p ng-if=\"MainGallery.length == 0\">\r\n		There are no files uploaded by you. Click on \"Upload Media\" tab to upload files.\r\n	</p>\r\n	</div>\r\n</div>");
$templateCache.put("app/essayUpdate/essayUpdate.html","<p></p>\r\n<h1><center>Update Essay</center></h1>\r\n<p></p>\r\n<center>\r\n    <div class=\"inline2\">\r\n        <form name=\"topicform\" id=\"topicform\">\r\n            <fieldset class=\"scheduler-border\">\r\n                <legend class=\"scheduler-border\">Essay details</legend>\r\n                <p></p>\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-12\">\r\n                        <div class=\"control-group\">\r\n                            <label class=\"control-label\" for=\"title\">Title</label>\r\n                            <div class=\"controls\">\r\n                                <input type=\"text\" ng-model=\"Essay.title\" placeholder=\"\" data-errormessage=\"Title is required.\" style=\"width:50%;\" class=\"form-control input-md  validate[required] text-input\">\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"control-group\">\r\n                            <div class=\"control-label\" for=\"title\">Select Tags</div>\r\n                            <div class=\"DisplayCat changeTextColor\">\r\n                                <div style=\"background-color: #eee; padding:5px;\">All Tags <br><small>(click to select)</small></div>\r\n                                <div ng-repeat=\"subent in subtopics.subcategories track by $index\" ng-include=\"\'field_renderer\'\">Loading...</div>\r\n                                <div ng-if=\"subtopics.subcategories.length == 0\" class=\"loadingSpinner\">\r\n                                    <i class=\"fa fa-refresh fa-spin fa-3x fa-fw\"></i>\r\n                                </div>\r\n                            </div>\r\n                            <div class=\"select buttons\" style=\"padding-left: 20px;\">&nbsp;\r\n                                <!-- <button class=\"btn mover left\" ng-click=\"AddmyCats()\" title=\"Add selected\" ng-disabled=\"!selectedCat.length\"><i class=\"fa fa-arrow-right\" aria-hidden=\"true\"></i></button>\r\n                                <button class=\"btn mover right\" ng-click=\"RemoveCats()\" title=\"Remove selected\" ng-disabled=\"!rmselectedCat.length\">\r\n                                    <i class=\"fa fa-arrow-left\" aria-hidden=\"true\"></i>\r\n                                </button> -->\r\n                            </div>\r\n                            <div class=\"DisplayCat changeTextColor\">\r\n                                <div style=\"background-color: #eee; padding:5px;\">Selected Tags<br><small>(click to remove)</small></div>\r\n                                <ul class=\"TcatList\">\r\n                                    <li ng-repeat=\"subent in selectedCat track by $index\">\r\n                                        <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                                            <input type=\"checkbox\" ng-click=\"removeVal(subent)\" ng-model=\"selectedAll.id[$index]\" ng-checked=\"selectedCat.indexOf(subnet) > -1\"> {{subent.title}}\r\n                                        </label>\r\n                                    </li>\r\n                                </ul>\r\n                            </div>\r\n                            <div style=\"clear:both;\"></div>\r\n                            <!-- <multi-select ng-model=\"Essay.subcategories\" available=\"subtopics\" selected-label=\"Selected subtopics\" available-label=\"All subtopics\" display=\"r as r.title\" title=\"r as r.title\" config=\"selectConfig\"></multi-select>\r\n                            <div class=\"input-error\" ng-show=\"selectForm.numSelected.$error.min\">\r\n                                Please select at least\r\n                                <ng-pluralize count=\"selectConfig.requiredMin\" when=\"{\'one\': \'one role\', \'other\': \'{} roles\'}\">.\r\n                            </div>\r\n                            <input type=\"hidden\" id=\"reqMin\" ng-model=\"selectConfig.requiredMin\" min=\"1\">-->\r\n                        </div>\r\n                        <div class=\"control-group\">\r\n                            <div class=\"DisplayCat changeTextColor\">\r\n                                <div style=\"background-color: #eee; padding:5px;\">Choose Location<br><small>(click to select)</small></div>\r\n                                <ul class=\"TcatList\">\r\n                                    <li style=\"padding-bottom:10px;\">\r\n                                        <input type=\"checkbox\" ng-click=\"getLocations(Essay.Locations, \'International\')\" ng-model=\"Essay.Locations\" ng-true-value=\"\'International\'\" ng-false-value=\"\'NO\'\">\r\n                                        <label ng-click=\"ShowAddLocation();\">International&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i></label>\r\n                                        <div style=\"padding-left:20px;\" ng-if=\"AddLocation\">\r\n                                        <div mass-autocomplete>\r\n                                            <input ng-model=\"newlocation.country\" mass-autocomplete-item=\"autocomplete_options\">\r\n                                        </div>\r\n                                        <div style=\"text-align: right;\"><button ng-click=\"AddCountry();\">Add country</button></div>\r\n                                        </div>\r\n                                    </li>\r\n                                    <li>\r\n                                        <input type=\"checkbox\" ng-model=\"Essay.National\" ng-click=\"getLocations(Essay.National, \'National\')\" ng-true-value=\"\'National\'\" ng-false-value=\"\'NO\'\">\r\n                                        <label>National</label>\r\n                                       \r\n                                        <ul class=\"TcatList\">\r\n                                            <li ng-repeat=\"area in allLocations track by $index\">\r\n                                                <input type=\"checkbox\" ng-click=\"getAreaVal(area, area.state, \'state\')\" ng-disabled=\"checkDisabled(area, area.state, \'state\')\" ng-checked=\"checkDisabled(area, area.state, \'state\')\">\r\n                                                <label ng-click=\"getCounties(area.statePostalCode)\">{{area.state}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoading.indexOf(area.statePostalCode)==-1\"></i> <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoading.indexOf(area.statePostalCode) > -1\"></i></label>\r\n                                                <!-- Display Counties -->\r\n                                                <ul class=\"TcatList\">\r\n                                                    <li ng-repeat=\"county in allCounties[area.statePostalCode] track by $index\">\r\n                                                        <input type=\"checkbox\" ng-click=\"getAreaVal(county._id, area.state, \'county\')\" ng-disabled=\"checkDisabled(county._id, area.state, \'county\')\" ng-checked=\"checkDisabled(county._id, area.state, \'county\')\">\r\n                                                        <label ng-click=\"getLocals(area.statePostalCode, county._id.county)\">{{county._id.county}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoadingCounty.indexOf(county._id.county) == -1\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingCounty.indexOf(county._id.county) > -1\"></i></label>\r\n                                                        <!-- Display Locals and sub counties -->\r\n                                                        <ul class=\"TcatList\" ng-if=\"Essay.location!=\'National\'\">\r\n                                                            <li ng-repeat=\"local in allLocals[area.statePostalCode][county._id.county] track by $index\">\r\n                                                                <label class=\"checkbox\" title=\"{{local._id.place}}\">\r\n                                                                    <input type=\"checkbox\" ng-click=\"getAreaVal(local._id, area.state, \'local\')\" ng-disabled=\"disabledLocation.indexOf(local._id) > -1 ? true : false\" ng-checked=\"disabledLocation.indexOf(local._id) > -1 ? true : false\"> {{local._id.countySubdivision}} - {{local._id.place}}\r\n                                                                </label>\r\n                                                            </li>\r\n                                                        </ul>\r\n                                                        <!-- Display Locals and sub counties End -->\r\n                                                    </li>\r\n                                                </ul>\r\n                                                <!-- Display Counties End -->\r\n                                            </li>\r\n                                        </ul>\r\n                                    </li>\r\n                                </ul>\r\n                            </div>\r\n                            <div class=\"select buttons\" style=\"padding-left: 20px;\">&nbsp;\r\n                                <!-- <button class=\"btn mover left\" ng-click=\"AddmyArea()\" title=\"Add selected\" ng-disabled=\"!selectedArea.length\"><i class=\"fa fa-arrow-right\" aria-hidden=\"true\"></i></button>\r\n                                <button class=\"btn mover right\" ng-click=\"RemoveArea()\" title=\"Remove selected\" ng-disabled=\"!rmselectedArea.length\">\r\n                                    <i class=\"fa fa-arrow-left\" aria-hidden=\"true\"></i>\r\n                                </button> -->\r\n                            </div>\r\n                            <div class=\"DisplayCat changeTextColor\">\r\n                                <div style=\"background-color: #eee; padding:5px;\">Selected Location\'s <br><small>(click to remove)</small></div>\r\n                                <ul class=\"TcatList\">\r\n                                    <li ng-repeat=\"area in selectedArea track by $index\">\r\n                                        <label class=\"checkbox\" title=\"{{area}}\">\r\n                                            <input type=\"checkbox\" ng-click=\"removeAreaVal(area)\" ng-model=\"selectedLAll.id[$index]\" ng-checked=\"selectedArea.indexOf(area) > -1\"> <span ng-if=\"area.country && (!(area.state) && !(area.county) && !(area.countySubdivision) && !(area.place))\">{{area.country}}</span> <span ng-if=\"area.state && (!(area.county) && !(area.countySubdivision) && !(area.place))\">{{area.state}}</span><span ng-if=\"area.county && (!(area.countySubdivision) && !(area.place))\">{{area.county}}</span><span ng-if=\"area.countySubdivision\">{{area.countySubdivision}}</span><span ng-if=\"area.place\"> - {{area.place}}</span>\r\n                                        </label>\r\n                                    </li>\r\n                                </ul>\r\n                            </div>\r\n                            <div style=\"clear:both;\"></div>\r\n                            <!-- <multi-select ng-model=\"Essay.subcategories\" available=\"subtopics\" selected-label=\"Selected subtopics\" available-label=\"All subtopics\" display=\"r as r.title\" title=\"r as r.title\" config=\"selectConfig\"></multi-select>\r\n                            <div class=\"input-error\" ng-show=\"selectForm.numSelected.$error.min\">\r\n                                Please select at least\r\n                                <ng-pluralize count=\"selectConfig.requiredMin\" when=\"{\'one\': \'one role\', \'other\': \'{} roles\'}\">.\r\n                            </div>\r\n                            <input type=\"hidden\" id=\"reqMin\" ng-model=\"selectConfig.requiredMin\" min=\"1\">-->\r\n                        </div>\r\n                        <!-- <div class=\"control-group\">\r\n                            <label class=\"control-label\" for=\"restricted\">Media Type</label>\r\n                            <div class=\"control-group\">\r\n                                <select ng-model=\"Essay.mediaType\">\r\n                                    <option ng-repeat=\"option in mediaType\" value=\"{{option}}\">{{option}}</option>\r\n                                </select>\r\n                            </div>\r\n                        </div> -->\r\n                        <div class=\"control-group\" ng-if=\"Essay.mediaType==\'Text\'\">\r\n                            <label class=\"control-label\" for=\"description\">Description</label>\r\n                            <div class=\"controls\">\r\n                                 <textarea id=\"description\" ng-model=\"Essay.description\" placeholder=\"\" style=\"width:95%; height:250px; padding:15px;\" class=\"changeTextColor\"></textarea>\r\n                                <!-- <input type=\"button\" name=\"btnAddMedia\" ng-click=\"Showgallery()\" value=\"Add Media\" style=\"margin-top:15px; margin-bottom:10px;\" />\r\n                                <textarea ui-tinymce=\"tinymceOptions\" ng-model=\"Essay.description\" style=\"height:350px;\"></textarea> -->\r\n                            </div>\r\n                        </div>\r\n           <!--             <div class=\"control-group\" ng-if=\"Essay.mediaType==\'Stills\'\">\r\n                            <label class=\"control-label\" for=\"description\">Upload Media</label>\r\n                            <div class=\"controls\">\r\n                                <input type=\"file\" check-file-size=\"\" file-model=\"Essay.files\" class=\"form-control input-md text-input\" accept=\"image/x-png, image/gif, image/jpeg, image/jpeg, image/svg+xml\">\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"control-group\" ng-if=\"Essay.mediaType==\'Video\' || Essay.mediaType==\'Audio\'\">\r\n                            <label class=\"control-label\" for=\"description\">{{Essay.mediaType}} url</label>\r\n                            <div class=\"controls\">\r\n                                <input type=\"text\" ng-model=\"Essay.mediaFile\" placeholder=\"\" data-errormessage-value-missing=\"Please enter url\" data-errormessage-custom-error=\"Please enter valid url. e.g. http://www.example.com/v1\" data-errormessage=\"Please enter valid url. e.g. http://www.example.com/v1\" style=\"width:50%;\" class=\"form-control input-md  validate[required, custom[url]] text-input\">\r\n                            </div>\r\n                        </div> \r\n                        <div class=\"control-group\" ng-if=\"Essay.mediaType!=\'Text\'\">\r\n                            <label class=\"control-label\" for=\"description\">Note</label>\r\n                            <div class=\"controls\">\r\n                                <textarea ng-model=\"Essay.description\" style=\"width: 70%; height: 150px;\" class=\"changeTextColor\"></textarea>\r\n                            </div>\r\n            -->          \r\n																									<div style=\"clear: both;\"></div>\r\n                    <div style=\"margin-top:20px;\">\r\n                        <button ng-click=\"UpdateEssay(Essay)\" type=\"button\" class=\"btn btn-success\" style=\"float: left;\">Submit Changes</button>\r\n                        &nbsp;&nbsp;&nbsp;&nbsp;\r\n               <!--         <button ng-click=\"goBack();\" type=\"button\" style=\"float: left;\" class=\"changeTextColor\">Cancel</button>  -->\r\n                        <div style=\"clear: both;\"></div>\r\n                    </div>\r\n																					<div style=\"clear: both;\"></div></div></div>\r\n                \r\n            </fieldset>\r\n        </form>\r\n    </div>\r\n</center>\r\n<script type=\"text/ng-template\" id=\"field_renderer\">\r\n    <ul class=\"TcatList\">\r\n        <li>\r\n             <div class=\"catname\" id=\"{{subent._id}}\" ng-if=\"(subent.parentIds.length == 0) && (subent.subcategories)\">\r\n                <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\">  <label ng-click=\"ChangeShow(subent._id);\">{{::subent.title}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id)==-1\"></i><i class=\"fa fa-caret-right\" aria-hidden=\"true\"  ng-if=\"showDown.indexOf(subent._id) > -1\"></i></label>\r\n            </div>\r\n            <div class=\"catname\" ng-if=\"(subent.parentIds.length == 0) && (!subent.subcategories)\">\r\n                <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                    <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\"> {{::subent.title}}\r\n                </label>\r\n            </div>\r\n            <label class=\"checkbox\" ng-if=\"subent.parentIds.length > 0 && showSubCat\" title=\"{{subent.title}}\" >\r\n                <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\"> {{::subent.title}}\r\n            </label>\r\n            <ul ng-if=\"subent.subcategories\" ng-class=\"subent.parentIds.length == 0 ? \'cmnUL MainCatLi_{{subent._id}}\' : \'\'\">\r\n                <li ng-repeat=\"subent in subent.subcategories track by $index\" ng-include=\"\'field_renderer\'\">\r\n                    <!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                      <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n                  </label> -->\r\n                </li>\r\n            </ul>\r\n        </li>\r\n    </ul>\r\n</script>\r\n<script type=\"text/javascript\">\r\njQuery(document).ready(function() {\r\n    // binds form submission and fields to the validation engine\r\n    // binds form submission and fields to the validation engine\r\n    $(\"form\").validationEngine();\r\n});\r\n</script>");
$templateCache.put("app/essay_press/essay.html","<link rel=\"stylesheet\" type=\"text/css\" href=\"./essay/essay.css\">\r\n<center>\r\n    <h1><p>User News</p></h1></center>\r\n<p>This section allows Press and Organizations to post local and national news which you can filter and search through using the Search tools below</p>\r\n            <center>\r\n      <a ng-href=\"#!/presshome/press\">\r\n        <button class=\"btnB20\">\r\n          <b>Find and Follow Local News Outlets</b>\r\n        </button>\r\n      </a>\r\n    </center>\r\n<br>\r\n\r\n<div style=\"width: 100%;\">\r\n    <!-- \r\n    <div style=\"width:90%; margin: auto;\" ng-if=\"staffResults.data.length > 0\">\r\n        <h3>Essay by Votewise</h3>\r\n    </div>\r\n    <div style=\"background-color: #eee; padding:10px; border: solid 1px #000; width: 90%; margin: auto;\" ng-if=\"staffResults.data.length > 0\">\r\n            <div ng-repeat=\"essay in staffResults.data\">\r\n                <div style=\"padding:10px;\">\r\n                    <div style=\"width:90%; float: left;\">\r\n                        <div class=\"boldbox\"> <span ng-click=\"gotoThread(essay._id);\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">{{essay.title}}</span> </div>\r\n                        <div class=\"DescriptionImg\" ng-bind-html=\'essay.description | convertHTML\'></div>\r\n                    </div>\r\n                    <div style=\"width:9%; float: left; text-align: center;\" ng-if=\"essay.createdBy.id==userId\">\r\n                        <span ng-click=\"GotoEdit(essay._id);\" style=\"text-decoration: underline; cursor: pointer;\">Edit</span>\r\n                    </div>\r\n                </div>\r\n                <div style=\"clear:both;\"></div>\r\n            </div>\r\n    </div>\r\n    <div style=\"width:90%; margin: auto; text-align: right;\" ng-if=\"staffResults.data.length > 0\">\r\n        <a href=\"#!/pressEssayStaff/{{categoryId}}\">more...</a>\r\n    </div>\r\n    -->\r\n    <p>\r\n        <h2><center>Search</center></h2></p>\r\n    <div id=\"tfheader\" class=\"searchbox\" ng-if=\"!ShowAdavace\" style=\"padding-left:10px;\">\r\n        <input type=\"text\" class=\"tftextinput\" ng-model=\"search.text\" name=\"q\" size=\"21\" maxlength=\"120\">\r\n        <input type=\"button\" ng-click=\"getEssayListAdvance(search);\" value=\"Post Search\" class=\"tfbutton\" style=\"margin-left:-4px;\">\r\n        <div ng-click=\"showadvace();\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">More Search Options</div>\r\n        <div class=\"tfclear\"></div>\r\n    </div>\r\n    <div id=\"tfheader\" class=\"searchbox\" ng-if=\"ShowAdavace\" style=\"padding-left:10px;\">\r\n        <form name=\"searchform\" id=\"searchform\" method=\"post\" action=\"submit.action\">\r\n            <div class=\"DivClassLeft\">Search for</div>\r\n            <div class=\"DivClassRight\">\r\n                <input type=\"text\" ng-model=\"search.text\" name=\"q\" size=\"21\" maxlength=\"120\">\r\n            </div>\r\n            <div style=\"clear:both;\"></div>\r\n            <div>\r\n                <div class=\"DivClassLeft\">Refine : </div>\r\n                <div class=\"DisplayCat\">\r\n                    <div class=\"DivClass\">\r\n                        <div class=\"leftClass\">\r\n                            <input type=\"checkbox\" ng-model=\"search.subject\" ng-true-value=\"\'Subject of Interest\'\" ng-false-value=\"\'NO\'\">\r\n                        </div>\r\n                        <div class=\"rightClass\" ng-click=\"showRefine($event, \'Interest\');\">\r\n                            Subject of Interest&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"!ShowSubcatTree\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"ShowSubcatTree\"></i></div>\r\n                    </div>\r\n                    <div ng-repeat=\"subent in subtopics.subcategories track by $index\" ng-include=\"\'field_renderer\'\">Loading...</div>\r\n                    <div class=\"DivClass\">\r\n                        <div class=\"leftClass\">\r\n                            <input type=\"checkbox\" ng-model=\"search.Locations\" ng-true-value=\"\'Location\'\" ng-false-value=\"\'NO\'\">\r\n                        </div>\r\n                        <div class=\"rightClass\" ng-click=\"showRefine($event, \'Location\');\">\r\n                            Location&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"!showLoadingLocation\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingLocation\"></i></div>\r\n                    </div>\r\n                    <ul class=\"catList innerCat\" ng-if=\"showRefineLocation\">\r\n                        <li ng-repeat=\"local in Location track by $index\">\r\n                            <input type=\"checkbox\" ng-click=\"SelectDefaultLocation(local)\" ng-true-value=\"\'{{local}}\'\" ng-false-value=\"\'NO\'\">\r\n                            <label class=\"checkbox\" ng-if=\"local!=\'Other Specific\'\" title=\"{{local}}\"> {{local}}&nbsp;</label>\r\n                            <label class=\"checkbox\" ng-if=\"local==\'Other Specific\'\" ng-click=\"showRefine($event, \'AllLocation\')\" title=\"{{local}}\"> {{local}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"!ShowStateLoader\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"ShowStateLoader\"></i></label>\r\n                            <!-- Select Location Start -->\r\n                            <ul class=\"catList innerCat\" ng-if=\"local==\'Other Specific\' && showRefineLocation && showStates\">\r\n                                <li ng-repeat=\"area in allLocations track by $index\">\r\n                                    <input type=\"checkbox\" ng-click=\"selectLocation(area, area.state, area.statePostalCode, \'state\')\">\r\n                                    <label ng-click=\"getCounties(area.statePostalCode, \'location\')\">{{area.state}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoading.indexOf(area.statePostalCode)==-1\"></i> <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoading.indexOf(area.statePostalCode) > -1\"></i></label>\r\n                                    <!-- Display Counties -->\r\n                                    <ul class=\"catList innerCat\">\r\n                                        <li ng-repeat=\"county in allCounties[area.statePostalCode] track by $index\">\r\n                                            <input type=\"checkbox\" ng-click=\"selectLocation(area, county._id, county._id.county, \'county\')\">\r\n                                            <label ng-click=\"getLocals(area.statePostalCode, county._id.county, \'location\')\">{{county._id.county}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoadingCounty.indexOf(county._id.county) == -1\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingCounty.indexOf(county._id.county) > -1\"></i></label>\r\n                                            <!-- Display Locals and sub counties -->\r\n                                            <ul class=\"catList innerCat\" ng-if=\"Essay.location!=\'National\'\">\r\n                                                <li ng-repeat=\"local in allLocals[area.statePostalCode][county._id.county] track by $index\">\r\n                                                    <label class=\"checkbox\" title=\"{{local._id.place}}\">\r\n                                                        <input type=\"checkbox\" ng-click=\"selectLocation(area, county._id.county, local._id, \'local\')\"> {{local._id.countySubdivision}} - {{local._id.place}}\r\n                                                    </label>\r\n                                                </li>\r\n                                            </ul>\r\n                                            <!-- Display Locals and sub counties End -->\r\n                                        </li>\r\n                                    </ul>\r\n                                    <!-- Display Counties End -->\r\n                                </li>\r\n                            </ul>\r\n                            <!-- Select Location End -->\r\n                        </li>\r\n                    </ul>\r\n                    <!-- Select Media Type Start -->\r\n   <!--                 <div class=\"DivClass\">\r\n                        <div class=\"leftClass\">\r\n                            <input type=\"checkbox\" ng-model=\"search.mediaType\" ng-true-value=\"\'MediaType\'\" ng-false-value=\"\'NO\'\">\r\n                        </div>\r\n                        <div class=\"rightClass\" ng-click=\"showRefine($event, \'Media\');\">\r\n                            Media Type&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"!showLoadingMedia\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingMedia\"></i></div>\r\n                    </div>\r\n                    <ul class=\"catList innerCat\" ng-if=\"showmediaType\">\r\n                        <li ng-repeat=\"media in mediaType track by $index\">\r\n                            <label class=\"checkbox\" title=\"{{search.mediaoption}}\">\r\n                                <input type=\"checkbox\" ng-model=\"search.mediaoption[$index]\" ng-true-value=\"\'{{media}}\'\" ng-false-value=\"\"> {{media}}\r\n                            </label>\r\n                        </li>\r\n                    </ul>\r\n                   <!-- Select Media Type End -->\r\n--> \r\n                    <!-- Select Date Range Start -->\r\n                    <div class=\"DivClass\">\r\n                        <div class=\"leftClass\">\r\n                            <input type=\"checkbox\" ng-model=\"search.DateRange\" ng-true-value=\"\'DateRange\'\" ng-false-value=\"\'NO\'\">\r\n                        </div>\r\n                        <div class=\"rightClass\" ng-click=\"showRefine($event, \'Date\');\">\r\n                            Date Range&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"!showLoadingMedia\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingMedia\"></i></div>\r\n                    </div>\r\n                    <ul class=\"catList innerCat\" ng-if=\"showDateRange\">\r\n                        <li ng-repeat=\"range in dateRange track by $index\">\r\n                            <label class=\"checkbox\" title=\"search.dateoption\">\r\n                                <input type=\"checkbox\" ng-model=\"search.dateoption\" ng-true-value=\"\'{{range}}\'\" ng-false-value=\"\'NO\'\"> {{range}}\r\n                            </label>\r\n                        </li>\r\n                        <li>\r\n                            <input type=\"checkbox\" ng-model=\"search.dateoption\" ng-true-value=\"\'Before\'\" ng-false-value=\"\'NO\'\">\r\n                            <label class=\"checkbox\">Before\r\n                                <input type=\"date\" ng-model=\"search.dateBefore\">\r\n                            </label>\r\n                        </li>\r\n                        <li>\r\n                            <input type=\"checkbox\" ng-model=\"search.dateoption1\" ng-true-value=\"\'After\'\" ng-false-value=\"\'NO\'\">\r\n                            <label class=\"checkbox\">After\r\n                                <input type=\"date\" ng-model=\"search.dateAfter\">\r\n                            </label>\r\n                        </li>\r\n                    </ul>\r\n                    <!-- Select Date Range End -->\r\n                    <!-- Match to author Start -->\r\n                    <div class=\"DivClass\">\r\n                        <div class=\"leftClass\">\r\n                            <input type=\"checkbox\" ng-model=\"search.matchauthor\" ng-true-value=\"\'Before\'\" ng-false-value=\"\'NO\'\">\r\n                        </div>\r\n                        <div class=\"rightClass\" ng-click=\"showRefine($event, \'Author\');\">Match to Author&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"!showLoadingMedia\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingMedia\"></i></div>\r\n                    </div>\r\n                    <ul class=\"catList\" ng-if=\"showMatchAuthor\">\r\n                        <li> Authors who match you between\r\n                            <input type=\"text\" class=\"numberText\" ng-model=\"search.matchFrom\" id=\"matchFrom\" data-errormessage=\"Please enter only numbers.\" maxlength=\"2\" size=\"2\" /> and\r\n                            <input type=\"text\" class=\"numberText\" ng-model=\"search.matchTo\" id=\"matchTo\" data-errormessage=\"Please enter only numbers.\" maxlength=\"2\" size=\"2\" /> percent\r\n                        </li>\r\n                    </ul>\r\n                    <!-- Match to author End -->\r\n                    <div class=\"DivClass\">\r\n                        <input type=\"checkbox\" ng-model=\"search.fromfollowlist\" ng-true-value=\"\'YES\'\" ng-false-value=\"\'NO\'\"> Authors on my follow list</div>\r\n                    <!-- User Rated Start -->\r\n                    <div class=\"DivClass\">\r\n                        <div class=\"leftClass\">\r\n                            <input type=\"checkbox\" ng-model=\"search.essayRating\" ng-true-value=\"\'Rating\'\" ng-false-value=\"\'NO\'\"> </div>\r\n                        <div class=\"rightClass\" ng-click=\"showRefine($event, \'EssayRated\');\">Post Rating&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"!showLoadingMedia\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingMedia\"></i></div>\r\n                    </div>\r\n                    <ul class=\"catList innerCat\" ng-if=\"showEssayRating\">\r\n                        <li>\r\n                            <input type=\"checkbox\" ng-model=\"search.Recommended\" ng-true-value=\"\'Recommended\'\" ng-false-value=\"\'NO\'\"> Recommended -\r\n                            <input type=\"text\" class=\"numberText\" ng-model=\"search.recommendFrom\" maxlength=\"2\" size=\"2\" /> and\r\n                            <input type=\"text\" class=\"numberText\" ng-model=\"search.recommendTo\" maxlength=\"2\" size=\"2\" /> percent\r\n                            <ul class=\"catList innerCat\">\r\n                                <li>As rated by</li>\r\n                                <li ng-repeat=\"user in users track by $index\">\r\n                                    <label class=\"checkbox\" title=\"search.recommend\">\r\n                                        <input type=\"checkbox\" ng-model=\"search.recommendFilter\" ng-true-value=\"\'{{user}}\'\" ng-false-value=\"\'NO\'\"> {{user}}\r\n                                    </label>\r\n                                </li>\r\n                            </ul>\r\n                        </li>\r\n                        <li>\r\n                            <input type=\"checkbox\" ng-model=\"search.Factual\" ng-true-value=\"\'Factual\'\" ng-false-value=\"\'NO\'\"> Factual -\r\n                            <input type=\"text\" class=\"numberText\" ng-model=\"search.factualFrom\" maxlength=\"2\" size=\"2\" /> and\r\n                            <input type=\"text\" class=\"numberText\" ng-model=\"search.factualTo\" maxlength=\"2\" size=\"2\" /> percent\r\n                            <ul class=\"catList innerCat\">\r\n                                <li>As rated by</li>\r\n                                <li ng-repeat=\"user in users track by $index\">\r\n                                    <label class=\"checkbox\" title=\"search.factual\">\r\n                                        <input type=\"checkbox\" ng-model=\"search.factualFilter\" ng-true-value=\"\'{{user}}\'\" ng-false-value=\"\'NO\'\"> {{user}}\r\n                                    </label>\r\n                                </li>\r\n                            </ul>\r\n                        </li>\r\n                    </ul>\r\n                    <!-- User Rated End -->\r\n                </div>\r\n                <div style=\"clear:both;\"></div>\r\n            </div>\r\n            <div style=\"clear:both;\"></div>\r\n        </form>\r\n        <div class=\"DivClassLeft\">&nbsp;</div>\r\n        <div class=\"DivClassRight\">\r\n            <input type=\"button\" ng-click=\"getEssayListAdvance(search);\" value=\"Post Search\" class=\"tfbuttonNew\">\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n    </div>\r\n</div>\r\n<br>\r\n<br>\r\n<br>\r\n<div style=\"padding:10px;\">\r\n    <div style=\"width:90%; float: left;\">\r\n        <a href=\"#!/newPressEssay/{{categoryId}}\" ng-if=\"userRole!=\'voter\'\">Add new post</a>\r\n    </div>\r\n    <div style=\"width:9%; float: left; text-align: center;\" ng-if=\"searchResults.data.length > 0\">\r\n        <span ng-click=\"showOrder()\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">Sort</span>\r\n    </div>\r\n    <div style=\"clear:both;\"></div>\r\n    <div class=\"OrderList\">\r\n        <div class=\"DisplayCat\" ng-if=\"ShowOrderList\">\r\n            <div class=\"DivClass\">\r\n                <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Most Recent\'\" ng-false-value=\"\'NO\'\">Most Recent\r\n            </div>\r\n            <div class=\"DivClass\">\r\n                <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Oldest\'\" ng-false-value=\"\'NO\'\">Oldest\r\n            </div>\r\n            <div class=\"DivClass\">\r\n                <div class=\"leftClass\">\r\n                    <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Highest Recommended\'\" ng-false-value=\"\'NO\'\">\r\n                </div>\r\n                <div class=\"rightClass\" ng-click=\"ShowUsers(\'HighestRecommended\')\">Highest Recommended&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i></div>\r\n            </div>\r\n            <ul class=\"catList innerCat\" ng-if=\"HighestRecommended\">\r\n                <li>As rated by</li>\r\n                <li ng-repeat=\"user in users track by $index\">\r\n                    <label class=\"checkbox\" title=\"search.recommend\">\r\n                        <input type=\"checkbox\" ng-model=\"search.recommendorder\" ng-true-value=\"\'{{user}}\'\" ng-false-value=\"\'NO\'\"> {{user}}\r\n                    </label>\r\n                </li>\r\n            </ul>\r\n            <div class=\"DivClass\">\r\n                <div class=\"leftClass\">\r\n                    <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Least Recommended\'\" ng-false-value=\"\'NO\'\">\r\n                </div>\r\n                <div class=\"rightClass\" ng-click=\"ShowUsers(\'LeastRecommended\')\">\r\n                    Least Recommended&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i></div>\r\n            </div>\r\n            <ul class=\"catList innerCat\" ng-if=\"LeastRecommended\">\r\n                <li>As rated by</li>\r\n                <li ng-repeat=\"user in users track by $index\">\r\n                    <label class=\"checkbox\" title=\"search.lrecommend\">\r\n                        <input type=\"checkbox\" ng-model=\"search.lrecommendorder\" ng-true-value=\"\'{{user}}\'\" ng-false-value=\"\'NO\'\"> {{user}}\r\n                    </label>\r\n                </li>\r\n            </ul>\r\n            <div class=\"DivClass\">\r\n                <div class=\"leftClass\">\r\n                    <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Most Factual\'\" ng-false-value=\"\'NO\'\">\r\n                </div>\r\n                <div class=\"rightClass\" ng-click=\"ShowUsers(\'MostFactual\')\">Most Factual&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i></div>\r\n            </div>\r\n            <ul class=\"catList innerCat\" ng-if=\"MostFactual\">\r\n                <li>As rated by</li>\r\n                <li ng-repeat=\"user in users track by $index\">\r\n                    <label class=\"checkbox\" title=\"search.factual\">\r\n                        <input type=\"checkbox\" ng-model=\"search.factualorder\" ng-true-value=\"\'{{user}}\'\" ng-false-value=\"\'NO\'\"> {{user}}\r\n                    </label>\r\n                </li>\r\n            </ul>\r\n            <div class=\"DivClass\">\r\n                <div class=\"leftClass\">\r\n                    <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Least Factual\'\" ng-false-value=\"\'NO\'\">\r\n                </div>\r\n                <div class=\"rightClass\" ng-click=\"ShowUsers(\'LeastFactual\')\">Least Factual&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i></div>\r\n            </div>\r\n            <ul class=\"catList innerCat\" ng-if=\"LeastFactual\">\r\n                <li>As rated by</li>\r\n                <li ng-repeat=\"user in users track by $index\">\r\n                    <label class=\"checkbox\" title=\"search.lfactual\">\r\n                        <input type=\"checkbox\" ng-model=\"search.lfactualorder\" ng-true-value=\"\'{{user}}\'\" ng-false-value=\"\'NO\'\"> {{user}}\r\n                    </label>\r\n                </li>\r\n            </ul>\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n    </div>\r\n<!--<p ng-if=\"displayMsg && search.text!=\'\'\">Search results for: {{search.text}}</p>-->\r\n    <div style=\"clear:both;\"></div>\r\n</div>\r\n<div style=\"padding-right:30px; float:right;\">\r\n    <dir-pagination-controls max-size=\"5\" pagination-id=\"list.id\"></dir-pagination-controls>\r\n</div>\r\n<div class=\"inline2\">\r\n    <div style=\"background-color: #eee; padding:10px; border: solid 1px #000;\" dir-paginate=\"forumthread in searchResults.data | orderBy:sortValues:isreverse | itemsPerPage : 10\" total-items=\"totalResults\" pagination-id=\"list.id\">\r\n        <!-- <div style=\"background-color: #eee; padding:10px; border: solid 1px #000;\" ng-repeat=\"forumthread in searchResults | orderBy:sortValues:isreverse\" ng-if=\"searchResults.length > 0\"> -->\r\n        <div>\r\n            <div style=\"width:90%; float: left;\">\r\n                <div class=\"boldbox\"> <span ng-click=\"gotoThread(forumthread._id);\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">{{forumthread.title}}</span> </div>\r\n                <div><strong>Recommended :</strong>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.recavg\" ng-if=\"showAvg\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.recavgvoters\" ng-if=\"showVoters\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.recavgpolitician\" ng-if=\"showPolitician\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.recavgadvocate\" ng-if=\"showAdvocate\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.recavgpress\" ng-if=\"showPress\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.recavgfollow\" ng-if=\"showFollow\" readonly></input-stars>\r\n                    , <strong>Factual :</strong>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.factfavg\" ng-if=\"showfAvg\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.factfavgvoters\" ng-if=\"showfVoters\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.factfavgpolitician\" ng-if=\"showfPolitician\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.factfavgadvocate\" ng-if=\"showfAdvocate\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.factfavgpress\" ng-if=\"showfPress\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.factfavgfollow\" ng-if=\"showfFollow\" readonly></input-stars>\r\n                </div>\r\n                <div ng-if=\"forumthread.mediaType==\'Video\'\" ng-bind-html=\'forumthread.mediaFile | urlify\'></div>\r\n                <div ng-if=\"forumthread.mediaType==\'Audio\'\" ng-bind-html=\'forumthread.mediaFile | urlify\'></div>\r\n                <p ng-if=\"GalleryFolder && forumthread.mediaType==\'Stills\'\" style=\"text-align: left;\">\r\n                    <img ng-src=\"{{GalleryFolder}}/{{forumthread.mediaFile}}\" style=\"max-width:300px;\" />\r\n                </p>\r\n                <div class=\"DescriptionImg\" ng-bind-html=\'forumthread.description | convertHTML\'></div>\r\n                <div> Posted by\r\n <!--                   <a href=\"#!/publicProfile/{{forumthread.createdBy.id}}\" ng-if=\"forumthread.createdBy.utype!=\'PressM\'\">{{forumthread.createdBy.name}}</a>  -->\r\n                    <a href=\"#!/pressProfile/{{forumthread.createdBy.id}}\" ng-if=\"forumthread.createdBy.utype==\'PressM\'\">{{forumthread.createdBy.name}}</a>\r\n  <!--                  <span ng-if=\"forumthread.createdBy.orgdata\">({{forumthread.createdBy.orgdata.title}})</span>--> Xon {{forumthread.createdOn | date:\'medium\'}}\r\n                </div>\r\n            </div>\r\n            <div style=\"width:9%; float: left; text-align: center;\" ng-if=\"forumthread.createdBy.id==userId || userRole==\'admin\'\">\r\n                <span ng-click=\"GotoEdit(forumthread._id);\" style=\"text-decoration: underline; cursor: pointer;\">Edit</span> &nbsp;\r\n                <span ng-click=\"GotoRemove(forumthread._id);\" style=\"text-decoration: underline; cursor: pointer;\">Remove</span>\r\n            </div>\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n    </div>\r\n    <div style=\"background-color: #eee; padding:10px; border: solid 1px #000; height:100px;\" ng-if=\"searchResults.data == 0\">\r\n        No records found.\r\n    </div>\r\n    <div style=\"float:right;\">\r\n        <dir-pagination-controls max-size=\"5\" pagination-id=\"list.id\"></dir-pagination-controls>\r\n    </div>\r\n</div>\r\n<script type=\"text/ng-template\" id=\"field_renderer\">\r\n    <ul class=\"catList\">\r\n        <li>\r\n            <div class=\"catname\" id=\"{{subent._id}}\" ng-if=\"(subent.parentIds.length == 0) && (subent.subcategories)\">\r\n                <input type=\"checkbox\" ng-click=\"getVal(subent)\">\r\n                <label ng-click=\"ChangeShow(subent._id);\">{{::subent.title}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id)==-1\"></i><i class=\"fa fa-caret-right\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id) > -1\"></i></label>\r\n            </div>\r\n            <div class=\"catname\" ng-if=\"(subent.parentIds.length == 0) && (!subent.subcategories)\">\r\n                <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                    <input type=\"checkbox\" ng-click=\"getVal(subent)\"> {{::subent.title}}\r\n                </label>\r\n            </div>\r\n            <label class=\"checkbox\" ng-if=\"subent.parentIds.length > 0 && showSubCat\" title=\"{{subent.title}}\">\r\n                <input type=\"checkbox\" ng-click=\"getVal(subent)\"> {{::subent.title}}\r\n            </label>\r\n            <ul ng-if=\"subent.subcategories\" ng-class=\"subent.parentIds.length == 0 ? \'cmnUL MainCatLi_{{subent._id}}\' : \'\'\">\r\n                <li ng-repeat=\"subent in subent.subcategories track by $index\" ng-include=\"\'field_renderer\'\">\r\n                    <!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                      <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n                    </label> -->\r\n                </li>\r\n            </ul>\r\n        </li>\r\n    </ul>\r\n</script>\r\n");
$templateCache.put("app/exploreQuiz/exploreQuiz.html","<div class=\"container-fluid\">\r\n  <h2 class=\"pageHeading\">INVITATION ONLY QUIZ</h2>\r\n  <center>\r\n    <div ng-if=\"showLoader\" style=\"z-index: 2; background:black;\">\r\n      <i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span>\r\n    </div>\r\n\r\n  </center>\r\n  <div ng-if=\"showInfo\">\r\n    <p class=\"pageSubHeading\">You have been invited by <span style=\"text-transform: capitalize\";><b>\r\n					<a href=\"#!/pressProfile/{{inviterId}}\" class=\"ylink\" ng-if=\"userProfile.userType== \'advocate\'\">{{inviterName}} </a>\r\n						<a href=\"#!/publicProfile/{{inviterId}}\" class=\"ylink\" ng-if=\"userProfile.userType== \'politician\' \">{{inviterName}} </a>\r\n						<a href=\"#!/voterProfile/{{inviterId}}\" class=\"ylink\" ng-if=\"userProfile.userType==\'voter\'\">{{inviterName}} </a>\r\n					</b></span>\r\n      to\r\n      answer their quiz.</p>\r\n\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <div ng-click=\"getQuiz()\" class=\"blockLink\"><img ng-src=\"./assets/images/quiz.svg\" class=\"gettingStartedImg img-fluid\">\r\n        <div class=\"showFollQuizDetails gettingStartedBlock1\">\r\n          <div>\r\n            <h4 class=\"gettingStartedBlockTitle\" style=\"text-transform: uppercase;\"><b>{{category.title}}</b></h4>\r\n\r\n            <p ng-if=\"$root.userRole==\'politician\'|| $root.userRole==\'advocate\' \">As you answer each question, they will\r\n              be saved and made public. Because the\r\n              world is always changing and new information is always developing, you will probably want to change your\r\n              answers in the future. We give you the ability to change your answers at any time. Users will be able to\r\n              see\r\n              your old answers and the reasons you gave for changing your position. </p>\r\n            <div ng-if=\"$root.userRole!=\'politician\'&& $root.userRole!=\'advocate\'\">Your answers will be shared\r\n              with<span style=\"text-transform: capitalize\"><b> {{inviterName}}</b>.</span> If there are any particular questions\r\n              that you don\'t want to share with <span style=\"text-transform: capitalize\"> {{inviterName}}</span> (including ones on this quiz that you answered in the past), you will have the option to hide them at the end of the quiz before you see your match-up. <br>By default, your profile will\r\n              be set to follow <span style=\"text-transform: capitalize\"> {{inviterName}}</span> so you can more easily keep up with what they are up to, but you can unfolow them at any time.</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <center>\r\n        <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"getQuiz()\">\r\n                         Take Quiz\r\n     </button>\r\n      </center>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/exportOrgRatings/exportOrgRatings.html","<div class=\"container-fluid\">\r\n  <h3>Export Rating Of Organizations</h3>\r\n  <a href=\"javascript: void(0);\"  ng-click=\"exportData();\" class=\"ylink\">Export Data</a> &nbsp;&nbsp;\r\n  <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loader\"></i>\r\n</div>\r\n");
$templateCache.put("app/faq/faq.html","\r\n<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">FREQUENTLY ASKED QUESTIONS</h2>\r\n  <p class=\"pageSubHeading\"></p>\r\n    \r\n \r\n\r\n  <div class=\"row d-flex justify-content-center\">\r\n    <div class=\"col col-lg-12 col-med-12 col-sm-12 col-12 colPadding1\">\r\n      <div class=\"row\">\r\n        <center><div class=\"col-lg-12 col-sm-12 contactBlock\">\r\n          \r\n          \r\n            <div><br>\r\n              <h4 class=\"blockTitleLearn\">Who Funds VoteWise? </h4>\r\n             \r\n            </div><div style=\"text-align: left;\">\r\n<p><b></b> VoteWise is a project of SilentMonkeys, a 501(c)3 educational nonprofit whose goal is to teach people to think for themselves, inform them about the issues that face them, and motivate them to do whatever they feel best to make the world a better place.  We are dedicated to being fair and balanced.  To avoid being influenced, we rely heavily upon small donations and lots of volunteers.  So, if you like what you see, please feel free to donate a few dollars or volunteer to help out.</p>\r\n  <center>\r\n      <a href=\"#!/donate\">\r\n        <button class=\"compareBtn\">\r\n          <b>Donate</b>\r\n        </button>\r\n      </a>\r\n    </center>\r\n            \r\n              <div><br>\r\n              <h4 class=\"blockTitleLearn\">Why don\'t we have images of the candidates? </h4>\r\n             \r\n            </div>\r\n    <p><b></b> We want to focus on ideas, not images.  There have been a number of studies where photos of candidates in one state were shown to people in other states.  Even though the people in these other states had never heard of the politicians, they were able to accurately predict who would win.  This is horrible.  Attractiveness does not make someone a better politician.  It may have an initial impact, but when you are working with someone in office every day, their ideas win out.  If your curiosity gets the best of you, there are plenty of other places online where you can find out what someone looks like, but at VoteWise, we are trying to create a place where ideas and ideas alone win the day.</p><br>\r\n            \r\n            \r\n            <div><br>\r\n              <h4 class=\"blockTitleLearn\">Everyone has a bias.  What&rsquo;s yours? </h4>\r\n             \r\n            </div>\r\n            \r\n    <p><b></b> We believe that great democracy depends on great information.  We don&rsquo;t believe that any single person, party or group has the absolute correct way of doing things, but we believe that if the logic of ALL sides can be listened to, then the best answers can be found.  There have been many studies to show that group wisdom is far better than individual wisdom.  For example, there was a study that had people guessing how many jelly beans were in a 5 gallon jar.  No single person guessed it right.  Many guessed far more beans than were in the jar and many guessed far fewer than in the jar, but when you averaged them all out, their guess as a whole was almost exactly correct.  This is not to be confused with mob rule where people&rsquo;s passions are fired up to the point where no thought is going on &ndash; fight or flight instincts take over and tragedy soon follows.  So it&rsquo;s important to listen to everyone in a calm, cool, and collected way.  Speak with logic not hate.  Everyone has wisdom if you listen carefully for it.  And if you listen enough, you can find solutions to anything. </p><br>\r\n									\r\n									<div><br>\r\n									<h4 class=\"blockTitleLearn\">What is your Privacy Policy</h4>\r\n									<p>Our aim is to balance reliability of information, privacy, and the sharing of your ideas so they have their greatest possible impact.  For a full description, click the link below.</p>\r\n									 <center>\r\n      <a href=\"#!/privacyPolicy\">\r\n        <button class=\"compareBtn\">\r\n          <b>Privacy</b>\r\n        </button>\r\n      </a>\r\n    </center></div>\r\n            </div></div></center>\r\n    \r\n\r\n\r\n\r\n\r\n");
$templateCache.put("app/federalBills/federalBills.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\"> Federal Bills</h2>\r\n  <p class=\"pageSubHeading\">Find Federal level legislation, see how far it has gotten and who voted on it.</p>\r\n\r\n \r\n  <form name=\"myForm\" role=\"form\">\r\n    <div ng-if=\"!searchTool\">\r\n      <div class=\"form-group row\">\r\n        <label style=\"color:#ffffff;padding-left: 5%;padding-right: 5%\">Search: </label>\r\n        <!-- <div class=\"col-lg-5 col-sm-5\"> -->\r\n        <input type=\"text\" ng-model=\"selType.title\" id=\"title\" name=\"title\" ng-minlength=\"3\" class=\"form-control\" placeholder=\"Search by Keyword\" style=\"width:170px;\">\r\n        <!-- </div> -->\r\n        <br>\r\n        <div ng-show=\"myForm.title.$dirty\" style=\"padding-left: 2%;color: red\" role=\"alert\">\r\n          <span ng-show=\"myForm.title.$error.minlength\">Please enter at least 3 characters</span>\r\n        </div>\r\n      </div>\r\n   \r\n              <div class=\"form-group row\">\r\n        <label style=\"color:#ffffff;padding-left: 5%;padding-right: 5%\"> Congress</label>\r\n        <select ng-model=\"selType.congress\" class=\"form-control\" style=\"width:180px;display:inline-block;\">\r\n          <option value=\"\">Select Congress</option>\r\n          <option value=\"116\">116th (2019-2020)</option>\r\n          <option value=\"115\">115th (2017-2018)(</option>\r\n          <option value=\"114\">114th (2015-2016)</option>\r\n          <option value=\"113\">113th (2013-2014)</option>\r\n        </select>\r\n      </div>\r\n        \r\n        \r\n        \r\n      <div class=\"form-group row\">\r\n        <label style=\"padding-left: 5%;padding-right: 5%\">Skip bills that became law</label>\r\n        <input type=\"checkbox\" name=\"law\" ng-model=\"selType.law\">\r\n      </div>\r\n        <div class=\"form-group row\">\r\n          <label style=\"padding-left: 5%;padding-right: 5%\">Skip bills that were voted down </label>\r\n          <input type=\"checkbox\" name=\"vote\" ng-model=\"selType.vote\">\r\n      </div>\r\n          <button class=\"blackText\" style=\"margin-left:5%\" ng-click=\"SearchBy(\'\',\'clicked\')\">Search</button>\r\n          <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loader\"></i>\r\n        </div>\r\n <p ng-if=\"countData\">\r\n    <h3>Total Count: {{countData}}</h3>\r\n  </p>\r\n        <!-- <div class=\"form-group row\">\r\n      <a href=\"\"class=\"ylink\" ng-if=\"!moreTool\" style=\"margin-left:5%\" ng-click=\"more()\"> Advanced Search Options</a>\r\n    </div> -->\r\n    \r\n    <!--\r\n        <p ng-if=\"search\" style=\"display: block; text-align: center;\">\r\n          <label>Search For</label>\r\n          <span ng-if=\"selType.congress\">Congress: {{selType.congress}}</span>\r\n\r\n          <span ng-if=\"selType.senate && selType.senate != \'Any Senator\'\">Senator: {{selType.senate}}</span>\r\n          <br>\r\n          <span ng-if=\"selType.house && selType.house != \'Any Representative\'\">Representattive: {{selType.house}}</span>\r\n          <br>\r\n          <span ng-if=\"selType.action &&  selType.action != \'Any Legislative Action\' \">Legislative Action: {{selType.action}}</span>\r\n          <br>\r\n          <span ng-if=\"sim.selHouse.length > 0\">House Committees</span>\r\n          <div style=\"display: block; text-align: center;\" ng-if=\"sim.selHouse\" ng-repeat=\"h in sim.selHouse\">\r\n            <span ng-if=\"h\">{{h}}</span>\r\n          </div>\r\n          <span style=\"display: block; text-align: center;\" ng-if=\"sim.selSenate.length > 0\">Senate Committees</span>\r\n          <div style=\"display: block; text-align: center;\" ng-if=\"sim.selSenate\" ng-repeat=\"s in sim.selSenate\">\r\n            <span ng-if=\"s\">{{s}}</span>\r\n          </div>\r\n        </p>\r\n\r\n-->\r\n\r\n        <div ng-if=\"searchTool\">\r\n          <fieldset class=\"scheduler-border\">\r\n            <legend class=\"scheduler-border\">Search</legend>\r\n            <div class=\"contactBlock d-flex justify-center container-fluid col-sm-10 col-lg-10\" style=\"width: 100%\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-12 col-md-12 col-sm-12\">\r\n                  <label style=\"padding-left: 5%;padding-right: 5%\"> Words & Phrases</label>\r\n                  <textarea class=\"form-control\" ng-model=\"selType.title\" rows=\"1\" placeholder=\"Search\"></textarea>\r\n                  <br>\r\n                  <!-- <div class=\" form-group row\">\r\n              <input type=\"checkbox\" name=\"law\" ng-model=\"selType.law\">\r\n              <label>Include bill text in the search &nbsp;|&nbsp;</label>\r\n              <input type=\"checkbox\" name=\"law\" ng-model=\"selType.law\">\r\n              <label>Word Variants </label>\r\n              &nbsp;&nbsp;&nbsp; <input type=\"checkbox\" name=\"law\" ng-model=\"selType.law\">\r\n              <label>Case Sensitive &nbsp;|&nbsp;</label>\r\n              &nbsp;&nbsp;<label>Search only</label>\r\n              &nbsp;&nbsp;&nbsp;\r\n              <input type=\"checkbox\" name=\"law\" ng-model=\"selType.law\"> <label>Titles </label> &nbsp;&nbsp;\r\n              <input type=\"checkbox\" name=\"law\" ng-model=\"selType.law\"> <label>Summaries</label> &nbsp;&nbsp;\r\n              <input type=\"checkbox\" name=\"law\" ng-model=\"selType.law\"><label>Actions</label>\r\n            </div> -->\r\n                  <div class=\"form-group row\">\r\n                    <div class=\"col-sm-6 col-lg-6\">\r\n                      <label><b>Congress</b></label>\r\n                      <p> <select ng-model=\"selType.congress\" class=\"form-control\" style=\"width:170px;display:inline-block;\">\r\n                      <option value=\"\">Select Congress</option>\r\n                      <option value=\"116\">116th</option>\r\n                      <option value=\"115\">115th</option>\r\n                      <option value=\"114\">114th</option>\r\n                      <option value=\"113\">113th</option>\r\n                    </select>\r\n                      </p>\r\n                    </div>\r\n                    <div class=\"col-sm-6 col-lg-6\">\r\n                      <label> <b>Sponsors/Cosponsors</b></label>\r\n                      <br>\r\n                      <input type=\"checkbox\" name=\"sponsor\" ng-model=\"selType.sponsor\"> <label>Sponsor </label>\r\n                      &nbsp;&nbsp;\r\n                      <input type=\"checkbox\" name=\"cosponsor\" ng-model=\"selType.cosponsor\"> <label>Cosponsor</label>\r\n                      &nbsp;&nbsp;\r\n                      <p>\r\n                        <select ng-model=\"selType.house\" class=\"form-control\" ng-init=\"selType.house=houseRepresent[0]\" ng-options=\"item for item in houseRepresent\" style=\"width:198px;display:inline-block;\">\r\n                    </select>\r\n                      </p>\r\n                      <p>\r\n                        <select ng-model=\"selType.senate\" class=\"form-control\" ng-init=\"selType.senate=senateRepresent[0]\" ng-options=\"item for item in senateRepresent\" style=\"width:180px;display:inline-block;\">\r\n                    </select>\r\n                      </p>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"form-group row\">\r\n                    <div class=\"col-sm-6 col-lg-6\">\r\n                      <!--   <label><b>Legislation and Law Numbers</b></label>\r\n                <input type=\"text\" class=\"form-control\" name=\"legislation\" ng-model=\"selType.legislation\"> -->\r\n                      <p>\r\n                        <label><b>Committees</b></label>\r\n                      </p>\r\n                      <!-- <p> -->\r\n                      <label>Any House Committees</label>\r\n                      <div class=\"DisplaySen changeTextColor\">\r\n                        <ul class=\"TcatList\">\r\n                          <li ng-repeat=\"hou in house track by $index\">\r\n                            <input type=\"checkbox\" name=\"hou\" ng-model=\"selType.selHouse[hou]\" ng-value=\"hou\">\r\n                            <label>{{hou}}&nbsp;\r\n                        </label>\r\n                          </li>\r\n                        </ul>\r\n                      </div>\r\n                      <!--   <select ng-model=\"selType.house\" class=\"form-control\" style=\"width:298px;display:inline-block;\">\r\n                    <option ng-repeat=\" h in senate\">\r\n                      <input type=\"checkbox\" ng-model=\"selType.selected[h]\" name=\"sel\">{{h}}\r\n                    </option>\r\n                  </select> -->\r\n                      <!-- </p> -->\r\n                    </div>\r\n                    <div class=\"col-sm-6 col-lg-6\">\r\n                      <p>\r\n                        <!-- <select ng-model=\"selType.senate\" class=\"form-control\" ng-options=\"item for item in house\" style=\"width:330px;\">\r\n                  </select> -->\r\n                        <label>Any Senate Committees</label>\r\n                        <div class=\"DisplaySen changeTextColor\">\r\n                          <ul class=\"TcatList\">\r\n                            <li ng-repeat=\"sen in senate track by $index\">\r\n                              <input type=\"checkbox\" ng-model=\"selType.selSenate[sen]\" ng-value=\"sen\">\r\n                              <label>{{sen}}&nbsp;\r\n                          </label>\r\n                            </li>\r\n                          </ul>\r\n                        </div>\r\n                      </p>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"form-group row\">\r\n                    <div class=\"col-sm-6 col-lg-6\">\r\n                      <label><b>Legislative Actions</b></label>\r\n                      <p>\r\n                        <select ng-model=\"selType.action\" class=\"form-control\" ng-init=\"selType.action=actionType[0]\" ng-options=\"item for item in actionType\" style=\"width:480px;display:inline-block;\">\r\n                    </select>\r\n                      </p>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"form-group row\">\r\n                    <div class=\"col-lg-6\">\r\n                      <button class=\"blackText form-control btn-primary\" ng-click=\"reset()\">Reset</button>\r\n                    </div>\r\n                    <div class=\"col-lg-6\">\r\n                      <button type=\"submit\" class=\"blackText form-control  btn-primary\"  ng-click=\"SearchBy(\'\',\'clicked\')\">Search</button>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n  </form>\r\n  <br>\r\n  <!-- <div ng-if=\"!showOne\" ng-controller=\"federalBillsCtrlOne\">\r\n    <div infinite-scroll=\'myPagingFunction()\'>\r\n      <table class=\"w100 changeTextColor\" ng-show=\"fData.length > 0\">\r\n        <tr>\r\n          <th style=\"width:15%\">Bill Type</th>\r\n          <th style=\"width:60%\">Title</th>\r\n          <th style=\"width:15%\">Policy Area</th>\r\n          <th style=\"width:9%\">Details</th>\r\n        </tr>\r\n        <tr ng-repeat=\"u in fData\">\r\n          <td>\r\n            <span ng-if=\"u.billType\">{{u.billType}}</span>\r\n          </td>\r\n          <td>\r\n            <p>\r\n              <span ng-if=\"u.billTitle\">{{u.billTitle}}</span>\r\n              <p>\r\n          </td>\r\n          <td>\r\n            <p>\r\n              <span ng-if=\"u.policyArea.name\">{{u.policyArea.name}}</span></p>\r\n          </td>\r\n          <td>\r\n            <a href=\"#!/federalDetail/{{u._id}}\" class=\"link\">Get Details</a>\r\n          </td>\r\n        </tr>\r\n        <tr ng-if=\"fData.length == 0\">\r\n          <td colspan=\"3\"> No records found.\r\n          </td>\r\n        </tr>\r\n      </table>\r\n      <p ng-if=\"statusGetResPg == 1 && serachData > fData.length\" class=\"fwb\">Loading Federal Bills Data...</p>\r\n    </div>\r\n  </div> -->\r\n  <div>\r\n    <div infinite-scroll=\'pageFunction()\'>\r\n      <table class=\"w100 changeTextColor\" ng-show=\"fedData.length > 0\">\r\n        <tr>\r\n          <th style=\"width:15%\">Bill Type</th>\r\n          <th style=\"width:60%\">Title</th>\r\n          <th style=\"width:15%\">Policy Area</th>\r\n          <th style=\"width:9%\">Details</th>\r\n        </tr>\r\n        <tr ng-repeat=\"u in fedData\">\r\n          <td>\r\n            <span ng-if=\"u.billType\">{{u.billType}}</span>\r\n          </td>\r\n          <td>\r\n            <p>\r\n              <span ng-if=\"u.billTitle\">{{u.billTitle}}</span>\r\n              <p>\r\n          </td>\r\n          <td>\r\n            <p>\r\n              <span ng-if=\"u.policyArea.name\">{{u.policyArea.name}}</span></p>\r\n          </td>\r\n          <td>\r\n            <a href=\"\" ng-click=\"getDetailPage(u._id)\" class=\"link\">Get Details</a>\r\n          </td>\r\n        </tr>\r\n        <tr ng-if=\"fedData.length == 0\">\r\n          <td colspan=\"3\"> No records found.\r\n          </td>\r\n        </tr>\r\n      </table>\r\n      <p ng-if=\"statusGetResPg == 1 && countData > fedData.length\" class=\"fwb\">Loading Federal Bills Data...</p>\r\n    </div>\r\n  </div>\r\n</div>\r\n<!-- <form name=\"federalctrl\" id=\"federalctrl\" ng-controller=\"federalBillsCtrlOne\" class=\"closeForm\">\r\n    <div ng-if=\"!showOne\">\r\n\r\n\r\n      <div infinite-scroll=\'myPagingFunction()\'>\r\n        <table class=\"w100 changeTextColor\" ng-show=\"fData.length > 0\">\r\n          <tr>\r\n            <th style=\"width:15%\">Bill Type</th>\r\n            <th style=\"width:60%\">Title</th>\r\n            <th style=\"width:15%\">Policy Area</th>\r\n            <th style=\"width:9%\">Details</th>\r\n          </tr>\r\n          <tr ng-repeat=\"u in fData\">\r\n            <td>\r\n              <span ng-if=\"u.billType\">{{u.billType}}</span>\r\n            </td>\r\n            <td>\r\n              <p>\r\n                <span ng-if=\"u.billTitle\">{{u.billTitle}}</span>\r\n                <p>\r\n            </td>\r\n            <td>\r\n              <p>\r\n                <span ng-if=\"u.policyArea.name\">{{u.policyArea.name}}</span></p>\r\n            </td>\r\n            <td>\r\n              <a href=\"#!/federalDetail/{{u._id}}\" class=\"link\">Get Details</a>\r\n            </td>\r\n          </tr>\r\n          <tr ng-if=\"fData.length == 0\">\r\n            <td colspan=\"3\"> No records found.\r\n            </td>\r\n          </tr>\r\n        </table>\r\n        <p ng-if=\"statusGetResPg == 1 && serachData > fData.length\" class=\"fwb\">Loading OpenState Data...</p>\r\n      </div>\r\n    </div>\r\n    <div ng-if=\"showOne\">\r\n      <h1>welcome</h1>\r\n    </div>\r\n  </form> -->\r\n");
$templateCache.put("app/federalDetails/federalDetails.html","<div class=\"container-fluid\">\r\n  <form name=\"federal\" id=\"federal\" ng-controller=\"federalCtrl\" class=\"closeForm\">\r\n    <br>\r\n    <h2 style=\"color:#ffffff;\">Details</h2>\r\n    <br>\r\n    <div>\r\n      <div>\r\n        <a href=\"\" ng-click=\"backTo()\" class=\"ylink\">Back</a>\r\n        <fieldset class=\"scheduler-border\">\r\n          <legend class=\"scheduler-border\">Bill Detail</legend>\r\n          <div class=\"billDetailBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\" style=\"width: 100%\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-12\"><br><br>\r\n                <center>\r\n                  <p ng-if=\"details.billType && details.billNumber\">\r\n                    <b> {{details.billType}} {{details.billNumber}},</b><span ng-if=\"details.congress\"><b> {{details.congress}}<em>th</em> Congress</b></span>\r\n                  </p>\r\n                </center>\r\n                <center>\r\n                  <p ng-if=\"details.introductoryDate\"><b>Introduced:</b> {{details.introductoryDate | date : \"M/d/y\"}}\r\n                  </p>\r\n                </center>\r\n\r\n                <p ng-if=\"details.billTitle\"> <b>\"{{details.billTitle}}\"</b></p>\r\n\r\n                <p>\r\n                  <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><a href=\"\" ng-show=\"details.titles.length > 0\" class=\"link\" ng-click=\"activeTitles = !activeTitles\"> <b>More Titles</b></a>\r\n                </p>\r\n                <div ng-hide=\"activeTitles\">\r\n                  <p ng-if=\"details.titles.length > 0\" ng-repeat=\" d in details.titles\">\r\n                    <span ng-if=\"d.titleType\"> <b>Title Type:</b> {{d.titleType}} </span>\r\n                    <br>\r\n                    <span ng-if=\"d.title\"> <b>Title:</b> {{d.title}} </span>\r\n                  </p>\r\n                </div>\r\n\r\n\r\n\r\n                <!-- <p ng-if=\"details.latestAction.description\"> <b>Text:</b> {{details.latestAction.description}}</p> -->\r\n\r\n                <p ng-if=\"details.latestAction.description && details.latestAction.actionDate\"><b>Latest Action:</b>\r\n                  {{details.latestAction.actionDate | date : \"M/d/y\" }} &nbsp;&nbsp;{{details.latestAction.description}}\r\n                </p>\r\n                <!-- <p ng-if=\"details.billNumber\"> <b>Bill Number:</b> {{details.billNumber}}</p> -->\r\n                <p>\r\n                  <a href=\"\" ng-show=\"votesData.votes.yes.length > 0\" class=\"link\" ng-click=\"activeVots = !activeVots\">Votes: {{votesData.votes.yes.length}}</a>\r\n                </p>\r\n                <div ng-hide=\"activeVots\">\r\n                  <p ng-if=\"votesData.votes.yes.length > 0\"> Yes</p>\r\n                  <p ng-show=\"votesData.votes.yes.length > 0\" ng-repeat=\" y in votesData.votes.yes \">\r\n                    <span ng-if=\"y.name\"><b>Name:</b>  {{y.name}}</span>\r\n                    <br>\r\n                    <span ng-if=\"y.party\"><b>Party:</b>  {{y.party}}</span>\r\n                    <br>\r\n                    <span ng-if=\"y.state\"><b>State:</b>  {{y.state}}</span>\r\n                  </p>\r\n                  <p ng-if=\"votesData.votes.no.length > 0\"> No</p>\r\n                  <p ng-show=\"votesData.votes.no.length > 0\" ng-repeat=\" n in votesData.votes.no \">\r\n                    <span ng-if=\"n.name\"><b>Name:</b>  {{n.name}}</span>\r\n                    <br>\r\n                    <span ng-if=\"n.party\"><b>Party:</b>  {{n.party}}</span>\r\n                    <br>\r\n                    <span ng-if=\"n.state\"><b>State:</b>  {{n.state}}</span>\r\n                  </p>\r\n                  <p ng-if=\"votesData.votes.notVoting.length > 0\"> Not Voting</p>\r\n                  <p ng-show=\"votesData.votes.notVoting.length > 0\" ng-repeat=\" n in votesData.votes.notVoting \">\r\n                    <span ng-if=\"n.name\"><b>Name:</b>  {{n.name}}</span>\r\n                    <br>\r\n                    <span ng-if=\"n.party\"><b>Party:</b>  {{n.party}}</span>\r\n                    <br>\r\n                    <span ng-if=\"n.state\"><b>State:</b>  {{n.state}}</span>\r\n                  </p>\r\n                </div>\r\n\r\n\r\n                <p ng-if=\"details.policyArea.name\"><b>Policy Area:</b> {{details.policyArea.name}}</p>\r\n\r\n                <p ng-show=\"details.billSubjects.legislativeSubjects.length > 0\"><b>Legislative Subjects: </b>\r\n                  <span ng-show=\"details.billSubjects.legislativeSubjects.length > 0\" ng-repeat=\" l in details.billSubjects.legislativeSubjects \">\r\n                    <span ng-if=\"l.name\"> {{l.name}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>\r\n                  </span></p>\r\n\r\n                <span ng-if=\"b.text\"><b>Text:</b> {{b.text}}</span>\r\n\r\n\r\n                <p>\r\n                  <a href=\"\" class=\"link\" ng-show=\"details.billSummaries.length > 0\" ng-click=\"activeSpo =!activeSpo\"><b>Bill Summaries</b></a>\r\n                </p>\r\n                <div ng-hide=\"activeSpo\">\r\n                  <p ng-show=\"details.billSummaries.length > 0\" ng-repeat=\" b in details.billSummaries\">\r\n                    <span ng-if=\"b.actionDate\"><b>Action Date:</b> {{b.actionDate | date : \"M/d/y\"}}</span>\r\n                    <br>\r\n                    <span ng-if=\"b.actionDesc\"><b>Action Description:</b> {{b.actionDesc}}</span>\r\n                    <br>\r\n                    <span ng-if=\"b.lastSummaryUpdateDate\"><b>Last Summary UpdateDate:</b> {{b.lastSummaryUpdateDate | date : \"M/d/y\"}}</span>\r\n                    <br>\r\n                    <span ng-if=\"b.name\"><b>Name:</b> {{b.name}}</span>\r\n                    <br>\r\n                    <span ng-if=\"b.text\"><b>Text:</b> {{b.text}}</span>\r\n                    <br>\r\n                    <span ng-if=\"b.updateDate\"><b>Update Date:</b> {{b.updateDate | date : \"M/d/y\"}}</span>\r\n                    <br>\r\n                    <span ng-if=\"b.versionCode\"><b>Version Code:</b> {{b.versionCode}}</span>\r\n                    <br>\r\n                    <span ng-if=\"details.form.officialTitle\"><b>Official Title:</b> {{details.form.officialTitle}}</span>\r\n                    <br>\r\n                    <span ng-if=\"b.description\"> <b>Text:</b></span><br>\r\n                    <span ng-if=\"b.description\" ng-bind-html=\'checkData(b.description)\'></span>\r\n                    <!-- <span ng-if=\"details.form.session\">Session: {{details.form.session}}</span> -->\r\n                  </p>\r\n                </div>\r\n\r\n\r\n\r\n                <!-- <p ng-if=\"details.latestAction\"><b>Latest Action:</b> {{details.latestAction.text}}</p> -->\r\n\r\n\r\n\r\n\r\n\r\n                <p>\r\n                  <a href=\"\" class=\"link\" ng-show=\"details.actions.length > 0\" ng-click=\"activeAct = !activeAct\"><b>Actions</b></a>\r\n                </p>\r\n                <div ng-hide=\"activeAct\">\r\n                  <p ng-if=\"details.latestAction.actionDate\"><b>Latest Action:</b>\r\n                    {{details.latestAction.actionDate | date : \"M/d/y\"}}</p>\r\n                  <p ng-if=\"details.actionByCounts.senate\"><b>Action By Count:</b> {{details.actionByCounts.senate}}\r\n                    <span ng-if=\"details.actionTypeCounts.agreedToInSenate\"> <b>Agreed To In Senate:</b> {{details.actionTypeCounts.agreedToInSenate}}  </span>\r\n                    <br>\r\n                    <span ng-if=\"details.actionTypeCounts.committeeDischarged\"> <b>Committee Discharged:</b> {{details.actionTypeCounts.committeeDischarged}}  </span>\r\n                    <br>\r\n                    <span ng-if=\"details.actionTypeCounts.introducedInSenate\"><b> Introduced In Senate:</b> {{details.actionTypeCounts.introducedInSenate}}  </span>\r\n                    <br>\r\n                    <span ng-if=\"details.actionTypeCounts.passedAgreedToInSenate\"> <b>Passed Agreed To In Senate:</b> {{details.actionTypeCounts.passedAgreedToInSenate}}  </span>\r\n                    <br>\r\n                    <span ng-if=\"details.actionTypeCounts.passedOrAgreedToInSenateDayOf\"><b> Passed Or Agreed To In Senate Day Of:</b> {{details.actionTypeCounts.passedOrAgreedToInSenateDayOf}}  </span>\r\n                    <br>\r\n                    <span ng-if=\"details.actionTypeCounts.referredToCommittee\"> <b>Referred To Committee:</b> {{details.actionTypeCounts.referredToCommittee}}  </span>\r\n                  </p>\r\n                  <div class=\"p\" ng-repeat=\"s in details.actions\">\r\n                    <span ng-if=\"s.actionDate\"><b>Action Date:</b> {{s.actionDate | date : \"M/d/y\"}}</span><br>\r\n                    <span ng-if=\"s.committee.name && s.committee.name !=\'\'\"><b>Committee Name:</b> {{s.committee.name}}<br> </span>\r\n\r\n\r\n                    <span ng-if=\"s.text\"><b>Text:</b> {{s.text}}<br></span>\r\n\r\n                    <span ng-if=\"s.type\"><b>Type:</b> {{s.type}}<br></span>\r\n                    <span ng-if=\"s.description\"><b>Description:</b> {{s.description}}<br></span>\r\n                    <p ng-if=\"s.sourceSystem.name\">\r\n                      <b>Name:</b>\r\n                      {{s.sourceSystem.name}}\r\n                      <br>\r\n                      <span  ng-if=\"s.sourceSystem.code\" >\r\n                        <b>Code:</b> {{s.sourceSystem.code}}\r\n                       </span>\r\n                    </p><br>\r\n                    <span ng-if=\"s[\'action-desc\']._text\"> <b>Text:</b> {{s[\'action-desc\']._text}}</span><br>\r\n                  </div>\r\n                  </div>\r\n                  <p ng-if=\"votesData.source_url\">\r\n                    <span ng-if=\"votesData.source_url\"><b>Source url:</b> <a href=\"{{votesData.source_url}}\" target=\"_blank\" ng-if=\"votesData.source_url\" class=\"link\">{{votesData.source_url}}</a> </span>\r\n                  </p>\r\n\r\n\r\n\r\n                  <p ng-if=\"details.textVersions.url\"><b>See full text of bill:</b>\r\n                    <a href=\"{{details.textVersions.url}}\" target=\"_blank\"  class=\"link\"><b>{{details.textVersions.url}}</b></a>\r\n                  </p>\r\n                  <!-- <div ng-hide=\"activeText\">\r\n                  <p ng-show=\"details.billSummaries.length > 0\" ng-repeat=\" b in details.billSummaries\">\r\n                    <span ng-if=\"b.description\" ng-bind-html=\'checkData(b.description)\'></span>\r\n                  </p>\r\n                </div> -->\r\n\r\n\r\n\r\n\r\n                  <p>\r\n                    <a href=\"\" class=\"link\" ng-show=\"details.sponsors\" ng-click=\"activeVot =!activeVot\"><b> See Sponsors</b></a>\r\n                  </p>\r\n                  <div ng-hide=\"activeVot\">\r\n                    <div ng-if=\"details.sponsors\">\r\n                      <p>\r\n                        <span> {{details.sponsors.fullName}}</span>\r\n                        <!--<span> <b>Bioguide Id:</b> {{details.sponsors.bioguideId}}</span>\r\n                      <br>\r\n\r\n                      <br>\r\n                      <span><b>gpoId:</b> {{details.sponsors.identifiers.gpoId}}</span>\r\n                      <br>\r\n                      <span><b>lisID:</b> {{details.sponsors.identifiers.lisID}}</span>\r\n                      <br>\r\n-->\r\n                      </p>\r\n                      <br>\r\n                  </div>\r\n                      <!-- <p> <a href=\"\" ng-if=\"more[\'votes\']\" class=\"link\" ng-click=\"showLess(\'votes\')\">Less</a></p> -->\r\n                    </div>\r\n\r\n\r\n\r\n                  </div>\r\n                </div>\r\n              </div>\r\n        </fieldset>\r\n      </div>\r\n    </div>\r\n    <!-- Display Rating tool for organization and admin -->\r\n    <div ng-show=\"userRole == \'admin\' || userRole == \'advocate\' \">\r\n      <fieldset class=\"scheduler-border\">\r\n        <legend class=\"scheduler-border\">Rate Legislation</legend>\r\n        <div class=\"contactBlock d-flex justify-center container-fluid col-sm-12 col-lg-8\" style=\"width: 100%\">\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n              <div style=\"padding-top: 10%\">\r\n                <p>Rate : <input-stars max=\"5\" ng-click=\"rateLegislation();\" ng-model=\"rating.rate\"></input-stars>\r\n                  <!-- <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loader\"></i> -->\r\n                </p>\r\n                <!--     <div>\r\n                  Vote Legislation:\r\n                  <img src=\"../assets/images/thumbsup.svg\" ng-if=\"disImg\" id=\"imageOne\" ng-click=\"rateLegislation(\'Like\');\" style=\"cursor:pointer;width: 30px\" alt=\"Vote\">\r\n                  <img src=\"../assets/images/thumbsupone.png\" ng-if=\"!disImg\" id=\"imageOne\" ng-click=\"rateLegislation(\'Like\');\" style=\"cursor:pointer;width: 30px\" alt=\"Vote\">\r\n                </div> -->\r\n              </div>\r\n              <div class=\"inline2\" style=\"width: 90%; margin: auto;\">\r\n                Comments: <span ng-if=\"comment !=\'\'\">{{comment}}\r\n                  </span>\r\n                <!-- <center> -->\r\n                <button ng-click=\"redirectToComment();\" ng-if=\"displayComments\" class=\"compareBtn\">Add Comment</button>\r\n                <!-- </center> -->\r\n                <div class=\"inline2\" ng-if=\"ShowComments\">\r\n                  <form name=\"essayform\" id=\"essayform\">\r\n                    <fieldset class=\"scheduler-border\">\r\n                      <legend class=\"scheduler-border\">Your Comments</legend>\r\n                      <p></p>\r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-12\">\r\n                          <div class=\"control-group\">\r\n                            <div class=\"controls\">\r\n                              <textarea id=\"comments\" ng-model=\"comments.content\" placeholder=\"\" data-errormessage=\"Comments is required.\" class=\"form-control input-md  validate[required] text-area changeTextColor\" style=\"width: 80%; height: 100px;\"></textarea>\r\n                            </div>\r\n                          </div>\r\n                        </div>\r\n                        <!-- <div style=\"clear: both;\"></div> -->\r\n                        <div style=\"margin-top:20px; width:100%;\">\r\n                          <button ng-click=\"SubmitComment(comments)\" type=\"button\" class=\"compareBtn\" ng-disabled=\"CommentButton\" style=\"float: left;\">Submit Comments</button>\r\n                          <center><button ng-click=\"goBack();\" type=\"button\" class=\"compareBtn\">Cancel</button></center>\r\n                        </div>\r\n                      </div>\r\n                    </fieldset>\r\n                  </form>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </fieldset>\r\n    </div>\r\n    <!-- End  Display Rating tool for organization and admin -->\r\n  </form>\r\n</div>\r\n");
$templateCache.put("app/federalTextBills/federalTextBills.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">Settings</h2>\r\n  <div>\r\n    <div class=\"closeForm\" ng-include=\"\'app/popups/setting_Ctrl.html\'\"></div>\r\n  </div>\r\n  <!--   <h3>OpenState Data</h3> -->\r\n  <form name=\"track\" id=\"track\" ng-controller=\"federalTextBillsCtrl\" class=\"closeForm\">\r\n    <br>\r\n    <h2 style=\"color:#ffffff;\">Federal Text Bills</h2>\r\n    <br>\r\n    <p>\r\n      <!-- <label> Congress</label> -->\r\n      <select ng-model=\"selType.congress\" class=\"form-control\" style=\"width:170px;display:inline-block;\">\r\n        <option value=\"\">Select Congress</option>\r\n        <option value=\"116\">116th</option>\r\n        <option value=\"115\">115th</option>\r\n        <option value=\"114\">114th</option>\r\n        <option value=\"113\">113th</option>\r\n\r\n      </select>\r\n      <!-- <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loader\"></i> -->\r\n    </p>\r\n   <p>\r\n      <!-- <label> Congress</label> -->\r\n      <select ng-model=\"selType.session\" class=\"form-control\" style=\"width:170px;display:inline-block;\">\r\n        <option value=\"\">Select Session</option>\r\n        <option value=\"1\">1</option>\r\n        <option value=\"2\">2</option>\r\n      </select>\r\n      <!-- <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loader\"></i> -->\r\n    </p>\r\n   <!--  <p>\r\n      <a href=\"javascript: void(0)\" class=\"ylink\" ng-click=\"getfederalBills()\">Get Federal Bills</a>\r\n      <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loaderOne\"></i>\r\n      <br>\r\n    </p> -->\r\n    <p>\r\n      <select ng-model=\"selType.type\" class=\"form-control\" ng-change=\"getfederalBills()\" style=\"width:170px;display:inline-block;\">\r\n        <option value=\"\">Select Type</option>\r\n        <option value=\"sres\">SRES</option>\r\n        <option value=\"s\">S</option>\r\n        <option value=\"hjres\">HJRES</option>\r\n        <option value=\"sjres\">SJRES</option>\r\n        <option value=\"hr\">HR</option>\r\n        <option value=\"hconres\">HCONRES</option>\r\n        <option value=\"sconres\">SCONRES</option>\r\n        <option value=\"hres\">HRES</option>\r\n      </select>\r\n      <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loader\"></i>\r\n    </p>\r\n    <div ng-show=\"federal.length>0\">\r\n      <!--  <div class=\"form-group row\">\r\n          <label style=\"color:#ffffff;padding-left: 5%;padding-right: 5%\">Title: </label>\r\n     \r\n          <input type=\"text\" ng-model=\"searchCandy.search\" id=\"searchCandy\" class=\"form-control\" placeholder=\"Search by Title\" style=\"width:170px;\">\r\n          <button class=\"blackText\" style=\"margin-left:5%\" ng-click=\"SearchByTitle()\">Search</button>\r\n\r\n        </div> -->\r\n      <div infinite-scroll=\'myPagingFunction()\'>\r\n        <table class=\"w100 changeTextColor\" ng-show=\"federal.length > 0\">\r\n          <tr>\r\n            <th style=\"width:15%\">BillStage</th>\r\n            <th style=\"width:60%\">Title</th>\r\n            <th style=\"width:15%\">Publisher</th>\r\n            <!-- <th style=\"width:9%\">Details</th> -->\r\n          </tr>\r\n          <tr ng-repeat=\"u in federal\">\r\n            <td>\r\n              <span ng-if=\"u.billStage\">{{u.billStage}}</span>\r\n            </td>\r\n            <td>\r\n              <p>\r\n                <span ng-if=\"u.metaData.dublinCore.dcTitle\">{{u.metaData.dublinCore.dcTitle}}</span>\r\n                <p>\r\n            </td>\r\n            <td>\r\n              <p>\r\n                <span ng-if=\"u.metaData.dublinCore.dcPublisher\">{{u.metaData.dublinCore.dcPublisher}}</span></p>\r\n            </td>\r\n          <!--   <td>\r\n              <a href=\"#!/federalDetail/{{u._id}}\" class=\"link\">Get Details</a>\r\n            </td> -->\r\n          </tr>\r\n          <tr ng-if=\"open.length == 0\">\r\n            <td colspan=\"3\"> No records found.\r\n            </td>\r\n          </tr>\r\n        </table>\r\n        <p ng-if=\"statusGetResPg == 1 && serachData > openBills.length\" class=\"fwb\">Loading OpenState Data...</p>\r\n      </div>\r\n    </div>\r\n  </form>\r\n</div>\r\n");
$templateCache.put("app/federalTrack/federalTrack.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">Settings</h2>\r\n  <div>\r\n    <div class=\"closeForm\" ng-include=\"\'app/popups/setting_Ctrl.html\'\"></div>\r\n  </div>\r\n  <!--   <h3>OpenState Data</h3> -->\r\n  <form name=\"track\" id=\"track\" ng-controller=\"federalTrackCtrl\" class=\"closeForm\">\r\n    <br>\r\n    <h2 style=\"color:#ffffff;\">Federal Legislation</h2>\r\n    <br>\r\n    <p>\r\n      <!-- <label> Congress</label> -->\r\n      <select ng-model=\"selType.congress\" class=\"form-control\" style=\"width:170px;display:inline-block;\">\r\n        <option value=\"\">Select Congress</option>\r\n        <option value=\"116\">116th</option>\r\n        <option value=\"115\">115th</option>\r\n        <option value=\"114\">114th</option>\r\n        <option value=\"113\">113th</option>\r\n\r\n      </select>\r\n      <!-- <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loader\"></i> -->\r\n    </p>\r\n  \r\n  <!--   <p>\r\n      <a href=\"javascript: void(0)\" class=\"ylink\" ng-click=\"getfederalBills()\">Get Federal Bills</a>\r\n      <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loaderOne\"></i>\r\n      <br>\r\n    </p> -->\r\n    <p>\r\n      <select ng-model=\"selType.type\" class=\"form-control\" ng-change=\"getfederalLegislation()\" style=\"width:170px;display:inline-block;\">\r\n        <option value=\"\">Select Type</option>\r\n        <option value=\"sres\">SRES</option>\r\n        <option value=\"s\">S</option>\r\n        <option value=\"hjres\">HJRES</option>\r\n        <option value=\"sjres\">SJRES</option>\r\n        <option value=\"hr\">HR</option>\r\n        <option value=\"hconres\">HCONRES</option>\r\n        <option value=\"sconres\">SCONRES</option>\r\n        <option value=\"hres\">HRES</option>\r\n      </select>\r\n      <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loader\"></i>\r\n    </p>\r\n    <div ng-show=\"federal.length>0\">\r\n      <!--  <div class=\"form-group row\">\r\n          <label style=\"color:#ffffff;padding-left: 5%;padding-right: 5%\">Title: </label>\r\n     \r\n          <input type=\"text\" ng-model=\"searchCandy.search\" id=\"searchCandy\" class=\"form-control\" placeholder=\"Search by Title\" style=\"width:170px;\">\r\n          <button class=\"blackText\" style=\"margin-left:5%\" ng-click=\"SearchByTitle()\">Search</button>\r\n\r\n        </div> -->\r\n      <div infinite-scroll=\'myPagingFunction()\'>\r\n        <table class=\"w100 changeTextColor\" ng-show=\"federal.length > 0\">\r\n          <tr>\r\n            <th style=\"width:15%\">BillType</th>\r\n            <th style=\"width:60%\">Title</th>\r\n            <th style=\"width:15%\">PolicyArea</th>\r\n            <th style=\"width:9%\">Details</th>\r\n          </tr>\r\n          <tr ng-repeat=\"u in federal\">\r\n            <td>\r\n              <span ng-if=\"u.billType\">{{u.billType}}</span>\r\n            </td>\r\n            <td>\r\n              <p>\r\n                <span ng-if=\"u.billTitle\">{{u.billTitle}}</span>\r\n                <p>\r\n            </td>\r\n            <td>\r\n              <p>\r\n                <span ng-if=\"u.policyArea.name\">{{u.policyArea.name}}</span></p>\r\n            </td>\r\n            <td>\r\n              <a href=\"#!/federalDetail/{{u._id}}\" class=\"link\">Get Details</a>\r\n            </td>\r\n          </tr>\r\n          <tr ng-if=\"open.length == 0\">\r\n            <td colspan=\"3\"> No records found.\r\n            </td>\r\n          </tr>\r\n        </table>\r\n        <p ng-if=\"statusGetResPg == 1 && serachData > openBills.length\" class=\"fwb\">Loading OpenState Data...</p>\r\n      </div>\r\n    </div>\r\n  </form>\r\n</div>\r\n");
$templateCache.put("app/findFollowerMatch/findFollowerMatch.html","<div>\r\n  <!-- <button ng-click=\"$root.printPage()\" class=\"print-hide changeTextColor\">Print this page</button> -->\r\n  <!--  <div>{{questions}}</div>\r\n  <div>{{questions[currentIndex]}}</div> -->\r\n\r\n\r\n  <center>\r\n    <div ng-if=\"loaders\" style=\"z-index: 2; background:black; margin-left: 3%;\">\r\n      <i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span>\r\n    </div>\r\n\r\n\r\n  </center>\r\n\r\n  <div id=\"DisplayQ\" name=\"DisplayQ\" style=\"overflow: hidden;\">\r\n\r\n    <div ng-show=\" questions[currentIndex] && !showComment && !unComment &&\r\n    !showPoliAnswerDetails && !showUserAnswerDetails && !showCurr\">\r\n      <!-- <type=\"button\" value=\"LEARN MORE\"> -->\r\n      <h6 ng-if=\"inviterName && inviterId\" style=\"padding: 5% 0% 0% 10%;\">Invited By\r\n        <span style=\"text-transform: capitalize;\">{{inviterName}}</span></h6>\r\n      <p></p>\r\n\r\n      <center>\r\n        <h2>QUESTION</h2>\r\n      </center>\r\n      <p></p>\r\n      <p></p>\r\n      <center>({{currentIndex+1}} of {{questions.length}})</center>\r\n      <p></p>\r\n      <p>STATEMENT:<span class=\"card-text\" ng-bind-html=\"questions[currentIndex].content | newlines\"></span></p>\r\n      Your Answers<span style=\"margin-left: 30px;\">Their Answers</span>\r\n\r\n      <div class=\"clearfix scro\">\r\n        <div class=\"pull-left ans-col\" style=\"border-right: 3px solid #de8998;\">\r\n          <div class=\"clearfix  pad10\">\r\n          </div>\r\n          <p></p>\r\n          <div class=\"pad10\">\r\n            <div class=\"clearfix\"><br>\r\n              <p>COMMENTS</p>\r\n              <div class=\"mb5 clearfix\">\r\n                <div class=\"inl-blk pull-right\">\r\n                  <span class=\"clk ylink\" ng-if=\"!(questions[currentIndex].my_answer.comment | isBlankString)\" ng-click=\"viewAnsComment(\'currentUser\')\"><a href=\"\" title=\"Click to see their comments.\">YOUR COMMENTS</a></span>\r\n                  <span ng-if=\"questions[currentIndex].my_answer.comment | isBlankString\">None</span>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <p></p>\r\n            <div class=\"clearfix\" style=\"line-height: 9px\">\r\n              <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <span class=\"inl-blk\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n                <span class=\"inl-blk\" ng-if=\"i == 6\">DISAGREE</span>\r\n                <div class=\"cq-box inl-blk pull-right\"\r\n                  ng-class=\"(questions[currentIndex].my_answer.answer == i) ? (\'ag-green\') : \'\'\"></div>\r\n              </div>\r\n            </div>\r\n            <div class=\"clearfix\">\r\n              <div class=\"mb5 clearfix\"><br>\r\n                <div class=\"inl-blk pull-right\">Match to Mean</div>\r\n              </div>\r\n            </div><br>\r\n            <div class=\"clearfix\" style=\"line-height: 9px\">\r\n              <p>IMPORTANCE</p>\r\n              <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n                <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n                <div class=\"cq-box inl-blk pull-right \"\r\n                  ng-class=\"(questions[currentIndex].my_answer.importance == i) ? \'ag-dg\' : \'\'\"></div>\r\n              </div>\r\n            </div>\r\n\r\n          </div>\r\n\r\n        </div>\r\n\r\n        <div class=\"pull-left ans-col\" ng-if=\"emailRegistered\">\r\n          <div class=\"clearfix pad10\">\r\n            <div class=\"nslant-txt\" ng-if=\"!userId\">\r\n              <a href=\"\" title=\"These are all the registered users who answered this question.  Click to see their annonymous individual answers.\">Email Confirmed Users</a>\r\n            </div>\r\n            <div class=\"nslant-txt clk ylink\" ng-if=\"userId && !inviterData && !showGrpFollow\"\r\n              ng-click=\"showAnswersDetail(\'politician\')\">\r\n              <a href=\"\" title=\"These are all the politicians in your area who answered this question.  Click to see their individual answers.\">Your Politicians</a>\r\n            </div>\r\n            <div class=\"nslant-txt clk ylink\"\r\n              ng-if=\"userId && inviterData && inviterData.nameOnBallot && !showGrpFollow\"\r\n              ng-click=\"showAnswersDetail(\'politician\')\">\r\n              <a href=\"\" title=\"This is the person or organization that invited you to take the quiz.\" style=\"text-transform: capitalize;\">{{inviterData.nameOnBallot}}</a>\r\n            </div>\r\n            <div class=\"nslant-txt clk ylink\" ng-if=\"userId && showGrpFollow\"\r\n              ng-click=\"showAnswersDetail(\'politician\')\">\r\n              <a href=\"\" title=\"These are the followers who took this quiz.  Click to see their individual answers.\">Your Followers (Politicians)</a>\r\n            </div>\r\n          </div>\r\n          <p></p>\r\n          <br>\r\n          <div class=\"pad10\">\r\n            <div class=\"clearfix\">\r\n              <p>&nbsp;</p>\r\n              <div class=\"mb5 clearfix\">\r\n                <span class=\"clk ylink\" ng-if=\"globalFlag[questions[currentIndex]._id]\" ng-click=\"viewAnsComment(\'email\')\"><a href=\"\" title=\"Click to see their comments.\">READ COMMENTS</a></span>\r\n                <span ng-if=\"ans.comment && (ans.comment | isBlankString)\">None</span>\r\n                <span ng-if=\"!globalFlag[questions[currentIndex]._id]\">N/A</span>\r\n              </div>\r\n            </div>\r\n            <p></p>\r\n            <div ng-if=\"userId\" class=\"clearfix\" style=\"height: 120px;\">\r\n              <div ng-repeat=\"i in [1,2,3,4,5,6] track by $index\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n\r\n\r\n                <span ng-if=\"ansCount[questions[currentIndex]._id][i]\" data-tooltip=\"tooltip\" class=\"has-tip\"  title=\"Click here to see everyone who answered this way\">\r\n                      <canvas class=\"clk\"\r\n                      ng-click=\"showAnswers(i,\'politician\',questions[currentIndex]._id,ansCount[questions[currentIndex]._id],$index)\"\r\n                      ng-style=\"changeColor(ansCount[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                      width=\"100\" height=\"10\" id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                    </canvas>\r\n                  </span>\r\n\r\n                <span ng-if=\"!ansCount[questions[currentIndex]._id][i]\" data-tooltip=\"tooltip\" class=\"has-tip\"  title=\"No users to see here\">\r\n                <canvas class=\"clk\"\r\n                  ng-click=\"showAnswers(i,\'politician\',questions[currentIndex]._id,ansCount[questions[currentIndex]._id],$index)\"\r\n                  ng-style=\"changeColor(ansCount[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                  width=\"100\" height=\"10\" id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                </canvas>\r\n</span>\r\n\r\n\r\n\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                      <b>N/A</b>\r\n                    </span>\r\n              </div>\r\n            </div>\r\n            <div ng-if=\"!userId\" class=\"clearfix\" style=\"height: 120px;\">\r\n              <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <canvas class=\"clk\" id=\"myCanvas\"\r\n                  ng-style=\"changeColor(ansCount[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                  width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                </canvas>\r\n                <!-- <div class=\"cq-box inl-blk pull-left\"></div> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span ng-if=\"ansCount[questions[currentIndex]._id][i]\">{{ansCount[questions[currentIndex]._id][i]}}%</span><span ng-if=\"!ansCount[questions[currentIndex]._id][i]\">0%</span> -->\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"clearfix\" style=\"height: 32px;\">\r\n              <div class=\"mb5 clearfix\"><br>\r\n                <div class=\"inl-blk pull-left\">{{emailRegistered[questions[currentIndex]._id]}}%</div>\r\n                <div ng-if=\"!emailRegistered[questions[currentIndex]._id]\" class=\"w100 text-center fwb\">N/A</div>\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div><br>\r\n            <div class=\"clearfix\" style=\"height: 111px;\">\r\n              <p>&nbsp;</p>\r\n              <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <canvas id=\"myCanvas\" width=\"100\" height=\"10\"\r\n                  style=\"border:1px solid #141212;\r\n              background: linear-gradient(to right, #e0dbdb {{impCount[questions[currentIndex]._id][i]}}%, #2b4f7f 10%);\">\r\n                </canvas>\r\n                <!-- <div class=\"cq-box inl-blk pull-left\" style=\"background: linear-gradient(to right, #141212 {{impCount[questions[currentIndex]._id][i]}}%, #2b4f7f 10%);\"></div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span ng-if=\"impCount[questions[currentIndex]._id][i]\">{{impCount[questions[currentIndex]._id][i]}}%</span><span ng-if=\"!impCount[questions[currentIndex]._id][i]\">0%</span> -->\r\n              </div>\r\n              <div ng-if=\"importance\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n              <!-- <div class=\"inl-blk pull-left\">{{emailImpo[questions[currentIndex]._id]}}%</div>\r\n            <div ng-if=\"!emailImpo[questions[currentIndex]._id]\" class=\"w100 text-center fwb\">N/A</div> -->\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div ng-if=\"inviterName && !emailRegistered && !inviterInfo.title && inviterInfo.userType == \'politician\'\">\r\n          <h5 style=\"margin: 15px 0px 0px 10%;\">{{inviterName}} skipped this question.</h5>\r\n        </div>\r\n        <div ng-if=\"inviterName && !voter && !inviterInfo.title && inviterInfo.userType == \'voter\'\">\r\n          <h5 style=\"margin: 15px 0px 0px 10%;\">{{inviterName}} skipped this question.</h5>\r\n        </div>\r\n        <div ng-if=\"inviterName && !advocate && inviterInfo.title\">\r\n          <h5 style=\"margin: 15px 0px 0px 10%;\">{{inviterName}} skipped this question.</h5>\r\n        </div>\r\n        <div class=\"pull-left ans-col\" ng-if=\"voter && userId\">\r\n          <!-- {{voter}} -->\r\n          <div class=\"clearfix  pad10\">\r\n            <div class=\"nslant-txt clk ylink\" ng-if=\"userId && !inviterData && !showGrpFollow \"\r\n              ng-click=\"showAnswersDetail(\'voter\')\">\r\n              <a href=\"\" title=\"These are all the email confirmed registered users who answered this question.  Click to see their individual answers.\">Followers - Voters</a>\r\n            </div>\r\n            <div class=\"nslant-txt clk ylink\" ng-if=\"voter && userId && inviterData.name && !showGrpFollow\"\r\n              ng-click=\"showAnswersDetail(\'voter\')\">\r\n              <a href=\"\" title=\"This is the person or organization that invited you to take the quiz.\" style=\"text-transform: capitalize;\">{{inviterData.name}}</a>\r\n            </div>\r\n            <div class=\"nslant-txt clk ylink\" ng-if=\"userId && showGrpFollow\" ng-click=\"showAnswersDetail(\'voter\')\">\r\n              <a href=\"\" title=\"These are the followers who took this quiz.  Click to see their individual answers.\">Your Followers (voters)</a>\r\n            </div>\r\n          </div>\r\n          <p></p>\r\n          <br>\r\n          <div class=\"pad10\">\r\n            <div class=\"clearfix\">\r\n              <p>&nbsp;</p>\r\n              <div class=\"mb5 clearfix\">\r\n                <span class=\"clk ylink\" ng-if=\"flagOfVoter[questions[currentIndex]._id]\" ng-click=\"viewAnsComment(\'voter\')\"><a href=\"\" title=\"Click to see their comments.\">READ COMMENTS</a></span>\r\n                <span ng-if=\"ans.comment && (ans.comment | isBlankString)\">None</span>\r\n                <span ng-if=\"!flagOfVoter[questions[currentIndex]._id]\">N/A</span>\r\n              </div>\r\n            </div>\r\n            <p></p>\r\n            <div class=\"clearfix\" style=\"height: 120px;\">\r\n              <div ng-repeat=\"i in [1,2,3,4,5,6] track by $index\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <span ng-if=\"voterAnsCount[questions[currentIndex]._id][i]\" data-tooltip=\"tooltip\" class=\"has-tip\"  title=\"Click here to see everyone who answered this way\">\r\n                <canvas class=\"clk\"\r\n                  ng-style=\"changeColor(voterAnsCount[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                  ng-click=\"showAnswers(i,\'voter\',questions[currentIndex]._id,voterAnsCount[questions[currentIndex]._id],$index)\"\r\n                  id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                </canvas>\r\n              </span>\r\n                <span ng-if=\"!voterAnsCount[questions[currentIndex]._id][i]\" data-tooltip=\"tooltip\" class=\"has-tip\"  title=\"No users to see here\">\r\n                  <canvas class=\"clk\"\r\n                    ng-style=\"changeColor(voterAnsCount[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                    ng-click=\"showAnswers(i,\'voter\',questions[currentIndex]._id,voterAnsCount[questions[currentIndex]._id],$index)\"\r\n                    id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                  </canvas>\r\n                </span>\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div>\r\n            <div class=\"clearfix\" style=\"height: 32px;\">\r\n              <div class=\"mb5 clearfix\"><br>\r\n                <div class=\"inl-blk pull-left\">{{voter[questions[currentIndex]._id]}}%</div>\r\n                <div ng-if=\"!voter[questions[currentIndex]._id]\" class=\"w100 text-center fwb\">N/A</div>\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div><br>\r\n            <div class=\"clearfix\" style=\"height: 111px;\">\r\n              <p>&nbsp;</p>\r\n              <div ng-if=\"voterImpCount[questions[currentIndex]._id]\" ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\"\r\n                style=\"line-height: 15px\">\r\n                <canvas id=\"myCanvas\" width=\"100\" height=\"10\"\r\n                  style=\"border:1px solid #141212;\r\n              background: linear-gradient(to right, #e0dbdb {{voterImpCount[questions[currentIndex]._id][i]}}%, #2b4f7f 10%); \">\r\n                </canvas>\r\n              </div>\r\n              <div ng-if=\"importance\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <i ng-if=\"loadernew\" class=\"fa fa-refresh fa-spin\" style=\"font-size:72px;float: left;margin-top: 10%\"></i>\r\n\r\n\r\n        <div class=\"pull-left ans-col\" ng-if=\"advocate && userId\">\r\n          <div class=\"clearfix  pad10\">\r\n            <div class=\"nslant-txt clk ylink\" ng-if=\"userId && !inviterData && !showGrpFollow\"\r\n              ng-click=\"showAnswersDetail(\'advocate\')\">\r\n              <a href=\"\" title=\"These are all the organizations who answered this question.  Click to see their individual answers.\">Organizations </a>\r\n            </div>\r\n            <div class=\"nslant-txt clk ylink\" ng-if=\"userId && inviterData.title && !showGrpFollow\"\r\n              ng-click=\"showAnswersDetail(\'advocate\')\">\r\n              <a href=\"\" title=\"This is the person or organization that invited you to take the quiz.\" style=\"text-transform: capitalize;\">{{inviterData.title}} </a>\r\n            </div>\r\n            <div class=\"nslant-txt clk ylink\" ng-if=\"userId && showGrpFollow\" ng-click=\"showAnswersDetail(\'advocate\')\">\r\n              <a href=\"\" title=\"These are the followers who took this quiz.  Click to see their individual answers.\">Your Followers (Organizations)</a>\r\n            </div>\r\n          </div>\r\n          <p></p>\r\n          <br>\r\n          <div class=\"pad10\">\r\n            <div class=\"clearfix\">\r\n              <p>&nbsp;</p>\r\n              <div class=\"mb5 clearfix\">\r\n                <span class=\"clk ylink\" ng-if=\"advocateFlag[questions[currentIndex]._id]\" ng-click=\"viewAnsComment(\'advocate\')\"><a href=\"\" title=\"Click to see their comments.\">READ COMMENTS</a></span>\r\n                <span ng-if=\"ans.comment && (ans.comment | isBlankString)\">None</span>\r\n                <span ng-if=\"!advocateFlag[questions[currentIndex]._id]\">N/A</span>\r\n              </div>\r\n            </div>\r\n            <p></p>\r\n            <div class=\"clearfix\" style=\"height: 120px;\">\r\n              <div ng-repeat=\"i in [1,2,3,4,5,6] track by $index\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <span ng-if=\"advocateAns[questions[currentIndex]._id][i]\" data-tooltip=\"tooltip\" class=\"has-tip\"  title=\"Click here to see everyone who answered this way\">\r\n                <canvas class=\"clk\"\r\n                  ng-style=\"changeColor(advocateAns[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                  ng-click=\"showAnswers(i,\'advocate\',questions[currentIndex]._id,advocateAns[questions[currentIndex]._id],$index)\"\r\n                  id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                </canvas>\r\n                </span>\r\n                <span ng-if=\"!advocateAns[questions[currentIndex]._id][i]\" data-tooltip=\"tooltip\" class=\"has-tip\"  title=\"No users to see here\">\r\n                    <canvas class=\"clk\"\r\n                      ng-style=\"changeColor(advocateAns[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                      ng-click=\"showAnswers(i,\'advocate\',questions[currentIndex]._id,advocateAns[questions[currentIndex]._id],$index)\"\r\n                      id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                    </canvas>\r\n                    </span>\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div>\r\n            <div class=\"clearfix\" style=\"height: 32px;\">\r\n              <div class=\"mb5 clearfix\"><br>\r\n                <div class=\"inl-blk pull-left\">{{advocate[questions[currentIndex]._id]}}%</div>\r\n                <!-- <div ng-if=\"!advocate[questions[currentIndex]._id]\" class=\"w100 text-center fwb\">N/A</div> -->\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div><br>\r\n            <div class=\"clearfix\" style=\"height: 111px;\">\r\n              <p>&nbsp;</p>\r\n              <div ng-if=\"advocateimpObj[questions[currentIndex]._id]\" ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\"\r\n                style=\"line-height: 15px\">\r\n                <canvas id=\"myCanvas\" width=\"100\" height=\"10\"\r\n                  style=\"border:1px solid #141212;\r\n              background: linear-gradient(to right, #e0dbdb {{advocateimpObj[questions[currentIndex]._id][i]}}%, #2b4f7f 10%); \">\r\n                </canvas>\r\n              </div>\r\n              <div ng-if=\"importance\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n\r\n        <div class=\"pull-left ans-col\" ng-if=\"unVerified\">\r\n          <div class=\"clearfix  pad10\">\r\n            <div class=\"nslant-txt\" ng-if=\"!userId\">\r\n              <a href=\"\" title=\"These are all the unregistered users who answered this question.  Click to see their annonymous individual answers.\">UnRegistered Users</a>\r\n            </div>\r\n            <div class=\"nslant-txt clk ylink\" ng-if=\"userId\" ng-click=\"showAnswersDetail(\'unRegister\')\"><a href=\"\" title=\"These are all the unregistered users who answered this question.  Click to see their annonymous individual answers.\">UnRegistered\r\n													Users</a></div>\r\n          </div>\r\n          <p></p>\r\n          <br>\r\n          <div class=\"pad10\">\r\n            <div class=\"clearfix\">\r\n              <p>&nbsp;</p>\r\n              <div class=\"mb5 clearfix\">\r\n                <span class=\"clk ylink\" ng-if=\"flagOfUnVerified[questions[currentIndex]._id]\" ng-click=\"viewAnsComment(\'unRegister\')\"><a href=\"\" title=\"Click to see their comments.\">READ COMMENTS</a></span>\r\n                <span ng-if=\"ans.comment && (ans.comment | isBlankString)\">None</span>\r\n                <span ng-if=\"!flagOfUnVerified[questions[currentIndex]._id]\" class=\"fwb\">N/A</span>\r\n              </div>\r\n            </div>\r\n            <p></p>\r\n\r\n            <div ng-if=\"userId\" class=\"clearfix\" style=\"height: 120px;\">\r\n              <div ng-repeat=\"i in [1,2,3,4,5,6] track by $index\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <span ng-if=\"unCount[questions[currentIndex]._id][i]\" data-tooltip=\"tooltip\" class=\"has-tip\"  title=\"Click here to see everyone who answered this way\">\r\n\r\n                <canvas class=\"clk\"\r\n                  ng-style=\"changeColor(unCount[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                  ng-click=\"showAnswers(i,\'guestUser\',questions[currentIndex]._id,unCount[questions[currentIndex]._id],$index)\"\r\n                  id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                </canvas>\r\n                </span>\r\n                <span ng-if=\"!unCount[questions[currentIndex]._id][i]\" data-tooltip=\"tooltip\" class=\"has-tip\"  title=\"No users to see here\">\r\n\r\n                    <canvas class=\"clk\"\r\n                      ng-style=\"changeColor(unCount[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                      ng-click=\"showAnswers(i,\'guestUser\',questions[currentIndex]._id,unCount[questions[currentIndex]._id],$index)\"\r\n                      id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                    </canvas>\r\n                    </span>\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div>\r\n            <div ng-if=\"!userId\" class=\"clearfix\" style=\"height: 120px;\">\r\n              <div ng-repeat=\"i in [1,2,3,4,5,6] track by $index\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <canvas\r\n                  ng-style=\"changeColor(unCount[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                  id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                </canvas>\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"clearfix\" style=\"height: 32px;\">\r\n              <div class=\"mb5 clearfix\"><br>\r\n                <div ng-if=\"unVerified[questions[currentIndex]._id]\" class=\"inl-blk pull-left\">\r\n                  {{unVerified[questions[currentIndex]._id]}}%</div>\r\n                <div ng-if=\"!unVerified[questions[currentIndex]._id]\" class=\"w100 text-center fwb\">N/A</div>\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div><br>\r\n            <div class=\"clearfix\" style=\"height: 111px;\">\r\n              <p>&nbsp;</p>\r\n              <div ng-if=\"unVeriImpo[questions[currentIndex]._id]\" ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\"\r\n                style=\"line-height: 15px\">\r\n                <!--  <span data-tooltip class=\"has-tip\" title=\"Click here to see everyone who answered this way\">-->\r\n\r\n                <canvas id=\"myCanvas\" width=\"100\" height=\"10\"\r\n                  style=\"border:1px solid #141212;\r\n         background: linear-gradient(to right, #e0dbdb {{unImpCount[questions[currentIndex]._id][i]}}%, #2b4f7f 10%); \">\r\n                </canvas>\r\n                <!--    </span>  -->\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"pull-left ans-col\" ng-if=\"!userId\">\r\n          <h6>\r\n            <p style=\"width:200px;\">If you register, we can also use your address to show you how you compare with your\r\n              local politicians.\r\n            </p>\r\n          </h6>\r\n          <center>\r\n            <button ng-if=\"!userId\" class=\"btnB275\" style=\"width:200px;\" ng-click=\"finalSignIn()\">Register Now</button>\r\n          </center>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n  <div ng-if=\"showComment\">\r\n    <div>\r\n      <a href=\"\" class=\"ylink\" style=\"padding-left: 10%\" ng-click=\"back()\">Back</a>\r\n    </div>\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Comments</legend>\r\n      <div class=\"contactBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\" style=\"width: 100%\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <br>\r\n\r\n            <!-- <span ng-if=\"\"> </span> -->\r\n            <div ng-repeat=\"com in global[questions[currentIndex]._id] | filter:getItems()\">\r\n\r\n              <div class=\"pad10\">\r\n                <span ng-if=\"com.author.username\">Name: </span><span class=\"newcomName\"> {{com.author.username}}</span>\r\n                <br>\r\n                <span>Comment: </span><span class=\"newcomName\"> {{com.comment}}</span>\r\n                <br>\r\n                <span>Answer</span>\r\n                <br>\r\n                <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n                  <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n                    style=\"padding-left: 8px;  line-height: 15px\">\r\n                    <span class=\"inl-blk pull-left\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n                    <div class=\"cq-box inl-blk pull-left\"\r\n                      ng-class=\"(com.answer == i) ? getComapreClass(com.match, i) : \'\'\"></div>\r\n                    <span class=\"inl-blk\" ng-if=\"i == 6\" style=\"padding-left:8px\">DISAGREE</span>\r\n                  </div>\r\n                </div>\r\n                <br>\r\n                <p></p>\r\n                <span>IMPORTANCE</span>\r\n                <br>\r\n                <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n                  <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"padding-left: 8px; line-height: 15px\">\r\n                    <span class=\"inl-blk\" ng-if=\"i == 1\">Very</span>\r\n                    <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                    <span class=\"inl-blk\" ng-if=\"i == 3\">Not Very</span>\r\n                    <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                      ng-class=\"(com.importance == i) ? \'ag-dg\' : \'\'\"></div>\r\n                  </div>\r\n                </div>\r\n                <hr style=\"\r\n                  margin-left: auto;\r\n                  margin-right: auto;\r\n                  height: 1px;\r\n                  background-color:#666;\r\n                  opcaity: 0.5;\">\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </fieldset>\r\n  </div>\r\n  <div ng-if=\"unComment\">\r\n    <div>\r\n      <a href=\"\" class=\"ylink\" style=\"padding-left: 10%\" ng-click=\"back()\">Back</a>\r\n    </div>\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Comments</legend>\r\n      <div class=\"contactBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\" style=\"width: 100%\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <br>\r\n            <!-- <span ng-if=\"\"> </span> -->\r\n            <div ng-repeat=\"item in unVeriComm[questions[currentIndex]._id] |filter:getComment() track by $index\">\r\n              <div class=\"pad10\">\r\n                <span>Name: </span><b>Unregistered User {{$index+1}}</b>\r\n                <br>\r\n                <span>Comment: </span><span>{{item.comment}}</span>\r\n                <br>\r\n                <span>Answer</span>\r\n                <br>\r\n                <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n                  <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n                    style=\"padding-left: 8px;  line-height: 15px\">\r\n                    <span class=\"inl-blk pull-left\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n                    <div class=\"cq-box inl-blk pull-left\"\r\n                      ng-class=\"(item.answer == i) ? getComapreClass(item.match, i) : \'\'\"></div>\r\n                    <span class=\"inl-blk\" ng-if=\"i == 6\" style=\"padding-left:8px\">DISAGREE</span>\r\n                  </div>\r\n                </div>\r\n                <br>\r\n                <p></p>\r\n                <span>IMPORTANCE</span>\r\n                <br>\r\n                <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n\r\n                  <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"padding-left: 8px;  line-height: 15px \">\r\n                    <span class=\"inl-blk\" ng-if=\"i == 1\">Very</span>\r\n                    <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                    <span class=\"inl-blk\" ng-if=\"i == 3\">Not Very</span>\r\n                    <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                      ng-class=\"(item.importance == i) ? \'ag-dg\' : \'\'\"></div>\r\n                  </div>\r\n                </div>\r\n\r\n                <hr style=\"\r\n                  margin-left: auto;\r\n                  margin-right: auto;\r\n                  height: 1px;\r\n                  background-color:#666;\r\n                  opcaity: 0.5;\">\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </fieldset>\r\n  </div>\r\n  <div ng-if=\"showCurr\">\r\n    <div>\r\n      <a href=\"\" class=\"ylink\" style=\"padding-left: 10%\" ng-click=\"back()\">Back</a>\r\n    </div>\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Comments</legend>\r\n      <div class=\"contactBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\" style=\"width: 100%\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <span>Comment: </span><span class=\"newcomName\">{{questions[currentIndex].my_answer.comment}}</span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </fieldset>\r\n  </div>\r\n  <div style=\"text-align:left;\" ng-if=\"showcomparison == true\">\r\n    <div ng-if=\"noDataFound == false\">\r\n      <div class=\"squareBoxY\" style=\"margin-left:10px;\">&nbsp;</div>\r\n      <span>= Simple Comparison by answers alone.</span>\r\n      <div style=\"clear:both;\"></div>\r\n      <div class=\"squareBoxB\" style=\"margin-left:10px\">&nbsp;</div>\r\n      <span>= Weighted Comparison by answers and importance.</span>\r\n      <div style=\"clear:both;\"></div>\r\n    </div>\r\n    <!--\r\n    <div>\r\n        <div style=\"width:30%; float:left; text-align:right;\">Order By :&nbsp;&nbsp;</div>\r\n        <div style=\"width:65%; float:left; text-align:left;\">\r\n            <select ng-model=\"ord.Option\">\r\n                <option value=\"BW\">Best Weighted match</option>\r\n                <option value=\"W\">Worst weighted match</option>\r\n                <option value=\"BS\">Best simple match</option>\r\n                <option value=\"S\">worst simple match</option>\r\n            </select>\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n    </div>\r\n    -->\r\n    <ul class=\"catList\" ng-if=\"noDataFound == false\">\r\n      <li ng-repeat=\"frd in AllUsers track by $index\" ng-if=\"FBunWeighted[frd._id] && fbcombinedWeight[frd._id]\">\r\n        <div style=\"background-color:#ffffee; padding:10px;\">\r\n          <div style=\"color: #000000;\"><b>\r\n              <div ng-repeat=\"fd in frd.politicianInfo\" ng-if=\"fd.candidateStatus==\'Running\'\"><span style=\"text-transform: capitalize;\">{{fd.officeName}}</span></div>\r\n            </b><b style=\"text-transform: capitalize;\">{{frd.name}}</b>&nbsp;&nbsp;&nbsp;Total Answered questions: {{fbqlen[frd._id]}}\r\n          </div>\r\n          <div style=\"width: 84%; float:left;\">\r\n            <div>\r\n              <div class=\"fbunweighted\" style=\"width:{{(FBunWeighted[frd._id] / fbqlen[frd._id] )  | number:2}}%\">{{(FBunWeighted[frd._id]\r\n                / fbqlen[frd._id] ) | number:2}}% Match</div>\r\n            </div>\r\n            <div>\r\n              <div class=\"fbweighted\"\r\n                style=\"width:{{(fbcombinedWeight[frd._id] / fbmultiplier[frd._id])  | number:2}}%\">{{(fbcombinedWeight[frd._id]\r\n                / fbmultiplier[frd._id]) | number:2}}% Weighted Match</div>\r\n            </div>\r\n          </div>\r\n          <div style=\"clear:both;\"></div>\r\n        </div>\r\n      </li>\r\n    </ul>\r\n    <!--  <div ng-if=\"noDataFound == true\">\r\n      <h3>\r\n        <p style=\"color:red\">Congratulations! You are the first person in your region to take this quiz. You are a true pioneer! You should contact your local politicians and your friends to encourage them to use this site. There are still plenty of wonderful things here to see.</p>\r\n      </h3>\r\n      <br>\r\n      <br>\r\n      <div class=\"margin-auto mxw\">\r\n        <div class=\"digDeeperSmall\" style=\"float:left\"> <a href=\"#!/digDeeper\"><img ng-src=\"../assets/images/DigDeeper.svg\" alt=\"Dig deeper\" /></a></div>\r\n        <button class=\"btnB275\" style=\"width:150px; float:right;\" ng-click=\"finalSignIn()\">Sign In</button>\r\n      </div>\r\n\r\n    </div> -->\r\n    <!--\r\n  <center><button class=\"btnB275\" ng-click=\"postonFacebook()\">Post Quiz to Facebook</button></center>\r\n-->\r\n    <!-- <div><center><input type=\"button\" name=\"btnNext\" value=\"Next\" ng-click=\"nextCat()\"></center></div> -->\r\n    <div ng-if=\"showcomparison == false\">\r\n      <p>This only shows politicians that have answered our quizzes. For the rest, you can see how organizations rated\r\n        them, their voting records, who financed their campaigns and more here</p>\r\n      <center><button class=\"btnB275\"> <a href=\"#!/compare-select/politician\">See Other Politicians</a></button>\r\n      </center><br><br>\r\n    </div>\r\n    </div>\r\n    <div class=\"mb5 clearfix print-hide\"\r\n      ng-if=\"!showComment && !unComment && !showPoliAnswerDetails && !showUserAnswerDetails && !showCurr\">\r\n      <!-- <a class=\"clk fwb\" ng-click=\"prevQuestion()\">Prev</a>&nbsp;\r\n                  <a class=\"clk fwb\" ng-click=\"skipQuestion()\">Next</a> -->\r\n      <button class=\"compareBtnS\" ng-click=\"prevQuestion()\"><i class=\"fa fa-angle-left arrowIconBack\"></i>Prev</button>\r\n      <button class=\"compareBtnS\" ng-click=\"skipQuestion()\">Next<i class=\"fa fa-angle-right arrowIconSubmit\"></i></button>\r\n    </div>\r\n    <div ng-show=\"questions.length <= 0 && status.questions == 2\">\r\n      <a href=\"javascript: void(0)\" ng-click=\"skipQuestion()\" class=\"changeTextColor\">Next</a>\r\n      <a href=\"javascript: void(0)\" ng-click=\"prevQuestion()\" class=\"changeTextColor\">Prev</a>\r\n    </div>\r\n    <button class=\"compareBtn\"><a href=\"#!/whatAmILookingAt1\">What Am I Looking At?</a></button>\r\n    <!--<br>\r\n	<button class=\"compareBtn\"><a href=\"#!/ballotMatch\">Did you skip this question?  Take the quiz.</a></button> -->\r\n  </div>\r\n");
$templateCache.put("app/findMatch/findMatch.html","<div>\r\n  <!-- <button ng-click=\"$root.printPage()\" class=\"print-hide changeTextColor\">Print this page</button> -->\r\n  <!--  <div>{{questions}}</div>\r\n  <div>{{questions[currentIndex]}}</div> -->\r\n\r\n\r\n  <center>\r\n    <div ng-if=\"loaders\" style=\"z-index: 2; background:black; margin-left: 3%;\">\r\n      <i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span>\r\n    </div>\r\n\r\n\r\n  </center>\r\n\r\n  <div id=\"DisplayQ\" name=\"DisplayQ\" style=\"overflow: hidden;\">\r\n\r\n    <div ng-show=\" questions[currentIndex] && !showComment && !unComment &&\r\n    !showPoliAnswerDetails && !showUserAnswerDetails && !showCurr\">\r\n      <!-- <type=\"button\" value=\"LEARN MORE\"> -->\r\n      <h6 ng-if=\"inviterName && inviterId\" style=\"padding: 5% 0% 0% 10%;\">Invited By\r\n        <a ng-if=\"inviterData.userType == \'politician\'\" href=\"#!/publicProfile/{{inviterId}}\" class=\"ylink\" style=\"text-transform: capitalize;\"><img ng-src=\"../assets/images/profile/politician.svg\" alt=\"Politician\"  class=\"usertype\">{{inviterData.nameOnBallot}}</a>\r\n        <a ng-if=\"inviterData.userType == \'voter\'\" href=\"#!/voterProfile/{{inviterId}}\" class=\"ylink\" style=\"text-transform: capitalize;\"><img ng-src=\"../assets/images/profile/voter.svg \" alt=\"Voter\" class=\"usertype \">{{inviterData.username}}</a>\r\n        <a ng-if=\"inviterData.userType == \'advocate\' || inviterData.userType ==\'\' || !inviterData.userType\"  href=\"#!/pressProfile/{{inviterId}}\" class=\"ylink\" style=\"text-transform: capitalize;\"><img ng-src=\"../assets/images/profile/advocate.svg\" class=\"usertype\" alt=\"Advocate\">{{inviterData.title}}</a>\r\n      </h6>\r\n      <p></p>\r\n\r\n      <center>\r\n        <h2>QUESTION</h2>\r\n      </center>\r\n      <p></p>\r\n      <p></p>\r\n      <center>({{currentIndex+1}} of {{questions.length}})</center>\r\n      <p></p>\r\n      <p>STATEMENT: <span class=\"card-text\" ng-bind-html=\"questions[currentIndex].content | newlines\"></span></p>\r\n      Your Answers<span style=\"margin-left: 30px;\">Their Answers</span>\r\n\r\n      <div class=\"clearfix scro\">\r\n        <div class=\"pull-left ans-col\" style=\"border-right: 3px solid #de8998;\">\r\n          <div class=\"clearfix  pad10\">\r\n          </div>\r\n          <p></p>\r\n          <div class=\"pad10\">\r\n            <div class=\"clearfix\"><br>\r\n              <p>COMMENTS</p>\r\n              <div class=\"mb5 clearfix\">\r\n                <div class=\"inl-blk pull-right\">\r\n                  <span class=\"clk ylink\" ng-if=\"!(questions[currentIndex].my_answer.comment | isBlankString)\" ng-click=\"viewAnsComment(\'currentUser\')\"><a href=\"\" title=\"Click to see their comments.\">YOUR COMMENTS</a></span>\r\n                  <span ng-if=\"questions[currentIndex].my_answer.comment | isBlankString\">None</span>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <p></p>\r\n            <div class=\"clearfix\" style=\"line-height: 9px\">\r\n              <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <span class=\"inl-blk\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n                <span class=\"inl-blk\" ng-if=\"i == 6\">DISAGREE</span>\r\n                <div class=\"cq-box inl-blk pull-right\"\r\n                  ng-class=\"(questions[currentIndex].my_answer.answer == i) ? (\'ag-green\') : \'\'\"></div>\r\n              </div>\r\n            </div>\r\n            <div class=\"clearfix\">\r\n              <div class=\"mb5 clearfix\"><br>\r\n                <div class=\"inl-blk pull-right\">Match to Mean</div>\r\n              </div>\r\n            </div><br>\r\n            <div class=\"clearfix\" style=\"line-height: 9px\">\r\n              <p>IMPORTANCE</p>\r\n              <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n                <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n                <div class=\"cq-box inl-blk pull-right \"\r\n                  ng-class=\"(questions[currentIndex].my_answer.importance == i) ? \'ag-dg\' : \'\'\"></div>\r\n              </div>\r\n            </div>\r\n\r\n          </div>\r\n\r\n        </div>\r\n\r\n        <div class=\"pull-left ans-col\" ng-if=\"emailRegistered\">\r\n          <div class=\"clearfix pad10\">\r\n            <div class=\"nslant-txt\" ng-if=\"!userId\">\r\n              <a href=\"\" title=\"These are all the registered users who answered this question.  Click to see their annonymous individual answers.\">Email Confirmed Users</a>\r\n            </div>\r\n            <div class=\"nslant-txt clk ylink\" ng-if=\"userId && !inviterData\" ng-click=\"showAnswersDetail(\'politician\')\">\r\n              <a href=\"\" title=\"These are all the politicians in your area who answered this question.  Click to see their individual answers.\">Your Politicians</a>\r\n            </div>\r\n            <div class=\"nslant-txt clk ylink\"\r\n              ng-if=\"userId && inviterData && inviterData.nameOnBallot && !showGrpFollow\"\r\n              ng-click=\"showAnswersDetail(\'politician\')\">\r\n              <a href=\"\" title=\"This is the person or organization that invited you to take the quiz.\" style=\"text-transform: capitalize;\">{{inviterData.nameOnBallot}}</a>\r\n            </div>\r\n            <div class=\"nslant-txt clk ylink\" ng-if=\"userId && showGrpFollow\"\r\n              ng-click=\"showAnswersDetail(\'politician\')\">\r\n              <a href=\"\" title=\"These are the followers who took this quiz.  Click to see their individual answers.\">Your Followers</a>\r\n            </div>\r\n          </div>\r\n          <p></p>\r\n          <br>\r\n          <div class=\"pad10\">\r\n            <div class=\"clearfix\">\r\n              <p>&nbsp;</p>\r\n              <div class=\"mb5 clearfix\">\r\n                <span class=\"clk ylink\" ng-if=\"globalFlag[questions[currentIndex]._id]\" ng-click=\"viewAnsComment(\'email\')\"><a href=\"\" title=\"Click to see their comments.\">READ COMMENTS</a></span>\r\n                <span ng-if=\"ans.comment && (ans.comment | isBlankString)\">None</span>\r\n                <span ng-if=\"!globalFlag[questions[currentIndex]._id]\">N/A</span>\r\n              </div>\r\n            </div>\r\n            <p></p>\r\n            <div ng-if=\"userId\" class=\"clearfix\" style=\"height: 120px;\">\r\n              <div ng-repeat=\"i in [1,2,3,4,5,6] track by $index\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n\r\n\r\n                <span ng-if=\"ansCount[questions[currentIndex]._id][i]\" data-tooltip=\"tooltip\" class=\"has-tip\"  title=\"Click here to see everyone who answered this way\">\r\n                      <canvas class=\"clk\"\r\n                      ng-click=\"showAnswers(i,\'politician\',questions[currentIndex]._id,ansCount[questions[currentIndex]._id],$index)\"\r\n                      ng-style=\"changeColor(ansCount[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                      width=\"100\" height=\"10\" id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                    </canvas>\r\n                  </span>\r\n\r\n                <span ng-if=\"!ansCount[questions[currentIndex]._id][i]\" data-tooltip=\"tooltip\" class=\"has-tip\"  title=\"No users to see here\">\r\n                <canvas class=\"clk\"\r\n                  ng-click=\"showAnswers(i,\'politician\',questions[currentIndex]._id,ansCount[questions[currentIndex]._id],$index)\"\r\n                  ng-style=\"changeColor(ansCount[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                  width=\"100\" height=\"10\" id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                </canvas>\r\n</span>\r\n\r\n\r\n\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                      <b>N/A</b>\r\n                    </span>\r\n              </div>\r\n            </div>\r\n            <div ng-if=\"!userId\" class=\"clearfix\" style=\"height: 120px;\">\r\n              <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <canvas class=\"clk\" id=\"myCanvas\"\r\n                  ng-style=\"changeColor(ansCount[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                  width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                </canvas>\r\n                <!-- <div class=\"cq-box inl-blk pull-left\"></div> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span ng-if=\"ansCount[questions[currentIndex]._id][i]\">{{ansCount[questions[currentIndex]._id][i]}}%</span><span ng-if=\"!ansCount[questions[currentIndex]._id][i]\">0%</span> -->\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"clearfix\" style=\"height: 32px;\">\r\n              <div class=\"mb5 clearfix\"><br>\r\n                <div class=\"inl-blk pull-left\">{{emailRegistered[questions[currentIndex]._id]}}%</div>\r\n                <div ng-if=\"!emailRegistered[questions[currentIndex]._id]\" class=\"w100 text-center fwb\">N/A</div>\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div><br>\r\n            <div class=\"clearfix\" style=\"height: 111px;\">\r\n              <p>&nbsp;</p>\r\n              <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <canvas id=\"myCanvas\" width=\"100\" height=\"10\"\r\n                  style=\"border:1px solid #141212;\r\n              background: linear-gradient(to right, #e0dbdb {{impCount[questions[currentIndex]._id][i]}}%, #2b4f7f 10%);\">\r\n                </canvas>\r\n                <!-- <div class=\"cq-box inl-blk pull-left\" style=\"background: linear-gradient(to right, #141212 {{impCount[questions[currentIndex]._id][i]}}%, #2b4f7f 10%);\"></div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span ng-if=\"impCount[questions[currentIndex]._id][i]\">{{impCount[questions[currentIndex]._id][i]}}%</span><span ng-if=\"!impCount[questions[currentIndex]._id][i]\">0%</span> -->\r\n              </div>\r\n              <div ng-if=\"importance\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n              <!-- <div class=\"inl-blk pull-left\">{{emailImpo[questions[currentIndex]._id]}}%</div>\r\n            <div ng-if=\"!emailImpo[questions[currentIndex]._id]\" class=\"w100 text-center fwb\">N/A</div> -->\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div ng-if=\"inviterName && !emailRegistered && !inviterInfo.title && inviterInfo.userType == \'politician\'\">\r\n          <h5 style=\"margin: 15px 0px 0px 10%;\">\r\n            <span style=\"text-transform: capitalize;\">{{inviterName}}</span><span> skipped this question.</span></h5>\r\n        </div>\r\n        <div ng-if=\"inviterName && !voter && !inviterInfo.title && inviterInfo.userType == \'voter\'\">\r\n          <h5 style=\"margin: 15px 0px 0px 10%;\">\r\n            <span style=\"text-transform: capitalize;\">{{inviterData.username}}</span><span> skipped this question.</span>\r\n          </h5>\r\n        </div>\r\n        <div ng-if=\"inviterName && !advocate && inviterInfo.title\">\r\n          <h5 style=\"margin: 15px 0px 0px 10%;\">\r\n            <span style=\"text-transform: capitalize;\">{{inviterInfo.title}}</span><span> skipped this question.</span>\r\n          </h5>\r\n        </div>\r\n        <div ng-if=\"inviterName ==\'\'\">\r\n          <h5 style=\"margin: 15px 0px 0px 10%;\">\r\n            <span style=\"text-transform: capitalize;\">They skipped this question.</span></h5>\r\n        </div>\r\n        <div class=\"pull-left ans-col\" ng-if=\"voter && userId\">\r\n          <!-- {{voter}} -->\r\n          <div class=\"clearfix  pad10\">\r\n            <div class=\"nslant-txt clk ylink\" ng-if=\"userId && !inviterData\" ng-click=\"showAnswersDetail(\'voter\')\">\r\n              <a href=\"\" title=\"These are all the registered users who answered this question.  Click to see their annonymous individual answers.\">Email Confirmed Voters</a>\r\n            </div>\r\n            <div class=\"nslant-txt clk ylink\" ng-if=\"voter && userId && inviterData.name && !showGrpFollow\"\r\n              ng-click=\"showAnswersDetail(\'voter\')\">\r\n              <a href=\"\" title=\"This is the person that invited you to take the quiz.\" style=\"text-transform: capitalize;\" ng-if=\"inviterData.userType==\'voter\'\">{{inviterData.username}} </a>\r\n              <a href=\"\" title=\"This is the person or organization that invited you to take the quiz.\" style=\"text-transform: capitalize;\" ng-if=\"inviterData.userType==\'advocate\'\">{{inviterData.title}} </a>\r\n            </div>\r\n            <div class=\"nslant-txt clk ylink\" ng-if=\"userId && showGrpFollow\"\r\n              ng-click=\"showAnswersDetail(\'politician\')\">\r\n              <a href=\"\" title=\"These are the followers who took this quiz.  Click to see their individual answers.\">Your Followers</a>\r\n            </div>\r\n          </div>\r\n          <p></p>\r\n          <br>\r\n          <div class=\"pad10\">\r\n            <div class=\"clearfix\">\r\n              <p>&nbsp;</p>\r\n              <div class=\"mb5 clearfix\">\r\n                <span class=\"clk ylink\" ng-if=\"flagOfVoter[questions[currentIndex]._id]\" ng-click=\"viewAnsComment(\'voter\')\"><a href=\"\" title=\"Click to see their comments.\">READ COMMENTS</a></span>\r\n                <span ng-if=\"ans.comment && (ans.comment | isBlankString)\">None</span>\r\n                <span ng-if=\"!flagOfVoter[questions[currentIndex]._id]\">N/A</span>\r\n              </div>\r\n            </div>\r\n            <p></p>\r\n            <div class=\"clearfix\" style=\"height: 120px;\">\r\n              <div ng-repeat=\"i in [1,2,3,4,5,6] track by $index\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <span ng-if=\"voterAnsCount[questions[currentIndex]._id][i]\" data-tooltip=\"tooltip\" class=\"has-tip\"  title=\"Click here to see everyone who answered this way\">\r\n                <canvas class=\"clk\"\r\n                  ng-style=\"changeColor(voterAnsCount[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                  ng-click=\"showAnswers(i,\'voter\',questions[currentIndex]._id,voterAnsCount[questions[currentIndex]._id],$index)\"\r\n                  id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                </canvas>\r\n              </span>\r\n                <span ng-if=\"!voterAnsCount[questions[currentIndex]._id][i]\" data-tooltip=\"tooltip\" class=\"has-tip\"  title=\"No users to see here\">\r\n                  <canvas class=\"clk\"\r\n                    ng-style=\"changeColor(voterAnsCount[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                    ng-click=\"showAnswers(i,\'voter\',questions[currentIndex]._id,voterAnsCount[questions[currentIndex]._id],$index)\"\r\n                    id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                  </canvas>\r\n                </span>\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div>\r\n            <div class=\"clearfix\" style=\"height: 32px;\">\r\n              <div class=\"mb5 clearfix\"><br>\r\n                <div class=\"inl-blk pull-left\">{{voter[questions[currentIndex]._id]}}%</div>\r\n                <div ng-if=\"!voter[questions[currentIndex]._id]\" class=\"w100 text-center fwb\">N/A</div>\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div><br>\r\n            <div class=\"clearfix\" style=\"height: 111px;\">\r\n              <p>&nbsp;</p>\r\n              <div ng-if=\"voterImpCount[questions[currentIndex]._id]\" ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\"\r\n                style=\"line-height: 15px\">\r\n                <canvas id=\"myCanvas\" width=\"100\" height=\"10\"\r\n                  style=\"border:1px solid #141212;\r\n              background: linear-gradient(to right, #e0dbdb {{voterImpCount[questions[currentIndex]._id][i]}}%, #2b4f7f 10%); \">\r\n                </canvas>\r\n              </div>\r\n              <div ng-if=\"importance\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <i ng-if=\"loadernew\" class=\"fa fa-refresh fa-spin\" style=\"font-size:72px;float: left;margin-top: 10%\"></i>\r\n\r\n\r\n        <div class=\"pull-left ans-col\" ng-if=\"advocate && userId\">\r\n          <div class=\"clearfix  pad10\">\r\n            <div class=\"nslant-txt clk ylink\" ng-if=\"userId && !inviterData\" ng-click=\"showAnswersDetail(\'advocate\')\">\r\n              <a href=\"\" title=\"These are all the organizations who answered this question.  Click to see their individual answers.\">Organizations </a>\r\n            </div>\r\n            <div class=\"nslant-txt clk ylink\" ng-if=\"userId && inviterData.title && !showGrpFollow\"\r\n              ng-click=\"showAnswersDetail(\'advocate\')\">\r\n              <a href=\"\" title=\"This is the person or organization that invited you to take the quiz.\" style=\"text-transform: capitalize;\">{{inviterData.title}}</a>\r\n            </div>\r\n            <div class=\"nslant-txt clk ylink\" ng-if=\"userId && showGrpFollow\"\r\n              ng-click=\"showAnswersDetail(\'politician\')\">\r\n              <a href=\"\" title=\"These are the followers who took this quiz.  Click to see their individual answers.\">Your Followers</a>\r\n            </div>\r\n          </div>\r\n          <p></p>\r\n          <br>\r\n          <div class=\"pad10\">\r\n            <div class=\"clearfix\">\r\n              <p>&nbsp;</p>\r\n              <div class=\"mb5 clearfix\">\r\n                <span class=\"clk ylink\" ng-if=\"advocateFlag[questions[currentIndex]._id]\" ng-click=\"viewAnsComment(\'advocate\')\"><a href=\"\" title=\"Click to see their comments.\">READ COMMENTS</a></span>\r\n                <span ng-if=\"ans.comment && (ans.comment | isBlankString)\">None</span>\r\n                <span ng-if=\"!advocateFlag[questions[currentIndex]._id]\">N/A</span>\r\n              </div>\r\n            </div>\r\n            <p></p>\r\n            <div class=\"clearfix\" style=\"height: 120px;\">\r\n              <div ng-repeat=\"i in [1,2,3,4,5,6] track by $index\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <span ng-if=\"advocateAns[questions[currentIndex]._id][i]\" data-tooltip=\"tooltip\" class=\"has-tip\"  title=\"Click here to see everyone who answered this way\">\r\n                <canvas class=\"clk\"\r\n                  ng-style=\"changeColor(advocateAns[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                  ng-click=\"showAnswers(i,\'advocate\',questions[currentIndex]._id,advocateAns[questions[currentIndex]._id],$index)\"\r\n                  id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                </canvas>\r\n                </span>\r\n                <span ng-if=\"!advocateAns[questions[currentIndex]._id][i]\" data-tooltip=\"tooltip\" class=\"has-tip\"  title=\"No users to see here\">\r\n                    <canvas class=\"clk\"\r\n                      ng-style=\"changeColor(advocateAns[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                      ng-click=\"showAnswers(i,\'advocate\',questions[currentIndex]._id,advocateAns[questions[currentIndex]._id],$index)\"\r\n                      id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                    </canvas>\r\n                    </span>\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div>\r\n            <div class=\"clearfix\" style=\"height: 32px;\">\r\n              <div class=\"mb5 clearfix\"><br>\r\n                <div class=\"inl-blk pull-left\">{{advocate[questions[currentIndex]._id]}}%</div>\r\n                <!-- <div ng-if=\"!advocate[questions[currentIndex]._id]\" class=\"w100 text-center fwb\">N/A</div> -->\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div><br>\r\n            <div class=\"clearfix\" style=\"height: 111px;\">\r\n              <p>&nbsp;</p>\r\n              <div ng-if=\"advocateimpObj[questions[currentIndex]._id]\" ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\"\r\n                style=\"line-height: 15px\">\r\n                <canvas id=\"myCanvas\" width=\"100\" height=\"10\"\r\n                  style=\"border:1px solid #141212;\r\n              background: linear-gradient(to right, #e0dbdb {{advocateimpObj[questions[currentIndex]._id][i]}}%, #2b4f7f 10%); \">\r\n                </canvas>\r\n              </div>\r\n              <div ng-if=\"importance\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n\r\n        <div class=\"pull-left ans-col\" ng-if=\"unVerified\">\r\n          <div class=\"clearfix  pad10\">\r\n            <div class=\"nslant-txt\" ng-if=\"!userId\">\r\n              <a href=\"\" title=\"These are all the unregistered users who answered this question.  Click to see their annonymous individual answers.\">UnRegistered Users</a>\r\n            </div>\r\n            <div class=\"nslant-txt clk ylink\" ng-if=\"userId\" ng-click=\"showAnswersDetail(\'unRegister\')\"><a href=\"\" title=\"These are all the unregistered users who answered this question.  Click to see their annonymous individual answers.\">UnRegistered\r\n													Users</a></div>\r\n          </div>\r\n          <p></p>\r\n          <br>\r\n          <div class=\"pad10\">\r\n            <div class=\"clearfix\">\r\n              <p>&nbsp;</p>\r\n              <div class=\"mb5 clearfix\">\r\n                <span class=\"clk ylink\" ng-if=\"flagOfUnVerified[questions[currentIndex]._id]\" ng-click=\"viewAnsComment(\'unRegister\')\"><a href=\"\" title=\"Click to see their comments.\">READ COMMENTS</a></span>\r\n                <span ng-if=\"ans.comment && (ans.comment | isBlankString)\">None</span>\r\n                <span ng-if=\"!flagOfUnVerified[questions[currentIndex]._id]\" class=\"fwb\">N/A</span>\r\n              </div>\r\n            </div>\r\n            <p></p>\r\n\r\n            <div ng-if=\"userId\" class=\"clearfix\" style=\"height: 120px;\">\r\n              <div ng-repeat=\"i in [1,2,3,4,5,6] track by $index\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <span ng-if=\"unCount[questions[currentIndex]._id][i]\" data-tooltip=\"tooltip\" class=\"has-tip\"  title=\"Click here to see everyone who answered this way\">\r\n\r\n                <canvas class=\"clk\"\r\n                  ng-style=\"changeColor(unCount[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                  ng-click=\"showAnswers(i,\'guestUser\',questions[currentIndex]._id,unCount[questions[currentIndex]._id],$index)\"\r\n                  id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                </canvas>\r\n                </span>\r\n                <span ng-if=\"!unCount[questions[currentIndex]._id][i]\" data-tooltip=\"tooltip\" class=\"has-tip\"  title=\"No users to see here\">\r\n\r\n                    <canvas class=\"clk\"\r\n                      ng-style=\"changeColor(unCount[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                      ng-click=\"showAnswers(i,\'guestUser\',questions[currentIndex]._id,unCount[questions[currentIndex]._id],$index)\"\r\n                      id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                    </canvas>\r\n                    </span>\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div>\r\n            <div ng-if=\"!userId\" class=\"clearfix\" style=\"height: 120px;\">\r\n              <div ng-repeat=\"i in [1,2,3,4,5,6] track by $index\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <canvas\r\n                  ng-style=\"changeColor(unCount[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                  id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                </canvas>\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"clearfix\" style=\"height: 32px;\">\r\n              <div class=\"mb5 clearfix\"><br>\r\n                <div ng-if=\"unVerified[questions[currentIndex]._id]\" class=\"inl-blk pull-left\">\r\n                  {{unVerified[questions[currentIndex]._id]}}%</div>\r\n                <div ng-if=\"!unVerified[questions[currentIndex]._id]\" class=\"w100 text-center fwb\">N/A</div>\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div><br>\r\n            <div class=\"clearfix\" style=\"height: 111px;\">\r\n              <p>&nbsp;</p>\r\n              <div ng-if=\"unVeriImpo[questions[currentIndex]._id]\" ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\"\r\n                style=\"line-height: 15px\">\r\n                <!--  <span data-tooltip class=\"has-tip\" title=\"Click here to see everyone who answered this way\">-->\r\n\r\n                <canvas id=\"myCanvas\" width=\"100\" height=\"10\"\r\n                  style=\"border:1px solid #141212;\r\n         background: linear-gradient(to right, #e0dbdb {{unImpCount[questions[currentIndex]._id][i]}}%, #2b4f7f 10%); \">\r\n                </canvas>\r\n                <!--    </span>  -->\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"pull-left ans-col\" ng-if=\"!userId\">\r\n          <h6>\r\n            <p style=\"width:200px;\">If you register, we can also use your address to show you how you compare with your\r\n              local politicians and organizations.\r\n            </p>\r\n          </h6>\r\n          <center>\r\n            <button ng-if=\"!userId\" class=\"btnB275\" style=\"width:200px;\" ng-click=\"finalSignIn()\">Register Now</button>\r\n          </center>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n  <div ng-if=\"showComment\">\r\n    <div>\r\n      <a href=\"\" class=\"ylink\" style=\"padding-left: 10%\" ng-click=\"back()\">Back</a>\r\n    </div>\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Comments</legend>\r\n      <div class=\"contactBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\" style=\"width: 100%\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <br>\r\n\r\n            <!-- <span ng-if=\"\"> </span> -->\r\n            <div ng-repeat=\"com in global[questions[currentIndex]._id] | filter:getItems()\">\r\n\r\n              <div class=\"pad10\">\r\n                <span ng-if=\"com.author.username\">Name: </span><span class=\"newcomName\"> {{com.author.username}}</span>\r\n                <br>\r\n                <span>Comment: </span><span class=\"newcomName\"> {{com.comment}}</span>\r\n                <br>\r\n                <span>Answer</span>\r\n                <br>\r\n                <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n                  <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n                    style=\"padding-left: 8px;  line-height: 15px\">\r\n                    <span class=\"inl-blk pull-left\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n                    <div class=\"cq-box inl-blk pull-left\"\r\n                      ng-class=\"(com.answer == i) ? getComapreClass(com.match, i) : \'\'\"></div>\r\n                    <span class=\"inl-blk\" ng-if=\"i == 6\" style=\"padding-left:8px\">DISAGREE</span>\r\n                  </div>\r\n                </div>\r\n                <br>\r\n                <p></p>\r\n                <span>IMPORTANCE</span>\r\n                <br>\r\n                <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n                  <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"padding-left: 8px; line-height: 15px\">\r\n                    <span class=\"inl-blk\" ng-if=\"i == 1\">Very</span>\r\n                    <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                    <span class=\"inl-blk\" ng-if=\"i == 3\">Not Very</span>\r\n                    <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                      ng-class=\"(com.importance == i) ? \'ag-dg\' : \'\'\"></div>\r\n                  </div>\r\n                </div>\r\n                <hr style=\"\r\n                  margin-left: auto;\r\n                  margin-right: auto;\r\n                  height: 1px;\r\n                  background-color:#666;\r\n                  opcaity: 0.5;\">\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </fieldset>\r\n  </div>\r\n  <div ng-if=\"unComment\">\r\n    <div>\r\n      <a href=\"\" class=\"ylink\" style=\"padding-left: 10%\" ng-click=\"back()\">Back</a>\r\n    </div>\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Comments</legend>\r\n      <div class=\"contactBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\" style=\"width: 100%\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <br>\r\n            <!-- <span ng-if=\"\"> </span> -->\r\n            <div ng-repeat=\"item in unVeriComm[questions[currentIndex]._id] |filter:getComment() track by $index\">\r\n              <div class=\"pad10\">\r\n                <span>Name: </span><b>Unregistered User {{$index+1}}</b>\r\n                <br>\r\n                <span>Comment: </span><span>{{item.comment}}</span>\r\n                <br>\r\n                <span>Answer</span>\r\n                <br>\r\n                <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n                  <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n                    style=\"padding-left: 8px;  line-height: 15px\">\r\n                    <span class=\"inl-blk pull-left\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n                    <div class=\"cq-box inl-blk pull-left\"\r\n                      ng-class=\"(item.answer == i) ? getComapreClass(item.match, i) : \'\'\"></div>\r\n                    <span class=\"inl-blk\" ng-if=\"i == 6\" style=\"padding-left:8px\">DISAGREE</span>\r\n                  </div>\r\n                </div>\r\n                <br>\r\n                <p></p>\r\n                <span>IMPORTANCE</span>\r\n                <br>\r\n                <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n\r\n                  <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"padding-left: 8px;  line-height: 15px \">\r\n                    <span class=\"inl-blk\" ng-if=\"i == 1\">Very</span>\r\n                    <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                    <span class=\"inl-blk\" ng-if=\"i == 3\">Not Very</span>\r\n                    <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                      ng-class=\"(item.importance == i) ? \'ag-dg\' : \'\'\"></div>\r\n                  </div>\r\n                </div>\r\n\r\n                <hr style=\"\r\n                  margin-left: auto;\r\n                  margin-right: auto;\r\n                  height: 1px;\r\n                  background-color:#666;\r\n                  opcaity: 0.5;\">\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </fieldset>\r\n  </div>\r\n  <div ng-if=\"showCurr\">\r\n    <div>\r\n      <a href=\"\" class=\"ylink\" style=\"padding-left: 10%\" ng-click=\"back()\">Back</a>\r\n    </div>\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Comments</legend>\r\n      <div class=\"contactBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\" style=\"width: 100%\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <span>Comment: </span><span class=\"newcomName\">{{questions[currentIndex].my_answer.comment}}</span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </fieldset>\r\n  </div>\r\n  <div style=\"text-align:left;\" ng-if=\"showcomparison == true\">\r\n    <div ng-if=\"noDataFound == false\">\r\n      <div class=\"squareBoxY\" style=\"margin-left:10px;\">&nbsp;</div>\r\n      <span>= Simple Comparison by answers alone.</span>\r\n      <div style=\"clear:both;\"></div>\r\n      <div class=\"squareBoxB\" style=\"margin-left:10px\">&nbsp;</div>\r\n      <span>= Weighted Comparison by answers and importance.</span>\r\n      <div style=\"clear:both;\"></div>\r\n    </div>\r\n    <!--\r\n    <div>\r\n        <div style=\"width:30%; float:left; text-align:right;\">Order By :&nbsp;&nbsp;</div>\r\n        <div style=\"width:65%; float:left; text-align:left;\">\r\n            <select ng-model=\"ord.Option\">\r\n                <option value=\"BW\">Best Weighted match</option>\r\n                <option value=\"W\">Worst weighted match</option>\r\n                <option value=\"BS\">Best simple match</option>\r\n                <option value=\"S\">worst simple match</option>\r\n            </select>\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n    </div>\r\n    -->\r\n    <ul class=\"catList\" ng-if=\"noDataFound == false\">\r\n      <li ng-repeat=\"frd in AllUsers track by $index\" ng-if=\"FBunWeighted[frd._id] && fbcombinedWeight[frd._id]\">\r\n        <div style=\"background-color:#ffffee; padding:10px;\">\r\n          <div style=\"color: #000000;\"><b>\r\n              <div ng-repeat=\"fd in frd.politicianInfo\" ng-if=\"fd.candidateStatus==\'Running\'\"><span style=\"text-transform: capitalize;\">{{fd.officeName}}</span></div>\r\n            </b><b style=\"text-transform: capitalize;\">{{frd.name}}</b>&nbsp;&nbsp;&nbsp;Total Answered questions: {{fbqlen[frd._id]}}\r\n          </div>\r\n          <div style=\"width: 84%; float:left;\">\r\n            <div>\r\n              <div class=\"fbunweighted\" style=\"width:{{(FBunWeighted[frd._id] / fbqlen[frd._id] )  | number:2}}%\">{{(FBunWeighted[frd._id]\r\n                / fbqlen[frd._id] ) | number:2}}% Match</div>\r\n            </div>\r\n            <div>\r\n              <div class=\"fbweighted\"\r\n                style=\"width:{{(fbcombinedWeight[frd._id] / fbmultiplier[frd._id])  | number:2}}%\">{{(fbcombinedWeight[frd._id]\r\n                / fbmultiplier[frd._id]) | number:2}}% Weighted Match</div>\r\n            </div>\r\n          </div>\r\n          <div style=\"clear:both;\"></div>\r\n        </div>\r\n      </li>\r\n    </ul>\r\n    <!--  <div ng-if=\"noDataFound == true\">\r\n      <h3>\r\n        <p style=\"color:red\">Congratulations! You are the first person in your region to take this quiz. You are a true pioneer! You should contact your local politicians and your friends to encourage them to use this site. There are still plenty of wonderful things here to see.</p>\r\n      </h3>\r\n      <br>\r\n      <br>\r\n      <div class=\"margin-auto mxw\">\r\n        <div class=\"digDeeperSmall\" style=\"float:left\"> <a href=\"#!/digDeeper\"><img ng-src=\"../assets/images/DigDeeper.svg\" alt=\"Dig deeper\" /></a></div>\r\n        <button class=\"btnB275\" style=\"width:150px; float:right;\" ng-click=\"finalSignIn()\">Sign In</button>\r\n      </div>\r\n\r\n    </div> -->\r\n    <!--\r\n  <center><button class=\"btnB275\" ng-click=\"postonFacebook()\">Post Quiz to Facebook</button></center>\r\n-->\r\n    <!-- <div><center><input type=\"button\" name=\"btnNext\" value=\"Next\" ng-click=\"nextCat()\"></center></div> -->\r\n    <div ng-if=\"showcomparison == false\">\r\n      <p>This only shows politicians that have answered our quizzes. For the rest, you can see how organizations rated\r\n        them, their voting records, who financed their campaigns and more here</p>\r\n      <center><button class=\"btnB275\"> <a href=\"#!/compare-select/politician\">See Other Politicians</a></button>\r\n      </center><br><br>\r\n    </div>\r\n    </div>\r\n    <div class=\"mb5 clearfix print-hide\"\r\n      ng-if=\"!showComment && !unComment && !showPoliAnswerDetails && !showUserAnswerDetails && !showCurr\">\r\n      <!-- <a class=\"clk fwb\" ng-click=\"prevQuestion()\">Prev</a>&nbsp;\r\n                  <a class=\"clk fwb\" ng-click=\"skipQuestion()\">Next</a> -->\r\n      <button class=\"compareBtnS\" ng-click=\"prevQuestion()\"><i class=\"fa fa-angle-left arrowIconBack\"></i>Prev</button>\r\n      <button class=\"compareBtnS\" ng-click=\"skipQuestion()\">Next<i class=\"fa fa-angle-right arrowIconSubmit\"></i></button>\r\n    </div>\r\n    <div ng-show=\"questions.length <= 0 && status.questions == 2\">\r\n      <a href=\"javascript: void(0)\" ng-click=\"skipQuestion()\" class=\"changeTextColor\">Next</a>\r\n      <a href=\"javascript: void(0)\" ng-click=\"prevQuestion()\" class=\"changeTextColor\">Prev</a>\r\n    </div>\r\n    <button class=\"compareBtn\"><a href=\"#!/whatAmILookingAt1\">What Am I Looking At?</a></button>\r\n    <!--<br>\r\n	<button class=\"compareBtn\"><a href=\"#!/ballotMatch\">Did you skip this question?  Take the quiz.</a></button> -->\r\n  </div>\r\n  <script type=\"text/ng-template\" id=\"ReviewMyAnswers\">\r\n    <h3>Review answers and hide private thoughts from<span ng-if=\"inviterData\" style=\"text-transform: capitalize;\"> {{inviterData.username}}.</span> <span ng-if=\"!inviterData\"> your friends.</span></h3>\r\n<p ng-if=\"inviterData\">The default is to show everything to <span style=\"text-transform: capitalize;\">{{inviterData.username}},</span> but if you want to hide any of your answers, click below.</p>\r\n  <p ng-if=\"!inviterData\">Please review the questions and make sure you want to make your answers public.</p>\r\n    <center>\r\n    <div ng-if=\"showLoader\" style=\"z-index: 2; background:black;\"><i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span></div>\r\n\r\n  </center>\r\n  <table class=\"w100\">\r\n    <tr>\r\n      <th>Num.</th>\r\n      <th>Question</th>\r\n      <th>Answer</th>\r\n      <th>Importance</th>\r\n      <th>Show/Hide</th>\r\n    </tr>\r\n    <tr ng-repeat=\"q in allQuestions | orderBy:\'categories[0].viewOrder\' track by $index\" ng-init=\"q.my_answer.show!=\'N\'? switchStatus[$index]=true: switchStatus[$index]=false;\">\r\n      <td>\r\n        {{$index + 1}}\r\n      </td>\r\n      <td style=\"text-align:left;\">\r\n        {{q.content}}\r\n      </td>\r\n      <td>\r\n        {{AnswerArray[q.my_answer.answer]}}\r\n      </td>\r\n      <td>\r\n        {{AnswerImpArray[q.my_answer.importance]}}\r\n      </td>\r\n      <td>\r\n        <!-- <div toggle-switch class=\"switch-small\" on-label=\"Show\" off-label=\"Hide\" ng-model=\"switchStatus\"></div> -->\r\n        <toggle-switch ng-model=\"switchStatus[$index]\" class=\"switch-small\" on-label=\"Show\" off-label=\"Hide\" ng-change=\"switchFilters(switchStatus, $index, q)\"></toggle-switch>\r\n      </td>\r\n\r\n    </tr>\r\n  </table>\r\n  <br>\r\n  <center>\r\n      <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"backTo()\">\r\n          Change Answers\r\n          </button>\r\n    <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"cancel()\">\r\n       Close\r\n       </button>\r\n  </center>\r\n  </script>\r\n");
$templateCache.put("app/fiveMatchQuestions/fiveMatchQuestions.html","<div class=\"container-fluid ng-scope\">\r\n   <h2 class=\"pageHeading\">Settings</h2>\r\n  <div>\r\n  <div class=\"closeForm\" ng-include=\"\'app/popups/setting_Ctrl.html\'\"></div>\r\n  </div>\r\n  <div class=\"closeForm\" ng-if=\"showFiveMatchQuestion\" ng-controller=\"MatchQuestionsCtrl\">\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Manage five match Questions</legend>\r\n      <div class=\"row\">\r\n        <table class=\"w100 changeTextColor\" ng-if=\"questions.length > 0\" style=\"margin-top: 10px;\">\r\n          <tr>\r\n            <th style=\"width:5%;\">Order</th>\r\n            <th style=\"width:70%;\">Question</th>\r\n            <th style=\"width:10%;\">Edit</th>\r\n            <th style=\"width:10%;\">Remove from match</th>\r\n          </tr>\r\n          <tr ng-repeat=\"q in questions\">\r\n            <td>{{q.matchOrder}}</td>\r\n            <td>{{q.content}}</td>\r\n            <td>\r\n              <a href=\"javascript: void(0)\" ng-click=\"editQeustion(q, $index)\">Edit</a>\r\n            </td>\r\n            <td>\r\n              <a href=\"javascript: void(0)\" ng-click=\"removeReportedQeustion(q, $index)\" class=\"link\">Remove from match</a>\r\n            </td>\r\n          </tr>\r\n        </table>\r\n      </div>\r\n    </fieldset>\r\n  </div>\r\n    <div class=\"closeForm\" ng-if=\"showReportQuestion\" ng-controller=\"ReportQuestionsCtrl\">\r\n          <fieldset class=\"scheduler-border\">\r\n            <legend class=\"scheduler-border\">Manage reported Questions</legend>\r\n            <div class=\"row\">\r\n              <table class=\"w100 changeTextColor\" ng-if=\"questions.length > 0\" style=\"margin-top: 10px;\">\r\n                <tr>\r\n                  <th>Question</th>\r\n                  <th>Reason</th>\r\n                  <th>Reported By</th>\r\n                  <th>Edit</th>\r\n                  <th>Remove</th>\r\n                </tr>\r\n                <tr ng-repeat=\"q in questions\">\r\n                  <td>{{q.question.content}}</td>\r\n                  <td>\r\n                    {{q.data.comment}}\r\n                  </td>\r\n                  <td>\r\n                    {{q.user.username}}\r\n                  </td>\r\n                  <th>\r\n                    <a href=\"javascript: void(0)\" ng-click=\"editQeustion(q.question, $index)\">Edit</a>\r\n                  </th>\r\n                  <th>\r\n                    <a href=\"javascript: void(0)\" ng-click=\"removeReportedQeustion(q.data, $index)\" class=\"link\">Remove from reported</a>\r\n                  </th>\r\n                </tr>\r\n              </table>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n</div>\r\n");
$templateCache.put("app/fivemincompare/fivemincompare.html","<style type=\"text/css\">\r\n  .digDeeperSmall {\r\n    width: 150px;\r\n  }\r\n</style>\r\n<center>\r\n  <h2>Match</h2>\r\n</center>\r\n<!-- <div ng-if=\"showcomparison == false\"><br>\r\n  <!--    <img ng-src=\"./assets/images/learnTopics.svg\" class=\"blockInfoImgLearn img-fluid\">  -->\r\n  <!--<div id=\"match5MinWarning\" ng-if=\"FBCompareList.length > 0\">\r\n    <div>\r\n      <h4 class=\"blockTitleLearn\">THIS LIST IS INCOMPLETE</h4>\r\n					<span class=\"blockDesc\">This only shows active candidates that have answered the Five Minute Quiz. Click <a href=\"#!/ballotMatch\" class=\"link\">HERE</a> to answer questions from <i>other</i> quizzes that some of your candidates answered.  For information on ALL of your candidates, you need to click <a href=\"#!/compare-select/politician\" class=\"link\"><b>HERE</b> </a>  where you can see their voting records, who financed their campaigns, and how the organizations you care about rated them.</span>\r\n    </div>\r\n  </div>\r\n</div>\r\n-->\r\n<div class=\"container\" ng-if=\"showcomparison == false\" >\r\n  <div ng-if=\"bannerInfo.length > 0\" class=\"app-mk-center\">\r\n    <div\r\n      class=\"col-lg-12 col-sm-12 gettingStartedContainer\"\r\n      ng-repeat=\"banner in bannerInfo\"\r\n    >\r\n      <div ng-if=\"banner.isActive\">\r\n        <div\r\n          class=\"gettingStartedBlock gettingStartedBlock4\"\r\n          style=\"background-color: yellow\"\r\n        >\r\n          <div>\r\n            <h4 class=\"gettingStartedBlockTitle\">Note</h4>\r\n            <p\r\n              class=\"gettingStartedBlockDesc\"\r\n              ng-bind-html=\"banner.description | newlines\"\r\n            ></p>\r\n											            <center>\r\n              <b> <a href=\"{{banner.webLink}}\" target=\"_blank\">{{banner.webLink}}</a></b>\r\n            </center>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n\r\n<div class=\"info-container item-center \" style=\"min-width:345px\";>\r\n<div class=\"dropdwn-container\">\r\n<label for=\"electionDate\"><h4><b>CANDIDATES</b></h4> </label>\r\n  <select  ng-init=\"quiz.eDate = electionDates[0]\" ng-model=\"quiz.eDate\"  ng-options=\"item as item.eDate for item in electionDates\" ng-change=\"getResultDateWise(\'date\')\" class=\"changeTextColor election-dropdwn form-control\"></select>\r\n</div>\r\n<div class=\"partyInfo dropdwn-container\">\r\n  <select ng-init=\"quiz.party = parties[0]\" ng-model=\"quiz.party\"  ng-options=\"item as item for item in parties\" ng-change=\"getResultDateWise(\'party\')\" class=\"changeTextColor party-drop election-dropdwn form-control\"></select>\r\n</div>\r\n</div>\r\n<center><div ng-if=\"loader\" style=\"z-index: 2; background:black;\"><i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span></div></center>\r\n\r\n\r\n  <div  class=\"info-container space-top\" ng-repeat=\"(key, value) in allCandidates | orderBy: \'dataY\' | groupBy: \'office\' \" ng-if=\"value.length >0\" style=\"min-width:345px\";>\r\n  <div class=\"offices-info\">\r\n			<div style=\"text-transform: capitalize;\"><h4><b>{{key}}</b></h4></div>\r\n    <div ng-if=\"checkIfDatax(key,value)\">\r\n  {{checkIfDatax(key,value)}}  Year Term\r\n\r\n    </div>\r\n    <div ng-if=\"showNumberOfOpening(key,value)\">\r\n\r\n     Vote for {{showNumberOfOpening(key,value)}} </div>\r\n  </div>\r\n  <div class=\"compare-headers\">\r\n    <div class=\"title-container\"  ng-if=\"isAnsExist(key,value)\">\r\n     <h6 class=\"compare-quiz word-brk cmp-statement\">\r\n     <a href=\"\" style=\"text-decoration: none; color: black;\" ng-click=\"showDetails(key)\">\r\n    Compare Mulitple Choice\r\n    </a>\r\n\r\n  </h6>\r\n    </div>\r\n    <div class=\"title-container\"  ng-if=\"isShowBarAsso(key,\'false\')\" >\r\n\r\n     <h6 class=\"compare-quiz  clk\" >\r\n\r\n     <a href=\"{{isShowBarAsso(key,\'true\')}}\"  target=\"_blank\" style=\"text-decoration: none; color: black;\">\r\n    Bar<br>Ratings\r\n    </a>\r\n  </h6></div>\r\n\r\n<div class=\"title-container clk\" ng-if=\"isEssayAnsExist(key,value)\">\r\n <h6 class=\"compare-quiz word-brk cmp-statement\">\r\n  <a href=\"\" style=\"text-decoration: none; color: black;\" ng-click=\"showAnswerDetails(key)\">\r\n    Compare Essay Answers\r\n    </a>\r\n    </h6>\r\n</div>\r\n\r\n  </div>\r\n<hr class=\"result-divider\">\r\n<!-- ng-if=\"fbqlen[frd._id]\" -->\r\n<div  ng-repeat=\"frd in value | orderBy:[\'-total_answers\',\'-politicianInfo[0].officeName\',\'_id\'] track by $index\">\r\n\r\n<h5 class=\"center\"> <i ng-if=\"ShowAsterix[frd._id]\" class=\"fa fa-asterisk clk info-color\" aria-hidden=\"true\" ng-click=\"showNotice()\"></i>  <a href=\"#!/publicProfile/{{frd._id}}\" style=\"text-transform: capitalize;text-decoration: none; color: black;\" class=\"link\"><b>{{frd.name}}</b></a></h5>\r\n\r\n	<div class=\"hideNonCell\">\r\n  <div class=\"compare-headers\">\r\n  <div class=\"result-info\" ng-if=\"fbqlen[frd._id] && !isShowBarAsso(key,\'false\')\">\r\n  <div style=\"color:blue; cursor:pointer;\" ng-if=\"noOfQuesMutuallyAns[frd._id]\"	ng-click=\"showMacthOnPop(frd,\'true\')\">{{(fbcombinedWeight[frd._id] / fbmultiplier[frd._id] ) | number:2}}% Match &nbsp;&nbsp;&nbsp; <span ng-if=\"confidenceLevel[frd._id] <= 33\">+/- {{confidenceLevel[frd._id]}}%</span><span ng-if=\"confidenceLevel[frd._id] >33\" style=\"color:red; cursor:pointer;\"> +/- {{confidenceLevel[frd._id]}}%</span></div>\r\n  <a href=\"\" ng-if=\"!noOfQuesMutuallyAns[frd._id]\" class=\"link\" style=\"color:blue;\" ng-click=\"showMacthOnPop(frd,\'false\')\">Answer More for Match</a>\r\n  <div ng-if=\"noOfQuesMutuallyAns[frd._id]\">\r\n      <canvas  class=\"clk\"        ng-click=\"showMacthOnPop(frd,\'true\')\"\r\n                      ng-style=\"changeColor((fbcombinedWeight[frd._id] / fbmultiplier[frd._id] ) | number:2)\"\r\n                      width=\"200\" height=\"15\" id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #FEFF10;\">\r\n			</canvas></div></div>\r\n  </div>\r\n\r\n    <div class=\"result-info\"  ng-if=\"barRatingData[frd._id] && barRatingData[frd._id].length > 0\">\r\n<!--<div>Bar Associations Rating</div> -->\r\n<div ng-repeat=\"bar in barRatingData[frd._id]\">\r\n<div>{{bar.associationName}} Rating</div>\r\n<div> <a href=\"{{bar.links}}\" target=\"_blank\"><img ng-src=\"{{getUrl(bar)}}\" width=\"40px\" alt=\"\" srcset=\"\"></a>\r\n <span>{{bar.review}}</span></div>\r\n</div>\r\n  </div>\r\n   <div class=\"result-info hideNonCell\" ng-if=\"!fbqlen[frd._id] && barRatingData[frd._id] && barRatingData[frd._id].length == 0\">\r\n <div style=\"width: 200px;\"></div>\r\n   </div>\r\n\r\n\r\n			 <div><center>\r\n\r\n  	<center><button ng-click=\"goToPoliticianThread(key, value, frd)\" class=\"viewDebates\" ng-if=\"frd.total_tagged && frd.total_tagged != 0\"> View Debates\r\n          </button></center>\r\n\r\n\r\n <div class=\"more clk\" ng-if=\"essayAnswers[frd._id] && essayAnswers[frd._id].length > 0\" style=\"width: 200px;\">\r\n  <div class=\"compare-quiz\">\r\n   <a href=\"\" style=\"text-decoration: none; color: black;\" ng-click=\"readStatement(essayAnswers[frd._id])\">Essay Answers</a>\r\n  </div>\r\n					</div>\r\n					  <div class=\"more clk\" style=\"width: 200px; margin-top: 10px;\">\r\n  <div class=\"compare-quiz\">\r\n  <a href=\"#!/publicProfile/{{frd._id}}\" style=\"text-transform: capitalize; text-decoration: none; color: black;\" class=\"link\">More</a>\r\n  </div>\r\n  </div>\r\n					</center>	<br>\r\n  </div>\r\n		</div>\r\n\r\n\r\n\r\n			<div class=\"hideCell\">\r\n  <div class=\"compare-headers\">\r\n  <div class=\"result-info\" ng-if=\"fbqlen[frd._id]\">\r\n   <div style=\"color:blue; cursor:pointer;\" ng-if=\"noOfQuesMutuallyAns[frd._id]\"	ng-click=\"showMacthOnPop(frd,\'true\')\">{{(fbcombinedWeight[frd._id] / fbmultiplier[frd._id] ) | number:2}}% Match &nbsp;&nbsp;&nbsp; <span ng-if=\"confidenceLevel[frd._id] <= 33\">+/- {{confidenceLevel[frd._id]}}%</span><span ng-if=\"confidenceLevel[frd._id] >33\" style=\"color:red; cursor:pointer;\"> +/- {{confidenceLevel[frd._id]}}%</span></div>\r\n  <a href=\"\" ng-if=\"!noOfQuesMutuallyAns[frd._id]\" class=\"link\" style=\"color:blue;\" ng-click=\"showMacthOnPop(frd,\'false\')\">Answer More for Match</a>\r\n\r\n  <div ng-if=\"noOfQuesMutuallyAns[frd._id]\">\r\n      <canvas  class=\"clk\"        ng-click=\"showMacthOnPop(frd,\'true\')\"\r\n                      ng-style=\"changeColor((fbcombinedWeight[frd._id] / fbmultiplier[frd._id] ) | number:2)\"\r\n                      width=\"200\" height=\"15\" id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #FEFF10;\">\r\n			</canvas>\r\n  </div>\r\n\r\n  </div>\r\n\r\n<div class=\"result-info\" ng-if=\"barRatingData[frd._id] && barRatingData[frd._id].length > 0\">\r\n<!--<div>Bar Associations Rating</div>-->\r\n<div ng-repeat=\"bar in barRatingData[frd._id]\">\r\n<div>{{bar.associationName}} Rating</div>\r\n<div>\r\n	<a href=\"{{bar.links}}\" target=\"_blank\"><img ng-src=\"{{getUrl(bar)}}\" width=\"40px\" alt=\"\" srcset=\"\"></a> <span>{{bar.review}}</span>\r\n</div>\r\n </div>\r\n  </div>\r\n   <div class=\"result-info\" ng-if=\"!fbqlen[frd._id] && barRatingData[frd._id] && barRatingData[frd._id].length == 0\">\r\n <div style=\"width: 200px;\"></div>\r\n   </div>\r\n\r\n<!--  	<button ng-click=\"goToPoliticianThread(key, value, frd)\" class=\"viewDebates\" ng-if=\"frd.total_tagged && frd.total_tagged != 0\"> View Debates\r\n          </button>-->\r\n\r\n <div class=\"essay-answers\">\r\n <div class=\"more clk\" ng-if=\"frd.total_tagged && frd.total_tagged != 0\" style=\"min-width: 120px;\">\r\n  <div class=\"compare-quiz\">\r\n   <a href=\"\" style=\"text-decoration: none; color: black;\" ng-click=\"goToPoliticianThread(key, value, frd)\">View Debates</a>\r\n  </div>\r\n  </div>\r\n			</div>\r\n\r\n\r\n  <div class=\"essay-answers\">\r\n <div class=\"more clk\" ng-if=\"essayAnswers[frd._id] && essayAnswers[frd._id].length > 0\" style=\"min-width: 120px;\">\r\n  <div class=\"compare-quiz\">\r\n   <a href=\"\" style=\"text-decoration: none; color: black;\" ng-click=\"readStatement(essayAnswers[frd._id])\">Essay Answers</a>\r\n  </div>\r\n  </div>\r\n			</div>\r\n\r\n		  <div class=\"essay-answers\">\r\n  <div class=\"more clk\" style=\"min-width: 120px;\">\r\n			<div class=\"compare-quiz\">\r\n  <a href=\"#!/publicProfile/{{frd._id}}\" style=\"text-decoration: none; color: black;\">More</a>\r\n  </div>\r\n  </div>\r\n			</div>\r\n				</div>\r\n\r\n\r\n\r\n\r\n\r\n		</div>\r\n\r\n\r\n\r\n <!--  <div class=\"compare-headers\">\r\n  <!--<div class=\"save\">\r\n   <input type=\"checkbox\"  name=\"chk\" id=\"chk\" ng-model=\"frd.isChecked\" class=\"form-control\" style=\"margin-right:10%;cursor:pointer;\" ng-change=\"saveCandidates(frd)\">\r\n  <label class=\"txt-save\">Save</label>\r\n  </div> -->\r\n  <!--<div class=\"more clk\">\r\n  <div class=\"compare-quiz\">\r\n  <a href=\"#!/publicProfile/{{frd._id}}\" style=\"text-transform: capitalize; text-decoration: none; color: black;\" class=\"link\">More</a>\r\n  </div>\r\n  </div>\r\n  </div>-->\r\n  <hr class=\"result-divider-with-space\">\r\n</div>\r\n  </div>\r\n\r\n   <div ng-if=\"showBanner\">\r\n    <h3>\r\n      <p style=\"color:red\">Candidates are not found for the selected party. Please select another</p>\r\n    </h3>\r\n\r\n    <!-- <div style=\"float: right; margin-right: 20px; margin-top: 7px; color:#ffffff;\">Already a member? <a style=\"text-decoration: underline;\" href=\"#!/fiveminsignin\" class=\"ylink\">Sign in</a></div> -->\r\n  </div>\r\n\r\n<!-- <div class=\"info-container space-top\">\r\n<div class=\"offices-info\">\r\n			<div style=\"text-transform: capitalize;\"><h4><b>Lower Court Judge</b></h4></div>\r\n    <div>\r\n 4 Year Term.\r\n\r\n    </div>\r\n    <div>\r\n\r\n     Vote for Four </div>\r\n  </div>\r\n  <div class=\"compare-headers\">\r\n    <div class=\"title-container\"  style=\"padding-top: 0; padding-bottom: 0;\">\r\n     <h6 class=\"compare-quiz  clk cmp-statement\">\r\n     <a href=\"\" style=\"text-decoration: none; color: black;\" ng-click=\"showDetails()\">\r\n    Bar Ratings\r\n    </a>\r\n  </h6>\r\n    </div>\r\n\r\n<div class=\"title-container clk\" style=\"padding-top: 0;padding-bottom: 0;\">\r\n <h6 class=\"compare-quiz cmp-statement\">\r\n  <a href=\"\" style=\"text-decoration: none; color: black;\" ng-click=\"showAnswerDetails(key)\">\r\n    Compare Words\r\n    </a>\r\n    </h6>\r\n</div>\r\n\r\n</div>\r\n<hr class=\"result-divider\">\r\n\r\n<div class=\"compare-headers\">\r\n<div>\r\n\r\n<p>Bill Ducan</p>\r\n<div>Bar Associations Rating</div>\r\n<div> <img src=\"../assets/images/redX.svg\" width=\"40px\" alt=\"\" srcset=\"\"> <span>Not Qualified</span></div>\r\n</div>\r\n<div>\r\nWritten Answers\r\n\r\n <div class=\"more clk\"  style=\"min-width: 120px;\">\r\n  <div class=\"compare-quiz\">\r\n   <a href=\"\" style=\"text-decoration: none; color: black;\" ng-click=\"readStatement(essayAnswers[frd._id])\">Read Statements</a>\r\n  </div>\r\n  </div>\r\n</div>\r\n</div>\r\n\r\n\r\n</div> -->\r\n<!--<center>\r\n<button ng-if=\"allCandidates.length > 0\" class=\"viewDebates\">\r\n\r\n        <a href=\"\" style=\"text-decoration: none; color: black;\" ng-click=\"showSavedCandidates()\"><b>SEE SAVED</b></a>\r\n\r\n</button></center>\r\n\r\n<!--<div ng-if=\"showcomparison == false\">\r\n  <center>\r\n    <a href=\"\" ng-click=\"showDetails()\"><button class=\"compareBtn\"> Match Details</button></a>\r\n    <a href=\"#!/compare-select/politician\"><button class=\"compareBtn\">See Other Politicians</button></a></center><br><br>\r\n</div>\r\n-->\r\n  <div class=\"alert alert-danger alert-dismissible\" id=\"alert\" ng-if=\"showAlert\" style=\"width:60%;margin-left:\r\n            20%;margin-top:10%\">\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button>\r\n    <strong> Please verify your email first. </strong>\r\n  </div>\r\n  <!--     <h2>BACKGROUND</h2></center>\r\n    <p></p>\r\n    <p ng-bind-html=\"category.description | newlines\"></p>-->\r\n  <!--<div ng-if=\"loader\" class=\"fwb\">\r\n\r\n    Loading data ...\r\n    <p>\r\n      <center><i class=\"fa fa-refresh fa-spin\" style=\"font-size:72px;\"></i></center>\r\n    </p>\r\n  </div>-->\r\n\r\n\r\n</div>\r\n  <div ng-if=\"showcomparison == true && !loader\">\r\n    <div ng-show=\"state == \'question-compare-politician\'\">\r\n      <div>\r\n        <p>\r\n          <h1>\r\n            <center style=\"text-transform:capitalize;\">{{category.title}}</center>\r\n          </h1>\r\n        </p>\r\n        <p></p>\r\n        <div>\r\n          <center ng-if=\"category.fbImage\">\r\n            <img ng-src=\"https://api.votewise.net/resources/{{category.fbImage}}\" class=\"wibble\" /></center>\r\n        </div>\r\n        <center id=\"DisplayC\">\r\n          <h2>BACKGROUND</h2>\r\n        </center>\r\n        <p></p>\r\n        <p ng-bind-html=\"category.description | newlines\"></p>\r\n      </div>\r\n      <div ng-show=\"questions[currentIndex]\">\r\n        <!-- <type=\"button\" value=\"LEARN MORE\"> -->\r\n        <!--      <button ng-click=\"$root.printPage()\" class=\"print-hide changeTextColor\">Print this page</button>  -->\r\n        <p></p>\r\n        <center id=\"DisplayQ\">\r\n          <h2>QUESTION</h2>\r\n        </center>\r\n        <p></p>\r\n        <p></p>\r\n        <center>({{currentIndex+1}} of {{questions.length}})</center>\r\n        <p></p>\r\n        <p>STATEMENT: <span class=\"card-text\" ng-bind-html=\"questions[currentIndex].content | newlines\"></span></p>\r\n        Your Answers<span  style=\"margin-left: 30px;\">Their Answers</span>\r\n        <div class=\"clearfix\">\r\n          <div class=\"pull-left ans-col\" style=\"border-right: 3px solid #de8998;\">\r\n            <div class=\"pad10\">\r\n              <div class=\"clearfix\" style=\"line-height: 9px\">\r\n                <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\">\r\n                  <span class=\"inl-blk\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n                  <span class=\"inl-blk\" ng-if=\"i == 6\">DISAGREE</span>\r\n                  <div class=\"cq-box inl-blk pull-right\"\r\n                    ng-class=\"(questions[currentIndex].my_answer.answer == i) ? (\'ag-green\') : \'\'\"></div>\r\n                </div>\r\n              </div>\r\n              <div class=\"clearfix\">\r\n                <div class=\"mb5 clearfix\"><br>\r\n                  <div class=\"inl-blk pull-right\">MATCH %</div>\r\n                </div>\r\n              </div><br>\r\n              <div class=\"clearfix\" style=\"line-height: 9px\">\r\n                <p>IMPORTANCE</p>\r\n                <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\">\r\n                  <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n                  <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n                  <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                  <div class=\"cq-box inl-blk pull-right \"\r\n                    ng-class=\"(questions[currentIndex].my_answer.importance == i) ? \'ag-dg\' : \'\'\"></div>\r\n                </div>\r\n              </div>\r\n              <div class=\"clearfix\"><br>\r\n                <p>COMMENTS</p>\r\n                <div class=\"mb5 clearfix\">\r\n                  <div class=\"inl-blk pull-right\">\r\n                    <span class=\"clk ylink\" ng-if=\"!(questions[currentIndex].my_answer.comment | isBlankString)\" ng-click=\"viewAnsComment(questions[currentIndex].my_answer)\">READ</span>\r\n                    <span ng-if=\"questions[currentIndex].my_answer.comment | isBlankString\">None</span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"clearfix vtxt-wrap pad10\">\r\n            </div>\r\n          </div>\r\n          <div class=\"pull-left ans-col\" ng-repeat=\"ans in questions[currentIndex].answers | orderBy:\'author.name\'\" ng-if=\"ans.author.name\">\r\n\r\n            <div class=\"pad10\" ng-if=\"showSelectedOffice(ans)\">\r\n              <div class=\"clearfix\" style=\"height: 120px;\">\r\n                <div ng-if=\"ans.answer > -1\" ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\">\r\n                  <div class=\"cq-box inl-blk pull-right\"\r\n                    ng-class=\"(ans.answer == i) ? getComapreClass(ans.match, i) : \'\'\"></div>\r\n                  <!-- ng-class=\"(ans.answer == i) ? (\'ag-dg\'+i) : \'\'\" -->\r\n                </div>\r\n                <div ng-if=\"!ans.answer\" class=\"flex w100 h100\">\r\n                  <span><b>N/A</b></span>\r\n                </div>\r\n              </div>\r\n              <div class=\"clearfix\" style=\"height: 32px;\">\r\n                <div class=\"mb5 clearfix\"><br>\r\n                  <div ng-if=\"ans.match != null\" class=\"inl-blk pull-right\"></i>{{ans.match}}%</div>\r\n                  <div ng-if=\"ans.match == null\" class=\"w100 text-center fwb\">N/A</div>\r\n                  <i ng-if=\"ShowAsterix[ans.author._id]\" class=\"fa fa-asterisk clk info-color\" aria-hidden=\"true\" ng-click=\"showNotice()\"></i>\r\n\r\n								<i ng-if=\"ans.oldAnswers.length > 0 && !ans.referenceBy\" class=\"fa fa-asterisk clk icolor\" aria-hidden=\"true\" ng-click=\"getOldAnswers(ans.oldAnswers)\" style=\"font-size: 15px;\"></i>\r\n                </div>\r\n              </div><br>\r\n              <div class=\"clearfix\" style=\"height: 111px;\">\r\n                <p>&nbsp;</p>\r\n                <div ng-if=\"ans.importance\" ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\">\r\n                  <div class=\"cq-box inl-blk pull-right \" ng-class=\"(ans.importance == i) ? \'ag-dg\' : \'\'\"></div>\r\n                </div>\r\n                <div ng-if=\"!ans.importance\" class=\"flex w100 h100\">\r\n                  <span><b>N/A</b></span>\r\n                </div>\r\n              </div>\r\n              <div class=\"clearfix\">\r\n                <p>&nbsp;</p>\r\n                <div class=\"mb5 clearfix\">\r\n                  <span class=\"clk ylink\" ng-if=\"ans.comment && !(ans.comment | isBlankString)\" ng-click=\"viewAnsComment(ans)\">READ</span>\r\n                  <span ng-if=\"ans.comment && (ans.comment | isBlankString)\">No</span>\r\n                  <span ng-if=\"!ans.comment\" class=\"fwb\">N/A</span>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"clearfix vtxt-wrap pad10\" ng-if=\"showSelectedOffice(ans)\">\r\n              <div class=\"ver-txt\">\r\n                <div style=\"line-height:12px; text-transform: capitalize;\"><i ng-if=\"ShowAsterix[frd._id]\" class=\"fa fa-asterisk clk info-color\"  aria-hidden=\"true\" ng-click=\"showNotice()\"></i>{{ans.author.nameOnBallot}}</div>\r\n                <!-- <div style=\"line-height:12px;\" ng-if=\"!ans.author.nameOnBallot\">{{ans.author.name}}</div> -->\r\n                <div style=\"line-height:12px;\" ng-repeat=\"pitem in ans.author.politicianInfo\"\r\n                  ng-if=\"pitem.candidateStatus==\'Running\' ||  pitem.candidateStatus ==\'Announced\'\" style=\"text-transform:capitalize;\">{{pitem.officeName}}</div>\r\n              </div>\r\n            </div>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"mb5 clearfix print-hide\">\r\n        <!-- <a class=\"clk fwb\" ng-click=\"prevQuestion()\">Prev</a>&nbsp;\r\n                  <a class=\"clk fwb\" ng-click=\"skipQuestion()\">Next</a> -->\r\n        <button class=\"compareBtnS\" ng-click=\"prevQuestion()\"><i class=\"fa fa-angle-left arrowIconBack\"></i>Prev</button>\r\n        <button class=\"compareBtnS\" ng-click=\"skipQuestion()\">Next<i class=\"fa fa-angle-right arrowIconSubmit\"></i></button>\r\n							<p><i class=\"fa fa-asterisk clk info-color\"  style=\"font-size: 15px;\"></i> This indicates that the politician did not answer this question, but we did research to figure out their LIKELY answer.  You can see our research notes by clicking on their yellow asterisk.</p><br>\r\n					<p><i class=\"fa fa-asterisk clk icolor\"  style=\"font-size: 15px;\"></i> This indicates that the politician changed\r\n        their answer at some point - possibly because they learned more about the topic. You can see the politician\'s\r\n        old answers for this question and the reasons for changing them by clicking on their asterix.</p><br>\r\n      <p>NOTE: Some of the politician questions were taken from other sources where an answer of \"True\" or \"False\" was\r\n        converted to \"Somewhat Agree\" or \"Somewhat Disagree\" (one point from either extreme) and we gave those answers\r\n        an\r\n        importance level of \"Somewhat important\". This may mean their answers do not fully express their passion or\r\n        conviction.</p>\r\n      </div>\r\n\r\n <!--     <button class=\"compareBtn\"><a href=\"#!/whatAmILookingAt4\">What Am I Looking At?</a></button> -->\r\n    </div>\r\n  </div>\r\n  <div ng-if=\"status.questions == 2 && questions.length == 0\" class=\"fwb\">\r\n    <center>No unanswered questions found.</center>\r\n  </div>\r\n  <div ng-if=\"status.questions == 1\" class=\"fwb\">\r\n    Loading questions ...\r\n  </div>\r\n  <div ng-if=\"status.questions == 3\" class=\"fwb\">\r\n    Something went wrong while loading questions.\r\n  </div>\r\n<!--\r\n<div style=\"text-align:left;\" ng-if=\"showcomparison == false\">\r\n\r\n			<div ng-if=\"politician || showadv || showvoter || noDataFound == false\">\r\n    <div class=\"squareBoxY\" style=\"margin-left:10px;\">&nbsp;</div>\r\n    <span>= Simple Comparison by answers alone.</span>\r\n    <div style=\"clear:both;\"></div>\r\n    <div class=\"squareBoxB\" style=\"margin-left:10px\">&nbsp;</div>\r\n    <span>= Weighted Comparison by answers and importance.</span>\r\n    <div style=\"clear:both;\"></div>\r\n				<button class=\"compareBtn\"><a href=\"#!/whatAmILookingAt3\">What this means</a></button>\r\n  </div>-->\r\n  <!--\r\n    <div>\r\n        <div style=\"width:30%; float:left; text-align:right;\">Order By :&nbsp;&nbsp;</div>\r\n        <div style=\"width:65%; float:left; text-align:left;\">\r\n            <select ng-model=\"ord.Option\">\r\n                <option value=\"BW\">Best Weighted match</option>\r\n                <option value=\"W\">Worst weighted match</option>\r\n                <option value=\"BS\">Best simple match</option>\r\n                <option value=\"S\">worst simple match</option>\r\n            </select>\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n    </div>\r\n    -->\r\n  <ul class=\"catList\" ng-if=\"noDataFound == false\">\r\n    <li ng-if=\"politician\">\r\n      <div style=\"background-color:#ffffee; padding:10px;\">\r\n        <div style=\"color: #000000;\"><b>\r\n\r\n           </b>\r\n          <b ng-if=\"!userId\">Email Confirmed Users</b><a href=\"\" ng-click=\"redirectTo(\'politician\')\"><b ng-if=\"userId && !inviterName\">Politicians in your area</b> <b ng-if=\"inviterName && allUser.length == 1\" style=\"text-transform: capitalize;\" class=\"link\">{{inviterName}}</b> <b ng-if=\"isShowFollow && allUser.length > 1\">Your Followers (Politicians)</b> </a>&nbsp;&nbsp;&nbsp;Total\r\n          Answered Questions: {{fbqlen}}\r\n        </div>\r\n        <div style=\"width: 84%; float:left;\">\r\n          <div>\r\n            <div class=\"fbunweighted\" style=\"width:{{(FBunWeighted  )  | number:2}}%\">{{(FBunWeighted ) | number:2}}% Match\r\n            </div>\r\n          </div>\r\n          <div>\r\n            <div class=\"fbweighted\" style=\"width:{{(fbcombinedWeight / fbmultiplier)  | number:2}}%\">{{(fbcombinedWeight\r\n                / fbmultiplier) | number:2}}% Weighted Match</div>\r\n          </div>\r\n\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n      </div><br>\r\n					 <p>This is an average of the politicians in your area that answered questions.  Go <a href=\"\" ng-click=\"showDetails()\" class=\"ylink\"><b>HERE</b></a> to see their answers in detail. <br><br>NOTE: Some of the politician questions may have been taken from other sources where an answer of \"True\" or \"False\" was\r\n    converted to \"Somewhat Agree\" or \"Somewhat Disagree\" (one point from either extreme) and we gave those answers an\r\n    importance level of \"Somewhat important\". This may mean their answers do not fully express their passion or\r\n    conviction.</p>\r\n    </li>\r\n  </ul>\r\n  <ul class=\"catList\" ng-if=\"noDataFound == false\">\r\n    <li ng-if=\"showadv\">\r\n      <div style=\"background-color:#ffffee; padding:10px;\">\r\n        <div style=\"color: #000000;\"><b>\r\n\r\n           </b><a href=\"\" ng-click=\"redirectTo(\'advocate\')\"><b ng-if=\"userId && !inviterName && !isShowFollow\" class=\"link\">Organizations Near You</b> <b ng-if=\"inviterName && allUser.length == 1\" style=\"text-transform: capitalize;\" >{{inviterName}}</b> <b ng-if=\"isShowFollow && allUser.length > 1\">Your Followers (Organizations)</b> </a>&nbsp;&nbsp;&nbsp;Total\r\n          Answered Questions: {{fbqlen}}\r\n        </div>\r\n        <div style=\"width: 84%; float:left;\">\r\n          <div>\r\n            <div class=\"fbunweighted\" style=\"width:{{(advUnWeighated)  | number:2}}%\">{{(advUnWeighated) | number:2}}% Match\r\n            </div>\r\n          </div>\r\n          <div>\r\n            <div class=\"fbweighted\" style=\"width:{{(advCombined / advMulti)  | number:2}}%\">{{(advCombined\r\n                / advMulti) | number:2}}% Weighted Match</div>\r\n          </div>\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n      </div>\r\n    </li>\r\n  </ul>\r\n\r\n  <ul class=\"catList\" ng-if=\"noDataFound == false\">\r\n    <li ng-if=\"showvoter\">\r\n      <div style=\"background-color:#ffffee; padding:10px;\">\r\n        <div style=\"color: #000000;\"><b>\r\n\r\n           </b><b ng-if=\"userId && !inviterName && !isShowFollow\">Email Confirmed Voter</b>\r\n          <b ng-if=\"inviterName && allUser.length == 1\" style=\"text-transform: capitalize;\">{{inviterName}}</b>\r\n          <b ng-if=\"isShowFollow && allUser.length > 1\">Your Followers (Voters)</b>\r\n          &nbsp;&nbsp;&nbsp;Total\r\n          Answered Questions: {{fbqlen}}\r\n        </div>\r\n        <div style=\"width: 84%; float:left;\">\r\n          <div>\r\n            <div class=\"fbunweighted\" style=\"width:{{(voterUnWeighated  )  | number:2}}%\">{{(voterUnWeighated\r\n                 ) | number:2}}% Match</div>\r\n          </div>\r\n          <div>\r\n            <div class=\"fbweighted\" style=\"width:{{(voterCombined / voterMulti)  | number:2}}%\">{{(voterCombined\r\n                / voterMulti) | number:2}}% Weighted Match</div>\r\n          </div>\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n      </div>\r\n    </li>\r\n  </ul>\r\n  <!-- | orderBy: [\'-politicianInfo[0].officeName\', \'_id\'] -->\r\n\r\n  <!-- Commented By Yogesh on 15 Jan 2021 because we have implemented new design for the quiz result of five minute quiz -->\r\n  <!-- <ul class=\"catList\" ng-if=\"showcomparison == false\">\r\n    <li ng-repeat=\"frd in AllUsers | orderBy:[\'-politicianInfo[0].officeName\',\'isOnBallot\',\'_id\'] track by $index\" ng-if=\"fbqlen[frd._id]\">\r\n      <div style=\"background-color:#ffffee; padding:10px;\">\r\n        <div style=\"color: #000000;\">\r\n\r\n									<b><div ng-repeat=\"fd in frd.politicianInfo\" ng-if=\"fd.candidateStatus==\'Running\' || fd.candidateStatus==\'Announced\'\"><span style=\"text-transform:capitalize;\">{{fd.officeName}}</span></div></b> <i ng-if=\"isShowAsterix[frd._id]\" class=\"fa fa-asterisk clk info-color\"  aria-hidden=\"true\"></i><span ng-if=\"isShowAsterix[frd._id]\">&nbsp;&nbsp;</span> <a href=\"#!/publicProfile/{{frd._id}}\" style=\"text-transform: capitalize\" class=\"link\"><b>{{frd.name}}</b></a>&nbsp;&nbsp;&nbsp;Total\r\n          Answered Questions: {{fbqlen[frd._id]}}\r\n        </div>\r\n\r\n        <div style=\"width: 84%; float:left;\">\r\n          <div>\r\n            <div class=\"fbunweighted\" style=\"width:{{(FBunWeighted[frd._id] / fbqlen[frd._id] )  | number:2}}%\">\r\n              {{(FBunWeighted[frd._id] / fbqlen[frd._id] ) | number:2}}% Match</div>\r\n          </div>\r\n          <div>\r\n            <div class=\"fbweighted\" style=\"width:{{(fbcombinedWeight[frd._id] / fbmultiplier[frd._id])  | number:2}}%\">\r\n              {{(fbcombinedWeight[frd._id] / fbmultiplier[frd._id]) | number:2}}% Weighted Match</div>\r\n          </div>\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n      </div>\r\n    </li>\r\n  </ul> -->\r\n\r\n\r\n\r\n	<div ng-if=\"politician || showadv || showvoter ||FBCompareList.length > 0 && showcomparison == false\">\r\n\r\n  <!--<center>\r\n    <!-- <a href=\"\" ng-click=\"showDetails()\"><button class=\"compareBtnL\" style=\"background-color: aqua\"> See Question by Question Match Details</button></a></center> -->\r\n\r\n		<div style=\"margin-left:10%\">&nbsp;<i class=\"fa fa-asterisk info-color\"></i><span style=\"display:inline-flex; width:80%; margin-left: 25px;\">If a politician has a yellow asterisk by their name, some or all of their answers are based on research rather than actual responses from the politicians.</span><br></div>\r\n		<div ng-if=\"FBCompareList.length > 0 && showcomparison == false\" style=\"margin-left:10%\"><br>NOTE: <span style=\"display:inline-flex; width:80%;\">Some of the politician questions were taken from other sources where an answer of \"True\" or \"False\" was converted to \"Somewhat Agree\" or \"Somewhat Disagree\" (one point from either extreme) and we gave those answers an importance level of \"Somewhat important\". This may mean their answers do not fully express their passion or conviction.</span><br>\r\n</div>\r\n			<div style=\"margin-left:10%;\"><br>NOTE: <span style=\"display:inline-flex;  width:80%;\">Bar Associations are groups of judges and lawyers that work together to try to improve their profession in whatever region they represent.  In some states, you must belong to the appropriate Bar Association in order to practice law.  This should not be confused with the \"bar exam\" which is administered by the state and not a Bar Association.  In every state, you must pass their bar exam to be able to practice law, but in some regions, you don\'t need to pass or even know much about the law to be a Municipal Judge.  Our research shows that Bar Associations are great at weeding out bad judges and lawyers, but are not perfect at determining which is the better of two well qualified judges.</span></div>\r\n<!--    <div class=\"squareBoxY\" style=\"margin-left:10px;\">&nbsp;</div>&nbsp;=\r\n    <span style=\"display:inline-flex; width:80%; margin-left: 10px;\">Simple Comparison by answers alone.</span>\r\n    <div style=\"clear:both;\"></div>\r\n    <div class=\"squareBoxB\" style=\"margin-left:10px\">&nbsp;</div>&nbsp;=\r\n    <span style=\"display:inline-flex; width:80%; margin-left: 10px;\">Weighted Comparison by answers and importance.</span>\r\n    <div style=\"clear:both;\"></div>\r\n				<button class=\"compareBtn\"><a href=\"#!/whatAmILookingAt3\">What this means</a></button>\r\n  </div> -->\r\n\r\n\r\n\r\n\r\n\r\n  <div ng-if=\"noDataFound == true\">\r\n    <h3>\r\n      <p style=\"color:red\">Congratulations! You are the first person in your region to take this quiz. You are a true\r\n        pioneer! You should contact your local politicians and your friends to encourage them to use this site. There\r\n        are still plenty of wonderful things here to see.</p>\r\n    </h3>\r\n    <br>\r\n    <br>\r\n    <div class=\"margin-auto mxw\">\r\n      <div class=\"digDeeperSmall\" style=\"float:left\">\r\n        <a href=\"#!/digDeeper\"><img ng-src=\"../assets/images/DigDeeper.svg\" alt=\"Dig deeper\"/></a></div>\r\n      <button class=\"btnB275\" style=\"width:150px; float:right;\" ng-click=\"finalSignIn()\">Sign In</button>\r\n    </div>\r\n    <!-- <div style=\"float: right; margin-right: 20px; margin-top: 7px; color:#ffffff;\">Already a member? <a style=\"text-decoration: underline;\" href=\"#!/fiveminsignin\" class=\"ylink\">Sign in</a></div> -->\r\n  </div>\r\n\r\n <!-- <center><button class=\"btnB275\" ng-click=\"postonFacebook()\">Post Quiz to Facebook</button></center>  -->\r\n\r\n  <!-- <div class=\"fb-share-button\" data-href=\"https://votewise.net/#!/fiveMatch#DisplayQ\" data-layout=\"button_count\">\r\n  </div> -->\r\n  <!-- <div><center><input type=\"button\" name=\"btnNext\" value=\"Next\" ng-click=\"nextCat()\"></center></div> -->\r\n\r\n\r\n  <div ng-if=\"showcomparison == false\">\r\n   <!-- <p>This only shows politicians that have answered our quizzes. For the rest, you can see how organizations rated\r\n      them, their voting records, who financed their campaigns and more here</p> -->\r\n   <!-- <center><a href=\"#!/compare-select/politician\"><button class=\"compareBtn\">See Other Politicians</button></a>\r\n    </center>-->\r\n\r\n  </div>\r\n  </div>\r\n  <!--<div>\r\n  <p ng-if=\"FBCompareList.length > 0 && showcomparison == false\">NOTE: Some of the politician questions were taken from other sources where an answer of \"True\" or \"False\" was\r\n    converted to \"Somewhat Agree\" or \"Somewhat Disagree\" (one point from either extreme) and we gave those answers an importance level of \"Somewhat important\". This may mean their answers do not fully express their passion or conviction.</p>\r\n</div>  -->\r\n    <!-- <button class=\"compareBtn\"><a href=\"#!/whatAmILookingAt3\">What Am I Looking At?</a></button> -->\r\n\r\n   <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\" ng-if=\"showcomparison == false\">\r\n      <a href=\"#!/incumbent_politician/politician\" class=\"blockLink\"><img ng-src=\"./assets/images/politiciansRBB7-01.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock4\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">YOUR POLITICIANS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Find out what they stand for, who stands behind them, and who pays for their campaigns.  See their voting record. See their ratings.  Compare politicians who are running for office, using your match quizzes to see who would best represent your interests.  Contact the politicians that represent you to ask for help.  Watch debates, read essays, and more.</p>\r\n\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n<div ng-if=\"showcomparison == false\">\r\n  <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\" ng-show=\"$root.userRole==\'voter\'\">\r\n    <a href=\"#!/gettingstarted\" class=\"blockLink\"><img ng-src=\"./assets/images/siteTour.svg\" class=\"gettingStartedImg img-fluid\">\r\n    <div class=\"gettingStartedBlock gettingStartedBlock5\">\r\n      <div>\r\n        <h4 class=\"gettingStartedBlockTitle\">TOUR THE SITE</h4>\r\n        <p class=\"gettingStartedBlockDesc\">The site has a lot of amazing things it can do.  Start here to learn more.</p>\r\n      </div>\r\n    </div></a>\r\n  </div>\r\n <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\" ng-show=\"$root.userRole==\'politician\'\">\r\n    <a href=\"#!/gettingStartedPol\" class=\"blockLink\"><img ng-src=\"./assets/images/siteTour.svg\" class=\"gettingStartedImg img-fluid\">\r\n    <div class=\"gettingStartedBlock gettingStartedBlock5\">\r\n      <div>\r\n        <h4 class=\"gettingStartedBlockTitle\">TOUR THE SITE</h4>\r\n        <p class=\"gettingStartedBlockDesc\">The site has a lot of amazing things it can do.  Start here to learn more.</p>\r\n      </div>\r\n    </div></a>\r\n  </div>\r\n <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\" ng-show=\"$root.userRole==\'advocate\'\">\r\n    <a href=\"#!/gettingStartedOrg\" class=\"blockLink\"><img ng-src=\"./assets/images/siteTour.svg\" class=\"gettingStartedImg img-fluid\">\r\n    <div class=\"gettingStartedBlock gettingStartedBlock5\">\r\n      <div>\r\n        <h4 class=\"gettingStartedBlockTitle\">TOUR THE SITE</h4>\r\n        <p class=\"gettingStartedBlockDesc\">The site has a lot of amazing things it can do.  Start here to learn more.</p>\r\n      </div>\r\n    </div></a>\r\n  </div>\r\n</div>\r\n\r\n<!--  <script type=\"text/ng-template\" id=\"FBComposeMessage\">\r\n    <center>\r\n    <h2>Post message on Facebook</h2>\r\n    <div>\r\n      <div style=\"width:15%; float:left;\">Message: </div>\r\n      <div style=\"width:84%; float:left;\">\r\n        <textarea ng-model=\"fb.message\" style=\"width:100%; height: 100px;\"></textarea>\r\n      </div>\r\n    </div>\r\n    <div style=\"clear:both;\"></div>\r\n    <div>\r\n      <div style=\"width:15%; float:left;\">&nbsp;</div>\r\n      <div style=\"width:84%; float:left; text-align:left;\">\r\n        <input type=\"button\" ng-click=\"postFB(fb.message)\" value=\"Submit to Facebook*\" />&nbsp;<i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"DisplayFPostLoader\"></i>\r\n        <p><b>*Note:</b>If you are not currently logged into Facebook, you must enable pop-ups in your browser in order for the Facebook sign in window to pop up.</p>\r\n      </div>\r\n    </div>\r\n    <div style=\"clear:both;\"></div>\r\n</script>  -->\r\n<script type=\"text/ng-template\" id=\"showOldAnsPopUp\">\r\n  <div class=\"container-fluid\">\r\n    <h5>Old Answers</h5>\r\n    <div ng-repeat=\"com in oldAns track by $index\">\r\n        <div class=\"pad10\">\r\n\r\n          <br>\r\n          <span>Answer</span>\r\n          <br>\r\n          <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n\r\n            <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n              style=\"padding-left: 8px;  line-height: 15px\">\r\n              <span class=\"inl-blk pull-left\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n              <div class=\"cq-box inl-blk pull-left\"\r\n                ng-class=\"(com.answer == i) ? getComapreClass(com.answer, i) : \'\'\"></div>\r\n              <span class=\"inl-blk\" ng-if=\"i == 6\" style=\"padding-left:8px\">DISAGREE</span>\r\n            </div>\r\n          </div>\r\n          <br>\r\n          <p></p>\r\n          <span>IMPORTANCE</span>\r\n          <br>\r\n          <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n            <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"padding-left: 8px; line-height: 9px\">\r\n              <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n              <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n              <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n              <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                ng-class=\"(com.importance == i) ? \'ag-blk\' : \'\'\"></div>\r\n            </div>\r\n          </div>\r\n          <p></p>\r\n          <div>\r\n            <span ng-if=\"com.comment\">Comment:</span>\r\n            <span ng-if=\"com.comment\" class=\"newcomName\" ng-bind-html=\'com.comment | urlify\'>{{com.comment}}</span>\r\n          </div>\r\n          <span>Reason to Change the Answer: {{com.reason}}</span><br>\r\n  <span>Updated on: {{com.created | date: \'MM-dd-y\'}}</span>\r\n          <hr style=\"\r\n          margin-left: auto;\r\n          margin-right: auto;\r\n          height: 1px;\r\n          background-color:#666;\r\n          opacity: 0.5;\">\r\n        </div>\r\n      </div>\r\n            </div>\r\n</script>\r\n\r\n<script type=\"text/ng-template\" id=\"showInfoPopUp\">\r\n  <div class=\"container-fluid\">\r\n    <h5>Notes</h5>\r\n    <p ng-bind-html=\"showComment | newlines\"></p>\r\n            </div>\r\n</script>\r\n\r\n<script type=\"text/ng-template\" id=\"showNoticePop\">\r\n  <div class=\"container-fluid\">\r\n    <h5>Note</h5>\r\n    <p> If a politician has a yellow asterisk by their name, some or all of their answers are based on research rather than actual responses from the politicians.</p>\r\n            </div>\r\n\r\n              <center>\r\n    <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"closeNotice()\">\r\n       Close\r\n       </button>\r\n  </center>\r\n</script>\r\n\r\n<script type=\"text/ng-template\" id=\"showSavedCandi\">\r\n    <h3>Saved Candidates</h3>\r\n\r\n  <table class=\"w100\">\r\n    <tr>\r\n      <th>Name</th>\r\n      <th>Office</th>\r\n    </tr>\r\n    <tr ng-repeat=\"candi in showCandidates track by $index\">\r\n      <td style=\"text-transform: capitalize;\">\r\n      <p ng-if=\"candi.nameOnBallot && candi.nameOnBallot !=\'\'\"> {{candi.nameOnBallot}}</p>\r\n        <p ng-if=\"!candi.nameOnBallot && candi.name !=\'\'\"> {{candi.name}}</p>\r\n      </td>\r\n      <td style=\"text-transform: capitalize;\">\r\n      <p ng-if=\"candi.politicianInfo.length > 0\">  {{candi.politicianInfo[0].officeName}}</p>\r\n       <p ng-if=\"!candi.politicianInfo\">{{candi.office}}</p>\r\n      </td>\r\n    </tr>\r\n  </table>\r\n  <br>\r\n  <center>\r\n    <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"hidePopup()\">\r\n       Close\r\n       </button>\r\n  </center>\r\n  </script>\r\n\r\n  <script type=\"text/ng-template\" id=\"showMatchDetails\">\r\n<div ng-if=\"answeredQuestions[uId] > noOfQuesMutuallyAns[uId]\"><p>If you answer more questions, we can give you a more accurate match.</p></div>\r\n<p> <b style=\"text-transform: capitalize;\">{{poliName}}</b> has answered <b>{{answeredQuestions[uId]}}</b> out of <b>{{queIdsN.length}}</b> questions. You have answered <b ng-if=\"curUserAns.length != 0\">{{curUserAns.length}}</b>  <b ng-if=\"curUserAns.length == 0\">0</b> questions. Our rating was based on the <b>{{noOfQuesMutuallyAns[uId]}}</b> mutually answered questions that both you and <b style=\"text-transform: capitalize;\">{{poliName}}</b> answered. <br>\r\n	<center>   <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"showDetails(ofcName)\">\r\nCompare Mulitple Choice  </button></center>\r\n	<br> <b>HOW WE CALCULATED YOUR MATCH:</b><br><b>\"+/- Uncertainty Number\"</b> - We looked at worst case and best case scenarios for the unanswered questions and came up with a maximum possible change of {{confidenceLevel[uId]}} points. Obviously, you can\'t be more than a 100% match or less than a 0% match, so this uncertainty number is the biggest possible change but not necessarily in both directions. Any unscertainty number over 33%, we labelled in red to encourage you to look at their actual answers instead of trusting the match score.<br><br><b>\"Match Scores\"</b> were calculated as a combination of how you and the politician answered the questions as well as how important you both thought each question was. If you thought a question was \"Very Important\", it counts as if you answered that question 3 times. \"Somewhat\" = 2 times. \"Not Very\" = once.</p>\r\n <!--<p>\r\nSum of importance <b>{{sumOfImp[uId]}}</b>\r\n<br>\r\nPercentage of Quiz unanswered <b>{{percentageOfQuizUnanswered[uId] | number : 2}}</b>\r\n<br>\r\nMatch Percentage <b>{{matchPercentage[uId] | number : 2}}</b>\r\n<br>\r\nLowest Possible Match <b>{{lowestPossibleMatch[uId] | number : 2}}</b>\r\n<br>\r\nHighest Possible Match <b>{{highestPossibleMatch[uId] | number : 2}}</b>\r\n<br>\r\nGreatest Possible Negative <b>{{greatestPossibleNegative[uId] | number : 2 }}</b>\r\n<br>\r\nGreatest Possible Positive <b>{{greatestPossiblePositive[uId] | number : 2}}</b>\r\n<br>\r\nConfidence Level <b>{{confidenceLevel[uId]}}</b>\r\n<br>\r\nNumber of Mutually Answer questions <b>{{noOfQuesMutuallyAns[uId]}}</b>\r\n</p> -->\r\n<br>\r\n\r\n  <br>\r\n  <center>\r\n    <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"hidePopup()\">\r\n       Close\r\n       </button>\r\n  </center>\r\n  </script>\r\n\r\n  <script type=\"text/ng-template\" id=\"showMatch\">\r\n  <p>\r\n<b style=\"text-transform: capitalize;\">{{poliName}}</b> has answered <b>{{answeredQuestions[uId]}}</b> out of <b>{{queIdsN.length}}</b> questions. You didn\'t answer any of the same questions. Please answer more questions to compare results.\r\n</p>\r\n\r\n   <br>\r\n  <center>\r\n      <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"hidePopup()\">\r\n        Close\r\n          </button>\r\n    <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"finish()\">\r\n       Finish\r\n       </button>\r\n  </center>\r\n  </script>\r\n<div class=\"bottomInfo\">\r\n  <p>Candidate information is provided in part by The Center for Tech and Civic Life, VoteSmart, ProPublica, Open States, Open Secrets, The Library of Congress, The Federal Elections Commission, The League of Women Voters of the City of New York, and by your local boards of elections.</p>\r\n\r\n  <p>\r\n       <a href=\"https://www.techandciviclife.org/\" target=\"_blank\">\r\n          <image\r\n            src=\"../assets/images/TechAndCivicLife.png\"\r\n            class=\"partners\"\r\n          ></image\r\n        ></a>\r\n			<a href=\"https://votesmart.org/\" target=\"_blank\">\r\n                    <image src=\"../assets/images/VoteSmartLogoD.png\" class=\"partners\"></image></a>\r\n    <a href=\"https://www.propublica.org/\" target=\"_blank\">\r\n                    <image src=\"../assets/images/logo-propublica.svg\" class=\"partners\"></image></a>\r\n\r\n    <a href=\"https://openstates.org/\" target=\"_blank\">\r\n                    <image src=\"../assets/images/openstates_logo.d5ae3c5f606e.svg\" class=\"partners\"></image></a>\r\n    <a href=\"https://www.opensecrets.org//\" target=\"_blank\">\r\n                    <image src=\"../assets/images/opensecrets_databy250x88.gif\" class=\"partners\"></image></a>\r\n    <a href=\"https://www.loc.gov/\" target=\"_blank\">\r\n                    <image src=\"../assets/images/LibraryOfCongressLogo.svg\" class=\"partners\"></image></a>\r\n    <a href=\"https://www.fec.gov/\" target=\"_blank\">\r\n                    <image src=\"../assets/images/FECseal.svg\" class=\"partnersCircle\"></image></a>\r\n				<a href=\"https://my.lwv.org/new-york/city-new-york\" target=\"_blank\"><image src=\"../assets/images/LWVofNYCsmall.jpg\" class=\"partners\"></image></a>\r\n  </p>\r\n\r\n\r\n</div>\r\n");
$templateCache.put("app/fiveMinEssayAnswers/fiveMinEssayAnswers.html","<div class=\"container\">\r\n  <br />\r\n  <h4>\r\n    <a\r\n      href=\"#!/publicProfile/{{essayAns[0].author._id}}\"\r\n      class=\"ylink\"\r\n      style=\"text-transform: capitalize\"\r\n      ><img\r\n        ng-src=\"../assets/images/profile/{{essayAns[0].author.userType}}.svg \"\r\n        alt=\"{{essayAns[0].author.userType}}\"\r\n        class=\"usertype\"\r\n      />\r\n      {{essayAns[0].author.name}}</a\r\n    >\r\n  </h4>\r\n  <br />\r\n  <fieldset class=\"scheduler-border\">\r\n    <legend class=\"scheduler-border\">Essay Answers</legend>\r\n\r\n    <div\r\n      class=\"\r\n        questionAnswersBlock\r\n        d-flex\r\n        justify-center\r\n        container-fluid\r\n        col-sm-12 col-lg-12\r\n      \"\r\n      style=\"width: 100%\"\r\n    >\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <br />\r\n          <div ng-repeat=\"com in essayAns track by $index\">\r\n            <div class=\"pad10\">\r\n              <p><b>Question:-</b> {{com.questionContent}}</p>\r\n              <br />\r\n              <span>Answers:</span>\r\n              <br />\r\n              Short Answer-<p ng-bind-html=\'com.shortAns | urlify\'>Short Answer {{com.shortAns}}</p>\r\n              Medium Answer-<p ng-bind-html=\'com.mediumAns |urlify\'>Medium Answer:- {{com.mediumAns}}</p>\r\n              Long Answer-<p ng-bind-html=\'com.longAns |urlify\'>Long Answer:- {{com.longAns}}</p>\r\n              <hr\r\n                style=\"\r\n                  margin-left: auto;\r\n                  margin-right: auto;\r\n                  height: 1px;\r\n                  background-color: #666;\r\n                  opcaity: 0.5;\r\n                \"\r\n              />\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </fieldset>\r\n</div>\r\n");
$templateCache.put("app/fiveMinLanding/fiveMinLanding.html","<script>var showHeader=\"false\"</script>\r\n<div class=\"container-fluid\">\r\n	<!--DESKTOP VIEW-->\r\n  <div class=\"welcomeSection1 jumbotron d-none d-md-block d-lg-block \">\r\n    <div class=\"row\">\r\n      <div class=\"col-lg-6 col-md-6\">\r\n      </div>\r\n      <div class=\"col-lg-6 col-md-6\">\r\n        <div><img ng-src=\"./assets/images/votewiselogoBlackwWhiteNew.svg\" class=\"img-fluid\"></div>\r\n          <div class=\"row\">\r\n            <div class=\"col-lg-2 col-md-2\"></div>\r\n            <div class=\"col-lg-8 col-md-8 blackText\">\r\n              <b>Where voters and politicians can connect without advertising dollars getting in the way.  <br><br><center>Non-profit.    Non-partisan.</center></b>\r\n													<br></div></div></div></div><center>\r\n              <a href=\"#!/fiveMatch/fiveminquiz\">\r\n                  <div class=\"fiveStartBtn\"  style=\"position:relative;z-index: 4;\"><center><b>Start Quiz</b></center></div></a></center>\r\n			<br><br></div>\r\n           <div class=\"col-lg-12 col-sm-12 learnHeader d-none d-lg-block\" >\r\n              	<div id=\"blockInfoLearn1\" style=\"width:60%; margin-left: 25%; background-color: #faeed2; box-shadow: -20px 20px 20px rgba(0, 0, 0, 0.5);position:relative; z-index: 2;\">\r\n                  \r\n                <div>\r\n                  <h4 class=\"blockTitleLearn\">FIVE MINUTE MATCH</h4>\r\n                  <span class=\"blockDesc\">\r\n	<p>The questions in the <b>\"Five Minute Match Quiz\"</b> are taken from our issue-based quizzes.  These <b>\"Topic Quizzes\"</b> explore the logic behind all sides of an argument.  For this reason, some questions may seem leading.  If you want to see point/counterpoint on any issue, hit the “More Questions on this Topic” button to see the quiz that the question came from.</p>\r\n	<!--																	\r\n<center><hr style=\"background-color: black; color:black; height:5px; width:80%; opacity:50%;\"></center>\r\n	<p><b><span style=\"text-decoration: underline\">NOTE</span> : Because of the dramatic events of 2020, the Five Minute Match Quiz has been extended.  It could take you 8-10 minutes to complete the whole quiz, but you can skip to the end after answering at least 5 questions if you don’t care about the accuracy of your matches.</b></p>\r\n-->\r\n                </span>\r\n              \r\n              \r\n														</div></div>\r\n            \r\n          <div class=\"col-lg-2\"></div>\r\n        </div>\r\n    \r\n	\r\n\r\n	\r\n	<div class=\"welcomeSection2 jumbotron d-none d-lg-block\" style=\"margin-top: -70px; \">\r\n    <div class=\"row\">\r\n					<div class=\"col-lg-6\">\r\n						<div id=\"blockInfoLearn1\" style=\"box-shadow: -20px 20px 20px rgba(0, 0, 0, 0.5); position:relative; z-index: 1;\">\r\n            <div>\r\n      \r\n													<h4 class=\"blockTitleLearn\" >WHAT IS VOTEWISE?</h4>\r\n              <span class=\"blockDesc\">VoteWise is  a non-partisan non-profit website that connects voters, organizations and politicians without advertising dollars getting in the way.  Our goal is to depolarize politics and make it easier for communities to find common ground and the tools they need to identify problems, find sustainable solutions that work for all, and put those solutions into action.<br><br>\r\n\r\nAn effective democracy requires the active participation of voters, politicians, the press, and the organizations that dedicate their lives to the issues they care about.  Sometimes this means making changes to legislation and sometimes this means more hands-on action.  Either way, it requires year-round teamwork.  We want to make it easier for everyone.<br> <br>\r\n\r\nWe have different tools available to different types of users to make their jobs easier.  Click on the videos below to learn more.\r\n</span>\r\n				\r\n            </div>\r\n          </div>\r\n					</div>\r\n    <!--  <div class=\"col-lg-6\">\r\n      </div>\r\n      <div class=\"col-lg-6\">\r\n        <div><img ng-src=\"./assets/images/votewiselogoBlackwWhiteNew.svg\" class=\"img-fluid\"></div>\r\n          <div class=\"row\">\r\n            <div class=\"col-lg-2\"></div>\r\n            <div class=\"col-lg-8 blackText\">\r\n              <b>Where voters and politicians can connect without advertising dollars getting in the way.  <br><br><center>Non-profit.    Non-partisan.</center></b>\r\n              <br>\r\n              <a href=\"#!/upcomingElection\">\r\n                  <div class=\"yBtn\"><center><b>Get Ready to Vote</b></center></div></a>\r\n              <br><br>\r\n              <a href=\"#!/takeAction\">\r\n                  <div class=\"yBtn\"><center><b>Take Action</b></center></div></a>\r\n            </div>\r\n\r\n          </div>\r\n          <div class=\"col-lg-2\"></div>\r\n        </div>-->\r\n      </div>\r\n    </div>\r\n	\r\n	<!--CELL PHONE VIEW-->\r\n    <div class=\"welcomeSection1Small jumbotron d-md-none\">\r\n      <div class=\"row justify-content-end\">\r\n        <div class=\"col col-6 topPaddingSmall\">\r\n          <img ng-src=\"./assets/images/votewiselogoBlackwWhiteNew.svg\" class=\"img-fluid\"></div>\r\n        </div>\r\n        <div class=\"row justify-content-end\">\r\n          <div class=\"col col-6 blackText\">\r\n            <b>Where voters and politicians can connect without advertising dollars getting in the way.  <br><br><center><span>Non-profit. </span>  <span> Non-partisan.</span></center></b><br><br><br><br></div><br></div>\r\n									\r\n            <center><a href=\"#!/fiveMatch/fiveminquiz\">\r\n													<div class=\"fiveStartBtn\" style=\"position:relative; z-index: 2;\"><center><b>Start Quiz</b></center></div></a></center></div></div>\r\n       \r\n  <div class=\"col-lg-12 col-sm-12 learnHeader d-lg-none\" >\r\n  \r\n              	<div id=\"blockInfoLearn1\" style=\" background-color: #faeed2; box-shadow: -20px 20px 20px rgba(0, 0, 0, 0.5);position:relative; margin-top: -90px;\">\r\n                  \r\n                <div>\r\n                  <h4 class=\"blockTitleLearn\" >FIVE MINUTE MATCH</h4>\r\n                  <span class=\"blockDesc\">\r\n	<p>The questions in the <b>\"Five Minute Match Quiz\"</b> are taken from our issue-based quizzes.  These <b>\"Topic Quizzes\"</b> explore the logic behind all sides of an argument.  For this reason, some questions may seem leading.  If you want to see point/counterpoint on any issue, hit the “More Questions on this Topic” button to see the quiz that the question came from.</p>\r\n	<!--																		\r\n<center><hr style=\"background-color: black; color:black; height:5px; width:80%; opacity:50%;\"></center>\r\n	<p><b><span style=\"text-decoration: underline\">NOTE</span> : Because of the dramatic events of 2020, the Five Minute Match Quiz has been extended.  It could take you 8-10 minutes to complete the whole quiz, but you can skip to the end after answering at least 5 questions if you don’t care about the accuracy of your matches.</b></p>\r\n-->\r\n                </span>\r\n              \r\n              \r\n														</div><br></div><br>\r\n            \r\n          <div class=\"col-lg-2\"></div>\r\n        </div>\r\n\r\n	<div class=\"welcomeSection2 jumbotron  d-lg-none\">\r\n    <div class=\"row\">\r\n					<div class=\"col-lg-6\">\r\n						<div id=\"blockInfoLearn1\">\r\n            <div>\r\n      \r\n													<h4 class=\"blockTitleLearn\" >WHAT IS VOTEWISE?</h4>\r\n              <span class=\"blockDesc\">VoteWise is  a non-partisan non-profit website that connects voters, organizations and politicians without advertising dollars getting in the way.  Our goal is to depolarize politics and make it easier for communities to find common ground, find sustainable solutions that work for all, and put those solutions into action.<br><br>\r\n\r\nAn effective democracy requires the active participation of voters, politicians, the press, and the organizations that dedicate their lives to the issues they care about.  Sometimes this means making changes to legislation and sometimes this means more hands-on action.  Either way, it requires year-round teamwork.  We want to make it easier for everyone.<br> <br>\r\n\r\nWe have different tools available to different types of users to make their jobs easier.  Click on the videos below to learn more.\r\n</span>\r\n				\r\n            </div>\r\n          </div>\r\n					</div>\r\n		</div></div></div>\r\n		    <center class=\"threefer\">\r\n							 <iframe src=\"https://player.vimeo.com/video/408236980?byline=false&title=false\" allowfullscreen style=\"border:0;\"></iframe><span>							\r\n														 <iframe src=\"https://player.vimeo.com/video/408236648?byline=false&title=false\" allowfullscreen style=\"border:0;\"></iframe></span><span>\r\n<iframe src=\"https://player.vimeo.com/video/408237898?byline=false&title=false\" allowfullscreen style=\"border:0;\"></iframe></span></center>\r\n\r\n\r\n	<center>\r\n	 <a href=\"#!/signup/voter\">\r\n                  <div class=\"ycompareBtn\"><center><b>Sign Up</b></center></div></a>\r\n	\r\n	\r\n	</center>\r\n	</div>\r\n\r\n");
$templateCache.put("app/fiveminsaveuser/fiveminsaveuser.html","<!--<div class=\"voter-signup\">  -->\r\n<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">CREATE ACCOUNT</h2>\r\n  <p class=\"pageSubHeading\">If you are a politician, please contact us and we will create an account for you after we\r\n    have confirmed your identity.</p>\r\n  <br />\r\n  <br />\r\n  <div class=\"signup-margin\">\r\n    <div class=\"alert alert-danger\" ng-show=\"Errors.length>0\" role=\"alert\" ng-repeat=\"error in Errors\">\r\n      {{ error }}\r\n    </div>\r\n    <!-- <fieldset class=\"scheduler-border\" style=\"width: 115%\" ng-if=\"!$root.showFacebookLoging\">\r\n      <legend class=\"scheduler-border\">Add Details</legend> -->\r\n    <form name=\"fiveminform1\" id=\"fiveminform1\">\r\n      <div class=\"col-md-12\">\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label\" for=\"firstname\">What type of user are you?</label>\r\n          <div class=\"controls\">\r\n            <select\r\n                ng-model=\"User.UserType\"\r\n                style=\"text-transform: capitalize;\"\r\n                ng-change=\"userTypeChanged(User.UserType)\"\r\n                class=\"changeTextColor\"\r\n              >\r\n                <option ng-repeat=\" item in MUserType\" value=\"{{ item.key }}\">{{\r\n                  item.name\r\n                }}</option>\r\n              </select>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <!-- <div ng-if=\"UserType == \'advocate\'\">\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label\" for=\"email\">Organization Name</label>\r\n          <div mass-autocomplete>\r\n            <input\r\n                ng-model=\"User.organization_name\"\r\n                ng-blur=\"checkExists();\"\r\n                mass-autocomplete-item=\"org_autocomplete_options\"\r\n																			class=\"blackText\"\r\n              />\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label\" for=\"email\">Website for organization</label>\r\n            <div class=\"controls\">\r\n              <input\r\n                type=\"text\"\r\n                ng-model=\"User.organization.web_url\"\r\n                ng-disabled=\"User.organization._id\"\r\n                data-errormessage-custom-error=\"Invalid URL.\"\r\n                data-errormessage=\"Website for organization is required.\"\r\n                class=\"form-control input-md  validate[required, custom[url]] text-input\"\r\n              />\r\n            </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"email\"\r\n              >Phone number of organization (xxx)xxx-xxxx</label>\r\n              <div class=\"controls\">\r\n                <input\r\n                type=\"tel\"\r\n                ng-model=\"User.organization.phone_no\"\r\n                ng-disabled=\"User.organization._id\"\r\n                data-errormessage=\"Phone number of organization is required.\"\r\n                class=\"form-control input-md  validate[required] text-input\"\r\n              />\r\n            </div>\r\n              </div>\r\n              <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\">Organization Type</label>\r\n                <div class=\"controls\">\r\n                  <select ng-model=\"User.orgType\" class=\"form-control\"  style=\"width:60%;\">\r\n                <option value=\"\">Select Organization</option>\r\n                <option value=\"501c3\">501c3</option>\r\n                <option value=\"501c4\">501c4</option>\r\n                <option value=\"registered lobbyist \">registered lobbyist</option>\r\n              </select>\r\n                </div>\r\n              </div>\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\">Employer Identification Number </label>\r\n                <div class=\"controls\">\r\n\r\n                  <input type=\"tel\" ng-model=\"User.empIndNo\" class=\"form-control input-md text-input\">\r\n      </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label\" for=\"email\">Your extension number (if any)</label>\r\n                  <div class=\"controls\">\r\n\r\n                    <input\r\n                type=\"tel\"\r\n                ng-model=\"User.extention_no\"\r\n                class=\"form-control input-md text-input\"\r\n              />\r\n            </div>\r\n                  </div>\r\n                </div> -->\r\n                <div ng-if=\"UserType == \'advocate\'\">\r\n                    <div class=\"control-group\">\r\n                      <label class=\"control-label formLabel whiteText\" for=\"email\">Organization Name</label>\r\n                      <div mass-autocomplete>\r\n                        <input ng-model=\"User.organization_name\" mass-autocomplete-item=\"org_autocomplete_options\" class=\"changeTextColor\">\r\n                  </div>\r\n                      </div>\r\n                      <div class=\"control-group\">\r\n                        <label class=\"control-label formLabel whiteText\" for=\"email\">Website for Organization</label>\r\n                        <div class=\"controls\">\r\n                          <input type=\"text\" ng-model=\"User.organization.web_url\" ng-disabled=\"User.organization._id\" data-errormessage-custom-error=\"Invalid URL.\"\r\n                  data-errormessage=\"Website for organization is required.\" class=\"form-control input-md  validate[required, custom[url]] text-input\">\r\n                  </div>\r\n                        </div>\r\n                        <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                          <label class=\"control-label formLabel whiteText\" for=\"email\">Organization Type</label>\r\n                          <div class=\"controls\">\r\n                            <select ng-model=\"User.orgType\" class=\"form-control\"  style=\"width:60%;\">\r\n                  <option value=\"\">Select Organization</option>\r\n                  <option value=\"501c3\">501c3</option>\r\n                  <option value=\"501c4\">501c4</option>\r\n																			<option value=\"501c5\">501c5</option>\r\n      <option value=\"501c6\">501c6</option>\r\n<option value=\"State level non-profit\">State Level Non-Profit</option>			\r\n                  <option value=\"registered lobbyist \">Registered Lobbyist</option>\r\n                  </select>\r\n                          </div>\r\n                        </div>\r\n                        <div class=\"control-group\">\r\n                          <label class=\"control-label formLabel whiteText\" for=\"email\">Employer Identification Number<br> or US House Lobbyist Registration # </label>\r\n                          <div class=\"controls\">\r\n                            <!-- <input type=\"text\" ng-model=\"User.extention_no\" data-errormessage=\"Phone is required.\" class=\"form-control input-md text-input\" class=\"validation[required] text-input\"> -->\r\n                            <input type=\"tel\" ng-model=\"User.empIndNo\" class=\"form-control input-md text-input\">\r\n                  </div>\r\n                          </div>\r\n                          <div ng-if=\"!HideOrgInfo\">\r\n                            <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                              <label class=\"control-label formLabel whiteText\" for=\"firstname\">Account Manager Name <br>(used for contact w VoteWise)</label>\r\n                              <div class=\"controls\">\r\n                                <input type=\"text\" ng-model=\"User.name\" placeholder=\"\" data-errormessage=\"Name is required.\"\r\n                  class=\"form-control input-md  validate[required] text-input\">\r\n                  </div>\r\n                              </div>\r\n                              <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                                <label class=\"control-label formLabel whiteText\" for=\"firstname\">Your Position</label>\r\n                                <div class=\"controls\">\r\n                                  <input type=\"text\" ng-model=\"User.position\" placeholder=\"\" data-errormessage=\"Position is required.\"\r\n                  class=\"form-control input-md  validate[required] text-input\">\r\n                  </div>\r\n                                  <div class=\"control-group\">\r\n                                    <label class=\"control-label formLabel whiteText\" for=\"email\">Phone number of Organization (xxx)xxx-xxxx</label>\r\n                                    <div class=\"controls\">\r\n                                      <input type=\"tel\" ng-model=\"User.organization.phone_no\" ng-disabled=\"User.organization._id\" data-errormessage=\"Phone number of organization is required.\"\r\n                  class=\"form-control input-md  validate[required] text-input\">\r\n                  </div>\r\n                                      <div class=\"control-group\">\r\n                                        <label class=\"control-label formLabel whiteText\" for=\"email\">Your extension number (if any)</label>\r\n                                        <div class=\"controls\">\r\n                                          <!-- <input type=\"text\" ng-model=\"User.extention_no\" data-errormessage=\"Phone is required.\" class=\"form-control input-md text-input\" class=\"validation[required] text-input\"> -->\r\n                                          <input type=\"tel\" ng-model=\"User.extention_no\" class=\"form-control input-md text-input\">\r\n                  </div>\r\n\r\n                                        </div>\r\n                                      </div>\r\n\r\n\r\n\r\n                                      <div ng-if=\"!HideOrgInfo\">\r\n                                        <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                                          <label class=\"control-label formLabel whiteText\" for=\"firstname\">UserName for future Log In</label>\r\n                                          <div class=\"controls\">\r\n                                            <input type=\"text\" ng-model=\"User.UserName\" ng-blur=\"CheckUserName()\" placeholder=\"\" data-errormessage=\"UserName is required.\"\r\n                  class=\"form-control input-md  validate[required] text-input\">\r\n                  </div>\r\n                                          </div>\r\n                                          <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                                            <label class=\"control-label formLabel whiteText\" for=\"password\">Create Password</label>\r\n                                            <div class=\"controls\">\r\n                                              <input type=\"password\" id=\"password\" ng-model=\"User.Password\" placeholder=\"\" data-errormessage=\"Password is required.\" class=\"form-control input-md  validate[required] text-input\"\r\n                  />\r\n                  </div>\r\n                                            </div>\r\n                                            <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                                              <label class=\"control-label formLabel whiteText\" for=\"password\">Confirm Password</label>\r\n                                              <div class=\"controls\">\r\n                                                <input type=\"password\" id=\"confirm_password\" ng-model=\"User.ConfirmPassword\" data-errormessage=\"Password and Confirm password do not match.\"\r\n                  placeholder=\"\" class=\"form-control input-md  validate[required,equals[password]] text-input \" />\r\n                                                <small id=\"message\"></small>\r\n                                              </div>\r\n                                            </div>\r\n                                            <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                                              <label class=\"control-label formLabel whiteText\" for=\"email\">Account Email</label>\r\n                                              <div class=\"controls\">\r\n                                                <input type=\"email\" ng-model=\"User.Email\" data-errormessage=\"Email is required.\" class=\"form-control input-md  validate[required] text-input\">\r\n                  </div>\r\n                                              </div>\r\n                                            </div>\r\n\r\n                                          </div>\r\n                                        </div>\r\n                                        <div ng-if=\"HideRegisterButton\">\r\n                                          <div class=\"control-group whiteText\">\r\n                                            <p>Congratulations. We already have you in\r\n                                              our system and sent you a password awhile\r\n                                              ago to\r\n                                              {{shortEmail}}. If you lost the password\r\n                                              and want to reset it, click on the link\r\n                                              below. If you have other issues call\r\n                                              70-VoteWise\r\n                                            </p>\r\n                                          </div>\r\n                                          <!-- <p>Login</p> -->\r\n                                          <div class=\"control-group\" ng-if=\"showMultiDrop\">\r\n                                            <label class=\"control-label formLabel removeTopMargin whiteText\"  for=\"UserName\">Which User</label>\r\n                                            <div class=\"controls\">\r\n                                              <select style=\"width: 80%;\"  ng-model=\"User.multiName\"  class=\"blackText\" ng-options=\"x as x.name for x in multiArr\">\r\n                  </select>\r\n                                            </div>\r\n                                          </div>\r\n                                          <div ng-if=\"!forFacebook\" class=\"control-group\" style=\"width:88%\">\r\n                                            <label class=\"control-label formLabel whiteText\" for=\"firstname\">UserName/Email</label>\r\n                                            <div class=\"controls\">\r\n                                              <input type=\"text\" ng-model=\"User.UserName\" placeholder=\"\" data-errormessage=\"UserName is required.\" class=\"form-control input-md  validate[required] text-input\">\r\n                  </div>\r\n                                            </div>\r\n                                            <div ng-if=\"!forFacebook\" class=\"control-group\" style=\"width:88%\">\r\n                                              <label class=\"control-label formLabel whiteText\" for=\"password\">Password</label>\r\n                                              <div class=\"controls\">\r\n                                                <input type=\"password\" id=\"password\" ng-model=\"User.Password\" placeholder=\"\" data-errormessage=\"Password is required.\" class=\"form-control input-md  validate[required] text-input\"\r\n                  />\r\n                  </div>\r\n                                              </div>\r\n                                              <div style=\"clear: both;\"></div>\r\n                                              <div class=\"btn-style\">\r\n                                                <button class=\"btnShort-style\" ng-if=\"!forFacebook\" ng-click=\"OrgLogin()\" type=\"button\" class=\"btn btn-success\" style=\"float: right; width:258px; margin-right: 25%\">Update details & Login</button>\r\n                                              </div>\r\n                                              <div style=\"clear: both;\"></div>\r\n                                              <p style=\"padding-top:5%;padding-left:3%; color: rgb(241, 241, 241)\">\r\n                                                Forgot password?</p>\r\n                                              <div class=\"btn-style\">\r\n                                                <button class=\"btnShort-style whiteText\" ng-if=\"!forFacebook\" ng-click=\"resetPassword()\" type=\"button\" class=\"btn btn-success\"\r\n                  style=\"float: right; width:258px; margin-right: 25%\">Please email me my password</button>\r\n                                              </div>\r\n                                            </div>\r\n                                            <div class=\"control-group\"\r\n                                            ng-if=\"!forFacebook && showGuest\">\r\n                                            <label class=\"control-label formLabel\">Street Address (LEAVE OUT APT #)<br>(This is used for location based tools like finding your representatives. Feel free to use an intersection instead of your actual address)</label>\r\n                                            <div class=\"control-group\">\r\n                                              <input\r\ntype=\"text\"\r\nid=\"address\"\r\nng-model=\"User.Address\"\r\nng-keyup=\"detectAddress($event)\"\r\nclass=\"zipInput form-control\"\r\n/>&nbsp;\r\n</div>\r\n                                            </div>\r\n                                            <div class=\"control-group\"\r\n                                              ng-if=\"!forFacebook && showGuest || showzip\">\r\n                                              <label class=\"control-label formLabel whiteText\" for=\"zipcode\">ZipCode</label>\r\n                                              <div class=\"control-group\">\r\n                                                <input\r\ntype=\"text\"\r\nng-model=\"User.ZipCodeOne\"\r\nid=\"zip\"\r\nclass=\"zipInput form-control validate[required,custom[integer],minSize[5]] text-input\"\r\n/>&nbsp;\r\n</div>\r\n                                              </div>\r\n                  </div>\r\n                <div ng-if=\"UserType == \'press\'\">\r\n                  <div class=\"control-group\">\r\n                    <label class=\"control-label\" for=\"email\">Name of Press outlet</label>\r\n                    <div mass-autocomplete>\r\n                      <input\r\n                ng-model=\"User.outlet_name\"\r\n                ng-blur=\"checkExists();\"\r\n                mass-autocomplete-item=\"org_autocomplete_options\"\r\n              />\r\n            </div>\r\n                    </div>\r\n                    <div class=\"control-group\">\r\n                      <label class=\"control-label\" for=\"email\">Website for press outlet</label>\r\n                      <div class=\"controls\">\r\n                        <input\r\n                type=\"text\"\r\n                ng-model=\"User.outlet_web\"\r\n                ng-disabled=\"User.organization._id\"\r\n                data-errormessage-custom-error=\"Invalid URL.\"\r\n                data-errormessage=\"Website for press outlet is required.\"\r\n                class=\"form-control input-md  validate[required, custom[url]] text-input\"\r\n              />\r\n            </div>\r\n                      </div>\r\n                      <div class=\"control-group\">\r\n                        <label class=\"control-label\" for=\"email\"\r\n              >Phone number of press outlet (xxx)xxx-xxxx</label>\r\n                        <div class=\"controls\">\r\n                          <input\r\n                type=\"tel\"\r\n                ng-model=\"User.outlet_phone_no\"\r\n                ng-disabled=\"User.organization._id\"\r\n                data-errormessage=\"Phone number of press outlet is required.\"\r\n                class=\"form-control input-md  validate[required] text-input\"\r\n              />\r\n            </div>\r\n                        </div>\r\n                        <div class=\"control-group\">\r\n                          <label class=\"control-label\" for=\"email\">Your extension number (if any)</label>\r\n                          <div class=\"controls\">\r\n                            <input\r\n                type=\"text\"\r\n                ng-model=\"User.press_extension_no\"\r\n                class=\"form-control input-md text-input\"\r\n              />\r\n            </div>\r\n                          </div>\r\n                        </div>\r\n                        <div ng-if=\"UserType == \'politician\'\">\r\n                          <div class=\"control-group\">\r\n                            <label class=\"control-label formLabel whiteText\" for=\"email\">Are you currently in Office?</label>\r\n                            <div class=\"controls whiteText\">\r\n                              <label>\r\n<input type=\"radio\" ng-model=\"User.isInCurrentOffice\" value=\"1\"> Yes\r\n</label>\r\n                              <label>\r\n<input type=\"radio\" ng-model=\"User.isInCurrentOffice\" value=\"0\"> No\r\n</label>\r\n                            </div>\r\n                          </div>\r\n                          <div ng-if=\"User.isInCurrentOffice == 1\">\r\n                            <div class=\"control-group\">\r\n                              <label class=\"control-label formLabel whiteText\" for=\"email\">What level of government?</label>\r\n                              <select ng-model=\"User.cur_level\" style=\"text-transform: capitalize;display: block;\" ng-options=\"item as item for item in levelOfGovt\"\r\nng-change=\"govLevelChanged(\'incumbent\')\" class=\"changeTextColor\">\r\n</select>\r\n                            </div>\r\n                            <div class=\"control-group\" ng-if=\"flagShowStateDropdown\">\r\n                              <label class=\"control-label formLabel whiteText\" for=\"email\">Select State: (if applicable)</label>\r\n                              <select ng-model=\"User.cur_state\" style=\"text-transform: capitalize;max-width: 85%\" ng-options=\"item as item.state for item in states\"\r\nng-change=\"onOfficeChange(\'incumbent\')\" class=\"changeTextColor\">\r\n</select>&nbsp; &nbsp;\r\n                              <center>\r\n                                <div ng-if=\"showLoader\" style=\"z-index: 2; background:black;\">\r\n                                  <i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span>\r\n                                </div>\r\n\r\n                              </center>\r\n                            </div>\r\n                            <div style=\"width:40%\" class=\"control-group\" ng-if=\"countyone\">\r\n                              <label class=\"control-label formLabel whiteText\" for=\"email\">County </label>\r\n                              <div class=\"controls\">\r\n                                <select ng-model=\"address.county\" style=\"text-transform: capitalize;display:inline\" ng-options=\"item as item.countyName for item in counties | orderBy : \'county\'\" ng-change=\"getSubCounties()\" class=\"changeTextColor\"></select>\r\n                                <i ng-if=\"showLoaderOne\" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>\r\n                              </div>\r\n                            </div>\r\n                            <div style=\"width:70%\" class=\"control-group\" ng-if=\"cityone\">\r\n                              <label class=\"control-label formLabel whiteText\" for=\"email\">City </label>\r\n                              <div class=\"controls\">\r\n                                <select ng-model=\"address.place\" style=\"text-transform: capitalize;\" ng-options=\"item as item.city for item in places | orderBy : \'place\' \" class=\"changeTextColor\"></select>\r\n                                <!-- <i ng-if=\"LoaderTwo \" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i> -->\r\n                              </div>\r\n                            </div>\r\n                            <div id=\"curCandidate\" class=\"control-group blackText\" ng-if=\"flagShowCandidateDropdown\">\r\n                              <label class=\"control-label formLabel whiteText\" for=\"email\">What is your name as it appears on the ballot?</label>\r\n                              <div mass-autocomplete>\r\n                                <input ng-model=\"User.cur_Candidates\" ng-blur=\"checkExists();\" mass-autocomplete-item=\"autocomplete_options\" class=\"changeTextColor\">\r\n</div>\r\n                              </div>\r\n                              <div class=\"control-group\" ng-if=\"showcur_office_name\">\r\n                                <label class=\"control-label formLabel whiteText\" for=\"email\">Office Name</label>\r\n                                <div class=\"controls\">\r\n                                  <input type=\"text\" ng-model=\"User.cur_office_name\" class=\"form-control  input-md text-input\" style=\"width: 88%\">\r\n</div>\r\n                                </div>\r\n                                <div class=\"control-group\" ng-if=\"showcur_office_name\">\r\n                                  <label class=\"control-label formLabel whiteText\" for=\"email\">Office Phone(optional)</label>\r\n                                  <div class=\"controls\">\r\n                                    <input type=\"text\" ng-model=\"User.cur_office_phone\" class=\"form-control input-md text-input\" style=\"width: 88%\">\r\n</div>\r\n                                  </div>\r\n                                  <div class=\"control-group\" ng-if=\"showcur_office_name\">\r\n                                    <label class=\"control-label formLabel whiteText\" for=\"email\">Office Email(optional)</label>\r\n                                    <div class=\"controls\">\r\n                                      <input type=\"text\" ng-model=\"User.cur_office_email\" class=\"form-control  input-md text-input\" style=\"width: 88%\">\r\n</div>\r\n                                    </div>\r\n                                    <div class=\"control-group\" ng-if=\"showcur_office_name\">\r\n                                      <label class=\"control-label formLabel whiteText\" for=\"email\">Office Website (optional)</label>\r\n                                      <div class=\"controls\">\r\n                                        <input type=\"text\" ng-model=\"User.cur_office_website\" class=\"form-control validate[custom[url]] input-md text-input\" style=\"width: 88%\">\r\n</div>\r\n                                      </div>\r\n                                      <div class=\"control-group\" ng-if=\"showcur_office_name\">\r\n                                        <label class=\"control-label formLabel whiteText\" for=\"email\">Office Facebook Url (optional)</label>\r\n                                        <div class=\"controls\">\r\n                                          <input type=\"text\" ng-model=\"User.facebook_url\" ng-disabled=\"User.organization._id\" class=\"form-control validate[custom[url]] input-md text-input\"\r\nstyle=\"width: 88%\">\r\n</div>\r\n                                        </div>\r\n                                        <!-- <div class=\"control-group\" ng-if=\"sendPostCard\">\r\n<p>We have you in our system, but in order to confirm you are who you say you are, we need to contact you either through an official government website or at the address you used for registering your campaign with your board of elections.</p>\r\n<button class=\"btnShort-style\" ng-click=\"generatePostcard()\" type=\"button\" class=\"btn btn-success\" ng-disabled=\"User.postCard && User.postCard !=\'\'\" style=\"width:200px; margin:0; margin-top:10px;\">Send me a Postcard</button>\r\n<div ng-if=\"PostcardSend\">\r\n<small style=\"color:#ff0000;\">Thank you for opting for postcard. We will send you a postcard with a code which will be required for verification.</small>\r\n</div>\r\n<input type=\"hidden\" ng-model=\"User.postCard\">\r\n<p>\r\n<center>---OR---</center>\r\n</p>\r\n<div class=\"control-group\">\r\n<label class=\"control-label\">Official Government website that we can contact you at.</label>\r\n<div class=\"controls\">\r\n<input type=\"text\" ng-model=\"User.govtOfficialWebsite\" class=\"form-control validate[custom[url]] input-md text-input\">\r\n</div>\r\n</div>\r\n<p>\r\n<center>---OR---</center>\r\n</p>\r\n<div class=\"control-group\">\r\n<label class=\"control-label\">I have received my code and am ready to enter it.</label>\r\n<div class=\"controls\">\r\n<input type=\"text\" ng-model=\"User.confirmPostalCode\" class=\"form-control input-md text-input\">\r\n</div>\r\n</div>\r\n<div class=\"control-group\">\r\n<div class=\"controls\">\r\n<button class=\"btnShort-style\" ng-click=\"submitPostcard(User)\" type=\"button\" class=\"btn btn-success\" style=\"width:200px; margin:0; margin-top:10px;\">Submit</button>\r\n</div>\r\n</div>\r\n</div> -->\r\n                                        <div class=\"control-group whiteText\" ng-if=\"sendPostCard\">\r\n                                          <p>We have you in our system, but in order to confirm your identity, you\r\n                                            need\r\n                                            to call\r\n                                            <br/>\r\n                                            <b>72-VoteWise</b>.</p>\r\n                                        </div>\r\n                                      </div>\r\n                                      <br>\r\n                                      <div>\r\n                                        <div class=\"control-group\">\r\n                                          <label class=\"control-label formLabel whiteText\" for=\"email\">Are you running for office this coming election?</label>\r\n                                          <div class=\"controls whiteText\">\r\n                                            <label>\r\n<input type=\"radio\" ng-model=\"User.isRunningForEle\" ng-click=\"User.RunningForOtherOffice = 0;  \" value=\"1\"> Yes\r\n</label>\r\n                                            <label>\r\n<input type=\"radio\" ng-model=\"User.isRunningForEle\" ng-click=\"User.RunningForOtherOffice = 0;  \" value=\"0\"> No\r\n</label>\r\n                                          </div>\r\n                                        </div>\r\n                                        <div ng-if=\"User.isRunningForEle == 1 && User.isInCurrentOffice == 1\">\r\n                                          <label class=\"control-label formLabel whiteText\" for=\"email\">Are you running for the same office?</label>\r\n                                          <div class=\"controls whiteText\">\r\n                                            <label>\r\n<input type=\"radio\" ng-model=\"User.RunningForOtherOffice\" ng-checked=\"User.RunningForOtherOffice == 1\" value=\"1\"> Yes\r\n</label>\r\n                                            <label>\r\n<input type=\"radio\" ng-model=\"User.RunningForOtherOffice\" ng-checked=\"User.RunningForOtherOffice == 0\" value=\"0\"> No\r\n</label>\r\n                                          </div>\r\n                                        </div>\r\n                                        <div\r\n                                          ng-if=\"User.isInCurrentOffice == 1? User.isRunningForEle==1? User.RunningForOtherOffice == 0: false : User.isRunningForEle==1\">\r\n                                          <div class=\"control-group\">\r\n                                            <label class=\"control-label formLabel whiteText\" for=\"email\">What level of government?</label>\r\n                                            <select ng-model=\"User.level\" style=\"text-transform: capitalize; display: block;\" ng-change=\"govLevelChanged(\'running\')\"\r\nng-options=\"item as item for item in levelOfGovt\" class=\"changeTextColor\">\r\n</select>\r\n                                          </div>\r\n                                          <div class=\"control-group\" ng-if=\"running_flagShowStateDropdown\">\r\n                                            <label class=\"control-label formLabel whiteText\" for=\"email\"> Select State: (if applicable)</label>\r\n                                            <select ng-model=\"User.state\" style=\"text-transform: capitalize;\" ng-options=\"item as item.state for item in states\" ng-change=\"onOfficeChange(\'running\')\"\r\nclass=\"changeTextColor\">\r\n</select>&nbsp; &nbsp;\r\n                                            <i ng-if=\"showLoader\" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>\r\n                                          </div>\r\n                                          <div style=\"width:40%\" class=\"control-group\"\r\n                                            ng-if=\" running_flagShowStateDropdown && running_countyone\">\r\n                                            <label class=\"control-label formLabel whiteText\" for=\"email\">County </label>\r\n                                            <div class=\"controls\">\r\n                                              <select ng-model=\"runAddress.county\" style=\"text-transform: capitalize;display:inline\" ng-options=\"item as item.countyName for item in runCounties | orderBy : \'county\'\" ng-change=\"getRunningSubCounties()\" class=\"changeTextColor\"></select>\r\n                                              <i ng-if=\"running_showLoaderOne\" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>\r\n                                            </div>\r\n                                          </div>\r\n                                          <div style=\"width:40%\" class=\"control-group\"\r\n                                            ng-if=\"running_flagShowStateDropdown && running_cityone\">\r\n                                            <label class=\"control-label formLabel whiteText\" for=\"email\">City </label>\r\n                                            <div class=\"controls\">\r\n                                              <select ng-model=\"runAddress.place\" style=\"text-transform: capitalize;\" ng-options=\"item as item.city for item in runPlaces | orderBy : \'place\'\" class=\"changeTextColor\"></select>\r\n                                            </div>\r\n                                          </div>\r\n                                          <div id=\"curCandidate\" class=\"control-group blackText\"\r\n                                            ng-if=\"running_flagShowCandidateDropdown\">\r\n                                            <label class=\"control-label formLabel formLabel whiteText\" for=\"email\">What is your name as it appears on the ballot?</label>\r\n                                            <div mass-autocomplete>\r\n                                              <input ng-model=\"User.new_Candidates\" ng-blur=\"checkExistsNew()\" mass-autocomplete-item=\"autocomplete_new_options\">\r\n</div>\r\n                                            </div>\r\n                                            <div class=\"control-group\" ng-if=\"shownew_office_name\">\r\n                                              <label class=\"control-label formLabel whiteText\" for=\"email\">Office Name</label>\r\n                                              <div class=\"controls\">\r\n                                                <input type=\"text\" ng-model=\"User.office_name\" class=\"form-control input-md text-input\" style=\"width: 88%\">\r\n</div>\r\n                                              </div>\r\n                                              <div style=\"width: 60%\">\r\n                                                <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                                                  <label class=\"control-label formLabel whiteText\" for=\"email\">Election Date</label>\r\n                                                  <div class=\"controls\">\r\n                                                    <input type=\"date\"  ng-model=\"User.runElectionDate\" class=\"form-control\">\r\n                                          </div>\r\n                                                  </div>\r\n                                                </div>\r\n                                                <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                                                  <label class=\"control-label formLabel whiteText\" for=\"email\">Candidate Status</label>\r\n                                                  <div class=\"controls\">\r\n                                                    <select ng-model=\"User.runStatus\" class=\"form-control\"  style=\"width:36%;\">\r\n                                          <option value=\"\">Select Status</option>\r\n                                          <option value=\"Announced\">Announced</option>\r\n                                          <option value=\"Write in\">Write in</option>\r\n                                          <option value=\"Running\">Running</option>\r\n                                          <option value=\"Campaign Suspended\">Campaign Suspended</option>\r\n                                          </select>\r\n                                                  </div>\r\n                                                </div>\r\n                                                <!-- <div class=\"control-group\" ng-if=\"shownew_office_name\">\r\n<label class=\"control-label formLabel whiteText\" for=\"email\">Office Location</label>\r\n<input type=\"text\" ng-model=\"User.office_location\" class=\"form-control validate[required] input-md text-input\">\r\n</div>  -->\r\n                                                <!-- <div class=\"control-group\" ng-if=\"sendPostCardNew\">\r\n<p>We have you in our system, but in order to confirm you are who you say you are, we need to contact you either through an official government website or at the address you used for registering your campaign with your board of elections.</p>\r\n<button class=\"btnShort-style\" ng-click=\"generatePostcard()\" type=\"button\" class=\"btn btn-success\" ng-disabled=\"User.postCard && User.postCard !=\'\'\" style=\"width:200px; margin:0; margin-top:10px;\">Send me a Postcard</button>\r\n<div ng-if=\"PostcardSend\">\r\n<small style=\"color:#ff0000;\">Thank you for opting for postcard. We will send you a postcard with a code which will be required for verification.</small>\r\n</div>\r\n<input type=\"hidden\" ng-model=\"User.postCard\">\r\n<p>\r\n<center>---OR---</center>\r\n</p>\r\n<div class=\"control-group\">\r\n<label class=\"control-label formLabel whiteText\">Official Government website that we can contact you at.</label>\r\n<div class=\"controls\">\r\n<input type=\"text\" ng-model=\"User.govtOfficialWebsite\" class=\"form-control validate[custom[url]] input-md text-input\">\r\n</div>\r\n</div>\r\n<p>\r\n<center>---OR---</center>\r\n</p>\r\n<div class=\"control-group\">\r\n<label class=\"control-label formLabel whiteText\">I have received my code and am ready to enter it.</label>\r\n<div class=\"controls\">\r\n<input type=\"text\" ng-model=\"User.confirmPostalCode\" class=\"form-control input-md text-input\">\r\n</div>\r\n</div>\r\n<div class=\"control-group\">\r\n<div class=\"controls\">\r\n<button class=\"btnShort-style\" ng-click=\"submitPostcard(User)\" type=\"button\" class=\"btn btn-success\" style=\"width:200px; margin:0; margin-top:10px;\">Submit</button>\r\n</div>\r\n</div>\r\n</div> -->\r\n                                                <div class=\"control-group whiteText\" ng-if=\"sendPostCardNew\">\r\n                                                  <p>We have you in our system, but in order to confirm your\r\n                                                    identity,\r\n                                                    you\r\n                                                    need to call\r\n                                                    <br/>\r\n                                                    <b>72-VoteWise</b>.</p>\r\n                                                </div>\r\n                                              </div>\r\n                                            </div>\r\n                                            <div ng-if=\"User.RunningForOtherOffice == 1\" style=\"width: 60%\">\r\n                                              <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                                                <label class=\"control-label formLabel whiteText\" for=\"email\">Election Date</label>\r\n                                                <div class=\"controls\">\r\n                                                  <input type=\"date\" ng-model=\"User.runElectionDate\" class=\"form-control\">\r\n</div>\r\n                                                </div>\r\n                                              </div>\r\n                                              <div ng-if=\"User.RunningForOtherOffice == 1\">\r\n                                                <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                                                  <label class=\"control-label formLabel whiteText\" for=\"email\">Candidate Status</label>\r\n                                                  <div class=\"controls\">\r\n                                                    <select ng-model=\"User.runStatus\" class=\"form-control\"  style=\"width:36%;\">\r\n<option value=\"\">Select Status</option>\r\n<option value=\"Announced\">Announced</option>\r\n<option value=\"Write in\">Write in</option>\r\n<option value=\"Running\">Running</option>\r\n<!-- <option value=\"Active\">Active</option> -->\r\n<option value=\"Campaign Suspended\">Campaign Suspended</option>\r\n</select>\r\n                                                  </div>\r\n                                                </div>\r\n                                              </div>\r\n                                              <br>\r\n                                              <div ng-if=\"shownew_office_name\">\r\n                                                <!--                                             <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                                            <label class=\"control-label formLabel whiteText\" for=\"email\">Campaign Email</label>\r\n                                            <div class=\"controls\">\r\n                                              <input type=\"email\" ng-model=\"User.campaignEmail\"  class=\"form-control input-md   text-input\"\r\nng-readonly=\"checkReadOnly\" style=\"width: 88%\">\r\n</div>\r\n                                            </div>\r\n                                            <div class=\"control-group\">\r\n                                              <label class=\"control-label formLabel whiteText\" for=\"email\">Campaign Phone number (xxx)xxx-xxxx</label>\r\n                                              <div class=\"controls\">\r\n                                                <input type=\"tel\" ng-model=\"User.campPhone_no\" data-errormessage=\"Phone number is required.\" data-errormessage-custom-error=\"Invalid phone number.\"\r\nclass=\"form-control input-md text-input\" style=\"width: 88%\">\r\n</div>\r\n                                              </div>-->\r\n                                                <div class=\"control-group\">\r\n                                                  <label class=\"control-label formLabel whiteText\" for=\"email\">Campaign Website (optional)</label>\r\n                                                  <div class=\"controls\">\r\n                                                    <input type=\"text\" ng-model=\"User.campaignWebSite\" ng-disabled=\"User.organization._id\" class=\"form-control validate[custom[url]] input-md text-input\"\r\nstyle=\"width: 88%\">\r\n</div>\r\n                                                  </div>\r\n                                                  <div class=\"control-group\">\r\n                                                    <label class=\"control-label formLabel whiteText\" for=\"email\">Campaign Facebook Url (optional)</label>\r\n                                                    <div class=\"controls\">\r\n                                                      <input type=\"text\" ng-model=\"User.campaignFburl\" ng-disabled=\"User.organization._id\" class=\"form-control validate[custom[url]] input-md text-input\"\r\n          style=\"width: 88%\">\r\n          </div>\r\n                                                    </div>\r\n                                                    <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                                                      <label class=\"control-label formLabel whiteText\" for=\"email\"> Account Email</label>\r\n                                                      <div class=\"controls\">\r\n                                                        <input type=\"email\" ng-model=\"User.Email\" data-errormessage=\"Email is required.\" class=\"form-control input-md  validate[required] text-input\"\r\nng-readonly=\"checkReadOnly\" style=\"width: 88%\">\r\n</div>\r\n                                                      </div>\r\n\r\n                                                      <div class=\"control-group\">\r\n                                                        <label class=\"control-label formLabel whiteText\" for=\"email\"> Account Phone number (xxx)xxx-xxxx</label>\r\n                                                        <div class=\"controls\">\r\n                                                          <input type=\"tel\" ng-model=\"User.phone_no\" data-errormessage=\"Phone number is required.\" data-errormessage-custom-error=\"Invalid phone number.\"\r\nclass=\"form-control input-md  validate[required] text-input\" style=\"width: 88%\">\r\n</div>\r\n                                                        </div>\r\n                                                        <!--                                                          <div class=\"control-group\">\r\n                                                        <label class=\"control-label formLabel whiteText\" for=\"email\">Website</label>\r\n                                                        <div class=\"controls\">\r\n                                                          <input type=\"text\" ng-model=\"User.web_url\" ng-disabled=\"User.organization._id\" class=\"form-control validate[custom[url]] input-md text-input\"\r\nstyle=\"width: 88%\">\r\n</div>\r\n                                                        </div> -->\r\n                                                      </div>\r\n                                                      <div ng-if=\"!HideRegisterButton && !HideNewRegisterButton\">\r\n                                                        <div ng-if=\"!shownew_office_name\">\r\n                                                          <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                                                            <label class=\"control-label formLabel whiteText\" for=\"email\">Account Email</label>\r\n                                                            <div class=\"controls\">\r\n                                                              <input type=\"email\" ng-model=\"User.Email\" data-errormessage=\"Email is required.\" class=\"form-control input-md  validate[required] text-input\"\r\nng-readonly=\"checkReadOnly\" style=\"width: 88%\">\r\n</div>\r\n                                                            </div>\r\n                                                            <div class=\"control-group\">\r\n                                                              <label class=\"control-label formLabel whiteText\" for=\"email\"> Account Phone number (xxx)xxx-xxxx</label>\r\n                                                              <div class=\"controls\">\r\n                                                                <input type=\"tel\" ng-model=\"User.phone_no\" data-errormessage=\"Phone number is required.\" data-errormessage-custom-error=\"Invalid phone number.\"\r\nclass=\"form-control input-md  validate[required] text-input\" style=\"width: 88%\">\r\n</div>\r\n                                                              </div>\r\n                                                              <div class=\"control-group\">\r\n                                                                <label class=\"control-label formLabel whiteText\" for=\"email\">Campaign Website (optional)</label>\r\n                                                                <div class=\"controls\">\r\n                                                                  <input type=\"text\" ng-model=\"User.web_url\" ng-disabled=\"User.organization._id\" class=\"form-control validate[custom[url]] input-md text-input\"\r\nstyle=\"width: 88%\">\r\n</div>\r\n                                                                </div>\r\n                                                              </div>\r\n\r\n                                                              <!--  <div class=\"control-group\">\r\n<label class=\"control-label formLabel whiteText\" for=\"email\">Mailing address</label>\r\n<div class=\"controls\">\r\n<input type=\"text\" ng-model=\"User.mailing_address\" data-errormessage=\"Mailing address is required.\" class=\"form-control input-md  validate[required] text-input\"\r\nstyle=\"width: 88%\">\r\n</div>\r\n</div> -->\r\n                                                              <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                                                                <label class=\"control-label formLabel whiteText\" for=\"firstname\">Account Manager\'s Name</label>\r\n                                                                <div class=\"controls\">\r\n                                                                  <input ng-if=\"UserType == \'voter\'\" type=\"text\" ng-model=\"User.name\" placeholder=\"\" class=\"form-control input-md text-input\"\r\nstyle=\"width: 88%\">\r\n                                                                  <input ng-if=\"UserType != \'voter\'\" type=\"text\" ng-model=\"User.name\" placeholder=\"\" data-errormessage=\"Account Manager\'s Name is required.\"\r\nclass=\"form-control input-md  validate[required] text-input\" style=\"width: 88%\">\r\n</div>\r\n                                                                </div>\r\n                                                                <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                                                                  <label class=\"control-label formLabel whiteText\" for=\"firstname\">UserName for future Log In</label>\r\n                                                                  <div class=\"controls\">\r\n                                                                    <input type=\"text\" ng-model=\"User.UserName\" ng-blur=\"CheckUserName()\" placeholder=\"\" data-errormessage=\"UserName is required.\"\r\nclass=\"form-control input-md  validate[required] text-input\" style=\"width: 88%\">\r\n</div>\r\n                                                                  </div>\r\n                                                                  <!-- <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                                                                  <label class=\"control-label formLabel whiteText\" for=\"password\"> Create Password</label>\r\n                                                                  <div class=\"controls\">\r\n                                                                    <input type=\"password\" id=\"password\" ng-model=\"User.Password\" placeholder=\"\" data-errormessage=\"Password is required.\" class=\"form-control input-md  validate[required] text-input\"\r\nstyle=\"width: 88%\" />\r\n</div>\r\n                                                                  </div>\r\n                                                                  <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                                                                    <label class=\"control-label formLabel whiteText\" for=\"password\">Confirm Password</label>\r\n                                                                    <div class=\"controls\">\r\n                                                                      <input type=\"password\" id=\"confirm_password\" ng-model=\"ConfirmPassword\" data-errormessage=\"Password and Confirm password do not match.\"\r\nplaceholder=\"\" class=\"form-control input-md  validate[required,equals[password]] text-input \" style=\"width: 88%\"\r\n/>\r\n                                                                      <small id=\"message\"></small>\r\n                                                                    </div>\r\n                                                                  </div> -->\r\n                                                                  <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                                                                    <br />\r\n                                                                    <label class=\"control-label\" for=\"password\"> Create Password</label>\r\n                                                                    <div class=\"controls\">\r\n                                                                      <input\r\ntype=\"password\"\r\nid=\"password\"\r\nng-model=\"User.Password\"\r\nplaceholder=\"\"\r\ndata-errormessage=\"Password is required.\"\r\nclass=\"form-control input-md  validate[required] text-input\"\r\n/>\r\n</div>\r\n                                                                    </div>\r\n                                                                    <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                                                                      <label class=\"control-label\" for=\"password\">Confirm Password</label>\r\n                                                                      <div class=\"controls\">\r\n                                                                        <input\r\ntype=\"password\"\r\nid=\"confirm_password\"\r\nng-model=\"User.ConfirmPassword\"\r\ndata-errormessage=\"Password and Confirm password do not match.\"\r\nplaceholder=\"\"\r\nclass=\"form-control input-md  validate[required,equals[password]] text-input \"\r\n/>\r\n                                                                        <small id=\"message\"></small>\r\n                                                                      </div>\r\n                                                                    </div>\r\n                                                                  </div>\r\n                                                                  <div\r\n                                                                    ng-if=\"HideRegisterButton || HideNewRegisterButton\">\r\n                                                                    <div class=\"control-group whiteText\">\r\n                                                                      <p>Congratulations. We already have you in\r\n                                                                        our system and sent you a password awhile\r\n                                                                        ago to\r\n                                                                        {{shortEmail}}. If you lost the password\r\n                                                                        and want to reset it, click on the link\r\n                                                                        below. If you have other issues call\r\n                                                                        70-VoteWise\r\n                                                                      </p>\r\n                                                                    </div>\r\n                                                                    <!-- <p>Login</p> -->\r\n                                                                    <div class=\"control-group\" ng-if=\"showMultiDrop\">\r\n                                                                      <label class=\"control-label formLabel removeTopMargin whiteText\"  for=\"UserName\">Which User</label>\r\n                                                                      <div class=\"controls\">\r\n                                                                        <select style=\"width: 80%;\"  ng-model=\"User.multiName\"  class=\"blackText\" ng-options=\"x as x.name for x in multiArr\">\r\n</select>\r\n                                                                      </div>\r\n                                                                    </div>\r\n                                                                    <div ng-if=\"!forFacebook\" class=\"control-group\"\r\n                                                                      style=\"width:88%\">\r\n                                                                      <label class=\"control-label formLabel whiteText\" for=\"firstname\">UserName/Email</label>\r\n                                                                      <div class=\"controls\">\r\n                                                                        <input type=\"text\" ng-model=\"User.UserName\" placeholder=\"\" data-errormessage=\"UserName is required.\" class=\"form-control input-md  validate[required] text-input\">\r\n</div>\r\n                                                                      </div>\r\n                                                                      <div ng-if=\"!forFacebook\" class=\"control-group\"\r\n                                                                        style=\"width:88%\">\r\n                                                                        <label class=\"control-label formLabel whiteText\" for=\"password\">Password</label>\r\n                                                                        <div class=\"controls\">\r\n                                                                          <input type=\"password\" id=\"password\" ng-model=\"User.Password\" placeholder=\"\" data-errormessage=\"Password is required.\" class=\"form-control input-md  validate[required] text-input\"\r\n/>\r\n</div>\r\n                                                                        </div>\r\n                                                                        <div style=\"clear: both;\"></div>\r\n                                                                        <div class=\"btn-style\">\r\n                                                                          <button class=\"btnShort-style\" ng-if=\"!forFacebook\" ng-click=\"UserLogin()\" type=\"button\" class=\"btn btn-success\" style=\"float: right; width:258px; margin-right: 25%\">Update details & Login</button>\r\n                                                                        </div>\r\n                                                                        <div style=\"clear: both;\"></div>\r\n                                                                        <p\r\n                                                                          style=\"padding-top:5%;padding-left:3%; color: rgb(241, 241, 241)\">\r\n                                                                          Forgot password?</p>\r\n                                                                        <div class=\"btn-style\">\r\n                                                                          <button class=\"btnShort-style whiteText\" ng-if=\"!forFacebook\" ng-click=\"resetPassword()\" type=\"button\" class=\"btn btn-success\"\r\nstyle=\"float: right; width:258px; margin-right: 25%\">Please email me my password</button>\r\n                                                                        </div>\r\n                                                                      </div>\r\n                                                                      <div class=\"control-group\"\r\n                                                                        ng-if=\"!forFacebook && showGuest || showzip\">\r\n                                                                        <label class=\"control-label formLabel whiteText\" for=\"zipcode\">ZipCode</label>\r\n                                                                        <div class=\"control-group\">\r\n                                                                          <input\r\ntype=\"text\"\r\nng-model=\"User.ZipCodeOne\"\r\nid=\"zip\"\r\nclass=\"zipInput form-control validate[required,custom[integer],minSize[5]] text-input\"\r\n/>&nbsp;\r\n</div>\r\n                                                                        </div>\r\n                                                                      </div>\r\n                                                                      <div style=\"clear: both;\"></div>\r\n\r\n                                                                      <!-- End of Politician -->\r\n                                                                      <div ng-if=\"UserType == \'voter\'\">\r\n\r\n\r\n                                                                        <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n\r\n                                                                          <br />\r\n                                                                          <label class=\"control-label formLabel whiteText\" for=\"firstname\">Giving us your name helps the email we send you (to confirm your account) get past your spam filter.<br> <br>First Name (optional)</label>\r\n\r\n                                                                          <div class=\"controls\">\r\n                                                                            <input\r\n              type=\"text\"\r\n              ng-model=\"User.name\"\r\n              placeholder=\"\"\r\n              data-errormessage=\"Name is required.\"\r\n              class=\"form-control input-md  validate[required] text-input\"\r\n            />\r\n          </div>\r\n                                                                          </div>\r\n                                                                          <div ng-if=\"!forFacebook\"\r\n                                                                            class=\"control-group\">\r\n                                                                            <label class=\"control-label formLabel whiteText\" for=\"firstname\">Last Name (optional)</label>\r\n                                                                            <div class=\"controls\">\r\n                                                                              <input  type=\"text\" ng-model=\"User.lastname\" placeholder=\"\" class=\"form-control input-md text-input\">\r\n\r\n                                                                                              </div>\r\n                                                                            </div>\r\n                                                                            <div ng-if=\"!forFacebook\"\r\n                                                                              class=\"control-group\">\r\n                                                                              <br />\r\n                                                                              <label class=\"control-label formLabel whiteText\" for=\"firstname\">UserName <br>(For Log in and User Forums)</label>\r\n\r\n                                                                              <div class=\"controls\">\r\n                                                                                <input\r\n              type=\"text\"\r\n              ng-model=\"User.UserName\"\r\n              ng-blur=\"CheckUserName()\"\r\n              placeholder=\"\"\r\n              data-errormessage=\"UserName is required.\"\r\n              class=\"form-control input-md  validate[required] text-input\"\r\n            />\r\n          </div>\r\n                                                                              </div>\r\n                                                                              <div ng-if=\"!forFacebook\"\r\n                                                                                class=\"control-group\">\r\n                                                                                <br />\r\n                                                                                <label class=\"control-label\" for=\"email\">Email for Account<br>(Not made public)</label>\r\n                                                                                <div class=\"controls\">\r\n                                                                                  <input\r\n              type=\"email\"\r\n              ng-model=\"User.Email\"\r\n              data-errormessage=\"Email is required.\"\r\n              class=\"form-control input-md  validate[required] text-input\"\r\n            />\r\n          </div>\r\n                                                                                </div>\r\n                                                                                <div ng-if=\"!forFacebook\"\r\n                                                                                  class=\"control-group\">\r\n                                                                                  <br />\r\n                                                                                  <label class=\"control-label\" for=\"password\"> Create Password</label>\r\n                                                                                  <div class=\"controls\">\r\n                                                                                    <input\r\n              type=\"password\"\r\n              id=\"password\"\r\n              ng-model=\"User.Password\"\r\n              placeholder=\"\"\r\n              data-errormessage=\"Password is required.\"\r\n              class=\"form-control input-md  validate[required] text-input\"\r\n            />\r\n          </div>\r\n                                                                                  </div>\r\n                                                                                  <div ng-if=\"!forFacebook\"\r\n                                                                                    class=\"control-group\">\r\n                                                                                    <label class=\"control-label\" for=\"password\">Confirm Password</label>\r\n                                                                                    <div class=\"controls\">\r\n                                                                                      <input\r\n              type=\"password\"\r\n              id=\"confirm_password\"\r\n              ng-model=\"User.ConfirmPassword\"\r\n              data-errormessage=\"Password and Confirm password do not match.\"\r\n              placeholder=\"\"\r\n              class=\"form-control input-md  validate[required,equals[password]] text-input \"\r\n            />\r\n                                                                                      <small id=\"message\"></small>\r\n                                                                                    </div>\r\n                                                                                  </div>\r\n                                                                                  <div class=\"control-group\"\r\n                                                                                    ng-if=\"!forFacebook && showGuest\">\r\n                                                                                    <label class=\"control-label formLabel\">Street Address (LEAVE OUT APT #)<br>(This is used for location based tools like finding your representatives. Feel free to use an intersection instead of your actual address)</label>\r\n                                                                                    <div class=\"control-group\">\r\n                                                                                      <input\r\n              type=\"text\"\r\n              id=\"address\"\r\n              ng-model=\"User.Address\"\r\n              ng-keyup=\"detectAddress($event)\"\r\n              class=\"zipInput form-control\"\r\n            />&nbsp;\r\n          </div>\r\n                                                                                    </div>\r\n                                                                                    <div class=\"control-group\"\r\n                                                                                      ng-if=\"!forFacebook && showGuest || showzip\">\r\n                                                                                      <label class=\"control-label formLabel whiteText\" for=\"zipcode\">ZipCode</label>\r\n                                                                                      <div class=\"control-group\">\r\n                                                                                        <input\r\n              type=\"text\"\r\n              ng-model=\"User.ZipCodeOne\"\r\n              id=\"zip\"\r\n              class=\"zipInput form-control validate[required,custom[integer],minSize[5]] text-input\"\r\n            />&nbsp;\r\n          </div>\r\n                                                                                      </div>\r\n\r\n                                                                                      <div style=\"clear: both;\"></div>\r\n                                                                                      <div class=\"control-group\"\r\n                                                                                        ng-if=\"User.UserType == \'voter\'\">\r\n                                                                                        <br />\r\n                                                                                        <label class=\"control-label\" for=\"zipcode\">Confirm account using: </label>\r\n                                                                                        <div class=\"control-group\">\r\n                                                                                          <label>\r\n              <input\r\n                type=\"radio\"\r\n                ng-model=\"User.confirmOpt\"\r\n                ng-click=\"disableRegister(\'E\');\"\r\n                value=\"Email\"\r\n              />\r\n              Email\r\n            </label>\r\n                                                                                          <label>\r\n              <input\r\n                type=\"radio\"\r\n                ng-model=\"User.confirmOpt\"\r\n                ng-click=\"disableRegister(\'P\');\"\r\n                value=\"Phone\"\r\n              />\r\n              Phone\r\n            </label>\r\n                                                                                        </div>\r\n                                                                                      </div>\r\n                                                                                      <div class=\"control-group\"\r\n                                                                                        ng-if=\"UserType == \'voter\' && User.confirmOpt==\'Phone\'\">\r\n                                                                                        <label class=\"control-label\" for=\"cellnumber\">Phone Number</label>\r\n                                                                                        <div class=\"control-group\">\r\n                                                                                          <input\r\n              type=\"number\"\r\n              maxlength=\"10\"\r\n              ng-model=\"User.cellnumber\"\r\n              class=\"form-control validate[required,custom[integer],minSize[5]] text-input\"\r\n            />\r\n          </div>\r\n                                                                                        </div>\r\n                                                                                        <div class=\"control-group\"\r\n                                                                                          ng-if=\"UserType == \'voter\' && User.confirmOpt==\'Phone\'\">\r\n                                                                                          <label class=\"control-label\" for=\"cellnumber\">Select carrier</label>\r\n                                                                                          <div\r\n                                                                                            class=\"control-group blackText\">\r\n                                                                                            <select\r\n              ng-model=\"User.carrier\"\r\n              style=\"text-transform: capitalize;\"\r\n              ng-options=\"item.name for item in carriers\"\r\n            >\r\n            </select>\r\n                                                                                          </div>\r\n                                                                                        </div>\r\n                                                                                        <div class=\"control-group\"\r\n                                                                                          ng-if=\"UserType == \'voter\' && User.confirmOpt==\'Phone\'\">\r\n                                                                                          <br />\r\n                                                                                          <a\r\n            href=\"javascript: void(0);\"\r\n            ng-click=\"getVerificationCode();\"\r\n            style=\"text-decoration: underline;\"\r\n            >Send verification code</a>\r\n                                                                                        </div>\r\n                                                                                        <div class=\"control-group\"\r\n                                                                                          ng-if=\"UserType == \'voter\' && User.confirmOpt==\'Phone\'\">\r\n                                                                                          <br />\r\n                                                                                          <label class=\"control-label\" for=\"cellnumber\">Enter verification code</label>\r\n                                                                                          <div class=\"control-group\">\r\n                                                                                            <input\r\n              type=\"text\"\r\n              ng-model=\"User.verificationCode\"\r\n              class=\"form-control validate[required,custom[integer],minSize[5]] text-input\"\r\n              ng-change=\"matchVerficationCode(User.verificationCode);\"\r\n              maxlength=\"6\"\r\n            />\r\n          </div>\r\n                                                                                          </div>\r\n                                                                                        </div>\r\n                                                                                        <!-- End of voter -->\r\n                                                                                        <div class=\"btn-style\"\r\n                                                                                          style=\"width:100%; margin-right:0px;\"\r\n                                                                                          ng-if=\"!HideRegisterButton && !HideNewRegisterButton\">\r\n                                                                                          <center>\r\n                                                                                            <button\r\n\r\n            ng-click=\"CreateUser()\"\r\n            type=\"button\"\r\n            class=\"btn btn-success\"\r\n            ng-disabled=\"RegisterButton\"\r\n            style=\"float: right;\"\r\n          >\r\n            Save\r\n          </button>\r\n                                                                                          </center>\r\n                                                                                        </div>\r\n                                                                                        <div\r\n                                                                                          style=\"float: left; margin-left: 20px; margin-top: 7px;\"\r\n                                                                                          ng-if=\"!HideRegisterButton && !HideNewRegisterButton\"\r\n                                                                                          class=\"whiteText\">\r\n                                                                                          Already have\r\n                                                                                          an account?\r\n                                                                                          Please\r\n                                                                                          <a style=\"text-decoration: underline;\" href=\"#!/signin\" class=\"ylink\">Sign In here</a>\r\n                                                                                        </div>\r\n    </form>\r\n    <br><br><br><br>\r\n    <hr><br><br>\r\n    <h3>\r\n      <center>See Our Privacy Policy\r\n      </center>\r\n    </h3>\r\n    <center>\r\n      <a href=\"#!/privacyPolicy\">\r\n        <button class=\"compareBtn\">\r\n          <b>Privacy</b>\r\n        </button>\r\n      </a>\r\n    </center>\r\n    <!-- </fieldset> -->\r\n    <div class=\"view1-body\">\r\n      <!-- <center><img src=\"../assets/images/FacebookIconSimple.svg\" class=\"fbTab2\">\r\n              <button class=\"btnW\" ng-click=\"ShowFB()\"> <b>Instant Voter Sign Up with Facebook</b></button>\r\n            </center> -->\r\n      <!--      <div ng-if=\"!$root.showFacebookLoging\" style=\"width: 55%; margin-top: 10px; float: right; margin-right: 17px;\">\r\n        <button ng-click=\"ShowFB()\" type=\"button\" class=\"btnB275\" style=\"float: right;\">\r\n          <i class=\"fa fa-facebook-square\" aria-hidden=\"true\"></i>Instant Voter Sign Up with Facebook</button>\r\n        <fb:login-button scope=\"public_profile,email\" onlogin=\"checkLoginState();\">\r\n                            </fb:login-button>-->\r\n      <div style=\"clear: both;\"></div>\r\n    </div>\r\n    <fieldset ng-if=\"$root.showFacebookLoging\" class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">To continue, we need some information from you.</legend>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label\" for=\"firstname\">What type of user are you?</label>\r\n        <div class=\"controls\">\r\n          <select\r\n            ng-model=\"User.UserType\"\r\n            style=\"text-transform: capitalize;\"\r\n            ng-change=\"userTypeChanged()\"\r\n          >\r\n            <option ng-repeat=\" item in MUserType\" value=\"{{ item.key }}\">{{ item.name }}</option>\r\n          </select>\r\n        </div>\r\n      </div>\r\n      <div ng-if=\"User.UserType == \'advocate\'\">\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label\" for=\"email\">Organization Name</label>\r\n          <div mass-autocomplete>\r\n            <input\r\n              ng-model=\"User.organization_name\"\r\n              ng-blur=\"checkExists();\"\r\n              mass-autocomplete-item=\"org_autocomplete_options\"\r\n																			class=\"blackText\"\r\n            />\r\n          </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label\" for=\"email\">Website for organization</label>\r\n            <div class=\"controls\">\r\n              <input\r\n              type=\"text\"\r\n              ng-model=\"User.organization.web_url\"\r\n              ng-disabled=\"User.organization._id\"\r\n              data-errormessage-custom-error=\"Invalid URL.\"\r\n              data-errormessage=\"Website for organization is required.\"\r\n              class=\"form-control input-md  validate[required, custom[url]] text-input\"\r\n            />\r\n          </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"email\"\r\n            >Phone number of organization (xxx)xxx-xxxx</label>\r\n              <div class=\"controls\">\r\n                <input\r\n              type=\"tel\"\r\n              ng-model=\"User.organization.phone_no\"\r\n              ng-disabled=\"User.organization._id\"\r\n              data-errormessage=\"Phone number of organization is required.\"\r\n              class=\"form-control input-md  validate[required] text-input\"\r\n            />\r\n          </div>\r\n              </div>\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label\" for=\"email\">Your extension number (if any)</label>\r\n                <div class=\"controls\">\r\n                  <!-- <input type=\"text\" ng-model=\"User.extention_no\" data-errormessage=\"Phone is required.\" class=\"form-control input-md text-input\" class=\"validation[required] text-input\"> -->\r\n                  <input\r\n              type=\"tel\"\r\n              ng-model=\"User.extention_no\"\r\n              class=\"form-control input-md text-input\"\r\n            />\r\n          </div>\r\n                </div>\r\n              </div>\r\n              <div ng-if=\"User.UserType == \'press\'\">\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label\" for=\"email\">Name of Press outlet</label>\r\n                  <div mass-autocomplete>\r\n                    <input\r\n              ng-model=\"User.outlet_name\"\r\n              ng-blur=\"checkExists();\"\r\n              mass-autocomplete-item=\"org_autocomplete_options\"\r\n            />\r\n          </div>\r\n                  </div>\r\n                  <div class=\"control-group\">\r\n                    <label class=\"control-label\" for=\"email\">Website for press outlet</label>\r\n                    <div class=\"controls\">\r\n                      <input\r\n              type=\"text\"\r\n              ng-model=\"User.outlet_web\"\r\n              ng-disabled=\"User.organization._id\"\r\n              data-errormessage-custom-error=\"Invalid URL.\"\r\n              data-errormessage=\"Website for press outlet is required.\"\r\n              class=\"form-control input-md  validate[required, custom[url]] text-input\"\r\n            />\r\n          </div>\r\n                    </div>\r\n                    <div class=\"control-group\">\r\n                      <label class=\"control-label\" for=\"email\"\r\n            >Phone number of press outlet (xxx)xxx-xxxx</label>\r\n                      <div class=\"controls\">\r\n                        <input\r\n              type=\"tel\"\r\n              ng-model=\"User.outlet_phone_no\"\r\n              ng-disabled=\"User.organization._id\"\r\n              data-errormessage=\"Phone number of press outlet is required.\"\r\n              class=\"form-control input-md  validate[required] text-input\"\r\n            />\r\n          </div>\r\n                      </div>\r\n                      <div class=\"control-group\">\r\n                        <label class=\"control-label\" for=\"email\">Your extension number (if any)</label>\r\n                        <div class=\"controls\">\r\n                          <input\r\n              type=\"text\"\r\n              ng-model=\"User.press_extension_no\"\r\n              class=\"form-control input-md text-input\"\r\n            />\r\n          </div>\r\n                        </div>\r\n                      </div>\r\n\r\n                      <div style=\"clear: both;\"></div>\r\n                      <br />\r\n                      <button\r\n        ng-click=\"LoginWithFacebook()\"\r\n        type=\"button\"\r\n        class=\"btn btn-primary\"\r\n        style=\"float: left;\"\r\n      >\r\n        Continue To Sign Up Using Facebook\r\n      </button>\r\n                      <div style=\"clear: both;\"></div>\r\n                      <p ng-if=\"!HideRegisterButton && !HideNewRegisterButton\">\r\n                        <button ng-click=\"ShowFB()\" type=\"button\" class=\"btnB275\" style=\"float: left;\">\r\n          Regular Signup\r\n        </button>\r\n                      </p>\r\n    </fieldset>\r\n  </div>\r\n</div>\r\n\r\n\r\n<script type=\"text/javascript\">\r\n  jQuery(document).ready(function () {\r\n    // binds form submission and fields to the validation engine\r\n    // binds form submission and fields to the validation engine\r\n    setTimeout(function () {\r\n      $(\'form\').validationEngine();\r\n    }, 500);\r\n  });\r\n</script>");
$templateCache.put("app/fiveminsignin/signin.html","<div class=\"voter-signup\">\r\n\r\n  <!-- <a href=\"#!/welcome\"><img class=\"choice\" ng-src=\"../assets/images/votewiseTop.svg\" alt=\"VoteWise\" /></a> -->\r\n\r\n  <!--<h3 style=\"padding-left: 215px;\">In order to match you with your local politicians, we need to know where you live. </h3>-->\r\n  <br>\r\n  <div class=\"signin-margin\">\r\n    <div class=\"alert alert-danger\" ng-show=\"Errors.length>0\" role=\"alert\" ng-repeat=\"error in Errors\">\r\n      {{error}}\r\n    </div>\r\n    <form name=\"signupform\" id=\"signInform\" ng-show=\"!showPasswordReset\">\r\n      <fieldset class=\"scheduler-border\">\r\n        <legend class=\"scheduler-border\">Sign In</legend>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"UserName\">UserName</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"UserName\" placeholder=\"\"\r\n                                    data-errormessage=\"UserName is required.\" class=\"form-control input-md validate[required] text-input\">\r\n                            </div>\r\n              </div>\r\n\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label\" for=\"password\">Password</label>\r\n                <div class=\"controls\">\r\n                  <input type=\"password\" id=\"password\" ng-model=\"Password\" placeholder=\"\"\r\n                                    data-errormessage=\"Password is required.\" class=\"form-control input-md validate[required] text-input\" />\r\n                            </div>\r\n                </div>\r\n              </div>\r\n\r\n              <div style=\"clear: both;\"></div>\r\n              <div style=\"margin-top: 10px;\">\r\n                <button ng-click=\"AuthenticateUser()\" type=\"submit\" class=\"btnB275\" style=\"float: right;\">Sign In</button>\r\n                <!--<fb:login-button scope=\"public_profile,email\" onlogin=\"checkLoginState();\">\r\n                            </fb:login-button>-->\r\n                <div style=\"clear: both;\"></div>\r\n              </div>\r\n              <div style=\"clear: both;\"></div>\r\n              <!-- <div style=\"width: 55%; margin-top: 10px; float: right; margin-right: 17px;\">\r\n                        <button ng-click=\"OpenLoginPopup()\" type=\"button\" class=\"btnB275\" style=\"float: right;\">\r\n                            <i class=\"fa fa-facebook-square\" aria-hidden=\"true\"></i> Sign In With FaceBook</button>\r\n                       <fb:login-button scope=\"public_profile,email\" onlogin=\"checkLoginState();\">\r\n                            </fb:login-button>\r\n                        <div style=\"clear: both;\"></div>\r\n                    </div> -->\r\n              <div style=\"clear: both;\"></div>\r\n              <div style=\"float: right;margin-top: 7px;\">Don\'t have an account. Please\r\n                <a style=\"text-decoration: underline;\" href=\"#!/signup/voter\" class=\"ylink\" >Sign Up here</a></div>\r\n              <div style=\"float: right;margin-top: 7px;\">Forgot password. Don\'t worry!\r\n                <a style=\"text-decoration: underline;\" href=\"javascript: void(0)\" ng-click=\"showPasswordReset = true;\" class=\"ylink\">Click here</a>\r\n              </div>\r\n            </div>\r\n\r\n      </fieldset>\r\n    </form>\r\n\r\n\r\n    <form name=\"forgotPassForm\" id=\"forgotPassForm\" ng-show=\"showPasswordReset\">\r\n      <fieldset class=\"scheduler-border\">\r\n        <legend class=\"scheduler-border\">Forgot Password</legend>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"UserName\">Email</label>\r\n              <div class=\"controls\">\r\n                <input type=\"email\" ng-model=\"forgotEmail\" placeholder=\"\"\r\n                                    data-errormessage=\"Email is required.\" class=\"form-control input-md validate[required] text-input\">\r\n                            </div>\r\n              </div>\r\n\r\n              <!-- <div class=\"control-group\">\r\n                            <label class=\"control-label\" for=\"password\">Password</label>\r\n                            <div class=\"controls\">\r\n                                <input type=\"password\" id=\"forgotPassword\" ng-model=\"forgotPassword\" placeholder=\"\"\r\n                                    data-errormessage=\"Password is required.\" class=\"form-control input-md validate[required] text-input\" />\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div class=\"controls\">\r\n                            <label class=\"control-label\" for=\"confirm_password\">Confirm password</label>\r\n                            <input type=\"password\" id=\"confirm_password\" ng-model=\"ConfirmPassword\"\r\n                                data-errormessage=\"Password and Confirm password do not match.\" placeholder=\"\" class=\"form-control input-md  validate[required,equals[forgotPassword]] text-input \"/>\r\n                            <small id=\"message\"></small>\r\n                        </div> -->\r\n            </div>\r\n\r\n            <div style=\"clear: both;\"></div>\r\n            <div style=\"width: 55%; margin-top: 10px; float: right; margin-right: 17px;\">\r\n              <button ng-click=\"requestPasswordReset()\" type=\"submit\" class=\"btn btn-success\" style=\"float: right;\">OK</button>\r\n              <button ng-click=\"showPasswordReset = false;\" type=\"submit\" class=\"btn btn-success\" style=\"float: right;\">Cancel</button>\r\n              <!--<fb:login-button scope=\"public_profile,email\" onlogin=\"checkLoginState();\">\r\n                            </fb:login-button>-->\r\n              <div style=\"clear: both;\"></div>\r\n            </div>\r\n            <div style=\"clear: both;\"></div>\r\n          </div>\r\n\r\n      </fieldset>\r\n    </form>\r\n\r\n    <center class=\"fwb mb10\" ng-if=\"$root.statusAuthenticate == 1\">Signing in...</center>\r\n  </div>\r\n</div>\r\n\r\n<script type=\"text/javascript\">\r\n  jQuery(document).ready(function () {\r\n    // binds form submission and fields to the validation engine\r\n    // binds form submission and fields to the validation engine\r\n    $(\"form\").validationEngine();\r\n  });\r\n\r\n</script>\r\n");
$templateCache.put("app/fiveminsignin/user-info-popup.html","<div class=\"voter-signup\">\r\n\r\n\r\n    <!--<h3 style=\"padding-left: 215px;\">In order to match you with your local politicians, we need to know where you live. </h3>-->\r\n    <div class=\"alert alert-danger\" ng-show=\"Errors.length>0\" role=\"alert\" ng-repeat=\"error in Errors\">\r\n        {{error}}\r\n    </div>\r\n    <form name=\"userinfoform\" >\r\n        <fieldset class=\"scheduler-border\">\r\n            <a href=\"javascript://\" ng-click=\"cancel()\"><div style=\"float: right;margin-top: -63px;\">x</div></a>\r\n            <legend class=\"scheduler-border\">To continue we need some nucessary information from you.</legend>\r\n            <div class=\"row\">\r\n                <div class=\"col-md-12\">\r\n                    <div class=\"control-group\">\r\n                        <label class=\"control-label\" for=\"UserName\">What type of user you are?</label>\r\n                        <div class=\"controls\">\r\n                            <select type=\"text\" ng-model=\"$parent.UserType\" \r\n                                placeholder=\"\" required class=\"form-control input-md\">\r\n                                <option value=\"Voter\">Voter</option>\r\n                                <option value=\"Advocate\">Organization</option>\r\n                                <option value=\"Press\">Press</option>\r\n                                <option value=\"Politician\">Politician</option>\r\n                            </select>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"control-group\">\r\n                        <label class=\"control-label\" for=\"password\">Please provide your zip code</label>\r\n                        <div class=\"controls\">\r\n                            <input type=\"text\" id=\"zipcode\" ng-model=\"$parent.ZipCode\" \r\n                               placeholder=\"\" class=\"form-control input-md\" required/>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n\r\n                <div style=\"clear: both;\"></div>\r\n                <div class=\"btn-style\">\r\n                    <button ng-click=\"LoginWithFacebook()\" ng-disabled=\"userinfoform.$invalid\" type=\"button\" class=\"btn btn-primary\" style=\"float: right;\">Continue To Facebook Sign In</button>\r\n                    <!--<fb:login-button scope=\"public_profile,email\" onlogin=\"checkLoginState();\">\r\n                            </fb:login-button>-->\r\n                    <div style=\"clear: both;\"></div>\r\n                </div>\r\n\r\n            </div>\r\n\r\n        </fieldset>\r\n    </form>\r\n</div>\r\n\r\n ");
$templateCache.put("app/fivemin_match/fivemin_match.html","<update-title title=\"Votewise\"></update-title>\r\n<update-meta property=\"og:title\" content=\"{{ fivefb.title }}\"></update-meta>\r\n<update-meta property=\"og:description\" content=\"{{ fivefb.description }}\"></update-meta>\r\n<update-meta property=\"og:image\" content=\"{{ fivefb.fbFiveImage }}\"></update-meta>\r\n<style type=\"text/css\">\r\n  .digDeeperSmall {\r\n    width: 150px;\r\n  }\r\n</style>\r\n<div class=\"applyBgImage\">\r\n  <div class=\"container-fluid \" id=\"fiveMinConatiner\">\r\n    <center>\r\n      <div ng-if=\"flagSkipAnsweredQuestion && isShowCheckBx \">\r\n        <label ng-if=\"!showZipCode\">\r\n          <input type=\"checkbox\" ng-model=\"flagSkipAnsweredQuestion\" ng-change=\"skipAnswerChagne()\"> Skip Answered Questions\r\n        </label>\r\n      </div>\r\n      </center>\r\n    <div id=\"fiveMinPage\" ng-show=\"questions[currentIndex] && !showZipCode\">\r\n      <div id=\"DisplayQ\" ng-if=\"oldQuestions.length > 0\">\r\n        <button ng-click=\"goBack();\" class=\"btnR\">Return to 5 minute match up</button>\r\n        <div>\r\n          <p>\r\n            <h1>\r\n              <center>{{category.title}}</center>\r\n            </h1>\r\n          </p>\r\n          <p></p>\r\n          <div>\r\n            <center ng-if=\"category.fbImage\">\r\n              <img ng-src=\"https://api.votewise.net/resources/{{category.fbImage}}\" class=\"wibble\" /></center>\r\n          </div>\r\n          <center id=\"DisplayC\">\r\n            <h4 class=\"backgroundText\">BACKGROUND</h4>\r\n          </center>\r\n          <p></p>\r\n          <div class=\"row d-flex justify-content-center\">\r\n            <div class=\"col-lg-10 col-sm-12 \">\r\n              <p ng-bind-html=\"category.description | newlines\"></p>\r\n            </div>\r\n            <div ng-if=\"status.category == 1\" class=\"fwb\">\r\n              Loading category ...\r\n            </div>\r\n            <div ng-if=\"status.category == 3\" class=\"fwb\">\r\n              Something went wrong while loading category.\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div ng-if=\"frontRunners && frontRunners.length > 0\">\r\n        <div class=\"control-group front-drop\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Select Front Runner To Answer For</label>\r\n          <select ng-model=\"isUser.selected\" style=\"text-transform: capitalize;display: block;\" ng-options=\"item as item.name for item in frontRunners\" ng-change=\"setUserId()\" class=\"changeTextColor form-control \">\r\n        </select>\r\n        </div>\r\n      </div>\r\n\r\n      <div id=\"DisplayQ1\" class=\"row  d-flex justify-content-center\">\r\n\r\n\r\n\r\n							<div class=\"row d-flex justify-content-center\">\r\n    <div class=\"col col-lg-9 col-med-12 col-sm-12 col-12 colPadding1\">\r\n      <div class=\"row\">\r\n\r\n\r\n							      <div class=\"col-lg-12 col-sm-12 learnHeader\" ng-if=\"oldQuestions.length == 0 && currentIndex ==0\">\r\n              <img ng-src=\"./assets/images/5minQuizIcon.jpg\" class=\"blockInfoImgLearn img-fluid\" style=\"position:relative; z-index: 2;\">\r\n              <div class=\"blockInfoNoLink\" style=\"background-color: #faeed2;\">\r\n\r\n                <div>\r\n                  <h5 class=\"blockTitle\">INSTRUCTIONS</h5>\r\n                  <span class=\"blockDesc\">\r\n\r\n<p>Comment on anything you wish, but your answer to the DISAGREE/AGREE scale should refer to the OPINION section not the FACTS section (if there is one).</p><p><span style=\"text-decoration: underline\">NOTE</span> : This quiz might take you longer than 5 minutes, but you can skip to the end after answering at least 5 questions if you don’t care about the accuracy of your matches.</p>\r\n\r\n                </span>\r\n              </div>\r\n\r\n														</div><br></div>\r\n					</div></div></div>\r\n\r\n\r\n        <div class=\"col-lg-7 col-sm-12 \">\r\n          <h4 class=\"text-center\">Questions</h4>\r\n\r\n          <div style=\"display: block; text-align: center;\">\r\n            <button type=\"button\" id=\"skipMatch\"  class=\"skipMatch\" ng-click=\"skipToMatch()\">Skip To Results</button>\r\n          </div>\r\n\r\n\r\n          <div class=\"card customCard\">\r\n            <div class=\"card-header quesCardHeaderMain\">\r\n              <div class=\"d-flex justify-content-between bd-highlight\">\r\n                <!-- <div class=\"p-2 bd-highlight quesCardHeader\">Statement</div> -->\r\n                <div class=\"p-2 bd-highlight\"><span class=\"textYellow\">{{currentIndex+1}}</span>/{{questions.length}}\r\n                </div>\r\n\r\n                <div id=\"anchor 1\" class=\"form-check anchor\">\r\n                  <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"defaultCheck1\" ng-model=\"flagSkipAnsweredQuestion\" ng-change=\"skipAnswerChagne()\">\r\n                  <label class=\"form-check-label checkboxLabel\" for=\"defaultCheck1\">\r\n                    Skip Answered Questions\r\n                  </label>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"card-body customCardBody\">\r\n													<p  class=\"card-text\" ng-bind-html=\"questions[currentIndex].content | newlines\"></p>\r\n              <div class=\"row vdivide\"  ng-if=\"!questions[currentIndex].isEssayQue\">\r\n                <div class=\"col col-6\">\r\n                  <div class=\"rcontent\" style=\"float:right;\">\r\n                    <span id=\"disagreeText\">DISAGREE &nbsp</span>\r\n                    <div style=\"float:right;\">\r\n                      <div class=\"box\">\r\n                        <ul class=\"vi-radio\">\r\n                          <li>\r\n                            <input type=\"radio\" id=\"agreedisagree-id6\" name=\"agreeDisagree\" value=\"6\" ng-model=\"$parent.answer\" ng-checked=\"checkIfExists(6)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                            <label for=\"agreedisagree-id6\"></label>\r\n                            <div class=\"checknew red sixth\"></div>\r\n                          </li>\r\n                        </ul>\r\n                      </div>\r\n                      <div class=\"box\">\r\n                        <ul class=\"vi-radio\">\r\n                          <li>\r\n                            <input type=\"radio\" id=\"agreedisagree-id5\" name=\"agreeDisagree\" value=\"5\" ng-model=\"$parent.answer\" ng-checked=\"checkIfExists(5)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                            <label for=\"agreedisagree-id5\"></label>\r\n                            <div class=\"checknew five fifth\"></div>\r\n                          </li>\r\n                        </ul>\r\n                      </div>\r\n                      <div class=\"box\">\r\n                        <ul class=\"vi-radio\">\r\n                          <li>\r\n                            <input type=\"radio\" id=\"agreedisagree-id4\" name=\"agreeDisagree\" value=\"4\" ng-model=\"$parent.answer\" ng-checked=\"checkIfExists(4)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                            <label for=\"agreedisagree-id4\"></label>\r\n                            <div class=\"checknew four forth\"></div>\r\n                          </li>\r\n                        </ul>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col col-6\">\r\n                  <div class=\"radio-container rcontent\">\r\n                    <span  style=\"color: #04A752; font-weight: bold;\">&nbsp;AGREE</span>\r\n                    <div style=\"float:left;\">\r\n                      <div class=\"box\">\r\n                        <ul class=\"vi-radio\">\r\n                          <li>\r\n                            <input type=\"radio\" id=\"agreedisagree-id3\" name=\"agreeDisagree\" value=\"3\" ng-model=\"$parent.answer\" ng-checked=\"checkIfExists(3)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                            <label for=\"agreedisagree-id3\"></label>\r\n                            <div class=\"checknew three third\"></div>\r\n                          </li>\r\n                        </ul>\r\n                      </div>\r\n                      <div class=\"box\">\r\n                        <ul class=\"vi-radio\">\r\n                          <li>\r\n                            <input type=\"radio\" id=\"agreedisagree-id2\" name=\"agreeDisagree\" value=\"2\" ng-model=\"$parent.answer\" ng-checked=\"checkIfExists(2)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                            <label for=\"agreedisagree-id2\"></label>\r\n                            <div class=\"checknew two second\"></div>\r\n                          </li>\r\n                        </ul>\r\n                      </div>\r\n                      <div class=\"box\">\r\n                        <ul class=\"vi-radio\">\r\n                          <li>\r\n                            <input type=\"radio\" id=\"agreedisagree-id1\" name=\"agreeDisagree\" value=\"1\" ng-model=\"$parent.answer\" ng-checked=\"checkIfExists(1)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                            <label for=\"agreedisagree-id1\"></label>\r\n                            <div class=\"checknew first\"></div>\r\n                          </li>\r\n                        </ul>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n<div class=\"card card1\" ng-if=\"questions[currentIndex].isEssayQue\">\r\n            <div class=\"card-header card1Header\">\r\n              <p class=\"card-title\">Write Your Answers</p>\r\n            </div>\r\n\r\n            <div class=\"card-body card1Body\">\r\n              <textarea class=\"form-control addComment\" ng-model=\"quizAns.shortAns\" maxlength=\"300\"  placeholder=\"Short Answer (300 Characters are Allowed)\"></textarea>\r\n              <br>\r\n               <textarea class=\"form-control addComment\" ng-model=\"quizAns.mediAns\" maxlength=\"2000\"  placeholder=\"Medium Answer (2000 Characters are Allowed)\"></textarea>\r\n               <br>\r\n                <textarea class=\"form-control addComment\" ng-model=\"quizAns.longAns\" rows=\"8\" maxlength=\"15000\"  placeholder=\"Long Answer (15000 Characters are Allowed)\"></textarea>\r\n                <br>\r\n            </div>\r\n          </div>\r\n          <!-- check ans {{answer}} checkImp {{importance}} -->\r\n          <div class=\"card card1\" ng-if=\"!questions[currentIndex].isEssayQue\">\r\n            <div class=\"card-header card1Header\">\r\n              <p class=\"card-title\">ADD COMMENT</p>\r\n            </div>\r\n\r\n            <div class=\"card-body card1Body\">\r\n              <textarea class=\"form-control addComment\" ng-model=\"updata.comment\" rows=\"1\" placeholder=\"(not required)\"></textarea>\r\n              <textarea ng-if=\"dis\" ng-model=\"updata.reason\" id=\"txtReason\" name=\"txtReason\" class=\"vi-textarea\" placeholder=\"REASON TO CHANGE ANSWER\" style=\"margin-top: 10px;\"></textarea>\r\n            </div>\r\n          </div>\r\n\r\n\r\n          <div class=\"card card1\" ng-if=\"!questions[currentIndex].isEssayQue\">\r\n            <div class=\"card-header card1Header\">\r\n              <p class=\"card-title\">IMPORTANCE</p>\r\n            </div>\r\n            <div class=\"card-body card1Body\" style=\"margin:0 auto;\">\r\n              <form class=\"impSection d-md-flex d-sm-block\">\r\n                <div class=\"A\">\r\n                  <input type=\"radio\" class=\"button\" id=\"importance-id1\" ng-model=\"$parent.importance\" ng-checked=\"checkImpExists(1)\" ng-click=\"oneMore(1); $event.stopPropagation();\" value=\"1\"></input>\r\n                  <label for=\"importance-id1\">Not Very</label>\r\n                </div>\r\n                <div class=\"B\">\r\n                  <input type=\"radio\" class=\"button\" id=\"importance-id2\" ng-model=\"$parent.importance\" ng-checked=\"checkImpExists(2)\"  ng-click=\"oneMore(2); $event.stopPropagation();\" value=\"2\"></input>\r\n                  <label for=\"importance-id2\">Somewhat</label>\r\n                </div>\r\n                <div class=\"C\">\r\n                  <input type=\"radio\" class=\"button\" id=\"importance-id3\" ng-model=\"$parent.importance\" ng-checked=\"checkImpExists(3)\"  ng-click=\"oneMore(3); $event.stopPropagation();\" value=\"3\"></input>\r\n                  <label for=\"importance-id3\">Very</label>\r\n                </div>\r\n                <!-- </div> -->\r\n              </form>\r\n            </div>\r\n          </div>\r\n\r\n\r\n\r\n\r\n          <div class=\"row\">\r\n            <div class=\"col bottomBtns\">\r\n              <div class=\"btn-group\" role=\"group\" aria-label=\"Default button group\">\r\n                <button type=\"button\" id=\"backBtn\" class=\"btn-transparent\" ng-click=\"prevQuestion()\"> <i class=\"fa fa-angle-left arrowIconBack\"></i> Back</button>\r\n                <button type=\"button\" id=\"skipBtn\" class=\"btn-transparent\" ng-click=\"skipQuestion()\">Skip</button>\r\n                <button type=\"button\" id=\"submitBtn\" class=\"btn-transparent\" ng-click=\"submitAnswer()\" ng-class=\"{\'activeSubmit\': (answer &&importance)}\">Submit <i class=\"fa fa-angle-right arrowIconSubmit\"></i></button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <center>\r\n            <button type=\"button\" id=\"btnY\" class=\"btn-transparent\" ng-if=\"oldQuestions.length == 0\" ng-click=\"digDeeper()\">More Questions on This Topic</button>\r\n            <br>\r\n            <div ng-if=\"oldQuestions.length > 0\">\r\n              <button ng-click=\"goBack();\" class=\"btnR\">Return to 5 minute match up</button> </div>\r\n            <!--  <div class=\"digDeeperSmall\" ng-if=\"oldQuestions.length == 0\"> <img ng-src=\"../assets/images/DigDeeper.svg\" ng-click=\"digDeeper()\" style=\"cursor: pointer;\" alt=\"Questions\" />&nbsp; &nbsp; <i ng-if=\"showDigDeeperLoader\" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i></div>  -->\r\n          </center>\r\n        </div>\r\n      </div>\r\n\r\n\r\n\r\n    </div>\r\n    <div class=\"news\" style=\"padding-top:20px;\" ng-if=\"showZipCode == true\">\r\n      <fieldset class=\"scheduler-border\">\r\n        <legend class=\"scheduler-border\">Where do you live?</legend>\r\n        <form name=\"fivemin\" id=\"fiveminzip\">\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel\">Street Address (LEAVE OUT APT #)<br>(This is used for location based tools like finding your representatives. Feel free to use an intersection instead of your actual address)</label>\r\n                <div class=\"control-group\">\r\n                  <input type=\"text\" id=\"address\" ng-model=\"User.Address\" ng-keyup=\"detectAddress($event)\" class=\"zipInput form-control\" />&nbsp;\r\n                </div>\r\n                </div>\r\n                <div ng-if=\"showAddressDropDown\">\r\n                  <div>\r\n                    <br>\r\n                    <span ng-if=\"address.state.state\" >State:</span><span>  {{address.state.state}}</span>\r\n                    <br>\r\n                    <span ng-if=\"address.state.statePostalCode\" >State Postal Code:</span><span>  {{address.state.statePostalCode}}</span>\r\n                    <br>\r\n                    <span ng-if=\"countyName[0].NAMELSAD\" >County:</span><span>  {{countyName[0].NAMELSAD}}</span>\r\n                    <br>\r\n                    <span ng-if=\"placeName[0].NAMELSAD\" >City:</span><span>  {{placeName[0].NAMELSAD}}</span>\r\n                    <br>\r\n                    <span ng-if=\"federalCongrassionalDist[0].CD115FP\" >Federal Congressional District: </span><span>  {{federalCongrassionalDist[0].CD115FP}}</span>\r\n                    <br>\r\n                    <span ng-if=\"unifiedSchoolDistrictNames[0].NAME\" >School District: </span><span>  {{unifiedSchoolDistrictNames[0].NAME}}</span>\r\n                    <br>\r\n                    <span ng-if=\"stateSenateDistrict[0].NAMELSAD\" >State Senate District:</span><span>  {{stateSenateDistrict[0].NAMELSAD}}</span>\r\n                    <br>\r\n                    <span ng-if=\"StateHouseOFRepresentativeDistricts[0].NAMELSAD\" >StateHouseOFRepresentativeDistricts:</span><span>  {{stateHouseOFRepresentativeDistricts[0].NAMELSAD}}</span>\r\n                    <br>\r\n                    <div ng-if=\"cityCouncilDistrict[0].COUNTDIST\">\r\n                   <span>City Council District Name </span> {{cityCouncilDistrict[0].COUNTDIST}}\r\n                    </div>\r\n                  </div>\r\n                    <!-- <div class=\"control-group\">\r\n                    <label class=\"control-label formLabel removeTopMargin\" for=\"email\">State </label>\r\n                    <div class=\"controls\">\r\n                      <select class=\"changeTextColor\" ng-model=\"address.state\" style=\"text-transform: capitalize;\" disabled=\"true\" ng-change=\"getCounties()\" ng-class=\"\" ng-options=\"item.state for item in states track by item.statePostalCode\"></select>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"control-group\">\r\n                    <label class=\"control-label formLabel\" for=\"email\">County </label>\r\n                    <div class=\"controls\">\r\n                      <select class=\"changeTextColor\" ng-model=\"address.county\" style=\"text-transform: capitalize;\" disabled=\"true\" ng-options=\"item.county for item in allcounties track by item.countyFips\" ng-change=\"onCountyChange()\"></select>\r\n                    </div>\r\n                  </div> -->\r\n                    <!--    <div class=\"control-group\">\r\n                <label class=\"control-label formLabel\" for=\"email\">Sub county </label>\r\n                <div class=\"controls\">\r\n                  <select class=\"changeTextColor\" ng-model=\"address.countySubdivision\" disabled=\"true\" style=\"text-transform: capitalize;\" ng-options=\"countySubdivision as item._id.countySubdivision for item in places | unique:\'_id.countySubdivision\' track by item._id.countySubdivision\" ng-change=\"onSubCountyChange()\"></select>\r\n                </div>\r\n              </div> -->\r\n                    <!-- <div class=\"control-group\">\r\n                    <label class=\"control-label formLabel\" for=\"email\">City </label>\r\n                    <div class=\"controls\">\r\n                      <select class=\"changeTextColor\" ng-model=\"address.place\" disabled=\"true\" style=\"text-transform: capitalize;\" ng-options=\"item as item.place for item in places track by item.place\"></select>\r\n                    </div>\r\n\r\n                  </div> -->\r\n                    <!--      <div class=\"control-group\">\r\n                <label class=\"control-label formLabel\" for=\"email\">Voter District (click if incorrect) </label>\r\n                <div class=\"controls\">\r\n                  <select class=\"changeTextColor\" ng-model=\"address.voterDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item.voterDistrictName for item in voterDistricts track by item.voterDistrictName\" ng-change=\"onVoterDistChange()\" ng-class=\"{yellowBackground: voterDistricts.length > 1}\"></select>\r\n                </div>\r\n              </div> -->\r\n                    <!-- <div class=\"control-group\">\r\n                    <label class=\"control-label formLabel\" for=\"email\">Federal Congressional District (click if incorrect) </label>\r\n                    <div class=\"controls\">\r\n                      <select class=\"changeTextColor\" ng-model=\"address.federalCongrassionalDist\" style=\"text-transform: capitalize;\" ng-options=\"item as item.CD115FP for item in federalCongrassionalDist track by item.CD115FP\" ng-class=\"checkLength(federalCongrassionalDist, \'federalCongrassionalDist\')\"></select>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"control-group\">\r\n                    <label class=\"control-label formLabel\" for=\"email\">State Senate District (click if incorrect) </label>\r\n                    <div class=\"controls\">\r\n                      <select class=\"changeTextColor\" ng-model=\"address.stateSenateDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item.NAMELSAD for item in stateSenateDistrict track by item.SLDUST\" ng-class=\"checkLength(stateSenateDistrict, \'stateSenateDistrict\')\"></select>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"control-group\">\r\n                    <label class=\"control-label formLabel\" for=\"email\">State House of Representative District (click if incorrect) </label>\r\n                    <div class=\"controls\">\r\n                      <select class=\"changeTextColor\" ng-model=\"address.stateHouseOFRepresentativeDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item.NAMELSAD for item in stateHouseOFRepresentativeDistricts track by item.NAMELSAD\" ng-class=\"checkLength(stateHouseOFRepresentativeDistricts, \'stateHouseOFRepresentativeDistrict\')\"></select>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"control-group\">\r\n                    <label class=\"control-label formLabel\" for=\"email\">School District Name (click if incorrect) </label>\r\n                    <div class=\"controls\">\r\n                      <select class=\"changeTextColor\" ng-model=\"address.unifiedSchoolDistrictName\" style=\"text-transform: capitalize;\" ng-options=\"item as item.NAME for item in unifiedSchoolDistrictNames track by item.NAME\" ng-class=\"checkLength(unifiedSchoolDistrictNames, \'unifiedSchoolDistrictName\')\"></select>\r\n                    </div>\r\n                  </div> -->\r\n                    <br>\r\n                    <!-- <div class=\"control-group\">\r\n                      <p>\r\n                        Don\'t know your info?\r\n                        <a href=\"javascript: void(0);\" ng-click=\"showFindAddress();\" class=\"ylink\">Click Here</a>\r\n                      </p>\r\n                    </div> -->\r\n                    <div style=\"clear: both;\"></div>\r\n                    <button class=\"btnShort-style\" ng-click=\"confirmPopup()\" type=\"button\" class=\"btn btn-success\" style=\"float: right;\">Done</button>\r\n                    <div style=\"clear: both;\"></div>\r\n                    <div style=\"float: right; margin-right: 20px; margin-top: 7px;\">Already a member?\r\n                      <a style=\"text-decoration: underline;\" href=\"#!/fiveminsignin\" class=\"ylink\">Sign in</a></div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n        </form>\r\n      </fieldset>\r\n    </div>\r\n  </div>\r\n");
$templateCache.put("app/followersGroupAnswer/followersGroupAnswer.html","<div class=\"container-fluid\" ng-controller=\"showGroupAnswerCtrl\">\r\n  <p>Followers Answers</p>\r\n  <h5>Answer</h5>\r\n  <div ng-if=\"showPoliAnswerDetails\">\r\n    <div>\r\n      <!--     <a href=\"\" class=\"ylink\" style=\"padding-left: 10%\" ng-click=\"back()\">Back</a>  -->\r\n    </div>\r\n    <div class=\"hideCell\">\r\n      <fieldset class=\"scheduler-border\">\r\n        <legend class=\"scheduler-border\">Answers</legend>\r\n\r\n        <div class=\"questionAnswersBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\" style=\"width: 100%\">\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n              <br>\r\n              <div ng-repeat=\"com in globalArray[queId] track by $index\">\r\n                <div class=\"pad10\">\r\n                  <!-- <span ng-if=\"com.author.username && com.author.userType != \'voter\'\">Name:</span>\r\n                <a href=\"#!/publicProfile/{{com.author._id}}\" class=\"link\" ng-if=\"com.author.username && com.author.userType != \'voter\'\"> {{com.author.username}}</a> -->\r\n                  <span >Name:</span>\r\n                  <a href=\"#!/publicProfile/{{com.author._id}}\" class=\"link\" ng-if=\"com.author.userType == \'politician\'\" style=\"text-transform: capitalize;\"><img src=\"../assets/images/profile/politician.svg\" class=\"UserTypeImg\" alt=\"Politician\" /> {{com.author.name}}</a>\r\n                  <a href=\"#!/pressProfile/{{com.author._id}}\" class=\"link\" ng-if=\"com.orgName\" style=\"text-transform: capitalize;\"> <img src=\"../assets/images/profile/advocate.svg\" class=\"UserTypeImg\" alt=\"Organization\" />{{com.orgName}}</a>\r\n                  <a href=\"#!/pressProfile/{{com.author._id}}\" class=\"link\" ng-if=\"com.author.name && com.author.userType != \'voter\' && com.author.userType != \'politician\' && !com.orgName\" style=\"text-transform: capitalize;\"> {{com.author.name}}</a>\r\n                  <a href=\"#!/voterProfile/{{com.author._id}}\" class=\"link\" ng-if=\"com.author.name && com.author.userType == \'voter\'\" style=\"text-transform: capitalize;\"><img src=\"../assets/images/profile/voter.svg\" class=\"UserTypeImg\" alt=\"Voter\"  />{{com.author.username}}</a>\r\n                  <br>\r\n                  <span>Answer</span>\r\n                  <br>\r\n                  <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n\r\n                    <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n                      style=\"padding-left: 8px;  line-height: 15px\">\r\n                      <span class=\"inl-blk pull-left\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n                      <div class=\"cq-box inl-blk pull-left\"\r\n                        ng-class=\"(com.answer == i) ? getComapreClass(com.match, i) : \'\'\"></div>\r\n                      <span class=\"inl-blk\" ng-if=\"i == 6\" style=\"padding-left:8px\">DISAGREE</span>\r\n                    </div>\r\n                  </div>\r\n                  <br>\r\n                  <p></p>\r\n                  <span>IMPORTANCE</span>\r\n                  <br>\r\n                  <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n                    <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"padding-left: 8px; line-height: 9px\">\r\n                      <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n                      <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                      <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n                      <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                        ng-class=\"(com.importance == i) ? \'ag-blk\' : \'\'\"></div>\r\n                    </div>\r\n                  </div>\r\n                  <p></p>\r\n                  <div>\r\n                    <span ng-if=\"com.comment\">Comment:</span>\r\n                    <span ng-if=\"com.comment\">{{com.comment}}</span>\r\n                  </div>\r\n                  <hr style=\"\r\n                margin-left: auto;\r\n                margin-right: auto;\r\n                height: 1px;\r\n                background-color:#666;\r\n                opcaity: 0.5;\">\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </fieldset>\r\n\r\n      <div ng-if=\"showUserAnswerDetails\">\r\n        <div>\r\n          <!--      <a href=\"\" class=\"ylink\" style=\"padding-left: 10%\" ng-click=\"back()\">Back</a> -->\r\n        </div>\r\n        <fieldset class=\"scheduler-border\">\r\n          <legend class=\"scheduler-border\">Answers</legend>\r\n          <div class=\"questionAnswersBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\"\r\n            style=\"width: 100%\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-12\">\r\n                <br>\r\n                <div ng-repeat=\"item in unVeriCommNew[queId] track by $index\">\r\n                  <div class=\"pad10\">\r\n                    <span ng-if=\"item.answer\">Name: </span><b>Unregistered User {{$index+1}}</b>\r\n                    <br>\r\n                    <span>Answer</span>\r\n                    <br>\r\n                    <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n                      <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n                        style=\"padding-left: 8px;  line-height: 15px\">\r\n                        <span class=\"inl-blk pull-left\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n                        <div class=\"cq-box inl-blk pull-left\"\r\n                          ng-class=\"(item.answer == i) ? getComapreClass(item.match, i) : \'\'\"></div>\r\n                        <span class=\"inl-blk\" ng-if=\"i == 6\" style=\"padding-left:8px\">DISAGREE</span>\r\n                      </div>\r\n                    </div>\r\n                    <br>\r\n                    <p></p>\r\n                    <span>IMPORTANCE</span>\r\n                    <br>\r\n                    <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n                      <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"padding-left: 8px;  line-height: 15px \">\r\n                        <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n                        <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                        <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n                        <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                          ng-class=\"(item.importance == i) ? \'ag-blk\' : \'\'\"></div>\r\n                      </div>\r\n                    </div>\r\n                    <p></p>\r\n                    <div>\r\n                      <span ng-if=\"item.comment\">Comment:</span>\r\n                      <span ng-if=\"item.comment\" style=\"font-size: 16px;font-weight: 200\">{{item.comment}}</span>\r\n                    </div>\r\n                    <hr style=\"\r\n                margin-left: auto;\r\n                margin-right: auto;\r\n                height: 1px;\r\n                background-color:#666;\r\n                opcaity: 0.5;\">\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </fieldset>\r\n      </div>\r\n    </div>\r\n    <div class=\"hideNonCell\">\r\n\r\n      <div class=\"questionAnswersBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\" style=\"width: 100%\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <br>\r\n            <div ng-repeat=\"com in globalArray[queId] track by $index\">\r\n              <div class=\"pad10\">\r\n                <!-- <span ng-if=\"com.author.username && com.author.userType != \'voter\'\">Name:</span>\r\n                <a href=\"#!/publicProfile/{{com.author._id}}\" class=\"link\" ng-if=\"com.author.username && com.author.userType != \'voter\'\"> {{com.author.username}}</a> -->\r\n               <span >Name:</span>\r\n                  <a href=\"#!/publicProfile/{{com.author._id}}\" class=\"link\" ng-if=\"com.author.userType == \'politician\'\" style=\"text-transform: capitalize;\"><img src=\"../assets/images/profile/politician.svg\" class=\"UserTypeImg\" alt=\"Politician\" /> {{com.author.name}}</a>\r\n                  <a href=\"#!/pressProfile/{{com.author._id}}\" class=\"link\" ng-if=\"com.orgName\" style=\"text-transform: capitalize;\"> <img src=\"../assets/images/profile/advocate.svg\" class=\"UserTypeImg\" alt=\"Organization\" />{{com.orgName}}</a>\r\n                  <a href=\"#!/pressProfile/{{com.author._id}}\" class=\"link\" ng-if=\"com.author.name && com.author.userType != \'voter\' && com.author.userType != \'politician\' && !com.orgName\" style=\"text-transform: capitalize;\"> {{com.author.name}}</a>\r\n                  <a href=\"#!/voterProfile/{{com.author._id}}\" class=\"link\" ng-if=\"com.author.name && com.author.userType == \'voter\'\" style=\"text-transform: capitalize;\"><img src=\"../assets/images/profile/voter.svg\" class=\"UserTypeImg\" alt=\"Voter\"  />{{com.author.username}}</a>\r\n                  <br>\r\n                <span>Answer</span>\r\n                <br>\r\n                <span style=\"float: left;\">AGREE</span>\r\n                <span style=\"float:right; padding-right: 20px;\">DISAGREE</span>\r\n                <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n                  <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n                    style=\"padding-left: 8px;  line-height: 15px\">\r\n                    <div class=\"cq-box inl-blk pull-left\"\r\n                      ng-class=\"(com.answer == i) ? getComapreClass(com.match, i) : \'\'\"></div>\r\n                  </div>\r\n                </div>\r\n                <br>\r\n                <p></p>\r\n                <span>IMPORTANCE</span>\r\n                <br>\r\n                <center>Not Very &nbsp;&nbsp;|&nbsp;&nbsp;Somewhat&nbsp;&nbsp;|&nbsp;&nbsp;Very</center>\r\n                <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n                  <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"padding-left: 8px; line-height: 9px\">\r\n\r\n                    <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                      ng-class=\"(com.importance == i) ? \'ag-blk\' : \'\'\"></div>\r\n                  </div>\r\n                </div>\r\n                <p></p>\r\n                <div>\r\n                  <span ng-if=\"com.comment\">Comment:</span>\r\n                  <span ng-if=\"com.comment\">{{com.comment}}</span>\r\n                </div>\r\n                <hr style=\"\r\n                margin-left: auto;\r\n                margin-right: auto;\r\n                height: 1px;\r\n                background-color:#666;\r\n                opcaity: 0.5;\">\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n\r\n      <div ng-if=\"showUserAnswerDetails\">\r\n        <div>\r\n          <!--      <a href=\"\" class=\"ylink\" style=\"padding-left: 10%\" ng-click=\"back()\">Back</a>  -->\r\n        </div>\r\n        <fieldset class=\"scheduler-border\">\r\n          <legend class=\"scheduler-border\">Answers</legend>\r\n          <div class=\"questionAnswersBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\"\r\n            style=\"width: 100%\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-12\">\r\n                <br>\r\n                <div ng-repeat=\"item in unVeriCommNew[queId] track by $index\">\r\n                  <div class=\"pad10\">\r\n                    <span ng-if=\"item.answer\">Name: </span><b>Unregistered User {{$index+1}}</b>\r\n                    <br>\r\n                    <span>Answer</span>\r\n                    <br><span style=\"float: left;\">AGREE</span>\r\n                    <span style=\"float:right; padding-right: 20px;\">DISAGREE</span>\r\n                    <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n                      <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n                        style=\"padding-left: 8px;  line-height: 15px\">\r\n                        <div class=\"cq-box inl-blk pull-left\"\r\n                          ng-class=\"(item.answer == i) ? getComapreClass(item.match, i) : \'\'\"></div>\r\n\r\n                      </div>\r\n                    </div>\r\n                    <br>\r\n                    <p></p>\r\n                    <span>IMPORTANCE</span>\r\n                    <br>\r\n                    <center>Not Very &nbsp;&nbsp;|&nbsp;&nbsp;Somewhat&nbsp;&nbsp;|&nbsp;&nbsp;Very</center>\r\n                    <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n                      <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"padding-left: 8px;  line-height: 15px \">\r\n\r\n                        <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                          ng-class=\"(item.importance == i) ? \'ag-blk\' : \'\'\"></div>\r\n                      </div>\r\n                    </div>\r\n                    <p></p>\r\n                    <div>\r\n                      <span ng-if=\"item.comment\">Comment:</span>\r\n                      <span ng-if=\"item.comment\" style=\"font-size: 16px;font-weight: 200\">{{item.comment}}</span>\r\n                    </div>\r\n                    <hr style=\"\r\n                margin-left: auto;\r\n                margin-right: auto;\r\n                height: 1px;\r\n                background-color:#666;\r\n                opcaity: 0.5;\">\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </fieldset>\r\n      </div>\r\n    </div>\r\n  </div>\r\n");
$templateCache.put("app/followersQuiz/followersQuiz.html","<div class=\"container-fluid\">\r\n  <div ng-if=\"!showZipCode\">\r\n    <h3 style=\"text-transform: capitalize;\" class=\"pageHeading\">organization Quiz</h3>\r\n    <h5 style=\"text-transform: capitalize;\" class=\"pageSubHeading\">{{orgInfo.title}}</h5>\r\n    <!-- Bring Back -->\r\n    <!-- <p ng-if=\"followersCnt\">\r\n      Followers:\r\n      <a href=\"#!/orgActivityDetails/followers\" class=\"ylink\">{{followersCnt}}</a>,</p> -->\r\n  </div>\r\n\r\n\r\n\r\n  <div id=\"fiveMinPage\" ng-show=\"questions[currentIndex] && !showZipCode\">\r\n    <p>\r\n      <h1>\r\n        <center>{{category.title}}</center>\r\n      </h1>\r\n    </p>\r\n    <p></p>\r\n    <div>\r\n      <center ng-if=\"category.fbImage\">\r\n        <img ng-src=\"https://api.votewise.net/resources/{{category.fbImage}}\" class=\"wibble\" /></center>\r\n    </div>\r\n    <center id=\"DisplayC\">\r\n      <h4 class=\"backgroundText\">BACKGROUND</h4>\r\n    </center>\r\n    <p></p>\r\n    <div class=\"row d-flex justify-content-center\">\r\n      <div class=\"col-lg-10 col-sm-12 \">\r\n        <p ng-bind-html=\"category.description | newlines\"></p>\r\n      </div>\r\n      <div ng-if=\"status.category == 1\" class=\"fwb\">\r\n        Loading category ...\r\n      </div>\r\n      <div ng-if=\"status.category == 3\" class=\"fwb\">\r\n        Something went wrong while loading category.\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div id=\"DisplayQ1\" class=\"row  d-flex justify-content-center\">\r\n  <!-- <center><label ng-hide=\"questions[currentIndex]\">\r\n      <input type=\"checkbox\" ng-model=\"flagSkipAnsweredQuestion\" ng-change=\"skipAnswerChagne()\"> Skip answered questions\r\n    </label></center> -->\r\n  <div class=\"col-lg-7 col-sm-12\">\r\n    <h4 class=\"text-center\" ng-hide=\"questions.length == 0\">Questions</h4>\r\n\r\n\r\n    <div class=\"card customCard\">\r\n      <div class=\"card-header quesCardHeaderMain\">\r\n        <div class=\"d-flex justify-content-between bd-highlight\">\r\n          <!-- <div class=\"p-2 bd-highlight quesCardHeader\">Statement</div> -->\r\n          <div ng-hide=\"questions.length == 0\" class=\"p-2 bd-highlight\">\r\n            <span class=\"textYellow\">{{currentIndex+1}}</span>/{{questions.length}}\r\n          </div>\r\n          <div class=\"form-check\" ng-if=\"showCheck\">\r\n            <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"shareWith\" ng-model=\"isShare\">\r\n            <label class=\"form-check-label checkboxLabel\" for=\"defaultCheck1\">\r\n                Share answer with <span style=\"text-transform: capitalize;\">{{orgInfo.title}}</span>\r\n                </label>\r\n          </div>\r\n          <div id=\"anchor 1\" class=\"form-check anchor\">\r\n            <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"defaultCheck1\" ng-model=\"flagSkipAnsweredQuestion\" ng-change=\"skipAnswerChagne()\">\r\n            <label class=\"form-check-label checkboxLabel\" for=\"defaultCheck1\">\r\n                  Skip Answered Questions\r\n                </label>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"card-body customCardBody\" ng-hide=\"questions.length == 0\">\r\n        <p  class=\"card-text\" ng-bind-html=\"questions[currentIndex].content | newlines\"></p>\r\n        <div class=\"row vdivide\">\r\n          <div class=\"col col-6\">\r\n            <div class=\"rcontent\" style=\"float:right;\">\r\n              <span id=\"disagreeText\">DISAGREE &nbsp</span>\r\n              <div style=\"float:right;\">\r\n                <div class=\"box\">\r\n                  <ul class=\"vi-radio\">\r\n                    <li>\r\n                      <input type=\"radio\" id=\"agreedisagree-id6\" name=\"agreeDisagree\" value=\"6\" ng-model=\"answer\" ng-checked=\"checkIfExists(6)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                      <label for=\"agreedisagree-id6\"></label>\r\n                      <div class=\"checknew red sixth\"></div>\r\n                    </li>\r\n                  </ul>\r\n                </div>\r\n                <div class=\"box\">\r\n                  <ul class=\"vi-radio\">\r\n                    <li>\r\n                      <input type=\"radio\" id=\"agreedisagree-id5\" name=\"agreeDisagree\" value=\"5\" ng-model=\"answer\" ng-checked=\"checkIfExists(5)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                      <label for=\"agreedisagree-id5\"></label>\r\n                      <div class=\"checknew five fifth\"></div>\r\n                    </li>\r\n                  </ul>\r\n                </div>\r\n                <div class=\"box\">\r\n                  <ul class=\"vi-radio\">\r\n                    <li>\r\n                      <input type=\"radio\" id=\"agreedisagree-id4\" name=\"agreeDisagree\" value=\"4\" ng-model=\"answer\" ng-checked=\"checkIfExists(4)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                      <label for=\"agreedisagree-id4\"></label>\r\n                      <div class=\"checknew four forth\"></div>\r\n                    </li>\r\n                  </ul>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"col col-6\">\r\n            <div class=\"radio-container rcontent\">\r\n              <span  style=\"color: #04A752; font-weight: bold;\">&nbsp;AGREE</span>\r\n              <div style=\"float:left;\">\r\n                <div class=\"box\">\r\n                  <ul class=\"vi-radio\">\r\n                    <li>\r\n                      <input type=\"radio\" id=\"agreedisagree-id3\" name=\"agreeDisagree\" value=\"3\" ng-model=\"answer\" ng-checked=\"checkIfExists(3)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                      <label for=\"agreedisagree-id3\"></label>\r\n                      <div class=\"checknew three third\"></div>\r\n                    </li>\r\n                  </ul>\r\n                </div>\r\n                <div class=\"box\">\r\n                  <ul class=\"vi-radio\">\r\n                    <li>\r\n                      <input type=\"radio\" id=\"agreedisagree-id2\" name=\"agreeDisagree\" value=\"2\" ng-model=\"answer\" ng-checked=\"checkIfExists(2)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                      <label for=\"agreedisagree-id2\"></label>\r\n                      <div class=\"checknew two second\"></div>\r\n                    </li>\r\n                  </ul>\r\n                </div>\r\n                <div class=\"box\">\r\n                  <ul class=\"vi-radio\">\r\n                    <li>\r\n                      <input type=\"radio\" id=\"agreedisagree-id1\" name=\"agreeDisagree\" value=\"1\" ng-model=\"answer\" ng-checked=\"checkIfExists(1)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                      <label for=\"agreedisagree-id1\"></label>\r\n                      <div class=\"checknew first\"></div>\r\n                    </li>\r\n                  </ul>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n\r\n    <div class=\"card card1\" ng-hide=\"questions.length == 0\">\r\n      <div class=\"card-header card1Header\">\r\n        <p class=\"card-title\">ADD COMMENT</p>\r\n      </div>\r\n      <div class=\"card-body card1Body\">\r\n        <textarea class=\"form-control addComment\" ng-model=\"updata.comment\" rows=\"1\" placeholder=\"(not required)\"></textarea>\r\n        <textarea ng-show=\"dis\" ng-model=\"updata.reason\" id=\"txtReason\" name=\"txtReason\" class=\"vi-textarea\" placeholder=\"REASON TO CHANGE ANSWER\" style=\"margin-top: 10px;\"></textarea>\r\n      </div>\r\n    </div>\r\n\r\n\r\n    <div class=\"card card1\" ng-hide=\"questions.length == 0\">\r\n      <div class=\"card-header card1Header\">\r\n        <p class=\"card-title\">IMPORTANCE</p>\r\n        <!-- <h4>Hello {{importance}}</h4> -->\r\n\r\n      </div>\r\n      <div class=\"card-body card1Body\" style=\"margin:0 auto;\">\r\n        <form class=\"impSection d-md-flex d-sm-block\">\r\n          <div class=\"A\">\r\n            <input type=\"radio\" class=\"button\" id=\"importance-id1\" ng-model=\"importance\" ng-checked=\"checkImpExists(1)\" ng-click=\"oneMore(1); $event.stopPropagation();\" value=\"1\"></input>\r\n            <label for=\"importance-id1\">Not Very</label>\r\n          </div>\r\n          <div class=\"B\">\r\n            <input type=\"radio\" class=\"button\" id=\"importance-id2\" ng-model=\"importance\" ng-checked=\"checkImpExists(2)\"  ng-click=\"oneMore(2); $event.stopPropagation();\" value=\"2\"></input>\r\n            <label for=\"importance-id2\">Somewhat</label>\r\n          </div>\r\n          <div class=\"C\">\r\n            <input type=\"radio\" class=\"button\" id=\"importance-id3\" ng-model=\"importance\" ng-checked=\"checkImpExists(3)\"  ng-click=\"oneMore(3); $event.stopPropagation();\" value=\"3\"></input>\r\n            <label for=\"importance-id3\">Very</label>\r\n          </div>\r\n          <!-- </div> -->\r\n        </form>\r\n      </div>\r\n    </div>\r\n\r\n\r\n\r\n    <div ng-if=\"showloader\" class=\"fwb\">\r\n      <p>\r\n        <center><i class=\"fa fa-refresh fa-spin\" style=\"font-size:72px;\"></i></center>\r\n      </p>\r\n    </div>\r\n    <div class=\"row\" ng-hide=\"questions.length == 0\">\r\n      <div class=\"col bottomBtns\">\r\n        <div class=\"btn-group\" role=\"group\" aria-label=\"Default button group\">\r\n          <button type=\"button\" id=\"backBtn\" class=\"btn-transparent\" ng-click=\"prevQuestion()\"> <i class=\"fa fa-angle-left arrowIconBack\"></i> Back</button>\r\n          <button type=\"button\" id=\"skipBtn\" class=\"btn-transparent\" ng-click=\"skipQuestion()\">Skip</button>\r\n          <button type=\"button\" id=\"submitBtn\" class=\"btn-transparent\" ng-click=\"submitAnswer()\" ng-class=\"{\'activeSubmit\': (answer &&importance)}\">Submit <i class=\"fa fa-angle-right arrowIconSubmit\"></i></button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n</div>\r\n<div class=\"news\" style=\"padding-top:20px;\" ng-if=\"showZipCode == true\">\r\n  <fieldset class=\"scheduler-border\">\r\n    <legend class=\"scheduler-border\">Where do you live?</legend>\r\n    <form name=\"fivemin\" id=\"fiveminzip\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\">Street Address (LEAVE OUT APT #)<br>(This is used for location based tools like finding your representatives. Feel free to use an intersection instead of your actual address)</label>\r\n            <div class=\"control-group\">\r\n              <input type=\"text\" id=\"address\" ng-model=\"User.Address\" ng-keyup=\"detectAddress($event)\" class=\"zipInput form-control\" />&nbsp;\r\n              </div>\r\n            </div>\r\n            <div ng-if=\"showAddressDropDown\">\r\n              <div>\r\n                <br>\r\n                <span ng-if=\"address.state.state\" >State:</span><span>  {{address.state.state}}</span>\r\n                <br>\r\n                <span ng-if=\"address.state.statePostalCode\" >State Postal Code:</span><span>  {{address.state.statePostalCode}}</span>\r\n                <br>\r\n                <span ng-if=\"countyName[0].NAMELSAD\" >County:</span><span>  {{countyName[0].NAMELSAD}}</span>\r\n                <br>\r\n                <span ng-if=\"placeName[0].NAMELSAD\" >City:</span><span>  {{placeName[0].NAMELSAD}}</span>\r\n                <br>\r\n                <span ng-if=\"federalCongrassionalDist[0].CD115FP\" >Federal Congressional District: </span><span>  {{federalCongrassionalDist[0].CD115FP}}</span>\r\n                <br>\r\n                <span ng-if=\"unifiedSchoolDistrictNames[0].NAME\" >School District: </span><span>  {{unifiedSchoolDistrictNames[0].NAME}}</span>\r\n                <br>\r\n                <span ng-if=\"stateSenateDistrict[0].NAMELSAD\" >State Senate District:</span><span>  {{stateSenateDistrict[0].NAMELSAD}}</span>\r\n                <br>\r\n                <span ng-if=\"StateHouseOFRepresentativeDistricts[0].NAMELSAD\" >StateHouseOFRepresentativeDistricts:</span><span>  {{stateHouseOFRepresentativeDistricts[0].NAMELSAD}}</span>\r\n                <br>\r\n                </div>\r\n                <br>\r\n                <div style=\"clear: both;\"></div>\r\n                <button class=\"btnShort-style\" ng-click=\"confirmPopup()\" type=\"button\" class=\"btn btn-success\" style=\"float: right;\">Done</button>\r\n                <div style=\"clear: both;\"></div>\r\n                <div style=\"float: right; margin-right: 20px; margin-top: 7px;\">Already a member?\r\n                  <a style=\"text-decoration: underline;\" href=\"#!/fiveminsignin\" class=\"ylink\">Sign in</a></div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n    </form>\r\n  </fieldset>\r\n</div>\r\n</div>\r\n");
$templateCache.put("app/followingUsers/followingUsers.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">FOLLOWING USERS</h2>\r\n  <p class=\"pageSubHeading\">This is the list of people, politicians, and organizations that you are currently following.\r\n    (Following makes it easier to find interesting videos, debates and more.)</p>\r\n  <!-- <div class=\"closeForm\" ng-include=\"\'app/popups/setting_Ctrl.html\'\"></div> -->\r\n  <form class=\"closeForm\">\r\n    <div class=\"row\" style=\"margin-top: 10px;\" class=\"blackText\">\r\n\r\n      <div style=\"float:right;\">\r\n        <dir-pagination-controls max-size=\"5\" pagination-id=\"list.id\"></dir-pagination-controls>\r\n      </div>\r\n      <table class=\"w100\">\r\n        <tr>\r\n          <th>User Details</th>\r\n          <th>Unfollow</th>\r\n        </tr>\r\n        <tr dir-paginate=\"u in users.data | itemsPerPage : 25\" ng-if=\"users.data.length> 0\" pagination-id=\"list.id\"\r\n          class=\"blackText\">\r\n          <td>\r\n\r\n\r\n            <span ng-if=\"u.name\" style=\"margin: 0;\">\r\n\r\n\r\n              <a ng-if=\"u.userType == \'politician\'\" href=\"#!/publicProfile/{{u._id}}\" class=\"link\" style=\"text-transform: capitalize;\"><img ng-src=\"../assets/images/profile/politician.svg\" alt=\"Politician\"  class=\"usertype\">{{u.name}}</a>\r\n              <a ng-if=\"u.userType == \'voter\'\" href=\"#!/voterProfile/{{u._id}}\" class=\"link\" style=\"text-transform: capitalize;\"><img ng-src=\"../assets/images/profile/voter.svg \" alt=\"Voter\" class=\"usertype \">{{u.username}}</a>\r\n              <a ng-if=\"u.userType == \'advocate\'\" href=\"#!/pressProfile/{{u._id}}\" class=\"link\" style=\"text-transform: capitalize;\"><img ng-src=\"../assets/images/profile/advocate.svg\" class=\"usertype\" alt=\"Advocate\">{{u.title}}</a>\r\n\r\n													<a ng-if=\"u.userType == \'admin\'\" href=\"#!/publicProfile/{{u._id}}\" class=\"link\" style=\"text-transform: capitalize;\"><img ng-src=\"../assets/images/profile/admin.svg\" class=\"usertype\" alt=\"Admin\" >VoteWise Admin</a>\r\n													<a ng-if=\"u.userType == \'press\'\" href=\"#!/pressProfile/{{u._id}}\" class=\"link\" style=\"text-transform: capitalize;\"> <img ng-src=\"../assets/images/profile/press.svg\" alt=\"Press\" class=\"usertype\" ><img ng-src=\"../assets/images/profile/admin.svg\" class=\"usertype\" alt=\"Admin\" >{{u.name}}</a>\r\n\r\n\r\n\r\n            </span>\r\n            <!-- <p ng-if=\"u.nameOnBallot && !u.name\" style=\"margin: 0;\">\r\n              <strong>Name:</strong>\r\n              <a href=\"#!/publicProfile/{{u._id}}\">{{u.nameOnBallot}}</a>\r\n            </p> -->\r\n            <!-- <p ng-if=\"u.username\" style=\"margin: 0;\">\r\n              <strong>UserName:</strong> {{u.username}}</p> -->\r\n            <!--        <p ng-if=\"u.userType\" style=\"text-transform: capitalize;\"><strong>User Type:</strong> {{u.userType}}</p>  -->\r\n            <!--         <p ng-if=\"u.public_email\" style=\"margin: 0;\">\r\n              <strong>Email:</strong> {{u.public_email}}</p>\r\n            <p ng-if=\"u.mailing_address\" style=\"margin: 0;\">\r\n              <strong>Address:</strong> {{u.mailing_address}} </p>  -->\r\n          </td>\r\n          <td>\r\n            <a href=\"javascript: void(0)\" ng-click=\"unfollow(u, $index)\" class=\"link\">Unfollow</a>\r\n          </td>\r\n        </tr>\r\n        <tr ng-if=\"users.data.length == 0\">\r\n          <td colspan=\"2\"> No records found.\r\n          </td>\r\n        </tr>\r\n      </table>\r\n      <div style=\"float:right;\">\r\n        <dir-pagination-controls max-size=\"5\" pagination-id=\"list.id\"></dir-pagination-controls>\r\n      </div>\r\n    </div>\r\n    <div ng-if=\"users.data.length == 0\">\r\n      <center> <b> You are not following any users. </b></center>\r\n    </div>\r\n\r\n  </form>\r\n  <div class=\"containerForQuiz\">\r\n    <h2 class=\"pageHeading\" ng-if=\"result.length > 0\">Details of invited Quizzes</h2>\r\n    <table class=\"w100\" ng-if=\"result.length > 0\">\r\n      <tr>\r\n        <th>QuizName</th>\r\n        <th>No of followers</th>\r\n        <th>See Match</th>\r\n        <th>Share</th>\r\n      </tr>\r\n      <tr ng-repeat=\"item in result\" class=\"blackText\">\r\n        <td>\r\n          {{item.quizName}}\r\n        </td>\r\n        <td>\r\n          {{item.quizTakerArr.length}}\r\n        </td>\r\n        <td>\r\n          <a href=\"\" ng-click=\"getMatch(item)\" class=\"link\">See Match</a>\r\n        </td>\r\n        <td>\r\n          <a href=\"\" ng-click=\"shareQuiz(item)\" class=\"link\">Share Quiz</a>\r\n        </td>\r\n      </tr>\r\n      <tr ng-if=\"result.data.data.length == 0\">\r\n        <td colspan=\"2\"> No records found.\r\n        </td>\r\n      </tr>\r\n    </table>\r\n    <br>\r\n    <div ng-if=\"followersCnt\">\r\n      <h4>\r\n        <a href=\"\" ng-show=\"followersData.length > 0\" ng-click=\"showList = !showList\" class=\"ylink\">Your Total Followers {{followersCnt}}</a>\r\n      </h4>\r\n      <div ng-hide=\"showList\">\r\n        <div>\r\n          <table class=\"w100\" ng-if=\"followersData.length > 0\">\r\n            <tr>\r\n              <th>Num.</th>\r\n              <th>Name</th>\r\n            </tr>\r\n            <tr ng-repeat=\"item in followersData track by $index\" class=\"blackText\">\r\n              <td>\r\n                {{$index+1}}\r\n              </td>\r\n              <td>\r\n                <div ng-if=\"item.userType == \'politician\'\">\r\n                  <img src=\"../assets/images/profile/politician.svg\" alt=\"Politician\"  class=\"usertype\" /><a href=\"#!/publicProfile/{{item._id}}\" class=\"link\" style=\"text-transform: capitalize;\">{{item.nameOnBallot}}</a>\r\n\r\n                </div>\r\n                <div ng-if=\"item.userType == \'advocate\'\">\r\n                  <img src=\"../assets/images/profile/advocate.svg\" class=\"usertype\" alt=\"Organization\" /><a  href=\"#!/pressProfile/{{item._id}}\" class=\"link\" style=\"text-transform: capitalize;\">\r\n																	{{item.title}}</a>\r\n                </div>\r\n                <div ng-if=\"item.userType == \'voter\'\">\r\n                  <img src=\"../assets/images/profile/voter.svg\" class=\"usertype\" alt=\"Voter\"  /><a href=\"#!/voterProfile/{{item._id}}\" class=\"link\" style=\"text-transform: capitalize;\">\r\n																	{{item.username}}</a>\r\n                </div>\r\n              </td>\r\n            </tr>\r\n            <tr ng-if=\"followers.data.data.length == 0\">\r\n              <td colspan=\"2\"> No records found.\r\n              </td>\r\n            </tr>\r\n          </table>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n\r\n<script type=\"text/ng-template\" id=\"exporeQuizLink\">\r\n  <h5>Copy and paste the link below to Facebook, Twitter, Email or wherever you want.<br><br>  When people click the link to take the quiz, you can each see how you compare and they will become your \"followers.\"</h5>\r\n <div>\r\n   <p>{{shareLink}}</p>\r\n </div>\r\n</script>");
$templateCache.put("app/forgot-password/forgot-password.html","<div class=\"voter-signup\">\r\n\r\n\r\n    <!--<h3 style=\"padding-left: 215px;\">In order to match you with your local politicians, we need to know where you live. </h3>-->\r\n    <br>\r\n    <div class=\"signup-margin\">\r\n        <div class=\"alert alert-danger\" ng-show=\"Errors.length>0\" role=\"alert\" ng-repeat=\"error in Errors\">\r\n            {{error}}\r\n        </div>\r\n        <form name=\"forgotPassForm\" id=\"forgotPassForm\">\r\n            <fieldset class=\"scheduler-border\">\r\n                <legend class=\"scheduler-border\">Reset Password</legend>\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-12\">\r\n                        <div class=\"control-group\">\r\n                            <label class=\"control-label\" for=\"password\">New Password</label>\r\n                            <div class=\"controls\">\r\n                                <input type=\"password\" id=\"forgotPassword\" ng-model=\"forgotPassword\" placeholder=\"\"\r\n                                    data-errormessage=\"Password is required.\" class=\"form-control input-md validate[required] text-input\" />\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div class=\"controls\">\r\n                            <label class=\"control-label\" for=\"confirm_password\">Confirm password</label>\r\n                            <input type=\"password\" id=\"confirm_password\" ng-model=\"confirmPassword\" \r\n                                data-errormessage=\"Password and Confirm password do not match.\" placeholder=\"\" class=\"form-control input-md  validate[required,equals[forgotPassword]] text-input \"/>\r\n                            <small id=\"message\"></small>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div style=\"clear: both;\"></div>\r\n                    <div style=\"width: 55%; margin-top: 10px; float: right; margin-right: 17px;\">\r\n                        <button ng-click=\"resetPassword()\" type=\"submit\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n                        <div style=\"clear: both;\"></div>\r\n                    </div>\r\n                    <div style=\"clear: both;\"></div>\r\n                </div>\r\n\r\n            </fieldset>\r\n        </form>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/forum/forum.html","<p>\r\n  <b><a href=\"#!/debateHome\" style=text-decoration:underline  class=\"ylink\">Forum</a> > <a href=\"#!/forum/{{previouscatId}}/{{finaltype}}\" class=\"ylink\" ng-if=\"previouscategory.title\"> {{previouscategory.title}} > </a>{{category.title}}</b>\r\n</p>\r\n<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">FORUM SUBTOPICS</h2>\r\n  <!--	<br>Is Email Verified {{userProfile.isEmailVerified}}\r\n	<br>Is a user {{userProfile.verifiedUser}}\r\n	<br>show em {{showEm}}\r\n	-->\r\n  <!--  <h1 style=\"text-transform: capitalize;\">{{category.title}}</h1>-->\r\n  <br>\r\n  <h1>\r\n    <center>{{category.title}}</center>\r\n  </h1>\r\n  <br>\r\n  <!--\r\n<div class=\"geobox\">\r\n<form action=\"\">\r\n<fieldset class=\"scheduler-border\">\r\n    <legend class=\"scheduler-border\">Choose</legend>\r\n    <input type=\"radio\" name=\"geographic-focus\" value=\"national\" checked /> National\r\n    <input type=\"radio\" name=\"geographic-focus\" value=\"state\"> State\r\n    <input type=\"radio\" name=\"geographic-focus\" value=\"county\"> County\r\n    <input type=\"radio\" name=\"geographic-focus\" value=\"local\"> Local<br>\r\n    </fieldset>\r\n</form>\r\n    </div>\r\n  <div class=\"geobox\">\r\n    <form>\r\n\r\n\r\nSkip to: <br>\r\n<select name=\"SUBJECT\" ng-model=\"filterCondition.subcat\">\r\n  <option ng-selected=\"{{operator.title == filterCondition.subcat}}\"\r\n            ng-repeat=\"operator in subCategories\"\r\n            value=\"{{operator.title}}\">\r\n      {{operator.title}}\r\n    </option>\r\n\r\n</select>\r\n    </form>\r\n    </div>\r\n<button class=\"geobox\">Change Location</button>\r\n    -->\r\n\r\n  <div id=\"tfheader\" class=\"searchbox\" style=\"padding-left:10px;\">\r\n    Search word must be longer than 3 letters\r\n    <input type=\"text\" class=\"tftextinput blackText\" ng-model=\"search.text\" name=\"q\" size=\"21\" maxlength=\"120\">\r\n    <input type=\"button\" ng-click=\"searchForum(search);\" value=\"Forum Search\" class=\"tfbutton\">\r\n    <div class=\"tfclear\"></div>\r\n  </div>\r\n  <br>\r\n  <div ng-if=\"!userData.isemailverified\" ng-click=\"sendMail()\" style=color:red>\r\n    <center><button ng-click=\"sendMail()\" class=\"compareBtn\">\r\n            Resend Confirmation Email</button></center>\r\n  </div>\r\n  <br>\r\n  <div class=\"newUser\">\r\n    <div class=\"inline2\">\r\n      <form>\r\n        <table style=\"width:100%\" class=\"changeTextColor\">\r\n          <tr>\r\n            <th>Forum</th>\r\n            <th>Total Comments</th>\r\n            <th>Latest Post</th>\r\n            <!--   <th><image src=\"../assets/images/peace.svg\" class=\"tablehead\" /><br>Solutions</th> -->\r\n            <!--<th> Total Threads</th> -->\r\n            <!-- <th>Total Posts</th> -->\r\n          </tr>\r\n          <tr ng-repeat=\"item in subCategories | orderBy: item.order\">\r\n            <td>\r\n\r\n              <a href=\"#!/forum/{{item._id}}/subcat\" ng-if=\"item.returndata.nextSubcat\" style=text-decoration:underline  class=\"link\"><b>{{item.title}}</b></a>\r\n              <a href=\"#!/forumList/{{categoryId}}/{{item._id}}/{{type}}\" ng-if=\"!item.returndata.nextSubcat\" style=text-decoration:underline  class=\"link\"><b>{{item.title}}</b></a>\r\n              <br><span ng-if=\"item &&  item.returndata && item.returndata.totalThread\">{{item.returndata.totalThread}} Threads</span>\r\n            </td>\r\n            <td>\r\n              <span ng-if=\"item && item.returndata && item.returndata.brainstorming\">{{item.returndata.brainstorming}}</span>\r\n            </td>\r\n            <td>\r\n              <span ng-if=\"item.returndata.totalPost > 0\">\r\n      <span ng-click=\"gotoThread(item.returndata, item._id);\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\" class=\"link\"><image src=\"../assets/images/ideas4small.svg\" class=\"usertype\" ng-if=\"item.type==\'B\'\" /> <image src=\"../assets/images/peace.svg\" class=\"usertype\" ng-if=\"item.type==\'S\'\" /> {{item.returndata.title}} </span>\r\n              <br><img ng-src=\"../assets/images/profile/{{item.returndata.createdby.utype}}.svg\" ng-if=\"item.returndata.createdby.utype\" class=\"usertype\"> by\r\n              <!-- FOR Politicians -->\r\n              <a href=\"#!/publicProfile/{{item.returndata.createdby.id}}\" class=\"link\" style=\"text-transform: capitalize;\" ng-if=\"item.returndata.createdby.utype==\'politician\' && item.returndata.userData.isEmailVerified && item.returndata.userData.verifiedUser\" >\r\n                        <b >{{item.returndata.userData.name}}</b>\r\n                    </a>\r\n\r\n              <!-- For Voters -->\r\n              <a href=\"#!/voterProfile/{{item.returndata.createdby.id}}\" class=\"link\" style=\"text-transform: capitalize;\" ng-if=\"item.returndata.createdby.utype==\'voter\'\" >\r\n\r\n                      <b >{{item.returndata.userData.username}}</b>\r\n                  </a>\r\n              <!-- for org  -->\r\n              <a href=\"#!/pressProfile/{{item.returndata.createdby.id}}\" class=\"link\" style=\"text-transform: capitalize;\" ng-if=\"item.returndata.createdby.utype ==\'advocate\' && item.returndata.userData.isEmailVerified && item.returndata.userData.verifiedUser\" >\r\n                        <b ng-if=\"item.returndata.createdby.utype!=\'politician\' && item.returndata.createdby.orgdata.title\">{{item.returndata.createdby.orgdata.title}}</b>\r\n\r\n                    </a>\r\n              <!-- For press -->\r\n              <a href=\"#!/pressProfile/{{item.returndata.createdby.id}}\" class=\"link\" style=\"text-transform: capitalize;\" ng-if=\"item.returndata.createdby.utype==\'press\' && item.returndata.userData.isEmailVerified && item.returndata.userData.verifiedUser\" >\r\n                      <b ng-if=\"item.returndata.createdby.utype!=\'politician\'\">{{item.returndata.createdby.name}}</b>\r\n\r\n                  </a>\r\n              <!-- For admin-->\r\n              <a href=\"#!/voterProfile/{{item.returndata.createdby.id}}\" class=\"link\" style=\"text-transform: capitalize;\" ng-if=\"item.returndata.createdby.utype==\'admin\'\" >\r\n\r\n                      <b >{{item.returndata.userData.username}}</b>\r\n                  </a>\r\n              <!-- for unverified -->\r\n              <b ng-if=\"item.returndata.createdby.utype!=\'voter\' && !item.returndata.userData.isEmailVerified || item.returndata.createdby.utype!=\'voter\' && !item.returndata.userData.verifiedUser\">\r\n\r\n<span ng-if=\"item.returndata.userData.tempName\">{{item.returndata.userData.tempName}}</span>\r\n<span ng-if=\"item.returndata.createdby.utype == \'politician\' && !item.returndata.userData.tempName\">Unknown Politician</span>\r\n        <span ng-if=\"item.returndata.createdby.utype == \'advocate\' && !item.returndata.userData.tempName\">Unknown Organization</span>\r\n                    </b>\r\n\r\n              <!--           <span ng-if=\"item.returndata.createdby.orgdata\">({{item.returndata.createdby.orgdata.title}})</span> -->\r\n              <br>{{item.returndata.createdOn | date:\'medium\'}}\r\n                    </span>\r\n              <span ng-if=\"item.returndata.totalPost == 0\">\r\n        <span ng-if=\"!item.returndata.nextSubcat\">\r\n          <div ng-if=\"userData.isemailverified\">\r\n              <a href=\"#!/topic/{{categoryId}}/{{item._id}}\"style=text-decoration:underline  class=\"link\"><b>Start a new discussion</b></a>\r\n            </div>\r\n            <a href ng-if=\"!userData.isemailverified\"  ng-click=\"sendMail()\" style=color:red>Confirm Email to start a new discussion</a>\r\n        </span>\r\n              <span ng-if=\"item.returndata.nextSubcat\">\r\n          Click the forum subject to the left to start a thread in a subcategory\r\n        </span>\r\n              </span>\r\n            </td>\r\n\r\n\r\n\r\n            <!-- <td>{{item.returndata.solution}}</td> -->\r\n            <!--  <td> <span ng-if=\"item &&  item.returndata && item.returndata.totalThread\">{{item.returndata.totalThread}}</span> </td> -->\r\n            <!-- <td> <span ng-if=\"item &&  item.returndata && item.returndata.totalPost\">{{item.returndata.totalPost}}</span> </td> -->\r\n          </tr>\r\n\r\n        </table>\r\n      </form>\r\n    </div>\r\n  </div>\r\n  <div class=\"boxed\">\r\n    <center>\r\n      <h2>My Discussions</h2>\r\n    </center>\r\n    <div ng-repeat=\"disc in DiscussionData | limitTo: 10\" ng-if=\"DiscussionData.length > 0\">\r\n      <p>\r\n        <a href=\"javascript: void(0);\" ng-click=\"gotoThread(disc, disc.subcategories[0].pid);\" style=\"cursor:pointer; font-weight: bold; text-decoration: underline;\">{{disc.title}}</a>\r\n      </p>\r\n    </div>\r\n\r\n    <p ng-if=\"DiscussionData.length==0\">No new discussions available.</p>\r\n  </div>\r\n  <div class=\"boxed\">\r\n    <center>\r\n      <h2>Threads by Following</h2>\r\n    </center>\r\n    <div ng-repeat=\"act in ActiveThreads | orderBy:\'-createdOn\'\" ng-if=\"ActiveThreads.length > 0\">\r\n      <p style=\"text-align: left;\">\r\n        <a href=\"javascript: void(0);\" ng-click=\"gotoThread(act, act.subcategories[0].pid);\" style=\"cursor:pointer; font-weight: bold; text-decoration: underline;\">{{act.title}}</a>\r\n        <br>\r\n          Posted by\r\n        <span> <img ng-src=\"../assets/images/profile/politician.svg \" ng-if=\"act.createdBy.utype == \'politician\'\" class=\"usertype \">\r\n    <img ng-src=\"../assets/images/profile/press.svg \" ng-if=\"act.createdBy.utype == \'press\'\" class=\"usertype \">\r\n    <img ng-src=\"../assets/images/profile/advocate.svg \" ng-if=\"act.createdBy.utype == \'advocate\'\" class=\"usertype \">\r\n    <img ng-src=\"../assets/images/profile/voter.svg \" ng-if=\"act.createdBy.utype == \'voter\'\" class=\"usertype \">\r\n    <img ng-src=\"../assets/images/profile/admin.svg \" ng-if=\"act.createdBy.utype ==\'admin\'\" class=\"usertype \"></span>\r\n        <a href=\"#!/publicProfile/{{act.createdBy.id}}\" ng-if=\"act.createdBy.utype==\'politician\'\" style=\"text-transform:capitalize;\">\r\n              <b>{{act.pName}}</b>\r\n            </a>\r\n        <a href=\"#!/pressProfile/{{act.createdBy.id}}\" ng-if=\"act.createdBy.utype == \'advocate\'\" style=\"text-transform:capitalize;\">\r\n              <b>{{act.orgName}}</b>\r\n           </a>\r\n        <a href=\"#!/voterProfile/{{act.createdBy.id}}\" ng-if=\"act.createdBy.utype ==\'voter\'\" style=\"text-transform:capitalize;\">\r\n              <b>{{act.username}}</b>\r\n           </a>\r\n        <a href=\"#!/publicProfile/{{act.createdBy.id}}\" ng-if=\"act.createdBy.utype==\'admin\'\" style=\"text-transform:capitalize;\">\r\n              <b>{{act.createdBy.name}}</b>\r\n           </a>\r\n      </p>\r\n      <div style=\"clear: both\"></div>\r\n    </div>\r\n\r\n    <p ng-if=\"ActiveThreads.length==0\">No active threads available.</p>\r\n  </div>\r\n</div>\r\n<!-- <div class=\"boxed\">\r\n    <center>\r\n      <h2>Hottest Threads</h2>\r\n    </center>\r\n    <p ng-repeat=\"hot in HotTopics | limitTo:10 | orderBy:\'-createdOn\'\" ng-if=\"HotTopics.length > 0\">\r\n      <span ng-click=\"gotoThread(hot, hot.subcategories[0].pid);\" style=\"cursor:pointer; text-decoration: underline;\" class=\"link\">{{hot.title}}</span>\r\n    </p>\r\n    <p ng-if=\"HotTopics.length==0\">No hottest threads available.</p>\r\n  </div> -->\r\n<div class=\"boxed\" ng-if=\"newData.Topics\">\r\n  <center>\r\n    <h2>New Forum Posts Since Last Login</h2>\r\n  </center>\r\n  <div>\r\n    <div style=\"width: 100%; position: relative; padding:5px;\" ng-if=\"newData.Topics.length > 0\">\r\n      <div ng-repeat=\"topic in newData.Topics\" style=\"padding:5px;\">\r\n        <a href=\"javascript: void(0);\" ng-click=\"gotoForumTopic(topic);\" ng-if=\"topic.subCategories[0].pid\" style=\"font-weight: bold; text-decoration: underline;\">\r\n              {{topic.title}}\r\n            </a>\r\n        <a href=\"javascript: void(0);\" ng-click=\"gotoForumT(topic);\" ng-if=\"!topic.subCategories[0].pid\" style=\"font-weight: bold; text-decoration: underline;\">\r\n              {{topic.title}}\r\n            </a>\r\n        <div>Posted by\r\n          <span> <img ng-src=\"../assets/images/profile/politician.svg \" ng-if=\"topic.createdBy.utype == \'politician\'\" class=\"usertype \">\r\n      <img ng-src=\"../assets/images/profile/press.svg \" ng-if=\"topic.createdBy.utype == \'press\'\" class=\"usertype \">\r\n      <img ng-src=\"../assets/images/profile/advocate.svg \" ng-if=\"topic.createdBy.utype == \'advocate\'\" class=\"usertype \">\r\n      <img ng-src=\"../assets/images/profile/voter.svg \" ng-if=\"topic.createdBy.utype == \'voter\'\" class=\"usertype \">\r\n      <img ng-src=\"../assets/images/profile/admin.svg \" ng-if=\"topic.createdBy.utype ==\'admin\'\" class=\"usertype \"></span>\r\n          <a href=\"#!/publicProfile/{{topic.createdBy.id}}\" ng-if=\"topic.createdBy.utype==\'politician\'\" style=\"text-transform:capitalize;\">\r\n                <b>{{topic.createdBy.nameOnBallot}}</b>\r\n              </a>\r\n          <a href=\"#!/pressProfile/{{topic.createdBy.id}}\" ng-if=\"topic.createdBy.utype == \'advocate\'\" style=\"text-transform:capitalize;\">\r\n                <b>{{topic.createdBy.orgName}}</b>\r\n             </a>\r\n          <a href=\"#!/voterProfile/{{topic.createdBy.id}}\" ng-if=\"topic.createdBy.utype ==\'voter\'\" style=\"text-transform:capitalize;\">\r\n                <b>{{topic.createdBy.name}}{{topic.createdBy.uname}}</b>\r\n             </a>\r\n          <a href=\"#!/publicProfile/{{topic.createdBy.id}}\" ng-if=\"topic.createdBy.utype==\'admin\'\" style=\"text-transform:capitalize;\">\r\n                <b>{{topic.createdBy.name}}</b>\r\n             </a>\r\n          on {{topic.createdOn | date:\'medium\'}}\r\n        </div>\r\n        <div style=\"clear: both\"></div>\r\n      </div>\r\n    </div>\r\n    <div ng-if=\"newData.Topics.length==0\" style=\"padding:10px; color:red;\">\r\n      <center>\r\n        <b> No new records.</b>\r\n      </center>\r\n    </div>\r\n  </div>\r\n</div>\r\n</div>\r\n<!--<div class=\"boxed\">\r\n    <center><h2>Local Threads</h2></center>\r\n    <p>  This is to be implemented. </p>\r\n    </div>-->\r\n<div></div>\r\n<script type=\"text/ng-template\" id=\"popUp\">\r\n  <div class=\"container\">\r\n   <p ng-if=\"showBoth && $root.userRole==\'politician\'\">You can read, but you can\'t write anything on the site until you confirm your email address.  <br><br> After you confirm your email, you can write, but everything will have the byline \"Unknown Politician\" until we can confirm your identification (then all your work will change to your byline).  You can wait for us to research you or you can use our automated ID confirmation system (which costs $1)</p>\r\n			<p ng-if=\"showBoth && $root.userRole==\'advocate\'\">You can read, but you can\'t write anything on the site until you confirm your email address.  <br><br> After you confirm your email, you can write, but everything will have the byline \"Unknown Organization\" until we can confirm your identification (then all your work will change to your byline).</p>\r\n   <p ng-if=\"showEm\">You can read, but you can\'t write anything on the site until you confirm your email address.</p>\r\n   <p ng-if=\"showCon && !showBoth && !showEm && $root.userRole==\'politician\'\">We still need to confirm you are who you say you are. If you are running for a large office, we will do the research to figure that out.  If you are running for a more local office and you don\'t want to wait for us, you can use the automated ID check which costs $1.</p>\r\n\r\n   <div class=\"ngdialog-buttons\">\r\n   <button  ng-click=\"sendMail()\" type=\"button\" class=\"ngdialog-button ngdialog-button-primary\" ng-if=\"showEm || (showBoth && $root.userRole==\'politician\')\" >Resend Confirmation Email</button>\r\n   <button ng-click=\"goto()\" ng-if=\"showCon && $root.userRole==\'politician\'\" type=\"button\" class=\"ngdialog-button ngdialog-button-primary\">Confirm Id</button>\r\n   <button ng-click=\"closeIt()\" type=\"button\" class=\"ngdialog-button ngdialog-button-primary\">Later</button>\r\n   </div>\r\n  </div>\r\n\r\n\r\n\r\n</script>\r\n");
$templateCache.put("app/forumList/forumList.html","<p>\r\n  <a href=\"#!/debateHome\" style=text-decoration:underline class=\"ylink\"><b>Forum</b></a> >\r\n  <a href=\"#!/forum/{{categoryId}}/{{type}}\" style=text-decoration:underline class=\"ylink\"><b>{{category.title}}</b> </a>\r\n  > {{subcategory.title}}\r\n</p>\r\n<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">FORUM THREADS</h2>\r\n  <!--  <h1 style=\"text-transform: capitalize;\">{{category.title}}</h1>-->\r\n  <br>\r\n\r\n  <p>\r\n  <h2>\r\n    <center>{{subcategory.title}}</center>\r\n  </h2>\r\n  </p><br>\r\n  <div ng-if=\"userData.isemailverified\">\r\n    <center>\r\n      <a href=\"#!/topic/{{categoryId}}/{{subcategoryId}}\"class=\"btn2\">Start a New Discussion</a>\r\n    </center>\r\n  </div>\r\n  <!--<p ng-if=\"userData.isemailverified\">\r\n  <a href=\"#!/topic/{{categoryId}}/{{subcategoryId}}\" style=text-decoration:underline class=\"ylink\"><b>Start a new discussion</b></a>\r\n</p> -->\r\n  <center>\r\n    <a href ng-if=\"!userData.isemailverified\" ng-click=\"sendMail()\" style=color:red>Confirm Email to start a new discussion</a>\r\n  </center>\r\n  <div ng-if=\"!userData.isemailverified\" ng-click=\"sendMail()\" style=color:red>\r\n    <center><button ng-click=\"sendMail()\" class=\"compareBtn\">Resend Confirmation Email</button></center>\r\n  </div>\r\n  <!-- <div ng-if=\"!$root.userRole\" style=color:red> Join/Sign In to start a new discussion</div> -->\r\n\r\n  <br>\r\n  <br>\r\n  <div class=\"inline2\">\r\n    <div style=\"width:60%; float:left;\">\r\n      <label>Refine: </label>\r\n    </div>\r\n    <div style=\"width:39%; float:right; text-align: right;\">\r\n      <label>Sort: </label>\r\n    </div>\r\n    <div style=\"width:60%; float:left;\">\r\n      <select ng-model=\"filterBy\" ng-init=\"filterBy = \'all\';\" style=\"text-transform: capitalize; \" class=\"blackText\">\r\n                  <option ng-repeat=\"item in filterArray\" val=\"{{item}}\">{{item}}</option>\r\n              </select>\r\n    </div>\r\n    <div style=\"width:39%; float:right; text-align: right;\">\r\n      <select ng-model=\"sortBy\" ng-change=\"SortData()\" style=\"text-transform: capitalize;\" class=\"blackText\">\r\n                  <option val=\"Select sort\">Chronological</option>\r\n                  <option ng-repeat=\"item in sortArray\" class=\"blackText\" val=\"{{item}}\">{{item}}</option>\r\n              </select>\r\n\r\n      <div style=\"clear:both;\"></div>\r\n    </div>\r\n    <form>\r\n      <table style=\"width:100%\" class=\"changeTextColor\">\r\n        <tr>\r\n          <th>Threads</th>\r\n          <th> Replies</th>\r\n          <th ng-if=\"userType==\'admin\'\"> Sticky </th>\r\n          <th> Actions </th>\r\n        </tr>\r\n        <!--<tr ng-repeat=\"key in objectKeys(DisplayData)\" ng-init=\"post = DisplayData[key]\"> -->\r\n        <tr ng-repeat=\"post in DisplayData |orderBy:\'-postSticky\' | refineDataNw:filterBy\"\r\n          ng-if=\"DisplayData.length > 0\" ng-style=\"checkSticky(post.postSticky)\">\r\n          <td>\r\n            <span ng-click=\"gotoThread(post._id);\" style=\"cursor:pointer;text-decoration:underline;\"  class=\"link\">\r\n				<!--									<img src=\"../assets/images/ideas.svg\"  ng-if=\"post.postSticky!=\'Y\'\" class=\"usertype\" /><img src=\"../assets/images/ideas4.svg\"  ng-if=\"post.postSticky==\'Y\'\" class=\"usertype\" />  -->\r\n													<b id=\"anchor{{post._id}}\"> {{post.title}}</b></span>\r\n            <br>Original Post by\r\n            <!-- <img src=\"../assets/images/VOTERbutton.svg\" class=\"usertype\"> -->\r\n            <img ng-src=\"../assets/images/profile/{{post.createdBy.utype}}.svg\" ng-if=\"post.createdBy.utype\" class=\"usertype\">\r\n\r\n            <!-- For politician -->\r\n            <a ng-if=\"post.userData.officeId && !post.createdBy.orgdata && post.userData.isEmailVerified && post.userData.verifiedUser\" href =\"#!/publicProfile/{{post.createdBy.id}}\" style=\"text-decoration:underline; text-transform: capitalize;\" class=\"link\">\r\n                     <b> {{post.userData.name}}</b>\r\n\r\n            </a>\r\n            <!-- For voter -->\r\n            <a ng-if=\"post.createdBy.utype == \'voter\'\" href =\"#!/voterProfile/{{post.createdBy.id}}\" style=\"text-decoration:underline; text-transform: capitalize;\" class=\"link\">\r\n              <b> {{post.userData.username}}</b>\r\n\r\n     </a>\r\n\r\n            <!-- For admin -->\r\n            <a ng-if=\"post.createdBy.utype == \'admin\'\" href =\"#!/voterProfile/{{post.createdBy.id}}\" style=\"text-decoration:underline; text-transform: capitalize;\" class=\"link\">\r\n      <b> {{post.userData.username}}</b>\r\n\r\n</a>\r\n            <!-- For advocate -->\r\n            <a ng-if=\"post.userData.officeId && post.userData.isEmailVerified && post.userData.verifiedUser\" href =\"#!/pressProfile/{{post.createdBy.id}}\" >\r\n            <!-- <b> {{post.userData.username}}</b> -->\r\n             <span ng-if=\"post.createdBy.orgdata\" style=\"text-decoration:underline; text-transform: capitalize;\" class=\"link\"><b>{{post.createdBy.orgdata.title}}</b></span>\r\n            </a>\r\n            <!-- For politician -->\r\n            <a ng-if=\"!post.userData.officeId && post.createdBy.utype == \'politician\' && post.userData.isEmailVerified && post.userData.verifiedUser\" href =\"#!/publicProfile/{{post.createdBy.id}}\" style=\"text-decoration:underline; text-transform: capitalize;\" class=\"link\">\r\n              <b>{{post.userData.name}}</b>\r\n\r\n     </a>\r\n            <!-- For unverified  -->\r\n            <b ng-if=\"!post.userData.isEmailVerified || !post.userData.verifiedUser\">\r\n            <span ng-if=\"post.userData.tempName\">{{post.userData.tempName}}</span>\r\n          <span ng-if=\"post.createdBy.utype == \'politician\' && !post.userData.tempName \">Unknown Politician</span>\r\n          <span ng-if=\"post.createdBy.utype == \'advocate\' && !post.userData.tempName \">Unknown Organization</span>  </b>\r\n            <br>\r\n											{{post.createdOn | date:\'medium\'}}\r\n            <div ng-if=\"post.lastTopic\">Latest post by <img ng-src=\"../assets/images/profile/{{post.lastTopic.createdBy.utype}}.svg\" ng-if=\"post.lastTopic.createdBy.utype\" class=\"usertype\">\r\n\r\n\r\n              <!-- For  politician -->\r\n              <a href=\"#!/publicProfile/{{post.lastTopic.createdBy.id}}\" ng-if=\"post.lastTopic.createdBy.utype != \'voter\' && post.lastTopic.userData.isEmailVerified && post.lastTopic.userData.verifiedUser\">\r\n                     <b><span ng-if=\"post.lastTopic.createdBy.utype == \'politician\'\" style=\"text-decoration:underline; text-transform: capitalize;\" class=\"link\">{{post.lastTopic.userData.name}}</span></b>\r\n                    </a>\r\n\r\n\r\n              <!-- For adv and press -->\r\n              <a ng-if=\"post.lastTopic.createdBy.utype == \'advocate\' || post.lastTopic.createdBy.utype == \'press\' && post.lastTopic.userData.isEmailVerified && post.lastTopic.userData.verifiedUser\" href=\"#!/pressProfile/{{post.lastTopic.createdBy.id}}\">\r\n                     <b> <span ng-if=\"post.lastTopic.createdBy.orgdata && post.lastTopic.userData.isEmailVerified && post.lastTopic.userData.verifiedUser\" style=\"text-decoration:underline; text-transform: capitalize;\" class=\"link\">{{post.lastTopic.createdBy.orgdata.title}}</span></b>\r\n                     </a>\r\n\r\n\r\n              <!-- For voter -->\r\n              <b><a href=\"#!/voterProfile/{{post.lastTopic.createdBy.id}}\" ng-if=\"post.lastTopic.createdBy.utype == \'voter\'\" style=\"text-decoration:underline; text-transform: capitalize;\" class=\"link\">\r\n                {{post.lastTopic.userData.username}}\r\n              </a></b>\r\n              <!-- For unverified -->\r\n              <b ng-if=\"!post.lastTopic.userData.isEmailVerified || !post.lastTopic.userData.verifiedUser\">\r\n               <span ng-if=\"post.lastTopic.userData.tempName\">{{post.lastTopic.userData.tempName}}</span>\r\n              <span ng-if=\"post.lastTopic.createdBy.utype == \'politician\' && !post.lastTopic.userData.tempName\">Unknown Politician</span>\r\n              <span ng-if=\"post.lastTopic.createdBy.utype == \'advocate\' && !post.lastTopic.userData.tempName\">Unknown Organization</span></b>\r\n              <br> {{post.lastTopic.createdOn | date:\'medium\'}}\r\n                  </div>\r\n          </td>\r\n          <td>{{post.totalReply}} </td>\r\n          <td ng-if=\"userType==\'admin\'\">\r\n            <span ng-if=\"post.postSticky==\'N\'\">\r\n        Order: <input type=\"number\" value=\"0\" style=\"width: 40px;\" ng-model=\"Sticky.txtOrder[post._id]\" maxlength=\"2\" /> <input type=\"button\" ng-click=\"updatePost(\'sticky\', post._id);\" name=\"btnSticky\" value=\"Set Sticky\">\r\n        </span>\r\n            <spam ng-click=\"updatePost(\'removeSticky\', post._id);\" ng-if=\"post.postSticky==\'Y\'\" style=\"cursor:pointer;\"\r\n              class=\"link\">Remove sticky </spam>\r\n          </td>\r\n          <td>\r\n            <!-- <a href=\"javascript: void(0);\" ng-if=\"post.createdBy.id!=userId\" ng-click=\"gotoThread(post._id);\" style=text-decoration:underline class=\"link\"><b>View</b></a><span ng-if=\"$root.userRole == \'admin\'\"> &nbsp;</span><a href=\"javascript: void(0);\" ng-if=\"post.createdBy.id==userId  || $root.userRole == \'admin\'\" ng-click=\"gotoUpdate(post);\" class=\"link\"><b>Edit</b></a> -->\r\n            <a href=\"javascript: void(0);\" ng-click=\"gotoThread(post._id);\" style=text-decoration:underline class=\"link\"><b>View</b></a><span ng-if=\"$root.userRole == \'admin\'\"> &nbsp;</span><a href=\"javascript: void(0);\" ng-if=\"$root.userRole == \'admin\'\" ng-click=\"gotoUpdate(post);\" class=\"link\"><b>Edit</b></a>\r\n          </td>\r\n        </tr>\r\n        <tr ng-if=\"DisplayData.length == 0\">\r\n          <td ng-if=\"userType!=\'admin\'\" colspan=\"3\">No records found.</td>\r\n          <td ng-if=\"userType==\'admin\'\" colspan=\"4\">No records found.</td>\r\n        </tr>\r\n      </table>\r\n    </form>\r\n  </div>\r\n  <div class=\"boxed\">\r\n    <center>\r\n      <h2>My Discussions</h2>\r\n    </center>\r\n    <p ng-repeat=\"disc in DiscussionData\" ng-if=\"DiscussionData.length > 0\">\r\n      <a href=\"javascript: void(0);\" ng-click=\"gotoThread(disc, disc.subcategories[0].pid);\" style=\"cursor:pointer; text-decoration: underline; font-weight: bold;\" >{{disc.title}}</a>\r\n    </p>\r\n    <p ng-if=\"DiscussionData.length==0\">No new discussions available.</p>\r\n  </div>\r\n  <div class=\"boxed\">\r\n    <center>\r\n      <h2>Threads by Following</h2>\r\n    </center>\r\n    <p ng-repeat=\"act in ActiveThreads | orderBy:\'-createdOn\'\" ng-if=\"ActiveThreads.length > 0\">\r\n      <a href=\"javascript: void(0);\" ng-click=\"gotoThread(act, act.subcategories[0].pid);\" style=\"cursor:pointer; text-decoration: underline; font-weight: bold;\" >{{act.title}}</a>\r\n      <br>\r\n					    Posted by\r\n      <span> <img ng-src=\"../assets/images/profile/politician.svg \" ng-if=\"act.createdBy.utype == \'politician\'\" class=\"usertype \">\r\n    <img ng-src=\"../assets/images/profile/press.svg \" ng-if=\"act.createdBy.utype == \'press\'\" class=\"usertype \">\r\n    <img ng-src=\"../assets/images/profile/advocate.svg \" ng-if=\"act.createdBy.utype == \'advocate\'\" class=\"usertype \">\r\n    <img ng-src=\"../assets/images/profile/voter.svg \" ng-if=\"act.createdBy.utype == \'voter\'\" class=\"usertype \">\r\n    <img ng-src=\"../assets/images/profile/admin.svg \" ng-if=\"act.createdBy.utype ==\'admin\'\" class=\"usertype \"></span>\r\n      <a href=\"#!/publicProfile/{{act.createdBy.id}}\" ng-if=\"act.createdBy.utype==\'politician\'\" style=\"text-transform:capitalize;\">\r\n              <b>{{act.pName}}</b>\r\n            </a>\r\n      <a href=\"#!/pressProfile/{{act.createdBy.id}}\" ng-if=\"act.createdBy.utype == \'advocate\'\" style=\"text-transform:capitalize;\">\r\n              <b>{{act.orgName}}</b>\r\n           </a>\r\n      <a href=\"#!/voterProfile/{{act.createdBy.id}}\" ng-if=\"act.createdBy.utype ==\'voter\'\" style=\"text-transform:capitalize;\">\r\n              <b>{{act.username}}</b>\r\n           </a>\r\n      <a href=\"#!/publicProfile/{{act.createdBy.id}}\" ng-if=\"act.createdBy.utype==\'admin\'\" style=\"text-transform:capitalize;\">\r\n              <b>{{act.createdBy.name}}</b>\r\n           </a>\r\n    </p>\r\n    <p ng-if=\"ActiveThreads.length==0\">No active threads available.</p>\r\n  </div>\r\n</div>\r\n<div class=\"boxed\" ng-if=\"newData.Topics\">\r\n  <center>\r\n    <h2>New Forum Posts Since Last Login</h2>\r\n  </center>\r\n  <div>\r\n    <div style=\"width: 100%; position: relative; padding:5px;\" ng-if=\"newData.Topics.length > 0\">\r\n      <div ng-repeat=\"topic in newData.Topics\" style=\"padding:5px;\">\r\n        <a href=\"javascript: void(0);\" ng-click=\"gotoForumTopic(topic);\" ng-if=\"topic.subCategories[0].pid\" style=\"font-weight: bold; text-decoration: underline;\">\r\n            {{topic.title}}\r\n          </a>\r\n        <a href=\"javascript: void(0);\" ng-click=\"gotoForumT(topic);\" ng-if=\"!topic.subCategories[0].pid\" style=\"font-weight: bold; text-decoration: underline;\">\r\n            {{topic.title}}\r\n          </a>\r\n        <div>Posted by\r\n          <span> <img ng-src=\"../assets/images/profile/politician.svg \" ng-if=\"topic.createdBy.utype == \'politician\'\" class=\"usertype \">\r\n    <img ng-src=\"../assets/images/profile/press.svg \" ng-if=\"topic.createdBy.utype == \'press\'\" class=\"usertype \">\r\n    <img ng-src=\"../assets/images/profile/advocate.svg \" ng-if=\"topic.createdBy.utype == \'advocate\'\" class=\"usertype \">\r\n    <img ng-src=\"../assets/images/profile/voter.svg \" ng-if=\"topic.createdBy.utype == \'voter\'\" class=\"usertype \">\r\n    <img ng-src=\"../assets/images/profile/admin.svg \" ng-if=\"topic.createdBy.utype ==\'admin\'\" class=\"usertype \"></span>\r\n          <a href=\"#!/publicProfile/{{topic.createdBy.id}}\" ng-if=\"topic.createdBy.utype==\'politician\'\" style=\"text-transform:capitalize;\">\r\n              <b>{{topic.createdBy.nameOnBallot}}</b>\r\n            </a>\r\n          <a href=\"#!/pressProfile/{{topic.createdBy.id}}\" ng-if=\"topic.createdBy.utype == \'advocate\'\" style=\"text-transform:capitalize;\">\r\n              <b>{{topic.createdBy.orgName}}</b>\r\n           </a>\r\n          <a href=\"#!/voterProfile/{{topic.createdBy.id}}\" ng-if=\"topic.createdBy.utype ==\'voter\'\" style=\"text-transform:capitalize;\">\r\n              <b>{{topic.createdBy.name}}{{topic.createdBy.uname}}</b>\r\n           </a>\r\n          <a href=\"#!/publicProfile/{{topic.createdBy.id}}\" ng-if=\"topic.createdBy.utype==\'admin\'\" style=\"text-transform:capitalize;\">\r\n              <b>{{topic.createdBy.name}}</b>\r\n           </a>\r\n          on {{topic.createdOn | date:\'medium\'}}\r\n        </div>\r\n        <div style=\"clear: both\"></div>\r\n      </div>\r\n    </div>\r\n    <div ng-if=\"newData.Topics.length==0\" style=\"padding:10px; color:red;\">\r\n      <center>\r\n        <b> No new records.</b>\r\n      </center>\r\n    </div>\r\n  </div>\r\n</div>\r\n<!--<div class=\"boxed\">\r\n    <center><h2>Local Threads</h2></center>\r\n    <p>  This is to be implemented. </p>\r\n    </div>-->\r\n<script type=\"text/ng-template\" id=\"popUp\">\r\n  <div class=\"container\">\r\n   <p ng-if=\"showBoth && $root.userRole==\'politician\'\">You can read, but you can\'t write anything on the site until you confirm your email address.  <br><br> After you confirm your email, you can write, but everything will have the byline \"Unknown Politician\" until we can confirm your identification (then all your work will change to your byline).  You can wait for us to research you or you can use our automated ID confirmation system (which costs $1)</p>\r\n			<p ng-if=\"showBoth && $root.userRole==\'advocate\'\">You can read, but you can\'t write anything on the site until you confirm your email address.  <br><br> After you confirm your email, you can write, but everything will have the byline \"Unknown Organization\" until we can confirm your identification (then all your work will change to your byline).</p>\r\n   <p ng-if=\"showEm\">You can read, but you can\'t write anything on the site until you confirm your email address.</p>\r\n   <p ng-if=\"showCon && !showBoth && !showEm && $root.userRole==\'politician\'\">We still need to confirm you are who you say you are. If you are running for a large office, we will do the research to figure that out.  If you are running for a more local office and you don\'t want to wait for us, you can use the automated ID check which costs $1.</p>\r\n\r\n   <div class=\"ngdialog-buttons\">\r\n   <button  ng-click=\"sendMail()\" type=\"button\" class=\"ngdialog-button ngdialog-button-primary\" ng-if=\"showEm || (showBoth && $root.userRole==\'politician\')\">Resend Confirmation Email</button>\r\n   <button ng-click=\"goto()\" ng-if=\"showCon && $root.userRole==\'politician\'\" type=\"button\" class=\"ngdialog-button ngdialog-button-primary\">Confirm Id</button>\r\n   <button ng-click=\"closeIt()\" type=\"button\" class=\"ngdialog-button ngdialog-button-primary\">Later</button>\r\n       </div>\r\n      </div>\r\n\r\n\r\n\r\n    </script>\r\n");
$templateCache.put("app/forumReply/forumReply.html","<link rel=\"stylesheet\" type=\"text/css\" href=\"./forumReply/forumReply.css\">\r\n<p></p>\r\n<h1><center>Reply to a thread</center></h1>\r\n<p></p>\r\n<center>\r\n  <div class=\"inline2\">\r\n\r\n    <form name=\"topicform\" id=\"topicform\">\r\n            <fieldset class=\"scheduler-border\">\r\n                <legend class=\"scheduler-border\">Thread details</legend>\r\n                <p></p>\r\n                <div class=\"row\">\r\n\r\n                    <div class=\"col-md-12\">\r\n                        <div class=\"control-group\">\r\n                            <label class=\"control-label\" for=\"title\">Title</label>\r\n                            <div class=\"controls\">\r\n                                <input type=\"text\" ng-model=\"Topic.title\" placeholder=\"\" \r\n                                   data-errormessage=\"Thread title is required.\"  class=\"form-control input-md  validate[required] text-input\" readonly=\"readonly\" style=\"width: 80%;\">\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div class=\"control-group\">\r\n                            <label class=\"control-label\" for=\"description\">Your reply</label>\r\n                            <div class=\"controls\">\r\n                                <textarea id=\"description\" ng-model=\"Topic.description\" placeholder=\"\"\r\n                                   data-errormessage=\"Description is required.\" class=\"form-control input-md  validate[required] text-area\"></textarea>\r\n                            </div>\r\n                        </div>\r\n\r\n\r\n                        \r\n\r\n                    </div>\r\n                    <div style=\"clear: both;\"></div>\r\n                    <div style=\"margin-top:20px;\">\r\n                        <button ng-click=\"SubmitTopic(Topic)\" type=\"button\" class=\"btn btn-success\" ng-disabled=\"TopicButton\"  style=\"float: left;\">Submit Reply</button>\r\n                          &nbsp;&nbsp;&nbsp;&nbsp;\r\n                        <button ng-click=\"goBack();\" type=\"button\" style=\"float: left;\">Cancel</button>\r\n                        <div style=\"clear: both;\"></div>\r\n                    </div>\r\n                    <div style=\"clear: both;\"></div>\r\n                   \r\n\r\n                </div>\r\n\r\n            </fieldset>\r\n        </form>\r\n\r\n  </div>\r\n\r\n\r\n</center>\r\n<script type=\"text/javascript\">\r\n    jQuery(document).ready(function () {\r\n        // binds form submission and fields to the validation engine\r\n        // binds form submission and fields to the validation engine\r\n        $(\"form\").validationEngine();\r\n    });\r\n</script>");
$templateCache.put("app/forumSearch/forumSearch.html","<link rel=\"stylesheet\" type=\"text/css\" href=\"./forumSearch/forumSearch.css\">\r\n<!--\r\n<div class=\"geobox\">\r\n<p><a href=\"#!/debateHome\">Forum</a> > <a href=\"#!/forum/{{categoryId}}/{{type}}\"> {{category.title}} </a> > {{subcategory.title}}</p>\r\n    </div>\r\n-->\r\n<p>\r\n  <h2>\r\n    <center>Search</center>\r\n  </h2>\r\n</p>\r\n<p>You searched for the word(s): {{search.text}}</p>\r\n\r\n<!-- Geo Proximity tab -->\r\n<!--<div class=\"geobox\">\r\n<form action=\"\"><fieldset>\r\n    <legend>Choose</legend>\r\n    <input type=\"radio\" name=\"geographic-focus\" value=\"national\" checked /> National\r\n    <input type=\"radio\" name=\"geographic-focus\" value=\"state\"> State\r\n    <input type=\"radio\" name=\"geographic-focus\" value=\"county\"> County\r\n    <input type=\"radio\" name=\"geographic-focus\" value=\"local\"> Local<br>\r\n    </fieldset>\r\n</form>\r\n    </div>\r\n  <div class=\"geobox\">\r\n    <form>\r\n\r\nSkip to: <br>\r\n<select name=\"SUBJECT\">\r\n  <option value=\"CivilLiberties\">Civil Liberties</option>\r\n  <option value=\"Crime\">Crime and Punishment</option>\r\n  <option value=\"Education\">Education</option>\r\n  <option value=\"Energy\">Energy</option>\r\n  <option value=\"Environment\">Environment</option>\r\n  <option value=\"Gun\">Gun Control</option>\r\n  <option value=\"Health\">Health and Safety</option>\r\n  <option value=\"Immigration\">Immigration</option>\r\n  <option value=\"Infrastructure\">Infrastructure</option>\r\n  <option value=\"International\">International Relations</option>\r\n  <option value=\"Jobs\">Jobs and the Economy</option>\r\n  <option value=\"Quality\">Quality of Life</option>\r\n  <option value=\"Reproduction\">Reproduction</option>\r\n  <option value=\"Social\">Social Services</option>\r\n  <option value=\"Taxes\">Taxes</option>\r\n  <option class=\"select-dash\" disabled=\"disabled\">----</option>\r\n    <option value=\"Conspiracy\">Conspiracy Corner</option>\r\n</select>\r\n    </form>\r\n    </div>\r\n<button class=\"geobox\">Change Location</button>\r\n    -->\r\n\r\n<div id=\"tfheader\" class=\"searchbox\" ng-if=\"!ShowAdavace\" style=\"padding-left:10px;\">\r\n  Search word must be longer than 3 letters\r\n  <input type=\"text\" class=\"tftextinput blackText\" ng-model=\"search.text\" name=\"q\" size=\"21\" maxlength=\"120\" ><input type=\"button\" ng-click=\"getForumList(search.text);\" value=\"Forum Search\" class=\"tfbutton\">\r\n  <span ng-click=\"showadvace();\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">More Search Options</span>\r\n  <div class=\"tfclear\"></div>\r\n</div>\r\n\r\n<div id=\"tfheader\" class=\"searchbox\" ng-if=\"ShowAdavace\" style=\"padding-left:10px;\">\r\n  <form name=\"searchform\" id=\"searchform\" method=\"post\" action=\"submit.action\">\r\n    <div class=\"DivClassLeft\">Search for</div>\r\n    <div class=\"DivClassRight\">\r\n      <input type=\"text\" ng-model=\"search.text\" name=\"q\" size=\"21\" maxlength=\"120\" class=\"blackText\">\r\n            </div>\r\n      <div style=\"clear:both;\"></div>\r\n      <div>\r\n        <div class=\"DivClassLeft\">Refine : </div>\r\n\r\n        <!-- SEARCH BOX -->\r\n\r\n        <div class=\"DisplayCat changeTextColor\" style=\"width:325px;\">\r\n          <div class=\"DivClass\">\r\n            <div class=\"leftClass\">\r\n              <input type=\"checkbox\" ng-model=\"search.subject\" ng-true-value=\"\'Subject of Interest\'\" ng-false-value=\"\'NO\'\">\r\n                        </div>\r\n              <div class=\"rightClass\" ng-click=\"showRefine($event, \'Interest\');\">\r\n                Subject of\r\n                Interest&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"!ShowSubcatTree\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"ShowSubcatTree\"></i>\r\n              </div>\r\n            </div>\r\n\r\n            <div ng-repeat=\"subent in subtopics.subcategories track by $index\" ng-include=\"\'field_renderer\'\"\r\n              style=\"padding-left: 5px;\">Loading...</div>\r\n            <!-- Location -->\r\n            <div class=\"DivClass\">\r\n              <div class=\"leftClass\">\r\n                <input type=\"checkbox\" ng-model=\"search.Locations\" ng-true-value=\"\'Location\'\" ng-false-value=\"\'NO\'\">\r\n                        </div>\r\n                <div class=\"rightClass\" ng-click=\"showRefine($event, \'Location\');\">\r\n                  Location&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"!showLoadingLocation\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingLocation\"></i>\r\n                </div>\r\n              </div>\r\n              <ul class=\"TcatList innerCat\" ng-if=\"showRefineLocation\">\r\n                <br>\r\n                <li ng-repeat=\"local in Location track by $index\" style=\"padding-left: 10px;\">\r\n                  <input type=\"checkbox\" ng-click=\"SelectDefaultLocation(local)\" ng-true-value=\"\'{{local}}\'\" ng-false-value=\"\'NO\'\">\r\n                  <label class=\"checkbox\" ng-if=\"local!=\'Other Specific\'\" title=\"{{local}}\"> {{local}}&nbsp;</label>\r\n                  <label class=\"checkbox\" ng-if=\"local==\'Other Specific\'\" ng-click=\"showRefine($event, \'AllLocation\')\" title=\"{{local}}\"> {{local}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"!ShowStateLoader\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"ShowStateLoader\"></i></label>\r\n                  <!-- Select Location Start -->\r\n                  <ul class=\"TcatList innerCat\" ng-if=\"local==\'Other Specific\' && showRefineLocation && showStates\">\r\n                    <li ng-repeat=\"area in allLocations track by $index\">\r\n                      <input type=\"checkbox\" ng-click=\"selectLocation(area, area.state, area.statePostalCode, \'state\')\">\r\n                      <label ng-click=\"getCounties(area.stateFips, \'location\')\">{{area.state}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoading.indexOf(area.statePostalCode)==-1\"></i> <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoading.indexOf(area.statePostalCode) > -1\"></i></label>\r\n                      <!-- Display Counties -->\r\n                      <ul class=\"TcatList innerCat\">\r\n                        <li ng-repeat=\"county in allCounties[area.stateFips] track by $index\">\r\n                          <input type=\"checkbox\" ng-click=\"selectLocation(area, county._id, county._id.county, \'county\')\">\r\n                          <label ng-click=\"getLocals(area.stateFips, county.countyFips, \'location\')\">{{county.countyName}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoadingCounty.indexOf(county.county) == -1\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingCounty.indexOf(county.county) > -1\"></i></label>\r\n                          <!-- Display Locals and sub counties -->\r\n                          <ul class=\"TcatList innerCat\" ng-if=\"Essay.location!=\'National\'\">\r\n                            <li ng-repeat=\"local in allLocals[area.stateFips][county.countyFips] track by $index\">\r\n                              <label class=\"checkbox\" title=\"{{local.placeName}}\">\r\n                                                        <input type=\"checkbox\" ng-click=\"selectLocation(area, county.countyFips, local.placeName, \'local\')\"> {{local.placeName}}\r\n                                                    </label>\r\n                            </li>\r\n                          </ul>\r\n                          <!-- Display Locals and sub counties End -->\r\n                        </li>\r\n                      </ul>\r\n                      <!-- Display Counties End -->\r\n                    </li>\r\n                  </ul>\r\n                  <!-- Select Location End -->\r\n                </li>\r\n              </ul>\r\n              <!-- Select Date Range Start -->\r\n              <div class=\"DivClass\">\r\n                <div class=\"leftClass\">\r\n                  <input type=\"checkbox\" ng-model=\"search.DateRange\" ng-true-value=\"\'DateRange\'\" ng-false-value=\"\'NO\'\">\r\n                        </div>\r\n                  <div class=\"rightClass\" ng-click=\"showRefine($event, \'Date\');\">\r\n                    Date\r\n                    Range&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"!showLoadingMedia\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingMedia\"></i>\r\n                  </div>\r\n                </div>\r\n                <ul class=\"TcatList innerCat\" ng-if=\"showDateRange\">\r\n                  <li ng-repeat=\"range in dateRange track by $index\">\r\n                    <label class=\"checkbox\" title=\"search.dateoption\">\r\n                                <input type=\"checkbox\" ng-model=\"search.dateoption\" ng-true-value=\"\'{{range}}\'\" ng-false-value=\"\'NO\'\"> {{range}}\r\n                            </label>\r\n                  </li>\r\n                  <li>\r\n                    <input type=\"checkbox\" ng-model=\"search.dateoption\" ng-true-value=\"\'Before\'\" ng-false-value=\"\'NO\'\">\r\n                    <label class=\"checkbox\">Before\r\n                                <input type=\"date\" ng-model=\"search.dateBefore\">\r\n                            </label>\r\n                  </li>\r\n                  <li>\r\n                    <input type=\"checkbox\" ng-model=\"search.dateoption1\" ng-true-value=\"\'After\'\" ng-false-value=\"\'NO\'\">\r\n                    <label class=\"checkbox\">After\r\n                                <input type=\"date\" ng-model=\"search.dateAfter\">\r\n                            </label>\r\n                  </li>\r\n                </ul>\r\n                <!-- Select Date Range End -->\r\n                <!-- Match to author Start -->\r\n                <div class=\"DivClass\">\r\n                  <div class=\"leftClass\">\r\n                    <input type=\"checkbox\" ng-model=\"search.matchauthor\" ng-true-value=\"\'Before\'\" ng-false-value=\"\'NO\'\">\r\n                        </div>\r\n                    <div class=\"rightClass\" ng-click=\"showRefine($event, \'Author\');\">Match to\r\n                      Author&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"!showLoadingMedia\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingMedia\"></i>\r\n                    </div>\r\n                  </div>\r\n                  <ul class=\"TcatList\" ng-if=\"showMatchAuthor\">\r\n                    <li> Authors who match you between\r\n                      <input type=\"text\" class=\"numberText\" ng-model=\"search.matchFrom\" id=\"matchFrom\" data-errormessage=\"Please enter only numbers.\" maxlength=\"2\" size=\"2\" /> and\r\n                      <input type=\"text\" class=\"numberText\" ng-model=\"search.matchTo\" id=\"matchTo\" data-errormessage=\"Please enter only numbers.\" maxlength=\"2\" size=\"2\" /> percent\r\n                        </li>\r\n                  </ul>\r\n                  <!-- Match to author End -->\r\n                  <div class=\"DivClass\">\r\n                    <input type=\"checkbox\" ng-model=\"search.fromfollowlist\" ng-true-value=\"\'YES\'\" ng-false-value=\"\'NO\'\"> Authors on my follow list</div>\r\n                  </div>\r\n\r\n\r\n                  <!-- END OF SEARCH BOX-->\r\n\r\n                  <div style=\"clear:both;\"></div>\r\n                </div>\r\n                <div style=\"clear:both;\"></div>\r\n  </form>\r\n  <div class=\"DivClassLeft\">&nbsp;</div>\r\n  <div class=\"DivClassRight\">\r\n    <input type=\"button\" ng-click=\"getForumListAdvance(search);\" value=\"Essay Search\" class=\"tfbuttonNew\">\r\n        </div>\r\n    <div style=\"clear:both;\"></div>\r\n  </div>\r\n\r\n  <br><br>\r\n\r\n  <br>\r\n  <div style=\"padding:10px;\">\r\n    <div style=\"width:90%; float: left;\">\r\n      &nbsp;\r\n    </div>\r\n    <div style=\"width:9%; float: left; text-align: center;\" ng-if=\"searchResults.data.length > 0\">\r\n      <span ng-click=\"showOrder()\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">Sort</span>\r\n    </div>\r\n    <div style=\"clear:both;\"></div>\r\n    <div class=\"OrderList\">\r\n      <div class=\"DisplayCat\" ng-if=\"ShowOrderList\" style=\"float:right; height:100px;\">\r\n        <div class=\"DivClass\">\r\n          <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Most Recent\'\" ng-false-value=\"\'NO\'\">Most Recent\r\n            </div>\r\n          <div class=\"DivClass\">\r\n            <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Oldest\'\" ng-false-value=\"\'NO\'\">Oldest\r\n            </div>\r\n\r\n          </div>\r\n          <div style=\"clear:both;\"></div>\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n      </div>\r\n      <br>\r\n\r\n\r\n      <div style=\"padding-right:30px; float:right;\">\r\n        <dir-pagination-controls max-size=\"5\" pagination-id=\"list.id\" class=\"blackText\"></dir-pagination-controls>\r\n      </div>\r\n      <div class=\"inline2\">\r\n        <div style=\"background-color: #eee; padding:10px; border: solid 1px #000;\" class=\"blackText\"\r\n          dir-paginate=\"forumthread in searchResults.data | orderBy:sortValues:isreverse | itemsPerPage : 10\"\r\n          pagination-id=\"list.id\">\r\n          <!-- <div style=\"background-color: #eee; padding:10px; border: solid 1px #000;\" ng-repeat=\"forumthread in searchResults.data | orderBy : \'-createdOn\'\" ng-if=\"searchResults.data.length > 0\"> -->\r\n          <div style=\"float:left; padding-top:10px;\">&nbsp;</div>\r\n          <div style=\"margin-left:10px; float:left;\">\r\n            <div class=\"boldbox\">\r\n              <span ng-click=\"gotoThread(forumthread);\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">\r\n                {{forumthread.title}}</span>\r\n            </div>\r\n            <div ng-bind-html=\'forumthread.description | urlify\'></div>\r\n            <div><b> Posted to <a href =\"#!/forum/{{forumthread.category._id}}/home\" class=\"link\">{{forumthread.category.title}}</a>\r\n              (Forum) by <img src=\"../assets/images/profile/{{forumthread.createdBy.utype}}.svg\" alt=\"{{forumthread.createdBy.utype}}\"  class=\"usertype\" /><a href =\"#!/pressProfile/{{forumthread.createdBy.id}}\" class=\"link\" ng-if=\"forumthread.createdBy.utype == \'advocate\'\" style=\"text-transform: capitalize;\">\r\n                {{forumthread.orgName}}</a>\r\n             <a href =\"#!/publicProfile/{{forumthread.createdBy.id}}\" class=\"link\" ng-if=\"forumthread.createdBy.utype == \'politician\'\" style=\"text-transform: capitalize;\">\r\n              {{forumthread.pName}}</a>\r\n              <a href =\"#!/voterProfile/{{forumthread.createdBy.id}}\" class=\"link\" ng-if=\"forumthread.createdBy.utype == \'voter\' || \'admin\'\" >\r\n               <span ng-if=\"forumthread.createdBy.utype == \'voter\'\" style=\"text-transform: capitalize;\">{{forumthread.username}}</span> <span ng-if=\"forumthread.createdBy.utype == \'admin\'\" style=\"text-transform: capitalize;\">{{forumthread.createdBy.name}}</span> </a> on\r\n              {{forumthread.createdOn | date:\'medium\'}}</b></div>\r\n          </div>\r\n\r\n          <div style=\"clear:both;\"></div>\r\n        </div>\r\n        <div style=\"background-color: #eee; padding:10px; border: solid 1px #000; height:100px;\"\r\n          ng-if=\"searchResults.data.length == 0\" class=\"blackText\">\r\n          No records found.\r\n        </div>\r\n        <div style=\"float:right;\">\r\n          <dir-pagination-controls max-size=\"5\" pagination-id=\"list.id\" class=\"blackText\"></dir-pagination-controls>\r\n        </div>\r\n      </div>\r\n      <!--<div class=\"boxed\">\r\n    <center><h2>Local Threads</h2></center>\r\n    <p>  This is to be implemented. </p>\r\n    </div>-->\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n      <script type=\"text/ng-template\" id=\"field_renderer\">\r\n   <br> <ul class=\"TcatList\">\r\n\r\n            <li class=\"catname\" id=\"{{subent._id}}\" ng-if=\"(subent.parentIds.length == 0) && (subent.subcategories)\" style=\"padding-left: 10px;\">\r\n                <input type=\"checkbox\" ng-click=\"getVal(subent)\">\r\n                <label ng-click=\"ChangeShow(subent._id);\">{{::subent.title}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id)==-1\"></i><i class=\"fa fa-caret-right\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id) > -1\"></i></label>\r\n            </li>\r\n            <li class=\"catname\" ng-if=\"(subent.parentIds.length == 0) && (!subent.subcategories)\">\r\n                <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                    <input type=\"checkbox\" ng-click=\"getVal(subent)\"> {{::subent.title}}\r\n                </label>\r\n            </li>\r\n            <label class=\"checkbox\" ng-if=\"subent.parentIds.length > 0 && showSubCat\" title=\"{{subent.title}}\">\r\n                <input type=\"checkbox\" ng-click=\"getVal(subent)\"> {{::subent.title}}\r\n            </label>\r\n            <ul ng-if=\"subent.subcategories\" ng-class=\"subent.parentIds.length == 0 ? \'cmnUL MainCatLi_{{subent._id}}\' : \'\'\" style=\"padding-left: 25px;\">\r\n                <li ng-repeat=\"subent in subent.subcategories track by $index\" ng-include=\"\'field_renderer\'\">\r\n                    <!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                      <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n                    </label> -->\r\n                </li>\r\n            </ul>\r\n\r\n    </ul>\r\n</script>\r\n");
$templateCache.put("app/forumthread/forumthread.html","<div>\r\n  <p>\r\n    <b><a href=\"#!/debateHome\" style=text-decoration:underline class=\"ylink\">Forum</a> > <a href=\"#!/forum/{{categoryId}}/home\" style=text-decoration:underline class=\"ylink\"> {{category.title}} </a> > <a href=\"#!/forum/{{subcategoryId}}/home\" style=text-decoration:underline class=\"ylink\"> {{subcategory.title}} </a>>{{froumthreads[0].title}}</b>\r\n  </p>\r\n</div>\r\n\r\n<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">USER FORUM </h2>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <div class=\"blockLink\"><img ng-src=\"./assets/images/ideas4small.svg\" class=\"gettingStartedImg img-fluid\">\r\n        <div class=\"noRollOverBlock2\">\r\n          <div>\r\n            <h4 class=\"gettingStartedBlockTitle\">USER FORUM</h4>\r\n\r\n            <p class=\"gettingStartedBlockDesc\">This is a brainstorming forum meant to discuss the issues and come up\r\n              with workable solutions to the problems that face the world. Insulting each other will not be permitted.\r\n              If you see someone spamming or insulting, mark the comment as abusive. Three strikes and the comment is\r\n              hidden.</p>\r\n											<p>Try to site your sources when possible.</p>\r\n											<p><a href=\"#!/postingHints\" class=\"link\">How to post videos and more from other sites</a></p>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <h4>\r\n    <center>\"{{froumthreads[0].title}}\"</center>\r\n  </h4>\r\n  <!--\r\n\r\n<img src=\"../assets/images/ideas.svg\" class=\"blockInfoImgLearn img-fluid\">\r\n<p>This is a brainstorming forum meant to discuss the issues and come up with workable solutions to the problems that\r\n  face the world. Insulting each other will not be permitted. If you see someone spamming or insulting, mark the comment\r\n  as abusive. Three strikes and the comment is gone.</p>\r\n<p>\r\n  <h2>\r\n    <center>{{subcategory.title}}</center>\r\n  </h2>\r\n</p>\r\n<p><b><center>\"{{froumthreads[0].title}}\"</center></b></p> -->\r\n  <!-- Geo Proximity tab -->\r\n  <br>\r\n  <br>\r\n  <div style=\"clear:both;\"></div>\r\n  <div class=\"inline2\" style=\"margin-bottom: 100px;\">\r\n    <div style=\"width:60%; float:left;\">\r\n      <label>Refine: </label>\r\n    </div>\r\n    <div style=\"width:39%; float:right; text-align: right;\">\r\n      <label>Sort: </label>\r\n    </div>\r\n    <div class=\"inline2\" style=\"margin-bottom: 100px;\">\r\n      <div style=\"width:60%; float:left;\">\r\n        <select ng-model=\"filterBy\" ng-init=\"filterBy = \'all\';\" style=\"text-transform: capitalize; \" class=\"blackText\">\r\n                <option ng-repeat=\"item in filterArray\" val=\"{{item}}\">{{item}}</option>\r\n            </select>\r\n      </div>\r\n      <div style=\"width:39%; float:right; text-align: right;\">\r\n        <select ng-model=\"sortBy\" ng-change=\"SortData()\" style=\"text-transform: capitalize;\" class=\"blackText\">\r\n                <option val=\"Select sort\">Chronological</option>\r\n                <option ng-repeat=\"item in sortArray\" class=\"blackText\" val=\"{{item}}\">{{item}}</option>\r\n            </select>\r\n      </div>\r\n      <div style=\"clear:both;\"></div>\r\n      <div infinite-scroll=\'myPagingFunction()\' infinite-scroll-disabled=\'statusLoading == 1\'\r\n        infinite-scroll-distance=\"1\" class=\"blackText\">\r\n        <table style=\"width:100%\" ng-repeat=\"forumthread in froumthreads | refineData: filterBy\">\r\n          <tr>\r\n            <th colspan=\"2\">{{forumthread.createdOn | date:\'medium\'}}\r\n              <br>\r\n              <div class=\"cell\">\r\n                <div class=\"imageDown\">\r\n\r\n                  <span>\r\n                    <img ng-src=\"../assets/images/profile/{{forumthread.createdBy.utype}}.svg\" ng-if=\"forumthread.createdBy.utype\" class=\"usertype\">\r\n                    </span>\r\n                  <span>\r\n                    <!-- <a href=\"#!/publicProfile/{{forumthread.userData._id}}\" >\r\n                        <b ng-if=\"!forumthread.userData.politician\">{{forumthread.userData.username}}</b>\r\n                        <b ng-if=\"forumthread.userData.politician\">{{forumthread.userData.name}}\r\n                            <span ng-if=\"!forumthread.userData.name\">{{forumthread.userData.username}}</span>\r\n                  </b>\r\n                  </a>\r\n                  <span ng-if=\"forumthread.createdBy.orgdata\">({{forumthread.createdBy.orgdata.title}})</span> -->\r\n\r\n                  <a ng-if=\"forumthread.createdBy.utype == \'politician\'&& forumthread.userData.isEmailVerified && forumthread.userData.verifiedUser\" style=\"text-transform: capitalize;\" href=\"#!/publicProfile/{{forumthread.userData._id}}\" class=\"ylink\">\r\n                    <b ng-if=\"!forumthread.userData.name\" style=\"text-transform: capitalize;\">{{forumthread.userData.username}}</b>\r\n                    <b  style=\"text-transform: capitalize;\">{{forumthread.userData.name}}\r\n\r\n          </b>\r\n          </a>\r\n                  <!-- IF user is Admin CELL PHONE -->\r\n                  <a ng-if=\"forumthread.createdBy.utype == \'admin\'  && forumthread.userData.isEmailVerified && forumthread.userData.verifiedUser\" style=\"text-transform: capitalize;\" href=\"#!/voterProfile/{{forumthread.userData._id}}\" class=\"ylink\">\r\n\r\n            <b ng-if=\"!forumthread.userData.name\" style=\"text-transform: capitalize;\">{{forumthread.userData.username}}</b>\r\n            <b  style=\"text-transform: capitalize;\">{{forumthread.userData.username}}\r\n\r\n  </b>\r\n  </a>\r\n\r\n                  <!-- Posts by voters Cell Phone-->\r\n                  <a ng-if=\"forumthread.createdBy.utype == \'voter\'\" style=\"text-transform: capitalize;\" href=\"#!/voterProfile/{{forumthread.userData._id}}\" class=\"ylink\">\r\n                    <b>{{forumthread.userData.username}}</b>\r\n\r\n        </a>\r\n                  <!-- Posts by orgs Cell Phone -->\r\n                  <a ng-if=\"forumthread.userData.officeId && forumthread.createdBy.utype == \'advocate\' || forumthread.createdBy.utype == \'press\'\" href=\"#!/pressProfile/{{forumthread.userData._id}}\" class=\"ylink\">\r\n          <b ng-if=\"forumthread.createdBy.orgdata.title && forumthread.userData.isEmailVerified && forumthread.userData.verifiedUser\" style=\"text-transform: capitalize;\">\r\n          <span ng-if=\"forumthread.createdBy.orgdata.title\">{{forumthread.createdBy.orgdata.title}}</span>\r\n          </b>\r\n          </a>\r\n                  <b ng-if=\"!forumthread.userData.isEmailVerified || !forumthread.userData.verifiedUser\">\r\n\r\n<!--If politician or org are not identity confirmed -->\r\n<span ng-if=\"forumthread.userData.tempName\" style=\"text-transform: capitalize;\">{{forumthread.userData.tempName}}</span>\r\n<span ng-if=\"forumthread.createdBy.utype == \'politician\' && !forumthread.userData.tempName \">Unknown Politician</span>\r\n<span ng-if=\"forumthread.createdBy.utype == \'advocate\' && !forumthread.userData.tempName \">Unknown Organization</span>\r\n                      </b></span>\r\n                </div>\r\n              </div>\r\n            </th>\r\n          </tr>\r\n          <tr>\r\n            <!--             <div class=\"hideCell\"><td class=\"boldbox\">\r\n                    <a id=\"{{forumthread._id}}\"></a> {{forumthread.title}} </td>\r\n-->\r\n            <td rowspan=\"2\" width=\"250\" class=\"hike\">\r\n              <div class=\"imageDown\">\r\n                <span>\r\n                    <img ng-src=\"../assets/images/profile/{{forumthread.createdBy.utype}}.svg\" ng-if=\"forumthread.createdBy.utype\" class=\"usertype\">\r\n                    <!-- <img src=\"./assets/images/profile/politician.svg\" class=\"usertype\" alt=\"Politician\" ng-if=\"forumthread.createdBy.uype == \'\'\" />\r\n                    <img src=\"./assets/images/profile/press.svg\" class=\"usertype\" alt=\"Press\" ng-if=\"forumthread.userData.press\" />\r\n                    <img src=\"./assets/images/profile/voter.svg\" class =\"usertype\" alt=\"Voter\" ng-if=\"forumthread.userData.voter\" />\r\n                    <img src=\"./assets/images/profile/advocate.svg\" class=\"usertype\" alt=\"Advocate\" ng-if=\"forumthread.userData.advocate\" /> -->\r\n                    <br></span>\r\n              </div>\r\n              <span class=\"blackText\">\r\n<!-- Posts by politicians -->\r\n\r\n<!-- if you want to use the usertype then you can get this using forumthread.createdBy.utype -->\r\n                <a ng-if=\"forumthread.createdBy.utype == \'politician\'&& forumthread.userData.isEmailVerified && forumthread.userData.verifiedUser\" style=\"text-transform: capitalize;\" href=\"#!/publicProfile/{{forumthread.userData._id}}\" class=\"link\">\r\n\r\n                        <b ng-if=\"!forumthread.userData.name\" style=\"text-transform: capitalize;\">{{forumthread.userData.username}}</b>\r\n                        <b  style=\"text-transform: capitalize;\">{{forumthread.userData.name}}\r\n\r\n              </b>\r\n              </a>\r\n              <a ng-if=\"forumthread.createdBy.utype == \'admin\'  && forumthread.userData.isEmailVerified && forumthread.userData.verifiedUser\" style=\"text-transform: capitalize;\" href=\"#!/voterProfile/{{forumthread.userData._id}}\" class=\"link\">\r\n\r\n                <b ng-if=\"!forumthread.userData.name\" style=\"text-transform: capitalize;\">{{forumthread.userData.username}}</b>\r\n                <b  style=\"text-transform: capitalize;\">{{forumthread.userData.username}}\r\n\r\n      </b>\r\n      </a>\r\n\r\n              <!-- Posts by voters -->\r\n              <a ng-if=\"forumthread.createdBy.utype == \'voter\'\" style=\"text-transform: capitalize;\" href=\"#!/voterProfile/{{forumthread.userData._id}}\" class=\"link\">\r\n                        <b>{{forumthread.userData.username}}</b>\r\n\r\n            </a>\r\n              <!-- Posts by orgs -->\r\n              <a ng-if=\"forumthread.userData.officeId && forumthread.createdBy.utype == \'advocate\' || forumthread.createdBy.utype == \'press\'\" href=\"#!/pressProfile/{{forumthread.userData._id}}\" class=\"link\">\r\n              <b ng-if=\"forumthread.createdBy.orgdata.title && forumthread.userData.isEmailVerified && forumthread.userData.verifiedUser\" style=\"text-transform: capitalize;\">\r\n                <!-- {{forumthread.userData.username}}</b>\r\n                        <b ng-if=\"forumthread.userData.isEmailVerified && forumthread.userData.verifiedUser\" style=\"text-transform: capitalize;\">{{forumthread.userData.name}}\r\n                            <span ng-if=\"!forumthread.userData.name && forumthread.userData.isEmailVerified && forumthread.userData.verifiedUser\" style=\"text-transform: capitalize;\">{{forumthread.userData.username}}  </span>{{forumthread.orgdata.title}}x\r\n              </b> -->\r\n              <span ng-if=\"forumthread.createdBy.orgdata.title\">{{forumthread.createdBy.orgdata.title}}</span>\r\n\r\n              </b>\r\n              <b ng-if=\"!forumthread.createdBy.orgdata.title && forumthread.userData.username \">\r\n{{forumthread.userData.username}}\r\n              </b>\r\n              </a>\r\n\r\n              <b ng-if=\"!forumthread.userData.isEmailVerified || !forumthread.userData.verifiedUser\">\r\n\r\n    <span ng-if=\"forumthread.userData.tempName\" style=\"text-transform: capitalize;\">{{forumthread.userData.tempName}}</span>\r\n    <span ng-if=\"forumthread.createdBy.utype == \'politician\' && !forumthread.userData.tempName \">Unknown Politician</span>\r\n    <span ng-if=\"forumthread.createdBy.utype == \'advocate\' && !forumthread.userData.tempName \">Unknown Organization</span>\r\n  </b>\r\n              <!--          <span ng-if=\"forumthread.createdBy.orgdata\">({{forumthread.createdBy.orgdata.title}})</span>-->\r\n              <br> Joined Forum on {{forumthread.userData.created | date:\'MMM d, yyyy\'}}\r\n              <br> Posts {{forumthread.totalpost}}\r\n              <br> Quality Points {{(forumthread.totalpost + forumthread.totalessay + forumthread.totallikes - forumthread.totaldislikes - (forumthread.totalspam * 5))\r\n															< 0 ? 0 : (forumthread.totalpost + forumthread.totalessay + forumthread.totallikes - forumthread.totaldislikes - (forumthread.totalspam * 5))}} </td>\r\n          </tr>\r\n          <tr ng-if=\"forumthread.visible==\'Y\'\">\r\n            <td id=\"thread-{{forumthread._id}}\" >\r\n              <div ng-bind-html=\'forumthread.description | urlify\' style=\"padding-left: 10px; padding-right: 10px; max-width:600px;  margin-left: auto; text-align:left; margin-right: auto; margin-top: 20px; \"></div>\r\n              <br>\r\n              <div ng-if=\"userData.isemailverified\">\r\n                <i class=\"fa fa-thumbs-up thumbs\" ng-click=\"updateForum(\'like\', forumthread._id, forumthread);\" style=\"cursor:pointer;\" alt=\"Like\">{{forumthread.likes}}</i>\r\n\r\n                <i class=\"fa fa-thumbs-down thumbs\" ng-click=\"updateForum(\'dislike\', forumthread._id, forumthread);\" style=\"cursor:pointer;\" alt=\"Dislike\">{{forumthread.dislikes}}</i>\r\n\r\n                <i class=\"fa fa-exclamation-triangle thumbs\" ng-click=\"updateForum(\'spam\', forumthread._id, forumthread);\" style=\"cursor:pointer; color:red;\" alt=\"Report Abuse\">\r\n                {{forumthread.spam}}</i>\r\n                <span style=\"float:right;\">\r\n                        <span ng-click=\"editThread(forumthread)\" ng-if=\"forumthread.userData._id == $root.UserId || userType==\'admin\'\" style=\"cursor:pointer;\" class=\"link\">Edit</span>&nbsp;\r\n                <span ng-click=\"removeThread(forumthread)\" ng-if=\"forumthread.userData._id == $root.UserId || userType==\'admin\'\" style=\"cursor:pointer;\" class=\"link\">Remove</span>&nbsp;\r\n                &nbsp;&nbsp;\r\n                <span ng-if=\"userType==\'admin\'\" style=\"float: right;\">\r\n                            <span ng-click=\"showStickyOrder(forumthread._id)\" ng-if=\"forumthread.sticky==\'N\'\" style=\"cursor:pointer;\" class=\"link\" class=\"link\">Make it sticky <br/>\r\n                            <span ng-if=\"Sticky.ShowOrder[forumthread._id]\">\r\n                            Order: <input type=\"number\" value=\"0\" style=\"width: 40px;\" ng-model=\"Sticky.txtOrder[forumthread._id]\" maxlength=\"2\" /> <input type=\"button\" ng-click=\"updateForum(\'sticky\', forumthread._id, $index);\" name=\"btnSticky\" value=\"Set Sticky\">\r\n                            </span>\r\n                </span>\r\n                <spam ng-click=\"updateForum(\'removeSticky\', forumthread._id, $index);\" ng-if=\"forumthread.sticky==\'Y\'\"\r\n                  style=\"cursor:pointer;\" class=\"link\">Remove sticky </spam>\r\n                </span>\r\n                </span>\r\n              </div>\r\n            </td>\r\n          </tr>\r\n          <tr ng-if=\"forumthread.visible==\'N\'\">\r\n            <td style=\"color:red;\">\r\n              <div ng-click=\"DisplaySpam(forumthread._id)\" style=\"text-decoration:underline; cursor:pointer;\">This\r\n                thread\r\n                is reported as spam or abusive.</div>\r\n              <br/>\r\n              <small ng-if=\"userType==\'admin\' || showSpam.indexOf(forumthread._id) > -1\"><div ng-bind-html=\'forumthread.description | urlify\'></div></small>\r\n              <div ng-if=\"userType==\'admin\'\" style=\"float: right;\">\r\n                <span ng-click=\"sendMessage(forumthread)\" style=\"cursor:pointer; text-decoration: underline;\">Send message to {{forumthread.createdBy.name}} </span>&nbsp;&nbsp;&nbsp;\r\n                <span ng-click=\"removeThread(forumthread)\" style=\"cursor:pointer; text-decoration: underline;\" class=\"link\">Remove</span>&nbsp;&nbsp;&nbsp;<span ng-click=\"notSpam(forumthread)\" style=\"cursor:pointer; text-decoration: underline;\" class=\"link\">Not a spam</span>\r\n              </div>\r\n            </td>\r\n          </tr>\r\n          </td>\r\n        </table>\r\n        <p class=\"fwb\" ng-if=\"statusLoading == 1\"> <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i> Loading thread\r\n          please\r\n          wait...</p>\r\n      </div>\r\n      <div class=\"footer\">\r\n        <div class=\"container\">\r\n          <div ng-if=\"userData.isemailverified\">\r\n            <center>\r\n              <button ng-click=\"redirectToReply();\" ng-if=\"displayReply\" class=\"compareBtn\">REPLY</button>\r\n            </center>\r\n          </div>\r\n          <div ng-if=\"!userData.isemailverified\" style=color:red>\r\n            <center>\r\n              <h3>Verify Email address and Re-Log In to Reply</h3>\r\n            </center>\r\n          </div>\r\n          <div ng-if=\"!userData.isemailverified\" ng-click=\"sendVeriMail()\" style=color:red>\r\n            <center><button ng-click=\"sendVeriMail()\" class=\"compareBtn\">\r\n            Resend Confirmation Email</button></center>\r\n          </div>\r\n          <div class=\"inline2\" ng-if=\"ShowReply\">\r\n            <form name=\"topicform\" id=\"topicform\">\r\n              <fieldset class=\"scheduler-border\">\r\n                <legend class=\"scheduler-border\">Thread reply</legend>\r\n                <p></p>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-12\">\r\n                    <!--<div class=\"control-group\">\r\n                                    <div><small>(Note: Use screen name if you do not want to share your name with others.)</small></div>\r\n                                    <label class=\"control-label\" for=\"profile-name\">Screen name : </label>\r\n                                    <input type=\"text\" ng-model=\"Reply.screenname\" placeholder=\"\" data-errormessage=\"Thread title is required.\" class=\"form-control input-md  validate[required] text-input\">\r\n                                </div> -->\r\n                    <div class=\"control-group\">\r\n                      <label class=\"control-label\" for=\"profile-name\">Your reply : </label>\r\n                      <div class=\"controls\">\r\n                        <textarea id=\"description\" ng-model=\"Reply.description\" placeholder=\"\" data-errormessage=\"Description is required.\" class=\"form-control input-md  validate[required] text-area\"></textarea>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div style=\"clear: both;\"></div>\r\n                  <div style=\"margin-top:20px;\">\r\n                    <button ng-click=\"SubmitReply(Reply)\" type=\"button\" class=\"compareBtn\" ng-disabled=\"TopicButton\" style=\"float: left;\">Submit Reply</button>\r\n                    &nbsp;&nbsp;&nbsp;&nbsp;\r\n                    <button ng-click=\"goBack();\" type=\"button\" class=\"compareBtn\" style=\"float: left;\">Cancel</button>\r\n                    <div style=\"clear: both;\"></div>\r\n                  </div>\r\n                  <div style=\"clear: both;\"></div>\r\n                </div>\r\n              </fieldset>\r\n            </form>\r\n          </div>\r\n          <script type=\"text/ng-template\" id=\"templateId\">\r\n                    <fieldset class=\"scheduler-border\">\r\n                        <legend class=\"scheduler-border\">Update reply</legend>\r\n                        <p></p>\r\n                        <div class=\"row\">\r\n                            <div class=\"col-md-12\">\r\n                                <div class=\"control-group\">\r\n                                    <div class=\"controls\">\r\n                                        <textarea id=\"description\" ng-model=\"editDescription.description\" placeholder=\"\" data-errormessage=\"Description is required.\" class=\"form-control input-md  validate[required] text-area\" style=\"width:95%; height:250px;\"></textarea>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                            <div style=\"clear: both;\"></div>\r\n                            <div style=\"margin-top:20px;\">\r\n                                <button ng-click=\"UpdateReply(editDescription)\" type=\"button\" class=\"compareBtn btn-success\" ng-disabled=\"TopicButton\" style=\"float: left;\">Update Reply</button>\r\n                                &nbsp;&nbsp;&nbsp;&nbsp;\r\n                                <button ng-click=\"closeThisDialog(\'templateId\');\" type=\"button\" style=\"float: left;\">Cancel</button>\r\n                                <div style=\"clear: both;\"></div>\r\n                            </div>\r\n                            <div style=\"clear: both;\"></div>\r\n                        </div>\r\n                    </fieldset>\r\n                    </form>\r\n                </script>\r\n        </div>\r\n      </div>\r\n      <script type=\"text/ng-template\" id=\"sendMessage\">\r\n            <div>\r\n                <div class=\"catname\">\r\n                    <div>Message :</div>\r\n                    <div>\r\n                        <textarea ng-model=\"spamMessage\" style=\"width:100%; height:100px;\"></textarea>\r\n                    </div>\r\n                </div>\r\n                <div class=\"ngdialog-buttons\">\r\n                    <button type=\"button\" class=\"ngdialog-button ngdialog-button-primary\" ng-click=\"sendMail(spamMessage)\">Send</button>\r\n                    <button type=\"button\" class=\"ngdialog-button ngdialog-button-secondary\" ng-click=\"closeThisDialog(0)\">Cancel</button>\r\n                </div>\r\n            </div>\r\n        </script>\r\n");
$templateCache.put("app/generatePostCards/generatePostCard.html","<div class=\"container-fluid\">\r\n  <h2>Select State</h2>\r\n  <div class=\"control-group\">\r\n    <label class=\"control-label\" for=\"email\">State </label>\r\n    <div class=\"controls\">\r\n      <select\r\n        class=\"changeTextColor\"\r\n        ng-model=\"params.state\"\r\n        style=\"text-transform: capitalize\"\r\n        ng-options=\"item.state for item in allState track by item.state\"\r\n      ></select\r\n      >&nbsp;\r\n      <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loader\"></i>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"control-group\">\r\n    <label for=\"electionDate\"> ElectionDate</label>\r\n    <select\r\n      ng-model=\"params.electionDate\"\r\n      ng-options=\"item as item.eDate for item in electionDates\"\r\n      ng-change=\"generatePostCard()\"\r\n      class=\"changeTextColor form-control\"\r\n      style=\"width: 35%\"\r\n    ></select>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/geoCode/geoCode.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">LOCATION</h2>\r\n  <p class=\"pageSubHeading\">Type in your address and find out which districts you live in.</p>\r\n  ");
$templateCache.put("app/getAReminder/getAReminder.html"," <div class=\"container-fluid\">\r\n     <h2 class=\"pageHeading\">GET A REMINDER</h2>\r\n  <p class=\"pageSubHeading\">Use the form below to have Vote.org send you reminders to vote.  Please note VoteWise and Vote.org are two separate organizations. We have no control over what they send you, but it can be useful to be reminded on election day.</p>\r\n\r\n\r\n<iframe src=\"https://reminders.vote.org/?partner=111111&campaign=free-tools\" width=\"100%\" height=\"1100\" marginheight=\"0\" frameborder=\"0\" id=\"frame4\" scrollable =\"yes\"></iframe><script type=\"text/javascript\" src=\"//cdnjs.cloudflare.com/ajax/libs/iframe-resizer/3.5.3/iframeResizer.min.js\"></script><script type=\"text/javascript\">iFrameResize({ log:true, checkOrigin:false});</script>\r\n</div>");
$templateCache.put("app/getBillVoteRecords/getBillVoteRecords.html","<div class=\"container-fluid\">\r\n     <div ng-if=\"userProfile && userProfile.registeredUser\">\r\n    <h2 class=\"pageHeading\">{{userProfile.name}}</h2>\r\n    <div class=\"pageSubHeading\">\r\n      <div ng-if=\"userProfile.office\"> {{userProfile.office}}</div>\r\n      <div ng-if=\"userProfile.party\">{{userProfile.party}}</div>\r\n      <div ng-if=\"memberRole.votes_with_party_pct\">Votes along party lines {{memberRole.votes_with_party_pct}}%</div>\r\n    </div>\r\n  </div>\r\n  <form name=\"getBillVoteRecords\" id=\"getBillVoteRecords\" ng-controller=\"getBillVoteRecordsCtrl\" class=\"closeForm\">\r\n    <div class=\"row d-none d-lg-flex\">\r\n      <div class=\"col-lg-4 offset-md-2 removePaddingRight\">\r\n        <a href=\"\" ng-click=\"getBillVotes()\" class=\"removeAnchorUnderline\">\r\n      <p ng-if=\"!show\" id=\"seeElectedPolitician\">See Bill Sponsored</p>\r\n      <p ng-if=\"show\" id=\"seeElectedPoliticianCompare\">See Bill Sponsored</p>\r\n  </a>\r\n      </div>\r\n      <div class=\"col-lg-4 removePaddingLeft\">\r\n        <a href=\"\" ng-click=\"getVotes()\" class=\"removeAnchorUnderline\">\r\n        <p ng-if=\"!show\" id=\"seeCandidiates\">See Voters </p>\r\n        <p ng-if=\"show\" id=\"seeCandidiatesCompare\">See Voters </p>\r\n      </a>\r\n      </div>\r\n    </div>\r\n    <!-- Small Screen -->\r\n    <div class=\"row d-lg-none\">\r\n      <div class=\"col-6 removePaddingRight\">\r\n        <a href=\"\" ng-click=\"getBillVotes()\" class=\"removeAnchorUnderline\">\r\n\r\n     <p ng-if=\"!show\" id=\"seeElectedPolitician\">See Bill Sponsored</p>\r\n      <p ng-if=\"show\" id=\"seeElectedPoliticianCompare\">See Bill Sponsored</p>\r\n  </a>\r\n      </div>\r\n      <div class=\"col-6 removePaddingLeft\">\r\n        <a href=\"\" ng-click=\"getVotes()\" class=\"removeAnchorUnderline\">\r\n        <p ng-if=\"!show\" id=\"seeCandidiates\">See Voters </p>\r\n        <p ng-if=\"show\" id=\"seeCandidiatesCompare\">See Voters </p>\r\n      </a>\r\n      </div>\r\n    </div>\r\n    <div class=\"alert alert-danger alert-dismissible\" id=\"alert\" ng-if=\"alert\" style=\"width:40%;margin-left:\r\n            28%\">\r\n      <button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button>\r\n      <strong>Record Not Found</strong>\r\n    </div>\r\n    \r\n 	 <center>\r\n    <div ng-if=\"showLoader\" style=\"z-index: 2; background:black;\"><i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span></div>\r\n\r\n  </center>\r\n    <div ng-if=\"!show\">\r\n      <fieldset class=\"scheduler-border\" ng-if=\"bill.length > 0\">\r\n        <div class=\"form-group row\">\r\n          <label style=\"color:#ffffff;padding-left: 5%;padding-right: 5%\">Title : </label>\r\n          <!-- <div class=\"col-lg-5 col-sm-5\"> -->\r\n          <input type=\"text\" ng-model=\"searchCandy.search\" id=\"searchCandy\" class=\"form-control\" placeholder=\"Search by Title\" style=\"width:170px;\">\r\n          <button class=\"blackText\" style=\"margin-left:5%\" ng-click=\"SearchByTitle()\">Search</button>\r\n\r\n          <!-- </div> -->\r\n        </div>\r\n        <legend class=\"scheduler-border\">Bill Details</legend>\r\n        <div class=\"contactBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\" style=\"width: 100%\">\r\n          <div infinite-scroll=\'myPagingFunction()\'>\r\n            <div class=\"row\">\r\n              <div class=\"col-md-12\">\r\n                  <br>\r\n                <div ng-repeat=\" n in bill\">\r\n<p>{{n.identifier}}</p>\r\n                  <p ng-if=\"n.title\">Title: {{n.title}}</p>\r\n                  <p ng-repeat=\"a in n.abstracts\">\r\n                    <span>Abstract : {{a.abstract}}</span>\r\n                  </p>\r\n  <!--     USERS DON\"T NEED TO SEE THIS INFO             \r\n                  <p>\r\n                                        <span>Bill Id : - {{n.billId}}</span><br>\r\n                    <span>Classification : {{n.classification[0]}}  </span>\r\n                  </p>\r\n                  \r\n                  <p>\r\n <span>Jurisdiction: {{n.legislativeSession.jurisdiction.name}}</span><br>\r\n                  </p>\r\n-->\r\n                    <p>LegislativeSession</p>\r\n                   <p>Identifier: {{n.legislativeSession.identifier}}</p> \r\n\r\n                   \r\n                  \r\n                  <p><a href=\"\" class=\"link\" ng-show=\"n.documents.length > 0\" ng-click=\"activeDoc = !activeDoc\" ng-class=\"{\'expandcollapse-heading-collapsed\': activeDoc, \'expandcollapse-heading-expanded\': !activeDoc}\">Documents</a></p>\r\n                  <div class=\"slideDown\" ng-hide=\"activeDoc\">\r\n                    <p ng-repeat=\"d in n.documents\" ng-if=\"n.documents.length > 0\">\r\n                      <span ng-if=\"d.date\">Date: {{d.date}}</span>\r\n                      <span ng-if=\"d.note\">Note: {{d.note}}</span>\r\n                      <span ng-if=\"d.links[0].url\">Links: <a href=\"{{d.links[0].url}}\" target=\"_blank\" ng-if=\"n.documents.length > 0\" class=\"link\">{{d.links[0].url}}</a> </span>\r\n                    </p>\r\n                    <!-- <p><a href=\"\" ng-if=\"documents[\'document\']\" class=\"link\" ng-click=\"showLess(\'document\')\">Less</a></p> -->\r\n                  </div>\r\n                  <p><a href=\"\" class=\"link\" ng-click=\"activeAct = !activeAct\" ng-class=\"{\'expandcollapse-heading-collapsed\': activeAct, \'expandcollapse-heading-expanded\': !activeAct}\">Actions</a></p>\r\n                  <div class=\"slideDown\" ng-hide=\"activeAct\">\r\n                    <p ng-repeat=\"u in n.actions\">\r\n                      <span>Date: {{u.date | date:\" MM/dd/y\"}}</span><br>\r\n                      <span>Classification: {{u.classification[0]}}</span><br>\r\n                      <span>Description: {{u.description}}</span>\r\n                    </p>\r\n                  <!--   <p> <a href=\"\" ng-if=\"more[\'action\']\" class=\"link\" ng-click=\"showLess(\'action\')\">Less</a></p> -->\r\n                  </div>\r\n                  <p><a href=\"\" class=\"link\" ng-click=\"activeSpo = !activeSpo\" ng-class=\"{\'expandcollapse-heading-collapsed\': activeSpo, \'expandcollapse-heading-expanded\': !activeSpo}\">Sponsors</a></p>\r\n                  <div class=\"slideDown\" ng-hide=\"activeSpo\">\r\n                    <div class=\"p\" ng-repeat=\"s in n.sponsorships\">\r\n<!-- Users don\'t need this info\r\n                      <span>entityType : {{s.entityType}}</span><br>\r\n                      <br>\r\n-->\r\n                      <div ng-if=\"s.name\">Name: {{s.name}}</div>\r\n                     \r\n                      <div ng-if=\"s.organization\">Organization : {{s.organization}}</div>\r\n                     \r\n <!-- Users don\'t need this info\r\n                     <span ng-if=\"s.person\">Person : {{s.person}}</span>\r\n-->\r\n                    </div>\r\n                    <!-- <p> <a href=\"\" ng-if=\"more[\'sponsorships\']\" class=\"link\" ng-click=\"showLess(\'sponsorships\')\">Less</a></p> -->\r\n                  </div>\r\n                    <hr>\r\n                  <p><a href=\"\" class=\"link\" ng-show=\"n.votes.edges.length > 0\" ng-click=\"activeVot = !activeVot\" ng-class=\"{\'expandcollapse-heading-collapsed\': activeVot, \'expandcollapse-heading-expanded\': !activeVot}\">Votes</a></p>\r\n                  <div class=\"slideDown\" ng-hide=\"activeVot\">\r\n                    <div ng-repeat=\"v in n.votes.edges\" ng-if=\"n.votes.edges.length > 0\">\r\n                      <p ng-if=\"v.node.billAction\">Bill Action: </p>\r\n                      <br>\r\n                      <p ng-repeat=\"c in v.node.counts\">\r\n                        <span>Counts</span>\r\n                          <span>Option: {{c.option}}</span>\r\n                          <br>\r\n                          <span>Value: {{c.value}} </span>\r\n                      </p>\r\n                      <br>\r\n                      <p>\r\n                        <span>Organization</span>\r\n                        <span>Classification: {{v.node.organization.classification}}</span>\r\n                        <br>\r\n                        <span> Name: {{v.node.organization.name}}</span>\r\n                        <br>\r\n                        <span> Result: {{v.node.result}}</span>\r\n                        <br>\r\n                      </p>\r\n                      <p ng-repeat=\"cv in v.node.votes\">\r\n                        <span>Votes </span>\r\n                        <span>Option: {{cv.option}}</span>\r\n                        <br>\r\n                        <span>VoterName: {{cv.voterName}} </span>\r\n                        <br>\r\n                        <span ng-if=\"cv.voter\">Voter: {{cv.voter}} </span>\r\n                      </p>\r\n                    </div>\r\n                    <!-- <p> <a href=\"\" ng-if=\"more[\'votes\']\" class=\"link\" ng-click=\"showLess(\'votes\')\">Less</a></p> -->\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <p ng-if=\"statusGetResPg == 1 && searchData > bill.length\" class=\"fwb\">Loading OpenState Data...</p>\r\n          </div>\r\n        </div>\r\n      </fieldset>\r\n    </div>\r\n    <div ng-if=\"show\">\r\n      <fieldset class=\"scheduler-border\" ng-if=\"votes.length > 0\">\r\n        <div class=\"form-group row\">\r\n          <label style=\"color:#ffffff;padding-left: 5%;padding-right: 5%\">Title: </label>\r\n          <!-- <div class=\"col-lg-5 col-sm-5\"> -->\r\n          <input type=\"text\" ng-model=\"searchCandy.search\" id=\"searchCandy\" class=\"form-control\" placeholder=\"Search by Title\" style=\"width:170px;\">\r\n          <button class=\"blackText\" style=\"margin-left:5%\" ng-click=\"SearchByTitle()\">Search</button>\r\n          \r\n          <!-- </div> -->\r\n        </div>\r\n        <legend class=\"scheduler-border\">Bill Details</legend>\r\n        <div class=\"contactBlock d-flex justify-center container-fluid col-sm-12 col-lg-7\" style=\"width: 100%\">\r\n          <div infinite-scroll=\'myPagingFunctionOne()\'>\r\n            <div class=\"row\">\r\n              <div class=\"col-md-12\">\r\n                <div ng-repeat=\" n in votes | filter:searchMe\">\r\n                  <p ng-if=\"n.title\">Title: {{n.title}}</p>\r\n                  <p ng-repeat=\"a in n.abstracts\">\r\n                    <span>Abstract: {{a.abstract}}</span>\r\n                  </p>\r\n                  <p>\r\n                    <span>Bill Id: {{n.billId}}</span><br>\r\n                    <span>Classification : {{n.classification[0]}}  </span>\r\n                  </p>\r\n                  <p>Identifier: {{n.identifier}}</p>\r\n                  <p>\r\n                    <span>LegislativeSession</span>\r\n                    <!-- <span>Identifier : {{legislativeSession.identifier}}</span> -->\r\n                    <span>Jurisdiction: {{n.legislativeSession.jurisdiction.name}}</span><br>\r\n                  </p>\r\n                  <p>\r\n                    <a href=\"\" ng-if=\"n.documents.length > 0\" class=\"link\" ng-click=\"getDetailsOfCandidates(\'document\');\">Documents</a>\r\n                  </p>\r\n                  <div ng-if=\"documents[\'document\']\">\r\n                    <p ng-repeat=\"d in n.documents\" ng-if=\"n.documents.length > 0\">\r\n                      <span ng-if=\"d.date\">Date: {{d.date}}</span>\r\n                      <span ng-if=\"d.note\">Note: {{d.note}}</span>\r\n                      <span ng-if=\"d.links[0].url\">Links: <a href=\"{{d.links[0].url}}\" target=\"_blank\" ng-if=\"n.documents.length > 0\" class=\"link\">{{d.links[0].url}}</a> </span>\r\n                    </p>\r\n                    <p><a href=\"\" ng-if=\"documents[\'document\']\" class=\"link\" ng-click=\"showLess(\'document\')\">Less</a></p>\r\n                  </div>\r\n                  <p><a href=\"\" class=\"link\" ng-click=\"getDetailsOfCandidates(\'action\');\">Actions</a></p>\r\n                  <div ng-if=\"more[\'action\']\">\r\n                    <p ng-repeat=\"u in n.actions\">\r\n                      <span>Date: {{u.date}}</span>\r\n                      <span>Classification: {{u.classification[0]}}</span>\r\n                      <span>Description: {{u.description}}</span>\r\n                    </p>\r\n                    <p> <a href=\"\" ng-if=\"more[\'action\']\" class=\"link\" ng-click=\"showLess(\'action\')\">Less</a></p>\r\n                  </div>\r\n                  <p><a href=\"\" class=\"link\" ng-click=\"getDetailsOfCandidates(\'sponsorships\');\">Sponsorships</a></p>\r\n                  <div ng-if=\"more[\'sponsorships\']\">\r\n                    <p ng-repeat=\"s in n.sponsorships\">\r\n                      <span>entityType: {{s.entityType}}</span>\r\n                      <br>\r\n                      <span>Name: {{s.name}}</span>\r\n                      <br>\r\n                      <span ng-if=\"s.organization\">Organization: {{s.organization}}</span>\r\n                      <br>\r\n                      <span ng-if=\"s.person\">Person: {{s.person}}</span>\r\n                    </p>\r\n                    <p> <a href=\"\" ng-if=\"more[\'sponsorships\']\" class=\"link\" ng-click=\"showLess(\'sponsorships\')\">Less</a></p>\r\n                  </div>\r\n                  <p><a href=\"\" class=\"link\" ng-if=\"n.votes.edges.length > 0\" ng-click=\"getDetailsOfCandidates(\'votes\');\">Votes</a></p>\r\n                  <div ng-if=\"more[\'votes\']\">\r\n                    <div ng-repeat=\"v in n.votes.edges\" ng-if=\"n.votes.edges.length > 0\">\r\n                      <p ng-if=\"v.node.billAction\">Bill Action: </p>\r\n                      <br>\r\n                      <p ng-repeat=\"c in v.node.counts\">\r\n                        <span>Counts</span>\r\n                          <span>Option: {{c.option}}</span>\r\n                          <br>\r\n                          <span>Value: {{c.value}} </span>\r\n                      </p>\r\n                      <br>\r\n                      <p>\r\n                        <span>Organization</span>\r\n                        <span>Classification: {{v.node.organization.classification}}</span>\r\n                        <br>\r\n                        <span> Name: {{v.node.organization.name}}</span>\r\n                        <br>\r\n                        <span> Result: {{v.node.result}}</span>\r\n                        <br>\r\n                      </p>\r\n                      <p ng-repeat=\"cv in v.node.votes\">\r\n                        <span>Votes </span>\r\n                        <span>Option: {{cv.option}}</span>\r\n                        <br>\r\n                        <span>VoterName: {{cv.voterName}} </span>\r\n                        <br>\r\n                        <span ng-if=\"cv.voter\">Voter: {{cv.voter}} </span>\r\n                      </p>\r\n                    </div>\r\n                    <p> <a href=\"\" ng-if=\"more[\'votes\']\" class=\"link\" ng-click=\"showLess(\'votes\')\">Less</a></p>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!-- <p ng-if=\"votes.length == 0\">Records Not Found</p> -->\r\n            <!-- <p ng-if=\"statusGetResPg == 1 && votes.length > 0\" class=\"fwb\">Loading OpenState Data...</p> -->\r\n            <p ng-if=\"statusGetResPg == 1 && searchData > bill.length\" class=\"fwb\">Loading OpenState Data...</p>\r\n            \r\n          </div>\r\n        </div>\r\n      </fieldset>\r\n    </div>\r\n  </form>\r\n</div>\r\n");
$templateCache.put("app/getPopularComparison/getPopularComparison.html","<div class=\"container-fluid\">\r\n  <div style=\"text-align:left;\">\r\n    <div ng-if=\"noDataFound == false\">\r\n      <div class=\"squareBoxY\" style=\"margin-left:10px;\">&nbsp;</div>\r\n      <span>= Simple Comparison by answers alone.</span>\r\n      <div style=\"clear:both;\"></div>\r\n      <div class=\"squareBoxB\" style=\"margin-left:10px\">&nbsp;</div>\r\n      <span>= Weighted Comparison by answers and importance.</span>\r\n      <div style=\"clear:both;\"></div>\r\n    </div>\r\n    <div ng-if=\"loader\" class=\"fwb\">\r\n      Loading data ...\r\n      <p>\r\n        <center><i class=\"fa fa-refresh fa-spin\" style=\"font-size:72px;\"></i></center>\r\n      </p>\r\n    </div>\r\n\r\n\r\n    <br>\r\n\r\n    <ul class=\"catList\" ng-if=\"noDataFound == false\">\r\n      <li ng-if=\"politician\">\r\n        <div style=\"background-color:#ffffee; padding:10px;\">\r\n          <div style=\"color: #000000;\"><b>\r\n\r\n           </b>\r\n            <b ng-if=\"userId\">Politicians in your area</b>&nbsp;&nbsp;&nbsp;Total\r\n            Answered questions: {{fbqlen}}\r\n          </div>\r\n          <div style=\"width: 84%; float:left;\">\r\n            <div>\r\n              <div class=\"fbunweighted\" style=\"width:{{(FBunWeighted  )  | number:2}}%\">{{(FBunWeighted ) | number:2}}%\r\n              </div>\r\n            </div>\r\n            <div>\r\n              <div class=\"fbweighted\" style=\"width:{{(fbcombinedWeight / fbmultiplier)  | number:2}}%\">{{(fbcombinedWeight\r\n                / fbmultiplier) | number:2}}%</div>\r\n            </div>\r\n          </div>\r\n          <div style=\"clear:both;\"></div>\r\n        </div>\r\n      </li>\r\n    </ul>\r\n    <ul class=\"catList\" ng-if=\"noDataFound == false\">\r\n      <li ng-if=\"showadv\">\r\n        <div style=\"background-color:#ffffee; padding:10px;\">\r\n          <div style=\"color: #000000;\"><b>\r\n\r\n           </b><b ng-if=\"userId\">{{orgName}}</b>&nbsp;&nbsp;&nbsp;Total\r\n            Answered questions: {{ansCnt}}\r\n          </div>\r\n          <div style=\"width: 84%; float:left;\">\r\n            <div>\r\n              <div class=\"fbunweighted\" style=\"width:{{(advUnWeighated)  | number:2}}%\">{{(advUnWeighated) | number:2}}%\r\n              </div>\r\n            </div>\r\n            <div>\r\n              <div class=\"fbweighted\" style=\"width:{{(advCombined / advMulti)  | number:2}}%\">{{(advCombined\r\n                / advMulti) | number:2}}%</div>\r\n            </div>\r\n          </div>\r\n          <div style=\"clear:both;\"></div>\r\n        </div>\r\n      </li>\r\n    </ul>\r\n\r\n    <ul class=\"catList\" ng-if=\"noDataFound == false\">\r\n      <li ng-if=\"showvoter\">\r\n        <div style=\"background-color:#ffffee; padding:10px;\">\r\n          <div style=\"color: #000000;\"><b>\r\n\r\n           </b><b ng-if=\"userId\">Voters</b>&nbsp;&nbsp;&nbsp;Total\r\n            Answered questions: {{fbqlen}}\r\n          </div>\r\n          <div style=\"width: 84%; float:left;\">\r\n            <div>\r\n              <div class=\"fbunweighted\" style=\"width:{{(voterUnWeighated  )  | number:2}}%\">{{(voterUnWeighated\r\n                 ) | number:2}}%</div>\r\n            </div>\r\n            <div>\r\n              <div class=\"fbweighted\" style=\"width:{{(voterCombined / voterMulti)  | number:2}}%\">{{(voterCombined\r\n                / voterMulti) | number:2}}%</div>\r\n            </div>\r\n          </div>\r\n          <div style=\"clear:both;\"></div>\r\n        </div>\r\n      </li>\r\n    </ul>\r\n\r\n  </div>\r\n  <button class=\"compareBtn\"><a href=\"#!/whatAmILookingAt2\">What Am I Looking At?</a></button>\r\n</div>\r\n");
$templateCache.put("app/getPopularQuestions/getPopularQues.html","<div class=\"container-fluid\" ng-cloak\r\n  ng-show=\"$root.userRole==\'admin\'|| $root.userRole==\'advocate\' || $root.userRole==\'politician\'\">\r\n\r\n  <div class=\"container-fluid ng-scope\">\r\n    <h2 class=\"pageHeading\">POPULAR QUESTIONS</h2>\r\n    <p class=\"pageSubHeading\">Use the search functions below to create a custom quiz made up of the questions that are\r\n      most frequently answered by voters, politicians, or organizations.</p>\r\n\r\n\r\n    <form ng-submit=\"find()\" name=\"myForm\" role=\"form\">\r\n      <fieldset class=\"scheduler-border\">\r\n        <legend class=\"scheduler-border\">Find Most Popular Questions</legend>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-4\">\r\n            <h6>Select User Type</h6>\r\n            <div class=\"form-group disInLine\">\r\n\r\n\r\n              <input type=\"checkbox\" class=\"marLeft\" ng-model=\"isSelect.voter\" name=\"voter\" id=\"voter\">\r\n              <label for=\"voter\"> Voter</label>\r\n            </div>\r\n            <div class=\"form-group disInLine\">\r\n\r\n\r\n              <input type=\"checkbox\" class=\"marLeft\" ng-model=\"isSelect.politician\" name=\"poli\" id=\"poli\">\r\n              <label for=\"poli\"> Politician</label>\r\n            </div>\r\n            <div class=\"form-group disInLine\">\r\n\r\n\r\n              <input type=\"checkbox\" class=\"marLeft\" ng-model=\"isSelect.organization\" name=\"organization\" id=\"organization\">\r\n              <label for=\"organization\"> Organization</label>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-md-4\">\r\n            <div>\r\n              <label class=\"control-label formLabel whiteText\" for=\"email\">Topic</label>\r\n\r\n              <!-- <div>\r\n                    <input type=\"text\" ng-model=\"isSelect.topic\" class=\"form-control\" style=\"width:50%;display:initial\">\r\n                  </div> -->\r\n              <div class=\"formLabel\">Select topic and subtopics to find questions</div>\r\n              <p class=\"fwb\" ng-if=\"statusGetCats == 1\">Loading categories ...</p>\r\n              <div ng-show=\"statusGetCats == 2\" ng-repeat=\"cat in selCatForQues\" class=\"pull-left\"\r\n                style=\"padding: 5px;\">\r\n                <select class=\"pull-left changeTextColor\" ng-model=\"cat[\'selected\']\" ng-change=\"selQuesCategory(cat[\'selected\'], $index)\">\r\n                                <option ng-repeat=\"item in cat.items\" value={{item}}>\r\n                                    {{item.order}}) {{item.title}}\r\n                                </option>\r\n                            </select>\r\n              </div>\r\n              <div class=\"fwb\" ng-if=\"statusSubCat == 1\">Loading sub categories(if any) ...</div>\r\n              <div style=\"clear: both;\"></div>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-md-4\">\r\n            <div>\r\n              <label class=\"control-label formLabel whiteText\" for=\"email\">I want my quiz to be </label>\r\n\r\n\r\n              <input type=\"number\" name=\"noOfQues\" ng-model=\"isSelect.numOfQues\"  min=\"0\" max=\"50\" class=\"form-control\" style=\"width:60px;display:initial\" required> questions long. (50 max)\r\n\r\n              <div role=\"alert\">\r\n                <span class=\"error\" ng-show=\"myForm.noOfQues.$dirty && myForm.noOfQues.$error.number\">Please Add Valid Number</span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n\r\n        <div style=\"text-align: center;margin-top: 2%\">\r\n          <button class=\"compareBtn  btn-success\" type=\"submit\">\r\n                              Find\r\n                            </button>\r\n          <!-- </div> -->\r\n        </div>\r\n      </fieldset>\r\n\r\n    </form>\r\n  </div>\r\n");
$templateCache.put("app/getRollVotes/getRollVotes.html","<div class=\"container-fluid\">\r\n  <h2 class=\"pageHeading\">Settings</h2>\r\n \r\n  <div>\r\n    <div class=\"closeForm\" ng-include=\"\'app/popups/setting_Ctrl.html\'\"></div>\r\n  </div>\r\n  <h1>Votes</h1>\r\n\r\n  <form name=\"votes\" id=\"votes\" ng-controller=\"getRollVotesCtrl\" class=\"closeForm\">\r\n    <p>\r\n      <a href=\"javascript: void(0)\" class=\"ylink\" ng-click=\"addVotes()\">Get Votes</a>\r\n      <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loaderOne\"></i>\r\n    </p>\r\n    <div ng-show=\"votesData.length>0\">\r\n      <!--  <div class=\"form-group row\">\r\n          <label style=\"color:#ffffff;padding-left: 5%;padding-right: 5%\">Title: </label>\r\n     \r\n          <input type=\"text\" ng-model=\"searchCandy.search\" id=\"searchCandy\" class=\"form-control\" placeholder=\"Search by Title\" style=\"width:170px;\">\r\n          <button class=\"blackText\" style=\"margin-left:5%\" ng-click=\"SearchByTitle()\">Search</button>\r\n\r\n        </div> -->\r\n      <div infinite-scroll=\'myPagingFunction()\'>\r\n        <table class=\"w100 changeTextColor\" ng-show=\"votesData.length > 0\">\r\n          <tr>\r\n            <th style=\"width:15%\">Bill Type</th>\r\n            <th style=\"width:60%\">Subject</th>\r\n            <th style=\"width:15%\">Session</th>\r\n            <th style=\"width:9%\">Details</th>\r\n          </tr>\r\n          <tr ng-repeat=\"u in votesData\">\r\n            <td>\r\n              <span ng-if=\"u.type\">{{u.type}}</span>\r\n            </td>\r\n            <td>\r\n              <p>\r\n                <span ng-if=\"u.subject\">{{u.subject}}</span>\r\n                <p>\r\n            </td>\r\n            <td>\r\n              <p>\r\n                <span ng-if=\"u.session\">{{u.session}}</span></p>\r\n            </td>\r\n            <td>\r\n              <a href=\"#!/getVotesDetails/{{u._id}}\" class=\"link\">Get Details</a>\r\n            </td>\r\n          </tr>\r\n          <tr ng-if=\"votesData.length == 0\">\r\n            <td colspan=\"3\"> No records found.\r\n            </td>\r\n          </tr>\r\n        </table>\r\n        <p ng-if=\"statusGetResPg == 1 && serachData > votesData.length\" class=\"fwb\">Loading OpenState Data...</p>\r\n      </div>\r\n    </div>\r\n  </form>\r\n</div>\r\n");
$templateCache.put("app/gettingStarted/gettingstarted.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">GETTING STARTED</h2>\r\n  <p class=\"pageSubHeading\">Choose your next action. Most of these actions are available through\r\n    the menu bar at the top of the screen. Others are in the \"My Account\" drop down.</p>\r\n			<div class=\"centerediframe\">\r\n  <iframe src=\"https://player.vimeo.com/video/442583285?byline=false&title=false\" allowfullscreen ></iframe>\r\n</div>\r\n		<center>\r\n								      <div class=\"col-lg-6 col-sm-12 gettingStartedContainer\">\r\n															<a href=\"#!/fiveMatch/fiveminquiz/\" class=\"blockLink\">\r\n              <img ng-src=\"./assets/images/5minQuizIcon.jpg\" class=\"gettingStartedImg img-fluid\">\r\n               <div class=\"gettingStartedBlock gettingStartedBlock2\">             \r\n                <div>\r\n                  <h5 class=\"blockTitle\">5-MINUTE MATCH</h5>\r\n                  <p class=\"gettingStartedBlockDesc\">\r\n	Click here to take the 5-Minute Match Quiz</p>\r\n\r\n																</div></div></a>\r\n              \r\n	</div>\r\n		<br></center>\r\n  <div class=\"row\">\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/userProfile/\" class=\"blockLink\"><img ng-src=\"./assets/images/ProfileSettings3.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock1\">\r\n          <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">PROFILE SETTINGS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Choose the subjects that matter to you most so you can be informed about events as they arise. Pick news sources, privacy settings, and many other things to make your experience more productive and enjoyable.</p>\r\n\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/questionHome\" class=\"blockLink\"><img ng-src=\"./assets/images/clipBoard2.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock2\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">POLITICAL MATCH QUESTIONS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Answer multiple choice questions to express your views on countless topics.  These answers can be used to find politicians and organizations that match your vision.  They can also be used by those in power as a guide for how best to help the people they represent.  The multiple choice answers allow for quick understanding of thousands of people’s thoughts, and your added comments add depth to those thoughts.</p>\r\n\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/learnHome\" class=\"blockLink\"><img ng-src=\"./assets/images/Learn2.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock3\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">LEARN ABOUT THE TOPICS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Get tons of useful information about the topics that interest you by watching videos or reading articles from organizations that devote their entire existence to the topics you are curious about.  See the same issue from many sides.  Also learn about the basics of politics, economics, where to vote, how to register, how to read through political double speak and many other userful things.</p>\r\n\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/debateHome\" class=\"blockLink\"><img ng-src=\"./assets/images/discuss4.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock4\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">DISCUSS THE ISSUES</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Engage in debate and discuss the issues with other voters, politicians, and organizations  in your town, your county, state or accross the United States.  Work towards solutions to the problems we face.</p>\r\n\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/incumbent_politician/politician\" class=\"blockLink\"><img ng-src=\"./assets/images/politiciansRBB7-01.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock5\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">YOUR POLITICIANS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Contact the politicians that represent you to ask for help.  Find out what they stand for, who stands behind them, and who pays for their campaigns.  See their voting record. Compare politicians who are running for office, using your match quizzes to see who would best represent your interests.  Watch debates, read essays, and more.</p>\r\n\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/advocateHome\" class=\"blockLink\"><img ng-src=\"./assets/images/Organizations.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock6\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">ORGANIZATIONS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">You may feel like one drop in the ocean, but if many drops come together, they can form a tsunami with incredible power.  Use this tool to find organizations that you can team up with to make the change you want to see in the world.</p>\r\n\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/liveFeed\" class=\"blockLink\"><img ng-src=\"./assets/images/press9.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock7\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">NEWS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Get local and national news feeds from the sources you trust.  More tools are on the way.</p>\r\n\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/gettingStartedOrg/gettingStartedOrg.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">GETTING STARTED</h2>\r\n  <p class=\"pageSubHeading\">Choose your next action. Most of the actions can easily be accessed\r\n    in the tool bar above. Some are in the \"My Account\" drop down menu. Your tools are laid out differently than voters\r\n    to give you easier access to the tools you use most.</p>\r\n\r\n\r\n<div class=\"centerediframe\">\r\n  <iframe src=\"https://player.vimeo.com/video/399178873?byline=false&title=false\" allowfullscreen ></iframe>\r\n</div>\r\n		<center>\r\n								      <div class=\"col-lg-6 col-sm-12 gettingStartedContainer\">\r\n															<a href=\"#!/fiveMatch/fiveminquiz/\" class=\"blockLink\">\r\n              <img ng-src=\"./assets/images/5minQuizIcon.jpg\" class=\"gettingStartedImg img-fluid\">\r\n               <div class=\"gettingStartedBlock gettingStartedBlock2\">             \r\n                <div>\r\n                  <h5 class=\"blockTitle\">5-MINUTE MATCH</h5>\r\n                  <p class=\"gettingStartedBlockDesc\">\r\n	Click here to take the 5-Minute Match Quiz</p>\r\n\r\n																</div></div></a>\r\n              \r\n	</div>\r\n		<br></center>\r\n	\r\n  <div class=\"row\">\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/userProfile/\" class=\"blockLink\"><img ng-src=\"./assets/images/ProfileSettings3.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock1\">\r\n          <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">PROFILE SETTINGS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Choose the subjects and locations that matter to you most.  Describe what your organization is about.  Add contact information and create your public persona.</p>\r\n\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/speakOut\" class=\"blockLink\"><img ng-src=\"./assets/images/speakOut.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock2\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">SPEAK OUT</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Post essays and videos.  Discuss the issues.  Rate or endorse politicians.  Take quizzes so that voters, politicians and other organizations can get matched up to you so your words have deeper meaning and so they can work with you towards your shared goals.</p>\r\n\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/research\" class=\"blockLink\"><img ng-src=\"./assets/images/research.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock3\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">RESEARCH</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Read essays, watch videos, post your own. Get polling data.  Research politicians and legislation. </p>\r\n\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/allies\" class=\"blockLink\"><img ng-src=\"./assets/images/findAllies2.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock4\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">FIND ALLIES</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Take quizzes and get matched up with voters, politicians and other organizations.  Get followers.  </p>\r\n\r\n            <!--\r\nPost quizzes to Facebook to generate more interest in your cause.</p>\r\n-->\r\n\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n\r\n    <!--   REACTIVATE WHEN DONATION TOOL IS BUILT\r\n       <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/incumbent_politician/politician\" class=\"blockLink\"><img ng-src=\"./assets/images/politiciansRBB7-01.svg\" class=\"gettingStartedImg img-fluid\"></a>\r\n      <div class=\"gettingStartedBlock gettingStartedBlock5\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">CREATE A CAMPAIGN</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Create a donation link.  More tools are on the way.</p>\r\n          <p><a href=\"#!/incumbent_politician/politician\" class=\"link\">Create a Campaign</a></p>\r\n        </div>\r\n      </div>\r\n    </div>  -->\r\n\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/liveFeed\" class=\"blockLink\"><img ng-src=\"./assets/images/press9.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock7\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">NEWS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Get local and national news feeds from the sources you trust, and more tools are on the way.</p>\r\n\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n  </div>\r\n</div>\r\n<script type=\"text/ng-template\" id=\"popUp\">\r\n  <div class=\"container\">\r\n   <p ng-if=\"showBoth && $root.userRole==\'politician\'\">You can read, but you can\'t write anything on the site until you confirm your email address.  <br><br> After you confirm your email, you can write, but everything will have the byline \"Unknown Politician\" until we can confirm your identification (then all your work will change to your byline).  You can wait for us to research you or you can use our automated ID confirmation system (which costs $1)</p>\r\n			<p ng-if=\"showBoth && $root.userRole==\'advocate\'\">You can read, but you can\'t write anything on the site until you confirm your email address.  <br><br> After you confirm your email, you can write, but everything will have the byline \"Unknown Organization\" until we can confirm your identification (then all your work will change to your byline).</p>\r\n   <p ng-if=\"showEm\">You can read, but you can\'t write anything on the site until you confirm your email address.</p>\r\n   <p ng-if=\"$root.userRole==\'politician\' && showCon && !showBoth && !showEm\">We still need to confirm you are who you say you are. If you are running for a large office, we will do the research to figure that out.  If you are running for a more local office and you don\'t want to wait for us, you can use the automated ID check which costs $1.</p>\r\n\r\n   <div class=\"ngdialog-buttons\">\r\n   <button  ng-click=\"sendMail()\" type=\"button\" class=\"ngdialog-button ngdialog-button-primary\" ng-if=\"showEm  || (showBoth && $root.userRole==\'politician\')\">Resend Confirmation Email</button>\r\n   <button ng-click=\"goto()\" ng-if=\"showCon && $root.userRole==\'politician\'\" type=\"button\" class=\"ngdialog-button ngdialog-button-primary\">Confirm Id</button>\r\n   <button ng-click=\"closeIt()\" type=\"button\" class=\"ngdialog-button ngdialog-button-primary\">Later</button>\r\n   </div>\r\n  </div>\r\n\r\n\r\n\r\n</script>\r\n");
$templateCache.put("app/gettingStartedPol/gettingStartedPol.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">GETTING STARTED</h2>\r\n  <p class=\"pageSubHeading\">Choose your next action. Most actions are available in the menu bar\r\n    above. Others are in the \"My Account\" drop down. Your tools differ from those of voters.</p>\r\n	<div class=\"centerediframe\">\r\n  <iframe src=\"https://player.vimeo.com/video/406711248?byline=false&title=false\" allowfullscreen ></iframe>\r\n</div>\r\n		\r\n	<center>\r\n								      <div class=\"col-lg-6 col-sm-12 gettingStartedContainer\">\r\n															<a href=\"#!/fiveMatch/fiveminquiz/\" class=\"blockLink\">\r\n              <img ng-src=\"./assets/images/5minQuizIcon.jpg\" class=\"gettingStartedImg img-fluid\">\r\n               <div class=\"gettingStartedBlock gettingStartedBlock2\">             \r\n                <div>\r\n                  <h5 class=\"blockTitle\">5-MINUTE MATCH</h5>\r\n                  <p class=\"gettingStartedBlockDesc\">\r\n	Click here to take the 5-Minute Match Quiz</p>\r\n\r\n																</div></div></a>\r\n              \r\n	</div>\r\n		<br></center>\r\n  <div class=\"row\">\r\n			\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/userProfile/\" class=\"blockLink\"><img ng-src=\"./assets/images/ProfileSettings3.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock1\">\r\n          <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">PROFILE SETTINGS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Control how the world sees you.  Add or correct contact information.  Post links to your websites.  Make a statement. More tools are on the way.</p>\r\n\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/winVoters\" class=\"blockLink\"><img ng-src=\"./assets/images/clipBoard2.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock2\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">WIN VOTERS AND ALLIES</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Answer multiple choice questions to express your views on countless topics.  These answers can be used by voters and organizations to be matched up with you just like an online dating site but for politics.  Because life doesn\'t always fit into multiple choice, every question also allows you to add your own comments.  </p>\r\n\r\n            <!--Or post the quizzes you answer to Facebook for a fun way to generate interest in the topics you care about most.</p>\r\n-->\r\n\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/debateHome\" class=\"blockLink\"><img ng-src=\"./assets/images/discuss4.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock4\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">DISCUSS THE ISSUES</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Engage in debate and discuss the issues with other voters, politicians, and organizations  in your town, your county, state or accross the United States.  Work towards solutions to the problems we face.</p>\r\n\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n\r\n\r\n\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/learnHome\" class=\"blockLink\"><img ng-src=\"./assets/images/Learn2.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock3\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">RESEARCH THE TOPICS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Get tons of useful information about the topics that interest you by watching videos or reading articles from organizations that devote their entire existence to the topics you are curious about.  See the same issue from many sides.  </p>\r\n\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n\r\n    <!-- *************** BRING BACK\r\n\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/incumbent_politician/politician\" class=\"blockLink\"><img ng-src=\"./assets/images/politiciansRBB7-01.svg\" class=\"gettingStartedImg img-fluid\"></a>\r\n      <div class=\"gettingStartedBlock gettingStartedBlock5\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">CAMPAIGN</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Post statements and videos. Get donations and more.</p>\r\n          <p><a href=\"#!/incumbent_politician/politician\" class=\"link\">View Your Politicians</a></p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    -->\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/allies\" class=\"blockLink\"><img ng-src=\"./assets/images/findAllies2.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock4\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">FIND ALLIES</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Take quizzes and get matched up with voters, politicians and other organizations.  Get followers.  </p>\r\n\r\n            <!--\r\nPost quizzes to Facebook to generate more interest in your cause.</p>\r\n-->\r\n\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n\r\n\r\n\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/liveFeed\" class=\"blockLink\"><img ng-src=\"./assets/images/press9.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock7\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">NEWS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Get local and national news feeds from the sources you trust.  More tools are on the way.</p>\r\n\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n  </div>\r\n</div>\r\n<script type=\"text/ng-template\" id=\"popUp\">\r\n  <div class=\"container\">\r\n   <p ng-if=\"showBoth && $root.userRole==\'politician\'\">You can read, but you can\'t write anything on the site until you confirm your email address.  <br><br> After you confirm your email, you can write, but everything will have the byline \"Unknown Politician\" until we can confirm your identification (then all your work will change to your byline).  You can wait for us to research you or you can use our automated ID confirmation system (which costs $1)</p>\r\n			<p ng-if=\"showBoth && $root.userRole==\'advocate\'\">You can read, but you can\'t write anything on the site until you confirm your email address.  <br><br> After you confirm your email, you can write, but everything will have the byline \"Unknown Organization\" until we can confirm your identification (then all your work will change to your byline).</p>\r\n   <p ng-if=\"showEm\">You can read, but you can\'t write anything on the site until you confirm your email address.</p>\r\n   <p ng-if=\"$root.userRole==\'politician\' && showCon && !showBoth && !showEm\">We still need to confirm you are who you say you are. If you are running for a large office, we will do the research to figure that out.  If you are running for a more local office and you don\'t want to wait for us, you can use the automated ID check which costs $1.</p>\r\n\r\n   <div class=\"ngdialog-buttons\">\r\n   <button  ng-click=\"sendMail()\" type=\"button\" class=\"ngdialog-button ngdialog-button-primary\" ng-if=\"showEm  || (showBoth && $root.userRole==\'politician\')\">Resend Confirmation Email</button>\r\n   <button ng-click=\"goto()\" ng-if=\"showCon && $root.userRole==\'politician\'\" type=\"button\" class=\"ngdialog-button ngdialog-button-primary\">Confirm Id</button>\r\n   <button ng-click=\"closeIt()\" type=\"button\" class=\"ngdialog-button ngdialog-button-primary\">Later</button>\r\n   </div>\r\n  </div>\r\n\r\n\r\n\r\n</script>\r\n");
$templateCache.put("app/getVotesDetails/getVotesDetails.html","<div class=\"container-fluid\">\r\n  <!-- <h4>Details of vote</h4> -->\r\n  <div>\r\n    <div>\r\n      <a href=\"#!/getRollVotes\" class=\"ylink\">Back</a>\r\n      <fieldset class=\"scheduler-border\">\r\n        <legend class=\"scheduler-border\">Vote Detail</legend>\r\n        <div class=\"contactBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\" style=\"width: 100%\">\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n              <p ng-if=\"details.question\"> Question: {{details.question}}</p>\r\n              <p ng-if=\"details.category\">Category: {{details.category}}</p>\r\n              <p ng-if=\"details.date\"> Date: {{details.date | date : \"M/d/y\"}}</p>\r\n              <p ng-if=\"details.chamber\">Chamber: {{details.chamber}}</p>\r\n              <p ng-if=\"details.result\">Result: {{details.result}}</p>\r\n              <p ng-if=\"details.session\">Session: {{details.session}}</p>\r\n              <p ng-if=\"details.subject\">Subject: {{details.subject}}\r\n              </p>\r\n              <p>\r\n                <span ng-if=\"details.updated_at\"> Updated: {{details.updated_at | date : \'M/d/y\'}} </span>\r\n                <br>\r\n                <span ng-if=\"details.number\"> Number: {{details.number}} </span>\r\n                <br>\r\n                 <span ng-if=\"details.source_url\">Source url: <a href=\"{{details.source_url}}\" target=\"_blank\" ng-if=\"details.source_url\" class=\"link\">{{details.source_url}}</a> </span>\r\n              </p>\r\n              <p>\r\n                <a href=\"\" ng-show=\"details.votes\" class=\"link\" ng-click=\"activeDoc = !activeDoc\">Votes</a>\r\n              </p>\r\n              <div ng-hide=\"activeDoc\">\r\n                <p ng-if=\"details.votes.yes.length > 0\"> Yes</p>\r\n                <p ng-show=\"details.votes.yes.length > 0\" ng-repeat=\" y in details.votes.yes \">\r\n                  <span ng-if=\"y.name\">Name:  {{y.name}}</span>\r\n                  <br>\r\n                  <span ng-if=\"y.party\">Party:  {{y.party}}</span>\r\n                  <br>\r\n                  <span ng-if=\"y.state\">State:  {{y.state}}</span>\r\n                </p>\r\n                <p ng-if=\"details.votes.no.length > 0\"> No</p>\r\n                <p ng-show=\"details.votes.no.length > 0\" ng-repeat=\" n in details.votes.no \">\r\n                  <span ng-if=\"n.name\">Name:  {{n.name}}</span>\r\n                  <br>\r\n                  <span ng-if=\"n.party\">Party:  {{n.party}}</span>\r\n                  <br>\r\n                  <span ng-if=\"n.state\">State:  {{n.state}}</span>\r\n                </p>\r\n                <p ng-if=\"details.votes.notVoting.length > 0\"> Not Voting</p>\r\n                <p ng-show=\"details.votes.notVoting.length > 0\" ng-repeat=\" n in details.votes.notVoting \">\r\n                  <span ng-if=\"n.name\">Name:  {{n.name}}</span>\r\n                  <br>\r\n                  <span ng-if=\"n.party\">Party:  {{n.party}}</span>\r\n                  <br>\r\n                  <span ng-if=\"n.state\">State:  {{n.state}}</span>\r\n                </p>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </fieldset>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/gridState/gridState.html","<div class=\"container-fluid ng-scope\" ng-cloak ng-show=\"$root.userRole==\'admin\'\">\r\n  <h2 class=\"pageHeading\">Settings</h2>\r\n  <div>\r\n    <div class=\"closeForm\" ng-include=\"\'app/popups/setting_Ctrl.html\'\"></div>\r\n  </div>\r\n  <!-- UI grid state start -->\r\n  <form ng-if=\"showHUpload\" name=\"Uploadform\" id=\"Uploadform\" ng-controller=\"GridStateCtrl\" class=\"closeForm\">\r\n    <div class=\"row\" style=\"margin-top: 10px;\">\r\n      <p>\r\n        <h3>Grid states user wise</h3>\r\n      </p>\r\n      <table class=\"w100 changeTextColor\">\r\n        <tr>\r\n          <th style=\"width:50%\">User</th>\r\n          <th style=\"width:40%\">Data</th>\r\n          <th style=\"width:10%\">Remove</th>\r\n        </tr>\r\n        <tr ng-repeat=\"u in users.data track by $index\">\r\n          <td>\r\n            <div>{{u.name}}</div>\r\n            <p>\r\n              <strong>username:</strong> {{u.username}},\r\n              <strong>email:</strong> {{u.email}}\r\n            </p>\r\n          </td>\r\n          <td>{{u.CountyName}}, {{u.StatePostalCode}}</td>\r\n          <td>\r\n            <a href=\"javascript: void(0)\" ng-click=\"removeGrid(u, $index)\" class=\"link\">Remove</a>\r\n          </td>\r\n        </tr>\r\n        <tr ng-if=\"users.data.length==0\">\r\n          <td colspan=\"3\">\r\n            <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoading\"></i>\r\n            <span ng-if=\"!showLoading\">No records found.</span>\r\n          </td>\r\n        </tr>\r\n      </table>\r\n    </div>\r\n  </form>\r\n  <!-- UI grid state end -->\r\n</div>\r\n");
$templateCache.put("app/highlightedPost/highlightedPost.html","<div class=\"container-fluid\" ng-controller=\"highlightedPostCtrl\">\r\n  <!-- <h1>Welcome</h1> -->\r\n  <br>\r\n  <a href=\"#!/pressProfile/{{pressId}}\" class=\"ylink\" >Back</a>\r\n  <div style=\"text-align: center\">\r\n    <h3>Highlighted Post</h3>\r\n  </div>\r\n  <br>\r\n  <div class=\"container\">\r\n    <div class=\"row\">\r\n      <div class=\"col-lg-6 col-md-6 col-sm-6\" ng-repeat=\"item in HighlightedPost\">\r\n        <div class=\"jumbotron jumbotron-fluid infoCard\">\r\n          <div class=\"container blackText\">\r\n            <div class=\"boldbox\">\r\n              <a href=\"#!/essayDetails/{{categoryId}}/{{item._id}}\" class=\"elink\">{{item.title}}</a>\r\n              <div class=\"DescriptionImg\" ng-bind-html=\'item.description | urlifyshort\'>\r\n              </div>\r\n            </div>\r\n            <br>\r\n            <div><strong>Recommended :</strong>\r\n              <input-stars max=\"5\" ng-model=\"forumthread.recavg\" ng-if=\"showAvg\" readonly>\r\n              </input-stars>\r\n              <input-stars max=\"5\" ng-model=\"forumthread.recavgvoters\" ng-if=\"showVoters\" readonly>\r\n              </input-stars>\r\n              <input-stars max=\"5\" ng-model=\"forumthread.recavgpolitician\" ng-if=\"showPolitician\" readonly>\r\n              </input-stars>\r\n              <input-stars max=\"5\" ng-model=\"forumthread.recavgadvocate\" ng-if=\"showAdvocate\" readonly>\r\n              </input-stars>\r\n              <input-stars max=\"5\" ng-model=\"forumthread.recavgpress\" ng-if=\"showPress\" readonly>\r\n              </input-stars>\r\n              <input-stars max=\"5\" ng-model=\"forumthread.recavgfollow\" ng-if=\"showFollow\" readonly>\r\n              </input-stars>\r\n              , <strong>Factual :</strong>\r\n              <input-stars max=\"5\" ng-model=\"forumthread.factfavg\" ng-if=\"showfAvg\" readonly>\r\n              </input-stars>\r\n              <input-stars max=\"5\" ng-model=\"forumthread.factfavgvoters\" ng-if=\"showfVoters\" readonly>\r\n              </input-stars>\r\n              <input-stars max=\"5\" ng-model=\"forumthread.factfavgpolitician\" ng-if=\"showfPolitician\" readonly>\r\n              </input-stars>\r\n              <input-stars max=\"5\" ng-model=\"forumthread.factfavgadvocate\" ng-if=\"showfAdvocate\" readonly>\r\n              </input-stars>\r\n              <input-stars max=\"5\" ng-model=\"forumthread.factfavgpress\" ng-if=\"showfPress\" readonly>\r\n              </input-stars>\r\n              <input-stars max=\"5\" ng-model=\"forumthread.factfavgfollow\" ng-if=\"showfFollow\" readonly>\r\n              </input-stars>\r\n\r\n            </div>\r\n            <hr>\r\n            <div style=\"clear:both;\">\r\n              Posted by\r\n              <a href=\"#!/publicProfile/{{item.createdBy.id}}\" class=\"link\">\r\n                {{item.createdBy.name}}\r\n                <span ng-if=\"item.createdBy.orgdata\">({{item.createdBy.orgdata.title}})</span>\r\n                </a> on {{item.createdOn | date:\'medium\'}}\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/howABillBecomesALaw/howABillBecomesALaw.html","<div class=\"container-fluid ng-scope\">\r\n <h2 class=\"pageHeading\">HOW A BILL BECOMES A LAW</h2>\r\n  <p class=\"pageSubHeading\">This describes the process that the United States Congress uses to create laws.  States, counties, and cities all have their own way of doing things, but many are based on the concepts created for the Federal Congress.  This should take less than an hour to read outloud, but much longer to really understand the ins and outs.</p>\r\n    <p class=\"pageSubHeading\">Please note that we often use the word, \"he\" when talking generically about a human being.  This is to make reading easier and not meant to infer that the person is male.</p>\r\n    \r\n    <div class=\"container-fluid\">\r\n    <div class=\"row basicContainer\">\r\n    <span class=\"anchorHidden\" id=\"top\"></span>\r\n      <div class=\"col col-lg-4 basicTopics\">\r\n      <div>  <!--  style=\" position: fixed;\r\n     width: 29%;\r\n     height: 500px; background-color:#ccc; overflow:scroll;\" id=\"social-float\" -->\r\n        <h3 style=\"text-align:center; padding-bottom:15px;\">Table of Content</h3>\r\n        \r\n       <ul>\r\n         <li> <a href=\"\" class=\"mainTopicNoIcon\" ng-click=\"$root.gotoAnchor(\'_Toc459927138\')\">INTRODUCTION</a></li>\r\n        \r\n            \r\n              <li><a href=\"\" class=\"card-title\" ng-click=\"$root.gotoAnchor(\'_Toc459927139\')\">Proposing a Bill</a></li>\r\n            \r\n              \r\n                <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927140\')\">Speaker of the House Decides Action</a></li>\r\n                <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927141\')\">The Bill Goes to Committee</a></li>\r\n                <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927142\')\">House Committee Mark-Up</a></li>\r\n             \r\n            \r\n              <li><a href=\"\" class=\"card-title\" ng-click=\"$root.gotoAnchor(\'_Toc459927143\')\">House Committee Report</a></li>\r\n\r\n                <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927144\')\">Goes Back to Speaker</a></li>\r\n \r\n                <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927145\')\">Rules Committee</a></li>\r\n                <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc4599271462\')\">House Debate</a></li>\r\n                  <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc4599271461\')\">Bill Goes to Senate</a></li>\r\n                <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927146\')\">Bill Goes to Senate Committee</a></li>\r\n                <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927147\')\">Bill Goes to Senate Majority Leader</a></li>\r\n                <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927148\')\">Getting Recognized</a></li>\r\n             \r\n            <li>\r\n              <a href=\"\" class=\"card-title\" ng-click=\"$root.gotoAnchor(\'_Toc459927149\')\">Senate Debate</a></li>\r\n            \r\n															<li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927150\')\">Merging Bills</a></li>                  <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927151\')\">Bill Goes to President</a></li>\r\n                  <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927152\')\">Extra Things to Know</a></li>\r\n                <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927153\')\">Additional Documents</a></li>\r\n                  <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927154\')\">Additional Educational Links</a>\r\n                </ul>         \r\n          \r\n          \r\n \r\n        </div>\r\n      </div>\r\n      <div class=\"col col-lg-8 basicInfo\"><br>\r\n							<center><h3>HOW A LAW IS CREATED</h3></center><br><br>\r\n							<span class=\"anchorHidden\" id=\"_Toc459927138\"></span>\r\n							<center><b>INTRODUCTION</b></center>\r\n       <p>First let&rsquo;s start off with a couple definitions.</p>\r\n<p>A &ldquo;law&rdquo; is a rule that is binding to the public and enforced by the government.</p>\r\n<p>A &ldquo;resolution&rdquo; is an agreed upon official statement that does not force anyone to take an action but may influence action.&nbsp; For example, the government may vote to condemn an atrocity committed by another country.</p>\r\n<p>&ldquo;Legislation&rdquo; is the term for anything that a government body discusses and eventually votes on whether it is a law or a resolution or anything else.</p>\r\n<p>We are going to skip past resolutions for now and talk only about laws.</p>\r\n<p>The ways that legislation is passed on the federal, state and local levels vary from location to location.&nbsp; We will discuss Federal here.&nbsp; Your local rules for making laws will likely be very similar, but you will have to research your local rules elsewhere.</p>\r\n<p>The Federal Government has three branches: The Executive Branch (The President), The Legislative Branch (The House and Senate) and the Judicial Branch (The Federal and Supreme Courts).&nbsp; Each branch will eventually weigh in on laws.&nbsp; The legislative branch writes the law, the Executive branch gives its stamp of approval, and the Judicial branch eventually looks at the law and decides if it was well written or if it goes against the Constitution and therefore isn&rsquo;t legal.</p>\r\n<p>Please note: Congress is made up of two &ldquo;houses&rdquo; (lower case &lsquo;h&rsquo;).&nbsp; The House of Representatives is often referred to as &ldquo;the House&rdquo; for short (capital &lsquo;H&rsquo;.)&nbsp; The other house is the Senate and since it&rsquo;s already one word, there&rsquo;s no short name for it.</p>\r\n<p>Every two years, we hold elections to elect our House of Representatives.&nbsp; The winners of these election along with the Senators form a team call a &ldquo;Congress&rdquo;.&nbsp; This Congress has two years to get things done before they are voted out or re-elected.&nbsp; Anything started during those two years but not finished dies and must go back to square one with the new Congress as if it had never been proposed before.&nbsp; As of this writing, the current Congress is called &ldquo;The 116<sup>th</sup> Congress&rdquo; going from Jan 2019- Dec 2020.&nbsp; Previous congresses include 115<sup>th</sup> (2017/2018), 114<sup>th</sup> (2015/2016), etc..</p>\r\n<p>Senators are elected every 6 years, but their elections are staggered 2 years apart so that there is more consistency in their membership.&nbsp; One third gets elected one year, then another third 2 years later, then the last third 2 years after that.&nbsp; The Senators elected in these periods are called &ldquo;class 1&rdquo;, &ldquo;class 2&rdquo; and &ldquo;class 3&rdquo; respectively, and then the cycle repeats.</p>\r\n<p>Before I get into the steps, it&rsquo;s important to say that these steps and the associated rules, for the most part, are not laid out by the Constitution.&nbsp; For most things, the Constitution just says that a bill must pass both houses by simple majority and then be signed by the President in order to become law.</p>\r\n<p>But over the last couple hundred years, the people in office found that there needed to be further rules to make things run smoothly.&nbsp; These rules sometimes change.&nbsp; Sometimes they change to make things work better.&nbsp; Sometimes they change to give more power to the party in power.&nbsp; But these rules don&rsquo;t go against the Constitution.&nbsp; For example, the Senate has the sole capability to approve Presidential appointments including to the Supreme Court.&nbsp; At one point, it sounded like a really good idea that members of the Supreme Court should be people that most congressmen thought were respectable and wise.&nbsp; To ensure that was the case, the Senate created rules that added a step in the process that essentially required 60 of the 100 Senators to agree before the Supreme Court nomination would be voted on.&nbsp; Most years, the senate is split close to 50/50 so this pretty much guaranteed that you would need to get some of the other party to vote for your judge &ndash; so you couldn&rsquo;t elect anyone incredibly radical.&nbsp; But then, in recent times, Senators found that they were too partisan to agree on anyone at 60%, so they changed the rules to go by simple majority.</p>\r\n							<span class=\"anchorHidden\" id=\"_Toc459927139\"></span>\r\n<center><p><b>STEP ONE</b></p></center><a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n							<center><b>Proposing a Bill</b></center>\r\n<p>Either a Senator or a member of the House of Representatives gets ahold of a great idea that they want to become a law.&nbsp; They talk with some people in the field and some lawyers and write a &ldquo;bill&rdquo; that they hope will become a law.&nbsp; If a bill is introduced in the House, it is named &ldquo;H.R.&rdquo;- and then some number referring to the order that it was introduced.&nbsp; If it was introduced in the Senate, then it is named &ldquo;S.&rdquo; plus whatever number.&nbsp; The President and anyone else (including you) can suggest legislation, but only a member of the House or Senate can actually propose and present a bill.&nbsp;</p>\r\n<p>Some organizations will write their own drafts of bills before they suggest them to House Reps and Senators to make adopting their ideas easier.&nbsp; On the other hand, this could look bad.&nbsp; Imagine big businesses funding political campaigns and then writing the laws for those same politicians to pass.&nbsp; It looks like the politician is taking a bribe to be the stooge of their funder.&nbsp; This happens a lot more often on the state level than the federal level simply because fewer people pay attention to state politics and campaigns for state races are a lot cheaper so organizations can afford to help fund dozens of politicians rather than just one.&nbsp; We recommend that you inform your local, state, and federal politicians about the problems, suggest solutions and keep track of their progress rather than actually writing the laws for them.&nbsp;</p>\r\n<p>For the sake of this article, let&rsquo;s say a bill was introduced in the House and they call it H.R. 203. The order of the next steps changes depending on whether it was introduced in the House or Senate.</p>\r\n<p>The main presenter of the bill can choose to increase their chances of passing the bill by getting other members of the House to sponsor or co-sponsor the bill with them.&nbsp; These endorsements can be added or retracted at later stages as well.&nbsp; For example, if a Republican can get a Democrat to co-sponsor it, the bill will appear like a very middle-of-the-road sensible non-partisan bill that everyone should take seriously.&nbsp; If a sponsor writes a bill about something Defense related, and they get a bunch of Defense specialists to sign on or veteran House reps. It gives the bill a lot more traction.</p>\r\n<p>If you read a bill you love and you think that it would gain traction if a particular House Representative would co-sponsor it, you should consider writing them to try to convince them of the merits of the bill.</p>\r\n							<br><span class=\"anchorHidden\" id=\"_Toc459927140\"></span>\r\n							\r\n<center><p><b>STEP TWO</b></p></center><a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n							<center><b>Speaker of The House Decides Action</b></center>\r\n<p>Since this bill was introduced in the House, the Speaker of the House would take a look at the bill and decide if it should:</p><ul>\r\n<li> <b>Go to one or more committees </b>for further research and discussion.&nbsp; If a bill covers issues that would interest more than one committee, then the Speaker would assign it to each of those committees and the Speaker would designate one of those committees as taking the lead.&nbsp; The Speaker may also give a deadline for how long the various committees can deliberate over the bill.&nbsp; Committees may also be told to research only the parts of that bill that they were specialists in.&nbsp; So, for example, if there was a bill that dealt with raising cows to sell to Indonesia, it might be sent to one committee that deals with agriculture and another committee that deals with international relations.&nbsp; The ag people know about farming and selling their goods and the international relations people would know about the US/Indonesia relationship and special conditions not specific to agriculture.&nbsp; So, each of those committees might get assigned different parts of the bill and depending on the purpose of the bill, one or the other would be assigned to take the lead.&nbsp; Most bills go to only one committee.</li>\r\n<li> <b>Hold the bill at the desk </b>for potential immediate action.&nbsp; This is done when the Speaker thinks the bill doesn&rsquo;t need further research but isn&rsquo;t quite important enough to be voted on immediately.</li>\r\n	<li> <b>Place the bill on the &ldquo;Calendar&rdquo;</b> to be discussed and voted on by the whole all the members of the House of Representatives.&nbsp; If a bill never goes on the calendar, then it never gets voted on and it becomes impossible to become a law.&nbsp; Despite its name, the Calendar does not necessarily set specific dates for anything to happen.&nbsp; It is just a list of bills that are ready to be acted upon.</li></ul>\r\n<p>The Speaker of the House is elected by the members of the House of Representatives.&nbsp; This means most of the time, the party in the majority is able to elect one of their own to be the Speaker of the House.&nbsp; And since the Speaker determines what gets voted on, legislation created by members of the minority party is less likely to ever come up for a vote.</p>\r\n<p>After a bill is proposed, it takes the Federal Government about three days to post the bill online.&nbsp; As soon as a bill is introduced (or if you know that it WILL be introduced) writing or calling the Speaker of the House could help influence their decision on how seriously to take the Bill.&nbsp; Because it takes the Government three days to post the text of the bill, you will have to base your letter off of the summary or even just the topic.</p><br>\r\n							<span class=\"anchorHidden\" id=\"_Toc459927141\"></span>\r\n<center><p><b>STEP THREE</b></p></center><a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n							<center><b>The Bill Goes to Committee</b></center>\r\n<p>Let&rsquo;s assume that the bill was sent to committee.&nbsp; The purpose of committees is to fully research the benefits and potential pitfalls of bills, try to fix the problems, and then report back to the rest of the House with their recommendations.&nbsp;&nbsp; This takes a lot of time.&nbsp; There just isn&rsquo;t enough time for every congressman to read and fully research every bill, so most of them rely on the advice of the people they trust for the bills they don&rsquo;t care about as much so they can focus on the ones that mean a lot to them.</p>\r\n<p>Committees are made up of both the Majority Party and the Minority Party.&nbsp; Together, they decide how many people should be in the committee and how the ratio of Majority/Minority members should be split.&nbsp; They make these decisions in accordance with the House Rules.&nbsp; These rules are not a part of the Constitution and are subject to change by a House Resolution (a voting process similar to how a Bill becomes a law but doesn&rsquo;t require approval from the Senate or the President).</p>\r\n<p>A House member who is neither a Republican nor Democrat can request to &ldquo;caucus&rdquo; with either side in all aspects of governing (not just committees).&nbsp; This means that they are essentially on their team and are treated as a Republican or Democrat for all intents and purposes.&nbsp; Caucuses get together to discuss things like the direction of their party, where to place their priorities, their concerns, tactics, etc..&nbsp; Caucuses are also called &ldquo;conferences&rdquo;, &ldquo;coalitions&rdquo;, &ldquo;study groups&rdquo;, &ldquo;task forces&rdquo;, or &ldquo;working groups&rdquo;. In addition to the two major caucuses/conferences, there are many other smaller groups that get together to discuss their unique concerns.&nbsp; For example, there may be a caucus for congressmen and women of color or there may be a study group for more moderate Republicans.&nbsp; These smaller caucuses function only to help them figure out how to improve their ability to fight for their causes, and are not used to identify who gets what sort of power on a Bill committee.&nbsp; That is determined only by the Republican/Democrat Majority/Minority split.</p>\r\n<p>As of this writing (early 2019), committees get 30 staffers that they can use to do research for them.&nbsp; Some of these staff will be hired by Democrats and others by Republicans.</p>\r\n<p>The committee chair then decides what happens to the bill next (At this point, you should write the committee chair and everyone in the committee to help them with their decision).</p>\r\n<p>The committee chair can do one of three things:</p>\r\n<ul>\r\n<li><b>They can assign it to a subcommittee.</b> If a subcommittee takes it, the chair of the subcommittee has all the choices that a top-level committee chair would have.</li>\r\n<li><b>They can choose to do nothing.</b> If this happens, the bill will likely die.&nbsp; There is really no way of knowing that the committee or subcommittee chose to do nothing without someone there in the room.&nbsp; So, if there is a bill that concerns you that is in committee, you should contact the members and check on its progress.&nbsp; If the committee chooses to do nothing, then the only way to get anything done is to get a &ldquo;discharge petition.&rdquo;&nbsp; In order to do that, a member of the House must request it and get a majority of the members to sign a paper to remove it from committee and bring it to the floor for debate and a vote.&nbsp; It&rsquo;s incredibly difficult to get half the House to act in favor of a bill they know little about, so this is incredibly rare.</li>\r\n<li><b>They can hold hearings.</b> The chair invites witnesses to come before the committee and testify about the subject.&nbsp; For legislative hearings, the witnesses are not under oath and there is a lot of political posturing, so you should take what you hear with a grain of salt.&nbsp; (Usually, the only time witnesses are under oath are during investigative hearings). &nbsp;So, when you hear their words, think about not just what they are saying, but why they are saying it.&nbsp; &nbsp;You can see a lot of current and historic hearings on C-Span at <a href=\"https://www.c-span.org\" target=\"_blank\" class=\"link\">https://www.c-span.org</a> .&nbsp; There are paid services that will allow you to read the testimony that they gave along with the documents they provide, or you can wait for the Government Printing Office to release them, but this can take moths or even years. &nbsp;If a witness brings additional documents, the GPO will put these in the appendix at the end of the official transcript.&nbsp; The hearings usually invite the main sponsor of a bill or the most prominent co-sponsor who can best describe its merits and its importance.&nbsp; They also usually invite lobbyists, public interest organizations, and representatives of larger bodies of people that might be affected by the legislation.&nbsp; We advise that you use VoteWise.net to find organizations that can help you get heard in the subject you care about.&nbsp; Oftentimes, one small organization doesn&rsquo;t have enough muscle to get invited to testify, but if you can put together a consortium of small organizations, they can&rsquo;t ignore you.&nbsp; And they of course need the help of individual supporters too.</li>\r\n</ul>\r\n<p>&nbsp;</p><br>\r\n							<span class=\"anchorHidden\" id=\"_Toc459927142\"></span>\r\n<center><p><b>STEP 4</b></p></center><a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n							<center><b>House Committee Mark-Up</b></center>\r\n<p>The committee marks it up.&nbsp; Once the hearings are done, the committee members discuss the bill, make amendments to try to make it better and then accept the bill or reject the bill.&nbsp; If it is rejected, it dies.&nbsp; If it is accepted by a subcommittee, then it gets forwarded to the main committee for further mark up.&nbsp; Generally speaking, the committee won&rsquo;t do additional hearings after something comes from subcommittee; they will skip straight to the mark up process.&nbsp;&nbsp; Changes to the bill don&rsquo;t get published by the Government Printing Office until the Bill makes its way out of committee (They don&rsquo;t print the interim changes as it goes from subcommittee to the main committee.)&nbsp;</p>\r\n<p>If they make really dramatic changes to a bill, they may decide that it is no longer the same bill.&nbsp; In this case, the bill as is dies and a new one with a new name and new number is created.&nbsp; So, if you see a lot of action going on about your bill and then nothing, you should use our search by subject tools to find out if they created a new bill. (this can happen in both subcommittee or in committee).</p>\r\n							<br>\r\n							<span class=\"anchorHidden\" id=\"_Toc459927143\"></span>						\r\n<center><p><b>STEP 5</b></p></center><a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n							<center><b>House Committee Report</b></center>\r\n<p>The Committee writes a report on the bill.&nbsp; When they are done negotiating over how the bill should be written, they will vote to go to the next step which is writing up their final touches on the bill, write a report about what they did in committee and what they discovered, and then file the report.&nbsp;&nbsp; The Bill doesn&rsquo;t move forward until the report has been filed.&nbsp; This can take weeks or even months.&nbsp; If it doesn&rsquo;t get filed before they run out of time, the bill dies.</p>\r\n<p>If the bill was originally sent to more than one committee, then their versions must be brought together into one document.&nbsp; Usually, the changes made by each committee are written in different fonts so you can tell which committee did what.&nbsp; Each committee must submit its own separate report.</p>\r\n<p>The report will usually include:</p>\r\n<ul>\r\n<li>The text of the bill as amended and reported (You will find this at the beginning of the document)</li>\r\n<li>The text of the bill as it would appear if it actually becomes a law as reported (this you would find at the end of the document)</li>\r\n<li>A discussion of the bill&rsquo;s merits and recommendations as described by the people who decided that the bill should go forward.</li>\r\n<li>Dissenting views by the committee members who had problems with the bill and thought it shouldn&rsquo;t go forward.</li>\r\n<li>The history of the bill as it went through all the steps to get where it is now.</li>\r\n</ul>\r\n<br>\r\n							<span class=\"anchorHidden\" id=\"_Toc459927144\"></span>\r\n							<center><p><b>STEP 6</b></p></center><a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n							<center><b>Goes Back to Speaker</b></center>\r\n<p>Once the report has been filed, it goes back to the desk of the Speaker of the House.&nbsp; The Speaker then has the options of:</p>\r\n<ul>\r\n<li>Do nothing and <b>let the bill die</b>.</li>\r\n<li><b>Sit on it and wait </b>for the time to be right to let it go to the next step or use it as political capital to trade for things their party cares about.</li>\r\n<li>Proceed to the next step &ndash; <b>sending it to the House Committee on Rules</b>.</li>\r\n<li><b>Make a motion to suspend the rules and pass a bill</b>. They can&rsquo;t suspend the rules on their own.&nbsp; They need 2/3rds of the House to agree to suspend the rules.&nbsp; If they don&rsquo;t agree to suspend the rules, then it has to go to the Rules Committee and go on the calendar like any other bill.&nbsp; If they DO agree to suspend the rules, then debate would be limited to 40 minutes total &ndash; 20 minutes given to those who support the bill and 20 minutes for those who are against the bill.&nbsp; No amendments would be allowed during those 40 minutes.&nbsp; Most bills go this route.</li>\r\n</ul>\r\n<p>&nbsp;</p>\r\n<br>\r\n							<span class=\"anchorHidden\" id=\"_Toc459927145\"></span>\r\n							<center><p><b>STEP 7</b></p></center><a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n							<center><b>Rules Comittee</b></center>\r\n<p>Because the House of Representatives is made up of so many members, they have to make rules on how long you can debate something -&nbsp; otherwise, it would take impossibly long to do anything.&nbsp; So, they have a Rules Committee that decides Special Rules how long anyone can debate a particular bill and how many amendments may be added before it must be considered for a vote.&nbsp; They may even make rules WHICH amendments might be considered for a particular bill.</p>\r\n<p>The Special Rules for a particular bill must be voted on by the House before the actual bill can be debated on the floor.</p>\r\n<p>The Rules Committee is usually more heavily populated by the Majority party than any other committee, so the Majority power really determines everything that goes through the House of Representatives.</p>\r\n<p>They may also decide to:</p>\r\n<ul>\r\n<li><b>Send the bill to a &ldquo;Committee of the Whole&rdquo; </b>instead of the general assembly. The Committee of the Whole is treated as a committee but made up of all the members of the House of Representatives. &nbsp;In traditional procedures, the House normally needs a quorum of 218 Representatives present in order to do anything, while a Committee of the Whole would only require 100 of the 435 House Reps to be there.&nbsp; They have a couple other rules that make it quicker to pass legislation.&nbsp; If it goes to the Committee of the Whole, the debate happens within this smaller number of people and then when they move forward to reporting it to the floor, there is only limited further debate allowed.&nbsp; At the end of the debate, the minority party is allowed to propose a &ldquo;Motion to Recommit&rdquo;, which, if successful, would send the bill back to committee where they can propose amendments.</li>\r\n<li><b>Put a bill on the Calendar</b> to go to the floor.</li>\r\n</ul>\r\n<br>\r\n							<span class=\"anchorHidden\" id=\"_Toc4599271462\"></span>\r\n							<center><p><b>STEP 8</b></p></center><a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n							<center><b>Debate on the Floor of the House</b></center>\r\n<p>The bill finally reaches the floor and is ready for debate and voting.&nbsp; At this point, any member of the House may request &ldquo;Unanimous Consent&rdquo;.&nbsp; This is used to pass bills where either people don&rsquo;t care that much (like the naming of a public office building) &ndash; or a bill where the opposition is so small that they have no hope of winning and don&rsquo;t want to go on record as having fought and lost.&nbsp; With a Unanimous Consent request, there is no debate.&nbsp; No amendments may be added.&nbsp; If even a single member of the House rejects the Unanimous Consent request, then it has to be debated like any other bill.</p>\r\n<p>Let&rsquo;s pretend that out sample bill doesn&rsquo;t win Unanimous Consent.</p>\r\n<p>Following the specific limitations set aside for a particular bill, members of the House of Representatives can now discuss the merits and pitfalls of the bill.&nbsp; This may mean that a member might be able to talk for only five minutes before passing the microphone off to someone else.&nbsp;</p>\r\n<p>Any amendments that are proposed in the House MUST be related to the bill.&nbsp; In the Senate, people can propose amendments completely unrelated to the bill.&nbsp; For example, if a bill doesn&rsquo;t have enough votes for an education bill to pass, and they know a Senator could be swayed by sending jobs to his state, they might propose funding the building of a bridge in his or her state.</p>\r\n<p>Once the debate is over, members vote on the bill.&nbsp; Bills must pass by a simple majority (one vote over half the people present).&nbsp; Voting can be done by simple voice vote which means that everyone who wants the bill to pass says &ldquo;Yea&rdquo; or &ldquo;Yes&rdquo; all at once when prompted and the people who are opposed say &ldquo;Nay&rdquo; or &ldquo;No&rdquo; all at once when prompted.&nbsp; The Speaker of the House then decides based on the sounds he or she heard to say whether the bill passed or not.&nbsp; If any member disagrees with their assessment of who won or lost, or if they just want to get everyone on record, then they can request a written count.&nbsp; In the House, the members have voting swipe cards that registers their votes as they cast them electronically.&nbsp; They can cast &ldquo;Yea&rdquo;, &ldquo;Nay&rdquo;, or &ldquo;Present&rdquo;(which means they were there but decided not to vote either way).</p>\r\n<br>\r\n							<span class=\"anchorHidden\" id=\"_Toc4599271461\"></span>\r\n							<center><p><b>STEP 9</b></p></center><a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n							<center><b>Bill Goes to the Senate</b></center>\r\n<p>After it passes one house, it goes to the second house.&nbsp; Since in this example, we started with the House of Representatives, it would now go to the Senate.&nbsp; In the Senate, the Majority Leader has essentially the combined powers similar to the Speaker of the House and the House Committee on Rules with a few exceptions.</p>\r\n\r\n<p>While the Senate Majority Leader is traditionally the person to propose that a bill be debated and voted upon, any Senator may make that motion. But keep in mind that for a motion to pass, it needs a majority of the Senators to give it the go ahead &ndash; which means that a number of the Senate Majority&rsquo;s party need to say that they disagree with the Majority Leader&rsquo;s choice not to bring it to the floor.&nbsp; This is a huge public slap in the face and destroys party cohesion, so it isn&rsquo;t done that often.</p>\r\n\r\n<p>The Senate has three leaders:</p><ul>\r\n<li><b>The Senate Majority Leader</b> is elected by the party who has more members in the Senate.&nbsp; Unlike in the House, the opposing power has no say, so it&rsquo;s possible to have a radical leader.&nbsp; (In the House, if the ticket is split, it&rsquo;s possible that the minority party would have enough votes to decide who the Speaker is.)</li>\r\n							<li> <b>The Senate Minority Leader</b> is elected by the smaller political party.&nbsp; The majority power has no say in this choice, so they can be radical also.</li>\r\n							<li><b> The President of the Senate</b> is the person who presides over the Senate saying who can talk when two people stand to talk at the same time.&nbsp; Constitutionally, it is the Vice President who does this, but the job has mostly been passed off to the President Pro Tempore (temporary President).&nbsp; This person is elected by the entire Senate.&nbsp; It is usually the most senior senator in the majority party.&nbsp; While a senator is presiding over the Senate, they can&rsquo;t themselves discuss the issues on the floor.&nbsp;&nbsp; The President Pro-Tempore is in the line of succession if the President dies/quits.&nbsp; It goes President&gt;Vice President &gt;Speaker of the House&gt; President Pro Tempore and then it goes to a specific order of people in the President&rsquo;s cabinet.&nbsp; If the President Pro Tempore is sick or otherwise absent, they can assign the job to someone else temporarily.</li></ul>\r\n<p>So, the Senate Majority leader receives the bill from the House of Representatives and they have the same options as the Speaker of the House did.</p>\r\n<ul>\r\n<li><b>Ignore it.</b></li>\r\n<li><b>Send it to committee</b></li>\r\n<li><b>Hold it ready for debate</b></li>\r\n<li><b>Put it on the calendar.</b></li>\r\n</ul>\r\n<br>\r\n										<span class=\"anchorHidden\" id=\"_Toc459927146\"></span>\r\n							<center><p><b>STEP 10</b></p></center><a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n							<center><b>Bill Goes to Senate Committee</b></center>\r\n<p>It goes to committee with essentially the same rules as the House of Representatives has. &nbsp;In the Senate, if the bill is going to go to more than one committee, the senate can decide to have it go to those committees at the same time or one after the other. The committees do research, have discussions and if it doesn&rsquo;t die, it goes back to the Senate Majority Leader with their report.&nbsp;&nbsp; If there is a Bill that you want to help become a law, contact the Senators on the committee that the bill is in to encourage them to take the appropriate action.&nbsp; Once again, like the House committees, if they make a lot of changes, they may call it a new bill, so you should keep up on your toes and use our search tools to track bills by key words and subjects if your bill falls off the radar.&nbsp; After a bill comes out of committee, the Senate must wait at least 2 days before they can debate it. (not including Sunday)</p>\r\n							<br>\r\n										<span class=\"anchorHidden\" id=\"_Toc459927147\"></span>\r\n<center><p><b>STEP 11</b></p></center><a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n							<center><b>Bill Goes Back to Senate Majority Leader</b></center>\r\n<p>After Committee, it goes back to the Senate Majority Leader and they choose again to:</p>\r\n<ul>\r\n<li><b>Ignore it and let it die.</b></li>\r\n<li><b>Put it on the calendar </b>as something that has the potential of being discussed soon. (Remember, this is not an actual calendar with dates of when they will be discussed &ndash; it&rsquo;s just a list of things that may happen in the future.)</li>\r\n<li><b>Discuss with the Minority leader what rules </b>they should have for the debate around the bill. Normal Senate rules allow endless debate over a bill, but if they did that for every bill, nothing would get done.&nbsp; So instead, they have the ability to make Special Rules on a bill-by-bill basis.&nbsp; Before they adopt the rules, the senate has to approve the rules on that particular bill and the most efficient way of finding rules that both sides will agree on is to have the majority and minority leaders sit down and hash them out.&nbsp; (In the House of Representatives, this is done by the Rules Committee instead of two people).</li>\r\n</ul>\r\n<br>\r\n										<span class=\"anchorHidden\" id=\"_Toc459927148\"></span>\r\n							<center><p><b>STEP 12</b></p></center><a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n							<center><b>Getting Recognized</b></center>\r\n<p>At the beginning of each day, the Senate Majority Leader stands up in the Senate, &nbsp;and is &ldquo;recognized&rdquo; by the President of Senate.&nbsp; Being &ldquo;recognized&rdquo; means you have the right to speak.&nbsp; The President of the Senate will recognize the Senate Majority Leader First, then the Senate Majority Leader, then any other Senator.&nbsp; Because the Senate majority Leader speaks first, he or she gets to set the agenda for that day.</p>\r\n<p>The Senate Majority Leader will motion to debate a bill (using the normal rules) or they will motion to adopt the Special Rules that they previously negotiated with the Senate Minority Leader.&nbsp; Usually, they will motion for Universal Consent to adopt the rules.&nbsp; If a single Senator decides to vote against the rules, then they would have to debate the rules to create the rules of debate for that one bill &ndash; which is sort of silly, so the Senate Majority leader then has to decide if the bill is worth spending time on or if it should be forgotten for more important things.&nbsp; If it&rsquo;s important, then the Senate Majority Leader may motion to debate the bill under the regular rules.</p>\r\n<br>\r\n										<span class=\"anchorHidden\" id=\"_Toc459927149\"></span>\r\n							<center><p><b>STEP 13</b></p></center><a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n							<center><b>Senate Debate</b></center>\r\n<p>The Bill is debated.<br /> <br /> Assuming it is debated under the regular rules:</p>\r\n<ul>\r\n<li>Any Senator may talk for as long as they like about the bill. A filibuster is when a Senator talks for a really long time in an attempt to make passage of a bill take an excruciatingly long time &ndash; so long that people want to abandon it in favor of bills they think are more important.</li>\r\n<li>Any Senator may propose adding any amendment to the bill &ndash; even if it has absolutely nothing to do with the bill. This is sort of a &ldquo;you scratch my back and I&rsquo;ll scratch yours&rdquo; way of getting more senators on board a bill that isn&rsquo;t popular enough to pass on its own.&nbsp; Senators who are on the fence are convinced to support a bill if an amendment is added that supports an entirely different cause that they care about.</li>\r\n<li>Debate continues until they vote to stop debate to either vote on the bill or &ldquo;table it for later&rdquo; (which probably means never talk about it ever again).</li>\r\n<li>A vote to stop debate for anything except Supreme Court or other Executive appointments or Senate Rule Changes requires &nbsp;3/5ths of the present Senators to pass.&nbsp;&nbsp; To stop debate on a Rule Change requires 2/3rds of the present Senators to pass.&nbsp; A vote to stop debate on an executive appointment requires only a simple majority.&nbsp; Any vote to stop debate is called &ldquo;Cloture.&rdquo;</li>\r\n<li>Once they have finished debating then the actual vote takes a simple majority to pass. But because it usually takes 60% to get to this point, it effectively takes 60% approval to pass most things in the Senate.&nbsp; (Simple majority by the Constitution, and 60% by Senate Rules)</li>\r\n</ul>\r\n<p>Important rules that you can potentially take advantage of:</p>\r\n<ul>\r\n<li>If the Senate makes a decision, certain senators can petition to reopen consideration within 2 days. In order to do so, the Senator must have cast a vote on the winning side or the Senator must not have cast a vote.&nbsp; In order to reconsider the issue, a majority of senators must agree to reopen it.&nbsp; When is this useful?&nbsp; On really rare occasions, new information is discovered after the decision is made.&nbsp; So, if you have information that is a complete game changer, contact any Senator on the winning side.&nbsp; If you can convince them that they didn&rsquo;t have information to make the right decision, they may re-open it.&nbsp; On less rare occasions, a lot of senators might be out campaigning instead of attending the Senate.&nbsp; During this time, the senators present at the vote may vote for something that more than half of the senators disagree with.&nbsp; If the absent senators can get their act together in time, they can all go back to the Senate, petition for reconsideration, and then debate and have the vote go the other way.</li>\r\n</ul><br>\r\n										<span class=\"anchorHidden\" id=\"_Toc459927150\"></span>\r\n<center><p><b>STEP 14</b></p></center> <a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n							<center><b>Merging Bills</b></center>\r\n<p>Both houses have to pass the identical bill.&nbsp; So, if the House of Representatives passes a bill and the Senate changes it, then it has to go back to the House to be voted on all over again.&nbsp; If the House of Representatives doesn&rsquo;t like the Senate changes, then they add their own changes &ndash; which would mean it would no longer be the bill that the Senate passed, so the Senate would have to go through the process again.&nbsp; This could become an endless loop.&nbsp;</p>\r\n<p>To avoid this, sometimes the leaderships of both houses will appoint people to represent the House and Senate in a conference to discuss the differences between the various versions of the bill.&nbsp; When they come up with a solution that they think both houses will like, they send the now unified bill to both houses to be voted on.</p>\r\n<p>Likewise, a bill might start in the House that is almost identical to an entirely different bill in the Senate and they get passed independent of each other.&nbsp;&nbsp; The two (or more) bills might go to such a conference to merge them together and get them passed.</p>\r\n<br>\r\n										<span class=\"anchorHidden\" id=\"_Toc459927151\"></span>\r\n					<center>		<p><b>STEP 15</b></p></center><a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n							<center><b>Bill Goes to the President</b></center>\r\n<p>It goes to the President to sign.&nbsp; The President can:</p>\r\n<ul>\r\n<li>Like it and sign it into law.</li>\r\n<li>Hate it and Veto it with instructions on why they hated it.</li>\r\n<li>Do nothing for ten days (not including Sundays) and it becomes a law.</li>\r\n<li>Hope that Congress has their final adjournment without signing it and it becomes a &ldquo;pocket veto&rdquo; without the President having to say they were against it.</li>\r\n</ul>\r\n<p>If the bill is vetoed, then it goes back to the house that introduced it.&nbsp; They can take note of why the President rejected it and make changes and pass it through both houses again as a new bill, OR they can send it through both houses unchanged and if they get 2/3rds of House Reps and 2/3rds of Senators to vote for it again, then it becomes a law.</p>\r\n							<br>\r\n										<span class=\"anchorHidden\" id=\"_Toc459927152\"></span>\r\n<center><p><b>EXTRA THINGS TO KNOW</b></p></center><a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n<ul>\r\n<li>Because of the increasingly partisan nature of Federal politics, only about 5% of bills proposed end up becoming laws. There has been a trend also to pass fewer bills with more in them rather than passing many simpler laws.&nbsp; This means some bills are thousands of pages long &ndash; too long for most of the people voting on them to actually read them.</li>\r\n<li>Tax bills can only start in the House of Representatives.</li>\r\n<li>Impeachment charges can only be made by the House of Representatives and the Senate is the only house that do the actual trials for impeachment. If the Senate finds the accused guilty, they will be kicked out of office and banned from ever serving in a position of honor, trust or financial gain from the US Government. But the powers of the Senate end there.&nbsp; From that point, the accused can be charged, tried and convicted in normal courts.</li>\r\n<li>Only the Senate can approve Presidential appointments (Cabinet, The Supreme Court, diplomats&hellip;) The Constitution also says that the Senate should also advise the president on who should be appointed.</li>\r\n<li>Only the Senate can ratify treaties with foreign nations. The President can negotiate and strike a deal, but it doesn&rsquo;t become valid until the Senate agrees with it by a 2/3<sup>rd</sup>&nbsp; The Constitution also says that the Senate should provide advice for treaties.</li>\r\n<li>If there is a tie in the Senate, the Vice President may cast a tie breaking vote.</li>\r\n<li>Besides laws there are various types of Resolutions:\r\n<ul>\r\n<li>A <b>Simple Resolution</b> is meant to be passed by one house only. It is used to change the rules in that house or to advise the President or to express a unified sentiment &ndash; like condolences for the victims of a natural disaster, or condemnation of the actions of a dictator.&nbsp; A simple resolution from the House would be labelled H.Res plus a number (not to be confused with H.R. plus a number which would be used for bills meant to become laws).&nbsp; A simple resolution from the Senate would be labelled S.Res plus a number.</li>\r\n<li>A <b>Concurrent Resolution</b> is similar to a Simple Resolution except it has to be agreed upon by both houses. If it was started in the House, it is labelled H.Con.Res plus a number and if it started in the Senate, then it&rsquo;s labelled S.Con.Res plus a number.&nbsp;</li>\r\n<li>A <b>Joint Resolution</b> is just like a regular bill but it is mostly used for continuing existing funding or emergency funding. So, a Joint Resolution requires both houses and the President to pass into law. A Joint Resolution can also be used to create a Constitutional Amendment, then it would require the President&rsquo;s signature and ratification of 2/3rds of the states.&nbsp; If a Joint Resolution is started in the House, it is called H.J.Res plus a number and if it is started in the Senate, then it is called S.J.Res plus a number. &nbsp;If you are interested in bills, we highly recommend that you keep your eyes on for Joint resolutions also.</li>\r\n</ul>\r\n</li>\r\n<li><b>&ldquo;Earmarks&rdquo;</b> &ndash; When a congressman wants to make sure that a part of a spending budget goes for something that they want, they will have this in writing in the bill. Without this, whoever was the head of the agency that received the money could decide for themselves how best to spend the money.&nbsp; For example, if the bill was an environmental thing, maybe the bill said $3 million would be spent to prevent the extinction of rare birds in America.&nbsp; An earmark might say that $100,000 would be set aside for a nature preserve aimed at saving a bird that the congressman was particularly worried about. &ndash; This may not be something that the administrator of the nature fund agrees with and may not have chosen this as a wise way to spend their budget &ndash; or it might be a good idea &ndash; either way, the decision is taken out of their hands.&nbsp; Some say Earmarks are a horrible corrupting part of our democracy and a horrible waste of money.&nbsp; Others would say that it is a critical negotiating tool needed to get things done.&nbsp; Earmarks make up about 1% &nbsp;or 2% of the national budget.</li>\r\n<li><b>&ldquo;Pork Barrel&rdquo;</b> is legislation is that is intended to benefit the voters in the congressman&rsquo;s home district. So, for example, if in the above example, the congressman insisted on an earmark for a nature preserve in his/her home district, that would be considered Pork Barrel.&nbsp; The Citizens Against Government Waste make a book every year pointing out things which they consider Pork Barrel Legislation.&nbsp; One person might consider &nbsp;a particular piece of legislation &ldquo;pork&rdquo; while another person might consider &ldquo;necessary legislation for the good of America&rdquo;.&nbsp; It is a bit open to personal interpretation.&nbsp; For example, if the government needs ships and you fight for the ships to be built in the shipyards in your district even though you know that other districts make better and cheaper ships, then that is clearly pure pork.&nbsp; However, if you are fighting for them to be made in your district because your ship builders are the best and cheapest and it would be best for America, then the fact that it benefits your district might be a pure coincidence.&nbsp; Some would call that last case pork and some would not.&nbsp; Technically, it fits the original definition of pork barrel legislation because it benefits your district.&nbsp; But it doesn&rsquo;t fit the derogatory definition of pork barrel legislation which is that the legislation was unnecessary and done because it will get you votes in your home district.&nbsp; Keeping this in mind, the research of the CAGW is certainly worth a look.&nbsp; Their site is <a href=\"https://www.cagw.org/\" target=\"_blank\" class=\"link\">https://www.cagw.org/</a>&nbsp; (It&rsquo;s called &ldquo;pork barrel&rdquo; because a barrel of preserved pork was an awesome thing back in the day and sometimes used as a gift or reward.)</li>\r\n<li><b>&ldquo;Graft&rdquo;</b> is when political influence is used for PERSONAL gain. It is pure corruption.</li>\r\n</ul>\r\n<p>&nbsp;</p>\r\n										<span class=\"anchorHidden\" id=\"_Toc459927153\"></span><a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n<p>Believe it or not, this document is a summary of the House and Senate Rules.&nbsp; The actual rules can be found here:</p>\r\n							<p><b>House of Representatives Rules (1500 pages long)</b></p>\r\n<p>115<sup>th </sup>Congress <a href=\"https://www.govinfo.gov/content/pkg/HMAN-115/pdf/HMAN-115.pdf\" target=\"_blank\" class=\"link\">https://www.govinfo.gov/content/pkg/HMAN-115/pdf/HMAN-115.pdf</a> Change the 115 to 116 or whatever congressional rules you are looking up.</p>\r\n							<br>\r\n<p><b>Senate Rules (100 pages long)</b></p>\r\n<p><a href=\"https://www.rules.senate.gov/rules-of-the-senate\" target=\"_blank\" class=\"link\">https://www.rules.senate.gov/rules-of-the-senate</a></p>\r\n<br>\r\n<p><b>GOVERNMENT MANUAL</b></p>\r\n<p>Click to see the machine readable Governent manual from 2018.  You should check for more up to date manuals by changing the end of the URL to other years.<a href=\"https://www.govinfo.gov/bulkdata/GOVMAN/2018\" target=\"_blank\" class=\"link\">https://www.govinfo.gov/bulkdata/GOVMAN/2018</a></p>\r\n							<br>\r\n<p><b>HOUSE RULES MANUAL</b></p><p> This is a link for the machine readable 115th congress rules.  Check for more up to date manuals by changing the 115 to 116 or 117 or whatever congress is going on when you read this.&nbsp; <a href=\"https://www.govinfo.gov/bulkdata/HMAN/115\" target=\"_blank\" class=\"link\">https://www.govinfo.gov/bulkdata/HMAN/115</a></p>\r\n							<br>\r\n<p><b>PUBLIC PAPERS OF THE PRESIDENT</b> </p><p> These are the machine readable public papers of the President.<a href=\"https://www.govinfo.gov/bulkdata/PPP\" target=\"_blank\" class=\"link\">https://www.govinfo.gov/bulkdata/PPP</a></p>\r\n							<br>\r\n							<p><b>CONGRESSIONAL DIRECTORY</b></p>\r\n							<p> This will give you a list and brief biographies of those in Congress.  They are not the best at keeping it up to date.<a href=\"https://www.govinfo.gov/app/collection/cdir\" target=\"_blank\" class=\"link\">https://www.govinfo.gov/app/collection/cdir</a></p>\r\n<p>&nbsp;</p>\r\n				<span class=\"anchorHidden\" id=\"_Toc459927154\"></span>\r\n							<center><b>ADDITIONAL EDUCATIONAL LINKS</b></center><a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n							<p>Khan Academy has a lot of wonderful videos.  Here is the link for their take on how a bill becomes a law.  It is not as complete as this essay, but it is quite good for those who prefer videos over reading. <a href=\"https://www.khanacademy.org/humanities/ap-us-government-and-politics/interactions-among-branches-of-government/structures-powers-and-functions-of-congress/v/how-a-bill-becomes-a-law\" target=\"_blank\" class=\"link\">https://www.khanacademy.org/humanities/ap-us-government-and-politics/interactions-among-branches-of-government/structures-powers-and-functions-of-congress/v/how-a-bill-becomes-a-law</a></p>\r\n							\r\n							<p><b>FUN FACT:</b></p>\r\n<p>President and Vice President must come from different states or the votes from their same state won&rsquo;t be counted</p>\r\n<br>\r\n\r\n");
$templateCache.put("app/howToVideo/howToVideo.html","<div class=\"container-fluid\">\r\n\r\n  <p>\r\n    <h1>\r\n      <center>How To</center>\r\n    </h1>\r\n  </p>\r\n  <!--<p><h3><center>Welcome to VoteWise!!</center></h3></p> -->\r\n  <div ng-if=\"!userData.isemailverified\">\r\n    <p style=\"color:red\">Because you have not yet verified your email (which is probably in your SPAM folder) you will\r\n      be able to explore the site, and listen in on debates, but you won\'t be able to answer questions or engage in\r\n      dabates.</p>\r\n    <p> Your voice is important to democracy, so please check your email and confirm as soon as you can.</p>\r\n    <br><br></div>\r\n    <div class=\"locationDiv\">\r\n      <!--\r\n	<div ng-if=\"userRole==\'voter\'\">\r\n		<h3><p>Voting is the most powerful way you can change the government.  But expressing your views helps you find the people to vote for and tells the people in power what they SHOULD be doing.  We highly recommend that you start out by going to the question section (see the big question mark above) and tell your politicians where you stand on the issues.</p>\r\n        <p>VoteWise has many tools and are adding more all the time.  Some of these tools are pretty obvious how to use.  Some are not.  We will be adding instructional videos soon to show you how to use some of the less intuitive tools, but one thing you might find useful is in the Debate section (see the quote balloons above) - you can cut and paste URL\'s from Vimeo or Youtube and the video will show up in the chat. You can copy Faceboook posts here also, but only if they are \"public\" as opposed to set to \"share with friends\".  If they ARE public, then the upper right corner of the Facebook post will have an arrow pointing down.  Hit it and you will see a number of options including \"embed\".  Click this and cut and paste the URL into the debate section.</p><p>\r\n\r\n        Also be aware that for the debate section, you can choose what tags to have and these will make it easy for other people to find the things you are writing about.  You can also choose to make your topic national to discuss issues with people all over, or local to discuss the issues with people in your own town.</p> <p>\r\n\r\n        Now go have fun saving the world.</p></h3>\r\n	</div>\r\n	<div ng-if=\"userRole==\'advocate\'\">\r\n  <!--      <h3><p>Without organizations like yours fighting to make the world a better place, we wouldn\'t have most of the great things about our country.   It\'s truly important that you get your voice out there without the filter of the media. We highly recommend you start by going to the essay section above. (it\'s the icon that looks like a book).  From there you can choose a category and start adding essays.</p>\r\n            <p>Once you\'ve added media about your cause, we highly reccommend that you go to the question section (the big question mark) and answer a few questions about your cause.  This will allow voters, politicians and others who never heard of you to find you.</p>\r\n\r\n            <p>Make sure to check out \"Settings\" (in the hamburger menu in the top right) so that you can go to your Profile and make sure that the information there about you is correct.</p>\r\n-->\r\n      <p>VoteWise has many tools and are adding more all the time. Some of these tools are pretty obvious how to use.\r\n        Some are not. Instructional videos are on the way, but if you have any particular requests, please email us at\r\n        <a href=\"mailto:email@votewise.net\" class=\"ylink\">email@votewise.net</a></p>\r\n      <!--       </h3>\r\n	</div>\r\n	<div ng-if=\"userRole==\'politician\'\">\r\n		<h3><p>To help voters find you, we highly recommend that you go straight to the question section (The big question mark above).  Choose subjects that matter to you.  You can always change your answers later if the conditions of the world change.   Answering these questions give you the best opportunity to automatically be matched up with voters and gives you a great opportunity to have your voice heard in as much detail as you want.</p>\r\n\r\n        <p>Make sure to check out \"Settings\" (in the hamburger menu in the top right) so that you can go to your Profile and make sure that the information there about you is correct.  Getting your zip code right is important for you to properly use the Politician tool (the top hat)</p>\r\n\r\n        <p>If you click on the top hat, you\'ll see a list of politicians in your area. Find your name and click \"View/Create\" Debate to make open statements or engage in discussion with voters and other politicians. You\'ll notice that you can select your opponents to tag so that anyone clicking on them would get a link to your post also.</p>\r\n\r\n         <p>VoteWise has many tools and are adding more all the time.  Some of these tools are pretty obvious how to use.  Some are not.  Instructional videos are on the way, but if you have any particular requests, please email us at email@votewise.net</p>\r\n\r\n        </h3>\r\n	</div>\r\n	<div ng-if=\"userRole==\'press\'\">\r\n\r\n        <h3><p>To help voters find you, we highly recommend that you go straight to the Press section (The big microphone above).  There you can start posting news.</p>\r\n\r\n        <p>Make sure to check out \"Settings\" (in the hamburger menu in the top right) so that you can go to your Profile and make sure that the information there about you is correct.  Take special note of what towns and counties you cover - listing these correctly will help your readers find you.</p>\r\n\r\n         <p>VoteWise has many tools and are adding more all the time.  Some of these tools are pretty obvious how to use.  Some are not.  Instructional videos are on the way, but if you have any particular requests, please email us at email@votewise.net</p>\r\n	</div>\r\n	<div ng-if=\"userRole==\'admin\'\">\r\n		<h3>Only Admin can see content from this Div</h3>\r\n	</div>\r\n<!--\r\n	<div ng-if=\"userData.isemailverified\">Email is verfied</div>\r\n	<div ng-if=\"!userData.isemailverified\">Email is not verfied</div>\r\n-->\r\n\r\n      <!--\r\n</div>\r\n<iframe id=videoblock2 width=\"345\" height=\"194\" src=\"https://www.youtube.com/embed/uYX5irdOLHg?rel=0\" frameborder=\"0\" allowfullscreen style=\"padding:10px\"></iframe>\r\n\r\n        <iframe width=\"345\" height=\"194\"\r\nsrc=\"https://www.youtube.com/embed/_mFkXiLJyOY?rel=0\" frameborder=\"0\"\r\nallowfullscreen style=\"padding:10px\"></iframe>\r\n\r\n-->\r\n\r\n      <p>\r\n        <h1>\r\n          <center>VoteWise Ads</center>\r\n        </h1>\r\n      </p>\r\n      <p>VoteWise is entirely run by volunteers and small donations. One of the best ways you can help us is by clicking\r\n        on the paper airplane icons to share our ads on your social media and telling your friends to do the same.</p>\r\n      <br>\r\n      <iframe src=\"https://player.vimeo.com/video/295984284\" width=\"345\" height=\"194\" frameborder=\"0\"\r\n        webkitallowfullscreen mozallowfullscreen allowfullscreen style=\"padding:10px\"></iframe>\r\n\r\n      <iframe src=\"https://player.vimeo.com/video/294472087\" width=\"345\" height=\"194\" frameborder=\"0\"\r\n        webkitallowfullscreen mozallowfullscreen allowfullscreen style=\"padding:10px\"></iframe>\r\n\r\n      <iframe src=\"https://player.vimeo.com/video/295179318\" width=\"345\" height=\"194\" frameborder=\"0\"\r\n        webkitallowfullscreen mozallowfullscreen allowfullscreen style=\"padding:10px\"></iframe>\r\n\r\n\r\n\r\n      <iframe width=\"345\" height=\"194\" src=\"https://www.youtube.com/embed/MZCnDRcV7mw?rel=0\" frameborder=\"0\"\r\n        allowfullscreen style=\"padding:10px\"></iframe>\r\n\r\n<script type=\"text/ng-template\" id=\"popUp\">\r\n  <div class=\"container\">\r\n   <p ng-if=\"showBoth && $root.userRole==\'politician\'\">You can read, but you can\'t write anything on the site until you confirm your email address.  <br><br> After you confirm your email, you can write, but everything will have the byline \"Unknown Politician\" until we can confirm your identification (then all your work will change to your byline).  You can wait for us to research you or you can use our automated ID confirmation system (which costs $1)</p>\r\n			<p ng-if=\"showBoth && $root.userRole==\'advocate\'\">You can read, but you can\'t write anything on the site until you confirm your email address.  <br><br> After you confirm your email, you can write, but everything will have the byline \"Unknown Organization\" until we can confirm your identification (then all your work will change to your byline).</p>\r\n   <p ng-if=\"showEm\">You can read, but you can\'t write anything on the site until you confirm your email address.</p>\r\n   <p ng-if=\"showCon && !showBoth && !showEm && $root.userRole==\'politician\'\">We still need to confirm you are who you say you are. If you are running for a large office, we will do the research to figure that out.  If you are running for a more local office and you don\'t want to wait for us, you can use the automated ID check which costs $1.</p>\r\n\r\n   <div class=\"ngdialog-buttons\">\r\n   <button  ng-click=\"sendMail()\" type=\"button\" class=\"ngdialog-button ngdialog-button-primary\" ng-if=\"showEm || (showBoth && $root.userRole==\'politician\')\">Resend Confirmation Email</button>\r\n   <button ng-click=\"goto()\" ng-if=\"showCon && $root.userRole==\'politician\'\" type=\"button\" class=\"ngdialog-button ngdialog-button-primary\">Confirm Id</button>\r\n   <button ng-click=\"closeIt()\" type=\"button\" class=\"ngdialog-button ngdialog-button-primary\">Later</button>\r\n   </div>\r\n  </div>\r\n\r\n\r\n\r\n</script>\r\n");
$templateCache.put("app/incumbent_politician/incumbent_politician.html","<!-- <div id=\"background\"></div> -->\r\n<div class=\"container-fluid\">\r\n  <h2 class=\"pageHeading\">YOUR POLITICIANS</h2>\r\n  <p class=\"pageSubHeading noPaddBott\">Elected Officials and Candidates</p>\r\n  <div ng-cloak ng-show=\"$root.userRole==\'advocate\' \">\r\n    <p class=\"pageSubHeading\">\r\n      The politicians listed here are the ones in office that represent the\r\n      address you specified as your home office. Find the politician you want\r\n      and click \"Add\" in the rating column to add your own rating. Click in the\r\n      Debate column to engage in discussions about them. If you want to leave\r\n      reviews or endorsements for candidates in the upcoming election, click the\r\n      <a href=\"#!/compare-select/politician\" class=\"ylink\"\r\n        >See Your Candidates</a\r\n      >\r\n      tab. If you want to rate or endorse politicians outside this area, hit the\r\n      <a href=\"#!/ratePolitician\" class=\"ylink\">Rate Unlisted Politicians </a\r\n      >button.\r\n    </p>\r\n  </div>\r\n  <div class=\"centerediframe\">\r\n    <iframe\r\n      src=\"https://player.vimeo.com/video/407429014?byline=false&title=false\"\r\n      allowfullscreen\r\n    ></iframe>\r\n  </div>\r\n  <button\r\n    ng-click=\"showPopups()\"\r\n    type=\"button\"\r\n    class=\"btn2Short-style widthAuto btn-success\"\r\n  >\r\n    Set or Change Location\r\n  </button>\r\n  <div class=\"row d-none d-lg-flex\">\r\n    <div class=\"col-lg-4 offset-md-2 removePaddingRight\">\r\n      <p id=\"seeElectedPolitician\">These Are Your Representatives</p>\r\n    </div>\r\n    <div class=\"col-lg-4 removePaddingLeft\">\r\n      <a href=\"#!/compare-select/politician\" class=\"removeAnchorUnderline\">\r\n        <p id=\"seeCandidiates\">See Your Candidates</p>\r\n      </a>\r\n    </div>\r\n  </div>\r\n  <!-- Small Screen -->\r\n  <div class=\"row d-lg-none\">\r\n    <div class=\"col-6 removePaddingRight\">\r\n      <p id=\"seeElectedPoliticianSmall\">Your Reps</p>\r\n    </div>\r\n    <div class=\"col-6 removePaddingLeft\">\r\n      <a href=\"#!/compare-select/politician\" class=\"removeAnchorUnderline\">\r\n        <p id=\"seeCandidiatesSmall\">See Your Candidates</p>\r\n      </a>\r\n    </div>\r\n  </div>\r\n  <div\r\n    class=\"alert alert-danger alert-dismissible\"\r\n    id=\"alert\"\r\n    ng-if=\"showAlert\"\r\n    style=\"width: 60%; margin-left: 28%; margin-top: 10%\"\r\n  >\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button>\r\n    <strong>\r\n      we don\'t have your right state level district information.\r\n    </strong>\r\n  </div>\r\n  <div class=\"row d-none d-lg-flex\">\r\n    <div class=\"col-lg-12\">\r\n      <div id=\"topHeader\">\r\n        <div id=\"politicianIcon\">\r\n          <img\r\n            src=\"./assets/images/yourPoliticansIcon200.jpg\"\r\n            class=\"img-fluid\"\r\n          />\r\n        </div>\r\n        <div id=\"electedOfficial\">\r\n          <h2>ELECTED OFFICIALS</h2>\r\n          <p>Find out what they stand for. Contact them for help.</p>\r\n          <nav class=\"nav nav-pills nav-fill optionTabs\">\r\n            <a\r\n              class=\"dayButtons flex-sm-fill text-sm-center nav-link\"\r\n              ng-click=\"getByType(\'local\')\"\r\n              ng-class=\"{\'acivetab\': sortype == \'local\'}\"\r\n              >Local</a\r\n            >\r\n            <a\r\n              class=\"dayButtons flex-sm-fill text-sm-center nav-link\"\r\n              ng-click=\"getByType(\'county\')\"\r\n              ng-class=\"{\'acivetab\': sortype == \'county\'}\"\r\n              >County</a\r\n            >\r\n            <a\r\n              class=\"dayButtons flex-sm-fill text-sm-center nav-link\"\r\n              ng-click=\"getByType(\'state\')\"\r\n              ng-class=\"{\'acivetab\': sortype == \'state\'}\"\r\n              >State</a\r\n            >\r\n            <a\r\n              class=\"dayButtons flex-sm-fill text-sm-center nav-link\"\r\n              ng-click=\"getByType(\'federal\')\"\r\n              ng-class=\"{\'acivetab\': sortype == \'federal\'}\"\r\n              >Federal</a\r\n            >\r\n            <a\r\n              class=\"dayButtons flex-sm-fill text-sm-center nav-link\"\r\n              ng-click=\"getByType(\'other\')\"\r\n              ng-class=\"{\'acivetab\': sortype == \'other\'}\"\r\n              >Other</a\r\n            >\r\n          </nav>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <!-- Small Screen -->\r\n  <div class=\"row d-lg-none\">\r\n    <div class=\"col-12\">\r\n      <img\r\n        ng-src=\"./assets/images/yourPoliticansIcon200.jpg\"\r\n        class=\"politicianIconSmall img-fluid\"\r\n      />\r\n      <div>\r\n        <div id=\"descContainer\">\r\n          <div class=\"candidateDescSmall\">\r\n            <h5 class=\"blockTitle\">ELECTED OFFICIALS</h5>\r\n            <span class=\"blockDesc\"\r\n              >Find out what they stand for. Contact them for help.</span\r\n            >\r\n          </div>\r\n        </div>\r\n        <div id=\"selectBoxContainer\">\r\n          <select\r\n            class=\"custom-select selectBox\"\r\n            ng-model=\"sortype\"\r\n            ng-change=\"getByType(sortype)\"\r\n          >\r\n            <option selected value=\"local\">Local</option>\r\n            <option value=\"county\">County</option>\r\n            <option value=\"state\">State</option>\r\n            <option value=\"federal\">Federal</option>\r\n            <option value=\"other\">Other</option>\r\n          </select>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <!-- <div id=\"topHeaderCandidate\">\r\n        <div id=\"candidateDesc\">\r\n          <h2>CANDIDATES</h2>\r\n          <p>Find out what they stand for.</p>\r\n          <nav class=\"nav nav-pills flex-column flex-sm-row optionTabs\">\r\n            <a class=\"dayButtons flex-sm-fill text-sm-center nav-link\">Local</a>\r\n            <a class=\"dayButtons flex-sm-fill text-sm-center nav-link\">County</a>\r\n            <a class=\"dayButtons flex-sm-fill text-sm-center nav-link\">State</a>\r\n            <a class=\"dayButtons flex-sm-fill text-sm-center nav-link\">Federal</a>\r\n            <a class=\"dayButtons flex-sm-fill text-sm-center nav-link\">Other</a>\r\n          </nav>\r\n        </div>\r\n        <div id=\"candidiateIcon\"><img src=\"./assets/images/candidatesIcon4.svg\" class=\"img-fluid\" style=\"height:250px;\"></div>\r\n      </div> -->\r\n  </div>\r\n  <div>\r\n    <div class=\"col-lg-12 col-centered\" id=\"compareContent\">\r\n      <!--<div class=\"tableContainer\" ng-repeat=\"(key, value) in searchUsersByType | groupBy: \'office\'\">\r\n        <center>\r\n          <h3 style=\"text-transform: capitalize; color:#fff;\">{{key}}</h3>\r\n        </center>\r\n        <div id=\"table-scroll\" class=\"table-scroll\">\r\n          <div class=\"table-wrap\">\r\n            <table class=\"main-table\">\r\n              <thead>\r\n                <tr>\r\n                  <th class=\"tableHead fixed-side\" scope=\"col\">Compare</th>\r\n                  <th class=\"tableHead fixed-side\" scope=\"col\">Name</th>\r\n                  <th class=\"tableHead\" scope=\"col\">Contact Politician</th>\r\n                  <th class=\"tableHead\" scope=\"col\">Questions Answered</th>\r\n                  <th class=\"tableHead\" scope=\"col\">Statement</th>\r\n                  <th class=\"tableHead\" scope=\"col\">Resume</th>\r\n                  <th class=\"tableHead\" scope=\"col\">Website</th>\r\n                  <th class=\"tableHead\" scope=\"col\">Incumbent</th>\r\n                  <th class=\"tableHead\" scope=\"col\">Debate/Discuss</th>\r\n                  <th class=\"tableHead\" scope=\"col\">Party</th>\r\n                  <th class=\"tableHead\" scope=\"col\">More Info</th>\r\n                </tr>\r\n              </thead>\r\n              <tbody>\r\n                <tr ng-repeat=\"user in value | orderBy : [\'-registeredUser\', \'-total_answers\']\">\r\n                  <th class=\"tableRow fixed-side\" ng-init=\"user.registeredUser ? user.isSelected = true : user.isSelected = false\">\r\n                    <div class=\"checkbox_wrapper\" ng-if=\"user.registeredUser && !selectForPrint\">\r\n                      <input type=\"checkbox\" name=\"Compare\" value=\"{{user._id}}\" ng-model=\"user.isSelected\" ng-checked=\"selectedUser.indexOf(user) > -1\" ng-click=\"toggleSelection(user)\" ng-if=\"user.registeredUser && !selectForPrint\" />\r\n                      <label></label>\r\n                    </div>\r\n                    <div class=\"checkbox_wrapper\" ng-show=\"selectForPrint\">\r\n                      <input type=\"checkbox\" name=\"print\" value=\"{{user._id}}\" ng-checked=\"selectedUserPrint.indexOf(user) > -1\" ng-click=\"togglePrintSelection(user)\" ng-show=\"selectForPrint\" />\r\n                      <label></label>\r\n                    </div>\r\n                    <span ng-if=\"!selectForPrint && !user.registeredUser\">N/A</span>\r\n\r\n                  </th>\r\n                  <th class=\"tableRow fixed-side\">\r\n                    <a ng-if=\"user.registeredUser\" ng-href=\"#!/publicProfile/{{user._id}}/false\">\r\n                            <span ng-if=\"user.nameOnBallot\" style=\"text-decoration:underline;\" class=\"link\"><b>{{user.nameOnBallot}}</b></span>\r\n                            <span ng-if=\"!user.nameOnBallot\" style=\"text-decoration:underline;\" class=\"link\"><b>{{user.name}}</b></span>\r\n                        </a>\r\n                    <a ng-if=\"!user.registeredUser\" ng-href=\"#!/publicProfile/{{user._id}}/true\">\r\n                            <span ng-if=\"user.nameOnBallot\" style=\"text-decoration:underline;\" class=\"link\"><b>{{user.nameOnBallot}}</b></span>\r\n                            <span ng-if=\"!user.nameOnBallot\" style=\"text-decoration:underline;\" class=\"link\"><b>{{user.name}}</b></span>\r\n                        </a>\r\n                  </th>\r\n                  <td class=\"tableRow\">\r\n                    <a ng-href=\"#!/publicProfile/{{user._id}}/false\">\r\n                      <button ng-if=\"user.registeredUser\">\r\n                        Contact\r\n                      </button>\r\n                    </a>\r\n                    <a ng-href=\"#!/publicProfile/{{user._id}}/true\">\r\n                      <button ng-if=\"!user.registeredUser\">\r\n                        Contact\r\n                      </button>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"tableRow\">\r\n                    <span ng-if=\"user.total_answers == 0\">{{user.total_answers}}</span>\r\n                    <a ng-if=\"user.total_answers > 0\" href=\"#!/question-answered-by/{{user._id}}\" style=\"text-decoration:underline;\" class=\"link\"><b>{{user.total_answers}}</b></a>\r\n                    <span ng-if=\"user.total_answers == null || user.total_answers == undefined\">-</span>\r\n                  </td>\r\n                  <td class=\"tableRow\">\r\n                    <a href=\"javascript: void(0)\" ng-if=\"user.resume\" ng-click=\"showHtmlViewer1(user.statement, \'Statement\')\" class=\"link\"><b>View</b></a>\r\n                    <span ng-if=\"!user.resume\">-</span>\r\n                  </td>\r\n                  <td class=\"tableRow\">\r\n                    <a href=\"javascript: void(0)\" ng-if=\"user.statement\" ng-click=\"showHtmlViewer1(user.resume, \'Resume\')\" style=\"text-decoration:underline;\" class=\"link\"><b>View</b></a>\r\n                    <span ng-if=\"!user.statement\">-</span>\r\n                  </td>\r\n                  <td class=\"tableRow\">\r\n                    <a ng-if=\"user.web_url\" ng-href=\"{{user.web_url | addHttp}}\" target=\"_blank\" style=\"text-decoration:underline;\" class=\"link\"> <b>View</b></a>\r\n                    <a ng-if=\"user.website\" ng-href=\"{{user.website | addHttp}}\" target=\"_blank\" style=\"text-decoration:underline;\" class=\"link\"> <b>View</b></a>\r\n                    <span ng-if=\"!user.web_url && !user.website\">-</span>\r\n                  </td>\r\n                  <td class=\"tableRow\">\r\n                    <span ng-if=\"user.incumbent\">{{user.incumbent}}</span>\r\n                    <span ng-if=\"!user.incumbent\">No</span>\r\n                  </td>\r\n                  <td class=\"tableRow\">\r\n                    <a href=\"javascript: void(0)\" ng-click=\"goToPoliticianThread(key, value, user)\" style=\"text-decoration:underline;\" class=\"link\" ng-if=\"user.total_tagged && user.total_tagged > 0\"><b>\r\n              View</b>\r\n\r\n          </a>\r\n                    <a href=\"javascript: void(0)\" ng-click=\"goToPoliticianThread(key, value, user)\" style=\"text-decoration:underline;\" class=\"link\" ng-if=\"!user.total_tagged || user.total_tagged == 0\"><b>\r\n              Create</b>\r\n          </a>\r\n                  </td>\r\n                  <td class=\"tableRow\">{{user.party}}</td>\r\n                  <td class=\"tableRow\" style=\"text-transform: capitalize;\">\r\n\r\n                    <a ng-if=\"user.dataX\" ng-href=\"{{user.dataX}}\" target=\"_blank\" style=\"text-decoration:underline;\"><b>Open</b></a>\r\n                  </td>\r\n                </tr>\r\n              </tbody>\r\n            </table>\r\n          </div>\r\n        </div>\r\n      </div>-->\r\n      <div ng-if=\"showIncumbentLoader\">\r\n        Please wait while we are loading your nearest politicians.\r\n      </div>\r\n      <div ng-if=\"!showIncumbentLoader && searchUsersByType.length == 0\">\r\n        VoteWise is a national organization, but we have some gaps in local\r\n        coverage. If you don\'t see any information in the Local tab, you may\r\n        live in a town with fewer than 30,000 residents, or you may live in a\r\n        larger city that is both a city and a county. Try one of the other tabs\r\n        to see your county, state, and federal officials.\r\n      </div>\r\n      <div\r\n        class=\"tableContainer\"\r\n        ng-if=\"searchUsersByType.length > 0\"\r\n        ng-repeat=\"(key, value) in searchUsersByType | groupBy: \'office\'\"\r\n      >\r\n        <center>\r\n          <h3 style=\"text-transform: capitalize; color: #fff\">{{key}}</h3>\r\n        </center>\r\n        <div class=\"table-responsive\">\r\n          <table class=\"table table-striped\" style=\"margin-bottom: 0px\">\r\n            <tr>\r\n              <th class=\"tableHead\">\r\n                <span class=\"d-none d-md-flex\">Compare</span>\r\n                <!-- <span class=\"d-none d-sm-block d-md-none\"></span> -->\r\n              </th>\r\n              <th class=\"tableHead\">Name</th>\r\n              <th class=\"tableHead\">Contact Politician</th>\r\n              <th class=\"tableHead\">Questions Answered</th>\r\n              <th class=\"tableHead\">Ratings</th>\r\n              <th class=\"tableHead\">Statement</th>\r\n              <th class=\"tableHead\">Resume</th>\r\n              <th class=\"tableHead\">Website</th>\r\n              <!--    <th class=\"tableHead\">Incumbent</th>   -->\r\n              <th class=\"tableHead\">Debate / Discuss</th>\r\n              <th class=\"tableHead\">Party</th>\r\n              <!--   <th class=\"tableHead\">More Info</th>   -->\r\n            </tr>\r\n            <tr\r\n              ng-repeat=\"user in value | orderBy : [\'-registeredUser\', \'-total_answers\',\'-office\'] track by $index\"\r\n            >\r\n              <td\r\n                class=\"tableRow\"\r\n                ng-init=\"user.registeredUser ? user.isSelected = true : user.isSelected = false\"\r\n              >\r\n                <div class=\"checkbox_wrapper\" ng-if=\"!selectForPrint\">\r\n                  <input\r\n                    type=\"checkbox\"\r\n                    name=\"Compare\"\r\n                    value=\"{{user._id}}\"\r\n                    ng-model=\"user.isSelected\"\r\n                    ng-checked=\"true\"\r\n                    ng-click=\"toggleSelection(user)\"\r\n                    ng-if=\"!selectForPrint\"\r\n                  />\r\n                  <label></label>\r\n                </div>\r\n                <!-- <span ng-if=\"!selectForPrint && !user.registeredUser\">N/A</span> -->\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a\r\n                  ng-if=\"user.registeredUser && user.politicianIds.length > 0\"\r\n                  ng-href=\"#!/publicProfile/{{user.politicianIds[0]}}/true\"\r\n                >\r\n                  <span\r\n                    ng-if=\"user.nameOnBallot\"\r\n                    style=\"text-decoration: underline\"\r\n                    class=\"link\"\r\n                  >\r\n                    <b>{{user.nameOnBallot}}</b>\r\n                  </span>\r\n                  <span\r\n                    ng-if=\"!user.nameOnBallot\"\r\n                    style=\"text-decoration: underline\"\r\n                    class=\"link\"\r\n                  >\r\n                    <b>{{user.name}}</b>\r\n                  </span>\r\n                </a>\r\n                <a\r\n                  ng-if=\"user.registeredUser && user.politicianIds.length == 0\"\r\n                  ng-href=\"#!/publicProfile/{{user._id}}/false\"\r\n                >\r\n                  <span\r\n                    ng-if=\"user.nameOnBallot\"\r\n                    style=\"text-decoration: underline\"\r\n                    class=\"link\"\r\n                  >\r\n                    <b>{{user.nameOnBallot}}</b>\r\n                  </span>\r\n                  <span\r\n                    ng-if=\"!user.nameOnBallot\"\r\n                    style=\"text-decoration: underline\"\r\n                    class=\"link\"\r\n                  >\r\n                    <b>{{user.name}}</b>\r\n                  </span>\r\n                </a>\r\n                <a\r\n                  ng-if=\"!user.registeredUser\"\r\n                  ng-href=\"#!/publicProfile/{{user._id}}/true\"\r\n                >\r\n                  <span\r\n                    ng-if=\"user.nameOnBallot\"\r\n                    style=\"text-decoration: underline\"\r\n                    class=\"link\"\r\n                  >\r\n                    <b>{{user.nameOnBallot}}</b>\r\n                  </span>\r\n                  <span\r\n                    ng-if=\"!user.nameOnBallot\"\r\n                    style=\"text-decoration: underline\"\r\n                    class=\"link\"\r\n                  >\r\n                    <b>{{user.name}}</b>\r\n                  </span>\r\n                </a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a ng-href=\"#!/publicProfile/{{user._id}}/false\">\r\n                  <button ng-if=\"user.registeredUser\" class=\"btnW\">\r\n                    Contact\r\n                  </button>\r\n                </a>\r\n                <a ng-href=\"#!/publicProfile/{{user._id}}/true\">\r\n                  <button ng-if=\"!user.registeredUser\" class=\"btnW\">\r\n                    Contact\r\n                  </button>\r\n                </a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <span ng-if=\"user.total_answers == 0\"\r\n                  >{{user.total_answers}}</span\r\n                >\r\n                <a\r\n                  ng-if=\"user.total_answers > 0\"\r\n                  href=\"#!/question-answered-by/{{user._id}}/{{user.votesmartCandidateId}}/politician\"\r\n                  style=\"text-decoration: underline\"\r\n                  class=\"link\"\r\n                >\r\n                  <b>{{user.total_answers}}</b>\r\n                </a>\r\n                <span\r\n                  ng-if=\"user.total_answers == null || user.total_answers == undefined\"\r\n                  >-</span\r\n                >\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a\r\n                  ng-if=\"user.registeredUser\"\r\n                  href=\"#!/allRatings/{{user._id}}\"\r\n                  class=\"link\"\r\n                >\r\n                  <b>{{user.total_reviews}}</b>\r\n                </a>\r\n                <a\r\n                  ng-if=\"!user.registeredUser\"\r\n                  href=\"#!/allRatings/{{user._id}}/false/true\"\r\n                  class=\"link\"\r\n                >\r\n                  <b>{{user.total_reviews}}</b>\r\n                </a>\r\n\r\n                <span\r\n                  ng-if=\"$root.userRole==\'politician\' ||$root.userRole==\'advocate\' || $root.userRole==\'admin\'\"\r\n                >\r\n                  /\r\n                  <a href=\"#!/addRating/{{user._id}}\" class=\"link\">\r\n                    <b>Add</b>\r\n                  </a></span\r\n                >\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a\r\n                  href=\"javascript: void(0)\"\r\n                  ng-if=\"user.resume\"\r\n                  ng-click=\"showHtmlViewer1(user.statement, \'Statement\')\"\r\n                  class=\"link\"\r\n                >\r\n                  <b>View</b>\r\n                </a>\r\n                <span ng-if=\"!user.resume\">-</span>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a\r\n                  href=\"javascript: void(0)\"\r\n                  ng-if=\"user.statement\"\r\n                  ng-click=\"showHtmlViewer1(user.resume, \'Resume\')\"\r\n                  style=\"text-decoration: underline\"\r\n                  class=\"link\"\r\n                >\r\n                  <b>View</b>\r\n                </a>\r\n                <span ng-if=\"!user.statement\">-</span>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a\r\n                  ng-if=\"user.webUrl\"\r\n                  ng-href=\"{{user.webUrl | addHttp}}\"\r\n                  target=\"_blank\"\r\n                  style=\"text-decoration: underline\"\r\n                  class=\"link\"\r\n                >\r\n                  <b>View</b>\r\n                </a>\r\n                <a\r\n                  ng-if=\"user.web_url\"\r\n                  ng-href=\"{{user.web_url | addHttp}}\"\r\n                  target=\"_blank\"\r\n                  style=\"text-decoration: underline\"\r\n                  class=\"link\"\r\n                >\r\n                  <b>View</b>\r\n                </a>\r\n\r\n                <a\r\n                  ng-if=\"user.website\"\r\n                  ng-href=\"{{user.website | addHttp}}\"\r\n                  target=\"_blank\"\r\n                  style=\"text-decoration: underline\"\r\n                  class=\"link\"\r\n                >\r\n                  <b>View</b>\r\n                </a>\r\n                <span ng-if=\"!user.webUrl && !user.website &&!user.web_url\"\r\n                  >-</span\r\n                >\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a\r\n                  href=\"javascript: void(0)\"\r\n                  ng-click=\"goToPoliticianThread(key, value, user)\"\r\n                  style=\"text-decoration: underline\"\r\n                  class=\"link\"\r\n                  ng-if=\"user.total_tagged && user.total_tagged > 0\"\r\n                >\r\n                  <b> View</b>\r\n                </a>\r\n                <a\r\n                  href=\"javascript: void(0)\"\r\n                  ng-click=\"goToPoliticianThread(key, value, user)\"\r\n                  style=\"text-decoration: underline\"\r\n                  class=\"flink\"\r\n                  ng-if=\"!user.total_tagged || user.total_tagged == 0\"\r\n                >\r\n                  <b> Create</b>\r\n                </a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <span ng-if=\"user.party !=\'\'\">{{user.party}}</span>\r\n                <!-- <span  ng-repeat=\"p in user.party track by $index\">{{p}} </span> -->\r\n                <span ng-if=\"!user.party\"\r\n                  >{{user.winDetails[0].officeParties}}</span\r\n                >\r\n              </td>\r\n            </tr>\r\n          </table>\r\n        </div>\r\n        <button\r\n          ng-hide=\"selectForPrint || users.length <= 0\"\r\n          ng-click=\"compareOfficeWiseSubject(value)\"\r\n          class=\"compareBtn\"\r\n        >\r\n          Compare Answers\r\n        </button>\r\n        <button\r\n          ng-hide=\"selectForPrint || users.length <= 0\"\r\n          ng-click=\"compareRatings(value)\"\r\n          class=\"compareBtn wlink\"\r\n        >\r\n          Compare Ratings\r\n        </button>\r\n        <div\r\n          ng-if=\"$root.userRole==\'politician\' ||$root.userRole==\'advocate\' || $root.userRole==\'admin\'\"\r\n        >\r\n          <a href=\"#!/ratePolitician\" class=\"btn\">\r\n            Rate Unlisted Politicians\r\n          </a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <br />\r\n    <a href=\"#!/otherPoliticians\" class=\"btn\">Other Politicians</a>\r\n\r\n    <div class=\"bottomInfo\">\r\n      <p>\r\n        <a href=\"https://votesmart.org/\" target=\"_blank\">\r\n          <image\r\n            src=\"../assets/images/VoteSmartLogoD.png\"\r\n            class=\"partners\"\r\n          ></image\r\n        ></a>\r\n      </p>\r\n      <p>\r\n        Elected Official information is provided in part by VoteSmart.org and by\r\n        your local boards of elections. Please keep in mind that we get much of\r\n        our information about who is in office shortly after they are elected,\r\n        so if something happened after that, we may not know. We currently don\'t\r\n        cover all towns and cities, but your donations of money and information\r\n        can help us reach that goal. For the most current information, please\r\n        contact your local state or county board of elections.\r\n      </p>\r\n    </div>\r\n  </div>\r\n</div>\r\n<script type=\"text/ng-template\" id=\"guest_location\">\r\n    <div class=\"row\">\r\n      <div class=\"col-12\">\r\n        <h3>Select your location</h3>\r\n        <div class=\"col-md-12\">\r\n          <div class=\"control-group\" ng-if=\"Zip\">\r\n            <label class=\"control-label formLabel\">Street Address (Leave out Apt #)</label>\r\n            <div class=\"control-group\">\r\n              <input type=\"text\" id=\"address\" ng-model=\"User.Address\" ng-keyup=\"detectAddress($event)\" class=\"zipInput form-control\" />&nbsp;\r\n            </div>\r\n                <br>\r\n          </div>\r\n          <div class=\"control-group\" ng-if=\"Address\">\r\n            <label class=\"control-label formLabel removeTopMargin\" for=\"zipcode\">Zip Code</label>\r\n            <div class=\"control-group\">\r\n              <input type=\"text\" id=\"zipcodeinput\" ng-model=\"Location.ZipCode\" ng-keyup=\"detectCode($event)\" class=\"form-control validate[required,custom[integer],minSize[5]] text-input\" tabindex=\"1\" />&nbsp; &nbsp;\r\n              <i ng-if=\"showZipLoader\" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>\r\n              <input type=\"hidden\" ng-model=\"hidzip\">\r\n            </div>\r\n          </div>\r\n          <div ng-if=\"showAddressDropDown\">\r\n            <div class=\"form-group\" ng-if=\"Location.state && Location.state!=\'\'\">\r\n              <p style=\"float:right\" ng-if=\"Link\">\r\n\r\n                            <center>\r\n              <button ng-click=\"submitLocation()\" type=\"button\" class=\"btn2Short-style widthAuto btn-success\">Save</button>\r\n            </center>\r\n\r\n      <br><br>Check the information below to see if it is correct.  If any are labelled with yellow, you should open them up and select the right option.\r\n\r\n              </p>\r\n              <!--    <center>\r\n              <button ng-click=\"submitLocation()\" type=\"button\" class=\"btnShort-style widthAuto btn-success\">Set Location</button>\r\n            </center> -->\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel removeTopMargin\" for=\"email\">State </label>\r\n              <div class=\"controls\">\r\n                <select ng-model=\"Location.state\" style=\"text-transform: capitalize;\" ng-options=\"item.state for item in allstates track by item.stateFips\" ng-class=\"checkLength(allstates, \'state\')\"></select>\r\n              </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\" for=\"email\">County </label>\r\n              <div class=\"controls\">\r\n                <select ng-model=\"Location.county\" style=\"text-transform: capitalize;\" ng-options=\"item.countyName for item in allcounties track by item.countyFips\" ng-class=\"checkLength(allcounties, \'county\')\"></select>\r\n              </div>\r\n            </div>\r\n            <!-- <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\" for=\"email\">Sub county </label>\r\n              <div class=\"controls\">\r\n                <select ng-model=\"Location.countySubdivision\" style=\"text-transform: capitalize;\" ng-options=\"countySubdivision as item.countySubdivision for item in subcounties track by item.countySubdivision\"\r\n                  ng-class=\"checkLength(subcounties, \'countySubdivision\')\"></select>\r\n              </div>\r\n            </div> -->\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\" for=\"email\">City </label>\r\n              <div class=\"controls\">\r\n                <select ng-model=\"Location.place\" style=\"text-transform: capitalize;\" ng-options=\"item as item.placeName for item in places track by item.place\" ng-class=\"checkLength(places, \'place\')\"></select>\r\n              </div>\r\n              <!-- ng-change=\"getZipDataTwo()\" -->\r\n            </div>\r\n            <!--  <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"email\">Voter District (click if incorrect) </label>\r\n            <div class=\"controls\">\r\n              <select ng-model=\"Location.voterDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item.voterDistrictName for item in voterDistricts | unique:\'voterDistrictName\' track by item.voterDistrictName\" ng-change=\"onVoterDistChange()\" ng-class=\"{yellowBackground: voterDistricts.length > 1}\"></select>\r\n            </div>\r\n          </div> -->\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\" for=\"email\">Federal Congressional District (click if incorrect) </label>\r\n              <div class=\"controls\">\r\n                <select ng-model=\"Location.federalCongrassionalDist\" style=\"text-transform: capitalize;\" ng-options=\"item as item.CD115FP for item in federalCongrassionalDist track by item.CD115FP\" ng-class=\"checkLength(federalCongrassionalDist, \'federalCongrassionalDist\')\"></select>\r\n              </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\" for=\"email\">State Senate District (click if incorrect) </label>\r\n              <div class=\"controls\">\r\n                <select ng-model=\"Location.stateSenateDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item.NAMELSAD for item in stateSenateDistrict track by item.SLDUST\" ng-class=\"checkLength(stateSenateDistrict, \'stateSenateDistrict\')\"></select>\r\n              </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\" for=\"email\">State House of Representative District (click if incorrect) </label>\r\n              <div class=\"controls\">\r\n                <select ng-model=\"Location.stateHouseOFRepresentativeDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item.NAMELSAD for item in stateHouseOFRepresentativeDistricts track by item.NAMELSAD\" ng-class=\"checkLength(stateHouseOFRepresentativeDistricts, \'stateHouseOFRepresentativeDistrict\')\"></select>\r\n              </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\" for=\"email\">School District Name (click if incorrect) </label>\r\n              <div class=\"controls\">\r\n                <select ng-model=\"Location.unifiedSchoolDistrictName\" style=\"text-transform: capitalize;\" ng-options=\"item as item.NAME for item in unifiedSchoolDistrictNames track by item.NAME\" ng-class=\"checkLength(unifiedSchoolDistrictNames, \'unifiedSchoolDistrictName\')\"></select>\r\n              </div>\r\n            </div>\r\n                     <div class=\"control-group\" ng-if=\"cityCouncilDistrict.length > 0\">\r\n              <label class=\"control-label formLabel\" for=\"citycouncil\">City Council District Name(click if incorrect) </label>\r\n              <div class=\"controls\">\r\n                <select ng-model=\"Location.cityCouncilDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item.COUNTDIST for item in cityCouncilDistrict track by item.COUNTDIST\"\r\n                  ng-class=\"checkLength(cityCouncilDistrict, \'cityCouncilDistrict\')\"></select>\r\n              </div>\r\n            </div>\r\n            <div style=\"clear: both;\"></div>\r\n          </div>\r\n          <div style=\"clear: both;\"></div>\r\n          <!-- <p>This is our best guess at your representation districts. Please change any that are wrong.</p> -->\r\n          <div class=\"form-group\" ng-if=\"Location.state && Location.state!=\'\'\"><br>\r\n            <!-- <p style=\"float:right\" ng-if=\"Link\">\r\n              <a ng-click=\"getAddress()\" class=\"removeAnchorUnderline\">\r\n                click here\r\n              </a>\r\n            </p> -->\r\n            <center>\r\n              <button ng-click=\"submitLocation()\" type=\"button\" class=\"btn2Short-style widthAuto btn-success\">This Looks Correct</button>\r\n            </center>\r\n  <!--            <br><br>\r\n              <center>\r\n                  <a ng-click=\"getAddress()\" class=\"btn2Short-style widthAuto btn-success\">\r\n                    Try Zip Code Tool Instead\r\n                  </a>\r\n                </center>  -->\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n</script>\r\n<script type=\"text/ng-template\" id=\"statement\">\r\n    <div class=\"row\">\r\n    <div ng-bind-html=\'displayContent\'></div>\r\n  </div>\r\n</script>\r\n");
$templateCache.put("app/invitePoliticians/invitePoliticians.html","<div class=\"container-fluid\" ng-controller=\"invitePoliCtrl\">\r\n  <h2 class=\"pageHeading\">INVITE POLITICIANS</h2>\r\n	<p class=\"pageSubHeading noPaddBott\">When they take your quiz, you will get an email letting you know.</p>\r\n  <br>\r\n  <form name=\"myForm\" role=\"form\">\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Search Politicians</legend>\r\n      <div class=\"center\">\r\n        <span ng-if=\"quizName\"> Quiz Name:- {{quizName}}</span>\r\n      </div>\r\n      <div class=\"makeCenter\">\r\n        <label class=\"control-label formLabel whiteText\" for=\"email\">Search By Name</label>\r\n\r\n        <div>\r\n          <input type=\"text\" ng-model=\"User.name\" class=\"form-control\" style=\"width:30%;display:initial\">\r\n                  </div>\r\n        </div>\r\n        <div style=\"text-align: center;margin-top: 2%\">\r\n          <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"searchPoli()\">\r\n                              Search\r\n                            </button>\r\n          <!-- </div> -->\r\n        </div>\r\n    </fieldset>\r\n    <div class=\"row table-responsive\" ng-if=\"poliData.length > 0\" style=\"margin-top: 10px;\">\r\n      <table class=\"table w100 changeTextColor\">\r\n        <tr>\r\n          <th>\r\n            <input type=\"checkbox\" ng-change=\"SelectChecks()\" ng-model=\"isSelected\">\r\n            Select\r\n          </th>\r\n          <th>\r\n            Politician\r\n            Details\r\n          </th>\r\n          <th>\r\n            Send Invitation\r\n          </th>\r\n        </tr>\r\n        <tr ng-repeat=\"u in poliData track by $index\">\r\n          <td>\r\n            <input type=\"checkbox\" value=\"{{u._id}}\" ng-model=\"u.isSelected\" ng-click=\"select(u._id)\">\r\n          </td>\r\n          <td>\r\n            <p ng-if=\"u.name\" style=\"margin: 0;\">\r\n              <strong>Name:</strong>\r\n              <a href=\"#!/publicProfile/{{u._id}}\">{{u.name}}</a>\r\n            </p>\r\n            <p ng-if=\"u.address.statePostalCode\">\r\n              <strong>StatePostalCode:</strong>{{u.address.statePostalCode}}\r\n            </p>\r\n            <p ng-if=\"u.public_email\" style=\"margin: 0;\">\r\n              <strong>Email:</strong> {{u.public_email}}</p>\r\n            <p ng-if=\"u.mailing_address\" style=\"margin: 0;\">\r\n              <strong>Address:</strong> {{u.mailing_address}} </p>\r\n            <p ng-if=\"u.govtOfficialWebsite\" style=\"margin: 0;\">\r\n              <strong>Government Official Website:</strong>\r\n              <a ng-href=\"{{u.govtOfficialWebsite}}\" target=\"_blank\">{{u.govtOfficialWebsite}}</a>\r\n            </p>\r\n          </td>\r\n          <td>\r\n            <a href=\"\" class=\"link\" ng-click=\"sendInvitation(u._id)\">Send Invitation</a>\r\n          </td>\r\n        </tr>\r\n      </table>\r\n      <div style=\"margin-top: 2%\">\r\n        <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"sendInvitation()\">\r\n                              Send Invitation\r\n                            </button>\r\n\r\n      </div>\r\n    </div>\r\n  </form>\r\n</div>\r\n");
$templateCache.put("app/learnHome/basicsofpolitics.html","<div class=\"container-fluid ng-scope\">\r\n <h2 class=\"pageHeading\">The Basics of Politics</h2>\r\n  <p class=\"pageSubHeading\">1 hr tutorial on how the federal government and elections work. (or skip to areas of interest)</p>\r\n    <p>Please note that we often use the word, \"he\" when talking generically about a human being.  This is to make reading easier and not meant to infer that the person is male.</p>\r\n    \r\n    <div class=\"container-fluid\">\r\n    <div class=\"row basicContainer\">\r\n    <span class=\"anchorHidden\" id=\"top\"></span>\r\n      <div class=\"col col-lg-4 basicTopics\">\r\n      <div>  <!--  style=\" position: fixed;\r\n     width: 29%;\r\n     height: 500px; background-color:#ccc; overflow:scroll;\" id=\"social-float\" -->\r\n        <h3 style=\"text-align:center; padding-bottom:15px;\">Table of Content</h3>\r\n        \r\n        <p>\r\n          <a href=\"\" class=\"mainTopicNoIcon\" ng-click=\"$root.gotoAnchor(\'_Toc459927138\')\">REPRESENTATIONAL DEMOCRACY</a></p>\r\n        <div id=\"accordionbasic\" class=\"accordionBasic\">\r\n          <div class=\"card mb-0\">\r\n            <div class=\"card-header collapsed\" data-toggle=\"collapse\" href=\"#collapseOne\" style=\"padding-top: 0px;\">\r\n              <a href=\"\" class=\"card-title\" ng-click=\"$root.gotoAnchor(\'_Toc459927139\')\">THE THREE BRANCHES OF GOVERNMENT</a>\r\n            </div>\r\n            <div id=\"collapseOne\" class=\"card-body collapse\" data-parent=\"#accordionbasic\">\r\n              <ul>\r\n                <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927140\')\">THE EXECUTIVE BRANCH</a></li>\r\n                <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927141\')\">THE LEGISLATIVE BRANCH</a></li>\r\n                <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927142\')\">JUDICIAL BRANCH</a></li>\r\n              </ul>\r\n            </div>\r\n            <div class=\"card-header collapsed\" data-toggle=\"collapse\" data-parent=\"#accordionbasic\" href=\"#collapseTwo\">\r\n              <a href=\"\" class=\"card-title\" ng-click=\"$root.gotoAnchor(\'_Toc459927143\')\">PRIMARIES</a>\r\n            </div>\r\n            <div id=\"collapseTwo\" class=\"card-body collapse\" data-parent=\"#accordionbasic\">\r\n              <ul>\r\n                <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927144\')\">CLOSED PRIMARY VS OPEN PRIMARY ELECTIONS</a></li>\r\n \r\n                <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927145\')\">CAUCUS</a></li>\r\n                <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc4599271462\')\">RUN OFF ELECTIONS</a></li>\r\n                  <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc4599271461\')\">CUMULATIVE VOTING</a></li>\r\n                <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927146\')\">WHO RUNS THE PRIMARIES AND CAUCUSES?</a></li>\r\n                <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927147\')\">DELEGATES, CONVENTIONS AND THE ELECTORAL COLLEGE</a></li>\r\n                <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927148\')\">SO WHAT IS THE ELECTORAL COLLEGE AND HOW DOES IT WORK?</a></li>\r\n              </ul>\r\n            </div>\r\n            <div class=\"card-header collapsed\" data-toggle=\"collapse\" data-parent=\"#accordionbasic\" href=\"#collapseFour\">\r\n              <a href=\"\" class=\"card-title\" ng-click=\"$root.gotoAnchor(\'_Toc459927149\')\">THE POLITICAL PARTIES</a>\r\n            </div>\r\n            <div id=\"collapseFour\" class=\"card-body collapse\" data-parent=\"#accordionbasic\">\r\n              <ul>\r\n                <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927150\')\">TWO EXTREMES OF HOW TO RUN AN ECONOMY</a></li>\r\n                <ul>\r\n                  <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927151\')\">COMMUNISM</a></li>\r\n                  <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927152\')\">CAPITALISM</a></li>\r\n                </ul>\r\n                <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927153\')\">TWO EXTREMES ON SIZE OF GOVERNMENT</a></li>\r\n                <ul>\r\n                  <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927154\')\">COMMUNISM</a></li>\r\n                  <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927155\')\">ANARCHISM</a></li>\r\n                </ul>\r\n                <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927156\')\">WILDLY OVERSIMPLIFIED DESCRIPTIONS OF COMMON PARTIES</a></li>\r\n                <ul>\r\n                  <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927157\')\">COMMUNIST</a></li>\r\n                  <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927158\')\">SOCIALISTS</a></li>\r\n                  <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927159\')\">DEMOCRAT</a></li>\r\n                  <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927160\')\">REPUBLICANS</a></li>\r\n                  <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927161\')\">LIBERTARIAN</a></li>\r\n                  <li><a href=\"\" ng-click=\"$root.gotoAnchor(\'_Toc459927162\')\">THE TEA PARTY</a></li>\r\n                </ul>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <p><a href=\"\" class=\"mainTopicNoIcon\" ng-click=\"$root.gotoAnchor(\'_Toc459927164\')\" style=\"margin-top:10px;\">LIBERAL VS CONSERVATIVE</a></p>\r\n        <p><a href=\"\" class=\"mainTopicNoIcon\" ng-click=\"$root.gotoAnchor(\'_Toc459927165\')\">FINAL WARNING</a></p>\r\n        </div>\r\n      </div>\r\n      <div class=\"col col-lg-8 basicInfo\">\r\n        <span class=\"anchorHidden\" id=\"_Toc459927138\"></span>\r\n        <h1>REPRESENTATIONAL DEMOCRACY</h1>\r\n        <p>Running a government requires countless decisions, each of which has to be studied deeply.&nbsp; It is a full time job. Expecting every citizen to earn a living, raise their family plus do the additional full time job of running the government is unrealistic.&nbsp; So instead, we choose people to represent our best interests. This is called &ldquo;representational democracy&rdquo; and it&rsquo;s what we have in America.&nbsp; In this system, it becomes incredibly important that you pick politicians who would do the same thing you would if you were in their shoes.&nbsp; If there are issues you really care about, it also becomes important for you to continue to read the news and tell your politicians how they should vote throughout their term in office.</p>\r\n        <p>&nbsp;</p>\r\n        <a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n        <span class=\"anchorHidden\" id=\"_Toc459927139\"></span>\r\n        <h2>THE THREE BRANCHES OF GOVERNMENT</h2>\r\n        <p>The founding forefathers of the United States didn&rsquo;t trust human nature much, so they broke up the power of the government into three major pieces, none of which could do much without the other two.</p>\r\n        <p>&nbsp;</p>\r\n        <a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n        <span class=\"anchorHidden\" id=\"_Toc459927140\"></span>\r\n        <h3>THE EXECUTIVE BRANCH</h3>\r\n        <p>The President is the Executive Branch.&nbsp; This branch is designed to lead the way and make quick decisions.&nbsp;</p>\r\n        <p>\r\n          <ul>\r\n            <li>He does not have the power to create laws, but rather can veto or pass laws that Congress creates.&nbsp;</li>\r\n            <li>He can negotiate treaties with foreign countries, but these have to be approved by the Senate.</li>\r\n            <li>He can appoint people to positions in Federal posts such as Federal Judges, but these appointments have to be approved by the Senate.&nbsp; The President can appoint lower level positions without having to go through this process. Sometimes the dividing line between &ldquo;lower level&rdquo; and &ldquo;upper level&rdquo; can be a bit grey and disputes occur.</li>\r\n            <li>He can grant pardons (forgiving people of crimes) (this is to overturn convictions that he feels the Judicial Branch judged poorly)</li>\r\n            <li>He is the Commander in Chief of the armed forces.&nbsp; This means, he can control what the armed forces do (ex, attack a foreign power or rescue civilians in a natural disaster) but he can&rsquo;t declare war or pay for the troops to do anything for any extended period of time.&nbsp; Only Congress can declare war and pay for it.</li>\r\n            <li>The President&rsquo;s office proposes an annual budget and requests for Congress to pay for it, but the House and Senate use this as a leap off point to build whatever they want.</li>\r\n            <li>He can also make Executive Orders.&nbsp; These can take several shapes.</li>\r\n            <ul>\r\n              <li>He can make rules about how the government agencies operate &ndash; for example, he can&rsquo;t make civil rights laws, but he can make rules that give fair treatment to minorities who need government housing.</li>\r\n              <li>He can do things that Congress gives him prior permission to do.&nbsp; For example, if we are on the brink of war, Congress can preapprove the declaration of war and the funding to pay for troops in case it comes to that and he needs those things in a rush.</li>\r\n              <li>He can do things that Congress doesn&rsquo;t stop him from doing.&nbsp; But even if Congress doesn&rsquo;t do anything to stop him, the Supreme Court can find it unconstitutional and rescind the Executive Order.</li>\r\n            </ul>\r\n          </ul>\r\n        </p>\r\n        <p>&nbsp;</p>\r\n        <a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n        <span class=\"anchorHidden\" id=\"_Toc459927141\"></span>\r\n        <h3>THE LEGISLATIVE BRANCH</h3>\r\n        <p>The Legislative Branch makes laws, approves spending, and levies taxes to pay for it all.&nbsp; The Legislative Branch (Congress) is made up of two separate organizations, the Senate and the House of Representatives.&nbsp; The two separate houses are designed to balance the needs of the majority and the needs of the minority.&nbsp; In the House of Representatives, each state gets more or less power depending upon how many people live in that state.&nbsp; So for example, California has 53 politicians representing it while Rhode Island only has 2.&nbsp; In the Senate, each state has 2 and only 2 representatives no matter how big or small the state is.&nbsp; In order for laws to be created and budgets to be passed, they have to be approved by both the House of Representatives and Senate.&nbsp; This means that the majority and minority have to work things out to accomplish what is best for both.&nbsp;</p>\r\n        <p>So for example, right now, only about 2% of Americans are farmers.&nbsp; These farmers are mostly in states that aren&rsquo;t very populated.&nbsp; Industry and finance tend to be concentrated in just a few states with higher populations.&nbsp; So in the House of Representatives, the farmers would struggle to get anything they need but would have a lot more power in the Senate, while industry and finance would have a lot of power in the House of Representatives, but less in the Senate.&nbsp; The two negotiate to do what&rsquo;s best for America so we don&rsquo;t pave over farms and starve to death or go bankrupt rerouting every river in America to farmlands.&nbsp; Knowing what battles they will have to put up with, the House and Senate generally don&rsquo;t approve laws they don&rsquo;t think the other will agree with.&nbsp; (Unless of course it&rsquo;s just for show, which is unfortunately a thing.)</p>\r\n        <p>Members of the House of Representatives stay in office for two years.&nbsp; This encourages new blood and fresh ideas, but also means that every other year is an election year, and the politician has to spend time trying to get re-elected.&nbsp; It also means, that for incoming new politicians, they spend half their term trying to learn how to do the job, and the other half of their term trying to keep their job.</p>\r\n        <p>Members of the Senate stay in office for six years, but their terms are staggered every two years, so you never replace the whole lot of them in a single election.&nbsp; This ensures that there is consistency in legislation so that the country doesn&rsquo;t swing wildly and unpredictably.&nbsp; But it also makes change harder to accomplish.</p>\r\n        <p>Just as the two houses balance each other out in interest of the states versus interests of the populace, their mix of brevity and longevity of office also balance out.</p>\r\n        <p>The Senate has a hundred members and the House of Representatives has over 400.&nbsp; This makes discussion and negotiation difficult.&nbsp;&nbsp; In order to accomplish things, congressmen often form comities of just a few politicians to study a particular issue, work out the best way of doing things, and then advise the rest of Congress on how to vote.&nbsp;</p>\r\n        <p>&nbsp;</p>\r\n        <a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n        <span class=\"anchorHidden\" id=\"_Toc459927142\"></span>\r\n        <h3>JUDICIAL BRANCH</h3>\r\n        <p>The Judicial Branch keeps the Congress and the President in check by making sure that they don&rsquo;t do anything that comes into conflict with the constitution.&nbsp; Here&rsquo;s how it works:&nbsp; On occasion, the President or Congress will pass a law or an executive order that comes into conflict with the constitution.&nbsp; The people who get hurt by this law can sue the government.&nbsp; If you aren&rsquo;t hurt by the law, then you can&rsquo;t sue.&nbsp; So if you are a politician or an interest group that just hates a law, they have to search for someone who was significantly hurt by this law.&nbsp; Sometimes, a law doesn&rsquo;t get looked at until years after it is passed because it takes a long time for the damage to occur.&nbsp; The Supreme Court can decide to take or not take the case.&nbsp; If they take the case, they look at the arguments and decide whether or not the law comes into conflict with the constitution.&nbsp; Most cases are not clear black and white.&nbsp; When the Supreme Court makes a ruling, the justices each write opinions on why they thought the law was or was not constitutional.&nbsp; These rulings and the opinions that describe the reasoning behind the rulings are used by other judges and lawmakers to figure out how the law should be interpreted and how future laws should be written.</p>\r\n        <p>State Supreme Courts do that same thing except they concentrate on State Constitutions as opposed to the American Constitution.</p>\r\n        <p>There are 9 Federal Supreme Court justices.&nbsp; The President nominates them and the Senate approves them or rejects them.&nbsp; These are lifetime appointments, so they don&rsquo;t leave office until they either retire or die.</p>\r\n        <p>&nbsp;</p>\r\n        <a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n        <span class=\"anchorHidden\" id=\"_Toc459927143\"></span>\r\n        <h1>PRIMARIES</h1>\r\n        <p>When there are too many people running for the same office, it often makes sense to do two votes.&nbsp; The first vote (The Primary Election) gets rid of the candidates you definitely don&rsquo;t want so you can take a closer look at the remaining ones.&nbsp; Months later, you have a second vote (The General Election), to pick the best candidate from the remaining crowd.</p>\r\n        <p>Why is this necessary?&nbsp; Why don&rsquo;t we have all the voting on one day and be done with it? Well, if you have too many similar people running for office, they will split the vote and none of them will win a majority.&nbsp; Let&rsquo;s pretend for example that you live in a district where 85% of the voters are Republicans.&nbsp; Without primaries, you might have eleven Republicans and one Communist running for office.&nbsp; Each Republican might win 8% of the vote while the Communist wins the election with only 12% of the votes.&nbsp; This would not be a good way of representing that district.</p>\r\n        <p>&nbsp;</p>\r\n        <a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n        <span class=\"anchorHidden\" id=\"_Toc459927144\"></span>\r\n        <h3>CLOSED PRIMARY VS OPEN PRIMARY ELECTIONS</h3>\r\n        <p>In a <b>Closed Primary</b>, voters are separated by party and they are only allowed to vote for candidates in their own party.&nbsp; The winner of that party&rsquo;s election then goes on to the General election to compete against the winners from all the other parties.&nbsp; One disadvantage of this system is that the best person to bridge the gap between the parties probably wouldn&rsquo;t win their party&rsquo;s primary.&nbsp; You end up with one candidate who is a diehard Democrat, another who is a diehard Republican, another who is a diehard Socialist or whatever.&nbsp; This makes it difficult for voters to find someone they ALL like.</p>\r\n        <p>In an <b>Open Primary</b>, voters can vote for anyone they want, regardless of political party.&nbsp; Usually, the top two candidates go on to the General Election.&nbsp; One advantage of this is that someone who is able to bridge the gaps between the parties stands a better chance.&nbsp; One disadvantage is that you could be repeating the same problem as no primary at all where you split the vote and the people who win are the candidates who few voters actually wanted.&nbsp;</p>\r\n        <p>Third party candidates do better with the Open Primary system.</p>\r\n        <p> The Closed Primary is the most common type of primary.</p>\r\n        <a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n        <span class=\"anchorHidden\" id=\"_Toc459927145\"></span>\r\n        <h3>CAUCUS</h3>\r\n        <p>A caucus is very similar to a primary, except instead of going to a voting booth, you go to a hall where you discuss the candidates with each other before voting.&nbsp; This requires that everyone in a community get together all at the same time.&nbsp; It takes about two hours and the actual voting is usually out in the open.&nbsp; A couple advantages of a caucus are that it encourages discussion of the candidates and you can usually see that your vote is being counted.&nbsp; A couple disadvantages are that it is rare that all voters are available at the same exact time, so some voices can&rsquo;t be heard and some voters prefer to vote in secret and that is sometimes not possible.&nbsp; Caucuses can be either open or closed.</p>\r\n        <p>&nbsp;</p>\r\n        <a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n        <p>\r\n            <span class=\"anchorHidden\" id=\"_Toc4599271462\"></span>\r\n          <h3>RUN OFF ELECTION</h3></p>\r\n        <p>Even with primaries, you still have the chance that the candidate that wins the most votes is a candidate that almost no one wanted. For example, you could have a candidate who is a liked by 25% of the population but everyone else hates him. Maybe they hate him so much that dozens of people run for office to defeat him. Because there are so many other qualified candidates, they each get only 10 percent. Maybe a couple of them get 24%, but that doesn’t win out over his 25%. So even though 75% of the population really don’t want him, he is elected. </p>\r\n        <p>To combat this, some places have “run off elections” where if no candidate gets 50% or more of the vote, they hold another election where the only two candidates are the ones that got the most votes – in this case the person few people like, and a guy who is very similar to a lot of his contenders. In this situation, the guy everyone hates is likely to lose by a landslide, but you never know because it’s hard to bring people out to vote once, never mind twice in a month. And running an election isn’t cheap so this causes other problems.</p>\r\n        <p>\r\n          <h3>INSTANT RUN OFF ELECTION</h3></p>\r\n        <p>In an instant run off, you rank the people running for office. Let’s pretend out of the 12 people running, you like 3 of them:</p>\r\n        <ul>\r\n          <li>\r\n            <p>Albert</p>\r\n          </li>\r\n          <li>\r\n            <p>Ramone</p>\r\n          </li>\r\n          <li>\r\n            <p>Christine</p>\r\n          </li>\r\n        </ul>\r\n        <p>And you rank them in that order. When the election officials go to count the votes, they look at who is on the top of everyone’s list. In your case, it’s Albert. They total up all the votes and if no one got more than half the votes, then they get rid of the candidate that got the least votes and look at the ballots again. So, let’s pretend that Albert got only 2% of the votes and they removed him from the running. They would look at your ballot and skip past Albert, (since he wasn’t popular enough ) and rather than throw your ballot away, they see that Ramone, your second choice, is still in the running, so they count your ballot as if you cast it for Ramone. </p>\r\n        <p>They total them again. </p>\r\n        <p>Once again, they take out whoever was the lowest scoring. Let’s pretend, it’s Franklin. Since Franklin wasn’t one of your choices, your ballot doesn’t change at all but other people’s ballots do. They keep recounting the ballots and kicking off the lowest scorers until they have someone who gets more than half the votes. This person will likely be first on some people’s list and third or fourth on other people’s list, but they are not the person that everyone hates.</p>\r\n        <p>Instant run offs can be used to pick candidates in Primaries, in General elections, or can be used to combine the two into one day of voting.</p>\r\n        <a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n<br>\r\n        <span class=\"anchorHidden\" id=\"_Toc4599271461\"></span>\r\n        <h3>CUMULATIVE VOTING</h3></p>\r\n        <p>While we are talking about different voting systems, we shoud talk about a couple different ways that people get elected to office when there is more than one seat to fill - for example School Board or City Council.  In most places, if there are 4 seats open, the voter picks 4 candidates from the list and votes for those 4 people.  But with cumulative voting, if there are 4 seats open, the voter can use all 4 of those votes on one person.  So why would this be a thing?  If you have a region with two parties, Party A in the majority and Party B in the minority. If party A proposes four candidates for those 4 positions, then the fact that they are a majority will likely mean that no one from Party B will ever get elected onto the committee and that part of the population will never be represented in government decisions.  However, with Cumulative Voting, Party B could propose one candidate and then get all their voters to use all of their votes on that one candidate, then, so long as Party B makes up at least a quarter of the voters, they are likely to get one seat at the table.</p>\r\n<a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a><br>\r\n        <span class=\"anchorHidden\" id=\"_Toc459927146\"></span>\r\n        <h3>WHO RUNS THE PRIMARIES AND CAUCUSES?</h3>\r\n        <p>It&rsquo;s important to remember that Political Parties are not actually government structures.&nbsp; Political parties are actually private organizations run by people who want to get their agenda passed in the government.&nbsp; In &ldquo;ye olden days&rdquo;, the public would have next to no say whatsoever in who the parties chose as their candidates.&nbsp; We would only have a real say in the general election.&nbsp; We would hold primary elections, but the results of these elections were considered suggestions to the party bosses.&nbsp; There was a lot of corruption so the states started paying for and regulating primary elections.&nbsp; But, to this day, each of the different parties make-up most of the rules for how the primaries are run and these rules are different in every state.</p>\r\n        <p>&nbsp;</p>\r\n        <a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n        <span class=\"anchorHidden\" id=\"_Toc459927147\"></span>\r\n        <h3>DELEGATES, CONVENTIONS AND THE ELECTORAL COLLEGE</h3>\r\n        <p>Back in the old days before rapid transit, computers and telephones, local communities would send representatives to big meetings where representatives from all over would discuss who would represent the whole region.&nbsp; This often took time because they might start off with a bunch of candidates and they would have to go through many votes and a lot of negotiation to come up with a final person.&nbsp; These local representatives were called Delegates and the meetings were called Conventions.&nbsp; This system is still used for our Presidents and it happens in two tiers &ndash; the Conventions, where the various political parties pick their candidates and the Electoral College, which is the final general election where they decide who wins the Presidency.&nbsp; The Electoral College is only used for Presidential elections.&nbsp; It is not used for any other office.</p>\r\n        <p>So how does this work?</p>\r\n        <p>Each political party decides how to choose their party&rsquo;s candidate.&nbsp; The political parties are made up of federal, state, and county organizations. They each have their input on how these decisions are made &ndash; so it varies from state to state.&nbsp; The number of delegates that each state has compared to other states is determined by various formulas that the parties come up with.&nbsp; These formulas take into consideration not just the population of that state, but also how well the winners of that state have done in the general election and other information.&nbsp; So if for example, you lived in a state that always voted for candidates that lost the general election, your party would choose to give your state less of a voice in choosing who to propose as that party&rsquo;s candidate for President.</p>\r\n        <p>The delegates themselves are chosen by the party.&nbsp; In the days before direct primaries, the voters didn&rsquo;t have much say in who the party chose.&nbsp; Back then, the public&rsquo;s vote in the primaries would be considered a &ldquo;suggestion&rdquo;, but the powers that be would do whatever they wanted.&nbsp; This lead to some serious corruption and the public wasn&rsquo;t too happy about this. So they started having primaries where the voters would choose what candidate they wanted and the delegate would promise to vote for that candidate on at least the first ballot&nbsp; - Remember, if you have a bunch of candidates, there might not be a clear winner after the first ballot, so they would have to negotiate with the other delegates and do many more votes until there was a clear winner.&nbsp; This made the voters happy, but the party leaders noticed that the public were choosing candidates that didn&rsquo;t necessarily do well in the general election.&nbsp; The voters would choose someone they loved, but this person wouldn&rsquo;t bridge the gap between the two parties and would lose to more centrist candidates. Frustrated with their losses, the political party heads decided to take a step back into the old way of doing things.&nbsp; They wanted to influence who was chosen so they could improve the chances of their party&rsquo;s candidate winning the Presidency.&nbsp; To do this, they created &ldquo;Super Delegates&rdquo; who are chosen by the party not the voters.&nbsp; Super Delegates have the same voting power as a regular delegate, but they can theoretically vote for whoever they want.&nbsp;</p>\r\n        <p>&nbsp;</p>\r\n        <a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n        <span class=\"anchorHidden\" id=\"_Toc459927148\"></span>\r\n        <h3>SO WHAT IS THE ELECTORAL COLLEGE AND HOW DOES IT WORK?&nbsp;</h3>\r\n        <p><strong>&nbsp;</strong></p>\r\n        <p>The Electoral College was set up in the Constitution and is only for the final vote for President of the United States.&nbsp; It is not for state or local elections.&nbsp; Here&rsquo;s how it works &ndash; each state gets a number of delegates in a similar design of the House of Representatives and the Senate &ndash; Each state gets 2 for being a state plus more depending upon how many people live in that state.&nbsp; In the Constitution, the states can choose to split those delegates up however they want.&nbsp; For example, they can choose to have each delegate represent a different region, or they can combine all the delegates into one large voting block so that the winner of more than half the state&rsquo;s votes gets all the delegates in the whole state.&nbsp; Most of the states have chosen to do this &ldquo;winner take all&rdquo; approach.</p>\r\n        <p>The advantage of one large voting block is the power of numbers.&nbsp;&nbsp; If a candidate can get more than 50% of the voters in that state, they also win a bunch of votes that they never would have gotten in a million years.&nbsp; So politicians who think they have a chance, will spend more time in that state making promises to make that state happy.&nbsp; The state essentially gets to negotiate for what it wants.&nbsp; The disadvantages include:&nbsp; districts who voted for the losing candidate don&rsquo;t get their voices heard, and if the candidate doesn&rsquo;t think they will win more than 50% of the state, they skip by it entirely and end up not listening to the state&rsquo;s issues at all.&nbsp; Likewise, if a candidate thinks there&rsquo;s no way he&rsquo;ll lose the state, he could skip it also to focus on areas where he can win votes that aren&rsquo;t already guaranteed.</p>\r\n        <p>The most popular alternative to the winner-take-all method is the Congressional District Method.&nbsp; This is where the 2 Electoral College representatives that they get for being a state reflect the will of the popular vote (like your 2 Senators represent your entire state) and each of the Congressional Districts get a vote.&nbsp; This is closer in some ways to the popular vote and further in some other ways.&nbsp; Because of gerrymandering (the way the Congressional Districts are drawn to keep people in power) it often doesn&rsquo;t represent the true will of the people.&nbsp; For example, in Pennsylvania, as of 2014, 50 % of the voters were registered as Democrat but only 28% of the district boundary lines are set up so that Democrats win elections.&nbsp; And 37% of the voters were registered as Republican, but the district lines were drawn up so that 72% of the districts are Republican. Chopping the Democratic voter&rsquo;s value in half, and doubling the Republican voter&rsquo;s value, you essentially make a Republican four times more valuable than a Democrat.</p>\r\n        <p>When the states send their delegate count to the federal government, they are all added together and the totals compared.&nbsp; If a candidate gets more than half the votes, they are declared the winner.&nbsp; If no one gets more than half, then the election gets tossed to Congress.&nbsp; The House of Representatives chooses the President and the Senate chooses the Vice President.&nbsp; A disadvantage of this system is that it encourages a two party system instead of hearing from candidates with a wide variety of views.&nbsp; When a race is close, as it almost always is, voting for a third party candidate&nbsp; - even if they only win 2% of the votes &ndash; could cause people&rsquo;s second choice to lose in favor of candidates that they truly hate.&nbsp; So instead of voting for candidates people want, people tend to choose, &ldquo;the lesser of two evils.&rdquo;&nbsp; A simple fix to this would be to allow candidates to give their votes to other candidates so that you could vote for the candidates you want and then they would negotiate with the other candidates to find a compromise.&nbsp; But that would require a constitutional amendment, which is incredibly difficult to do.</p>\r\n        <p>The biggest complaint people have about the Electoral College is that it makes it possible for someone to win the popular vote, but lose the Presidency.&nbsp; This could happen in several ways:&nbsp; 1- In the winner-take-all method of states allocating all their Electoral College votes to the most popular candidate in their state, you can have a bunch of states where a popular candidate loses 49 to 51, while in other states he wins by a landslide.&nbsp; But if there were enough of those 49 to 51% states, he would lose.&nbsp; 2-Because each state has a set number of Electoral College votes based on the number of citizens, it doesn&rsquo;t matter how many of those voters actually show up to the poles. So whether every single eligible voter shows up, or only one guy, it doesn&rsquo;t affect the Electoral Vote count.&nbsp; 3- Because every state gets 2 electoral votes plus a number of votes based on population, small states with lower population get more votes per person than more populated states.</p>\r\n        <p>&nbsp;</p>\r\n        <p><strong>RECOMMENDED VIDEO ON ELECTORAL COLLEGE</strong><strong>:</strong></p>\r\n        <p><strong><a target=\"_blank\" class=\"link\" href=\"https://www.youtube.com/watch?v=W9H3gvnN468%20\">https://www.youtube.com/watch?v=W9H3gvnN468</a> </strong></p>\r\n        <p><strong>&nbsp;</strong></p>\r\n        <p><strong>RECOMMENDED VIDEO ON GERRYMANDERING</strong><strong>:</strong></p>\r\n        <p><strong><a target=\"_blank\" class=\"link\" href=\"https://www.youtube.com/watch?v=YcUDBgYodIE%20\">https://www.youtube.com/watch?v=YcUDBgYodIE</a> </strong></p>\r\n        <p>&nbsp;</p>\r\n        <p><strong>RECOMMENDED READING ON ELECTORAL COLLEGE:</strong></p>\r\n        <p><strong><a target=\"_blank\" class=\"link\"  href=\"http://www.diffen.com/difference/Electoral_Vote_vs_Popular_Vote\">http://www.diffen.com/difference/Electoral_Vote_vs_Popular_Vote</a></strong></p>\r\n        <p><strong>&nbsp;</strong></p>\r\n        <a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n        <span class=\"anchorHidden\" id=\"_Toc459927149\"></span>\r\n        <h1>THE POLITICAL PARTIES</h1>\r\n        <p>Contrary to popular belief, the political parties are not tax payer funded government structures.&nbsp; Political parties are actually private organizations set up by people who want to get their agenda passed in the government.&nbsp; The organization finds candidates and voters who feel the same way they do to make these changes possible.&nbsp; In America, the political parties set agendas, help fund and organize campaigns and create rules for how their candidates will be chosen in primaries.</p>\r\n        <p>The two biggest American parties, Democrat and Republican have relatively loose agendas and a local party might have different ideas than the national party.&nbsp; So someone who might consider themselves a Democrat in one state might be considered a Republican in another state.&nbsp; In fact, these two parties have so many issues, that it is very common for someone to agree with some ideas from one party and other ideas from another party.&nbsp; In order to get a party&rsquo;s endorsement, however, candidates usually have to be a bit quiet about the things they disagree with.</p>\r\n        <p>Political parties can be designed around any number of reasons.&nbsp; They usually have one main goal and many less important or flexible goals.</p>\r\n        <p>Two of the more popular ways of dividing up parties are by how the economy is run by how much government involvement there is.</p>\r\n        <p>&nbsp;</p>\r\n        <a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n        <span class=\"anchorHidden\" id=\"_Toc459927150\"></span>\r\n        <h2>TWO EXTREMES OF HOW TO RUN AN ECONOMY.</h2>\r\n        <p>At one end of the spectrum, we have Communism, and the other end of the spectrum, we have pure Capitalism.</p>\r\n        <p>&nbsp;</p>\r\n        <span class=\"anchorHidden\" id=\"_Toc459927151\"></span>\r\n        <h3>COMMUNISM</h3>\r\n        <p>Communism is based on the concept of &ldquo;Love Thy Neighbor.&rdquo;&nbsp; Everyone should do what they are capable of doing to help the greater good. Everyone should share everything they have.&nbsp; Consequently, everyone gets paid equally no matter how hard they work or how good at their job they are. This tends to work best in small communities where people know and care about each other and can see how their contributions help their friends. Additional pay for the harder workers comes in the form of appreciation and respect instead of money.&nbsp; Most families do this.&nbsp; If both parents are working, they pool their money to feed and clothe the children.&nbsp; The children earn nothing for their efforts in school.&nbsp;&nbsp;</p>\r\n        <p>When you get into larger communities, this becomes harder to sustain.&nbsp; People&rsquo;s spirits tend to get destroyed when they hear about someone they don&rsquo;t know or actively dislike being lazy and getting the same pay.&nbsp; It&rsquo;s also difficult to see the benefit of your hard work if it is going to build roads in some town you never heard of while you see things in your own community that need help. In these circumstances, many people tend to work with less vigor and ingenuity.&nbsp;</p>\r\n        <p>No pure communist system has ever been tried on a national level.&nbsp; Historically, countries that called themselves &ldquo;communist&rdquo; have paid more to people they deemed more valuable &ndash; politicians, Olympic athletes, scientists working on weapons... etc.&nbsp; Other communist countries have filtered in capitalism to help motivate people.</p>\r\n        <p>Karl Marx and Friedrich Engels wrote &ldquo;The Communist Manifesto&rdquo;, which borrowed ideas of Christian and other religious communal sharing, but claimed that religion got in the way of caring about the community.&nbsp; So many communist nations banned religion to be replaced with faith in the state.&nbsp; But just as there has never been a pure communist state, someone who claims to be a communist isn&rsquo;t necessarily an atheist.&nbsp; Marx&rsquo;s grandfather was the last of a long line of rabbi&rsquo;s, and Engels&rsquo; father was a Protestant minister.&nbsp; Engels had a strained relationship with his dad, so this combined with the popularity of atheism in intellectual circles at the time contributed to the anti-religious views of &ldquo;the Communist Manifesto.&rdquo;</p>\r\n        <p>&nbsp;</p>\r\n        <span class=\"anchorHidden\" id=\"_Toc459927152\"></span>\r\n        <h3>CAPITALISM</h3>\r\n        <p>Capitalism is based on the notion that hard work and ingenuity should be rewarded.&nbsp; And this hard work and ingenuity will be rewarded most in areas where they are needed most.&nbsp; If someone figures out a way to build a mousetrap that works better than one that already exists, then people will be happy to pay more for it.&nbsp; Improving society improves your bank account.&nbsp; This is a great motivator for many people.&nbsp; But in practice, it can also have a lot of problems.&nbsp;</p>\r\n        <p>People can artificially create a need and therefore waste.&nbsp; For example, in a purely capitalist system, I could dam a river up, let a few people down stream die of dehydration, and then charge $100/gallon for water.&nbsp; Earning tons of money off this endeavor, I can then go to the next town, buy land that is up-river and do the same thing again and again.&nbsp; Once someone has accumulated wealth, they have more power to gain more wealth and the cycle continues. &nbsp;Power begets more and more power. &nbsp;Doctors who save lives would earn less than those that threaten lives.</p>\r\n        <p>Another example, in more recent times, is mine towns.&nbsp; Someone buys up land and hires people to work the mine.&nbsp; Because the miners are in the middle of nowhere, and they are working ridiculously long hours, they can&rsquo;t go out and buy their food and clothes.&nbsp; So the mine owner creates a store to sell them everything they need &ndash; at enormously inflated prices. If the miner can&rsquo;t afford food, the mine company will lend them money.&nbsp; Workers, then, leave the mine decades later in more debt than when they started.&nbsp;</p>\r\n        <p>In a much more timid form of creating a need, a manufacturer might make false claims about the benefits of their product or create a scare so that people will think they need something when they actually don&rsquo;t.&nbsp;</p>\r\n        <p>Money and advertising change the equation.&nbsp; If you don&rsquo;t have the money to pay for advertising, then it&rsquo;s the better advertising campaign, not the better product that wins the day.&nbsp; Without money to invest in product development, the brilliant ideas can&rsquo;t even be built and brought to market.&nbsp; Once you have money to do the work for you, you are no longer on equal footing as someone who is hard working and ingenious.&nbsp; You have more power.&nbsp; The more power you get, the more money you get and the cycle continues until the brilliant hard worker has no chance to compete at all.</p>\r\n        <p>No purely capitalist system has been tried on a national level in recent times either.&nbsp; Governments set up anti-trust laws, anti-pollution, minimum wage and other laws and have police forces to ensure that some of these practices are prohibited.&nbsp;&nbsp;</p>\r\n        <p>Both capitalism and communism have their benefits.&nbsp; Both systems have their pitfalls.&nbsp; Because of this, all governments try to balance these ideas out.&nbsp; They try to ensure some degree of fairness while at the same time encouraging ingenuity and productivity.&nbsp; Depending upon your tastes, you may swing one way or another.&nbsp; And your opinion on which way to swing may need to change as the conditions of the country change and need one direction more than another.&nbsp; A great idea one year could be an ill-fitting idea a year later.&nbsp; Always keep an open mind.</p>\r\n        <p>&nbsp;</p>\r\n        <a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n        <span class=\"anchorHidden\" id=\"_Toc459927153\"></span>\r\n        <h2>TWO EXTREMES ON SIZE OF GOVERNMENT.</h2>\r\n        <p>Communism is at one extreme and Anarchism is at the other extreme. Now I must here say that the Anarchist party is extremely small, but it is useful for this tutorial to help explain the extremes. You should also be aware that the political philosophy of Anarchism is different from the adjactive &quot;anarchy.&quot; &quot;Anarchy&quot; is an adjective that is often used to describe complete disarray and disorganization. Anarchism, on the other hand, is the belief that we need no organiztion.</p>\r\n        <a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n        <span class=\"anchorHidden\" id=\"_Toc459927154\"></span>\r\n        <h3>COMMUNISM</h3>\r\n        <p>Communism is both an economic and political system, and it ends up as an extreme in both economic views and size of government.&nbsp; Communism has the largest of all government structures.&nbsp; It uses regulations and distribution networks to ensure that every single citizen is treated equally.&nbsp; Once again, we have to talk about it in theory versus in practice because it&rsquo;s never been tried in real life on a big scale.</p>\r\n        <p>In theory, communism looks at the needs of everyone in the country.&nbsp; It then creates industry, creates product, and creates culture to keep its citizenry happy without waste or suffering. The biggest problem with this thought process is that humans are individuals and we all have different needs.&nbsp; There is no way that a government can know what each of us needs, so there is no way that it could provide what we need.&nbsp; If you have ever tried going to the movies with your extended family, you know what a communist system faces.&nbsp; You can&rsquo;t make everyone happy, so you choose something that makes everyone not entirely annoyed instead.&nbsp; No one stands out in the cold, but no one gets to see a great movie either.</p>\r\n        <p>&nbsp;</p>\r\n        <a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n        <span class=\"anchorHidden\" id=\"_Toc459927155\"></span>\r\n        <h3>ANARCHISM</h3>\r\n        <p>Anarchists, on the other hand, rely on no government whatsoever.&nbsp; No police.&nbsp; No money. No anything.&nbsp; They believe that if you are acting in your own self-interest, doing whatever you want, that you will naturally work with other people when and only when it is in your best interest to do so.&nbsp; You will trade the goods you make for the goods you want.&nbsp; You will farm and share with others not because a government is telling you to do so, but rather because it is human nature to be good to each other.&nbsp; This perhaps is not a perfect summary of their philosophy, but since they don&rsquo;t believe in organization, it&rsquo;s sometimes hard to figure out exactly what they stand for.&nbsp; But at their core, they believe in no government.&nbsp; Now, if humans were entirely selfless, this system might work &ndash; but as prisons across the world have shown, this isn&rsquo;t the case.&nbsp; We are neither purely good, nor purely evil.&nbsp; We are complicated.&nbsp; When we have times of bounty, sharing is easy, but in times of famine, we have to decide who our friends are.</p>\r\n        <p>In times of famine, everyone in a communist system would get enough to eat.&nbsp; In an every-man-for himself system, some people would horde.&nbsp; While they were hording, their stockrooms would fill with rotting fruit they didn&rsquo;t have time to eat while others would starve to death.</p>\r\n        <p>Just like with the economy, the size of the government has to be balanced between the needs of the many and the needs of the individual.&nbsp; Governments are needed to do the things we can&rsquo;t as individuals &ndash; build highways, defend the borders, ensure that the food we eat is not loaded with toxins that will kill us&hellip; But every time you build a highway, you are running bulldozers through someone&rsquo;s property.&nbsp; And unfortunately, some level of pollution is a necessary fact for making many of the products we enjoy.&nbsp; So do we do without those products entirely?</p>\r\n        <p>Besides protecting the citizenry, government aid and regulation tend to stabilize things.&nbsp; Any large mass of people make change difficult.&nbsp; Things tend to lumber along.</p>\r\n        <p>The advantage of this is that it makes for a predictable stable economy where people can see and fill gaps with their businesses and earn predictable incomes.&nbsp; The disadvantage is that it makes extreme forms of innovation harder and it makes it harder on random gamblers seeking overnight fortunes.&nbsp; (but the business gamblers who are wildly successful are far outweighed by those who lose their shirts in unstable economies.)</p>\r\n        <p>The amount of waste created by big government vs small government can be argued.&nbsp; Any large organization, whether it is a government or a business experiences the same benefits and problems.&nbsp; A large organization can buy or build in bulk and that saves a lot of money.&nbsp; However buying in bulk sometimes means buying more than you need.&nbsp; This depends on how wise the people are doing the buying.&nbsp; But because everyone in the organization is desperate for the same dollars for their pet projects, if someone has clear waste, that a competitor for that cash can point out, then the person who wastes won&rsquo;t get the funds they ask for the next time money is handed out.&nbsp; Most of the &ldquo;waste&rdquo; that goes on in government programs is actually a values call &ndash; it is money that isn&rsquo;t benefitting the person calling it waste, so to them, it might be waste, but for the people who it is benefitting, it is desperately needed.&nbsp;</p>\r\n        <p>That being said, the funding structure of any large organization has what I would consider a built in waste in its distribution of funds within the organization.&nbsp; If a particular department does a great job, but doesn&rsquo;t spend their entire budget, some might think &ldquo;well, they obviously didn&rsquo;t NEED all the money they asked for.&nbsp; So next time they ask for money, we should only give them a percentage of what they ask for.&rdquo;&nbsp; Knowing that this is a problem, some department heads will spend a lot of money near the end of the economic period to make sure that every penny is spent.&nbsp; Without the proper planning to make the most effective choices, some of this money is not spent wisely.&nbsp; Likewise, knowing that their budget will be undercut, some departments will ask for more money than they need.&nbsp; In the meantime, other department heads will ask for exactly what they need and not a penny more, but the manager won&rsquo;t know this so they will undercut the program and the program won&rsquo;t have enough funds to do what it needs.&nbsp; Without enough funds to complete the project, this department will do their best with what they have, but this often means building something that isn&rsquo;t up to the job and then the rest of us have to deal with a product that is more trouble than its worth.&nbsp; It&rsquo;s like trying to live in a house with no roof.&nbsp;</p>\r\n        <p>Some businesses have tried giving bonuses to department heads who return more surplus, but this tends to cause department heads to undercut their own programs &ndash; especially if they are thinking short term and don&rsquo;t plan on being in that position for very long.&nbsp; But this budgeting problem is true of any organization that&rsquo;s large enough for people not to know the inner workings of all departments.&nbsp; It could be a problem is organizations as small or 50 or 100 people.</p>\r\n        <p>In order to figure out what is best for you personally, it becomes important to make a list of what you think every citizen should have, what you think YOU should have. This could be anything &ndash; the right to an education, the right to a fair income&hellip; Then try to figure out what is being accomplished with the randomness of the individual desires of the masses and what is being accomplished with the rules and structure of the government.&nbsp; When you compare your lists to the results, then you can decide for yourself which way the country should head.&nbsp; Remember, just like the economy, more or less government regulation and aid can be a great idea one year and not such a great idea the next.</p>\r\n        <a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n        <span class=\"anchorHidden\" id=\"_Toc459927156\"></span>\r\n        <h2>WILDLY OVERSIMPLIFIED DESCRIPTIONS OF COMMON PARTIES</h2>\r\n        <p>Now it&rsquo;s time to compare political parties that are based on a combination of economic interests and government involvement.</p>\r\n        <p>There are hundreds of political parties out there.&nbsp; Not all parties base their identities around either size of government or manipulation of the economy, but the more popular ones do.&nbsp; Here are a few that combine these two concepts.</p>\r\n        <p>&nbsp;</p>\r\n        <ul>\r\n          <li>Communist</li>\r\n          <li>Socialist</li>\r\n          <li>Democrat</li>\r\n          <li>Republican</li>\r\n          <li>Libertarian</li>\r\n          <li>Tea Party</li>\r\n        </ul>\r\n        <p>&nbsp;</p>\r\n        <p><strong>WARNING: </strong>Labels are a dangerous thing.&nbsp; They reduce complicated ideas into meaningless sound bites.&nbsp; They take people who have a wide spectrum of beliefs and pigeon hole them into artificial identities that put them at odds with those they personally agree with.&nbsp; You should never look at a label and think that truly represents a person.&nbsp; I am about to speak in very wide and general terms that really don&rsquo;t reflect reality, but just some aspects of the labels.</p>\r\n        <p>&nbsp;</p>\r\n        <p>Before I get into details, let me warn you that someone may claim to be a member of one party or another, but they may not agree with everything their party says and someone from an outside view may perceive them as being more similar to a different party.</p>\r\n        <a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n        <span class=\"anchorHidden\" id=\"_Toc459927157\"></span>\r\n        <h3>COMMUNIST</h3>\r\n        <p>&nbsp;The Communists believe that the people come first.&nbsp; In pure Communism, the state owns everything and distributes everything to whomever they feel needs it most.&nbsp; We already discussed the benefits and pitfalls of this.</p>\r\n        <p>&nbsp;</p>\r\n        <a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n        <span class=\"anchorHidden\" id=\"_Toc459927158\"></span>\r\n        <h3>SOCIALISTS</h3>\r\n        <p>The Socialists believe that no system that is necessary for the day to day health of its citizens should be in the hands of a capitalist who might take it away.&nbsp; Therefore, big businesses like railways, post offices, roadways, hospitals, and some farming elements should be state owned, but all smaller businesses should be run by individuals.&nbsp; They also believe that the weak and infirm should be cared for.&nbsp; There is heavy regulation on what businesses can and can&rsquo;t do.&nbsp; Many people would consider most European nations to be Socialist.&nbsp;&nbsp; Because people don&rsquo;t fear what may happen in their old age, or if they get sick, the citizenry tend to panic less.&nbsp; This also means that there is less ingenuity and their economy moves slower than a purely capitalist system.&nbsp; The names &ldquo;Communists&rdquo; and &ldquo;Socialists&rdquo; have developed a nasty flavor in America that I feel is undeserved.&nbsp; Without these parties working to organize labor, we would still have children working in factories and 80 hour work weeks.&nbsp; All parties have something legitimate to say and sometimes an extreme answer is the right one.&nbsp; But they also have a lot of bad ideas, so it&rsquo;s important to listen to the ideas of all parties to figure out what works for you.</p>\r\n        <p>&nbsp;</p>\r\n        <a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n        <span class=\"anchorHidden\" id=\"_Toc459927159\"></span>\r\n        <h3>DEMOCRAT</h3>\r\n        <p>The Democrats and Republicans are both considered centrists and are very similar to each other.&nbsp; The Democrats believe that the government should support people in need but, unlike the Socialists, they feel that big business should be owned by people not the government.&nbsp; These big businesses, however, should be heavily regulated by the government.&nbsp; They also feel that some regions need more help than others, so while Republicans favor local people solving local problems, Democrats favor higher levels of government helping and regulating local levels.</p>\r\n        <p>&nbsp;</p>\r\n        <a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n        <span class=\"anchorHidden\" id=\"_Toc459927160\"></span>\r\n        <h3>REPUBLICANS</h3>\r\n        <p>The Republicans believe that people are more competent than the government to decide what is right and wrong, so they are in favor of fewer rules and regulations.&nbsp; They have faith that if one business is suppressing the citizenry, then another business will pop up to compete with them and be less oppressive.&nbsp;&nbsp; But they also don&rsquo;t want the extremes of people starving in the streets, so they support some level of aid and regulation.&nbsp;</p>\r\n        <p>&nbsp;</p>\r\n        <p>The term, &ldquo;Republican&rdquo; harkens back to the concept of the United States being a group of states &ndash; a republic.&nbsp; The Democrats want the power centralized in Washington, while the Republicans feel that the states should stand on their own as much as possible and be helped out only when necessary.&nbsp; The Republican idea is the more local you are, the more familiar you are with your own individual problems.&nbsp; The Democrat idea is that if there is a poor community in need or a people who are oppressed and defenseless, they may not have the resources to help themselves, so the rest of the nation should lend a hand.&nbsp; Government can be both a blessing and a curse.&nbsp; If you have a problem that needs fixing, and the person fixing it doesn&rsquo;t know what they are doing, they may do more harm than good.&nbsp; For example, let&rsquo;s say you have some kids who aren&rsquo;t doing as well as others in school. They are failing classes and falling through the cracks.&nbsp;&nbsp; Someone who doesn&rsquo;t understand the problem may lay down a rule that says all kids have to pass the class or the schools will get no money. &nbsp;Problem solved, right?&nbsp; Nope.&nbsp; Without the ability to meet the specific needs of the children who are failing, the schools has to lower the standards so it&rsquo;s easier to pass. All the other students, then, learn less and we have a new generation of uneducated Americans.&nbsp; But politicians can make the right choices too.&nbsp; And sometimes even imperfect help is better than none at all.&nbsp; For example, when Katrina hit, there were many mistakes made while trying to help the newly homeless people, but if no help was sent, hundreds if not thousands more would have died.</p>\r\n        <p>&nbsp;</p>\r\n        <a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n        <span class=\"anchorHidden\" id=\"_Toc459927161\"></span>\r\n        <h3>LIBERTARIAN</h3>\r\n        <p>This party believes that we need to drastically reduce the government&rsquo;s role in our daily lives.&nbsp; They see the benefit of the police and a reduced military but other regulatory commissions are seen as hindering the economy.&nbsp; For example the Environmental Protection Agency is supposed to protect the air we breathe and the water we drink.&nbsp; In order to meet the safety requirements, companies must spend a lot of money to reduce the amount of pollution they create or pay heavy fines.&nbsp; Additionally, sometimes these regulations change, so companies have to wait for the new regulations before starting to build their factories or risk having to make expensive retrofits.&nbsp; They have to pass these costs on to the consumers, potentially making it too expensive to buy.&nbsp; Libertarians believe in individual freedom of the people &ndash; and making no laws to prevent people from being who they are.&nbsp; So this often has them allied with the Democratic party on a lot of civil rights issues.&nbsp; The United States has been around for over 200 years, and we started making new rules from day one.&nbsp; Oftentimes, these new rules are patches for older rules.&nbsp; So, many of our laws are a patch on a patch on a patch.&nbsp; This means that there are a lot of laws that really should be gotten rid of and rethought from square one.</p>\r\n        <p>&nbsp;</p>\r\n        <a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n        <span class=\"anchorHidden\" id=\"_Toc459927162\"></span>\r\n        <h3>THE TEA PARTY</h3>\r\n        <p>This party hasn&rsquo;t been around long enough to create a consistent message.&nbsp; Most of the members of this party are disgruntled with the government and just want it to be smaller.&nbsp; They want to go back to &ldquo;the Principals of the Founding Fathers&rdquo;.&nbsp; But there is little agreement on what these principals are.&nbsp; Some will state with certainty that the Founding Fathers wanted one thing while others will state that they wanted something else. Most will acknowledge that the world has changed in the last two centuries so we can&rsquo;t strip the government back to 1776 sizes, but they feel we should head in that general direction.&nbsp; As the frustration with the federal government and the faltering economy grows, so grows the number of people who claim to be a member of the Tea Party.&nbsp; But because these people include a really wide variety of views, it&rsquo;s hard to get these people behind a candidate unless the candidate is so vague that it is impossible to know what they really plan on doing.</p>\r\n        <p>&nbsp;</p>\r\n        <a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n        <span class=\"anchorHidden\" id=\"_Toc459927164\"></span>\r\n        <h1>LIBERAL VS CONSERVATIVE.</h1>\r\n        <p>A Conservative believes that the best way to do something is the time tested &ldquo;tried and true&rdquo; way of doing it.&nbsp; They believe we just need a few tweaks or get more dedication to the cause to make it work better.&nbsp;</p>\r\n        <p>A Liberal believes that the old ways don&rsquo;t work, so we have to try something new.&nbsp; They believe the world has never worked perfectly so why repeat our mistakes?</p>\r\n        <p>A view that was once considered liberal can be seen years later as conservative.</p>\r\n        <p>Taken to extremes, the concept of conservatism would have us still living in caves because the thought of building a house and weaving clothes were risky concepts, and the concept of liberalism would have us redesigning the roof in the middle of a hurricane.&nbsp; Both extremes are really bad, but both are good in moderation.</p>\r\n        <p>By definition, conservatism is about not taking risks and trying anything new, while liberalism is about accepting all ideas and trying everything new.&nbsp; In the world of politics, this can make decision making take a short time with conservatives and a long time with liberals.&nbsp; A liberal will weigh all the options and listen to every single idea no matter how ridiculous while a conservative will make a decision right away, even if it&rsquo;s a bad one &ndash; &ldquo;just do what we did before.&rdquo;</p>\r\n        <p>In the political world, both sides believe the other is oppressive:&nbsp;</p>\r\n        <p>The Conservative believes that the Liberals are oppressive because they are asking for new rules. The reason they ask for new rules is because it&rsquo;s easier to add laws than get rid of old ones, so this is much more common.&nbsp; While the new law is intended to fix a problem, it may hurt someone else.&nbsp; That&rsquo;s just the way things go.&nbsp;&nbsp; If you make something illegal, the people who used to benefit from that activity get upset.&nbsp; You can turn a liberal into a conservative by making their favorite activity illegal.&nbsp; Upset with the change, they demand a return to the past.</p>\r\n        <p>The Liberal believes that Conservatives are oppressive because they weigh them down with old-fashioned tunnel vision laws that prevent people from being free and healthy.&nbsp; They see it like forcing people to walk barefoot on a broken pathway with potholes and broken glass while soft grass is just two steps away.</p>\r\n        <p>So, the terms &ldquo;Liberal&rdquo; and &ldquo;Conservative&rdquo; can be used to talk about approaches to any issue, but over time politicians have twisted the meanings to suit their goals and confuse the public.&nbsp; The terms have been used incorrectly and as insults.</p>\r\n        <p>Currently, &ldquo;Liberal&rdquo; has the connotation of big government and &ldquo;Conservative&rdquo; has the connotation of big business.&nbsp; So, now, people who are interested in making a change are calling themselves &ldquo;Progressive.&rdquo;</p>\r\n        <p>Currently, there are a lot of Liberals who try to encourage individual rights and protections against the forces of government and industry &ndash; using lawyers and government to encourage these protections.&nbsp; For example, a lot of Liberals would be against the &ldquo;US Patriot Act&rdquo; because they see it as a violation of the 4<sup>th</sup>, 5<sup>th</sup>, 6<sup>th</sup> and 7<sup>th</sup> amendments.&nbsp; (These ammendments prevent search and seizure without probable cause, imprisonment and deportation without trial by jury.)&nbsp; But the benefit of the law is that it could potentially catch terrorists before they commit a crime.&nbsp; So now, even though the thought of preserving the protections ensured by the Constitution have been around for centuries, they are considered Liberal because in recent history the tried and true way of doing things was to imprison and torture people who you suspected might or might not have done something wrong.&nbsp; So then Liberals are seen as those who let the guilty go free while Conservatives are seen as those who would punish the innocent.</p>\r\n        <p>The terms &ldquo;Conservative&rdquo; and &ldquo;Liberal&rdquo; have become intertwined with &ldquo;Republican&rdquo; and &ldquo;Democrat&rdquo; in unfortunate and misleading ways.&nbsp; Instead of meaning &ldquo;using tested methods&rdquo; and &ldquo;trying something new&rdquo;, &ldquo;Conservative&rdquo; and &ldquo;Liberal&rdquo; have become associated with viewpoints that are neither new nor tested.&nbsp;</p>\r\n        <p>Be warned, here&rsquo;s where you hear not just the positive things, but the negative things associate with these labels.&nbsp; This is intended to show you not just how these people see themselves, but how their opposition sees them:</p>\r\n        <p>As of 2016, &ldquo;Conservative&rdquo; has been associated with reducing government oversight of businesses to the point of allowing pollution that harms people, giving businesses money directly or indirectly, using the military to support business interests, sending jobs overseas, turning some Christian values into laws while ignoring other Christian values, anti-LGBT, anti-minority, anti-abortion, support of gun rights, lowering the taxes particularly for the rich, stronger military, stronger police force, rules that hinder personal freedoms and privacy with a concept that a show of force increases safety and you don&rsquo;t have anything to hide if you&rsquo;re not doing anything wrong. Their public relations campaigns tend to focus on patriotism, Christianity, and returning to a vague imagined time when everything was perfect.</p>\r\n        <p>In the same year &ldquo;Liberal&rdquo; has been associated with increasing government oversight of businesses to the point of potentially strangling ingenuity, increasing taxes and fines on businesses to the point of potentially sending entire businesses overseas, &nbsp;supporting worker&rsquo;s rights, supporting the poor and those in need and (in some eyes) giving money to lazy people who don&rsquo;t deserve it creating a cycle of dependence and idleness, supporting all religious views to the point of not talking about religion and therefore seeming Godless, reducing the size of the military potentially weakening it,&nbsp; defending personal freedoms to the point of defending people that they find quite objectionable, and defending privacy to the point of reducing the safety of others.&nbsp; Their public relations campaigns tend to focus on ending government hand-outs to large corporations and using the saving to help people get the help they need.</p>\r\n        <p>&nbsp;</p>\r\n        <a href=\"\" ng-click=\"$root.gotoAnchor(\'top\')\" class=\"back\">Back to top</a>\r\n        <span class=\"anchorHidden\" id=\"_Toc459927165\"></span>\r\n        <h1>FINAL WARNING</h1>\r\n        <p>Once again, you need to remember that labels are counter-productive in most situations.&nbsp; They reduce complicated ideas into meaningless sound bites.&nbsp; They take people who have a wide spectrum of beliefs and pigeon hole them into artificial identities that put them at odds with those they personally agree with.&nbsp; The above essay should not make you think that because someone has a label on them, they believe certain things.&nbsp; Look deeper.</p>\r\n        <p>&nbsp;</p>\r\n        <p>&nbsp;</p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n");
$templateCache.put("app/learnHome/BoardsOfElections.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">BOARDS OF ELECTIONS</h2>\r\n  <p class=\"pageSubHeading\">Choose your state and click its link.</p>\r\n\r\n\r\n    \r\n<p>   WHERE DO I VOTE/What’s my voter district?\r\nAlabama\r\nhttps://myinfo.alabamavotes.gov/VoterView/RegistrantSearch.do\r\nAlaska\r\nhttps://www.elections.alaska.gov/vi_w_polls.php\r\nArizona\r\nhttps://voter.azsos.gov/VoterView/RegistrantSearch.do\r\nArkansas\r\nhttps://www.voterview.ar-nova.org/VoterView/RegistrantSearch.do\r\nCalifornia\r\nhttp://www.rockthevote.com/get-informed/elections/state/california.html?referrer=https://www.google.com/\r\nColorado\r\nhttp://www.sos.state.co.us/pubs/elections/vote/VoterHome.html\r\nConnecticut\r\nhttp://www.ct.gov/sots/cwp/view.asp?a=3172&q=512796\r\nDelaware\r\nhttps://ivote.de.gov/default.aspx\r\nDistrict of COlumbia\r\nhttps://www.dcboee.org/voter_info/reg_status/\r\nFlorida\r\nhttp://registration.elections.myflorida.com/CheckVoterStatus\r\nGeorgia \r\nhttps://www.mvp.sos.ga.gov/MVP/mvp.do\r\nHawaii\r\nhttp://elections.hawaii.gov/\r\nIdaho\r\nhttp://www.idahovotes.gov/YPP_NEW/AmIRegistered.aspx\r\nIllinois\r\nhttps://ova.elections.il.gov/RegistrationLookup.aspx\r\nIndiana\r\nhttps://indianavoters.in.gov/PublicSite/Public/FT1/PublicLookupMain.aspx?AspxAutoDetectCookieSupport=1\r\nIowa\r\nhttps://sos.iowa.gov/elections/voterreg/regtovote/search.aspx\r\nKansas\r\nhttps://myvoteinfo.voteks.org/VoterView/RegistrantSearch.do\r\nKentucky\r\nhttps://vrsws.sos.ky.gov/vic/\r\nLouisiana\r\nhttps://voterportal.sos.la.gov/\r\nMaine\r\nhttp://www.maine.gov/portal/government/edemocracy/lookup_voter_info\r\nMaryland\r\nhttps://voterservices.elections.maryland.gov/votersearch\r\nMassachusetts\r\nhttps://www.sec.state.ma.us/VoterRegistrationSearch/MyVoterRegStatus.aspx\r\nMichigan\r\nhttps://webapps.sos.state.mi.us/MVIC/\r\nMinnesota\r\nhttps://mnvotes.sos.state.mn.us/VoterStatus.aspx\r\nMississippi\r\nhttp://www.sos.ms.gov/pollingplace/Pages/default.aspx\r\nMissouri\r\nhttps://s1.sos.mo.gov/elections/voterlookup/\r\nMontana\r\nhttps://app.mt.gov/cgi-bin/voterinfo/voterinfo.cgi\r\nNebraska\r\nhttps://www.votercheck.necvr.ne.gov/VoterView/RegistrantSearch.do\r\nNevada\r\nhttps://nvsos.gov/VoterSearch/index.aspx\r\nNew Jersey\r\nhttps://voter.njsvrs.com/PublicAccess/servlet/com.saber.publicaccess.control.PublicAccessNavigationServlet?USERPROCESS=PublicSearch\r\nNew Mexico\r\nhttps://voterview.state.nm.us/VoterView/RegistrantSearch.do\r\nNew York\r\nhttps://voterlookup.elections.state.ny.us/votersearch.aspx\r\n\r\n</p>\r\n<a target=\"_blank\" href=\"https://enr.ncsbe.gov/voter_search_public/><b>North Carolina</b></a>> \r\n\r\n<a target=\"_blank\" href=\"https://vip.sos.nd.gov/WhereToVote.aspx?tab=&ptlPKID=&ptlhPKID=\"><b>North Dakota</b></a>> \r\n\r\n<a target=\"_blank\" href=\"http://voterlookup.sos.state.oh.us/voterlookup.aspx\"><b>Ohio</b></a>> \r\n\r\n <a target=\"_blank\" href=\"https://services.okelections.us/voterSearch.aspx\"><b>Oklahoma</b></a>> \r\n\r\n<a target=\"http://sos.oregon.gov/voting/Pages/voteinor.aspx\"><b>Oregon</b></a>> \r\n\r\n                                                            <p> As of 9 17 2016, their site is not as good as some of the other states and you might want to contact the League of Women Voters to get more complete information.</p>\r\n\r\n<a target=\"_blank\" href=\"https://www.pavoterservices.state.pa.us/Pages/voterregistrationstatus.aspx\"><b>Pennsylvania</b></a>>\r\n\r\n<a target=\"_blank\" href=\"https://vote.sos.ri.gov/\"><b>Rhode Island</b></a>>\r\n\r\n<a target=\"_blank\" href=\"https://info.scvotes.sc.gov/eng/voterinquiry/VoterInformationRequest.aspx\"><b>South Carolina</b></a>>\r\n\r\n<a target=\"_blank\" href=\"https://sos.sd.gov/Elections/VIPLogin.aspx\"><b>South Dakota</b></a>>\r\n\r\n<a target=\"_blank\" href=\"https://tnmap.tn.gov/voterlookup/\"><b>Tennessee</b></a>>\r\n \r\n<a target=\"_blank\" href=\"https://teamrv-mvp.sos.texas.gov/MVP/mvp.do\"><b>Texas</b></a>>\r\n\r\n<a target=\"_blank\" href=\"https://vote.utah.gov/vote/menu/index\"><b>Utah</b></a>>\r\n\r\n<a target=\"_blank\" href=\"https://www.sec.state.vt.us/elections.aspx\"><b>Vermont</b></a>>\r\n\r\n<a target=\"_blank\" href=\"https://vote.elections.virginia.gov/VoterInformation\"><b>Virginia</b></a>>\r\n\r\n<a target=\"_blank\" href=\"https://weiapplets.sos.wa.gov/MyVote/#!/login\"><b>Washington</b></a>>\r\n\r\n<a target=\"_blank\" href=\"https://services.sos.wv.gov/Elections/Voter/AmIRegisteredToVote\"><b>West Virginia</b></a>>\r\n\r\n<a target=\"_blank\" href=\"https://myvote.wi.gov/Voter/VoterSearchScreen.aspx\"><b>Wisconsin</b></a>>\r\n    \r\n<a target=\"_blank\" href=\"http://soswy.state.wy.us/Elections/PollPlace/Default.aspx\"><b>Wyoming</b></a>>\r\n\r\n");
$templateCache.put("app/learnHome/cat_sel_press_essay.html","<head>\r\n<title>Learn Home</title>\r\n<!-- This next line keeps buttons and forms at a legible size on cell phones -->\r\n<meta name=\"viewport\" content=\"initial-scale=1, maximum-scale=1\">\r\n   \r\n<style type=\"text/css\">\r\n	/*\r\n	img {\r\n	   width: 10%;\r\n	   min-width: 30px;\r\n	   max-width: 300px;\r\n	}\r\n	a{\r\n		text-decoration: none;\r\n	}\r\n	 a img:hover {transform:scale(1.1);}\r\n	 a img:active {transform:scale(1.5);}\r\n	.votewise {width:23%; max-width:600px;}\r\n	.local{width:23%; max-width:600px; min-width:150px}\r\n	.subjects {\r\n		width:32%; max-width:200px;\r\n	}\r\n*/\r\n</style></head>\r\n<div>\r\n\r\n<!-- <p><h1><center>Learn</center></h1></p>\r\n\r\n\r\n<a href=\"#!/wheretovote\"> <img src=\"assets/images/where_to_vote.svg\" class=\"local\" alt=\"Where to vote\"/></a>\r\n<a href=\"#!/wheretogetnews\"> <img src=\"assets/images/where_to_get_news.svg\" class=\"local\" alt=\"Where to get news\"/></a>\r\n<a href=\"#!/politicalDictionary\"> <img src=\"assets/images/political_dictionary.svg\" class=\"local\" alt=\"Political Dictionary\"/></a>\r\n<a href=\"#!/basicsofpolitics\"> <img src=\"assets/images/basics_of_politics.svg\" class=\"local\" alt=\"Basics of Politics\"/></a> -->\r\n<p>\r\n	<h2 style=\"padding-left:20px;padding-right:10px; padding-bottom:0px;\">Select category</h2>\r\n</p>\r\n\r\n<!-- This is the Start of the subject assets/images -->\r\n\r\n<!-- <a href=\"NotBuiltYet.html\"><img src=\"assets/images/social_services.svg\" class=\"allTopics\" alt=\"Social Services\"/></a>\r\n<a href=\"NotBuiltYet.html\"><img src=\"assets/images/local.svg\" class=\"subjects\" alt=\"Local Subjects\"/></a> -->\r\n<!-- This is the end of the subject assets/images -->\r\n<a ng-repeat=\"item in categories\" href=\"#!/essay_press/{{item._id}}/home\" title=\"{{item.title}}\" style=\"padding: 10px 0px;\">\r\n	 <img src=\"{{imgUrl}}/{{item.icon_image}}\" class=\"subjects\" alt=\"{{item.title}}\"/>	\r\n</a>\r\n");
$templateCache.put("app/learnHome/FactChecking.html","<html>\r\n<head>\r\n<title>Where to Get News</title>\r\n<!-- This next line keeps buttons and forms at a legible size on cell phones -->\r\n<meta name=\"viewport\" content=\"initial-scale=1, maximum-scale=1\">\r\n</head>\r\n<div>\r\n<p><h1><center>\r\nFact Checking\r\n</center></h1>\r\n</p>\r\n<p>\r\n<h2><b>Sites</b></h2>\r\n<p>For very popular stuff - national news and national hoaxes, there are a few sites that check the facts for you.  Two of the most useful ones are:</p>\r\n<p><a target=\"_blank\" href=\"http://www.politifact.com/\" class=\"ylink\">Politifact</a> looks at statement made by national politicians and rates their level of truth.</p>\r\n<p><a target=\"_blank\" href=\"http://www.snopes.com/\" class=\"ylink\">Snopes</a> Looks at a wide variety of rumors, wives tales, and fake news stories.</p>\r\n<h2><b>Doing Your Own Research</b></h2>\r\n</p>\r\n<p>When you are doing your own research, the first step is to think about your sources. Read our essay about judging sources <a target=\"_blank\" href=\"#!/wheretogetnews\" class=\"ylink\"><b>HERE</b></a>.\r\n\r\nA good place to start is <a target=\"_blank\" href=\"https://www.wikipedia.org/\" class=\"ylink\">Wikipedia</a>.  Wikipedia is a non-profit that uses concerned citizens like yourself to write essays.  They are then judged by the readers.  Generally speaking, people who know about the subject will write about things they care about and others in that field will correct them.  But on occassion, people who group together can subvert the truth and create false information on there.   But these attacks tend not to last long, so if you see something that seems bizarre, it\'s probably a data attack.  Check other sources and check Wikipedia again in a couple weeks.<br><br>\r\n\r\nOnce you have some basic information, then you can do further research.  Wikipedia forces essay writers to site their sources, so you can go straight to their sources if you want.  Or you can use key phrases to do searches elsewhere.<br><br>\r\n\r\nIf you use the search engine in your web browser, you should start off with using just one or two key words.  This might show you more results than you could possibly want, but by looking over these results briefly, you can see who else is talking about this issue, if similar things happened elsewhere and a lot of other surprizing things.<br><br>\r\nA second or third sweep using more words or enclosing a phrase in quotes will refine your search to just a few results.<br><br>\r\nFor example, let\'s say that you hear that innoculating your child causes autism.  Perhaps you read an article that quoted Andrew Wakefield\'s study linking Autism and inoculation.  If you typed in the words &quot;Autism &quot; and &quot;inoculation &quot;, you would see a lot of different links.  Some scientific papers proving that his study was a fraud and some people saying that they still have fear.  But if you put in a quote from his paper, you would likely just get his paper and not know that his paper was a fraud or any of the controversy that it spawned. <br><br>\r\n    Never trust just one source.  Find other sources. If those other sources sound just like the first source, then they probably are just repeating what you heard from the first source. If they use the same exact phrases, be VERY wary.  They may be intentionally repeating talking points that are phrased in a way that someone said were effective at convincing you of something they want you to think.  This is likely propoganda and not true.<br><br></p>\r\n\r\n<b><h2>BEWARE THE BIG LIE</h2></b>\r\n<p>There is a very common tactic used in politics, advertising and other arease called, &quot;the Big Lie&quot;.  There are two concepts involved with this.<br><p><ul>\r\n<li> &quot;If you tell a lie often enough, it becomes the truth.&quot;  The idea behind this is that if you hear something again and again and again from many sources, you can\'thelp but think there must be some truth in it.</li>\r\n<li>If you tell an incredibly huge lie, people will believe that you are telling a partial truth.  We all expect people to fib just a bit.  But we don\'t expect someone to be outlandish.  So if someone walks into your hospital room carrying a chart and says that he\'s the world\'s greatest brain surgeon, you will probably imagine that he\'s probably just the best one at the hospital or maybe among the top ten.  But you wouldn\'t imagine that he\'s just a janitor. </li></p></ul>\r\n<p>Both of these techniques are incredibly common and you should beware of them.</p>\r\n");
$templateCache.put("app/learnHome/FakeNews.html","<html>\r\n<head>\r\n<title>Where to Get News</title>\r\n<!-- This next line keeps buttons and forms at a legible size on cell phones -->\r\n<meta name=\"viewport\" content=\"initial-scale=1, maximum-scale=1\">\r\n</head>\r\n<div>\r\n\r\n<p><h1><center>\r\n    Fake News\r\n</center></h1>\r\n</p>\r\n<p>Finding reliable sources for news can be difficult. One thing making it much harder is organizations intentionally putting out fake news. Some of these are satire and are actually funny. More often, though, organizations create fake news to lure people in to see the ads. They get paid by how many people visit the page, so they try to come up with some rather insane stories. During the 2016 Presidential elections, many ridiculous claims were made about all the candidates. Many claim to be satire in the fine print, but that appears to be just so they can avoid being sued.</p><br>\r\n    \r\n<b><p>Things to Look for:</p></b>\r\n    <b><p>Claims that are almost too crazy to believe.</p></b>\r\n    <p>Everyone is competing for your attention.  Click bait is not limited by the truth, so they will push the bounds to get you to click on their site.  If you find yourself tempted and click on it, remember - extraordinary claims require extraordinary proof.  Don\'t believe what they say until you see it from other sources that you know and trust - and look for their source material.</p>\r\n    <br>\r\n    <b><p>Improper English </p></b>\r\n    <p>If they can\'t spend the time to go back and correct their English, they probably don\'t take the time to correct their facts.  Traditional news outlets have reporters who went to school and editors who fix the mistakes that slip by.  But a lot of click bait is created by people who write as many articles as they can in a day. Sometimes, it is written by people who speak English as a second language.</p><br>\r\n    <b><p>Tons of Ads and Pictures</p></b>\r\n    <p>Everyone has to make a living, so ads are a part of a lot of sites, but click bait\'s entire goal is to draw you in to see the ads, so you\'ll find a lot more there.  Their sites will also have more pictures than most sites and their lay out is usually amateurish.</p>\r\n    <br>\r\n    <b><p>Misleading Names</p></b>\r\n    <p>There are some organizations that intentionally choose names aimed at confusing you into thinking they are a reputable site. For example, they might call themselves NBC.com.co which makes them look like the major network NBC.com</p><br>\r\n    <b><p>Check the List</p></b>\r\n    <p>Here\'s a quick list of some fake news sources we found. A more complete list of fake news sites can be found at <a target=\"_blank\" href=\"http://www.fakenewswatch.com/\" class=\"link\"><b>http://www.fakenewswatch.com/</b></a></p>\r\n<p>And Professor Melissa Zimdars of Merrimack College wrote a nice piece \r\n    <a target=\"_blank\" href=\"http://d279m997dpfwgl.cloudfront.net/wp/2016/11/Resource-False-Misleading-Clickbait-y-and-Satirical-%E2%80%9CNews%E2%80%9D-Sources-1.pdf\"  class=\"link\"><b>Here</b></a></p></p>\r\n<ul>\r\n\r\n  <li>World News Daily Report</li>\r\n <li>Weekly World News</li>\r\n  <li>National Report</li>\r\n  <li>Global Associated News  (mediaFetcher.com)</li>\r\n  <li>The Daily Currant</li>\r\n  <li>NewsWatch33</li>\r\n  <li>Call the Cops</li>\r\n  <li>Empire News</li>\r\n  <li>Empire Sports</li>\r\n  <li>National Report</li>\r\n  <li>The Borowitz Report</li>\r\n  <li>Lightly Braised Turnip</li>\r\n  <li>Betoota Advocate</li>\r\n  <li>Huzlers</li>\r\n  <li>Empire News</li>\r\n  <li>Freewoodpost.com</li>\r\n  </ul>\r\n\r\n\r\n    \r\n");
$templateCache.put("app/learnHome/learnHome.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\" ng-if=\"$root.userRole!=\'advocate\'\">LEARN</h2>\r\n	<h2 class=\"pageHeading\" ng-if=\"$root.userRole==\'advocate\'\">TEACH OR RESEARCH</h2>\r\n  <p class=\"pageSubHeading\" ng-if=\"$root.userRole!=\'advocate\'\">Research the Topics, the Basics of Politics, Upcoming Legislation, and Election tools near you.</p>\r\n	  <p class=\"pageSubHeading\" ng-if=\"$root.userRole==\'advocate\'\">Teach or Learn about the Topics, the Basics of Politics and Services available near you.</p>\r\n																				<div class=\"centerediframe\">\r\n  <iframe src=\"https://player.vimeo.com/video/407428918?byline=false&title=false\" allowfullscreen ></iframe>\r\n</div>\r\n  <div class=\"row d-flex justify-content-center\">\r\n    <div class=\"col col-lg-9  col-med-12 col-sm-12 col-12 colPadding1\">\r\n      <div class=\"row\">\r\n        <div class=\"col-lg-12 col-sm-12 learnHeader\">\r\n           <img ng-src=\"./assets/images/learnTopics.svg\" class=\"blockInfoImgLearn img-fluid\">\r\n          <div id=\"blockInfoLearn1\">\r\n            <div>\r\n              <h4 ng-if=\"$root.userRole==\'advocate\'\"  class=\"blockTitleLearn\" >TEACH OR RESEARCH THE TOPICS</h4>\r\n													<h4 ng-if=\"$root.userRole!=\'advocate\'\"  class=\"blockTitleLearn\" >LEARN ABOUT THE TOPICS</h4>\r\n              <span class=\"blockDesc\">Watch videos and read articles from our staff and organizations that specialize in these topics.</span>\r\n				\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"newUserLearn\">\r\n          <form class=\"ng-pristine ng-valid\">\r\n            <div>\r\n              <!-- <legend class=\"scheduler-border\">Learn about the Issues</legend> -->\r\n              <p class=\"fwb\" ng-if=\"statusGetEssayCat == 1\">Loading categories...</p>\r\n              <p class=\"fwb\" ng-if=\"statusGetEssayCat == 2 && categories.length <= 0\">No category available to select</p>\r\n              <a ng-repeat=\"item in categories | orderBy: \'order\'\" href=\"#!/essay/{{item._id}}/home\" title=\"{{item.title}}\" style=\"padding: 10px 0px;\">\r\n                <div class=\"allTopics\">\r\n                  <img src=\"{{imgUrl}}/{{item.iconImage}}\" alt=\"{{item.title}}\" />\r\n                  <span>{{item.title}}</span>\r\n                </div>\r\n              </a>\r\n            </div>\r\n          </form>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col col-lg-9 col-med-12 col-sm-12 col-12 colPadding2\">\r\n      <div class=\"row\">\r\n        <div class=\"col-lg-12 col-sm-12 learnHeader\">\r\n          <img ng-src=\"./assets/images/learnPolitics.svg\" class=\"blockInfoImgLearn img-fluid\">\r\n          <div id=\"blockInfoLearn2\">\r\n            <div>\r\n              <h4 class=\"blockTitleLearn\">LEARN ABOUT POLITICS</h4>\r\n              <span class=\"blockDesc\">Learn the basics of politics including how government works, how to register, where to vote and more.</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"newUserLearn\">\r\n          <form class=\"ng-pristine ng-valid\">\r\n            <div>\r\n              <div>\r\n                  <a href=\"#!/wheretovote\" class=\"allTopics\"> <img src=\"assets/images/where_to_vote.svg\" alt=\"How to Register and Where to Vote\"/><span>Help Voting</span></a>\r\n                  <a href=\"#!/basicsofpolitics\" class=\"allTopics\"> <img src=\"assets/images/basics_of_politics.svg\" alt=\"Basics of Politics\"/><span>Basics of Politics</span></a>\r\n                  <a href=\"#!/legislation\" class=\"allTopics\"> <img src=\"assets/images/followLegislation.svg\" alt=\"All About Legislation\"/><span>All About Legislation</span></a>\r\n                \r\n                  <a href=\"#!/politicalDictionary\" class=\"allTopics\"> <img src=\"assets/images/political_dictionary.svg\" alt=\"Politician to Voter Dictionary\"/><span>Politician to Voter Dictionary</span></a>\r\n                  <a href=\"#!/wheretogetnews\" class=\"allTopics\"> <img src=\"assets/images/where_to_get_news.svg\" alt=\"How to find news you can trust\"/><span>How to find news you can trust</span></a>\r\n              </div>\r\n            </div>\r\n          </form>\r\n        </div>\r\n      </div>\r\n      <div>\r\n      </div> <br><br>\r\n					<div class=\"col-lg-12 col-sm-12 gettingStartedContainer row\">\r\n        <a href=\"#!/incumbent_politician/politician\" class=\"blockLink\"><img ng-src=\"./assets/images/politiciansRBB7-01.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock5\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">POLITICIANS</h4>\r\n          <p class=\"gettingStartedBlockDesc\" ng-if=\"$root.userRole==\'advocate\'\">Learn about the politicians in office and up for election in your area.  See their voting records and who funds their campaigns. Rate or endorse them. If you\'ve taken the Ideological Match quiz, you can see which ones would be best to team up with.\r\n          </p>\r\n									<p class=\"gettingStartedBlockDesc\" ng-if=\"$root.userRole!=\'advocate\'\">Learn about the politicians in office and up for election in your area.</p>\r\n            \r\n        </div>\r\n      </div></a>\r\n    </div>\r\n    </div>\r\n  </div>\r\n	\r\n</div>\r\n<!-- <p>\r\n  <h1><center>Learn</center></h1></p>\r\n<p><b>Explore.</b> Use this section to:\r\n  <ul>\r\n    <li>Watch videos and read essays from various organizations so you can learn about the issues from different perspectives.</li>\r\n    <li>Learn about politics in general including how to read through \"Political Speak\"</li>\r\n  </ul>\r\n</p>\r\n<div class=\"newUser\">\r\n  <form>\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Learn about Politics</legend>\r\n      <div>\r\n      <div class=\"allTopics\">\r\n      <a href=\"#!/wheretovote\"> <img src=\"assets/images/where_to_vote.svg\" alt=\"Where to vote\"/><span>Where to Vote</span></a>\r\n      </div>\r\n      <div class=\"allTopics\">\r\n      <a href=\"#!/wheretogetnews\"> <img src=\"assets/images/where_to_get_news.svg\" alt=\"Where to get news\"/><span>Where to Get News</span></a>\r\n      </div>\r\n      <div class=\"allTopics\">\r\n      <a href=\"#!/politicalDictionary\"> <img src=\"assets/images/political_dictionary.svg\" alt=\"Political Dictionary\"/><span>Political Dictionary</span></a>\r\n      </div>\r\n      <div class=\"allTopics\">\r\n      <a href=\"#!/basicsofpolitics\"> <img src=\"assets/images/basics_of_politics.svg\" alt=\"Basics of Politics\"/><span>Basics of Politics</span></a>\r\n      </div>\r\n      </div>\r\n    </fieldset>\r\n  </form>\r\n</div>\r\n<div class=\"newUser\">\r\n  <form>\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Learn about the Issues</legend>\r\n      <p class=\"fwb\" ng-if=\"statusGetEssayCat == 1\">Loading categories...</p>\r\n      <p class=\"fwb\" ng-if=\"statusGetEssayCat == 2 && categories.length <= 0\">No category available to select</p>\r\n      <a ng-repeat=\"item in categories | orderBy: \'order\'\" href=\"#!/essay/{{item._id}}/home\" title=\"{{item.title}}\" style=\"padding: 10px 0px;\">\r\n      <div class=\"allTopics\">\r\n   <img src=\"{{imgUrl}}/{{item.iconImage}}\" alt=\"{{item.title}}\"/>\r\n   <span>{{item.title}}</span>\r\n   </div> \r\n</a>\r\n    </fieldset>\r\n  </form>\r\n</div>\r\n -->\r\n");
$templateCache.put("app/learnHome/PoliticalDictionary.html","<html>\r\n<head>\r\n<title>Political Dictionary</title>\r\n<!-- This next line keeps buttons and forms at a legible size on cell phones -->\r\n<meta name=\"viewport\" content=\"initial-scale=1, maximum-scale=1\">\r\n</head>\r\n<div>\r\n\r\n<center><h1>Political Dictionary</h1></center>\r\n<p>Sometimes it&#8217s difficult to understand what people are saying in the world of politics.  The Press often use words not used in regular conversation and some politicians use common words, but in a way that is aimed at intentionally confusing you.</p>\r\n<p><a href=\"#!/commonPhrases\"  class=\"ylink\">Click <b>here</b> to see words used by the press</a></p>\r\n\r\n<center><h2>Political Tactics</h2></center>\r\n<p> Below are some techniques that some political handlers use to confuse you.</p>\r\n<h2>It&#8217s all in the name</h2>\r\n<p>One common practice is to give a bill a great sounding name when it really has nothing to do with it.  If you name something, &quot;The I love America Bill&quot; then it makes anyone who votes against it seem evil.  In the meantime, the bill might promote sending jobs overseas, clear&ndash;cutting forests, or anything else.</p>\r\n\r\n<h2>Focus on positive image and vague answers</h2>\r\n<p>If you like someone you just met, you will assume that they feel the same way you do about most things until they prove otherwise. Many politicians capitalize on this by spending tons of money creating a likeable character but avoid saying what they want to do. If they can be vague enough, then voters will fill in the gap with whatever answers they like most. &quot;I want to make America safe&quot; &ndash; could mean &quot;I want to increase spending on food inspection to make sure that poisonous stuff doesn&#8217t make it to our dinner table&quot; or it could mean &quot;I want to create a dialogue between police and citizens so that police are more effective in the community&quot; or it could mean &quot;I want to nuke all the other nations, so we are the last one standing and no longer have fear of invasion or economic competition.&quot; Don&#8217t trust someone who doesn&#8217t give you the details.</p>\r\n\r\n\r\n<h2><b>Fear</b></h2>\r\n<p>This is currently one of the most popular tactics. Fear creates a &ldquo;fight or flight&rdquo; panic response in  people. This focus on survival eliminates thinking things through and can lead to herd behavior. When you see a crowd running past you  screaming in fear, you don&rsquo;t stop to ask questions, you run too. There have been many cases where crowds of people died in night club fires because everyone was pushing on the exit door instead of stopping to read the sign that says &quot;pull.&quot; Similarly, politicians can try to create this base level of thinking and  herd behavior by creating fear in the voter. They say that you will become the victim of a  great calamity if you don&rsquo;t do what they say. In the face of such fear, many don&rsquo;t question as deeply as they  should. This is a very good way of  getting people to do something short term, but keeping people in a state of  fear for long periods of time has many negative side effects. A caged animal that would normally run, will  eventually turn and fight. Hard. Sometimes this turning is on each other in  the form of physical violence and other crime. Selfishness. Other times it can  destroy hope and the economy. Lesser  lash&ndash;backs would be finding some small fault in the politician and using that  as an excuse to get REALLY angry at him/her A historic example of this  technique is Joe McCarthy and his search for communists For the past 20 years, this tactic has been used a lot by politicians and the media and is probably contributing to  the rise in mass shootings and other extremist activities.</p>\r\n<h2><b>Hope</b></h2>\r\n<p>This one is rarely used. It is the opposite of fear…. to some degree. For the most part, it calms people down,  makes them feel good and enables them take the time to think straight and look  at the ideas a little closer. The public  response is usually not as strong as from fear, but this technique is better  for keeping people motivated for much longer periods of time (there is no  cornered animal response.) But in order  for it to work, you have to have a sense of progress to keep people motivated. There was recently a national politician who  ran on the platform of hope. When he got  into office, he had some minor successes but failed to advertise them as  victories on the path to the big dream. So everyone lost faith in him. Once faith is lost, it&rsquo;s really hard to recover. Creating fear, on the otherhand is really easy. Encouraging hope as a campaign tactic also has  positive side effects on the economy, how people treat each other in the  street, and general happiness. Historic examples of this  technique include Martin Luther King Jr, and Mahatma Ghandi. Ronald Reagan made good use of both fear and  hope techniques at the same time.</p>\r\n<h2><b>Polarizing</b>/Demonizing</h2>\r\n<p>When running for office, it&#8217s important to show how you differ from other candidates, so voters can make informed decisions on how to vote, but many candidates try to make it seem like their opponent is Satan. Polarizing people is one of the worst things you can do when trying to solve a problem.  If all of our problems were obvious black and white, then they would be easily solved and we wouldn&#8217t need politicians. But the reality is no one side is ever fully right or wrong. They share comon ground with you and their desires are legitimate from their point of view.  In order to solve problems, you have to treat all the opposing sides as intelligent people who want to do what is best.  If you start off by calling them evil, then everything they have to say is not worth listening to and no solutions can be made. Politicians need to listen to the logic, weigh all the options and compromise to get things done. It&#8217s like when you go to the movies with your family. One person wants to see a bloody horror film, another wants to see a romantic comedy. You could spend the evening yelling at each other and never see anything, or you could go together and enjoy an action film where the guy rescues the girl. Polarizing is a good way to win elections, but a horrible way to get anything done once you&#8217re in office.<br>\r\n</p>\r\n<h2>Changing the Question</h2>\r\n<p>There is the saying &quot;Don&#8217t answer the question you were asked &ndash; answer the question you WISH you were asked.&quot;  This is the most commonly used tactic.  The other is by answering the question with meaningless phrases (see below) When you hear a politician answer a question, ask yourself, &quot;Did they really say anything?  If so, was it the answer to the question?&quot;</p>\r\n\r\n<h2>Commonly used Doublespeak phrases.</h2>\r\n<p>&quot;Doublespeak&quot; is the use of words to say something that appears kind when it is horrific or seem meanigful when it ie entirely meaningless. Here are some examples.</p>\r\n<p><b><u>&quot;Family Values&quot;</u>&ndash; </b>This is a very popular one that really doesn&#8217t mean anything.  What values do a family actually have?  All it takes to make a family is the ability to procreate or adopt.  Even a serial killer can get someone pregnant.   Every family &ndash; including ones you disagree with, have their own sets of values &ndash; different values.  So the phrase &quot;family values&quot; is entirely meaningless.   But when a politician says he supports &quot;family values&quot; it reminds us of our love for our families and associates himself to that love.</p>\r\n\r\n<p><b><u>&quot;Special interests/lobbyists&quot;</u> &ndash;</b> Everyone is a special interest, so this too is meaningless.  Everyone has things we care about &ndash; that&#8217s why we vote.  Sometimes we donate money to charities who go to politicians and try to convince them not to allow pollution in our drinking water.  Some of us belong to labor unions who send people to congress to convince them to avoid sending our jobs overseas.  That&#8217s part of representational democracy.  We work fulltime jobs &ndash; many of us work multiple jobs.  It&#8217s impossible for us to become experts in all the problems that face America.  So we choose politicians who we trust to listen to different arguments and come up with conclusions that we would if we were in his shoes.  Part of that process is listening to all sides .  The people who come to him to try to convince him their way is the right way are called &quot;lobyists&quot;.  But by cloaking people in the words &quot;Special Interest groups&quot; or &quot;lobbyists&quot; politicians can make them out as evil villains.  This makes them easy targets, but no one gets rid of them &ndash; partly because they can&#8217t do their job properly without them.  You can&#8217t make an informed decision without first hearing the arguments.</p>\r\n\r\n<p><b><u>&quot;Lower taxes, safer streets, better schools&quot;</u></b> &ndash; Everyone wants these things, so most politicians claim they will deliver.  But safer streets and better schools cost money, and if you lower taxes then you have no money to pay for it.  If they don&#8217t give you very specific details of what services they are going to cut back in order to get the money to pay for these new things, then you shouldn&#8217t believe them.</p>\r\n\r\n<p><b><u>&quot;Cut the government waste&quot;</u></b> &ndash; Budgets are pretty tight in government programs.   Everyone wants more money for their favorite project., but politicians are scared to raise taxes to pay for them.  You can believe that if there was money that was universally believed to be wasted, someone would have pounced on it and claimed it for themselves.  On the other hand, there are programs that some don&#8217t feel important.  For example, if you don’t have children or want or like them, then you might consider afterschool sports programs to be a waste of money.  If they say they are going to cut the waste, you should find out exactly what they mean by that.</p>\r\n\r\n<p><b><u>&quot;Keep America Free/pure&quot;</u>  &ndash;</b> This makes the politician seem like a hero and therefore their opponent is an evil villain.   It&#8217s polarizing. It is also a phrase often used to promote prejudice.</p>\r\n    \r\n<h2>Redefining the language</h2>\r\n<p>This a technique that a lot of cults use.  What they do is they take a common word and redefine it and encourage their followers to use it all the time.  There are two things that they can do from here.  They can either keep it redefined and make communication between the followers and those outside the organization impossible because they don’t know what the other is talking about.  Or, they can bring the word back to its original definition, but with all the new connotations attached.   </p>\r\n<p>For an example of the later, check out this youtube video: <a target=\"_blank\" href=\"https://www.youtube.com/watch?v=ERj3QeGw9Ok&feature=youtu.be\" class=\"ylink\"><b>Thomas Sowell on Intellectuals and Society</b></a>    In the beginning of this half-hour video, he redefines &quot;intellectual&quot; so instead of meaning someone who is educated, it means &quot;someone who is arrogant and assumes that because they know about one thing, they know about everything.&quot;  He is very clear that other educated people who stick to their fields of study are good people, but these other people who fall under the new definition of the word &quot;Intellectual&quot; are unwise and have destroyed our society.  He then goes on to list a lot of times in history where people who were arrogant and didn’t fully understand the situation made unwise choices.  But then he slowly intersperses the correct definition of &quot;intelligence&quot; and &quot;intellectual&quot;.</p>  \r\n<p>Let me make a side note here.   Most mind control techniques don’t work in a vacuum, so he makes use of what con artists would call a &quot;plant&quot; or a \"shill.\"  The speaker gets borrowed legitimacy by having the interviewer start as a skeptic but by the end is helping him make leaps in logic that would sound bad coming out of the speaker’s mouth.  So by the end of the half hour, he has inferred that getting anything more than a high school education is a mistake and ruins your wisdom.   Interviewers are supposed to be trusted skeptics, so we subconsciously feel that if he has convinced the skeptic, he must have said something really brilliant.</p>\r\n<p>This technique turns off the mind in preparation for the next messages they want to plant into your mind.   It makes you suspicious of people who have actually studied the issues, so it makes independent research impossible.  Any reputable source is now disreputable.  The only people you can trust now are the people who redefined the word (and effectively your world.)  These leaders can then use other techniques to make other concepts seem &quot;emotionally right&quot;.  In the video above, at the end of the half hour, he claims to know more than &quot;intellectuals&quot; who have been studying environmental technology their entire lives.  He becomes what he was railing against, but has placed the label of this unscrupulous activity on his enemies.  And he has now created a situation where whenever you hear that word, you cringe in disgust and distrust. </p>\r\n<p>This exact technique of blaming &quot;intellectuals&quot; was used by Chairman Mao to get rid of his opposition in the Cultural Revolution which would eventually cost the lives of 30 million people.  Hitler put every hateful aspect of humanity into the word &quot;jew&quot; and used it to kill 6 million of them and 4 million people of other newly defined labels.   Pol Pot used the technique to kill 2.5 million of his people.</p>\r\n<p>It&#8217s a REALLY scary technique.   Beware of it.  Whether used in a cult or by political leaders, it never ends well.</p>\r\n\r\n");
$templateCache.put("app/learnHome/WhereToGetNews.html","<html>\r\n<head>\r\n<title>Where to Get News</title>\r\n<!-- This next line keeps buttons and forms at a legible size on cell phones -->\r\n<meta name=\"viewport\" content=\"initial-scale=1, maximum-scale=1\">\r\n</head>\r\n<div>\r\n\r\n<p><h1><center>Where to Get News</center></h1>\r\n</p>\r\n<p><h2><b>Avoid Fake News</b></h2></p><p>There are a lot of people out there intentionally creating fake news.  Click below to see how to avoid these.</p>\r\n<center><a ng-href=\"#!/fakenews\">\r\n    <input type=\"button\" class=\"btn\" value=\"List of Fake News Sources\">\r\n</a></center>\r\n\r\n<p><h2><b>Fact Checking</b></h2>\r\n</p><p>If someone says something that shocks you, there\'s a chance that they are wrong and you should check it out.  There are a number of great sources for fact checking.  Click below to find out.\r\n<center><a ng-href=\"#!/factchecking\">\r\n    <input type=\"button\" class=\"btn\" value=\"Fact Checking\">\r\n    </a></center></p>\r\n\r\n\r\n<p><h2><b>How to Judge Your Sources of Information</b></h2><br>\r\n<p>Sometimes people get the facts wrong by accident.  There is a lot of bad information out there about every subject known to mankind. With so many people stating things as fact that are just opinion or pure fabrication, it becomes hard to find the truth. But here is a quick guide to help.<br><br>\r\nWhen judging a source of information, you have to consider:  <b>Bias, Motivation, Risk of them lying, Closeness to original source, Expertise,</b>  and <b>Experience.</b> I will be using VoteWise here as an example for you to judge.</p>\r\n\r\n<p><b><u>Bias</u></b> &mdash; everybody has a set of life experiences  that make them believe some things more strongly than others and feel that some things are more important than others.  Six people can see the same event and each might tell you a different  thing happened.  One might say, &ldquo;A guy was trying to hit on girls by showing his puppy dog around when someone&rsquo;s  husband got upset and chased him off.&rdquo;  Another person might say &ldquo;There was a freaky looking dog in the park today.  It looked like a cross between a cat and a ferret, but it barked, so I think it was a dog.. or an alien.&rdquo;  Both people are telling the truth of what they saw from their point of view.  Their eyes were open and they saw the same things, but their bias had them notice different things.  It&rsquo;s important to hear the story from a  number of different sources in order to get closer to the truth that you find important.</p>\r\n\r\n<p>Common news source biases &mdash; Most American news sources explain things almost entirely from the point of view of Americans with little interest in understanding the motivations of our allies and enemies.  To balance out this bias, you should also view foreign news sources like the BBC.  Some sources favor the point of view of Democrats (like MSNBC) and some favor the point of view of Republicans  (like FOX News).</p>\r\n<p>VoteWise&rsquo;s Bias &mdash; we try to be as neutral as possible but it&rsquo;s impossible to include ALL information.  We pick what we feel is relevant.  Our bias is based on several assumptions</p><p>\r\n<ul>\r\n  <li>You can&rsquo;t come up with great solutions unless  you figure out what everyone REALLY wants.  No one sees themselves as evil. We all see ourselves as doing what is right most of the time.  So when you look at a conflict, you have to learn how to see it from each and every side &mdash; even if that side seems insane from the first glance. If you don&rsquo;t think their ideas are &ldquo;good&rdquo; on some level, then you  haven&rsquo;t really figured them out yet.</li>\r\n  <li>You can&rsquo;t come up with a LASTING solution unless  you understand the cause of the problem.</li>\r\n  <li>People from opposing parties are not your enemies, but rather your allies in finding a solution that fits more people.</li>\r\n  <li>Long term thinking is critical.</li>\r\n  <li>Democracy cannot exist without freedom of speech.</li>\r\n  <li>Everyone has at least one brilliant thing to say, so true wisdom requires a lot of listening.</li>\r\n  <li>It is mature and wise to change your mind when faced with ideas, information, or situations that change. </li>\r\n  <li>The future lies in the hands of the voters.  They have the power to change the world, if they learn how to use that power and vote wisely.</li>\r\n  <li>Extraordinary claims require extraordinary proof.</li>\r\n  <li>You should never trust information coming from just one source &mdash; even from us.  Maybe someone made a typo or got hacked or just made a mistake.  People make mistakes.  The more important the information is, the  more sources you should check.</li>\r\n  <li>Just because something was done a million times before doesn&rsquo;t mean it was done right.</li>\r\n</ul></p>\r\n\r\n<p><u><b>Motivation</b></u> &mdash; Everyone has a motivation for saying what they are saying.  Are they  saying it to get ratings?  Are they  saying it to piss you off?  Are they saying it to make themselves look good?   Are they saying it to win you over and get something from you?  Oftentimes, this means that a news channel  will have a brilliant scientist debate with a crackpot and say they are of equal value just because the conflict makes for more entertaining TV.  Sometimes they will encourage fear because it makes you tune in later for more information.  ex. &quot;There may be something in your kitchen cabinet that can kill you, Tune in at 11 to find out.&quot; Sometimes they say things to appeal to their advertisers or owners.</p>\r\n\r\n<p>VoteWise Motivation &mdash; We believe that an informed electorate will make the world a better place.  We live here too, so improving the world will improve our lives as well.  We are non-profit.  We rely upon donations of  people like you.  Hopefully, if you think we are doing a good job, you will donate so we can continue to do this.  But mostly we are looking for the world to be better.</p>\r\n\r\n<p><u><b>Risk of Lying</b></u> &mdash; If a big corporate news outlet lies, they can be sued for millions of dollars.. Their public reputation is besmirched, viewers/readers stop turning to them for news resulting in massive loss of business, jobs, etc...  If an anonymous blogger lies, then maybe they get a few fewer readers or at worst, they spend half an hour creating a new  blog.</p>\r\n\r\n<p>VoteWise Risk of Lying&mdash; we spent a few years putting this thing together.  If we are seen as untrustworthy, it would take a lot of work to fix.</p>\r\n\r\n<p><u><b>Expertise</b></u> &mdash; When it comes to making pies, who are you going to trust, a baker or a nuclear physicist?  The physicist may be more intelligent, but the baker is an expert at making pies.. Go to sources that specialize in the information you want.</p>\r\n\r\n<p>VoteWise Expertise &mdash; We are generalists who specialize on the interrelation of different areas. If you want to know more about economics, environmentalism or any single thing, there are much better sources. </p>\r\n\r\n<p><u><b>Closeness to original source</b></u> &mdash; Once information is out there, it can be interpreted and repeated again and again. Each time it is repeated, it is &ldquo;summarized&rdquo; and altered.. What may have started out as someone saying &ldquo;they were late for work&rdquo; may change down the line to &ldquo;they hated their job so they quit.&rdquo;  Sometimes even a normally reputable source can get information from the middle of the stream instead of the top of the mountain and make bad information seem good. If you can, go to the original source.</p>\r\n\r\n<p><u><b>Experience</b></u> &mdash;If a source has been trusted for decades, then viewers/readers have had time to see if that source is reliable.</p>\r\n<p><b>NEVER TRUST JUST ONE SOURCE</b>&mdash; not even us. Everyone can make a mistake. Everyone can be hacked. And even if people are correctly stating what they think, it\'s not the whole story. Get the story from another angle to get a better idea of the truth. If you are fighting FOR an issue, listen also to people who are AGAINST that same issue.</p>\r\n<p>&nbsp; </p>\r\n<p>&nbsp;</p>\r\n");
$templateCache.put("app/learnHome/WhereToVote.html","<html>\r\n<head>\r\n<title>Where To Vote</title>\r\n<!-- This next line keeps buttons and forms at a legible size on cell phones -->\r\n<meta name=\"viewport\" content=\"initial-scale=1, maximum-scale=1\">\r\n</head>\r\n<div class=\"container-fluid\">\r\n\r\n    \r\n    \r\n   \r\n  <div class=\"votingTools jumbotron\">\r\n            <h2 class=\"pageHeading\">VOTING</h2>\r\n  <p class=\"pageSubHeading\">Here are some great tools created by other organizations to help you register and vote.</p>\r\n    <div class=\"row\">\r\n      <div class=\"col-lg-6 d-lg-none\">\r\n        <div class=\"row\">\r\n          <div>\r\n              \r\n            <div class=\"col-12\">\r\n              <a href=\"https://register.rockthevote.com/registrants/new?partner=1&source=rtv.org-topnav&_ga=2.164445756.285480818.1570202241-1599620056.1570202241\" target=\"_blank\" class=\"blockLink\">\r\n              <img ng-src=\"./assets/images/registerToVote.svg\" class=\"blockInfoSmallImgSmall img-fluid\">\r\n              <div class=\"blockInfoSmall\">\r\n                <div>\r\n                  <h5 class=\"blockTitle\">REGISTER TO VOTE</h5>\r\n                  <span class=\"blockDesc\">This will take you to Rock the Vote\'s voter Registration tools.</span>\r\n                </div>\r\n                  </div>\r\n                 \r\n              </a></div>\r\n          \r\n                <div class=\"col-12\">\r\n              <a href=\"#!/checkRegistration\" class=\"blockLink\">\r\n              <img ng-src=\"./assets/images/checkStatus.svg\" class=\"blockInfoSmallImgSmall img-fluid\">\r\n              <div class=\"blockInfoSmall\">\r\n                  \r\n                <div>\r\n                  <h5 class=\"blockTitle\">CHECK REGISTRATION STATUS</h5>\r\n                  <span class=\"blockDesc\">Many states kick you off the voter rolls if you haven\'t voted for awhile.  Use this form to check your status.</span>\r\n                </div>\r\n              </div>\r\n              </a>\r\n            </div>\r\n              \r\n              \r\n              \r\n            <div class=\"col-12\">\r\n              <a href=\"https://www.vote.org/polling-place-locator/\" target=\"_blank\"class=\"blockLink\">\r\n              <img ng-src=\"./assets/images/findYourPollingPlace.svg\" class=\"blockInfoSmallImgSmall img-fluid\">\r\n              <div class=\"blockInfoSmall\">\r\n                  \r\n                <div>\r\n                  <h5 class=\"blockTitle\">FIND YOUR POLLING PLACE</h5>\r\n                  <span class=\"blockDesc\">Go to this website to look up where you need to go to vote.</span>\r\n                </div>\r\n              </div>\r\n              </a>\r\n            </div>\r\n              \r\n                           \r\n            <div class=\"col-12\">\r\n              <a href=\"#!/absenteeBallots\" target=\"_blank\"class=\"blockLink\">\r\n              <img ng-src=\"./assets/images/absenteeBallot.svg\" class=\"blockInfoSmallImgSmall img-fluid\">\r\n              <div class=\"blockInfoSmall\">\r\n                  \r\n                <div>\r\n                  <h5 class=\"blockTitle\">ABSENTEE BALLOTS</h5>\r\n                  <span class=\"blockDesc\">If you can\'t physically get to the polls on election day, you can request a mail in ballot in advance.  Every area has their own rules, so make sure you apply early.</span>\r\n                </div>\r\n              </div>\r\n              </a>\r\n            </div>\r\n              \r\n                                     \r\n            \r\n                                  \r\n            <div class=\"col-12\">\r\n               <a href=\"#!/getAReminder\" class=\"blockLink\">\r\n              <img ng-src=\"./assets/images/reminder.svg\" class=\"blockInfoSmallImgSmall img-fluid\">\r\n              <div class=\"blockInfoSmall\">\r\n                  \r\n                <div>\r\n                  <h5 class=\"blockTitle\">GET A REMINDER</h5>\r\n                  <span class=\"blockDesc\">Are you scared you\'ll forget to vote?  Get a reminder.</span>\r\n                </div>\r\n              </div>\r\n              </a>\r\n            </div>\r\n              \r\n                 \r\n              \r\n            <div class=\"col-12\">\r\n                <a href=\"#!/electionProblems\" class=\"blockLink\">\r\n             <!-- <a href=\"https://www.justice.gov/crt/complaint/votintake/index.php\" target=\"_blank\" class=\"blockLink\">  -->\r\n              <img ng-src=\"./assets/images/votingIrregularities.svg\" class=\"blockInfoSmallImgSmall img-fluid\">\r\n              <div class=\"blockInfoSmall\">\r\n                <div>\r\n                  <h5 class=\"blockTitle\">REPORT VOTING PROBLEMS</h5>\r\n                  <span class=\"blockDesc\">Are you having problems on election day?  Did you get turned away at the polls?  Get help here.</span>\r\n                </div>\r\n              </div>\r\n              </a>\r\n            \r\n											\r\n											\r\n											\r\n											\r\n																				          <div class=\"col-12\">\r\n            <a href=\"https://www.vote.org/early-voting-calendar/\" target=\"_blank\"class=\"blockLink\">\r\n             <!-- <a href=\"https://www.justice.gov/crt/complaint/votintake/index.php\" target=\"_blank\" class=\"blockLink\">  -->\r\n              <img ng-src=\"./assets/images/earlyVoting.svg\" class=\"blockInfoSmallImgSmall img-fluid\">\r\n              <div class=\"blockInfoSmall\">\r\n                <div>\r\n                  <h5 class=\"blockTitle\">CAN I VOTE EARLY?</h5>\r\n                  <span class=\"blockDesc\">Sometimes trying to get off work during polling hours is impossible.  Fortunately, some states have polling stations open on other days before election day, so you can vote early.  Click here to see if and when you have that ability near you.</span>\r\n                </div>\r\n              </div>\r\n              </a>\r\n          </div>\r\n									\r\n												\r\n									          <div class=\"col-12\">\r\n            <a href=\"https://ballotpedia.org/Voter_identification_laws_by_state#tab=Details_by_state\" target=\"_blank\"class=\"blockLink\">\r\n             <!-- <a href=\"https://www.justice.gov/crt/complaint/votintake/index.php\" target=\"_blank\" class=\"blockLink\">  -->\r\n              <img ng-src=\"./assets/images/voterID.svg\" class=\"blockInfoSmallImgSmall img-fluid\">\r\n              <div class=\"blockInfoSmall\">\r\n                <div>\r\n                  <h5 class=\"blockTitle\">DO I NEED AN ID?</h5>\r\n                  <span class=\"blockDesc\">Some states require specific ID\'s in order to vote.  Laws are constantly changing so you should check here.</span>\r\n                </div>\r\n              </div>\r\n              </a>\r\n          </div>\r\n									\r\n														\r\n									\r\n												\r\n									          <div class=\"col-12\">\r\n            <a href=\"https://www.aclu.org/issues/voting-rights/voter-restoration/felony-disenfranchisement-laws-map?redirect=map/state-criminal-re-enfranchisement-laws-map\" target=\"_blank\"class=\"blockLink\">\r\n             <!-- <a href=\"https://www.justice.gov/crt/complaint/votintake/index.php\" target=\"_blank\" class=\"blockLink\">  -->\r\n              <img ng-src=\"./assets/images/felonVoting.svg\" class=\"blockInfoSmallImgSmall img-fluid\">\r\n              <div class=\"blockInfoSmall\">\r\n                <div>\r\n                  <h5 class=\"blockTitle\">AS A FELON, AM I ALLOWED TO VOTE?</h5>\r\n                  <span class=\"blockDesc\">Many states prohibit felons from voting after they have served their time.  The laws are constantly changing.  Chack here to see if it is an issue in your state.</span>\r\n                </div>\r\n              </div>\r\n              </a>\r\n          </div>        </div>\r\n      </div>\r\n							\r\n							\r\n							\r\n          </div>\r\n        </div>\r\n      </div>\r\n        \r\n  \r\n      <div class=\"d-none d-lg-flex\" style=\"width:100%;\">\r\n        <div class=\"col-lg-6\">\r\n\r\n          <div class=\"col-12\">\r\n            <a href=\"https://register.rockthevote.com/registrants/new?partner=1&source=rtv.org-topnav&_ga=2.164445756.285480818.1570202241-1599620056.1570202241\" target=\"_blank\" class=\"blockLink\">\r\n              <img ng-src=\"./assets/images/registerToVote.svg\" class=\"blockInfoSmallImgSmall img-fluid\">\r\n              <div class=\"blockInfoSmall\">\r\n                <div>\r\n                  <h5 class=\"blockTitle\">REGISTER TO VOTE</h5>\r\n                  <span class=\"blockDesc\">This will take you to Rock the Vote\'s voter Registration tools.</span>\r\n                </div>\r\n                  </div>\r\n                 \r\n              </a></div>\r\n\r\n          <div class=\"col-12\">\r\n            <a href=\"#!/checkRegistration\" class=\"blockLink\">\r\n              <img ng-src=\"./assets/images/checkStatus.svg\" class=\"blockInfoSmallImgSmall img-fluid\">\r\n              <div class=\"blockInfoSmall\">\r\n                <div>\r\n                  <h5 class=\"blockTitle\">CHECK REGISTRATION STATUS</h5>\r\n                  <span class=\"blockDesc\">Many states kick you off the voter rolls if you haven\'t voted for awhile.  Use this form to check your status.</span>\r\n                </div>\r\n                  </div>\r\n                 \r\n              </a></div>\r\n          <div class=\"col-12\">\r\n           <a href=\"https://www.vote.org/polling-place-locator/\" target=\"_blank\"class=\"blockLink\">\r\n              <img ng-src=\"./assets/images/findYourPollingPlace.svg\" class=\"blockInfoSmallImgSmall img-fluid\">\r\n              <div class=\"blockInfoSmall\">\r\n                  \r\n                <div>\r\n                  <h5 class=\"blockTitle\">FIND YOUR POLLING PLACE</h5>\r\n                  <span class=\"blockDesc\">Go to this website to look up where you need to go to vote.</span>\r\n                </div>\r\n              </div>\r\n              </a>\r\n          </div>\r\n            \r\n                  <div class=\"col-12\">\r\n           <a href=\"#!/absenteeBallots\" class=\"blockLink\">\r\n              <img ng-src=\"./assets/images/absenteeBallot.svg\" class=\"blockInfoSmallImgSmall img-fluid\">\r\n              <div class=\"blockInfoSmall\">\r\n                  \r\n                <div>\r\n                  <h5 class=\"blockTitle\">ABSENTEE BALLOTS</h5>\r\n                  <span class=\"blockDesc\">If you can\'t physically get to the polls on election day, you can request a mail in ballot in advance.  Every area has their own rules, so make sure you apply early.</span>\r\n                </div>\r\n              </div>\r\n              </a>\r\n          </div>\r\n            \r\n               \r\n                    <div class=\"col-12\">\r\n           <a href=\"#!/getAReminder\" class=\"blockLink\">\r\n              <img ng-src=\"./assets/images/reminder.svg\" class=\"blockInfoSmallImgSmall img-fluid\">\r\n              <div class=\"blockInfoSmall\">\r\n                  \r\n                <div>\r\n                  <h5 class=\"blockTitle\">GET A REMINDER</h5>\r\n                  <span class=\"blockDesc\">Are you scared you\'ll forget to vote?  Get a reminder.</span>\r\n                </div>\r\n              </div>\r\n              </a>\r\n          </div>\r\n            \r\n               \r\n            \r\n            \r\n          <div class=\"col-12\">\r\n            <a href=\"#!/electionProblems\" class=\"blockLink\">\r\n             <!-- <a href=\"https://www.justice.gov/crt/complaint/votintake/index.php\" target=\"_blank\" class=\"blockLink\">  -->\r\n              <img ng-src=\"./assets/images/votingIrregularities.svg\" class=\"blockInfoSmallImgSmall img-fluid\">\r\n              <div class=\"blockInfoSmall\">\r\n                <div>\r\n                  <h5 class=\"blockTitle\">REPORT VOTING PROBLEMS</h5>\r\n                  <span class=\"blockDesc\">Are you having problems on election day?  Did you get turned away at the polls?  Get help here.</span>\r\n                </div>\r\n              </div>\r\n              </a>\r\n          </div>\r\n									\r\n									\r\n									          <div class=\"col-12\">\r\n            <a href=\"https://www.vote.org/early-voting-calendar/\" target=\"_blank\"class=\"blockLink\">\r\n             <!-- <a href=\"https://www.justice.gov/crt/complaint/votintake/index.php\" target=\"_blank\" class=\"blockLink\">  -->\r\n              <img ng-src=\"./assets/images/earlyVoting.svg\" class=\"blockInfoSmallImgSmall img-fluid\">\r\n              <div class=\"blockInfoSmall\">\r\n                <div>\r\n                  <h5 class=\"blockTitle\">CAN I VOTE EARLY?</h5>\r\n                  <span class=\"blockDesc\">Sometimes trying to get off work during polling hours is impossible.  Fortunately, some states have polling stations open on other days before election day, so you can vote early.  Click here to see if and when you have that ability near you.</span>\r\n                </div>\r\n              </div>\r\n              </a>\r\n          </div>\r\n									\r\n												\r\n									          <div class=\"col-12\">\r\n            <a href=\"https://ballotpedia.org/Voter_identification_laws_by_state#tab=Details_by_state\" target=\"_blank\"class=\"blockLink\">\r\n             <!-- <a href=\"https://www.justice.gov/crt/complaint/votintake/index.php\" target=\"_blank\" class=\"blockLink\">  -->\r\n              <img ng-src=\"./assets/images/voterID.svg\" class=\"blockInfoSmallImgSmall img-fluid\">\r\n              <div class=\"blockInfoSmall\">\r\n                <div>\r\n                  <h5 class=\"blockTitle\">DO I NEED AN ID?</h5>\r\n                  <span class=\"blockDesc\">Some states require specific ID\'s in order to vote.  Laws are constantly changing so you should check here.</span>\r\n                </div>\r\n              </div>\r\n              </a>\r\n          </div>\r\n									\r\n														\r\n									\r\n												\r\n									          <div class=\"col-12\">\r\n            <a href=\"https://www.aclu.org/issues/voting-rights/voter-restoration/felony-disenfranchisement-laws-map?redirect=map/state-criminal-re-enfranchisement-laws-map\" target=\"_blank\"class=\"blockLink\">\r\n             <!-- <a href=\"https://www.justice.gov/crt/complaint/votintake/index.php\" target=\"_blank\" class=\"blockLink\">  -->\r\n              <img ng-src=\"./assets/images/felonVoting.svg\" class=\"blockInfoSmallImgSmall img-fluid\">\r\n              <div class=\"blockInfoSmall\">\r\n                <div>\r\n                  <h5 class=\"blockTitle\">AS A FELON, AM I ALLOWED TO VOTE?</h5>\r\n                  <span class=\"blockDesc\">Many states prohibit felons from voting after they have served their time.  The laws are constantly changing.  Chack here to see if it is an issue in your state.</span>\r\n                </div>\r\n              </div>\r\n              </a>\r\n          </div>        </div>\r\n      </div>\r\n\r\n\r\n      <div class=\"col-lg-6\">\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n");
$templateCache.put("app/legislation/legislation.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">LEGISLATION</h2>\r\n  <p class=\"pageSubHeading\"> </p>\r\n  <div class=\"row\">\r\n      <!-- BRING THIS BACK\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <img ng-src=\"./assets/images/legislationColor.svg\" class=\"blockInfoImgLearn img-fluid\">\r\n\r\n        <div id=\"blockInfoLearn3\">\r\n            <div>\r\n              <h4 class=\"blockTitleLearn\">GET INVOLVED WITH LEGISLATION</h4>\r\n              <span class=\"blockDesc\">Find legislation.  Discuss upcoming legislation or see how politicians voted on past legislation. Rate legislation to help guide future decisions.<br><br>State and Federal agencies are not standardized so we had to create separate search tools for each. </span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"newUserLearn\">\r\n          <form class=\"ng-pristine ng-valid\">\r\n            <div>\r\n              <div>\r\n                  <a href=\"#!/viewBills\" class=\"allTopics\"> <img src=\"assets/images/BWstateLegislation.svg\" alt=\"State Legislation\"/><span>State Legislation</span></a>\r\n                  <a href=\"#!/federalBills\" class=\"allTopics\"> <img src=\"assets/images/BWfederalLegislation.svg\" alt=\"Federal Legislation\"/><span>Federal Legislation</span></a>         \r\n              </div>    \r\n              </div></form></div>\r\n      \r\n      -->\r\n      \r\n          <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">    \r\n        <img ng-src=\"./assets/images/legislationColorLearn.svg\" class=\"blockInfoImgLearn img-fluid\">\r\n        <div id=\"blockInfoLearn1\">\r\n            <div>\r\n              <h4 class=\"blockTitleLearn\">LEARN ABOUT HOW LAWS WORK</h4>\r\n              <span class=\"blockDesc\">Find out how laws are created, how the constitution of the USA and of the states work and more. </span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"newUserLearn\">\r\n          <form class=\"ng-pristine ng-valid\">\r\n            <div>\r\n              <div>\r\n                  <a href=\"https://www.youtube.com/watch?v=FFroMQlKiag\" target=\"_blank\" class=\"allTopics\"> <img src=\"assets/images/justABill.svg\" alt=\"Short Video on How a Bill Becomes a Law\"/><span>Short Video on How a Bill Becomes a Law</span></a>\r\n\r\n                  <a href=\"#!/howABillBecomesALaw\" class=\"allTopics\"> <img src=\"assets/images/writtenHowToBill.svg\" alt=\"Detailed Description of How a Bill Becomes a Law\"/><span>Detailed Written Description of How a Bill Becomes a Law</span></a>\r\n\r\n                <a href=\"#!/theConstitution\" class=\"allTopics\"> <img src=\"assets/images/USConstitution.svg\" alt=\"The US Constitution\"/><span>US Constitution and Explanations</span></a>\r\n                  <a href=\"https://ballotpedia.org/State_constitution\" target=\"_blank\" class=\"allTopics\"> <img src=\"assets/images/StateConstitution.svg\" alt=\"State Constitutions\"/><span>State Constitutions</span></a>\r\n              </div>    \r\n              </div></form></div>\r\n      \r\n      \r\n      \r\n    \r\n     \r\n \r\n            \r\n          </div>\r\n          <br><br><br><br>\r\n          <div>\r\n              <h2>OTHER TOOLS</h2>\r\n           <p>   Search for Federal legislation by key words. (This will take you to a Federal site.)</p>\r\n              \r\n              \r\n           <br>   \r\n              \r\n    <p>Search Words: <input ng-model=\"sw1\" class=\"blackText\"><br></p>\r\n   <!-- <p>Search Word 2: <input ng-model=\"sw2\"><br></p>\r\n    <p>Search Word 3: <input ng-model=\"sw3\"></p>\r\n    <center><h1>You entered: {{sw1+\" \"+sw2+\" \"+sw3}}</h1></center>  -->\r\n              \r\n              \r\n            <center>  <a ng-href=\"https://www.congress.gov/quick-search/legislation?wordsPhrases=%22{{sw1}}%22&include=on&wordVariants=on&titles=on&summaries=on&actions=on&congresses%5B%5D=116&legislationNumbers=&legislativeAction=&sponsor=on&cosponsor=on&representative=&senator=&searchResultViewType=compact&KWICView=false\" target=\"_blank\"><button class=\"compareBtn\">Search</button></a></center>\r\n											\r\n										\r\n              \r\n              \r\n              <!--  https://www.congress.gov/quick-search/legislation?wordsPhrases=  -->\r\n              \r\n              <!-- %22keywords%22&wordVariants=on&summaries=on&congresses%5B%5D=115&legislationNumbers=&legislativeAction=&sponsor=on&representative=&senator=&houseCommittee=&senateCommittee=&searchResultViewType=compact   -->\r\n             \r\n              \r\n              \r\n        </div>\r\n      </div>\r\n    </div>\r\n      \r\n     \r\n</div>\r\n    \r\n    \r\n<p><h2>Tracking Legislation</h2>\r\n</p>\r\n<p>Below are some websites that track Federal or State legislation and Congressional voting records.</p>\r\n\r\n<p><a target=\"_blank\"class=\"ylink\"  href=\"https://www.legis.state.pa.us/\"><b>Legis.PA</b></a> is a site run by the Pennsylvania State government that allows you to see when commitee meetings are happening, what they are talking about, votes and more.  You can subscribe to daily notices.</p>\r\n<p><a target=\"_blank\"class=\"ylink\"  href=\"http://www.senate.gov/reference/common/faq/how_to_votes.htm\"><b>THIS</b></a> is a page run by the Federal Government that allows you to see the voting records in Congress.  It is accurate, but lacks analysis, so you will have to read the bills in order to understand what they were voting for.</p>\r\n<p><a target=\"_blank\" class=\"ylink\" href=\"https://openstates.org/\"><b>OpenStates.org</b></a> is a non-profit organization that helps you find out about legislation on the state level.  Their website is pretty decent.</p>\r\n<p><a target=\"_blank\" class=\"ylink\" href=\"https://www.govtrack.us/\"><b>GOVTRACK</b></a> is a civic minded business that tracks legislation and voting records.</p>\r\n<!--\r\n<p><a target=\"_blank\" class=\"ylink\" href=\"http://projects.washingtonpost.com/congress/\"><b>THIS</b></a> is a page run by the Washington Post.  This includes older federal voting records with some analysis and different ways of organizing data.</p>\r\n-->\r\n<p><a target=\"_blank\"class=\"ylink\"  href=\"http://www.congress.org/congressorg/megavote/\"><b>Megavote</b></a> is a system that sends you weekly emails on the voting record of your feeral legislators and upcoming legislation.  It is run by Congress.org, a non-profit organization not affiliated with the government.</p>\r\n");
$templateCache.put("app/listOfInvitedFollowers/listOfFollowers.html","<div class=\"container-fluid\">\r\n  <p ng-if=\"quizName\">\r\n    <b style=\"text-transform: capitalize;\">\"{{quizName}}\"</b> comparison. Please choose which politicians you would like\r\n    to compare.\r\n  </p>\r\n  <center>\r\n    <div class=\"control-group\">\r\n      <label class=\"control-label formLabel whiteText\" for=\"options\">Select Type</label>\r\n      <div class=\"controls\">\r\n        <select ng-model=\"types\" class=\"form-control\" ng-change=\"selectType()\" style=\"width:170px;\">\r\n              <option value=\"\">Select Type</option>\r\n              <option value=\"All\">All</option>\r\n              <option value=\"Invited\">Invited</option>\r\n              <option value=\"unInvited\">unInvited</option>\r\n\r\n            </select>\r\n      </div>\r\n    </div>\r\n  </center>\r\n\r\n  <div class=\"row table-responsive\" style=\"margin-top: 10px;\">\r\n    <table class=\"table w100 changeTextColor\" ng-if=\"polData.length > 0\">\r\n      <tr>\r\n        <th>\r\n          <input type=\"checkbox\" ng-change=\"SelectChecks()\" ng-model=\"isSelected\">\r\n           Select All\r\n        </th>\r\n          <!-- Followers Name -->\r\n        <th>\r\n          <a href=\"\" ng-click=\"orderByField=\'orgName\'; reverseSort = !reverseSort\">\r\n             Politician Name <span ng-show=\"orderByField == \'orgName\'\"><i ng-show=\"!reverseSort\" class=\"fa fa-arrow-circle-up\"></i><i ng-show=\"reverseSort\" class=\"fa fa-arrow-circle-down\"></i>\r\n         </a>\r\n        </th>\r\n        <th>\r\n          Office\r\n        </th>\r\n        <th>\r\n          Location\r\n        </th>\r\n        <th>\r\n          Quiz Name\r\n        </th>\r\n\r\n      </tr>\r\n      <tr ng-repeat=\"u in polData | orderBy:orderByField:reverseSort  track by $index\">\r\n        <td>\r\n          <input type=\"checkbox\" value=\"{{u}}\" ng-model=\"u.isSelected\" ng-click=\"select(u.id,u.quizName,u.name,u)\">\r\n        </td>\r\n\r\n        <td>\r\n          <p ng-if=\"u.name\" style=\"margin: 0;\">\r\n            <a href=\"#!/publicProfile/{{u.id}}\" class=\"link\" style=\"text-transform:capitalize;\">{{u.name}}</a>\r\n          </p>\r\n        </td>\r\n        <td>\r\n          <div ng-if=\"u.politicianInfo && u.politicianInfo.length > 0\">\r\n            <div ng-repeat=\"poli in u.politicianInfo\"> \r\n              \r\n              <div ng-if=\"poli && poli.officeName && poli.officeName !=\'\'\">{{poli.officeName}}</div> \r\n            </div>\r\n          </div>\r\n        </td>\r\n        <td>\r\n          <div ng-if=\"u.politicianInfo && u.politicianInfo.length > 0\">\r\n            <div ng-repeat=\"poli in u.politicianInfo\"> \r\n              <div ng-if=\"poli.runningForOffice == \'Y\'\"> \r\n                <span ng-if=\"poli.runningForOffice == \'Y\'\">Running For Office: </span>\r\n                <span ng-if=\"poli.levelOfGov == \'placeName\'\">{{poli.place}}</span>\r\n               <span ng-if=\"poli.levelOfGov ==\'All USA\'\">the United States</span>\r\n               <span ng-if=\"poli.levelOfGov == \'countyName\'\">{{poli.countyName}}</span>\r\n               <span ng-if=\"poli.levelOfGov == \'statePostalCode\'\">{{poli.state}}</span>\r\n               <span ng-if=\"poli.levelOfGov == \'stateSenateDistrict\'\">{{poli.state}}</span>\r\n               <span ng-if=\"poli.levelOfGov == \'federalCongressionalDistrict\'\">{{poli.state}} <span ng-if=\"poli.federalCongressionalDistrict\"> Federal Congressional District {{poli.federalCongressionalDistrict}}</span>\r\n               </span> ,<span ng-if=\"poli.state\">{{poli.state}}</span>  </span>\r\n              </div>\r\n              <div ng-if=\"poli.incumbent && poli.incumbent !=\'\'\"> \r\n                <span ng-if=\"poli.incumbent && poli.incumbent !=\'\'\">Current Office: </span>\r\n                <span ng-if=\"poli.levelOfGov == \'placeName\'\">{{poli.place}}</span>\r\n               <span ng-if=\"poli.levelOfGov ==\'All USA\'\">the United States</span>\r\n               <span ng-if=\"poli.levelOfGov == \'countyName\'\">{{poli.countyName}}</span>\r\n               <span ng-if=\"poli.levelOfGov == \'statePostalCode\'\">{{poli.state}}</span>\r\n               <span ng-if=\"poli.levelOfGov == \'stateSenateDistrict\'\">{{poli.state}}</span>\r\n               <span ng-if=\"poli.levelOfGov == \'federalCongressionalDistrict\'\">{{poli.state}} <span ng-if=\"poli.federalCongressionalDistrict\"> Federal Congressional District {{poli.federalCongressionalDistrict}}</span>\r\n               </span> </span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </td>\r\n        <td style=\"text-transform: capitalize;\">\r\n          {{u.quizName}}\r\n        </td>\r\n      </tr>\r\n    </table>\r\n\r\n    <div style=\"margin-top: 5%\">\r\n      <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"compare()\">\r\n                           Compare\r\n                          </button>\r\n\r\n    </div>\r\n  </div>\r\n\r\n</div>\r\n");
$templateCache.put("app/liveFeed/liveFeed.html","<div style=\"width: 98%; margin: auto\">\r\n  <div class=\"container-fluid ng-scope\">\r\n    <h2 class=\"pageHeading\">NEWS</h2>\r\n    <p class=\"pageSubHeading\">\r\n      Read live feeds from local, national and international outlets or look up\r\n      upcoming legislation.\r\n    </p>\r\n    <!--     <center>\r\n      <a href=\"#!/essay_press\">\r\n        <button class=\"btnB20\">\r\n          <b>News from Users</b>\r\n        </button>\r\n      </a>\r\n    </center>\r\n\r\n            <center>\r\n      <a href=\"#!/presshome/press\">\r\n        <button class=\"btnB20\">\r\n          <b>Find and Follow Local News Outlets</b>\r\n        </button>\r\n      </a>\r\n    </center>\r\n                <center>\r\n     <!-- <a href=\"#!/calendar\">\r\n        <button class=\"btnB20\">\r\n          <b>Calendar of Events</b>\r\n        </button>\r\n      </a>\r\n    </center>\r\n    <hr style: color=\"black\";>  -->\r\n\r\n    <center>\r\n      <h2><p>Live Feed from {{title}}</p></h2>\r\n    </center>\r\n\r\n    <div style=\"width: 100%; text-align: center\">\r\n      <div class=\"controls\">\r\n        <label class=\"control-label\" for=\"newsChannel\"\r\n          >Change news Source :\r\n        </label>\r\n        <select\r\n          ng-model=\"newsChannel\"\r\n          ng-change=\"changeNewsChannel(newsChannel)\"\r\n          style=\"color: #000\"\r\n        >\r\n          <option\r\n            ng-repeat=\"opt in allSource track by $index\"\r\n            value=\"{{opt.id}}\"\r\n          >\r\n            {{opt.name}}\r\n          </option>\r\n        </select>\r\n      </div>\r\n    </div>\r\n    <p ng-if=\"showLoading\">\r\n      <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i> Loading feeds please\r\n      wait...\r\n    </p>\r\n    <div style=\"text-align: center\" ng-if=\"feed.data.length > 0\">\r\n      <center>\r\n        <input\r\n          type=\"button\"\r\n          ng-click=\"getAllFeeds()\"\r\n          class=\"compareBtn\"\r\n          value=\"Refresh\"\r\n        />\r\n      </center>\r\n    </div>\r\n  </div>\r\n  <div style=\"color: #000\">\r\n    <div\r\n      ng-repeat=\"feed in feed.data\"\r\n      ng-if=\"!showLoading\"\r\n      style=\"\r\n        width: 90%;\r\n        padding: 10px;\r\n        border: solid 1px #000;\r\n        margin: auto;\r\n        position: relative;\r\n        text-align: left;\r\n        margin-top: 2px;\r\n        background-color: #ffffff;\r\n      \"\r\n    >\r\n      <div style=\"width: 100%; position: relative\">\r\n        <h3><a href=\"{{feed.url}}\" target=\"_blank\">{{feed.title}}</a></h3>\r\n      </div>\r\n      <div style=\"width: 100%; position: relative\">\r\n        <img\r\n          ng-if=\"feed.urlToImage\"\r\n          ng-src=\"{{feed.urlToImage}}\"\r\n          style=\"float: left; margin-right: 10px\"\r\n          class=\"news\"\r\n        />\r\n        <p>{{feed.description}}</p>\r\n        <p>\r\n          <b>Source:</b> {{feed.author}},\r\n          <b>Published On:</b> {{feed.publishedAt | date:\'medium\'}}\r\n        </p>\r\n        <!--<p><b>Url:</b> <a href=\"{{feed.url}}\" target=\"_blank\">Check detailed article</a></p> -->\r\n        <div style=\"clear: both\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <br />\r\n</div>\r\n<p>\r\n  <a ng-href=\"https://newsapi.org/\" target=\"_blank\"\r\n    ><center><b> News Feed Powered by NewsAPI.org</b></center></a\r\n  >\r\n</p>\r\n\r\n<br /><br />\r\n<h1><center>Positive news</center></h1>\r\n<center>\r\n  <iframe\r\n    width=\"90%\"\r\n    height=\"402px\"\r\n    src=\"https://feed.mikle.com/widget/v2/126286/?preloader-text=Loading\"\r\n  ></iframe>\r\n</center>\r\n\r\n<br /><br />\r\n<h1><center>Local News</center></h1>\r\n\r\n<center>\r\n  <iframe\r\n    width=\"90%\"\r\n    height=\"800\"\r\n    src=\"https://feed.mikle.com/widget/v2/48569/\"\r\n  ></iframe>\r\n</center>\r\n<br /><br />\r\n\r\n<!--<center>\r\n  <iframe width=\"90%\" height=\"800\" ng-src=\"{{baseApiUrl}}\"></iframe>\r\n</center>\r\n\r\n<!--  BRING THIS BACK\r\n<div class=\"row\">\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <img ng-src=\"./assets/images/legislationColor.svg\" class=\"blockInfoImgLearn img-fluid\">\r\n        <div id=\"blockInfoLearn3\">\r\n            <div>\r\n              <h4 class=\"blockTitleLearn\">GET INVOLVED WITH LEGISLATION</h4>\r\n              <span class=\"blockDesc\">Find legislation.  Discuss upcoming legislation or see how politicians voted on past legislation. Rate legislation to help guide future decisions.<br><br>State and Federal agencies are not standardized so we had to create separate search tools for each. </span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"newUserLearn\">\r\n          <form class=\"ng-pristine ng-valid\">\r\n            <div>\r\n              <div>\r\n                  <a href=\"#!/viewBills\" class=\"allTopics\"> <img src=\"assets/images/BWstateLegislation.svg\" alt=\"State Legislation\"/><span>State Legislation</span></a>\r\n                  <a href=\"#!/federalBills\" class=\"allTopics\"> <img src=\"assets/images/BWfederalLegislation.svg\" alt=\"Federal Legislation\"/><span>Federal Legislation</span></a>\r\n              </div>\r\n              </div></form></div>\r\n</div>\r\n-->\r\n");
$templateCache.put("app/localDebate/localDebate.html","<head>\r\n<title>Debate Local</title>\r\n<!-- This next line keeps buttons and forms at a legible size on cell phones -->\r\n<meta name=\"viewport\" content=\"initial-scale=1, maximum-scale=1\">\r\n</head>\r\n<div>\r\n<p>See and comment on debates between interest groups or politicians.</p>\r\n<a href=\"VoterCreation.html\"> <img src=\"assets/images/politician.svg\" class=\"local\" alt=\"Politicians Debate\"/></a>\r\n<a href=\"VoterCreation.html\"> <img src=\"assets/images/advocate.svg\" class=\"local\" alt=\"Where to get news\"/></a>\r\n\r\n<hr size=\"5\" noshade>\r\n<p><center>OR</center></p>\r\n<hr size=\"5\" noshade>\r\n\r\n<p>Engage in debates and come up with solutions to problems in the subjects you care about.</p>\r\n\r\n<a href=\"NotBuiltYet.html\"> <img src=\"assets/images/civil_liberties.svg\" class=\"allTopics\" alt=\"Civil Liberties\"/></a>\r\n<a href=\"NotBuiltYet.html\"> <img src=\"assets/images/crime_punishment.svg\" class=\"allTopics\" alt=\"Crime and Punishment\"/></a>\r\n<a href=\"NotBuiltYet.html\"><img src=\"assets/images/education.svg\" class=\"allTopics\" alt=\"Education\"/></a>\r\n<a href=\"NotBuiltYet.html\"><img src=\"assets/images/energy.svg\" class=\"allTopics\" alt=\"Energy\"/></a>\r\n<a href=\"NotBuiltYet.html\"> <img src=\"assets/images/environment.svg\" class=\"allTopics\" alt=\"Environment\"/></a>\r\n<a href=\"NotBuiltYet.html\"> <img src=\"assets/images/gun_control.svg\" class=\"allTopics\" alt=\"Gun Control\"/></a>\r\n<a href=\"NotBuiltYet.html\"><img src=\"assets/images/health_safety.svg\" class=\"allTopics\" alt=\"Health & Safety\"/></a>\r\n<a href=\"NotBuiltYet.html\"><img src=\"assets/images/immigration.svg\" class=\"allTopics\" alt=\"Immigration\"/></a>\r\n<a href=\"NotBuiltYet.html\"> <img src=\"assets/images/infrastructure.svg\" class=\"allTopics\" alt=\"Infrastructure\"/></a>\r\n<a href=\"NotBuiltYet.html\"><img src=\"assets/images/international_rel.svg\" class=\"allTopics\" alt=\"International Relations\"/></a>\r\n<a href=\"NotBuiltYet.html\"> <img src=\"assets/images/jobs_economy.svg\" class=\"allTopics\" alt=\"Jobs and Economy\"/></a>\r\n<a href=\"NotBuiltYet.html\"><img src=\"assets/images/quality_of_life.svg\" class=\"allTopics\"alt=\"Quality of Life\"/></a>\r\n<a href=\"NotBuiltYet.html\"><img src=\"assets/images/reproduction.svg\" class=\"allTopics\" alt=\"Reproduction\"/></a>\r\n<a href=\"NotBuiltYet.html\"><img src=\"assets/images/taxes.svg\" class=\"allTopics\" alt=\"Taxes\"/></a>\r\n<a href=\"NotBuiltYet.html\"><img src=\"assets/images/social_services.svg\" class=\"allTopics\" alt=\"Social Services\"/></a>\r\n<a href=\"NotBuiltYet.html\"><img src=\"assets/images/local.svg\" class=\"allTopics\" alt=\"Local Subjects\"/></a>\r\n");
$templateCache.put("app/localPress/localPress.html","<head>\r\n<title>Local Press</title>\r\n <!-- This next line keeps buttons and forms at a legible size on cell phones -->\r\n<meta name=\"viewport\" content=\"initial-scale=1, maximum-scale=1\">\r\n</head>\r\n<div>\r\n\r\n<p><h1><center>News</center></h1></p>\r\n<center><form action=\"PressList.html\">\r\n    <input type=\"submit\" value=\"Review/Choose News Sources\">\r\n</form></center>\r\n\r\n<!-- This is the Start of the subject assets/images -->\r\n<a href=\"NotBuiltYet.html\"> <img src=\"assets/images/civil_liberties.svg\" class=\"allTopics\" alt=\"Civil Liberties\"/></a>\r\n<a href=\"NotBuiltYet.html\"> <img src=\"assets/images/crime_punishment.svg\" class=\"subjects\" alt=\"Crime and Punishment\"/></a>\r\n<a href=\"NotBuiltYet.html\"><img src=\"assets/images/education.svg\" class=\"subjects\" alt=\"Education\"/></a>\r\n<a href=\"NotBuiltYet.html\"><img src=\"assets/images/energy.svg\" class=\"subjects\" alt=\"Energy\"/></a>\r\n<a href=\"NotBuiltYet.html\"> <img src=\"assets/images/environment.svg\" class=\"subjects\" alt=\"Environment\"/></a>\r\n<a href=\"NotBuiltYet.html\"> <img src=\"assets/images/gun_control.svg\" class=\"subjects\" alt=\"Gun Control\"/></a>\r\n<a href=\"NotBuiltYet.html\"><img src=\"assets/images/health_safety.svg\" class=\"subjects\" alt=\"Health & Safety\"/></a>\r\n<a href=\"NotBuiltYet.html\"><img src=\"assets/images/immigration.svg\" class=\"subjects\" alt=\"Immigration\"/></a>\r\n<a href=\"NotBuiltYet.html\"> <img src=\"assets/images/infrastructure.svg\" class=\"subjects\" alt=\"Infrastructure\"/></a>\r\n<a href=\"NotBuiltYet.html\"><img src=\"assets/images/international_rel.svg\" class=\"subjects\" alt=\"International Relations\"/></a>\r\n<a href=\"NotBuiltYet.html\"> <img src=\"assets/images/jobs_economy.svg\" class=\"subjects\" alt=\"Jobs and Economy\"/></a>\r\n<a href=\"NotBuiltYet.html\"><img src=\"assets/images/quality_of_life.svg\" class=\"subjects\"alt=\"Quality of Life\"/></a>\r\n<a href=\"NotBuiltYet.html\"><img src=\"assets/images/reproduction.svg\" class=\"subjects\" alt=\"Reproduction\"/></a>\r\n<a href=\"NotBuiltYet.html\"><img src=\"assets/images/taxes.svg\" class=\"subjects\" alt=\"Taxes\"/></a>\r\n<a href=\"NotBuiltYet.html\"><img src=\"assets/images/social_services.svg\" class=\"subjects\" alt=\"Social Services\"/></a>\r\n<a href=\"NotBuiltYet.html\"><img src=\"assets/images/rate_topics.svg\" class=\"subjects\" alt=\"Rate the Subjects\"/></a>\r\n<a href=\"NotBuiltYet.html\"><img src=\"assets/images/local.svg\" class=\"subjects\" alt=\"Local Subjects\"/></a>\r\n");
$templateCache.put("app/manageOrganizationQuestion/manageOrganizationQuestions.html","<div class=\"container-fluid\" ng-cloak ng-show=\"$root.userRole==\'admin\'|| $root.userRole==\'advocate\'\">\r\n    <h3 class=\"hideNonCell\" style=\"color:yellow;\">This page was designed for a desktop screen.  Trying to use it on a cell phone can be... challenging.</h3>\r\n  <h2 class=\"pageHeading\">CREATE QUIZ</h2>\r\n  <p class=\"pageSubHeading noPaddBott\">Select questions from any of our many topics to create your own quiz. You can\r\n    make your quiz as long as you want and have it involve questions from as many catagories as you want. After you are\r\n    done adding questions, you can go to another page to order them however you want.</p>\r\n  <div class=\"closeForm\" ng-include=\"\'app/popups/manageOrgQuestions.html\'\"></div>\r\n</div>\r\n<div><center>\r\n  <a href=\"#!/allQuizzes\" class=\"btn\">\r\n                  Edit/Manage Your Quizzes\r\n              </a></center></div>\r\n");
$templateCache.put("app/manageQuestions/manageQuestions.html","<div class=\"container-fluid ng-scope\" ng-cloak ng-show=\"$root.userRole==\'admin\'|| $root.userRole==\'advocate\'\">\r\n  <h2 class=\"pageHeading\">Settings</h2>\r\n  <div>\r\n      <div class=\"closeForm\" ng-include=\"\'app/popups/setting_Ctrl.html\'\"></div>\r\n  </div>\r\n  <div class=\"closeForm\" ng-include=\"\'app/popups/manage_questions.html\'\"></div>\r\n</div>\r\n");
$templateCache.put("app/match/match.html","\r\n  <style type=\"text/css\">\r\n    .button_width{\r\n      width: 300px;\r\n      display: inline-block;\r\n    }\r\n    .leftJustified {text-align: left;}\r\n    .rightJustified {text-align: right;}\r\n    body{background-color: #ccccff}\r\n\r\n    table {\r\n      width: 100%;\r\n    }\r\n\r\n    img {\r\n      width: 10%;\r\n      min-width: 10px;\r\n      max-width: 300px;\r\n    } \r\n    a img:hover, .arrow-left-wrapper:hover, .arrow-right-wrapper:hover {\r\n      transform:scale(1.1);\r\n    }\r\n    a img:active, .arrow-left-wrapper:active, .arrow-right-wrapper:active {transform:scale(1.5);}\r\n    .votewise {width:20%; max-width:600px;}\r\n    .local{width:23%; max-width:600px; min-width:150px}\r\n   \r\n    .submit {width:100%;}\r\n    .back {width:60%;}\r\n\r\n    .cap_first::first-letter { \r\n      font-size: 120%;\r\n    }\r\n\r\n    .round-button{\r\n      padding: 5px;\r\n      border: 2px solid #000;\r\n      border-radius: 5px;\r\n      background-color: #aeaef8;\r\n      color: #000;\r\n      font-weight: bold;\r\n      font-size: 12px;\r\n      text-align: center;\r\n      min-width: 140px;\r\n    }\r\n    \r\n\r\n    .arrow-left-wrapper{\r\n      position: relative;\r\n      width: 150px;\r\n      height: 80px;\r\n      float: left;\r\n    }\r\n    .arrow-right-wrapper{\r\n      position: relative;\r\n      width: 150px;\r\n      height: 80px;\r\n      float: right; \r\n    }\r\n    .arrow-left{\r\n      width: 0;\r\n      height: 0;\r\n      border-top: 40px solid transparent;\r\n      border-bottom: 40px solid transparent;\r\n      border-right: 150px solid #2e3192;\r\n      color: #fff;\r\n      line-height: 0;\r\n      position: absolute;\r\n      top: 0;\r\n      left: 0;\r\n      z-index: 1;\r\n    }\r\n\r\n    .arrow-right{\r\n      width: 0;\r\n      height: 0;\r\n      border-top: 40px solid transparent;\r\n      border-bottom: 40px solid transparent;\r\n      border-left: 150px solid #2e3192;\r\n      color: #fff;\r\n      line-height: 0;\r\n      position: absolute;\r\n      top: 0;\r\n      left: 0;\r\n      z-index: 1;\r\n    }\r\n    .arrow-right-txt{\r\n      position: absolute;\r\n      line-height: 80px;\r\n      text-align: left;\r\n      width: 140px;\r\n      padding-left: 10px;\r\n      color: #fff;\r\n      z-index: 2;\r\n      font-size: 20px;\r\n      font-weight: bold;\r\n    }\r\n    .arrow-left-txt{\r\n      position: absolute;\r\n      line-height: 80px;\r\n      text-align: right;\r\n      width: 140px;\r\n      padding-right: 10px;\r\n      color: #fff;\r\n      z-index: 2;\r\n      font-size: 20px;\r\n      font-weight: bold;\r\n    }\r\n\r\n    .clk{\r\n      cursor: pointer;\r\n    }\r\n    .rel{\r\n      position: relative;\r\n    }\r\n    .abs{\r\n      position: absolute;\r\n    }\r\n\r\n    .w33_33{\r\n      width: 33.33%;\r\n    }\r\n  </style>\r\n\r\n  <div class=\"pad10\"> \r\n    <div ng-show=\"state == \'question\'\">\r\n      <span>Compare Answers</span>\r\n      <select ng-model=\"compare_with\" ng-change=\"compareChanged(compare_with)\">\r\n        <option value=\"politician\">Politician</option>\r\n        <option value=\"voter\">Voter</option>\r\n        <option value=\"press\">Press</option>\r\n        <option value=\"advocate\">Advocate</option>\r\n      </select>\r\n    </div>\r\n\r\n    <p>{{category.title}}</p>\r\n    <p></p><center><h2>BACKGROUND</h2></center><p></p>\r\n    <p>{{category.description}}</p>\r\n    <br>\r\n\r\n    <div ng-show=\"state == \'question\'\">\r\n      <div ng-show=\"questions[currentIndex]\"> \r\n        <!-- <type=\"button\" value=\"LEARN MORE\"> -->\r\n        <p></p><center><h2>QUESTION</h2></center><p></p>\r\n        <p></p><center>({{currentIndex+1}} of {{questions.length}})</center><p></p>\r\n\r\n        <p>STATEMENT: <span class=\"card-text\" ng-bind-html=\"questions[currentIndex].content | newlines\"></span></p>\r\n     Your Answers<span  style=\"margin-left: 30px;\">Their Answers</span>   \r\n\r\n        <div class=\"flex\">\r\n          <div class=\"margin-auto mxw\">\r\n            <div class=\"vi-container clearfix\">\r\n              <div class=\"clearfix hori-line\">\r\n                <div class=\"radio-container-arrow\">\r\n                  <div class=\"arrow-down\"></div>\r\n                </div>\r\n\r\n                <div class=\"radio-lbl-left cap_first\">AGREE</div>\r\n                <div class=\"radio-lbl-right cap_first\">DISAGREE</div>\r\n\r\n                <div class=\"radio-container\">\r\n                    <div class=\"box\">\r\n                      <ul class=\"vi-radio\">\r\n                        <li>\r\n                          <input type=\"radio\" id=\"agreedisagree-id1\" name=\"agreeDisagree\" value=\"1\" ng-model=\"answer\">\r\n                          <label for=\"agreedisagree-id1\"></label>\r\n                          <div class=\"check\"></div>\r\n                        </li>\r\n                      </ul>\r\n                    </div>\r\n                    <div class=\"box\">\r\n                      <ul class=\"vi-radio\">\r\n                        <li>\r\n                          <input type=\"radio\" id=\"agreedisagree-id2\" name=\"agreeDisagree\" value=\"2\" ng-model=\"answer\">\r\n                          <label for=\"agreedisagree-id2\"></label>\r\n                          <div class=\"check\"></div>\r\n                        </li>\r\n                      </ul>\r\n                    </div>\r\n                    <div class=\"box\">\r\n                      <ul class=\"vi-radio\">\r\n                        <li>\r\n                          <input type=\"radio\" id=\"agreedisagree-id3\" name=\"agreeDisagree\" value=\"3\" ng-model=\"answer\">\r\n                          <label for=\"agreedisagree-id3\"></label>\r\n                          <div class=\"check\"></div>\r\n                        </li>\r\n                      </ul>\r\n                    </div>\r\n                    <div class=\"box\">\r\n                      <ul class=\"vi-radio\">\r\n                        <li>\r\n                          <input type=\"radio\" id=\"agreedisagree-id4\" name=\"agreeDisagree\" value=\"4\" ng-model=\"answer\">\r\n                          <label for=\"agreedisagree-id4\"></label>\r\n                          <div class=\"check red\"></div>\r\n                        </li>\r\n                      </ul>\r\n                    </div>\r\n                    <div class=\"box\">\r\n                      <ul class=\"vi-radio\">\r\n                        <li>\r\n                          <input type=\"radio\" id=\"agreedisagree-id5\" name=\"agreeDisagree\" value=\"5\" ng-model=\"answer\">\r\n                          <label for=\"agreedisagree-id5\"></label>\r\n                          <div class=\"check red\"></div>\r\n                        </li>\r\n                      </ul>\r\n                    </div>\r\n                    <div class=\"box\">\r\n                      <ul class=\"vi-radio\">\r\n                        <li>\r\n                          <input type=\"radio\" id=\"agreedisagree-id6\" name=\"agreeDisagree\" value=\"6\" ng-model=\"answer\">\r\n                          <label for=\"agreedisagree-id6\"></label>\r\n                          <div class=\"check red\"></div>\r\n                        </li>\r\n                      </ul>\r\n                    </div>\r\n                    <span class=\"stretch\"></span>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <br>\r\n            <ul class=\"vi-radio\" style=\"width: 100%; font-size: 12px;\">\r\n              <li ng-click=\"notAnswerableSelected()\">\r\n                <input type=\"radio\" id=\"agreedisagree-id0\" name=\"agreeDisagree\" value=\"0\" ng-model=\"answer\">\r\n                <label for=\"agreedisagree-id0\" style=\"color: #000; padding-left: 35px;\"> This question is not answerable </label>\r\n                <div class=\"check\"></div>\r\n              </li>\r\n            </ul>\r\n            \r\n\r\n            <br>\r\n\r\n            <div class=\"vi-container clearfix\">\r\n              <div class=\"clearfix hori-line\">\r\n              <div class=\"radio-lbl-center cap_first\">IMPORTANCE</div>\r\n\r\n                <div class=\"radio-lbl-left cap_first\">SOMEWHAT</div>\r\n                <div class=\"radio-lbl-right cap_first\">VERY</div>\r\n\r\n                <div class=\"radio-container\">\r\n                    <div class=\"box\">\r\n                      <ul class=\"vi-radio\">\r\n                        <li>\r\n                          <input type=\"radio\" id=\"importance-id1\" name=\"importance\" value=\"1\" ng-model=\"importance\">\r\n                          <label for=\"importance-id1\"></label>\r\n                          <div class=\"check\"></div>\r\n                        </li>\r\n                      </ul>\r\n                    </div>\r\n                    <div class=\"box\">\r\n                      <ul class=\"vi-radio\">\r\n                        <li>\r\n                          <input type=\"radio\" id=\"importance-id2\" name=\"importance\" value=\"2\" ng-model=\"importance\">\r\n                          <label for=\"importance-id2\"></label>\r\n                          <div class=\"check\"></div>\r\n                        </li>\r\n                      </ul>\r\n                    </div>\r\n                    <div class=\"box\">\r\n                      <ul class=\"vi-radio\">\r\n                        <li>\r\n                          <input type=\"radio\" id=\"importance-id3\" name=\"importance\" value=\"3\" ng-model=\"importance\">\r\n                          <label for=\"importance-id3\"></label>\r\n                          <div class=\"check\"></div>\r\n                        </li>\r\n                      </ul>\r\n                    </div>\r\n                    <span class=\"stretch\"></span>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n\r\n            <br>\r\n\r\n            <div class=\"vi-container clearfix\">\r\n              <textarea ng-model=\"comment\" class=\"vi-textarea\" placeholder=\"ADD COMMENTS\"></textarea>\r\n            </div>\r\n            <br>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div ng-show=\"questions.length > 0\" class=\"clearfix pad10 flex\">\r\n        <div class=\"margin-auto mxw\">\r\n          <div class=\"clearfix\">\r\n            <div class=\"arrow-left-wrapper clk\" ng-click=\"prevQuestion()\">\r\n              <div class=\"arrow-left-txt cap_first\">\r\n                BACK\r\n              </div>\r\n              <div class=\"arrow-left\"></div>\r\n            </div>\r\n\r\n            <div class=\"arrow-right-wrapper clk\" ng-click=\"submitAnswer()\">\r\n              <div class=\"arrow-right-txt cap_first\">\r\n                SUBMIT\r\n              </div>\r\n              <div class=\"arrow-right\"></div>\r\n            </div>\r\n          </div>\r\n          <br>\r\n          <br>\r\n          <br>\r\n          <div class=\"clearfix\">\r\n            <div class=\"round-button pull-left clk\" ng-click=\"reportQuestion()\">REPORT QUESTION</div>\r\n            <div class=\"round-button pull-right clk\" ng-click=\"skipQuestion()\">SKIP QUESTION</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    \r\n\r\n    <div ng-show=\"state == \'question-compare\'\">\r\n      <div ng-show=\"questions[currentIndex]\"> \r\n        <!-- <type=\"button\" value=\"LEARN MORE\"> -->\r\n        <p></p><center><h2>QUESTION</h2></center><p></p>\r\n        <p></p><center>({{currentIndex+1}} of {{questions.length}})</center><p></p>\r\n\r\n        <p>STATEMENT: <span class=\"card-text\" ng-bind-html=\"questions[currentIndex].content | newlines\"></span></p>\r\n        \r\n\r\n        <div class=\"clearfix\">\r\n            <div class=\"pull-left ans-col\" style=\"border-right: 3px solid #de8998;\">\r\n              <div class=\"pad10\">\r\n                <div class=\"clearfix\" style=\"line-height: 9px\">\r\n                  <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\">\r\n                    <span class=\"inl-blk\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span> \r\n                    <span class=\"inl-blk\" ng-if=\"i == 6\">DISAGREE</span>\r\n                    <div class=\"cq-box inl-blk pull-right\" ng-class=\"(questions[currentIndex].my_answer.answer == i) ? (\'ag-dg\'+i) : \'\'\"></div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"clearfix\">\r\n                  <div class=\"mb5 clearfix\"><br>\r\n                    <div class=\"inl-blk pull-right\">MATCH %</div>\r\n                  </div>\r\n                </div><br>\r\n                <div class=\"clearfix\" style=\"line-height: 9px\">\r\n                  <p>IMPORTANCE</p>\r\n                  <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\">\r\n                    <span class=\"inl-blk\" ng-if=\"i == 1\">Very</span> \r\n                    <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span> \r\n                    <span class=\"inl-blk\" ng-if=\"i == 3\">Not Very</span>\r\n                    <div class=\"cq-box inl-blk pull-right \" ng-class=\"(questions[currentIndex].my_answer.importance == i) ? \'ag-dg\' : \'\'\"></div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"clearfix\"><br>\r\n                  <p>COMMENTS</p>\r\n                  <div class=\"mb5 clearfix\">\r\n                    <div class=\"inl-blk pull-right\">\r\n                      <span ng-if=\"!(questions[currentIndex].my_answer.comment | isBlankString)\">READ</span>\r\n                      <span ng-if=\"questions[currentIndex].my_answer.comment | isBlankString\">None</span>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"clearfix vtxt-wrap pad10\">\r\n                \r\n                \r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"pull-left ans-col\" ng-repeat=\"ans in questions[currentIndex].answers\">\r\n              <div class=\"pad10\">\r\n                <div class=\"clearfix\" style=\"height: 120px;\">\r\n                  <div ng-if=\"ans.answer > -1\" ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\">\r\n                    <div class=\"cq-box inl-blk pull-right\" ng-class=\"(ans.answer == i) ? (\'ag-dg\'+i) : \'\'\"></div>\r\n                  </div>\r\n                  <div ng-if=\"!ans.answer\" class=\"flex w100 h100\">\r\n                    <div class=\"margin-auto fwb\">N/A</div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"clearfix\" style=\"height: 32px;\">\r\n                  <div class=\"mb5 clearfix\"><br>\r\n                    <div ng-if=\"ans.match\" class=\"inl-blk pull-right\">{{ans.match}}%</div>\r\n                    <div ng-if=\"!ans.match\" class=\"w100 text-center fwb\">N/A</div>\r\n                  </div>\r\n                </div><br>\r\n                <div class=\"clearfix\" style=\"height: 111px;\">\r\n                  <p>&nbsp;</p>\r\n                  <div ng-if=\"ans.importance\" ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\">\r\n                    <div class=\"cq-box inl-blk pull-right \" ng-class=\"(ans.importance == i) ? \'ag-dg\' : \'\'\"></div>\r\n                  </div>\r\n                  <div ng-if=\"!ans.importance\" class=\"w100 h100 flex\">\r\n                    <div class=\"fwb margin-auto\">N/A</div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"clearfix\">\r\n                  <p>&nbsp;</p>\r\n                  <div class=\"mb5 clearfix\">\r\n                    <span ng-if=\"ans.comment && !(ans.comment | isBlankString)\">READ</span>\r\n                    <span ng-if=\"ans.comment && (ans.comment | isBlankString)\">No</span>\r\n                    <span ng-if=\"!ans.comment\" class=\"fwb\">N/A</span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"clearfix vtxt-wrap pad10\">\r\n                <div class=\"ver-txt\">{{ans.author.name}}</div>\r\n              </div>\r\n            </div>\r\n        </div>\r\n      <div class=\"mb5 clearfix print-hide\">\r\n              <!-- <a class=\"clk fwb\" ng-click=\"prevQuestion()\">Prev</a>&nbsp;\r\n                  <a class=\"clk fwb\" ng-click=\"skipQuestion()\">Next</a> -->\r\n              <button class=\"compareBtnS\" ng-click=\"prevQuestion()\"><i class=\"fa fa-angle-left arrowIconBack\"></i>Prev</button>\r\n              <button class=\"compareBtnS\" ng-click=\"skipQuestion()\">Next<i class=\"fa fa-angle-right arrowIconSubmit\"></i></button>\r\n            </div>\r\n         <div ng-show=\"questions.length <= 0 && status.questions == 2\" class=\"mb5 clearfix print-hide\">\r\n              <!-- <a class=\"clk fwb\" ng-click=\"prevQuestion()\">Prev</a>&nbsp;\r\n                  <a class=\"clk fwb\" ng-click=\"skipQuestion()\">Next</a> -->\r\n              <button class=\"compareBtnS\" ng-click=\"prevQuestion()\"><i class=\"fa fa-angle-left arrowIconBack\"></i>Prev</button>\r\n              <button class=\"compareBtnS\" ng-click=\"skipQuestion()\">Next<i class=\"fa fa-angle-right arrowIconSubmit\"></i></button>\r\n            </div>\r\n    </div>\r\n\r\n\r\n    <div ng-if=\"questions.length == 0\">\r\n      No questions found in this category.\r\n    </div>\r\n  </div>\r\n");
$templateCache.put("app/newEssay/dialogGallery.html","\r\n<p></p>\r\n<h1><center>Upload Media</center></h1>\r\n<p></p>\r\n<div>\r\n	<ul style=\"padding:0; height:50px;\">\r\n	<li class=\"liclass lispecial\" ng-click=\"ChangeMedia(\'U\');\" ><div>Upload Media</div></li>\r\n	<li class=\"liclass\" style=\"width:1%; height:50px;\">|</li>\r\n	<li class=\"liclass lispecial\" ng-click=\"ChangeMedia(\'G\');\"><div>Gallery</div></li>\r\n	</ul>\r\n	<div ng-if=\"uploadMedia\">\r\n		<form name=\"topicform\" id=\"topicform\">\r\n            <fieldset class=\"scheduler-border\">\r\n                <legend class=\"scheduler-border\">Upload file</legend>\r\n                <p><small>File size should not be greater than 1MB.</small></p>\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-12\">\r\n                        <div class=\"control-group\">\r\n                            \r\n                            <div class=\"controls\"><input type=\"file\" file-model=\"uploads.files\" check-file-size=\"\" class=\"form-control input-md text-input\" accept=\"image/x-png, image/gif, image/jpeg, image/jpeg, image/svg+xml\">\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"control-group\" style=\"margin-top:15px; margin-bottom:10px;\" >\r\n                            \r\n                            <div class=\"controls\"><input type=\"button\" ng-click=\"uploadFile();\" value=\"Upload File\">\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </fieldset>\r\n        </form>\r\n	</div>\r\n	<div ng-if=\"Gallery\"> \r\n	<p ng-if=\"MainGallery.length > 0\">\r\n		<p>Select the file then select the url from textbox to insert it in the Description</p>\r\n		<p ng-if=\"ShowPath\">Use Ctrl+C to copy from text box<input type=\"text\" ng-model=\"uploads.path\" style=\"width:100%;\"></p>\r\n		<div style=\"width:100%; max-height: 350px; overflow: scroll;\">\r\n			<span ng-repeat=\"img in MainGallery\" style=\"cursor: pointer; padding:10px;\" ng-click=\"ShowSelectedPath(img.fileName);\"><img src=\"{{GalleryFolder}}/{{img.fileName}}\" style=\"width:100px;\" /></span>\r\n\r\n		</div>\r\n	</p>\r\n	<p ng-if=\"MainGallery.length == 0\">\r\n		There are no files uploaded by you. Click on \"Upload Media\" tab to upload files.\r\n	</p>\r\n	</div>\r\n</div>");
$templateCache.put("app/newEssay/newEssay.html","<div class=\"container-fluid ng-scope\" ng-cloak ng-show=\"$root.userRole==\'admin\'|| $root.userRole==\'advocate\'\">\r\n\r\n  <h2 class=\"pageHeading\">POST ESSAYS AND VIDEOS</h2>\r\n  <p class=\"pageSubHeading\">Write essays or post links to web pages or videos. </p>\r\n	<p class=\"pageSubHeading\" ><h3><center>RULES</center></h3>\r\n	<ul>\r\n		<li>No hate speach.</li>\r\n		<li>Try to be factually accurate</li>\r\n		<li>No spamming - do not repost the same or essentially the same material again and again.</li>\r\n	</ul>If you violate these rules, your posts will be removed and your rights to post will be taken away.</p>\r\n  <p></p>\r\n  <center>\r\n    <div class=\"inline2\">\r\n      <form name=\"topicform\" id=\"topicform\" style=\"position: relative;\">\r\n        <fieldset class=\"scheduler-border\">\r\n          <legend class=\"scheduler-border\">Essay details</legend>\r\n          <p></p>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label\" for=\"title\">Title</label>\r\n                <div class=\"controls\">\r\n                  <input type=\"text\" ng-model=\"Essay.title\" id=\"titleOne\" name=\"titleOne\" placeholder=\"\" data-errormessage=\"Title is required.\" style=\"width:50%;\" class=\"form-control input-md  validate[required] text-input\">\r\n              </div>\r\n                </div><br>\r\n                <div class=\"control-group\">\r\n                  <div class=\"control-label\">Select Tags</div>\r\n                  <div class=\"col-12 col-md-6\">Your posts are organized by topic so others can easily find them. The\r\n                    categories and subcategories are the same as in all our other tools, so we reccommend taking a few\r\n                    minute to look them over. You can create a default list of tags in your profile settings so that if\r\n                    you post about the same topics a lot, all you have to do is hit \"load default tags.\" Loading default\r\n                    tags sweeps the slate clean and puts down your defaults. So, if you are going to use that button,\r\n                    use it first and then add or subtract from the list it creates.</div><br>\r\n                  <div class=\"control-label\"\r\n                    ng-if=\"subtopics.subcategories.length > 0 && uData.subject_of_deep_interest.length > 0\">\r\n                    <button class=\"tfbuttonNew\" type=\"button\" ng-click=\"loadDefaultTags();\">Load your default tags</button>\r\n                  </div>\r\n                  <div class=\"DisplayCat changeTextColor\">\r\n                    <div style=\"background-color: #eee; padding:5px;\">All Tags\r\n                      <br><small>(click to select)</small></div>\r\n                    <div ng-repeat=\"subent in subtopics.subcategories track by $index\" ng-include=\"\'field_renderer\'\">\r\n                      Loading...</div>\r\n                    <div ng-if=\"subtopics.subcategories.length == 0\" class=\"loadingSpinner\">\r\n                      <i class=\"fa fa-refresh fa-spin fa-3x fa-fw\"></i>\r\n                    </div>\r\n                  </div>\r\n\r\n                  <div class=\"DisplayCat changeTextColor\">\r\n                    <div style=\"background-color: #eee; padding:5px;\">Selected Tags\r\n                      <br><small>(click to remove)</small></div>\r\n                    <ul class=\"TcatList\">\r\n                      <li ng-repeat=\"subent in selectedCat track by $index\">\r\n                        <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                      <input type=\"checkbox\" ng-click=\"removeVal(subent)\" name=\"checkedidcat\" ng-model=\"selectedAll.id[$index]\" ng-checked=\"\'true\'\"> {{subent.title}}\r\n                    </label>\r\n                      </li>\r\n                    </ul>\r\n                  </div>\r\n                  <div style=\"clear:both;\"></div>\r\n                  <br/>\r\n\r\n                  <!--\r\n                            <multi-select ng-model=\"Essay.subcategories\" available=\"subtopics\" selected-label=\"Selected subtopics\" available-label=\"All subtopics\" display=\"r as r.title\" title=\"r as r.title\" config=\"selectConfig\"></multi-select>\r\n                            <div class=\"input-error\" ng-show=\"selectForm.numSelected.$error.min\">\r\n                                Please select at least\r\n                                <ng-pluralize count=\"selectConfig.requiredMin\" when=\"{\'one\': \'one role\', \'other\': \'{} roles\'}\">.\r\n                            </div>\r\n                            <input type=\"hidden\" id=\"reqMin\" ng-model=\"selectConfig.requiredMin\" min=\"1\">\r\n                            -->\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <div class=\"control-label\">Select Locations</div>\r\n                  <div class=\"col-12 col-md-6\">If you focus on local issues, then we highly recommend marking those\r\n                    locations. Otherwise, choose National.</div><br>\r\n                  <div class=\"control-label\" ng-if=\"uData.location_of_interest.length > 0\">\r\n                    <button class=\"tfbuttonNew\" type=\"button\" ng-click=\"loadDefaultLocations();\">Load your default Location</button>\r\n                  </div>\r\n                  <div class=\"DisplayCat changeTextColor\">\r\n                    <div style=\"background-color: #eee; padding:5px;\">Choose Location\r\n                      <br><small>(click to select)</small></div>\r\n                    <ul class=\"TcatList\">\r\n                      <li style=\"padding-bottom:10px;\">\r\n\r\n                        <input type=\"checkbox\" ng-change=\"getLocations(Essay.Locations, \'International\')\" ng-model=\"Essay.Locations\" ng-true-value=\"\'International\'\" ng-false-value=\"\'NO\'\">\r\n                        <label ng-click=\"ShowAddLocation();\">International&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i></label>\r\n                        <div style=\"padding-left:20px;\" ng-if=\"AddLocation\">\r\n                          <div mass-autocomplete>\r\n                            <input ng-model=\"newlocation.country\" mass-autocomplete-item=\"autocomplete_options\">\r\n                      </div>\r\n                            <div style=\"text-align: right;\">\r\n                              <button ng-click=\"AddCountry();\">Add country</button>\r\n                            </div>\r\n                          </div>\r\n                      </li>\r\n                      <li>\r\n                        <input type=\"checkbox\" ng-model=\"Essay.National\"  ng-change=\"getLocations(Essay.National, \'National\')\" ng-true-value=\"\'National\'\" ng-false-value=\"\'NO\'\">\r\n                        <label>National</label>\r\n                      \r\n                        <ul class=\"TcatList\">\r\n                          <li ng-repeat=\"area in allLocations track by $index\">\r\n                            <input type=\"checkbox\" ng-click=\"getAreaVal(area, area.state, \'state\')\" ng-disabled=\"checkDisabled(area, area.state, \'state\')\" ng-checked=\"checkDisabled(area, area.state, \'state\')\">\r\n                            <label ng-click=\"getCounties(area.stateFips)\">{{area.state}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoading.indexOf(area.stateFips)==-1\"></i> <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoading.indexOf(area.stateFips) > -1\"></i></label>\r\n                            <!-- Display Counties -->\r\n                            <ul class=\"TcatList\">\r\n                              <li\r\n                                ng-repeat=\"county in allCounties[area.stateFips] | orderBy:\'countyName\' track by $index\">\r\n                                <input type=\"checkbox\" ng-click=\"getAreaVal(county, area.state, \'county\')\" ng-disabled=\"checkDisabled(county, area.state, \'county\')\" ng-checked=\"checkDisabled(county, area.state, \'county\')\">\r\n                                <label ng-click=\"getLocals(area.stateFips, county.countyFips)\">{{county.countyName}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoadingCounty.indexOf(county.county) == -1\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingCounty.indexOf(county.county) > -1\"></i></label>\r\n                                <!-- Display Locals and sub counties -->\r\n                                <ul class=\"TcatList\" ng-if=\"Essay.location!=\'National\'\">\r\n                                  <li\r\n                                    ng-repeat=\"local in allLocals[area.stateFips][county.countyFips] | orderBy:\'placeName\'  track by $index\">\r\n                                    <label class=\"checkbox\" title=\"{{local.place}}\">\r\n                                  <input type=\"checkbox\" ng-click=\"getAreaVal(local, area.state, \'local\')\" ng-disabled=\"disabledLocation.indexOf(local) > -1 ? true : false\" ng-checked=\"disabledLocation.indexOf(local) > -1 ? true : false\"> {{local.placeName}}\r\n                                </label>\r\n                                  </li>\r\n                                </ul>\r\n                                <!-- Display Locals and sub counties End -->\r\n                              </li>\r\n                            </ul>\r\n                            <!-- Display Counties End -->\r\n                          </li>\r\n                        </ul>\r\n                      </li>\r\n                    </ul>\r\n                  </div>\r\n\r\n                  <div class=\"DisplayCat changeTextColor\">\r\n                    <div style=\"background-color: #eee; padding:5px;\">Selected Location\'s\r\n                      <br><small>(click to remove)</small></div>\r\n                    <ul class=\"TcatList\">\r\n                      <li ng-repeat=\"area in selectedArea track by $index\">\r\n\r\n                        <label class=\"checkbox\" title=\"{{area}}\">\r\n                      <input type=\"checkbox\" ng-click=\"removeAreaVal(area)\" name=\"checkedid\" ng-model=\"selectedLAll.id[$index]\" ng-checked=\"true\"> <span ng-if=\"area.country && (!(area.state) && !(area.county) && !(area.countySubdivision) && !(area.place))\">{{area.country}}</span> <span ng-if=\"area.state && (!(area.county) && !(area.countySubdivision) && !(area.place))\">{{area.state}}</span><span ng-if=\"area.county && (!(area.countySubdivision) && !(area.place))\">{{area.county}}</span><span ng-if=\"area.countySubdivision\">{{area.countySubdivision}}</span><span ng-if=\"area.place\"> - {{area.place}}</span>\r\n                    </label>\r\n                      </li>\r\n                    </ul>\r\n                  </div>\r\n                  <div style=\"clear:both;\"></div>\r\n                  <br/>\r\n\r\n                  <br/>\r\n                  <!-- <multi-select ng-model=\"Essay.subcategories\" available=\"subtopics\" selected-label=\"Selected subtopics\" available-label=\"All subtopics\" display=\"r as r.title\" title=\"r as r.title\" config=\"selectConfig\"></multi-select>\r\n                            <div class=\"input-error\" ng-show=\"selectForm.numSelected.$error.min\">\r\n                                Please select at least\r\n                                <ng-pluralize count=\"selectConfig.requiredMin\" when=\"{\'one\': \'one role\', \'other\': \'{} roles\'}\">.\r\n                            </div>\r\n                            <input type=\"hidden\" id=\"reqMin\" ng-model=\"selectConfig.requiredMin\" min=\"1\">-->\r\n                </div>\r\n                <!--                   <div class=\"control-group\">\r\n                            <label class=\"control-label\" for=\"restricted\">Media Type</label>\r\n                            <div class=\"control-group\">\r\n                                <select ng-model=\"Essay.mediaType\">\r\n                                    <option ng-repeat=\"option in mediaType\" value=\"{{option}}\">{{option}}</option>\r\n                                </select>\r\n                            </div>\r\n                        </div>\r\n-->\r\n                <div class=\"control-group\" ng-if=\"Essay.mediaType==\'Text\'\">\r\n                  <label class=\"control-label\" for=\"description\">Post</label>\r\n                  <div class=\"col-12 col-md-6\">Users tend to gravitate towards things with images. It\'s just human\r\n                    nature. We reccommend that you keep that in mind. If you post a link to a website, the image from\r\n                    that page\'s metadata will show up here. We don\'t have enough storage space for video files here, so\r\n                    if you want to post a video, we recommend you upload it to YouTube or Vimeo and post the link here.\r\n                    If you are writing an essay directly here, keep in mind that only the first hundred characters show\r\n                    up in the thumbnail before the user clicks on it. (This number count includes spaces and\r\n                    punctuation) So try to make your title and first sentence engaging. </div><br>\r\n                  <div class=\"controls\">\r\n                    <textarea id=\"description\" ng-model=\"Essay.description\" placeholder=\"\" style=\"width:95%; height:250px; padding:15px;\" class=\"changeTextColor\"></textarea>\r\n                    <!--Commented the TinyMCE\r\n                                <input type=\"button\" name=\"btnAddMedia\" ng-click=\"Showgallery()\" value=\"Add Media\" style=\"margin-top:15px; margin-bottom:10px;\" />\r\n                                <textarea ui-tinymce=\"tinymceOptions\" ng-model=\"Essay.description\" style=\"height:350px;\"></textarea> -->\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\" ng-if=\"Essay.mediaType==\'Stills\'\">\r\n                  <label class=\"control-label\" for=\"description\">Upload Media</label>\r\n                  <div class=\"controls\">\r\n                    <input type=\"file\" check-file-size=\"\" file-model=\"Essay.files\" class=\"form-control input-md text-input\" accept=\"image/x-png, image/gif, image/jpeg, image/jpeg, image/svg+xml\">\r\n              </div>\r\n                  </div>\r\n                  <div class=\"control-group\" ng-if=\"Essay.mediaType==\'Video\' || Essay.mediaType==\'Audio\'\">\r\n                    <label class=\"control-label\" for=\"description\">{{Essay.mediaType}} url</label>\r\n                    <div class=\"controls\">\r\n                      <input type=\"text\" ng-model=\"Essay.mediaFile\" placeholder=\"\" data-errormessage-value-missing=\"Please enter url\" data-errormessage-custom-error=\"Please enter valid url. e.g. http://www.example.com/v1\" data-errormessage=\"Please enter valid url. e.g. http://www.example.com/v1\" style=\"width:50%;\" class=\"form-control input-md  validate[required, custom[url]] text-input\">\r\n              </div>\r\n                    </div>\r\n                    <div class=\"control-group\" ng-if=\"Essay.mediaType!=\'Text\'\">\r\n                      <label class=\"control-label\" for=\"description\">Note</label>\r\n                      <div class=\"controls\">\r\n                        <textarea ng-model=\"Essay.description\" style=\"width: 70%; height: 150px;\" class=\"changeTextColor\"></textarea>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div style=\"clear: both;\"></div>\r\n                  <div style=\"margin-top:20px;\">\r\n                    <button ng-click=\"SubmitEssay(Essay)\" type=\"button\" class=\"btn btn-success\" ng-disabled=\"EssayButton\" style=\"float: left;\">Submit Essay</button>\r\n                    &nbsp;&nbsp;&nbsp;&nbsp;\r\n                    <button ng-click=\"goBack();\" type=\"button\" style=\"float: left;\" class=\"changeTextColor\">Cancel</button>\r\n                    <div style=\"clear: both;\"></div>\r\n                  </div>\r\n                  <div style=\"clear: both;\"></div>\r\n                </div>\r\n        </fieldset>\r\n      </form>\r\n    </div>\r\n  </center>\r\n  <script type=\"text/ng-template\" id=\"field_renderer\">\r\n    <ul class=\"TcatList\">\r\n    <li>\r\n      <div class=\"catname\" id=\"{{subent._id}}\" ng-if=\"(subent.parentIds.length == 0) && (subent.subcategories)\">\r\n        <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\">\r\n        <label ng-click=\"ChangeShow(subent._id);\">{{::subent.title}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id)==-1\"></i><i class=\"fa fa-caret-right\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id) > -1\"></i></label>\r\n      </div>\r\n      <div class=\"catname\" ng-if=\"(subent.parentIds.length == 0) && (!subent.subcategories)\">\r\n        <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n          <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\"> {{::subent.title}}\r\n        </label>\r\n      </div>\r\n      <label class=\"checkbox\" ng-if=\"subent.parentIds.length > 0 && showSubCat\" title=\"{{subent.title}}\">\r\n        <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\"> {{::subent.title}}\r\n      </label>\r\n      <ul ng-if=\"subent.subcategories\" ng-class=\"subent.parentIds.length == 0 ? \'cmnUL MainCatLi_{{subent._id}}\' : \'\'\">\r\n        <li ng-repeat=\"subent in subent.subcategories track by $index\" ng-include=\"\'field_renderer\'\">\r\n          <!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                      <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n                  </label> -->\r\n        </li>\r\n      </ul>\r\n    </li>\r\n  </ul>\r\n</script>\r\n  <script type=\"text/javascript\">\r\n    jQuery(document).ready(function () {\r\n      // binds form submission and fields to the validation engine\r\n      // binds form submission and fields to the validation engine\r\n      $(\"form\").validationEngine();\r\n    });\r\n\r\n  </script>\r\n");
$templateCache.put("app/matchOfFollowers/matchOfFollowers.html","<style type=\"text/css\">\r\n  .digDeeperSmall {\r\n    width: 150px;\r\n  }\r\n</style>\r\n<div>\r\n  <center>\r\n    <h2>Match</h2>\r\n  </center>\r\n\r\n\r\n  <div style=\"text-align:left;\" ng-if=\"showcomparison == false && questions.length > 0\">\r\n\r\n    <div ng-if=\"noDataFound == false\">\r\n      <div class=\"squareBoxY\" style=\"margin-left:10px;\">&nbsp;</div>\r\n      <span>= Simple Comparison by answers alone.</span>\r\n      <div style=\"clear:both;\"></div>\r\n      <div class=\"squareBoxB\" style=\"margin-left:10px\">&nbsp;</div>\r\n      <span>= Weighted Comparison by answers and importance.</span>\r\n      <div style=\"clear:both;\"></div>\r\n    </div>\r\n\r\n    <ul class=\"catList\" ng-if=\"noDataFound == false\">\r\n\r\n      <li ng-repeat=\"frd in AllUsers track by $index\" ng-if=\"fbqlen[frd._id]\">\r\n        <div style=\"background-color:#ffffee; padding:10px;\">\r\n          <div style=\"color: #000000;\">\r\n            <b ng-if=\"frd.name && frd.name !=\'\'\"><i ng-if=\"isShowAsterix[frd._id]\" class=\"fa fa-asterisk clk info-color\"  aria-hidden=\"true\"></i> &nbsp;&nbsp;{{frd.name}}</b>&nbsp;&nbsp;&nbsp;Total\r\n            Answered questions: {{fbqlen[frd._id]}}\r\n\r\n          </div>\r\n          <div style=\"width: 84%; float:left;\">\r\n            <div>\r\n              <div class=\"fbunweighted\" style=\"width:{{(FBunWeighted[frd._id] / fbqlen[frd._id] )  | number:2}}%\">\r\n                {{(FBunWeighted[frd._id] / fbqlen[frd._id] ) | number:2}}% Match</div>\r\n            </div>\r\n            <div>\r\n              <div class=\"fbweighted\"\r\n                style=\"width:{{(fbcombinedWeight[frd._id] / fbmultiplier[frd._id])  | number:2}}%\">\r\n                {{(fbcombinedWeight[frd._id] / fbmultiplier[frd._id]) | number:2}}% Weighted Match</div>\r\n            </div>\r\n          </div>\r\n          <div style=\"clear:both;\"></div>\r\n        </div>\r\n        <div class=\"rateBtns\">\r\n          <center>\r\n            <a href=\"#!/addRating/{{frd._id}}\" class=\"btn2Short-style widthAuto btn-success\" >\r\n                    Rate Politician\r\n                  </a>\r\n            <a href=\"#!/addEndorsement/{{frd._id}}\" ng-if=\"frd.politicianInfo[0].runningForOffice == \'Y\'\" class=\"btn2Short-style widthAuto btn-success\">Endorse</a>\r\n          </center>\r\n        </div>\r\n\r\n      </li>\r\n    </ul>\r\n\r\n  </div>\r\n  <center>\r\n    <div style=\"margin-left:10px\">&nbsp;<i class=\"fa fa-asterisk info-color\"></i><span style=\"display:inline-flex; width:80%; margin-left: 25px;\">If a politician has a yellow asterisk by their name, some or all of their answers are based on research rather than actual responses from the politicians.</span></div>\r\n\r\n  </center>\r\n  <div class=\"alert alert-danger alert-dismissible\" id=\"alert\" ng-if=\"showAlert\" style=\"width:60%;margin-left:\r\n              20%;margin-top:10%\">\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button>\r\n    <strong> Please verify your email first. </strong>\r\n  </div>\r\n  <!--     <h2>BACKGROUND</h2></center>\r\n      <p></p>\r\n      <p ng-bind-html=\"category.description | newlines\"></p>-->\r\n  <div ng-if=\"loader\" class=\"fwb\">\r\n    Loading data ...\r\n    <p>\r\n      <center><i class=\"fa fa-refresh fa-spin\" style=\"font-size:72px;\"></i></center>\r\n    </p>\r\n  </div>\r\n  <div ng-if=\"status.questions == 2 && questions.length == 0\" class=\"fwb\">\r\n    <center>No unanswered questions found.</center>\r\n  </div>\r\n  <div ng-if=\"status.questions == 1\" class=\"fwb\">\r\n    Loading questions ...\r\n  </div>\r\n  <div ng-if=\"status.questions == 3\" class=\"fwb\">\r\n    Something went wrong while loading questions.\r\n  </div>\r\n</div>\r\n</div>\r\n");
$templateCache.put("app/newPressEssay/dialogGallery.html","\r\n<p></p>\r\n<h1><center>Upload Media</center></h1>\r\n<p></p>\r\n<div>\r\n	<ul style=\"padding:0; height:50px;\">\r\n	<li class=\"liclass lispecial\" ng-click=\"ChangeMedia(\'U\');\" ><div>Upload Media</div></li>\r\n	<li class=\"liclass\" style=\"width:1%; height:50px;\">|</li>\r\n	<li class=\"liclass lispecial\" ng-click=\"ChangeMedia(\'G\');\"><div>Gallery</div></li>\r\n	</ul>\r\n	<div ng-if=\"uploadMedia\">\r\n		<form name=\"topicform\" id=\"topicform\">\r\n            <fieldset class=\"scheduler-border\">\r\n                <legend class=\"scheduler-border\">Upload file</legend>\r\n                <p><small>File size should not be greater than 1MB.</small></p>\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-12\">\r\n                        <div class=\"control-group\">\r\n                            \r\n                            <div class=\"controls\"><input type=\"file\" file-model=\"uploads.files\" check-file-size=\"\" class=\"form-control input-md text-input\" accept=\"image/x-png, image/gif, image/jpeg, image/jpeg, image/svg+xml\">\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"control-group\" style=\"margin-top:15px; margin-bottom:10px;\" >\r\n                            \r\n                            <div class=\"controls\"><input type=\"button\" ng-click=\"uploadFile();\" value=\"Upload File\">\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </fieldset>\r\n        </form>\r\n	</div>\r\n	<div ng-if=\"Gallery\"> \r\n	<p ng-if=\"MainGallery.length > 0\">\r\n		<p>Select the file then select the url from textbox to insert it in the Description</p>\r\n		<p ng-if=\"ShowPath\">Use Ctrl+C to copy from text box<input type=\"text\" ng-model=\"uploads.path\" style=\"width:100%;\"></p>\r\n		<div style=\"width:100%; max-height: 350px; overflow: scroll;\">\r\n			<span ng-repeat=\"img in MainGallery\" style=\"cursor: pointer; padding:10px;\" ng-click=\"ShowSelectedPath(img.fileName);\"><img src=\"{{GalleryFolder}}/{{img.fileName}}\" style=\"width:100px;\" /></span>\r\n\r\n		</div>\r\n	</p>\r\n	<p ng-if=\"MainGallery.length == 0\">\r\n		There are no files uploaded by you. Click on \"Upload Media\" tab to upload files.\r\n	</p>\r\n	</div>\r\n</div>");
$templateCache.put("app/newPressEssay/newEssay.html","<link rel=\"stylesheet\" type=\"text/css\" href=\"./newEssay/newEssay.css\">\r\n<p></p>\r\n<div ng-cloak ng-show=\"$root.userRole==\'admin\'|| $root.userRole==\'advocate\'|| $root.userRole==\'press\'\">\r\n<h1><center>Create new Essay</center></h1>\r\n<p></p>\r\n<center>\r\n    <div class=\"inline2\">\r\n        <form name=\"topicform\" id=\"topicform\">\r\n            <fieldset class=\"scheduler-border\">\r\n                <legend class=\"scheduler-border\">Essay details</legend>\r\n                <p></p>\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-12\">\r\n                        <div class=\"control-group\">\r\n                            <label class=\"control-label\" for=\"title\">Title</label>\r\n                            <div class=\"controls\">\r\n                                <input type=\"text\" ng-model=\"Essay.title\" placeholder=\"\" data-errormessage=\"Title is required.\" style=\"width:50%;\" class=\"form-control input-md  validate[required] text-input\">\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"control-group\" ng-if=\"userType==\'admin\'\">\r\n                            <label class=\"control-label\" for=\"press\">Press&nbsp;&nbsp;<i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"displayPressRefresh\"></i></label>\r\n\r\n                            <div class=\"controls\">\r\n                               <div mass-autocomplete>\r\n                                    <input style=\"width:50%;\" ng-model=\"Essay.press\" mass-autocomplete-item=\"autocomplete_press_options\">\r\n                                </div>\r\n                                \r\n                            </div>\r\n                        </div>\r\n                        <div class=\"control-group\">\r\n                            <div class=\"control-label\" for=\"title\">Select Tags</div>\r\n\r\n                            <div class=\"DisplayCat\">\r\n                                <div style=\"background-color: #eee; padding:5px;\">All Tags\r\n                                    <br><small>(click to select)</small></div>\r\n                                <div ng-repeat=\"subent in subtopics.subcategories track by $index\" ng-include=\"\'field_renderer\'\">Loading...</div>\r\n                                <div ng-if=\"subtopics.subcategories.length == 0\" class=\"loadingSpinner\">\r\n                                    <i class=\"fa fa-refresh fa-spin fa-3x fa-fw\"></i>\r\n                                </div>\r\n                            </div>\r\n                            <div class=\"select buttons\" style=\"padding-left: 20px;\">&nbsp;\r\n                                <!-- <button class=\"btn mover left\" ng-click=\"AddmyCats()\" title=\"Add selected\" ng-disabled=\"!selectedCat.length\"><i class=\"fa fa-arrow-right\" aria-hidden=\"true\"></i></button>\r\n                                <button class=\"btn mover right\" ng-click=\"RemoveCats()\" title=\"Remove selected\" ng-disabled=\"!rmselectedCat.length\">\r\n                                    <i class=\"fa fa-arrow-left\" aria-hidden=\"true\"></i>\r\n                                </button> -->\r\n                            </div>\r\n                            <div class=\"DisplayCat\">\r\n                                <div style=\"background-color: #eee; padding:5px;\">Selected Tags\r\n                                    <br><small>(click to remove)</small></div>\r\n                                <ul class=\"TcatList\">\r\n                                    <li ng-repeat=\"subent in selectedCat track by $index\">\r\n                                        <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                                            <input type=\"checkbox\" ng-click=\"removeVal(subent)\" name=\"checkedidcat\" ng-model=\"selectedAll.id[$index]\" ng-checked=\"\'true\'\"> {{subent.title}}\r\n                                        </label>\r\n                                    </li>\r\n                                </ul>\r\n                            </div>\r\n                            <div style=\"clear:both;\"></div>\r\n                            <br/>\r\n                            <div class=\"control-label\" for=\"title\" ng-if=\"subtopics.subcategories.length > 0 && uData.subject_of_deep_interest.length > 0\"><button class=\"tfbuttonNew\" type=\"button\" ng-click=\"loadDefaultTags();\">Load your default tag\'s</button></div>\r\n                            <!-- <multi-select ng-model=\"Essay.subcategories\" available=\"subtopics\" selected-label=\"Selected subtopics\" available-label=\"All subtopics\" display=\"r as r.title\" title=\"r as r.title\" config=\"selectConfig\"></multi-select>\r\n                            <div class=\"input-error\" ng-show=\"selectForm.numSelected.$error.min\">\r\n                                Please select at least\r\n                                <ng-pluralize count=\"selectConfig.requiredMin\" when=\"{\'one\': \'one role\', \'other\': \'{} roles\'}\">.\r\n                            </div>\r\n                            <input type=\"hidden\" id=\"reqMin\" ng-model=\"selectConfig.requiredMin\" min=\"1\">-->\r\n                        </div>\r\n                        <div class=\"control-group\">\r\n                            <div class=\"DisplayCat\">\r\n                                <div style=\"background-color: #eee; padding:5px;\">Choose Location\r\n                                    <br><small>(click to select)</small></div>\r\n                                <ul class=\"TcatList\">\r\n                                    <li style=\"padding-bottom:10px;\">\r\n                                        <input type=\"checkbox\" ng-click=\"getLocations(Essay.Locations, \'International\')\" ng-model=\"Essay.Locations\" ng-true-value=\"\'International\'\" ng-false-value=\"\'NO\'\">\r\n                                        <label ng-click=\"ShowAddLocation();\">International&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i></label>\r\n                                        <div style=\"padding-left:20px;\" ng-if=\"AddLocation\">\r\n                                            <div mass-autocomplete>\r\n                                                <input ng-model=\"newlocation.country\" mass-autocomplete-item=\"autocomplete_options\">\r\n                                            </div>\r\n                                            <div style=\"text-align: right;\">\r\n                                                <button ng-click=\"AddCountry();\">Add country</button>\r\n                                            </div>\r\n                                        </div>\r\n                                    </li>\r\n                                    <li>\r\n                                        <input type=\"checkbox\" ng-model=\"Essay.National\" ng-click=\"getLocations(Essay.National, \'National\')\" ng-true-value=\"\'National\'\" ng-false-value=\"\'NO\'\">\r\n                                        <label>National</label>\r\n                                        </i>\r\n                                        <ul class=\"TcatList\">\r\n                                            <li ng-repeat=\"area in allLocations track by $index\">\r\n                                                <input type=\"checkbox\" ng-click=\"getAreaVal(area, area.state, \'state\')\" ng-disabled=\"checkDisabled(area, area.state, \'state\')\" ng-checked=\"checkDisabled(area, area.state, \'state\')\">\r\n                                                <label ng-click=\"getCounties(area.statePostalCode)\">{{area.state}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoading.indexOf(area.statePostalCode)==-1\"></i> <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoading.indexOf(area.statePostalCode) > -1\"></i></label>\r\n                                                <!-- Display Counties -->\r\n                                                <ul class=\"TcatList\">\r\n                                                    <li ng-repeat=\"county in allCounties[area.statePostalCode] track by $index\">\r\n                                                        <input type=\"checkbox\" ng-click=\"getAreaVal(county._id, area.state, \'county\')\" ng-disabled=\"checkDisabled(county._id, area.state, \'county\')\" ng-checked=\"checkDisabled(county._id, area.state, \'county\')\">\r\n                                                        <label ng-click=\"getLocals(area.statePostalCode, county._id.county)\">{{county._id.county}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoadingCounty.indexOf(county._id.county) == -1\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingCounty.indexOf(county._id.county) > -1\"></i></label>\r\n                                                        <!-- Display Locals and sub counties -->\r\n                                                        <ul class=\"TcatList\" ng-if=\"Essay.location!=\'National\'\">\r\n                                                            <li ng-repeat=\"local in allLocals[area.statePostalCode][county._id.county] track by $index\">\r\n                                                                <label class=\"checkbox\" title=\"{{local._id.place}}\">\r\n                                                                    <input type=\"checkbox\" ng-click=\"getAreaVal(local._id, area.state, \'local\')\" ng-disabled=\"disabledLocation.indexOf(local._id) > -1 ? true : false\" ng-checked=\"disabledLocation.indexOf(local._id) > -1 ? true : false\"> {{local._id.countySubdivision}} - {{local._id.place}}\r\n                                                                </label>\r\n                                                            </li>\r\n                                                        </ul>\r\n                                                        <!-- Display Locals and sub counties End -->\r\n                                                    </li>\r\n                                                </ul>\r\n                                                <!-- Display Counties End -->\r\n                                            </li>\r\n                                        </ul>\r\n                                    </li>\r\n                                </ul>\r\n                            </div>\r\n                            <div class=\"select buttons\" style=\"padding-left: 20px;\">&nbsp;\r\n\r\n                                <!-- <button class=\"btn mover left\" ng-click=\"AddmyArea()\" title=\"Add selected\" ng-disabled=\"!selectedArea.length\"><i class=\"fa fa-arrow-right\" aria-hidden=\"true\"></i></button>\r\n                                <button class=\"btn mover right\" ng-click=\"RemoveArea()\" title=\"Remove selected\" ng-disabled=\"!rmselectedArea.length\">\r\n                                    <i class=\"fa fa-arrow-left\" aria-hidden=\"true\"></i>\r\n                                </button> -->\r\n                            </div>\r\n                            <div class=\"DisplayCat\">\r\n                                <div style=\"background-color: #eee; padding:5px;\">Selected Location\'s\r\n                                    <br><small>(click to remove)</small></div>\r\n                                <ul class=\"TcatList\">\r\n                                    <li ng-repeat=\"area in selectedArea track by $index\">\r\n                                        <label class=\"checkbox\" title=\"{{area}}\">\r\n                                            <input type=\"checkbox\" ng-click=\"removeAreaVal(area)\" name=\"checkedid\" ng-model=\"selectedLAll.id[$index]\" ng-checked=\"true\"> <span ng-if=\"area.country && (!(area.state) && !(area.county) && !(area.countySubdivision) && !(area.place))\">{{area.country}}</span> <span ng-if=\"area.state && (!(area.county) && !(area.countySubdivision) && !(area.place))\">{{area.state}}</span><span ng-if=\"area.county && (!(area.countySubdivision) && !(area.place))\">{{area.county}}</span><span ng-if=\"area.countySubdivision\">{{area.countySubdivision}}</span><span ng-if=\"area.place\"> - {{area.place}}</span>\r\n                                        </label>\r\n                                    </li>\r\n                                </ul>\r\n                            </div>\r\n                            <div style=\"clear:both;\"></div>\r\n                             <br/>\r\n                            <div class=\"control-label\" for=\"title\" ng-if=\"uData.location_of_interest.length > 0\"><button class=\"tfbuttonNew\" type=\"button\" ng-click=\"loadDefaultLocations();\">Load your default Location</button></div><br/>\r\n                            <!-- <multi-select ng-model=\"Essay.subcategories\" available=\"subtopics\" selected-label=\"Selected subtopics\" available-label=\"All subtopics\" display=\"r as r.title\" title=\"r as r.title\" config=\"selectConfig\"></multi-select>\r\n                            <div class=\"input-error\" ng-show=\"selectForm.numSelected.$error.min\">\r\n                                Please select at least\r\n                                <ng-pluralize count=\"selectConfig.requiredMin\" when=\"{\'one\': \'one role\', \'other\': \'{} roles\'}\">.\r\n                            </div>\r\n                            <input type=\"hidden\" id=\"reqMin\" ng-model=\"selectConfig.requiredMin\" min=\"1\">-->\r\n                        </div>\r\n  <!--                      <div class=\"control-group\">\r\n                            <label class=\"control-label\" for=\"restricted\">Media Type</label>\r\n                            <div class=\"control-group\">\r\n                                <select ng-model=\"Essay.mediaType\">\r\n                                    <option ng-repeat=\"option in mediaType\" value=\"{{option}}\">{{option}}</option>\r\n                                </select>\r\n                            </div>\r\n                        </div>\r\n-->\r\n                        <div class=\"control-group\" ng-if=\"Essay.mediaType==\'Text\'\">\r\n                            <label class=\"control-label\" for=\"description\">Description</label>\r\n                            <div class=\"controls\">\r\n                            <textarea id=\"description\" ng-model=\"Essay.description\" placeholder=\"\" style=\"width:95%; height:250px;\"></textarea>\r\n                                <!-- <input type=\"button\" name=\"btnAddMedia\" ng-click=\"Showgallery()\" value=\"Add Media\" style=\"margin-top:15px; margin-bottom:10px;\" />\r\n                                <textarea ui-tinymce=\"tinymceOptions\" ng-model=\"Essay.description\" style=\"height:350px;\"></textarea> -->\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"control-group\" ng-if=\"Essay.mediaType==\'Stills\'\">\r\n                            <label class=\"control-label\" for=\"description\">Upload Media</label>\r\n                            <div class=\"controls\">\r\n                                <input type=\"file\" check-file-size=\"\" file-model=\"Essay.files\" class=\"form-control input-md text-input\" accept=\"image/x-png, image/gif, image/jpeg, image/jpeg, image/svg+xml\">\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"control-group\" ng-if=\"Essay.mediaType==\'Video\' || Essay.mediaType==\'Audio\'\">\r\n                            <label class=\"control-label\" for=\"description\">{{Essay.mediaType}} url</label>\r\n                            <div class=\"controls\">\r\n                                <input type=\"text\" ng-model=\"Essay.mediaFile\" placeholder=\"\" data-errormessage-value-missing=\"Please enter url\" data-errormessage-custom-error=\"Please enter valid url. e.g. http://www.example.com/v1\" data-errormessage=\"Please enter valid url. e.g. http://www.example.com/v1\" style=\"width:50%;\" class=\"form-control input-md  validate[required, custom[url]] text-input\">\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"control-group\" ng-if=\"Essay.mediaType!=\'Text\'\">\r\n                            <label class=\"control-label\" for=\"description\">Note</label>\r\n                            <div class=\"controls\">\r\n                                <textarea ng-model=\"Essay.description\" style=\"width: 70%; height: 150px;\"></textarea>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <div style=\"clear: both;\"></div>\r\n                    <div style=\"margin-top:20px;\">\r\n                        <button ng-click=\"SubmitEssay(Essay)\" type=\"button\" class=\"btn btn-success\" ng-disabled=\"EssayButton\" style=\"float: left;\">Submit Essay</button>\r\n                        &nbsp;&nbsp;&nbsp;&nbsp;\r\n                        <button ng-click=\"goBack();\" type=\"button\" style=\"float: left;\">Cancel</button>\r\n                        <div style=\"clear: both;\"></div>\r\n                    </div>\r\n                    <div style=\"clear: both;\"></div>\r\n                </div>\r\n            </fieldset>\r\n        </form>\r\n    </div>\r\n</center>\r\n<script type=\"text/ng-template\" id=\"field_renderer\">\r\n    <ul class=\"TcatList\">\r\n        <li>\r\n            <div class=\"catname\" id=\"{{subent._id}}\" ng-if=\"(subent.parentIds.length == 0) && (subent.subcategories)\">\r\n                <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\">\r\n                <label ng-click=\"ChangeShow(subent._id);\">{{::subent.title}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id)==-1\"></i><i class=\"fa fa-caret-right\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id) > -1\"></i></label>\r\n            </div>\r\n            <div class=\"catname\" ng-if=\"(subent.parentIds.length == 0) && (!subent.subcategories)\">\r\n                <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                    <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\"> {{::subent.title}}\r\n                </label>\r\n            </div>\r\n            <label class=\"checkbox\" ng-if=\"subent.parentIds.length > 0 && showSubCat\" title=\"{{subent.title}}\">\r\n                <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\"> {{::subent.title}}\r\n            </label>\r\n            <ul ng-if=\"subent.subcategories\" ng-class=\"subent.parentIds.length == 0 ? \'cmnUL MainCatLi_{{subent._id}}\' : \'\'\">\r\n                <li ng-repeat=\"subent in subent.subcategories track by $index\" ng-include=\"\'field_renderer\'\">\r\n                    <!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                      <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n                  </label> -->\r\n                </li>\r\n            </ul>\r\n        </li>\r\n    </ul>\r\n</script>\r\n<script type=\"text/javascript\">\r\njQuery(document).ready(function() {\r\n    // binds form submission and fields to the validation engine\r\n    // binds form submission and fields to the validation engine\r\n    $(\"form\").validationEngine();\r\n});\r\n</script>\r\n");
$templateCache.put("app/openFecCandidates/openFecCandidates.html","<div class=\"container-fluid ng-scope\" ng-cloak ng-show=\"$root.userRole==\'admin\'\">\r\n  <h2 class=\"pageHeading\">Settings</h2>\r\n  <div>\r\n    <div class=\"closeForm\" ng-include=\"\'app/popups/setting_Ctrl.html\'\"></div>\r\n  </div>\r\n  <!-- OpenFEC -->\r\n  <form ng-if=\"$root.showOpenFec \" name=\"showOpenFec \" id=\"showOpenFec \" ng-controller=\"openFECCtrl\" class=\"closeForm \">\r\n    <h2 style=\"color:#ffffff; \">OpenFEC Candidates</h2>\r\n    <p>\r\n      <a href=\"javascript: void(0); \" ng-click=\"getElectionData(); \" class=\"ylink \">Get Election date data</a> &nbsp; &nbsp;</p>\r\n    <a href=\"javascript: void(0); \" ng-click=\"getCurrentFECCandidatesr(1); \" class=\"ylink \">Get current OpenFEC Data</a> &nbsp; &nbsp;\r\n    <i ng-if=\"showLoader \" class=\"fa fa-refresh fa-spin fa-1x fa-fw \"></i>\r\n    <div ng-if=\"openCandidateDtls==false\">\r\n      <!-- <div class=\"changeTextColor \" style=\"float:right; \">\r\n              <dir-pagination-controls max-size=\"5 \" on-page-change=\"pageChanged(newPageNumber) \"></dir-pagination-controls>\r\n            </div> -->\r\n      <div class=\"row table-responsive \" ng-if=\"openFecCandidates.length> 0\" style=\"margin-top: 10px;\">\r\n        <div infinite-scroll=\'myPagingFunction()\'>\r\n          <table class=\"table w100 changeTextColor\">\r\n            <tr>\r\n              <th>District</th>\r\n              <th>Name</th>\r\n              <th>Incumbent Challenge</th>\r\n              <th>Candidate ID</th>\r\n              <th>State</th>\r\n              <th>Office</th>\r\n              <th>Party</th>\r\n              <th>Candidate status</th>\r\n              <th style=\"width:10%;\">Present In Database</th>\r\n            </tr>\r\n            <tr ng-repeat=\"u in openFecCandidates | filter:{presentInDB: selDbPresent.present}\">\r\n              <td>\r\n                {{u.district}}\r\n              </td>\r\n              <td>\r\n                <a href=\"\" ng-click=\"getCandidateDetails(u.candidate_id)\" class=\"link\">{{u.name}}</a>\r\n              </td>\r\n              <td>\r\n                {{u.incumbent_challenge}} {{u.incumbent_challenge_full}}\r\n              </td>\r\n              <td>\r\n                {{u.candidate_id}}\r\n              </td>\r\n              <td>\r\n                {{u.state}}\r\n              </td>\r\n              <td>\r\n                {{u.office}}\r\n              </td>\r\n              <td>\r\n                {{u.party}}\r\n              </td>\r\n              <td>\r\n                {{u.candidate_status}}\r\n              </td>\r\n              <td>\r\n                <!-- {{u.presentInDB}} -   {{u.userId}} - {{u.politicianId}}-->\r\n                <a href=\"#!/publicProfile/{{u.user_id}}/false\" class=\"link\" ng-if=\"u.presentInDB==\'Y\' && u.user_id && !u.pol_id\">Yes</a>\r\n                <a href=\"#!/publicProfile/{{u.pol_id}}/true\" class=\"link\" ng-if=\"u.presentInDB==\'Y\' && u.pol_id && !u.user_id\">Yes</a>\r\n                <!-- <a href=\"\" ng-click=\"matchMembers(u.firstName, u.lastName)\" class=\"link\" ng-if=\"u.presentInDB==\'N\'\">NO</a> -->\r\n              </td>\r\n            </tr>\r\n          </table>\r\n          <p ng-if=\"statusGetResPg == 1\" class=\"fwb\">Loading candidiates...</p>\r\n        </div>\r\n      </div>\r\n      <!-- <div class=\"changeTextColor\" style=\"float:right;\">\r\n              <dir-pagination-controls max-size=\"5\" on-page-change=\"pageChanged(newPageNumber)\"></dir-pagination-controls>\r\n            </div> -->\r\n    </div>\r\n    <div ng-if=\"openCandidateDtls == true\">\r\n      <fieldset class=\"scheduler-border\">\r\n        <legend class=\"scheduler-border\">Address</legend>\r\n        <div ng-if=\"candidiateDtls.address_city\">City : {{candidiateDtls.address_city}}</div>\r\n        <div ng-if=\"candidiateDtls.address_state\">State : {{candidiateDtls.address_state}}</div>\r\n        <div ng-if=\"candidiateDtls.address_street_1\">Street 1 : {{candidiateDtls.address_street_1}}</div>\r\n        <div ng-if=\"candidiateDtls.address_street_2\">Street 2 : {{candidiateDtls.address_street_2}}</div>\r\n        <div ng-if=\"candidiateDtls.address_zip\">Zipcode : {{candidiateDtls.address_zip}}</div>\r\n        <div ng-if=\"candidiateDtls.candidate_inactive\">Candidate Inactive : {{candidiateDtls.candidate_inactive}}</div>\r\n      </fieldset>\r\n      <fieldset class=\"scheduler-border\" ng-if=\"candidiateCommittees && candidiateCommittees.length > 0\">\r\n        <legend class=\"scheduler-border\">Committees</legend>\r\n        <div ng-repeat=\"com in candidiateCommittees\">\r\n          <div ng-if=\"com.city\">City : {{com.city}}</div>\r\n          <div ng-if=\"com.committee_id\">Committee ID : {{com.committee_id}}</div>\r\n          <div ng-if=\"com.committee_type\">Committee Type : {{com.committee_type}}</div>\r\n          <div ng-if=\"com.committee_type_full\">Committee Type Full : {{com.committee_type_full}}</div>\r\n          <div ng-if=\"com.custodian_city\">Custodian City : {{com.custodian_city}}</div>\r\n          <div ng-if=\"com.custodian_name_1\">Custodian Name 1 : {{com.custodian_name_1}}</div>\r\n          <div ng-if=\"com.custodian_name_2\">Custodian Name 2 : {{com.custodian_name_2}}</div>\r\n          <div ng-if=\"com.custodian_name_full\">Custodian Name Full : {{com.custodian_name_full}}</div>\r\n          <div ng-if=\"com.custodian_name_middle\">Custodian Name Middle : {{com.custodian_name_middle}}</div>\r\n          <div ng-if=\"com.custodian_name_suffix\">Custodian Name Suffix : {{com.custodian_name_suffix}}</div>\r\n          <div ng-if=\"com.custodian_name_title\">Custodian Name Title : {{com.custodian_name_title}}</div>\r\n          <div ng-if=\"com.custodian_phone\">Custodian Phone : {{com.custodian_phone}}</div>\r\n          <div ng-if=\"com.custodian_state\">Custodian State : {{com.custodian_state}}</div>\r\n          <div ng-if=\"com.custodian_street_1\">Custodian Street 1 : {{com.custodian_street_1}}</div>\r\n          <div ng-if=\"com.custodian_street_2\">Custodian Street 2 : {{com.custodian_street_2}}</div>\r\n          <div ng-if=\"com.custodian_zip\">Custodian Zipcode : {{com.custodian_zip}}</div>\r\n          <div ng-if=\"com.cycles[0]\">Cycles : {{com.cycles[0]}}</div>\r\n          <div ng-if=\"com.designation\">Designation : {{com.designation}}</div>\r\n          <div ng-if=\"com.designation_full\">Designation Full : {{com.designation_full}}</div>\r\n          <div ng-if=\"com.email\">Email : {{com.email}}</div>\r\n          <div ng-if=\"com.fax\">Fax : {{com.fax}}</div>\r\n          <div ng-if=\"com.filing_frequency\">Filing Frequency : {{com.filing_frequency}}</div>\r\n          <div ng-if=\"com.first_file_date\">First File Date : {{com.first_file_date}}</div>\r\n          <div ng-if=\"com.form_type\">Form Type : {{com.form_type}}</div>\r\n          <div ng-if=\"com.last_file_date\">Last File Date : {{com.last_file_date}}</div>\r\n          <div ng-if=\"com.leadership_pac\">Leadership Pac : {{com.leadership_pac}}</div>\r\n          <div ng-if=\"com.lobbyist_registrant_pac\">Lobbyist Registrant Pac : {{com.lobbyist_registrant_pac}}</div>\r\n          <div ng-if=\"com.name\">Name : {{com.name}}</div>\r\n          <div ng-if=\"com.organization_type\">Organization Type : {{com.organization_type}}</div>\r\n          <div ng-if=\"com.organization_type_full\">Organization Type Full : {{com.organization_type_full}}</div>\r\n          <div ng-if=\"com.party\">Party : {{com.party}}</div>\r\n          <div ng-if=\"com.party_full\">Party Full : {{com.party_full}}</div>\r\n          <div ng-if=\"com.party_type\">Party Type : {{com.party_type}}</div>\r\n          <div ng-if=\"com.party_type_full\">Party Type Full : {{com.party_type_full}}</div>\r\n          <div ng-if=\"com.qualifying_date\">Qualifying Date : {{com.qualifying_date}}</div>\r\n          <div ng-if=\"com.state\">State : {{com.state}}</div>\r\n          <div ng-if=\"com.state_full\">State Full : {{com.state_full}}</div>\r\n          <div ng-if=\"com.street_1\">street 1 : {{com.street_1}}</div>\r\n          <div ng-if=\"com.street_2\">street 2 : {{com.street_2}}</div>\r\n          <div ng-if=\"com.treasurer_city\">Treasurer City : {{com.treasurer_city}}</div>\r\n          <div ng-if=\"com.treasurer_name\">Treasurer Name : {{com.treasurer_name}}</div>\r\n          <div ng-if=\"com.treasurer_name_1\">Treasurer Name 1 : {{com.treasurer_name_1}}</div>\r\n          <div ng-if=\"com.treasurer_name_2\">Treasurer Name 2 : {{com.treasurer_name_2}}</div>\r\n          <div ng-if=\"com.treasurer_name_middle\">Treasurer Name Middle : {{com.treasurer_name_middle}}</div>\r\n          <div ng-if=\"com.treasurer_name_prefix\">Treasurer Name Prefix : {{com.treasurer_name_prefix}}</div>\r\n          <div ng-if=\"com.treasurer_name_suffix\">Treasurer Name Suffix : {{com.treasurer_name_suffix}}</div>\r\n          <div ng-if=\"com.treasurer_name_title\">Treasurer Name Title : {{com.treasurer_name_title}}</div>\r\n          <div ng-if=\"com.treasurer_phone\">Treasurer Phone : {{com.treasurer_phone}}</div>\r\n          <div ng-if=\"com.treasurer_state\">Treasurer State : {{com.treasurer_state}}</div>\r\n          <div ng-if=\"com.treasurer_street_1\">Treasurer Street 1 : {{com.treasurer_street_1}}</div>\r\n          <div ng-if=\"com.treasurer_street_2\">Treasurer Street 2 : {{com.treasurer_street_2}}</div>\r\n          <div ng-if=\"com.treasurer_zip\">Treasurer Zipcode : {{com.treasurer_zip}}</div>\r\n          <div ng-if=\"com.website\">Website : {{com.website}}</div>\r\n          <div ng-if=\"com.zip\">Zipcode : {{com.zip}}</div>\r\n          <hr>\r\n        </div>\r\n      </fieldset>\r\n      <button ng-click=\"goBack()\" type=\"button\" class=\"btn btn-success\">Back</button>\r\n    </div>\r\n  </form>\r\n  <!-- // OpenFEC -->\r\n</div>\r\n");
$templateCache.put("app/openFecCommittees/openFecCommittee.html","<div class=\"container-fluid ng-scope\" ng-cloak ng-show=\"$root.userRole==\'admin\'\">\r\n  <h2 class=\"pageHeading\">Settings</h2>\r\n  <div>\r\n    <div class=\"closeForm\" ng-include=\"\'app/popups/setting_Ctrl.html\'\"></div>\r\n  </div>\r\n  <!-- OpenFEC Committees -->\r\n  <form ng-if=\"$root.showOpenFecCommittee\" name=\"showOpenFecCommittee\" id=\"showOpenFecCommittee\" ng-controller=\"openFECCommittee\" class=\"closeForm\">\r\n    <br>\r\n    <h2 style=\"color:#ffffff;\">OpenFEC Committees</h2>\r\n    <br>\r\n    <p>\r\n      <a href=\"javascript: void(0)\" class=\"ylink\" ng-click=\"AddCommittees()\">Add Committees</a>\r\n    </p>\r\n    <br>\r\n    <div infinite-scroll=\'myPagingFunction()\'>\r\n      <!-- infinite-scroll-distance=\'2\' infinite-scroll-container=\"\'#globalHtmlTag\'\" -->\r\n      <table class=\"w100 changeTextColor\" ng-show=\"committee.length > 0\">\r\n        <tr>\r\n          <th>Committee_id</th>\r\n          <th>Name</th>\r\n          <th>Committee_type</th>\r\n          <th>Cycles</th>\r\n          <th>State</th>\r\n          <th>Treasurer_name</th>\r\n          <!-- <th>Edit / Remove</th> -->\r\n        </tr>\r\n        <tr ng-repeat=\"u in committee\">\r\n          <!-- dir-paginate=\"u in users.data | itemsPerPage :usersPerPage\" total-items=\"totalUsers\" current-page=\"pagination.current\" -->\r\n          <td>\r\n            {{u.committee_id}}\r\n          </td>\r\n          <td>\r\n            <!-- <img src=\"../assets/images/profile/politician.svg\" alt=\"Politician\" ng-if=\"u.politician\" class=\"UserTypeImg\" />\r\n                <img src=\"../assets/images/profile/press.svg\" class=\"UserTypeImg\" alt=\"Press\" ng-if=\"u.press\" />\r\n                <img src=\"../assets/images/profile/voter.svg\" class=\"UserTypeImg\" alt=\"Voter\" ng-if=\"u.voter\" />\r\n                <img src=\"../assets/images/profile/voter.svg\" class=\"UserTypeImg\" alt=\"Voter\" ng-if=\"u.admin\" />\r\n                <img src=\"../assets/images/profile/voter.svg\" class=\"UserTypeImg\" alt=\"Voter\" ng-if=\"u.forumadmin\" />\r\n                <img src=\"../assets/images/profile/voter.svg\" class=\"UserTypeImg\" alt=\"Voter\" ng-if=\"u.voteradmin\" />\r\n                <img src=\"../assets/images/profile/advocate.svg\" class=\"UserTypeImg\" alt=\"Advocate\" ng-if=\"u.advocate\" /> -->\r\n            {{u.name}}\r\n          </td>\r\n          <td>\r\n            {{u.committee_type_full}}\r\n          </td>\r\n          <td>\r\n            {{u.cycles[0]}}\r\n          </td>\r\n          <td>\r\n            {{u.state}}\r\n          </td>\r\n          <td>\r\n            {{u.treasurer_name}}\r\n          </td>\r\n          <!-- <td>\r\n                  <a href=\"javascript: void(0)\" ng-click=\"EditUser(u, $index)\" class=\"link\">Edit</a> |\r\n                  <a href=\"javascript: void(0)\" ng-click=\"removeUser(u, $index)\" class=\"link\">Remove</a>\r\n                </td> -->\r\n        </tr>\r\n        <tr ng-if=\"users.data.length == 0\">\r\n          <td colspan=\"3\"> No records found.\r\n          </td>\r\n        </tr>\r\n      </table>\r\n      <p ng-if=\"statusGetResPg == 1\" class=\"fwb\">Loading Committees...</p>\r\n    </div>\r\n    <!-- <p>\r\n          <a href=\"javascript: void(0);\" ng-click=\"getElectionData();\" class=\"ylink\">Get Election date data</a> &nbsp; &nbsp;</p>-->\r\n  </form>\r\n  <!--// OpenFEC Committees -->\r\n</div>\r\n");
$templateCache.put("app/openState/openState.html","<div class=\"container-fluid ng-scope\" ng-cloak ng-show=\"$root.userRole==\'admin\'\">\r\n  <h2 class=\"pageHeading\">Settings</h2>\r\n  <div>\r\n    <div class=\"closeForm\" ng-include=\"\'app/popups/setting_Ctrl.html\'\"></div>\r\n  </div>\r\n  <!--   <h3>OpenState Data</h3> -->\r\n  <form name=\"showOpenState\" id=\"showOpenState\" ng-controller=\"openStateCtrl\" class=\"closeForm\">\r\n    <br>\r\n    <h2 style=\"color:#ffffff;\">OpenState Data</h2>\r\n    <br>\r\n    <p>\r\n      <a href=\"javascript: void(0)\" class=\"ylink\" ng-click=\"getOpenState()\">Get OpenState</a>\r\n      <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loader\"></i>\r\n    </p>\r\n    <div ng-show=\"open.length>0\">\r\n      <div ng-if=\"people\">\r\n        <div class=\"form-group row\">\r\n          <label for=\"selDbPresent\" style=\"color:#ffffff;padding-left: 5%;padding-right: 5%\">Present in Database\r\n            :\r\n          </label>\r\n          <!-- <div class=\"col-lg-5 col-sm-5\"> -->\r\n          <select ng-model=\"selDbPresent.present\" class=\"form-control\" style=\"width:170px;\">\r\n            <option value=\"\">Select Option</option>\r\n            <option value=\"Y\">Yes</option>\r\n            <option value=\"N\">No</option>\r\n          </select>\r\n          <!-- </div> -->\r\n        </div>\r\n        <div class=\"form-group row\">\r\n          <label for=\"searchCandys\" style=\"color:#ffffff;padding-left: 5%;padding-right: 5%\">Name : </label>\r\n\r\n          <!-- <input type=\"text\" ng-model=\"searchCandys\" id=\"searchCandys\" class=\"form-control\" placeholder=\"Search by Name\"\r\n            style=\"width:170px;\"> -->\r\n          <input type=\"text\" ng-model=\"search.sdata\" id=\"sdata\" class=\"form-control\" placeholder=\"Search by Name\" style=\"width:170px;\">\r\n          <button class=\"blackText\" style=\"margin-left:5%\" ng-click=\"SearchByName()\">Search</button>\r\n\r\n        </div>\r\n        <div infinite-scroll=\'myPagingFunction()\'>\r\n          <!-- infinite-scroll-distance=\'2\' infinite-scroll-container=\"\'#globalHtmlTag\'\" -->\r\n          <table class=\"w100 changeTextColor\" ng-show=\"open.length > 0\">\r\n            <tr>\r\n              <th>Name</th>\r\n              <th>CurrentMemberships</th>\r\n              <th>Present In Database</th>\r\n\r\n            </tr>\r\n            <tr ng-repeat=\"o in open | filter:{presentInDB: selDbPresent.present} \">\r\n              <!-- dir-paginate=\"u in users.data | itemsPerPage :usersPerPage\" total-items=\"totalUsers\" current-page=\"pagination.current\" -->\r\n              {{o}}\r\n              <td>\r\n                {{o.name}}\r\n              </td>\r\n              <td>\r\n                <div ng-repeat=\"d in o.currentMemberships track by $index\">\r\n                  {{$index + 1}}. {{d.organization.name}} - {{d.organization.classification}}<span ng-if=\"u.role\"> -\r\n                    {{d.role}}</span>\r\n\r\n                </div>\r\n              </td>\r\n              <td>\r\n                <a href=\"#!/publicProfile/{{o.userId}}/false\" class=\"link\" ng-if=\"o.presentInDB==\'Y\' && o.userId && !o.politicianId\">Yes</a>\r\n                <a href=\"#!/publicProfile/{{o.politicianId}}/true\" class=\"link\" ng-if=\"o.presentInDB==\'Y\' && o.politicianId && !u.userId\">Yes</a>\r\n                <a href=\"\" ng-click=\"matchMembers(o)\" class=\"link\" ng-if=\"o.presentInDB==\'N\'\">Find</a>\r\n              </td>\r\n            </tr>\r\n            <tr ng-if=\"open.length == 0\">\r\n              <td colspan=\"3\"> No records found.\r\n              </td>\r\n            </tr>\r\n          </table>\r\n          <p ng-if=\"statusGetResPg == 1 && searchCount > open.length\" class=\"fwb\">Loading OpenState Data...</p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div ng-if=\"!people\" style=\"margin-top: 10px;\">\r\n      <div class=\"ylink\" ng-click=\"back()\">Back</div>\r\n      <div class=\"form-group row\" style=\"color:#ffffff;display:block;text-align:center;\">\r\n        <p>\r\n          <h3>{{pdata.name}}</h3>\r\n        </p>\r\n\r\n      </div>\r\n      <div class=\"alert alert-danger alert-dismissible\" ng-if=\"alert_msg\" style=\"width:40%;margin-left:\r\n            28% \">\r\n        <button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button>\r\n        <strong>Record Not Found</strong>\r\n      </div>\r\n      <div>\r\n        <div class=\"form-group row\">\r\n          <label for=\"selectCandidate\" class=\"col-lg-2 col-sm-5 col-form-label\" style=\"color:#ffffff; \">Filter :\r\n          </label>\r\n          <div class=\"col-lg-5 col-sm-5\">\r\n            <select ng-model=\"selectCandidate.selectCandy\" class=\"form-control\" style=\"width:170px;\">\r\n              <option value=\"\">Select</option>\r\n              <option value=\"user\">User</option>\r\n              <option value=\"politician\">Politicians</option>\r\n            </select>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"alert alert-success alert-dismissible\" id=\"alert\" ng-if=\"success_msg\" style=\"width:40%;margin-left:\r\n            28%\">\r\n        <button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button>\r\n        <strong>Politician matched successfully to local database</strong>\r\n      </div>\r\n      <table class=\"w100\" ng-show=\"matchData.user.length > 0 || matchData.politicians.length > 0 \">\r\n        <tr>\r\n          <th style=\"width:50%;\">Name</th>\r\n          <th style=\"width:30%;\">office</th>\r\n          <th style=\"width:20%;\">Add</th>\r\n          <!-- <th style=\"width:10%;\">Party</th>\r\n                <th style=\"width:10%;\">Present In Database</th> -->\r\n        </tr>\r\n        <tr ng-repeat=\"u in matchData.politicians\" ng-if=\"selectCandidate.selectCandy==\'politician\'\" style=\"color:black\">\r\n          <td>\r\n            {{u.name}}&nbsp;&nbsp; &nbsp;\r\n            <a href=\"\" class=\"link\" ng-if=\"!more[u._id]\" ng-click=\"getDetailsOfCandidates(u._id);\">More</a>\r\n            <div ng-if=\"more[u._id]\">\r\n              <h6 ng-if=\"u.incumbent\">incumbent: {{u.incumbent}}</h6>\r\n              <h6 ng-if=\"u.party\">Party: {{u.party}}</h6>\r\n              <h6 ng-if=\"u.federalCongressionalDistrict\">federalCongressionalDistrict:\r\n                {{u.federalCongressionalDistrict}}</h6>\r\n              <h6 ng-if=\"u.voterScope\">voterScope: {{u.voterScope}}</h6>\r\n              <h6 ng-if=\"u.statePostalCode\">statePostalCode: {{u.statePostalCode}}</h6>\r\n              <h6 ng-if=\"u.runningForOffice\">runningForOffice: {{u.runningForOffice}}</h6>\r\n              <h6 ng-if=\"u.openFecId\">openFecId: {{u.openFecId}}</h6>\r\n              <a href=\"\" ng-if=\"more[u._id]\" class=\"link\" ng-click=\"showLess(u._id)\">Less</a>\r\n            </div>\r\n          </td>\r\n          <td>\r\n            {{u.office}}\r\n          </td>\r\n          <td>\r\n            <a href=\"\" ng-click=\"addMatchCandidates(u._id,\'politician\')\" class=\"link\">Add</a>\r\n          </td>\r\n        </tr>\r\n        <tr ng-repeat=\"u in matchData.user\" ng-if=\"selectCandidate.selectCandy==\'user\'\" style=\"color:black\">\r\n          <td>\r\n            {{u.name}} &nbsp;&nbsp; &nbsp;\r\n            <a href=\"\" class=\"link\" ng-if=\"!more[u._id]\" ng-click=\"getDetailsOfCandidates(u._id);\">More</a>\r\n            <div ng-if=\"more[u._id]\">\r\n              <h6 ng-if=\"u.email[0]\">Email: {{u.email[0]}}</h6>\r\n              <h6 ng-if=\"u.address.place\">Address: {{u.address.place}}</h6>\r\n              <h6 ng-if=\"u.userType\">Usertype: {{u.userType}}</h6>\r\n              <a href=\"\" ng-if=\"more[u._id]\" class=\"link\" ng-click=\"showLess(u._id)\">Less</a>\r\n            </div>\r\n          </td>\r\n          <td>\r\n            {{u.politicianInfo[0].officeName}}\r\n          </td>\r\n          <td>\r\n            <a href=\"\" ng-click=\"addMatchCandidates(u._id, \'user\') \" class=\"link \">Add</a>\r\n          </td>\r\n        </tr>\r\n      </table>\r\n    </div>\r\n  </form>\r\n</div>\r\n");
$templateCache.put("app/openStateBills/openStateBills.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">Settings</h2>\r\n  <div>\r\n    <div class=\"closeForm\" ng-include=\"\'app/popups/setting_Ctrl.html\'\"></div>\r\n  </div>\r\n  <!--   <h3>OpenState Data</h3> -->\r\n  <form name=\"showOpenState\" id=\"showOpenState\" ng-controller=\"openStateBillsCtrl\" class=\"closeForm\">\r\n    <br>\r\n    <h2 style=\"color:#ffffff;\">Bills</h2>\r\n    <br>\r\n    <p>\r\n      <a href=\"javascript: void(0)\" class=\"ylink\" ng-click=\"getOpenStateBills()\">Get OpenState Bills</a>\r\n      <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loader\"></i>\r\n    </p>\r\n    <div ng-show=\"openBills.length>0\">\r\n      <div ng-if=\"!showDetail\">\r\n        <div class=\"form-group row\">\r\n          <label style=\"color:#ffffff;padding-left: 5%;padding-right: 5%\">Title: </label>\r\n          <!-- <div class=\"col-lg-5 col-sm-5\"> -->\r\n          <input type=\"text\" ng-model=\"searchCandy.search\" id=\"searchCandy\" class=\"form-control\" placeholder=\"Search by Title\" style=\"width:170px;\">\r\n          <button class=\"blackText\" style=\"margin-left:5%\" ng-click=\"SearchByTitle()\">Search</button>\r\n\r\n          <!-- </div> -->\r\n        </div>\r\n        <div infinite-scroll=\'myPagingFunction()\'>\r\n          <table class=\"w100 changeTextColor\" ng-show=\"openBills.length > 0\">\r\n            <tr>\r\n              <th>Title</th>\r\n              <th>Subject</th>\r\n              <th>Jurisdiction</th>\r\n              <th style=\"width:9%\">Details</th>\r\n            </tr>\r\n            <tr ng-repeat=\"u in openBills\">\r\n              <td style= \"text-align: left\"><p>\r\n                  {{u.title}}</p>\r\n              </td>\r\n              <td>\r\n                <ul style= \"text-align: left\" ng-repeat=\"s in u.subject track by $index\">\r\n                  <li ng-if=\"s\"> {{s}}</li>\r\n                </ul>\r\n              </td>\r\n              <td>\r\n                {{u.legislativeSession.jurisdiction.name}}\r\n              </td>\r\n              <td>\r\n                <a href=\"javascript: void(0)\" class=\"link\" ng-click=\"getDetails(u._id)\">Get Details</a>\r\n              </td>\r\n            </tr>\r\n            <tr ng-if=\"open.length == 0\">\r\n              <td colspan=\"3\"> No records found.\r\n              </td>\r\n            </tr>\r\n          </table>\r\n          <p ng-if=\"statusGetResPg == 1 && serachData > openBills.length\" class=\"fwb\">Loading OpenState Data...</p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div ng-if=\"showDetail\">\r\n      <a href=\"javascript: void(0)\" class=\"ylink\" ng-click=\"back()\">Back</a>\r\n      <fieldset class=\"scheduler-border\">\r\n        <legend class=\"scheduler-border\">Bill Detail</legend>\r\n        <div class=\"contactBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\" style=\"width: 100%\">\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n                <p>{{details.identifier}}</p>\r\n              <p ng-if=\"details.title\">Title: {{details.title}}</p>\r\n              <p ng-repeat=\"a in details.abstracts\">\r\n                <span>Abstract: {{a.abstract}}</span>\r\n              </p>\r\n              <p>\r\n                <span>Bill Id: {{details.billId}}</span><br>\r\n                <span>Classification: {{details.classification[0]}}  </span>\r\n              </p>\r\n              \r\n              <p>\r\n                <span>LegislativeSession</span>\r\n                <!-- <span>Identifier: {{legislativeSession.identifier}}</span> -->\r\n                <span>Jurisdiction: {{details.legislativeSession.jurisdiction.name}}</span><br>\r\n              </p>\r\n              <p>\r\n                <a href=\"\" ng-show=\"details.documents.length > 0\" class=\"link\" ng-click=\"activeDoc = !activeDoc\">Documents</a>\r\n              </p>\r\n              <div ng-hide=\"activeDoc\">\r\n                <p ng-repeat=\"d in details.documents\" ng-if=\"details.documents.length > 0\">\r\n                  <span ng-if=\"d.date\">Date: {{d.date}}</span>\r\n                  <span ng-if=\"d.note\">Note: {{d.note}}</span>\r\n                  <span ng-if=\"d.links[0].url\">Links: <a href=\"{{d.links[0].url}}\" target=\"_blank\" ng-if=\"details.documents.length > 0\" class=\"link\">{{d.links[0].url}}</a> </span>\r\n                </p>\r\n              \r\n              </div>\r\n              <p><a href=\"\" class=\"link\" ng-click=\"activeAct = !activeAct\">Actions</a></p>\r\n              <div ng-hide=\"activeAct\">\r\n                <div class=\"p\" ng-repeat=\"u in details.actions\">\r\n                  <div>Date: {{u.date | date:\" MM/dd/y\"}}</div>\r\n                  <div>Classification: {{u.classification[0]}}</div>\r\n                  <div>Description: {{u.description}}</div><br>\r\n                </div>\r\n              \r\n              </div>\r\n              <p><a href=\"\" class=\"link\" ng-click=\"activeSpo =!activeSpo\">Sponsorships</a></p>\r\n              <div ng-hide=\"activeSpo\">\r\n                <p ng-repeat=\"s in details.sponsorships\">\r\n                  <span>entityType: {{s.entityType}}</span>\r\n                  <br>\r\n                  <span>Name: {{s.name}}</span>\r\n                  <br>\r\n                  <span ng-if=\"s.organization\">Organization: {{s.organization}}</span>\r\n                  <br>\r\n                  <span ng-if=\"s.person\">Person: {{s.person}}</span>\r\n                </p>\r\n              </div>\r\n              <p><a href=\"\" class=\"link\" ng-show=\"details.votes.edges.length > 0\" ng-click=\"activeVot =!activeVot\">Votes</a></p>\r\n              <div ng-hide=\"activeVot\">\r\n                <div ng-repeat=\"v in details.votes.edges\" ng-if=\"details.votes.edges.length > 0\">\r\n                  <p ng-if=\"v.node.billAction\">Bill Action: </p>\r\n                  <br>\r\n                  <p ng-repeat=\"c in v.node.counts\">\r\n                    <span>Counts</span>\r\n                      <span>Option: {{c.option}}</span>\r\n                      <br>\r\n                      <span>Value: {{c.value}} </span>\r\n                  </p>\r\n                  <br>\r\n                  <p>\r\n                    <span>Organization</span>\r\n                    <span>Classification: {{v.node.organization.classification}}</span>\r\n                    <br>\r\n                    <span> Name: {{v.node.organization.name}}</span>\r\n                    <br>\r\n                    <span> Result: {{v.node.result}}</span>\r\n                    <br>\r\n                  </p>\r\n                  <p ng-repeat=\"cv in v.node.votes\">\r\n                    <span>Votes </span>\r\n                    <span>Option: {{cv.option}}</span>\r\n                    <br>\r\n                    <span>VoterName: {{cv.voterName}} </span>\r\n                    <br>\r\n                    <span ng-if=\"cv.voter\">Voter: {{cv.voter}} </span>\r\n                  </p>\r\n                </div>\r\n                <p> <a href=\"\" ng-if=\"more[\'votes\']\" class=\"link\" ng-click=\"showLess(\'votes\')\">Less</a></p>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </fieldset>\r\n    </div>\r\n  </form>\r\n</div>\r\n");
$templateCache.put("app/orgActivityDetails/orgActivityDetails.html","<div class=\"container-fluid\" ng-controller=\"orgActivityDetailsCtrl\">\r\n  <form class=\"closeForm\">\r\n    <div class=\"row\" style=\"margin-top: 10px;\" class=\"blackText\" ng-if=\"isfollow\">\r\n      <p>\r\n        <h3 style=\"color:white\">Followers</h3>\r\n      </p>\r\n      <table class=\"w100\">\r\n        <tr>\r\n          <th>User Details</th>\r\n        </tr>\r\n        <tr ng-repeat=\"u in foData\" class=\"blackText\">\r\n          <td>\r\n   <!--         <img src=\"../assets/images/profile/politician.svg\" alt=\"Politician\" ng-if=\"u.userType==\'politician\'\" class=\"UserTypeImg\" />\r\n            <img src=\"../assets/images/profile/press.svg\" class=\"UserTypeImg\" alt=\"Press\" ng-if=\"u.userType==\'press\'\" />\r\n            <img src=\"../assets/images/profile/voter.svg\" class=\"UserTypeImg\" alt=\"Voter\" ng-if=\"u.userType==\'voter\'\" />\r\n            <img src=\"../assets/images/profile/admin.svg\" class=\"UserTypeImg\" alt=\"Admin\" ng-if=\"u.userType==\'admin\'\" />\r\n            <img src=\"../assets/images/profile/admin.svg\" class=\"UserTypeImg\" alt=\"Voter\" ng-if=\"u.userType==\'forunadmin\'\" />\r\n            <img src=\"../assets/images/profile/voteradminVb.svg\" class=\"UserTypeImg\" alt=\"Voter\" ng-if=\"u.userType==\'voteradmin\'\" />\r\n            <img src=\"../assets/images/profile/advocate.svg\" class=\"UserTypeImg\" alt=\"Advocate\" ng-if=\"u.userType==\'advocate\'\" />\r\n            <p ng-if=\"u.name\" style=\"margin: 0;\">  -->\r\n              <strong>Name:</strong>\r\n													<a ng-if=\"u.userType == \'politician\'\" href=\"#!/publicProfile/{{u._id}}\" class=\"link\" style=\"text-transform: capitalize;\"><img ng-src=\"../assets/images/profile/politician.svg\" alt=\"Politician\"  class=\"usertype\">{{u.name}}</a>\r\n              <a ng-if=\"u.userType == \'advocate\'\" href=\"#!/pressProfile/{{u._id}}\" class=\"link\" style=\"text-transform: capitalize;\"><img ng-src=\"../assets/images/profile/advocate.svg\" class=\"usertype\" alt=\"Advocate\">{{u.name}}{{u.title}}{{u.orgInfo.title}}{{u.info.title}}{{u.orginfo.title}}{{u.Title}}{{u.orgInfo.Title}}</a>\r\n												<a ng-if=\"u.userType == \'voter\'\" href=\"#!/voterProfile/{{u._id}}\" class=\"link\" style=\"text-transform: capitalize;\"><img ng-src=\"../assets/images/profile/voter.svg \" alt=\"Voter\" class=\"usertype \">{{u.username}}{{u.name}}{{u.userName}}{{u.UserName}}{{u.Username}}</a>\r\n													<a ng-if=\"u.userType == \'admin\'\" href=\"#!/publicProfile/{{u._id}}\" class=\"link\" style=\"text-transform: capitalize;\"><img ng-src=\"../assets/images/profile/admin.svg\" class=\"usertype\" alt=\"Admin\" >VoteWise Admin</a>\r\n       <!--       <a ng-if=\"u.userType == \'voter\' || \'admin\'\" href=\"\">{{u.name}}</a> -->\r\n       <!--     </p>\r\n            <p ng-if=\"u.userType\"><strong>User Type:</strong> {{u.userType}}</p> -->\r\n\r\n          </td>\r\n        </tr>\r\n        <tr ng-if=\"users.data.length == 0\">\r\n          <td colspan=\"2\"> No records found.\r\n          </td>\r\n        </tr>\r\n      </table>\r\n    </div>\r\n    <div ng-if=\"isQus\">\r\n      <h5 class=\"center\">Questions</h5>\r\n      <p></p>\r\n      <div ng-repeat=\"q in quesData\">\r\n        <p ng-if=\"q.content\">\r\n          Question: {{q.content}}\r\n        </p>\r\n      </div>\r\n    </div>\r\n  </form>\r\n</div>\r\n");
$templateCache.put("app/organizedTable/organizedTable.html","<div class=\"container-fluid ng-scope\" ng-cloak ng-show=\"$root.userRole==\'admin\'\">\r\n  <h2 class=\"pageHeading\">Settings</h2>\r\n  <div>\r\n    <div class=\"closeForm\" ng-include=\"\'app/popups/setting_Ctrl.html\'\"></div>\r\n  </div>\r\n  <!-- Organized Table start -->\r\n  <form ng-if=\"$root.showOrganized\" name=\"uploadform\" id=\"uploadform\" ng-controller=\"OrganizedTblCtrl\" class=\"closeForm\">\r\n    <fieldset>\r\n      <legend>&nbsp;\r\n        <strong>Download File</strong>&nbsp;</legend>\r\n      <h2>Select State</h2>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label\" for=\"email\">State </label>\r\n        <div class=\"controls\">\r\n          <select class=\"changeTextColor\" ng-model=\"address.state\" style=\"text-transform: capitalize;\" ng-change=\"getOrganizedData()\" ng-options=\"item.state for item in allState track by item.state\"></select>&nbsp;\r\n          <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loader\"></i>\r\n        </div>\r\n      </div>\r\n      <div ng-if=\"displayLong\" style=\"color:red; font-size:12px;\" class=\"blink\">This may take several minutes depending on number of records so please be patient.</div>\r\n      <div ng-if=\"recordLength > 0\">\r\n        <p>Total records\r\n          <span>{{recordLength}}</span>.\r\n          <!-- <a href=\"javascript: void(0);\" ng-json-export-excel data=\"ziprecords\" >Click here</a> to download. -->\r\n          <a href=\"javascript: void(0);\" ng-json-export-excel data=\"ziprecords\" report-fields=\'{_id : \"ID\", zipname : \"zipname\", ZIPCensusTabulationArea : \"ZIPCensusTabulationArea\", secondarySchoolDistrictName : \"secondarySchoolDistrictName\", secondarySchoolDistrict : \"secondarySchoolDistrict\", elementarySchoolDistrictName : \"elementarySchoolDistrictName\", elementarySchoolDistrict : \"elementarySchoolDistrict\", unifiedSchoolDistrictName : \"unifiedSchoolDistrictName\", unifiedSchoolDistrict : \"unifiedSchoolDistrict\", stateHouseOFRepresentativeDistrict : \"stateHouseOFRepresentativeDistrict\", stateSenateDistrict : \"stateSenateDistrict\", federalCongrassionalDist : \"federalCongrassionalDist\", voterDistrictName : \"voterDistrictName\", voterDistrict : \"voterDistrict\", place : \"place\", FIPSplace : \"FIPSplace\", countySubdivision : \"countySubdivision\", FIPScountySub : \"FIPScountySub\", county : \"county\", FIPScounty : \"FIPScounty\", statePostalCode : \"statePostalCode\", FIPSstate : \"FIPSstate\", afact : \"afact\", census2010 : \"census2010\"}\'\r\n                  class=\"css-class\"> Export to excel</a>\r\n        </p>\r\n      </div>\r\n    </fieldset>\r\n    <br />\r\n    <fieldset>\r\n      <legend>&nbsp;\r\n        <strong>Upload File</strong>&nbsp;</legend>\r\n      <h2>Select State</h2>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label\" for=\"email\">State </label>\r\n        <div class=\"controls\">\r\n          <select class=\"changeTextColor\" ng-model=\"address.upstate\" style=\"text-transform: capitalize;\" ng-options=\"item.state for item in allState track by item.state\"></select>&nbsp;\r\n          <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loader\"></i>\r\n        </div>\r\n      </div>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label\" for=\"file\">Upload File </label>\r\n        <div class=\"controls\">\r\n          <input type=\"file\" file-model=\"address.files\" class=\"form-control input-md text-input\" accept=\".xlsx\">\r\n          <p ng-show=\"upload.maxSizeError\">Max file size exceeded (2000 bytes)</p>\r\n        </div>\r\n      </div>\r\n      <div class=\"control-group\" style=\"padding:10px;\">\r\n        <div class=\"controls\">\r\n          <button ng-click=\"updateZips(address)\" type=\"submit\" class=\"btnShort-style\" style=\"float: left;\">Save</button>&nbsp;\r\n          <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"UploadLoader\"></i>\r\n        </div>\r\n      </div>\r\n    </fieldset>\r\n  </form>\r\n  <!-- Organized Table End -->\r\n</div>\r\n");
$templateCache.put("app/orgMatch/orgMatch.html","<style type=\"text/css\">\r\n  .digDeeperSmall {\r\n    width: 150px;\r\n  }\r\n</style>\r\n<div>\r\n  <center>\r\n    <h2>Match</h2>\r\n  </center>\r\n\r\n  <div ng-if=\"showcomparison == false && questions.length > 0\">\r\n    <center>\r\n      <a href=\"\" ng-click=\"showDetails()\"><button class=\"compareBtn\"> Match Details</button></a>\r\n    </center>\r\n    <br><br>\r\n  </div>\r\n    <div style=\"text-align:left;\" ng-if=\"showcomparison == false && questions.length > 0\">\r\n\r\n      <div ng-if=\"noDataFound == false\">\r\n        <div class=\"squareBoxY\" style=\"margin-left:10px;\">&nbsp;</div>\r\n        <span>= Simple Comparison by answers alone.</span>\r\n        <div style=\"clear:both;\"></div>\r\n        <div class=\"squareBoxB\" style=\"margin-left:10px\">&nbsp;</div>\r\n        <span>= Weighted Comparison by answers and importance.</span>\r\n        <div style=\"clear:both;\"></div>\r\n      </div>\r\n\r\n      <ul class=\"catList\" ng-if=\"noDataFound == false\">\r\n        <!-- <li ng-if=\"FBunWeighted[AllUsers._id] && fbcombinedWeight[AllUsers._id]\">\r\n          <div style=\"background-color:#ffffee; padding:10px;\">\r\n            <div style=\"color: #000000;\">\r\n              <b>{{orgName}}</b>&nbsp;&nbsp;&nbsp;Total\r\n              Answered questions: {{fbqlen[AllUsers._id]}}\r\n            </div>\r\n            <div style=\"width: 84%; float:left;\">\r\n              <div>\r\n                <div class=\"fbunweighted\"\r\n                  style=\"width:{{(FBunWeighted[AllUsers._id] / fbqlen[AllUsers._id] )  | number:2}}%\">\r\n                  {{(FBunWeighted[AllUsers._id] / fbqlen[AllUsers._id] ) | number:2}}%</div>\r\n              </div>\r\n              <div>\r\n                <div class=\"fbweighted\"\r\n                  style=\"width:{{(fbcombinedWeight[AllUsers._id] / fbmultiplier[AllUsers._id])  | number:2}}%\">\r\n                  {{(fbcombinedWeight[AllUsers._id] / fbmultiplier[AllUsers._id]) | number:2}}%</div>\r\n              </div>\r\n            </div>\r\n            <div style=\"clear:both;\"></div>\r\n          </div>\r\n        </li> -->\r\n        <li ng-repeat=\"frd in AllUsers track by $index\" ng-if=\"FBunWeighted[frd._id] && fbcombinedWeight[frd._id]\">\r\n          <div style=\"background-color:#ffffee; padding:10px;\">\r\n            <div style=\"color: #000000;\">\r\n              <b ng-if=\"frd.name && frd.name !=\'\' && !orgName\">{{frd.name}}</b>\r\n              <b ng-if=\"orgName\">{{orgName}}</b>&nbsp;&nbsp;&nbsp;Total\r\n              Answered questions: {{fbqlen[frd._id]}}\r\n\r\n            </div>\r\n            <div style=\"width: 84%; float:left;\">\r\n              <div>\r\n                <div class=\"fbunweighted\" style=\"width:{{(FBunWeighted[frd._id] / fbqlen[frd._id] )  | number:2}}%\">\r\n                  {{(FBunWeighted[frd._id] / fbqlen[frd._id] ) | number:2}}% Match</div>\r\n              </div>\r\n              <div>\r\n                <div class=\"fbweighted\"\r\n                  style=\"width:{{(fbcombinedWeight[frd._id] / fbmultiplier[frd._id])  | number:2}}%\">\r\n                  {{(fbcombinedWeight[frd._id] / fbmultiplier[frd._id]) | number:2}} Weighted Match%</div>\r\n              </div>\r\n            </div>\r\n            <div style=\"clear:both;\"></div>\r\n          </div>\r\n        </li>\r\n      </ul>\r\n      <div ng-if=\"noDataFound == true\">\r\n        <h3>\r\n          <p style=\"color:red\">Congratulations! You are the first person in your region to take this quiz. You are a\r\n            true\r\n            pioneer! You should contact your local politicians and your friends to encourage them to use this site.\r\n            There\r\n            are still plenty of wonderful things here to see.</p>\r\n        </h3>\r\n        <br>\r\n        <br>\r\n        <div class=\"margin-auto mxw\">\r\n          <div class=\"digDeeperSmall\" style=\"float:left\">\r\n            <a href=\"#!/digDeeper\"><img ng-src=\"../assets/images/DigDeeper.svg\" alt=\"Dig deeper\"/></a></div>\r\n          <button class=\"btnB275\" style=\"width:150px; float:right;\" ng-click=\"finalSignIn()\">Sign In</button>\r\n        </div>\r\n\r\n      </div>\r\n    </div>\r\n    <div class=\"alert alert-danger alert-dismissible\" id=\"alert\" ng-if=\"showAlert\" style=\"width:60%;margin-left:\r\n              20%;margin-top:10%\">\r\n      <button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button>\r\n      <strong> Please verify your email first. </strong>\r\n    </div>\r\n    <!--     <h2>BACKGROUND</h2></center>\r\n      <p></p>\r\n      <p ng-bind-html=\"category.description | newlines\"></p>-->\r\n    <div ng-if=\"loader\" class=\"fwb\">\r\n      Loading data ...\r\n      <p>\r\n        <center><i class=\"fa fa-refresh fa-spin\" style=\"font-size:72px;\"></i></center>\r\n      </p>\r\n    </div>\r\n\r\n    <div ng-if=\"showcomparison == true && !loader\">\r\n      <div>\r\n        <div>\r\n          <p>\r\n            <h1>\r\n              <center>{{category.title}}</center>\r\n            </h1>\r\n          </p>\r\n          <p></p>\r\n          <div>\r\n            <center ng-if=\"category.fbImage\">\r\n              <img ng-src=\"https://api.votewise.net/resources/{{category.fbImage}}\" class=\"wibble\" /></center>\r\n          </div>\r\n          <center id=\"DisplayC\">\r\n            <h2>BACKGROUND</h2>\r\n          </center>\r\n          <p></p>\r\n          <p ng-bind-html=\"category.description | newlines\"></p>\r\n        </div>\r\n        <div ng-show=\"questions[currentIndex]\">\r\n          <!-- <type=\"button\" value=\"LEARN MORE\"> -->\r\n          <!--      <button ng-click=\"$root.printPage()\" class=\"print-hide changeTextColor\">Print this page</button>  -->\r\n          <p></p>\r\n          <center id=\"DisplayQ\">\r\n            <h2>QUESTION</h2>\r\n          </center>\r\n          <p></p>\r\n          <p></p>\r\n          <center>({{currentIndex+1}} of {{questions.length}})</center>\r\n          <p></p>\r\n          <p>STATEMENT: <span class=\"card-text\" ng-bind-html=\"questions[currentIndex].content | newlines\"></span></p>\r\n          Your Answers<span  style=\"margin-left: 30px;\">Their Answers</span>\r\n          <div class=\"clearfix\">\r\n            <div class=\"pull-left ans-col\" style=\"border-right: 3px solid #de8998;\">\r\n              <div class=\"pad10\">\r\n                <div class=\"clearfix\" style=\"line-height: 9px\">\r\n                  <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\">\r\n                    <span class=\"inl-blk\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n                    <span class=\"inl-blk\" ng-if=\"i == 6\">DISAGREE</span>\r\n                    <div class=\"cq-box inl-blk pull-right\"\r\n                      ng-class=\"(questions[currentIndex].my_answer.answer == i) ? (\'ag-green\') : \'\'\"></div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"clearfix\">\r\n                  <div class=\"mb5 clearfix\"><br>\r\n                    <div class=\"inl-blk pull-right\">MATCH %</div>\r\n                  </div>\r\n                </div><br>\r\n                <div class=\"clearfix\" style=\"line-height: 9px\">\r\n                  <p>IMPORTANCE</p>\r\n                  <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\">\r\n                    <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n                    <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n                    <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                    <div class=\"cq-box inl-blk pull-right \"\r\n                      ng-class=\"(questions[currentIndex].my_answer.importance == i) ? \'ag-dg\' : \'\'\"></div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"clearfix\"><br>\r\n                  <p>COMMENTS</p>\r\n                  <div class=\"mb5 clearfix\">\r\n                    <div class=\"inl-blk pull-right\">\r\n                      <span class=\"clk ylink\" ng-if=\"!(questions[currentIndex].my_answer.comment | isBlankString)\" ng-click=\"viewAnsComment(questions[currentIndex].my_answer)\">READ</span>\r\n                      <span ng-if=\"questions[currentIndex].my_answer.comment | isBlankString\">None</span>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"clearfix vtxt-wrap pad10\" style=\"height:342px;\">\r\n              </div>\r\n            </div>\r\n            <div class=\"pull-left ans-col\" ng-repeat=\"ans in questions[currentIndex].answers\" ng-if=\"ans.author.name\">\r\n              <div class=\"pad10\">\r\n                <div class=\"clearfix\" style=\"height: 120px;\">\r\n                  <div ng-if=\"ans.answer > -1\" ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\">\r\n                    <div class=\"cq-box inl-blk pull-right\"\r\n                      ng-class=\"(ans.answer == i) ? getComapreClass(ans.match, i) : \'\'\"></div>\r\n                    <!-- ng-class=\"(ans.answer == i) ? (\'ag-dg\'+i) : \'\'\" -->\r\n                  </div>\r\n                  <div ng-if=\"!ans.answer\" class=\"flex w100 h100\">\r\n                    <span><b>N/A</b></span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"clearfix\" style=\"height: 32px;\">\r\n                  <div class=\"mb5 clearfix\"><br>\r\n                    <div ng-if=\"ans.match != null\" class=\"inl-blk pull-right\">{{ans.match}}%</div>\r\n                    <div ng-if=\"ans.match == null\" class=\"w100 text-center fwb\">N/A</div>\r\n                  </div>\r\n                </div><br>\r\n                <div class=\"clearfix\" style=\"height: 111px;\">\r\n                  <p>&nbsp;</p>\r\n                  <div ng-if=\"ans.importance\" ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\">\r\n                    <div class=\"cq-box inl-blk pull-right \" ng-class=\"(ans.importance == i) ? \'ag-dg\' : \'\'\"></div>\r\n                  </div>\r\n                  <div ng-if=\"!ans.importance\" class=\"flex w100 h100\">\r\n                    <span><b>N/A</b></span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"clearfix\">\r\n                  <p>&nbsp;</p>\r\n                  <div class=\"mb5 clearfix\">\r\n                    <span class=\"clk ylink\" ng-if=\"ans.comment && !(ans.comment | isBlankString)\" ng-click=\"viewAnsComment(ans)\">READ</span>\r\n                    <span ng-if=\"ans.comment && (ans.comment | isBlankString)\">No</span>\r\n                    <span ng-if=\"!ans.comment\" class=\"fwb\">N/A</span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"clearfix vtxt-wrap pad10\">\r\n                <div class=\"ver-txt\" style=\"width:345px;margin-top:31%;\">\r\n                  <div style=\"line-height:12px;\">\r\n                    {{orgName || ans.author.name_on_ballot || ans.author.name}}</div>\r\n                  <div style=\"line-height:12px;\" ng-repeat=\"pitem in ans.author.politicianInfo\"\r\n                    ng-if=\"pitem.candidateStatus==\'Running\'\">{{pitem.officeName}}</div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"mb5 clearfix print-hide\">\r\n          <!-- <a class=\"clk fwb\" ng-click=\"prevQuestion()\">Prev</a>&nbsp;\r\n                    <a class=\"clk fwb\" ng-click=\"skipQuestion()\">Next</a> -->\r\n          <button class=\"compareBtnS\" ng-click=\"prevQuestion()\"><i class=\"fa fa-angle-left arrowIconBack\"></i>Prev</button>\r\n          <button class=\"compareBtnS\" ng-click=\"skipQuestion()\">Next<i class=\"fa fa-angle-right arrowIconSubmit\"></i></button>\r\n        </div>\r\n        <button class=\"compareBtn\"><a href=\"#!/whatAmILookingAt4\">What Am I Looking At?</a></button>\r\n      </div>\r\n    </div>\r\n    <div ng-if=\"status.questions == 2 && questions.length == 0\" class=\"fwb\">\r\n      <center>No unanswered questions found.</center>\r\n    </div>\r\n    <div ng-if=\"status.questions == 1\" class=\"fwb\">\r\n      Loading questions ...\r\n    </div>\r\n    <div ng-if=\"status.questions == 3\" class=\"fwb\">\r\n      Something went wrong while loading questions.\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/organizationQuiz/organizationQuiz.html","<div class=\"container-fluid\">\r\n  <h2 class=\"pageHeading\">INVITED QUIZ</h2>\r\n  <div class=\"pageSubHeading\" ng-if=\"orgInfo.title\">Quiz created by\r\n    <span style=\"text-transform: capitalize;\">{{orgInfo.title}}</span></div>\r\n  <!-- <p>Followers: {{orgUser.}}</p> -->\r\n  <!-- BRING BACK  -->\r\n  <!-- <p ng-if=\"followersCnt\">\r\n    Followers:\r\n    <a href=\"#!/orgActivityDetails/followers\" class=\"ylink\">{{followersCnt}}</a>,</p> -->\r\n\r\n  <!-- <pre>{{status.category}} | {{status.levlCat}}</pre> -->\r\n  <!-- display {{questions[currentIndex]}} -->\r\n  <!-- length {{questions.length}} -->\r\n  <div id=\"fiveMinPage\" ng-show=\"category && !showZipCode\">\r\n    <div id=\"DisplayQ\">\r\n      <div>\r\n        <p>\r\n          <h1>\r\n            <center>{{category.title}}</center>\r\n          </h1>\r\n        </p>\r\n        <p></p>\r\n        <div>\r\n          <center ng-if=\"category.fbImage\">\r\n            <img ng-src=\"https://api.votewise.net/resources/{{category.fbImage}}\" class=\"wibble\" /></center>\r\n        </div>\r\n        <center id=\"DisplayC\">\r\n          <h4 class=\"backgroundText\">BACKGROUND</h4>\r\n        </center>\r\n        <p></p>\r\n        <div class=\"row d-flex justify-content-center\">\r\n          <div class=\"col-lg-10 col-sm-12 \">\r\n            <p ng-bind-html=\"category.description | newlines\"></p>\r\n          </div>\r\n          <div ng-if=\"status.category == 1\" class=\"fwb\">\r\n            Loading category ...\r\n          </div>\r\n          <div ng-if=\"status.category == 3\" class=\"fwb\">\r\n            Something went wrong while loading category.\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div id=\"DisplayQ1\" class=\"row  d-flex justify-content-center\">\r\n      <center><label ng-hide=\"questions[currentIndex]\">\r\n      <input type=\"checkbox\" ng-model=\"flagSkipAnsweredQuestion\" ng-change=\"skipAnswerChagne()\"> Skip Answered Questions\r\n    </label></center>\r\n      <div class=\"col-lg-7 col-sm-12\" ng-show=\"questions[currentIndex] && !showZipCode\">\r\n        <h4 class=\"text-center\">Questions</h4>\r\n\r\n\r\n        <div class=\"card customCard\">\r\n          <div class=\"card-header quesCardHeaderMain\">\r\n            <div class=\"d-flex justify-content-between bd-highlight\">\r\n              <!-- <div class=\"p-2 bd-highlight quesCardHeader\">Statement</div> -->\r\n              <div class=\"p-2 bd-highlight\"><span class=\"textYellow\">{{currentIndex+1}}</span>/{{questions.length}}\r\n              </div>\r\n\r\n              <div id=\"anchor 1\" class=\"form-check anchor\">\r\n                <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"defaultCheck1\" ng-model=\"flagSkipAnsweredQuestion\" ng-change=\"skipAnswerChagne()\">\r\n                <label class=\"form-check-label checkboxLabel\" for=\"defaultCheck1\">\r\n                  Skip Answered Questions\r\n                </label>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"card-body customCardBody\">\r\n            <p  class=\"card-text\" ng-bind-html=\"questions[currentIndex].content | newlines\"></p>\r\n            <div class=\"row vdivide\">\r\n              <div class=\"col col-6\">\r\n                <div class=\"rcontent\" style=\"float:right;\">\r\n                  <span id=\"disagreeText\">DISAGREE &nbsp</span>\r\n                  <div style=\"float:right;\">\r\n                    <div class=\"box\">\r\n                      <ul class=\"vi-radio\">\r\n                        <li>\r\n                          <input type=\"radio\" id=\"agreedisagree-id6\" name=\"agreeDisagree\" value=\"6\" ng-model=\"answer\" ng-checked=\"checkIfExists(6)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                          <label for=\"agreedisagree-id6\"></label>\r\n                          <div class=\"checknew red sixth\"></div>\r\n                        </li>\r\n                      </ul>\r\n                    </div>\r\n                    <div class=\"box\">\r\n                      <ul class=\"vi-radio\">\r\n                        <li>\r\n                          <input type=\"radio\" id=\"agreedisagree-id5\" name=\"agreeDisagree\" value=\"5\" ng-model=\"answer\" ng-checked=\"checkIfExists(5)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                          <label for=\"agreedisagree-id5\"></label>\r\n                          <div class=\"checknew five fifth\"></div>\r\n                        </li>\r\n                      </ul>\r\n                    </div>\r\n                    <div class=\"box\">\r\n                      <ul class=\"vi-radio\">\r\n                        <li>\r\n                          <input type=\"radio\" id=\"agreedisagree-id4\" name=\"agreeDisagree\" value=\"4\" ng-model=\"answer\" ng-checked=\"checkIfExists(4)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                          <label for=\"agreedisagree-id4\"></label>\r\n                          <div class=\"checknew four forth\"></div>\r\n                        </li>\r\n                      </ul>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col col-6\">\r\n                <div class=\"radio-container rcontent\">\r\n                  <span  style=\"color: #04A752; font-weight: bold;\">&nbsp;AGREE</span>\r\n                  <div style=\"float:left;\">\r\n                    <div class=\"box\">\r\n                      <ul class=\"vi-radio\">\r\n                        <li>\r\n                          <input type=\"radio\" id=\"agreedisagree-id3\" name=\"agreeDisagree\" value=\"3\" ng-model=\"answer\" ng-checked=\"checkIfExists(3)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                          <label for=\"agreedisagree-id3\"></label>\r\n                          <div class=\"checknew three third\"></div>\r\n                        </li>\r\n                      </ul>\r\n                    </div>\r\n                    <div class=\"box\">\r\n                      <ul class=\"vi-radio\">\r\n                        <li>\r\n                          <input type=\"radio\" id=\"agreedisagree-id2\" name=\"agreeDisagree\" value=\"2\" ng-model=\"answer\" ng-checked=\"checkIfExists(2)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                          <label for=\"agreedisagree-id2\"></label>\r\n                          <div class=\"checknew two second\"></div>\r\n                        </li>\r\n                      </ul>\r\n                    </div>\r\n                    <div class=\"box\">\r\n                      <ul class=\"vi-radio\">\r\n                        <li>\r\n                          <input type=\"radio\" id=\"agreedisagree-id1\" name=\"agreeDisagree\" value=\"1\" ng-model=\"answer\" ng-checked=\"checkIfExists(1)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                          <label for=\"agreedisagree-id1\"></label>\r\n                          <div class=\"checknew first\"></div>\r\n                        </li>\r\n                      </ul>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        \r\n        <div class=\"card card1\">\r\n          <div class=\"card-header card1Header\">\r\n            <p class=\"card-title\">ADD COMMENT</p>\r\n          </div>\r\n          <div class=\"card-body card1Body\">\r\n            <textarea class=\"form-control addComment\" ng-model=\"updata.comment\" rows=\"1\" placeholder=\"(not required)\"></textarea>\r\n            <textarea ng-show=\"dis\" ng-model=\"updata.reason\" id=\"txtReason\" name=\"txtReason\" class=\"vi-textarea\" placeholder=\"REASON TO CHANGE ANSWER\" style=\"margin-top: 10px;\"></textarea>\r\n          </div>\r\n        </div>\r\n\r\n\r\n        <div class=\"card card1\">\r\n          <div class=\"card-header card1Header\">\r\n            <p class=\"card-title\">IMPORTANCE</p>\r\n            <!-- <h4>Hello {{importance}}</h4> -->\r\n\r\n          </div>\r\n          <div class=\"card-body card1Body\" style=\"margin:0 auto;\">\r\n            <form class=\"impSection d-md-flex d-sm-block\">\r\n              <div class=\"A\">\r\n                <input type=\"radio\" class=\"button\" id=\"importance-id1\" ng-model=\"importance\" ng-checked=\"checkImpExists(1)\" ng-click=\"oneMore(1); $event.stopPropagation();\" value=\"1\"></input>\r\n                <label for=\"importance-id1\">Not Very</label>\r\n              </div>\r\n              <div class=\"B\">\r\n                <input type=\"radio\" class=\"button\" id=\"importance-id2\" ng-model=\"importance\" ng-checked=\"checkImpExists(2)\"  ng-click=\"oneMore(2); $event.stopPropagation();\" value=\"2\"></input>\r\n                <label for=\"importance-id2\">Somewhat</label>\r\n              </div>\r\n              <div class=\"C\">\r\n                <input type=\"radio\" class=\"button\" id=\"importance-id3\" ng-model=\"importance\" ng-checked=\"checkImpExists(3)\"  ng-click=\"oneMore(3); $event.stopPropagation();\" value=\"3\"></input>\r\n                <label for=\"importance-id3\">Very</label>\r\n              </div>\r\n              <!-- </div> -->\r\n            </form>\r\n          </div>\r\n        </div>\r\n\r\n\r\n\r\n        <center>\r\n          <div ng-if=\"showLoader\" style=\"z-index: 2; background:black;\">\r\n            <i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span>\r\n          </div>\r\n\r\n        </center>\r\n        <div class=\"row\">\r\n          <div class=\"col bottomBtns\">\r\n            <div class=\"btn-group\" role=\"group\" aria-label=\"Default button group\">\r\n              <button type=\"button\" id=\"backBtn\" class=\"btn-transparent\" ng-click=\"prevQuestion()\"> <i class=\"fa fa-angle-left arrowIconBack\"></i> Back</button>\r\n              <button type=\"button\" id=\"skipBtn\" class=\"btn-transparent\" ng-click=\"skipQuestion()\">Skip</button>\r\n              <button type=\"button\" id=\"submitBtn\" class=\"btn-transparent\" ng-click=\"submitAnswer()\" ng-class=\"{\'activeSubmit\': (answer &&importance)}\">Submit <i class=\"fa fa-angle-right arrowIconSubmit\"></i></button>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n\r\n\r\n      </div>\r\n    </div>\r\n    <center>\r\n      <button ng-if=\"skipToMatchNew\" type=\"button\" id=\"skipToMatchNew\"  class=\"skipToFinal\" ng-click=\"skipToMatchs()\">Skip to Question Comparison</button>\r\n    </center>\r\n    <center>\r\n      <button ng-if=\"skipToFinal\" type=\"button\" id=\"skipToFinal\"  class=\"skipToFinal\" ng-click=\"skipToCompare()\">Skip to Overall Comparison</button>\r\n    </center>\r\n  </div>\r\n  <div class=\"news\" style=\"padding-top:20px;\" ng-if=\"showZipCode == true\">\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Where do you live?</legend>\r\n      <form name=\"fivemin\" id=\"fiveminzip\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\">Street Address (LEAVE OUT APT #)<br>(This is used for location based tools like finding your representatives. Feel free to use an intersection instead of your actual address)</label>\r\n              <div class=\"control-group\">\r\n                <input type=\"text\" id=\"address\" ng-model=\"User.Address\" ng-keyup=\"detectAddress($event)\" class=\"zipInput form-control\" />&nbsp;\r\n              </div>\r\n              </div>\r\n              <div ng-if=\"showAddressDropDown\">\r\n                <div>\r\n                  <br>\r\n                  <span ng-if=\"address.state.state\" >State:</span><span>  {{address.state.state}}</span>\r\n                  <br>\r\n                  <span ng-if=\"address.state.statePostalCode\" >State Postal Code:</span><span>  {{address.state.statePostalCode}}</span>\r\n                  <br>\r\n                  <span ng-if=\"countyName[0].NAMELSAD\" >County:</span><span>  {{countyName[0].NAMELSAD}}</span>\r\n                  <br>\r\n                  <span ng-if=\"placeName[0].NAMELSAD\" >City:</span><span>  {{placeName[0].NAMELSAD}}</span>\r\n                  <br>\r\n                  <span ng-if=\"federalCongrassionalDist[0].CD115FP\" >Federal Congressional District: </span><span>  {{federalCongrassionalDist[0].CD115FP}}</span>\r\n                  <br>\r\n                  <span ng-if=\"unifiedSchoolDistrictNames[0].NAME\" >School District: </span><span>  {{unifiedSchoolDistrictNames[0].NAME}}</span>\r\n                  <br>\r\n                  <span ng-if=\"stateSenateDistrict[0].NAMELSAD\" >State Senate District:</span><span>  {{stateSenateDistrict[0].NAMELSAD}}</span>\r\n                  <br>\r\n                  <span ng-if=\"StateHouseOFRepresentativeDistricts[0].NAMELSAD\" >StateHouseOFRepresentativeDistricts:</span><span>  {{stateHouseOFRepresentativeDistricts[0].NAMELSAD}}</span>\r\n                  <br>\r\n                </div>\r\n                  <!-- <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel removeTopMargin\" for=\"email\">State </label>\r\n                  <div class=\"controls\">\r\n                    <select class=\"changeTextColor\" ng-model=\"address.state\" style=\"text-transform: capitalize;\" disabled=\"true\" ng-change=\"getCounties()\" ng-class=\"\" ng-options=\"item.state for item in states track by item.statePostalCode\"></select>\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"email\">County </label>\r\n                  <div class=\"controls\">\r\n                    <select class=\"changeTextColor\" ng-model=\"address.county\" style=\"text-transform: capitalize;\" disabled=\"true\" ng-options=\"item.county for item in allcounties track by item.countyFips\" ng-change=\"onCountyChange()\"></select>\r\n                  </div>\r\n                </div> -->\r\n                  <!--    <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\" for=\"email\">Sub county </label>\r\n              <div class=\"controls\">\r\n                <select class=\"changeTextColor\" ng-model=\"address.countySubdivision\" disabled=\"true\" style=\"text-transform: capitalize;\" ng-options=\"countySubdivision as item._id.countySubdivision for item in places | unique:\'_id.countySubdivision\' track by item._id.countySubdivision\" ng-change=\"onSubCountyChange()\"></select>\r\n              </div>\r\n            </div> -->\r\n                  <!-- <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"email\">City </label>\r\n                  <div class=\"controls\">\r\n                    <select class=\"changeTextColor\" ng-model=\"address.place\" disabled=\"true\" style=\"text-transform: capitalize;\" ng-options=\"item as item.place for item in places track by item.place\"></select>\r\n                  </div>\r\n\r\n                </div> -->\r\n                  <!--      <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\" for=\"email\">Voter District (click if incorrect) </label>\r\n              <div class=\"controls\">\r\n                <select class=\"changeTextColor\" ng-model=\"address.voterDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item.voterDistrictName for item in voterDistricts track by item.voterDistrictName\" ng-change=\"onVoterDistChange()\" ng-class=\"{yellowBackground: voterDistricts.length > 1}\"></select>\r\n              </div>\r\n            </div> -->\r\n                  <!-- <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"email\">Federal Congressional District (click if incorrect) </label>\r\n                  <div class=\"controls\">\r\n                    <select class=\"changeTextColor\" ng-model=\"address.federalCongrassionalDist\" style=\"text-transform: capitalize;\" ng-options=\"item as item.CD115FP for item in federalCongrassionalDist track by item.CD115FP\" ng-class=\"checkLength(federalCongrassionalDist, \'federalCongrassionalDist\')\"></select>\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"email\">State Senate District (click if incorrect) </label>\r\n                  <div class=\"controls\">\r\n                    <select class=\"changeTextColor\" ng-model=\"address.stateSenateDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item.NAMELSAD for item in stateSenateDistrict track by item.SLDUST\" ng-class=\"checkLength(stateSenateDistrict, \'stateSenateDistrict\')\"></select>\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"email\">State House of Representative District (click if incorrect) </label>\r\n                  <div class=\"controls\">\r\n                    <select class=\"changeTextColor\" ng-model=\"address.stateHouseOFRepresentativeDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item.NAMELSAD for item in stateHouseOFRepresentativeDistricts track by item.NAMELSAD\" ng-class=\"checkLength(stateHouseOFRepresentativeDistricts, \'stateHouseOFRepresentativeDistrict\')\"></select>\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"email\">School District Name (click if incorrect) </label>\r\n                  <div class=\"controls\">\r\n                    <select class=\"changeTextColor\" ng-model=\"address.unifiedSchoolDistrictName\" style=\"text-transform: capitalize;\" ng-options=\"item as item.NAME for item in unifiedSchoolDistrictNames track by item.NAME\" ng-class=\"checkLength(unifiedSchoolDistrictNames, \'unifiedSchoolDistrictName\')\"></select>\r\n                  </div>\r\n                </div> -->\r\n                  <br>\r\n                  <!-- <div class=\"control-group\">\r\n                    <p>\r\n                      Don\'t know your info?\r\n                      <a href=\"javascript: void(0);\" ng-click=\"showFindAddress();\" class=\"ylink\">Click Here</a>\r\n                    </p>\r\n                  </div> -->\r\n                  <div style=\"clear: both;\"></div>\r\n                  <button class=\"btnShort-style\" ng-click=\"confirmPopup()\" type=\"button\" class=\"btn btn-success\" style=\"float: right;\">Done</button>\r\n                  <div style=\"clear: both;\"></div>\r\n                  <div style=\"float: right; margin-right: 20px; margin-top: 7px;\">Already a member?\r\n                    <a style=\"text-decoration: underline;\" href=\"#!/fiveminsignin\" class=\"ylink\">Sign in</a></div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n      </form>\r\n    </fieldset>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/orgQuestions/orgQuestions.html","<div class=\"container-fluid\" ng-cloak ng-show=\"$root.userRole==\'admin\'|| $root.userRole==\'advocate\'\">\r\n  <h2 class=\"pageHeading\">MANAGE QUESTIONS</h2>\r\n  <p class=\"pageSubHeading noPaddBott\">Drag and drop the questions to change the order of the questions for your quiz.\r\n  </p>\r\n\r\n  <div>\r\n    <a href=\"#!/allQuizzes\" class=\"ylink\">Back</a>\r\n  </div>\r\n\r\n  <form name=\"orgQue\" id=\"orgQue\" ng-controller=\"orgQuestionsCtrl\">\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Manage Questions</legend>\r\n      <div class=\"row\">\r\n\r\n\r\n\r\n        <table class=\"w100 changeTextColor\" ng-if=\"questions.length > 0\" style=\"margin-top: 10px;\">\r\n          <tr>\r\n            <th>Question Id</th>\r\n            <!-- <th>Order</th> -->\r\n            <th>Questions</th>\r\n            <th>Edit Questions</th>\r\n          </tr>\r\n          <tr ng-repeat=\"item in questions\" data-drop=\"true\" data-drag=\"true\" ng-model=\"questions\"\r\n            jqyoui-droppable=\"{index: {{$index}},onDrop:\'drop(item.qOrder,item._id,$index)\'}\"\r\n            jqyoui-draggable=\"{index: {{$index}}, insertInline: true, direction:\'jqyouiDirection\',onStart:\'start(item.qOrder,item._id,$index)\'}\"\r\n            data-jqyoui-options=\"{revert: \'invalid\',helper: \'clone\',zIndex: 350}\"\r\n            data-direction=\"{{item.jqyouiDirection}}\">\r\n            <td>{{item.queId}}</td>\r\n            <!-- <td>{{item.qOrder}}</td> -->\r\n            <td>\r\n              {{item.content}}\r\n            </td>\r\n            <td>\r\n\r\n              <a ng-if=\" $root.userRole==\'advocate\'\" href=\" javascript: void(0)\" ng-click=\"removeQue(item)\" class=\"link\">\r\n            Remove</a>\r\n              <span class=\"fwb\" ng-if=\"item.apiApproveStatus == 1\"><br> Requesting ...</span>\r\n            </td>\r\n          </tr>\r\n        </table>\r\n      </div>\r\n    </fieldset>\r\n  </form>\r\n</div>\r\n");
$templateCache.put("app/orgQuizComparison/orgQuizComparison.html","<div class=\"container-fluid\">\r\n\r\n\r\n  <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n    <div class=\"blockLink\">\r\n      <div class=\"showFollQuizDetails gettingStartedBlock1\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\" style=\"text-transform: uppercase;\"><b>Congratulation</b></h4>\r\n          <p class=\"gettingStartedBlockDesc\">Congratulations! You have completed the quiz. A notice has been sent to\r\n            <b style=\"text-transform: capitalize;\">{{orgName}}</b> to let them know, but it wouldn’t hurt to contact\r\n            them directly just in case.\" </p>\r\n\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <center>\r\n      <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"moreQuizzes()\">\r\n        More quizzes\r\n       </button>\r\n      <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"seeContact()\">\r\n        See contact info\r\n       </button>\r\n\r\n      <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"seeComparison()\">\r\n        See Comparison of Quiz\r\n       </button>\r\n    </center>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/orgQuizIntro/orgQuizIntro.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">SPECIAL QUIZ</h2>\r\n  <p class=\"pageSubHeading\">You have been invited by (org name) to answer a (number of questions) question quiz.  They are interested in knowing your stance on these issues so they can decide if they should support you and how best to do so.</p>\r\n  <div class=\"row\">\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/userProfile/\" class=\"blockLink\"><img ng-src=\"./assets/images/quiz.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock1\">\r\n          <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">TAKE THE QUIZ</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Click here to take the quiz that (org name) invited you to take</p>\r\n          \r\n        </div>\r\n      </div></a>\r\n    </div>\r\n      <br>\r\n      <br>\r\n       <h2 class=\"pageHeading\">OTHER QUIZZES</h2>\r\n  <p class=\"pageSubHeading\">You have a lot of quizzes available to you.  Use them to express your concerns, reach voters, or connect with other people fighting for the same things you care about.</p>\r\n      <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/compositeQuiz\" class=\"blockLink\"><img ng-src=\"./assets/images/OrgQuiz.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock2\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">OTHER ORG QUIZZES</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Take quizzes created by other organizations.</p>\r\n          \r\n        </div>\r\n      </div></a>\r\n    </div>\r\n     \r\n     <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/getPopularQues\" class=\"blockLink\"><img ng-src=\"./assets/images/popular.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock4\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">MOST POPULAR</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Find and answer the questions answered by the most voters, politicians or organizations.  </p>    \r\n        </div>\r\n      </div></a>\r\n    </div>\r\n         \r\n\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/winVoters\" class=\"blockLink\"><img ng-src=\"./assets/images/clipBoard2.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock3\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">IMPORTANT TO YOU</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Explore different topics and take the quizzes on the subjects that are most important to you so that others can know where you stand.  Let potential voters and allies find you. </p>\r\n          \r\n        </div>\r\n      </div></a>\r\n    </div>\r\n  \r\n   <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/fiveMatch#DisplayQ\" class=\"blockLink\"><img ng-src=\"./assets/images/5minQuiz1.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock4\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">FIVE MINUTE MATCH</h4>\r\n          <p class=\"gettingStartedBlockDesc\">This is a five minute quiz aimed at voters who do not have the time to devote to deeper research.  Each year, the questions are chosen by people in the community who think these topics are important. </p>\r\n          \r\n        </div>\r\n            </div></a></div>\r\n       \r\n       <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/ballotMatch\" class=\"blockLink\"><img ng-src=\"./assets/images/ballotMatch.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock5\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">BALLOT MATCH</h4>\r\n          <p class=\"gettingStartedBlockDesc\">This is a quiz made up of all the questions answered by politicians in your area who are on the ballot for the next election. It could be a short quiz or it could be a really long one depending on their participation in this site.</p>\r\n          \r\n        </div>\r\n      </div></a>\r\n    </div>\r\n       \r\n       \r\n    </div>  \r\n  </div>\r\n\r\n");
$templateCache.put("app/orgRating/orgRating.html","<div class=\"container-fluid\">\r\n  <div>\r\n    <img ng-src=\"../assets/images/profile/{{item.returndata.createdby.utype}}.svg\" ng-if=\"item.returndata.createdby.utype\">\r\n\r\n\r\n    <h2 class=\"pageHeading\" style=\"text-transform: capitalize;\">{{press.title}}</h2>\r\n    <div class=\"pageSubHeading\">\r\n\r\n      <p ng-if=\"press.type == \'Advocate\'\" style=\"padding-left:7% !important\"><b>Organization</b></p>\r\n      <p ng-if=\"press.type == \'Press\'\"><b>Press</b></p>\r\n      <h3>Ratings </h3>\r\n      <p>Recommended : <input-stars max=\"5\" ng-click=\"PressVote(\'Recommended\');\" ng-model=\"vote.recommend\">\r\n        </input-stars>\r\n\r\n        <br/>Factual : <input-stars max=\"5\" ng-click=\"PressVote(\'Factual\');\" ng-model=\"vote.factual\">\r\n        </input-stars>\r\n      </p>\r\n\r\n\r\n    </div>\r\n\r\n\r\n\r\n    <!-- <div>\r\n          <h3>Take a quick vote </h3>\r\n          <p>Recommended : <input-stars max=\"5\" ng-click=\"PressVote(\'Recommended\');\" ng-model=\"vote.recommend\">\r\n            </input-stars>\r\n            <br/>Factual : <input-stars max=\"5\" ng-click=\"PressVote(\'Factual\');\" ng-model=\"vote.factual\">\r\n            </input-stars>\r\n          </p>\r\n        </div> -->\r\n\r\n  </div>\r\n\r\n</div>\r\n<div class=\"col-lg-12\">\r\n  <center>\r\n    <h3>Comments</h3>\r\n  </center>\r\n  <div>\r\n\r\n    <table ng-repeat=\"comment in essayComments  | orderBy :\'createdOn\' track by $index\" class=\"changeTextColor\">\r\n\r\n      <tr>\r\n        <th colspan=\"2\">{{comment.createdOn | date:\'medium\'}}</th>\r\n      </tr>\r\n      <tr>\r\n        <td width=\"20%;\">\r\n          <img src=\"../assets/images/profile/{{comment.createdBy.utype}}.svg\" style=\"width: 30px; height:30px;\" class= \"usertype\" alt=\"{{comment.createdBy.utype}}\" ng-if=\"comment.createdBy.utype!=\'admin\'\"/>\r\n          <img src=\"../assets/images/profile/voter.svg\" style=\"width: 30px; height:30px;\" class= \"usertype\" alt=\"{{comment.createdBy.utype}}\" ng-if=\"comment.createdBy.utype==\'admin\'\"/>\r\n          <br>\r\n          <div ng-if=\"comment.createdBy.utype==\'admin\'\">\r\n            <a href =\"#!/publicProfile/{{comment.createdBy.id}}\" style=\"text-transform: capitalize;\">{{comment.createdBy.name}}</a>\r\n          </div>\r\n          <div ng-if=\"comment.createdBy.utype==\'voter\'\">\r\n            <a href =\"#!/voterProfile/{{comment.createdBy.id}}\" style=\"text-transform: capitalize;\">{{comment.createdBy.name}}</a>\r\n          </div>\r\n          <div ng-if=\"comment.createdBy.utype==\'politician\'\">\r\n            <a href =\"#!/publicProfile/{{comment.createdBy.id}}\" style=\"text-transform: capitalize;\" ng-if=\"comment.createdBy.nameOn && comment.userData.isEmailVerified && comment.userData.verifiedUser\">{{comment.createdBy.nameOn}}</a>\r\n            <a href =\"#!/publicProfile/{{comment.createdBy.id}}\" style=\"text-transform: capitalize;\" ng-if=\"!comment.createdBy.nameOn && comment.userData.isEmailVerified && comment.userData.verifiedUser\">{{comment.createdBy.name}}</a>\r\n            <span ng-if=\"!comment.userData.isEmailVerified || !comment.userData.verifiedUser\">\r\n              Unknown Politician\r\n            </span>\r\n          </div>\r\n          <div ng-if=\"comment.createdBy.utype==\'advocate\'\">\r\n            <a href =\"#!/pressProfile/{{comment.createdBy.id}}\" style=\"text-transform: capitalize;\" ng-if=\"!comment.createdBy.title && comment.userData.isEmailVerified && comment.userData.verifiedUser\">{{comment.createdBy.name}}</a>\r\n            <a href =\"#!/pressProfile/{{comment.createdBy.id}}\" style=\"text-transform: capitalize;\" ng-if=\"comment.createdBy.title && comment.userData.isEmailVerified && comment.userData.verifiedUser\">{{comment.createdBy.title}}</a>\r\n            <span ng-if=\"!comment.userData.isEmailVerified || !comment.userData.verifiedUser\">\r\n              Unknown Organization\r\n            </span>\r\n          </div>\r\n\r\n        </td>\r\n\r\n        <td>\r\n          <div ng-bind-html=\'comment.comments | urlify\'></div>\r\n          <br>\r\n          <div style=\"text-align: left;\">\r\n            <i class=\"fa fa-thumbs-up thumbs\" ng-click=\"updateComments(\'like\', comment._id, $index);\" style=\"cursor:pointer;\" alt=\"Like\">\r\n            {{comment.totalLikes}}</i>\r\n            <i class=\"fa fa-thumbs-down thumbs\"  ng-click=\"updateComments(\'dislike\', comment._id, $index);\" style=\"cursor:pointer;\" alt=\"Dislike\">\r\n           {{comment.totalDislike}}</i>\r\n            <i class=\"fa fa-exclamation-triangle thumbs\" ng-click=\"updateComments(\'spam\', comment._id, $index);\" style=\"cursor:pointer; color:red;\" alt=\"Report Spam\">\r\n           {{comment.totalSpam}}</i>\r\n          </div>\r\n        </td>\r\n      </tr>\r\n    </table>\r\n    <div style=\"width: 90%; margin-bottom:10%;\">\r\n\r\n      <button ng-click=\"redirectToComment();\" ng-if=\"displayComments\" class=\"compareBtn\">Add comment</button>\r\n      <!-- </center> -->\r\n      <div class=\"inline2\" ng-if=\"ShowComments\">\r\n        <form name=\"essayform\" id=\"essayform\">\r\n          <fieldset class=\"scheduler-border\">\r\n            <legend class=\"scheduler-border\">Your Comments</legend>\r\n            <p></p>\r\n            <div class=\"row\">\r\n              <div class=\"col-md-12\">\r\n                <div class=\"control-group\">\r\n                  <div class=\"controls\">\r\n                    <textarea id=\"comments\" ng-model=\"comments.content\" placeholder=\"\" data-errormessage=\"Comments is required.\" class=\"form-control input-md  validate[required] text-area changeTextColor\" style=\"width: 80%; height: 100px;\"></textarea>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <!-- <div style=\"clear: both;\"></div> -->\r\n              <div style=\"margin-top:20px; width:100%;\">\r\n                <button ng-click=\"SubmitComment(comments)\" type=\"button\" class=\"compareBtn\" ng-disabled=\"CommentButton\" style=\"float: left;\">Submit Comments</button>\r\n                <center><button ng-click=\"goBack();\" type=\"button\" class=\"compareBtn\">Cancel</button>\r\n                </center>\r\n              </div>\r\n\r\n            </div>\r\n          </fieldset>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n</center>\r\n<div style=\"clear:both;\"></div>\r\n<script type=\"text/ng-template\" id=\"popUp\">\r\n  <div class=\"container\">\r\n   <p ng-if=\"showBoth && $root.userRole==\'politician\'\">You can read, but you can\'t write anything on the site until you confirm your email address.  <br><br> After you confirm your email, you can write, but everything will have the byline \"Unknown Politician\" until we can confirm your identification (then all your work will change to your byline).  You can wait for us to research you or you can use our automated ID confirmation system (which costs $1)</p>\r\n			<p ng-if=\"showBoth && $root.userRole==\'advocate\'\">You can read, but you can\'t write anything on the site until you confirm your email address.  <br><br> After you confirm your email, you can write, but everything will have the byline \"Unknown Organization\" until we can confirm your identification (then all your work will change to your byline).</p>\r\n   <p ng-if=\"showEm\">You can read, but you can\'t write anything on the site until you confirm your email address.</p>\r\n   <p ng-if=\"showCon && !showBoth && !showEm && $root.userRole==\'politician\'\">We still need to confirm you are who you say you are. If you are running for a large office, we will do the research to figure that out.  If you are running for a more local office and you don\'t want to wait for us, you can use the automated ID check which costs $1.</p>\r\n\r\n   <div class=\"ngdialog-buttons\">\r\n   <button  ng-click=\"sendMail()\" type=\"button\" class=\"ngdialog-button ngdialog-button-primary\" ng-if=\"showEm || (showBoth && $root.userRole==\'politician\')\">Resend Confirmation Email</button>\r\n   <button ng-click=\"goto()\" ng-if=\"showCon && $root.userRole==\'politician\'\" type=\"button\" class=\"ngdialog-button ngdialog-button-primary\">Confirm Id</button>\r\n   <button ng-click=\"closeIt()\" type=\"button\" class=\"ngdialog-button ngdialog-button-primary\">Later</button>\r\n   </div>\r\n  </div>\r\n\r\n\r\n\r\n</script>\r\n");
$templateCache.put("app/orgVideo/orgVideo.html","\r\n<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">Organizations</h2>\r\n  <p class=\"pageSubHeading\">\r\n   <a href=\"#!/signup/voter\" class=\"compareBtn\">	&nbsp;	&nbsp;Sign Up	&nbsp;	&nbsp;</a></p>\r\n 									<style>\r\n.iframe-container {\r\n  overflow: hidden;\r\n  padding-top: 56.25%;\r\n  position: relative;\r\n	top: -10%;\r\n}\r\n \r\n.iframe-container iframe {\r\n   border: 0;\r\n   height: 100%;\r\n   left: 0;\r\n   position: absolute;\r\n   top: 0;\r\n   width: 100%;\r\n	max-height: 400px;\r\n}\r\n											.fgtrh-container iframe{\r\n												left: 0;\r\n												top: 250px;\r\n												position:absolute;\r\n												height:50%;\r\n												width:50%;\r\n											}\r\n/* 4x3 Aspect Ratio */\r\n.iframe-container-4x3 {\r\n  padding-top: 75%;\r\n}</style>\r\n                          \r\n<div class=\"iframe-container\">\r\n  <iframe src=\"https://player.vimeo.com/video/408236648\" allowfullscreen></iframe>\r\n</div>\r\n                ");
$templateCache.put("app/otherPoliticians/otherPoliticians.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">OTHER POLITICIANS</h2>\r\n  <p class=\"pageSubHeading\">Use this page to get the contact information for other politicians you want to research or\r\n    contact. You can search for individulas by name or you can search for a list of politicians using the filters.</p>\r\n\r\n\r\n\r\n  <br>\r\n	Search for list by filter.<br>\r\n\r\n  <label for=\"selChamber\" class=\"col-lg-2 col-sm-5 col-form-label\" style=\"color:#ffffff;\">Select Level :\r\n        </label>\r\n  <div class=\"col-lg-5 col-sm-5\">\r\n    <select ng-model=\"search.level\" class=\"form-control\" ng-change=\"resetDropDown()\" style=\"width:170px;\">\r\n            <option value=\"\">Select Level</option>\r\n											<option value=\"placeName\">Local</option>\r\n            <option value=\"countyName\">County</option>\r\n            <option value=\"statePostalCode\">State</option>\r\n											 <option value=\"federalCongressionalDistrict\">Federal</option>\r\n          </select>\r\n  </div>\r\n\r\n\r\n  <label for=\"selState\" class=\"col-lg-2 col-sm-5 col-form-label\" style=\"color:#ffffff;\">Select State :\r\n        </label>\r\n  <div class=\"col-lg-5 col-sm-5\">\r\n    <select ng-model=\"search.curState\"  style=\"text-transform: capitalize;width:170px;display:inline\" ng-options=\"item as item.state for item in allState\" ng-change=\"getCounties()\" class=\"changeTextColor form-control\">\r\n        </select>&nbsp; &nbsp;\r\n    <i ng-if=\"showLoader\"  class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>\r\n  </div>\r\n\r\n  <div style=\"width:20%\" class=\"control-col-lg-5 col-sm-5\" ng-if=\"countyone\">\r\n    <label class=\"control-label formLabel whiteText\" for=\"email\">County </label>\r\n    <div class=\"controls\">\r\n      <select ng-model=\"search.county\" style=\"text-transform: capitalize;display:inline\" ng-options=\"item as item.countyName for item in counties | orderBy : \'county\'\" ng-change=\"getSubCounties()\" class=\"changeTextColor form-control\"></select>\r\n      <i ng-if=\"showLoaderOne\" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>\r\n    </div>\r\n  </div>\r\n  <div style=\"width:20%\" class=\"control-group\" ng-if=\"cityone\">\r\n    <label class=\"control-label formLabel whiteText\" for=\"email\">City </label>\r\n    <div class=\"controls\">\r\n      <select ng-model=\"search.city\" style=\"text-transform: capitalize;\" ng-options=\"item as item.city for item in places | orderBy : \'place\' \" class=\"changeTextColor form-control\"></select>\r\n      <!-- <i ng-if=\"LoaderTwo \" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i> -->\r\n    </div>\r\n  </div>\r\n  <label for=\"selChamber\"  class=\"col-lg-2 col-sm-5 col-form-label\" ng-if=\"showChamber\" style=\"color:#ffffff;\">Select Chamber :\r\n        </label>\r\n  <div class=\"col-lg-5 col-sm-5\" ng-if=\"showChamber\">\r\n    <select ng-model=\"search.chamber\"  class=\"form-control\" style=\"width:170px;\">\r\n            <option value=\"\">Select Chamber</option>\r\n											<option value=\"all\">All</option>\r\n            <option value=\"house\">House</option>\r\n            <option value=\"senate\">Senate</option>\r\n          </select>\r\n  </div>\r\n\r\n  <label for=\"selParty\" class=\"col-lg-2 col-sm-5 col-form-label\" style=\"color:#ffffff;\">Select Party :\r\n        </label>\r\n  <div class=\"col-lg-5 col-sm-5\">\r\n    <select ng-model=\"search.party\" class=\"form-control\" style=\"width:170px;\">\r\n            <option value=\"\">Select Party</option>\r\n											<option value=\"all\">All</option>\r\n            <option value=\"democratic\">Democratic</option>\r\n            <option value=\"republican\">Republican</option>\r\n            <option value=\"Green Party\"> Green Party</option>\r\n            <option value=\"Libertarian\"> Libertarian</option>\r\n											<option value=\"other\">Other</option>\r\n          </select>\r\n  </div>\r\n  <label for=\"office\" class=\"col-lg-2 col-sm-5 col-form-label\" style=\"color:#ffffff;\">Running or In Office :\r\n  </label>\r\n  <div class=\"col-lg-5 col-sm-5\">\r\n    <select ng-model=\"search.isOffice\" class=\"form-control\" style=\"width:170px;\">\r\n            <option value=\"\">Select </option>\r\n											<option value=\"any\">Any</option>\r\n            <option value=\"Y\">Running For Office</option>\r\n            <option value=\"Incumbent\">Incumbent</option>\r\n          </select>\r\n  </div>\r\n  <br> <button  ng-click=\"searchPoliticians()\" class=\"blackText\">Search</button>\r\n  <button  ng-click=\"resetSearch()\" class=\"blackText\" style=\"margin-left: 5%;\">Reset</button>\r\n  <hr>\r\n  <br>\r\n  <div class=\"col-lg-5 col-sm-5\">\r\n    <label for=\"search-box-title\">Search by name.</label><br>\r\n    <input ng-model=\"search.pName\" class=\"blackText form-control search-box\">\r\n    <button ng-click=\"searchPoliticians()\" class=\"blackText\">Search</button>\r\n  </div>\r\n\r\n</div><br><br>\r\n<div style=\"padding-left: 5%;\">\r\n  <div class=\"col-lg-12 col-centered containerBlock\" id=\"compareContent\">\r\n    <div class=\"table-responsive\" ng-if=\"poliData.length > 0\">\r\n      <table class=\"table table-striped\" style=\"margin-bottom:0px;\">\r\n        <tr>\r\n\r\n          <th class=\"tableHead\">Name</th>\r\n          <th class=\"tableHead\">Contact Politician</th>\r\n          <th class=\"tableHead\">Office</th>\r\n          <th class=\"tableHead\">Jurisdiction</th>\r\n          <th class=\"tableHead\">State</th>\r\n          <th class=\"tableHead\">Party</th>\r\n          <!--   <th class=\"tableHead\">More Info</th>   -->\r\n        </tr>\r\n        <tr ng-repeat=\"user in poliData | filter:filterItems() track by $index\">\r\n\r\n          <td class=\"tableRow\">\r\n            <!-- {{$index +1}} -->\r\n            <a ng-if=\"user.politicianIds.length > 0\" ng-href=\"#!/publicProfile/{{user.politicianIds[0]}}/true\">\r\n                  <span ng-if=\"user.nameOnBallot\" style=\"text-decoration:underline;\" class=\"link\">\r\n                    <b>{{user.nameOnBallot}}</b>\r\n                  </span>\r\n                  <span ng-if=\"!user.nameOnBallot\" style=\"text-decoration:underline;\" class=\"link\">\r\n                    <b>{{user.name}}</b>\r\n                  </span>\r\n                </a>\r\n            <a ng-if=\"user.politicianIds.length == 0\" ng-href=\"#!/publicProfile/{{user._id}}/true\">\r\n                  <span ng-if=\"user.nameOnBallot\" style=\"text-decoration:underline;\" class=\"link\">\r\n                    <b>{{user.nameOnBallot}}</b>\r\n                  </span>\r\n                  <span ng-if=\"!user.nameOnBallot\" style=\"text-decoration:underline;\" class=\"link\">\r\n                    <b>{{user.name}}</b>\r\n                  </span>\r\n                </a>\r\n\r\n            <a ng-if=\"!user.politicianIds.length\" ng-href=\"#!/publicProfile/{{user._id}}/true\">\r\n                  <span ng-if=\"user.nameOnBallot\" style=\"text-decoration:underline;\" class=\"link\">\r\n                    <b>{{user.nameOnBallot}}</b>\r\n                  </span>\r\n                  <span ng-if=\"!user.nameOnBallot\" style=\"text-decoration:underline;\" class=\"link\">\r\n                    <b>{{user.name}}</b>\r\n                  </span>\r\n                </a>\r\n          </td>\r\n          <td class=\"tableRow\">\r\n            <a ng-href=\"#!/publicProfile/{{user._id}}/false\">\r\n                  <button ng-if=\"user.registeredUser\" class=\"btnW\">\r\n                    Contact\r\n                  </button>\r\n                </a>\r\n            <a ng-href=\"#!/publicProfile/{{user._id}}/false\">\r\n                  <button ng-if=\"!user.registeredUser\" class=\"btnW\">\r\n                    Contact\r\n                  </button>\r\n                </a>\r\n          </td>\r\n          <td class=\"tableRow\">\r\n            <div ng-if=\"user.politicianInfo && user.politicianInfo.length > 0\" ng-repeat=\"info in user.politicianInfo\">\r\n              <b ng-if=\"info.officeName\" style=\"text-transform: capitalize;\">{{info.officeName}}</b>\r\n\r\n            </div>\r\n            <div ng-if=\" user.office && !user.politicianInfo && !user.winDetails[0].office\"\r\n              style=\"text-transform: capitalize;\">{{user.office}}\r\n            </div>\r\n            <div ng-if=\"user.winDetails && user.winDetails[0].office\" style=\"text-transform: capitalize;\">\r\n              {{user.winDetails[0].office}}\r\n            </div>\r\n\r\n          </td>\r\n          <td class=\"tableRow\">\r\n            <div ng-if=\"user.politicianInfo && user.politicianInfo.length > 0\" ng-repeat=\"info in user.politicianInfo\">\r\n              <b ng-if=\"info.levelOfGov == \'Federal\'\">Federal</b>\r\n              <b ng-if=\"info.levelOfGov == \'federalCongressionalDistrict\'\">Federal</b>\r\n              <b ng-if=\"info.levelOfGov == \'stateHouseofRepresentativesDistrict\'\">State</b>\r\n              <b ng-if=\"info.levelOfGov == \'placeName\'\">Local</b>\r\n              <b ng-if=\"info.levelOfGov == \'countyName\'\">County</b>\r\n              <b ng-if=\"info.levelOfGov == \'statePostalCode\'\">State</b>\r\n              <b ng-if=\"info.levelOfGov == \'stateSenateDistrict\'\">State</b>\r\n              <b ng-if=\"info.levelOfGov == \'All USA\'\">All USA</b>\r\n\r\n            </div>\r\n            <div ng-if=\"user.office && !user.politicianInfo\">\r\n              <b ng-if=\"user.voterScope == \'federalCongressionalDistrict\'\">Federal</b>\r\n              <b ng-if=\"user.voterScope == \'statePostalCode\'\">State</b>\r\n              <b ng-if=\"user.voterScope == \'stateSenateDistrict\'\">State</b>\r\n              <b ng-if=\"user.voterScope == \'stateHouseofRepresentativesDistrict\'\">State</b>\r\n              <b ng-if=\"user.voterScope == \'placeName\'\">Local</b>\r\n              <b ng-if=\"user.voterScope == \'countyName\'\">County</b>\r\n              <b ng-if=\"user.voterScope == \'All USA\'\">All USA</b>\r\n            </div>\r\n\r\n          </td>\r\n          <td class=\"tableRow\">\r\n            <div ng-if=\"user.politicianInfo && user.politicianInfo.length > 0\" ng-repeat=\"info in user.politicianInfo\">\r\n              <b ng-if=\"info.state && info.state !=\'NA\'\">{{info.state}}</b>\r\n            </div>\r\n            <div ng-if=\" user.state && !user.politicianInfo\">\r\n              <b ng-if=\"user.state && user.state !=\'NA\'\">{{user.state}}</b>\r\n              <b ng-if=\"user.state ==\'NA\' && user.winDetails && user.winDetails[0].statePostalCode !=\'NA\'\">{{user.winDetails[0].statePostalCode}}</b>\r\n            </div>\r\n            <b ng-if=\"!user.state  && user.statePostalCode\">{{user.statePostalCode}}</b>\r\n\r\n          </td>\r\n          <td class=\"tableRow\">\r\n            <div ng-if=\"user.politicianInfo && user.politicianInfo.length > 0\" ng-repeat=\"info in user.politicianInfo\">\r\n              <div ng-if=\"info.party && info.party.length > 0\" ng-repeat=\"party in info.party\">\r\n                <b ng-if=\"party\">{{party}}</b>\r\n              </div>\r\n            </div>\r\n            <div ng-if=\"user.party && user.party.length > 0\">\r\n\r\n              <div ng-if=\"user.party && user.party.length > 0\" ng-repeat=\"party in user.party\">\r\n                <b ng-if=\'party && party !=\"\"\'>{{party}}</b>\r\n                <b ng-if=\'party && party ==\"\"\'>N/A</b>\r\n\r\n              </div>\r\n\r\n            </div>\r\n            <b ng-if=\"user.party.length == 0\">N/A</b>\r\n            <b ng-if=\"user.politicianInfo[0].party.length == 0\">N/A</b>\r\n\r\n          </td>\r\n        </tr>\r\n      </table>\r\n    </div>\r\n    <center>\r\n      <div ng-if=\"loader\" style=\"z-index: 2; background:black;\">\r\n        <i class=\"fa fa-refresh fa-spin loader-stly\"></i><br><span class=\"loader-text\">LOADING. PLEASE WAIT.</span>\r\n      </div>\r\n    </center>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/placesShape/placesShape.html","<div class=\"container-fluid ng-scope\" ng-cloak ng-show=\"$root.userRole==\'admin\'\">\r\n  <h2 class=\"pageHeading\">Settings</h2>\r\n  <div>\r\n    <div class=\"closeForm\" ng-include=\"\'app/popups/setting_Ctrl.html\'\"></div>\r\n  </div>\r\n  <form ng-if=\"$root.showPlacesShape\" name=\"showPlacesShape\" id=\"showPlacesShape\" ng-controller=\"PlacesShapeCtrl\" class=\"closeForm\">\r\n    <h2 style=\"color:#ffffff;\">Places Shape file</h2>\r\n    <div id=\"grid1\" ui-grid=\"gridOptions\" style=\"color:black;\" ui-grid-edit ui-grid-pagination ui-grid-move-columns ui-grid-resize-columns ui-grid-selection class=\"grid\">\r\n      <div class=\"grid-msg-overlay\" ng-show=\"!gridOptions.data.length\">\r\n        <div class=\"msg\">\r\n          <div class=\"center\">\r\n            <span class=\"muted\">Select Spreadsheet File</span>\r\n            <br />\r\n            <input type=\"file\" accept=\".xls,.xlsx,.ods\" fileread=\"\" address=\"address\" opts=\"gridOptions\" multiple=\"false\" />\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </form>\r\n</div>\r\n");
$templateCache.put("app/polFinance/polFinance.html"," <!-- New Design -->\r\n<div class=\"container-fluid\">\r\n  <p class=\"fwb\" ng-if=\"statusGetData == 1\">Loading profile data...</p>\r\n  <div ng-if=\"userProfile && userProfile.registeredUser\">\r\n    <h2 class=\"pageHeading\">{{userProfile.name}}</h2>\r\n      <h2 class=\"pageHeading\">Financial Info</h2>\r\n  \r\n    <div class=\"pageSubHeading\">\r\n      <div ng-if=\"userProfile.office\"> {{userProfile.office}}</div>\r\n      <div ng-if=\"userProfile.party\">{{userProfile.party}}</div>\r\n      <div ng-if=\"memberRole.votes_with_party_pct\">Votes along party lines {{memberRole.votes_with_party_pct}}%</div>\r\n      <div ng-if=\"loginUser!=userId\">\r\n        <input type=\"button\" class=\"followProfileBtn\" ng-click=\"addtoFollow();\" value=\"Follow\">\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div ng-if=\"userProfile && userProfile.registeredUser == false\">\r\n    <h2 class=\"pageHeading\">{{userProfile.name}}</h2>\r\n      <h2 >Financial Info</h2>\r\n    <div class=\"pageSubHeading\">\r\n      <div ng-if=\"userProfile.office\">{{userProfile.office}}</div>\r\n      <div ng-if=\"userProfile.party\">{{userProfile.party}}</div>\r\n      <div ng-if=\"memberRole.votes_with_party_pct\">Votes along party lines : {{memberRole.votes_with_party_pct}}%</div>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n  \r\n      <div class=\"row\" ng-if=\"propublicaData != \'\'\">\r\n        <div class=\"col-12 \">\r\n            \r\n        \r\n            <!-- <span ng-repeat=\"r in allroles\" ng-click=\"showPreviousYearRole(r.id)\">{{r.year}}<span ng-hide=\"$last\">, </span></span> -->\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-lg-5 col-centered\">\r\n\r\n        \r\n        <!-- 10 BIGGEST INDUSTRIES -->\r\n        \r\n      <div class=\"row\" ng-if=\"propublicaData != \'\'\">\r\n        <div class=\"col-12 contributorsBlock\">\r\n            <center><img ng-src=\"./assets/images/contributors.svg\" class=\"blockLink publicProfileImg img-fluid\"><br></center>\r\n          <h5 class=\"blockHeading\">10 Biggest Contributors by Type</h5>\r\n          <p class=\"accP\">\r\n            This is a list of the industry types that contributed the most money to this politician\'s compaign. You should see this as their endorsement. They spent potentially millions of dollars to put this candidate into office because they believed that this candidate would take actions that would benefit them in some way or another.\r\n          </p>\r\n          <div id=\"accordion\" class=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\">\r\n            <!-- <h5 class=\"blockHeading\">{{topContributorData[\'@attributes\'].cycle}}</h5> -->\r\n            <div class=\"legislationSelect\">\r\n            <select class=\"custom-select\" ng-model=\"contYear\" ng-change=\"getIndustrySupport(contYear)\">\r\n              <option ng-repeat=\"r in contYearArray\" value=\"{{r}}\">\r\n                {{r}}\r\n              </option>\r\n            </select>\r\n            <p ng-if=\"msg\">{{msg}}</p>\r\n            </div>\r\n            <div class=\"card\" ng-repeat=\"industry in industrySupport.industry track by $index\">\r\n              <div class=\"card-header collapsed\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#block_{{$index}}\" target=\"_self\" ng-click=\"isClicked = !isClicked\">\r\n                <a class=\"card-title\">\r\n                  <div style=\"width:65%; display: inline-flex;\">\r\n                    <div>\r\n                      <div class=\"fa fa-fw list-arrow listIcons\" ng-class=\"{\'fa-caret-down\': isClicked, \'fa-caret-right\' : !isClicked}\">\r\n                      </div>\r\n                    </div>\r\n                    <div>{{industry[\'@attributes\'].industry_name}}</div>\r\n                  </div>\r\n                  <span class=\"cardRightHeading\" style=\"float:right;\">{{industry[\'@attributes\'].total | currency}}</span>\r\n                </a>\r\n              </div>\r\n              <div id=\"block_{{$index}}\" class=\"collapse\" role=\"tabpanel\" aria-labelledby=\"{{$index}}\">\r\n                <div class=\"card-block\">\r\n                  <div class=\"cardRightContent removeBold\">Individuals : {{industry[\'@attributes\'].indivs | currency}}</div>\r\n                  <div class=\"cardRightContent removeBold\">PACs : {{industry[\'@attributes\'].pacs | currency}}</div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <!-- <div class=\"blockBottomLink\">\r\n            <a href=\"\" ng-click=\"topContributor()\">See more contributions</a>\r\n          </div> -->\r\n            <br> <br>\r\n        </div>\r\n      </div>\r\n      \r\n        \r\n        <!-- INDUSTRY SUPPORT -->\r\n   <div class=\"row\" ng-if=\"propublicaData != \'\'\">\r\n				<div class=\"col-12 contributorsBlock\">\r\n         <center><img ng-src=\"./assets/images/contributors.svg\" class=\"blockLink publicProfileImg img-fluid\"><br></center>\r\n          <h5 class=\"blockHeading\">10 Biggest Company Contributors</h5>\r\n          <p class=\"accP\">\r\n            This is a list of the companies that contributed the most money to this politician\'s compaign. You should see this as their endorsement. They spent potentially millions of dollars to put this candidate into office because they believed that this candidate would take actions that would benefit them in some way or another.\r\n          </p>\r\n    <fieldset style=\"margin-top:25px;\"> \r\n              \r\n      <div id=\"fundraising\" >\r\n         <h3 style=\"padding-left:0px;\">Contributors</h3>\r\n        <!--<div>Candidate Name : {{topContributorData[\'@attributes\'].cand_name}}</div>\r\n        <div>Cycle : {{topContributorData[\'@attributes\'].cycle}}</div>\r\n        <div>Last Updated : {{topContributorData[\'@attributes\'].last_updated}}</div>\r\n        <div>Origin : {{topContributorData[\'@attributes\'].origin}}</div> -->\r\n        <!-- <div>Source : {{industrySupport[\'@attributes\'].source}}</div> -->\r\n        <br />\r\n        <h5>Industry List :</h5>\r\n        <div ng-repeat=\"cont in topContributorData.contributor\">\r\n          <div>Name : {{cont[\'@attributes\'].org_name}}</div>\r\n          <div>Indivs : {{cont[\'@attributes\'].indivs | currency}}</div>\r\n          <div>Pacs : {{cont[\'@attributes\'].pacs | currency}}</div>\r\n          <div>Total : {{cont[\'@attributes\'].total | currency}}</div>\r\n          <hr style=\"border-top: 1px solid #b6b4b4;\" />\r\n        </div>\r\n        <input type=\"button\" class=\"changeTextColor\" ng-click=\"getIndustrySupport()\" value=\"Previous Year\">\r\n         \r\n      </div>\r\n    \r\n    </fieldset>\r\n       \r\n       </div>\r\n\r\n  <div class=\"row\" ng-if=\"propublicaData != \'\'\">\r\n    <div class=\"col-12\">\r\n    <fieldset style=\"margin-top:25px;\">\r\n      <!-- <input type=\"button\" class=\"changeTextColor\" ng-click=\"getIndustrySupport()\" value=\"Industry Support\">\r\n      <input type=\"button\" class=\"changeTextColor\" ng-click=\"personalHoldings()\" value=\"Personal Holdings\">\r\n      <input type=\"button\" class=\"changeTextColor\" ng-click=\"fundRaising()\" value=\"Fund Raising\"> -->\r\n      <div class=\"btn-group\" role=\"group\" aria-label=\"Basic example\" style=\"padding: 30px 0px 30px 0px;\">\r\n      \r\n        <button type=\"button\" class=\"btn btn-primary\" style=\"width:auto\" ng-click=\"personalHoldings()\">Personal Holdings</button>\r\n        <button type=\"button\" class=\"btn btn-primary\" style=\"width:auto\" ng-click=\"fundRaising()\">Fund Raising</button>\r\n      </div>\r\n      <br/>\r\n      <div style=\"padding: 0% 8% 8% 8%;\">\r\n          \r\n          \r\n          \r\n       <!--   Personal Holdings-->\r\n      <div id=\"personalholding\" >\r\n        <h3 style=\"padding-left:0px;\">Personal Holdings</h3>\r\n        <div>Name : {{personalHoldingData.member_profile[\'@attributes\'].name}}</div>\r\n        <div>Data Year : {{personalHoldingData.member_profile[\'@attributes\'].data_year}}</div>\r\n        <div>Net Low : {{personalHoldingData.member_profile[\'@attributes\'].net_low | currency}}</div>\r\n        <div>Net High : {{personalHoldingData.member_profile[\'@attributes\'].net_high | currency}}</div>\r\n        <div>Positions Held Count : {{personalHoldingData.member_profile[\'@attributes\'].positions_held_count}}</div>\r\n        <div>Asset Count : {{personalHoldingData.member_profile[\'@attributes\'].asset_count}}</div>\r\n        <div>Asset Low : {{personalHoldingData.member_profile[\'@attributes\'].asset_low | currency}}</div>\r\n        <div>Asset High : {{personalHoldingData.member_profile[\'@attributes\'].asset_high | currency}}</div>\r\n        <div>Transaction Count : {{personalHoldingData.member_profile[\'@attributes\'].transaction_count}}</div>\r\n        <div>Transaction Low : {{personalHoldingData.member_profile[\'@attributes\'].tx_low | currency}}</div>\r\n        <div>Transaction High : {{personalHoldingData.member_profile[\'@attributes\'].tx_high | currency}}</div>\r\n        <div>Origin : {{personalHoldingData.member_profile[\'@attributes\'].origin}}</div>\r\n        <div>Update Timestamp : {{personalHoldingData.member_profile[\'@attributes\'].update_timestamp}}</div>\r\n        <br/>\r\n        <div ng-if=\"personalHoldingData.member_profile.assets\">\r\n          <h5>Assets : </h5>\r\n          <div ng-repeat=\"asset in personalHoldingData.member_profile.assets.asset\">\r\n            <div>Holdings High : {{asset[\'@attributes\'].holdings_high | currency}}</div>\r\n            <div>Holdings Low : {{asset[\'@attributes\'].holdings_low | currency}}</div>\r\n            <div>Industry : {{asset[\'@attributes\'].industry }}</div>\r\n            <div>Name : {{asset[\'@attributes\'].name}}</div>\r\n            <div>Sector : {{asset[\'@attributes\'].sector}}</div>\r\n            <div>Subsidiary Of : {{asset[\'@attributes\'].subsidiary_of}}</div>\r\n            <hr style=\"border-top: 1px solid #b6b4b4;\" />\r\n          </div>\r\n        </div>\r\n        <br />\r\n        <div ng-if=\"personalHoldingData.member_profile.transactions\">\r\n          <h5>Transaction : </h5>\r\n          <div ng-repeat=\"trn in personalHoldingData.member_profile.transactions.transaction\">\r\n            <div>Asset Name : {{trn[\'@attributes\'].asset_name}}</div>\r\n            <div>Transaction action : {{trn[\'@attributes\'].tx_action}}</div>\r\n            <div>Transaction date : {{trn[\'@attributes\'].tx_date}}</div>\r\n            <div>Value High : {{trn[\'@attributes\'].value_high | currency}}</div>\r\n            <div>Value Low : {{trn[\'@attributes\'].value_low | currency}}</div>\r\n            <hr style=\"border-top: 1px solid #b6b4b4;\" />\r\n          </div>\r\n        </div>\r\n      </div>\r\n          \r\n          \r\n       <!--   FUNDRAISING -->\r\n      <div id=\"fundraising\" >\r\n        <h3 style=\"padding-left:0px;\">Fund Raising</h3>\r\n        <div>Name : {{fundRaisingData.cand_name}}</div>\r\n        <div>Cycle : {{fundRaisingData.cycle}}</div>\r\n        <div>State : {{fundRaisingData.state}}</div>\r\n        <div>Party : {{matchParty(fundRaisingData.party)}}</div>\r\n        <!-- <div>Chamber : {{fundRaisingData.chamber}}</div> -->\r\n        <div>First Elected : {{fundRaisingData.first_elected}}</div>\r\n        <div>Next Election : {{fundRaisingData.next_election}}</div>\r\n        <div>Total : {{fundRaisingData.total | currency}}</div>\r\n        <div>Spent : {{fundRaisingData.spent | currency}}</div>\r\n        <div>Cash On Hand : {{fundRaisingData.cash_on_hand | currency}}</div>\r\n        <div>Debt : {{fundRaisingData.debt | currency}}</div>\r\n        <div>Origin : {{fundRaisingData.origin}}</div>\r\n        <div>Last Updated : {{fundRaisingData.last_updated}}</div>\r\n      </div>\r\n          \r\n          \r\n          \r\n          \r\n     \r\n      \r\n    </div>\r\n    </fieldset>\r\n  </div>\r\n  </div>\r\n\r\n</div>\r\n\r\n</div>\r\n\r\n<div class=\"col-lg-5 col-centered\">\r\n<!-- 10 BIGGEST INDIVIDUAL  -->\r\n        \r\n        \r\n           \r\n      <div class=\"row\" ng-if=\"propublicaData != \'\'\">\r\n        <div class=\"col-12 votewiseActivitiesBlock\">\r\n            <center><img ng-src=\"./assets/images/contributors.svg\" class=\"blockLink publicProfileImg img-fluid\"><br></center>\r\n          <h5 class=\"blockHeading\">10 Biggest Organizations</h5>\r\n          <p class=\"accP\">\r\n            This is a list of the organizations that contributed the most money to this politician\'s compaign. You should see this as their endorsement. They spent lots of money to put this candidate into office because they believed that this candidate would take actions that would benefit them in some way or another.\r\n          </p>\r\n          <div id=\"accordion\" class=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\">\r\n            <!-- <h5 class=\"blockHeading\">{{topContributorData[\'@attributes\'].cycle}}</h5> -->\r\n            <div class=\"legislationSelect\">\r\n            <select class=\"custom-select\" ng-model=\"contYear\" ng-change=\"getIndustrySupport(contYear)\">\r\n              <option ng-repeat=\"r in contYearArray\" value=\"{{r}}\">\r\n                {{r}}\r\n              </option>\r\n            </select>\r\n            <p ng-if=\"msg\">{{msg}}</p>\r\n            </div>\r\n            <div class=\"card\" ng-repeat=\"cont in topContributorData.contributor track by $index\">\r\n              <div class=\"card-header collapsed\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#block_{{$index}}\" target=\"_self\" ng-click=\"isClicked = !isClicked\">\r\n                <a class=\"card-title\">\r\n                  <div style=\"width:65%; display: inline-flex;\">\r\n                    <div>\r\n                      <div class=\"fa fa-fw list-arrow listIcons\" ng-class=\"{\'fa-caret-down\': isClicked, \'fa-caret-right\' : !isClicked}\">\r\n                      </div>\r\n                    </div>\r\n                    <div>{{cont[\'@attributes\'].org_name}}</div>\r\n                  </div>\r\n                  <span class=\"cardRightHeading\" style=\"float:right;\">{{cont[\'@attributes\'].total | currency}}</span>\r\n                </a>\r\n              </div>\r\n              <div id=\"block_{{$index}}\" class=\"collapse\" role=\"tabpanel\" aria-labelledby=\"{{$index}}\">\r\n                <div class=\"card-block\">\r\n                  <div class=\"cardRightContent removeBold\">Individuals : {{cont[\'@attributes\'].indivs | currency}}</div>\r\n                  <div class=\"cardRightContent removeBold\">PACs : {{cont[\'@attributes\'].pacs | currency}}</div>\r\n                </div>\r\n                  \r\n                  \r\n  \r\n															\r\n															\r\n															 <div class=\"card\" ng-repeat=\"industry in industrySupport.industry track by $index\">\r\n              <div class=\"card-header collapsed\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#block_{{$index}}\" target=\"_self\" ng-click=\"isClicked = !isClicked\">\r\n                <a class=\"card-title\">\r\n                  <div style=\"width:65%; display: inline-flex;\">\r\n                    <div>\r\n                      <div class=\"fa fa-fw list-arrow listIcons\" ng-class=\"{\'fa-caret-down\': isClicked, \'fa-caret-right\' : !isClicked}\">\r\n                      </div>\r\n                    </div>\r\n                    <div>{{industry[\'@attributes\'].industry_name}}</div>\r\n                  </div>\r\n                  <span class=\"cardRightHeading\" style=\"float:right;\">{{industry[\'@attributes\'].total | currency}}</span>\r\n                </a>\r\n              </div>\r\n              <div id=\"block_{{$index}}\" class=\"collapse\" role=\"tabpanel\" aria-labelledby=\"{{$index}}\">\r\n                <div class=\"card-block\">\r\n                  <div class=\"cardRightContent removeBold\">Individuals : {{industry[\'@attributes\'].indivs | currency}}</div>\r\n                  <div class=\"cardRightContent removeBold\">PACs : {{industry[\'@attributes\'].pacs | currency}}</div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n															\r\n															\r\n															\r\n															\r\n            \r\n              </div>\r\n            </div>\r\n          </div>\r\n          <!-- <div class=\"blockBottomLink\">\r\n            <a href=\"\" ng-click=\"topContributor()\">See more contributions</a>\r\n          </div> --> <br><br>\r\n        </div>\r\n      </div>\r\n      \r\n      \r\n        \r\n        \r\n        \r\n  </div>\r\n    \r\n</div>  \r\n    \r\n      <div class=\"bottomInfo\">\r\n    <p>Candidate information is provided in part by The Center for Tech and Civil Life, ProPublica, Open States, Open Secrets and by your local boards of elections.</p>\r\n    <p class=\"bottomurl\"><a href=\"https://www.techandciviclife.org/\" target=\"_blank\"><span class=\"urllinks\">Center for Tech and Civil Life</span></a> provides election information.</p>\r\n    <p class=\"bottomurl\"><a href=\"https://www.propublica.org/\" target=\"_blank\"><span class=\"urllinks\">ProPublica</span></a> provides information on federal elected officials and their actions in office.</p>\r\n    <p class=\"bottomurl\"><a href=\"https://openstates.org/\" target=\"_blank\"><span class=\"urllinks\">Open States</span> </a>provides information on state level elected official and their actions.</p>\r\n    <p class=\"bottomurl\"><a href=\"https://www.opensecrets.org/\" target=\"_blank\"><span class=\"urllinks\">OpenSecrets.org</span></a> provides information on campaign finance and its impact.</p>\r\n  </div>\r\n</div>");
$templateCache.put("app/poliAnswers/poliAnswers.html","<div class=\"container-fluid\">\r\n  <!-- <h2>Welcome</h2> -->\r\n\r\n  <p ng-if=\"status.levlCat == 1\" class=\"fwb\">Loading background ...</p>\r\n  <div class=\"pad10\" ng-show=\"questions.length > 0\">\r\n    <div class=\"clearfix w100\">\r\n      <div ng-show=\"[\'question\', \'question-background\'].indexOf(state) > -1 && userId\">\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <p>\r\n        <h1>\r\n          <center>{{category.title}}</center>\r\n        </h1>\r\n      </p>\r\n      <p></p>\r\n      <div>\r\n        <center ng-if=\"category.fbImage\">\r\n          <img ng-src=\"https://api.votewise.net/resources/{{category.fbImage}}\" class=\"wibble\" />\r\n      </center>\r\n      </div>\r\n      <center id=\"DisplayC\">\r\n        <h2>BACKGROUND</h2>\r\n      </center>\r\n      <p></p>\r\n      <div class=\"row d-flex justify-content-center\">\r\n        <div class=\"col-lg-7 col-sm-12\">\r\n          <p ng-bind-html=\"category.description | newlines\"></p>\r\n        </div>\r\n        <div ng-if=\"status.category == 1\" class=\"fwb\">\r\n          Loading category ...\r\n        </div>\r\n        <div ng-if=\"status.category == 3\" class=\"fwb\">\r\n          Something went wrong while loading category.\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <br>\r\n    <br>\r\n    <div class=\"row  d-flex justify-content-center\">\r\n      <div class=\"col-lg-7 col-sm-12 \">\r\n        <h4 class=\"text-center\">Questions</h4>\r\n\r\n        <div class=\"card customCard\">\r\n          <div class=\"card-header quesCardHeaderMain\">\r\n            <div class=\"d-flex justify-content-between bd-highlight\">\r\n              <!-- <div class=\"p-2 bd-highlight quesCardHeader\">Statement</div> -->\r\n              <div class=\"p-2 bd-highlight\"><span class=\"textYellow\">{{currentIndex+1}}</span>/{{questions.length}}\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"card-body customCardBody\">\r\n            <p  class=\"card-text\" ng-bind-html=\"questions[currentIndex].content | newlines\"></p>\r\n            <div class=\"row vdivide\">\r\n              <div class=\"col col-6\">\r\n                <div class=\"radio-container rcontent\" style=\"float:right;\">\r\n\r\n                  <span id=\"disagreeText\">DISAGREE &nbsp;</span>\r\n                  <div style=\"float:right;\">\r\n                    <div class=\"box\">\r\n                      <ul class=\"vi-radio\">\r\n                        <li>\r\n                          <input type=\"radio\" id=\"agreedisagree-id6\" ng-disabled=\"true\" name=\"agreeDisagree\" value=\"6\" ng-model=\"answer\" ng-checked=\"checkIfExists(6)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                          <label for=\"agreedisagree-id6\"></label>\r\n                          <div class=\"checknew red sixth\"></div>\r\n                        </li>\r\n                      </ul>\r\n                    </div>\r\n                    <div class=\"box\">\r\n                      <ul class=\"vi-radio\">\r\n                        <li>\r\n                          <input type=\"radio\" id=\"agreedisagree-id5\" ng-disabled=\"true\" name=\"agreeDisagree\" value=\"5\" ng-model=\"answer\" ng-checked=\"checkIfExists(5)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                          <label for=\"agreedisagree-id5\"></label>\r\n                          <div class=\"checknew five fifth\"></div>\r\n                        </li>\r\n                      </ul>\r\n                    </div>\r\n                    <div class=\"box\">\r\n                      <ul class=\"vi-radio\">\r\n                        <li>\r\n                          <input type=\"radio\" id=\"agreedisagree-id4\" ng-disabled=\"true\" name=\"agreeDisagree\" value=\"4\" ng-model=\"answer\" ng-checked=\"checkIfExists(4)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                          <label for=\"agreedisagree-id4\"></label>\r\n                          <div class=\"checknew four forth\"></div>\r\n                        </li>\r\n                      </ul>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col col-6\">\r\n                <div class=\"radio-container rcontent\">\r\n                  <span  style=\"color: #04A752; font-weight: bold;\">&nbsp;AGREE</span>\r\n                  <div style=\"float:left;\">\r\n                    <div class=\"box\">\r\n                      <ul class=\"vi-radio\">\r\n                        <li>\r\n                          <input type=\"radio\" id=\"agreedisagree-id3\" ng-disabled=\"true\" name=\"agreeDisagree\" value=\"3\" ng-model=\"answer\" ng-checked=\"checkIfExists(3)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                          <label for=\"agreedisagree-id3\"></label>\r\n                          <div class=\"checknew three third\"></div>\r\n                        </li>\r\n                      </ul>\r\n                    </div>\r\n                    <div class=\"box\">\r\n                      <ul class=\"vi-radio\">\r\n                        <li>\r\n                          <input type=\"radio\" id=\"agreedisagree-id2\" ng-disabled=\"true\" name=\"agreeDisagree\" value=\"2\" ng-model=\"answer\" ng-checked=\"checkIfExists(2)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                          <label for=\"agreedisagree-id2\"></label>\r\n                          <div class=\"checknew two second\"></div>\r\n                        </li>\r\n                      </ul>\r\n                    </div>\r\n                    <div class=\"box\">\r\n                      <ul class=\"vi-radio\">\r\n                        <li>\r\n                          <input type=\"radio\" id=\"agreedisagree-id1\" ng-disabled=\"true\" name=\"agreeDisagree\" value=\"1\" ng-model=\"answer\" ng-checked=\"checkIfExists(1)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                          <label for=\"agreedisagree-id1\"></label>\r\n                          <div class=\"checknew first\"></div>\r\n                        </li>\r\n                      </ul>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"card card1\">\r\n          <div class=\"card-header card1Header\">\r\n            <p class=\"card-title\">IMPORTANCE</p>\r\n          </div>\r\n          <div class=\"card-body card1Body\" style=\"margin:0 auto;\">\r\n            <form class=\"impSection d-md-flex d-sm-block\">\r\n              <div class=\"A\">\r\n                <input type=\"radio\" class=\"button\" ng-disabled=\"true\" id=\"importance-id1\" ng-model=\"importance\" ng-checked=\"checkImpExists(1)\" value=\"1\"></input>\r\n                <label for=\"importance-id1\">Not Very</label>\r\n              </div>\r\n              <div class=\"B\">\r\n                <input type=\"radio\" class=\"button\" ng-disabled=\"true\" id=\"importance-id2\" ng-model=\"importance\" ng-checked=\"checkImpExists(2)\" value=\"2\"></input>\r\n                <label for=\"importance-id2\">Somewhat</label>\r\n              </div>\r\n              <div class=\"C\">\r\n                <input type=\"radio\" class=\"button\" id=\"importance-id3\" ng-disabled=\"true\" ng-model=\"importance\" ng-checked=\"checkImpExists(3)\" value=\"3\"></input>\r\n                <label for=\"importance-id3\">Very</label>\r\n              </div>\r\n              <!-- </div> -->\r\n            </form>\r\n          </div>\r\n        </div>\r\n        <div class=\"card card1\" ng-if=\"comment\">\r\n          <div class=\"card-header card1Header\">\r\n            <p class=\"card-title\">COMMENT</p>\r\n          </div>\r\n          <div class=\"card-body card1Body\">\r\n\r\n            <h3>{{comment}}</h3>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"col bottomBtns\">\r\n            <div class=\"btn-group\" role=\"group\" aria-label=\"Default button group\">\r\n              <button type=\"button\" id=\"backBtn\" ng-if=\"currentIndex > 0\" class=\"btn-transparent\" ng-click=\"prevQuestion()\"> <i class=\"fa fa-angle-left arrowIconBack\"></i> Back</button>\r\n\r\n              <button type=\"button\" id=\"submitBtn\" class=\"btn-transparent\" ng-if=\"currentIndex < questions.length -1 \" ng-click=\"skipQuestion()\" ng-class=\"{\'activeSubmit\': (answer &&importance)}\">Next <i class=\"fa fa-angle-right arrowIconSubmit\"></i></button>\r\n              <button type=\"button\" id=\"submitBtn\" class=\"btn-transparent\" ng-if=\"currentIndex == questions.length -1 \" ng-click=\"getMatch()\" ng-class=\"{\'activeSubmit\': (answer &&importance)}\">Finish <i class=\"fa fa-angle-right arrowIconSubmit\"></i></button>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/poliCompare/poliCompare.html","<!-- <div class=\"container-fluid\"> -->\r\n<!-- <h4>Welocme</h4> -->\r\n<div>\r\n  <div>\r\n    <p id=\"DisplayQ\">\r\n      <h1>\r\n        <center>{{category.title}}</center>\r\n      </h1>\r\n    </p>\r\n    <p></p>\r\n    <div>\r\n      <center ng-if=\"category.fbImage\">\r\n        <img ng-src=\"https://api.votewise.net/resources/{{category.fbImage}}\" class=\"wibble\" />\r\n      </center>\r\n    </div>\r\n    <center id=\"DisplayC\">\r\n      <h2>BACKGROUND</h2>\r\n    </center>\r\n    <p></p>\r\n    <div class=\"row d-flex justify-content-center\">\r\n      <div class=\"col-lg-7 col-sm-12\">\r\n        <p ng-bind-html=\"category.description | newlines\"></p>\r\n      </div>\r\n      <div ng-if=\"status.category == 1\" class=\"fwb\">\r\n        Loading category ...\r\n      </div>\r\n      <div ng-if=\"status.category == 3\" class=\"fwb\">\r\n        Something went wrong while loading category.\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div ng-show=\"questions[currentIndex]\">\r\n    <!-- <type=\"button\" value=\"LEARN MORE\"> -->\r\n    <p></p>\r\n    <center>\r\n      <h2>QUESTION</h2>\r\n    </center>\r\n    <p></p>\r\n    <p></p>\r\n    <center>({{currentIndex+1}} of {{questions.length}})</center>\r\n    <p></p>\r\n    <p>STATEMENT: <span class=\"card-text\" ng-bind-html=\"questions[currentIndex].content | newlines\"></span></p>\r\n    Your Answers<span  style=\"margin-left: 30px;\">Their Answers</span>\r\n    <div class=\"clearfix\">\r\n      <div class=\"pull-left ans-col\" style=\"border-right: 3px solid #de8998;\">\r\n        <div class=\"pad10\">\r\n          <div class=\"clearfix\" style=\"line-height: 9px\">\r\n            <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\">\r\n              <span class=\"inl-blk\" ng-if=\"i == 1\" style=\"margin-right: 10px; \">AGREE</span>\r\n              <span class=\"inl-blk\" ng-if=\"i == 6\">DISAGREE</span>\r\n              <div class=\"cq-box inl-blk pull-right\"\r\n                ng-class=\"(questions[currentIndex].my_answer.answer == i) ? (\'ag-green\') : \'\'\"></div>\r\n            </div>\r\n          </div>\r\n          <div class=\"clearfix\">\r\n            <div class=\"mb5 clearfix\">\r\n              <div class=\"inl-blk pull-right\">MATCH %</div>\r\n            </div>\r\n          </div><br>\r\n          <div class=\"clearfix\" style=\"line-height: 9px\">\r\n            <p>IMPORTANCE</p>\r\n            <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\">\r\n              <span class=\"inl-blk\" ng-if=\"i == 1\">Very</span>\r\n              <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n              <span class=\"inl-blk\" ng-if=\"i == 3\">Not Very</span>\r\n              <div class=\"cq-box inl-blk pull-right \"\r\n                ng-class=\"(questions[currentIndex].my_answer.importance == i) ? \'ag-dg\' : \'\'\"></div>\r\n            </div>\r\n          </div>\r\n          <div class=\"clearfix\"><br>\r\n            <p>COMMENTS</p>\r\n            <div class=\"mb5 clearfix\">\r\n              <div class=\"inl-blk pull-right\">\r\n                <span class=\"clk ylink\" ng-if=\"!(questions[currentIndex].my_answer.comment | isBlankString)\" ng-click=\"viewAnsComment(questions[currentIndex].my_answer)\">READ</span>\r\n                <span ng-if=\"questions[currentIndex].my_answer.comment | isBlankString\">None</span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"clearfix vtxt-wrap pad10\">\r\n        </div>\r\n      </div>\r\n\r\n\r\n      <div class=\"pull-left ans-col\" ng-repeat=\"ans in questions[currentIndex].answers | orderBy:\'author.nameOnBallot\'\">\r\n        <div class=\"pad10\">\r\n          <div class=\"clearfix\" style=\"height: 120px;\">\r\n\r\n            <div ng-if=\"ans.answer > -1\" ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\">\r\n              <div class=\"cq-box inl-blk pull-right\" ng-class=\"(ans.answer == i) ? getComapreClass(ans.match, i) : \'\'\">\r\n              </div>\r\n\r\n              <!-- ng-class=\"(ans.answer == i) ? (\'ag-dg\'+i) : \'\'\" -->\r\n            </div>\r\n            <div ng-if=\"!ans.answer\" class=\"flex w100 h100\">\r\n              <span>\r\n                <b>N/A</b>\r\n              </span>\r\n            </div>\r\n          </div>\r\n          <div class=\"clearfix\" style=\"height: 32px;\">\r\n            <div class=\"mb5 clearfix\">\r\n              <div ng-if=\"ans.match != null\" class=\"inl-blk pull-right\">{{ans.match}}%</div>\r\n              <div ng-if=\"ans.match == null\" class=\"w100 text-center fwb\">N/A</div>\r\n              <i ng-if=\"ans.referenceBy && ans.referenceBy !=\'\'\" class=\"fa fa-asterisk clk info-color\" aria-hidden=\"true\" ng-click=\"getInfo(ans)\"></i>\r\n              <i ng-if=\"ans.oldAnswers.length > 0 && !ans.referenceBy\" class=\"fa fa-asterisk clk icolor\" aria-hidden=\"true\" ng-click=\"getOldAnswers(ans.oldAnswers)\" style=\"font-size: 15px;\"></i>\r\n            </div>\r\n          </div>\r\n          <div class=\"clearfix\" style=\"height: 111px;\">\r\n            <p>&nbsp;</p>\r\n            <div ng-if=\"ans.importance\" ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\">\r\n              <div class=\"cq-box inl-blk pull-right \" ng-class=\"(ans.importance == i) ? \'ag-dg\' : \'\'\"></div>\r\n            </div>\r\n            <div ng-if=\"!ans.importance\" class=\"flex w100 h100\">\r\n              <span>\r\n                <b>N/A</b>\r\n              </span>\r\n            </div>\r\n          </div>\r\n          <div class=\"clearfix\">\r\n            <p>&nbsp;</p>\r\n            <div class=\"mb5 clearfix\">\r\n              <span class=\"clk ylink\" ng-if=\"ans.comment && !(ans.comment | isBlankString)\" ng-click=\"viewAnsComment(ans)\">READ</span>\r\n              <span ng-if=\"ans.comment && (ans.comment | isBlankString)\">None</span>\r\n              <span ng-if=\"!ans.comment\" class=\"fwb\">N/A</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"clearfix vtxt-wrap pad10\">\r\n          <div class=\"ver-txt\" ng-if=\"ans.author.userType == \'politician\'\" style=\"text-transform:capitalize;\">\r\n            {{ans.author.name_on_ballot || ans.author.name}}</div>\r\n          <div class=\"ver-txt\" ng-if=\"ans.author.userType == \'advocate\'\" style=\"text-transform:capitalize;\">\r\n            {{ans.author.title || ans.author.name}}</div>\r\n          <div style=\"line-height:12px; text-transform:capitalize;\" ng-repeat=\"pitem in ans.author.politicianInfo\"\r\n            ng-if=\"pitem.candidateStatus==\'Running\' || pitem.candidateStatus==\'Announced\'\">{{pitem.officeName}}</div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"mb5 clearfix print-hide\"\r\n    ng-if=\"!showComment && !unComment && !showPoliAnswerDetails && !showUserAnswerDetails && !showCurr\">\r\n    <!-- <a class=\"clk fwb\" ng-click=\"prevQuestion()\">Prev</a>&nbsp;\r\n                  <a class=\"clk fwb\" ng-click=\"skipQuestion()\">Next</a> -->\r\n    <button class=\"compareBtnS\" ng-click=\"prevQuestion()\"><i class=\"fa fa-angle-left arrowIconBack\"></i>Prev</button>\r\n    <button class=\"compareBtnS\" ng-click=\"skipQuestion()\">Next<i class=\"fa fa-angle-right arrowIconSubmit\"></i></button>\r\n			<p><i class=\"fa fa-asterisk clk info-color\"  style=\"font-size: 15px;\"></i> This indicates that the politician did not answer this question, but we did research to figure out their LIKELY answer.  You can see our research notes by clicking on their yellow asterisk.</p>\r\n			<p><i class=\"fa fa-asterisk clk icolor\"  style=\"font-size: 15px;\"></i> This indicates that the politician changed\r\n        their answer at some point - possibly because they learned more about the topic. You can see the politician\'s\r\n        old answers for this question and the reasons for changing them by clicking on their asterix.</p>\r\n      <p>NOTE: Some of the politician questions were taken from other sources where an answer of \"True\" or \"False\" was\r\n        converted to \"Somewhat Agree\" or \"Somewhat Disagree\" (one point from either extreme) and we gave those answers\r\n        an importance level of \"Somewhat important\". This may mean their answers do not fully express their passion or\r\n        conviction.</p>\r\n  </div>\r\n  </div>\r\n</div>\r\n<!-- </div> -->\r\n<script type=\"text/ng-template\" id=\"showOldAnsPopUp\">\r\n  <div class=\"container-fluid\">\r\n    <h5>Old Answers</h5>\r\n    <div ng-repeat=\"com in oldAns track by $index\">\r\n        <div class=\"pad10\">\r\n\r\n          <br>\r\n          <span>Answer</span>\r\n          <br>\r\n          <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n\r\n            <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n              style=\"padding-left: 8px;  line-height: 15px\">\r\n              <span class=\"inl-blk pull-left\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n              <div class=\"cq-box inl-blk pull-left\"\r\n                ng-class=\"(com.answer == i) ? getComapreClass(com.answer, i) : \'\'\"></div>\r\n              <span class=\"inl-blk\" ng-if=\"i == 6\" style=\"padding-left:8px\">DISAGREE</span>\r\n            </div>\r\n          </div>\r\n          <br>\r\n          <p></p>\r\n          <span>IMPORTANCE</span>\r\n          <br>\r\n          <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n            <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"padding-left: 8px; line-height: 9px\">\r\n              <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n              <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n              <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n              <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                ng-class=\"(com.importance == i) ? \'ag-blk\' : \'\'\"></div>\r\n            </div>\r\n          </div>\r\n          <p></p>\r\n          <div>\r\n            <span ng-if=\"com.comment\">Comment:</span>\r\n            <span ng-if=\"com.comment\" class=\"newcomName\">{{com.comment}}</span>\r\n          </div>\r\n          <span>Reason to Change the Answer: {{com.reason}}</span><br>\r\n  <span>Updated on: {{com.created | date: \'MM-dd-y\'}}</span>\r\n          <hr style=\"\r\n          margin-left: auto;\r\n          margin-right: auto;\r\n          height: 1px;\r\n          background-color:#666;\r\n          opacity: 0.5;\">\r\n        </div>\r\n      </div>\r\n            </div>\r\n</script>\r\n<script type=\"text/ng-template\" id=\"showInfoPopUp\">\r\n  <div class=\"container-fluid\">\r\n    <h5>Notes</h5>\r\n    <p ng-bind-html=\"showComment | newlines\"></p>\r\n            </div>\r\n</script>");
$templateCache.put("app/politicianMatch/politicianMatch.html","<style type=\"text/css\">\r\n  .digDeeperSmall {\r\n    width: 150px;\r\n  }\r\n</style>\r\n<div>\r\n  <center>\r\n    <h2>Match</h2>\r\n  </center>\r\n\r\n  <div ng-if=\"showcomparison == false && questions.length > 0\">\r\n    <center>\r\n      <a href=\"\" ng-click=\"showDetails()\"><button class=\"compareBtn\"> Match Details</button></a>\r\n    </center>\r\n    <br><br>\r\n  </div>\r\n    <div style=\"text-align:left;\" ng-if=\"showcomparison == false && questions.length > 0\">\r\n\r\n      <div ng-if=\"noDataFound == false\">\r\n        <div class=\"squareBoxY\" style=\"margin-left:10px;\">&nbsp;</div>\r\n        <span>= Simple Comparison by answers alone.</span>\r\n        <div style=\"clear:both;\"></div>\r\n        <div class=\"squareBoxB\" style=\"margin-left:10px\">&nbsp;</div>\r\n        <span>= Weighted Comparison by answers and importance.</span>\r\n        <div style=\"clear:both;\"></div>\r\n      </div>\r\n\r\n      <ul class=\"catList\" ng-if=\"noDataFound == false\">\r\n        <li ng-if=\"FBunWeighted[AllUsers._id] && fbcombinedWeight[AllUsers._id]\">\r\n          <div style=\"background-color:#ffffee; padding:10px;\">\r\n            <div style=\"color: #000000;\">\r\n              <b>{{poliName}}</b>&nbsp;&nbsp;&nbsp;Total\r\n              Answered questions: {{fbqlen[AllUsers._id]}}\r\n            </div>\r\n            <div style=\"width: 84%; float:left;\">\r\n              <div>\r\n                <div class=\"fbunweighted\"\r\n                  style=\"width:{{(FBunWeighted[AllUsers._id] / fbqlen[AllUsers._id] )  | number:2}}%\">\r\n                  {{(FBunWeighted[AllUsers._id] / fbqlen[AllUsers._id] ) | number:2}}%</div>\r\n              </div>\r\n              <div>\r\n                <div class=\"fbweighted\"\r\n                  style=\"width:{{(fbcombinedWeight[AllUsers._id] / fbmultiplier[AllUsers._id])  | number:2}}%\">\r\n                  {{(fbcombinedWeight[AllUsers._id] / fbmultiplier[AllUsers._id]) | number:2}}%</div>\r\n              </div>\r\n            </div>\r\n            <div style=\"clear:both;\"></div>\r\n          </div>\r\n        </li>\r\n      </ul>\r\n      <div ng-if=\"noDataFound == true\">\r\n        <h3>\r\n          <p style=\"color:red\">Congratulations! You are the first person in your region to take this quiz. You are a\r\n            true\r\n            pioneer! You should contact your local politicians and your friends to encourage them to use this site.\r\n            There\r\n            are still plenty of wonderful things here to see.</p>\r\n        </h3>\r\n        <br>\r\n        <br>\r\n        <div class=\"margin-auto mxw\">\r\n          <div class=\"digDeeperSmall\" style=\"float:left\">\r\n            <a href=\"#!/digDeeper\"><img ng-src=\"../assets/images/DigDeeper.svg\" alt=\"Dig deeper\"/></a></div>\r\n          <button class=\"btnB275\" style=\"width:150px; float:right;\" ng-click=\"finalSignIn()\">Sign In</button>\r\n        </div>\r\n\r\n      </div>\r\n    </div>\r\n    <div class=\"alert alert-danger alert-dismissible\" id=\"alert\" ng-if=\"showAlert\" style=\"width:60%;margin-left:\r\n              20%;margin-top:10%\">\r\n      <button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button>\r\n      <strong> Please verify your email first. </strong>\r\n    </div>\r\n    <!--     <h2>BACKGROUND</h2></center>\r\n      <p></p>\r\n      <p ng-bind-html=\"category.description | newlines\"></p>-->\r\n    <div ng-if=\"loader\" class=\"fwb\">\r\n      Loading data ...\r\n      <p>\r\n        <center><i class=\"fa fa-refresh fa-spin\" style=\"font-size:72px;\"></i></center>\r\n      </p>\r\n    </div>\r\n\r\n    <div ng-if=\"showcomparison == true && !loader\">\r\n      <div>\r\n        <div>\r\n          <p>\r\n            <h1>\r\n              <center>{{category.title}}</center>\r\n            </h1>\r\n          </p>\r\n          <p></p>\r\n          <div>\r\n            <center ng-if=\"category.fbImage\">\r\n              <img ng-src=\"https://api.votewise.net/resources/{{category.fbImage}}\" class=\"wibble\" /></center>\r\n          </div>\r\n          <center id=\"DisplayC\">\r\n            <h2>BACKGROUND</h2>\r\n          </center>\r\n          <p></p>\r\n          <p ng-bind-html=\"category.description | newlines\"></p>\r\n        </div>\r\n        <div ng-show=\"questions[currentIndex]\">\r\n          <!-- <type=\"button\" value=\"LEARN MORE\"> -->\r\n          <!--      <button ng-click=\"$root.printPage()\" class=\"print-hide changeTextColor\">Print this page</button>  -->\r\n          <p></p>\r\n          <center id=\"DisplayQ\">\r\n            <h2>QUESTION</h2>\r\n          </center>\r\n          <p></p>\r\n          <p></p>\r\n          <center>({{currentIndex+1}} of {{questions.length}})</center>\r\n          <p></p>\r\n          <p>STATEMENT: <span class=\"card-text\" ng-bind-html=\"questions[currentIndex].content | newlines\"></span></p>\r\n          Your Answers<span  style=\"margin-left: 30px;\">Their Answers</span>\r\n          <div class=\"clearfix\">\r\n            <div class=\"pull-left ans-col\" style=\"border-right: 3px solid #de8998;\">\r\n              <div class=\"pad10\">\r\n                <div class=\"clearfix\" style=\"line-height: 9px\">\r\n                  <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\">\r\n                    <span class=\"inl-blk\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n                    <span class=\"inl-blk\" ng-if=\"i == 6\">DISAGREE</span>\r\n                    <div class=\"cq-box inl-blk pull-right\"\r\n                      ng-class=\"(questions[currentIndex].my_answer.answer == i) ? (\'ag-green\') : \'\'\"></div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"clearfix\">\r\n                  <div class=\"mb5 clearfix\"><br>\r\n                    <div class=\"inl-blk pull-right\">MATCH %</div>\r\n                  </div>\r\n                </div><br>\r\n                <div class=\"clearfix\" style=\"line-height: 9px\">\r\n                  <p>IMPORTANCE</p>\r\n                  <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\">\r\n                    <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n                    <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n                    <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                    <div class=\"cq-box inl-blk pull-right \"\r\n                      ng-class=\"(questions[currentIndex].my_answer.importance == i) ? \'ag-dg\' : \'\'\"></div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"clearfix\"><br>\r\n                  <p>COMMENTS</p>\r\n                  <div class=\"mb5 clearfix\">\r\n                    <div class=\"inl-blk pull-right\">\r\n                      <span class=\"clk ylink\" ng-if=\"!(questions[currentIndex].my_answer.comment | isBlankString)\" ng-click=\"viewAnsComment(questions[currentIndex].my_answer)\">READ</span>\r\n                      <span ng-if=\"questions[currentIndex].my_answer.comment | isBlankString\">None</span>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"clearfix vtxt-wrap pad10\">\r\n              </div>\r\n            </div>\r\n            <div class=\"pull-left ans-col\"\r\n              ng-if=\"questions[currentIndex].answers.author.name || questions[currentIndex].answers.author.nameOnBallot\">\r\n              <div class=\"pad10\">\r\n                <div class=\"clearfix\" style=\"height: 120px;\">\r\n                  <div ng-if=\"questions[currentIndex].answers.answer > -1\" ng-repeat=\"i in [1,2,3,4,5,6]\"\r\n                    class=\"mb5 clearfix\">\r\n                    <div class=\"cq-box inl-blk pull-right\"\r\n                      ng-class=\"(questions[currentIndex].answers.answer == i) ? getComapreClass(questions[currentIndex].answers.answer, i) : \'\'\">\r\n                    </div>\r\n                    <!-- ng-class=\"(ans.answer == i) ? (\'ag-dg\'+i) : \'\'\" -->\r\n                  </div>\r\n                  <div ng-if=\"!questions[currentIndex].answers.answer\" class=\"flex w100 h100\">\r\n                    <span><b>N/A</b></span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"clearfix\" style=\"height: 32px;\">\r\n                  <div class=\"mb5 clearfix\"><br>\r\n                    <div ng-if=\"questions[currentIndex].answers.match != null\" class=\"inl-blk pull-right\">\r\n                      {{questions[currentIndex].answers.match}}%</div>\r\n                    <div ng-if=\"questions[currentIndex].answers.match == null\" class=\"w100 text-center fwb\">N/A</div>\r\n                  </div>\r\n                </div><br>\r\n                <div class=\"clearfix\" style=\"height: 111px;\">\r\n                  <p>&nbsp;</p>\r\n                  <div ng-if=\"questions[currentIndex].answers.importance\" ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\">\r\n                    <div class=\"cq-box inl-blk pull-right \"\r\n                      ng-class=\"(questions[currentIndex].answers.importance == i) ? \'ag-dg\' : \'\'\"></div>\r\n                  </div>\r\n                  <div ng-if=\"!questions[currentIndex].answers.importance\" class=\"flex w100 h100\">\r\n                    <span><b>N/A</b></span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"clearfix\">\r\n                  <p>&nbsp;</p>\r\n                  <div class=\"mb5 clearfix\">\r\n                    <span class=\"clk ylink\" ng-if=\"questions[currentIndex].answers.comment && !(questions[currentIndex].answers.comment | isBlankString)\" ng-click=\"viewAnsComment(questions[currentIndex].answers)\">READ</span>\r\n                    <span ng-if=\"questions[currentIndex].answers.comment && (questions[currentIndex].answers.comment | isBlankString)\">No</span>\r\n                    <span ng-if=\"!questions[currentIndex].answers.comment\" class=\"fwb\">N/A</span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"clearfix vtxt-wrap pad10\">\r\n                <div class=\"ver-txt\">\r\n                  <div style=\"line-height:12px;\">\r\n                    {{questions[currentIndex].answers.author.nameOnBallot || questions[currentIndex].answers.author.name}}\r\n                  </div>\r\n                  <div style=\"line-height:12px;\" ng-repeat=\"pitem in ans.author.politicianInfo\"\r\n                    ng-if=\"pitem.candidateStatus==\'Running\'\">{{pitem.officeName}}</div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"mb5 clearfix print-hide\">\r\n          <!-- <a class=\"clk fwb\" ng-click=\"prevQuestion()\">Prev</a>&nbsp;\r\n                    <a class=\"clk fwb\" ng-click=\"skipQuestion()\">Next</a> -->\r\n          <button class=\"compareBtnS\" ng-click=\"prevQuestion()\"><i class=\"fa fa-angle-left arrowIconBack\"></i>Prev</button>\r\n          <button class=\"compareBtnS\" ng-click=\"skipQuestion()\">Next<i class=\"fa fa-angle-right arrowIconSubmit\"></i></button>\r\n        </div>\r\n        <button class=\"compareBtn\"><a href=\"#!/whatAmILookingAt4\">What Am I Looking At?</a></button>\r\n      </div>\r\n    </div>\r\n    <div ng-if=\"status.questions == 2 && questions.length == 0\" class=\"fwb\">\r\n      <center>No unanswered questions found.</center>\r\n    </div>\r\n    <div ng-if=\"status.questions == 1\" class=\"fwb\">\r\n      Loading questions ...\r\n    </div>\r\n    <div ng-if=\"status.questions == 3\" class=\"fwb\">\r\n      Something went wrong while loading questions.\r\n    </div>\r\n  </div>\r\n  <center>\r\n    <a href=\"#!/addRating/{{poliId}}\" class=\"btn2Short-style widthAuto btn-success\" >\r\n      Rate Politician\r\n    </a>\r\n    <a href=\"#!/addEndorsement/{{poliId}}\" ng-if=\"poliInfo.politicianInfo[0].runningForOffice == \'Y\'\" class=\"btn2Short-style widthAuto btn-success\">Endorse</a>\r\n  </center>\r\n</div>\r\n");
$templateCache.put("app/politicianSignup/politicianSignup.html","<head>\r\n<title>Politician Creation</title>\r\n<!-- This next line keeps buttons and forms at a legible size on cell phones -->\r\n<meta name=\"viewport\" content=\"initial-scale=1, maximum-scale=1\">\r\n</head>\r\n<div>\r\n\r\n<div>\r\n<p align = left>\r\nThis section is for people who are running for office. <br><br>\r\nIf you have received a confirmation code from us, please put write it into the box below. <b>\r\n\r\n<form>\r\nConfirmation Code: <br>\r\n<input type \"text\" name=\"confirmationCode\"\r\n</form>\r\n<br></b>\r\n\r\nIn this current launch, you can answer questions and explore the site, but we won&#8217t be posting your answers or allowing you to see how your constituents answered until we can verify that you are who you say you are using whatever contact information is in the board of elections database.  For many of you, this is just a mailing address, so confirmation could take time.  If you are not on the ballot, we won&#8217t be letting you create a Politician profile.  Please contact your local board of elections to find out how to get on the ballot. </p>\r\n\r\n<form>\r\nFirst name:<br>\r\n<input type=\"text\" name=\"firstname\">\r\n<br>\r\nMiddle name:<br>\r\n<input type=\"text\" name=\"middlename\">\r\n<br>\r\nLast name:<br>\r\n<input type=\"text\" name=\"lastname\">\r\n</form>\r\n<form>\r\n  E-mail:<br>\r\n  <input ng-model=\"user.email\" type=\"email\" name=\"email\">\r\n  <br>\r\n  User password:<br>\r\n  <input ng-model=\"user.password\" type=\"password\" name=\"psw\">\r\n    Telephone:<br>\r\n  <input ng-model=\"user.phone\" type=\"tel\" name=\"usrtel\"><br>\r\n  <form>\r\nZIP Code:<br>\r\n<input ng-model=\"user.zip\" type=\"zip\" name=\"zip\">\r\n</form>\r\n    Add your Website: <br>\r\n  <input type=\"url\" ng-model=\"user.url\" name=\"weibsite\">\r\n</form>\r\n<p align = left>\r\nWhat Office are you running for? <br> <br>\r\n\r\n<b> STATE LEVEL </b>\r\n<br>\r\nPosition </p>\r\n<form action=\"action_page.php\">\r\n  <select ng-model=\"user.judgeType\" name=\"Judge Type\">\r\n    <option value=\"No answer\">No answer</option>\r\n        <option value=\"JUSTICE OF THE SUPREME COURT\">JUSTICE OF THE SUPREME COURT</option>\r\n    <option value=\"JUDGE OF THE SUPERIOR COURT\">JUDGE OF THE SUPERIOR COURT</option>\r\n    <option value=\"JUDGE OF THE COMMONWEALTH COURT\">JUDGE OF THE COMMONWEALTH COURT</option>\r\n    <option value=\"JUDGE OF THE COURT OF COMMON PLEAS\">JUDGE OF THE COURT OF COMMON PLEAS</option>\r\n    <option value=\"JUDGE OF THE MUNICIPAL COURT\">JUDGE OF THE MUNICIPAL COURT</option>\r\n  </select>\r\n  <br>\r\n  <form>\r\nJudicial District Number (Enter 0 for StateWide):\r\n  <input ng-model=\"user.districtNum\" type=\"number\" name=\"quantity\" min=\"0\" max=\"60\">\r\n</form>\r\n  <input type=\"submit\">\r\n</form>\r\n<br> <hr size=\"5\" noshade><br>\r\n<b>COUNTY LEVEL</b>\r\n<br>\r\nPosition\r\n<form action=\"action_page.php\">\r\n  <select ng-model=\"user.countyLevel\" name=\"County Level\">\r\n    <option value=\"No answer\">No answer</option>\r\n    <option value=\"County Commissioner-at-Large\">County Commissioner-at-Large</option>\r\n    <option value=\"County Controller\">County Controller</option>\r\n    <option value=\"District Attorney\">District Attorney</option>\r\n    <option value=\"Sheriff\">Sheriff</option>\r\n    <option value=\"Clerk of Judicial Records\">Clerk of Judicial Records</option>\r\n    <option value=\"Magisterial District 31-1-01\">Magisterial District 31-1-01</option>\r\n    <option value=\"Magisterial District 31-1-03\">Magisterial District 31-1-03</option>\r\n    <option value=\"Magisterial District 31-2-01\">Magisterial District 31-2-01</option>\r\n  </select>\r\n  <br>\r\n  <form>\r\n\r\n</form>\r\n  <input type=\"submit\">\r\n  <br> <hr size=\"5\" noshade><br>\r\n<b>CITY LEVEL</b>\r\n<br>\r\nPosition\r\n<form action=\"action_page.php\">\r\n  <select ng-model=\"user.cityLevel\" name=\"CITY LEVEL\">\r\n    <option value=\"No answer\">No answer</option>\r\n    <option value=\"Auditor\">Auditor</option>\r\n	<option value=\"City Controller\">City Controller</option>\r\n    <option value=\"City Council\">City/Town Council</option>\r\n	<option value=\"City Treasurer\">City Treasurer</option>\r\n    <option value=\"Commissioner\">Commissioner</option>\r\n    <option value=\"Commissioner 1st ward\">Commissioner 1st ward</option>\r\n    <option value=\"Commissioner 3rd ward\">Commissioner 3rd ward</option>\r\n    <option value=\"Commissioner 5th ward\">Commissioner 5th ward</option>\r\n    <option value=\"Constable\">Constable</option>\r\n    <option value=\"Council at Large\">Council at Large</option>\r\n    <option value=\"District Council\">District Council</option>\r\n    <option value=\"Mayor\">Mayor</option>\r\n    <option value=\"Register of Wills\">Register of Wills</option>\r\n    <option value=\"School Director\">School Director</option>\r\n    <option value=\"School Director At Large\">School Director At Large</option>\r\n    <option value=\"Supervisor\">Supervisor</option>\r\n    <option value=\"Sheriff\">Sheriff</option>\r\n    <option value=\"Tax Collector\">Tax Collector</option>\r\n  </select>\r\n  <br>\r\n  <form>\r\nWhich City <br>\r\n\r\n\r\n  <form ng-model=\"user.city\" action=\"action_page.php\">\r\n  <select name=\"Location\">\r\n    <option value=\"No answer\">No answer</option>\r\n	<option value=\"Alburtis\">Alburtis</option>\r\n    <option value=\"Allentown\">Allentown</option>\r\n    <option value=\"Bethlehem School District At Large\">Bethlehem School District At Large</option>\r\n    <option value=\"Bethlehem School District 2\">Bethlehem School District 2</option>\r\n    <option value=\"Bethlehem School District 3\">Bethlehem School District 3</option>\r\n    <option value=\"Catasaqua\">Catasaqua</option>\r\n	<option value=\"Coopersburg\">Coopersburg</option>\r\n    <option value=\"Coplay\">Coplay</option>\r\n	<option value=\"East Penn School District\">Lowhill</option>\r\n    <option value=\"Emmaus\">Emmaus</option>\r\n    <option value=\"Fountain Hill\">Fountain Hill</option>\r\n    <option value=\"Macungie\">Commissioner 5th ward</option>\r\n    <option value=\"Slatington\">Constable</option>\r\n    <option value=\"Hanover\">Hanover</option>\r\n    <option value=\"Heidelberg\">Heidelberg</option>\r\n    <option value=\"Lower Macungie\">Lower Macungie</option>\r\n    <option value=\"Lower Milford\">Lower Milford</option>\r\n	<option value=\"Lowhill\">Lowhill</option>\r\n    <option value=\"Lynn\">Lynn</option>\r\n    <option value=\"North Whitehall\">North Whitehall</option>\r\n    <option value=\"Northern Lehigh School District\">Northern Lehigh School District</option>\r\n    <option value=\"Northwestern Lehigh School District\">\"Northwestern Lehigh School District</option>\r\n	<option value=\"Parkland School District\">Parkland School District</option>\r\n    <option value=\"Philadelphia\">Philadelphia</option>\r\n    <option value=\"Salisbury\">Salisbury</option>\r\n	<option value=\"South Whitehall\">South Whitehall</option>\r\n    <option value=\"Southern Lehigh School District\">Southern Lehigh School District</option>\r\n    <option value=\"Upper Macungie\">Upper Macungie</option>\r\n    <option value=\"Upper Milford\">Upper Milford</option>\r\n    <option value=\"Upper Saucon\">Upper Sauconl</option>\r\n    <option value=\"Washington\">Washington</option>\r\n    <option value=\"Weisenberg\">Weisenberg</option>\r\n    <option value=\"Whitehall\">Whitehall</option>\r\n    <option value=\"Whitehall/Coplay School District\">Whitehall/Coplay School District</option>\r\n\r\n  </select>\r\n  <br>\r\n  <form>\r\n\r\n</form>\r\n  <form>\r\nWhat Ward Number (number only):\r\n  <input type=\"number\" name=\"quantity\" min=\"0\" max=\"60\"><br>\r\nWhat District Number (number only):\r\n  <input type=\"number\" name=\"quantity\" min=\"0\" max=\"60\">\r\n<br>\r\n <input type=\"submit\">\r\n </form>\r\n</div>\r\n");
$templateCache.put("app/politicianVideo/politicianVideo.html","\r\n<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">Politicians</h2>\r\n  <p class=\"pageSubHeading\">\r\n	  <a href=\"#!/signup/voter\" class=\"compareBtn\">	&nbsp;	&nbsp;Sign Up	&nbsp;	&nbsp;</a></p>\r\n 									<style>\r\n.iframe-container {\r\n  overflow: hidden;\r\n  padding-top: 56.25%;\r\n  position: relative;\r\n	top: -10%;\r\n}\r\n \r\n.iframe-container iframe {\r\n   border: 0;\r\n   height: 100%;\r\n   left: 0;\r\n   position: absolute;\r\n   top: 0;\r\n   width: 100%;\r\n	max-height: 400px;\r\n}\r\n											.fgtrh-container iframe{\r\n												left: 0;\r\n												top: 250px;\r\n												position:absolute;\r\n												height:50%;\r\n												width:50%;\r\n											}\r\n/* 4x3 Aspect Ratio */\r\n.iframe-container-4x3 {\r\n  padding-top: 75%;\r\n}</style>\r\n\r\n<div class=\"iframe-container\">\r\n  <iframe src=\"https://player.vimeo.com/video/408237898\" allowfullscreen></iframe>\r\n</div>\r\n");
$templateCache.put("app/politician_compare/politician_compare.html","<center>\r\n        <h2>Match</h2>\r\n        <h3>{{category.title}}</h3></center>\r\n\r\n    <center>\r\n        <h2>BACKGROUND</h2></center>\r\n    <p></p>\r\n\r\n    <p ng-bind-html=\"category.description | newlines\"></p>\r\n       <div class=\"alert alert-danger alert-dismissible\" id=\"alert\" ng-if=\"showAlert\" style=\"width:60%;margin-left:\r\n            20%;margin-top:10%\">\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button>\r\n    <strong> You haven\'t answered these questions yet to make the match. </strong>\r\n  </div>\r\n    <div>\r\n        <div class=\"squareBoxY\" style=\"margin-left:10px;\">&nbsp;</div>\r\n        <span>= Simple Comparison by answers alone.</span>\r\n        <div style=\"clear:both;\"></div>\r\n        <div class=\"squareBoxB\" style=\"margin-left:10px\">&nbsp;</div>\r\n        <span>= Weighted Comparison by answers and importance.</span>\r\n        <div style=\"clear:both;\"></div>\r\n    </div>\r\n    <!-- \r\n    <div>\r\n        <div style=\"width:30%; float:left; text-align:right;\">Order By :&nbsp;&nbsp;</div>\r\n        <div style=\"width:65%; float:left; text-align:left;\">\r\n            <select ng-model=\"ord.Option\">\r\n                <option value=\"BW\">Best Weighted match</option>\r\n                <option value=\"W\">Worst weighted match</option>\r\n                <option value=\"BS\">Best simple match</option>\r\n                <option value=\"S\">worst simple match</option>\r\n            </select>\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n    </div> \r\n    -->\r\n\r\n    <ul class=\"catList\">\r\n        <li ng-repeat=\"frd in FBfreinds track by $index\" ng-if=\"fbqlen[frd._id]\">\r\n            <div style=\"background-color:#dfdfed; padding:10px;\" class=\"blackText\">\r\n                <div><b style=\"text-transform: capitalize;\">{{frd.name}}</b>&nbsp;&nbsp;&nbsp;Total Answered questions: {{answeredQuestions[frd._id]}}</div>\r\n                <div style=\"width: 84%; float:left;\">\r\n                    <div>\r\n                        <div class=\"fbunweighted\" style=\"width:{{(FBunWeighted[frd._id] / fbqlen[frd._id] )  | number:2}}%\">{{(FBunWeighted[frd._id] / fbqlen[frd._id] ) | number:2}}%</div>\r\n                    </div>\r\n                    <div>\r\n                        <div class=\"fbweighted blackText\" style=\"width:{{(fbcombinedWeight[frd._id] / fbmultiplier[frd._id])  | number:2}}%\">{{(fbcombinedWeight[frd._id] / fbmultiplier[frd._id]) | number:2}}%</div>\r\n                    </div>\r\n                </div>\r\n                <div style=\"clear:both;\"></div>\r\n            </div>\r\n        </li>\r\n    </ul>\r\n    <div><center><input type=\"button\" name=\"btnNext\" class=\"compareBtn\" value=\"Next\" ng-click=\"nextCat()\"></center></div>");
$templateCache.put("app/politician_thread/politician_thread.html","<link rel=\"stylesheet\" type=\"text/css\" href=\"./forumList/forumList.css\">\r\n<div class=\"inline2\">\r\n  <div class=\"container-fluid\">\r\n\r\n    <h2 class=\"pageHeading\">POLITICIAN THREAD </h2>\r\n\r\n    <br>\r\n    <div style=\"width:60%; float:left;\">\r\n      <label>Refine: </label>\r\n    </div>\r\n    <div style=\"width:39%; float:right; text-align: right;\">\r\n      <label>Sort: </label>\r\n    </div>\r\n    <div>\r\n      <div style=\"width:60%; float:left;\">\r\n        <select ng-model=\"filterBy\" ng-init=\"filterBy = \'all\';\" style=\"text-transform: capitalize; \" class=\"blackText\">\r\n                <option ng-repeat=\"item in filterArray\" val=\"{{item}}\">{{item}}</option>\r\n            </select>\r\n      </div>\r\n      <div style=\"width:39%; float:right; text-align: right;\">\r\n        <select ng-model=\"sortBy\" ng-change=\"SortData()\" style=\"text-transform: capitalize;\" class=\"blackText\">\r\n                <option val=\"Select sort\">Chronological</option>\r\n                <option ng-repeat=\"item in sortArray\" class=\"blackText\" val=\"{{item}}\">{{item}}</option>\r\n            </select>\r\n      </div>\r\n    </div>\r\n    <div style=\"clear:both;\"></div>\r\n    <p ng-if=\"statusGetForumList == 1\">Loading ...</p>\r\n    <table style=\"width:100%\" class=\"blackText\">\r\n      <tr>\r\n        <th>Threads</th>\r\n        <th ng-if=\"userType==\'admin\'\"> Sticky </th>\r\n        <th> Replies</th>\r\n        <!-- <th ng-if=\"userType==\'admin\'\"> Sticky </th>\r\n      <th > Details </th> -->\r\n      </tr>\r\n\r\n      <tr ng-repeat=\"post in DisplayData | orderBy:\'-postSticky\'| refineDataPol: filterBy\"\r\n        ng-if=\"DisplayData.length > 0\" ng-style=\"checkSticky(post.postSticky)\">\r\n        <td>\r\n          <span ng-click=\"gotoThread(post._id);\" style=\"cursor:pointer;\">\r\n											<div class=\"link\" id=\"anchorList{{post._id}}\" >{{post.title}}</div></span>\r\n          <span>\r\n            Original Post by <img src=\"../assets/images/profile/{{post.createdBy.utype}}.svg\" class=\"usertype\" style=\"text-transform: capitalize;\">\r\n\r\n										<a href =\"#!/voterProfile/{{post.createdBy.id}}\"  class=\"link\" ng-if=\"post.createdBy.utype==\'voter\'\" style=\"text-transform: capitalize;\">{{post.createdBy.name}}</a>\r\n          <a href =\"#!/pressProfile/{{post.createdBy.id}}\"  class=\"link\" ng-if=\"post.createdBy.utype==\'advocate\'\" style=\"text-transform: capitalize;\">{{post.title}}</a>\r\n           <a href=\"#!/publicProfile/{{post.createdBy.id}}\" ng-if=\"post.createdBy.utype==\'politician\'\"style=\"text-transform: capitalize;\" class=\"link\">{{post.createdBy.nameOnBallot}}</a>\r\n										<b ng-if=\"post.createdBy.utype == \'admin\'\">VoteWise Admin</b>\r\n          </span>\r\n          <br>\r\n          <div ng-if=\"post.lastTopic\">Latest post by\r\n            <img src=\"../assets/images/profile/{{post.lastTopic.createdBy.utype}}.svg\" class=\"usertype\">\r\n            <a href =\"#!/voterProfile/{{post.lastTopic.createdBy.id}}\"  class=\"link\" ng-if=\"post.lastTopic.createdBy.utype==\'voter\'\" style=\"text-transform: capitalize;\">{{post.lastTopic.createdBy.name}}</a>\r\n            <a href =\"#!/pressProfile/{{post.lastTopic.createdBy.id}}\"  class=\"link\" ng-if=\"post.lastTopic.createdBy.utype==\'advocate\'\" style=\"text-transform: capitalize;\">{{post.lastTopic.createdBy.title}}</a>\r\n            <a href=\"#!/publicProfile/{{post.lastTopic.createdBy.id}}\" ng-if=\"post.lastTopic.createdBy.utype==\'politician\'\"style=\"text-transform: capitalize;\" class=\"link\">{{post.lastTopic.createdBy.nameOnBallot}}</a>\r\n            <b ng-if=\"post.lastTopic.createdBy.utype == \'admin\'\">VoteWise Admin</b>\r\n            <br>\r\n            {{post.lastTopic.createdOn | date:\'medium\'}}\r\n        </div>\r\n        </td>\r\n        <td ng-if=\"userType==\'admin\'\">\r\n          <span ng-if=\"post.postSticky==\'N\'\">\r\n      Order: <input type=\"number\" value=\"0\" style=\"width: 40px;\" ng-model=\"Sticky.txtOrder[post._id]\" maxlength=\"2\" /> <input type=\"button\" ng-click=\"updatePost(\'sticky\', post._id);\" name=\"btnSticky\" value=\"Set Sticky\">\r\n      </span>\r\n          <spam ng-click=\"updatePost(\'removeSticky\', post._id);\" ng-if=\"post.postSticky==\'Y\'\" style=\"cursor:pointer;\"\r\n            class=\"link\">Remove sticky </spam>\r\n        </td>\r\n        <td>{{post.totalReply}} </td>\r\n\r\n        <!-- <td ng-if=\"userType==\'admin\'\">\r\n        <span ng-if=\"post.postSticky==\'N\'\">\r\n        Order: <input type=\"number\" value=\"0\" style=\"width: 40px;\" ng-model=\"Sticky.txtOrder[post._id]\" maxlength=\"2\" /> <input type=\"button\" ng-click=\"updatePost(\'sticky\', post._id);\" name=\"btnSticky\" value=\"Set Sticky\">\r\n        </span>\r\n        <span ng-click=\"updatePost(\'removeSticky\', post._id);\" ng-if=\"post.postSticky==\'Y\'\" style=\"cursor:pointer;\">Remove sticky </span>\r\n      </td>\r\n\r\n      <td>\r\n        <a href=\"javascript: void(0);\" ng-if=\"post.createdBy.id!=userId\" ng-click=\"gotoThread(post._id);\">Details</a>\r\n        <a href=\"javascript: void(0);\" ng-if=\"post.createdBy.id==userId\" ng-click=\"gotoUpdate(post);\">Edit</a>\r\n      </td> -->\r\n      </tr>\r\n      <tr ng-if=\"DisplayData.length == 0\">\r\n        <td ng-if=\"userType!=\'admin\'\" colspan=\"3\">No records found.</td>\r\n        <td ng-if=\"userType==\'admin\'\" colspan=\"4\">No records found.</td>\r\n      </tr>\r\n    </table>\r\n    <br>\r\n    <!-- <form action=\"\"> -->\r\n    <center>\r\n      <input type=\"submit\" class=\"btn\" ng-click=\"createNew()\" value=\"Create New Thread\" /></center>\r\n    <!-- </form> -->\r\n  </div>\r\n");
$templateCache.put("app/polProfile/polProfile.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">GETTING STARTED</h2>\r\n  <p class=\"pageSubHeading\">Choose your next action.</p>\r\n  <div class=\"row\">\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/dashboard\" class=\"blockLink\"><img ng-src=\"./assets/images/ProfileSettings3.svg\" class=\"gettingStartedImg img-fluid\"></a>\r\n      <div class=\"gettingStartedBlock\" id=\"gettingStartedBlock1\">\r\n          <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">PROFILE SETTINGS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Choose the subjects that matter to you most so you can be informed about events as they arise. Pick news sources, privacy settings, and many other things to make your experience more productive and enjoyable.</p>\r\n          <p><a href=\"#!/dashboard\" class=\"link\">View Profile Settings</a></p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/questionHome\" class=\"blockLink\"><img ng-src=\"./assets/images/clipBoard2.svg\" class=\"gettingStartedImg img-fluid\"></a>\r\n      <div class=\"gettingStartedBlock\" id=\"gettingStartedBlock2\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">POLITICAL MATCH QUESTIONS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Answer multiple choice questions to express your views on countless topics.  These answers can be used to find politicians and organizations that match your vision.  They can also be used by those in power as a guide for how best to help the people they represent.  The multiple choice answers allow for quick understanding of thousands of people’s thoughts, and your added comments add depth to those thoughts.</p>\r\n          <p><a href=\"#!/questionHome\" class=\"link\">View Political Match Questions</a></p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/learnHome\" class=\"blockLink\"><img ng-src=\"./assets/images/Learn2.svg\" class=\"gettingStartedImg img-fluid\"></a>\r\n      <div class=\"gettingStartedBlock\" id=\"gettingStartedBlock3\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">LEARN ABOUT THE TOPICS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Get tons of useful information about the topics that interest you by watching videos or reading articles from organizations that devote their entire existence to the topics you are curious about.  See the same issue from many sides.  Also learn about the basics of politics, economics, where to vote, how to register, how to read through political double speak and many other userful things.</p>\r\n          <p><a href=\"#!/learnHome\" class=\"link\">View Learn About the Topics</a></p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/debateHome\" class=\"blockLink\"><img ng-src=\"./assets/images/discuss4.svg\" class=\"gettingStartedImg img-fluid\"></a>\r\n      <div class=\"gettingStartedBlock\" id=\"gettingStartedBlock4\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">DISCUSS THE ISSUES</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Engage in debate and discuss the issues with other voters, politicians, and organizations  in your town, your county, state or accross the United States.  Work towards solutions to the problems we face.</p>\r\n          <p><a href=\"#!/debateHome\" class=\"link\">View Discuss the Issue</a></p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/incumbent_politician/politician\" class=\"blockLink\"><img ng-src=\"./assets/images/politiciansRBB7-01.svg\" class=\"gettingStartedImg img-fluid\"></a>\r\n      <div class=\"gettingStartedBlock\" id=\"gettingStartedBlock5\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">YOUR POLITICIANS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Contact the politicians that represent you to ask for help.  Find out what they stand for, who stands behind them, and who pays for their campaigns.  See their voting record. Compare politicians who are running for office, using your match quizzes to see who would best represent your interests.  Watch debates, read essays, and more.</p>\r\n          <p><a href=\"#!/incumbent_politician/politician\" class=\"link\">View Your Politicians</a></p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/advocateHome\" class=\"blockLink\"><img ng-src=\"./assets/images/Organizations.svg\" class=\"gettingStartedImg img-fluid\"></a>\r\n      <div class=\"gettingStartedBlock\" id=\"gettingStartedBlock6\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">ORGANIZATIONS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">You may feel like one drop in the ocean, but if many drops come together, they can form a tsunami with incredible power.  Use this tool to find organizations that you can team up with to make the change you want to see in the world.</p>\r\n          <p><a href=\"#!/advocateHome\" class=\"link\">View Organizations</a></p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/liveFeed\" class=\"blockLink\"><img ng-src=\"./assets/images/press9.svg\" class=\"gettingStartedImg img-fluid\"></a>\r\n      <div class=\"gettingStartedBlock\" id=\"gettingStartedBlock7\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">NEWS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Find out about upcoming legislation for the subjects you care about, get local and national news feeds from the sources you trust, and see local event calendars from organizations you want to get involved with.</p>\r\n          <p><a href=\"#!/liveFeed\" class=\"link\">View News</a></p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/polProfileSetUp/polProfileSetUp.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">PROFILE SET UP</h2>\r\n  <p class=\"pageSubHeading\">Set up your profile for your office and for your campaign.</p>\r\n  <div class=\"row\">\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/dashboard\" class=\"blockLink\"><img ng-src=\"./assets/images/ProfileSettings3.svg\" class=\"gettingStartedImg img-fluid\"></a>\r\n      <div class=\"gettingStartedBlock\" id=\"gettingStartedBlock1\">\r\n          <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">PROFILE SETTINGS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">VoteWise is designed for Politicians connecting to their constituents day to day and for Candidates who want to get people excited about an upcoming election.  These two rolls have entirely different sets of contact information and team structures.  Please make sure you fill them out for each if they apply to you. </p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/questionHome\" class=\"blockLink\"><img ng-src=\"./assets/images/contact_politician1.svg\" class=\"gettingStartedImg img-fluid\"></a>\r\n      <div class=\"gettingStartedBlock\" id=\"gettingStartedBlock2\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">IN OFFICE CONTACTS AND TEAM</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Click below to enter or correct your information if you are currently in office.</p>\r\n          <p><a href=\"#!/questionHome\" class=\"link\">Show Office Info</a></p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/learnHome\" class=\"blockLink\"><img ng-src=\"./assets/images/contactCampaign.svg\" class=\"gettingStartedImg img-fluid\"></a>\r\n      <div class=\"gettingStartedBlock\" id=\"gettingStartedBlock3\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">CAMPAIGN CONTACT AND TEAM</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Click below to enter or correct your information if you are currently running an election campaign.</p>\r\n          <p><a href=\"#!/learnHome\" class=\"link\">View Campaign Information.</a></p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/debateHome\" class=\"blockLink\"><img ng-src=\"./assets/images/settings.svg\" class=\"gettingStartedImg img-fluid\"></a>\r\n      <div class=\"gettingStartedBlock\" id=\"gettingStartedBlock4\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">SET PREFFERENCE</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Set preferences for notifications, subjects of interest, and who you are following.</p>\r\n          <p><a href=\"#!/debateHome\" class=\"link\">View Discuss the Issue</a></p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <!--<div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/incumbent_politician/politician\" class=\"blockLink\"><img ng-src=\"./assets/images/politiciansRBB7-01.svg\" class=\"gettingStartedImg img-fluid\"></a>\r\n      <div class=\"gettingStartedBlock\" id=\"gettingStartedBlock5\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">YOUR POLITICIANS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Contact the politicians that represent you to ask for help.  Find out what they stand for, who stands behind them, and who pays for their campaigns.  See their voting record. Compare politicians who are running for office, using your match quizzes to see who would best represent your interests.  Watch debates, read essays, and more.</p>\r\n          <p><a href=\"#!/incumbent_politician/politician\" class=\"link\">View Your Politicians</a></p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/advocateHome\" class=\"blockLink\"><img ng-src=\"./assets/images/Organizations.svg\" class=\"gettingStartedImg img-fluid\"></a>\r\n      <div class=\"gettingStartedBlock\" id=\"gettingStartedBlock6\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">ORGANIZATIONS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">You may feel like one drop in the ocean, but if many drops come together, they can form a tsunami with incredible power.  Use this tool to find organizations that you can team up with to make the change you want to see in the world.</p>\r\n          <p><a href=\"#!/advocateHome\" class=\"link\">View Organizations</a></p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/liveFeed\" class=\"blockLink\"><img ng-src=\"./assets/images/press9.svg\" class=\"gettingStartedImg img-fluid\"></a>\r\n      <div class=\"gettingStartedBlock\" id=\"gettingStartedBlock7\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">NEWS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Find out about upcoming legislation for the subjects you care about, get local and national news feeds from the sources you trust, and see local event calendars from organizations you want to get involved with.</p>\r\n          <p><a href=\"#!/liveFeed\" class=\"link\">View News</a></p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/popularQuizMatch/popularQuizMatch.html","<div>\r\n  <!-- <button ng-click=\"$root.printPage()\" class=\"print-hide changeTextColor\">Print this page</button> -->\r\n  <!--  <div>{{questions}}</div>\r\n  <div>{{questions[currentIndex]}}</div> -->\r\n  <div>\r\n    <center>\r\n      <div ng-if=\"showLoader\" style=\"z-index: 2; background:black;\">\r\n        <i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span>\r\n      </div>\r\n\r\n    </center>\r\n    <div ng-show=\"questions[currentIndex] && !showComment && !unComment &&\r\n    !showPoliAnswerDetails && !showUserAnswerDetails && !showCurr\">\r\n      <!-- <type=\"button\" value=\"LEARN MORE\"> -->\r\n      <p></p>\r\n      <center id=\"DisplayQ\">\r\n        <h2>QUESTION</h2>\r\n      </center>\r\n      <p></p>\r\n      <p></p>\r\n      <center>({{currentIndex+1}} of {{questions.length}})</center>\r\n      <p></p>\r\n      <p>STATEMENT: <span class=\"card-text\" ng-bind-html=\"questions[currentIndex].content | newlines\"></span></p>\r\n      Your Answers<span style=\"margin-left: 30px;\">Their Answers</span>\r\n\r\n      <div class=\"clearfix scro\">\r\n        <div class=\"pull-left ans-col\" style=\"border-right: 3px solid #de8998;\">\r\n          <div class=\"clearfix  pad10\">\r\n          </div>\r\n          <p></p>\r\n          <div class=\"pad10\">\r\n            <div class=\"clearfix\"><br>\r\n              <p>COMMENTS</p>\r\n              <div class=\"mb5 clearfix\">\r\n                <div class=\"inl-blk pull-right\">\r\n                  <span class=\"clk ylink\" ng-if=\"!(questions[currentIndex].my_answer.comment | isBlankString)\" ng-click=\"viewAnsComment(\'currentUser\')\">READ</span>\r\n                  <span ng-if=\"questions[currentIndex].my_answer.comment | isBlankString\">None</span>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <p></p>\r\n            <div class=\"clearfix\" style=\"line-height: 9px\">\r\n              <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <span class=\"inl-blk\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n                <span class=\"inl-blk\" ng-if=\"i == 6\">DISAGREE</span>\r\n                <div class=\"cq-box inl-blk pull-right\"\r\n                  ng-class=\"(questions[currentIndex].my_answer.answer == i) ? (\'ag-green\') : \'\'\"></div>\r\n              </div>\r\n            </div>\r\n            <div class=\"clearfix\">\r\n              <div class=\"mb5 clearfix\"><br>\r\n                <div class=\"inl-blk pull-right\">Match to Mean</div>\r\n              </div>\r\n            </div><br>\r\n            <div class=\"clearfix\" style=\"line-height: 9px\">\r\n              <p>IMPORTANCE</p>\r\n              <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n                <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n                <div class=\"cq-box inl-blk pull-right \"\r\n                  ng-class=\"(questions[currentIndex].my_answer.importance == i) ? \'ag-dg\' : \'\'\"></div>\r\n              </div>\r\n            </div>\r\n\r\n          </div>\r\n\r\n        </div>\r\n\r\n        <div class=\"pull-left ans-col\" ng-if=\"showPolitician\">\r\n          <div class=\"clearfix pad10\">\r\n            <div class=\"nslant-txt clk ylink\" ng-if=\"userId\" ng-click=\"showAnswersDetail(\'politician\')\">Politicians\r\n            </div>\r\n          </div>\r\n          <p></p>\r\n          <br>\r\n          <div class=\"pad10\">\r\n            <div class=\"clearfix\">\r\n              <p>&nbsp;</p>\r\n              <div class=\"mb5 clearfix\">\r\n                <span class=\"clk ylink\" ng-if=\"globalFlag[questions[currentIndex]._id]\" ng-click=\"viewAnsComment(\'email\')\">READ</span>\r\n                <span ng-if=\"ans.comment && (ans.comment | isBlankString)\">None</span>\r\n                <span ng-if=\"!globalFlag[questions[currentIndex]._id]\">N/A</span>\r\n              </div>\r\n            </div>\r\n            <p></p>\r\n            <div ng-if=\"userId\" class=\"clearfix\" style=\"height: 120px;\">\r\n              <div ng-repeat=\"i in [1,2,3,4,5,6] track by $index\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <canvas class=\"clk\"\r\n                  ng-click=\"showAnswers(i,\'politician\',questions[currentIndex]._id,ansCount[questions[currentIndex]._id],$index)\"\r\n                  ng-style=\"changeColor(ansCount[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                  width=\"100\" height=\"10\" id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                </canvas>\r\n\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                      <b>N/A</b>\r\n                    </span>\r\n              </div>\r\n            </div>\r\n            <div ng-if=\"!userId\" class=\"clearfix\" style=\"height: 120px;\">\r\n              <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <canvas class=\"clk\" id=\"myCanvas\"\r\n                  ng-style=\"changeColor(ansCount[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                  width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                </canvas>\r\n\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"clearfix\" style=\"height: 32px;\">\r\n              <div class=\"mb5 clearfix\"><br>\r\n                <div class=\"inl-blk pull-left\">{{emailRegistered[questions[currentIndex]._id]}}%</div>\r\n                <div ng-if=\"!emailRegistered[questions[currentIndex]._id]\" class=\"w100 text-center fwb\">N/A</div>\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div><br>\r\n            <div class=\"clearfix\" style=\"height: 111px;\">\r\n              <p>&nbsp;</p>\r\n              <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <canvas id=\"myCanvas\" width=\"100\" height=\"10\"\r\n                  style=\"border:1px solid #141212;\r\n              background: linear-gradient(to right, #e0dbdb {{impCount[questions[currentIndex]._id][i]}}%, #2b4f7f 10%);\">\r\n                </canvas>\r\n\r\n              </div>\r\n              <div ng-if=\"importance\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"pull-left ans-col\" ng-if=\"showVoter && userId\">\r\n          <div class=\"clearfix  pad10\">\r\n            <div class=\"nslant-txt clk ylink\" ng-if=\"userId\" ng-click=\"showAnswersDetail(\'voter\')\">\r\n              Voters</div>\r\n          </div>\r\n          <p></p>\r\n          <br>\r\n          <div class=\"pad10\">\r\n            <div class=\"clearfix\">\r\n              <p>&nbsp;</p>\r\n              <div class=\"mb5 clearfix\">\r\n                <span class=\"clk ylink\" ng-if=\"flagOfVoter[questions[currentIndex]._id]\" ng-click=\"viewAnsComment(\'voter\')\">READ</span>\r\n                <span ng-if=\"ans.comment && (ans.comment | isBlankString)\">None</span>\r\n                <span ng-if=\"!flagOfVoter[questions[currentIndex]._id]\">N/A</span>\r\n              </div>\r\n            </div>\r\n            <p></p>\r\n            <div class=\"clearfix\" style=\"height: 120px;\">\r\n              <div ng-repeat=\"i in [1,2,3,4,5,6] track by $index\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <canvas class=\"clk\"\r\n                  ng-style=\"changeColor(voterAnsCount[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                  ng-click=\"showAnswers(i,\'voter\',questions[currentIndex]._id,voterAnsCount[questions[currentIndex]._id],$index)\"\r\n                  id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                </canvas>\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div>\r\n            <div class=\"clearfix\" style=\"height: 32px;\">\r\n              <div class=\"mb5 clearfix\"><br>\r\n                <div class=\"inl-blk pull-left\">{{voter[questions[currentIndex]._id]}}%</div>\r\n                <div ng-if=\"!voter[questions[currentIndex]._id]\" class=\"w100 text-center fwb\">N/A</div>\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div><br>\r\n            <div class=\"clearfix\" style=\"height: 111px;\">\r\n              <p>&nbsp;</p>\r\n              <div ng-if=\"voterImpCount[questions[currentIndex]._id]\" ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\"\r\n                style=\"line-height: 15px\">\r\n                <canvas id=\"myCanvas\" width=\"100\" height=\"10\"\r\n                  style=\"border:1px solid #141212;\r\n              background: linear-gradient(to right, #e0dbdb {{voterImpCount[questions[currentIndex]._id][i]}}%, #2b4f7f 10%); \">\r\n                </canvas>\r\n              </div>\r\n              <div ng-if=\"importance\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"pull-left ans-col\" ng-if=\"showAdv && userId\">\r\n          <div class=\"clearfix  pad10\">\r\n            <div class=\"nslant-txt clk ylink\" ng-if=\"userId\" ng-click=\"showAnswersDetail(\'advocate\')\" style=\"transform: rotate(-7deg);\r\n            width: 354px; text-transform: capitalize;\">{{orgName}}\r\n            </div>\r\n          </div>\r\n          <p></p>\r\n          <br>\r\n          <div class=\"pad10\">\r\n            <div class=\"clearfix\">\r\n              <p>&nbsp;</p>\r\n              <div class=\"mb5 clearfix\">\r\n                <span class=\"clk ylink\" ng-if=\"advocateFlag[questions[currentIndex]._id]\" ng-click=\"viewAnsComment(\'advocate\')\">READ</span>\r\n                <span ng-if=\"ans.comment && (ans.comment | isBlankString)\">None</span>\r\n                <span ng-if=\"!advocateFlag[questions[currentIndex]._id]\">N/A</span>\r\n              </div>\r\n            </div>\r\n            <p></p>\r\n            <div class=\"clearfix\" style=\"height: 120px;\">\r\n              <div ng-repeat=\"i in [1,2,3,4,5,6] track by $index\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <canvas class=\"clk\"\r\n                  ng-style=\"changeColor(advocateAns[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                  ng-click=\"showAnswers(i,\'advocate\',questions[currentIndex]._id,advocateAns[questions[currentIndex]._id],$index)\"\r\n                  id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                </canvas>\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div>\r\n            <div class=\"clearfix\" style=\"height: 32px;\">\r\n              <div class=\"mb5 clearfix\"><br>\r\n                <div class=\"inl-blk pull-left\">{{advocate[questions[currentIndex]._id]}}%</div>\r\n                <!-- <div ng-if=\"!advocate[questions[currentIndex]._id]\" class=\"w100 text-center fwb\">N/A</div> -->\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div><br>\r\n            <div class=\"clearfix\" style=\"height: 111px;\">\r\n              <p>&nbsp;</p>\r\n              <div ng-if=\"advocateimpObj[questions[currentIndex]._id]\" ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\"\r\n                style=\"line-height: 9px\">\r\n                <canvas id=\"myCanvas\" width=\"100\" height=\"10\"\r\n                  style=\"border:1px solid #141212;\r\n              background: linear-gradient(to right, #e0dbdb {{advocateimpObj[questions[currentIndex]._id][i]}}%, #2b4f7f 10%); \">\r\n                </canvas>\r\n              </div>\r\n              <div ng-if=\"importance\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n\r\n\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n\r\n  <div ng-if=\"showCurr\">\r\n    <div>\r\n      <a href=\"\" class=\"ylink\" style=\"padding-left: 10%\" ng-click=\"back()\">Back</a>\r\n    </div>\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Comments</legend>\r\n      <div class=\"contactBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\" style=\"width: 100%\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <span>Comment: </span><span class=\"newcomName\">{{questions[currentIndex].my_answer.comment}}</span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </fieldset>\r\n  </div>\r\n\r\n  <div class=\"mb5 clearfix print-hide\"\r\n    ng-if=\"!showComment && !unComment && !showPoliAnswerDetails && !showUserAnswerDetails && !showCurr\">\r\n    <!-- <a class=\"clk fwb\" ng-click=\"prevQuestion()\">Prev</a>&nbsp;\r\n                  <a class=\"clk fwb\" ng-click=\"skipQuestion()\">Next</a> -->\r\n    <button class=\"compareBtnS\" ng-click=\"prevQuestion()\"><i class=\"fa fa-angle-left arrowIconBack\"></i>Prev</button>\r\n    <button class=\"compareBtnS\" ng-click=\"skipQuestion()\">Next<i class=\"fa fa-angle-right arrowIconSubmit\"></i></button>\r\n  </div>\r\n  <div ng-show=\"questions.length <= 0 && status.questions == 2\">\r\n    <a href=\"javascript: void(0)\" ng-click=\"skipQuestion()\" class=\"changeTextColor\">Next</a>\r\n    <a href=\"javascript: void(0)\" ng-click=\"prevQuestion()\" class=\"changeTextColor\">Prev</a>\r\n  </div>\r\n\r\n</div>\r\n");
$templateCache.put("app/popups/add_parent_category.html","<div class=\"row\" ng-controller=\"AddNewParentsCtrl\">\r\n    <!-- ******* Add new parent section ******** -->\r\n    <h3>Add new parents </h3>\r\n    <div class=\"clearfix\" ng-repeat=\"pitem in allRootCats\">    \r\n        <div ng-repeat=\"cat in pitem track by $index\" class=\"pull-left\" style=\"padding: 5px;\" ng-init=\"cat[\'viewOrders\'] = 0;\">\r\n            <select class=\"pull-left changeTextColor\" ng-model=\"cat[\'selected\']\" ng-change=\"toogleAddCatSel(cat[\'selected\'], $index, $parent.$index)\">\r\n                <option ng-repeat=\"item in cat.items\" value=\"{{item}}\">\r\n                    {{item.order}}) {{item.title}}\r\n                </option>\r\n            </select>\r\n            >\r\n            <!-- <input class=\"pull-left\" type=\"number\" ng-model=\"pitem[$index][\'viewOrders\']\" ng-show=\"pitem[$index][\'selected\'] && !pitem[$index+1][\'selected\']\" style=\"max-width: 50px;\"> -->\r\n            <input class=\"pull-left changeTextColor\" type=\"number\" ng-model=\"cat[\'viewOrders\']\" ng-show=\"pitem[$index][\'selected\'] && !pitem[$index+1][\'selected\']\" style=\"max-width: 50px;\">\r\n        </div>\r\n        <button ng-if=\"allRootCats.length > 1\" ng-click=\"removeParent($index)\">\r\n            Remove\r\n        </button>\r\n        <hr class=\"w100 pull-left\">\r\n    </div>\r\n    <div ng-show=\"[0,2,3].indexOf(statusaddParents) > -1\" class=\"clearfix w100\">\r\n        <button  ng-click=\"addOneMoreParent2()\" class=\"changeTextColor\">\r\n            Add one more parent\r\n        </button>\r\n    </div>\r\n    <div class=\"forgetPassButtons\">\r\n    <button ng-show=\"[0,2,3].indexOf(statusaddParents) > -1\" ng-click=\"addParentCategory()\" type=\"submit\" class=\"btnShort-style\" style=\"float: right;\">\r\n        Save\r\n    </button>\r\n    </div>\r\n</div>");
$templateCache.put("app/popups/editOrgQuestions.html","<h3>Add Question</h3>\r\n<div class=\"row clearfix\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"control-group\">\r\n      <label class=\"control-label formLabel\" for=\"category-title\">Question</label>\r\n      <div class=\"controls\">\r\n        <textarea class=\"w100\" disabled ng-model=\"question.content\" class=\"form-control input-md text-input\">\r\n        </textarea>\r\n      </div>\r\n    </div>\r\n\r\n    <span ng-if=\"qNames ==\'\'\">Create a new quiz.</span>\r\n    <span ng-if=\"qNames !=\'\'\">Create a new quiz, or add this question to one or many of your older quizzes.</span>\r\n    <div ng-repeat=\"itm in qNames\">\r\n      <input type=\"checkbox\"  ng-click=\"select(itm)\">\r\n      <label for=\"quizName\">{{itm}}</label>\r\n    </div>\r\n    <div class=\"control-group\" id=\"autoFillText\">\r\n      <label class=\"control-label formLabel\" for=\"question.match\">Quiz Name</label>\r\n\r\n      <div class=\"controls\" mass-autocomplete>\r\n        <input type=\"text\" id=\"quiz\" name=\"quiz\" ng-model=\"question.quiz\" ng-disabled=\"disTxt\"  class=\"form-control input-md text-input\" mass-autocomplete-item=\"autoFillOptions\" style=\"width: 50%\">\r\n</div>\r\n        Choose your names carefully. Politicians will see these names when they are deciding to answer your quizzes.\r\n        <!-- {{question.quiz}} -->\r\n      </div>\r\n      <!-- <div class=\"control-group\">\r\n        <label class=\"control-label formLabel\" for=\"quizDate\">Date for quiz</label>\r\n        <input type=\"date\" class=\"form-control\" ng-model=\"question.date\" style=\"width: 50%\">\r\n      </div> -->\r\n      <!--    <div class=\"control-group\">\r\n      <label class=\"control-label formLabel\" for=\"question.match\">Order </label>\r\n      <div class=\"controls\">\r\n        <input class=\"pull-left\" type=\"number\" ng-model=\"question.matchOrder\" style=\"max-width: 50px;\">\r\n      </div>\r\n      </div> -->\r\n    </div>\r\n    <p ng-if=\"statusGetCats == 1\">Loading categories</p>\r\n    <!--    <div class=\"clearfix\" ng-show=\"statusGetCats == 2\">\r\n      <p>Change background(select lowest level of category): </p>\r\n      <div ng-repeat=\"cat in selCatForQues\" class=\"pull-left\" style=\"padding: 5px;\">\r\n        <select class=\"pull-left\" ng-model=\"cat[\'selected\']\" ng-change=\"selQuesCategory(cat[\'selected\'], $index)\">\r\n        <option ng-repeat=\"item in cat.items\" value={{item}}>\r\n          {{item.order}}) {{item.title}}\r\n        </option>\r\n      </select>\r\n        >\r\n        <input class=\"pull-left\" type=\"number\" ng-model=\"cat[\'viewOrders\']\" ng-disabled=\"!cat[\'selected\']\" style=\"max-width: 50px;\">\r\n    </div>\r\n      </div> -->\r\n    <div style=\"clear: both;\"></div>\r\n    <div style=\"width: 55%; margin-top: 10px; float: right; margin-right: 17px;\">\r\n      <button ng-click=\"addQuestion()\" type=\"submit\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n      <div style=\"clear: both;\"></div>\r\n    </div>\r\n  </div>\r\n");
$templateCache.put("app/popups/edit_question.html","<h3>Edit Question</h3>\r\n<div class=\"row clearfix\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"control-group\">\r\n      <label class=\"control-label formLabel\" for=\"category-title\">Question</label>\r\n      <div class=\"controls\">\r\n        <textarea class=\"w100\" ng-model=\"question.content\" class=\"form-control input-md text-input\">\r\n        </textarea>\r\n      </div>\r\n    </div>\r\n    <div class=\"control-group\">\r\n      <label class=\"control-label formLabel\" for=\"question.match\">Add in 5 minute match (NOTE: You MUST add an order or it won\'t let you add the question.  You can change the order later in the Five Minute Quiz tool)</label>\r\n      <div class=\"controls\">\r\n        <select ng-model=\"question.showInMatch\" style=\"text-transform: capitalize;\" ng-options=\"item as item for item in matchType track by item\"></select>\r\n      </div>\r\n    </div>\r\n    <div class=\"control-group\">\r\n      <label class=\"control-label formLabel\" for=\"question.match\">Order for 5 minute match </label>\r\n      <div class=\"controls\">\r\n        <input class=\"pull-left\" type=\"number\" ng-model=\"question.matchOrder\" style=\"max-width: 50px;\">\r\n      </div>\r\n      </div>\r\n    </div>\r\n    <p ng-if=\"statusGetCats == 1\">Loading categories</p>\r\n    <div class=\"clearfix\" ng-show=\"statusGetCats == 2\">\r\n      <p>Change background(select lowest level of category): </p>\r\n      <div ng-repeat=\"cat in selCatForQues\" class=\"pull-left\" style=\"padding: 5px;\">\r\n        <select class=\"pull-left\" ng-model=\"cat[\'selected\']\" ng-change=\"selQuesCategory(cat[\'selected\'], $index)\">\r\n        <option ng-repeat=\"item in cat.items\" value={{item}}>\r\n          {{item.order}}) {{item.title}}\r\n        </option>\r\n      </select>\r\n        >\r\n        <input class=\"pull-left\" type=\"number\" ng-model=\"cat[\'viewOrders\']\" ng-disabled=\"!cat[\'selected\']\" style=\"max-width: 50px;\">\r\n    </div>\r\n      </div>\r\n      <div style=\"clear: both;\"></div>\r\n      <div style=\"width: 55%; margin-top: 10px; float: right; margin-right: 17px;\">\r\n        <button ng-click=\"addQuestion()\" type=\"submit\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n        <div style=\"clear: both;\"></div>\r\n      </div>\r\n    </div>\r\n");
$templateCache.put("app/popups/html_viewer.html","<h3>{{ngDialogData.title}}</h3>\r\n<div ng-bind-html=\"ngDialogData.content | to_trusted\"></div>");
$templateCache.put("app/popups/manageOrgQuestions.html","<!-- Add question -->\r\n<form name=\"signupform\" id=\"signInform\" ng-controller=\"manageOrganizationQuestionsCtrl\">\r\n  <fieldset class=\"scheduler-border\">\r\n    <legend class=\"scheduler-border\">Add Question</legend>\r\n    <div class=\"row\">\r\n\r\n      <div class=\"clearfix\">\r\n        <div class=\"formLabel\">Select topic and subtopics to find questions </div>\r\n        <p class=\"fwb\" ng-if=\"statusGetCats == 1\">Loading categories ...</p>\r\n        <div ng-show=\"statusGetCats == 2\" ng-repeat=\"cat in selCatForQues\" class=\"pull-left\" style=\"padding: 5px;\">\r\n          <select class=\"pull-left changeTextColor\" ng-model=\"cat[\'selected\']\" ng-change=\"selQuesCategory(cat[\'selected\'], $index)\">\r\n                      <option ng-repeat=\"item in cat.items\" value={{item}}>\r\n                          {{item.order}}) {{item.title}}\r\n                      </option>\r\n                  </select>\r\n\r\n          <!--          <input class=\"pull-left changeTextColor\" type=\"number\" ng-model=\"cat[\'viewOrders\']\" ng-disabled=\"!cat[\'selected\']\" style=\"max-width: 50px;\">\r\n              </div>\r\n          <button ng-show=\"statusGetCats == 2 || statusGetCats == 3\" ng-click=\"getParentCategories()\" class=\"changeTextColor\">Reload categories</button>-->\r\n        </div>\r\n        <div class=\"fwb\" ng-if=\"statusSubCat == 1\">Loading sub categories(if any) ...</div>\r\n        <div style=\"clear: both;\"></div>\r\n\r\n							\r\n							        <div>\r\n          <p>\r\n            <h1>\r\n              <center>{{subCategory.title}}</center>\r\n            </h1>\r\n          </p>\r\n          <p></p>\r\n\r\n          <center id=\"DisplayC\" ng-if=\"subCategory\">\r\n            <h2>BACKGROUND</h2>\r\n          </center>\r\n          <p></p>\r\n          <div class=\"row d-flex justify-content-center\">\r\n            <div class=\"col-lg-7 col-sm-12\">\r\n              <p ng-bind-html=\"subCategory.description | newlines\"></p>\r\n            </div>\r\n            <div ng-if=\"statusSubCat == 1\" class=\"fwb\">\r\n              Loading category ...\r\n            </div>\r\n            <div ng-if=\"statusSubCat == 3\" class=\"fwb\">\r\n              Something went wrong while loading category.\r\n            </div>\r\n          </div>\r\n          <div>\r\n            <center ng-if=\"subCategory.fbImage\">\r\n              <img ng-src=\"https://api.votewise.net/resources/{{subCategory.fbImage}}\" class=\"wibble\" />\r\n            </center>\r\n          </div>\r\n        </div>\r\n					\r\n					\r\n        <div class=\"formLabel\">\r\n          <!-- <label>Filter Questions: </label>\r\n          <select ng-model=\"questionVeriFilter\" ng-change=\"filterQuestions(questionVeriFilter)\" class=\"changeTextColor\">\r\n              <option ng-repeat=\"item in [{lbl: \'All\', val: \'all\'}, {lbl: \'Verified\', val: 1}, {lbl: \'Unverified\', val: 0}]\" value=\"{{item.val}}\">{{item.lbl}}</option>\r\n          </select> -->\r\n\r\n          <button ng-if=\"question.content.length > 0\" ng-click=\"getQuestoins()\" class=\"changeTextColor\">Load questions</button>\r\n\r\n          <p class=\"fwb\" ng-if=\"statusGetQuestoins == 1\">Loading questions(if any)...</p>\r\n\r\n          <div ng-if=\"statusGetQuestoins == 2 || statusGetQuestoins == 3\">\r\n            <!--            <button class=\"pull-right changeTextColor\" ng-click=\"filterQuestions(questionVeriFilter)\">Reload Questions</button>-->\r\n          </div>\r\n        </div>\r\n        <table class=\"w100 changeTextColor\" ng-if=\"questions.length > 0\" style=\"margin-top: 10px;\">\r\n          <tr>\r\n            <th>Question Id</th>\r\n            <th>Our Order</th>\r\n            <th>Questions</th>\r\n            <th>Add Questions</th>\r\n          </tr>\r\n          <tr ng-repeat=\"q in questions\">\r\n            <td>{{q._id}}</td>\r\n            <td>{{q.categories.viewOrder}}</td>\r\n            <td>\r\n              {{q.content}}\r\n            </td>\r\n            <td>\r\n\r\n              <a ng-if=\"$root.userRole == \'advocate\'\" href=\"javascript: void(0)\" ng-click=\"editQeustion(q, $index)\">Add</a>\r\n              <span class=\"fwb\" ng-if=\"q.apiApproveStatus == 1\"><br> Requesting ...</span>\r\n            </td>\r\n          </tr>\r\n        </table>\r\n\r\n      </div>\r\n\r\n  </fieldset>\r\n</form>\r\n");
$templateCache.put("app/popups/manage_questions.html","<!-- Add question -->\r\n<form name=\"signupform\" id=\"signInform\" ng-controller=\"QuestionsCtrl\">\r\n  <fieldset class=\"scheduler-border\">\r\n    <legend class=\"scheduler-border\">Add Question</legend>\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel\" for=\"category-title\">Question</label>\r\n          <div class=\"controls\">\r\n            <textarea class=\"w100 changeTextColor\" ng-model=\"question.content\" class=\"form-control input-md text-input\" style=\"min-height: 100px;\"></textarea>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"clearfix\">\r\n        <div class=\"formLabel\">Select lowest level of category: </div>\r\n        <p class=\"fwb\" ng-if=\"statusGetCats == 1\">Loading categories ...</p>\r\n        <div ng-show=\"statusGetCats == 2\" ng-repeat=\"cat in selCatForQues\" class=\"pull-left\" style=\"padding: 5px;\">\r\n          <select class=\"pull-left changeTextColor\" ng-model=\"cat[\'selected\']\" ng-change=\"selQuesCategory(cat[\'selected\'], $index)\">\r\n                        <option ng-repeat=\"item in cat.items\" value={{item}}>\r\n                            {{item.order}}) {{item.title}}\r\n                        </option>\r\n                    </select>\r\n          >\r\n          <input class=\"pull-left changeTextColor\" type=\"number\" ng-model=\"cat[\'viewOrders\']\" ng-disabled=\"!cat[\'selected\']\" style=\"max-width: 50px;\">\r\n                </div>\r\n          <button ng-show=\"statusGetCats == 2 || statusGetCats == 3\" ng-click=\"getParentCategories()\" class=\"changeTextColor\">Reload categories</button>\r\n        </div>\r\n        <div class=\"fwb\" ng-if=\"statusSubCat == 1\">Loading sub categories(if any) ...</div>\r\n        <div style=\"clear: both;\"></div>\r\n        <div class=\"forgetPassButtons\">\r\n          <button ng-click=\"addQuestion()\" type=\"submit\" class=\"btn btn-success\" style=\"float: right;\">Add Question</button>\r\n          <div style=\"clear: both;\"></div>\r\n        </div>\r\n        <div class=\"formLabel\">\r\n          <label>Filter Questions: </label>\r\n          <select ng-model=\"questionVeriFilter\" ng-change=\"filterQuestions(questionVeriFilter)\" class=\"changeTextColor\">\r\n                <option ng-repeat=\"item in [{lbl: \'All\', val: \'all\'}, {lbl: \'Verified\', val: 1}, {lbl: \'Unverified\', val: 0}]\" value=\"{{item.val}}\">{{item.lbl}}</option>\r\n            </select>\r\n\r\n          <button ng-if=\"question.content.length > 0\" ng-click=\"getQuestoins()\" class=\"changeTextColor\">Load questions</button>\r\n\r\n          <p class=\"fwb\" ng-if=\"statusGetQuestoins == 1\">Loading questions(if any)...</p>\r\n\r\n          <div ng-if=\"statusGetQuestoins == 2 || statusGetQuestoins == 3\">\r\n            <button class=\"pull-right changeTextColor\" ng-click=\"filterQuestions(questionVeriFilter)\">Reload Questions</button>\r\n          </div>\r\n        </div>\r\n        <table class=\"w100 changeTextColor\" ng-if=\"questions.length > 0\" style=\"margin-top: 10px;\">\r\n          <tr>\r\n            <th>Q Id</th>\r\n            <th>Order</th>\r\n            <th>Title</th>\r\n            <th>Action</th>\r\n          </tr>\r\n          <tr ng-repeat=\"q in questions\" data-drop=\"true\" data-drag=\"true\" ng-model=\"questions\"\r\n            jqyoui-droppable=\"{index: {{$index}},onDrop:\'drop(q.categories.viewOrder,q._id,$index)\'}\"\r\n            jqyoui-draggable=\"{index: {{$index}}, insertInline: true, direction:\'jqyouiDirection\',onStart:\'start(q.categories.viewOrder,q._id,$index)\'}\"\r\n            data-jqyoui-options=\"{revert: \'invalid\',helper: \'clone\',zIndex: 350}\"\r\n            data-direction=\"{{item.jqyouiDirection}}\">\r\n            <td>{{q._id}}</td>\r\n            <td>{{q.categories.viewOrder}}</td>\r\n            <td>\r\n              {{q.content}}\r\n            </td>\r\n            <td>\r\n              <a href=\"javascript: void(0)\" ng-click=\"removeQeustion(q, $index)\">Remove |</a>\r\n              <a ng-if=\"$root.userRole == \'admin\'\" href=\"javascript: void(0)\" ng-click=\"editQeustion(q, $index)\">Edit |</a>\r\n              <a ng-if=\"q.approved && $root.userRole == \'admin\'\" href=\"javascript: void(0)\" ng-click=\"verifyThisQues(q, $index, false)\">Disapprove |</a>\r\n              <a ng-if=\"!q.approved && $root.userRole == \'admin\'\" href=\"javascript: void(0)\" ng-click=\"verifyThisQues(q, $index, true)\">Approve</a>\r\n              <span class=\"fwb\" ng-if=\"q.apiApproveStatus == 1\"><br> Requesting ...</span>\r\n            </td>\r\n          </tr>\r\n        </table>\r\n      </div>\r\n			\r\n  </fieldset>\r\n</form>\r\n");
$templateCache.put("app/popups/matchQuestion.html","<div ng-controller=\"matchQuestion\">\r\n  <h3>Your match with your politicians</h3>\r\n   <div>\r\n    <div class=\"squareBoxB\">&nbsp;</div>\r\n    <div class=\"squareMenu\">= Weighted Comparison by answers and importance.</div>\r\n    <div style=\"clear:both;\"></div>\r\n  </div>\r\n  <div id=\"viewOne\">\r\n     <ul class=\"catList\">\r\n    <li ng-repeat=\"frd in AllPolitician track by $index\" ng-if=\"FBunWeighted[frd._id] && fbcombinedWeight[frd._id]\">\r\n      <div style=\"background-color:#bbb; padding:10px;\">\r\n        <div style=\"width: 15%; float:left;\">{{frd.name}}</div>\r\n        <div style=\"width: 84%; float:left;\">\r\n            <div class=\"fbweighted\" style=\"width:{{(fbcombinedWeight[frd._id] / fbmultiplier[frd._id])  | number:2}}%\">{{(fbcombinedWeight[frd._id] / fbmultiplier[frd._id]) | number:2}}%</div>\r\n          </div>\r\n        <div style=\"clear:both;\"></div>\r\n      </div>\r\n    </li>\r\n  </ul>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/popups/mellisa_data.html","<div>\r\n  <div class=\"control-group\">\r\n    <label class=\"control-label\" for=\"address\">Address </label>\r\n    <input type=\"text\" ng-model=\"findaddress.address\" />\r\n  </div>\r\n  <div class=\"control-group\">\r\n    <label class=\"control-label\" for=\"city\">City </label>\r\n    <input type=\"text\" ng-model=\"findaddress.city\" />\r\n  </div>\r\n  <div class=\"control-group\">\r\n    <label class=\"control-label\" for=\"state\">State </label>\r\n    <input type=\"text\" ng-model=\"findaddress.state\" />\r\n  </div>\r\n  <div class=\"control-group\">\r\n    <label class=\"control-label\" for=\"zipcode\">Zipcode </label>\r\n    <input type=\"text\" ng-model=\"findaddress.zipcode\" />\r\n  </div>\r\n  <button ng-click=\"getDetails(findaddress);\" type=\"button\" class=\"btnShort-style\">Get Details</button>&nbsp; &nbsp; <i ng-if=\"finddetailsclicked\" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>\r\n  <div style=\"clear: both;\"></div>\r\n  <div ng-if=\"result.city!=\'\'\">\r\n    <h2>Result : </h2>\r\n    <div class=\"control-group\">\r\n      <label class=\"control-label\" style=\"font-weight:bold;\" for=\"email\">CongressionalDistrict : </label>\r\n      {{result.CongressionalDistrict}}\r\n    </div>\r\n    <div class=\"control-group\">\r\n      <label class=\"control-label\" style=\"font-weight:bold;\" for=\"email\">CountyFIPS : </label>\r\n      {{result.CountyFIPS}}\r\n    </div>\r\n    <div class=\"control-group\">\r\n      <label class=\"control-label\" style=\"font-weight:bold;\" for=\"email\">CountyName : </label>\r\n      {{result.CountyName}}\r\n    </div>\r\n    <div class=\"control-group\">\r\n      <label class=\"control-label\" style=\"font-weight:bold;\" for=\"email\">CountySubdivisionCode : </label>\r\n      {{result.CountySubdivisionCode}}\r\n    </div>\r\n    <div class=\"control-group\">\r\n      <label class=\"control-label\" style=\"font-weight:bold;\" for=\"email\">CountySubdivisionName : </label>\r\n      {{result.CountySubdivisionName}}\r\n    </div>\r\n    <div class=\"control-group\" ng-if=\"(result.ElementarySchoolDistrictCode|nospace)\">\r\n      <label class=\"control-label\" style=\"font-weight:bold;\" for=\"email\">ElementarySchoolDistrictCode : </label>\r\n      {{result.ElementarySchoolDistrictCode}}\r\n    </div>\r\n    <div class=\"control-group\" ng-if=\"(result.ElementarySchoolDistrictName|nospace)\">\r\n      <label class=\"control-label\" style=\"font-weight:bold;\" for=\"email\">ElementarySchoolDistrictName : </label>\r\n      {{result.ElementarySchoolDistrictName}}\r\n    </div>\r\n    <div class=\"control-group\" ng-if=\"(result.Latitude|nospace)\">\r\n      <label class=\"control-label\" style=\"font-weight:bold;\" for=\"email\">Latitude : </label>\r\n      {{result.Latitude}}\r\n    </div>\r\n    <div class=\"control-group\" ng-if=\"(result.Longitude|nospace)\">\r\n      <label class=\"control-label\" style=\"font-weight:bold;\" for=\"email\">Longitude : </label>\r\n      {{result.Longitude}}\r\n    </div>\r\n    <div class=\"control-group\" ng-if=\"(result.PlaceName|nospace)\">\r\n      <label class=\"control-label\" style=\"font-weight:bold;\" for=\"email\">PlaceName : </label>\r\n      {{result.PlaceName}}\r\n    </div>\r\n    <div class=\"control-group\" ng-if=\"(result.SecondarySchoolDistrictCode|nospace)\">\r\n      <label class=\"control-label\" style=\"font-weight:bold;\" for=\"email\">SecondarySchoolDistrictCode : </label>\r\n      {{result.SecondarySchoolDistrictCode}}\r\n    </div>\r\n    <div class=\"control-group\" ng-if=\"(result.SecondarySchoolDistrictName|nospace)\">\r\n      <label class=\"control-label\" style=\"font-weight:bold;\" for=\"email\">SecondarySchoolDistrictName : </label>\r\n      {{result.SecondarySchoolDistrictName}}\r\n    </div>\r\n    <div class=\"control-group\" ng-if=\"(result.StateDistrictLower|nospace)\">\r\n      <label class=\"control-label\" style=\"font-weight:bold;\" for=\"email\">StateDistrictLower : </label>\r\n      {{result.StateDistrictLower}}\r\n    </div>\r\n    <div class=\"control-group\" ng-if=\"(result.StateDistrictUpper|nospace)\">\r\n      <label class=\"control-label\" style=\"font-weight:bold;\" for=\"email\">StateDistrictUpper : </label>\r\n      {{result.StateDistrictUpper}}\r\n    </div>\r\n    <div class=\"control-group\" ng-if=\"(result.UnifiedSchoolDistrictCode|nospace)\">\r\n      <label class=\"control-label\" style=\"font-weight:bold;\" for=\"email\">UnifiedSchoolDistrictCode : </label>\r\n      {{result.UnifiedSchoolDistrictCode}}\r\n    </div>\r\n    <div class=\"control-group\" ng-if=\"(result.UnifiedSchoolDistrictName|nospace)\">\r\n      <label class=\"control-label\" style=\"font-weight:bold;\" for=\"email\">UnifiedSchoolDistrictName : </label>\r\n      {{result.UnifiedSchoolDistrictName}}\r\n    </div>\r\n    <div style=\"clear: both;\"></div>\r\n    <div>\r\n      <button ng-click=\"setAddressNew()\" type=\"button\" style=\"width:200px;\">Use this address</button>\r\n    </div>\r\n    <div style=\"clear: both;\"></div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/popups/report_question.html","<p ng-hide=\"addComments\" id=\"ngdialog1-aria-describedby\" style=z-index:-2>\r\nMany of our Statements have a fact followed by an opinion like, “The sky is blue.  I hate the sky.”  If this is your problem with the question, then realize that this is just part of the question process and users are meant to respond to the second half.  If not, please leave a coment so we can fix it.  Thank you.\r\n</p>\r\n<div ng-show=\"addComments\">\r\n	<textarea ng-model=\"ngDialogData.comment\" class=\"vi-textarea ng-pristine ng-valid ng-empty ng-touched\" placeholder=\"ADD COMMENTS\" style=\"margin: 15px 0px 15px 0px;\"></textarea>\r\n</div>\r\n<div class=\"ngdialog-buttons\">\r\n	<!-- <button type=\"button\" class=\"ngdialog-button ngdialog-button-secondary\" ng-click=\"closeThisDialog(0)\">\r\n		OK\r\n	</button> -->\r\n	<button type=\"button\" class=\"ngdialog-button ngdialog-button-secondary\" ng-click=\"closeThisDialog(0)\">\r\n		Cancel\r\n	</button>\r\n\r\n	<button type=\"button\" ng-show=\"addComments\" class=\"ngdialog-button ngdialog-button-secondary\" ng-click=\"postAnswer()\">\r\n		Save\r\n	</button>\r\n\r\n	<button type=\"button\" ng-hide=\"addComments\" class=\"ngdialog-button ngdialog-button-secondary\" ng-click=\"addComments = true;\">\r\n		Leave comments\r\n	</button>\r\n</div>");
$templateCache.put("app/popups/setPreference.html","<style>\r\n/* adapted from http://maxwells.github.io/bootstrap-tags.html */\r\n\r\n.labtag {\r\n  font-size: 14px;\r\n  padding: .3em .4em .4em;\r\n  margin: 0 .1em;\r\n  background-color: #bbb;\r\n  border-radius: 5px;\r\n}\r\n\r\n.labtag a {\r\n  color: #fff;\r\n  cursor: pointer;\r\n  opacity: 0.6;\r\n}\r\n\r\n.labtag a:hover {\r\n  opacity: 1.0\r\n}\r\n\r\n.labtag .remove {\r\n  vertical-align: bottom;\r\n  top: 0;\r\n}\r\n\r\n.labtag a {\r\n  margin: 0 0 0 .3em;\r\n}\r\n\r\n\r\n#ultab {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n#ultab li {\r\n  float: left;\r\n  border: 1px solid #000;\r\n  border-bottom-width: 0;\r\n  margin: 3px 3px 0px 3px;\r\n  padding: 5px 5px 0px 5px;\r\n  background-color: #CCC;\r\n  color: #696969;\r\n}\r\n\r\n#mainView {\r\n  border: 1px solid black;\r\n  clear: both;\r\n  padding: 0 1em;\r\n}\r\n\r\n#tabs .active {\r\n  background-color: #FFF;\r\n  color: #000;\r\n}\r\n\r\n#tabs ul {\r\n  list-style: none;\r\n}\r\n\r\n</style>\r\n<div ng-controller=\"setPreference\">\r\n  <h3>Set/update preferences</h3>\r\n  <div id=\"tabs\">\r\n    <ul id=\"ultab\">\r\n      <li ng-repeat=\"tab in tabs\" ng-class=\"{active:isActiveTab(tab.url)}\" ng-click=\"onClickTab(tab)\">{{tab.title}}</li>\r\n    </ul>\r\n    <div id=\"mainView\">\r\n      <div ng-include=\"currentTab\"></div>\r\n    </div>\r\n  </div>\r\n  <script type=\"text/ng-template\" id=\"one.tpl.html\">\r\n    <div id=\"viewOne\">\r\n      <h1>All Template</h1>\r\n      <table style=\"position:relative;\" ng-if=\"userSelectedCols.length > 0\" >\r\n      <thead>\r\n        <tr>\r\n          <th style=\"width:80%;\">Name</th>\r\n          <th style=\"width:20%;\">Remove</th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        <tr ng-repeat=\"list in userSelectedCols track by $index\">\r\n          <td>\r\n            <strong>{{list.name}}</strong>\r\n            <div ng-if=\"list.cols.length > 0\"><div ng-repeat=\"u in list.cols\" style=\"float:left;\">&nbsp;{{u}}&nbsp;</div></div>\r\n          </td>\r\n          <td>\r\n            <a href=\"javascript: void(0)\" ng-click=\"removeTemplate(list, $index)\" class=\"link\">Remove</a>\r\n          </td>\r\n        </tr>\r\n        </tbody>\r\n      </table>\r\n    </div>\r\n  </script>\r\n  <script type=\"text/ng-template\" id=\"two.tpl.html\">\r\n    <div id=\"viewTwo\">\r\n      <h1>Create new template</h1>\r\n      <small ng-if=\"userSelectedCols.length>=10\" style=\"color:red;\">Only 10 templates are allowed.</small>\r\n      <div class=\"row clearfix\">\r\n        <div class=\"col-md-12\">\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label\">\r\n              <strong>List Name</strong></label>\r\n            <input type=\"text\" ng-model=\"list.name\" id=\"name\">\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label\">\r\n              <strong>Select Columns</strong></label>\r\n            <div class=\"controls\" style=\"height:200px; overflow:auto; border:solid 1px #000; padding:10px;\">\r\n              <div ng-repeat=\"cols in columns track by $index\">\r\n                <div>\r\n                  <label>\r\n                    <input type=\"checkbox\" ng-model=\"chkcol[$index]\" ng-click=\"setColumns(cols)\" ng-checked=\"userSelectedColsNew.indexOf(cols) > -1\">&nbsp;&nbsp;&nbsp;{{cols}}\r\n                  </label>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\" ng-if=\"userSelectedColsNew.length > 0\">\r\n            <label class=\"control-label\">\r\n              <strong>Selected Columns</strong></label>\r\n            <div class=\"controls\">\r\n              <div>\r\n                <span ng-repeat=\"cols in userSelectedColsNew\" class=\"labtag\">\r\n                <span>{{cols}}</span>\r\n                <a href=\"javascript: void(0);\" ng-click=\"removeSelected(cols);\">\r\n            <i class=\"fa fa-times\"></i>\r\n            </a>\r\n                </span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <br/>\r\n          <div class=\"controls\">\r\n            <button ng-click=\"savePreferences(list);\" ng-disabled=\"userSelectedCols.length >= 10\">Save</button>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </script>\r\n  <script type=\"text/ng-template\" id=\"three.tpl.html\">\r\n    <div id=\"viewThree\">\r\n      <h1>Update template</h1>\r\n      <div class=\"row clearfix\">\r\n        <div class=\"col-md-12\">\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label\">\r\n              <strong>List Name</strong></label>\r\n            <select ng-model=\"list.selectedName\" ng-change=\"selectedCols(list.selectedName)\">\r\n            <option ng-repeat=\"list in userSelectedCols\" ng-value=\"{{list}}\">{{list.name}}</option>\r\n            </select>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label\">\r\n              <strong>Rename List</strong></label>\r\n            <input type=\"text\" ng-model=\"list.rename\" id=\"rename\">\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label\">\r\n              <strong>Select Columns</strong></label>\r\n            <div class=\"controls\" style=\"height:200px; overflow:auto; border:solid 1px #000; padding:10px;\">\r\n              <div ng-repeat=\"cols in columns track by $index\">\r\n                <div>\r\n                  <label>\r\n                    <input type=\"checkbox\" ng-model=\"chkcol[$index]\" ng-click=\"setupdatedColumns(cols)\" ng-checked=\"updateSelectedCols.indexOf(cols) > -1\">&nbsp;&nbsp;&nbsp;{{cols}}\r\n                  </label>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\" ng-if=\"updateSelectedCols.length > 0\">\r\n            <label class=\"control-label\">\r\n              <strong>Selected Columns</strong></label>\r\n            <div class=\"controls\">\r\n              <div>\r\n                <span ng-repeat=\"cols in updateSelectedCols\" class=\"labtag\">\r\n                <span>{{cols}}</span>\r\n                <a href=\"javascript: void(0);\" ng-click=\"removeupdatedSelected(cols);\">\r\n            <i class=\"fa fa-times\"></i>\r\n            </a>\r\n                </span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <br/>\r\n          <div class=\"controls\">\r\n            <button ng-click=\"updateRecords(list);\">Update</button>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </script>\r\n</div>\r\n");
$templateCache.put("app/popups/setting_Ctrl.html","<div class=\"container-fluid ng-scope\">\r\n  <!-- <a ng-show=\"[\'advocate\', \'press\', \'voter\', \'forumadmin\', \'voteradmin\', \'admin\'].indexOf($root.userRole) > -1\" ng-click=\"hideAll(); $root.showProfile = !$root.showProfile\"\r\n      ng-class=\"{\'active\': $root.showProfile}\" class=\"link\">My Profile&nbsp;|&nbsp;</a> -->\r\n  <!-- <a ng-show=\"$root.userRole == \'politician\'\" ng-click=\"hideAll(); $root.showPoliProfile = !$root.showPoliProfile\" ng-class=\"{\'active\': showPoliProfile}\"\r\n      class=\"link\">My Profile&nbsp;|&nbsp;</a> -->\r\n  <a ng-click=\"hideAll();  $root.showFollowing = !$root.showFollowing\" ng-class=\"{\'active\': $root.showFollowing}\" href=\"#!/followingUsers\" style=\"color: white\">Following Users&nbsp;|&nbsp;</a>\r\n  <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll(); showAddCategories = !showAddCategories\" href=\"#!/addCategory/Add\" ng-class=\"{\'active\': showAddCategories}\"\r\n       style=\"color: white\">Add category&nbsp;|&nbsp;</a>\r\n  <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll(); showUpdateCategories = !showUpdateCategories\" href=\"#!/addCategory\" ng-class=\"{\'active\': showUpdateCategories}\"\r\n     style=\"color: white\">Update category&nbsp;|&nbsp;</a>\r\n  <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll(); showAddQuestion = !showAddQuestion\" href=\"#!/manageQue\" ng-class=\"{\'active\': showAddQuestion}\"\r\n       style=\"color: white\">Manage Questions&nbsp;|&nbsp;</a>\r\n  <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll(); showFiveMatchQuestion = !showFiveMatchQuestion\" href=\"#!/fiveMatchQuestions\" ng-class=\"{\'active\': showFiveMatchQuestion}\"\r\n      style=\"color: white\">Five match Questions&nbsp;|&nbsp;</a>\r\n  <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll(); $root.showReportQuestion = !$root.showReportQuestion\" href=\"#!/fiveMatchQuestions/Reported\" ng-class=\"{\'active\': $root.showReportQuestion}\"\r\n      style=\"color: white\">Reported Questions&nbsp;|&nbsp;</a>\r\n  <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll(); showUserVerification = !showUserVerification\" href=\"#!/verifyUsers\" ng-class=\"{\'active\': showUserVerification}\"\r\n      style=\"color: white\">Verify Users&nbsp;|&nbsp;</a>\r\n  <!-- <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"showQuesApproval = !showQuesApproval\" ng-class=\"{\'active\': showQuesApproval}\">Approve questions | </a> -->\r\n  <a ng-show=\"$root.userRole == \'admin\' || $root.userRole == \'voteradmin\' || $root.userRole == \'dataentryadmin\'\"  href=\"#!/uploadPolitician\" ng-click=\"hideAll(); $root.showUpload = !$root.showUpload\"\r\n      ng-class=\"{\'active\': $root.showUpload}\"style=\"color: white\">Upload Politician&nbsp;|&nbsp;</a>\r\n  <a ng-show=\"$root.userRole == \'admin\' || $root.userRole == \'voteradmin\' || $root.userRole == \'dataentryadmin\'\" ng-click=\"hideAll(); $root.showVUpload = !$root.showVUpload\"\r\n      ng-class=\"{\'active\': $root.showVUpload}\" href=\"#!/uploadNewPolitician\" style=\"color: white\" >Upload Politician New&nbsp;|&nbsp;</a>\r\n  <a ng-show=\"$root.userRole == \'admin\' || $root.userRole == \'voteradmin\' || $root.userRole == \'dataentryadmin\'\" ng-click=\"hideAll(); $root.showRUpload = !$root.showRUpload\"\r\n      href=\"#!/restorePolitician/remove\" ng-class=\"{\'active\': $root.showRUpload}\" style=\"color: white\">Restore deleted politician&nbsp;|&nbsp;</a>\r\n  <a ng-show=\"$root.userRole == \'admin\' || $root.userRole == \'voteradmin\' || $root.userRole == \'dataentryadmin\'\" href=\"#!/gridState\" ng-click=\"hideAll(); $root.showHUpload = !$root.showHUpload\"\r\n      ng-class=\"{\'active\': $root.showHUpload}\" style=\"color: white\">Grid state saved&nbsp;|&nbsp;</a>\r\n  <a ng-show=\"$root.userRole == \'admin\' || $root.userRole == \'voteradmin\'\" ng-click=\"hideAll(); $root.showAdvocates = !$root.showAdvocates\"\r\n      ng-class=\"{\'active\': $root.showAdvocates}\" href=\"#!/uploadAdvocates\" style=\"color: white\">Upload Advocates&nbsp;|&nbsp;</a>\r\n  <a ng-show=\"$root.userRole == \'admin\' || $root.userRole == \'voteradmin\'\" ng-click=\"hideAll(); $root.showPress = !$root.showPress\"\r\n      ng-class=\"{\'active\': $root.showPress}\" href=\"#!/uploadPress\"  style=\"color: white\">Upload Press&nbsp;|&nbsp;</a>\r\n  <a ng-show=\"$root.userRole == \'admin\' || $root.userRole == \'voteradmin\' || $root.userRole == \'forumadmin\'\" ng-click=\"hideAll(); $root.showTopicSpam = !$root.showTopicSpam\"\r\n      ng-class=\"{\'active\': $root.showTopicSpam}\"  href=\"#!/topicSpams\"  style=\"color: white\">Topic Spams&nbsp;|&nbsp;</a>\r\n  <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll(); $root.showAllUsers = !$root.showAllUsers\" ng-class=\"{\'active\': $root.showAllUsers}\"\r\n       href=\"#!/allUsers\"  style=\"color: white\">All Users&nbsp;|&nbsp;</a>\r\n  <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll(); $root.showAllTopic = !$root.showAllTopic\" ng-class=\"{\'active\': $root.showAllTopic}\"\r\n     href=\"#!/allTopics\"  style=\"color: white\">All Topics&nbsp;|&nbsp;</a>\r\n  <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll(); $root.showAllEssay = !$root.showAllEssay\" ng-class=\"{\'active\': $root.showAllEssay}\"\r\n      href=\"#!/allEssay\"  style=\"color: white\">All Essay&nbsp;|&nbsp;</a>\r\n  <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll(); $root.showAllCongressman = !$root.showAllCongressman\" ng-class=\"{\'active\': $root.showAllCongressman}\"\r\n     href=\"#!/allCongressman\"  style=\"color: white\">All Congressmen&nbsp;|&nbsp;</a>\r\n  <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll(); $root.showAllEmail = !$root.showAllEmail\" ng-class=\"{\'active\': $root.showAllEmail}\"\r\n      href=\"#!/sendEmail\"  style=\"color: white\">Send Email&nbsp;|&nbsp;</a>\r\n  <!-- <a ng-click=\"hideAll(); $root.showAllRecommendation = !$root.showAllRecommendation\" ng-class=\"{\'active\': $root.showAllRecommendation}\" class=\"link\">My Favorites&nbsp;|&nbsp;</a> -->\r\n  <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll(); $root.showOrganized = !$root.showOrganized\" ng-class=\"{\'active\': $root.showOrganized}\"\r\n      href=\"#!/organizedTable\"  style=\"color: white\">Organized Table&nbsp;|&nbsp;</a>\r\n  <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll(); showBackup = !showBackup\" ng-class=\"{\'active\': showBackup}\" href=\"#!/backup\"  style=\"color: white\">Backup&nbsp;|&nbsp;</a>\r\n  <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll(); addCongressBills()\" ng-class=\"{\'active\': $root.showCongressbills}\"\r\n      class=\"link\">Congress Bills&nbsp;|&nbsp;</a>&nbsp; &nbsp;\r\n  <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loader\"></i>\r\n  <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll(); $root.showOpenFec = !$root.showOpenFec\" ng-class=\"{\'active\': $root.showCongressbills}\"\r\n      href=\"#!/openFecCandidates\"  style=\"color: white\">OpenFEC Candidates&nbsp;|&nbsp;</a>&nbsp; &nbsp;\r\n  <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll(); $root.showOpenFecCommittee = !$root.showOpenFecCommittee\" ng-class=\"{\'active\': $root.showCongressbills}\"\r\n      href=\"#!/openFecCommittees\"  style=\"color: white\">OpenFEC Committees&nbsp;|&nbsp;</a>&nbsp; &nbsp;\r\n  <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll(); $root.showPlacesShape = !$root.showPlacesShape\" ng-class=\"{\'active\': $root.showPlacesShape}\"\r\n      href=\"#!/placesShapes\"  style=\"color: white\">Show Places Shapes&nbsp;|&nbsp;</a>&nbsp; &nbsp;\r\n  <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll();\" ng-class=\"{\'active\': $root.showPlacesShape}\"\r\n        href=\"#!/totalUsers\"  style=\"color: white\">Total Users&nbsp;|&nbsp;</a>&nbsp; &nbsp;\r\n  <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll();\" ng-class=\"{\'active\': $root.showPlacesShape}\"\r\n        href=\"#!/openState\"  style=\"color: white\">OpenStateData&nbsp;|&nbsp;</a>&nbsp; &nbsp;\r\n  <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll();\" ng-class=\"{\'active\': $root.showPlacesShape}\"\r\n        href=\"#!/openStateBills\"  style=\"color: white\">OpenState Bills&nbsp;|&nbsp;</a>&nbsp; &nbsp;\r\n  <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll();\"\r\n        href=\"#!/federalLegislation\"  style=\"color: white\">Federal Legislation&nbsp;|&nbsp;</a>&nbsp; &nbsp;\r\n  <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll();\"\r\n        href=\"#!/getRollVotes\"  style=\"color: white\">Get Votes &nbsp;|&nbsp;</a>&nbsp; &nbsp;\r\n  <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll();\"\r\n        href=\"#!/federalTextBills\"  style=\"color: white\">Get Federal Text Bills &nbsp;|&nbsp;</a>&nbsp; &nbsp;\r\n  <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll();\"\r\n        href=\"#!/addPolitician\"  style=\"color: white\">Add Politician&nbsp;|&nbsp;</a>&nbsp; &nbsp;\r\n  <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll();\"\r\n        href=\"#!/trackUserActivities\"  style=\"color: white\">Track User Activities&nbsp;|&nbsp;</a>\r\n  <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll();\"\r\n        href=\"#!/uploadElectionDate\"  style=\"color: white\">Upload Election Dates&nbsp;|&nbsp;</a>\r\n  <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll();\"\r\n        href=\"#!/uploadBallotMeasures\"  style=\"color: white\">Upload Ballot Measures&nbsp;|&nbsp;</a>\r\n  <!-- <a ng-show=\"$root.userRole == \'admin\'\" ng-click=\"hideAll();\"\r\n        href=\"#!/sendMailTo\"  style=\"color: white\">Send Email To&nbsp;|&nbsp;</a> -->\r\n  <!-- <hr ng-show=\"Auth\" size=\"5\" noshade=\"\"> -->\r\n  <!-- <hr ng-show=\"Auth\" size=\"5\" noshade=\"\"> -->\r\n</div>\r\n");
$templateCache.put("app/popups/show_comment_txt.html","<h3>{{ngDialogData.title}}</h3>\r\n<p ng-bind-html=\"ngDialogData.content | urlify\"></p>\r\n");
$templateCache.put("app/popups/signup_section.html","<style type=\"text/css\">\r\n  .highlight {\r\n    background-color: lightyellow;\r\n    font-weight: bold;\r\n  }\r\n</style>\r\n<form name=\"signupform\" id=\"signupform\" ng-controller=\"SignupSectionCtrl\">\r\n  <div ng-if=\"!$root.showFacebookLoging\" class=\"blackText\">\r\n    <div class=\"row\">\r\n\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel whiteText\" for=\"firstname\" style=\"padding-bottom: 10px;\">What type of user are you?<br></label>\r\n        <div class=\"controls\">\r\n          <select ng-model=\"UserType\" style=\"text-transform: capitalize;\" ng-change=\"userTypeChanged(UserType)\" class=\"changeTextColor\">\r\n<option ng-repeat=\" item in MUserType\" value=\"{{item.key}}\">{{item.name}}</option>\r\n</select>\r\n        </div>\r\n      </div>\r\n\r\n\r\n      <!-- FOR ADVOCATES ----->\r\n      <div ng-if=\"UserType == \'advocate\'\">\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Organization Name</label>\r\n          <div mass-autocomplete>\r\n            <input ng-model=\"User.organization_name\" mass-autocomplete-item=\"org_autocomplete_options\" class=\"changeTextColor\">\r\n</div>\r\n\r\n        </div>\r\n        <div ng-if=\"!HideOrgInfo\">\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\">Website for Organization</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"User.organization.web_url\" ng-disabled=\"User.organization._id\" data-errormessage-custom-error=\"Invalid URL.\"\r\ndata-errormessage=\"Website for organization is required.\" class=\"form-control input-md  validate[required, custom[url]] text-input\">\r\n</div>\r\n          </div>\r\n          <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\">Organization Type</label>\r\n            <div class=\"controls\">\r\n              <select ng-model=\"User.orgType\" class=\"form-control\"  style=\"width:60%;\">\r\n<option value=\"\">Select Organization</option>\r\n<option value=\"501c3\">501c3</option>\r\n<option value=\"501c4\">501c4</option>\r\n	<option value=\"501c5\">501c5</option>\r\n      <option value=\"501c6\">501c6</option>\r\n<option value=\"State level non-profit\">State Level Non-Profit</option>			\r\n<option value=\"registered lobbyist \">Registered Lobbyist</option>\r\n</select>\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\">Employer Identification Number<br> or US House Lobbyist Registration # </label>\r\n            <div class=\"controls\">\r\n              <!-- <input type=\"text\" ng-model=\"User.extention_no\" data-errormessage=\"Phone is required.\" class=\"form-control input-md text-input\" class=\"validation[required] text-input\"> -->\r\n              <input type=\"tel\" ng-model=\"User.empIndNo\" class=\"form-control input-md text-input\">\r\n</div>\r\n          </div>\r\n\r\n          <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"firstname\">Account Manager Name <br>(used for contact w VoteWise)</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"User.name\" placeholder=\"\" data-errormessage=\"Name is required.\"\r\n  class=\"form-control input-md  validate[required] text-input\">\r\n  </div>\r\n          </div>\r\n          <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"firstname\">Your Position</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"User.position\" placeholder=\"\" data-errormessage=\"Position is required.\"\r\n  class=\"form-control input-md  validate[required] text-input\">\r\n  </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"email\">Phone number of Organization (xxx)xxx-xxxx</label>\r\n              <div class=\"controls\">\r\n                <input type=\"tel\" ng-model=\"User.organization.phone_no\" ng-disabled=\"User.organization._id\" data-errormessage=\"Phone number of organization is required.\"\r\n  class=\"form-control input-md  validate[required] text-input\">\r\n  </div>\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\">Your extension number (if any)</label>\r\n                <div class=\"controls\">\r\n                  <!-- <input type=\"text\" ng-model=\"User.extention_no\" data-errormessage=\"Phone is required.\" class=\"form-control input-md text-input\" class=\"validation[required] text-input\"> -->\r\n                  <input type=\"tel\" ng-model=\"User.extention_no\" class=\"form-control input-md text-input\">\r\n  </div>\r\n\r\n              </div>\r\n            </div>\r\n\r\n\r\n\r\n            <div ng-if=\"!HideOrgInfo\">\r\n              <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"firstname\">UserName for future Log In</label>\r\n                <div class=\"controls\">\r\n                  <input type=\"text\" ng-model=\"User.UserName\" ng-blur=\"CheckUserName()\" placeholder=\"\" data-errormessage=\"UserName is required.\"\r\n  class=\"form-control input-md  validate[required] text-input\">\r\n  </div>\r\n              </div>\r\n              <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"password\">Create Password</label>\r\n                <div class=\"controls\">\r\n                  <input type=\"password\" id=\"password\" ng-model=\"User.Password\" placeholder=\"\" data-errormessage=\"Password is required.\" class=\"form-control input-md  validate[required] text-input\"\r\n  />\r\n  </div>\r\n              </div>\r\n              <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"password\">Confirm Password</label>\r\n                <div class=\"controls\">\r\n                  <input type=\"password\" id=\"confirm_password\" ng-model=\"ConfirmPassword\" data-errormessage=\"Password and Confirm password do not match.\"\r\n  placeholder=\"\" class=\"form-control input-md  validate[required,equals[password]] text-input \" />\r\n                  <small id=\"message\"></small>\r\n                </div>\r\n              </div>\r\n              <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\">Account Email</label>\r\n                <div class=\"controls\">\r\n                  <input type=\"email\" ng-model=\"User.Email\" data-errormessage=\"Email is required.\" class=\"form-control input-md  validate[required] text-input\">\r\n  </div>\r\n              </div>\r\n            </div>\r\n\r\n          </div>\r\n        </div>\r\n        <div ng-if=\"HideRegisterButton\">\r\n          <div class=\"control-group whiteText\">\r\n											<br><br>\r\n            <div>It looks like you are already in our system. If you don\'t remember signing up,\r\n              we may have sent you a\r\n              temporary username in the past.\r\n              <br><br>\r\n              The email for the account is <b>{{User.UserName}}</b></div>\r\n											<br>\r\n											<div> If this is not your email, please contact us at SpencerSnygg@votewise.net or\r\n              Call 70-VoteWise\r\n              (708)683-9473</div>\r\n            <div class=\"btn-style\">\r\n              <button class=\"btnShort-style whiteText\" ng-if=\"!forFacebook\" ng-click=\"resetPassword()\" type=\"button\" class=\"btn btn-success\"\r\n      style=\"float: right; width:258px; margin-right: 25%\">Please email me my password</button>\r\n            </div>\r\n            <br>\r\n            <div class=\"btn-style\">\r\n              <button class=\"btnShort-style\" ng-if=\"!forFacebook\" ng-click=\"goToSignIn()\" type=\"button\" class=\"btn btn-success\" style=\"float: right; width:258px; margin-right: 25%\">I remember.<br>Go to Sign in</button>\r\n            </div>\r\n\r\n            \r\n\r\n          </div>\r\n          <!-- <p>Login</p> -->\r\n          <div class=\"control-group\" ng-if=\"showMultiDrop\">\r\n            <label class=\"control-label formLabel removeTopMargin whiteText\"  for=\"UserName\">Which User</label>\r\n            <div class=\"controls\">\r\n              <select style=\"width: 80%;\"  ng-model=\"User.multiName\"  class=\"blackText\" ng-options=\"x as x.name for x in multiArr\">\r\n  </select>\r\n            </div>\r\n          </div>\r\n          <div ng-if=\"!HideOrgInfo\">\r\n            <div ng-if=\"!forFacebook\" class=\"control-group\" style=\"width:88%\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"firstname\">UserName/Email</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"User.UserName\" placeholder=\"\" data-errormessage=\"UserName is required.\" class=\"form-control input-md  validate[required] text-input\">\r\n  </div>\r\n            </div>\r\n            <div ng-if=\"!forFacebook\" class=\"control-group\" style=\"width:88%\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"password\">Password</label>\r\n              <div class=\"controls\">\r\n                <input type=\"password\" id=\"password\" ng-model=\"User.Password\" placeholder=\"\" data-errormessage=\"Password is required.\" class=\"form-control input-md  validate[required] text-input\"\r\n  />\r\n  </div>\r\n            </div>\r\n            <div style=\"clear: both;\"></div>\r\n            <div class=\"btn-style\">\r\n              <button class=\"btnShort-style\" ng-if=\"!forFacebook\" ng-click=\"OrgLogin()\" type=\"button\" class=\"btn btn-success\" style=\"float: right; width:258px; margin-right: 25%\">Update details & Login</button>\r\n            </div>\r\n            <div style=\"clear: both;\"></div>\r\n            <p style=\"padding-top:5%;padding-left:3%; color: rgb(241, 241, 241)\">\r\n              Forgot password?</p>\r\n          </div>\r\n\r\n\r\n\r\n        </div>\r\n      </div>\r\n\r\n\r\n      <!--   For POLITICIANS -->\r\n      <div ng-if=\"UserType == \'politician\'\">\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Are you currently in Office?</label>\r\n          <div class=\"controls whiteText\">\r\n            <label>\r\n<input type=\"radio\" ng-model=\"User.isInCurrentOffice\" value=\"1\"> Yes\r\n</label>\r\n            <label>\r\n<input type=\"radio\" ng-model=\"User.isInCurrentOffice\" value=\"0\"> No\r\n</label>\r\n          </div>\r\n        </div>\r\n        <div ng-if=\"User.isInCurrentOffice == 1\">\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\">What level of government?</label>\r\n            <select ng-model=\"User.cur_level\" style=\"text-transform: capitalize;display: block;\" ng-options=\"item as item for item in levelOfGovt\"\r\nng-change=\"govLevelChanged(\'incumbent\')\" class=\"changeTextColor\">\r\n</select>\r\n          </div>\r\n          <div class=\"control-group\" ng-if=\"flagShowStateDropdown\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\">Select State: (if applicable)</label>\r\n            <select ng-model=\"User.cur_state\" style=\"text-transform: capitalize;max-width: 85%\" ng-options=\"item as item.state for item in states\"\r\nng-change=\"onOfficeChange(\'incumbent\')\" class=\"changeTextColor\">\r\n</select>&nbsp; &nbsp;\r\n            <i ng-if=\"showLoader\" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>\r\n          </div>\r\n          <div style=\"width:40%\" class=\"control-group\" ng-if=\"countyone\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\">County </label>\r\n            <div class=\"controls\">\r\n              <select ng-model=\"address.county\" style=\"text-transform: capitalize;display:inline\" ng-options=\"item as item.countyName for item in counties | orderBy : \'county\'\" ng-change=\"getSubCounties()\" class=\"changeTextColor\"></select>\r\n              <i ng-if=\"showLoaderOne\" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>\r\n            </div>\r\n          </div>\r\n          <div style=\"width:70%\" class=\"control-group\" ng-if=\"cityone\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\">City </label>\r\n            <div class=\"controls\">\r\n              <select ng-model=\"address.place\" style=\"text-transform: capitalize;\" ng-options=\"item as item.city for item in places | orderBy : \'place\' \" class=\"changeTextColor\"></select>\r\n              <!-- <i ng-if=\"LoaderTwo \" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i> -->\r\n            </div>\r\n          </div>\r\n          <div id=\"curCandidate\" class=\"control-group\" ng-if=\"flagShowCandidateDropdown\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\">What is your name as it appears on the ballot?</label>\r\n            <div mass-autocomplete>\r\n              <input ng-model=\"User.cur_Candidates\" ng-blur=\"checkExists();\" mass-autocomplete-item=\"autocomplete_options\" class=\"changeTextColor\">\r\n</div>\r\n          </div>\r\n          <div class=\"control-group\" ng-if=\"showcur_office_name\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\">Office Name</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"User.cur_office_name\" class=\"form-control  input-md text-input\" style=\"width: 88%\">\r\n</div>\r\n          </div>\r\n          <div class=\"control-group\" ng-if=\"showcur_office_name\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\">Office Phone(optional)</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"User.cur_office_phone\" class=\"form-control input-md text-input\" style=\"width: 88%\">\r\n</div>\r\n          </div>\r\n          <div class=\"control-group\" ng-if=\"showcur_office_name\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\">Office Email(optional)</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"User.cur_office_email\" class=\"form-control  input-md text-input\" style=\"width: 88%\">\r\n</div>\r\n          </div>\r\n          <div class=\"control-group\" ng-if=\"showcur_office_name\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\">Office Website (optional)</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"User.cur_office_website\" class=\"form-control validate[custom[url]] input-md text-input\" style=\"width: 88%\">\r\n</div>\r\n          </div>\r\n          <div class=\"control-group\" ng-if=\"showcur_office_name\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\">Office Facebook Url (optional)</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"User.facebook_url\" ng-disabled=\"User.organization._id\" class=\"form-control validate[custom[url]] input-md text-input\"\r\n      style=\"width: 88%\">\r\n      </div>\r\n          </div>\r\n          <!-- <div class=\"control-group\" ng-if=\"sendPostCard\">\r\n<p>We have you in our system, but in order to confirm you are who you say you are, we need to contact you either through an official government website or at the address you used for registering your campaign with your board of elections.</p>\r\n<button class=\"btnShort-style\" ng-click=\"generatePostcard()\" type=\"button\" class=\"btn btn-success\" ng-disabled=\"User.postCard && User.postCard !=\'\'\" style=\"width:200px; margin:0; margin-top:10px;\">Send me a Postcard</button>\r\n<div ng-if=\"PostcardSend\">\r\n<small style=\"color:#ff0000;\">Thank you for opting for postcard. We will send you a postcard with a code which will be required for verification.</small>\r\n</div>\r\n<input type=\"hidden\" ng-model=\"User.postCard\">\r\n<p>\r\n<center>---OR---</center>\r\n</p>\r\n<div class=\"control-group\">\r\n<label class=\"control-label\">Official Government website that we can contact you at.</label>\r\n<div class=\"controls\">\r\n<input type=\"text\" ng-model=\"User.govtOfficialWebsite\" class=\"form-control validate[custom[url]] input-md text-input\">\r\n</div>\r\n</div>\r\n<p>\r\n<center>---OR---</center>\r\n</p>\r\n<div class=\"control-group\">\r\n<label class=\"control-label\">I have received my code and am ready to enter it.</label>\r\n<div class=\"controls\">\r\n<input type=\"text\" ng-model=\"User.confirmPostalCode\" class=\"form-control input-md text-input\">\r\n</div>\r\n</div>\r\n<div class=\"control-group\">\r\n<div class=\"controls\">\r\n<button class=\"btnShort-style\" ng-click=\"submitPostcard(User)\" type=\"button\" class=\"btn btn-success\" style=\"width:200px; margin:0; margin-top:10px;\">Submit</button>\r\n</div>\r\n</div>\r\n</div> -->\r\n          <div class=\"control-group whiteText\" ng-if=\"sendPostCard\">\r\n            <p>We have you in our system, but in order to confirm your identity, you\r\n              need\r\n              to call\r\n              <br/>\r\n              <b>72-VoteWise</b>.</p>\r\n          </div>\r\n        </div>\r\n        <br>\r\n        <div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\">Are you running for office this coming election?</label>\r\n            <div class=\"controls whiteText\">\r\n              <label>\r\n<input type=\"radio\" ng-model=\"User.isRunningForEle\" ng-click=\"User.RunningForOtherOffice = 0;  \" value=\"1\"> Yes\r\n</label>\r\n              <label>\r\n<input type=\"radio\" ng-model=\"User.isRunningForEle\" ng-click=\"User.RunningForOtherOffice = 0;  \" value=\"0\"> No\r\n</label>\r\n            </div>\r\n          </div>\r\n          <div ng-if=\"User.isRunningForEle == 1 && User.isInCurrentOffice == 1\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\">Are you running for the same office?</label>\r\n            <div class=\"controls whiteText\">\r\n              <label>\r\n<input type=\"radio\" ng-model=\"User.RunningForOtherOffice\" ng-checked=\"User.RunningForOtherOffice == 1\" value=\"1\"> Yes\r\n</label>\r\n              <label>\r\n<input type=\"radio\" ng-model=\"User.RunningForOtherOffice\" ng-checked=\"User.RunningForOtherOffice == 0\" value=\"0\"> No\r\n</label>\r\n            </div>\r\n          </div>\r\n          <div\r\n            ng-if=\"User.isInCurrentOffice == 1? User.isRunningForEle==1? User.RunningForOtherOffice == 0: false : User.isRunningForEle==1\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"email\">What level of government?</label>\r\n              <select ng-model=\"User.level\" style=\"text-transform: capitalize; display: block;\" ng-change=\"govLevelChanged(\'running\')\"\r\nng-options=\"item as item for item in levelOfGovt\" class=\"changeTextColor\">\r\n</select>\r\n            </div>\r\n            <div class=\"control-group\" ng-if=\"running_flagShowStateDropdown\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"email\"> Select State: (if applicable)</label>\r\n              <select ng-model=\"User.state\" style=\"text-transform: capitalize;\" ng-options=\"item as item.state for item in states\" ng-change=\"onOfficeChange(\'running\')\"\r\nclass=\"changeTextColor\">\r\n</select>&nbsp; &nbsp;\r\n              <i ng-if=\"showLoader\" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>\r\n            </div>\r\n            <div style=\"width:40%\" class=\"control-group\" ng-if=\" running_flagShowStateDropdown && running_countyone\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"email\">County </label>\r\n              <div class=\"controls\">\r\n                <select ng-model=\"runAddress.county\" style=\"text-transform: capitalize;display:inline\" ng-options=\"item as item.countyName for item in runCounties | orderBy : \'county\'\" ng-change=\"getRunningSubCounties()\" class=\"changeTextColor\"></select>\r\n                <i ng-if=\"running_showLoaderOne\" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>\r\n              </div>\r\n            </div>\r\n            <div style=\"width:40%\" class=\"control-group\" ng-if=\"running_flagShowStateDropdown && running_cityone\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"email\">City </label>\r\n              <div class=\"controls\">\r\n                <select ng-model=\"runAddress.place\" style=\"text-transform: capitalize;\" ng-options=\"item as item.city for item in runPlaces | orderBy : \'place\'\" class=\"changeTextColor\"></select>\r\n              </div>\r\n            </div>\r\n            <div id=\"curCandidate\" class=\"control-group\" ng-if=\"running_flagShowCandidateDropdown\">\r\n              <label class=\"control-label formLabel formLabel whiteText\" for=\"email\">What is your name as it appears on the ballot?</label>\r\n              <div mass-autocomplete>\r\n                <input ng-model=\"User.new_Candidates\" ng-blur=\"checkExistsNew()\" mass-autocomplete-item=\"autocomplete_new_options\">\r\n</div>\r\n            </div>\r\n            <div class=\"control-group\" ng-if=\"shownew_office_name\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"email\">Office Name</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"User.office_name\" class=\"form-control input-md text-input\" style=\"width: 88%\">\r\n</div>\r\n            </div>\r\n            <div style=\"width: 60%\">\r\n              <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\">Election Date</label>\r\n                <div class=\"controls\">\r\n                  <input type=\"date\"  ng-model=\"User.runElectionDate\" class=\"form-control\">\r\n                                              </div>\r\n              </div>\r\n            </div>\r\n            <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"email\">Candidate Status</label>\r\n              <div class=\"controls\">\r\n                <select ng-model=\"User.runStatus\" class=\"form-control\"  style=\"width:36%;\">\r\n                                              <option value=\"\">Select Status</option>\r\n                                              <option value=\"Announced\">Announced</option>\r\n                                              <option value=\"Write in\">Write in</option>\r\n                                              <option value=\"Running\">Running</option>\r\n                                              <option value=\"Campaign Suspended\">Campaign Suspended</option>\r\n                                              </select>\r\n              </div>\r\n            </div>\r\n            <!-- <div class=\"control-group\" ng-if=\"shownew_office_name\">\r\n<label class=\"control-label formLabel whiteText\" for=\"email\">Office Location</label>\r\n<input type=\"text\" ng-model=\"User.office_location\" class=\"form-control validate[required] input-md text-input\">\r\n</div>  -->\r\n            <!-- <div class=\"control-group\" ng-if=\"sendPostCardNew\">\r\n<p>We have you in our system, but in order to confirm you are who you say you are, we need to contact you either through an official government website or at the address you used for registering your campaign with your board of elections.</p>\r\n<button class=\"btnShort-style\" ng-click=\"generatePostcard()\" type=\"button\" class=\"btn btn-success\" ng-disabled=\"User.postCard && User.postCard !=\'\'\" style=\"width:200px; margin:0; margin-top:10px;\">Send me a Postcard</button>\r\n<div ng-if=\"PostcardSend\">\r\n<small style=\"color:#ff0000;\">Thank you for opting for postcard. We will send you a postcard with a code which will be required for verification.</small>\r\n</div>\r\n<input type=\"hidden\" ng-model=\"User.postCard\">\r\n<p>\r\n<center>---OR---</center>\r\n</p>\r\n<div class=\"control-group\">\r\n<label class=\"control-label formLabel whiteText\">Official Government website that we can contact you at.</label>\r\n<div class=\"controls\">\r\n<input type=\"text\" ng-model=\"User.govtOfficialWebsite\" class=\"form-control validate[custom[url]] input-md text-input\">\r\n</div>\r\n</div>\r\n<p>\r\n<center>---OR---</center>\r\n</p>\r\n<div class=\"control-group\">\r\n<label class=\"control-label formLabel whiteText\">I have received my code and am ready to enter it.</label>\r\n<div class=\"controls\">\r\n<input type=\"text\" ng-model=\"User.confirmPostalCode\" class=\"form-control input-md text-input\">\r\n</div>\r\n</div>\r\n<div class=\"control-group\">\r\n<div class=\"controls\">\r\n<button class=\"btnShort-style\" ng-click=\"submitPostcard(User)\" type=\"button\" class=\"btn btn-success\" style=\"width:200px; margin:0; margin-top:10px;\">Submit</button>\r\n</div>\r\n</div>\r\n</div> -->\r\n            <div class=\"control-group whiteText\" ng-if=\"sendPostCardNew\">\r\n              <p>We have you in our system, but in order to confirm your\r\n                identity,\r\n                you\r\n                need to call\r\n                <br/>\r\n                <b>72-VoteWise</b>.</p>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div ng-if=\"User.RunningForOtherOffice == 1\" style=\"width: 60%\">\r\n          <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\">Election Date</label>\r\n            <div class=\"controls\">\r\n              <input type=\"date\" ng-model=\"User.runElectionDate\" class=\"form-control\">\r\n</div>\r\n          </div>\r\n        </div>\r\n        <div ng-if=\"User.RunningForOtherOffice == 1\">\r\n          <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\">Candidate Status</label>\r\n            <div class=\"controls\">\r\n              <select ng-model=\"User.runStatus\" class=\"form-control\"  style=\"width:36%;\">\r\n<option value=\"\">Select Status</option>\r\n<option value=\"Announced\">Announced</option>\r\n<option value=\"Write in\">Write in</option>\r\n<option value=\"Running\">Running</option>\r\n<!-- <option value=\"Active\">Active</option> -->\r\n<option value=\"Campaign Suspended\">Campaign Suspended</option>\r\n</select>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <br>\r\n        <div ng-if=\"shownew_office_name\">\r\n          <!--                                             <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                                                <label class=\"control-label formLabel whiteText\" for=\"email\">Campaign Email</label>\r\n                                                <div class=\"controls\">\r\n                                                  <input type=\"email\" ng-model=\"User.campaignEmail\"  class=\"form-control input-md   text-input\"\r\nng-readonly=\"checkReadOnly\" style=\"width: 88%\">\r\n</div>\r\n                                                </div>\r\n                                                <div class=\"control-group\">\r\n                                                  <label class=\"control-label formLabel whiteText\" for=\"email\">Campaign Phone number (xxx)xxx-xxxx</label>\r\n                                                  <div class=\"controls\">\r\n                                                    <input type=\"tel\" ng-model=\"User.campPhone_no\" data-errormessage=\"Phone number is required.\" data-errormessage-custom-error=\"Invalid phone number.\"\r\nclass=\"form-control input-md text-input\" style=\"width: 88%\">\r\n</div>\r\n                                                  </div>-->\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\">Campaign Website (optional)</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"User.campaignWebSite\" ng-disabled=\"User.organization._id\" class=\"form-control validate[custom[url]] input-md text-input\"\r\nstyle=\"width: 88%\">\r\n</div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\">Campaign Facebook Url (optional)</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"User.campaignFburl\" ng-disabled=\"User.organization._id\" class=\"form-control validate[custom[url]] input-md text-input\"\r\n              style=\"width: 88%\">\r\n              </div>\r\n          </div>\r\n          <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\"> Account Email</label>\r\n            <div class=\"controls\">\r\n              <input type=\"email\" ng-model=\"User.Email\" data-errormessage=\"Email is required.\" class=\"form-control input-md  validate[required] text-input\"\r\nng-readonly=\"checkReadOnly\" style=\"width: 88%\">\r\n</div>\r\n          </div>\r\n\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\"> Account Phone number (xxx)xxx-xxxx</label>\r\n            <div class=\"controls\">\r\n              <input type=\"tel\" ng-model=\"User.phone_no\" data-errormessage=\"Phone number is required.\" data-errormessage-custom-error=\"Invalid phone number.\"\r\nclass=\"form-control input-md  validate[required] text-input\" style=\"width: 88%\">\r\n</div>\r\n          </div>\r\n          <!--                                                          <div class=\"control-group\">\r\n                                                            <label class=\"control-label formLabel whiteText\" for=\"email\">Website</label>\r\n                                                            <div class=\"controls\">\r\n                                                              <input type=\"text\" ng-model=\"User.web_url\" ng-disabled=\"User.organization._id\" class=\"form-control validate[custom[url]] input-md text-input\"\r\nstyle=\"width: 88%\">\r\n</div>\r\n                                                            </div> -->\r\n        </div>\r\n        <div ng-if=\"!HideRegisterButton && !HideNewRegisterButton\">\r\n          <div ng-if=\"!shownew_office_name\">\r\n            <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"email\">Account Email</label>\r\n              <div class=\"controls\">\r\n                <input type=\"email\" ng-model=\"User.Email\" data-errormessage=\"Email is required.\" class=\"form-control input-md  validate[required] text-input\"\r\nng-readonly=\"checkReadOnly\" style=\"width: 88%\">\r\n</div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"email\"> Account Phone number (xxx)xxx-xxxx</label>\r\n              <div class=\"controls\">\r\n                <input type=\"tel\" ng-model=\"User.phone_no\" data-errormessage=\"Phone number is required.\" data-errormessage-custom-error=\"Invalid phone number.\"\r\nclass=\"form-control input-md  validate[required] text-input\" style=\"width: 88%\">\r\n</div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"email\">Campaign Website (optional)</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"User.web_url\" ng-disabled=\"User.organization._id\" class=\"form-control validate[custom[url]] input-md text-input\"\r\nstyle=\"width: 88%\">\r\n</div>\r\n            </div>\r\n          </div>\r\n          <!-- <div class=\"control-group\">\r\n                                                                    <label class=\"control-label formLabel whiteText\" for=\"email\">Facebook Url (optional)</label>\r\n                                                                    <div class=\"controls\">\r\n                                                                      <input type=\"text\" ng-model=\"User.facebook_url\" ng-disabled=\"User.organization._id\" class=\"form-control validate[custom[url]] input-md text-input\"\r\nstyle=\"width: 88%\">\r\n</div>\r\n                                                                    </div> -->\r\n          <!--  <div class=\"control-group\">\r\n<label class=\"control-label formLabel whiteText\" for=\"email\">Mailing address</label>\r\n<div class=\"controls\">\r\n<input type=\"text\" ng-model=\"User.mailing_address\" data-errormessage=\"Mailing address is required.\" class=\"form-control input-md  validate[required] text-input\"\r\nstyle=\"width: 88%\">\r\n</div>\r\n</div> -->\r\n          <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"firstname\">Account Manager\'s Name</label>\r\n            <div class=\"controls\">\r\n              <input ng-if=\"UserType == \'voter\'\" type=\"text\" ng-model=\"User.name\" placeholder=\"\" class=\"form-control input-md text-input\"\r\nstyle=\"width: 88%\">\r\n              <input ng-if=\"UserType != \'voter\'\" type=\"text\" ng-model=\"User.name\" placeholder=\"\" data-errormessage=\"Account Manager\'s Name is required.\"\r\nclass=\"form-control input-md  validate[required] text-input\" style=\"width: 88%\">\r\n</div>\r\n          </div>\r\n          <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"firstname\">UserName for future Log In</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"User.UserName\" ng-blur=\"CheckUserName()\" placeholder=\"\" data-errormessage=\"UserName is required.\"\r\nclass=\"form-control input-md  validate[required] text-input\" style=\"width: 88%\">\r\n</div>\r\n          </div>\r\n          <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"password\"> Create Password</label>\r\n            <div class=\"controls\">\r\n              <input type=\"password\" id=\"password\" ng-model=\"User.Password\" placeholder=\"\" data-errormessage=\"Password is required.\" class=\"form-control input-md  validate[required] text-input\"\r\nstyle=\"width: 88%\" />\r\n</div>\r\n          </div>\r\n          <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"password\">Confirm Password</label>\r\n            <div class=\"controls\">\r\n              <input type=\"password\" id=\"confirm_password\" ng-model=\"ConfirmPassword\" data-errormessage=\"Password and Confirm password do not match.\"\r\nplaceholder=\"\" class=\"form-control input-md  validate[required,equals[password]] text-input \" style=\"width: 88%\"\r\n/>\r\n              <small id=\"message\"></small>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div ng-if=\"HideRegisterButton || HideNewRegisterButton\">\r\n          <div class=\"control-group whiteText\">\r\n            <p>Congratulations. We already have you in\r\n              our system and sent you a password awhile\r\n              ago to\r\n              {{shortEmail}}. If you lost the password\r\n              and want to reset it, click on the link\r\n              below. If you have other issues call\r\n              70-VoteWise\r\n            </p>\r\n          </div>\r\n          <!-- <p>Login</p> -->\r\n          <div class=\"control-group\" ng-if=\"showMultiDrop\">\r\n            <label class=\"control-label formLabel removeTopMargin whiteText\"  for=\"UserName\">Which User</label>\r\n            <div class=\"controls\">\r\n              <select style=\"width: 80%;\"  ng-model=\"User.multiName\"  class=\"blackText\" ng-options=\"x as x.name for x in multiArr\">\r\n</select>\r\n            </div>\r\n          </div>\r\n          <div ng-if=\"!forFacebook\" class=\"control-group\" style=\"width:88%\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"firstname\">UserName/Email</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"User.UserName\" placeholder=\"\" data-errormessage=\"UserName is required.\" class=\"form-control input-md  validate[required] text-input\">\r\n</div>\r\n          </div>\r\n          <div ng-if=\"!forFacebook\" class=\"control-group\" style=\"width:88%\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"password\">Password</label>\r\n            <div class=\"controls\">\r\n              <input type=\"password\" id=\"password\" ng-model=\"User.Password\" placeholder=\"\" data-errormessage=\"Password is required.\" class=\"form-control input-md  validate[required] text-input\"\r\n/>\r\n</div>\r\n          </div>\r\n          <div style=\"clear: both;\"></div>\r\n          <div class=\"btn-style\">\r\n            <button class=\"btnShort-style\" ng-if=\"!forFacebook\" ng-click=\"UserLogin()\" type=\"button\" class=\"btn btn-success\" style=\"float: right; width:258px; margin-right: 25%\">Update details & Login</button>\r\n          </div>\r\n          <div style=\"clear: both;\"></div>\r\n          <p style=\"padding-top:5%;padding-left:3%; color: rgb(241, 241, 241)\">\r\n            Forgot password?</p>\r\n          <div class=\"btn-style\">\r\n            <button class=\"btnShort-style whiteText\" ng-if=\"!forFacebook\" ng-click=\"resetPassword()\" type=\"button\" class=\"btn btn-success\"\r\nstyle=\"float: right; width:258px; margin-right: 25%\">Please email me my password</button>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n\r\n      <!-- FOR PRESS -->\r\n      <div ng-if=\"UserType == \'press\'\">\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Name of Press outlet</label>\r\n          <div mass-autocomplete>\r\n            <input ng-model=\"User.outlet_name\" mass-autocomplete-item=\"org_autocomplete_options\">\r\n</div>\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Website for press outlet</label>\r\n          <div class=\"controls\">\r\n            <input type=\"text\" ng-model=\"User.outlet_web\" ng-disabled=\"User.organization._id\" data-errormessage-custom-error=\"Invalid URL.\"\r\ndata-errormessage=\"Website for press outlet is required.\" class=\"form-control input-md  validate[required, custom[url]] text-input\">\r\n</div>\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Phone number of press outlet (xxx)xxx-xxxx</label>\r\n          <div class=\"controls\">\r\n            <input type=\"tel\" ng-model=\"User.outlet_phone_no\" ng-disabled=\"User.organization._id\" data-errormessage=\"Phone number of press outlet is required.\"\r\nclass=\"form-control input-md  validate[required] text-input\">\r\n</div>\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Your extension number (if any)</label>\r\n          <div class=\"controls\">\r\n            <input type=\"text\" ng-model=\"User.press_extension_no\" class=\"form-control input-md text-input\">\r\n</div>\r\n        </div>\r\n        <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"firstname\">Your Name</label>\r\n          <div class=\"controls\">\r\n            <input ng-if=\"UserType == \'voter\'\" type=\"text\" ng-model=\"User.name\" placeholder=\"\" class=\"form-control input-md text-input\">\r\n            <input ng-if=\"UserType != \'voter\'\" type=\"text\" ng-model=\"User.name\" placeholder=\"\" data-errormessage=\"Name is required.\"\r\nclass=\"form-control input-md  validate[required] text-input\">\r\n</div>\r\n        </div>\r\n        <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"firstname\">Your Position</label>\r\n          <div class=\"controls\">\r\n            <input ng-if=\"UserType == \'voter\'\" type=\"text\" ng-model=\"User.lastname\" placeholder=\"\" class=\"form-control input-md text-input\">\r\n            <input ng-if=\"UserType != \'voter\'\" type=\"text\" ng-model=\"User.lastname\" placeholder=\"\" data-errormessage=\"Last name is required.\"\r\nclass=\"form-control input-md  validate[required] text-input\">\r\n</div>\r\n        </div>\r\n        <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"firstname\">UserName for future Log In</label>\r\n          <div class=\"controls\">\r\n            <input type=\"text\" ng-model=\"User.UserName\" ng-blur=\"CheckUserName()\" placeholder=\"\" data-errormessage=\"UserName is required.\"\r\nclass=\"form-control input-md  validate[required] text-input\">\r\n</div>\r\n        </div>\r\n        <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"password\">Create Password</label>\r\n          <div class=\"controls\">\r\n            <input type=\"password\" id=\"password\" ng-model=\"User.Password\" placeholder=\"\" data-errormessage=\"Password is required.\" class=\"form-control input-md  validate[required] text-input\"\r\n/>\r\n</div>\r\n        </div>\r\n        <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"password\">Confirm Password</label>\r\n          <div class=\"controls\">\r\n            <input type=\"password\" id=\"confirm_password\" ng-model=\"ConfirmPassword\" data-errormessage=\"Password and Confirm password do not match.\"\r\nplaceholder=\"\" class=\"form-control input-md  validate[required,equals[password]] text-input \" />\r\n            <small id=\"message\"></small>\r\n          </div>\r\n        </div>\r\n        <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Email</label>\r\n          <div class=\"controls\">\r\n            <input type=\"email\" id=\"email\" ng-model=\"User.Email\" data-errormessage=\"Email is required.\" class=\"form-control input-md  validate[required] text-input\">\r\n</div>\r\n        </div>\r\n      </div>\r\n\r\n\r\n      <!-- For VOTERS -->\r\n      <div ng-if=\"UserType == \'voter\'\">\r\n\r\n\r\n        <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"firstname\">Giving us your name helps the email we send you (to confirm your account) get past your spam filter.<br> <br>First Name (optional)</label>\r\n          <div class=\"controls\">\r\n            <input type=\"text\" ng-model=\"User.name\" placeholder=\"\" class=\"form-control input-md text-input\">\r\n            <!--<input ng-if=\"UserType != \'voter\'\" type=\"text\" ng-model=\"User.name\" placeholder=\"\" data-errormessage=\"Name is required.\"\r\nclass=\"form-control input-md  validate[required] text-input\">  -->\r\n          </div>\r\n        </div>\r\n        <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"firstname\">Last Name (optional)</label>\r\n          <div class=\"controls\">\r\n            <input  type=\"text\" ng-model=\"User.lastname\" placeholder=\"\" class=\"form-control input-md text-input\">\r\n            <!--<input ng-if=\"UserType != \'voter\'\" type=\"text\" ng-model=\"User.lastname\" placeholder=\"\" data-errormessage=\"Last name is required.\"\r\nclass=\"form-control input-md  validate[required] text-input\"> -->\r\n          </div>\r\n        </div>\r\n        <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"firstname\">UserName <br>(For Log in and User Forums)</label>\r\n          <div class=\"controls\">\r\n            <input type=\"text\" ng-model=\"User.UserName\" ng-blur=\"CheckUserName()\" placeholder=\"\" data-errormessage=\"UserName is required.\"\r\nclass=\"form-control input-md  validate[required] text-input\">\r\n</div>\r\n        </div>\r\n        <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"password\"> Create Password</label>\r\n          <div class=\"controls\">\r\n            <input type=\"password\" id=\"password\" ng-model=\"User.Password\" placeholder=\"\" data-errormessage=\"Password is required.\" class=\"form-control input-md  validate[required] text-input\"\r\n/>\r\n</div>\r\n        </div>\r\n        <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"password\">Confirm Password</label>\r\n          <div class=\"controls\">\r\n            <input type=\"password\" id=\"confirm_password\" ng-model=\"ConfirmPassword\" data-errormessage=\"Password and Confirm password do not match.\"\r\nplaceholder=\"\" class=\"form-control input-md  validate[required,equals[password]] text-input \" />\r\n            <small id=\"message\"></small>\r\n          </div>\r\n        </div>\r\n        <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Email</label>\r\n          <div class=\"controls\">\r\n            <input type=\"email\" ng-model=\"User.Email\" data-errormessage=\"Email is required.\" class=\"form-control input-md  validate[required] text-input\">\r\n</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"control-group\" ng-if=\"!HideRegisterButton && !HideNewRegisterButton \">\r\n        <label class=\"control-label formLabel whiteText\">Street Address (LEAVE OUT APT #)<br>(This is used for location based tools like finding your representatives. Feel free to use an intersection instead of your actual address)</label>\r\n        <div class=\"control-group\">\r\n          <input type=\"text\" id=\"address\" ng-model=\"User.Address\" ng-keyup=\"detectAddress($event)\" class=\"zipInput form-control\" />&nbsp;\r\n</div>\r\n      </div>\r\n\r\n      <div class=\"control-group\" ng-if=\"!HideRegisterButton && !HideNewRegisterButton \">\r\n        <label class=\"control-label formLabel whiteText\" for=\"zipcode\">ZipCode</label>\r\n        <div class=\"control-group\">\r\n          <!-- <input type=\"text\" ng-model=\"User.ZipCode\" ng-keydown=\"detectCode($event, User.ZipCode)\" class=\"zipInput form-control validate[required,custom[integer],minSize[5]] text-input\"\r\n/>&nbsp;\r\n<i class=\"fa fa-search zipSearchIcon\" ng-click=\"showAddressDropDowns(User.ZipCode)\" aria-hidden=\"true\"></i>&nbsp; &nbsp;\r\n<i ng-if=\"showZipLoader\" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i> -->\r\n          <input type=\"text\" ng-model=\"User.ZipCode\" id=\"zip\" class=\"zipInput form-control validate[required,custom[integer],minSize[5]] text-input\"\r\n/>&nbsp;\r\n</div>\r\n      </div>\r\n      <div ng-if=\"showAddressDropDown\">\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel removeTopMargin\" for=\"email\">State </label>\r\n          <div class=\"controls\">\r\n            <select ng-model=\"address.state\" style=\"text-transform: capitalize;\" disabled=\"true\" ng-change=\"getCounties()\" ng-options=\"item.state for item in states track by item.statePostalCode\"\r\nclass=\"changeTextColor\"></select>\r\n          </div>\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">County </label>\r\n          <div class=\"controls\">\r\n            <select ng-model=\"address.county\" disabled=\"true\" style=\"text-transform: capitalize;\" ng-options=\"item._id.county for item in counties track by item._id.county\"\r\nng-change=\"onCountyChange()\" class=\"changeTextColor\"></select>\r\n          </div>\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Sub county </label>\r\n          <div class=\"controls\">\r\n            <select ng-model=\"address.countySubdivision\" disabled=\"true\" style=\"text-transform: capitalize;\" ng-options=\"countySubdivision as item._id.countySubdivision for item in places | unique:\'_id.countySubdivision\' track by item._id.countySubdivision\"\r\nng-change=\"onSubCountyChange()\" class=\"changeTextColor\"></select>\r\n          </div>\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">City </label>\r\n          <div class=\"controls\">\r\n            <select ng-model=\"address.place\" disabled=\"true\" style=\"text-transform: capitalize;\" ng-options=\"item as item._id.place for item in places | filter:emptyOrNull\"\r\nclass=\"changeTextColor\"></select>\r\n          </div>\r\n          <!-- ng-change=\"getZipDataTwo()\" -->\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Voter District (click if incorrect) </label>\r\n          <div class=\"controls\">\r\n            <select class=\"changeTextColor\" ng-model=\"address.voterDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item.voterDistrictName for item in voterDistricts | unique:\'voterDistrictName\' track by item.voterDistrictName\"\r\nng-change=\"onVoterDistChange()\" ng-class=\"{yellowBackground: voterDistricts.length > 1}\"></select>\r\n          </div>\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Federal Congressional District (click if incorrect) </label>\r\n          <div class=\"controls\">\r\n            <select class=\"changeTextColor\" ng-model=\"address.federalCongrassionalDist\" style=\"text-transform: capitalize;\" ng-options=\"item as item.federalCongrassionalDist for item in federalCongrassionalDist | unique:\'federalCongrassionalDist\' track by item.federalCongrassionalDist\"\r\nng-class=\"checkLength(federalCongrassionalDist, \'federalCongrassionalDist\')\"></select>\r\n          </div>\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">State Senate District (click if incorrect) </label>\r\n          <div class=\"controls\">\r\n            <select class=\"changeTextColor\" ng-model=\"address.stateSenateDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item.stateSenateDistrict for item in stateSenateDistrict | unique:\'stateSenateDistrict\' track by item.stateSenateDistrict\"\r\nng-class=\"checkLength(stateSenateDistrict, \'stateSenateDistrict\')\"></select>\r\n          </div>\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">State House of Representative District (click if incorrect) </label>\r\n          <div class=\"controls\">\r\n            <select class=\"changeTextColor\" ng-model=\"address.stateHouseOFRepresentativeDistrict\" style=\"text-transform: capitalize;\"\r\nng-options=\"item as item.stateHouseOFRepresentativeDistrict for item in stateHouseOFRepresentativeDistricts | unique:\'stateHouseOFRepresentativeDistrict\' track by item.stateHouseOFRepresentativeDistrict\"\r\nng-class=\"checkLength(stateHouseOFRepresentativeDistricts, \'stateHouseOFRepresentativeDistrict\')\"></select>\r\n          </div>\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">School District Name (click if incorrect) </label>\r\n          <div class=\"controls\">\r\n            <select class=\"changeTextColor\" ng-model=\"address.unifiedSchoolDistrictName\" style=\"text-transform: capitalize;\" ng-options=\"item as item.unifiedSchoolDistrictName for item in unifiedSchoolDistrictNames | unique:\'unifiedSchoolDistrictName\' track by item.unifiedSchoolDistrictName\"\r\nng-class=\"checkLength(unifiedSchoolDistrictNames, \'unifiedSchoolDistrictName\')\"></select>\r\n          </div>\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <p>\r\n            Don\'t know\r\n            your info?\r\n            <a ng-click=\"showFindAddress();\" class=\"ylink\">Click Here</a>\r\n            <!--<a href=\"http://www.melissadata.com/lookups/addressverify.asp\" target=\"_blank\" class=\"link\">MelissaData</a> -->\r\n          </p>\r\n        </div>\r\n        <div style=\"clear: both;\">\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"control-group whiteText\" ng-if=\"UserType == \'voter\'\">\r\n        <label class=\"control-label formLabel removeTopMargin\" for=\"zipcode\">Confirm account using: </label>\r\n        <div class=\"control-group\">\r\n          <label>\r\n<input type=\"radio\" ng-model=\"User.confirmOpt\" ng-click=\"disableRegister(\'E\');\" value=\"Email\"> Email\r\n</label>\r\n          <label>\r\n<input type=\"radio\" ng-model=\"User.confirmOpt\" ng-click=\"disableRegister(\'P\');\" value=\"Phone\"> Phone\r\n</label>\r\n        </div>\r\n      </div>\r\n      <!--  <div class=\"control-group whiteText\" ng-if=\"UserType == \'politician\' && !HideRegisterButton && !HideNewRegisterButton \">\r\n<p>We do not store the SSN in our system, we will use it to verify your account.</p>\r\n<label class=\"control-label formLabel whiteText\" for=\"cellnumber\">Social Security Number</label>\r\n<div class=\"control-group\">\r\n<input type=\"text\" maxlength=\"10\" ng-model=\"User.ssn\" class=\"form-control validate[required,custom[integer],minSize[5]] text-input\"\r\n/>\r\n</div>\r\n<br>\r\n<a ng-click=\"verifySSN();\" style=\"text-decoration: underline;\">Check valid SSN</a>\r\n</div> -->\r\n      <div class=\"control-group\" ng-if=\"UserType == \'voter\' && User.confirmOpt==\'Phone\'\">\r\n\r\n        <div class=\"alert alert-danger alert-dismissible\" id=\"alert\" ng-if=\"number_exist\" style=\"width:100%;\">\r\n          <button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button>\r\n          <strong>Phone number already used by another user for verification.</strong>\r\n        </div>\r\n        <label class=\"control-label formLabel whiteText\" for=\"cellnumber\">Phone Number</label>\r\n        <div class=\"control-group\">\r\n          <input type=\"number\" maxlength=\"10\" ng-model=\"User.cellnumber\" class=\"form-control validate[required,custom[integer],minSize[5]] text-input\"\r\n/>\r\n</div>\r\n      </div>\r\n      <div class=\"control-group\" ng-if=\"UserType == \'voter\' && User.confirmOpt==\'Phone\'\">\r\n        <label class=\"control-label formLabel whiteText\" for=\"cellnumber\">Select carrier</label>\r\n        <div class=\"control-group blackText\">\r\n          <select ng-model=\"User.carrier\" style=\"text-transform: capitalize;\" ng-options=\"item.name for item in carriers\">\r\n</select>\r\n        </div>\r\n      </div>\r\n      <div class=\"control-group\" ng-if=\"UserType == \'voter\' && User.confirmOpt==\'Phone\'\">\r\n        <br>\r\n        <a ng-click=\"getVerificationCode();\" style=\"text-decoration: underline;\">Send verification code</a>\r\n      </div>\r\n      <div class=\"control-group\" ng-if=\"UserType == \'voter\' && User.confirmOpt==\'Phone\'\">\r\n        <br>\r\n        <label class=\"control-label formLabel whiteText\" for=\"cellnumber\">Enter verification code</label>\r\n        <div class=\"control-group\">\r\n          <input type=\"text\" ng-model=\"User.verificationCode\" class=\"form-control validate[required,custom[integer],minSize[5]] text-input\"\r\nng-change=\"matchVerficationCode(User.verificationCode);\" maxlength=\"6\" />\r\n\r\n</div>\r\n      </div>\r\n      <div ng-if=\"UserType != \'voter\' && User.Candidates.name==\'Other\'\">\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Instructions if any needed to confirm identity</label>\r\n          <div class=\"controls\">\r\n            <textarea ng-model=\"User.verification_note\"></textarea>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div style=\"clear: both;\">\r\n      </div>\r\n      <div class=\"btn-style\" style=\"width:100%; margin-right:0px;\"\r\n        ng-if=\"!HideRegisterButton && !HideNewRegisterButton\">\r\n        <center>\r\n          <button class=\"btnShort-style\" ng-if=\"!forFacebook\" ng-click=\"CreateUser()\" type=\"button\" class=\"btn btn-success\" ng-disabled=\"RegisterButton\"\r\n>Register</button></center>\r\n        <br/>\r\n        <br/>\r\n\r\n        <button ng-click=\"ShowFB()\"  ng-if=\"!forFacebook\" type=\"button\" class=\"btnB275 fullWidth\">\r\n<i class=\"fa fa-facebook-square\" aria-hidden=\"true\"></i>&nbsp;Instant Voter Sign Up with Facebook</button>\r\n\r\n      </div>\r\n    </div>\r\n\r\n\r\n    <div style=\"float: left; margin-left: 20px; margin-top: 7px;\" ng-if=\"!HideRegisterButton && !HideNewRegisterButton\"\r\n      class=\"whiteText\">\r\n      Already have\r\n      an account?\r\n      Please\r\n      <a style=\"text-decoration: underline;\" href=\"#!/signin\" class=\"ylink\">Sign In here</a>\r\n    </div>\r\n  </div>\r\n  <fieldset ng-if=\"$root.showFacebookLoging\" class=\"scheduler-border\">\r\n    <legend class=\"scheduler-border\">\r\n      To\r\n      continue,\r\n      we\r\n      need\r\n      some\r\n      information\r\n      from\r\n      you.\r\n    </legend>\r\n    <div class=\"control-group\">\r\n      <label class=\"control-label formLabel removeTopMargin\" for=\"firstname\">What type of user are you?</label>\r\n      <div class=\"controls\">\r\n        <select ng-model=\"User.UserType\" style=\"text-transform: capitalize;\" class=\"form-control validate[required]\" ng-change=\"userTypeChanged(User.UserType)\">\r\n<option ng-repeat=\" item in MUserType\" ng-selected=\"item.name==\'Voter\'\" value=\"{{item.key}}\">{{item.name}}</option>\r\n</select>\r\n      </div>\r\n    </div>\r\n    <div ng-if=\"User.UserType == \'advocate\'\">\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel whiteText\" for=\"email\">Organization Name</label>\r\n        <div mass-autocomplete style=\"text-transform: capitalize\"; >\r\n          <input ng-model=\"User.organization_name\" ng-blur=\"checkExists();\" mass-autocomplete-item=\"org_autocomplete_options\" style=\"text-transform: capitalize\";>\r\n</div>\r\n      </div>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel whiteText\" for=\"email\">Website for organization</label>\r\n        <div class=\"controls\">\r\n          <input type=\"text\" ng-model=\"User.organization.web_url\" ng-disabled=\"User.organization._id\" data-errormessage-custom-error=\"Invalid URL.\"\r\ndata-errormessage=\"Website for organization is required.\" class=\"form-control input-md  validate[required, custom[url]] text-input\">\r\n</div>\r\n      </div>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel whiteText\" for=\"email\">Phone number of organization (xxx)xxx-xxxx</label>\r\n        <div class=\"controls\">\r\n          <input type=\"tel\" ng-model=\"User.organization.phone_no\" ng-disabled=\"User.organization._id\" data-errormessage=\"Phone number of organization is required.\"\r\nclass=\"form-control input-md  validate[required] text-input\">\r\n</div>\r\n      </div>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel whiteText\" for=\"email\">Your extension number (if any)</label>\r\n        <div class=\"controls\">\r\n          <!-- <input type=\"text\" ng-model=\"User.extention_no\" data-errormessage=\"Phone is required.\" class=\"form-control input-md text-input\" class=\"validation[required] text-input\"> -->\r\n          <input type=\"tel\" ng-model=\"User.extention_no\" class=\"form-control input-md text-input\">\r\n</div>\r\n      </div>\r\n    </div>\r\n    <!-- Politician section -->\r\n    <div ng-if=\"User.UserType == \'politician\'\">\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel whiteText\" for=\"email\">Are you currently in Office?</label>\r\n        <div class=\"controls whiteText\">\r\n          <label>\r\n                                                                                <input type=\"radio\" ng-model=\"User.isInCurrentOffice\" value=\"1\"> Yes\r\n                                                                                </label>\r\n          <label>\r\n                                                                                <input type=\"radio\" ng-model=\"User.isInCurrentOffice\" value=\"0\"> No\r\n                                                                                </label>\r\n        </div>\r\n      </div>\r\n      <div ng-if=\"User.isInCurrentOffice == 1\">\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">What level of government?</label>\r\n          <select ng-model=\"User.cur_level\" style=\"text-transform: capitalize;display: block;\" ng-options=\"item as item for item in levelOfGovt\"\r\n                                                                                ng-change=\"govLevelChanged(\'incumbent\')\" class=\"changeTextColor\">\r\n                                                                                </select>\r\n        </div>\r\n        <div class=\"control-group\" ng-if=\"flagShowStateDropdown\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Select State: (if applicable)</label>\r\n          <select ng-model=\"User.cur_state\" style=\"text-transform: capitalize;max-width: 85%\" ng-options=\"item as item.state for item in states\"\r\n                                                                                ng-change=\"onOfficeChange(\'incumbent\')\" class=\"changeTextColor\">\r\n                                                                                </select>&nbsp; &nbsp;\r\n          <i ng-if=\"showLoader\" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>\r\n        </div>\r\n        <div style=\"width:40%\" class=\"control-group\" ng-if=\"countyone\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">County </label>\r\n          <div class=\"controls\">\r\n            <select ng-model=\"address.county\" style=\"text-transform: capitalize;display:inline\" ng-options=\"item as item.countyName for item in counties | orderBy : \'county\'\" ng-change=\"getSubCounties()\" class=\"changeTextColor\"></select>\r\n            <i ng-if=\"showLoaderOne\" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>\r\n          </div>\r\n        </div>\r\n        <div style=\"width:70%\" class=\"control-group\" ng-if=\"cityone\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">City </label>\r\n          <div class=\"controls\">\r\n            <select ng-model=\"address.place\" style=\"text-transform: capitalize;\" ng-options=\"item as item.city for item in places | orderBy : \'place\' \" class=\"changeTextColor\"></select>\r\n            <!-- <i ng-if=\"LoaderTwo \" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i> -->\r\n          </div>\r\n        </div>\r\n        <div id=\"curCandidate\" class=\"control-group\" ng-if=\"flagShowCandidateDropdown\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">What is your name as it appears on the ballot?</label>\r\n          <div mass-autocomplete>\r\n            <input ng-model=\"User.cur_Candidates\" ng-blur=\"checkExists();\" mass-autocomplete-item=\"autocomplete_options\" class=\"changeTextColor\">\r\n                                                                                </div>\r\n        </div>\r\n        <div class=\"control-group\" ng-if=\"showcur_office_name\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Office Name</label>\r\n          <div class=\"controls\">\r\n            <input type=\"text\" ng-model=\"User.cur_office_name\" class=\"form-control  input-md text-input\" style=\"width: 88%\">\r\n                                                                                </div>\r\n        </div>\r\n        <div class=\"control-group\" ng-if=\"showcur_office_name\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Office Phone(optional)</label>\r\n          <div class=\"controls\">\r\n            <input type=\"text\" ng-model=\"User.cur_office_phone\" class=\"form-control input-md text-input\" style=\"width: 88%\">\r\n                                                                                </div>\r\n        </div>\r\n        <div class=\"control-group\" ng-if=\"showcur_office_name\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Office Email(optional)</label>\r\n          <div class=\"controls\">\r\n            <input type=\"text\" ng-model=\"User.cur_office_email\" class=\"form-control  input-md text-input\" style=\"width: 88%\">\r\n                                                                                </div>\r\n        </div>\r\n        <div class=\"control-group\" ng-if=\"showcur_office_name\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Office Website (optional)</label>\r\n          <div class=\"controls\">\r\n            <input type=\"text\" ng-model=\"User.cur_office_website\" class=\"form-control validate[custom[url]] input-md text-input\" style=\"width: 88%\">\r\n                                                                                </div>\r\n        </div>\r\n        <div class=\"control-group\" ng-if=\"showcur_office_name\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Office Facebook Url (optional)</label>\r\n          <div class=\"controls\">\r\n            <input type=\"text\" ng-model=\"User.facebook_url\" ng-disabled=\"User.organization._id\" class=\"form-control validate[custom[url]] input-md text-input\"\r\n                                                                                      style=\"width: 88%\">\r\n                                                                                      </div>\r\n        </div>\r\n\r\n      </div>\r\n      <br>\r\n      <div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Are you running for office this coming election?</label>\r\n          <div class=\"controls whiteText\">\r\n            <label>\r\n                                                                                <input type=\"radio\" ng-model=\"User.isRunningForEle\" ng-click=\"User.RunningForOtherOffice = 0;  \" value=\"1\"> Yes\r\n                                                                                </label>\r\n            <label>\r\n                                                                                <input type=\"radio\" ng-model=\"User.isRunningForEle\" ng-click=\"User.RunningForOtherOffice = 0;  \" value=\"0\"> No\r\n                                                                                </label>\r\n          </div>\r\n        </div>\r\n        <div ng-if=\"User.isRunningForEle == 1 && User.isInCurrentOffice == 1\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Are you running for the same office?</label>\r\n          <div class=\"controls whiteText\">\r\n            <label>\r\n                                                                                <input type=\"radio\" ng-model=\"User.RunningForOtherOffice\" ng-checked=\"User.RunningForOtherOffice == 1\" value=\"1\"> Yes\r\n                                                                                </label>\r\n            <label>\r\n                                                                                <input type=\"radio\" ng-model=\"User.RunningForOtherOffice\" ng-checked=\"User.RunningForOtherOffice == 0\" value=\"0\"> No\r\n                                                                                </label>\r\n          </div>\r\n        </div>\r\n        <div\r\n          ng-if=\"User.isInCurrentOffice == 1? User.isRunningForEle==1? User.RunningForOtherOffice == 0: false : User.isRunningForEle==1\">\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\">What level of government?</label>\r\n            <select ng-model=\"User.level\" style=\"text-transform: capitalize; display: block;\" ng-change=\"govLevelChanged(\'running\')\"\r\n                                                                                ng-options=\"item as item for item in levelOfGovt\" class=\"changeTextColor\">\r\n                                                                                </select>\r\n          </div>\r\n          <div class=\"control-group\" ng-if=\"running_flagShowStateDropdown\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\"> Select State: (if applicable)</label>\r\n            <select ng-model=\"User.state\" style=\"text-transform: capitalize;\" ng-options=\"item as item.state for item in states\" ng-change=\"onOfficeChange(\'running\')\"\r\n                                                                                class=\"changeTextColor\">\r\n                                                                                </select>&nbsp; &nbsp;\r\n            <i ng-if=\"showLoader\" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>\r\n          </div>\r\n          <div style=\"width:40%\" class=\"control-group\" ng-if=\" running_flagShowStateDropdown && running_countyone\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\">County </label>\r\n            <div class=\"controls\">\r\n              <select ng-model=\"runAddress.county\" style=\"text-transform: capitalize;display:inline\" ng-options=\"item as item.countyName for item in runCounties | orderBy : \'county\'\" ng-change=\"getRunningSubCounties()\" class=\"changeTextColor\"></select>\r\n              <i ng-if=\"running_showLoaderOne\" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>\r\n            </div>\r\n          </div>\r\n          <div style=\"width:40%\" class=\"control-group\" ng-if=\"running_flagShowStateDropdown && running_cityone\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\">City </label>\r\n            <div class=\"controls\">\r\n              <select ng-model=\"runAddress.place\" style=\"text-transform: capitalize;\" ng-options=\"item as item.city for item in runPlaces | orderBy : \'place\'\" class=\"changeTextColor\"></select>\r\n            </div>\r\n          </div>\r\n          <div id=\"curCandidate\" class=\"control-group\" ng-if=\"running_flagShowCandidateDropdown\">\r\n            <label class=\"control-label formLabel formLabel whiteText\" for=\"email\">What is your name as it appears on the ballot?</label>\r\n            <div mass-autocomplete>\r\n              <input ng-model=\"User.new_Candidates\" ng-blur=\"checkExistsNew()\" mass-autocomplete-item=\"autocomplete_new_options\">\r\n                                                                                </div>\r\n          </div>\r\n          <div class=\"control-group\" ng-if=\"shownew_office_name\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\">Office Name</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"User.office_name\" class=\"form-control input-md text-input\" style=\"width: 88%\">\r\n                                                                                </div>\r\n          </div>\r\n          <div style=\"width: 60%\">\r\n            <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"email\">Election Date</label>\r\n              <div class=\"controls\">\r\n                <input type=\"date\"  ng-model=\"User.runElectionDate\" class=\"form-control\">\r\n                                                                                                                              </div>\r\n            </div>\r\n          </div>\r\n          <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\">Candidate Status</label>\r\n            <div class=\"controls\">\r\n              <select ng-model=\"User.runStatus\" class=\"form-control\"  style=\"width:36%;\">\r\n                                                                                                                              <option value=\"\">Select Status</option>\r\n                                                                                                                              <option value=\"Announced\">Announced</option>\r\n                                                                                                                              <option value=\"Write in\">Write in</option>\r\n                                                                                                                              <option value=\"Running\">Running</option>\r\n                                                                                                                              <option value=\"Campaign Suspended\">Campaign Suspended</option>\r\n                                                                                                                              </select>\r\n            </div>\r\n          </div>\r\n\r\n\r\n        </div>\r\n      </div>\r\n      <div ng-if=\"User.RunningForOtherOffice == 1\" style=\"width: 60%\">\r\n        <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Election Date</label>\r\n          <div class=\"controls\">\r\n            <input type=\"date\" ng-model=\"User.runElectionDate\" class=\"form-control\">\r\n                                                                                </div>\r\n        </div>\r\n      </div>\r\n      <div ng-if=\"User.RunningForOtherOffice == 1\">\r\n        <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Candidate Status</label>\r\n          <div class=\"controls\">\r\n            <select ng-model=\"User.runStatus\" class=\"form-control\"  style=\"width:36%;\">\r\n                                                                                <option value=\"\">Select Status</option>\r\n                                                                                <option value=\"Announced\">Announced</option>\r\n                                                                                <option value=\"Write in\">Write in</option>\r\n                                                                                <option value=\"Running\">Running</option>\r\n                                                                                <!-- <option value=\"Active\">Active</option> -->\r\n                                                                                <option value=\"Campaign Suspended\">Campaign Suspended</option>\r\n                                                                                </select>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <br>\r\n      <div ng-if=\"shownew_office_name\">\r\n\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Campaign Website (optional)</label>\r\n          <div class=\"controls\">\r\n            <input type=\"text\" ng-model=\"User.campaignWebSite\" ng-disabled=\"User.organization._id\" class=\"form-control validate[custom[url]] input-md text-input\"\r\n                                                                                style=\"width: 88%\">\r\n                                                                                </div>\r\n        </div>\r\n\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Campaign Facebook Url (optional)</label>\r\n          <div class=\"controls\">\r\n            <input type=\"text\" ng-model=\"User.campaignFburl\" ng-disabled=\"User.organization._id\" class=\"form-control validate[custom[url]] input-md text-input\"\r\n                                                                                                  style=\"width: 88%\">\r\n                                                                                                  </div>\r\n        </div>\r\n\r\n        <!-- <div class=\"control-group\">\r\n                                                                                                                                          <label class=\"control-label formLabel whiteText\" for=\"email\"> Account Phone number (xxx)xxx-xxxx</label>\r\n                                                                                                                                          <div class=\"controls\">\r\n                                                                                                                                            <input type=\"tel\" ng-model=\"User.phone_no\" data-errormessage=\"Phone number is required.\" data-errormessage-custom-error=\"Invalid phone number.\"\r\n                                                                                class=\"form-control input-md  validate[required] text-input\" style=\"width: 88%\">\r\n                                                                                </div>\r\n                                                                                                                                          </div> -->\r\n        <!--                                                          <div class=\"control-group\">\r\n                                                                                                                                            <label class=\"control-label formLabel whiteText\" for=\"email\">Website</label>\r\n                                                                                                                                            <div class=\"controls\">\r\n                                                                                                                                              <input type=\"text\" ng-model=\"User.web_url\" ng-disabled=\"User.organization._id\" class=\"form-control validate[custom[url]] input-md text-input\"\r\n                                                                                style=\"width: 88%\">\r\n                                                                                </div>\r\n                                                                                                                                            </div> -->\r\n      </div>\r\n      <div ng-if=\"!HideRegisterButton && !HideNewRegisterButton\">\r\n        <!-- <div ng-if=\"!shownew_office_name\">\r\n                                                                                                                                            <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                                                                                                                                              <label class=\"control-label formLabel whiteText\" for=\"email\">Account Email</label>\r\n                                                                                                                                              <div class=\"controls\">\r\n                                                                                                                                                <input type=\"email\" ng-model=\"User.Email\" data-errormessage=\"Email is required.\" class=\"form-control input-md  validate[required] text-input\"\r\n                                                                                ng-readonly=\"checkReadOnly\" style=\"width: 88%\">\r\n                                                                                </div>\r\n                                                                                                                                              </div>\r\n                                                                                                                                              <div class=\"control-group\">\r\n                                                                                                                                                <label class=\"control-label formLabel whiteText\" for=\"email\"> Account Phone number (xxx)xxx-xxxx</label>\r\n                                                                                                                                                <div class=\"controls\">\r\n                                                                                                                                                  <input type=\"tel\" ng-model=\"User.phone_no\" data-errormessage=\"Phone number is required.\" data-errormessage-custom-error=\"Invalid phone number.\"\r\n                                                                                class=\"form-control input-md  validate[required] text-input\" style=\"width: 88%\">\r\n                                                                                </div>\r\n                                                                                                                                                </div>\r\n                                                                                                                                                <div class=\"control-group\">\r\n                                                                                                                                                  <label class=\"control-label formLabel whiteText\" for=\"email\">Campaign Website (optional)</label>\r\n                                                                                                                                                  <div class=\"controls\">\r\n                                                                                                                                                    <input type=\"text\" ng-model=\"User.web_url\" ng-disabled=\"User.organization._id\" class=\"form-control validate[custom[url]] input-md text-input\"\r\n                                                                                style=\"width: 88%\">\r\n                                                                                </div>\r\n                                                                                                                                                  </div>\r\n                                                                                                                                                </div> -->\r\n        <!-- <div class=\"control-group\">\r\n                                                                                                                                                  <label class=\"control-label formLabel whiteText\" for=\"email\">Facebook Url (optional)</label>\r\n                                                                                                                                                  <div class=\"controls\">\r\n                                                                                                                                                    <input type=\"text\" ng-model=\"User.facebook_url\" ng-disabled=\"User.organization._id\" class=\"form-control validate[custom[url]] input-md text-input\"\r\n                                                                                style=\"width: 88%\">\r\n                                                                                </div>\r\n                                                                                                                                                  </div> -->\r\n        <!--  <div class=\"control-group\">\r\n                                                                                <label class=\"control-label formLabel whiteText\" for=\"email\">Mailing address</label>\r\n                                                                                <div class=\"controls\">\r\n                                                                                <input type=\"text\" ng-model=\"User.mailing_address\" data-errormessage=\"Mailing address is required.\" class=\"form-control input-md  validate[required] text-input\"\r\n                                                                                style=\"width: 88%\">\r\n                                                                                </div>\r\n                                                                                </div> -->\r\n        <!-- <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                                                                                                                                                    <label class=\"control-label formLabel whiteText\" for=\"firstname\">Account Manager\'s Name</label>\r\n                                                                                                                                                    <div class=\"controls\">\r\n                                                                                                                                                      <input ng-if=\"UserType == \'voter\'\" type=\"text\" ng-model=\"User.name\" placeholder=\"\" class=\"form-control input-md text-input\"\r\n                                                                                style=\"width: 88%\">\r\n                                                                                                                                                      <input ng-if=\"UserType != \'voter\'\" type=\"text\" ng-model=\"User.name\" placeholder=\"\" data-errormessage=\"Account Manager\'s Name is required.\"\r\n                                                                                class=\"form-control input-md  validate[required] text-input\" style=\"width: 88%\">\r\n                                                                                </div>\r\n                                                                                                                                                    </div>\r\n                                                                                                                                                    <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                                                                                                                                                      <label class=\"control-label formLabel whiteText\" for=\"firstname\">UserName for future Log In</label>\r\n                                                                                                                                                      <div class=\"controls\">\r\n                                                                                                                                                        <input type=\"text\" ng-model=\"User.UserName\" ng-blur=\"CheckUserName()\" placeholder=\"\" data-errormessage=\"UserName is required.\"\r\n                                                                                class=\"form-control input-md  validate[required] text-input\" style=\"width: 88%\">\r\n                                                                                </div>\r\n                                                                                                                                                      </div>\r\n                                                                                                                                                      <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                                                                                                                                                        <label class=\"control-label formLabel whiteText\" for=\"password\"> Create Password</label>\r\n                                                                                                                                                        <div class=\"controls\">\r\n                                                                                                                                                          <input type=\"password\" id=\"password\" ng-model=\"User.Password\" placeholder=\"\" data-errormessage=\"Password is required.\" class=\"form-control input-md  validate[required] text-input\"\r\n                                                                                style=\"width: 88%\" />\r\n                                                                                </div>\r\n                                                                                                                                                        </div>\r\n                                                                                                                                                        <div ng-if=\"!forFacebook\" class=\"control-group\">\r\n                                                                                                                                                          <label class=\"control-label formLabel whiteText\" for=\"password\">Confirm Password</label>\r\n                                                                                                                                                          <div class=\"controls\">\r\n                                                                                                                                                            <input type=\"password\" id=\"confirm_password\" ng-model=\"ConfirmPassword\" data-errormessage=\"Password and Confirm password do not match.\"\r\n                                                                                placeholder=\"\" class=\"form-control input-md  validate[required,equals[password]] text-input \" style=\"width: 88%\"\r\n                                                                                />\r\n                                                                                                                                                            <small id=\"message\"></small>\r\n                                                                                                                                                          </div>\r\n                                                                                                                                                        </div> -->\r\n      </div>\r\n      <!-- <div\r\n                                                                                                                                      ng-if=\"HideRegisterButton || HideNewRegisterButton\">\r\n                                                                                                                                      <div\r\n                                                                                                                                        class=\"control-group whiteText\">\r\n                                                                                                                                        <p>\r\n                                                                                                                                          Congratulations.\r\n                                                                                                                                          We\r\n                                                                                                                                          already\r\n                                                                                                                                          have\r\n                                                                                                                                          you\r\n                                                                                                                                          in\r\n                                                                                                                                          our\r\n                                                                                                                                          system\r\n                                                                                                                                          and\r\n                                                                                                                                          sent\r\n                                                                                                                                          you\r\n                                                                                                                                          a\r\n                                                                                                                                          password\r\n                                                                                                                                          awhile\r\n                                                                                                                                          ago\r\n                                                                                                                                          to\r\n                                                                                                                                          {{shortEmail}}.\r\n                                                                                                                                          If\r\n                                                                                                                                          you\r\n                                                                                                                                          lost\r\n                                                                                                                                          the\r\n                                                                                                                                          password\r\n                                                                                                                                          and\r\n                                                                                                                                          want\r\n                                                                                                                                          to\r\n                                                                                                                                          reset\r\n                                                                                                                                          it,\r\n                                                                                                                                          click\r\n                                                                                                                                          on\r\n                                                                                                                                          the\r\n                                                                                                                                          link\r\n                                                                                                                                          below.\r\n                                                                                                                                          If\r\n                                                                                                                                          you\r\n                                                                                                                                          have\r\n                                                                                                                                          other\r\n                                                                                                                                          issues\r\n                                                                                                                                          call\r\n                                                                                                                                          70-VoteWise\r\n                                                                                                                                        </p>\r\n                                                                                                                                      </div>\r\n\r\n                                                                                                                                      <div\r\n                                                                                                                                        class=\"control-group\"\r\n                                                                                                                                        ng-if=\"showMultiDrop\">\r\n                                                                                                                                        <label class=\"control-label formLabel removeTopMargin whiteText\"  for=\"UserName\">Which User</label>\r\n                                                                                                                                        <div\r\n                                                                                                                                          class=\"controls\">\r\n                                                                                                                                          <select style=\"width: 80%;\"  ng-model=\"User.multiName\"  class=\"blackText\" ng-options=\"x as x.name for x in multiArr\">\r\n                                                                                </select>\r\n                                                                                                                                        </div>\r\n                                                                                                                                      </div>\r\n                                                                                                                                      <div\r\n                                                                                                                                        ng-if=\"!forFacebook\"\r\n                                                                                                                                        class=\"control-group\"\r\n                                                                                                                                        style=\"width:88%\">\r\n                                                                                                                                        <label class=\"control-label formLabel whiteText\" for=\"firstname\">UserName/Email</label>\r\n                                                                                                                                        <div\r\n                                                                                                                                          class=\"controls\">\r\n                                                                                                                                          <input type=\"text\" ng-model=\"User.UserName\" placeholder=\"\" data-errormessage=\"UserName is required.\" class=\"form-control input-md  validate[required] text-input\">\r\n                                                                                </div>\r\n                                                                                                                                        </div>\r\n                                                                                                                                        <div\r\n                                                                                                                                          ng-if=\"!forFacebook\"\r\n                                                                                                                                          class=\"control-group\"\r\n                                                                                                                                          style=\"width:88%\">\r\n                                                                                                                                          <label class=\"control-label formLabel whiteText\" for=\"password\">Password</label>\r\n                                                                                                                                          <div\r\n                                                                                                                                            class=\"controls\">\r\n                                                                                                                                            <input type=\"password\" id=\"password\" ng-model=\"User.Password\" placeholder=\"\" data-errormessage=\"Password is required.\" class=\"form-control input-md  validate[required] text-input\"\r\n                                                                                />\r\n                                                                                </div>\r\n                                                                                                                                          </div>\r\n                                                                                                                                          <div\r\n                                                                                                                                            style=\"clear: both;\">\r\n                                                                                                                                          </div>\r\n                                                                                                                                          <div\r\n                                                                                                                                            class=\"btn-style\">\r\n                                                                                                                                            <button class=\"btnShort-style\" ng-if=\"!forFacebook\" ng-click=\"UserLogin()\" type=\"button\" class=\"btn btn-success\" style=\"float: right; width:258px; margin-right: 25%\">Update details & Login</button>\r\n                                                                                                                                          </div>\r\n                                                                                                                                          <div\r\n                                                                                                                                            style=\"clear: both;\">\r\n                                                                                                                                          </div>\r\n                                                                                                                                          <p\r\n                                                                                                                                            style=\"padding-top:5%;padding-left:3%; color: rgb(241, 241, 241)\">\r\n                                                                                                                                            Forgot\r\n                                                                                                                                            password?\r\n                                                                                                                                          </p>\r\n                                                                                                                                          <div\r\n                                                                                                                                            class=\"btn-style\">\r\n                                                                                                                                            <button class=\"btnShort-style whiteText\" ng-if=\"!forFacebook\" ng-click=\"resetPassword()\" type=\"button\" class=\"btn btn-success\"\r\n                                                                                style=\"float: right; width:258px; margin-right: 25%\">Please email me my password</button>\r\n                                                                                                                                          </div>\r\n                                                                                                                                        </div> -->\r\n    </div>\r\n    <!-- End Of Politician section -->\r\n    <div ng-if=\"User.UserType == \'press\'\">\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel whiteText\" for=\"email\">Name of Press outlet</label>\r\n        <div mass-autocomplete>\r\n          <input ng-model=\"User.outlet_name\" ng-blur=\"checkExists();\" mass-autocomplete-item=\"org_autocomplete_options\">\r\n</div>\r\n      </div>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel whiteText\" for=\"email\">Website for press outlet</label>\r\n        <div class=\"controls\">\r\n          <input type=\"text\" ng-model=\"User.outlet_web\" ng-disabled=\"User.organization._id\" data-errormessage-custom-error=\"Invalid URL.\"\r\ndata-errormessage=\"Website for press outlet is required.\" class=\"form-control input-md  validate[required, custom[url]] text-input\">\r\n</div>\r\n      </div>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel whiteText\" for=\"email\">Phone number of press outlet (xxx)xxx-xxxx</label>\r\n        <div class=\"controls\">\r\n          <input type=\"tel\" ng-model=\"User.outlet_phone_no\" ng-disabled=\"User.organization._id\" data-errormessage=\"Phone number of press outlet is required.\"\r\nclass=\"form-control input-md  validate[required] text-input\">\r\n</div>\r\n      </div>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel whiteText\" for=\"email\">Your extension number (if any)</label>\r\n        <div class=\"controls\">\r\n          <input type=\"text\" ng-model=\"User.press_extension_no\" class=\"form-control input-md text-input\">\r\n</div>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel whiteText\" for=\"zipcode\">ZipCode</label>\r\n        <div class=\"control-group\">\r\n          <!-- <input type=\"text\" ng-model=\"User.ZipCode\" ng-keyup=\"detectCode($event, User.ZipCode)\" class=\"zipInput form-control validate[required,custom[integer],minSize[5]] text-input\"\r\n/>&nbsp;\r\n<i class=\"fa fa-search zipSearchIcon\" ng-click=\"showAddressDropDowns(User.ZipCode)\" aria-hidden=\"true\"></i>&nbsp; &nbsp;\r\n<i ng-if=\"showZipLoader\" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i> -->\r\n          <input type=\"text\" ng-model=\"User.ZipCode\" class=\"zipInput form-control validate[required,custom[integer],minSize[5]] text-input\"\r\n/>\r\n</div>\r\n      </div>\r\n      <div ng-if=\"showAddressDropDown\">\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel removeTopMargin\" for=\"email\">State </label>\r\n          <div class=\"controls\">\r\n            <select ng-model=\"address.state\" style=\"text-transform: capitalize;\" disabled=\"true\" ng-change=\"getCounties()\" ng-options=\"item.state for item in states track by item.statePostalCode\"></select>\r\n          </div>\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">County </label>\r\n          <div class=\"controls\">\r\n            <select ng-model=\"address.county\" style=\"text-transform: capitalize;\" ng-options=\"item._id.county for item in counties track by item._id.county\"\r\nng-change=\"onCountyChange()\"></select>\r\n          </div>\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Sub county </label>\r\n          <div class=\"controls\">\r\n            <select ng-model=\"address.countySubdivision\" style=\"text-transform: capitalize;\" ng-options=\"countySubdivision as item._id.countySubdivision for item in places | unique:\'_id.countySubdivision\' track by item._id.countySubdivision\"\r\nng-change=\"onSubCountyChange()\"></select>\r\n          </div>\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">City </label>\r\n          <div class=\"controls\">\r\n            <select ng-model=\"address.place\" style=\"text-transform: capitalize;\" ng-options=\"item as item._id.place for item in places | filter:emptyOrNull\"></select>\r\n          </div>\r\n          <!-- ng-change=\"getZipDataTwo()\" -->\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Voter District (click if incorrect) </label>\r\n          <div class=\"controls\">\r\n            <select ng-model=\"address.voterDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item.voterDistrictName for item in voterDistricts | unique:\'voterDistrictName\' track by item.voterDistrictName\"\r\nng-change=\"onVoterDistChange()\"></select>\r\n          </div>\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">Federal Congressional District (click if incorrect) </label>\r\n          <div class=\"controls\">\r\n            <select ng-model=\"address.federalCongrassionalDist\" style=\"text-transform: capitalize;\" ng-options=\"item as item.federalCongrassionalDist for item in federalCongrassionalDist | unique:\'federalCongrassionalDist\' track by item.federalCongrassionalDist\"></select>\r\n          </div>\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">State Senate District (click if incorrect) </label>\r\n          <div class=\"controls\">\r\n            <select ng-model=\"address.stateSenateDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item.stateSenateDistrict for item in stateSenateDistrict | unique:\'stateSenateDistrict\' track by item.stateSenateDistrict\"></select>\r\n          </div>\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">State House of Representative District (click if incorrect) </label>\r\n          <div class=\"controls\">\r\n            <select ng-model=\"address.stateHouseOFRepresentativeDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item.stateHouseOFRepresentativeDistrict for item in stateHouseOFRepresentativeDistricts | unique:\'stateHouseOFRepresentativeDistrict\' track by item.stateHouseOFRepresentativeDistrict\"></select>\r\n          </div>\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\">School District Name (click if incorrect) </label>\r\n          <div class=\"controls\">\r\n            <select ng-model=\"address.unifiedSchoolDistrictName\" style=\"text-transform: capitalize;\" ng-options=\"item as item.unifiedSchoolDistrictName for item in unifiedSchoolDistrictNames | unique:\'unifiedSchoolDistrictName\' track by item.unifiedSchoolDistrictName\"></select>\r\n          </div>\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <p>\r\n            Don\'t\r\n            know\r\n            your\r\n            info?\r\n            <a ng-click=\"showFindAddress();\" class=\"ylink\">Click Here</a>\r\n            <!--<a href=\"http://www.melissadata.com/lookups/addressverify.asp\" target=\"_blank\" class=\"link\">MelissaData</a> -->\r\n          </p>\r\n        </div>\r\n        <div style=\"clear: both;\">\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div style=\"clear: both;\">\r\n    </div>\r\n    <br/>\r\n    <button ng-click=\"LoginWithFacebook()\" type=\"button\" class=\"btn btn-primary\" style=\"float: left;width: 260px\"> Sign Up Using Facebook</button>\r\n    <div style=\"clear: both;\">\r\n    </div>\r\n    <!-- Continue To -->\r\n    <p ng-if=\"!HideRegisterButton && !HideNewRegisterButton\">\r\n      <button ng-click=\"ShowFB()\" type=\"button\" class=\"btnB275\" style=\"float: left;width: 200px\"> Regular Signup</button>\r\n    </p>\r\n  </fieldset>\r\n  <div style=\"clear: both;\">\r\n  </div>\r\n</form>\r\n<br><br>\r\n<hr><br><br>\r\n<h3>\r\n  <center>See Our Privacy Policy\r\n  </center>\r\n</h3>\r\n<center>\r\n  <a href=\"#!/privacyPolicy\">\r\n        <button class=\"compareBtn\">\r\n          <b>Privacy</b>\r\n        </button>\r\n      </a>\r\n</center>\r\n\r\n<script type=\"text/javascript\">\r\n  jQuery(document).ready(function () {\r\n    // binds form submission and fields to the validation engine\r\n    // binds form submission and fields to the validation engine\r\n    setTimeout(function () {\r\n      $(\"form\").validationEngine();\r\n    }, 500);\r\n  });\r\n\r\n</script>\r\n");
$templateCache.put("app/popups/update_politician_office.html","<style type=\"text/css\">  /*\r\n.ac-container {\r\n    top: 100% !important;\r\n    left: 0px !important;\r\n}           */\r\n</style>\r\n<div ng-controller=\"UpdatePoliticianOfficeCtrl\">\r\n    <form name=\"oupdateform\" ng-if=\"!ShowAdd\" id=\"oupdateform\">\r\n        <div >\r\n            <p>Update Record</p>\r\n            <div class=\"control-group\">\r\n                <label class=\"control-label\" for=\"email\">What level of government?</label>\r\n                <select ng-model=\"User.level\" style=\"text-transform: capitalize;\" ng-options=\"item as item for item in levelOfGovt track by item\" ng-change=\"govLevelChanged(\'running\')\">\r\n                </select>\r\n            </div>\r\n            <div class=\"control-group\" ng-if=\"running_flagShowStateDropdown\">\r\n                <label class=\"control-label\" for=\"email\"> Select State: (if applicable)</label>\r\n                <select ng-model=\"User.state\" style=\"text-transform: capitalize;\" ng-options=\"item.state for item in states track by item.statePostalCode\" ng-change=\"onStateChange(\'running\')\">\r\n                </select>\r\n                <!-- ng-change=\"getCounties(\'cur\')\" -->\r\n            </div>\r\n            <div class=\"control-group\" ng-if=\"editflagShowOfficeDropdown\">\r\n                <label class=\"control-label\" for=\"email\"> What Office? </label>\r\n                <select ng-model=\"User.off_name\" style=\"text-transform: capitalize;\" ng-options=\"item as item for item in showlevelOfGovt track by item\" ng-change=\"onOfficeChange(\'running\')\">\r\n                </select>\r\n            </div>\r\n            <div class=\"control-group\" ng-if=\"User.from_date\">\r\n                <label class=\"control-label\" for=\"email\">From Date</label>\r\n                <input type=\"date\" ng-model=\"User.from_date\" class=\"validate[required]\">\r\n            </div>\r\n            <div class=\"control-group\" ng-if=\"User.end_date\">\r\n                <label class=\"control-label\" for=\"email\">To Date</label>\r\n                <input type=\"date\" ng-model=\"User.end_date\" class=\"validate[required]\">\r\n            </div>\r\n            <!-- <div class=\"control-group\" ng-if=\"User.Candidates.name==\'Other\'\">\r\n                <label class=\"control-label\" for=\"email\">Office Name?</label>\r\n                <input type=\"text\" ng-model=\"User.office_name\" class=\"form-control validate[required] input-md text-input\">\r\n            </div>\r\n            <div class=\"control-group\" ng-if=\"User.Candidates.name==\'Other\'\">\r\n                <label class=\"control-label\" for=\"email\">Office Location</label>\r\n                <input type=\"text\" ng-model=\"User.office_location\" class=\"form-control validate[required] input-md text-input\">\r\n            </div> -->\r\n            <div style=\"clear: both;\"></div>\r\n            <div class=\"btn-style\">\r\n                <button ng-click=\"UpdateOffice()\" type=\"button\" class=\"btn btn-success\" ng-disabled=\"RegisterButton\" style=\"float: right;\">Update</button>\r\n            </div>\r\n            <div style=\"clear: both;\"></div>\r\n        </div>\r\n    </form>\r\n    <form name=\"oupdateform\" ng-if=\"ShowAdd\" id=\"oupdateform\">\r\n        <div class=\"control-group\">\r\n            <label class=\"control-label\" for=\"email\">Are you candidate for upcoming election?</label>\r\n            <div class=\"controls\">\r\n                <label>\r\n                    <input type=\"radio\" ng-model=\"User.isInCurrentOffice\" value=\"0\"> Yes\r\n                </label>\r\n                <label>\r\n                    <input type=\"radio\" ng-model=\"User.isInCurrentOffice\" value=\"1\"> No\r\n                </label>\r\n            </div>\r\n        </div>\r\n        <div ng-if=\"User.isInCurrentOffice == 1\">\r\n            <div class=\"control-group\">\r\n                <label class=\"control-label\" for=\"email\">What level of government?</label>\r\n                <select ng-model=\"User.cur_level\" style=\"text-transform: capitalize;\" ng-options=\"item as item for item in levelOfGovt\" ng-change=\"govLevelChanged(\'incumbent\')\">\r\n                </select>\r\n            </div>\r\n            <div class=\"control-group\" ng-if=\"flagShowStateDropdown\">\r\n                <label class=\"control-label\" for=\"email\"> Select State: (if applicable)</label>\r\n                <select ng-model=\"User.cur_state\" style=\"text-transform: capitalize;\" ng-options=\"item as item.state for item in states\" ng-change=\"onStateChange(\'incumbent\')\">\r\n                </select>\r\n                <!-- ng-change=\"getCounties(\'cur\')\" -->\r\n            </div>\r\n            <div class=\"control-group\" ng-if=\"flagShowOfficeDropdown\">\r\n                <label class=\"control-label\" for=\"email\"> What Office? </label>\r\n                <select ng-model=\"User.cur_off_name\" style=\"text-transform: capitalize;\" ng-options=\"item as item for item in showlevelOfGovt\" ng-change=\"onOfficeChange(\'incumbent\')\">\r\n                </select>\r\n            </div>\r\n           <div class=\"control-group\" ng-if=\"User.cur_Candidates.name==\'Other\'\">\r\n                <label class=\"control-label\" for=\"email\">Office Name?</label>\r\n                <input type=\"text\" ng-model=\"User.cur_office_name\" class=\"form-control validate[required] input-md text-input\">\r\n            </div>\r\n            <div class=\"control-group\" ng-if=\"User.cur_Candidates.name==\'Other\'\">\r\n                <label class=\"control-label\" for=\"email\">Office Location</label>\r\n                <input type=\"text\" ng-model=\"User.cur_office_location\" class=\"form-control validate[required] input-md text-input\">\r\n            </div>\r\n           \r\n            <div style=\"clear: both;\"></div>\r\n            <div class=\"btn-style\">\r\n                <button ng-click=\"AddNewOffice(\'incumbent\')\" type=\"button\" class=\"btnShort-style\" ng-disabled=\"RegisterButton\" style=\"float: right;\">Save</button>\r\n            </div>\r\n            <div style=\"clear: both;\"></div>\r\n        </div>\r\n        <div ng-if=\"User.isInCurrentOffice == 0\">\r\n            <div class=\"control-group\">\r\n                <label class=\"control-label\" for=\"email\">What level of government?</label>\r\n                <select ng-model=\"User.level\" style=\"text-transform: capitalize;\" ng-options=\"item as item for item in levelOfGovt\" ng-change=\"govLevelChanged(\'running\')\">\r\n                </select>\r\n            </div>\r\n            <div class=\"control-group\" ng-if=\"running_flagShowStateDropdown\">\r\n                <label class=\"control-label\" for=\"email\"> Select State: (if applicable)</label>\r\n                <select ng-model=\"User.state\" style=\"text-transform: capitalize;\" ng-options=\"item as item.state for item in states\" ng-change=\"onStateChange(\'running\')\">\r\n                </select>\r\n                <!-- ng-change=\"getCounties(\'cur\')\" -->\r\n            </div>\r\n            <div class=\"control-group\" ng-if=\"running_flagShowOfficeDropdown\">\r\n                <label class=\"control-label\" for=\"email\"> What Office? </label>\r\n                <select ng-model=\"User.off_name\" style=\"text-transform: capitalize;\" ng-options=\"item as item for item in showlevelOfGovt\" ng-change=\"onOfficeChange(\'running\')\">\r\n                </select>\r\n            </div>\r\n            <div class=\"control-group\" ng-if=\"User.Candidates.name==\'Other\'\">\r\n                <label class=\"control-label\" for=\"email\">Office Name?</label>\r\n                <input type=\"text\" ng-model=\"User.office_name\" class=\"form-control validate[required] input-md text-input\">\r\n            </div>\r\n            <div class=\"control-group\" ng-if=\"User.Candidates.name==\'Other\'\">\r\n                <label class=\"control-label\" for=\"email\">Office Location</label>\r\n                <input type=\"text\" ng-model=\"User.office_location\" class=\"form-control validate[required] input-md text-input\">\r\n            </div>\r\n             <div class=\"control-group\">\r\n                <label class=\"control-label\" for=\"email\">From Date</label>\r\n                <input type=\"date\" ng-model=\"User.from_date\" class=\"validate[required]\">\r\n            </div>\r\n            <div class=\"control-group\">\r\n                <label class=\"control-label\" for=\"email\">To Date</label>\r\n                <input type=\"date\" ng-model=\"User.end_date\" class=\"validate[required]\">\r\n            </div>\r\n            <div style=\"clear: both;\"></div>\r\n            <div class=\"btn-style\">\r\n                <button ng-click=\"AddNewOffice(\'running\')\" type=\"button\" class=\"btnShort-style\" ng-disabled=\"RegisterButton\" style=\"float: right;\">Save</button>\r\n            </div>\r\n            <div style=\"clear: both;\"></div>\r\n        </div>\r\n\r\n    </form>\r\n</div>\r\n<script type=\"text/javascript\">\r\njQuery(document).ready(function() {\r\n    // binds form submission and fields to the validation engine\r\n    // binds form submission and fields to the validation engine\r\n    setTimeout(function() {\r\n        $(\"form\").validationEngine();\r\n    }, 500);\r\n});\r\n</script>\r\n");
$templateCache.put("app/popups/user_localupdate.html","<div ng-controller=\"UpdateUserAddressCtrl\">\r\n  <p ng-if=\"!showNwTitle\">\r\n    Change Your Location\r\n  </p>\r\n\r\n  <p ng-if=\"showNwTitle\">\r\n  Type in your address to see how you match politicians in your district\r\n\r\n  </p>\r\n  <form name=\"oupdateform\" id=\"oupdateform\">\r\n    <div class=\"row\">\r\n\r\n      <div class=\"col-md-12\" ng-show=\"statusGetZipdata == 2 && statusGetStates == 2\">\r\n        <div ng-if=\"showFAddress\">\r\n          <div class=\"control-group\">\r\n\r\n            <label class=\"control-label\" for=\"email\">Zipcode (click if incorrect) </label>\r\n            <input type=\"text\" ng-model=\"address.zipcode\" ng-blur=\"zipCodeChanged()\">\r\n          </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"email\">State (click if incorrect) </label>\r\n              <select ng-model=\"address.state\" style=\"text-transform: capitalize;\" ng-change=\"getCounties()\" ng-options=\"item.state for item in states\" ng-class=\"{yellowBackground: states.length > 1}\"></select>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"email\">County (click if incorrect) </label>\r\n              <select ng-model=\"address.county\" style=\"text-transform: capitalize;\" ng-options=\"item as item.NAMELSAD for item in counties\" ng-change=\"onCountyChange()\" ng-class=\"{yellowBackground: counties.length > 1}\"></select>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"email\">Sub county (click if incorrect) </label>\r\n              <select ng-model=\"address.subcounty\" style=\"text-transform: capitalize;\" ng-options=\"item as item.NAMELSAD for item in subCounties\" ng-change=\"onSubCountyChange()\" ng-class=\"{yellowBackground: subCounties.length > 1}\"></select>\r\n            </div>\r\n            {{places}}\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"email\">City (click if incorrect) </label>\r\n              <select ng-model=\"address.place\" style=\"text-transform: capitalize;\" ng-options=\"item as item.placeName for item in places\" ng-class=\"{yellowBackground: places.length > 1}\"></select>\r\n              <!-- ng-change=\"getZipDataTwo()\" -->\r\n            </div>\r\n            <!-- <div class=\"control-group\">\r\n            <label class=\"control-label\" for=\"email\">Voter District (click if incorrect) </label>\r\n            <select ng-model=\"address.voterDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item.name for item in voterDistricts\" ng-change=\"onVoterDistChange()\" ng-class=\"{yellowBackground: voterDistricts.length > 1}\"></select>\r\n          </div> -->\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"email\">Federal Congressional District (click if incorrect) </label>\r\n              <select ng-model=\"address.federalCongrassionalDist\" style=\"text-transform: capitalize;\" ng-options=\"item as item.CD115FP for item in federalCongrassionalDist\" ng-class=\"{yellowBackground: federalCongrassionalDist.length > 1}\"></select>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"email\">State Senate District (click if incorrect) </label>\r\n              <select ng-model=\"address.stateSenateDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item.NAMELSAD for item in stateSenateDistrict\" ng-class=\"{yellowBackground: stateSenateDistrict.length > 1}\"></select>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"email\">State Legislative District (click if incorrect) </label>\r\n              <select ng-model=\"address.stateLegislativeDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item.NAMELSAD for item in stateLegislativeDistrict track by item.NAMELSAD\" ng-class=\"{yellowBackground: stateLegislativeDistrict.length > 1}\"></select>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"email\">School District Name (click if incorrect) </label>\r\n              <select ng-model=\"address.schoolDistrict\" style=\"text-transform: capitalize;\" ng-options=\"item as item.NAME for item in schoolDistricts\" ng-class=\"{yellowBackground: schoolDistricts.length > 1}\"></select>\r\n            </div>\r\n            <div style=\"clear: both;\"></div>\r\n            <div class=\"btn-style\">\r\n              <button ng-if=\"!forFacebook\" ng-click=\"updateAddress(address)\" type=\"button\" class=\"btnShort-style\" ng-disabled=\"RegisterButton\" style=\"float: right;\">Save</button>\r\n            </div>\r\n            <div style=\"clear: both;\"></div>\r\n            <!--      <p>\r\n            Don\'t know your info? Try going to this outside site for help. <a href=\"javascript: void(0);\" ng-click=\"showFindAddress();\" class=\"link\">Click Here</a>\r\n            <a href=\"http://www.melissadata.com/lookups/addressverify.asp\" target=\"_blank\" class=\"link\">MelissaData</a>\r\n\r\n          </p>\r\n    -->\r\n\r\n\r\n          </div>\r\n\r\n          <div ng-if=\"!showFAddress\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\">Street Address (leave out Apt #)</label>\r\n              <div class=\"control-group\">\r\n                <input type=\"text\" id=\"address\" ng-model=\"User.Address\" ng-keyup=\"detectAddress($event)\" class=\"zipInput form-control\" />&nbsp;\r\n            </div>\r\n              </div>\r\n\r\n              <!-- Drop down -->\r\n\r\n              <div ng-if=\"showAddressDrop\">\r\n                <div class=\"control-group\">\r\n                  <br>\r\n                  <center>\r\n                    <button ng-click=\"setAddressNew(Location)\" type=\"button\" class=\"btn2Short-style widthAuto btn-success\">Save</button>\r\n                  </center>\r\n                  <br>\r\n                  <p>Check the answers. Boxes labelled with yelow have mutliple possibilities. Make sure to pick the\r\n                    right ones.</p>\r\n                  <label class=\"control-label formLabel removeTopMargin\" for=\"email\">State </label>\r\n                  <div class=\"controls\">\r\n                    <select ng-model=\"Location.state\" style=\"text-transform: capitalize;\" ng-init=\"Location.state = allstatesData[0]\" ng-options=\"item.state for item in allstatesData track by item.stateFips\" ng-class=\"checkLen(allstatesData, \'state\')\"></select>\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"email\">County </label>\r\n                  <div class=\"controls\">\r\n                    <select ng-model=\"Location.county\" style=\"text-transform: capitalize;\"  ng-options=\"item.countyName for item in allcounties track by item.countyFips\" ng-class=\"checkLen(allcounties, \'county\')\"></select>\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"email\">City </label>\r\n                  <div class=\"controls\">\r\n                    <select ng-model=\"Location.place\" style=\"text-transform: capitalize;\"  ng-options=\"item as item.placeName for item in places track by item.place\" ng-class=\"checkLen(places, \'place\')\"></select>\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"email\">Federal Congressional District (click if incorrect) </label>\r\n                  <div class=\"controls\">\r\n                    <select ng-model=\"Location.federalCongrassionalDist\" style=\"text-transform: capitalize;\" ng-init=\"Location.federalCongrassionalDist = federalCongrassionalDist[0]\" ng-options=\"item as item.CD115FP for item in federalCongrassionalDist track by item.CD115FP\" ng-class=\"checkLen(federalCongrassionalDist, \'federalCongrassionalDist\')\"></select>\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"email\">State Senate District (click if incorrect) </label>\r\n                  <div class=\"controls\">\r\n                    <select ng-model=\"Location.stateSenateDistrict\" style=\"text-transform: capitalize;\" ng-init=\"Location.stateSenateDistrict = stateSenateDistrict[0]\" ng-options=\"item as item.NAMELSAD for item in stateSenateDistrict track by item.SLDUST\" ng-class=\"checkLen(stateSenateDistrict, \'stateSenateDistrict\')\"></select>\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"email\">State House of Representative District (click if incorrect) </label>\r\n                  <div class=\"controls\">\r\n                    <select ng-model=\"Location.stateHouseOFRepresentativeDistrict\" style=\"text-transform: capitalize;\" ng-init=\"Location.stateHouseOFRepresentativeDistrict = stateHouseOFRepresentativeDistricts[0]\" ng-options=\"item as item.NAMELSAD for item in stateHouseOFRepresentativeDistricts track by item.NAMELSAD\" ng-class=\"checkLen(stateHouseOFRepresentativeDistricts, \'stateHouseOFRepresentativeDistrict\')\"></select>\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\" ng-if=\"cityCouncilDistrict.length > 0\">\r\n  <label class=\"control-label formLabel\" for=\"email\">City Council District Name(click if incorrect) </label>\r\n  <div class=\"controls\">\r\n    <select\r\n      ng-model=\"Location.cityCouncilDistrict\"\r\n      style=\"text-transform: capitalize\"\r\n      ng-options=\"item as item.COUNTDIST for item in cityCouncilDistrict track by item.COUNTDIST\"\r\n      ng-class=\"checkLength(cityCouncilDistrict, \'cityCouncilDistrict\')\"\r\n    ></select>\r\n  </div>\r\n</div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"email\">School District Name (click if incorrect) </label>\r\n                  <div class=\"controls\">\r\n                    <select ng-model=\"Location.unifiedSchoolDistrictName\" ng-init=\"Location.unifiedSchoolDistrictName = unifiedSchoolDistrictNames[0]\" style=\"text-transform: capitalize;\" ng-options=\"item as item.NAME for item in unifiedSchoolDistrictNames track by item.NAME\" ng-class=\"checkLen(unifiedSchoolDistrictNames, \'unifiedSchoolDistrictName\')\"></select>\r\n                  </div>\r\n                </div><br>\r\n                <center>\r\n                  <button ng-click=\"setAddressNew(Location)\" type=\"button\" class=\"btn2Short-style widthAuto btn-success\">This Looks Correct</button>\r\n                </center>\r\n\r\n                <br><br>\r\n                <!-- <center>\r\n                  <a href=\"javascript: void(0);\" ng-click=\"showFindAddress();\" class=\"btn2Short-style widthAuto btn-success\">Try the zip code tool instead</a>\r\n                </center> -->\r\n                <!-- <a href=\"http://www.melissadata.com/lookups/addressverify.asp\" target=\"_blank\" class=\"link\">MelissaData</a> -->\r\n\r\n              </div>\r\n            </div>\r\n            <div style=\"clear: both;\"></div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-md-12\" ng-show=\"statusGetZipdata == 1 || statusGetStates == 1\">\r\n        <p>Loading ...</p>\r\n      </div>\r\n      <div class=\"col-md-12\" ng-show=\"statusGetZipdata == 3 || statusGetStates == 3\">\r\n        <p>Something went wrong.</p>\r\n      </div>\r\n  </form>\r\n</div>\r\n<script type=\"text/javascript\">\r\n  /*jQuery(document).ready(function () {\r\n                // binds form submission and fields to the validation engine\r\n                // binds form submission and fields to the validation engine\r\n                setTimeout(function(){\r\n                    $(\"form\").validationEngine();\r\n                }, 500);\r\n            });*/\r\n\r\n</script>\r\n");
$templateCache.put("app/popups/view_old_answers.html","<div ng-repeat=\"item in ngDialogData\">\r\n	Date : {{item.created | date : \"medium\"}} <br>\r\n	Answer : {{QuestionAnsArray[item.answer]}} <br>\r\n	Importance : {{QuestionImpArray[item.importance]}} <br>\r\n	Reason : {{item.reason}}\r\n	<hr ng-if=\"!$last\">\r\n</div>");
$templateCache.put("app/postingHints/postingHints.html","\r\n<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">Posting Hints</h2>\r\n  <p class=\"pageSubHeading\">Here are a few hits to make your posting easier.</p>\r\n	<p><center><h3><b>How to bring in material from other websites:</b></h3></center></p>\r\n<p><b>Most websites:</b> Copy and paste the URL of the page.  Depending upon the programming language and the site designers, a place holder image will be visible on your post. This placeholder image could be an image that represents the article on the page you picked, or it could represent the site as a whole.  If other users click on this, they will be taken to that webpage.</p>\r\n<p><b>YouTube or Vimeo videos: </b>Copy and paste the URL of the clip to your VoteWise post and the video along with play controls will be imbedded in your post.</p>\r\n<p><b>Facebook posts</b> – In Facebook, click on the post you want to copy.  Then click on the “embed” button at the bottom- center- right of the Facebook popup.  Then copy the iframe coding they give you. Then paste that iframe coding into your VoteWise post.   This won’t work on “Private” Facebook posts.</p>\r\n<p><b>Giphy - </b>Copying the  URL won’t work.  You have to go to the icon next to the clip that says “Copy Link” then copy and paste the top link to your VoteWise post</p>\r\n<p><b>Gifng – </b>Won’t work.</p>\r\n<p><b>Gfycat –</b> Won’t work</p>\r\n<p><b>Tumblr-</b>Won’t work</p>\r\n<p><b>Gifxdx – </b>Won’t work</p>\r\n<p><b>i.pinimg –</b> Won’t work</p>\r\n\r\n\r\n\r\n");
$templateCache.put("app/postOnFaceBook/postOnFaceBook.html","<div class=\"container-fluid\">\r\n  <h2 class=\"pageHeading\" style=\"text-transform: capitalize;\">POST TO FACEBOOK</h2>\r\n  <div class=\"pageSubHeading\">You are now ready to post your quiz to Facebook. If you want, you can add your own message\r\n    to post with the quiz on your Timeline. </div>\r\n\r\n  <center>\r\n\r\n    <!-- <div>\r\n      <div style=\"width:15%; float:left;\">Message: </div>\r\n      <div style=\"width:84%; float:left;\" class=\"blackText\">\r\n        <textarea ng-model=\"fb.message\" style=\"width:100%; height: 100px;\"></textarea>\r\n      </div>\r\n    </div> -->\r\n    <div style=\"clear:both;\"></div>\r\n    <div>\r\n      <div style=\"width:15%; float:left;\">&nbsp;</div>\r\n      <div style=\"width:84%;\">\r\n        <input type=\"button\" class=\"btn\" ng-click=\"postFB(fb.message)\" value=\"Post Quiz to Facebook*\" />\r\n        <br>\r\n        <br>\r\n        <br>\r\n        <!-- <input type=\"button\" class=\"btn\" ng-click=\"checkSSR()\" value=\"SSR\" /> -->\r\n\r\n\r\n      </div>\r\n        <div style=\"margin-top: 5%\">\r\n          <p style=\"font-size: 25px\"><b>*Note:</b>When it posts to Facebook, you NEED to write in the subject area what this quiz is about in order to get your friends to answer it.  The automatic parts of the post will just say \"Take a fun five minute quiz to figure out who to vote for in your local elections.\"</p>\r\n        </div>\r\n      </div>\r\n      <div style=\"clear:both;\"></div>\r\n    </div>\r\n    <!-- &nbsp;<i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"DisplayFPostLoader\"></i> -->\r\n<script>\r\n  \r\n</script>");
$templateCache.put("app/pressComment/pressComment.html","<link rel=\"stylesheet\" type=\"text/css\" href=\"./pressProfile/pressProfile.css\">\r\n<div>\r\n    <p><a href=\"#!/presshome\">Press</a> </p>\r\n</div>\r\n<p>\r\n    <h2><center>{{pressName}}</center></h2></p>\r\n\r\n<div class=\"inline2\" ng-if=\"essayComments.length==0\">\r\nThere are no comments available.\r\n</div>\r\n<div class=\"inline2\">\r\n\r\n   <table style=\"width:100%\" ng-if=\"essayComments.length > 0\" ng-repeat=\"comment in essayComments track by $index\">\r\n\r\n  <tr>\r\n    <th colspan=\"2\">{{comment.createdOn | date:\'medium\'}}</th>\r\n      </tr>\r\n  <tr>\r\n      <td  width=\"10%;\">\r\n<img src=\"../assets/images/profile/{{comment.createdBy.utype}}.svg\" style=\"width: 30px; height:30px;\" class= \"usertype\" alt=\"Politician\" ng-if=\"comment.createdBy.utype!=\'admin\'\"/>\r\n<img src=\"../assets/images/profile/voter.svg\" style=\"width: 30px; height:30px;\" class= \"usertype\" alt=\"Politician\" ng-if=\"comment.createdBy.utype==\'admin\'\"/>\r\n<br> <a href =\"#!/publicProfile/{{comment.createdBy.id}}\">{{comment.createdBy.name}}</a>  </td>\r\n     \r\n    <td>\r\n        <div ng-bind-html=\'comment.comments | urlify\'></div>\r\n        <br>\r\n        <div style=\"text-align: left;\"> \r\n            <i class=\"fa fa-thumbs-up thumbs\" ng-click=\"updateComments(\'like\', comment._id, $index);\" style=\"cursor:pointer;\" alt=\"Like\">\r\n            {{comment.totalLikes}}</i>\r\n            <i class=\"fa fa-thumbs-down thumbs\" ng-click=\"updateComments(\'dislike\', comment._id, $index);\" style=\"cursor:pointer;\" alt=\"Dislike\"> \r\n            {{comment.totalDislike}}</i> \r\n            <i class=\"fa fa-exclamation-triangle thumbs\"class=\"tabletools\" ng-click=\"updateComments(\'spam\', comment._id, $index);\" style=\"cursor:pointer; color:red;\" alt=\"Report Abuse\"> \r\n            {{comment.totalSpam}}</i> \r\n        </div>\r\n    </td>\r\n    </tr> \r\n    </table>\r\n\r\n    \r\n  </div>\r\n\r\n<div class=\"inline2\" style=\"width: 90%; margin: auto;\">\r\n    <div class=\"inline2\" ng-if=\"ShowComments\">\r\n        <form name=\"essayform\" id=\"essayform\">\r\n            <fieldset class=\"scheduler-border\">\r\n                <legend class=\"scheduler-border\">Your Comments</legend>\r\n                <p></p>\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-12\">\r\n                        <div class=\"control-group\">\r\n                            <div class=\"controls\">\r\n                                <textarea id=\"comments\" ng-model=\"comments.content\" placeholder=\"\" data-errormessage=\"Comments is required.\" class=\"form-control input-md  validate[required] text-area\" style=\"width: 80%; height: 100px;\"></textarea>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <div style=\"clear: both;\"></div>\r\n                    <div style=\"margin-top:20px;\">\r\n                        <button ng-click=\"SubmitComment(comments)\" type=\"button\" class=\"btn btn-success\" ng-disabled=\"CommentButton\" style=\"float: left;\">Submit Comments</button>\r\n                        &nbsp;&nbsp;&nbsp;&nbsp;\r\n                        <button ng-click=\"goBack();\" type=\"button\" style=\"float: left;\">Cancel</button>\r\n                        <div style=\"clear: both;\"></div>\r\n                    </div>\r\n                    <div style=\"clear: both;\"></div>\r\n                </div>\r\n            </fieldset>\r\n        </form>\r\n    </div>\r\n    <center>\r\n        <button ng-click=\"redirectToComment();\" ng-if=\"displayComments\">Add comment</button>\r\n    </center>\r\n</div>");
$templateCache.put("app/pressEssayDetails/essayDetails.html","<!-- <link rel=\"stylesheet\" type=\"text/css\" href=\"./essayDetails/essayDetails.css\"> -->\r\n<div>\r\n    <p><a href=\"#!/learnHome\">Post</a> > <a href=\"#!/essay/{{categoryId}}/home\"> {{category.title}} </a> </p>\r\n</div>\r\n<p>\r\n    <h2><center>{{essay.title}}</center></h2></p>\r\n<div class=\"inline2\">\r\n    <p class=\"DescrImg\" ng-if=\"essay.mediaType==\'Text\'\" ng-bind-html=\"essay.description | to_trusted\"></p>\r\n    <div ng-if=\"essay.mediaType!=\'Text\'\">\r\n        <p class=\"DescrImg\">{{essay.description}}</p>\r\n        <p></p>\r\n        <div ng-if=\"essay.mediaType==\'Video\'\" ng-bind-html=\'CheckUrl(essay.mediaFile, \"V\")\' style=\"text-align:center;\"></div>\r\n        <div ng-if=\"essay.mediaType==\'Audio\'\" ng-bind-html=\'CheckUrl(essay.mediaFile, \"A\")\' style=\"text-align:center;\"></div>\r\n        <p ng-if=\"essay.mediaType==\'Stills\'\" style=\"text-align: center;\">\r\n            <img ng-src=\"{{GalleryFolder}}/{{essay.mediaFile}}\" />\r\n        </p>\r\n    </div>\r\n    <!-- Geo Proximity tab -->\r\n</div>\r\n<div style=\"clear:both;\"></div>\r\n<div class=\"inline2\">\r\n<hr size=\"5\" noshade=\"\">\r\n<h3>Take a quick vote: </h3>\r\n<p>Recommended : <input-stars max=\"5\" ng-click=\"EssayVote(\'Recommended\');\" ng-model=\"vote.recommend\"></input-stars>\r\n<br/>Factual : <input-stars max=\"5\" ng-click=\"EssayVote(\'Factual\');\" ng-model=\"vote.factual\"></input-stars></p>\r\n</div>\r\n\r\n<div style=\"clear:both;\"></div>\r\n\r\n<div class=\"inline2\">\r\n    <hr size=\"5\" noshade=\"\"> Comments:\r\n    <center>\r\n        <button ng-click=\"redirectToComment();\" ng-if=\"displayComments\">Add comment</button>\r\n    </center>\r\n    <div class=\"inline2\" ng-if=\"ShowComments\">\r\n        <form name=\"essayform\" id=\"essayform\">\r\n            <fieldset class=\"scheduler-border\">\r\n                <legend class=\"scheduler-border\">Your Comments</legend>\r\n                <p></p>\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-12\">\r\n                        <div class=\"control-group\">\r\n                            <div class=\"controls\">\r\n                                <textarea id=\"comments\" ng-model=\"comments.content\" placeholder=\"\" data-errormessage=\"Comments is required.\" class=\"form-control input-md  validate[required] text-area\"></textarea>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <div style=\"clear: both;\"></div>\r\n                    <div style=\"margin-top:20px;\">\r\n                        <button ng-click=\"SubmitComment(comments)\" type=\"button\" class=\"btn btn-success\" ng-disabled=\"CommentButton\" style=\"float: left;\">Submit Comments</button>\r\n                        &nbsp;&nbsp;&nbsp;&nbsp;\r\n                        <button ng-click=\"goBack();\" type=\"button\" style=\"float: left;\">Cancel</button>\r\n                        <div style=\"clear: both;\"></div>\r\n                    </div>\r\n                    <div style=\"clear: both;\"></div>\r\n                </div>\r\n            </fieldset>\r\n        </form>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"inline2\">\r\n\r\n   <table style=\"width:100%\" ng-repeat=\"comment in essayComments track by $index\">\r\n\r\n  <tr>\r\n    <th colspan=\"2\">{{comment.createdOn | date:\'medium\'}}</th>\r\n      </tr>\r\n  <tr>\r\n\r\n    <td  width=\"10%;\">\r\n        <img src=\"../assets/images/profile/{{comment.createdBy.utype}}.svg\" style=\"width: 30px; height:30px;\" class= \"usertype\" alt=\"Politician\" ng-if=\"comment.createdBy.utype!=\'admin\'\"/>\r\n        <img src=\"../assets/images/profile/voter.svg\" style=\"width: 30px; height:30px;\" class= \"usertype\" alt=\"Politician\" ng-if=\"comment.createdBy.utype==\'admin\'\"/>\r\n        <br>\r\n        <a href =\"#!/publicProfile/{{comment.createdBy.id}}\">\r\n            {{comment.createdBy.name}}\r\n            <span ng-if=\"comment.createdBy.orgdata\">({{comment.createdBy.orgdata.title}})</span>\r\n        </a>\r\n    </td>\r\n     \r\n    <td><div ng-bind-html=\'comment.comments | urlify\'></div><br><div style=\"text-align: left;\"> \r\n        <i class=\"fa fa-thumbs-up thumbs\"  ng-click=\"updateComments(\'like\', comment._id, $index);\" style=\"cursor:pointer;\" alt=\"Like\">{{comment.totalLikes}}</i>\r\n        <i class=\"fa fa-thumbs-down thumbs\" ng-click=\"updateComments(\'dislike\', comment._id, $index);\" style=\"cursor:pointer;\" alt=\"Dislike\"> {{comment.totalDislike}}</i> \r\n            <i class=\"fa fa-exclamation-triangle thumbs\" ng-click=\"updateComments(\'spam\', comment._id, $index);\" style=\"cursor:pointer; color:red;\" alt=\"Report Abuse\"> {{comment.totalSpam}}</i> </div></td>\r\n    </tr>\r\n  \r\n       \r\n    </table>\r\n    \r\n\r\n  </div>\r\n\r\n");
$templateCache.put("app/pressEssayStaff/essayStaff.html","<!-- <link rel=\"stylesheet\" type=\"text/css\" href=\"./essayStaff/essayStaff.css\"> -->\r\n<div style=\"width: 100%;\">\r\n    <div style=\"width:90%; margin: auto;\">\r\n        <h3>Essay by Votewise</h3></div>\r\n    <p>\r\n        <h2><center>Search</center></h2>\r\n    </p>\r\n    <div id=\"tfheader\" class=\"searchbox\" ng-if=\"!ShowAdavace\" style=\"padding-left:10px;\">\r\n        <input type=\"text\" class=\"tftextinput\" ng-model=\"search.text\" name=\"q\" size=\"21\" maxlength=\"120\">\r\n        <input type=\"button\" ng-click=\"getEssayListAdvance(search);\" value=\"Essay Search\" class=\"tfbutton\" style=\"margin-left:-4px;\">\r\n        <div class=\"tfclear\"></div>\r\n    </div>\r\n</div>\r\n<br>\r\n<br>\r\n<br>\r\n<div style=\"padding:10px;\">\r\n    <div style=\"width:90%; float: left;\" \">&nbsp;</div>\r\n    <div style=\"width:9%; float: left; text-align: center; \" ng-if=\"searchResults.data.length> 0\">\r\n        <span ng-click=\"showOrder()\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">Sort</span>\r\n    </div>\r\n    <div style=\"clear:both;\"></div>\r\n    <div class=\"OrderList\">\r\n        <div class=\"DisplayCat\" ng-if=\"ShowOrderList\">\r\n            <div class=\"DivClass\">\r\n                <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Most Recent\'\" ng-false-value=\"\'NO\'\">Most Recent\r\n            </div>\r\n            <div class=\"DivClass\">\r\n                <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Oldest\'\" ng-false-value=\"\'NO\'\">Oldest\r\n            </div>\r\n            <div class=\"DivClass\">\r\n                <div class=\"leftClass\">\r\n                    <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Highest Recommended\'\" ng-false-value=\"\'NO\'\">\r\n                </div>\r\n                <div class=\"rightClass\" ng-click=\"ShowUsers(\'HighestRecommended\')\">Highest Recommended&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i></div>\r\n            </div>\r\n            <ul class=\"catList innerCat\" ng-if=\"HighestRecommended\">\r\n                <li>As rated by</li>\r\n                <li ng-repeat=\"user in users track by $index\">\r\n                    <label class=\"checkbox\" title=\"search.recommend\">\r\n                        <input type=\"checkbox\" ng-model=\"search.recommendorder\" ng-true-value=\"\'{{user}}\'\" ng-false-value=\"\'NO\'\"> {{user}}\r\n                    </label>\r\n                </li>\r\n            </ul>\r\n            <div class=\"DivClass\">\r\n                <div class=\"leftClass\">\r\n                    <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Least Recommended\'\" ng-false-value=\"\'NO\'\">\r\n                </div>\r\n                <div class=\"rightClass\" ng-click=\"ShowUsers(\'LeastRecommended\')\">\r\n                    Least Recommended&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i></div>\r\n            </div>\r\n            <ul class=\"catList innerCat\" ng-if=\"LeastRecommended\">\r\n                <li>As rated by</li>\r\n                <li ng-repeat=\"user in users track by $index\">\r\n                    <label class=\"checkbox\" title=\"search.lrecommend\">\r\n                        <input type=\"checkbox\" ng-model=\"search.lrecommendorder\" ng-true-value=\"\'{{user}}\'\" ng-false-value=\"\'NO\'\"> {{user}}\r\n                    </label>\r\n                </li>\r\n            </ul>\r\n            <div class=\"DivClass\">\r\n                <div class=\"leftClass\">\r\n                    <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Most Factual\'\" ng-false-value=\"\'NO\'\">\r\n                </div>\r\n                <div class=\"rightClass\" ng-click=\"ShowUsers(\'MostFactual\')\">Most Factual&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i></div>\r\n            </div>\r\n            <ul class=\"catList innerCat\" ng-if=\"MostFactual\">\r\n                <li>As rated by</li>\r\n                <li ng-repeat=\"user in users track by $index\">\r\n                    <label class=\"checkbox\" title=\"search.factual\">\r\n                        <input type=\"checkbox\" ng-model=\"search.factualorder\" ng-true-value=\"\'{{user}}\'\" ng-false-value=\"\'NO\'\"> {{user}}\r\n                    </label>\r\n                </li>\r\n            </ul>\r\n            <div class=\"DivClass\">\r\n                <div class=\"leftClass\">\r\n                    <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Least Factual\'\" ng-false-value=\"\'NO\'\">\r\n                </div>\r\n                <div class=\"rightClass\" ng-click=\"ShowUsers(\'LeastFactual\')\">Least Factual&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i></div>\r\n            </div>\r\n            <ul class=\"catList innerCat\" ng-if=\"LeastFactual\">\r\n                <li>As rated by</li>\r\n                <li ng-repeat=\"user in users track by $index\">\r\n                    <label class=\"checkbox\" title=\"search.lfactual\">\r\n                        <input type=\"checkbox\" ng-model=\"search.lfactualorder\" ng-true-value=\"\'{{user}}\'\" ng-false-value=\"\'NO\'\"> {{user}}\r\n                    </label>\r\n                </li>\r\n            </ul>\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n    </div>\r\n    <div style=\"clear:both;\"></div>\r\n</div>\r\n<div style=\"padding-right:30px; float:right;\">\r\n    <dir-pagination-controls max-size=\"5\" pagination-id=\"list.id\"></dir-pagination-controls>\r\n</div>\r\n<div class=\"inline2\">\r\n    <div style=\"background-color: #eee; padding:10px; border: solid 1px #000;\" dir-paginate=\"forumthread in searchResults.data | orderBy:sortValues:isreverse | filter : search.text | itemsPerPage : 10\" total-items=\"totalResults\" pagination-id=\"list.id\">\r\n        <!-- <div style=\"background-color: #eee; padding:10px; border: solid 1px #000;\" ng-repeat=\"forumthread in searchResults | orderBy:sortValues:isreverse\" ng-if=\"searchResults.length > 0\"> -->\r\n        <div>\r\n            <div style=\"width:90%; float: left;\">\r\n                <div class=\"boldbox\"> <span ng-click=\"gotoThread(forumthread._id);\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">{{forumthread.title}}</span> </div>\r\n                <div><strong>Recommended :</strong>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.recavg\" ng-if=\"showAvg\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.recavgvoters\" ng-if=\"showVoters\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.recavgpolitician\" ng-if=\"showPolitician\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.recavgadvocate\" ng-if=\"showAdvocate\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.recavgpress\" ng-if=\"showPress\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.recavgfollow\" ng-if=\"showFollow\" readonly></input-stars>\r\n                    , <strong>Factual :</strong>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.factfavg\" ng-if=\"showfAvg\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.factfavgvoters\" ng-if=\"showfVoters\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.factfavgpolitician\" ng-if=\"showfPolitician\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.factfavgadvocate\" ng-if=\"showfAdvocate\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.factfavgpress\" ng-if=\"showfPress\" readonly></input-stars>\r\n                    <input-stars max=\"5\" ng-model=\"forumthread.factfavgfollow\" ng-if=\"showfFollow\" readonly></input-stars>\r\n                </div>\r\n                <div class=\"DescriptionImg\" ng-bind-html=\'forumthread.description | convertHTML\'></div>\r\n                <div> Posted by <a href=\"#!/publicProfile/{{forumthread.createdBy.id}}\">{{forumthread.createdBy.name}}</a> on {{forumthread.createdOn | date:\'medium\'}}</div>\r\n            </div>\r\n            <div style=\"width:9%; float: left; text-align: center;\" ng-if=\"forumthread.createdBy.id==userId\">\r\n                <span ng-click=\"GotoEdit(forumthread._id);\" style=\"text-decoration: underline; cursor: pointer;\">Edit</span>\r\n            </div>\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n    </div>\r\n    <div style=\"background-color: #eee; padding:10px; border: solid 1px #000; height:100px;\" ng-if=\"searchResults.data == 0\">\r\n        No records found.\r\n    </div>\r\n    <div style=\"float:right;\">\r\n        <dir-pagination-controls max-size=\"5\" pagination-id=\"list.id\"></dir-pagination-controls>\r\n    </div>\r\n</div>\r\n<script type=\"text/ng-template\" id=\"field_renderer\">\r\n    <ul class=\"catList\">\r\n        <li>\r\n            <div class=\"catname\" id=\"{{subent._id}}\" ng-if=\"(subent.parentIds.length == 0) && (subent.subcategories)\">\r\n                <input type=\"checkbox\" ng-click=\"getVal(subent)\">\r\n                <label ng-click=\"ChangeShow(subent._id);\">{{::subent.title}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id)==-1\"></i><i class=\"fa fa-caret-right\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id) > -1\"></i></label>\r\n            </div>\r\n            <div class=\"catname\" ng-if=\"(subent.parentIds.length == 0) && (!subent.subcategories)\">\r\n                <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                    <input type=\"checkbox\" ng-click=\"getVal(subent)\"> {{::subent.title}}\r\n                </label>\r\n            </div>\r\n            <label class=\"checkbox\" ng-if=\"subent.parentIds.length > 0 && showSubCat\" title=\"{{subent.title}}\">\r\n                <input type=\"checkbox\" ng-click=\"getVal(subent)\"> {{::subent.title}}\r\n            </label>\r\n            <ul ng-if=\"subent.subcategories\" ng-class=\"subent.parentIds.length == 0 ? \'cmnUL MainCatLi_{{subent._id}}\' : \'\'\">\r\n                <li ng-repeat=\"subent in subent.subcategories track by $index\" ng-include=\"\'field_renderer\'\">\r\n                    <!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                      <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n                    </label> -->\r\n                </li>\r\n            </ul>\r\n        </li>\r\n    </ul>\r\n</script>\r\n");
$templateCache.put("app/pressEssayUpdate/dialogGallery.html","\r\n<p></p>\r\n<h1><center>Upload Media</center></h1>\r\n<p></p>\r\n<div>\r\n	<ul style=\"padding:0; height:50px;\">\r\n	<li class=\"liclass lispecial\" ng-click=\"ChangeMedia(\'U\');\" ><div>Upload Media</div></li>\r\n	<li class=\"liclass\" style=\"width:1%; height:50px;\">|</li>\r\n	<li class=\"liclass lispecial\" ng-click=\"ChangeMedia(\'G\');\"><div>Gallery</div></li>\r\n	</ul>\r\n	<div ng-if=\"uploadMedia\">\r\n		<form name=\"topicform\" id=\"topicform\">\r\n            <fieldset class=\"scheduler-border\">\r\n                <legend class=\"scheduler-border\">Upload file</legend>\r\n                <p><small>File size should not be greater than 1MB.</small></p>\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-12\">\r\n                        <div class=\"control-group\">\r\n                            \r\n                            <div class=\"controls\"><input type=\"file\" file-model=\"uploads.files\" check-file-size=\"\" class=\"form-control input-md text-input\" accept=\"image/x-png, image/gif, image/jpeg, image/jpeg, image/svg+xml\">\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"control-group\" style=\"margin-top:15px; margin-bottom:10px;\" >\r\n                            \r\n                            <div class=\"controls\"><input type=\"button\" ng-click=\"uploadFile();\" value=\"Upload File\">\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </fieldset>\r\n        </form>\r\n	</div>\r\n	<div ng-if=\"Gallery\"> \r\n	<p ng-if=\"MainGallery.length > 0\">\r\n		<p>Select the file then select the url from textbox to insert it in the Description</p>\r\n		<p ng-if=\"ShowPath\">Use Ctrl+C to copy from text box<input type=\"text\" ng-model=\"uploads.path\" style=\"width:100%;\"></p>\r\n		<div style=\"width:100%; max-height: 350px; overflow: scroll;\">\r\n			<span ng-repeat=\"img in MainGallery\" style=\"cursor: pointer; padding:10px;\" ng-click=\"ShowSelectedPath(img.fileName);\"><img src=\"{{GalleryFolder}}/{{img.fileName}}\" style=\"width:100px;\" /></span>\r\n\r\n		</div>\r\n	</p>\r\n	<p ng-if=\"MainGallery.length == 0\">\r\n		There are no files uploaded by you. Click on \"Upload Media\" tab to upload files.\r\n	</p>\r\n	</div>\r\n</div>");
$templateCache.put("app/pressEssayUpdate/essayUpdate.html","<!-- <link rel=\"stylesheet\" type=\"text/css\" href=\"./essayUpdate/essayUpdate.css\"> -->\r\n<p></p>\r\n<h1><center>Update Essay</center></h1>\r\n<p></p>\r\n<center>\r\n    <div class=\"inline2\">\r\n        <form name=\"topicform\" id=\"topicform\">\r\n            <fieldset class=\"scheduler-border\">\r\n                <legend class=\"scheduler-border\">Essay details</legend>\r\n                <p></p>\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-12\">\r\n                        <div class=\"control-group\">\r\n                            <label class=\"control-label\" for=\"title\">Title</label>\r\n                            <div class=\"controls\">\r\n                                <input type=\"text\" ng-model=\"Essay.title\" placeholder=\"\" data-errormessage=\"Title is required.\" style=\"width:50%;\" class=\"form-control input-md  validate[required] text-input\">\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"control-group\">\r\n                            <div class=\"control-label\" for=\"title\">Select Tags</div>\r\n                            <div class=\"DisplayCat\">\r\n                                <div style=\"background-color: #eee; padding:5px;\">All Tags <br><small>(click to select)</small></div>\r\n                                <div ng-repeat=\"subent in subtopics.subcategories track by $index\" ng-include=\"\'field_renderer\'\">Loading...</div>\r\n                                <div ng-if=\"subtopics.subcategories.length == 0\" class=\"loadingSpinner\">\r\n                                    <i class=\"fa fa-refresh fa-spin fa-3x fa-fw\"></i>\r\n                                </div>\r\n                            </div>\r\n                            <div class=\"select buttons\" style=\"padding-left: 20px;\">&nbsp;\r\n                                <!-- <button class=\"btn mover left\" ng-click=\"AddmyCats()\" title=\"Add selected\" ng-disabled=\"!selectedCat.length\"><i class=\"fa fa-arrow-right\" aria-hidden=\"true\"></i></button>\r\n                                <button class=\"btn mover right\" ng-click=\"RemoveCats()\" title=\"Remove selected\" ng-disabled=\"!rmselectedCat.length\">\r\n                                    <i class=\"fa fa-arrow-left\" aria-hidden=\"true\"></i>\r\n                                </button> -->\r\n                            </div>\r\n                            <div class=\"DisplayCat\">\r\n                                <div style=\"background-color: #eee; padding:5px;\">Selected Tags<br><small>(click to remove)</small></div>\r\n                                <ul class=\"catList\">\r\n                                    <li ng-repeat=\"subent in selectedCat track by $index\">\r\n                                        <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                                            <input type=\"checkbox\" ng-click=\"removeVal(subent)\" ng-model=\"selectedAll.id[$index]\" ng-checked=\"selectedCat.indexOf(subnet) > -1\"> {{subent.title}}\r\n                                        </label>\r\n                                    </li>\r\n                                </ul>\r\n                            </div>\r\n                            <div style=\"clear:both;\"></div>\r\n                            <!-- <multi-select ng-model=\"Essay.subcategories\" available=\"subtopics\" selected-label=\"Selected subtopics\" available-label=\"All subtopics\" display=\"r as r.title\" title=\"r as r.title\" config=\"selectConfig\"></multi-select>\r\n                            <div class=\"input-error\" ng-show=\"selectForm.numSelected.$error.min\">\r\n                                Please select at least\r\n                                <ng-pluralize count=\"selectConfig.requiredMin\" when=\"{\'one\': \'one role\', \'other\': \'{} roles\'}\">.\r\n                            </div>\r\n                            <input type=\"hidden\" id=\"reqMin\" ng-model=\"selectConfig.requiredMin\" min=\"1\">-->\r\n                        </div>\r\n                        <div class=\"control-group\">\r\n                            <div class=\"DisplayCat\">\r\n                                <div style=\"background-color: #eee; padding:5px;\">Choose Location<br><small>(click to select)</small></div>\r\n                                <ul class=\"catList\">\r\n                                    <li style=\"padding-bottom:10px;\">\r\n                                        <input type=\"checkbox\" ng-click=\"getLocations(Essay.Locations, \'International\')\" ng-model=\"Essay.Locations\" ng-true-value=\"\'International\'\" ng-false-value=\"\'NO\'\">\r\n                                        <label ng-click=\"ShowAddLocation();\">International&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i></label>\r\n                                        <div style=\"padding-left:20px;\" ng-if=\"AddLocation\">\r\n                                        <div mass-autocomplete>\r\n                                            <input ng-model=\"newlocation.country\" mass-autocomplete-item=\"autocomplete_options\">\r\n                                        </div>\r\n                                        <div style=\"text-align: right;\"><button ng-click=\"AddCountry();\">Add country</button></div>\r\n                                        </div>\r\n                                    </li>\r\n                                    <li>\r\n                                        <input type=\"checkbox\" ng-model=\"Essay.National\" ng-click=\"getLocations(Essay.National, \'National\')\" ng-true-value=\"\'National\'\" ng-false-value=\"\'NO\'\">\r\n                                        <label>National</label>\r\n                                        </i>\r\n                                        <ul class=\"catList\">\r\n                                            <li ng-repeat=\"area in allLocations track by $index\">\r\n                                                <input type=\"checkbox\" ng-click=\"getAreaVal(area, area.state, \'state\')\" ng-disabled=\"checkDisabled(area, area.state, \'state\')\" ng-checked=\"checkDisabled(area, area.state, \'state\')\">\r\n                                                <label ng-click=\"getCounties(area.statePostalCode)\">{{area.state}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoading.indexOf(area.statePostalCode)==-1\"></i> <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoading.indexOf(area.statePostalCode) > -1\"></i></label>\r\n                                                <!-- Display Counties -->\r\n                                                <ul class=\"catList\">\r\n                                                    <li ng-repeat=\"county in allCounties[area.statePostalCode] track by $index\">\r\n                                                        <input type=\"checkbox\" ng-click=\"getAreaVal(county._id, area.state, \'county\')\" ng-disabled=\"checkDisabled(county._id, area.state, \'county\')\" ng-checked=\"checkDisabled(county._id, area.state, \'county\')\">\r\n                                                        <label ng-click=\"getLocals(area.statePostalCode, county._id.county)\">{{county._id.county}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoadingCounty.indexOf(county._id.county) == -1\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingCounty.indexOf(county._id.county) > -1\"></i></label>\r\n                                                        <!-- Display Locals and sub counties -->\r\n                                                        <ul class=\"catList\" ng-if=\"Essay.location!=\'National\'\">\r\n                                                            <li ng-repeat=\"local in allLocals[area.statePostalCode][county._id.county] track by $index\">\r\n                                                                <label class=\"checkbox\" title=\"{{local._id.place}}\">\r\n                                                                    <input type=\"checkbox\" ng-click=\"getAreaVal(local._id, area.state, \'local\')\" ng-disabled=\"disabledLocation.indexOf(local._id) > -1 ? true : false\" ng-checked=\"disabledLocation.indexOf(local._id) > -1 ? true : false\"> {{local._id.countySubdivision}} - {{local._id.place}}\r\n                                                                </label>\r\n                                                            </li>\r\n                                                        </ul>\r\n                                                        <!-- Display Locals and sub counties End -->\r\n                                                    </li>\r\n                                                </ul>\r\n                                                <!-- Display Counties End -->\r\n                                            </li>\r\n                                        </ul>\r\n                                    </li>\r\n                                </ul>\r\n                            </div>\r\n                            <div class=\"select buttons\" style=\"padding-left: 20px;\">&nbsp;\r\n                                <!-- <button class=\"btn mover left\" ng-click=\"AddmyArea()\" title=\"Add selected\" ng-disabled=\"!selectedArea.length\"><i class=\"fa fa-arrow-right\" aria-hidden=\"true\"></i></button>\r\n                                <button class=\"btn mover right\" ng-click=\"RemoveArea()\" title=\"Remove selected\" ng-disabled=\"!rmselectedArea.length\">\r\n                                    <i class=\"fa fa-arrow-left\" aria-hidden=\"true\"></i>\r\n                                </button> -->\r\n                            </div>\r\n                            <div class=\"DisplayCat\">\r\n                                <div style=\"background-color: #eee; padding:5px;\">Selected Location\'s <br><small>(click to remove)</small></div>\r\n                                <ul class=\"catList\">\r\n                                    <li ng-repeat=\"area in selectedArea track by $index\">\r\n                                        <label class=\"checkbox\" title=\"{{area}}\">\r\n                                            <input type=\"checkbox\" ng-click=\"removeAreaVal(area)\" ng-model=\"selectedLAll.id[$index]\" ng-checked=\"selectedArea.indexOf(area) > -1\"> <span ng-if=\"area.country && (!(area.state) && !(area.county) && !(area.countySubdivision) && !(area.place))\">{{area.country}}</span> <span ng-if=\"area.state && (!(area.county) && !(area.countySubdivision) && !(area.place))\">{{area.state}}</span><span ng-if=\"area.county && (!(area.countySubdivision) && !(area.place))\">{{area.county}}</span><span ng-if=\"area.countySubdivision\">{{area.countySubdivision}}</span><span ng-if=\"area.place\"> - {{area.place}}</span>\r\n                                        </label>\r\n                                    </li>\r\n                                </ul>\r\n                            </div>\r\n                            <div style=\"clear:both;\"></div>\r\n                            <!-- <multi-select ng-model=\"Essay.subcategories\" available=\"subtopics\" selected-label=\"Selected subtopics\" available-label=\"All subtopics\" display=\"r as r.title\" title=\"r as r.title\" config=\"selectConfig\"></multi-select>\r\n                            <div class=\"input-error\" ng-show=\"selectForm.numSelected.$error.min\">\r\n                                Please select at least\r\n                                <ng-pluralize count=\"selectConfig.requiredMin\" when=\"{\'one\': \'one role\', \'other\': \'{} roles\'}\">.\r\n                            </div>\r\n                            <input type=\"hidden\" id=\"reqMin\" ng-model=\"selectConfig.requiredMin\" min=\"1\">-->\r\n                        </div>\r\n                        <!-- <div class=\"control-group\">\r\n                            <label class=\"control-label\" for=\"restricted\">Media Type</label>\r\n                            <div class=\"control-group\">\r\n                                <select ng-model=\"Essay.mediaType\">\r\n                                    <option ng-repeat=\"option in mediaType\" value=\"{{option}}\">{{option}}</option>\r\n                                </select>\r\n                            </div>\r\n                        </div> -->\r\n                        <div class=\"control-group\" ng-if=\"Essay.mediaType==\'Text\'\">\r\n                            <label class=\"control-label\" for=\"description\">Description</label>\r\n                            <div class=\"controls\">\r\n\r\n                                <textarea id=\"description\" ng-model=\"Essay.description\" placeholder=\"\" style=\"width:95%; height:250px;\"></textarea>\r\n                                \r\n                                <!-- <input type=\"button\" name=\"btnAddMedia\" ng-click=\"Showgallery()\" value=\"Add Media\" style=\"margin-top:15px; margin-bottom:10px;\" />\r\n                                <textarea ui-tinymce=\"tinymceOptions\" ng-model=\"Essay.description\" style=\"height:350px;\"></textarea> -->\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"control-group\" ng-if=\"Essay.mediaType==\'Stills\'\">\r\n                            <label class=\"control-label\" for=\"description\">Upload Media</label>\r\n                            <div class=\"controls\">\r\n                                <input type=\"file\" check-file-size=\"\" file-model=\"Essay.files\" class=\"form-control input-md text-input\" accept=\"image/x-png, image/gif, image/jpeg, image/jpeg, image/svg+xml\">\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"control-group\" ng-if=\"Essay.mediaType==\'Video\' || Essay.mediaType==\'Audio\'\">\r\n                            <label class=\"control-label\" for=\"description\">{{Essay.mediaType}} url</label>\r\n                            <div class=\"controls\">\r\n                                <input type=\"text\" ng-model=\"Essay.mediaFile\" placeholder=\"\" data-errormessage-value-missing=\"Please enter url\" data-errormessage-custom-error=\"Please enter valid url. e.g. http://www.example.com/v1\" data-errormessage=\"Please enter valid url. e.g. http://www.example.com/v1\" style=\"width:50%;\" class=\"form-control input-md  validate[required, custom[url]] text-input\">\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"control-group\" ng-if=\"Essay.mediaType!=\'Text\'\">\r\n                            <label class=\"control-label\" for=\"description\">Note</label>\r\n                            <div class=\"controls\">\r\n                                <textarea ng-model=\"Essay.description\" style=\"width: 70%; height: 150px;\"></textarea>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <div style=\"clear: both;\"></div>\r\n                    <div style=\"margin-top:20px;\">\r\n                        <button ng-click=\"UpdateEssay(Essay)\" type=\"button\" class=\"btn btn-success\" ng-disabled=\"EssayButton\" style=\"float: left;\">Submit Essay</button>\r\n                        &nbsp;&nbsp;&nbsp;&nbsp;\r\n                        <button ng-click=\"goBack();\" type=\"button\" style=\"float: left;\">Cancel</button>\r\n                        <div style=\"clear: both;\"></div>\r\n                    </div>\r\n                    <div style=\"clear: both;\"></div>\r\n                </div>\r\n            </fieldset>\r\n        </form>\r\n    </div>\r\n</center>\r\n<script type=\"text/ng-template\" id=\"field_renderer\">\r\n    <ul class=\"catList\">\r\n        <li>\r\n             <div class=\"catname\" id=\"{{subent._id}}\" ng-if=\"(subent.parentIds.length == 0) && (subent.subcategories)\">\r\n                <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\">  <label ng-click=\"ChangeShow(subent._id);\">{{::subent.title}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id)==-1\"></i><i class=\"fa fa-caret-right\" aria-hidden=\"true\"  ng-if=\"showDown.indexOf(subent._id) > -1\"></i></label>\r\n            </div>\r\n            <div class=\"catname\" ng-if=\"(subent.parentIds.length == 0) && (!subent.subcategories)\">\r\n                <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                    <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\"> {{::subent.title}}\r\n                </label>\r\n            </div>\r\n            <label class=\"checkbox\" ng-if=\"subent.parentIds.length > 0 && showSubCat\" title=\"{{subent.title}}\" >\r\n                <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\"> {{::subent.title}}\r\n            </label>\r\n            <ul ng-if=\"subent.subcategories\" ng-class=\"subent.parentIds.length == 0 ? \'cmnUL MainCatLi_{{subent._id}}\' : \'\'\">\r\n                <li ng-repeat=\"subent in subent.subcategories track by $index\" ng-include=\"\'field_renderer\'\">\r\n                    <!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                      <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n                  </label> -->\r\n                </li>\r\n            </ul>\r\n        </li>\r\n    </ul>\r\n</script>\r\n<script type=\"text/javascript\">\r\njQuery(document).ready(function() {\r\n    // binds form submission and fields to the validation engine\r\n    // binds form submission and fields to the validation engine\r\n    $(\"form\").validationEngine();\r\n});\r\n</script>");
$templateCache.put("app/pressHome/pressHome.html","<!-- <link rel=\"stylesheet\" type=\"text/css\" href=\"./pressHome/pressHome.css\"> -->\r\n<div style=\"width: 98%; margin: auto;\">\r\n  <!--  <div ng-if=\"orgtype ==\'press\'\">\r\n    <p>\r\n      <h1>\r\n        <center>News Outlets</center>\r\n      </h1>\r\n    </p>\r\n    <p>Please choose news sources to follow. You can always change your mind, but selecting news sources to follow makes\r\n      it easier to have the news you want come to you. We highly reccommend picking multiple sources - some that are\r\n      moderate, and some that extreme. Some that agree with you and some that don\'t. Truth is never found in just one\r\n      source. Wisdom comes from listening to all sides of an argument. And make sure to choose a source for local news\r\n      because as entertaining as world news is, what\'s going on in your own town has a greater impact on your life, and\r\n      with VoteWise, you have a greater ability to help it change for the better. If you don\'t see your local news\r\n      source here, give them a call and get them to join.</p>\r\n  </div>-->\r\n  <div ng-if=\"orgtype ==\'advocate\'\">\r\n    <p>\r\n      <h1>\r\n        <center>Organizations</center>\r\n      </h1>\r\n    </p>\r\n    <p>\r\n      <h3>\r\n        <center>{{cat_title}}</center>\r\n      </h3>\r\n    </p>\r\n  </div>\r\n  <br>\r\n  <br>\r\n  <fieldset class=\"scheduler-border\">\r\n    <legend class=\"scheduler-border\">Choose</legend>\r\n    <label>\r\n      <input type=\"radio\" name=\"geographic-focus\" value=\"International\" ng-model=\"locationIntrest\" ng-change=\"intrestChange()\" /> International\r\n    </label>\r\n    <label>\r\n      <input type=\"radio\" name=\"geographic-focus\" value=\"usa\" ng-model=\"locationIntrest\" ng-change=\"intrestChange()\" /> National\r\n    </label>\r\n    <label>\r\n      <input type=\"radio\" name=\"geographic-focus\" value=\"state\" ng-model=\"locationIntrest\" ng-change=\"intrestChange()\"> My State\r\n    </label>\r\n    <label>\r\n      <input type=\"radio\" name=\"geographic-focus\" value=\"county\" ng-model=\"locationIntrest\" ng-change=\"intrestChange()\"> My County\r\n    </label>\r\n    <label>\r\n      <input type=\"radio\" name=\"geographic-focus\" value=\"local\" ng-model=\"locationIntrest\" ng-change=\"intrestChange()\"> My Local\r\n    </label>\r\n    <br>\r\n  </fieldset>\r\n    <div style=\"padding-left: 20px; \">\r\n      <div infinite-scroll=\'myPagingFunction()\'>\r\n        <table style=\"width:100%\" ng-repeat=\"(key, value) in press.data | groupBy: \'orgtype\'\"\r\n          ng-init=\"sort[\'factual\'+key] = \'All\'; sort[\'recommend\'+key] = \'All\'\" class=\"changeTextColor\">\r\n          <!-- <caption><b>{{key}}</b></caption> -->\r\n          <tr>\r\n            <!--         <th>Follow</th>  -->\r\n            <th>\r\n\r\n              <a href=\"\" ng-click=\"sorArr(\'name\')\">\r\n													Name <span><i ng-show=\"nameUp\" class=\"fa fa-arrow-circle-up\"></i><i ng-show=\"nameDown\" class=\"fa fa-arrow-circle-down\"></i></span>\r\n              </a>\r\n            </th>\r\n            <th style=\"width: 200px\">Specialty</th>\r\n            <!--     <th ng-if=\"orgtype == \'press\'\">Frequency of Release</th>\r\n         <th ng-if=\"orgtype == \'press\'\">Audience</th>  -->\r\n            <th style=\"width: 100px\"> <a href=\"\" ng-click=\"sorArr(\'match\')\">\r\n            Match &nbsp;<i ng-if=\"ratingUp\" class=\"fa fa-arrow-circle-up\"></i><i ng-if=\"ratingDown\" class=\"fa fa-arrow-circle-down\"></i>\r\n             </a></th>\r\n            <th>Website</th>\r\n            <th># of Followers</th>\r\n            <th> Factual According to\r\n              <select name=\"SUBJECT\" ng-model=\"sort[\'factual\'+key]\" class=\"blackText\">\r\n          <option value=\"All\">ALL</option>\r\n          <option value=\"Voters\">VOTERS</option>\r\n <!--         <option value=\"Press\">PRESS</option>  -->\r\n          <option value=\"Advocates\">ORGANIZATIONS</option>\r\n          <option value=\"Politicians\">POLITICIANS</option>\r\n        </select>\r\n            </th>\r\n            <th>Recommended by\r\n              <select name=\"SUBJECT\" ng-model=\"sort[\'recommend\'+key]\" class=\"blackText\">\r\n          <option value=\"All\">ALL</option>\r\n          <option value=\"Voters\">VOTERS</option>\r\n <!--         <option value=\"Press\">PRESS</option>  -->\r\n          <option value=\"Advocates\">ORGANIZATIONS</option>\r\n          <option value=\"Politicians\">POLITICIANS</option>\r\n        </select>\r\n            </th>\r\n            <!--        <th>Annual Revenue</th>  -->\r\n            <th>User Reviews</th>\r\n          </tr>\r\n\r\n          <!-- | orderBy:orderByField:reverseSort -->\r\n          <tr ng-repeat=\"item in value\">\r\n            <!--       <td>\r\n            <input type=\"checkbox\" ng-click=\"addFollow(item)\" name=\"Follow[]\" value=\"{{item._id}}\">\r\n      </td>  -->\r\n            <td style=\"padding-left: 10px; padding-right: 10px; padding-bottom: 7px;\">\r\n              <a href=\"#!/pressProfile/{{item._id}}\"  class=\"link\" style=\"text-decoration:underline\"><b style=\"text-transform:capitalize !important;\" >{{item.title}}</b></a>\r\n            </td>\r\n            <td>\r\n              <!--           <span ng-if=\"orgtype == \'press\'\">{{item.specialTopic}}</span>  -->\r\n              <span ng-if=\"orgtype == \'advocate\'\">{{item.speciality}}</span>\r\n            </td>\r\n            <td><span ng-if=\"item.match && item.match !=0\">{{item.match}}%</span>\r\n              <span ng-if=\"item.match == 0\">-</span></td>\r\n            <!--         <td ng-if=\"orgtype == \'press\'\">{{item.frequency}}</td>\r\n          <td ng-if=\"orgtype == \'press\'\">{{item.circulation}}</td> -->\r\n            <td>\r\n              <a ng-href=\"{{item.webUrl}}\" ng-if=\"item.webUrl.indexOf(\'http://\')>-1\" target=\"_blank\"><b ng-if=\"item.webUrl\" class=\"link\">View</b></a>\r\n              <a ng-href=\"http://{{item.webUrl}}\" ng-if=\"item.webUrl.indexOf(\'http://\')==-1\" target=\"_blank\" class=\"link\"><b ng-if=\"item.webUrl\">View</b></a>\r\n              <!-- <a ng-href=\"{{item.webUrl}}\" target=\"_blank\"style=text-decoration:underline class=\"link\"></a> -->\r\n            </td>\r\n            <td>\r\n              <span ng-if=\"!item.followersCount\">0</span><span ng-if=\"item.followersCount\">{{item.followersCount}}</span>\r\n            </td>\r\n            <td>\r\n              <!-- <span ng-if=\"sort[\'factual\'+key] == \'All\'\">{{item.factfavg}} stars ({{item.factfavgtotal}} reviews)</span>\r\n          <span ng-if=\"sort[\'factual\'+key] == \'Voters\'\">{{item.factfavgvoters}} stars ({{item.factfavgvoterstotal}} reviews)</span>\r\n          <span ng-if=\"sort[\'factual\'+key] == \'Politicians\'\">{{item.factfavgpolitician}} stars ({{item.factfavgpoliticiantotal}} reviews)</span>\r\n          <span ng-if=\"sort[\'factual\'+key] == \'Advocates\'\">{{item.factfavgadvocate}} stars ({{item.factfavgadvocatetotal}} reviews)</span>\r\n          <span ng-if=\"sort[\'factual\'+key] == \'Press\'\">{{item.factfavgpress}} stars ({{item.factfavgpresstotal}} reviews)</span> -->\r\n              <span  ng-if=\"sort[\'factual\'+key] == \'All\' && item.factfavg\">\r\n													<input-stars max=\"5\" ng-model=\"item.factfavg\" readonly></input-stars>\r\n\r\n          </span>\r\n              <span  ng-if=\"sort[\'factual\'+key] == \'All\' && !item.factfavg\">\r\n              N/A\r\n        </span>\r\n              <span  ng-if=\"sort[\'factual\'+key] == \'All\' && item.factfavgtotal\">{{item.factfavgtotal}}</span>\r\n              <span  ng-if=\"sort[\'factual\'+key] == \'All\' && !item.factfavgtotal\">-</span>\r\n              <!-- <span>{{item.recavg}} stars ({{item.recavgtotal}} reviews)</span> -->\r\n              <span ng-if=\"sort[\'factual\'+key] == \'Voters\' && item.factfavgvoters\">\r\n													<input-stars max=\"5\" ng-model=\"item.factfavgvoters\" readonly></input-stars>\r\n            </span>\r\n              <span  ng-if=\"sort[\'factual\'+key] == \'Voters\' && !item.factfavgvoters\">\r\n                N/A\r\n          </span>\r\n              <span  ng-if=\"sort[\'factual\'+key] == \'Voters\' && item.factfavgvoterstotal\">{{item.factfavgvoterstotal}}</span>\r\n              <span  ng-if=\"sort[\'factual\'+key] == \'Voters\' && !item.factfavgvoterstotal\">-</span>\r\n              <span ng-if=\"sort[\'factual\'+key] == \'Politicians\' && item.factfavgpolitician\">\r\n													<input-stars max=\"5\" ng-model=\"item.factfavgpolitician\" readonly></input-stars>\r\n          </span>\r\n              <span  ng-if=\"sort[\'factual\'+key] == \'Politicians\' && !item.factfavgpolitician\">\r\n              N/A\r\n        </span>\r\n              <span  ng-if=\"sort[\'factual\'+key] == \'Politicians\' && item.factfavgpoliticiantotal\">{{item.factfavgpoliticiantotal}}</span>\r\n              <span  ng-if=\"sort[\'factual\'+key] == \'Politicians\' && !item.factfavgpoliticiantotal\">-</span>\r\n              <span ng-if=\"sort[\'factual\'+key] == \'Advocates\' && item.factfavgadvocate\">\r\n													<input-stars max=\"5\" ng-model=\"item.factfavgadvocate\" readonly></input-stars>\r\n            </span>\r\n              <span  ng-if=\"sort[\'factual\'+key] == \'Advocates\' && !item.factfavgadvocate\">\r\n                N/A\r\n          </span>\r\n              <span  ng-if=\"sort[\'factual\'+key] == \'Advocates\' && item.factfavgadvocatetotal\">{{item.factfavgadvocatetotal}}</span>\r\n              <span  ng-if=\"sort[\'factual\'+key] == \'Advocates\' && !item.factfavgadvocatetotal\">-</span>\r\n              <span ng-if=\"sort[\'factual\'+key] == \'Press\' && item.factfavgpress\">\r\n													<input-stars max=\"5\" ng-model=\"item.factfavgpress\" readonly></input-stars>\r\n            </span>\r\n              <span  ng-if=\"sort[\'factual\'+key] == \'Press\' && !item.factfavgpress\">\r\n                N/A\r\n          </span>\r\n              <span  ng-if=\"sort[\'factual\'+key] == \'Press\' && item.factfavgpresstotal\">{{item.factfavgadvocatetotal}}</span>\r\n              <span  ng-if=\"sort[\'factual\'+key] == \'Press\' && !item.factfavgpresstotal\">-</span>\r\n            </td>\r\n            <td>\r\n              <span  ng-if=\"sort[\'recommend\'+key] == \'All\' && item.recavg\">\r\n													<input-stars max=\"5\" ng-model=\"item.recavg\" readonly></input-stars>\r\n\r\n          </span>\r\n              <span  ng-if=\"sort[\'recommend\'+key] == \'All\' && !item.recavg\">\r\n              N/A\r\n          </span>\r\n              <span  ng-if=\"sort[\'recommend\'+key] == \'All\' && item.recavgtotal\">{{item.recavgtotal}}</span>\r\n              <span  ng-if=\"sort[\'recommend\'+key] == \'All\' && !item.recavgtotal\">-</span>\r\n              <!-- <span>{{item.recavg}} stars ({{item.recavgtotal}} reviews)</span> -->\r\n              <span ng-if=\"sort[\'recommend\'+key] == \'Voters\' && item.recavgvoters\">\r\n													<input-stars max=\"5\" ng-model=\"item.recavgvoters\" readonly></input-stars>\r\n            </span>\r\n              <span  ng-if=\"sort[\'recommend\'+key] == \'Voters\' && !item.recavgvoters\">\r\n                N/A\r\n            </span>\r\n              <span  ng-if=\"sort[\'recommend\'+key] == \'Voters\' && item.recavgvoterstotal\">\r\n            {{item.recavgvoterstotal}}</span>\r\n              <span  ng-if=\"sort[\'recommend\'+key] == \'Voters\' && !item.recavgvoterstotal\">-</span>\r\n              <span ng-if=\"sort[\'recommend\'+key] == \'Politicians\' && item.recavgpolitician\">\r\n													<input-stars max=\"5\" ng-model=\"item.recavgpolitician\" readonly></input-stars>\r\n          </span>\r\n              <span  ng-if=\"sort[\'recommend\'+key] == \'Politicians\' && !item.recavgpolitician\">\r\n              N/A\r\n          </span>\r\n              <span  ng-if=\"sort[\'recommend\'+key] == \'Politicians\' && item.recavgpoliticiantotal\">{{item.recavgvoterstotal}}</span>\r\n              <span  ng-if=\"sort[\'recommend\'+key] == \'Politicians\' && !item.recavgpoliticiantotal\">-</span>\r\n              <span ng-if=\"sort[\'recommend\'+key] == \'Advocates\' && item.recavgadvocate\">\r\n													<input-stars max=\"5\" ng-model=\"item.recavgadvocate\" readonly></input-stars>\r\n            </span>\r\n              <span  ng-if=\"sort[\'recommend\'+key] == \'Advocates\' && !item.recavgadvocate\">\r\n                N/A\r\n            </span>\r\n              <span  ng-if=\"sort[\'recommend\'+key] == \'Advocates\' && item.recavgadvocatetotal\">{{item.recavgvoterstotal}}</span>\r\n              <span  ng-if=\"sort[\'recommend\'+key] == \'Advocates\' && !item.recavgadvocatetotal\">-</span>\r\n              <span ng-if=\"sort[\'recommend\'+key] == \'Press\' && item.recavgpress\">\r\n													<input-stars max=\"5\" ng-model=\"item.recavgpress\" readonly></input-stars>\r\n            </span>\r\n              <span  ng-if=\"sort[\'recommend\'+key] == \'Press\' && !item.recavgpress\">\r\n                N/A\r\n            </span>\r\n              <span  ng-if=\"sort[\'recommend\'+key] == \'Press\' && item.recavgpresstotal\">{{item.recavgvoterstotal}}</span>\r\n              <span  ng-if=\"sort[\'recommend\'+key] == \'Press\' && !item.recavgpresstotal\">-</span>\r\n            </td>\r\n            <!--         <td>{{item.annualRevenue}}</td>  -->\r\n            <td style=\"padding-left: 10px; padding-right: 10px;\">\r\n              <a href=\"#!/orgRating/{{item._id}}\" style=text-decoration:underline class=\"link\"><b>Add/See</b></a>\r\n            </td>\r\n          </tr>\r\n        </table>\r\n      </div>\r\n      <div class=\"fwb\" ng-if=\"statusGetAll == 1\">\r\n        <center>\r\n          <i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span>\r\n        </center>\r\n      </div>\r\n      <p class=\"fwb\" ng-if=\"statusGetAll == 2 && press.data.length <= 0\">No results found</p>\r\n      <!--    <div><input type=\"submit\" ng-click=\"updateFollow(\'r\')\" class=\"compareBtn\" value=\"Submit\"></div>\r\n      <!-- <button ng-click=\"loadMore()\" ng-show=\"statusGetAll != 1\" class=\"btnShort-style\">Load more</button> -->\r\n      <!-- <div style=\"float:left;\" class=\"changeTextColor\">\r\n        <dir-pagination-controls max-size=\"5\" pagination-id=\"list.id\" on-page-change=\"scrollToTop()\">\r\n        </dir-pagination-controls>\r\n      </div> -->\r\n      <br/>\r\n\r\n</div>\r\n");
$templateCache.put("app/pressProfile/pressProfile.html","<div class=\"container-fluid\">\r\n  <div>\r\n    <img ng-src=\"../assets/images/profile/{{item.returndata.createdby.utype}}.svg\" ng-if=\"item.returndata.createdby.utype\">\r\n\r\n\r\n    <h2 class=\"pageHeading\" style=\"text-transform: capitalize;\">{{press.title}}</h2>\r\n\r\n    <div style=\"display: flex\">\r\n      <div class=\"pressRating\">\r\n\r\n        <p ng-if=\"press.type == \'Advocate\'\" style=\"padding-left:7% !important\"><b>Organization</b></p>\r\n        <p ng-if=\"press.type == \'Press\'\"><b>Press</b></p>\r\n        <p ng-if=\"pressUser.typeOfOrg\">Type of Organization:\r\n          <b style=\"text-transform: capitalize;\">{{pressUser.typeOfOrg}}</b></p>\r\n\r\n        <a href=\"#!/orgRating/{{pressId}}\" class=\"hoverYellow\"><h3>Ratings</h3>\r\n                <p>Recommended : <input-stars max=\"5\" ng-click=\"PressVote(\'Recommended\');\" ng-model=\"vote.recommend\" readonly>\r\n                  </input-stars>\r\n\r\n                  <br/>Factual : <input-stars max=\"5\" ng-click=\"PressVote(\'Factual\');\" ng-model=\"vote.factual\" readonly>\r\n                  </input-stars>\r\n                </p></a>\r\n\r\n        <a ng-if=\"pressUserId && match\"  href=\"#!/compare-subject/politician\" class=\"hoverYellow\"><h3>Match to You</h3>\r\n                <p>{{match}}%</p></a>\r\n        <a ng-if=\"!pressUserId && match\"  href=\"#!/compare-subject/politician\" class=\"hoverYellow\"><h3>Match to You</h3>\r\n                  <p>{{match}}%</p></a>\r\n        <div style=\"padding-left:5%;float: left\">\r\n          <div ng-if=\"loginUser!=pressId && !showUnFollow\">\r\n            <input type=\"button\" class=\"compareBtn\" ng-click=\"addtoFollow();\" value=\"Follow\">\r\n          </div>\r\n          <div ng-if=\"loginUser!=pressId && showUnFollow\">\r\n            <input type=\"button\" class=\"compareBtn\" ng-click=\"removetoFollow();\" value=\"Unfollow\"></div>\r\n\r\n          <div>\r\n            <input  type=\"button\" class=\"compareBtn\" ng-click=\"redirectToReviews();\" value=\"See Reviews\"></div>\r\n          <div>\r\n            <a ng-if=\"pressUser.donationLink\"  target=\"_blank\" href=\"{{pressUser.donationLink}}\" class=\"compareBtn\"  style=\"width: 250px; text-align: center\">Donate to Organization</a>\r\n          </div>\r\n\r\n\r\n          <br>\r\n\r\n        </div>\r\n        <br>\r\n      </div>\r\n\r\n    </div>\r\n\r\n\r\n    <!-- <div class=\"row\">\r\n            <div class=\"col-lg-5\"> -->\r\n    <center>\r\n      <div>\r\n\r\n        <!-- Contact Info -->\r\n        <div class=\"contactBlock\">\r\n          <center>\r\n            <img ng-src=\"./assets/images/contactPoliticiansWide1.svg\" class=\"blockLink publicProfileImg img-fluid\"><br></center>\r\n          <h5 class=\"blockHeading\">Contact</h5>\r\n\r\n          <!-- <div class=\"DescrImg\" ng-if=\"press.description\" ng-bind-html=\"press.description | to_trusted\"></div> -->\r\n          <div ng-if=\"press.webUrl\"><i class=\"fa fa-globe faSize\" aria-hidden=\"true\"></i>\r\n            Website :\r\n            <span ng-if=\"press.webUrl.substring(0,4) != \'http\'\">\r\n\r\n                      <a ng-href=\"{{press.webUrl}}\" class=\"link\" ng-if=\"press.webUrl.indexOf(\'http://\')>-1\" target=\"_blank\">{{press.webUrl}}</a><a ng-href=\"http://{{press.webUrl}}\" ng-if=\"press.webUrl.indexOf(\'http://\')==-1\" target=\"_blank\">{{press.webUrl}}</a>\r\n																					</span>\r\n            <span ng-if=\"press.webUrl.substring(0,4) == \'http\'\"}}>\r\n\r\n																							<a ng-href=\"{{press.webUrl}}\"  ng-if=\"press.webUrl.indexOf(\'http://\')>-1\" target=\"_blank\" class=\"link\">{{press.webUrl}}</a><a ng-href=\"{{press.webUrl}}\" ng-if=\"press.webUrl.indexOf(\'http://\')==-1\" target=\"_blank\">{{press.webUrl}}</a></span>\r\n          </div>\r\n          <div ng-if=\"pressUser.publicEmail && pressUser.publicEmail != \'null\'\">\r\n            <i class=\"fa fa-envelope faSize\" aria-hidden=\"true\"></i>\r\n            Email: <a href=\"mailto:{{pressUser.publicEmail}}\" class=\"link\">{{pressUser.publicEmail}}</a>\r\n          </div>\r\n          <!-- {{pressUser.email}} -->\r\n          <div ng-if=\"press.frequency\">Frequency: {{press.frequency}}</div>\r\n          <div ng-if=\"press.mailingAddress\"><i class=\"fa fa-address-card faSize\" aria-hidden=\"true\"></i>\r\n            Mailing Address: {{press.mailingAddress}}</div>\r\n          <div ng-if=\"press.headquarter\">Headquarter: {{press.headquarter}}</div>\r\n          <div ng-if=\"press.foundedOn\">Founded: {{press.foundedOn}}</div>\r\n          <div ng-if=\"press.email\"><i class=\"fa fa-address-book-o faSize\" aria-hidden=\"true\"></i>\r\n            General Contact:\r\n            <a href=\"mailto:{{press.email}}\" class=\"link\">{{press.email}}</a></div>\r\n          <div ng-if=\"press.phoneNo\"> <i class=\"fa fa-phone faSize\" aria-hidden=\"true\"></i>\r\n            Phone Number: <a href=\"tel:{{press.phoneNo}}\">{{press.phoneNo}}</a>\r\n          </div>\r\n          <div ng-if=\"press.owner\">Owner: {{press.owner}}</div>\r\n          <div ng-if=\"press.type == \'Press\'\">Publisher: {{press.contactPerson.name}}</div>\r\n          <div ng-if=\"press.twitterHandle\">\r\n            <i class=\"fa fa-twitter-square faSize\"></i> Twitter Account :\r\n											\r\n											<span ng-if=\"press.twitterHandle.substring(0,4) == \'http\'\"}}>\r\n            <a ng-href=\"{{press.twitterHandle}}\" ng-if=\"press.twitterHandle\"\r\n															class=\"infoAns\" target=\"_blank\">{{press.twitterHandle}}</a></span>\r\n												<span ng-if=\"press.twitterHandle.substring(0,4) != \'http\'\"}}><a ng-href=\"https://www.twitter.com/{{press.twitterHandle}}\" ng-if=\"press.twitterHandle\"\r\n															class=\"infoAns\" target=\"_blank\">{{press.twitterHandle}}</a></span>\r\n          </div>\r\n          <div ng-if=\"press.facebookUrl\">\r\n            <i class=\"fa fa-facebook-square faSize\" aria-hidden=\"true\"></i>\r\n            Facebook Url\r\n            <a  ng-href=\"{{press.facebookUrl}}\" target=\"_blank\" class=\"infoAns\"> {{press.facebookUrl}} </a>\r\n          </div>\r\n          <!--<div ng-if=\"press.type == \'Advocate\'\"> Press Contact: {{press.contactPerson.name}}</div>\r\n    <div ng-if=\"press.type == \'Press\'\">Publisher Email:<a href=\"mailto:{press.contactPerson.email}\" class=\"link\">{{press.contactPerson.email}}</a></div>\r\n    <div ng-if=\"press.type == \'Advocate\'\">Press Contact Email:<a href=\"mailto:{press.contactPerson.email}\" class=\"link\"> {{press.contactPerson.email}}</a></div>\r\n    <div ng-if=\"press.editor.name\">Editor: {{press.editor.name}}</div>\r\n    <div ng-if=\"press.editor.email\">Editor Email: <a href=\"mailto:{{press.editor.email}}\" class=\"link\">{{press.editor.email}}</a></div>\r\n</div>  -->\r\n          <div ng-if=\"press.circulation\">Circulation: {{press.circulation}}</div>\r\n          <div ng-if=\"press.towns\">Locations: {{press.towns}}</div>\r\n          <div ng-if=\"press.annualRevenue\">AnnualRevenue : {{press.annualRevenue}}</div>\r\n\r\n          <!-- Geo Proximity tab -->\r\n        </div>\r\n\r\n        <!-- ABOUT US    -->\r\n        <div class=\"contactBlock\" ng-if=\"press.description || press.videoLink\">\r\n\r\n          <h5 class=\"blockHeading\">About us</h5>\r\n          \r\n									<div class=\"DescrImg\" ng-if=\"press.description\" ng-bind-html=\"press.description | newlines\"></div>\r\n          <div class=\"DescriptionImg\" ng-bind-html=\'press.videoLink | urlifyshort\'>\r\n          </div>\r\n          <!-- Geo Proximity tab -->\r\n        </div>\r\n        <!--    VOTEWISE ACTIVITY  --->\r\n        <div class=\"votewiseActivitiesBlock\"\r\n          ng-show=\"votewiseActivity.totalthread >\'0\' || votewiseActivity.totalanswers >\'0\' || votewiseActivity.totalthreads >\'0\' || votewiseActivity.totalposts >\'0\'\">\r\n          <center>\r\n            <img ng-src=\"./assets/images/votewiseWide3.svg\" class=\"blockLink publicProfileImg img-fluid\">\r\n            <br>\r\n      </center>\r\n          <h5 class=\"blockHeading\">Votewise Activities</h5>\r\n          <p class=\"userInfo\">\r\n            <span class=\"infoName\">Questions Answered </span>\r\n            <a ng-if=\"pressUserId\" href=\"#!/question-answered-by/{{pressUserId}}\" ng-click=\"\"><span class=\"link\">{{votewiseActivity.totalanswers}}</span></a>\r\n\r\n          </p>\r\n          <p class=\"userInfo\" ng-if=\"votewiseActivity.totalthread>0\">\r\n            <span class=\"infoName\">Threads Created </span>\r\n            <a ng-href=\"\" ng-click=\"gotoPage(\'Thread\', votewiseActivity.userData)\"\r\n          class=\"infoAns\">\r\n          <span class=\"link\">{{votewiseActivity.totalthread}}</span>\r\n        </a>\r\n          </p>\r\n\r\n          <p class=\"userInfo\" ng-if=\"votewiseActivity.totalthread==0\">\r\n            <span>Threads Created </span>\r\n            <span class=\"link\">{{votewiseActivity.totalthread}}</span>\r\n          </p>\r\n          <p class=\"userInfo\" ng-if=\"votewiseActivity.totalpost>0\">\r\n            <span class=\"infoName\">Total Posts </span>\r\n            <a ng-href=\"\" ng-click=\"gotoPage(\'Post\', votewiseActivity.userData)\"\r\n          class=\"infoAns\">\r\n          <span class=\"link\">{{votewiseActivity.totalpost}}</span>\r\n        </a>\r\n          </p>\r\n          <p ng-if=\"votewiseActivity.totalessay && votewiseActivity.totalessay > 0\" class=\"userInfo\">\r\n            <span>Essays Created </span><a href=\"javascript: void(0);\" ng-click=\"gotoPage(\'Essay\', votewiseActivity.userData)\" class=\"link\" >{{votewiseActivity.totalessay}}</a>\r\n          </p>\r\n          <p ng-if=\"votewiseActivity.totalessaycomments && votewiseActivity.totalessaycomments > 0\" class=\"userInfo\">\r\n            <span>Essay Comments </span><a href=\"javascript: void(0);\" ng-click=\"gotoPage(\'EssayComment\', votewiseActivity.userData)\" class=\"link\"> {{votewiseActivity.totalessaycomments}}</a>\r\n          </p>\r\n          <p class=\"userInfo\" ng-if=\"votewiseActivity.totalpost==0\">\r\n            <span class=\"infoName\">Total Posts </span>\r\n            <span class=\"link\">{{votewiseActivity.totalpost}}</span>\r\n          </p>\r\n\r\n          <div ng-if=\"votewiseActivity.userData.subjectOfDeepInterests.length > 0\">\r\n            <p class=\"userInfo\">\r\n              <span>Topics of interest </span>\r\n              <!-- <span class=\"infoAns\" ng-bind-html=\"userProfile.resume | to_trusted\"></span> -->\r\n              <a href=\"javascript: void(0)\" ng-if=\"votewiseActivity.userData.subjectOfDeepInterests.length > 0\" ng-click=\"gotoPage(\'topic of interest\',votewiseActivity.userData.subjectOfDeepInterests)\" class=\"link\">\r\n                                      <b>View</b>\r\n                                    </a>\r\n            </p>\r\n          </div>\r\n          <div ng-if=\"votewiseActivity.userData.locationOfInterest.length > 0\">\r\n            <p class=\"userInfo\">\r\n              <span>Location of interest </span>\r\n              <!-- <span class=\"infoAns\" ng-bind-html=\"userProfile.resume | to_trusted\"></span> -->\r\n              <a href=\"javascript: void(0)\" ng-if=\"votewiseActivity.userData.locationOfInterest.length > 0\" ng-click=\"gotoPage(\'location of interest\',votewiseActivity.userData.locationOfInterest)\" class=\"link\">\r\n                                      <b>View</b>\r\n                                    </a>\r\n            </p>\r\n          </div>\r\n          \r\n          <p ng-if=\"followersCnt\" class=\"userInfo\">\r\n            Followers:{{followersCnt}} </p>\r\n          <!--      <a href=\"#!/orgActivityDetails/followers/{{pressId}}\" class=\"infoAns\">{{followersCnt}}</a></p> -->\r\n\r\n          <!--             <p ng-if=\"questionsCnt\" class=\"userInfo\">\r\n                      Quiz Questions Created By Organization: <a href=\"\" class=\"infoAns\">{{questionsCnt}}</a>\r\n                    </p>  -->\r\n          <!--             <p ng-if=\"quizQuesHasAns\" class=\"userInfo\">\r\n                      Quiz Questions Has Already Answered: {{quizQuesHasAns}}\r\n                    </p>\r\n-->\r\n\r\n\r\n          <div class=\"blockBottomLink\">\r\n            <span><a href=\"\" ng-click=\"getMatchSpecific()\" class=\"link\">Take their Match Quiz</a></span>\r\n            <!--    <a ng-if=\"pressUserId\" href=\"#!/question-answered-by/{{pressUserId}}\" ng-click=\"\">See Match Answers</a>\r\n                      <a ng-if=\"!pressUserId\" href=\"#!/question-answered-by/{{pressId}}\" ng-click=\"\">See Match Answers</a>  -->\r\n          </div>\r\n\r\n        </div>\r\n\r\n        <!--   TWITTER SEARCH  -->\r\n        <div class=\"twitterBlock\" ng-if=\"press.twitterHandle\">\r\n          <center>\r\n            <img ng-src=\"./assets/images/twitterSearch.svg\" class=\"blockLink publicProfileImg img-fluid\">\r\n            <br>\r\n      </center>\r\n          <h5 class=\"blockHeading\">TWITTER SEARCH</h5>\r\n          <p>Search <span style=\"text-transform: capitalize;\">{{press.title}}</span>\'s Twitter feed by\r\n            entering search words or hashtags.\r\n          </p>\r\n\r\n          <p>Search Words: <input ng-model=\"sw1\" class=\"blackText\"><br></p>\r\n          <center>\r\n											<span ng-if=\"press.twitterHandle.substring(0,4) != \'http\'\"}}>\r\n            <a ng-href=\"https://twitter.com/search?q={{sw1}}(from%3A{{press.twitterHandle}})&src=typed_query\" target=\"_blank\"><button class=\"compareBtn\">Search</button></a>\r\n											</span>\r\n									</center>\r\n									<center>\r\n											<span ng-if=\"press.twitterHandle.substring(0,4) == \'http\'\"}}>\r\n            <a ng-href=\"https://twitter.com/search?q={{sw1}}(from%3A{{press.twitterHandle.substring(20)}})&src=typed_query\" target=\"_blank\"><button class=\"compareBtn\">Search</button></a>\r\n											</span>\r\n          </center>\r\n          <a class=\"twitter-timeline\" data-width=\"500\" data-height=\"500\" href=\"https://twitter.com/{{press.twitterHandle}}?ref_src=twsrc%5Etfw\"></a>\r\n          <script async src=\"https://platform.twitter.com/widgets.js\" charset=\"utf-8\"></script>\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n      </div>\r\n    </center>\r\n  </div>\r\n\r\n</div>\r\n<script type=\"text/ng-template\" id=\"LatestEssayId\">\r\n            <div class=\"latestPosts\">\r\n              <h3>Latest Essay</h3>\r\n              <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"LatestEssay==0\"></i>\r\n              <ul>\r\n                <li ng-repeat=\"essay in LatestEssay track by $index\">\r\n                  <div class=\"boldbox\">\r\n                    <span ng-click=\"gotoEssay(essay._id, essay.parentCat[0]);\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">{{essay.title}}</span>\r\n                  </div>\r\n                  <!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                                <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n                            </label> -->\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </script>\r\n<script type=\"text/ng-template\" id=\"LatestEssayCommentId\">\r\n            <div class=\"latestPosts\">\r\n              <h3>Latest Essay Comments</h3>\r\n              <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"LatestEssayComments==0\"></i>\r\n              <ul>\r\n                <li ng-repeat=\"essay in LatestEssayComments track by $index\">\r\n                  <div class=\"boldbox\">\r\n                    <!-- <div  ng-bind-html=\'essay.comments | urlify\' ng-click=\"gotoComments(essay.essayId)\"></div> -->\r\n                    <span ng-click=\"gotoComments(essay._id, essay.parentCat[0]);\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">{{essay.title}}</span>\r\n                  </div>\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </script>\r\n<script type=\"text/ng-template\" id=\"LatestPostId\">\r\n            <div class=\"latestPosts\">\r\n              <h3>Latest Posts</h3>\r\n              <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"LatestPost==0\"></i>\r\n              <ul>\r\n                <li ng-repeat=\"post in LatestPost track by $index\">\r\n                  <div class=\"boldbox\">\r\n                    <span ng-click=\"gotoThread(post, post.subCategories[0].pid);\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">{{post.title}}</span>\r\n                  </div>\r\n                  <!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                                <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n                            </label> -->\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </script>\r\n<script type=\"text/ng-template\" id=\"LatestThreadId\">\r\n            <div class=\"latestPosts\">\r\n              <h3>Latest Threads</h3>\r\n              <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"LatestThread==0\"></i>\r\n              <ul>\r\n                <li ng-repeat=\"thread in LatestThread track by $index\">\r\n                  <div class=\"boldbox\">\r\n                    <span ng-click=\"gotoThread(thread, thread.subCategories[0].pid);\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">{{thread.title}}</span>\r\n                  </div>\r\n                  <!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                                <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n                            </label> -->\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </script>\r\n          <script type=\"text/ng-template\" id=\"TopicsOfInterest\">\r\n            <div class=\"latestPosts\">\r\n              <h3>Topics Of Interest</h3>\r\n              <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"TopicsOfInterests.length == 0\"></i>\r\n              <ul>\r\n                <li ng-repeat=\"topic in TopicsOfInterests track by $index\">\r\n                  <div class=\"boldbox\">\r\n                    <span style=\"cursor:pointer; font-weight: bolder;\">{{topic.title}}</span>\r\n                  </div>\r\n\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </script>\r\n          <script type=\"text/ng-template\" id=\"LocationOfInterest\">\r\n            <div class=\"latestPosts\">\r\n              <h3>Location Of Interest</h3>\r\n              <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"locationOfInterest.length == 0\"></i>\r\n              <ul>\r\n                <li ng-repeat=\"location in locationOfInterest track by $index\">\r\n                  <div class=\"boldbox\">\r\n               \r\n                    <div style=\"cursor:pointer; font-weight: bolder;\" ng-if=\"location.country\">{{location.country}}</div>\r\n                    \r\n                    <div style=\"cursor:pointer; font-weight: bolder;\" ng-if=\"location.state && location.state !=\'\'\">{{location.state}}</div>\r\n                    <div style=\"cursor:pointer; font-weight: bolder;\" ng-if=\"location.county && location.county !=\'\'\">{{location.county}}</div>\r\n                    <div style=\"cursor:pointer; font-weight: bolder;\" ng-if=\"location.place && location.place !=\'\'\">{{location.place}}</div>\r\n                    <div style=\"cursor:pointer; font-weight: bolder;\" ng-if=\"location.countySubdivision && location.countySubdivision !=\'\'\">{{location.countySubdivision}}</div>\r\n                    <hr>\r\n                  </div>\r\n\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </script>");
$templateCache.put("app/printUsers/printUsers.html","<style type=\"text/css\">\r\n    \r\n    \r\n    /*\r\n    \r\n    \r\n    \r\n  table th  {\r\n      background-color: black;\r\n      color: white;\r\n      text-transform: uppercase;\r\n  }table, th, td {\r\n      border: 1px solid black;\r\n      border-collapse: collapse;\r\n  }\r\n  th, td {\r\n      padding: 5px;\r\n      text-align: left;\r\n    \r\n  }\r\n  table tr:nth-child(even) {\r\n      background-color: #eee;\r\n  }\r\n  table tr:nth-child(odd) {\r\n     background-color:#fff;\r\n  }\r\n    \r\n    \r\n    \r\n    \r\n    */\r\n    \r\n    \r\n</style>\r\n<div style=\"padding: 20px;\">\r\n  <button class=\"print-hide\" ng-click=\"$root.printPage()\" style=\"margin-bottom: 10px;\"> Print </button>\r\n  <table style=\"width:100%; margin-bottom: 15px;\" ng-repeat=\"(key, value) in printUsers | groupBy: \'groupByKey\'\">\r\n      <tr>\r\n        <th>{{key}}</th>\r\n      </tr>\r\n      <tr ng-repeat=\"user in value\">\r\n        <td>{{user.name_on_ballot || user.name}}</td>\r\n      </tr>\r\n  </table>\r\n</div>");
$templateCache.put("app/privacyPolicy/privacyPolicy.html","\r\n<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">PRIVACY POLICY</h2>\r\n  <p class=\"pageSubHeading\"></p>\r\n    \r\n \r\n\r\n  <div class=\"row d-flex justify-content-center\">\r\n    <div class=\"col col-lg-12 col-med-12 col-sm-12 col-12\">\r\n      <div class=\"row\">\r\n        <center><div class=\"col-lg-12 col-sm-12 contactBlock\" style=\"text-align: left;\">\r\n            <br>\r\n              <h4 class=\"blockTitleLearn\"> Privacy</h4>\r\n            <p>\r\n													This privacy notice discloses the privacy practices for VoteWise.net. This privacy notice applies solely to information collected by this website. It will notify you of the following:</p>\r\n								<p>	<ul>\r\n<li>What personally identifiable information is collected from you through the website, how it is used and with whom it may be shared.</li>\r\n<li>What choices are available to you regarding the use of your data.</li>\r\n<li>The security procedures in place to protect the misuse of your information.</li>\r\n<li>How you can correct any inaccuracies in the information.</li></ul></p>\r\n									<b>Information Collection, Use, and Sharing</b>\r\n<p>We are the sole owners of the information collected on this site. We only have access to/collect information that you voluntarily give us via email or other direct contact from you. We will not sell or rent your contact or any personal information to anyone.</p>\r\n									\r\n<p>We will use your information to respond to you, regarding the reason you contacted us. We will not share your private information with any third party outside of our organization, other than as necessary to fulfill your request, e.g. to ship an order. </p>\r\n									\r\n<p>The quizzes you take will be associated with an anonymous identity unless you choose to make your answers public.  The comments you make in the user forum will be associated with your username unless you are a public figure and are choosing to present yourself that way.  In that case, your answers and comments will be attributed to you.</p>\r\n									\r\n<p>Your bulk polling data may be shared with politicians, the public, and other organizations if we believe it will help your goals in making the world in your vision.</p>\r\n\r\n<p>We reserve the right to create additional sites that use all the data presented in different ways to make the user experience easier for different types of users.  For example, some users may want to use a simpler more graphic site, while others may want more detail.  You will be able to log onto these sites using your same log in. </p>\r\n									\r\n<p>Unless you ask us not to, we may contact you via email in the future to tell you about things we think you might be concerned about, excited about, or changes to this privacy policy.</p>\r\n									\r\n<b>Your Access to and Control Over Information</b>\r\n<p>You may opt out of any future contacts from us at any time. You can do the following at any time by contacting us via the email address or phone number given on our website:</p>\r\n<ul>						\r\n<li>See what data we have about you, if any.</li>\r\n<li>Change/correct any data we have about you.</li>\r\n<li>Have us delete any private data we have about you.</li>\r\n<li>Express any concern you have about our use of your data.</li></ul>			\r\n<b>Security</b>\r\n<p>We take precautions to protect your information. When you submit sensitive information via the website, your information is protected both online and offline.</p>\r\n<p>Wherever we collect sensitive information (such as credit card data), that information is encrypted and transmitted to us in a secure way. You can verify this by looking for a lock icon in the address bar and looking for \"https\" at the beginning of the address of the Web page.</p>\r\n<p>While we use encryption to protect sensitive information transmitted online, we also protect your information offline. Only employees who need the information to perform a specific job (for example, billing or customer service) are granted access to personally identifiable information. The computers/servers in which we store personally identifiable information are kept in a secure environment.</p>\r\n<p>If you feel that we are not abiding by this privacy policy, you should contact us immediately via telephone at 70-VoteWise or email@votewise.net</p>\r\n\r\n");
$templateCache.put("app/publicProfile/publicProfile.html","<!-- New Design -->\r\n<div class=\"container-fluid\">\r\n  <p class=\"fwb\" ng-if=\"statusGetData == 1\">Loading profile data...</p>\r\n  <!--  <div ng-if=\"shobackbtn\">\r\n    <a href=\"\" ng-click=\"BackToPrev()\" class=\"ylink\">Back</a>\r\n  </div> -->\r\n  <div ng-if=\"userProfile && userProfile.registeredUser\">\r\n    <h2 class=\"pageHeading\" style=\"text-transform: capitalize;\"\r\n      ng-if=\"userProfile.verifiedUser && userProfile.isEmailVerified\">{{userProfile.name}}</h2>\r\n    <!-- is userProfile && userProfile.registeredUser -->\r\n    <h2 class=\"pageHeading\" style=\"text-transform: capitalize;\"\r\n      ng-if=\"!userProfile.verifiedUser || !userProfile.isEmailVerified\">Unknown Politician</h2>\r\n    <div class=\"pageSubHeading\">\r\n      <div ng-if=\"userProfile.politicianInfo[0].officeName\" style=\"text-transform: capitalize;\">\r\n        <div ng-repeat=\"item in userProfile.politicianInfo\">\r\n\r\n          <div ng-if=\" item.officeName && item.incumbent == \'incumbent\' || item.incumbent == \'Incumbent\'\">\r\n            <span ng-if=\"item.incumbent == \'incumbent\' || item.incumbent == \'Incumbent\'\">\r\n               Office:\r\n            </span>\r\n            {{item.officeName}}<span ng-if=\"item.levelOfGov == \'placeName\'\"> of {{item.place}}</span>\r\n            <span ng-if=\"item.levelOfGov == \'countyName\'\">of {{item.county}}</span>\r\n            <span ng-if=\"item.levelOfGov == \'statePostalCode\' && item.state !=\'NA\'\">,  {{item.state}}</span>\r\n            <span ng-if=\"item.levelOfGov == \'All USA\'\"> of the United States</span>\r\n            <span ng-if=\"item.levelOfGov == \'statePostalCode\' && item.state ==\'NA\'\">{{item.statePostalCode}}</span>\r\n            <span ng-if=\"item.levelOfGov == \'stateHouseofRepresentativesDistrict\'\"> of {{item.statePostalCode}} Legislative district {{item.legislativeDistrict}}</span>\r\n            <span ng-if=\"item.levelOfGov == \'stateSenateDistrict\' && item.state !=\'NA\'\"> of {{item.state}} State district {{item.stateSenateDistrict}}</span>\r\n            <span ng-if=\"item.levelOfGov == \'stateSenateDistrict\' && item.state ==\'NA\'\">{{item.statePostalCode}}</span>\r\n            <span ng-if=\"item.levelOfGov == \'federalCongressionalDistrict\'\">,<span ng-if=\"item.state !=\'NA\'\">{{item.state}}</span>\r\n            <span ng-if=\"item.state ==\'NA\' && item.statePostalCode !=\'NA\'\">{{item.statePostalCode}}</span>\r\n            <span ng-if=\"item.federalCongressionalDistrict\"> Federal Congressional District </span>\r\n            {{item.federalCongressionalDistrict}}</span>\r\n\r\n          </div>\r\n          <!-- item.officeName && item.incumbent !=\'incumbent\' || item.incumbent !=\'null\' || item.incumbent !=\'Incumbent\' && item.runningForOffice == \'Y\' &&  item.electionYear >= curYear  || userProfile.electionDate >= curDate -->\r\n          <div\r\n            ng-if=\"item.officeName && item.incumbent ==\'\' || item.incumbent !=\'null\' || item.incumbent !=\'Incumbent\' && item.runningForOffice == \'Y\' &&  item.electionYear >= curYear  || userProfile.electionDate >= curDate\">\r\n\r\n            <span ng-if=\"item.runningForOffice == \'Y\'\">\r\n                Running For Office:\r\n\r\n            {{item.officeName}}, <span ng-if=\"item.levelOfGov == \'placeName\'\">{{item.place}}</span>\r\n            <span ng-if=\"item.levelOfGov == \'countyName\'\">{{item.county}}</span>\r\n            <span ng-if=\"item.levelOfGov == \'statePostalCode\' && item.state != \'NA\'\">{{item.state}}</span>\r\n            <span ng-if=\"item.levelOfGov == \'stateHouseofRepresentativesDistrict\'\"> of {{item.statePostalCode}} Legislative district {{item.legislativeDistrict}}</span>\r\n            <span ng-if=\"item.levelOfGov == \'stateSenateDistrict\'\">{{item.state}} state senate district {{item.stateSenateDistrict}}</span>\r\n            <span ng-if=\"item.levelOfGov == \'All USA\'\">the United States</span>\r\n            <span ng-if=\"item.levelOfGov == \'federalCongressionalDistrict\'\"> {{item.state}} <span ng-if=\"item.federalCongressionalDistrict\">Federal Congressional District </span>\r\n            {{item.federalCongressionalDistrict}}</span>\r\n            </span>\r\n          </div>\r\n          <div ng-if=\"item.party.length > 0\">\r\n            <!--         this is new  -->\r\n            <span>Party: {{item.party[0]}}</span>\r\n            <!--           <div ng-repeat=\"part in item.party track by $index\">\r\n              <span ng-if=\"part\">{{part}}</span>\r\n           </div> -->\r\n          </div>\r\n\r\n        </div>\r\n      </div>\r\n      <div ng-if=\"userDetails.orgData.title\">\r\n        <span>Title: </span> {{userDetails.orgData.title}}\r\n      </div>\r\n      <div ng-if=\"userDetails.orgData.description\">\r\n        {{userDetails.orgData.description}}\r\n      </div>\r\n\r\n      <div ng-if=\" memberRole.votes_with_party_pct\">Votes along party lines {{memberRole.votes_with_party_pct}}%</div>\r\n      <!-- {{userDetails}} -->\r\n      <!-- {{userProfile}} -->\r\n\r\n      <div ng-if=\"loginUser!=userId && !showUnFollow && userProfile.userType == \'politician\'\">\r\n        <input type=\"button\" class=\"compareBtn\" ng-click=\"addtoFollow();\" value=\"Follow\">\r\n      </div>\r\n      <div ng-if=\"loginUser!=userId && showUnFollow && userProfile.userType == \'politician\'\">\r\n        <input type=\"button\" class=\"compareBtn\" ng-click=\"removetoFollow();\" value=\"Unfollow\">\r\n      </div>\r\n    </div>\r\n\r\n    <!-- <div class=\" pageSubHeading\">\r\n              <div ng-if=\"userProfile.winDetails[0].office\" style=\"text-transform: capitalize\">\r\n                {{userProfile.winDetails[0].office}}\r\n              </div>\r\n              <div ng-if=\"userProfile.party\">{{userProfile.party}}</div>\r\n              <div ng-if=\"memberRole.votes_with_party_pct\">Votes along party lines {{memberRole.votes_with_party_pct}}%\r\n              </div>\r\n              <div ng-if=\"loginUser!=userId\">\r\n                <input type=\"button\" class=\"compareBtn\" ng-click=\"addtoFollow();\" value=\"Follow\">\r\n        </div>\r\n              </div> -->\r\n  </div>\r\n  <div ng-if=\"userProfile && userProfile.registeredUser == false\">\r\n    <!-- <h1>Hello</h1> -->\r\n    <h2 class=\"pageHeading\">{{userProfile.name}}</h2>\r\n    <!-- is neither userProfile nor userProfile.registeredUser -->\r\n    <div class=\"pageSubHeading\">\r\n      <div ng-if=\"userProfile.office && userProfile.incumbent == \'Incumbent\' || userProfile.incumbent == \'incumbent\'\"\r\n        style=\"text-transform:capitalize;\">\r\n\r\n        <span ng-if=\"userProfile.incumbent == \'Incumbent\' || userProfile.incumbent == \'incumbent\'\">Current Office: </span>\r\n        {{userProfile.office}},\r\n        <span ng-if=\"userProfile.voterScope == \'placeName\' || userProfile.voterScope == \'unifiedSchoolDistrictName\' \">{{userProfile.place}}</span>\r\n        <span ng-if=\"userProfile.voterScope ==\'All USA\'\">the United States</span>\r\n        <span ng-if=\"userProfile.voterScope == \'countyName\'\">{{userProfile.countyName}}</span>\r\n        <span ng-if=\"userProfile.voterScope == \'statePostalCode\'\">{{userProfile.state}}</span>\r\n        <span ng-if=\"userProfile.voterScope == \'stateSenateDistrict\'\">{{userProfile.state}}</span>\r\n        <span ng-if=\"userProfile.voterScope == \'federalCongressionalDistrict\'\">{{userProfile.state}} <span ng-if=\"userProfile.federalCongressionalDistrict\"> Federal Congressional District {{userProfile.federalCongressionalDistrict}}</span>\r\n        </span>\r\n      </div>\r\n      <!-- {{userProfile.electionDate}} curr {{curDate}} -->\r\n      <div\r\n        ng-if=\"userProfile.office && userProfile.incumbent == \'\' || userProfile.runningForOffice == \'Y\'  && userProfile.electionDate > curDate \"\r\n        style=\"text-transform: capitalize;\">\r\n        <span ng-if=\"userProfile.runningForOffice == \'Y\'\">Running For Office: </span>\r\n        {{userProfile.office}}, <span ng-if=\"userProfile.voterScope == \'placeName\' || userProfile.voterScope == \'unifiedSchoolDistrictName\'\">{{userProfile.place}}</span>\r\n        <span ng-if=\"userProfile.voterScope ==\'All USA\'\">the United States</span>\r\n        <span ng-if=\"userProfile.voterScope == \'countyName\'\">{{userProfile.countyName}}</span>\r\n        <span ng-if=\"userProfile.voterScope == \'statePostalCode\'\">{{userProfile.state}}</span>\r\n        <span ng-if=\"userProfile.voterScope == \'stateSenateDistrict\'\">{{userProfile.state}}</span>\r\n        <span ng-if=\"userProfile.voterScope == \'federalCongressionalDistrict\'\">{{userProfile.state}} <span ng-if=\"userProfile.federalCongressionalDistrict\"> Federal Congressional District {{userProfile.federalCongressionalDistrict}}</span>\r\n        </span> </span>\r\n      </div>\r\n      <div ng-if=\"userProfile.party !=\'\'\">\r\n        {{userProfile.party[0]}}</div>\r\n      <div ng-if=\"memberRole.votes_with_party_pct\">Votes along party lines {{memberRole.votes_with_party_pct}}%\r\n      </div>\r\n      <!-- {{userProfile.userType}} -->\r\n      <div ng-if=\"loginUser!=userId && !showUnFollow && userProfile.userType ==\'politician\'\">\r\n        <input type=\"button\" class=\"compareBtn\" ng-click=\"addtoFollow();\" value=\"Follow\">\r\n      </div>\r\n      <div ng-if=\"loginUser!=userId && showUnFollow && userProfile.userType ==\'politician\'\">\r\n        <input type=\"button\" class=\"compareBtn\" ng-click=\"removetoFollow();\" value=\"Unfollow\">\r\n  </div>\r\n    </div>\r\n  </div>\r\n  <center>\r\n    <div>\r\n\r\n      <!--          CONTACT INFO  and  LEGISLATION            -->\r\n      <div class=\"contactBlock\">\r\n        <center>\r\n          <img ng-src=\"./assets/images/contactPoliticiansWide1.svg\" class=\"blockLink publicProfileImg img-fluid\">\r\n          <br>\r\n      </center>\r\n        <h5 class=\"blockHeading\">Contact</h5>\r\n							<div ng-if=\"!userProfile.officePhone && !userProfile.publicEmail  && !userProfile.facebookUrl && !userProfile.webUrl && !userProfile.curOfficeWebiste && !userProfile.officeTwitterFeed && !userProfile.officeLinkedInUrl  && !userProfile.officeYouTubeUrl  && !userProfile.officeInstagramUrl\">No Information Found</div>\r\n        <div ng-if=\"userProfile && userProfile.registeredUser\">\r\n          <!-- <h1>Hello</h1> -->\r\n\r\n          <div ng-if=\"userProfile.userType == \'advocate\'\">\r\n            <div ng-if=\"userProfile.address.place\"> <span>City: </span> {{userProfile.address.place}}</div>\r\n            <div ng-if=\"userProfile.address.county\"><span>County: </span>{{userProfile.address.county}}</div>\r\n            <div ng-if=\"userProfile.address.countySubdivision\">\r\n              <span>County Subdivision</span> {{userProfile.address.countySubdivision}}</div>\r\n            <div ng-if=\"userProfile.address.state\"><span>State: </span>{{userProfile.address.state}} -\r\n              {{userProfile.address.statePostalCode}}</div>\r\n            <div ng-if=\"userProfile.zipcode\">\r\n              <strong>Zipcode:</strong> {{userProfile.zipcode}}</div>\r\n          </div>\r\n          <div ng-if=\"userDetails.orgData.phoneNo\">\r\n            <i class=\"fa fa-phone\"></i> Phone :\r\n            <a href=\"tel:{{userDetails.orgData.phoneNo}}\" class=\"infoAns\">{{userDetails.orgData.phoneNo}}</a>\r\n\r\n          </div>\r\n          <div ng-if=\"userProfile.officePhone\">\r\n\r\n            <i class=\"fa fa-phone\"></i> Phone :\r\n            <a href=\"tel:{{userProfile.officePhone}}\" class=\"infoAns\">{{userProfile.officePhone}}</a>\r\n\r\n          </div>\r\n\r\n          <div ng-if=\"userProfile.publicEmail\"> <i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> Email: <a href=\"mailto:{{userProfile.publicEmail}}\" target=\"_top\" class=\"link\">\r\n                {{userProfile.publicEmail}}</a>\r\n          </div>\r\n          <div ng-if=\"userProfile.facebookUrl\"><i class=\"fa fa-facebook-square\"></i> \r\n            Facebook Url\r\n            <a href= \"https://www.facebook.com/{{userProfile.facebookUrl}}\" target=\"_blank\" class=\"infoAns\">{{userProfile.facebookUrl}} </a>\r\n          </div>\r\n          <!-- <div ng-if=\"userProfile.webUrl\">\r\n            <i class=\"fa fa-globe\" aria-hidden=\"true\"></i> Website\r\n            <a href= \"{{userProfile.webUrl}}\" target=\"_blank\" class=\"infoAns\">{{userProfile.webUrl}} </a>\r\n          </div> -->\r\n          <div ng-if=\"userProfile.curOfficeWebiste\">\r\n            <i class=\"fa fa-globe\" aria-hidden=\"true\"></i> Website:\r\n            <a href= \"{{userProfile.curOfficeWebiste}}\" target=\"_blank\" class=\"infoAns\">{{userProfile.curOfficeWebiste}} </a>\r\n          </div>\r\n          <div ng-if=\"userProfile.officeTwitterFeed\">\r\n            <i class=\"fa fa-twitter\" aria-hidden=\"true\"></i> Twitter:\r\n            <a href= \"{{userProfile.officeTwitterFeed}}\" target=\"_blank\" class=\"infoAns\">{{userProfile.officeTwitterFeed}} </a>\r\n          </div>\r\n          <div ng-if=\"userProfile.officeInstagramUrl\">\r\n            <i class=\"fa fa-instagram\" aria-hidden=\"true\"></i> Instagram Account:\r\n            <a ng-href=\"{{userProfile.officeInstagramUrl}}\" ng-if=\"userProfile.officeInstagramUrl\"\r\n            class=\"infoAns\" target=\"_blank\">{{userProfile.officeInstagramUrl}}</a>\r\n          </div>\r\n          <div ng-if=\"userProfile.officeYouTubeUrl\">\r\n            <i class=\"fa fa-youtube-square\" aria-hidden=\"true\"></i> YouTube Channel:\r\n            <a ng-href=\"{{userProfile.officeYouTubeUrl}}\" ng-if=\"userProfile.officeYouTubeUrl\"\r\n            class=\"infoAns\" target=\"_blank\">{{userProfile.officeYouTubeUrl}}</a>\r\n          </div>\r\n          <div ng-if=\"userProfile.officeLinkedInUrl\">\r\n            <i class=\"fa  fa-linkedin-square\" aria-hidden=\"true\"></i> LinkedIn:\r\n            <a ng-href=\"{{userProfile.officeLinkedInUrl}}\" ng-if=\"userProfile.officeLinkedInUrl\"\r\n            class=\"infoAns\" target=\"_blank\">{{userProfile.officeLinkedInUrl}}</a>\r\n          </div>\r\n          <a ng-href=\"userDetails.orgData.webUrl\" ng-if=\"userDetails.orgData.webUrl.indexOf(\'http://\')>-1\" target=\"_blank\"> <i class=\"fa fa-globe\" aria-hidden=\"true\"></i> Website:\r\n          <span class=\"infoAns\">{{userDetails.orgData.webUrl}} </span>\r\n\r\n\r\n          <a ng-href=\"{{userDetails.orgData.webUrl}}\" ng-if=\"userDetails.orgData.webUrl.indexOf(\'https://\')>-1\" target=\"_blank\"> <i class=\"fa fa-globe\" aria-hidden=\"true\"></i> Website:\r\n            <span class=\"infoAns\">{{userDetails.orgData.webUrl}}</span>\r\n          </a>\r\n          <a ng-href=\"http://{{userDetails.orgData.webUrl}}\" ng-if=\"userDetails.orgData.webUrl.indexOf(\'http://\')==-1\"\r\n            target=\"_blank\"> <i class=\"fa fa-globe\" aria-hidden=\"true\"></i> Website:\r\n            <span class=\"infoAns\"> {{userDetails.orgData.webUrl}}</span>\r\n          </a>\r\n\r\n          <!-- propublica info -->\r\n          <div ng-if=\"propublicaData\">\r\n            <div ng-if=\"memberRole.phone\">\r\n              <i class=\"fa fa-phone\"></i> Phone :\r\n              <a href=\"tel:{{memberRole.phone}}\" class=\"infoAns\">{{memberRole.phone}}</a>\r\n            </div>\r\n            <div ng-if=\"memberRole.fax\">\r\n              <i class=\"fa fa-printer-1\"></i>Fax :\r\n              <span class=\"infoAns\">{{memberRole.fax}}</span>\r\n            </div>\r\n            <div ng-if=\"memberRole.contact_form\">\r\n              <i class=\"fa fa-pencil\"></i>Contact Form :\r\n              <a ng-href=\"{{memberRole.contact_form}}\" ng- target=\"_blank\" class=\"infoAns\">{{memberRole.contact_form}}</a>\r\n            </div>\r\n          </div>\r\n          <div ng-if=\"userProfile.website\" ng-href=\"http://{{userProfile.website}}\"\r\n            ng-if=\"userProfile.website.indexOf(\'http://\')==-1\" target=\"_blank\">\r\n            <strong> <i class=\"fa fa-globe\" aria-hidden=\"true\"></i> Website:</strong>\r\n            <span class=\"infoAns\">{{userProfile.website}}</span>\r\n          </div>\r\n\r\n        </div>\r\n        <div ng-if=\"propublicaData\">\r\n          <div ng-if=\"propublicaData.twitter_account\">\r\n            <i class=\"fa fa-twitter-square\"></i> Twitter Account :\r\n            <a ng-href=\"https://www.twitter.com/{{propublicaData.twitter_account}}\" ng-if=\"propublicaData.twitter_account\"\r\n                class=\"infoAns\" target=\"_blank\">{{propublicaData.twitter_account}}</a>\r\n          </div>\r\n									\r\n          <div ng-if=\"propublicaData.facebook_account\">\r\n            <i class=\"fa fa-facebook-square\"></i> Facebook Account :\r\n            <a ng-href=\"https://www.facebook.com/{{propublicaData.facebook_account}}\" ng-if=\"propublicaData.facebook_account\"\r\n                class=\"infoAns\" target=\"_blank\">{{propublicaData.facebook_account}}</a>\r\n          </div>\r\n          <div ng-if=\"propublicaData.youtube_account\">\r\n            <i class=\"fa fa-youtube-square\"></i> YouTube Account :\r\n            <a ng-href=\"https://www.youtube.com/{{propublicaData.youtube_account}}\" ng-if=\"propublicaData.youtube_account\"\r\n                class=\"infoAns\" target=\"_blank\">{{propublicaData.youtube_account}}</a>\r\n          </div>\r\n        </div>\r\n        <!-- <div>RSS URL : {{propublicaData.rss_url}}</div>\r\n          <div>Current Party : {{matchParty(propublicaData.current_party)}}</div>-->\r\n        <div ng-if=\"userProfile.politician\">\r\n     <!--     <div class=\"dottedDivider\"></div> -->\r\n          <div id=\"accordion\" class=\"accordionContact\" ng-if=\"userProfile.politicianInfo\">\r\n            <div class=\"card\">\r\n              <div id=\"headingOne\">\r\n                <h5 class=\"mb-0\">\r\n                  <div class=\"card-header contactCardHead\" data-toggle=\"collapse\" data-target=\"#collapseOne\"\r\n                    aria-expanded=\"true\" aria-controls=\"collapseOne\">\r\n                    Local Offices\r\n                  </div>\r\n                </h5>\r\n              </div>\r\n              <div id=\"collapseOne\" class=\"collapse show\" aria-labelledby=\"headingOne\" data-parent=\"#accordion\">\r\n                <div class=\"card-body\">\r\n                  <div ng-repeat=\"polinfo in userProfile.politicianInfo\">\r\n                    <div style=\"padding:10px;\">\r\n                      <div ng-if=\"polinfo.officeName\" style=\"text-transform: capitalize\">\r\n                        {{polinfo.officeName}}\r\n                      </div>\r\n                      <div ng-if=\"polinfo.place && polinfo.place != null\">{{polinfo.place}}</div>\r\n                      <div ng-if=\"polinfo.officeNote\">{{polinfo.officeNote}}</div>\r\n                      <div ng-if=\"polinfo.jurisdictionName\">Jurisdiction Name: {{polinfo.jurisdictionName}}\r\n                      </div>\r\n                      <div ng-if=\"polinfo.secondarySchoolDistrictName\">Secondary School District Name:\r\n                        {{polinfo.secondarySchoolDistrictName}}</div>\r\n                      <div ng-if=\"polinfo.elementarySchoolDistrictName\">Elementary School District Name:\r\n                        {{polinfo.elementarySchoolDistrictName}}</div>\r\n                      <div ng-if=\"polinfo.unifiedSchoolDistrictName\">Unified School District Name:\r\n                        {{polinfo.unifiedSchoolDistrictName}}</div>\r\n                      <div ng-if=\"polinfo.stateBoardEducationDistrict\">StateBoard Education District:\r\n                        {{polinfo.stateBoardEducationDistrict}}</div>\r\n                      <div ng-if=\"polinfo.judicialCircuitNumber\">Judicial Circuit Number:\r\n                        {{polinfo.judicialCircuitNumber}}</div>\r\n                      <div ng-if=\"polinfo.federalCongressionalDistrict\">Federal Congressional District:\r\n                        {{polinfo.federalCongressionalDistrict}}</div>\r\n                      <div ng-if=\"polinfo.countySubdivision && polinfo.countySubdivision != null\">County\r\n                        Subdivision:\r\n                        {{polinfo.countySubdivision}}</div>\r\n                      <div ng-if=\"polinfo.county\">County: {{polinfo.county}}</div>\r\n                      <div ng-if=\"polinfo.state\">State: {{polinfo.state}} - {{polinfo.statePostalCode}}\r\n                      </div>\r\n                      <!-- <div ng-if=\"polinfo.fromDate\">From Date: {{polinfo.fromDate}}</div>\r\n                  <div ng-if=\"polinfo.endDate\">End Date: {{polinfo.endDate}}</div> -->\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div id=\"accordion\" class=\"accordionContact\" ng-if=\"userProfile.politicianInfo\">\r\n          <div class=\"card\">\r\n            <div id=\"headingTwo\"\r\n              ng-if=\"(userProfile.campaignInfo.length > 0 ) && ((userProfile.campaignInfo[0].campaignEmail && userProfile.campaignInfo[0].campaignEmail != \'undefined\') ||  (userProfile.campaignInfo[0].campaignWeburl && userProfile.campaignInfo[0].campaignWeburl!= \'undefined\' )  || (userProfile.campaignInfo[0].campaignPhone && userProfile.campaignInfo[0].campaignPhone != \'undefined\'))\">\r\n              <h5 class=\"mb-0\">\r\n                <div class=\"card-header collapsed contactCardHead\" data-toggle=\"collapse\" data-target=\"#collapseTwo\"\r\n                  aria-controls=\"collapseTwo\">\r\n                  CAMPAIGN CONTACT\r\n                </div>\r\n              </h5>\r\n            </div>\r\n            <div id=\"collapseTwo\" class=\"collapse\" aria-labelledby=\"headingTwo\" data-parent=\"#accordion\">\r\n              <div class=\"card-body\">\r\n                <div ng-if=\"userProfile.campaignInfo.length > 0\">\r\n                  <!-- <h5>Campaign Information</h5> -->\r\n                  <div\r\n                    ng-if=\"(userProfile.campaignInfo[0].campaignFburl && userProfile.campaignInfo[0].campaignFburl != \'undefined\')\">\r\n                    <i class=\"fa fa-facebook-square\"></i> Campaign Facebook Url:\r\n                    <!-- <a href= \"https://www.facebook.com/{{userProfile.campaignInfo[0].campaignFburl}}\" ng-if=\"userProfile.campaignInfo[0].campaignFburl.indexOf(\'https://\')>-1\"  target=\"_blank\" class=\"infoAns\">{{userProfile.campaignInfo[0].campaignFburl}}</a> -->\r\n                    <a href=\"{{userProfile.campaignInfo[0].campaignFburl}}\"  target=\"_blank\" class=\"infoAns\">{{userProfile.campaignInfo[0].campaignFburl}}</a>\r\n\r\n                  </div>\r\n                  <div\r\n                    ng-if=\"(userProfile.campaignInfo[0].campaignEmail && userProfile.campaignInfo[0].campaignEmail != \'undefined\')\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> \r\n                    Campaign Email: {{userProfile.campaignInfo[0].campaignEmail}}\r\n                  </div>\r\n                  <div\r\n                    ng-if=\"(userProfile.campaignInfo[0].campaignWeburl && userProfile.campaignInfo[0].campaignWeburl!= \'undefined\')\"><i class=\"fa fa-globe\" aria-hidden=\"true\"></i> \r\n                    WebSite:\r\n                    <a href=\"{{userProfile.campaignInfo[0].campaignWeburl}}\"  target=\"_blank\" class=\"infoAns\">{{userProfile.campaignInfo[0].campaignWeburl}} </a>\r\n                  </div>\r\n                  <div\r\n                    ng-if=\"(userProfile.campaignInfo[0].campaignPhone && userProfile.campaignInfo[0].campaignPhone != \'undefined\') \"><i class=\"fa fa-phone\"></i> \r\n                    Phone:\r\n                    <a href=\"tel:{{userProfile.campaignInfo[0].campaignPhone}}\" class=\"infoAns\">{{userProfile.campaignInfo[0].campaignPhone}}</a>\r\n                  </div>\r\n                  <div ng-if=\"(userProfile.campaignInfo[0].campaignTwitterurl && userProfile.campaignInfo[0].campaignTwitterurl != \'undefined\') \">\r\n                    <i class=\"fa fa-twitter-square\"></i> Twitter Account:\r\n                    <a ng-href=\"{{userProfile.campaignInfo[0].campaignTwitterurl}}\" ng-if=\"userProfile.campaignInfo[0].campaignTwitterurl\"\r\n                    class=\"infoAns\" target=\"_blank\">{{userProfile.campaignInfo[0].campaignTwitterurl}}</a>\r\n                  </div>\r\n                  <div ng-if=\"(userProfile.campaignInfo[0].campaignInstagramUrl && userProfile.campaignInfo[0].campaignInstagramUrl != \'undefined\') \">\r\n                    <i class=\"fa fa-instagram\" aria-hidden=\"true\"></i> Instagram Account:\r\n                    <a ng-href=\"{{userProfile.campaignInfo[0].campaignInstagramUrl}}\" ng-if=\"userProfile.campaignInfo[0].campaignInstagramUrl\"\r\n                    class=\"infoAns\" target=\"_blank\">{{userProfile.campaignInfo[0].campaignInstagramUrl}}</a>\r\n                  </div>\r\n                  <div ng-if=\"(userProfile.campaignInfo[0].campaignYouTubeUrl && userProfile.campaignInfo[0].campaignYouTubeUrl != \'undefined\') \">\r\n                    <i class=\"fa fa-youtube-square\" aria-hidden=\"true\"></i> YouTube Channel:\r\n                    <a ng-href=\"{{userProfile.campaignInfo[0].campaignYouTubeUrl}}\" ng-if=\"userProfile.campaignInfo[0].campaignYouTubeUrl\"\r\n                    class=\"infoAns\" target=\"_blank\">{{userProfile.campaignInfo[0].campaignYouTubeUrl}}</a>\r\n                  </div>\r\n                  <div ng-if=\"(userProfile.campaignInfo[0].campaignLinkedInUrl && userProfile.campaignInfo[0].campaignLinkedInUrl != \'undefined\') \">\r\n                    <i class=\"fa fa-linkedin-square\" aria-hidden=\"true\"></i> LinkedIn:\r\n                    <a ng-href=\"{{userProfile.campaignInfo[0].campaignLinkedInUrl}}\" ng-if=\"userProfile.campaignInfo[0].campaignLinkedInUrl\"\r\n                    class=\"infoAns\" target=\"_blank\">{{userProfile.campaignInfo[0].campaignLinkedInUrl}}</a>\r\n                  </div>\r\n                  <div ng-if=\"userProfile.donationLink\">Donation Link <a href= \"{{userProfile.donationLink}}\"  target=\"_blank\" class=\"infoAns\">{{userProfile.donationLink}}\r\n              </a>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div ng-if=\"userProfile && userProfile.registeredUser == false\">\r\n          <div ng-if=\"userProfile.publicMailingAddress\">\r\n            <i class=\"fa fa-mail\"></i>{{userProfile.publicMailingAddress}}</div>\r\n          <div ng-if=\"!userProfile.publicMailingAddress\">\r\n            <!--\r\n                <div ng-if=\"userProfile.placeName\"><span>City:</span> {{userProfile.placeName}}</div>\r\n                <!--  <div ng-if=\"userProfile.placeFips\"><span>Place Fips</span> {{userProfile.placeFips}}</div> -->\r\n            <!--\r\n                <div ng-if=\"userProfile.countySubdivisionName\">\r\n                  <span>County Subdivision</span> {{userProfile.countySubdivisionName}}</div>\r\n                <!--             <div ng-if=\"userProfile.countySubdivisionFips\">\r\n                <span>County Subdivision Fips</span> {{userProfile.countySubdivisionFips}}</div> -->\r\n            <!--\r\n                <div ng-if=\"userProfile.countyName\"><span>County:</span> {{userProfile.countyName}}</div>\r\n                <!--             <div ng-if=\"userProfile.countyFips\"><span>County Fips</span>                                  {{userProfile.countyFips}}</div>\r\n              <div ng-if=\"userProfile.stateFips\"><span>State Fips</span> {{userProfile.stateFips}}</div> -->\r\n            <!--\r\n                <div ng-if=\"userProfile.statePostalCode\"><span>State: </span> {{userProfile.statePostalCode}}\r\n                </div>\r\n                <div ng-if=\"userProfile.publicZipcode\"><span>ZipCode:</span> {{userProfile.publicZipcode}}</div>\r\n\r\n-->\r\n          </div>\r\n\r\n          <div ng-if=\"userProfile.publicPhoneNumber\">\r\n            <i class=\"fa fa-phone\"></i> Phone:\r\n            <a href=\"tel:{{userProfile.publicPhoneNumber}}\" class=\"infoAns\">{{userProfile.publicPhoneNumber}}</a>\r\n          </div>\r\n\r\n          <div ng-if=\"userProfile.fax\">\r\n            <i class=\"fa fa-printer-1\"></i>Fax:\r\n            <span class=\"infoAns\">{{userProfile.fax}}</span>\r\n          </div>\r\n          <div ng-if=\"userProfile.publicZipcode\">\r\n            <strong>Public Zipcode:</strong> {{userProfile.publicZipcode}}</div>\r\n          <div ng-if=\"propublicaData\">\r\n            <div ng-if=\"memberRole.phone && !userProfile.publicPhoneNumber\">\r\n              <i class=\"fa fa-phone\"></i> Phone:\r\n              <a href=\"tel:{{memberRole.phone}}\" class=\"infoAns\">{{memberRole.phone}}</a>\r\n            </div>\r\n            <div ng-if=\"memberRole.fax && !userProfile.fax\">\r\n              <i class=\"fa fa-printer-1\"></i>Fax:\r\n              <a href=\"tel:{{memberRole.fax}}\" class=\"infoAns\">{{memberRole.fax}}</a>\r\n            </div>\r\n            <div ng-if=\"memberRole.contact_form\">\r\n              <i class=\"fa fa-pencil\"></i>Contact Form:\r\n              <a ng-href=\"{{memberRole.contact_form}}\" class=\"infoAns\" target=\"_blank\">{{memberRole.contact_form}}</a>\r\n            </div>\r\n            <div ng-if=\"userProfile.website\"><i class=\"fa fa-globe\" aria-hidden=\"true\"></i> Website:\r\n              <a ng-href=\"{{userProfile.website}}\" ng-if=\"userProfile.website.indexOf(\'http://\')>-1 || userProfile.website.indexOf(\'https://\')>-1\"\r\n              class=\"infoAns\" target=\"_blank\">{{userProfile.website}}</a>\r\n            </div>\r\n            <div ng-if=\"userProfile.twitterFeed\"><i class=\"fa fa-twitter-square\"></i> Twitter:\r\n													 <span ng-if=\"userProfile.twitterFeed.substring(0,4) == \'http\'\"}}>\r\n															<a ng-href=\"{{userProfile.twitterFeed}}\" class=\"infoAns\" target=\"_blank\">{{userProfile.twitterFeed}}</a></span>\r\n															<span ng-if=\"userProfile.twitterFeed.substring(0,4) != \'http\'\"}}>\r\n																<a ng-href=\"https://www.twitter.com/{{userProfile.twitterFeed}}\" class=\"infoAns\" target=\"_blank\">{{userProfile.twitterFeed}}</a></span>\r\n            </div>\r\n            <div ng-if=\"userProfile.facebookPage\"><i class=\"fa fa-facebook-square\"></i> Facebook:\r\n              <a ng-href=\"{{userProfile.facebookPage}}\" class=\"infoAns\" target=\"_blank\">{{userProfile.facebookPage}}</a>\r\n            </div>\r\n											 <div ng-if=\"userProfile.officeInstagramUrl\">\r\n            <i class=\"fa fa-instagram\" aria-hidden=\"true\"></i> Instagram Account:\r\n            <a ng-href=\"{{userProfile.officeInstagramUrl}}\" ng-if=\"userProfile.officeInstagramUrl\"\r\n            class=\"infoAns\" target=\"_blank\">{{userProfile.officeInstagramUrl}}</a>\r\n          </div>\r\n		\r\n            <div ng-if=\"userProfile.campaignInfo.length > 0\">\r\n              <br>\r\n             <center><h5><b>CAMPAIGN CONTACT</b></h5></center> \r\n													<div ng-if=\"!userProfile.campaignInfo[0].campaignEmail && !userProfile.campaignInfo[0].campaignWeburl && !userProfile.campaignInfo[0].campaignPhone\">No Information Found</div>\r\n              <div ng-if=\"userProfile.campaignInfo[0].campaignEmail\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> \r\n                Campaign Email: {{userProfile.campaignInfo[0].campaignEmail}}\r\n              </div>\r\n              <div ng-if=\"userProfile.campaignInfo[0].campaignWeburl\">\r\n                <i class=\"fa fa-globe\" aria-hidden=\"true\"></i> WebSite: <a href=\"{{userProfile.campaignInfo[0].campaignWeburl}}\" target=\"_blank\" class=\"infoAns\">{{userProfile.campaignInfo[0].campaignWeburl}}</a>\r\n              </div>\r\n              <div ng-if=\"userProfile.campaignInfo[0].campaignPhone\"><i class=\"fa fa-phone\"></i> Phone:\r\n                <a href=\"tel:{{userProfile.campaignInfo[0].campaignPhone}}\" class=\"infoAns\">{{userProfile.campaignInfo[0].campaignPhone}}</a>\r\n              </div>\r\n              <br>\r\n              </div>\r\n            <div ng-if=\"propublicaData\">\r\n              <div ng-if=\"propublicaData.twitter_account\">\r\n                <i class=\"fa fa-twitter-square\"></i> Twitter Account:\r\n                <a ng-href=\"https://www.twitter.com/{{propublicaData.twitter_account}}\" ng-if=\"propublicaData.twitter_account\"\r\n                class=\"infoAns\" target=\"_blank\">{{propublicaData.twitter_account}}</a>\r\n              </div>\r\n              <div ng-if=\"propublicaData.facebook_account\">\r\n                <i class=\"fa fa-facebook-square\"></i> Facebook Account:\r\n                <a ng-href=\"https://www.facebook.com/{{propublicaData.facebook_account}}\" ng-if=\"propublicaData.facebook_account\"\r\n                class=\"infoAns\" target=\"_blank\">{{propublicaData.facebook_account}}</a>\r\n              </div>\r\n              <div ng-if=\"propublicaData.youtube_account\">\r\n                <i class=\"fa fa-youtube-square\"></i> YouTube Account:\r\n                <a ng-href=\"https://www.youtube.com/{{propublicaData.youtube_account}}\" ng-if=\"propublicaData.youtube_account\"\r\n                class=\"infoAns\" target=\"_blank\">{{propublicaData.youtube_account}}</a>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div ng-if=\"userProfile.politician\">\r\n            <div id=\"accordion\" class=\"accordionContact\" ng-if=\"userProfile.politicianInfo\">\r\n             <!-- <div class=\"dottedDivider\"></div>-->\r\n              <div class=\"card\">\r\n                <div id=\"headingOne\">\r\n                  <h5 class=\"mb-0\">\r\n                    <div class=\"card-header contactCardHead\" data-toggle=\"collapse\" data-target=\"#collapseOne\"\r\n                      aria-expanded=\"true\" aria-controls=\"collapseOne\">\r\n                      Local Offices\r\n                    </div>\r\n                  </h5>\r\n                </div>\r\n                <div id=\"collapseOne\" class=\"collapse show\" aria-labelledby=\"headingOne\" data-parent=\"#accordion\">\r\n                  <div class=\"card-body\">\r\n                    <div ng-repeat=\"polinfo in userProfile.politicianInfo\">\r\n                      <div style=\"padding:10px;\">\r\n                        <div ng-if=\"polinfo.officeName\" style=\"text-transform: capitalize\">\r\n                          {{polinfo.officeName}}\r\n                        </div>\r\n                        <div ng-if=\"polinfo.place && polinfo.place != null\">{{polinfo.place}}</div>\r\n                        <div ng-if=\"polinfo.officeNote\">{{polinfo.officeNote}}</div>\r\n                        <div ng-if=\"polinfo.jurisdictionName\">Jurisdiction Name:\r\n                          {{polinfo.jurisdictionName}}\r\n                        </div>\r\n                        <div ng-if=\"polinfo.secondarySchoolDistrictName\">Secondary School District Name:\r\n                          {{polinfo.secondarySchoolDistrictName}}</div>\r\n                        <div ng-if=\"polinfo.elementarySchoolDistrictName\">Elementary School District Name:\r\n                          {{polinfo.elementarySchoolDistrictName}}</div>\r\n                        <div ng-if=\"polinfo.unifiedSchoolDistrictName\">Unified School District Name:\r\n                          {{polinfo.unifiedSchoolDistrictName}}</div>\r\n                        <div ng-if=\"polinfo.stateBoardEducationDistrict\">StateBoard Education District:\r\n                          {{polinfo.stateBoardEducationDistrict}}</div>\r\n                        <div ng-if=\"polinfo.judicialCircuitNumber\">Judicial Circuit Number:\r\n                          {{polinfo.judicialCircuitNumber}}</div>\r\n                        <div ng-if=\"polinfo.federalCongressionalDistrict\">Federal Congressional District:\r\n                          {{polinfo.federalCongressionalDistrict}}</div>\r\n                        <div ng-if=\"polinfo.countySubdivision && polinfo.countySubdivision != null\">County\r\n                          Subdivision:\r\n                          {{polinfo.countySubdivision}}</div>\r\n                        <div ng-if=\"polinfo.county\">County: {{polinfo.county}}</div>\r\n                        <div ng-if=\"polinfo.state\">State: {{polinfo.state}} - {{polinfo.statePostalCode}}\r\n                        </div>\r\n                        <!-- <div ng-if=\"polinfo.fromDate\">From Date: {{polinfo.fromDate}}</div>\r\n                  <div ng-if=\"polinfo.endDate\">End Date: {{polinfo.endDate}}</div> -->\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div id=\"accordion\" class=\"accordionContact\" ng-if=\"userProfile.politicianInfo\">\r\n            <div class=\"card\">\r\n              <div id=\"headingTwo\" ng-if=\"userProfile.campaignInfo[0].campaignEmail !=\'\'\">\r\n                <h5 class=\" mb-0\">\r\n                  <div class=\"card-header collapsed contactCardHead\" data-toggle=\"collapse\" data-target=\"#collapseTwo\"\r\n                    aria-controls=\"collapseTwo\">\r\n                    CAMPAIGN CONTACT\r\n                  </div>\r\n                </h5>\r\n              </div>\r\n              <div id=\"collapseTwo\" class=\"collapse\" aria-labelledby=\"headingTwo\" data-parent=\"#accordion\">\r\n                <div class=\"card-body\">\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <!-- <div class=\"row\" ng-if=\"userProfile && userProfile.registeredUser == false\">\r\n        <div class=\"contactBlock col-12\">\r\n          <h5 class=\"blockHeading\">Contact</h5>\r\n          <div ng-if=\"userProfile.placeName\"><strong>Place Name:</strong> {{userProfile.placeName}}</div>\r\n          <div ng-if=\"userProfile.placeFips\"><strong>Place FIPS:</strong> {{userProfile.placeFips}}</div>\r\n          <div ng-if=\"userProfile.countySubdivisionName\"><strong>County Subdivision Name:</strong> {{userProfile.countySubdivisionName}}</div>\r\n          <div ng-if=\"userProfile.countySubdivisionFips\"><strong>County Subdivision FIPS:</strong> {{userProfile.countySubdivisionFips}}</div>\r\n          <div ng-if=\"userProfile.countyName\"><strong>County Name:</strong> {{userProfile.countyName}}</div>\r\n          <div ng-if=\"userProfile.countyFips\"><strong>County FIPS:</strong> {{userProfile.countyFips}}</div>\r\n          <div ng-if=\"userProfile.stateFips\"><strong>State FIPS:</strong> {{userProfile.stateFips}}</div>\r\n          <div ng-if=\"userProfile.statePostalCode\"><strong>State Postal Code:</strong> {{userProfile.statePostalCode}}</div>\r\n          <div ng-if=\"userProfile.publicZipcode\"><strong>Public Zipcode:</strong> {{userProfile.publicZipcode}}</div>\r\n          <br />\r\n          <a ng-if=\"userProfile.website\" ng-href=\"http://{{userProfile.website}}\" ng-if=\"userProfile.website.indexOf(\'http://\')==-1\" target=\"_blank\" class=\"breakLink\"><strong>Website:</strong><span class=\"infoAns\">{{userProfile.website}}</span></a>\r\n        </div>\r\n</div> </div>-->\r\n      <!-- <p>length : {{propublicaData.length}}</p> -->\r\n      <!--   LEGISLATION  ---->\r\n      <div class=\"legislationBlock\" ng-if=\" propublicaData !=\'\'\">\r\n        <center>\r\n          <img ng-src=\"./assets/images/legislationWideYellowThick.svg\" class=\"blockLink publicProfileImg img-fluid\">\r\n          <br>\r\n      </center>\r\n        <h5 class=\"blockHeading\">Legislation</h5>\r\n        <div class=\"legislationSelect\">\r\n          <!-- <select id=\"store\" class=\"form-control input-inline input-medium\" ng-model=\"selectedYear\" ng-options=\"r.year for r in allroles\">\r\n            <option value=\"\" selected=\"true\">2017 - 2018</option>\r\n            </select> -->\r\n          <select class=\"custom-select\" ng-model=\"selectedYear\" ng-change=\"showPreviousYearRole(selectedYear, \'legislation\')\">\r\n          <option ng-repeat=\"r in allroles\" value=\"{{r.id}}\">\r\n            {{r.year}}\r\n          </option>\r\n        </select>\r\n        </div>\r\n        <!--<div ng-if=\"memberRole.title\">Title : {{memberRole.title}}</div>\r\n          <div ng-if=\"memberRole.party\">Party : {{matchParty(memberRole.party)}}</div> -->\r\n        <div ng-if=\"memberRole.votes_with_party_pct\">Votes along party lines :\r\n          {{memberRole.votes_with_party_pct}}%\r\n        </div>\r\n        <div ng-if=\"memberRole.missed_votes_pct\">Missed Votes: {{memberRole.missed_votes_pct}}%</div>\r\n        <div>Bills Sponsored:\r\n          <a href=\"\" class=\"infoAns\" ng-if=\"memberRole.bills_sponsored\" ng-click=\"getBillCosponsored(propublicaData.member_id)\">{{memberRole.bills_sponsored}}</a>\r\n        </div>\r\n        <div>Bills Cosponsored:\r\n          <a href=\"\" class=\"infoAns\" ng-if=\"memberRole.bills_cosponsored\" ng-click=\"getBillCosponsored(propublicaData.member_id)\">{{memberRole.bills_cosponsored}}</a>\r\n        </div>\r\n        <div class=\"blockBottomLink\">\r\n          <a href=\"\" ng-click=\"getVotingRecords(propublicaData.member_id)\">See Recent Votes</a>\r\n          <br />\r\n      </div>\r\n        <!-- <span ng-repeat=\"r in allroles\" ng-click=\"showPreviousYearRole(r.id)\">{{r.year}}<span ng-hide=\"$last\">, </span></span> -->\r\n      </div>\r\n\r\n      <!-- for openState Legislation -->\r\n      <!-- <div class=\"grid-item legislationBlock\" ng-if=\"openData !=\'\'\">\r\n      <center>\r\n        <img ng-src=\"./assets/images/legislationWideYellowThick.svg\" class=\"blockLink publicProfileImg img-fluid\">\r\n        <br>\r\n      </center>\r\n      <h5 class=\"blockHeading\">Legislation</h5>\r\n      <div class=\"legislationSelect\">\r\n\r\n             <span>2017-2018</span>\r\n\r\n      </div>\r\n\r\n      <div ng-if=\"openData[0].voterCount\">Votes along party lines : {{openData.voterCount}}%</div>\r\n      <div>Bills Sponsored :\r\n      {{openData[0].billSpoCount}}\r\n      </div>\r\n      <div class=\"blockBottomLink\">\r\n        <a href=\"\" ng-click=\"getVoting()\">See Recent Votes</a>\r\n        <br />\r\n      </div>\r\n    </div> -->\r\n\r\n      <!-- End of openState Legislation -->\r\n\r\n      <!--    VOTEWISE ACTIVITY  --->\r\n      <div class=\"votewiseActivitiesBlock\"\r\n        ng-show=\"userDetails.totalthread >\'0\' || userDetails.totalanswers >\'0\' || userDetails.totalthreads >\'0\' || userDetails.totalposts >\'0\' ||userProfile.resume !=null || userProfile.statement !=null\">\r\n        <center>\r\n          <img ng-src=\"./assets/images/votewiseWide3.svg\" class=\"blockLink publicProfileImg img-fluid\">\r\n          <br>\r\n      </center>\r\n        <h5 class=\"blockHeading\">Votewise Activities</h5>\r\n        \r\n        <p class=\"userInfo\">\r\n          <span class=\"infoName\">Questions Answered </span>\r\n\r\n          <a href=\"#!/question-answered-by/{{userId}}/{{userProfile.votesmartCandidateId}}/politician\" ng-click=\"\" ng-if=\"userProfile.votesmartCandidateId &&  userProfile.votesmartCandidateId!=\'\'\"><span class=\"link\">{{userDetails.totalanswers}}</span></a>\r\n          <a href=\"#!/question-answered-by/{{userId}}\" ng-click=\"\" ng-if=\"!userProfile.votesmartCandidateId\"><span class=\"link\">{{userDetails.totalanswers}}</span></a>\r\n\r\n        </p>\r\n        <p class=\"userInfo\" ng-if=\"userDetails.totalthread>0\">\r\n          <span class=\"infoName\">Threads Created </span>\r\n          <a ng-href=\"\" ng-click=\"gotoPage(\'Thread\', userDetails.userData)\"\r\n          class=\"infoAns\">\r\n          <span class=\"link\">{{userDetails.totalthread}}</span>\r\n        </a>\r\n        </p>\r\n        <p class=\"userInfo\" ng-if=\"userDetails.totalthread==0\">\r\n          <span>Threads Created </span>\r\n          <span class=\"link\">{{userDetails.totalthread}}</span>\r\n        </p>\r\n        <p class=\"userInfo\" ng-if=\"userDetails.totalpost>0\">\r\n          <span class=\"infoName\">Total Posts </span>\r\n          <a ng-href=\"\" ng-click=\"gotoPage(\'Post\', userDetails.userData)\"\r\n          class=\"infoAns\">\r\n          <span class=\"link\">{{userDetails.totalpost}}</span>\r\n        </a>\r\n        </p>\r\n        <p class=\"userInfo\" ng-if=\"userDetails.totalpost==0\">\r\n          <span class=\"infoName\">Total Posts </span>\r\n          <span class=\"link\">{{userDetails.totalpost}}</span>\r\n        </p>\r\n        <p ng-if=\"userDetails.totalessay && userDetails.totalessay > 0\" class=\"userInfo\">\r\n          <span class=\"infoName\">Essay </span>\r\n          <a href=\"javascript: void(0);\" ng-click=\"gotoPage(\'Essay\', userDetails.userData)\" class=\"link\">{{userDetails.totalessay}}</a>\r\n        </p>\r\n        <p ng-if=\"userDetails.totalessaycomments && userDetails.totalessaycomments > 0\" class=\"userInfo\">\r\n          <span class=\"infoName\">Essay Comments </span>\r\n          <a href=\"javascript: void(0);\" ng-click=\"gotoPage(\'EssayComment\', userDetails.userData)\" class=\"link\"> {{userDetails.totalessaycomments}}</a>\r\n        </p>\r\n        <p ng-if=\"followersCnt\" class=\"userInfo\">\r\n          Followers {{followersCnt}} </p>\r\n\r\n        <!-- <div ng-if=\"userProfile.politician\"> -->\r\n        <div ng-if=\"userProfile.subjectOfDeepInterests.length > 0\">\r\n          <p class=\"userInfo\">\r\n            <span>Topics of interest </span>\r\n            <!-- <span class=\"infoAns\" ng-bind-html=\"userProfile.resume | to_trusted\"></span> -->\r\n            <a href=\"javascript: void(0)\" ng-if=\"userProfile.subjectOfDeepInterests.length > 0\" ng-click=\"gotoPage(\'topic of interest\',userProfile.subjectOfDeepInterests)\" class=\"link\">\r\n                                    <b>View</b>\r\n                                  </a>\r\n          </p>\r\n        </div>\r\n        <div ng-if=\"userProfile.resume\">\r\n          <p class=\"userInfo\">\r\n            <span>Resume </span>\r\n            <!-- <span class=\"infoAns\" ng-bind-html=\"userProfile.resume | to_trusted\"></span> -->\r\n            <a href=\"javascript: void(0)\" ng-if=\"userProfile.resume\" ng-click=\"showHtmlViewer1(userProfile.resume, \'Resume\')\" class=\"link\">\r\n                              <b>View</b>\r\n                            </a>\r\n          </p>\r\n        </div>\r\n        <div ng-if=\"userProfile.statement\">\r\n          <p class=\"userInfo\">\r\n            <span>Statement </span>\r\n            <!-- <span class=\"infoAns\" ng-bind-html=\"userProfile.statement | to_trusted\"></span>\r\n                             -->\r\n            <a href=\"javascript: void(0)\" ng-if=\"userProfile.statement\" ng-click=\"showHtmlViewer1(userProfile.statement, \'Statement\')\" class=\"link\">\r\n                              <b>View</b>\r\n                            </a>\r\n          </p>\r\n        </div>\r\n        <!-- </div> -->\r\n        <div class=\"blockBottomLink\">\r\n\r\n          <span><a href=\"\" ng-click=\"getMatch()\" class=\"link\">Take their Match Quiz</a></span>\r\n          <!--         <a href=\"#!/question-answered-by/{{userId}}\" ng-click=\"\">See Match Answers</a>   -->\r\n        </div>\r\n      </div>\r\n      <!-- 10 BIGGEST CONTRIBUTORS  --->\r\n      <div class=\"contributorsBlock\" ng-if=\" propublicaData !=\'\' \">\r\n        <center>\r\n          <img ng-src=\"./assets/images/contributors.svg\" class=\"blockLink publicProfileImg img-fluid\">\r\n          <br>\r\n      </center>\r\n        <h5 class=\"blockHeading\">10 Biggest Contributors</h5>\r\n        <p class=\"accP\">\r\n          This is a list of the industries that contributed the most money to this politician\'s\r\n          compaign.\r\n          You\r\n          should see\r\n          this as their\r\n          endorsement. They spent millions of dollars to put this candidate into office because they\r\n          believed\r\n          that\r\n          this\r\n          candidate\r\n          would take actions that would benefit them in some way or another.\r\n        </p>\r\n        <div id=\"accordion\" class=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\">\r\n          <!-- <h5 class=\"blockHeading\">{{topContributorData[\'@attributes\'].cycle}}</h5> -->\r\n          <div class=\"legislationSelect\">\r\n            <select class=\"custom-select\" ng-model=\"contYear\" ng-change=\"getIndustrySupport(contYear)\">\r\n            <option ng-repeat=\"r in contYearArray\" value=\"{{r}}\">\r\n              {{r}}\r\n            </option>\r\n          </select>\r\n            <p ng-if=\"msg\">{{msg}}</p>\r\n          </div>\r\n          <div class=\"card\" ng-repeat=\"industry in industrySupport.industry track by $index\">\r\n            <div class=\"card-header collapsed\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#block_{{$index}}\"\r\n              target=\"_self\" ng-click=\"isClicked = !isClicked\">\r\n              <a class=\"card-title\">\r\n              <div style=\"width:65%; display: inline-flex;\">\r\n                <div>\r\n                  <div class=\"fa fa-fw list-arrow listIcons\" ng-class=\"{\'fa-caret-down\': isClicked, \'fa-caret-right\' : !isClicked}\">\r\n                    </div>\r\n                </div>\r\n                <div>{{industry[\'@attributes\'].industry_name}}</div>\r\n              </div>\r\n              <span class=\"cardRightHeading\" style=\"float:right;\">{{industry[\'@attributes\'].total | currency}}</span>\r\n            </a>\r\n            </div>\r\n            <div id=\"block_{{$index}}\" class=\"collapse\" role=\"tabpanel\" aria-labelledby=\"{{$index}}\">\r\n              <div class=\"card-block\">\r\n                <div class=\"cardRightContent removeBold\">Individuals:\r\n                  {{industry[\'@attributes\'].indivs | currency}}</div>\r\n                <div class=\"cardRightContent removeBold\">PACs:\r\n                  {{industry[\'@attributes\'].pacs | currency}}\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"blockBottomLink\">\r\n          <!-- <a href=\"#!/polFinance/{{userId}}/true\" ng-click=\"\">See More Financial Info</a> -->\r\n          <a href=\"https://www.opensecrets.org/members-of-congress/summary?cid={{memberCrpId}}\" target=\"_blank\">See More Financial Info</a>\r\n          <br>\r\n          <a href=\"https://www.opensecrets.org/members-of-congress/summary?cid={{memberCrpId}}\" target=\"_blank\">\r\n                    <image src=\"../assets/images/openSecrets.svg\" class=\"partners\"></image></a>\r\n        </div>\r\n      </div>\r\n      <!---   RATINGS  -->\r\n      <div class=\"ratingsBlock\" ng-if=\"ratingsData.length >0\">\r\n\r\n        <center>\r\n          <img ng-src=\"./assets/images/rating.svg\" class=\"blockLink publicProfileImg img-fluid\">\r\n          <br>\r\n      </center>\r\n        <h5 class=\"blockHeading\">RATINGS</h5>\r\n        <!-- <p>Topic</p> -->\r\n        <div ng-if=\"ratingsData.length > 0\">\r\n          <div>ORGANIZATIONS : RATING</div>\r\n          <div ng-repeat=\"rtdt in ratingsData | limitTo:5\" style=\"text-transform: capitalize;\">\r\n            {{rtdt.orgName}}{{rtdt.pName}} :\r\n            {{rtdt.candidateRating[0].rating}}%\r\n          </div>\r\n          <div class=\"blockBottomLink\" ng-if=\"ratingsData.length > 5\">\r\n            <a href=\"#!/allRatings/{{userId}}/false/true\" ng-click=\"\">See More</a>\r\n          </div>\r\n          <div class=\"blockBottomLink\" ng-if=\"ratingsData.length <= 5 && ratingsData.length >=1\">\r\n            <a href=\"#!/allRatings/{{userId}}/false/true\" ng-click=\"\">See Details</a>\r\n          </div><br>\r\n                        </div>\r\n        <p ng-if=\"ratingsData.length == 0\">Ratings not avialble.</p>\r\n      </div>\r\n      <!--   COMMITTEES -->\r\n      <div class=\"committeesBlock\" ng-if=\"propublicaData != \'\'\">\r\n        <center>\r\n          <img ng-src=\"./assets/images/committee.svg\" class=\"blockLink publicProfileImg img-fluid\">\r\n          <br>\r\n      </center>\r\n        <h5 class=\"blockHeading\">COMMITTEES</h5>\r\n        <!-- <div class=\"blockBottomLink\">\r\n            <a href=\"\">{{memberRole.congress}}</a>\r\n          </div> -->\r\n        <div class=\"legislationSelect\">\r\n          <select class=\"custom-select\" ng-model=\"selectedYearCommittee\" ng-change=\"showPreviousYearRole(selectedYearCommittee, \'committee\')\">\r\n          <option ng-repeat=\"r in committeesYears\" value=\"{{r.id}}\">\r\n            {{r.year}}\r\n          </option>\r\n        </select>\r\n        </div>\r\n        <!-- <div class=\"comitteeHeading\">Committees : </div> -->\r\n        <!-- <div ng-repeat=\"commity in memberRole.committees\" style=\"margin-bottom:10px;\">\r\n            <div>Name : {{commity.name}}</div>\r\n            <div>Rank In Party : {{commity.rank_in_party}}</div>\r\n            <div>Begin Date : {{commity.begin_date}}</div>\r\n            <div>End Date : {{commity.end_date}}</div>\r\n          </div> -->\r\n        <div id=\"accordion1\" class=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\">\r\n          <div class=\"card\" ng-repeat=\"commity in committeeData track by $index\">\r\n            <div class=\"card-header collapsed\" data-toggle=\"collapse\" data-parent=\"#accordion1\"\r\n              href=\"#blockComittee_{{$index}}\" target=\"_self\" ng-click=\"isClicked = !isClicked\">\r\n              <!-- <a class=\"card-title\">\r\n                  {{commity.committeeName}}\r\n                </a> -->\r\n              <a class=\"card-title\">\r\n              <div style=\"width:100%; display: inline-flex;\">\r\n                <div>\r\n                  <div class=\"fa fa-fw list-arrow listIcons\" ng-class=\"{\'fa-caret-down\': isClicked, \'fa-caret-right\' : !isClicked}\">\r\n                  </div>\r\n                </div>\r\n                <div>{{commity.committeeName}}</div>\r\n              </div>\r\n              <!-- <span class=\"cardRightHeading\" style=\"float:right;\">${{cont[\'@attributes\'].total}}</span> -->\r\n            </a>\r\n            </div>\r\n            <div id=\"blockComittee_{{$index}}\" class=\"collapse\" role=\"tabpanel\" aria-labelledby=\"{{$index}}\">\r\n              <div class=\"card-block cardblockComittee\">\r\n                <div>Rank In Party: {{commity.committeeRank}}</div>\r\n                <div>Begin Date: {{commity.committeeBeginDate}}</div>\r\n                <div>End Date: {{commity.committeeEndDate}}</div>\r\n              </div>\r\n            </div>\r\n            <div ng-if=\"commity.subcommittees.length > 0\" style=\"padding-left:30px;\">\r\n              <div class=\"comitteeHeading\" style=\"padding-left:15px;\">Subcommittees : </div>\r\n              <div id=\"accordion5\" class=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\">\r\n                <div class=\"card\" ng-repeat=\"scommity in commity.subcommittees track by $index\">\r\n                  <div class=\"card-header collapsed\" data-toggle=\"collapse\" data-parent=\"#accordion5\"\r\n                    href=\"#subComittee_{{scommity.scommitteeCode}}_{{$index}}\" target=\"_self\"\r\n                    ng-click=\"isClicked = !isClicked\">\r\n                    <!-- <a class=\"card-title\">\r\n                        {{scommity.scommitteeName}}\r\n                      </a> -->\r\n                    <a class=\"card-title\">\r\n                    <div style=\"width:100%; display: inline-flex;\">\r\n                      <div>\r\n                        <div class=\"fa fa-fw list-arrow listIcons\" ng-class=\"{\'fa-caret-down\': isClicked, \'fa-caret-right\' : !isClicked}\">\r\n                        </div>\r\n                      </div>\r\n                      <div>{{scommity.scommitteeName}}</div>\r\n                    </div>\r\n                    <!-- <span class=\"cardRightHeading\" style=\"float:right;\">${{cont[\'@attributes\'].total}}</span> -->\r\n                  </a>\r\n                  </div>\r\n                  <div id=\"subComittee_{{scommity.scommitteeCode}}_{{$index}}\" class=\"collapse\" role=\"tabpanel\"\r\n                    aria-labelledby=\"{{$index}}\">\r\n                    <div class=\"card-block cardblockComittee\">\r\n                      <div>Rank In Party: {{scommity.scommitteeRank}}</div>\r\n                      <div>Begin Date: {{scommity.scommitteeBeginDate}}</div>\r\n                      <div>End Date: {{scommity.scommitteeEndDate}}</div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <!-- <div class=\"blockBottomLink\">\r\n            <a href=\"\">See Previous Years</a>\r\n            <br />\r\n             <span ng-repeat=\"r in committeesYears\" ng-click=\"showPreviousYearRole(r.committeesid)\">{{r.year}}<span ng-hide=\"$last\">, </span></span>\r\n          </div> -->\r\n        <br></div>\r\n				\r\n							\r\n      <!--   TWITTER SEARCH  -->\r\n							\r\n							\r\n      <div class=\"twitterBlock\" ng-if=\"propublicaData.twitter_account ||  userProfile.campaignInfo[0].campaignTwitterurl\">\r\n        <center>\r\n          <img ng-src=\"./assets/images/twitterSearch.svg\" class=\"blockLink publicProfileImg img-fluid\">\r\n          <br>\r\n      </center>\r\n							<!--<div ng-if=\"userProfile.officeTwitterFeed == propublicaData.twitter_account || !propublicaData.twitter_account || 	!userProfile.officeTwitterFeed\">-->\r\n        <h5 class=\"blockHeading\">TWITTER SEARCH</h5>\r\n							\r\n								<div ng-if=\"userProfile.officeTwitterFeed && !propublicaData.twitter_account && userProfile.campaignInfo[0].campaignTwitterurl !=userProfile.officeTwitterFeed\">\r\n									<center><b>OFFICE TWITTER</b></center>\r\n        <p>Search <span style=\"text-transform: capitalize;\">{{userProfile.name}}</span>\'s\r\n          Office Twitter feed by entering search words or hashtags.\r\n        </p>\r\n\r\n        <p>Search Words: <input ng-model=\"sw1\" class=\"blackText\"><br></p>\r\n							\r\n        <center>\r\n									<span ng-if=\"userProfile.officeTwitterFeed.substring(0,4) != \'http\'\"}}>\r\n										<a ng-href=\"https://twitter.com/search?q={{sw1}}(from%3A{{userProfile.officeTwitterFeed}})&src=typed_query&f=live\" target=\"_blank\"><button class=\"compareBtn\">Search</button></a></span>\r\n        </center>\r\n							\r\n							<center>\r\n											<span ng-if=\"propublicaData.twitter_account.substring(0,4) == \'http\'\"}}>\r\n            <a ng-href=\"https://twitter.com/search?q={{sw1}}(from%3A{{userProfile.officeTwitterFeed.substring(20)}})&src=typed_query&f=live\" target=\"_blank\"><button class=\"compareBtn\">Search</button></a>\r\n											</span>\r\n          </center>\r\n							\r\n        <a class=\"twitter-timeline\" data-width=\"500\" data-height=\"500\" href=\"https://twitter.com/{{propublicaData.twitter_account}}?ref_src=twsrc%5Etfw\"></a>\r\n							</div>\r\n							\r\n							\r\n															<div ng-if=\"propublicaData.twitter_account  && userProfile.campaignInfo[0].campaignTwitterurl !=userProfile.officeTwitterFeed\">\r\n									<center><b>OFFICE TWITTER</b></center>\r\n        <p>Search <span style=\"text-transform: capitalize;\">{{userProfile.name}}</span>\'s\r\n          Office Twitter feed by entering search words or hashtags.\r\n        </p>\r\n\r\n        <p>Search Words: <input ng-model=\"sw1\" class=\"blackText\"><br></p>\r\n							\r\n        <center>\r\n									<span ng-if=\"propublicaData.twitter_account.substring(0,4) != \'http\'\"}}>\r\n										<a ng-href=\"https://twitter.com/search?q={{sw1}}(from%3A{{propublicaData.twitter_account}})&src=typed_query&f=live\" target=\"_blank\"><button class=\"compareBtn\">Search</button></a></span>\r\n        </center>\r\n							\r\n							<center>\r\n											<span ng-if=\"propublicaData.twitter_account.substring(0,4) == \'http\'\"}}>\r\n            <a ng-href=\"https://twitter.com/search?q={{sw1}}(from%3A{{propublicaData.twitter_account.substring(20)}})&src=typed_query&f=live\" target=\"_blank\"><button class=\"compareBtn\">Search</button></a>\r\n											</span>\r\n          </center>\r\n							\r\n        <a class=\"twitter-timeline\" data-width=\"500\" data-height=\"500\" href=\"https://twitter.com/{{propublicaData.twitter_account}}?ref_src=twsrc%5Etfw\"></a>\r\n							</div>\r\n							\r\n							\r\n										<div ng-if=\"userProfile.campaignInfo[0].campaignTwitterurl && propublicaData.twitter_account\">\r\n											<br>\r\n											<hr style=\"height:1px; background-color: black; margin-right: 10%;\">\r\n											<br></div>\r\n										<div ng-if=\"userProfile.campaignInfo[0].campaignTwitterurl  && userProfile.campaignInfo[0].campaignTwitterurl !=userProfile.officeTwitterFeed\">\r\n									<center><b>CAMPAIGN TWITTER</b></center>\r\n									\r\n								 <p>Search <span style=\"text-transform: capitalize;\">{{userProfile.name}}</span>\'s\r\n          Campaign Twitter feed\r\n          by entering search words or hashtags.\r\n        </p>\r\n\r\n        <p>Search Words: <input ng-model=\"sw2\" class=\"blackText\"><br></p>\r\n							\r\n        <center>\r\n									<span ng-if=\"userProfile.campaignInfo[0].campaignTwitterurl.substring(0,4) != \'http\'\"}}>\r\n										<a ng-href=\"https://twitter.com/search?q={{sw2}}(from%3A{{userProfile.campaignInfo[0].campaignTwitterurl}})&src=typed_query&f=live\" target=\"_blank\"><button class=\"compareBtn\">Search</button></a></span>\r\n        </center>\r\n							\r\n							<center>\r\n											<span ng-if=\"userProfile.campaignInfo[0].campaignTwitterurl.substring(0,4) == \'http\'\"}}>\r\n            <a ng-href=\"https://twitter.com/search?q={{sw2}}(from%3A{{userProfile.campaignInfo[0].campaignTwitterurl.substring(20)}})&src=typed_query&f=live\" target=\"_blank\"><button class=\"compareBtn\">Search</button></a>\r\n											</span>\r\n          </center>\r\n		\r\n											\r\n        <a class=\"twitter-timeline\" data-width=\"500\" data-height=\"500\" href=\"https://twitter.com/{{propublicaData.twitter_account}}?ref_src=twsrc%5Etfw\"></a>\r\n        <script async src=\"https://platform.twitter.com/widgets.js\" charset=\"utf-8\"></script>\r\n								\r\n        <script async src=\"https://platform.twitter.com/widgets.js\" charset=\"utf-8\"></script>\r\n							</div>\r\n							\r\n																	<div ng-if=\"userProfile.campaignInfo[0].campaignTwitterurl  && userProfile.campaignInfo[0].campaignTwitterurl ==userProfile.officeTwitterFeed\">\r\n\r\n								 <p>Search <span style=\"text-transform: capitalize;\">{{userProfile.name}}</span>\'s\r\n           Twitter feed\r\n          by entering search words or hashtags.\r\n        </p>\r\n\r\n        <p>Search Words: <input ng-model=\"sw2\" class=\"blackText\"><br></p>\r\n							\r\n        <center>\r\n									<span ng-if=\"userProfile.campaignInfo[0].campaignTwitterurl.substring(0,4) != \'http\'\"}}>\r\n										<a ng-href=\"https://twitter.com/search?q={{sw2}}(from%3A{{userProfile.campaignInfo[0].campaignTwitterurl}})&src=typed_query&f=live\" target=\"_blank\"><button class=\"compareBtn\">Search</button></a></span>\r\n        </center>\r\n							\r\n							<center>\r\n											<span ng-if=\"userProfile.campaignInfo[0].campaignTwitterurl.substring(0,4) == \'http\'\"}}>\r\n            <a ng-href=\"https://twitter.com/search?q={{sw2}}(from%3A{{userProfile.campaignInfo[0].campaignTwitterurl.substring(20)}})&src=typed_query&f=live\" target=\"_blank\"><button class=\"compareBtn\">Search</button></a>\r\n											</span>\r\n          </center>\r\n		\r\n											\r\n        <a class=\"twitter-timeline\" data-width=\"500\" data-height=\"500\" href=\"https://twitter.com/{{propublicaData.twitter_account}}?ref_src=twsrc%5Etfw\"></a>\r\n        <script async src=\"https://platform.twitter.com/widgets.js\" charset=\"utf-8\"></script>\r\n								\r\n        <script async src=\"https://platform.twitter.com/widgets.js\" charset=\"utf-8\"></script>\r\n							</div>\r\n							</div>\r\n							\r\n					\r\n					</div>\r\n							\r\n							\r\n    </div>\r\n</div>\r\n<br>\r\n<div></div>\r\n\r\n<div class=\"bottomInfo\">\r\n  <p>Candidate information is provided in part by The Center for Tech and Civic Life, VoteSmart, ProPublica, Open States, Open Secrets, The Library of Congress, The Federal Elections Commission, The League of Women Voters of the City of New York, and by your local boards of elections.</p>\r\n\r\n  <p>\r\n       <a href=\"https://www.techandciviclife.org/\" target=\"_blank\">\r\n          <image\r\n            src=\"../assets/images/TechAndCivicLife.png\"\r\n            class=\"partners\"\r\n          ></image\r\n        ></a>\r\n			<a href=\"https://votesmart.org/\" target=\"_blank\">\r\n                    <image src=\"../assets/images/VoteSmartLogoD.png\" class=\"partners\"></image></a>\r\n    <a href=\"https://www.propublica.org/\" target=\"_blank\">\r\n                    <image src=\"../assets/images/logo-propublica.svg\" class=\"partners\"></image></a>\r\n\r\n    <a href=\"https://openstates.org/\" target=\"_blank\">\r\n                    <image src=\"../assets/images/openstates_logo.d5ae3c5f606e.svg\" class=\"partners\"></image></a>\r\n    <a href=\"https://www.opensecrets.org//\" target=\"_blank\">\r\n                    <image src=\"../assets/images/opensecrets_databy250x88.gif\" class=\"partners\"></image></a>\r\n    <a href=\"https://www.loc.gov/\" target=\"_blank\">\r\n                    <image src=\"../assets/images/LibraryOfCongressLogo.svg\" class=\"partners\"></image></a>\r\n    <a href=\"https://www.fec.gov/\" target=\"_blank\">\r\n                    <image src=\"../assets/images/FECseal.svg\" class=\"partnersCircle\"></image></a>\r\n				<a href=\"https://my.lwv.org/new-york/city-new-york\" target=\"_blank\"><image src=\"../assets/images/LWVofNYCsmall.jpg\" class=\"partners\"></image></a>\r\n  </p>\r\n\r\n \r\n</div>\r\n<script type=\"text/ng-template\" id=\"statement\">\r\n              <div class=\"row\">\r\n              <div ng-bind-html=\'displayContent\' class=\"txtwindow\"></div>\r\n            </div>\r\n          </script>\r\n<script type=\"text/ng-template\" id=\"LatestEssayId\">\r\n            <div class=\"latestPosts\">\r\n              <h3>Latest Essay</h3>\r\n              <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"LatestEssay==0\"></i>\r\n              <ul>\r\n                <li ng-repeat=\"essay in LatestEssay track by $index\">\r\n                  <div class=\"boldbox\">\r\n                    <span ng-click=\"gotoEssay(essay._id, essay.parentCat[0]);\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">{{essay.title}}</span>\r\n                  </div>\r\n                  <!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                                <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n                            </label> -->\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </script>\r\n<script type=\"text/ng-template\" id=\"LatestEssayCommentId\">\r\n            <div class=\"latestPosts\">\r\n              <h3>Latest Essay Comments</h3>\r\n              <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"LatestEssayComments==0\"></i>\r\n              <ul>\r\n                <li ng-repeat=\"essay in LatestEssayComments track by $index\">\r\n                  <div class=\"boldbox\">\r\n                    <!-- <div  ng-bind-html=\'essay.comments | urlify\' ng-click=\"gotoComments(essay.essayId)\"></div> -->\r\n                    <span ng-click=\"gotoComments(essay._id, essay.parentCat[0]);\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">{{essay.title}}</span>\r\n                  </div>\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </script>\r\n<script type=\"text/ng-template\" id=\"LatestPostId\">\r\n            <div class=\"latestPosts\">\r\n              <h3>Latest Posts</h3>\r\n              <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"LatestPost==0\"></i>\r\n              <ul>\r\n                <li ng-repeat=\"post in LatestPost track by $index\">\r\n                  <div class=\"boldbox\">\r\n                    <span ng-click=\"gotoThread(post, post.subCategories[0].pid);\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">{{post.title}}</span>\r\n                  </div>\r\n                  <!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                                <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n                            </label> -->\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </script>\r\n<script type=\"text/ng-template\" id=\"LatestThreadId\">\r\n            <div class=\"latestPosts\">\r\n              <h3>Latest Threads</h3>\r\n              <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"LatestThread==0\"></i>\r\n              <ul>\r\n                <li ng-repeat=\"thread in LatestThread track by $index\">\r\n                  <div class=\"boldbox\">\r\n                    <span ng-click=\"gotoThread(thread, thread.subCategories[0].pid);\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">{{thread.title}}</span>\r\n                  </div>\r\n                  <!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                                <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n                            </label> -->\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </script>\r\n<script type=\"text/ng-template\" id=\"TopicsOfInterest\">\r\n            <div class=\"latestPosts\">\r\n              <h3>Topics Of Interest</h3>\r\n              <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"TopicsOfInterests.length == 0\"></i>\r\n              <ul>\r\n                <li ng-repeat=\"topic in TopicsOfInterests track by $index\">\r\n                  <div class=\"boldbox\">\r\n                    <span style=\"cursor:pointer; font-weight: bolder;\">{{topic.title}}</span>\r\n                  </div>\r\n\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </script>\r\n");
$templateCache.put("app/question/question.html","<!-- <pre>{{status.category}} | {{status.levlCat}}</pre> -->\r\n<p ng-if=\"status.levlCat == 1\" class=\"fwb\">Loading background ...</p>\r\n<div class=\"pad10\">\r\n  <div class=\"clearfix w100\">\r\n    <div ng-show=\"[\'question\', \'question-background\'].indexOf(state) > -1 && userId\">\r\n    </div>\r\n  </div>\r\n  <div class=\"clearfix w100\" ng-if=\"state == \'question-answered-by\' && politicianName\">\r\n    Showing questions answered by <b>{{politicianName}}</b>\r\n  </div>\r\n  <div>\r\n    <p>\r\n      <h1>\r\n        <center>{{category.title}}</center>\r\n      </h1>\r\n    </p>\r\n    <p></p>\r\n    <div>\r\n      <center ng-if=\"category.fbImage\">\r\n        <img ng-src=\"https://api.votewise.net/resources/{{category.fbImage}}\" class=\"wibble\" />\r\n      </center>\r\n    </div>\r\n    <center id=\"DisplayC\">\r\n      <h2>BACKGROUND</h2>\r\n    </center>\r\n    <p></p>\r\n    <div class=\"row d-flex justify-content-center\">\r\n      <div class=\"col-lg-7 col-sm-12\">\r\n        <p ng-bind-html=\"category.description | newlines\"></p>\r\n      </div>\r\n      <div ng-if=\"status.category == 1\" class=\"fwb\">\r\n        Loading category ...\r\n      </div>\r\n      <div ng-if=\"status.category == 3\" class=\"fwb\">\r\n        Something went wrong while loading category.\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <br>\r\n  <br>\r\n  <div ng-show=\"[\'question\', \'question-tagged\', \'question-background\', \'question-search\'].indexOf(state) > -1\">\r\n    <center id=\"DisplayQ\">\r\n      <label ng-hide=\"questions[currentIndex]\">\r\n        <input type=\"checkbox\" ng-model=\"flagSkipAnsweredQuestion\" ng-change=\"skipAnswerChagne()\"> Skip Answered Questions\r\n      </label>\r\n    </center>\r\n    <!-- </div> -->\r\n    <div>\r\n      <!-- ng-show=\"state == \'question\' || state == \'question-tagged\' || state == \'question-background\'\" -->\r\n      <div ng-show=\"questions[currentIndex]\">\r\n        <!-- <type=\"button\" value=\"LEARN MORE\"> -->\r\n        <p></p>\r\n        <div class=\"row  d-flex justify-content-center\">\r\n          <div class=\"col-lg-7 col-sm-12 \">\r\n            <h4 class=\"text-center\">Questions</h4>\r\n            <div class=\"card customCard\">\r\n              <div class=\"card-header quesCardHeaderMain\">\r\n                <div class=\"d-flex justify-content-between bd-highlight\">\r\n                  <!-- <div class=\"p-2 bd-highlight quesCardHeader\">Statement</div> -->\r\n                  <div class=\"p-2 bd-highlight\">\r\n                    <span class=\"textYellow\">{{currentIndex+1}}</span>/{{questions.length}}</div> <label>\r\n                    <input type=\"checkbox\" ng-model=\"flagSkipAnsweredQuestion\" ng-change=\"skipAnswerChagne()\"> Skip Answered Questions\r\n                  </label>\r\n                </div>\r\n              </div>\r\n              <div class=\"card-body customCardBody\">\r\n                <p  class=\"card-text\" ng-bind-html=\"questions[currentIndex].content | newlines\"></p>\r\n                <div class=\"row vdivide\">\r\n                  <div class=\"col col-6\">\r\n                    <div class=\"rcontent\" style=\"float:right;\">\r\n                      <span id=\"disagreeText\">DISAGREE &nbsp;</span>\r\n                      <div style=\"float:right;\">\r\n                        <div class=\"box\">\r\n                          <ul class=\"vi-radio\">\r\n                            <li>\r\n                              <input type=\"radio\" id=\"agreedisagree-id6\" name=\"agreeDisagree\" value=\"6\" ng-model=\"answer\" ng-checked=\"checkIfExists(6)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                              <label for=\"agreedisagree-id6\"></label>\r\n                              <div class=\"checknew red sixth\"></div>\r\n                            </li>\r\n                          </ul>\r\n                        </div>\r\n                        <div class=\"box\">\r\n                          <ul class=\"vi-radio\">\r\n                            <li>\r\n                              <input type=\"radio\" id=\"agreedisagree-id5\" name=\"agreeDisagree\" value=\"5\" ng-model=\"answer\" ng-checked=\"checkIfExists(5)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                              <label for=\"agreedisagree-id5\"></label>\r\n                              <div class=\"checknew five fifth\"></div>\r\n                            </li>\r\n                          </ul>\r\n                        </div>\r\n                        <div class=\"box\">\r\n                          <ul class=\"vi-radio\">\r\n                            <li>\r\n                              <input type=\"radio\" id=\"agreedisagree-id4\" name=\"agreeDisagree\" value=\"4\" ng-model=\"answer\" ng-checked=\"checkIfExists(4)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                              <label for=\"agreedisagree-id4\"></label>\r\n                              <div class=\"checknew four forth\"></div>\r\n                            </li>\r\n                          </ul>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col col-6\">\r\n                    <div class=\" rcontent\">\r\n                      <span  style=\"color: #04A752; font-weight: bold;\">&nbsp;AGREE</span>\r\n                      <div style=\"float:left;\">\r\n                        <div class=\"box\">\r\n                          <ul class=\"vi-radio\">\r\n                            <li>\r\n                              <input type=\"radio\" id=\"agreedisagree-id3\" name=\"agreeDisagree\" value=\"3\" ng-model=\"answer\" ng-checked=\"checkIfExists(3)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                              <label for=\"agreedisagree-id3\"></label>\r\n                              <div class=\"checknew three third\"></div>\r\n                            </li>\r\n                          </ul>\r\n                        </div>\r\n                        <div class=\"box\">\r\n                          <ul class=\"vi-radio\">\r\n                            <li>\r\n                              <input type=\"radio\" id=\"agreedisagree-id2\" name=\"agreeDisagree\" value=\"2\" ng-model=\"answer\" ng-checked=\"checkIfExists(2)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                              <label for=\"agreedisagree-id2\"></label>\r\n                              <div class=\"checknew two second\"></div>\r\n                            </li>\r\n                          </ul>\r\n                        </div>\r\n                        <div class=\"box\">\r\n                          <ul class=\"vi-radio\">\r\n                            <li>\r\n                              <input type=\"radio\" id=\"agreedisagree-id1\" name=\"agreeDisagree\" value=\"1\" ng-model=\"answer\" ng-checked=\"checkIfExists(1)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                              <label for=\"agreedisagree-id1\"></label>\r\n                              <div class=\"checknew first\"></div>\r\n                            </li>\r\n                          </ul>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"card card1\">\r\n              <div class=\"card-header card1Header\">\r\n                <p class=\"card-title\">ADD COMMENT</p>\r\n              </div>\r\n              <div class=\"card-body card1Body\">\r\n                <textarea class=\"form-control addComment\" id=\"exampleFormControlTextarea1\" ng-model=\"comment\" rows=\"1\" placeholder=\"(not required)\"></textarea>\r\n                <textarea ng-show=\"questions[currentIndex].my_answer\" ng-model=\"reason\" class=\"vi-textarea\" placeholder=\"REASON TO CHANGE ANSWER\" style=\"margin-top: 10px;\"></textarea>\r\n              </div>\r\n            </div>\r\n            <div class=\"card card1\">\r\n              <div class=\"card-header card1Header\">\r\n                <p class=\"card-title\">IMPORTANCE</p>\r\n              </div>\r\n              <div class=\"card-body card1Body\" style=\"margin:0 auto;\">\r\n                <form class=\"impSection d-md-flex d-sm-block\">\r\n                  <div class=\"A\">\r\n                    <input type=\"radio\" class=\"button\" id=\"importance-id1\" ng-model=\"importance\" name=\"importance\" ng-model=\"importance\" ng-checked=\"checkImpExists(1)\" ng-click=\"subNew(1)\" value=\"1\"></input>\r\n                    <label for=\"importance-id1\">Not Very</label>\r\n                  </div>\r\n                  <div class=\"B\">\r\n                    <input type=\"radio\" class=\"button\" id=\"importance-id2\" ng-model=\"importance\" name=\"importance\" ng-model=\"importance\" ng-checked=\"checkImpExists(2)\" ng-click=\"subNew(2)\" value=\"2\"></input>\r\n                    <label for=\"importance-id2\">Somewhat</label>\r\n                  </div>\r\n                  <div class=\"C\">\r\n                    <input type=\"radio\" class=\"button\" id=\"importance-id3\" ng-model=\"importance\" name=\"importance\" ng-model=\"importance\" ng-checked=\"checkImpExists(3)\" ng-click=\"subNew(3)\" value=\"3\"></input>\r\n                    <label for=\"importance-id3\">Very</label>\r\n                  </div>\r\n                  <!-- </div> -->\r\n                </form>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\">\r\n              <div class=\"col bottomBtns\">\r\n                <div class=\"btn-group\" role=\"group\" aria-label=\"Default button group\">\r\n                  <button type=\"button\" id=\"backBtn\" class=\"btn-transparent\" ng-click=\"prevQuestion()\">\r\n                    <i class=\"fa fa-angle-left arrowIconBack\"></i> Back</button>\r\n                  <button type=\"button\" id=\"skipBtn\" class=\"btn-transparent\" ng-click=\"skipQuestion()\">Skip</button>\r\n                  <button type=\"button\" id=\"submitBtn\" class=\"btn-transparent\" ng-click=\"submitAnswer()\" ng-class=\"{\'activeSubmit\': (answer &&importance)}\">Submit\r\n                    <i class=\"fa fa-angle-right arrowIconSubmit\"></i>\r\n                  </button>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <center>\r\n              <button type=\"button\" id=\"btnY\" class=\"btn-transparent\" ng-click=\"notAnswerableSelected()\" ng-show=\"$root.userRole==\'admin\'||$root.userRole==\'advocate\' \">REPORT BAD QUESTION</button>\r\n            </center>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <!-- only show answers, dont allow user to modify the answeres -->\r\n  <!--  <div ng-if=\"state == \'question-answered-by\'\">\r\n    <div ng-show=\"questions[currentIndex]\">\r\n\r\n      <p></p>\r\n      <center id=\"DisplayQ\">\r\n        <h2>QUESTION</h2>\r\n      </center>\r\n      <p></p>\r\n      <p></p>\r\n      <center>({{currentIndex+1}} of {{questions.length}})</center>\r\n      <p></p>\r\n      <p>STATEMENT: {{questions[currentIndex].content}}</p>\r\n      <div class=\"flex\">\r\n        <div class=\"margin-auto mxw\">\r\n          <div class=\"vi-container clearfix\">\r\n            <div class=\"clearfix hori-line\">\r\n              <div class=\"radio-container-arrow\">\r\n                <div class=\"arrow-down\"></div>\r\n              </div>\r\n              <div class=\"radio-lbl-left cap_first\">AGREE</div>\r\n              <div class=\"radio-lbl-right cap_first\">DISAGREE</div>\r\n              <div class=\"radio-container\">\r\n                <div class=\"box\">\r\n                  <ul class=\"vi-radio\">\r\n                    <li>\r\n                      <input type=\"radio\" id=\"agreedisagree-id1\" name=\"agreeDisagree\" value=\"1\" ng-model=\"answer\" ng-checked=\"questions[currentIndex].user_answer.answer==1 ? \'checked\': \'\'\" disabled>\r\n                      <label></label>\r\n\r\n                      <div class=\"check\"></div>\r\n                    </li>\r\n                  </ul>\r\n                </div>\r\n                <div class=\"box\">\r\n                  <ul class=\"vi-radio\">\r\n                    <li>\r\n                      <input type=\"radio\" id=\"agreedisagree-id2\" name=\"agreeDisagree\" value=\"2\" ng-model=\"answer\" ng-checked=\"questions[currentIndex].user_answer.answer==2 ? \'checked\': \'\'\" disabled>\r\n                      <label></label>\r\n\r\n                      <div class=\"check two\"></div>\r\n                    </li>\r\n                  </ul>\r\n                </div>\r\n                <div class=\"box\">\r\n                  <ul class=\"vi-radio\">\r\n                    <li>\r\n                      <input type=\"radio\" id=\"agreedisagree-id3\" name=\"agreeDisagree\" value=\"3\" ng-model=\"answer\" ng-checked=\"questions[currentIndex].user_answer.answer==3 ? \'checked\': \'\'\" disabled>\r\n                      <label></label>\r\n\r\n                      <div class=\"check three\"></div>\r\n                    </li>\r\n                  </ul>\r\n                </div>\r\n                <div class=\"box\">\r\n                  <ul class=\"vi-radio\">\r\n                    <li>\r\n                      <input type=\"radio\" id=\"agreedisagree-id4\" name=\"agreeDisagree\" value=\"4\" ng-model=\"answer\" ng-checked=\"questions[currentIndex].user_answer.answer==4 ? \'checked\': \'\'\" disabled>\r\n                      <label></label>\r\n\r\n                      <div class=\"check four\"></div>\r\n                    </li>\r\n                  </ul>\r\n                </div>\r\n                <div class=\"box\">\r\n                  <ul class=\"vi-radio\">\r\n                    <li>\r\n                      <input type=\"radio\" id=\"agreedisagree-id5\" name=\"agreeDisagree\" value=\"5\" ng-model=\"answer\" ng-checked=\"questions[currentIndex].user_answer.answer==5 ? \'checked\': \'\'\" disabled>\r\n                      <label></label>\r\n\r\n                      <div class=\"check five\"></div>\r\n                    </li>\r\n                  </ul>\r\n                </div>\r\n                <div class=\"box\">\r\n                  <ul class=\"vi-radio\">\r\n                    <li>\r\n                      <input type=\"radio\" id=\"agreedisagree-id6\" name=\"agreeDisagree\" value=\"6\" ng-model=\"answer\" ng-checked=\"questions[currentIndex].user_answer.answer==6 ? \'checked\': \'\'\" disabled>\r\n                      <label></label>\r\n\r\n                      <div class=\"check red\"></div>\r\n                    </li>\r\n                  </ul>\r\n                </div>\r\n                <span class=\"stretch\"></span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <br>\r\n          <div class=\"vi-container clearfix\">\r\n            <div class=\"clearfix hori-line\">\r\n              <div class=\"radio-lbl-center cap_first\">IMPORTANCE</div>\r\n              <div class=\"radio-lbl-left cap_first\">SOMEWHAT</div>\r\n              <div class=\"radio-lbl-right cap_first\">VERY</div>\r\n              <div class=\"radio-container\" ng-init=\"tt= true\">\r\n                <div class=\"box\">\r\n                  <ul class=\"vi-radio\">\r\n                    <li>\r\n                      <input type=\"radio\" id=\"importance-id1\" name=\"importance\" value=\"1\" ng-model=\"importance\" ng-checked=\"questions[currentIndex].user_answer.importance==1 ? \'checked\': \'\'\" disabled>\r\n                      <label></label>\r\n\r\n                      <div class=\"check A\"></div>\r\n                    </li>\r\n                  </ul>\r\n                </div>\r\n                <div class=\"box\">\r\n                  <ul class=\"vi-radio\">\r\n                    <li>\r\n                      <input type=\"radio\" id=\"importance-id2\" name=\"importance\" value=\"2\" ng-model=\"importance\" ng-checked=\"questions[currentIndex].user_answer.importance==2 ? \'checked\': \'\'\" disabled>\r\n                      <label></label>\r\n\r\n                      <div class=\"check B\"></div>\r\n                    </li>\r\n                  </ul>\r\n                </div>\r\n                <div class=\"box\">\r\n                  <ul class=\"vi-radio\">\r\n                    <li>\r\n                      <input type=\"radio\" id=\"importance-id3\" name=\"importance\" ng-model=\"importance\" value=\"3\" ng-checked=\"questions[currentIndex].user_answer.importance==3 ? \'checked\': \'\'\" disabled>\r\n                      <label></label>\r\n\r\n                      <div class=\"check C\"></div>\r\n                    </li>\r\n                  </ul>\r\n                </div>\r\n                <span class=\"stretch\"></span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <br>\r\n          <div class=\"vi-container clearfix\">\r\n            <textarea ng-model=\"comment\" class=\"vi-textarea\" placeholder=\"ADD COMMENTS\" readonly=\"readonly\"></textarea>\r\n          </div>\r\n          <br>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div ng-show=\"questions.length > 0\" class=\"clearfix pad10 flex\">\r\n      <div class=\"margin-auto mxw\">\r\n        <div class=\"clearfix\">\r\n          <div class=\"arrow-left-wrapper clk\" ng-click=\"prevQuestion()\">\r\n            <div class=\"arrow-left-txt cap_first\">\r\n              BACK\r\n            </div>\r\n            <div class=\"arrow-left\"></div>\r\n          </div>\r\n          <div class=\"arrow-right-wrapper clk\" ng-click=\"skipQuestion()\">\r\n            <div class=\"arrow-right-txt cap_first\">\r\n              Next\r\n            </div>\r\n            <div class=\"arrow-right\"></div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div> -->\r\n</div>\r\n</div>\r\n<div ng-if=\"status.questions == 2 && questions.length == 0\" class=\"fwb\">\r\n  <center>No unanswered questions found.</center>\r\n</div>\r\n<div ng-if=\"status.questions == 1\" class=\"fwb\">\r\n  Loading questions ...\r\n</div>\r\n<div ng-if=\"status.questions == 3\" class=\"fwb\">\r\n  Something went wrong while loading questions.\r\n</div>\r\n<!--\r\n  <div>\r\n    <br>\r\n    <br>\r\n\r\n    <table>\r\n      <tbody>\r\n        <tr>\r\n          <th>\r\n            <center>\r\n              <a href=\"NotBuiltYet.html\">\r\n                <img src=\"assets/images/back3.svg\" alt=\"Back\" class=\"back\">\r\n              </a>\r\n            </center>\r\n          </th>\r\n          <th>\r\n            <center>\r\n              <a href=\"compare.html\">\r\n                <img src=\"assets/images/submit.svg\" alt=\"Submit\" class=\"submit\">\r\n              </a>\r\n            </center>\r\n          </th>\r\n          <th>\r\n            <center>\r\n              <a href=\"NotBuiltYet.html\">\r\n                <img src=\"assets/images/skip3.svg\" alt=\"Skip\" class=\"back\">\r\n              </a>\r\n            </center>\r\n          </th>\r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n  </div>\r\n  -->\r\n<script type=\"text/ng-template\" id=\"nextQuestionOptions\">\r\n  <ul class=\"catList\">\r\n    <li>\r\n      <input type=\"radio\" id=\"options1\" ng-model=\"fb.options\" value=\"C\" />\r\n      <label for=\"options1\">Continue Answering questions so your politicians know what you want them to do.</label>\r\n    </li>\r\n  <!--\r\n    <li>\r\n      <input type=\"radio\" id=\"options2\" ng-model=\"fb.options\" value=\"P\" />\r\n      <label for=\"options2\">Post this quiz for your friends to answer on Facebook.</label>\r\n    </li>\r\n    <li>\r\n      <input type=\"radio\" id=\"options3\" ng-model=\"fb.options\" value=\"Q\" />\r\n      <label for=\"options3\">Let me choose which questions to hide from Facebook.</label>\r\n    </li>\r\n    <li>\r\n      <input type=\"radio\" id=\"options4\" ng-model=\"fb.options\" value=\"M\" />\r\n      <label for=\"options4\">See how your friends match your answers.</label>\r\n    </li>\r\n-->\r\n    <li>\r\n      <input type=\"radio\" id=\"options5\" ng-model=\"fb.options\" value=\"F\" />\r\n      <label for=\"options5\">See how others answered</label>\r\n    </li>\r\n    <li>\r\n      <center><input type=\"button\" ng-click=\"NextOptions(fb.options)\" class=\"compareBtn\" value=\"Next\" />&nbsp;\r\n      <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"DisplayFLoader\"></i></center>\r\n    </li>\r\n\r\n  </ul>\r\n</script>\r\n<script type=\"text/ng-template\" id=\"FBComposeMessage\">\r\n  <center>\r\n    <h2>Post message on Facebook</h2>\r\n    <div>\r\n      <div style=\"width:15%; float:left;\">Message: </div>\r\n      <div style=\"width:84%; float:left;\">\r\n        <textarea ng-model=\"fb.message\" style=\"width:100%; height: 100px;\"></textarea>\r\n      </div>\r\n    </div>\r\n    <div style=\"clear:both;\"></div>\r\n    <div>\r\n      <div style=\"width:15%; float:left;\">&nbsp;</div>\r\n      <div style=\"width:84%; float:left; text-align:left;\">\r\n        <input type=\"button\" ng-click=\"postFB(fb.message)\" value=\"Submit to Facebook*\" />&nbsp;\r\n        <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"DisplayFPostLoader\"></i>\r\n        <p>\r\n          <b>*Note:</b>If you are not currently logged into Facebook, you must enable pop-ups in your browser in order for the\r\n          Facebook sign in window to pop up.</p>\r\n      </div>\r\n    </div>\r\n    <div style=\"clear:both;\"></div>\r\n</script>\r\n<script type=\"text/ng-template\" id=\"FBFreindList\">\r\n  <h3>Select friends to compare with your answers.</h3>\r\n  <ul class=\"catList\">\r\n    <li ng-repeat=\"frd in FBfreinds track by $index\">\r\n      <!--<div style=\"width:15%; height: 50px; float: left;\">\r\n            <i class=\"fa fa-check-circle\" aria-hidden=\"true\"></i> -->\r\n      <input type=\"checkbox\" id=\"{{$index}}\" name=\"selectedFrds[]\" value=\"{{frd.id}}\" ng-click=\"selectedFrd(frd)\" ng-checked=\"selection.indexOf({{frd.id}}) > -1\"\r\n      />\r\n      <label for=\"{{$index}}\">\r\n        <img ng-src=\"http://graph.facebook.com/{{frd.id}}/picture?type=square\" /> {{frd.name}}</label>\r\n      <!-- </div><div style=\"width:15%; height: 50px; float: left;\"><img ng-src=\"http://graph.facebook.com/{{frd.id}}/picture?type=square\" /></div> <div style=\"width:48%; height: 50px; float: left;\">{{frd.name}}</div> -->\r\n    </li>\r\n    <li>\r\n      <input type=\"button\" ng-click=\"ComapreWithSelected()\" value=\"Compare\" />\r\n    </li>\r\n  </ul>\r\n</script>\r\n<!--\r\n<script type=\"text/ng-template\" id=\"FBFreindCompare\">\r\n    <h3>Comparision with your freinds.</h3>\r\n    <ul class=\"catList\">\r\n        <li ng-repeat=\"quest in FBCompareList track by $index\">\r\n            <div style=\"width: 3%; float:left;\">{{$index + 1}}</div>\r\n            <div style=\"width: 96%; float:left;\">\r\n                <div>{{quest.content}}</div>\r\n                <div><b>My Answer:</b> {{AnswerArray[quest.my_answer.answer]}}, <b>Importance:</b> {{AnswerImpArray[quest.my_answer.importance]}}\r\n                <div ng-if=\"quest.my_answer.comment!=\'\'\" style=\"padding-left:10px;padding-right:10px;\"><i><small>Comments: {{quest.my_answer.comment}}</small></i></div>\r\n                </div>\r\n                <div ng-repeat=\"frd in quest.answers\"><b>{{frd.author.username}}:</b> {{AnswerArray[frd.answer]}}, <b>Importance:</b> {{AnswerImpArray[frd.importance]}}\r\n                    <div ng-if=\"frd.comment!=\'\'\" style=\"padding-left:10px;padding-right:10px;\"><i><small>Comments: {{frd.comment}}</i></small></div>\r\n                </div>\r\n            </div>\r\n            <div style=\"clear:both;\"></div>\r\n        </li>\r\n    </ul>\r\n</script>\r\n-->\r\n<script type=\"text/ng-template\" id=\"FBFreindCompare\">\r\n  <center>\r\n    <h2>Match</h2>\r\n    <h3>{{category.title}}</h3>\r\n  </center>\r\n  <div>\r\n    <div class=\"squareBoxY\" >&nbsp;</div>\r\n    <div class=\"squareMenu\">= Simple Comparison by answers alone.</div>\r\n    <div style=\"clear:both;\"></div>\r\n    <div class=\"squareBoxB\" >&nbsp;</div>\r\n    <div class=\"squareMenu\">= Weighted Comparison by answers and importance.</div>\r\n    <div style=\"clear:both;\"></div>\r\n  </div>\r\n  <div>\r\n    <div style=\"width:30%; float:left; text-align:right;\">Order By :&nbsp;&nbsp;</div>\r\n    <div style=\"width:65%; float:left; text-align:left;\">\r\n      <select ng-model=\"ord.Option\">\r\n        <option value=\"BW\">Best Weighted match</option>\r\n        <option value=\"W\">Worst weighted match</option>\r\n        <option value=\"BS\">Best simple match</option>\r\n        <option value=\"S\">Worst simple match</option>\r\n      </select>\r\n    </div>\r\n    <div style=\"clear:both;\"></div>\r\n  </div>\r\n  <ul class=\"catList\">\r\n    <li ng-repeat=\"frd in FBfreinds | orderBy:checkMyOrder track by $index\" ng-if=\"FBunWeighted[frd.id] && fbcombinedWeight[frd.id]\">\r\n      <div style=\"background-color:#bbb; padding:10px;\">\r\n        <div style=\"width: 15%; float:left;\">\r\n          <img ng-src=\"http://graph.facebook.com/{{frd.id}}/picture?type=square\" />\r\n          <br/>{{frd.name}}</div>\r\n        <div style=\"width: 84%; float:left;\">\r\n          <div>\r\n            <div class=\"fbunweighted\" style=\"width:{{(FBunWeighted[frd.id] / fbqlen[frd.id] )  | number:2}}%\">{{(FBunWeighted[frd.id] / fbqlen[frd.id] ) | number:2}}%</div>\r\n          </div>\r\n          <div>\r\n            <div class=\"fbweighted\" style=\"width:{{(fbcombinedWeight[frd.id] / fbmultiplier[frd.id])  | number:2}}%\">{{(fbcombinedWeight[frd.id] / fbmultiplier[frd.id]) | number:2}}%</div>\r\n          </div>\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n      </div>\r\n    </li>\r\n  </ul>\r\n</script>\r\n<script type=\"text/ng-template\" id=\"ReviewMyAnswers\">\r\n  <h3>Review Answers and hide them from your friends.</h3>\r\n  	 <center>\r\n    <div ng-if=\"showLoader\" style=\"z-index: 2; background:black;\"><i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span></div>\r\n\r\n  </center>\r\n  <table class=\"w100\">\r\n    <tr>\r\n      <th>Sr.</th>\r\n      <th>Question</th>\r\n      <th>Answer</th>\r\n      <th>Importance</th>\r\n      <th>Show/Hide</th>\r\n    </tr>\r\n    <tr ng-repeat=\"q in allQuestions track by $index\" ng-init=\"q.my_answer.show!=\'N\'? switchStatus[$index]=true: switchStatus[$index]=false;\">\r\n      <td>\r\n        {{$index + 1}}\r\n      </td>\r\n      <td style=\"text-align:left;\">\r\n        {{q.content}}\r\n      </td>\r\n      <td>\r\n        {{AnswerArray[q.my_answer.answer]}}\r\n      </td>\r\n      <td>\r\n        {{AnswerImpArray[q.my_answer.importance]}}\r\n      </td>\r\n      <td>\r\n        <!-- <div toggle-switch class=\"switch-small\" on-label=\"Show\" off-label=\"Hide\" ng-model=\"switchStatus\"></div> -->\r\n        <toggle-switch ng-model=\"switchStatus[$index]\" class=\"switch-small\" on-label=\"Show\" off-label=\"Hide\" ng-change=\"switchFilters(switchStatus, $index, q)\"></toggle-switch>\r\n      </td>\r\n    </tr>\r\n  </table>\r\n</script>\r\n");
$templateCache.put("app/questionAnsweredBy/questionAnsweredBy.html","<p ng-if=\"status.levlCat == 1\" class=\"fwb\">Loading background ...</p>\r\n<div class=\"pad10\">\r\n  <div class=\"clearfix w100\">\r\n    <div ng-show=\"[\'question\', \'question-background\'].indexOf(state) > -1 && userId\">\r\n    </div>\r\n  </div>\r\n  <div class=\"clearfix w100\" ng-if=\"state == \'question-answered-by\' && politicianName\">\r\n    Showing questions answered by <b>{{politicianName}}</b>\r\n  </div>\r\n  <div>\r\n    <p>\r\n      <h1>\r\n        <center>{{category.title}}</center>\r\n      </h1>\r\n    </p>\r\n    <p></p>\r\n    <div>\r\n      <center ng-if=\"category.fbImage\">\r\n        <img ng-src=\"https://api.votewise.net/resources/{{category.fbImage}}\" class=\"wibble\" />\r\n      </center>\r\n    </div>\r\n    <center id=\"DisplayC\">\r\n      <h2>BACKGROUND</h2>\r\n    </center>\r\n    <p></p>\r\n    <div class=\"row d-flex justify-content-center\">\r\n      <div class=\"col-lg-7 col-sm-12\">\r\n        <p ng-bind-html=\"category.description | newlines\"></p>\r\n      </div>\r\n      <div ng-if=\"status.category == 1\" class=\"fwb\">\r\n        Loading category ...\r\n      </div>\r\n      <div ng-if=\"status.category == 3\" class=\"fwb\">\r\n        Something went wrong while loading category.\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <br>\r\n  <br>\r\n  <div ng-if=\"state == \'question-answered-by\'\" class=\"row  d-flex justify-content-center\">\r\n    <div class=\"col-lg-7 col-sm-12 \">\r\n      <h4 class=\"text-center\">Questions</h4>\r\n\r\n      <div class=\"card customCard\">\r\n        <div class=\"card-header quesCardHeaderMain\">\r\n          <div class=\"d-flex justify-content-between bd-highlight\">\r\n            <!-- <div class=\"p-2 bd-highlight quesCardHeader\">Statement</div> -->\r\n            <div class=\"p-2 bd-highlight\"><span class=\"textYellow\">{{currentIndex+1}}</span>/{{questions.length}}</div>\r\n            <p ng-if=\"isShowVotesmart\">NOTE: The politician did not answer this exact question. They answered a very\r\n              similar question from VoteSmart. Scroll all the way to the bottom of the page to read their original\r\n              question and answer (shown below ours).</p>\r\n          </div>\r\n        </div>\r\n        <div class=\"card-body customCardBody\">\r\n          <p  class=\"card-text\" ng-bind-html=\"questions[currentIndex].content | newlines\"></p>\r\n\r\n          <div class=\"row vdivide\">\r\n            <div class=\"col col-6\">\r\n              <div class=\"radio-container rcontent\" style=\"float:right;\">\r\n                <!-- <span ng-if=\"isShowVotesmart\" class=\"showinfovote clk ylink\" ng-click=\"showVotesmartAns(questions[currentIndex])\">\r\n                  <a href=\"\" title=\"Click to see answers.\"> <i class=\"fa fa-info-circle clk icolor\" aria-hidden=\"true\" style=\"font-size:25px;\"></i></a>\r\n                </span> -->\r\n															 <i ng-if=\"questions[currentIndex].userAnswer.referenceBy && questions[currentIndex].userAnswer.referenceBy !=\'\'\" class=\"fa fa-asterisk clk info-color\" aria-hidden=\"true\" ng-click=\"getInfo(questions[currentIndex].userAnswer)\"></i>\r\n                <i ng-if=\"questions[currentIndex].userAnswer.oldAnswers.length > 0  && !(questions[currentIndex].userAnswer.referenceBy && questions[currentIndex].userAnswer.referenceBy !=\'\')\" class=\"fa fa-asterisk clk icolor\" aria-hidden=\"true\" ng-click=\"getOldAnswers(questions[currentIndex].userAnswer)\"></i>\r\n                <span id=\"disagreeText\">DISAGREE &nbsp;</span>\r\n                <div style=\"float:right;\">\r\n                  <div class=\"box\">\r\n                    <ul class=\"vi-radio\">\r\n                      <li>\r\n                        <input type=\"radio\" id=\"agreedisagree-id6\" ng-disabled=\"true\" name=\"agreeDisagree\" value=\"6\" ng-model=\"answer\" ng-checked=\"checkIfExists(6)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                        <label for=\"agreedisagree-id6\"></label>\r\n                        <div class=\"checknew red sixth\"></div>\r\n                      </li>\r\n                    </ul>\r\n                  </div>\r\n                  <div class=\"box\">\r\n                    <ul class=\"vi-radio\">\r\n                      <li>\r\n                        <input type=\"radio\" id=\"agreedisagree-id5\" ng-disabled=\"true\" name=\"agreeDisagree\" value=\"5\" ng-model=\"answer\" ng-checked=\"checkIfExists(5)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                        <label for=\"agreedisagree-id5\"></label>\r\n                        <div class=\"checknew five fifth\"></div>\r\n                      </li>\r\n                    </ul>\r\n                  </div>\r\n                  <div class=\"box\">\r\n                    <ul class=\"vi-radio\">\r\n                      <li>\r\n                        <input type=\"radio\" id=\"agreedisagree-id4\" ng-disabled=\"true\" name=\"agreeDisagree\" value=\"4\" ng-model=\"answer\" ng-checked=\"checkIfExists(4)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                        <label for=\"agreedisagree-id4\"></label>\r\n                        <div class=\"checknew four forth\"></div>\r\n                      </li>\r\n                    </ul>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col col-6\">\r\n              <div class=\"radio-container rcontent\">\r\n                <span  style=\"color: #04A752; font-weight: bold;\">&nbsp;AGREE</span>\r\n                <div style=\"float:left;\">\r\n                  <div class=\"box\">\r\n                    <ul class=\"vi-radio\">\r\n                      <li>\r\n                        <input type=\"radio\" id=\"agreedisagree-id3\" ng-disabled=\"true\" name=\"agreeDisagree\" value=\"3\" ng-model=\"answer\" ng-checked=\"checkIfExists(3)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                        <label for=\"agreedisagree-id3\"></label>\r\n                        <div class=\"checknew three third\"></div>\r\n                      </li>\r\n                    </ul>\r\n                  </div>\r\n                  <div class=\"box\">\r\n                    <ul class=\"vi-radio\">\r\n                      <li>\r\n                        <input type=\"radio\" id=\"agreedisagree-id2\" ng-disabled=\"true\" name=\"agreeDisagree\" value=\"2\" ng-model=\"answer\" ng-checked=\"checkIfExists(2)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                        <label for=\"agreedisagree-id2\"></label>\r\n                        <div class=\"checknew two second\"></div>\r\n                      </li>\r\n                    </ul>\r\n                  </div>\r\n                  <div class=\"box\">\r\n                    <ul class=\"vi-radio\">\r\n                      <li>\r\n                        <input type=\"radio\" id=\"agreedisagree-id1\" ng-disabled=\"true\" name=\"agreeDisagree\" value=\"1\" ng-model=\"answer\" ng-checked=\"checkIfExists(1)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                        <label for=\"agreedisagree-id1\"></label>\r\n                        <div class=\"checknew first\"></div>\r\n                      </li>\r\n                    </ul>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"card card1\">\r\n        <div class=\"card-header card1Header\">\r\n          <p class=\"card-title\">IMPORTANCE</p>\r\n        </div>\r\n        <div class=\"card-body card1Body\" style=\"margin:0 auto;\">\r\n          <form class=\"impSection d-md-flex d-sm-block\">\r\n            <div class=\"A\">\r\n              <input type=\"radio\" class=\"button\" ng-disabled=\"true\" id=\"importance-id1\" ng-model=\"importance\" ng-checked=\"checkImpExists(1)\" value=\"1\"></input>\r\n              <label for=\"importance-id1\">Not Very</label>\r\n            </div>\r\n            <div class=\"B\">\r\n              <input type=\"radio\" class=\"button\" ng-disabled=\"true\" id=\"importance-id2\" ng-model=\"importance\" ng-checked=\"checkImpExists(2)\" value=\"2\"></input>\r\n              <label for=\"importance-id2\">Somewhat</label>\r\n            </div>\r\n            <div class=\"C\">\r\n              <input type=\"radio\" class=\"button\" id=\"importance-id3\" ng-disabled=\"true\" ng-model=\"importance\" ng-checked=\"checkImpExists(3)\" value=\"3\"></input>\r\n              <label for=\"importance-id3\">Very</label>\r\n            </div>\r\n            <!-- </div> -->\r\n          </form>\r\n        </div>\r\n      </div>\r\n      <div class=\"card card1\" ng-if=\"comment\">\r\n        <div class=\"card-header card1Header\">\r\n          <p class=\"card-title\">COMMENT</p>\r\n        </div>\r\n        <div class=\"card-body card1Body\">\r\n          <!-- <textarea class=\"form-control addComment\" id=\"exampleFormControlTextarea1\" rows=\"3\" placeholder=\"Add comments here....\"></textarea> -->\r\n          <!-- <h3>{{comment}}</h3> -->\r\n          \r\n          <p class=\"card-text\" style=\"font-size: 20px;\" ng-bind-html=\"comment | newlines\"></p>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col bottomBtns\">\r\n          <div class=\"btn-group\" role=\"group\" aria-label=\"Default button group\">\r\n            <button type=\"button\" id=\"backBtn\" ng-if=\"currentIndex > 0\" class=\"btn-transparent\" ng-click=\"prevQuestion()\"> <i class=\"fa fa-angle-left arrowIconBack\"></i> Back</button>\r\n            <!-- <button type=\"button\" id=\"skipBtn\" class=\"btn-transparent\" ng-click=\"skipQuestion()\">Skip</button> -->\r\n            <button type=\"button\" id=\"submitBtn\" class=\"btn-transparent\" ng-if=\"currentIndex < questions.length -1 \" ng-click=\"skipQuestion()\" ng-class=\"{\'activeSubmit\': (answer &&importance)}\">Next <i class=\"fa fa-angle-right arrowIconSubmit\"></i></button>\r\n            <button type=\"button\" id=\"submitBtn\" class=\"btn-transparent\" ng-if=\"currentIndex == questions.length -1 \" ng-click=\"gotoPolitician()\" ng-class=\"{\'activeSubmit\': (answer &&importance)}\">Finish <i class=\"fa fa-angle-right arrowIconSubmit\"></i></button>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <!-- <p ng-if=\"isShowVotesmart\">\r\n        <a href=\"https://votesmart.org/\" target=\"_blank\">\r\n                  <image src=\"../assets/images/VoteSmartLogoD.png\" class=\"partners\"></image></a> </p> -->\r\n\r\n\r\n      <!-- To see the\r\n        original question and\r\n        answer click here\"\r\n        <a href=\"\" ng-click=\"showVotesmartAns(questions[currentIndex])\" class=\"ylink\"> See Original</a> </p> -->\r\n\r\n      <center>\r\n        <button type=\"button\" id=\"btnY\" class=\"btn-transparent\" ng-if=\"oldQuestions.length == 0\" ng-click=\"digDeeper()\">More Questions on This Topic</button>\r\n        <br>\r\n        <div ng-if=\"oldQuestions.length > 0\">\r\n          <button ng-click=\"goBack();\" class=\"btnR\">Return to 5 minute match up</button> </div>\r\n        <!--  <div class=\"digDeeperSmall\" ng-if=\"oldQuestions.length == 0\"> <img ng-src=\"../assets/images/DigDeeper.svg\" ng-click=\"digDeeper()\" style=\"cursor: pointer;\" alt=\"Questions\" />&nbsp; &nbsp; <i ng-if=\"showDigDeeperLoader\" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i></div>  -->\r\n      </center>\r\n      <center>\r\n        <div ng-if=\"showLoader\" style=\"z-index: 2; background:black;\">\r\n          <i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span>\r\n        </div>\r\n\r\n      </center>\r\n      <fieldset class=\"scheduler-border\" ng-if=\"voteData.length > 0\">\r\n        <legend class=\"scheduler-border\">Original Question and Answer.</legend>\r\n        <div class=\"billDetailBlock d-flex  container-fluid col-sm-12 col-lg-12\" style=\"width:100%;\">\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n              <br>\r\n              <div>\r\n                <p style=\"text-align: center;\">\r\n                  <a href=\"https://votesmart.org/\" target=\"_blank\">\r\n                                    <image src=\"../assets/images/VoteSmartLogoD.png\" class=\"partners\"></image></a> </p>\r\n                <p>\r\n                  <div class=\"p\" ng-repeat=\"d in voteData\" ng-if=\"voteData.length > 0\">\r\n                    <div ng-if=\"d.question\"><b>Question:</b> {{d.question}}</div>\r\n                    <br>\r\n                    <!-- <div ng-if=\"d.category\"><b>Category:</b> {{d.category}}</div> -->\r\n                    <!-- <br> -->\r\n                    <div ng-if=\"d.userAnswer.answer\"><b>Answer:</b> {{d.userAnswer.answer}}</div>\r\n                    <br>\r\n                    <div ng-if=\"d.userAnswer.answer_descriptive\"><b>Answer Text:</b>\r\n                      {{d.userAnswer.answer_descriptive}}\r\n                    </div>\r\n                    <br>\r\n                    </div>\r\n                  </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <p>We altered the above question to fit our format. \"True\" or \"False\" were converted to \"Somewhat Agree\" or\r\n            \"Somewhat Disagree\" (one point from either extreme) and we gave those answers an importance level of\r\n            \"Somewhat Important\". This means the converted answers may not fully express their passion or conviction.\r\n            This allows us to make a loose mathematical match, but it should not be considered exact to their\r\n            intentions.</p>\r\n      </fieldset>\r\n      <center>\r\n        <div ng-if=\"voteData.length == 0\">\r\n          Records Not Found\r\n        </div>\r\n      </center>\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n<script type=\"text/ng-template\" id=\"showOldAnsPopUp\">\r\n  <div class=\"container-fluid\">\r\n    <h5>Old Answers</h5>\r\n    <div ng-repeat=\"com in oldAns |orderBy:\'-created\' track by $index\">\r\n        <div class=\"pad10\">\r\n\r\n          <br>\r\n          <span>Answer</span>\r\n          <br>\r\n          <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n\r\n            <div ng-repeat=\"i in [6,5,4,3,2,1]\" class=\"mb5 clearfix\"\r\n              style=\"padding-left: 8px;  line-height: 15px\">\r\n              <span class=\"inl-blk pull-left\" ng-if=\"i == 6\" style=\"margin-right:8px\">DISAGREE</span>\r\n\r\n              <div class=\"cq-box inl-blk pull-left\"\r\n                ng-class=\"(com.answer == i) ? getComapreClass(com.answer, i) : \'\'\"></div>\r\n                <span class=\"inl-blk\" ng-if=\"i == 1\" style=\"padding-left: 10px;\">AGREE</span>\r\n            </div>\r\n          </div>\r\n          <br>\r\n          <p></p>\r\n          <span>IMPORTANCE</span>\r\n          <br>\r\n          <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n            <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"padding-left: 8px; line-height: 9px\">\r\n              <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n              <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n              <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n              <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                ng-class=\"(com.importance == i) ? \'ag-blk\' : \'\'\"></div>\r\n            </div>\r\n          </div>\r\n          <p></p>\r\n          <div>\r\n            <span ng-if=\"com.comment\">Comment:</span>\r\n            <span ng-if=\"com.comment\" class=\"newcomName\">{{com.comment}}</span>\r\n          </div>\r\n          <span>Reason to Change the Answer: {{com.reason}}</span><br>\r\n  <span>Updated on: {{com.created | date: \'MM-dd-y\'}}</span>\r\n          <hr style=\"\r\n          margin-left: auto;\r\n          margin-right: auto;\r\n          height: 1px;\r\n          background-color:#666;\r\n          opacity: 0.5;\">\r\n        </div>\r\n      </div>\r\n            </div>\r\n</script>\r\n<div ng-if=\"questions[currentIndex].userAnswer.referenceBy && questions[currentIndex].userAnswer.referenceBy !=\'\'\">\r\n <p><i  class=\"fa fa-asterisk clk info-color\" aria-hidden=\"true\" ng-click=\"getInfo(questions[currentIndex].userAnswer)\"></i> This answer is based on research rather than the actual response of the politician.</p> </div>\r\n<div ng-if=\"questions[currentIndex].userAnswer.oldAnswers.length > 0 && !(questions[currentIndex].userAnswer.referenceBy && questions[currentIndex].userAnswer.referenceBy !=\'\')\"\r\n  ng-click=\"getOldAnswers(questions[currentIndex].userAnswer)\">\r\n  <span><p><span class=\"fa fa-asterisk clk icolor\"><span class=\"ylink\"> THEY HAVE CHANGE THEIR ANSWER.</span></span><span> The world is an ever changing place and wise people will change their points of view when situations or information changes.  Click <span ng-click=\"getOldAnswers(questions[currentIndex].userAnswer)\" class=\"ylink\">here</span>\r\n  to see their original answer and why they changed their mind.</span></p>\r\n  </span></div>\r\n  <script type=\"text/ng-template\" id=\"showInfoPopUp\">\r\n    <div class=\"container-fluid\">\r\n      <h5>Notes</h5>\r\n      <p ng-bind-html=\"showComment | newlines\"></p>\r\n              </div>\r\n  </script>");
$templateCache.put("app/questionBackGround/questionBackGround.html","<!-- <pre>{{status.category}} | {{status.levlCat}}</pre> -->\r\n<p ng-if=\"status.levlCat == 1\" class=\"fwb\">Loading background ...</p>\r\n<div class=\"pad10\">\r\n  <div class=\"clearfix w100\">\r\n    <div ng-show=\"[\'question\', \'question-background\'].indexOf(state) > -1 && userId\">\r\n    </div>\r\n  </div>\r\n  <div class=\"clearfix w100\" ng-if=\"state == \'question-answered-by\' && politicianName\">\r\n    Showing questions answered by <b>{{politicianName}}</b>\r\n  </div>\r\n  <div>\r\n    <p>\r\n      <h1>\r\n        <center>{{category.title}}</center>\r\n      </h1>\r\n    </p>\r\n    <p></p>\r\n    <div>\r\n      <center ng-if=\"category.fbImage\">\r\n        <img ng-src=\"https://api.votewise.net/resources/{{category.fbImage}}\" class=\"wibble\" />\r\n      </center>\r\n    </div>\r\n    <center id=\"DisplayC\">\r\n      <h2>BACKGROUND</h2>\r\n    </center>\r\n    <p></p>\r\n    <div class=\"row d-flex justify-content-center\">\r\n      <div class=\"col-lg-7 col-sm-12\">\r\n        <p ng-bind-html=\"category.description | newlines\"></p>\r\n      </div>\r\n      <div ng-if=\"status.category == 1\" class=\"fwb\">\r\n        Loading category ...\r\n      </div>\r\n      <div ng-if=\"status.category == 3\" class=\"fwb\">\r\n        Something went wrong while loading category.\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <br>\r\n  <br>\r\n  <center>\r\n    <div ng-if=\"showLoaderNw\" style=\"z-index: 2; background:black;\">\r\n      <i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span>\r\n    </div>\r\n\r\n  </center>\r\n  <div ng-show=\"[\'question\', \'question-tagged\', \'question-background\', \'question-search\'].indexOf(state) > -1\">\r\n    <center id=\"DisplayQ\">\r\n      <label ng-hide=\"questions[currentIndex]\">\r\n        <input type=\"checkbox\" ng-model=\"flagSkipAnsweredQuestion\" ng-change=\"skipAnswerChagne()\"> Skip Answered Questions\r\n      </label>\r\n    </center>\r\n\r\n    <!--   <div ng-if=\"loadernew\" class=\"fwb\">\r\n      <!-- Loading data ...\r\n      <p>\r\n        <center><i class=\"fa fa-refresh fa-spin\" style=\"font-size:72px;\"></i></center>\r\n      </p>\r\n    </div>  -->\r\n\r\n    <center>\r\n      <div ng-if=\"loadernew\" style=\"z-index: 2; background:black;\">\r\n        <i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span>\r\n      </div>\r\n    </center>\r\n\r\n\r\n\r\n    <!-- </div> -->\r\n    <div>\r\n      <!-- ng-show=\"state == \'question\' || state == \'question-tagged\' || state == \'question-background\'\" -->\r\n      <div ng-show=\"questions[currentIndex]\">\r\n        <!-- <type=\"button\" value=\"LEARN MORE\"> -->\r\n        <p></p>\r\n        <div class=\"row  d-flex justify-content-center\">\r\n         \r\n          <div class=\"col-lg-7 col-sm-12 \">\r\n\r\n            <h4 class=\"text-center\">Questions</h4>\r\n            <div class=\"card customCard\">\r\n              <!-- <div class=\"card-header quesCardHeaderMain\">\r\n\r\n                <div class=\"d-flex justify-content-between bd-highlight\">\r\n                  <div class=\"p-2 bd-highlight quesCardHeader\">Statement</div>\r\n                  <div class=\"p-2 bd-highlight\">\r\n                    <span class=\"textYellow\">{{currentIndex+1}}</span>/{{questions.length}}</div> <label>\r\n                    <input type=\"checkbox\" ng-model=\"flagSkipAnsweredQuestion\" ng-change=\"skipAnswerChagne()\"> Skip answered questions\r\n                  </label>\r\n                </div>\r\n              </div> -->\r\n              \r\n\r\n              <div class=\"card-header quesCardHeaderMain\">\r\n                <div class=\"d-flex justify-content-between bd-highlight\">\r\n                  <!-- <div class=\"p-2 bd-highlight quesCardHeader\">Statement</div> -->\r\n                  <div ng-hide=\"questions.length == 0\" class=\"p-2 bd-highlight\">\r\n                    <span class=\"textYellow\">{{currentIndex+1}}</span>/{{questions.length}}\r\n                  </div>\r\n                  <div class=\"form-check\" ng-if=\"inviterId\">\r\n                    <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"shareWith\" ng-model=\"isShare\" ng-change=\"updateFlag()\">\r\n                    <label class=\"form-check-label checkboxLabel\" for=\"defaultCheck1\">\r\n                          Share answer with <span style=\"text-transform: capitalize;\" ng-if=\"inviterName\">{{inviterName}}</span>\r\n                          </label>\r\n                  </div>\r\n                  <div id=\"anchor 1\" class=\"form-check anchor\">\r\n                    <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"defaultCheck1\" ng-model=\"flagSkipAnsweredQuestion\" ng-change=\"skipAnswerChagne()\">\r\n                    <label class=\"form-check-label checkboxLabel\" for=\"defaultCheck1\">\r\n                            Skip Answered Questions\r\n                          </label>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"card-body customCardBody\">\r\n                <!-- <p class=\"card-text\">{{questions[currentIndex].content}}</p> -->\r\n                <p  class=\"card-text\" ng-bind-html=\"questions[currentIndex].content | newlines\"></p>\r\n                <div class=\"row vdivide\">\r\n                  <div class=\"col col-6\">\r\n                    <div class=\"rcontent\" style=\"float:right;\">\r\n                      <span id=\"disagreeText\">DISAGREE &nbsp;</span>\r\n                      <div style=\"float:right;\">\r\n                        <div class=\"box\">\r\n                          <ul class=\"vi-radio\">\r\n                            <li>\r\n                              <input type=\"radio\" id=\"agreedisagree-id6\" name=\"agreeDisagree\" value=\"6\" ng-model=\"answer\" ng-checked=\"checkIfExists(6)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                              <label for=\"agreedisagree-id6\"></label>\r\n                              <div class=\"checknew red sixth\"></div>\r\n                            </li>\r\n                          </ul>\r\n                        </div>\r\n                        <div class=\"box\">\r\n                          <ul class=\"vi-radio\">\r\n                            <li>\r\n                              <input type=\"radio\" id=\"agreedisagree-id5\" name=\"agreeDisagree\" value=\"5\" ng-model=\"answer\" ng-checked=\"checkIfExists(5)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                              <label for=\"agreedisagree-id5\"></label>\r\n                              <div class=\"checknew five fifth\"></div>\r\n                            </li>\r\n                          </ul>\r\n                        </div>\r\n                        <div class=\"box\">\r\n                          <ul class=\"vi-radio\">\r\n                            <li>\r\n                              <input type=\"radio\" id=\"agreedisagree-id4\" name=\"agreeDisagree\" value=\"4\" ng-model=\"answer\" ng-checked=\"checkIfExists(4)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                              <label for=\"agreedisagree-id4\"></label>\r\n                              <div class=\"checknew four forth\"></div>\r\n                            </li>\r\n                          </ul>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col col-6\">\r\n                    <div class=\" rcontent\">\r\n                      <span  style=\"color: #04A752; font-weight: bold;\">&nbsp;AGREE</span>\r\n                      <div style=\"float:left;\">\r\n                        <div class=\"box\">\r\n                          <ul class=\"vi-radio\">\r\n                            <li>\r\n                              <input type=\"radio\" id=\"agreedisagree-id3\" name=\"agreeDisagree\" value=\"3\" ng-model=\"answer\" ng-checked=\"checkIfExists(3)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                              <label for=\"agreedisagree-id3\"></label>\r\n                              <div class=\"checknew three third\"></div>\r\n                            </li>\r\n                          </ul>\r\n                        </div>\r\n                        <div class=\"box\">\r\n                          <ul class=\"vi-radio\">\r\n                            <li>\r\n                              <input type=\"radio\" id=\"agreedisagree-id2\" name=\"agreeDisagree\" value=\"2\" ng-model=\"answer\" ng-checked=\"checkIfExists(2)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                              <label for=\"agreedisagree-id2\"></label>\r\n                              <div class=\"checknew two second\"></div>\r\n                            </li>\r\n                          </ul>\r\n                        </div>\r\n                        <div class=\"box\">\r\n                          <ul class=\"vi-radio\">\r\n                            <li>\r\n                              <input type=\"radio\" id=\"agreedisagree-id1\" name=\"agreeDisagree\" value=\"1\" ng-model=\"answer\" ng-checked=\"checkIfExists(1)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                              <label for=\"agreedisagree-id1\"></label>\r\n                              <div class=\"checknew first\"></div>\r\n                            </li>\r\n                          </ul>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"card card1\">\r\n              <div class=\"card-header card1Header\">\r\n                <p class=\"card-title\">ADD COMMENT</p>\r\n              </div>\r\n              <div class=\"card-body card1Body\">\r\n                <textarea class=\"form-control addComment\" id=\"exampleFormControlTextarea1\" ng-model=\"comment\" rows=\"1\" placeholder=\"(not required)\"></textarea>\r\n                <textarea ng-show=\"questions[currentIndex].my_answer\" ng-model=\"reason\" class=\"vi-textarea\" placeholder=\"REASON TO CHANGE ANSWER\" style=\"margin-top: 10px;\"></textarea>\r\n              </div>\r\n            </div>\r\n            <div class=\"card card1\">\r\n              <div class=\"card-header card1Header\">\r\n                <p class=\"card-title\">IMPORTANCE</p>\r\n              </div>\r\n\r\n              <div class=\"card-body card1Body\" style=\"margin:0 auto;\">\r\n                <form class=\"impSection d-md-flex d-sm-block\">\r\n                  <!-- imp {{importance}} -->\r\n                  <div class=\"A\">\r\n                    <input type=\"radio\" class=\"button\" id=\"importance-id1\" ng-model=\"importance\"  name=\"importance\" ng-checked=\"checkImpExists(1)\" ng-click=\"subNew(1)\" value=\"1\"></input>\r\n                    <label for=\"importance-id1\">Not Very</label>\r\n                  </div>\r\n                  <div class=\"B\">\r\n                    <input type=\"radio\" class=\"button\" id=\"importance-id2\" ng-model=\"importance\"  name=\"importance\"  ng-checked=\"checkImpExists(2)\" ng-click=\"subNew(2)\" value=\"2\"></input>\r\n                    <label for=\"importance-id2\">Somewhat</label>\r\n                  </div>\r\n                  <div class=\"C\">\r\n                    <input type=\"radio\" class=\"button\" id=\"importance-id3\" ng-model=\"importance\" name=\"importance\" ng-checked=\"checkImpExists(3)\" ng-click=\"subNew(3)\" value=\"3\"></input>\r\n                    <label for=\"importance-id3\">Very</label>\r\n\r\n                  </div>\r\n                  <!-- </div> -->\r\n                </form>\r\n              </div>\r\n              <!-- <span>Imp</span> {{importance}} <br>\r\n              <span>Ans</span> {{answer}} -->\r\n            </div>\r\n            <div class=\"row\">\r\n              <div class=\"col bottomBtns\">\r\n                <div class=\"btn-group\" role=\"group\" aria-label=\"Default button group\">\r\n                  <button type=\"button\" id=\"backBtn\" class=\"btn-transparent\" ng-click=\"prevQuestion()\">\r\n                    <i class=\"fa fa-angle-left arrowIconBack\"></i> Back</button>\r\n                  <button type=\"button\" id=\"skipBtn\" class=\"btn-transparent\" ng-click=\"skipQuestion()\">Skip</button>\r\n                  <button type=\"button\" id=\"submitBtn\" class=\"btn-transparent\" ng-click=\"submitAnswer()\" ng-class=\"{\'activeSubmit\': (answer &&importance)}\">Submit\r\n                    <i class=\"fa fa-angle-right arrowIconSubmit\"></i>\r\n                  </button>\r\n                </div>\r\n              </div>\r\n            </div>\r\n					            <center>\r\n              <button ng-if=\"saveForLater\" type=\"button\" id=\"saveForLater\"  class=\"skipToFinal\" ng-click=\"saveQuizForLater()\">Save Quiz For Later</button>\r\n            </center>\r\n            <center>\r\n              <button type=\"button\" id=\"btnY\" class=\"btn-transparent\" ng-click=\"notAnswerableSelected()\" ng-show=\"$root.userRole==\'admin\'||$root.userRole==\'advocate\' \">REPORT BAD QUESTION</button>\r\n            </center>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <center>\r\n      <button ng-if=\"skipToMatch\" type=\"button\" id=\"skipMatch\"  class=\"skipToFinal\" ng-click=\"skipToMatchs()\">Skip to Question Comparison</button>\r\n    </center>\r\n    <center>\r\n      <button ng-if=\"skipToFinal\" type=\"button\" id=\"skipMatch\"  class=\"skipToFinal\" ng-click=\"skipToCompare()\">Skip to Overall Comparison</button>\r\n    </center>\r\n    <center>\r\n      <button ng-if=\"skipToFinal\" type=\"button\" id=\"skipMatch\"  class=\"skipToFinal\" ng-click=\"skipToActions()\">Skip to Other Actions</button>\r\n    </center>\r\n\r\n  </div>\r\n  <script type=\"text/ng-template\" id=\"nextQuestionOptions\">\r\n    <ul class=\"catList\">\r\n        <li ng-if=\"!userId\">\r\n            <input type=\"radio\" id=\"options0\" ng-model=\"fb.options\" value=\"R\" />\r\n            <label for=\"options0\" ng-if=\"!inviterId\">Sign up so your politicians can see your answers.</label>\r\n            <label for=\"options0\" ng-if=\"inviterId\">Sign up to see how you match <b style=\"text-transform: capitalize;\">{{inviterName}}</b></label>\r\n          </li>\r\n   <li ng-if=\"!userId\">\r\n						<input type=\"radio\" id=\"options5\" ng-model=\"fb.options\" value=\"F\" />\r\n						<label for=\"options5\" ng-if=\"!inviterId\">Skip signing up and go straight to seeing how others answered</label>\r\n\r\n\r\n    <!-- <li>\r\n      <input type=\"radio\" id=\"options2\" ng-model=\"fb.options\" value=\"P\" />\r\n      <label for=\"options2\">Post this quiz to Facebook.</label>\r\n    </li>  -->\r\n    <li ng-if=\"userId\">\r\n      <input type=\"radio\" id=\"options01\" ng-model=\"fb.options\" value=\"PS\" ng-click=\"createLink()\" />\r\n      <label for=\"options01\">Share this quiz with friends and followers to see how they compare.</label>\r\n    </li>\r\n					 <!--\r\n    <li>\r\n      <input type=\"radio\" id=\"options3\" ng-model=\"fb.options\" value=\"Q\" />\r\n      <label for=\"options3\">Let me choose which questions to hide from Facebook.</label>\r\n    </li>\r\n    <li>\r\n      <input type=\"radio\" id=\"options4\" ng-model=\"fb.options\" value=\"M\" />\r\n      <label for=\"options4\">See how your friends match your answers.</label>\r\n    </li>\r\n\r\n\r\n-->\r\n	\r\n					\r\n\r\n					<span ng-if=\"poliData\">The politician, <a href=\"\" ng-click=\"redirectTo(\'politician\',poliData._id)\" style=\"text-transform: capitalize;\" class=\"link\"><b>{{poliData.name}}</b></a>  is a {{poliData.match}}% match to you on this quiz</span><span ng-if=\"poliData.answeredQues\">(Match based on {{poliData.answeredQues}} questions)</span><br ng-if=\"poliData\">\r\n				<span ng-if=\"orgData\">The organization, <a href=\"\" ng-click=\"redirectTo(\'advocate\',orgData._id)\" style=\"text-transform: capitalize;\" class=\"link\"><b>{{orgData.name}}</b> </a> is a {{orgData.match}}% match to you on this quiz.</span><span ng-if=\"poliData.answeredQues\">(Match based on {{poliData.answeredQues}} questions)</span><br ng-if=\"orgData\">\r\n\r\n<br ng-if=\"orgData||poliData\">\r\n    <li ng-if=\"userId\">\r\n      <input type=\"radio\" id=\"options5\" ng-model=\"fb.options\" value=\"F\" />\r\n      <label for=\"options5\" ng-if=\"!inviterId\">See How Others Answered</label>\r\n      <label for=\"options5\" ng-if=\"inviterId\"> <b>See How {{inviterName}} Answered</b></label>\r\n    </li>\r\n				<li ng-if=\"userId\">\r\n			<input type=\"radio\" id=\"option6\" ng-model=\"fb.options\" value=\"L\">\r\n			<label for=\"option6\">Learn More About this Topic</label></li>\r\n					<li ng-if=\"userId\">\r\n			<input type=\"radio\" id=\"option7\" ng-model=\"fb.options\" value=\"D\">\r\n			<label for=\"option7\">Discuss this Topic with Others</label></li>\r\n <li ng-if=\"userId\">\r\n      <input type=\"radio\" id=\"options1\" ng-model=\"fb.options\" value=\"C\" />\r\n      <label for=\"options1\">Continue Answering questions so your politicians know what you want them to do.</label>\r\n    </li>\r\n    <li>\r\n      <center><input type=\"button\" ng-click=\"NextOptions(fb.options)\" class=\"compareBtn\" value=\"Next\" />&nbsp;\r\n      <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"DisplayFLoader\"></i></center>\r\n    </li>\r\n\r\n  </ul>\r\n</script>\r\n  <script type=\"text/ng-template\" id=\"FBComposeMessage\">\r\n    <center>\r\n    <h2>Post message on Facebook</h2>\r\n    <div>\r\n      <div style=\"width:15%; float:left;\">Message: </div>\r\n      <div style=\"width:84%; float:left;\">\r\n        <textarea ng-model=\"fb.message\" style=\"width:100%; height: 100px;\"></textarea>\r\n      </div>\r\n    </div>\r\n    <div style=\"clear:both;\"></div>\r\n    <div>\r\n      <div style=\"width:15%; float:left;\">&nbsp;</div>\r\n      <div style=\"width:84%; float:left; text-align:left;\">\r\n        <input type=\"button\" ng-click=\"postFB(fb.message)\" value=\"Submit to Facebook*\" />&nbsp;\r\n        <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"DisplayFPostLoader\"></i>\r\n        <p>\r\n          <b>*Note:</b>If you are not currently logged into Facebook, you must enable pop-ups in your browser in order for the\r\n          Facebook sign in window to pop up.</p>\r\n      </div>\r\n    </div>\r\n    <div style=\"clear:both;\"></div>\r\n</script>\r\n  <script type=\"text/ng-template\" id=\"FBFreindList\">\r\n    <h3>Select friends to compare with your answers.</h3>\r\n  <ul class=\"catList\">\r\n    <li ng-repeat=\"frd in FBfreinds track by $index\">\r\n      <!--<div style=\"width:15%; height: 50px; float: left;\">\r\n            <i class=\"fa fa-check-circle\" aria-hidden=\"true\"></i> -->\r\n      <input type=\"checkbox\" id=\"{{$index}}\" name=\"selectedFrds[]\" value=\"{{frd.id}}\" ng-click=\"selectedFrd(frd)\" ng-checked=\"selection.indexOf({{frd.id}}) > -1\"\r\n      />\r\n      <label for=\"{{$index}}\">\r\n        <img ng-src=\"http://graph.facebook.com/{{frd.id}}/picture?type=square\" /> {{frd.name}}</label>\r\n      <!-- </div><div style=\"width:15%; height: 50px; float: left;\"><img ng-src=\"http://graph.facebook.com/{{frd.id}}/picture?type=square\" /></div> <div style=\"width:48%; height: 50px; float: left;\">{{frd.name}}</div> -->\r\n    </li>\r\n    <li>\r\n      <input type=\"button\" ng-click=\"ComapreWithSelected()\" value=\"Compare\" />\r\n    </li>\r\n  </ul>\r\n</script>\r\n  <!--\r\n<script type=\"text/ng-template\" id=\"FBFreindCompare\">\r\n    <h3>Comparision with your freinds.</h3>\r\n    <ul class=\"catList\">\r\n        <li ng-repeat=\"quest in FBCompareList track by $index\">\r\n            <div style=\"width: 3%; float:left;\">{{$index + 1}}</div>\r\n            <div style=\"width: 96%; float:left;\">\r\n                <div>{{quest.content}}</div>\r\n                <div><b>My Answer:</b> {{AnswerArray[quest.my_answer.answer]}}, <b>Importance:</b> {{AnswerImpArray[quest.my_answer.importance]}}\r\n                <div ng-if=\"quest.my_answer.comment!=\'\'\" style=\"padding-left:10px;padding-right:10px;\"><i><small>Comments: {{quest.my_answer.comment}}</small></i></div>\r\n                </div>\r\n                <div ng-repeat=\"frd in quest.answers\"><b>{{frd.author.username}}:</b> {{AnswerArray[frd.answer]}}, <b>Importance:</b> {{AnswerImpArray[frd.importance]}}\r\n                    <div ng-if=\"frd.comment!=\'\'\" style=\"padding-left:10px;padding-right:10px;\"><i><small>Comments: {{frd.comment}}</i></small></div>\r\n                </div>\r\n            </div>\r\n            <div style=\"clear:both;\"></div>\r\n        </li>\r\n    </ul>\r\n</script>\r\n-->\r\n  <script type=\"text/ng-template\" id=\"FBFreindCompare\">\r\n    <center>\r\n    <h2>Match</h2>\r\n    <h3>{{category.title}}</h3>\r\n  </center>\r\n  <div>\r\n    <div class=\"squareBoxY\" >&nbsp;</div>\r\n    <div class=\"squareMenu\">= Simple Comparison by answers alone.</div>\r\n    <div style=\"clear:both;\"></div>\r\n    <div class=\"squareBoxB\" >&nbsp;</div>\r\n    <div class=\"squareMenu\">= Weighted Comparison by answers and importance.</div>\r\n    <div style=\"clear:both;\"></div>\r\n  </div>\r\n  <div>\r\n    <div style=\"width:30%; float:left; text-align:right;\">Order By :&nbsp;&nbsp;</div>\r\n    <div style=\"width:65%; float:left; text-align:left;\">\r\n      <select ng-model=\"ord.Option\">\r\n        <option value=\"BW\">Best Weighted match</option>\r\n        <option value=\"W\">Worst weighted match</option>\r\n        <option value=\"BS\">Best simple match</option>\r\n        <option value=\"S\">Worst simple match</option>\r\n      </select>\r\n    </div>\r\n    <div style=\"clear:both;\"></div>\r\n  </div>\r\n  <ul class=\"catList\">\r\n    <li ng-repeat=\"frd in FBfreinds | orderBy:checkMyOrder track by $index\" ng-if=\"FBunWeighted[frd.id] && fbcombinedWeight[frd.id]\">\r\n      <div style=\"background-color:#bbb; padding:10px;\">\r\n        <div style=\"width: 15%; float:left;\">\r\n          <img ng-src=\"http://graph.facebook.com/{{frd.id}}/picture?type=square\" />\r\n          <br/>{{frd.name}}</div>\r\n        <div style=\"width: 84%; float:left;\">\r\n          <div>\r\n            <div class=\"fbunweighted\" style=\"width:{{(FBunWeighted[frd.id] / fbqlen[frd.id] )  | number:2}}%\">{{(FBunWeighted[frd.id] / fbqlen[frd.id] ) | number:2}}%</div>\r\n          </div>\r\n          <div>\r\n            <div class=\"fbweighted\" style=\"width:{{(fbcombinedWeight[frd.id] / fbmultiplier[frd.id])  | number:2}}%\">{{(fbcombinedWeight[frd.id] / fbmultiplier[frd.id]) | number:2}}%</div>\r\n          </div>\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n      </div>\r\n    </li>\r\n  </ul>\r\n</script>\r\n  <script type=\"text/ng-template\" id=\"ReviewMyAnswers\">\r\n    <h3>Review Answers and Hide Them From Your Friends.</h3>\r\n<p>Please review the questions and make sure you want to make your answers public.</p>\r\n 	 <center>\r\n    <div ng-if=\"showLoader\" style=\"z-index: 2; background:black;\"><i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span></div>\r\n\r\n  </center>\r\n\r\n  <table class=\"w100\">\r\n    <tr>\r\n      <th>Num.</th>\r\n      <th>Question</th>\r\n      <th>Answer</th>\r\n      <th>Importance</th>\r\n      <th>Show/Hide</th>\r\n    </tr>\r\n    <tr ng-repeat=\"q in allQuestions | orderBy:\'categories[0].viewOrder\' track by $index\" ng-init=\"q.my_answer.show!=\'N\'? switchStatus[$index]=true: switchStatus[$index]=false;\">\r\n      <td>\r\n        {{$index + 1}}\r\n      </td>\r\n      <td style=\"text-align:left;\">\r\n        <span class=\"card-text\" ng-bind-html=\"q.content | newlines\"></span>\r\n      </td>\r\n      <td>\r\n        {{AnswerArray[q.my_answer.answer]}}\r\n      </td>\r\n      <td>\r\n        {{AnswerImpArray[q.my_answer.importance]}}\r\n      </td>\r\n      <td>\r\n        <!-- <div toggle-switch class=\"switch-small\" on-label=\"Show\" off-label=\"Hide\" ng-model=\"switchStatus\"></div> -->\r\n        <toggle-switch ng-model=\"switchStatus[$index]\" class=\"switch-small\" on-label=\"Show\" off-label=\"Hide\" ng-change=\"switchFilters(switchStatus, $index, q)\"></toggle-switch>\r\n      </td>\r\n    </tr>\r\n  </table>\r\n  <br>\r\n  <center>\r\n    <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"next()\">\r\n       Next\r\n       </button>\r\n    <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"cancel()\">\r\n       Cancel\r\n       </button>\r\n  </center>\r\n</script>\r\n\r\n  <script type=\"text/ng-template\" id=\"exporeQuizLink\">\r\n  <h5>Copy and paste the link below to Facebook, Twitter, Email or wherever you want.<br><br>  When people click the link to take the quiz, you can each see how you compare and they will become your \"followers.\"</h5>\r\n <div>\r\n   <p>{{shareLink}}</p>\r\n </div>\r\n</script>\r\n");
$templateCache.put("app/questionCompare/questionCompare.html","<!-- <pre>{{status.category}} | {{status.levlCat}}</pre> -->\r\n<p ng-if=\"status.levlCat == 1\" class=\"fwb\">Loading background ...</p>\r\n<div class=\"pad10\">\r\n  <div class=\"clearfix w100\">\r\n    <div ng-show=\"[\'question\', \'question-background\'].indexOf(state) > -1 && userId\">\r\n    </div>\r\n  </div>\r\n  <div class=\"clearfix w100\" ng-if=\"state == \'question-answered-by\' && politicianName\">\r\n    Showing questions answered by <b>{{politicianName}}</b>\r\n  </div>\r\n  <div>\r\n    <p>\r\n      <h1>\r\n        <center>{{category.title}}</center>\r\n      </h1>\r\n    </p>\r\n    <p></p>\r\n    <div>\r\n      <center ng-if=\"category.fbImage\">\r\n        <img ng-src=\"https://api.votewise.net/resources/{{category.fbImage}}\" class=\"wibble\" />\r\n      </center>\r\n    </div>\r\n    <center id=\"DisplayC\">\r\n      <h2>BACKGROUND</h2>\r\n    </center>\r\n    <p></p>\r\n    <div class=\"row d-flex justify-content-center\">\r\n      <div class=\"col-lg-7 col-sm-12\">\r\n        <p ng-bind-html=\"category.description | newlines\"></p>\r\n      </div>\r\n      <div ng-if=\"status.category == 1\" class=\"fwb\">\r\n        Loading category ...\r\n      </div>\r\n      <div ng-if=\"status.category == 3\" class=\"fwb\">\r\n        Something went wrong while loading category.\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <br>\r\n  <br>\r\n  <div ng-show=\"[\'question\', \'question-tagged\', \'question-background\', \'question-search\'].indexOf(state) > -1\">\r\n    <center id=\"DisplayQ\">\r\n      <label ng-hide=\"questions[currentIndex]\">\r\n        <input type=\"checkbox\" ng-model=\"flagSkipAnsweredQuestion\" ng-change=\"skipAnswerChagne()\"> Skip Answered Questions\r\n      </label>\r\n    </center>\r\n    <!-- </div> -->\r\n  </div>\r\n  <div ng-show=\"state == \'question-compare\'\">\r\n    <!-- <button ng-click=\"$root.printPage()\" class=\"print-hide blackText\">Print this page</button>  -->\r\n    <div ng-show=\"questions[currentIndex]\">\r\n      <!-- <type=\"button\" value=\"LEARN MORE\"> -->\r\n      <p></p>\r\n      <center>\r\n        <h2>QUESTION</h2>\r\n      </center>\r\n      <p></p>\r\n      <p></p>\r\n      <center>({{currentIndex+1}} of {{questions.length}})</center>\r\n      <p></p>\r\n      <p>STATEMENT: <span class=\"card-text\" ng-bind-html=\"questions[currentIndex].content | newlines\"></span></p>\r\n      Your Answers<span  style=\"margin-left: 30px;\">Their Answers</span>\r\n      <div class=\"clearfix\">\r\n        <div class=\"pull-left ans-col\" style=\"border-right: 3px solid #de8998;\">\r\n          <div class=\"pad10\">\r\n            <div class=\"clearfix\" style=\"line-height: 9px\">\r\n              <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\">\r\n                <span class=\"inl-blk\" ng-if=\"i == 1\" style=\"margin-right: 10px; \">AGREE</span>\r\n                <span class=\"inl-blk\" ng-if=\"i == 6\">DISAGREE</span>\r\n                <div class=\"cq-box inl-blk pull-right\"\r\n                  ng-class=\"(questions[currentIndex].my_answer.answer == i) ? (\'ag-green\') : \'\'\"></div>\r\n              </div>\r\n            </div>\r\n            <div class=\"clearfix\">\r\n              <div class=\"mb5 clearfix\">\r\n                <div class=\"inl-blk pull-right\">MATCH %</div>\r\n              </div>\r\n            </div><br>\r\n            <div class=\"clearfix\" style=\"line-height: 9px\">\r\n              <p>IMPORTANCE</p>\r\n              <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\">\r\n                <span class=\"inl-blk\" ng-if=\"i == 1\">Very</span>\r\n                <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                <span class=\"inl-blk\" ng-if=\"i == 3\">Not Very</span>\r\n                <div class=\"cq-box inl-blk pull-right \"\r\n                  ng-class=\"(questions[currentIndex].my_answer.importance == i) ? \'ag-dg\' : \'\'\"></div>\r\n              </div>\r\n            </div>\r\n            <div class=\"clearfix\"><br>\r\n              <p>COMMENTS</p>\r\n              <div class=\"mb5 clearfix\">\r\n                <div class=\"inl-blk pull-right\">\r\n                  <span class=\"clk ylink\" ng-if=\"!(questions[currentIndex].my_answer.comment | isBlankString)\" ng-click=\"viewAnsComment(questions[currentIndex].my_answer)\">READ</span>\r\n                  <span ng-if=\"questions[currentIndex].my_answer.comment | isBlankString\">None</span>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"clearfix vtxt-wrap pad10\">\r\n          </div>\r\n        </div>\r\n\r\n\r\n        <div class=\"pull-left ans-col\"\r\n          ng-repeat=\"ans in questions[currentIndex].answers | orderBy:\'author.nameOnBallot\'\">\r\n          <div class=\"pad10\">\r\n            <div class=\"clearfix\" style=\"height: 120px;\">\r\n\r\n              <div ng-if=\"ans.answer > -1\" ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\">\r\n                <div class=\"cq-box inl-blk pull-right\"\r\n                  ng-class=\"(ans.answer == i) ? getComapreClass(ans.match, i) : \'\'\">\r\n                </div>\r\n\r\n                <!-- ng-class=\"(ans.answer == i) ? (\'ag-dg\'+i) : \'\'\" -->\r\n              </div>\r\n\r\n              <div ng-if=\"!ans.answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                  <b>N/A</b>\r\n                </span>\r\n              </div>\r\n            </div>\r\n            <div class=\"clearfix\" style=\"height: 32px;\">\r\n              <div class=\"mb5 clearfix\">\r\n                <div ng-if=\"ans.match != null\" class=\"inl-blk pull-right\">{{ans.match}}%</div>\r\n                <div ng-if=\"ans.match == null\" class=\"w100 text-center fwb\">N/A</div>\r\n                <i ng-if=\"ans.referenceBy && ans.referenceBy !=\'\'\" class=\"fa fa-asterisk clk info-color\" aria-hidden=\"true\" ng-click=\"getInfo(ans)\"></i>\r\n                <i ng-if=\"ans.oldAnswers.length > 0 && !ans.referenceBy\" class=\"fa fa-asterisk clk icolor\" aria-hidden=\"true\" ng-click=\"getOldAnswers(ans.oldAnswers)\" style=\"font-size: 15px;\"></i>\r\n              </div>\r\n            </div>\r\n            <div class=\"clearfix\" style=\"height: 111px;\">\r\n              <p>&nbsp;</p>\r\n              <div ng-if=\"ans.importance\" ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\">\r\n                <div class=\"cq-box inl-blk pull-right \" ng-class=\"(ans.importance == i) ? \'ag-dg\' : \'\'\"></div>\r\n              </div>\r\n              <div ng-if=\"!ans.importance\" class=\"flex w100 h100\">\r\n                <span>\r\n                  <b>N/A</b>\r\n                </span>\r\n              </div>\r\n            </div>\r\n            <div class=\"clearfix\">\r\n              <p>&nbsp;</p>\r\n              <div class=\"mb5 clearfix\">\r\n                <span class=\"clk ylink\" ng-if=\"ans.comment && !(ans.comment | isBlankString)\" ng-click=\"viewAnsComment(ans)\">READ</span>\r\n                <span ng-if=\"ans.comment && (ans.comment | isBlankString)\">None</span>\r\n                <span ng-if=\"!ans.comment\" class=\"fwb\">N/A</span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"clearfix vtxt-wrap pad10\">\r\n            <div class=\"ver-txt\" ng-if=\"ans.author.userType == \'politician\' && ans.answer\" style=\"text-transform:capitalize;\">\r\n              {{ans.author.nameOnBallot || ans.author.name}}</div>\r\n              <div class=\"ver-txt\" ng-if=\"!ans.answer\" style=\"text-transform:capitalize;\">\r\n               N/A</div>\r\n            <div class=\"ver-txt\" ng-if=\"ans.author.userType == \'advocate\'\" style=\"text-transform:capitalize;\">\r\n              {{ans.author.title || ans.author.name}}</div>\r\n            <div style=\"line-height:12px;\" ng-if=\"ans.answer\" ng-repeat=\"pitem in ans.author.politicianInfo\"\r\n              ng-if=\"pitem.candidateStatus==\'Running\'\" style=\"text-transform:capitalize;\">{{pitem.officeName}}</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"mb5 clearfix print-hide\">\r\n      <!-- <a class=\"clk fwb\" ng-click=\"prevQuestion()\">Prev</a>&nbsp;\r\n                  <a class=\"clk fwb\" ng-click=\"skipQuestion()\">Next</a> -->\r\n      <button class=\"compareBtnS\" ng-click=\"prevQuestion()\"><i class=\"fa fa-angle-left arrowIconBack\"></i>Prev</button>\r\n      <button class=\"compareBtnS\" ng-click=\"skipQuestionOne()\">Next<i class=\"fa fa-angle-right arrowIconSubmit\"></i></button>\r\n      <p><i class=\"fa fa-asterisk clk info-color\"  style=\"font-size: 15px;\"></i> This indicates that the politician did not answer this question, but we did research to figure out their LIKELY answer.  You can see our research notes by clicking on their yellow asterisk.</p>\r\n					<p><i class=\"fa fa-asterisk clk icolor\"  style=\"font-size: 15px;\"></i> This indicates that the politician changed\r\n        their answer at some point - possibly because they learned more about the topic. You can see the politician\'s\r\n        old answers for this question and the reasons for changing them by clicking on their asterix.</p>\r\n      <p>NOTE: Some of the politician questions were taken from other sources where an answer of \"True\" or \"False\" was\r\n        converted to \"Somewhat Agree\" or \"Somewhat Disagree\" (one point from either extreme) and we gave those answers\r\n        an\r\n        importance level of \"Somewhat important\". This may mean their answers do not fully express their passion or\r\n        conviction.</p>\r\n    </div>\r\n  </div>\r\n  <div ng-if=\"status.questions == 2 && questions.length == 0\" class=\"fwb\">\r\n    <center>No unanswered questions found.</center>\r\n  </div>\r\n  <div ng-if=\"status.questions == 1\" class=\"fwb\">\r\n    Loading questions ...\r\n  </div>\r\n  <div ng-if=\"status.questions == 3\" class=\"fwb\">\r\n    Something went wrong while loading questions.\r\n  </div>\r\n  <script type=\"text/ng-template\" id=\"showOldAnsPopUp\">\r\n    <div class=\"container-fluid\">\r\n      <h5>Old Answers</h5>\r\n      <div ng-repeat=\"com in oldAns track by $index\">\r\n          <div class=\"pad10\">\r\n\r\n            <br>\r\n            <span>Answer</span>\r\n            <br>\r\n            <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n\r\n              <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n                style=\"padding-left: 8px;  line-height: 15px\">\r\n                <span class=\"inl-blk pull-left\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n                <div class=\"cq-box inl-blk pull-left\"\r\n                  ng-class=\"(com.answer == i) ? getComapreClass(com.answer, i) : \'\'\"></div>\r\n                <span class=\"inl-blk\" ng-if=\"i == 6\" style=\"padding-left:8px\">DISAGREE</span>\r\n              </div>\r\n            </div>\r\n            <br>\r\n            <p></p>\r\n            <span>IMPORTANCE</span>\r\n            <br>\r\n            <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n              <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"padding-left: 8px; line-height: 9px\">\r\n                <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n                <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n                <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                  ng-class=\"(com.importance == i) ? \'ag-blk\' : \'\'\"></div>\r\n              </div>\r\n            </div>\r\n            <p></p>\r\n            <div>\r\n              <span ng-if=\"com.comment\">Comment:</span>\r\n              <span ng-if=\"com.comment\" class=\"newcomName\">{{com.comment}}</span>\r\n            </div>\r\n            <span>Reason to Change the Answer: {{com.reason}}</span><br>\r\n    <span>Updated on: {{com.created | date: \'MM-dd-y\'}}</span>\r\n            <hr style=\"\r\n            margin-left: auto;\r\n            margin-right: auto;\r\n            height: 1px;\r\n            background-color:#666;\r\n            opacity: 0.5;\">\r\n          </div>\r\n        </div>\r\n              </div>\r\n  </script>\r\n  <script type=\"text/ng-template\" id=\"showInfoPopUp\">\r\n    <div class=\"container-fluid\">\r\n      <h5>Notes</h5>\r\n      <p ng-bind-html=\"showComment | newlines\"></p>\r\n              </div>\r\n  </script>");
$templateCache.put("app/questionComparePolitician/questionComparePolitician.html","<p ng-if=\"status.levlCat == 1\" class=\"fwb\">Loading background ...</p>\r\n<div class=\"pad10\">\r\n  <div class=\"clearfix w100\">\r\n    <div ng-show=\"[\'question\', \'question-background\'].indexOf(state) > -1 && userId\">\r\n    </div>\r\n  </div>\r\n  <div class=\"clearfix w100\" ng-if=\"state == \'question-answered-by\' && politicianName\">\r\n    Showing questions answered by <b>{{politicianName}}</b>\r\n  </div>\r\n  <div>\r\n    <p>\r\n      <h1>\r\n        <center>{{category.title}}</center>\r\n      </h1>\r\n    </p>\r\n    <p></p>\r\n    <div>\r\n      <center ng-if=\"category.fbImage\">\r\n        <img ng-src=\"https://api.votewise.net/resources/{{category.fbImage}}\" class=\"wibble\" />\r\n      </center>\r\n    </div>\r\n    <center id=\"DisplayC\">\r\n      <h2>BACKGROUND</h2>\r\n    </center>\r\n    <p></p>\r\n    <div class=\"row d-flex justify-content-center\">\r\n      <div class=\"col-lg-7 col-sm-12\">\r\n        <p ng-bind-html=\"category.description | newlines\"></p>\r\n      </div>\r\n      <div ng-if=\"status.category == 1\" class=\"fwb\">\r\n        Loading category ...\r\n      </div>\r\n      <div ng-if=\"status.category == 3\" class=\"fwb\">\r\n        Something went wrong while loading category.\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <br>\r\n  <br>\r\n  <div ng-show=\"[\'question\', \'question-tagged\', \'question-background\', \'question-search\'].indexOf(state) > -1\">\r\n    <center id=\"DisplayQ\">\r\n      <label ng-hide=\"questions[currentIndex]\">\r\n        <input type=\"checkbox\" ng-model=\"flagSkipAnsweredQuestion\" ng-change=\"skipAnswerChagne()\"> Skip Answered Questions\r\n      </label>\r\n    </center>\r\n    <!-- </div> -->\r\n\r\n  </div>\r\n</div>\r\n<div ng-show=\"state == \'question-compare-politician\'\" id=\"DisplayQ1\">\r\n  <!--  <button ng-click=\"$root.printPage()\" class=\"print-hide changeTextColor\">Print this page</button> -->\r\n  <div ng-show=\"questions[currentIndex]\">\r\n    <!-- <type=\"button\" value=\"LEARN MORE\"> -->\r\n    <p></p>\r\n    <center>\r\n      <h2>QUESTION</h2>\r\n    </center>\r\n    <p></p>\r\n    <p></p>\r\n    <center>({{currentIndex+1}} of {{questions.length}})</center>\r\n    <p></p>\r\n    <p>STATEMENT: <span class=\"card-text\" ng-bind-html=\"questions[currentIndex].content | newlines\"></span></p>\r\n    Your Answers<span  style=\"margin-left: 30px;\">Their Answers</span>\r\n    <div class=\"clearfix\">\r\n      <div class=\"pull-left ans-col\" style=\"border-right: 3px solid #de8998;\">\r\n        <div class=\"pad10\">\r\n          <div class=\"clearfix\" style=\"line-height: 9px\">\r\n            <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\">\r\n              <span class=\"inl-blk\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n              <span class=\"inl-blk\" ng-if=\"i == 6\">DISAGREE</span>\r\n              <div class=\"cq-box inl-blk pull-right\"\r\n                ng-class=\"(questions[currentIndex].my_answer.answer == i) ? (\'ag-green\') : \'\'\"></div>\r\n            </div>\r\n          </div>\r\n          <div class=\"clearfix\">\r\n            <div class=\"mb5 clearfix\"><br>\r\n              <div class=\"inl-blk pull-right\">MATCH %</div>\r\n            </div>\r\n          </div><br>\r\n          <div class=\"clearfix\" style=\"line-height: 9px\">\r\n            <p>IMPORTANCE</p>\r\n            <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\">\r\n              <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n              <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n              <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n              <div class=\"cq-box inl-blk pull-right \"\r\n                ng-class=\"(questions[currentIndex].my_answer.importance == i) ? \'ag-dg\' : \'\'\"></div>\r\n            </div>\r\n          </div>\r\n          <div class=\"clearfix\"><br>\r\n            <p>COMMENTS</p>\r\n            <div class=\"mb5 clearfix\">\r\n              <div class=\"inl-blk pull-right\">\r\n                <span class=\"clk ylink\" ng-if=\"!(questions[currentIndex].my_answer.comment | isBlankString)\" ng-click=\"viewAnsComment(questions[currentIndex].my_answer)\">READ</span>\r\n                <span ng-if=\"questions[currentIndex].my_answer.comment | isBlankString\">None</span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"clearfix vtxt-wrap pad10\">\r\n        </div>\r\n      </div>\r\n      <div class=\"pull-left ans-col\" ng-repeat=\"ans in questions[currentIndex].answers | orderBy:\'author.name\'\" ng-if=\"ans.author.name\">\r\n        <div class=\"pad10\">\r\n          <div class=\"clearfix\" style=\"height: 120px;\">\r\n            <div ng-if=\"ans.answer > -1\" ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\">\r\n              <div class=\"cq-box inl-blk pull-right\" ng-class=\"(ans.answer == i) ? getComapreClass(ans.match, i) : \'\'\">\r\n              </div>\r\n              <!-- ng-class=\"(ans.answer == i) ? (\'ag-dg\'+i) : \'\'\" -->\r\n            </div>\r\n          \r\n            <div ng-if=\"!ans.answer\" class=\"flex w100 h100\">\r\n              <span>\r\n                  <b>N/A</b>\r\n                </span>\r\n            </div>\r\n          </div>\r\n          <div class=\"clearfix\" style=\"height: 32px;\">\r\n            <div class=\"mb5 clearfix\"><br>\r\n              <div ng-if=\"ans.match != null\" class=\"inl-blk pull-right\">{{ans.match}}%</div>\r\n              <div ng-if=\"ans.match == null\" class=\"w100 text-center fwb\">N/A</div>\r\n              <i ng-if=\"ans.referenceBy && ans.referenceBy !=\'\'\" class=\"fa fa-asterisk clk info-color\" aria-hidden=\"true\" ng-click=\"getInfo(ans)\"></i>\r\n													<i ng-if=\"ans.oldAnswers.length > 0 && !ans.referenceBy\" class=\"fa fa-asterisk clk icolor\" aria-hidden=\"true\" ng-click=\"getOldAnswers(ans.oldAnswers)\" style=\"font-size: 15px;\"></i>\r\n            </div>\r\n          </div><br>\r\n          <div class=\"clearfix\" style=\"height: 111px;\">\r\n            <p>&nbsp;</p>\r\n            <div ng-if=\"ans.importance\" ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\">\r\n              <div class=\"cq-box inl-blk pull-right \" ng-class=\"(ans.importance == i) ? \'ag-dg\' : \'\'\"></div>\r\n            </div>\r\n            <div ng-if=\"!ans.importance\" class=\"flex w100 h100\">\r\n              <span>\r\n                  <b>N/A</b>\r\n                </span>\r\n            </div>\r\n          </div>\r\n          <div class=\"clearfix\">\r\n            <p>&nbsp;</p>\r\n            <div class=\"mb5 clearfix\">\r\n              <span class=\"clk ylink\" ng-if=\"ans.comment && !(ans.comment | isBlankString)\" ng-click=\"viewAnsComment(ans)\">READ</span>\r\n              <span ng-if=\"ans.comment && (ans.comment | isBlankString)\">None</span>\r\n              <span ng-if=\"!ans.comment\" class=\"fwb\">N/A</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"clearfix vtxt-wrap pad10\">\r\n          <div class=\"ver-txt\" style=\"text-transform: capitalize;\">{{ans.author.name_on_ballot || ans.author.name}}</div>\r\n          <div>\r\n            <div style=\"line-height:65px;text-transform: capitalize;\" class=\"ver-txt\" ng-repeat=\"pitem in ans.author.politicianInfo\"\r\n              ng-if=\"pitem.candidateStatus==\'Running\' || pitem.candidateStatus==\'Announced\'\" >{{pitem.officeName}}</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"mb5 clearfix print-hide\">\r\n    <!-- <a class=\"clk fwb\" ng-click=\"prevQuestion()\">Prev</a>&nbsp;\r\n                  <a class=\"clk fwb\" ng-click=\"skipQuestion()\">Next</a> -->\r\n    <button class=\"compareBtnS\" ng-click=\"prevQuestion()\"><i class=\"fa fa-angle-left arrowIconBack\"></i>Prev</button>\r\n    <button class=\"compareBtnS\" ng-click=\"skipQuestion()\">Next<i class=\"fa fa-angle-right arrowIconSubmit\"></i></button>\r\n			<p><i class=\"fa fa-asterisk clk info-color\"  style=\"font-size: 15px;\"></i> This indicates that the politician did not answer this question, but we did research to figure out their LIKELY answer.  You can see our research notes by clicking on their yellow asterisk.</p>\r\n			<p><i class=\"fa fa-asterisk clk icolor\"  style=\"font-size: 15px;\"></i> This indicates that the politician changed\r\n        their answer at some point - possibly because they learned more about the topic. You can see the politician\'s\r\n        old answers for this question and the reasons for changing them by clicking on their asterix.</p>\r\n      <p>NOTE: Some of the politician questions were taken from other sources where an answer of \"True\" or \"False\" was\r\n        converted to \"Somewhat Agree\" or \"Somewhat Disagree\" (one point from either extreme) and we gave those answers\r\n        an importance level of \"Somewhat important\". This may mean their answers do not fully express their passion or\r\n        conviction.</p>\r\n  </div>\r\n  <button class=\"compareBtn\"><a href=\"#!/whatAmILookingAt4\">What Am I Looking At?</a></button>\r\n</div>\r\n<script type=\"text/ng-template\" id=\"showOldAnsPopUp\">\r\n  <div class=\"container-fluid\">\r\n    <h5>Old Answers</h5>\r\n    <div ng-repeat=\"com in oldAns track by $index\">\r\n        <div class=\"pad10\">\r\n\r\n          <br>\r\n          <span>Answer</span>\r\n          <br>\r\n          <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n\r\n            <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n              style=\"padding-left: 8px;  line-height: 15px\">\r\n              <span class=\"inl-blk pull-left\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n              <div class=\"cq-box inl-blk pull-left\"\r\n                ng-class=\"(com.answer == i) ? getComapreClass(com.answer, i) : \'\'\"></div>\r\n              <span class=\"inl-blk\" ng-if=\"i == 6\" style=\"padding-left:8px\">DISAGREE</span>\r\n            </div>\r\n          </div>\r\n          <br>\r\n          <p></p>\r\n          <span>IMPORTANCE</span>\r\n          <br>\r\n          <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n            <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"padding-left: 8px; line-height: 9px\">\r\n              <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n              <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n              <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n              <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                ng-class=\"(com.importance == i) ? \'ag-blk\' : \'\'\"></div>\r\n            </div>\r\n          </div>\r\n          <p></p>\r\n          <div>\r\n            <span ng-if=\"com.comment\">Comment:</span>\r\n            <span ng-if=\"com.comment\" class=\"newcomName\">{{com.comment}}</span>\r\n          </div>\r\n          <span>Reason to Change the Answer: {{com.reason}}</span><br>\r\n  <span>Updated on: {{com.created | date: \'MM-dd-y\'}}</span>\r\n          <hr style=\"\r\n          margin-left: auto;\r\n          margin-right: auto;\r\n          height: 1px;\r\n          background-color:#666;\r\n          opacity: 0.5;\">\r\n        </div>\r\n      </div>\r\n            </div>\r\n</script>\r\n<script type=\"text/ng-template\" id=\"showInfoPopUp\">\r\n  <div class=\"container-fluid\">\r\n    <h5>Notes</h5>\r\n    <p ng-bind-html=\"showComment | newlines\"></p>\r\n            </div>\r\n</script>");
$templateCache.put("app/questionHome/questionHome.html","<div class=\"container-fluid\">\r\n  <h2 class=\"pageHeading\">ANSWER QUESTIONS</h2>\r\n  <p class=\"pageSubHeading\">Take quizzes to get matched up with politicians and organizations. Let your politicians know what you think anonymously.</p>\r\n					<div class=\"centerediframe\">\r\n  <iframe src=\"https://player.vimeo.com/video/442446052?byline=false&title=false\" allowfullscreen ></iframe>\r\n</div>\r\n  <div class=\"row questionOptions d-none d-md-flex\">\r\n	\r\n      \r\n    <div class=\"col-lg-5 col-sm-5 offset-lg-1 removeRightPadding\" ng-class=\"{\'col-12\': showLocalMatch == true}\">\r\n        <a href=\"#!/fiveMatch/fiveminquiz\" class=\"blockLink\">\r\n      <img ng-src=\"./assets/images/5minQuizIcon.jpg\" class=\"fiveMinQuizImg img-fluid\" >\r\n      <div class=\"fiveMinQuiz\">\r\n        <div>\r\n          <h4 >FIVE MINUTE MATCH</h4>\r\n          <span>Take a five minute quiz based on the topics that most Americans find important.  The questions are taken from our Topic Quizzes which explore the logic behind all sides of an argument -so some questions may seem leading.  For more complete exploration of the arguments, take the Topic Quizzes.  Because the dramatic events of 2020, this year\'s \"5 Min Quiz\" actually runs about 8 minutes long. </span>\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n\r\n<div class=\"col-lg-5 col-sm-5 removeLeftPadding\" ng-click=\"matchQuestion()\" ng-if=\"showLocalMatch == true\"> \r\n      <a href=\"#!/ballotMatch\" class=\"blockLink\">  \r\n      <img ng-src=\"./assets/images/localMatch200.jpg\" class=\"localMatchImg img-fluid\">\r\n      <div class=\"localMatch\">\r\n        <div>\r\n          <h4>BALLOT MATCH</h4>\r\n          <span>Take a quiz that features only questions that your local politicians have answered. This could be shorter or longer than the 5 minute quiz.  For this, we need your location, so you must be signed in.</span>\r\n        </div>\r\n          </div></a>\r\n  </div>\r\n\r\n\r\n\r\n   \r\n    \r\n    \r\n    \r\n    </div>\r\n  <div class=\"row questionOptionsSmall d-md-none\">\r\n    <div class=\"col-12 removeRightPaddingSmall\">\r\n        <a href=\"#!/fiveMatch/fiveminquiz\" class=\"blockLink\">\r\n      <img ng-src=\"./assets/images/5minQuizIcon.jpg\" class=\"fiveMinQuizImgSmall img-fluid\">\r\n      <div class=\"fiveMinQuizSmall\">\r\n        <div>\r\n          <h4>FIVE MINUTE MATCH</h4>\r\n          <span>Take a five minute quiz based on the topics that most Americans find important.  The questions are taken from our Topic Quizzes which explore the logic behind all sides of an argument -so some questions may seem leading.  For more complete exploration of the arguments, take the Topic Quizzes.  Because the dramatic events of 2020, this year\'s \"5 Min Quiz\" actually runs about 8 minutes long. </span>\r\n        </div>\r\n            </div></a>\r\n    </div>\r\n  \r\n\r\n      \r\n      \r\n    <div class=\"col-12 removeRightPaddingSmall\">\r\n        <a href=\"#!/ballotMatch\" class=\"blockLink\"> \r\n      <img ng-src=\"./assets/images/localMatch200.jpg\" class=\"localMatchImgSmall img-fluid\">\r\n      <div class=\"localMatchSmall\">\r\n        <div>\r\n          <h4>BALLOT MATCH</h4>\r\n          <span>Take a quiz that features only questions that your local politicians have answered. This could be shorter or longer than the 5 minute quiz. For this, we need your location, so you must be signed in.</span>\r\n        </div>\r\n            </div></a>\r\n    </div>\r\n\r\n \r\n\r\n  </div>\r\n  <div class=\"row topicsSection d-none d-md-flex\">\r\n    <div class=\"col-3\">\r\n      <img ng-src=\"./assets/images/speakerStand200.jpg\" class=\"img-fluid\" id=\"speakerImg\">\r\n    </div>\r\n    <div class=\"col-9 shiftLeft\">\r\n      <h3 id=\"chooseTopic\">Topic Quizzes</h3>\r\n      <div id=\"chooseTopicContent\">\r\n        Choose from the topic below to dig deeper and speak out to let your politicians know what you really think. Inform them on how they should govern. Find organizations that match your vision so you can work together towards a better future.\r\n      </div>\r\n      <div style=\"text-align:center;\">\r\n        <a ng-repeat=\"item in $root.categories | orderBy: \'order\'\" href=\"#!/questionSubcategories/{{item._id}}\" title=\"{{item.title}}\" style=\"padding: 10px 0px;\">\r\n          <div class=\"allTopics\">\r\n            <img ng-src=\"{{$root.imgUrl}}/{{item.iconImage}}\" alt=\"{{item.title}}\">\r\n            <span>{{item.title}}</span>\r\n          </div>\r\n        </a>\r\n\r\n        <br><br>\r\n          <div>Can\'t find what you\'re looking for?  Try using a word search. <center>\r\n		<input ng-model=\"$root.searchQuestionKeyword\" class=\"blackText\"> <button ng-click=\"$root.searchQuestion()\" class=\"blackText\">Search Questions</button>\r\n	</center></div>\r\n\r\n\r\n        \r\n        </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"row topicsSectionSmall d-md-none\">\r\n    <div class=\"col-12\">\r\n      <h3 id=\"chooseTopic\">Topic Quizzes</h3>\r\n      <div id=\"chooseTopicContent\">\r\n        Choose from the topic below to dig deeper and speak out to let your politicians know what you really think. Inform them on how they should govern. Find organizations that match your vision so you can work together towards a better future.\r\n      \r\n        \r\n	\r\n</div>\r\n      <div style=\"text-align:center;\">\r\n        <a ng-repeat=\"item in $root.categories | orderBy: \'order\'\" href=\"#!/questionSubcategories/{{item._id}}\" title=\"{{item.title}}\" style=\"padding: 10px 0px;\">\r\n          <div class=\"allTopics\">\r\n            <img ng-src=\"{{$root.imgUrl}}/{{item.iconImage}}\" alt=\"{{item.title}}\">\r\n            <span>{{item.title}}</span>\r\n          </div>\r\n        </a>\r\n          \r\n           <br><br>\r\n          <div>Can\'t find what you\'re looking for?  Try using a word search. <center>\r\n		<input ng-model=\"$root.searchQuestionKeyword\" class=\"blackText\"> <button ng-click=\"$root.searchQuestion()\" class=\"blackText\">Search Questions</button>\r\n	</center></div>\r\n\r\n\r\n\r\n\r\n      </div>\r\n    </div>\r\n      \r\n  </div>\r\n   \r\n</div>\r\n\r\n<div ng-cloak ng-show=\"$root.userRole==\'advocate\' \" class=\"row\" >  \r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/quizzesOrg\" class=\"blockLink\"><img ng-src=\"./assets/images/quiz.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock2\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">MORE QUIZ OPTIONS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Create your own quizzes to poll your followers, test politicians to see if they are worthy of your endorsements and more.\r\n          </p>\r\n            \r\n        </div>\r\n      </div></a>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/questionSearch/questionSearch.html","<p ng-if=\"status.levlCat == 1\" class=\"fwb\">Loading background ...</p>\r\n<div class=\"pad10\">\r\n  <div class=\"clearfix w100\">\r\n    <div ng-show=\"[\'question\', \'question-background\'].indexOf(state) > -1 && userId\">\r\n    </div>\r\n  </div>\r\n  <div class=\"clearfix w100\" ng-if=\"state == \'question-answered-by\' && politicianName\">\r\n    Showing questions answered by <b>{{politicianName}}</b>\r\n  </div>\r\n  <div>\r\n    <p>\r\n      <h1>\r\n        <center>{{category.title}}</center>\r\n      </h1>\r\n    </p>\r\n    <p></p>\r\n    <div>\r\n      <center ng-if=\"category.fbImage\">\r\n        <img ng-src=\"https://api.votewise.net/resources/{{category.fbImage}}\" class=\"wibble\" />\r\n      </center>\r\n    </div>\r\n    <center id=\"DisplayC\">\r\n      <h2>BACKGROUND</h2>\r\n    </center>\r\n    <p></p>\r\n    <div class=\"row d-flex justify-content-center\">\r\n      <div class=\"col-lg-7 col-sm-12\">\r\n        <p ng-bind-html=\"category.description | newlines\"></p>\r\n      </div>\r\n      <div ng-if=\"status.category == 1\" class=\"fwb\">\r\n        Loading category ...\r\n      </div>\r\n      <div ng-if=\"status.category == 3\" class=\"fwb\">\r\n        Something went wrong while loading category.\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <br>\r\n  <br>\r\n  <div ng-show=\"[\'question\', \'question-tagged\', \'question-background\', \'question-search\'].indexOf(state) > -1\">\r\n    <center id=\"DisplayQ\">\r\n      <label ng-hide=\"questions[currentIndex]\">\r\n        <input type=\"checkbox\" ng-model=\"flagSkipAnsweredQuestion\" ng-change=\"skipAnswerChagne()\"> Skip Answered Questions\r\n      </label>\r\n    </center>\r\n    <!-- </div> -->\r\n    <div>\r\n      <!-- ng-show=\"state == \'question\' || state == \'question-tagged\' || state == \'question-background\'\" -->\r\n      <div ng-show=\"questions[currentIndex]\">\r\n        <!-- <type=\"button\" value=\"LEARN MORE\"> -->\r\n        <p></p>\r\n        <div class=\"row  d-flex justify-content-center\">\r\n          <div class=\"col-lg-7 col-sm-12 \">\r\n            <h4 class=\"text-center\">Questions</h4>\r\n            <div class=\"card customCard\">\r\n              <div class=\"card-header quesCardHeaderMain\">\r\n                <div class=\"d-flex justify-content-between bd-highlight\">\r\n                  <!-- <div class=\"p-2 bd-highlight quesCardHeader\">Statement</div> -->\r\n                  <div class=\"p-2 bd-highlight\">\r\n                    <span class=\"textYellow\">{{currentIndex+1}}</span>/{{questions.length}}</div> <label>\r\n                    <input type=\"checkbox\" ng-model=\"flagSkipAnsweredQuestion\" ng-change=\"skipAnswerChagne()\"> Skip Answered Questions\r\n                  </label>\r\n                </div>\r\n              </div>\r\n              <div class=\"card-body customCardBody\">\r\n                <p  class=\"card-text\" ng-bind-html=\"questions[currentIndex].content | newlines\"></p>\r\n                <div class=\"row vdivide\">\r\n                  <div class=\"col col-6\">\r\n                    <div class=\"rcontent\" style=\"float:right;\">\r\n                      <span id=\"disagreeText\">DISAGREE &nbsp;</span>\r\n                      <div style=\"float:right;\">\r\n                        <div class=\"box\">\r\n                          <ul class=\"vi-radio\">\r\n                            <li>\r\n                              <input type=\"radio\" id=\"agreedisagree-id6\" name=\"agreeDisagree\" value=\"6\" ng-model=\"answer\" ng-checked=\"checkIfExists(6)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                              <label for=\"agreedisagree-id6\"></label>\r\n                              <div class=\"checknew red sixth\"></div>\r\n                            </li>\r\n                          </ul>\r\n                        </div>\r\n                        <div class=\"box\">\r\n                          <ul class=\"vi-radio\">\r\n                            <li>\r\n                              <input type=\"radio\" id=\"agreedisagree-id5\" name=\"agreeDisagree\" value=\"5\" ng-model=\"answer\" ng-checked=\"checkIfExists(5)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                              <label for=\"agreedisagree-id5\"></label>\r\n                              <div class=\"checknew five fifth\"></div>\r\n                            </li>\r\n                          </ul>\r\n                        </div>\r\n                        <div class=\"box\">\r\n                          <ul class=\"vi-radio\">\r\n                            <li>\r\n                              <input type=\"radio\" id=\"agreedisagree-id4\" name=\"agreeDisagree\" value=\"4\" ng-model=\"answer\" ng-checked=\"checkIfExists(4)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                              <label for=\"agreedisagree-id4\"></label>\r\n                              <div class=\"checknew four forth\"></div>\r\n                            </li>\r\n                          </ul>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col col-6\">\r\n                    <div class=\" rcontent\">\r\n                      <span  style=\"color: #04A752; font-weight: bold;\">&nbsp;AGREE</span>\r\n                      <div style=\"float:left;\">\r\n                        <div class=\"box\">\r\n                          <ul class=\"vi-radio\">\r\n                            <li>\r\n                              <input type=\"radio\" id=\"agreedisagree-id3\" name=\"agreeDisagree\" value=\"3\" ng-model=\"answer\" ng-checked=\"checkIfExists(3)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                              <label for=\"agreedisagree-id3\"></label>\r\n                              <div class=\"checknew three third\"></div>\r\n                            </li>\r\n                          </ul>\r\n                        </div>\r\n                        <div class=\"box\">\r\n                          <ul class=\"vi-radio\">\r\n                            <li>\r\n                              <input type=\"radio\" id=\"agreedisagree-id2\" name=\"agreeDisagree\" value=\"2\" ng-model=\"answer\" ng-checked=\"checkIfExists(2)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                              <label for=\"agreedisagree-id2\"></label>\r\n                              <div class=\"checknew two second\"></div>\r\n                            </li>\r\n                          </ul>\r\n                        </div>\r\n                        <div class=\"box\">\r\n                          <ul class=\"vi-radio\">\r\n                            <li>\r\n                              <input type=\"radio\" id=\"agreedisagree-id1\" name=\"agreeDisagree\" value=\"1\" ng-model=\"answer\" ng-checked=\"checkIfExists(1)\" class=\"ng-pristine ng-untouched ng-valid ng-empty\">\r\n                              <label for=\"agreedisagree-id1\"></label>\r\n                              <div class=\"checknew first\"></div>\r\n                            </li>\r\n                          </ul>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"card card1\">\r\n              <div class=\"card-header card1Header\">\r\n                <p class=\"card-title\">ADD COMMENT</p>\r\n              </div>\r\n              <div class=\"card-body card1Body\">\r\n                <textarea class=\"form-control addComment\" id=\"exampleFormControlTextarea1\" ng-model=\"comment\" rows=\"1\" placeholder=\"(not required)\"></textarea>\r\n                <textarea ng-show=\"questions[currentIndex].my_answer\" ng-model=\"reason\" class=\"vi-textarea\" placeholder=\"REASON TO CHANGE ANSWER\" style=\"margin-top: 10px;\"></textarea>\r\n              </div>\r\n            </div>\r\n            <div class=\"card card1\">\r\n              <div class=\"card-header card1Header\">\r\n                <p class=\"card-title\">IMPORTANCE</p>\r\n              </div>\r\n              <div class=\"card-body card1Body\" style=\"margin:0 auto;\">\r\n                <form class=\"impSection d-md-flex d-sm-block\">\r\n                  <div class=\"A\">\r\n                    <input type=\"radio\" class=\"button\" id=\"importance-id1\" ng-model=\"importance\" name=\"importance\" ng-model=\"importance\" ng-checked=\"checkImpExists(1)\" ng-click=\"subNew(1)\" value=\"1\"></input>\r\n                    <label for=\"importance-id1\">Not Very</label>\r\n                  </div>\r\n                  <div class=\"B\">\r\n                    <input type=\"radio\" class=\"button\" id=\"importance-id2\" ng-model=\"importance\" name=\"importance\" ng-model=\"importance\" ng-checked=\"checkImpExists(2)\" ng-click=\"subNew(2)\" value=\"2\"></input>\r\n                    <label for=\"importance-id2\">Somewhat</label>\r\n                  </div>\r\n                  <div class=\"C\">\r\n                    <input type=\"radio\" class=\"button\" id=\"importance-id3\" ng-model=\"importance\" name=\"importance\" ng-model=\"importance\" ng-checked=\"checkImpExists(3)\" ng-click=\"subNew(3)\" value=\"3\"></input>\r\n                    <label for=\"importance-id3\">Very</label>\r\n                  </div>\r\n                  <!-- </div> -->\r\n                </form>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\">\r\n              <div class=\"col bottomBtns\">\r\n                <div class=\"btn-group\" role=\"group\" aria-label=\"Default button group\">\r\n                  <button type=\"button\" id=\"backBtn\" class=\"btn-transparent\" ng-click=\"prevQuestion()\">\r\n                    <i class=\"fa fa-angle-left arrowIconBack\"></i> Back</button>\r\n                  <button type=\"button\" id=\"skipBtn\" class=\"btn-transparent\" ng-click=\"skipQuestion()\">Skip</button>\r\n                  <button type=\"button\" id=\"submitBtn\" class=\"btn-transparent\" ng-click=\"submitAnswer()\" ng-class=\"{\'activeSubmit\': (answer &&importance)}\">Submit\r\n                    <i class=\"fa fa-angle-right arrowIconSubmit\"></i>\r\n                  </button>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <center>\r\n              <button type=\"button\" id=\"btnY\" class=\"btn-transparent\" ng-click=\"notAnswerableSelected()\" ng-show=\"$root.userRole==\'admin\'||$root.userRole==\'advocate\' \">REPORT BAD QUESTION</button>\r\n            </center>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/questionSubcategories/questionSubcategories.html","<p></p>\r\n<h1>\r\n  <center>{{category.title}}</center>\r\n</h1>\r\n<p></p>\r\n<p></p>\r\n<center>Choose a subcategory</center>\r\n<p></p>\r\n<form lpformnum=\"1\">\r\n  <center>\r\n    <div class=\"mb20\" ng-repeat=\"item in subCategories | orderBy:\'order\' track by $index\">\r\n      <a href=\"javascript: void(0)\" ng-click=\"goToNextPage(item)\">\r\n        <input type=\"button\" class=\"btn\" value=\"{{item.title}}\">\r\n      </a>\r\n    </div>\r\n  </center>\r\n</form>\r\n");
$templateCache.put("app/quizResult/quizResult.html","<div class=\"container-fluid\">\r\n\r\n\r\n  <div class=\"row table-responsive\" ng-if=\"list.length > 0\" style=\"margin-top: 10px;\">\r\n    <table class=\"table w100 changeTextColor\">\r\n      <tr>\r\n        <th>\r\n          Name\r\n        </th>\r\n        <th>\r\n          See Answers\r\n        </th>\r\n      </tr>\r\n      <tr ng-repeat=\"u in list track by $index\">\r\n\r\n        <td>\r\n          <p ng-if=\"u.name\" style=\"margin: 0;\">\r\n            <strong>Name:</strong>\r\n            {{u.name}}\r\n          </p>\r\n        </td>\r\n        <td>\r\n          <a href=\"#!/poliAnswers/\'\'/\'\'/{{u.email}}\" class=\"link\">View</a>\r\n        </td>\r\n      </tr>\r\n    </table>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/quizzes/quizzes.html","<div class=\"container-fluid ng-scope\">\r\n\r\n  <h2 class=\"pageHeading\">IDEOLOGICAL MATCH QUESTIONS</h2>\r\n  <p class=\"pageSubHeading\">You have a lot of quizzes available to you. Use them to express your concerns, reach voters,\r\n    or connect with other people and organizations fighting for the same things you care about.</p>\r\n  <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n    <a href=\"#!/compositeQuiz\" class=\"blockLink\"><img ng-src=\"./assets/images/OrgQuiz.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock2\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">ORGANIZATION QUIZZES</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Take quizzes created by other organizations.  Some of these quizzes may be made especially for you to see if they want to endorse you.</p>\r\n\r\n        </div>\r\n      </div></a>\r\n  </div>\r\n<!--      BRING BACK\r\n  <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n    <a href=\"#!/getPopularQues/false\" class=\"blockLink\"><img ng-src=\"./assets/images/popular.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock4\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">MOST POPULAR</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Find and answer the questions answered by the most voters, politicians or organizations.  </p>\r\n        </div>\r\n      </div></a>\r\n  </div>\r\n-->\r\n\r\n  <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n    <a href=\"#!/winVoters\" class=\"blockLink\"><img ng-src=\"./assets/images/clipBoard2.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock3\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">IMPORTANT TO YOU</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Explore different topics and take the quizzes on the subjects that are most important to you so that others can know where you stand.  Let potential voters and allies find you. </p>\r\n\r\n        </div>\r\n      </div></a>\r\n  </div>\r\n\r\n  <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n    <a href=\"#!/fiveMatch#DisplayQ\" class=\"blockLink\"><img ng-src=\"./assets/images/5minQuiz1.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock4\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">FIVE MINUTE MATCH</h4>\r\n          <p class=\"gettingStartedBlockDesc\">This is a five minute quiz aimed at voters who do not have the time to devote to deeper research.  Each year, the questions are chosen by people in the community who think these topics are important. </p>\r\n\r\n        </div>\r\n            </div></a></div>\r\n\r\n  <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n    <a href=\"#!/ballotMatch\" class=\"blockLink\"><img ng-src=\"./assets/images/ballotMatch.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock5\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">BALLOT MATCH</h4>\r\n          <p class=\"gettingStartedBlockDesc\">This is a quiz made up of all the questions answered by politicians in your area who are on the ballot for the next election. It could be a short quiz or it could be a really long one depending on their participation in this site.</p>\r\n\r\n        </div>\r\n      </div></a>\r\n  </div>\r\n\r\n\r\n</div>\r\n</div>\r\n");
$templateCache.put("app/quizzesOrg/quizzesOrg.html","<div class=\"container-fluid ng-scope\">\r\n\r\n  <h2 class=\"pageHeading\">IDEOLOGICAL MATCH QUESTIONS</h2>\r\n  <p class=\"pageSubHeading\">You have a lot of quizzes available to you. Use them to express your concerns, reach voters,\r\n    or connect with other people and organizations fighting for the same things you care about.</p>\r\n\r\n  <div class=\"row\">\r\n\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/questionHome\" class=\"blockLink\"><img ng-src=\"./assets/images/clipBoard2.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock1\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">IMPORTANT TO YOU</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Explore different topics and take the quizzes on the subjects that are most important to you so that others can know where you stand.  We reccommend answering as many questions as possible, but only questions that you have official positions on.  If you answer more questions, you pop up higher in people\'s searches, and we use your answers to help users, politicians and other organizations find you. </p>\r\n\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/manageOrganizationQuestions\" class=\"blockLink\"><img ng-src=\"./assets/images/createQuiz.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock2\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">CREATE QUIZZES</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Use our questions to create quizzes to poll your members, find out if politicians are worth endorsing, or draw interest to your cause by posting quizzes to Facebook.</p>\r\n\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n<!--   BRING BACK\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/getPopularQues/false\" class=\"blockLink\"><img ng-src=\"./assets/images/popular.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock4\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">MOST POPULAR</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Find and answer the questions answered by the most voters, politicians or organizations.  </p>\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n\r\n-->\r\n\r\n\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/fiveMatch#DisplayQ\" class=\"blockLink\"><img ng-src=\"./assets/images/5minQuiz1.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock5\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">FIVE MINUTE MATCH</h4>\r\n          <p class=\"gettingStartedBlockDesc\">This is a five minute quiz aimed at voters who do not have the time to devote to deeper research.  Each year, the questions are chosen by people in the community who think these topics are important. </p>\r\n\r\n        </div>\r\n            </div></a></div>\r\n\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/ballotMatch\" class=\"blockLink\"><img ng-src=\"./assets/images/ballotMatch.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock6\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">BALLOT MATCH</h4>\r\n          <p class=\"gettingStartedBlockDesc\">This is a quiz made up of all the questions answered by politicians in your area who are on the ballot for the next election. It could be a short quiz or it could be a really long one depending on their participation in this site.</p>\r\n\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n\r\n\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/rateBallotMeasures/rateBallotMeasures.html","<div class=\"container-fluid add-rating-container\" ng-cloak\r\n  ng-show=\"$root.userRole==\'admin\'|| $root.userRole==\'advocate\'|| $root.userRole==\'politician\'\">\r\n  <h2 class=\"pageHeading\">Add Rating to Ballot Measures</h2>\r\n  <form ng-submit=\"submitReview()\" name=\"myform\" id=\"myform\">\r\n\r\n    <div class=\"row d-lg-flex\">\r\n\r\n      <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\">\r\n        <div ng-if=\"selectionType != \'yourself\'\">\r\n          <div class=\"control-group\" id=\"auto-user-suggest-box\">\r\n            <label class=\"control-label\" for=\"title\" style=\"text-transform: capitalize;\">Selected Ballot Measure</label>&nbsp;&nbsp;	 <center>\r\n    <div ng-if=\"showLoader\" style=\"z-index: 2; background:black;\"><i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span></div>\r\n\r\n  </center>\r\n            <div class=\"controls\" mass-autocomplete>\r\n              <input ng-model=\'selectedUser.value\' ng-disabled=\"true\" class=\"form-control\" />\r\n                </div>\r\n            </div>\r\n\r\n            <br />\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"grade\" style=\"text-transform: capitalize;\">Select Grade 0-100</label>\r\n              <div class=\"controls\">\r\n                <input type=\"number\" name=\"rating\" ng-model=\"review.grade.number\" class=\"form-control validate[required]\"  min=\"0\" max=\"100\"/>\r\n                <div role=\"alert\">\r\n                  <span class=\"error\" ng-show=\"myform.rating.$dirty && myform.rating.$error.number\">Please Add Valid Number</span>\r\n                  <span class=\"error\" ng-show=\"myform.rating.$dirty && myform.rating.$error.required\">Required field</span>\r\n\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <br />\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"title\" style=\"text-transform: capitalize;\">Write Review</label>\r\n\r\n              <div class=\"controls\">\r\n                <textarea ng-model=\"review.text\" class=\"form-control\"></textarea>\r\n              </div>\r\n            </div>\r\n            <br />\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"title\" style=\"text-transform: capitalize;\">Links to outside reviews or other relevant items</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"review.links[0]\" class=\"form-control\" />\r\n                <br />\r\n                <input type=\"text\" ng-model=\"review.links[1]\" class=\"form-control\" />\r\n                <br />\r\n                <input type=\"text\" ng-model=\"review.links[2]\" class=\"form-control\" />\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <button type=\"submit\" class=\"donateBtn btn\"  style=\"width: auto;margin-top: 20px;margin-left: 0;\">Submit Review</button>\r\n          </div>\r\n  </form>\r\n\r\n</div>\r\n\r\n\r\n</div>\r\n");
$templateCache.put("app/ratePolitician/ratePolitician.html","<div class=\"container-fluid\" ng-cloak ng-show=\"$root.userRole==\'admin\'|| $root.userRole==\'advocate\'|| $root.userRole==\'politician\'\">\r\n  <h2 class=\"pageHeading\">RATE/ENDORSE POLITICIANS</h2>\r\n  <p class=\"pageSubHeading noPaddBott\">Use this tool to look up politicians by name so that you can rate or endorse\r\n    them.</p>\r\n\r\n  <form name=\"myForm\" role=\"form\" ng-controller=\"ratePoliticianCtrl\">\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Search Politician</legend>\r\n      <div class=\"row\">\r\n        <div class=\"col-md col-lg col-sm\">\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\">Search By Name</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"User.name\" class=\"form-control\">\r\n                  </div>\r\n            </div>\r\n\r\n          </div>\r\n          <div class=\"col-md col-lg col-sm\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"email\">Select State</label>\r\n              <div class=\"controls\">\r\n                <select class=\"changeTextColor form-control\" ng-model=\"User.state\" style=\"text-transform: capitalize;\"  ng-options=\"item.state for item in allState track by item.state\"></select>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-md col-lg col-sm\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"email\">Running For Office</label>\r\n              <div class=\"controls\">\r\n                <select ng-model=\"User.runningFor\" class=\"form-control\">\r\n                        <option value=\"\">Select Status</option>\r\n                        <option value=\"Y\">Yes</option>\r\n                        <option value=\"N\">No</option>\r\n                      </select>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div style=\"text-align: center;margin-top: 5%\">\r\n          <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"search()\">\r\n                            Search\r\n                          </button>\r\n          <!-- </div> -->\r\n        </div>\r\n    </fieldset>\r\n\r\n    <div class=\"row table-responsive \" ng-if=\"searchResult.length> 0\" style=\"margin-top: 10px;\">\r\n      <table class=\"table w100 changeTextColor\">\r\n        <tr>\r\n\r\n          <th>Name</th>\r\n          <th>Party</th>\r\n          <th>Candidate Status</th>\r\n          <th>Rate Politician</th>\r\n          <th>Endorse Politician</th>\r\n\r\n        </tr>\r\n        <tr ng-repeat=\"u in searchResult\">\r\n\r\n          <td>\r\n\r\n            <span ng-if=\"u.name\">{{u.name}}</span>\r\n            <span ng-if=\"!u.name && u.nameOnBallot\">{{u.nameOnBallot}}</span>\r\n          </td>\r\n          <td>\r\n            <span ng-if=\"u.politicianInfo.length > 0\">{{u.politicianInfo[0].party[0]}}</span>\r\n            <span ng-if=\"u.party.length > 0\">{{u.party[0]}}</span>\r\n            <span ng-if=\"u.party == \'\'\">N/A</span>\r\n\r\n          </td>\r\n          <td>\r\n            <span ng-if=\"u.politicianInfo.length > 0\">{{u.politicianInfo[0].candidateStatus}}</span>\r\n            <span ng-if=\"u.candidateStatus !=\'\'\">{{u.candidateStatus}}</span>\r\n            <span ng-if=\"u.candidateStatus ==\'\'\">N/A</span>\r\n\r\n          </td>\r\n          <td>\r\n            <a href=\"#!/addRating/{{u._id}}\" class=\"link\">Rate</a>\r\n          </td>\r\n          <td>\r\n            <a href=\"\" ng-if=\"!u.endorse\" ng-click=\"endorse(u,\'endorse\')\" class=\"link\">Endorse</a>\r\n            <a href=\"\" ng-if=\"u.endorse\" ng-click=\"endorse(u,\'already endorse\')\" class=\"link\">Already Endorse</a>\r\n            <!-- <a href=\"\" ng-if=\"showEndorse\" ng-click=\"endorse(u._id,\'remove\')\" class=\"link\">Remove</a> -->\r\n            <br>\r\n            <!-- <label ng-if=\"fEndorse && chkId == u._id \" for=\"note\">Note</label>\r\n            <input type=\"text\" ng-if=\"fEndorse && chkId == u._id \" ng-model=\"User.note\">\r\n            <button type=\"button\" class=\" btn-primary\" ng-if=\"fEndorse && chkId == u._id\" ng-click=\"addInfo(u)\">Submit</button> -->\r\n          </td>\r\n        </tr>\r\n      </table>\r\n      <p ng-if=\"statusGetResPg == 1\" class=\"fwb\">Loading candidiates...</p>\r\n    </div>\r\n  </form>\r\n</div>\r\n<script type=\"text/ng-template\" id=\"notePop\">\r\n  <div class=\"row\">\r\n  <div class=\"col-12\">\r\n    <h3>Endorse</h3>\r\n    <div class=\"col-md-12\">\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel\">Note</label>\r\n        <br>\r\n        <div class=\"control-group\">\r\n          <textarea type=\"textarea\" id=\"address\" ng-model=\"User.note\" class=\"zipInput form-control\" >&nbsp;\r\n          </textarea>\r\n        </div>\r\n            <br>\r\n      </div>\r\n\r\n      <div class=\"form-group\"><br>\r\n\r\n        <center>\r\n          <button ng-click=\"addInfo()\" type=\"button\" class=\"btn2Short-style widthAuto btn-success\">Submit</button>\r\n        </center>\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n</script>\r\n<script type=\"text/ng-template\" id=\"disNotePop\">\r\n  <div class=\"row\">\r\n  <div class=\"col-12\">\r\n    <!-- <h3>Note</h3> -->\r\n    <div class=\"col-md-12\">\r\n      <span>Note:</span> <span ng-if=\"disNote\"><b>{{disNote}}</b></span><span ng-if=\"!disNote\"><b>N/A</b></span>\r\n\r\n      <div class=\"form-group\"><br>\r\n\r\n        <center>\r\n          <button ng-click=\"close()\" type=\"button\" class=\"btn2Short-style widthAuto btn-success\">Close</button>\r\n        </center>\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n</script>\r\n");
$templateCache.put("app/ratingReviews/ratingReviews.html","<!-- <div id=\"background\"></div> -->\r\n<div class=\"container-fluid\">\r\n  <h2 class=\"pageHeading\">Organization Matches</h2>\r\n  <p class=\"pageSubHeading\">See what organizations you match best with.</p>\r\n  <div class=\"col-lg-6 col-sm-12\">The default is to show overall ratings, but you may choose to look for ratings on specific topics.</div>\r\n  <br>\r\n  <div>\r\n        <div class=\"squareBoxY\" style=\"margin-left:10px;\">&nbsp;</div>\r\n        <span>= Simple Comparison by answers alone.</span>\r\n        <div style=\"clear:both;\"></div>\r\n        <div class=\"squareBoxB\" style=\"margin-left:10px\">&nbsp;</div>\r\n        <span>= Weighted Comparison by answers and importance.</span>\r\n        <div style=\"clear:both;\"></div>\r\n    </div>\r\n  <div class=\"col-lg-12 col-centered\" id=\"compareContent\">\r\n    <div class=\"tableContainer\">\r\n     \r\n      <div class=\"table-responsive\">\r\n        <table class=\"table table-striped\" style=\"margin-bottom:0px;\">\r\n          <tr>\r\n            <th class=\"tableHead\">Organization</th>\r\n            <th class=\"tableHead\">Your Match</th>\r\n           \r\n          </tr>\r\n          <tr ng-repeat=\"item in organizations\">\r\n            <td class=\"tableRow\">\r\n                  <b ng-if=\"!item.orgTitle\">{{item.author.name}}</b>\r\n                  <b ng-if=\"item.orgTitle\">{{item.orgTitle}}</b>\r\n\r\n            </td>\r\n            <td class=\"tableRow\">\r\n            <div>\r\n                        <div class=\"fbunweighted\" style=\"background-color:yellow;width:{{(item.match / item.fbqlength) | number:2}}%\">{{(item.match / item.fbqlength) | number:2}}%</div>\r\n                    </div>\r\n                    <div>\r\n                        <div class=\"fbweighted blackText\" style=\"width:{{(item.fbcombinedWeight / item.fbmultiplier) | number:2}}%\">{{(item.fbcombinedWeight / item.fbmultiplier) | number:2}}%</div>\r\n                    </div>\r\n              \r\n            </td>\r\n           \r\n          </tr>\r\n        </table>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"bottomInfo\">\r\n    <p>If there are organizations that you personally like but don\'t see here, contact them and ask them to answer questions so we can help them shape the future.</p>\r\n  </div>\r\n</div>\r\n</div>\r\n</script>\r\n");
$templateCache.put("app/ratingsDetails/ratingsDetails.html","<!-- <div id=\"background\"></div> -->\r\n<div class=\"container-fluid\">\r\n  <h2 class=\"pageHeading\">\r\n    <a href=\"#!/pressProfile/{{reviewDetails.votesmart[0].from[0].uid}}\" ng-if=\"reviewDetails.votesmart[0].to[0].uid != reviewDetails.votesmart[0].from[0].uid\"> <span ng-if=\"reviewDetails.votesmart[0].orgName\">{{reviewDetails.votesmart[0].orgName}}</span> <span ng-if=\"!reviewDetails.votesmart[0].uType\"> {{reviewDetails.votesmart[0].from[0].name}}</span>\r\n    <span ng-if=\"reviewDetails.votesmart[0].pName\">{{reviewDetails.votesmart[0].pName}}</span>\r\n    </a>\r\n    <!-- <span ng-if=\"reviewDetails.to[0].uid == reviewDetails.from[0].uid\">{{reviewDetails.votewise[0].referal[0].name}}</span> -->\r\n    <!-- {{reviewDetails.votesmart.length}} -->\r\n    <span ng-if=\"reviewDetails.votesmart.length != 0 && !reviewDetails.votesmart[0].from\">{{reviewDetails.votesmart[0].sig.name}}</span>\r\n  </h2>\r\n  <p class=\"pageSubHeading\">Rating of\r\n    <a href=\"#!/publicProfile/{{reviewDetails.votesmart[0].to[0].uid}}\">{{reviewDetails.votesmart[0].to[0].name}}</a>\r\n    <span ng-if=\"reviewDetails.votesmart[0] && !reviewDetails.votesmart[0].from && !candiName\">Admin</span>\r\n    <span ng-if=\"candiName\">{{candiName}}</span>\r\n  </p>\r\n  <div class=\"row\" style=\"text-align:right;\">\r\n    <div class=\"col-lg-12\">\r\n      <div id=\"topHeader\">\r\n        <a href=\"#!/allRatings/{{politicianId}}/false/false\" ng-if=\"politicianId\" class=\"ylink\">Back</a>\r\n        <a href=\"#!/allRatings/{{usid}}/false/true\" ng-if=\"usid && !politicianId && !candiName\" class=\"ylink\">Back</a>\r\n        <a href=\"#!/allRatings/{{usid}}/false/false\" ng-if=\"usid && !politicianId\" class=\"ylink\">Back</a>\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <!-- Small Screen -->\r\n  <div class=\"col-lg-12 col-centered\" id=\"compareContent\">\r\n    <div class=\"tableContainer\" ng-if=\"reviewDetails.votewise[0]\">\r\n      <center>\r\n        <h3 style=\"text-transform: capitalize; color:#fff;\">Rating {{reviewDetails.votewise[0].number}}%</h3>\r\n      </center>\r\n      {{reviewDetails.votewise[0].review}}\r\n      <br>\r\n      <br>\r\n      <!--\r\n        <span ng-if=\"reviewDetails.referal[0].uid != reviewDetails.from[0].uid\">\r\n          NOTE: This entry was created by {{reviewDetails.referal[0].name}} based on an article on an outside website.\r\n          <a href=\"{{reviewDetails.links}}\" class=\"ylink\" ng-if=\"reviewDetails.links\">SEE ARTICLE</a>\r\n        </span>\r\n        <span ng-if=\"reviewDetails.referal[0].uid == reviewDetails.from[0].uid\">\r\n          NOTE: This entry was created by {{reviewDetails.from[0].name}} based on an article on an outside website.\r\n          <a href=\"{{reviewDetails.links}}\" class=\"ylink\" ng-if=\"reviewDetails.links\">SEE ARTICLE</a>\r\n        </span>\r\n         -->\r\n      <br>\r\n      <!--<hr>\r\n        <br> -->\r\n\r\n      <div ng-repeat=\"link in arrLinks track by $index\">\r\n        <div ng-if=\"link !=\'\'\">\r\n          <h5>Relevant Link</h5>\r\n        </div>\r\n        <a href=\"{{link}}\" target=\"_blank\" class=\"ylink\">{{link}}</a>\r\n      </div>\r\n    </div>\r\n    <div class=\"tableContainer\" ng-if=\"reviewDetails.votesmart[0]\">\r\n      <center>\r\n        <h3 style=\"text-transform: capitalize; color:#fff;\" ng-if=\"reviewDetails.votesmart[0]\">Rating\r\n          {{reviewDetails.votesmart[0].candidateRating[0].rating}}%</h3>\r\n      </center>\r\n      <b>{{pdata.ratingName}}</b>\r\n      <div>{{pdata.ratingText}}</div>\r\n      <div ng-if=\"reviewDetails.votesmart[0].review\">{{reviewDetails.votesmart[0].review}}</div>\r\n      <br>\r\n      <br>\r\n      <div ng-repeat=\"link in arrLinks track by $index\">\r\n        <div ng-if=\"link !=\'\'\">\r\n          <h5>Relevant Link</h5>\r\n        </div>\r\n        <a href=\"{{link}}\" target=\"_blank\" class=\"ylink\">{{link}}</a>\r\n      </div>\r\n      <!--\r\n        <span ng-if=\"reviewDetails.referal[0].uid != reviewDetails.from[0].uid\">\r\n          NOTE: This entry was created by {{reviewDetails.referal[0].name}} based on an article on an outside website.\r\n          <a href=\"{{reviewDetails.links}}\" class=\"ylink\" ng-if=\"reviewDetails.links\">SEE ARTICLE</a>\r\n        </span>\r\n        <span ng-if=\"reviewDetails.referal[0].uid == reviewDetails.from[0].uid\">\r\n          NOTE: This entry was created by {{reviewDetails.from[0].name}} based on an article on an outside website.\r\n          <a href=\"{{reviewDetails.links}}\" class=\"ylink\" ng-if=\"reviewDetails.links\">SEE ARTICLE</a>\r\n        </span>\r\n         -->\r\n      <br>\r\n      <!--<hr>\r\n        <br> -->\r\n      <div ng-repeat=\"link in reviewDetails.links track by $index\">\r\n        <div ng-if=\"link!=\'\'\">\r\n          <h5>Relevant Link</h5>\r\n        </div>\r\n        <a href=\"{{link}}\" target=\"_blank\" class=\"ylink\">{{link}}</a>\r\n      </div>\r\n    </div>\r\n    <br>\r\n    <!--     <hr>\r\n        <br> -->\r\n    <!--     <p>review.to[0].uid = {{review.to[0].uid}}</p>\r\n        <p>review.from[0].uid = {{review.from[0].uid}}</p>\r\n     <p>reviewDetails.from[0].name={{reviewDetails.from[0].name}}</p>\r\n        <p>reviewDetails.referal[0].name={{reviewDetails.referal[0].name}}</p> -->\r\n    <div ng-hide=\"reviewDetails.referal[0].name==reviewDetails.from[0].name\">\r\n      <h5>NOTE: This entry was created by {{reviewDetails.votewise[0].from[0].name}} based on an outside article or\r\n        review by {{reviewDetails.votewise[0].referal[0].name}}</h5>\r\n    </div>\r\n  </div>\r\n</div>\r\n<!-- <div>\r\n    <div class=\"col-lg-12 col-centered\" id=\"compareContent\">\r\n\r\n      <div class=\"tableContainer\">\r\n        <center>\r\n          <h3 style=\"text-transform: capitalize; color:#fff;\">Crime and Punishment: A-</h3>\r\n        </center>\r\n        Donald Smedley has been a great fighter for the fair treatment of accused people. When Bill Plimpton was imprisoned on false\r\n        charges, Donald Smedley raised funds to defend him. He went on a speeaking tour to all the law schools around the\r\n        East Coast and got 120 student volunteers to help defend Bill Plimpton and to create better laws to prevent that\r\n        miscarriage of justice again.\r\n        <br>\r\n        <br> NOTE: This entry was created by VoteWise staff based on an article on an outside website.\r\n        <a href=\"https://www.splcenter.org/news/2018/06/08/weekend-read-executed-committing-war-crimes-%E2%80%94-then-honored-confederate-monument\"\r\n          class=\"ylink\">SEE ARTICLE</a>\r\n        <br>\r\n        <br>\r\n        <br>\r\n        <hr>\r\n        <br>\r\n        <center>\r\n          <h3 style=\"text-transform: capitalize; color:#fff;\">Environment: F</h3>\r\n        </center>\r\n\r\n        Donald Smedley has a horrible record with the environment. He owned a chemical factory that dumped waste into rivers of 17\r\n        nations, poisoning millions of people.\r\n\r\n        <br>\r\n        <br> NOTE: This entry was created by VoteWise staff based on an article on an outside website.\r\n        <a href=\"https://www.splcenter.org/news/2018/06/08/weekend-read-executed-committing-war-crimes-%E2%80%94-then-honored-confederate-monument\"\r\n          class=\"ylink\">SEE ARTICLE</a>\r\n        <br>\r\n        <br>\r\n      </div>\r\n    </div>\r\n\r\n  </div> -->\r\n</div>\r\n");
$templateCache.put("app/registerToVote/registerToVote.html","<div class=\"container-fluid\">\r\n     <h2 class=\"pageHeading\">REGISTER TO VOTE</h2>\r\n  <p class=\"pageSubHeading\">This is a tool created by Vote.org (unrelated to VoteWise).  Make sure you register well in advance of the elections.</p>\r\n\r\n<iframe src=\"https://register.vote.org/?partner=111111&campaign=free-tools\" width=\"100%\" height=\"1200\" marginheight=\"0\" frameborder=\"0\" id=\"frame1\" scrollable =\"no\"></iframe><script type=\"text/javascript\" src=\"//cdnjs.cloudflare.com/ajax/libs/iframe-resizer/3.5.3/iframeResizer.min.js\"></script><script type=\"text/javascript\">iFrameResize({ log:true, checkOrigin:false});</script>");
$templateCache.put("app/reports/comments.html","\r\n<h1><center>All Comments</center></h1>\r\n<p>Question:\r\n    <br/> {{CommentQuestion.content}}\r\n</p>\r\n<p>Comments</p>\r\n<table class=\"w100\" ng-if=\"AllComments.length > 0\" ng-init=\"items.total = 0\">\r\n    <tr>\r\n        <th style=\"width:80%\">Comments</th>\r\n        <th style=\"width:20%\">User</th>\r\n    </tr>\r\n    <tr ng-repeat=\"u in AllComments\">\r\n        <td>\r\n            {{u.comment}}\r\n        </td>\r\n        <td>\r\n            \r\n           <!-- {{u.userData.name || u.userData.username}}  -->\r\n\r\n        </td>        \r\n    </tr>\r\n</table>\r\n");
$templateCache.put("app/reports/reports.html","<link rel=\"stylesheet\" type=\"text/css\" href=\"./reports/reports.css\">\r\n<div>\r\n    <!-- This is the end of the header -->\r\n    <p>\r\n        <h1><center>Reports</center></h1></p>\r\n    <div class=\"pad10\">\r\n        <a ng-show=\"[\'forumadmin\', \'voteradmin\', \'admin\', \'politician\'].indexOf($root.userRole) > -1\" ng-click=\"showTab(\'AnsweredQuestion\')\" ng-class=\"{\'active\': $scope.showAnswered}\" class=\"link\">Answered Questions |</a>\r\n        <a ng-show=\"[\'forumadmin\', \'voteradmin\', \'admin\'].indexOf($root.userRole) > -1\" ng-click=\"showTab(\'AreaQuestion\')\" ng-class=\"{\'active\': $scope.showArea}\" class=\"link\">Answered Questions by region |</a>\r\n        <a ng-show=\"[\'forumadmin\', \'voteradmin\', \'admin\', \'politician\'].indexOf($root.userRole) > -1\" ng-click=\"showTab(\'CommentsQuestion\')\" ng-class=\"{\'active\': $scope.showComments}\" class=\"link\">Comments |</a>\r\n        <a ng-show=\"$root.userRole==\'admin\'\" ng-click=\"showTab(\'liveUsers\')\" ng-class=\"{\'active\': $scope.showliveUsers}\" class=\"link\">Live Users |</a>\r\n        \r\n        <!-- <a ng-show=\"$root.userRole == \'politician\'\" ng-click=\"$root.showPoliProfile = !$root.showPoliProfile\" ng-class=\"{\'active\': showPoliProfile}\">My Profile |</a>\r\n        <a ng-click=\"$root.showFollowing = !$root.showFollowing\" ng-class=\"{\'active\': $root.showFollowing}\">Following Users |</a> -->\r\n        <hr ng-show=\"Auth\" size=\"5\" noshade=\"\">\r\n        <div class=\"flex\">\r\n            <div class=\"margin-auto\">\r\n                <!-- Answered Questions -->\r\n                <div ng-if=\"showAnswered\">\r\n                    <h2><center>Answered Questions</center></h2>\r\n                    <fieldset class=\"scheduler-border\">\r\n                        <legend class=\"scheduler-border\">Select Category</legend>\r\n                        <div class=\"row\">\r\n                            <div class=\"col-md-12\">\r\n                                <div>\r\n                                    <div class=\"control-group\">\r\n                                        <label class=\"control-label\" for=\"profile-name\">Category</label>\r\n                                        <div class=\"controls\">\r\n                                            <select ng-model=\"Report.category\" ng-change=\"getSubcat()\" style=\"text-transform: capitalize;\" class=\"blackText\" ng-options=\"item as item.title for item in categories\"></select> &nbsp; &nbsp;<i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showCatLoading\"></i>\r\n                                        </div>\r\n                                    </div>\r\n                                    <div class=\"control-group\" ng-if=\"Report.category!=\'\'\">\r\n                                        <label class=\"control-label\" for=\"profile-name\">Sub Category</label>\r\n                                        <div class=\"controls\">\r\n                                            <select ng-model=\"Report.subcategory\" style=\"text-transform: capitalize;\" class=\"blackText\" ng-options=\"item as item.title for item in subcategories\"></select> &nbsp; &nbsp;<i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showsubCatLoading\"></i>\r\n                                        </div>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        <div>\r\n                            <button ng-click=\"getReport(Report)\" type=\"submit\" ng-disabled=\"ReportButton\" class=\"btn btn-success\" style=\"float: right;\">Get Report</button> &nbsp; &nbsp;<i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"ReportButton\"></i>\r\n                            <div style=\"clear: both;\"></div>\r\n                        </div>\r\n                    </fieldset>\r\n                    <div>\r\n                        <div style=\"width:9%; float: left; text-align: center;\" ng-if=\"TotalRecords.data.length > 0\">\r\n                            <span ng-click=\"showOrder()\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">Refine</span>\r\n                        </div>\r\n                        <div style=\"clear:both;\"></div>\r\n                        <div class=\"OrderList\">\r\n                            <div class=\"DisplayCat\" ng-if=\"ShowOrderList\">\r\n                                <!-- \r\n                                <div class=\"DivClass\">\r\n                                    <div class=\"leftClass\">\r\n                                        <input type=\"checkbox\" ng-model=\"search.order\" ng-true-value=\"\'Important\'\" ng-false-value=\"\'NO\'\">\r\n                                    </div>\r\n                                    <div class=\"rightClass\" ng-click=\"ShowImp(\'Importance\')\">Importance&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i></div>\r\n                                </div>\r\n                                <ul class=\"catList innerCat\" ng-if=\"Importance\">\r\n                                    <li>Select Important Level</li>\r\n                                    <li ng-repeat=\"user in [\'Somewhat\', \'Important\', \'Very Important\'] track by $index\">\r\n                                        <label class=\"checkbox\" title=\"search.importance\">\r\n                                            <input type=\"checkbox\" ng-model=\"search.importance\" ng-true-value=\"\'{{user}}\'\" ng-false-value=\"\'NO\'\"> {{user}}\r\n                                            <div ng-if=\"search.importance==\'Somewhat\' && user==\'Somewhat\'\">\r\n                                                Min :\r\n                                                <input type=\"number\" min=\"0\" max=\"90\" ng-model=\"search.importancesmin\" style=\"width:40px;\"> Max :\r\n                                                <input type=\"number\" min=\"10\" max=\"100\" ng-model=\"search.importancesmax\" style=\"width:40px;\">\r\n                                            </div>\r\n                                            <div ng-if=\"search.importance==\'Important\' && user==\'Important\'\">\r\n                                                Min :\r\n                                                <input type=\"number\" min=\"0\" max=\"90\" ng-model=\"search.importanceimin\" style=\"width:40px;\"> Max :\r\n                                                <input type=\"number\" min=\"10\" max=\"100\" ng-model=\"search.importanceimax\" style=\"width:40px;\">\r\n                                            </div>\r\n                                            <div ng-if=\"search.importance==\'Very Important\' && user==\'Very Important\'\">\r\n                                                Min :\r\n                                                <input type=\"number\" min=\"0\" max=\"90\" ng-model=\"search.importancevmin\" style=\"width:40px;\"> Max :\r\n                                                <input type=\"number\" min=\"10\" max=\"100\" ng-model=\"search.importancevmax\" style=\"width:40px;\">\r\n                                            </div>\r\n                                        </label>\r\n                                    </li>\r\n                                </ul> -->\r\n                                <div class=\"DivClass\">\r\n                                    <div class=\"rightClass\">Agree&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i></div>\r\n                                </div>\r\n                                <ul class=\"catList innerCat\">\r\n                                    <li>Select Level</li>\r\n                                    <li ng-repeat=\"user in [\'Very strongly agree\', \'Agree\', \'Sort of agree\', \'Sort of disagree\', \'Disagree\', \'Very strongly disagree\'] track by $index\">\r\n                                        <label class=\"checkbox\" title=\"search.agree\">\r\n                                            <input type=\"checkbox\" ng-model=\"search.agree\" ng-true-value=\"\'{{user}}\'\" ng-false-value=\"\'NO\'\"> {{user}}\r\n                                            <div ng-if=\"search.agree==\'Very strongly agree\' && user==\'Very strongly agree\'\" class=\"link\">\r\n                                                Min :\r\n                                                <input type=\"number\" min=\"0\" max=\"90\" ng-model=\"search.strongagreemin\" style=\"width:40px;\" class=\"link\"> Max :\r\n                                                <input type=\"number\" min=\"10\" max=\"100\" ng-model=\"search.strongagreemax\" style=\"width:40px;\" >\r\n                                            </div>\r\n                                            <div ng-if=\"search.agree==\'Agree\' && user==\'Agree\'\">\r\n                                                Min :\r\n                                                <input type=\"number\" min=\"0\" max=\"90\" ng-model=\"search.agreemin\" style=\"width:40px;\" class=\"link\"> Max :\r\n                                                <input type=\"number\" min=\"10\" max=\"100\" ng-model=\"search.agreemax\" style=\"width:40px;\">\r\n                                            </div>\r\n                                            <div ng-if=\"search.agree==\'Sort of agree\' && user==\'Sort of agree\'\"class=\"link\">\r\n                                                Min :\r\n                                                <input type=\"number\" min=\"0\" max=\"90\" ng-model=\"search.sortagreemin\" style=\"width:40px;\"class=\"link\"> Max :\r\n                                                <input type=\"number\" min=\"10\" max=\"100\" ng-model=\"search.sortagreemax\" style=\"width:40px;\">\r\n                                            </div>\r\n                                            <div ng-if=\"search.agree==\'Sort of disagree\' && user==\'Sort of disagree\'\"class=\"link\">\r\n                                                Min :\r\n                                                <input type=\"number\" min=\"0\" max=\"90\" ng-model=\"search.sortdisagreemin\" style=\"width:40px;\"class=\"link\"> Max :\r\n                                                <input type=\"number\" min=\"10\" max=\"100\" ng-model=\"search.sortdisagreemax\" style=\"width:40px;\">\r\n                                            </div>\r\n                                            <div ng-if=\"search.agree==\'Disagree\' && user==\'Disagree\'\"class=\"link\">\r\n                                                Min :\r\n                                                <input type=\"number\" min=\"0\" max=\"90\" ng-model=\"search.disagreemin\" style=\"width:40px;\"class=\"link\"> Max :\r\n                                                <input type=\"number\" min=\"10\" max=\"100\" ng-model=\"search.disagreemax\" style=\"width:40px;\">\r\n                                            </div>\r\n                                            <div ng-if=\"search.agree==\'Very strongly disagree\' && user==\'Very strongly disagree\'\"class=\"link\">\r\n                                                Min :\r\n                                                <input type=\"number\" min=\"0\" max=\"90\" ng-model=\"search.strongdisagreemin\" style=\"width:40px;\"class=\"link\"> Max :\r\n                                                <input type=\"number\" min=\"10\" max=\"100\" ng-model=\"search.strongdisagreemax\" style=\"width:40px;\">\r\n                                            </div>\r\n                                        </label>\r\n                                    </li>\r\n                                </ul>\r\n                            </div>\r\n                            <div style=\"clear:both;\"></div>\r\n                        </div>\r\n                        <div style=\"clear:both;\"></div>\r\n                    </div>\r\n                    <table class=\"w100 blackText\" ng-if=\"TotalRecords.data.length > 0\">\r\n                        <tr>\r\n                            <th>Question</th>\r\n                        </tr>\r\n                        <tr ng-repeat=\"u in TotalRecords.data | filter:filterFn\">\r\n                            <td>\r\n                            <div>\r\n                                <strong>Questions:</strong> {{u.content}}\r\n\r\n                            </div>\r\n                            <div style=\"padding-top:20px;\">\r\n                                <a href=\"javascript: void(0)\" ng-if=\"u.commentsCount > 0\" ng-click=\"DisplayAComments(u)\" style=\"text-decoration:underline;\"class=\"link\">Comments</a><br>\r\n                                <center><strong>Total Answers:</strong> {{u.total_answers}}</center>\r\n                            </div>\r\n                            <div style=\"padding-top:20px;\">\r\n                                <div class=\"leftChart\">\r\n                                    <canvas id=\"bar\" class=\"chart chart-bar\" chart-data=\"[u.somewhatAvg, u.improtantAvg, u.veryImprotantAvg]\" chart-labels=\"[\'Somewhat\', \'Important\', \'Very Important\']\" chart-colors=\"[\'#46BFBD\', \'#FDB45C\', \'#FA0019\']\" chart-options=\"{scales: { yAxes: [{ stacked: true, ticks: { min: 0, max: 100, stepSize: 20, } }]}}\"></canvas>\r\n                                </div>\r\n                                <div class=\"rightChart\">\r\n                                    <canvas id=\"bar\" class=\"chart chart-bar\" chart-data=\"[u.strongDisagreeAvg, u.DisagreeAvg, u.sortDisagreeAvg, u.sortAgreeAvg, u.AgreeAvg, u.strongAgreeAvg]\" chart-labels=\"[\'Very strongly disagree\', \'Disagree\', \'Sort of disagree\', \'Sort of agree\', \'Agree\', \'Very strongly agree\']\" chart-colors=\"[\'#990000\', \'#cc3300\', \'#ff9933\', \'#ffff00\', \'#99cc00\', \'#009900\']\" chart-options=\"{scales: { yAxes: [{ stacked: true, ticks: { min: 0, max: 100, stepSize: 20, } }]}}\"></canvas>\r\n                                </div>\r\n                                <div style=\"clear:both;\"></div>\r\n                            </div>\r\n                            </td>\r\n                        </tr>\r\n                        <!-- <tr>\r\n                            <td style=\"padding:0px;\">\r\n                                <div style=\"width: 80%; text-align: center; float:left; font-weight:bold;\">Total</div>\r\n                                <div style=\"width: 19%; text-align: center; float:left; border-left: solid 1px;\">{{TotalRecords.data.length}}</div>\r\n                            </td>\r\n                            <td></td>\r\n                            <td>\r\n                                {{items.total}}\r\n                            </td>\r\n                        </tr> -->\r\n                    </table>\r\n\r\n\r\n                </div>\r\n                <!-- Answered Questions End -->\r\n                <!-- Area wise Questions -->\r\n                <div ng-if=\"showArea\">\r\n                    <h2><center>Area wise Questions</center></h2>\r\n                    <fieldset class=\"scheduler-border\">\r\n                        <legend class=\"scheduler-border\">Select Options</legend>\r\n                        <div class=\"row\">\r\n                            <div class=\"col-md-12\">\r\n                                <div>\r\n                                    <div class=\"control-group\">\r\n                                        <label class=\"control-label\" for=\"profile-name\">State</label>\r\n                                        <div class=\"controls\">\r\n                                            <select ng-model=\"Report.state\" ng-change=\"getCounty()\" style=\"text-transform: capitalize;\" ng-options=\"item as item.state for item in states\"></select> &nbsp; &nbsp;<i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showStateLoading\"></i>\r\n                                        </div>\r\n                                    </div>\r\n                                    <div class=\"control-group\" ng-if=\"Report.state\">\r\n                                        <label class=\"control-label\" for=\"profile-name\">County</label>\r\n                                        <div class=\"controls\">\r\n                                            <select ng-model=\"Report.county\" ng-change=\"getPlaces()\" style=\"text-transform: capitalize;\" ng-options=\"item as item._id.county for item in counties\"></select> &nbsp; &nbsp;<i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showCountyLoading\"></i>\r\n                                        </div>\r\n                                    </div>\r\n                                    <div class=\"control-group\" ng-if=\"Report.county\">\r\n                                        <label class=\"control-label\" for=\"profile-name\">Place</label>\r\n                                        <div class=\"controls\">\r\n                                            <select ng-model=\"Report.place\" style=\"text-transform: capitalize;\" ng-options=\"item as item._id.countySubdivision+\'-\'+item._id.place for item in subcounties\"></select>\r\n                                        </div>\r\n                                    </div>\r\n                                    <div class=\"control-group\">\r\n                                        <label class=\"control-label\" for=\"profile-name\">Category</label>\r\n                                        <div class=\"controls\">\r\n                                            <select ng-model=\"Report.category\" ng-change=\"getSubcat()\" style=\"text-transform: capitalize;\" ng-options=\"item as item.title for item in categories\"></select> &nbsp; &nbsp;<i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showCatLoading\"></i>\r\n                                        </div>\r\n                                    </div>\r\n                                    <div class=\"control-group\" ng-if=\"Report.category!=\'\'\">\r\n                                        <label class=\"control-label\" for=\"profile-name\">Sub Category</label>\r\n                                        <div class=\"controls\">\r\n                                            <select ng-model=\"Report.subcategory\" style=\"text-transform: capitalize;\" ng-options=\"item as item.title for item in subcategories\"></select> &nbsp; &nbsp;<i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showsubCatLoading\"></i>\r\n                                        </div>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        <div>\r\n                            <button ng-click=\"resetRecord()\" type=\"button\" class=\"btn btn-success\" style=\"float: right;\">Reset</button> &nbsp; &nbsp;\r\n                            <button ng-click=\"getAreaReport(Report)\" type=\"submit\" ng-disabled=\"ReportButton\" class=\"btn btn-success\" style=\"float: right;\">Get Report</button> &nbsp; &nbsp;<i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"ReportButton\"></i>\r\n                            <div style=\"clear: both;\"></div>\r\n                        </div>\r\n                        <!-- <div>\r\n                            --------OR--------\r\n                        </div>\r\n                        <div>\r\n                            <button ng-click=\"getUserReport()\" type=\"submit\" ng-disabled=\"ReportButton\" class=\"btn btn-success\" style=\"float: center;\">Get All Users Data</button>\r\n                            <div style=\"clear: both;\"></div>\r\n                        </div> -->\r\n                    </fieldset>\r\n                    <p ng-if=\"TotalRecords.data.length==0 && showError\">There are no records for selected options.</p>\r\n                    <div infinite-scroll=\'myPagingFunction()\' ng-if=\"TotalRecords.data.length > 0\">\r\n                        <div><span ng-if=\"page<totalPages\">This may take several minutes depending on number of records. Please wait till it finish. </span> <span ng-if=\"page==totalPages\">We are showing those records which answered atleast one question.</span></div>\r\n                        <table class=\"w100 blackText\" ng-if=\"TotalRecords.data.length > 0 && Report.category\" ng-init=\"items.total = 0\">\r\n                            <tr>\r\n                                <th style=\"width:90%\" class=\"blackText\">Question</th>\r\n                                <th style=\"width:10%\" class=\"blackText\">Total Answers</th>\r\n                            </tr>\r\n                            <tr ng-repeat=\"u in TotalRecords.data\">\r\n                                <td class=\"blackText\">\r\n                                    {{u.content}}\r\n                                </td>\r\n                                <td ng-init=\"items.total = items.total + u.total_answers\" class=\"blackText\">\r\n                                    {{u.total_answers}}\r\n                                </td>\r\n                            </tr>\r\n                            <tr>\r\n                                <td style=\"padding:0px;\" class=\"blackText\">\r\n                                    <div style=\"width: 80%; text-align: center; float:left; font-weight:bold;\">Total</div>\r\n                                    <div style=\"width: 19%; text-align: center; float:left; border-left: solid 1px;\">{{TotalRecords.data.length}}</div>\r\n                                </td>\r\n                                <td>\r\n                                    {{items.total}}\r\n                                </td>\r\n                            </tr>\r\n                        </table>\r\n                        <table class=\"w100 blackText\" ng-if=\"TotalRecords.data.length > 0 && !Report.category\" ng-init=\"items.total = 0\">\r\n                            <tr>\r\n                                <th style=\"width:90%\">User</th>\r\n                                <th style=\"width:10%\">Total Answers</th>\r\n                            </tr>\r\n                            <tr ng-repeat=\"u in TotalRecords.data\">\r\n                                <td>\r\n                                    <p ng-if=\"u.name\" style=\"margin: 0;\"><strong>Name:</strong> <a href=\"#!/publicProfile/{{u._id}}\">{{u.name}}</a></p>\r\n                                    <p ng-if=\"u.username\" style=\"margin: 0;\"><strong>UserName:</strong> <a href=\"#!/publicProfile/{{u._id}}\">{{u.username}}</a></p>\r\n                                    <p ng-if=\"u.public_email\" style=\"margin: 0;\"><strong>Email:</strong> {{u.public_email}}</p>\r\n                                    <p ng-if=\"u.mailing_address\" style=\"margin: 0;\"><strong>Address:</strong> {{u.mailing_address}} </p>\r\n                                </td>\r\n                                <td ng-init=\"items.total = items.total + u.total_answers\">\r\n                                    {{u.total_answers}}\r\n                                </td>\r\n                            </tr>\r\n                            <tr>\r\n                                <td style=\"padding:0px;\">\r\n                                    <div style=\"width: 80%; text-align: center; float:left; font-weight:bold;\">Total</div>\r\n                                    <div style=\"width: 19%; text-align: center; float:left; border-left: solid 1px;\">{{TotalRecords.data.length}}</div>\r\n                                </td>\r\n                                <td>\r\n                                    {{items.total}}\r\n                                </td>\r\n                            </tr>\r\n                        </table>\r\n                    </div>\r\n                </div>\r\n                <!-- Area wise Questions End -->\r\n                <!-- Comments Questions -->\r\n                <div ng-if=\"showComments\">\r\n                    <h2><center>Comments</center></h2>\r\n                    <div ng-if=\"ShowCommentsSection==1\">\r\n                        <fieldset class=\"scheduler-border\">\r\n                            <legend class=\"scheduler-border\">Select Category</legend>\r\n                            <div class=\"row\">\r\n                                <div class=\"col-md-12\">\r\n                                    <div>\r\n                                        <div class=\"control-group\">\r\n                                            <label class=\"control-label\" for=\"profile-name\">Category</label>\r\n                                            <div class=\"controls\">\r\n                                                <select ng-model=\"Report.category\" ng-change=\"getSubcat()\" style=\"text-transform: capitalize;\" class=\"blackText\" ng-options=\"item as item.title for item in categories\"></select> &nbsp; &nbsp;<i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showCatLoading\"></i>\r\n                                            </div>\r\n                                        </div>\r\n                                        <div class=\"control-group\" ng-if=\"Report.category!=\'\'\">\r\n                                            <label class=\"control-label\" for=\"profile-name\">Sub Category</label>\r\n                                            <div class=\"controls\">\r\n                                                <select ng-model=\"Report.subcategory\" style=\"text-transform: capitalize;\" class=\"blackText\" ng-options=\"item as item.title for item in subcategories\"></select> &nbsp; &nbsp;<i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showsubCatLoading\"></i>\r\n                                            </div>\r\n                                        </div>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                            <div>\r\n                                <button ng-click=\"getCommentsReport(Report)\" type=\"submit\" ng-disabled=\"ReportButton\" class=\"btn btn-success\" style=\"float: right;\">Get Report</button> &nbsp; &nbsp;<i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"ReportButton\"></i>\r\n                                <div style=\"clear: both;\"></div>\r\n                            </div>\r\n                        </fieldset>\r\n                        <table class=\"w100 blackText\" ng-if=\"TotalRecords.data.length > 0\" ng-init=\"items.total = 0\">\r\n                            <tr>\r\n                                <th style=\"width:80%\">Question</th>\r\n                                <th style=\"width:10%\">Total Answers</th>\r\n                                <th style=\"width:10%\">Total Comments</th>\r\n                            </tr>\r\n                            <tr ng-repeat=\"u in TotalRecords.data\">\r\n                                <td>\r\n                                    {{u.content}}\r\n                                </td>\r\n                                <td ng-init=\"items.total = items.total + u.total_answers\">\r\n                                    {{u.total_answers}}\r\n                                </td>\r\n                                <td>\r\n                                    {{u.total_comments}} (<a href=\"javascript: void(0)\" ng-click=\"DisplayComments(u)\" style=\"text-decoration:underline;\" class=\"link\">Comments</a>)\r\n                                </td>\r\n                            </tr>\r\n                        </table>\r\n                    </div>\r\n                    <div ng-if=\"ShowCommentsSection==2\" class=\"blackText\">\r\n                        <p>\r\n                             <a href=\"javascript: void(0)\" ng-click=\"gotoBack(1)\" style=\"text-decoration:underline;\">Back</a>\r\n                        </p>\r\n                        <h1><center>All Comments</center></h1>\r\n                        <p>Question:\r\n                            <br/> {{CommentQuestion.content}}\r\n                        </p>\r\n                        <p>Comments</p>\r\n                        <table class=\"w100 blackText\" ng-if=\"AllComments.length > 0\">\r\n                            <tr>\r\n                                <th style=\"width:80%\">Comments</th>\r\n                                <th style=\"width:20%\">User</th>\r\n                            </tr>\r\n                            <tr ng-repeat=\"u in AllComments\">\r\n                                <td>\r\n                                    {{u.comment}}\r\n                                </td>\r\n                                <td>\r\n                                \r\n<!--  <<<<<<<< FOR THIS WE NEED TO HAVE A WAY OF NOT SHOWING THE NAMES OF PEOPLE WHO WANT TO REMAIN ANONNYMOUS\r\n                                   <a href=\"javascript: void(0)\" ng-click=\"gotoUserAnswers(u)\" style=\"text-decoration:underline;\">{{u.userData.name || u.userData.username}}</a> \r\n>>>>>>>>>  --> Hidden\r\n                                </td>\r\n                            </tr>\r\n                        </table>\r\n                        <p ng-if=\"AllComments.length==0 && !loading\">There are no comments added for this question.</p>\r\n                        <p ng-if=\"loading\"><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>Loading data please wait...</p>\r\n                    </div>\r\n                    <div ng-if=\"ShowCommentsSection==3\" class=\"blackText\">\r\n                        <p>\r\n                            <a href=\"javascript: void(0)\" ng-click=\"gotoBack(2)\" style=\"text-decoration:underline;\">Back</a>\r\n                        </p>\r\n                        <h1><center>Questions Answered by {{userData.name || userData.username}}</center></h1>\r\n                        <table class=\"w100 blackText\" ng-if=\"AllAnswers.length > 0\">\r\n                            <tr>\r\n                                <th style=\"width:80%\">Questions</th>\r\n                                <th style=\"width:20%\">Answer</th>\r\n                            </tr>\r\n                            <tr ng-repeat=\"u in AllAnswers\">\r\n                                <td>\r\n                                    {{u.question.content}}\r\n                                    <div ng-if=\"u.comment && u.comment !=\'\'\">\r\n                                        <strong>Comment:</strong>{{u.comment}}\r\n                                    </div>\r\n                                </td>\r\n                                <td>\r\n                                    {{u.answer}}\r\n                                </td>\r\n                            </tr>\r\n                        </table>\r\n                        <p ng-if=\"loading\"><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>Loading data please wait...</p>\r\n                    </div>\r\n                </div>\r\n                <!-- Comments Questions End -->\r\n                <!-- Live Users -->\r\n                <div ng-if=\"showliveUsers\" class=\"blackText\">\r\n                    <h2><center>Users active in last 24 hours</center></h2>\r\n\r\n                    <p ng-if=\"loadingExtra\"><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>Loading data please wait...</p>\r\n                    <div style=\"padding: 10px;\">\r\n\r\n                    <div>Voters : {{liveusersrecords.voters}}</div>\r\n                    <div>Politicians : {{liveusersrecords.politicians}}</div>\r\n                    <div>Advocates : {{liveusersrecords.advocates}}</div>\r\n                    <div>Press : {{liveusersrecords.press}}</div>\r\n                    <div>Voter Admins : {{liveusersrecords.voteradmins}}</div>\r\n                    <div>Forum Admins : {{liveusersrecords.forumadmins}}</div>\r\n                    </div>\r\n\r\n\r\n                </div>\r\n                <!-- Live Users End -->\r\n\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/representativeVideo/representativeVideo.html","\r\n<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">Politicians</h2>\r\n  <p class=\"pageSubHeading\">\r\n	  <a href=\"#!/signup/voter\" class=\"compareBtn\">	&nbsp;	&nbsp;Sign Up	&nbsp;	&nbsp;</a></p>\r\n 									<style>\r\n.iframe-container {\r\n  overflow: hidden;\r\n  padding-top: 56.25%;\r\n  position: relative;\r\n	top: -10%;\r\n}\r\n \r\n.iframe-container iframe {\r\n   border: 0;\r\n   height: 100%;\r\n   left: 0;\r\n   position: absolute;\r\n   top: 0;\r\n   width: 100%;\r\n	max-height: 400px;\r\n}\r\n											.fgtrh-container iframe{\r\n												left: 0;\r\n												top: 250px;\r\n												position:absolute;\r\n												height:50%;\r\n												width:50%;\r\n											}\r\n/* 4x3 Aspect Ratio */\r\n.iframe-container-4x3 {\r\n  padding-top: 75%;\r\n}</style>\r\n\r\n<div class=\"iframe-container\">\r\n  <iframe src=\"https://player.vimeo.com/video/408237898\" allowfullscreen></iframe>\r\n</div>\r\n");
$templateCache.put("app/research/research.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">RESEARCH</h2>\r\n  <p class=\"pageSubHeading\">Research the Topics, the Basics of Politics, Upcoming Legislation, and Election tools near you.</p>\r\n  <div class=\"row d-flex justify-content-center\">\r\n    <div class=\"col col-lg-9 col-med-12 col-sm-12 col-12 colPadding1\">\r\n      <div class=\"row\">\r\n        <div class=\"col-lg-12 col-sm-12 learnHeader\">\r\n           <img ng-src=\"./assets/images/learnTopics.svg\" class=\"blockInfoImgLearn img-fluid\">\r\n          <div id=\"blockInfoLearn1\">\r\n            <div>\r\n              <h4 class=\"blockTitleLearn\">LEARN ABOUT THE TOPICS</h4>\r\n              <span class=\"blockDesc\">Watch videos and read articles from our staff and organizations that specialize in these topics.</span>\r\n													<div class=\"centerediframe\">\r\n  <iframe src=\"https://player.vimeo.com/video/407428918?byline=false&title=false\" allowfullscreen ></iframe>\r\n</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"newUserLearn\">\r\n          <form class=\"ng-pristine ng-valid\">\r\n            <div>\r\n              <!-- <legend class=\"scheduler-border\">Learn about the Issues</legend> -->\r\n              <p class=\"fwb\" ng-if=\"statusGetEssayCat == 1\">Loading categories...</p>\r\n              <p class=\"fwb\" ng-if=\"statusGetEssayCat == 2 && categories.length <= 0\">No category available to select</p>\r\n              <a ng-repeat=\"item in categories | orderBy: \'order\'\" href=\"#!/essay/{{item._id}}/home\" title=\"{{item.title}}\" style=\"padding: 10px 0px;\">\r\n                <div class=\"allTopics\">\r\n                  <img src=\"{{imgUrl}}/{{item.iconImage}}\" alt=\"{{item.title}}\" />\r\n                  <span>{{item.title}}</span>\r\n                </div>\r\n              </a>\r\n            </div>\r\n          </form>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col col-lg-9 col-med-12 col-sm-12 col-12 colPadding2\">\r\n      <div class=\"row\">\r\n        <div class=\"col-lg-12 col-sm-12 learnHeader\">\r\n          <img ng-src=\"./assets/images/learnPolitics.svg\" class=\"blockInfoImgLearn img-fluid\">\r\n          <div id=\"blockInfoLearn2\">\r\n            <div>\r\n              <h4 class=\"blockTitleLearn\">LEARN ABOUT POLITICS</h4>\r\n              <span class=\"blockDesc\">Learn the basics of politics including how government works, how to register, where to vote and more.</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"newUserLearn\">\r\n          <form class=\"ng-pristine ng-valid\">\r\n            <div>\r\n              <div>\r\n                  <a href=\"#!/wheretovote\" class=\"allTopics\"> <img src=\"assets/images/where_to_vote.svg\" alt=\"How to Register and Where to Vote\"/><span>How to Register and Where to Vote</span></a>\r\n                  <a href=\"#!/basicsofpolitics\" class=\"allTopics\"> <img src=\"assets/images/basics_of_politics.svg\" alt=\"Basics of Politics\"/><span>Basics of Politics</span></a>\r\n                  <a href=\"#!/legislation\" class=\"allTopics\"> <img src=\"assets/images/followLegislation.svg\" alt=\"Upcoming Legislation\"/><span>Upcoming Legislation</span></a>\r\n                \r\n                  <a href=\"#!/politicalDictionary\" class=\"allTopics\"> <img src=\"assets/images/political_dictionary.svg\" alt=\"Politician to Voter Dictionary\"/><span>Politician to Voter Dictionary</span></a>\r\n                  <a href=\"#!/wheretogetnews\" class=\"allTopics\"> <img src=\"assets/images/where_to_get_news.svg\" alt=\"How to find news you can trust\"/><span>How to find news you can trust</span></a>\r\n              </div>\r\n            </div>\r\n          </form>\r\n        </div>\r\n      </div>\r\n      <div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n          <div class=\"col-lg-12 col-sm-12 gettingStartedContainer row\">\r\n        <a href=\"#!/incumbent_politician/politician\" class=\"blockLink\"><img ng-src=\"./assets/images/politiciansRBB7-01.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock5\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">POLITICIANS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Learn about the politicians in office and up for election in your area.  See their voting records and who funds their campaigns. Rate or endorse them. If you\'ve taken the Ideological Match quiz, you can see which ones would be best to team up with.\r\n          </p>\r\n            \r\n        </div>\r\n      </div></a>\r\n    </div>\r\n  </div>\r\n<!-- <p>\r\n  <h1><center>Learn</center></h1></p>\r\n<p><b>Explore.</b> Use this section to:\r\n  <ul>\r\n    <li>Watch videos and read essays from various organizations so you can learn about the issues from different perspectives.</li>\r\n    <li>Learn about politics in general including how to read through \"Political Speak\"</li>\r\n  </ul>\r\n</p>\r\n<div class=\"newUser\">\r\n  <form>\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Learn about Politics</legend>\r\n      <div>\r\n      <div class=\"allTopics\">\r\n      <a href=\"#!/wheretovote\"> <img src=\"assets/images/where_to_vote.svg\" alt=\"Where to vote\"/><span>Where to Vote</span></a>\r\n      </div>\r\n      <div class=\"allTopics\">\r\n      <a href=\"#!/wheretogetnews\"> <img src=\"assets/images/where_to_get_news.svg\" alt=\"Where to get news\"/><span>Where to Get News</span></a>\r\n      </div>\r\n      <div class=\"allTopics\">\r\n      <a href=\"#!/politicalDictionary\"> <img src=\"assets/images/political_dictionary.svg\" alt=\"Political Dictionary\"/><span>Political Dictionary</span></a>\r\n      </div>\r\n      <div class=\"allTopics\">\r\n      <a href=\"#!/basicsofpolitics\"> <img src=\"assets/images/basics_of_politics.svg\" alt=\"Basics of Politics\"/><span>Basics of Politics</span></a>\r\n      </div>\r\n      </div>\r\n    </fieldset>\r\n  </form>\r\n</div>\r\n<div class=\"newUser\">\r\n  <form>\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Learn about the Issues</legend>\r\n      <p class=\"fwb\" ng-if=\"statusGetEssayCat == 1\">Loading categories...</p>\r\n      <p class=\"fwb\" ng-if=\"statusGetEssayCat == 2 && categories.length <= 0\">No category available to select</p>\r\n      <a ng-repeat=\"item in categories | orderBy: \'order\'\" href=\"#!/essay/{{item._id}}/home\" title=\"{{item.title}}\" style=\"padding: 10px 0px;\">\r\n      <div class=\"allTopics\">\r\n   <img src=\"{{imgUrl}}/{{item.iconImage}}\" alt=\"{{item.title}}\"/>\r\n   <span>{{item.title}}</span>\r\n   </div> \r\n</a>\r\n    </fieldset>\r\n  </form>\r\n</div>\r\n -->\r\n");
$templateCache.put("app/resetPassword/resetPassword.html","<div class=\"voter-signup\">\r\n\r\n  <div class=\"signin-margin\">\r\n    <div class=\"alert alert-danger\" ng-show=\"Errors.length>0\" role=\"alert\" ng-repeat=\"error in Errors\">\r\n      {{error}}\r\n    </div>\r\n\r\n    <form name=\"forgotPassForm\" id=\"forgotPassForm\">\r\n      <fieldset class=\"scheduler-border\">\r\n        <legend class=\"scheduler-border\">Forgot Password</legend>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel removeTopMargin\" for=\"UserName\">Email</label>\r\n              <div class=\"controls\">\r\n                <input type=\"email\" ng-model=\"forgotEmail\" placeholder=\"\"\r\n                                    data-errormessage=\"Email is required.\" ng-blur=\"detectEmail()\" class=\"form-control input-md validate[required] text-input\">\r\n                            </div>\r\n              </div>\r\n              <div class=\"control-group\" ng-if=\"showDrop\">\r\n                <label class=\"control-label formLabel removeTopMargin\"  for=\"UserName\">Which User</label>\r\n                <div class=\"controls blackText\">\r\n                  <select class=\"changeTextColor form-control\" ng-model=\"User.uName\"   ng-options=\"item as item.name for item in dropData track by item.name\"></select>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div style=\"clear: both;\"></div>\r\n            <div class=\"forgetPassButtons\">\r\n              <button ng-click=\"requestPasswordReset()\" type=\"submit\" class=\"btn btn-success fullWidth\">OK</button>\r\n              <button ng-click=\"showPasswordReset = false;\" type=\"submit\" class=\"btn btn-success fullWidth\">Cancel</button>\r\n              <!-- <fb:login-button scope=\"public_profile,email\" onlogin=\"checkLoginState();\">\r\n              </fb:login-button> -->\r\n              <div style=\"clear: both;\"></div>\r\n            </div>\r\n            <div style=\"clear: both;\"></div>\r\n          </div>\r\n\r\n      </fieldset>\r\n    </form>\r\n\r\n  </div>\r\n</div>\r\n\r\n<script type=\"text/javascript\">\r\n  jQuery(document).ready(function () {\r\n    // binds form submission and fields to the validation engine\r\n    // binds form submission and fields to the validation engine\r\n    $(\"form\").validationEngine();\r\n  });\r\n\r\n</script>\r\n");
$templateCache.put("app/restorePoliticians/restorePoliticians.html","<div class=\"container-fluid ng-scope\" ng-cloak ng-show=\"$root.userRole==\'admin\'\">\r\n  <h2 class=\"pageHeading\">Settings</h2>\r\n  <div>\r\n    <div class=\"closeForm\" ng-include=\"\'app/popups/setting_Ctrl.html\'\"></div>\r\n  </div>\r\n  <!-- Restore politician start -->\r\n  <form ng-if=\"showRUpload\" name=\"Historyform\" id=\"Historyform\" ng-controller=\"RemovePoliticianCtrl\" class=\"closeForm\">\r\n    <div class=\"row\" style=\"margin-top: 10px;\">\r\n      <p>\r\n        <h3>Removed Politician</h3>\r\n      </p>\r\n      <div style=\"float:right;\">\r\n        <dir-pagination-controls max-size=\"5\" on-page-change=\"pageChanged(newPageNumber)\"></dir-pagination-controls>\r\n      </div>\r\n      <table class=\"w100 changeTextColor\">\r\n        <tr>\r\n          <th style=\"width:90%\">Politician</th>\r\n          <th style=\"width:10%\">Restore</th>\r\n        </tr>\r\n        <tr dir-paginate=\"u in politician.data | itemsPerPage :usersPerPage\" total-items=\"totalUsers\" current-page=\"pagination.current\">\r\n          <td>\r\n            <div>{{u.name}}</div>\r\n            <p>\r\n              <strong>Party:</strong> {{u.party}},\r\n              <strong>Office:</strong> {{u.office}},\r\n              <strong>Election Date:</strong> {{u.electionDate}}\r\n              <div>\r\n                <span ng-if=\"u.placeName\">\r\n                        <strong>Place:</strong> {{u.placeName}}, </span>\r\n                <span ng-if=\"u.countySubdivisionName\">\r\n                        <strong>countySubdivisionName:</strong>{{u.countySubdivisionName}}, </span>\r\n                <span ng-if=\"u.countyName\">\r\n                        <strong>countyName:</strong>{{u.countyName}}, </span>\r\n                <span ng-if=\"u.statePostalCode\">\r\n                        <strong>state:</strong>{{u.statePostalCode}}</span>\r\n              </div>\r\n            </p>\r\n          </td>\r\n          <td>\r\n            <a href=\"javascript: void(0)\" ng-click=\"restorePolitician(u, $index)\" class=\"link\">Restore</a>\r\n          </td>\r\n        </tr>\r\n        <tr ng-if=\"politician.data.length==0\">\r\n          <td colspan=\"3\">\r\n            <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoading\"></i>\r\n            <spam ng-if=\"!showLoading\">No records found.</spam>\r\n          </td>\r\n        </tr>\r\n      </table>\r\n      <div style=\"float:right;\">\r\n        <dir-pagination-controls max-size=\"5\" on-page-change=\"pageChanged(newPageNumber)\"></dir-pagination-controls>\r\n      </div>\r\n    </div>\r\n  </form>\r\n  <!-- Restore politician end -->\r\n  <!-- UI grid state start -->\r\n  <form ng-if=\"showHUpload\" name=\"Uploadform\" id=\"Uploadform\" ng-controller=\"GridStateCtrl\" class=\"closeForm\">\r\n    <div class=\"row\" style=\"margin-top: 10px;\">\r\n      <p>\r\n        <h3>Grid states user wise</h3>\r\n      </p>\r\n      <table class=\"w100 changeTextColor\">\r\n        <tr>\r\n          <th style=\"width:50%\">User</th>\r\n          <th style=\"width:40%\">Data</th>\r\n          <th style=\"width:10%\">Remove</th>\r\n        </tr>\r\n        <tr ng-repeat=\"u in users.data track by $index\">\r\n          <td>\r\n            <div>{{u.name}}</div>\r\n            <p>\r\n              <strong>username:</strong> {{u.username}},\r\n              <strong>email:</strong> {{u.email}}\r\n            </p>\r\n          </td>\r\n          <td>{{u.CountyName}}, {{u.StatePostalCode}}</td>\r\n          <td>\r\n            <a href=\"javascript: void(0)\" ng-click=\"removeGrid(u, $index)\" class=\"link\">Remove</a>\r\n          </td>\r\n        </tr>\r\n        <tr ng-if=\"users.data.length==0\">\r\n          <td colspan=\"3\">\r\n            <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoading\"></i>\r\n            <spam ng-if=\"!showLoading\">No records found.</spam>\r\n          </td>\r\n        </tr>\r\n      </table>\r\n    </div>\r\n  </form>\r\n  <!-- UI grid state end -->\r\n</div>\r\n");
$templateCache.put("app/sendEmail/sendEmail.html","<div class=\"container-fluid ng-scope\" ng-cloak ng-show=\"$root.userRole==\'admin\'\">\r\n  <h2 class=\"pageHeading\">Settings</h2>\r\n  <div>\r\n    <div class=\"closeForm\" ng-include=\"\'app/popups/setting_Ctrl.html\'\"></div>\r\n  </div>\r\n  <!-- Send Email Start -->\r\n  <form ng-if=\"$root.showAllEmail\" name=\"showAllEmail\" id=\"showAllEmail\" ng-controller=\"AllEmailCtrl\" class=\"closeForm\">\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Send Email</legend>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel removeTopMargin\" for=\"Email.userType\">User Type</label>\r\n            <div class=\"controls\">\r\n              <select ng-model=\"Email.userType\" style=\"text-transform: capitalize;\" ng-options=\"item as item for item in usersType\" class=\"changeTextColor\"></select>\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\" ng-if=\"Email.userType == \'Politicians\'\">\r\n            <label class=\"control-label formLabel removeTopMargin\" for=\"Email.officeType\">Office</label>\r\n            <div class=\"controls\">\r\n              <select ng-model=\"Email.officeType\" style=\"text-transform: capitalize;\" ng-options=\"item as item for item in allOfficeType\" class=\"changeTextColor\"></select>\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\" ng-if=\"Email.userType==\'Custom\'\">\r\n            <label class=\"control-label formLabel\" for=\"Email.toField\">To (Comma Separated if multiple recipients)</label>\r\n            <div class=\"controls\">\r\n              <textarea ng-model=\"Email.toField\" style=\"width: 70%;color:black\"></textarea>\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"Email.subject\">Subject</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"Email.subject\" class=\"form-control input-md text-input\">\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"Email.message\">Message</label>\r\n            <div class=\"controls\">\r\n              <textarea ui-tinymce=\"tinymceOptions\" ng-model=\"Email.message\" style=\"height:250px;\"></textarea>\r\n              <!-- <input type=\"text\"  class=\"form-control input-md text-input\"> -->\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div style=\"clear: both;\"></div>\r\n      </div>\r\n      <div style=\"width: 55%; margin-top: 10px; float: right; margin-right: 17px;\">\r\n        <button ng-click=\"SendMail($event);\" ng-disabled=\"DisableEmail\" type=\"submit\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n        <!--<fb:login-button scope=\"public_profile,email\" onlogin=\"checkLoginState();\">\r\n                                </fb:login-button>-->\r\n        <div style=\"clear: both;\"></div>\r\n      </div>\r\n      <div style=\"clear: both;\"></div>\r\n    </fieldset>\r\n  </form>\r\n  <!-- Send Email End -->\r\n</div>\r\n");
$templateCache.put("app/sendInvitations/sendInvitations.html","<div class=\"container-fluid\">\r\n  <h2>Select State</h2>\r\n  <div class=\"control-group\">\r\n    <label class=\"control-label\" for=\"email\">State </label>\r\n    <div class=\"controls\">\r\n      <select\r\n        class=\"changeTextColor\"\r\n        ng-model=\"address.state\"\r\n        style=\"text-transform: capitalize\"\r\n        ng-change=\"getElectionDates()\"\r\n        ng-options=\"item.state for item in allState track by item.state\"\r\n      ></select\r\n      >&nbsp;\r\n      <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loader\"></i>\r\n    </div>\r\n  </div>\r\n  <div ng-if=\"electionDates.length > 0\">\r\n    <label for=\"electionDate\"\r\n      ><h4><b>Election Date</b></h4>\r\n    </label>\r\n    <select\r\n      ng-model=\"address.eDate\"\r\n      ng-options=\"item  for item in electionDates\"\r\n      class=\"changeTextColor form-control\"\r\n      style=\"width: 30%\"\r\n    ></select>\r\n    <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"Showloader\"></i>\r\n  </div>\r\n  <br />\r\n  <br />\r\n  <button\r\n    ng-click=\"sendInvitations()\"\r\n    type=\"button\"\r\n    class=\"btn btn-success\"\r\n    ng-disabled=\"TopicButton\"\r\n    style=\"float: left\"\r\n  >\r\n    Send Invitations\r\n  </button>\r\n</div>\r\n");
$templateCache.put("app/showAllUsersMatch/showAllUsersMatch.html","<div>\r\n  <!-- <button ng-click=\"$root.printPage()\" class=\"print-hide changeTextColor\">Print this page</button> -->\r\n  <!--  <div>{{questions}}</div>\r\n  <div>{{questions[currentIndex]}}</div> -->\r\n\r\n\r\n  <center>\r\n    <div ng-if=\"loaders\" style=\"z-index: 2; background:black; margin-left: 3%;\">\r\n      <i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span>\r\n    </div>\r\n\r\n\r\n  </center>\r\n\r\n  <div id=\"DisplayQ\" name=\"DisplayQ\" style=\"overflow: hidden;\">\r\n\r\n    <div ng-show=\" questions[currentIndex] && !showComment && !unComment &&\r\n    !showPoliAnswerDetails && !showUserAnswerDetails && !showCurr\">\r\n      <!-- <type=\"button\" value=\"LEARN MORE\"> -->\r\n      <h6 ng-if=\"inviterName && inviterId\" style=\"padding: 5% 0% 0% 10%;\">Invited By\r\n        <a ng-if=\"inviterData.userType == \'politician\'\" href=\"#!/publicProfile/{{inviterId}}\" class=\"ylink\" style=\"text-transform: capitalize;\"><img ng-src=\"../assets/images/profile/politician.svg\" alt=\"Politician\"  class=\"usertype\">{{inviterData.nameOnBallot}}</a>\r\n        <a ng-if=\"inviterData.userType == \'voter\'\" href=\"#!/voterProfile/{{inviterId}}\" class=\"ylink\" style=\"text-transform: capitalize;\"><img ng-src=\"../assets/images/profile/voter.svg \" alt=\"Voter\" class=\"usertype \">{{inviterData.username}}</a>\r\n        <a ng-if=\"inviterData.userType == \'advocate\' || inviterData.userType ==\'\' || !inviterData.userType\"  href=\"#!/pressProfile/{{inviterId}}\" class=\"ylink\" style=\"text-transform: capitalize;\"><img ng-src=\"../assets/images/profile/advocate.svg\" class=\"usertype\" alt=\"Advocate\">{{inviterData.title}}</a>\r\n      </h6>\r\n      <p></p>\r\n\r\n      <center>\r\n        <h2>QUESTION</h2>\r\n      </center>\r\n      <p></p>\r\n      <p></p>\r\n      <center>({{currentIndex+1}} of {{questions.length}})</center>\r\n      <p></p>\r\n      <p>STATEMENT: <span class=\"card-text\" ng-bind-html=\"questions[currentIndex].content | newlines\"></span></p>\r\n      Your Answers<span style=\"margin-left: 30px;\">Their Answers</span>\r\n\r\n      <div class=\"clearfix scro\">\r\n        <div class=\"pull-left ans-col\" style=\"border-right: 3px solid #de8998;\">\r\n          <div class=\"clearfix  pad10\">\r\n          </div>\r\n          <p></p>\r\n          <div class=\"pad10\">\r\n            <div class=\"clearfix\"><br>\r\n              <p>COMMENTS</p>\r\n              <div class=\"mb5 clearfix\">\r\n                <div class=\"inl-blk pull-right\">\r\n                  <span class=\"clk ylink\" ng-if=\"!(questions[currentIndex].my_answer.comment | isBlankString)\" ng-click=\"viewAnsComment(\'currentUser\')\"><a href=\"\" title=\"Click to see their comments.\">YOUR COMMENTS</a></span>\r\n                  <span ng-if=\"questions[currentIndex].my_answer.comment | isBlankString\">None</span>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <p></p>\r\n            <!-- check {{questions[currentIndex]}} -->\r\n            <div class=\"clearfix\" style=\"line-height: 9px\">\r\n              <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <span class=\"inl-blk\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n                <span class=\"inl-blk\" ng-if=\"i == 6\">DISAGREE</span>\r\n                <div class=\"cq-box inl-blk pull-right\"\r\n                  ng-class=\"(questions[currentIndex].my_answer.answer == i) ? (\'ag-green\') : \'\'\"></div>\r\n              </div>\r\n            </div>\r\n            <div class=\"clearfix\">\r\n              <div class=\"mb5 clearfix\"><br>\r\n                <div class=\"inl-blk pull-right\">Match to Mean</div>\r\n              </div>\r\n            </div><br>\r\n            <div class=\"clearfix\" style=\"line-height: 9px\">\r\n              <p>IMPORTANCE</p>\r\n              <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n                <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n                <div class=\"cq-box inl-blk pull-right \"\r\n                  ng-class=\"(questions[currentIndex].my_answer.importance == i) ? \'ag-dg\' : \'\'\"></div>\r\n              </div>\r\n            </div>\r\n\r\n          </div>\r\n\r\n        </div>\r\n\r\n        <div class=\"pull-left ans-col\" ng-if=\"emailRegistered\">\r\n          <div class=\"clearfix pad10\">\r\n            <div class=\"nslant-txt\" ng-if=\"!userId\">\r\n              <a href=\"\" title=\"These are all the registered users who answered this question.  Click to see their annonymous individual answers.\">Email Confirmed Users</a>\r\n            </div>\r\n            <div class=\"nslant-txt clk ylink\" ng-if=\"userId && !inviterData\" ng-click=\"showAnswersDetail(\'politician\')\">\r\n              <a href=\"\" title=\"These are all the politicians in your area who answered this question.  Click to see their individual answers.\">Your Politicians</a>\r\n            </div>\r\n            <div class=\"nslant-txt clk ylink\"\r\n              ng-if=\"userId && inviterData && inviterData.nameOnBallot && !showGrpFollow\"\r\n              ng-click=\"showAnswersDetail(\'politician\')\">\r\n              <a href=\"\" title=\"This is the person or organization that invited you to take the quiz.\" style=\"text-transform: capitalize;\">{{inviterData.nameOnBallot}}</a>\r\n            </div>\r\n            <div class=\"nslant-txt clk ylink\" ng-if=\"userId && showGrpFollow\"\r\n              ng-click=\"showAnswersDetail(\'politician\')\">\r\n              <a href=\"\" title=\"These are the followers who took this quiz.  Click to see their individual answers.\">Your Followers</a>\r\n            </div>\r\n          </div>\r\n          <p></p>\r\n          <br>\r\n          <div class=\"pad10\">\r\n            <div class=\"clearfix\">\r\n              <p>&nbsp;</p>\r\n              <div class=\"mb5 clearfix\">\r\n                <span class=\"clk ylink\" ng-if=\"globalFlag[questions[currentIndex]._id]\" ng-click=\"viewAnsComment(\'email\')\"><a href=\"\" title=\"Click to see their comments.\">READ COMMENTS</a></span>\r\n                <span ng-if=\"ans.comment && (ans.comment | isBlankString)\">None</span>\r\n                <span ng-if=\"!globalFlag[questions[currentIndex]._id]\">N/A</span>\r\n              </div>\r\n            </div>\r\n            <p></p>\r\n            <div ng-if=\"userId\" class=\"clearfix\" style=\"height: 120px;\">\r\n              <div ng-repeat=\"i in [1,2,3,4,5,6] track by $index\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n\r\n\r\n                <span ng-if=\"ansCount[questions[currentIndex]._id][i]\" data-tooltip=\"tooltip\" class=\"has-tip\"  title=\"Click here to see everyone who answered this way\">\r\n                      <canvas class=\"clk\"\r\n                      ng-click=\"showAnswers(i,\'politician\',questions[currentIndex]._id,ansCount[questions[currentIndex]._id],$index)\"\r\n                      ng-style=\"changeColor(ansCount[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                      width=\"100\" height=\"10\" id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                    </canvas>\r\n                  </span>\r\n\r\n                <span ng-if=\"!ansCount[questions[currentIndex]._id][i]\" data-tooltip=\"tooltip\" class=\"has-tip\"  title=\"No users to see here\">\r\n                <canvas class=\"clk\"\r\n                  ng-click=\"showAnswers(i,\'politician\',questions[currentIndex]._id,ansCount[questions[currentIndex]._id],$index)\"\r\n                  ng-style=\"changeColor(ansCount[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                  width=\"100\" height=\"10\" id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                </canvas>\r\n</span>\r\n\r\n\r\n\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                      <b>N/A</b>\r\n                    </span>\r\n              </div>\r\n            </div>\r\n            <div ng-if=\"!userId\" class=\"clearfix\" style=\"height: 120px;\">\r\n              <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <canvas class=\"clk\" id=\"myCanvas\"\r\n                  ng-style=\"changeColor(ansCount[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                  width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                </canvas>\r\n                <!-- <div class=\"cq-box inl-blk pull-left\"></div> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span ng-if=\"ansCount[questions[currentIndex]._id][i]\">{{ansCount[questions[currentIndex]._id][i]}}%</span><span ng-if=\"!ansCount[questions[currentIndex]._id][i]\">0%</span> -->\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"clearfix\" style=\"height: 32px;\">\r\n              <div class=\"mb5 clearfix\"><br>\r\n                <div class=\"inl-blk pull-left\">{{emailRegistered[questions[currentIndex]._id]}}%</div>\r\n                <div ng-if=\"!emailRegistered[questions[currentIndex]._id]\" class=\"w100 text-center fwb\">N/A</div>\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div><br>\r\n            <div class=\"clearfix\" style=\"height: 111px;\">\r\n              <p>&nbsp;</p>\r\n              <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <canvas id=\"myCanvas\" width=\"100\" height=\"10\"\r\n                  style=\"border:1px solid #141212;\r\n              background: linear-gradient(to right, #e0dbdb {{impCount[questions[currentIndex]._id][i]}}%, #2b4f7f 10%);\">\r\n                </canvas>\r\n                <!-- <div class=\"cq-box inl-blk pull-left\" style=\"background: linear-gradient(to right, #141212 {{impCount[questions[currentIndex]._id][i]}}%, #2b4f7f 10%);\"></div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span ng-if=\"impCount[questions[currentIndex]._id][i]\">{{impCount[questions[currentIndex]._id][i]}}%</span><span ng-if=\"!impCount[questions[currentIndex]._id][i]\">0%</span> -->\r\n              </div>\r\n              <div ng-if=\"importance\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n              <!-- <div class=\"inl-blk pull-left\">{{emailImpo[questions[currentIndex]._id]}}%</div>\r\n            <div ng-if=\"!emailImpo[questions[currentIndex]._id]\" class=\"w100 text-center fwb\">N/A</div> -->\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n\r\n\r\n        <div class=\"pull-left ans-col\" ng-if=\"voter && userId\">\r\n          \r\n          <div class=\"clearfix  pad10\">\r\n            <div class=\"nslant-txt clk ylink\" ng-if=\"userId\" ng-click=\"showAnswersDetail(\'voter\')\">\r\n              <a href=\"\" title=\"These are all the registered users who answered this question.  Click to see their annonymous individual answers.\">Email Confirmed Voters</a>\r\n            </div>\r\n\r\n          </div>\r\n          <p></p>\r\n          <br>\r\n          <div class=\"pad10\">\r\n            <div class=\"clearfix\">\r\n              <p>&nbsp;</p>\r\n              <div class=\"mb5 clearfix\">\r\n                <span class=\"clk ylink\" ng-if=\"flagOfVoter[questions[currentIndex]._id]\" ng-click=\"viewAnsComment(\'voter\')\"><a href=\"\" title=\"Click to see their comments.\">READ COMMENTS</a></span>\r\n                <span ng-if=\"ans.comment && (ans.comment | isBlankString)\">None</span>\r\n                <span ng-if=\"!flagOfVoter[questions[currentIndex]._id]\">N/A</span>\r\n              </div>\r\n            </div>\r\n            <p></p>\r\n            <div class=\"clearfix\" style=\"height: 120px;\">\r\n              <div ng-repeat=\"i in [1,2,3,4,5,6] track by $index\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <span ng-if=\"voterAnsCount[questions[currentIndex]._id][i]\" data-tooltip=\"tooltip\" class=\"has-tip\"  title=\"Click here to see everyone who answered this way\">\r\n                <canvas class=\"clk\"\r\n                  ng-style=\"changeColor(voterAnsCount[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                  ng-click=\"showAnswers(i,\'voter\',questions[currentIndex]._id,voterAnsCount[questions[currentIndex]._id],$index)\"\r\n                  id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                </canvas>\r\n              </span>\r\n                <span ng-if=\"!voterAnsCount[questions[currentIndex]._id][i]\" data-tooltip=\"tooltip\" class=\"has-tip\"  title=\"No users to see here\">\r\n                  <canvas class=\"clk\"\r\n                    ng-style=\"changeColor(voterAnsCount[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                    ng-click=\"showAnswers(i,\'voter\',questions[currentIndex]._id,voterAnsCount[questions[currentIndex]._id],$index)\"\r\n                    id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                  </canvas>\r\n                </span>\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div>\r\n            <div class=\"clearfix\" style=\"height: 32px;\">\r\n              <div class=\"mb5 clearfix\"><br>\r\n                <div class=\"inl-blk pull-left\">{{voter[questions[currentIndex]._id]}}%</div>\r\n                <div ng-if=\"!voter[questions[currentIndex]._id]\" class=\"w100 text-center fwb\">N/A</div>\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div><br>\r\n            <div class=\"clearfix\" style=\"height: 111px;\">\r\n              <p>&nbsp;</p>\r\n              <div ng-if=\"voterImpCount[questions[currentIndex]._id]\" ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\"\r\n                style=\"line-height: 15px\">\r\n                <canvas id=\"myCanvas\" width=\"100\" height=\"10\"\r\n                  style=\"border:1px solid #141212;\r\n              background: linear-gradient(to right, #e0dbdb {{voterImpCount[questions[currentIndex]._id][i]}}%, #2b4f7f 10%); \">\r\n                </canvas>\r\n              </div>\r\n              <div ng-if=\"importance\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <i ng-if=\"loadernew\" class=\"fa fa-refresh fa-spin\" style=\"font-size:72px;float: left;margin-top: 10%\"></i>\r\n\r\n\r\n        <div class=\"pull-left ans-col\" ng-if=\"advocate && userId\">\r\n          <div class=\"clearfix  pad10\">\r\n            <div class=\"nslant-txt clk ylink\" ng-if=\"userId && !inviterData\" ng-click=\"showAnswersDetail(\'advocate\')\">\r\n              <a href=\"\" title=\"These are all the organizations who answered this question.  Click to see their individual answers.\">Organizations </a>\r\n            </div>\r\n            <div class=\"nslant-txt clk ylink\" ng-if=\"userId && inviterData.title && !showGrpFollow\"\r\n              ng-click=\"showAnswersDetail(\'advocate\')\">\r\n              <a href=\"\" title=\"This is the person or organization that invited you to take the quiz.\" style=\"text-transform: capitalize;\">{{inviterData.title}}</a>\r\n            </div>\r\n            <div class=\"nslant-txt clk ylink\" ng-if=\"userId && showGrpFollow\"\r\n              ng-click=\"showAnswersDetail(\'politician\')\">\r\n              <a href=\"\" title=\"These are the followers who took this quiz.  Click to see their individual answers.\">Your Followers</a>\r\n            </div>\r\n          </div>\r\n          <p></p>\r\n          <br>\r\n          <div class=\"pad10\">\r\n            <div class=\"clearfix\">\r\n              <p>&nbsp;</p>\r\n              <div class=\"mb5 clearfix\">\r\n                <span class=\"clk ylink\" ng-if=\"advocateFlag[questions[currentIndex]._id]\" ng-click=\"viewAnsComment(\'advocate\')\"><a href=\"\" title=\"Click to see their comments.\">READ COMMENTS</a></span>\r\n                <span ng-if=\"ans.comment && (ans.comment | isBlankString)\">None</span>\r\n                <span ng-if=\"!advocateFlag[questions[currentIndex]._id]\">N/A</span>\r\n              </div>\r\n            </div>\r\n            <p></p>\r\n            <div class=\"clearfix\" style=\"height: 120px;\">\r\n              <div ng-repeat=\"i in [1,2,3,4,5,6] track by $index\" class=\"mb5 clearfix\" style=\"line-height: 15px\">\r\n                <span ng-if=\"advocateAns[questions[currentIndex]._id][i]\" data-tooltip=\"tooltip\" class=\"has-tip\"  title=\"Click here to see everyone who answered this way\">\r\n                <canvas class=\"clk\"\r\n                  ng-style=\"changeColor(advocateAns[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                  ng-click=\"showAnswers(i,\'advocate\',questions[currentIndex]._id,advocateAns[questions[currentIndex]._id],$index)\"\r\n                  id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                </canvas>\r\n                </span>\r\n                <span ng-if=\"!advocateAns[questions[currentIndex]._id][i]\" data-tooltip=\"tooltip\" class=\"has-tip\"  title=\"No users to see here\">\r\n                    <canvas class=\"clk\"\r\n                      ng-style=\"changeColor(advocateAns[questions[currentIndex]._id][i],i,questions[currentIndex].my_answer.answer)\"\r\n                      ng-click=\"showAnswers(i,\'advocate\',questions[currentIndex]._id,advocateAns[questions[currentIndex]._id],$index)\"\r\n                      id=\"myCanvas\" width=\"100\" height=\"10\" style=\"border:1px solid #009900;\">\r\n                    </canvas>\r\n                    </span>\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div>\r\n            <div class=\"clearfix\" style=\"height: 32px;\">\r\n              <div class=\"mb5 clearfix\"><br>\r\n                <div class=\"inl-blk pull-left\">{{advocate[questions[currentIndex]._id]}}%</div>\r\n                <!-- <div ng-if=\"!advocate[questions[currentIndex]._id]\" class=\"w100 text-center fwb\">N/A</div> -->\r\n              </div>\r\n              <div ng-if=\"answer\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div><br>\r\n            <div class=\"clearfix\" style=\"height: 111px;\">\r\n              <p>&nbsp;</p>\r\n              <div ng-if=\"advocateimpObj[questions[currentIndex]._id]\" ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\"\r\n                style=\"line-height: 15px\">\r\n                <canvas id=\"myCanvas\" width=\"100\" height=\"10\"\r\n                  style=\"border:1px solid #141212;\r\n              background: linear-gradient(to right, #e0dbdb {{advocateimpObj[questions[currentIndex]._id][i]}}%, #2b4f7f 10%); \">\r\n                </canvas>\r\n              </div>\r\n              <div ng-if=\"importance\" class=\"flex w100 h100\">\r\n                <span>\r\n                <b>N/A</b>\r\n              </span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n  <div ng-if=\"showComment\">\r\n    <div>\r\n      <a href=\"\" class=\"ylink\" style=\"padding-left: 10%\" ng-click=\"back()\">Back</a>\r\n    </div>\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Comments</legend>\r\n      <div class=\"contactBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\" style=\"width: 100%\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <br>\r\n\r\n            <!-- <span ng-if=\"\"> </span> -->\r\n            <div ng-repeat=\"com in global[questions[currentIndex]._id] | filter:getItems()\">\r\n\r\n              <div class=\"pad10\">\r\n                <span ng-if=\"com.author.username\">Name: </span><span class=\"newcomName\"> {{com.author.username}}</span>\r\n                <br>\r\n                <span>Comment: </span><span class=\"newcomName\"> {{com.comment}}</span>\r\n                <br>\r\n                <span>Answer</span>\r\n                <br>\r\n                <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n                  <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n                    style=\"padding-left: 8px;  line-height: 15px\">\r\n                    <span class=\"inl-blk pull-left\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n                    <div class=\"cq-box inl-blk pull-left\"\r\n                      ng-class=\"(com.answer == i) ? getComapreClass(com.match, i) : \'\'\"></div>\r\n                    <span class=\"inl-blk\" ng-if=\"i == 6\" style=\"padding-left:8px\">DISAGREE</span>\r\n                  </div>\r\n                </div>\r\n                <br>\r\n                <p></p>\r\n                <span>IMPORTANCE</span>\r\n                <br>\r\n                <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n                  <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"padding-left: 8px; line-height: 15px\">\r\n                    <span class=\"inl-blk\" ng-if=\"i == 1\">Very</span>\r\n                    <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                    <span class=\"inl-blk\" ng-if=\"i == 3\">Not Very</span>\r\n                    <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                      ng-class=\"(com.importance == i) ? \'ag-dg\' : \'\'\"></div>\r\n                  </div>\r\n                </div>\r\n                <hr style=\"\r\n                  margin-left: auto;\r\n                  margin-right: auto;\r\n                  height: 1px;\r\n                  background-color:#666;\r\n                  opcaity: 0.5;\">\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </fieldset>\r\n  </div>\r\n\r\n  <div ng-if=\"showCurr\">\r\n    <div>\r\n      <a href=\"\" class=\"ylink\" style=\"padding-left: 10%\" ng-click=\"back()\">Back</a>\r\n    </div>\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Comments</legend>\r\n      <div class=\"contactBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\" style=\"width: 100%\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <span>Comment: </span><span class=\"newcomName\">{{questions[currentIndex].my_answer.comment}}</span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </fieldset>\r\n  </div>\r\n  <div style=\"text-align:left;\" ng-if=\"showcomparison == true\">\r\n    <div ng-if=\"noDataFound == false\">\r\n      <div class=\"squareBoxY\" style=\"margin-left:10px;\">&nbsp;</div>\r\n      <span>= Simple Comparison by answers alone.</span>\r\n      <div style=\"clear:both;\"></div>\r\n      <div class=\"squareBoxB\" style=\"margin-left:10px\">&nbsp;</div>\r\n      <span>= Weighted Comparison by answers and importance.</span>\r\n      <div style=\"clear:both;\"></div>\r\n    </div>\r\n    <!--\r\n    <div>\r\n        <div style=\"width:30%; float:left; text-align:right;\">Order By :&nbsp;&nbsp;</div>\r\n        <div style=\"width:65%; float:left; text-align:left;\">\r\n            <select ng-model=\"ord.Option\">\r\n                <option value=\"BW\">Best Weighted match</option>\r\n                <option value=\"W\">Worst weighted match</option>\r\n                <option value=\"BS\">Best simple match</option>\r\n                <option value=\"S\">worst simple match</option>\r\n            </select>\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n    </div>\r\n    -->\r\n    <ul class=\"catList\" ng-if=\"noDataFound == false\">\r\n      <li ng-repeat=\"frd in AllUsers track by $index\" ng-if=\"FBunWeighted[frd._id] && fbcombinedWeight[frd._id]\">\r\n        <div style=\"background-color:#ffffee; padding:10px;\">\r\n          <div style=\"color: #000000;\"><b>\r\n              <div ng-repeat=\"fd in frd.politicianInfo\" ng-if=\"fd.candidateStatus==\'Running\'\"><span style=\"text-transform: capitalize;\">{{fd.officeName}}</span></div>\r\n            </b><b style=\"text-transform: capitalize;\">{{frd.name}}</b>&nbsp;&nbsp;&nbsp;Total Answered questions:\r\n            {{fbqlen[frd._id]}}\r\n          </div>\r\n          <div style=\"width: 84%; float:left;\">\r\n            <div>\r\n              <div class=\"fbunweighted\" style=\"width:{{(FBunWeighted[frd._id] / fbqlen[frd._id] )  | number:2}}%\">{{(FBunWeighted[frd._id]\r\n                / fbqlen[frd._id] ) | number:2}}% Match</div>\r\n            </div>\r\n            <div>\r\n              <div class=\"fbweighted\"\r\n                style=\"width:{{(fbcombinedWeight[frd._id] / fbmultiplier[frd._id])  | number:2}}%\">{{(fbcombinedWeight[frd._id]\r\n                / fbmultiplier[frd._id]) | number:2}}% Weighted Match</div>\r\n            </div>\r\n          </div>\r\n          <div style=\"clear:both;\"></div>\r\n        </div>\r\n      </li>\r\n    </ul>\r\n    <!--  <div ng-if=\"noDataFound == true\">\r\n      <h3>\r\n        <p style=\"color:red\">Congratulations! You are the first person in your region to take this quiz. You are a true pioneer! You should contact your local politicians and your friends to encourage them to use this site. There are still plenty of wonderful things here to see.</p>\r\n      </h3>\r\n      <br>\r\n      <br>\r\n      <div class=\"margin-auto mxw\">\r\n        <div class=\"digDeeperSmall\" style=\"float:left\"> <a href=\"#!/digDeeper\"><img ng-src=\"../assets/images/DigDeeper.svg\" alt=\"Dig deeper\" /></a></div>\r\n        <button class=\"btnB275\" style=\"width:150px; float:right;\" ng-click=\"finalSignIn()\">Sign In</button>\r\n      </div>\r\n\r\n    </div> -->\r\n    <!--\r\n  <center><button class=\"btnB275\" ng-click=\"postonFacebook()\">Post Quiz to Facebook</button></center>\r\n-->\r\n    <!-- <div><center><input type=\"button\" name=\"btnNext\" value=\"Next\" ng-click=\"nextCat()\"></center></div> -->\r\n    <div ng-if=\"showcomparison == false\">\r\n      <p>This only shows politicians that have answered our quizzes. For the rest, you can see how organizations rated\r\n        them, their voting records, who financed their campaigns and more here</p>\r\n      <center><button class=\"btnB275\"> <a href=\"#!/compare-select/politician\">See Other Politicians</a></button>\r\n      </center><br><br>\r\n    </div>\r\n    </div>\r\n    <div class=\"mb5 clearfix print-hide\"\r\n      ng-if=\"!showComment && !unComment && !showPoliAnswerDetails && !showUserAnswerDetails && !showCurr\">\r\n      <!-- <a class=\"clk fwb\" ng-click=\"prevQuestion()\">Prev</a>&nbsp;\r\n                  <a class=\"clk fwb\" ng-click=\"skipQuestion()\">Next</a> -->\r\n      <button class=\"compareBtnS\" ng-click=\"prevQuestion()\"><i class=\"fa fa-angle-left arrowIconBack\"></i>Prev</button>\r\n      <button class=\"compareBtnS\" ng-click=\"skipQuestion()\">Next<i class=\"fa fa-angle-right arrowIconSubmit\"></i></button>\r\n    </div>\r\n    <div ng-show=\"questions.length <= 0 && status.questions == 2\">\r\n      <a href=\"javascript: void(0)\" ng-click=\"skipQuestion()\" class=\"changeTextColor\">Next</a>\r\n      <a href=\"javascript: void(0)\" ng-click=\"prevQuestion()\" class=\"changeTextColor\">Prev</a>\r\n    </div>\r\n    <button class=\"compareBtn\"><a href=\"#!/whatAmILookingAt1\">What Am I Looking At?</a></button>\r\n    <!--<br>\r\n	<button class=\"compareBtn\"><a href=\"#!/ballotMatch\">Did you skip this question?  Take the quiz.</a></button> -->\r\n  </div>\r\n");
$templateCache.put("app/showAnswers/showAnswers.html","\r\n<div class=\"container-fluid\">\r\n  <div>\r\n    <!-- <h5>Answers</h5> -->\r\n   \r\n  <center>\r\n    <div ng-if=\"showLoader\" style=\"z-index: 2; background:black; margin-left: 3%;\">\r\n      <i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span>\r\n    </div>\r\n\r\n\r\n  </center>\r\n    <div ng-if=\"showPoliAnswerDetails\">\r\n      <!--     <div>\r\n        <a href=\"\" class=\"ylink\" style=\"padding-left: 10%\" ng-click=\"back()\">Back</a>\r\n      </div>  -->\r\n      <fieldset class=\"scheduler-border\">\r\n        <legend class=\"scheduler-border\">Answers</legend>\r\n       \r\n        <div class=\"questionAnswersBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\" style=\"width: 100%\">\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n              <br>\r\n              <div ng-repeat=\"com in globalArray[quesId] track by $index\">\r\n                <div class=\"pad10\">\r\n                  <!-- <span ng-if=\"com.author.name && com.author.userType != \'voter\'\">Name:{{orgName}}2{{com.orgName}}3{{com.author.title}}4{{com.author.userType}}5{{com.author.orgName}}6{{com.author.name}}7{{com.author.Name}}{{com.author.orgname}}{{com.orgname}}{{com.org.title}}{{com.author.org.Title}}</span> -->\r\n                  <a href=\"#!/publicProfile/{{com.author._id}}\" class=\"link\" ng-if=\"com.author.name && com.author.userType != \'voter\' &&\r\n                  com.author.userType == \'politician\'\" style=\"text-transform: capitalize;\"><img ng-src=\"../assets/images/profile/{{com.author.userType}}.svg \" alt=\"{{com.author.userType}}\" class=\"usertype \">  {{com.author.name}}</a>\r\n                  <a href=\"#!/pressProfile/{{com.author._id}}\" class=\"link\" ng-if=\"com.author.name && com.author.userType != \'voter\' &&\r\n                  com.author.userType != \'politician\' && com.orgName\" style=\"text-transform: capitalize;\"> <img ng-src=\"../assets/images/profile/{{com.author.userType}}.svg \" alt=\"{{com.author.userType}}\" class=\"usertype \"> {{com.orgName}}</a>\r\n                  <a href=\"#!/pressProfile/{{com.author._id}}\" class=\"link\" ng-if=\"com.author.name && com.author.userType != \'voter\' &&\r\n                  com.author.userType != \'politician\' && !com.orgName\" style=\"text-transform: capitalize;\"><img ng-src=\"../assets/images/profile/{{com.author.userType}}.svg \" alt=\"{{com.author.userType}}\" class=\"usertype \">  {{com.author.name}}</a>\r\n                  <!-- <a href=\"#!/publicProfile/{{com.author._id}}\" class=\"link\" ng-if=\"com.author.name == \'\' && com.author.userType != \'voter\'\"> {{com.author.username}}</a> -->\r\n                  <span ng-if=\"com.author.username && com.author.userType != \'politician\' && com.author.userType != \'advocate\' \"> <img ng-src=\"../assets/images/profile/voter.svg \" alt=\"Voter\" class=\"usertype \"> Name: voter {{$index+1}}</span>\r\n                  <br>\r\n                  <span>Answer</span>\r\n                  <br>\r\n                  <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n\r\n                    <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n                      style=\"padding-left: 8px;  line-height: 9px\">\r\n                      <span class=\"inl-blk pull-left\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n                      <div class=\"cq-box inl-blk pull-left\"\r\n                        ng-class=\"(com.answer == i) ? getComapreClass(com.match, i) : \'\'\"></div>\r\n                      <span class=\"inl-blk\" ng-if=\"i == 6\" style=\"padding-left:8px\">DISAGREE</span>\r\n                    </div>\r\n                  </div>\r\n                  <br>\r\n                  <p></p>\r\n                  <span>IMPORTANCE</span>\r\n                  <br>\r\n                  <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n                    <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"padding-left: 8px; line-height: 9px\">\r\n                      <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n                      <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                      <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n                      <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                        ng-class=\"(com.importance == i) ? \'ag-dg\' : \'\'\"></div>\r\n                    </div>\r\n                  </div>\r\n                  <p></p>\r\n                  <div>\r\n                    <span ng-if=\"com.comment\">Comment:</span>\r\n                    <span ng-if=\"com.comment\" class=\"newcomName\">{{com.comment}}</span>\r\n                  </div>\r\n                  <hr style=\"\r\n                    margin-left: auto;\r\n                    margin-right: auto;\r\n                    height: 1px;\r\n                    background-color:#666;\r\n                    opcaity: 0.5;\">\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </fieldset>\r\n    </div>\r\n    <div ng-if=\"showUserAnswerDetails\">\r\n      <!--      <div>\r\n        <a href=\"\" class=\"ylink\" style=\"padding-left: 10%\" ng-click=\"back()\">Back</a>\r\n      </div> -->\r\n      <fieldset class=\"scheduler-border\">\r\n        <legend class=\"scheduler-border\">Answers</legend>\r\n        <div class=\"questionAnswersBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\" style=\"width: 100%\">\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n              <br>\r\n              <div ng-repeat=\"item in unVeriComm[quesId] track by $index\">\r\n\r\n\r\n                <div class=\"pad10\">\r\n                  <span ng-if=\"item.answer\">Name: </span><span class=\"\r\n                    newcomName\">Unregistered User {{$index+1}}</span>\r\n                  <br>\r\n                  <span>Answer</span>\r\n                  <br>\r\n                  <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n                    <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n                      style=\"padding-left: 8px;  line-height: 9px\">\r\n                      <span class=\"inl-blk pull-left\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n                      <div class=\"cq-box inl-blk pull-left\"\r\n                        ng-class=\"(item.answer == i) ? getComapreClass(item.match, i) : \'\'\"></div>\r\n                      <span class=\"inl-blk\" ng-if=\"i == 6\" style=\"padding-left:8px\">DISAGREE</span>\r\n                    </div>\r\n                  </div>\r\n                  <br>\r\n                  <p></p>\r\n                  <span>IMPORTANCE</span>\r\n                  <br>\r\n                  <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n\r\n                    <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"padding-left: 8px;  line-height: 9px \">\r\n                      <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n                      <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                      <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n                      <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                        ng-class=\"(item.importance == i) ? \'ag-dg\' : \'\'\"></div>\r\n                    </div>\r\n                  </div>\r\n                  <p></p>\r\n                  <div>\r\n                    <span ng-if=\"item.comment\">Comment:</span>\r\n                    <span ng-if=\"item.comment\" style=\"font-size: 16px;font-weight: 200\">{{item.comment}}</span>\r\n                  </div>\r\n                  <hr style=\"\r\n                    margin-left: auto;\r\n                    margin-right: auto;\r\n                    height: 1px;\r\n                    background-color:#666;\r\n                    opcaity: 0.5;\">\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </fieldset>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/showBallotEndorsement/showBallotEndorsement.html","<!-- <div id=\"background\"></div> -->\r\n<div class=\"container-fluid\">\r\n  <h2 class=\"pageHeading\">ENDORSEMENTS<br>\r\n    <span>{{title}}</span>\r\n  </h2>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-lg-12\">\r\n      <div id=\"topHeader\">\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <!-- Small Screen -->\r\n  <div class=\"row d-lg-none\">\r\n    <div class=\"col-12\">\r\n\r\n      <div>\r\n        <div id=\"descContainer\">\r\n        </div>\r\n        <div id=\"selectBoxContainer\">\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div>\r\n    <div class=\"col-lg-12 col-centered\" id=\"compareContent\">\r\n      <div class=\"tableContainer\">\r\n        <center>\r\n          <h3 style=\"text-transform: capitalize; color:#fff;\">ENDORSEMENTS</h3>\r\n        </center>\r\n        The endorsements are listed in order of most active endorser, but you can reorder using any of the headers.\r\n        <br>\r\n        <br>\r\n        <div class=\"table-responsive\">\r\n          <table class=\"table table-striped\" style=\"margin-bottom:0px;\">\r\n            <tr>\r\n              <th class=\"tableHead\">\r\n                <span ng-click=\"sortSearch(\'name\')\" style=\"cursor:pointer; text-decoration:underline;\" class=\"hoverYellow\">Endorser</span>&nbsp;<i ng-if=\"nameUp\" class=\"fa fa-arrow-circle-up\"></i><i ng-if=\"nameDown\" class=\"fa fa-arrow-circle-down\"></i>\r\n              </th>\r\n              <th class=\"tableHead\">Details</th>\r\n            </tr>\r\n            <tr ng-repeat=\"endorsement in allEndorsements\">\r\n              <td class=\"tableRow\" ng-if=\"endorsement.endorseBy[0].name\">\r\n                <img ng-src=\"../assets/images/profile/{{endorsement.endorseBy[0].uType}}.svg\" ng-if=\"endorsement.endorseBy[0].uType\" class=\"usertype\"><a href=\"#!/pressProfile/{{endorsement.endorseBy[0].uid}}\" ng-if=\"endorsement.endorseBy[0].uType == \'advocate\'\">{{endorsement.orgName}}</a>\r\n\r\n                <a href=\"#!/publicProfile/{{endorsement.endorseBy[0].uid}}\" ng-if=\"endorsement.endorseBy[0].uType == \'politician\'\" >{{endorsement.pName}}</a>\r\n              </td>\r\n              <td class=\"tableRow\">\r\n                <a href=\"\" ng-if=\"endorsement.note !=\'\'\" ng-click=\"showHtmlViewer(endorsement.note)\" class=\"link\">View</a>\r\n                <span ng-if=\"!endorsement.note\">N/A</span>\r\n              </td>\r\n\r\n            </tr>\r\n          </table>\r\n          <div ng-if=\"loader\" class=\"fwb\">\r\n            <p>\r\n              <center><i class=\"fa fa-refresh fa-spin\" style=\"font-size:72px;\"></i></center>\r\n            </p>\r\n          </div>\r\n        </div>\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<script type=\"text/ng-template\" id=\"statement\">\r\n  <div class=\"row\">\r\n  <div ng-bind-html=\'displayContent\' class=\"txtwindow\"></div>\r\n</div>\r\n</script>\r\n");
$templateCache.put("app/showComments/showComments.html","<div class=\"container-fluid\">\r\n  <div>\r\n    <h4>Comments</h4>\r\n	\r\n    <div ng-if=\"showComment\">\r\n      <div class=\"hideCell\">\r\n        <!--     <div>\r\n        <a href=\"\" class=\"ylink\" style=\"padding-left: 10%\" ng-click=\"back()\">Back</a>\r\n      </div> -->\r\n        <fieldset class=\"scheduler-border\">\r\n          <legend class=\"scheduler-border\">Comments</legend>\r\n          <div class=\"contactBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\" style=\"width: 100%\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-12\">\r\n                <br>\r\n\r\n                <!-- <span ng-if=\"\"> </span> -->\r\n                <div ng-repeat=\"com in global[queId] | filter:getItems()\">\r\n\r\n\r\n                  <div class=\"pad10\">\r\n                    <span ng-if=\"com.author.username\">Name: </span>\r\n																			<a href=\"#!/publicProfile/{{com.author._id}}\" class=\"link\" ng-if=\"com.author.username && com.author.userType == \'politician\'\" style=\"text-transform: capitalize;\"><img ng-src=\"../assets/images/profile/{{com.author.userType}}.svg \" alt=\"{{com.author.userType}}\" class=\"usertype \"> \r\n                    <b ng-if=\"com.author.userType == \'politician\' && com.author.userType != \'advocate\'\" > {{com.author.nameOnBallot}}</b></a>\r\n                   <span ng-if=\"com.author.userType == voter\" style=\"text-transform: capitalize;\"><img ng-src=\"../assets/images/profile/{{com.author.userType}}.svg \" alt=\"{{com.author.userType}}\" class=\"usertype \"> \r\n                      <b style=\"text-transform: capitalize;\"> Voter {{$index+1}}</b></span>\r\n                    <a href=\"#!/pressProfile/{{com.author._id}}\" class=\"link\"  ng-if=\"com.author.userType == \'advocate\'\" style=\"text-transform: capitalize;\"><img ng-src=\"../assets/images/profile/{{com.author.userType}}.svg \" alt=\"{{com.author.userType}}\" class=\"usertype \"> \r\n                        <b style=\"text-transform: capitalize;\"> {{com.orgName}}</b></a>\r\n                    <br>\r\n                    <span>COMMENT: </span><b> {{com.comment}}</b>\r\n                    <br>\r\n                    <span>Answer</span>\r\n                    <br>\r\n                    <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n                      <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n                        style=\"padding-left: 8px;  line-height: 9px\">\r\n                        <span class=\"inl-blk pull-left\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n                        <div class=\"cq-box inl-blk pull-left\"\r\n                          ng-class=\"(com.answer == i) ? getComapreClass(com.match, i) : \'\'\"></div>\r\n                        <span class=\"inl-blk\" ng-if=\"i == 6\" style=\"padding-left:8px\">DISAGREE</span>\r\n                      </div>\r\n                    </div>\r\n                    <br>\r\n                    <p></p>\r\n                    <span>IMPORTANCE</span>\r\n                    <br>\r\n                    <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n                      <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"padding-left: 8px; line-height: 9px\">\r\n                        <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n                        <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                        <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n                        <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                          ng-class=\"(com.importance == i) ? \'ag-blk\' : \'\'\"></div>\r\n                      </div>\r\n                    </div>\r\n                    <br>\r\n                    <div ng-if=\"com.oldAnswers.length > 0\">\r\n                      <a href=\"\" ng-show=\"com.oldAnswers.length > 0\" ng-click=\"showHis =!showHis\"><h5> <b>History</b></h5></a>\r\n                      <div ng-hide=\"showHis\">\r\n                        <div ng-repeat=\"itm in com.oldAnswers track by $index\">\r\n                          <span ng-if=\"itm.comment\">Comment: </span><span> {{itm.comment}}</span>\r\n                          <br>\r\n                          <span ng-if=\"itm.created\">Updated: {{itm.created | date: \'MM-d-y\'}}</span>\r\n                          <br>\r\n                          <span ng-if=\"itm.reason\">Reason:- {{itm.reason}}</span>\r\n                          <br>\r\n                          <span ng-if=\"itm.answer\">Answer</span>\r\n                          <br>\r\n                          <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n                            <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n                              style=\"padding-left: 8px;  line-height: 9px\">\r\n                              <span class=\"inl-blk pull-left\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n                              <div class=\"cq-box inl-blk pull-left\"\r\n                                ng-class=\"(itm.answer == i) ? getComapreClassHis(itm.answer, i) : \'\'\"></div>\r\n                              <span class=\"inl-blk\" ng-if=\"i == 6\" style=\"padding-left:8px\">DISAGREE</span>\r\n                            </div>\r\n                          </div>\r\n                          <br>\r\n                          <p></p>\r\n                          <span>IMPORTANCE</span>\r\n                          <br>\r\n                          <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n                            <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\"\r\n                              style=\"padding-left: 8px; line-height: 9px\">\r\n                              <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n                              <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                              <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n                              <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                                ng-class=\"(itm.importance == i) ? \'ag-blk\' : \'\'\"></div>\r\n                            </div>\r\n                          </div>\r\n                          <hr style=\"\r\n                        margin-left: auto;\r\n                        margin-right: auto;\r\n                        height: 1px;\r\n                        background-color:#666;\r\n                        opcaity: 0.5;\">\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <hr style=\"\r\n                      margin-left: auto;\r\n                      margin-right: auto;\r\n                      height: 1px;\r\n                      background-color:#666;\r\n                      opcaity: 0.5;\">\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n        </fieldset>\r\n					</div></div>\r\n        <div ng-if=\"unCommentNew\">\r\n          <!--     <div>\r\n        <a href=\"\" class=\"ylink\" style=\"padding-left: 10%\" ng-click=\"back()\">Back</a>\r\n      </div>  -->\r\n          <fieldset class=\"scheduler-border\">\r\n            <legend class=\"scheduler-border\">Comments</legend>\r\n            <div class=\"contactBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\" style=\"width: 100%\">\r\n              <div class=\"row\">\r\n                <div class=\"col-md-12\">\r\n                  <br>\r\n                  <!-- <span ng-if=\"\"> </span> -->\r\n                  <div ng-repeat=\"item in unVeriCommNew[queId] |filter:getComment() track by $index\">\r\n                    <div class=\"pad10\">\r\n                      <span>Name: </span><b>Unregistered User {{$index+1}}</b>\r\n                      <br>\r\n                      <span>COMMENT: </span><span>{{item.comment}}</span>\r\n                      <br>\r\n                      <span>Answer</span>\r\n                      <br>\r\n                      <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n                        <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n                          style=\"padding-left: 8px;  line-height: 9px\">\r\n                          <span class=\"inl-blk pull-left\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n                          <div class=\"cq-box inl-blk pull-left\"\r\n                            ng-class=\"(item.answer == i) ? getComapreClass(item.match, i) : \'\'\"></div>\r\n                          <span class=\"inl-blk\" ng-if=\"i == 6\" style=\"padding-left:8px\">DISAGREE</span>\r\n                        </div>\r\n                      </div>\r\n                      <br>\r\n                      <p></p>\r\n                      <span>IMPORTANCE</span>\r\n                      <br>\r\n                      <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n\r\n                        <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\"\r\n                          style=\"padding-left: 8px;  line-height: 9px \">\r\n                          <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n                          <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                          <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n                          <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                            ng-class=\"(item.importance == i) ? \'ag-blk\' : \'\'\"></div>\r\n                        </div>\r\n                      </div>\r\n\r\n                      <hr style=\"\r\n                      margin-left: auto;\r\n                      margin-right: auto;\r\n                      height: 1px;\r\n                      background-color:#666;\r\n                      opcaity: 0.5;\">\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n        <div ng-if=\"showCurUser\">\r\n          <!--     <div>\r\n        <a href=\"\" class=\"ylink\" style=\"padding-left: 10%\" ng-click=\"back()\">Back</a>\r\n      </div>  -->\r\n          <fieldset class=\"scheduler-border\">\r\n            <legend class=\"scheduler-border\">Comment</legend>\r\n            <div class=\"contactBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\" style=\"width: 100%\">\r\n              <div class=\"row\">\r\n                <div class=\"col-md-12\">\r\n                  <br>\r\n                  <!-- <span ng-if=\"\"> </span> -->\r\n                  <div ng-if=\"currentUser.my_answer.comment\">\r\n                    <span>Comment: </span><span>{{currentUser.my_answer.comment}}</span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n      </div>\r\n      <div class=\"hideNonCell\">\r\n        <!--     <div>\r\n        <a href=\"\" class=\"ylink\" style=\"padding-left: 10%\" ng-click=\"back()\">Back</a>\r\n      </div> -->\r\n\r\n        <div class=\"contactBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\" style=\"width: 100%\">\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n              <br>\r\n\r\n              <!-- <span ng-if=\"\"> </span> -->\r\n              <div ng-repeat=\"com in global[queId] | filter:getItems()\">\r\n\r\n\r\n                <div class=\"pad10\">\r\n                  <span ng-if=\"com.author.username\">Name: </span><a href=\"#!/publicProfile/{{com.author._id}}\" class=\"link\" ng-if=\"com.author.username && com.author.userType == \'politician\'\">\r\n                    <a href=\"#!/pressProfile/{{com.author._id}}\" class=\"link\"  ng-if=\"com.author.username && com.author.userType == \'advocate\'\">\r\n                <b style=\"text-transform: capitalize;\"> {{com.author.username}}</b></a>\r\n                  <b ng-if=\"com.author.userType != \'politician\' && com.author.userType != \'advocate\'\" > {{com.author.username}}</b></a>\r\n                  <br>\r\n                  <span>Comment: </span><b> {{com.comment}}</b>\r\n                  <br>\r\n                  <span>Answer</span>\r\n                  <br>\r\n                  <span style=\"float: left;\">AGREE</span>\r\n                  <span style=\"float:right; padding-right: 20px;\">DISAGREE</span>\r\n                  <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n                    <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n                      style=\"padding-left: 8px;  line-height: 9px\">\r\n\r\n                      <div class=\"cq-box inl-blk pull-left\"\r\n                        ng-class=\"(com.answer == i) ? getComapreClass(com.match, i) : \'\'\"></div>\r\n\r\n                    </div>\r\n                  </div>\r\n                  <br>\r\n                  <p></p>\r\n                  <span>IMPORTANCE</span>\r\n                  <br>\r\n                  <center>Not Very &nbsp;&nbsp;|&nbsp;&nbsp;Somewhat&nbsp;&nbsp;|&nbsp;&nbsp;Very</center>\r\n                  <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n                    <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"padding-left: 8px; line-height: 9px\">\r\n                      <!--                     <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n                      <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                      <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>  -->\r\n                      <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                        ng-class=\"(com.importance == i) ? \'ag-blk\' : \'\'\"></div>\r\n                    </div>\r\n                  </div>\r\n                  <br>\r\n                  <div ng-if=\"com.oldAnswers.length > 0\">\r\n                    <a href=\"\" ng-show=\"com.oldAnswers.length > 0\" ng-click=\"showHis =!showHis\"><h5> <b>History</b></h5></a>\r\n                    <div ng-hide=\"showHis\">\r\n                      <div ng-repeat=\"itm in com.oldAnswers track by $index\">\r\n                        <span ng-if=\"itm.comment\">Comment: </span><span> {{itm.comment}}</span>\r\n                        <br>\r\n                        <span ng-if=\"itm.created\">Updated: {{itm.created | date: \'MM-d-y\'}}</span>\r\n                        <br>\r\n                        <span ng-if=\"itm.reason\">Reason:- {{itm.reason}}</span>\r\n                        <br>\r\n                        <span ng-if=\"itm.answer\">Answer</span>\r\n                        <br>\r\n                        <span style=\"float: left;\">AGREE</span>\r\n                        <span style=\"float:right; padding-right: 20px;\">DISAGREE</span>\r\n                        <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n                          <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n                            style=\"padding-left: 8px;  line-height: 9px\">\r\n                            <div class=\"cq-box inl-blk pull-left\"\r\n                              ng-class=\"(itm.answer == i) ? getComapreClassHis(itm.answer, i) : \'\'\"></div>\r\n                          </div>\r\n                        </div>\r\n                        <br>\r\n                        <p></p>\r\n                        <span>IMPORTANCE</span>\r\n                        <br>\r\n                        <center>Not Very &nbsp;&nbsp;|&nbsp;&nbsp;Somewhat&nbsp;&nbsp;|&nbsp;&nbsp;Very</center>\r\n                        <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n                          <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\"\r\n                            style=\"padding-left: 8px; line-height: 9px\">\r\n                            <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                              ng-class=\"(itm.importance == i) ? \'ag-blk\' : \'\'\"></div>\r\n                          </div>\r\n                        </div>\r\n                        <hr style=\"\r\n                        margin-left: auto;\r\n                        margin-right: auto;\r\n                        height: 1px;\r\n                        background-color:#666;\r\n                        opcaity: 0.5;\">\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <hr style=\"\r\n                      margin-left: auto;\r\n                      margin-right: auto;\r\n                      height: 1px;\r\n                      background-color:#666;\r\n                      opcaity: 0.5;\">\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n\r\n\r\n        <div ng-if=\"unCommentNew\">\r\n          <!--     <div>\r\n        <a href=\"\" class=\"ylink\" style=\"padding-left: 10%\" ng-click=\"back()\">Back</a>\r\n      </div>  -->\r\n          <div class=\"contactBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\" style=\"width: 100%\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-12\">\r\n                <br>\r\n                <!-- <span ng-if=\"\"> </span> -->\r\n                <div ng-repeat=\"item in unVeriCommNew[queId] |filter:getComment() track by $index\">\r\n                  <div class=\"pad10\">\r\n                    <span>Name: </span><b>Unregistered User {{$index+1}}</b>\r\n                    <br>\r\n                    <span>Comment: </span><span>{{item.comment}}</span>\r\n                    <br>\r\n                    <span>Answer</span>\r\n                    <br> <span style=\"float: left;\">AGREE</span>\r\n                    <span style=\"float:right; padding-right: 20px;\">DISAGREE</span>\r\n                    <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n                      <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n                        style=\"padding-left: 8px;  line-height: 9px\">\r\n\r\n                        <div class=\"cq-box inl-blk pull-left\"\r\n                          ng-class=\"(item.answer == i) ? getComapreClass(item.match, i) : \'\'\"></div>\r\n                      </div>\r\n                    </div>\r\n                    <br>\r\n                    <p></p>\r\n                    <span>IMPORTANCE</span>\r\n                    <br>\r\n                    <center>Not Very &nbsp;&nbsp;|&nbsp;&nbsp;Somewhat&nbsp;&nbsp;|&nbsp;&nbsp;Very</center>\r\n                    <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n\r\n                      <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"padding-left: 8px;  line-height: 9px \">\r\n                        <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                          ng-class=\"(item.importance == i) ? \'ag-blk\' : \'\'\"></div>\r\n                      </div>\r\n                    </div>\r\n\r\n                    <hr style=\"\r\n                      margin-left: auto;\r\n                      margin-right: auto;\r\n                      height: 1px;\r\n                      background-color:#666;\r\n                      opcaity: 0.5;\">\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n\r\n      </div>\r\n    </div>\r\n    <div ng-if=\"showCurUser\">\r\n      <!--     <div>\r\n      <a href=\"\" class=\"ylink\" style=\"padding-left: 10%\" ng-click=\"back()\">Back</a>\r\n    </div>  -->\r\n\r\n      <div class=\"contactBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\" style=\"width: 100%\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <br>\r\n            <!-- <span ng-if=\"\"> </span> -->\r\n            <div ng-if=\"currentUser.my_answer.comment\">\r\n              <span>Comment: </span><span>{{currentUser.my_answer.comment}}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/showCompetitors/showCompetitors.html","<div class=\"container-fluid\">\r\n    \r\n    <div class=\"title-comp\">\r\n        Competitors of <a href=\"#!/publicProfile/{{selectedPoli._id}}\" class=\"ylink\">\r\n            {{selectedPoli.name}}</a>\r\n\r\n            <!-- <div ng-if=\"selectedPoli.incumbent == \'incumbent\' || selectedPoli.incumbent == \'Incumbent\'\">\r\n                <b>Incumbent:</b> Yes\r\n              </div>\r\n              <div ng-if=\"selectedPoli.incumbent == \'\'\"><b>Incumbent:</b> No</div>\r\n      \r\n              <div ng-if=\"selectedPoli.runningForOffice == \'Y\'\">\r\n                <b>runningForOffice:</b> Yes\r\n              </div>\r\n              <div ng-if=\"selectedPoli.runningForOffice == \'N\'\"><b>runningForOffice:</b> No</div>\r\n      \r\n              <div ng-click=\"showVotewiseAns = !showVotewiseAns\"><b>{{selectedPoli.votewiseAnsCount}}</b> Votewise answers</div>\r\n              <div ng-click=\"showVotesmartAns = !showVotesmartAns\"><b>{{selectedPoli.votesmartAnsCount}}</b> Votesmart answers</div>\r\n      \r\n              <div\r\n                ng-show=\"selectedPoli.statement != null\"\r\n                ng-click=\"showStatement = !showStatement\r\n                  \"\r\n              >\r\n                <b>1</b> Statement\r\n              </div>\r\n              <div ng-hide=\"showStatement\">{{selectedPoli.statement}}</div>\r\n              <div ng-if=\"selectedPoli.statement == null\"><b>0</b> Statement</div>\r\n              <div\r\n                ng-show=\"selectedPoli.resume != null\"\r\n                ng-click=\"showResume = !showResume\"\r\n              >\r\n                <b>1</b> Resume\r\n              </div>\r\n              <div ng-hide=\"showResume\">{{selectedPoli.resume}}</div>\r\n              <div ng-if=\"selectedPoli.resume == null\"><b>0</b> Resume</div>\r\n              <div ng-if=\"selectedPoli.lastLogin && selectedPoli.lastLogin != \'\'\">\r\n                <b>Last Logged in</b> {{selectedPoli.lastLogin}}\r\n              </div>\r\n              <div ng-if=\"User.officeType ==\'runningForOffice\'\">\r\n             <span ng-if=\"selectedPoli.voterScope == \'placeName\'\"> {{selectedPoli.place}}</span>\r\n                <span ng-if=\"selectedPoli.voterScope == \'countyName\'\"> {{selectedPoli.county}}</span>\r\n                <span ng-if=\"selectedPoli.voterScope == \'statePostalCode\' && selectedPoli.state !=\'NA\'\"> {{selectedPoli.state}}</span>\r\n                <span ng-if=\"selectedPoli.voterScope == \'All USA\'\"> the United States</span>\r\n                <span ng-if=\"selectedPoli.voterScope == \'statePostalCode\' && selectedPoli.state ==\'NA\'\">{{selectedPoli.statePostalCode}}</span>\r\n                <span ng-if=\"selectedPoli.voterScope == \'stateHouseofRepresentativesDistrict\'\">  {{selectedPoli.statePostalCode}} Legislative district {{selectedPoli.stateHouseofRepresentativesDistrict}}</span>\r\n                <span ng-if=\"selectedPoli.voterScope == \'stateSenateDistrict\' && selectedPoli.state !=\'NA\'\"> {{selectedPoli.state}} State district {{selectedPoli.stateSenateDistrict}}</span>\r\n                <span ng-if=\"selectedPoli.voterScope == \'stateSenateDistrict\' && selectedPoli.state ==\'NA\'\">{{selectedPoli.statePostalCode}}</span>\r\n                <span ng-if=\"selectedPoli.voterScope == \'federalCongressionalDistrict\'\">,<span ng-if=\"selectedPoli.state !=\'NA\'\">{{selectedPoli.state}}</span>\r\n                <span ng-if=\"selectedPoli.state ==\'NA\' && selectedPoli.statePostalCode !=\'NA\'\">{{selectedPoli.statePostalCode}}</span>\r\n                <span ng-if=\"selectedPoli.federalCongressionalDistrict\"> Federal Congressional District </span>\r\n                {{selectedPoli.federalCongressionalDistrict}}</span>\r\n      \r\n              </div>\r\n      \r\n              <div ng-if=\"User.officeType ==\'inOffice\'\">\r\n                <span ng-if=\"selectedPoli.winDetails[0].voterScope == \'placeName\'\"> {{selectedPoli.winDetails[0].place}}</span>\r\n                   <span ng-if=\"selectedPoli.winDetails[0].voterScope == \'countyName\'\">{{selectedPoli.winDetails[0].county}}</span>\r\n                   <span ng-if=\"selectedPoli.winDetails[0].voterScope == \'statePostalCode\'\">  {{selectedPoli.winDetails[0].statePostalCode}}</span>\r\n                   <span ng-if=\"selectedPoli.winDetails[0].voterScope == \'All USA\'\"> the United States</span>\r\n                   <span ng-if=\"selectedPoli.winDetails[0].voterScope == \'statePostalCode\' && selectedPoli.winDetails[0].state ==\'NA\'\">{{selectedPoli.winDetails[0].statePostalCode}}</span>\r\n                   <span ng-if=\"selectedPoli.winDetails[0].voterScope == \'stateHouseofRepresentativesDistrict\'\"> {{selectedPoli.winDetails[0].statePostalCode}} Legislative district {{selectedPoli.winDetails[0].stateHouseofRepresentativesDistrict}}</span>\r\n                   <span ng-if=\"selectedPoli.winDetails[0].voterScope == \'stateSenateDistrict\' && selectedPoli.winDetails[0].state !=\'NA\'\"> {{selectedPoli.winDetails[0].statePostalCode}} State district {{selectedPoli.winDetails[0].stateSenateDistrict}}</span>\r\n                   <span ng-if=\"selectedPoli.winDetails[0].voterScope == \'stateSenateDistrict\' && selectedPoli.winDetails[0].state ==\'NA\'\">{{selectedPoli.winDetails[0].statePostalCode}}</span>\r\n                   <span ng-if=\"selectedPoli.winDetails[0].voterScope == \'federalCongressionalDistrict\'\">,<span>{{selectedPoli.winDetails[0].statePostalCode}}</span>\r\n                   <span ng-if=\"selectedPoli.winDetails[0].state ==\'NA\' && selectedPoli.winDetails[0].statePostalCode !=\'NA\'\">{{selectedPoli.winDetails[0].statePostalCode}}</span>\r\n                   <span ng-if=\"selectedPoli.winDetails[0].federalCongressionalDistrict\"> Federal Congressional District </span>\r\n                   {{selectedPoli.winDetails[0].federalCongressionalDistrict}}</span>\r\n         \r\n                 </div> -->\r\n\r\n    </div>\r\n    <br>\r\n<h6>Competitors</h6>\r\n    <div ng-if=\"competitors.length > 0\">\r\n        <div>\r\n          <div ng-repeat=\" d in competitors\">\r\n            <span\r\n              ><b>Name: </b\r\n              ><a href=\"#!/publicProfile/{{d._id}}\" class=\"ylink\">\r\n                {{d.name}}</a\r\n              ></span\r\n            >\r\n    \r\n            <!-- <span ng-if=\"d.email && d.email.length > 0\"> <b>Email:</b> {{d.email[0]}} </span> -->\r\n            <div ng-if=\"d.incumbent == \'incumbent\' || d.incumbent == \'Incumbent\'\">\r\n              <b>Incumbent:</b> Yes\r\n            </div>\r\n            <div ng-if=\"d.incumbent == \'\'\"><b>Incumbent:</b> No</div>\r\n    \r\n            <div ng-if=\"d.runningForOffice == \'Y\'\">\r\n              <b>runningForOffice:</b> Yes\r\n            </div>\r\n            <div ng-if=\"d.runningForOffice == \'N\'\"><b>runningForOffice:</b> No</div>\r\n    \r\n            <div ng-click=\"showVotewiseAns = !showVotewiseAns\"><b>{{d.votewiseAnsCount}}</b> Votewise answers</div>\r\n            <div ng-click=\"showVotesmartAns = !showVotesmartAns\"><b>{{d.votesmartAnsCount}}</b> Votesmart answers</div>\r\n    \r\n            <div\r\n              ng-show=\"d.statement != null\"\r\n              ng-click=\"showStatement = !showStatement\r\n                \"\r\n            >\r\n              <b>1</b> Statement\r\n            </div>\r\n            <div ng-hide=\"showStatement\">{{d.statement}}</div>\r\n            <div ng-if=\"d.statement == null\"><b>0</b> Statement</div>\r\n            <div\r\n              ng-show=\"d.resume != null\"\r\n              ng-click=\"showResume = !showResume\"\r\n            >\r\n              <b>1</b> Resume\r\n            </div>\r\n            <div ng-hide=\"showResume\">{{d.resume}}</div>\r\n            <div ng-if=\"d.resume == null\"><b>0</b> Resume</div>\r\n            <div ng-if=\"d.lastLogin && d.lastLogin != \'\'\">\r\n              <b>Last Logged in</b> {{d.lastLogin}}\r\n            </div>\r\n            <div ng-if=\"selectedPoli.officeType ==\'runningForOffice\'\">\r\n           <span ng-if=\"d.voterScope == \'placeName\'\"> {{d.place}}</span>\r\n              <span ng-if=\"d.voterScope == \'countyName\'\"> {{d.county}}</span>\r\n              <span ng-if=\"d.voterScope == \'statePostalCode\' && d.state !=\'NA\'\"> {{d.state}}</span>\r\n              <span ng-if=\"d.voterScope == \'All USA\'\"> the United States</span>\r\n              <span ng-if=\"d.voterScope == \'statePostalCode\' && d.state ==\'NA\'\">{{d.statePostalCode}}</span>\r\n              <span ng-if=\"d.voterScope == \'stateHouseofRepresentativesDistrict\'\">  {{d.statePostalCode}} Legislative district {{d.stateHouseofRepresentativesDistrict}}</span>\r\n              <span ng-if=\"d.voterScope == \'stateSenateDistrict\' && d.state !=\'NA\'\"> {{d.state}} State district {{d.stateSenateDistrict}}</span>\r\n              <span ng-if=\"d.voterScope == \'stateSenateDistrict\' && d.state ==\'NA\'\">{{d.statePostalCode}}</span>\r\n              <span ng-if=\"d.voterScope == \'federalCongressionalDistrict\'\">,<span ng-if=\"d.state !=\'NA\'\">{{d.state}}</span>\r\n              <span ng-if=\"d.state ==\'NA\' && d.statePostalCode !=\'NA\'\">{{d.statePostalCode}}</span>\r\n              <span ng-if=\"d.federalCongressionalDistrict\"> Federal Congressional District </span>\r\n              {{d.federalCongressionalDistrict}}</span>\r\n    \r\n            </div>\r\n    \r\n            <div ng-if=\"selectedPoli.officeType ==\'inOffice\'\">\r\n              <span ng-if=\"d.winDetails[0].voterScope == \'placeName\'\"> {{d.winDetails[0].place}}</span>\r\n                 <span ng-if=\"d.winDetails[0].voterScope == \'countyName\'\">{{d.winDetails[0].county}}</span>\r\n                 <span ng-if=\"d.winDetails[0].voterScope == \'statePostalCode\'\">  {{d.winDetails[0].statePostalCode}}</span>\r\n                 <span ng-if=\"d.winDetails[0].voterScope == \'All USA\'\"> the United States</span>\r\n                 <span ng-if=\"d.winDetails[0].voterScope == \'statePostalCode\' && d.winDetails[0].state ==\'NA\'\">{{d.winDetails[0].statePostalCode}}</span>\r\n                 <span ng-if=\"d.winDetails[0].voterScope == \'stateHouseofRepresentativesDistrict\'\"> {{d.winDetails[0].statePostalCode}} Legislative district {{d.winDetails[0].stateHouseofRepresentativesDistrict}}</span>\r\n                 <span ng-if=\"d.winDetails[0].voterScope == \'stateSenateDistrict\' && d.winDetails[0].state !=\'NA\'\"> {{d.winDetails[0].statePostalCode}} State district {{d.winDetails[0].stateSenateDistrict}}</span>\r\n                 <span ng-if=\"d.winDetails[0].voterScope == \'stateSenateDistrict\' && d.winDetails[0].state ==\'NA\'\">{{d.winDetails[0].statePostalCode}}</span>\r\n                 <span ng-if=\"d.winDetails[0].voterScope == \'federalCongressionalDistrict\'\">,<span>{{d.winDetails[0].statePostalCode}}</span>\r\n                 <span ng-if=\"d.winDetails[0].state ==\'NA\' && d.winDetails[0].statePostalCode !=\'NA\'\">{{d.winDetails[0].statePostalCode}}</span>\r\n                 <span ng-if=\"d.winDetails[0].federalCongressionalDistrict\"> Federal Congressional District </span>\r\n                 {{d.winDetails[0].federalCongressionalDistrict}}</span>\r\n       \r\n               </div>\r\n    \r\n               <div ng-if=\"d.populationData && d.populationData.state\">\r\n                Most populace City: {{d.populationData.place}} ( {{d.populationData.population}} )\r\n               </div>\r\n    \r\n           \r\n            <div ng-hide=\"showVotesmartAns\">\r\n              <fieldset class=\"scheduler-border\" ng-if=\"d.votesmartAns.length > 0\">\r\n               \r\n                <legend class=\"scheduler-border\">Answers</legend>\r\n                <div\r\n                  class=\"questionAnswersBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\"\r\n                  style=\"width: 100%\"\r\n                >\r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-12\">\r\n                      <br />\r\n                      <div ng-repeat=\"com in d.votesmartAns track by $index\">\r\n                        <div class=\"pad10\">\r\n                         \r\n                          <div ng-if=\"com.content\">Question {{com.content}}</div>\r\n                          <br />\r\n                          <span>Answer</span>\r\n                          <br />\r\n                          <div\r\n                            class=\"clearfix\"\r\n                            style=\"line-height: 15px; display: inline-flex\"\r\n                          >\r\n                            <div\r\n                              ng-repeat=\"i in [1,2,3,4,5,6]\"\r\n                              class=\"mb5 clearfix\"\r\n                              style=\"padding-left: 8px; line-height: 15px\"\r\n                            >\r\n                              <span\r\n                                class=\"inl-blk pull-left\"\r\n                                ng-if=\"i == 1\"\r\n                                style=\"margin-right: 10px\"\r\n                                >AGREE</span\r\n                              >\r\n                              <div\r\n                                class=\"cq-box inl-blk pull-left\"\r\n                                ng-class=\"(com.answer == i) ? getComapreClass(com.answer, i) : \'\'\"\r\n                              ></div>\r\n                              <span\r\n                                class=\"inl-blk\"\r\n                                ng-if=\"i == 6\"\r\n                                style=\"padding-left: 8px\"\r\n                                >DISAGREE</span\r\n                              >\r\n                            </div>\r\n                          </div>\r\n                          <br />\r\n                          <p></p>\r\n                          <span>IMPORTANCE</span>\r\n                          <br />\r\n                          <div\r\n                            class=\"clearfix\"\r\n                            style=\"line-height: 15px; display: inline-flex\"\r\n                          >\r\n                            <div\r\n                              ng-repeat=\"i in [1,2,3]\"\r\n                              class=\"mb5 clearfix\"\r\n                              style=\"padding-left: 8px; line-height: 9px\"\r\n                            >\r\n                              <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n                              <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                              <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n                              <div\r\n                                class=\"cq-box inl-blk pull-right\"\r\n                                style=\"margin-left: 8px\"\r\n                                ng-class=\"(com.Importance == i) ? \'ag-blk\' : \'\'\"\r\n                              ></div>\r\n                            </div>\r\n                          </div>\r\n                          <p></p>\r\n                          <div>\r\n                            <span ng-if=\"com.comment\">Comment:</span>\r\n                            <span ng-if=\"com.comment\">{{com.comment}}</span>\r\n                          </div>\r\n                          <div ng-if=\"com.answer_descriptive && com.answer_descriptive !=\'\'\">\r\n                            Text Ans:- {{com.answer_descriptive}}\r\n                          </div>\r\n                          <hr\r\n                            style=\"\r\n                              margin-left: auto;\r\n                              margin-right: auto;\r\n                              height: 1px;\r\n                              background-color: #666;\r\n                              opcaity: 0.5;\r\n                            \"\r\n                          />\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n            </div>\r\n    \r\n            <div ng-hide=\"showVotewiseAns\">\r\n              <fieldset class=\"scheduler-border\">\r\n                <legend class=\"scheduler-border\">Answers</legend>\r\n                <div\r\n                  class=\"questionAnswersBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\"\r\n                  style=\"width: 100%\"\r\n                >\r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-12\">\r\n                      <br />\r\n                      <div ng-repeat=\"com in d.votewiseAns track by $index\">\r\n                        <div class=\"pad10\">\r\n                          <div ng-if=\"com.content\">Question {{com.content}}</div>\r\n                          <br />\r\n                          <span>Answer</span>\r\n                          <br />\r\n                          <div\r\n                            class=\"clearfix\"\r\n                            style=\"line-height: 15px; display: inline-flex\"\r\n                          >\r\n                            <div\r\n                              ng-repeat=\"i in [1,2,3,4,5,6]\"\r\n                              class=\"mb5 clearfix\"\r\n                              style=\"padding-left: 8px; line-height: 15px\"\r\n                            >\r\n                              <span\r\n                                class=\"inl-blk pull-left\"\r\n                                ng-if=\"i == 1\"\r\n                                style=\"margin-right: 10px\"\r\n                                >AGREE</span\r\n                              >\r\n                              <div\r\n                                class=\"cq-box inl-blk pull-left\"\r\n                                ng-class=\"(com.answer == i) ? getComapreClass(com.answer, i) : \'\'\"\r\n                              ></div>\r\n                              <span\r\n                                class=\"inl-blk\"\r\n                                ng-if=\"i == 6\"\r\n                                style=\"padding-left: 8px\"\r\n                                >DISAGREE</span\r\n                              >\r\n                            </div>\r\n                          </div>\r\n                          <br />\r\n                          <p></p>\r\n                          <span>IMPORTANCE</span>\r\n                          <br />\r\n                          <div\r\n                            class=\"clearfix\"\r\n                            style=\"line-height: 15px; display: inline-flex\"\r\n                          >\r\n                            <div\r\n                              ng-repeat=\"i in [1,2,3]\"\r\n                              class=\"mb5 clearfix\"\r\n                              style=\"padding-left: 8px; line-height: 9px\"\r\n                            >\r\n                              <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n                              <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                              <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n                              <div\r\n                                class=\"cq-box inl-blk pull-right\"\r\n                                style=\"margin-left: 8px\"\r\n                                ng-class=\"(com.importance == i) ? \'ag-blk\' : \'\'\"\r\n                              ></div>\r\n                            </div>\r\n                          </div>\r\n                          <p></p>\r\n                          <div>\r\n                            <span ng-if=\"com.comment\">Comment:</span>\r\n                            <span ng-if=\"com.comment\">{{com.comment}}</span>\r\n                          </div>\r\n                          <hr\r\n                            style=\"\r\n                              margin-left: auto;\r\n                              margin-right: auto;\r\n                              height: 1px;\r\n                              background-color: #666;\r\n                              opcaity: 0.5;\r\n                            \"\r\n                          />\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n            </div>\r\n            <hr />\r\n          </div>\r\n        </div>\r\n      </div>\r\n</div>");
$templateCache.put("app/showFbMessage/showFbMessage.html","<div class=\"container-fluid\">\r\n	\r\n  <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n    <div class=\"blockLink\">\r\n      <div class=\"showFollQuizDetails gettingStartedBlock1\">\r\n        <div>\r\n          <p class=\"gettingStartedBlockDesc\">Post this quiz to Facebook so others can take it and see how you match up.  You can choose to make any answer of yours private so it won’t be shared with others.  After your friends have taken the quiz, you can compare side by side.  Start conversations about the changes you want to see in the world.</p>\r\n    <center>\r\n      <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"next()\">\r\n       Next\r\n       </button>\r\n      <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"cancel()\">\r\n       Cancel\r\n       </button>\r\n    </center>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/showFollowersQuiz/showFollowersQuiz.html","<div class=\"container-fluid\">\r\n  <h2 class=\"pageHeading\">INVITATION ONLY QUIZ</h2>\r\n  <p class=\"pageSubHeading\">You have been invited by <span style=\"text-transform: capitalize\";>{{orgName}}</span> to\r\n    answer their quiz.</p>\r\n\r\n  <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n    <div ng-click=\"getQuiz()\" class=\"blockLink\"><img ng-src=\"./assets/images/quiz.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"showFollQuizDetails gettingStartedBlock1\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\" style=\"text-transform: uppercase;\"><b>{{quizName}}</b></h4>\r\n          <p class=\"gettingStartedBlockDesc\">This quiz is <b>{{totalQues}}</b> questions long. </p>\r\n          <p ng-show=\"ansQues\">You have already answered\r\n            <b>{{ansQues}}</b> of the\r\n            questions they chose to include their quiz. </p>\r\n          <p>If you run accross a question which you think is important, but you have a reason not to share with\r\n            <b style=\"text-transform: capitalize;\">{{orgName}}</b>, uncheck the box that says \"share\" and your answer\r\n            will still join the voices of the many other anonymous voices on VoteWise. Your answer will still be used by\r\n            politicians and other organizations to figure out the best ways to help your community, but they won\'t be\r\n            part of the polling data in this particular quiz.</p>\r\n\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <center>\r\n      <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"getQuiz()\">\r\n                           Take Quiz\r\n       </button>\r\n\r\n    </center>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/showGroupAnswer/showGroupAnswer.html","<div class=\"container-fluid\" ng-controller=\"showGroupAnswerCtrl\">\r\n  <h5>Answer</h5>\r\n  <div ng-if=\"showPoliAnswerDetails\">\r\n    <div>\r\n      <!--     <a href=\"\" class=\"ylink\" style=\"padding-left: 10%\" ng-click=\"back()\">Back</a>  -->\r\n    </div>\r\n    <div class=\"hideCell\">\r\n      <fieldset class=\"scheduler-border\">\r\n        <legend class=\"scheduler-border\">Answers</legend>\r\n        <div class=\"questionAnswersBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\" style=\"width: 100%\">\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n              <br>\r\n              <div ng-repeat=\"com in globalArray[queId] track by $index\">\r\n                <div class=\"pad10\">\r\n                  <!-- <span ng-if=\"com.author.username && com.author.userType != \'voter\'\">Name:</span>\r\n                <a href=\"#!/publicProfile/{{com.author._id}}\" class=\"link\" ng-if=\"com.author.username && com.author.userType != \'voter\'\"> {{com.author.username}}</a> -->\r\n                  <span>Name:</span>\r\n                  <a href=\"#!/publicProfile/{{com.author._id}}\" class=\"link\" ng-if=\"com.author.name && com.author.userType != \'voter\' && com.author.userType == \'politician\'\" style=\"text-transform: capitalize;\"><img ng-src=\"../assets/images/profile/politician.svg\" alt=\"Politician\"  class=\"usertype\"> {{com.author.name}}</a>\r\n                  <a href=\"#!/pressProfile/{{com.author._id}}\" class=\"link\" ng-if=\"com.author.userType == \'advocate\'\" style=\"text-transform: capitalize;\"><img ng-src=\"../assets/images/profile/advocate.svg\" class=\"usertype\" alt=\"Advocate\">{{com.orgName}}</a>\r\n                  <span ng-if=\"com.author.name && com.author.userType == \'voter\'\" style=\"text-transform: capitalize;\"><img ng-src=\"../assets/images/profile/voter.svg \" alt=\"Voter\" class=\"usertype \"> voter {{$index+1}}</span>\r\n                  <!--     <span ng-if=\"com.author.username && com.author.userType != \'politician\' && com.author.userType != \'advocate\' \">Name:\r\n                  voter {{$index+1}}</span>  -->\r\n                  <br>\r\n                  <span>Answer</span>\r\n                  <br>\r\n                  <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n\r\n                    <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n                      style=\"padding-left: 8px;  line-height: 15px\">\r\n                      <span class=\"inl-blk pull-left\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n                      <div class=\"cq-box inl-blk pull-left\"\r\n                        ng-class=\"(com.answer == i) ? getComapreClass(com.match, i) : \'\'\"></div>\r\n                      <span class=\"inl-blk\" ng-if=\"i == 6\" style=\"padding-left:8px\">DISAGREE</span>\r\n                    </div>\r\n                  </div>\r\n                  <br>\r\n                  <p></p>\r\n                  <span>IMPORTANCE</span>\r\n                  <br>\r\n                  <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n                    <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"padding-left: 8px; line-height: 9px\">\r\n                      <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n                      <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                      <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n                      <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                        ng-class=\"(com.importance == i) ? \'ag-blk\' : \'\'\"></div>\r\n                    </div>\r\n                  </div>\r\n                  <p></p>\r\n                  <div>\r\n                    <span ng-if=\"com.comment\">Comment:</span>\r\n                    <span ng-if=\"com.comment\">{{com.comment}}</span>\r\n                  </div>\r\n                  <hr style=\"\r\n                margin-left: auto;\r\n                margin-right: auto;\r\n                height: 1px;\r\n                background-color:#666;\r\n                opcaity: 0.5;\">\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </fieldset>\r\n			</div></div>\r\n      <div ng-if=\"showUserAnswerDetails\">\r\n        <div>\r\n          <!--      <a href=\"\" class=\"ylink\" style=\"padding-left: 10%\" ng-click=\"back()\">Back</a> -->\r\n        </div>\r\n        <fieldset class=\"scheduler-border\">\r\n          <legend class=\"scheduler-border\">Answers</legend>\r\n          <div class=\"questionAnswersBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\"\r\n            style=\"width: 100%\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-12\">\r\n                <br>\r\n                <div ng-repeat=\"item in unVeriCommNew[queId] track by $index\">\r\n                  <div class=\"pad10\">\r\n                    <span ng-if=\"item.answer\">Name: </span><b>Unregistered User {{$index+1}}</b>\r\n                    <br>\r\n                    <span>Answer</span>\r\n                    <br>\r\n                    <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n                      <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n                        style=\"padding-left: 8px;  line-height: 15px\">\r\n                        <span class=\"inl-blk pull-left\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n                        <div class=\"cq-box inl-blk pull-left\"\r\n                          ng-class=\"(item.answer == i) ? getComapreClass(item.match, i) : \'\'\"></div>\r\n                        <span class=\"inl-blk\" ng-if=\"i == 6\" style=\"padding-left:8px\">DISAGREE</span>\r\n                      </div>\r\n                    </div>\r\n                    <br>\r\n                    <p></p>\r\n                    <span>IMPORTANCE</span>\r\n                    <br>\r\n                    <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n                      <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"padding-left: 8px;  line-height: 15px \">\r\n                        <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n                        <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                        <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n                        <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                          ng-class=\"(item.importance == i) ? \'ag-blk\' : \'\'\"></div>\r\n                      </div>\r\n                    </div>\r\n                    <p></p>\r\n                    <div>\r\n                      <span ng-if=\"item.comment\">Comment:</span>\r\n                      <span ng-if=\"item.comment\" style=\"font-size: 16px;font-weight: 200\">{{item.comment}}</span>\r\n                    </div>\r\n                    <hr style=\"\r\n                margin-left: auto;\r\n                margin-right: auto;\r\n                height: 1px;\r\n                background-color:#666;\r\n                opcaity: 0.5;\">\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </fieldset>\r\n      </div>\r\n    </div>\r\n    <div class=\"hideNonCell\">\r\n\r\n      <div class=\"questionAnswersBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\" style=\"width: 100%\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <br>\r\n            <div ng-repeat=\"com in globalArray[queId] track by $index\">\r\n              <div class=\"pad10\">\r\n                <!-- <span ng-if=\"com.author.username && com.author.userType != \'voter\'\">Name:</span>\r\n                <a href=\"#!/publicProfile/{{com.author._id}}\" class=\"link\" ng-if=\"com.author.username && com.author.userType != \'voter\'\"> {{com.author.username}}</a> -->\r\n                <span ng-if=\"com.author.name && com.author.userType != \'voter\'\">Name:</span>\r\n                <a href=\"#!/publicProfile/{{com.author._id}}\" class=\"link\" ng-if=\"com.author.name && com.author.userType != \'voter\'\"> {{com.author.name}}</a>\r\n                <span ng-if=\"com.author.username && com.author.userType != \'politician\' && com.author.userType != \'advocate\' \">Name:\r\n                  voter {{$index+1}}</span>\r\n                <br>\r\n                <span>Answer</span>\r\n                <br>\r\n                <span style=\"float: left;\">AGREE</span>\r\n                <span style=\"float:right; padding-right: 20px;\">DISAGREE</span>\r\n                <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n                  <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n                    style=\"padding-left: 8px;  line-height: 15px\">\r\n                    <div class=\"cq-box inl-blk pull-left\"\r\n                      ng-class=\"(com.answer == i) ? getComapreClass(com.match, i) : \'\'\"></div>\r\n                  </div>\r\n                </div>\r\n                <br>\r\n                <p></p>\r\n                <span>IMPORTANCE</span>\r\n                <br>\r\n                <center>Not Very &nbsp;&nbsp;|&nbsp;&nbsp;Somewhat&nbsp;&nbsp;|&nbsp;&nbsp;Very</center>\r\n                <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n                  <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"padding-left: 8px; line-height: 9px\">\r\n\r\n                    <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                      ng-class=\"(com.importance == i) ? \'ag-blk\' : \'\'\"></div>\r\n                  </div>\r\n                </div>\r\n                <p></p>\r\n                <div>\r\n                  <span ng-if=\"com.comment\">Comment:</span>\r\n                  <span ng-if=\"com.comment\">{{com.comment}}</span>\r\n                </div>\r\n                <hr style=\"\r\n                margin-left: auto;\r\n                margin-right: auto;\r\n                height: 1px;\r\n                background-color:#666;\r\n                opcaity: 0.5;\">\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n\r\n      <div ng-if=\"showUserAnswerDetails\">\r\n        <div>\r\n          <!--      <a href=\"\" class=\"ylink\" style=\"padding-left: 10%\" ng-click=\"back()\">Back</a>  -->\r\n        </div>\r\n        <fieldset class=\"scheduler-border\">\r\n          <legend class=\"scheduler-border\">Answers</legend>\r\n          <div class=\"questionAnswersBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\"\r\n            style=\"width: 100%\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-12\">\r\n                <br>\r\n                <div ng-repeat=\"item in unVeriCommNew[queId] track by $index\">\r\n                  <div class=\"pad10\">\r\n                    <span ng-if=\"item.answer\">Name: </span><b>Unregistered User {{$index+1}}</b>\r\n                    <br>\r\n                    <span>Answer</span>\r\n                    <br><span style=\"float: left;\">AGREE</span>\r\n                    <span style=\"float:right; padding-right: 20px;\">DISAGREE</span>\r\n                    <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n                      <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n                        style=\"padding-left: 8px;  line-height: 15px\">\r\n                        <div class=\"cq-box inl-blk pull-left\"\r\n                          ng-class=\"(item.answer == i) ? getComapreClass(item.match, i) : \'\'\"></div>\r\n\r\n                      </div>\r\n                    </div>\r\n                    <br>\r\n                    <p></p>\r\n                    <span>IMPORTANCE</span>\r\n                    <br>\r\n                    <center>Not Very &nbsp;&nbsp;|&nbsp;&nbsp;Somewhat&nbsp;&nbsp;|&nbsp;&nbsp;Very</center>\r\n                    <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n                      <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"padding-left: 8px;  line-height: 15px \">\r\n\r\n                        <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                          ng-class=\"(item.importance == i) ? \'ag-blk\' : \'\'\"></div>\r\n                      </div>\r\n                    </div>\r\n                    <p></p>\r\n                    <div>\r\n                      <span ng-if=\"item.comment\">Comment:</span>\r\n                      <span ng-if=\"item.comment\" style=\"font-size: 16px;font-weight: 200\">{{item.comment}}</span>\r\n                    </div>\r\n                    <hr style=\"\r\n                margin-left: auto;\r\n                margin-right: auto;\r\n                height: 1px;\r\n                background-color:#666;\r\n                opcaity: 0.5;\">\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </fieldset>\r\n      </div>\r\n    </div>\r\n  </div>\r\n");
$templateCache.put("app/showHideAns/showHideAns.html","<div class=\"container-fluid\">\r\n  <h2 class=\"pageHeading\" style=\"text-transform: capitalize;\">REVIEW</h2>\r\n  <div class=\"pageSubHeading\">Review your answers and choose to hide the ones you don\'t want to share. The default is to\r\n    show everything. </div>\r\n  <div ng-if=\"allQuestions.length > 0\">\r\n\r\n	 <center>\r\n    <div ng-if=\"showLoader\" style=\"z-index: 2; background:black;\"><i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span></div>\r\n\r\n  </center>\r\n    <table class=\"w100 blackText\">\r\n      <tr>\r\n        <th>&nbsp;#&nbsp;</th>\r\n        <th>Question</th>\r\n        <th>&nbsp;&nbsp;Answer&nbsp;&nbsp;</th>\r\n        <th>Importance</th>\r\n        <th width=\"10%\">Share/Hide</th>\r\n      </tr>\r\n      <tr ng-repeat=\"q in allQuestions track by $index\"\r\n        ng-init=\"q.my_answer.show!=\'N\'? switchStatus[$index]=true: switchStatus[$index]=false;\">\r\n        <td>\r\n          {{$index + 1}}\r\n        </td>\r\n        <td style=\"text-align:left; padding-left: 10px; padding-right: 5px;\">\r\n          {{q.content}}\r\n        </td>\r\n        <td style=\"padding-left: 10px; padding-right: 5px;\">\r\n          {{AnswerArray[q.my_answer.answer]}}\r\n        </td>\r\n        <td style=\"padding-left: 10px; padding-right: 5px;\">\r\n          {{AnswerImpArray[q.my_answer.importance]}}\r\n        </td>\r\n        <td>\r\n          <!-- <div toggle-switch class=\"switch-small\" on-label=\"Show\" off-label=\"Hide\" ng-model=\"switchStatus\"></div> -->\r\n          <toggle-switch ng-model=\"switchStatus[$index]\" class=\"switch-small\" on-label=\"Share\" off-label=\"Hide\"\r\n            ng-change=\"switchFilters(switchStatus, $index, q)\">\r\n          </toggle-switch><br>\r\n          <span ng-if=\"switchStatus[$index] == false\">Will Share</span><span ng-if=\"switchStatus[$index] == true\">Will Hide</span>\r\n        </td>\r\n      </tr>\r\n    </table>\r\n\r\n    <!--  -->\r\n  </div>\r\n  <br>\r\n  <center>\r\n    <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"next()\">\r\n       Next\r\n       </button>\r\n    <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"cancel()\">\r\n       Cancel\r\n       </button>\r\n  </center>\r\n</div>\r\n");
$templateCache.put("app/showListOfMatch/showListOfMatch.html","<style type=\"text/css\">\r\n  .digDeeperSmall {\r\n    width: 150px;\r\n  }\r\n</style>\r\n<div class=\"container-fluid\">\r\n\r\n  <center>\r\n    <h2>Match</h2>\r\n  </center>\r\n  <center>\r\n    <h1>{{quizTitle}}</h1>\r\n  </center>\r\n  <div ng-if=\"questions.length == 0\" class=\"fwb\">\r\n    <center>No unanswered questions found.</center>\r\n  </div>\r\n  <div ng-if=\"loader\" class=\"fwb\">\r\n    Loading data ...\r\n    <p>\r\n      <center><i class=\"fa fa-refresh fa-spin\" style=\"font-size:72px;\"></i></center>\r\n    </p>\r\n  </div>\r\n\r\n  <div style=\"text-align:left;\">\r\n    <div ng-if=\"questions.length > 0\">\r\n      <div class=\"squareBoxY\" style=\"margin-left:10px;\">&nbsp;</div>\r\n      <span>= Simple Comparison by answers alone.</span>\r\n      <div style=\"clear:both;\"></div>\r\n      <div class=\"squareBoxB\" style=\"margin-left:10px\">&nbsp;</div>\r\n      <span>= Weighted Comparison by answers and importance.</span>\r\n      <div style=\"clear:both;\"></div>\r\n    </div>\r\n\r\n    <ul class=\"catList\" ng-if=\"questions.length > 0\">\r\n      <li ng-repeat=\"frd in AllUsers track by $index\" ng-if=\"FBunWeighted[frd._id] && fbcombinedWeight[frd._id]\">\r\n        <div style=\"background-color:#ffffee; padding:10px;\">\r\n          <div style=\"color: #000000;\">\r\n            <b><div ng-repeat=\"fd in frd.politicianInfo\" ng-if=\"fd.candidateStatus==\'Running\'|| fd.candidateStatus==\'Announced\'\"><span style=\"text-transform: capitalize;\">{{fd.officeName}}</span></div></b><b ng-if=\"frd.userType == \'politician\'\"><a href=\"#!/publicProfile/{{frd._id}}/false\" style=\"text-transform: capitalize;\" class=\"link\">{{frd.name}}</a></b><b ng-if=\"frd.userType == \'advocate\'\">\r\n             <a href=\"#!/pressProfile/{{frd._id}}\" style=\"text-transform: capitalize;\" class=\"link\"> {{orgNames[frd._id]}}</a></b>\r\n			<!--								<b ng-if=\"frd.userType == \'advocate\' && orgNames[frd._id]==\'\'\">\r\n             Unconfirmed Org</b>  -->\r\n											&nbsp;&nbsp;&nbsp;Total\r\n            Answered questions: {{fbqlen[frd._id]}}\r\n\r\n          </div>\r\n          <div style=\"width: 84%; float:left;\">\r\n            <div>\r\n              <div class=\"fbunweighted\" style=\"width:{{(FBunWeighted[frd._id] / fbqlen[frd._id] )  | number:2}}%\">\r\n                {{(FBunWeighted[frd._id] / fbqlen[frd._id] ) | number:2}}% Match</div>\r\n            </div>\r\n            <div>\r\n              <div class=\"fbweighted\"\r\n                style=\"width:{{(fbcombinedWeight[frd._id] / fbmultiplier[frd._id])  | number:2}}%\">\r\n                {{(fbcombinedWeight[frd._id] / fbmultiplier[frd._id]) | number:2}}% Weighted Match</div>\r\n            </div>\r\n          </div>\r\n          <div style=\"clear:both;\"></div>\r\n        </div>\r\n      </li>\r\n    </ul>\r\n  </div>\r\n");
$templateCache.put("app/showMelisaData/showMelisaData.html","<div class=\"container-fluid\">\r\n  <div ng-if=\"result.length > 0\">\r\n    <div class=\"contactBlock d-flex justify-center container-fluid col-sm-12 col-lg-7\">\r\n\r\n      <div style=\"padding:20px;\">\r\n        <div ng-repeat=\"itm in result track by $index\">\r\n          <div ng-if=\"itm.politicianName\">Name:-\r\n            {{itm.politicianName}} </div>\r\n          <div ng-if=\"itm.address.mailingAddress\">Address:- {{itm.address.mailingAddress}}</div>\r\n          <!-- <div ng-if=\"itm.PostalCode\">PostalCode:- {{itm.PostalCode}}</div> -->\r\n          <div ng-if=\"itm.address.state\">State:- {{itm.address.state}}</div>\r\n          <div ng-if=\"itm.address.county\">County:- {{itm.address.county}}</div>\r\n          <div ng-if=\"itm.address.countyFips\">CountyFIPS:- {{itm.address.countyFips}} </div>\r\n          <div ng-if=\"itm.address.countySubdivision\">CountySubdivisionName:- {{itm.address.countySubdivision}}</div>\r\n          <div ng-if=\"itm.address.countySubdivisionFips\">CountySubdivisionCode:- {{itm.address.countySubdivisionFips}}\r\n          </div>\r\n          <div ng-if=\"itm.address.place\">City:- {{itm.address.place}}</div>\r\n          <div ng-if=\"itm.address.placeFips\">PlaceCode:- {{itm.address.placeFips}} </div>\r\n          <div ng-if=\"itm.address.federalCongrassionalDist\">CongressionalDistrict:-\r\n            {{itm.address.federalCongrassionalDist}}</div>\r\n          <div ng-if=\"itm.address.schoolDistrict\">UnifiedSchoolDistrictName:- {{itm.address.schoolDistrict}}\r\n          </div>\r\n          <div ng-if=\"itm.address.schoolDistrictFips\">UnifiedSchoolDistrictCode:- {{itm.address.schoolDistrictFips}}\r\n          </div>\r\n          <div ng-if=\"itm.address.stateSenateDistrict\">stateSenateDistrict:- {{itm.address.stateSenateDistrict}}</div>\r\n          <hr style=\"border-top: 1px solid #222;\" /><br>\r\n            </div>\r\n\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n");
$templateCache.put("app/showMessage/showMessage.html","<div class=\"container-fluid\">\r\n	<h2 class=\"pageHeading\" style=\"text-transform: capitalize;\">ERROR!</h2>\r\n  <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n			 <img ng-src=\"./assets/images/error.svg\" class=\"gettingStartedImg img-fluid\">\r\n    \r\n      <div class=\"showFollQuizDetails gettingStartedBlock1\">\r\n        <div>\r\n          <p class=\"gettingStartedBlockDesc\">Sorry. We do not recognize that as a match to a real person and address. No database is perfect.  For whatever reason, ours does not have a record of the politician you claim to be with that spelling living at that address.  If you contact us, we will try to figure out some other way of confirming your identity.  It will just take longer.<br> Email us at : email@votewise.net <br>Call 70-VoteWise (708)683-9473</p>\r\n\r\n							</div>  </div>\r\n							<img ng-src=\"./assets/images/48666910_l.jpg\" style=\" width:100%;\">\r\n <!--   <div class=\"pageSubHeading\"> -->\r\n\r\n	</div></div>\r\n    \r\n\r\n");
$templateCache.put("app/showPoliAns/showPoliAns.html","<div class=\"container-fluid\">\r\n  <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n\r\n    <div class=\"showQuizDetails gettingStartedBlock2\">\r\n      <div>\r\n\r\n        <p class=\"gettingStartedBlockDesc\"> <b style=\"text-transform: capitalize;\">{{poliName}}</b>, has just answered <b>{{answerQues}}</b> questions in\r\n          your <b>{{totalQuestions}}</b> questions quiz, <b style=\"text-transform: capitalize;\">\"{{qName}}\".</b>\r\n        </p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <center>\r\n    <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"getAnswers()\">\r\n      See Politician Answers\r\n</button>\r\n    <button ng-if=\"polData && polData.length > 0\" class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"gotoList()\">\r\n Compare Politicians Answers\r\n</button>\r\n  </center>\r\n</div>\r\n");
$templateCache.put("app/showPoliQuiz/showPoliQuiz.html","<div class=\"container-fluid\">\r\n  <h2 class=\"pageHeading\">INVITATION ONLY QUIZ</h2>\r\n  <p class=\"pageSubHeading\">You have been invited by <span style=\"text-transform: capitalize\";>{{orgName}}</span> to\r\n    answer their quiz.</p>\r\n\r\n  <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n    <div ng-click=\"getQuiz()\" class=\"blockLink\"><img ng-src=\"./assets/images/quiz.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"showFollQuizDetails gettingStartedBlock1\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\" style=\"text-transform: uppercase;\"><b>{{quizName}}</b></h4>\r\n          <p class=\"gettingStartedBlockDesc\">This quiz is <b>{{totalQues}}</b> questions long. </p>\r\n          <p ng-show=\"ansQues\">You have already answered\r\n            <b>{{ansQues}}</b> of the\r\n            questions that <span style=\"text-transform: capitalize;\">{{orgName}}</span> chose to include their quiz.\r\n          </p>\r\n          <p>As you answer each question, they will be saved and made public. Because the\r\n            world is always changing and new information is always developing, you will probably want to change your\r\n            answers in the future. We give you the ability to change your answers at any time. Users will be able to see\r\n											your old answers and the reasons you gave for changing your position. </p><p>When you get to the end of this quiz,\r\n            an\r\n            email will be sent to <span style=\"text-transform: capitalize;\">{{orgName}}</span> to let them know.</p>\r\n\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <center>\r\n      <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"getQuiz()\">\r\n                         Take Quiz\r\n     </button>\r\n\r\n    </center>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/showPopUp/showPopUp.html","<div class=\"container-fluid\">\r\n\r\n</div>\r\n");
$templateCache.put("app/showVotesmartAnsQues/showVotesmartAnsQues.html","<div class=\"container-fluid\">\r\n\r\n\r\n\r\n  <a href=\"\" ng-click=\"backTo()\" class=\"ylink\">Back</a>\r\n  <fieldset class=\"scheduler-border\">\r\n    <legend class=\"scheduler-border\">Original Question and Answer.</legend>\r\n    <div class=\"billDetailBlock d-flex  container-fluid col-sm-12 col-lg-12\" style=\"width:100%;\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <br>\r\n          <div>\r\n            <p style=\"text-align: center;\">\r\n              <a href=\"https://votesmart.org/\" target=\"_blank\">\r\n                              <image src=\"../assets/images/VoteSmartLogoD.png\" class=\"partners\"></image></a> </p>\r\n            <p>\r\n              <div class=\"p\" ng-repeat=\"d in voteData\" ng-if=\"voteData.length > 0\">\r\n                <div ng-if=\"d.question\"><b>Question:</b> {{d.question}}</div>\r\n                <br>\r\n                <div ng-if=\"d.category\"><b>Category:</b> {{d.category}}</div>\r\n                <br>\r\n                <div ng-if=\"d.userAnswer.answer\"><b>Answer:</b> {{d.userAnswer.answer}}</div>\r\n                <br>\r\n                <div ng-if=\"d.userAnswer.answer_descriptive\"><b>Answer Text:</b> {{d.userAnswer.answer_descriptive}}\r\n                </div>\r\n                <br>\r\n              </div>\r\n              </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n  </fieldset>\r\n</div>\r\n");
$templateCache.put("app/signin/signin.html","<div class=\"voter-signup\">\r\n  <!-- REMOVE THIS ONCE THE SITE IS WORKING --->\r\n\r\n  <!-- <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <img ng-src=\"./assets/images/ProfileSettings3.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock1\">\r\n          <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">SORRY</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Our mail servers enthusiastically sent out the invitations before the website servers had a chance to update.  Please check back at noon (5/16/2019)</p>\r\n\r\n        </div>\r\n      </div>\r\n    </div> -->\r\n\r\n  <!-- REMOVE THIS ONCE THE SITE IS WORKING ^^^^^^^ -->\r\n\r\n\r\n  <!-- <a href=\"#!/welcome\"><img class=\"choice\" ng-src=\"../assets/images/votewiseTop.svg\" alt=\"VoteWise\" /></a> -->\r\n\r\n  <!--<h3 style=\"padding-left: 215px;\">In order to match you with your local politicians, we need to know where you live. </h3>-->\r\n  <!--   COMMENTED OUT 5 15 2019  ERASE THIS LINE  NO TAIL<br> -->\r\n  <div class=\"signin-margin\">\r\n    <div class=\"alert alert-danger\" ng-show=\"Errors.length>0\" role=\"alert\" ng-repeat=\"error in Errors\">\r\n      {{error}}\r\n    </div>\r\n\r\n\r\n    <!--   COMMENTED OUT 5 15 2019  ERASE THIS LINE  NO TAIL -->\r\n    <form name=\"signupform\" id=\"signInform\">\r\n      <fieldset class=\"scheduler-border\">\r\n        <legend class=\"scheduler-border\">Sign In</legend>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel removeTopMargin\" for=\"UserName\">UserName</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"UserName\" placeholder=\"\"\r\n                                    data-errormessage=\"UserName is required.\" class=\"form-control input-md validate[required] text-input\">\r\n                            </div>\r\n              </div>\r\n\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel\" for=\"password\">Password</label>\r\n                <div class=\"controls\">\r\n                  <input type=\"password\" id=\"password\" ng-model=\"Password\" placeholder=\"\"\r\n                                    data-errormessage=\"Password is required.\" class=\"form-control input-md validate[required] text-input\" />\r\n                            </div>\r\n                </div>\r\n              </div>\r\n\r\n              <div style=\"clear: both;\"></div>\r\n              <div class=\"forgetPassButtons\">\r\n                <button ng-click=\"AuthenticateUser()\" type=\"submit\" class=\"formButton btnB275 fullWidth\">Sign In</button>\r\n                <!--<fb:login-button scope=\"public_profile,email\" onlogin=\"checkLoginState();\">\r\n                            </fb:login-button>-->\r\n                <div style=\"clear: both;\"></div>\r\n              </div>\r\n              <div style=\"clear: both;\"></div>\r\n <!--             <div class=\"forgetPassButtons\">\r\n\r\n              <button ng-click=\"OpenLoginPopup()\" type=\"button\" class=\"btnB275 fullWidth\">\r\n                            <i class=\"fa fa-facebook-square formButton\" aria-hidden=\"true\"></i> Sign In With FaceBook</button> \r\n                <fb:login-button scope=\"public_profile,email\" onlogin=\"checkLoginState();\">\r\n                </fb:login-button>\r\n                <div style=\"clear: both;\"></div>\r\n              </div>\r\n-->\r\n              <!--   COMMENTED OUT 5 15 2019  ERASE THIS LINE  NO TAIL -->\r\n              <div style=\"clear: both;\"></div>\r\n              <div class=\"forgetPassButtons\">Don\'t have an account? <br>Please\r\n                <a style=\"text-decoration: underline;\" href=\"#!/signup/voter\" class=\"ylink\" >Sign Up here</a></div>\r\n              <div class=\"forgetPassButtons\">Forgot password? Don\'t worry!\r\n                <br><a style=\"text-decoration: underline;\" href=\"#!/resetPassword\"  class=\"ylink\">Click here</a>\r\n              </div>\r\n            </div>\r\n\r\n      </fieldset>\r\n    </form>\r\n\r\n\r\n\r\n    <!--   COMMENTED OUT 5 15 2019  ERASE THIS LINE  NO TAIL -->\r\n\r\n\r\n    <center class=\"fwb mb10\" ng-if=\"$root.statusAuthenticate == 1\">Signing in...</center>\r\n  </div>\r\n</div>\r\n\r\n<script type=\"text/javascript\">\r\n  jQuery(document).ready(function () {\r\n    // binds form submission and fields to the validation engine\r\n    // binds form submission and fields to the validation engine\r\n    $(\"form\").validationEngine();\r\n  });\r\n\r\n</script>\r\n");
$templateCache.put("app/signin/user-info-popup.html","<div class=\"voter-signup\">\r\n\r\n\r\n    <!--<h3 style=\"padding-left: 215px;\">In order to match you with your local politicians, we need to know where you live. </h3>-->\r\n    <div class=\"alert alert-danger\" ng-show=\"Errors.length>0\" role=\"alert\" ng-repeat=\"error in Errors\">\r\n        {{error}}\r\n    </div>\r\n    <form name=\"userinfoform\" >\r\n        <fieldset class=\"scheduler-border\">\r\n            <a href=\"javascript://\" ng-click=\"cancel()\"><div style=\"float: right;margin-top: -63px;\">x</div></a>\r\n            <legend class=\"scheduler-border\">To continue we need some nucessary information from you.</legend>\r\n            <div class=\"row\">\r\n                <div class=\"col-md-12\">\r\n                    <div class=\"control-group\">\r\n                        <label class=\"control-label\" for=\"UserName\">What type of user you are?</label>\r\n                        <div class=\"controls\">\r\n                            <select type=\"text\" ng-model=\"$parent.UserType\" \r\n                                placeholder=\"\" required class=\"form-control input-md\">\r\n                                <option value=\"Voter\">Voter</option>\r\n                                <option value=\"Advocate\">Organization</option>\r\n                                <option value=\"Press\">Press</option>\r\n                                <option value=\"Politician\">Politician</option>\r\n                            </select>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"control-group\">\r\n                        <label class=\"control-label\" for=\"password\">Please provide your zip code</label>\r\n                        <div class=\"controls\">\r\n                            <input type=\"text\" id=\"zipcode\" ng-model=\"$parent.ZipCode\" \r\n                               placeholder=\"\" class=\"form-control input-md\" required/>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n\r\n                <div style=\"clear: both;\"></div>\r\n                <div class=\"btn-style\">\r\n                    <button ng-click=\"LoginWithFacebook()\" ng-disabled=\"userinfoform.$invalid\" type=\"button\" class=\"btn btn-primary\" style=\"float: right;\">Continue To Facebook Sign In</button>\r\n                    <!--<fb:login-button scope=\"public_profile,email\" onlogin=\"checkLoginState();\">\r\n                            </fb:login-button>-->\r\n                    <div style=\"clear: both;\"></div>\r\n                </div>\r\n\r\n            </div>\r\n\r\n        </fieldset>\r\n    </form>\r\n</div>\r\n\r\n ");
$templateCache.put("app/signup/signup.html"," <div class=\"container-fluid ng-scope\">\r\n		<h2 class=\"pageHeading\">CREATE ACCOUNT</h2>\r\n		<p class=\"pageSubHeading\">If you are a politician, please contact us and we will create an account for you after we have confirmed your identity.</p>\r\n<div class=\"voter-signup\">\r\n  <br>\r\n  <br>\r\n  <div class=\"signup-margin\">\r\n    <div class=\"alert alert-danger\" ng-show=\"Errors.length>0\" role=\"alert\" ng-repeat=\"error in Errors\">\r\n      {{error}}\r\n    </div>\r\n <!--   <fieldset class=\"scheduler-border\" style=\"width: 115%\">\r\n      <legend class=\"scheduler-border\">Sign Up with Email</legend> -->\r\n      <div ng-include=\"\'app/popups/signup_section.html\'\"></div>\r\n<!--    </fieldset>  -->\r\n  </div>\r\n  <script>\r\n    if (document.location.href.search(\"politician\") > 0) {\r\n      //window.onload=function(){\r\n\r\n      //window.alert(document.location.href.search(\"politician\"));\r\n      document.getElementById(\"videoblock\").src = \"https://www.youtube.com/embed/Yx33ZVgs4xo?rel=0\";\r\n      document.getElementById(\"videoblock2\").src = \"https://www.youtube.com/embed/Yx33ZVgs4xo?rel=0\";\r\n    } else if (document.location.href.search(\"advocate\") > 0) {\r\n      document.getElementById(\"videoblock\").src = \"https://www.youtube.com/embed/S1copOipUxY?rel=0\";\r\n      document.getElementById(\"videoblock2\").src = \"https://www.youtube.com/embed/S1copOipUxY?rel=0\";\r\n    }\r\n\r\n\r\n    //else()//(document.location.href.search(\"advocate\"> 0)){\r\n    //document.getElementById(\"videoblock\").src=\"https://www.youtube.com/embed/S1copOipUxY?rel=0\";}\r\n    else {\r\n      document.getElementById(\"videoblock\").src = \"https://www.youtube.com/embed/HrZqeFsbQZk?rel=0\";\r\n    }\r\n\r\n  </script>\r\n");
$templateCache.put("app/signup/verify.html","<div class=\"voter-signup\">\r\n\r\n\r\n    <!--<h3 style=\"padding-left: 215px;\">In order to match you with your local politicians, we need to know where you live. </h3>-->\r\n    <br>\r\n    <div class=\"signup-margin\">\r\n        <form name=\"signupform\" id=\"signupform\">\r\n            <div class=\"alert alert-success\" ng-show=\"Show\">\r\n                Congratulations! Your email address has been successfully verified.\r\n            </div>\r\n            <div class=\"alert alert-danger\" ng-show=\"Error\">\r\n                Something went wrong with the request. Your email address has not been verified, Please try again later.\r\n            </div>\r\n        </form>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/snapshot/snapshot.html","<div ng-if=\"$root.userRole!=\'politician\'\">\r\n	<div>\r\n  <!-- This is the end of the header -->\r\n  <center>\r\n    <h1>Personal Home Page</h1>\r\n  </center>\r\n	<center>\r\n								      <div class=\"col-lg-6 col-sm-12 gettingStartedContainer\">\r\n															<a href=\"#!/fiveMatch/fiveminquiz/\" class=\"blockLink\">\r\n              <img ng-src=\"./assets/images/5minQuizIcon.jpg\" class=\"gettingStartedImg img-fluid\">\r\n               <div class=\"gettingStartedBlock gettingStartedBlock2\">             \r\n                <div>\r\n                  <h5 class=\"blockTitle\">5-MINUTE MATCH</h5>\r\n                  <p class=\"gettingStartedBlockDesc\">\r\n	Click here to take the 5-Minute Match Quiz</p>\r\n\r\n																</div></div></a>\r\n              \r\n	</div>\r\n		<br></center>\r\n<div ng-if=\"$root.userRole!=\'politician\'\"><br><br></div>\r\n\r\n	\r\n  <div class=\"alert alert-success alert-dismissible fade show\" ng-if=\"alert_success\"\r\n    style=\" width:40%; margin-left: 28%\">\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button>\r\n    <strong>Transaction Successfull!</strong>\r\n  </div>\r\n  <div class=\"alert alert-danger alert-dismissible fade show\" ng-if=\"error_alert\"\r\n    style=\"z-index: 15000; width:40%;margin-left: 28%\">\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button>\r\n    <strong>{{st_error}}</strong>\r\n  </div>\r\n\r\n  <div ng-cloak ng-show=\"$root.userRole==\'politician\'\">\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/gettingStartedPol/\" class=\"blockLink\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock1\" style=\"clear: both;\">\r\n          <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">FIRST TIME HERE?</h4>\r\n          <p class=\"gettingStartedBlockDesc\">If this is your first time here, you should check out the Getting Started section (click here or on the tool bar above) Since you are logged in as a politician, tools are laid out and named best for your use.  If you use this site as a voter, the site will look different.</p>\r\n\r\n        </div>\r\n          </div></a></div>\r\n  </div>\r\n\r\n</div>\r\n\r\n<div ng-if=\"!userData.isemailverified\" class=\"boxed\" style=background-color:yellow>\r\n  <br>\r\n  <center>\r\n    <h3><b>NOTE:</b></h3>\r\n  </center>\r\n  <p style=\"color:red\">Because you have not yet verified your email, you won\'t have full access to the site. You will\r\n    be\r\n    able to explore the\r\n    site, and listen in on debates, but you won\'t be able to engage in dabates. Your can take quizzes and see how you\r\n    match with others, but your answers won\'t become part of\r\n    the polling data the politicians use to decide America\'s future. If you can\'t find your confirmation email, try\r\n    checking your spam folder.</p>\r\n\r\n\r\n  <!--   <p> Your voice is important to democracy, so please check your email and confirm as soon as you can. If you are having\r\n        problems with the email confirmation or can\'t wait, sign in with Facebook - it gives instant verification.</p>  -->\r\n  <div>\r\n    <center><button ng-click=\"sendMail()\" class=\"compareBtn\">\r\n            Resend Confirmation Email</button></center>\r\n  </div>\r\n\r\n</div>\r\n<!--\r\n  <div class=\"boxed\">\r\n    <center>\r\n      <h2>News from VoteWise</h2>\r\n    </center>\r\n    <p>VoteWise was only recently launched so we still have a few bugs to work out. Please let us know what problems you see\r\n      so we can fix them. Thank you for your patience. </p>\r\n  </div>\r\n-->\r\n<!--    BRING BACK     Video out of date\r\n  <iframe id=videoblock2 width=\"345\" height=\"194\" src=\"https://www.youtube.com/embed/uYX5irdOLHg?rel=0\" frameborder=\"0\" allowfullscreen\r\n    style=\"padding:10px\"></iframe>\r\n\r\n-->\r\n<div class=\"boxed\">\r\n  <center>\r\n    <a href=\"#!/liveFeed\">\r\n        <h2>News Feed from {{feedtitle}}</h2>\r\n      </a>\r\n  </center>\r\n  <div ng-repeat=\"feed in feed.data | limitTo: 5\">\r\n    <div style=\"width: 100%; position: relative;\">\r\n      <br>\r\n      <a href=\"{{feed.url}}\" target=\"_blank\">\r\n          <img ng-if=\"feed.urlToImage\" ng-src=\"{{feed.urlToImage}}\" width=\"100\" style=\"float:left; margin-right: 10px;\" /> {{feed.title}}\r\n        </a>\r\n      <div style=\"clear: both\"></div>\r\n    </div>\r\n  </div>\r\n  <p>\r\n    <a ng-href=\"https://newsapi.org/\" target=\"_blank\">\r\n        <center>\r\n          <b> Powered by NewsAPI.org</b>\r\n        </center>\r\n      </a>\r\n  </p>\r\n</div>\r\n<div class=\"boxed\" ng-if=\"newData.Topics || newData.Essay \">\r\n  <center>\r\n    <h2>New Forum Posts Since Last Login</h2>\r\n  </center>\r\n  <div>\r\n    <div style=\"width: 100%; position: relative; padding:5px;\" ng-if=\"newData.Topics.length > 0\">\r\n      <div ng-repeat=\"topic in newData.Topics\" style=\"padding:5px;\">\r\n        <a href=\"javascript: void(0);\" ng-click=\"gotoForumTopic(topic);\" ng-if=\"topic.subCategories[0].pid\" style=\"font-weight: bold; text-decoration: underline;\">\r\n            {{topic.title}}\r\n          </a>\r\n        <a href=\"javascript: void(0);\" ng-click=\"gotoForumT(topic);\" ng-if=\"!topic.subCategories[0].pid\" style=\"font-weight: bold; text-decoration: underline;\">\r\n            {{topic.title}}\r\n          </a>\r\n        <div>Posted by\r\n          <span> <img ng-src=\"../assets/images/profile/politician.svg \" ng-if=\"topic.createdBy.utype == \'politician\'\" class=\"usertype \">\r\n    <img ng-src=\"../assets/images/profile/press.svg \" ng-if=\"topic.createdBy.utype == \'press\'\" class=\"usertype \">\r\n    <img ng-src=\"../assets/images/profile/advocate.svg \" ng-if=\"topic.createdBy.utype == \'advocate\'\" class=\"usertype \">\r\n    <img ng-src=\"../assets/images/profile/voter.svg \" ng-if=\"topic.createdBy.utype == \'voter\'\" class=\"usertype \">\r\n    <img ng-src=\"../assets/images/profile/admin.svg \" ng-if=\"topic.createdBy.utype ==\'admin\'\" class=\"usertype \"></span>\r\n          <a href=\"#!/publicProfile/{{topic.createdBy.id}}\" ng-if=\"topic.createdBy.utype==\'politician\'\" style=\"text-transform:capitalize;\">\r\n              <b>{{topic.createdBy.nameOnBallot}}</b>\r\n            </a>\r\n          <a href=\"#!/pressProfile/{{topic.createdBy.id}}\" ng-if=\"topic.createdBy.utype == \'advocate\'\" style=\"text-transform:capitalize;\">\r\n              <b>{{topic.createdBy.orgName}}</b>\r\n           </a>\r\n          <a href=\"#!/voterProfile/{{topic.createdBy.id}}\" ng-if=\"topic.createdBy.utype ==\'voter\'\" style=\"text-transform:capitalize;\">\r\n              <b>{{topic.createdBy.name}}{{topic.createdBy.uname}}</b>\r\n           </a>\r\n          <a href=\"#!/publicProfile/{{topic.createdBy.id}}\" ng-if=\"topic.createdBy.utype==\'admin\'\" style=\"text-transform:capitalize;\">\r\n              <b>{{topic.createdBy.name}}</b>\r\n           </a>\r\n          on {{topic.createdOn | date:\'medium\'}}\r\n        </div>\r\n        <div style=\"clear: both\"></div>\r\n      </div>\r\n    </div>\r\n    <div ng-if=\"newData.Topics.length==0\" style=\"padding:10px; color:red;\">\r\n      <center>\r\n        <b> No new records.</b>\r\n      </center>\r\n    </div>\r\n  </div>\r\n</div>\r\n  <div class=\"boxed\" ng-if=\"newData.Essay.length > 0\">\r\n      <center><h2>New Essays since last login</h2></center>\r\n        <div>\r\n           <div style=\"width: 100%; position: relative;\" ng-if=\"newData.Essay.length > 0\">\r\n                <div  ng-repeat=\"essay in newData.Essay\" style=\"padding:5px;\">\r\n                <a ng-href=\"#!/essayDetails/{{essay.parentCat[0]}}/{{essay._id}}\" style=\"font-weight: bold; text-decoration: underline;\">\r\n                 {{essay.title}}\r\n                 </a>\r\n                 <div> Posted by\r\n                    <a href=\"#!/publicProfile/{{essay.createdBy.id}}\" ng-if=\"essay.createdBy.utype!=\'PressM\'\"><b>{{essay.createdBy.name}}</b></a>\r\n                    <a href=\"#!/pressProfile/{{essay.createdBy.id}}\" ng-if=\"essay.createdBy.utype==\'PressM\'\"><b>{{essay.createdBy.name}}</b></a>\r\n                    <span ng-if=\"essay.createdBy.orgdata\"><b>({{essay.createdBy.orgdata.title}})</b></span> on {{essay.createdOn | date:\'medium\'}}\r\n                </div>\r\n                </div>\r\n                <div style=\"clear: both\"></div>\r\n            </div>\r\n            <div ng-if=\"newData.Essay.length==0\" style=\"padding:10px; color:red;\"><center><b> No new records.</b></center></div>\r\n        </div>\r\n    </div>\r\n    <div class=\"boxed\" ng-if=\"newData.Category.length > 0\">\r\n      <center>\r\n          <h2>New Quizzes Since last login</h2></center>\r\n      <p ng-repeat=\"quiz in newData.Category | limitTo: 5\" ng-if=\"!loadingExtra\">\r\n        <a ng-href=\"#!/question-background/{{quiz.parentIds[0].pid}}/{{quiz._id}}\" style=\"font-weight: bold; text-decoration: underline;\">\r\n          {{quiz.title}}\r\n          </a>\r\n      </p>\r\n              <p ng-if=\"newData.Category.length==0 && !loadingExtra\">No new quizzes available.</p>\r\n      <p ng-if=\"loadingExtra\"><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>Loading data please wait...</p>\r\n  </div>\r\n  <!--   <div class=\"boxed\" ng-if=\"DiscussionData.length > 0\">\r\n        <center>\r\n            <h2>My Discussions</h2></center>\r\n        <p ng-repeat=\"disc in DiscussionData | limitTo: 5\" ng-if=\"!loadingExtra\"> <span ng-click=\"gotoThread(disc, disc.subcategories[0].pid);\" style=\"cursor:pointer; text-decoration: underline;\">{{disc.title}}</span> </p>\r\n        <p ng-if=\"DiscussionData.length==0 && !loadingExtra\">No new discussions available.</p>\r\n        <p ng-if=\"loadingExtra\"><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>Loading data please wait...</p>\r\n    </div>\r\n    <div class=\"boxed\" ng-if=\"HotTopics.length > 0\">\r\n        <center>\r\n            <h2>Hottest Threads</h2></center>\r\n        <p ng-repeat=\"hot in HotTopics\" ng-if=\"!loadingExtra\" \"> <span ng-click=\"gotoThread(hot, hot.subcategories[0].pid); \" style=\"cursor:pointer; text-decoration: underline; \">{{hot.title}}</span> </p>\r\n        <p ng-if=\"HotTopics.length==0 && !loadingExtra \"\">No hottest threads available.</p>\r\n        <p ng-if=\"loadingExtra\"><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>Loading data please wait...</p>\r\n    </div>\r\n-->\r\n<!--\r\n  <div class=\"boxed\" ng-if=\"ActiveThreads.length > 0\">\r\n    <center>\r\n      <h2>Active Threads</h2>\r\n    </center>\r\n    <p ng-repeat=\"act in ActiveThreads\" ng-if=\"!loadingExtra\">\r\n      <span ng-click=\"gotoThread(act, act.subCategories[0].pid);\" style=\"cursor:pointer; text-decoration: underline;\">{{act.title}}</span>\r\n    </p>\r\n    <p ng-if=\"ActiveThreads.length==0 && !loadingExtra\">No active threads available.</p>\r\n    <p ng-if=\"loadingExtra\">\r\n      <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>Loading data please wait...</p>\r\n  </div>\r\n-->\r\n<div class=\"boxed\" ng-if=\"followlist.length > 0\">\r\n  <center>\r\n    <h2>You Are Following</h2>\r\n  </center>\r\n  <p ng-repeat=\"users in followlistData\" ng-if=\"!loadingFollow\">\r\n    <img ng-src=\"../assets/images/profile/politician.svg \" ng-if=\"users.userType == \'politician\'\" class=\"usertype \">\r\n    <img ng-src=\"../assets/images/profile/press.svg \" ng-if=\"users.userType == \'press\'\" class=\"usertype \">\r\n    <img ng-src=\"../assets/images/profile/advocate.svg \" ng-if=\"users.userType == \'advocate\'\" class=\"usertype \">\r\n    <img ng-src=\"../assets/images/profile/voter.svg \" ng-if=\"users.userType == \'voter\'\" class=\"usertype \">\r\n    <img ng-src=\"../assets/images/profile/admin.svg \" ng-if=\"users.userType == \'admin\'\"\r\n        class=\"usertype \">\r\n    <a ng-if=\"users.userType == \'admin\'\" href=\"#!/publicProfile/{{users._id}} \" style=\"text-decoration:underline; \">\r\n        <span>VoteWise Admin</span>\r\n      </a>\r\n    <a ng-if=\"users.userType == \'politician\'\" href=\"#!/publicProfile/{{users._id}} \" style=\"text-decoration:underline; text-transform: capitalize;\">\r\n        <span>{{users.name}}</span>\r\n      </a>\r\n    <a ng-if=\"users.userType == \'voter\'\" href=\"#!/voterProfile/{{users._id}} \" style=\"text-decoration:underline; text-transform: capitalize;\">\r\n        <span>{{users.username}}</span>\r\n      </a>\r\n    <a ng-if=\"users.userType == \'advocate\' || users.userType == \'press\'\" href=\"#!/pressProfile/{{users._id}} \" style=\"text-decoration:underline; text-transform: capitalize;\">\r\n        <!-- <span>{{users.name}}</span>1{{users.orgdata.title}}2{{orgdata.title}}3{{users.title}}4{{press.title}} 5{{users.username}} 6{{users.orgdata.title}}{{users.orgName}}{{users.orgname}} -->\r\n        {{users.orgName}}\r\n      </a>\r\n  </p>\r\n  <p ng-if=\"followlist.length==0 && !loadingFollow \">You are not following any user.</p>\r\n  <p ng-if=\" loadingFollow \"> <i class=\" fa fa-refresh fa-spin fa-1x fa-fw \"></i>Loading data please wait...</p>\r\n</div>\r\n<div class=\" boxed \">\r\n  <center>\r\n    <h2>My Activities</h2>\r\n  </center>\r\n  <div ng-if=\" !ShowPorifleLoading \">\r\n    <p>Question answered: <a href=\"#!/answeredQuestions\" class=\"link\">{{userDetails.totalanswers}}</a></p>\r\n    <p ng-if=\" userDetails.totalthread && userDetails.totalthread >0\">\r\n      Thread created: <a href=\"javascript: void(0);\" ng-click=\"gotoPage(\'Thread\', userDetails.userData)\" class=\"link\">{{userDetails.totalthread}}</a>\r\n    </p>\r\n    <p ng-if=\"userDetails.totalpost && userDetails.totalpost > 0\">\r\n      Total post: <a href=\"javascript: void(0);\" ng-click=\"gotoPage(\'Post\', userDetails.userData)\" class=\"link\">{{userDetails.totalpost}}</a>\r\n    </p>\r\n    <p ng-if=\"userDetails.totalessay && userDetails.totalessay > 0\">\r\n      Essay: <a href=\"javascript: void(0);\" ng-click=\"gotoPage(\'Essay\', userDetails.userData)\" class=\"link\">{{userDetails.totalessay}}</a>\r\n      <p ng-if=\"userDetails.totalessaycomments && userDetails.totalessaycomments > 0\">\r\n        Essay Comments: <a href=\"javascript: void(0);\" ng-click=\"gotoPage(\'EssayComment\', userDetails.userData)\" class=\"link\">{{userDetails.totalessaycomments}}</a>\r\n      </p>\r\n  </div>\r\n  <p ng-if=\"ShowPorifleLoading\">\r\n    <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>Loading data please wait...</p>\r\n</div>\r\n<div class=\" boxed \" ng-if=\"inCompleteQuiz.length > 0 || completedQuiz.length > 0\">\r\n  <center>\r\n    <h2>Saved Quizzes</h2>\r\n  </center>\r\n  <div ng-if=\"!ShowPorifleLoading\"><ul>\r\n			<div ng-if=\"inCompleteQuiz.length<1 || inCompleteQuiz== undefined\"><center>NONE</center></div>\r\n    <div ng-repeat=\"quiz in inCompleteQuiz\">\r\n					<li><a href=\"{{quiz.quizLink}}\" class=\"link\">{{quiz.quizName}}</a></li>\r\n    \r\n			</div></ul>\r\n  <center>\r\n    <h2>Completed Quizzes</h2>\r\n  </center>\r\n  <div ng-if=\"!ShowPorifleLoading\"><ul>\r\n			<div ng-if=\"completedQuiz.length<1 || completedQuiz== undefined\"><center>NONE</center></div>\r\n    <div ng-repeat=\"quiz in completedQuiz\">\r\n      <li> <a href=\"{{quiz.quizLink}}\" class=\"link\">{{quiz.quizName}}</a></li>\r\n					\r\n    </div></ul>\r\n  </div>\r\n	\r\n  <p ng-if=\"ShowPorifleLoading\">\r\n    <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>Loading data please wait...</p>\r\n</div>\r\n<!--\r\n    <div class=\"boxed\">\r\n        <center>\r\n           <h2>My Tags</h2></center>\r\n        <div ng-if=\"!ShowPorifleLoading\">\r\n            <div>\r\n                <div class=\"DisplayCat\">\r\n                    <div style=\"background-color: #eee; padding:5px;\">All Tags\r\n                        <br><small>(click to select)</small></div>\r\n                    <div ng-repeat=\"subent in subtopics.subcategories track by $index\" ng-include=\"\'field_renderer\'\">Loading...</div>\r\n                    <div ng-if=\"subtopics.subcategories.length == 0\" class=\"loadingSpinner\">\r\n                        <i class=\"fa fa-refresh fa-spin fa-3x fa-fw\"></i>\r\n                    </div>\r\n                </div>\r\n                <div class=\"select buttons\" style=\"padding-left: 20px; height:20px;\">&nbsp;</div>\r\n                <br/>\r\n                <div class=\"DisplayCat\">\r\n                    <div style=\"background-color: #eee; padding:5px;\">Selected Tags\r\n                        <br><small>(click to remove)</small></div>\r\n                    <ul class=\"catList\">\r\n                        <li ng-repeat=\"subent in selectedCat track by $index\">\r\n                            <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                                <input type=\"checkbox\" ng-click=\"removeVal(subent)\" name=\"checkedidcat\" ng-model=\"selectedAll.id[$index]\" ng-checked=\"\'true\'\"> {{subent.title}}\r\n                            </label>\r\n                        </li>\r\n                    </ul>\r\n                </div>\r\n                <div style=\"clear:both;\"></div>\r\n                <p style=\"text-align: center;\">\r\n                <input type=\"button\" ng-click=\"saveTags()\" value=\"Save Tags\" />\r\n                </p>\r\n            </div>\r\n        </div>\r\n\r\n        <p ng-if=\"ShowPorifleLoading\"><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>Loading data please wait...</p>\r\n    </div>\r\n-->\r\n<div class=\"boxed\" ng-if=\"NewsPost.length > 0\">\r\n  <center>\r\n    <h2>News Feed</h2>\r\n  </center>\r\n  <p ng-repeat=\"act in NewsPost\" ng-if=\"!loadingNewsExtra\">\r\n    <span ng-click=\"gotoNewsThread(act, act.subCategories[0].pid);\" style=\"cursor:pointer; text-decoration: underline;\">{{act.title}}</span>\r\n  </p>\r\n  <p ng-if=\"NewsPost.length==0 && !loadingExtra\">There are no news available.</p>\r\n  <p ng-if=\"loadingNewsExtra\">\r\n    <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>Loading data please wait...</p>\r\n</div>\r\n<div class=\"boxed\" ng-if=\"recommended.length > 0\">\r\n  <center>\r\n    <h2>Movies Recommended</h2>\r\n  </center>\r\n  <p ng-repeat=\"recomend in recommended\" ng-if=\"!loadingNewsExtra && recomend.type==\'movie\'\"> {{recomend.name}}</p>\r\n  <p ng-if=\"recommended.length==0 && !loadingExtra\">There are no recommended movies for you.</p>\r\n  <p ng-if=\"loadingNewsExtra\">\r\n    <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>Loading data please wait...</p>\r\n</div>\r\n<div class=\"boxed\" ng-if=\"recommended.length > 0\">\r\n  <center>\r\n    <h2>Books Recommended</h2>\r\n  </center>\r\n  <p ng-repeat=\"recomend in recommended\" ng-if=\"!loadingNewsExtra && recomend.type==\'book\'\"> {{recomend.name}}</p>\r\n  <p ng-if=\"recommended.length==0 && !loadingExtra\">There are no recommended books for you.</p>\r\n  <p ng-if=\"loadingNewsExtra\">\r\n    <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>Loading data please wait...</p>\r\n</div>\r\n<div class=\"boxed\" ng-if=\"recommended.length > 0\">\r\n  <center>\r\n    <h2>Music Recommended</h2>\r\n  </center>\r\n  <p ng-repeat=\"recomend in recommended\" ng-if=\"!loadingNewsExtra && recomend.type==\'music\'\"> {{recomend.name}}</p>\r\n  <p ng-if=\"recommended.length==0 && !loadingExtra\">There are no recommended music for you.</p>\r\n  <p ng-if=\"loadingNewsExtra\">\r\n    <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>Loading data please wait...</p>\r\n</div>\r\n<div class=\"boxed\" ng-if=\"recommended.length > 0\">\r\n  <center>\r\n    <h2>Podcast Recommended</h2>\r\n  </center>\r\n  <p ng-repeat=\"recomend in recommended\" ng-if=\"!loadingNewsExtra && recomend.type==\'podcast\'\"> {{recomend.name}}</p>\r\n  <p ng-if=\"recommended.length==0 && !loadingExtra\">There are no recommended podcast for you.</p>\r\n  <p ng-if=\"loadingNewsExtra\">\r\n    <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>Loading data please wait...</p>\r\n</div>\r\n</div>\r\n<script type=\"text/ng-template\" id=\"field_renderer\">\r\n  <ul class=\"catList\">\r\n    <li>\r\n      <div class=\"catname\" id=\"{{subent._id}}\" ng-if=\"(subent.parentIds.length == 0) && (subent.subcategories)\">\r\n        <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\">\r\n        <label ng-click=\"ChangeShow(subent._id);\">{{::subent.title}}&nbsp;\r\n          <i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id)==-1\"></i>\r\n          <i class=\"fa fa-caret-right\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id) > -1\"></i>\r\n        </label>\r\n      </div>\r\n      <div class=\"catname\" ng-if=\"(subent.parentIds.length == 0) && (!subent.subcategories)\">\r\n        <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n          <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\"> {{::subent.title}}\r\n        </label>\r\n      </div>\r\n      <label class=\"checkbox\" ng-if=\"subent.parentIds.length > 0 && showSubCat\" title=\"{{subent.title}}\">\r\n        <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\"> {{::subent.title}}\r\n      </label>\r\n      <ul ng-if=\"subent.subcategories\" ng-class=\"subent.parentIds.length == 0 ? \'cmnUL MainCatLi_{{subent._id}}\' : \'\'\">\r\n        <li ng-repeat=\"subent in subent.subcategories track by $index\" ng-include=\"\'field_renderer\'\">\r\n          <!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                      <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n                  </label> -->\r\n        </li>\r\n      </ul>\r\n    </li>\r\n  </ul>\r\n</script>\r\n<script type=\"text/ng-template\" id=\"LatestEssayId\">\r\n  <div class=\"latestPosts\">\r\n    <h3>Latest Essay</h3>\r\n    <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"LatestEssay==0\"></i>\r\n    <ul>\r\n      <li ng-repeat=\"essay in LatestEssay track by $index\">\r\n        <div class=\"boldbox\">\r\n          <span ng-click=\"gotoEssay(essay._id, essay.parentCat[0]);\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">{{essay.title}}</span>\r\n        </div>\r\n        <!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                      <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n                  </label> -->\r\n      </li>\r\n    </ul>\r\n  </div>\r\n</script>\r\n<script type=\"text/ng-template\" id=\"LatestEssayCommentId\">\r\n  <div class=\"latestPosts\">\r\n    <h3>Latest Essay Comments</h3>\r\n    <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"LatestEssayComments==0\"></i>\r\n    <ul>\r\n      <li ng-repeat=\"essay in LatestEssayComments track by $index\">\r\n        <div class=\"boldbox\">\r\n          <!-- <div  ng-bind-html=\'essay.comments | urlify\' ng-click=\"gotoComments(essay.essayId)\"></div> -->\r\n          <span ng-click=\"gotoComments(essay._id, essay.parentCat[0]);\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">{{essay.title}}</span>\r\n        </div>\r\n      </li>\r\n    </ul>\r\n  </div>\r\n</script>\r\n<script type=\"text/ng-template\" id=\"LatestPostId\">\r\n  <div class=\"latestPosts\">\r\n    <h3>Latest Posts</h3>\r\n    <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"LatestPost==0\"></i>\r\n    <ul>\r\n      <li ng-repeat=\"post in LatestPost track by $index\">\r\n        <div class=\"boldbox\">\r\n          <span ng-click=\"gotoThread(post, post.subCategories[0].pid);\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">{{post.title}}</span>\r\n        </div>\r\n        <!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                      <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n                  </label> -->\r\n      </li>\r\n    </ul>\r\n  </div>\r\n</script>\r\n<script type=\"text/ng-template\" id=\"LatestThreadId\">\r\n  <div class=\"latestPosts\">\r\n    <h3>Latest Threads</h3>\r\n    <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"LatestThread==0\"></i>\r\n    <ul>\r\n      <li ng-repeat=\"thread in LatestThread track by $index\">\r\n        <div class=\"boldbox\">\r\n          <span ng-click=\"gotoThread(thread, thread.subCategories[0].pid);\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">{{thread.title}}</span>\r\n        </div>\r\n        <!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                      <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n                  </label> -->\r\n      </li>\r\n    </ul>\r\n  </div>\r\n</script>\r\n<script type=\"text/ng-template\" id=\"popUp\">\r\n  <div class=\"container\">\r\n   <p ng-if=\"showBoth && $root.userRole==\'politician\'\">You can read, but you can\'t write anything on the site until you confirm your email address.  <br><br> After you confirm your email, you can write, but everything will have the byline \"Unknown Politician\" until we can confirm your identification (then all your work will change to your byline).  You can wait for us to research you or you can use our automated ID confirmation system (which costs $1)</p>\r\n			<p ng-if=\"showBoth && $root.userRole==\'advocate\'\">You can read, but you can\'t write anything on the site until you confirm your email address.  <br><br> After you confirm your email, you can write, but everything will have the byline \"Unknown Organization\" until we can confirm your identification (then all your work will change to your byline).</p>\r\n   <p ng-if=\"showEm\">You can read, but you can\'t write anything on the site until you confirm your email address.</p>\r\n   <p ng-if=\"$root.userRole==\'politician\' && showCon && !showBoth && !showEm\">We still need to confirm you are who you say you are. If you are running for a large office, we will do the research to figure that out.  If you are running for a more local office and you don\'t want to wait for us, you can use the automated ID check which costs $1.</p>\r\n\r\n   <div class=\"ngdialog-buttons\">\r\n   <button  ng-click=\"sendMail()\" type=\"button\" class=\"ngdialog-button ngdialog-button-primary\" ng-if=\"showEm  || (showBoth && $root.userRole==\'politician\')\">Resend Confirmation Email</button>\r\n   <button ng-click=\"goto()\" ng-if=\"showCon && $root.userRole==\'politician\'\" type=\"button\" class=\"ngdialog-button ngdialog-button-primary\">Confirm Id</button>\r\n   <button ng-click=\"closeIt()\" type=\"button\" class=\"ngdialog-button ngdialog-button-primary\">Later</button>\r\n   </div>\r\n  </div>\r\n\r\n\r\n\r\n</script>\r\n<script type=\"text/ng-template\" id=\"addressPopUp\">\r\n  <div>\r\n    <h5>We need your address to show you your local politicians and other location-based tools.</h5>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\">Street Address (Leave out Apt#)</label>\r\n              <div class=\"control-group\">\r\n                <input type=\"text\" id=\"address\" ng-model=\"User.Address\" ng-keyup=\"detectAddress($event)\" class=\"zipInput form-control\" />&nbsp;\r\n            </div>\r\n              </div>\r\n\r\n              <!-- Drop down -->\r\n\r\n              <div ng-if=\"showAddressDrop\">\r\n                <div ng-if=\"noShow\">\r\n                 <div class=\"control-group\">\r\n                  <br>\r\n                  <center>\r\n                    <button ng-click=\"setAddressNew(Location)\" type=\"button\" class=\"btn2Short-style widthAuto btn-success\">Save</button>\r\n                  </center>\r\n                  <br>\r\n\r\n                  <label class=\"control-label formLabel removeTopMargin\" for=\"email\">State </label>\r\n                  <div class=\"controls\">\r\n                    <select ng-model=\"Location.state\" style=\"text-transform: capitalize;\" ng-init=\"Location.state = allstatesData[0]\" ng-options=\"item.state for item in allstatesData track by item.stateFips\" ng-class=\"checkLen(allstatesData, \'state\')\"></select>\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"email\">County </label>\r\n                  <div class=\"controls\">\r\n                    <select ng-model=\"Location.county\" style=\"text-transform: capitalize;\"  ng-options=\"item.countyName for item in allcounties track by item.countyFips\" ng-class=\"checkLen(allcounties, \'county\')\"></select>\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"email\">City </label>\r\n                  <div class=\"controls\">\r\n                    <select ng-model=\"Location.place\" style=\"text-transform: capitalize;\"  ng-options=\"item as item.placeName for item in places track by item.place\" ng-class=\"checkLen(places, \'place\')\"></select>\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"email\">Federal Congressional District (click if incorrect) </label>\r\n                  <div class=\"controls\">\r\n                    <select ng-model=\"Location.federalCongrassionalDist\" style=\"text-transform: capitalize;\" ng-init=\"Location.federalCongrassionalDist = federalCongrassionalDist[0]\" ng-options=\"item as item.CD115FP for item in federalCongrassionalDist track by item.CD115FP\" ng-class=\"checkLen(federalCongrassionalDist, \'federalCongrassionalDist\')\"></select>\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"email\">State Senate District (click if incorrect) </label>\r\n                  <div class=\"controls\">\r\n                    <select ng-model=\"Location.stateSenateDistrict\" style=\"text-transform: capitalize;\" ng-init=\"Location.stateSenateDistrict = stateSenateDistrict[0]\" ng-options=\"item as item.NAMELSAD for item in stateSenateDistrict track by item.SLDUST\" ng-class=\"checkLen(stateSenateDistrict, \'stateSenateDistrict\')\"></select>\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"email\">State House of Representative District (click if incorrect) </label>\r\n                  <div class=\"controls\">\r\n                    <select ng-model=\"Location.stateHouseOFRepresentativeDistrict\" style=\"text-transform: capitalize;\" ng-init=\"Location.stateHouseOFRepresentativeDistrict = stateHouseOFRepresentativeDistricts[0]\" ng-options=\"item as item.NAMELSAD for item in stateHouseOFRepresentativeDistricts track by item.NAMELSAD\" ng-class=\"checkLen(stateHouseOFRepresentativeDistricts, \'stateHouseOFRepresentativeDistrict\')\"></select>\r\n                  </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"email\">School District Name (click if incorrect) </label>\r\n                  <div class=\"controls\">\r\n                    <select ng-model=\"Location.unifiedSchoolDistrictName\" ng-init=\"Location.unifiedSchoolDistrictName = unifiedSchoolDistrictNames[0]\" style=\"text-transform: capitalize;\" ng-options=\"item as item.NAME for item in unifiedSchoolDistrictNames track by item.NAME\" ng-class=\"checkLen(unifiedSchoolDistrictNames, \'unifiedSchoolDistrictName\')\"></select>\r\n                  </div>\r\n                </div><br>\r\n              </div>\r\n                <div>\r\n                    <br>\r\n                    <span ng-if=\"address.state.state\" >State:</span><span>  {{address.state.state}}</span>\r\n                    <br>\r\n                    <span ng-if=\"address.state.statePostalCode\" >State Postal Code:</span><span>  {{address.state.statePostalCode}}</span>\r\n                    <br>\r\n                    <span ng-if=\"address.county[0].NAMELSAD\" >County:</span><span>  {{address.county[0].NAMELSAD}}</span>\r\n                    <br>\r\n                    <span ng-if=\"address.place[0].NAMELSAD\" >City:</span><span>  {{address.place[0].NAMELSAD}}</span>\r\n                    <br>\r\n                    <span ng-if=\"federalCongrassionalDist[0].CD115FP\" >Federal Congressional District: </span><span>  {{federalCongrassionalDist[0].CD115FP}}</span>\r\n                    <br>\r\n                    <span ng-if=\"unifiedSchoolDistrictNames[0].NAME\" >School District: </span><span>  {{unifiedSchoolDistrictNames[0].NAME}}</span>\r\n                    <br>\r\n                    <span ng-if=\"stateSenateDistrict[0].NAMELSAD\" >State Senate District:</span><span>  {{stateSenateDistrict[0].NAMELSAD}}</span>\r\n                    <br>\r\n                    <span ng-if=\"StateHouseOFRepresentativeDistricts[0].NAMELSAD\" >StateHouseOFRepresentativeDistricts:</span><span>  {{stateHouseOFRepresentativeDistricts[0].NAMELSAD}}</span>\r\n                    <br>\r\n                  </div>\r\n                <center>\r\n                  <button ng-click=\"setAddressNew(Location)\" type=\"button\" class=\"btn2Short-style widthAuto btn-success\">This Looks Correct</button>\r\n                </center>\r\n\r\n                <br><br>\r\n              </div>\r\n            </div>\r\n</script>\r\n\r\n</div>\r\n<!-- <script type=\"text/javascript\" src=\"https://js.stripe.com/v2/\"></script> -->\r\n<div ng-if=\"$root.userRole==\'politician\'\">\r\n\r\n<script>var showHeader=\"false\"</script>\r\n<div class=\"container-fluid\">\r\n	<!--DESKTOP VIEW-->\r\n  <div class=\"welcomeSection1 jumbotron d-none d-md-block d-lg-block \">\r\n    <div class=\"row\">\r\n      <div class=\"col-lg-6 col-md-6\">\r\n      </div>\r\n      <div class=\"col-lg-6 col-md-6\">\r\n        <div><img ng-src=\"./assets/images/votewiselogoBlackwWhiteNew.svg\" class=\"img-fluid\"></div>\r\n          <div class=\"row\">\r\n            <div class=\"col-lg-2 col-md-2\"></div>\r\n            <div class=\"col-lg-8 col-md-8 blackText\">\r\n              <b>Where voters and politicians can connect without advertising dollars getting in the way.  <br><br><center>Non-profit.    Non-partisan.</center></b>\r\n													<br></div></div></div></div><center>\r\n              <a href=\"#!/fiveMatch/fiveminquiz\">\r\n                  <div class=\"fiveStartBtn\"  style=\"position:relative;z-index: 4;\"><center><b>Start Quiz</b></center></div></a></center>\r\n			<br><br></div>\r\n           <div class=\"col-lg-12 col-sm-12 learnHeader d-none d-lg-block\" >\r\n              	<div id=\"blockInfoLearn1\" style=\"width:60%; margin-left: 25%; background-color: #faeed2; box-shadow: -20px 20px 20px rgba(0, 0, 0, 0.5);position:relative; z-index: 2;\">\r\n                  \r\n                <div><a href=\"#!/fiveMatch/fiveminquiz\">\r\n                  <h4 class=\"blockTitleLearn\">FIVE MINUTE MATCH</h4>\r\n                  <span class=\"blockDesc\">\r\n	<p>The questions in the <b>\"Five Minute Match Quiz\"</b> are taken from our issue-based quizzes.  These <b>\"Topic Quizzes\"</b> explore the logic behind all sides of an argument.  For this reason, some questions may seem leading.  If you want to see point/counterpoint on any issue, hit the “More Questions on this Topic” button to see the quiz that the question came from.</p>\r\n	<!--																	\r\n<center><hr style=\"background-color: black; color:black; height:5px; width:80%; opacity:50%;\"></center>\r\n	<p><b><span style=\"text-decoration: underline\">NOTE</span> : Because of the dramatic events of 2020, the Five Minute Match Quiz has been extended.  It could take you 8-10 minutes to complete the whole quiz, but you can skip to the end after answering at least 5 questions if you don’t care about the accuracy of your matches.</b></p>\r\n-->\r\n                </span>\r\n              \r\n              \r\n																	</a>				</div></div>\r\n            \r\n          <div class=\"col-lg-2\"></div>\r\n        </div>\r\n    \r\n	\r\n\r\n	\r\n	<div class=\"welcomeSection2 jumbotron d-none d-lg-block\" style=\"margin-top: -70px; \">\r\n    <div class=\"row\">\r\n					<div class=\"col-lg-6\">\r\n						<div id=\"blockInfoLearn1\" style=\"box-shadow: -20px 20px 20px rgba(0, 0, 0, 0.5); position:relative; z-index: 1;\">\r\n            <div>\r\n      \r\n													<h4 class=\"blockTitleLearn\" >WHAT IS VOTEWISE?</h4>\r\n              <span class=\"blockDesc\">VoteWise is  a non-partisan non-profit website that connects voters, organizations and politicians without advertising dollars getting in the way.  Our goal is to depolarize politics and make it easier for communities to find common ground and the tools they need to identify problems, find sustainable solutions that work for all, and put those solutions into action.<br><br>\r\n\r\nAn effective democracy requires the active participation of voters, politicians, the press, and the organizations that dedicate their lives to the issues they care about.  Sometimes this means making changes to legislation and sometimes this means more hands-on action.  Either way, it requires year-round teamwork.  We want to make it easier for everyone.<br> <br>\r\n\r\nWe have different tools available to different types of users to make their jobs easier.  Click on the videos below to learn more.\r\n</span>\r\n				\r\n            </div>\r\n          </div>\r\n					</div>\r\n    <!--  <div class=\"col-lg-6\">\r\n      </div>\r\n      <div class=\"col-lg-6\">\r\n        <div><img ng-src=\"./assets/images/votewiselogoBlackwWhiteNew.svg\" class=\"img-fluid\"></div>\r\n          <div class=\"row\">\r\n            <div class=\"col-lg-2\"></div>\r\n            <div class=\"col-lg-8 blackText\">\r\n              <b>Where voters and politicians can connect without advertising dollars getting in the way.  <br><br><center>Non-profit.    Non-partisan.</center></b>\r\n              <br>\r\n              <a href=\"#!/upcomingElection\">\r\n                  <div class=\"yBtn\"><center><b>Get Ready to Vote</b></center></div></a>\r\n              <br><br>\r\n              <a href=\"#!/takeAction\">\r\n                  <div class=\"yBtn\"><center><b>Take Action</b></center></div></a>\r\n            </div>\r\n\r\n          </div>\r\n          <div class=\"col-lg-2\"></div>\r\n        </div>-->\r\n      </div>\r\n    </div>\r\n	\r\n	<!--CELL PHONE VIEW-->\r\n    <div class=\"welcomeSection1Small jumbotron d-md-none\">\r\n      <div class=\"row justify-content-end\">\r\n        <div class=\"col col-6 topPaddingSmall\">\r\n          <img ng-src=\"./assets/images/votewiselogoBlackwWhiteNew.svg\" class=\"img-fluid\"></div>\r\n        </div>\r\n        <div class=\"row justify-content-end\">\r\n          <div class=\"col col-6 blackText\">\r\n            <b>Where voters and politicians can connect without advertising dollars getting in the way.  <br><br><center><span>Non-profit. </span>  <span> Non-partisan.</span></center></b><br><br><br><br></div><br></div>\r\n									\r\n            <center><a href=\"#!/fiveMatch/fiveminquiz\">\r\n													<div class=\"fiveStartBtn\" style=\"position:relative; z-index: 2;\"><center><b>Start Quiz</b></center></div></a></center></div></div>\r\n       \r\n  <div class=\"col-lg-12 col-sm-12 learnHeader d-lg-none\" >\r\n  \r\n              	<div id=\"blockInfoLearn1\" style=\" background-color: #faeed2; box-shadow: -20px 20px 20px rgba(0, 0, 0, 0.5);position:relative; margin-top: -90px;\">\r\n                  \r\n                <div><a href=\"#!/fiveMatch/fiveminquiz\">\r\n                  <h4 class=\"blockTitleLearn\" >FIVE MINUTE MATCH</h4>\r\n                  <span class=\"blockDesc\">\r\n	<p>The questions in the <b>\"Five Minute Match Quiz\"</b> are taken from our issue-based quizzes.  These <b>\"Topic Quizzes\"</b> explore the logic behind all sides of an argument.  For this reason, some questions may seem leading.  If you want to see point/counterpoint on any issue, hit the “More Questions on this Topic” button to see the quiz that the question came from.</p>\r\n	<!--																		\r\n<center><hr style=\"background-color: black; color:black; height:5px; width:80%; opacity:50%;\"></center>\r\n	<p><b><span style=\"text-decoration: underline\">NOTE</span> : Because of the dramatic events of 2020, the Five Minute Match Quiz has been extended.  It could take you 8-10 minutes to complete the whole quiz, but you can skip to the end after answering at least 5 questions if you don’t care about the accuracy of your matches.</b></p>\r\n-->\r\n                </span>\r\n              \r\n              \r\n																	</a>						</div><br></div><br>\r\n            \r\n          <div class=\"col-lg-2\"></div>\r\n        </div>\r\n\r\n	<div class=\"welcomeSection2 jumbotron  d-lg-none\">\r\n    <div class=\"row\">\r\n					<div class=\"col-lg-6\">\r\n						<div id=\"blockInfoLearn1\">\r\n            <div>\r\n      \r\n													<h4 class=\"blockTitleLearn\" >WHAT IS VOTEWISE?</h4>\r\n              <span class=\"blockDesc\">VoteWise is  a non-partisan non-profit website that connects voters, organizations and politicians without advertising dollars getting in the way.  Our goal is to depolarize politics and make it easier for communities to find common ground, find sustainable solutions that work for all, and put those solutions into action.<br><br>\r\n\r\nAn effective democracy requires the active participation of voters, politicians, the press, and the organizations that dedicate their lives to the issues they care about.  Sometimes this means making changes to legislation and sometimes this means more hands-on action.  Either way, it requires year-round teamwork.  We want to make it easier for everyone.<br> <br>\r\n\r\nWe have different tools available to different types of users to make their jobs easier.  Click on the videos below to learn more.\r\n</span>\r\n				\r\n            </div>\r\n          </div>\r\n					</div>\r\n		</div></div>\r\n		    <center class=\"threefer\">\r\n							 <iframe src=\"https://player.vimeo.com/video/408236980?byline=false&title=false\" allowfullscreen style=\"border:0;\"></iframe><span>							\r\n														 <iframe src=\"https://player.vimeo.com/video/408236648?byline=false&title=false\" allowfullscreen style=\"border:0;\"></iframe></span><span>\r\n<iframe src=\"https://player.vimeo.com/video/408237898?byline=false&title=false\" allowfullscreen style=\"border:0;\"></iframe></span></center>\r\n\r\n\r\n\r\n	</div>\r\n\r\n");
$templateCache.put("app/speakOut/speakOut.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">SPEAK OUT</h2>\r\n  <p class=\"pageSubHeading\">We have many ways for you to get the word out about your cause.</p>\r\n	\r\n		<div class=\"centerediframe\">\r\n  <iframe src=\"https://player.vimeo.com/video/399344448?byline=false&title=false\" allowfullscreen ></iframe>\r\n</div>\r\n	\r\n  <div class=\"row\">\r\n \r\n   <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/questionHome\" class=\"blockLink\"><img ng-src=\"./assets/images/clipBoard2.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock2\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">QUESTIONS IMPORTANT TO YOU</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Answer multiple choice questions to express your views on countless topics.  Voters get matched up to you based on these quizzes so that when you endorse a bill or a politician, it has far more weight.  We reccommend answering as many questions as make sense for your organization, but skip any that you don\'t have a position on.<br><br>Voters also use these quizzes to find you and donate their time and money. <br><br>Organizations and politicians use the quizzes to find each other to team-up over shared issues.  <br><br>As an organization, you are also trusted to go over our questions and let us know when you think a question is bad or if we are missing the finer points of an issue.  \r\n          </p>\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n      \r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/learnHome\" class=\"blockLink\"><img ng-src=\"./assets/images/Learn2.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock3\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">TEACH ABOUT YOUR TOPICS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">As an organization, you have the exclusive right to post videos and articles in an area where voters and politicians can learn from your expertise.  You probably already have tons of this stuff in your closet.  Post it here to teach everyone about your issues. \r\n          </p>\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n      \r\n      \r\n          \r\n      \r\n\r\n\r\n          <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/incumbent_politician/politician\" class=\"blockLink\"><img ng-src=\"./assets/images/politiciansRBB7-01.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock5\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">RATE, ENDORSE AND DISCUSS POLITICIANS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Use our tools to rate and leave comments about a politician.  Too often, politicians make their message unclear to voters who don\'t have time to investigate the issues as deeply as you do.  When a voter looks for politicians, they will see the grades you gave them.  To give more weight to your grades, we also show your \"match score\" next to it (\"match score\" is based on the Idealogical Match Questions you answered compared to those that the voter answered.) <br><br>\r\n          If a voter clicks on the grade you gave the politician, the voter will see your comments about why they deserved the grade you gave them.  By deault, we show the ratings from the three organizations that best match the voter.  If voter is not signed in, then the list of three organizations they see are the ones that answered the most questions in the Idealogical Match section and posted the most material in the Teach About Your Topics section. <br><br> Those are the defaults.  Users can also see the organizations that they are \"following\" or search for the ones that interest them.</p>\r\n          \r\n        </div>\r\n      </div></a>\r\n    </div>\r\n      \r\n    \r\n      <!-- REACTIVATE WHEN LEGISLATION TATING TOOL IS WORKING\r\n     <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/debateHome\" class=\"blockLink\"><img ng-src=\"./assets/images/legislationColor.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock6\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">RATE AND DISCUSS LEGISLATION</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Use our tools to rate and leave comments about upcoming legislation.  Voters don\'t have time to investigate the issues as deeply as you do.  In fact, often times, the politicians voting on legislation may be in the dark about how it may affect your issues.  When a voters, politicians and others look at legislation, they will see the grades you gave them.  To give more weight to your grades, we also show your \"match score\" next to it (\"match score\" is based on the Idealogical Match Questions you answered compared to those that the user answered.) <br><br>If a user clicks on the grade you gave the legislation, the user will see your comments about why they deserved the grade you gave them.  By deault, we show the ratings from the three organizations that best match the user.  If user is not signed in, then the list of three organizations they see are the ones that answered the most questions in the Idealogical Match section and posted the most material in the Teach About Your Topics section. <br><br> Those are the defaults.  Users can also see the organizations that they are \"following\" or search for the ones that interest them.</p>\r\n          \r\n        </div>\r\n      </div></a>\r\n    </div>   \r\n    -->  \r\n      \r\n      \r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/debateHome\" class=\"blockLink\"><img ng-src=\"./assets/images/discuss4.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock4\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">DISCUSS YOUR ISSUES</h4>\r\n            <p class=\"gettingStartedBlockDesc\">Voters and politicians use the debate section to discuss the issues and come up with solutions.  Join in and guide them in the right direction.  Search by subject or location.</p>\r\n          \r\n        </div>\r\n      </div></a>\r\n    </div>\r\n   \r\n     \r\n      \r\n      \r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/sponsored/sponsored.html","<div class=\"container-fluid pageBg\">\r\n<div id=\"cosponsoredContent\">\r\n    <h2 class=\"pageHeading\" ng-click=\"backToProfile()\">{{memberName}}</h2>\r\n    <div class=\"pageSubHeading\">Sponsors and Cosponsors</div>\r\n  <div ng-repeat=\"bills in sponsorData track by $index\">\r\n    <div>Congress : {{bills.congress}}</div>\r\n    <div>Bill ID : {{bills.bill_id}}</div>\r\n    <div>Title : {{bills.title}}</div>\r\n    <div>Cosponsored Date : {{bills.cosponsored_date}}</div>\r\n    <div>Primary Subject : {{bills.primary_subject}}</div>\r\n    <br />\r\n    <input type=\"button\" value=\"Show Details\" class=\"changeTextColor\" ng-click=\"$parent.selectedIndex=$index\">\r\n    <br />\r\n    <div ng-show=\"$parent.selectedIndex == $index\">\r\n      <div>Sponsor Title : {{bills.sponsor_title}}</div>\r\n      <div>Sponsor Name : {{bills.sponsor_name}}</div>\r\n      <div>Sponsor State : {{bills.sponsor_state}}</div>\r\n      <div>Sponsor Party : {{bills.sponsor_party}}</div>\r\n      <div>Congressdotgov URL : {{bills.congressdotgov_url}}</div>\r\n      <div>Govtrack URL : {{bills.govtrack_url}}</div>\r\n      <div>Introduced Date : {{bills.introduced_date}}</div>\r\n      <div>Last Vote : {{bills.last_vote}}</div>\r\n      <div>House Passage : {{bills.house_passage}}</div>\r\n      <div>Senate Passage : {{bills.senate_passage}}</div>\r\n      <div>Enacted : {{bills.enacted}}</div>\r\n      <div>Vetoed : {{bills.vetoed}}</div>\r\n      <div>Cosponsors : {{bills.cosponsors}}</div>\r\n      <div>Cosponsors By Party : {{bills.cosponsors_by_party}}</div>\r\n      <div>Committees : {{bills.committees}}</div>\r\n      <div>Summary : {{bills.summary}}</div>\r\n      <div>Summary Short : {{bills.summary_short}}</div>\r\n      <div>Latest Major Action Date : {{bills.latest_major_action_date}}</div>\r\n      <div>Latest Major Action : {{bills.latest_major_action}}</div>\r\n    </div>\r\n    <hr style=\"border-top: 1px solid #222;\" />\r\n  </div>\r\n</div>\r\n</div>");
$templateCache.put("app/stripe/stripe.html","<!-- <script type=\"text/ng-template\" id=\"popUp\"> -->\r\n\r\n<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">ID CHECK</h2>\r\n  <p class=\"pageSubHeading\">In order to confirm you are the politician you claim to be, we need to connect your name,\r\n    your address (which are public information) with your credit card information (which is private). We do not store\r\n    your credit card info. We merely send it to Stripe to check to see if the information matches. They charge for this\r\n    service, so we have to charge you, but it is only a\r\n    dollar.<br><br>  Keep in mind, your address must be the same as your billing address.  If you use a card with the wrong address, you will still be charged the dollar, but you id check will fail.</p>\r\n    <div ng-if=\"!show\">\r\n      <h5>We need your address to verify your identity.</h5>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label formLabel\">Street Address (Leave out Apt #)</label>\r\n        <div class=\"control-group\">\r\n          <input type=\"text\" id=\"address\" ng-model=\"User.Address\" ng-keyup=\"detectAddress($event)\" class=\"zipInput form-control\" />&nbsp;\r\n              </div>\r\n        </div>\r\n\r\n        <!-- Drop down -->\r\n\r\n        <div ng-if=\"showAddressDrop\" class=\"blackText\">\r\n          <div class=\"control-group\">\r\n            <br>\r\n\r\n            <br>\r\n\r\n            <label class=\"control-label formLabel removeTopMargin\" for=\"email\">State </label>\r\n            <div class=\"controls\">\r\n              <select ng-model=\"Location.state\" style=\"text-transform: capitalize;\" ng-init=\"Location.state = allstatesData[0]\" ng-options=\"item.state for item in allstatesData track by item.stateFips\" ng-class=\"checkLen(allstatesData, \'state\')\"></select>\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"email\">County </label>\r\n            <div class=\"controls\">\r\n              <select ng-model=\"Location.county\" style=\"text-transform: capitalize;\"  ng-options=\"item.countyName for item in allcounties track by item.countyFips\" ng-class=\"checkLen(allcounties, \'county\')\"></select>\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"email\">City </label>\r\n            <div class=\"controls\">\r\n              <select ng-model=\"Location.place\" style=\"text-transform: capitalize;\"  ng-options=\"item as item.placeName for item in places track by item.place\" ng-class=\"checkLen(places, \'place\')\"></select>\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"email\">Federal Congressional District (click if incorrect) </label>\r\n            <div class=\"controls\">\r\n              <select ng-model=\"Location.federalCongrassionalDist\" style=\"text-transform: capitalize;\" ng-init=\"Location.federalCongrassionalDist = federalCongrassionalDist[0]\" ng-options=\"item as item.CD115FP for item in federalCongrassionalDist track by item.CD115FP\" ng-class=\"checkLen(federalCongrassionalDist, \'federalCongrassionalDist\')\"></select>\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"email\">State Senate District (click if incorrect) </label>\r\n            <div class=\"controls\">\r\n              <select ng-model=\"Location.stateSenateDistrict\" style=\"text-transform: capitalize;\" ng-init=\"Location.stateSenateDistrict = stateSenateDistrict[0]\" ng-options=\"item as item.NAMELSAD for item in stateSenateDistrict track by item.SLDUST\" ng-class=\"checkLen(stateSenateDistrict, \'stateSenateDistrict\')\"></select>\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"email\">State House of Representative District (click if incorrect) </label>\r\n            <div class=\"controls\">\r\n              <select ng-model=\"Location.stateHouseOFRepresentativeDistrict\" style=\"text-transform: capitalize;\" ng-init=\"Location.stateHouseOFRepresentativeDistrict = stateHouseOFRepresentativeDistricts[0]\" ng-options=\"item as item.NAMELSAD for item in stateHouseOFRepresentativeDistricts track by item.NAMELSAD\" ng-class=\"checkLen(stateHouseOFRepresentativeDistricts, \'stateHouseOFRepresentativeDistrict\')\"></select>\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"email\">School District Name (click if incorrect) </label>\r\n            <div class=\"controls\">\r\n              <select ng-model=\"Location.unifiedSchoolDistrictName\" ng-init=\"Location.unifiedSchoolDistrictName = unifiedSchoolDistrictNames[0]\" style=\"text-transform: capitalize;\" ng-options=\"item as item.NAME for item in unifiedSchoolDistrictNames track by item.NAME\" ng-class=\"checkLen(unifiedSchoolDistrictNames, \'unifiedSchoolDistrictName\')\"></select>\r\n            </div>\r\n          </div><br>\r\n          <center>\r\n            <button ng-click=\"setAddressNew(Location)\" type=\"button\" class=\"btn2Short-style widthAuto btn-success\">This Looks Correct</button>\r\n          </center>\r\n\r\n          <br><br>\r\n                </div>\r\n        </div>\r\n        <!-- <div ng-if=\"!show\">\r\n          <div class=\"contactBlock d-flex justify-center container-fluid col-sm-12 col-lg-7\" ng-if=\"data.length > 0\">\r\n\r\n            <div style=\"padding:20px;\">\r\n              <div ng-repeat=\"itm in data track by $index\">\r\n                <div ng-if=\"itm.NameFull !=\' \'\">Name:-\r\n                  <a href=\"\" class=\"link\" ng-click=\"showPay(itm)\">{{itm.NameFull}}</a> </div>\r\n                <div ng-if=\"itm.AddressLine1 && itm.AddressLine1 !=\' \'\">Address:- {{itm.AddressLine1}}</div>\r\n                <div ng-if=\" itm.PostalCode && itm.PostalCode !=\' \' \">PostalCode:- {{itm.PostalCode}}</div>\r\n                <div ng-if=\"itm.State\">State:- {{itm.State}}</div>\r\n                <div ng-if=\"itm.County\">County:- {{itm.CountyName}}</div>\r\n                <div ng-if=\"itm.CountyFIPS\">CountyFIPS:- {{itm.CountyFIPS}} </div>\r\n                <div ng-if=\"itm.CountySubdivisionName\">CountySubdivisionName:- {{itm.CountySubdivisionName}}</div>\r\n                <div ng-if=\"itm.CountySubdivisionCode\">CountySubdivisionCode:- {{itm.CountySubdivisionCode}} </div>\r\n                <div ng-if=\"itm.City\">City:- {{itm.City}}</div>\r\n                <div ng-if=\"itm.PlaceCode\">PlaceCode:- {{itm.PlaceCode}} </div>\r\n                <div ng-if=\"itm.CongressionalDistrict\">CongressionalDistrict:- {{itm.CongressionalDistrict}}</div>\r\n                <div ng-if=\"itm.UnifiedSchoolDistrictName\">UnifiedSchoolDistrictName:- {{itm.UnifiedSchoolDistrictName}}\r\n                </div>\r\n                <div ng-if=\"itm.UnifiedSchoolDistrictCode\">UnifiedSchoolDistrictCode:- {{itm.UnifiedSchoolDistrictCode}}\r\n                </div>\r\n                <div ng-if=\"itm.StateDistrictUpper\">StateDistrictUpper:- {{itm.StateDistrictUpper}}</div>\r\n                <div ng-if=\"itm.StateDistrictLower\">StateDistrictLower:- {{itm.StateDistrictLower}}</div>\r\n                <div ng-if=\"itm.CBSALevel\">CBSALevel:- {{itm.CBSALevel}} </div>\r\n                <div ng-if=\"itm.CBSATitle\">CBSATitle:- {{itm.CBSATitle}} </div>\r\n                <div ng-if=\"itm.CBSACode\">CBSACode:- {{itm.CBSACode}}</div>\r\n                <hr style=\"border-top: 1px solid #222;\" /><br>\r\n              </div>\r\n\r\n              </div>\r\n            </div>\r\n          </div> -->\r\n        <div class=\"form-row\" ng-if=\"show\">\r\n          <div class=\"col-12\">\r\n            <form stripe-form=\"stripeCallback\">\r\n              <div class=\"control-group\">\r\n                <div class=\"control-group\">\r\n                  <input ng-model=\"number\" placeholder=\"Card Number\" payments-format=\"card\" class=\"form-control\" payments-validate=\"card\" name=\"card\"\r\n              />\r\n                  <br>\r\n\r\n                  <input ng-model=\"expiry\" placeholder=\"Expiration\" payments-format=\"expiry\" class=\"form-control\" payments-validate=\"expiry\"\r\n                name=\"expiry\" />\r\n            </div>\r\n                </div>\r\n                <br>\r\n                <div class=\"control-group\">\r\n\r\n                  <div class=\"control-group\">\r\n                    <input ng-model=\"cvc\" placeholder=\"CVC\" payments-format=\"cvc\" class=\"form-control\" payments-validate=\"cvc\" name=\"cvs\" />\r\n            </div>\r\n                  </div>\r\n                  <br>\r\n                  <div class=\"control-group\">\r\n\r\n                    <div class=\"control-group\">\r\n                      <input ng-model=\"addressLine1\" placeholder=\"Address\" disabled class=\"form-control\" name=\"addressLine1\" />\r\n            </div>\r\n                    </div>\r\n                    <br>\r\n                    <div class=\"control-group\">\r\n\r\n                      <div class=\"control-group\">\r\n                        <input ng-model=\"addressZip\" placeholder=\"Zip Code\" class=\"form-control\" name=\"addressZip\" />\r\n            </div>\r\n                      </div>\r\n                      <br>\r\n\r\n                      <button type=\"submit\" class=\"btnShort-style widthAuto btn-success\">Pay 1$</button>\r\n            </form>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n\r\n      <!-- <div class=\"row\">\r\n    <div class=\"col-12\">\r\n      <h3>Pay</h3>\r\n      <div class=\"col-md-12\">\r\n        <form action=\"/charge\" method=\"post\" id=\"payment-form\">\r\n          <div class=\"form-row\">\r\n          <div id=\"card-element\">\r\n            <div class=\"control-group\">\r\n              <input type=\"text\" placeholder=\"Card Number\" />\r\n            </div>\r\n          </div>\r\n<p></p>\r\n          <div id=\"card-element\">\r\n            <div class=\"control-group\">\r\n              <input type=\"text\" placeholder=\"CVC\" />\r\n            </div>\r\n          </div>\r\n\r\n          Used to display form errors.\r\n          <div id=\"card-errors\" role=\"alert\"></div>\r\n      </div>\r\n      <br>\r\n      <button>Submit Payment</button>\r\n      </form>\r\n\r\n    </div>\r\n  </div>\r\n  </div> -->\r\n      <!-- </script> -->\r\n");
$templateCache.put("app/takeAction/takeAction.html","<div class=\"container-fluid ng-scope\">\r\n    \r\n    <center class=\"centerediframe\"><iframe src=\"https://player.vimeo.com/video/408236980?byline=false&title=false\" allowfullscreen ></iframe>		</center>\r\n    \r\n  <h2 class=\"pageHeading\">TAKE ACTION</h2>\r\n  <p class=\"pageSubHeading\">VoteWise is a year-round tool to learn about the issues and to connect with politicians and organizations that can help your vision of the future become a reality.  Each of the tabs above bring you to a different set of tools.  They are described below. Some of the free tools require you to sign up to use.</p>\r\n    \r\n <center>\r\n\r\n    <a href=\"#!/signup/voter\">\r\n          <div class=\"btn\"><b>Sign Up</b>\r\n  \r\n</center>\r\n    \r\n  <div class=\"row\">\r\n    <!--   \r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/dashboard\" class=\"blockLink\"><img ng-src=\"./assets/images/ProfileSettings3.svg\" class=\"gettingStartedImg img-fluid\">   \r\n      <div class=\"gettingStartedBlock gettingStartedBlock1\">\r\n          <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">PROFILE SETTINGS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Choose the subjects that matter to you most so you can be informed about events as they arise. Pick news sources, privacy settings, and many other things to make your experience more productive and enjoyable.</p>\r\n          \r\n        </div>\r\n      </div></a> \r\n-->\r\n    </div>\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/questionHome\" class=\"blockLink\"><img ng-src=\"./assets/images/clipBoard2.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock2\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">MATCH QUIZZES</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Answer multiple choice questions to express your views on countless topics.  You can use these answers to find politicians and organizations that match your vision.  Your answers can also be used by those in power as a guide for how best to help the people they represent.  Because they are multiple choice, your answers allow politicians to quickly aggregate and understand thousands of people’s thoughts, and your added comments add depth to those thoughts.</p><p>  The questions are phrased from the perspectives of all sides of an issue, so while you are being polled, you are also being prepared for intelligent conversation with others that may lead to workable solutions.  You can post quizzes you like to Facebook to get your friends in on the conversation.\r\n        </div>\r\n      </div>\r\n        </a></div>\r\n    \r\n    \r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/learnHome\" class=\"blockLink\"><img ng-src=\"./assets/images/Learn2.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock3\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">LEARN ABOUT THE TOPICS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Get tons of useful information about the topics that interest you by watching videos or reading articles from organizations that devote their entire existence to the topics you are curious about.  See the same issue from many sides without a filter. </p><p> You can also track legislation, learn about the basics of politics, economics, where to vote, how to register, how to read through political double speak and many other userful things.</p>\r\n          \r\n        </div>\r\n      </div></a>\r\n    </div>\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/debateHome\" class=\"blockLink\"><img ng-src=\"./assets/images/discuss4.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock4\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">DISCUSS THE ISSUES</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Engage in debate and discuss the issues with other voters, politicians, and organizations  in your town, your county, state or accross the United States.  Work towards solutions to the problems we face.</p>\r\n          \r\n        </div>\r\n      </div></a>\r\n    </div>\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/incumbent_politician/politician\" class=\"blockLink\"><img ng-src=\"./assets/images/politiciansRBB7-01.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock5\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">YOUR POLITICIANS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Contact the politicians that represent you to ask for help.  Find out what they stand for, who stands behind them, and who pays for their campaigns.  See their voting record. </p><p>Compare politicians who are running for office. Use the answers from your match quizzes to see who would best represent your interests.  See how the organizations that you match with rate the politicians.  Watch debates, read essays, and more.</p>\r\n         \r\n        </div>\r\n      </div></a>\r\n    </div>\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/advocateHome\" class=\"blockLink\"><img ng-src=\"./assets/images/Organizations.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock6\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">ORGANIZATIONS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">You may feel like one drop in the ocean, but if many drops come together, they can form a tsunami with incredible power.  Use this tool to find organizations that you can team up with to make the change you want to see in the world.</p>\r\n          \r\n        </div>\r\n      </div></a>\r\n    </div>\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <a href=\"#!/liveFeed\" class=\"blockLink\"><img ng-src=\"./assets/images/press9.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock7\">\r\n        <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">NEWS</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Find out about upcoming legislation for the subjects you care about, get local and national news feeds from the sources you trust.  See upcoming legislation.</p>\r\n          \r\n        </div>\r\n      </div></a>\r\n    </div>\r\n  </div>\r\n</div>\r\n<center>\r\n\r\n    <a href=\"#!/signup/voter\">\r\n          <div class=\"btn\"><b>Sign Up</b>\r\n  \r\n</center>");
$templateCache.put("app/theConstitution/theConstitution.html","\r\n    \r\n<div class=\"container-fluid ng-scope\">\r\n <h2 class=\"pageHeading\">The US Constitution</h2>\r\n  <p class=\"pageSubHeading\">Read the US Constitution with explanations</p>\r\n    <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n        <img ng-src=\"./assets/images/USConstitutionColor.svg\" class=\"blockInfoImgLearn img-fluid\">\r\n        <div id=\"blockInfoLearn3\">\r\n            <div>\r\n              <h4 class=\"blockTitleLearn\">The US Constitution</h4>\r\n              <span class=\"blockDesc\"> <p>This document and the attached links are provided by <a href=\"https://www.usconstitution.net\" target=\"_blank\" class=\"link\"> USConstitution.net.</a> Clicking on the links will take you to their site where they will define or explain the term you clicked.  A summary of the Constitution and what it means can be found on their site here. <a href=\"https://www.usconstitution.net/constquick.html\" target=\"_blank\" class=\"link\"> USConstitution.net\'s summary.</a> </p> </span>\r\n            </div>\r\n </div>\r\n        </div>\r\n        <div class=\"bigTextBlock\">\r\n          <form class=\"ng-pristine ng-valid\">\r\n            <div>\r\n              <div>\r\n<p><center><h1>The Constitution of the United States</h1></center><br>\r\n <p> <strong>Preamble </strong></p><br>\r\n<p>We the People of the United States, in Order to form a more  perfect Union, establish Justice, insure <a href=\"http://www.usconstitution.net/glossary.html#DOMTRAN\" class=\"link\" target=\"_blank\" >domestic Tranquility</a>, provide for the  common <a href=\"http://www.usconstitution.net/constmiss.html\" class=\"link\" target=\"_blank\" >defense</a>, promote the  general <a href=\"http://www.usconstitution.net/glossary.html#WELFARE\" class=\"link\" target=\"_blank\" >Welfare</a>, and secure the  Blessings of Liberty to ourselves and our <a href=\"http://www.usconstitution.net/glossary.html#POSTERITY\" class=\"link\" target=\"_blank\" >posterity</a>, do <a href=\"http://www.usconstitution.net/glossary.html#ORDAIN\" class=\"link\" target=\"_blank\" >ordain</a> and establish  this Constitution for the United States of America.</p>\r\n<p><strong>Article I - The Legislative Branch </strong><br>\r\n  <strong>Section 1 - The Legislature</strong> <br>\r\n  All legislative Powers herein granted shall be vested in a  Congress of the United States, which shall consist of a Senate and House of  Representatives.<br>\r\n  <strong>Section 2 - The House</strong> <br>\r\n  The House of Representatives shall be composed of Members  chosen every second Year by the People of the several States, and the Electors  in each State shall have the Qualifications requisite for Electors of the most  numerous Branch of the State Legislature.<br>\r\n  No Person shall be a Representative who shall not have  attained to the Age of twenty five Years, and been seven Years a Citizen of the  United States, and who shall not, when elected, be an Inhabitant of that State  in which he shall be chosen.<br>\r\n  <em>(Representatives and direct Taxes shall be </em><a href=\"http://www.usconstitution.net/glossary.html#APPORTIONMENT\" class=\"link\" target=\"_blank\" ><em>apportioned</em></a><em> among the  several States which may be included within this Union, according to their  respective Numbers, which shall be determined by adding to the whole Number of  free Persons, including those bound to Service for a Term of Years, and  excluding Indians not taxed, three fifths of all other Persons.)</em> <strong>(The previous  sentence in parentheses was modified by the <u>14th Amendment, section 2</u>.)</strong> The actual <a href=\"http://www.usconstitution.net/glossary.html#ENUMERATE\" class=\"link\" target=\"_blank\" >Enumeration</a> shall be made  within three Years after the first Meeting of the Congress of the United  States, and within every subsequent Term of ten Years, in such manner as they  shall by Law direct. The Number of Representatives shall not exceed one for  every thirty Thousand, but each State shall have at Least one Representative;  and until such <a href=\"http://www.usconstitution.net/glossary.html#ENUMERATE\" class=\"link\" target=\"_blank\" >enumeration</a> shall be made,  the State of New Hampshire shall be entitled to <a href=\"http://www.usconstitution.net/constmiss.html\" class=\"link\" target=\"_blank\" >choose</a> three,  Massachusetts eight, Rhode Island and Providence Plantations one, Connecticut  five, New York six, New Jersey four, Pennsylvania eight, Delaware one, Maryland  six, Virginia ten, North Carolina five, South Carolina five and Georgia three.<br>\r\n  When vacancies happen in the Representation from any State,  the Executive Authority thereof shall issue Writs of Election to fill such  Vacancies.<br>\r\n  The House of Representatives shall <a href=\"http://www.usconstitution.net/constmiss.html\" class=\"link\" target=\"_blank\" >choose</a> their Speaker  and other Officers; and shall have the sole Power of <a href=\"http://www.usconstitution.net/glossary.html#IMPEACH\" class=\"link\" target=\"_blank\" >Impeachment</a>.<br>\r\n  <strong>Section 3 - The Senate</strong> <br>\r\n  The Senate of the United States shall be composed of two  Senators from each State, <em>(chosen by the Legislature thereof,)</em> <strong>(The  preceding words in parentheses superseded by <u>17th Amendment, section 1</u>.)</strong> for six Years;  and each Senator shall have one Vote.<br>\r\n  Immediately after they shall be assembled in Consequence of  the first Election, they shall be divided as equally as may be into three  Classes. The Seats of the Senators of the first Class shall be vacated at the  Expiration of the second Year, of the second Class at the Expiration of the  fourth Year, and of the third Class at the Expiration of the sixth Year, so  that one third may be chosen every second Year; <em>(and if Vacancies happen by  Resignation, or otherwise, during the Recess of the Legislature of any State,  the Executive thereof may make temporary Appointments until the next Meeting of  the Legislature, which shall then fill such Vacancies.)</em> <strong>(The preceding  words in parentheses were superseded by the <u>17th Amendment, section 2</u>.)</strong><br>\r\n  No person shall be a Senator who shall not have attained to  the Age of thirty Years, and been nine Years a Citizen of the United States,  and who shall not, when elected, be an Inhabitant of that State for which he  shall be chosen.<br>\r\n  The Vice President of the United States shall be President of  the Senate, but shall have no Vote, unless they be equally divided.<br>\r\n  The Senate shall <a href=\"http://www.usconstitution.net/constmiss.html\" class=\"link\" target=\"_blank\" >choose</a> their other  Officers, and also a President <a href=\"http://www.usconstitution.net/glossary.html#PROTEM\" class=\"link\" target=\"_blank\" >pro  tempore</a>,  in the absence of the Vice President, or when he shall exercise the Office of  President of the United States.<br>\r\n  The Senate shall have the sole Power to try all <a href=\"http://www.usconstitution.net/glossary.html#IMPEACH\" class=\"link\" target=\"_blank\" >Impeachments</a>. When sitting  for that Purpose, they shall be on Oath or Affirmation. When the President of  the United States is tried, the Chief Justice shall preside: And no Person  shall be convicted without the <a href=\"http://www.usconstitution.net/glossary.html#CONCUR\" class=\"link\" target=\"_blank\" >Concurrence</a> of two thirds of  the Members present.<br>\r\n  Judgment in Cases of <a href=\"http://www.usconstitution.net/glossary.html#IMPEACH\" class=\"link\" target=\"_blank\" >Impeachment</a> shall not extend  further than to removal from Office, and disqualification to hold and enjoy any  Office of honor, Trust or Profit under the United States: but the Party  convicted shall nevertheless be liable and subject to Indictment, Trial,  Judgment and Punishment, according to Law.<br>\r\n  <strong>Section 4 - Elections, Meetings</strong> <br>\r\n  The Times, Places and Manner of holding Elections for Senators  and Representatives, shall be prescribed in each State by the Legislature  thereof; but the Congress may at any time by Law make or alter such  Regulations, except as to the Place of <a href=\"http://www.usconstitution.net/constmiss.html\" class=\"link\" target=\"_blank\" >Choosing</a> Senators.<br>\r\n  The Congress shall assemble at least once in every Year, and  such Meeting shall <em>(be on the first Monday in December,)</em> <strong>(The  preceding words in parentheses were superseded by the <u>20th Amendment, section 2</u>.)</strong> unless they shall by Law appoint a different Day.<br>\r\n  <strong>Section 5 – House Rules</strong> <br>\r\n  Each House shall be the Judge of the Elections, Returns and  Qualifications of its own Members, and a Majority of each shall constitute a <a href=\"http://www.usconstitution.net/glossary.html#QUORUM\" class=\"link\" target=\"_blank\" >Quorum</a> to do Business;  but a smaller number may <a href=\"http://www.usconstitution.net/glossary.html#ADJOURN\" class=\"link\" target=\"_blank\" >adjourn</a> from day to day,  and may be authorized to compel the Attendance of absent Members, in such  Manner, and under such Penalties as each House may provide.<br>\r\n  Each House may determine the Rules of its Proceedings, punish  its Members for disorderly Behavior, and, with the <a href=\"http://www.usconstitution.net/glossary.html#CONCUR\" class=\"link\" target=\"_blank\" >Concurrence</a> of two-thirds,  expel a Member.<br>\r\n  Each House shall keep a Journal of its Proceedings, and from  time to time publish the same, excepting such Parts as may in their Judgment  require Secrecy; and the Yeas and Nays of the Members of either House on any  question shall, at the Desire of one fifth of those Present, be entered on the  Journal.<br>\r\n  Neither House, during the Session of Congress, shall, without  the Consent of the other, <a href=\"http://www.usconstitution.net/glossary.html#ADJOURN\" class=\"link\" target=\"_blank\" >adjourn</a> for more than  three days, nor to any other Place than that in which the two Houses shall be  sitting.<br>\r\n  <strong>Section 6 - Pay</strong> <br>\r\n  <em>(The Senators and Representatives shall receive a Compensation  for their Services, to be ascertained by Law, and paid out of the Treasury of  the United States.)</em> <strong>(The preceding words in parentheses were  modified by the <u>27th  Amendment</u>.)</strong> They shall in all Cases, except <a href=\"http://www.usconstitution.net/glossary.html#TREASON\" class=\"link\" target=\"_blank\" >Treason</a>, Felony and  Breach of the Peace, be privileged from Arrest during their Attendance at the  Session of their respective Houses, and in going to and returning from the  same; and for any Speech or Debate in either House, they shall not be  questioned in any other Place.<br>\r\n  No Senator or Representative shall, during the Time for which  he was elected, be appointed to any civil Office under the Authority of the  United States which shall have been created, or the <a href=\"http://www.usconstitution.net/glossary.html#EMOLUMENT\" class=\"link\" target=\"_blank\" >Emoluments</a> whereof shall  have been increased during such time; and no Person holding any Office under  the United States, shall be a Member of either House during his Continuance in  Office.<br>\r\n  <strong>Section 7 - Revenue Bills, Legislative Process, and  Presidential Veto</strong> <br>\r\n  All bills for raising Revenue shall originate in the House of  Representatives; but the Senate may propose or <a href=\"http://www.usconstitution.net/glossary.html#CONCUR\" class=\"link\" target=\"_blank\" >concur</a> with Amendments  as on other Bills.<br>\r\n  Every Bill which shall have passed the House of  Representatives and the Senate, shall, before it become a Law, be presented to  the President of the United States; If he approve he shall sign it, but if not  he shall return it, with his Objections to that House in which it shall have  originated, who shall enter the Objections at large on their Journal, and  proceed to reconsider it. If after such Reconsideration two thirds of that  House shall agree to pass the Bill, it shall be sent, together with the  Objections, to the other House, by which it shall likewise be reconsidered, and  if approved by two thirds of that House, it shall become a Law. But in all such  Cases the votes of both Houses shall be determined by Yeas and Nays, and the  names of the persons voting for and against the bill shall be entered on the  Journal of each House respectively. If any Bill shall not be returned by the  President within ten Days (Sundays excepted) after it shall have been presented  to him, the Same shall be a Law, in like Manner as if he had signed it, unless  the Congress by their <a href=\"http://www.usconstitution.net/glossary.html#ADJOURN\" class=\"link\" target=\"_blank\" >Adjournment</a> prevent its  Return, in which Case it shall not be a Law.<br>\r\n  Every Order, Resolution, or Vote to which the <a href=\"http://www.usconstitution.net/glossary.html#CONCUR\" class=\"link\" target=\"_blank\" >Concurrence</a> of the Senate  and House of Representatives may be necessary (except on a question of <a href=\"http://www.usconstitution.net/glossary.html#ADJOURN\" class=\"link\" target=\"_blank\" >Adjournment</a>) shall be  presented to the President of the United States; and before the Same shall take  Effect, shall be approved by him, or being disapproved by him, shall be  repassed by two thirds of the Senate and House of Representatives, according to  the Rules and Limitations prescribed in the Case of a Bill.<br>\r\n  <strong>Section 8 – The Powers of Congress</strong> <br>\r\n  The Congress shall have Power To lay and collect Taxes,  Duties, <a href=\"http://www.usconstitution.net/glossary.html#IMPOST\" class=\"link\" target=\"_blank\" >Imposts</a> and <a href=\"http://www.usconstitution.net/glossary.html#EXCISE\" class=\"link\" target=\"_blank\" >Excises</a>, to pay the  Debts and provide for the common Defense and general <a href=\"http://www.usconstitution.net/glossary.html#WELFARE\" class=\"link\" target=\"_blank\" >Welfare</a> of the United  States; but all Duties, <a href=\"http://www.usconstitution.net/glossary.html#IMPOST\" class=\"link\" target=\"_blank\" >Imposts</a> and <a href=\"http://www.usconstitution.net/glossary.html#EXCISE\" class=\"link\" target=\"_blank\" >Excises</a> shall be uniform  throughout the United States;<br>\r\n  To borrow money on the credit of the United States;<br>\r\n  To regulate Commerce with foreign Nations, and among the  several States, and with the Indian Tribes;<br>\r\n  To establish an uniform Rule of Naturalization, and uniform  Laws on the subject of Bankruptcies throughout the United States;<br>\r\n  To coin Money, regulate the Value thereof, and of foreign  Coin, and fix the Standard of Weights and Measures;<br>\r\n  To provide for the Punishment of counterfeiting the Securities  and current Coin of the United States;<br>\r\n  To establish Post Offices and <a href=\"http://www.usconstitution.net/glossary.html#POSTROAD\" class=\"link\" target=\"_blank\" >Post  Roads</a>;<br>\r\n  To promote the Progress of Science and useful Arts, by  securing for limited Times to Authors and Inventors the exclusive Right to  their respective Writings and Discoveries;<br>\r\n  To constitute Tribunals inferior to the Supreme Court;<br>\r\n  To define and punish Piracies and Felonies committed on the  high Seas, and Offenses against the Law of Nations;<br>\r\n  To declare War, grant <a href=\"http://www.usconstitution.net/glossary.html#MARQUE\" class=\"link\" target=\"_blank\" >Letters  of Marque</a> and <a href=\"http://www.usconstitution.net/glossary.html#REPRISAL\" class=\"link\" target=\"_blank\" >Reprisal</a>, and make Rules  concerning Captures on Land and Water;<br>\r\n  To raise and support Armies, but no Appropriation of Money to  that Use shall be for a longer Term than two Years;<br>\r\n  To provide and maintain a Navy;<br>\r\n  To make Rules for the Government and Regulation of the land  and naval Forces;<br>\r\n  To provide for calling forth the Militia to execute the Laws  of the Union, suppress Insurrections and repel Invasions;<br>\r\n  To provide for organizing, arming, and disciplining, the  Militia, and for governing such Part of them as may be employed in the Service  of the United States, reserving to the States respectively, the Appointment of  the Officers, and the Authority of training the Militia according to the  discipline prescribed by Congress;<br>\r\n  To exercise exclusive Legislation in all Cases whatsoever,  over such District (not exceeding ten Miles square) as may, by Cession of  particular States, and the acceptance of Congress, become the Seat of the  Government of the United States, and to exercise like Authority over all Places  purchased by the Consent of the Legislature of the State in which the Same  shall be, for the Erection of Forts, Magazines, Arsenals, dock-Yards, and other  needful Buildings; And<br>\r\n  To make all Laws which shall be necessary and proper for  carrying into Execution the foregoing Powers, and all other Powers vested by  this Constitution in the Government of the United States, or in any Department  or Officer thereof.<br>\r\n  <strong>Section 9 – The Limits on Congress</strong> <br>\r\n  The Migration or Importation of such Persons as any of the  States now existing shall think proper to admit, shall not be prohibited by the  Congress prior to the Year one thousand eight hundred and eight, but a tax or  duty may be imposed on such Importation, not exceeding ten dollars for each  Person.<br>\r\n  The privilege of the Writ of <a href=\"http://www.usconstitution.net/glossary.html#HABCOR\" class=\"link\" target=\"_blank\" >Habeas  Corpus</a> shall not be suspended, unless when in Cases of Rebellion or Invasion the  public Safety may require it.<br>\r\n  No Bill of <a href=\"http://www.usconstitution.net/glossary.html#ATTAINDER\" class=\"link\" target=\"_blank\" >Attainder</a> or <a href=\"http://www.usconstitution.net/glossary.html#EXPOST\" class=\"link\" target=\"_blank\" >ex  post facto</a> Law shall be passed.<br>\r\n  <em>(No capitation, or other direct, Tax shall be laid, unless in  Proportion to the Census or </em><a href=\"http://www.usconstitution.net/glossary.html#ENUMERATE\" class=\"link\" target=\"_blank\" ><em>Enumeration</em></a><em> herein before  directed to be taken.)</em> <strong>(Section in parentheses clarified by the <u>16th Amendment</u>.)</strong><br>\r\n  No Tax or Duty shall be laid on Articles exported from any  State.<br>\r\n  No Preference shall be given by any Regulation of Commerce or  Revenue to the Ports of one State over those of another: nor shall Vessels  bound to, or from, one State, be obliged to enter, clear, or pay Duties in  another.<br>\r\n  No Money shall be drawn from the Treasury, but in Consequence  of Appropriations made by Law; and a regular Statement and Account of the  Receipts and Expenditures of all public Money shall be published from time to  time.<br>\r\n  No <a href=\"http://www.usconstitution.net/glossary.html#NOBILITY\" class=\"link\" target=\"_blank\" >Title  of Nobility</a> shall be granted by the United States: And no Person holding any Office of  Profit or Trust under them, shall, without the Consent of the Congress, accept  of any present, <a href=\"http://www.usconstitution.net/glossary.html#EMOLUMENT\" class=\"link\" target=\"_blank\" >Emolument</a>, Office, or  Title, of any kind whatever, from any King, Prince or foreign State.<br>\r\n  <strong>Section 10 - Powers prohibited of States</strong> <br>\r\n  No State shall enter into any Treaty, Alliance, or  Confederation; grant <a href=\"http://www.usconstitution.net/glossary.html#MARQUE\" class=\"link\" target=\"_blank\" >Letters  of Marque</a> and <a href=\"http://www.usconstitution.net/glossary.html#REPRISAL\" class=\"link\" target=\"_blank\" >Reprisal</a>; coin Money;  emit <a href=\"http://www.usconstitution.net/glossary.html#CREDIT\" class=\"link\" target=\"_blank\" >Bills  of Credit</a>;  make any Thing but gold and silver Coin a Tender in Payment of Debts; pass any  Bill of <a href=\"http://www.usconstitution.net/glossary.html#ATTAINDER\" class=\"link\" target=\"_blank\" >Attainder</a>, <a href=\"http://www.usconstitution.net/glossary.html#EXPOST\" class=\"link\" target=\"_blank\" >ex  post facto</a> Law, or Law impairing the Obligation of Contracts, or grant any <a href=\"http://www.usconstitution.net/glossary.html#NOBILITY\" class=\"link\" target=\"_blank\" >Title  of Nobility</a>.<br>\r\n  No State shall, without the Consent of the Congress, lay any <a href=\"http://www.usconstitution.net/glossary.html#IMPOST\" class=\"link\" target=\"_blank\" >Imposts</a> or Duties on  Imports or Exports, except what may be absolutely necessary for executing <a href=\"http://www.usconstitution.net/constmiss.html\" class=\"link\" target=\"_blank\" >it\'s</a> inspection Laws:  and the net Produce of all Duties and <a href=\"http://www.usconstitution.net/glossary.html#IMPOST\" class=\"link\" target=\"_blank\" >Imposts</a>, laid by any  State on Imports or Exports, shall be for the Use of the Treasury of the United  States; and all such Laws shall be subject to the Revision and <a href=\"http://www.usconstitution.net/constmiss.html\" class=\"link\" target=\"_blank\" >Control</a> of the Congress.<br>\r\n  No State shall, without the Consent of Congress, lay any duty  of Tonnage, keep Troops, or Ships of War in time of Peace, enter into any  Agreement or Compact with another State, or with a foreign Power, or engage in  War, unless actually invaded, or in such imminent Danger as will not admit of  delay.</p>\r\n<p><strong>Article II - The Executive Branch </strong><br>\r\n  <strong>Section 1 - The President</strong> <br>\r\n  The executive Power shall be vested in a President of the  United States of America. He shall hold his Office during the Term of four  Years, and, together with the Vice-President chosen for the same Term, be  elected, as follows:<br>\r\n  Each State shall appoint, in such Manner as the Legislature  thereof may direct, a Number of Electors, equal to the whole Number of Senators  and Representatives to which the State may be entitled in the Congress: but no  Senator or Representative, or Person holding an Office of Trust or Profit under  the United States, shall be appointed an Elector.<br>\r\n  <em>(The Electors shall meet in their respective States, and vote  by Ballot for two persons, of whom one at least shall not lie an Inhabitant of  the same State with themselves. And they shall make a List of all the Persons  voted for, and of the Number of Votes for each; which List they shall sign and  certify, and transmit sealed to the Seat of the Government of the United  States, directed to the President of the Senate. The President of the Senate shall,  in the Presence of the Senate and House of Representatives, open all the  Certificates, and the Votes shall then be counted. The Person having the  greatest Number of Votes shall be the President, if such Number be a Majority  of the whole Number of Electors appointed; and if there be more than one who  have such Majority, and have an equal Number of Votes, then the House of  Representatives shall immediately </em><a href=\"http://www.usconstitution.net/constmiss.html\" class=\"link\" target=\"_blank\" ><em>choose</em></a><em> by Ballot one of  them for President; and if no Person have a Majority, then from the five  highest on the List the said House shall in like Manner </em><a href=\"http://www.usconstitution.net/constmiss.html\" class=\"link\" target=\"_blank\" ><em>choose</em></a><em> the President.  But in </em><a href=\"http://www.usconstitution.net/constmiss.html\" class=\"link\" target=\"_blank\" ><em>choosing</em></a><em> the President,  the Votes shall be taken by States, the Representation from each State having  one Vote; a </em><a href=\"http://www.usconstitution.net/glossary.html#QUORUM\" class=\"link\" target=\"_blank\" ><em>quorum</em></a><em> for this Purpose  shall consist of a Member or Members from two-thirds of the States, and a  Majority of all the States shall be necessary to a Choice. In every Case, after  the Choice of the President, the Person having the greatest Number of Votes of  the Electors shall be the Vice President. But if there should remain two or  more who have equal Votes, the Senate shall </em><a href=\"http://www.usconstitution.net/constmiss.html\" class=\"link\" target=\"_blank\" ><em>choose</em></a><em> from them by  Ballot the Vice-President.)</em> <strong>(This clause in parentheses was superseded by  the <u>12th  Amendment</u>.)</strong><br>\r\n  The Congress may determine the Time of <a href=\"http://www.usconstitution.net/constmiss.html\" class=\"link\" target=\"_blank\" >choosing</a> the Electors,  and the Day on which they shall give their Votes; which Day shall be the same  throughout the United States.<br>\r\n  No person except a natural born Citizen, or a Citizen of the  United States, at the time of the Adoption of this Constitution, shall be  eligible to the Office of President; neither shall any Person be eligible to  that Office who shall not have attained to the Age of thirty-five Years, and  been fourteen Years a Resident within the United States.<br>\r\n  <em>(In Case of the Removal of the President from Office, or of  his Death, Resignation, or Inability to discharge the Powers and Duties of the  said Office, the same shall devolve on the Vice President, and the Congress may  by Law provide for the Case of Removal, Death, Resignation or Inability, both  of the President and Vice President, declaring what Officer shall then act as  President, and such Officer shall act accordingly, until the Disability be  removed, or a President shall be elected.)</em> <strong>(This clause in parentheses has been  modified by the <u>20th</u> and <u>25th  Amendments</u>.)</strong><br>\r\n  The President shall, at stated Times, receive for his  Services, a Compensation, which shall neither be increased nor diminished  during the Period for which he shall have been elected, and he shall not  receive within that Period any other <a href=\"http://www.usconstitution.net/glossary.html#EMOLUMENT\" class=\"link\" target=\"_blank\" >emolument</a> from the United  States, or any of them.<br>\r\n  Before he enter on the Execution of his Office, he shall take  the following Oath or Affirmation:<br>\r\n  &quot;I do solemnly swear (or affirm) that I will faithfully  execute the Office of President of the United States, and will to the best of  my Ability, preserve, protect and defend the Constitution of the United  States.&quot;<br>\r\n  <strong>Section 2 - Civilian Power over Military, Cabinet, Pardon  Power, Appointments</strong> <br>\r\n  The President shall be Commander in Chief of the Army and Navy  of the United States, and of the Militia of the several States, when called  into the actual Service of the United States; he may require the Opinion, in  writing, of the principal Officer in each of the executive Departments, upon  any subject relating to the Duties of their respective Offices, and he shall  have Power to Grant Reprieves and Pardons for Offenses against the United  States, except in Cases of <a href=\"http://www.usconstitution.net/glossary.html#IMPEACH\" class=\"link\" target=\"_blank\" >Impeachment</a>.<br>\r\n  He shall have Power, by and with the Advice and Consent of the  Senate, to make Treaties, provided two thirds of the Senators present <a href=\"http://www.usconstitution.net/glossary.html#CONCUR\" class=\"link\" target=\"_blank\" >concur</a>; and he shall  nominate, and by and with the Advice and Consent of the Senate, shall appoint  Ambassadors, other public Ministers and Consuls, Judges of the supreme Court,  and all other Officers of the United States, whose Appointments are not herein  otherwise provided for, and which shall be established by Law: but the Congress  may by Law vest the Appointment of such inferior Officers, as they think  proper, in the President alone, in the Courts of Law, or in the Heads of  Departments.<br>\r\n  The President shall have Power to fill up all Vacancies that  may happen during the Recess of the Senate, by granting Commissions which shall  expire at the End of their next Session.<br>\r\n  <strong>Section 3 - State of the Union, Convening Congress</strong> <br>\r\n  He shall from time to time give to the Congress Information of  the State of the Union, and recommend to their Consideration such Measures as  he shall judge necessary and expedient; he may, on extraordinary Occasions,  convene both Houses, or either of them, and in Case of Disagreement between  them, with Respect to the Time of <a href=\"http://www.usconstitution.net/glossary.html#ADJOURN\" class=\"link\" target=\"_blank\" >Adjournment</a>, he may <a href=\"http://www.usconstitution.net/glossary.html#ADJOURN\" class=\"link\" target=\"_blank\" >adjourn</a> them to such  Time as he shall think proper; he shall receive Ambassadors and other public  Ministers; he shall take Care that the Laws be faithfully executed, and shall  Commission all the Officers of the United States.<br>\r\n  <strong>Section 4 - Disqualification</strong> <br>\r\n  The President, Vice President and all civil Officers of the  United States, shall be removed from Office on <a href=\"http://www.usconstitution.net/glossary.html#IMPEACH\" class=\"link\" target=\"_blank\" >Impeachment</a> for, and  Conviction of, <a href=\"http://www.usconstitution.net/glossary.html#TREASON\" class=\"link\" target=\"_blank\" >Treason</a>, Bribery, or  other high Crimes and Misdemeanors.</p>\r\n<p><strong>Article III - The Judicial Branch </strong><br>\r\n  <strong>Section 1 - Judicial powers</strong> <br>\r\n  The judicial Power of the United States shall be vested in one  Supreme Court, and in such inferior Courts as the Congress may from time to  time <a href=\"http://www.usconstitution.net/glossary.html#ORDAIN\" class=\"link\" target=\"_blank\" >ordain</a> and establish.  The Judges, both of the supreme and inferior Courts, shall hold their Offices  during good Behavior, and shall, at stated Times, receive for their Services a  Compensation which shall not be diminished during their Continuance in Office.<br>\r\n  <strong>Section 2 - Trial by Jury, Original Jurisdiction, Jury Trials</strong> <br>\r\n  <em>(The judicial Power shall extend to all Cases, in Law and  Equity, arising under this Constitution, the Laws of the United States, and  Treaties made, or which shall be made, under their Authority; to all Cases  affecting Ambassadors, other public Ministers and Consuls; to all Cases of  admiralty and maritime </em><a href=\"http://www.usconstitution.net/glossary.html#JURIS\" class=\"link\" target=\"_blank\" ><em>Jurisdiction</em></a><em>; to  Controversies to which the United States shall be a Party; to Controversies  between two or more States; between a State and Citizens of another State;  between Citizens of different States; between Citizens of the same State  claiming Lands under Grants of different States, and between a State, or the  Citizens thereof, and foreign States, Citizens or Subjects.)</em> <strong>(This section  in parentheses is modified by the <u>11th Amendment</u>.)</strong><br>\r\n  In all Cases affecting Ambassadors, other public Ministers and  Consuls, and those in which a State shall be Party, the Supreme Court shall  have original <a href=\"http://www.usconstitution.net/glossary.html#JURIS\" class=\"link\" target=\"_blank\" >Jurisdiction</a>. In all the  other Cases before mentioned, the Supreme Court shall have <a href=\"http://www.usconstitution.net/glossary.html#APPELLATE\" class=\"link\" target=\"_blank\" >appellate</a> <a href=\"http://www.usconstitution.net/glossary.html#JURIS\" class=\"link\" target=\"_blank\" >Jurisdiction</a>, both as to Law  and Fact, with such Exceptions, and under such Regulations as the Congress  shall make.<br>\r\n  The Trial of all Crimes, except in Cases of <a href=\"http://www.usconstitution.net/glossary.html#IMPEACH\" class=\"link\" target=\"_blank\" >Impeachment</a>, shall be by  Jury; and such Trial shall be held in the State where the said Crimes shall  have been committed; but when not committed within any State, the Trial shall  be at such Place or Places as the Congress may by Law have directed.<br>\r\n  <strong>Section 3 - Treason</strong> <br>\r\n  <a href=\"http://www.usconstitution.net/glossary.html#TREASON\" class=\"link\" target=\"_blank\" >Treason</a> against the  United States shall consist only in levying War against them, or in adhering to  their Enemies, giving them Aid and Comfort. No Person shall be convicted of <a href=\"http://www.usconstitution.net/glossary.html#TREASON\" class=\"link\" target=\"_blank\" >Treason</a> unless on the  Testimony of two Witnesses to the same overt Act, or on Confession in open  Court.<br>\r\n  The Congress shall have power to declare the Punishment of <a href=\"http://www.usconstitution.net/glossary.html#TREASON\" class=\"link\" target=\"_blank\" >Treason</a>, but no  Attainder of <a href=\"http://www.usconstitution.net/glossary.html#TREASON\" class=\"link\" target=\"_blank\" >Treason</a> shall work <a href=\"http://www.usconstitution.net/glossary.html#BLOOD\" class=\"link\" target=\"_blank\" >Corruption  of Blood</a>,  or Forfeiture except during the Life of the Person attainted.</p>\r\n<p><strong>Article IV - The States</strong><br>\r\n  <strong>Section 1 - Each State to Honor all others</strong> <br>\r\n  Full Faith and Credit shall be given in each State to the  public Acts, Records, and judicial Proceedings of every other State. And the  Congress may by general Laws prescribe the Manner in which such Acts, Records  and Proceedings shall be proved, and the Effect thereof.<br>\r\n  <strong>Section 2 - State citizens, Extradition</strong> <br>\r\n  The Citizens of each State shall be entitled to all Privileges  and Immunities of Citizens in the several States.<br>\r\n  A Person charged in any State with <a href=\"http://www.usconstitution.net/glossary.html#TREASON\" class=\"link\" target=\"_blank\" >Treason</a>, Felony, or  other Crime, who shall flee from Justice, and be found in another State, shall  on demand of the executive Authority of the State from which he fled, be  delivered up, to be removed to the State having <a href=\"http://www.usconstitution.net/glossary.html#JURIS\" class=\"link\" target=\"_blank\" >Jurisdiction</a> of the Crime.<br>\r\n  <em>(No Person held to Service or </em><a href=\"http://www.usconstitution.net/constmiss.html\" class=\"link\" target=\"_blank\" ><em>Labor</em></a><em> in one State,  under the Laws thereof, escaping into another, shall, in Consequence of any Law  or Regulation therein, be discharged from such Service or </em><a href=\"http://www.usconstitution.net/constmiss.html\" class=\"link\" target=\"_blank\" ><em>Labor</em></a><em>, But shall be  delivered up on Claim of the Party to whom such Service or </em><a href=\"http://www.usconstitution.net/constmiss.html\" class=\"link\" target=\"_blank\" ><em>Labor</em></a><em> may be due.)</em> <strong>(This clause  in parentheses is superseded by the <u>13th Amendment</u>.)</strong><br>\r\n  <strong>Section 3 - New States</strong> <br>\r\n  New States may be admitted by the Congress into this Union;  but no new States shall be formed or erected within the <a href=\"http://www.usconstitution.net/glossary.html#JURIS\" class=\"link\" target=\"_blank\" >Jurisdiction</a> of any other  State; nor any State be formed by the Junction of two or more States, or parts  of States, without the Consent of the Legislatures of the States concerned as  well as of the Congress.<br>\r\n  The Congress shall have Power to dispose of and make all  needful Rules and Regulations respecting the Territory or other Property  belonging to the United States; and nothing in this Constitution shall be so  construed as to Prejudice any Claims of the United States, or of any particular  State.<br>\r\n  <strong>Section 4 - Republican government</strong> <br>\r\n  The United States shall guarantee to every State in this Union  a <a href=\"http://www.usconstitution.net/glossary.html#REPUBLIC\" class=\"link\" target=\"_blank\" >Republican</a> Form of  Government, and shall protect each of them against Invasion; and on Application  of the Legislature, or of the Executive (when the Legislature cannot be  convened) against domestic Violence.</p>\r\n<p><strong>Article V - Amendment </strong><br>\r\n  The Congress, whenever two thirds of both Houses shall deem it  necessary, shall propose Amendments to this Constitution, or, on the  Application of the Legislatures of two thirds of the several States, shall call  a Convention for proposing Amendments, which, in either Case, shall be valid to  all Intents and Purposes, as part of this Constitution, when ratified by the  Legislatures of three fourths of the several States, or by Conventions in three  fourths thereof, as the one or the other Mode of Ratification may be proposed  by the Congress; Provided that no Amendment which may be made prior to the Year  One thousand eight hundred and eight shall in any Manner affect the <u>first</u> and <u>fourth</u> Clauses in the Ninth Section of the first Article; and that no State, without  its Consent, shall be <a href=\"http://www.usconstitution.net/glossary.html#DEPRIVE\" class=\"link\" target=\"_blank\" >deprived</a> of its equal  Suffrage in the Senate.</p>\r\n<p><strong>Article VI - Debts, Supremacy, Oaths</strong><br>\r\n  All Debts contracted and Engagements entered into, before the  Adoption of this Constitution, shall be as valid against the United States  under this Constitution, as under the Confederation.<br>\r\n  This Constitution, and the Laws of the United States which  shall be made in Pursuance thereof; and all Treaties made, or which shall be  made, under the Authority of the United States, shall be the supreme Law of the  Land; and the Judges in every State shall be bound thereby, any Thing in the  Constitution or Laws of any State to the Contrary notwithstanding.<br>\r\n  The Senators and Representatives before mentioned, and the  Members of the several State Legislatures, and all executive and judicial  Officers, both of the United States and of the several States, shall be bound  by Oath or Affirmation, to support this Constitution; but no religious Test shall  ever be required as a Qualification to any Office or public Trust under the  United States.</p>\r\n<p><strong>Article VII - Ratification </strong><br>\r\n  The Ratification of the Conventions of nine States shall be  sufficient for the Establishment of this Constitution between the States so  ratifying the same.</p>\r\n<p>Done in Convention by the Unanimous Consent of the States  present the Seventeenth Day of September in the Year of our Lord one thousand  seven hundred and Eighty seven and of the Independence of the United States of  America the Twelfth. In Witness whereof we have hereunto subscribed our Names. <br>\r\n  Go Washington - President and deputy from Virginia<br>\r\n  New Hampshire - John Langdon, Nicholas Gilman<br>\r\n  Massachusetts - Nathaniel Gorham, Rufus King<br>\r\n  Connecticut - Wm Saml Johnson, Roger Sherman<br>\r\n  New York - Alexander Hamilton<br>\r\n  New Jersey - Wil Livingston, David Brearley, Wm Paterson,  Jona. Dayton<br>\r\n  <a href=\"http://www.usconstitution.net/constmiss.html\" class=\"link\" target=\"_blank\" >Pennsylvania</a> - B Franklin,  Thomas Mifflin, Robt Morris, Geo. Clymer, Thos FitzSimons, Jared Ingersoll,  James Wilson, Gouv Morris<br>\r\n  Delaware - Geo. Read, Gunning Bedford jun, John Dickinson,  Richard Bassett, Jaco. Broom<br>\r\n  Maryland - James McHenry, Dan of St Tho Jenifer, Danl Carroll<br>\r\n  Virginia - John Blair, James Madison Jr.<br>\r\n  North Carolina - Wm Blount, Richd Dobbs Spaight, Hu Williamson<br>\r\n  South Carolina - J. Rutledge, Charles Cotesworth Pinckney,  Charles Pinckney, Pierce Butler<br>\r\n  Georgia - William Few, Abr Baldwin<br>\r\n  Attest: William Jackson, Secretary</p>\r\n<p><strong>The Amendments </strong><br>\r\n  <strong>Below are the Amendments to the Constitution. The first ten  Amendments collectively are called the </strong><a href=\"http://www.usconstitution.net/consttop_bor.html\" class=\"link\" target=\"_blank\" ><strong>Bill  of Rights.</strong></a></p>\r\n<p><strong>Amendment 1 – (Freedom of Religion, Press, and Peaceful  Assembly) </strong><a href=\"http://www.usconstitution.net/constamrat.html#BoR\" class=\"link\" target=\"_blank\" ><strong>Ratified</strong></a><strong> 12/15/1791.</strong> <br>\r\n  Congress shall make no law respecting an establishment of  religion, or prohibiting the free exercise thereof; or abridging the freedom of  speech, or of the press; or the right of the people peaceably to assemble, and  to petition the Government for a <a href=\"http://www.usconstitution.net/glossary.html#REDRESS\" class=\"link\" target=\"_blank\" >redress</a> of grievances.</p>\r\n<p><strong>Amendment 2 – (Right to Bear Arms.) </strong><a href=\"http://www.usconstitution.net/constamrat.html#BoR\" class=\"link\" target=\"_blank\" ><strong>Ratified</strong></a><strong> 12/15/1791.</strong> <br>\r\n  A well regulated Militia, being necessary to the security of a  free State, the right of the people to keep and bear Arms, shall not be <a href=\"http://www.usconstitution.net/glossary.html#INFRINGE\" class=\"link\" target=\"_blank\" >infringed</a>.</p>\r\n<p><strong>Amendment 3 – (Forced Housing of Soldiers.) </strong><a href=\"http://www.usconstitution.net/constamrat.html#BoR\" class=\"link\" target=\"_blank\" ><strong>Ratified</strong></a><strong> 12/15/1791.</strong> <br>\r\n  No Soldier shall, in time of peace be <a href=\"http://www.usconstitution.net/glossary.html#QUARTER\" class=\"link\" target=\"_blank\" >quartered</a> in any house,  without the consent of the Owner, nor in time of war, but in a manner to be  prescribed by law.</p>\r\n<p><strong>Amendment 4 – (Unreasonable Search and Seizure.) </strong><a href=\"http://www.usconstitution.net/constamrat.html#BoR\" class=\"link\" target=\"_blank\" ><strong>Ratified</strong></a><strong> 12/15/1791.</strong> <br>\r\n  The right of the people to be secure in their persons, houses,  papers, and effects, against unreasonable searches and seizures, shall not be  violated, and no Warrants shall issue, but upon probable cause, supported by  Oath or affirmation, and particularly describing the place to be searched, and  the persons or things to be seized.</p>\r\n<p><strong>Amendment 5 – (Trial Rights Barring Self Incrimination, Double  Jeopardy..) </strong><a href=\"http://www.usconstitution.net/constamrat.html#BoR\" class=\"link\" target=\"_blank\" ><strong>Ratified</strong></a><strong> 12/15/1791.</strong> <br>\r\n  No person shall be held to answer for a capital, or otherwise  infamous crime, unless on a presentment or indictment of a Grand Jury, except  in cases arising in the land or naval forces, or in the Militia, when in actual  service in time of War or public danger; nor shall any person <a href=\"http://www.usconstitution.net/glossary.html#DOUBLEJ\" class=\"link\" target=\"_blank\" >be  subject for the same offense to be twice put in jeopardy of life or limb</a>; nor shall be  compelled in any criminal case to be a witness against himself, nor be <a href=\"http://www.usconstitution.net/glossary.html#DEPRIVE\" class=\"link\" target=\"_blank\" >deprived</a> of life,  liberty, or property, without <a href=\"http://www.usconstitution.net/consttop_duep.html\" class=\"link\" target=\"_blank\" >due process</a> of law; nor  shall private property be taken for public use, without just compensation.</p>\r\n<p><strong>Amendment 6 – (Right to Speedy Trial, Confrontation of  Witnesses.) </strong><a href=\"http://www.usconstitution.net/constamrat.html#BoR\" class=\"link\" target=\"_blank\" ><strong>Ratified</strong></a><strong> 12/15/1791.</strong> <br>\r\n  In all criminal prosecutions, the accused shall enjoy the  right to a speedy and public trial, by an <a href=\"http://www.usconstitution.net/glossary.html#IMPARTIAL\" class=\"link\" target=\"_blank\" >impartial</a> jury of the  State and district wherein the crime shall have been committed, which district  shall have been previously ascertained by law, and to be informed of the nature  and cause of the accusation; to be confronted with the witnesses against him;  to have compulsory process for obtaining witnesses in his favor, and to have the  Assistance of Counsel for his <a href=\"http://www.usconstitution.net/constmiss.html\" class=\"link\" target=\"_blank\" >defense</a>.</p>\r\n<p><strong>Amendment 7 – (Right to Trial by Jury in Civil Cases.) </strong><a href=\"http://www.usconstitution.net/constamrat.html#BoR\" class=\"link\" target=\"_blank\" ><strong>Ratified</strong></a><strong> 12/15/1791.</strong> <br>\r\n  In Suits at common law, where the value in controversy shall  exceed twenty dollars, the right of trial by jury shall be preserved, and no  fact tried by a jury, shall be otherwise re-examined in any Court of the United  States, than according to the rules of the common law.</p>\r\n<p><strong>Amendment 8 – (Barring Cruel and Unusual Punishment.) </strong><a href=\"http://www.usconstitution.net/constamrat.html#BoR\" class=\"link\" target=\"_blank\" ><strong>Ratified</strong></a><strong> 12/15/1791.</strong> <br>\r\n  Excessive bail shall not be required, nor excessive fines  imposed, nor cruel and unusual punishments inflicted.</p>\r\n<p><strong>Amendment 9 – (Construction of the Constitution.) </strong><a href=\"http://www.usconstitution.net/constamrat.html#BoR\" class=\"link\" target=\"_blank\" ><strong>Ratified</strong></a><strong> 12/15/1791.</strong> <br>\r\n  The <a href=\"http://www.usconstitution.net/glossary.html#ENUMERATE\" class=\"link\" target=\"_blank\" >enumeration</a> in the  Constitution, of certain rights, shall not be construed to deny or disparage  others retained by the people.</p>\r\n<p><strong>Amendment 10 – (Powers of the States and People.)</strong><a href=\"http://www.usconstitution.net/constamrat.html#BoR\" class=\"link\" target=\"_blank\" ><strong>Ratified</strong></a><strong> 12/15/1791.</strong> <br>\r\n  The powers not delegated to the United States by the  Constitution, nor prohibited by it to the States, are reserved to the States  respectively, or to the people.</p>\r\n<p><strong>Amendment 11 – (Limits of Judicial Power). </strong><a href=\"http://www.usconstitution.net/constamrat.html#Am11\" class=\"link\" target=\"_blank\" ><strong>Ratified</strong></a><strong> 2/7/1795.</strong> <br>\r\n  The Judicial power of the United States shall not be construed  to extend to any suit in law or equity, commenced or prosecuted against one of  the United States by Citizens of another State, or by Citizens or Subjects of  any Foreign State.</p>\r\n<p><strong>Amendment 12 – (Choosing the President and Vice-President.)</strong><a href=\"http://www.usconstitution.net/constamrat.html#Am12\" class=\"link\" target=\"_blank\" ><strong>Ratified</strong></a><strong> 6/15/1804.</strong> The Electors  shall meet in their respective states, and vote by ballot for President and  Vice-President, one of whom, at least, shall not be an inhabitant of the same  state with themselves; they shall name in their ballots the person voted for as  President, and in distinct ballots the person voted for as Vice-President, and  they shall make distinct lists of all persons voted for as President, and of  all persons voted for as Vice-President and of the number of votes for each,  which lists they shall sign and certify, and transmit sealed to the seat of the  government of the United States, directed to the President of the Senate;<br>\r\n  The President of the Senate shall, in the presence of the  Senate and House of Representatives, open all the certificates and the votes  shall then be counted;<br>\r\n  The person having the greatest Number of votes for President,  shall be the President, if such number be a majority of the whole number of  Electors appointed; and if no person have such majority, then from the persons  having the highest numbers not exceeding three on the list of those voted for  as President, the House of Representatives shall choose immediately, by ballot,  the President. But in choosing the President, the votes shall be taken by  states, the representation from each state having one vote; a <a href=\"http://www.usconstitution.net/glossary.html#QUORUM\" class=\"link\" target=\"_blank\" >quorum</a> for this purpose  shall consist of a member or members from two-thirds of the states, and a  majority of all the states shall be necessary to a choice. And if the House of  Representatives shall not choose a President whenever the right of choice shall  devolve upon them, before the fourth day of March next following, then the  Vice-President shall act as President, as in the case of the death or other  constitutional disability of the President.<br>\r\n  The person having the greatest number of votes as  Vice-President, shall be the Vice-President, if such number be a majority of  the whole number of Electors appointed, and if no person have a majority, then  from the two highest numbers on the list, the Senate shall choose the  Vice-President; a <a href=\"http://www.usconstitution.net/glossary.html#QUORUM\" class=\"link\" target=\"_blank\" >quorum</a> for the purpose  shall consist of two-thirds of the whole number of Senators, and a majority of  the whole number shall be necessary to a choice. But no person constitutionally  ineligible to the office of President shall be eligible to that of  Vice-President of the United States.</p>\r\n<p><strong>Amendment 13 – (Slavery Abolished.) </strong><a href=\"http://www.usconstitution.net/constamrat.html#Am13\" class=\"link\" target=\"_blank\" ><strong>Ratified</strong></a><strong> 12/6/1865.</strong> <br>\r\n  1. Neither slavery nor involuntary servitude, except as a  punishment for crime whereof the party shall have been duly convicted, shall  exist within the United States, or any place subject to their <a href=\"http://www.usconstitution.net/glossary.html#JURIS\" class=\"link\" target=\"_blank\" >jurisdiction</a>.<br>\r\n  2. Congress shall have power to enforce this article by  appropriate legislation.</p>\r\n<p><strong>Amendment 14 – (Protecting all Citizens Rights and Preventing  Rebels from Taking Over the Government.) </strong><a href=\"http://www.usconstitution.net/constamrat.html#Am14\" class=\"link\" target=\"_blank\" ><strong>Ratified</strong></a><strong> 7/9/1868.</strong> <br>\r\n  1. All persons born or naturalized in the United States, and  subject to the <a href=\"http://www.usconstitution.net/glossary.html#JURIS\" class=\"link\" target=\"_blank\" >jurisdiction</a> thereof, are  citizens of the United States and of the State wherein they reside. No State  shall make or enforce any law which shall abridge the privileges or immunities  of citizens of the United States; nor shall any State <a href=\"http://www.usconstitution.net/glossary.html#DEPRIVE\" class=\"link\" target=\"_blank\" >deprive</a> any person of  life, liberty, or property, without <a href=\"http://www.usconstitution.net/consttop_duep.html\" class=\"link\" target=\"_blank\" >due process</a> of law; nor deny  to any person within its <a href=\"http://www.usconstitution.net/glossary.html#JURIS\" class=\"link\" target=\"_blank\" >jurisdiction</a> the equal  protection of the laws.<br>\r\n  2. Representatives shall be <a href=\"http://www.usconstitution.net/glossary.html#APPORTIONMENT\" class=\"link\" target=\"_blank\" >apportioned</a> among the  several States according to their respective numbers, counting the whole number  of persons in each State, excluding Indians not taxed. But when the right to  vote at any election for the choice of electors for President and  Vice-President of the United States, Representatives in Congress, the Executive  and Judicial officers of a State, or the members of the Legislature thereof, is  denied to any of the male inhabitants of such State, being twenty-one years of  age, and citizens of the United States, or in any way abridged, except for  participation in rebellion, or other crime, the basis of representation therein  shall be reduced in the proportion which the number of such male citizens shall  bear to the whole number of male citizens twenty-one years of age in such  State.<br>\r\n  3. No person shall be a Senator or Representative in Congress,  or elector of President and Vice-President, or hold any office, civil or  military, under the United States, or under any State, who, having previously  taken an oath, as a member of Congress, or as an officer of the United States, or  as a member of any State legislature, or as an executive or judicial officer of  any State, to support the Constitution of the United States, shall have engaged  in insurrection or rebellion against the same, or given aid or comfort to the  enemies thereof. But Congress may by a vote of two-thirds of each House, remove  such disability.<br>\r\n  4. The validity of the public debt of the United States,  authorized by law, including debts incurred for payment of pensions and  bounties for services in suppressing insurrection or rebellion, shall not be  questioned. But neither the United States nor any State shall assume or pay any  debt or obligation incurred in aid of insurrection or rebellion against the  United States, or any claim for the loss or emancipation of any slave; but all  such debts, obligations and claims shall be held illegal and void.<br>\r\n  5. The Congress shall have power to enforce, by appropriate  legislation, the provisions of this article.</p>\r\n<p><strong>Amendment 15 – (All Races Can Vote.) </strong><a href=\"http://www.usconstitution.net/constamrat.html#Am15\" class=\"link\" target=\"_blank\" ><strong>Ratified</strong></a><strong> 2/3/1870.</strong> <br>\r\n  1. The right of citizens of the United States to vote shall  not be denied or abridged by the United States or by any State on account of  race, color, or previous condition of servitude.<br>\r\n  2. The Congress shall have power to enforce this article by  appropriate legislation.</p>\r\n<p><strong>Amendment 16 – (Status of Income Tax Clarified.) </strong><a href=\"http://www.usconstitution.net/constamrat.html#Am16\" class=\"link\" target=\"_blank\" ><strong>Ratified</strong></a><strong> 2/3/1913.</strong> <br>\r\n  The Congress shall have power to lay and collect taxes on  incomes, from whatever source derived, without <a href=\"http://www.usconstitution.net/glossary.html#APPORTIONMENT\" class=\"link\" target=\"_blank\" >apportionment</a> among the  several States, and without regard to any census or <a href=\"http://www.usconstitution.net/glossary.html#ENUMERATE\" class=\"link\" target=\"_blank\" >enumeration</a>.</p>\r\n<p><strong>Amendment 17 – (Senators Elected by Popular Vote.)</strong><a href=\"http://www.usconstitution.net/constamrat.html#Am17\" class=\"link\" target=\"_blank\" ><strong>Ratified</strong></a><strong> 4/8/1913.</strong> <br>\r\n  The Senate of the United States shall be composed of two  Senators from each State, elected by the people thereof, for six years; and  each Senator shall have one vote. The electors in each State shall have the  qualifications requisite for electors of the most numerous branch of the State  legislatures.<br>\r\n  When vacancies happen in the representation of any State in  the Senate, the executive authority of such State shall issue writs of election  to fill such vacancies: Provided, That the legislature of any State may empower  the executive thereof to make temporary appointments until the people fill the  vacancies by election as the legislature may direct.<br>\r\n  This amendment shall not be so construed as to affect the  election or term of any Senator chosen before it becomes valid as part of the  Constitution.</p>\r\n<p><strong>Amendment 18 – (Liquor Outlawed.) </strong><a href=\"http://www.usconstitution.net/constamrat.html#Am18\" class=\"link\" target=\"_blank\" ><strong>Ratified</strong></a><strong> 1/16/1919.  Repealed by <u>Amendment  21</u>, 12/5/1933.</strong> <br>\r\n  1. After one year from the ratification of this article the  manufacture, sale, or transportation of intoxicating liquors within, the  importation thereof into, or the exportation thereof from the United States and  all territory subject to the <a href=\"http://www.usconstitution.net/glossary.html#JURIS\" class=\"link\" target=\"_blank\" >jurisdiction</a> thereof for  beverage purposes is hereby prohibited.<br>\r\n  2. The Congress and the several States shall have concurrent  power to enforce this article by appropriate legislation.<br>\r\n  3. This article shall be inoperative unless it shall have been  ratified as an amendment to the Constitution by the legislatures of the several  States, as provided in the Constitution, within seven years from the date of  the submission hereof to the States by the Congress.</p>\r\n<p><strong>Amendment 19 – (Women\'s </strong><a href=\"http://www.usconstitution.net/glossary.html#SUFF\" class=\"link\" target=\"_blank\" ><strong>Suffrage</strong></a><strong>.) </strong><a href=\"http://www.usconstitution.net/constamrat.html#Am19\" class=\"link\" target=\"_blank\" ><strong>Ratified</strong></a><strong> 8/18/1920.</strong> <br>\r\n  The right of citizens of the United States to vote shall not  be denied or abridged by the United States or by any State on account of sex.<br>\r\n  Congress shall have power to enforce this article by  appropriate legislation.</p>\r\n<p><strong>Amendment 20 – (Starts Dates of Terms of Office.) </strong><a href=\"http://www.usconstitution.net/constamrat.html#Am20\" class=\"link\" target=\"_blank\" ><strong>Ratified</strong></a><strong> 1/23/1933.</strong> <br>\r\n  1. The terms of the President and Vice President shall end at  noon on the 20th day of January, and the terms of Senators and Representatives  at noon on the 3d day of January, of the years in which such terms would have  ended if this article had not been ratified; and the terms of their successors  shall then begin.<br>\r\n  2. The Congress shall assemble at least once in every year,  and such meeting shall begin at noon on the 3d day of January, unless they  shall by law appoint a different day.<br>\r\n  3. If, at the time fixed for the beginning of the term of the  President, the President elect shall have died, the Vice President elect shall  become President. If a President shall not have been chosen before the time  fixed for the beginning of his term, or if the President elect shall have  failed to qualify, then the Vice President elect shall act as President until a  President shall have qualified; and the Congress may by law provide for the  case wherein neither a President elect nor a Vice President elect shall have  qualified, declaring who shall then act as President, or the manner in which  one who is to act shall be selected, and such person shall act accordingly  until a President or Vice President shall have qualified.<br>\r\n  4. The Congress may by law provide for the case of the death  of any of the persons from whom the House of Representatives may choose a  President whenever the right of choice shall have devolved upon them, and for  the case of the death of any of the persons from whom the Senate may choose a  Vice President whenever the right of choice shall have devolved upon them.<br>\r\n  5. Sections 1 and 2 shall take effect on the 15th day of  October following the ratification of this article.<br>\r\n  6. This article shall be inoperative unless it shall have been  ratified as an amendment to the Constitution by the legislatures of  three-fourths of the several States within seven years from the date of its  submission.</p>\r\n<p><strong>Amendment 21 – (Prohibition Repealed.) </strong><a href=\"http://www.usconstitution.net/constamrat.html#Am21\" class=\"link\" target=\"_blank\" ><strong>Ratified</strong></a><strong> 12/5/1933.</strong> <br>\r\n  1. The eighteenth article of amendment to the Constitution of  the United States is hereby repealed.<br>\r\n  2. The transportation or importation into any State,  Territory, or possession of the United States for delivery or use therein of  intoxicating liquors, in violation of the laws thereof, is hereby prohibited.<br>\r\n  3. The article shall be inoperative unless it shall have been  ratified as an amendment to the Constitution by conventions in the several  States, as provided in the Constitution, within seven years from the date of  the submission hereof to the States by the Congress.</p>\r\n<p><strong>Amendment 22 – (Presidential Term Limits.) </strong><a href=\"http://www.usconstitution.net/constamrat.html#Am22\" class=\"link\" target=\"_blank\" ><strong>Ratified</strong></a><strong> 2/27/1951</strong> <br>\r\n  1. No person shall be elected to the office of the President  more than twice, and no person who has held the office of President, or acted  as President, for more than two years of a term to which some other person was  elected President shall be elected to the office of the President more than  once. But this Article shall not apply to any person holding the office of  President, when this Article was proposed by the Congress, and shall not  prevent any person who may be holding the office of President, or acting as  President, during the term within which this Article becomes operative from holding  the office of President or acting as President during the remainder of such  term.<br>\r\n  2. This article shall be inoperative unless it shall have been  ratified as an amendment to the Constitution by the legislatures of  three-fourths of the several States within seven years from the date of its  submission to the States by the Congress.</p>\r\n<p><strong>Amendment 23 – (Presidential Vote for District of Columbia). </strong><a href=\"http://www.usconstitution.net/constamrat.html#Am23\" class=\"link\" target=\"_blank\" ><strong>Ratified</strong></a><strong> 3/29/1961.</strong> <br>\r\n  1. The District constituting the seat of Government of the  United States shall appoint in such manner as the Congress may direct: A number  of electors of President and Vice President equal to the whole number of  Senators and Representatives in Congress to which the District would be  entitled if it were a State, but in no event more than the least populous  State; they shall be in addition to those appointed by the States, but they  shall be considered, for the purposes of the election of President and Vice  President, to be electors appointed by a State; and they shall meet in the  District and perform such duties as provided by the twelfth article of  amendment.<br>\r\n  2. The Congress shall have power to enforce this article by  appropriate legislation.</p>\r\n<p><strong>Amendment 24 – (</strong><a href=\"http://www.usconstitution.net/glossary.html#POLLTAX\" class=\"link\" target=\"_blank\" ><strong>Poll  Tax</strong></a><strong> outlawed.) </strong><a href=\"http://www.usconstitution.net/constamrat.html#Am24\" class=\"link\" target=\"_blank\" ><strong>Ratified</strong></a><strong> 1/23/1964.</strong> <br>\r\n  1. The right of citizens of the United States to vote in any  primary or other election for President or Vice President, for electors for  President or Vice President, or for Senator or Representative in Congress,  shall not be denied or abridged by the United States or any State by reason of  failure to pay any <a href=\"http://www.usconstitution.net/glossary.html#POLLTAX\" class=\"link\" target=\"_blank\" >poll  tax</a> or other tax.<br>\r\n  2. The Congress shall have power to enforce this article by  appropriate legislation.</p>\r\n<p><strong>Amendment 25 – (Presidential Disability and Succession.) </strong><a href=\"http://www.usconstitution.net/constamrat.html#Am25\" class=\"link\" target=\"_blank\" ><strong>Ratified</strong></a><strong> 2/10/1967.</strong> <br>\r\n  1. In case of the removal of the President from office or of  his death or resignation, the Vice President shall become President.<br>\r\n  2. Whenever there is a vacancy in the office of the Vice  President, the President shall nominate a Vice President who shall take office  upon confirmation by a majority vote of both Houses of Congress.<br>\r\n  3. Whenever the President transmits to the President pro  tempore of the Senate and the Speaker of the House of Representatives his  written declaration that he is unable to discharge the powers and duties of his  office, and until he transmits to them a written declaration to the contrary,  such powers and duties shall be discharged by the Vice President as Acting  President.<br>\r\n  4. Whenever the Vice President and a majority of either the  principal officers of the executive departments or of such other body as  Congress may by law provide, transmit to the President pro tempore of the  Senate and the Speaker of the House of Representatives their written  declaration that the President is unable to discharge the powers and duties of  his office, the Vice President shall immediately assume the powers and duties  of the office as Acting President.<br>\r\n  Thereafter, when the President transmits to the President pro  tempore of the Senate and the Speaker of the House of Representatives his  written declaration that no inability exists, he shall resume the powers and  duties of his office unless the Vice President and a majority of either the  principal officers of the executive department or of such other body as  Congress may by law provide, transmit within four days to the President pro  tempore of the Senate and the Speaker of the House of Representatives their  written declaration that the President is unable to discharge the powers and  duties of his office. Thereupon Congress shall decide the issue, assembling  within forty-eight hours for that purpose if not in session. If the Congress,  within twenty one days after receipt of the latter written declaration, or, if  Congress is not in session, within twenty one days after Congress is required  to assemble, determines by two thirds vote of both Houses that the President is  unable to discharge the powers and duties of his office, the Vice President  shall continue to discharge the same as Acting President; otherwise, the  President shall resume the powers and duties of his office.</p>\r\n<p><strong>Amendment 26 – (Voting Age Set to 18. )</strong><a href=\"http://www.usconstitution.net/constamrat.html#Am26\" class=\"link\" target=\"_blank\" ><strong>Ratified</strong></a><strong> 7/1/1971.</strong> <br>\r\n  1. The right of citizens of the United States, who are  eighteen years of age or older, to vote shall not be denied or abridged by the  United States or by any State on account of age.<br>\r\n  2. The Congress shall have power to enforce this article by  appropriate legislation.</p>\r\n<p><strong>Amendment 27 – (Limits to Congress giving themselves pay  raises.) </strong><a href=\"http://www.usconstitution.net/constamrat.html#Am27\" class=\"link\" target=\"_blank\" ><strong>Ratified</strong></a><strong> 5/7/1992.</strong> <br>\r\n  No law, varying the compensation for the services of the  Senators and Representatives, shall take effect, until an election of  Representatives shall have intervened.</p>\r\n<p>&nbsp;</p>\r\n</div>\r\n\r\n\r\n\r\n\r\n");
$templateCache.put("app/topic/topic.html","<p></p>\r\n<h1>\r\n  <center>Create new thread</center>\r\n</h1>\r\n<p></p>\r\n<center>\r\n  <div class=\"inline2\">\r\n    <form name=\"topicform\" id=\"topicform\">\r\n      <fieldset class=\"scheduler-border\">\r\n        <legend class=\"scheduler-border\">Thread details</legend>\r\n        <p></p>\r\n\r\n<div ng-show=\"curState == \'topic-politician\'\">\r\n<a href=\"#!/addDebate/{{uId}}\" class=\"ylink\">Add Debate with Location</a>\r\n</div>\r\n<br>\r\n<br>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"title\">Title</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"Topic.title\" placeholder=\"\"\r\n                                       data-errormessage=\"Topic is required.\"  class=\"form-control input-md  validate[required] text-input\" style=\"width:90%;\">\r\n                                </div>\r\n              </div>\r\n\r\n              <div class=\"control-group\" ng-show=\"curState == \'topic\'\">\r\n                <div class=\"control-label\" for=\"title\">Select Tags</div>\r\n\r\n                <div class=\"DisplayCat changeTextColor\">\r\n                  <div style=\"background-color: #eee; padding:5px;\">All Tags <br><small>(click to select)</small></div>\r\n\r\n                  <div ng-repeat=\"subent in subtopics.subcategories track by $index\" ng-include=\"\'field_renderer\'\">\r\n                    Loading...</div>\r\n                  <div ng-if=\"subtopics.subcategories.length == 0\" class=\"loadingSpinner\">\r\n                    <i class=\"fa fa-refresh fa-spin fa-3x fa-fw\"></i>\r\n                  </div>\r\n                </div>\r\n                <div class=\"select buttons\" style=\"padding-left: 20px;\">&nbsp;\r\n                  <!-- <button class=\"btn mover left\" ng-click=\"AddmyCats()\" title=\"Add selected\" ng-disabled=\"!selectedCat.length\"><i class=\"fa fa-arrow-right\" aria-hidden=\"true\"></i></button>\r\n                                    <button class=\"btn mover right\" ng-click=\"RemoveCats()\" title=\"Remove selected\" ng-disabled=\"!rmselectedCat.length\">\r\n                                        <i class=\"fa fa-arrow-left\" aria-hidden=\"true\"></i>\r\n                                    </button> -->\r\n                </div>\r\n                <div class=\"DisplayCat changeTextColor\">\r\n                  <div style=\"background-color: #eee; padding:5px;\">Selected Tags<br><small>(click to remove)</small>\r\n                  </div>\r\n                  <ul class=\"TcatList\">\r\n                    <li ng-repeat=\"subent in selectedCat track by $index\">\r\n                      <label class=\"checkbox\" ng-if=\"mainCatIds.indexOf(subent._id) == -1 ? true:false\" title=\"{{subent.title}}\">\r\n                                                <input type=\"checkbox\" ng-click=\"removeVal(subent)\" ng-model=\"selectedAll.id[$index]\" ng-checked=\"true\" ng-disabled=\"subCatArr.indexOf(subent._id) > -1 ? true : false\" name=\"checkedidcat\"> {{subent.title}}\r\n                                            </label>\r\n                    </li>\r\n                  </ul>\r\n                </div>\r\n                <div style=\"clear:both;\"></div>\r\n                <!-- <multi-select ng-model=\"Essay.subcategories\" available=\"subtopics\" selected-label=\"Selected subtopics\" available-label=\"All subtopics\" display=\"r as r.title\" title=\"r as r.title\" config=\"selectConfig\"></multi-select>\r\n                                <div class=\"input-error\" ng-show=\"selectForm.numSelected.$error.min\">\r\n                                    Please select at least\r\n                                    <ng-pluralize count=\"selectConfig.requiredMin\" when=\"{\'one\': \'one role\', \'other\': \'{} roles\'}\">.\r\n                                </div>\r\n                                <input type=\"hidden\" id=\"reqMin\" ng-model=\"selectConfig.requiredMin\" min=\"1\">-->\r\n              </div>\r\n\r\n              <div class=\"control-group\" ng-show=\"curState == \'topic-politician\'\">\r\n                <div class=\"control-label\" for=\"title\">Select politician to tag</div>\r\n                <div class=\"DisplayCat\">\r\n                  <div style=\"background-color: #eee; padding:5px;\">All Politician <br><small>(click to select)</small>\r\n                  </div>\r\n                  <div ng-if=\"statusfetchPoliticiansByState == 1\" class=\"loadingSpinner\">\r\n                    <i class=\"fa fa-refresh fa-spin fa-3x fa-fw\"></i>\r\n                  </div>\r\n                  <div class=\"catname\" ng-repeat=\"(key, value) in $root.politicianThreadData.users | groupBy: \'office\'\">\r\n                    <label class=\"ng-binding\">\r\n                                            <!-- <input type=\"checkbox\" ng-model=\"item.loadPolitician\" ng-change=\"fetchPoliticiansByState(item, $index);\">\r\n                                            {{item.state}}&nbsp; -->\r\n                                            <input type=\"checkbox\" ng-model=\"item.loadPolitician\" ng-change=\"selectUsersFromGroup(value, item.loadPolitician)\">\r\n                                            {{key}}&nbsp;\r\n                                            <i class=\"fa fa-caret-down ng-scope\" aria-hidden=\"true\"></i>\r\n                                        </label>\r\n                    <!-- <p ng-if=\"item.getPolStatus == 1\">Loading ...</p>\r\n                                        <ul ng-show=\"item.politicians.length > 0\" style=\"margin: 0px; list-style: none;\">\r\n                                            <li ng-repeat=\"pol in item.politicians\">\r\n                                                <label>\r\n                                                    <input type=\"checkbox\" ng-model=\"pol.selected\"> {{pol.name_on_ballot}}\r\n                                                </label>\r\n                                            </li>\r\n                                        </ul> -->\r\n                    <ul ng-show=\"value.length > 0\" style=\"margin: 0px; list-style: none;\">\r\n                      <li ng-repeat=\"pol in value\">\r\n                        <label>\r\n                                                    <input type=\"checkbox\" ng-model=\"pol.selected\">\r\n                                                    <span ng-if=\"pol.registeredUser\">\r\n                                                        <span ng-if=\"pol.name_on_ballot\">{{pol.name_on_ballot}}</span>\r\n                                                        <span ng-if=\"!pol.name_on_ballot\">{{pol.name}}</span>\r\n                                                    </span>\r\n                                                    <span ng-if=\"!pol.registeredUser\">\r\n                                                        <span ng-if=\"pol.name_on_ballot\">{{pol.name_on_ballot}}</span>\r\n                                                        <span ng-if=\"!pol.name_on_ballot\">{{pol.name}}</span>\r\n                                                    </span>\r\n                                                </label>\r\n                      </li>\r\n                    </ul>\r\n                  </div>\r\n                </div>\r\n                <div class=\"select buttons\" style=\"padding-left: 20px;\">&nbsp;\r\n                </div>\r\n                <div class=\"DisplayCat\">\r\n                  <div style=\"background-color: #eee; padding:5px;\">Selected Tags<br><small>(click to remove)</small>\r\n                  </div>\r\n                  <!-- <div ng-repeat=\"item in allLocations\">\r\n                                        <ul ng-show=\"item.politicians.length > 0\" style=\"margin: 0px; list-style: none; padding: 0;\">\r\n                                            <li ng-repeat=\"pol in item.politicians\" ng-if=\"pol.selected\">\r\n                                                <label>\r\n                                                    <input type=\"checkbox\" ng-model=\"pol.selected\"> {{pol.name_on_ballot}}\r\n                                                </label>\r\n                                            </li>\r\n                                        </ul>\r\n                                    </div> -->\r\n                  <ul ng-show=\"$root.politicianThreadData.users.length > 0\"\r\n                    style=\"margin: 0px; list-style: none; padding: 0;\">\r\n                    <li ng-repeat=\"pol in $root.politicianThreadData.users\" ng-if=\"pol.selected\">\r\n                      <label>\r\n                                                <input type=\"checkbox\" ng-model=\"pol.selected\">\r\n                                                <span ng-if=\"pol.registeredUser\">\r\n                                                    <span ng-if=\"pol.name_on_ballot\">{{pol.name_on_ballot}}</span>\r\n                                                    <span ng-if=\"!pol.name_on_ballot\">{{pol.name}}</span>\r\n                                                </span>\r\n                                                <span ng-if=\"!pol.registeredUser\">\r\n                                                    <span ng-if=\"pol.name_on_ballot\">{{pol.name_on_ballot}}</span>\r\n                                                    <span ng-if=\"!pol.name_on_ballot\">{{pol.name}}</span>\r\n                                                </span>\r\n                                            </label>\r\n                    </li>\r\n                  </ul>\r\n                </div>\r\n                <div style=\"clear:both;\"></div>\r\n              </div>\r\n\r\n\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label\" for=\"description\">Description</label>\r\n                <div class=\"controls\">\r\n                  <textarea id=\"description\" ng-model=\"Topic.description\" placeholder=\"\"\r\n                                       data-errormessage=\"Description is required.\" class=\"form-control input-md  validate[required] text-area\"></textarea>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label\" for=\"location\">Thread Location</label>\r\n              </div>\r\n              <div class=\"control-group\" ng-if=\"!ShowLocationOptions\">\r\n                <!-- <label class=\"control-label\" for=\"location\">Thread Location</label> -->\r\n                <div class=\"controls\">\r\n                  <div style=\"float: left; padding-right:20px; padding-top:20px; padding-bottom:20px;\">\r\n                    <strong>City :</strong> {{uData.address.place}},<br /><strong>Sub county :</strong>\r\n                    {{uData.address.countySubdivision}},<br />\r\n                    <strong>County :</strong> {{uData.address.county}},<br /><strong>State :</strong>\r\n                    {{uData.address.state}}<br><strong>Country: {{isNational}}</strong>\r\n                  </div>\r\n                  <div style=\"float: left; margin-left:2%; padding-top:40px; padding-bottom:20px;\">\r\n                    <input type=\"button\" class=\"btnShort-style\" value=\"Change\" ng-click=\"ShowLocation()\">\r\n                                    </div>\r\n                    <div style=\"clear:both;\"></div>\r\n                  </div>\r\n                </div>\r\n\r\n                <div class=\"control-group\" ng-if=\"ShowLocationOptions\">\r\n\r\n                  <div class=\"DisplayCat changeTextColor\">\r\n                    <div style=\"background-color: #eee; padding:5px;\">Choose Location\r\n                      <br><small>(click to select)</small></div>\r\n                    <ul class=\"TcatList\">\r\n                      <li style=\"padding-bottom:10px;\">\r\n\r\n                        <input type=\"checkbox\" ng-change=\"getLocations(Essay.Locations, \'International\')\" ng-model=\"Essay.Locations\" ng-true-value=\"\'International\'\" ng-false-value=\"\'NO\'\">\r\n                        <label ng-click=\"ShowAddLocation();\">International&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-show=\"never\"></i></label>\r\n                        <!-- <div style=\"padding-left:20px;\" ng-if=\"AddLocation\">\r\n                            <div mass-autocomplete>\r\n                              <input ng-model=\"newlocation.country\" mass-autocomplete-item=\"autocomplete_options\">\r\n                      </div>\r\n                              <div style=\"text-align: right;\">\r\n                                <button ng-click=\"AddCountry();\">Add country</button>\r\n                              </div>\r\n                            </div> -->\r\n                      </li>\r\n                      <li>\r\n                        <input type=\"checkbox\" ng-model=\"Essay.National\"  ng-change=\"getLocations(Essay.National, \'National\')\" ng-true-value=\"\'National\'\" ng-false-value=\"\'NO\'\">\r\n                        <label>National</label>\r\n                        </i>\r\n                        <ul class=\"TcatList\">\r\n                          <li ng-repeat=\"area in allLocations track by $index\">\r\n                            <input type=\"checkbox\" ng-click=\"getAreaVal(area, area.state, \'state\')\" ng-disabled=\"checkDisabled(area, area.state, \'state\')\" ng-checked=\"checkDisabled(area, area.state, \'state\')\">\r\n                            <label ng-click=\"getCounties(area.stateFips)\">{{area.state}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoading.indexOf(area.stateFips)==-1\"></i> <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoading.indexOf(area.stateFips) > -1\"></i></label>\r\n                            <!-- Display Counties -->\r\n                            <ul class=\"TcatList\">\r\n                              <li\r\n                                ng-repeat=\"county in allCounties[area.stateFips] | orderBy:\'countyName\' track by $index\">\r\n                                <input type=\"checkbox\" ng-click=\"getAreaVal(county, area.state, \'county\')\" ng-disabled=\"checkDisabled(county, area.state, \'county\')\" ng-checked=\"checkDisabled(county, area.state, \'county\')\">\r\n                                <label ng-click=\"getLocals(area.stateFips, county.countyFips)\">{{county.countyName}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoadingCounty.indexOf(county.county) == -1\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingCounty.indexOf(county.county) > -1\"></i></label>\r\n                                <!-- Display Locals and sub counties -->\r\n                                <ul class=\"TcatList\" ng-if=\"Essay.location!=\'National\'\">\r\n                                  <li\r\n                                    ng-repeat=\"local in allLocals[area.stateFips][county.countyFips] | orderBy:\'placeName\'  track by $index\">\r\n                                    <label class=\"checkbox\" title=\"{{local.place}}\">\r\n                                  <input type=\"checkbox\" ng-click=\"getAreaVal(local, area.state, \'local\')\" ng-disabled=\"disabledLocation.indexOf(local) > -1 ? true : false\" ng-checked=\"disabledLocation.indexOf(local) > -1 ? true : false\"> {{local.placeName}}\r\n                                </label>\r\n                                  </li>\r\n                                </ul>\r\n                                <!-- Display Locals and sub counties End -->\r\n                              </li>\r\n                            </ul>\r\n                            <!-- Display Counties End -->\r\n                          </li>\r\n                        </ul>\r\n                      </li>\r\n                    </ul>\r\n                  </div>\r\n\r\n                  <div class=\"DisplayCat changeTextColor\">\r\n                    <div style=\"background-color: #eee; padding:5px;\">Selected Location\'s\r\n                      <br><small>(click to remove)</small></div>\r\n                    <ul class=\"TcatList\">\r\n                      <li ng-repeat=\"area in selectedArea track by $index\">\r\n\r\n                        <label class=\"checkbox\" title=\"{{area}}\">\r\n                      <input type=\"checkbox\" ng-click=\"removeAreaVal(area)\" name=\"checkedid\" ng-model=\"selectedLAll.id[$index]\" ng-checked=\"true\"> <span ng-if=\"area.country && (!(area.state) && !(area.county) && !(area.countySubdivision) && !(area.place))\">{{area.country}}</span> <span ng-if=\"area.state && (!(area.county) && !(area.countySubdivision) && !(area.place))\">{{area.state}}</span><span ng-if=\"area.county && (!(area.countySubdivision) && !(area.place))\">{{area.countyName}}</span><span ng-if=\"area.countySubdivision\">{{area.countySubdivision}}</span><span ng-if=\"area.place\"> - {{area.placeName}}</span>\r\n                    </label>\r\n                      </li>\r\n                    </ul>\r\n                  </div>\r\n                  <div style=\"clear:both;\"></div>\r\n                  <!--\r\n                                <multi-select ng-model=\"Essay.subcategories\" available=\"subtopics\" selected-label=\"Selected subtopics\" available-label=\"All subtopics\" display=\"r as r.title\" title=\"r as r.title\" config=\"selectConfig\"></multi-select>\r\n                                <div class=\"input-error\" ng-show=\"selectForm.numSelected.$error.min\">\r\n                                    Please select at least\r\n                                    <ng-pluralize count=\"selectConfig.requiredMin\" when=\"{\'one\': \'one role\', \'other\': \'{} roles\'}\">.\r\n                                </div>\r\n                                <input type=\"hidden\" id=\"reqMin\" ng-model=\"selectConfig.requiredMin\" min=\"1\">\r\n                                -->\r\n                </div>\r\n\r\n                <!--        <div class=\"control-group\">\r\n                    <label class=\"control-label\" for=\"restricted\">Any Restrictions</label>\r\n                    <div class=\"control-group\">\r\n                      <select ng-model=\"Topic.restrictedTo\" class=\"changeTextColor\">\r\n                                       <option ng-repeat=\"option in restrictedOptions\" value=\"{{option}}\">{{option}}</option>\r\n                                    </select>\r\n\r\n                    </div>\r\n                  </div>  -->\r\n\r\n\r\n                <div style=\"clear: both;\"></div>\r\n\r\n                <div style=\"margin-top:20px;\">\r\n                  <button ng-click=\"SubmitTopic(Topic)\" type=\"button\" class=\"btn btn-success\" ng-disabled=\"TopicButton\"  style=\"float: left;\">Submit Thread</button>\r\n                  &nbsp;&nbsp;&nbsp;&nbsp;\r\n                  <button ng-click=\"goBack();\" class=\"btnShort-style\" type=\"button\" style=\"float: left;\">Cancel</button>\r\n                  <div style=\"clear: both;\"></div>\r\n                </div>\r\n\r\n                <div style=\"clear: both;\"></div>\r\n\r\n\r\n\r\n      </fieldset>\r\n    </form>\r\n  </div>\r\n</center>\r\n<script type=\"text/ng-template\" id=\"field_renderer\">\r\n  <ul class=\"TcatList\">\r\n        <li>\r\n             <div class=\"catname\" id=\"{{subent._id}}\" ng-if=\"(subent.parentIds.length == 0) && (subent.subcategories)\">\r\n                <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\">  <label ng-click=\"ChangeShow(subent._id);\">{{::subent.title}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id)==-1\"></i><i class=\"fa fa-caret-right\" aria-hidden=\"true\"  ng-if=\"showDown.indexOf(subent._id) > -1\"></i></label>\r\n            </div>\r\n            <div class=\"catname\" ng-if=\"(subent.parentIds.length == 0) && (!subent.subcategories)\">\r\n                <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                    <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\"> {{::subent.title}}\r\n                </label>\r\n            </div>\r\n            <label class=\"checkbox\" ng-if=\"subent.parentIds.length > 0 && showSubCat\" title=\"{{subent.title}}\" >\r\n                <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\"> {{::subent.title}}\r\n            </label>\r\n            <ul ng-if=\"subent.subcategories\" ng-class=\"subent.parentIds.length == 0 ? \'cmnUL MainCatLi_{{subent._id}}\' : \'\'\">\r\n                <li ng-repeat=\"subent in subent.subcategories track by $index\" ng-include=\"\'field_renderer\'\">\r\n                    <!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                      <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n                  </label> -->\r\n                </li>\r\n            </ul>\r\n        </li>\r\n    </ul>\r\n</script>\r\n<script type=\"text/javascript\">\r\n  jQuery(document).ready(function () {\r\n    // binds form submission and fields to the validation engine\r\n    // binds form submission and fields to the validation engine\r\n    $(\"form\").validationEngine();\r\n  });\r\n\r\n</script>\r\n");
$templateCache.put("app/topicSpams/topicSpams.html","<div class=\"container-fluid ng-scope\" ng-cloak ng-show=\"$root.userRole==\'admin\'\">\r\n  <h2 class=\"pageHeading\">Settings</h2>\r\n  <div>\r\n    <div class=\"closeForm\" ng-include=\"\'app/popups/setting_Ctrl.html\'\"></div>\r\n  </div>\r\n  <!-- Topic Spam Start -->\r\n  <form ng-if=\"$root.showTopicSpam\" name=\"TopicSpamform\" id=\"TopicSpamform\" ng-controller=\"TopicSpamCtrl\" class=\"closeForm\">\r\n    <div class=\"row\" style=\"margin-top: 10px;\">\r\n      <p>\r\n        <h3>Topic Spams</h3>\r\n      </p>\r\n      <div style=\"float:right;\">\r\n        <dir-pagination-controls max-size=\"5\" on-page-change=\"pageChanged(newPageNumber)\"></dir-pagination-controls>\r\n      </div>\r\n      <table class=\"w100 changeTextColor\">\r\n        <tr>\r\n          <th style=\"width:80%\">Topic</th>\r\n          <th style=\"width:10%\">Not Spam</th>\r\n          <th style=\"width:10%\">Remove</th>\r\n        </tr>\r\n        <tr dir-paginate=\"u in topic.data | itemsPerPage :usersPerPage\" total-items=\"totalUsers\" current-page=\"pagination.current\">\r\n          <td>\r\n            <div ng-bind-html=\'u.description | urlify\'></div>\r\n            <p>\r\n              <img src=\"../assets/images/profile/{{u.createdBy.utype}}.svg\" class=\"UserTypeImg\" /> Created By :\r\n              <a href=\"#!/publicProfile/{{u.createdBy.id}}\" class=\"link\">{{u.createdBy.name}}</a>\r\n            </p>\r\n          </td>\r\n          <td>\r\n            <a href=\"javascript: void(0);\" ng-click=\"notSpam(u, $index)\" class=\"link\">Not Spam</a>\r\n          </td>\r\n          <td>\r\n            <a href=\"javascript: void(0)\" ng-click=\"removeTopic(u, $index)\" class=\"link\">Remove</a>\r\n          </td>\r\n        </tr>\r\n        <tr ng-if=\"topic.data.length==0\">\r\n          <td colspan=\"3\">\r\n            <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoading\"></i>\r\n            <spam ng-if=\"!showLoading\">No records found.</spam>\r\n          </td>\r\n        </tr>\r\n      </table>\r\n      <div style=\"float:right;\">\r\n        <dir-pagination-controls max-size=\"5\" on-page-change=\"pageChanged(newPageNumber)\"></dir-pagination-controls>\r\n      </div>\r\n    </div>\r\n  </form>\r\n  <!-- Topic Spam End -->\r\n</div>\r\n");
$templateCache.put("app/totalUsers/totalUsers.html","<div class=\"container-fluid ng-scope\" ng-cloak ng-show=\"$root.userRole==\'admin\'\">\r\n  <h2 class=\"pageHeading\">Settings</h2>\r\n  <!-- Upload Politicians -->\r\n  <div>\r\n    <div class=\"closeForm\" ng-include=\"\'app/popups/setting_Ctrl.html\'\"></div>\r\n  </div>\r\n  <div ng-if=\"showTotal\">\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Total Users</legend>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <label> Voters: </label> &nbsp; &nbsp;<a href=\"\" ng-click=\"getVoterStateWise(\'voter\')\" class=\"ylink\">{{count.voterCount}}</a>\r\n          <br>\r\n          <br>\r\n          <label> Politicians: </label>&nbsp; &nbsp;<a href=\"\" ng-click=\"getVoterStateWise(\'politician\')\" class=\"ylink\">{{count.politicianCount}}</a>\r\n          <br>\r\n          <br>\r\n          <label> Organizations: </label>&nbsp; &nbsp;<a href=\"\" ng-click=\"getVoterStateWise(\'advocate\')\" class=\"ylink\">{{count.advocateCount}}</a>\r\n          <br>\r\n          <br>\r\n          <label> Press: </label>&nbsp; &nbsp;<a href=\"\" ng-click=\"getVoterStateWise(\'press\')\" class=\"ylink\">{{count.pressCount}}</a>\r\n          <br>\r\n          <br>\r\n          <label> Guest Users: </label>&nbsp; &nbsp;<a href=\"\" ng-click=\"getGuestUsersAnswers()\" class=\"ylink\">{{count.guestCount}}</a>\r\n          <br>\r\n          <br>\r\n        </div>\r\n      </div>\r\n    </fieldset>\r\n  </div>\r\n  <div ng-if=\"voter\">\r\n    <a href=\"\" class=\"ylink\" ng-click=\"back()\">Back</a>\r\n    <div class=\"row\" ng-if=\"stateWise.length > 0\" style=\"margin-top: 10px;\">\r\n      <table class=\"w100\">\r\n        <tr>\r\n          <th style=\"width:70%;\">State</th>\r\n          <th style=\"width:10%;\">Counts</th>\r\n        </tr>\r\n        <tr ng-repeat=\"u in stateWise\">\r\n          <td>\r\n            <strong style=\"color: black\">{{u.state}}</strong>&nbsp;&nbsp;<a href=\"\" ng-if=\"!more[u.state]\" ng-click=\"getUsersCountyWise(u.state,u.stateFips,u.statePostalCode,u)\" class=\"link\">More</a>\r\n            <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" style=\"color: black\" ng-if=\"loaderOne && dis[u.state]\"></i>\r\n           &nbsp;&nbsp;&nbsp;&nbsp; <a href=\"\" ng-if=\"!morePoli[u.state] && UserType == \'politician\'\" ng-click=\"getPolitician(u)\" class=\"link\">See Politicians</a>\r\n            <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" style=\"color: black\" ng-if=\"loaderPolitician && disPoli[u.state]\"></i>\r\n              <div ng-if=\"UserType == \'politician\' && stateLevelPoli.length > 0 && morePoli[u.state]\">\r\n                <p ng-repeat=\"p in stateLevelPoli\">\r\n                  <span ng-if=\"p.name\" class=\"blackText\"> <b>Name: </b> {{p.name}}</span>\r\n                  <span ng-if=\"p.politicianInfo[0].officeName\" class=\"blackText\"><b>OfficeName: </b> {{p.politicianInfo[0].officeName}}</span>\r\n\r\n                </p>\r\n                <a href=\"\" ng-if=\"morePoli[u.state]\" ng-click=\"showLess(u.state)\" class=\"link\">Less</a>\r\n              </div>\r\n            <div ng-if=more[u.state] style=\"color: black;padding-left: 5%;padding-right: 5%\">\r\n              <table class=\"w100\" ng-if=\"countywise.length > 0\">\r\n                <tr>\r\n                  <th style=\"width:30%;\">Coutny</th>\r\n                  <th style=\"width:10%;\">Counts</th>\r\n                  <th style=\"width:10%;\">City</th>\r\n                </tr>\r\n                <tr ng-repeat=\"c in countywise\">\r\n                  <td>\r\n                    <h6>{{c.county}}</h6>\r\n                    <br>\r\n                    <div ng-if=\"cities && disCity[c.county] \">\r\n                      <table class=\"w100\" ng-if=\"cityWise.length > 0\">\r\n                        <tr>\r\n                          <th style=\"width:30%;\">Cities</th>\r\n                          <th style=\"width:10%;\">Counts</th>\r\n                        </tr>\r\n                        <tr ng-repeat=\"y in cityWise\">\r\n                          <td>\r\n                            <h6>{{y.city}}</h6>\r\n                          </td>\r\n                          <td>\r\n                            <p ng-if=\"y.voterCount\">\r\n                              {{y.voterCount}}</p>\r\n                            <p ng-if=\"y.politicianCount\">\r\n                              {{y.politicianCount}}</p>\r\n                            <p ng-if=\"y.advocateCount\">\r\n                              {{y.advocateCount}}</p>\r\n                            <p ng-if=\"y.pressCount\">\r\n                              {{y.pressCount}}</p>\r\n                          </td>\r\n                        </tr>\r\n                      </table>\r\n                    </div>\r\n                  </td>\r\n                  <td>\r\n                    <p ng-if=\"c.voterCount\">\r\n                      {{c.voterCount}}</p>\r\n                    <p ng-if=\"c.politicianCount\">\r\n                      {{c.politicianCount}}</p>\r\n                    <p ng-if=\"c.advocateCount\">\r\n                      {{c.advocateCount}}</p>\r\n                    <p ng-if=\"c.pressCount\">\r\n                      {{c.pressCount}}</p>\r\n                  </td>\r\n                  <td>\r\n                    <a href=\"\" ng-click=\"getUsersCityWise(c.county,u.state,u.stateFips,u.statePostalCode,c)\"  class=\"link\">More</a>\r\n                    <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" style=\"color: black\" ng-if=\"showLoader && disLo[c.county]\"></i>\r\n                  </td>\r\n                </tr>\r\n              </table>\r\n              <div>\r\n                <b><a href=\"\" ng-if=\"countywise.length == 0\" ng-click=\"getCityWise(u.state,u.stateFips,u.statePostalCode)\"  class=\"link\">City</a></b>\r\n                <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" style=\"color: black\" ng-if=\"newLoader\"></i>\r\n                <table ng-if=\"city.length > 0 \">\r\n                  <tr>\r\n                    <th style=\"width:30%;\">City</th>\r\n                    <th style=\"width:10%;\">Counts</th>\r\n                  </tr>\r\n                  <tr ng-repeat=\" s in city\">\r\n                    <td> <h6>{{s.city}}</h6>\r\n                    </td>\r\n                    <td>\r\n                      <p ng-if=\"s.voterCount\">\r\n                        {{s.voterCount}}</p>\r\n                      <p ng-if=\"s.politicianCount\">\r\n                        {{s.politicianCount}}</p>\r\n                      <p ng-if=\"s.advocateCount\">\r\n                        {{s.advocateCount}}</p>\r\n                      <p ng-if=\"s.pressCount\">\r\n                        {{s.pressCount}}</p>\r\n                    </td>\r\n                  </tr>\r\n                </table>\r\n                <div>\r\n                </div>\r\n              </div>\r\n              <a href=\"\" ng-if=\"more[u.state]\" class=\"link\" ng-click=\"showLess(u.state)\">Less</a>\r\n            </div>\r\n          </td>\r\n          <td style=\"color: black\">\r\n            <p ng-if=\"u.voterCount\">\r\n              {{u.voterCount}}</p>\r\n            <p ng-if=\"u.politicianCount\">\r\n              {{u.politicianCount}}</p>\r\n            <p ng-if=\"u.advocateCount\">\r\n              {{u.advocateCount}}</p>\r\n            <p ng-if=\"u.pressCount\">\r\n              {{u.pressCount}}</p>\r\n          </td>\r\n        </tr>\r\n      </table>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/trackFiveMinQuizAns/trackFiveMinQuizAns.html","<div class=\"container-fluid\">\r\n\r\n    <fieldset class=\"scheduler-border\">\r\n        <legend class=\"scheduler-border\">Track Five Minute Quiz</legend>\r\n        <div class=\"row search-inputs\">\r\n          <div class=\"col-3\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"email\">From</label>\r\n              <div class=\"controls\">\r\n                <input type=\"date\" ng-model=\"User.from\" class=\"form-control\">\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-3\">\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\">To</label>\r\n                <div class=\"controls\">\r\n                  <input type=\"date\" ng-model=\"User.to\" class=\"form-control\">\r\n                    </div>\r\n                </div>\r\n              </div>\r\n              </div>\r\n              <div class=\"btn-search\">\r\n                <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"searchRecords()\">\r\n                    Search\r\n                  </button>\r\n              </div>\r\n              </fieldset>\r\n\r\n              <fieldset class=\"scheduler-border\" ng-if=\"guestAnswers.length > 0\">\r\n                <legend class=\"scheduler-border\"> Guest Users Answers</legend>\r\n               \r\n                <div class=\"questionAnswersBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\" style=\"width: 100%\">\r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-12\">\r\n                      <br>\r\n                      <div ng-repeat=\"ans in guestAnswers | orderBy:\'matchOrder\' track by $index\">\r\n\r\n                        <div>\r\n                          <span class=\"link\" ng-click=\"showQue = !showQue\">Question {{ans.matchOrder}}</span> <span ng-show=\"ans.answers.length > 0\"  ng-click=\"showAns = !showAns\"> {{ans.answers.length}} answers</span>\r\n                          \r\n                        </div>\r\n\r\n                        <div ng-hide=\"showQue\">\r\n                          <br>\r\n                          <div> Content: {{ans.content}} </div>\r\n                        </div>\r\n                       \r\n                        <div ng-hide=\"showAns\">\r\n                            <div ng-if=\"ans.answers.length > 0\" ng-repeat=\"an in ans.answers\">\r\n                                <br>\r\n                                <span>Answer</span>\r\n                                <br>\r\n                                <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n              \r\n                                  <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n                                    style=\"padding-left: 8px;  line-height: 9px\">\r\n                                    <span class=\"inl-blk pull-left\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n                                    <div class=\"cq-box inl-blk pull-left\"\r\n                                      ng-class=\"(an.answer == i) ? getComapreClass(an.answer, i) : \'\'\"></div>\r\n                                    <span class=\"inl-blk\" ng-if=\"i == 6\" style=\"padding-left:8px\">DISAGREE</span>\r\n                                  </div>\r\n                                </div>\r\n                                <br>\r\n                                <p></p>\r\n                                <span>IMPORTANCE</span>\r\n                                <br>\r\n                                <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n              \r\n                                  <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"padding-left: 8px; line-height: 9px\">\r\n                                    <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n                                    <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                                    <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n                                    <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                                      ng-class=\"(an.importance == i) ? \'ag-dg\' : \'\'\"></div>\r\n                                  </div>\r\n                                </div>\r\n                                <p></p>\r\n                                <div>\r\n                                  <span ng-if=\"an.comment\">Comment:</span>\r\n                                  <span ng-if=\"an.comment\" class=\"newcomName\">{{an.comment}}</span>\r\n                                </div>\r\n                                <br>\r\n                                <div>\r\n                                    created: {{an.created | date : \"y-MM-dd h:mm:ss a\"}}\r\n                                </div>\r\n                                <hr style=\"\r\n                                  margin-left: auto;\r\n                                  margin-right: auto;\r\n                                  height: 1px;\r\n                                  background-color:#666;\r\n                                  opcaity: 0.5;\">\r\n                            </div>\r\n                            </div>\r\n                            <hr style=\"\r\n                                  margin-left: auto;\r\n                                  margin-right: auto;\r\n                                  height: 1px;\r\n                                  background-color:#666;\r\n                                  opcaity: 0.5;\">\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n\r\n              <fieldset class=\"scheduler-border\" ng-if=\"userAnswers.length > 0\">\r\n                <legend class=\"scheduler-border\"> Register Users Answers</legend>\r\n               \r\n                <div class=\"questionAnswersBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\" style=\"width: 100%\">\r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-12\">\r\n                      <br>\r\n                      <div ng-repeat=\"ans in userAnswers | orderBy:\'matchOrder\' track by $index\">\r\n\r\n                        <div>\r\n                          <span class=\"link\" ng-show=\"ans.answers.length > 0\" ng-click=\"showQue = !showQue\">Question {{ans.matchOrder}}</span> <span ng-show=\"ans.answers.length > 0\"  ng-click=\"showAns = !showAns\"> {{ans.answers.length}} answers</span>\r\n                          \r\n                        </div>\r\n\r\n                        <div ng-hide=\"showQue\">\r\n                          <br>\r\n                          <div> Content: {{ans.content}} </div>\r\n                        </div>\r\n                       \r\n                        <div ng-hide=\"showAns\">\r\n                            <div ng-if=\"ans.answers.length > 0\" ng-repeat=\"an in ans.answers track by $index\">\r\n\r\n                              <span ng-if=\"an\">Name: </span>\r\n                              <a href=\"#!/publicProfile/{{an.id}}\" class=\"link\" ng-if=\"an.poliName && an.userType == \'politician\'\" style=\"text-transform: capitalize;\"><img ng-src=\"../assets/images/profile/{{an.userType}}.svg \" alt=\"{{an.userType}}\" class=\"usertype \"> \r\n            <b ng-if=\"an.userType == \'politician\' && an.userType != \'advocate\'\" > {{an.poliName}}</b></a>\r\n           <span ng-if=\"an.userType == \'voter\'\" style=\"text-transform: capitalize;\"><img ng-src=\"../assets/images/profile/{{an.userType}}.svg \" alt=\"{{an.userType}}\" class=\"usertype\"> \r\n              <b style=\"text-transform: capitalize;\"> Voter {{$index+1}}</b></span>\r\n            <a href=\"#!/pressProfile/{{an.id}}\" class=\"link\"  ng-if=\"an.userType == \'advocate\'\" style=\"text-transform: capitalize;\"><img ng-src=\"../assets/images/profile/{{an.userType}}.svg \" alt=\"{{an.userType}}\" class=\"usertype \"> \r\n                <b style=\"text-transform: capitalize;\"> {{an.orgName}}</b></a>\r\n                                <br>\r\n                                <span>Answer</span>\r\n                                <br>\r\n                                <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n              \r\n                                  <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n                                    style=\"padding-left: 8px;  line-height: 9px\">\r\n                                    <span class=\"inl-blk pull-left\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n                                    <div class=\"cq-box inl-blk pull-left\"\r\n                                      ng-class=\"(an.answer == i) ? getComapreClass(an.answer, i) : \'\'\"></div>\r\n                                    <span class=\"inl-blk\" ng-if=\"i == 6\" style=\"padding-left:8px\">DISAGREE</span>\r\n                                  </div>\r\n                                </div>\r\n                                <br>\r\n                                <p></p>\r\n                                <span>IMPORTANCE</span>\r\n                                <br>\r\n                                <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n              \r\n                                  <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"padding-left: 8px; line-height: 9px\">\r\n                                    <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n                                    <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                                    <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n                                    <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                                      ng-class=\"(an.importance == i) ? \'ag-dg\' : \'\'\"></div>\r\n                                  </div>\r\n                                </div>\r\n                                <p></p>\r\n                                <div>\r\n                                  <span ng-if=\"an.comment\">Comment:</span>\r\n                                  <span ng-if=\"an.comment\" class=\"newcomName\">{{an.comment}}</span>\r\n                                </div>\r\n                                <br>\r\n                                <div>\r\n                                    created: {{an.created | date : \"y-MM-dd h:mm:ss a\"}}\r\n                                </div>\r\n                                <hr class=\"hrizontalLine\">\r\n                            </div>\r\n                            </div>\r\n                            <hr  class=\"hrizontalLine\">\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n\r\n              <fieldset class=\"scheduler-border\" ng-if=\"otherQuizzes.length > 0\">\r\n                <legend class=\"scheduler-border\"> Other Answers</legend>\r\n               \r\n                <div class=\"questionAnswersBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\" style=\"width: 100%\">\r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-12\">\r\n                      <br>\r\n                      <div ng-repeat=\"ans in otherQuizzes  track by $index\">\r\n\r\n                        <div>\r\n                          <span class=\"link\"  ng-click=\"showQue = !showQue\">{{ans.guestId}}</span> <span ng-click=\"showAns = !showAns\"> Show Answers</span>\r\n                          \r\n                        </div>\r\n\r\n                        <div ng-hide=\"showQue\">\r\n                          <br>\r\n                          <div> Content: {{ans.content}} </div>\r\n                        </div>\r\n                       \r\n                        <div ng-hide=\"showAns\">\r\n                            <div>\r\n\r\n                       \r\n                                <span>Answer</span>\r\n                                <br>\r\n                                <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n              \r\n                                  <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n                                    style=\"padding-left: 8px;  line-height: 9px\">\r\n                                    <span class=\"inl-blk pull-left\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n                                    <div class=\"cq-box inl-blk pull-left\"\r\n                                      ng-class=\"(ans.answer == i) ? getComapreClass(ans.answer, i) : \'\'\"></div>\r\n                                    <span class=\"inl-blk\" ng-if=\"i == 6\" style=\"padding-left:8px\">DISAGREE</span>\r\n                                  </div>\r\n                                </div>\r\n                                <br>\r\n                                <p></p>\r\n                                <span>IMPORTANCE</span>\r\n                                <br>\r\n                                <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n              \r\n                                  <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\" style=\"padding-left: 8px; line-height: 9px\">\r\n                                    <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n                                    <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                                    <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n                                    <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                                      ng-class=\"(ans.importance == i) ? \'ag-dg\' : \'\'\"></div>\r\n                                  </div>\r\n                                </div>\r\n                                <p></p>\r\n                                <div>\r\n                                  <span ng-if=\"ans.comment\">Comment:</span>\r\n                                  <span ng-if=\"ans.comment\" class=\"newcomName\">{{ans.comment}}</span>\r\n                                </div>\r\n                                <br>\r\n                                <div>\r\n                                    created: {{ans.created | date : \"y-MM-dd h:mm:ss a\"}}\r\n                                </div>\r\n                                <hr class=\"hrizontalLine\">\r\n                            </div>\r\n                            </div>\r\n                            <hr  class=\"hrizontalLine\">\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n</div>");
$templateCache.put("app/trackPoliticians/trackPoliticians.html","<div class=\"container-fluid\">\r\n  <fieldset class=\"scheduler-border\">\r\n    <legend class=\"scheduler-border\">Track Politician Activities</legend>\r\n    <div class=\"row\">\r\n     \r\n      <div class=\"col-md col-lg col-sm\">\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n            >To</label\r\n          >\r\n          <div class=\"controls\">\r\n            <input type=\"date\" ng-model=\"User.to\" class=\"form-control\" />\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"col-md col-lg col-sm\">\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n            >From</label\r\n          >\r\n          <div class=\"controls\">\r\n            <input type=\"date\" ng-model=\"User.from\" class=\"form-control\" />\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-md col-lg col-sm\">\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n            >Select State</label\r\n          >\r\n          <div class=\"controls\">\r\n            <select\r\n              class=\"changeTextColor form-control\"\r\n              ng-model=\"User.state\"\r\n              style=\"text-transform: capitalize\"\r\n              ng-options=\"item.state for item in allState track by item.state\"\r\n            ></select>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      \r\n\r\n      <div class=\"col-md col-lg col-sm\">\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n            >Select Office</label\r\n          >\r\n          <div class=\"controls\">\r\n            <select\r\n              ng-model=\"User.officeType\"\r\n              style=\"text-transform: capitalize\"\r\n              ng-options=\"item as item for item in allOfficeType\"\r\n              class=\"changeTextColor form-control\"\r\n            ></select>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"col-md col-lg col-sm\">\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel whiteText\" for=\"email\"\r\n            > isUserContributed </label\r\n          >\r\n          <div class=\"controls\">\r\n            <select\r\n              ng-model=\"User.isContri\"\r\n              style=\"text-transform: capitalize\"\r\n              ng-options=\"item as item for item in isUserContributed\"\r\n              class=\"changeTextColor form-control\"\r\n            ></select>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <br>\r\n    <div class=\"row\">\r\n      <div class=\"col-lg-3 col-md-3 col-sm-3\">\r\n        <div style=\"display:flex; flex-direction: row; justify-content: center; align-items: center;\">\r\n          <label for=\"isAnsVotewise\" >Answered Votewise Questions</label>\r\n          <input type=\"checkbox\"  name=\"chk\" id=\"chk\" ng-model=\"User.isAnsVotewise\" class=\"form-control vt-chk\">\r\n        </div>\r\n        </div>\r\n        <div class=\"col-md col-lg col-sm\">\r\n          <div style=\"display:flex; flex-direction: row; justify-content: center; align-items: center;\">\r\n            <label for=\"isAnsVotesmart\" >Answered Votesmart Questions</label>\r\n            <input type=\"checkbox\"  name=\"chk\" id=\"chk\" ng-model=\"User.isAnsVotesmart\" class=\"form-control vt-chk\">\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md col-lg col-sm\">\r\n          <div style=\"display:flex; flex-direction: row; justify-content: center; align-items: center;\">\r\n            <label for=\"isLoggedin\" >Is Logged In</label>\r\n            <input type=\"checkbox\"  name=\"chk\" id=\"chk\" ng-model=\"User.isLoggedin\" class=\"form-control vt-chk\">\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md col-lg col-sm\">\r\n          <div style=\"display:flex; flex-direction: row; justify-content: center; align-items: center;\">\r\n            <label for=\"addedStatement\" >Added Statement</label>\r\n            <input type=\"checkbox\"  name=\"chk\" id=\"chk\" ng-model=\"User.addedStatement\" class=\"form-control vt-chk\">\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md col-lg col-sm\">\r\n          <div style=\"display:flex; flex-direction: row; justify-content: center; align-items: center;\">\r\n            <label for=\"addedResume\" >Added Resume</label>\r\n            <input type=\"checkbox\"  name=\"chk\" id=\"chk\" ng-model=\"User.addedResume\" class=\"form-control vt-chk\">\r\n          </div>\r\n        </div>\r\n    </div>\r\n    <!-- <div class=\"row\"> -->\r\n    <div style=\"text-align: center; margin-top: 5%\">\r\n      <button\r\n        class=\"btn2Short-style widthAuto btn-success\"\r\n        type=\"button\"\r\n        ng-click=\"searchRecords(0,\'click\')\"\r\n      >\r\n        Search\r\n      </button>\r\n      <!-- </div> -->\r\n    </div>\r\n  </fieldset>\r\n\r\n  <center>\r\n    <div ng-if=\"loader\" style=\"z-index: 2; background:black; margin-left: 3%;\">\r\n      <i class=\"fa fa-refresh fa-spin\" style=\"font-size:125px;margin-top: 5%; color:yellow; font-weight: bold;\"></i><br><span style=\"font-size:20px; z-index: 3; position:relative; top: -60px; color: yellow; background-color: black; padding:1px; font-weight:bold;\">LOADING. PLEASE WAIT.</span>\r\n    </div>\r\n  </center>\r\n  \r\n  <div ng-if=\"mainData.length > 0\">\r\n    <div infinite-scroll=\"pageFunction()\">\r\n      <div ng-repeat=\" d in mainData | filter:getItem()\">\r\n        <span\r\n          ><b>Name: </b\r\n          ><a href=\"#!/publicProfile/{{d._id}}\" class=\"ylink\">\r\n            {{d.name}}</a\r\n          ></span\r\n        >\r\n\r\n        <!-- <span ng-if=\"d.email && d.email.length > 0\"> <b>Email:</b> {{d.email[0]}} </span> -->\r\n        <div ng-if=\"d.incumbent == \'incumbent\' || d.incumbent == \'Incumbent\'\">\r\n          <b>Incumbent:</b> Yes\r\n        </div>\r\n        <div ng-if=\"d.incumbent == \'\'\"><b>Incumbent:</b> No</div>\r\n\r\n        <div ng-if=\"d.runningForOffice == \'Y\'\">\r\n          <b>runningForOffice:</b> Yes\r\n        </div>\r\n        <div ng-if=\"d.runningForOffice == \'N\'\"><b>runningForOffice:</b> No</div>\r\n\r\n        <div  ng-click=\"showVotewiseAns = !showVotewiseAns\"><b>{{d.votewiseAnsCount}}</b> Votewise answers</div>\r\n        <div ng-click=\"showVotesmartAns = !showVotesmartAns\"><b>{{d.votesmartAnsCount}}</b> Votesmart answers</div>\r\n\r\n        <div\r\n          ng-show=\"d.statement != null\"\r\n          ng-click=\"showStatement = !showStatement\r\n            \"\r\n        >\r\n          <b>1</b> Statement\r\n        </div>\r\n        <div ng-hide=\"showStatement\">{{d.statement}}</div>\r\n        <div ng-if=\"d.statement == null\"><b>0</b> Statement</div>\r\n        <div\r\n          ng-show=\"d.resume != null\"\r\n          ng-click=\"showResume = !showResume\"\r\n        >\r\n          <b>1</b> Resume\r\n        </div>\r\n        <div ng-hide=\"showResume\">{{d.resume}}</div>\r\n        <div ng-if=\"d.resume == null\"><b>0</b> Resume</div>\r\n        <div ng-if=\"d.lastLogin && d.lastLogin != \'\'\">\r\n          <b>Last Logged in</b> {{d.lastLogin}}\r\n        </div>\r\n        <div ng-if=\"User.officeType ==\'runningForOffice\'\">\r\n       <span ng-if=\"d.voterScope == \'placeName\'\"> {{d.place}}</span>\r\n          <span ng-if=\"d.voterScope == \'countyName\'\"> {{d.county}}</span>\r\n          <span ng-if=\"d.voterScope == \'statePostalCode\' && d.state !=\'NA\'\"> {{d.state}}</span>\r\n          <span ng-if=\"d.voterScope == \'All USA\'\"> the United States</span>\r\n          <span ng-if=\"d.voterScope == \'statePostalCode\' && d.state ==\'NA\'\">{{d.statePostalCode}}</span>\r\n          <span ng-if=\"d.voterScope == \'stateHouseofRepresentativesDistrict\'\">  {{d.statePostalCode}} Legislative district {{d.stateHouseofRepresentativesDistrict}}</span>\r\n          <span ng-if=\"d.voterScope == \'stateSenateDistrict\' && d.state !=\'NA\'\"> {{d.state}} State district {{d.stateSenateDistrict}}</span>\r\n          <span ng-if=\"d.voterScope == \'stateSenateDistrict\' && d.state ==\'NA\'\">{{d.statePostalCode}}</span>\r\n          <span ng-if=\"d.voterScope == \'federalCongressionalDistrict\'\">,<span ng-if=\"d.state !=\'NA\'\">{{d.state}}</span>\r\n          <span ng-if=\"d.state ==\'NA\' && d.statePostalCode !=\'NA\'\">{{d.statePostalCode}}</span>\r\n          <span ng-if=\"d.federalCongressionalDistrict\"> Federal Congressional District </span>\r\n          {{d.federalCongressionalDistrict}}</span>\r\n\r\n        </div>\r\n\r\n        <div ng-if=\"User.officeType ==\'inOffice\'\">\r\n          <span ng-if=\"d.winDetails[0].voterScope == \'placeName\'\"> {{d.winDetails[0].place}}</span>\r\n             <span ng-if=\"d.winDetails[0].voterScope == \'countyName\'\">{{d.winDetails[0].county}}</span>\r\n             <span ng-if=\"d.winDetails[0].voterScope == \'statePostalCode\'\">  {{d.winDetails[0].statePostalCode}}</span>\r\n             <span ng-if=\"d.winDetails[0].voterScope == \'All USA\'\"> the United States</span>\r\n             <span ng-if=\"d.winDetails[0].voterScope == \'statePostalCode\' && d.winDetails[0].state ==\'NA\'\">{{d.winDetails[0].statePostalCode}}</span>\r\n             <span ng-if=\"d.winDetails[0].voterScope == \'stateHouseofRepresentativesDistrict\'\"> {{d.winDetails[0].statePostalCode}} Legislative district {{d.winDetails[0].stateHouseofRepresentativesDistrict}}</span>\r\n             <span ng-if=\"d.winDetails[0].voterScope == \'stateSenateDistrict\' && d.winDetails[0].state !=\'NA\'\"> {{d.winDetails[0].statePostalCode}} State district {{d.winDetails[0].stateSenateDistrict}}</span>\r\n             <span ng-if=\"d.winDetails[0].voterScope == \'stateSenateDistrict\' && d.winDetails[0].state ==\'NA\'\">{{d.winDetails[0].statePostalCode}}</span>\r\n             <span ng-if=\"d.winDetails[0].voterScope == \'federalCongressionalDistrict\'\">,<span>{{d.winDetails[0].statePostalCode}}</span>\r\n             <span ng-if=\"d.winDetails[0].state ==\'NA\' && d.winDetails[0].statePostalCode !=\'NA\'\">{{d.winDetails[0].statePostalCode}}</span>\r\n             <span ng-if=\"d.winDetails[0].federalCongressionalDistrict\"> Federal Congressional District </span>\r\n             {{d.winDetails[0].federalCongressionalDistrict}}</span>\r\n   \r\n           </div>\r\n\r\n           <div ng-if=\"d.populationData && d.populationData.state\">\r\n            Most populace City: {{d.populationData.place}} ( {{d.populationData.population}} )\r\n           </div>\r\n\r\n           <div  class=\"ylink\" ng-click=\"showCompetitors(d)\">\r\n           Show Competitors\r\n           </div>\r\n        <div ng-hide=\"showVotesmartAns\">\r\n          <fieldset class=\"scheduler-border\">\r\n           \r\n            <legend class=\"scheduler-border\">Answers</legend>\r\n            <div\r\n              class=\"questionAnswersBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\"\r\n              style=\"width: 100%\"\r\n            >\r\n              <div class=\"row\">\r\n                <div class=\"col-md-12\">\r\n                  <br />\r\n                  <div ng-repeat=\"com in d.votesmartAns track by $index\">\r\n                    <div class=\"pad10\">\r\n                     \r\n                      <div ng-if=\"com.content\">Question {{com.content}}</div>\r\n                      <br />\r\n                      <span>Answer</span>\r\n                      <br />\r\n                      <div\r\n                        class=\"clearfix\"\r\n                        style=\"line-height: 15px; display: inline-flex\"\r\n                      >\r\n                        <div\r\n                          ng-repeat=\"i in [1,2,3,4,5,6]\"\r\n                          class=\"mb5 clearfix\"\r\n                          style=\"padding-left: 8px; line-height: 15px\"\r\n                        >\r\n                          <span\r\n                            class=\"inl-blk pull-left\"\r\n                            ng-if=\"i == 1\"\r\n                            style=\"margin-right: 10px\"\r\n                            >AGREE</span\r\n                          >\r\n                          <div\r\n                            class=\"cq-box inl-blk pull-left\"\r\n                            ng-class=\"(com.answer == i) ? getComapreClass(com.answer, i) : \'\'\"\r\n                          ></div>\r\n                          <span\r\n                            class=\"inl-blk\"\r\n                            ng-if=\"i == 6\"\r\n                            style=\"padding-left: 8px\"\r\n                            >DISAGREE</span\r\n                          >\r\n                        </div>\r\n                      </div>\r\n                      <br />\r\n                      <p></p>\r\n                      <span>IMPORTANCE</span>\r\n                      <br />\r\n                      <div\r\n                        class=\"clearfix\"\r\n                        style=\"line-height: 15px; display: inline-flex\"\r\n                      >\r\n                        <div\r\n                          ng-repeat=\"i in [1,2,3]\"\r\n                          class=\"mb5 clearfix\"\r\n                          style=\"padding-left: 8px; line-height: 9px\"\r\n                        >\r\n                          <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n                          <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                          <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n                          <div\r\n                            class=\"cq-box inl-blk pull-right\"\r\n                            style=\"margin-left: 8px\"\r\n                            ng-class=\"(com.Importance == i) ? \'ag-blk\' : \'\'\"\r\n                          ></div>\r\n                        </div>\r\n                      </div>\r\n                      <p></p>\r\n                      <div>\r\n                        <span ng-if=\"com.comment\">Comment:</span>\r\n                        <span ng-if=\"com.comment\">{{com.comment}}</span>\r\n                      </div>\r\n                      <div ng-if=\"com.answer_descriptive && com.answer_descriptive !=\'\'\">\r\n                        Text Ans:- {{com.answer_descriptive}}\r\n                      </div>\r\n                      <hr\r\n                        style=\"\r\n                          margin-left: auto;\r\n                          margin-right: auto;\r\n                          height: 1px;\r\n                          background-color: #666;\r\n                          opcaity: 0.5;\r\n                        \"\r\n                      />\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n\r\n        <div ng-hide=\"showVotewiseAns\">\r\n          <fieldset class=\"scheduler-border\">\r\n            <legend class=\"scheduler-border\">Answers</legend>\r\n            <div\r\n              class=\"questionAnswersBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\"\r\n              style=\"width: 100%\"\r\n            >\r\n              <div class=\"row\">\r\n                <div class=\"col-md-12\">\r\n                  <br />\r\n                  <div ng-repeat=\"com in d.votewiseAns track by $index\">\r\n                    <div class=\"pad10\">\r\n                      <div ng-if=\"com.content\">Question {{com.content}}</div>\r\n                      <br />\r\n                      <span>Answer</span>\r\n                      <br />\r\n                      <div\r\n                        class=\"clearfix\"\r\n                        style=\"line-height: 15px; display: inline-flex\"\r\n                      >\r\n                        <div\r\n                          ng-repeat=\"i in [1,2,3,4,5,6]\"\r\n                          class=\"mb5 clearfix\"\r\n                          style=\"padding-left: 8px; line-height: 15px\"\r\n                        >\r\n                          <span\r\n                            class=\"inl-blk pull-left\"\r\n                            ng-if=\"i == 1\"\r\n                            style=\"margin-right: 10px\"\r\n                            >AGREE</span\r\n                          >\r\n                          <div\r\n                            class=\"cq-box inl-blk pull-left\"\r\n                            ng-class=\"(com.answer == i) ? getComapreClass(com.answer, i) : \'\'\"\r\n                          ></div>\r\n                          <span\r\n                            class=\"inl-blk\"\r\n                            ng-if=\"i == 6\"\r\n                            style=\"padding-left: 8px\"\r\n                            >DISAGREE</span\r\n                          >\r\n                        </div>\r\n                      </div>\r\n                      <br />\r\n                      <p></p>\r\n                      <span>IMPORTANCE</span>\r\n                      <br />\r\n                      <div\r\n                        class=\"clearfix\"\r\n                        style=\"line-height: 15px; display: inline-flex\"\r\n                      >\r\n                        <div\r\n                          ng-repeat=\"i in [1,2,3]\"\r\n                          class=\"mb5 clearfix\"\r\n                          style=\"padding-left: 8px; line-height: 9px\"\r\n                        >\r\n                          <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n                          <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                          <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n                          <div\r\n                            class=\"cq-box inl-blk pull-right\"\r\n                            style=\"margin-left: 8px\"\r\n                            ng-class=\"(com.importance == i) ? \'ag-blk\' : \'\'\"\r\n                          ></div>\r\n                        </div>\r\n                      </div>\r\n                      <p></p>\r\n                      <div>\r\n                        <span ng-if=\"com.comment\">Comment:</span>\r\n                        <span ng-if=\"com.comment\">{{com.comment}}</span>\r\n                      </div>\r\n                      <hr\r\n                        style=\"\r\n                          margin-left: auto;\r\n                          margin-right: auto;\r\n                          height: 1px;\r\n                          background-color: #666;\r\n                          opcaity: 0.5;\r\n                        \"\r\n                      />\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n        <hr />\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/trackUserActivities/trackUserActivities.html","<div class=\"container-fluid ng-scope\">\r\n  <!-- <h5></h5> -->\r\n  <form name=\"myForm\" role=\"form\">\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Track User Activities</legend>\r\n      <div class=\"row\">\r\n        <div class=\"col-md col-lg col-sm\">\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel whiteText\" for=\"email\">From</label>\r\n            <div class=\"controls\">\r\n              <input type=\"date\" ng-model=\"User.from\" class=\"form-control\">\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-md col-lg col-sm\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel whiteText\" for=\"email\">To</label>\r\n              <div class=\"controls\">\r\n                <input type=\"date\" ng-model=\"User.to\" class=\"form-control\">\r\n                  </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-md col-lg col-sm\">\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\">User Type</label>\r\n                <div class=\"controls\">\r\n                  <select ng-model=\"User.type\" class=\"form-control\">\r\n                      <option value=\"\">Select Status</option>\r\n                      <option value=\"voter\">Voter</option>\r\n                      <option value=\"politician\">Politician</option>\r\n                      <option value=\"advocate\">Advocate</option>\r\n                      <option value=\"press\">Press</option>\r\n                    </select>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-md col-lg col-sm\">\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\">Select State</label>\r\n                <div class=\"controls\">\r\n                  <select class=\"changeTextColor form-control\" ng-model=\"User.state\" style=\"text-transform: capitalize;\"  ng-options=\"item.state for item in allState track by item.state\"></select>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-md col-lg col-sm\">\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel whiteText\" for=\"email\">See Users Who Hadn\'t LoggedIn</label>\r\n                <div class=\"controls\">\r\n                  <input type=\"date\" ng-model=\"User.checkUsers\" class=\"form-control\">\r\n                      </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!-- <div class=\"row\"> -->\r\n            <div style=\"text-align: center;margin-top: 5%\">\r\n              <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"searchRecords(0,\'click\')\">\r\n                    Search\r\n                  </button>\r\n              <!-- </div> -->\r\n            </div>\r\n    </fieldset>\r\n    <fieldset class=\"scheduler-border\" ng-if=\"\r\n    mainData.length > 0 || notLoggedIn.length > 0\">\r\n      <!-- <legend class=\"scheduler-border\"></legend> -->\r\n      <div class=\"row\">\r\n        <div class=\"col-md\" ng-if=\"\r\n        mainData.length > 0\">\r\n          <h5>Users:\r\n            <a href=\"\" ng-show=\"mainData.length > 0\" class=\"ylink\" ng-click=\"activeUsers = !activeUsers\"> <b> {{countData}}</b></a>\r\n          </h5>\r\n          <hr>\r\n          <!-- <div class=\"col-md\" ng-show=\"questionAnswered.length > 0\">\r\n            <h4>Question Answered:- {{questionAnswered.length}}</h4>\r\n          </div> -->\r\n          <hr>\r\n          <div ng-if=\"mainData.length > 0\">\r\n            <div infinite-scroll=\'pageFunction()\'>\r\n              <div ng-repeat=\" d in mainData | filter:getItem()\">\r\n                <span ng-if=\"d.userType\"><img ng-src=\"../assets/images/profile/{{d.userType}}.svg \" class=\"usertype \"> <b>User Type:</b> {{d.userType}} </span>\r\n                <br>\r\n                <span ng-if=\"d.userType==\'politician\'\"><b>Name: </b><a href=\"#!/publicProfile/{{d._id}}\" class=\"ylink\"> {{d.nameOnBallot}}</a></span>\r\n                <span ng-if=\"d.userType==\'voter\'\"> <b>Name: </b> <a href=\"#!/voterProfile/{{d._id}}\" class=\"ylink\"> {{d.name}}</a> </span>\r\n                <span ng-if=\"d.userType==\'advocate\'\"> <b>Name: </b> <a href=\"#!/pressProfile/{{d._id}}\" class=\"ylink\"> {{d.orgName}}</a></span>\r\n                <br>\r\n                <spen><b>Username: </b>{{d.username}}</spen>\r\n\r\n                <span ng-if=\"!d.name && d.nameOnBallot\"> <b>Name:</b><a href=\"#!/pressProfile/{{d.userId.id}}\"> {{d.nameOnBallot}} </a></span>\r\n                <br>\r\n                <!-- <span ng-if=\"d.email && d.email.length > 0\"> <b>Email:</b> {{d.email[0]}} </span> -->\r\n                <span ng-if=\"d.email\"> <b>Email:</b> {{d.email}} </span>\r\n                <br>\r\n                <span ng-if=\"d.address.statePostalCode\"> <b>StatePostalCode:</b> {{d.address.statePostalCode}}</span>\r\n                <span ng-if=\"!d.address.statePostalCode && d.politicianInfo[0].statePostalCode !=\'\' \"> <b>StatePostalCode:</b> {{d.politicianInfo[0].statePostalCode}}</span>\r\n                <span ng-if=\"!d.address.statePostalCode && d.politicianInfo[0].statePostalCode ==\'\' \"> <b>StatePostalCode:</b> {{d.politicianInfo[1].statePostalCode}}</span>\r\n                <br>\r\n                <span ng-if=\"d.lastLogin\"> <b>Last Login:</b> {{d.lastLogin | date : \"M/d/y\" }}</span>\r\n                <br>\r\n                <span ng-if=\"d.created\"> <b>created:</b> {{d.created | date : \"M/d/y\" }}</span>\r\n                <br>\r\n                <div class=\"col-md\" ng-show=\"d.answersCount\">\r\n                  <a href=\"\" ng-show=\"d.answersCount\" class=\"ylink\" ng-click=\"showAns = !showAns\"> <b> Question Answered:- {{d.answersCount}}</b></a>\r\n                </div>\r\n                <div ng-hide=\"showAns\">\r\n                  <fieldset class=\"scheduler-border\">\r\n                    <legend class=\"scheduler-border\">Answers</legend>\r\n                    <div class=\"questionAnswersBlock d-flex justify-center container-fluid col-sm-12 col-lg-12\"\r\n                      style=\"width: 100%\">\r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-12\">\r\n                          <br>\r\n                          <div ng-repeat=\"com in d.answerData track by $index\">\r\n                            <div class=\"pad10\">\r\n                              <!-- <span ng-if=\"com.author.username && com.author.userType != \'voter\'\">Name:</span>\r\n                                <a href=\"#!/publicProfile/{{com.author._id}}\" class=\"link\" ng-if=\"com.author.username && com.author.userType != \'voter\'\"> {{com.author.username}}</a> -->\r\n                              <span>Name:</span>\r\n                              <a href=\"#!/publicProfile/{{d._id}}\" class=\"link\" ng-if=\"d.name && d.userType != \'voter\' && d.userType == \'politician\'\" style=\"text-transform: capitalize;\"><img ng-src=\"../assets/images/profile/politician.svg\" alt=\"Politician\"  class=\"usertype\"> {{d.nameOnBallot}}</a>\r\n                              <a href=\"#!/pressProfile/{{d._id}}\" class=\"link\" ng-if=\"d.userType == \'advocate\'\" style=\"text-transform: capitalize;\"><img ng-src=\"../assets/images/profile/advocate.svg\" class=\"usertype\" alt=\"Advocate\">{{d.orgName}}</a>\r\n                              <a href=\"#!/voterProfile/{{d._id}}\" class=\"link\" ng-if=\"d.name && d.userType == \'voter\'\" style=\"text-transform: capitalize;\"><img ng-src=\"../assets/images/profile/voter.svg \" alt=\"Voter\" class=\"usertype \"> {{d.username}}</a>\r\n                              <br>\r\n                              <span>Answer</span>\r\n                              <br>\r\n                              <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n\r\n                                <div ng-repeat=\"i in [1,2,3,4,5,6]\" class=\"mb5 clearfix\"\r\n                                  style=\"padding-left: 8px;  line-height: 15px\">\r\n                                  <span class=\"inl-blk pull-left\" ng-if=\"i == 1\" style=\"margin-right: 10px;\">AGREE</span>\r\n                                  <div class=\"cq-box inl-blk pull-left\"\r\n                                    ng-class=\"(com.answer == i) ? getComapreClass(com.answer, i) : \'\'\"></div>\r\n                                  <span class=\"inl-blk\" ng-if=\"i == 6\" style=\"padding-left:8px\">DISAGREE</span>\r\n                                </div>\r\n                              </div>\r\n                              <br>\r\n                              <p></p>\r\n                              <span>IMPORTANCE</span>\r\n                              <br>\r\n                              <div class=\"clearfix\" style=\"line-height: 15px; display: inline-flex;\">\r\n\r\n                                <div ng-repeat=\"i in [1,2,3]\" class=\"mb5 clearfix\"\r\n                                  style=\"padding-left: 8px; line-height: 9px\">\r\n                                  <span class=\"inl-blk\" ng-if=\"i == 1\">Not Very</span>\r\n                                  <span class=\"inl-blk\" ng-if=\"i == 2\">Somewhat</span>\r\n                                  <span class=\"inl-blk\" ng-if=\"i == 3\">Very</span>\r\n                                  <div class=\"cq-box inl-blk pull-right \" style=\"margin-left:8px\"\r\n                                    ng-class=\"(com.importance == i) ? \'ag-blk\' : \'\'\"></div>\r\n                                </div>\r\n                              </div>\r\n                              <p></p>\r\n                              <div>\r\n                                <span ng-if=\"com.comment\">Comment:</span>\r\n                                <span ng-if=\"com.comment\">{{com.comment}}</span>\r\n                              </div>\r\n                              <hr style=\"\r\n                                margin-left: auto;\r\n                                margin-right: auto;\r\n                                height: 1px;\r\n                                background-color:#666;\r\n                                opcaity: 0.5;\">\r\n                            </div>\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </fieldset>\r\n                </div>\r\n                <hr>\r\n\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n\r\n        <div class=\"col-md\" ng-show=\"notLoggedIn.length > 0\">\r\n          <h5>Users Who Hadn\'t LoggedIn From Long Time:-\r\n            <a href=\"\" ng-show=\"notLoggedIn.length > 0\" class=\"ylink\" ng-click=\"activeLogged = !activeLogged\"> <b> {{notLoggedIn.length}}</b></a>\r\n          </h5>\r\n          <div ng-hide=\"activeLogged\">\r\n            <div ng-repeat=\"itm in notLoggedIn\">\r\n              <span ng-if=\"itm.name\"> <b>Name:</b> {{itm.name}}</span>\r\n              <span ng-if=\"!itm.name && itm.nameOnBallot\"> <b>Name:</b> {{itm.nameOnBallot}} </span>\r\n              <br><span ng-if=\"itm.email\"> <b>Email:</b> {{itm.email[0]}}</span>\r\n              <br><span ng-if=\"itm.userType\"> <b>User Type:</b> {{itm.userType}}</span>\r\n              <br>\r\n              <span ng-if=\"itm.address.statePostalCode\"> <b>StatePostalCode:</b> {{itm.address.statePostalCode}}</span>\r\n              <br>\r\n\r\n\r\n              <span ng-if=\"itm.lastLogin\"> <b>Last Login:</b> {{itm.lastLogin | date : \"M/d/y\" }}</span>\r\n\r\n              <hr>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n</div>\r\n\r\n</fieldset>\r\n\r\n</form>\r\n</div>\r\n\r\n<!-- <div class=\"col-md\" ng-show=\"lastLogin.length > 0\">\r\n\r\n    <h5>LoggedIn Users:-\r\n      <a href=\"\" ng-show=\"lastLogin.length > 0\" class=\"ylink\" ng-click=\"activeLastLogin = !activeLastLogin\"> <b> {{lastLogin.length}}</b></a>\r\n    </h5>\r\n    <hr>\r\n    <div ng-hide=\"activeLastLogin\">\r\n      <div ng-repeat=\"item in lastLogin\">\r\n\r\n        <span ng-if=\"item.name\"> <b>Name:</b> {{item.name}}</span>\r\n        <span ng-if=\"!item.name && item.nameOnBallot\"> <b>Name:</b> {{item.nameOnBallot}} </span>\r\n        <br><span ng-if=\"item.email\"> <b>Email:</b> {{item.email[0]}}</span>\r\n        <br><span ng-if=\"item.userType\"> <b>User Type:</b> {{item.userType}}</span>\r\n        <br>\r\n        <span ng-if=\"item.address.statePostalCode\"> <b>StatePostalCode:</b> {{item.address.statePostalCode}}</span>\r\n        <br>\r\n        <span ng-if=\"item.lastLogin\"> <b>Last Login:</b> {{item.lastLogin | date : \"M/d/y\" }}</span>\r\n        <hr>\r\n        <br>\r\n      </div>\r\n      </div>\r\n    </div> -->\r\n");
$templateCache.put("app/upcomingElection/upcomingElection.html","<div class=\"container-fluid\">\r\n  <div class=\"welcomeSection4 jumbotron\">\r\n    <div class=\"row\">\r\n      <div class=\"col-lg-6 d-lg-none\">\r\n        <div class=\"row\">\r\n          <div>\r\n \r\n            <div class=\"col-12\">\r\n              <a href=\"#!/fiveMatch#DisplayQ\" class=\"blockLink\">\r\n              <img ng-src=\"./assets/images/5minQuiz1.svg\" class=\"blockInfoSmallImgSmall img-fluid\">\r\n              <div class=\"blockInfoSmall\">\r\n                  \r\n                <div>\r\n                  <h5 class=\"blockTitle\">FIVE MINUTE MATCH</h5>\r\n                  <span class=\"blockDesc\">Take a five minute quiz to get matched-up with politicians and organizations.  Or choose <a href=\"#!/questionHome\" class=\"rlink\">All Quizzes</a></span> for a better match.\r\n                </div>\r\n              </div>\r\n              </a>\r\n            </div>\r\n              \r\n              \r\n\r\n    <div class=\"col-12\">\r\n              <a href=\"#!/compare-select/politician\" class=\"blockLink\">\r\n              <img ng-src=\"./assets/images/contact_politician2.svg\" class=\"blockInfoSmallImgSmall img-fluid\">\r\n              <div class=\"blockInfoSmall\">\r\n                <div>\r\n                  <h5 class=\"blockTitle\">SEE YOUR CANDIDATES</h5>\r\n                  <span class=\"blockDesc\">Skip the quizzes and go straight to seeing your candidates.  You won\'t get a match score, but there is still a lot to see.</span>\r\n                </div>\r\n                  </div>\r\n                 \r\n              </a></div>\r\n              \r\n              \r\n    <div class=\"col-12\">\r\n              <a href=\"#!/wheretovote\" class=\"blockLink\">\r\n              <img ng-src=\"./assets/images/voterRegistration3.svg\" class=\"blockInfoSmallImgSmall img-fluid\">\r\n              <div class=\"blockInfoSmall\">\r\n                <div>\r\n                  <h5 class=\"blockTitle\">HELP VOTING</h5>\r\n                  <span class=\"blockDesc\">Register to vote. Find your polling place. Absentee ballots.  Check your status.  Report problems.</span>\r\n                </div>\r\n              </div>\r\n              </a>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"d-none d-lg-flex\" style=\"width:100%;\">\r\n        <div class=\"col-lg-6\">\r\n\r\n          <div class=\"col-12\">\r\n            <a href=\"#!/fiveMatch#DisplayQ\" class=\"blockLink\">\r\n              <img ng-src=\"./assets/images/5minQuiz1.svg\" class=\"blockInfoSmallImgSmall img-fluid\">\r\n              <div class=\"blockInfoSmall\">\r\n                  \r\n                <div>\r\n                  <h5 class=\"blockTitle\">FIVE MINUTE MATCH</h5>\r\n                  <span class=\"blockDesc\">Take a five minute quiz to get matched-up with politicians and organizations.  Or choose <a href=\"#!/questionHome\" class=\"rlink\">All Quizzes</a></span> for a better match.\r\n                </div>\r\n              </div>\r\n              </a>\r\n          </div>\r\n                           <div class=\"col-12\">\r\n            <a href=\"#!/compare-select/politician\" class=\"blockLink\">\r\n              <img ng-src=\"./assets/images/contact_politician2.svg\" class=\"blockInfoSmallImgSmall img-fluid\">\r\n              <div class=\"blockInfoSmall\">\r\n                <div>\r\n                  <h5 class=\"blockTitle\">SEE YOUR CANDIDATES</h5>\r\n                  <span class=\"blockDesc\">Skip the quizzes and go straight to seeing your candidates.  You won\'t get a match score, but there is still a lot to see.</span>\r\n                </div>\r\n                  </div>\r\n                 \r\n              </a></div>\r\n          <div class=\"col-12\">\r\n            <a href=\"#!/wheretovote\" class=\"blockLink\">\r\n              <img ng-src=\"./assets/images/voterRegistration3.svg\" class=\"blockInfoSmallImgSmall img-fluid\">\r\n              <div class=\"blockInfoSmall\">\r\n                <div>\r\n                  <h5 class=\"blockTitle\">HELP VOTING</h5>\r\n                  <span class=\"blockDesc\">Register to vote. Find your polling place. Absentee ballots.  Check your Status. Report problems.</span>\r\n                </div>\r\n              </div>\r\n              </a>\r\n          </div>\r\n       \r\n        </div>\r\n      </div>\r\n      <div class=\"col-lg-6\">\r\n      </div>\r\n    </div>\r\n  </div>");
$templateCache.put("app/updateTopic/updateTopic.html","<p></p>\r\n<h1>\r\n  <center>Update Thread</center>\r\n</h1>\r\n<p></p>\r\n<center>\r\n  <div class=\"inline2\">\r\n\r\n    <form name=\"topicform\" id=\"topicform\">\r\n      <fieldset class=\"scheduler-border\">\r\n        <legend class=\"scheduler-border\">Thread details</legend>\r\n        <p></p>\r\n        <div class=\"row\">\r\n\r\n          <div class=\"col-md-12\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"title\">Title</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"Topic.title\" placeholder=\"\"\r\n                                   data-errormessage=\"Topic is required.\"  class=\"form-control input-md  validate[required] text-input\">\r\n                            </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <div class=\"control-label\" for=\"title\">Select Tags</div>\r\n              <div class=\"DisplayCat\">\r\n                <div style=\"background-color: #eee; padding:5px;\">All Tags <br><small>(click to select)</small></div>\r\n                <div ng-repeat=\"subent in subtopics.subcategories track by $index\" ng-include=\"\'field_renderer\'\">\r\n                  Loading...</div>\r\n                <div ng-if=\"subtopics.subcategories.length == 0\" class=\"loadingSpinner\">\r\n                  <i class=\"fa fa-refresh fa-spin fa-3x fa-fw\"></i>\r\n                </div>\r\n              </div>\r\n              <div class=\"select buttons\" style=\"padding-left: 20px;\">&nbsp;\r\n                <!-- <button class=\"btn mover left\" ng-click=\"AddmyCats()\" title=\"Add selected\" ng-disabled=\"!selectedCat.length\"><i class=\"fa fa-arrow-right\" aria-hidden=\"true\"></i></button>\r\n                                <button class=\"btn mover right\" ng-click=\"RemoveCats()\" title=\"Remove selected\" ng-disabled=\"!rmselectedCat.length\">\r\n                                    <i class=\"fa fa-arrow-left\" aria-hidden=\"true\"></i>\r\n                                </button> -->\r\n              </div>\r\n              <div class=\"DisplayCat\">\r\n                <div style=\"background-color: #eee; padding:5px;\">Selected Tags<br><small>(click to remove)</small>\r\n                </div>\r\n                <ul class=\"TcatList\">\r\n                  <li ng-repeat=\"subent in selectedCat track by $index\">\r\n                    <label class=\"checkbox\" ng-if=\"mainCatIds.indexOf(subent._id) == -1 ? true:false\" title=\"{{subent.title}}\">\r\n                                            <input type=\"checkbox\" ng-click=\"removeVal(subent)\" ng-model=\"selectedAll.id[$index]\" ng-checked=\"true\" name=\"checkedidcat\"> {{subent.title}}\r\n                                        </label>\r\n                  </li>\r\n                </ul>\r\n              </div>\r\n              <div style=\"clear:both;\"></div>\r\n              <!-- <multi-select ng-model=\"Essay.subcategories\" available=\"subtopics\" selected-label=\"Selected subtopics\" available-label=\"All subtopics\" display=\"r as r.title\" title=\"r as r.title\" config=\"selectConfig\"></multi-select>\r\n                            <div class=\"input-error\" ng-show=\"selectForm.numSelected.$error.min\">\r\n                                Please select at least\r\n                                <ng-pluralize count=\"selectConfig.requiredMin\" when=\"{\'one\': \'one role\', \'other\': \'{} roles\'}\">.\r\n                            </div>\r\n                            <input type=\"hidden\" id=\"reqMin\" ng-model=\"selectConfig.requiredMin\" min=\"1\">-->\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"description\">Description</label>\r\n              <div class=\"controls\">\r\n                <textarea id=\"description\" ng-model=\"Topic.description\" placeholder=\"\"\r\n                                   data-errormessage=\"Description is required.\" class=\"form-control input-md  validate[required] text-area\"></textarea>\r\n              </div>\r\n            </div>\r\n\r\n\r\n            <div class=\"control-group\" ng-if=\"!ShowLocationOptions\">\r\n              <label class=\"control-label\" for=\"location\">Thread Location</label>\r\n              <div class=\"controls\">\r\n                <div style=\"float: left; padding-right:20px; padding-top:20px; padding-bottom:20px;\">\r\n                  <strong>City :</strong> {{uData.address.place}},<br /><strong>Sub county :</strong>\r\n                  {{uData.address.countySubdivision}},<br />\r\n                  <strong>County :</strong> {{uData.address.county}},<br /><strong>State :</strong>\r\n                  {{uData.address.state}}<br>\r\n                                </div>\r\n                <div style=\"float: left; margin-left:2%; padding-top:40px; padding-bottom:20px;\">\r\n                  <input type=\"button\" value=\"Change\" ng-click=\"ShowLocation()\">\r\n                                </div>\r\n                <div style=\"clear:both;\"></div>\r\n              </div>\r\n            </div>\r\n            <div class=\"control-group\" ng-if=\"ShowLocationOptions\">\r\n\r\n              <div class=\"DisplayCat changeTextColor\">\r\n                <div style=\"background-color: #eee; padding:5px;\">Choose Location\r\n                  <br><small>(click to select)</small></div>\r\n                <ul class=\"TcatList\">\r\n                  <li style=\"padding-bottom:10px;\">\r\n\r\n                    <input type=\"checkbox\" ng-change=\"getLocations(Essay.Locations, \'International\')\" ng-model=\"Essay.Locations\" ng-true-value=\"\'International\'\" ng-false-value=\"\'NO\'\">\r\n                    <label ng-click=\"ShowAddLocation();\">International&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-show=\"never\"></i></label>\r\n                    <!-- <div style=\"padding-left:20px;\" ng-if=\"AddLocation\">\r\n                                    <div mass-autocomplete>\r\n                                      <input ng-model=\"newlocation.country\" mass-autocomplete-item=\"autocomplete_options\">\r\n                              </div>\r\n                                      <div style=\"text-align: right;\">\r\n                                        <button ng-click=\"AddCountry();\">Add country</button>\r\n                                      </div>\r\n                                    </div> -->\r\n                  </li>\r\n                  <li>\r\n                    <input type=\"checkbox\" ng-model=\"Essay.National\"  ng-change=\"getLocations(Essay.National, \'National\')\" ng-true-value=\"\'National\'\" ng-false-value=\"\'NO\'\">\r\n                    <label>National</label>\r\n                    </i>\r\n                    <ul class=\"TcatList\">\r\n                      <li ng-repeat=\"area in allLocations track by $index\">\r\n                        <input type=\"checkbox\" ng-click=\"getAreaVal(area, area.state, \'state\')\" ng-disabled=\"checkDisabled(area, area.state, \'state\')\" ng-checked=\"checkDisabled(area, area.state, \'state\')\">\r\n                        <label ng-click=\"getCounties(area.stateFips)\">{{area.state}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoading.indexOf(area.stateFips)==-1\"></i> <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoading.indexOf(area.stateFips) > -1\"></i></label>\r\n                        <!-- Display Counties -->\r\n                        <ul class=\"TcatList\">\r\n                          <li ng-repeat=\"county in allCounties[area.stateFips] | orderBy:\'countyName\' track by $index\">\r\n                            <input type=\"checkbox\" ng-click=\"getAreaVal(county, area.state, \'county\')\" ng-disabled=\"checkDisabled(county, area.state, \'county\')\" ng-checked=\"checkDisabled(county, area.state, \'county\')\">\r\n                            <label ng-click=\"getLocals(area.stateFips, county.countyFips)\">{{county.countyName}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoadingCounty.indexOf(county.county) == -1\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingCounty.indexOf(county.county) > -1\"></i></label>\r\n                            <!-- Display Locals and sub counties -->\r\n                            <ul class=\"TcatList\" ng-if=\"Essay.location!=\'National\'\">\r\n                              <li\r\n                                ng-repeat=\"local in allLocals[area.stateFips][county.countyFips] | orderBy:\'placeName\'  track by $index\">\r\n                                <label class=\"checkbox\" title=\"{{local.place}}\">\r\n                                          <input type=\"checkbox\" ng-click=\"getAreaVal(local, area.state, \'local\')\" ng-disabled=\"disabledLocation.indexOf(local) > -1 ? true : false\" ng-checked=\"disabledLocation.indexOf(local) > -1 ? true : false\"> {{local.placeName}}\r\n                                        </label>\r\n                              </li>\r\n                            </ul>\r\n                            <!-- Display Locals and sub counties End -->\r\n                          </li>\r\n                        </ul>\r\n                        <!-- Display Counties End -->\r\n                      </li>\r\n                    </ul>\r\n                  </li>\r\n                </ul>\r\n              </div>\r\n\r\n              <div class=\"DisplayCat changeTextColor\">\r\n                <div style=\"background-color: #eee; padding:5px;\">Selected Location\'s\r\n                  <br><small>(click to remove)</small></div>\r\n                <ul class=\"TcatList\">\r\n                  <li ng-repeat=\"area in selectedArea track by $index\">\r\n                    <!-- {{area}} -->\r\n                    <label class=\"checkbox\" title=\"{{area}}\">\r\n                              <input type=\"checkbox\" ng-click=\"removeAreaVal(area)\" name=\"checkedid\" ng-model=\"selectedLAll.id[$index]\" ng-checked=\"true\"> <span ng-if=\"area.country && (!(area.state) && !(area.county) && !(area.countySubdivision) && !(area.place))\">{{area.country}}</span> <span ng-if=\"area.state && (!(area.county) && !(area.countySubdivision) && !(area.place))\">{{area.state}}</span><span ng-if=\"area.county && (!(area.countySubdivision) && !(area.place))\">{{area.county}}</span><span ng-if=\"area.countySubdivision\">{{area.countySubdivision}}</span><span ng-if=\"area.place\"> - {{area.place}}</span>\r\n                            </label>\r\n                  </li>\r\n                </ul>\r\n              </div>\r\n              <div style=\"clear:both;\"></div>\r\n              <!--\r\n                                        <multi-select ng-model=\"Essay.subcategories\" available=\"subtopics\" selected-label=\"Selected subtopics\" available-label=\"All subtopics\" display=\"r as r.title\" title=\"r as r.title\" config=\"selectConfig\"></multi-select>\r\n                                        <div class=\"input-error\" ng-show=\"selectForm.numSelected.$error.min\">\r\n                                            Please select at least\r\n                                            <ng-pluralize count=\"selectConfig.requiredMin\" when=\"{\'one\': \'one role\', \'other\': \'{} roles\'}\">.\r\n                                        </div>\r\n                                        <input type=\"hidden\" id=\"reqMin\" ng-model=\"selectConfig.requiredMin\" min=\"1\">\r\n                                        -->\r\n            </div>\r\n\r\n            <!--         <div class=\"control-group\">\r\n                            <label class=\"control-label\" for=\"restricted\">Any Restrictions</label>\r\n                            <div class=\"control-group\">\r\n                               <select ng-model=\"Topic.restrictedTo\">\r\n                                   <option ng-repeat=\"option in restrictedOptions\" value=\"{{option}}\" class=\"blackText\">{{option}}</option>\r\n                                </select>\r\n\r\n                            </div>\r\n                        </div>  -->\r\n\r\n\r\n            <div style=\"clear: both;\"></div>\r\n            <div style=\"margin-top:20px;\">\r\n              <button ng-click=\"SubmitTopic(Topic)\" type=\"button\" class=\"btn btn-success\" ng-disabled=\"TopicButton\"  style=\"float: left;\">Submit Thread</button>\r\n              &nbsp;&nbsp;&nbsp;&nbsp;\r\n              <button ng-click=\"goBack();\" type=\"button\" style=\"float: left;\" class=\"blackText\">Cancel</button>\r\n              <div style=\"clear: both;\"></div>\r\n            </div>\r\n            <div style=\"clear: both;\"></div>\r\n\r\n\r\n          </div>\r\n\r\n      </fieldset>\r\n    </form>\r\n\r\n  </div>\r\n\r\n\r\n</center>\r\n<script type=\"text/ng-template\" id=\"field_renderer\">\r\n    <ul class=\"TcatList\">\r\n        <li>\r\n             <div class=\"catname\" id=\"{{subent._id}}\" ng-if=\"(subent.parentIds.length == 0) && (subent.subcategories)\">\r\n                <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\">  <label ng-click=\"ChangeShow(subent._id);\">{{::subent.title}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id)==-1\"></i><i class=\"fa fa-caret-right\" aria-hidden=\"true\"  ng-if=\"showDown.indexOf(subent._id) > -1\"></i></label>\r\n            </div>\r\n            <div class=\"catname\" ng-if=\"(subent.parentIds.length == 0) && (!subent.subcategories)\">\r\n                <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                    <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\"> {{::subent.title}}\r\n                </label>\r\n            </div>\r\n            <label class=\"checkbox\" ng-if=\"subent.parentIds.length > 0 && showSubCat\" title=\"{{subent.title}}\" >\r\n                <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\"> {{::subent.title}}\r\n            </label>\r\n            <ul ng-if=\"subent.subcategories\" ng-class=\"subent.parentIds.length == 0 ? \'cmnUL MainCatLi_{{subent._id}}\' : \'\'\">\r\n                <li ng-repeat=\"subent in subent.subcategories track by $index\" ng-include=\"\'field_renderer\'\">\r\n                    <!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                      <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n                  </label> -->\r\n                </li>\r\n            </ul>\r\n        </li>\r\n    </ul>\r\n</script>\r\n<script type=\"text/javascript\">\r\n  jQuery(document).ready(function () {\r\n    // binds form submission and fields to the validation engine\r\n    // binds form submission and fields to the validation engine\r\n    $(\"form\").validationEngine();\r\n  });\r\n</script>\r\n");
$templateCache.put("app/uploadAdvocates/uploadAdvocates.html","<div class=\"container-fluid ng-scope\" ng-cloak ng-show=\"$root.userRole==\'admin\'\">\r\n  <h2 class=\"pageHeading\">Settings</h2>\r\n  <div>\r\n    <div class=\"closeForm\" ng-include=\"\'app/popups/setting_Ctrl.html\'\"></div>\r\n  </div>\r\n  <!-- Upload Advocates -->\r\n  <form ng-if=\"$root.showAdvocates\" name=\"advcateform\" id=\"advcateform\" ng-controller=\"UploadAdvocateCtrl\"\r\n    class=\"closeForm\">\r\n    <fieldset class=\"scheduler-border\" ng-if=\"showAdvcoatesList\">\r\n      <legend class=\"scheduler-border\">Upload csv file</legend>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <p>Download sample excel file.\r\n            <a href=\"../assets/downloadFile/sampleAdvocate.xlsx\" target=\"_blank\" class=\"ylink\">Click Here</a>\r\n          </p>\r\n          <div class=\"control-group\" style=\"padding:5px;\">\r\n            <label class=\"control-label\" for=\"upload-file\">\r\n              <strong>Update Option : </strong>\r\n            </label>\r\n            <select class=\"changeTextColor\" ng-model=\"upload.opt\">\r\n              <option value=\"New\">Create New</option>\r\n              <option value=\"Update\">Update</option>\r\n            </select>\r\n          </div>\r\n          <div class=\"control-group\" style=\"padding:5px;\">\r\n            <label class=\"control-label\" for=\"upload-file\">\r\n              <strong>Select csv File : </strong>\r\n            </label>\r\n            <input type=\"file\" file-model=\"upload.files\" class=\"form-control input-md text-input\" accept=\".xlsx\">\r\n          </div>\r\n            <div class=\"control-group\" style=\"padding-left:20px;\">\r\n              <button ng-click=\"updateAdvocates(upload)\" type=\"submit\" ng-disabled=\"AdvocateButton\" class=\"btnShort-style\" style=\"float: left;\">Save</button>&nbsp;\r\n              <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"AdvocateButton\"></i>\r\n              <!--<fb:login-button scope=\"public_profile,email\" onlogin=\"checkLoginState();\"></fb:login-button>-->\r\n              <div style=\"clear: both;\"></div>\r\n            </div>\r\n            <div style=\"clear: both;\"></div>\r\n          </div>\r\n        </div>\r\n    </fieldset>\r\n    <div class=\"row\" ng-if=\"advocates.data.length > 0 && showAdvcoatesList\" style=\"margin-top: 10px;\">\r\n      <div style=\"text-align: center; padding:10px;\">\r\n        <label class=\"control-label\" for=\"search\">\r\n          <strong>Search : </strong>\r\n        </label>\r\n        <input type=\"text\" ng-model=\"search\" class=\"form-control input-md text-input\">\r\n      </div>\r\n        <div style=\"float:right;\" class=\"changeTextColor\">\r\n          <dir-pagination-controls max-size=\"5\" pagination-id=\"list.id\"></dir-pagination-controls>\r\n        </div>\r\n        <a href=\"javascript: void(0);\" ng-if=\"showExportLink\" ng-click=\"exportData();\" class=\"ylink\">Export Data</a>\r\n        <span ng-if=\"!showExportLink\">\r\n          <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i> Please wait this may take time...</span>\r\n        &nbsp;&nbsp;&nbsp;&nbsp;\r\n        <a href=\"javascript: void(0);\"  ng-click=\"createUserOfOrg();\" class=\"ylink\">Create Users Of Org</a>\r\n        <span ng-if=\"showCreate\">\r\n          <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i> Please wait this may take time...</span>\r\n\r\n        <table class=\"w100 changeTextColor\">\r\n          <tr>\r\n            <th>Organization</th>\r\n            <th>Details</th>\r\n          </tr>\r\n          <tr dir-paginate=\"u in advocates.data | filter: search | itemsPerPage : 25\" pagination-id=\"list.id\">\r\n            <td>\r\n              <strong>{{u.title}}</strong>\r\n              <p ng-if=\"u.contact_person.name\" style=\"margin: 0;\">\r\n                <strong>Official:</strong> {{u.contact_person.name}}\r\n                <span ng-if=\"u.contact_person.position\">\r\n                      <strong>, Position:</strong> {{u.contact_person.position}}</span>\r\n                <span ng-if=\"u.contact_person.phone_no\">\r\n                      <strong>, Contact Phone:</strong> {{u.contact_person.phone_no}}</span>\r\n              </p>\r\n              <p ng-if=\"u.email\" style=\"margin: 0;\">\r\n                <strong>Email:</strong> {{u.email}}</p>\r\n              <p ng-if=\"u.typeOfOrg\" style=\"margin: 0;\">\r\n                <strong>Type Of Organization:</strong> {{u.typeOfOrg}}</p>\r\n              <p ng-if=\"u.empIndNo\" style=\"margin: 0;\">\r\n                <strong>Employee Indentification Number:</strong> {{u.empIndNo}}</p>\r\n\r\n              <p ng-if=\"u.mailing_address\" style=\"margin: 0;\">\r\n                <strong>Address:</strong> {{u.mailing_address}} </p>\r\n              <p ng-if=\"u.phone_no\" style=\"margin: 0;\">\r\n                <strong>Phone:</strong> {{u.phone_no}}</p>\r\n            </td>\r\n            <td>\r\n              <a href=\"javascript: void(0);\" ng-click=\"showAdvocate(u, $index)\" class=\"link\">Details</a>\r\n              <br>\r\n              <br>\r\n              <a href=\"\" ng-click=\"makeInactive(\'inactive\',u._id)\" ng-if=\"u.inactive ==null\" class=\"link\">Make Inactive</a>\r\n              <a href=\"\" ng-click=\"makeInactive(null,u._id)\" ng-if=\"u.inactive == \'inactive\'\" class=\"link\">Make Active</a>\r\n              <br>\r\n              <br>\r\n\r\n            </td>\r\n          </tr>\r\n        </table>\r\n        <div style=\"float:right;\" class=\"changeTextColor\">\r\n          <dir-pagination-controls max-size=\"5\" pagination-id=\"list.id\"></dir-pagination-controls>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\" ng-if=\"!showAdvcoatesList\" style=\"margin-top: 10px;\">\r\n        <div class=\"row\">\r\n          <!-- <div class=\"col-md-12\"> -->\r\n          <div class=\"col-md-6\">\r\n            <div class=\"control-group\" style=\"margin-top:30px;\">\r\n              <div class=\"controls\">\r\n                <h3>Contact Details</h3>\r\n              </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel removeTopMargin\" for=\"ShowData-name\">Name</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"ShowData.contactPerson.name\" class=\"form-control input-md text-input validate[required]\">\r\n            </div>\r\n              </div>\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel\" for=\"ShowData-extension_no\">Position</label>\r\n                <div class=\"controls\">\r\n                  <input type=\"text\" ng-model=\"ShowData.contactPerson.position\" class=\"form-control input-md text-input\">\r\n            </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"ShowData-extension_no\">Phone</label>\r\n                  <div class=\"controls\">\r\n                    <input type=\"text\" ng-model=\"ShowData.contactPerson.phoneNo\" class=\"form-control input-md text-input\">\r\n            </div>\r\n                  </div>\r\n                  <div class=\"control-group\">\r\n                    <label class=\"control-label formLabel\" for=\"ShowData-email\">Email</label>\r\n                    <div class=\"controls\">\r\n                      <input type=\"text\" ng-model=\"ShowData.contactPerson.email\" class=\"form-control input-md text-input validate[custom[email]]\">\r\n            </div>\r\n                    </div>\r\n                    <div ng-show=\"$root.userRole != \'voter\'\">\r\n                      <div class=\"control-group\" style=\"margin-top:30px;\">\r\n                        <div class=\"controls\">\r\n                          <h3>Organization Details</h3>\r\n                        </div>\r\n                      </div>\r\n                      <div class=\"control-group\">\r\n                        <label class=\"control-label formLabel removeTopMargin\" for=\"ShowData-title\">Name</label>\r\n                        <div class=\"controls\">\r\n                          <input type=\"text\" ng-model=\"ShowData.title\" class=\"form-control input-md text-input validate[required]\">\r\n              </div>\r\n                        </div>\r\n                        <div class=\"control-group\">\r\n                          <label class=\"control-label formLabel\" for=\"ShowData-phoneNo\">Phone</label>\r\n                          <div class=\"controls\">\r\n                            <input type=\"text\" ng-model=\"ShowData.phoneNo\" class=\"form-control input-md text-input\">\r\n              </div>\r\n                          </div>\r\n                          <div class=\"control-group\">\r\n                            <label class=\"control-label formLabel\" for=\"ShowData-email\">Email</label>\r\n                            <div class=\"controls\">\r\n                              <input type=\"text\" ng-model=\"ShowData.email\" class=\"form-control input-md text-input validate[custom[email]]\">\r\n              </div>\r\n                            </div>\r\n                            <div class=\"control-group\">\r\n                              <label class=\"control-label formLabel\" for=\"ShowData-webUrl\">Website</label>\r\n                              <div class=\"controls\">\r\n                                <input type=\"text\" ng-model=\"ShowData.webUrl\" class=\"form-control input-md text-input\">\r\n              </div>\r\n                              </div>\r\n                              <div class=\"control-group\">\r\n                                <label class=\"control-label formLabel\" for=\"ShowData-facebook_url\">Facebook Url</label>\r\n                                <div class=\"controls\">\r\n                                  <input type=\"text\" ng-model=\"ShowData.facebook_url\" class=\"form-control input-md text-input\">\r\n              </div>\r\n                                </div>\r\n                                <div class=\"control-group\">\r\n                                  <label class=\"control-label formLabel\" for=\"ShowData-zipcode\">Zipcode</label>\r\n                                  <div class=\"controls\">\r\n                                    <input type=\"text\" ng-model=\"ShowData.zipcode\" class=\"form-control input-md text-input validate[required]\">\r\n              </div>\r\n                                  </div>\r\n                                  <div class=\"control-group\">\r\n                                    <label class=\"control-label formLabel\" for=\"typOfOrg\">Type Of Organization</label>\r\n                                    <div class=\"controls\">\r\n                                      <input type=\"text\" ng-model=\"ShowData.typeOfOrg\" class=\"form-control input-md text-input validate[required]\">\r\n                  </div>\r\n                                    </div>\r\n                                    <div class=\"control-group\">\r\n                                      <label class=\"control-label formLabel\" for=\"empIndNo\">Employee Identification Number</label>\r\n                                      <div class=\"controls\">\r\n                                        <input type=\"text\" ng-model=\"ShowData.empIndNo\" class=\"form-control input-md text-input validate[required]\">\r\n                      </div>\r\n                                      </div>\r\n                                      <div class=\"control-group\">\r\n                                        <label class=\"control-label formLabel\" for=\"ShowData-state\">State</label>\r\n                                        <div class=\"controls\">\r\n                                          <select class=\"changeTextColor\" ng-model=\"ShowData.stateData\" ng-change=\"getCounties(ShowData.stateData);\">\r\n                  <option ng-repeat=\"opt in allLocations track by $index\" value=\"{{opt}}\">{{opt.state}}</option>\r\n                </select>\r\n                                        </div>\r\n                                      </div>\r\n                                      <div class=\"control-group\">\r\n                                        <label class=\"control-label formLabel\" for=\"ShowData-county\">County</label>\r\n                                        <div class=\"controls\">\r\n                                          <select class=\"changeTextColor\" ng-model=\"ShowData.county\" ng-change=\"getLocals(ShowData.stateData, ShowData.county)\">\r\n                  <option ng-repeat=\"opt in MyCounties track by $index\" value=\"{{opt._id}}\">{{opt._id.county}}</option>\r\n                </select>\r\n                                        </div>\r\n                                      </div>\r\n                                      <div class=\"control-group\">\r\n                                        <label class=\"control-label formLabel\" for=\"profile-state\">Locality</label>\r\n                                        <div class=\"controls\">\r\n                                          <select class=\"changeTextColor\" ng-model=\"ShowData.Locality\">\r\n                  <option ng-repeat=\"opt in MyPlaces track by $index\" value=\"{{opt._id}}\">{{opt._id.countySubdivision}} - {{opt._id.place}}</option>\r\n                </select>\r\n                                        </div>\r\n                                      </div>\r\n                                    </div>\r\n                                  </div>\r\n                                  <div class=\"col-md-6\">\r\n                                    <div class=\"control-group\" style=\"margin-top:30px;\">\r\n                                      <div class=\"controls\">&nbsp;</div>\r\n                                    </div>\r\n                                    <div class=\"control-group\">\r\n                                      <label class=\"control-label formLabel\" for=\"ShowData-mailingAddress\">Mailing Address</label>\r\n                                      <div class=\"controls\">\r\n                                        <textarea ng-model=\"ShowData.mailingAddress\" class=\"form-control input-md text-input\" style=\"height:70px;\"></textarea>\r\n                                      </div>\r\n                                    </div>\r\n                                    <div class=\"control-group\">\r\n                                      <label class=\"control-label formLabel\" for=\"ShowData-topics\">Topics</label>\r\n                                      <div class=\"controls\">\r\n                                        <textarea ng-model=\"ShowData.topic\" class=\"form-control input-md text-input\" style=\"height:70px;\"></textarea>\r\n                                      </div>\r\n                                    </div>\r\n                                    <div class=\"control-group\">\r\n                                      <label class=\"control-label formLabel\" for=\"ShowData-specialTopic\">Special Topics</label>\r\n                                      <div class=\"controls\">\r\n                                        <textarea ng-model=\"ShowData.specialTopic\" class=\"form-control input-md text-input\" style=\"height:70px;\"></textarea>\r\n                                      </div>\r\n                                    </div>\r\n                                  </div>\r\n                                  <div style=\"clear:both;\"></div>\r\n                                  <div class=\"forgetPassButtons\">\r\n                                    <button ng-click=\"updateAdvocatesData(ShowData)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btnShort-style\">Save</button>\r\n                                    &nbsp;\r\n                                    <button ng-click=\"registerAdvocateData(ShowData)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btn btn-success\">Create User</button>\r\n                                    &nbsp;\r\n                                    <button ng-click=\"goBack()\" type=\"button\" class=\"btn btn-success\">Cancel</button>\r\n                                    <div style=\"clear: both;\"></div>\r\n                                  </div>\r\n                                  <!-- </div> -->\r\n                                </div>\r\n                              </div>\r\n  </form>\r\n  <!-- Upload Advocates End -->\r\n</div>\r\n");
$templateCache.put("app/uploadBallotMeasures/uploadBallotMeasures.html","<div class=\"container-fluid\">\r\n  <fieldset class=\"scheduler-border\">\r\n    <legend class=\"scheduler-border\">Upload Ballot Measures</legend>\r\n    <div class=\"control-group\" style=\"padding:5px;\">\r\n      <p>Download sample excel file.\r\n        <a href=\"../assets/downloadFile/ballotsample.xlsx\" target=\"_blank\" class=\"ylink\">Click Here</a>\r\n      </p>\r\n      <label class=\"control-label\" for=\"upload-file\">\r\n        <strong>Select csv File : </strong>\r\n      </label>\r\n      <input type=\"file\" file-model=\"upload.files\" class=\"form-control input-md text-input\" accept=\".xlsx\">\r\n      <p ng-show=\"upload.maxSizeError\">Max file size exceeded (2000 bytes)</p>\r\n    </div>\r\n    <div class=\"control-group blackText\" style=\"padding-left:20px;\">\r\n      <button ng-click=\"uploadBallotMeasures(upload)\" type=\"submit\" ng-disabled=\"PoliticianButton || upload.PoliticianButton\" class=\"btnShort-style\" style=\"float: left;\">Save</button>&nbsp;\r\n      <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"PoliticianButton\"></i>\r\n      <!--<fb:login-button scope=\"public_profile,email\" onlogin=\"checkLoginState();\"></fb:login-button>-->\r\n      <div style=\"clear: both;\"></div>\r\n    </div>\r\n    <div style=\"clear: both;\"></div>\r\n    <p>\r\n      <b>Mandatory Fields:</b>\r\n      <ul>\r\n\r\n        <li>voterScope</li>\r\n        <ul>Acceptable answers:\r\n          <li>statePostalCode</li>\r\n          <li>countyName</li>\r\n          <li>placeName</li>\r\n          <li>countySubdivision</li>\r\n        </ul>\r\n      </ul>\r\n    </p>\r\n  </fieldset>\r\n  <div style=\"text-align: center; padding:10px;\">\r\n    <label class=\"control-label\" for=\"search\">\r\n        <strong>Select State: </strong>\r\n      </label>\r\n    <select ng-model=\"ballot.state\" ng-change=\"getBallotMeasuresStateWise(ballot.state);\" class=\"changeTextColor\">\r\n        <option value=\"{{allUSAPol}}\">All USA</option>\r\n        <option ng-repeat=\"opt in allLocations track by $index\" value=\"{{opt}}\">{{opt.state}}</option>\r\n      </select>\r\n    &nbsp;\r\n    <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoader\"></i>\r\n  </div>\r\n\r\n  <div ng-if=\"ballotData.length > 0\">\r\n    <a href=\"javascript: void(0);\" ng-click=\"exportData();\" class=\"ylink\">Export Selected state data</a>\r\n    <br>\r\n    <div style=\"padding-top: 5px; padding-bottom: 5px;\">\r\n      <input type=\"button\" class=\"btn\" ng-click=\"deleteSelected()\" value=\"Delete Selected Records\">\r\n    </div>\r\n      <table class=\"w100\">\r\n        <tr>\r\n          <th style=\"width:5%; padding-top:5px;\">\r\n            <input type=\"checkbox\" ng-change=\"SelectChecks()\" ng-model=\"isSelected\">\r\n        </th>\r\n          <th>Title</th>\r\n          <th>Election Date</th>\r\n          <th>Measure Text</th>\r\n          <th>Summary</th>\r\n          <th>Summary Url</th>\r\n          <th>Text Url</th>\r\n          <th>Update</th>\r\n\r\n        </tr>\r\n        <tr ng-repeat=\"u in ballotData\">\r\n          <td style=\"vertical-align:middle;\">\r\n            <input type=\"checkbox\" ng-model=\"u.checked\" name=\"{{u._id}}\" id=\"{{u._id}}\">\r\n        </td>\r\n          <td class=\"textColor\">\r\n            <strong ng-if=\"u.title\">{{u.title}}</strong>\r\n          </td>\r\n          <td class=\"changeTextColor\">\r\n            {{u.electionDate | date : \"MM/dd/yyyy\"}}\r\n          </td>\r\n          <td>\r\n            <a href=\"javascript: void(0)\" ng-if=\"u.measureText\" ng-click=\"showHtmlViewer(u.measureText, \'BallotMeaures\')\" class=\"link\">\r\n                <b>View</b>\r\n              </a>\r\n            <span ng-if=\"!u.measureText\">-</span></td>\r\n          </td>\r\n          <td>\r\n            <a href=\"javascript: void(0)\" ng-if=\"u.summary\" ng-click=\"showHtmlViewer(u.summary, \'BallotMeaures\')\" class=\"link\">\r\n                  <b>View</b>\r\n                </a>\r\n            <span ng-if=\"!u.summary\">-</span></td>\r\n          </td>\r\n          <td>\r\n            <a href=\"{{u.summaryUrl}}\" target=\"_blank\" class=\"link\">{{u.summaryUrl}}</a>\r\n          </td>\r\n          <td>\r\n            <a href=\"{{u.textUrl}}\" target=\"_blank\" class=\"link\">{{u.textUrl}}</a> </td>\r\n          <td>\r\n            <a href=\"javascript: void(0)\" ng-click=\"editBill(u, $index)\" class=\"link\">Update</a>\r\n          </td>\r\n        </tr>\r\n        <tr>\r\n          <td style=\"text-align:left; padding:5px;\" colspan=\"8\">\r\n            <input type=\"button\" class=\"btn\" ng-click=\"deleteSelected()\" value=\"Delete Selected Records\">\r\n        </td>\r\n        </tr>\r\n      </table>\r\n    </div>\r\n  </div>\r\n  <script type=\"text/ng-template\" id=\"ballotText\">\r\n  <div class=\"row\">\r\n  <div ng-bind-html=\'displayContent\' class=\"txtwindow\"></div>\r\n</div>\r\n</script>\r\n");
$templateCache.put("app/uploadBarAssociations/uploadBarAssociations.html","<div class=\"container-fluid\">\r\n<fieldset class=\"scheduler-border\">\r\n        <legend class=\"scheduler-border\">Upload Bar Associations Rating</legend>\r\n        <div class=\"control-group\" style=\"padding:5px;\">\r\n <p>Download sample excel file.\r\n            <a href=\"../assets/downloadFile/barAssoSample.xlsx\" download=\"barAssoSample.xlsx\" target=\"_blank\" class=\"ylink\">Click Here</a>\r\n          </p>\r\n          <label class=\"control-label\" for=\"upload-file\">\r\n            <strong>Select csv File : </strong>\r\n          </label>\r\n              <input type=\"file\" file-model=\"upload.files\" class=\"form-control input-md text-input\" accept=\".xlsx\">\r\n            <p ng-show=\"upload.maxSizeError\">Max file size exceeded (2000 bytes)</p>\r\n        </div>\r\n        <div class=\"control-group blackText\" style=\"padding-left:20px;\">\r\n          <button ng-click=\"uploadBarAssociations(upload)\" type=\"submit\" class=\"btnShort-style\" style=\"float: left;\">Save</button>&nbsp;\r\n          <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoader\"></i>\r\n          <div style=\"clear: both;\"></div>\r\n        </div>\r\n        <div style=\"clear: both;\"></div>\r\n        <p>\r\n          <b>Mandatory Fields:</b>\r\n          <ul>\r\n            <li>politicianId</li>\r\n            <li>rating</li>\r\n          </ul>\r\n        </p>\r\n      </fieldset>\r\n</div>");
$templateCache.put("app/uploadElectionDate/uploadElectionDate.html","<div class=\"container-fluid\">\r\n  <h6>Upload ElectionDate</h6>\r\n  <div class=\"control-group\" style=\"padding:5px;\">\r\n    <label class=\"control-label\" for=\"upload-file\">\r\n      <strong>Select csv File : </strong>\r\n    </label>\r\n    <input type=\"file\" file-model=\"upload.files\" class=\"form-control input-md text-input\" accept=\".xlsx\">\r\n    <p ng-show=\"upload.maxSizeError\">Max file size exceeded (2000 bytes)</p>\r\n  </div>\r\n  <div class=\"control-group blackText\" style=\"padding-left:20px;\">\r\n    <button ng-click=\"uploadElectionDates(upload)\" type=\"submit\" ng-disabled=\"PoliticianButton || upload.PoliticianButton\" class=\"btnShort-style\" style=\"float: left;\">Save</button>&nbsp;\r\n    <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"PoliticianButton\"></i>\r\n    <!--<fb:login-button scope=\"public_profile,email\" onlogin=\"checkLoginState();\"></fb:login-button>-->\r\n    <div style=\"clear: both;\"></div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/uploadFollowers/uploadFollowers.html","<div class=\"container-fluid\" ng-controller=\"uploadFollowersCtrl\">\r\n  <!-- <h6>Welcome</h6> -->\r\n    <h2 class=\"pageHeading\">UPLOAD FOLLOWERS</h2>\r\n  <p class=\"pageSubHeading noPaddBott\">Use this tool to upload the names and email addresses of followers who you would like to poll with your quiz.  As soon as you hit the \"upload\" button, we will send them an invitation to take the quiz and you will be able to see their anonnymous results. We ask for their names in addition to their email addresses only because it helps the email get to them and not get treated as spam.</p><p class=\"pageSubHeading\">The file you upload must be .csv or .xlxs format (like from microsoft excel) and it can only be one \"sheet\" as opposed to a workbook with many sheets. The file must have a column labelled \"name\" and a column labelled \"email\".  Do not capitalize or put in spaces or anything else into those headers or the file won\'t upload. If you have more than those two columns, those extra columns will be ignored, but the two good columns will still work fine.</p>\r\n  <form name=\"uploadFollower\" id=\"uploadFollower\">\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Upload csv file</legend>\r\n      <div class=\"control-group\" style=\"padding:5px;\">\r\n        <label class=\"control-label\" for=\"upload-file\">\r\n          <strong>Select csv File : </strong>\r\n        </label>\r\n        <input type=\"file\" file-model=\"upload.files\" class=\"form-control input-md text-input\" accept=\".xlsx\">\r\n        <p ng-show=\"upload.maxSizeError\">Max file size exceeded (2000 bytes)</p>\r\n      </div>\r\n      <div class=\"control-group blackText\" style=\"padding-left:20px;\">\r\n        <button ng-click=\"uploadFollowers(upload)\" type=\"submit\" ng-disabled=\"PoliticianButton || upload.PoliticianButton\" class=\"btnShort-style\" style=\"float: left;\">Upload</button>&nbsp;\r\n        <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"PoliticianButton\"></i>\r\n        <div style=\"clear: both;\"></div>\r\n      </div>\r\n    </fieldset>\r\n  </form>\r\n</div>\r\n");
$templateCache.put("app/uploadNewPolitician/uploadNewPolitician.html","<div class=\"container-fluid ng-scope\" ng-cloak ng-show=\"$root.userRole==\'admin\'\">\r\n  <h2 class=\"pageHeading\">Settings</h2>\r\n  <!-- Upload Politicians -->\r\n  <div>\r\n    <div class=\"closeForm\" ng-include=\"\'app/popups/setting_Ctrl.html\'\"></div>\r\n  </div>\r\n  <!--upload new-->\r\n  <form ng-if=\"$root.showVUpload\" name=\"uploadform\" id=\"uploadform\" ng-controller=\"UploadNewPoliticianCtrl\"\r\n    class=\"closeForm\">\r\n    <p>\r\n      <a href=\"javascript: void(0);\" ng-click=\"showPreferences()\">Setup your preferences</a>\r\n    </p>\r\n    <fieldset>\r\n      <h2>Select State and County</h2>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label\" for=\"email\">State </label>\r\n        <select class=\"changeTextColor\" ng-model=\"address.state\" style=\"text-transform: capitalize;\" ng-change=\"getCounties()\" ng-options=\"item.state for item in allState track by item.state\"></select>\r\n      </div>\r\n      <div class=\"control-group\" ng-if=\"countyList.length > 0\">\r\n        <label class=\"control-label\" for=\"email\">County </label>\r\n        <select class=\"changeTextColor\" ng-model=\"address.county\" ng-change=\"getSubCounties()\" style=\"text-transform: capitalize;\" ng-options=\"item as item for item in counties\"></select>\r\n      </div>\r\n      <div class=\"control-group\" ng-if=\"countyList.length == 0\">\r\n        <label class=\"control-label\" for=\"email\">County </label>\r\n        <select class=\"changeTextColor\" ng-model=\"address.county\" ng-change=\"getSubCounties()\" style=\"text-transform: capitalize;\" ng-options=\"item as item.county for item in counties\"></select>\r\n      </div>\r\n    </fieldset>\r\n    <!--\r\n                    <div>\r\n                        <js-xls onread=\"read\" onerror=\"error\"></js-xls>\r\n                    </div>\r\n                    <div>\r\n                    <textarea rows=\"20\" cols=\"100\" ng-model=\"finaldata\"></textarea>\r\n                    </div>\r\n                    -->\r\n    <div ng-if=\"address.state!=\'\' && address.county!=\'\'\" class=\"changeTextColor\">\r\n      <button type=\"button\" class=\"btn btn-success\" ng-click=\"reset()\">Reset Grid</button>&nbsp;&nbsp;&nbsp;\r\n      <button id=\"button_add\" class=\"btn\" ng-click=\"add()\">Add new column at end</button>&nbsp;&nbsp;&nbsp;\r\n      <button id=\"button_remove\" class=\"btn\" ng-if=\"showSave\" ng-click=\"remove()\">Remove selected rows</button>&nbsp;&nbsp;\r\n      <button id=\"button_remove\" class=\"btn\" ng-if=\"!showSave\" ng-click=\"removeDB()\">Remove selected rows from DB</button>&nbsp;&nbsp;\r\n      <button id=\"button_save\" class=\"btn\" ng-if=\"!checkPrevState\" ng-click=\"saveState()\">Save current state</button>&nbsp;&nbsp;\r\n      <button id=\"button_restore\" class=\"btn\" ng-if=\"checkPrevState\" ng-click=\"restoreState()\">Restore state</button>&nbsp;&nbsp;\r\n      <button id=\"button_remove\" class=\"btn\" ng-if=\"checkPrevState\" ng-click=\"removeState()\">Clear stored state</button>&nbsp;&nbsp;\r\n      <button id=\"button_remove\" class=\"btn\" ng-if=\"showSave\" ng-click=\"saveRecords()\">Save all records</button>&nbsp;&nbsp;\r\n      <button id=\"button_remove\" class=\"btn\" ng-if=\"showSave\" ng-click=\"saveSelectedRecords()\">Save selected records</button>\r\n      <button id=\"button_remove\" class=\"btn\" ng-if=\"!showSave\" ng-click=\"updateRecords()\">Update all records</button>&nbsp;&nbsp;\r\n      <button id=\"button_remove\" class=\"btn\" ng-if=\"!showSave\" ng-click=\"updateSelectedRecords()\">Update selected records</button>\r\n      <br />\r\n      <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"Show.Loader\"></i>\r\n      <br />\r\n      <div class=\"control-group\" ng-if=\"!showSave\">\r\n        <label class=\"control-label\" for=\"winner\">Hide Winners </label>\r\n        <input type=\"checkbox\" ng-model=\"checkboxModel.winner\" id=\"winner\" ng-click=\"showHideWinners()\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;\r\n        <label class=\"control-label\" for=\"runningFor\">Running for Office</label>\r\n        <input type=\"checkbox\" ng-model=\"checkboxModel.runningFor\" id=\"runningFor\" ng-click=\"showRunningFor()\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;\r\n        <label class=\"control-label\" for=\"selectedTemplate\">Apply Template</label>\r\n        <select ng-model=\"list.selectedName\" ng-change=\"selectedCols(list.selectedName)\">\r\n          <option ng-value=\"restore\">Restore all visible</option>\r\n          <option ng-repeat=\"list in userSelectedCols\" ng-value=\"{{list}}\">{{list.name}}</option>\r\n        </select>\r\n      </div>\r\n      <br />\r\n      <div id=\"grid1\" ui-grid=\"gridOptions\" ui-grid-edit ui-grid-pagination ui-grid-move-columns ui-grid-resize-columns\r\n        ui-grid-selection class=\"grid\">\r\n        <div class=\"grid-msg-overlay\" ng-show=\"!gridOptions.data.length\">\r\n          <div class=\"msg\">\r\n            <div class=\"center\">\r\n              <span class=\"muted\">Select Spreadsheet File</span>\r\n              <br />\r\n              <input type=\"file\" accept=\".xls,.xlsx,.ods\" fileread=\"\" address=\"address\" opts=\"gridOptions\" multiple=\"false\" />\r\n            </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n  </form>\r\n  <!--upload new end-->\r\n</div>\r\n");
$templateCache.put("app/uploadPoliticians/uploadPoliticians.html","<div class=\"container-fluid ng-scope\" ng-cloak ng-show=\"$root.userRole==\'admin\'\">\r\n  <h2 class=\"pageHeading\">Settings</h2>\r\n  <!-- Upload Politicians -->\r\n  <div>\r\n    <div class=\"closeForm\" ng-include=\"\'app/popups/setting_Ctrl.html\'\"></div>\r\n  </div>\r\n  <form ng-if=\"$root.showUpload\" name=\"uploadform\" id=\"uploadform\" class=\"closeForm\">\r\n    <fieldset class=\"scheduler-border\" ng-if=\"showPoliticianList\">\r\n      <legend class=\"scheduler-border\">Upload csv file</legend>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <p>Download sample excel file.\r\n            <a href=\"../assets/downloadFile/sample.xlsx\" target=\"_blank\" class=\"ylink\">Click Here</a>\r\n          </p>\r\n          <p ng-if=\"errorFile!=\'\'\" style=\"color:red;\">There are some records which did not uploaded\r\n            <a href=\"{{imgUrl}}/{{errorFile}}\" target=\"_blank\" style=\"text-decoration: underline;\" class=\"ylink\">click here</a>\r\n            to check them out</p>\r\n          <div class=\"control-group\" style=\"padding:5px;\">\r\n            <label class=\"control-label\" for=\"upload-file\">\r\n              <strong>Select Excel Type : </strong>\r\n            </label>\r\n            <select ng-model=\"upload.mtype\" class=\"changeTextColor\">\r\n              <option value=\"BEF\">Before Election</option>\r\n              <option value=\"WIN\">Winners List</option>\r\n            </select>\r\n          </div>\r\n          <!-- <div class=\"control-group\" style=\"padding:5px;\">\r\n            <label class=\"control-label\" for=\"upload-file\">\r\n              <strong>Select Election Type : </strong>\r\n            </label>\r\n            <select ng-model=\"upload.etype\" class=\"changeTextColor\">\r\n              <option value=\"PRS\">Presidential</option>\r\n              <option value=\"WIN\">Winners List</option>\r\n            </select>\r\n          </div> -->\r\n          <div class=\"control-group\" ng-if=\"upload.mtype==\'BEF\'\" style=\"padding:5px;\">\r\n            <label class=\"control-label\" for=\"upload-file\">\r\n              <strong>Update Option : </strong>\r\n            </label>\r\n            <select ng-model=\"upload.opt\" class=\"changeTextColor\">\r\n              <option value=\"New\">Create New</option>\r\n              <option value=\"Update\">Update</option>\r\n            </select>\r\n          </div>\r\n           <div class=\"control-group\" ng-if=\"upload.mtype==\'BEF\'\" style=\"padding:5px;\">\r\n            <label class=\"control-label\" for=\"upload-file\">\r\n              <strong>Do you want to send emails : </strong>\r\n            </label>\r\n            <select ng-model=\"upload.isEmail\" class=\"changeTextColor\">\r\n              <option value=\"Yes\">Yes</option>\r\n              <option value=\"No\">No</option>\r\n            </select>\r\n          </div>\r\n             <!-- <div class=\"control-group\" ng-if=\"upload.mtype==\'BEF\'\" style=\"padding:5px;\">\r\n            <label class=\"control-label\" for=\"upload-file\">\r\n              <strong>Update Option : </strong>\r\n            </label>\r\n            <select ng-model=\"upload.opt\" class=\"changeTextColor\">\r\n              <option value=\"New\">Create New</option>\r\n              <option value=\"Update\">Update</option>\r\n            </select>\r\n          </div> -->\r\n          <div class=\"control-group\" ng-if=\"upload.mtype==\'WIN\'\" style=\"padding:5px;\">\r\n            <label class=\"control-label\" for=\"search\">\r\n              <strong>Select State: </strong>\r\n            </label>\r\n            <select ng-model=\"upload.mstate\" class=\"changeTextColor\">\r\n              <option ng-repeat=\"opt in allLocations track by $index\" value=\"{{opt}}\">{{opt.state}}</option>\r\n            </select>\r\n          </div>\r\n          <div class=\"control-group\" style=\"padding:5px;\">\r\n            <label class=\"control-label\" for=\"upload-file\">\r\n              <strong>Select csv File : </strong>\r\n            </label>\r\n            <input type=\"file\" file-model=\"upload.files\" class=\"form-control input-md text-input\" accept=\".xlsx\">\r\n            <p ng-show=\"upload.maxSizeError\">Max file size exceeded (2000 bytes)</p>\r\n          </div>\r\n          <div class=\"control-group blackText\" style=\"padding-left:20px; \">\r\n            <button ng-click=\"updatePolitician(upload)\" type=\"submit\" ng-disabled=\"PoliticianButton || upload.PoliticianButton\" class=\"btnShort-style\" style=\"float: left;\">Save</button>&nbsp;\r\n            <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"PoliticianButton\"></i>\r\n            <!--<fb:login-button scope=\"public_profile,email\" onlogin=\"checkLoginState();\"></fb:login-button>-->\r\n            <div style=\"clear: both;\"></div>\r\n            <div style=\"background-color: white;\">\r\n\r\n              <p>\r\n                <b>Mandatory Fields:</b>\r\n                <ul>\r\n                  <li>name</li>\r\n                  <li>office</li>\r\n                  <li>voterScope</li>\r\n                  <ul>Acceptable answers:\r\n                    <li>rapidTransitDistrict</li>\r\n                    <li>statePostalCode</li>\r\n                    <li>countyName</li>\r\n                    <li>countySubdivisionName</li>\r\n                    <li>placeName</li>\r\n                    <ul>\r\n                      <li>If placeName is the chosen option, then CountyName and CountySubdivisionName are also required\r\n                        because sometimes the name of a town is not unique even within its own state.</li>\r\n                    </ul>\r\n                    <li>voterDistrict</li>\r\n                    <li>votingDistrictName</li>\r\n                    <li>federalCongressionalDistrict</li>\r\n                    <li>stateSenateDistrict</li>\r\n                    <li>stateHouseofRepresentativesDistrict</li>\r\n                    <li>unifiedSchoolDistrictName</li>\r\n                    <li>elementarySchoolDistrictName</li>\r\n                    <li>secondarySchoolDistrictName</li>\r\n                    <li>All USA</li>\r\n                    <ul>\r\n                      <li>This is for if the candidate is running for the Presidency.</li>\r\n                    </ul>\r\n                  </ul>\r\n                  <li>statePostalCode</li>\r\n                  <li>runningForOffice</li>\r\n                  <ul>\r\n                    <li>Acceptable Answers:\"Y\" or \"N\" - must be capitalized. Failure to include the Y appears to default\r\n                      the listing to become a politician in office not running for election</li>\r\n                  </ul>\r\n                </ul>\r\n              </p>\r\n              <p>\r\n                <b>Semi-Voluntary Fields:</b>\r\n                <ul>\r\n                  <li>incumbent</li>\r\n                  <ul>\r\n                    <li>This is needed for a politician to show up on the incumbents page. Acceptable answers:\r\n                      \"incumbent\" or blank if they aren\'t in office. YOU MUST ALSO go to officeStatus column and add\r\n                      \"active\".</li>\r\n                  </ul>\r\n                  <li>officeStatus</li>\r\n                  <ul>\r\n                    <li>Acceptable Values: \"active\" or \"inactive\"/blank. This must be used IN COMBINATION with\r\n                      \"incumbent\" column if you want the politician to show up in the incumbents page.</li>\r\n                  </ul>\r\n                  <li>electionDate</li>\r\n                  <ul>\r\n                    <li>Acceptable Values: This must be in the form of year-month-day (2020-2-28)</li>\r\n                  </ul>\r\n                  <li>candidateStatus</li>\r\n                  <ul>\r\n                    <li>Acceptable values: Announced, Write-in, Running, Campaign Suspended</li>\r\n                  </ul>\r\n                  <li>typeOfElection</li>\r\n                  <ul>\r\n                    <li>Acceptable Values: Primary (will list the candidate once for each party they are listed and then\r\n                      allow user to sift them), General (will list the candidate once and all their parties will be\r\n                      listed in the party column), Special, Run-off</li>\r\n                  </ul>\r\n\r\n\r\n                </ul>\r\n              </p>\r\n              <p>\r\n                <b>Other fields</b>\r\n                <ul>\r\n                  <li>fromDate and endDate : This was intended to describe the term of office so that we could\r\n                    eventually automate the database to inform potential politicians what offices were opening up in the\r\n                    future and to let us know where we needed to focus our research</li>\r\n                  <li>archive : I believe this is a marker saying this person has been archived and is no longer an\r\n                    active politician.</li>\r\n                  <li>verified : I believe this was supposed to indicate whether or not the admin has verified the\r\n                    identity of the politician, but it doesn\'t. All values appear to be \"false\" whether the user is\r\n                    email verified or identity verified or not verified at all.</li>\r\n                  <li>state : this is the state they live in. Many politicians live in one state and work in another.\r\n                  </li>\r\n                  <li>all the columns ending with \"Fips\" : these are codes used by the Census Bureau. They were critical\r\n                    in the original design, but now we are sourcing our information in a different way so they are kept\r\n                    around just in case we have to go back to the old way of doing things.</li>\r\n                  <li>totalPop and afact : These are both from the Census Bureau and relate to population in a\r\n                    particular area. They are probably of little use in this tool.</li>\r\n                  <li>dataX dataY dataZ : these were fields created so we could be flexible in offering outside data in\r\n                    the candidate or incumbent page. At one point they included links to Ballotpedia profiles for that\r\n                    politician. They remain for potential future partenrships.</li>\r\n                  <li>dataOrigin : this indicates where the data entry person got this information so we can look it up\r\n                    if there is a problem with the politician info or if we discover that a particular source is\r\n                    untrustworthy.</li>\r\n                  <li>dataEntryPerson : This indicates who enterend the data into our system.</li>\r\n                  <li>officeTypeId : This is for information coming from votesmart</li>\r\n                  <ul>\r\n                    <li>Acceptable Values:</li>\r\n                  </ul>\r\n                </ul>\r\n              </p>\r\n            </div>\r\n            <div style=\"clear: both;\"></div>\r\n          </div>\r\n        </div>\r\n    </fieldset>\r\n    <!-- <div>\r\n            <js-xls onread=\"read\" onerror=\"error\"></js-xls>\r\n          </div> -->\r\n    <div style=\"text-align: center; padding:10px;\" ng-if=\"showPoliticianList\">\r\n      <label class=\"control-label\" for=\"search\">\r\n        <strong>Select State: </strong>\r\n      </label>\r\n      <select ng-model=\"upload.state\" ng-change=\"getPolitciansStateWise(upload.state);\" class=\"changeTextColor\">\r\n        <option value=\"{{allUSAPol}}\">All USA</option>\r\n        <option ng-repeat=\"opt in allLocations track by $index\" value=\"{{opt}}\">{{opt.state}}</option>\r\n      </select>\r\n      &nbsp;\r\n      <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"ShowPoliticianLoader\"></i>\r\n    </div>\r\n    <div style=\"text-align: center; padding:10px;\" ng-if=\"politicians.data.length==0\">\r\n      No records found for selected state.\r\n    </div>\r\n    <div class=\"row\" ng-if=\"politicians.data.length > 0 && showPoliticianList\" style=\"margin-top: 10px;\">\r\n      <div class=\"col-12\">\r\n        <div style=\"text-align: center; padding:10px;\">\r\n          <label class=\"control-label\" for=\"search\">\r\n            <strong>Search : </strong>\r\n          </label>\r\n          <input type=\"text\" ng-model=\"search\" class=\"form-control input-md text-input\" style=\"width:40%; display:inline-block;\">\r\n        </div>\r\n          <div style=\"float:right;\">\r\n            <dir-pagination-controls max-size=\"5\" pagination-id=\"list.id\" class=\"textColor\"></dir-pagination-controls>\r\n          </div>\r\n          <a href=\"javascript: void(0);\" ng-if=\"showExportLink\" ng-click=\"exportData();\" class=\"ylink\">Export Selected state data</a>\r\n          <br>\r\n          <br>\r\n\r\n          <div class=\"col-lg-5 col-sm-5\">\r\n            <select ng-model=\"rate.year\" class=\"form-control\" style=\"width:170px;\">\r\n                    <option value=\"\">Select </option>\r\n                              <option value=\"2000-2001\">2000-2001</option>\r\n                    <option value=\"2001-2002\">2001-2002</option>\r\n                    <option value=\"2002-2003\">2002-2003</option>\r\n                    <option value=\"2003-2004\">2003-2004</option>\r\n                    <option value=\"2004-2005\">2004-2005</option>\r\n                    <option value=\"2005-2006\">2005-2006</option>\r\n                    <option value=\"2006-2007\">2006-2007</option>\r\n                    <option value=\"2007-2008\">2007-2008</option>\r\n                    <option value=\"2008-2009\">2008-2009</option>\r\n                    <option value=\"2009-2010\">2009-2010</option>\r\n                    <option value=\"2010-2011\">2010-2011</option>\r\n                    <option value=\"2011-2012\">2011-2012</option>\r\n                    <option value=\"2012-2013\">2012-2013</option>\r\n                    <option value=\"2013-2014\">2013-2014</option>\r\n                    <option value=\"2014-2015\">2014-2015</option>\r\n                    <option value=\"2015-2016\">2015-2016</option>\r\n                    <option value=\"2016-2017\">2016-2017</option>\r\n                    <option value=\"2017-2018\">2017-2018</option>\r\n                    <option value=\"2018-2019\">2018-2019</option>\r\n                    <option value=\"2019-2020\">2019-2020</option>\r\n                  </select>\r\n          </div>\r\n          <br>\r\n          <a href=\"javascript: void(0)\" ng-if=\"showExportLink\" ng-click=\"getRatings(politicians.data[0].statePostalCode)\" class=\"ylink\">GetRatings Of Candidate</a>\r\n          <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loader\"></i>\r\n          <br>\r\n          <br>\r\n          <span ng-if=\"!showExportLink\">\r\n                <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i> Please wait this may take time...</span>\r\n          <div style=\"padding-top: 5px; padding-bottom: 5px;\">\r\n            <input type=\"button\" class=\"btn\" ng-click=\"deleteSelected()\" value=\"Delete Selected Records\">\r\n        </div>\r\n            <table class=\"w100\">\r\n              <tr>\r\n                <th style=\"width:5%; padding-top:5px;\">\r\n                  <input type=\"checkbox\" ng-change=\"SelectChecks()\" ng-model=\"isSelected\">\r\n            </th>\r\n                <th style=\"width:70%;\">Candidate</th>\r\n                <th style=\"width:15%;\">Election Date</th>\r\n                <th style=\"width:10%;\">Details</th>\r\n                <!-- <th style=\"width:10%;\">Ratings</th> -->\r\n              </tr>\r\n              <tr dir-paginate=\"u in politicians.data | filter: search | itemsPerPage : 25\" pagination-id=\"list.id\">\r\n                <td style=\"vertical-align:middle;\">\r\n                  <input type=\"checkbox\" ng-model=\"u.checked\" name=\"{{u._id}}\" id=\"{{u._id}}\">\r\n            </td>\r\n                <td class=\"textColor\">\r\n                  <strong>{{u.name}}</strong>\r\n                  <p ng-if=\"u.email\" style=\"margin: 0;\">\r\n                    <strong>Email:</strong> {{u.email}}</p>\r\n                  <p ng-if=\"u.office\" style=\"margin: 0;\">\r\n                    <strong>Office:</strong> {{u.office}} </p>\r\n                  <p ng-if=\"u.voterScope\" style=\"margin: 0;\">\r\n                    <strong>Voter Scope:</strong> {{u.voterScope}}</p>\r\n                  <p ng-if=\"u.electionDate\" style=\"margin: 0;\">\r\n                    <strong>Election Date:</strong> {{u.electionDate}}</p>\r\n                  <p ng-if=\"u.StatePostalCode\" style=\"margin: 0;\">\r\n                    <strong>State Postal Code:</strong> {{u.StatePostalCode}}</p>\r\n                  <p ng-if=\"u.FederalCongressionalDistrict\" style=\"margin: 0;\">\r\n                    <strong>Federal Congressional District:</strong> {{u.FederalCongressionalDistrict}}</p>\r\n                  <p ng-if=\"u.CountyName\" style=\"margin: 0;\">\r\n                    <strong>County Name:</strong> {{u.CountyName}}</p>\r\n                  <p ng-if=\"u.CountySubdivisionName\" style=\"margin: 0;\">\r\n                    <strong>County Subdivision:</strong> {{u.CountySubdivisionName}}</p>\r\n                  <p ng-if=\"u.PlaceName\" style=\"margin: 0;\">\r\n                    <strong>Place:</strong> {{u.PlaceName}}</p>\r\n                  <p ng-if=\"u.public_mailing_address\" style=\"margin: 0;\">\r\n                    <strong>Public Mail Address:</strong> {{u.public_mailing_address}}</p>\r\n                </td>\r\n                <td class=\"changeTextColor\">\r\n                  {{u.electionDate | date : \"MM/dd/yyyy\"}}\r\n                </td>\r\n                <td>\r\n                  <a href=\"javascript: void(0)\" ng-click=\"showPolitician(u, $index)\" class=\"link\">Details</a>\r\n                </td>\r\n              </tr>\r\n              <tr>\r\n                <td style=\"text-align:left; padding:5px;\" colspan=\"4\">\r\n                  <input type=\"button\" class=\"btn\" ng-click=\"deleteSelected()\" value=\"Delete Selected Records\">\r\n            </td>\r\n              </tr>\r\n            </table>\r\n            <div style=\"float:right;\">\r\n              <dir-pagination-controls max-size=\"5\" pagination-id=\"list.id\" class=\"textColor\"></dir-pagination-controls>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\" ng-if=\"!showPoliticianList\" style=\"margin-top: 10px;\">\r\n          <div class=\"row\">\r\n            <!-- <div class=\"col-lg-12\"> -->\r\n            <div class=\"col-md-4\">\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel\" for=\"ShowData-name\">Name on Ballot</label>\r\n                <div class=\"controls\">\r\n                  <input type=\"text\" ng-model=\"ShowData.name\" class=\"form-control input-md text-input validate[required]\">\r\n                  <input type=\"hidden\" ng-model=\"ShowData._id\" class=\"form-control input-md text-input\">\r\n            </div>\r\n                </div>\r\n                <div class=\"control-group\">\r\n                  <label class=\"control-label formLabel\" for=\"ShowData-email\">Email</label>\r\n                  <div class=\"controls\">\r\n                    <input type=\"text\" ng-model=\"ShowData.publicEmail\" class=\"form-control input-md text-input validate[custom[email]]\">\r\n            </div>\r\n                  </div>\r\n                  <div class=\"control-group\">\r\n                    <label class=\"control-label formLabel\" for=\"ShowData-privateemail\">Private Email</label>\r\n                    <div class=\"controls\">\r\n                      <input type=\"text\" ng-model=\"ShowData.privateEmail\" class=\"form-control input-md text-input validate[custom[email]]\">\r\n            </div>\r\n                    </div>\r\n                    <div class=\"control-group\">\r\n                      <label class=\"control-label formLabel\" for=\"ShowData-website\">Office Website</label>\r\n                      <div class=\"controls\">\r\n                        <input type=\"text\" ng-model=\"ShowData.website\" class=\"form-control input-md text-input validate[custom[url]]\">\r\n            </div>\r\n                      </div>\r\n                      <div class=\"control-group\">\r\n                        <label class=\"control-label formLabel\" for=\"ShowData-website\">Campaign Website</label>\r\n                        <div class=\"controls\">\r\n                          <input type=\"text\" ng-model=\"ShowData.campaignWeburl\" class=\"form-control input-md text-input validate[custom[url]]\">\r\n              </div>\r\n                        </div>\r\n                      <div class=\"control-group\">\r\n                        <label class=\"control-label formLabel\" for=\"profile-phone_no\">Public Phone</label>\r\n                        <div class=\"controls\">\r\n                          <input type=\"text\" ng-model=\"ShowData.publicPhoneNumber\" class=\"form-control input-md text-input\">\r\n            </div>\r\n                        </div>\r\n                        <div class=\"control-group\">\r\n                          <label class=\"control-label formLabel\" for=\"profile-phone_no\">Private Phone</label>\r\n                          <div class=\"controls\">\r\n                            <input type=\"text\" ng-model=\"ShowData.privatePhoneNumber\" class=\"form-control input-md text-input\">\r\n            </div>\r\n                          </div>\r\n                          <div class=\"control-group\">\r\n                            <label class=\"control-label formLabel\" for=\"profile-public_mailing_address\">Public Mailing Address</label>\r\n                            <div class=\"controls\">\r\n                              <textarea ng-model=\"ShowData.publicMailingAddress\" class=\"form-control input-md text-input\" style=\"height:80px;\"></textarea>\r\n                            </div>\r\n                          </div>\r\n                          <div class=\"control-group\">\r\n                            <label class=\"control-label formLabel\" for=\"profile-private_mailing_address\">Private Mailing Address</label>\r\n                            <div class=\"controls\">\r\n                              <textarea ng-model=\"ShowData.privateMailingAddress\" class=\"form-control input-md text-input\" style=\"height:80px;\"></textarea>\r\n                            </div>\r\n                          </div>\r\n                          <div class=\"control-group\">\r\n                            <label class=\"control-label formLabel\" for=\"profile-statement\">Statement</label>\r\n                            <div class=\"controls\">\r\n                              <textarea ng-model=\"ShowData.statement\" class=\"form-control input-md text-input\" style=\"height:80px;\"></textarea>\r\n                            </div>\r\n                          </div>\r\n                          <div class=\"control-group\">\r\n                            <label class=\"control-label formLabel\" for=\"profile-zipname\">Zipcode</label>\r\n                            <div class=\"controls\">\r\n                              <input type=\"text\" ng-model=\"ShowData.zipname\" class=\"form-control input-md text-input\">\r\n            </div>\r\n                            </div>\r\n                            <div class=\"control-group\">\r\n                              <label class=\"control-label formLabel\" for=\"profile-publicZipcode\">Private Zipcode</label>\r\n                              <div class=\"controls\">\r\n                                <input type=\"text\" ng-model=\"ShowData.publicZipcode\" class=\"form-control input-md text-input\">\r\n            </div>\r\n                              </div>\r\n                              <div class=\"control-group\">\r\n                                <label class=\"control-label formLabel\" for=\"profile-state\">State</label>\r\n                                <div class=\"controls\">\r\n                                  <select ng-model=\"ShowData.statePostalCode\" ng-change=\"setState(ShowData.statePostalCode)\" class=\"changeTextColor\">\r\n                <!-- <option value=\"All USA\">All USA</option> -->\r\n                <option ng-repeat=\"opt in allLocations track by $index\" value=\"{{opt.statePostalCode}}\">{{opt.state}}</option>\r\n              </select>\r\n                                </div>\r\n                              </div>\r\n                            </div>\r\n                            <div class=\"col-md-8\">\r\n                              <div class=\"row\">\r\n                                <div class=\"col-md-6\">\r\n                                  <div class=\"control-group\">\r\n                                    <label class=\"control-label formLabel\" for=\"ShowData-office\">Office</label>\r\n                                    <div class=\"controls\">\r\n                                      <input type=\"text\" ng-model=\"ShowData.office\" class=\"form-control input-md text-input validate[required]\">\r\n                </div>\r\n                                    </div>\r\n                                    <div class=\"control-group\">\r\n                                      <label class=\"control-label formLabel\" for=\"ShowData-office\">Office Place</label>\r\n                                      <div class=\"controls\">\r\n                                        <input type=\"text\" ng-model=\"ShowData.officePlace\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                      </div>\r\n                                      <div class=\"control-group\">\r\n                                        <label class=\"control-label formLabel\" for=\"ShowData-candidateStatus\">Candidate Status</label>\r\n                                        <div class=\"controls\">\r\n                                          <input type=\"text\" ng-model=\"ShowData.candidateStatus\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                        </div>\r\n                                        <div class=\"control-group\">\r\n                                          <label class=\"control-label formLabel\" for=\"ShowData-party\">Party</label>\r\n                                          <div class=\"controls\">\r\n                                            <input type=\"text\" ng-model=\"ShowData.party\" class=\"form-control input-md text-input validate[required]\">\r\n                </div>\r\n                                          </div>\r\n                                          <div class=\"control-group\">\r\n                                            <label class=\"control-label formLabel\" for=\"ShowData-electionDate\">Election Date</label>\r\n                                            <div class=\"controls\">\r\n                                              <input type=\"text\" ng-model=\"ShowData.electionDate\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                            </div>\r\n                                            <div class=\"control-group\">\r\n                                              <label class=\"control-label formLabel\" for=\"ShowData-voterscope\">Voter Scope</label>\r\n                                              <div class=\"controls\">\r\n                                                <input type=\"text\" ng-model=\"ShowData.voterScope\" class=\"form-control input-md text-input validate[required]\">\r\n                </div>\r\n                                              </div>\r\n                                              <div class=\"control-group\">\r\n                                                <label class=\"control-label formLabel\" for=\"ShowData-rapidTransitDistrict\">Rapid Transit District</label>\r\n                                                <div class=\"controls\">\r\n                                                  <input type=\"text\" ng-model=\"ShowData.rapidTransitDistrict\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                                </div>\r\n                                                <div class=\"control-group\">\r\n                                                  <label class=\"control-label formLabel\" for=\"ShowData-numberOfOpenings\">Number Of Openings</label>\r\n                                                  <div class=\"controls\">\r\n                                                    <input type=\"text\" ng-model=\"ShowData.numberOfOpenings\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                                  </div>\r\n                                                  <div class=\"control-group\">\r\n                                                    <label class=\"control-label formLabel\" for=\"ShowData-incumbent\">Incumbent</label>\r\n                                                    <div class=\"controls\">\r\n                                                      <input type=\"text\" ng-model=\"ShowData.incumbent\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                                    </div>\r\n                                                    <div class=\"control-group\">\r\n                                                      <label class=\"control-label formLabel\" for=\"ShowData-stateBoardEducationDistrict\">State Board Education District</label>\r\n                                                      <div class=\"controls\">\r\n                                                        <input type=\"text\" ng-model=\"ShowData.stateBoardEducationDistrict\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                                      </div>\r\n                                                      <div class=\"control-group\">\r\n                                                        <label class=\"control-label formLabel\" for=\"ShowData-judicialCircuitNumber\">Judicial Circuit Number</label>\r\n                                                        <div class=\"controls\">\r\n                                                          <input type=\"text\" ng-model=\"ShowData.judicialCircuitNumber\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                                        </div>\r\n                                                        <div class=\"control-group\">\r\n                                                          <label class=\"control-label formLabel\" for=\"ShowData-stateFips\">State FIPS</label>\r\n                                                          <div class=\"controls\">\r\n                                                            <input type=\"text\" ng-model=\"ShowData.stateFips\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                                          </div>\r\n                                                          <div class=\"control-group\">\r\n                                                            <label class=\"control-label formLabel\" for=\"ShowData-countyFips\">County FIPS</label>\r\n                                                            <div class=\"controls\">\r\n                                                              <input type=\"text\" ng-model=\"ShowData.countyFips\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                                            </div>\r\n                                                            <div class=\"control-group\">\r\n                                                              <label class=\"control-label formLabel\" for=\"ShowData-countyName\">County</label>\r\n                                                              <div class=\"controls\">\r\n                                                                <input type=\"text\" ng-model=\"ShowData.countyName\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                                              </div>\r\n                                                              <div class=\"control-group\">\r\n                                                                <label class=\"control-label formLabel\" for=\"ShowData-countySubdivisionFips\">County Subdivision FIPS</label>\r\n                                                                <div class=\"controls\">\r\n                                                                  <input type=\"text\" ng-model=\"ShowData.countySubdivisionFips\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                                                </div>\r\n                                                                <div class=\"control-group\">\r\n                                                                  <label class=\"control-label formLabel\" for=\"ShowData-countySubdivisionName\">County Subdivision</label>\r\n                                                                  <div class=\"controls\">\r\n                                                                    <input type=\"text\" ng-model=\"ShowData.countySubdivisionName\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                                                  </div>\r\n                                                                  <div class=\"control-group\">\r\n                                                                    <label class=\"control-label formLabel\" for=\"ShowData-placeFips\">Place FIPS</label>\r\n                                                                    <div class=\"controls\">\r\n                                                                      <input type=\"text\" ng-model=\"ShowData.placeFips\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                                                    </div>\r\n                                                                    <div class=\"control-group\">\r\n                                                                      <label class=\"control-label formLabel\" for=\"ShowData-placeName\">Place</label>\r\n                                                                      <div class=\"controls\">\r\n                                                                        <input type=\"text\" ng-model=\"ShowData.placeName\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                                                      </div>\r\n                                                                    </div>\r\n                                                                    <div class=\"col-md-6\">\r\n                                                                      <div class=\"control-group\">\r\n                                                                        <label class=\"control-label formLabel\" for=\"ShowData-voterDistrict\">Voter District</label>\r\n                                                                        <div class=\"controls\">\r\n                                                                          <input type=\"text\" ng-model=\"ShowData.voterDistrict\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                                                        </div>\r\n                                                                        <div class=\"control-group\">\r\n                                                                          <label class=\"control-label formLabel\" for=\"ShowData-votingDistrictName\">Voter District Name</label>\r\n                                                                          <div class=\"controls\">\r\n                                                                            <input type=\"text\" ng-model=\"ShowData.votingDistrictName\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                                                          </div>\r\n                                                                          <div class=\"control-group\">\r\n                                                                            <label class=\"control-label formLabel\" for=\"ShowData-federalCongressionalDistrict\">Federal Congressional District</label>\r\n                                                                            <div class=\"controls\">\r\n                                                                              <input type=\"text\" ng-model=\"ShowData.federalCongressionalDistrict\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                                                            </div>\r\n                                                                            <div class=\"control-group\">\r\n                                                                              <label class=\"control-label formLabel\" for=\"ShowData-stateSenateDistrict\">State Senate District</label>\r\n                                                                              <div class=\"controls\">\r\n                                                                                <input type=\"text\" ng-model=\"ShowData.stateSenateDistrict\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                                                              </div>\r\n                                                                              <div class=\"control-group\">\r\n                                                                                <label class=\"control-label formLabel\" for=\"ShowData-stateHouseofRepresentativesDistrict\">State House of Representatives District</label>\r\n                                                                                <div class=\"controls\">\r\n                                                                                  <input type=\"text\" ng-model=\"ShowData.stateHouseofRepresentativesDistrict\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                                                                </div>\r\n                                                                                <div class=\"control-group\">\r\n                                                                                  <label class=\"control-label formLabel\" for=\"ShowData-unifiedSchoolDistrict\">Unified School District</label>\r\n                                                                                  <div class=\"controls\">\r\n                                                                                    <input type=\"text\" ng-model=\"ShowData.unifiedSchoolDistrict\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                                                                  </div>\r\n                                                                                  <div class=\"control-group\">\r\n                                                                                    <label class=\"control-label formLabel\" for=\"ShowData-unifiedSchoolDistrictName\">Unified School District Name</label>\r\n                                                                                    <div class=\"controls\">\r\n                                                                                      <input type=\"text\" ng-model=\"ShowData.unifiedSchoolDistrictName\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                                                                    </div>\r\n                                                                                    <div class=\"control-group\">\r\n                                                                                      <label class=\"control-label formLabel\" for=\"ShowData-elementarySchoolDistrict\">ElementarySchoolDistrict</label>\r\n                                                                                      <div class=\"controls\">\r\n                                                                                        <input type=\"text\" ng-model=\"ShowData.elementarySchoolDistrict\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                                                                      </div>\r\n                                                                                      <div class=\"control-group\">\r\n                                                                                        <label class=\"control-label formLabel\" for=\"ShowData-elementarySchoolDistrictName\">Elementary School District Name</label>\r\n                                                                                        <div class=\"controls\">\r\n                                                                                          <input type=\"text\" ng-model=\"ShowData.elementarySchoolDistrictName\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                                                                        </div>\r\n                                                                                        <div class=\"control-group\">\r\n                                                                                          <label class=\"control-label formLabel\" for=\"ShowData-secondarySchoolDistrict\">Secondary School District</label>\r\n                                                                                          <div class=\"controls\">\r\n                                                                                            <input type=\"text\" ng-model=\"ShowData.secondarySchoolDistrict\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                                                                          </div>\r\n                                                                                          <div class=\"control-group\">\r\n                                                                                            <label class=\"control-label formLabel\" for=\"ShowData-secondarySchoolDistrictName\">Secondary School District Name</label>\r\n                                                                                            <div class=\"controls\">\r\n                                                                                              <input type=\"text\" ng-model=\"ShowData.secondarySchoolDistrictName\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                                                                            </div>\r\n                                                                                            <div class=\"control-group\">\r\n                                                                                              <label class=\"control-label formLabel\" for=\"ShowData-totalPop\">Total Population</label>\r\n                                                                                              <div class=\"controls\">\r\n                                                                                                <input type=\"text\" ng-model=\"ShowData.totalPop\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                                                                              </div>\r\n                                                                                              <div\r\n                                                                                                class=\"control-group\">\r\n                                                                                                <label class=\"control-label formLabel\" for=\"ShowData-dataX\">Data X</label>\r\n                                                                                                <div class=\"controls\">\r\n                                                                                                  <input type=\"text\" ng-model=\"ShowData.dataX\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                                                                                </div>\r\n                                                                                                <div\r\n                                                                                                  class=\"control-group\">\r\n                                                                                                  <label class=\"control-label formLabel\" for=\"ShowData-dataY\">Data Y</label>\r\n                                                                                                  <div class=\"controls\">\r\n                                                                                                    <input type=\"text\" ng-model=\"ShowData.dataY\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                                                                                  </div>\r\n                                                                                                  <div\r\n                                                                                                    class=\"control-group\">\r\n                                                                                                    <label class=\"control-label formLabel\" for=\"ShowData-dataZ\">Data Z</label>\r\n                                                                                                    <div\r\n                                                                                                      class=\"controls\">\r\n                                                                                                      <input type=\"text\" ng-model=\"ShowData.dataZ\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                                                                                    </div>\r\n                                                                                                    <div\r\n                                                                                                      class=\"control-group\">\r\n                                                                                                      <label class=\"control-label formLabel\" for=\"ShowData-runningForOffice\">Running for office</label>\r\n                                                                                                      <div\r\n                                                                                                        class=\"controls\">\r\n                                                                                                        <input type=\"text\" ng-model=\"ShowData.runningForOffice\" class=\"form-control input-md text-input\">\r\n                </div>\r\n                                                                                                      </div>\r\n                                                                                                      <div\r\n                                                                                                        class=\"control-group\">\r\n                                                                                                        <label class=\"control-label formLabel\" for=\"ShowData-runningForOffice\">IsOnBallot</label>\r\n                                                                                                        <div\r\n                                                                                                          class=\"controls\">\r\n                                                                                                          <select ng-model=\"ShowData.isOnBallot\" ng-init=\"ShowData.isOnBallot ? ShowData.isOnBallot = \'true\' : ShowData.isOnBallot = \'false\'\" class=\"form-control\" style=\"width:170px;display:inline-block;\">\r\n\r\n                                                                                                            <option value=\'true\'>Yes</option>\r\n                                                                                                            <option value=\'false\'>No</option>\r\n\r\n                                                                                                          </select>\r\n                                                                                                        </div>\r\n                                                                                                      </div>\r\n                                                                                                    </div>\r\n                                                                                                  </div>\r\n                                                                                                  <div\r\n                                                                                                    style=\"clear:both;\">\r\n                                                                                                  </div>\r\n                                                                                                </div>\r\n                                                                                                <div\r\n                                                                                                  style=\"clear:both;\">\r\n                                                                                                </div>\r\n                                                                                                <div\r\n                                                                                                  class=\"forgetPassButtons\"\r\n                                                                                                  style=\"text-align:center;\">\r\n                                                                                                  <button ng-click=\"updatePoliticianData(ShowData)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btnShort-style\">Save</button>\r\n                                                                                                  &nbsp;\r\n                                                                                                  <button ng-click=\"registerPoliticianData(ShowData)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btn btn-success\">Create User</button>\r\n                                                                                                  &nbsp;\r\n                                                                                                  <button ng-click=\"goBack()\" type=\"button\" class=\"btn btn-success\">Cancel</button>\r\n                                                                                                  <!--<fb:login-button scope=\"public_profile,email\" onlogin=\"checkLoginState();\">\r\n                                </fb:login-button>-->\r\n                                                                                                  <div\r\n                                                                                                    style=\"clear: both;\">\r\n                                                                                                  </div>\r\n                                                                                                </div>\r\n                                                                                                <!-- </div> -->\r\n                                                                                              </div>\r\n                                                                                            </div>\r\n  </form>\r\n  <!-- Upload Politicians End -->\r\n</div>\r\n");
$templateCache.put("app/uploadPopulationData/uploadPopulationData.html","<div class=\"container-fluid\">\r\n    <fieldset class=\"scheduler-border\">\r\n        <legend class=\"scheduler-border\">Upload Population Data</legend>\r\n        <div class=\"control-group\" style=\"padding:5px;\">\r\n         \r\n          <label class=\"control-label\" for=\"upload-file\">\r\n            <strong>Select csv File : </strong>\r\n          </label>\r\n          <input type=\"file\" file-model=\"upload.files\" class=\"form-control input-md text-input\" accept=\".xlsx\">\r\n          <p ng-show=\"upload.maxSizeError\">Max file size exceeded (2000 bytes)</p>\r\n        </div>\r\n        <div class=\"control-group blackText\" style=\"padding-left:20px;\">\r\n          <button ng-click=\"uploadBallotMeasures(upload)\" type=\"submit\" class=\"btnShort-style\" style=\"float: left;\">Save</button>&nbsp;\r\n          <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoader\"></i>\r\n          <div style=\"clear: both;\"></div>\r\n        </div>\r\n        <div style=\"clear: both;\"></div>\r\n        <p>\r\n          <b>Mandatory Fields:</b>\r\n          <ul>\r\n            <li>State</li>\r\n            <li>City</li>\r\n            <li>Population</li>\r\n          </ul>\r\n        </p>\r\n      </fieldset>\r\n</div>");
$templateCache.put("app/uploadPress/uploadPress.html","<div class=\"container-fluid ng-scope\" ng-cloak ng-show=\"$root.userRole==\'admin\'\">\r\n  <h2 class=\"pageHeading\">Settings</h2>\r\n  <div>\r\n    <div class=\"closeForm\" ng-include=\"\'app/popups/setting_Ctrl.html\'\"></div>\r\n  </div>\r\n  <!-- Upload Press -->\r\n  <form ng-if=\"$root.showPress\" name=\"pressform\" id=\"pressform\" ng-controller=\"UploadPressCtrl\" class=\"closeForm\">\r\n    <fieldset class=\"scheduler-border\" ng-if=\"showPressList\">\r\n      <legend class=\"scheduler-border\">Upload csv file</legend>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <p>Download sample excel file.\r\n            <a href=\"../assets/downloadFile/samplePress.xlsx\" target=\"_blank\" class=\"ylink\">Click Here</a>\r\n          </p>\r\n          <div class=\"control-group\" style=\"padding:5px;\">\r\n            <label class=\"control-label\" for=\"upload-file\">\r\n              <strong>Update Option : </strong>\r\n            </label>\r\n            <select ng-model=\"upload.opt\" class=\"changeTextColor\">\r\n              <option value=\"New\">Create New</option>\r\n              <option value=\"Update\">Update</option>\r\n            </select>\r\n          </div>\r\n          <div class=\"control-group\" style=\"padding:5px;\">\r\n            <label class=\"control-label\" for=\"upload-file\">\r\n              <strong>Select csv File : </strong>\r\n            </label>\r\n            <input type=\"file\" file-model=\"upload.files\" class=\"form-control input-md text-input\" accept=\".xlsx\">\r\n          </div>\r\n          <div class=\"control-group\" style=\"padding-left:20px;\">\r\n            <button ng-click=\"updatePress(upload)\" type=\"submit\" ng-disabled=\"AdvocateButton\" class=\"btnShort-style\" style=\"float: left;\">Save</button>&nbsp;\r\n            <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"AdvocateButton\"></i>\r\n            <!--<fb:login-button scope=\"public_profile,email\" onlogin=\"checkLoginState();\"></fb:login-button>-->\r\n            <div style=\"clear: both;\"></div>\r\n          </div>\r\n          <div style=\"clear: both;\"></div>\r\n        </div>\r\n      </div>\r\n    </fieldset>\r\n    <div class=\"row\" ng-if=\"press.data.length > 0 && showPressList\" style=\"margin-top: 10px;\">\r\n      <div style=\"text-align: center; padding:10px;\">\r\n        <label class=\"control-label\" for=\"search\">\r\n          <strong>Search : </strong>\r\n        </label>\r\n        <input type=\"text\" ng-model=\"search\" class=\"form-control input-md text-input\">\r\n      </div>\r\n      <div style=\"float:right;\" class=\"changeTextColor\">\r\n        <dir-pagination-controls max-size=\"5\" pagination-id=\"list.id\"></dir-pagination-controls>\r\n      </div>\r\n      <a href=\"javascript: void(0);\" ng-if=\"showExportLink\" ng-click=\"exportData();\" class=\"ylink\">Export Data</a>\r\n      <span ng-if=\"!showExportLink\">\r\n              <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i> Please wait this may take time...</span>\r\n      <table class=\"w100 changeTextColor\">\r\n        <tr>\r\n          <th>Press</th>\r\n          <th>Details</th>\r\n        </tr>\r\n        <tr dir-paginate=\"u in press.data | filter: search | itemsPerPage : 25\" pagination-id=\"list.id\">\r\n          <td>\r\n            <strong>{{u.title}}</strong>\r\n            <p ng-if=\"u.contact_person.name\" style=\"margin: 0;\">\r\n              <strong>Official:</strong> {{u.contact_person.name}}\r\n              <span ng-if=\"u.contact_person.position\">\r\n                      <strong>, Position:</strong> {{u.contact_person.position}}</span>\r\n              <span ng-if=\"u.contact_person.phone_no\">\r\n                      <strong>, Contact Phone:</strong> {{u.contact_person.phone_no}}</span>\r\n            </p>\r\n            <p ng-if=\"u.email\" style=\"margin: 0;\">\r\n              <strong>Email:</strong> {{u.email}}</p>\r\n            <p ng-if=\"u.mailing_address\" style=\"margin: 0;\">\r\n              <strong>Address:</strong> {{u.mailing_address}} </p>\r\n            <p ng-if=\"u.phone_no\" style=\"margin: 0;\">\r\n              <strong>Phone:</strong> {{u.phone_no}}</p>\r\n          </td>\r\n          <td>\r\n            <a href=\"javascript: void(0)\" ng-click=\"showPress(u, $index)\" class=\"link\">Details</a>\r\n          </td>\r\n        </tr>\r\n      </table>\r\n      <div style=\"float:right;\" class=\"changeTextColor\">\r\n        <dir-pagination-controls max-size=\"5\" pagination-id=\"list.id\"></dir-pagination-controls>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\" ng-if=\"!showPressList\" style=\"margin-top: 10px;\">\r\n      <div class=\"row\">\r\n        <!-- <div class=\"col-md-12\"> -->\r\n        <div class=\"col-md-6\">\r\n          <div class=\"control-group\" style=\"margin-top:30px;\">\r\n            <div class=\"controls\">\r\n              <h3>Contact Details</h3>\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel removeTopMargin\" for=\"ShowData-name\">Name</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"ShowData.contact_person.name\" class=\"form-control input-md text-input validate[required]\">\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"ShowData-extension_no\">Position</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"ShowData.contact_person.position\" class=\"form-control input-md text-input\">\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"ShowData-extension_no\">Phone</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"ShowData.contact_person.phone_no\" class=\"form-control input-md text-input\">\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"ShowData-email\">Email</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"ShowData.contact_person.email\" class=\"form-control input-md text-input validate[custom[email]]\">\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"ShowData-zipcode\">Zipcode</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"ShowData.zipcode\" class=\"form-control input-md text-input validate[required]\">\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"ShowData-state\">State</label>\r\n            <div class=\"controls\">\r\n              <select class=\"changeTextColor\" ng-model=\"ShowData.stateData\" ng-change=\"getCounties(ShowData.stateData);\">\r\n                <option ng-repeat=\"opt in allLocations track by $index\" value=\"{{opt}}\">{{opt.state}}</option>\r\n              </select>\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"ShowData-county\">County</label>\r\n            <div class=\"controls\">\r\n              <select class=\"changeTextColor\" ng-model=\"ShowData.county\" ng-change=\"getLocals(ShowData.stateData, ShowData.county)\">\r\n                <option ng-repeat=\"opt in MyCounties track by $index\" value=\"{{opt._id}}\">{{opt._id.county}}</option>\r\n              </select>\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"profile-state\">Locality</label>\r\n            <div class=\"controls\">\r\n              <select class=\"changeTextColor\" ng-model=\"ShowData.Locality\">\r\n                <option ng-repeat=\"opt in MyPlaces track by $index\" value=\"{{opt._id}}\">{{opt._id.countySubdivision}} - {{opt._id.place}}</option>\r\n              </select>\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\" style=\"margin-top:30px;\">\r\n            <div class=\"controls\">\r\n              <h3>Editor Details</h3>\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"ShowData-name\">Name</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"ShowData.editor.name\" class=\"form-control input-md text-input validate[required]\">\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"ShowData-extension_no\">Phone</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"ShowData.editor.phone_no\" class=\"form-control input-md text-input\">\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"ShowData-email\">Email</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"ShowData.editor.email\" class=\"form-control input-md text-input validate[custom[email]]\">\r\n            </div>\r\n          </div>\r\n          <div ng-show=\"$root.userRole != \'voter\'\">\r\n            <div class=\"control-group\" style=\"margin-top:30px;\">\r\n              <div class=\"controls\">\r\n                <h3>Organization Details</h3>\r\n              </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\" for=\"ShowData-title\">Name</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"ShowData.title\" class=\"form-control input-md text-input validate[required]\">\r\n              </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\" for=\"ShowData-phone_no\">Phone</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"ShowData.phone_no\" class=\"form-control input-md text-input\">\r\n              </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\" for=\"ShowData-email\">Email</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"ShowData.email\" class=\"form-control input-md text-input validate[custom[email]]\">\r\n              </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\" for=\"ShowData-frequency\">Frequency</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"ShowData.frequency\" class=\"form-control input-md text-input\">\r\n              </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\" for=\"ShowData-orgtype\">Type</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"ShowData.orgtype\" class=\"form-control input-md text-input\">\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-6\">\r\n          <div class=\"control-group\" style=\"margin-top:30px;\">\r\n            <div class=\"controls\">&nbsp;</div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"ShowData-owner\">Owner</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"ShowData.owner\" class=\"form-control input-md text-input\">\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"ShowData-circulation\">Circulation</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"ShowData.circulation\" class=\"form-control input-md text-input\">\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"ShowData-revenue\">Annual Revenue</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"ShowData.revenue\" class=\"form-control input-md text-input\">\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"ShowData-location_of_interest\">Region</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"ShowData.location_of_interest\" class=\"form-control input-md text-input validate[required]\">\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"ShowData-web_url\">Website</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"ShowData.web_url\" class=\"form-control input-md text-input\">\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"ShowData-facebook_url\">Facebook Url</label>\r\n            <div class=\"controls\">\r\n              <input type=\"text\" ng-model=\"ShowData.facebook_url\" class=\"form-control input-md text-input\">\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"ShowData-mailing_address\">Mailing Address</label>\r\n            <div class=\"controls\">\r\n              <textarea ng-model=\"ShowData.mailing_address\" class=\"form-control input-md text-input\" style=\"height:70px;\"></textarea>\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"ShowData-specialTopic\">Special Topics</label>\r\n            <div class=\"controls\">\r\n              <textarea ng-model=\"ShowData.specialTopic\" class=\"form-control input-md text-input\" style=\"height:70px;\"></textarea>\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"ShowData-states\">States</label>\r\n            <div class=\"controls\">\r\n              <textarea ng-model=\"ShowData.states\" class=\"form-control input-md text-input\" style=\"height:70px;\"></textarea>\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"ShowData-counties\">County</label>\r\n            <div class=\"controls\">\r\n              <textarea ng-model=\"ShowData.counties\" class=\"form-control input-md text-input\" style=\"height:70px;\"></textarea>\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"ShowData-SelfdeclaredRegion\">Self Declared Region</label>\r\n            <div class=\"controls\">\r\n              <textarea ng-model=\"ShowData.SelfdeclaredRegion\" class=\"form-control input-md text-input\" style=\"height:70px;\"></textarea>\r\n            </div>\r\n          </div>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label formLabel\" for=\"ShowData-towns\">Towns</label>\r\n            <div class=\"controls\">\r\n              <textarea ng-model=\"ShowData.towns\" class=\"form-control input-md text-input\" style=\"height:70px;\"></textarea>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div style=\"clear:both;\"></div>\r\n        <div class=\"forgetPassButtons\">\r\n          <button ng-click=\"updatePressData(ShowData)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btnShort-style\">Save</button>\r\n          &nbsp;\r\n          <!-- <button ng-click=\"registerAdvocateData(ShowData)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btn btn-success\">Create User</button> -->\r\n          &nbsp;\r\n          <button ng-click=\"goBack()\" type=\"button\" class=\"btn btn-success\">Cancel</button>\r\n          <div style=\"clear: both;\"></div>\r\n        </div>\r\n        <!-- </div> -->\r\n      </div>\r\n    </div>\r\n  </form>\r\n  <!-- Upload Press End -->\r\n</div>\r\n");
$templateCache.put("app/userProfile/userProfile.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">PROFILE</h2>\r\n  <p class=\"pageSubHeading\">Make sure to hit \"save\" after any changes you make.</p>\r\n\r\n  <div class=\"centerediframe\" ng-show=\"$root.userRole == \'advocate\'\">\r\n    <iframe src=\"https://player.vimeo.com/video/399270249?byline=false&title=false\" allowfullscreen></iframe>\r\n  </div>\r\n  <div class=\"centerediframe\" ng-show=\"$root.userRole == \'politician\'\">\r\n    <iframe src=\"https://player.vimeo.com/video/406719151?byline=false&title=false\" allowfullscreen></iframe>\r\n  </div>\r\n\r\n  <form ng-if=\"showProfile\" name=\"changeusername\" id=\"changeusername\" ng-controller=\"MyProfileCtrl\" class=\"closeForm\">\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Change username</legend>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <div class=\"col-left\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel removeTopMargin\" for=\"profile-name\">Username</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"username\" class=\"form-control input-md text-input validate[required]\">\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"dashboardRightBtn\">\r\n            <button ng-click=\"changeUsername(username)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n            <div style=\"clear: both;\"></div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </fieldset>\r\n    <a ng-if=\"profile.userType == \'voter\'\" href=\"#!/voterProfile/{{profile._id}}\" class=\"ylink\">Click here to see your public profile</a>\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Address</legend>\r\n      <div ng-cloak ng-show=\"$root.userRole==\'admin\'\">\r\n        <a href=\"https://www.bestrandoms.com/random-address\" target=\"_blank\" class=\"ylink\">Click here for fake person generator</a><br><br><br></div>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <div class=\"col-left\">\r\n            <span ng-if=\"mainData.mailingAddress\" >Address:</span><span>{{mainData.mailingAddress}}</span>\r\n            <br>\r\n            <span ng-if=\"mainData.address.country\" >Country:</span><span>{{mainData.address.country}}</span>\r\n            <br>\r\n            <span ng-if=\"mainData.address.state\" >State:</span><span>{{mainData.address.state}}</span>\r\n            <br>\r\n            <span ng-if=\"mainData.address.statePostalCode\" >State Postal Code:</span><span>{{mainData.address.statePostalCode}}</span>\r\n            <br>\r\n            <span ng-if=\"mainData.address.county\" >County:</span><span>{{mainData.address.county}}</span>\r\n            <br>\r\n            <span ng-if=\"mainData.address.place\" >City:</span><span>{{mainData.address.place}}</span>\r\n            <br>\r\n            <span ng-if=\"mainData.address.federalCongrassionalDist\" >Federal Congressional District: </span><span>{{mainData.address.federalCongrassionalDist}}</span>\r\n            <br>\r\n            <span ng-if=\"mainData.address.schoolDistrict\" >School District: </span><span>{{mainData.address.schoolDistrict}}</span>\r\n            <br>\r\n            <span ng-if=\"mainData.address.stateSenateDistrict\" >State Senate District:</span><span>{{mainData.address.stateSenateDistrict}}</span>\r\n            <br>\r\n            <span ng-if=\"mainData.address.legislativeDistrict\" >State House Of Representative District:</span><span>{{mainData.address.legislativeDistrict}}</span>\r\n            <br>\r\n             <span ng-if=\"mainData.address.cityCouncilDistrictName\" >City Council District Name:</span><span>{{mainData.address.cityCouncilDistrictName}}</span>\r\n          </div>\r\n\r\n        </div>\r\n      </div>\r\n      <p>\r\n      </p>\r\n\r\n      <button class=\"compareBtn\"> <a href=\"javascript: void(0)\" ng-click=\"updateAddress()\" >Change Address</a></button>&nbsp;\r\n      &nbsp;\r\n      <i ng-if=\"UpdateAddressLoader\" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>\r\n\r\n      <!--      <a href=\"javascript: void(0)\" ng-click=\"updateAddress()\" class=\"ylink\">Click here to update address</a>&nbsp;\r\n        &nbsp;\r\n        <i ng-if=\"UpdateAddressLoader\" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>  -->\r\n    </fieldset>\r\n\r\n\r\n\r\n\r\n\r\n\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">News</legend>\r\n      <p>Choose the news source you want in your private news feed.</p>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <div class=\"col-left\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel removeTopMargin\" for=\"newsChannel\">News Channel</label>\r\n              <div class=\"controls\">\r\n                <select ng-model=\"newsChannel\" class=\"changeTextColor\">\r\n                  <option ng-repeat=\"opt in allSource  track by $index\" value=\"{{opt.id}}\">{{opt.name}}</option>\r\n                </select>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"dashboardRightBtn\">\r\n            <button ng-click=\"changeNewsChannel(newsChannel)\" type=\"submit\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n            <div style=\"clear: both;\"></div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </fieldset>\r\n\r\n    <fieldset class=\"scheduler-border\" ng-if=\"$root.userRole == \'admin\'\">\r\n      <legend class=\"scheduler-border\">Five minute match Facebook post</legend>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <div class=\"col-left\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel removeTopMargin\" for=\"facebookTitle\">Title</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"fivefb.title\" class=\"form-control input-md text-input validate[required]\">\r\n              </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\" for=\"facebookDescription\">Description</label>\r\n              <div class=\"controls\">\r\n                <textarea ng-model=\"fivefb.description\" class=\"form-control input-md validate[required] text-input\" style=\"height:100px;\"></textarea>\r\n              </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <img ng-src=\"{{fbFiveImage}}\" width=\"100\" />\r\n              <br/>\r\n              <label class=\"control-label formLabel removeTopMargin\" for=\"facebookImage\">Image</label>\r\n              <div class=\"controls\">\r\n                <input type=\"file\" file-model=\"fivefb.files\" class=\"form-control input-md text-input\">\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"dashboardRightBtn\">\r\n            <button ng-click=\"changeFacebookPost(fivefb)\" type=\"submit\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n            <div style=\"clear: both;\"></div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </fieldset>\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Change Email</legend>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <div class=\"col-left\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel removeTopMargin\" for=\"profile-name\">Email</label>\r\n              <div class=\"controls\">\r\n                <input type=\"email\" ng-model=\"emailID\" class=\"form-control input-md text-input validate[custom[email]]\">\r\n              </div>\r\n            </div>\r\n            <br>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel removeTopMargin\" for=\"profile-name\">Confirm Email</label>\r\n              <div class=\"controls\">\r\n                <input type=\"email\" ng-model=\"confirmEmailID\" class=\"form-control input-md text-input validate[custom[email]]\">\r\n                </div>\r\n            </div>\r\n          </div>\r\n          <br>\r\n          <br>\r\n          <div class=\"dashboardRightBtn\">\r\n            <button ng-click=\"changeEmailID(emailID,confirmEmailID)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n            <div style=\"clear: both;\"></div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </fieldset>\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Subjects of Interest</legend>\r\n      <div class=\"col-right\">\r\n        <div class=\"control-group\">\r\n          <div class=\"control-label formLabel removeTopMargin\" for=\"title\">Select subjects\r\n            of\r\n            interest</div>\r\n          <div class=\"DisplayCat changeTextColor\">\r\n            <div style=\"background-color: #eee; padding:5px;\">All Tags\r\n              <br>\r\n              <small>(click to select)</small>\r\n            </div>\r\n            <div ng-repeat=\"subent in subtopics.subcategories track by $index\" ng-include=\"\'field_renderer\'\">Loading...\r\n            </div>\r\n            <div ng-if=\"subtopics.subcategories.length == 0\" class=\"loadingSpinner\">\r\n              <i class=\"fa fa-refresh fa-spin fa-3x fa-fw\"></i>\r\n            </div>\r\n          </div>\r\n          <div class=\"select buttons\">&nbsp;</div>\r\n          <div class=\"DisplayCat changeTextColor\">\r\n            <div style=\"background-color: #eee; padding:5px;\">Selected Tags\r\n              <br>\r\n              <small>(click to remove)</small>\r\n            </div>\r\n            <ul class=\"TcatList\">\r\n              <li ng-repeat=\"subent in selectedCat track by $index\">\r\n                <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                        <input type=\"checkbox\" ng-click=\"removeVal(subent)\" ng-model=\"selectedAll.id[$index]\" ng-checked=\"true\" name=\"checkedidcat\"> {{subent.title}}\r\n                      </label>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n\r\n\r\n        </div>\r\n      </div>\r\n      <div>\r\n        <button ng-click=\"updateProfile(profile)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btnShort-style\"\r\n        style=\"float: right;\">Save</button>\r\n        <div style=\"clear: both;\"></div>\r\n      </div>\r\n    </fieldset>\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Change password</legend>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <div class=\"col-left\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel removeTopMargin\" for=\"profile-name\">Old Password</label>\r\n              <div class=\"controls\">\r\n                <input type=\"password\" ng-model=\"old_password\" class=\"form-control input-md text-input validate[required]\">\r\n              </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\" for=\"profile-name\">New Password</label>\r\n              <div class=\"controls\">\r\n                <input type=\"password\" ng-model=\"password\" class=\"form-control input-md text-input validate[required]\">\r\n              </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\" for=\"profile-name\">Confirm new Password</label>\r\n              <div class=\"controls\">\r\n                <input type=\"password\" ng-model=\"confirm_password\" class=\"form-control input-md text-input validate[required]\">\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"dashboardRightBtn\">\r\n            <button ng-click=\"changePassword(old_password, password,confirm_password)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btnShort-style\"\r\n              style=\"float: right;\">Save</button>\r\n            <div style=\"clear: both;\"></div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </fieldset>\r\n  </form>\r\n\r\n  <form ng-if=\"showOrganizationProfile\" name=\"profileform\" id=\"profileform\" ng-controller=\"MyProfileCtrl\"\r\n    class=\"closeForm\">\r\n    <fieldset class=\"scheduler-border\">\r\n      <a ng-if=\"profile.userType == \'advocate\'\" href=\"#!/pressProfile/{{profile._id}}\" class=\"ylink\">Click here to see your public profile</a>\r\n      <legend class=\"scheduler-border\">Other Detail</legend>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <div class=\"col-left\" style=\"padding-right:30px;\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel removeTopMargin\" for=\"profile-name\">Your Name</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"profile.name\" class=\"form-control input-md text-input validate[required]\">\r\n              </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\" for=\"profile-extension_no\">Your extension number (if any)</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"profile.extensionNo\" class=\"form-control input-md text-input\">\r\n              </div>\r\n            </div>\r\n\r\n            <!-- <div class=\"control-group\">\r\n                  <label class=\"formLabel\">\r\n                <input type=\"checkbox\" ng-model=\"profile.showEmailToAll\"> Show Public Email To All\r\n              </label>\r\n                  <br>\r\n            </div> -->\r\n\r\n            <div\r\n              ng-show=\"$root.userRole != \'voter\' && $root.userRole != \'forumadmin\' && $root.userRole != \'voteradmin\'\">\r\n              <div class=\"control-group\" style=\"margin-top:30px;\">\r\n                <div class=\"controls\">\r\n                  <h3>Organization Details</h3>\r\n                </div>\r\n              </div>\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel removeTopMargin\" for=\"profile-title\">Name of Organization</label>\r\n                <div class=\"controls\" style=\"text-transform: capitalize;\">\r\n                  <h4>{{profile.orgData.title}} </h4>\r\n                  <!--<input type=\"text\" ng-model=\"profile.orgData.title\" class=\"form-control input-md text-input validate[required]\"> -->\r\n                </div>\r\n              </div>\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel\" for=\"profile-type-of-org\">Type of Organization </label>\r\n                <div class=\"controls\">\r\n                  <h4>{{profile.orgData.typeOfOrg}}</h4>\r\n                </div>\r\n                <a href=\"#!/contactUs\" class=\"ylink\">(Contact us if your organization type or name is incorrect.)</a>\r\n              </div>\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel\" for=\"profile-email\">Public Email</label>\r\n                <div class=\"controls\">\r\n                  <input type=\"email\" ng-model=\"profile.publicEmail\" class=\"form-control input-md text-input validate[required]\">\r\n                </div>\r\n              </div>\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel\" for=\"profile-phone_no\">Public Phone</label>\r\n                <div class=\"controls\">\r\n                  <input type=\"text\" ng-model=\"profile.orgData.phoneNo\" class=\"form-control input-md text-input validate[required]\">\r\n                </div>\r\n              </div>\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel\" for=\"profile-web_url\">Website</label>\r\n                <div class=\"controls\">\r\n                  <input type=\"text\" ng-model=\"profile.orgData.webUrl\" class=\"form-control input-md text-input validate[required]\">\r\n                </div>\r\n              </div>\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel\" for=\"profile-facebook_url\">Facebook Url</label>\r\n\r\n															<div class=\"controls\" style=\"width:100%;\">\r\n                <div>\r\n                  <div style=\"float:left;\">\r\n                    <span class=\"control-label\"for=\"profile-web_url\">https://www.facebook.com/</span>\r\n                  </div>\r\n                  <div style=\"float:left;\">\r\n                    <input type=\"text\" style=\"margin-left: 5%;\r\n                        \" ng-model=\"profile.orgData.facebookUrl\" class=\"form-control input-md text-input validate[required]\"></div><br>\r\n\r\n              </div>\r\n															<br>\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel\" >Twitter</label>\r\n\r\n															<div class=\"controls\" style=\"width:100%;\">\r\n                <div>\r\n                  <div style=\"float:left;\">\r\n                    <span class=\"control-label\"for=\"profile-web_url\">https://www.twitter.com/</span>\r\n                  </div>\r\n                  <div style=\"float:left;\">\r\n                    <input type=\"text\" style=\"margin-left: 5%;\r\n                        \" ng-model=\"profile.orgData.twitterHandle\" class=\"form-control input-md text-input\"></div>\r\n\r\n\r\n\r\n                <!--  <div class=\"control-group\">\r\n                <label class=\"control-label formLabel\" for=\"profile-state\">State</label>\r\n                <div class=\"controls\">\r\n                  <select ng-model=\"profile.state\" ng-change=\"getCounties(profile.state, \'address\');\" class=\"changeTextColor\">\r\n                    <option ng-repeat=\"opt in allLocations track by $index\" value=\"{{opt}}\">{{opt.state}}</option>\r\n                  </select>\r\n                </div>\r\n              </div>\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel\" for=\"profile-state\">County</label>\r\n                <div class=\"controls\">\r\n                  <select ng-model=\"profile.county\" ng-change=\"getLocals(profile.state, profile.county, \'address\')\" class=\"changeTextColor\">\r\n                    <option ng-repeat=\"opt in MyCounties track by $index\" value=\"{{opt}}\">{{opt.county}}</option>\r\n                  </select>\r\n                </div>\r\n              </div>\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel\" for=\"profile-state\">Locality</label>\r\n                <div class=\"controls\">\r\n                  <select ng-model=\"profile.places\" class=\"changeTextColor\">\r\n                    <option ng-repeat=\"opt in MyPlaces.places track by $index\" value=\"{{opt}}\">{{opt.place}}</option>\r\n                  </select>\r\n                </div>\r\n              </div> -->\r\n                <!--               <div class=\"control-group\">\r\n                                    <label class=\"control-label formLabel\" for=\"profile-state\">Zip Code</label>\r\n                                    <div class=\"controls\">\r\n                                      <input type=\"text\" ng-model=\"profile.zipcode\" class=\"form-control input-md text-input validate[required]\">\r\n                </div>\r\n                                    </div>-->\r\n              </div>\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label formLabel\" for=\"profile-web_url\">Donation Link For Organization</label>\r\n                <br>\r\n\r\n                <div class=\"controls\">\r\n                  <input type=\"text\" ng-model=\"profile.donationLink\" class=\"form-control input-md text-input validate[custom[url]]\">\r\n                                    </div>\r\n              </div><br>\r\n                              </div>\r\n          </div>\r\n          <div class=\"dashboardRightBtn\">\r\n            <button ng-click=\"updateProfile(profile)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n            <div style=\"clear: both;\"></div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div style=\"width: 100%; margin-top: 10px; float: right; \">\r\n        <button ng-click=\"updateProfile(profile)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n        <p ng-if=\"statusUpdateProfile == 1\">Updating profile ...</p>\r\n\r\n      </div>\r\n    </fieldset>\r\n\r\n    <fieldset class=\"scheduler-border\"\r\n      ng-show=\"$root.userRole != \'voter\' && $root.userRole != \'forumadmin\' && $root.userRole != \'voteradmin\'\">\r\n      <legend class=\"scheduler-border\">About</legend>\r\n      <div class=\"control-group\"\r\n        ng-show=\"$root.userRole != \'voter\' && $root.userRole != \'forumadmin\' && $root.userRole != \'voteradmin\'\">\r\n        <label class=\"control-label formLabel\" for=\"profile-description\">About Organization </label>\r\n        <div class=\"controls\">\r\n          <textarea ng-model=\"profile.orgData.description\" class=\"form-control input-md validate[required] text-input\" style=\"width: 90%; height:200px;\"></textarea>\r\n        </div>\r\n        <div class=\"control-group\">\r\n          <label class=\"control-label formLabel\" for=\"profile-state\">\"About us\" Video Link</label>\r\n          <div class=\"controls\">\r\n            <input type=\"text\" ng-model=\"profile.videoLink\" class=\"form-control input-md text-input validate[required]\">\r\n                    </div>\r\n        </div>\r\n      </div>\r\n      <div style=\"width: 100%; margin-top: 10px; float: right; \">\r\n        <button ng-click=\"updateProfile(profile)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n        <p ng-if=\"statusUpdateProfile == 1\">Updating profile ...</p>\r\n\r\n      </div>\r\n    </fieldset>\r\n\r\n    <fieldset class=\"scheduler-border\"\r\n      ng-show=\"$root.userRole != \'voter\' && $root.userRole != \'forumadmin\' && $root.userRole != \'voteradmin\' && $root.userRole != \'politician\'\">\r\n      <legend class=\"scheduler-border\">Speciality</legend>\r\n      <div class=\"control-group\"\r\n        ng-show=\"$root.userRole != \'voter\' && $root.userRole != \'forumadmin\' && $root.userRole != \'voteradmin\'\">\r\n        <label class=\"control-label formLabel\" for=\"profile-description\">Speciality of Organization </label>\r\n        <div class=\"controls\">\r\n          <textarea ng-model=\"profile.orgData.speciality\" class=\"form-control input-md validate[required] text-input\"  ng-maxlength=\"100\"  style=\"width: 90%; height:200px;\"></textarea>\r\n        </div>\r\n      </div>\r\n      <div style=\"width: 100%; margin-top: 10px; float: right; \">\r\n        <button ng-click=\"updateProfile(profile)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n        <p ng-if=\"statusUpdateProfile == 1\">Updating profile ...</p>\r\n\r\n      </div>\r\n    </fieldset>\r\n\r\n\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Subjects and Locations you Cover</legend>\r\n      <div class=\"col-right\">\r\n        <div class=\"control-group\">\r\n          <div class=\"control-label formLabel removeTopMargin\" for=\"title\">Select subjects\r\n            of\r\n            interest</div>\r\n          <div class=\"DisplayCat changeTextColor\">\r\n            <div style=\"background-color: #eee; padding:5px;\">All Tags\r\n              <br>\r\n              <small>(click to select)</small>\r\n            </div>\r\n            <div ng-repeat=\"subent in subtopics.subcategories track by $index\" ng-include=\"\'field_renderer\'\">Loading...\r\n            </div>\r\n            <div ng-if=\"subtopics.subcategories.length == 0\" class=\"loadingSpinner\">\r\n              <i class=\"fa fa-refresh fa-spin fa-3x fa-fw\"></i>\r\n            </div>\r\n          </div>\r\n          <div class=\"select buttons\">&nbsp;</div>\r\n          <div class=\"DisplayCat changeTextColor\">\r\n            <div style=\"background-color: #eee; padding:5px;\">Selected Tags\r\n              <br>\r\n              <small>(click to remove)</small>\r\n            </div>\r\n            <ul class=\"TcatList\">\r\n              <li ng-repeat=\"subent in selectedCat track by $index\">\r\n                <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                      <input type=\"checkbox\" ng-click=\"removeVal(subent)\" ng-model=\"selectedAll.id[$index]\" ng-checked=\"true\" name=\"checkedidcat\"> {{subent.title}}\r\n                    </label>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n          <div style=\"clear:both;\"></div>\r\n        </div>\r\n        <div class=\"control-group\" style=\"margin-top:30px;\">\r\n          <div class=\"control-label\" for=\"title\">Select locations of interest</div>\r\n          <div class=\"control-group\">\r\n\r\n            <div class=\"DisplayCat changeTextColor\">\r\n              <div style=\"background-color: #eee; padding:5px;\">Choose Location\r\n                <br><small>(click to select)</small></div>\r\n              <ul class=\"TcatList\">\r\n                <li style=\"padding-bottom:10px;\">\r\n\r\n                  <input type=\"checkbox\" ng-change=\"getLocations(Essay.Locations, \'International\')\" ng-model=\"Essay.Locations\" ng-true-value=\"\'International\'\" ng-false-value=\"\'NO\'\">\r\n                  <label ng-click=\"ShowAddLocation();\">International&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-show=\"never\"></i></label>\r\n                  <!-- <div style=\"padding-left:20px;\" ng-if=\"AddLocation\">\r\n                    <div mass-autocomplete>\r\n                      <input ng-model=\"newlocation.country\" mass-autocomplete-item=\"autocomplete_options\">\r\n              </div>\r\n                      <div style=\"text-align: right;\">\r\n                        <button ng-click=\"AddCountry();\">Add country</button>\r\n                      </div>\r\n                    </div> -->\r\n                </li>\r\n                <li>\r\n                  <input type=\"checkbox\" ng-model=\"Essay.National\"  ng-change=\"getLocations(Essay.National, \'National\')\" ng-true-value=\"\'National\'\" ng-false-value=\"\'NO\'\">\r\n                  <label>National</label>\r\n                  </i>\r\n                  <ul class=\"TcatList\">\r\n                    <li ng-repeat=\"area in allLocations track by $index\">\r\n                      <input type=\"checkbox\" ng-click=\"getAreaVal(area, area.state, \'state\')\" ng-disabled=\"checkDisabled(area, area.state, \'state\')\" ng-checked=\"checkDisabled(area, area.state, \'state\')\">\r\n                      <label ng-click=\"getCounties(area.stateFips)\">{{area.state}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoading.indexOf(area.stateFips)==-1\"></i> <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoading.indexOf(area.stateFips) > -1\"></i></label>\r\n                      <!-- Display Counties -->\r\n                      <ul class=\"TcatList\">\r\n                        <li ng-repeat=\"county in allCounties[area.stateFips] | orderBy:\'countyName\' track by $index\">\r\n                          <input type=\"checkbox\" ng-click=\"getAreaVal(county, area.state, \'county\')\" ng-disabled=\"checkDisabled(county, area.state, \'county\')\" ng-checked=\"checkDisabled(county, area.state, \'county\')\">\r\n                          <label ng-click=\"getLocals(area.stateFips, county.countyFips)\">{{county.countyName}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoadingCounty.indexOf(county.county) == -1\"></i><i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingCounty.indexOf(county.county) > -1\"></i></label>\r\n                          <!-- Display Locals and sub counties -->\r\n                          <ul class=\"TcatList\" ng-if=\"Essay.location!=\'National\'\">\r\n                            <li\r\n                              ng-repeat=\"local in allLocals[area.stateFips][county.countyFips] | orderBy:\'placeName\'  track by $index\">\r\n                              <label class=\"checkbox\" title=\"{{local.place}}\">\r\n                          <input type=\"checkbox\" ng-click=\"getAreaVal(local, area.state, \'local\')\" ng-disabled=\"disabledLocation.indexOf(local) > -1 ? true : false\" ng-checked=\"disabledLocation.indexOf(local) > -1 ? true : false\"> {{local.placeName}}\r\n                        </label>\r\n                            </li>\r\n                          </ul>\r\n                          <!-- Display Locals and sub counties End -->\r\n                        </li>\r\n                      </ul>\r\n                      <!-- Display Counties End -->\r\n                    </li>\r\n                  </ul>\r\n                </li>\r\n              </ul>\r\n            </div>\r\n\r\n            <div class=\"DisplayCat changeTextColor\">\r\n              <div style=\"background-color: #eee; padding:5px;\">Selected Location\'s\r\n                <br><small>(click to remove)</small></div>\r\n              <ul class=\"TcatList\">\r\n                <li ng-repeat=\"area in selectedArea track by $index\">\r\n\r\n                  <label class=\"checkbox\" title=\"{{area}}\">\r\n              <input type=\"checkbox\" ng-click=\"removeAreaVal(area)\" name=\"checkedid\" ng-model=\"selectedLAll.id[$index]\" ng-checked=\"true\"> <span ng-if=\"area.country && (!(area.state) && !(area.county) && !(area.countySubdivision) && !(area.place))\">{{area.country}}</span> <span ng-if=\"area.state && (!(area.county) && !(area.countySubdivision) && !(area.place))\">{{area.state}}</span><span ng-if=\"area.county && (!(area.countySubdivision) && !(area.place))\">{{area.county}}</span><span ng-if=\"area.countySubdivision\">{{area.countySubdivision}}</span><span ng-if=\"area.place\"> - {{area.place}}</span>\r\n            </label>\r\n                </li>\r\n              </ul>\r\n            </div>\r\n            <div style=\"clear:both;\"></div>\r\n            <!--\r\n                        <multi-select ng-model=\"Essay.subcategories\" available=\"subtopics\" selected-label=\"Selected subtopics\" available-label=\"All subtopics\" display=\"r as r.title\" title=\"r as r.title\" config=\"selectConfig\"></multi-select>\r\n                        <div class=\"input-error\" ng-show=\"selectForm.numSelected.$error.min\">\r\n                            Please select at least\r\n                            <ng-pluralize count=\"selectConfig.requiredMin\" when=\"{\'one\': \'one role\', \'other\': \'{} roles\'}\">.\r\n                        </div>\r\n                        <input type=\"hidden\" id=\"reqMin\" ng-model=\"selectConfig.requiredMin\" min=\"1\">\r\n                        -->\r\n          </div>\r\n          <!-- <div class=\"DisplayCat changeTextColor\">\r\n            <div style=\"background-color: #eee; padding:5px;\">Choose Location\r\n              <br>\r\n              <small>(click to select)</small>\r\n            </div>\r\n            <ul class=\"TcatList\">\r\n              <li style=\"padding-bottom:10px;\">\r\n                <input type=\"checkbox\" ng-click=\"getLocations(Essay.Locations, \'International\')\" ng-model=\"Essay.Locations\" ng-true-value=\"\'International\'\" ng-false-value=\"\'NO\'\">\r\n                <label ng-click=\"ShowAddLocation();\">International&nbsp;\r\n                      <i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i>\r\n                    </label>\r\n                <div style=\"padding-left:20px;\" ng-if=\"AddLocation\">\r\n                  <div mass-autocomplete>\r\n                    <input ng-model=\"newlocation.country\" mass-autocomplete-item=\"autocomplete_options\">\r\n                      </div>\r\n                    <div style=\"text-align: right;\">\r\n                      <button ng-click=\"AddCountry();\">Add country</button>\r\n                    </div>\r\n                  </div>\r\n              </li>\r\n              <li>\r\n                <input type=\"checkbox\" ng-model=\"Essay.National\" ng-click=\"getLocations(Essay.National, \'National\')\" ng-true-value=\"\'National\'\" ng-false-value=\"\'NO\'\">\r\n                <label>National</label>\r\n                </i>\r\n                <ul class=\"TcatList\">\r\n                  <li ng-repeat=\"area in allLocations track by $index\">\r\n                    <input type=\"checkbox\" ng-click=\"getAreaVal(area, area.state, \'state\')\" ng-disabled=\"checkDisabled(area, area.state, \'state\')\" ng-checked=\"checkDisabled(area, area.state, \'state\')\">\r\n                    <label ng-click=\"getCounties(area.stateFips, \'location\')\">{{area.state}}&nbsp;\r\n                          <i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoading.indexOf(area.stateFips)==-1\"></i>\r\n                          <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoading.indexOf(area.stateFips) > -1\"></i>\r\n                        </label>\r\n\r\n                    <ul class=\"TcatList\">\r\n                      <li ng-repeat=\"county in allCounties[area.stateFips] | orderBy:\'countyName\' track by $index\">\r\n                        <input type=\"checkbox\" ng-click=\"getAreaVal(county, area.state, \'county\')\" ng-disabled=\"checkDisabled(county, area.state, \'county\')\" ng-checked=\"checkDisabled(county, area.state, \'county\')\">\r\n                        <label ng-click=\"getLocals(area.stateFips, county.countyFips, \'location\')\">{{county.countyName}}&nbsp;\r\n                              <i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showLoadingCounty.indexOf(county.county) == -1\"></i>\r\n                              <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoadingCounty.indexOf(county.county) > -1\"></i>\r\n                            </label>\r\n\r\n                        <ul class=\"TcatList\" ng-if=\"Essay.location!=\'National\'\">\r\n                          <li\r\n                            ng-repeat=\"local in allLocals[area.stateFips][county.countyFips] | orderBy: \'placeName\' track by $index\">\r\n                            <label class=\"checkbox\" title=\"{{local.place}}\">\r\n                                  <input type=\"checkbox\" ng-click=\"getAreaVal(local, area.state, \'local\')\" ng-disabled=\"disabledLocation.indexOf(local) > -1 ? true : false\" ng-checked=\"disabledLocation.indexOf(local) > -1 ? true : false\"> {{local.placeName}}\r\n                                </label>\r\n                          </li>\r\n                        </ul>\r\n\r\n                      </li>\r\n                    </ul>\r\n\r\n                  </li>\r\n                </ul>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n          <div class=\"select buttons\">&nbsp;</div>\r\n          <div class=\"DisplayCat changeTextColor\">\r\n            <div style=\"background-color: #eee; padding:5px;\">Selected Location\'s\r\n              <br>\r\n              <small>(click to remove)</small>\r\n            </div>\r\n            <ul class=\"TcatList\">\r\n              <li ng-repeat=\"area in selectedArea track by $index\">\r\n                <label class=\"checkbox\" title=\"{{area}}\">\r\n                      <input type=\"checkbox\" ng-click=\"removeAreaVal(area)\" ng-model=\"selectedLAll.id[$index]\" ng-checked=\"true\" name=\"checkedid\">\r\n                      <span ng-if=\"area.country && (!(area.state) && !(area.county) && !(area.countySubdivision) && !(area.place))\">{{area.country}}</span>\r\n                      <span ng-if=\"area.state && (!(area.county) && !(area.countySubdivision) && !(area.place))\">{{area.state}}</span>\r\n                      <span ng-if=\"area.county && (!(area.countySubdivision) && !(area.place))\">{{area.county}}</span>\r\n                      <span ng-if=\"area.countySubdivision\">{{area.countySubdivision}}</span>\r\n                      <span ng-if=\"area.place\"> - {{area.place}}</span>\r\n                    </label>\r\n              </li>\r\n            </ul>\r\n          </div> -->\r\n          <div style=\"clear:both;\"></div>\r\n          <div class=\"dashboardRightBtn\">\r\n            <div style=\"width: 55%; margin-top: 10px; float: right; margin-right: 17px;\">\r\n              <button ng-click=\"updateProfile(profile)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n              <p ng-if=\"statusUpdateProfile == 1\">Updating profile ...</p>\r\n            </div>\r\n            <div style=\"clear: both;\"></div>\r\n    </fieldset>\r\n\r\n\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Change Sign-in Name</legend>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <div class=\"col-left\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel removeTopMargin\" for=\"profile-name\">Username</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"username\" class=\"form-control input-md text-input validate[required]\">\r\n                                            </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"dashboardRightBtn\">\r\n            <button ng-click=\"changeUsername(username)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n            <div style=\"clear: both;\"></div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </fieldset>\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Change Account Email</legend>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <div class=\"col-left\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel removeTopMargin\" for=\"profile-name\">Email</label>\r\n              <div class=\"controls\">\r\n                <input type=\"email\" ng-model=\"emailID\" class=\"form-control input-md text-input validate[custom[email]]\">\r\n              </div>\r\n            </div>\r\n            <br>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel removeTopMargin\" for=\"profile-name\">Confirm Email</label>\r\n              <div class=\"controls\">\r\n                <input type=\"email\" ng-model=\"confirmEmailID\" class=\"form-control input-md text-input validate[custom[email]]\">\r\n                </div>\r\n            </div>\r\n          </div>\r\n          <br>\r\n          <br>\r\n          <div class=\"dashboardRightBtn\">\r\n            <button ng-click=\"changeEmailID(emailID,confirmEmailID)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n            <div style=\"clear: both;\"></div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </fieldset>\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Change password</legend>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <div class=\"col-left\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel removeTopMargin\" for=\"profile-name\">Old Password</label>\r\n              <div class=\"controls\">\r\n                <input type=\"password\" ng-model=\"old_password\" class=\"form-control input-md text-input validate[required]\">\r\n                                            </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\" for=\"profile-name\">New Password</label>\r\n              <div class=\"controls\">\r\n                <input type=\"password\" ng-model=\"password\" class=\"form-control input-md text-input validate[required]\">\r\n                                            </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\" for=\"profile-name\">Confirm new Password</label>\r\n              <div class=\"controls\">\r\n                <input type=\"password\" ng-model=\"confirm_password\" class=\"form-control input-md text-input validate[required]\">\r\n                                            </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"dashboardRightBtn\">\r\n            <button ng-click=\"changePassword(old_password, password,confirm_password)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btnShort-style\"\r\n                                            style=\"float: right;\">Save</button>\r\n            <div style=\"clear: both;\"></div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </fieldset>\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Account Address</legend>\r\n      {{isShowMailingAddress}}\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <div class=\"col-left\">\r\n            <h5 ng-if=\"isShowMailingAddress\">\r\n              <span ng-if=\"mainData.mailingAddress\" >Address:</span><span>{{mainData.mailingAddress}}</span>\r\n            </h5>\r\n            This address is not made public. It is just used to center where you are when\r\n            you look up information about\r\n            others in your area or use other similar tools.<br>\r\n            <br>\r\n            <span ng-if=\"mainData.address.country\" >Country: </span><span>{{mainData.address.country}}</span>\r\n            <br>\r\n            <span ng-if=\"mainData.address.state\" >State: </span><span>{{mainData.address.state}}</span>\r\n            <br>\r\n            <span ng-if=\"mainData.address.statePostalCode\" >State Postal Code:</span><span>{{mainData.address.statePostalCode}}</span>\r\n            <br>\r\n            <span ng-if=\"mainData.address.county\" >County: </span><span>{{mainData.address.county}}</span>\r\n            <br>\r\n            <span ng-if=\"mainData.address.place\" >City: </span><span>{{mainData.address.place}}</span>\r\n            <br>\r\n            <span ng-if=\"mainData.address.federalCongrassionalDist\" >Federal Congressional District:</span><span>{{mainData.address.federalCongrassionalDist}}</span>\r\n            <br>\r\n            <span ng-if=\"mainData.address.schoolDistrict\" >School District: </span><span>{{mainData.address.schoolDistrict}}</span>\r\n            <br>\r\n            <span ng-if=\"mainData.address.stateSenateDistrict\" >State Senate District: </span><span>{{mainData.address.stateSenateDistrict}}</span>\r\n            <br>\r\n            <span ng-if=\"mainData.address.legislativeDistrict\" >State House Of Representative District:</span><span>{{mainData.address.legislativeDistrict}}</span>\r\n             <br>\r\n             <span ng-if=\"mainData.address.cityCouncilDistrictName\" >City Council District Name:</span><span>{{mainData.address.cityCouncilDistrictName}}</span>\r\n          </div>\r\n\r\n        </div>\r\n      </div>\r\n      <p>\r\n      </p>\r\n      <button class=\"compareBtn\"> <a href=\"javascript: void(0)\" ng-click=\"updateAddress()\" >Change Address</a></button>&nbsp;\r\n      &nbsp;\r\n      <i ng-if=\"UpdateAddressLoader\" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>\r\n\r\n      <!--      <a href=\"javascript: void(0)\" ng-click=\"updateAddress()\" class=\"ylink\">Click here to update address</a>&nbsp;\r\n      &nbsp;\r\n      <i ng-if=\"UpdateAddressLoader\" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>  -->\r\n    </fieldset>\r\n\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">News</legend>\r\n      <p>Choose the news source you want in your private news feed.</p>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <div class=\"col-left\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel removeTopMargin\" for=\"newsChannel\">News Channel</label>\r\n              <div class=\"controls\">\r\n                <select ng-model=\"newsChannel\" class=\"changeTextColor\">\r\n                  <option ng-repeat=\"opt in allSource  track by $index\" value=\"{{opt.id}}\">{{opt.name}}</option>\r\n                </select>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"dashboardRightBtn\">\r\n            <button ng-click=\"changeNewsChannel(newsChannel)\" type=\"submit\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n            <div style=\"clear: both;\"></div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </fieldset>\r\n\r\n    <div style=\"clear:both;\"></div>\r\n\r\n\r\n\r\n    <div style=\"clear: both;\"></div>\r\n    <div class=\"control-group\"\r\n      ng-show=\"$root.userRole == \'voter\' || $root.userRole == \'forumadmin\' || $root.userRole == \'voteradmin\'\">\r\n      <label class=\"control-label formLabel\" for=\"profile-description\">About Me </label>\r\n      <div class=\"controls\">\r\n        <textarea ng-model=\"profile.about_me\" class=\"form-control input-md text-input\" style=\"width: 90%; height:200px;\"></textarea>\r\n      </div>\r\n    </div>\r\n    <div style=\"clear: both;\"></div>\r\n    <div style=\"width: 55%; margin-top: 10px; float: right; margin-right: 17px;\">\r\n      <button ng-click=\"updateProfile(profile)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n      <p ng-if=\"statusUpdateProfile == 1\">Updating profile ...</p>\r\n      <div style=\"clear: both;\"></div>\r\n    </div>\r\n\r\n    </fieldset>\r\n  </form>\r\n  <!-- My Profile End-->\r\n  <form ng-if=\"showPoliticianProfile\" name=\"profileform\" id=\"profileform\" ng-controller=\"MyProfileCtrl\"\r\n    class=\"closeForm\">\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">My Public Profile</legend>\r\n      <a ng-if=\"profile.userType == \'politician\'\" href=\"#!/publicProfile/{{profile._id}}\" class=\"ylink\">Click here to see your public profile</a>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <div class=\"col-left\">\r\n            <div class=\"control-group\">\r\n              Public Politician Name\r\n              <h4 style=\"text-transform: capitalize;\">{{profile.name}}</h4>\r\n            </div>\r\n            <br>\r\n            <!--\r\n              <div class=\"control-group\">\r\n                <label class=\"control-label\" for=\"profile-name\">Name as it appears on the ballot</label>\r\n                <div class=\"controls\">\r\n                  <input type=\"text\" ng-model=\"profile.nameOnBallot\" class=\"form-control input-md text-input validate[required]\">\r\n              </div>\r\n                </div>\r\n                <!--   <div class=\"control-group\">\r\n                  <label class=\"control-label\" for=\"profile-extension_no\">Your extension number (if any)</label>\r\n                  <div class=\"controls\">\r\n                    <input type=\"text\" ng-model=\"profile.extension_no\" class=\"form-control input-md text-input\">\r\n              </div>\r\n                  </div>  -->\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"profile-extension_no\">Phone Number for account, if any(to be used for communication with VoteWise)</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"mainData.phone\" class=\"form-control input-md text-input\">\r\n                  </div>\r\n            </div><br>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"profile-web_url\">Office Phone</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"profile.officePhone\" class=\"form-control input-md text-input validate[custom[url]]\">\r\n              </div>\r\n            </div><br>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"profile-web_url\">Office Email</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"profile.publicEmail\" class=\"form-control input-md text-input ]\">\r\n                </div>\r\n\r\n            </div><br>\r\n\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"profile-web_url\">Office Website</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"profile.curOfficeWebiste\" class=\"form-control input-md text-input validate[custom[url]]\">\r\n              </div>\r\n\r\n            </div><br>\r\n\r\n\r\n\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"profile-facebook_url\">Office Facebook Url</label>\r\n              <br>\r\n\r\n\r\n              <div class=\"controls\" style=\"width:100%;\">\r\n                <div>\r\n                  <div style=\"float:left;\">\r\n                    <span class=\"control-label\"for=\"profile-web_url\">https://www.facebook.com/</span>\r\n                  </div>\r\n                  <div style=\"float:left;\">\r\n                    <input type=\"text\" style=\"margin-left: 5%;\r\n                        \" ng-model=\"profile.facebookUrl\" class=\"form-control input-md text-input validate[custom[url]]\"></div>\r\n\r\n\r\n                </div>\r\n              </div>\r\n\r\n            </div>\r\n            <br><br>\r\n            <div style=\"clear: both;\"></div>\r\n            <div style=\"width: 100%; margin-top: 10px; float: right; \">\r\n              <button ng-click=\"updateProfile(profile)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n              <p ng-if=\"statusUpdateProfile == 1\">Updating profile ...</p>\r\n\r\n            </div><br><br>\r\n            <hr>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"profile-camp\">Campaign Phone</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"profile.campPhone\" class=\"form-control input-md text-input validate[custom[url]]\">\r\n                  </div>\r\n            </div><br>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"profile-camp\">Campaign Email</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"profile.campEmail\" class=\"form-control input-md text-input]\">\r\n                    </div>\r\n            </div><br>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"profile-camp\">Campaign Website</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"profile.campwebUrl\" class=\"form-control input-md text-input validate[custom[url]]\">\r\n                      </div>\r\n            </div><br>\r\n            <div style=\"clear: both;\"></div>\r\n            <!--                     <div style=\"width: 100%; margin-top: 10px; float: right; \">\r\n                            <button ng-click=\"updateProfile(profile)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n                            <p ng-if=\"statusUpdateProfile == 1\">Updating profile ...</p>\r\n\r\n                          </div>\r\n-->\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"profile-web_url\">Donation Link For Campaign</label>\r\n              <br>\r\n\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"profile.donationLink\" class=\"form-control input-md text-input validate[custom[url]]\">\r\n                  </div>\r\n            </div><br>\r\n\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label\" for=\"profile-facebook_url\">Campaign Facebook Url</label>\r\n              <br>\r\n\r\n\r\n              <div class=\"controls\" style=\"width:100%;\">\r\n                <div>\r\n                  <div style=\"float:left;\">\r\n                    <span class=\"control-label\"for=\"profile-web_url\">https://www.facebook.com/</span>\r\n                  </div>\r\n                  <div style=\"float:left;\">\r\n                    <input type=\"text\" style=\"margin-left: 5%;\r\n                          \" ng-model=\"profile.campaignFburl\" class=\"form-control input-md text-input validate[custom[url]]\"></div>\r\n\r\n\r\n                </div>\r\n              </div>\r\n\r\n            </div>\r\n            <div style=\"clear: both;\"></div>\r\n            <div style=\"width: 100%; margin-top: 10px; float: right; \">\r\n              <button ng-click=\"updateProfile(profile)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n              <p ng-if=\"statusUpdateProfile == 1\">Updating profile ...</p>\r\n\r\n            </div>\r\n            <br><br><br>\r\n            <hr>\r\n            <br>\r\n\r\n\r\n            <p></p>\r\n            <p></p>\r\n\r\n            <!--  BRING BACK WHEN OFFICE DETAILS WORKS\r\n                        <div ng-repeat=\"o in profile.campaignInfo track by $index\" ng-if=\"!o.archive && !o.archive\">\r\n                          <div class=\"control-group\">\r\n                            <h3 class=\"control-label\" ng-if=\"o.campaignEmail || o.campaignPhone || o.campaignWeburl\"\r\n                              for=\"profile-description\"> Campaign\r\n                              Office Detail</h3>\r\n                            <div class=\"control-group\" ng-if=\"o.campaignEmail\">\r\n                              <label class=\"control-label\" for=\"profile-name\">Campaign Email:</label>\r\n                              <div class=\"controls\">\r\n                                <input type=\"text\" ng-model=\"o.campaignEmail\" class=\"form-control input-md text-input validate[required]\">\r\n                                                 </div>\r\n                              </div>\r\n                              <div class=\"control-group\" ng-if=\"o.campaignPhone\">\r\n                                <label class=\"control-label\" for=\"profile-name\">Campaign Phone:</label>\r\n                                <div class=\"controls\">\r\n                                  <input type=\"text\" ng-model=\"o.campaignPhone\" class=\"form-control input-md text-input validate[required]\">\r\n                                                     </div>\r\n                                </div>\r\n                                <div class=\"control-group\" ng-if=\"o.campaignWeburl\">\r\n                                  <label class=\"control-label\" for=\"profile-name\">Campaign Website:</label>\r\n                                  <div class=\"controls\">\r\n                                    <input type=\"text\" ng-model=\"o.campaignWeburl\" class=\"form-control input-md text-input validate[required]\">\r\n                                                         </div>\r\n                                  </div>\r\n\r\n\r\n\r\n                                  <hr style=\"height:2px;border-width:0;color:gray;background-color:gray\">\r\n                                </div>\r\n                              </div>\r\n\r\n-->\r\n            <!-- <div ng-repeat=\"o in profile.politicianInfo | filter: getData() track by $index\"\r\n                          ng-if=\"!o.archive && !o.archive\">\r\n                          <div class=\"control-group\">\r\n                            <h3 class=\"control-label\" for=\"profile-description\"> Incumbent Offices Detail</h3>\r\n                            <div class=\"control-group\" ng-if=\"o.officeName\">\r\n                              <label class=\"control-label\" for=\"profile-name\">Current Office:</label>\r\n                              <div class=\"controls\">\r\n                                <input type=\"text\" ng-model=\"o.officeName\" class=\"form-control input-md text-input validate[required]\">\r\n                                     </div>\r\n                              </div>\r\n                              <div class=\"control-group\" ng-if=\"!o.end_date\">\r\n                                <label class=\"control-label\" for=\"profile-name\">Running For Office:</label>\r\n                                <div class=\"controls\">\r\n                                  <input type=\"text\" ng-model=\"o.runningForOffice\" class=\"form-control input-md text-input validate[required]\">\r\n                                       </div>\r\n                                </div>\r\n                                <div class=\"control-group\">\r\n                                  <label class=\"control-label\" for=\"profile-name\">statePostalCode:</label>\r\n                                  <div class=\"controls\">\r\n                                    <input type=\"text\" ng-model=\"o.statePostalCode\" class=\"form-control input-md text-input validate[required]\">\r\n                                         </div>\r\n                                  </div>\r\n                                  <div class=\"control-group\">\r\n                                    <label class=\"control-label\" for=\"profile-name\">County:</label>\r\n                                    <div class=\"controls\">\r\n                                      <input type=\"text\" ng-model=\"o.county\" class=\"form-control input-md text-input validate[required]\">\r\n                                            </div>\r\n                                    </div>\r\n                                    <div class=\"control-group\">\r\n                                      <label class=\"control-label\" for=\"profile-name\">Locality:</label>\r\n                                      <div class=\"controls\">\r\n                                        <input type=\"text\" ng-model=\"o.place\" class=\"form-control input-md text-input validate[required]\">\r\n                                             </div>\r\n                                      </div>\r\n                                      <div class=\"control-group\">\r\n                                        <label class=\"control-label\" for=\"profile-name\">Level of Government:</label>\r\n                                        <div class=\"controls\">\r\n                                          <input type=\"text\" ng-model=\"o.levelOfGov\" class=\"form-control input-md text-input validate[required]\">\r\n                                               </div>\r\n                                        </div>\r\n\r\n                                        <div class=\"control-group\" ng-if=\"profile.publicEmail\">\r\n                                          <label class=\"control-label\" for=\"profile-name\">Office Email:</label>\r\n                                          <div class=\"controls\">\r\n                                            <input type=\"text\" ng-model=\"profile.publicEmail\" class=\"form-control input-md text-input validate[required]\">\r\n                                                   </div>\r\n                                          </div>\r\n                                          <div class=\"control-group\" ng-if=\"profile.officePhone\">\r\n                                            <label class=\"control-label\" for=\"profile-name\">Office Phone:</label>\r\n                                            <div class=\"controls\">\r\n                                              <input type=\"text\" ng-model=\"profile.officePhone\" class=\"form-control input-md text-input validate[required]\">\r\n                                                     </div>\r\n                                            </div>\r\n                                            <div class=\"control-group\" ng-if=\"profile.curOfficeWebiste\">\r\n                                              <label class=\"control-label\" for=\"profile-name\">Office Website:</label>\r\n                                              <div class=\"controls\">\r\n                                                <input type=\"text\" ng-model=\"profile.curOfficeWebiste\" class=\"form-control input-md text-input validate[required]\">\r\n                                                       </div>\r\n                                              </div>\r\n\r\n                                              <hr style=\"height:2px;border-width:0;color:gray;background-color:gray\">\r\n                                            </div>\r\n                                          </div> -->\r\n\r\n          </div>\r\n\r\n          <!--  BRING BACK WHEN OFFICE DETAILS WORKS\r\n                            <div class=\"col-right\" style=\"padding-left: 5%\">\r\n                              <h3 class=\"control-label\" for=\"profile-description\">Office Details</h3>\r\n                              <div ng-repeat=\"o in profile.politicianInfo track by $index\"\r\n                                ng-if=\"!o.archive && !o.archive\">\r\n                                <div class=\"control-group\">\r\n\r\n                                  <div class=\"control-group\" ng-if=\"o.officeName\">\r\n                                    <label class=\"control-label\" for=\"profile-name\">Current Office:</label>\r\n                                    <div class=\"controls\">\r\n                                      <input type=\"text\" ng-model=\"o.officeName\" class=\"form-control input-md text-input validate[required]\">\r\n                             </div>\r\n                                    </div>\r\n                                    <div class=\"control-group\" ng-if=\"!o.end_date\">\r\n                                      <label class=\"control-label\" for=\"profile-name\">Running For Office:</label>\r\n                                      <div class=\"controls\">\r\n                                        <input type=\"text\" ng-model=\"o.runningForOffice\" class=\"form-control input-md text-input validate[required]\">\r\n                               </div>\r\n                                      </div>\r\n                                      <div class=\"control-group\">\r\n                                        <label class=\"control-label\" for=\"profile-name\">statePostalCode:</label>\r\n                                        <div class=\"controls\">\r\n                                          <input type=\"text\" ng-model=\"o.statePostalCode\" class=\"form-control input-md text-input validate[required]\">\r\n                                 </div>\r\n                                        </div>\r\n                                        <div class=\"control-group\">\r\n                                          <label class=\"control-label\" for=\"profile-name\">County:</label>\r\n                                          <div class=\"controls\">\r\n                                            <input type=\"text\" ng-model=\"o.county\" class=\"form-control input-md text-input validate[required]\">\r\n                                    </div>\r\n                                          </div>\r\n                                          <div class=\"control-group\">\r\n                                            <label class=\"control-label\" for=\"profile-name\">Locality:</label>\r\n                                            <div class=\"controls\">\r\n                                              <input type=\"text\" ng-model=\"o.place\" class=\"form-control input-md text-input validate[required]\">\r\n                                     </div>\r\n                                            </div>\r\n                                            <div class=\"control-group\">\r\n                                              <label class=\"control-label\" for=\"profile-name\">Level of Government:</label>\r\n                                              <div class=\"controls\">\r\n                                                <input type=\"text\" ng-model=\"o.levelOfGov\" class=\"form-control input-md text-input validate[required]\">\r\n                                       </div>\r\n                                              </div>\r\n                                              <div class=\"control-group\">\r\n                                                <label class=\"control-label\" for=\"profile-name\">Office Website:</label>\r\n                                                <div class=\"controls\">\r\n                                                  <input type=\"text\" ng-model=\"o.officeWebUrl\" class=\"form-control input-md text-input validate[required]\">\r\n                                                   </div>\r\n                                                </div>\r\n                                                <div class=\"control-group\">\r\n                                                  <label class=\"control-label\" for=\"profile-name\">Office Facebook Url</label>\r\n                                                  <div class=\"controls\">\r\n                                                    <input type=\"text\" ng-model=\"o.officeFacebookUrl\" class=\"form-control input-md text-input validate[required]\">\r\n                                                       </div>\r\n                                                  </div>\r\n\r\n                                                  <hr\r\n                                                    style=\"height:2px;border-width:0;color:gray;background-color:gray\">\r\n                                                </div>\r\n                                              </div>\r\n\r\n                                            </div>\r\n\r\n     -->\r\n          <div style=\"clear:both;\"></div>\r\n          <div ng-if=\"$root.userRole == \'politician\'\" class=\"control-group\">\r\n            <label class=\"control-label\" for=\"profile-description\">Resume </label>\r\n            <div class=\"controls\">\r\n              <!-- <textarea ui-tinymce=\"tinymceOptions\" ng-model=\"profile.resume\" style=\"height:350px;\"></textarea> -->\r\n              <textarea ng-model=\"profile.resume\" class=\"form-control input-md text-input\" style=\"width: 90%; height:200px;\"></textarea>\r\n            </div>\r\n          </div><br>\r\n          <div ng-if=\"$root.userRole == \'politician\'\" class=\"control-group\">\r\n            <label class=\"control-label\" for=\"profile-description\">Statement </label>\r\n            <div class=\"controls\">\r\n              <!-- <textarea ui-tinymce=\"tinymceOptions\" ng-model=\"profile.statement\" style=\"height:350px;\"></textarea> -->\r\n              <textarea ng-model=\"profile.statement\" class=\"form-control input-md text-input\" style=\"width: 90%; height:200px;\"></textarea>\r\n            </div>\r\n          </div>\r\n          <div style=\"clear: both;\"></div>\r\n          <div style=\"width: 55%; margin-top: 10px; float: right; margin-right: 17px;\">\r\n            <button ng-click=\"updateProfile(profile)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n            <p ng-if=\"statusUpdateProfile == 1\">Updating profile ...</p>\r\n            <!--<fb:login-button scope=\"public_profile,email\" onlogin=\"checkLoginState();\">\r\n                          </fb:login-button>-->\r\n            <div style=\"clear: both;\"></div>\r\n          </div>\r\n        </div>\r\n    </fieldset>\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Subjects Of Interest</legend>\r\n      <div class=\"col-right\">\r\n        <div class=\"control-group\">\r\n          <div class=\"control-label formLabel removeTopMargin\" for=\"title\">Select subjects\r\n            of\r\n            interest</div>\r\n          <div class=\"DisplayCat changeTextColor\">\r\n            <div style=\"background-color: #eee; padding:5px;\">All Tags\r\n              <br>\r\n              <small>(click to select)</small>\r\n            </div>\r\n            <div ng-repeat=\"subent in subtopics.subcategories track by $index\" ng-include=\"\'field_renderer\'\">Loading...\r\n            </div>\r\n            <div ng-if=\"subtopics.subcategories.length == 0\" class=\"loadingSpinner\">\r\n              <i class=\"fa fa-refresh fa-spin fa-3x fa-fw\"></i>\r\n            </div>\r\n          </div>\r\n          <div class=\"select buttons\">&nbsp;</div>\r\n          <div class=\"DisplayCat changeTextColor\">\r\n            <div style=\"background-color: #eee; padding:5px;\">Selected Tags\r\n              <br>\r\n              <small>(click to remove)</small>\r\n            </div>\r\n            <ul class=\"TcatList\">\r\n              <li ng-repeat=\"subent in selectedCat track by $index\">\r\n                <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                          <input type=\"checkbox\" ng-click=\"removeVal(subent)\" ng-model=\"selectedAll.id[$index]\" ng-checked=\"true\" name=\"checkedidcat\"> {{subent.title}}\r\n                        </label>\r\n              </li>\r\n            </ul>\r\n\r\n          </div>\r\n          <br>\r\n          <div style=\"float: left; margin-top: 200px;\">\r\n            <button ng-click=\"updateProfile(profile)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btnShort-style\"\r\n          style=\"float: right;\">Save</button>\r\n            <div style=\"clear: both;\"></div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n    </fieldset>\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Change Sign-in Name</legend>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <div class=\"col-left\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel removeTopMargin\" for=\"profile-name\">Username</label>\r\n              <div class=\"controls\">\r\n                <input type=\"text\" ng-model=\"username\" class=\"form-control input-md text-input validate[required]\">\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"dashboardRightBtn\">\r\n            <button ng-click=\"changeUsername(username)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n            <div style=\"clear: both;\"></div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </fieldset>\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Change Account Email</legend>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <div class=\"col-left\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel removeTopMargin\" for=\"profile-name\">Email</label>\r\n              <div class=\"controls\">\r\n                <input type=\"email\" ng-model=\"emailID\" class=\"form-control input-md text-input validate[custom[email]]\">\r\n              </div>\r\n            </div>\r\n            <br>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel removeTopMargin\" for=\"profile-name\">Confirm Email</label>\r\n              <div class=\"controls\">\r\n                <input type=\"email\" ng-model=\"confirmEmailID\" class=\"form-control input-md text-input validate[custom[email]]\">\r\n                </div>\r\n            </div>\r\n          </div>\r\n          <br>\r\n          <br>\r\n          <div class=\"dashboardRightBtn\">\r\n            <button ng-click=\"changeEmailID(emailID,confirmEmailID)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n            <div style=\"clear: both;\"></div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </fieldset>\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Change password</legend>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <div class=\"col-left\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel removeTopMargin\" for=\"profile-name\">Old Password</label>\r\n              <div class=\"controls\">\r\n                <input type=\"password\" ng-model=\"old_password\" class=\"form-control input-md text-input validate[required]\">\r\n              </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\" for=\"profile-name\">New Password</label>\r\n              <div class=\"controls\">\r\n                <input type=\"password\" ng-model=\"password\" class=\"form-control input-md text-input validate[required]\">\r\n              </div>\r\n            </div>\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel\" for=\"profile-name\">Confirm new Password</label>\r\n              <div class=\"controls\">\r\n                <input type=\"password\" ng-model=\"confirm_password\" class=\"form-control input-md text-input validate[required]\">\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"dashboardRightBtn\">\r\n            <button ng-click=\"changePassword(old_password, password,confirm_password)\" type=\"submit\" ng-disabled=\"EssayButton\" class=\"btnShort-style\"\r\n              style=\"float: right;\">Save</button>\r\n            <div style=\"clear: both;\"></div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </fieldset>\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Account Address</legend>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <div class=\"col-left\">\r\n            <h5 ng-if=\"isShowMailingAddress\"><span ng-if=\"mainData.mailingAddress\" >Address:</span><span>{{mainData.mailingAddress}}</span></h5>\r\n            This address is not made public. It is just used to center where you are when you look up information about\r\n            others in your area or use other similar tools.<br>\r\n            <br>\r\n            <span ng-if=\"mainData.address.country\" >Country: </span><span>{{mainData.address.country}}</span>\r\n            <br>\r\n            <span ng-if=\"mainData.address.state\" >State: </span><span>{{mainData.address.state}}</span>\r\n            <br>\r\n            <span ng-if=\"mainData.address.statePostalCode\" >State Postal Code:</span><span>{{mainData.address.statePostalCode}}</span>\r\n            <br>\r\n            <span ng-if=\"mainData.address.county\" >County: </span><span>{{mainData.address.county}}</span>\r\n            <br>\r\n            <span ng-if=\"mainData.address.place\" >City: </span><span>{{mainData.address.place}}</span>\r\n            <br>\r\n            <span ng-if=\"mainData.address.federalCongrassionalDist\" >Federal Congressional District:</span><span>{{mainData.address.federalCongrassionalDist}}</span>\r\n            <br>\r\n            <span ng-if=\"mainData.address.schoolDistrict\" >School District: </span><span>{{mainData.address.schoolDistrict}}</span>\r\n            <br>\r\n            <span ng-if=\"mainData.address.stateSenateDistrict\" >State Senate District: </span><span>{{mainData.address.stateSenateDistrict}}</span>\r\n            <br>\r\n            <span ng-if=\"mainData.address.legislativeDistrict\" >State House Of Representative District:</span><span>{{mainData.address.legislativeDistrict}}</span>\r\n             <br>\r\n             <span ng-if=\"mainData.address.cityCouncilDistrictName\" >City Council District Name:</span><span>{{mainData.address.cityCouncilDistrictName}}</span>\r\n          </div>\r\n\r\n        </div>\r\n      </div>\r\n      <p>\r\n      </p>\r\n\r\n      <button class=\"compareBtn\"> <a href=\"javascript: void(0)\" ng-click=\"updateAddress()\" >Change Address</a></button>&nbsp;\r\n      &nbsp;\r\n      <i ng-if=\"UpdateAddressLoader\" class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>\r\n    </fieldset>\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">News</legend>\r\n      <p>Choose the news source you want in your private news feed.</p>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <div class=\"col-left\">\r\n            <div class=\"control-group\">\r\n              <label class=\"control-label formLabel removeTopMargin\" for=\"newsChannel\">News Channel</label>\r\n              <div class=\"controls\">\r\n                <select ng-model=\"newsChannel\" class=\"changeTextColor\">\r\n                  <option ng-repeat=\"opt in allSource  track by $index\" value=\"{{opt.id}}\">{{opt.name}}</option>\r\n                </select>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"dashboardRightBtn\">\r\n            <button ng-click=\"changeNewsChannel(newsChannel)\" type=\"submit\" class=\"btnShort-style\" style=\"float: right;\">Save</button>\r\n            <div style=\"clear: both;\"></div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </fieldset>\r\n\r\n\r\n  </form>\r\n  <!-- My Profile End -->\r\n</div>\r\n<script type=\"text/ng-template\" id=\"field_renderer\">\r\n  <ul class=\"TcatList\">\r\n  <li>\r\n    <div class=\"catname\" id=\"{{subent._id}}\" ng-if=\"(subent.parentIds.length == 0) && (subent.subcategories)\">\r\n      <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\">\r\n      <label ng-click=\"ChangeShow(subent._id);\">{{::subent.title}}&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id)==-1\"></i><i class=\"fa fa-caret-right\" aria-hidden=\"true\" ng-if=\"showDown.indexOf(subent._id) > -1\"></i></label>\r\n    </div>\r\n    <div class=\"catname\" ng-if=\"(subent.parentIds.length == 0) && (!subent.subcategories)\">\r\n      <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n        <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\"> {{::subent.title}}\r\n      </label>\r\n    </div>\r\n    <label class=\"checkbox\" ng-if=\"subent.parentIds.length > 0 && showSubCat\" title=\"{{subent.title}}\">\r\n      <input type=\"checkbox\" ng-click=\"getVal(subent)\" ng-disabled=\"disabled.indexOf(subent._id) > -1 ? true : false\" ng-checked=\"disabled.indexOf(subent._id) > -1 ? true : false\"> {{::subent.title}}\r\n    </label>\r\n    <ul ng-if=\"subent.subcategories\" ng-class=\"subent.parentIds.length == 0 ? \'cmnUL MainCatLi_{{subent._id}}\' : \'\'\">\r\n      <li ng-repeat=\"subent in subent.subcategories track by $index\" ng-include=\"\'field_renderer\'\">\r\n        <!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                    <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n                </label> -->\r\n      </li>\r\n    </ul>\r\n  </li>\r\n</ul>\r\n</script>\r\n");
$templateCache.put("app/verifyUsers/verifyUsers.html","<div class=\"container-fluid ng-scope\" ng-cloak ng-show=\"$root.userRole==\'admin\'\">\r\n  <h2 class=\"pageHeading\">Settings</h2>\r\n  <div class=\"closeForm\" ng-include=\"\'app/popups/setting_Ctrl.html\'\"></div>\r\n\r\n  <form name=\"signupform\" id=\"signInform\" ng-controller=\"AdminVerifyUsers\" class=\"closeForm\">\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Verify user</legend>\r\n      <label>Select user type: </label>\r\n      <select ng-model=\"verifySelectedUser\" ng-change=\"getVerifyUsers(verifySelectedUser)\" class=\"changeTextColor form-control\" style=\"width: 30%\">\r\n        <option ng-repeat=\"item in [\'Advocate\', \'Politician\', \'Press\']\" value=\"{{item}}\">{{item}}</option>\r\n      </select>\r\n      <label>Filter: </label>\r\n      <select ng-model=\"verifyFilter\" ng-change=\"getVerifyFilterUsers(verifySelectedUser, verifyFilter)\" class=\"changeTextColor form-control\" style=\"width: 30%\">\r\n        <option ng-repeat=\"item in [{lbl: \'Verified\', val: 1}, {lbl: \'Unverified\', val: 0}]\" value=\"{{item.val}}\">{{item.lbl}}</option>\r\n      </select>\r\n\r\n      <div>\r\n        <label class=\"control-label formLabel whiteText\" for=\"email\">Search By Name</label>\r\n\r\n        <div>\r\n          <input type=\"text\" ng-model=\"User.name\" class=\"form-control\" style=\"width:30%;display:initial\">\r\n                        </div>\r\n        </div>\r\n        <div style=\"margin-top: 2%\">\r\n          <button class=\"btn2Short-style widthAuto btn-success\" type=\"button\" ng-click=\"searchUsers()\">\r\n                                    Search\r\n                                  </button>\r\n          <!-- </div> -->\r\n        </div>\r\n\r\n        <div class=\"row\" ng-if=\"verifyUsers.data.length > 0\" style=\"margin-top: 10px;\">\r\n          <div infinite-scroll=\'myPagingFunction()\'>\r\n            <table class=\"w100 changeTextColor\">\r\n              <tr>\r\n                <th>User name</th>\r\n                <!-- <th>Generate Password</th> -->\r\n                <th width=\"30%\">Verified</th>\r\n              </tr>\r\n              <tr ng-repeat=\"u in verifyUsers.data\">\r\n                <td>\r\n                  <span ng-if=\"u.userType != \'advocate\'\">Politician name:{{u.name}}<br>Username: {{u.username}}</span>\r\n                  <span ng-if=\"u.userType != \'politician\'\">Org name: {{u.organization.title}}<br> Username: {{u.username}}</span>\r\n                  <p style=\"margin: 0;\" ng-if=\"u.typeOfOrg && u.typeOfOrg != null\">Type Of Organization: {{u.typeOfOrg}}\r\n                  </p>\r\n                  <p style=\"margin: 0;\" ng-if=\"u.empIndNo\">Employee Identification Number: {{u.empIndNo}}</p>\r\n                  <p style=\"margin: 0;\">Email: {{u.email}}</p>\r\n                  <p ng-if=\"u.phone\" style=\"margin: 0;\">Phone: {{u.phone}}</p>\r\n                  <p ng-if=\"u.name_on_ballot\" style=\"margin: 0;\">Name on Ballot: {{u.name_on_ballot}}</p>\r\n                  <p ng-if=\"!u.voter\" style=\"margin: 0;\">Verification Note: {{u.verification_note}}</p>\r\n                  <a href=\"javascript:(0)\" ng-click=\"showDetails= !showDetails\" class=\"link\">\r\n                        <b>More Info</b>\r\n                      </a>\r\n                  <br>\r\n                  <div ng-hide=\"showDetails\">\r\n                    <p ng-if=\"u.web_url\" style=\"margin: 0;\">Website: {{u.web_url}}</p>\r\n                    <p ng-if=\"u.mailing_address\" style=\"margin: 0;\">Mailing Address: {{u.mailing_address}}</p>\r\n                    <p ng-if=\"u.zipcode\" style=\"margin: 0;\">Zipcode: {{u.zipcode}}</p>\r\n                    <p ng-if=\"u.address.state\" style=\"margin: 0;\">Address (as per OrganizedZips:\r\n                      <br>\r\n                      <span ng-if=\"u.address.state\">State: {{u.address.state}}</span>\r\n                      <br>\r\n                      <span ng-if=\"u.address.county\">County: {{u.address.county}}</span>\r\n                      <br>\r\n                      <span ng-if=\"u.address.countySubdivision\">County Subdivision: {{u.address.countySubdivision}}</span>\r\n                      <br>\r\n                      <span ng-if=\"u.address.voterDistrict\">Voter District: {{u.address.voterDistrict}}</span>\r\n                      <br>\r\n                  </p>\r\n                      <p ng-if=\"u.location_of_interest.length > 0\">Location of Interest:\r\n                        {{u.location_of_interest.join(\', \')}}</p>\r\n                      <p ng-if=\"u.subject_of_deep_interest.length > 0\">Deep Interests:\r\n                        {{u.subject_of_deep_interest.join(\', \')}}</p>\r\n                      <p ng-if=\"u.subject_of_interest.length > 0\">Subject of Interests:\r\n                        {{u.subject_of_interest.join(\', \')}}</p>\r\n                      <div ng-if=\"u.politician==true\">\r\n                        <h3>Politician Details</h3>\r\n                        <div ng-repeat=\"politicians in u.politician_info\" style=\"padding-bottom: 10px;\">\r\n                          <p style=\"margin: 0;\">Office: {{politicians.office_name}}</p>\r\n                          <p style=\"margin: 0;\">State: {{politicians.state}}</p>\r\n                          <p style=\"margin: 0;\">Level of Govt.: {{politicians.levelOfGov}}</p>\r\n                        </div>\r\n                      </div>\r\n                  </div>\r\n                  <a  ng-show=\"u.officeId\" href=\"javascript:(0)\" ng-click=\"isShowOrg = !isShowOrg\">\r\n                        <b>View Organization</b>\r\n                      </a>\r\n                  <!-- <p ng-if=\"u.organization.status == 1\" style=\"margin: 0;\">Loading organization detail...</p> -->\r\n                  <div ng-hide=\"isShowOrg\">\r\n                    <h3>Organization</h3>\r\n                    <p style=\"margin: 0;\" ng-if=\"u.organization.title\">Name: {{u.organization.title}}</p>\r\n                    <p style=\"margin: 0;\" ng-if=\"u.typeOfOrg\">Type Of Organization: {{u.typeOfOrg}}</p>\r\n                    <p style=\"margin: 0;\" ng-if=\"u.empIndNo\">Employee Identification Number: {{u.empIndNo}}</p>\r\n                    <p style=\"margin: 0;\" ng-if=\"u.organization.phoneNo\"> {{u.organization.phoneNo}}</p>\r\n                    <p style=\"margin: 0;\" ng-if=\"u.extension_no\">Extension no: {{u.extension_no}}</p>\r\n                    <p ng-if=\"u.web_url\" style=\"margin: 0;\" ng-if=\"u.organization.webUrl\">Website:\r\n                      {{u.organization.webUrl}}</p>\r\n                    <p ng-if=\"u.mailing_address\" style=\"margin: 0;\" ng-if=\"u.organization.mailingAddress\">Mailing\r\n                      Address: {{u.organization.mailingAddress}}\r\n                    </p>\r\n                    <p ng-if=\"u.organization.zipcode\" style=\"margin: 0;\" ng-if=\"u.organization.zipcode\">Zipcode:\r\n                      {{u.organization.zipcode}}</p>\r\n                    <p ng-if=\"u.organization.address.state || u.organization.address.statePostalCode\"\r\n                      style=\"margin: 0;\">Address (as per OrganizedZips):\r\n                      <br>\r\n                      <span ng-if=\"u.organization.address.state\">State: {{u.organization.address.state}}</span>\r\n                      <span ng-if=\"!u.organization.address.state\">State: {{u.organization.address.statePostalCode}}</span>\r\n                      <br>\r\n                      <span ng-if=\"u.organization.address.county\">County: {{u.organization.address.county}}</span>\r\n                      <br>\r\n                      <span ng-if=\"u.organization.address.countySubdivision\">County Subdivision: {{u.organization.address.countySubdivision}}</span>\r\n                      <br>\r\n                      <span ng-if=\"u.organization.address.place\">Voter District: {{u.organization.address.place}}</span>\r\n                    </p>\r\n                    <p ng-if=\"u.organization.contactPerson.name\" style=\"margin: 0;\">Contact Person:\r\n                      <br>\r\n                      <span ng-if=\"u.organization.contactPerson.name\">Name: {{u.organization.contactPerson.name}}</span>\r\n                      <br>\r\n                      <span ng-if=\"u.organization.contactPerson.email\">Email: {{u.organization.contactPerson.email}}</span>\r\n                      <br>\r\n                      <span ng-if=\"u.organization.contactPerson.position\">Position: {{u.organization.contactPerson.position}}</span>\r\n                      <br>\r\n                  </p>\r\n                      <p ng-if=\"u.organization.editor.name\" style=\"margin: 0;\">Editor:\r\n                        <br>\r\n                        <span ng-if=\"u.organization.editor.name\" style=\"margin: 0;\">Name: {{u.organization.editor.name}}</span>\r\n                        <br>\r\n                        <span ng-if=\"u.organization.editor.email\" style=\"margin: 0;\">Email: {{u.organization.editor.email}}</span>\r\n                        <br>\r\n                        <span ng-if=\"u.organization.editor.phone_no\" style=\"margin: 0;\">Phone No: {{u.organization.editor.phone_no}}</span>\r\n                        <br>\r\n                  </p>\r\n                        <p ng-if=\"u.organization.circulation\" style=\"margin: 0;\">Circulation:\r\n                          {{u.organization.circulation}}</p>\r\n                        <p ng-if=\"u.organization.counties\" style=\"margin: 0;\">Counties: {{u.organization.counties}}</p>\r\n                        <p ng-if=\"u.organization.description\" style=\"margin: 0;\">Description:\r\n                          {{u.organization.description}}</p>\r\n                        <p ng-if=\"u.organization.foundedOn\" style=\"margin: 0;\">Founded On: {{u.organization.foundedOn}}\r\n                        </p>\r\n                        <p ng-if=\"u.organization.frequency\" style=\"margin: 0;\">Frequency: {{u.organization.frequency}}\r\n                        </p>\r\n                        <p ng-if=\"u.organization.headquarter\" style=\"margin: 0;\">Headquarter:\r\n                          {{u.organization.headquarter}}</p>\r\n                        <p ng-if=\"u.organization.location_of_interest\" style=\"margin: 0;\">Location of Interest:\r\n                          {{u.organization.location_of_interest}}</p>\r\n                        <p ng-if=\"u.organization.mailing_address\" style=\"margin: 0;\">Mailing address:\r\n                          {{u.organization.mailing_address}}</p>\r\n                        <p ng-if=\"u.organization.orgtype\" style=\"margin: 0;\">Type: {{u.organization.orgtype}}</p>\r\n                        <p ng-if=\"u.organization.phone_no\" style=\"margin: 0;\">Phone No: {{u.organization.phone_no}}</p>\r\n                  </div>\r\n                  <div ng-if=\"u.organization.status == 2 && u.politician==true\">\r\n                    <h3>Politician Details</h3>\r\n                    <p style=\"margin: 0;\">Name: {{u.organization.name}}</p>\r\n                    <p style=\"margin: 0;\">Office: {{u.organization.office}}</p>\r\n                    <p style=\"margin: 0;\">Party: {{u.organization.party}}</p>\r\n                    <p ng-if=\"u.organization.incumbent\" style=\"margin: 0;\">Incumbent: {{u.organization.incumbent}}</p>\r\n                    <p ng-if=\"u.organization.office\" style=\"margin: 0;\">Office: {{u.organization.office}}</p>\r\n                    <p ng-if=\"u.organization.public_zipcode\" style=\"margin: 0;\">Public zipcode:\r\n                      {{u.organization.public_zipcode}}</p>\r\n                    <p ng-if=\"u.organization.public_address.state\" style=\"margin: 0;\">Address (as per OrganizedZips:\r\n                      <br>\r\n                      <span ng-if=\"u.organization.public_address.state\">State: {{u.organization.public_address.state}}</span>\r\n                      <br>\r\n                      <span ng-if=\"u.organization.public_address.county\">County: {{u.organization.public_address.county}}</span>\r\n                      <br>\r\n                      <span ng-if=\"u.organization.public_address.countySubdivision\">County Subdivision: {{u.organization.public_address.countySubdivision}}</span>\r\n                      <br>\r\n                      <span ng-if=\"u.organization.public_address.place\">Voter District: {{u.organization.public_address.place}}</span>\r\n                    </p>\r\n                    <p ng-if=\"u.organization.voterScope\" style=\"margin: 0;\">VoterScope: {{u.organization.voterScope}}\r\n                    </p>\r\n                    <p ng-if=\"u.organization.website\" style=\"margin: 0;\">Website: {{u.organization.website}}</p>\r\n                    <p ng-if=\"u.organization.electionDate\" style=\"margin: 0;\">Election Date:\r\n                      {{u.organization.electionDate}}</p>\r\n                    <p ng-if=\"u.organization.dataX\" style=\"margin: 0;\">dataX: {{u.organization.electionDate}}</p>\r\n                    <p ng-if=\"u.organization.dataY\" style=\"margin: 0;\">dataY: {{u.organization.dataY}}</p>\r\n                    <p ng-if=\"u.organization.dataZ\" style=\"margin: 0;\">dataZ: {{u.organization.dataZ}}</p>\r\n                  </div>\r\n                </td>\r\n\r\n                <td>\r\n                  <a ng-if=\"u.verifiedUser\" href=\"javascript: void(0)\" ng-click=\"verifyThisUser(u, $index, false)\">Unverify</a>\r\n                  <a ng-if=\"!u.verifiedUser\" href=\"javascript: void(0)\" ng-click=\"verifyThisUser(u, $index, true)\">Verify</a>\r\n                </td>\r\n              </tr>\r\n            </table>\r\n          </div>\r\n        </div>\r\n        <p ng-if=\"verifyUsers.data.length <= 0 && statusVerifyUsers == 2\">No results found</p>\r\n        <p ng-if=\"statusVerifyUsers == 1\">Loading data...</p>\r\n    </fieldset>\r\n  </form>\r\n</div>\r\n<h2 class=\"pageHeading\">USEFUL LOOK UPS</h2>\r\n<p>Federal House fo Congress Lobbyist look\r\n  up.<a href=\"http://disclosures.house.gov/ld/ldsearch.aspx\" target=\"_blank\">HERE</a><br>The xml download supplies the name and address of the organization that they work for.  The online tool just says the name.  THe XML also shaows their Senate ID.</p>\r\n  <p>Charity Look up (lists both c3 and\r\n    c4)<a href=\"https://www.charitynavigator.org/index.cfm?bay=search.profile&ein\" target=\"_blank\">HERE</a> </p>\r\n  <p>IRS Charity look up tool <a href=\"https://apps.irs.gov/app/eos/\" target=\"_blank\">HERE</a><br></p>\r\n");
$templateCache.put("app/viewBillDetails/viewBillDetails.html","<div class=\"container-fluid ng-scope\">\r\n  <div>\r\n    <a href=\"\" ng-click=\"backTo()\" class=\"ylink\">Back</a>\r\n    <fieldset class=\"scheduler-border\">\r\n      <legend class=\"scheduler-border\">Bill Detail</legend>\r\n      <div class=\"billDetailBlock d-flex  container-fluid col-sm-12 col-lg-12\" style=\"width:100%;\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <br>\r\n            <p ng-if=\"details.identifier\"><b> Identifier:</b> {{details.identifier}}</p><br>\r\n            <p ng-if=\"details.classification[0]\"><b>Classification:</b> {{details.classification[0]}} </p><br>\r\n            <p ng-if=\"details.title\"><b>Title:</b> {{details.title}}</p>\r\n            <p ng-repeat=\"a in details.abstracts\">\r\n              <span><b>Abstract:</b> {{a.abstract}}</span>\r\n            </p>\r\n            <!--           <p>\r\n              <span>Bill Id : - {{details.billId}}</span><br>  \r\n              \r\n            </p>-->\r\n            <p><b>LegislativeSession</b>\r\n              <!-- <span>Identifier : {{legislativeSession.identifier}}-->\r\n            </p>\r\n            <p><b>Jurisdiction:</b> {{details.legislativeSession.jurisdiction.name}}</p><br>\r\n            <p>\r\n              <a href=\"\" ng-show=\"details.documents.length > 0\" class=\"link\" ng-click=\"activeDoc = !activeDoc\"><b>Documents</b></a>\r\n            </p>\r\n            <div ng-hide=\"activeDoc\">\r\n              <div class=\"p\" ng-repeat=\"d in details.documents\" ng-if=\"details.documents.length > 0\">\r\n                <div ng-if=\"d.date\"><b>Date:</b>{{d.date}}</div>\r\n                <div ng-if=\"d.note\"><b>Note:</b>{{d.note}}</div>\r\n                <div ng-if=\"d.links[0].url\"><b>Links:</b> <a href=\"{{d.links[0].url}}\" target=\"_blank\" ng-if=\"details.documents.length > 0\" class=\"link\"><b>{{d.links[0].url}}</b></a> </div>\r\n              </div>\r\n            </div>\r\n            <p><a href=\"\" class=\"link\" ng-show=\"details.actions.length > 0\" ng-click=\"activeAction = !activeAction\"><b>Actions</b></a></p>\r\n            <div ng-hide=\"activeAction\">\r\n              <div class=\"p\" ng-repeat=\"u in details.actions\">\r\n                <div><b>Date:</b> {{u.date | date:\" MM/dd/y\"}}</div>\r\n                <div><b>Classification:</b> {{u.classification[0]}}</div>\r\n                <div><b>Description:</b> {{u.description}}</div>\r\n              </div>\r\n            </div>\r\n            <p><a href=\"\" class=\"link\" ng-show=\"details.sponsorships.length > 0\" ng-click=\"activeSpo = !activeSpo\"><b>Sponsors</b></a></p>\r\n            <div ng-hide=\"activeSpo\">\r\n              <div class=\"p\" ng-repeat=\"s in details.sponsorships\">\r\n                <!--            <span>entityType : {{s.entityType}}</span>  -->\r\n                <div ng-if=\"s.name\"><b>Name:</b> {{s.name}}</div>\r\n                <div ng-if=\"s.organization\"><b>Organization:</b> {{s.organization}}</div>\r\n                <!--            <div ng-if=\"s.person\">Person : {{s.person}}</div> -->\r\n              </div>\r\n            </div>\r\n            <p><a href=\"\" class=\"link\" ng-show=\"details.votes.edges.length > 0\" ng-click=\"activeVot = !activeVot\"><b>Votes</b></a></p>\r\n            <div ng-hide=\"activeVot\">\r\n              <div ng-repeat=\"v in details.votes.edges\" ng-if=\"details.votes.edges.length > 0\">\r\n                <p ng-if=\"v.node.billAction\"><b>Bill Action:</b> </p>\r\n                <br>\r\n                <p ng-repeat=\"c in v.node.counts\">\r\n                  <span><b>Counts</b></span>\r\n                  <span><b>Option:</b> {{c.option}}</span>\r\n                  <br>\r\n                  <span><b>Value:</b> {{c.value}} </span>\r\n                </p>\r\n                <br>\r\n                <p>\r\n                  <span><b>Organization</b></span>\r\n                  <span><b>Classification:</b> {{v.node.organization.classification}}</span>\r\n                  <br>\r\n                  <span><b> Name:</b> {{v.node.organization.name}}</span>\r\n                  <br>\r\n                  <span><b> Result:</b> {{v.node.result}}</span>\r\n                  <br>\r\n                </p>\r\n                <p ng-repeat=\"cv in v.node.votes\">\r\n                  <span><b>Votes</b> </span>\r\n                  <span><b>Option:</b> {{cv.option}}</span>\r\n                  <br>\r\n                  <span><b>VoterName:</b> {{cv.voterName}} </span>\r\n                  <br>\r\n                  <span ng-if=\"cv.voter\"><b>Voter:</b> {{cv.voter}} </span>\r\n                </p>\r\n              </div>\r\n              <!-- <p><a href=\"\" ng-if=\"more[\'votes\']\" class=\"link\" ng-click=\"showLess(\'votes\')\">Less</a></p> -->\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </fieldset>\r\n    <!-- Display Rating tool for organization and admin -->\r\n    <div ng-show=\"userRole == \'admin\' || userRole == \'advocate\' \">\r\n      <fieldset class=\"scheduler-border\">\r\n        <legend class=\"scheduler-border\">Rate Legislation</legend>\r\n        <div class=\"contactBlock d-flex justify-center container-fluid col-sm-12 col-lg-8\" style=\"width: 100%\">\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n              <div style=\"padding-top: 10%\">\r\n                <p>Rate : <input-stars max=\"5\" ng-click=\"rateLegislation();\" ng-model=\"rating.rate\"></input-stars>\r\n                </p>\r\n              <!--   <div>\r\n                  Vote Legislation:\r\n                  <img src=\"../assets/images/thumbsup.svg\" ng-if=\"disImg\"  ng-click=\"rateLegislation(\'Like\');\" style=\"cursor:pointer;width: 30px\" alt=\"Vote\">\r\n                   <img src=\"../assets/images/thumbsupone.png\" ng-if=\"!disImg\"  ng-click=\"rateLegislation(\'Like\');\" style=\"cursor:pointer;width: 30px\" alt=\"Vote\">\r\n                </div> -->\r\n                <div>\r\n                  <span ng-if=\"comment !=\'\'\">Comment : {{comment}}\r\n                  </span>\r\n                </div>\r\n              </div>\r\n              <div class=\"inline2\" style=\"width: 90%; margin: auto;\">\r\n                <!-- Comments: -->\r\n                <!-- <center> -->\r\n                <button ng-click=\"redirectToComment();\" ng-if=\"displayComments\" class=\"compareBtn\">Add comment</button>\r\n                <!-- <button ng-click=\"redirectToComment();\" ng-if=\"displayComments && comment != \'\'\" class=\"compareBtn\">Edit comment</button> -->\r\n\r\n                <!-- </center> -->\r\n                <div class=\"inline2\" ng-if=\"ShowComments\">\r\n                  <form name=\"essayform\" id=\"essayform\">\r\n                    <fieldset class=\"scheduler-border\">\r\n                      <legend class=\"scheduler-border\">Your Comments</legend>\r\n                      <p></p>\r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-12\">\r\n                          <div class=\"control-group\">\r\n                            <div class=\"controls\">\r\n                              <textarea id=\"comments\" ng-model=\"comments.content\" placeholder=\"\" data-errormessage=\"Comments is required.\" class=\"form-control input-md  validate[required] text-area changeTextColor\" style=\"width: 80%; height: 100px;\"></textarea>\r\n                            </div>\r\n                          </div>\r\n                        </div>\r\n                        <!-- <div style=\"clear: both;\"></div> -->\r\n                        <div style=\"margin-top:20px; width:100%;\">\r\n                          <button ng-click=\"SubmitComment(comments)\" type=\"button\" class=\"compareBtn\" ng-disabled=\"CommentButton\" style=\"float: left;\">Submit Comments</button>\r\n                          <center><button ng-click=\"goBack();\" type=\"button\" class=\"compareBtn\">Cancel</button></center>\r\n                        </div>\r\n                      </div>\r\n                    </fieldset>\r\n                  </form>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </fieldset>\r\n    </div>\r\n    <!-- End  Display Rating tool for organization and admin -->\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/viewBills/viewBills.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">State Bills</h2>\r\n    <p class=\"pageSubHeading\">Find state level legislation, see how far it has gotten and who voted on it.</p>\r\n  <!-- <h4> {{u.legislativeSession.jurisdiction.name}}</h4> -->\r\n  <div>\r\n    <h4 ng-if=\"searchData\">Total Bills {{searchData}} </h4>\r\n    <br>\r\n    <div class=\"form-group row\">\r\n      <label style=\"color:#ffffff;padding-left: 5%;padding-right: 5%\">Title: </label>\r\n      <!-- <div class=\"col-lg-5 col-sm-5\"> -->\r\n      <input type=\"text\" ng-model=\"searchCandy.search\" id=\"searchCandy\" class=\"form-control\" placeholder=\"Search by Title\" style=\"width:170px;\">\r\n      <!-- </div> -->\r\n    </div>\r\n    <div class=\"form-group row\">\r\n      <!-- <button class=\"blackText\" style=\"margin-left:5%\" ng-click=\"sortByDate()\">Sort By Date</button> -->\r\n      <label style=\"color:#ffffff;padding-left: 5%;padding-right: 5%\">Sort By Date: </label>\r\n      <select ng-model=\"date.value\" class=\"form-control\" style=\"width:170px;\">\r\n        <option value=\"\">Select Option</option>\r\n        <option value=\'actions[0].date\'>Ascending</option>\r\n        <option value=\'-actions[0].date\'>Descending</option>\r\n      </select>\r\n    </div>\r\n    <div class=\"form-group\">\r\n      <label>Select State</label>\r\n      <div class=\"DisplaySen changeTextColor\" style=\"width: 40%;\">\r\n        <ul class=\"TcatList\">\r\n          <li ng-repeat=\"sta in allState track by $index\">\r\n            <input type=\"checkbox\" name=\"state\" ng-model=\"searchCandy.state[sta.state]\" ng-value=\"sta.state\">\r\n            <label>{{sta.state}}&nbsp;\r\n            </label>\r\n          </li>\r\n        </ul>\r\n      </div>\r\n    </div>\r\n    <div class=\"form-group\">\r\n      <button class=\"blackText\" style=\"margin-left:5%\" ng-click=\"getBills()\">Search</button>\r\n    </div>\r\n    <div infinite-scroll=\'myPagingFunction()\'>\r\n      <table class=\"w100 changeTextColor\" ng-show=\"openBills.length > 0\">\r\n        <tr>\r\n          <th>Title</th>\r\n          <th>Classification</th>\r\n          <th>Subject</th>\r\n          <th>Jurisdiction</th>\r\n          <th style=\"width:10%\">Details</th>\r\n        </tr>\r\n        <tr ng-repeat=\"u in openBills | orderBy:date.value\">\r\n          <td style=\"text-align: left\">\r\n            <p>\r\n              {{u.title}}</p>\r\n          </td>\r\n          <td style=\"text-transform: capitalize;\">\r\n            {{u.classification[0]}}\r\n          </td>\r\n          <td>\r\n            <p style=\"text-align: left\" ng-repeat=\"s in u.subject track by $index\">\r\n              <span ng-if=\"s\"> {{s}}</span>\r\n            </p>\r\n          </td>\r\n          <td>\r\n            {{u.legislativeSession.jurisdiction.name}}\r\n          </td>\r\n          <td>\r\n            <a href=\"\" ng-click=\"getDetailPage(u._id)\" class=\"link\">Get Details</a>\r\n          </td>\r\n        </tr>\r\n        <tr ng-if=\"open.length == 0\">\r\n          <td colspan=\"3\"> No records found.\r\n          </td>\r\n        </tr>\r\n      </table>\r\n      <div class=\"contactBlock  col-sm-12 col-lg-12 \" style=\"width: 100%\" ng-if=\"openBills.length == 0\">\r\n        <div style=\"display: block; text-align: center;\">\r\n          <span>No Data Found</span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <p ng-if=\"statusGetResPg == 1 && searchData > openBills.length\" class=\"fwb\">Loading OpenState Data...</p>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/voterProfile/voterProfile.html","<div class=\"container-fluid\">\r\n  <div>\r\n    <img ng-src=\"../assets/images/profile/{{item.returndata.createdby.utype}}.svg\" ng-if=\"item.returndata.createdby.utype\">\r\n\r\n\r\n    <h2 class=\"pageHeading\" style=\"text-transform: capitalize;\">{{press.userData.username}}</h2>\r\n\r\n    <div style=\"display: flex\">\r\n      <div class=\"pressRating\">\r\n\r\n        <p ng-if=\"press.type == \'Advocate\'\" style=\"padding-left:7% !important\"><b>Organization</b></p>\r\n        <p ng-if=\"press.type == \'Press\'\"><b>Press</b></p>\r\n        <p ng-if=\"pressUser.typeOfOrg\">Type of Organization: <b>{{pressUser.typeOfOrg}}</b></p>\r\n\r\n\r\n\r\n        <div ng-if=\"pressUserId && match\" href=\"#!/compare-subject/politician\" class=\"hoverYellow\">\r\n          <h3>Match to You</h3>\r\n          <p>{{match}}%</p>\r\n        </div>\r\n        <div ng-if=\"!pressUserId && match\" href=\"#!/compare-subject/politician\" class=\"hoverYellow\">\r\n          <h3>Match to You</h3>\r\n          <p>{{match}}%</p>\r\n        </div>\r\n        <div style=\"padding-left:5%;float: left\">\r\n          <div ng-if=\"loginUser!=pressId && !showUnFollow\">\r\n            <input type=\"button\" class=\"compareBtn\" ng-click=\"addtoFollow();\" value=\"Follow\">\r\n          </div>\r\n            <div ng-if=\"loginUser!=pressId && showUnFollow\">\r\n              <input type=\"button\" class=\"compareBtn\" ng-click=\"removetoFollow();\" value=\"Unfollow\"></div>\r\n\r\n              <!--             <div>\r\n                <input  type=\"button\" class=\"compareBtn\" ng-click=\"redirectToReviews();\" value=\"See Reviews\"></div>\r\n\r\n\r\n\r\n                <br>-->\r\n\r\n            </div>\r\n            <br>\r\n      </div>\r\n\r\n          </div>\r\n\r\n<center>\r\n          <!-- <div class=\"row\">\r\n            <div class=\"col-lg-5\"> -->\r\n          <div>\r\n\r\n\r\n            <!--    VOTEWISE ACTIVITY  --->\r\n            <div class=\"votewiseActivitiesBlock\"\r\n              ng-show=\"votewiseActivity.totalthread >\'0\' || votewiseActivity.totalanswers >\'0\' || votewiseActivity.totalthreads >\'0\' || votewiseActivity.totalposts >\'0\'\"\r\n              style=\"clear: both;\">\r\n              <center>\r\n                <img ng-src=\"./assets/images/votewiseWide3.svg\" class=\"blockLink publicProfileImg img-fluid\">\r\n                <br>\r\n      </center>\r\n                <h5 class=\"blockHeading\">Votewise Activities</h5>\r\n                <p class=\"userInfo\">\r\n                  <span class=\"infoName\">Questions Answered </span>\r\n                  <span >{{votewiseActivity.totalanswers}}</span>\r\n                </p>\r\n                <p class=\"userInfo\" ng-if=\"votewiseActivity.totalthread>0\">\r\n                  <span class=\"infoName\">Threads Created </span>\r\n                  <a ng-href=\"\" ng-click=\"gotoPage(\'Thread\', votewiseActivity.userData)\"\r\n          class=\"infoAns\">\r\n          <span class=\"link\">{{votewiseActivity.totalthread}}</span>\r\n        </a>\r\n                </p>\r\n                <p class=\"userInfo\" ng-if=\"votewiseActivity.totalthread==0\">\r\n                  <span>Threads Created </span>\r\n                  <span  >{{votewiseActivity.totalthread}}</span>\r\n                </p>\r\n                <p class=\"userInfo\" ng-if=\"votewiseActivity.totalpost>0\">\r\n                  <span class=\"infoName\">Total Posts </span>\r\n                  <a ng-href=\"\"  ng-click=\"gotoPage(\'Post\', votewiseActivity.userData)\"\r\n          class=\"infoAns\">\r\n          <span class=\"link\">{{votewiseActivity.totalpost}}</span>\r\n        </a>\r\n                </p>\r\n                <p class=\"userInfo\" ng-if=\"votewiseActivity.totalpost==0\">\r\n                  <span class=\"infoName\">Total Posts </span>\r\n                  <span >{{votewiseActivity.totalpost}}</span>\r\n                </p>\r\n           <!--     <p ng-if=\"votewiseActivity.totalessay && votewiseActivity.totalessay > 0\" class=\"userInfo\">\r\n                  <a href=\"javascript: void(0);\" ng-click=\"gotoPage(\'Essay\', votewiseActivity.userData)\" style=\"cursor:pointer; text-decoration: underline;\">Essay :{{votewiseActivity.totalessay}}</a>\r\n                </p>-->\r\n                <p ng-if=\"votewiseActivity.totalessaycomments && votewiseActivity.totalessaycomments > 0\" class=\"userInfo\">\r\n                  <span class=\"infoName\">Essay Comments:</span>\r\n																	<a href=\"javascript: void(0);\" ng-click=\"gotoPage(\'EssayComment\', votewiseActivity.userData)\" class=\"link\"> {{votewiseActivity.totalessaycomments}}</a>\r\n                </p>\r\n\r\n                <p ng-if=\"followersCnt\" class=\"userInfo\">\r\n																	Followers:{{followersCnt}} </p>\r\n																	\r\n             <!--     <a href=\"#!/orgActivityDetails/followers/{{pressId}}\" class=\"infoAns\">{{followersCnt}}</a></p> -->\r\n\r\n\r\n                <p ng-if=\"quizQuesHasAns\" class=\"userInfo\">\r\n                  Quiz Questions Has Already Answered: {{quizQuesHasAns}}\r\n                </p>\r\n\r\n\r\n\r\n\r\n\r\n            </div>\r\n\r\n\r\n            <div style=\"clear:both;\"></div>\r\n          </div>\r\n			</center>\r\n        </div>\r\n\r\n      </div>\r\n      <script type=\"text/ng-template\" id=\"LatestEssayId\">\r\n        <div class=\"latestPosts\">\r\n          <h3>Latest Essay</h3>\r\n          <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"LatestEssay==0\"></i>\r\n          <ul>\r\n            <li ng-repeat=\"essay in LatestEssay track by $index\">\r\n              <div class=\"boldbox\">\r\n                <span ng-click=\"gotoEssay(essay._id, essay.parentCat[0]);\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">{{essay.title}}</span>\r\n              </div>\r\n              <!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                            <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n                        </label> -->\r\n            </li>\r\n          </ul>\r\n        </div>\r\n      </script>\r\n      <script type=\"text/ng-template\" id=\"LatestEssayCommentId\">\r\n        <div class=\"latestPosts\">\r\n          <h3>Latest Essay Comments</h3>\r\n          <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"LatestEssayComments==0\"></i>\r\n          <ul>\r\n            <li ng-repeat=\"essay in LatestEssayComments track by $index\">\r\n              <div class=\"boldbox\">\r\n                <!-- <div  ng-bind-html=\'essay.comments | urlify\' ng-click=\"gotoComments(essay.essayId)\"></div> -->\r\n                <span ng-click=\"gotoComments(essay._id, essay.parentCat[0]);\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">{{essay.title}}</span>\r\n              </div>\r\n            </li>\r\n          </ul>\r\n        </div>\r\n      </script>\r\n      <script type=\"text/ng-template\" id=\"LatestPostId\">\r\n        <div class=\"latestPosts\">\r\n          <h3>Latest Posts</h3>\r\n          <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"LatestPost==0\"></i>\r\n          <ul>\r\n            <li ng-repeat=\"post in LatestPost track by $index\">\r\n              <div class=\"boldbox\">\r\n                <span ng-click=\"gotoThread(post, post.subCategories[0].pid);\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">{{post.title}}</span>\r\n              </div>\r\n              <!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                            <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n                        </label> -->\r\n            </li>\r\n          </ul>\r\n        </div>\r\n      </script>\r\n      <script type=\"text/ng-template\" id=\"LatestThreadId\">\r\n        <div class=\"latestPosts\">\r\n          <h3>Latest Threads</h3>\r\n          <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"LatestThread==0\"></i>\r\n          <ul>\r\n            <li ng-repeat=\"thread in LatestThread track by $index\">\r\n              <div class=\"boldbox\">\r\n                <span ng-click=\"gotoThread(thread, thread.subCategories[0].pid);\" style=\"cursor:pointer; font-weight: bolder; text-decoration: underline;\">{{thread.title}}</span>\r\n              </div>\r\n              <!-- <label class=\"checkbox\" title=\"{{subent.title}}\">\r\n                            <input type=\"checkbox\" ng-model=\"selected.available[$index].selected\"> {{subent.title}}\r\n                        </label> -->\r\n            </li>\r\n          </ul>\r\n        </div>\r\n      </script>\r\n");
$templateCache.put("app/voterSignup/voterSignup.html","<head>\r\n<title>Voter Creation</title>\r\n<!-- This next line keeps buttons and forms at a legible size on cell phones -->\r\n<meta name=\"viewport\" content=\"initial-scale=1, maximum-scale=1\">\r\n</head>\r\n<!-- <div>\r\n<img class=\"votewise\" src=\"assets/images/votewiselogo.svg\"/></div>\r\n\r\n    <div> -->\r\n\r\n<div class=\"voter-signup\">\r\n\r\n\r\n<p align = left>\r\nIn order to match you with your local politicians, we need to know where you live. </p>\r\n\r\n<form>\r\nZip Code:<br>\r\n<input ng-model=\"user.zip\" type=\"number\" name=\"zip\"> <br>\r\n<button ng-click=\"findByZip( user )\">Submit</button>\r\n<div class={{zipClicked}}>\r\n  <br>County:<br>\r\n  <br/>{{counties}} <br>\r\n  <br />\r\n   Not your county? <input ng-model=\"user.county\" type=\"text\" name=\"county\">\r\n   <br />\r\n  <br>City:<br>\r\n  <select ng-model=\"user.city\">\r\n    <option ng-repeat=\"city in cities\">{{city}}</option>\r\n  </select>\r\n  <br />\r\n  <br />\r\n   City not listed? <input ng-model=\"user.city\" type=\"text\" name=\"city\">\r\n   <br />\r\n  <br>Street Address:<br>\r\n  <input ng-model=\"user.address\" type=\"text\" name=\"address\">\r\n  <br>\r\n  <br>Username: {{usernameMessage}}<br>\r\n\r\n  <input  ng-model=\"user.username\" type=\"text\" name=\"userName\"><br>\r\n  Password: {{passwordMessage}}<br>\r\n  <input  ng-model=\"user.password\" type=\"password\" name=\"psw\"> <br>\r\n\r\n  <br>\r\n    E-mail: {{emailMessage}}<br>\r\n    <input  ng-model=\"user.email\" type=\"email\" name=\"email\" />\r\n  </form>\r\n\r\n  <p>\r\n    {{errorMessages}}\r\n  </p>\r\n\r\n  </form>\r\n    <input type=\"checkbox\"/>Is all this information correct?\r\n    <br><br>\r\n    <button ng-click=\"signUp( user )\" >Submit</button>\r\n  </form>\r\n</div>\r\n</div>\r\n</div>\r\n");
$templateCache.put("app/voteSmart/votesmart.html","<div class=\"container-fluid ng-scope\" ng-cloak ng-show=\"$root.userRole==\'admin\'\">\r\n  <!-- This is the end of the header -->\r\n  <h2 class=\"pageHeading\">VoteSmart</h2>\r\n  <p>If you need to track down a call, you can find the list of all the votesmart calls at\r\n    <a href=\"http://api.votesmart.org/docs/Rating.html\" target=\"_blank\" class=\"ylink\">http://api.votesmart.org/docs/Rating.html</a>\r\n    <br>An example call is\r\n    <a href=\"http://api.votesmart.org/Rating.getSig?key=fdbde8c0a9f34ec9607eb83ecd246836&sigId=3001\" target=\"_blank\" class=\"ylink\">Here</a>\r\n    The area between the \"org/\" and the \"?key\" is for the call. The area after the \"&#38;\" is for type and specific. The\r\n    format is \"&#38;type=specific\". If there are multiple details, then all have \"&#38;type=x&#38;type=Y\". Sometimes NA\r\n    is an option for specifics.\r\n\r\n  </p>\r\nINCUMBENTS <br>\r\n	&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a ng-click=\"$root.cityData = !$root.cityData\" ng-class=\"{\'active\': $root.cityData}\" class=\"link\">City Incumbents&nbsp;|&nbsp;</a>\r\n	 <a ng-click=\"$root.local = !$root.local\" ng-class=\"{\'active\': $root.local}\" class=\"link\">County Incumbents&nbsp;|&nbsp;</a>\r\n	 <a ng-click=\"$root.incumbent = !$root.incumbent\" ng-class=\"{\'active\': $root.incumbent}\" class=\"link\">State and Federal Incumbent&nbsp;|&nbsp;</a><br>\r\n	ELECTION INFO<br>\r\n	<span style=\"color: darkorange;\">(WARNING: Hitting these will create new users and autoemail them if used with live back end)</span><br>\r\n  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a ng-click=\" $root.election = !$root.election\" ng-class=\"{\'active\': $root.election}\" class=\"link\">Election Data&nbsp;|&nbsp;</a>\r\n	<a ng-click=\"$root.presidentData = !$root.presidentData\" ng-class=\"{\'active\': $root.presidentData}\" class=\"link\">President Data&nbsp;|&nbsp;</a>\r\n  <a ng-click=\"$root.courage = !$root.courage\" ng-class=\"{\'active\': $root.courage}\" class=\"link\">Courage Data&nbsp;|&nbsp;</a>\r\n  <!-- <a ng-click=\"$root.CityCouncil = !$root.CityCouncil\" ng-class=\"{\'active\': $root.CityCouncil}\" class=\"link\">New York City Council&nbsp;|&nbsp;</a> -->\r\n  <!--<a ng-click=\"$root.withoutState = !$root.withoutState\" ng-class=\"{\'active\': $root.withoutState}\" class=\"link\">Get Incumbent&nbsp;|&nbsp;</a>  -->\r\n  <a href=\"#!/ballotMeasures\"  ng-click=\"$root.ballotMeasures = !$root.ballotMeasures\" ng-class=\"{\'active\': $root.ballotMeasures}\" class=\"link\" style=\"color:white\">Ballot Measures&nbsp;|&nbsp;</a><br>\r\n	ORGANIZATIONS<br>\r\n  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a ng-click=\"$root.catList = !$root.catList\" ng-class=\"{\'active\': $root.catList}\" class=\"link\">Get Category List&nbsp;|&nbsp;</a>\r\n  <a ng-click=\"$root.orgvList = !$root.orgvList\" ng-class=\"{\'active\': $root.orgvList}\" class=\"link\">Get List of Organizations&nbsp;|&nbsp;</a>\r\n\r\n  <form ng-if=\"$root.election\" name=\"election\" id=\"election\" ng-controller=\"votesmartCtrl\" class=\"closeForm\">\r\n    <div ng-if=\"!candidates\">\r\n      <div class=\"form-group row\" style=\"margin-top: 10px;\" ng-if=\"electionData\">\r\n        <p>\r\n          <h3>Election Data</h3>\r\n        </p>\r\n      </div>\r\n      <h2>Select State</h2>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label\" for=\"email\">State </label>\r\n        <div class=\"controls\">\r\n          <select class=\"changeTextColor\" ng-model=\"address.state\" style=\"text-transform: capitalize;\" ng-change=\"getElections()\" ng-options=\"item.state for item in allState track by item.state\"></select>&nbsp;\r\n          <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loader\"></i>\r\n        </div>\r\n      </div>\r\n      <div class=\"row table-responsive \" ng-if=\"ElectionData.length> 0\" style=\"margin-top: 10px;\">\r\n        <table class=\"table w100 changeTextColor\">\r\n          <tr>\r\n            <th>ElectionId</th>\r\n            <th>Name</th>\r\n            <th>ElectionYear</th>\r\n            <th>officeType</th>\r\n            <th style=\"width:25%\">Elections</th>\r\n            <th>Candidates Details</th>\r\n          </tr>\r\n          <tr ng-repeat=\"u in ElectionData | filter:getItems()\">\r\n            <td>\r\n              {{u.electionId}}\r\n            </td>\r\n            <td>\r\n              <a href=\"#!/publicProfile/{{u._id}}\" class=\"link\">{{u.name}}</a> \r\n            </td>\r\n            <td>\r\n              {{u.electionYear}}\r\n            </td>\r\n            <td>\r\n              <p ng-if=\"u.officeTypeId == \'L\'\">\r\n                State Legislative\r\n              </p>\r\n              <p ng-if=\"u.officeTypeId == \'P\'\">\r\n                President and Cabinet\r\n              </p>\r\n              <p ng-if=\"u.officeTypeId == \'C\'\">\r\n                Congress\r\n              </p>\r\n              <p ng-if=\"u.officeTypeId == \'G\'\">\r\n                Governor and Cabinet\r\n              </p>\r\n              <p ng-if=\"u.officeTypeId == \'S\'\">\r\n                Statewide\r\n              </p>\r\n              <p ng-if=\"u.officeTypeId == \'K\'\">\r\n                State Judicial\r\n              </p>\r\n              <p ng-if=\"u.officeTypeId == \'J\'\">\r\n                Federal Supreme Court\r\n              </p>\r\n              <p ng-if=\"u.officeTypeId == \'M\'\">\r\n                Local Executive Like Mayor or Equivalent\r\n              </p>\r\n              <p ng-if=\"u.officeTypeId == \'N\'\">\r\n                Local Legislative Like City Council or Equivalent\r\n              </p>\r\n              <p ng-if=\"u.officeTypeId == \'H\'\">\r\n                Local Judges\r\n              </p>\r\n              <!-- {{u.officeTypeId}} -->\r\n            </td>\r\n            <td>\r\n              <div ng-repeat=\"st in u.stage\" ng-if=\"st.electionDate >= today\">\r\n                <!-- {{st.electionDate}} -->\r\n                <p> <b>Date:</b> {{st.electionDate | date : \"y / MM / dd\"}}</p>\r\n                <p> <b>StageId:</b> {{st.electionElectionstageId}}</p>\r\n                <p> <b>Name:</b> {{st.name}}</p>\r\n              </div>\r\n            </td>\r\n            <td>\r\n              <a href=\"\" class=\"link\" ng-click=\"getCandidates(u.electionId)\">Display Candidates</a>\r\n            </td>\r\n          </tr>\r\n        </table>\r\n        <!-- <p ng-if=\"statusGetResPg == 1\" class=\"fwb\">Loading candidiates...</p> -->\r\n      </div>\r\n    </div>\r\n    <div ng-if=\"candidates\">\r\n      <h1>Candidates</h1>\r\n      <a href=\"\" class=\"ylink\" ng-click=\"back()\">Back</a>\r\n      <div class=\"row table-responsive \" ng-if=\"candidatesData.length> 0\" style=\"margin-top: 10px;\">\r\n        <table class=\"table w100 changeTextColor\">\r\n          <tr>\r\n            <th>CandidateId</th>\r\n            <th>Name</th>\r\n            <th>Party</th>\r\n            <th>ElectionStatus</th>\r\n          </tr>\r\n          <tr ng-repeat=\"u in candidatesData\">\r\n            <td>\r\n              <a href=\"http://api.votesmart.org/CandidateBio.getBio?key=fdbde8c0a9f34ec9607eb83ecd246836&candidateId={{u.votesmartCandidateId}}\" target=\"_blank\" class=\"link\">{{u.votesmartCandidateId}}</a>\r\n            </td>\r\n            <td>\r\n              <a href=\"#!/publicProfile/{{u._id}}\" class=\"link\">{{u.name}}</a> \r\n            </td>\r\n            <td>\r\n              {{u.party[0]}}\r\n            </td>\r\n            <td>\r\n              {{u.candidateStatus}}\r\n            </td>\r\n          </tr>\r\n        </table>\r\n        <p ng-if=\"statusGetResPg == 1\" class=\"fwb\">Loading candidiates...</p>\r\n      </div>\r\n    </div>\r\n  </form>\r\n  <form ng-if=\"$root.local\" name=\"local\" id=\"local\" ng-controller=\"votesmartLocalCtrl\" class=\"closeForm\">\r\n    <!-- <div ng-if=\"!candidates\"> -->\r\n    <div class=\"form-group row\" style=\"margin-top: 10px;\" ng-if=\"electionData\">\r\n      <p>\r\n        <h3> County Data</h3>\r\n      </p>\r\n    </div>\r\n    <h2>Select State</h2>\r\n    <div class=\"control-group\">\r\n      <label class=\"control-label\" for=\"email\">State </label>\r\n      <div class=\"controls\">\r\n        <select class=\"changeTextColor\" ng-model=\"address.state\" style=\"text-transform: capitalize;\" ng-change=\"getLocalData()\" ng-options=\"item.state for item in allState track by item.state\"></select>&nbsp;\r\n        <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loader\"></i>\r\n      </div>\r\n    </div>\r\n    <div class=\"row table-responsive \" ng-if=\"CountyData.length> 0\" style=\"margin-top: 10px;\">\r\n      <table class=\"table w100 changeTextColor\">\r\n        <tr>\r\n          <th>Name</th>\r\n          <th> County Name</th>\r\n          <th>ElectionYear</th>\r\n          <th>Party</th>\r\n          <th>User ID</th>\r\n          <th>Office</th>\r\n        </tr>\r\n        <tr ng-repeat=\"u in CountyData\">\r\n          <td>\r\n            <a href=\"#!/publicProfile/{{u._id}}\" class=\"link\">{{u.name}}</a> \r\n          </td>\r\n          <td>\r\n            {{u.countyName}}\r\n          </td>\r\n          <td>\r\n            {{u.electionYear}}\r\n          </td>\r\n          <td>\r\n            <div ng-if=\"u.party && u.party.length > 0\">{{u.party}}</div>\r\n            <div ng-if=\"u.party && u.party.length == 0\">N/A</div>\r\n          </td>\r\n          <td>\r\n           <a href=\"http://api.votesmart.org/CandidateBio.getBio?key=fdbde8c0a9f34ec9607eb83ecd246836&candidateId={{u.votesmartCandidateId}}\" target=\"_blank\" class=\"link\">{{u.votesmartCandidateId}}</a>\r\n          </td>\r\n          <td>\r\n            {{u.office}}\r\n          </td>\r\n        </tr>\r\n      </table>\r\n    </div>\r\n    <!-- </div> -->\r\n    <!-- </div> -->\r\n  </form>\r\n  <form ng-if=\"$root.cityData\" name=\"cityData\" id=\"cityData\" ng-controller=\"LocalCityCtrl\" class=\"closeForm\">\r\n    <!-- <div ng-if=\"!candidates\"> -->\r\n    <div class=\"form-group row\" style=\"margin-top: 10px;\" ng-if=\"electionData\">\r\n      <p>\r\n        <h3>City Data</h3>\r\n      </p>\r\n    </div>\r\n    <h2>Select State</h2>\r\n    <div class=\"control-group\">\r\n      <label class=\"control-label\" for=\"email\">State </label>\r\n      <div class=\"controls\">\r\n        <select class=\"changeTextColor\" ng-model=\"address.state\" style=\"text-transform: capitalize;\" ng-change=\"getLocalCity()\" ng-options=\"item.state for item in allState track by item.state\"></select>&nbsp;\r\n        <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loader\"></i>\r\n      </div>\r\n    </div>\r\n    <div class=\"row table-responsive \" ng-if=\"City.length> 0\" style=\"margin-top: 10px;\">\r\n      <table class=\"table w100 changeTextColor\">\r\n        <tr>\r\n          <th>Name</th>\r\n          <th> Place Name</th>\r\n          <th>ElectionYear</th>\r\n          <th>Party</th>\r\n          <th>user Id</th>\r\n          <th>Office</th>\r\n        </tr>\r\n        <tr ng-repeat=\"u in City track by $index\">\r\n          <td>\r\n            <a href=\"#!/publicProfile/{{u._id}}\" class=\"link\">{{u.name}}</a>\r\n          </td>\r\n          <td>\r\n            {{u.winDetails[0].placeName}}\r\n          </td>\r\n          <td>\r\n            {{u.electionYear}}\r\n          </td>\r\n          <td>\r\n            <div ng-if=\"u.party && u.party.length > 0\"> {{u.party}}</div>\r\n            <div ng-if=\"u.party.length == 0\"> N/A</div>\r\n          </td>\r\n          <td>\r\n            <a href=\"http://api.votesmart.org/CandidateBio.getBio?key=fdbde8c0a9f34ec9607eb83ecd246836&candidateId={{u.votesmartCandidateId}}\" target=\"_blank\" class=\"link\">{{u.votesmartCandidateId}}</a>\r\n          </td>\r\n          <td>\r\n            {{u.office}}\r\n          </td>\r\n        </tr>\r\n      </table>\r\n    </div>\r\n  </form>\r\n  <form ng-if=\"$root.courage\" name=\"courage\" id=\"courage\" ng-controller=\"CourageTest\" class=\"closeForm\">\r\n    <div ng-if=\"!Test && !candy\">\r\n      <div class=\"form-group row\" style=\"margin-top: 10px;\" ng-if=\"electionData\">\r\n        <p>\r\n          <h3>City Data</h3>\r\n        </p>\r\n      </div>\r\n      <h2>Select State</h2>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label\" for=\"email\">State </label>\r\n        <div class=\"controls\">\r\n          <select class=\"changeTextColor\" ng-model=\"address.state\" style=\"text-transform: capitalize;\" ng-change=\"getCourageData()\" ng-options=\"item.state for item in allState track by item.state\"></select>&nbsp;\r\n          <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loader\"></i>\r\n        </div>\r\n      </div>\r\n      <div class=\"row table-responsive \" ng-if=\"courageResult.length> 0\" style=\"margin-top: 10px;\">\r\n        <a href=\"\" class=\"ylink\" ng-click=\"getCourTest();\">View All Questions</a>\r\n        <a href=\"\" class=\"ylink\" ng-click=\"exportCourage();\">Export Courage Data</a>\r\n        <br>\r\n        <div class=\"control-group\" style=\"padding:5px;\">\r\n          <label class=\"control-label\" for=\"upload-file\">\r\n            <strong>Select csv File : </strong>\r\n          </label>\r\n          <input type=\"file\" file-model=\"upload.files\" class=\"form-control input-md text-input\" accept=\".xlsx\">\r\n        </div>\r\n          <div class=\"control-group\" style=\"padding-left:20px;\">\r\n            <button ng-click=\"importCourage(upload)\" type=\"submit\" class=\"btnShort-style\" style=\"float: left;\">Save</button>&nbsp;\r\n            <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"import\"></i>\r\n            <!--<fb:login-button scope=\"public_profile,email\" onlogin=\"checkLoginState();\"></fb:login-button>-->\r\n            <div style=\"clear: both;\"></div>\r\n          </div>\r\n          <div style=\"clear: both;\"></div>\r\n          <br>\r\n          <table class=\"table w100 changeTextColor\">\r\n            <tr>\r\n              <th>Name</th>\r\n              <!-- <th> Place Name</th> -->\r\n              <th>ElectionYear</th>\r\n              <th>Party</th>\r\n              <th>user Id</th>\r\n              <th>Office</th>\r\n              <th>CourageTest</th>\r\n            </tr>\r\n            <tr ng-repeat=\"u in courageResult\">\r\n              <td>\r\n                <a href=\"#!/publicProfile/{{u._id}}\" class=\"link\">{{u.name}}</a> \r\n              </td>\r\n              <!-- <td>\r\n               {{u.winDetails[0].placeName}}\r\n            </td> -->\r\n              <td>\r\n                {{u.electionYear}}\r\n              </td>\r\n              <td>\r\n                {{u.party}}\r\n              </td>\r\n              <td>\r\n                <a href=\"http://api.votesmart.org/Npat.getNpat?key=fdbde8c0a9f34ec9607eb83ecd246836&candidateId={{u.votesmartCandidateId}}\" target=\"_blank\">{{u.votesmartCandidateId}}</a>\r\n              </td>\r\n              <td>\r\n                {{u.office}}\r\n              </td>\r\n              <td>\r\n                <a href=\"\" class=\"link\" ng-click=\"getTst(u);\">View Data</a>\r\n              </td>\r\n            </tr>\r\n          </table>\r\n        </div>\r\n      </div>\r\n      <div ng-if=\"Test\">\r\n        <h1>Courage</h1>\r\n        <a href=\"\" class=\"ylink\" ng-click=\"backto()\">Back</a>\r\n        <!-- <div infinite-scroll=\'myPagingFunction()\'> -->\r\n        <div class=\"row table-responsive \" ng-if=\"TstData.length > 0\" style=\"margin-top: 10px;\">\r\n          <div class=\"alert alert-success alert-dismissible\" id=\"alert\" ng-if=\"success_msg\" style=\"width:40%;margin-left:\r\n            28%;margin-top:10%\">\r\n            <button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button>\r\n            <strong>Question Added successfully into fiveMatch</strong>\r\n          </div>\r\n          <div class=\"alert alert-success alert-dismissible\" id=\"alert\" ng-if=\"success_msg1\" style=\"width:40%;margin-left:\r\n            28%;margin-top:10%\">\r\n            <button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button>\r\n            <strong>Removed Successfullly</strong>\r\n          </div>\r\n          <table class=\"table w100 changeTextColor\">\r\n            <tr>\r\n              <th>Questions</th>\r\n              <!-- <th>Name</th> -->\r\n            </tr>\r\n            <tr ng-repeat=\"u in TstData track by $index\">\r\n              <td>\r\n                <div>\r\n                  <b>Category:</b> {{u.category}}\r\n                  <div>\r\n                    <div>\r\n                      <b>Questions:</b> {{u.question}}\r\n                      <div>\r\n                        <br>\r\n                        <!--    <div class=\"form-group row\">\r\n                        <label for=\"showInMatch\" class=\"col-lg-2 col-sm-5 col-form-label\">Show In FiveMatch : </label>\r\n                        <div class=\"col-lg-5 col-sm-5\">\r\n                          <select ng-model=\"fiveMatch.match[u._id]\" ng-init=\"fiveMatch.match[u._id]=u.fiveMatchQue\" class=\"form-control\" ng-change=\"getMatchData(u)\" style=\"width:170px;\">\r\n                            <option value=\"\" selected>Select</option>\r\n                            <option value=\"Yes\">Yes</option>\r\n                            <option value=\"No\">No</option>\r\n                          </select>\r\n                        </div>\r\n                      </div> -->\r\n                        <div class=\"clearfix\">\r\n                          <div class=\"formLabel\">Select category: </div>\r\n                          <!-- <p class=\"fwb\" ng-if=\"statusGetCats == 1\">Loading categories ...</p> -->\r\n                          <div ng-show=\"statusGetCats == 2\" ng-repeat=\"cat in selCatForQues\" class=\"pull-left\"\r\n                            style=\"padding: 5px;\">\r\n                            <select class=\"pull-left changeTextColor\" ng-model=\"cat.selected[u._id]\" ng-change=\"selQuesCategory(cat.selected, $index,u)\">\r\n                            <option ng-repeat=\"item in cat.items\" value={{item}}>\r\n                              {{item.order}}) {{item.title}}\r\n                            </option>\r\n                          </select>\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                      <div ng-if=\"showtbl[u._id] && tbl.length> 0\">\r\n                        <table>\r\n                          <tr>\r\n                            <th>\r\n                              Questions\r\n                            </th>\r\n                            <th>\r\n                              Match\r\n                            </th>\r\n                          </tr>\r\n                          <tr ng-repeat=\"t in tbl\">\r\n                            <td>{{t.content}}</td>\r\n                            <td>\r\n                              <a href=\"\" ng-if=\"exist(u.QueId,t._id)\" class=\"link\" ng-click=\"addToFiveMatch(t,u,\'\',$parent.$parent.$index);\">Add</a>\r\n                              <a href=\"\" ng-if=\" !exist(u.QueId,t._id)\" class=\"link\" ng-click=\"addToFiveMatch(t,u,\'remove\',$parent.$parent.$index);\">Remove</a>\r\n                            </td>\r\n                          </tr>\r\n                        </table>\r\n                        <!-- <a href=\"\" class=\"link\" ng-click=\"showLess(u._id)\">Less</a> -->\r\n                      </div>\r\n                      <!-- <button ng-click=\"getFiveMatchQue()\" style=\"width: 125px\" type=\"submit\" class=\"btnShort-style\">Questions</button> -->\r\n              </td>\r\n            </tr>\r\n            <!-- <tr ng-repeat=\"u in TstData\">\r\n              <td style=\"text-align:left;\">\r\n                  <div ng-if=\"u.section\" ng-repeat=\"st in u.section\">\r\n                     <b>Category:</b>    {{st.name}}\r\n\r\n                 <div>\r\n                    <a href=\"\" class=\"link\" ng-if=\"!more[st.name]\" ng-click=\"getQuestion(st.name);\">Question:</a>\r\n                 </div>\r\n\r\n                       <div  ng-if=\"more[st.name]\">\r\n                          <h4 style=\"padding-left:15px\">{{st.row.rowText}}</h4>\r\n                          <b>Answer:</b>\r\n\r\n                          <h6 ng-if=\"st.row.open == \'f\'\">Yes</h6>\r\n                          <h6 ng-if=\"st.row.open == \'t\' && \'\' \">No</h6>\r\n\r\n                                  <b>Options:</b>\r\n                            <div class=\"form-group\" ng-repeat=\"ttest in st.row.row\">\r\n\r\n\r\n                                <h6 style=\"padding-left:15px\">{{ttest.rowText}}</h6>\r\n\r\n                         <div style=\"padding-left:15px\">\r\n                            <b>Answer:</b>\r\n                            <h6 ng-if=\"ttest.open == \'f\'\">Yes</h6>\r\n                            <h6 ng-if=\"ttest.open == \'t\' && \'\' \">No</h6>\r\n\r\n                         </div>\r\n\r\n                            </div>\r\n                            <a href=\"\" ng-if=\"more[st.name]\" class=\"link\" ng-click=\"showLess(st.name)\">Less</a>\r\n\r\n                       </div>\r\n\r\n                    </div>\r\n\r\n                    <div ng-if=\"u.section == \'\' \">\r\n\r\n                        <b>SurveyMessage:</b>    {{u.surveyMessage}}\r\n                   </div>\r\n\r\n              </td>\r\n\r\n            </tr> -->\r\n          </table>\r\n        </div>\r\n        <!--   <p ng-if=\"statusGetResPg == 0\" class=\"fwb\">Loading Questions...</p>\r\n        </div> -->\r\n      </div>\r\n      <div ng-if=\"candy\">\r\n        <a href=\"\" class=\"ylink\" ng-click=\"backto()\">Back</a>\r\n        <div class=\"alert alert-success alert-dismissible\" id=\"alert\" ng-if=\"NotFound\" style=\"width:40%;margin-left:\r\n            28%;margin-top:10%\">\r\n          <button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button>\r\n          <strong>Data Not Found</strong>\r\n        </div>\r\n        <div class=\"form-group row\" style=\"color:#ffffff;display:block;text-align:center;\">\r\n          <p>\r\n            <h3>{{name}}</h3>\r\n          </p>\r\n          <p> {{party}}\r\n          </p>\r\n        </div>\r\n        <table class=\"table w100 changeTextColor\" ng-if=\"testy.length > 0 \">\r\n          <tr>\r\n            <th>Questions</th>\r\n          </tr>\r\n          <tr ng-repeat=\"y in testy\">\r\n            <td style=\"text-align:left;\">\r\n              <div>\r\n                <b>Category:</b> {{y.question_id.category}}\r\n                <div>\r\n                  <a href=\"\" class=\"link\" ng-if=\"!more[y.question_id._id]\" ng-click=\"getQuestion(y.question_id._id);\">Question:</a>\r\n                </div>\r\n                <div ng-if=\"more[y.question_id._id]\">\r\n                  <h5 style=\"padding-left:15px\">{{y.question_id.question}}</h5>\r\n                  <b ng-if=\"y.optionAns.length >0\">Options:</b>\r\n                  <div class=\"form-group\" ng-repeat=\"d in y.optionAns\">\r\n                    <h6 style=\"padding-left:15px\" ng-if=\"y.optionAns\">{{d.rowText}}</h6>\r\n                    <h6 style=\"padding-left:15px\" ng-if=\"y.optionAns\"> <b>Answer:</b> {{d.optionText}}</h6>\r\n                  </div>\r\n                  <h6 ng-if=\"y.answer\"> <b>Answer:</b> {{y.answer}}</h6>\r\n                  <h6 ng-if=\"y.answer_descriptive\"> <b>Answer:</b> {{y.answer_descriptive}}</h6>\r\n                  <a href=\"\" ng-if=\"more[y.question_id._id]\" class=\"link\" ng-click=\"showLess(y.question_id._id)\">Less</a>\r\n                </div>\r\n            </td>\r\n          </tr>\r\n        </table>\r\n      </div>\r\n  </form>\r\n  <form ng-if=\"$root.incumbent\" name=\"incumbent\" id=\"incumbent\" ng-controller=\"votesmartIncumbentCtrl\"\r\n    class=\"closeForm\">\r\n    <div ng-if=\"!candidates\">\r\n      <div class=\"form-group row\" style=\"margin-top: 10px;\">\r\n        <h3>Incumbent Data</h3>\r\n      </div>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label\" for=\"email\">Select State </label>\r\n        <div class=\"controls\">\r\n          <select class=\"changeTextColor\" ng-model=\"address.state\" style=\"text-transform: capitalize;\" ng-change=\"getIncumbent()\" ng-options=\"item.state for item in allState track by item.state\"></select>&nbsp;\r\n          <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loader\"></i>\r\n        </div>\r\n      </div>\r\n      <div class=\"row table-responsive \" ng-if=\"ElectionData.length> 0\" style=\"margin-top: 10px;\">\r\n        Records added successfully. Now you can check them in the incumbent list.\r\n        <!-- <p ng-if=\"statusGetResPg == 1\" class=\"fwb\">Loading candidiates...</p> -->\r\n      </div>\r\n    </div>\r\n    <div ng-if=\"candidates\">\r\n      <h1>Candidates</h1>\r\n      <a href=\"\" class=\"ylink\" ng-click=\"back()\">Back</a>\r\n      <div class=\"row table-responsive \" ng-if=\"candidatesData.length> 0\" style=\"margin-top: 10px;\">\r\n        <table class=\"table w100 changeTextColor\">\r\n          <tr>\r\n            <th>CandidateId</th>\r\n            <th>Name</th>\r\n            <th>Party</th>\r\n            <th>ElectionStatus</th>\r\n          </tr>\r\n          <tr ng-repeat=\"u in candidatesData\">\r\n            <td>\r\n              <a href=\"http://api.votesmart.org/CandidateBio.getBio?key=fdbde8c0a9f34ec9607eb83ecd246836&candidateId={{u.votesmartCandidateId}}\" target=\"_blank\" class=\"link\">{{u.votesmartCandidateId}}</a>\r\n            </td>\r\n            <td>\r\n              <a href=\"#!/publicProfile/{{u._id}}\" class=\"link\">{{u.name}}</a> \r\n            </td>\r\n            <td>\r\n              {{u.party}}\r\n            </td>\r\n            <td>\r\n              {{u.candidateStatus}}\r\n            </td>\r\n          </tr>\r\n        </table>\r\n        <p ng-if=\"statusGetResPg == 1\" class=\"fwb\">Loading candidiates...</p>\r\n      </div>\r\n    </div>\r\n  </form>\r\n  <form ng-if=\"$root.withoutState\" name=\"withoutState\" id=\"withoutState\" ng-controller=\"votesmartWithoutState\"\r\n    class=\"closeForm\">\r\n    <div ng-if=\"!candidates\">\r\n      <div class=\"form-group row\" style=\"margin-top: 10px;\">\r\n        <h3>Get Data</h3>\r\n      </div>\r\n      <a href=\"\" class=\"ylink\" ng-click=\"getWithoutState()\">Pull Data</a>\r\n      <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loader\"></i>\r\n    </div>\r\n    <div ng-if=\"candidates\">\r\n      <h1>Candidates</h1>\r\n      <a href=\"\" class=\"ylink\" ng-click=\"back()\">Back</a>\r\n      <div class=\"row table-responsive \" ng-if=\"without.length> 0\" style=\"margin-top: 10px;\">\r\n        <table class=\"table w100 changeTextColor\">\r\n          <tr>\r\n            <th>CandidateId</th>\r\n            <th>Name</th>\r\n            <th>Party</th>\r\n\r\n          </tr>\r\n\r\n          <tr ng-repeat=\"u in without\">\r\n\r\n            <td>\r\n              <a href=\"http://api.votesmart.org/CandidateBio.getBio?key=fdbde8c0a9f34ec9607eb83ecd246836&candidateId={{u.votesmartCandidateId}}\" target=\"_blank\" class=\"link\">{{u.votesmartCandidateId}}</a>\r\n            </td>\r\n            <td>\r\n              <a href=\"#!/publicProfile/{{u._id}}\" class=\"link\">{{u.name}}</a> \r\n            </td>\r\n            <td>\r\n              {{u.party[0]}}\r\n            </td>\r\n\r\n          </tr>\r\n        </table>\r\n        <p ng-if=\"statusGetResPg == 1\" class=\"fwb\">Loading candidiates...</p>\r\n      </div>\r\n    </div>\r\n  </form>\r\n  <!-- <form ng-if=\"$root.CityCouncil\" name=\"CityCouncil\" id=\"CityCouncil\" ng-controller=\"votesmartCityCouncil\"\r\n    class=\"closeForm\">\r\n    <div ng-if=\"!candidates\">\r\n      <div class=\"form-group row\" style=\"margin-top: 10px;\">\r\n        <h3>City Data</h3>\r\n      </div>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label\" for=\"email\">Select State </label>\r\n        <div class=\"controls\">\r\n          <select class=\"changeTextColor\" ng-model=\"address.state\" style=\"text-transform: capitalize;\" ng-change=\"getCityCouncil()\" ng-options=\"item.state for item in allState track by item.state\"></select>&nbsp;\r\n          <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loader\"></i>\r\n        </div>\r\n      </div>\r\n      <div class=\"row table-responsive \" ng-if=\"citysd.length> 0\" style=\"margin-top: 10px;\">\r\n        Records added successfully. Now you can check them in the incumbent list.\r\n        <p ng-if=\"statusGetResPg == 1\" class=\"fwb\">Loading candidiates...</p>\r\n      </div>\r\n    </div>\r\n    <div ng-if=\"candidates\">\r\n      <h1>Candidates</h1>\r\n      <a href=\"\" class=\"ylink\" ng-click=\"back()\">Back</a>\r\n      <div class=\"row table-responsive \" ng-if=\"citysd.length> 0\" style=\"margin-top: 10px;\">\r\n        <table class=\"table w100 changeTextColor\">\r\n          <tr>\r\n            <th>CandidateId</th>\r\n            <th>Name</th>\r\n            <th>Party</th>\r\n            <th>DistrictId</th>\r\n          </tr>\r\n          <tr ng-repeat=\"u in citysd\">\r\n            <td>\r\n              {{u.votesmartCandidateId}}\r\n            </td>\r\n            <td>\r\n              <a href=\"#!/publicProfile/{{u._id}}\" class=\"link\">{{u.name}}</a> \r\n            </td>\r\n            <td>\r\n              {{u.party}}\r\n            </td>\r\n            <td>\r\n              {{u.districtId}}\r\n            </td>\r\n          </tr>\r\n        </table>\r\n        <p ng-if=\"statusGetResPg == 1\" class=\"fwb\">Loading candidiates...</p>\r\n      </div>\r\n    </div>\r\n  </form> -->\r\n  <form ng-if=\"$root.presidentData\" name=\"presidentData\" id=\"presidentData\" ng-controller=\"votesmartCtrl\"\r\n    class=\"closeForm\">\r\n    <div ng-if=\"!candidates\">\r\n      <div class=\"form-group row\" style=\"margin-top: 10px;\" ng-if=\"electionData\">\r\n        <p>\r\n          <h3>Presidential Data</h3>\r\n        </p>\r\n      </div>\r\n\r\n      <div class=\"control-group\">\r\n\r\n        <div class=\"controls\">\r\n          <h2>Select State</h2>\r\n          <div class=\"control-group\">\r\n            <label class=\"control-label\" for=\"email\">State </label>\r\n            <div class=\"controls\">\r\n              <select class=\"changeTextColor\" ng-model=\"address.state\" style=\"text-transform: capitalize;\" ng-change=\"getPrimaryElections()\" ng-options=\"item.state for item in allState track by item.state\"></select>&nbsp;\r\n\r\n              <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"showLoader\"></i>\r\n            </div>\r\n          </div>\r\n          <br>\r\n          <!-- <a href=\"\" ng-click=\"getPresidentData()\" class=\"ylink\">Get President Data</a> -->\r\n          <!-- &nbsp; -->\r\n        </div>\r\n      </div>\r\n      <div class=\"row table-responsive \" ng-if=\"ElectionData.length> 0\" style=\"margin-top: 10px;\">\r\n        <table class=\"table w100 changeTextColor\">\r\n          <tr>\r\n            <th>ElectionId</th>\r\n            <th>Name</th>\r\n            <th>ElectionYear</th>\r\n            <th>officeType</th>\r\n            <th style=\"width:25%\">Elections</th>\r\n            <th>Candidates Details</th>\r\n          </tr>\r\n          <tr ng-repeat=\"u in ElectionData | filter:getItems()\">\r\n            <td>\r\n              {{u.electionId}}\r\n            </td>\r\n            <td>\r\n              <a href=\"#!/publicProfile/{{u._id}}\" class=\"link\">{{u.name}}</a> \r\n            </td>\r\n            <td>\r\n              {{u.electionYear}}\r\n            </td>\r\n            <td>\r\n              <p ng-if=\"u.officeTypeId == \'L\'\">\r\n                State Legislative\r\n              </p>\r\n              <p ng-if=\"u.officeTypeId == \'P\'\">\r\n                President and Cabinet\r\n              </p>\r\n              <p ng-if=\"u.officeTypeId == \'C\'\">\r\n                Congress\r\n              </p>\r\n              <p ng-if=\"u.officeTypeId == \'G\'\">\r\n                Governor and Cabinet\r\n              </p>\r\n              <p ng-if=\"u.officeTypeId == \'S\'\">\r\n                Statewide\r\n              </p>\r\n              <p ng-if=\"u.officeTypeId == \'K\'\">\r\n                State Judicial\r\n              </p>\r\n              <p ng-if=\"u.officeTypeId == \'J\'\">\r\n                Federal Supreme Court\r\n              </p>\r\n              <p ng-if=\"u.officeTypeId == \'M\'\">\r\n                Local Executive Like Mayor or Equivalent\r\n              </p>\r\n              <p ng-if=\"u.officeTypeId == \'N\'\">\r\n                Local Legislative Like City Council or Equivalent\r\n              </p>\r\n              <p ng-if=\"u.officeTypeId == \'H\'\">\r\n                Local Judges\r\n              </p>\r\n              <!-- {{u.officeTypeId}} -->\r\n            </td>\r\n            <td>\r\n              <div ng-repeat=\"st in u.stage\" ng-if=\"st.electionDate >= today\">\r\n                <!-- {{st.electionDate}} -->\r\n                <p> <b>Date:</b> {{st.electionDate | date : \"y / MM / dd\"}}</p>\r\n                <p> <b>StageId:</b> {{st.electionElectionstageId}}</p>\r\n                <p> <b>Name:</b> {{st.name}}</p>\r\n              </div>\r\n            </td>\r\n            <td>\r\n              <a href=\"\" class=\"link\" ng-click=\"getCandidates(u.electionId)\">Display Candidates</a>\r\n            </td>\r\n          </tr>\r\n        </table>\r\n        <!-- <p ng-if=\"statusGetResPg == 1\" class=\"fwb\">Loading candidiates...</p> -->\r\n      </div>\r\n    </div>\r\n    <div ng-if=\"candidates\">\r\n      <h1>Candidates</h1>\r\n      <a href=\"\" class=\"ylink\" ng-click=\"back()\">Back</a>\r\n      <div class=\"row table-responsive \" ng-if=\"candidatesData.length> 0\" style=\"margin-top: 10px;\">\r\n        <table class=\"table w100 changeTextColor\">\r\n          <tr>\r\n            <th>CandidateId</th>\r\n            <th>Name</th>\r\n            <th>Party</th>\r\n            <th>ElectionStatus</th>\r\n          </tr>\r\n          <tr ng-repeat=\"u in candidatesData\">\r\n            <td>\r\n             <a href=\"http://api.votesmart.org/CandidateBio.getBio?key=fdbde8c0a9f34ec9607eb83ecd246836&candidateId={{u.votesmartCandidateId}}\" target=\"_blank\" class=\"link\">{{u.votesmartCandidateId}}</a>\r\n            </td>\r\n            <td>\r\n              <a href=\"#!/publicProfile/{{u._id}}\" class=\"link\">{{u.name}}</a> \r\n            </td>\r\n            <td>\r\n              {{u.party[0]}}\r\n            </td>\r\n            <td>\r\n              {{u.candidateStatus}}\r\n            </td>\r\n          </tr>\r\n        </table>\r\n        <p ng-if=\"statusGetResPg == 1\" class=\"fwb\">Loading candidiates...</p>\r\n      </div>\r\n    </div>\r\n  </form>\r\n  <form ng-if=\"$root.catList\" name=\"catList\" id=\"catList\" ng-controller=\"orgCatCtrl\" class=\"closeForm\">\r\n    <div ng-if=\"!candidates\">\r\n      <div class=\"form-group row\" style=\"margin-top: 10px;\">\r\n        <p>\r\n          <h3>Get Category List</h3>\r\n        </p>\r\n      </div>\r\n      <h2>Select State</h2>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label\" for=\"email\">State </label>\r\n        <div class=\"controls\">\r\n          <select class=\"changeTextColor\" ng-model=\"address.state\" style=\"text-transform: capitalize;\" ng-change=\"getReviewCategory()\" ng-options=\"item.state for item in allState track by item.state\"></select>&nbsp;\r\n          <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loader\"></i>\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n  </form>\r\n  <form ng-if=\"$root.orgvList\" name=\"orgvList\" id=\"orgvList\" ng-controller=\"orgListCtrl\" class=\"closeForm\">\r\n    <div>\r\n      <div class=\"form-group row\" style=\"margin-top: 10px;\">\r\n        <p>\r\n          <h3>Get Organizations List</h3>\r\n        </p>\r\n      </div>\r\n      <h2>Select State</h2>\r\n      <div class=\"control-group\">\r\n        <label class=\"control-label\" for=\"email\">State </label>\r\n        <div class=\"controls\">\r\n          <select class=\"changeTextColor\" ng-model=\"address.state\" style=\"text-transform: capitalize;\" ng-change=\"getOrgList()\" ng-options=\"item.state for item in allState track by item.state\"></select>&nbsp;\r\n          <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\" ng-if=\"loader\"></i>\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n  </form>\r\n</div>\r\n</div>\r\n");
$templateCache.put("app/votingRecords/votingRecords.html","<div class=\"container-fluid\">\r\n    <p class=\"fwb\" ng-if=\"statusGetData == 1\">Loading profile data...</p>\r\n    \r\n    <h2 class=\"pageHeading\">{{userProfile.name}}</h2>\r\n    <h2 class=\"pageHeading\">VOTING RECORD </h2>\r\n<br><br>\r\n<div class=\"contactBlock d-flex justify-center container-fluid col-sm-12 col-lg-7\">\r\n<center>\r\n    <br><br>\r\n    <h2>{{memberName}}</h2>\r\n  </center>\r\n  <div style=\"padding:20px;\">\r\n \r\n   <center> <div>Last {{votingRecords.num_results}} votes</div></center>\r\n      <br>\r\n\r\n    <div ng-repeat=\"vote in votingRecords.votes track by $index\">\r\n      <div>Bill ID: {{vote.bill.bill_id}}</div>\r\n      <!--<div>Number : {{vote.bill.number}}</div>-->\r\n      <div>Title: {{vote.bill.title}}</div>\r\n      <div>{{userProfile.name}} Voted: {{vote.position}}</div>\r\n    <!--  <input type=\"button\" value=\"Show Details\" ng-click=\"$parent.selectedIndex=$index\" class=\"changeTextColor\">\r\n      <div ng-show=\"$parent.selectedIndex == $index\">\r\n      <p>Chamber : {{vote.chamber}}</p>\r\n      <p>Congress : {{vote.congress}}</p>\r\n      <p>Session : {{vote.session}}</p>  -->\r\n      <div class=\"removeBold\">Roll Call: {{vote.roll_call}}</div>  \r\n      <div class=\"removeBold\">Latest Action: {{vote.bill.latest_action}}</div>\r\n      <div>Description: {{vote.description}}</div>\r\n      <div>Question: {{vote.question}}</div>\r\n      <div>Result: {{vote.result}}</div>\r\n      <div class=\"removeBold\">Date: {{vote.date}}</div>\r\n      <div class=\"removeBold\">Time: {{vote.time}}</div>\r\n      <div class=\"removeBold\">{{vote.total.yes}} People Voted Yes</div>\r\n      <div class=\"removeBold\">{{vote.total.no}} People Voted No</div>\r\n     <!-- <div class=\"removeBold\">{{vote.total.present}} People were present</div> -->\r\n      <div class=\"removeBold\">{{vote.total.not_voting}} People Did not vote.</div> \r\n       <br> <hr style=\"border-top: 1px solid #222;\"/><br>\r\n      </div>\r\n      \r\n    </div>\r\n  </div>\r\n <p>\r\n    \r\n       <a href=\"https://www.propublica.org/\" target=\"_blank\">\r\n                    <image src=\"../assets/images/logo-propublica.svg\" class=\"partners\"></image></a>\r\n                           \r\n                <a href=\"https://openstates.org/\" target=\"_blank\">\r\n                    <image src=\"../assets/images/openstates_logo.d5ae3c5f606e.svg\" class=\"partners\"></image></a> \r\n       <a href=\"https://www.loc.gov/\" target=\"_blank\">\r\n                    <image src=\"../assets/images/LibraryOfCongressLogo.svg\" class=\"partners\"></image></a>\r\n                        \r\n                \r\n                </p> \r\n    <p>Voting information is provided in part by Propublica, OpenStates, and the Library of Congress</p>\r\n");
$templateCache.put("app/welcomeView/welcomeView.html","\r\n<div class=\"container-fluid\">\r\n	<!--DESKTOP VIEW-->\r\n	\r\n	<!-- ERASE THIS WHEN THE SITE IS BACK UP  START VVVVVVVV -->\r\n		<div id=\"blockInfoLearn1\" style=\"background-color: yellow; border-color: red;\">\r\n            <div>\r\n      \r\n													<h4 class=\"blockTitleLearn\" >VOTEWISE WON\'T BE COVERING ANY ELECTIONS THIS YEAR:</h4>\r\n              <span class=\"blockDesc\">				 We are using this year\'s budget to increase the security of the site to ensure safer elections in the future.  The faster we get money to cover this, the faster we can get back to covering elections. <br><br>Feel free to continue to use the NEWS section to read news from different sources from all over the world.\r\n															<br><br>\r\n															<div class=\"col-sm-6 col-lg-2\" style=\"text-align:center;\">\r\n            <a href=\"#!/donate\">\r\n                <button type=\"button\" class=\"donateBtn btn float-lg-right\">Donate</button>\r\n              </a>\r\n          </div>\r\n			<!-- ERASE THIS WHEN THE SITE IS BACK UP  END   ^^^^^^^^^^  -->												\r\n															\r\n															\r\n  <div class=\"welcomeSection1 jumbotron d-none d-lg-block\">\r\n			\r\n			\r\n			\r\n			\r\n    <div class=\"row\">\r\n      <div class=\"col-lg-6\">\r\n      </div>\r\n					\r\n					\r\n      <div class=\"col-lg-6\">\r\n        <div><img ng-src=\"./assets/images/votewiselogoBlackwWhiteNew.svg\" class=\"img-fluid\"></div>\r\n          <div class=\"row\">\r\n											\r\n											\r\n											\r\n            <div class=\"col-lg-2\"></div>\r\n            <div class=\"col-lg-8 blackText\">\r\n              <b>Where voters and politicians can connect without advertising dollars getting in the way.  <br><br><center>Non-profit.    Non-partisan.</center></b>\r\n              <br>\r\n              <a href=\"#!/upcomingElection\">\r\n                  <div class=\"yBtn\"><center><b>Get Ready to Vote</b></center></div></a>\r\n              <br><br>\r\n              <a href=\"#!/takeAction\">\r\n                  <div class=\"yBtn\"><center><b>Take Action</b></center></div></a>\r\n            </div>\r\n\r\n          </div>\r\n          <div class=\"col-lg-2\"></div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n	\r\n\r\n	\r\n	<div class=\"welcomeSection2 jumbotron d-none d-lg-block\">\r\n    <div class=\"row\">\r\n					<div class=\"col-lg-6\">\r\n						<div id=\"blockInfoLearn1\">\r\n            <div>\r\n      \r\n													<h4 class=\"blockTitleLearn\" >WHAT IS VOTEWISE?</h4>\r\n              <span class=\"blockDesc\">VoteWise is  a non-partisan non-profit website that connects voters, organizations and politicians without advertising dollars getting in the way.  Our goal is to depolarize politics and make it easier for communities to find common ground and the tools they need to identify problems, find sustainable solutions that work for all, and put those solutions into action.<br><br>\r\n\r\nAn effective democracy requires the active participation of voters, politicians, the press, and the organizations that dedicate their lives to the issues they care about.  Sometimes this means making changes to legislation and sometimes this means more hands-on action.  Either way, it requires year-round teamwork.  We want to make it easier for everyone.<br> <br>\r\n\r\nWe have different tools available to different types of users to make their jobs easier.  Click on the videos below to learn more.\r\n</span>\r\n				\r\n            </div>\r\n          </div>\r\n					</div>\r\n    <!--  <div class=\"col-lg-6\">\r\n      </div>\r\n      <div class=\"col-lg-6\">\r\n        <div><img ng-src=\"./assets/images/votewiselogoBlackwWhiteNew.svg\" class=\"img-fluid\"></div>\r\n          <div class=\"row\">\r\n            <div class=\"col-lg-2\"></div>\r\n            <div class=\"col-lg-8 blackText\">\r\n              <b>Where voters and politicians can connect without advertising dollars getting in the way.  <br><br><center>Non-profit.    Non-partisan.</center></b>\r\n              <br>\r\n              <a href=\"#!/upcomingElection\">\r\n                  <div class=\"yBtn\"><center><b>Get Ready to Vote</b></center></div></a>\r\n              <br><br>\r\n              <a href=\"#!/takeAction\">\r\n                  <div class=\"yBtn\"><center><b>Take Action</b></center></div></a>\r\n            </div>\r\n\r\n          </div>\r\n          <div class=\"col-lg-2\"></div>\r\n        </div>-->\r\n      </div>\r\n    </div>\r\n	\r\n	<!--CELL PHONE VIEW-->\r\n    <div class=\"welcomeSection1Small jumbotron d-lg-none\">\r\n      <div class=\"row justify-content-end\" >\r\n        <div class=\"col col-7 topPaddingSmall\" >\r\n          <img ng-src=\"./assets/images/votewiselogoBlackwWhiteNew.svg\" class=\"img-fluid\"></div>\r\n        </div>\r\n        <div class=\"row justify-content-end\">\r\n											\r\n							\r\n          <div class=\"col col-6 blackText\">\r\n            <b>Where voters and politicians can connect without advertising dollars getting in the way.  <br><br><center><span>Non-profit. </span>  <span> Non-partisan.</span></center></b><br>\r\n            <a href=\"#!/upcomingElection\">\r\n                  <div class=\"ycompareBtn\"><center><b>Get Ready to Vote</b></center></div></a>\r\n            <br>\r\n            <a href=\"#!/takeAction\">\r\n                  <div class=\"ycompareBtn\"><center><b>Take Action</b></center></div></a></div>\r\n        </div>\r\n      </div>\r\n\r\n	<div class=\"welcomeSection2 jumbotron  d-lg-none\">\r\n    <div class=\"row\">\r\n					<div class=\"col-lg-6\">\r\n						<div id=\"blockInfoLearn1\">\r\n            <div>\r\n      \r\n													<h4 class=\"blockTitleLearn\" >WHAT IS VOTEWISE?</h4>\r\n              <span class=\"blockDesc\">VoteWise is  a non-partisan non-profit website that connects voters, organizations and politicians without advertising dollars getting in the way.  Our goal is to depolarize politics and make it easier for communities to find common ground and the tools they need to identify problems, find sustainable solutions that work for all, and put those solutions into action.<br><br>\r\n\r\nAn effective democracy requires the active participation of voters, politicians, the press, and the organizations that dedicate their lives to the issues they care about.  Sometimes this means making changes to legislation and sometimes this means more hands-on action.  Either way, it requires year-round teamwork.  We want to make it easier for everyone.<br> <br>\r\n\r\nWe have different tools available to different types of users to make their jobs easier.  Click on the videos below to learn more.\r\n</span>\r\n				\r\n            </div>\r\n          </div>\r\n					</div>\r\n		</div></div></div>\r\n		    <center class=\"threefer\">\r\n							 <iframe src=\"https://player.vimeo.com/video/408236980?byline=false&title=false\" allowfullscreen style=\"border:0;\"></iframe><span>							\r\n														 <iframe src=\"https://player.vimeo.com/video/408236648?byline=false&title=false\" allowfullscreen style=\"border:0;\"></iframe></span><span>\r\n<iframe src=\"https://player.vimeo.com/video/408237898?byline=false&title=false\" allowfullscreen style=\"border:0;\"></iframe></span></center>\r\n\r\n\r\n	<center>\r\n	 <a href=\"#!/signup/voter\">\r\n                  <div class=\"ycompareBtn\"><center><b>Sign Up</b></center></div></a>\r\n	\r\n	\r\n	</center>\r\n	</div>");
$templateCache.put("app/whatAmILookingAt1/whatAmILookingAt1.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">WHAT AM I LOOKING AT?</h2>\r\n \r\n    \r\n  <div class=\"row topicsSectionMed d-none d-md-flex\">\r\n    <div class=\"col-3\">\r\n      <img ng-src=\"./assets/images/whatIsThis1.jpg\" class=\"whatIsThisImg\">\r\n    </div>\r\n    <div class=\"col-9 \">\r\n      <h3 id=\"chooseTopic\">Question Comparison</h3>\r\n      <div id=\"chooseTopicContent\">\r\n        A.	If you click the categories at the top (Politicians, Email Confirmed Users, Organizations, and Unregistered Users) you will see all the answers under that category.  (voters names are hidden) Unregistered Users\' identities aren\'t confirmed in any way, so their data shouldn\'t be trusted.<br><br>\r\nB.	“Yes” means there are comments left by users in that category for you to read if you want.<br><br>\r\nC.	If you click on the colored bars you will see users who answered with that answer.<br><br>\r\nD.	The color of the bars indicate how closely they agree or disagree with you. (Green is perfect match, red is the least possible match)<br><br>\r\nE.	Match to mean.  If you were to average all the answers, this is how close you are to that number.  Example: if half the people answered at one extreme and the other half answered at the other extreme, the average would be right in the middle.  So, if you answered right in the middle, you would be a 100% match.<br><br>\r\nF.	Importance.  This is how important people said their answer was.\r\n      </div>   \r\n        </div>\r\n    </div>\r\n    <br><br><br>\r\n    \r\n    <div class=\"row topicsSectionSmall d-md-none\">\r\n          <div class=\"col-10\">     \r\n     <center><img ng-src=\"./assets/images/whatIsThis1.jpg\" class=\"whatIsThisImgS\"></center>\r\n    </div>\r\n    <div class=\"col-12\">\r\n      <h3 id=\"chooseTopic\">Question Comparison</h3>\r\n      <div id=\"chooseTopicContent\">\r\n         A.	If you click the categories at the top (Politicians, Email Confirmed Users, Organizations, and Unregistered Users) you will see all the answers under that category.  (voters names are hidden)  Unregistered Users\' identities aren\'t confirmed in any way, so their data shouldn\'t be trusted.<br><br>\r\nB.	“Yes” means there are comments left by users in that category for you to read if you want.<br><br>\r\nC.	If you click on the colored bars you will see users who answered with that answer.<br><br>\r\nD.	The color of the bars indicate how closely they agree or disagree with you. (Green is perfect match, red is the least possible match)<br><br>\r\nE.	Match to mean.  If you were to average all the answers, this is how close you are to that number.  Example: if half the people answered at one extreme and the other half answered at the other extreme, the average would be right in the middle.  So, if you answered right in the middle, you would be a 100% match.<br><br>\r\nF.	Importance.  This is how important people said their answer was.\r\n          </div>\r\n        </div>\r\n</div>\r\n    ");
$templateCache.put("app/whatAmILookingAt2/whatAmILookingAt2.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">WHAT AM I LOOKING AT?</h2>\r\n \r\n    \r\n  <div class=\"row topicsSectionMed d-none d-md-flex\">\r\n    <div class=\"col-3\">\r\n      <img ng-src=\"./assets/images/whatIsThis2.jpg\" class=\"whatIsThisImg\">\r\n    </div>\r\n    <div class=\"col-9 \">\r\n      <h3 id=\"chooseTopic\">Subject Comparison</h3>\r\n      <div id=\"chooseTopicContent\">\r\n        A.	T<b>Total Answered Questions</b>  If this is an individual, they may have chosen to answer only a few of the questions on the quiz.  All comparisons are based only on the questions they answered, so if they only answered one question, your answer for that one question is matched to their answer for that one question and that\'s it.  The more questions they answered, the more you can be sure that the total match is closer to reality.<br><br>\r\nB.	<b>Match </b>The first bar (yellow) shows how your answers compare with theirs.<br><br>\r\nC.	<b>Weighted Match </b>The second bar (light blue) is your match after taking into consideration how important each question is to you and the person/group you are being compared with.  This way you can find people/groups that you may disagree with on the little things, but agree with you on the things that are really important.  The way we calculate this is by taking the \"Very Important\" questions and giving them the weight of 3 questions, the \"Somewhat Important\" questions are given the weight of 2 questions, and the \"Not Very Important\" questions are given the weight of one question. \r\n      </div>   \r\n        </div>\r\n    </div>\r\n    <br><br><br>\r\n    \r\n    <div class=\"row topicsSectionSmall d-md-none\">\r\n          <div class=\"col-10\">     \r\n     <center><img ng-src=\"./assets/images/whatIsThis2.jpg\" class=\"whatIsThisImgS\"></center>\r\n    </div>\r\n    <div class=\"col-12\">\r\n      <h3 id=\"chooseTopic\">Subject Comparison</h3>\r\n      <div id=\"chooseTopicContent\">\r\n          A.	<b>Total Answered Questions</b>  If this is an individual, they may have chosen to answer only a few of the questions on the quiz.  All comparisons are based only on the questions they answered, so if they only answered one question, your answer for that one question is matched to their answer for that one question and that\'s it.  The more questions they answered, the more you can be sure that the total match is closer to reality.<br><br>\r\nB.	<b>Match </b>The first bar (yellow) shows how your answers compare with theirs.<br><br>\r\n          C.	<b>Weighted Match </b>The second bar (light blue) is your match after taking into consideration how important each question is to you and the person/group you are being compared with.  This way you can find people/groups that you may disagree with on the little things, but agree with you on the things that are really important.  The way we calculate this is by taking the \"Very Important\" questions and giving them the weight of 3 questions, the \"Somewhat Important\" questions are given the weight of 2 questions, and the \"Not Very Important\" questions are given the weight of one question. </div>\r\n          </div>\r\n        </div>\r\n</div>\r\n");
$templateCache.put("app/whatAmILookingAt3/whatAmILookingAt3.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">WHAT AM I LOOKING AT?</h2>\r\n \r\n    \r\n  <div class=\"row topicsSectionMed d-none d-md-flex\">\r\n    <div class=\"col-3\">\r\n      <img ng-src=\"./assets/images/whatIsThis2.jpg\" class=\"whatIsThisImg\">\r\n    </div>\r\n    <div class=\"col-9 \">\r\n      <h3 id=\"chooseTopic\">Candidate Comparison</h3>\r\n      <div id=\"chooseTopicContent\">\r\n        A.	<b>Total Answered Questions</b>  If someone is running for school board, it doesn\'t make sense for them to answer questions about international trade or other things that their job has no control over.  So, they may have chosen to answer only a few of the questions on the quiz.  All comparisons are based only on the questions they answered, so if they only answered one question, your answer for that one question is matched to their answer for that one question and that\'s it.  The more questions they answered, the more you can be sure that the total match is closer to reality.<br><br>\r\n							B.	<b>Match</b> The first bar (yellow) shows how your answers compare with theirs.<br><br>\r\nC.	<b>Weighted Match</b> The second bar (light blue) is your match after taking into consideration how important each question is to you and the person/group you are being compared with. This way you can find people/groups that you may disagree with on the little things, but agree with you on the things that are really important.  The way we calculate this is by taking the \"Very Important\" questions and giving them the weight of 3 questions, the \"Somewhat Important\" questions are given the weight of 2 questions, and the \"Not Very Important\" questions are given the weight of one question.<br><br> NOTE: Some of the politician questions may have been taken from other sources where an answer of \"True\" or \"False\" was converted to \"Somewhat Agree\" or \"Somewhat Disagree\" (one point from either extreme) and we gave those answers an importance level of \"Somewhat important\". This may mean their answers do not fully express their passion or conviction.<br><br> If you want to see how you match, question by question, hit the Match Details Button.<br><br>Questions are not the only information we have on the candidates.  Hit the See Other Politicians button to see resumes, statments, videos, reviews of the candidates, discussions, information about who paid for their campaigns, voting records and more.\r\n      </div>   \r\n        </div>\r\n    </div>\r\n    <br><br><br>\r\n    \r\n    <div class=\"row topicsSectionSmall d-md-none\">\r\n          <div class=\"col-10\">     \r\n     <center><img ng-src=\"./assets/images/whatIsThis2.jpg\" class=\"whatIsThisImgS\"></center>\r\n    </div>\r\n    <div class=\"col-12\">\r\n      <h3 id=\"chooseTopic\">Subject Comparison</h3>\r\n      <div id=\"chooseTopicContent\">\r\n         A.	<b>Total Answered Questions</b>  If someone is running for school board, it doesn\'t make sense for them to answer questions about international trade or other things that their job has no control over.  So, they may have chosen to answer only a few of the questions on the quiz.  All comparisons are based only on the questions they answered, so if they only answered one question, your answer for that one question is matched to their answer for that one question and that\'s it.  The more questions they answered, the more you can be sure that the total match is closer to reality.<br><br>\r\nB.	<b>Match </b>The first bar (yellow) shows how your answers compare with theirs.<br><br>\r\nC.	<b>Weighted Match </b>The second bar (light blue) is your match after taking into consideration how important each question is to you and the person/group you are being compared with.  This way you can find people/groups that you may disagree with on the little things, but agree with you on the things that are really important.  The way we calculate this is by taking the \"Very Important\" questions and giving them the weight of 3 questions, the \"Somewhat Important\" questions are given the weight of 2 questions, and the \"Not Very Important\" questions are given the weight of one question. <br><br> NOTE: Some of the politician questions may have been taken from other sources where an answer of \"True\" or \"False\" was converted to \"Somewhat Agree\" or \"Somewhat Disagree\" (one point from either extreme) and we gave those answers an importance level of \"Somewhat important\". This may mean their answers do not fully express their passion or conviction.<br><br> If you want to see how you match, question by question, hit the Match Details Button.<br><br>Questions are not the only information we have on the candidates.  Hit the See Other Politicians button to see resumes, statments, videos, reviews of the candidates, discussions, information about who paid for their campaigns, voting records and more.\r\n        </div>\r\n</div>\r\n");
$templateCache.put("app/whatAmILookingAt4/whatAmILookingAt4.html","<div class=\"container-fluid ng-scope\">\r\n  <h2 class=\"pageHeading\">WHAT AM I LOOKING AT?</h2>\r\n \r\n    \r\n  <div class=\"row topicsSectionMed d-none d-md-flex\">\r\n    <div class=\"col-3\">\r\n      <img ng-src=\"./assets/images/whatIsThis4.jpg\" class=\"whatIsThisImg\">\r\n    </div>\r\n    <div class=\"col-9 \">\r\n      <h3 id=\"chooseTopic\">Question Comparison</h3>\r\n      <div id=\"chooseTopicContent\">\r\n        A.	This is how you answered the question.  We have colored it green so you can easily find others who have responded the same way.<br><br>\r\nB.	This is how a particular politician answered the same questions. (Their name is written below)  The oval\'s color is based on how closely it matches your answer.  If they completely agree with you, their answer is green too.  If they completely disagree with you, their answer is in red.  All other answers are some grade of color in between.<br><br>\r\nC.	This is how much a particular politician agrees with you.<br><br>\r\nD.	This is how passionate they are about this question.<br><br>\r\nE.	If the politician left a comment, you can click on the \"yes\" and a pop-up will appear so you can read what they had to say.<br><br>\r\nF.	These are the politicians up for election in your area who chose to answer this particular question. Both their name and the office they are running for is listed.  Please note that politicians are encouraged not to answer questions that have nothing to do with their job.  For example, someone running for school board probably won\'t answer questions about war in some other country because their job has no control over it.\r\n      </div>   \r\n        </div>\r\n    </div>\r\n    <br><br><br>\r\n    \r\n    <div class=\"row topicsSectionSmall d-md-none\">\r\n          <div class=\"col-10\">     \r\n     <center><img ng-src=\"./assets/images/whatIsThis1.jpg\" class=\"whatIsThisImgS\"></center>\r\n    </div>\r\n    <div class=\"col-12\">\r\n      <h3 id=\"chooseTopic\">Question Comparison</h3>\r\n      <div id=\"chooseTopicContent\">\r\n          A.	This is how you answered the question.  We have colored it green so you can easily find others who have responded the same way.<br><br>\r\nB.	This is how a particular politician answered the same questions. (Their name is written below)  The oval\'s color is based on how closely it matches your answer.  If they completely agree with you, their answer is green too.  If they completely disagree with you, their answer is in red.  All other answers are some grade of color in between.<br><br>\r\nC.	This is how much a particular politician agrees with you.<br><br>\r\nD.	This is how passionate they are about this question.<br><br>\r\nE.	If the politician left a comment, you can click on the \"yes\" and a pop-up will appear so you can read what they had to say.<br><br>\r\nF.	These are the politicians up for election in your area who chose to answer this particular question. Both their name and the office they are running for is listed.  Please note that politicians are encouraged not to answer questions that have nothing to do with their job.  For example, someone running for school board probably won\'t answer questions about war in some other country because their job has no control over it.\r\n          </div>\r\n        </div>\r\n</div>\r\n    ");
$templateCache.put("app/winVoters/winVoters.html","<div class=\"container-fluid\">\r\n  <h2 class=\"pageHeading\">WIN VOTERS AND ALLIES</h2>\r\n  <p class=\"pageSubHeading col-md-6\">Take quizzes to find your matches. Let your voters know what you think. Find allies\r\n    in your fight to make the world fit your vision of the future.</p>\r\n  <p style=\"margin-left: auto; margin-right:auto; max-width: 1000px;\">Voters and Organizations take the same quizzes that you do and then get matched up to you like an online dating site only for politics.</p>\r\n  <p style=\"margin-left: auto; margin-right:auto; max-width: 1000px;\">You can also use the quizzes to get matched up with organizations and other politicians who would want to help you accomplish your goals.</p>\r\n  <!--   <p class=\"col-md-6 d-flex justify-content-center\">Post the quizzes you answer to Facebook to create a fun way to engage others in the issues you care about.</p>\r\n  -->\r\n  <p style=\"margin-left: auto; margin-right:auto; max-width: 1000px;\">The more questions you answer, the more powerful the site becomes for you. On the candidate page, we list politicians in order of how many questions they have answered. High answering\r\n    politicians will have more power in future tools.</p><br>\r\n	<div class=\"centerediframe\" ng-show=\"$root.userRole == \'politician\'\">\r\n  <iframe src=\"https://player.vimeo.com/video/407450936?byline=false&title=false\" allowfullscreen ></iframe>\r\n</div>\r\n  <div class=\"row questionOptions d-none d-md-flex\">\r\n\r\n\r\n    <div class=\"col-lg-5 col-sm-5 offset-lg-1 removeRightPadding\" ng-class=\"{\'col-12\': showLocalMatch == true}\">\r\n      <a href=\"#!/fiveMatch#DisplayQ\" class=\"blockLink\">\r\n      <img ng-src=\"./assets/images/5minQuizIcon.jpg\" class=\"fiveMinQuizImg img-fluid\" >\r\n      <div class=\"fiveMinQuiz\">\r\n        <div>\r\n          <h4 >FIVE MINUTE MATCH</h4>\r\n          <span>This is a quiz based around the topics that interest Americans most.  Sometimes this is based on Pew Research polls, and sometimes we ask the parties what issues concern them most in the coming election. This is the most popular quiz for last minute voters who want a quick guide the night before the election.  With each question, you have the option to stray off the path and dig deeper into the topic.  We highly reccommend that you start with this quiz, answer the questions that relate to you job, skip the ones that don\'t, and then take other quizzes about the topics you care about most.</span>\r\n        </div>\r\n      </div></a>\r\n    </div>\r\n\r\n    <div class=\"col-lg-5 col-sm-5 removeLeftPadding\" ng-click=\"matchQuestion()\" ng-if=\"showLocalMatch == true\">\r\n      <a href=\"#!/ballotMatch\" class=\"blockLink\"></a>\r\n      <img ng-src=\"./assets/images/localMatch200.jpg\" class=\"localMatchImg img-fluid\">\r\n      <div class=\"localMatch\">\r\n        <div>\r\n          <h4>BALLOT MATCH</h4>\r\n          <span>Use this quiz to answer the same questions that politicians in your area have taken.  This is an efficient way of finding allies that you might not expect.  This quiz could be really short or really long depending on how many questions your colleagues have answered.</span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n\r\n  </div>\r\n  <div class=\"row questionOptionsSmall d-md-none\">\r\n    <div class=\"col-12 removeRightPaddingSmall\">\r\n      <a href=\"#!/fiveMatch#DisplayQ\" class=\"blockLink\">\r\n      <img ng-src=\"./assets/images/5minQuizIcon.jpg\" class=\"fiveMinQuizImgSmall img-fluid\">\r\n      <div class=\"fiveMinQuizSmall\">\r\n        <div>\r\n          <h4>FIVE MINUTE MATCH</h4>\r\n          <span>This is a quiz based around the topics that interest Americans most according to a Pew Research poll. This is the most popular quiz for last minute voters who want a quick quide the night before the election.  With each question, you have the option to stray off the path and dig deeper into the topic.  We highly reccommend that you start with this quiz, answer the questions that relate to you job, skip the ones that don\'t, and then take other quizzes about the topics you care about most.</span>\r\n        </div>\r\n            </div></a>\r\n    </div>\r\n\r\n    \r\n    <div class=\"col-12 removeRightPaddingSmall\">\r\n      <img ng-src=\"./assets/images/localMatch200.jpg\" class=\"localMatchImgSmall img-fluid\">\r\n      <div class=\"localMatchSmall\">\r\n        <div>\r\n          <h4>BALLOT MATCH</h4>\r\n          <span>Use this quiz to answer the same questions that politicians in your area have taken.  This is an efficient way of finding allies that you might not expect.  This quiz could be really short or really long depending on how many questions your colleagues have answered.</span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n\r\n  </div>\r\n  <div class=\"row topicsSection d-none d-md-flex\">\r\n    <div class=\"col-3\">\r\n      <img ng-src=\"./assets/images/speakerStand200.jpg\" class=\"img-fluid\" id=\"speakerImg\">\r\n    </div>\r\n      <div class=\"col-9 shiftLeft\">\r\n        <h3 id=\"chooseTopic\">Topic Quizzes</h3>\r\n        <div id=\"chooseTopicContent\">\r\n          The five minute quiz above barely brushes the surface of only a few topics. Explore below to find the topics\r\n          you care about most to express your ideas and generate interest. Remember, any questions you answer here will\r\n          pop up in other users\' \"Ballot Match\" questionnaire.\r\n        </div>\r\n        <div style=\"text-align:center;\">\r\n          <a ng-repeat=\"item in $root.categories | orderBy: \'order\'\" href=\"#!/questionSubcategories/{{item._id}}\" title=\"{{item.title}}\" style=\"padding: 10px 0px;\">\r\n          <div class=\"allTopics\">\r\n            <img ng-src=\"{{$root.imgUrl}}/{{item.iconImage}}\" alt=\"{{item.title}}\">\r\n            <span>{{item.title}}</span>\r\n          </div>\r\n        </a>\r\n\r\n          \r\n            <br><br>\r\n          <div>Can\'t find what you\'re looking for?  Try using a word search. <center>\r\n		<input ng-model=\"$root.searchQuestionKeyword\" class=\"blackText\"> <button ng-click=\"$root.searchQuestion()\" class=\"blackText\">Search Questions</button>\r\n	</center></div>\r\n        \r\n\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"row topicsSectionSmall d-md-none\">\r\n      <div class=\"col-12\">\r\n        <h3 id=\"chooseTopic\">Topic Quizzes</h3>\r\n        <div id=\"chooseTopicContent\">\r\n          The five minute quiz above barely brushes the surface of only a few topics. Explore below to find the topics\r\n          you care about most to express your ideas and generate interest. Remember, any questions you answer here will\r\n          pop up in other users\' \"Ballot Match\" questionnaire.\r\n        </div>\r\n\r\n        <div style=\"text-align:center;\">\r\n          <a ng-repeat=\"item in $root.categories | orderBy: \'order\'\" href=\"#!/questionSubcategories/{{item._id}}\" title=\"{{item.title}}\" style=\"padding: 10px 0px;\">\r\n          <div class=\"allTopics\">\r\n            <img ng-src=\"{{$root.imgUrl}}/{{item.iconImage}}\" alt=\"{{item.title}}\">\r\n            <span>{{item.title}}</span>\r\n          </div>\r\n        </a>\r\n\r\n          <!-- ************* BRING BACK\r\n            <br><br>\r\n          <div>Can\'t find what you\'re looking for?  Try using a word search. <center>\r\n		<input ng-model=\"$root.searchQuestionKeyword\" class=\"blackText\"> <button ng-click=\"$root.searchQuestion()\" class=\"blackText\">Search Questions</button>\r\n	</center></div>\r\n  -->\r\n\r\n        </div>\r\n      </div>\r\n    </div>\r\n        <div class=\"col-lg-12 col-sm-12 gettingStartedContainer\">\r\n      <a href=\"#!/quizzes\" class=\"blockLink\"><img ng-src=\"./assets/images/quiz.svg\" class=\"gettingStartedImg img-fluid\">\r\n      <div class=\"gettingStartedBlock gettingStartedBlock1\">\r\n          <div>\r\n          <h4 class=\"gettingStartedBlockTitle\">OTHER QUIZZES</h4>\r\n          <p class=\"gettingStartedBlockDesc\">Take quizzes from organizations, composite quizzes made up of the most popular questions and more.</p>\r\n          \r\n        </div>\r\n      </div></a>\r\n    </div>\r\n  </div>\r\n  <!-- <head>\r\n<title>Question Home</title>\r\n<meta name=\"viewport\" content=\"initial-scale=1, maximum-scale=1\">\r\n</head>\r\n<div>\r\n<p><h1><center>Answer Questions</center></h1></p>\r\n<p><b>Speak out by answering quizzes to find Politicians, Organizations and others that match your vision of how to make the world a better place.</b></p>\r\n<p>\r\n<ul><li>Choose an issue below that is important to you</li>\r\n<li>Answer questions about the issue.  You can skip questions you don\'t like or stop at any time.</li><li>When you get to the end of a section, you can: <ul><li>Post your quiz to facebook to see how you match your friends</li><li>Go to the Politician section to see if any Politicians in your area answered the same questions.</li><li>Continue answering questions to let your politicians know more about how they should be representing you.</li></ul></li></ul>\r\n</p>\r\n<p><b>Either way, your anonymous answers will be given to your politicians so they know what they should be doing.</b></p>\r\n\r\n\r\n<div class=\"clearfix w100\" style=\"padding: 10px;\">\r\n	<center>\r\n		<input ng-model=\"$root.searchQuestionKeyword\"> <button ng-click=\"$root.searchQuestion()\">Search Question</button>\r\n	</center>\r\n</div>\r\n<p><b><h2>Question Topics</h2></b></p>\r\n<div class=\"newUser\">\r\n\r\n<p ng-if=\"$root.statusGetCategories == 1\" class=\"fwb\">Loading categories...</p>\r\n<a ng-repeat=\"item in $root.categories | orderBy: \'order\'\" href=\"#!/questionSubcategories/{{item._id}}\" title=\"{{item.title}}\" style=\"padding: 10px 0px;\">\r\n	<img class=\"subjects\" ng-src=\"{{$root.imgUrl}}/{{item.iconImage}}\" alt=\"{{item.title}}\">\r\n</a>\r\n\r\n</div>\r\n -->\r\n");}]);